(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2677],{

/***/ 99549:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Bip39 = exports.EnglishMnemonic = exports.mnemonicToEntropy = exports.entropyToMnemonic = void 0;
const encoding_1 = __webpack_require__(92540);
const pbkdf2_1 = __webpack_require__(42997);
const sha_1 = __webpack_require__(52387);
const wordlist = [
    "abandon",
    "ability",
    "able",
    "about",
    "above",
    "absent",
    "absorb",
    "abstract",
    "absurd",
    "abuse",
    "access",
    "accident",
    "account",
    "accuse",
    "achieve",
    "acid",
    "acoustic",
    "acquire",
    "across",
    "act",
    "action",
    "actor",
    "actress",
    "actual",
    "adapt",
    "add",
    "addict",
    "address",
    "adjust",
    "admit",
    "adult",
    "advance",
    "advice",
    "aerobic",
    "affair",
    "afford",
    "afraid",
    "again",
    "age",
    "agent",
    "agree",
    "ahead",
    "aim",
    "air",
    "airport",
    "aisle",
    "alarm",
    "album",
    "alcohol",
    "alert",
    "alien",
    "all",
    "alley",
    "allow",
    "almost",
    "alone",
    "alpha",
    "already",
    "also",
    "alter",
    "always",
    "amateur",
    "amazing",
    "among",
    "amount",
    "amused",
    "analyst",
    "anchor",
    "ancient",
    "anger",
    "angle",
    "angry",
    "animal",
    "ankle",
    "announce",
    "annual",
    "another",
    "answer",
    "antenna",
    "antique",
    "anxiety",
    "any",
    "apart",
    "apology",
    "appear",
    "apple",
    "approve",
    "april",
    "arch",
    "arctic",
    "area",
    "arena",
    "argue",
    "arm",
    "armed",
    "armor",
    "army",
    "around",
    "arrange",
    "arrest",
    "arrive",
    "arrow",
    "art",
    "artefact",
    "artist",
    "artwork",
    "ask",
    "aspect",
    "assault",
    "asset",
    "assist",
    "assume",
    "asthma",
    "athlete",
    "atom",
    "attack",
    "attend",
    "attitude",
    "attract",
    "auction",
    "audit",
    "august",
    "aunt",
    "author",
    "auto",
    "autumn",
    "average",
    "avocado",
    "avoid",
    "awake",
    "aware",
    "away",
    "awesome",
    "awful",
    "awkward",
    "axis",
    "baby",
    "bachelor",
    "bacon",
    "badge",
    "bag",
    "balance",
    "balcony",
    "ball",
    "bamboo",
    "banana",
    "banner",
    "bar",
    "barely",
    "bargain",
    "barrel",
    "base",
    "basic",
    "basket",
    "battle",
    "beach",
    "bean",
    "beauty",
    "because",
    "become",
    "beef",
    "before",
    "begin",
    "behave",
    "behind",
    "believe",
    "below",
    "belt",
    "bench",
    "benefit",
    "best",
    "betray",
    "better",
    "between",
    "beyond",
    "bicycle",
    "bid",
    "bike",
    "bind",
    "biology",
    "bird",
    "birth",
    "bitter",
    "black",
    "blade",
    "blame",
    "blanket",
    "blast",
    "bleak",
    "bless",
    "blind",
    "blood",
    "blossom",
    "blouse",
    "blue",
    "blur",
    "blush",
    "board",
    "boat",
    "body",
    "boil",
    "bomb",
    "bone",
    "bonus",
    "book",
    "boost",
    "border",
    "boring",
    "borrow",
    "boss",
    "bottom",
    "bounce",
    "box",
    "boy",
    "bracket",
    "brain",
    "brand",
    "brass",
    "brave",
    "bread",
    "breeze",
    "brick",
    "bridge",
    "brief",
    "bright",
    "bring",
    "brisk",
    "broccoli",
    "broken",
    "bronze",
    "broom",
    "brother",
    "brown",
    "brush",
    "bubble",
    "buddy",
    "budget",
    "buffalo",
    "build",
    "bulb",
    "bulk",
    "bullet",
    "bundle",
    "bunker",
    "burden",
    "burger",
    "burst",
    "bus",
    "business",
    "busy",
    "butter",
    "buyer",
    "buzz",
    "cabbage",
    "cabin",
    "cable",
    "cactus",
    "cage",
    "cake",
    "call",
    "calm",
    "camera",
    "camp",
    "can",
    "canal",
    "cancel",
    "candy",
    "cannon",
    "canoe",
    "canvas",
    "canyon",
    "capable",
    "capital",
    "captain",
    "car",
    "carbon",
    "card",
    "cargo",
    "carpet",
    "carry",
    "cart",
    "case",
    "cash",
    "casino",
    "castle",
    "casual",
    "cat",
    "catalog",
    "catch",
    "category",
    "cattle",
    "caught",
    "cause",
    "caution",
    "cave",
    "ceiling",
    "celery",
    "cement",
    "census",
    "century",
    "cereal",
    "certain",
    "chair",
    "chalk",
    "champion",
    "change",
    "chaos",
    "chapter",
    "charge",
    "chase",
    "chat",
    "cheap",
    "check",
    "cheese",
    "chef",
    "cherry",
    "chest",
    "chicken",
    "chief",
    "child",
    "chimney",
    "choice",
    "choose",
    "chronic",
    "chuckle",
    "chunk",
    "churn",
    "cigar",
    "cinnamon",
    "circle",
    "citizen",
    "city",
    "civil",
    "claim",
    "clap",
    "clarify",
    "claw",
    "clay",
    "clean",
    "clerk",
    "clever",
    "click",
    "client",
    "cliff",
    "climb",
    "clinic",
    "clip",
    "clock",
    "clog",
    "close",
    "cloth",
    "cloud",
    "clown",
    "club",
    "clump",
    "cluster",
    "clutch",
    "coach",
    "coast",
    "coconut",
    "code",
    "coffee",
    "coil",
    "coin",
    "collect",
    "color",
    "column",
    "combine",
    "come",
    "comfort",
    "comic",
    "common",
    "company",
    "concert",
    "conduct",
    "confirm",
    "congress",
    "connect",
    "consider",
    "control",
    "convince",
    "cook",
    "cool",
    "copper",
    "copy",
    "coral",
    "core",
    "corn",
    "correct",
    "cost",
    "cotton",
    "couch",
    "country",
    "couple",
    "course",
    "cousin",
    "cover",
    "coyote",
    "crack",
    "cradle",
    "craft",
    "cram",
    "crane",
    "crash",
    "crater",
    "crawl",
    "crazy",
    "cream",
    "credit",
    "creek",
    "crew",
    "cricket",
    "crime",
    "crisp",
    "critic",
    "crop",
    "cross",
    "crouch",
    "crowd",
    "crucial",
    "cruel",
    "cruise",
    "crumble",
    "crunch",
    "crush",
    "cry",
    "crystal",
    "cube",
    "culture",
    "cup",
    "cupboard",
    "curious",
    "current",
    "curtain",
    "curve",
    "cushion",
    "custom",
    "cute",
    "cycle",
    "dad",
    "damage",
    "damp",
    "dance",
    "danger",
    "daring",
    "dash",
    "daughter",
    "dawn",
    "day",
    "deal",
    "debate",
    "debris",
    "decade",
    "december",
    "decide",
    "decline",
    "decorate",
    "decrease",
    "deer",
    "defense",
    "define",
    "defy",
    "degree",
    "delay",
    "deliver",
    "demand",
    "demise",
    "denial",
    "dentist",
    "deny",
    "depart",
    "depend",
    "deposit",
    "depth",
    "deputy",
    "derive",
    "describe",
    "desert",
    "design",
    "desk",
    "despair",
    "destroy",
    "detail",
    "detect",
    "develop",
    "device",
    "devote",
    "diagram",
    "dial",
    "diamond",
    "diary",
    "dice",
    "diesel",
    "diet",
    "differ",
    "digital",
    "dignity",
    "dilemma",
    "dinner",
    "dinosaur",
    "direct",
    "dirt",
    "disagree",
    "discover",
    "disease",
    "dish",
    "dismiss",
    "disorder",
    "display",
    "distance",
    "divert",
    "divide",
    "divorce",
    "dizzy",
    "doctor",
    "document",
    "dog",
    "doll",
    "dolphin",
    "domain",
    "donate",
    "donkey",
    "donor",
    "door",
    "dose",
    "double",
    "dove",
    "draft",
    "dragon",
    "drama",
    "drastic",
    "draw",
    "dream",
    "dress",
    "drift",
    "drill",
    "drink",
    "drip",
    "drive",
    "drop",
    "drum",
    "dry",
    "duck",
    "dumb",
    "dune",
    "during",
    "dust",
    "dutch",
    "duty",
    "dwarf",
    "dynamic",
    "eager",
    "eagle",
    "early",
    "earn",
    "earth",
    "easily",
    "east",
    "easy",
    "echo",
    "ecology",
    "economy",
    "edge",
    "edit",
    "educate",
    "effort",
    "egg",
    "eight",
    "either",
    "elbow",
    "elder",
    "electric",
    "elegant",
    "element",
    "elephant",
    "elevator",
    "elite",
    "else",
    "embark",
    "embody",
    "embrace",
    "emerge",
    "emotion",
    "employ",
    "empower",
    "empty",
    "enable",
    "enact",
    "end",
    "endless",
    "endorse",
    "enemy",
    "energy",
    "enforce",
    "engage",
    "engine",
    "enhance",
    "enjoy",
    "enlist",
    "enough",
    "enrich",
    "enroll",
    "ensure",
    "enter",
    "entire",
    "entry",
    "envelope",
    "episode",
    "equal",
    "equip",
    "era",
    "erase",
    "erode",
    "erosion",
    "error",
    "erupt",
    "escape",
    "essay",
    "essence",
    "estate",
    "eternal",
    "ethics",
    "evidence",
    "evil",
    "evoke",
    "evolve",
    "exact",
    "example",
    "excess",
    "exchange",
    "excite",
    "exclude",
    "excuse",
    "execute",
    "exercise",
    "exhaust",
    "exhibit",
    "exile",
    "exist",
    "exit",
    "exotic",
    "expand",
    "expect",
    "expire",
    "explain",
    "expose",
    "express",
    "extend",
    "extra",
    "eye",
    "eyebrow",
    "fabric",
    "face",
    "faculty",
    "fade",
    "faint",
    "faith",
    "fall",
    "false",
    "fame",
    "family",
    "famous",
    "fan",
    "fancy",
    "fantasy",
    "farm",
    "fashion",
    "fat",
    "fatal",
    "father",
    "fatigue",
    "fault",
    "favorite",
    "feature",
    "february",
    "federal",
    "fee",
    "feed",
    "feel",
    "female",
    "fence",
    "festival",
    "fetch",
    "fever",
    "few",
    "fiber",
    "fiction",
    "field",
    "figure",
    "file",
    "film",
    "filter",
    "final",
    "find",
    "fine",
    "finger",
    "finish",
    "fire",
    "firm",
    "first",
    "fiscal",
    "fish",
    "fit",
    "fitness",
    "fix",
    "flag",
    "flame",
    "flash",
    "flat",
    "flavor",
    "flee",
    "flight",
    "flip",
    "float",
    "flock",
    "floor",
    "flower",
    "fluid",
    "flush",
    "fly",
    "foam",
    "focus",
    "fog",
    "foil",
    "fold",
    "follow",
    "food",
    "foot",
    "force",
    "forest",
    "forget",
    "fork",
    "fortune",
    "forum",
    "forward",
    "fossil",
    "foster",
    "found",
    "fox",
    "fragile",
    "frame",
    "frequent",
    "fresh",
    "friend",
    "fringe",
    "frog",
    "front",
    "frost",
    "frown",
    "frozen",
    "fruit",
    "fuel",
    "fun",
    "funny",
    "furnace",
    "fury",
    "future",
    "gadget",
    "gain",
    "galaxy",
    "gallery",
    "game",
    "gap",
    "garage",
    "garbage",
    "garden",
    "garlic",
    "garment",
    "gas",
    "gasp",
    "gate",
    "gather",
    "gauge",
    "gaze",
    "general",
    "genius",
    "genre",
    "gentle",
    "genuine",
    "gesture",
    "ghost",
    "giant",
    "gift",
    "giggle",
    "ginger",
    "giraffe",
    "girl",
    "give",
    "glad",
    "glance",
    "glare",
    "glass",
    "glide",
    "glimpse",
    "globe",
    "gloom",
    "glory",
    "glove",
    "glow",
    "glue",
    "goat",
    "goddess",
    "gold",
    "good",
    "goose",
    "gorilla",
    "gospel",
    "gossip",
    "govern",
    "gown",
    "grab",
    "grace",
    "grain",
    "grant",
    "grape",
    "grass",
    "gravity",
    "great",
    "green",
    "grid",
    "grief",
    "grit",
    "grocery",
    "group",
    "grow",
    "grunt",
    "guard",
    "guess",
    "guide",
    "guilt",
    "guitar",
    "gun",
    "gym",
    "habit",
    "hair",
    "half",
    "hammer",
    "hamster",
    "hand",
    "happy",
    "harbor",
    "hard",
    "harsh",
    "harvest",
    "hat",
    "have",
    "hawk",
    "hazard",
    "head",
    "health",
    "heart",
    "heavy",
    "hedgehog",
    "height",
    "hello",
    "helmet",
    "help",
    "hen",
    "hero",
    "hidden",
    "high",
    "hill",
    "hint",
    "hip",
    "hire",
    "history",
    "hobby",
    "hockey",
    "hold",
    "hole",
    "holiday",
    "hollow",
    "home",
    "honey",
    "hood",
    "hope",
    "horn",
    "horror",
    "horse",
    "hospital",
    "host",
    "hotel",
    "hour",
    "hover",
    "hub",
    "huge",
    "human",
    "humble",
    "humor",
    "hundred",
    "hungry",
    "hunt",
    "hurdle",
    "hurry",
    "hurt",
    "husband",
    "hybrid",
    "ice",
    "icon",
    "idea",
    "identify",
    "idle",
    "ignore",
    "ill",
    "illegal",
    "illness",
    "image",
    "imitate",
    "immense",
    "immune",
    "impact",
    "impose",
    "improve",
    "impulse",
    "inch",
    "include",
    "income",
    "increase",
    "index",
    "indicate",
    "indoor",
    "industry",
    "infant",
    "inflict",
    "inform",
    "inhale",
    "inherit",
    "initial",
    "inject",
    "injury",
    "inmate",
    "inner",
    "innocent",
    "input",
    "inquiry",
    "insane",
    "insect",
    "inside",
    "inspire",
    "install",
    "intact",
    "interest",
    "into",
    "invest",
    "invite",
    "involve",
    "iron",
    "island",
    "isolate",
    "issue",
    "item",
    "ivory",
    "jacket",
    "jaguar",
    "jar",
    "jazz",
    "jealous",
    "jeans",
    "jelly",
    "jewel",
    "job",
    "join",
    "joke",
    "journey",
    "joy",
    "judge",
    "juice",
    "jump",
    "jungle",
    "junior",
    "junk",
    "just",
    "kangaroo",
    "keen",
    "keep",
    "ketchup",
    "key",
    "kick",
    "kid",
    "kidney",
    "kind",
    "kingdom",
    "kiss",
    "kit",
    "kitchen",
    "kite",
    "kitten",
    "kiwi",
    "knee",
    "knife",
    "knock",
    "know",
    "lab",
    "label",
    "labor",
    "ladder",
    "lady",
    "lake",
    "lamp",
    "language",
    "laptop",
    "large",
    "later",
    "latin",
    "laugh",
    "laundry",
    "lava",
    "law",
    "lawn",
    "lawsuit",
    "layer",
    "lazy",
    "leader",
    "leaf",
    "learn",
    "leave",
    "lecture",
    "left",
    "leg",
    "legal",
    "legend",
    "leisure",
    "lemon",
    "lend",
    "length",
    "lens",
    "leopard",
    "lesson",
    "letter",
    "level",
    "liar",
    "liberty",
    "library",
    "license",
    "life",
    "lift",
    "light",
    "like",
    "limb",
    "limit",
    "link",
    "lion",
    "liquid",
    "list",
    "little",
    "live",
    "lizard",
    "load",
    "loan",
    "lobster",
    "local",
    "lock",
    "logic",
    "lonely",
    "long",
    "loop",
    "lottery",
    "loud",
    "lounge",
    "love",
    "loyal",
    "lucky",
    "luggage",
    "lumber",
    "lunar",
    "lunch",
    "luxury",
    "lyrics",
    "machine",
    "mad",
    "magic",
    "magnet",
    "maid",
    "mail",
    "main",
    "major",
    "make",
    "mammal",
    "man",
    "manage",
    "mandate",
    "mango",
    "mansion",
    "manual",
    "maple",
    "marble",
    "march",
    "margin",
    "marine",
    "market",
    "marriage",
    "mask",
    "mass",
    "master",
    "match",
    "material",
    "math",
    "matrix",
    "matter",
    "maximum",
    "maze",
    "meadow",
    "mean",
    "measure",
    "meat",
    "mechanic",
    "medal",
    "media",
    "melody",
    "melt",
    "member",
    "memory",
    "mention",
    "menu",
    "mercy",
    "merge",
    "merit",
    "merry",
    "mesh",
    "message",
    "metal",
    "method",
    "middle",
    "midnight",
    "milk",
    "million",
    "mimic",
    "mind",
    "minimum",
    "minor",
    "minute",
    "miracle",
    "mirror",
    "misery",
    "miss",
    "mistake",
    "mix",
    "mixed",
    "mixture",
    "mobile",
    "model",
    "modify",
    "mom",
    "moment",
    "monitor",
    "monkey",
    "monster",
    "month",
    "moon",
    "moral",
    "more",
    "morning",
    "mosquito",
    "mother",
    "motion",
    "motor",
    "mountain",
    "mouse",
    "move",
    "movie",
    "much",
    "muffin",
    "mule",
    "multiply",
    "muscle",
    "museum",
    "mushroom",
    "music",
    "must",
    "mutual",
    "myself",
    "mystery",
    "myth",
    "naive",
    "name",
    "napkin",
    "narrow",
    "nasty",
    "nation",
    "nature",
    "near",
    "neck",
    "need",
    "negative",
    "neglect",
    "neither",
    "nephew",
    "nerve",
    "nest",
    "net",
    "network",
    "neutral",
    "never",
    "news",
    "next",
    "nice",
    "night",
    "noble",
    "noise",
    "nominee",
    "noodle",
    "normal",
    "north",
    "nose",
    "notable",
    "note",
    "nothing",
    "notice",
    "novel",
    "now",
    "nuclear",
    "number",
    "nurse",
    "nut",
    "oak",
    "obey",
    "object",
    "oblige",
    "obscure",
    "observe",
    "obtain",
    "obvious",
    "occur",
    "ocean",
    "october",
    "odor",
    "off",
    "offer",
    "office",
    "often",
    "oil",
    "okay",
    "old",
    "olive",
    "olympic",
    "omit",
    "once",
    "one",
    "onion",
    "online",
    "only",
    "open",
    "opera",
    "opinion",
    "oppose",
    "option",
    "orange",
    "orbit",
    "orchard",
    "order",
    "ordinary",
    "organ",
    "orient",
    "original",
    "orphan",
    "ostrich",
    "other",
    "outdoor",
    "outer",
    "output",
    "outside",
    "oval",
    "oven",
    "over",
    "own",
    "owner",
    "oxygen",
    "oyster",
    "ozone",
    "pact",
    "paddle",
    "page",
    "pair",
    "palace",
    "palm",
    "panda",
    "panel",
    "panic",
    "panther",
    "paper",
    "parade",
    "parent",
    "park",
    "parrot",
    "party",
    "pass",
    "patch",
    "path",
    "patient",
    "patrol",
    "pattern",
    "pause",
    "pave",
    "payment",
    "peace",
    "peanut",
    "pear",
    "peasant",
    "pelican",
    "pen",
    "penalty",
    "pencil",
    "people",
    "pepper",
    "perfect",
    "permit",
    "person",
    "pet",
    "phone",
    "photo",
    "phrase",
    "physical",
    "piano",
    "picnic",
    "picture",
    "piece",
    "pig",
    "pigeon",
    "pill",
    "pilot",
    "pink",
    "pioneer",
    "pipe",
    "pistol",
    "pitch",
    "pizza",
    "place",
    "planet",
    "plastic",
    "plate",
    "play",
    "please",
    "pledge",
    "pluck",
    "plug",
    "plunge",
    "poem",
    "poet",
    "point",
    "polar",
    "pole",
    "police",
    "pond",
    "pony",
    "pool",
    "popular",
    "portion",
    "position",
    "possible",
    "post",
    "potato",
    "pottery",
    "poverty",
    "powder",
    "power",
    "practice",
    "praise",
    "predict",
    "prefer",
    "prepare",
    "present",
    "pretty",
    "prevent",
    "price",
    "pride",
    "primary",
    "print",
    "priority",
    "prison",
    "private",
    "prize",
    "problem",
    "process",
    "produce",
    "profit",
    "program",
    "project",
    "promote",
    "proof",
    "property",
    "prosper",
    "protect",
    "proud",
    "provide",
    "public",
    "pudding",
    "pull",
    "pulp",
    "pulse",
    "pumpkin",
    "punch",
    "pupil",
    "puppy",
    "purchase",
    "purity",
    "purpose",
    "purse",
    "push",
    "put",
    "puzzle",
    "pyramid",
    "quality",
    "quantum",
    "quarter",
    "question",
    "quick",
    "quit",
    "quiz",
    "quote",
    "rabbit",
    "raccoon",
    "race",
    "rack",
    "radar",
    "radio",
    "rail",
    "rain",
    "raise",
    "rally",
    "ramp",
    "ranch",
    "random",
    "range",
    "rapid",
    "rare",
    "rate",
    "rather",
    "raven",
    "raw",
    "razor",
    "ready",
    "real",
    "reason",
    "rebel",
    "rebuild",
    "recall",
    "receive",
    "recipe",
    "record",
    "recycle",
    "reduce",
    "reflect",
    "reform",
    "refuse",
    "region",
    "regret",
    "regular",
    "reject",
    "relax",
    "release",
    "relief",
    "rely",
    "remain",
    "remember",
    "remind",
    "remove",
    "render",
    "renew",
    "rent",
    "reopen",
    "repair",
    "repeat",
    "replace",
    "report",
    "require",
    "rescue",
    "resemble",
    "resist",
    "resource",
    "response",
    "result",
    "retire",
    "retreat",
    "return",
    "reunion",
    "reveal",
    "review",
    "reward",
    "rhythm",
    "rib",
    "ribbon",
    "rice",
    "rich",
    "ride",
    "ridge",
    "rifle",
    "right",
    "rigid",
    "ring",
    "riot",
    "ripple",
    "risk",
    "ritual",
    "rival",
    "river",
    "road",
    "roast",
    "robot",
    "robust",
    "rocket",
    "romance",
    "roof",
    "rookie",
    "room",
    "rose",
    "rotate",
    "rough",
    "round",
    "route",
    "royal",
    "rubber",
    "rude",
    "rug",
    "rule",
    "run",
    "runway",
    "rural",
    "sad",
    "saddle",
    "sadness",
    "safe",
    "sail",
    "salad",
    "salmon",
    "salon",
    "salt",
    "salute",
    "same",
    "sample",
    "sand",
    "satisfy",
    "satoshi",
    "sauce",
    "sausage",
    "save",
    "say",
    "scale",
    "scan",
    "scare",
    "scatter",
    "scene",
    "scheme",
    "school",
    "science",
    "scissors",
    "scorpion",
    "scout",
    "scrap",
    "screen",
    "script",
    "scrub",
    "sea",
    "search",
    "season",
    "seat",
    "second",
    "secret",
    "section",
    "security",
    "seed",
    "seek",
    "segment",
    "select",
    "sell",
    "seminar",
    "senior",
    "sense",
    "sentence",
    "series",
    "service",
    "session",
    "settle",
    "setup",
    "seven",
    "shadow",
    "shaft",
    "shallow",
    "share",
    "shed",
    "shell",
    "sheriff",
    "shield",
    "shift",
    "shine",
    "ship",
    "shiver",
    "shock",
    "shoe",
    "shoot",
    "shop",
    "short",
    "shoulder",
    "shove",
    "shrimp",
    "shrug",
    "shuffle",
    "shy",
    "sibling",
    "sick",
    "side",
    "siege",
    "sight",
    "sign",
    "silent",
    "silk",
    "silly",
    "silver",
    "similar",
    "simple",
    "since",
    "sing",
    "siren",
    "sister",
    "situate",
    "six",
    "size",
    "skate",
    "sketch",
    "ski",
    "skill",
    "skin",
    "skirt",
    "skull",
    "slab",
    "slam",
    "sleep",
    "slender",
    "slice",
    "slide",
    "slight",
    "slim",
    "slogan",
    "slot",
    "slow",
    "slush",
    "small",
    "smart",
    "smile",
    "smoke",
    "smooth",
    "snack",
    "snake",
    "snap",
    "sniff",
    "snow",
    "soap",
    "soccer",
    "social",
    "sock",
    "soda",
    "soft",
    "solar",
    "soldier",
    "solid",
    "solution",
    "solve",
    "someone",
    "song",
    "soon",
    "sorry",
    "sort",
    "soul",
    "sound",
    "soup",
    "source",
    "south",
    "space",
    "spare",
    "spatial",
    "spawn",
    "speak",
    "special",
    "speed",
    "spell",
    "spend",
    "sphere",
    "spice",
    "spider",
    "spike",
    "spin",
    "spirit",
    "split",
    "spoil",
    "sponsor",
    "spoon",
    "sport",
    "spot",
    "spray",
    "spread",
    "spring",
    "spy",
    "square",
    "squeeze",
    "squirrel",
    "stable",
    "stadium",
    "staff",
    "stage",
    "stairs",
    "stamp",
    "stand",
    "start",
    "state",
    "stay",
    "steak",
    "steel",
    "stem",
    "step",
    "stereo",
    "stick",
    "still",
    "sting",
    "stock",
    "stomach",
    "stone",
    "stool",
    "story",
    "stove",
    "strategy",
    "street",
    "strike",
    "strong",
    "struggle",
    "student",
    "stuff",
    "stumble",
    "style",
    "subject",
    "submit",
    "subway",
    "success",
    "such",
    "sudden",
    "suffer",
    "sugar",
    "suggest",
    "suit",
    "summer",
    "sun",
    "sunny",
    "sunset",
    "super",
    "supply",
    "supreme",
    "sure",
    "surface",
    "surge",
    "surprise",
    "surround",
    "survey",
    "suspect",
    "sustain",
    "swallow",
    "swamp",
    "swap",
    "swarm",
    "swear",
    "sweet",
    "swift",
    "swim",
    "swing",
    "switch",
    "sword",
    "symbol",
    "symptom",
    "syrup",
    "system",
    "table",
    "tackle",
    "tag",
    "tail",
    "talent",
    "talk",
    "tank",
    "tape",
    "target",
    "task",
    "taste",
    "tattoo",
    "taxi",
    "teach",
    "team",
    "tell",
    "ten",
    "tenant",
    "tennis",
    "tent",
    "term",
    "test",
    "text",
    "thank",
    "that",
    "theme",
    "then",
    "theory",
    "there",
    "they",
    "thing",
    "this",
    "thought",
    "three",
    "thrive",
    "throw",
    "thumb",
    "thunder",
    "ticket",
    "tide",
    "tiger",
    "tilt",
    "timber",
    "time",
    "tiny",
    "tip",
    "tired",
    "tissue",
    "title",
    "toast",
    "tobacco",
    "today",
    "toddler",
    "toe",
    "together",
    "toilet",
    "token",
    "tomato",
    "tomorrow",
    "tone",
    "tongue",
    "tonight",
    "tool",
    "tooth",
    "top",
    "topic",
    "topple",
    "torch",
    "tornado",
    "tortoise",
    "toss",
    "total",
    "tourist",
    "toward",
    "tower",
    "town",
    "toy",
    "track",
    "trade",
    "traffic",
    "tragic",
    "train",
    "transfer",
    "trap",
    "trash",
    "travel",
    "tray",
    "treat",
    "tree",
    "trend",
    "trial",
    "tribe",
    "trick",
    "trigger",
    "trim",
    "trip",
    "trophy",
    "trouble",
    "truck",
    "true",
    "truly",
    "trumpet",
    "trust",
    "truth",
    "try",
    "tube",
    "tuition",
    "tumble",
    "tuna",
    "tunnel",
    "turkey",
    "turn",
    "turtle",
    "twelve",
    "twenty",
    "twice",
    "twin",
    "twist",
    "two",
    "type",
    "typical",
    "ugly",
    "umbrella",
    "unable",
    "unaware",
    "uncle",
    "uncover",
    "under",
    "undo",
    "unfair",
    "unfold",
    "unhappy",
    "uniform",
    "unique",
    "unit",
    "universe",
    "unknown",
    "unlock",
    "until",
    "unusual",
    "unveil",
    "update",
    "upgrade",
    "uphold",
    "upon",
    "upper",
    "upset",
    "urban",
    "urge",
    "usage",
    "use",
    "used",
    "useful",
    "useless",
    "usual",
    "utility",
    "vacant",
    "vacuum",
    "vague",
    "valid",
    "valley",
    "valve",
    "van",
    "vanish",
    "vapor",
    "various",
    "vast",
    "vault",
    "vehicle",
    "velvet",
    "vendor",
    "venture",
    "venue",
    "verb",
    "verify",
    "version",
    "very",
    "vessel",
    "veteran",
    "viable",
    "vibrant",
    "vicious",
    "victory",
    "video",
    "view",
    "village",
    "vintage",
    "violin",
    "virtual",
    "virus",
    "visa",
    "visit",
    "visual",
    "vital",
    "vivid",
    "vocal",
    "voice",
    "void",
    "volcano",
    "volume",
    "vote",
    "voyage",
    "wage",
    "wagon",
    "wait",
    "walk",
    "wall",
    "walnut",
    "want",
    "warfare",
    "warm",
    "warrior",
    "wash",
    "wasp",
    "waste",
    "water",
    "wave",
    "way",
    "wealth",
    "weapon",
    "wear",
    "weasel",
    "weather",
    "web",
    "wedding",
    "weekend",
    "weird",
    "welcome",
    "west",
    "wet",
    "whale",
    "what",
    "wheat",
    "wheel",
    "when",
    "where",
    "whip",
    "whisper",
    "wide",
    "width",
    "wife",
    "wild",
    "will",
    "win",
    "window",
    "wine",
    "wing",
    "wink",
    "winner",
    "winter",
    "wire",
    "wisdom",
    "wise",
    "wish",
    "witness",
    "wolf",
    "woman",
    "wonder",
    "wood",
    "wool",
    "word",
    "work",
    "world",
    "worry",
    "worth",
    "wrap",
    "wreck",
    "wrestle",
    "wrist",
    "write",
    "wrong",
    "yard",
    "year",
    "yellow",
    "you",
    "young",
    "youth",
    "zebra",
    "zero",
    "zone",
    "zoo",
];
function bytesToBitstring(bytes) {
    return Array.from(bytes)
        .map((byte) => byte.toString(2).padStart(8, "0"))
        .join("");
}
function deriveChecksumBits(entropy) {
    const entropyLengthBits = entropy.length * 8; // "ENT" (in bits)
    const checksumLengthBits = entropyLengthBits / 32; // "CS" (in bits)
    const hash = (0, sha_1.sha256)(entropy);
    return bytesToBitstring(hash).slice(0, checksumLengthBits);
}
function bitstringToByte(bin) {
    return parseInt(bin, 2);
}
const allowedEntropyLengths = [16, 20, 24, 28, 32];
const allowedWordLengths = [12, 15, 18, 21, 24];
function entropyToMnemonic(entropy) {
    if (allowedEntropyLengths.indexOf(entropy.length) === -1) {
        throw new Error("invalid input length");
    }
    const entropyBits = bytesToBitstring(entropy);
    const checksumBits = deriveChecksumBits(entropy);
    const bits = entropyBits + checksumBits;
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const chunks = bits.match(/(.{11})/g);
    const words = chunks.map((binary) => {
        const index = bitstringToByte(binary);
        return wordlist[index];
    });
    return words.join(" ");
}
exports.entropyToMnemonic = entropyToMnemonic;
const invalidNumberOfWorks = "Invalid number of words";
const wordNotInWordlist = "Found word that is not in the wordlist";
const invalidEntropy = "Invalid entropy";
const invalidChecksum = "Invalid mnemonic checksum";
function normalize(str) {
    return str.normalize("NFKD");
}
function mnemonicToEntropy(mnemonic) {
    const words = normalize(mnemonic).split(" ");
    if (!allowedWordLengths.includes(words.length)) {
        throw new Error(invalidNumberOfWorks);
    }
    // convert word indices to 11 bit binary strings
    const bits = words
        .map((word) => {
        const index = wordlist.indexOf(word);
        if (index === -1) {
            throw new Error(wordNotInWordlist);
        }
        return index.toString(2).padStart(11, "0");
    })
        .join("");
    // split the binary string into ENT/CS
    const dividerIndex = Math.floor(bits.length / 33) * 32;
    const entropyBits = bits.slice(0, dividerIndex);
    const checksumBits = bits.slice(dividerIndex);
    // calculate the checksum and compare
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const entropyBytes = entropyBits.match(/(.{1,8})/g).map(bitstringToByte);
    if (entropyBytes.length < 16 || entropyBytes.length > 32 || entropyBytes.length % 4 !== 0) {
        throw new Error(invalidEntropy);
    }
    const entropy = Uint8Array.from(entropyBytes);
    const newChecksum = deriveChecksumBits(entropy);
    if (newChecksum !== checksumBits) {
        throw new Error(invalidChecksum);
    }
    return entropy;
}
exports.mnemonicToEntropy = mnemonicToEntropy;
class EnglishMnemonic {
    constructor(mnemonic) {
        if (!EnglishMnemonic.mnemonicMatcher.test(mnemonic)) {
            throw new Error("Invalid mnemonic format");
        }
        const words = mnemonic.split(" ");
        const allowedWordsLengths = [12, 15, 18, 21, 24];
        if (allowedWordsLengths.indexOf(words.length) === -1) {
            throw new Error(`Invalid word count in mnemonic (allowed: ${allowedWordsLengths} got: ${words.length})`);
        }
        for (const word of words) {
            if (EnglishMnemonic.wordlist.indexOf(word) === -1) {
                throw new Error("Mnemonic contains invalid word");
            }
        }
        // Throws with informative error message if mnemonic is not valid
        mnemonicToEntropy(mnemonic);
        this.data = mnemonic;
    }
    toString() {
        return this.data;
    }
}
exports.EnglishMnemonic = EnglishMnemonic;
EnglishMnemonic.wordlist = wordlist;
// list of space separated lower case words (1 or more)
EnglishMnemonic.mnemonicMatcher = /^[a-z]+( [a-z]+)*$/;
class Bip39 {
    /**
     * Encodes raw entropy of length 16, 20, 24, 28 or 32 bytes as an English mnemonic between 12 and 24 words.
     *
     * | Entropy            | Words |
     * |--------------------|-------|
     * | 128 bit (16 bytes) |    12 |
     * | 160 bit (20 bytes) |    15 |
     * | 192 bit (24 bytes) |    18 |
     * | 224 bit (28 bytes) |    21 |
     * | 256 bit (32 bytes) |    24 |
     *
     *
     * @see https://github.com/bitcoin/bips/blob/master/bip-0039.mediawiki#generating-the-mnemonic
     * @param entropy The entropy to be encoded. This must be cryptographically secure.
     */
    static encode(entropy) {
        return new EnglishMnemonic(entropyToMnemonic(entropy));
    }
    static decode(mnemonic) {
        return mnemonicToEntropy(mnemonic.toString());
    }
    static async mnemonicToSeed(mnemonic, password) {
        const mnemonicBytes = (0, encoding_1.toUtf8)(normalize(mnemonic.toString()));
        const salt = "mnemonic" + (password ? normalize(password) : "");
        const saltBytes = (0, encoding_1.toUtf8)(salt);
        return (0, pbkdf2_1.pbkdf2Sha512)(mnemonicBytes, saltBytes, 2048, 64);
    }
}
exports.Bip39 = Bip39;
//# sourceMappingURL=bip39.js.map

/***/ }),

/***/ 13955:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Hmac = void 0;
class Hmac {
    constructor(hashFunctionConstructor, originalKey) {
        // This implementation is based on https://en.wikipedia.org/wiki/HMAC#Implementation
        // with the addition of incremental hashing support. Thus part of the algorithm
        // is in the constructor and the rest in digest().
        const blockSize = new hashFunctionConstructor().blockSize;
        this.hash = (data) => new hashFunctionConstructor().update(data).digest();
        let key = originalKey;
        if (key.length > blockSize) {
            key = this.hash(key);
        }
        if (key.length < blockSize) {
            const zeroPadding = new Uint8Array(blockSize - key.length);
            key = new Uint8Array([...key, ...zeroPadding]);
        }
        // eslint-disable-next-line no-bitwise
        this.oKeyPad = key.map((keyByte) => keyByte ^ 0x5c);
        // eslint-disable-next-line no-bitwise
        this.iKeyPad = key.map((keyByte) => keyByte ^ 0x36);
        this.messageHasher = new hashFunctionConstructor();
        this.blockSize = blockSize;
        this.update(this.iKeyPad);
    }
    update(data) {
        this.messageHasher.update(data);
        return this;
    }
    digest() {
        const innerHash = this.messageHasher.digest();
        return this.hash(new Uint8Array([...this.oKeyPad, ...innerHash]));
    }
}
exports.Hmac = Hmac;
//# sourceMappingURL=hmac.js.map

/***/ }),

/***/ 79562:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.stringToPath = exports.Slip10RawIndex = exports.slip10CurveFromString = exports.Slip10Curve = exports.Slip10 = exports.pathToString = exports.sha512 = exports.Sha512 = exports.sha256 = exports.Sha256 = exports.Secp256k1Signature = exports.ExtendedSecp256k1Signature = exports.Secp256k1 = exports.ripemd160 = exports.Ripemd160 = exports.Random = exports.Xchacha20poly1305Ietf = exports.xchacha20NonceLength = exports.isArgon2idOptions = exports.Ed25519Keypair = exports.Ed25519 = exports.Argon2id = exports.keccak256 = exports.Keccak256 = exports.Hmac = exports.EnglishMnemonic = exports.Bip39 = void 0;
var bip39_1 = __webpack_require__(99549);
Object.defineProperty(exports, "Bip39", ({ enumerable: true, get: function () { return bip39_1.Bip39; } }));
Object.defineProperty(exports, "EnglishMnemonic", ({ enumerable: true, get: function () { return bip39_1.EnglishMnemonic; } }));
var hmac_1 = __webpack_require__(13955);
Object.defineProperty(exports, "Hmac", ({ enumerable: true, get: function () { return hmac_1.Hmac; } }));
var keccak_1 = __webpack_require__(59372);
Object.defineProperty(exports, "Keccak256", ({ enumerable: true, get: function () { return keccak_1.Keccak256; } }));
Object.defineProperty(exports, "keccak256", ({ enumerable: true, get: function () { return keccak_1.keccak256; } }));
var libsodium_1 = __webpack_require__(53942);
Object.defineProperty(exports, "Argon2id", ({ enumerable: true, get: function () { return libsodium_1.Argon2id; } }));
Object.defineProperty(exports, "Ed25519", ({ enumerable: true, get: function () { return libsodium_1.Ed25519; } }));
Object.defineProperty(exports, "Ed25519Keypair", ({ enumerable: true, get: function () { return libsodium_1.Ed25519Keypair; } }));
Object.defineProperty(exports, "isArgon2idOptions", ({ enumerable: true, get: function () { return libsodium_1.isArgon2idOptions; } }));
Object.defineProperty(exports, "xchacha20NonceLength", ({ enumerable: true, get: function () { return libsodium_1.xchacha20NonceLength; } }));
Object.defineProperty(exports, "Xchacha20poly1305Ietf", ({ enumerable: true, get: function () { return libsodium_1.Xchacha20poly1305Ietf; } }));
var random_1 = __webpack_require__(616);
Object.defineProperty(exports, "Random", ({ enumerable: true, get: function () { return random_1.Random; } }));
var ripemd_1 = __webpack_require__(70568);
Object.defineProperty(exports, "Ripemd160", ({ enumerable: true, get: function () { return ripemd_1.Ripemd160; } }));
Object.defineProperty(exports, "ripemd160", ({ enumerable: true, get: function () { return ripemd_1.ripemd160; } }));
var secp256k1_1 = __webpack_require__(56649);
Object.defineProperty(exports, "Secp256k1", ({ enumerable: true, get: function () { return secp256k1_1.Secp256k1; } }));
var secp256k1signature_1 = __webpack_require__(58222);
Object.defineProperty(exports, "ExtendedSecp256k1Signature", ({ enumerable: true, get: function () { return secp256k1signature_1.ExtendedSecp256k1Signature; } }));
Object.defineProperty(exports, "Secp256k1Signature", ({ enumerable: true, get: function () { return secp256k1signature_1.Secp256k1Signature; } }));
var sha_1 = __webpack_require__(52387);
Object.defineProperty(exports, "Sha256", ({ enumerable: true, get: function () { return sha_1.Sha256; } }));
Object.defineProperty(exports, "sha256", ({ enumerable: true, get: function () { return sha_1.sha256; } }));
Object.defineProperty(exports, "Sha512", ({ enumerable: true, get: function () { return sha_1.Sha512; } }));
Object.defineProperty(exports, "sha512", ({ enumerable: true, get: function () { return sha_1.sha512; } }));
var slip10_1 = __webpack_require__(52081);
Object.defineProperty(exports, "pathToString", ({ enumerable: true, get: function () { return slip10_1.pathToString; } }));
Object.defineProperty(exports, "Slip10", ({ enumerable: true, get: function () { return slip10_1.Slip10; } }));
Object.defineProperty(exports, "Slip10Curve", ({ enumerable: true, get: function () { return slip10_1.Slip10Curve; } }));
Object.defineProperty(exports, "slip10CurveFromString", ({ enumerable: true, get: function () { return slip10_1.slip10CurveFromString; } }));
Object.defineProperty(exports, "Slip10RawIndex", ({ enumerable: true, get: function () { return slip10_1.Slip10RawIndex; } }));
Object.defineProperty(exports, "stringToPath", ({ enumerable: true, get: function () { return slip10_1.stringToPath; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 59372:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.keccak256 = exports.Keccak256 = void 0;
const sha3_1 = __webpack_require__(85426);
const utils_1 = __webpack_require__(49583);
class Keccak256 {
    constructor(firstData) {
        this.blockSize = 512 / 8;
        this.impl = sha3_1.keccak_256.create();
        if (firstData) {
            this.update(firstData);
        }
    }
    update(data) {
        this.impl.update((0, utils_1.toRealUint8Array)(data));
        return this;
    }
    digest() {
        return this.impl.digest();
    }
}
exports.Keccak256 = Keccak256;
/** Convenience function equivalent to `new Keccak256(data).digest()` */
function keccak256(data) {
    return new Keccak256(data).digest();
}
exports.keccak256 = keccak256;
//# sourceMappingURL=keccak.js.map

/***/ }),

/***/ 53942:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

// Keep all classes requiring libsodium-js in one file as having multiple
// requiring of the libsodium-wrappers module currently crashes browsers
//
// libsodium.js API: https://gist.github.com/webmaster128/b2dbe6d54d36dd168c9fabf441b9b09c
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Xchacha20poly1305Ietf = exports.xchacha20NonceLength = exports.Ed25519 = exports.Ed25519Keypair = exports.Argon2id = exports.isArgon2idOptions = void 0;
const utils_1 = __webpack_require__(85553);
const libsodium_wrappers_1 = __importDefault(__webpack_require__(6869));
function isArgon2idOptions(thing) {
    if (!(0, utils_1.isNonNullObject)(thing))
        return false;
    if (typeof thing.outputLength !== "number")
        return false;
    if (typeof thing.opsLimit !== "number")
        return false;
    if (typeof thing.memLimitKib !== "number")
        return false;
    return true;
}
exports.isArgon2idOptions = isArgon2idOptions;
class Argon2id {
    static async execute(password, salt, options) {
        await libsodium_wrappers_1.default.ready;
        return libsodium_wrappers_1.default.crypto_pwhash(options.outputLength, password, salt, // libsodium only supports 16 byte salts and will throw when you don't respect that
        options.opsLimit, options.memLimitKib * 1024, libsodium_wrappers_1.default.crypto_pwhash_ALG_ARGON2ID13);
    }
}
exports.Argon2id = Argon2id;
class Ed25519Keypair {
    constructor(privkey, pubkey) {
        this.privkey = privkey;
        this.pubkey = pubkey;
    }
    // a libsodium privkey has the format `<ed25519 privkey> + <ed25519 pubkey>`
    static fromLibsodiumPrivkey(libsodiumPrivkey) {
        if (libsodiumPrivkey.length !== 64) {
            throw new Error(`Unexpected key length ${libsodiumPrivkey.length}. Must be 64.`);
        }
        return new Ed25519Keypair(libsodiumPrivkey.slice(0, 32), libsodiumPrivkey.slice(32, 64));
    }
    toLibsodiumPrivkey() {
        return new Uint8Array([...this.privkey, ...this.pubkey]);
    }
}
exports.Ed25519Keypair = Ed25519Keypair;
class Ed25519 {
    /**
     * Generates a keypair deterministically from a given 32 bytes seed.
     *
     * This seed equals the Ed25519 private key.
     * For implementation details see crypto_sign_seed_keypair in
     * https://download.libsodium.org/doc/public-key_cryptography/public-key_signatures.html
     * and diagram on https://blog.mozilla.org/warner/2011/11/29/ed25519-keys/
     */
    static async makeKeypair(seed) {
        await libsodium_wrappers_1.default.ready;
        const keypair = libsodium_wrappers_1.default.crypto_sign_seed_keypair(seed);
        return Ed25519Keypair.fromLibsodiumPrivkey(keypair.privateKey);
    }
    static async createSignature(message, keyPair) {
        await libsodium_wrappers_1.default.ready;
        return libsodium_wrappers_1.default.crypto_sign_detached(message, keyPair.toLibsodiumPrivkey());
    }
    static async verifySignature(signature, message, pubkey) {
        await libsodium_wrappers_1.default.ready;
        return libsodium_wrappers_1.default.crypto_sign_verify_detached(signature, message, pubkey);
    }
}
exports.Ed25519 = Ed25519;
/**
 * Nonce length in bytes for all flavours of XChaCha20.
 *
 * @see https://libsodium.gitbook.io/doc/advanced/stream_ciphers/xchacha20#notes
 */
exports.xchacha20NonceLength = 24;
class Xchacha20poly1305Ietf {
    static async encrypt(message, key, nonce) {
        await libsodium_wrappers_1.default.ready;
        const additionalData = null;
        return libsodium_wrappers_1.default.crypto_aead_xchacha20poly1305_ietf_encrypt(message, additionalData, null, // secret nonce: unused and should be null (https://download.libsodium.org/doc/secret-key_cryptography/aead/chacha20-poly1305/xchacha20-poly1305_construction)
        nonce, key);
    }
    static async decrypt(ciphertext, key, nonce) {
        await libsodium_wrappers_1.default.ready;
        const additionalData = null;
        return libsodium_wrappers_1.default.crypto_aead_xchacha20poly1305_ietf_decrypt(null, // secret nonce: unused and should be null (https://download.libsodium.org/doc/secret-key_cryptography/aead/chacha20-poly1305/xchacha20-poly1305_construction)
        ciphertext, additionalData, nonce, key);
    }
}
exports.Xchacha20poly1305Ietf = Xchacha20poly1305Ietf;
//# sourceMappingURL=libsodium.js.map

/***/ }),

/***/ 42997:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.pbkdf2Sha512 = exports.pbkdf2Sha512Noble = exports.pbkdf2Sha512Crypto = exports.pbkdf2Sha512Subtle = exports.getSubtle = exports.getCryptoModule = void 0;
const utils_1 = __webpack_require__(85553);
const pbkdf2_1 = __webpack_require__(29023);
const sha512_1 = __webpack_require__(86262);
/**
 * Returns the Node.js crypto module when available and `undefined`
 * otherwise.
 *
 * Detects an unimplemented fallback module from Webpack 5 and returns
 * `undefined` in that case.
 */
async function getCryptoModule() {
    try {
        const crypto = await Promise.resolve().then(() => __importStar(__webpack_require__(42474)));
        // We get `Object{default: Object{}}` as a fallback when using
        // `crypto: false` in Webpack 5, which we interprete as unavailable.
        if (typeof crypto === "object" && Object.keys(crypto).length <= 1) {
            return undefined;
        }
        return crypto;
    }
    catch (_a) {
        return undefined;
    }
}
exports.getCryptoModule = getCryptoModule;
async function getSubtle() {
    // From Node.js 15 onwards, webcrypto is available in globalThis.
    // In version 15 and 16 this was stored under the webcrypto key.
    // With Node.js 17 it was moved to the same locations where browsers
    // make it available.
    // Loading `require("crypto")` here seems unnecessary since it only
    // causes issues with bundlers and does not increase compatibility.
    var _a, _b, _c;
    // Browsers and Node.js 17+
    let subtle = (_a = globalThis === null || globalThis === void 0 ? void 0 : globalThis.crypto) === null || _a === void 0 ? void 0 : _a.subtle;
    // Node.js 15+
    if (!subtle)
        subtle = (_c = (_b = globalThis === null || globalThis === void 0 ? void 0 : globalThis.crypto) === null || _b === void 0 ? void 0 : _b.webcrypto) === null || _c === void 0 ? void 0 : _c.subtle;
    return subtle;
}
exports.getSubtle = getSubtle;
async function pbkdf2Sha512Subtle(
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
subtle, secret, salt, iterations, keylen) {
    (0, utils_1.assert)(subtle, "Argument subtle is falsy");
    (0, utils_1.assert)(typeof subtle === "object", "Argument subtle is not of type object");
    (0, utils_1.assert)(typeof subtle.importKey === "function", "subtle.importKey is not a function");
    (0, utils_1.assert)(typeof subtle.deriveBits === "function", "subtle.deriveBits is not a function");
    return subtle.importKey("raw", secret, { name: "PBKDF2" }, false, ["deriveBits"]).then((key) => subtle
        .deriveBits({
        name: "PBKDF2",
        salt: salt,
        iterations: iterations,
        hash: { name: "SHA-512" },
    }, key, keylen * 8)
        .then((buffer) => new Uint8Array(buffer)));
}
exports.pbkdf2Sha512Subtle = pbkdf2Sha512Subtle;
async function pbkdf2Sha512Crypto(
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
crypto, secret, salt, iterations, keylen) {
    (0, utils_1.assert)(crypto, "Argument crypto is falsy");
    (0, utils_1.assert)(typeof crypto === "object", "Argument crypto is not of type object");
    (0, utils_1.assert)(typeof crypto.pbkdf2 === "function", "crypto.pbkdf2 is not a function");
    return new Promise((resolve, reject) => {
        crypto.pbkdf2(secret, salt, iterations, keylen, "sha512", (error, result) => {
            if (error) {
                reject(error);
            }
            else {
                resolve(Uint8Array.from(result));
            }
        });
    });
}
exports.pbkdf2Sha512Crypto = pbkdf2Sha512Crypto;
async function pbkdf2Sha512Noble(secret, salt, iterations, keylen) {
    return (0, pbkdf2_1.pbkdf2Async)(sha512_1.sha512, secret, salt, { c: iterations, dkLen: keylen });
}
exports.pbkdf2Sha512Noble = pbkdf2Sha512Noble;
/**
 * A pbkdf2 implementation for BIP39. This is not exported at package level and thus a private API.
 */
async function pbkdf2Sha512(secret, salt, iterations, keylen) {
    const subtle = await getSubtle();
    if (subtle) {
        return pbkdf2Sha512Subtle(subtle, secret, salt, iterations, keylen);
    }
    else {
        const crypto = await getCryptoModule();
        if (crypto) {
            return pbkdf2Sha512Crypto(crypto, secret, salt, iterations, keylen);
        }
        else {
            return pbkdf2Sha512Noble(secret, salt, iterations, keylen);
        }
    }
}
exports.pbkdf2Sha512 = pbkdf2Sha512;
//# sourceMappingURL=pbkdf2.js.map

/***/ }),

/***/ 616:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Random = void 0;
class Random {
    /**
     * Returns `count` cryptographically secure random bytes
     */
    static getBytes(count) {
        try {
            const globalObject = typeof window === "object" ? window : self;
            const cryptoApi = typeof globalObject.crypto !== "undefined" ? globalObject.crypto : globalObject.msCrypto;
            const out = new Uint8Array(count);
            cryptoApi.getRandomValues(out);
            return out;
        }
        catch (_a) {
            try {
                // eslint-disable-next-line @typescript-eslint/no-var-requires
                const crypto = __webpack_require__(42474);
                return new Uint8Array([...crypto.randomBytes(count)]);
            }
            catch (_b) {
                throw new Error("No secure random number generator found");
            }
        }
    }
}
exports.Random = Random;
//# sourceMappingURL=random.js.map

/***/ }),

/***/ 70568:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ripemd160 = exports.Ripemd160 = void 0;
const ripemd160_1 = __webpack_require__(70830);
const utils_1 = __webpack_require__(49583);
class Ripemd160 {
    constructor(firstData) {
        this.blockSize = 512 / 8;
        this.impl = ripemd160_1.ripemd160.create();
        if (firstData) {
            this.update(firstData);
        }
    }
    update(data) {
        this.impl.update((0, utils_1.toRealUint8Array)(data));
        return this;
    }
    digest() {
        return this.impl.digest();
    }
}
exports.Ripemd160 = Ripemd160;
/** Convenience function equivalent to `new Ripemd160(data).digest()` */
function ripemd160(data) {
    return new Ripemd160(data).digest();
}
exports.ripemd160 = ripemd160;
//# sourceMappingURL=ripemd.js.map

/***/ }),

/***/ 56649:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Secp256k1 = void 0;
const encoding_1 = __webpack_require__(92540);
const bn_js_1 = __importDefault(__webpack_require__(13550));
const elliptic_1 = __importDefault(__webpack_require__(86266));
const secp256k1signature_1 = __webpack_require__(58222);
const secp256k1 = new elliptic_1.default.ec("secp256k1");
const secp256k1N = new bn_js_1.default("FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEBAAEDCE6AF48A03BBFD25E8CD0364141", "hex");
class Secp256k1 {
    /**
     * Takes a 32 byte private key and returns a privkey/pubkey pair.
     *
     * The resulting pubkey is uncompressed. For the use in Cosmos it should
     * be compressed first using `Secp256k1.compressPubkey`.
     */
    static async makeKeypair(privkey) {
        if (privkey.length !== 32) {
            // is this check missing in secp256k1.validatePrivateKey?
            // https://github.com/bitjson/bitcoin-ts/issues/4
            throw new Error("input data is not a valid secp256k1 private key");
        }
        const keypair = secp256k1.keyFromPrivate(privkey);
        if (keypair.validate().result !== true) {
            throw new Error("input data is not a valid secp256k1 private key");
        }
        // range test that is not part of the elliptic implementation
        const privkeyAsBigInteger = new bn_js_1.default(privkey);
        if (privkeyAsBigInteger.gte(secp256k1N)) {
            // not strictly smaller than N
            throw new Error("input data is not a valid secp256k1 private key");
        }
        const out = {
            privkey: (0, encoding_1.fromHex)(keypair.getPrivate("hex")),
            // encodes uncompressed as
            // - 1-byte prefix "04"
            // - 32-byte x coordinate
            // - 32-byte y coordinate
            pubkey: Uint8Array.from(keypair.getPublic("array")),
        };
        return out;
    }
    /**
     * Creates a signature that is
     * - deterministic (RFC 6979)
     * - lowS signature
     * - DER encoded
     */
    static async createSignature(messageHash, privkey) {
        if (messageHash.length === 0) {
            throw new Error("Message hash must not be empty");
        }
        if (messageHash.length > 32) {
            throw new Error("Message hash length must not exceed 32 bytes");
        }
        const keypair = secp256k1.keyFromPrivate(privkey);
        // the `canonical` option ensures creation of lowS signature representations
        const { r, s, recoveryParam } = keypair.sign(messageHash, { canonical: true });
        if (typeof recoveryParam !== "number")
            throw new Error("Recovery param missing");
        return new secp256k1signature_1.ExtendedSecp256k1Signature(Uint8Array.from(r.toArray()), Uint8Array.from(s.toArray()), recoveryParam);
    }
    static async verifySignature(signature, messageHash, pubkey) {
        if (messageHash.length === 0) {
            throw new Error("Message hash must not be empty");
        }
        if (messageHash.length > 32) {
            throw new Error("Message hash length must not exceed 32 bytes");
        }
        const keypair = secp256k1.keyFromPublic(pubkey);
        // From https://github.com/indutny/elliptic:
        //
        //     Sign the message's hash (input must be an array, or a hex-string)
        //
        //     Signature MUST be either:
        //     1) DER-encoded signature as hex-string; or
        //     2) DER-encoded signature as buffer; or
        //     3) object with two hex-string properties (r and s); or
        //     4) object with two buffer properties (r and s)
        //
        // Uint8Array is not a Buffer, but elliptic seems to be happy with the interface
        // common to both types. Uint8Array is not an array of ints but the interface is
        // similar
        try {
            return keypair.verify(messageHash, signature.toDer());
        }
        catch (error) {
            return false;
        }
    }
    static recoverPubkey(signature, messageHash) {
        const signatureForElliptic = { r: (0, encoding_1.toHex)(signature.r()), s: (0, encoding_1.toHex)(signature.s()) };
        const point = secp256k1.recoverPubKey(messageHash, signatureForElliptic, signature.recovery);
        const keypair = secp256k1.keyFromPublic(point);
        return (0, encoding_1.fromHex)(keypair.getPublic(false, "hex"));
    }
    /**
     * Takes a compressed or uncompressed pubkey and return a compressed one.
     *
     * This function is idempotent.
     */
    static compressPubkey(pubkey) {
        switch (pubkey.length) {
            case 33:
                return pubkey;
            case 65:
                return Uint8Array.from(secp256k1.keyFromPublic(pubkey).getPublic(true, "array"));
            default:
                throw new Error("Invalid pubkey length");
        }
    }
    /**
     * Takes a compressed or uncompressed pubkey and returns an uncompressed one.
     *
     * This function is idempotent.
     */
    static uncompressPubkey(pubkey) {
        switch (pubkey.length) {
            case 33:
                return Uint8Array.from(secp256k1.keyFromPublic(pubkey).getPublic(false, "array"));
            case 65:
                return pubkey;
            default:
                throw new Error("Invalid pubkey length");
        }
    }
    static trimRecoveryByte(signature) {
        switch (signature.length) {
            case 64:
                return signature;
            case 65:
                return signature.slice(0, 64);
            default:
                throw new Error("Invalid signature length");
        }
    }
}
exports.Secp256k1 = Secp256k1;
//# sourceMappingURL=secp256k1.js.map

/***/ }),

/***/ 58222:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ExtendedSecp256k1Signature = exports.Secp256k1Signature = void 0;
function trimLeadingNullBytes(inData) {
    let numberOfLeadingNullBytes = 0;
    for (const byte of inData) {
        if (byte === 0x00) {
            numberOfLeadingNullBytes++;
        }
        else {
            break;
        }
    }
    return inData.slice(numberOfLeadingNullBytes);
}
const derTagInteger = 0x02;
class Secp256k1Signature {
    constructor(r, s) {
        if (r.length > 32 || r.length === 0 || r[0] === 0x00) {
            throw new Error("Unsigned integer r must be encoded as unpadded big endian.");
        }
        if (s.length > 32 || s.length === 0 || s[0] === 0x00) {
            throw new Error("Unsigned integer s must be encoded as unpadded big endian.");
        }
        this.data = {
            r: r,
            s: s,
        };
    }
    /**
     * Takes the pair of integers (r, s) as 2x32 byte of binary data.
     *
     * Note: This is the format Cosmos SDK uses natively.
     *
     * @param data a 64 byte value containing integers r and s.
     */
    static fromFixedLength(data) {
        if (data.length !== 64) {
            throw new Error(`Got invalid data length: ${data.length}. Expected 2x 32 bytes for the pair (r, s)`);
        }
        return new Secp256k1Signature(trimLeadingNullBytes(data.slice(0, 32)), trimLeadingNullBytes(data.slice(32, 64)));
    }
    static fromDer(data) {
        let pos = 0;
        if (data[pos++] !== 0x30) {
            throw new Error("Prefix 0x30 expected");
        }
        const bodyLength = data[pos++];
        if (data.length - pos !== bodyLength) {
            throw new Error("Data length mismatch detected");
        }
        // r
        const rTag = data[pos++];
        if (rTag !== derTagInteger) {
            throw new Error("INTEGER tag expected");
        }
        const rLength = data[pos++];
        if (rLength >= 0x80) {
            throw new Error("Decoding length values above 127 not supported");
        }
        const rData = data.slice(pos, pos + rLength);
        pos += rLength;
        // s
        const sTag = data[pos++];
        if (sTag !== derTagInteger) {
            throw new Error("INTEGER tag expected");
        }
        const sLength = data[pos++];
        if (sLength >= 0x80) {
            throw new Error("Decoding length values above 127 not supported");
        }
        const sData = data.slice(pos, pos + sLength);
        pos += sLength;
        return new Secp256k1Signature(
        // r/s data can contain leading 0 bytes to express integers being non-negative in DER
        trimLeadingNullBytes(rData), trimLeadingNullBytes(sData));
    }
    r(length) {
        if (length === undefined) {
            return this.data.r;
        }
        else {
            const paddingLength = length - this.data.r.length;
            if (paddingLength < 0) {
                throw new Error("Length too small to hold parameter r");
            }
            const padding = new Uint8Array(paddingLength);
            return new Uint8Array([...padding, ...this.data.r]);
        }
    }
    s(length) {
        if (length === undefined) {
            return this.data.s;
        }
        else {
            const paddingLength = length - this.data.s.length;
            if (paddingLength < 0) {
                throw new Error("Length too small to hold parameter s");
            }
            const padding = new Uint8Array(paddingLength);
            return new Uint8Array([...padding, ...this.data.s]);
        }
    }
    toFixedLength() {
        return new Uint8Array([...this.r(32), ...this.s(32)]);
    }
    toDer() {
        // DER supports negative integers but our data is unsigned. Thus we need to prepend
        // a leading 0 byte when the higest bit is set to differentiate nagative values
        const rEncoded = this.data.r[0] >= 0x80 ? new Uint8Array([0, ...this.data.r]) : this.data.r;
        const sEncoded = this.data.s[0] >= 0x80 ? new Uint8Array([0, ...this.data.s]) : this.data.s;
        const rLength = rEncoded.length;
        const sLength = sEncoded.length;
        const data = new Uint8Array([derTagInteger, rLength, ...rEncoded, derTagInteger, sLength, ...sEncoded]);
        return new Uint8Array([0x30, data.length, ...data]);
    }
}
exports.Secp256k1Signature = Secp256k1Signature;
/**
 * A Secp256k1Signature plus the recovery parameter
 */
class ExtendedSecp256k1Signature extends Secp256k1Signature {
    constructor(r, s, recovery) {
        super(r, s);
        if (!Number.isInteger(recovery)) {
            throw new Error("The recovery parameter must be an integer.");
        }
        if (recovery < 0 || recovery > 4) {
            throw new Error("The recovery parameter must be one of 0, 1, 2, 3.");
        }
        this.recovery = recovery;
    }
    /**
     * Decode extended signature from the simple fixed length encoding
     * described in toFixedLength().
     */
    static fromFixedLength(data) {
        if (data.length !== 65) {
            throw new Error(`Got invalid data length ${data.length}. Expected 32 + 32 + 1`);
        }
        return new ExtendedSecp256k1Signature(trimLeadingNullBytes(data.slice(0, 32)), trimLeadingNullBytes(data.slice(32, 64)), data[64]);
    }
    /**
     * A simple custom encoding that encodes the extended signature as
     * r (32 bytes) | s (32 bytes) | recovery param (1 byte)
     * where | denotes concatenation of bonary data.
     */
    toFixedLength() {
        return new Uint8Array([...this.r(32), ...this.s(32), this.recovery]);
    }
}
exports.ExtendedSecp256k1Signature = ExtendedSecp256k1Signature;
//# sourceMappingURL=secp256k1signature.js.map

/***/ }),

/***/ 52387:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.sha512 = exports.Sha512 = exports.sha256 = exports.Sha256 = void 0;
const sha256_1 = __webpack_require__(23061);
const sha512_1 = __webpack_require__(86262);
const utils_1 = __webpack_require__(49583);
class Sha256 {
    constructor(firstData) {
        this.blockSize = 512 / 8;
        this.impl = sha256_1.sha256.create();
        if (firstData) {
            this.update(firstData);
        }
    }
    update(data) {
        this.impl.update((0, utils_1.toRealUint8Array)(data));
        return this;
    }
    digest() {
        return this.impl.digest();
    }
}
exports.Sha256 = Sha256;
/** Convenience function equivalent to `new Sha256(data).digest()` */
function sha256(data) {
    return new Sha256(data).digest();
}
exports.sha256 = sha256;
class Sha512 {
    constructor(firstData) {
        this.blockSize = 1024 / 8;
        this.impl = sha512_1.sha512.create();
        if (firstData) {
            this.update(firstData);
        }
    }
    update(data) {
        this.impl.update((0, utils_1.toRealUint8Array)(data));
        return this;
    }
    digest() {
        return this.impl.digest();
    }
}
exports.Sha512 = Sha512;
/** Convenience function equivalent to `new Sha512(data).digest()` */
function sha512(data) {
    return new Sha512(data).digest();
}
exports.sha512 = sha512;
//# sourceMappingURL=sha.js.map

/***/ }),

/***/ 52081:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.stringToPath = exports.pathToString = exports.Slip10 = exports.Slip10RawIndex = exports.slip10CurveFromString = exports.Slip10Curve = void 0;
const encoding_1 = __webpack_require__(92540);
const math_1 = __webpack_require__(62949);
const bn_js_1 = __importDefault(__webpack_require__(13550));
const elliptic_1 = __importDefault(__webpack_require__(86266));
const hmac_1 = __webpack_require__(13955);
const sha_1 = __webpack_require__(52387);
/**
 * Raw values must match the curve string in SLIP-0010 master key generation
 *
 * @see https://github.com/satoshilabs/slips/blob/master/slip-0010.md#master-key-generation
 */
var Slip10Curve;
(function (Slip10Curve) {
    Slip10Curve["Secp256k1"] = "Bitcoin seed";
    Slip10Curve["Ed25519"] = "ed25519 seed";
})(Slip10Curve = exports.Slip10Curve || (exports.Slip10Curve = {}));
/**
 * Reverse mapping of Slip10Curve
 */
function slip10CurveFromString(curveString) {
    switch (curveString) {
        case Slip10Curve.Ed25519:
            return Slip10Curve.Ed25519;
        case Slip10Curve.Secp256k1:
            return Slip10Curve.Secp256k1;
        default:
            throw new Error(`Unknown curve string: '${curveString}'`);
    }
}
exports.slip10CurveFromString = slip10CurveFromString;
class Slip10RawIndex extends math_1.Uint32 {
    static hardened(hardenedIndex) {
        return new Slip10RawIndex(hardenedIndex + 2 ** 31);
    }
    static normal(normalIndex) {
        return new Slip10RawIndex(normalIndex);
    }
    isHardened() {
        return this.data >= 2 ** 31;
    }
}
exports.Slip10RawIndex = Slip10RawIndex;
const secp256k1 = new elliptic_1.default.ec("secp256k1");
// Universal private key derivation accoring to
// https://github.com/satoshilabs/slips/blob/master/slip-0010.md
class Slip10 {
    static derivePath(curve, seed, path) {
        let result = this.master(curve, seed);
        for (const rawIndex of path) {
            result = this.child(curve, result.privkey, result.chainCode, rawIndex);
        }
        return result;
    }
    static master(curve, seed) {
        const i = new hmac_1.Hmac(sha_1.Sha512, (0, encoding_1.toAscii)(curve)).update(seed).digest();
        const il = i.slice(0, 32);
        const ir = i.slice(32, 64);
        if (curve !== Slip10Curve.Ed25519 && (this.isZero(il) || this.isGteN(curve, il))) {
            return this.master(curve, i);
        }
        return {
            chainCode: ir,
            privkey: il,
        };
    }
    static child(curve, parentPrivkey, parentChainCode, rawIndex) {
        let i;
        if (rawIndex.isHardened()) {
            const payload = new Uint8Array([0x00, ...parentPrivkey, ...rawIndex.toBytesBigEndian()]);
            i = new hmac_1.Hmac(sha_1.Sha512, parentChainCode).update(payload).digest();
        }
        else {
            if (curve === Slip10Curve.Ed25519) {
                throw new Error("Normal keys are not allowed with ed25519");
            }
            else {
                // Step 1 of https://github.com/satoshilabs/slips/blob/master/slip-0010.md#private-parent-key--private-child-key
                // Calculate I = HMAC-SHA512(Key = c_par, Data = ser_P(point(k_par)) || ser_32(i)).
                // where the functions point() and ser_p() are defined in BIP-0032
                const data = new Uint8Array([
                    ...Slip10.serializedPoint(curve, new bn_js_1.default(parentPrivkey)),
                    ...rawIndex.toBytesBigEndian(),
                ]);
                i = new hmac_1.Hmac(sha_1.Sha512, parentChainCode).update(data).digest();
            }
        }
        return this.childImpl(curve, parentPrivkey, parentChainCode, rawIndex, i);
    }
    /**
     * Implementation of ser_P(point(k_par)) from BIP-0032
     *
     * @see https://github.com/bitcoin/bips/blob/master/bip-0032.mediawiki
     */
    static serializedPoint(curve, p) {
        switch (curve) {
            case Slip10Curve.Secp256k1:
                return (0, encoding_1.fromHex)(secp256k1.g.mul(p).encodeCompressed("hex"));
            default:
                throw new Error("curve not supported");
        }
    }
    static childImpl(curve, parentPrivkey, parentChainCode, rawIndex, i) {
        // step 2 (of the Private parent key → private child key algorithm)
        const il = i.slice(0, 32);
        const ir = i.slice(32, 64);
        // step 3
        const returnChainCode = ir;
        // step 4
        if (curve === Slip10Curve.Ed25519) {
            return {
                chainCode: returnChainCode,
                privkey: il,
            };
        }
        // step 5
        const n = this.n(curve);
        const returnChildKeyAsNumber = new bn_js_1.default(il).add(new bn_js_1.default(parentPrivkey)).mod(n);
        const returnChildKey = Uint8Array.from(returnChildKeyAsNumber.toArray("be", 32));
        // step 6
        if (this.isGteN(curve, il) || this.isZero(returnChildKey)) {
            const newI = new hmac_1.Hmac(sha_1.Sha512, parentChainCode)
                .update(new Uint8Array([0x01, ...ir, ...rawIndex.toBytesBigEndian()]))
                .digest();
            return this.childImpl(curve, parentPrivkey, parentChainCode, rawIndex, newI);
        }
        // step 7
        return {
            chainCode: returnChainCode,
            privkey: returnChildKey,
        };
    }
    static isZero(privkey) {
        return privkey.every((byte) => byte === 0);
    }
    static isGteN(curve, privkey) {
        const keyAsNumber = new bn_js_1.default(privkey);
        return keyAsNumber.gte(this.n(curve));
    }
    static n(curve) {
        switch (curve) {
            case Slip10Curve.Secp256k1:
                return new bn_js_1.default("FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEBAAEDCE6AF48A03BBFD25E8CD0364141", 16);
            default:
                throw new Error("curve not supported");
        }
    }
}
exports.Slip10 = Slip10;
function pathToString(path) {
    return path.reduce((current, component) => {
        const componentString = component.isHardened()
            ? `${component.toNumber() - 2 ** 31}'`
            : component.toString();
        return current + "/" + componentString;
    }, "m");
}
exports.pathToString = pathToString;
function stringToPath(input) {
    if (!input.startsWith("m"))
        throw new Error("Path string must start with 'm'");
    let rest = input.slice(1);
    const out = new Array();
    while (rest) {
        const match = rest.match(/^\/([0-9]+)('?)/);
        if (!match)
            throw new Error("Syntax error while reading path component");
        const [fullMatch, numberString, apostrophe] = match;
        const value = math_1.Uint53.fromString(numberString).toNumber();
        if (value >= 2 ** 31)
            throw new Error("Component value too high. Must not exceed 2**31-1.");
        if (apostrophe)
            out.push(Slip10RawIndex.hardened(value));
        else
            out.push(Slip10RawIndex.normal(value));
        rest = rest.slice(fullMatch.length);
    }
    return out;
}
exports.stringToPath = stringToPath;
//# sourceMappingURL=slip10.js.map

/***/ }),

/***/ 49583:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.toRealUint8Array = void 0;
// See https://github.com/paulmillr/noble-hashes/issues/25 for why this is needed
function toRealUint8Array(data) {
    if (data instanceof Uint8Array)
        return data;
    else
        return Uint8Array.from(data);
}
exports.toRealUint8Array = toRealUint8Array;
//# sourceMappingURL=utils.js.map

/***/ }),

/***/ 5319:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.fromAscii = exports.toAscii = void 0;
function toAscii(input) {
    const toNums = (str) => str.split("").map((x) => {
        const charCode = x.charCodeAt(0);
        // 0x00–0x1F control characters
        // 0x20–0x7E printable characters
        // 0x7F delete character
        // 0x80–0xFF out of 7 bit ascii range
        if (charCode < 0x20 || charCode > 0x7e) {
            throw new Error("Cannot encode character that is out of printable ASCII range: " + charCode);
        }
        return charCode;
    });
    return Uint8Array.from(toNums(input));
}
exports.toAscii = toAscii;
function fromAscii(data) {
    const fromNums = (listOfNumbers) => listOfNumbers.map((x) => {
        // 0x00–0x1F control characters
        // 0x20–0x7E printable characters
        // 0x7F delete character
        // 0x80–0xFF out of 7 bit ascii range
        if (x < 0x20 || x > 0x7e) {
            throw new Error("Cannot decode character that is out of printable ASCII range: " + x);
        }
        return String.fromCharCode(x);
    });
    return fromNums(Array.from(data)).join("");
}
exports.fromAscii = fromAscii;
//# sourceMappingURL=ascii.js.map

/***/ }),

/***/ 45316:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.fromBase64 = exports.toBase64 = void 0;
const base64js = __importStar(__webpack_require__(79742));
function toBase64(data) {
    return base64js.fromByteArray(data);
}
exports.toBase64 = toBase64;
function fromBase64(base64String) {
    if (!base64String.match(/^[a-zA-Z0-9+/]*={0,2}$/)) {
        throw new Error("Invalid base64 string format");
    }
    return base64js.toByteArray(base64String);
}
exports.fromBase64 = fromBase64;
//# sourceMappingURL=base64.js.map

/***/ }),

/***/ 74545:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Bech32 = exports.normalizeBech32 = exports.fromBech32 = exports.toBech32 = void 0;
const bech32 = __importStar(__webpack_require__(85541));
function toBech32(prefix, data, limit) {
    const address = bech32.encode(prefix, bech32.toWords(data), limit);
    return address;
}
exports.toBech32 = toBech32;
function fromBech32(address, limit = Infinity) {
    const decodedAddress = bech32.decode(address, limit);
    return {
        prefix: decodedAddress.prefix,
        data: new Uint8Array(bech32.fromWords(decodedAddress.words)),
    };
}
exports.fromBech32 = fromBech32;
/**
 * Takes a bech32 address and returns a normalized (i.e. lower case) representation of it.
 *
 * The input is validated along the way, which makes this significantly safer than
 * using `address.toLowerCase()`.
 */
function normalizeBech32(address) {
    const { prefix, data } = fromBech32(address);
    return toBech32(prefix, data);
}
exports.normalizeBech32 = normalizeBech32;
/**
 * @deprecated This class is deprecated and will be removed soon. Please use fromBech32() and toBech32() instead. For more details please refer to https://github.com/cosmos/cosmjs/issues/1053.
 */
class Bech32 {
    /**
     * @deprecated This class is deprecated and will be removed soon. Please use fromBech32() and toBech32() instead. For more details please refer to https://github.com/cosmos/cosmjs/issues/1053.
     */
    static encode(prefix, data, limit) {
        return toBech32(prefix, data, limit);
    }
    /**
     * @deprecated This class is deprecated and will be removed soon. Please use fromBech32() and toBech32() instead. For more details please refer to https://github.com/cosmos/cosmjs/issues/1053.
     */
    static decode(address, limit = Infinity) {
        return fromBech32(address, limit);
    }
}
exports.Bech32 = Bech32;
//# sourceMappingURL=bech32.js.map

/***/ }),

/***/ 47480:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.fromHex = exports.toHex = void 0;
function toHex(data) {
    let out = "";
    for (const byte of data) {
        out += ("0" + byte.toString(16)).slice(-2);
    }
    return out;
}
exports.toHex = toHex;
function fromHex(hexstring) {
    if (hexstring.length % 2 !== 0) {
        throw new Error("hex string length must be a multiple of 2");
    }
    const out = new Uint8Array(hexstring.length / 2);
    for (let i = 0; i < out.length; i++) {
        const j = 2 * i;
        const hexByteAsString = hexstring.slice(j, j + 2);
        if (!hexByteAsString.match(/[0-9a-f]{2}/i)) {
            throw new Error("hex string contains invalid characters");
        }
        out[i] = parseInt(hexByteAsString, 16);
    }
    return out;
}
exports.fromHex = fromHex;
//# sourceMappingURL=hex.js.map

/***/ }),

/***/ 92540:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.toUtf8 = exports.fromUtf8 = exports.toRfc3339 = exports.fromRfc3339 = exports.toHex = exports.fromHex = exports.toBech32 = exports.normalizeBech32 = exports.fromBech32 = exports.Bech32 = exports.toBase64 = exports.fromBase64 = exports.toAscii = exports.fromAscii = void 0;
var ascii_1 = __webpack_require__(5319);
Object.defineProperty(exports, "fromAscii", ({ enumerable: true, get: function () { return ascii_1.fromAscii; } }));
Object.defineProperty(exports, "toAscii", ({ enumerable: true, get: function () { return ascii_1.toAscii; } }));
var base64_1 = __webpack_require__(45316);
Object.defineProperty(exports, "fromBase64", ({ enumerable: true, get: function () { return base64_1.fromBase64; } }));
Object.defineProperty(exports, "toBase64", ({ enumerable: true, get: function () { return base64_1.toBase64; } }));
var bech32_1 = __webpack_require__(74545);
Object.defineProperty(exports, "Bech32", ({ enumerable: true, get: function () { return bech32_1.Bech32; } }));
Object.defineProperty(exports, "fromBech32", ({ enumerable: true, get: function () { return bech32_1.fromBech32; } }));
Object.defineProperty(exports, "normalizeBech32", ({ enumerable: true, get: function () { return bech32_1.normalizeBech32; } }));
Object.defineProperty(exports, "toBech32", ({ enumerable: true, get: function () { return bech32_1.toBech32; } }));
var hex_1 = __webpack_require__(47480);
Object.defineProperty(exports, "fromHex", ({ enumerable: true, get: function () { return hex_1.fromHex; } }));
Object.defineProperty(exports, "toHex", ({ enumerable: true, get: function () { return hex_1.toHex; } }));
var rfc3339_1 = __webpack_require__(44604);
Object.defineProperty(exports, "fromRfc3339", ({ enumerable: true, get: function () { return rfc3339_1.fromRfc3339; } }));
Object.defineProperty(exports, "toRfc3339", ({ enumerable: true, get: function () { return rfc3339_1.toRfc3339; } }));
var utf8_1 = __webpack_require__(26834);
Object.defineProperty(exports, "fromUtf8", ({ enumerable: true, get: function () { return utf8_1.fromUtf8; } }));
Object.defineProperty(exports, "toUtf8", ({ enumerable: true, get: function () { return utf8_1.toUtf8; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 44604:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.toRfc3339 = exports.fromRfc3339 = void 0;
const rfc3339Matcher = /^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2}):(\d{2})(\.\d{1,9})?((?:[+-]\d{2}:\d{2})|Z)$/;
function padded(integer, length = 2) {
    return integer.toString().padStart(length, "0");
}
function fromRfc3339(str) {
    const matches = rfc3339Matcher.exec(str);
    if (!matches) {
        throw new Error("Date string is not in RFC3339 format");
    }
    const year = +matches[1];
    const month = +matches[2];
    const day = +matches[3];
    const hour = +matches[4];
    const minute = +matches[5];
    const second = +matches[6];
    // fractional seconds match either undefined or a string like ".1", ".123456789"
    const milliSeconds = matches[7] ? Math.floor(+matches[7] * 1000) : 0;
    let tzOffsetSign;
    let tzOffsetHours;
    let tzOffsetMinutes;
    // if timezone is undefined, it must be Z or nothing (otherwise the group would have captured).
    if (matches[8] === "Z") {
        tzOffsetSign = 1;
        tzOffsetHours = 0;
        tzOffsetMinutes = 0;
    }
    else {
        tzOffsetSign = matches[8].substring(0, 1) === "-" ? -1 : 1;
        tzOffsetHours = +matches[8].substring(1, 3);
        tzOffsetMinutes = +matches[8].substring(4, 6);
    }
    const tzOffset = tzOffsetSign * (tzOffsetHours * 60 + tzOffsetMinutes) * 60; // seconds
    const timestamp = Date.UTC(year, month - 1, day, hour, minute, second, milliSeconds) - tzOffset * 1000;
    return new Date(timestamp);
}
exports.fromRfc3339 = fromRfc3339;
function toRfc3339(date) {
    const year = date.getUTCFullYear();
    const month = padded(date.getUTCMonth() + 1);
    const day = padded(date.getUTCDate());
    const hour = padded(date.getUTCHours());
    const minute = padded(date.getUTCMinutes());
    const second = padded(date.getUTCSeconds());
    const ms = padded(date.getUTCMilliseconds(), 3);
    return `${year}-${month}-${day}T${hour}:${minute}:${second}.${ms}Z`;
}
exports.toRfc3339 = toRfc3339;
//# sourceMappingURL=rfc3339.js.map

/***/ }),

/***/ 26834:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.fromUtf8 = exports.toUtf8 = void 0;
function toUtf8(str) {
    return new TextEncoder().encode(str);
}
exports.toUtf8 = toUtf8;
/**
 * Takes UTF-8 data and decodes it to a string.
 *
 * In lossy mode, the replacement character � is used to substitude invalid
 * encodings. By default lossy mode is off and invalid data will lead to exceptions.
 */
function fromUtf8(data, lossy = false) {
    const fatal = !lossy;
    return new TextDecoder("utf-8", { fatal }).decode(data);
}
exports.fromUtf8 = fromUtf8;
//# sourceMappingURL=utf8.js.map

/***/ }),

/***/ 85541:
/***/ (function(module) {

"use strict";

var ALPHABET = 'qpzry9x8gf2tvdw0s3jn54khce6mua7l'

// pre-compute lookup table
var ALPHABET_MAP = {}
for (var z = 0; z < ALPHABET.length; z++) {
  var x = ALPHABET.charAt(z)

  if (ALPHABET_MAP[x] !== undefined) throw new TypeError(x + ' is ambiguous')
  ALPHABET_MAP[x] = z
}

function polymodStep (pre) {
  var b = pre >> 25
  return ((pre & 0x1FFFFFF) << 5) ^
    (-((b >> 0) & 1) & 0x3b6a57b2) ^
    (-((b >> 1) & 1) & 0x26508e6d) ^
    (-((b >> 2) & 1) & 0x1ea119fa) ^
    (-((b >> 3) & 1) & 0x3d4233dd) ^
    (-((b >> 4) & 1) & 0x2a1462b3)
}

function prefixChk (prefix) {
  var chk = 1
  for (var i = 0; i < prefix.length; ++i) {
    var c = prefix.charCodeAt(i)
    if (c < 33 || c > 126) return 'Invalid prefix (' + prefix + ')'

    chk = polymodStep(chk) ^ (c >> 5)
  }
  chk = polymodStep(chk)

  for (i = 0; i < prefix.length; ++i) {
    var v = prefix.charCodeAt(i)
    chk = polymodStep(chk) ^ (v & 0x1f)
  }
  return chk
}

function encode (prefix, words, LIMIT) {
  LIMIT = LIMIT || 90
  if ((prefix.length + 7 + words.length) > LIMIT) throw new TypeError('Exceeds length limit')

  prefix = prefix.toLowerCase()

  // determine chk mod
  var chk = prefixChk(prefix)
  if (typeof chk === 'string') throw new Error(chk)

  var result = prefix + '1'
  for (var i = 0; i < words.length; ++i) {
    var x = words[i]
    if ((x >> 5) !== 0) throw new Error('Non 5-bit word')

    chk = polymodStep(chk) ^ x
    result += ALPHABET.charAt(x)
  }

  for (i = 0; i < 6; ++i) {
    chk = polymodStep(chk)
  }
  chk ^= 1

  for (i = 0; i < 6; ++i) {
    var v = (chk >> ((5 - i) * 5)) & 0x1f
    result += ALPHABET.charAt(v)
  }

  return result
}

function __decode (str, LIMIT) {
  LIMIT = LIMIT || 90
  if (str.length < 8) return str + ' too short'
  if (str.length > LIMIT) return 'Exceeds length limit'

  // don't allow mixed case
  var lowered = str.toLowerCase()
  var uppered = str.toUpperCase()
  if (str !== lowered && str !== uppered) return 'Mixed-case string ' + str
  str = lowered

  var split = str.lastIndexOf('1')
  if (split === -1) return 'No separator character for ' + str
  if (split === 0) return 'Missing prefix for ' + str

  var prefix = str.slice(0, split)
  var wordChars = str.slice(split + 1)
  if (wordChars.length < 6) return 'Data too short'

  var chk = prefixChk(prefix)
  if (typeof chk === 'string') return chk

  var words = []
  for (var i = 0; i < wordChars.length; ++i) {
    var c = wordChars.charAt(i)
    var v = ALPHABET_MAP[c]
    if (v === undefined) return 'Unknown character ' + c
    chk = polymodStep(chk) ^ v

    // not in the checksum?
    if (i + 6 >= wordChars.length) continue
    words.push(v)
  }

  if (chk !== 1) return 'Invalid checksum for ' + str
  return { prefix: prefix, words: words }
}

function decodeUnsafe () {
  var res = __decode.apply(null, arguments)
  if (typeof res === 'object') return res
}

function decode (str) {
  var res = __decode.apply(null, arguments)
  if (typeof res === 'object') return res

  throw new Error(res)
}

function convert (data, inBits, outBits, pad) {
  var value = 0
  var bits = 0
  var maxV = (1 << outBits) - 1

  var result = []
  for (var i = 0; i < data.length; ++i) {
    value = (value << inBits) | data[i]
    bits += inBits

    while (bits >= outBits) {
      bits -= outBits
      result.push((value >> bits) & maxV)
    }
  }

  if (pad) {
    if (bits > 0) {
      result.push((value << (outBits - bits)) & maxV)
    }
  } else {
    if (bits >= inBits) return 'Excess padding'
    if ((value << (outBits - bits)) & maxV) return 'Non-zero padding'
  }

  return result
}

function toWordsUnsafe (bytes) {
  var res = convert(bytes, 8, 5, true)
  if (Array.isArray(res)) return res
}

function toWords (bytes) {
  var res = convert(bytes, 8, 5, true)
  if (Array.isArray(res)) return res

  throw new Error(res)
}

function fromWordsUnsafe (words) {
  var res = convert(words, 5, 8, false)
  if (Array.isArray(res)) return res
}

function fromWords (words) {
  var res = convert(words, 5, 8, false)
  if (Array.isArray(res)) return res

  throw new Error(res)
}

module.exports = {
  decodeUnsafe: decodeUnsafe,
  decode: decode,
  encode: encode,
  toWordsUnsafe: toWordsUnsafe,
  toWords: toWords,
  fromWordsUnsafe: fromWordsUnsafe,
  fromWords: fromWords
}


/***/ }),

/***/ 38828:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Decimal = void 0;
const bn_js_1 = __importDefault(__webpack_require__(13550));
// Too large values lead to massive memory usage. Limit to something sensible.
// The largest value we need is 18 (Ether).
const maxFractionalDigits = 100;
/**
 * A type for arbitrary precision, non-negative decimals.
 *
 * Instances of this class are immutable.
 */
class Decimal {
    constructor(atomics, fractionalDigits) {
        if (!atomics.match(/^[0-9]+$/)) {
            throw new Error("Invalid string format. Only non-negative integers in decimal representation supported.");
        }
        this.data = {
            atomics: new bn_js_1.default(atomics),
            fractionalDigits: fractionalDigits,
        };
    }
    static fromUserInput(input, fractionalDigits) {
        Decimal.verifyFractionalDigits(fractionalDigits);
        const badCharacter = input.match(/[^0-9.]/);
        if (badCharacter) {
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            throw new Error(`Invalid character at position ${badCharacter.index + 1}`);
        }
        let whole;
        let fractional;
        if (input === "") {
            whole = "0";
            fractional = "";
        }
        else if (input.search(/\./) === -1) {
            // integer format, no separator
            whole = input;
            fractional = "";
        }
        else {
            const parts = input.split(".");
            switch (parts.length) {
                case 0:
                case 1:
                    throw new Error("Fewer than two elements in split result. This must not happen here.");
                case 2:
                    if (!parts[1])
                        throw new Error("Fractional part missing");
                    whole = parts[0];
                    fractional = parts[1].replace(/0+$/, "");
                    break;
                default:
                    throw new Error("More than one separator found");
            }
        }
        if (fractional.length > fractionalDigits) {
            throw new Error("Got more fractional digits than supported");
        }
        const quantity = `${whole}${fractional.padEnd(fractionalDigits, "0")}`;
        return new Decimal(quantity, fractionalDigits);
    }
    static fromAtomics(atomics, fractionalDigits) {
        Decimal.verifyFractionalDigits(fractionalDigits);
        return new Decimal(atomics, fractionalDigits);
    }
    /**
     * Creates a Decimal with value 0.0 and the given number of fractial digits.
     *
     * Fractional digits are not relevant for the value but needed to be able
     * to perform arithmetic operations with other decimals.
     */
    static zero(fractionalDigits) {
        Decimal.verifyFractionalDigits(fractionalDigits);
        return new Decimal("0", fractionalDigits);
    }
    /**
     * Creates a Decimal with value 1.0 and the given number of fractial digits.
     *
     * Fractional digits are not relevant for the value but needed to be able
     * to perform arithmetic operations with other decimals.
     */
    static one(fractionalDigits) {
        Decimal.verifyFractionalDigits(fractionalDigits);
        return new Decimal("1" + "0".repeat(fractionalDigits), fractionalDigits);
    }
    static verifyFractionalDigits(fractionalDigits) {
        if (!Number.isInteger(fractionalDigits))
            throw new Error("Fractional digits is not an integer");
        if (fractionalDigits < 0)
            throw new Error("Fractional digits must not be negative");
        if (fractionalDigits > maxFractionalDigits) {
            throw new Error(`Fractional digits must not exceed ${maxFractionalDigits}`);
        }
    }
    static compare(a, b) {
        if (a.fractionalDigits !== b.fractionalDigits)
            throw new Error("Fractional digits do not match");
        return a.data.atomics.cmp(new bn_js_1.default(b.atomics));
    }
    get atomics() {
        return this.data.atomics.toString();
    }
    get fractionalDigits() {
        return this.data.fractionalDigits;
    }
    /** Creates a new instance with the same value */
    clone() {
        return new Decimal(this.atomics, this.fractionalDigits);
    }
    /** Returns the greatest decimal <= this which has no fractional part (rounding down) */
    floor() {
        const factor = new bn_js_1.default(10).pow(new bn_js_1.default(this.data.fractionalDigits));
        const whole = this.data.atomics.div(factor);
        const fractional = this.data.atomics.mod(factor);
        if (fractional.isZero()) {
            return this.clone();
        }
        else {
            return Decimal.fromAtomics(whole.mul(factor).toString(), this.fractionalDigits);
        }
    }
    /** Returns the smallest decimal >= this which has no fractional part (rounding up) */
    ceil() {
        const factor = new bn_js_1.default(10).pow(new bn_js_1.default(this.data.fractionalDigits));
        const whole = this.data.atomics.div(factor);
        const fractional = this.data.atomics.mod(factor);
        if (fractional.isZero()) {
            return this.clone();
        }
        else {
            return Decimal.fromAtomics(whole.addn(1).mul(factor).toString(), this.fractionalDigits);
        }
    }
    toString() {
        const factor = new bn_js_1.default(10).pow(new bn_js_1.default(this.data.fractionalDigits));
        const whole = this.data.atomics.div(factor);
        const fractional = this.data.atomics.mod(factor);
        if (fractional.isZero()) {
            return whole.toString();
        }
        else {
            const fullFractionalPart = fractional.toString().padStart(this.data.fractionalDigits, "0");
            const trimmedFractionalPart = fullFractionalPart.replace(/0+$/, "");
            return `${whole.toString()}.${trimmedFractionalPart}`;
        }
    }
    /**
     * Returns an approximation as a float type. Only use this if no
     * exact calculation is required.
     */
    toFloatApproximation() {
        const out = Number(this.toString());
        if (Number.isNaN(out))
            throw new Error("Conversion to number failed");
        return out;
    }
    /**
     * a.plus(b) returns a+b.
     *
     * Both values need to have the same fractional digits.
     */
    plus(b) {
        if (this.fractionalDigits !== b.fractionalDigits)
            throw new Error("Fractional digits do not match");
        const sum = this.data.atomics.add(new bn_js_1.default(b.atomics));
        return new Decimal(sum.toString(), this.fractionalDigits);
    }
    /**
     * a.minus(b) returns a-b.
     *
     * Both values need to have the same fractional digits.
     * The resulting difference needs to be non-negative.
     */
    minus(b) {
        if (this.fractionalDigits !== b.fractionalDigits)
            throw new Error("Fractional digits do not match");
        const difference = this.data.atomics.sub(new bn_js_1.default(b.atomics));
        if (difference.ltn(0))
            throw new Error("Difference must not be negative");
        return new Decimal(difference.toString(), this.fractionalDigits);
    }
    /**
     * a.multiply(b) returns a*b.
     *
     * We only allow multiplication by unsigned integers to avoid rounding errors.
     */
    multiply(b) {
        const product = this.data.atomics.mul(new bn_js_1.default(b.toString()));
        return new Decimal(product.toString(), this.fractionalDigits);
    }
    equals(b) {
        return Decimal.compare(this, b) === 0;
    }
    isLessThan(b) {
        return Decimal.compare(this, b) < 0;
    }
    isLessThanOrEqual(b) {
        return Decimal.compare(this, b) <= 0;
    }
    isGreaterThan(b) {
        return Decimal.compare(this, b) > 0;
    }
    isGreaterThanOrEqual(b) {
        return Decimal.compare(this, b) >= 0;
    }
}
exports.Decimal = Decimal;
//# sourceMappingURL=decimal.js.map

/***/ }),

/***/ 62949:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Uint64 = exports.Uint53 = exports.Uint32 = exports.Int53 = exports.Decimal = void 0;
var decimal_1 = __webpack_require__(38828);
Object.defineProperty(exports, "Decimal", ({ enumerable: true, get: function () { return decimal_1.Decimal; } }));
var integers_1 = __webpack_require__(40172);
Object.defineProperty(exports, "Int53", ({ enumerable: true, get: function () { return integers_1.Int53; } }));
Object.defineProperty(exports, "Uint32", ({ enumerable: true, get: function () { return integers_1.Uint32; } }));
Object.defineProperty(exports, "Uint53", ({ enumerable: true, get: function () { return integers_1.Uint53; } }));
Object.defineProperty(exports, "Uint64", ({ enumerable: true, get: function () { return integers_1.Uint64; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 40172:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Uint64 = exports.Uint53 = exports.Int53 = exports.Uint32 = void 0;
/* eslint-disable no-bitwise */
const bn_js_1 = __importDefault(__webpack_require__(13550));
const uint64MaxValue = new bn_js_1.default("18446744073709551615", 10, "be");
class Uint32 {
    constructor(input) {
        if (Number.isNaN(input)) {
            throw new Error("Input is not a number");
        }
        if (!Number.isInteger(input)) {
            throw new Error("Input is not an integer");
        }
        if (input < 0 || input > 4294967295) {
            throw new Error("Input not in uint32 range: " + input.toString());
        }
        this.data = input;
    }
    /** @deprecated use Uint32.fromBytes */
    static fromBigEndianBytes(bytes) {
        return Uint32.fromBytes(bytes);
    }
    /**
     * Creates a Uint32 from a fixed length byte array.
     *
     * @param bytes a list of exactly 4 bytes
     * @param endianess defaults to big endian
     */
    static fromBytes(bytes, endianess = "be") {
        if (bytes.length !== 4) {
            throw new Error("Invalid input length. Expected 4 bytes.");
        }
        for (let i = 0; i < bytes.length; ++i) {
            if (!Number.isInteger(bytes[i]) || bytes[i] > 255 || bytes[i] < 0) {
                throw new Error("Invalid value in byte. Found: " + bytes[i]);
            }
        }
        const beBytes = endianess === "be" ? bytes : Array.from(bytes).reverse();
        // Use mulitiplication instead of shifting since bitwise operators are defined
        // on SIGNED int32 in JavaScript and we don't want to risk surprises
        return new Uint32(beBytes[0] * 2 ** 24 + beBytes[1] * 2 ** 16 + beBytes[2] * 2 ** 8 + beBytes[3]);
    }
    static fromString(str) {
        if (!str.match(/^[0-9]+$/)) {
            throw new Error("Invalid string format");
        }
        return new Uint32(Number.parseInt(str, 10));
    }
    toBytesBigEndian() {
        // Use division instead of shifting since bitwise operators are defined
        // on SIGNED int32 in JavaScript and we don't want to risk surprises
        return new Uint8Array([
            Math.floor(this.data / 2 ** 24) & 0xff,
            Math.floor(this.data / 2 ** 16) & 0xff,
            Math.floor(this.data / 2 ** 8) & 0xff,
            Math.floor(this.data / 2 ** 0) & 0xff,
        ]);
    }
    toBytesLittleEndian() {
        // Use division instead of shifting since bitwise operators are defined
        // on SIGNED int32 in JavaScript and we don't want to risk surprises
        return new Uint8Array([
            Math.floor(this.data / 2 ** 0) & 0xff,
            Math.floor(this.data / 2 ** 8) & 0xff,
            Math.floor(this.data / 2 ** 16) & 0xff,
            Math.floor(this.data / 2 ** 24) & 0xff,
        ]);
    }
    toNumber() {
        return this.data;
    }
    toBigInt() {
        return BigInt(this.toNumber());
    }
    toString() {
        return this.data.toString();
    }
}
exports.Uint32 = Uint32;
class Int53 {
    constructor(input) {
        if (Number.isNaN(input)) {
            throw new Error("Input is not a number");
        }
        if (!Number.isInteger(input)) {
            throw new Error("Input is not an integer");
        }
        if (input < Number.MIN_SAFE_INTEGER || input > Number.MAX_SAFE_INTEGER) {
            throw new Error("Input not in int53 range: " + input.toString());
        }
        this.data = input;
    }
    static fromString(str) {
        if (!str.match(/^-?[0-9]+$/)) {
            throw new Error("Invalid string format");
        }
        return new Int53(Number.parseInt(str, 10));
    }
    toNumber() {
        return this.data;
    }
    toBigInt() {
        return BigInt(this.toNumber());
    }
    toString() {
        return this.data.toString();
    }
}
exports.Int53 = Int53;
class Uint53 {
    constructor(input) {
        const signed = new Int53(input);
        if (signed.toNumber() < 0) {
            throw new Error("Input is negative");
        }
        this.data = signed;
    }
    static fromString(str) {
        const signed = Int53.fromString(str);
        return new Uint53(signed.toNumber());
    }
    toNumber() {
        return this.data.toNumber();
    }
    toBigInt() {
        return BigInt(this.toNumber());
    }
    toString() {
        return this.data.toString();
    }
}
exports.Uint53 = Uint53;
class Uint64 {
    constructor(data) {
        if (data.isNeg()) {
            throw new Error("Input is negative");
        }
        if (data.gt(uint64MaxValue)) {
            throw new Error("Input exceeds uint64 range");
        }
        this.data = data;
    }
    /** @deprecated use Uint64.fromBytes */
    static fromBytesBigEndian(bytes) {
        return Uint64.fromBytes(bytes);
    }
    /**
     * Creates a Uint64 from a fixed length byte array.
     *
     * @param bytes a list of exactly 8 bytes
     * @param endianess defaults to big endian
     */
    static fromBytes(bytes, endianess = "be") {
        if (bytes.length !== 8) {
            throw new Error("Invalid input length. Expected 8 bytes.");
        }
        for (let i = 0; i < bytes.length; ++i) {
            if (!Number.isInteger(bytes[i]) || bytes[i] > 255 || bytes[i] < 0) {
                throw new Error("Invalid value in byte. Found: " + bytes[i]);
            }
        }
        const beBytes = endianess === "be" ? Array.from(bytes) : Array.from(bytes).reverse();
        return new Uint64(new bn_js_1.default(beBytes));
    }
    static fromString(str) {
        if (!str.match(/^[0-9]+$/)) {
            throw new Error("Invalid string format");
        }
        return new Uint64(new bn_js_1.default(str, 10, "be"));
    }
    static fromNumber(input) {
        if (Number.isNaN(input)) {
            throw new Error("Input is not a number");
        }
        if (!Number.isInteger(input)) {
            throw new Error("Input is not an integer");
        }
        let bigint;
        try {
            bigint = new bn_js_1.default(input);
        }
        catch (_a) {
            throw new Error("Input is not a safe integer");
        }
        return new Uint64(bigint);
    }
    toBytesBigEndian() {
        return Uint8Array.from(this.data.toArray("be", 8));
    }
    toBytesLittleEndian() {
        return Uint8Array.from(this.data.toArray("le", 8));
    }
    toString() {
        return this.data.toString(10);
    }
    toBigInt() {
        return BigInt(this.toString());
    }
    toNumber() {
        return this.data.toNumber();
    }
}
exports.Uint64 = Uint64;
// Assign classes to unused variables in order to verify static interface conformance at compile time.
// Workaround for https://github.com/microsoft/TypeScript/issues/33892
const _int53Class = (/* unused pure expression or super */ null && (Int53));
const _uint53Class = (/* unused pure expression or super */ null && (Uint53));
const _uint32Class = (/* unused pure expression or super */ null && (Uint32));
const _uint64Class = (/* unused pure expression or super */ null && (Uint64));
//# sourceMappingURL=integers.js.map

/***/ }),

/***/ 2118:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.concat = void 0;
const xstream_1 = __webpack_require__(43813);
/**
 * An implementation of concat that buffers all source stream events
 *
 * Marble diagram:
 *
 * ```text
 * --1--2---3---4-|
 * -a--b-c--d-|
 * --------X---------Y---------Z-
 *           concat
 * --1--2---3---4-abcdXY-------Z-
 * ```
 *
 * This is inspired by RxJS's concat as documented at http://rxmarbles.com/#concat and behaves
 * differently than xstream's concat as discussed in https://github.com/staltz/xstream/issues/170.
 *
 */
function concat(...streams) {
    const subscriptions = new Array();
    const queues = new Array(); // one queue per stream
    const completedStreams = new Set();
    let activeStreamIndex = 0;
    function reset() {
        while (subscriptions.length > 0) {
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const subscription = subscriptions.shift();
            subscription.unsubscribe();
        }
        queues.length = 0;
        completedStreams.clear();
        activeStreamIndex = 0;
    }
    const producer = {
        start: (listener) => {
            streams.forEach((_) => queues.push([]));
            function emitAllQueuesEvents(streamIndex) {
                // eslint-disable-next-line no-constant-condition
                while (true) {
                    const element = queues[streamIndex].shift();
                    if (element === undefined) {
                        return;
                    }
                    listener.next(element);
                }
            }
            function isDone() {
                return activeStreamIndex >= streams.length;
            }
            if (isDone()) {
                listener.complete();
                return;
            }
            streams.forEach((stream, index) => {
                subscriptions.push(stream.subscribe({
                    next: (value) => {
                        if (index === activeStreamIndex) {
                            listener.next(value);
                        }
                        else {
                            queues[index].push(value);
                        }
                    },
                    complete: () => {
                        completedStreams.add(index);
                        while (completedStreams.has(activeStreamIndex)) {
                            // this stream completed: emit all and move on
                            emitAllQueuesEvents(activeStreamIndex);
                            activeStreamIndex++;
                        }
                        if (isDone()) {
                            listener.complete();
                        }
                        else {
                            // now active stream can have some events queued but did not yet complete
                            emitAllQueuesEvents(activeStreamIndex);
                        }
                    },
                    error: (error) => {
                        listener.error(error);
                        reset();
                    },
                }));
            });
        },
        stop: () => {
            reset();
        },
    };
    return xstream_1.Stream.create(producer);
}
exports.concat = concat;
//# sourceMappingURL=concat.js.map

/***/ }),

/***/ 57606:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.DefaultValueProducer = void 0;
// allows pre-producing values before anyone is listening
class DefaultValueProducer {
    constructor(value, callbacks) {
        this.callbacks = callbacks;
        this.internalValue = value;
    }
    get value() {
        return this.internalValue;
    }
    /**
     * Update the current value.
     *
     * If producer is active (i.e. someone is listening), this emits an event.
     * If not, just the current value is updated.
     */
    update(value) {
        this.internalValue = value;
        if (this.listener) {
            this.listener.next(value);
        }
    }
    /**
     * Produce an error
     */
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    error(error) {
        if (this.listener) {
            this.listener.error(error);
        }
    }
    /**
     * Called by the stream. Do not call this directly.
     */
    start(listener) {
        this.listener = listener;
        listener.next(this.internalValue);
        if (this.callbacks) {
            this.callbacks.onStarted();
        }
    }
    /**
     * Called by the stream. Do not call this directly.
     */
    stop() {
        if (this.callbacks) {
            this.callbacks.onStop();
        }
        this.listener = undefined;
    }
}
exports.DefaultValueProducer = DefaultValueProducer;
//# sourceMappingURL=defaultvalueproducer.js.map

/***/ }),

/***/ 62889:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.dropDuplicates = void 0;
/**
 * Drops duplicate values in a stream.
 *
 * Marble diagram:
 *
 * ```text
 * -1-1-1-2-4-3-3-4--
 *   dropDuplicates
 * -1-----2-4-3------
 * ```
 *
 * Each value must be uniquely identified by a string given by
 * valueToKey(value).
 *
 * Internally this maintains a set of keys that have been processed already,
 * i.e. memory consumption and Set lookup times should be considered when
 * using this function.
 */
function dropDuplicates(valueToKey) {
    const operand = (instream) => {
        const emittedKeys = new Set();
        const deduplicatedStream = instream
            .filter((value) => !emittedKeys.has(valueToKey(value)))
            .debug((value) => emittedKeys.add(valueToKey(value)));
        return deduplicatedStream;
    };
    return operand;
}
exports.dropDuplicates = dropDuplicates;
//# sourceMappingURL=dropduplicates.js.map

/***/ }),

/***/ 81459:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ValueAndUpdates = exports.toListPromise = exports.fromListPromise = exports.firstEvent = exports.dropDuplicates = exports.DefaultValueProducer = exports.concat = void 0;
var concat_1 = __webpack_require__(2118);
Object.defineProperty(exports, "concat", ({ enumerable: true, get: function () { return concat_1.concat; } }));
var defaultvalueproducer_1 = __webpack_require__(57606);
Object.defineProperty(exports, "DefaultValueProducer", ({ enumerable: true, get: function () { return defaultvalueproducer_1.DefaultValueProducer; } }));
var dropduplicates_1 = __webpack_require__(62889);
Object.defineProperty(exports, "dropDuplicates", ({ enumerable: true, get: function () { return dropduplicates_1.dropDuplicates; } }));
var promise_1 = __webpack_require__(43511);
Object.defineProperty(exports, "firstEvent", ({ enumerable: true, get: function () { return promise_1.firstEvent; } }));
Object.defineProperty(exports, "fromListPromise", ({ enumerable: true, get: function () { return promise_1.fromListPromise; } }));
Object.defineProperty(exports, "toListPromise", ({ enumerable: true, get: function () { return promise_1.toListPromise; } }));
__exportStar(__webpack_require__(80165), exports);
var valueandupdates_1 = __webpack_require__(53633);
Object.defineProperty(exports, "ValueAndUpdates", ({ enumerable: true, get: function () { return valueandupdates_1.ValueAndUpdates; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 43511:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.firstEvent = exports.toListPromise = exports.fromListPromise = void 0;
const xstream_1 = __webpack_require__(43813);
/**
 * Emits one event for each list element as soon as the promise resolves
 */
function fromListPromise(promise) {
    const producer = {
        start: (listener) => {
            // the code in `start` runs as soon as anyone listens to the stream
            promise
                .then((iterable) => {
                for (const element of iterable) {
                    listener.next(element);
                }
                listener.complete();
            })
                .catch((error) => listener.error(error));
        },
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        stop: () => { },
    };
    return xstream_1.Stream.create(producer);
}
exports.fromListPromise = fromListPromise;
/**
 * Listens to stream and collects events. When `count` events are collected,
 * the promise resolves with an array of events.
 *
 * Rejects if stream completes before `count` events are collected.
 */
async function toListPromise(stream, count) {
    return new Promise((resolve, reject) => {
        if (count === 0) {
            resolve([]);
            return;
        }
        const events = new Array();
        // take() unsubscribes from source stream automatically
        stream.take(count).subscribe({
            next: (event) => {
                events.push(event);
                if (events.length === count) {
                    resolve(events);
                }
            },
            complete: () => {
                reject(`Stream completed before all events could be collected. ` +
                    `Collected ${events.length}, expected ${count}`);
            },
            error: (error) => reject(error),
        });
    });
}
exports.toListPromise = toListPromise;
/**
 * Listens to stream, collects one event and revolves.
 *
 * Rejects if stream completes before one event was fired.
 */
async function firstEvent(stream) {
    return (await toListPromise(stream, 1))[0];
}
exports.firstEvent = firstEvent;
//# sourceMappingURL=promise.js.map

/***/ }),

/***/ 80165:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.lastValue = exports.asArray = exports.countStream = exports.Reducer = void 0;
// Reducer takes a stream of events T and a ReducerFunc, that
// materializes a state of type U.
class Reducer {
    constructor(stream, reducer, initState) {
        this.stream = stream;
        this.reducer = reducer;
        this.state = initState;
        this.completed = new Promise((resolve, reject) => {
            const subscription = this.stream.subscribe({
                next: (evt) => {
                    this.state = this.reducer(this.state, evt);
                },
                complete: () => {
                    resolve();
                    // this must happen after resolve, to ensure stream.subscribe() has finished
                    subscription.unsubscribe();
                },
                error: (err) => {
                    reject(err);
                    // the stream already closed on error, but unsubscribe to be safe
                    subscription.unsubscribe();
                },
            });
        });
    }
    // value returns current materialized state
    value() {
        return this.state;
    }
    // finished resolves on completed stream, rejects on stream error
    async finished() {
        return this.completed;
    }
}
exports.Reducer = Reducer;
function increment(sum, _) {
    return sum + 1;
}
// countStream returns a reducer that contains current count
// of events on the stream
function countStream(stream) {
    return new Reducer(stream, increment, 0);
}
exports.countStream = countStream;
function append(list, evt) {
    return [...list, evt];
}
// asArray maintains an array containing all events that have
// occurred on the stream
function asArray(stream) {
    return new Reducer(stream, append, []);
}
exports.asArray = asArray;
function last(_, event) {
    return event;
}
// lastValue returns the last value read from the stream, or undefined if no values sent
function lastValue(stream) {
    return new Reducer(stream, last, undefined);
}
exports.lastValue = lastValue;
//# sourceMappingURL=reducer.js.map

/***/ }),

/***/ 53633:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ValueAndUpdates = void 0;
const xstream_1 = __webpack_require__(43813);
/**
 * A read only wrapper around DefaultValueProducer that allows
 * to synchronously get the current value using the .value property
 * and listen to to updates by suscribing to the .updates stream
 */
class ValueAndUpdates {
    constructor(producer) {
        this.producer = producer;
        this.updates = xstream_1.MemoryStream.createWithMemory(this.producer);
    }
    get value() {
        return this.producer.value;
    }
    /**
     * Resolves as soon as search value is found.
     *
     * @param search either a value or a function that must return true when found
     * @returns the value of the update that caused the search match
     */
    async waitFor(search) {
        const searchImplementation = typeof search === "function" ? search : (value) => value === search;
        return new Promise((resolve, reject) => {
            const subscription = this.updates.subscribe({
                next: (newValue) => {
                    if (searchImplementation(newValue)) {
                        resolve(newValue);
                        // MemoryStream.subscribe() calls next with the last value.
                        // Make async to ensure the subscription exists
                        setTimeout(() => subscription.unsubscribe(), 0);
                    }
                },
                complete: () => {
                    subscription.unsubscribe();
                    reject("Update stream completed without expected value");
                },
                error: (error) => {
                    reject(error);
                },
            });
        });
    }
}
exports.ValueAndUpdates = ValueAndUpdates;
//# sourceMappingURL=valueandupdates.js.map

/***/ }),

/***/ 91057:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.arrayContentStartsWith = exports.arrayContentEquals = void 0;
/**
 * Compares the content of two arrays-like objects for equality.
 *
 * Equality is defined as having equal length and element values, where element equality means `===` returning `true`.
 *
 * This allows you to compare the content of a Buffer, Uint8Array or number[], ignoring the specific type.
 * As a consequence, this returns different results than Jasmine's `toEqual`, which ensures elements have the same type.
 */
function arrayContentEquals(a, b) {
    if (a.length !== b.length)
        return false;
    for (let i = 0; i < a.length; ++i) {
        if (a[i] !== b[i])
            return false;
    }
    return true;
}
exports.arrayContentEquals = arrayContentEquals;
/**
 * Checks if `a` starts with the contents of `b`.
 *
 * This requires equality of the element values, where element equality means `===` returning `true`.
 *
 * This allows you to compare the content of a Buffer, Uint8Array or number[], ignoring the specific type.
 * As a consequence, this returns different results than Jasmine's `toEqual`, which ensures elements have the same type.
 */
function arrayContentStartsWith(a, b) {
    if (a.length < b.length)
        return false;
    for (let i = 0; i < b.length; ++i) {
        if (a[i] !== b[i])
            return false;
    }
    return true;
}
exports.arrayContentStartsWith = arrayContentStartsWith;
//# sourceMappingURL=arrays.js.map

/***/ }),

/***/ 34427:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.assertDefinedAndNotNull = exports.assertDefined = exports.assert = void 0;
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function assert(condition, msg) {
    if (!condition) {
        throw new Error(msg || "condition is not truthy");
    }
}
exports.assert = assert;
function assertDefined(value, msg) {
    if (value === undefined) {
        throw new Error(msg !== null && msg !== void 0 ? msg : "value is undefined");
    }
}
exports.assertDefined = assertDefined;
function assertDefinedAndNotNull(value, msg) {
    if (value === undefined || value === null) {
        throw new Error(msg !== null && msg !== void 0 ? msg : "value is undefined or null");
    }
}
exports.assertDefinedAndNotNull = assertDefinedAndNotNull;
//# sourceMappingURL=assert.js.map

/***/ }),

/***/ 85553:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.isUint8Array = exports.isNonNullObject = exports.isDefined = exports.sleep = exports.assertDefinedAndNotNull = exports.assertDefined = exports.assert = exports.arrayContentStartsWith = exports.arrayContentEquals = void 0;
var arrays_1 = __webpack_require__(91057);
Object.defineProperty(exports, "arrayContentEquals", ({ enumerable: true, get: function () { return arrays_1.arrayContentEquals; } }));
Object.defineProperty(exports, "arrayContentStartsWith", ({ enumerable: true, get: function () { return arrays_1.arrayContentStartsWith; } }));
var assert_1 = __webpack_require__(34427);
Object.defineProperty(exports, "assert", ({ enumerable: true, get: function () { return assert_1.assert; } }));
Object.defineProperty(exports, "assertDefined", ({ enumerable: true, get: function () { return assert_1.assertDefined; } }));
Object.defineProperty(exports, "assertDefinedAndNotNull", ({ enumerable: true, get: function () { return assert_1.assertDefinedAndNotNull; } }));
var sleep_1 = __webpack_require__(73029);
Object.defineProperty(exports, "sleep", ({ enumerable: true, get: function () { return sleep_1.sleep; } }));
var typechecks_1 = __webpack_require__(95012);
Object.defineProperty(exports, "isDefined", ({ enumerable: true, get: function () { return typechecks_1.isDefined; } }));
Object.defineProperty(exports, "isNonNullObject", ({ enumerable: true, get: function () { return typechecks_1.isNonNullObject; } }));
Object.defineProperty(exports, "isUint8Array", ({ enumerable: true, get: function () { return typechecks_1.isUint8Array; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 73029:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.sleep = void 0;
async function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
}
exports.sleep = sleep;
//# sourceMappingURL=sleep.js.map

/***/ }),

/***/ 95012:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/* provided dependency */ var Buffer = __webpack_require__(48764)["Buffer"];

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.isDefined = exports.isUint8Array = exports.isNonNullObject = void 0;
/**
 * Checks if data is a non-null object (i.e. matches the TypeScript object type).
 *
 * Note: this returns true for arrays, which are objects in JavaScript
 * even though array and object are different types in JSON.
 *
 * @see https://www.typescriptlang.org/docs/handbook/basic-types.html#object
 */
// eslint-disable-next-line @typescript-eslint/ban-types
function isNonNullObject(data) {
    return typeof data === "object" && data !== null;
}
exports.isNonNullObject = isNonNullObject;
/**
 * Checks if data is an Uint8Array. Note: Buffer is treated as not a Uint8Array
 */
function isUint8Array(data) {
    if (!isNonNullObject(data))
        return false;
    // Avoid instanceof check which is unreliable in some JS environments
    // https://medium.com/@simonwarta/limitations-of-the-instanceof-operator-f4bcdbe7a400
    // Use check that was discussed in https://github.com/crypto-browserify/pbkdf2/pull/81
    if (Object.prototype.toString.call(data) !== "[object Uint8Array]")
        return false;
    if (typeof Buffer !== "undefined" && typeof Buffer.isBuffer !== "undefined") {
        // Buffer.isBuffer is available at runtime
        if (Buffer.isBuffer(data))
            return false;
    }
    return true;
}
exports.isUint8Array = isUint8Array;
/**
 * Checks if input is not undefined in a TypeScript-friendly way.
 *
 * This is convenient to use in e.g. `Array.filter` as it will convert
 * the type of a `Array<Foo | undefined>` to `Array<Foo>`.
 */
function isDefined(value) {
    return value !== undefined;
}
exports.isDefined = isDefined;
//# sourceMappingURL=typechecks.js.map

/***/ }),

/***/ 52597:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "PZM": function() { return /* reexport */ esm_Add1Icon; },
  "Y4O": function() { return /* reexport */ esm_ArrowLeftIcon; },
  "LZ3": function() { return /* reexport */ esm_ArrowRightIcon; },
  "BTe": function() { return /* reexport */ esm_BoxedExportIcon; },
  "rkm": function() { return /* reexport */ esm_BoxedImportIcon; },
  "YJ9": function() { return /* reexport */ esm_CheckedIcon; },
  "DUI": function() { return /* reexport */ esm_CloseBoxedIcon; },
  "PtX": function() { return /* reexport */ esm_Code3Icon; },
  "v_m": function() { return /* reexport */ esm_CopytoclipboardIcon; },
  "CEn": function() { return /* reexport */ esm_CrownIcon; },
  "rsV": function() { return /* reexport */ esm_DropIcon; },
  "KZX": function() { return /* reexport */ esm_Fullscreen1Icon; },
  "ym1": function() { return /* reexport */ esm_Fullscreen2Icon; },
  "ETn": function() { return /* reexport */ esm_GithubIcon; },
  "eCW": function() { return /* reexport */ esm_Graph2Icon; },
  "tvw": function() { return /* reexport */ esm_HomeIcon; },
  "jSc": function() { return /* reexport */ esm_KnowledgeIcon; },
  "ffx": function() { return /* reexport */ esm_Remove1Icon; },
  "YGC": function() { return /* reexport */ esm_TelegramIcon; },
  "Tqm": function() { return /* reexport */ esm_ToolkitIcon; },
  "Zmm": function() { return /* reexport */ esm_TwitterIcon; },
  "_Dm": function() { return /* reexport */ esm_ViewListIcon; }
});

// UNUSED EXPORTS: Add2Icon, AlarmIcon, AndroidIcon, AppleCommandIcon, ArrowBottom2Icon, ArrowBottom3Icon, ArrowBottom4Icon, ArrowBottom5Icon, ArrowBottomleftIcon, ArrowBottomrightIcon, ArrowBottomtopIcon, ArrowDiagonal1Icon, ArrowDiagonal2Icon, ArrowDownBoxedIcon, ArrowDownIcon, ArrowLeft2Icon, ArrowLeft3Icon, ArrowLeft4Icon, ArrowLeft5Icon, ArrowLeftBoxedIcon, ArrowLeftrightIcon, ArrowRight2Icon, ArrowRight3Icon, ArrowRight4Icon, ArrowRight5Icon, ArrowRightBoxedIcon, ArrowTop2Icon, ArrowTop3Icon, ArrowTop4Icon, ArrowTop5Icon, ArrowTopleftIcon, ArrowToprightIcon, ArrowUpBoxedIcon, ArrowUpIcon, AxeIcon, BadgeIcon, BallIcon, BarChartIcon, Batery0Icon, Batery1Icon, Batery2Icon, Batery3Icon, Batery4Icon, Block3DIcon, BlockIcon, BlockchainIcon, BluetoothIcon, Book184Icon, Book33Icon, Box1Icon, Box2Icon, Box3Icon, Box4Icon, Box5Icon, Box6Icon, Box7Icon, BoxContainerIcon, BrowserIcon, BulpIcon, CameraIcon, Cart1Icon, Cart2Icon, CdIcon, Chat1Icon, Chat2Icon, Check2Icon, CheckIcon, CheckboxIcon, CheckmarkIcon, Circle1Icon, Circle2Icon, Circle3Icon, Circle4Icon, Circle5Icon, Circle6Icon, Circle7Icon, CliIcon, CloseIcon, CloudDownloadIcon, CloudIcon, CloudUploadIcon, Code1Icon, Code2Icon, CoffeeIcon, CompassIcon, CropIcon, CutIcon, DashboardIcon, DatabaseIcon, DayIcon, Diamond2Icon, DiamondIcon, DiscordIcon, DisplayIcon, DocumentIcon, DonateIcon, DoorEnterIcon, DoorExitIcon, DownloadIcon, DragIcon, Edit1Icon, Edit2Icon, Edit3Icon, Edit4Icon, EmailIcon, EmailOpenIcon, EmoteHappyIcon, EmoteSadIcon, ExportIcon, FacebookIcon, File3DIcon, FileAudioCdIcon, FileAudioRecordIcon, FileAudioWaveIcon, FileBookIcon, FileBookmarkIcon, FileCameraIcon, FileChartBarIcon, FileChartPieIcon, FileCodeIcon, FileConfigIcon, FileDatabaseIcon, FileEmailIcon, FileEmptyIcon, FileExcelIcon, FileGameIcon, FileImageIcon, FilePdfIcon, FilePowerpointIcon, FileProtectedIcon, FileShellIcon, FileTextIcon, FileVcardIcon, FileVideoIcon, FileWordIcon, FileZipIcon, FingernailIcon, FlagIcon, FolderIcon, FolderOpenIcon, ForkIcon, FullscreenExpandIcon, FullscreenShrinkIcon, GhostIcon, GiftIcon, GitcoinKudosIcon, GlassChampagneIcon, GlassCoctailIcon, GlassJuiceIcon, GlassWineIcon, GlobeIcon, Graph1Icon, GroundPlanIcon, HashIcon, Heart1Icon, Heart2Icon, HexagonSpiderWebIcon, ImageIcon, ImportIcon, InvisibleIcon, KeyIcon, KeypairIcon, Layers2Icon, Layers3Icon, LifebeltIcon, Link1Icon, Link2Icon, LinkedinIcon, ListIcon, LocationIcon, LockCheckedIcon, LockLockedIcon, LockUnlockedIcon, Loop1Icon, Loop2Icon, LoopIcon, Magnet2Icon, MagnetIcon, MapIcon, MarkerIcon, MenIcon, Menu2Icon, MenuCircleIcon, MenuHorizontalIcon, MenuIcon, MenuVerticalIcon, ModelConnectionIcon, ModelIcon, MouseIcon, NetworkConnectedIcon, NetworkDisconnectedIcon, NetworkIcon, NightIcon, PaperclipIcon, PaperplaneIcon, PeaceIcon, PhoneCableIcon, PhoneChatBubblesIcon, PhoneChatIcon, PhoneClassicIcon, PhoneHandIcon, PhoneKeysIcon, PhoneMobileIcon, PhoneMobileKeysIcon, PhoneMobileRingIcon, PhoneMobileUserIcon, PhoneNumpadIcon, PhoneOfficeIcon, PhoneRingIcon, PhoneVideoPcIcon, PieChartIcon, PieIcon, PinIcon, PintrestIcon, PlayIcon, PlayVideoIcon, PowerIcon, PrintIcon, ProductsIcon, PuzzleIcon, QrcodeIcon, RadiobuttonIcon, Record1Icon, Record2Icon, Remove2Icon, RhombusNumberIcon, RulerIcon, Sandglass2Icon, SandglassIcon, SaveIcon, Search1Icon, Search2Icon, Search3Icon, SearchIcon, SequenceIcon, SettingsIcon, ShirtIcon, Sign2Icon, SignIcon, SkypeIcon, SlidersIcon, Spinner1Icon, Spinner2Icon, StairsIcon, StarIcon, SteeringWheelIcon, SunIcon, SwitchIcon, TagIcon, TargetCrossIcon, TargetCrossSmallIcon, TargetIcon, TextfileIcon, TimeIcon, TireIcon, ToggleIcon, TokenIcon, TrashIcon, UmbrellaIcon, UnlinkIcon, UsbIcon, UserAddIcon, UserIcon, ViewGridIcon, VisibleIcon, WarningIcon, Wifi2Icon, WifiIcon, WindowsLayersIcon, Woman2Icon, WomanIcon, WrenchIcon, YoutubeIcon, ZoomInIcon, ZoomOutIcon

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/Add1Icon.js


function Add1Icon(props) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/react.createElement("line", {
    x1: 20,
    y1: 32,
    x2: 44,
    y2: 32
  }), /*#__PURE__*/react.createElement("line", {
    x1: 32,
    y1: 20,
    x2: 32,
    y2: 44
  }), /*#__PURE__*/react.createElement("rect", {
    x: 8,
    y: 8,
    width: 48,
    height: 48
  }));
}

/* harmony default export */ var esm_Add1Icon = (Add1Icon);
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/Add2Icon.js


function Add2Icon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 24
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 32,
    x2: 44,
    y2: 32
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 20,
    x2: 32,
    y2: 44
  }));
}

/* harmony default export */ var esm_Add2Icon = ((/* unused pure expression or super */ null && (Add2Icon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/AlarmIcon.js


function AlarmIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12 44a48.53 48.53 0 0 0 20 4 48.53 48.53 0 0 0 20-4c-4-20-4-32-20-32S16 24 12 44z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 8,
    x2: 32,
    y2: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 47.41V48a8 8 0 0 0 16 0v-.59"
  }));
}

/* harmony default export */ var esm_AlarmIcon = ((/* unused pure expression or super */ null && (AlarmIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/AndroidIcon.js


function AndroidIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M56 44v4H8v-4a24 24 0 0 1 48 0z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 46.85,
    y1: 25.15,
    x2: 56,
    y2: 16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17.15,
    y1: 25.15,
    x2: 8,
    y2: 16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 32,
    x2: 24,
    y2: 36
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 32,
    x2: 40,
    y2: 36
  }));
}

/* harmony default export */ var esm_AndroidIcon = ((/* unused pure expression or super */ null && (AndroidIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/AppleCommandIcon.js


function AppleCommandIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M16 24a8 8 0 0 1-8-8 8 8 0 0 1 8-8 8 8 0 0 1 8 8v32a8 8 0 0 1-8 8 8 8 0 0 1-8-8 8 8 0 0 1 8-8h32a8 8 0 0 1 8 8 8 8 0 0 1-8 8 8 8 0 0 1-8-8V16a8 8 0 0 1 8-8 8 8 0 0 1 8 8 8 8 0 0 1-8 8z"
  }));
}

/* harmony default export */ var esm_AppleCommandIcon = ((/* unused pure expression or super */ null && (AppleCommandIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/ArrowBottom2Icon.js


function ArrowBottom2Icon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "24 28 32 36 40 28"
  }));
}

/* harmony default export */ var esm_ArrowBottom2Icon = ((/* unused pure expression or super */ null && (ArrowBottom2Icon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/ArrowBottom3Icon.js


function ArrowBottom3Icon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "24 24 32 32 40 24"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "24 32 32 40 40 32"
  }));
}

/* harmony default export */ var esm_ArrowBottom3Icon = ((/* unused pure expression or super */ null && (ArrowBottom3Icon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/ArrowBottom4Icon.js


function ArrowBottom4Icon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "48 24 32 40 16 24"
  }));
}

/* harmony default export */ var esm_ArrowBottom4Icon = ((/* unused pure expression or super */ null && (ArrowBottom4Icon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/ArrowBottom5Icon.js


function ArrowBottom5Icon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "48 32 32 48 16 32"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "48 16 32 32 16 16"
  }));
}

/* harmony default export */ var esm_ArrowBottom5Icon = ((/* unused pure expression or super */ null && (ArrowBottom5Icon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/ArrowBottomleftIcon.js


function ArrowBottomleftIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "16 36 16 48 28 48"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 48,
    x2: 48,
    y2: 16
  }));
}

/* harmony default export */ var esm_ArrowBottomleftIcon = ((/* unused pure expression or super */ null && (ArrowBottomleftIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/ArrowBottomrightIcon.js


function ArrowBottomrightIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "36 48 48 48 48 36"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 48,
    y1: 48,
    x2: 16,
    y2: 16
  }));
}

/* harmony default export */ var esm_ArrowBottomrightIcon = ((/* unused pure expression or super */ null && (ArrowBottomrightIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/ArrowBottomtopIcon.js


function ArrowBottomtopIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "40 20 32 12 24 20"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "24 44 32 52 40 44"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 12,
    x2: 32,
    y2: 52
  }));
}

/* harmony default export */ var esm_ArrowBottomtopIcon = ((/* unused pure expression or super */ null && (ArrowBottomtopIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/ArrowDiagonal1Icon.js


function ArrowDiagonal1Icon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "48 27.31 48 16 36.69 16"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "16 36.69 16 48 27.31 48"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 48,
    y1: 16,
    x2: 16,
    y2: 48
  }));
}

/* harmony default export */ var esm_ArrowDiagonal1Icon = ((/* unused pure expression or super */ null && (ArrowDiagonal1Icon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/ArrowDiagonal2Icon.js


function ArrowDiagonal2Icon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "36.69 48 48 48 48 36.69"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "27.31 16 16 16 16 27.31"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 48,
    y1: 48,
    x2: 16,
    y2: 16
  }));
}

/* harmony default export */ var esm_ArrowDiagonal2Icon = ((/* unused pure expression or super */ null && (ArrowDiagonal2Icon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/ArrowDownIcon.js


function ArrowDownIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "24 44 32 52 40 44"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 12,
    x2: 32,
    y2: 52
  }));
}

/* harmony default export */ var esm_ArrowDownIcon = ((/* unused pure expression or super */ null && (ArrowDownIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/ArrowDownBoxedIcon.js


function ArrowDownBoxedIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "24 28 32 36 40 28"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 48,
    height: 48
  }));
}

/* harmony default export */ var esm_ArrowDownBoxedIcon = ((/* unused pure expression or super */ null && (ArrowDownBoxedIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/ArrowLeftIcon.js


function ArrowLeftIcon(props) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/react.createElement("polyline", {
    points: "20 24 12 32 20 40"
  }), /*#__PURE__*/react.createElement("line", {
    x1: 52,
    y1: 32,
    x2: 12,
    y2: 32
  }));
}

/* harmony default export */ var esm_ArrowLeftIcon = (ArrowLeftIcon);
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/ArrowLeft2Icon.js


function ArrowLeft2Icon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "36 24 28 32 36 40"
  }));
}

/* harmony default export */ var esm_ArrowLeft2Icon = ((/* unused pure expression or super */ null && (ArrowLeft2Icon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/ArrowLeft3Icon.js


function ArrowLeft3Icon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "40 24 32 32 40 40"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "32 24 24 32 32 40"
  }));
}

/* harmony default export */ var esm_ArrowLeft3Icon = ((/* unused pure expression or super */ null && (ArrowLeft3Icon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/ArrowLeft4Icon.js


function ArrowLeft4Icon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "40 48 24 32 40 16"
  }));
}

/* harmony default export */ var esm_ArrowLeft4Icon = ((/* unused pure expression or super */ null && (ArrowLeft4Icon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/ArrowLeft5Icon.js


function ArrowLeft5Icon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "48 48 32 32 48 16"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "32 48 16 32 32 16"
  }));
}

/* harmony default export */ var esm_ArrowLeft5Icon = ((/* unused pure expression or super */ null && (ArrowLeft5Icon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/ArrowLeftBoxedIcon.js


function ArrowLeftBoxedIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "36 24 28 32 36 40"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 48,
    height: 48
  }));
}

/* harmony default export */ var esm_ArrowLeftBoxedIcon = ((/* unused pure expression or super */ null && (ArrowLeftBoxedIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/ArrowLeftrightIcon.js


function ArrowLeftrightIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "44 40 52 32 44 24"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "20 24 12 32 20 40"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 52,
    y1: 32,
    x2: 12,
    y2: 32
  }));
}

/* harmony default export */ var esm_ArrowLeftrightIcon = ((/* unused pure expression or super */ null && (ArrowLeftrightIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/ArrowRightIcon.js


function ArrowRightIcon(props) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/react.createElement("polyline", {
    points: "44 40 52 32 44 24"
  }), /*#__PURE__*/react.createElement("line", {
    x1: 52,
    y1: 32,
    x2: 12,
    y2: 32
  }));
}

/* harmony default export */ var esm_ArrowRightIcon = (ArrowRightIcon);
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/ArrowRight2Icon.js


function ArrowRight2Icon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "28 40 36 32 28 24"
  }));
}

/* harmony default export */ var esm_ArrowRight2Icon = ((/* unused pure expression or super */ null && (ArrowRight2Icon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/ArrowRight3Icon.js


function ArrowRight3Icon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "24 40 32 32 24 24"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "32 40 40 32 32 24"
  }));
}

/* harmony default export */ var esm_ArrowRight3Icon = ((/* unused pure expression or super */ null && (ArrowRight3Icon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/ArrowRight4Icon.js


function ArrowRight4Icon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "24 16 40 32 24 48"
  }));
}

/* harmony default export */ var esm_ArrowRight4Icon = ((/* unused pure expression or super */ null && (ArrowRight4Icon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/ArrowRight5Icon.js


function ArrowRight5Icon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "16 16 32 32 16 48"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "32 16 48 32 32 48"
  }));
}

/* harmony default export */ var esm_ArrowRight5Icon = ((/* unused pure expression or super */ null && (ArrowRight5Icon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/ArrowRightBoxedIcon.js


function ArrowRightBoxedIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "28 40 36 32 28 24"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 48,
    height: 48
  }));
}

/* harmony default export */ var esm_ArrowRightBoxedIcon = ((/* unused pure expression or super */ null && (ArrowRightBoxedIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/ArrowTop2Icon.js


function ArrowTop2Icon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "40 36 32 28 24 36"
  }));
}

/* harmony default export */ var esm_ArrowTop2Icon = ((/* unused pure expression or super */ null && (ArrowTop2Icon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/ArrowTop3Icon.js


function ArrowTop3Icon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "40 40 32 32 24 40"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "40 32 32 24 24 32"
  }));
}

/* harmony default export */ var esm_ArrowTop3Icon = ((/* unused pure expression or super */ null && (ArrowTop3Icon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/ArrowTop4Icon.js


function ArrowTop4Icon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "16 40 32 24 48 40"
  }));
}

/* harmony default export */ var esm_ArrowTop4Icon = ((/* unused pure expression or super */ null && (ArrowTop4Icon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/ArrowTop5Icon.js


function ArrowTop5Icon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "16 48 32 32 48 48"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "16 32 32 16 48 32"
  }));
}

/* harmony default export */ var esm_ArrowTop5Icon = ((/* unused pure expression or super */ null && (ArrowTop5Icon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/ArrowTopleftIcon.js


function ArrowTopleftIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "28 16 16 16 16 28"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 16,
    x2: 48,
    y2: 48
  }));
}

/* harmony default export */ var esm_ArrowTopleftIcon = ((/* unused pure expression or super */ null && (ArrowTopleftIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/ArrowToprightIcon.js


function ArrowToprightIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "48 28 48 16 36 16"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 48,
    y1: 16,
    x2: 16,
    y2: 48
  }));
}

/* harmony default export */ var esm_ArrowToprightIcon = ((/* unused pure expression or super */ null && (ArrowToprightIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/ArrowUpIcon.js


function ArrowUpIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "40 20 32 12 24 20"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 12,
    x2: 32,
    y2: 52
  }));
}

/* harmony default export */ var esm_ArrowUpIcon = ((/* unused pure expression or super */ null && (ArrowUpIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/ArrowUpBoxedIcon.js


function ArrowUpBoxedIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "40 36 32 28 24 36"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 48,
    height: 48
  }));
}

/* harmony default export */ var esm_ArrowUpBoxedIcon = ((/* unused pure expression or super */ null && (ArrowUpBoxedIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/AxeIcon.js


function AxeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("line", {
    x1: 52,
    y1: 12,
    x2: 8,
    y2: 56
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 20c-4-4-4-12-4-12a16 16 0 0 0-16 16s8 0 12 4 4 12 4 12a16 16 0 0 0 16-16s-8 0-12-4z"
  }));
}

/* harmony default export */ var esm_AxeIcon = ((/* unused pure expression or super */ null && (AxeIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/BadgeIcon.js


function BadgeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 28,
    r: 20
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 28,
    r: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 48a27.32 27.32 0 0 0 19.31 8H56V40h-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 48a27.32 27.32 0 0 1-19.31 8H8V40h8"
  }));
}

/* harmony default export */ var esm_BadgeIcon = ((/* unused pure expression or super */ null && (BadgeIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/BallIcon.js


function BallIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M46 51.49a24 24 0 0 1 0-39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 12.51a24 24 0 0 1 0 39"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 32,
    x2: 56,
    y2: 32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 24
  }));
}

/* harmony default export */ var esm_BallIcon = ((/* unused pure expression or super */ null && (BallIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/BarChartIcon.js


function BarChartIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "56 56 8 56 8 36"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 20,
    x2: 20,
    y2: 56
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 32,
    x2: 32,
    y2: 56
  }), /*#__PURE__*/React.createElement("line", {
    x1: 44,
    y1: 8,
    x2: 44,
    y2: 56
  }));
}

/* harmony default export */ var esm_BarChartIcon = ((/* unused pure expression or super */ null && (BarChartIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/Batery0Icon.js


function Batery0Icon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polygon", {
    points: "48 24 48 16 8 16 8 48 48 48 48 40 56 40 56 24 48 24"
  }));
}

/* harmony default export */ var esm_Batery0Icon = ((/* unused pure expression or super */ null && (Batery0Icon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/Batery1Icon.js


function Batery1Icon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polygon", {
    points: "48 24 48 16 8 16 8 48 48 48 48 40 56 40 56 24 48 24"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 24,
    x2: 16,
    y2: 40
  }));
}

/* harmony default export */ var esm_Batery1Icon = ((/* unused pure expression or super */ null && (Batery1Icon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/Batery2Icon.js


function Batery2Icon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 24,
    x2: 16,
    y2: 40
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 24,
    x2: 24,
    y2: 40
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "48 24 48 16 8 16 8 48 48 48 48 40 56 40 56 24 48 24"
  }));
}

/* harmony default export */ var esm_Batery2Icon = ((/* unused pure expression or super */ null && (Batery2Icon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/Batery3Icon.js


function Batery3Icon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 24,
    x2: 16,
    y2: 40
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 24,
    x2: 24,
    y2: 40
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 24,
    x2: 32,
    y2: 40
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "48 24 48 16 8 16 8 48 48 48 48 40 56 40 56 24 48 24"
  }));
}

/* harmony default export */ var esm_Batery3Icon = ((/* unused pure expression or super */ null && (Batery3Icon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/Batery4Icon.js


function Batery4Icon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polygon", {
    points: "48 24 48 16 8 16 8 48 48 48 48 40 56 40 56 24 48 24"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 24,
    x2: 16,
    y2: 40
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 24,
    x2: 24,
    y2: 40
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 24,
    x2: 32,
    y2: 40
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 24,
    x2: 40,
    y2: 40
  }));
}

/* harmony default export */ var esm_Batery4Icon = ((/* unused pure expression or super */ null && (Batery4Icon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/BlockIcon.js


function BlockIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polygon", {
    points: "8 20 8 44 32 56 56 44 56 20 32 8 8 20"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "56 20 32 32 8 20"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 32,
    x2: 32,
    y2: 56
  }));
}

/* harmony default export */ var esm_BlockIcon = ((/* unused pure expression or super */ null && (BlockIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/Block3DIcon.js


function Block3DIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polygon", {
    points: "8 20 8 44 32 56 56 44 56 20 32 8 8 20"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 32,
    x2: 56,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 56,
    x2: 32,
    y2: 32
  }), /*#__PURE__*/React.createElement("line", {
    x1: 56,
    y1: 44,
    x2: 32,
    y2: 32
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 44,
    x2: 32,
    y2: 32
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 20,
    x2: 32,
    y2: 32
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 8,
    x2: 32,
    y2: 32
  }));
}

/* harmony default export */ var esm_Block3DIcon = ((/* unused pure expression or super */ null && (Block3DIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/BlockchainIcon.js


function BlockchainIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "48 8 16 24 16 40 48 56"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "16 8 48 24 48 40 16 56"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 48,
    y1: 24,
    x2: 32,
    y2: 32
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 24,
    x2: 32,
    y2: 32
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 48,
    x2: 32,
    y2: 32
  }));
}

/* harmony default export */ var esm_BlockchainIcon = ((/* unused pure expression or super */ null && (BlockchainIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/BluetoothIcon.js


function BluetoothIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "20 40 40 24 28 12 28 52 40 40 20 24"
  }));
}

/* harmony default export */ var esm_BluetoothIcon = ((/* unused pure expression or super */ null && (BluetoothIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/Book184Icon.js


function Book184Icon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polygon", {
    points: "32 56 56 52 56 8 32 12 8 8 8 52 32 56"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 12,
    x2: 32,
    y2: 56
  }));
}

/* harmony default export */ var esm_Book184Icon = ((/* unused pure expression or super */ null && (Book184Icon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/Book33Icon.js


function Book33Icon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polygon", {
    points: "32 56 56 52 56 8 32 12 8 8 8 52 32 56"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 12,
    x2: 32,
    y2: 56
  }));
}

/* harmony default export */ var esm_Book33Icon = ((/* unused pure expression or super */ null && (Book33Icon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/Box1Icon.js


function Box1Icon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 48,
    height: 48
  }));
}

/* harmony default export */ var esm_Box1Icon = ((/* unused pure expression or super */ null && (Box1Icon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/Box2Icon.js


function Box2Icon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 48,
    height: 48
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 56,
    x2: 32,
    y2: 8
  }));
}

/* harmony default export */ var esm_Box2Icon = ((/* unused pure expression or super */ null && (Box2Icon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/Box3Icon.js


function Box3Icon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 48,
    height: 48
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 32,
    x2: 56,
    y2: 32
  }));
}

/* harmony default export */ var esm_Box3Icon = ((/* unused pure expression or super */ null && (Box3Icon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/Box4Icon.js


function Box4Icon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 48,
    height: 48
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 56,
    x2: 32,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 32,
    x2: 56,
    y2: 32
  }));
}

/* harmony default export */ var esm_Box4Icon = ((/* unused pure expression or super */ null && (Box4Icon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/Box5Icon.js


function Box5Icon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 48,
    height: 48
  }), /*#__PURE__*/React.createElement("line", {
    x1: 56,
    y1: 8,
    x2: 8,
    y2: 56
  }));
}

/* harmony default export */ var esm_Box5Icon = ((/* unused pure expression or super */ null && (Box5Icon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/Box6Icon.js


function Box6Icon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 48,
    height: 48
  }), /*#__PURE__*/React.createElement("line", {
    x1: 56,
    y1: 56,
    x2: 8,
    y2: 8
  }));
}

/* harmony default export */ var esm_Box6Icon = ((/* unused pure expression or super */ null && (Box6Icon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/Box7Icon.js


function Box7Icon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 48,
    height: 48
  }), /*#__PURE__*/React.createElement("line", {
    x1: 56,
    y1: 8,
    x2: 8,
    y2: 56
  }), /*#__PURE__*/React.createElement("line", {
    x1: 56,
    y1: 56,
    x2: 8,
    y2: 8
  }));
}

/* harmony default export */ var esm_Box7Icon = ((/* unused pure expression or super */ null && (Box7Icon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/BoxContainerIcon.js


function BoxContainerIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polygon", {
    points: "16 8 48 8 56 24 56 56 8 56 8 24 16 8"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 24,
    x2: 56,
    y2: 24
  }));
}

/* harmony default export */ var esm_BoxContainerIcon = ((/* unused pure expression or super */ null && (BoxContainerIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/BoxedExportIcon.js


function BoxedExportIcon(props) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/react.createElement("polyline", {
    points: "52 32 52 56 8 56 8 12 32 12"
  }), /*#__PURE__*/react.createElement("polyline", {
    points: "56 24 56 8 40 8"
  }), /*#__PURE__*/react.createElement("line", {
    x1: 36,
    y1: 28,
    x2: 56,
    y2: 8
  }));
}

/* harmony default export */ var esm_BoxedExportIcon = (BoxedExportIcon);
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/BoxedImportIcon.js


function BoxedImportIcon(props) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/react.createElement("polyline", {
    points: "52 40 52 56 8 56 8 12 24 12"
  }), /*#__PURE__*/react.createElement("polyline", {
    points: "36 12 36 28 52 28"
  }), /*#__PURE__*/react.createElement("line", {
    x1: 56,
    y1: 8,
    x2: 36,
    y2: 28
  }));
}

/* harmony default export */ var esm_BoxedImportIcon = (BoxedImportIcon);
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/BrowserIcon.js


function BrowserIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 48,
    height: 48
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 24,
    x2: 56,
    y2: 24
  }), /*#__PURE__*/React.createElement("line", {
    x1: 48,
    y1: 16,
    x2: 44,
    y2: 16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 16,
    x2: 36,
    y2: 16
  }));
}

/* harmony default export */ var esm_BrowserIcon = ((/* unused pure expression or super */ null && (BrowserIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/BulpIcon.js


function BulpIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M30.28 44 29 28.27a1.85 1.85 0 0 0-3.32-1 1.85 1.85 0 0 0 1.48 3h9.74a1.85 1.85 0 0 0 1.48-3 1.85 1.85 0 0 0-3.32 1L33.72 44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.41 44c0-5.41 4.35-10.27 6.6-13.66a14.34 14.34 0 0 0 2.38-8.81C46 14.35 41 8 32 8s-14.41 6.08-14.41 14.38a14.33 14.33 0 0 0 2.48 8.09c2.3 3.38 6.52 8.12 6.52 13.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 52a4 4 0 0 0 8 0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 44,
    width: 16,
    height: 8,
    rx: 3
  }));
}

/* harmony default export */ var esm_BulpIcon = ((/* unused pure expression or super */ null && (BulpIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/CameraIcon.js


function CameraIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 20,
    width: 48,
    height: 36,
    rx: 4
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "16 20 20 8 44 8 48 20"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 38,
    r: 10
  }));
}

/* harmony default export */ var esm_CameraIcon = ((/* unused pure expression or super */ null && (CameraIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/Cart1Icon.js


function Cart1Icon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "16 20 56 20 52 44 16 44 16 8 8 8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 52,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 52,
    r: 4
  }));
}

/* harmony default export */ var esm_Cart1Icon = ((/* unused pure expression or super */ null && (Cart1Icon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/Cart2Icon.js


function Cart2Icon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 48,
    x2: 32,
    y2: 32
  }), /*#__PURE__*/React.createElement("line", {
    x1: 44,
    y1: 48,
    x2: 44,
    y2: 32
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 48,
    x2: 20,
    y2: 32
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "8 24 12 56 52 56 56 24 8 24"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 24,
    x2: 20,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 48,
    y1: 24,
    x2: 44,
    y2: 8
  }));
}

/* harmony default export */ var esm_Cart2Icon = ((/* unused pure expression or super */ null && (Cart2Icon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/CdIcon.js


function CdIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 38,
    y1: 32,
    x2: 56,
    y2: 32
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 32,
    x2: 26.01,
    y2: 32
  }), /*#__PURE__*/React.createElement("line", {
    x1: 48.97,
    y1: 15.03,
    x2: 36.21,
    y2: 27.79
  }), /*#__PURE__*/React.createElement("line", {
    x1: 27.76,
    y1: 36.24,
    x2: 15.03,
    y2: 48.97
  }));
}

/* harmony default export */ var esm_CdIcon = ((/* unused pure expression or super */ null && (CdIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/Chat1Icon.js


function Chat1Icon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M8 52V18.58A6.59 6.59 0 0 1 14.58 12h34.84A6.59 6.59 0 0 1 56 18.58v22.84A6.59 6.59 0 0 1 49.42 48H16z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 24,
    x2: 48,
    y2: 24
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 36,
    x2: 48,
    y2: 36
  }));
}

/* harmony default export */ var esm_Chat1Icon = ((/* unused pure expression or super */ null && (Chat1Icon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/Chat2Icon.js


function Chat2Icon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 20,
    x2: 48,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 30,
    x2: 48,
    y2: 30
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 40,
    x2: 48,
    y2: 40
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56 56-12-4H17.16A9.16 9.16 0 0 1 8 42.84V17.16A9.16 9.16 0 0 1 17.16 8h29.68A9.16 9.16 0 0 1 56 17.16z"
  }));
}

/* harmony default export */ var esm_Chat2Icon = ((/* unused pure expression or super */ null && (Chat2Icon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/CheckIcon.js


function CheckIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "44 24 28 40 20 32"
  }));
}

/* harmony default export */ var esm_CheckIcon = ((/* unused pure expression or super */ null && (CheckIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/Check2Icon.js


function Check2Icon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "44 24 28 40 20 32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8 35.13A24 24 0 1 1 35.13 8.2"
  }));
}

/* harmony default export */ var esm_Check2Icon = ((/* unused pure expression or super */ null && (Check2Icon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/CheckboxIcon.js


function CheckboxIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 48,
    height: 48
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "20 32 28 40 44 24"
  }));
}

/* harmony default export */ var esm_CheckboxIcon = ((/* unused pure expression or super */ null && (CheckboxIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/CheckedIcon.js


function CheckedIcon(props) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/react.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 24
  }), /*#__PURE__*/react.createElement("polyline", {
    points: "44 24 28 40 20 32"
  }));
}

/* harmony default export */ var esm_CheckedIcon = (CheckedIcon);
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/CheckmarkIcon.js


function CheckmarkIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "12 28 28 44 52 20"
  }));
}

/* harmony default export */ var esm_CheckmarkIcon = ((/* unused pure expression or super */ null && (CheckmarkIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/Circle1Icon.js


function Circle1Icon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 24
  }));
}

/* harmony default export */ var esm_Circle1Icon = ((/* unused pure expression or super */ null && (Circle1Icon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/Circle2Icon.js


function Circle2Icon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 24
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 8,
    x2: 32,
    y2: 56
  }));
}

/* harmony default export */ var esm_Circle2Icon = ((/* unused pure expression or super */ null && (Circle2Icon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/Circle3Icon.js


function Circle3Icon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 24
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 32,
    x2: 56,
    y2: 32
  }));
}

/* harmony default export */ var esm_Circle3Icon = ((/* unused pure expression or super */ null && (Circle3Icon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/Circle4Icon.js


function Circle4Icon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 24
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 8,
    x2: 32,
    y2: 56
  }), /*#__PURE__*/React.createElement("line", {
    x1: 56,
    y1: 32,
    x2: 8,
    y2: 32
  }));
}

/* harmony default export */ var esm_Circle4Icon = ((/* unused pure expression or super */ null && (Circle4Icon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/Circle5Icon.js


function Circle5Icon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 24
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15.03,
    y1: 48.97,
    x2: 48.96,
    y2: 15.04
  }));
}

/* harmony default export */ var esm_Circle5Icon = ((/* unused pure expression or super */ null && (Circle5Icon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/Circle6Icon.js


function Circle6Icon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 24
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15.03,
    y1: 15.04,
    x2: 48.96,
    y2: 48.97
  }));
}

/* harmony default export */ var esm_Circle6Icon = ((/* unused pure expression or super */ null && (Circle6Icon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/Circle7Icon.js


function Circle7Icon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 24
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15.03,
    y1: 48.97,
    x2: 48.96,
    y2: 15.04
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15.03,
    y1: 15.04,
    x2: 48.96,
    y2: 48.97
  }));
}

/* harmony default export */ var esm_Circle7Icon = ((/* unused pure expression or super */ null && (Circle7Icon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/CliIcon.js


function CliIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 12,
    width: 48,
    height: 40
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "20 40 28 32 20 24"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 40,
    x2: 44,
    y2: 40
  }));
}

/* harmony default export */ var esm_CliIcon = ((/* unused pure expression or super */ null && (CliIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/CloseIcon.js


function CloseIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 16,
    x2: 48,
    y2: 48
  }), /*#__PURE__*/React.createElement("line", {
    x1: 48,
    y1: 16,
    x2: 16,
    y2: 48
  }));
}

/* harmony default export */ var esm_CloseIcon = ((/* unused pure expression or super */ null && (CloseIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/CloseBoxedIcon.js


function CloseBoxedIcon(props) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/react.createElement("line", {
    x1: 20,
    y1: 20,
    x2: 44,
    y2: 44
  }), /*#__PURE__*/react.createElement("line", {
    x1: 44,
    y1: 20,
    x2: 20,
    y2: 44
  }), /*#__PURE__*/react.createElement("rect", {
    x: 8,
    y: 8,
    width: 48,
    height: 48
  }));
}

/* harmony default export */ var esm_CloseBoxedIcon = (CloseBoxedIcon);
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/CloudIcon.js


function CloudIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M42 48a14 14 0 1 0-4.46-27.26A12 12 0 0 0 16.71 32H16a8 8 0 0 0 0 16z"
  }));
}

/* harmony default export */ var esm_CloudIcon = ((/* unused pure expression or super */ null && (CloudIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/CloudDownloadIcon.js


function CloudDownloadIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M45.84 43.47a14 14 0 1 0-8.3-26.73A12 12 0 0 0 16.71 28H16a8 8 0 0 0 0 16h2"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "24 44 32 52 40 44"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 52,
    x2: 32,
    y2: 28
  }));
}

/* harmony default export */ var esm_CloudDownloadIcon = ((/* unused pure expression or super */ null && (CloudDownloadIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/CloudUploadIcon.js


function CloudUploadIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M42 44a14 14 0 1 0-4.46-27.26A12 12 0 0 0 16.71 28H16a8 8 0 0 0 0 16h6"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "40 36 32 28 24 36"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 28,
    x2: 32,
    y2: 52
  }));
}

/* harmony default export */ var esm_CloudUploadIcon = ((/* unused pure expression or super */ null && (CloudUploadIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/Code1Icon.js


function Code1Icon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "16 48 8 32 16 16"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "48 48 56 32 48 16"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 36,
    y1: 8,
    x2: 28,
    y2: 56
  }));
}

/* harmony default export */ var esm_Code1Icon = ((/* unused pure expression or super */ null && (Code1Icon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/Code2Icon.js


function Code2Icon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M20 56a8 8 0 0 1-8-8V36l-4-4 4-4V16a8 8 0 0 1 8-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 8a8 8 0 0 1 8 8v12l4 4-4 4v12a8 8 0 0 1-8 8"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 32,
    x2: 24,
    y2: 32
  }), /*#__PURE__*/React.createElement("line", {
    x1: 30,
    y1: 32,
    x2: 34,
    y2: 32
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 32,
    x2: 44,
    y2: 32
  }));
}

/* harmony default export */ var esm_Code2Icon = ((/* unused pure expression or super */ null && (Code2Icon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/Code3Icon.js


function Code3Icon(props) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/react.createElement("rect", {
    x: 8,
    y: 12,
    width: 48,
    height: 40
  }), /*#__PURE__*/react.createElement("polyline", {
    points: "40 40 48 32 40 24"
  }), /*#__PURE__*/react.createElement("polyline", {
    points: "24 24 16 32 24 40"
  }), /*#__PURE__*/react.createElement("line", {
    x1: 34,
    y1: 22,
    x2: 30,
    y2: 42
  }));
}

/* harmony default export */ var esm_Code3Icon = (Code3Icon);
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/CoffeeIcon.js


function CoffeeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M8 24h40v24a8 8 0 0 1-8 8H16a8 8 0 0 1-8-8V24z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 16,
    x2: 28,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 16,
    x2: 16,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 16,
    x2: 40,
    y2: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 44h5.42A2.59 2.59 0 0 0 56 41.42v-6.84A2.59 2.59 0 0 0 53.42 32H48"
  }));
}

/* harmony default export */ var esm_CoffeeIcon = ((/* unused pure expression or super */ null && (CoffeeIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/CompassIcon.js


function CompassIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 24
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "28 28 24 40 36 36 40 24 28 28"
  }));
}

/* harmony default export */ var esm_CompassIcon = ((/* unused pure expression or super */ null && (CompassIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/CopytoclipboardIcon.js


function CopytoclipboardIcon(props) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/react.createElement("polyline", {
    points: "24 40 8 40 8 8 40 8 40 24"
  }), /*#__PURE__*/react.createElement("rect", {
    x: 24,
    y: 24,
    width: 32,
    height: 32
  }));
}

/* harmony default export */ var esm_CopytoclipboardIcon = (CopytoclipboardIcon);
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/CropIcon.js


function CropIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "56 48 16 48 16 8"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "8 16 48 16 48 56"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 56,
    x2: 56,
    y2: 8
  }));
}

/* harmony default export */ var esm_CropIcon = ((/* unused pure expression or super */ null && (CropIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/CrownIcon.js


function CrownIcon(props) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/react.createElement("polygon", {
    points: "52 56 52 44 56 20 44 24 32 8 20 24 8 20 12 44 12 56 52 56"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M12 44z"
  }));
}

/* harmony default export */ var esm_CrownIcon = (CrownIcon);
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/CutIcon.js


function CutIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 20,
    r: 8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 44,
    r: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20.8,
    y1: 37.6,
    x2: 56,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20.8,
    y1: 26.4,
    x2: 56,
    y2: 44
  }));
}

/* harmony default export */ var esm_CutIcon = ((/* unused pure expression or super */ null && (CutIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/DashboardIcon.js


function DashboardIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 8,
    x2: 32,
    y2: 16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 56,
    x2: 32,
    y2: 48
  }), /*#__PURE__*/React.createElement("line", {
    x1: 56,
    y1: 32,
    x2: 48,
    y2: 32
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 32,
    x2: 16,
    y2: 32
  }), /*#__PURE__*/React.createElement("line", {
    x1: 48.97,
    y1: 15.03,
    x2: 32,
    y2: 32
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15.03,
    y1: 48.97,
    x2: 20.69,
    y2: 43.31
  }), /*#__PURE__*/React.createElement("line", {
    x1: 48.97,
    y1: 48.97,
    x2: 43.31,
    y2: 43.31
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15.03,
    y1: 15.03,
    x2: 20.69,
    y2: 20.69
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 24
  }));
}

/* harmony default export */ var esm_DashboardIcon = ((/* unused pure expression or super */ null && (DashboardIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/DatabaseIcon.js


function DatabaseIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M56 16v32c0 4.42-10.75 8-24 8S8 52.42 8 48V16c0-4.42 10.75-8 24-8s24 3.58 24 8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 16c0 4.42-10.75 8-24 8S8 20.42 8 16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 32c0 4.42-10.75 8-24 8S8 36.42 8 32"
  }));
}

/* harmony default export */ var esm_DatabaseIcon = ((/* unused pure expression or super */ null && (DatabaseIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/DayIcon.js


function DayIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 8,
    x2: 32,
    y2: 16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 56,
    x2: 32,
    y2: 48
  }), /*#__PURE__*/React.createElement("line", {
    x1: 56,
    y1: 32,
    x2: 48,
    y2: 32
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 32,
    x2: 16,
    y2: 32
  }), /*#__PURE__*/React.createElement("line", {
    x1: 48.97,
    y1: 15.03,
    x2: 43.31,
    y2: 20.69
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15.03,
    y1: 48.97,
    x2: 20.69,
    y2: 43.31
  }), /*#__PURE__*/React.createElement("line", {
    x1: 48.97,
    y1: 48.97,
    x2: 43.31,
    y2: 43.31
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15.03,
    y1: 15.03,
    x2: 20.69,
    y2: 20.69
  }));
}

/* harmony default export */ var esm_DayIcon = ((/* unused pure expression or super */ null && (DayIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/DiamondIcon.js


function DiamondIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polygon", {
    points: "32 56 20 32 32 8 44 32 32 56"
  }));
}

/* harmony default export */ var esm_DiamondIcon = ((/* unused pure expression or super */ null && (DiamondIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/Diamond2Icon.js


function Diamond2Icon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polygon", {
    points: "32 44 8 32 32 20 56 32 32 44"
  }));
}

/* harmony default export */ var esm_Diamond2Icon = ((/* unused pure expression or super */ null && (Diamond2Icon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/DiscordIcon.js


function DiscordIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M14.55 40.17c3.53 2.67 8.86 5.46 17.45 5.46s13.92-2.79 17.45-5.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 22.18c-4.31-2.2-8.57-4.26-16-4.26S20.33 20 16 22.18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.32 18.23-1.87-3.68a22.75 22.75 0 0 0-10.9 4.36S9 27 8 42.91c5.63 6.49 14.18 6.54 14.18 6.54L25.5 45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38.5 45 3.32 4.42s8.55-.02 14.18-6.51c-1-15.9-6.55-24-6.55-24s-5-3.92-10.9-4.36l-1.82 3.69"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.91,
    cy: 34.18,
    rx: 3.82,
    ry: 4.36
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 39.09,
    cy: 34.18,
    rx: 3.82,
    ry: 4.36
  }));
}

/* harmony default export */ var esm_DiscordIcon = ((/* unused pure expression or super */ null && (DiscordIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/DisplayIcon.js


function DisplayIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 48,
    height: 36,
    rx: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 56,
    x2: 48,
    y2: 56
  }), /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 44,
    x2: 24,
    y2: 56
  }), /*#__PURE__*/React.createElement("line", {
    x1: 36,
    y1: 44,
    x2: 40,
    y2: 56
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 36,
    x2: 56,
    y2: 36
  }));
}

/* harmony default export */ var esm_DisplayIcon = ((/* unused pure expression or super */ null && (DisplayIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/DocumentIcon.js


function DocumentIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 8,
    width: 40,
    height: 48
  }));
}

/* harmony default export */ var esm_DocumentIcon = ((/* unused pure expression or super */ null && (DocumentIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/DonateIcon.js


function DonateIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 28,
    r: 20
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "8 48 8 56 56 56 56 48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 28a4 4 0 0 1 0-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 28a4 4 0 0 1 0 8"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 16,
    x2: 32,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 36,
    x2: 32,
    y2: 40
  }), /*#__PURE__*/React.createElement("line", {
    x1: 30,
    y1: 28,
    x2: 34,
    y2: 28
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38 22s-2-2-4-2h-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 34s2 2 4 2h4"
  }));
}

/* harmony default export */ var esm_DonateIcon = ((/* unused pure expression or super */ null && (DonateIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/DoorEnterIcon.js


function DoorEnterIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "16 20 16 8 48 8 48 56 16 56 16 44"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "28 40 36 32 28 24"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 32,
    x2: 36,
    y2: 32
  }));
}

/* harmony default export */ var esm_DoorEnterIcon = ((/* unused pure expression or super */ null && (DoorEnterIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/DoorExitIcon.js


function DoorExitIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "40 44 40 56 8 56 8 8 40 8 40 20"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "48 40 56 32 48 24"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 32,
    x2: 56,
    y2: 32
  }));
}

/* harmony default export */ var esm_DoorExitIcon = ((/* unused pure expression or super */ null && (DoorExitIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/DownloadIcon.js


function DownloadIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 40,
    width: 48,
    height: 16
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "24 24 32 32 40 24"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 8,
    x2: 32,
    y2: 32
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 48,
    x2: 20,
    y2: 48
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 48,
    x2: 28,
    y2: 48
  }));
}

/* harmony default export */ var esm_DownloadIcon = ((/* unused pure expression or super */ null && (DownloadIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/DragIcon.js


function DragIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 8,
    x2: 32,
    y2: 56
  }), /*#__PURE__*/React.createElement("line", {
    x1: 56,
    y1: 32,
    x2: 8,
    y2: 32
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "40 16 32 8 24 16"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "24 48 32 56 40 48"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "48 40 56 32 48 24"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "16 24 8 32 16 40"
  }));
}

/* harmony default export */ var esm_DragIcon = ((/* unused pure expression or super */ null && (DragIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/DropIcon.js


function DropIcon(props) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/react.createElement("path", {
    d: "M52 36.8C52 17.6 32 8 32 8s-20 9.6-20 28.8C12 47.4 21 56 32 56s20-8.6 20-19.2z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M22 36.8a9.81 9.81 0 0 0 10 9.6"
  }));
}

/* harmony default export */ var esm_DropIcon = (DropIcon);
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/Edit1Icon.js


function Edit1Icon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polygon", {
    points: "20 56 56 20 44 8 8 44 8 56 20 56"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 40,
    x2: 24,
    y2: 52
  }), /*#__PURE__*/React.createElement("line", {
    x1: 36,
    y1: 16,
    x2: 48,
    y2: 28
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 56,
    x2: 56,
    y2: 56
  }));
}

/* harmony default export */ var esm_Edit1Icon = ((/* unused pure expression or super */ null && (Edit1Icon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/Edit2Icon.js


function Edit2Icon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polygon", {
    points: "24 52 56 20 44 8 12 40 8 56 24 52"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 40,
    x2: 24,
    y2: 52
  }), /*#__PURE__*/React.createElement("line", {
    x1: 36,
    y1: 16,
    x2: 48,
    y2: 28
  }));
}

/* harmony default export */ var esm_Edit2Icon = ((/* unused pure expression or super */ null && (Edit2Icon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/Edit3Icon.js


function Edit3Icon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polygon", {
    points: "20 56 56 20 44 8 8 44 8 56 20 56"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 40,
    x2: 24,
    y2: 52
  }), /*#__PURE__*/React.createElement("line", {
    x1: 36,
    y1: 16,
    x2: 48,
    y2: 28
  }));
}

/* harmony default export */ var esm_Edit3Icon = ((/* unused pure expression or super */ null && (Edit3Icon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/Edit4Icon.js


function Edit4Icon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polygon", {
    points: "24 56 56 24 40 8 8 40 8 56 24 56"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 40,
    x2: 24,
    y2: 56
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 16,
    x2: 48,
    y2: 32
  }));
}

/* harmony default export */ var esm_Edit4Icon = ((/* unused pure expression or super */ null && (Edit4Icon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/EmailIcon.js


function EmailIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 12,
    width: 48,
    height: 40
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "56 20 32 36 8 20"
  }));
}

/* harmony default export */ var esm_EmailIcon = ((/* unused pure expression or super */ null && (EmailIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/EmailOpenIcon.js


function EmailOpenIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polygon", {
    points: "56 20 32 12 8 20 8 52 56 52 56 20"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "48 28 32 36 16 28"
  }));
}

/* harmony default export */ var esm_EmailOpenIcon = ((/* unused pure expression or super */ null && (EmailOpenIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/EmoteHappyIcon.js


function EmoteHappyIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.49 40a12 12 0 0 1-3.82 2.57 12.07 12.07 0 0 1-9.34 0A12 12 0 0 1 23.51 40"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 24,
    x2: 36,
    y2: 24
  }), /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 24,
    x2: 24,
    y2: 24
  }));
}

/* harmony default export */ var esm_EmoteHappyIcon = ((/* unused pure expression or super */ null && (EmoteHappyIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/EmoteSadIcon.js


function EmoteSadIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.51 43.51a12.18 12.18 0 0 1 3.82-2.57 12.07 12.07 0 0 1 9.34 0 12.18 12.18 0 0 1 3.82 2.57"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 24,
    x2: 36,
    y2: 24
  }), /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 24,
    x2: 24,
    y2: 24
  }));
}

/* harmony default export */ var esm_EmoteSadIcon = ((/* unused pure expression or super */ null && (EmoteSadIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/ExportIcon.js


function ExportIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "48 24 32 8 16 24"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 56,
    y1: 56,
    x2: 8,
    y2: 56
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 48,
    x2: 32,
    y2: 8
  }));
}

/* harmony default export */ var esm_ExportIcon = ((/* unused pure expression or super */ null && (ExportIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/FacebookIcon.js


function FacebookIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M28 56V20Q28 8 40 8"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 24,
    x2: 22,
    y2: 24
  }));
}

/* harmony default export */ var esm_FacebookIcon = ((/* unused pure expression or super */ null && (FacebookIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/File3DIcon.js


function File3DIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "44 8 44 16 52 16"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "52 16 44 8 12 8 12 56 52 56 52 16"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "20 26 20 38 32 44 44 38 44 26 32 20 20 26"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 32,
    x2: 44,
    y2: 26
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 44,
    x2: 32,
    y2: 32
  }), /*#__PURE__*/React.createElement("line", {
    x1: 44,
    y1: 38,
    x2: 32,
    y2: 32
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 38,
    x2: 32,
    y2: 32
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 26,
    x2: 32,
    y2: 32
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 20,
    x2: 32,
    y2: 32
  }));
}

/* harmony default export */ var esm_File3DIcon = ((/* unused pure expression or super */ null && (File3DIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/FileAudioCdIcon.js


function FileAudioCdIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "44 8 44 16 52 16"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "52 16 44 8 12 8 12 56 52 56 52 16"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 12
  }));
}

/* harmony default export */ var esm_FileAudioCdIcon = ((/* unused pure expression or super */ null && (FileAudioCdIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/FileAudioRecordIcon.js


function FileAudioRecordIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "44 8 44 16 52 16"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "52 16 44 8 12 8 12 56 52 56 52 16"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 4
  }));
}

/* harmony default export */ var esm_FileAudioRecordIcon = ((/* unused pure expression or super */ null && (FileAudioRecordIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/FileAudioWaveIcon.js


function FileAudioWaveIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "44 8 44 16 52 16"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "52 16 44 8 12 8 12 56 52 56 52 16"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 20,
    x2: 32,
    y2: 44
  }), /*#__PURE__*/React.createElement("line", {
    x1: 38,
    y1: 24,
    x2: 38,
    y2: 40
  }), /*#__PURE__*/React.createElement("line", {
    x1: 26,
    y1: 24,
    x2: 26,
    y2: 40
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 28,
    x2: 20,
    y2: 36
  }), /*#__PURE__*/React.createElement("line", {
    x1: 44,
    y1: 28,
    x2: 44,
    y2: 36
  }));
}

/* harmony default export */ var esm_FileAudioWaveIcon = ((/* unused pure expression or super */ null && (FileAudioWaveIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/FileBookIcon.js


function FileBookIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "44 8 44 16 52 16"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "52 16 44 8 12 8 12 56 52 56 52 16"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "32 44 44 42 44 20 32 22 20 20 20 42 32 44"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 21,
    x2: 32,
    y2: 43
  }));
}

/* harmony default export */ var esm_FileBookIcon = ((/* unused pure expression or super */ null && (FileBookIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/FileBookmarkIcon.js


function FileBookmarkIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "44 8 44 16 52 16"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "52 16 44 8 12 8 12 56 52 56 52 16"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "32 39.9 24.2 44 25.69 35.32 19.38 29.17 28.1 27.9 32 20 35.9 27.9 44.62 29.17 38.31 35.32 39.8 44 32 39.9"
  }));
}

/* harmony default export */ var esm_FileBookmarkIcon = ((/* unused pure expression or super */ null && (FileBookmarkIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/FileCameraIcon.js


function FileCameraIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "44 8 44 16 52 16"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "52 16 44 8 12 8 12 56 52 56 52 16"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "36 28.63 44 26.63 44 37.38 36 35.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 36a4 4 0 0 1-4 4l-8-.62a4 4 0 0 1-4-4v-6.76a4 4 0 0 1 4-4l8-.62a4 4 0 0 1 4 4z"
  }));
}

/* harmony default export */ var esm_FileCameraIcon = ((/* unused pure expression or super */ null && (FileCameraIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/FileChartBarIcon.js


function FileChartBarIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "44 8 44 16 52 16"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "52 16 44 8 12 8 12 56 52 56 52 16"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 20,
    x2: 28,
    y2: 44
  }), /*#__PURE__*/React.createElement("line", {
    x1: 36,
    y1: 32,
    x2: 36,
    y2: 44
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "44 36 44 44 20 44 20 28"
  }));
}

/* harmony default export */ var esm_FileChartBarIcon = ((/* unused pure expression or super */ null && (FileChartBarIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/FileChartPieIcon.js


function FileChartPieIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "44 8 44 16 52 16"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "52 16 44 8 12 8 12 56 52 56 52 16"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 12
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "44 32 32 32 32 20"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 32,
    x2: 23.53,
    y2: 40.47
  }));
}

/* harmony default export */ var esm_FileChartPieIcon = ((/* unused pure expression or super */ null && (FileChartPieIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/FileCodeIcon.js


function FileCodeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "44 8 44 16 52 16"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "52 16 44 8 12 8 12 56 52 56 52 16"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "24 40 20 32 24 24"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "40 40 44 32 40 24"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 34,
    y1: 20,
    x2: 30,
    y2: 44
  }));
}

/* harmony default export */ var esm_FileCodeIcon = ((/* unused pure expression or super */ null && (FileCodeIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/FileConfigIcon.js


function FileConfigIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "44 8 44 16 52 16"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "52 16 44 8 12 8 12 56 52 56 52 16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 32a11.49 11.49 0 0 0-.16-1.95L40 28.69 41.75 25A12 12 0 0 0 39 22.25L35.31 24 34 20.16a12 12 0 0 0-3.9 0L28.69 24 25 22.25A12 12 0 0 0 22.25 25L24 28.69l-3.84 1.36a12 12 0 0 0 0 3.9L24 35.31 22.25 39A12 12 0 0 0 25 41.75L28.69 40l1.36 3.84a12 12 0 0 0 3.9 0L35.31 40 39 41.75A12 12 0 0 0 41.75 39L40 35.31 43.84 34a11.49 11.49 0 0 0 .16-2z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 2
  }));
}

/* harmony default export */ var esm_FileConfigIcon = ((/* unused pure expression or super */ null && (FileConfigIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/FileDatabaseIcon.js


function FileDatabaseIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "44 8 44 16 52 16"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "52 16 44 8 12 8 12 56 52 56 52 16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 24v16c0 2.21-5.37 4-12 4s-12-1.79-12-4V24c0-2.21 5.37-4 12-4s12 1.79 12 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 24c0 2.21-5.37 4-12 4s-12-1.79-12-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 32c0 2.21-5.37 4-12 4s-12-1.79-12-4"
  }));
}

/* harmony default export */ var esm_FileDatabaseIcon = ((/* unused pure expression or super */ null && (FileDatabaseIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/FileEmailIcon.js


function FileEmailIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "44 8 44 16 52 16"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "52 16 44 8 12 8 12 56 52 56 52 16"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "52 32 32 44 12 32"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 20,
    x2: 28,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 36,
    y1: 28,
    x2: 20,
    y2: 28
  }));
}

/* harmony default export */ var esm_FileEmailIcon = ((/* unused pure expression or super */ null && (FileEmailIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/FileEmptyIcon.js


function FileEmptyIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "44 8 44 16 52 16"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "52 16 44 8 12 8 12 56 52 56 52 16"
  }));
}

/* harmony default export */ var esm_FileEmptyIcon = ((/* unused pure expression or super */ null && (FileEmptyIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/FileExcelIcon.js


function FileExcelIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "44 8 44 16 52 16"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "52 16 44 8 12 8 12 56 52 56 52 16"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 20,
    x2: 40,
    y2: 44
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 20,
    x2: 24,
    y2: 44
  }));
}

/* harmony default export */ var esm_FileExcelIcon = ((/* unused pure expression or super */ null && (FileExcelIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/FileGameIcon.js


function FileGameIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "44 8 44 16 52 16"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "52 16 44 8 12 8 12 56 52 56 52 16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44 44-4-2-4 2-4-2-4 2-4-2-4 2V32a12 12 0 0 1 12-12 12 12 0 0 1 12 12z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 30,
    x2: 28,
    y2: 32
  }), /*#__PURE__*/React.createElement("line", {
    x1: 36,
    y1: 30,
    x2: 36,
    y2: 32
  }));
}

/* harmony default export */ var esm_FileGameIcon = ((/* unused pure expression or super */ null && (FileGameIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/FileImageIcon.js


function FileImageIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "44 8 44 16 52 16"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "52 16 44 8 12 8 12 56 52 56 52 16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 44h6.67c6.66 0 13.33-8 20-8s6.66 8 13.33 8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 22,
    r: 6
  }));
}

/* harmony default export */ var esm_FileImageIcon = ((/* unused pure expression or super */ null && (FileImageIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/FilePdfIcon.js


function FilePdfIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "44 8 44 16 52 16"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "52 16 44 8 12 8 12 56 52 56 52 16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.22 20.08C19.37 22 41.51 42.71 43 35.8s-26.33 2.89-21.41 7.68 11.48-25.27 4.63-23.4z"
  }));
}

/* harmony default export */ var esm_FilePdfIcon = ((/* unused pure expression or super */ null && (FilePdfIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/FilePowerpointIcon.js


function FilePowerpointIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "44 8 44 16 52 16"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "52 16 44 8 12 8 12 56 52 56 52 16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 34.4h8.8a7.2 7.2 0 1 0 0-14.4H24v24"
  }));
}

/* harmony default export */ var esm_FilePowerpointIcon = ((/* unused pure expression or super */ null && (FilePowerpointIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/FileProtectedIcon.js


function FileProtectedIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "44 8 44 16 52 16"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "52 16 44 8 12 8 12 56 52 56 52 16"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 30,
    width: 20,
    height: 14,
    rx: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 40,
    x2: 32,
    y2: 34
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 30v-4a6 6 0 0 1 12 0v4"
  }));
}

/* harmony default export */ var esm_FileProtectedIcon = ((/* unused pure expression or super */ null && (FileProtectedIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/FileShellIcon.js


function FileShellIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "44 8 44 16 52 16"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "52 16 44 8 12 8 12 56 52 56 52 16"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "20 40 28 32 20 24"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 40,
    x2: 44,
    y2: 40
  }));
}

/* harmony default export */ var esm_FileShellIcon = ((/* unused pure expression or super */ null && (FileShellIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/FileTextIcon.js


function FileTextIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "44 8 44 16 52 16"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "52 16 44 8 12 8 12 56 52 56 52 16"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 20,
    x2: 28,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 28,
    x2: 44,
    y2: 28
  }), /*#__PURE__*/React.createElement("line", {
    x1: 36,
    y1: 36,
    x2: 20,
    y2: 36
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 44,
    x2: 44,
    y2: 44
  }));
}

/* harmony default export */ var esm_FileTextIcon = ((/* unused pure expression or super */ null && (FileTextIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/FileVcardIcon.js


function FileVcardIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "44 8 44 16 52 16"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "52 16 44 8 12 8 12 56 52 56 52 16"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 32,
    cy: 28,
    rx: 6,
    ry: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 32.73s-5 1.34-6 4A16.42 16.42 0 0 0 20 44h24a16.42 16.42 0 0 0-1-7.27c-1-2.66-6-4-6-4"
  }));
}

/* harmony default export */ var esm_FileVcardIcon = ((/* unused pure expression or super */ null && (FileVcardIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/FileVideoIcon.js


function FileVideoIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "44 8 44 16 52 16"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "52 16 44 8 12 8 12 56 52 56 52 16"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "39 32 25 24 25 40 39 32"
  }));
}

/* harmony default export */ var esm_FileVideoIcon = ((/* unused pure expression or super */ null && (FileVideoIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/FileWordIcon.js


function FileWordIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "44 8 44 16 52 16"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "52 16 44 8 12 8 12 56 52 56 52 16"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "44 20 40 44 32 34.4 24 44 20 20"
  }));
}

/* harmony default export */ var esm_FileWordIcon = ((/* unused pure expression or super */ null && (FileWordIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/FileZipIcon.js


function FileZipIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "44 8 44 16 52 16"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "52 16 44 8 12 8 12 56 52 56 52 16"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 8,
    x2: 32,
    y2: 56
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 16,
    x2: 24,
    y2: 16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 24,
    x2: 32,
    y2: 24
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 32,
    x2: 24,
    y2: 32
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 40,
    x2: 32,
    y2: 40
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 48,
    x2: 24,
    y2: 48
  }));
}

/* harmony default export */ var esm_FileZipIcon = ((/* unused pure expression or super */ null && (FileZipIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/FingernailIcon.js


function FingernailIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12 56v-6.91a43.27 43.27 0 0 1 7.26-24L20 24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44 24 .74 1.11a43.27 43.27 0 0 1 7.26 24V56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44 44-2.74.91a29.19 29.19 0 0 1-18.52 0L20 44V20A12 12 0 0 1 32 8a12 12 0 0 1 12 12z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 36,
    x2: 28,
    y2: 24
  }));
}

/* harmony default export */ var esm_FingernailIcon = ((/* unused pure expression or super */ null && (FingernailIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/FlagIcon.js


function FlagIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "16 32 48 32 36 20 48 8 16 8 16 56"
  }));
}

/* harmony default export */ var esm_FlagIcon = ((/* unused pure expression or super */ null && (FlagIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/FolderIcon.js


function FolderIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polygon", {
    points: "28 20 24 12 8 12 8 20 8 52 56 52 56 20 28 20"
  }));
}

/* harmony default export */ var esm_FolderIcon = ((/* unused pure expression or super */ null && (FolderIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/FolderOpenIcon.js


function FolderOpenIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polygon", {
    points: "28 20 24 12 8 12 8 20 8 52 56 52 56 20 28 20"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 56,
    y1: 28,
    x2: 8,
    y2: 28
  }));
}

/* harmony default export */ var esm_FolderOpenIcon = ((/* unused pure expression or super */ null && (FolderOpenIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/ForkIcon.js


function ForkIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m40.12 8-5.95 6a8.42 8.42 0 0 0 0 11.91l4 4a8.42 8.42 0 0 0 11.91 0l6-5.95"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 56,
    x2: 47.69,
    y2: 16.31
  }));
}

/* harmony default export */ var esm_ForkIcon = ((/* unused pure expression or super */ null && (ForkIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/Fullscreen1Icon.js


function Fullscreen1Icon(props) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/react.createElement("polyline", {
    points: "20 8 8 8 8 20"
  }), /*#__PURE__*/react.createElement("line", {
    x1: 8,
    y1: 8,
    x2: 24,
    y2: 24
  }), /*#__PURE__*/react.createElement("polyline", {
    points: "56 20 56 8 44 8"
  }), /*#__PURE__*/react.createElement("line", {
    x1: 56,
    y1: 8,
    x2: 40,
    y2: 24
  }), /*#__PURE__*/react.createElement("polyline", {
    points: "44 56 56 56 56 44"
  }), /*#__PURE__*/react.createElement("line", {
    x1: 56,
    y1: 56,
    x2: 40,
    y2: 40
  }), /*#__PURE__*/react.createElement("polyline", {
    points: "8 44 8 56 20 56"
  }), /*#__PURE__*/react.createElement("line", {
    x1: 8,
    y1: 56,
    x2: 24,
    y2: 40
  }));
}

/* harmony default export */ var esm_Fullscreen1Icon = (Fullscreen1Icon);
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/Fullscreen2Icon.js


function Fullscreen2Icon(props) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/react.createElement("polyline", {
    points: "52 40 40 40 40 52"
  }), /*#__PURE__*/react.createElement("line", {
    x1: 40,
    y1: 40,
    x2: 56,
    y2: 56
  }), /*#__PURE__*/react.createElement("polyline", {
    points: "24 52 24 40 12 40"
  }), /*#__PURE__*/react.createElement("line", {
    x1: 24,
    y1: 40,
    x2: 8,
    y2: 56
  }), /*#__PURE__*/react.createElement("polyline", {
    points: "12 24 24 24 24 12"
  }), /*#__PURE__*/react.createElement("line", {
    x1: 24,
    y1: 24,
    x2: 8,
    y2: 8
  }), /*#__PURE__*/react.createElement("polyline", {
    points: "40 12 40 24 52 24"
  }), /*#__PURE__*/react.createElement("line", {
    x1: 40,
    y1: 24,
    x2: 56,
    y2: 8
  }));
}

/* harmony default export */ var esm_Fullscreen2Icon = (Fullscreen2Icon);
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/FullscreenExpandIcon.js


function FullscreenExpandIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "36 48 48 48 48 36"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "28 16 16 16 16 28"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 48,
    height: 48
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 16,
    x2: 28,
    y2: 28
  }), /*#__PURE__*/React.createElement("line", {
    x1: 48,
    y1: 48,
    x2: 36,
    y2: 36
  }));
}

/* harmony default export */ var esm_FullscreenExpandIcon = ((/* unused pure expression or super */ null && (FullscreenExpandIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/FullscreenShrinkIcon.js


function FullscreenShrinkIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "48 36 36 36 36 48"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 48,
    height: 48
  }), /*#__PURE__*/React.createElement("line", {
    x1: 36,
    y1: 36,
    x2: 48,
    y2: 48
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "16 28 28 28 28 16"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 28,
    x2: 16,
    y2: 16
  }));
}

/* harmony default export */ var esm_FullscreenShrinkIcon = ((/* unused pure expression or super */ null && (FullscreenShrinkIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/GhostIcon.js


function GhostIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m56 56-8-4-8 4-8-4-8 4-8-4-8 4V32A24 24 0 0 1 32 8a24 24 0 0 1 24 24z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 28,
    x2: 24,
    y2: 32
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 28,
    x2: 40,
    y2: 32
  }));
}

/* harmony default export */ var esm_GhostIcon = ((/* unused pure expression or super */ null && (GhostIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/GiftIcon.js


function GiftIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M32 20c-6 0-12 0-12-6a6 6 0 0 1 6-6c6 0 6 8 6 12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 20c6 0 12 0 12-6a6 6 0 0 0-6-6c-6 0-6 8-6 12z"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "12 32 12 56 52 56 52 32"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 20,
    width: 48,
    height: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 20,
    x2: 32,
    y2: 56
  }));
}

/* harmony default export */ var esm_GiftIcon = ((/* unused pure expression or super */ null && (GiftIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/GitcoinKudosIcon.js


function GitcoinKudosIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polygon", {
    points: "56 44 56 20 32 8 8 20 8 44 32 56 56 44"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "44 38 44 26 32 20 20 26 20 38 32 44 44 38"
  }));
}

/* harmony default export */ var esm_GitcoinKudosIcon = ((/* unused pure expression or super */ null && (GitcoinKudosIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/GithubIcon.js


function GithubIcon(props) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/react.createElement("path", {
    d: "M20 56a4 4 0 0 0 4-4 8 8 0 0 1 2.35-5.67s-13.69-1.53-16.6-7.41A21.67 21.67 0 0 1 8 29.42 17.23 17.23 0 0 1 11.9 18a15.43 15.43 0 0 1-.77-4.82C11.13 11 11 10 12 8c4.48 0 8 .85 11.37 3.52A39.58 39.58 0 0 1 32 10.7a39.58 39.58 0 0 1 8.63.82C44 8.85 47.52 8 52 8c1 1.95.87 3 .87 5.18A15.43 15.43 0 0 1 52.1 18 17.23 17.23 0 0 1 56 29.42a21.67 21.67 0 0 1-1.75 9.5c-2.91 5.88-16.6 7.41-16.6 7.41A8 8 0 0 1 40 52a4 4 0 0 0 4 4"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M24 50.88c-4 2-6.31-.43-8.75-2S11 46.75 8 48"
  }), /*#__PURE__*/react.createElement("ellipse", {
    cx: 22.81,
    cy: 31.72,
    rx: 3.19,
    ry: 4.82
  }), /*#__PURE__*/react.createElement("ellipse", {
    cx: 41.19,
    cy: 31.72,
    rx: 3.19,
    ry: 4.82
  }));
}

/* harmony default export */ var esm_GithubIcon = (GithubIcon);
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/GlassChampagneIcon.js


function GlassChampagneIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M36 40h-8l-1.74-7A75.87 75.87 0 0 1 24 14.68V8h16v6.68a75.87 75.87 0 0 1-2.26 18.37z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 56,
    x2: 32,
    y2: 40
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 56,
    x2: 40,
    y2: 56
  }));
}

/* harmony default export */ var esm_GlassChampagneIcon = ((/* unused pure expression or super */ null && (GlassChampagneIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/GlassCoctailIcon.js


function GlassCoctailIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polygon", {
    points: "32 40 48 8 16 8 32 40"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 56,
    x2: 44,
    y2: 56
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 40,
    x2: 32,
    y2: 56
  }));
}

/* harmony default export */ var esm_GlassCoctailIcon = ((/* unused pure expression or super */ null && (GlassCoctailIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/GlassJuiceIcon.js


function GlassJuiceIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polygon", {
    points: "44 56 20 56 16 8 48 8 44 56"
  }));
}

/* harmony default export */ var esm_GlassJuiceIcon = ((/* unused pure expression or super */ null && (GlassJuiceIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/GlassWineIcon.js


function GlassWineIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M16 24a33.83 33.83 0 0 1 3.58-15.16L20 8h24l.42.84A33.83 33.83 0 0 1 48 24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 24a16 16 0 0 1-32 0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 56,
    x2: 32,
    y2: 40
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 56,
    x2: 44,
    y2: 56
  }));
}

/* harmony default export */ var esm_GlassWineIcon = ((/* unused pure expression or super */ null && (GlassWineIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/GlobeIcon.js


function GlobeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M52 19.17a39.79 39.79 0 0 1-20 5.33 39.79 39.79 0 0 1-20-5.33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 44.88a40 40 0 0 1 39.92 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 56a40 40 0 0 1 0-48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 8a40 40 0 0 1 0 48"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 24
  }));
}

/* harmony default export */ var esm_GlobeIcon = ((/* unused pure expression or super */ null && (GlobeIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/Graph1Icon.js


function Graph1Icon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("line", {
    x1: 56,
    y1: 56,
    x2: 56,
    y2: 40
  }), /*#__PURE__*/React.createElement("line", {
    x1: 44,
    y1: 56,
    x2: 44,
    y2: 32
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 56,
    x2: 32,
    y2: 24
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 56,
    x2: 20,
    y2: 16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 56,
    x2: 8,
    y2: 8
  }));
}

/* harmony default export */ var esm_Graph1Icon = ((/* unused pure expression or super */ null && (Graph1Icon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/Graph2Icon.js


function Graph2Icon(props) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/react.createElement("line", {
    x1: 8,
    y1: 56,
    x2: 8,
    y2: 40
  }), /*#__PURE__*/react.createElement("line", {
    x1: 20,
    y1: 56,
    x2: 20,
    y2: 32
  }), /*#__PURE__*/react.createElement("line", {
    x1: 32,
    y1: 56,
    x2: 32,
    y2: 24
  }), /*#__PURE__*/react.createElement("line", {
    x1: 44,
    y1: 56,
    x2: 44,
    y2: 16
  }), /*#__PURE__*/react.createElement("line", {
    x1: 56,
    y1: 56,
    x2: 56,
    y2: 8
  }));
}

/* harmony default export */ var esm_Graph2Icon = (Graph2Icon);
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/GroundPlanIcon.js


function GroundPlanIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 48,
    height: 48
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 40,
    x2: 56,
    y2: 40
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 40,
    x2: 24,
    y2: 56
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "32 40 32 20 8 20"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 56,
    y1: 28,
    x2: 32,
    y2: 28
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 8,
    x2: 20,
    y2: 20
  }));
}

/* harmony default export */ var esm_GroundPlanIcon = ((/* unused pure expression or super */ null && (GroundPlanIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/HashIcon.js


function HashIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 8,
    x2: 20,
    y2: 56
  }), /*#__PURE__*/React.createElement("line", {
    x1: 44,
    y1: 8,
    x2: 44,
    y2: 56
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 20,
    x2: 56,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 44,
    x2: 56,
    y2: 44
  }));
}

/* harmony default export */ var esm_HashIcon = ((/* unused pure expression or super */ null && (HashIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/Heart1Icon.js


function Heart1Icon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M44 12c-8 0-9.91 8-12 8s-4-8-12-8c-6.63 0-12 4-12 12 0 12 20 28 24 28s24-16 24-28c0-8-5.37-12-12-12z"
  }));
}

/* harmony default export */ var esm_Heart1Icon = ((/* unused pure expression or super */ null && (Heart1Icon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/Heart2Icon.js


function Heart2Icon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M35.54 15.44 32 19l-3.54-3.53A11.67 11.67 0 0 0 12 31.94l3.54 3.54 8.25 8.25L32 52l8.25-8.25 8.25-8.25 3.5-3.56a11.67 11.67 0 0 0-16.5-16.5z"
  }));
}

/* harmony default export */ var esm_Heart2Icon = ((/* unused pure expression or super */ null && (Heart2Icon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/HexagonSpiderWebIcon.js


function HexagonSpiderWebIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polygon", {
    points: "20 54 8 32 20 10 44 10 56 32 44 54 20 54"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 32,
    x2: 44,
    y2: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 32,
    x2: 56,
    y2: 32
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 32,
    x2: 44,
    y2: 54
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 32,
    x2: 20,
    y2: 54
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 32,
    x2: 8,
    y2: 32
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 32,
    x2: 20,
    y2: 10
  }));
}

/* harmony default export */ var esm_HexagonSpiderWebIcon = ((/* unused pure expression or super */ null && (HexagonSpiderWebIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/HomeIcon.js


function HomeIcon(props) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/react.createElement("polygon", {
    points: "8 24 8 56 56 56 56 24 32 8 8 24"
  }), /*#__PURE__*/react.createElement("polyline", {
    points: "40 56 40 36 24 36 24 56"
  }));
}

/* harmony default export */ var esm_HomeIcon = (HomeIcon);
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/ImageIcon.js


function ImageIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M8 44h8c8 0 16-8 24-8s8 8 16 8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 48,
    height: 48
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 6
  }));
}

/* harmony default export */ var esm_ImageIcon = ((/* unused pure expression or super */ null && (ImageIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/ImportIcon.js


function ImportIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "16 32 32 48 48 32"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 56,
    y1: 56,
    x2: 8,
    y2: 56
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 8,
    x2: 32,
    y2: 48
  }));
}

/* harmony default export */ var esm_ImportIcon = ((/* unused pure expression or super */ null && (ImportIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/InvisibleIcon.js


function InvisibleIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M56 32s-8 16-24 16S8 32 8 32s8-16 24-16 24 16 24 16z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 52,
    y1: 12,
    x2: 12,
    y2: 52
  }), /*#__PURE__*/React.createElement("line", {
    x1: 52,
    y1: 52,
    x2: 12,
    y2: 12
  }));
}

/* harmony default export */ var esm_InvisibleIcon = ((/* unused pure expression or super */ null && (InvisibleIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/KeyIcon.js


function KeyIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 32,
    r: 12
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "56 44 56 32 32 32"
  }));
}

/* harmony default export */ var esm_KeyIcon = ((/* unused pure expression or super */ null && (KeyIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/KeypairIcon.js


function KeypairIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 44,
    r: 12
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "56 56 56 44 32 44"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 12
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "56 32 56 20 32 20"
  }));
}

/* harmony default export */ var esm_KeypairIcon = ((/* unused pure expression or super */ null && (KeypairIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/KnowledgeIcon.js


function KnowledgeIcon(props) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/react.createElement("polygon", {
    points: "32 36 8 24 32 12 56 24 32 36"
  }), /*#__PURE__*/react.createElement("polyline", {
    points: "48 28 48 52 16 52 16 28"
  }), /*#__PURE__*/react.createElement("line", {
    x1: 56,
    y1: 24,
    x2: 56,
    y2: 44
  }));
}

/* harmony default export */ var esm_KnowledgeIcon = (KnowledgeIcon);
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/Layers2Icon.js


function Layers2Icon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polygon", {
    points: "56 24 32 36 8 24 32 12 56 24"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "40 32 56 40 32 52 8 40 24 32"
  }));
}

/* harmony default export */ var esm_Layers2Icon = ((/* unused pure expression or super */ null && (Layers2Icon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/Layers3Icon.js


function Layers3Icon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polygon", {
    points: "32 40 16 32 32 24 48 32 32 40"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "32 24 16 16 32 8 48 16 32 24"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "32 56 16 48 32 40 48 48 32 56"
  }));
}

/* harmony default export */ var esm_Layers3Icon = ((/* unused pure expression or super */ null && (Layers3Icon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/LifebeltIcon.js


function LifebeltIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 48.97,
    y1: 48.97,
    x2: 37.66,
    y2: 37.66
  }), /*#__PURE__*/React.createElement("line", {
    x1: 26.34,
    y1: 26.34,
    x2: 15.03,
    y2: 15.03
  }), /*#__PURE__*/React.createElement("line", {
    x1: 37.66,
    y1: 26.34,
    x2: 48.97,
    y2: 15.03
  }), /*#__PURE__*/React.createElement("line", {
    x1: 26.34,
    y1: 37.66,
    x2: 15.03,
    y2: 48.97
  }));
}

/* harmony default export */ var esm_LifebeltIcon = ((/* unused pure expression or super */ null && (LifebeltIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/Link1Icon.js


function Link1Icon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M28 44h-8A12 12 0 0 1 8 32a12 12 0 0 1 12-12h8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 20h8a12 12 0 0 1 12 12 12 12 0 0 1-12 12h-8"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 32,
    x2: 44,
    y2: 32
  }));
}

/* harmony default export */ var esm_Link1Icon = ((/* unused pure expression or super */ null && (Link1Icon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/Link2Icon.js


function Link2Icon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M24 44h-4A12 12 0 0 1 8 32a12 12 0 0 1 12-12h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 20h4a12 12 0 0 1 12 12 12 12 0 0 1-12 12h-4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 16,
    x2: 32,
    y2: 48
  }));
}

/* harmony default export */ var esm_Link2Icon = ((/* unused pure expression or super */ null && (Link2Icon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/LinkedinIcon.js


function LinkedinIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("line", {
    x1: 53,
    y1: 56,
    x2: 53,
    y2: 32
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23,
    y1: 56,
    x2: 23,
    y2: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 32c0-6.63 6.72-12 15-12s15 5.37 15 12"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11,
    y1: 8,
    x2: 11,
    y2: 14
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11,
    y1: 20,
    x2: 11,
    y2: 56
  }));
}

/* harmony default export */ var esm_LinkedinIcon = ((/* unused pure expression or super */ null && (LinkedinIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/ListIcon.js


function ListIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 16,
    x2: 56,
    y2: 16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 32,
    x2: 56,
    y2: 32
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 48,
    x2: 56,
    y2: 48
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 16,
    x2: 12,
    y2: 16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 32,
    x2: 12,
    y2: 32
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 48,
    x2: 12,
    y2: 48
  }));
}

/* harmony default export */ var esm_ListIcon = ((/* unused pure expression or super */ null && (ListIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/LocationIcon.js


function LocationIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12 27.2C12 46.4 32 56 32 56s20-9.6 20-28.8C52 16.6 43.05 8 32 8s-20 8.6-20 19.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 26.88,
    r: 6.88
  }));
}

/* harmony default export */ var esm_LocationIcon = ((/* unused pure expression or super */ null && (LocationIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/LockCheckedIcon.js


function LockCheckedIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M20 28v-8a12 12 0 0 1 24 0v8H16a4 4 0 0 0-4 4v20a4 4 0 0 0 4 4h32a4 4 0 0 0 4-4V40"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "56 28 32 48 24 40"
  }));
}

/* harmony default export */ var esm_LockCheckedIcon = ((/* unused pure expression or super */ null && (LockCheckedIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/LockLockedIcon.js


function LockLockedIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 28,
    width: 40,
    height: 28,
    rx: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 48,
    x2: 32,
    y2: 36
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 28v-8a12 12 0 0 1 24 0v8"
  }));
}

/* harmony default export */ var esm_LockLockedIcon = ((/* unused pure expression or super */ null && (LockLockedIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/LockUnlockedIcon.js


function LockUnlockedIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 28,
    width: 40,
    height: 28,
    rx: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 48,
    x2: 32,
    y2: 36
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 28v-8a12 12 0 0 1 20.49-8.49"
  }));
}

/* harmony default export */ var esm_LockUnlockedIcon = ((/* unused pure expression or super */ null && (LockUnlockedIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/LoopIcon.js


function LoopIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "56 32 48 40 40 32"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "32 56 24 48 32 40"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "8 32 16 24 24 32"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "32 8 40 16 32 24"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 16,
    x2: 16,
    y2: 16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 24,
    x2: 16,
    y2: 48
  }), /*#__PURE__*/React.createElement("line", {
    x1: 48,
    y1: 48,
    x2: 24,
    y2: 48
  }), /*#__PURE__*/React.createElement("line", {
    x1: 48,
    y1: 40,
    x2: 48,
    y2: 16
  }));
}

/* harmony default export */ var esm_LoopIcon = ((/* unused pure expression or super */ null && (LoopIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/Loop1Icon.js


function Loop1Icon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M15 15a24 24 0 1 0 17-7"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "15.03 24 15.03 15.03 8 15.03"
  }));
}

/* harmony default export */ var esm_Loop1Icon = ((/* unused pure expression or super */ null && (Loop1Icon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/Loop2Icon.js


function Loop2Icon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M15 49A24 24 0 0 1 32 8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49 15a24 24 0 0 1-17 41"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "15.03 40 15.03 48.97 8 48.97"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "48.97 24 48.97 15.03 56 15.03"
  }));
}

/* harmony default export */ var esm_Loop2Icon = ((/* unused pure expression or super */ null && (Loop2Icon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/MagnetIcon.js


function MagnetIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M56 8H40v24a8 8 0 0 1-8 8 8 8 0 0 1-8-8V8H8v24a24 24 0 0 0 24 24 24 24 0 0 0 24-24z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 56,
    y1: 20,
    x2: 40,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 20,
    x2: 8,
    y2: 20
  }));
}

/* harmony default export */ var esm_MagnetIcon = ((/* unused pure expression or super */ null && (MagnetIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/Magnet2Icon.js


function Magnet2Icon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M52 8H40v28a8 8 0 0 1-8 8 8 8 0 0 1-8-8V8H12v28a20 20 0 0 0 20 20 20 20 0 0 0 20-20z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 20,
    x2: 12,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 20,
    x2: 52,
    y2: 20
  }));
}

/* harmony default export */ var esm_Magnet2Icon = ((/* unused pure expression or super */ null && (Magnet2Icon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/MapIcon.js


function MapIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polygon", {
    points: "24 56 40 52 56 56 56 12 40 8 24 12 8 8 8 52 24 56"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 12,
    x2: 24,
    y2: 56
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 8,
    x2: 40,
    y2: 52
  }));
}

/* harmony default export */ var esm_MapIcon = ((/* unused pure expression or super */ null && (MapIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/MarkerIcon.js


function MarkerIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polygon", {
    points: "52 12 12 28 28 36 36 52 52 12"
  }));
}

/* harmony default export */ var esm_MarkerIcon = ((/* unused pure expression or super */ null && (MarkerIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/MenIcon.js


function MenIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("line", {
    x1: 56,
    y1: 8,
    x2: 35.31,
    y2: 28.69
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 40,
    r: 16
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "40 8 56 8 56 24"
  }));
}

/* harmony default export */ var esm_MenIcon = ((/* unused pure expression or super */ null && (MenIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/MenuIcon.js


function MenuIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 32,
    x2: 48,
    y2: 32
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 20,
    x2: 48,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 44,
    x2: 48,
    y2: 44
  }));
}

/* harmony default export */ var esm_MenuIcon = ((/* unused pure expression or super */ null && (MenuIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/Menu2Icon.js


function Menu2Icon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 48,
    height: 48
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 24,
    x2: 44,
    y2: 24
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 40,
    x2: 44,
    y2: 40
  }));
}

/* harmony default export */ var esm_Menu2Icon = ((/* unused pure expression or super */ null && (Menu2Icon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/MenuCircleIcon.js


function MenuCircleIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.5,
    y: 31.5,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 31.5,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 31.5,
    width: 1,
    height: 1
  }));
}

/* harmony default export */ var esm_MenuCircleIcon = ((/* unused pure expression or super */ null && (MenuCircleIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/MenuHorizontalIcon.js


function MenuHorizontalIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: 31.5,
    y: 31.5,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 31.5,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 31.5,
    width: 1,
    height: 1
  }));
}

/* harmony default export */ var esm_MenuHorizontalIcon = ((/* unused pure expression or super */ null && (MenuHorizontalIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/MenuVerticalIcon.js


function MenuVerticalIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: 31.5,
    y: 31.5,
    width: 1,
    height: 1,
    transform: "rotate(90 32 32)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.5,
    y: 47,
    width: 1,
    height: 1,
    transform: "rotate(90 32 47.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.5,
    y: 16,
    width: 1,
    height: 1,
    transform: "rotate(90 32 16.5)"
  }));
}

/* harmony default export */ var esm_MenuVerticalIcon = ((/* unused pure expression or super */ null && (MenuVerticalIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/ModelIcon.js


function ModelIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 40,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 40,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 8,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "48 40 48 32 16 32 16 40"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 32,
    x2: 32,
    y2: 24
  }));
}

/* harmony default export */ var esm_ModelIcon = ((/* unused pure expression or super */ null && (ModelIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/ModelConnectionIcon.js


function ModelConnectionIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M24 20v4c0 12 16 4 16 16v4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 44,
    width: 32,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 32,
    height: 12
  }));
}

/* harmony default export */ var esm_ModelConnectionIcon = ((/* unused pure expression or super */ null && (ModelConnectionIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/MouseIcon.js


function MouseIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 8,
    width: 32,
    height: 48,
    rx: 16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 16,
    x2: 32,
    y2: 28
  }));
}

/* harmony default export */ var esm_MouseIcon = ((/* unused pure expression or super */ null && (MouseIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/NetworkIcon.js


function NetworkIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 48,
    height: 36
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 56,
    x2: 52,
    y2: 56
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 44,
    x2: 40,
    y2: 56
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 44,
    x2: 24,
    y2: 56
  }));
}

/* harmony default export */ var esm_NetworkIcon = ((/* unused pure expression or super */ null && (NetworkIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/NetworkConnectedIcon.js


function NetworkConnectedIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 48,
    height: 36
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 56,
    x2: 52,
    y2: 56
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 44,
    x2: 40,
    y2: 56
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 44,
    x2: 24,
    y2: 56
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "46 16 26 36 18 28"
  }));
}

/* harmony default export */ var esm_NetworkConnectedIcon = ((/* unused pure expression or super */ null && (NetworkConnectedIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/NetworkDisconnectedIcon.js


function NetworkDisconnectedIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 48,
    height: 36
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 56,
    x2: 52,
    y2: 56
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 44,
    x2: 40,
    y2: 56
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 44,
    x2: 24,
    y2: 56
  }), /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 16,
    x2: 42,
    y2: 36
  }), /*#__PURE__*/React.createElement("line", {
    x1: 42,
    y1: 16,
    x2: 22,
    y2: 36
  }));
}

/* harmony default export */ var esm_NetworkDisconnectedIcon = ((/* unused pure expression or super */ null && (NetworkDisconnectedIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/NightIcon.js


function NightIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M46 44a26 26 0 0 1-24.94-33.36 24 24 0 1 0 32.3 32.3A26.24 26.24 0 0 1 46 44z"
  }));
}

/* harmony default export */ var esm_NightIcon = ((/* unused pure expression or super */ null && (NightIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/PaperclipIcon.js


function PaperclipIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M54.35 31.22 32.94 50.75a13.65 13.65 0 0 1-19.3-19.3l21.41-19.53a9.1 9.1 0 0 1 12.87 12.87L26.51 44.31a4.55 4.55 0 0 1-6.43-6.43l21.45-19.57"
  }));
}

/* harmony default export */ var esm_PaperclipIcon = ((/* unused pure expression or super */ null && (PaperclipIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/PaperplaneIcon.js


function PaperplaneIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("line", {
    x1: 56,
    y1: 8,
    x2: 28,
    y2: 36
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "28 36 40 56 56 8 8 24 28 36"
  }));
}

/* harmony default export */ var esm_PaperplaneIcon = ((/* unused pure expression or super */ null && (PaperplaneIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/PeaceIcon.js


function PeaceIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 24
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 8,
    x2: 32,
    y2: 56
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 32,
    x2: 15.05,
    y2: 48.95
  }), /*#__PURE__*/React.createElement("line", {
    x1: 48.97,
    y1: 48.97,
    x2: 32,
    y2: 32
  }));
}

/* harmony default export */ var esm_PeaceIcon = ((/* unused pure expression or super */ null && (PeaceIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/PhoneCableIcon.js


function PhoneCableIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M53.26 54.62a4.09 4.09 0 0 0 2.51-5.22l-1.36-3.87A4.1 4.1 0 0 0 49.18 43c-7.73 2.71-10.45-5-11.81-8.88S33.3 22.55 41 19.83a4.1 4.1 0 0 0 2.51-5.22l-1.36-3.87A4.1 4.1 0 0 0 37 8.23c-9.66 3.4-14.1 9.3-7.31 28.63S43.6 58 53.26 54.62z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.81 48.18A4 4 0 0 0 32 52a4 4 0 0 1-8 0 4 4 0 0 0-8 0 4 4 0 0 1-8 0"
  }));
}

/* harmony default export */ var esm_PhoneCableIcon = ((/* unused pure expression or super */ null && (PhoneCableIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/PhoneChatIcon.js


function PhoneChatIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 8,
    width: 28,
    height: 48,
    rx: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 16,
    x2: 36,
    y2: 16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 24,
    x2: 28,
    y2: 24
  }), /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 40,
    x2: 40,
    y2: 40
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 32,
    x2: 32,
    y2: 32
  }), /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 48,
    x2: 24,
    y2: 48
  }));
}

/* harmony default export */ var esm_PhoneChatIcon = ((/* unused pure expression or super */ null && (PhoneChatIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/PhoneChatBubblesIcon.js


function PhoneChatBubblesIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 8,
    width: 28,
    height: 48,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 28h-7l-4 2V17a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 48h7l4 2V37a1 1 0 0 0-1-1H29a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1z"
  }));
}

/* harmony default export */ var esm_PhoneChatBubblesIcon = ((/* unused pure expression or super */ null && (PhoneChatBubblesIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/PhoneClassicIcon.js


function PhoneClassicIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M8 25a4 4 0 0 0 4 4h8a4 4 0 0 0 4-4c0-4 4-4 8-4s8 0 8 4a4 4 0 0 0 4 4h8a4 4 0 0 0 4-4c0-10-4-14-24-14S8 15 8 25z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 37,
    r: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16 29-3.91 11.73A9.32 9.32 0 0 0 20.94 53h22.12a9.32 9.32 0 0 0 8.85-12.27L48 29"
  }));
}

/* harmony default export */ var esm_PhoneClassicIcon = ((/* unused pure expression or super */ null && (PhoneClassicIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/PhoneHandIcon.js


function PhoneHandIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M14.87 32a17.67 17.67 0 0 1 0-25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 26.87a10.41 10.41 0 0 1 0-14.71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28 30-5.43 5.43a8.77 8.77 0 0 0-2.57 6.2V52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 56h9a3 3 0 0 0 3-3V19a3 3 0 0 0-3-3H31a3 3 0 0 0-3 3v19.33a2 2 0 0 0 3.42 1.42l4.46-4.45a3.23 3.23 0 0 1 4.41-.24 3.12 3.12 0 0 1 .12 4.53l-3.29 3.29a9.83 9.83 0 0 0-2.88 7 6.25 6.25 0 0 1-6.24 6.2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 39,
    y1: 52,
    x2: 41,
    y2: 52
  }), /*#__PURE__*/React.createElement("line", {
    x1: 36,
    y1: 20,
    x2: 44,
    y2: 20
  }));
}

/* harmony default export */ var esm_PhoneHandIcon = ((/* unused pure expression or super */ null && (PhoneHandIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/PhoneKeysIcon.js


function PhoneKeysIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M50.19 20.6a3.33 3.33 0 0 0-4.62.8l-1.9 2.71a3.31 3.31 0 0 0 .8 4.61c5.41 3.81 1.59 9.22-.31 11.93S38.44 48.76 33 45a3.31 3.31 0 0 0-4.61.8l-1.91 2.7a3.31 3.31 0 0 0 .8 4.61C34.07 57.83 40 58 49.57 44.46s7.43-19.09.62-23.86z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 8,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 8,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 20,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 20,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 32,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 32,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 32,
    width: 6,
    height: 6
  }));
}

/* harmony default export */ var esm_PhoneKeysIcon = ((/* unused pure expression or super */ null && (PhoneKeysIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/PhoneMobileIcon.js


function PhoneMobileIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 8,
    width: 28,
    height: 48,
    rx: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 12,
    x2: 36,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 30,
    y1: 52,
    x2: 34,
    y2: 52
  }));
}

/* harmony default export */ var esm_PhoneMobileIcon = ((/* unused pure expression or super */ null && (PhoneMobileIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/PhoneMobileKeysIcon.js


function PhoneMobileKeysIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 8,
    width: 32,
    height: 48,
    rx: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 48,
    x2: 26,
    y2: 48
  }), /*#__PURE__*/React.createElement("line", {
    x1: 38,
    y1: 48,
    x2: 40,
    y2: 48
  }), /*#__PURE__*/React.createElement("line", {
    x1: 31,
    y1: 48,
    x2: 33,
    y2: 48
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 40,
    x2: 26,
    y2: 40
  }), /*#__PURE__*/React.createElement("line", {
    x1: 38,
    y1: 40,
    x2: 40,
    y2: 40
  }), /*#__PURE__*/React.createElement("line", {
    x1: 31,
    y1: 40,
    x2: 33,
    y2: 40
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 32,
    x2: 26,
    y2: 32
  }), /*#__PURE__*/React.createElement("line", {
    x1: 38,
    y1: 32,
    x2: 40,
    y2: 32
  }), /*#__PURE__*/React.createElement("line", {
    x1: 31,
    y1: 32,
    x2: 33,
    y2: 32
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 24,
    x2: 48,
    y2: 24
  }));
}

/* harmony default export */ var esm_PhoneMobileKeysIcon = ((/* unused pure expression or super */ null && (PhoneMobileKeysIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/PhoneMobileRingIcon.js


function PhoneMobileRingIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M49 15a24 24 0 0 1 0 34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42 22a14.15 14.15 0 0 1 0 20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 28,
    height: 48,
    rx: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 12,
    x2: 26,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 52,
    x2: 24,
    y2: 52
  }));
}

/* harmony default export */ var esm_PhoneMobileRingIcon = ((/* unused pure expression or super */ null && (PhoneMobileRingIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/PhoneMobileUserIcon.js


function PhoneMobileUserIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 8,
    width: 28,
    height: 48,
    rx: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 12,
    x2: 36,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 30,
    y1: 52,
    x2: 34,
    y2: 52
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 32,
    cy: 29.35,
    rx: 3.98,
    ry: 5.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.67 32.48s-3.34.89-4 2.65a10.88 10.88 0 0 0-.62 4.87H40a10.88 10.88 0 0 0-.64-4.82c-.64-1.76-4-2.65-4-2.65"
  }));
}

/* harmony default export */ var esm_PhoneMobileUserIcon = ((/* unused pure expression or super */ null && (PhoneMobileUserIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/PhoneNumpadIcon.js


function PhoneNumpadIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 51,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 32,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 13,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 51,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 32,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 13,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 51,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 5
  }));
}

/* harmony default export */ var esm_PhoneNumpadIcon = ((/* unused pure expression or super */ null && (PhoneNumpadIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/PhoneOfficeIcon.js


function PhoneOfficeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 16,
    height: 48,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 12h28a4 4 0 0 1 4 4v32a4 4 0 0 1-4 4H24"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 44,
    x2: 34,
    y2: 44
  }), /*#__PURE__*/React.createElement("line", {
    x1: 46,
    y1: 44,
    x2: 48,
    y2: 44
  }), /*#__PURE__*/React.createElement("line", {
    x1: 39,
    y1: 44,
    x2: 41,
    y2: 44
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 36,
    x2: 34,
    y2: 36
  }), /*#__PURE__*/React.createElement("line", {
    x1: 46,
    y1: 36,
    x2: 48,
    y2: 36
  }), /*#__PURE__*/React.createElement("line", {
    x1: 39,
    y1: 36,
    x2: 41,
    y2: 36
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 28,
    x2: 34,
    y2: 28
  }), /*#__PURE__*/React.createElement("line", {
    x1: 46,
    y1: 28,
    x2: 48,
    y2: 28
  }), /*#__PURE__*/React.createElement("line", {
    x1: 39,
    y1: 28,
    x2: 41,
    y2: 28
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "48 12 48 20 32 20 32 12"
  }));
}

/* harmony default export */ var esm_PhoneOfficeIcon = ((/* unused pure expression or super */ null && (PhoneOfficeIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/PhoneRingIcon.js


function PhoneRingIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M24 56a4 4 0 0 0 4-4v-4a4 4 0 0 0-4-4c-8 0-8-8-8-12s0-12 8-12a4 4 0 0 0 4-4v-4a4 4 0 0 0-4-4C14 8 8 12 8 32s6 24 16 24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4 52a27.33 27.33 0 0 0 0-38.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.67 44.27a16.38 16.38 0 0 0 0-23.17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 36.55a5.47 5.47 0 0 0 0-7.73"
  }));
}

/* harmony default export */ var esm_PhoneRingIcon = ((/* unused pure expression or super */ null && (PhoneRingIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/PhoneVideoPcIcon.js


function PhoneVideoPcIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 9,
    width: 48,
    height: 39,
    rx: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 40,
    x2: 56,
    y2: 40
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 32,
    cy: 23.97,
    rx: 5.98,
    ry: 7.97
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 39.9a16.29 16.29 0 0 0-1-7.24c-1-2.65-6-4-6-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 28.68s-5 1.33-6 4a16.29 16.29 0 0 0-1 7.24"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 30,
    y1: 44,
    x2: 34,
    y2: 44
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 56c-4-4-4-8-4-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 48s0 4-4 8"
  }));
}

/* harmony default export */ var esm_PhoneVideoPcIcon = ((/* unused pure expression or super */ null && (PhoneVideoPcIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/PieIcon.js


function PieIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M8 47.17v-24l24-12 24 12v24a53.69 53.69 0 0 1-48 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 23.17a53.69 53.69 0 0 1-48 0"
  }));
}

/* harmony default export */ var esm_PieIcon = ((/* unused pure expression or super */ null && (PieIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/PieChartIcon.js


function PieChartIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 24
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 8,
    x2: 32,
    y2: 32
  }), /*#__PURE__*/React.createElement("line", {
    x1: 56,
    y1: 32,
    x2: 32,
    y2: 32
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15.03,
    y1: 48.97,
    x2: 32,
    y2: 32
  }));
}

/* harmony default export */ var esm_PieChartIcon = ((/* unused pure expression or super */ null && (PieChartIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/PinIcon.js


function PinIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 56,
    x2: 24,
    y2: 40
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52 28 4-4-4-4-8-8-4-4-4 4a5.66 5.66 0 0 0 0 8l-8 8a11.31 11.31 0 0 0-16 0l23.94 24.12L36 52a11.36 11.36 0 0 0 0-16l8-8a5.66 5.66 0 0 0 8 0z"
  }));
}

/* harmony default export */ var esm_PinIcon = ((/* unused pure expression or super */ null && (PinIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/PintrestIcon.js


function PintrestIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M17.6 56s19.2-28.8 14.78-36.32c-2.12-3.61-10-2.08-4.91 15.64 3.82 13.35 23.73 5.31 23.73-8.12a19.2 19.2 0 1 0-32.78 13.58"
  }));
}

/* harmony default export */ var esm_PintrestIcon = ((/* unused pure expression or super */ null && (PintrestIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/PlayIcon.js


function PlayIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 24
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "28 40 36 32 28 24"
  }));
}

/* harmony default export */ var esm_PlayIcon = ((/* unused pure expression or super */ null && (PlayIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/PlayVideoIcon.js


function PlayVideoIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 12,
    width: 48,
    height: 40,
    rx: 11.96
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "28 40 36 32 28 24"
  }));
}

/* harmony default export */ var esm_PlayVideoIcon = ((/* unused pure expression or super */ null && (PlayVideoIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/PowerIcon.js


function PowerIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M49 15a24 24 0 1 1-34 0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 8,
    x2: 32,
    y2: 32
  }));
}

/* harmony default export */ var esm_PowerIcon = ((/* unused pure expression or super */ null && (PowerIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/PrintIcon.js


function PrintIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 32,
    width: 32,
    height: 24
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 48,
    x2: 40,
    y2: 48
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 40,
    x2: 40,
    y2: 40
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "20 16 20 8 44 8 44 16"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "16 40 8 40 8 16 56 16 56 40 48 40"
  }));
}

/* harmony default export */ var esm_PrintIcon = ((/* unused pure expression or super */ null && (PrintIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/ProductsIcon.js


function ProductsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 12,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 8,
    width: 12,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 44,
    width: 12,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 8,
    width: 12,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 26,
    width: 12,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 26,
    width: 12,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 26,
    width: 12,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 44,
    width: 12,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 44,
    width: 12,
    height: 12
  }));
}

/* harmony default export */ var esm_ProductsIcon = ((/* unused pure expression or super */ null && (ProductsIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/PuzzleIcon.js


function PuzzleIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M48 28V12H36c0 2.21 4 8-4 8s-4-5.79-4-8H16v16c-2.21 0-8-4-8 4s5.79 4 8 4v16h12c0-2.21-4-8 4-8s4 5.79 4 8h12V36c2.21 0 8 4 8-4s-5.79-4-8-4z"
  }));
}

/* harmony default export */ var esm_PuzzleIcon = ((/* unused pure expression or super */ null && (PuzzleIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/QrcodeIcon.js


function QrcodeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "16 56 8 56 8 48"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "56 48 56 56 48 56"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "48 8 56 8 56 16"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "8 16 8 8 16 8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16,
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 24,
    width: 16,
    height: 16
  }));
}

/* harmony default export */ var esm_QrcodeIcon = ((/* unused pure expression or super */ null && (QrcodeIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/RadiobuttonIcon.js


function RadiobuttonIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 8
  }));
}

/* harmony default export */ var esm_RadiobuttonIcon = ((/* unused pure expression or super */ null && (RadiobuttonIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/Record1Icon.js


function Record1Icon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M49 40a24 24 0 0 1-34 0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 56,
    x2: 44,
    y2: 56
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 48,
    x2: 32,
    y2: 56
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 32a8 8 0 0 1-16 0V16a8 8 0 0 1 16 0z"
  }));
}

/* harmony default export */ var esm_Record1Icon = ((/* unused pure expression or super */ null && (Record1Icon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/Record2Icon.js


function Record2Icon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 32,
    r: 8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 32,
    r: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 40,
    x2: 48,
    y2: 40
  }));
}

/* harmony default export */ var esm_Record2Icon = ((/* unused pure expression or super */ null && (Record2Icon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/Remove1Icon.js


function Remove1Icon(props) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/react.createElement("line", {
    x1: 20,
    y1: 32,
    x2: 44,
    y2: 32
  }), /*#__PURE__*/react.createElement("rect", {
    x: 8,
    y: 8,
    width: 48,
    height: 48
  }));
}

/* harmony default export */ var esm_Remove1Icon = (Remove1Icon);
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/Remove2Icon.js


function Remove2Icon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 24
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 32,
    x2: 44,
    y2: 32
  }));
}

/* harmony default export */ var esm_Remove2Icon = ((/* unused pure expression or super */ null && (Remove2Icon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/RhombusNumberIcon.js


function RhombusNumberIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 8,
    x2: 24,
    y2: 56
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 8,
    x2: 40,
    y2: 56
  }), /*#__PURE__*/React.createElement("line", {
    x1: 56,
    y1: 24,
    x2: 8,
    y2: 24
  }), /*#__PURE__*/React.createElement("line", {
    x1: 56,
    y1: 40,
    x2: 8,
    y2: 40
  }));
}

/* harmony default export */ var esm_RhombusNumberIcon = ((/* unused pure expression or super */ null && (RhombusNumberIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/RulerIcon.js


function RulerIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: 9.37,
    y: 20.69,
    width: 45.25,
    height: 22.63,
    transform: "rotate(-45 32.002 31.994)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 32,
    x2: 20,
    y2: 36
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 24,
    x2: 28,
    y2: 28
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 16,
    x2: 36,
    y2: 20
  }));
}

/* harmony default export */ var esm_RulerIcon = ((/* unused pure expression or super */ null && (RulerIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/SandglassIcon.js


function SandglassIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M46 8v8c0 8.84-6.27 16-14 16s-14-7.16-14-16V8"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 8,
    x2: 52,
    y2: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 56v-8c0-8.84 6.27-16 14-16s14 7.16 14 16v8"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 52,
    y1: 56,
    x2: 12,
    y2: 56
  }));
}

/* harmony default export */ var esm_SandglassIcon = ((/* unused pure expression or super */ null && (SandglassIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/Sandglass2Icon.js


function Sandglass2Icon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M44 56c0-7.55.44-14.67-5.6-19.2l-12.8-9.6C19.56 22.67 20 15.55 20 8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 8c0 7.55.44 14.67-5.6 19.2l-12.8 9.6C19.56 41.33 20 48.45 20 56"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 8,
    x2: 52,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 52,
    y1: 56,
    x2: 12,
    y2: 56
  }));
}

/* harmony default export */ var esm_Sandglass2Icon = ((/* unused pure expression or super */ null && (Sandglass2Icon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/SaveIcon.js


function SaveIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 48,
    height: 48
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "48 8 48 28 16 28 16 8"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "24 56 24 44 40 44 40 56"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 44,
    x2: 32,
    y2: 56
  }));
}

/* harmony default export */ var esm_SaveIcon = ((/* unused pure expression or super */ null && (SaveIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/SearchIcon.js


function SearchIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 56,
    y1: 56,
    x2: 42.14,
    y2: 42.14
  }));
}

/* harmony default export */ var esm_SearchIcon = ((/* unused pure expression or super */ null && (SearchIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/Search1Icon.js


function Search1Icon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 56,
    y1: 56,
    x2: 35.31,
    y2: 35.31
  }));
}

/* harmony default export */ var esm_Search1Icon = ((/* unused pure expression or super */ null && (Search1Icon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/Search2Icon.js


function Search2Icon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 44,
    y1: 44,
    x2: 33.66,
    y2: 33.66
  }));
}

/* harmony default export */ var esm_Search2Icon = ((/* unused pure expression or super */ null && (Search2Icon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/Search3Icon.js


function Search3Icon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 56,
    x2: 32,
    y2: 40
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 24,
    r: 16
  }));
}

/* harmony default export */ var esm_Search3Icon = ((/* unused pure expression or super */ null && (Search3Icon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/SequenceIcon.js


function SequenceIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "56 24 48 32 32 16"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "40 56 32 48 48 32"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "8 40 16 32 32 48"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "24 8 32 16 16 32"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16,
    width: 32,
    height: 32
  }));
}

/* harmony default export */ var esm_SequenceIcon = ((/* unused pure expression or super */ null && (SequenceIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/SettingsIcon.js


function SettingsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M56 32a23.74 23.74 0 0 0-.32-3.89L48 25.37 51.5 18a24.41 24.41 0 0 0-5.5-5.5L38.63 16l-2.74-7.68a23.8 23.8 0 0 0-7.78 0L25.37 16 18 12.5a24.41 24.41 0 0 0-5.5 5.5l3.5 7.37-7.68 2.74a23.8 23.8 0 0 0 0 7.78L16 38.63 12.5 46a24.41 24.41 0 0 0 5.5 5.5l7.37-3.5 2.74 7.68a23.8 23.8 0 0 0 7.78 0L38.63 48 46 51.5a24.41 24.41 0 0 0 5.5-5.5L48 38.63l7.68-2.74A23.74 23.74 0 0 0 56 32z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 4
  }));
}

/* harmony default export */ var esm_SettingsIcon = ((/* unused pure expression or super */ null && (SettingsIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/ShirtIcon.js


function ShirtIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M44 12.09c3.92 1.62 12 12 12 12l-8 8-4-4v24H20v-24l-4 4-8-8s8.08-10.38 12-12c.92-.39 4 0 4 0 0 4 4 8 8 8s8-4 8-8c0 0 3.08-.39 4 0z"
  }));
}

/* harmony default export */ var esm_ShirtIcon = ((/* unused pure expression or super */ null && (ShirtIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/SignIcon.js


function SignIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 32,
    x2: 28,
    y2: 56
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "44 32 8 32 8 8 44 8 56 20 44 32"
  }));
}

/* harmony default export */ var esm_SignIcon = ((/* unused pure expression or super */ null && (SignIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/Sign2Icon.js


function Sign2Icon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "32 40 16 40 8 32 16 24 32 24"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "32 56 32 8 48 8 56 16 48 24 32 24"
  }));
}

/* harmony default export */ var esm_Sign2Icon = ((/* unused pure expression or super */ null && (Sign2Icon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/SkypeIcon.js


function SkypeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M53.85 34.55A21.55 21.55 0 0 0 54 32a22 22 0 0 0-22-22 21.55 21.55 0 0 0-2.55.15 14 14 0 0 0-19.3 19.3A21.55 21.55 0 0 0 10 32a22 22 0 0 0 22 22 21.55 21.55 0 0 0 2.55-.15 14 14 0 0 0 19.3-19.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 26c0-2 0-6-8-6-4 0-8 0-8 6 0 10 16 2 16 12 0 6-4 6-8 6-8 0-8-4-8-6"
  }));
}

/* harmony default export */ var esm_SkypeIcon = ((/* unused pure expression or super */ null && (SkypeIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/SlidersIcon.js


function SlidersIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 8,
    x2: 16,
    y2: 56
  }), /*#__PURE__*/React.createElement("line", {
    x1: 48,
    y1: 8,
    x2: 48,
    y2: 56
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 8,
    x2: 32,
    y2: 56
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 48,
    x2: 24,
    y2: 48
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 20,
    x2: 40,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 40,
    x2: 56,
    y2: 40
  }));
}

/* harmony default export */ var esm_SlidersIcon = ((/* unused pure expression or super */ null && (SlidersIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/Spinner1Icon.js


function Spinner1Icon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 8,
    x2: 32,
    y2: 16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 56,
    x2: 32,
    y2: 48
  }), /*#__PURE__*/React.createElement("line", {
    x1: 56,
    y1: 32,
    x2: 48,
    y2: 32
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 32,
    x2: 16,
    y2: 32
  }), /*#__PURE__*/React.createElement("line", {
    x1: 48.97,
    y1: 15.03,
    x2: 43.31,
    y2: 20.69
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15.03,
    y1: 48.97,
    x2: 20.69,
    y2: 43.31
  }), /*#__PURE__*/React.createElement("line", {
    x1: 48.97,
    y1: 48.97,
    x2: 43.31,
    y2: 43.31
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15.03,
    y1: 15.03,
    x2: 20.69,
    y2: 20.69
  }));
}

/* harmony default export */ var esm_Spinner1Icon = ((/* unused pure expression or super */ null && (Spinner1Icon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/Spinner2Icon.js


function Spinner2Icon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 8,
    x2: 32,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 56,
    x2: 32,
    y2: 44
  }), /*#__PURE__*/React.createElement("line", {
    x1: 56,
    y1: 32,
    x2: 44,
    y2: 32
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 32,
    x2: 20,
    y2: 32
  }), /*#__PURE__*/React.createElement("line", {
    x1: 48.97,
    y1: 15.03,
    x2: 40.49,
    y2: 23.51
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15.03,
    y1: 48.97,
    x2: 23.51,
    y2: 40.49
  }), /*#__PURE__*/React.createElement("line", {
    x1: 48.97,
    y1: 48.97,
    x2: 40.49,
    y2: 40.49
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15.03,
    y1: 15.03,
    x2: 23.51,
    y2: 23.51
  }));
}

/* harmony default export */ var esm_Spinner2Icon = ((/* unused pure expression or super */ null && (Spinner2Icon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/StairsIcon.js


function StairsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "48 48 28 48 28 40 48 40"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "48 40 32 40 32 32 48 32"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "48 32 36 32 36 24 48 24"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "24 56 24 48 48 48"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 8,
    width: 32,
    height: 48
  }));
}

/* harmony default export */ var esm_StairsIcon = ((/* unused pure expression or super */ null && (StairsIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/StarIcon.js


function StarIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polygon", {
    points: "32 12 38.41 24.84 52 27.28 42.37 37.66 44.36 52 32 45.58 19.64 52 21.63 37.66 12 27.28 25.59 24.84 32 12"
  }));
}

/* harmony default export */ var esm_StarIcon = ((/* unused pure expression or super */ null && (StarIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/SteeringWheelIcon.js


function SteeringWheelIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 8,
    x2: 32,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 56,
    x2: 32,
    y2: 44
  }), /*#__PURE__*/React.createElement("line", {
    x1: 56,
    y1: 32,
    x2: 44,
    y2: 32
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 32,
    x2: 20,
    y2: 32
  }), /*#__PURE__*/React.createElement("line", {
    x1: 48.97,
    y1: 15.03,
    x2: 40.49,
    y2: 23.51
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15.03,
    y1: 48.97,
    x2: 23.51,
    y2: 40.49
  }), /*#__PURE__*/React.createElement("line", {
    x1: 48.97,
    y1: 48.97,
    x2: 40.49,
    y2: 40.49
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15.03,
    y1: 15.03,
    x2: 23.51,
    y2: 23.51
  }));
}

/* harmony default export */ var esm_SteeringWheelIcon = ((/* unused pure expression or super */ null && (SteeringWheelIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/SunIcon.js


function SunIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 8,
    x2: 32,
    y2: 16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 56,
    x2: 32,
    y2: 48
  }), /*#__PURE__*/React.createElement("line", {
    x1: 56,
    y1: 32,
    x2: 48,
    y2: 32
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 32,
    x2: 16,
    y2: 32
  }), /*#__PURE__*/React.createElement("line", {
    x1: 48.97,
    y1: 15.03,
    x2: 43.31,
    y2: 20.69
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15.03,
    y1: 48.97,
    x2: 20.69,
    y2: 43.31
  }), /*#__PURE__*/React.createElement("line", {
    x1: 48.97,
    y1: 48.97,
    x2: 43.31,
    y2: 43.31
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15.03,
    y1: 15.03,
    x2: 20.69,
    y2: 20.69
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 8
  }));
}

/* harmony default export */ var esm_SunIcon = ((/* unused pure expression or super */ null && (SunIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/SwitchIcon.js


function SwitchIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "48 12 56 20 48 28"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "48 36 56 44 48 52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 20H40c-12 0-12 24-24 24H8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 20h8c12 0 12 24 24 24h16"
  }));
}

/* harmony default export */ var esm_SwitchIcon = ((/* unused pure expression or super */ null && (SwitchIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/TagIcon.js


function TagIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polygon", {
    points: "36 8 8 36 28 56 56 28 56 8 36 8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 20,
    r: 4
  }));
}

/* harmony default export */ var esm_TagIcon = ((/* unused pure expression or super */ null && (TagIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/TargetIcon.js


function TargetIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 8
  }));
}

/* harmony default export */ var esm_TargetIcon = ((/* unused pure expression or super */ null && (TargetIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/TargetCrossIcon.js


function TargetCrossIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 24
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 8,
    x2: 32,
    y2: 16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 48,
    x2: 32,
    y2: 56
  }), /*#__PURE__*/React.createElement("line", {
    x1: 56,
    y1: 32,
    x2: 48,
    y2: 32
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 32,
    x2: 16,
    y2: 32
  }));
}

/* harmony default export */ var esm_TargetCrossIcon = ((/* unused pure expression or super */ null && (TargetCrossIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/TargetCrossSmallIcon.js


function TargetCrossSmallIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 8,
    x2: 32,
    y2: 24
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 40,
    x2: 32,
    y2: 56
  }), /*#__PURE__*/React.createElement("line", {
    x1: 56,
    y1: 32,
    x2: 40,
    y2: 32
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 32,
    x2: 24,
    y2: 32
  }));
}

/* harmony default export */ var esm_TargetCrossSmallIcon = ((/* unused pure expression or super */ null && (TargetCrossSmallIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/TelegramIcon.js


function TelegramIcon(props) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/react.createElement("line", {
    x1: 40,
    y1: 28,
    x2: 27.88,
    y2: 41.92
  }), /*#__PURE__*/react.createElement("polygon", {
    points: "48 56 56 8 8 28 48 56"
  }));
}

/* harmony default export */ var esm_TelegramIcon = (TelegramIcon);
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/TextfileIcon.js


function TextfileIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 8,
    width: 40,
    height: 48
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 32,
    x2: 44,
    y2: 32
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 20,
    x2: 44,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 44,
    x2: 44,
    y2: 44
  }));
}

/* harmony default export */ var esm_TextfileIcon = ((/* unused pure expression or super */ null && (TextfileIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/TimeIcon.js


function TimeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 24
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "40 44 32 32 32 16"
  }));
}

/* harmony default export */ var esm_TimeIcon = ((/* unused pure expression or super */ null && (TimeIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/TireIcon.js


function TireIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 24,
    x2: 56,
    y2: 24
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 40,
    x2: 56,
    y2: 40
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 40,
    x2: 40,
    y2: 56
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 40,
    x2: 24,
    y2: 56
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 40,
    x2: 8,
    y2: 40
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 24,
    x2: 8,
    y2: 24
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 24,
    x2: 24,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 24,
    x2: 40,
    y2: 8
  }));
}

/* harmony default export */ var esm_TireIcon = ((/* unused pure expression or super */ null && (TireIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/ToggleIcon.js


function ToggleIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 20,
    width: 48,
    height: 24,
    rx: 12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 32,
    r: 8
  }));
}

/* harmony default export */ var esm_ToggleIcon = ((/* unused pure expression or super */ null && (ToggleIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/TokenIcon.js


function TokenIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 24
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 14,
    x2: 32,
    y2: 18.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 50,
    x2: 32,
    y2: 45.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 32,
    x2: 45.5,
    y2: 32
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 32,
    x2: 18.5,
    y2: 32
  }), /*#__PURE__*/React.createElement("line", {
    x1: 44.73,
    y1: 19.27,
    x2: 41.55,
    y2: 22.45
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19.27,
    y1: 44.73,
    x2: 22.45,
    y2: 41.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 44.73,
    y1: 44.73,
    x2: 41.55,
    y2: 41.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19.27,
    y1: 19.27,
    x2: 22.45,
    y2: 22.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 8
  }));
}

/* harmony default export */ var esm_TokenIcon = ((/* unused pure expression or super */ null && (TokenIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/ToolkitIcon.js


function ToolkitIcon(props) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/react.createElement("rect", {
    x: 8,
    y: 20,
    width: 48,
    height: 32
  }), /*#__PURE__*/react.createElement("line", {
    x1: 8,
    y1: 32,
    x2: 56,
    y2: 32
  }), /*#__PURE__*/react.createElement("line", {
    x1: 32,
    y1: 28,
    x2: 32,
    y2: 36
  }), /*#__PURE__*/react.createElement("path", {
    d: "m20 20 2.89-5.78a4 4 0 0 1 3.6-2.22h11a4 4 0 0 1 3.6 2.22L44 20"
  }));
}

/* harmony default export */ var esm_ToolkitIcon = (ToolkitIcon);
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/TrashIcon.js


function TrashIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "52 16 48 56 16 56 12 16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 16v-3.94A4.06 4.06 0 0 1 24.06 8h15.88A4.06 4.06 0 0 1 44 12.06V16"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 16,
    x2: 56,
    y2: 16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 28,
    x2: 40,
    y2: 44
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 28,
    x2: 24,
    y2: 44
  }));
}

/* harmony default export */ var esm_TrashIcon = ((/* unused pure expression or super */ null && (TrashIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/TwitterIcon.js


function TwitterIcon(props) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/react.createElement("path", {
    d: "M56 16.46a67.49 67.49 0 0 0-8.11-.73 9.75 9.75 0 0 0-16.56 8.91c-8.08-.41-14.2-4.56-19.92-10.73-.78 1.52-2.26 6.37-1.11 9.87a19.1 19.1 0 0 0 6.75 8.59 26.05 26.05 0 0 1-8.52-1.85c1.41 4.63 6.25 11.35 13.86 12.4a19.46 19.46 0 0 1-12.07 4.19A19.66 19.66 0 0 1 8 47a27.42 27.42 0 0 0 14.9 4.39c17.87 0 27.65-14.89 27.65-27.81v-1.27z"
  }));
}

/* harmony default export */ var esm_TwitterIcon = (TwitterIcon);
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/UmbrellaIcon.js


function UmbrellaIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M56 32H8c0-11 10.75-20 24-20s24 9 24 20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 52a4 4 0 0 1-8 0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 32,
    x2: 32,
    y2: 52
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 8,
    x2: 32,
    y2: 12
  }));
}

/* harmony default export */ var esm_UmbrellaIcon = ((/* unused pure expression or super */ null && (UmbrellaIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/UnlinkIcon.js


function UnlinkIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M24 44h-4A12 12 0 0 1 8 32a12 12 0 0 1 12-12h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 20h4a12 12 0 0 1 12 12 12 12 0 0 1-12 12h-4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 12,
    x2: 20,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 12,
    x2: 44,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 52,
    x2: 20,
    y2: 56
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 52,
    x2: 44,
    y2: 56
  }));
}

/* harmony default export */ var esm_UnlinkIcon = ((/* unused pure expression or super */ null && (UnlinkIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/UsbIcon.js


function UsbIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "56 56 56 40 8 40 8 56"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "52 40 52 8 12 8 12 40"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 20,
    width: 8,
    height: 8
  }));
}

/* harmony default export */ var esm_UsbIcon = ((/* unused pure expression or super */ null && (UsbIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/UserIcon.js


function UserIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("ellipse", {
    cx: 32,
    cy: 24,
    rx: 12,
    ry: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 33.46s-10.09 2.68-12 8A33 33 0 0 0 8 56h48a33 33 0 0 0-1.94-14.54c-1.93-5.32-12-8-12-8"
  }));
}

/* harmony default export */ var esm_UserIcon = ((/* unused pure expression or super */ null && (UserIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/UserAddIcon.js


function UserAddIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("ellipse", {
    cx: 32,
    cy: 24,
    rx: 12,
    ry: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 33.46s-10.09 2.68-12 8A33 33 0 0 0 8 56h24"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 48,
    y1: 56,
    x2: 48,
    y2: 40
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 48,
    x2: 56,
    y2: 48
  }));
}

/* harmony default export */ var esm_UserAddIcon = ((/* unused pure expression or super */ null && (UserAddIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/ViewGridIcon.js


function ViewGridIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 8,
    x2: 32,
    y2: 56
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 32,
    x2: 56,
    y2: 32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 48,
    height: 48
  }));
}

/* harmony default export */ var esm_ViewGridIcon = ((/* unused pure expression or super */ null && (ViewGridIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/ViewListIcon.js


function ViewListIcon(props) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/react.createElement("line", {
    x1: 16,
    y1: 20,
    x2: 48,
    y2: 20
  }), /*#__PURE__*/react.createElement("line", {
    x1: 16,
    y1: 44,
    x2: 48,
    y2: 44
  }), /*#__PURE__*/react.createElement("line", {
    x1: 48,
    y1: 32,
    x2: 16,
    y2: 32
  }), /*#__PURE__*/react.createElement("rect", {
    x: 8,
    y: 8,
    width: 48,
    height: 48
  }));
}

/* harmony default export */ var esm_ViewListIcon = (ViewListIcon);
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/VisibleIcon.js


function VisibleIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 32s-8 16-24 16S8 32 8 32s8-16 24-16 24 16 24 16z"
  }));
}

/* harmony default export */ var esm_VisibleIcon = ((/* unused pure expression or super */ null && (VisibleIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/WarningIcon.js


function WarningIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 24
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 16,
    x2: 32,
    y2: 36
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 44,
    x2: 32,
    y2: 48
  }));
}

/* harmony default export */ var esm_WarningIcon = ((/* unused pure expression or super */ null && (WarningIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/WifiIcon.js


function WifiIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M8 24c12-12 36-12 48 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 36c8-8 24-8 32 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 48c4-4 12-4 16 0"
  }));
}

/* harmony default export */ var esm_WifiIcon = ((/* unused pure expression or super */ null && (WifiIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/Wifi2Icon.js


function Wifi2Icon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M8 8a48 48 0 0 1 48 48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 24a32 32 0 0 1 32 32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 40a16 16 0 0 1 16 16"
  }));
}

/* harmony default export */ var esm_Wifi2Icon = ((/* unused pure expression or super */ null && (Wifi2Icon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/WindowsLayersIcon.js


function WindowsLayersIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "20 44 8 44 8 8 36 8 36 28"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 28,
    width: 36,
    height: 28
  }));
}

/* harmony default export */ var esm_WindowsLayersIcon = ((/* unused pure expression or super */ null && (WindowsLayersIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/WomanIcon.js


function WomanIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 56,
    x2: 28.69,
    y2: 35.31
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 24,
    r: 16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 52,
    x2: 12,
    y2: 36
  }));
}

/* harmony default export */ var esm_WomanIcon = ((/* unused pure expression or super */ null && (WomanIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/Woman2Icon.js


function Woman2Icon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 22,
    r: 14
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 36,
    x2: 32,
    y2: 60
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 48,
    x2: 24,
    y2: 48
  }));
}

/* harmony default export */ var esm_Woman2Icon = ((/* unused pure expression or super */ null && (Woman2Icon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/WrenchIcon.js


function WrenchIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m55.52 18.37-3.35 3.36a7 7 0 1 1-9.9-9.9l3.36-3.36A14.51 14.51 0 0 0 42 8a14 14 0 0 0-13.19 18.7L10.34 42.34a8 8 0 0 0 11.32 11.32L37.3 35.19a14 14 0 0 0 18.22-16.82z"
  }));
}

/* harmony default export */ var esm_WrenchIcon = ((/* unused pure expression or super */ null && (WrenchIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/YoutubeIcon.js


function YoutubeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M55.16 20.42A5.94 5.94 0 0 0 50 15.6c-6-.38-12-.69-18-.7s-12 .3-18 .68a5.94 5.94 0 0 0-5.17 4.82 79.25 79.25 0 0 0 0 22.88 6.17 6.17 0 0 0 5.19 5c6 .38 12 .77 18 .77s12-.34 18-.73a6.24 6.24 0 0 0 5.18-5.1 78.19 78.19 0 0 0 .8-11.38 78 78 0 0 0-.84-11.42z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "26.56 38.73 26.56 24.79 39.55 31.76 26.56 38.73"
  }));
}

/* harmony default export */ var esm_YoutubeIcon = ((/* unused pure expression or super */ null && (YoutubeIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/ZoomInIcon.js


function ZoomInIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 56,
    y1: 56,
    x2: 42.14,
    y2: 42.14
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 28,
    x2: 40,
    y2: 28
  }), /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 16,
    x2: 28,
    y2: 40
  }));
}

/* harmony default export */ var esm_ZoomInIcon = ((/* unused pure expression or super */ null && (ZoomInIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/ZoomOutIcon.js


function ZoomOutIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 56,
    y1: 56,
    x2: 42.14,
    y2: 42.14
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 28,
    x2: 40,
    y2: 28
  }));
}

/* harmony default export */ var esm_ZoomOutIcon = ((/* unused pure expression or super */ null && (ZoomOutIcon)));
;// CONCATENATED MODULE: ./node_modules/@fusion-icons/react/interface/esm/index.js










































































































































































































































































































/***/ }),

/***/ 45791:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(87919);

/***/ }),

/***/ 43234:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(80562);
var settle = __webpack_require__(50469);
var cookies = __webpack_require__(49477);
var buildURL = __webpack_require__(59695);
var buildFullPath = __webpack_require__(46490);
var parseHeaders = __webpack_require__(79485);
var isURLSameOrigin = __webpack_require__(20953);
var transitionalDefaults = __webpack_require__(6315);
var AxiosError = __webpack_require__(54532);
var CanceledError = __webpack_require__(41683);
var parseProtocol = __webpack_require__(92945);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;
    var responseType = config.responseType;
    var onCanceled;
    function done() {
      if (config.cancelToken) {
        config.cancelToken.unsubscribe(onCanceled);
      }

      if (config.signal) {
        config.signal.removeEventListener('abort', onCanceled);
      }
    }

    if (utils.isFormData(requestData) && utils.isStandardBrowserEnv()) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);

    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !responseType || responseType === 'text' ||  responseType === 'json' ?
        request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(function _resolve(value) {
        resolve(value);
        done();
      }, function _reject(err) {
        reject(err);
        done();
      }, response);

      // Clean up request
      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(new AxiosError('Request aborted', AxiosError.ECONNABORTED, config, request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(new AxiosError('Network Error', AxiosError.ERR_NETWORK, config, request, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = config.timeout ? 'timeout of ' + config.timeout + 'ms exceeded' : 'timeout exceeded';
      var transitional = config.transitional || transitionalDefaults;
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(new AxiosError(
        timeoutErrorMessage,
        transitional.clarifyTimeoutError ? AxiosError.ETIMEDOUT : AxiosError.ECONNABORTED,
        config,
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
      request.responseType = config.responseType;
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken || config.signal) {
      // Handle cancellation
      // eslint-disable-next-line func-names
      onCanceled = function(cancel) {
        if (!request) {
          return;
        }
        reject(!cancel || (cancel && cancel.type) ? new CanceledError() : cancel);
        request.abort();
        request = null;
      };

      config.cancelToken && config.cancelToken.subscribe(onCanceled);
      if (config.signal) {
        config.signal.aborted ? onCanceled() : config.signal.addEventListener('abort', onCanceled);
      }
    }

    if (!requestData) {
      requestData = null;
    }

    var protocol = parseProtocol(fullPath);

    if (protocol && [ 'http', 'https', 'file' ].indexOf(protocol) === -1) {
      reject(new AxiosError('Unsupported protocol ' + protocol + ':', AxiosError.ERR_BAD_REQUEST, config));
      return;
    }


    // Send the request
    request.send(requestData);
  });
};


/***/ }),

/***/ 87919:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(80562);
var bind = __webpack_require__(76220);
var Axios = __webpack_require__(2234);
var mergeConfig = __webpack_require__(63438);
var defaults = __webpack_require__(41423);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  // Factory for creating new instances
  instance.create = function create(instanceConfig) {
    return createInstance(mergeConfig(defaultConfig, instanceConfig));
  };

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Expose Cancel & CancelToken
axios.CanceledError = __webpack_require__(41683);
axios.CancelToken = __webpack_require__(74175);
axios.isCancel = __webpack_require__(68848);
axios.VERSION = (__webpack_require__(38477).version);
axios.toFormData = __webpack_require__(20282);

// Expose AxiosError class
axios.AxiosError = __webpack_require__(54532);

// alias for CanceledError for backward compatibility
axios.Cancel = axios.CanceledError;

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(48785);

// Expose isAxiosError
axios.isAxiosError = __webpack_require__(9119);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports["default"] = axios;


/***/ }),

/***/ 74175:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var CanceledError = __webpack_require__(41683);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;

  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;

  // eslint-disable-next-line func-names
  this.promise.then(function(cancel) {
    if (!token._listeners) return;

    var i;
    var l = token._listeners.length;

    for (i = 0; i < l; i++) {
      token._listeners[i](cancel);
    }
    token._listeners = null;
  });

  // eslint-disable-next-line func-names
  this.promise.then = function(onfulfilled) {
    var _resolve;
    // eslint-disable-next-line func-names
    var promise = new Promise(function(resolve) {
      token.subscribe(resolve);
      _resolve = resolve;
    }).then(onfulfilled);

    promise.cancel = function reject() {
      token.unsubscribe(_resolve);
    };

    return promise;
  };

  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new CanceledError(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `CanceledError` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Subscribe to the cancel signal
 */

CancelToken.prototype.subscribe = function subscribe(listener) {
  if (this.reason) {
    listener(this.reason);
    return;
  }

  if (this._listeners) {
    this._listeners.push(listener);
  } else {
    this._listeners = [listener];
  }
};

/**
 * Unsubscribe from the cancel signal
 */

CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
  if (!this._listeners) {
    return;
  }
  var index = this._listeners.indexOf(listener);
  if (index !== -1) {
    this._listeners.splice(index, 1);
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),

/***/ 41683:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var AxiosError = __webpack_require__(54532);
var utils = __webpack_require__(80562);

/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function CanceledError(message) {
  // eslint-disable-next-line no-eq-null,eqeqeq
  AxiosError.call(this, message == null ? 'canceled' : message, AxiosError.ERR_CANCELED);
  this.name = 'CanceledError';
}

utils.inherits(CanceledError, AxiosError, {
  __CANCEL__: true
});

module.exports = CanceledError;


/***/ }),

/***/ 68848:
/***/ (function(module) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),

/***/ 2234:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(80562);
var buildURL = __webpack_require__(59695);
var InterceptorManager = __webpack_require__(31790);
var dispatchRequest = __webpack_require__(65354);
var mergeConfig = __webpack_require__(63438);
var buildFullPath = __webpack_require__(46490);
var validator = __webpack_require__(98908);

var validators = validator.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(configOrUrl, config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof configOrUrl === 'string') {
    config = config || {};
    config.url = configOrUrl;
  } else {
    config = configOrUrl || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  var transitional = config.transitional;

  if (transitional !== undefined) {
    validator.assertOptions(transitional, {
      silentJSONParsing: validators.transitional(validators.boolean),
      forcedJSONParsing: validators.transitional(validators.boolean),
      clarifyTimeoutError: validators.transitional(validators.boolean)
    }, false);
  }

  // filter out skipped interceptors
  var requestInterceptorChain = [];
  var synchronousRequestInterceptors = true;
  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
      return;
    }

    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  var responseInterceptorChain = [];
  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
  });

  var promise;

  if (!synchronousRequestInterceptors) {
    var chain = [dispatchRequest, undefined];

    Array.prototype.unshift.apply(chain, requestInterceptorChain);
    chain = chain.concat(responseInterceptorChain);

    promise = Promise.resolve(config);
    while (chain.length) {
      promise = promise.then(chain.shift(), chain.shift());
    }

    return promise;
  }


  var newConfig = config;
  while (requestInterceptorChain.length) {
    var onFulfilled = requestInterceptorChain.shift();
    var onRejected = requestInterceptorChain.shift();
    try {
      newConfig = onFulfilled(newConfig);
    } catch (error) {
      onRejected(error);
      break;
    }
  }

  try {
    promise = dispatchRequest(newConfig);
  } catch (error) {
    return Promise.reject(error);
  }

  while (responseInterceptorChain.length) {
    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  var fullPath = buildFullPath(config.baseURL, config.url);
  return buildURL(fullPath, config.params, config.paramsSerializer);
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: (config || {}).data
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/

  function generateHTTPMethod(isForm) {
    return function httpMethod(url, data, config) {
      return this.request(mergeConfig(config || {}, {
        method: method,
        headers: isForm ? {
          'Content-Type': 'multipart/form-data'
        } : {},
        url: url,
        data: data
      }));
    };
  }

  Axios.prototype[method] = generateHTTPMethod();

  Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});

module.exports = Axios;


/***/ }),

/***/ 54532:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(80562);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
function AxiosError(message, code, config, request, response) {
  Error.call(this);
  this.message = message;
  this.name = 'AxiosError';
  code && (this.code = code);
  config && (this.config = config);
  request && (this.request = request);
  response && (this.response = response);
}

utils.inherits(AxiosError, Error, {
  toJSON: function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});

var prototype = AxiosError.prototype;
var descriptors = {};

[
  'ERR_BAD_OPTION_VALUE',
  'ERR_BAD_OPTION',
  'ECONNABORTED',
  'ETIMEDOUT',
  'ERR_NETWORK',
  'ERR_FR_TOO_MANY_REDIRECTS',
  'ERR_DEPRECATED',
  'ERR_BAD_RESPONSE',
  'ERR_BAD_REQUEST',
  'ERR_CANCELED'
// eslint-disable-next-line func-names
].forEach(function(code) {
  descriptors[code] = {value: code};
});

Object.defineProperties(AxiosError, descriptors);
Object.defineProperty(prototype, 'isAxiosError', {value: true});

// eslint-disable-next-line func-names
AxiosError.from = function(error, code, config, request, response, customProps) {
  var axiosError = Object.create(prototype);

  utils.toFlatObject(error, axiosError, function filter(obj) {
    return obj !== Error.prototype;
  });

  AxiosError.call(axiosError, error.message, code, config, request, response);

  axiosError.name = error.name;

  customProps && Object.assign(axiosError, customProps);

  return axiosError;
};

module.exports = AxiosError;


/***/ }),

/***/ 31790:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(80562);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected,
    synchronous: options ? options.synchronous : false,
    runWhen: options ? options.runWhen : null
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),

/***/ 46490:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(19978);
var combineURLs = __webpack_require__(12867);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),

/***/ 65354:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(80562);
var transformData = __webpack_require__(54615);
var isCancel = __webpack_require__(68848);
var defaults = __webpack_require__(41423);
var CanceledError = __webpack_require__(41683);

/**
 * Throws a `CanceledError` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }

  if (config.signal && config.signal.aborted) {
    throw new CanceledError();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData.call(
    config,
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData.call(
      config,
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),

/***/ 63438:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(80562);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  function getMergedValue(target, source) {
    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
      return utils.merge(target, source);
    } else if (utils.isPlainObject(source)) {
      return utils.merge({}, source);
    } else if (utils.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  // eslint-disable-next-line consistent-return
  function mergeDeepProperties(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function valueFromConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(undefined, config2[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function defaultToConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(undefined, config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function mergeDirectKeys(prop) {
    if (prop in config2) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  var mergeMap = {
    'url': valueFromConfig2,
    'method': valueFromConfig2,
    'data': valueFromConfig2,
    'baseURL': defaultToConfig2,
    'transformRequest': defaultToConfig2,
    'transformResponse': defaultToConfig2,
    'paramsSerializer': defaultToConfig2,
    'timeout': defaultToConfig2,
    'timeoutMessage': defaultToConfig2,
    'withCredentials': defaultToConfig2,
    'adapter': defaultToConfig2,
    'responseType': defaultToConfig2,
    'xsrfCookieName': defaultToConfig2,
    'xsrfHeaderName': defaultToConfig2,
    'onUploadProgress': defaultToConfig2,
    'onDownloadProgress': defaultToConfig2,
    'decompress': defaultToConfig2,
    'maxContentLength': defaultToConfig2,
    'maxBodyLength': defaultToConfig2,
    'beforeRedirect': defaultToConfig2,
    'transport': defaultToConfig2,
    'httpAgent': defaultToConfig2,
    'httpsAgent': defaultToConfig2,
    'cancelToken': defaultToConfig2,
    'socketPath': defaultToConfig2,
    'responseEncoding': defaultToConfig2,
    'validateStatus': mergeDirectKeys
  };

  utils.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
    var merge = mergeMap[prop] || mergeDeepProperties;
    var configValue = merge(prop);
    (utils.isUndefined(configValue) && merge !== mergeDirectKeys) || (config[prop] = configValue);
  });

  return config;
};


/***/ }),

/***/ 50469:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var AxiosError = __webpack_require__(54532);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(new AxiosError(
      'Request failed with status code ' + response.status,
      [AxiosError.ERR_BAD_REQUEST, AxiosError.ERR_BAD_RESPONSE][Math.floor(response.status / 100) - 4],
      response.config,
      response.request,
      response
    ));
  }
};


/***/ }),

/***/ 54615:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(80562);
var defaults = __webpack_require__(41423);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  var context = this || defaults;
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn.call(context, data, headers);
  });

  return data;
};


/***/ }),

/***/ 41423:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(34155);


var utils = __webpack_require__(80562);
var normalizeHeaderName = __webpack_require__(40347);
var AxiosError = __webpack_require__(54532);
var transitionalDefaults = __webpack_require__(6315);
var toFormData = __webpack_require__(20282);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(43234);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(43234);
  }
  return adapter;
}

function stringifySafely(rawValue, parser, encoder) {
  if (utils.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

var defaults = {

  transitional: transitionalDefaults,

  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');

    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }

    var isObjectPayload = utils.isObject(data);
    var contentType = headers && headers['Content-Type'];

    var isFileList;

    if ((isFileList = utils.isFileList(data)) || (isObjectPayload && contentType === 'multipart/form-data')) {
      var _FormData = this.env && this.env.FormData;
      return toFormData(isFileList ? {'files[]': data} : data, _FormData && new _FormData());
    } else if (isObjectPayload || contentType === 'application/json') {
      setContentTypeIfUnset(headers, 'application/json');
      return stringifySafely(data);
    }

    return data;
  }],

  transformResponse: [function transformResponse(data) {
    var transitional = this.transitional || defaults.transitional;
    var silentJSONParsing = transitional && transitional.silentJSONParsing;
    var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';

    if (strictJSONParsing || (forcedJSONParsing && utils.isString(data) && data.length)) {
      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw AxiosError.from(e, AxiosError.ERR_BAD_RESPONSE, this, null, this.response);
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  env: {
    FormData: __webpack_require__(47487)
  },

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },

  headers: {
    common: {
      'Accept': 'application/json, text/plain, */*'
    }
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;


/***/ }),

/***/ 6315:
/***/ (function(module) {

"use strict";


module.exports = {
  silentJSONParsing: true,
  forcedJSONParsing: true,
  clarifyTimeoutError: false
};


/***/ }),

/***/ 38477:
/***/ (function(module) {

module.exports = {
  "version": "0.27.2"
};

/***/ }),

/***/ 76220:
/***/ (function(module) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),

/***/ 59695:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(80562);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),

/***/ 12867:
/***/ (function(module) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),

/***/ 49477:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(80562);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),

/***/ 19978:
/***/ (function(module) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
};


/***/ }),

/***/ 9119:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(80562);

/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
module.exports = function isAxiosError(payload) {
  return utils.isObject(payload) && (payload.isAxiosError === true);
};


/***/ }),

/***/ 20953:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(80562);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),

/***/ 40347:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(80562);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),

/***/ 47487:
/***/ (function(module) {

// eslint-disable-next-line strict
module.exports = null;


/***/ }),

/***/ 79485:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(80562);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),

/***/ 92945:
/***/ (function(module) {

"use strict";


module.exports = function parseProtocol(url) {
  var match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
  return match && match[1] || '';
};


/***/ }),

/***/ 48785:
/***/ (function(module) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),

/***/ 20282:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* provided dependency */ var Buffer = __webpack_require__(48764)["Buffer"];


var utils = __webpack_require__(80562);

/**
 * Convert a data object to FormData
 * @param {Object} obj
 * @param {?Object} [formData]
 * @returns {Object}
 **/

function toFormData(obj, formData) {
  // eslint-disable-next-line no-param-reassign
  formData = formData || new FormData();

  var stack = [];

  function convertValue(value) {
    if (value === null) return '';

    if (utils.isDate(value)) {
      return value.toISOString();
    }

    if (utils.isArrayBuffer(value) || utils.isTypedArray(value)) {
      return typeof Blob === 'function' ? new Blob([value]) : Buffer.from(value);
    }

    return value;
  }

  function build(data, parentKey) {
    if (utils.isPlainObject(data) || utils.isArray(data)) {
      if (stack.indexOf(data) !== -1) {
        throw Error('Circular reference detected in ' + parentKey);
      }

      stack.push(data);

      utils.forEach(data, function each(value, key) {
        if (utils.isUndefined(value)) return;
        var fullKey = parentKey ? parentKey + '.' + key : key;
        var arr;

        if (value && !parentKey && typeof value === 'object') {
          if (utils.endsWith(key, '{}')) {
            // eslint-disable-next-line no-param-reassign
            value = JSON.stringify(value);
          } else if (utils.endsWith(key, '[]') && (arr = utils.toArray(value))) {
            // eslint-disable-next-line func-names
            arr.forEach(function(el) {
              !utils.isUndefined(el) && formData.append(fullKey, convertValue(el));
            });
            return;
          }
        }

        build(value, fullKey);
      });

      stack.pop();
    } else {
      formData.append(parentKey, convertValue(data));
    }
  }

  build(obj);

  return formData;
}

module.exports = toFormData;


/***/ }),

/***/ 98908:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var VERSION = (__webpack_require__(38477).version);
var AxiosError = __webpack_require__(54532);

var validators = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach(function(type, i) {
  validators[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

var deprecatedWarnings = {};

/**
 * Transitional option validator
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 * @returns {function}
 */
validators.transitional = function transitional(validator, version, message) {
  function formatMessage(opt, desc) {
    return '[Axios v' + VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return function(value, opt, opts) {
    if (validator === false) {
      throw new AxiosError(
        formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')),
        AxiosError.ERR_DEPRECATED
      );
    }

    if (version && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new AxiosError('options must be an object', AxiosError.ERR_BAD_OPTION_VALUE);
  }
  var keys = Object.keys(options);
  var i = keys.length;
  while (i-- > 0) {
    var opt = keys[i];
    var validator = schema[opt];
    if (validator) {
      var value = options[opt];
      var result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new AxiosError('option ' + opt + ' must be ' + result, AxiosError.ERR_BAD_OPTION_VALUE);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw new AxiosError('Unknown option ' + opt, AxiosError.ERR_BAD_OPTION);
    }
  }
}

module.exports = {
  assertOptions: assertOptions,
  validators: validators
};


/***/ }),

/***/ 80562:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(76220);

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

// eslint-disable-next-line func-names
var kindOf = (function(cache) {
  // eslint-disable-next-line func-names
  return function(thing) {
    var str = toString.call(thing);
    return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
  };
})(Object.create(null));

function kindOfTest(type) {
  type = type.toLowerCase();
  return function isKindOf(thing) {
    return kindOf(thing) === type;
  };
}

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return Array.isArray(val);
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
var isArrayBuffer = kindOfTest('ArrayBuffer');


/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (isArrayBuffer(val.buffer));
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */
function isPlainObject(val) {
  if (kindOf(val) !== 'object') {
    return false;
  }

  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}

/**
 * Determine if a value is a Date
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
var isDate = kindOfTest('Date');

/**
 * Determine if a value is a File
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
var isFile = kindOfTest('File');

/**
 * Determine if a value is a Blob
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
var isBlob = kindOfTest('Blob');

/**
 * Determine if a value is a FileList
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
var isFileList = kindOfTest('FileList');

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} thing The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(thing) {
  var pattern = '[object FormData]';
  return thing && (
    (typeof FormData === 'function' && thing instanceof FormData) ||
    toString.call(thing) === pattern ||
    (isFunction(thing.toString) && thing.toString() === pattern)
  );
}

/**
 * Determine if a value is a URLSearchParams object
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
var isURLSearchParams = kindOfTest('URLSearchParams');

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge({}, val);
    } else if (isArray(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */
function stripBOM(content) {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 */

function inherits(constructor, superConstructor, props, descriptors) {
  constructor.prototype = Object.create(superConstructor.prototype, descriptors);
  constructor.prototype.constructor = constructor;
  props && Object.assign(constructor.prototype, props);
}

/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function} [filter]
 * @returns {Object}
 */

function toFlatObject(sourceObj, destObj, filter) {
  var props;
  var i;
  var prop;
  var merged = {};

  destObj = destObj || {};

  do {
    props = Object.getOwnPropertyNames(sourceObj);
    i = props.length;
    while (i-- > 0) {
      prop = props[i];
      if (!merged[prop]) {
        destObj[prop] = sourceObj[prop];
        merged[prop] = true;
      }
    }
    sourceObj = Object.getPrototypeOf(sourceObj);
  } while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);

  return destObj;
}

/*
 * determines whether a string ends with the characters of a specified string
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 * @returns {boolean}
 */
function endsWith(str, searchString, position) {
  str = String(str);
  if (position === undefined || position > str.length) {
    position = str.length;
  }
  position -= searchString.length;
  var lastIndex = str.indexOf(searchString, position);
  return lastIndex !== -1 && lastIndex === position;
}


/**
 * Returns new array from array like object
 * @param {*} [thing]
 * @returns {Array}
 */
function toArray(thing) {
  if (!thing) return null;
  var i = thing.length;
  if (isUndefined(i)) return null;
  var arr = new Array(i);
  while (i-- > 0) {
    arr[i] = thing[i];
  }
  return arr;
}

// eslint-disable-next-line func-names
var isTypedArray = (function(TypedArray) {
  // eslint-disable-next-line func-names
  return function(thing) {
    return TypedArray && thing instanceof TypedArray;
  };
})(typeof Uint8Array !== 'undefined' && Object.getPrototypeOf(Uint8Array));

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isPlainObject: isPlainObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim,
  stripBOM: stripBOM,
  inherits: inherits,
  toFlatObject: toFlatObject,
  kindOf: kindOf,
  kindOfTest: kindOfTest,
  endsWith: endsWith,
  toArray: toArray,
  isTypedArray: isTypedArray,
  isFileList: isFileList
};


/***/ }),

/***/ 94301:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// the whatwg-fetch polyfill installs the fetch() function
// on the global object (window or self)
//
// Return that as the export for use in Webpack, Browserify etc.
__webpack_require__(66477);
module.exports = self.fetch.bind(self);


/***/ }),

/***/ 85037:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "l8": function() { return /* reexport */ kujiraQueryClient; }
});

// UNUSED EXPORTS: ATOM, CHAIN_INFO, DEMO, Denom, IBC, KUJI, MAINNET, NETWORKS, NETWORK_DEFAULT, POND, RPCS, TESTNET, TRANSFER_CHANNELS, USK, USK_TESTNET, accountParser, aminoTypes, axlUSDC, axlUSDT, axlwAVAX, axlwBNB, axlwETH, axlwFTM, axlwGLMR, axlwMATIC, bigCompare, bow, divToNumber, factor, fetchTokens, fin, fromHumanString, ghost, gravity, kns, local, msg, mulDec, nobleUSDC, orca, parsers, pilot, registry, setSignerAddress, toHuman, usk

// EXTERNAL MODULE: ./node_modules/kujira.js/node_modules/long/src/long.js
var src_long = __webpack_require__(10648);
var long_default = /*#__PURE__*/__webpack_require__.n(src_long);
// EXTERNAL MODULE: ./node_modules/protobufjs/minimal.js
var minimal = __webpack_require__(62100);
// EXTERNAL MODULE: ./node_modules/kujira.js/node_modules/@cosmjs/cosmwasm-stargate/build/index.js
var build = __webpack_require__(40702);
// EXTERNAL MODULE: ./node_modules/kujira.js/node_modules/@cosmjs/stargate/build/index.js
var stargate_build = __webpack_require__(66422);
// EXTERNAL MODULE: ./node_modules/kujira.js/node_modules/@cosmjs/utils/build/index.js
var utils_build = __webpack_require__(62584);
// EXTERNAL MODULE: ./node_modules/kujira.js/node_modules/cosmjs-types/cosmwasm/wasm/v1/authz.js
var authz = __webpack_require__(48451);
;// CONCATENATED MODULE: ./node_modules/kujira.js/lib/esm/amino/authz.js


const grantToAmino = (grant) => {
    var _a, _b, _c;
    console.log({ original: grant });
    const expiration = new Date(Math.floor(((_a = grant.expiration) === null || _a === void 0 ? void 0 : _a.seconds.toNumber()) || 0) * 1000)
        .toISOString()
        .replace(/\.\d+Z/, "Z");
    switch ((_b = grant.authorization) === null || _b === void 0 ? void 0 : _b.typeUrl) {
        case "/cosmwasm.wasm.v1.ContractExecutionAuthorization":
            const contractExecutionAuthorization = ContractExecutionAuthorization.decode(grant.authorization.value);
            const grants = contractExecutionAuthorization.grants.map((g) => ({
                contract: g.contract,
                filter: g.filter && {
                    type: "wasm/AcceptedMessageKeysFilter",
                    value: {
                        keys: AcceptedMessageKeysFilter.decode(g.filter.value).keys,
                    },
                },
                limit: g.limit && {
                    type: "wasm/MaxFundsLimit",
                    value: {
                        amounts: MaxFundsLimit.decode(g.limit.value).amounts,
                    },
                },
            }));
            return {
                expiration,
                authorization: {
                    type: "wasm/ContractExecutionAuthorization",
                    value: { grants },
                },
            };
        default:
            throw new Error(`${(_c = grant.authorization) === null || _c === void 0 ? void 0 : _c.typeUrl} not supported for Ledger`);
    }
};
const grantFromAmino = (grant) => {
    var _a;
    console.log({ amino: grant });
    const expiration = grant.expiration &&
        Long.fromNumber(new Date(grant.expiration).getTime() / 1000);
    switch (grant.authorization.type) {
        case "wasm/ContractExecutionAuthorization":
            console.log(grant.authorization);
            return {
                expiration: expiration ? { seconds: expiration, nanos: 0 } : undefined,
                authorization: {
                    typeUrl: "/cosmwasm.wasm.v1.ContractExecutionAuthorization",
                    value: ContractExecutionAuthorization.encode({
                        grants: grant.authorization.value.grants.map((g) => ({
                            contract: g.contract,
                            filter: {
                                typeUrl: "/cosmwasm.wasm.v1.AcceptedMessageKeysFilter",
                                value: AcceptedMessageKeysFilter.encode({
                                    keys: g.filter.value.keys,
                                }).finish(),
                            },
                            limit: {
                                typeUrl: "/cosmwasm.wasm.v1.MaxFundsLimit",
                                value: MaxFundsLimit.encode({
                                    amounts: g.limit.value.amounts,
                                }).finish(),
                            },
                        })),
                    }).finish(),
                },
            };
        default:
            throw new Error(`${(_a = grant.authorization) === null || _a === void 0 ? void 0 : _a.type} not supported from Ledger`);
    }
};
function authz_createAuthzAminoConverters() {
    return {
        "/cosmos.authz.v1beta1.MsgGrant": {
            aminoType: "cosmos-sdk/MsgGrant",
            toAmino: ({ granter, grantee, grant, }) => ({
                granter: granter,
                grantee: grantee,
                grant: grant && grantToAmino(grant),
            }),
            fromAmino: ({ granter, grantee, grant, }) => {
                console.log({ returned: grant && grantFromAmino(grant) });
                return {
                    granter: granter,
                    grantee: grantee,
                    grant: grant && grantFromAmino(grant),
                };
            },
        },
        "/cosmos.authz.v1beta1.MsgRevoke": {
            aminoType: "cosmos-sdk/MsgRevoke",
            toAmino: ({ granter, grantee, msgTypeUrl, }) => ({
                granter: granter,
                grantee: grantee,
                msgTypeUrl,
            }),
            fromAmino: ({ granter, grantee, msgTypeUrl, }) => ({
                granter: granter,
                grantee: grantee,
                msgTypeUrl,
            }),
        },
    };
}

;// CONCATENATED MODULE: ./node_modules/kujira.js/lib/esm/amino.js





const extra = {
    "/cosmos.staking.v1beta1.MsgCancelUnbondingDelegation": {
        aminoType: "cosmos-sdk/MsgCancelUnbondingDelegation",
        toAmino: ({ delegatorAddress, validatorAddress, amount, creationHeight, }) => {
            (0,utils_build.assertDefinedAndNotNull)(amount, "missing amount");
            return {
                delegator_address: delegatorAddress,
                validator_address: validatorAddress,
                amount: amount,
                creation_height: creationHeight.toString(),
            };
        },
        fromAmino: ({ delegator_address, validator_address, amount, creation_height, }) => ({
            delegatorAddress: delegator_address,
            validatorAddress: validator_address,
            amount: amount,
            creationHeight: long_default().fromString(creation_height),
        }),
    },
};
const aminoTypes = (prefix) => new s.AminoTypes(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, createAuthzAminoConverters()), s.createBankAminoConverters()), s.createDistributionAminoConverters()), s.createFeegrantAminoConverters()), s.createGovAminoConverters()), s.createIbcAminoConverters()), s.createStakingAminoConverters()), s.createVestingAminoConverters()), createWasmAminoConverters()), extra));

// EXTERNAL MODULE: ./node_modules/@ethersproject/bytes/lib.esm/index.js + 1 modules
var lib_esm = __webpack_require__(16441);
// EXTERNAL MODULE: ./node_modules/@ethersproject/logger/lib.esm/index.js + 1 modules
var logger_lib_esm = __webpack_require__(1581);
// EXTERNAL MODULE: ./node_modules/@ethersproject/bignumber/lib.esm/_version.js
var _version = __webpack_require__(48794);
// EXTERNAL MODULE: ./node_modules/@ethersproject/bignumber/lib.esm/bignumber.js
var bignumber = __webpack_require__(2593);
;// CONCATENATED MODULE: ./node_modules/@ethersproject/bignumber/lib.esm/fixednumber.js




const logger = new logger_lib_esm/* Logger */.Yd(_version/* version */.i);

const _constructorGuard = {};
const Zero = bignumber/* BigNumber.from */.O$.from(0);
const NegativeOne = bignumber/* BigNumber.from */.O$.from(-1);
function throwFault(message, fault, operation, value) {
    const params = { fault: fault, operation: operation };
    if (value !== undefined) {
        params.value = value;
    }
    return logger.throwError(message, logger_lib_esm/* Logger.errors.NUMERIC_FAULT */.Yd.errors.NUMERIC_FAULT, params);
}
// Constant to pull zeros from for multipliers
let zeros = "0";
while (zeros.length < 256) {
    zeros += zeros;
}
// Returns a string "1" followed by decimal "0"s
function getMultiplier(decimals) {
    if (typeof (decimals) !== "number") {
        try {
            decimals = bignumber/* BigNumber.from */.O$.from(decimals).toNumber();
        }
        catch (e) { }
    }
    if (typeof (decimals) === "number" && decimals >= 0 && decimals <= 256 && !(decimals % 1)) {
        return ("1" + zeros.substring(0, decimals));
    }
    return logger.throwArgumentError("invalid decimal size", "decimals", decimals);
}
function formatFixed(value, decimals) {
    if (decimals == null) {
        decimals = 0;
    }
    const multiplier = getMultiplier(decimals);
    // Make sure wei is a big number (convert as necessary)
    value = bignumber/* BigNumber.from */.O$.from(value);
    const negative = value.lt(Zero);
    if (negative) {
        value = value.mul(NegativeOne);
    }
    let fraction = value.mod(multiplier).toString();
    while (fraction.length < multiplier.length - 1) {
        fraction = "0" + fraction;
    }
    // Strip training 0
    fraction = fraction.match(/^([0-9]*[1-9]|0)(0*)/)[1];
    const whole = value.div(multiplier).toString();
    if (multiplier.length === 1) {
        value = whole;
    }
    else {
        value = whole + "." + fraction;
    }
    if (negative) {
        value = "-" + value;
    }
    return value;
}
function fixednumber_parseFixed(value, decimals) {
    if (decimals == null) {
        decimals = 0;
    }
    const multiplier = getMultiplier(decimals);
    if (typeof (value) !== "string" || !value.match(/^-?[0-9.]+$/)) {
        logger.throwArgumentError("invalid decimal value", "value", value);
    }
    // Is it negative?
    const negative = (value.substring(0, 1) === "-");
    if (negative) {
        value = value.substring(1);
    }
    if (value === ".") {
        logger.throwArgumentError("missing value", "value", value);
    }
    // Split it into a whole and fractional part
    const comps = value.split(".");
    if (comps.length > 2) {
        logger.throwArgumentError("too many decimal points", "value", value);
    }
    let whole = comps[0], fraction = comps[1];
    if (!whole) {
        whole = "0";
    }
    if (!fraction) {
        fraction = "0";
    }
    // Trim trailing zeros
    while (fraction[fraction.length - 1] === "0") {
        fraction = fraction.substring(0, fraction.length - 1);
    }
    // Check the fraction doesn't exceed our decimals size
    if (fraction.length > multiplier.length - 1) {
        throwFault("fractional component exceeds decimals", "underflow", "parseFixed");
    }
    // If decimals is 0, we have an empty string for fraction
    if (fraction === "") {
        fraction = "0";
    }
    // Fully pad the string with zeros to get to wei
    while (fraction.length < multiplier.length - 1) {
        fraction += "0";
    }
    const wholeValue = bignumber/* BigNumber.from */.O$.from(whole);
    const fractionValue = bignumber/* BigNumber.from */.O$.from(fraction);
    let wei = (wholeValue.mul(multiplier)).add(fractionValue);
    if (negative) {
        wei = wei.mul(NegativeOne);
    }
    return wei;
}
class FixedFormat {
    constructor(constructorGuard, signed, width, decimals) {
        if (constructorGuard !== _constructorGuard) {
            logger.throwError("cannot use FixedFormat constructor; use FixedFormat.from", logger_lib_esm/* Logger.errors.UNSUPPORTED_OPERATION */.Yd.errors.UNSUPPORTED_OPERATION, {
                operation: "new FixedFormat"
            });
        }
        this.signed = signed;
        this.width = width;
        this.decimals = decimals;
        this.name = (signed ? "" : "u") + "fixed" + String(width) + "x" + String(decimals);
        this._multiplier = getMultiplier(decimals);
        Object.freeze(this);
    }
    static from(value) {
        if (value instanceof FixedFormat) {
            return value;
        }
        if (typeof (value) === "number") {
            value = `fixed128x${value}`;
        }
        let signed = true;
        let width = 128;
        let decimals = 18;
        if (typeof (value) === "string") {
            if (value === "fixed") {
                // defaults...
            }
            else if (value === "ufixed") {
                signed = false;
            }
            else {
                const match = value.match(/^(u?)fixed([0-9]+)x([0-9]+)$/);
                if (!match) {
                    logger.throwArgumentError("invalid fixed format", "format", value);
                }
                signed = (match[1] !== "u");
                width = parseInt(match[2]);
                decimals = parseInt(match[3]);
            }
        }
        else if (value) {
            const check = (key, type, defaultValue) => {
                if (value[key] == null) {
                    return defaultValue;
                }
                if (typeof (value[key]) !== type) {
                    logger.throwArgumentError("invalid fixed format (" + key + " not " + type + ")", "format." + key, value[key]);
                }
                return value[key];
            };
            signed = check("signed", "boolean", signed);
            width = check("width", "number", width);
            decimals = check("decimals", "number", decimals);
        }
        if (width % 8) {
            logger.throwArgumentError("invalid fixed format width (not byte aligned)", "format.width", width);
        }
        if (decimals > 80) {
            logger.throwArgumentError("invalid fixed format (decimals too large)", "format.decimals", decimals);
        }
        return new FixedFormat(_constructorGuard, signed, width, decimals);
    }
}
class FixedNumber {
    constructor(constructorGuard, hex, value, format) {
        if (constructorGuard !== _constructorGuard) {
            logger.throwError("cannot use FixedNumber constructor; use FixedNumber.from", logger_lib_esm/* Logger.errors.UNSUPPORTED_OPERATION */.Yd.errors.UNSUPPORTED_OPERATION, {
                operation: "new FixedFormat"
            });
        }
        this.format = format;
        this._hex = hex;
        this._value = value;
        this._isFixedNumber = true;
        Object.freeze(this);
    }
    _checkFormat(other) {
        if (this.format.name !== other.format.name) {
            logger.throwArgumentError("incompatible format; use fixedNumber.toFormat", "other", other);
        }
    }
    addUnsafe(other) {
        this._checkFormat(other);
        const a = fixednumber_parseFixed(this._value, this.format.decimals);
        const b = fixednumber_parseFixed(other._value, other.format.decimals);
        return FixedNumber.fromValue(a.add(b), this.format.decimals, this.format);
    }
    subUnsafe(other) {
        this._checkFormat(other);
        const a = fixednumber_parseFixed(this._value, this.format.decimals);
        const b = fixednumber_parseFixed(other._value, other.format.decimals);
        return FixedNumber.fromValue(a.sub(b), this.format.decimals, this.format);
    }
    mulUnsafe(other) {
        this._checkFormat(other);
        const a = fixednumber_parseFixed(this._value, this.format.decimals);
        const b = fixednumber_parseFixed(other._value, other.format.decimals);
        return FixedNumber.fromValue(a.mul(b).div(this.format._multiplier), this.format.decimals, this.format);
    }
    divUnsafe(other) {
        this._checkFormat(other);
        const a = fixednumber_parseFixed(this._value, this.format.decimals);
        const b = fixednumber_parseFixed(other._value, other.format.decimals);
        return FixedNumber.fromValue(a.mul(this.format._multiplier).div(b), this.format.decimals, this.format);
    }
    floor() {
        const comps = this.toString().split(".");
        if (comps.length === 1) {
            comps.push("0");
        }
        let result = FixedNumber.from(comps[0], this.format);
        const hasFraction = !comps[1].match(/^(0*)$/);
        if (this.isNegative() && hasFraction) {
            result = result.subUnsafe(ONE.toFormat(result.format));
        }
        return result;
    }
    ceiling() {
        const comps = this.toString().split(".");
        if (comps.length === 1) {
            comps.push("0");
        }
        let result = FixedNumber.from(comps[0], this.format);
        const hasFraction = !comps[1].match(/^(0*)$/);
        if (!this.isNegative() && hasFraction) {
            result = result.addUnsafe(ONE.toFormat(result.format));
        }
        return result;
    }
    // @TODO: Support other rounding algorithms
    round(decimals) {
        if (decimals == null) {
            decimals = 0;
        }
        // If we are already in range, we're done
        const comps = this.toString().split(".");
        if (comps.length === 1) {
            comps.push("0");
        }
        if (decimals < 0 || decimals > 80 || (decimals % 1)) {
            logger.throwArgumentError("invalid decimal count", "decimals", decimals);
        }
        if (comps[1].length <= decimals) {
            return this;
        }
        const factor = FixedNumber.from("1" + zeros.substring(0, decimals), this.format);
        const bump = BUMP.toFormat(this.format);
        return this.mulUnsafe(factor).addUnsafe(bump).floor().divUnsafe(factor);
    }
    isZero() {
        return (this._value === "0.0" || this._value === "0");
    }
    isNegative() {
        return (this._value[0] === "-");
    }
    toString() { return this._value; }
    toHexString(width) {
        if (width == null) {
            return this._hex;
        }
        if (width % 8) {
            logger.throwArgumentError("invalid byte width", "width", width);
        }
        const hex = bignumber/* BigNumber.from */.O$.from(this._hex).fromTwos(this.format.width).toTwos(width).toHexString();
        return (0,lib_esm/* hexZeroPad */.$m)(hex, width / 8);
    }
    toUnsafeFloat() { return parseFloat(this.toString()); }
    toFormat(format) {
        return FixedNumber.fromString(this._value, format);
    }
    static fromValue(value, decimals, format) {
        // If decimals looks more like a format, and there is no format, shift the parameters
        if (format == null && decimals != null && !(0,bignumber/* isBigNumberish */.Zm)(decimals)) {
            format = decimals;
            decimals = null;
        }
        if (decimals == null) {
            decimals = 0;
        }
        if (format == null) {
            format = "fixed";
        }
        return FixedNumber.fromString(formatFixed(value, decimals), FixedFormat.from(format));
    }
    static fromString(value, format) {
        if (format == null) {
            format = "fixed";
        }
        const fixedFormat = FixedFormat.from(format);
        const numeric = fixednumber_parseFixed(value, fixedFormat.decimals);
        if (!fixedFormat.signed && numeric.lt(Zero)) {
            throwFault("unsigned value cannot be negative", "overflow", "value", value);
        }
        let hex = null;
        if (fixedFormat.signed) {
            hex = numeric.toTwos(fixedFormat.width).toHexString();
        }
        else {
            hex = numeric.toHexString();
            hex = (0,lib_esm/* hexZeroPad */.$m)(hex, fixedFormat.width / 8);
        }
        const decimal = formatFixed(numeric, fixedFormat.decimals);
        return new FixedNumber(_constructorGuard, hex, decimal, fixedFormat);
    }
    static fromBytes(value, format) {
        if (format == null) {
            format = "fixed";
        }
        const fixedFormat = FixedFormat.from(format);
        if ((0,lib_esm/* arrayify */.lE)(value).length > fixedFormat.width / 8) {
            throw new Error("overflow");
        }
        let numeric = bignumber/* BigNumber.from */.O$.from(value);
        if (fixedFormat.signed) {
            numeric = numeric.fromTwos(fixedFormat.width);
        }
        const hex = numeric.toTwos((fixedFormat.signed ? 0 : 1) + fixedFormat.width).toHexString();
        const decimal = formatFixed(numeric, fixedFormat.decimals);
        return new FixedNumber(_constructorGuard, hex, decimal, fixedFormat);
    }
    static from(value, format) {
        if (typeof (value) === "string") {
            return FixedNumber.fromString(value, format);
        }
        if ((0,lib_esm/* isBytes */._t)(value)) {
            return FixedNumber.fromBytes(value, format);
        }
        try {
            return FixedNumber.fromValue(value, 0, format);
        }
        catch (error) {
            // Allow NUMERIC_FAULT to bubble up
            if (error.code !== logger_lib_esm/* Logger.errors.INVALID_ARGUMENT */.Yd.errors.INVALID_ARGUMENT) {
                throw error;
            }
        }
        return logger.throwArgumentError("invalid FixedNumber value", "value", value);
    }
    static isFixedNumber(value) {
        return !!(value && value._isFixedNumber);
    }
}
const ONE = FixedNumber.from(1);
const BUMP = FixedNumber.from("0.5");
//# sourceMappingURL=fixednumber.js.map
// EXTERNAL MODULE: ./node_modules/kujira.js/node_modules/@cosmjs/crypto/build/index.js
var crypto_build = __webpack_require__(45027);
// EXTERNAL MODULE: ./node_modules/chain-registry/main/index.js
var main = __webpack_require__(42150);
;// CONCATENATED MODULE: ./node_modules/kujira.js/lib/esm/network.js
const network_MAINNET = "kaiyo-1";
const TESTNET = "harpoon-4";
const POND = "pond-1";
const NETWORKS = {
    [TESTNET]: "Testnet",
    [network_MAINNET]: "Mainnet",
    [POND]: "Pond",
};
const RPCS = {
    [TESTNET]: [
        // "https://rpc.harpoon.kujira.setten.io",
        "https://kujira-testnet-rpc.polkachu.com",
        "https://rpc-harpoon-4.starsquid.io",
        "https://test-rpc-kujira.mintthemoon.xyz",
        // "https://dev-rpc-kujira.mintthemoon.xyz",
    ],
    [network_MAINNET]: [
        "https://kujira-mainnet-rpc.autostake.com",
        "https://kujira-rpc.ibs.team",
        "https://kujira-rpc.nodes.defiantlabs.net",
        "https://kujira-rpc.openbitlab.com",
        "https://kujira-rpc.theamsolutions.info",
        "https://kujira.rpc.ghostinnet.com",
        "https://kujira.rpc.kjnodes.com",
        "https://rpc-kujira.capybaralabs.com/",
        "https://rpc-kujira.mintthemoon.xyz",
        "https://rpc-kujira.mms.team",
        "https://rpc-kujira.rorcualnodes.com",
        "https://rpc-kujira.starsquid.io",
        "https://rpc-kujira.synergynodes.com",
        "https://rpc.kujira.rektdao.club",
        "https://rpc-kujira.goldenratiostaking.net",
        // "https://kuji-rpc.kleomedes.network",
        // "https://kujira-rpc.lavenderfive.com",
        // "https://kujira-rpc.polkachu.com",
        // "https://rpc-kujira.whispernode.com",
        // "https://rpc.kaiyo.kujira.setten.io",
    ],
    [POND]: ["http://127.0.0.1:10157"],
    "gravity-bridge-3": [
        "https://gravity-rpc.synergynodes.com",
        "https://gravitybridge.rpc.kjnodes.com",
        "https://gravitybridge-rpc.lavenderfive.com",
    ],
};
const chainInfo = (chainId, chainName, rpc, rest, fees = []) => ({
    chainId,
    chainName,
    rpc,
    rest,
    bip44: {
        coinType: 118,
    },
    bech32Config: {
        bech32PrefixAccAddr: "kujira",
        bech32PrefixAccPub: "kujira" + "pub",
        bech32PrefixValAddr: "kujira" + "valoper",
        bech32PrefixValPub: "kujira" + "valoperpub",
        bech32PrefixConsAddr: "kujira" + "valcons",
        bech32PrefixConsPub: "kujira" + "valconspub",
    },
    currencies: fees,
    feeCurrencies: fees,
    stakeCurrency: {
        coinDenom: "KUJI",
        coinMinimalDenom: "ukuji",
        coinDecimals: 6,
        coinGeckoId: "kujira",
    },
});
const CHAIN_INFO = {
    [TESTNET]: chainInfo(TESTNET, "Kujira Testnet", "https://test-rpc-kujira.mintthemoon.xyz", "https://test-lcd-kujira.mintthemoon.xyz", [
        {
            coinDenom: "KUJI",
            coinMinimalDenom: "ukuji",
            coinDecimals: 6,
            coinGeckoId: "kujira",
            gasPriceStep: { low: 0.0034, average: 0.0051, high: 0.00681 },
        },
        {
            coinDenom: "DEMO",
            coinMinimalDenom: "factory/kujira1ltvwg69sw3c5z99c6rr08hal7v0kdzfxz07yj5/demo",
            coinDecimals: 6,
            coinGeckoId: "kujira",
            gasPriceStep: {
                low: 0.00125,
                average: 0.0025,
                high: 0.00375,
            },
        },
    ]),
    [POND]: chainInfo(POND, "Kujira Pond", "http://127.0.0.1:10157", "http://127.0.0.1:10117", [
        {
            coinDenom: "KUJI",
            coinMinimalDenom: "ukuji",
            coinDecimals: 6,
            coinGeckoId: "kujira",
            gasPriceStep: { low: 0.0034, average: 0.0051, high: 0.00681 },
        },
    ]),
    [network_MAINNET]: chainInfo(network_MAINNET, "Kujira", "https://rpc.cosmos.directory/kujira", "https://rest.cosmos.directory/kujira", [
        {
            coinDenom: "KUJI",
            coinMinimalDenom: "ukuji",
            coinDecimals: 6,
            coinGeckoId: "kujira",
            gasPriceStep: { low: 0.0034, average: 0.0051, high: 0.00681 },
        },
        {
            coinDenom: "USK",
            coinMinimalDenom: "factory/kujira1qk00h5atutpsv900x202pxx42npjr9thg58dnqpa72f2p7m2luase444a7/uusk",
            coinDecimals: 6,
            coinGeckoId: "usk",
            gasPriceStep: { low: 0.01186, average: 0.01779, high: 0.02372 },
        },
        {
            coinDenom: "axlUSDC",
            coinMinimalDenom: "ibc/295548A78785A1007F232DE286149A6FF512F180AF5657780FC89C009E2C348F",
            coinDecimals: 6,
            coinGeckoId: "axlusdc",
            gasPriceStep: { low: 0.0119, average: 0.01785, high: 0.02379 },
        },
        {
            coinDenom: "ATOM",
            coinMinimalDenom: "ibc/27394FB092D2ECCD56123C74F36E4C1F926001CEADA9CA97EA622B25F41E5EB2",
            coinDecimals: 6,
            coinGeckoId: "cosmos",
            gasPriceStep: { low: 0.00129, average: 0.00193, high: 0.00258 },
        },
        {
            coinDenom: "OSMO",
            coinMinimalDenom: "ibc/47BD209179859CDE4A2806763D7189B6E6FE13A17880FE2B42DE1E6C1E329E23",
            coinDecimals: 6,
            coinGeckoId: "osmosis",
            gasPriceStep: { low: 0.01795, average: 0.02692, high: 0.0359 },
        },
        {
            coinDenom: "CMDX",
            coinMinimalDenom: "ibc/3607EB5B5E64DD1C0E12E07F077FF470D5BC4706AFCBC98FE1BA960E5AE4CE07",
            coinDecimals: 6,
            coinGeckoId: "comdex",
            gasPriceStep: { low: 0.65943, average: 0.98915, high: 1.31887 },
        },
        {
            coinDenom: "EVMOS",
            coinMinimalDenom: "ibc/F3AA7EF362EC5E791FE78A0F4CCC69FEE1F9A7485EB1A8CAB3F6601C00522F10",
            coinDecimals: 18,
            coinGeckoId: "evmos",
            gasPriceStep: {
                low: 160416396197,
                average: 240624594296,
                high: 320832792394,
            },
        },
        {
            coinDenom: "JUNO",
            coinMinimalDenom: "ibc/EFF323CC632EC4F747C61BCE238A758EFDB7699C3226565F7C20DA06509D59A5",
            coinDecimals: 6,
            coinGeckoId: "juno-network",
            gasPriceStep: { low: 0.02689, average: 0.04034, high: 0.05379 },
        },
        {
            coinDenom: "LUNA",
            coinMinimalDenom: "ibc/DA59C009A0B3B95E0549E6BF7B075C8239285989FF457A8EDDBB56F10B2A6986",
            coinDecimals: 6,
            coinGeckoId: "terra-luna-2",
            gasPriceStep: { low: 0.01495, average: 0.02243, high: 0.02991 },
        },
        {
            coinDenom: "SCRT",
            coinMinimalDenom: "ibc/A358D7F19237777AF6D8AD0E0F53268F8B18AE8A53ED318095C14D6D7F3B2DB5",
            coinDecimals: 6,
            coinGeckoId: "secret",
            gasPriceStep: { low: 0.03139, average: 0.04709, high: 0.06278 },
        },
        {
            coinDenom: "STARS",
            coinMinimalDenom: "ibc/4F393C3FCA4190C0A6756CE7F6D897D5D1BE57D6CCB80D0BC87393566A7B6602",
            coinDecimals: 6,
            coinGeckoId: "stargaze",
            gasPriceStep: { low: 0.90403, average: 1.35605, high: 1.80806 },
        },
        {
            coinDenom: "AVAX",
            coinMinimalDenom: "ibc/004EBF085BBED1029326D56BE8A2E67C08CECE670A94AC1947DF413EF5130EB2",
            coinDecimals: 18,
            coinGeckoId: "avalanche-2",
            gasPriceStep: { low: 559196837, average: 838795256, high: 1118393675 },
        },
        {
            coinDenom: "ETH",
            coinMinimalDenom: "ibc/1B38805B1C75352B28169284F96DF56BDEBD9E8FAC005BDCC8CF0378C82AA8E7",
            coinDecimals: 18,
            coinGeckoId: "ethereum",
            gasPriceStep: { low: 5772801, average: 8659201, high: 11545602 },
        },
        {
            coinDenom: "MNTA",
            coinMinimalDenom: "factory/kujira1643jxg8wasy5cfcn7xm8rd742yeazcksqlg4d7/umnta",
            coinDecimals: 6,
            coinGeckoId: "mantadao",
            gasPriceStep: { low: 0.01807, average: 0.02711, high: 0.03615 },
        },
        {
            coinDenom: "USDC",
            coinMinimalDenom: "ibc/FE98AAD68F02F03565E9FA39A5E627946699B2B07115889ED812D8BA639576A9",
            coinDecimals: 6,
            coinGeckoId: "usd-coin",
            gasPriceStep: { low: 0.01194, average: 0.01792, high: 0.02389 },
        },
        {
            coinDenom: "SOL",
            coinMinimalDenom: "ibc/E5CA126979E2FFB4C70C072F8094D07ECF27773B37623AD2BF7582AD0726F0F3",
            coinDecimals: 8,
            coinGeckoId: "solana",
            gasPriceStep: { low: 0.00019, average: 0.00029, high: 0.00039 },
        },
    ]),
};
const NETWORK_DEFAULT = "kaiyo-1";

// EXTERNAL MODULE: ./node_modules/kujira.js/lib/esm/resources/contracts.json
var resources_contracts = __webpack_require__(41911);
// EXTERNAL MODULE: ./node_modules/kujira.js/lib/esm/resources/osmosis.json
var osmosis = __webpack_require__(95104);
// EXTERNAL MODULE: ./node_modules/kujira.js/lib/esm/resources/tokens.json
var tokens = __webpack_require__(10187);
;// CONCATENATED MODULE: ./node_modules/kujira.js/lib/esm/denom.js
/* provided dependency */ var Buffer = __webpack_require__(48764)["Buffer"];
var _a;






const ghostVaults = [
    ...resources_contracts[network_MAINNET].ghostVault,
    ...resources_contracts[TESTNET].ghostVault,
];
const wormholeAssets = ((_a = main/* assets.find */.Ll.find((x) => x.chain_name === "gateway")) === null || _a === void 0 ? void 0 : _a.assets) || [];
const labels = Object.assign({ ulp: "LP ", wei: "OKT", ugraviton: "GRAV", usdt: "USDT", usat: "nBTC", uregen: "REGEN", 
    // Noble USDC
    "ibc/FE98AAD68F02F03565E9FA39A5E627946699B2B07115889ED812D8BA639576A9": "USDC", "ibc/119334C55720942481F458C9C462F5C0CD1F1E7EEAC4679D674AA67221916AEA": "LUNC", "ibc/217755344C0D40C75036110E20B0427CC6505760F071BE4080DAD5AC845969EE": "USTC", "ibc/217755344c0d40c75036110e20b0427cc6505760f071be4080dad5ac845969ee": "USTC", uausdc: "axlUSDC", uusdc: "axlUSDC", uausdt: "axlUSDT", uusdt: "axlUSDT", atevmos: "EVMOS", staevmos: "stEVMOS", "wavax-wei": "wAVAX", "arb-wei": "ARB", basecro: "CRO", "weth-wei": "wETH", "link-wei": "LINK", "wsteth-wei": "wstETH", "reth-wei": "rETH", "dot-planck": "DOT", "pepe-wei": "PEPE", "yieldeth-wei": "yieldETH", aevmos: "EVMOS", afet: "FET", adydx: "DYDX", demo: "DEMO", local: "LOCAL", swth: "SWTH", aarch: "ARCH", aacre: "ACRE", aplanq: "PLQ", ufrienzies: "FRNZ", stinj: "stINJ", nanomobx: "MOBX", ario: "RIO", ophir: "OPHIR", "factory/kujira1ltvwg69sw3c5z99c6rr08hal7v0kdzfxz07yj5/demo": "DEMO", "factory/kujira12w0ua4eqnkk0aahtnjlt6h3dhxael6x25s507w/local": "LOCAL", "factory/kujira1swkuyt08z74n5jl7zr6hx0ru5sa2yev5v896p6/local": "LOCAL", "factory/kujira1503w3cjnzpd06m4apje4v0nx47h5gevkywxar8r25gce8r727jxqe4cehk/LOCAL": "LOCAL", "factory/kujira1r85reqy6h0lu02vyz0hnzhv5whsns55gdt4w0d7ft87utzk7u0wqr4ssll/uusk": "USK", "factory:kujira1r85reqy6h0lu02vyz0hnzhv5whsns55gdt4w0d7ft87utzk7u0wqr4ssll:uusk": "USK", "factory/kujira1qk00h5atutpsv900x202pxx42npjr9thg58dnqpa72f2p7m2luase444a7/uusk": "USK", "factory:kujira1qk00h5atutpsv900x202pxx42npjr9thg58dnqpa72f2p7m2luase444a7:uusk": "USK", "factory/kujira1sc6a0347cc5q3k890jj0pf3ylx2s38rh4sza4t/urfuzn": "rFUZN", "factory/kujira1v3hcejcerf0d9em9ds8rpyyq68vx3u9u4k0fvw4e9hacdy8nn6pqx4urcw/urcpt": "cMNTA", "factory/kujira1qzu3up50auxhqyzfq56znuj8n38q2ra7daaf9ef7vg8gu66jh4fqd2wd2y/urcpt": "qcMNTA", "factory/kujira1m96ucsfpt2yy72w09z2rxjdj38y5qd8lqx5jtggnejmdua2ynpnsxyvjex/urcpt": "qcKUJI", "factory/kujira14el9xd5e688s7g8yra2rjjv26dmjatfrkgrpkyly5hh9hswn2ngs3p9vag/urcpt": "qcMNTA", "factory/kujira1jaf8tsgvchqfmycv8wmncv52t4fcv3ehuh57gsd9ycce5ewn87ksnwhlkr/urcpt": "qcKUJI", "factory/migaloo1eqntnl6tzcj9h86psg4y4h6hh05g2h9nj8e09l/urac": "RAC", gravity0x45804880De22913dAFE09f4980848ECE6EcbAf78: "gPAXG", gravity0xfB5c6815cA3AC72Ce9F5006869AE67f18bF77006: "gPSTAKE", gravity0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2: "gwETH", gravity0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48: "gUSDC", gravity0xdAC17F958D2ee523a2206206994597C13D831ec7: "gUSDT", gravity0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599: "gwBTC", gravity0x6B175474E89094C44Da98b954EedeAC495271d0F: "gDAI", gravity0x77E06c9eCCf2E797fd462A92B6D7642EF85b0A44: "wTAO", gravity0xa0b93B9e90aB887E53F9FB8728c009746e989B53: "gTST", gravity0xe28b3B32B6c345A34Ff64674606124Dd5Aceca30: "gINJ", gravity0xB50721BCf8d664c30412Cfbc6cf7a15145234ad1: "gARB", gravity0x4c11249814f11b9346808179Cf06e71ac328c1b5: "gORAI", gravity0x93581991f68DBaE1eA105233b67f7FA0D6BDeE7b: "gwEVMOS", gravity0x35a532d376FFd9a705d0Bb319532837337A398E7: "gwDOGE", gravity0x07baC35846e5eD502aA91AdF6A9e7aA210F2DcbE: "gerowan", gravity0xd2877702675e6cEb975b4A1dFf9fb7BAF4C91ea9: "gwLUNC", gravity0x95aD61b0a150d79219dCF64E1E6Cc01f0B64C4cE: "gSHIB", 
    // 18
    gravity0xAa6E8127831c9DE45ae56bB1b0d4D4Da6e5665BD: "gETH2x-FLI", 
    // 6
    gravity0x44017598f2AF1bD733F9D87b5017b4E7c1B28DDE: "gstkATOM", 
    // 18
    gravity0xBA11D00c5f74255f56a5E366F4F77f5A186d7f55: "gBAND", 
    // 6
    gravity0xEa5A82B35244d9e5E48781F00b11B14E627D2951: "gATOM", 
    // 18
    gravity0x83F20F44975D03b1b09e64809B757c47f942BEeA: "gsDAI", 
    // 18
    gravity0x6982508145454Ce325dDbE47a25d4ec3d2311933: "gPEPE", 
    // 18
    gravity0x817bbDbC3e8A1204f3691d14bB44992841e3dB35: "gCUDOS", 
    // 18
    gravity0xd23Ed8cA350CE2631F7EcDC5E6bf80D0A1DeBB7B: "gPLQ", 
    // 18
    gravity0xd3E4Ba569045546D09CF021ECC5dFe42b1d7f6E4: "gMNW", 
    // 18
    gravity0x514910771AF9Ca656af840dff83E8264EcF986CA: "gLINK", "erc20/0xAE6D3334989a22A65228732446731438672418F2": "CNTO", "frax-wei": "FRAX", inj: "INJ", "dai-wei": "DAI", "wbtc-satoshi": "wBTC", "wbnb-wei": "wBNB", "wftm-wei": "wFTM", "uni-wei": "UNI", "wmatic-wei": "wMATIC", "wglmr-wei": "wGLMR", "busd-wei": "BUSD", ncheq: "CHEQ", "cw20:juno1qsrercqegvs4ye0yqg93knv73ye5dc3prqwd6jcdcuj8ggp6w0us66deup": "LOOP", "cw20:juno1cltgm8v842gu54srmejewghnd6uqa26lzkpa635wzra9m9xuudkqa2gtcz": "FURY.legacy", "cw20:juno1hnftys64ectjfynm6qjk9my8jd3f6l9dq9utcd3dy8ehwrsx9q4q7n9uxt": "AQUA", "cw20:juno168ctmpyppk90d34p3jjy658zf5a5l3w8wk35wht6ccqj4mr0yv8s4j5awr": "NETA", "cw20:juno1r4pzw8f9z0sypct5l9j906d47z998ulwvhvqe5xdwgy8wf84583sxwh0pa": "RAC.legacy", "cw20:juno1j0a9ymgngasfn3l5me8qpd53l5zlm9wurfdk7r65s5mg6tkxal3qpgf5se": "GLTO", "cw20:terra1ecgazyd0waaj3g7l9cmy5gulhxkps2gmxu9ghducvuypjq68mq2s5lvsct": "ampLUNA", "cw20:terra1xzkel96e5e8vfmqw7valzdzzv9hqasfyslclvnmvxdejvpda3xwsskxzus": "whLOCAL", "cw20:terra1nsuqsk6kh58ulczatwev87ttq2z6r3pusulg9r24mfj2fvtzd4uq3exn26": "ASTRO", "cw20:terra1x62mjnme4y0rdnag3r8rfgjuutsqlkkyuh4ndgex0wl3wue25uksau39q8": "xASTRO", "cw20:secret1qfql357amn448duf5gvp9gr48sxx9tsnhupu3d": "SHD.legacy", "cw20:terra17gck626vgax9jpe6utm7dhx4vdzawfkt0jhru03l7a3dzu98wedsfad4sz": "dUST", "cw20:terra1lxx40s29qvkrcj8fsa3yzyehy7w50umdvvnls2r830rys6lu2zns63eelv": "ROAR", "cw20:terra1xp9hrhthzddnl7j5du83gqqr4wmdjm5t0guzg9jp6jwrtpukwfjsjgy4f3": "SAYVE", "cw20:terra1lalvk0r6nhruel7fvzdppk3tup3mh5j4d4eadrqzfhle4zrf52as58hh9t": "CUB", "cw20:terra1gwrz9xzhqsygyr5asrgyq3pu0ewpn00mv2zenu86yvx2nlwpe8lqppv584": "BLUE", "cw20:terra17aj4ty4sz4yhgm08na8drc0v03v2jwr3waxcqrwhajj729zhl7zqnpc0ml": "boneLUNA", "cw20:secret1s09x2xvfd2lp2skgzm29w2xtena7s8fq98v852": "AMBER", "cw20:secret1k6u0cy4feepm6pehnz804zmwakuwdapm69tuc4": "stkd-SCRT", "cw20:secret1yxcexylwyxlq58umhgsjgstgcg2a0ytfy4d9lt": "BUTT", "cw20:secret153wu605vvp934xhd4k9dtd640zsep5jkesstdm": "SHD", "cw20:secret1fl449muk5yq8dlad7a22nje4p5d2pnsgymhjfd": "SILK", "cw20:terra1xfsdgcemqwxp4hhnyk4rle6wr22sseq7j07dnn": "KUJIC", "cw20:terra188w26t95tf4dz77raftme8p75rggatxjxfeknw": "SKUJIC", terra18zqcnl83z98tf6lly37gghm7238k7lh79u4z9a: "bATOM", terra1dzhzukyezv0etz22ud940z7adyv7xgcjkahuun: "bETH", terra1kc87mu460fwkqte29rquh4hc20m54fxwtsx7gp: "bLUNA", terra1c00vskhyzdv0z63z2tyetzx2qma67n2z3vzyn0: "bSOL", terra1z3e2e4jpk4n0xzzwlkgcfvc95pc5ldq0xcny58: "sAVAX", "factory/migaloo1436kxs0w2es6xlqpp9rd35e3d0cjnw4sv8j3a7483sgks29jqwgshqdky4/ampWHALE": "ampWHALE", "erc20/0x655ecB57432CC1370f65e5dc2309588b71b473A9": "NEOK", "factory/neutron1p8d89wvxyjcnawmgw72klknr3lg9gwwl6ypxda/newt": "NEWT" }, wormholeAssets.reduce((a, v) => (Object.assign(Object.assign({}, a), { [v.base]: `wh${v.symbol}` })), {}));
const terra = {
    uaud: "AUT",
    ucad: "CAT",
    uchf: "CHT",
    ucny: "CNT",
    udkk: "DKT",
    ueur: "EUT",
    ugbp: "GBT",
    uhkd: "HKT",
    uidr: "IDT",
    uinr: "INT",
    ujpy: "JPT",
    umnt: "MNT",
    umyr: "MYT",
    unok: "NOT",
    uphp: "PHT",
    usdr: "SDT",
    usek: "SET",
    usgd: "SGT",
    uthb: "THT",
    utwd: "TWT",
    uusd: "UST",
};
const baseDenomToSymbol = (denom) => {
    var _a;
    const raw = labels[denom];
    if (raw)
        return raw;
    const factoryAddress = denom.split("/")[1];
    const ghost = factoryAddress && ghostVaults.find((a) => a.address === factoryAddress);
    if (ghost)
        return denom.endsWith("/udebt") ? `debt` : `x`;
    const baseDenom = denom.startsWith("ibc/")
        ? (_a = tokens[denom]) === null || _a === void 0 ? void 0 : _a.base_denom
        : denom.startsWith("factory/")
            ? denom.split("/")[2]
            : denom.startsWith("factory:")
                ? denom.split(":")[2]
                : denom;
    if (!baseDenom)
        return "Unknown";
    const label = labels[baseDenom];
    if (label)
        return label;
    const t = terra[denom];
    if (t)
        return t;
    // Stafi
    return baseDenom.startsWith("ur")
        ? "r" + baseDenom.replace(/^ur/, "").toUpperCase()
        : baseDenom.startsWith("u")
            ? baseDenom.replace(/^u/, "").toUpperCase()
            : // Stride
                baseDenom.startsWith("stu")
                    ? `st${baseDenomToSymbol(baseDenom.replace(/^st/, ""))}`
                    : baseDenom;
};
const avalanche = {
    // Mainnet
    "0x2b2c81e08f1af8835a78bb2a90ae924ace0ea4be": "sAVAX",
};
const ics20 = {
    "cw20:juno1qsrercqegvs4ye0yqg93knv73ye5dc3prqwd6jcdcuj8ggp6w0us66deup": {
        contract: "juno1qsrercqegvs4ye0yqg93knv73ye5dc3prqwd6jcdcuj8ggp6w0us66deup",
        router: "juno1lkv72wruk6m39a2j4ps036hzxyhjccwncgfzzcaqxuwndg5x0ghqa8mrhg",
        channel: "channel-97",
    },
    "cw20:juno1r4pzw8f9z0sypct5l9j906d47z998ulwvhvqe5xdwgy8wf84583sxwh0pa": {
        contract: "juno1r4pzw8f9z0sypct5l9j906d47z998ulwvhvqe5xdwgy8wf84583sxwh0pa",
        router: "juno1lkv72wruk6m39a2j4ps036hzxyhjccwncgfzzcaqxuwndg5x0ghqa8mrhg",
        channel: "channel-97",
    },
    "cw20:juno1cltgm8v842gu54srmejewghnd6uqa26lzkpa635wzra9m9xuudkqa2gtcz": {
        contract: "juno1cltgm8v842gu54srmejewghnd6uqa26lzkpa635wzra9m9xuudkqa2gtcz",
        router: "juno1lkv72wruk6m39a2j4ps036hzxyhjccwncgfzzcaqxuwndg5x0ghqa8mrhg",
        channel: "channel-97",
    },
    "cw20:juno1hnftys64ectjfynm6qjk9my8jd3f6l9dq9utcd3dy8ehwrsx9q4q7n9uxt": {
        contract: "juno1hnftys64ectjfynm6qjk9my8jd3f6l9dq9utcd3dy8ehwrsx9q4q7n9uxt",
        router: "juno1lkv72wruk6m39a2j4ps036hzxyhjccwncgfzzcaqxuwndg5x0ghqa8mrhg",
        channel: "channel-97",
    },
    "cw20:juno1j0a9ymgngasfn3l5me8qpd53l5zlm9wurfdk7r65s5mg6tkxal3qpgf5se": {
        contract: "juno1j0a9ymgngasfn3l5me8qpd53l5zlm9wurfdk7r65s5mg6tkxal3qpgf5se",
        router: "juno1lkv72wruk6m39a2j4ps036hzxyhjccwncgfzzcaqxuwndg5x0ghqa8mrhg",
        channel: "channel-97",
    },
    // whLOCAL
    "cw20:terra1xzkel96e5e8vfmqw7valzdzzv9hqasfyslclvnmvxdejvpda3xwsskxzus": {
        contract: "terra1xzkel96e5e8vfmqw7valzdzzv9hqasfyslclvnmvxdejvpda3xwsskxzus",
        router: "terra1d90p5lacfxnqgjxjupu234lxnxyeu8fdeef4d0e0nqy3p30r7gss4myn9x",
        channel: "channel-34",
    },
    // ASTRO
    "cw20:terra1nsuqsk6kh58ulczatwev87ttq2z6r3pusulg9r24mfj2fvtzd4uq3exn26": {
        contract: "terra1nsuqsk6kh58ulczatwev87ttq2z6r3pusulg9r24mfj2fvtzd4uq3exn26",
        router: "terra1d90p5lacfxnqgjxjupu234lxnxyeu8fdeef4d0e0nqy3p30r7gss4myn9x",
        channel: "channel-34",
    },
    // xASTRO
    "cw20:terra1x62mjnme4y0rdnag3r8rfgjuutsqlkkyuh4ndgex0wl3wue25uksau39q8": {
        contract: "terra1x62mjnme4y0rdnag3r8rfgjuutsqlkkyuh4ndgex0wl3wue25uksau39q8",
        router: "terra1d90p5lacfxnqgjxjupu234lxnxyeu8fdeef4d0e0nqy3p30r7gss4myn9x",
        channel: "channel-34",
    },
    // ampLUNA
    "cw20:terra1ecgazyd0waaj3g7l9cmy5gulhxkps2gmxu9ghducvuypjq68mq2s5lvsct": {
        contract: "terra1ecgazyd0waaj3g7l9cmy5gulhxkps2gmxu9ghducvuypjq68mq2s5lvsct",
        router: "terra1e0mrzy8077druuu42vs0hu7ugguade0cj65dgtauyaw4gsl4kv0qtdf2au",
        channel: "channel-28",
    },
    // ROAR
    "cw20:terra1lxx40s29qvkrcj8fsa3yzyehy7w50umdvvnls2r830rys6lu2zns63eelv": {
        contract: "terra1lxx40s29qvkrcj8fsa3yzyehy7w50umdvvnls2r830rys6lu2zns63eelv",
        router: "terra1e0mrzy8077druuu42vs0hu7ugguade0cj65dgtauyaw4gsl4kv0qtdf2au",
        channel: "channel-28",
    },
    // SAYVE
    "cw20:terra1xp9hrhthzddnl7j5du83gqqr4wmdjm5t0guzg9jp6jwrtpukwfjsjgy4f3": {
        contract: "terra1xp9hrhthzddnl7j5du83gqqr4wmdjm5t0guzg9jp6jwrtpukwfjsjgy4f3",
        router: "terra1e0mrzy8077druuu42vs0hu7ugguade0cj65dgtauyaw4gsl4kv0qtdf2au",
        channel: "channel-28",
    },
    // CUB
    "cw20:terra1lalvk0r6nhruel7fvzdppk3tup3mh5j4d4eadrqzfhle4zrf52as58hh9t": {
        contract: "terra1lalvk0r6nhruel7fvzdppk3tup3mh5j4d4eadrqzfhle4zrf52as58hh9t",
        router: "terra1e0mrzy8077druuu42vs0hu7ugguade0cj65dgtauyaw4gsl4kv0qtdf2au",
        channel: "channel-28",
    },
    // BLUE
    "cw20:terra1gwrz9xzhqsygyr5asrgyq3pu0ewpn00mv2zenu86yvx2nlwpe8lqppv584": {
        contract: "terra1gwrz9xzhqsygyr5asrgyq3pu0ewpn00mv2zenu86yvx2nlwpe8lqppv584",
        router: "terra1e0mrzy8077druuu42vs0hu7ugguade0cj65dgtauyaw4gsl4kv0qtdf2au",
        channel: "channel-28",
    },
    // bLUNA
    "cw20:terra17aj4ty4sz4yhgm08na8drc0v03v2jwr3waxcqrwhajj729zhl7zqnpc0ml": {
        contract: "terra17aj4ty4sz4yhgm08na8drc0v03v2jwr3waxcqrwhajj729zhl7zqnpc0ml",
        router: "terra1e0mrzy8077druuu42vs0hu7ugguade0cj65dgtauyaw4gsl4kv0qtdf2au",
        channel: "channel-28",
    },
    // SHD
    // "cw20:secret1qfql357amn448duf5gvp9gr48sxx9tsnhupu3d": {
    //   contract: "secret1qfql357amn448duf5gvp9gr48sxx9tsnhupu3d",
    //   router: "secret1tqmms5awftpuhalcv5h5mg76fa0tkdz4jv9ex4",
    //   channel: "channel-46",
    // },
    // dUST
    "cw20:terra17gck626vgax9jpe6utm7dhx4vdzawfkt0jhru03l7a3dzu98wedsfad4sz": {
        contract: "terra17gck626vgax9jpe6utm7dhx4vdzawfkt0jhru03l7a3dzu98wedsfad4sz",
        router: "terra1d90p5lacfxnqgjxjupu234lxnxyeu8fdeef4d0e0nqy3p30r7gss4myn9x",
        channel: "channel-34",
    },
    // KUJIC
    "cw20:terra1xfsdgcemqwxp4hhnyk4rle6wr22sseq7j07dnn": {
        contract: "terra1xfsdgcemqwxp4hhnyk4rle6wr22sseq7j07dnn",
        router: "terra1lwdvjtl5lecxcyfl7hc362gczqh03msgcwlh76xa0fcu0usf7ejskkfulk",
        channel: "",
    },
    // SKUJIC
    "cw20:terra188w26t95tf4dz77raftme8p75rggatxjxfeknw": {
        contract: "terra188w26t95tf4dz77raftme8p75rggatxjxfeknw",
        router: "terra1lwdvjtl5lecxcyfl7hc362gczqh03msgcwlh76xa0fcu0usf7ejskkfulk",
        channel: "",
    },
};
class denom_Denom {
    constructor(reference, underlying) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        this.reference = reference;
        this.underlying = underlying;
        this.decimals = 6;
        this.eq = (other) => this.reference == other.reference;
        this.compare = (other) => this.symbol
            .replace(/[a-z]+/, "")
            .localeCompare(other.symbol.replace(/[a-z]+/, ""));
        this.normalizedReference = () => {
            if (this.reference.startsWith("ibc/")) {
                return `ibc/${this.reference.replace("ibc/", "").toLocaleUpperCase()}`;
            }
            return this.reference;
        };
        if (this.reference.startsWith("ibc/")) {
            this.trace = tokens[this.reference];
        }
        this.symbol = baseDenomToSymbol(this.reference);
        if ((_a = this.trace) === null || _a === void 0 ? void 0 : _a.base_denom.startsWith("gamm")) {
            this.symbol = "Osmosis LP ";
        }
        if (this.underlying) {
            this.symbol = `${this.symbol}${this.underlying
                .map((d) => d.symbol)
                .join("-")}`;
        }
        this.decimals = 6;
        // wormhole
        if (((_b = this.trace) === null || _b === void 0 ? void 0 : _b.path) === `transfer/channel-113`) {
            this.decimals =
                ((_d = (_c = wormholeAssets
                    .find((a) => { var _a; return a.base === ((_a = this.trace) === null || _a === void 0 ? void 0 : _a.base_denom); })) === null || _c === void 0 ? void 0 : _c.denom_units.at(-1)) === null || _d === void 0 ? void 0 : _d.exponent) || this.decimals;
        }
        if ((((_e = this.trace) === null || _e === void 0 ? void 0 : _e.base_denom) || this.reference).startsWith("erc20/"))
            this.decimals = 18;
        if ((((_f = this.trace) === null || _f === void 0 ? void 0 : _f.base_denom) || this.reference).startsWith("gravity"))
            this.decimals = 18;
        if ((((_g = this.trace) === null || _g === void 0 ? void 0 : _g.base_denom) || this.reference).endsWith("wei"))
            this.decimals = 18;
        if ((((_h = this.trace) === null || _h === void 0 ? void 0 : _h.base_denom) || this.reference).endsWith("-satoshi"))
            this.decimals = 8;
        if (this.symbol === "gPAXG")
            this.decimals = 18;
        if (this.symbol === "EVMOS")
            this.decimals = 18;
        if (this.symbol === "wAVAX")
            this.decimals = 18;
        if (this.symbol === "wETH")
            this.decimals = 18;
        if (this.symbol === "CRO")
            this.decimals = 8;
        if (this.symbol === "EL1")
            this.decimals = 18;
        if (this.symbol === "nBTC")
            this.decimals = 14;
        if (this.symbol === "BOOT")
            this.decimals = 0;
        if (this.symbol === "DOT")
            this.decimals = 10;
        if (this.symbol === "SHD")
            this.decimals = 8;
        if (this.symbol === "SHD,legacy")
            this.decimals = 8;
        if (this.symbol === "INJ")
            this.decimals = 18;
        if (this.symbol === "gINJ")
            this.decimals = 18;
        if (this.symbol === "stINJ")
            this.decimals = 18;
        if (this.symbol === "CNTO")
            this.decimals = 18;
        if (this.symbol === "wTAO")
            this.decimals = 9;
        if (this.symbol === "ACRE")
            this.decimals = 18;
        if (this.symbol === "PLQ")
            this.decimals = 18;
        if (this.symbol === "SWTH")
            this.decimals = 8;
        if (this.symbol === "gTST")
            this.decimals = 18;
        if (this.symbol === "ARB")
            this.decimals = 18;
        if (this.symbol === "FET")
            this.decimals = 18;
        if (this.symbol === "HANS")
            this.decimals = 18;
        if (this.symbol === "ORAI")
            this.decimals = 18;
        if (this.symbol === "wEVMOS")
            this.decimals = 18;
        if (this.symbol === "wDOGE")
            this.decimals = 18;
        if (this.symbol === "erowan")
            this.decimals = 18;
        if (this.symbol === "wLUNC")
            this.decimals = 18;
        if (this.symbol === "SHIB")
            this.decimals = 18;
        if (this.symbol === "MOBX")
            this.decimals = 9;
        if (this.symbol === "ARCH")
            this.decimals = 18;
        if (this.symbol === "RIO")
            this.decimals = 18;
        if (this.symbol === "DYDX")
            this.decimals = 18;
        if (this.symbol === "CHEQ")
            this.decimals = 9;
        if (((_j = this.underlying) === null || _j === void 0 ? void 0 : _j.length) === 2 &&
            this.underlying[0].decimals === this.underlying[1].decimals) {
            this.decimals = this.underlying[0].decimals;
        }
        // OKX USDT
        if (this.reference ===
            "ibc/EA20485E9BEBF77BB3638A79F60A0E1D0A12A6289972F30E475529C80BF5C960")
            this.decimals = 18;
        // Handle ghost underlying
        if (((_k = this.underlying) === null || _k === void 0 ? void 0 : _k.length) === 1 && this.decimals === 6)
            this.decimals = this.underlying[0].decimals;
        this.ics20 = ics20[this.reference];
    }
    static from(string) {
        var _a, _b, _c, _d;
        const bowUnderlying = (_b = (_a = Object.values(resources_contracts)
            .flatMap((x) => x.bow)
            .find((x) => `factory/${x.address}/ulp` === string)) === null || _a === void 0 ? void 0 : _a.config.denoms) === null || _b === void 0 ? void 0 : _b.map(denom_Denom.from);
        let osmosisUnderlying;
        if (string.startsWith("ibc/")) {
            const trace = tokens[string];
            osmosisUnderlying = (_d = (_c = osmosis.find((x) => `gamm/pool/${x.id}` === (trace === null || trace === void 0 ? void 0 : trace.base_denom))) === null || _c === void 0 ? void 0 : _c.assets) === null || _d === void 0 ? void 0 : _d.map((x) => denom_Denom.from(x.token.denom));
        }
        const factoryAddress = string.startsWith("factory/") && string.split("/")[1];
        const ghostVault = ghostVaults.find((f) => f.address === factoryAddress);
        return new denom_Denom(string, bowUnderlying ||
            osmosisUnderlying ||
            (ghostVault ? [denom_Denom.from(ghostVault.config.denom)] : undefined));
    }
    /*
    Method for creating a denom that hasn't yet been IBC'd and so doesn't have an
    entry in tokens.json
    */
    static from_path(port, channel, denom) {
        let d = new denom_Denom(ibcDenom(port, channel, denom));
        d.trace = { base_denom: denom, path: `${port}/${channel}` };
        return d;
    }
}
const ibcDenom = (port, channel, denom) => "ibc/" +
    Buffer.from((0,crypto_build.sha256)(Buffer.from(`${port}/${channel}/${denom}`)))
        .toString("hex")
        .toUpperCase();
const USK_TESTNET = denom_Denom.from("factory/kujira1r85reqy6h0lu02vyz0hnzhv5whsns55gdt4w0d7ft87utzk7u0wqr4ssll/uusk");
const USK = denom_Denom.from("factory/kujira1qk00h5atutpsv900x202pxx42npjr9thg58dnqpa72f2p7m2luase444a7/uusk");
const KUJI = denom_Denom.from("ukuji");
const DEMO = denom_Denom.from("factory/kujira1ltvwg69sw3c5z99c6rr08hal7v0kdzfxz07yj5/demo");
const ATOM = denom_Denom.from("ibc/27394FB092D2ECCD56123C74F36E4C1F926001CEADA9CA97EA622B25F41E5EB2");
const axlUSDC = denom_Denom.from("ibc/295548A78785A1007F232DE286149A6FF512F180AF5657780FC89C009E2C348F");
const nobleUSDC = denom_Denom.from_path("transfer", "channel-62", "uusdc");
const axlUSDT = denom_Denom.from("ibc/F2331645B9683116188EF36FC04A809C28BD36B54555E8705A37146D0182F045");
const axlwETH = denom_Denom.from("ibc/1B38805B1C75352B28169284F96DF56BDEBD9E8FAC005BDCC8CF0378C82AA8E7");
const axlwMATIC = denom_Denom.from("ibc/A64467480BBE4CCFC3CF7E25AD1446AA9BDBD4F5BCB9EF6038B83D6964C784E6");
const axlwBNB = denom_Denom.from("ibc/DADB399E742FCEE71853E98225D13E44E90292852CD0033DF5CABAB96F80B833");
const axlwAVAX = denom_Denom.from("ibc/004EBF085BBED1029326D56BE8A2E67C08CECE670A94AC1947DF413EF5130EB2");
const axlwGLMR = denom_Denom.from("ibc/C8D63703F5805CE6A2B20555139CF6ED9CDFA870389648EB08D688B94B0AE2C1");
const axlwFTM = denom_Denom.from("ibc/E67ADA2204A941CD4743E70771BA08E24885E1ADD6FD140CE1F9E0FEBB68C6B2");
const denom_factor = ([base, quote]) => {
    return Math.pow(10, (base.decimals - quote.decimals));
};

;// CONCATENATED MODULE: ./node_modules/kujira.js/lib/esm/bow.js




const EXCLUDED = [
    "kujira188p624ykuepun8h8kjmcfs553mz2jgeanetyqv7l6xltdld497vqespn6c",
    "kujira136rwqvwy3flttm9wfnc5xgnlr6mu5k8e2elgzs2hdhuwf50w3l2qp807cx",
    "kujira1xgjefq7fs4yj29t9gk0t9esgw52s68j83yeac3ru2mefdp529qsqca7hhv",
    "kujira167gut7dskwurax8an630m3yy2cwa2fp3kmcpdzucyy6ppg7njgyqhl7w50",
    "kujira1ywlrdpqymukghjwhfyp2n98r49j56wej36n4l08egkdlwj4fn87ql2l2ey",
    "kujira1dj2s8uvup63fsmpfdfpmu570es4whswp806w0p6usdamtglhwvfqd5jx40",
    "kujira1cdy6aje8zszx5vryttkkm5rn9g2n53ltfds753fsn63m09cmhx0sgp6v6m",
    "kujira1h356yzzk2yw7q5s26dewdgaptw05fxplgmxdxcfqcatjyurckuks6zfay8",
    "kujira19a0wethewg36vny9jremekzlx66lwljp2htrhe255mp6djv652dqsu2l76",
    "kujira1xdjt8r39nvm03fs4d9cwyw2sks5dahs52msza59y4vevdgdwhtlq9e3vvg",
    "kujira1kupjzlp96l4ypt0fdpse8slmkdkkz3g0t5evy033va0gvtw867sq0cm6q0",
];
const castPosition = (res) => ({
    idx: res.idx,
    holder: res.holder,
    lpAmount: BigNumber.from(res.lp_amount),
    ltv: parseFixed(res.ltv, 18),
    debtShares: res.debt_shares.reduce((a, v) => (Object.assign(Object.assign({}, a), { [v.denom]: {
            amount: BigNumber.from(v.amount),
            denom: Denom.from(v.denom),
            ratio: parseFixed(v.ratio, 18),
        } })), {}),
});
const castPool = (address, res, margin) => ({
    strategy: "amp" in res ? "xyk" : "adapter" in res ? "lsd" : "stable",
    address,
    owner: res.owner,
    denoms: [denom_Denom.from(res.denoms[0]), denom_Denom.from(res.denoms[1])],
    pricePrecision: res.price_precision.decimal_places,
    decimalDelta: res.decimal_delta,
    finContract: res.fin_contract,
    margin: margin && castMargin(margin.address, margin.config),
});
const castMargin = (address, res) => ({
    address,
    owner: res.owner,
    bowContract: res.bow_contract,
    denoms: [
        {
            denom: denom_Denom.from(res.denoms[0].denom),
            decimals: res.denoms[0].decimals,
            oracle: res.denoms[0].oracle,
        },
        {
            denom: denom_Denom.from(res.denoms[1].denom),
            decimals: res.denoms[1].decimals,
            oracle: res.denoms[1].oracle,
        },
    ],
    vaults: [res.vaults[0], res.vaults[1]],
    orcas: [res.orcas[0], res.orcas[1]],
    maxLtv: fixednumber_parseFixed(res.max_ltv, 18),
    fullLiquidationThreshold: bignumber/* BigNumber.from */.O$.from(res.full_liquidation_threshold),
    partialLiquidationTarget: fixednumber_parseFixed(res.partial_liquidation_target, 18),
    borrowFee: fixednumber_parseFixed(res.borrow_fee, 18),
});
const POOLS = {
    [network_MAINNET]: resources_contracts[network_MAINNET].bow.reduce((a, v) => EXCLUDED.includes(v.address)
        ? a
        : Object.assign(Object.assign({}, a), { [v.address]: castPool(v.address, v.config, Object.values(resources_contracts[network_MAINNET].bowMargin).find((x) => x.config.bow_contract === v.address)) }), {}),
    [TESTNET]: resources_contracts[TESTNET].bow.reduce((a, v) => EXCLUDED.includes(v.address)
        ? a
        : Object.assign(Object.assign({}, a), { [v.address]: castPool(v.address, v.config, Object.values(resources_contracts[TESTNET].bowMargin).find((x) => x.config.bow_contract === v.address)) }), {}),
    [POND]: {},
};

;// CONCATENATED MODULE: ./node_modules/kujira.js/lib/esm/fin/client.js
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};



const filterMigrationError = (agg, pool) => {
    const prev = agg[agg.length - 1];
    return prev && prev.quotePrice > pool.quotePrice ? agg : [...agg, pool];
};
const castBook = (denoms) => (response) => ({
    base: response.base.map(client_castPool(denoms)).reduce(filterMigrationError, []),
    quote: response.quote.map(client_castPool(denoms)),
});
const castConfig = (response) => ({
    owner: response.owner,
    denoms: [parseDenom(response.denoms[0]), parseDenom(response.denoms[1])],
    isBootstrapping: response.is_bootstrapping,
    decimalDelta: response.decimal_delta || 0,
});
const parseDenom = (response) => {
    if ("string" === typeof response) {
        return Denom.from(response);
    }
    if ("native" in response) {
        return Denom.from(response.native);
    }
    return Denom.from(response.cw20);
};
const client_castOrder = (denoms) => (response) => ({
    idx: parseInt(response.idx),
    owner: response.owner,
    quotePrice: parseFloat(response.quote_price) * factor(denoms),
    quotePriceInt: parseFixed(response.quote_price, 18),
    offerDenom: parseDenom(response.offer_denom),
    offerAmount: BigNumber.from(response.offer_amount),
    filledAmount: BigNumber.from(response.filled_amount),
    originalOfferAmount: BigNumber.from(response.original_offer_amount),
    createdAt: new Date(parseInt(response.created_at) / 1000000),
});
const client_castPool = (denoms) => (response) => {
    return {
        quotePrice: parseFloat(response.quote_price) * factor(denoms),
        quotePriceInt: parseFixed(response.quote_price, 18),
        offerDenom: parseDenom(response.offer_denom),
        totalOfferAmount: BigNumber.from(response.total_offer_amount),
    };
};
const WEI = bignumber/* BigNumber.from */.O$.from(10).pow(18);
const DEFAULT_SIMULATION = {
    returnAmount: bignumber/* BigNumber.from */.O$.from(0),
    spreadAmount: bignumber/* BigNumber.from */.O$.from(0),
    commissionAmount: bignumber/* BigNumber.from */.O$.from(0),
    rate: bignumber/* BigNumber.from */.O$.from(0),
    slippage: bignumber/* BigNumber.from */.O$.from(0),
};
const simulate = (query, amount, denom, pair, book) => __awaiter(void 0, void 0, void 0, function* () {
    if (amount.isZero())
        return DEFAULT_SIMULATION;
    const sell = denom.eq(pair.denoms[0]);
    const mid = book && book.base.length && book.quote.length
        ? book.base[0].quotePriceInt.add(book.quote[0].quotePriceInt).div(2)
        : BigNumber.from(0);
    let sim = book
        ? yield simulateLocal(amount, denom, pair, book).catch(() => simulateQuery(query, amount, denom, pair))
        : yield simulateQuery(query, amount, denom, pair);
    let offer = amount.mul(WEI);
    const beliefReturnAmount = sell
        ? offer.mul(mid).div(WEI).div(WEI)
        : offer.div(mid);
    const rate = sell
        ? sim.returnAmount.mul(WEI).div(amount)
        : amount.mul(WEI).div(sim.returnAmount);
    const diff = beliefReturnAmount.gt(sim.returnAmount)
        ? beliefReturnAmount.sub(sim.returnAmount)
        : sim.returnAmount.sub(beliefReturnAmount);
    const slippage = diff.mul(WEI).div(beliefReturnAmount);
    return {
        returnAmount: sim.returnAmount,
        spreadAmount: beliefReturnAmount.sub(sim.returnAmount),
        commissionAmount: sim.commissionAmount,
        rate,
        slippage,
    };
});
const simulateLocal = (amount, denom, pair, book) => __awaiter(void 0, void 0, void 0, function* () {
    // decimals from decoding are 18 dp
    const sell = denom.eq(pair.denoms[0]);
    let returned = BigNumber.from(0);
    const pools = [...(sell ? book.quote : book.base)].reverse();
    let offer = amount;
    while (offer.gt(0)) {
        const pool = pools.pop();
        if (!pool)
            break;
        const price = pool.quotePriceInt;
        const poolValue = sell
            ? pool.totalOfferAmount.mul(WEI).div(price)
            : pool.totalOfferAmount.mul(price).div(WEI);
        const consumedOffer = poolValue.gt(offer) ? offer : poolValue;
        const consumedAsk = sell
            ? consumedOffer.mul(price).div(WEI)
            : consumedOffer.mul(WEI).div(price);
        returned = returned.add(consumedAsk);
        offer = offer.sub(consumedOffer);
    }
    if (!offer.isZero()) {
        throw new Error("Out of orders");
    }
    const commissionAmount = mulDec(returned, 0.0015);
    const netReturnAmount = returned.sub(commissionAmount);
    return { returnAmount: netReturnAmount, commissionAmount };
});
const simulateQuery = (query, amount, denom, pair) => query.wasm
    .queryContractSmart(pair.address, {
    simulation: {
        offer_asset: {
            info: { native_token: { denom: denom.reference } },
            amount: amount.toString(),
        },
    },
})
    .then((res) => ({
    returnAmount: BigNumber.from(res.return_amount),
    commissionAmount: BigNumber.from(res.commission_amount),
}));
const formatPrice = (price, denom, denoms) => {
    const [, quote] = denoms;
    return price && denom.eq(quote)
        ? factor(denoms) / price
        : price * factor(denoms);
};

;// CONCATENATED MODULE: ./node_modules/kujira.js/lib/esm/usk.js




const castStatus = (res) => ({
    debtAmount: BigNumber.from(res.debt_amount),
});
const usk_castConfig = (json) => ({
    owner: json.owner,
    stableDenom: denom_Denom.from(json.stable_denom),
    stableDenomAdmin: json.stable_denom_admin,
    collateralDenom: denom_Denom.from(json.collateral_denom),
    oracleDenom: json.oracle_denom,
    maxRatio: parseFloat(json.max_ratio),
    mintFee: parseFloat(json.mint_fee),
    interestRate: parseFloat(json.interest_rate),
    orcaAddress: json.orca_address,
    maxDebt: bignumber/* BigNumber.from */.O$.from(json.max_debt),
    liquidationThreshold: bignumber/* BigNumber.from */.O$.from(json.liquidation_threshold),
    liquidationRatio: parseFloat(json.liquidation_ratio),
});
const compile = (a, v) => (Object.assign(Object.assign({}, a), { [v.address]: Object.assign({ address: v.address }, usk_castConfig(v.config)) }));
const MARKETS = {
    [network_MAINNET]: resources_contracts["kaiyo-1"].uskMarket.reduce(compile, {}),
    [TESTNET]: resources_contracts["harpoon-4"].uskMarket.reduce(compile, {}),
    [POND]: {},
};
const usk_castPosition = (p) => ({
    owner: p.owner,
    deposit_amount: BigNumber.from(p.deposit_amount),
    mint_amount: BigNumber.from(p.mint_amount),
    interest_amount: BigNumber.from(p.interest_amount),
    liquidation_price: p.liquidation_price
        ? parseFloat(p.liquidation_price)
        : null,
});
const defaultPosition = (owner) => ({
    owner: owner || "",
    deposit_amount: BigNumber.from(0),
    mint_amount: BigNumber.from(0),
    interest_amount: BigNumber.from(0),
    liquidation_price: null,
});
const fetchPosition = (queryClient, address, account) => queryClient.wasm
    .queryContractSmart(address, {
    position: { address: account.address },
})
    .then(usk_castPosition);

;// CONCATENATED MODULE: ./node_modules/kujira.js/lib/esm/fin/margin.js




const castPositionLimit = (denoms) => (p) => ({
    idx: p.idx,
    owner: p.owner,
    margin_amount: BigNumber.from(p.margin_amount),
    mint_amount: BigNumber.from(p.mint_amount),
    interest_amount: BigNumber.from(p.interest_amount),
    liquidation_price: p.liquidation_price
        ? parseFloat(p.liquidation_price)
        : null,
    order: castOrder(denoms)(p.order),
});
const fetchPositionLimit = (queryClient, address, idx, denoms) => queryClient.wasm
    .queryContractSmart(address, {
    position: { idx },
})
    .then(castPositionLimit(denoms));
const fetchPositionsLimit = (queryClient, address, account, denoms) => queryClient.wasm
    .queryContractSmart(address, {
    positions: { owner: account.address },
})
    .then((xs) => xs.positions.map(castPositionLimit(denoms)));

;// CONCATENATED MODULE: ./node_modules/kujira.js/lib/esm/fin/pairs.js



const FILTERED = [
    "kujira18638dsuf7p3a2e23seqz8zegqrcpsdr5nw6j2a50qg6r3q8vn3qqrg9lzp",
    "kujira143thenn7ugsevf0tl3hz4ved53t6w5r7uq0qcwr8kxgg343jxg0svcrfjf",
    "kujira12g0jkp5hqlujw57akq2prkq4hq7hsy4qecmv93gdyzelggzpc4dsjtkvh2",
    "kujira1qshjsyprd79w5q494themln57qz35txt2kx7yc6c0u4nmd4cy27qanxdlc",
    "kujira1kc3msrd9gvnfumfcshlkvcdgklf9m9ln7llfqsxqalcfk9xjr5uqdy8us6",
    "kujira13l8gwanf37938wgfv5yktmfzxjwaj4ysn4gl96vj78xcqqxlcrgssfl797",
    "kujira1vt9lmzw5wc9gss07ty9cf8ytpy7se77u7xytylv4xvklsfggmxgquklr7p",
    "kujira1467jk0ljtesmtcut5tec9j4a6rnu59vd38ea5n0q2y6k85qk803qqqhsg8",
    "kujira1trxh7pu70dmzpqyqs4yltx2h5202k9e9fpssee0tdq4x2jr9praqg7c96e",
];
const NOTICES = {
    kujira1v8lkqws3gd6npr0rdk9ch54amh9guas86r4u62jq27hee88lryfsxwrvlk: "The FURY token from JUNO will be replaced by the native staking token from the new FURY blockchain after launch. A snapshot of token holders was taken at block height 9200000 on Juno",
    kujira1cduudfszcm9slm8qxlaqvnpzg2u0hkus94fe3pwt9x446dtw6eeql8ualz: "This SHD token from Shade Protocol was replaced with a new version. Tokens can be migrated on [Shade Protocol's app](https://app.shadeprotocol.io/migrate). Trade the new token [here](https://fin.kujira.network/trade/kujira1vdv74x0w4mq2v57r4mydps89jw4wsrqtrxez3tylzqwmy972a9fssy5e3y).",
    kujira1kmw6fk5p7an27u8f3er08xrwvzlehczymgshkqxzfrxyrfleu2eqxykaln: "The RAC token from the Juno network has been replaced with a native token on Migaloo. See [their medium post](https://medium.com/@racoon-supply/rac-is-now-an-ibc-asset-1dccad0df7bb) for instructions on how to migrate",
};

const STAKING = {
    [TESTNET]: "kujira1e7hxytqdg6v05f8ev3wrfcm5ecu3qyhl7y4ga73z76yuufnlk2rqd4uwf4",
    [network_MAINNET]: "kujira1p2j2cq4g3jjrz53ceku725t4uectn89hw35sehf8fpq9qfzvufeqymyem8",
};
const pairs_castConfig = (json) => ({
    denoms: [
        denom_Denom.from(typeof json.denoms[0] === "string"
            ? json.denoms[0]
            : json.denoms[0].native),
        denom_Denom.from(typeof json.denoms[1] === "string"
            ? json.denoms[1]
            : json.denoms[1].native),
    ],
    precision: { decimal_places: json.price_precision.decimal_places },
    decimalDelta: json.decimal_delta || 0,
    multiswap: true,
});
const pairs_compile = (network) => (a, v) => {
    var _a, _b, _c;
    if (FILTERED.includes(v.address))
        return a;
    const config = pairs_castConfig(v.config);
    const margin = resources_contracts[network].uskMarginSwap.find((m) => m.config.fin_address === v.address);
    return Object.assign(Object.assign({}, a), { [v.address]: Object.assign(Object.assign({ address: v.address }, config), { pool: (_a = resources_contracts[network].bow
                // Reverse as the laterly created contracts are more likely to be correct
                .reverse()
                // @ts-ignore
                .find((b) => b.config.fin_contract === v.address &&
                v.config.price_precision.decimal_places ===
                    b.config.price_precision.decimal_places &&
                ![
                    "kujira188p624ykuepun8h8kjmcfs553mz2jgeanetyqv7l6xltdld497vqespn6c",
                    "kujira136rwqvwy3flttm9wfnc5xgnlr6mu5k8e2elgzs2hdhuwf50w3l2qp807cx",
                    "kujira1xgjefq7fs4yj29t9gk0t9esgw52s68j83yeac3ru2mefdp529qsqca7hhv",
                    "kujira167gut7dskwurax8an630m3yy2cwa2fp3kmcpdzucyy6ppg7njgyqhl7w50",
                    "kujira1ywlrdpqymukghjwhfyp2n98r49j56wej36n4l08egkdlwj4fn87ql2l2ey",
                    "kujira1dj2s8uvup63fsmpfdfpmu570es4whswp806w0p6usdamtglhwvfqd5jx40",
                    "kujira1cdy6aje8zszx5vryttkkm5rn9g2n53ltfds753fsn63m09cmhx0sgp6v6m",
                    "kujira1h356yzzk2yw7q5s26dewdgaptw05fxplgmxdxcfqcatjyurckuks6zfay8",
                    "kujira19a0wethewg36vny9jremekzlx66lwljp2htrhe255mp6djv652dqsu2l76",
                    "kujira1xdjt8r39nvm03fs4d9cwyw2sks5dahs52msza59y4vevdgdwhtlq9e3vvg",
                ].includes(b.address))) === null || _a === void 0 ? void 0 : _a.address, calc: ((_b = resources_contracts[network].calc[0]) === null || _b === void 0 ? void 0 : _b.pairs.find((x) => x.denoms[0] === config.denoms[0].reference &&
                x.denoms[1] === config.denoms[1].reference))
                ? (_c = resources_contracts[network].calc[0]) === null || _c === void 0 ? void 0 : _c.address
                : undefined, margin: margin
                ? Object.assign({ address: margin.address }, usk_castConfig(margin.config.market)) : undefined }) });
};
const PAIRS = {
    [network_MAINNET]: resources_contracts["kaiyo-1"].fin.reduce(pairs_compile("kaiyo-1"), {}),
    [TESTNET]: resources_contracts["harpoon-4"].fin.reduce(pairs_compile("harpoon-4"), {}),
    [POND]: {},
};

;// CONCATENATED MODULE: ./node_modules/kujira.js/lib/esm/fin.js
var fin_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};





class FinQueryClient {
    constructor(client, contractAddress) {
        this.config = () => fin_awaiter(this, void 0, void 0, function* () {
            return this.client.queryContractSmart(this.contractAddress, {
                config: {},
            });
        });
        this.simulation = ({ offerAsset, }) => fin_awaiter(this, void 0, void 0, function* () {
            return this.client.queryContractSmart(this.contractAddress, {
                simulation: {
                    offer_asset: offerAsset,
                },
            });
        });
        this.order = ({ orderIdx, }) => fin_awaiter(this, void 0, void 0, function* () {
            return this.client.queryContractSmart(this.contractAddress, {
                order: {
                    order_idx: orderIdx,
                },
            });
        });
        this.ordersByUser = ({ address, limit, startAfter, }) => fin_awaiter(this, void 0, void 0, function* () {
            return this.client.queryContractSmart(this.contractAddress, {
                orders_by_user: {
                    address,
                    limit,
                    start_after: startAfter,
                },
            });
        });
        this.price = ({ price }) => fin_awaiter(this, void 0, void 0, function* () {
            return this.client.queryContractSmart(this.contractAddress, {
                price: {
                    price,
                },
            });
        });
        this.book = ({ limit, offset, }) => fin_awaiter(this, void 0, void 0, function* () {
            return this.client.queryContractSmart(this.contractAddress, {
                book: {
                    limit,
                    offset,
                },
            });
        });
        this.client = client;
        this.contractAddress = contractAddress;
        this.config = this.config.bind(this);
        this.simulation = this.simulation.bind(this);
        this.order = this.order.bind(this);
        this.ordersByUser = this.ordersByUser.bind(this);
        this.price = this.price.bind(this);
        this.book = this.book.bind(this);
    }
}
class FinClient extends (/* unused pure expression or super */ null && (FinQueryClient)) {
    constructor(client, sender, contractAddress) {
        super(client, contractAddress);
        this.receive = ({ amount, msg, sender, }, fee = "auto", memo, funds) => fin_awaiter(this, void 0, void 0, function* () {
            return yield this.client.execute(this.sender, this.contractAddress, {
                receive: {
                    amount,
                    msg,
                    sender,
                },
            }, fee, memo, funds);
        });
        this.launch = (fee = "auto", memo, funds) => fin_awaiter(this, void 0, void 0, function* () {
            return yield this.client.execute(this.sender, this.contractAddress, {
                launch: {},
            }, fee, memo, funds);
        });
        this.updateConfig = ({ owner, pricePrecision, }, fee = "auto", memo, funds) => fin_awaiter(this, void 0, void 0, function* () {
            return yield this.client.execute(this.sender, this.contractAddress, {
                update_config: {
                    owner,
                    price_precision: pricePrecision,
                },
            }, fee, memo, funds);
        });
        this.submitOrder = ({ price, }, fee = "auto", memo, funds) => fin_awaiter(this, void 0, void 0, function* () {
            return yield this.client.execute(this.sender, this.contractAddress, {
                submit_order: {
                    price,
                },
            }, fee, memo, funds);
        });
        this.swap = ({ beliefPrice, maxSpread, offerAsset, to, }, fee = "auto", memo, funds) => fin_awaiter(this, void 0, void 0, function* () {
            return yield this.client.execute(this.sender, this.contractAddress, {
                swap: {
                    belief_price: beliefPrice,
                    max_spread: maxSpread,
                    offer_asset: offerAsset,
                    to,
                },
            }, fee, memo, funds);
        });
        this.retractOrder = ({ amount, orderIdx, }, fee = "auto", memo, funds) => fin_awaiter(this, void 0, void 0, function* () {
            return yield this.client.execute(this.sender, this.contractAddress, {
                retract_order: {
                    amount,
                    order_idx: orderIdx,
                },
            }, fee, memo, funds);
        });
        this.retractOrders = ({ orderIdxs, }, fee = "auto", memo, funds) => fin_awaiter(this, void 0, void 0, function* () {
            return yield this.client.execute(this.sender, this.contractAddress, {
                retract_orders: {
                    order_idxs: orderIdxs,
                },
            }, fee, memo, funds);
        });
        this.withdrawOrders = ({ orderIdxs, }, fee = "auto", memo, funds) => fin_awaiter(this, void 0, void 0, function* () {
            return yield this.client.execute(this.sender, this.contractAddress, {
                withdraw_orders: {
                    order_idxs: orderIdxs,
                },
            }, fee, memo, funds);
        });
        this.client = client;
        this.sender = sender;
        this.contractAddress = contractAddress;
        this.receive = this.receive.bind(this);
        this.launch = this.launch.bind(this);
        this.updateConfig = this.updateConfig.bind(this);
        this.submitOrder = this.submitOrder.bind(this);
        this.swap = this.swap.bind(this);
        this.retractOrder = this.retractOrder.bind(this);
        this.retractOrders = this.retractOrders.bind(this);
        this.withdrawOrders = this.withdrawOrders.bind(this);
    }
}

;// CONCATENATED MODULE: ./node_modules/kujira.js/lib/esm/ghost.js





const ghost_FILTERED = [
    "kujira1fj2y8uslgw89x50scw7njwxjg4f42u84hkw3nguf3kn0fm69wxqsrl3p6k",
    "kujira14r4d6xw6jgu6d4en0uxalx9slaft54h499scmeyj63w4axavhvuqdgfr8d",
];
const castVaultState = (res) => {
    const deposited = BigNumber.from(res.deposited);
    const lent = BigNumber.from(res.borrowed);
    const interestRate = parseFloat(res.rate);
    return {
        deposited,
        lent,
        available: deposited.sub(lent),
        interestRate,
        apr: divToNumber(mulDec(lent, interestRate), deposited),
        redemptionRate: parseFixed(res.deposit_redemption_ratio, 18),
        debtShareRatio: parseFixed(res.debt_share_ratio, 18),
    };
};
const DEFAULT_MARKET_STATE = {
    deposited: bignumber/* BigNumber.from */.O$.from(0),
    borrowed: bignumber/* BigNumber.from */.O$.from(0),
};
const DEFAULT_VAULT_STATE = {
    deposited: bignumber/* BigNumber.from */.O$.from(0),
    lent: bignumber/* BigNumber.from */.O$.from(0),
    available: bignumber/* BigNumber.from */.O$.from(0),
    interestRate: 0,
    apr: 0,
    redemptionRate: fixednumber_parseFixed("1", 18),
    debtShareRatio: fixednumber_parseFixed("1", 18),
};
const ghost_castPosition = (res) => ({
    debtShares: BigNumber.from(res.debt_shares),
    collateralAmount: BigNumber.from(res.collateral_amount),
});
const castMarket = (address, raw, vault) => ({
    address,
    owner: raw.owner,
    collateralDenom: denom_Denom.from(raw.collateral_denom),
    collateralOracleDenom: raw.collateral_oracle_denom,
    collateralDecimals: raw.collateral_decimals,
    maxLtv: parseFloat(raw.max_ltv),
    vault,
    borrowFee: fixednumber_parseFixed(raw.borrow_fee, 18),
    orcaAddress: raw.orca_addr,
});
const castVault = (address, raw, markets) => ({
    address,
    owner: raw.owner,
    denom: denom_Denom.from(raw.denom),
    oracle: "static" in raw.oracle
        ? { static: fixednumber_parseFixed(raw.oracle.static, 18) }
        : raw.oracle,
    decimals: raw.decimals,
    receiptDenom: denom_Denom.from(raw.receipt_denom),
    debtTokenDenom: denom_Denom.from(raw.debt_token_denom),
    markets: markets.map((m) => ({
        addr: m.addr,
        borrowLimit: m.borrow_limit ? bignumber/* BigNumber.from */.O$.from(m.borrow_limit) : null,
    })),
    interest: castInterest(raw.interest),
});
const castInterest = (raw) => ({
    type: "curve",
    value: raw.utilization_to_curve.map((x) => [
        fixednumber_parseFixed(x[0], 18),
        {
            linear: {
                start: [
                    fixednumber_parseFixed(x[1].linear.start[0], 18),
                    fixednumber_parseFixed(x[1].linear.start[1], 18),
                ],
                end: [
                    fixednumber_parseFixed(x[1].linear.end[0], 18),
                    fixednumber_parseFixed(x[1].linear.end[1], 18),
                ],
            },
        },
    ]),
});
const VAULTS = {
    [network_MAINNET]: resources_contracts[network_MAINNET].ghostVault.reduce((a, v) => ghost_FILTERED.includes(v.address)
        ? a
        : Object.assign(Object.assign({}, a), { [v.address]: castVault(v.address, 
            // @ts-expect-error TS not liking the Rust serialization of tuples
            v.config, v.markets || []) }), {}),
    [TESTNET]: resources_contracts[TESTNET].ghostVault.reduce((a, v) => ghost_FILTERED.includes(v.address)
        ? a
        : Object.assign(Object.assign({}, a), { [v.address]: castVault(v.address, 
            // @ts-expect-error TS not liking the Rust serialization of tuples
            v.config, v.markets || []) }), {}),
    [POND]: {},
};
const ghost_MARKETS = {
    [network_MAINNET]: resources_contracts[network_MAINNET].ghostMarket.reduce((a, v) => ghost_FILTERED.includes(v.address)
        ? a
        : VAULTS[network_MAINNET][v.config.vault_addr]
            ? Object.assign(Object.assign({}, a), { [v.address]: castMarket(v.address, v.config, VAULTS[network_MAINNET][v.config.vault_addr]) }) : a, {}),
    [TESTNET]: resources_contracts[TESTNET].ghostMarket.reduce((a, v) => ghost_FILTERED.includes(v.address)
        ? a
        : VAULTS[TESTNET][v.config.vault_addr]
            ? Object.assign(Object.assign({}, a), { [v.address]: castMarket(v.address, v.config, VAULTS[TESTNET][v.config.vault_addr]) }) : a, {}),
    [POND]: {},
};

// EXTERNAL MODULE: ./node_modules/kujira.js/node_modules/@cosmjs/proto-signing/build/index.js
var proto_signing_build = __webpack_require__(75216);
// EXTERNAL MODULE: ./node_modules/kujira.js/node_modules/cosmjs-types/cosmos/base/v1beta1/coin.js
var coin = __webpack_require__(81637);
// EXTERNAL MODULE: ./node_modules/kujira.js/node_modules/cosmjs-types/google/protobuf/any.js
var any = __webpack_require__(75654);
;// CONCATENATED MODULE: ./node_modules/kujira.js/lib/esm/gravity/v1/helpers.js
/* eslint-disable */
/**
 * This file and any referenced files were automatically generated by @osmonauts/telescope@0.69.0
 * DO NOT MODIFY BY HAND. Instead, download the latest proto files for your chain
 * and run the transpile command or yarn proto command to regenerate this bundle.
 */


// @ts-ignore
if (minimal.util.Long !== (long_default())) {
    minimal.util.Long = (long_default());
    minimal.configure();
}

var helpers_globalThis = (() => {
    if (typeof helpers_globalThis !== "undefined")
        return helpers_globalThis;
    if (typeof self !== "undefined")
        return self;
    if (typeof window !== "undefined")
        return window;
    if (typeof __webpack_require__.g !== "undefined")
        return __webpack_require__.g;
    throw "Unable to locate global object";
})();
const atob = helpers_globalThis.atob ||
    ((b64) => helpers_globalThis.Buffer.from(b64, "base64").toString("binary"));
function bytesFromBase64(b64) {
    const bin = atob(b64);
    const arr = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; ++i) {
        arr[i] = bin.charCodeAt(i);
    }
    return arr;
}
const btoa = helpers_globalThis.btoa ||
    ((bin) => helpers_globalThis.Buffer.from(bin, "binary").toString("base64"));
function base64FromBytes(arr) {
    const bin = [];
    arr.forEach((byte) => {
        bin.push(String.fromCharCode(byte));
    });
    return btoa(bin.join(""));
}
function omitDefault(input) {
    if (typeof input === "string") {
        return input === "" ? undefined : input;
    }
    if (typeof input === "number") {
        return input === 0 ? undefined : input;
    }
    if (Long.isLong(input)) {
        return input.isZero() ? undefined : input;
    }
    throw new Error(`Got unsupported type ${typeof input}`);
}
function toDuration(duration) {
    return {
        seconds: Long.fromNumber(Math.floor(parseInt(duration) / 1000000000)),
        nanos: parseInt(duration) % 1000000000,
    };
}
function fromDuration(duration) {
    return (parseInt(duration.seconds.toString()) * 1000000000 +
        duration.nanos).toString();
}
function isSet(value) {
    return value !== null && value !== undefined;
}
function isObject(value) {
    return typeof value === "object" && value !== null;
}
const setPaginationParams = (options, pagination) => {
    if (!pagination) {
        return options;
    }
    if (typeof (pagination === null || pagination === void 0 ? void 0 : pagination.countTotal) !== "undefined") {
        options.params["pagination.count_total"] = pagination.countTotal;
    }
    if (typeof (pagination === null || pagination === void 0 ? void 0 : pagination.key) !== "undefined") {
        // String to Uint8Array
        // let uint8arr = new Uint8Array(Buffer.from(data,'base64'));
        // Uint8Array to String
        options.params["pagination.key"] = helpers_globalThis.Buffer.from(pagination.key).toString("base64");
    }
    if (typeof (pagination === null || pagination === void 0 ? void 0 : pagination.limit) !== "undefined") {
        options.params["pagination.limit"] = pagination.limit.toString();
    }
    if (typeof (pagination === null || pagination === void 0 ? void 0 : pagination.offset) !== "undefined") {
        options.params["pagination.offset"] = pagination.offset.toString();
    }
    if (typeof (pagination === null || pagination === void 0 ? void 0 : pagination.reverse) !== "undefined") {
        options.params["pagination.reverse"] = pagination.reverse;
    }
    return options;
};
function toTimestamp(date) {
    const seconds = numberToLong(date.getTime() / 1000);
    const nanos = (date.getTime() % 1000) * 1000000;
    return {
        seconds,
        nanos,
    };
}
function fromTimestamp(t) {
    let millis = t.seconds.toNumber() * 1000;
    millis += t.nanos / 1000000;
    return new Date(millis);
}
const fromJSON = (object) => {
    return {
        seconds: isSet(object.seconds)
            ? Long.fromString(object.seconds)
            : Long.ZERO,
        nanos: isSet(object.nanos) ? Number(object.nanos) : 0,
    };
};
const timestampFromJSON = (object) => {
    return {
        seconds: isSet(object.seconds) ? long_default().fromValue(object.seconds) : (long_default()).ZERO,
        nanos: isSet(object.nanos) ? Number(object.nanos) : 0,
    };
};
function fromJsonTimestamp(o) {
    if (o instanceof Date) {
        return toTimestamp(o);
    }
    else if (typeof o === "string") {
        return toTimestamp(new Date(o));
    }
    else {
        return timestampFromJSON(o);
    }
}
function numberToLong(number) {
    return long_default().fromNumber(number);
}

// EXTERNAL MODULE: ./node_modules/kujira.js/node_modules/cosmjs-types/cosmos/bank/v1beta1/bank.js
var bank = __webpack_require__(674);
;// CONCATENATED MODULE: ./node_modules/kujira.js/lib/esm/gravity/v1/types.js
/* eslint-disable */




const protobufPackage = "gravity.v1";
function createBaseBridgeValidator() {
    return {
        power: (long_default()).UZERO,
        ethereumAddress: "",
    };
}
const BridgeValidator = {
    encode(message, writer = minimal.Writer.create()) {
        if (!message.power.isZero()) {
            writer.uint32(8).uint64(message.power);
        }
        if (message.ethereumAddress !== "") {
            writer.uint32(18).string(message.ethereumAddress);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseBridgeValidator();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.power = reader.uint64();
                    break;
                case 2:
                    message.ethereumAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            power: isSet(object.power) ? long_default().fromValue(object.power) : (long_default()).UZERO,
            ethereumAddress: isSet(object.ethereumAddress)
                ? String(object.ethereumAddress)
                : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.power !== undefined &&
            (obj.power = (message.power || (long_default()).UZERO).toString());
        message.ethereumAddress !== undefined &&
            (obj.ethereumAddress = message.ethereumAddress);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseBridgeValidator();
        message.power =
            object.power !== undefined && object.power !== null
                ? long_default().fromValue(object.power)
                : (long_default()).UZERO;
        message.ethereumAddress = (_a = object.ethereumAddress) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
function createBaseValset() {
    return {
        nonce: (long_default()).UZERO,
        members: [],
        height: (long_default()).UZERO,
        rewardAmount: "",
        rewardToken: "",
    };
}
const Valset = {
    encode(message, writer = minimal.Writer.create()) {
        if (!message.nonce.isZero()) {
            writer.uint32(8).uint64(message.nonce);
        }
        for (const v of message.members) {
            BridgeValidator.encode(v, writer.uint32(18).fork()).ldelim();
        }
        if (!message.height.isZero()) {
            writer.uint32(24).uint64(message.height);
        }
        if (message.rewardAmount !== "") {
            writer.uint32(34).string(message.rewardAmount);
        }
        if (message.rewardToken !== "") {
            writer.uint32(42).string(message.rewardToken);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseValset();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.nonce = reader.uint64();
                    break;
                case 2:
                    message.members.push(BridgeValidator.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.height = reader.uint64();
                    break;
                case 4:
                    message.rewardAmount = reader.string();
                    break;
                case 5:
                    message.rewardToken = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            nonce: isSet(object.nonce) ? long_default().fromValue(object.nonce) : (long_default()).UZERO,
            members: Array.isArray(object === null || object === void 0 ? void 0 : object.members)
                ? object.members.map((e) => BridgeValidator.fromJSON(e))
                : [],
            height: isSet(object.height) ? long_default().fromValue(object.height) : (long_default()).UZERO,
            rewardAmount: isSet(object.rewardAmount)
                ? String(object.rewardAmount)
                : "",
            rewardToken: isSet(object.rewardToken) ? String(object.rewardToken) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.nonce !== undefined &&
            (obj.nonce = (message.nonce || (long_default()).UZERO).toString());
        if (message.members) {
            obj.members = message.members.map((e) => e ? BridgeValidator.toJSON(e) : undefined);
        }
        else {
            obj.members = [];
        }
        message.height !== undefined &&
            (obj.height = (message.height || (long_default()).UZERO).toString());
        message.rewardAmount !== undefined &&
            (obj.rewardAmount = message.rewardAmount);
        message.rewardToken !== undefined &&
            (obj.rewardToken = message.rewardToken);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseValset();
        message.nonce =
            object.nonce !== undefined && object.nonce !== null
                ? long_default().fromValue(object.nonce)
                : (long_default()).UZERO;
        message.members =
            ((_a = object.members) === null || _a === void 0 ? void 0 : _a.map((e) => BridgeValidator.fromPartial(e))) || [];
        message.height =
            object.height !== undefined && object.height !== null
                ? long_default().fromValue(object.height)
                : (long_default()).UZERO;
        message.rewardAmount = (_b = object.rewardAmount) !== null && _b !== void 0 ? _b : "";
        message.rewardToken = (_c = object.rewardToken) !== null && _c !== void 0 ? _c : "";
        return message;
    },
};
function createBaseLastObservedEthereumBlockHeight() {
    return {
        cosmosBlockHeight: (long_default()).UZERO,
        ethereumBlockHeight: (long_default()).UZERO,
    };
}
const LastObservedEthereumBlockHeight = {
    encode(message, writer = minimal.Writer.create()) {
        if (!message.cosmosBlockHeight.isZero()) {
            writer.uint32(8).uint64(message.cosmosBlockHeight);
        }
        if (!message.ethereumBlockHeight.isZero()) {
            writer.uint32(16).uint64(message.ethereumBlockHeight);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseLastObservedEthereumBlockHeight();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.cosmosBlockHeight = reader.uint64();
                    break;
                case 2:
                    message.ethereumBlockHeight = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            cosmosBlockHeight: isSet(object.cosmosBlockHeight)
                ? long_default().fromValue(object.cosmosBlockHeight)
                : (long_default()).UZERO,
            ethereumBlockHeight: isSet(object.ethereumBlockHeight)
                ? long_default().fromValue(object.ethereumBlockHeight)
                : (long_default()).UZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        message.cosmosBlockHeight !== undefined &&
            (obj.cosmosBlockHeight = (message.cosmosBlockHeight || (long_default()).UZERO).toString());
        message.ethereumBlockHeight !== undefined &&
            (obj.ethereumBlockHeight = (message.ethereumBlockHeight || (long_default()).UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseLastObservedEthereumBlockHeight();
        message.cosmosBlockHeight =
            object.cosmosBlockHeight !== undefined &&
                object.cosmosBlockHeight !== null
                ? long_default().fromValue(object.cosmosBlockHeight)
                : (long_default()).UZERO;
        message.ethereumBlockHeight =
            object.ethereumBlockHeight !== undefined &&
                object.ethereumBlockHeight !== null
                ? long_default().fromValue(object.ethereumBlockHeight)
                : (long_default()).UZERO;
        return message;
    },
};
function createBaseERC20ToDenom() {
    return {
        erc20: "",
        denom: "",
    };
}
const ERC20ToDenom = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.erc20 !== "") {
            writer.uint32(10).string(message.erc20);
        }
        if (message.denom !== "") {
            writer.uint32(18).string(message.denom);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseERC20ToDenom();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.erc20 = reader.string();
                    break;
                case 2:
                    message.denom = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            erc20: isSet(object.erc20) ? String(object.erc20) : "",
            denom: isSet(object.denom) ? String(object.denom) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.erc20 !== undefined && (obj.erc20 = message.erc20);
        message.denom !== undefined && (obj.denom = message.denom);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseERC20ToDenom();
        message.erc20 = (_a = object.erc20) !== null && _a !== void 0 ? _a : "";
        message.denom = (_b = object.denom) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
function createBaseUnhaltBridgeProposal() {
    return {
        title: "",
        description: "",
        targetNonce: (long_default()).UZERO,
    };
}
const UnhaltBridgeProposal = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.title !== "") {
            writer.uint32(10).string(message.title);
        }
        if (message.description !== "") {
            writer.uint32(18).string(message.description);
        }
        if (!message.targetNonce.isZero()) {
            writer.uint32(32).uint64(message.targetNonce);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUnhaltBridgeProposal();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.title = reader.string();
                    break;
                case 2:
                    message.description = reader.string();
                    break;
                case 4:
                    message.targetNonce = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            title: isSet(object.title) ? String(object.title) : "",
            description: isSet(object.description) ? String(object.description) : "",
            targetNonce: isSet(object.targetNonce)
                ? long_default().fromValue(object.targetNonce)
                : (long_default()).UZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        message.title !== undefined && (obj.title = message.title);
        message.description !== undefined &&
            (obj.description = message.description);
        message.targetNonce !== undefined &&
            (obj.targetNonce = (message.targetNonce || (long_default()).UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseUnhaltBridgeProposal();
        message.title = (_a = object.title) !== null && _a !== void 0 ? _a : "";
        message.description = (_b = object.description) !== null && _b !== void 0 ? _b : "";
        message.targetNonce =
            object.targetNonce !== undefined && object.targetNonce !== null
                ? long_default().fromValue(object.targetNonce)
                : (long_default()).UZERO;
        return message;
    },
};
function createBaseAirdropProposal() {
    return {
        title: "",
        description: "",
        denom: "",
        recipients: new Uint8Array(),
        amounts: [],
    };
}
const AirdropProposal = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.title !== "") {
            writer.uint32(10).string(message.title);
        }
        if (message.description !== "") {
            writer.uint32(18).string(message.description);
        }
        if (message.denom !== "") {
            writer.uint32(26).string(message.denom);
        }
        if (message.recipients.length !== 0) {
            writer.uint32(34).bytes(message.recipients);
        }
        writer.uint32(42).fork();
        for (const v of message.amounts) {
            writer.uint64(v);
        }
        writer.ldelim();
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAirdropProposal();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.title = reader.string();
                    break;
                case 2:
                    message.description = reader.string();
                    break;
                case 3:
                    message.denom = reader.string();
                    break;
                case 4:
                    message.recipients = reader.bytes();
                    break;
                case 5:
                    if ((tag & 7) === 2) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.amounts.push(reader.uint64());
                        }
                    }
                    else {
                        message.amounts.push(reader.uint64());
                    }
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            title: isSet(object.title) ? String(object.title) : "",
            description: isSet(object.description) ? String(object.description) : "",
            denom: isSet(object.denom) ? String(object.denom) : "",
            recipients: isSet(object.recipients)
                ? bytesFromBase64(object.recipients)
                : new Uint8Array(),
            amounts: Array.isArray(object === null || object === void 0 ? void 0 : object.amounts)
                ? object.amounts.map((e) => long_default().fromValue(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        message.title !== undefined && (obj.title = message.title);
        message.description !== undefined &&
            (obj.description = message.description);
        message.denom !== undefined && (obj.denom = message.denom);
        message.recipients !== undefined &&
            (obj.recipients = base64FromBytes(message.recipients !== undefined ? message.recipients : new Uint8Array()));
        if (message.amounts) {
            obj.amounts = message.amounts.map((e) => (e || (long_default()).UZERO).toString());
        }
        else {
            obj.amounts = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e;
        const message = createBaseAirdropProposal();
        message.title = (_a = object.title) !== null && _a !== void 0 ? _a : "";
        message.description = (_b = object.description) !== null && _b !== void 0 ? _b : "";
        message.denom = (_c = object.denom) !== null && _c !== void 0 ? _c : "";
        message.recipients = (_d = object.recipients) !== null && _d !== void 0 ? _d : new Uint8Array();
        message.amounts = ((_e = object.amounts) === null || _e === void 0 ? void 0 : _e.map((e) => long_default().fromValue(e))) || [];
        return message;
    },
};
function createBaseIBCMetadataProposal() {
    return {
        title: "",
        description: "",
        metadata: undefined,
        ibcDenom: "",
    };
}
const IBCMetadataProposal = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.title !== "") {
            writer.uint32(10).string(message.title);
        }
        if (message.description !== "") {
            writer.uint32(18).string(message.description);
        }
        if (message.metadata !== undefined) {
            bank.Metadata.encode(message.metadata, writer.uint32(26).fork()).ldelim();
        }
        if (message.ibcDenom !== "") {
            writer.uint32(34).string(message.ibcDenom);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseIBCMetadataProposal();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.title = reader.string();
                    break;
                case 2:
                    message.description = reader.string();
                    break;
                case 3:
                    message.metadata = bank.Metadata.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.ibcDenom = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            title: isSet(object.title) ? String(object.title) : "",
            description: isSet(object.description) ? String(object.description) : "",
            metadata: isSet(object.metadata)
                ? bank.Metadata.fromJSON(object.metadata)
                : undefined,
            ibcDenom: isSet(object.ibcDenom) ? String(object.ibcDenom) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.title !== undefined && (obj.title = message.title);
        message.description !== undefined &&
            (obj.description = message.description);
        message.metadata !== undefined &&
            (obj.metadata = message.metadata
                ? bank.Metadata.toJSON(message.metadata)
                : undefined);
        message.ibcDenom !== undefined && (obj.ibcDenom = message.ibcDenom);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseIBCMetadataProposal();
        message.title = (_a = object.title) !== null && _a !== void 0 ? _a : "";
        message.description = (_b = object.description) !== null && _b !== void 0 ? _b : "";
        message.metadata =
            object.metadata !== undefined && object.metadata !== null
                ? bank.Metadata.fromPartial(object.metadata)
                : undefined;
        message.ibcDenom = (_c = object.ibcDenom) !== null && _c !== void 0 ? _c : "";
        return message;
    },
};
function createBasePendingIbcAutoForward() {
    return {
        foreignReceiver: "",
        token: undefined,
        ibcChannel: "",
        eventNonce: (long_default()).UZERO,
    };
}
const PendingIbcAutoForward = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.foreignReceiver !== "") {
            writer.uint32(10).string(message.foreignReceiver);
        }
        if (message.token !== undefined) {
            coin.Coin.encode(message.token, writer.uint32(18).fork()).ldelim();
        }
        if (message.ibcChannel !== "") {
            writer.uint32(26).string(message.ibcChannel);
        }
        if (!message.eventNonce.isZero()) {
            writer.uint32(32).uint64(message.eventNonce);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePendingIbcAutoForward();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.foreignReceiver = reader.string();
                    break;
                case 2:
                    message.token = coin.Coin.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.ibcChannel = reader.string();
                    break;
                case 4:
                    message.eventNonce = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            foreignReceiver: isSet(object.foreignReceiver)
                ? String(object.foreignReceiver)
                : "",
            token: isSet(object.token) ? coin.Coin.fromJSON(object.token) : undefined,
            ibcChannel: isSet(object.ibcChannel) ? String(object.ibcChannel) : "",
            eventNonce: isSet(object.eventNonce)
                ? long_default().fromValue(object.eventNonce)
                : (long_default()).UZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        message.foreignReceiver !== undefined &&
            (obj.foreignReceiver = message.foreignReceiver);
        message.token !== undefined &&
            (obj.token = message.token ? coin.Coin.toJSON(message.token) : undefined);
        message.ibcChannel !== undefined && (obj.ibcChannel = message.ibcChannel);
        message.eventNonce !== undefined &&
            (obj.eventNonce = (message.eventNonce || (long_default()).UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBasePendingIbcAutoForward();
        message.foreignReceiver = (_a = object.foreignReceiver) !== null && _a !== void 0 ? _a : "";
        message.token =
            object.token !== undefined && object.token !== null
                ? coin.Coin.fromPartial(object.token)
                : undefined;
        message.ibcChannel = (_b = object.ibcChannel) !== null && _b !== void 0 ? _b : "";
        message.eventNonce =
            object.eventNonce !== undefined && object.eventNonce !== null
                ? long_default().fromValue(object.eventNonce)
                : (long_default()).UZERO;
        return message;
    },
};

;// CONCATENATED MODULE: ./node_modules/kujira.js/lib/esm/gravity/v1/msgs.js
/* eslint-disable */






const msgs_protobufPackage = "gravity.v1";
function createBaseMsgSetOrchestratorAddress() {
    return {
        validator: "",
        orchestrator: "",
        ethAddress: "",
    };
}
const MsgSetOrchestratorAddress = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.validator !== "") {
            writer.uint32(10).string(message.validator);
        }
        if (message.orchestrator !== "") {
            writer.uint32(18).string(message.orchestrator);
        }
        if (message.ethAddress !== "") {
            writer.uint32(26).string(message.ethAddress);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgSetOrchestratorAddress();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.validator = reader.string();
                    break;
                case 2:
                    message.orchestrator = reader.string();
                    break;
                case 3:
                    message.ethAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            validator: isSet(object.validator) ? String(object.validator) : "",
            orchestrator: isSet(object.orchestrator)
                ? String(object.orchestrator)
                : "",
            ethAddress: isSet(object.ethAddress) ? String(object.ethAddress) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.validator !== undefined && (obj.validator = message.validator);
        message.orchestrator !== undefined &&
            (obj.orchestrator = message.orchestrator);
        message.ethAddress !== undefined && (obj.ethAddress = message.ethAddress);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseMsgSetOrchestratorAddress();
        message.validator = (_a = object.validator) !== null && _a !== void 0 ? _a : "";
        message.orchestrator = (_b = object.orchestrator) !== null && _b !== void 0 ? _b : "";
        message.ethAddress = (_c = object.ethAddress) !== null && _c !== void 0 ? _c : "";
        return message;
    },
};
function createBaseMsgSetOrchestratorAddressResponse() {
    return {};
}
const MsgSetOrchestratorAddressResponse = {
    encode(_, writer = minimal.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgSetOrchestratorAddressResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgSetOrchestratorAddressResponse();
        return message;
    },
};
function createBaseMsgValsetConfirm() {
    return {
        nonce: (long_default()).UZERO,
        orchestrator: "",
        ethAddress: "",
        signature: "",
    };
}
const MsgValsetConfirm = {
    encode(message, writer = minimal.Writer.create()) {
        if (!message.nonce.isZero()) {
            writer.uint32(8).uint64(message.nonce);
        }
        if (message.orchestrator !== "") {
            writer.uint32(18).string(message.orchestrator);
        }
        if (message.ethAddress !== "") {
            writer.uint32(26).string(message.ethAddress);
        }
        if (message.signature !== "") {
            writer.uint32(34).string(message.signature);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgValsetConfirm();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.nonce = reader.uint64();
                    break;
                case 2:
                    message.orchestrator = reader.string();
                    break;
                case 3:
                    message.ethAddress = reader.string();
                    break;
                case 4:
                    message.signature = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            nonce: isSet(object.nonce) ? long_default().fromValue(object.nonce) : (long_default()).UZERO,
            orchestrator: isSet(object.orchestrator)
                ? String(object.orchestrator)
                : "",
            ethAddress: isSet(object.ethAddress) ? String(object.ethAddress) : "",
            signature: isSet(object.signature) ? String(object.signature) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.nonce !== undefined &&
            (obj.nonce = (message.nonce || (long_default()).UZERO).toString());
        message.orchestrator !== undefined &&
            (obj.orchestrator = message.orchestrator);
        message.ethAddress !== undefined && (obj.ethAddress = message.ethAddress);
        message.signature !== undefined && (obj.signature = message.signature);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseMsgValsetConfirm();
        message.nonce =
            object.nonce !== undefined && object.nonce !== null
                ? long_default().fromValue(object.nonce)
                : (long_default()).UZERO;
        message.orchestrator = (_a = object.orchestrator) !== null && _a !== void 0 ? _a : "";
        message.ethAddress = (_b = object.ethAddress) !== null && _b !== void 0 ? _b : "";
        message.signature = (_c = object.signature) !== null && _c !== void 0 ? _c : "";
        return message;
    },
};
function createBaseMsgValsetConfirmResponse() {
    return {};
}
const MsgValsetConfirmResponse = {
    encode(_, writer = minimal.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgValsetConfirmResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgValsetConfirmResponse();
        return message;
    },
};
function createBaseMsgSendToEth() {
    return {
        sender: "",
        ethDest: "",
        amount: undefined,
        bridgeFee: undefined,
        chainFee: undefined,
    };
}
const MsgSendToEth = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.sender !== "") {
            writer.uint32(10).string(message.sender);
        }
        if (message.ethDest !== "") {
            writer.uint32(18).string(message.ethDest);
        }
        if (message.amount !== undefined) {
            coin.Coin.encode(message.amount, writer.uint32(26).fork()).ldelim();
        }
        if (message.bridgeFee !== undefined) {
            coin.Coin.encode(message.bridgeFee, writer.uint32(34).fork()).ldelim();
        }
        if (message.chainFee !== undefined) {
            coin.Coin.encode(message.chainFee, writer.uint32(42).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgSendToEth();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.sender = reader.string();
                    break;
                case 2:
                    message.ethDest = reader.string();
                    break;
                case 3:
                    message.amount = coin.Coin.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.bridgeFee = coin.Coin.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.chainFee = coin.Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            sender: isSet(object.sender) ? String(object.sender) : "",
            ethDest: isSet(object.ethDest) ? String(object.ethDest) : "",
            amount: isSet(object.amount) ? coin.Coin.fromJSON(object.amount) : undefined,
            bridgeFee: isSet(object.bridgeFee)
                ? coin.Coin.fromJSON(object.bridgeFee)
                : undefined,
            chainFee: isSet(object.chainFee)
                ? coin.Coin.fromJSON(object.chainFee)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.sender !== undefined && (obj.sender = message.sender);
        message.ethDest !== undefined && (obj.ethDest = message.ethDest);
        message.amount !== undefined &&
            (obj.amount = message.amount ? coin.Coin.toJSON(message.amount) : undefined);
        message.bridgeFee !== undefined &&
            (obj.bridgeFee = message.bridgeFee
                ? coin.Coin.toJSON(message.bridgeFee)
                : undefined);
        message.chainFee !== undefined &&
            (obj.chainFee = message.chainFee
                ? coin.Coin.toJSON(message.chainFee)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseMsgSendToEth();
        message.sender = (_a = object.sender) !== null && _a !== void 0 ? _a : "";
        message.ethDest = (_b = object.ethDest) !== null && _b !== void 0 ? _b : "";
        message.amount =
            object.amount !== undefined && object.amount !== null
                ? coin.Coin.fromPartial(object.amount)
                : undefined;
        message.bridgeFee =
            object.bridgeFee !== undefined && object.bridgeFee !== null
                ? coin.Coin.fromPartial(object.bridgeFee)
                : undefined;
        message.chainFee =
            object.chainFee !== undefined && object.chainFee !== null
                ? coin.Coin.fromPartial(object.chainFee)
                : undefined;
        return message;
    },
};
function createBaseMsgSendToEthResponse() {
    return {};
}
const MsgSendToEthResponse = {
    encode(_, writer = minimal.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgSendToEthResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgSendToEthResponse();
        return message;
    },
};
function createBaseMsgRequestBatch() {
    return {
        sender: "",
        denom: "",
    };
}
const MsgRequestBatch = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.sender !== "") {
            writer.uint32(10).string(message.sender);
        }
        if (message.denom !== "") {
            writer.uint32(18).string(message.denom);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgRequestBatch();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.sender = reader.string();
                    break;
                case 2:
                    message.denom = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            sender: isSet(object.sender) ? String(object.sender) : "",
            denom: isSet(object.denom) ? String(object.denom) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.sender !== undefined && (obj.sender = message.sender);
        message.denom !== undefined && (obj.denom = message.denom);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseMsgRequestBatch();
        message.sender = (_a = object.sender) !== null && _a !== void 0 ? _a : "";
        message.denom = (_b = object.denom) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
function createBaseMsgRequestBatchResponse() {
    return {};
}
const MsgRequestBatchResponse = {
    encode(_, writer = minimal.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgRequestBatchResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgRequestBatchResponse();
        return message;
    },
};
function createBaseMsgConfirmBatch() {
    return {
        nonce: (long_default()).UZERO,
        tokenContract: "",
        ethSigner: "",
        orchestrator: "",
        signature: "",
    };
}
const MsgConfirmBatch = {
    encode(message, writer = minimal.Writer.create()) {
        if (!message.nonce.isZero()) {
            writer.uint32(8).uint64(message.nonce);
        }
        if (message.tokenContract !== "") {
            writer.uint32(18).string(message.tokenContract);
        }
        if (message.ethSigner !== "") {
            writer.uint32(26).string(message.ethSigner);
        }
        if (message.orchestrator !== "") {
            writer.uint32(34).string(message.orchestrator);
        }
        if (message.signature !== "") {
            writer.uint32(42).string(message.signature);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgConfirmBatch();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.nonce = reader.uint64();
                    break;
                case 2:
                    message.tokenContract = reader.string();
                    break;
                case 3:
                    message.ethSigner = reader.string();
                    break;
                case 4:
                    message.orchestrator = reader.string();
                    break;
                case 5:
                    message.signature = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            nonce: isSet(object.nonce) ? long_default().fromValue(object.nonce) : (long_default()).UZERO,
            tokenContract: isSet(object.tokenContract)
                ? String(object.tokenContract)
                : "",
            ethSigner: isSet(object.ethSigner) ? String(object.ethSigner) : "",
            orchestrator: isSet(object.orchestrator)
                ? String(object.orchestrator)
                : "",
            signature: isSet(object.signature) ? String(object.signature) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.nonce !== undefined &&
            (obj.nonce = (message.nonce || (long_default()).UZERO).toString());
        message.tokenContract !== undefined &&
            (obj.tokenContract = message.tokenContract);
        message.ethSigner !== undefined && (obj.ethSigner = message.ethSigner);
        message.orchestrator !== undefined &&
            (obj.orchestrator = message.orchestrator);
        message.signature !== undefined && (obj.signature = message.signature);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d;
        const message = createBaseMsgConfirmBatch();
        message.nonce =
            object.nonce !== undefined && object.nonce !== null
                ? long_default().fromValue(object.nonce)
                : (long_default()).UZERO;
        message.tokenContract = (_a = object.tokenContract) !== null && _a !== void 0 ? _a : "";
        message.ethSigner = (_b = object.ethSigner) !== null && _b !== void 0 ? _b : "";
        message.orchestrator = (_c = object.orchestrator) !== null && _c !== void 0 ? _c : "";
        message.signature = (_d = object.signature) !== null && _d !== void 0 ? _d : "";
        return message;
    },
};
function createBaseMsgConfirmBatchResponse() {
    return {};
}
const MsgConfirmBatchResponse = {
    encode(_, writer = minimal.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgConfirmBatchResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgConfirmBatchResponse();
        return message;
    },
};
function createBaseMsgConfirmLogicCall() {
    return {
        invalidationId: "",
        invalidationNonce: (long_default()).UZERO,
        ethSigner: "",
        orchestrator: "",
        signature: "",
    };
}
const MsgConfirmLogicCall = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.invalidationId !== "") {
            writer.uint32(10).string(message.invalidationId);
        }
        if (!message.invalidationNonce.isZero()) {
            writer.uint32(16).uint64(message.invalidationNonce);
        }
        if (message.ethSigner !== "") {
            writer.uint32(26).string(message.ethSigner);
        }
        if (message.orchestrator !== "") {
            writer.uint32(34).string(message.orchestrator);
        }
        if (message.signature !== "") {
            writer.uint32(42).string(message.signature);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgConfirmLogicCall();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.invalidationId = reader.string();
                    break;
                case 2:
                    message.invalidationNonce = reader.uint64();
                    break;
                case 3:
                    message.ethSigner = reader.string();
                    break;
                case 4:
                    message.orchestrator = reader.string();
                    break;
                case 5:
                    message.signature = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            invalidationId: isSet(object.invalidationId)
                ? String(object.invalidationId)
                : "",
            invalidationNonce: isSet(object.invalidationNonce)
                ? long_default().fromValue(object.invalidationNonce)
                : (long_default()).UZERO,
            ethSigner: isSet(object.ethSigner) ? String(object.ethSigner) : "",
            orchestrator: isSet(object.orchestrator)
                ? String(object.orchestrator)
                : "",
            signature: isSet(object.signature) ? String(object.signature) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.invalidationId !== undefined &&
            (obj.invalidationId = message.invalidationId);
        message.invalidationNonce !== undefined &&
            (obj.invalidationNonce = (message.invalidationNonce || (long_default()).UZERO).toString());
        message.ethSigner !== undefined && (obj.ethSigner = message.ethSigner);
        message.orchestrator !== undefined &&
            (obj.orchestrator = message.orchestrator);
        message.signature !== undefined && (obj.signature = message.signature);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d;
        const message = createBaseMsgConfirmLogicCall();
        message.invalidationId = (_a = object.invalidationId) !== null && _a !== void 0 ? _a : "";
        message.invalidationNonce =
            object.invalidationNonce !== undefined &&
                object.invalidationNonce !== null
                ? long_default().fromValue(object.invalidationNonce)
                : (long_default()).UZERO;
        message.ethSigner = (_b = object.ethSigner) !== null && _b !== void 0 ? _b : "";
        message.orchestrator = (_c = object.orchestrator) !== null && _c !== void 0 ? _c : "";
        message.signature = (_d = object.signature) !== null && _d !== void 0 ? _d : "";
        return message;
    },
};
function createBaseMsgConfirmLogicCallResponse() {
    return {};
}
const MsgConfirmLogicCallResponse = {
    encode(_, writer = minimal.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgConfirmLogicCallResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgConfirmLogicCallResponse();
        return message;
    },
};
function createBaseMsgSendToCosmosClaim() {
    return {
        eventNonce: (long_default()).UZERO,
        ethBlockHeight: (long_default()).UZERO,
        tokenContract: "",
        amount: "",
        ethereumSender: "",
        cosmosReceiver: "",
        orchestrator: "",
    };
}
const MsgSendToCosmosClaim = {
    encode(message, writer = minimal.Writer.create()) {
        if (!message.eventNonce.isZero()) {
            writer.uint32(8).uint64(message.eventNonce);
        }
        if (!message.ethBlockHeight.isZero()) {
            writer.uint32(16).uint64(message.ethBlockHeight);
        }
        if (message.tokenContract !== "") {
            writer.uint32(26).string(message.tokenContract);
        }
        if (message.amount !== "") {
            writer.uint32(34).string(message.amount);
        }
        if (message.ethereumSender !== "") {
            writer.uint32(42).string(message.ethereumSender);
        }
        if (message.cosmosReceiver !== "") {
            writer.uint32(50).string(message.cosmosReceiver);
        }
        if (message.orchestrator !== "") {
            writer.uint32(58).string(message.orchestrator);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgSendToCosmosClaim();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.eventNonce = reader.uint64();
                    break;
                case 2:
                    message.ethBlockHeight = reader.uint64();
                    break;
                case 3:
                    message.tokenContract = reader.string();
                    break;
                case 4:
                    message.amount = reader.string();
                    break;
                case 5:
                    message.ethereumSender = reader.string();
                    break;
                case 6:
                    message.cosmosReceiver = reader.string();
                    break;
                case 7:
                    message.orchestrator = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            eventNonce: isSet(object.eventNonce)
                ? long_default().fromValue(object.eventNonce)
                : (long_default()).UZERO,
            ethBlockHeight: isSet(object.ethBlockHeight)
                ? long_default().fromValue(object.ethBlockHeight)
                : (long_default()).UZERO,
            tokenContract: isSet(object.tokenContract)
                ? String(object.tokenContract)
                : "",
            amount: isSet(object.amount) ? String(object.amount) : "",
            ethereumSender: isSet(object.ethereumSender)
                ? String(object.ethereumSender)
                : "",
            cosmosReceiver: isSet(object.cosmosReceiver)
                ? String(object.cosmosReceiver)
                : "",
            orchestrator: isSet(object.orchestrator)
                ? String(object.orchestrator)
                : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.eventNonce !== undefined &&
            (obj.eventNonce = (message.eventNonce || (long_default()).UZERO).toString());
        message.ethBlockHeight !== undefined &&
            (obj.ethBlockHeight = (message.ethBlockHeight || (long_default()).UZERO).toString());
        message.tokenContract !== undefined &&
            (obj.tokenContract = message.tokenContract);
        message.amount !== undefined && (obj.amount = message.amount);
        message.ethereumSender !== undefined &&
            (obj.ethereumSender = message.ethereumSender);
        message.cosmosReceiver !== undefined &&
            (obj.cosmosReceiver = message.cosmosReceiver);
        message.orchestrator !== undefined &&
            (obj.orchestrator = message.orchestrator);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e;
        const message = createBaseMsgSendToCosmosClaim();
        message.eventNonce =
            object.eventNonce !== undefined && object.eventNonce !== null
                ? long_default().fromValue(object.eventNonce)
                : (long_default()).UZERO;
        message.ethBlockHeight =
            object.ethBlockHeight !== undefined && object.ethBlockHeight !== null
                ? long_default().fromValue(object.ethBlockHeight)
                : (long_default()).UZERO;
        message.tokenContract = (_a = object.tokenContract) !== null && _a !== void 0 ? _a : "";
        message.amount = (_b = object.amount) !== null && _b !== void 0 ? _b : "";
        message.ethereumSender = (_c = object.ethereumSender) !== null && _c !== void 0 ? _c : "";
        message.cosmosReceiver = (_d = object.cosmosReceiver) !== null && _d !== void 0 ? _d : "";
        message.orchestrator = (_e = object.orchestrator) !== null && _e !== void 0 ? _e : "";
        return message;
    },
};
function createBaseMsgSendToCosmosClaimResponse() {
    return {};
}
const MsgSendToCosmosClaimResponse = {
    encode(_, writer = minimal.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgSendToCosmosClaimResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgSendToCosmosClaimResponse();
        return message;
    },
};
function createBaseMsgExecuteIbcAutoForwards() {
    return {
        forwardsToClear: (long_default()).UZERO,
        executor: "",
    };
}
const MsgExecuteIbcAutoForwards = {
    encode(message, writer = minimal.Writer.create()) {
        if (!message.forwardsToClear.isZero()) {
            writer.uint32(8).uint64(message.forwardsToClear);
        }
        if (message.executor !== "") {
            writer.uint32(18).string(message.executor);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgExecuteIbcAutoForwards();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.forwardsToClear = reader.uint64();
                    break;
                case 2:
                    message.executor = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            forwardsToClear: isSet(object.forwardsToClear)
                ? long_default().fromValue(object.forwardsToClear)
                : (long_default()).UZERO,
            executor: isSet(object.executor) ? String(object.executor) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.forwardsToClear !== undefined &&
            (obj.forwardsToClear = (message.forwardsToClear || (long_default()).UZERO).toString());
        message.executor !== undefined && (obj.executor = message.executor);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseMsgExecuteIbcAutoForwards();
        message.forwardsToClear =
            object.forwardsToClear !== undefined && object.forwardsToClear !== null
                ? long_default().fromValue(object.forwardsToClear)
                : (long_default()).UZERO;
        message.executor = (_a = object.executor) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
function createBaseMsgExecuteIbcAutoForwardsResponse() {
    return {};
}
const MsgExecuteIbcAutoForwardsResponse = {
    encode(_, writer = minimal.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgExecuteIbcAutoForwardsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgExecuteIbcAutoForwardsResponse();
        return message;
    },
};
function createBaseMsgBatchSendToEthClaim() {
    return {
        eventNonce: (long_default()).UZERO,
        ethBlockHeight: (long_default()).UZERO,
        batchNonce: (long_default()).UZERO,
        tokenContract: "",
        orchestrator: "",
    };
}
const MsgBatchSendToEthClaim = {
    encode(message, writer = minimal.Writer.create()) {
        if (!message.eventNonce.isZero()) {
            writer.uint32(8).uint64(message.eventNonce);
        }
        if (!message.ethBlockHeight.isZero()) {
            writer.uint32(16).uint64(message.ethBlockHeight);
        }
        if (!message.batchNonce.isZero()) {
            writer.uint32(24).uint64(message.batchNonce);
        }
        if (message.tokenContract !== "") {
            writer.uint32(34).string(message.tokenContract);
        }
        if (message.orchestrator !== "") {
            writer.uint32(42).string(message.orchestrator);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgBatchSendToEthClaim();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.eventNonce = reader.uint64();
                    break;
                case 2:
                    message.ethBlockHeight = reader.uint64();
                    break;
                case 3:
                    message.batchNonce = reader.uint64();
                    break;
                case 4:
                    message.tokenContract = reader.string();
                    break;
                case 5:
                    message.orchestrator = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            eventNonce: isSet(object.eventNonce)
                ? long_default().fromValue(object.eventNonce)
                : (long_default()).UZERO,
            ethBlockHeight: isSet(object.ethBlockHeight)
                ? long_default().fromValue(object.ethBlockHeight)
                : (long_default()).UZERO,
            batchNonce: isSet(object.batchNonce)
                ? long_default().fromValue(object.batchNonce)
                : (long_default()).UZERO,
            tokenContract: isSet(object.tokenContract)
                ? String(object.tokenContract)
                : "",
            orchestrator: isSet(object.orchestrator)
                ? String(object.orchestrator)
                : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.eventNonce !== undefined &&
            (obj.eventNonce = (message.eventNonce || (long_default()).UZERO).toString());
        message.ethBlockHeight !== undefined &&
            (obj.ethBlockHeight = (message.ethBlockHeight || (long_default()).UZERO).toString());
        message.batchNonce !== undefined &&
            (obj.batchNonce = (message.batchNonce || (long_default()).UZERO).toString());
        message.tokenContract !== undefined &&
            (obj.tokenContract = message.tokenContract);
        message.orchestrator !== undefined &&
            (obj.orchestrator = message.orchestrator);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseMsgBatchSendToEthClaim();
        message.eventNonce =
            object.eventNonce !== undefined && object.eventNonce !== null
                ? long_default().fromValue(object.eventNonce)
                : (long_default()).UZERO;
        message.ethBlockHeight =
            object.ethBlockHeight !== undefined && object.ethBlockHeight !== null
                ? long_default().fromValue(object.ethBlockHeight)
                : (long_default()).UZERO;
        message.batchNonce =
            object.batchNonce !== undefined && object.batchNonce !== null
                ? long_default().fromValue(object.batchNonce)
                : (long_default()).UZERO;
        message.tokenContract = (_a = object.tokenContract) !== null && _a !== void 0 ? _a : "";
        message.orchestrator = (_b = object.orchestrator) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
function createBaseMsgBatchSendToEthClaimResponse() {
    return {};
}
const MsgBatchSendToEthClaimResponse = {
    encode(_, writer = minimal.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgBatchSendToEthClaimResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgBatchSendToEthClaimResponse();
        return message;
    },
};
function createBaseMsgERC20DeployedClaim() {
    return {
        eventNonce: (long_default()).UZERO,
        ethBlockHeight: (long_default()).UZERO,
        cosmosDenom: "",
        tokenContract: "",
        name: "",
        symbol: "",
        decimals: (long_default()).UZERO,
        orchestrator: "",
    };
}
const MsgERC20DeployedClaim = {
    encode(message, writer = minimal.Writer.create()) {
        if (!message.eventNonce.isZero()) {
            writer.uint32(8).uint64(message.eventNonce);
        }
        if (!message.ethBlockHeight.isZero()) {
            writer.uint32(16).uint64(message.ethBlockHeight);
        }
        if (message.cosmosDenom !== "") {
            writer.uint32(26).string(message.cosmosDenom);
        }
        if (message.tokenContract !== "") {
            writer.uint32(34).string(message.tokenContract);
        }
        if (message.name !== "") {
            writer.uint32(42).string(message.name);
        }
        if (message.symbol !== "") {
            writer.uint32(50).string(message.symbol);
        }
        if (!message.decimals.isZero()) {
            writer.uint32(56).uint64(message.decimals);
        }
        if (message.orchestrator !== "") {
            writer.uint32(66).string(message.orchestrator);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgERC20DeployedClaim();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.eventNonce = reader.uint64();
                    break;
                case 2:
                    message.ethBlockHeight = reader.uint64();
                    break;
                case 3:
                    message.cosmosDenom = reader.string();
                    break;
                case 4:
                    message.tokenContract = reader.string();
                    break;
                case 5:
                    message.name = reader.string();
                    break;
                case 6:
                    message.symbol = reader.string();
                    break;
                case 7:
                    message.decimals = reader.uint64();
                    break;
                case 8:
                    message.orchestrator = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            eventNonce: isSet(object.eventNonce)
                ? long_default().fromValue(object.eventNonce)
                : (long_default()).UZERO,
            ethBlockHeight: isSet(object.ethBlockHeight)
                ? long_default().fromValue(object.ethBlockHeight)
                : (long_default()).UZERO,
            cosmosDenom: isSet(object.cosmosDenom) ? String(object.cosmosDenom) : "",
            tokenContract: isSet(object.tokenContract)
                ? String(object.tokenContract)
                : "",
            name: isSet(object.name) ? String(object.name) : "",
            symbol: isSet(object.symbol) ? String(object.symbol) : "",
            decimals: isSet(object.decimals)
                ? long_default().fromValue(object.decimals)
                : (long_default()).UZERO,
            orchestrator: isSet(object.orchestrator)
                ? String(object.orchestrator)
                : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.eventNonce !== undefined &&
            (obj.eventNonce = (message.eventNonce || (long_default()).UZERO).toString());
        message.ethBlockHeight !== undefined &&
            (obj.ethBlockHeight = (message.ethBlockHeight || (long_default()).UZERO).toString());
        message.cosmosDenom !== undefined &&
            (obj.cosmosDenom = message.cosmosDenom);
        message.tokenContract !== undefined &&
            (obj.tokenContract = message.tokenContract);
        message.name !== undefined && (obj.name = message.name);
        message.symbol !== undefined && (obj.symbol = message.symbol);
        message.decimals !== undefined &&
            (obj.decimals = (message.decimals || (long_default()).UZERO).toString());
        message.orchestrator !== undefined &&
            (obj.orchestrator = message.orchestrator);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e;
        const message = createBaseMsgERC20DeployedClaim();
        message.eventNonce =
            object.eventNonce !== undefined && object.eventNonce !== null
                ? long_default().fromValue(object.eventNonce)
                : (long_default()).UZERO;
        message.ethBlockHeight =
            object.ethBlockHeight !== undefined && object.ethBlockHeight !== null
                ? long_default().fromValue(object.ethBlockHeight)
                : (long_default()).UZERO;
        message.cosmosDenom = (_a = object.cosmosDenom) !== null && _a !== void 0 ? _a : "";
        message.tokenContract = (_b = object.tokenContract) !== null && _b !== void 0 ? _b : "";
        message.name = (_c = object.name) !== null && _c !== void 0 ? _c : "";
        message.symbol = (_d = object.symbol) !== null && _d !== void 0 ? _d : "";
        message.decimals =
            object.decimals !== undefined && object.decimals !== null
                ? long_default().fromValue(object.decimals)
                : (long_default()).UZERO;
        message.orchestrator = (_e = object.orchestrator) !== null && _e !== void 0 ? _e : "";
        return message;
    },
};
function createBaseMsgERC20DeployedClaimResponse() {
    return {};
}
const MsgERC20DeployedClaimResponse = {
    encode(_, writer = minimal.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgERC20DeployedClaimResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgERC20DeployedClaimResponse();
        return message;
    },
};
function createBaseMsgLogicCallExecutedClaim() {
    return {
        eventNonce: (long_default()).UZERO,
        ethBlockHeight: (long_default()).UZERO,
        invalidationId: new Uint8Array(),
        invalidationNonce: (long_default()).UZERO,
        orchestrator: "",
    };
}
const MsgLogicCallExecutedClaim = {
    encode(message, writer = minimal.Writer.create()) {
        if (!message.eventNonce.isZero()) {
            writer.uint32(8).uint64(message.eventNonce);
        }
        if (!message.ethBlockHeight.isZero()) {
            writer.uint32(16).uint64(message.ethBlockHeight);
        }
        if (message.invalidationId.length !== 0) {
            writer.uint32(26).bytes(message.invalidationId);
        }
        if (!message.invalidationNonce.isZero()) {
            writer.uint32(32).uint64(message.invalidationNonce);
        }
        if (message.orchestrator !== "") {
            writer.uint32(42).string(message.orchestrator);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgLogicCallExecutedClaim();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.eventNonce = reader.uint64();
                    break;
                case 2:
                    message.ethBlockHeight = reader.uint64();
                    break;
                case 3:
                    message.invalidationId = reader.bytes();
                    break;
                case 4:
                    message.invalidationNonce = reader.uint64();
                    break;
                case 5:
                    message.orchestrator = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            eventNonce: isSet(object.eventNonce)
                ? long_default().fromValue(object.eventNonce)
                : (long_default()).UZERO,
            ethBlockHeight: isSet(object.ethBlockHeight)
                ? long_default().fromValue(object.ethBlockHeight)
                : (long_default()).UZERO,
            invalidationId: isSet(object.invalidationId)
                ? bytesFromBase64(object.invalidationId)
                : new Uint8Array(),
            invalidationNonce: isSet(object.invalidationNonce)
                ? long_default().fromValue(object.invalidationNonce)
                : (long_default()).UZERO,
            orchestrator: isSet(object.orchestrator)
                ? String(object.orchestrator)
                : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.eventNonce !== undefined &&
            (obj.eventNonce = (message.eventNonce || (long_default()).UZERO).toString());
        message.ethBlockHeight !== undefined &&
            (obj.ethBlockHeight = (message.ethBlockHeight || (long_default()).UZERO).toString());
        message.invalidationId !== undefined &&
            (obj.invalidationId = base64FromBytes(message.invalidationId !== undefined
                ? message.invalidationId
                : new Uint8Array()));
        message.invalidationNonce !== undefined &&
            (obj.invalidationNonce = (message.invalidationNonce || (long_default()).UZERO).toString());
        message.orchestrator !== undefined &&
            (obj.orchestrator = message.orchestrator);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseMsgLogicCallExecutedClaim();
        message.eventNonce =
            object.eventNonce !== undefined && object.eventNonce !== null
                ? long_default().fromValue(object.eventNonce)
                : (long_default()).UZERO;
        message.ethBlockHeight =
            object.ethBlockHeight !== undefined && object.ethBlockHeight !== null
                ? long_default().fromValue(object.ethBlockHeight)
                : (long_default()).UZERO;
        message.invalidationId = (_a = object.invalidationId) !== null && _a !== void 0 ? _a : new Uint8Array();
        message.invalidationNonce =
            object.invalidationNonce !== undefined &&
                object.invalidationNonce !== null
                ? long_default().fromValue(object.invalidationNonce)
                : (long_default()).UZERO;
        message.orchestrator = (_b = object.orchestrator) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
function createBaseMsgLogicCallExecutedClaimResponse() {
    return {};
}
const MsgLogicCallExecutedClaimResponse = {
    encode(_, writer = minimal.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgLogicCallExecutedClaimResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgLogicCallExecutedClaimResponse();
        return message;
    },
};
function createBaseMsgValsetUpdatedClaim() {
    return {
        eventNonce: (long_default()).UZERO,
        valsetNonce: (long_default()).UZERO,
        ethBlockHeight: (long_default()).UZERO,
        members: [],
        rewardAmount: "",
        rewardToken: "",
        orchestrator: "",
    };
}
const MsgValsetUpdatedClaim = {
    encode(message, writer = minimal.Writer.create()) {
        if (!message.eventNonce.isZero()) {
            writer.uint32(8).uint64(message.eventNonce);
        }
        if (!message.valsetNonce.isZero()) {
            writer.uint32(16).uint64(message.valsetNonce);
        }
        if (!message.ethBlockHeight.isZero()) {
            writer.uint32(24).uint64(message.ethBlockHeight);
        }
        for (const v of message.members) {
            BridgeValidator.encode(v, writer.uint32(34).fork()).ldelim();
        }
        if (message.rewardAmount !== "") {
            writer.uint32(42).string(message.rewardAmount);
        }
        if (message.rewardToken !== "") {
            writer.uint32(50).string(message.rewardToken);
        }
        if (message.orchestrator !== "") {
            writer.uint32(58).string(message.orchestrator);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgValsetUpdatedClaim();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.eventNonce = reader.uint64();
                    break;
                case 2:
                    message.valsetNonce = reader.uint64();
                    break;
                case 3:
                    message.ethBlockHeight = reader.uint64();
                    break;
                case 4:
                    message.members.push(BridgeValidator.decode(reader, reader.uint32()));
                    break;
                case 5:
                    message.rewardAmount = reader.string();
                    break;
                case 6:
                    message.rewardToken = reader.string();
                    break;
                case 7:
                    message.orchestrator = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            eventNonce: isSet(object.eventNonce)
                ? long_default().fromValue(object.eventNonce)
                : (long_default()).UZERO,
            valsetNonce: isSet(object.valsetNonce)
                ? long_default().fromValue(object.valsetNonce)
                : (long_default()).UZERO,
            ethBlockHeight: isSet(object.ethBlockHeight)
                ? long_default().fromValue(object.ethBlockHeight)
                : (long_default()).UZERO,
            members: Array.isArray(object === null || object === void 0 ? void 0 : object.members)
                ? object.members.map((e) => BridgeValidator.fromJSON(e))
                : [],
            rewardAmount: isSet(object.rewardAmount)
                ? String(object.rewardAmount)
                : "",
            rewardToken: isSet(object.rewardToken) ? String(object.rewardToken) : "",
            orchestrator: isSet(object.orchestrator)
                ? String(object.orchestrator)
                : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.eventNonce !== undefined &&
            (obj.eventNonce = (message.eventNonce || (long_default()).UZERO).toString());
        message.valsetNonce !== undefined &&
            (obj.valsetNonce = (message.valsetNonce || (long_default()).UZERO).toString());
        message.ethBlockHeight !== undefined &&
            (obj.ethBlockHeight = (message.ethBlockHeight || (long_default()).UZERO).toString());
        if (message.members) {
            obj.members = message.members.map((e) => e ? BridgeValidator.toJSON(e) : undefined);
        }
        else {
            obj.members = [];
        }
        message.rewardAmount !== undefined &&
            (obj.rewardAmount = message.rewardAmount);
        message.rewardToken !== undefined &&
            (obj.rewardToken = message.rewardToken);
        message.orchestrator !== undefined &&
            (obj.orchestrator = message.orchestrator);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d;
        const message = createBaseMsgValsetUpdatedClaim();
        message.eventNonce =
            object.eventNonce !== undefined && object.eventNonce !== null
                ? long_default().fromValue(object.eventNonce)
                : (long_default()).UZERO;
        message.valsetNonce =
            object.valsetNonce !== undefined && object.valsetNonce !== null
                ? long_default().fromValue(object.valsetNonce)
                : (long_default()).UZERO;
        message.ethBlockHeight =
            object.ethBlockHeight !== undefined && object.ethBlockHeight !== null
                ? long_default().fromValue(object.ethBlockHeight)
                : (long_default()).UZERO;
        message.members =
            ((_a = object.members) === null || _a === void 0 ? void 0 : _a.map((e) => BridgeValidator.fromPartial(e))) || [];
        message.rewardAmount = (_b = object.rewardAmount) !== null && _b !== void 0 ? _b : "";
        message.rewardToken = (_c = object.rewardToken) !== null && _c !== void 0 ? _c : "";
        message.orchestrator = (_d = object.orchestrator) !== null && _d !== void 0 ? _d : "";
        return message;
    },
};
function createBaseMsgValsetUpdatedClaimResponse() {
    return {};
}
const MsgValsetUpdatedClaimResponse = {
    encode(_, writer = minimal.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgValsetUpdatedClaimResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgValsetUpdatedClaimResponse();
        return message;
    },
};
function createBaseMsgCancelSendToEth() {
    return {
        transactionId: (long_default()).UZERO,
        sender: "",
    };
}
const MsgCancelSendToEth = {
    encode(message, writer = minimal.Writer.create()) {
        if (!message.transactionId.isZero()) {
            writer.uint32(8).uint64(message.transactionId);
        }
        if (message.sender !== "") {
            writer.uint32(18).string(message.sender);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgCancelSendToEth();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.transactionId = reader.uint64();
                    break;
                case 2:
                    message.sender = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            transactionId: isSet(object.transactionId)
                ? long_default().fromValue(object.transactionId)
                : (long_default()).UZERO,
            sender: isSet(object.sender) ? String(object.sender) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.transactionId !== undefined &&
            (obj.transactionId = (message.transactionId || (long_default()).UZERO).toString());
        message.sender !== undefined && (obj.sender = message.sender);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseMsgCancelSendToEth();
        message.transactionId =
            object.transactionId !== undefined && object.transactionId !== null
                ? long_default().fromValue(object.transactionId)
                : (long_default()).UZERO;
        message.sender = (_a = object.sender) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
function createBaseMsgCancelSendToEthResponse() {
    return {};
}
const MsgCancelSendToEthResponse = {
    encode(_, writer = minimal.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgCancelSendToEthResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgCancelSendToEthResponse();
        return message;
    },
};
function createBaseMsgSubmitBadSignatureEvidence() {
    return {
        subject: undefined,
        signature: "",
        sender: "",
    };
}
const MsgSubmitBadSignatureEvidence = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.subject !== undefined) {
            any.Any.encode(message.subject, writer.uint32(10).fork()).ldelim();
        }
        if (message.signature !== "") {
            writer.uint32(18).string(message.signature);
        }
        if (message.sender !== "") {
            writer.uint32(26).string(message.sender);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgSubmitBadSignatureEvidence();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.subject = any.Any.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.signature = reader.string();
                    break;
                case 3:
                    message.sender = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            subject: isSet(object.subject) ? any.Any.fromJSON(object.subject) : undefined,
            signature: isSet(object.signature) ? String(object.signature) : "",
            sender: isSet(object.sender) ? String(object.sender) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.subject !== undefined &&
            (obj.subject = message.subject ? any.Any.toJSON(message.subject) : undefined);
        message.signature !== undefined && (obj.signature = message.signature);
        message.sender !== undefined && (obj.sender = message.sender);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseMsgSubmitBadSignatureEvidence();
        message.subject =
            object.subject !== undefined && object.subject !== null
                ? any.Any.fromPartial(object.subject)
                : undefined;
        message.signature = (_a = object.signature) !== null && _a !== void 0 ? _a : "";
        message.sender = (_b = object.sender) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
function createBaseMsgSubmitBadSignatureEvidenceResponse() {
    return {};
}
const MsgSubmitBadSignatureEvidenceResponse = {
    encode(_, writer = minimal.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgSubmitBadSignatureEvidenceResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgSubmitBadSignatureEvidenceResponse();
        return message;
    },
};
function createBaseEventSetOperatorAddress() {
    return {
        message: "",
        address: "",
    };
}
const EventSetOperatorAddress = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.message !== "") {
            writer.uint32(10).string(message.message);
        }
        if (message.address !== "") {
            writer.uint32(18).string(message.address);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseEventSetOperatorAddress();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.message = reader.string();
                    break;
                case 2:
                    message.address = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            message: isSet(object.message) ? String(object.message) : "",
            address: isSet(object.address) ? String(object.address) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.message !== undefined && (obj.message = message.message);
        message.address !== undefined && (obj.address = message.address);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseEventSetOperatorAddress();
        message.message = (_a = object.message) !== null && _a !== void 0 ? _a : "";
        message.address = (_b = object.address) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
function createBaseEventValsetConfirmKey() {
    return {
        message: "",
        key: "",
    };
}
const EventValsetConfirmKey = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.message !== "") {
            writer.uint32(10).string(message.message);
        }
        if (message.key !== "") {
            writer.uint32(18).string(message.key);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseEventValsetConfirmKey();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.message = reader.string();
                    break;
                case 2:
                    message.key = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            message: isSet(object.message) ? String(object.message) : "",
            key: isSet(object.key) ? String(object.key) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.message !== undefined && (obj.message = message.message);
        message.key !== undefined && (obj.key = message.key);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseEventValsetConfirmKey();
        message.message = (_a = object.message) !== null && _a !== void 0 ? _a : "";
        message.key = (_b = object.key) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
function createBaseEventBatchCreated() {
    return {
        message: "",
        batchNonce: "",
    };
}
const EventBatchCreated = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.message !== "") {
            writer.uint32(10).string(message.message);
        }
        if (message.batchNonce !== "") {
            writer.uint32(18).string(message.batchNonce);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseEventBatchCreated();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.message = reader.string();
                    break;
                case 2:
                    message.batchNonce = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            message: isSet(object.message) ? String(object.message) : "",
            batchNonce: isSet(object.batchNonce) ? String(object.batchNonce) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.message !== undefined && (obj.message = message.message);
        message.batchNonce !== undefined && (obj.batchNonce = message.batchNonce);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseEventBatchCreated();
        message.message = (_a = object.message) !== null && _a !== void 0 ? _a : "";
        message.batchNonce = (_b = object.batchNonce) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
function createBaseEventBatchConfirmKey() {
    return {
        message: "",
        batchConfirmKey: "",
    };
}
const EventBatchConfirmKey = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.message !== "") {
            writer.uint32(10).string(message.message);
        }
        if (message.batchConfirmKey !== "") {
            writer.uint32(18).string(message.batchConfirmKey);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseEventBatchConfirmKey();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.message = reader.string();
                    break;
                case 2:
                    message.batchConfirmKey = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            message: isSet(object.message) ? String(object.message) : "",
            batchConfirmKey: isSet(object.batchConfirmKey)
                ? String(object.batchConfirmKey)
                : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.message !== undefined && (obj.message = message.message);
        message.batchConfirmKey !== undefined &&
            (obj.batchConfirmKey = message.batchConfirmKey);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseEventBatchConfirmKey();
        message.message = (_a = object.message) !== null && _a !== void 0 ? _a : "";
        message.batchConfirmKey = (_b = object.batchConfirmKey) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
function createBaseEventBatchSendToEthClaim() {
    return {
        nonce: "",
    };
}
const EventBatchSendToEthClaim = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.nonce !== "") {
            writer.uint32(10).string(message.nonce);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseEventBatchSendToEthClaim();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.nonce = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            nonce: isSet(object.nonce) ? String(object.nonce) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.nonce !== undefined && (obj.nonce = message.nonce);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseEventBatchSendToEthClaim();
        message.nonce = (_a = object.nonce) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
function createBaseEventClaim() {
    return {
        message: "",
        claimHash: "",
        attestationId: "",
    };
}
const EventClaim = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.message !== "") {
            writer.uint32(10).string(message.message);
        }
        if (message.claimHash !== "") {
            writer.uint32(18).string(message.claimHash);
        }
        if (message.attestationId !== "") {
            writer.uint32(26).string(message.attestationId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseEventClaim();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.message = reader.string();
                    break;
                case 2:
                    message.claimHash = reader.string();
                    break;
                case 3:
                    message.attestationId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            message: isSet(object.message) ? String(object.message) : "",
            claimHash: isSet(object.claimHash) ? String(object.claimHash) : "",
            attestationId: isSet(object.attestationId)
                ? String(object.attestationId)
                : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.message !== undefined && (obj.message = message.message);
        message.claimHash !== undefined && (obj.claimHash = message.claimHash);
        message.attestationId !== undefined &&
            (obj.attestationId = message.attestationId);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseEventClaim();
        message.message = (_a = object.message) !== null && _a !== void 0 ? _a : "";
        message.claimHash = (_b = object.claimHash) !== null && _b !== void 0 ? _b : "";
        message.attestationId = (_c = object.attestationId) !== null && _c !== void 0 ? _c : "";
        return message;
    },
};
function createBaseEventBadSignatureEvidence() {
    return {
        message: "",
        badEthSignature: "",
        badEthSignatureSubject: "",
    };
}
const EventBadSignatureEvidence = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.message !== "") {
            writer.uint32(10).string(message.message);
        }
        if (message.badEthSignature !== "") {
            writer.uint32(18).string(message.badEthSignature);
        }
        if (message.badEthSignatureSubject !== "") {
            writer.uint32(26).string(message.badEthSignatureSubject);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseEventBadSignatureEvidence();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.message = reader.string();
                    break;
                case 2:
                    message.badEthSignature = reader.string();
                    break;
                case 3:
                    message.badEthSignatureSubject = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            message: isSet(object.message) ? String(object.message) : "",
            badEthSignature: isSet(object.badEthSignature)
                ? String(object.badEthSignature)
                : "",
            badEthSignatureSubject: isSet(object.badEthSignatureSubject)
                ? String(object.badEthSignatureSubject)
                : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.message !== undefined && (obj.message = message.message);
        message.badEthSignature !== undefined &&
            (obj.badEthSignature = message.badEthSignature);
        message.badEthSignatureSubject !== undefined &&
            (obj.badEthSignatureSubject = message.badEthSignatureSubject);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseEventBadSignatureEvidence();
        message.message = (_a = object.message) !== null && _a !== void 0 ? _a : "";
        message.badEthSignature = (_b = object.badEthSignature) !== null && _b !== void 0 ? _b : "";
        message.badEthSignatureSubject = (_c = object.badEthSignatureSubject) !== null && _c !== void 0 ? _c : "";
        return message;
    },
};
function createBaseEventERC20DeployedClaim() {
    return {
        token: "",
        nonce: "",
    };
}
const EventERC20DeployedClaim = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.token !== "") {
            writer.uint32(10).string(message.token);
        }
        if (message.nonce !== "") {
            writer.uint32(18).string(message.nonce);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseEventERC20DeployedClaim();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.token = reader.string();
                    break;
                case 2:
                    message.nonce = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            token: isSet(object.token) ? String(object.token) : "",
            nonce: isSet(object.nonce) ? String(object.nonce) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.token !== undefined && (obj.token = message.token);
        message.nonce !== undefined && (obj.nonce = message.nonce);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseEventERC20DeployedClaim();
        message.token = (_a = object.token) !== null && _a !== void 0 ? _a : "";
        message.nonce = (_b = object.nonce) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
function createBaseEventValsetUpdatedClaim() {
    return {
        nonce: "",
    };
}
const EventValsetUpdatedClaim = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.nonce !== "") {
            writer.uint32(10).string(message.nonce);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseEventValsetUpdatedClaim();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.nonce = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            nonce: isSet(object.nonce) ? String(object.nonce) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.nonce !== undefined && (obj.nonce = message.nonce);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseEventValsetUpdatedClaim();
        message.nonce = (_a = object.nonce) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
function createBaseEventMultisigUpdateRequest() {
    return {
        bridgeContract: "",
        bridgeChainId: "",
        multisigId: "",
        nonce: "",
    };
}
const EventMultisigUpdateRequest = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.bridgeContract !== "") {
            writer.uint32(10).string(message.bridgeContract);
        }
        if (message.bridgeChainId !== "") {
            writer.uint32(18).string(message.bridgeChainId);
        }
        if (message.multisigId !== "") {
            writer.uint32(26).string(message.multisigId);
        }
        if (message.nonce !== "") {
            writer.uint32(34).string(message.nonce);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseEventMultisigUpdateRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.bridgeContract = reader.string();
                    break;
                case 2:
                    message.bridgeChainId = reader.string();
                    break;
                case 3:
                    message.multisigId = reader.string();
                    break;
                case 4:
                    message.nonce = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            bridgeContract: isSet(object.bridgeContract)
                ? String(object.bridgeContract)
                : "",
            bridgeChainId: isSet(object.bridgeChainId)
                ? String(object.bridgeChainId)
                : "",
            multisigId: isSet(object.multisigId) ? String(object.multisigId) : "",
            nonce: isSet(object.nonce) ? String(object.nonce) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.bridgeContract !== undefined &&
            (obj.bridgeContract = message.bridgeContract);
        message.bridgeChainId !== undefined &&
            (obj.bridgeChainId = message.bridgeChainId);
        message.multisigId !== undefined && (obj.multisigId = message.multisigId);
        message.nonce !== undefined && (obj.nonce = message.nonce);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d;
        const message = createBaseEventMultisigUpdateRequest();
        message.bridgeContract = (_a = object.bridgeContract) !== null && _a !== void 0 ? _a : "";
        message.bridgeChainId = (_b = object.bridgeChainId) !== null && _b !== void 0 ? _b : "";
        message.multisigId = (_c = object.multisigId) !== null && _c !== void 0 ? _c : "";
        message.nonce = (_d = object.nonce) !== null && _d !== void 0 ? _d : "";
        return message;
    },
};
function createBaseEventOutgoingLogicCallCanceled() {
    return {
        logicCallInvalidationId: "",
        logicCallInvalidationNonce: "",
    };
}
const EventOutgoingLogicCallCanceled = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.logicCallInvalidationId !== "") {
            writer.uint32(10).string(message.logicCallInvalidationId);
        }
        if (message.logicCallInvalidationNonce !== "") {
            writer.uint32(18).string(message.logicCallInvalidationNonce);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseEventOutgoingLogicCallCanceled();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.logicCallInvalidationId = reader.string();
                    break;
                case 2:
                    message.logicCallInvalidationNonce = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            logicCallInvalidationId: isSet(object.logicCallInvalidationId)
                ? String(object.logicCallInvalidationId)
                : "",
            logicCallInvalidationNonce: isSet(object.logicCallInvalidationNonce)
                ? String(object.logicCallInvalidationNonce)
                : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.logicCallInvalidationId !== undefined &&
            (obj.logicCallInvalidationId = message.logicCallInvalidationId);
        message.logicCallInvalidationNonce !== undefined &&
            (obj.logicCallInvalidationNonce = message.logicCallInvalidationNonce);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseEventOutgoingLogicCallCanceled();
        message.logicCallInvalidationId = (_a = object.logicCallInvalidationId) !== null && _a !== void 0 ? _a : "";
        message.logicCallInvalidationNonce =
            (_b = object.logicCallInvalidationNonce) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
function createBaseEventSignatureSlashing() {
    return {
        type: "",
        address: "",
    };
}
const EventSignatureSlashing = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.type !== "") {
            writer.uint32(10).string(message.type);
        }
        if (message.address !== "") {
            writer.uint32(18).string(message.address);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseEventSignatureSlashing();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.type = reader.string();
                    break;
                case 2:
                    message.address = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            type: isSet(object.type) ? String(object.type) : "",
            address: isSet(object.address) ? String(object.address) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.type !== undefined && (obj.type = message.type);
        message.address !== undefined && (obj.address = message.address);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseEventSignatureSlashing();
        message.type = (_a = object.type) !== null && _a !== void 0 ? _a : "";
        message.address = (_b = object.address) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
function createBaseEventOutgoingTxId() {
    return {
        message: "",
        txId: "",
    };
}
const EventOutgoingTxId = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.message !== "") {
            writer.uint32(10).string(message.message);
        }
        if (message.txId !== "") {
            writer.uint32(18).string(message.txId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseEventOutgoingTxId();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.message = reader.string();
                    break;
                case 2:
                    message.txId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            message: isSet(object.message) ? String(object.message) : "",
            txId: isSet(object.txId) ? String(object.txId) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.message !== undefined && (obj.message = message.message);
        message.txId !== undefined && (obj.txId = message.txId);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseEventOutgoingTxId();
        message.message = (_a = object.message) !== null && _a !== void 0 ? _a : "";
        message.txId = (_b = object.txId) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
function createBaseEventSendToEthFeeCollected() {
    return {
        sender: "",
        sendAmount: "",
        feeAmount: "",
    };
}
const EventSendToEthFeeCollected = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.sender !== "") {
            writer.uint32(10).string(message.sender);
        }
        if (message.sendAmount !== "") {
            writer.uint32(18).string(message.sendAmount);
        }
        if (message.feeAmount !== "") {
            writer.uint32(26).string(message.feeAmount);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseEventSendToEthFeeCollected();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.sender = reader.string();
                    break;
                case 2:
                    message.sendAmount = reader.string();
                    break;
                case 3:
                    message.feeAmount = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            sender: isSet(object.sender) ? String(object.sender) : "",
            sendAmount: isSet(object.sendAmount) ? String(object.sendAmount) : "",
            feeAmount: isSet(object.feeAmount) ? String(object.feeAmount) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.sender !== undefined && (obj.sender = message.sender);
        message.sendAmount !== undefined && (obj.sendAmount = message.sendAmount);
        message.feeAmount !== undefined && (obj.feeAmount = message.feeAmount);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseEventSendToEthFeeCollected();
        message.sender = (_a = object.sender) !== null && _a !== void 0 ? _a : "";
        message.sendAmount = (_b = object.sendAmount) !== null && _b !== void 0 ? _b : "";
        message.feeAmount = (_c = object.feeAmount) !== null && _c !== void 0 ? _c : "";
        return message;
    },
};
class MsgClientImpl {
    constructor(rpc) {
        this.rpc = rpc;
        this.ValsetConfirm = this.ValsetConfirm.bind(this);
        this.SendToEth = this.SendToEth.bind(this);
        this.RequestBatch = this.RequestBatch.bind(this);
        this.ConfirmBatch = this.ConfirmBatch.bind(this);
        this.ConfirmLogicCall = this.ConfirmLogicCall.bind(this);
        this.SendToCosmosClaim = this.SendToCosmosClaim.bind(this);
        this.ExecuteIbcAutoForwards = this.ExecuteIbcAutoForwards.bind(this);
        this.BatchSendToEthClaim = this.BatchSendToEthClaim.bind(this);
        this.ValsetUpdateClaim = this.ValsetUpdateClaim.bind(this);
        this.ERC20DeployedClaim = this.ERC20DeployedClaim.bind(this);
        this.LogicCallExecutedClaim = this.LogicCallExecutedClaim.bind(this);
        this.SetOrchestratorAddress = this.SetOrchestratorAddress.bind(this);
        this.CancelSendToEth = this.CancelSendToEth.bind(this);
        this.SubmitBadSignatureEvidence =
            this.SubmitBadSignatureEvidence.bind(this);
    }
    ValsetConfirm(request) {
        const data = MsgValsetConfirm.encode(request).finish();
        const promise = this.rpc.request("gravity.v1.Msg", "ValsetConfirm", data);
        return promise.then((data) => MsgValsetConfirmResponse.decode(new _m0.Reader(data)));
    }
    SendToEth(request) {
        const data = MsgSendToEth.encode(request).finish();
        const promise = this.rpc.request("gravity.v1.Msg", "SendToEth", data);
        return promise.then((data) => MsgSendToEthResponse.decode(new _m0.Reader(data)));
    }
    RequestBatch(request) {
        const data = MsgRequestBatch.encode(request).finish();
        const promise = this.rpc.request("gravity.v1.Msg", "RequestBatch", data);
        return promise.then((data) => MsgRequestBatchResponse.decode(new _m0.Reader(data)));
    }
    ConfirmBatch(request) {
        const data = MsgConfirmBatch.encode(request).finish();
        const promise = this.rpc.request("gravity.v1.Msg", "ConfirmBatch", data);
        return promise.then((data) => MsgConfirmBatchResponse.decode(new _m0.Reader(data)));
    }
    ConfirmLogicCall(request) {
        const data = MsgConfirmLogicCall.encode(request).finish();
        const promise = this.rpc.request("gravity.v1.Msg", "ConfirmLogicCall", data);
        return promise.then((data) => MsgConfirmLogicCallResponse.decode(new _m0.Reader(data)));
    }
    SendToCosmosClaim(request) {
        const data = MsgSendToCosmosClaim.encode(request).finish();
        const promise = this.rpc.request("gravity.v1.Msg", "SendToCosmosClaim", data);
        return promise.then((data) => MsgSendToCosmosClaimResponse.decode(new _m0.Reader(data)));
    }
    ExecuteIbcAutoForwards(request) {
        const data = MsgExecuteIbcAutoForwards.encode(request).finish();
        const promise = this.rpc.request("gravity.v1.Msg", "ExecuteIbcAutoForwards", data);
        return promise.then((data) => MsgExecuteIbcAutoForwardsResponse.decode(new _m0.Reader(data)));
    }
    BatchSendToEthClaim(request) {
        const data = MsgBatchSendToEthClaim.encode(request).finish();
        const promise = this.rpc.request("gravity.v1.Msg", "BatchSendToEthClaim", data);
        return promise.then((data) => MsgBatchSendToEthClaimResponse.decode(new _m0.Reader(data)));
    }
    ValsetUpdateClaim(request) {
        const data = MsgValsetUpdatedClaim.encode(request).finish();
        const promise = this.rpc.request("gravity.v1.Msg", "ValsetUpdateClaim", data);
        return promise.then((data) => MsgValsetUpdatedClaimResponse.decode(new _m0.Reader(data)));
    }
    ERC20DeployedClaim(request) {
        const data = MsgERC20DeployedClaim.encode(request).finish();
        const promise = this.rpc.request("gravity.v1.Msg", "ERC20DeployedClaim", data);
        return promise.then((data) => MsgERC20DeployedClaimResponse.decode(new _m0.Reader(data)));
    }
    LogicCallExecutedClaim(request) {
        const data = MsgLogicCallExecutedClaim.encode(request).finish();
        const promise = this.rpc.request("gravity.v1.Msg", "LogicCallExecutedClaim", data);
        return promise.then((data) => MsgLogicCallExecutedClaimResponse.decode(new _m0.Reader(data)));
    }
    SetOrchestratorAddress(request) {
        const data = MsgSetOrchestratorAddress.encode(request).finish();
        const promise = this.rpc.request("gravity.v1.Msg", "SetOrchestratorAddress", data);
        return promise.then((data) => MsgSetOrchestratorAddressResponse.decode(new _m0.Reader(data)));
    }
    CancelSendToEth(request) {
        const data = MsgCancelSendToEth.encode(request).finish();
        const promise = this.rpc.request("gravity.v1.Msg", "CancelSendToEth", data);
        return promise.then((data) => MsgCancelSendToEthResponse.decode(new _m0.Reader(data)));
    }
    SubmitBadSignatureEvidence(request) {
        const data = MsgSubmitBadSignatureEvidence.encode(request).finish();
        const promise = this.rpc.request("gravity.v1.Msg", "SubmitBadSignatureEvidence", data);
        return promise.then((data) => MsgSubmitBadSignatureEvidenceResponse.decode(new _m0.Reader(data)));
    }
}

;// CONCATENATED MODULE: ./node_modules/kujira.js/lib/esm/gravity/v1/attestation.js
/* eslint-disable */



const attestation_protobufPackage = "gravity.v1";
/**
 * ClaimType is the cosmos type of an event from the counterpart chain that can
 * be handled
 */
var ClaimType;
(function (ClaimType) {
    /** CLAIM_TYPE_UNSPECIFIED - An unspecified claim type */
    ClaimType[ClaimType["CLAIM_TYPE_UNSPECIFIED"] = 0] = "CLAIM_TYPE_UNSPECIFIED";
    /** CLAIM_TYPE_SEND_TO_COSMOS - A claim for a SendToCosmos transaction */
    ClaimType[ClaimType["CLAIM_TYPE_SEND_TO_COSMOS"] = 1] = "CLAIM_TYPE_SEND_TO_COSMOS";
    /** CLAIM_TYPE_BATCH_SEND_TO_ETH - A claim for when batches are relayed */
    ClaimType[ClaimType["CLAIM_TYPE_BATCH_SEND_TO_ETH"] = 2] = "CLAIM_TYPE_BATCH_SEND_TO_ETH";
    /** CLAIM_TYPE_ERC20_DEPLOYED - A claim for when an erc20 contract has been deployed */
    ClaimType[ClaimType["CLAIM_TYPE_ERC20_DEPLOYED"] = 3] = "CLAIM_TYPE_ERC20_DEPLOYED";
    /** CLAIM_TYPE_LOGIC_CALL_EXECUTED - A claim for when a logic call has been executed */
    ClaimType[ClaimType["CLAIM_TYPE_LOGIC_CALL_EXECUTED"] = 4] = "CLAIM_TYPE_LOGIC_CALL_EXECUTED";
    /** CLAIM_TYPE_VALSET_UPDATED - A claim for when a valset update has happened */
    ClaimType[ClaimType["CLAIM_TYPE_VALSET_UPDATED"] = 5] = "CLAIM_TYPE_VALSET_UPDATED";
    ClaimType[ClaimType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(ClaimType || (ClaimType = {}));
function claimTypeFromJSON(object) {
    switch (object) {
        case 0:
        case "CLAIM_TYPE_UNSPECIFIED":
            return ClaimType.CLAIM_TYPE_UNSPECIFIED;
        case 1:
        case "CLAIM_TYPE_SEND_TO_COSMOS":
            return ClaimType.CLAIM_TYPE_SEND_TO_COSMOS;
        case 2:
        case "CLAIM_TYPE_BATCH_SEND_TO_ETH":
            return ClaimType.CLAIM_TYPE_BATCH_SEND_TO_ETH;
        case 3:
        case "CLAIM_TYPE_ERC20_DEPLOYED":
            return ClaimType.CLAIM_TYPE_ERC20_DEPLOYED;
        case 4:
        case "CLAIM_TYPE_LOGIC_CALL_EXECUTED":
            return ClaimType.CLAIM_TYPE_LOGIC_CALL_EXECUTED;
        case 5:
        case "CLAIM_TYPE_VALSET_UPDATED":
            return ClaimType.CLAIM_TYPE_VALSET_UPDATED;
        case -1:
        case "UNRECOGNIZED":
        default:
            return ClaimType.UNRECOGNIZED;
    }
}
function claimTypeToJSON(object) {
    switch (object) {
        case ClaimType.CLAIM_TYPE_UNSPECIFIED:
            return "CLAIM_TYPE_UNSPECIFIED";
        case ClaimType.CLAIM_TYPE_SEND_TO_COSMOS:
            return "CLAIM_TYPE_SEND_TO_COSMOS";
        case ClaimType.CLAIM_TYPE_BATCH_SEND_TO_ETH:
            return "CLAIM_TYPE_BATCH_SEND_TO_ETH";
        case ClaimType.CLAIM_TYPE_ERC20_DEPLOYED:
            return "CLAIM_TYPE_ERC20_DEPLOYED";
        case ClaimType.CLAIM_TYPE_LOGIC_CALL_EXECUTED:
            return "CLAIM_TYPE_LOGIC_CALL_EXECUTED";
        case ClaimType.CLAIM_TYPE_VALSET_UPDATED:
            return "CLAIM_TYPE_VALSET_UPDATED";
        case ClaimType.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
function createBaseAttestation() {
    return {
        observed: false,
        votes: [],
        height: (long_default()).UZERO,
        claim: undefined,
    };
}
const Attestation = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.observed === true) {
            writer.uint32(8).bool(message.observed);
        }
        for (const v of message.votes) {
            writer.uint32(18).string(v);
        }
        if (!message.height.isZero()) {
            writer.uint32(24).uint64(message.height);
        }
        if (message.claim !== undefined) {
            any.Any.encode(message.claim, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAttestation();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.observed = reader.bool();
                    break;
                case 2:
                    message.votes.push(reader.string());
                    break;
                case 3:
                    message.height = reader.uint64();
                    break;
                case 4:
                    message.claim = any.Any.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            observed: isSet(object.observed) ? Boolean(object.observed) : false,
            votes: Array.isArray(object === null || object === void 0 ? void 0 : object.votes)
                ? object.votes.map((e) => String(e))
                : [],
            height: isSet(object.height) ? long_default().fromValue(object.height) : (long_default()).UZERO,
            claim: isSet(object.claim) ? any.Any.fromJSON(object.claim) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.observed !== undefined && (obj.observed = message.observed);
        if (message.votes) {
            obj.votes = message.votes.map((e) => e);
        }
        else {
            obj.votes = [];
        }
        message.height !== undefined &&
            (obj.height = (message.height || (long_default()).UZERO).toString());
        message.claim !== undefined &&
            (obj.claim = message.claim ? any.Any.toJSON(message.claim) : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseAttestation();
        message.observed = (_a = object.observed) !== null && _a !== void 0 ? _a : false;
        message.votes = ((_b = object.votes) === null || _b === void 0 ? void 0 : _b.map((e) => e)) || [];
        message.height =
            object.height !== undefined && object.height !== null
                ? long_default().fromValue(object.height)
                : (long_default()).UZERO;
        message.claim =
            object.claim !== undefined && object.claim !== null
                ? any.Any.fromPartial(object.claim)
                : undefined;
        return message;
    },
};
function createBaseERC20Token() {
    return {
        contract: "",
        amount: "",
    };
}
const ERC20Token = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.contract !== "") {
            writer.uint32(10).string(message.contract);
        }
        if (message.amount !== "") {
            writer.uint32(18).string(message.amount);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseERC20Token();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.contract = reader.string();
                    break;
                case 2:
                    message.amount = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            contract: isSet(object.contract) ? String(object.contract) : "",
            amount: isSet(object.amount) ? String(object.amount) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.contract !== undefined && (obj.contract = message.contract);
        message.amount !== undefined && (obj.amount = message.amount);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseERC20Token();
        message.contract = (_a = object.contract) !== null && _a !== void 0 ? _a : "";
        message.amount = (_b = object.amount) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
function createBaseEventObservation() {
    return {
        attestationType: "",
        bridgeContract: "",
        bridgeChainId: "",
        attestationId: "",
        nonce: "",
    };
}
const EventObservation = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.attestationType !== "") {
            writer.uint32(10).string(message.attestationType);
        }
        if (message.bridgeContract !== "") {
            writer.uint32(18).string(message.bridgeContract);
        }
        if (message.bridgeChainId !== "") {
            writer.uint32(26).string(message.bridgeChainId);
        }
        if (message.attestationId !== "") {
            writer.uint32(34).string(message.attestationId);
        }
        if (message.nonce !== "") {
            writer.uint32(42).string(message.nonce);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseEventObservation();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.attestationType = reader.string();
                    break;
                case 2:
                    message.bridgeContract = reader.string();
                    break;
                case 3:
                    message.bridgeChainId = reader.string();
                    break;
                case 4:
                    message.attestationId = reader.string();
                    break;
                case 5:
                    message.nonce = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            attestationType: isSet(object.attestationType)
                ? String(object.attestationType)
                : "",
            bridgeContract: isSet(object.bridgeContract)
                ? String(object.bridgeContract)
                : "",
            bridgeChainId: isSet(object.bridgeChainId)
                ? String(object.bridgeChainId)
                : "",
            attestationId: isSet(object.attestationId)
                ? String(object.attestationId)
                : "",
            nonce: isSet(object.nonce) ? String(object.nonce) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.attestationType !== undefined &&
            (obj.attestationType = message.attestationType);
        message.bridgeContract !== undefined &&
            (obj.bridgeContract = message.bridgeContract);
        message.bridgeChainId !== undefined &&
            (obj.bridgeChainId = message.bridgeChainId);
        message.attestationId !== undefined &&
            (obj.attestationId = message.attestationId);
        message.nonce !== undefined && (obj.nonce = message.nonce);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e;
        const message = createBaseEventObservation();
        message.attestationType = (_a = object.attestationType) !== null && _a !== void 0 ? _a : "";
        message.bridgeContract = (_b = object.bridgeContract) !== null && _b !== void 0 ? _b : "";
        message.bridgeChainId = (_c = object.bridgeChainId) !== null && _c !== void 0 ? _c : "";
        message.attestationId = (_d = object.attestationId) !== null && _d !== void 0 ? _d : "";
        message.nonce = (_e = object.nonce) !== null && _e !== void 0 ? _e : "";
        return message;
    },
};
function createBaseEventInvalidSendToCosmosReceiver() {
    return {
        amount: "",
        nonce: "",
        token: "",
        sender: "",
    };
}
const EventInvalidSendToCosmosReceiver = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.amount !== "") {
            writer.uint32(10).string(message.amount);
        }
        if (message.nonce !== "") {
            writer.uint32(18).string(message.nonce);
        }
        if (message.token !== "") {
            writer.uint32(26).string(message.token);
        }
        if (message.sender !== "") {
            writer.uint32(34).string(message.sender);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseEventInvalidSendToCosmosReceiver();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.amount = reader.string();
                    break;
                case 2:
                    message.nonce = reader.string();
                    break;
                case 3:
                    message.token = reader.string();
                    break;
                case 4:
                    message.sender = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            amount: isSet(object.amount) ? String(object.amount) : "",
            nonce: isSet(object.nonce) ? String(object.nonce) : "",
            token: isSet(object.token) ? String(object.token) : "",
            sender: isSet(object.sender) ? String(object.sender) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.amount !== undefined && (obj.amount = message.amount);
        message.nonce !== undefined && (obj.nonce = message.nonce);
        message.token !== undefined && (obj.token = message.token);
        message.sender !== undefined && (obj.sender = message.sender);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d;
        const message = createBaseEventInvalidSendToCosmosReceiver();
        message.amount = (_a = object.amount) !== null && _a !== void 0 ? _a : "";
        message.nonce = (_b = object.nonce) !== null && _b !== void 0 ? _b : "";
        message.token = (_c = object.token) !== null && _c !== void 0 ? _c : "";
        message.sender = (_d = object.sender) !== null && _d !== void 0 ? _d : "";
        return message;
    },
};
function createBaseEventSendToCosmos() {
    return {
        amount: "",
        nonce: "",
        token: "",
    };
}
const EventSendToCosmos = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.amount !== "") {
            writer.uint32(10).string(message.amount);
        }
        if (message.nonce !== "") {
            writer.uint32(18).string(message.nonce);
        }
        if (message.token !== "") {
            writer.uint32(26).string(message.token);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseEventSendToCosmos();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.amount = reader.string();
                    break;
                case 2:
                    message.nonce = reader.string();
                    break;
                case 3:
                    message.token = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            amount: isSet(object.amount) ? String(object.amount) : "",
            nonce: isSet(object.nonce) ? String(object.nonce) : "",
            token: isSet(object.token) ? String(object.token) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.amount !== undefined && (obj.amount = message.amount);
        message.nonce !== undefined && (obj.nonce = message.nonce);
        message.token !== undefined && (obj.token = message.token);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseEventSendToCosmos();
        message.amount = (_a = object.amount) !== null && _a !== void 0 ? _a : "";
        message.nonce = (_b = object.nonce) !== null && _b !== void 0 ? _b : "";
        message.token = (_c = object.token) !== null && _c !== void 0 ? _c : "";
        return message;
    },
};
function createBaseEventSendToCosmosLocal() {
    return {
        nonce: "",
        receiver: "",
        token: "",
        amount: "",
    };
}
const EventSendToCosmosLocal = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.nonce !== "") {
            writer.uint32(10).string(message.nonce);
        }
        if (message.receiver !== "") {
            writer.uint32(18).string(message.receiver);
        }
        if (message.token !== "") {
            writer.uint32(26).string(message.token);
        }
        if (message.amount !== "") {
            writer.uint32(34).string(message.amount);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseEventSendToCosmosLocal();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.nonce = reader.string();
                    break;
                case 2:
                    message.receiver = reader.string();
                    break;
                case 3:
                    message.token = reader.string();
                    break;
                case 4:
                    message.amount = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            nonce: isSet(object.nonce) ? String(object.nonce) : "",
            receiver: isSet(object.receiver) ? String(object.receiver) : "",
            token: isSet(object.token) ? String(object.token) : "",
            amount: isSet(object.amount) ? String(object.amount) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.nonce !== undefined && (obj.nonce = message.nonce);
        message.receiver !== undefined && (obj.receiver = message.receiver);
        message.token !== undefined && (obj.token = message.token);
        message.amount !== undefined && (obj.amount = message.amount);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d;
        const message = createBaseEventSendToCosmosLocal();
        message.nonce = (_a = object.nonce) !== null && _a !== void 0 ? _a : "";
        message.receiver = (_b = object.receiver) !== null && _b !== void 0 ? _b : "";
        message.token = (_c = object.token) !== null && _c !== void 0 ? _c : "";
        message.amount = (_d = object.amount) !== null && _d !== void 0 ? _d : "";
        return message;
    },
};
function createBaseEventSendToCosmosPendingIbcAutoForward() {
    return {
        nonce: "",
        receiver: "",
        token: "",
        amount: "",
        channel: "",
    };
}
const EventSendToCosmosPendingIbcAutoForward = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.nonce !== "") {
            writer.uint32(10).string(message.nonce);
        }
        if (message.receiver !== "") {
            writer.uint32(18).string(message.receiver);
        }
        if (message.token !== "") {
            writer.uint32(26).string(message.token);
        }
        if (message.amount !== "") {
            writer.uint32(34).string(message.amount);
        }
        if (message.channel !== "") {
            writer.uint32(42).string(message.channel);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseEventSendToCosmosPendingIbcAutoForward();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.nonce = reader.string();
                    break;
                case 2:
                    message.receiver = reader.string();
                    break;
                case 3:
                    message.token = reader.string();
                    break;
                case 4:
                    message.amount = reader.string();
                    break;
                case 5:
                    message.channel = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            nonce: isSet(object.nonce) ? String(object.nonce) : "",
            receiver: isSet(object.receiver) ? String(object.receiver) : "",
            token: isSet(object.token) ? String(object.token) : "",
            amount: isSet(object.amount) ? String(object.amount) : "",
            channel: isSet(object.channel) ? String(object.channel) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.nonce !== undefined && (obj.nonce = message.nonce);
        message.receiver !== undefined && (obj.receiver = message.receiver);
        message.token !== undefined && (obj.token = message.token);
        message.amount !== undefined && (obj.amount = message.amount);
        message.channel !== undefined && (obj.channel = message.channel);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e;
        const message = createBaseEventSendToCosmosPendingIbcAutoForward();
        message.nonce = (_a = object.nonce) !== null && _a !== void 0 ? _a : "";
        message.receiver = (_b = object.receiver) !== null && _b !== void 0 ? _b : "";
        message.token = (_c = object.token) !== null && _c !== void 0 ? _c : "";
        message.amount = (_d = object.amount) !== null && _d !== void 0 ? _d : "";
        message.channel = (_e = object.channel) !== null && _e !== void 0 ? _e : "";
        return message;
    },
};
function createBaseEventSendToCosmosExecutedIbcAutoForward() {
    return {
        nonce: "",
        receiver: "",
        token: "",
        amount: "",
        channel: "",
        timeoutTime: "",
        timeoutHeight: "",
    };
}
const EventSendToCosmosExecutedIbcAutoForward = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.nonce !== "") {
            writer.uint32(10).string(message.nonce);
        }
        if (message.receiver !== "") {
            writer.uint32(18).string(message.receiver);
        }
        if (message.token !== "") {
            writer.uint32(26).string(message.token);
        }
        if (message.amount !== "") {
            writer.uint32(34).string(message.amount);
        }
        if (message.channel !== "") {
            writer.uint32(42).string(message.channel);
        }
        if (message.timeoutTime !== "") {
            writer.uint32(50).string(message.timeoutTime);
        }
        if (message.timeoutHeight !== "") {
            writer.uint32(58).string(message.timeoutHeight);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseEventSendToCosmosExecutedIbcAutoForward();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.nonce = reader.string();
                    break;
                case 2:
                    message.receiver = reader.string();
                    break;
                case 3:
                    message.token = reader.string();
                    break;
                case 4:
                    message.amount = reader.string();
                    break;
                case 5:
                    message.channel = reader.string();
                    break;
                case 6:
                    message.timeoutTime = reader.string();
                    break;
                case 7:
                    message.timeoutHeight = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            nonce: isSet(object.nonce) ? String(object.nonce) : "",
            receiver: isSet(object.receiver) ? String(object.receiver) : "",
            token: isSet(object.token) ? String(object.token) : "",
            amount: isSet(object.amount) ? String(object.amount) : "",
            channel: isSet(object.channel) ? String(object.channel) : "",
            timeoutTime: isSet(object.timeoutTime) ? String(object.timeoutTime) : "",
            timeoutHeight: isSet(object.timeoutHeight)
                ? String(object.timeoutHeight)
                : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.nonce !== undefined && (obj.nonce = message.nonce);
        message.receiver !== undefined && (obj.receiver = message.receiver);
        message.token !== undefined && (obj.token = message.token);
        message.amount !== undefined && (obj.amount = message.amount);
        message.channel !== undefined && (obj.channel = message.channel);
        message.timeoutTime !== undefined &&
            (obj.timeoutTime = message.timeoutTime);
        message.timeoutHeight !== undefined &&
            (obj.timeoutHeight = message.timeoutHeight);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f, _g;
        const message = createBaseEventSendToCosmosExecutedIbcAutoForward();
        message.nonce = (_a = object.nonce) !== null && _a !== void 0 ? _a : "";
        message.receiver = (_b = object.receiver) !== null && _b !== void 0 ? _b : "";
        message.token = (_c = object.token) !== null && _c !== void 0 ? _c : "";
        message.amount = (_d = object.amount) !== null && _d !== void 0 ? _d : "";
        message.channel = (_e = object.channel) !== null && _e !== void 0 ? _e : "";
        message.timeoutTime = (_f = object.timeoutTime) !== null && _f !== void 0 ? _f : "";
        message.timeoutHeight = (_g = object.timeoutHeight) !== null && _g !== void 0 ? _g : "";
        return message;
    },
};

;// CONCATENATED MODULE: ./node_modules/kujira.js/lib/esm/gravity/v1/batch.js
/* eslint-disable */



const batch_protobufPackage = "gravity.v1";
function createBaseOutgoingTxBatch() {
    return {
        batchNonce: (long_default()).UZERO,
        batchTimeout: (long_default()).UZERO,
        transactions: [],
        tokenContract: "",
        cosmosBlockCreated: (long_default()).UZERO,
    };
}
const OutgoingTxBatch = {
    encode(message, writer = minimal.Writer.create()) {
        if (!message.batchNonce.isZero()) {
            writer.uint32(8).uint64(message.batchNonce);
        }
        if (!message.batchTimeout.isZero()) {
            writer.uint32(16).uint64(message.batchTimeout);
        }
        for (const v of message.transactions) {
            OutgoingTransferTx.encode(v, writer.uint32(26).fork()).ldelim();
        }
        if (message.tokenContract !== "") {
            writer.uint32(34).string(message.tokenContract);
        }
        if (!message.cosmosBlockCreated.isZero()) {
            writer.uint32(40).uint64(message.cosmosBlockCreated);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseOutgoingTxBatch();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.batchNonce = reader.uint64();
                    break;
                case 2:
                    message.batchTimeout = reader.uint64();
                    break;
                case 3:
                    message.transactions.push(OutgoingTransferTx.decode(reader, reader.uint32()));
                    break;
                case 4:
                    message.tokenContract = reader.string();
                    break;
                case 5:
                    message.cosmosBlockCreated = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            batchNonce: isSet(object.batchNonce)
                ? long_default().fromValue(object.batchNonce)
                : (long_default()).UZERO,
            batchTimeout: isSet(object.batchTimeout)
                ? long_default().fromValue(object.batchTimeout)
                : (long_default()).UZERO,
            transactions: Array.isArray(object === null || object === void 0 ? void 0 : object.transactions)
                ? object.transactions.map((e) => OutgoingTransferTx.fromJSON(e))
                : [],
            tokenContract: isSet(object.tokenContract)
                ? String(object.tokenContract)
                : "",
            cosmosBlockCreated: isSet(object.cosmosBlockCreated)
                ? long_default().fromValue(object.cosmosBlockCreated)
                : (long_default()).UZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        message.batchNonce !== undefined &&
            (obj.batchNonce = (message.batchNonce || (long_default()).UZERO).toString());
        message.batchTimeout !== undefined &&
            (obj.batchTimeout = (message.batchTimeout || (long_default()).UZERO).toString());
        if (message.transactions) {
            obj.transactions = message.transactions.map((e) => e ? OutgoingTransferTx.toJSON(e) : undefined);
        }
        else {
            obj.transactions = [];
        }
        message.tokenContract !== undefined &&
            (obj.tokenContract = message.tokenContract);
        message.cosmosBlockCreated !== undefined &&
            (obj.cosmosBlockCreated = (message.cosmosBlockCreated || (long_default()).UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseOutgoingTxBatch();
        message.batchNonce =
            object.batchNonce !== undefined && object.batchNonce !== null
                ? long_default().fromValue(object.batchNonce)
                : (long_default()).UZERO;
        message.batchTimeout =
            object.batchTimeout !== undefined && object.batchTimeout !== null
                ? long_default().fromValue(object.batchTimeout)
                : (long_default()).UZERO;
        message.transactions =
            ((_a = object.transactions) === null || _a === void 0 ? void 0 : _a.map((e) => OutgoingTransferTx.fromPartial(e))) || [];
        message.tokenContract = (_b = object.tokenContract) !== null && _b !== void 0 ? _b : "";
        message.cosmosBlockCreated =
            object.cosmosBlockCreated !== undefined &&
                object.cosmosBlockCreated !== null
                ? long_default().fromValue(object.cosmosBlockCreated)
                : (long_default()).UZERO;
        return message;
    },
};
function createBaseOutgoingTransferTx() {
    return {
        id: (long_default()).UZERO,
        sender: "",
        destAddress: "",
        erc20Token: undefined,
        erc20Fee: undefined,
    };
}
const OutgoingTransferTx = {
    encode(message, writer = minimal.Writer.create()) {
        if (!message.id.isZero()) {
            writer.uint32(8).uint64(message.id);
        }
        if (message.sender !== "") {
            writer.uint32(18).string(message.sender);
        }
        if (message.destAddress !== "") {
            writer.uint32(26).string(message.destAddress);
        }
        if (message.erc20Token !== undefined) {
            ERC20Token.encode(message.erc20Token, writer.uint32(34).fork()).ldelim();
        }
        if (message.erc20Fee !== undefined) {
            ERC20Token.encode(message.erc20Fee, writer.uint32(42).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseOutgoingTransferTx();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.id = reader.uint64();
                    break;
                case 2:
                    message.sender = reader.string();
                    break;
                case 3:
                    message.destAddress = reader.string();
                    break;
                case 4:
                    message.erc20Token = ERC20Token.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.erc20Fee = ERC20Token.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            id: isSet(object.id) ? long_default().fromValue(object.id) : (long_default()).UZERO,
            sender: isSet(object.sender) ? String(object.sender) : "",
            destAddress: isSet(object.destAddress) ? String(object.destAddress) : "",
            erc20Token: isSet(object.erc20Token)
                ? ERC20Token.fromJSON(object.erc20Token)
                : undefined,
            erc20Fee: isSet(object.erc20Fee)
                ? ERC20Token.fromJSON(object.erc20Fee)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.id !== undefined &&
            (obj.id = (message.id || (long_default()).UZERO).toString());
        message.sender !== undefined && (obj.sender = message.sender);
        message.destAddress !== undefined &&
            (obj.destAddress = message.destAddress);
        message.erc20Token !== undefined &&
            (obj.erc20Token = message.erc20Token
                ? ERC20Token.toJSON(message.erc20Token)
                : undefined);
        message.erc20Fee !== undefined &&
            (obj.erc20Fee = message.erc20Fee
                ? ERC20Token.toJSON(message.erc20Fee)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseOutgoingTransferTx();
        message.id =
            object.id !== undefined && object.id !== null
                ? long_default().fromValue(object.id)
                : (long_default()).UZERO;
        message.sender = (_a = object.sender) !== null && _a !== void 0 ? _a : "";
        message.destAddress = (_b = object.destAddress) !== null && _b !== void 0 ? _b : "";
        message.erc20Token =
            object.erc20Token !== undefined && object.erc20Token !== null
                ? ERC20Token.fromPartial(object.erc20Token)
                : undefined;
        message.erc20Fee =
            object.erc20Fee !== undefined && object.erc20Fee !== null
                ? ERC20Token.fromPartial(object.erc20Fee)
                : undefined;
        return message;
    },
};
function createBaseOutgoingLogicCall() {
    return {
        transfers: [],
        fees: [],
        logicContractAddress: "",
        payload: new Uint8Array(),
        timeout: (long_default()).UZERO,
        invalidationId: new Uint8Array(),
        invalidationNonce: (long_default()).UZERO,
        cosmosBlockCreated: (long_default()).UZERO,
    };
}
const OutgoingLogicCall = {
    encode(message, writer = minimal.Writer.create()) {
        for (const v of message.transfers) {
            ERC20Token.encode(v, writer.uint32(10).fork()).ldelim();
        }
        for (const v of message.fees) {
            ERC20Token.encode(v, writer.uint32(18).fork()).ldelim();
        }
        if (message.logicContractAddress !== "") {
            writer.uint32(26).string(message.logicContractAddress);
        }
        if (message.payload.length !== 0) {
            writer.uint32(34).bytes(message.payload);
        }
        if (!message.timeout.isZero()) {
            writer.uint32(40).uint64(message.timeout);
        }
        if (message.invalidationId.length !== 0) {
            writer.uint32(50).bytes(message.invalidationId);
        }
        if (!message.invalidationNonce.isZero()) {
            writer.uint32(56).uint64(message.invalidationNonce);
        }
        if (!message.cosmosBlockCreated.isZero()) {
            writer.uint32(64).uint64(message.cosmosBlockCreated);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseOutgoingLogicCall();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.transfers.push(ERC20Token.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.fees.push(ERC20Token.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.logicContractAddress = reader.string();
                    break;
                case 4:
                    message.payload = reader.bytes();
                    break;
                case 5:
                    message.timeout = reader.uint64();
                    break;
                case 6:
                    message.invalidationId = reader.bytes();
                    break;
                case 7:
                    message.invalidationNonce = reader.uint64();
                    break;
                case 8:
                    message.cosmosBlockCreated = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            transfers: Array.isArray(object === null || object === void 0 ? void 0 : object.transfers)
                ? object.transfers.map((e) => ERC20Token.fromJSON(e))
                : [],
            fees: Array.isArray(object === null || object === void 0 ? void 0 : object.fees)
                ? object.fees.map((e) => ERC20Token.fromJSON(e))
                : [],
            logicContractAddress: isSet(object.logicContractAddress)
                ? String(object.logicContractAddress)
                : "",
            payload: isSet(object.payload)
                ? bytesFromBase64(object.payload)
                : new Uint8Array(),
            timeout: isSet(object.timeout)
                ? long_default().fromValue(object.timeout)
                : (long_default()).UZERO,
            invalidationId: isSet(object.invalidationId)
                ? bytesFromBase64(object.invalidationId)
                : new Uint8Array(),
            invalidationNonce: isSet(object.invalidationNonce)
                ? long_default().fromValue(object.invalidationNonce)
                : (long_default()).UZERO,
            cosmosBlockCreated: isSet(object.cosmosBlockCreated)
                ? long_default().fromValue(object.cosmosBlockCreated)
                : (long_default()).UZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.transfers) {
            obj.transfers = message.transfers.map((e) => e ? ERC20Token.toJSON(e) : undefined);
        }
        else {
            obj.transfers = [];
        }
        if (message.fees) {
            obj.fees = message.fees.map((e) => e ? ERC20Token.toJSON(e) : undefined);
        }
        else {
            obj.fees = [];
        }
        message.logicContractAddress !== undefined &&
            (obj.logicContractAddress = message.logicContractAddress);
        message.payload !== undefined &&
            (obj.payload = base64FromBytes(message.payload !== undefined ? message.payload : new Uint8Array()));
        message.timeout !== undefined &&
            (obj.timeout = (message.timeout || (long_default()).UZERO).toString());
        message.invalidationId !== undefined &&
            (obj.invalidationId = base64FromBytes(message.invalidationId !== undefined
                ? message.invalidationId
                : new Uint8Array()));
        message.invalidationNonce !== undefined &&
            (obj.invalidationNonce = (message.invalidationNonce || (long_default()).UZERO).toString());
        message.cosmosBlockCreated !== undefined &&
            (obj.cosmosBlockCreated = (message.cosmosBlockCreated || (long_default()).UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e;
        const message = createBaseOutgoingLogicCall();
        message.transfers =
            ((_a = object.transfers) === null || _a === void 0 ? void 0 : _a.map((e) => ERC20Token.fromPartial(e))) || [];
        message.fees = ((_b = object.fees) === null || _b === void 0 ? void 0 : _b.map((e) => ERC20Token.fromPartial(e))) || [];
        message.logicContractAddress = (_c = object.logicContractAddress) !== null && _c !== void 0 ? _c : "";
        message.payload = (_d = object.payload) !== null && _d !== void 0 ? _d : new Uint8Array();
        message.timeout =
            object.timeout !== undefined && object.timeout !== null
                ? long_default().fromValue(object.timeout)
                : (long_default()).UZERO;
        message.invalidationId = (_e = object.invalidationId) !== null && _e !== void 0 ? _e : new Uint8Array();
        message.invalidationNonce =
            object.invalidationNonce !== undefined &&
                object.invalidationNonce !== null
                ? long_default().fromValue(object.invalidationNonce)
                : (long_default()).UZERO;
        message.cosmosBlockCreated =
            object.cosmosBlockCreated !== undefined &&
                object.cosmosBlockCreated !== null
                ? long_default().fromValue(object.cosmosBlockCreated)
                : (long_default()).UZERO;
        return message;
    },
};
function createBaseEventOutgoingBatchCanceled() {
    return {
        bridgeContract: "",
        bridgeChainId: "",
        batchId: "",
        nonce: "",
    };
}
const EventOutgoingBatchCanceled = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.bridgeContract !== "") {
            writer.uint32(10).string(message.bridgeContract);
        }
        if (message.bridgeChainId !== "") {
            writer.uint32(18).string(message.bridgeChainId);
        }
        if (message.batchId !== "") {
            writer.uint32(26).string(message.batchId);
        }
        if (message.nonce !== "") {
            writer.uint32(34).string(message.nonce);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseEventOutgoingBatchCanceled();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.bridgeContract = reader.string();
                    break;
                case 2:
                    message.bridgeChainId = reader.string();
                    break;
                case 3:
                    message.batchId = reader.string();
                    break;
                case 4:
                    message.nonce = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            bridgeContract: isSet(object.bridgeContract)
                ? String(object.bridgeContract)
                : "",
            bridgeChainId: isSet(object.bridgeChainId)
                ? String(object.bridgeChainId)
                : "",
            batchId: isSet(object.batchId) ? String(object.batchId) : "",
            nonce: isSet(object.nonce) ? String(object.nonce) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.bridgeContract !== undefined &&
            (obj.bridgeContract = message.bridgeContract);
        message.bridgeChainId !== undefined &&
            (obj.bridgeChainId = message.bridgeChainId);
        message.batchId !== undefined && (obj.batchId = message.batchId);
        message.nonce !== undefined && (obj.nonce = message.nonce);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d;
        const message = createBaseEventOutgoingBatchCanceled();
        message.bridgeContract = (_a = object.bridgeContract) !== null && _a !== void 0 ? _a : "";
        message.bridgeChainId = (_b = object.bridgeChainId) !== null && _b !== void 0 ? _b : "";
        message.batchId = (_c = object.batchId) !== null && _c !== void 0 ? _c : "";
        message.nonce = (_d = object.nonce) !== null && _d !== void 0 ? _d : "";
        return message;
    },
};
function createBaseEventOutgoingBatch() {
    return {
        bridgeContract: "",
        bridgeChainId: "",
        batchId: "",
        nonce: "",
    };
}
const EventOutgoingBatch = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.bridgeContract !== "") {
            writer.uint32(10).string(message.bridgeContract);
        }
        if (message.bridgeChainId !== "") {
            writer.uint32(18).string(message.bridgeChainId);
        }
        if (message.batchId !== "") {
            writer.uint32(26).string(message.batchId);
        }
        if (message.nonce !== "") {
            writer.uint32(34).string(message.nonce);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseEventOutgoingBatch();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.bridgeContract = reader.string();
                    break;
                case 2:
                    message.bridgeChainId = reader.string();
                    break;
                case 3:
                    message.batchId = reader.string();
                    break;
                case 4:
                    message.nonce = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            bridgeContract: isSet(object.bridgeContract)
                ? String(object.bridgeContract)
                : "",
            bridgeChainId: isSet(object.bridgeChainId)
                ? String(object.bridgeChainId)
                : "",
            batchId: isSet(object.batchId) ? String(object.batchId) : "",
            nonce: isSet(object.nonce) ? String(object.nonce) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.bridgeContract !== undefined &&
            (obj.bridgeContract = message.bridgeContract);
        message.bridgeChainId !== undefined &&
            (obj.bridgeChainId = message.bridgeChainId);
        message.batchId !== undefined && (obj.batchId = message.batchId);
        message.nonce !== undefined && (obj.nonce = message.nonce);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d;
        const message = createBaseEventOutgoingBatch();
        message.bridgeContract = (_a = object.bridgeContract) !== null && _a !== void 0 ? _a : "";
        message.bridgeChainId = (_b = object.bridgeChainId) !== null && _b !== void 0 ? _b : "";
        message.batchId = (_c = object.batchId) !== null && _c !== void 0 ? _c : "";
        message.nonce = (_d = object.nonce) !== null && _d !== void 0 ? _d : "";
        return message;
    },
};

;// CONCATENATED MODULE: ./node_modules/kujira.js/lib/esm/gravity/v1/genesis.js
/* eslint-disable */







const genesis_protobufPackage = "gravity.v1";
function createBaseParams() {
    return {
        gravityId: "",
        contractSourceHash: "",
        bridgeEthereumAddress: "",
        bridgeChainId: (long_default()).UZERO,
        signedValsetsWindow: (long_default()).UZERO,
        signedBatchesWindow: (long_default()).UZERO,
        signedLogicCallsWindow: (long_default()).UZERO,
        targetBatchTimeout: (long_default()).UZERO,
        averageBlockTime: (long_default()).UZERO,
        averageEthereumBlockTime: (long_default()).UZERO,
        slashFractionValset: new Uint8Array(),
        slashFractionBatch: new Uint8Array(),
        slashFractionLogicCall: new Uint8Array(),
        unbondSlashingValsetsWindow: (long_default()).UZERO,
        slashFractionBadEthSignature: new Uint8Array(),
        valsetReward: undefined,
        bridgeActive: false,
        ethereumBlacklist: [],
        minChainFeeBasisPoints: (long_default()).UZERO,
    };
}
const Params = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.gravityId !== "") {
            writer.uint32(10).string(message.gravityId);
        }
        if (message.contractSourceHash !== "") {
            writer.uint32(18).string(message.contractSourceHash);
        }
        if (message.bridgeEthereumAddress !== "") {
            writer.uint32(34).string(message.bridgeEthereumAddress);
        }
        if (!message.bridgeChainId.isZero()) {
            writer.uint32(40).uint64(message.bridgeChainId);
        }
        if (!message.signedValsetsWindow.isZero()) {
            writer.uint32(48).uint64(message.signedValsetsWindow);
        }
        if (!message.signedBatchesWindow.isZero()) {
            writer.uint32(56).uint64(message.signedBatchesWindow);
        }
        if (!message.signedLogicCallsWindow.isZero()) {
            writer.uint32(64).uint64(message.signedLogicCallsWindow);
        }
        if (!message.targetBatchTimeout.isZero()) {
            writer.uint32(72).uint64(message.targetBatchTimeout);
        }
        if (!message.averageBlockTime.isZero()) {
            writer.uint32(80).uint64(message.averageBlockTime);
        }
        if (!message.averageEthereumBlockTime.isZero()) {
            writer.uint32(88).uint64(message.averageEthereumBlockTime);
        }
        if (message.slashFractionValset.length !== 0) {
            writer.uint32(98).bytes(message.slashFractionValset);
        }
        if (message.slashFractionBatch.length !== 0) {
            writer.uint32(106).bytes(message.slashFractionBatch);
        }
        if (message.slashFractionLogicCall.length !== 0) {
            writer.uint32(114).bytes(message.slashFractionLogicCall);
        }
        if (!message.unbondSlashingValsetsWindow.isZero()) {
            writer.uint32(120).uint64(message.unbondSlashingValsetsWindow);
        }
        if (message.slashFractionBadEthSignature.length !== 0) {
            writer.uint32(130).bytes(message.slashFractionBadEthSignature);
        }
        if (message.valsetReward !== undefined) {
            coin.Coin.encode(message.valsetReward, writer.uint32(138).fork()).ldelim();
        }
        if (message.bridgeActive === true) {
            writer.uint32(144).bool(message.bridgeActive);
        }
        for (const v of message.ethereumBlacklist) {
            writer.uint32(154).string(v);
        }
        if (!message.minChainFeeBasisPoints.isZero()) {
            writer.uint32(160).uint64(message.minChainFeeBasisPoints);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseParams();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.gravityId = reader.string();
                    break;
                case 2:
                    message.contractSourceHash = reader.string();
                    break;
                case 4:
                    message.bridgeEthereumAddress = reader.string();
                    break;
                case 5:
                    message.bridgeChainId = reader.uint64();
                    break;
                case 6:
                    message.signedValsetsWindow = reader.uint64();
                    break;
                case 7:
                    message.signedBatchesWindow = reader.uint64();
                    break;
                case 8:
                    message.signedLogicCallsWindow = reader.uint64();
                    break;
                case 9:
                    message.targetBatchTimeout = reader.uint64();
                    break;
                case 10:
                    message.averageBlockTime = reader.uint64();
                    break;
                case 11:
                    message.averageEthereumBlockTime = reader.uint64();
                    break;
                case 12:
                    message.slashFractionValset = reader.bytes();
                    break;
                case 13:
                    message.slashFractionBatch = reader.bytes();
                    break;
                case 14:
                    message.slashFractionLogicCall = reader.bytes();
                    break;
                case 15:
                    message.unbondSlashingValsetsWindow = reader.uint64();
                    break;
                case 16:
                    message.slashFractionBadEthSignature = reader.bytes();
                    break;
                case 17:
                    message.valsetReward = coin.Coin.decode(reader, reader.uint32());
                    break;
                case 18:
                    message.bridgeActive = reader.bool();
                    break;
                case 19:
                    message.ethereumBlacklist.push(reader.string());
                    break;
                case 20:
                    message.minChainFeeBasisPoints = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            gravityId: isSet(object.gravityId) ? String(object.gravityId) : "",
            contractSourceHash: isSet(object.contractSourceHash)
                ? String(object.contractSourceHash)
                : "",
            bridgeEthereumAddress: isSet(object.bridgeEthereumAddress)
                ? String(object.bridgeEthereumAddress)
                : "",
            bridgeChainId: isSet(object.bridgeChainId)
                ? long_default().fromValue(object.bridgeChainId)
                : (long_default()).UZERO,
            signedValsetsWindow: isSet(object.signedValsetsWindow)
                ? long_default().fromValue(object.signedValsetsWindow)
                : (long_default()).UZERO,
            signedBatchesWindow: isSet(object.signedBatchesWindow)
                ? long_default().fromValue(object.signedBatchesWindow)
                : (long_default()).UZERO,
            signedLogicCallsWindow: isSet(object.signedLogicCallsWindow)
                ? long_default().fromValue(object.signedLogicCallsWindow)
                : (long_default()).UZERO,
            targetBatchTimeout: isSet(object.targetBatchTimeout)
                ? long_default().fromValue(object.targetBatchTimeout)
                : (long_default()).UZERO,
            averageBlockTime: isSet(object.averageBlockTime)
                ? long_default().fromValue(object.averageBlockTime)
                : (long_default()).UZERO,
            averageEthereumBlockTime: isSet(object.averageEthereumBlockTime)
                ? long_default().fromValue(object.averageEthereumBlockTime)
                : (long_default()).UZERO,
            slashFractionValset: isSet(object.slashFractionValset)
                ? bytesFromBase64(object.slashFractionValset)
                : new Uint8Array(),
            slashFractionBatch: isSet(object.slashFractionBatch)
                ? bytesFromBase64(object.slashFractionBatch)
                : new Uint8Array(),
            slashFractionLogicCall: isSet(object.slashFractionLogicCall)
                ? bytesFromBase64(object.slashFractionLogicCall)
                : new Uint8Array(),
            unbondSlashingValsetsWindow: isSet(object.unbondSlashingValsetsWindow)
                ? long_default().fromValue(object.unbondSlashingValsetsWindow)
                : (long_default()).UZERO,
            slashFractionBadEthSignature: isSet(object.slashFractionBadEthSignature)
                ? bytesFromBase64(object.slashFractionBadEthSignature)
                : new Uint8Array(),
            valsetReward: isSet(object.valsetReward)
                ? coin.Coin.fromJSON(object.valsetReward)
                : undefined,
            bridgeActive: isSet(object.bridgeActive)
                ? Boolean(object.bridgeActive)
                : false,
            ethereumBlacklist: Array.isArray(object === null || object === void 0 ? void 0 : object.ethereumBlacklist)
                ? object.ethereumBlacklist.map((e) => String(e))
                : [],
            minChainFeeBasisPoints: isSet(object.minChainFeeBasisPoints)
                ? long_default().fromValue(object.minChainFeeBasisPoints)
                : (long_default()).UZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        message.gravityId !== undefined && (obj.gravityId = message.gravityId);
        message.contractSourceHash !== undefined &&
            (obj.contractSourceHash = message.contractSourceHash);
        message.bridgeEthereumAddress !== undefined &&
            (obj.bridgeEthereumAddress = message.bridgeEthereumAddress);
        message.bridgeChainId !== undefined &&
            (obj.bridgeChainId = (message.bridgeChainId || (long_default()).UZERO).toString());
        message.signedValsetsWindow !== undefined &&
            (obj.signedValsetsWindow = (message.signedValsetsWindow || (long_default()).UZERO).toString());
        message.signedBatchesWindow !== undefined &&
            (obj.signedBatchesWindow = (message.signedBatchesWindow || (long_default()).UZERO).toString());
        message.signedLogicCallsWindow !== undefined &&
            (obj.signedLogicCallsWindow = (message.signedLogicCallsWindow || (long_default()).UZERO).toString());
        message.targetBatchTimeout !== undefined &&
            (obj.targetBatchTimeout = (message.targetBatchTimeout || (long_default()).UZERO).toString());
        message.averageBlockTime !== undefined &&
            (obj.averageBlockTime = (message.averageBlockTime || (long_default()).UZERO).toString());
        message.averageEthereumBlockTime !== undefined &&
            (obj.averageEthereumBlockTime = (message.averageEthereumBlockTime || (long_default()).UZERO).toString());
        message.slashFractionValset !== undefined &&
            (obj.slashFractionValset = base64FromBytes(message.slashFractionValset !== undefined
                ? message.slashFractionValset
                : new Uint8Array()));
        message.slashFractionBatch !== undefined &&
            (obj.slashFractionBatch = base64FromBytes(message.slashFractionBatch !== undefined
                ? message.slashFractionBatch
                : new Uint8Array()));
        message.slashFractionLogicCall !== undefined &&
            (obj.slashFractionLogicCall = base64FromBytes(message.slashFractionLogicCall !== undefined
                ? message.slashFractionLogicCall
                : new Uint8Array()));
        message.unbondSlashingValsetsWindow !== undefined &&
            (obj.unbondSlashingValsetsWindow = (message.unbondSlashingValsetsWindow || (long_default()).UZERO).toString());
        message.slashFractionBadEthSignature !== undefined &&
            (obj.slashFractionBadEthSignature = base64FromBytes(message.slashFractionBadEthSignature !== undefined
                ? message.slashFractionBadEthSignature
                : new Uint8Array()));
        message.valsetReward !== undefined &&
            (obj.valsetReward = message.valsetReward
                ? coin.Coin.toJSON(message.valsetReward)
                : undefined);
        message.bridgeActive !== undefined &&
            (obj.bridgeActive = message.bridgeActive);
        if (message.ethereumBlacklist) {
            obj.ethereumBlacklist = message.ethereumBlacklist.map((e) => e);
        }
        else {
            obj.ethereumBlacklist = [];
        }
        message.minChainFeeBasisPoints !== undefined &&
            (obj.minChainFeeBasisPoints = (message.minChainFeeBasisPoints || (long_default()).UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        const message = createBaseParams();
        message.gravityId = (_a = object.gravityId) !== null && _a !== void 0 ? _a : "";
        message.contractSourceHash = (_b = object.contractSourceHash) !== null && _b !== void 0 ? _b : "";
        message.bridgeEthereumAddress = (_c = object.bridgeEthereumAddress) !== null && _c !== void 0 ? _c : "";
        message.bridgeChainId =
            object.bridgeChainId !== undefined && object.bridgeChainId !== null
                ? long_default().fromValue(object.bridgeChainId)
                : (long_default()).UZERO;
        message.signedValsetsWindow =
            object.signedValsetsWindow !== undefined &&
                object.signedValsetsWindow !== null
                ? long_default().fromValue(object.signedValsetsWindow)
                : (long_default()).UZERO;
        message.signedBatchesWindow =
            object.signedBatchesWindow !== undefined &&
                object.signedBatchesWindow !== null
                ? long_default().fromValue(object.signedBatchesWindow)
                : (long_default()).UZERO;
        message.signedLogicCallsWindow =
            object.signedLogicCallsWindow !== undefined &&
                object.signedLogicCallsWindow !== null
                ? long_default().fromValue(object.signedLogicCallsWindow)
                : (long_default()).UZERO;
        message.targetBatchTimeout =
            object.targetBatchTimeout !== undefined &&
                object.targetBatchTimeout !== null
                ? long_default().fromValue(object.targetBatchTimeout)
                : (long_default()).UZERO;
        message.averageBlockTime =
            object.averageBlockTime !== undefined && object.averageBlockTime !== null
                ? long_default().fromValue(object.averageBlockTime)
                : (long_default()).UZERO;
        message.averageEthereumBlockTime =
            object.averageEthereumBlockTime !== undefined &&
                object.averageEthereumBlockTime !== null
                ? long_default().fromValue(object.averageEthereumBlockTime)
                : (long_default()).UZERO;
        message.slashFractionValset =
            (_d = object.slashFractionValset) !== null && _d !== void 0 ? _d : new Uint8Array();
        message.slashFractionBatch = (_e = object.slashFractionBatch) !== null && _e !== void 0 ? _e : new Uint8Array();
        message.slashFractionLogicCall =
            (_f = object.slashFractionLogicCall) !== null && _f !== void 0 ? _f : new Uint8Array();
        message.unbondSlashingValsetsWindow =
            object.unbondSlashingValsetsWindow !== undefined &&
                object.unbondSlashingValsetsWindow !== null
                ? long_default().fromValue(object.unbondSlashingValsetsWindow)
                : (long_default()).UZERO;
        message.slashFractionBadEthSignature =
            (_g = object.slashFractionBadEthSignature) !== null && _g !== void 0 ? _g : new Uint8Array();
        message.valsetReward =
            object.valsetReward !== undefined && object.valsetReward !== null
                ? coin.Coin.fromPartial(object.valsetReward)
                : undefined;
        message.bridgeActive = (_h = object.bridgeActive) !== null && _h !== void 0 ? _h : false;
        message.ethereumBlacklist = ((_j = object.ethereumBlacklist) === null || _j === void 0 ? void 0 : _j.map((e) => e)) || [];
        message.minChainFeeBasisPoints =
            object.minChainFeeBasisPoints !== undefined &&
                object.minChainFeeBasisPoints !== null
                ? long_default().fromValue(object.minChainFeeBasisPoints)
                : (long_default()).UZERO;
        return message;
    },
};
function createBaseGenesisState() {
    return {
        params: undefined,
        gravityNonces: undefined,
        valsets: [],
        valsetConfirms: [],
        batches: [],
        batchConfirms: [],
        logicCalls: [],
        logicCallConfirms: [],
        attestations: [],
        delegateKeys: [],
        erc20ToDenoms: [],
        unbatchedTransfers: [],
        pendingIbcAutoForwards: [],
    };
}
const GenesisState = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.params !== undefined) {
            Params.encode(message.params, writer.uint32(10).fork()).ldelim();
        }
        if (message.gravityNonces !== undefined) {
            GravityNonces.encode(message.gravityNonces, writer.uint32(18).fork()).ldelim();
        }
        for (const v of message.valsets) {
            Valset.encode(v, writer.uint32(26).fork()).ldelim();
        }
        for (const v of message.valsetConfirms) {
            MsgValsetConfirm.encode(v, writer.uint32(34).fork()).ldelim();
        }
        for (const v of message.batches) {
            OutgoingTxBatch.encode(v, writer.uint32(42).fork()).ldelim();
        }
        for (const v of message.batchConfirms) {
            MsgConfirmBatch.encode(v, writer.uint32(50).fork()).ldelim();
        }
        for (const v of message.logicCalls) {
            OutgoingLogicCall.encode(v, writer.uint32(58).fork()).ldelim();
        }
        for (const v of message.logicCallConfirms) {
            MsgConfirmLogicCall.encode(v, writer.uint32(66).fork()).ldelim();
        }
        for (const v of message.attestations) {
            Attestation.encode(v, writer.uint32(74).fork()).ldelim();
        }
        for (const v of message.delegateKeys) {
            MsgSetOrchestratorAddress.encode(v, writer.uint32(82).fork()).ldelim();
        }
        for (const v of message.erc20ToDenoms) {
            ERC20ToDenom.encode(v, writer.uint32(90).fork()).ldelim();
        }
        for (const v of message.unbatchedTransfers) {
            OutgoingTransferTx.encode(v, writer.uint32(98).fork()).ldelim();
        }
        for (const v of message.pendingIbcAutoForwards) {
            PendingIbcAutoForward.encode(v, writer.uint32(106).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGenesisState();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.params = Params.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.gravityNonces = GravityNonces.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.valsets.push(Valset.decode(reader, reader.uint32()));
                    break;
                case 4:
                    message.valsetConfirms.push(MsgValsetConfirm.decode(reader, reader.uint32()));
                    break;
                case 5:
                    message.batches.push(OutgoingTxBatch.decode(reader, reader.uint32()));
                    break;
                case 6:
                    message.batchConfirms.push(MsgConfirmBatch.decode(reader, reader.uint32()));
                    break;
                case 7:
                    message.logicCalls.push(OutgoingLogicCall.decode(reader, reader.uint32()));
                    break;
                case 8:
                    message.logicCallConfirms.push(MsgConfirmLogicCall.decode(reader, reader.uint32()));
                    break;
                case 9:
                    message.attestations.push(Attestation.decode(reader, reader.uint32()));
                    break;
                case 10:
                    message.delegateKeys.push(MsgSetOrchestratorAddress.decode(reader, reader.uint32()));
                    break;
                case 11:
                    message.erc20ToDenoms.push(ERC20ToDenom.decode(reader, reader.uint32()));
                    break;
                case 12:
                    message.unbatchedTransfers.push(OutgoingTransferTx.decode(reader, reader.uint32()));
                    break;
                case 13:
                    message.pendingIbcAutoForwards.push(PendingIbcAutoForward.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            params: isSet(object.params) ? Params.fromJSON(object.params) : undefined,
            gravityNonces: isSet(object.gravityNonces)
                ? GravityNonces.fromJSON(object.gravityNonces)
                : undefined,
            valsets: Array.isArray(object === null || object === void 0 ? void 0 : object.valsets)
                ? object.valsets.map((e) => Valset.fromJSON(e))
                : [],
            valsetConfirms: Array.isArray(object === null || object === void 0 ? void 0 : object.valsetConfirms)
                ? object.valsetConfirms.map((e) => MsgValsetConfirm.fromJSON(e))
                : [],
            batches: Array.isArray(object === null || object === void 0 ? void 0 : object.batches)
                ? object.batches.map((e) => OutgoingTxBatch.fromJSON(e))
                : [],
            batchConfirms: Array.isArray(object === null || object === void 0 ? void 0 : object.batchConfirms)
                ? object.batchConfirms.map((e) => MsgConfirmBatch.fromJSON(e))
                : [],
            logicCalls: Array.isArray(object === null || object === void 0 ? void 0 : object.logicCalls)
                ? object.logicCalls.map((e) => OutgoingLogicCall.fromJSON(e))
                : [],
            logicCallConfirms: Array.isArray(object === null || object === void 0 ? void 0 : object.logicCallConfirms)
                ? object.logicCallConfirms.map((e) => MsgConfirmLogicCall.fromJSON(e))
                : [],
            attestations: Array.isArray(object === null || object === void 0 ? void 0 : object.attestations)
                ? object.attestations.map((e) => Attestation.fromJSON(e))
                : [],
            delegateKeys: Array.isArray(object === null || object === void 0 ? void 0 : object.delegateKeys)
                ? object.delegateKeys.map((e) => MsgSetOrchestratorAddress.fromJSON(e))
                : [],
            erc20ToDenoms: Array.isArray(object === null || object === void 0 ? void 0 : object.erc20ToDenoms)
                ? object.erc20ToDenoms.map((e) => ERC20ToDenom.fromJSON(e))
                : [],
            unbatchedTransfers: Array.isArray(object === null || object === void 0 ? void 0 : object.unbatchedTransfers)
                ? object.unbatchedTransfers.map((e) => OutgoingTransferTx.fromJSON(e))
                : [],
            pendingIbcAutoForwards: Array.isArray(object === null || object === void 0 ? void 0 : object.pendingIbcAutoForwards)
                ? object.pendingIbcAutoForwards.map((e) => PendingIbcAutoForward.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        message.params !== undefined &&
            (obj.params = message.params ? Params.toJSON(message.params) : undefined);
        message.gravityNonces !== undefined &&
            (obj.gravityNonces = message.gravityNonces
                ? GravityNonces.toJSON(message.gravityNonces)
                : undefined);
        if (message.valsets) {
            obj.valsets = message.valsets.map((e) => e ? Valset.toJSON(e) : undefined);
        }
        else {
            obj.valsets = [];
        }
        if (message.valsetConfirms) {
            obj.valsetConfirms = message.valsetConfirms.map((e) => e ? MsgValsetConfirm.toJSON(e) : undefined);
        }
        else {
            obj.valsetConfirms = [];
        }
        if (message.batches) {
            obj.batches = message.batches.map((e) => e ? OutgoingTxBatch.toJSON(e) : undefined);
        }
        else {
            obj.batches = [];
        }
        if (message.batchConfirms) {
            obj.batchConfirms = message.batchConfirms.map((e) => e ? MsgConfirmBatch.toJSON(e) : undefined);
        }
        else {
            obj.batchConfirms = [];
        }
        if (message.logicCalls) {
            obj.logicCalls = message.logicCalls.map((e) => e ? OutgoingLogicCall.toJSON(e) : undefined);
        }
        else {
            obj.logicCalls = [];
        }
        if (message.logicCallConfirms) {
            obj.logicCallConfirms = message.logicCallConfirms.map((e) => e ? MsgConfirmLogicCall.toJSON(e) : undefined);
        }
        else {
            obj.logicCallConfirms = [];
        }
        if (message.attestations) {
            obj.attestations = message.attestations.map((e) => e ? Attestation.toJSON(e) : undefined);
        }
        else {
            obj.attestations = [];
        }
        if (message.delegateKeys) {
            obj.delegateKeys = message.delegateKeys.map((e) => e ? MsgSetOrchestratorAddress.toJSON(e) : undefined);
        }
        else {
            obj.delegateKeys = [];
        }
        if (message.erc20ToDenoms) {
            obj.erc20ToDenoms = message.erc20ToDenoms.map((e) => e ? ERC20ToDenom.toJSON(e) : undefined);
        }
        else {
            obj.erc20ToDenoms = [];
        }
        if (message.unbatchedTransfers) {
            obj.unbatchedTransfers = message.unbatchedTransfers.map((e) => e ? OutgoingTransferTx.toJSON(e) : undefined);
        }
        else {
            obj.unbatchedTransfers = [];
        }
        if (message.pendingIbcAutoForwards) {
            obj.pendingIbcAutoForwards = message.pendingIbcAutoForwards.map((e) => e ? PendingIbcAutoForward.toJSON(e) : undefined);
        }
        else {
            obj.pendingIbcAutoForwards = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        const message = createBaseGenesisState();
        message.params =
            object.params !== undefined && object.params !== null
                ? Params.fromPartial(object.params)
                : undefined;
        message.gravityNonces =
            object.gravityNonces !== undefined && object.gravityNonces !== null
                ? GravityNonces.fromPartial(object.gravityNonces)
                : undefined;
        message.valsets = ((_a = object.valsets) === null || _a === void 0 ? void 0 : _a.map((e) => Valset.fromPartial(e))) || [];
        message.valsetConfirms =
            ((_b = object.valsetConfirms) === null || _b === void 0 ? void 0 : _b.map((e) => MsgValsetConfirm.fromPartial(e))) || [];
        message.batches =
            ((_c = object.batches) === null || _c === void 0 ? void 0 : _c.map((e) => OutgoingTxBatch.fromPartial(e))) || [];
        message.batchConfirms =
            ((_d = object.batchConfirms) === null || _d === void 0 ? void 0 : _d.map((e) => MsgConfirmBatch.fromPartial(e))) || [];
        message.logicCalls =
            ((_e = object.logicCalls) === null || _e === void 0 ? void 0 : _e.map((e) => OutgoingLogicCall.fromPartial(e))) || [];
        message.logicCallConfirms =
            ((_f = object.logicCallConfirms) === null || _f === void 0 ? void 0 : _f.map((e) => MsgConfirmLogicCall.fromPartial(e))) || [];
        message.attestations =
            ((_g = object.attestations) === null || _g === void 0 ? void 0 : _g.map((e) => Attestation.fromPartial(e))) || [];
        message.delegateKeys =
            ((_h = object.delegateKeys) === null || _h === void 0 ? void 0 : _h.map((e) => MsgSetOrchestratorAddress.fromPartial(e))) || [];
        message.erc20ToDenoms =
            ((_j = object.erc20ToDenoms) === null || _j === void 0 ? void 0 : _j.map((e) => ERC20ToDenom.fromPartial(e))) || [];
        message.unbatchedTransfers =
            ((_k = object.unbatchedTransfers) === null || _k === void 0 ? void 0 : _k.map((e) => OutgoingTransferTx.fromPartial(e))) || [];
        message.pendingIbcAutoForwards =
            ((_l = object.pendingIbcAutoForwards) === null || _l === void 0 ? void 0 : _l.map((e) => PendingIbcAutoForward.fromPartial(e))) || [];
        return message;
    },
};
function createBaseGravityNonces() {
    return {
        latestValsetNonce: (long_default()).UZERO,
        lastObservedNonce: (long_default()).UZERO,
        lastSlashedValsetNonce: (long_default()).UZERO,
        lastSlashedBatchBlock: (long_default()).UZERO,
        lastSlashedLogicCallBlock: (long_default()).UZERO,
        lastTxPoolId: (long_default()).UZERO,
        lastBatchId: (long_default()).UZERO,
    };
}
const GravityNonces = {
    encode(message, writer = minimal.Writer.create()) {
        if (!message.latestValsetNonce.isZero()) {
            writer.uint32(8).uint64(message.latestValsetNonce);
        }
        if (!message.lastObservedNonce.isZero()) {
            writer.uint32(16).uint64(message.lastObservedNonce);
        }
        if (!message.lastSlashedValsetNonce.isZero()) {
            writer.uint32(24).uint64(message.lastSlashedValsetNonce);
        }
        if (!message.lastSlashedBatchBlock.isZero()) {
            writer.uint32(32).uint64(message.lastSlashedBatchBlock);
        }
        if (!message.lastSlashedLogicCallBlock.isZero()) {
            writer.uint32(40).uint64(message.lastSlashedLogicCallBlock);
        }
        if (!message.lastTxPoolId.isZero()) {
            writer.uint32(48).uint64(message.lastTxPoolId);
        }
        if (!message.lastBatchId.isZero()) {
            writer.uint32(56).uint64(message.lastBatchId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGravityNonces();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.latestValsetNonce = reader.uint64();
                    break;
                case 2:
                    message.lastObservedNonce = reader.uint64();
                    break;
                case 3:
                    message.lastSlashedValsetNonce = reader.uint64();
                    break;
                case 4:
                    message.lastSlashedBatchBlock = reader.uint64();
                    break;
                case 5:
                    message.lastSlashedLogicCallBlock = reader.uint64();
                    break;
                case 6:
                    message.lastTxPoolId = reader.uint64();
                    break;
                case 7:
                    message.lastBatchId = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            latestValsetNonce: isSet(object.latestValsetNonce)
                ? long_default().fromValue(object.latestValsetNonce)
                : (long_default()).UZERO,
            lastObservedNonce: isSet(object.lastObservedNonce)
                ? long_default().fromValue(object.lastObservedNonce)
                : (long_default()).UZERO,
            lastSlashedValsetNonce: isSet(object.lastSlashedValsetNonce)
                ? long_default().fromValue(object.lastSlashedValsetNonce)
                : (long_default()).UZERO,
            lastSlashedBatchBlock: isSet(object.lastSlashedBatchBlock)
                ? long_default().fromValue(object.lastSlashedBatchBlock)
                : (long_default()).UZERO,
            lastSlashedLogicCallBlock: isSet(object.lastSlashedLogicCallBlock)
                ? long_default().fromValue(object.lastSlashedLogicCallBlock)
                : (long_default()).UZERO,
            lastTxPoolId: isSet(object.lastTxPoolId)
                ? long_default().fromValue(object.lastTxPoolId)
                : (long_default()).UZERO,
            lastBatchId: isSet(object.lastBatchId)
                ? long_default().fromValue(object.lastBatchId)
                : (long_default()).UZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        message.latestValsetNonce !== undefined &&
            (obj.latestValsetNonce = (message.latestValsetNonce || (long_default()).UZERO).toString());
        message.lastObservedNonce !== undefined &&
            (obj.lastObservedNonce = (message.lastObservedNonce || (long_default()).UZERO).toString());
        message.lastSlashedValsetNonce !== undefined &&
            (obj.lastSlashedValsetNonce = (message.lastSlashedValsetNonce || (long_default()).UZERO).toString());
        message.lastSlashedBatchBlock !== undefined &&
            (obj.lastSlashedBatchBlock = (message.lastSlashedBatchBlock || (long_default()).UZERO).toString());
        message.lastSlashedLogicCallBlock !== undefined &&
            (obj.lastSlashedLogicCallBlock = (message.lastSlashedLogicCallBlock || (long_default()).UZERO).toString());
        message.lastTxPoolId !== undefined &&
            (obj.lastTxPoolId = (message.lastTxPoolId || (long_default()).UZERO).toString());
        message.lastBatchId !== undefined &&
            (obj.lastBatchId = (message.lastBatchId || (long_default()).UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseGravityNonces();
        message.latestValsetNonce =
            object.latestValsetNonce !== undefined &&
                object.latestValsetNonce !== null
                ? long_default().fromValue(object.latestValsetNonce)
                : (long_default()).UZERO;
        message.lastObservedNonce =
            object.lastObservedNonce !== undefined &&
                object.lastObservedNonce !== null
                ? long_default().fromValue(object.lastObservedNonce)
                : (long_default()).UZERO;
        message.lastSlashedValsetNonce =
            object.lastSlashedValsetNonce !== undefined &&
                object.lastSlashedValsetNonce !== null
                ? long_default().fromValue(object.lastSlashedValsetNonce)
                : (long_default()).UZERO;
        message.lastSlashedBatchBlock =
            object.lastSlashedBatchBlock !== undefined &&
                object.lastSlashedBatchBlock !== null
                ? long_default().fromValue(object.lastSlashedBatchBlock)
                : (long_default()).UZERO;
        message.lastSlashedLogicCallBlock =
            object.lastSlashedLogicCallBlock !== undefined &&
                object.lastSlashedLogicCallBlock !== null
                ? long_default().fromValue(object.lastSlashedLogicCallBlock)
                : (long_default()).UZERO;
        message.lastTxPoolId =
            object.lastTxPoolId !== undefined && object.lastTxPoolId !== null
                ? long_default().fromValue(object.lastTxPoolId)
                : (long_default()).UZERO;
        message.lastBatchId =
            object.lastBatchId !== undefined && object.lastBatchId !== null
                ? long_default().fromValue(object.lastBatchId)
                : (long_default()).UZERO;
        return message;
    },
};

;// CONCATENATED MODULE: ./node_modules/kujira.js/lib/esm/gravity/v1/pool.js
/* eslint-disable */


const pool_protobufPackage = "gravity.v1";
function createBaseIDSet() {
    return {
        ids: [],
    };
}
const IDSet = {
    encode(message, writer = minimal.Writer.create()) {
        writer.uint32(10).fork();
        for (const v of message.ids) {
            writer.uint64(v);
        }
        writer.ldelim();
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseIDSet();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if ((tag & 7) === 2) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.ids.push(reader.uint64());
                        }
                    }
                    else {
                        message.ids.push(reader.uint64());
                    }
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            ids: Array.isArray(object === null || object === void 0 ? void 0 : object.ids)
                ? object.ids.map((e) => long_default().fromValue(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.ids) {
            obj.ids = message.ids.map((e) => (e || (long_default()).UZERO).toString());
        }
        else {
            obj.ids = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseIDSet();
        message.ids = ((_a = object.ids) === null || _a === void 0 ? void 0 : _a.map((e) => long_default().fromValue(e))) || [];
        return message;
    },
};
function createBaseBatchFees() {
    return {
        token: "",
        totalFees: "",
        txCount: (long_default()).UZERO,
    };
}
const BatchFees = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.token !== "") {
            writer.uint32(10).string(message.token);
        }
        if (message.totalFees !== "") {
            writer.uint32(18).string(message.totalFees);
        }
        if (!message.txCount.isZero()) {
            writer.uint32(24).uint64(message.txCount);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseBatchFees();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.token = reader.string();
                    break;
                case 2:
                    message.totalFees = reader.string();
                    break;
                case 3:
                    message.txCount = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            token: isSet(object.token) ? String(object.token) : "",
            totalFees: isSet(object.totalFees) ? String(object.totalFees) : "",
            txCount: isSet(object.txCount)
                ? long_default().fromValue(object.txCount)
                : (long_default()).UZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        message.token !== undefined && (obj.token = message.token);
        message.totalFees !== undefined && (obj.totalFees = message.totalFees);
        message.txCount !== undefined &&
            (obj.txCount = (message.txCount || (long_default()).UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseBatchFees();
        message.token = (_a = object.token) !== null && _a !== void 0 ? _a : "";
        message.totalFees = (_b = object.totalFees) !== null && _b !== void 0 ? _b : "";
        message.txCount =
            object.txCount !== undefined && object.txCount !== null
                ? long_default().fromValue(object.txCount)
                : (long_default()).UZERO;
        return message;
    },
};
function createBaseEventWithdrawalReceived() {
    return {
        bridgeContract: "",
        bridgeChainId: "",
        outgoingTxId: "",
        nonce: "",
    };
}
const EventWithdrawalReceived = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.bridgeContract !== "") {
            writer.uint32(10).string(message.bridgeContract);
        }
        if (message.bridgeChainId !== "") {
            writer.uint32(18).string(message.bridgeChainId);
        }
        if (message.outgoingTxId !== "") {
            writer.uint32(26).string(message.outgoingTxId);
        }
        if (message.nonce !== "") {
            writer.uint32(34).string(message.nonce);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseEventWithdrawalReceived();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.bridgeContract = reader.string();
                    break;
                case 2:
                    message.bridgeChainId = reader.string();
                    break;
                case 3:
                    message.outgoingTxId = reader.string();
                    break;
                case 4:
                    message.nonce = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            bridgeContract: isSet(object.bridgeContract)
                ? String(object.bridgeContract)
                : "",
            bridgeChainId: isSet(object.bridgeChainId)
                ? String(object.bridgeChainId)
                : "",
            outgoingTxId: isSet(object.outgoingTxId)
                ? String(object.outgoingTxId)
                : "",
            nonce: isSet(object.nonce) ? String(object.nonce) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.bridgeContract !== undefined &&
            (obj.bridgeContract = message.bridgeContract);
        message.bridgeChainId !== undefined &&
            (obj.bridgeChainId = message.bridgeChainId);
        message.outgoingTxId !== undefined &&
            (obj.outgoingTxId = message.outgoingTxId);
        message.nonce !== undefined && (obj.nonce = message.nonce);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d;
        const message = createBaseEventWithdrawalReceived();
        message.bridgeContract = (_a = object.bridgeContract) !== null && _a !== void 0 ? _a : "";
        message.bridgeChainId = (_b = object.bridgeChainId) !== null && _b !== void 0 ? _b : "";
        message.outgoingTxId = (_c = object.outgoingTxId) !== null && _c !== void 0 ? _c : "";
        message.nonce = (_d = object.nonce) !== null && _d !== void 0 ? _d : "";
        return message;
    },
};
function createBaseEventWithdrawCanceled() {
    return {
        sender: "",
        txId: "",
        bridgeContract: "",
        bridgeChainId: "",
    };
}
const EventWithdrawCanceled = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.sender !== "") {
            writer.uint32(10).string(message.sender);
        }
        if (message.txId !== "") {
            writer.uint32(18).string(message.txId);
        }
        if (message.bridgeContract !== "") {
            writer.uint32(26).string(message.bridgeContract);
        }
        if (message.bridgeChainId !== "") {
            writer.uint32(34).string(message.bridgeChainId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseEventWithdrawCanceled();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.sender = reader.string();
                    break;
                case 2:
                    message.txId = reader.string();
                    break;
                case 3:
                    message.bridgeContract = reader.string();
                    break;
                case 4:
                    message.bridgeChainId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            sender: isSet(object.sender) ? String(object.sender) : "",
            txId: isSet(object.txId) ? String(object.txId) : "",
            bridgeContract: isSet(object.bridgeContract)
                ? String(object.bridgeContract)
                : "",
            bridgeChainId: isSet(object.bridgeChainId)
                ? String(object.bridgeChainId)
                : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.sender !== undefined && (obj.sender = message.sender);
        message.txId !== undefined && (obj.txId = message.txId);
        message.bridgeContract !== undefined &&
            (obj.bridgeContract = message.bridgeContract);
        message.bridgeChainId !== undefined &&
            (obj.bridgeChainId = message.bridgeChainId);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d;
        const message = createBaseEventWithdrawCanceled();
        message.sender = (_a = object.sender) !== null && _a !== void 0 ? _a : "";
        message.txId = (_b = object.txId) !== null && _b !== void 0 ? _b : "";
        message.bridgeContract = (_c = object.bridgeContract) !== null && _c !== void 0 ? _c : "";
        message.bridgeChainId = (_d = object.bridgeChainId) !== null && _d !== void 0 ? _d : "";
        return message;
    },
};

;// CONCATENATED MODULE: ./node_modules/kujira.js/lib/esm/gravity/v1/query.js
/* eslint-disable */








const query_protobufPackage = "gravity.v1";
function createBaseQueryParamsRequest() {
    return {};
}
const QueryParamsRequest = {
    encode(_, writer = minimal.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryParamsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseQueryParamsRequest();
        return message;
    },
};
function createBaseQueryParamsResponse() {
    return {
        params: undefined,
    };
}
const QueryParamsResponse = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.params !== undefined) {
            Params.encode(message.params, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryParamsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.params = Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            params: isSet(object.params) ? Params.fromJSON(object.params) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.params !== undefined &&
            (obj.params = message.params ? Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryParamsResponse();
        message.params =
            object.params !== undefined && object.params !== null
                ? Params.fromPartial(object.params)
                : undefined;
        return message;
    },
};
function createBaseQueryCurrentValsetRequest() {
    return {};
}
const QueryCurrentValsetRequest = {
    encode(_, writer = minimal.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryCurrentValsetRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseQueryCurrentValsetRequest();
        return message;
    },
};
function createBaseQueryCurrentValsetResponse() {
    return {
        valset: undefined,
    };
}
const QueryCurrentValsetResponse = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.valset !== undefined) {
            Valset.encode(message.valset, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryCurrentValsetResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.valset = Valset.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            valset: isSet(object.valset) ? Valset.fromJSON(object.valset) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.valset !== undefined &&
            (obj.valset = message.valset ? Valset.toJSON(message.valset) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryCurrentValsetResponse();
        message.valset =
            object.valset !== undefined && object.valset !== null
                ? Valset.fromPartial(object.valset)
                : undefined;
        return message;
    },
};
function createBaseQueryValsetRequestRequest() {
    return {
        nonce: (long_default()).UZERO,
    };
}
const QueryValsetRequestRequest = {
    encode(message, writer = minimal.Writer.create()) {
        if (!message.nonce.isZero()) {
            writer.uint32(8).uint64(message.nonce);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryValsetRequestRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.nonce = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            nonce: isSet(object.nonce) ? long_default().fromValue(object.nonce) : (long_default()).UZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        message.nonce !== undefined &&
            (obj.nonce = (message.nonce || (long_default()).UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryValsetRequestRequest();
        message.nonce =
            object.nonce !== undefined && object.nonce !== null
                ? long_default().fromValue(object.nonce)
                : (long_default()).UZERO;
        return message;
    },
};
function createBaseQueryValsetRequestResponse() {
    return {
        valset: undefined,
    };
}
const QueryValsetRequestResponse = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.valset !== undefined) {
            Valset.encode(message.valset, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryValsetRequestResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.valset = Valset.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            valset: isSet(object.valset) ? Valset.fromJSON(object.valset) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.valset !== undefined &&
            (obj.valset = message.valset ? Valset.toJSON(message.valset) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryValsetRequestResponse();
        message.valset =
            object.valset !== undefined && object.valset !== null
                ? Valset.fromPartial(object.valset)
                : undefined;
        return message;
    },
};
function createBaseQueryValsetConfirmRequest() {
    return {
        nonce: (long_default()).UZERO,
        address: "",
    };
}
const QueryValsetConfirmRequest = {
    encode(message, writer = minimal.Writer.create()) {
        if (!message.nonce.isZero()) {
            writer.uint32(8).uint64(message.nonce);
        }
        if (message.address !== "") {
            writer.uint32(18).string(message.address);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryValsetConfirmRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.nonce = reader.uint64();
                    break;
                case 2:
                    message.address = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            nonce: isSet(object.nonce) ? long_default().fromValue(object.nonce) : (long_default()).UZERO,
            address: isSet(object.address) ? String(object.address) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.nonce !== undefined &&
            (obj.nonce = (message.nonce || (long_default()).UZERO).toString());
        message.address !== undefined && (obj.address = message.address);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryValsetConfirmRequest();
        message.nonce =
            object.nonce !== undefined && object.nonce !== null
                ? long_default().fromValue(object.nonce)
                : (long_default()).UZERO;
        message.address = (_a = object.address) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
function createBaseQueryValsetConfirmResponse() {
    return {
        confirm: undefined,
    };
}
const QueryValsetConfirmResponse = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.confirm !== undefined) {
            MsgValsetConfirm.encode(message.confirm, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryValsetConfirmResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.confirm = MsgValsetConfirm.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            confirm: isSet(object.confirm)
                ? MsgValsetConfirm.fromJSON(object.confirm)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.confirm !== undefined &&
            (obj.confirm = message.confirm
                ? MsgValsetConfirm.toJSON(message.confirm)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryValsetConfirmResponse();
        message.confirm =
            object.confirm !== undefined && object.confirm !== null
                ? MsgValsetConfirm.fromPartial(object.confirm)
                : undefined;
        return message;
    },
};
function createBaseQueryValsetConfirmsByNonceRequest() {
    return {
        nonce: (long_default()).UZERO,
    };
}
const QueryValsetConfirmsByNonceRequest = {
    encode(message, writer = minimal.Writer.create()) {
        if (!message.nonce.isZero()) {
            writer.uint32(8).uint64(message.nonce);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryValsetConfirmsByNonceRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.nonce = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            nonce: isSet(object.nonce) ? long_default().fromValue(object.nonce) : (long_default()).UZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        message.nonce !== undefined &&
            (obj.nonce = (message.nonce || (long_default()).UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryValsetConfirmsByNonceRequest();
        message.nonce =
            object.nonce !== undefined && object.nonce !== null
                ? long_default().fromValue(object.nonce)
                : (long_default()).UZERO;
        return message;
    },
};
function createBaseQueryValsetConfirmsByNonceResponse() {
    return {
        confirms: [],
    };
}
const QueryValsetConfirmsByNonceResponse = {
    encode(message, writer = minimal.Writer.create()) {
        for (const v of message.confirms) {
            MsgValsetConfirm.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryValsetConfirmsByNonceResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.confirms.push(MsgValsetConfirm.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            confirms: Array.isArray(object === null || object === void 0 ? void 0 : object.confirms)
                ? object.confirms.map((e) => MsgValsetConfirm.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.confirms) {
            obj.confirms = message.confirms.map((e) => e ? MsgValsetConfirm.toJSON(e) : undefined);
        }
        else {
            obj.confirms = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryValsetConfirmsByNonceResponse();
        message.confirms =
            ((_a = object.confirms) === null || _a === void 0 ? void 0 : _a.map((e) => MsgValsetConfirm.fromPartial(e))) || [];
        return message;
    },
};
function createBaseQueryLastValsetRequestsRequest() {
    return {};
}
const QueryLastValsetRequestsRequest = {
    encode(_, writer = minimal.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryLastValsetRequestsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseQueryLastValsetRequestsRequest();
        return message;
    },
};
function createBaseQueryLastValsetRequestsResponse() {
    return {
        valsets: [],
    };
}
const QueryLastValsetRequestsResponse = {
    encode(message, writer = minimal.Writer.create()) {
        for (const v of message.valsets) {
            Valset.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryLastValsetRequestsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.valsets.push(Valset.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            valsets: Array.isArray(object === null || object === void 0 ? void 0 : object.valsets)
                ? object.valsets.map((e) => Valset.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.valsets) {
            obj.valsets = message.valsets.map((e) => e ? Valset.toJSON(e) : undefined);
        }
        else {
            obj.valsets = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryLastValsetRequestsResponse();
        message.valsets = ((_a = object.valsets) === null || _a === void 0 ? void 0 : _a.map((e) => Valset.fromPartial(e))) || [];
        return message;
    },
};
function createBaseQueryLastPendingValsetRequestByAddrRequest() {
    return {
        address: "",
    };
}
const QueryLastPendingValsetRequestByAddrRequest = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.address !== "") {
            writer.uint32(10).string(message.address);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryLastPendingValsetRequestByAddrRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.address = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            address: isSet(object.address) ? String(object.address) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryLastPendingValsetRequestByAddrRequest();
        message.address = (_a = object.address) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
function createBaseQueryLastPendingValsetRequestByAddrResponse() {
    return {
        valsets: [],
    };
}
const QueryLastPendingValsetRequestByAddrResponse = {
    encode(message, writer = minimal.Writer.create()) {
        for (const v of message.valsets) {
            Valset.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryLastPendingValsetRequestByAddrResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.valsets.push(Valset.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            valsets: Array.isArray(object === null || object === void 0 ? void 0 : object.valsets)
                ? object.valsets.map((e) => Valset.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.valsets) {
            obj.valsets = message.valsets.map((e) => e ? Valset.toJSON(e) : undefined);
        }
        else {
            obj.valsets = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryLastPendingValsetRequestByAddrResponse();
        message.valsets = ((_a = object.valsets) === null || _a === void 0 ? void 0 : _a.map((e) => Valset.fromPartial(e))) || [];
        return message;
    },
};
function createBaseQueryBatchFeeRequest() {
    return {};
}
const QueryBatchFeeRequest = {
    encode(_, writer = minimal.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryBatchFeeRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseQueryBatchFeeRequest();
        return message;
    },
};
function createBaseQueryBatchFeeResponse() {
    return {
        batchFees: [],
    };
}
const QueryBatchFeeResponse = {
    encode(message, writer = minimal.Writer.create()) {
        for (const v of message.batchFees) {
            BatchFees.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryBatchFeeResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.batchFees.push(BatchFees.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            batchFees: Array.isArray(object === null || object === void 0 ? void 0 : object.batchFees)
                ? object.batchFees.map((e) => BatchFees.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.batchFees) {
            obj.batchFees = message.batchFees.map((e) => e ? BatchFees.toJSON(e) : undefined);
        }
        else {
            obj.batchFees = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryBatchFeeResponse();
        message.batchFees =
            ((_a = object.batchFees) === null || _a === void 0 ? void 0 : _a.map((e) => BatchFees.fromPartial(e))) || [];
        return message;
    },
};
function createBaseQueryLastPendingBatchRequestByAddrRequest() {
    return {
        address: "",
    };
}
const QueryLastPendingBatchRequestByAddrRequest = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.address !== "") {
            writer.uint32(10).string(message.address);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryLastPendingBatchRequestByAddrRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.address = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            address: isSet(object.address) ? String(object.address) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryLastPendingBatchRequestByAddrRequest();
        message.address = (_a = object.address) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
function createBaseQueryLastPendingBatchRequestByAddrResponse() {
    return {
        batch: [],
    };
}
const QueryLastPendingBatchRequestByAddrResponse = {
    encode(message, writer = minimal.Writer.create()) {
        for (const v of message.batch) {
            OutgoingTxBatch.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryLastPendingBatchRequestByAddrResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.batch.push(OutgoingTxBatch.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            batch: Array.isArray(object === null || object === void 0 ? void 0 : object.batch)
                ? object.batch.map((e) => OutgoingTxBatch.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.batch) {
            obj.batch = message.batch.map((e) => e ? OutgoingTxBatch.toJSON(e) : undefined);
        }
        else {
            obj.batch = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryLastPendingBatchRequestByAddrResponse();
        message.batch =
            ((_a = object.batch) === null || _a === void 0 ? void 0 : _a.map((e) => OutgoingTxBatch.fromPartial(e))) || [];
        return message;
    },
};
function createBaseQueryLastPendingLogicCallByAddrRequest() {
    return {
        address: "",
    };
}
const QueryLastPendingLogicCallByAddrRequest = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.address !== "") {
            writer.uint32(10).string(message.address);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryLastPendingLogicCallByAddrRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.address = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            address: isSet(object.address) ? String(object.address) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryLastPendingLogicCallByAddrRequest();
        message.address = (_a = object.address) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
function createBaseQueryLastPendingLogicCallByAddrResponse() {
    return {
        call: [],
    };
}
const QueryLastPendingLogicCallByAddrResponse = {
    encode(message, writer = minimal.Writer.create()) {
        for (const v of message.call) {
            OutgoingLogicCall.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryLastPendingLogicCallByAddrResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.call.push(OutgoingLogicCall.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            call: Array.isArray(object === null || object === void 0 ? void 0 : object.call)
                ? object.call.map((e) => OutgoingLogicCall.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.call) {
            obj.call = message.call.map((e) => e ? OutgoingLogicCall.toJSON(e) : undefined);
        }
        else {
            obj.call = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryLastPendingLogicCallByAddrResponse();
        message.call =
            ((_a = object.call) === null || _a === void 0 ? void 0 : _a.map((e) => OutgoingLogicCall.fromPartial(e))) || [];
        return message;
    },
};
function createBaseQueryOutgoingTxBatchesRequest() {
    return {};
}
const QueryOutgoingTxBatchesRequest = {
    encode(_, writer = minimal.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryOutgoingTxBatchesRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseQueryOutgoingTxBatchesRequest();
        return message;
    },
};
function createBaseQueryOutgoingTxBatchesResponse() {
    return {
        batches: [],
    };
}
const QueryOutgoingTxBatchesResponse = {
    encode(message, writer = minimal.Writer.create()) {
        for (const v of message.batches) {
            OutgoingTxBatch.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryOutgoingTxBatchesResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.batches.push(OutgoingTxBatch.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            batches: Array.isArray(object === null || object === void 0 ? void 0 : object.batches)
                ? object.batches.map((e) => OutgoingTxBatch.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.batches) {
            obj.batches = message.batches.map((e) => e ? OutgoingTxBatch.toJSON(e) : undefined);
        }
        else {
            obj.batches = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryOutgoingTxBatchesResponse();
        message.batches =
            ((_a = object.batches) === null || _a === void 0 ? void 0 : _a.map((e) => OutgoingTxBatch.fromPartial(e))) || [];
        return message;
    },
};
function createBaseQueryOutgoingLogicCallsRequest() {
    return {};
}
const QueryOutgoingLogicCallsRequest = {
    encode(_, writer = minimal.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryOutgoingLogicCallsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseQueryOutgoingLogicCallsRequest();
        return message;
    },
};
function createBaseQueryOutgoingLogicCallsResponse() {
    return {
        calls: [],
    };
}
const QueryOutgoingLogicCallsResponse = {
    encode(message, writer = minimal.Writer.create()) {
        for (const v of message.calls) {
            OutgoingLogicCall.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryOutgoingLogicCallsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.calls.push(OutgoingLogicCall.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            calls: Array.isArray(object === null || object === void 0 ? void 0 : object.calls)
                ? object.calls.map((e) => OutgoingLogicCall.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.calls) {
            obj.calls = message.calls.map((e) => e ? OutgoingLogicCall.toJSON(e) : undefined);
        }
        else {
            obj.calls = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryOutgoingLogicCallsResponse();
        message.calls =
            ((_a = object.calls) === null || _a === void 0 ? void 0 : _a.map((e) => OutgoingLogicCall.fromPartial(e))) || [];
        return message;
    },
};
function createBaseQueryBatchRequestByNonceRequest() {
    return {
        nonce: (long_default()).UZERO,
        contractAddress: "",
    };
}
const QueryBatchRequestByNonceRequest = {
    encode(message, writer = minimal.Writer.create()) {
        if (!message.nonce.isZero()) {
            writer.uint32(8).uint64(message.nonce);
        }
        if (message.contractAddress !== "") {
            writer.uint32(18).string(message.contractAddress);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryBatchRequestByNonceRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.nonce = reader.uint64();
                    break;
                case 2:
                    message.contractAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            nonce: isSet(object.nonce) ? long_default().fromValue(object.nonce) : (long_default()).UZERO,
            contractAddress: isSet(object.contractAddress)
                ? String(object.contractAddress)
                : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.nonce !== undefined &&
            (obj.nonce = (message.nonce || (long_default()).UZERO).toString());
        message.contractAddress !== undefined &&
            (obj.contractAddress = message.contractAddress);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryBatchRequestByNonceRequest();
        message.nonce =
            object.nonce !== undefined && object.nonce !== null
                ? long_default().fromValue(object.nonce)
                : (long_default()).UZERO;
        message.contractAddress = (_a = object.contractAddress) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
function createBaseQueryBatchRequestByNonceResponse() {
    return {
        batch: undefined,
    };
}
const QueryBatchRequestByNonceResponse = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.batch !== undefined) {
            OutgoingTxBatch.encode(message.batch, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryBatchRequestByNonceResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.batch = OutgoingTxBatch.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            batch: isSet(object.batch)
                ? OutgoingTxBatch.fromJSON(object.batch)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.batch !== undefined &&
            (obj.batch = message.batch
                ? OutgoingTxBatch.toJSON(message.batch)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryBatchRequestByNonceResponse();
        message.batch =
            object.batch !== undefined && object.batch !== null
                ? OutgoingTxBatch.fromPartial(object.batch)
                : undefined;
        return message;
    },
};
function createBaseQueryBatchConfirmsRequest() {
    return {
        nonce: (long_default()).UZERO,
        contractAddress: "",
    };
}
const QueryBatchConfirmsRequest = {
    encode(message, writer = minimal.Writer.create()) {
        if (!message.nonce.isZero()) {
            writer.uint32(8).uint64(message.nonce);
        }
        if (message.contractAddress !== "") {
            writer.uint32(18).string(message.contractAddress);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryBatchConfirmsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.nonce = reader.uint64();
                    break;
                case 2:
                    message.contractAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            nonce: isSet(object.nonce) ? long_default().fromValue(object.nonce) : (long_default()).UZERO,
            contractAddress: isSet(object.contractAddress)
                ? String(object.contractAddress)
                : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.nonce !== undefined &&
            (obj.nonce = (message.nonce || (long_default()).UZERO).toString());
        message.contractAddress !== undefined &&
            (obj.contractAddress = message.contractAddress);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryBatchConfirmsRequest();
        message.nonce =
            object.nonce !== undefined && object.nonce !== null
                ? long_default().fromValue(object.nonce)
                : (long_default()).UZERO;
        message.contractAddress = (_a = object.contractAddress) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
function createBaseQueryBatchConfirmsResponse() {
    return {
        confirms: [],
    };
}
const QueryBatchConfirmsResponse = {
    encode(message, writer = minimal.Writer.create()) {
        for (const v of message.confirms) {
            MsgConfirmBatch.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryBatchConfirmsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.confirms.push(MsgConfirmBatch.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            confirms: Array.isArray(object === null || object === void 0 ? void 0 : object.confirms)
                ? object.confirms.map((e) => MsgConfirmBatch.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.confirms) {
            obj.confirms = message.confirms.map((e) => e ? MsgConfirmBatch.toJSON(e) : undefined);
        }
        else {
            obj.confirms = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryBatchConfirmsResponse();
        message.confirms =
            ((_a = object.confirms) === null || _a === void 0 ? void 0 : _a.map((e) => MsgConfirmBatch.fromPartial(e))) || [];
        return message;
    },
};
function createBaseQueryLogicConfirmsRequest() {
    return {
        invalidationId: new Uint8Array(),
        invalidationNonce: (long_default()).UZERO,
    };
}
const QueryLogicConfirmsRequest = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.invalidationId.length !== 0) {
            writer.uint32(10).bytes(message.invalidationId);
        }
        if (!message.invalidationNonce.isZero()) {
            writer.uint32(16).uint64(message.invalidationNonce);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryLogicConfirmsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.invalidationId = reader.bytes();
                    break;
                case 2:
                    message.invalidationNonce = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            invalidationId: isSet(object.invalidationId)
                ? bytesFromBase64(object.invalidationId)
                : new Uint8Array(),
            invalidationNonce: isSet(object.invalidationNonce)
                ? long_default().fromValue(object.invalidationNonce)
                : (long_default()).UZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        message.invalidationId !== undefined &&
            (obj.invalidationId = base64FromBytes(message.invalidationId !== undefined
                ? message.invalidationId
                : new Uint8Array()));
        message.invalidationNonce !== undefined &&
            (obj.invalidationNonce = (message.invalidationNonce || (long_default()).UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryLogicConfirmsRequest();
        message.invalidationId = (_a = object.invalidationId) !== null && _a !== void 0 ? _a : new Uint8Array();
        message.invalidationNonce =
            object.invalidationNonce !== undefined &&
                object.invalidationNonce !== null
                ? long_default().fromValue(object.invalidationNonce)
                : (long_default()).UZERO;
        return message;
    },
};
function createBaseQueryLogicConfirmsResponse() {
    return {
        confirms: [],
    };
}
const QueryLogicConfirmsResponse = {
    encode(message, writer = minimal.Writer.create()) {
        for (const v of message.confirms) {
            MsgConfirmLogicCall.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryLogicConfirmsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.confirms.push(MsgConfirmLogicCall.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            confirms: Array.isArray(object === null || object === void 0 ? void 0 : object.confirms)
                ? object.confirms.map((e) => MsgConfirmLogicCall.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.confirms) {
            obj.confirms = message.confirms.map((e) => e ? MsgConfirmLogicCall.toJSON(e) : undefined);
        }
        else {
            obj.confirms = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryLogicConfirmsResponse();
        message.confirms =
            ((_a = object.confirms) === null || _a === void 0 ? void 0 : _a.map((e) => MsgConfirmLogicCall.fromPartial(e))) || [];
        return message;
    },
};
function createBaseQueryLastEventNonceByAddrRequest() {
    return {
        address: "",
    };
}
const QueryLastEventNonceByAddrRequest = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.address !== "") {
            writer.uint32(10).string(message.address);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryLastEventNonceByAddrRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.address = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            address: isSet(object.address) ? String(object.address) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryLastEventNonceByAddrRequest();
        message.address = (_a = object.address) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
function createBaseQueryLastEventNonceByAddrResponse() {
    return {
        eventNonce: (long_default()).UZERO,
    };
}
const QueryLastEventNonceByAddrResponse = {
    encode(message, writer = minimal.Writer.create()) {
        if (!message.eventNonce.isZero()) {
            writer.uint32(8).uint64(message.eventNonce);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryLastEventNonceByAddrResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.eventNonce = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            eventNonce: isSet(object.eventNonce)
                ? long_default().fromValue(object.eventNonce)
                : (long_default()).UZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        message.eventNonce !== undefined &&
            (obj.eventNonce = (message.eventNonce || (long_default()).UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryLastEventNonceByAddrResponse();
        message.eventNonce =
            object.eventNonce !== undefined && object.eventNonce !== null
                ? long_default().fromValue(object.eventNonce)
                : (long_default()).UZERO;
        return message;
    },
};
function createBaseQueryERC20ToDenomRequest() {
    return {
        erc20: "",
    };
}
const QueryERC20ToDenomRequest = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.erc20 !== "") {
            writer.uint32(10).string(message.erc20);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryERC20ToDenomRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.erc20 = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            erc20: isSet(object.erc20) ? String(object.erc20) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.erc20 !== undefined && (obj.erc20 = message.erc20);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryERC20ToDenomRequest();
        message.erc20 = (_a = object.erc20) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
function createBaseQueryERC20ToDenomResponse() {
    return {
        denom: "",
        cosmosOriginated: false,
    };
}
const QueryERC20ToDenomResponse = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.denom !== "") {
            writer.uint32(10).string(message.denom);
        }
        if (message.cosmosOriginated === true) {
            writer.uint32(16).bool(message.cosmosOriginated);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryERC20ToDenomResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.denom = reader.string();
                    break;
                case 2:
                    message.cosmosOriginated = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            denom: isSet(object.denom) ? String(object.denom) : "",
            cosmosOriginated: isSet(object.cosmosOriginated)
                ? Boolean(object.cosmosOriginated)
                : false,
        };
    },
    toJSON(message) {
        const obj = {};
        message.denom !== undefined && (obj.denom = message.denom);
        message.cosmosOriginated !== undefined &&
            (obj.cosmosOriginated = message.cosmosOriginated);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseQueryERC20ToDenomResponse();
        message.denom = (_a = object.denom) !== null && _a !== void 0 ? _a : "";
        message.cosmosOriginated = (_b = object.cosmosOriginated) !== null && _b !== void 0 ? _b : false;
        return message;
    },
};
function createBaseQueryDenomToERC20Request() {
    return {
        denom: "",
    };
}
const QueryDenomToERC20Request = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.denom !== "") {
            writer.uint32(10).string(message.denom);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryDenomToERC20Request();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.denom = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            denom: isSet(object.denom) ? String(object.denom) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.denom !== undefined && (obj.denom = message.denom);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryDenomToERC20Request();
        message.denom = (_a = object.denom) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
function createBaseQueryDenomToERC20Response() {
    return {
        erc20: "",
        cosmosOriginated: false,
    };
}
const QueryDenomToERC20Response = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.erc20 !== "") {
            writer.uint32(10).string(message.erc20);
        }
        if (message.cosmosOriginated === true) {
            writer.uint32(16).bool(message.cosmosOriginated);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryDenomToERC20Response();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.erc20 = reader.string();
                    break;
                case 2:
                    message.cosmosOriginated = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            erc20: isSet(object.erc20) ? String(object.erc20) : "",
            cosmosOriginated: isSet(object.cosmosOriginated)
                ? Boolean(object.cosmosOriginated)
                : false,
        };
    },
    toJSON(message) {
        const obj = {};
        message.erc20 !== undefined && (obj.erc20 = message.erc20);
        message.cosmosOriginated !== undefined &&
            (obj.cosmosOriginated = message.cosmosOriginated);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseQueryDenomToERC20Response();
        message.erc20 = (_a = object.erc20) !== null && _a !== void 0 ? _a : "";
        message.cosmosOriginated = (_b = object.cosmosOriginated) !== null && _b !== void 0 ? _b : false;
        return message;
    },
};
function createBaseQueryLastObservedEthBlockRequest() {
    return {
        useV1Key: false,
    };
}
const QueryLastObservedEthBlockRequest = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.useV1Key === true) {
            writer.uint32(8).bool(message.useV1Key);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryLastObservedEthBlockRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.useV1Key = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            useV1Key: isSet(object.useV1Key) ? Boolean(object.useV1Key) : false,
        };
    },
    toJSON(message) {
        const obj = {};
        message.useV1Key !== undefined && (obj.useV1Key = message.useV1Key);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryLastObservedEthBlockRequest();
        message.useV1Key = (_a = object.useV1Key) !== null && _a !== void 0 ? _a : false;
        return message;
    },
};
function createBaseQueryLastObservedEthBlockResponse() {
    return {
        block: (long_default()).UZERO,
    };
}
const QueryLastObservedEthBlockResponse = {
    encode(message, writer = minimal.Writer.create()) {
        if (!message.block.isZero()) {
            writer.uint32(8).uint64(message.block);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryLastObservedEthBlockResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.block = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            block: isSet(object.block) ? long_default().fromValue(object.block) : (long_default()).UZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        message.block !== undefined &&
            (obj.block = (message.block || (long_default()).UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryLastObservedEthBlockResponse();
        message.block =
            object.block !== undefined && object.block !== null
                ? long_default().fromValue(object.block)
                : (long_default()).UZERO;
        return message;
    },
};
function createBaseQueryLastObservedEthNonceRequest() {
    return {
        useV1Key: false,
    };
}
const QueryLastObservedEthNonceRequest = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.useV1Key === true) {
            writer.uint32(8).bool(message.useV1Key);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryLastObservedEthNonceRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.useV1Key = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            useV1Key: isSet(object.useV1Key) ? Boolean(object.useV1Key) : false,
        };
    },
    toJSON(message) {
        const obj = {};
        message.useV1Key !== undefined && (obj.useV1Key = message.useV1Key);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryLastObservedEthNonceRequest();
        message.useV1Key = (_a = object.useV1Key) !== null && _a !== void 0 ? _a : false;
        return message;
    },
};
function createBaseQueryLastObservedEthNonceResponse() {
    return {
        nonce: (long_default()).UZERO,
    };
}
const QueryLastObservedEthNonceResponse = {
    encode(message, writer = minimal.Writer.create()) {
        if (!message.nonce.isZero()) {
            writer.uint32(8).uint64(message.nonce);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryLastObservedEthNonceResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.nonce = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            nonce: isSet(object.nonce) ? long_default().fromValue(object.nonce) : (long_default()).UZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        message.nonce !== undefined &&
            (obj.nonce = (message.nonce || (long_default()).UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryLastObservedEthNonceResponse();
        message.nonce =
            object.nonce !== undefined && object.nonce !== null
                ? long_default().fromValue(object.nonce)
                : (long_default()).UZERO;
        return message;
    },
};
function createBaseQueryAttestationsRequest() {
    return {
        limit: (long_default()).UZERO,
        orderBy: "",
        claimType: "",
        nonce: (long_default()).UZERO,
        height: (long_default()).UZERO,
        useV1Key: false,
    };
}
const QueryAttestationsRequest = {
    encode(message, writer = minimal.Writer.create()) {
        if (!message.limit.isZero()) {
            writer.uint32(8).uint64(message.limit);
        }
        if (message.orderBy !== "") {
            writer.uint32(18).string(message.orderBy);
        }
        if (message.claimType !== "") {
            writer.uint32(26).string(message.claimType);
        }
        if (!message.nonce.isZero()) {
            writer.uint32(32).uint64(message.nonce);
        }
        if (!message.height.isZero()) {
            writer.uint32(40).uint64(message.height);
        }
        if (message.useV1Key === true) {
            writer.uint32(48).bool(message.useV1Key);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryAttestationsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.limit = reader.uint64();
                    break;
                case 2:
                    message.orderBy = reader.string();
                    break;
                case 3:
                    message.claimType = reader.string();
                    break;
                case 4:
                    message.nonce = reader.uint64();
                    break;
                case 5:
                    message.height = reader.uint64();
                    break;
                case 6:
                    message.useV1Key = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            limit: isSet(object.limit) ? long_default().fromValue(object.limit) : (long_default()).UZERO,
            orderBy: isSet(object.orderBy) ? String(object.orderBy) : "",
            claimType: isSet(object.claimType) ? String(object.claimType) : "",
            nonce: isSet(object.nonce) ? long_default().fromValue(object.nonce) : (long_default()).UZERO,
            height: isSet(object.height) ? long_default().fromValue(object.height) : (long_default()).UZERO,
            useV1Key: isSet(object.useV1Key) ? Boolean(object.useV1Key) : false,
        };
    },
    toJSON(message) {
        const obj = {};
        message.limit !== undefined &&
            (obj.limit = (message.limit || (long_default()).UZERO).toString());
        message.orderBy !== undefined && (obj.orderBy = message.orderBy);
        message.claimType !== undefined && (obj.claimType = message.claimType);
        message.nonce !== undefined &&
            (obj.nonce = (message.nonce || (long_default()).UZERO).toString());
        message.height !== undefined &&
            (obj.height = (message.height || (long_default()).UZERO).toString());
        message.useV1Key !== undefined && (obj.useV1Key = message.useV1Key);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseQueryAttestationsRequest();
        message.limit =
            object.limit !== undefined && object.limit !== null
                ? long_default().fromValue(object.limit)
                : (long_default()).UZERO;
        message.orderBy = (_a = object.orderBy) !== null && _a !== void 0 ? _a : "";
        message.claimType = (_b = object.claimType) !== null && _b !== void 0 ? _b : "";
        message.nonce =
            object.nonce !== undefined && object.nonce !== null
                ? long_default().fromValue(object.nonce)
                : (long_default()).UZERO;
        message.height =
            object.height !== undefined && object.height !== null
                ? long_default().fromValue(object.height)
                : (long_default()).UZERO;
        message.useV1Key = (_c = object.useV1Key) !== null && _c !== void 0 ? _c : false;
        return message;
    },
};
function createBaseQueryAttestationsResponse() {
    return {
        attestations: [],
    };
}
const QueryAttestationsResponse = {
    encode(message, writer = minimal.Writer.create()) {
        for (const v of message.attestations) {
            Attestation.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryAttestationsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.attestations.push(Attestation.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            attestations: Array.isArray(object === null || object === void 0 ? void 0 : object.attestations)
                ? object.attestations.map((e) => Attestation.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.attestations) {
            obj.attestations = message.attestations.map((e) => e ? Attestation.toJSON(e) : undefined);
        }
        else {
            obj.attestations = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryAttestationsResponse();
        message.attestations =
            ((_a = object.attestations) === null || _a === void 0 ? void 0 : _a.map((e) => Attestation.fromPartial(e))) || [];
        return message;
    },
};
function createBaseQueryDelegateKeysByValidatorAddress() {
    return {
        validatorAddress: "",
    };
}
const QueryDelegateKeysByValidatorAddress = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.validatorAddress !== "") {
            writer.uint32(10).string(message.validatorAddress);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryDelegateKeysByValidatorAddress();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.validatorAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            validatorAddress: isSet(object.validatorAddress)
                ? String(object.validatorAddress)
                : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.validatorAddress !== undefined &&
            (obj.validatorAddress = message.validatorAddress);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryDelegateKeysByValidatorAddress();
        message.validatorAddress = (_a = object.validatorAddress) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
function createBaseQueryDelegateKeysByValidatorAddressResponse() {
    return {
        ethAddress: "",
        orchestratorAddress: "",
    };
}
const QueryDelegateKeysByValidatorAddressResponse = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.ethAddress !== "") {
            writer.uint32(10).string(message.ethAddress);
        }
        if (message.orchestratorAddress !== "") {
            writer.uint32(18).string(message.orchestratorAddress);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryDelegateKeysByValidatorAddressResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.ethAddress = reader.string();
                    break;
                case 2:
                    message.orchestratorAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            ethAddress: isSet(object.ethAddress) ? String(object.ethAddress) : "",
            orchestratorAddress: isSet(object.orchestratorAddress)
                ? String(object.orchestratorAddress)
                : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.ethAddress !== undefined && (obj.ethAddress = message.ethAddress);
        message.orchestratorAddress !== undefined &&
            (obj.orchestratorAddress = message.orchestratorAddress);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseQueryDelegateKeysByValidatorAddressResponse();
        message.ethAddress = (_a = object.ethAddress) !== null && _a !== void 0 ? _a : "";
        message.orchestratorAddress = (_b = object.orchestratorAddress) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
function createBaseQueryDelegateKeysByEthAddress() {
    return {
        ethAddress: "",
    };
}
const QueryDelegateKeysByEthAddress = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.ethAddress !== "") {
            writer.uint32(10).string(message.ethAddress);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryDelegateKeysByEthAddress();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.ethAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            ethAddress: isSet(object.ethAddress) ? String(object.ethAddress) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.ethAddress !== undefined && (obj.ethAddress = message.ethAddress);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryDelegateKeysByEthAddress();
        message.ethAddress = (_a = object.ethAddress) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
function createBaseQueryDelegateKeysByEthAddressResponse() {
    return {
        validatorAddress: "",
        orchestratorAddress: "",
    };
}
const QueryDelegateKeysByEthAddressResponse = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.validatorAddress !== "") {
            writer.uint32(10).string(message.validatorAddress);
        }
        if (message.orchestratorAddress !== "") {
            writer.uint32(18).string(message.orchestratorAddress);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryDelegateKeysByEthAddressResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.validatorAddress = reader.string();
                    break;
                case 2:
                    message.orchestratorAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            validatorAddress: isSet(object.validatorAddress)
                ? String(object.validatorAddress)
                : "",
            orchestratorAddress: isSet(object.orchestratorAddress)
                ? String(object.orchestratorAddress)
                : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.validatorAddress !== undefined &&
            (obj.validatorAddress = message.validatorAddress);
        message.orchestratorAddress !== undefined &&
            (obj.orchestratorAddress = message.orchestratorAddress);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseQueryDelegateKeysByEthAddressResponse();
        message.validatorAddress = (_a = object.validatorAddress) !== null && _a !== void 0 ? _a : "";
        message.orchestratorAddress = (_b = object.orchestratorAddress) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
function createBaseQueryDelegateKeysByOrchestratorAddress() {
    return {
        orchestratorAddress: "",
    };
}
const QueryDelegateKeysByOrchestratorAddress = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.orchestratorAddress !== "") {
            writer.uint32(10).string(message.orchestratorAddress);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryDelegateKeysByOrchestratorAddress();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.orchestratorAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            orchestratorAddress: isSet(object.orchestratorAddress)
                ? String(object.orchestratorAddress)
                : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.orchestratorAddress !== undefined &&
            (obj.orchestratorAddress = message.orchestratorAddress);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryDelegateKeysByOrchestratorAddress();
        message.orchestratorAddress = (_a = object.orchestratorAddress) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
function createBaseQueryDelegateKeysByOrchestratorAddressResponse() {
    return {
        validatorAddress: "",
        ethAddress: "",
    };
}
const QueryDelegateKeysByOrchestratorAddressResponse = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.validatorAddress !== "") {
            writer.uint32(10).string(message.validatorAddress);
        }
        if (message.ethAddress !== "") {
            writer.uint32(18).string(message.ethAddress);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryDelegateKeysByOrchestratorAddressResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.validatorAddress = reader.string();
                    break;
                case 2:
                    message.ethAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            validatorAddress: isSet(object.validatorAddress)
                ? String(object.validatorAddress)
                : "",
            ethAddress: isSet(object.ethAddress) ? String(object.ethAddress) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.validatorAddress !== undefined &&
            (obj.validatorAddress = message.validatorAddress);
        message.ethAddress !== undefined && (obj.ethAddress = message.ethAddress);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseQueryDelegateKeysByOrchestratorAddressResponse();
        message.validatorAddress = (_a = object.validatorAddress) !== null && _a !== void 0 ? _a : "";
        message.ethAddress = (_b = object.ethAddress) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
function createBaseQueryPendingSendToEth() {
    return {
        senderAddress: "",
    };
}
const QueryPendingSendToEth = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.senderAddress !== "") {
            writer.uint32(10).string(message.senderAddress);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryPendingSendToEth();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.senderAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            senderAddress: isSet(object.senderAddress)
                ? String(object.senderAddress)
                : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.senderAddress !== undefined &&
            (obj.senderAddress = message.senderAddress);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryPendingSendToEth();
        message.senderAddress = (_a = object.senderAddress) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
function createBaseQueryPendingSendToEthResponse() {
    return {
        transfersInBatches: [],
        unbatchedTransfers: [],
    };
}
const QueryPendingSendToEthResponse = {
    encode(message, writer = minimal.Writer.create()) {
        for (const v of message.transfersInBatches) {
            OutgoingTransferTx.encode(v, writer.uint32(10).fork()).ldelim();
        }
        for (const v of message.unbatchedTransfers) {
            OutgoingTransferTx.encode(v, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryPendingSendToEthResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.transfersInBatches.push(OutgoingTransferTx.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.unbatchedTransfers.push(OutgoingTransferTx.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            transfersInBatches: Array.isArray(object === null || object === void 0 ? void 0 : object.transfersInBatches)
                ? object.transfersInBatches.map((e) => OutgoingTransferTx.fromJSON(e))
                : [],
            unbatchedTransfers: Array.isArray(object === null || object === void 0 ? void 0 : object.unbatchedTransfers)
                ? object.unbatchedTransfers.map((e) => OutgoingTransferTx.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.transfersInBatches) {
            obj.transfersInBatches = message.transfersInBatches.map((e) => e ? OutgoingTransferTx.toJSON(e) : undefined);
        }
        else {
            obj.transfersInBatches = [];
        }
        if (message.unbatchedTransfers) {
            obj.unbatchedTransfers = message.unbatchedTransfers.map((e) => e ? OutgoingTransferTx.toJSON(e) : undefined);
        }
        else {
            obj.unbatchedTransfers = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseQueryPendingSendToEthResponse();
        message.transfersInBatches =
            ((_a = object.transfersInBatches) === null || _a === void 0 ? void 0 : _a.map((e) => OutgoingTransferTx.fromPartial(e))) || [];
        message.unbatchedTransfers =
            ((_b = object.unbatchedTransfers) === null || _b === void 0 ? void 0 : _b.map((e) => OutgoingTransferTx.fromPartial(e))) || [];
        return message;
    },
};
function createBaseQueryPendingIbcAutoForwards() {
    return {
        limit: (long_default()).UZERO,
    };
}
const QueryPendingIbcAutoForwards = {
    encode(message, writer = minimal.Writer.create()) {
        if (!message.limit.isZero()) {
            writer.uint32(8).uint64(message.limit);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryPendingIbcAutoForwards();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.limit = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            limit: isSet(object.limit) ? long_default().fromValue(object.limit) : (long_default()).UZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        message.limit !== undefined &&
            (obj.limit = (message.limit || (long_default()).UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryPendingIbcAutoForwards();
        message.limit =
            object.limit !== undefined && object.limit !== null
                ? long_default().fromValue(object.limit)
                : (long_default()).UZERO;
        return message;
    },
};
function createBaseQueryPendingIbcAutoForwardsResponse() {
    return {
        pendingIbcAutoForwards: [],
    };
}
const QueryPendingIbcAutoForwardsResponse = {
    encode(message, writer = minimal.Writer.create()) {
        for (const v of message.pendingIbcAutoForwards) {
            PendingIbcAutoForward.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryPendingIbcAutoForwardsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.pendingIbcAutoForwards.push(PendingIbcAutoForward.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            pendingIbcAutoForwards: Array.isArray(object === null || object === void 0 ? void 0 : object.pendingIbcAutoForwards)
                ? object.pendingIbcAutoForwards.map((e) => PendingIbcAutoForward.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.pendingIbcAutoForwards) {
            obj.pendingIbcAutoForwards = message.pendingIbcAutoForwards.map((e) => e ? PendingIbcAutoForward.toJSON(e) : undefined);
        }
        else {
            obj.pendingIbcAutoForwards = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryPendingIbcAutoForwardsResponse();
        message.pendingIbcAutoForwards =
            ((_a = object.pendingIbcAutoForwards) === null || _a === void 0 ? void 0 : _a.map((e) => PendingIbcAutoForward.fromPartial(e))) || [];
        return message;
    },
};
class QueryClientImpl {
    constructor(rpc) {
        this.rpc = rpc;
        this.Params = this.Params.bind(this);
        this.CurrentValset = this.CurrentValset.bind(this);
        this.ValsetRequest = this.ValsetRequest.bind(this);
        this.ValsetConfirm = this.ValsetConfirm.bind(this);
        this.ValsetConfirmsByNonce = this.ValsetConfirmsByNonce.bind(this);
        this.LastValsetRequests = this.LastValsetRequests.bind(this);
        this.LastPendingValsetRequestByAddr =
            this.LastPendingValsetRequestByAddr.bind(this);
        this.LastPendingBatchRequestByAddr =
            this.LastPendingBatchRequestByAddr.bind(this);
        this.LastPendingLogicCallByAddr =
            this.LastPendingLogicCallByAddr.bind(this);
        this.LastEventNonceByAddr = this.LastEventNonceByAddr.bind(this);
        this.BatchFees = this.BatchFees.bind(this);
        this.OutgoingTxBatches = this.OutgoingTxBatches.bind(this);
        this.OutgoingLogicCalls = this.OutgoingLogicCalls.bind(this);
        this.BatchRequestByNonce = this.BatchRequestByNonce.bind(this);
        this.BatchConfirms = this.BatchConfirms.bind(this);
        this.LogicConfirms = this.LogicConfirms.bind(this);
        this.ERC20ToDenom = this.ERC20ToDenom.bind(this);
        this.DenomToERC20 = this.DenomToERC20.bind(this);
        this.GetLastObservedEthBlock = this.GetLastObservedEthBlock.bind(this);
        this.GetLastObservedEthNonce = this.GetLastObservedEthNonce.bind(this);
        this.GetAttestations = this.GetAttestations.bind(this);
        this.GetDelegateKeyByValidator = this.GetDelegateKeyByValidator.bind(this);
        this.GetDelegateKeyByEth = this.GetDelegateKeyByEth.bind(this);
        this.GetDelegateKeyByOrchestrator =
            this.GetDelegateKeyByOrchestrator.bind(this);
        this.GetPendingSendToEth = this.GetPendingSendToEth.bind(this);
        this.GetPendingIbcAutoForwards = this.GetPendingIbcAutoForwards.bind(this);
    }
    Params(request = {}) {
        const data = QueryParamsRequest.encode(request).finish();
        const promise = this.rpc.request("gravity.v1.Query", "Params", data);
        return promise.then((data) => QueryParamsResponse.decode(new minimal.Reader(data)));
    }
    CurrentValset(request = {}) {
        const data = QueryCurrentValsetRequest.encode(request).finish();
        const promise = this.rpc.request("gravity.v1.Query", "CurrentValset", data);
        return promise.then((data) => QueryCurrentValsetResponse.decode(new minimal.Reader(data)));
    }
    ValsetRequest(request) {
        const data = QueryValsetRequestRequest.encode(request).finish();
        const promise = this.rpc.request("gravity.v1.Query", "ValsetRequest", data);
        return promise.then((data) => QueryValsetRequestResponse.decode(new minimal.Reader(data)));
    }
    ValsetConfirm(request) {
        const data = QueryValsetConfirmRequest.encode(request).finish();
        const promise = this.rpc.request("gravity.v1.Query", "ValsetConfirm", data);
        return promise.then((data) => QueryValsetConfirmResponse.decode(new minimal.Reader(data)));
    }
    ValsetConfirmsByNonce(request) {
        const data = QueryValsetConfirmsByNonceRequest.encode(request).finish();
        const promise = this.rpc.request("gravity.v1.Query", "ValsetConfirmsByNonce", data);
        return promise.then((data) => QueryValsetConfirmsByNonceResponse.decode(new minimal.Reader(data)));
    }
    LastValsetRequests(request = {}) {
        const data = QueryLastValsetRequestsRequest.encode(request).finish();
        const promise = this.rpc.request("gravity.v1.Query", "LastValsetRequests", data);
        return promise.then((data) => QueryLastValsetRequestsResponse.decode(new minimal.Reader(data)));
    }
    LastPendingValsetRequestByAddr(request) {
        const data = QueryLastPendingValsetRequestByAddrRequest.encode(request).finish();
        const promise = this.rpc.request("gravity.v1.Query", "LastPendingValsetRequestByAddr", data);
        return promise.then((data) => QueryLastPendingValsetRequestByAddrResponse.decode(new minimal.Reader(data)));
    }
    LastPendingBatchRequestByAddr(request) {
        const data = QueryLastPendingBatchRequestByAddrRequest.encode(request).finish();
        const promise = this.rpc.request("gravity.v1.Query", "LastPendingBatchRequestByAddr", data);
        return promise.then((data) => QueryLastPendingBatchRequestByAddrResponse.decode(new minimal.Reader(data)));
    }
    LastPendingLogicCallByAddr(request) {
        const data = QueryLastPendingLogicCallByAddrRequest.encode(request).finish();
        const promise = this.rpc.request("gravity.v1.Query", "LastPendingLogicCallByAddr", data);
        return promise.then((data) => QueryLastPendingLogicCallByAddrResponse.decode(new minimal.Reader(data)));
    }
    LastEventNonceByAddr(request) {
        const data = QueryLastEventNonceByAddrRequest.encode(request).finish();
        const promise = this.rpc.request("gravity.v1.Query", "LastEventNonceByAddr", data);
        return promise.then((data) => QueryLastEventNonceByAddrResponse.decode(new minimal.Reader(data)));
    }
    BatchFees(request = {}) {
        const data = QueryBatchFeeRequest.encode(request).finish();
        const promise = this.rpc.request("gravity.v1.Query", "BatchFees", data);
        return promise.then((data) => QueryBatchFeeResponse.decode(new minimal.Reader(data)));
    }
    OutgoingTxBatches(request = {}) {
        const data = QueryOutgoingTxBatchesRequest.encode(request).finish();
        const promise = this.rpc.request("gravity.v1.Query", "OutgoingTxBatches", data);
        return promise.then((data) => QueryOutgoingTxBatchesResponse.decode(new minimal.Reader(data)));
    }
    OutgoingLogicCalls(request = {}) {
        const data = QueryOutgoingLogicCallsRequest.encode(request).finish();
        const promise = this.rpc.request("gravity.v1.Query", "OutgoingLogicCalls", data);
        return promise.then((data) => QueryOutgoingLogicCallsResponse.decode(new minimal.Reader(data)));
    }
    BatchRequestByNonce(request) {
        const data = QueryBatchRequestByNonceRequest.encode(request).finish();
        const promise = this.rpc.request("gravity.v1.Query", "BatchRequestByNonce", data);
        return promise.then((data) => QueryBatchRequestByNonceResponse.decode(new minimal.Reader(data)));
    }
    BatchConfirms(request) {
        const data = QueryBatchConfirmsRequest.encode(request).finish();
        const promise = this.rpc.request("gravity.v1.Query", "BatchConfirms", data);
        return promise.then((data) => QueryBatchConfirmsResponse.decode(new minimal.Reader(data)));
    }
    LogicConfirms(request) {
        const data = QueryLogicConfirmsRequest.encode(request).finish();
        const promise = this.rpc.request("gravity.v1.Query", "LogicConfirms", data);
        return promise.then((data) => QueryLogicConfirmsResponse.decode(new minimal.Reader(data)));
    }
    ERC20ToDenom(request) {
        const data = QueryERC20ToDenomRequest.encode(request).finish();
        const promise = this.rpc.request("gravity.v1.Query", "ERC20ToDenom", data);
        return promise.then((data) => QueryERC20ToDenomResponse.decode(new minimal.Reader(data)));
    }
    DenomToERC20(request) {
        const data = QueryDenomToERC20Request.encode(request).finish();
        const promise = this.rpc.request("gravity.v1.Query", "DenomToERC20", data);
        return promise.then((data) => QueryDenomToERC20Response.decode(new minimal.Reader(data)));
    }
    GetLastObservedEthBlock(request) {
        const data = QueryLastObservedEthBlockRequest.encode(request).finish();
        const promise = this.rpc.request("gravity.v1.Query", "GetLastObservedEthBlock", data);
        return promise.then((data) => QueryLastObservedEthBlockResponse.decode(new minimal.Reader(data)));
    }
    GetLastObservedEthNonce(request) {
        const data = QueryLastObservedEthNonceRequest.encode(request).finish();
        const promise = this.rpc.request("gravity.v1.Query", "GetLastObservedEthNonce", data);
        return promise.then((data) => QueryLastObservedEthNonceResponse.decode(new minimal.Reader(data)));
    }
    GetAttestations(request) {
        const data = QueryAttestationsRequest.encode(request).finish();
        const promise = this.rpc.request("gravity.v1.Query", "GetAttestations", data);
        return promise.then((data) => QueryAttestationsResponse.decode(new minimal.Reader(data)));
    }
    GetDelegateKeyByValidator(request) {
        const data = QueryDelegateKeysByValidatorAddress.encode(request).finish();
        const promise = this.rpc.request("gravity.v1.Query", "GetDelegateKeyByValidator", data);
        return promise.then((data) => QueryDelegateKeysByValidatorAddressResponse.decode(new minimal.Reader(data)));
    }
    GetDelegateKeyByEth(request) {
        const data = QueryDelegateKeysByEthAddress.encode(request).finish();
        const promise = this.rpc.request("gravity.v1.Query", "GetDelegateKeyByEth", data);
        return promise.then((data) => QueryDelegateKeysByEthAddressResponse.decode(new minimal.Reader(data)));
    }
    GetDelegateKeyByOrchestrator(request) {
        const data = QueryDelegateKeysByOrchestratorAddress.encode(request).finish();
        const promise = this.rpc.request("gravity.v1.Query", "GetDelegateKeyByOrchestrator", data);
        return promise.then((data) => QueryDelegateKeysByOrchestratorAddressResponse.decode(new minimal.Reader(data)));
    }
    GetPendingSendToEth(request) {
        const data = QueryPendingSendToEth.encode(request).finish();
        const promise = this.rpc.request("gravity.v1.Query", "GetPendingSendToEth", data);
        return promise.then((data) => QueryPendingSendToEthResponse.decode(new minimal.Reader(data)));
    }
    GetPendingIbcAutoForwards(request) {
        const data = QueryPendingIbcAutoForwards.encode(request).finish();
        const promise = this.rpc.request("gravity.v1.Query", "GetPendingIbcAutoForwards", data);
        return promise.then((data) => QueryPendingIbcAutoForwardsResponse.decode(new minimal.Reader(data)));
    }
}

;// CONCATENATED MODULE: ./node_modules/kujira.js/lib/esm/gravity/v1/queries.js
var queries_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};



function setupGravityExtension(base) {
    const rpc = (0,stargate_build.createProtobufRpcClient)(base);
    const queryService = new QueryClientImpl(rpc);
    return {
        gravity: {
            params: () => queries_awaiter(this, void 0, void 0, function* () {
                const { params } = yield queryService.Params({});
                (0,utils_build.assert)(params);
                return params;
            }),
            pendingSendToEth: (q) => queries_awaiter(this, void 0, void 0, function* () {
                return queryService.GetPendingSendToEth(q);
            }),
            denomToERC20: (q) => queries_awaiter(this, void 0, void 0, function* () {
                return queryService.DenomToERC20(q);
            }),
        },
    };
}

;// CONCATENATED MODULE: ./node_modules/kujira.js/lib/esm/gravity/v1/index.js






const types = [
    ["/gravity.v1.MsgBatchSendToEthClaim", MsgBatchSendToEthClaim],
    [
        "/gravity.v1.MsgBatchSendToEthClaimResponse",
        MsgBatchSendToEthClaimResponse,
    ],
    ["/gravity.v1.MsgCancelSendToEth", MsgCancelSendToEth],
    ["/gravity.v1.MsgCancelSendToEthResponse", MsgCancelSendToEthResponse],
    ["/gravity.v1.MsgConfirmBatch", MsgConfirmBatch],
    ["/gravity.v1.MsgConfirmBatchResponse", MsgConfirmBatchResponse],
    ["/gravity.v1.MsgConfirmLogicCall", MsgConfirmLogicCall],
    ["/gravity.v1.MsgConfirmLogicCallResponse", MsgConfirmLogicCallResponse],
    ["/gravity.v1.MsgERC20DeployedClaim", MsgERC20DeployedClaim],
    ["/gravity.v1.MsgERC20DeployedClaimResponse", MsgERC20DeployedClaimResponse],
    ["/gravity.v1.MsgExecuteIbcAutoForwards", MsgExecuteIbcAutoForwards],
    [
        "/gravity.v1.MsgExecuteIbcAutoForwardsResponse",
        MsgExecuteIbcAutoForwardsResponse,
    ],
    ["/gravity.v1.MsgLogicCallExecutedClaim", MsgLogicCallExecutedClaim],
    [
        "/gravity.v1.MsgLogicCallExecutedClaimResponse",
        MsgLogicCallExecutedClaimResponse,
    ],
    ["/gravity.v1.MsgRequestBatch", MsgRequestBatch],
    ["/gravity.v1.MsgRequestBatchResponse", MsgRequestBatchResponse],
    ["/gravity.v1.MsgSendToCosmosClaim", MsgSendToCosmosClaim],
    ["/gravity.v1.MsgSendToCosmosClaimResponse", MsgSendToCosmosClaimResponse],
    ["/gravity.v1.MsgSendToEth", MsgSendToEth],
    ["/gravity.v1.MsgSendToEthResponse", MsgSendToEthResponse],
    ["/gravity.v1.MsgSetOrchestratorAddress", MsgSetOrchestratorAddress],
    [
        "/gravity.v1.MsgSetOrchestratorAddressResponse",
        MsgSetOrchestratorAddressResponse,
    ],
    ["/gravity.v1.MsgSubmitBadSignatureEvidence", MsgSubmitBadSignatureEvidence],
    [
        "/gravity.v1.MsgSubmitBadSignatureEvidenceResponse",
        MsgSubmitBadSignatureEvidenceResponse,
    ],
    ["/gravity.v1.MsgValsetConfirm", MsgValsetConfirm],
    ["/gravity.v1.MsgValsetConfirmResponse", MsgValsetConfirmResponse],
    ["/gravity.v1.MsgValsetUpdatedClaim", MsgValsetUpdatedClaim],
    ["/gravity.v1.MsgValsetUpdatedClaimResponse", MsgValsetUpdatedClaimResponse],
];
const registry = new proto_signing_build.Registry(types);
const msg = {
    msgBatchSendToEthClaim: (data) => ({
        typeUrl: "/gravity.v1.MsgBatchSendToEthClaim",
        value: MsgBatchSendToEthClaim.fromPartial(data),
    }),
    msgBatchSendToEthClaimResponse: (data) => ({
        typeUrl: "/gravity.v1.MsgBatchSendToEthClaimResponse",
        value: MsgBatchSendToEthClaimResponse.fromPartial(data),
    }),
    msgCancelSendToEth: (data) => ({
        typeUrl: "/gravity.v1.MsgCancelSendToEth",
        value: MsgCancelSendToEth.fromPartial(data),
    }),
    msgCancelSendToEthResponse: (data) => ({
        typeUrl: "/gravity.v1.MsgCancelSendToEthResponse",
        value: MsgCancelSendToEthResponse.fromPartial(data),
    }),
    msgConfirmBatch: (data) => ({
        typeUrl: "/gravity.v1.MsgConfirmBatch",
        value: MsgConfirmBatch.fromPartial(data),
    }),
    msgConfirmBatchResponse: (data) => ({
        typeUrl: "/gravity.v1.MsgConfirmBatchResponse",
        value: MsgConfirmBatchResponse.fromPartial(data),
    }),
    msgConfirmLogicCall: (data) => ({
        typeUrl: "/gravity.v1.MsgConfirmLogicCall",
        value: MsgConfirmLogicCall.fromPartial(data),
    }),
    msgConfirmLogicCallResponse: (data) => ({
        typeUrl: "/gravity.v1.MsgConfirmLogicCallResponse",
        value: MsgConfirmLogicCallResponse.fromPartial(data),
    }),
    msgERC20DeployedClaim: (data) => ({
        typeUrl: "/gravity.v1.MsgERC20DeployedClaim",
        value: MsgERC20DeployedClaim.fromPartial(data),
    }),
    msgERC20DeployedClaimResponse: (data) => ({
        typeUrl: "/gravity.v1.MsgERC20DeployedClaimResponse",
        value: MsgERC20DeployedClaimResponse.fromPartial(data),
    }),
    msgExecuteIbcAutoForwards: (data) => ({
        typeUrl: "/gravity.v1.MsgExecuteIbcAutoForwards",
        value: MsgExecuteIbcAutoForwards.fromPartial(data),
    }),
    msgExecuteIbcAutoForwardsResponse: (data) => ({
        typeUrl: "/gravity.v1.MsgExecuteIbcAutoForwardsResponse",
        value: MsgExecuteIbcAutoForwardsResponse.fromPartial(data),
    }),
    msgLogicCallExecutedClaim: (data) => ({
        typeUrl: "/gravity.v1.MsgLogicCallExecutedClaim",
        value: MsgLogicCallExecutedClaim.fromPartial(data),
    }),
    msgLogicCallExecutedClaimResponse: (data) => ({
        typeUrl: "/gravity.v1.MsgLogicCallExecutedClaimResponse",
        value: MsgLogicCallExecutedClaimResponse.fromPartial(data),
    }),
    msgRequestBatch: (data) => ({
        typeUrl: "/gravity.v1.MsgRequestBatch",
        value: MsgRequestBatch.fromPartial(data),
    }),
    msgRequestBatchResponse: (data) => ({
        typeUrl: "/gravity.v1.MsgRequestBatchResponse",
        value: MsgRequestBatchResponse.fromPartial(data),
    }),
    msgSendToCosmosClaim: (data) => ({
        typeUrl: "/gravity.v1.MsgSendToCosmosClaim",
        value: MsgSendToCosmosClaim.fromPartial(data),
    }),
    msgSendToCosmosClaimResponse: (data) => ({
        typeUrl: "/gravity.v1.MsgSendToCosmosClaimResponse",
        value: MsgSendToCosmosClaimResponse.fromPartial(data),
    }),
    msgSendToEth: (data) => ({
        typeUrl: "/gravity.v1.MsgSendToEth",
        value: MsgSendToEth.fromPartial(data),
    }),
    msgSendToEthResponse: (data) => ({
        typeUrl: "/gravity.v1.MsgSendToEthResponse",
        value: MsgSendToEthResponse.fromPartial(data),
    }),
    msgSetOrchestratorAddress: (data) => ({
        typeUrl: "/gravity.v1.MsgSetOrchestratorAddress",
        value: MsgSetOrchestratorAddress.fromPartial(data),
    }),
    msgSetOrchestratorAddressResponse: (data) => ({
        typeUrl: "/gravity.v1.MsgSetOrchestratorAddressResponse",
        value: MsgSetOrchestratorAddressResponse.fromPartial(data),
    }),
    msgSubmitBadSignatureEvidence: (data) => ({
        typeUrl: "/gravity.v1.MsgSubmitBadSignatureEvidence",
        value: MsgSubmitBadSignatureEvidence.fromPartial(data),
    }),
    msgSubmitBadSignatureEvidenceResponse: (data) => ({
        typeUrl: "/gravity.v1.MsgSubmitBadSignatureEvidenceResponse",
        value: MsgSubmitBadSignatureEvidenceResponse.fromPartial(data),
    }),
    msgValsetConfirm: (data) => ({
        typeUrl: "/gravity.v1.MsgValsetConfirm",
        value: MsgValsetConfirm.fromPartial(data),
    }),
    msgValsetConfirmResponse: (data) => ({
        typeUrl: "/gravity.v1.MsgValsetConfirmResponse",
        value: MsgValsetConfirmResponse.fromPartial(data),
    }),
    msgValsetUpdatedClaim: (data) => ({
        typeUrl: "/gravity.v1.MsgValsetUpdatedClaim",
        value: MsgValsetUpdatedClaim.fromPartial(data),
    }),
    msgValsetUpdatedClaimResponse: (data) => ({
        typeUrl: "/gravity.v1.MsgValsetUpdatedClaimResponse",
        value: MsgValsetUpdatedClaimResponse.fromPartial(data),
    }),
};


;// CONCATENATED MODULE: ./node_modules/kujira.js/lib/esm/resources/channels.json
var channels_namespaceObject = JSON.parse('{"$":[{"state":1,"ordering":2,"counterparty":{"portId":"icahost","channelId":""},"connectionHops":["connection-14"],"version":"{\\"version\\":\\"ics27-1\\",\\"controller_connection_id\\":\\"connection-14\\",\\"host_connection_id\\":\\"connection-0\\",\\"address\\":\\"\\",\\"encoding\\":\\"proto3\\",\\"tx_type\\":\\"sdk_multi_msg\\"}","portId":"icacontroller-kujira1hhzf9u376mg8zcuvx3jsls7t805kzcrssrvvk5","channelId":"channel-22"},{"state":1,"ordering":2,"counterparty":{"portId":"icahost","channelId":""},"connectionHops":["connection-0"],"version":"{\\"version\\":\\"ics27-1\\",\\"controller_connection_id\\":\\"connection-0\\",\\"host_connection_id\\":\\"connection-1558\\",\\"address\\":\\"\\",\\"encoding\\":\\"proto3\\",\\"tx_type\\":\\"sdk_multi_msg\\"}","portId":"icacontroller-kujira1hhzf9u376mg8zcuvx3jsls7t805kzcrssrvvk5","channelId":"channel-23"},{"state":1,"ordering":2,"counterparty":{"portId":"icahost","channelId":""},"connectionHops":["connection-15"],"version":"{\\"version\\":\\"ics27-1\\",\\"controller_connection_id\\":\\"connection-15\\",\\"host_connection_id\\":\\"connection-1\\",\\"address\\":\\"\\",\\"encoding\\":\\"proto3\\",\\"tx_type\\":\\"sdk_multi_msg\\"}","portId":"icacontroller-kujira1hhzf9u376mg8zcuvx3jsls7t805kzcrssrvvk5","channelId":"channel-24"},{"state":1,"ordering":2,"counterparty":{"portId":"icahost","channelId":""},"connectionHops":["connection-10"],"version":"{\\"version\\":\\"ics27-1\\",\\"controller_connection_id\\":\\"connection-10\\",\\"host_connection_id\\":\\"connection-17\\",\\"address\\":\\"\\",\\"encoding\\":\\"proto3\\",\\"tx_type\\":\\"sdk_multi_msg\\"}","portId":"icacontroller-kujira1ltvwg69sw3c5z99c6rr08hal7v0kdzfxz07yj5","channelId":"channel-16"},{"state":1,"ordering":2,"counterparty":{"portId":"icahost","channelId":""},"connectionHops":["connection-14"],"version":"{\\"version\\":\\"ics27-1\\",\\"controller_connection_id\\":\\"connection-14\\",\\"host_connection_id\\":\\"connection-0\\",\\"address\\":\\"\\",\\"encoding\\":\\"proto3\\",\\"tx_type\\":\\"sdk_multi_msg\\"}","portId":"icacontroller-kujira1ltvwg69sw3c5z99c6rr08hal7v0kdzfxz07yj5","channelId":"channel-17"},{"state":1,"ordering":2,"counterparty":{"portId":"icahost","channelId":""},"connectionHops":["connection-14"],"version":"{\\"version\\":\\"ics27-1\\",\\"controller_connection_id\\":\\"connection-14\\",\\"host_connection_id\\":\\"connection-0\\",\\"address\\":\\"\\",\\"encoding\\":\\"proto3\\",\\"tx_type\\":\\"sdk_multi_msg\\"}","portId":"icacontroller-kujira1ltvwg69sw3c5z99c6rr08hal7v0kdzfxz07yj5","channelId":"channel-20"},{"state":1,"ordering":2,"counterparty":{"portId":"icahost","channelId":""},"connectionHops":["connection-14"],"version":"{\\"version\\":\\"ics27-1\\",\\"controller_connection_id\\":\\"connection-14\\",\\"host_connection_id\\":\\"connection-0\\",\\"address\\":\\"\\",\\"encoding\\":\\"proto3\\",\\"tx_type\\":\\"sdk_multi_msg\\"}","portId":"icacontroller-kujira1ltvwg69sw3c5z99c6rr08hal7v0kdzfxz07yj5","channelId":"channel-21"},{"state":1,"ordering":2,"counterparty":{"portId":"icahost","channelId":""},"connectionHops":["connection-14"],"version":"{\\"version\\":\\"ics27-1\\",\\"controller_connection_id\\":\\"connection-14\\",\\"host_connection_id\\":\\"connection-0\\",\\"address\\":\\"\\",\\"encoding\\":\\"proto3\\",\\"tx_type\\":\\"sdk_multi_msg\\"}","portId":"icacontroller-kujira1xesqr8vjvy34jhu027zd70ypl0nnev5eh42prp","channelId":"channel-25"},{"state":3,"ordering":2,"counterparty":{"portId":"icacontroller-neutron14hj2tavq8fpesdwxxcu44rty3hh90vhujrvcmstl4zr3txmfvw9s5c2epq.george_ica_0","channelId":"channel-2"},"connectionHops":["connection-25"],"version":"{\\"version\\":\\"ics27-1\\",\\"controller_connection_id\\":\\"connection-1\\",\\"host_connection_id\\":\\"connection-25\\",\\"address\\":\\"kujira1wlyf4e8522s30les7f707usudjr2j2vlpd65y6vknf4mafas976sfprgks\\",\\"encoding\\":\\"proto3\\",\\"tx_type\\":\\"sdk_multi_msg\\"}","portId":"icahost","channelId":"channel-31"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-297"},"connectionHops":["connection-0"],"version":"ics20-1","portId":"transfer","channelId":"channel-0"},{"state":1,"ordering":1,"counterparty":{"portId":"transfer","channelId":""},"connectionHops":["connection-2"],"version":"ics20-1","portId":"transfer","channelId":"channel-1"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-18"},"connectionHops":["connection-9"],"version":"ics20-1","portId":"transfer","channelId":"channel-10"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-24"},"connectionHops":["connection-10"],"version":"ics20-1","portId":"transfer","channelId":"channel-11"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-25"},"connectionHops":["connection-10"],"version":"ics20-1","portId":"transfer","channelId":"channel-12"},{"state":3,"ordering":1,"counterparty":{"portId":"wasm.juno1qrhrjhln673kf0v4r2yn4d0nuh029gacp2zjk74nen27wh7xw48spl4an8","channelId":"channel-76"},"connectionHops":["connection-11"],"version":"ics20-1","portId":"transfer","channelId":"channel-13"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-179"},"connectionHops":["connection-12"],"version":"ics20-1","portId":"transfer","channelId":"channel-14"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-188"},"connectionHops":["connection-13"],"version":"ics20-1","portId":"transfer","channelId":"channel-15"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-0"},"connectionHops":["connection-14"],"version":"ics20-1","portId":"transfer","channelId":"channel-18"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-1"},"connectionHops":["connection-14"],"version":"ics20-1","portId":"transfer","channelId":"channel-19"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-14"},"connectionHops":["connection-2"],"version":"ics20-1","portId":"transfer","channelId":"channel-2"},{"state":1,"ordering":1,"counterparty":{"portId":"transfer","channelId":""},"connectionHops":["connection-16"],"version":"ics20-1","portId":"transfer","channelId":"channel-26"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-0"},"connectionHops":["connection-22"],"version":"ics20-1","portId":"transfer","channelId":"channel-27"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-0"},"connectionHops":["connection-23"],"version":"ics20-1","portId":"transfer","channelId":"channel-28"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-0"},"connectionHops":["connection-24"],"version":"ics20-1","portId":"transfer","channelId":"channel-29"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-15"},"connectionHops":["connection-3"],"version":"ics20-1","portId":"transfer","channelId":"channel-3"},{"state":2,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-1"},"connectionHops":["connection-25"],"version":"ics20-1","portId":"transfer","channelId":"channel-30"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-0"},"connectionHops":["connection-26"],"version":"ics20-1","portId":"transfer","channelId":"channel-32"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-0"},"connectionHops":["connection-27"],"version":"ics20-1","portId":"transfer","channelId":"channel-33"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-390"},"connectionHops":["connection-30"],"version":"ics20-1","portId":"transfer","channelId":"channel-34"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-0"},"connectionHops":["connection-31"],"version":"ics20-1","portId":"transfer","channelId":"channel-35"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-1"},"connectionHops":["connection-32"],"version":"ics20-1","portId":"transfer","channelId":"channel-36"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-0"},"connectionHops":["connection-33"],"version":"ics20-1","portId":"transfer","channelId":"channel-37"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-398"},"connectionHops":["connection-34"],"version":"ics20-1","portId":"transfer","channelId":"channel-38"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-0"},"connectionHops":["connection-35"],"version":"ics20-1","portId":"transfer","channelId":"channel-39"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-1"},"connectionHops":["connection-4"],"version":"ics20-1","portId":"transfer","channelId":"channel-4"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-6"},"connectionHops":["connection-36"],"version":"ics20-1","portId":"transfer","channelId":"channel-40"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-5"},"connectionHops":["connection-37"],"version":"ics20-1","portId":"transfer","channelId":"channel-41"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-6"},"connectionHops":["connection-38"],"version":"ics20-1","portId":"transfer","channelId":"channel-42"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-7"},"connectionHops":["connection-39"],"version":"ics20-1","portId":"transfer","channelId":"channel-43"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-257"},"connectionHops":["connection-40"],"version":"ics20-1","portId":"transfer","channelId":"channel-44"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-209"},"connectionHops":["connection-41"],"version":"ics20-1","portId":"transfer","channelId":"channel-45"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-2"},"connectionHops":["connection-42"],"version":"ics20-1","portId":"transfer","channelId":"channel-46"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-316"},"connectionHops":["connection-43"],"version":"ics20-1","portId":"transfer","channelId":"channel-47"},{"state":1,"ordering":1,"counterparty":{"portId":"transfer","channelId":""},"connectionHops":["connection-6"],"version":"ics20-1","portId":"transfer","channelId":"channel-5"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-6"},"connectionHops":["connection-7"],"version":"ics20-1","portId":"transfer","channelId":"channel-6"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-7"},"connectionHops":["connection-7"],"version":"ics20-1","portId":"transfer","channelId":"channel-7"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-19"},"connectionHops":["connection-8"],"version":"ics20-1","portId":"transfer","channelId":"channel-8"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-20"},"connectionHops":["connection-8"],"version":"ics20-1","portId":"transfer","channelId":"channel-9"}],"R":[{"state":1,"ordering":2,"counterparty":{"portId":"icahost","channelId":""},"connectionHops":["connection-5"],"version":"{\\"fee_version\\":\\"ics29-1\\",\\"app_version\\":\\"{\\\\\\"version\\\\\\":\\\\\\"ics27-1\\\\\\",\\\\\\"controller_connection_id\\\\\\":\\\\\\"connection-5\\\\\\",\\\\\\"host_connection_id\\\\\\":\\\\\\"connection-111\\\\\\",\\\\\\"address\\\\\\":\\\\\\"\\\\\\",\\\\\\"encoding\\\\\\":\\\\\\"proto3\\\\\\",\\\\\\"tx_type\\\\\\":\\\\\\"sdk_multi_msg\\\\\\"}\\"}","portId":"icacontroller-kujira16qpvzhmawvsm8mcj4hdvtz25dadatdhhgw79xa","channelId":"channel-148"},{"state":1,"ordering":2,"counterparty":{"portId":"icahost","channelId":""},"connectionHops":["connection-5"],"version":"{\\"fee_version\\":\\"ics29-1\\",\\"app_version\\":\\"{\\\\\\"version\\\\\\":\\\\\\"ics27-1\\\\\\",\\\\\\"controller_connection_id\\\\\\":\\\\\\"connection-5\\\\\\",\\\\\\"host_connection_id\\\\\\":\\\\\\"connection-111\\\\\\",\\\\\\"address\\\\\\":\\\\\\"\\\\\\",\\\\\\"encoding\\\\\\":\\\\\\"proto3\\\\\\",\\\\\\"tx_type\\\\\\":\\\\\\"sdk_multi_msg\\\\\\"}\\"}","portId":"icacontroller-kujira16qpvzhmawvsm8mcj4hdvtz25dadatdhhgw79xa","channelId":"channel-149"},{"state":3,"ordering":2,"counterparty":{"portId":"icahost","channelId":"channel-337"},"connectionHops":["connection-3"],"version":"{\\"fee_version\\":\\"ics29-1\\",\\"app_version\\":\\"{\\\\\\"version\\\\\\":\\\\\\"ics27-1\\\\\\",\\\\\\"controller_connection_id\\\\\\":\\\\\\"connection-3\\\\\\",\\\\\\"host_connection_id\\\\\\":\\\\\\"connection-13\\\\\\",\\\\\\"address\\\\\\":\\\\\\"terra17j3c6qtfk20s28nceu4vwyhz0jtsnk2v9y8e58nayyks8v69yxdskyfse3\\\\\\",\\\\\\"encoding\\\\\\":\\\\\\"proto3\\\\\\",\\\\\\"tx_type\\\\\\":\\\\\\"sdk_multi_msg\\\\\\"}\\"}","portId":"icacontroller-kujira16qpvzhmawvsm8mcj4hdvtz25dadatdhhgw79xa","channelId":"channel-150"},{"state":1,"ordering":2,"counterparty":{"portId":"icahost","channelId":""},"connectionHops":["connection-5"],"version":"{\\"fee_version\\":\\"ics29-1\\",\\"app_version\\":\\"{\\\\\\"version\\\\\\":\\\\\\"ics27-1\\\\\\",\\\\\\"controller_connection_id\\\\\\":\\\\\\"connection-5\\\\\\",\\\\\\"host_connection_id\\\\\\":\\\\\\"connection-111\\\\\\",\\\\\\"address\\\\\\":\\\\\\"\\\\\\",\\\\\\"encoding\\\\\\":\\\\\\"proto3\\\\\\",\\\\\\"tx_type\\\\\\":\\\\\\"sdk_multi_msg\\\\\\"}\\"}","portId":"icacontroller-kujira16qpvzhmawvsm8mcj4hdvtz25dadatdhhgw79xa","channelId":"channel-151"},{"state":1,"ordering":2,"counterparty":{"portId":"icahost","channelId":""},"connectionHops":["connection-5"],"version":"{\\"fee_version\\":\\"ics29-1\\",\\"app_version\\":\\"{\\\\\\"version\\\\\\":\\\\\\"ics27-1\\\\\\",\\\\\\"controller_connection_id\\\\\\":\\\\\\"connection-5\\\\\\",\\\\\\"host_connection_id\\\\\\":\\\\\\"connection-111\\\\\\",\\\\\\"address\\\\\\":\\\\\\"\\\\\\",\\\\\\"encoding\\\\\\":\\\\\\"proto3\\\\\\",\\\\\\"tx_type\\\\\\":\\\\\\"sdk_multi_msg\\\\\\"}\\"}","portId":"icacontroller-kujira16qpvzhmawvsm8mcj4hdvtz25dadatdhhgw79xa","channelId":"channel-152"},{"state":1,"ordering":2,"counterparty":{"portId":"icahost","channelId":""},"connectionHops":["connection-5"],"version":"{\\"fee_version\\":\\"ics29-1\\",\\"app_version\\":\\"{\\\\\\"version\\\\\\":\\\\\\"ics27-1\\\\\\",\\\\\\"controller_connection_id\\\\\\":\\\\\\"connection-5\\\\\\",\\\\\\"host_connection_id\\\\\\":\\\\\\"connection-111\\\\\\",\\\\\\"address\\\\\\":\\\\\\"\\\\\\",\\\\\\"encoding\\\\\\":\\\\\\"proto3\\\\\\",\\\\\\"tx_type\\\\\\":\\\\\\"sdk_multi_msg\\\\\\"}\\"}","portId":"icacontroller-kujira16qpvzhmawvsm8mcj4hdvtz25dadatdhhgw79xa","channelId":"channel-153"},{"state":1,"ordering":2,"counterparty":{"portId":"icahost","channelId":""},"connectionHops":["connection-5"],"version":"{\\"fee_version\\":\\"ics29-1\\",\\"app_version\\":\\"{\\\\\\"version\\\\\\":\\\\\\"ics27-1\\\\\\",\\\\\\"controller_connection_id\\\\\\":\\\\\\"connection-5\\\\\\",\\\\\\"host_connection_id\\\\\\":\\\\\\"connection-111\\\\\\",\\\\\\"address\\\\\\":\\\\\\"\\\\\\",\\\\\\"encoding\\\\\\":\\\\\\"proto3\\\\\\",\\\\\\"tx_type\\\\\\":\\\\\\"sdk_multi_msg\\\\\\"}\\"}","portId":"icacontroller-kujira16qpvzhmawvsm8mcj4hdvtz25dadatdhhgw79xa","channelId":"channel-154"},{"state":3,"ordering":2,"counterparty":{"portId":"icahost","channelId":"channel-172"},"connectionHops":["connection-5"],"version":"{\\"version\\":\\"ics27-1\\",\\"controller_connection_id\\":\\"connection-5\\",\\"host_connection_id\\":\\"connection-111\\",\\"address\\":\\"stars10vvraf9qpfts20z3djz8zr0m0sfp292jmnlpm7dz8gtnvkhqmw7s04l0dh\\",\\"encoding\\":\\"proto3\\",\\"tx_type\\":\\"sdk_multi_msg\\"}","portId":"icacontroller-kujira16s4etqsg456m5txn8ec39n4f2u9r0f642vdlxu","channelId":"channel-93"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-343"},"connectionHops":["connection-0"],"version":"ics20-1","portId":"transfer","channelId":"channel-0"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-87"},"connectionHops":["connection-1"],"version":"ics20-1","portId":"transfer","channelId":"channel-1"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-22"},"connectionHops":["connection-7"],"version":"ics20-1","portId":"transfer","channelId":"channel-10"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-48"},"connectionHops":["connection-111"],"version":"ics20-1","portId":"transfer","channelId":"channel-100"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-27"},"connectionHops":["connection-112"],"version":"ics20-1","portId":"transfer","channelId":"channel-101"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-105"},"connectionHops":["connection-113"],"version":"ics20-1","portId":"transfer","channelId":"channel-102"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-16"},"connectionHops":["connection-114"],"version":"ics20-1","portId":"transfer","channelId":"channel-103"},{"state":1,"ordering":1,"counterparty":{"portId":"wasm.terra1lwdvjtl5lecxcyfl7hc362gczqh03msgcwlh76xa0fcu0usf7ejskkfulk","channelId":""},"connectionHops":["connection-79"],"version":"ics20-1","portId":"transfer","channelId":"channel-104"},{"state":1,"ordering":1,"counterparty":{"portId":"wasm.terra1lwdvjtl5lecxcyfl7hc362gczqh03msgcwlh76xa0fcu0usf7ejskkfulk","channelId":""},"connectionHops":["connection-79"],"version":"ics20-1","portId":"transfer","channelId":"channel-105"},{"state":1,"ordering":1,"counterparty":{"portId":"wasm.terra1lwdvjtl5lecxcyfl7hc362gczqh03msgcwlh76xa0fcu0usf7ejskkfulk","channelId":""},"connectionHops":["connection-79"],"version":"ics20-1","portId":"transfer","channelId":"channel-106"},{"state":1,"ordering":1,"counterparty":{"portId":"wasm.terra1lwdvjtl5lecxcyfl7hc362gczqh03msgcwlh76xa0fcu0usf7ejskkfulk","channelId":""},"connectionHops":["connection-79"],"version":"ics20-1","portId":"transfer","channelId":"channel-107"},{"state":1,"ordering":1,"counterparty":{"portId":"wasm.terra1lwdvjtl5lecxcyfl7hc362gczqh03msgcwlh76xa0fcu0usf7ejskkfulk","channelId":""},"connectionHops":["connection-79"],"version":"ics20-1","portId":"transfer","channelId":"channel-108"},{"state":1,"ordering":1,"counterparty":{"portId":"wasm.terra1lwdvjtl5lecxcyfl7hc362gczqh03msgcwlh76xa0fcu0usf7ejskkfulk","channelId":""},"connectionHops":["connection-79"],"version":"ics20-1","portId":"transfer","channelId":"channel-109"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-83"},"connectionHops":["connection-8"],"version":"ics20-1","portId":"transfer","channelId":"channel-11"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-6"},"connectionHops":["connection-115"],"version":"ics20-1","portId":"transfer","channelId":"channel-110"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-7"},"connectionHops":["connection-115"],"version":"ics20-1","portId":"transfer","channelId":"channel-111"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-8"},"connectionHops":["connection-116"],"version":"ics20-1","portId":"transfer","channelId":"channel-112"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-9"},"connectionHops":["connection-117"],"version":"ics20-1","portId":"transfer","channelId":"channel-113"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-3"},"connectionHops":["connection-118"],"version":"ics20-1","portId":"transfer","channelId":"channel-114"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-4"},"connectionHops":["connection-119"],"version":"ics20-1","portId":"transfer","channelId":"channel-115"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-0"},"connectionHops":["connection-120"],"version":"ics20-1","portId":"transfer","channelId":"channel-116"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-9"},"connectionHops":["connection-121"],"version":"ics20-1","portId":"transfer","channelId":"channel-117"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-5"},"connectionHops":["connection-122"],"version":"ics20-1","portId":"transfer","channelId":"channel-118"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-0"},"connectionHops":["connection-123"],"version":"ics20-1","portId":"transfer","channelId":"channel-119"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-16"},"connectionHops":["connection-9"],"version":"ics20-1","portId":"transfer","channelId":"channel-12"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-48"},"connectionHops":["connection-124"],"version":"ics20-1","portId":"transfer","channelId":"channel-120"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-14"},"connectionHops":["connection-125"],"version":"ics20-1","portId":"transfer","channelId":"channel-121"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-17"},"connectionHops":["connection-126"],"version":"ics20-1","portId":"transfer","channelId":"channel-122"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-5"},"connectionHops":["connection-127"],"version":"{\\"fee_version\\":\\"ics29-1\\",\\"app_version\\":\\"ics20-1\\"}","portId":"transfer","channelId":"channel-123"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-35"},"connectionHops":["connection-128"],"version":"ics20-1","portId":"transfer","channelId":"channel-124"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-44"},"connectionHops":["connection-10"],"version":"ics20-1","portId":"transfer","channelId":"channel-13"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-94"},"connectionHops":["connection-11"],"version":"ics20-1","portId":"transfer","channelId":"channel-14"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-8"},"connectionHops":["connection-12"],"version":"ics20-1","portId":"transfer","channelId":"channel-15"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-6"},"connectionHops":["connection-13"],"version":"ics20-1","portId":"transfer","channelId":"channel-16"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-21"},"connectionHops":["connection-14"],"version":"ics20-1","portId":"transfer","channelId":"channel-17"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-31"},"connectionHops":["connection-15"],"version":"ics20-1","portId":"transfer","channelId":"channel-18"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-7"},"connectionHops":["connection-16"],"version":"ics20-1","portId":"transfer","channelId":"channel-19"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-88"},"connectionHops":["connection-1"],"version":"ics20-1","portId":"transfer","channelId":"channel-2"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-1"},"connectionHops":["connection-17"],"version":"ics20-1","portId":"transfer","channelId":"channel-20"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-27"},"connectionHops":["connection-18"],"version":"ics20-1","portId":"transfer","channelId":"channel-21"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-17"},"connectionHops":["connection-19"],"version":"ics20-1","portId":"transfer","channelId":"channel-22"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-18"},"connectionHops":["connection-19"],"version":"ics20-1","portId":"transfer","channelId":"channel-23"},{"state":3,"ordering":1,"counterparty":{"portId":"wasm.juno1lkv72wruk6m39a2j4ps036hzxyhjccwncgfzzcaqxuwndg5x0ghqa8mrhg","channelId":"channel-91"},"connectionHops":["connection-20"],"version":"ics20-1","portId":"transfer","channelId":"channel-24"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-0"},"connectionHops":["connection-21"],"version":"ics20-1","portId":"transfer","channelId":"channel-25"},{"state":2,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-0"},"connectionHops":["connection-21"],"version":"ics20-1","portId":"transfer","channelId":"channel-26"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-2"},"connectionHops":["connection-23"],"version":"ics20-1","portId":"transfer","channelId":"channel-27"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-22"},"connectionHops":["connection-25"],"version":"ics20-1","portId":"transfer","channelId":"channel-28"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-7"},"connectionHops":["connection-29"],"version":"ics20-1","portId":"transfer","channelId":"channel-29"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-259"},"connectionHops":["connection-2"],"version":"ics20-1","portId":"transfer","channelId":"channel-3"},{"state":1,"ordering":1,"counterparty":{"portId":"wasm.juno1lkv72wruk6m39a2j4ps036hzxyhjccwncgfzzcaqxuwndg5x0ghqa8mrhg","channelId":""},"connectionHops":["connection-20"],"version":"ics20-1","portId":"transfer","channelId":"channel-30"},{"state":3,"ordering":1,"counterparty":{"portId":"wasm.juno1lkv72wruk6m39a2j4ps036hzxyhjccwncgfzzcaqxuwndg5x0ghqa8mrhg","channelId":"channel-97"},"connectionHops":["connection-30"],"version":"ics20-1","portId":"transfer","channelId":"channel-31"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-8"},"connectionHops":["connection-31"],"version":"ics20-1","portId":"transfer","channelId":"channel-32"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-13"},"connectionHops":["connection-32"],"version":"ics20-1","portId":"transfer","channelId":"channel-33"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-30"},"connectionHops":["connection-33"],"version":"ics20-1","portId":"transfer","channelId":"channel-34"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-18"},"connectionHops":["connection-34"],"version":"ics20-1","portId":"transfer","channelId":"channel-35"},{"state":3,"ordering":1,"counterparty":{"portId":"wasm.terra1e0mrzy8077druuu42vs0hu7ugguade0cj65dgtauyaw4gsl4kv0qtdf2au","channelId":"channel-28"},"connectionHops":["connection-3"],"version":"ics20-1","portId":"transfer","channelId":"channel-36"},{"state":1,"ordering":1,"counterparty":{"portId":"wasm.terra1jrx4qw4uwjpcug6z4h39tt6lpq9d6angms2nzr","channelId":""},"connectionHops":["connection-35"],"version":"ics20-1","portId":"transfer","channelId":"channel-37"},{"state":1,"ordering":1,"counterparty":{"portId":"wasm.terra1jrx4qw4uwjpcug6z4h39tt6lpq9d6angms2nzr","channelId":""},"connectionHops":["connection-36"],"version":"ics20-1","portId":"transfer","channelId":"channel-38"},{"state":1,"ordering":1,"counterparty":{"portId":"wasm.terra1jrx4qw4uwjpcug6z4h39tt6lpq9d6angms2nzr","channelId":""},"connectionHops":["connection-36"],"version":"ics20-1","portId":"transfer","channelId":"channel-39"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-9"},"connectionHops":["connection-3"],"version":"ics20-1","portId":"transfer","channelId":"channel-4"},{"state":1,"ordering":1,"counterparty":{"portId":"wasm.terra1jrx4qw4uwjpcug6z4h39tt6lpq9d6angms2nzr","channelId":""},"connectionHops":["connection-37"],"version":"ics20-1","portId":"transfer","channelId":"channel-40"},{"state":1,"ordering":1,"counterparty":{"portId":"wasm.terra1jrx4qw4uwjpcug6z4h39tt6lpq9d6angms2nzr","channelId":""},"connectionHops":["connection-37"],"version":"ics20-1","portId":"transfer","channelId":"channel-41"},{"state":1,"ordering":1,"counterparty":{"portId":"wasm.terra1jrx4qw4uwjpcug6z4h39tt6lpq9d6angms2nzr","channelId":""},"connectionHops":["connection-37"],"version":"ics20-1","portId":"transfer","channelId":"channel-42"},{"state":3,"ordering":1,"counterparty":{"portId":"wasm.terra1d90p5lacfxnqgjxjupu234lxnxyeu8fdeef4d0e0nqy3p30r7gss4myn9x","channelId":"channel-34"},"connectionHops":["connection-38"],"version":"ics20-1","portId":"transfer","channelId":"channel-43"},{"state":3,"ordering":1,"counterparty":{"portId":"wasm.secret1tqmms5awftpuhalcv5h5mg76fa0tkdz4jv9ex4","channelId":"channel-46"},"connectionHops":["connection-7"],"version":"ics20-1","portId":"transfer","channelId":"channel-44"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-12"},"connectionHops":["connection-39"],"version":"ics20-1","portId":"transfer","channelId":"channel-45"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-9"},"connectionHops":["connection-40"],"version":"ics20-1","portId":"transfer","channelId":"channel-46"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-7"},"connectionHops":["connection-41"],"version":"ics20-1","portId":"transfer","channelId":"channel-47"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-37"},"connectionHops":["connection-43"],"version":"ics20-1","portId":"transfer","channelId":"channel-48"},{"state":1,"ordering":1,"counterparty":{"portId":"wasm.terra1wgv3ahu359e776hfv3p6cju90n3cwjfl6zp25c","channelId":""},"connectionHops":["connection-44"],"version":"ics20-1","portId":"transfer","channelId":"channel-49"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-10"},"connectionHops":["connection-3"],"version":"ics20-1","portId":"transfer","channelId":"channel-5"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-107"},"connectionHops":["connection-45"],"version":"ics20-1","portId":"transfer","channelId":"channel-50"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-23"},"connectionHops":["connection-46"],"version":"ics20-1","portId":"transfer","channelId":"channel-51"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-27"},"connectionHops":["connection-47"],"version":"ics20-1","portId":"transfer","channelId":"channel-52"},{"state":1,"ordering":1,"counterparty":{"portId":"transfer","channelId":""},"connectionHops":["connection-48"],"version":"ics20-1","portId":"transfer","channelId":"channel-53"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-98"},"connectionHops":["connection-53"],"version":"ics20-1","portId":"transfer","channelId":"channel-54"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-0"},"connectionHops":["connection-54"],"version":"ics20-1","portId":"transfer","channelId":"channel-55"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-72"},"connectionHops":["connection-56"],"version":"ics20-1","portId":"transfer","channelId":"channel-56"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-17"},"connectionHops":["connection-58"],"version":"ics20-1","portId":"transfer","channelId":"channel-57"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-8"},"connectionHops":["connection-59"],"version":"ics20-1","portId":"transfer","channelId":"channel-58"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-70"},"connectionHops":["connection-62"],"version":"ics20-1","portId":"transfer","channelId":"channel-59"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-56"},"connectionHops":["connection-4"],"version":"ics20-1","portId":"transfer","channelId":"channel-6"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-18"},"connectionHops":["connection-63"],"version":"ics20-1","portId":"transfer","channelId":"channel-60"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-13"},"connectionHops":["connection-64"],"version":"ics20-1","portId":"transfer","channelId":"channel-61"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-2"},"connectionHops":["connection-65"],"version":"ics20-1","portId":"transfer","channelId":"channel-62"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-6"},"connectionHops":["connection-68"],"version":"ics20-1","portId":"transfer","channelId":"channel-63"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-63"},"connectionHops":["connection-72"],"version":"ics20-1","portId":"transfer","channelId":"channel-64"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-19"},"connectionHops":["connection-73"],"version":"ics20-1","portId":"transfer","channelId":"channel-65"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-41"},"connectionHops":["connection-74"],"version":"ics20-1","portId":"transfer","channelId":"channel-66"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-42"},"connectionHops":["connection-75"],"version":"ics20-1","portId":"transfer","channelId":"channel-67"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-100"},"connectionHops":["connection-76"],"version":"ics20-1","portId":"transfer","channelId":"channel-68"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-4"},"connectionHops":["connection-77"],"version":"ics20-1","portId":"transfer","channelId":"channel-69"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-49"},"connectionHops":["connection-5"],"version":"ics20-1","portId":"transfer","channelId":"channel-7"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-26"},"connectionHops":["connection-78"],"version":"ics20-1","portId":"transfer","channelId":"channel-70"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-71"},"connectionHops":["connection-79"],"version":"ics20-1","portId":"transfer","channelId":"channel-71"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-72"},"connectionHops":["connection-79"],"version":"ics20-1","portId":"transfer","channelId":"channel-72"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-6"},"connectionHops":["connection-80"],"version":"ics20-1","portId":"transfer","channelId":"channel-73"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-21"},"connectionHops":["connection-81"],"version":"ics20-1","portId":"transfer","channelId":"channel-74"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-3"},"connectionHops":["connection-82"],"version":"ics20-1","portId":"transfer","channelId":"channel-75"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-47"},"connectionHops":["connection-83"],"version":"ics20-1","portId":"transfer","channelId":"channel-76"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-40"},"connectionHops":["connection-84"],"version":"ics20-1","portId":"transfer","channelId":"channel-77"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-31"},"connectionHops":["connection-85"],"version":"ics20-1","portId":"transfer","channelId":"channel-78"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-22"},"connectionHops":["connection-86"],"version":"ics20-1","portId":"transfer","channelId":"channel-79"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-13"},"connectionHops":["connection-6"],"version":"ics20-1","portId":"transfer","channelId":"channel-8"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-26"},"connectionHops":["connection-87"],"version":"ics20-1","portId":"transfer","channelId":"channel-80"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-21"},"connectionHops":["connection-88"],"version":"ics20-1","portId":"transfer","channelId":"channel-81"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-52"},"connectionHops":["connection-89"],"version":"ics20-1","portId":"transfer","channelId":"channel-82"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-56"},"connectionHops":["connection-90"],"version":"ics20-1","portId":"transfer","channelId":"channel-83"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-22"},"connectionHops":["connection-91"],"version":"ics20-1","portId":"transfer","channelId":"channel-84"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-101"},"connectionHops":["connection-92"],"version":"ics20-1","portId":"transfer","channelId":"channel-85"},{"state":1,"ordering":1,"counterparty":{"portId":"transfer","channelId":""},"connectionHops":["connection-93"],"version":"ics20-1","portId":"transfer","channelId":"channel-86"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-111"},"connectionHops":["connection-95"],"version":"ics20-1","portId":"transfer","channelId":"channel-87"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-96"},"connectionHops":["connection-98"],"version":"ics20-1","portId":"transfer","channelId":"channel-88"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-30"},"connectionHops":["connection-100"],"version":"ics20-1","portId":"transfer","channelId":"channel-89"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-14"},"connectionHops":["connection-6"],"version":"ics20-1","portId":"transfer","channelId":"channel-9"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-77"},"connectionHops":["connection-101"],"version":"ics20-1","portId":"transfer","channelId":"channel-90"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-51"},"connectionHops":["connection-103"],"version":"ics20-1","portId":"transfer","channelId":"channel-91"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-37"},"connectionHops":["connection-104"],"version":"ics20-1","portId":"transfer","channelId":"channel-92"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-39"},"connectionHops":["connection-105"],"version":"ics20-1","portId":"transfer","channelId":"channel-94"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-116"},"connectionHops":["connection-106"],"version":"ics20-1","portId":"transfer","channelId":"channel-95"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-94"},"connectionHops":["connection-107"],"version":"ics20-1","portId":"transfer","channelId":"channel-96"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-46"},"connectionHops":["connection-108"],"version":"ics20-1","portId":"transfer","channelId":"channel-97"},{"state":2,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-10"},"connectionHops":["connection-109"],"version":"ics20-1","portId":"transfer","channelId":"channel-98"},{"state":3,"ordering":1,"counterparty":{"portId":"transfer","channelId":"channel-11"},"connectionHops":["connection-110"],"version":"ics20-1","portId":"transfer","channelId":"channel-99"},{"state":3,"ordering":1,"counterparty":{"portId":"wasm.juno1z0fepsfeeew78uwespyneswt5q9aqntj55xdwdasefxpu7zjed2qa6t582","channelId":"channel-473"},"connectionHops":["connection-1"],"version":"WyJKU09OLUNvc21vc01zZyJd","portId":"wasm.kujira13nqh8m3394cpm62h8wm0uagqux37zaxs30e6e2zgg3acdx5yr5aq08ezlr","channelId":"channel-125"},{"state":2,"ordering":1,"counterparty":{"portId":"wasm.juno1z0fepsfeeew78uwespyneswt5q9aqntj55xdwdasefxpu7zjed2qa6t582","channelId":"channel-473"},"connectionHops":["connection-1"],"version":"WyJKU09OLUNvc21vc01zZyJd","portId":"wasm.kujira13nqh8m3394cpm62h8wm0uagqux37zaxs30e6e2zgg3acdx5yr5aq08ezlr","channelId":"channel-126"},{"state":2,"ordering":1,"counterparty":{"portId":"wasm.juno1z0fepsfeeew78uwespyneswt5q9aqntj55xdwdasefxpu7zjed2qa6t582","channelId":"channel-473"},"connectionHops":["connection-1"],"version":"WyJKU09OLUNvc21vc01zZyJd","portId":"wasm.kujira13nqh8m3394cpm62h8wm0uagqux37zaxs30e6e2zgg3acdx5yr5aq08ezlr","channelId":"channel-127"},{"state":2,"ordering":1,"counterparty":{"portId":"wasm.juno1z0fepsfeeew78uwespyneswt5q9aqntj55xdwdasefxpu7zjed2qa6t582","channelId":"channel-473"},"connectionHops":["connection-1"],"version":"WyJKU09OLUNvc21vc01zZyJd","portId":"wasm.kujira13nqh8m3394cpm62h8wm0uagqux37zaxs30e6e2zgg3acdx5yr5aq08ezlr","channelId":"channel-128"},{"state":3,"ordering":1,"counterparty":{"portId":"wasm.juno1z0fepsfeeew78uwespyneswt5q9aqntj55xdwdasefxpu7zjed2qa6t582","channelId":"channel-474"},"connectionHops":["connection-1"],"version":"WyJKU09OLUNvc21vc01zZyJd","portId":"wasm.kujira13nqh8m3394cpm62h8wm0uagqux37zaxs30e6e2zgg3acdx5yr5aq08ezlr","channelId":"channel-129"},{"state":2,"ordering":1,"counterparty":{"portId":"wasm.juno1z0fepsfeeew78uwespyneswt5q9aqntj55xdwdasefxpu7zjed2qa6t582","channelId":"channel-474"},"connectionHops":["connection-1"],"version":"WyJKU09OLUNvc21vc01zZyJd","portId":"wasm.kujira13nqh8m3394cpm62h8wm0uagqux37zaxs30e6e2zgg3acdx5yr5aq08ezlr","channelId":"channel-130"},{"state":2,"ordering":1,"counterparty":{"portId":"wasm.juno1z0fepsfeeew78uwespyneswt5q9aqntj55xdwdasefxpu7zjed2qa6t582","channelId":"channel-474"},"connectionHops":["connection-1"],"version":"WyJKU09OLUNvc21vc01zZyJd","portId":"wasm.kujira13nqh8m3394cpm62h8wm0uagqux37zaxs30e6e2zgg3acdx5yr5aq08ezlr","channelId":"channel-132"},{"state":3,"ordering":1,"counterparty":{"portId":"wasm.neutron162fvv88dxpsapf3rnux63anruqach36r8qg73ehm2dv3fkat2rusw70nlx","channelId":"channel-69"},"connectionHops":["connection-82"],"version":"WyJKU09OLUNvc21vc01zZyJd","portId":"wasm.kujira14dckdzh7t30lkpdr0hgdqsqh52erux4tst5rl7jhvc693plnm39qp2r95q","channelId":"channel-140"},{"state":3,"ordering":1,"counterparty":{"portId":"wasm.osmo1546fnys90560am2jzuzsl0csmqc502g8ywgwpf3q9jdfucyr93jq7urvlm","channelId":"channel-16723"},"connectionHops":["connection-2"],"version":"WyJKU09OLUNvc21vc01zZyJd","portId":"wasm.kujira15454vhqp90cy7u2swyaf79e53hervg0g6h78jgfsgydys5vgqa6shcruhm","channelId":"channel-147"},{"state":3,"ordering":1,"counterparty":{"portId":"wasm.terra14qj6ejeuqmgtx63fujulzcvnr290wcjmmfkvqdqh5p4vjdkuewzsyagufs","channelId":"channel-333"},"connectionHops":["connection-3"],"version":"WyJKU09OLUNvc21vc01zZyJd","portId":"wasm.kujira15u8wevalrxd62y6z549fmkmjdt3k2adr4zzsjgwp0uw365gmy45qkn8s8v","channelId":"channel-141"},{"state":2,"ordering":1,"counterparty":{"portId":"wasm.osmo174mke7nylzwylaerfk6j8epzy5yxnvnfvrlx6gy2j0sq8sjf80lsw6skfn","channelId":"channel-16722"},"connectionHops":["connection-2"],"version":"WyJKU09OLUNvc21vc01zZyJd","portId":"wasm.kujira18zwe6dyezfla7p6zevm4wkatrajr4dn9lzf4l07ssdjz39s2322sw6ppuz","channelId":"channel-145"},{"state":3,"ordering":1,"counterparty":{"portId":"wasm.osmo174mke7nylzwylaerfk6j8epzy5yxnvnfvrlx6gy2j0sq8sjf80lsw6skfn","channelId":"channel-16722"},"connectionHops":["connection-2"],"version":"WyJKU09OLUNvc21vc01zZyJd","portId":"wasm.kujira18zwe6dyezfla7p6zevm4wkatrajr4dn9lzf4l07ssdjz39s2322sw6ppuz","channelId":"channel-146"},{"state":3,"ordering":1,"counterparty":{"portId":"wasm.juno1vv7s07lcv2de64nphg255y7vsreasg6k89vq48gqf754wpsc5w0qmwupeu","channelId":"channel-475"},"connectionHops":["connection-1"],"version":"WyJKU09OLUNvc21vc01zZyJd","portId":"wasm.kujira1kthhh99l9ec60jr4eytnva40ep52tjvjlup9y2a409vgc7sutn6qv4rrxj","channelId":"channel-131"},{"state":3,"ordering":1,"counterparty":{"portId":"wasm.terra1r5h8yun7yrlp9r8d508zlupzkhd2nhydljsyu6uwhllya972hxmqeu4spg","channelId":"channel-335"},"connectionHops":["connection-3"],"version":"WyJKU09OLUNvc21vc01zZyJd","portId":"wasm.kujira1ky62g8mpg03ym4x2qa2x3ewtekmd78hf9899es4al9qzehl2vscs9t30fq","channelId":"channel-143"},{"state":2,"ordering":1,"counterparty":{"portId":"wasm.terra1r5h8yun7yrlp9r8d508zlupzkhd2nhydljsyu6uwhllya972hxmqeu4spg","channelId":"channel-335"},"connectionHops":["connection-3"],"version":"WyJKU09OLUNvc21vc01zZyJd","portId":"wasm.kujira1ky62g8mpg03ym4x2qa2x3ewtekmd78hf9899es4al9qzehl2vscs9t30fq","channelId":"channel-144"},{"state":3,"ordering":1,"counterparty":{"portId":"wasm.archway1hnt7vrz40qy8lnz9577z0dxw6nedvgmxtqxqvt0ayts6e256v7cq3yzmlg","channelId":"channel-90"},"connectionHops":["connection-110"],"version":"WyJKU09OLUNvc21vc01zZyJd","portId":"wasm.kujira1q4r43ywst620wc9valw592nxs8k2a7vlsawkws0tz8x5675aaxxs5etvt8","channelId":"channel-133"},{"state":3,"ordering":1,"counterparty":{"portId":"wasm.stars1hp26cl5crsuyt9srmc9qjjmsf2fxv0sykxgvlcwk8qz59plm5xlqzk2n5g","channelId":"channel-276"},"connectionHops":["connection-5"],"version":"WyJKU09OLUNvc21vc01zZyJd","portId":"wasm.kujira1rd4l7q3c8737g3zjejlwkch3nht4hg00565k9dqezyrtsdn7xhns4thzes","channelId":"channel-135"},{"state":3,"ordering":1,"counterparty":{"portId":"wasm.neutron1gkrrj668pf84sefae7yqgseeugnfeygrat8tnu06q8vtqfvc6mhqk7sysy","channelId":"channel-68"},"connectionHops":["connection-82"],"version":"WyJKU09OLUNvc21vc01zZyJd","portId":"wasm.kujira1uexv52ffftauns6v2vlgvahc42k92nn0j0qa94u8re6dgp8zgfgqpw8uef","channelId":"channel-138"},{"state":2,"ordering":1,"counterparty":{"portId":"wasm.neutron1gkrrj668pf84sefae7yqgseeugnfeygrat8tnu06q8vtqfvc6mhqk7sysy","channelId":"channel-68"},"connectionHops":["connection-82"],"version":"WyJKU09OLUNvc21vc01zZyJd","portId":"wasm.kujira1uexv52ffftauns6v2vlgvahc42k92nn0j0qa94u8re6dgp8zgfgqpw8uef","channelId":"channel-139"},{"state":2,"ordering":1,"counterparty":{"portId":"wasm.neutron1gkrrj668pf84sefae7yqgseeugnfeygrat8tnu06q8vtqfvc6mhqk7sysy","channelId":"channel-68"},"connectionHops":["connection-82"],"version":"WyJKU09OLUNvc21vc01zZyJd","portId":"wasm.kujira1uexv52ffftauns6v2vlgvahc42k92nn0j0qa94u8re6dgp8zgfgqpw8uef","channelId":"channel-142"},{"state":3,"ordering":1,"counterparty":{"portId":"wasm.stars1qm2nv8vx9qf673h9r68vzwce4xf9kvyvkk54a28xnn5x5etcthuswrglxc","channelId":"channel-277"},"connectionHops":["connection-5"],"version":"WyJKU09OLUNvc21vc01zZyJd","portId":"wasm.kujira1wgjpx4d38gt3tc9rvyffk8upgs4sa805r0a3dleehtll67t7jyuqypclff","channelId":"channel-136"},{"state":3,"ordering":1,"counterparty":{"portId":"wasm.archway1mtjcp0l5tszsxncg73nga8u974ssy2rfmseyeuzekujw553d2nzqppclue","channelId":"channel-91"},"connectionHops":["connection-110"],"version":"WyJKU09OLUNvc21vc01zZyJd","portId":"wasm.kujira1xgrswwqadqgeaxejsy5gcpw0dlx8z6wzyavu07n5w5tvnl2k5ucqt93myv","channelId":"channel-134"},{"state":2,"ordering":1,"counterparty":{"portId":"wasm.archway1mtjcp0l5tszsxncg73nga8u974ssy2rfmseyeuzekujw553d2nzqppclue","channelId":"channel-91"},"connectionHops":["connection-110"],"version":"WyJKU09OLUNvc21vc01zZyJd","portId":"wasm.kujira1xgrswwqadqgeaxejsy5gcpw0dlx8z6wzyavu07n5w5tvnl2k5ucqt93myv","channelId":"channel-137"}]}');
// EXTERNAL MODULE: ./node_modules/kujira.js/lib/esm/resources/connections.json
var connections = __webpack_require__(1526);
;// CONCATENATED MODULE: ./node_modules/kujira.js/lib/esm/ibc.js




const TRANSFER_CHANNELS = {
    testnet: {
        "channel-44": "terra2",
    },
    mainnet: {
        "channel-0": "cosmoshub",
        "channel-1": "juno",
        "channel-3": "osmosis",
        "channel-5": "terra2",
        "channel-6": "cryptoorgchain",
        "channel-7": "stargaze",
        "channel-9": "axelar",
        "channel-10": "secretnetwork",
        "channel-13": "persistence",
        "channel-14": "band",
        "channel-15": "bitsong",
        "channel-16": "cerberus",
        "channel-17": "chihuahua",
        "channel-18": "comdex",
        "channel-19": "lum",
        "channel-20": "vidulum",
        "channel-21": "emoney",
        "channel-23": "evmos",
        "channel-27": "okexchain",
        "channel-32": "stride",
        "channel-46": "carbon",
        "channel-50": "gravitybridge",
        "channel-51": "planq",
        "channel-54": "injective",
        "channel-55": "mars",
        "channel-58": "migaloo",
        "channel-59": "sentinel",
        "channel-60": "fetch-ai",
        "channel-61": "agoric",
        "channel-62": "noble",
        "channel-63": "stafihub",
        "channel-64": "akash",
        "channel-65": "assetmantle",
        "channel-67": "crescent",
        "channel-68": "regen",
        "channel-69": "sommelier",
        "channel-70": "omniflixhub",
        "channel-71": "terra",
        "channel-75": "neutron",
        "channel-89": "teritori",
        "channel-95": "kava",
        "channel-99": "archway",
        "channel-102": "umee",
        "channel-113": "gateway",
        "channel-115": "realio",
        "channel-116": "nomic",
        "channel-117": "celestia",
        "channel-118": "dydx",
        "channel-119": "furya",
    },
};
const CHAINS = [
    {
        $schema: "../chain.schema.json",
        chain_name: "dydx",
        status: "live",
        website: "https://dydx.exchange/",
        network_type: "mainnet",
        pretty_name: "dYdX Protocol",
        chain_id: "dydx-mainnet-1",
        bech32_prefix: "dydx",
        daemon_name: "dydxprotocold",
        node_home: "$HOME/.dydxprotocol",
        key_algos: ["secp256k1"],
        slip44: 118,
        fees: {
            fee_tokens: [
                {
                    denom: "adydx",
                    fixed_min_gas_price: 12500000000,
                    low_gas_price: 12500000000,
                    average_gas_price: 12500000000,
                    high_gas_price: 20000000000,
                },
                {
                    denom: "ibc/8E27BA2D5493AF5636760E354E46004562C46AB7EC0CC4C1CA14E9E20E2545B5",
                    fixed_min_gas_price: 0.025,
                    low_gas_price: 0.025,
                    average_gas_price: 0.025,
                    high_gas_price: 0.03,
                },
            ],
        },
        staking: {
            staking_tokens: [
                {
                    denom: "adydx",
                },
            ],
        },
        codebase: {
            git_repo: "https://github.com/dydxprotocol/v4-chain/",
            recommended_version: "v1.0.1",
            compatible_versions: ["v1.0.0", "v1.0.1"],
            cosmos_sdk_version: "v0.47.4",
            cosmwasm_enabled: false,
            genesis: {
                genesis_url: "https://raw.githubusercontent.com/dydxopsdao/networks/main/dydx-mainnet-1/genesis.json",
            },
            versions: [
                {
                    name: "v1",
                    recommended_version: "v1.0.1",
                    compatible_versions: ["v1.0.0", "v1.0.1"],
                    cosmos_sdk_version: "v0.47.4",
                },
            ],
        },
        logo_URIs: {
            png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/dydx/images/dydx.png",
            svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/dydx/images/dydx.svg",
        },
        peers: {
            seeds: [
                {
                    id: "20e1000e88125698264454a884812746c2eb4807",
                    address: "seeds.lavenderfive.com:23856",
                    provider: "Lavender.Five Nodes 🐝",
                },
                {
                    id: "ebc272824924ea1a27ea3183dd0b9ba713494f83",
                    address: "dydx-mainnet-seed.autostake.com:27366",
                    provider: "AutoStake 🛡️ Slash Protected",
                },
                {
                    id: "65b740ee326c9260c30af1f044e9cda63c73f7c1",
                    address: "seeds.kingnodes.net:23856",
                    provider: "Kingnodes",
                },
                {
                    id: "4c30c8a95e26b07b249813b677caab28bf0c54eb",
                    address: "rpc.dydx.nodestake.top:666",
                    provider: "NodeStake",
                },
                {
                    id: "400f3d9e30b69e78a7fb891f60d76fa3c73f0ecc",
                    address: "dydx.rpc.kjnodes.com:17059",
                    provider: "kjnodes",
                },
                {
                    id: "e1b058e5cfa2b836ddaa496b10911da62dcf182e",
                    address: "dydx-seed-de.allnodes.me:26656",
                    provider: "Allnodes ⚡️ Nodes & Staking",
                },
                {
                    id: "e726816f42831689eab9378d5d577f1d06d25716",
                    address: "dydx-seed-us.allnodes.me:26656",
                    provider: "Allnodes ⚡️ Nodes & Staking",
                },
                {
                    id: "e726816f42831689eab9378d5d577f1d06d25716",
                    address: "seeds.kingnodes.net:23856",
                    provider: "Kingnodes",
                },
                {
                    id: "4f20c3e303c9515051b6276aeb89c0b88ee79f8f",
                    address: "seed.dydx.cros-nest.com:26656",
                    provider: "Crosnest",
                },
            ],
            persistent_peers: [
                {
                    id: "ebc272824924ea1a27ea3183dd0b9ba713494f83",
                    address: "dydx-mainnet-peer.autostake.com:27366",
                    provider: "AutoStake 🛡️ Slash Protected",
                },
            ],
        },
        apis: {
            rpc: [
                {
                    address: "https://dydx-rpc.lavenderfive.com:443",
                    provider: "Lavender.Five Nodes 🐝",
                },
                {
                    address: "https://dydx-mainnet-rpc.autostake.com:443",
                    provider: "AutoStake 🛡️ Slash Protected",
                },
                {
                    address: "https://rpc-dydx.ecostake.com:443",
                    provider: "ecostake",
                },
                {
                    address: "https://rpc.dydx.nodestake.top:443",
                    provider: "NodeStake",
                },
                {
                    address: "https://rpc-dydx.cosmos-spaces.cloud",
                    provider: "Cosmos Spaces",
                },
                {
                    address: "https://dydx.rpc.kjnodes.com:443",
                    provider: "kjnodes",
                },
                {
                    address: "https://dydx-rpc.publicnode.com:443",
                    provider: "Allnodes ⚡️ Nodes & Staking",
                },
                {
                    address: "https://dydx-rpc.kingnodes.com:443",
                    provider: "Kingnodes",
                },
            ],
            rest: [
                {
                    address: "https://dydx-api.lavenderfive.com:443",
                    provider: "Lavender.Five Nodes 🐝",
                },
                {
                    address: "https://dydx-mainnet-lcd.autostake.com:443",
                    provider: "AutoStake 🛡️ Slash Protected",
                },
                {
                    address: "https://rest-dydx.ecostake.com:443",
                    provider: "ecostake",
                },
                {
                    address: "https://api-dydx.cosmos-spaces.cloud",
                    provider: "Cosmos Spaces",
                },
                {
                    address: "https://api.dydx.nodestake.top:443",
                    provider: "NodeStake",
                },
                {
                    address: "https://dydx.api.kjnodes.com:443",
                    provider: "kjnodes",
                },
                {
                    address: "https://dydx-rest.publicnode.com",
                    provider: "Allnodes ⚡️ Nodes & Staking",
                },
                {
                    address: "https://dydx-rest.kingnodes.com:443",
                    provider: "Kingnodes",
                },
            ],
            grpc: [
                {
                    address: "https://dydx-grpc.lavenderfive.com",
                    provider: "Lavender.Five Nodes 🐝",
                },
                {
                    address: "dydx-mainnet-grpc.autostake.com:443",
                    provider: "AutoStake 🛡️ Slash Protected",
                },
                {
                    address: "https://grpc.dydx.nodestake.top",
                    provider: "NodeStake",
                },
                {
                    address: "dydx.grpc.kjnodes.com:443",
                    provider: "kjnodes",
                },
                {
                    address: "grpc-dydx.cosmos-spaces.cloud:4990",
                    provider: "Cosmos Spaces",
                },
                {
                    address: "dydx-grpc.publicnode.com:443",
                    provider: "Allnodes ⚡️ Nodes & Staking",
                },
                {
                    address: "https://dydx-grpc.kingnodes.com:443",
                    provider: "Kingnodes",
                },
            ],
        },
        explorers: [
            {
                kind: "mintscan",
                url: "https://www.mintscan.io/dydx",
                tx_page: "https://www.mintscan.io/dydx/txs/${txHash}",
                account_page: "https://www.mintscan.io/dydx/account/${accountAddress}",
            },
            {
                kind: "NodeStake",
                url: "https://explorer.nodestake.top/dydx/",
                tx_page: "https://explorer.nodestake.top/dydx/txs/${txHash}",
                account_page: "https://explorer.nodestake.top/dydx/account/${accountAddress}",
            },
        ],
        images: [
            {
                png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/dydx/images/dydx.png",
                svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/dydx/images/dydx.svg",
            },
        ],
        assets: [
            {
                description: "The native staking token of dYdX Protocol.",
                denom_units: [
                    {
                        denom: "adydx",
                        exponent: 0,
                    },
                    {
                        denom: "dydx",
                        exponent: 18,
                    },
                ],
                base: "adydx",
                name: "dYdX",
                display: "dydx",
                symbol: "DYDX",
                logo_URIs: {
                    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/dydx/images/dydx.png",
                    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/dydx/images/dydx.svg",
                },
                coingecko_id: "dydx",
                images: [
                    {
                        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/dydx/images/dydx.png",
                        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/dydx/images/dydx.svg",
                    },
                    {
                        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/dydx/images/dydx-circle.svg",
                        theme: {
                            circle: true,
                        },
                    },
                ],
            },
            {
                description: "Noble USDC on dYdX Protocol.",
                denom_units: [
                    {
                        denom: "ibc/8E27BA2D5493AF5636760E354E46004562C46AB7EC0CC4C1CA14E9E20E2545B5",
                        exponent: 0,
                    },
                    {
                        denom: "usdc",
                        exponent: 18,
                    },
                ],
                type_asset: "ics20",
                base: "ibc/8E27BA2D5493AF5636760E354E46004562C46AB7EC0CC4C1CA14E9E20E2545B5",
                name: "Noble USDC",
                display: "usdc",
                symbol: "USDC",
                traces: [
                    {
                        type: "ibc",
                        counterparty: {
                            chain_name: "noble",
                            base_denom: "uusdc",
                            channel_id: "channel-33",
                        },
                        chain: {
                            channel_id: "channel-0",
                            path: "transfer/channel-0",
                        },
                    },
                ],
                images: [
                    {
                        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/noble/images/USDCoin.png",
                        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/noble/images/USDCoin.svg",
                    },
                ],
                logo_URIs: {
                    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/noble/images/USDCoin.png",
                    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/noble/images/USDCoin.svg",
                },
            },
        ],
    },
    {
        $schema: "../chain.schema.json",
        chain_name: "celestia",
        chain_id: "celestia",
        pretty_name: "Celestia",
        status: "live",
        network_type: "mainnet",
        bech32_prefix: "celestia",
        daemon_name: "celestia-appd",
        node_home: "$HOME/.celestia-app",
        key_algos: ["secp256k1"],
        slip44: 118,
        assets: [
            {
                description: "",
                denom_units: [
                    {
                        denom: "utia",
                        exponent: 0,
                    },
                    {
                        denom: "tia",
                        exponent: 6,
                    },
                ],
                base: "utia",
                name: "Celestia",
                display: "tia",
                symbol: "TIA",
                logo_URIs: {
                    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/celestia/images/celestia.svg",
                    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/celestia/images/celestia.png",
                },
                images: [
                    {
                        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/celestia/images/celestia.svg",
                        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/celestia/images/celestia.png",
                    },
                ],
            },
        ],
        fees: {
            fee_tokens: [
                {
                    denom: "utia",
                    fixed_min_gas_price: 0,
                    low_gas_price: 0.1,
                    average_gas_price: 0.2,
                    high_gas_price: 0.4,
                },
            ],
        },
        staking: {
            staking_tokens: [
                {
                    denom: "utia",
                },
            ],
        },
        codebase: {
            git_repo: "https://github.com/celestiaorg/celestia-app",
            recommended_version: "v1.3.0",
            compatible_versions: ["v1.3.0"],
            genesis: {
                genesis_url: "https://raw.githubusercontent.com/celestiaorg/networks/master/celestia/genesis.json",
            },
            versions: [
                {
                    name: "v1.3.0",
                    recommended_version: "v1.3.0",
                    compatible_versions: ["v1.3.0"],
                },
            ],
        },
        peers: {
            seeds: [
                {
                    id: "e6116822e1a5e283d8a85d3ec38f4d232274eaf3",
                    address: "consensus-full-seed-1.celestia-bootstrap.net:26656",
                    provider: "Lunar Oasis",
                },
                {
                    id: "cf7ac8b19ff56a9d47c75551bd4864883d1e24b5",
                    address: "consensus-full-seed-1.celestia-bootstrap.net:26656",
                    provider: "Lunar Oasis",
                },
                {
                    id: "ebc272824924ea1a27ea3183dd0b9ba713494f83",
                    address: "celestia-mainnet-seed.autostake.com:27206",
                    provider: "AutoStake 🛡️ Slash Protected",
                },
            ],
            persistent_peers: [
                {
                    id: "ebc272824924ea1a27ea3183dd0b9ba713494f83",
                    address: "celestia-mainnet-peer.autostake.com:27206",
                    provider: "AutoStake 🛡️ Slash Protected",
                },
            ],
        },
        apis: {
            rpc: [
                {
                    address: "https://public-celestia-rpc.numia.xyz",
                    provider: "Numia",
                },
                {
                    address: "https://celestia-mainnet-rpc.autostake.com:443",
                    provider: "AutoStake 🛡️ Slash Protected",
                },
                {
                    address: "https://celestia-rpc.mesa.newmetric.xyz",
                    provider: "Newmetric",
                },
                {
                    address: "https://rpc.lunaroasis.net",
                    provider: "Lunar Oasis",
                },
                {
                    address: "https://rpc.celestia.nodestake.top",
                    provider: "NodeStake",
                },
            ],
            rest: [
                {
                    address: "https://public-celestia-lcd.numia.xyz",
                    provider: "Numia",
                },
                {
                    address: "https://celestia-mainnet-lcd.autostake.com:443",
                    provider: "AutoStake 🛡️ Slash Protected",
                },
                {
                    address: "https://celestia-rest.mesa.newmetric.xyz",
                    provider: "Newmetric",
                },
                {
                    address: "https://api.lunaroasis.net",
                    provider: "Lunar Oasis",
                },
                {
                    address: "https://api.celestia.nodestake.top",
                    provider: "NodeStake",
                },
            ],
            grpc: [
                {
                    address: "https://grpc.celestia.nodestake.top",
                    provider: "NodeStake",
                },
                {
                    address: "celestia-mainnet-grpc.autostake.com:443",
                    provider: "AutoStake 🛡️ Slash Protected",
                },
            ],
        },
        explorers: [
            {
                kind: "Mintscan",
                url: "https://mintscan.io/celestia",
                tx_page: "https://mintscan.io/celestia/txs/${txHash}",
            },
            {
                kind: "NodeStake",
                url: "https://explorer.nodestake.top/celestia/",
                tx_page: "https://explorer.nodestake.top/celestia/txs/${txHash}",
                account_page: "https://explorer.nodestake.top/celestia/account/${accountAddress}",
            },
        ],
    },
    {
        $schema: "../chain.schema.json",
        chain_name: "archway",
        status: "live",
        network_type: "mainnet",
        website: "https://archway.io/",
        pretty_name: "Archway",
        chain_id: "archway-1",
        bech32_prefix: "archway",
        daemon_name: "archwayd",
        node_home: "$HOME/.archway",
        key_algos: ["secp256k1"],
        slip44: 118,
        fees: {
            fee_tokens: [
                {
                    denom: "aarch",
                    fixed_min_gas_price: 900000000000,
                    low_gas_price: 1000000000000,
                    average_gas_price: 1500000000000,
                    high_gas_price: 2000000000000,
                },
            ],
        },
        staking: {
            staking_tokens: [
                {
                    denom: "aarch",
                },
            ],
            lock_duration: {
                time: "1209600s",
            },
        },
        codebase: {
            git_repo: "https://github.com/archway-network/archway",
            recommended_version: "v1.0.0",
            compatible_versions: ["v1.0.0"],
            binaries: {
                "linux/amd64": "https://github.com/archway-network/archway/releases/download/v1.0.0/archwayd_linux_amd64",
                "linux/arm64": "https://github.com/archway-network/archway/releases/download/v1.0.0/archwayd_linux_arm64",
            },
            cosmos_sdk_version: "v0.45.16",
            consensus: {
                type: "tendermint",
                version: "v0.34.27",
            },
            cosmwasm_version: "v0.32.0",
            cosmwasm_enabled: true,
            ibc_go_version: "v4.3.1",
            genesis: {
                genesis_url: "https://github.com/archway-network/networks/raw/main/archway-1/genesis/genesis.json.gz",
            },
            versions: [
                {
                    name: "v1.0.0",
                    recommended_version: "v1.0.0",
                    compatible_versions: ["v1.0.0"],
                    tag: "v1.0.0",
                    height: 1,
                    consensus: {
                        type: "tendermint",
                        version: "v0.34.27",
                    },
                    cosmos_sdk_version: "v0.45.16",
                    cosmwasm_version: "v0.32.0",
                    cosmwasm_enabled: true,
                    ibc_go_version: "v4.3.1",
                    binaries: {
                        "linux/amd64": "https://github.com/archway-network/archway/releases/download/v1.0.0/archwayd_linux_amd64",
                        "linux/arm64": "https://github.com/archway-network/archway/releases/download/v1.0.0/archwayd_linux_arm64",
                    },
                },
            ],
        },
        logo_URIs: {
            png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/archway/images/archway.png",
            svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/archway/images/archway.svg",
        },
        peers: {
            seeds: [
                {
                    id: "3ba7bf08f00e228026177e9cdc027f6ef6eb2b39",
                    address: "35.232.234.58:26656",
                    provider: "Archway Foundation",
                },
                {
                    id: "b308dda41e4db2ee00852d91846f981c49943d46",
                    address: "161.97.96.91:46656",
                    provider: "AM Solutions",
                },
                {
                    id: "d2362ebcdd562500ac8c4cfa2214a89ad811033c",
                    address: "seeds.whispernode.com:11556",
                    provider: "WhisperNode🤐",
                },
            ],
        },
        apis: {
            rpc: [
                {
                    address: "https://rpc.mainnet.archway.io",
                    provider: "Archway Foundation",
                },
                {
                    address: "https://m-archway.rpc.utsa.tech",
                    provider: "𝐥𝐞𝐬𝐧𝐢𝐤 | 𝐔𝐓𝐒𝐀",
                },
                {
                    address: "https://rpc-1.archway.nodes.guru",
                    provider: "Nodes.Guru",
                },
                {
                    address: "https://archway.rpc.silknodes.io/",
                    provider: "Silk Nodes",
                },
                {
                    address: "https://archway.rpc.kjnodes.com",
                    provider: "kjnodes",
                },
                {
                    address: "https://rpc-archway.cryptech.com.ua",
                    provider: "cryptech",
                },
                {
                    address: "https://rpc.archway.nodestake.top",
                    provider: "NodeStake",
                },
                {
                    address: "https://rpc-archway.theamsolutions.info",
                    provider: "AM Solutions",
                },
                {
                    address: "https://rpc-archway.whispernode.com",
                    provider: "WhisperNode🤐",
                },
            ],
            rest: [
                {
                    address: "https://api.mainnet.archway.io",
                    provider: "Archway Foundation",
                },
                {
                    address: "https://m-archway.api.utsa.tech",
                    provider: "𝐥𝐞𝐬𝐧𝐢𝐤 | 𝐔𝐓𝐒𝐀",
                },
                {
                    address: "https://api-1.archway.nodes.guru",
                    provider: "Nodes.Guru",
                },
                {
                    address: "https://archway.api.silknodes.io/",
                    provider: "Silk Nodes",
                },
                {
                    address: "https://archway.api.kjnodes.com",
                    provider: "kjnodes",
                },
                {
                    address: "https://api-archway.cryptech.com.ua",
                    provider: "cryptech",
                },
                {
                    address: "https://api.archway.nodestake.top",
                    provider: "NodeStake",
                },
                {
                    address: "https://rest-archway.theamsolutions.info",
                    provider: "AM Solutions",
                },
                {
                    address: "https://lcd-archway.whispernode.com:443",
                    provider: "WhisperNode🤐",
                },
            ],
            grpc: [
                {
                    address: "grpc.mainnet.archway.io:443",
                    provider: "Archway Foundation",
                },
                {
                    address: "grpc-1.archway.nodes.guru:10690",
                    provider: "Nodes.Guru",
                },
                {
                    address: "archway.grpc.kjnodes.com:15690",
                    provider: "kjnodes",
                },
                {
                    address: "https://grpc-archway.cryptech.com.ua",
                    provider: "cryptech",
                },
                {
                    address: "https://grpc.archway.nodestake.top:443",
                    provider: "NodeStake",
                },
                {
                    address: "grpc-archway.theamsolutions.info:443",
                    provider: "AM Solutions",
                },
            ],
        },
        explorers: [
            {
                kind: "Nodes Guru",
                url: "https://archway.explorers.guru/",
                tx_page: "https://archway.explorers.guru/transaction/${txHash}",
                account_page: "https://archway.explorers.guru/account/${accountAddress}",
            },
            {
                kind: "𝐥𝐞𝐬𝐧𝐢𝐤 | 𝐔𝐓𝐒𝐀",
                url: "https://exp.utsa.tech/archway",
                tx_page: "https://exp.utsa.tech/archway/tx/${txHash}",
                account_page: "https://exp.utsa.tech/archway/account/${accountAddress}",
            },
            {
                kind: "Mintscan",
                url: "https://mintscan.io/archway/",
                tx_page: "https://mintscan.io/archway/txs/${txHash}",
                account_page: "https://mintscan.io/archway/account/${accountAddress}",
            },
            {
                kind: "Silk Nodes",
                url: "https://explorer.silknodes.io/archway",
                tx_page: "https://explorer.silknodes.io/archway/tx/${txHash}",
                account_page: "https://explorer.silknodes.io/archway/account/${accountAddress}",
            },
            {
                kind: "NodeStake Explorer",
                url: "https://explorer.nodestake.top/archway/",
                tx_page: "https://explorer.nodestake.top/archway/txs/${txHash}",
                account_page: "https://explorer.nodestake.top/archway/account/${accountAddress}",
            },
            {
                kind: "Exploreme",
                url: "https://archway.exploreme.pro/",
                tx_page: "https://archway.exploreme.pro/transaction/${txHash}",
                account_page: "https://archway.exploreme.pro/account/${accountAddress}",
            },
        ],
        assets: [
            {
                description: "The native token of Archway network",
                denom_units: [
                    {
                        denom: "aarch",
                        exponent: 0,
                    },
                    {
                        denom: "uarch",
                        exponent: 12,
                    },
                    {
                        denom: "arch",
                        exponent: 18,
                    },
                ],
                base: "aarch",
                name: "Archway",
                display: "arch",
                symbol: "ARCH",
                logo_URIs: {
                    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/archway/images/archway.png",
                    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/archway/images/archway.svg",
                },
                coingecko_id: "archway",
            },
        ],
    },
    {
        $schema: "../chain.schema.json",
        chain_name: "furya",
        status: "live",
        network_type: "mainnet",
        website: "https://furya.xyz/",
        pretty_name: "furya",
        chain_id: "furya-1",
        daemon_name: "furyad",
        node_home: "$HOME/.furyad",
        bech32_prefix: "furya",
        slip44: 118,
        fees: {
            fee_tokens: [
                {
                    denom: "ufury",
                    low_gas_price: 0,
                    average_gas_price: 0.25,
                    high_gas_price: 0.5,
                },
            ],
        },
        staking: {
            staking_tokens: [
                {
                    denom: "ufury",
                },
            ],
        },
        codebase: {
            git_repo: "https://github.com/furysport/furya-chain",
            recommended_version: "v1.0.0",
            compatible_versions: ["v1.0.0"],
            genesis: {
                genesis_url: "https://github.com/furysport/furya-chain/blob/main/network/mainnet/genesis.json",
            },
            versions: [
                {
                    name: "v1.0.0",
                    recommended_version: "v1.0.0",
                    compatible_versions: ["v1.0.0"],
                },
            ],
        },
        logo_URIs: {
            png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/furya/images/chain.png",
            svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/furya/images/chain.svg",
        },
        peers: {
            seeds: [
                {
                    id: "38f40db17cdae23ba3c2b0f7d5738b9d31d077aa",
                    address: "34.32.247.201:26656",
                    provider: "Furya",
                },
            ],
            persistent_peers: [
                {
                    id: "38f40db17cdae23ba3c2b0f7d5738b9d31d077aa",
                    address: "34.32.247.201:26656",
                    provider: "Furya",
                },
            ],
        },
        apis: {
            rpc: [
                {
                    address: "https://rpc.furya.xyz",
                    provider: "Furya Genesis Validator 🐝",
                },
            ],
            rest: [
                {
                    address: "https://api.furya.xyz",
                    provider: "Furya Genesis Validator 🐝",
                },
            ],
            grpc: [
                {
                    address: "grpc.furya.xyz:443",
                    provider: "Lavender.Five Nodes 🐝",
                },
            ],
        },
        explorers: [
            {
                kind: "Furya Explorer",
                url: "https://explorer.furya.xyz/",
                tx_page: "https://explorer.furya.xyz/txs/${txHash}",
                account_page: "https://explorer.furya.xyz/account/${accountAddress}",
            },
        ],
        images: [
            {
                png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/furya/images/chain.png",
                svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/furya/images/chain.svg",
            },
        ],
        assets: [
            {
                description: "The native token of Furya",
                denom_units: [
                    {
                        denom: "ufury",
                        exponent: 0,
                    },
                    {
                        denom: "fury",
                        exponent: 6,
                    },
                ],
                base: "ufury",
                name: "Furya",
                display: "fury",
                symbol: "FURY",
                logo_URIs: {
                    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/furya/images/ufury.png",
                    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/furya/images/ufury.svg",
                },
                images: [
                    {
                        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/furya/images/ufury.png",
                        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/furya/images/ufury.svg",
                    },
                ],
            },
        ],
    },
];
const IBC = {
    chains: main/* chains.reduce */.p5.reduce((a, v) => {
        var _a;
        const assets_ = ((_a = main/* assets.find */.Ll.find((a) => a.chain_name === v.chain_name)) === null || _a === void 0 ? void 0 : _a.assets) || [];
        const x = Object.assign(Object.assign({}, v), { assets: assets_ });
        const key = v.network_type === "mainnet" ? "mainnet" : "testnet";
        return Object.assign(Object.assign({}, a), { [key]: [...a[key], x] });
    }, { mainnet: CHAINS, testnet: [] }),
    connections: connections,
    channels: {
        mainnet: channels_namespaceObject.R.filter((x) => !!TRANSFER_CHANNELS.mainnet[x.channelId]),
        testnet: channels_namespaceObject.$.filter((x) => !!TRANSFER_CHANNELS.testnet[x.channelId]),
    },
    tokens: tokens,
};

;// CONCATENATED MODULE: ./node_modules/kujira.js/lib/esm/kns/auctions.js
var auctions_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class AuctionsQueryClient {
    constructor(client, contractAddress) {
        this.bidsByDomain = ({ domain, limit, startAfter, }) => auctions_awaiter(this, void 0, void 0, function* () {
            return this.client.queryContractSmart(this.contractAddress, {
                bids_by_domain: {
                    domain,
                    limit,
                    start_after: startAfter,
                },
            });
        });
        this.bidsByBidder = ({ bidder, limit, startAfter, }) => auctions_awaiter(this, void 0, void 0, function* () {
            return this.client.queryContractSmart(this.contractAddress, {
                bids_by_bidder: {
                    bidder,
                    limit,
                    start_after: startAfter,
                },
            });
        });
        this.auction = ({ domain }) => auctions_awaiter(this, void 0, void 0, function* () {
            return this.client.queryContractSmart(this.contractAddress, {
                auction: {
                    domain,
                },
            });
        });
        this.auctions = ({ limit, startAfter, state, }) => auctions_awaiter(this, void 0, void 0, function* () {
            return this.client.queryContractSmart(this.contractAddress, {
                auctions: {
                    limit,
                    start_after: startAfter,
                    state,
                },
            });
        });
        this.config = () => auctions_awaiter(this, void 0, void 0, function* () {
            return this.client.queryContractSmart(this.contractAddress, {
                config: {},
            });
        });
        this.client = client;
        this.contractAddress = contractAddress;
        this.bidsByDomain = this.bidsByDomain.bind(this);
        this.bidsByBidder = this.bidsByBidder.bind(this);
        this.auction = this.auction.bind(this);
        this.auctions = this.auctions.bind(this);
        this.config = this.config.bind(this);
    }
}
class AuctionsClient extends (/* unused pure expression or super */ null && (AuctionsQueryClient)) {
    constructor(client, sender, contractAddress) {
        super(client, contractAddress);
        this.placeBid = ({ domain, }, fee = "auto", memo, funds) => auctions_awaiter(this, void 0, void 0, function* () {
            return yield this.client.execute(this.sender, this.contractAddress, {
                place_bid: {
                    domain,
                },
            }, fee, memo, funds);
        });
        this.increaseBid = ({ domain, }, fee = "auto", memo, funds) => auctions_awaiter(this, void 0, void 0, function* () {
            return yield this.client.execute(this.sender, this.contractAddress, {
                increase_bid: {
                    domain,
                },
            }, fee, memo, funds);
        });
        this.withdrawBid = ({ domain, }, fee = "auto", memo, funds) => auctions_awaiter(this, void 0, void 0, function* () {
            return yield this.client.execute(this.sender, this.contractAddress, {
                withdraw_bid: {
                    domain,
                },
            }, fee, memo, funds);
        });
        this.claimAuction = ({ domain, }, fee = "auto", memo, funds) => auctions_awaiter(this, void 0, void 0, function* () {
            return yield this.client.execute(this.sender, this.contractAddress, {
                claim_auction: {
                    domain,
                },
            }, fee, memo, funds);
        });
        this.openAuction = (fee = "auto", memo, funds) => auctions_awaiter(this, void 0, void 0, function* () {
            return yield this.client.execute(this.sender, this.contractAddress, {
                open_auction: {},
            }, fee, memo, funds);
        });
        this.configure = ({ admin, canBid, denom, depositDuration, maxOpen, openDuration, registrar, }, fee = "auto", memo, funds) => auctions_awaiter(this, void 0, void 0, function* () {
            return yield this.client.execute(this.sender, this.contractAddress, {
                configure: {
                    admin,
                    can_bid: canBid,
                    denom,
                    deposit_duration: depositDuration,
                    max_open: maxOpen,
                    open_duration: openDuration,
                    registrar,
                },
            }, fee, memo, funds);
        });
        this.client = client;
        this.sender = sender;
        this.contractAddress = contractAddress;
        this.placeBid = this.placeBid.bind(this);
        this.increaseBid = this.increaseBid.bind(this);
        this.withdrawBid = this.withdrawBid.bind(this);
        this.claimAuction = this.claimAuction.bind(this);
        this.openAuction = this.openAuction.bind(this);
        this.configure = this.configure.bind(this);
    }
}

;// CONCATENATED MODULE: ./node_modules/kujira.js/lib/esm/kns/registrar.js
var registrar_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class RegistrarQueryClient {
    constructor(client, contractAddress) {
        this.ownerOf = ({ includeExpired, tokenId, }) => registrar_awaiter(this, void 0, void 0, function* () {
            return this.client.queryContractSmart(this.contractAddress, {
                owner_of: {
                    include_expired: includeExpired,
                    token_id: tokenId,
                },
            });
        });
        this.approval = ({ includeExpired, spender, tokenId, }) => registrar_awaiter(this, void 0, void 0, function* () {
            return this.client.queryContractSmart(this.contractAddress, {
                approval: {
                    include_expired: includeExpired,
                    spender,
                    token_id: tokenId,
                },
            });
        });
        this.approvals = ({ includeExpired, tokenId, }) => registrar_awaiter(this, void 0, void 0, function* () {
            return this.client.queryContractSmart(this.contractAddress, {
                approvals: {
                    include_expired: includeExpired,
                    token_id: tokenId,
                },
            });
        });
        this.allOperators = ({ includeExpired, limit, owner, startAfter, }) => registrar_awaiter(this, void 0, void 0, function* () {
            return this.client.queryContractSmart(this.contractAddress, {
                all_operators: {
                    include_expired: includeExpired,
                    limit,
                    owner,
                    start_after: startAfter,
                },
            });
        });
        this.numTokens = () => registrar_awaiter(this, void 0, void 0, function* () {
            return this.client.queryContractSmart(this.contractAddress, {
                num_tokens: {},
            });
        });
        this.contractInfo = () => registrar_awaiter(this, void 0, void 0, function* () {
            return this.client.queryContractSmart(this.contractAddress, {
                contract_info: {},
            });
        });
        this.nftInfo = ({ tokenId, }) => registrar_awaiter(this, void 0, void 0, function* () {
            return this.client.queryContractSmart(this.contractAddress, {
                nft_info: {
                    token_id: tokenId,
                },
            });
        });
        this.allNftInfo = ({ includeExpired, tokenId, }) => registrar_awaiter(this, void 0, void 0, function* () {
            return this.client.queryContractSmart(this.contractAddress, {
                all_nft_info: {
                    include_expired: includeExpired,
                    token_id: tokenId,
                },
            });
        });
        this.tokens = ({ limit, owner, startAfter, }) => registrar_awaiter(this, void 0, void 0, function* () {
            return this.client.queryContractSmart(this.contractAddress, {
                tokens: {
                    limit,
                    owner,
                    start_after: startAfter,
                },
            });
        });
        this.allTokens = ({ limit, startAfter, }) => registrar_awaiter(this, void 0, void 0, function* () {
            return this.client.queryContractSmart(this.contractAddress, {
                all_tokens: {
                    limit,
                    start_after: startAfter,
                },
            });
        });
        this.minter = () => registrar_awaiter(this, void 0, void 0, function* () {
            return this.client.queryContractSmart(this.contractAddress, {
                minter: {},
            });
        });
        this.config = () => registrar_awaiter(this, void 0, void 0, function* () {
            return this.client.queryContractSmart(this.contractAddress, {
                config: {},
            });
        });
        this.domainInfo = ({ name, }) => registrar_awaiter(this, void 0, void 0, function* () {
            return this.client.queryContractSmart(this.contractAddress, {
                domain_info: {
                    name,
                },
            });
        });
        this.client = client;
        this.contractAddress = contractAddress;
        this.ownerOf = this.ownerOf.bind(this);
        this.approval = this.approval.bind(this);
        this.approvals = this.approvals.bind(this);
        this.allOperators = this.allOperators.bind(this);
        this.numTokens = this.numTokens.bind(this);
        this.contractInfo = this.contractInfo.bind(this);
        this.nftInfo = this.nftInfo.bind(this);
        this.allNftInfo = this.allNftInfo.bind(this);
        this.tokens = this.tokens.bind(this);
        this.allTokens = this.allTokens.bind(this);
        this.minter = this.minter.bind(this);
        this.config = this.config.bind(this);
        this.domainInfo = this.domainInfo.bind(this);
    }
}
class RegistrarClient extends (/* unused pure expression or super */ null && (RegistrarQueryClient)) {
    constructor(client, sender, contractAddress) {
        super(client, contractAddress);
        this.transferNft = ({ recipient, tokenId, }, fee = "auto", memo, funds) => registrar_awaiter(this, void 0, void 0, function* () {
            return yield this.client.execute(this.sender, this.contractAddress, {
                transfer_nft: {
                    recipient,
                    token_id: tokenId,
                },
            }, fee, memo, funds);
        });
        this.sendNft = ({ contract, msg, tokenId, }, fee = "auto", memo, funds) => registrar_awaiter(this, void 0, void 0, function* () {
            return yield this.client.execute(this.sender, this.contractAddress, {
                send_nft: {
                    contract,
                    msg,
                    token_id: tokenId,
                },
            }, fee, memo, funds);
        });
        this.approve = ({ expires, spender, tokenId, }, fee = "auto", memo, funds) => registrar_awaiter(this, void 0, void 0, function* () {
            return yield this.client.execute(this.sender, this.contractAddress, {
                approve: {
                    expires,
                    spender,
                    token_id: tokenId,
                },
            }, fee, memo, funds);
        });
        this.revoke = ({ spender, tokenId, }, fee = "auto", memo, funds) => registrar_awaiter(this, void 0, void 0, function* () {
            return yield this.client.execute(this.sender, this.contractAddress, {
                revoke: {
                    spender,
                    token_id: tokenId,
                },
            }, fee, memo, funds);
        });
        this.approveAll = ({ expires, operator, }, fee = "auto", memo, funds) => registrar_awaiter(this, void 0, void 0, function* () {
            return yield this.client.execute(this.sender, this.contractAddress, {
                approve_all: {
                    expires,
                    operator,
                },
            }, fee, memo, funds);
        });
        this.revokeAll = ({ operator, }, fee = "auto", memo, funds) => registrar_awaiter(this, void 0, void 0, function* () {
            return yield this.client.execute(this.sender, this.contractAddress, {
                revoke_all: {
                    operator,
                },
            }, fee, memo, funds);
        });
        this.mint = ({ extension, owner, tokenId, tokenUri, }, fee = "auto", memo, funds) => registrar_awaiter(this, void 0, void 0, function* () {
            return yield this.client.execute(this.sender, this.contractAddress, {
                mint: {
                    extension,
                    owner,
                    token_id: tokenId,
                    token_uri: tokenUri,
                },
            }, fee, memo, funds);
        });
        this.burn = ({ tokenId, }, fee = "auto", memo, funds) => registrar_awaiter(this, void 0, void 0, function* () {
            return yield this.client.execute(this.sender, this.contractAddress, {
                burn: {
                    token_id: tokenId,
                },
            }, fee, memo, funds);
        });
        this.extension = ({ msg, }, fee = "auto", memo, funds) => registrar_awaiter(this, void 0, void 0, function* () {
            return yield this.client.execute(this.sender, this.contractAddress, {
                extension: {
                    msg,
                },
            }, fee, memo, funds);
        });
        this.client = client;
        this.sender = sender;
        this.contractAddress = contractAddress;
        this.transferNft = this.transferNft.bind(this);
        this.sendNft = this.sendNft.bind(this);
        this.approve = this.approve.bind(this);
        this.revoke = this.revoke.bind(this);
        this.approveAll = this.approveAll.bind(this);
        this.revokeAll = this.revokeAll.bind(this);
        this.mint = this.mint.bind(this);
        this.burn = this.burn.bind(this);
        this.extension = this.extension.bind(this);
    }
}

;// CONCATENATED MODULE: ./node_modules/kujira.js/lib/esm/kns/registry.js
var registry_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class RegistryQueryClient {
    constructor(client, contractAddress) {
        this.addr = ({ name, prefix, }) => registry_awaiter(this, void 0, void 0, function* () {
            return this.client.queryContractSmart(this.contractAddress, {
                addr: {
                    name,
                    prefix,
                },
            });
        });
        this.kujiraAddr = ({ addr }) => registry_awaiter(this, void 0, void 0, function* () {
            return this.client.queryContractSmart(this.contractAddress, {
                kujira_addr: {
                    addr,
                },
            });
        });
        this.name = ({ addr }) => registry_awaiter(this, void 0, void 0, function* () {
            return this.client.queryContractSmart(this.contractAddress, {
                name: {
                    addr,
                },
            });
        });
        this.record = ({ name }) => registry_awaiter(this, void 0, void 0, function* () {
            return this.client.queryContractSmart(this.contractAddress, {
                record: {
                    name,
                },
            });
        });
        this.resolver = ({ name }) => registry_awaiter(this, void 0, void 0, function* () {
            return this.client.queryContractSmart(this.contractAddress, {
                resolver: {
                    name,
                },
            });
        });
        this.client = client;
        this.contractAddress = contractAddress;
        this.addr = this.addr.bind(this);
        this.kujiraAddr = this.kujiraAddr.bind(this);
        this.name = this.name.bind(this);
        this.record = this.record.bind(this);
        this.resolver = this.resolver.bind(this);
    }
}
class RegistryClient extends (/* unused pure expression or super */ null && (RegistryQueryClient)) {
    constructor(client, sender, contractAddress) {
        super(client, contractAddress);
        this.setResolver = ({ admin, allowedKinds, name, }, fee = "auto", memo, funds) => registry_awaiter(this, void 0, void 0, function* () {
            return yield this.client.execute(this.sender, this.contractAddress, {
                set_resolver: {
                    admin,
                    allowed_kinds: allowedKinds,
                    name,
                },
            }, fee, memo, funds);
        });
        this.removeResolver = ({ name, }, fee = "auto", memo, funds) => registry_awaiter(this, void 0, void 0, function* () {
            return yield this.client.execute(this.sender, this.contractAddress, {
                remove_resolver: {
                    name,
                },
            }, fee, memo, funds);
        });
        this.setRecord = ({ data, kind, name, }, fee = "auto", memo, funds) => registry_awaiter(this, void 0, void 0, function* () {
            return yield this.client.execute(this.sender, this.contractAddress, {
                set_record: {
                    data,
                    kind,
                    name,
                },
            }, fee, memo, funds);
        });
        this.removeRecord = ({ name, }, fee = "auto", memo, funds) => registry_awaiter(this, void 0, void 0, function* () {
            return yield this.client.execute(this.sender, this.contractAddress, {
                remove_record: {
                    name,
                },
            }, fee, memo, funds);
        });
        this.setKujiraAddr = ({ name, }, fee = "auto", memo, funds) => registry_awaiter(this, void 0, void 0, function* () {
            return yield this.client.execute(this.sender, this.contractAddress, {
                set_kujira_addr: {
                    name,
                },
            }, fee, memo, funds);
        });
        this.client = client;
        this.sender = sender;
        this.contractAddress = contractAddress;
        this.setResolver = this.setResolver.bind(this);
        this.removeResolver = this.removeResolver.bind(this);
        this.setRecord = this.setRecord.bind(this);
        this.removeRecord = this.removeRecord.bind(this);
        this.setKujiraAddr = this.setKujiraAddr.bind(this);
    }
}

;// CONCATENATED MODULE: ./node_modules/kujira.js/lib/esm/kns/index.js




;// CONCATENATED MODULE: ./node_modules/kujira.js/lib/esm/local.js

const CONTRACTS = {
    [network_MAINNET]: {
        hub: "kujira1392dk7n69wj2gvz25ygtyz48w0lgtkrgay72c60vszhrrkkrtw9qzced2h",
        offer: "kujira1hpmasdua44u83h497p6wpu84dmmvafj82xd4jfky7z55vpf8a4rqd7qeat",
        trade: "kujira1hdydzhe7dfhw2vmfsrzu6dcw2aeuff4ja8wr5puqhsg8rlf44gvq6car5s",
        price: "kujira189qa4s2c8kyhcrf5e75fhmaa6g8ux2h76p06qx32cxgasy07mtqq9mudvh",
        profile: "kujira1tyqttr06k5hgrz95a508mu5euvjadtfyfaf4yu2hnh6tueswkvwsjy7290",
    },
};

// EXTERNAL MODULE: ./node_modules/kujira.js/node_modules/cosmjs-types/cosmos/authz/v1beta1/tx.js
var tx = __webpack_require__(10892);
// EXTERNAL MODULE: ./node_modules/kujira.js/node_modules/cosmjs-types/cosmos/bank/v1beta1/tx.js
var v1beta1_tx = __webpack_require__(59534);
// EXTERNAL MODULE: ./node_modules/kujira.js/node_modules/cosmjs-types/cosmos/distribution/v1beta1/tx.js
var distribution_v1beta1_tx = __webpack_require__(80798);
// EXTERNAL MODULE: ./node_modules/kujira.js/node_modules/cosmjs-types/cosmos/feegrant/v1beta1/tx.js
var feegrant_v1beta1_tx = __webpack_require__(57431);
// EXTERNAL MODULE: ./node_modules/kujira.js/node_modules/cosmjs-types/cosmos/gov/v1/tx.js
var v1_tx = __webpack_require__(13037);
// EXTERNAL MODULE: ./node_modules/kujira.js/node_modules/cosmjs-types/cosmos/gov/v1beta1/tx.js
var gov_v1beta1_tx = __webpack_require__(37429);
// EXTERNAL MODULE: ./node_modules/kujira.js/node_modules/cosmjs-types/cosmos/staking/v1beta1/tx.js
var staking_v1beta1_tx = __webpack_require__(70381);
// EXTERNAL MODULE: ./node_modules/kujira.js/node_modules/cosmjs-types/cosmos/vesting/v1beta1/tx.js
var vesting_v1beta1_tx = __webpack_require__(74762);
// EXTERNAL MODULE: ./node_modules/kujira.js/node_modules/cosmjs-types/cosmwasm/wasm/v1/tx.js
var wasm_v1_tx = __webpack_require__(63949);
// EXTERNAL MODULE: ./node_modules/kujira.js/node_modules/cosmjs-types/ibc/applications/transfer/v1/tx.js
var transfer_v1_tx = __webpack_require__(88313);
// EXTERNAL MODULE: ./node_modules/kujira.js/node_modules/cosmjs-types/google/protobuf/duration.js
var duration = __webpack_require__(9591);
// EXTERNAL MODULE: ./node_modules/kujira.js/node_modules/cosmjs-types/google/protobuf/timestamp.js
var timestamp = __webpack_require__(70147);
;// CONCATENATED MODULE: ./node_modules/kujira.js/lib/esm/alliance/params.js
/* eslint-disable */




const params_protobufPackage = "alliance.alliance";
function params_createBaseParams() {
    return {
        rewardDelayTime: undefined,
        takeRateClaimInterval: undefined,
        lastTakeRateClaimTime: undefined,
    };
}
const params_Params = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.rewardDelayTime !== undefined) {
            duration.Duration.encode(message.rewardDelayTime, writer.uint32(10).fork()).ldelim();
        }
        if (message.takeRateClaimInterval !== undefined) {
            duration.Duration.encode(message.takeRateClaimInterval, writer.uint32(18).fork()).ldelim();
        }
        if (message.lastTakeRateClaimTime !== undefined) {
            timestamp.Timestamp.encode(message.lastTakeRateClaimTime, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = params_createBaseParams();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.rewardDelayTime = duration.Duration.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.takeRateClaimInterval = duration.Duration.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.lastTakeRateClaimTime = timestamp.Timestamp.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            rewardDelayTime: isSet(object.rewardDelayTime)
                ? duration.Duration.fromJSON(object.rewardDelayTime)
                : undefined,
            takeRateClaimInterval: isSet(object.takeRateClaimInterval)
                ? duration.Duration.fromJSON(object.takeRateClaimInterval)
                : undefined,
            lastTakeRateClaimTime: isSet(object.lastTakeRateClaimTime)
                ? fromJsonTimestamp(object.lastTakeRateClaimTime)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.rewardDelayTime !== undefined &&
            (obj.rewardDelayTime = message.rewardDelayTime
                ? duration.Duration.toJSON(message.rewardDelayTime)
                : undefined);
        message.takeRateClaimInterval !== undefined &&
            (obj.takeRateClaimInterval = message.takeRateClaimInterval
                ? duration.Duration.toJSON(message.takeRateClaimInterval)
                : undefined);
        message.lastTakeRateClaimTime !== undefined &&
            (obj.lastTakeRateClaimTime = fromTimestamp(message.lastTakeRateClaimTime).toISOString());
        return obj;
    },
    fromPartial(object) {
        const message = params_createBaseParams();
        message.rewardDelayTime =
            object.rewardDelayTime !== undefined && object.rewardDelayTime !== null
                ? duration.Duration.fromPartial(object.rewardDelayTime)
                : undefined;
        message.takeRateClaimInterval =
            object.takeRateClaimInterval !== undefined &&
                object.takeRateClaimInterval !== null
                ? duration.Duration.fromPartial(object.takeRateClaimInterval)
                : undefined;
        message.lastTakeRateClaimTime =
            object.lastTakeRateClaimTime !== undefined &&
                object.lastTakeRateClaimTime !== null
                ? timestamp.Timestamp.fromPartial(object.lastTakeRateClaimTime)
                : undefined;
        return message;
    },
};
function createBaseRewardHistory() {
    return {
        denom: "",
        index: "",
    };
}
const RewardHistory = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.denom !== "") {
            writer.uint32(10).string(message.denom);
        }
        if (message.index !== "") {
            writer.uint32(18).string(message.index);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRewardHistory();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.denom = reader.string();
                    break;
                case 2:
                    message.index = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            denom: isSet(object.denom) ? String(object.denom) : "",
            index: isSet(object.index) ? String(object.index) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.denom !== undefined && (obj.denom = message.denom);
        message.index !== undefined && (obj.index = message.index);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseRewardHistory();
        message.denom = (_a = object.denom) !== null && _a !== void 0 ? _a : "";
        message.index = (_b = object.index) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};

;// CONCATENATED MODULE: ./node_modules/kujira.js/lib/esm/alliance/alliance.js
/* eslint-disable */





const alliance_protobufPackage = "alliance.alliance";
function createBaseRewardWeightRange() {
    return {
        min: "",
        max: "",
    };
}
const RewardWeightRange = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.min !== "") {
            writer.uint32(10).string(message.min);
        }
        if (message.max !== "") {
            writer.uint32(18).string(message.max);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRewardWeightRange();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.min = reader.string();
                    break;
                case 2:
                    message.max = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            min: isSet(object.min) ? String(object.min) : "",
            max: isSet(object.max) ? String(object.max) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.min !== undefined && (obj.min = message.min);
        message.max !== undefined && (obj.max = message.max);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseRewardWeightRange();
        message.min = (_a = object.min) !== null && _a !== void 0 ? _a : "";
        message.max = (_b = object.max) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
function createBaseAllianceAsset() {
    return {
        denom: "",
        rewardWeight: "",
        takeRate: "",
        totalTokens: "",
        totalValidatorShares: "",
        rewardStartTime: undefined,
        rewardChangeRate: "",
        rewardChangeInterval: undefined,
        lastRewardChangeTime: undefined,
        rewardWeightRange: undefined,
    };
}
const AllianceAsset = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.denom !== "") {
            writer.uint32(10).string(message.denom);
        }
        if (message.rewardWeight !== "") {
            writer.uint32(18).string(message.rewardWeight);
        }
        if (message.takeRate !== "") {
            writer.uint32(26).string(message.takeRate);
        }
        if (message.totalTokens !== "") {
            writer.uint32(34).string(message.totalTokens);
        }
        if (message.totalValidatorShares !== "") {
            writer.uint32(42).string(message.totalValidatorShares);
        }
        if (message.rewardStartTime !== undefined) {
            timestamp.Timestamp.encode(message.rewardStartTime, writer.uint32(50).fork()).ldelim();
        }
        if (message.rewardChangeRate !== "") {
            writer.uint32(58).string(message.rewardChangeRate);
        }
        if (message.rewardChangeInterval !== undefined) {
            duration.Duration.encode(message.rewardChangeInterval, writer.uint32(66).fork()).ldelim();
        }
        if (message.lastRewardChangeTime !== undefined) {
            timestamp.Timestamp.encode(message.lastRewardChangeTime, writer.uint32(74).fork()).ldelim();
        }
        if (message.rewardWeightRange !== undefined) {
            RewardWeightRange.encode(message.rewardWeightRange, writer.uint32(82).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAllianceAsset();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.denom = reader.string();
                    break;
                case 2:
                    message.rewardWeight = reader.string();
                    break;
                case 3:
                    message.takeRate = reader.string();
                    break;
                case 4:
                    message.totalTokens = reader.string();
                    break;
                case 5:
                    message.totalValidatorShares = reader.string();
                    break;
                case 6:
                    message.rewardStartTime = timestamp.Timestamp.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.rewardChangeRate = reader.string();
                    break;
                case 8:
                    message.rewardChangeInterval = duration.Duration.decode(reader, reader.uint32());
                    break;
                case 9:
                    message.lastRewardChangeTime = timestamp.Timestamp.decode(reader, reader.uint32());
                    break;
                case 10:
                    message.rewardWeightRange = RewardWeightRange.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            denom: isSet(object.denom) ? String(object.denom) : "",
            rewardWeight: isSet(object.rewardWeight)
                ? String(object.rewardWeight)
                : "",
            takeRate: isSet(object.takeRate) ? String(object.takeRate) : "",
            totalTokens: isSet(object.totalTokens) ? String(object.totalTokens) : "",
            totalValidatorShares: isSet(object.totalValidatorShares)
                ? String(object.totalValidatorShares)
                : "",
            rewardStartTime: isSet(object.rewardStartTime)
                ? fromJsonTimestamp(object.rewardStartTime)
                : undefined,
            rewardChangeRate: isSet(object.rewardChangeRate)
                ? String(object.rewardChangeRate)
                : "",
            rewardChangeInterval: isSet(object.rewardChangeInterval)
                ? duration.Duration.fromJSON(object.rewardChangeInterval)
                : undefined,
            lastRewardChangeTime: isSet(object.lastRewardChangeTime)
                ? fromJsonTimestamp(object.lastRewardChangeTime)
                : undefined,
            rewardWeightRange: isSet(object.rewardWeightRange)
                ? RewardWeightRange.fromJSON(object.rewardWeightRange)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.denom !== undefined && (obj.denom = message.denom);
        message.rewardWeight !== undefined &&
            (obj.rewardWeight = message.rewardWeight);
        message.takeRate !== undefined && (obj.takeRate = message.takeRate);
        message.totalTokens !== undefined &&
            (obj.totalTokens = message.totalTokens);
        message.totalValidatorShares !== undefined &&
            (obj.totalValidatorShares = message.totalValidatorShares);
        message.rewardStartTime !== undefined &&
            (obj.rewardStartTime = fromTimestamp(message.rewardStartTime).toISOString());
        message.rewardChangeRate !== undefined &&
            (obj.rewardChangeRate = message.rewardChangeRate);
        message.rewardChangeInterval !== undefined &&
            (obj.rewardChangeInterval = message.rewardChangeInterval
                ? duration.Duration.toJSON(message.rewardChangeInterval)
                : undefined);
        message.lastRewardChangeTime !== undefined &&
            (obj.lastRewardChangeTime = fromTimestamp(message.lastRewardChangeTime).toISOString());
        message.rewardWeightRange !== undefined &&
            (obj.rewardWeightRange = message.rewardWeightRange
                ? RewardWeightRange.toJSON(message.rewardWeightRange)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f;
        const message = createBaseAllianceAsset();
        message.denom = (_a = object.denom) !== null && _a !== void 0 ? _a : "";
        message.rewardWeight = (_b = object.rewardWeight) !== null && _b !== void 0 ? _b : "";
        message.takeRate = (_c = object.takeRate) !== null && _c !== void 0 ? _c : "";
        message.totalTokens = (_d = object.totalTokens) !== null && _d !== void 0 ? _d : "";
        message.totalValidatorShares = (_e = object.totalValidatorShares) !== null && _e !== void 0 ? _e : "";
        message.rewardStartTime =
            object.rewardStartTime !== undefined && object.rewardStartTime !== null
                ? timestamp.Timestamp.fromPartial(object.rewardStartTime)
                : undefined;
        message.rewardChangeRate = (_f = object.rewardChangeRate) !== null && _f !== void 0 ? _f : "";
        message.rewardChangeInterval =
            object.rewardChangeInterval !== undefined &&
                object.rewardChangeInterval !== null
                ? duration.Duration.fromPartial(object.rewardChangeInterval)
                : undefined;
        message.lastRewardChangeTime =
            object.lastRewardChangeTime !== undefined &&
                object.lastRewardChangeTime !== null
                ? timestamp.Timestamp.fromPartial(object.lastRewardChangeTime)
                : undefined;
        message.rewardWeightRange =
            object.rewardWeightRange !== undefined &&
                object.rewardWeightRange !== null
                ? RewardWeightRange.fromPartial(object.rewardWeightRange)
                : undefined;
        return message;
    },
};
function createBaseRewardWeightChangeSnapshot() {
    return {
        prevRewardWeight: "",
        rewardHistories: [],
    };
}
const RewardWeightChangeSnapshot = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.prevRewardWeight !== "") {
            writer.uint32(10).string(message.prevRewardWeight);
        }
        for (const v of message.rewardHistories) {
            RewardHistory.encode(v, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRewardWeightChangeSnapshot();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.prevRewardWeight = reader.string();
                    break;
                case 2:
                    message.rewardHistories.push(RewardHistory.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            prevRewardWeight: isSet(object.prevRewardWeight)
                ? String(object.prevRewardWeight)
                : "",
            rewardHistories: Array.isArray(object === null || object === void 0 ? void 0 : object.rewardHistories)
                ? object.rewardHistories.map((e) => RewardHistory.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        message.prevRewardWeight !== undefined &&
            (obj.prevRewardWeight = message.prevRewardWeight);
        if (message.rewardHistories) {
            obj.rewardHistories = message.rewardHistories.map((e) => e ? RewardHistory.toJSON(e) : undefined);
        }
        else {
            obj.rewardHistories = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseRewardWeightChangeSnapshot();
        message.prevRewardWeight = (_a = object.prevRewardWeight) !== null && _a !== void 0 ? _a : "";
        message.rewardHistories =
            ((_b = object.rewardHistories) === null || _b === void 0 ? void 0 : _b.map((e) => RewardHistory.fromPartial(e))) || [];
        return message;
    },
};

;// CONCATENATED MODULE: ./node_modules/kujira.js/lib/esm/alliance/gov.js
/* eslint-disable */




const gov_protobufPackage = "alliance.alliance";
function createBaseMsgCreateAllianceProposal() {
    return {
        title: "",
        description: "",
        denom: "",
        rewardWeight: "",
        takeRate: "",
        rewardChangeRate: "",
        rewardChangeInterval: undefined,
        rewardWeightRange: undefined,
    };
}
const MsgCreateAllianceProposal = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.title !== "") {
            writer.uint32(10).string(message.title);
        }
        if (message.description !== "") {
            writer.uint32(18).string(message.description);
        }
        if (message.denom !== "") {
            writer.uint32(26).string(message.denom);
        }
        if (message.rewardWeight !== "") {
            writer.uint32(34).string(message.rewardWeight);
        }
        if (message.takeRate !== "") {
            writer.uint32(42).string(message.takeRate);
        }
        if (message.rewardChangeRate !== "") {
            writer.uint32(50).string(message.rewardChangeRate);
        }
        if (message.rewardChangeInterval !== undefined) {
            duration.Duration.encode(message.rewardChangeInterval, writer.uint32(58).fork()).ldelim();
        }
        if (message.rewardWeightRange !== undefined) {
            RewardWeightRange.encode(message.rewardWeightRange, writer.uint32(66).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgCreateAllianceProposal();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.title = reader.string();
                    break;
                case 2:
                    message.description = reader.string();
                    break;
                case 3:
                    message.denom = reader.string();
                    break;
                case 4:
                    message.rewardWeight = reader.string();
                    break;
                case 5:
                    message.takeRate = reader.string();
                    break;
                case 6:
                    message.rewardChangeRate = reader.string();
                    break;
                case 7:
                    message.rewardChangeInterval = duration.Duration.decode(reader, reader.uint32());
                    break;
                case 8:
                    message.rewardWeightRange = RewardWeightRange.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            title: isSet(object.title) ? String(object.title) : "",
            description: isSet(object.description) ? String(object.description) : "",
            denom: isSet(object.denom) ? String(object.denom) : "",
            rewardWeight: isSet(object.rewardWeight)
                ? String(object.rewardWeight)
                : "",
            takeRate: isSet(object.takeRate) ? String(object.takeRate) : "",
            rewardChangeRate: isSet(object.rewardChangeRate)
                ? String(object.rewardChangeRate)
                : "",
            rewardChangeInterval: isSet(object.rewardChangeInterval)
                ? duration.Duration.fromJSON(object.rewardChangeInterval)
                : undefined,
            rewardWeightRange: isSet(object.rewardWeightRange)
                ? RewardWeightRange.fromJSON(object.rewardWeightRange)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.title !== undefined && (obj.title = message.title);
        message.description !== undefined &&
            (obj.description = message.description);
        message.denom !== undefined && (obj.denom = message.denom);
        message.rewardWeight !== undefined &&
            (obj.rewardWeight = message.rewardWeight);
        message.takeRate !== undefined && (obj.takeRate = message.takeRate);
        message.rewardChangeRate !== undefined &&
            (obj.rewardChangeRate = message.rewardChangeRate);
        message.rewardChangeInterval !== undefined &&
            (obj.rewardChangeInterval = message.rewardChangeInterval
                ? duration.Duration.toJSON(message.rewardChangeInterval)
                : undefined);
        message.rewardWeightRange !== undefined &&
            (obj.rewardWeightRange = message.rewardWeightRange
                ? RewardWeightRange.toJSON(message.rewardWeightRange)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f;
        const message = createBaseMsgCreateAllianceProposal();
        message.title = (_a = object.title) !== null && _a !== void 0 ? _a : "";
        message.description = (_b = object.description) !== null && _b !== void 0 ? _b : "";
        message.denom = (_c = object.denom) !== null && _c !== void 0 ? _c : "";
        message.rewardWeight = (_d = object.rewardWeight) !== null && _d !== void 0 ? _d : "";
        message.takeRate = (_e = object.takeRate) !== null && _e !== void 0 ? _e : "";
        message.rewardChangeRate = (_f = object.rewardChangeRate) !== null && _f !== void 0 ? _f : "";
        message.rewardChangeInterval =
            object.rewardChangeInterval !== undefined &&
                object.rewardChangeInterval !== null
                ? duration.Duration.fromPartial(object.rewardChangeInterval)
                : undefined;
        message.rewardWeightRange =
            object.rewardWeightRange !== undefined &&
                object.rewardWeightRange !== null
                ? RewardWeightRange.fromPartial(object.rewardWeightRange)
                : undefined;
        return message;
    },
};
function createBaseMsgUpdateAllianceProposal() {
    return {
        title: "",
        description: "",
        denom: "",
        rewardWeight: "",
        takeRate: "",
        rewardChangeRate: "",
        rewardChangeInterval: undefined,
    };
}
const MsgUpdateAllianceProposal = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.title !== "") {
            writer.uint32(10).string(message.title);
        }
        if (message.description !== "") {
            writer.uint32(18).string(message.description);
        }
        if (message.denom !== "") {
            writer.uint32(26).string(message.denom);
        }
        if (message.rewardWeight !== "") {
            writer.uint32(34).string(message.rewardWeight);
        }
        if (message.takeRate !== "") {
            writer.uint32(42).string(message.takeRate);
        }
        if (message.rewardChangeRate !== "") {
            writer.uint32(50).string(message.rewardChangeRate);
        }
        if (message.rewardChangeInterval !== undefined) {
            duration.Duration.encode(message.rewardChangeInterval, writer.uint32(58).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgUpdateAllianceProposal();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.title = reader.string();
                    break;
                case 2:
                    message.description = reader.string();
                    break;
                case 3:
                    message.denom = reader.string();
                    break;
                case 4:
                    message.rewardWeight = reader.string();
                    break;
                case 5:
                    message.takeRate = reader.string();
                    break;
                case 6:
                    message.rewardChangeRate = reader.string();
                    break;
                case 7:
                    message.rewardChangeInterval = duration.Duration.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            title: isSet(object.title) ? String(object.title) : "",
            description: isSet(object.description) ? String(object.description) : "",
            denom: isSet(object.denom) ? String(object.denom) : "",
            rewardWeight: isSet(object.rewardWeight)
                ? String(object.rewardWeight)
                : "",
            takeRate: isSet(object.takeRate) ? String(object.takeRate) : "",
            rewardChangeRate: isSet(object.rewardChangeRate)
                ? String(object.rewardChangeRate)
                : "",
            rewardChangeInterval: isSet(object.rewardChangeInterval)
                ? duration.Duration.fromJSON(object.rewardChangeInterval)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.title !== undefined && (obj.title = message.title);
        message.description !== undefined &&
            (obj.description = message.description);
        message.denom !== undefined && (obj.denom = message.denom);
        message.rewardWeight !== undefined &&
            (obj.rewardWeight = message.rewardWeight);
        message.takeRate !== undefined && (obj.takeRate = message.takeRate);
        message.rewardChangeRate !== undefined &&
            (obj.rewardChangeRate = message.rewardChangeRate);
        message.rewardChangeInterval !== undefined &&
            (obj.rewardChangeInterval = message.rewardChangeInterval
                ? duration.Duration.toJSON(message.rewardChangeInterval)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f;
        const message = createBaseMsgUpdateAllianceProposal();
        message.title = (_a = object.title) !== null && _a !== void 0 ? _a : "";
        message.description = (_b = object.description) !== null && _b !== void 0 ? _b : "";
        message.denom = (_c = object.denom) !== null && _c !== void 0 ? _c : "";
        message.rewardWeight = (_d = object.rewardWeight) !== null && _d !== void 0 ? _d : "";
        message.takeRate = (_e = object.takeRate) !== null && _e !== void 0 ? _e : "";
        message.rewardChangeRate = (_f = object.rewardChangeRate) !== null && _f !== void 0 ? _f : "";
        message.rewardChangeInterval =
            object.rewardChangeInterval !== undefined &&
                object.rewardChangeInterval !== null
                ? duration.Duration.fromPartial(object.rewardChangeInterval)
                : undefined;
        return message;
    },
};
function createBaseMsgDeleteAllianceProposal() {
    return {
        title: "",
        description: "",
        denom: "",
    };
}
const MsgDeleteAllianceProposal = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.title !== "") {
            writer.uint32(10).string(message.title);
        }
        if (message.description !== "") {
            writer.uint32(18).string(message.description);
        }
        if (message.denom !== "") {
            writer.uint32(26).string(message.denom);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgDeleteAllianceProposal();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.title = reader.string();
                    break;
                case 2:
                    message.description = reader.string();
                    break;
                case 3:
                    message.denom = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            title: isSet(object.title) ? String(object.title) : "",
            description: isSet(object.description) ? String(object.description) : "",
            denom: isSet(object.denom) ? String(object.denom) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.title !== undefined && (obj.title = message.title);
        message.description !== undefined &&
            (obj.description = message.description);
        message.denom !== undefined && (obj.denom = message.denom);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseMsgDeleteAllianceProposal();
        message.title = (_a = object.title) !== null && _a !== void 0 ? _a : "";
        message.description = (_b = object.description) !== null && _b !== void 0 ? _b : "";
        message.denom = (_c = object.denom) !== null && _c !== void 0 ? _c : "";
        return message;
    },
};

// EXTERNAL MODULE: ./node_modules/kujira.js/node_modules/cosmjs-types/cosmos/base/query/v1beta1/pagination.js
var v1beta1_pagination = __webpack_require__(84043);
;// CONCATENATED MODULE: ./node_modules/kujira.js/lib/esm/alliance/delegations.js
/* eslint-disable */





const delegations_protobufPackage = "alliance.alliance";
function createBaseDelegation() {
    return {
        delegatorAddress: "",
        validatorAddress: "",
        denom: "",
        shares: "",
        rewardHistory: [],
        lastRewardClaimHeight: (long_default()).UZERO,
    };
}
const Delegation = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.delegatorAddress !== "") {
            writer.uint32(10).string(message.delegatorAddress);
        }
        if (message.validatorAddress !== "") {
            writer.uint32(18).string(message.validatorAddress);
        }
        if (message.denom !== "") {
            writer.uint32(26).string(message.denom);
        }
        if (message.shares !== "") {
            writer.uint32(34).string(message.shares);
        }
        for (const v of message.rewardHistory) {
            RewardHistory.encode(v, writer.uint32(42).fork()).ldelim();
        }
        if (!message.lastRewardClaimHeight.isZero()) {
            writer.uint32(48).uint64(message.lastRewardClaimHeight);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDelegation();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorAddress = reader.string();
                    break;
                case 3:
                    message.denom = reader.string();
                    break;
                case 4:
                    message.shares = reader.string();
                    break;
                case 5:
                    message.rewardHistory.push(RewardHistory.decode(reader, reader.uint32()));
                    break;
                case 6:
                    message.lastRewardClaimHeight = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            delegatorAddress: isSet(object.delegatorAddress)
                ? String(object.delegatorAddress)
                : "",
            validatorAddress: isSet(object.validatorAddress)
                ? String(object.validatorAddress)
                : "",
            denom: isSet(object.denom) ? String(object.denom) : "",
            shares: isSet(object.shares) ? String(object.shares) : "",
            rewardHistory: Array.isArray(object === null || object === void 0 ? void 0 : object.rewardHistory)
                ? object.rewardHistory.map((e) => RewardHistory.fromJSON(e))
                : [],
            lastRewardClaimHeight: isSet(object.lastRewardClaimHeight)
                ? long_default().fromValue(object.lastRewardClaimHeight)
                : (long_default()).UZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        message.delegatorAddress !== undefined &&
            (obj.delegatorAddress = message.delegatorAddress);
        message.validatorAddress !== undefined &&
            (obj.validatorAddress = message.validatorAddress);
        message.denom !== undefined && (obj.denom = message.denom);
        message.shares !== undefined && (obj.shares = message.shares);
        if (message.rewardHistory) {
            obj.rewardHistory = message.rewardHistory.map((e) => e ? RewardHistory.toJSON(e) : undefined);
        }
        else {
            obj.rewardHistory = [];
        }
        message.lastRewardClaimHeight !== undefined &&
            (obj.lastRewardClaimHeight = (message.lastRewardClaimHeight || (long_default()).UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e;
        const message = createBaseDelegation();
        message.delegatorAddress = (_a = object.delegatorAddress) !== null && _a !== void 0 ? _a : "";
        message.validatorAddress = (_b = object.validatorAddress) !== null && _b !== void 0 ? _b : "";
        message.denom = (_c = object.denom) !== null && _c !== void 0 ? _c : "";
        message.shares = (_d = object.shares) !== null && _d !== void 0 ? _d : "";
        message.rewardHistory =
            ((_e = object.rewardHistory) === null || _e === void 0 ? void 0 : _e.map((e) => RewardHistory.fromPartial(e))) || [];
        message.lastRewardClaimHeight =
            object.lastRewardClaimHeight !== undefined &&
                object.lastRewardClaimHeight !== null
                ? long_default().fromValue(object.lastRewardClaimHeight)
                : (long_default()).UZERO;
        return message;
    },
};
function createBaseRedelegation() {
    return {
        delegatorAddress: "",
        srcValidatorAddress: "",
        dstValidatorAddress: "",
        balance: undefined,
    };
}
const Redelegation = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.delegatorAddress !== "") {
            writer.uint32(10).string(message.delegatorAddress);
        }
        if (message.srcValidatorAddress !== "") {
            writer.uint32(18).string(message.srcValidatorAddress);
        }
        if (message.dstValidatorAddress !== "") {
            writer.uint32(26).string(message.dstValidatorAddress);
        }
        if (message.balance !== undefined) {
            coin.Coin.encode(message.balance, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRedelegation();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.srcValidatorAddress = reader.string();
                    break;
                case 3:
                    message.dstValidatorAddress = reader.string();
                    break;
                case 4:
                    message.balance = coin.Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            delegatorAddress: isSet(object.delegatorAddress)
                ? String(object.delegatorAddress)
                : "",
            srcValidatorAddress: isSet(object.srcValidatorAddress)
                ? String(object.srcValidatorAddress)
                : "",
            dstValidatorAddress: isSet(object.dstValidatorAddress)
                ? String(object.dstValidatorAddress)
                : "",
            balance: isSet(object.balance)
                ? coin.Coin.fromJSON(object.balance)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.delegatorAddress !== undefined &&
            (obj.delegatorAddress = message.delegatorAddress);
        message.srcValidatorAddress !== undefined &&
            (obj.srcValidatorAddress = message.srcValidatorAddress);
        message.dstValidatorAddress !== undefined &&
            (obj.dstValidatorAddress = message.dstValidatorAddress);
        message.balance !== undefined &&
            (obj.balance = message.balance
                ? coin.Coin.toJSON(message.balance)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseRedelegation();
        message.delegatorAddress = (_a = object.delegatorAddress) !== null && _a !== void 0 ? _a : "";
        message.srcValidatorAddress = (_b = object.srcValidatorAddress) !== null && _b !== void 0 ? _b : "";
        message.dstValidatorAddress = (_c = object.dstValidatorAddress) !== null && _c !== void 0 ? _c : "";
        message.balance =
            object.balance !== undefined && object.balance !== null
                ? coin.Coin.fromPartial(object.balance)
                : undefined;
        return message;
    },
};
function createBaseQueuedRedelegation() {
    return {
        entries: [],
    };
}
const QueuedRedelegation = {
    encode(message, writer = minimal.Writer.create()) {
        for (const v of message.entries) {
            Redelegation.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueuedRedelegation();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.entries.push(Redelegation.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            entries: Array.isArray(object === null || object === void 0 ? void 0 : object.entries)
                ? object.entries.map((e) => Redelegation.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.entries) {
            obj.entries = message.entries.map((e) => e ? Redelegation.toJSON(e) : undefined);
        }
        else {
            obj.entries = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueuedRedelegation();
        message.entries =
            ((_a = object.entries) === null || _a === void 0 ? void 0 : _a.map((e) => Redelegation.fromPartial(e))) || [];
        return message;
    },
};
function createBaseUndelegation() {
    return {
        delegatorAddress: "",
        validatorAddress: "",
        balance: undefined,
    };
}
const Undelegation = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.delegatorAddress !== "") {
            writer.uint32(10).string(message.delegatorAddress);
        }
        if (message.validatorAddress !== "") {
            writer.uint32(18).string(message.validatorAddress);
        }
        if (message.balance !== undefined) {
            coin.Coin.encode(message.balance, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUndelegation();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorAddress = reader.string();
                    break;
                case 3:
                    message.balance = coin.Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            delegatorAddress: isSet(object.delegatorAddress)
                ? String(object.delegatorAddress)
                : "",
            validatorAddress: isSet(object.validatorAddress)
                ? String(object.validatorAddress)
                : "",
            balance: isSet(object.balance)
                ? coin.Coin.fromJSON(object.balance)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.delegatorAddress !== undefined &&
            (obj.delegatorAddress = message.delegatorAddress);
        message.validatorAddress !== undefined &&
            (obj.validatorAddress = message.validatorAddress);
        message.balance !== undefined &&
            (obj.balance = message.balance
                ? coin.Coin.toJSON(message.balance)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseUndelegation();
        message.delegatorAddress = (_a = object.delegatorAddress) !== null && _a !== void 0 ? _a : "";
        message.validatorAddress = (_b = object.validatorAddress) !== null && _b !== void 0 ? _b : "";
        message.balance =
            object.balance !== undefined && object.balance !== null
                ? coin.Coin.fromPartial(object.balance)
                : undefined;
        return message;
    },
};
function createBaseQueuedUndelegation() {
    return {
        entries: [],
    };
}
const QueuedUndelegation = {
    encode(message, writer = minimal.Writer.create()) {
        for (const v of message.entries) {
            Undelegation.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueuedUndelegation();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.entries.push(Undelegation.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            entries: Array.isArray(object === null || object === void 0 ? void 0 : object.entries)
                ? object.entries.map((e) => Undelegation.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.entries) {
            obj.entries = message.entries.map((e) => e ? Undelegation.toJSON(e) : undefined);
        }
        else {
            obj.entries = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueuedUndelegation();
        message.entries =
            ((_a = object.entries) === null || _a === void 0 ? void 0 : _a.map((e) => Undelegation.fromPartial(e))) || [];
        return message;
    },
};
function createBaseAllianceValidatorInfo() {
    return {
        globalRewardHistory: [],
        totalDelegatorShares: [],
        validatorShares: [],
    };
}
const AllianceValidatorInfo = {
    encode(message, writer = minimal.Writer.create()) {
        for (const v of message.globalRewardHistory) {
            RewardHistory.encode(v, writer.uint32(10).fork()).ldelim();
        }
        for (const v of message.totalDelegatorShares) {
            coin.DecCoin.encode(v, writer.uint32(18).fork()).ldelim();
        }
        for (const v of message.validatorShares) {
            coin.DecCoin.encode(v, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAllianceValidatorInfo();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.globalRewardHistory.push(RewardHistory.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.totalDelegatorShares.push(coin.DecCoin.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.validatorShares.push(coin.DecCoin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            globalRewardHistory: Array.isArray(object === null || object === void 0 ? void 0 : object.globalRewardHistory)
                ? object.globalRewardHistory.map((e) => RewardHistory.fromJSON(e))
                : [],
            totalDelegatorShares: Array.isArray(object === null || object === void 0 ? void 0 : object.totalDelegatorShares)
                ? object.totalDelegatorShares.map((e) => coin.DecCoin.fromJSON(e))
                : [],
            validatorShares: Array.isArray(object === null || object === void 0 ? void 0 : object.validatorShares)
                ? object.validatorShares.map((e) => coin.DecCoin.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.globalRewardHistory) {
            obj.globalRewardHistory = message.globalRewardHistory.map((e) => e ? RewardHistory.toJSON(e) : undefined);
        }
        else {
            obj.globalRewardHistory = [];
        }
        if (message.totalDelegatorShares) {
            obj.totalDelegatorShares = message.totalDelegatorShares.map((e) => e ? coin.DecCoin.toJSON(e) : undefined);
        }
        else {
            obj.totalDelegatorShares = [];
        }
        if (message.validatorShares) {
            obj.validatorShares = message.validatorShares.map((e) => e ? coin.DecCoin.toJSON(e) : undefined);
        }
        else {
            obj.validatorShares = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseAllianceValidatorInfo();
        message.globalRewardHistory =
            ((_a = object.globalRewardHistory) === null || _a === void 0 ? void 0 : _a.map((e) => RewardHistory.fromPartial(e))) ||
                [];
        message.totalDelegatorShares =
            ((_b = object.totalDelegatorShares) === null || _b === void 0 ? void 0 : _b.map((e) => coin.DecCoin.fromPartial(e))) || [];
        message.validatorShares =
            ((_c = object.validatorShares) === null || _c === void 0 ? void 0 : _c.map((e) => coin.DecCoin.fromPartial(e))) || [];
        return message;
    },
};

;// CONCATENATED MODULE: ./node_modules/kujira.js/lib/esm/alliance/query.js
/* eslint-disable */







const alliance_query_protobufPackage = "alliance.alliance";
function query_createBaseQueryParamsRequest() {
    return {};
}
const query_QueryParamsRequest = {
    encode(_, writer = minimal.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = query_createBaseQueryParamsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = query_createBaseQueryParamsRequest();
        return message;
    },
};
function query_createBaseQueryParamsResponse() {
    return {
        params: undefined,
    };
}
const query_QueryParamsResponse = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.params !== undefined) {
            params_Params.encode(message.params, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = query_createBaseQueryParamsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.params = params_Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            params: isSet(object.params) ? params_Params.fromJSON(object.params) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.params !== undefined &&
            (obj.params = message.params ? params_Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = query_createBaseQueryParamsResponse();
        message.params =
            object.params !== undefined && object.params !== null
                ? params_Params.fromPartial(object.params)
                : undefined;
        return message;
    },
};
function createBaseQueryAlliancesRequest() {
    return {
        pagination: undefined,
    };
}
const QueryAlliancesRequest = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.pagination !== undefined) {
            v1beta1_pagination.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryAlliancesRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.pagination = v1beta1_pagination.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            pagination: isSet(object.pagination)
                ? v1beta1_pagination.PageRequest.fromJSON(object.pagination)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? v1beta1_pagination.PageRequest.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryAlliancesRequest();
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? v1beta1_pagination.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryAlliancesResponse() {
    return {
        alliances: [],
        pagination: undefined,
    };
}
const QueryAlliancesResponse = {
    encode(message, writer = minimal.Writer.create()) {
        for (const v of message.alliances) {
            AllianceAsset.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            v1beta1_pagination.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryAlliancesResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.alliances.push(AllianceAsset.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = v1beta1_pagination.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            alliances: Array.isArray(object === null || object === void 0 ? void 0 : object.alliances)
                ? object.alliances.map((e) => AllianceAsset.fromJSON(e))
                : [],
            pagination: isSet(object.pagination)
                ? v1beta1_pagination.PageResponse.fromJSON(object.pagination)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.alliances) {
            obj.alliances = message.alliances.map((e) => e ? AllianceAsset.toJSON(e) : undefined);
        }
        else {
            obj.alliances = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? v1beta1_pagination.PageResponse.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryAlliancesResponse();
        message.alliances =
            ((_a = object.alliances) === null || _a === void 0 ? void 0 : _a.map((e) => AllianceAsset.fromPartial(e))) || [];
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? v1beta1_pagination.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryAllianceRequest() {
    return {
        denom: "",
    };
}
const QueryAllianceRequest = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.denom !== "") {
            writer.uint32(10).string(message.denom);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryAllianceRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.denom = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            denom: isSet(object.denom) ? String(object.denom) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.denom !== undefined && (obj.denom = message.denom);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryAllianceRequest();
        message.denom = (_a = object.denom) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
function createBaseQueryAllianceResponse() {
    return {
        alliance: undefined,
    };
}
const QueryAllianceResponse = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.alliance !== undefined) {
            AllianceAsset.encode(message.alliance, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryAllianceResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.alliance = AllianceAsset.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            alliance: isSet(object.alliance)
                ? AllianceAsset.fromJSON(object.alliance)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.alliance !== undefined &&
            (obj.alliance = message.alliance
                ? AllianceAsset.toJSON(message.alliance)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryAllianceResponse();
        message.alliance =
            object.alliance !== undefined && object.alliance !== null
                ? AllianceAsset.fromPartial(object.alliance)
                : undefined;
        return message;
    },
};
function createBaseQueryIBCAllianceRequest() {
    return {
        hash: "",
    };
}
const QueryIBCAllianceRequest = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.hash !== "") {
            writer.uint32(10).string(message.hash);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryIBCAllianceRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.hash = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            hash: isSet(object.hash) ? String(object.hash) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.hash !== undefined && (obj.hash = message.hash);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryIBCAllianceRequest();
        message.hash = (_a = object.hash) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
function createBaseQueryAllianceValidatorRequest() {
    return {
        validatorAddr: "",
    };
}
const QueryAllianceValidatorRequest = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.validatorAddr !== "") {
            writer.uint32(10).string(message.validatorAddr);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryAllianceValidatorRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.validatorAddr = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            validatorAddr: isSet(object.validatorAddr)
                ? String(object.validatorAddr)
                : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.validatorAddr !== undefined &&
            (obj.validatorAddr = message.validatorAddr);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryAllianceValidatorRequest();
        message.validatorAddr = (_a = object.validatorAddr) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
function createBaseQueryAllAllianceValidatorsRequest() {
    return {
        pagination: undefined,
    };
}
const QueryAllAllianceValidatorsRequest = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.pagination !== undefined) {
            v1beta1_pagination.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryAllAllianceValidatorsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.pagination = v1beta1_pagination.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            pagination: isSet(object.pagination)
                ? v1beta1_pagination.PageRequest.fromJSON(object.pagination)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? v1beta1_pagination.PageRequest.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryAllAllianceValidatorsRequest();
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? v1beta1_pagination.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryAllAlliancesDelegationsRequest() {
    return {
        pagination: undefined,
    };
}
const QueryAllAlliancesDelegationsRequest = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.pagination !== undefined) {
            v1beta1_pagination.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryAllAlliancesDelegationsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.pagination = v1beta1_pagination.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            pagination: isSet(object.pagination)
                ? v1beta1_pagination.PageRequest.fromJSON(object.pagination)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? v1beta1_pagination.PageRequest.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryAllAlliancesDelegationsRequest();
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? v1beta1_pagination.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryAlliancesDelegationsRequest() {
    return {
        delegatorAddr: "",
        pagination: undefined,
    };
}
const QueryAlliancesDelegationsRequest = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.delegatorAddr !== "") {
            writer.uint32(10).string(message.delegatorAddr);
        }
        if (message.pagination !== undefined) {
            v1beta1_pagination.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryAlliancesDelegationsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.delegatorAddr = reader.string();
                    break;
                case 2:
                    message.pagination = v1beta1_pagination.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            delegatorAddr: isSet(object.delegatorAddr)
                ? String(object.delegatorAddr)
                : "",
            pagination: isSet(object.pagination)
                ? v1beta1_pagination.PageRequest.fromJSON(object.pagination)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.delegatorAddr !== undefined &&
            (obj.delegatorAddr = message.delegatorAddr);
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? v1beta1_pagination.PageRequest.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryAlliancesDelegationsRequest();
        message.delegatorAddr = (_a = object.delegatorAddr) !== null && _a !== void 0 ? _a : "";
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? v1beta1_pagination.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryAlliancesDelegationByValidatorRequest() {
    return {
        delegatorAddr: "",
        validatorAddr: "",
        pagination: undefined,
    };
}
const QueryAlliancesDelegationByValidatorRequest = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.delegatorAddr !== "") {
            writer.uint32(10).string(message.delegatorAddr);
        }
        if (message.validatorAddr !== "") {
            writer.uint32(18).string(message.validatorAddr);
        }
        if (message.pagination !== undefined) {
            v1beta1_pagination.PageRequest.encode(message.pagination, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryAlliancesDelegationByValidatorRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.delegatorAddr = reader.string();
                    break;
                case 2:
                    message.validatorAddr = reader.string();
                    break;
                case 3:
                    message.pagination = v1beta1_pagination.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            delegatorAddr: isSet(object.delegatorAddr)
                ? String(object.delegatorAddr)
                : "",
            validatorAddr: isSet(object.validatorAddr)
                ? String(object.validatorAddr)
                : "",
            pagination: isSet(object.pagination)
                ? v1beta1_pagination.PageRequest.fromJSON(object.pagination)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.delegatorAddr !== undefined &&
            (obj.delegatorAddr = message.delegatorAddr);
        message.validatorAddr !== undefined &&
            (obj.validatorAddr = message.validatorAddr);
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? v1beta1_pagination.PageRequest.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseQueryAlliancesDelegationByValidatorRequest();
        message.delegatorAddr = (_a = object.delegatorAddr) !== null && _a !== void 0 ? _a : "";
        message.validatorAddr = (_b = object.validatorAddr) !== null && _b !== void 0 ? _b : "";
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? v1beta1_pagination.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseDelegationResponse() {
    return {
        delegation: undefined,
        balance: undefined,
    };
}
const DelegationResponse = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.delegation !== undefined) {
            Delegation.encode(message.delegation, writer.uint32(10).fork()).ldelim();
        }
        if (message.balance !== undefined) {
            coin.Coin.encode(message.balance, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDelegationResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.delegation = Delegation.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.balance = coin.Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            delegation: isSet(object.delegation)
                ? Delegation.fromJSON(object.delegation)
                : undefined,
            balance: isSet(object.balance)
                ? coin.Coin.fromJSON(object.balance)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.delegation !== undefined &&
            (obj.delegation = message.delegation
                ? Delegation.toJSON(message.delegation)
                : undefined);
        message.balance !== undefined &&
            (obj.balance = message.balance
                ? coin.Coin.toJSON(message.balance)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseDelegationResponse();
        message.delegation =
            object.delegation !== undefined && object.delegation !== null
                ? Delegation.fromPartial(object.delegation)
                : undefined;
        message.balance =
            object.balance !== undefined && object.balance !== null
                ? coin.Coin.fromPartial(object.balance)
                : undefined;
        return message;
    },
};
function createBaseQueryAlliancesDelegationsResponse() {
    return {
        delegations: [],
        pagination: undefined,
    };
}
const QueryAlliancesDelegationsResponse = {
    encode(message, writer = minimal.Writer.create()) {
        for (const v of message.delegations) {
            DelegationResponse.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            v1beta1_pagination.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryAlliancesDelegationsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.delegations.push(DelegationResponse.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = v1beta1_pagination.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            delegations: Array.isArray(object === null || object === void 0 ? void 0 : object.delegations)
                ? object.delegations.map((e) => DelegationResponse.fromJSON(e))
                : [],
            pagination: isSet(object.pagination)
                ? v1beta1_pagination.PageResponse.fromJSON(object.pagination)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.delegations) {
            obj.delegations = message.delegations.map((e) => e ? DelegationResponse.toJSON(e) : undefined);
        }
        else {
            obj.delegations = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? v1beta1_pagination.PageResponse.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryAlliancesDelegationsResponse();
        message.delegations =
            ((_a = object.delegations) === null || _a === void 0 ? void 0 : _a.map((e) => DelegationResponse.fromPartial(e))) || [];
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? v1beta1_pagination.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryAllianceDelegationRequest() {
    return {
        delegatorAddr: "",
        validatorAddr: "",
        denom: "",
        pagination: undefined,
    };
}
const QueryAllianceDelegationRequest = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.delegatorAddr !== "") {
            writer.uint32(10).string(message.delegatorAddr);
        }
        if (message.validatorAddr !== "") {
            writer.uint32(18).string(message.validatorAddr);
        }
        if (message.denom !== "") {
            writer.uint32(26).string(message.denom);
        }
        if (message.pagination !== undefined) {
            v1beta1_pagination.PageRequest.encode(message.pagination, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryAllianceDelegationRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.delegatorAddr = reader.string();
                    break;
                case 2:
                    message.validatorAddr = reader.string();
                    break;
                case 3:
                    message.denom = reader.string();
                    break;
                case 4:
                    message.pagination = v1beta1_pagination.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            delegatorAddr: isSet(object.delegatorAddr)
                ? String(object.delegatorAddr)
                : "",
            validatorAddr: isSet(object.validatorAddr)
                ? String(object.validatorAddr)
                : "",
            denom: isSet(object.denom) ? String(object.denom) : "",
            pagination: isSet(object.pagination)
                ? v1beta1_pagination.PageRequest.fromJSON(object.pagination)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.delegatorAddr !== undefined &&
            (obj.delegatorAddr = message.delegatorAddr);
        message.validatorAddr !== undefined &&
            (obj.validatorAddr = message.validatorAddr);
        message.denom !== undefined && (obj.denom = message.denom);
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? v1beta1_pagination.PageRequest.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseQueryAllianceDelegationRequest();
        message.delegatorAddr = (_a = object.delegatorAddr) !== null && _a !== void 0 ? _a : "";
        message.validatorAddr = (_b = object.validatorAddr) !== null && _b !== void 0 ? _b : "";
        message.denom = (_c = object.denom) !== null && _c !== void 0 ? _c : "";
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? v1beta1_pagination.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryIBCAllianceDelegationRequest() {
    return {
        delegatorAddr: "",
        validatorAddr: "",
        hash: "",
        pagination: undefined,
    };
}
const QueryIBCAllianceDelegationRequest = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.delegatorAddr !== "") {
            writer.uint32(10).string(message.delegatorAddr);
        }
        if (message.validatorAddr !== "") {
            writer.uint32(18).string(message.validatorAddr);
        }
        if (message.hash !== "") {
            writer.uint32(26).string(message.hash);
        }
        if (message.pagination !== undefined) {
            v1beta1_pagination.PageRequest.encode(message.pagination, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryIBCAllianceDelegationRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.delegatorAddr = reader.string();
                    break;
                case 2:
                    message.validatorAddr = reader.string();
                    break;
                case 3:
                    message.hash = reader.string();
                    break;
                case 4:
                    message.pagination = v1beta1_pagination.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            delegatorAddr: isSet(object.delegatorAddr)
                ? String(object.delegatorAddr)
                : "",
            validatorAddr: isSet(object.validatorAddr)
                ? String(object.validatorAddr)
                : "",
            hash: isSet(object.hash) ? String(object.hash) : "",
            pagination: isSet(object.pagination)
                ? v1beta1_pagination.PageRequest.fromJSON(object.pagination)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.delegatorAddr !== undefined &&
            (obj.delegatorAddr = message.delegatorAddr);
        message.validatorAddr !== undefined &&
            (obj.validatorAddr = message.validatorAddr);
        message.hash !== undefined && (obj.hash = message.hash);
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? v1beta1_pagination.PageRequest.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseQueryIBCAllianceDelegationRequest();
        message.delegatorAddr = (_a = object.delegatorAddr) !== null && _a !== void 0 ? _a : "";
        message.validatorAddr = (_b = object.validatorAddr) !== null && _b !== void 0 ? _b : "";
        message.hash = (_c = object.hash) !== null && _c !== void 0 ? _c : "";
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? v1beta1_pagination.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryAllianceDelegationResponse() {
    return {
        delegation: undefined,
    };
}
const QueryAllianceDelegationResponse = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.delegation !== undefined) {
            DelegationResponse.encode(message.delegation, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryAllianceDelegationResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.delegation = DelegationResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            delegation: isSet(object.delegation)
                ? DelegationResponse.fromJSON(object.delegation)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.delegation !== undefined &&
            (obj.delegation = message.delegation
                ? DelegationResponse.toJSON(message.delegation)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryAllianceDelegationResponse();
        message.delegation =
            object.delegation !== undefined && object.delegation !== null
                ? DelegationResponse.fromPartial(object.delegation)
                : undefined;
        return message;
    },
};
function createBaseQueryAllianceDelegationRewardsRequest() {
    return {
        delegatorAddr: "",
        validatorAddr: "",
        denom: "",
        pagination: undefined,
    };
}
const QueryAllianceDelegationRewardsRequest = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.delegatorAddr !== "") {
            writer.uint32(10).string(message.delegatorAddr);
        }
        if (message.validatorAddr !== "") {
            writer.uint32(18).string(message.validatorAddr);
        }
        if (message.denom !== "") {
            writer.uint32(26).string(message.denom);
        }
        if (message.pagination !== undefined) {
            v1beta1_pagination.PageRequest.encode(message.pagination, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryAllianceDelegationRewardsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.delegatorAddr = reader.string();
                    break;
                case 2:
                    message.validatorAddr = reader.string();
                    break;
                case 3:
                    message.denom = reader.string();
                    break;
                case 4:
                    message.pagination = v1beta1_pagination.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            delegatorAddr: isSet(object.delegatorAddr)
                ? String(object.delegatorAddr)
                : "",
            validatorAddr: isSet(object.validatorAddr)
                ? String(object.validatorAddr)
                : "",
            denom: isSet(object.denom) ? String(object.denom) : "",
            pagination: isSet(object.pagination)
                ? v1beta1_pagination.PageRequest.fromJSON(object.pagination)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.delegatorAddr !== undefined &&
            (obj.delegatorAddr = message.delegatorAddr);
        message.validatorAddr !== undefined &&
            (obj.validatorAddr = message.validatorAddr);
        message.denom !== undefined && (obj.denom = message.denom);
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? v1beta1_pagination.PageRequest.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseQueryAllianceDelegationRewardsRequest();
        message.delegatorAddr = (_a = object.delegatorAddr) !== null && _a !== void 0 ? _a : "";
        message.validatorAddr = (_b = object.validatorAddr) !== null && _b !== void 0 ? _b : "";
        message.denom = (_c = object.denom) !== null && _c !== void 0 ? _c : "";
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? v1beta1_pagination.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryIBCAllianceDelegationRewardsRequest() {
    return {
        delegatorAddr: "",
        validatorAddr: "",
        hash: "",
        pagination: undefined,
    };
}
const QueryIBCAllianceDelegationRewardsRequest = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.delegatorAddr !== "") {
            writer.uint32(10).string(message.delegatorAddr);
        }
        if (message.validatorAddr !== "") {
            writer.uint32(18).string(message.validatorAddr);
        }
        if (message.hash !== "") {
            writer.uint32(26).string(message.hash);
        }
        if (message.pagination !== undefined) {
            v1beta1_pagination.PageRequest.encode(message.pagination, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryIBCAllianceDelegationRewardsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.delegatorAddr = reader.string();
                    break;
                case 2:
                    message.validatorAddr = reader.string();
                    break;
                case 3:
                    message.hash = reader.string();
                    break;
                case 4:
                    message.pagination = v1beta1_pagination.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            delegatorAddr: isSet(object.delegatorAddr)
                ? String(object.delegatorAddr)
                : "",
            validatorAddr: isSet(object.validatorAddr)
                ? String(object.validatorAddr)
                : "",
            hash: isSet(object.hash) ? String(object.hash) : "",
            pagination: isSet(object.pagination)
                ? v1beta1_pagination.PageRequest.fromJSON(object.pagination)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.delegatorAddr !== undefined &&
            (obj.delegatorAddr = message.delegatorAddr);
        message.validatorAddr !== undefined &&
            (obj.validatorAddr = message.validatorAddr);
        message.hash !== undefined && (obj.hash = message.hash);
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? v1beta1_pagination.PageRequest.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseQueryIBCAllianceDelegationRewardsRequest();
        message.delegatorAddr = (_a = object.delegatorAddr) !== null && _a !== void 0 ? _a : "";
        message.validatorAddr = (_b = object.validatorAddr) !== null && _b !== void 0 ? _b : "";
        message.hash = (_c = object.hash) !== null && _c !== void 0 ? _c : "";
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? v1beta1_pagination.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryAllianceDelegationRewardsResponse() {
    return {
        rewards: [],
    };
}
const QueryAllianceDelegationRewardsResponse = {
    encode(message, writer = minimal.Writer.create()) {
        for (const v of message.rewards) {
            coin.Coin.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryAllianceDelegationRewardsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.rewards.push(coin.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            rewards: Array.isArray(object === null || object === void 0 ? void 0 : object.rewards)
                ? object.rewards.map((e) => coin.Coin.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.rewards) {
            obj.rewards = message.rewards.map((e) => e ? coin.Coin.toJSON(e) : undefined);
        }
        else {
            obj.rewards = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryAllianceDelegationRewardsResponse();
        message.rewards = ((_a = object.rewards) === null || _a === void 0 ? void 0 : _a.map((e) => coin.Coin.fromPartial(e))) || [];
        return message;
    },
};
function createBaseQueryAllianceValidatorResponse() {
    return {
        validatorAddr: "",
        totalDelegationShares: [],
        validatorShares: [],
        totalStaked: [],
    };
}
const QueryAllianceValidatorResponse = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.validatorAddr !== "") {
            writer.uint32(10).string(message.validatorAddr);
        }
        for (const v of message.totalDelegationShares) {
            coin.DecCoin.encode(v, writer.uint32(18).fork()).ldelim();
        }
        for (const v of message.validatorShares) {
            coin.DecCoin.encode(v, writer.uint32(26).fork()).ldelim();
        }
        for (const v of message.totalStaked) {
            coin.DecCoin.encode(v, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryAllianceValidatorResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.validatorAddr = reader.string();
                    break;
                case 2:
                    message.totalDelegationShares.push(coin.DecCoin.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.validatorShares.push(coin.DecCoin.decode(reader, reader.uint32()));
                    break;
                case 4:
                    message.totalStaked.push(coin.DecCoin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            validatorAddr: isSet(object.validatorAddr)
                ? String(object.validatorAddr)
                : "",
            totalDelegationShares: Array.isArray(object === null || object === void 0 ? void 0 : object.totalDelegationShares)
                ? object.totalDelegationShares.map((e) => coin.DecCoin.fromJSON(e))
                : [],
            validatorShares: Array.isArray(object === null || object === void 0 ? void 0 : object.validatorShares)
                ? object.validatorShares.map((e) => coin.DecCoin.fromJSON(e))
                : [],
            totalStaked: Array.isArray(object === null || object === void 0 ? void 0 : object.totalStaked)
                ? object.totalStaked.map((e) => coin.DecCoin.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        message.validatorAddr !== undefined &&
            (obj.validatorAddr = message.validatorAddr);
        if (message.totalDelegationShares) {
            obj.totalDelegationShares = message.totalDelegationShares.map((e) => e ? coin.DecCoin.toJSON(e) : undefined);
        }
        else {
            obj.totalDelegationShares = [];
        }
        if (message.validatorShares) {
            obj.validatorShares = message.validatorShares.map((e) => e ? coin.DecCoin.toJSON(e) : undefined);
        }
        else {
            obj.validatorShares = [];
        }
        if (message.totalStaked) {
            obj.totalStaked = message.totalStaked.map((e) => e ? coin.DecCoin.toJSON(e) : undefined);
        }
        else {
            obj.totalStaked = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d;
        const message = createBaseQueryAllianceValidatorResponse();
        message.validatorAddr = (_a = object.validatorAddr) !== null && _a !== void 0 ? _a : "";
        message.totalDelegationShares =
            ((_b = object.totalDelegationShares) === null || _b === void 0 ? void 0 : _b.map((e) => coin.DecCoin.fromPartial(e))) || [];
        message.validatorShares =
            ((_c = object.validatorShares) === null || _c === void 0 ? void 0 : _c.map((e) => coin.DecCoin.fromPartial(e))) || [];
        message.totalStaked =
            ((_d = object.totalStaked) === null || _d === void 0 ? void 0 : _d.map((e) => coin.DecCoin.fromPartial(e))) || [];
        return message;
    },
};
function createBaseQueryAllianceValidatorsResponse() {
    return {
        validators: [],
        pagination: undefined,
    };
}
const QueryAllianceValidatorsResponse = {
    encode(message, writer = minimal.Writer.create()) {
        for (const v of message.validators) {
            QueryAllianceValidatorResponse.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            v1beta1_pagination.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryAllianceValidatorsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.validators.push(QueryAllianceValidatorResponse.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = v1beta1_pagination.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            validators: Array.isArray(object === null || object === void 0 ? void 0 : object.validators)
                ? object.validators.map((e) => QueryAllianceValidatorResponse.fromJSON(e))
                : [],
            pagination: isSet(object.pagination)
                ? v1beta1_pagination.PageResponse.fromJSON(object.pagination)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.validators) {
            obj.validators = message.validators.map((e) => e ? QueryAllianceValidatorResponse.toJSON(e) : undefined);
        }
        else {
            obj.validators = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? v1beta1_pagination.PageResponse.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryAllianceValidatorsResponse();
        message.validators =
            ((_a = object.validators) === null || _a === void 0 ? void 0 : _a.map((e) => QueryAllianceValidatorResponse.fromPartial(e))) || [];
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? v1beta1_pagination.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
class query_QueryClientImpl {
    constructor(rpc) {
        this.rpc = rpc;
        this.Params = this.Params.bind(this);
        this.Alliances = this.Alliances.bind(this);
        this.IBCAlliance = this.IBCAlliance.bind(this);
        this.AllAlliancesDelegations = this.AllAlliancesDelegations.bind(this);
        this.AllianceValidator = this.AllianceValidator.bind(this);
        this.AllAllianceValidators = this.AllAllianceValidators.bind(this);
        this.AlliancesDelegation = this.AlliancesDelegation.bind(this);
        this.AlliancesDelegationByValidator =
            this.AlliancesDelegationByValidator.bind(this);
        this.AllianceDelegation = this.AllianceDelegation.bind(this);
        this.IBCAllianceDelegation = this.IBCAllianceDelegation.bind(this);
        this.AllianceDelegationRewards = this.AllianceDelegationRewards.bind(this);
        this.IBCAllianceDelegationRewards =
            this.IBCAllianceDelegationRewards.bind(this);
        this.Alliance = this.Alliance.bind(this);
    }
    Params(request = {}) {
        const data = query_QueryParamsRequest.encode(request).finish();
        const promise = this.rpc.request("alliance.alliance.Query", "Params", data);
        return promise.then((data) => query_QueryParamsResponse.decode(new minimal.Reader(data)));
    }
    Alliances(request = {
        pagination: undefined,
    }) {
        const data = QueryAlliancesRequest.encode(request).finish();
        const promise = this.rpc.request("alliance.alliance.Query", "Alliances", data);
        return promise.then((data) => QueryAlliancesResponse.decode(new minimal.Reader(data)));
    }
    IBCAlliance(request) {
        const data = QueryIBCAllianceRequest.encode(request).finish();
        const promise = this.rpc.request("alliance.alliance.Query", "IBCAlliance", data);
        return promise.then((data) => QueryAllianceResponse.decode(new minimal.Reader(data)));
    }
    AllAlliancesDelegations(request = {
        pagination: undefined,
    }) {
        const data = QueryAllAlliancesDelegationsRequest.encode(request).finish();
        const promise = this.rpc.request("alliance.alliance.Query", "AllAlliancesDelegations", data);
        return promise.then((data) => QueryAlliancesDelegationsResponse.decode(new minimal.Reader(data)));
    }
    AllianceValidator(request) {
        const data = QueryAllianceValidatorRequest.encode(request).finish();
        const promise = this.rpc.request("alliance.alliance.Query", "AllianceValidator", data);
        return promise.then((data) => QueryAllianceValidatorResponse.decode(new minimal.Reader(data)));
    }
    AllAllianceValidators(request = {
        pagination: undefined,
    }) {
        const data = QueryAllAllianceValidatorsRequest.encode(request).finish();
        const promise = this.rpc.request("alliance.alliance.Query", "AllAllianceValidators", data);
        return promise.then((data) => QueryAllianceValidatorsResponse.decode(new minimal.Reader(data)));
    }
    AlliancesDelegation(request) {
        const data = QueryAlliancesDelegationsRequest.encode(request).finish();
        const promise = this.rpc.request("alliance.alliance.Query", "AlliancesDelegation", data);
        return promise.then((data) => QueryAlliancesDelegationsResponse.decode(new minimal.Reader(data)));
    }
    AlliancesDelegationByValidator(request) {
        const data = QueryAlliancesDelegationByValidatorRequest.encode(request).finish();
        const promise = this.rpc.request("alliance.alliance.Query", "AlliancesDelegationByValidator", data);
        return promise.then((data) => QueryAlliancesDelegationsResponse.decode(new minimal.Reader(data)));
    }
    AllianceDelegation(request) {
        const data = QueryAllianceDelegationRequest.encode(request).finish();
        const promise = this.rpc.request("alliance.alliance.Query", "AllianceDelegation", data);
        return promise.then((data) => QueryAllianceDelegationResponse.decode(new minimal.Reader(data)));
    }
    IBCAllianceDelegation(request) {
        const data = QueryIBCAllianceDelegationRequest.encode(request).finish();
        const promise = this.rpc.request("alliance.alliance.Query", "IBCAllianceDelegation", data);
        return promise.then((data) => QueryAllianceDelegationResponse.decode(new minimal.Reader(data)));
    }
    AllianceDelegationRewards(request) {
        const data = QueryAllianceDelegationRewardsRequest.encode(request).finish();
        const promise = this.rpc.request("alliance.alliance.Query", "AllianceDelegationRewards", data);
        return promise.then((data) => QueryAllianceDelegationRewardsResponse.decode(new minimal.Reader(data)));
    }
    IBCAllianceDelegationRewards(request) {
        const data = QueryIBCAllianceDelegationRewardsRequest.encode(request).finish();
        const promise = this.rpc.request("alliance.alliance.Query", "IBCAllianceDelegationRewards", data);
        return promise.then((data) => QueryAllianceDelegationRewardsResponse.decode(new minimal.Reader(data)));
    }
    Alliance(request) {
        const data = QueryAllianceRequest.encode(request).finish();
        const promise = this.rpc.request("alliance.alliance.Query", "Alliance", data);
        return promise.then((data) => QueryAllianceResponse.decode(new minimal.Reader(data)));
    }
}

;// CONCATENATED MODULE: ./node_modules/kujira.js/lib/esm/alliance/queries.js
var alliance_queries_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};



function setupAllianceExtension(base) {
    const rpc = (0,stargate_build.createProtobufRpcClient)(base);
    const queryService = new query_QueryClientImpl(rpc);
    return {
        alliance: {
            params: () => alliance_queries_awaiter(this, void 0, void 0, function* () {
                const { params } = yield queryService.Params({});
                (0,utils_build.assert)(params);
                return params;
            }),
            /** Query paginated alliances */
            alliances: (q) => alliance_queries_awaiter(this, void 0, void 0, function* () {
                return queryService.Alliances(q);
            }),
            /** Query a specific alliance by ibc hash */
            ibcAlliance: (q) => alliance_queries_awaiter(this, void 0, void 0, function* () {
                return queryService.IBCAlliance(q);
            }),
            /** Query all paginated alliance delegations */
            allAlliancesDelegations: (q) => alliance_queries_awaiter(this, void 0, void 0, function* () {
                return queryService.AllAlliancesDelegations(q);
            }),
            /** Query alliance validator */
            allianceValidator: (q) => alliance_queries_awaiter(this, void 0, void 0, function* () {
                return queryService.AllianceValidator(q);
            }),
            /** Query all paginated alliance validators */
            allAllianceValidators: (q) => alliance_queries_awaiter(this, void 0, void 0, function* () {
                return queryService.AllAllianceValidators(q);
            }),
            /** Query all paginated alliance delegations for a delegator addr */
            alliancesDelegation: (q) => alliance_queries_awaiter(this, void 0, void 0, function* () {
                return queryService.AlliancesDelegation(q);
            }),
            /** Query all paginated alliance delegations for a delegator addr and validator_addr */
            alliancesDelegationByValidator: (q) => alliance_queries_awaiter(this, void 0, void 0, function* () {
                return queryService.AlliancesDelegationByValidator(q);
            }),
            /** Query a delegation to an alliance by delegator addr, validator_addr and denom */
            allianceDelegation: (q) => alliance_queries_awaiter(this, void 0, void 0, function* () {
                return queryService.AllianceDelegation(q);
            }),
            /** Query a delegation to an alliance by delegator addr, validator_addr and denom */
            ibcAllianceDelegation: (q) => alliance_queries_awaiter(this, void 0, void 0, function* () {
                return queryService.IBCAllianceDelegation(q);
            }),
            /** Query for rewards by delegator addr, validator_addr and denom */
            allianceDelegationRewards: (q) => alliance_queries_awaiter(this, void 0, void 0, function* () {
                return queryService.AllianceDelegationRewards(q);
            }),
            /** Query for rewards by delegator addr, validator_addr and denom */
            ibcAllianceDelegationRewards: (q) => alliance_queries_awaiter(this, void 0, void 0, function* () {
                return queryService.IBCAllianceDelegationRewards(q);
            }),
            /** Query a specific alliance by denom */
            alliance: (q) => alliance_queries_awaiter(this, void 0, void 0, function* () {
                return queryService.Alliance(q);
            }),
        },
    };
}

;// CONCATENATED MODULE: ./node_modules/kujira.js/lib/esm/alliance/tx.js
/* eslint-disable */



const tx_protobufPackage = "alliance.alliance";
function createBaseMsgDelegate() {
    return {
        delegatorAddress: "",
        validatorAddress: "",
        amount: undefined,
    };
}
const MsgDelegate = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.delegatorAddress !== "") {
            writer.uint32(10).string(message.delegatorAddress);
        }
        if (message.validatorAddress !== "") {
            writer.uint32(18).string(message.validatorAddress);
        }
        if (message.amount !== undefined) {
            coin.Coin.encode(message.amount, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgDelegate();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorAddress = reader.string();
                    break;
                case 3:
                    message.amount = coin.Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            delegatorAddress: isSet(object.delegatorAddress)
                ? String(object.delegatorAddress)
                : "",
            validatorAddress: isSet(object.validatorAddress)
                ? String(object.validatorAddress)
                : "",
            amount: isSet(object.amount) ? coin.Coin.fromJSON(object.amount) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.delegatorAddress !== undefined &&
            (obj.delegatorAddress = message.delegatorAddress);
        message.validatorAddress !== undefined &&
            (obj.validatorAddress = message.validatorAddress);
        message.amount !== undefined &&
            (obj.amount = message.amount ? coin.Coin.toJSON(message.amount) : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseMsgDelegate();
        message.delegatorAddress = (_a = object.delegatorAddress) !== null && _a !== void 0 ? _a : "";
        message.validatorAddress = (_b = object.validatorAddress) !== null && _b !== void 0 ? _b : "";
        message.amount =
            object.amount !== undefined && object.amount !== null
                ? coin.Coin.fromPartial(object.amount)
                : undefined;
        return message;
    },
};
function createBaseMsgDelegateResponse() {
    return {};
}
const MsgDelegateResponse = {
    encode(_, writer = minimal.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgDelegateResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgDelegateResponse();
        return message;
    },
};
function createBaseMsgUndelegate() {
    return {
        delegatorAddress: "",
        validatorAddress: "",
        amount: undefined,
    };
}
const MsgUndelegate = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.delegatorAddress !== "") {
            writer.uint32(10).string(message.delegatorAddress);
        }
        if (message.validatorAddress !== "") {
            writer.uint32(18).string(message.validatorAddress);
        }
        if (message.amount !== undefined) {
            coin.Coin.encode(message.amount, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgUndelegate();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorAddress = reader.string();
                    break;
                case 3:
                    message.amount = coin.Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            delegatorAddress: isSet(object.delegatorAddress)
                ? String(object.delegatorAddress)
                : "",
            validatorAddress: isSet(object.validatorAddress)
                ? String(object.validatorAddress)
                : "",
            amount: isSet(object.amount) ? coin.Coin.fromJSON(object.amount) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.delegatorAddress !== undefined &&
            (obj.delegatorAddress = message.delegatorAddress);
        message.validatorAddress !== undefined &&
            (obj.validatorAddress = message.validatorAddress);
        message.amount !== undefined &&
            (obj.amount = message.amount ? coin.Coin.toJSON(message.amount) : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseMsgUndelegate();
        message.delegatorAddress = (_a = object.delegatorAddress) !== null && _a !== void 0 ? _a : "";
        message.validatorAddress = (_b = object.validatorAddress) !== null && _b !== void 0 ? _b : "";
        message.amount =
            object.amount !== undefined && object.amount !== null
                ? coin.Coin.fromPartial(object.amount)
                : undefined;
        return message;
    },
};
function createBaseMsgUndelegateResponse() {
    return {};
}
const MsgUndelegateResponse = {
    encode(_, writer = minimal.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgUndelegateResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgUndelegateResponse();
        return message;
    },
};
function createBaseMsgRedelegate() {
    return {
        delegatorAddress: "",
        validatorSrcAddress: "",
        validatorDstAddress: "",
        amount: undefined,
    };
}
const MsgRedelegate = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.delegatorAddress !== "") {
            writer.uint32(10).string(message.delegatorAddress);
        }
        if (message.validatorSrcAddress !== "") {
            writer.uint32(18).string(message.validatorSrcAddress);
        }
        if (message.validatorDstAddress !== "") {
            writer.uint32(26).string(message.validatorDstAddress);
        }
        if (message.amount !== undefined) {
            coin.Coin.encode(message.amount, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgRedelegate();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorSrcAddress = reader.string();
                    break;
                case 3:
                    message.validatorDstAddress = reader.string();
                    break;
                case 4:
                    message.amount = coin.Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            delegatorAddress: isSet(object.delegatorAddress)
                ? String(object.delegatorAddress)
                : "",
            validatorSrcAddress: isSet(object.validatorSrcAddress)
                ? String(object.validatorSrcAddress)
                : "",
            validatorDstAddress: isSet(object.validatorDstAddress)
                ? String(object.validatorDstAddress)
                : "",
            amount: isSet(object.amount) ? coin.Coin.fromJSON(object.amount) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.delegatorAddress !== undefined &&
            (obj.delegatorAddress = message.delegatorAddress);
        message.validatorSrcAddress !== undefined &&
            (obj.validatorSrcAddress = message.validatorSrcAddress);
        message.validatorDstAddress !== undefined &&
            (obj.validatorDstAddress = message.validatorDstAddress);
        message.amount !== undefined &&
            (obj.amount = message.amount ? coin.Coin.toJSON(message.amount) : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseMsgRedelegate();
        message.delegatorAddress = (_a = object.delegatorAddress) !== null && _a !== void 0 ? _a : "";
        message.validatorSrcAddress = (_b = object.validatorSrcAddress) !== null && _b !== void 0 ? _b : "";
        message.validatorDstAddress = (_c = object.validatorDstAddress) !== null && _c !== void 0 ? _c : "";
        message.amount =
            object.amount !== undefined && object.amount !== null
                ? coin.Coin.fromPartial(object.amount)
                : undefined;
        return message;
    },
};
function createBaseMsgRedelegateResponse() {
    return {};
}
const MsgRedelegateResponse = {
    encode(_, writer = minimal.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgRedelegateResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgRedelegateResponse();
        return message;
    },
};
function createBaseMsgClaimDelegationRewards() {
    return {
        delegatorAddress: "",
        validatorAddress: "",
        denom: "",
    };
}
const MsgClaimDelegationRewards = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.delegatorAddress !== "") {
            writer.uint32(10).string(message.delegatorAddress);
        }
        if (message.validatorAddress !== "") {
            writer.uint32(18).string(message.validatorAddress);
        }
        if (message.denom !== "") {
            writer.uint32(26).string(message.denom);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgClaimDelegationRewards();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorAddress = reader.string();
                    break;
                case 3:
                    message.denom = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            delegatorAddress: isSet(object.delegatorAddress)
                ? String(object.delegatorAddress)
                : "",
            validatorAddress: isSet(object.validatorAddress)
                ? String(object.validatorAddress)
                : "",
            denom: isSet(object.denom) ? String(object.denom) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.delegatorAddress !== undefined &&
            (obj.delegatorAddress = message.delegatorAddress);
        message.validatorAddress !== undefined &&
            (obj.validatorAddress = message.validatorAddress);
        message.denom !== undefined && (obj.denom = message.denom);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseMsgClaimDelegationRewards();
        message.delegatorAddress = (_a = object.delegatorAddress) !== null && _a !== void 0 ? _a : "";
        message.validatorAddress = (_b = object.validatorAddress) !== null && _b !== void 0 ? _b : "";
        message.denom = (_c = object.denom) !== null && _c !== void 0 ? _c : "";
        return message;
    },
};
function createBaseMsgClaimDelegationRewardsResponse() {
    return {};
}
const MsgClaimDelegationRewardsResponse = {
    encode(_, writer = minimal.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgClaimDelegationRewardsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgClaimDelegationRewardsResponse();
        return message;
    },
};

;// CONCATENATED MODULE: ./node_modules/kujira.js/lib/esm/alliance/index.js




const alliance_types = [
    ["/alliance.alliance.MsgDelegate", MsgDelegate],
    ["/alliance.alliance.MsgDelegateResponse", MsgDelegateResponse],
    ["/alliance.alliance.MsgUndelegate", MsgUndelegate],
    ["/alliance.alliance.MsgUndelegateResponse", MsgUndelegateResponse],
    ["/alliance.alliance.MsgRedelegate", MsgRedelegate],
    ["/alliance.alliance.MsgRedelegateResponse", MsgRedelegateResponse],
    ["/alliance.alliance.MsgClaimDelegationRewards", MsgClaimDelegationRewards],
    ["/alliance.alliance.MsgCreateAllianceProposal", MsgCreateAllianceProposal],
    ["/alliance.alliance.MsgUpdateAllianceProposal", MsgUpdateAllianceProposal],
    ["/alliance.alliance.MsgDeleteAllianceProposal", MsgDeleteAllianceProposal],
];
const alliance_msg = {
    msgDelegate: (x) => ({
        typeUrl: "/alliance.alliance.MsgDelegate",
        value: MsgDelegate.fromPartial(x),
    }),
    msgDelegateResponse: (x) => ({
        typeUrl: "/alliance.alliance.MsgDelegateResponse",
        value: MsgDelegateResponse.fromPartial(x),
    }),
    msgUndelegate: (x) => ({
        typeUrl: "/alliance.alliance.MsgUndelegate",
        value: MsgUndelegate.fromPartial(x),
    }),
    msgUndelegateResponse: (x) => ({
        typeUrl: "/alliance.alliance.MsgUndelegateResponse",
        value: MsgUndelegateResponse.fromPartial(x),
    }),
    msgRedelegate: (x) => ({
        typeUrl: "/alliance.alliance.MsgRedelegate",
        value: MsgRedelegate.fromPartial(x),
    }),
    msgRedelegateResponse: (x) => ({
        typeUrl: "/alliance.alliance.MsgRedelegateResponse",
        value: MsgRedelegateResponse.fromPartial(x),
    }),
    msgClaimDelegationRewards: (x) => ({
        typeUrl: "/alliance.alliance.MsgClaimDelegationRewards",
        value: MsgClaimDelegationRewards.fromPartial(x),
    }),
};
const alliance_registry = new proto_signing_build.Registry(alliance_types);


;// CONCATENATED MODULE: ./node_modules/kujira.js/lib/esm/kujira/kujira.denom/types/tx.js
/* eslint-disable */


const types_tx_protobufPackage = "kujira.denom";
const baseMsgCreateDenom = { sender: "", nonce: "" };
const MsgCreateDenom = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.sender !== "") {
            writer.uint32(10).string(message.sender);
        }
        if (message.nonce !== "") {
            writer.uint32(18).string(message.nonce);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgCreateDenom);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.sender = reader.string();
                    break;
                case 2:
                    message.nonce = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgCreateDenom);
        if (object.sender !== undefined && object.sender !== null) {
            message.sender = String(object.sender);
        }
        else {
            message.sender = "";
        }
        if (object.nonce !== undefined && object.nonce !== null) {
            message.nonce = String(object.nonce);
        }
        else {
            message.nonce = "";
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.sender !== undefined && (obj.sender = message.sender);
        message.nonce !== undefined && (obj.nonce = message.nonce);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseMsgCreateDenom);
        if (object.sender !== undefined && object.sender !== null) {
            message.sender = object.sender;
        }
        else {
            message.sender = "";
        }
        if (object.nonce !== undefined && object.nonce !== null) {
            message.nonce = object.nonce;
        }
        else {
            message.nonce = "";
        }
        return message;
    },
};
const baseMsgCreateDenomResponse = { new_token_denom: "" };
const MsgCreateDenomResponse = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.new_token_denom !== "") {
            writer.uint32(10).string(message.new_token_denom);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgCreateDenomResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.new_token_denom = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgCreateDenomResponse);
        if (object.new_token_denom !== undefined &&
            object.new_token_denom !== null) {
            message.new_token_denom = String(object.new_token_denom);
        }
        else {
            message.new_token_denom = "";
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.new_token_denom !== undefined &&
            (obj.new_token_denom = message.new_token_denom);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseMsgCreateDenomResponse);
        if (object.new_token_denom !== undefined &&
            object.new_token_denom !== null) {
            message.new_token_denom = object.new_token_denom;
        }
        else {
            message.new_token_denom = "";
        }
        return message;
    },
};
const baseMsgMint = { sender: "", recipient: "" };
const MsgMint = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.sender !== "") {
            writer.uint32(10).string(message.sender);
        }
        if (message.amount !== undefined) {
            coin.Coin.encode(message.amount, writer.uint32(18).fork()).ldelim();
        }
        if (message.recipient !== "") {
            writer.uint32(26).string(message.recipient);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgMint);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.sender = reader.string();
                    break;
                case 2:
                    message.amount = coin.Coin.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.recipient = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgMint);
        if (object.sender !== undefined && object.sender !== null) {
            message.sender = String(object.sender);
        }
        else {
            message.sender = "";
        }
        if (object.amount !== undefined && object.amount !== null) {
            message.amount = coin.Coin.fromJSON(object.amount);
        }
        else {
            message.amount = undefined;
        }
        if (object.recipient !== undefined && object.recipient !== null) {
            message.recipient = String(object.recipient);
        }
        else {
            message.recipient = "";
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.sender !== undefined && (obj.sender = message.sender);
        message.amount !== undefined &&
            (obj.amount = message.amount ? coin.Coin.toJSON(message.amount) : undefined);
        message.recipient !== undefined && (obj.recipient = message.recipient);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseMsgMint);
        if (object.sender !== undefined && object.sender !== null) {
            message.sender = object.sender;
        }
        else {
            message.sender = "";
        }
        if (object.amount !== undefined && object.amount !== null) {
            message.amount = coin.Coin.fromPartial(object.amount);
        }
        else {
            message.amount = undefined;
        }
        if (object.recipient !== undefined && object.recipient !== null) {
            message.recipient = object.recipient;
        }
        else {
            message.recipient = "";
        }
        return message;
    },
};
const baseMsgMintResponse = {};
const MsgMintResponse = {
    encode(_, writer = minimal.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgMintResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgMintResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgMintResponse);
        return message;
    },
};
const baseMsgBurn = { sender: "" };
const MsgBurn = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.sender !== "") {
            writer.uint32(10).string(message.sender);
        }
        if (message.amount !== undefined) {
            coin.Coin.encode(message.amount, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgBurn);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.sender = reader.string();
                    break;
                case 2:
                    message.amount = coin.Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgBurn);
        if (object.sender !== undefined && object.sender !== null) {
            message.sender = String(object.sender);
        }
        else {
            message.sender = "";
        }
        if (object.amount !== undefined && object.amount !== null) {
            message.amount = coin.Coin.fromJSON(object.amount);
        }
        else {
            message.amount = undefined;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.sender !== undefined && (obj.sender = message.sender);
        message.amount !== undefined &&
            (obj.amount = message.amount ? coin.Coin.toJSON(message.amount) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseMsgBurn);
        if (object.sender !== undefined && object.sender !== null) {
            message.sender = object.sender;
        }
        else {
            message.sender = "";
        }
        if (object.amount !== undefined && object.amount !== null) {
            message.amount = coin.Coin.fromPartial(object.amount);
        }
        else {
            message.amount = undefined;
        }
        return message;
    },
};
const baseMsgBurnResponse = {};
const MsgBurnResponse = {
    encode(_, writer = minimal.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgBurnResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgBurnResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgBurnResponse);
        return message;
    },
};
const baseMsgChangeAdmin = { sender: "", denom: "", newAdmin: "" };
const MsgChangeAdmin = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.sender !== "") {
            writer.uint32(10).string(message.sender);
        }
        if (message.denom !== "") {
            writer.uint32(18).string(message.denom);
        }
        if (message.newAdmin !== "") {
            writer.uint32(26).string(message.newAdmin);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgChangeAdmin);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.sender = reader.string();
                    break;
                case 2:
                    message.denom = reader.string();
                    break;
                case 3:
                    message.newAdmin = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgChangeAdmin);
        if (object.sender !== undefined && object.sender !== null) {
            message.sender = String(object.sender);
        }
        else {
            message.sender = "";
        }
        if (object.denom !== undefined && object.denom !== null) {
            message.denom = String(object.denom);
        }
        else {
            message.denom = "";
        }
        if (object.newAdmin !== undefined && object.newAdmin !== null) {
            message.newAdmin = String(object.newAdmin);
        }
        else {
            message.newAdmin = "";
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.sender !== undefined && (obj.sender = message.sender);
        message.denom !== undefined && (obj.denom = message.denom);
        message.newAdmin !== undefined && (obj.newAdmin = message.newAdmin);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseMsgChangeAdmin);
        if (object.sender !== undefined && object.sender !== null) {
            message.sender = object.sender;
        }
        else {
            message.sender = "";
        }
        if (object.denom !== undefined && object.denom !== null) {
            message.denom = object.denom;
        }
        else {
            message.denom = "";
        }
        if (object.newAdmin !== undefined && object.newAdmin !== null) {
            message.newAdmin = object.newAdmin;
        }
        else {
            message.newAdmin = "";
        }
        return message;
    },
};
const baseMsgChangeAdminResponse = {};
const MsgChangeAdminResponse = {
    encode(_, writer = minimal.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgChangeAdminResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgChangeAdminResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgChangeAdminResponse);
        return message;
    },
};

;// CONCATENATED MODULE: ./node_modules/kujira.js/lib/esm/kujira/kujira.denom/types/authorityMetadata.js

const authorityMetadata_protobufPackage = "kujira.denom";
const baseDenomAuthorityMetadata = { Admin: "" };
const DenomAuthorityMetadata = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.Admin !== "") {
            writer.uint32(10).string(message.Admin);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseDenomAuthorityMetadata);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.Admin = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseDenomAuthorityMetadata);
        if (object.Admin !== undefined && object.Admin !== null) {
            message.Admin = String(object.Admin);
        }
        else {
            message.Admin = "";
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.Admin !== undefined && (obj.Admin = message.Admin);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseDenomAuthorityMetadata);
        if (object.Admin !== undefined && object.Admin !== null) {
            message.Admin = object.Admin;
        }
        else {
            message.Admin = "";
        }
        return message;
    },
};

;// CONCATENATED MODULE: ./node_modules/kujira.js/lib/esm/kujira/kujira.denom/types/params.js


const types_params_protobufPackage = "kujira.denom";
const baseParams = {};
const types_params_Params = {
    encode(message, writer = minimal.Writer.create()) {
        for (const v of message.creation_fee) {
            coin.Coin.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseParams);
        message.creation_fee = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creation_fee.push(coin.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseParams);
        message.creation_fee = [];
        if (object.creation_fee !== undefined && object.creation_fee !== null) {
            for (const e of object.creation_fee) {
                message.creation_fee.push(coin.Coin.fromJSON(e));
            }
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.creation_fee) {
            obj.creation_fee = message.creation_fee.map((e) => e ? coin.Coin.toJSON(e) : undefined);
        }
        else {
            obj.creation_fee = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseParams);
        message.creation_fee = [];
        if (object.creation_fee !== undefined && object.creation_fee !== null) {
            for (const e of object.creation_fee) {
                message.creation_fee.push(coin.Coin.fromPartial(e));
            }
        }
        return message;
    },
};

;// CONCATENATED MODULE: ./node_modules/kujira.js/lib/esm/kujira/kujira.denom/types/query.js
var query_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};



const types_query_protobufPackage = "kujira.denom";
const baseQueryParamsRequest = {};
const types_query_QueryParamsRequest = {
    encode(_, writer = minimal.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryParamsRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseQueryParamsRequest);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseQueryParamsRequest);
        return message;
    },
};
const baseQueryParamsResponse = {};
const types_query_QueryParamsResponse = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.params !== undefined) {
            types_params_Params.encode(message.params, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryParamsResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.params = types_params_Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryParamsResponse);
        if (object.params !== undefined && object.params !== null) {
            message.params = types_params_Params.fromJSON(object.params);
        }
        else {
            message.params = undefined;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.params !== undefined &&
            (obj.params = message.params ? types_params_Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryParamsResponse);
        if (object.params !== undefined && object.params !== null) {
            message.params = types_params_Params.fromPartial(object.params);
        }
        else {
            message.params = undefined;
        }
        return message;
    },
};
const baseQueryDenomAuthorityMetadataRequest = { denom: "" };
const QueryDenomAuthorityMetadataRequest = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.denom !== "") {
            writer.uint32(10).string(message.denom);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryDenomAuthorityMetadataRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.denom = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryDenomAuthorityMetadataRequest);
        if (object.denom !== undefined && object.denom !== null) {
            message.denom = String(object.denom);
        }
        else {
            message.denom = "";
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.denom !== undefined && (obj.denom = message.denom);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryDenomAuthorityMetadataRequest);
        if (object.denom !== undefined && object.denom !== null) {
            message.denom = object.denom;
        }
        else {
            message.denom = "";
        }
        return message;
    },
};
const baseQueryDenomAuthorityMetadataResponse = {};
const QueryDenomAuthorityMetadataResponse = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.authority_metadata !== undefined) {
            DenomAuthorityMetadata.encode(message.authority_metadata, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryDenomAuthorityMetadataResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.authority_metadata = DenomAuthorityMetadata.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryDenomAuthorityMetadataResponse);
        if (object.authority_metadata !== undefined &&
            object.authority_metadata !== null) {
            message.authority_metadata = DenomAuthorityMetadata.fromJSON(object.authority_metadata);
        }
        else {
            message.authority_metadata = undefined;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.authority_metadata !== undefined &&
            (obj.authority_metadata = message.authority_metadata
                ? DenomAuthorityMetadata.toJSON(message.authority_metadata)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryDenomAuthorityMetadataResponse);
        if (object.authority_metadata !== undefined &&
            object.authority_metadata !== null) {
            message.authority_metadata = DenomAuthorityMetadata.fromPartial(object.authority_metadata);
        }
        else {
            message.authority_metadata = undefined;
        }
        return message;
    },
};
const baseQueryDenomsFromCreatorRequest = { creator: "" };
const QueryDenomsFromCreatorRequest = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryDenomsFromCreatorRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryDenomsFromCreatorRequest);
        if (object.creator !== undefined && object.creator !== null) {
            message.creator = String(object.creator);
        }
        else {
            message.creator = "";
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryDenomsFromCreatorRequest);
        if (object.creator !== undefined && object.creator !== null) {
            message.creator = object.creator;
        }
        else {
            message.creator = "";
        }
        return message;
    },
};
const baseQueryDenomsFromCreatorResponse = { denoms: "" };
const QueryDenomsFromCreatorResponse = {
    encode(message, writer = minimal.Writer.create()) {
        for (const v of message.denoms) {
            writer.uint32(10).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryDenomsFromCreatorResponse);
        message.denoms = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.denoms.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryDenomsFromCreatorResponse);
        message.denoms = [];
        if (object.denoms !== undefined && object.denoms !== null) {
            for (const e of object.denoms) {
                message.denoms.push(String(e));
            }
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.denoms) {
            obj.denoms = message.denoms.map((e) => e);
        }
        else {
            obj.denoms = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryDenomsFromCreatorResponse);
        message.denoms = [];
        if (object.denoms !== undefined && object.denoms !== null) {
            for (const e of object.denoms) {
                message.denoms.push(e);
            }
        }
        return message;
    },
};
class types_query_QueryClientImpl {
    constructor(rpc) {
        this.rpc = rpc;
    }
    Params(request) {
        return query_awaiter(this, void 0, void 0, function* () {
            const data = types_query_QueryParamsRequest.encode(request).finish();
            const promise = this.rpc.request("kujira.denom.Query", "Params", data);
            const data_1 = yield promise;
            return types_query_QueryParamsResponse.decode(new minimal.Reader(data_1));
        });
    }
    DenomAuthorityMetadata(request) {
        return query_awaiter(this, void 0, void 0, function* () {
            const data = QueryDenomAuthorityMetadataRequest.encode(request).finish();
            const promise = this.rpc.request("kujira.denom.Query", "DenomAuthorityMetadata", data);
            const data_1 = yield promise;
            return QueryDenomAuthorityMetadataResponse.decode(new minimal.Reader(data_1));
        });
    }
    DenomsFromCreator(request) {
        return query_awaiter(this, void 0, void 0, function* () {
            const data = QueryDenomsFromCreatorRequest.encode(request).finish();
            const promise = this.rpc.request("kujira.denom.Query", "DenomsFromCreator", data);
            const data_1 = yield promise;
            return QueryDenomsFromCreatorResponse.decode(new minimal.Reader(data_1));
        });
    }
}

;// CONCATENATED MODULE: ./node_modules/kujira.js/lib/esm/kujira/kujira.denom/queries.js
var kujira_denom_queries_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};



function setupDenomExtension(base) {
    const rpc = (0,stargate_build.createProtobufRpcClient)(base);
    const queryService = new types_query_QueryClientImpl(rpc);
    return {
        denom: {
            params: () => kujira_denom_queries_awaiter(this, void 0, void 0, function* () {
                const { params } = yield queryService.Params({});
                (0,utils_build.assert)(params);
                return params;
            }),
            fromCreator: (creator) => kujira_denom_queries_awaiter(this, void 0, void 0, function* () {
                const { denoms } = yield queryService.DenomsFromCreator({
                    creator,
                });
                return denoms;
            }),
            authorityMetadata: (denom) => kujira_denom_queries_awaiter(this, void 0, void 0, function* () {
                const { authority_metadata } = yield queryService.DenomAuthorityMetadata({
                    denom,
                });
                (0,utils_build.assert)(authority_metadata);
                return authority_metadata;
            }),
        },
    };
}

;// CONCATENATED MODULE: ./node_modules/kujira.js/lib/esm/kujira/kujira.denom/index.js



const kujira_denom_types = [
    ["/kujira.denom.MsgBurn", MsgBurn],
    ["/kujira.denom.MsgChangeAdmin", MsgChangeAdmin],
    ["/kujira.denom.MsgCreateDenom", MsgCreateDenom],
    ["/kujira.denom.MsgMint", MsgMint],
];
const kujira_denom_registry = new proto_signing_build.Registry(kujira_denom_types);
const kujira_denom_msg = {
    msgBurn: (data) => ({
        typeUrl: "/kujira.denom.MsgBurn",
        value: MsgBurn.fromPartial(data),
    }),
    msgChangeAdmin: (data) => ({
        typeUrl: "/kujira.denom.MsgChangeAdmin",
        value: MsgChangeAdmin.fromPartial(data),
    }),
    msgCreateDenom: (data) => ({
        typeUrl: "/kujira.denom.MsgCreateDenom",
        value: MsgCreateDenom.fromPartial(data),
    }),
    msgMint: (data) => ({
        typeUrl: "/kujira.denom.MsgMint",
        value: MsgMint.fromPartial(data),
    }),
};


;// CONCATENATED MODULE: ./node_modules/kujira.js/lib/esm/kujira/kujira.oracle/types/tx.js

const kujira_oracle_types_tx_protobufPackage = "kujira.oracle";
const baseMsgAggregateExchangeRatePrevote = {
    hash: "",
    feeder: "",
    validator: "",
};
const MsgAggregateExchangeRatePrevote = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.hash !== "") {
            writer.uint32(10).string(message.hash);
        }
        if (message.feeder !== "") {
            writer.uint32(18).string(message.feeder);
        }
        if (message.validator !== "") {
            writer.uint32(26).string(message.validator);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgAggregateExchangeRatePrevote);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.hash = reader.string();
                    break;
                case 2:
                    message.feeder = reader.string();
                    break;
                case 3:
                    message.validator = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgAggregateExchangeRatePrevote);
        if (object.hash !== undefined && object.hash !== null) {
            message.hash = String(object.hash);
        }
        else {
            message.hash = "";
        }
        if (object.feeder !== undefined && object.feeder !== null) {
            message.feeder = String(object.feeder);
        }
        else {
            message.feeder = "";
        }
        if (object.validator !== undefined && object.validator !== null) {
            message.validator = String(object.validator);
        }
        else {
            message.validator = "";
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.hash !== undefined && (obj.hash = message.hash);
        message.feeder !== undefined && (obj.feeder = message.feeder);
        message.validator !== undefined && (obj.validator = message.validator);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseMsgAggregateExchangeRatePrevote);
        if (object.hash !== undefined && object.hash !== null) {
            message.hash = object.hash;
        }
        else {
            message.hash = "";
        }
        if (object.feeder !== undefined && object.feeder !== null) {
            message.feeder = object.feeder;
        }
        else {
            message.feeder = "";
        }
        if (object.validator !== undefined && object.validator !== null) {
            message.validator = object.validator;
        }
        else {
            message.validator = "";
        }
        return message;
    },
};
const baseMsgAggregateExchangeRatePrevoteResponse = {};
const MsgAggregateExchangeRatePrevoteResponse = {
    encode(_, writer = minimal.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgAggregateExchangeRatePrevoteResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgAggregateExchangeRatePrevoteResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgAggregateExchangeRatePrevoteResponse);
        return message;
    },
};
const baseMsgAggregateExchangeRateVote = {
    salt: "",
    exchange_rates: "",
    feeder: "",
    validator: "",
};
const MsgAggregateExchangeRateVote = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.salt !== "") {
            writer.uint32(10).string(message.salt);
        }
        if (message.exchange_rates !== "") {
            writer.uint32(18).string(message.exchange_rates);
        }
        if (message.feeder !== "") {
            writer.uint32(26).string(message.feeder);
        }
        if (message.validator !== "") {
            writer.uint32(34).string(message.validator);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgAggregateExchangeRateVote);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.salt = reader.string();
                    break;
                case 2:
                    message.exchange_rates = reader.string();
                    break;
                case 3:
                    message.feeder = reader.string();
                    break;
                case 4:
                    message.validator = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgAggregateExchangeRateVote);
        if (object.salt !== undefined && object.salt !== null) {
            message.salt = String(object.salt);
        }
        else {
            message.salt = "";
        }
        if (object.exchange_rates !== undefined && object.exchange_rates !== null) {
            message.exchange_rates = String(object.exchange_rates);
        }
        else {
            message.exchange_rates = "";
        }
        if (object.feeder !== undefined && object.feeder !== null) {
            message.feeder = String(object.feeder);
        }
        else {
            message.feeder = "";
        }
        if (object.validator !== undefined && object.validator !== null) {
            message.validator = String(object.validator);
        }
        else {
            message.validator = "";
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.salt !== undefined && (obj.salt = message.salt);
        message.exchange_rates !== undefined &&
            (obj.exchange_rates = message.exchange_rates);
        message.feeder !== undefined && (obj.feeder = message.feeder);
        message.validator !== undefined && (obj.validator = message.validator);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseMsgAggregateExchangeRateVote);
        if (object.salt !== undefined && object.salt !== null) {
            message.salt = object.salt;
        }
        else {
            message.salt = "";
        }
        if (object.exchange_rates !== undefined && object.exchange_rates !== null) {
            message.exchange_rates = object.exchange_rates;
        }
        else {
            message.exchange_rates = "";
        }
        if (object.feeder !== undefined && object.feeder !== null) {
            message.feeder = object.feeder;
        }
        else {
            message.feeder = "";
        }
        if (object.validator !== undefined && object.validator !== null) {
            message.validator = object.validator;
        }
        else {
            message.validator = "";
        }
        return message;
    },
};
const baseMsgAggregateExchangeRateVoteResponse = {};
const MsgAggregateExchangeRateVoteResponse = {
    encode(_, writer = minimal.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgAggregateExchangeRateVoteResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgAggregateExchangeRateVoteResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgAggregateExchangeRateVoteResponse);
        return message;
    },
};
const baseMsgDelegateFeedConsent = { operator: "", delegate: "" };
const MsgDelegateFeedConsent = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.operator !== "") {
            writer.uint32(10).string(message.operator);
        }
        if (message.delegate !== "") {
            writer.uint32(18).string(message.delegate);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgDelegateFeedConsent);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.operator = reader.string();
                    break;
                case 2:
                    message.delegate = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgDelegateFeedConsent);
        if (object.operator !== undefined && object.operator !== null) {
            message.operator = String(object.operator);
        }
        else {
            message.operator = "";
        }
        if (object.delegate !== undefined && object.delegate !== null) {
            message.delegate = String(object.delegate);
        }
        else {
            message.delegate = "";
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.operator !== undefined && (obj.operator = message.operator);
        message.delegate !== undefined && (obj.delegate = message.delegate);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseMsgDelegateFeedConsent);
        if (object.operator !== undefined && object.operator !== null) {
            message.operator = object.operator;
        }
        else {
            message.operator = "";
        }
        if (object.delegate !== undefined && object.delegate !== null) {
            message.delegate = object.delegate;
        }
        else {
            message.delegate = "";
        }
        return message;
    },
};
const baseMsgDelegateFeedConsentResponse = {};
const MsgDelegateFeedConsentResponse = {
    encode(_, writer = minimal.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgDelegateFeedConsentResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgDelegateFeedConsentResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgDelegateFeedConsentResponse);
        return message;
    },
};

;// CONCATENATED MODULE: ./node_modules/kujira.js/lib/esm/kujira/kujira.oracle/types/oracle.js

const oracle_protobufPackage = "kujira.oracle";
const oracle_baseParams = {
    vote_period: 0,
    vote_threshold: "",
    reward_band: "",
    reward_distribution_window: 0,
    slash_fraction: "",
    slash_window: 0,
    min_valid_per_window: "",
};
const oracle_Params = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.vote_period !== 0) {
            writer.uint32(8).uint64(message.vote_period);
        }
        if (message.vote_threshold !== "") {
            writer.uint32(18).string(message.vote_threshold);
        }
        if (message.reward_band !== "") {
            writer.uint32(26).string(message.reward_band);
        }
        if (message.reward_distribution_window !== 0) {
            writer.uint32(32).uint64(message.reward_distribution_window);
        }
        for (const v of message.whitelist) {
            oracle_Denom.encode(v, writer.uint32(42).fork()).ldelim();
        }
        if (message.slash_fraction !== "") {
            writer.uint32(50).string(message.slash_fraction);
        }
        if (message.slash_window !== 0) {
            writer.uint32(56).uint64(message.slash_window);
        }
        if (message.min_valid_per_window !== "") {
            writer.uint32(66).string(message.min_valid_per_window);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, oracle_baseParams);
        message.whitelist = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.vote_period = reader.uint64().toNumber();
                    break;
                case 2:
                    message.vote_threshold = reader.string();
                    break;
                case 3:
                    message.reward_band = reader.string();
                    break;
                case 4:
                    message.reward_distribution_window = reader.uint64().toNumber();
                    break;
                case 5:
                    message.whitelist.push(oracle_Denom.decode(reader, reader.uint32()));
                    break;
                case 6:
                    message.slash_fraction = reader.string();
                    break;
                case 7:
                    message.slash_window = reader.uint64().toNumber();
                    break;
                case 8:
                    message.min_valid_per_window = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, oracle_baseParams);
        message.whitelist = [];
        if (object.vote_period !== undefined && object.vote_period !== null) {
            message.vote_period = Number(object.vote_period);
        }
        else {
            message.vote_period = 0;
        }
        if (object.vote_threshold !== undefined && object.vote_threshold !== null) {
            message.vote_threshold = String(object.vote_threshold);
        }
        else {
            message.vote_threshold = "";
        }
        if (object.reward_band !== undefined && object.reward_band !== null) {
            message.reward_band = String(object.reward_band);
        }
        else {
            message.reward_band = "";
        }
        if (object.reward_distribution_window !== undefined &&
            object.reward_distribution_window !== null) {
            message.reward_distribution_window = Number(object.reward_distribution_window);
        }
        else {
            message.reward_distribution_window = 0;
        }
        if (object.whitelist !== undefined && object.whitelist !== null) {
            for (const e of object.whitelist) {
                message.whitelist.push(oracle_Denom.fromJSON(e));
            }
        }
        if (object.slash_fraction !== undefined && object.slash_fraction !== null) {
            message.slash_fraction = String(object.slash_fraction);
        }
        else {
            message.slash_fraction = "";
        }
        if (object.slash_window !== undefined && object.slash_window !== null) {
            message.slash_window = Number(object.slash_window);
        }
        else {
            message.slash_window = 0;
        }
        if (object.min_valid_per_window !== undefined &&
            object.min_valid_per_window !== null) {
            message.min_valid_per_window = String(object.min_valid_per_window);
        }
        else {
            message.min_valid_per_window = "";
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.vote_period !== undefined &&
            (obj.vote_period = message.vote_period);
        message.vote_threshold !== undefined &&
            (obj.vote_threshold = message.vote_threshold);
        message.reward_band !== undefined &&
            (obj.reward_band = message.reward_band);
        message.reward_distribution_window !== undefined &&
            (obj.reward_distribution_window = message.reward_distribution_window);
        if (message.whitelist) {
            obj.whitelist = message.whitelist.map((e) => e ? oracle_Denom.toJSON(e) : undefined);
        }
        else {
            obj.whitelist = [];
        }
        message.slash_fraction !== undefined &&
            (obj.slash_fraction = message.slash_fraction);
        message.slash_window !== undefined &&
            (obj.slash_window = message.slash_window);
        message.min_valid_per_window !== undefined &&
            (obj.min_valid_per_window = message.min_valid_per_window);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, oracle_baseParams);
        message.whitelist = [];
        if (object.vote_period !== undefined && object.vote_period !== null) {
            message.vote_period = object.vote_period;
        }
        else {
            message.vote_period = 0;
        }
        if (object.vote_threshold !== undefined && object.vote_threshold !== null) {
            message.vote_threshold = object.vote_threshold;
        }
        else {
            message.vote_threshold = "";
        }
        if (object.reward_band !== undefined && object.reward_band !== null) {
            message.reward_band = object.reward_band;
        }
        else {
            message.reward_band = "";
        }
        if (object.reward_distribution_window !== undefined &&
            object.reward_distribution_window !== null) {
            message.reward_distribution_window = object.reward_distribution_window;
        }
        else {
            message.reward_distribution_window = 0;
        }
        if (object.whitelist !== undefined && object.whitelist !== null) {
            for (const e of object.whitelist) {
                message.whitelist.push(oracle_Denom.fromPartial(e));
            }
        }
        if (object.slash_fraction !== undefined && object.slash_fraction !== null) {
            message.slash_fraction = object.slash_fraction;
        }
        else {
            message.slash_fraction = "";
        }
        if (object.slash_window !== undefined && object.slash_window !== null) {
            message.slash_window = object.slash_window;
        }
        else {
            message.slash_window = 0;
        }
        if (object.min_valid_per_window !== undefined &&
            object.min_valid_per_window !== null) {
            message.min_valid_per_window = object.min_valid_per_window;
        }
        else {
            message.min_valid_per_window = "";
        }
        return message;
    },
};
const baseDenom = { name: "" };
const oracle_Denom = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.name !== "") {
            writer.uint32(10).string(message.name);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseDenom);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.name = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseDenom);
        if (object.name !== undefined && object.name !== null) {
            message.name = String(object.name);
        }
        else {
            message.name = "";
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.name !== undefined && (obj.name = message.name);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseDenom);
        if (object.name !== undefined && object.name !== null) {
            message.name = object.name;
        }
        else {
            message.name = "";
        }
        return message;
    },
};
const baseAggregateExchangeRatePrevote = {
    hash: "",
    voter: "",
    submit_block: 0,
};
const AggregateExchangeRatePrevote = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.hash !== "") {
            writer.uint32(10).string(message.hash);
        }
        if (message.voter !== "") {
            writer.uint32(18).string(message.voter);
        }
        if (message.submit_block !== 0) {
            writer.uint32(24).uint64(message.submit_block);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseAggregateExchangeRatePrevote);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.hash = reader.string();
                    break;
                case 2:
                    message.voter = reader.string();
                    break;
                case 3:
                    message.submit_block = reader.uint64().toNumber();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseAggregateExchangeRatePrevote);
        if (object.hash !== undefined && object.hash !== null) {
            message.hash = String(object.hash);
        }
        else {
            message.hash = "";
        }
        if (object.voter !== undefined && object.voter !== null) {
            message.voter = String(object.voter);
        }
        else {
            message.voter = "";
        }
        if (object.submit_block !== undefined && object.submit_block !== null) {
            message.submit_block = Number(object.submit_block);
        }
        else {
            message.submit_block = 0;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.hash !== undefined && (obj.hash = message.hash);
        message.voter !== undefined && (obj.voter = message.voter);
        message.submit_block !== undefined &&
            (obj.submit_block = message.submit_block);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseAggregateExchangeRatePrevote);
        if (object.hash !== undefined && object.hash !== null) {
            message.hash = object.hash;
        }
        else {
            message.hash = "";
        }
        if (object.voter !== undefined && object.voter !== null) {
            message.voter = object.voter;
        }
        else {
            message.voter = "";
        }
        if (object.submit_block !== undefined && object.submit_block !== null) {
            message.submit_block = object.submit_block;
        }
        else {
            message.submit_block = 0;
        }
        return message;
    },
};
const baseAggregateExchangeRateVote = { voter: "" };
const AggregateExchangeRateVote = {
    encode(message, writer = minimal.Writer.create()) {
        for (const v of message.exchange_rate_tuples) {
            ExchangeRateTuple.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.voter !== "") {
            writer.uint32(18).string(message.voter);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseAggregateExchangeRateVote);
        message.exchange_rate_tuples = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.exchange_rate_tuples.push(ExchangeRateTuple.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.voter = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseAggregateExchangeRateVote);
        message.exchange_rate_tuples = [];
        if (object.exchange_rate_tuples !== undefined &&
            object.exchange_rate_tuples !== null) {
            for (const e of object.exchange_rate_tuples) {
                message.exchange_rate_tuples.push(ExchangeRateTuple.fromJSON(e));
            }
        }
        if (object.voter !== undefined && object.voter !== null) {
            message.voter = String(object.voter);
        }
        else {
            message.voter = "";
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.exchange_rate_tuples) {
            obj.exchange_rate_tuples = message.exchange_rate_tuples.map((e) => e ? ExchangeRateTuple.toJSON(e) : undefined);
        }
        else {
            obj.exchange_rate_tuples = [];
        }
        message.voter !== undefined && (obj.voter = message.voter);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseAggregateExchangeRateVote);
        message.exchange_rate_tuples = [];
        if (object.exchange_rate_tuples !== undefined &&
            object.exchange_rate_tuples !== null) {
            for (const e of object.exchange_rate_tuples) {
                message.exchange_rate_tuples.push(ExchangeRateTuple.fromPartial(e));
            }
        }
        if (object.voter !== undefined && object.voter !== null) {
            message.voter = object.voter;
        }
        else {
            message.voter = "";
        }
        return message;
    },
};
const baseExchangeRateTuple = { denom: "", exchange_rate: "" };
const ExchangeRateTuple = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.denom !== "") {
            writer.uint32(10).string(message.denom);
        }
        if (message.exchange_rate !== "") {
            writer.uint32(18).string(message.exchange_rate);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseExchangeRateTuple);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.denom = reader.string();
                    break;
                case 2:
                    message.exchange_rate = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseExchangeRateTuple);
        if (object.denom !== undefined && object.denom !== null) {
            message.denom = String(object.denom);
        }
        else {
            message.denom = "";
        }
        if (object.exchange_rate !== undefined && object.exchange_rate !== null) {
            message.exchange_rate = String(object.exchange_rate);
        }
        else {
            message.exchange_rate = "";
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.denom !== undefined && (obj.denom = message.denom);
        message.exchange_rate !== undefined &&
            (obj.exchange_rate = message.exchange_rate);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseExchangeRateTuple);
        if (object.denom !== undefined && object.denom !== null) {
            message.denom = object.denom;
        }
        else {
            message.denom = "";
        }
        if (object.exchange_rate !== undefined && object.exchange_rate !== null) {
            message.exchange_rate = object.exchange_rate;
        }
        else {
            message.exchange_rate = "";
        }
        return message;
    },
};

;// CONCATENATED MODULE: ./node_modules/kujira.js/lib/esm/kujira/kujira.oracle/types/query.js



const kujira_oracle_types_query_protobufPackage = "kujira.oracle";
const baseQueryExchangeRateRequest = { denom: "" };
const QueryExchangeRateRequest = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.denom !== "") {
            writer.uint32(10).string(message.denom);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryExchangeRateRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.denom = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryExchangeRateRequest);
        if (object.denom !== undefined && object.denom !== null) {
            message.denom = String(object.denom);
        }
        else {
            message.denom = "";
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.denom !== undefined && (obj.denom = message.denom);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryExchangeRateRequest);
        if (object.denom !== undefined && object.denom !== null) {
            message.denom = object.denom;
        }
        else {
            message.denom = "";
        }
        return message;
    },
};
const baseQueryExchangeRateResponse = { exchange_rate: "" };
const QueryExchangeRateResponse = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.exchange_rate !== "") {
            writer.uint32(10).string(message.exchange_rate);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryExchangeRateResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.exchange_rate = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryExchangeRateResponse);
        if (object.exchange_rate !== undefined && object.exchange_rate !== null) {
            message.exchange_rate = String(object.exchange_rate);
        }
        else {
            message.exchange_rate = "";
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.exchange_rate !== undefined &&
            (obj.exchange_rate = message.exchange_rate);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryExchangeRateResponse);
        if (object.exchange_rate !== undefined && object.exchange_rate !== null) {
            message.exchange_rate = object.exchange_rate;
        }
        else {
            message.exchange_rate = "";
        }
        return message;
    },
};
const baseQueryExchangeRatesRequest = {};
const QueryExchangeRatesRequest = {
    encode(_, writer = minimal.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryExchangeRatesRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseQueryExchangeRatesRequest);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseQueryExchangeRatesRequest);
        return message;
    },
};
const baseQueryExchangeRatesResponse = {};
const QueryExchangeRatesResponse = {
    encode(message, writer = minimal.Writer.create()) {
        for (const v of message.exchange_rates) {
            coin.DecCoin.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryExchangeRatesResponse);
        message.exchange_rates = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.exchange_rates.push(coin.DecCoin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryExchangeRatesResponse);
        message.exchange_rates = [];
        if (object.exchange_rates !== undefined && object.exchange_rates !== null) {
            for (const e of object.exchange_rates) {
                message.exchange_rates.push(coin.DecCoin.fromJSON(e));
            }
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.exchange_rates) {
            obj.exchange_rates = message.exchange_rates.map((e) => e ? coin.DecCoin.toJSON(e) : undefined);
        }
        else {
            obj.exchange_rates = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryExchangeRatesResponse);
        message.exchange_rates = [];
        if (object.exchange_rates !== undefined && object.exchange_rates !== null) {
            for (const e of object.exchange_rates) {
                message.exchange_rates.push(coin.DecCoin.fromPartial(e));
            }
        }
        return message;
    },
};
const baseQueryActivesRequest = {};
const QueryActivesRequest = {
    encode(_, writer = minimal.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryActivesRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseQueryActivesRequest);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseQueryActivesRequest);
        return message;
    },
};
const baseQueryActivesResponse = { actives: "" };
const QueryActivesResponse = {
    encode(message, writer = minimal.Writer.create()) {
        for (const v of message.actives) {
            writer.uint32(10).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryActivesResponse);
        message.actives = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.actives.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryActivesResponse);
        message.actives = [];
        if (object.actives !== undefined && object.actives !== null) {
            for (const e of object.actives) {
                message.actives.push(String(e));
            }
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.actives) {
            obj.actives = message.actives.map((e) => e);
        }
        else {
            obj.actives = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryActivesResponse);
        message.actives = [];
        if (object.actives !== undefined && object.actives !== null) {
            for (const e of object.actives) {
                message.actives.push(e);
            }
        }
        return message;
    },
};
const baseQueryVoteTargetsRequest = {};
const QueryVoteTargetsRequest = {
    encode(_, writer = minimal.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryVoteTargetsRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseQueryVoteTargetsRequest);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseQueryVoteTargetsRequest);
        return message;
    },
};
const baseQueryVoteTargetsResponse = { vote_targets: "" };
const QueryVoteTargetsResponse = {
    encode(message, writer = minimal.Writer.create()) {
        for (const v of message.vote_targets) {
            writer.uint32(10).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryVoteTargetsResponse);
        message.vote_targets = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.vote_targets.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryVoteTargetsResponse);
        message.vote_targets = [];
        if (object.vote_targets !== undefined && object.vote_targets !== null) {
            for (const e of object.vote_targets) {
                message.vote_targets.push(String(e));
            }
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.vote_targets) {
            obj.vote_targets = message.vote_targets.map((e) => e);
        }
        else {
            obj.vote_targets = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryVoteTargetsResponse);
        message.vote_targets = [];
        if (object.vote_targets !== undefined && object.vote_targets !== null) {
            for (const e of object.vote_targets) {
                message.vote_targets.push(e);
            }
        }
        return message;
    },
};
const baseQueryFeederDelegationRequest = { validator_addr: "" };
const QueryFeederDelegationRequest = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.validator_addr !== "") {
            writer.uint32(10).string(message.validator_addr);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryFeederDelegationRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.validator_addr = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryFeederDelegationRequest);
        if (object.validator_addr !== undefined && object.validator_addr !== null) {
            message.validator_addr = String(object.validator_addr);
        }
        else {
            message.validator_addr = "";
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.validator_addr !== undefined &&
            (obj.validator_addr = message.validator_addr);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryFeederDelegationRequest);
        if (object.validator_addr !== undefined && object.validator_addr !== null) {
            message.validator_addr = object.validator_addr;
        }
        else {
            message.validator_addr = "";
        }
        return message;
    },
};
const baseQueryFeederDelegationResponse = { feeder_addr: "" };
const QueryFeederDelegationResponse = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.feeder_addr !== "") {
            writer.uint32(10).string(message.feeder_addr);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryFeederDelegationResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.feeder_addr = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryFeederDelegationResponse);
        if (object.feeder_addr !== undefined && object.feeder_addr !== null) {
            message.feeder_addr = String(object.feeder_addr);
        }
        else {
            message.feeder_addr = "";
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.feeder_addr !== undefined &&
            (obj.feeder_addr = message.feeder_addr);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryFeederDelegationResponse);
        if (object.feeder_addr !== undefined && object.feeder_addr !== null) {
            message.feeder_addr = object.feeder_addr;
        }
        else {
            message.feeder_addr = "";
        }
        return message;
    },
};
const baseQueryMissCounterRequest = { validator_addr: "" };
const QueryMissCounterRequest = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.validator_addr !== "") {
            writer.uint32(10).string(message.validator_addr);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryMissCounterRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.validator_addr = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryMissCounterRequest);
        if (object.validator_addr !== undefined && object.validator_addr !== null) {
            message.validator_addr = String(object.validator_addr);
        }
        else {
            message.validator_addr = "";
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.validator_addr !== undefined &&
            (obj.validator_addr = message.validator_addr);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryMissCounterRequest);
        if (object.validator_addr !== undefined && object.validator_addr !== null) {
            message.validator_addr = object.validator_addr;
        }
        else {
            message.validator_addr = "";
        }
        return message;
    },
};
const baseQueryMissCounterResponse = { miss_counter: 0 };
const QueryMissCounterResponse = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.miss_counter !== 0) {
            writer.uint32(8).uint64(message.miss_counter);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryMissCounterResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.miss_counter = reader.uint64().toNumber();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryMissCounterResponse);
        if (object.miss_counter !== undefined && object.miss_counter !== null) {
            message.miss_counter = Number(object.miss_counter);
        }
        else {
            message.miss_counter = 0;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.miss_counter !== undefined &&
            (obj.miss_counter = message.miss_counter);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryMissCounterResponse);
        if (object.miss_counter !== undefined && object.miss_counter !== null) {
            message.miss_counter = object.miss_counter;
        }
        else {
            message.miss_counter = 0;
        }
        return message;
    },
};
const baseQueryAggregatePrevoteRequest = { validator_addr: "" };
const QueryAggregatePrevoteRequest = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.validator_addr !== "") {
            writer.uint32(10).string(message.validator_addr);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAggregatePrevoteRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.validator_addr = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryAggregatePrevoteRequest);
        if (object.validator_addr !== undefined && object.validator_addr !== null) {
            message.validator_addr = String(object.validator_addr);
        }
        else {
            message.validator_addr = "";
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.validator_addr !== undefined &&
            (obj.validator_addr = message.validator_addr);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryAggregatePrevoteRequest);
        if (object.validator_addr !== undefined && object.validator_addr !== null) {
            message.validator_addr = object.validator_addr;
        }
        else {
            message.validator_addr = "";
        }
        return message;
    },
};
const baseQueryAggregatePrevoteResponse = {};
const QueryAggregatePrevoteResponse = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.aggregate_prevote !== undefined) {
            AggregateExchangeRatePrevote.encode(message.aggregate_prevote, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAggregatePrevoteResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.aggregate_prevote = AggregateExchangeRatePrevote.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryAggregatePrevoteResponse);
        if (object.aggregate_prevote !== undefined &&
            object.aggregate_prevote !== null) {
            message.aggregate_prevote = AggregateExchangeRatePrevote.fromJSON(object.aggregate_prevote);
        }
        else {
            message.aggregate_prevote = undefined;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.aggregate_prevote !== undefined &&
            (obj.aggregate_prevote = message.aggregate_prevote
                ? AggregateExchangeRatePrevote.toJSON(message.aggregate_prevote)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryAggregatePrevoteResponse);
        if (object.aggregate_prevote !== undefined &&
            object.aggregate_prevote !== null) {
            message.aggregate_prevote = AggregateExchangeRatePrevote.fromPartial(object.aggregate_prevote);
        }
        else {
            message.aggregate_prevote = undefined;
        }
        return message;
    },
};
const baseQueryAggregatePrevotesRequest = {};
const QueryAggregatePrevotesRequest = {
    encode(_, writer = minimal.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAggregatePrevotesRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseQueryAggregatePrevotesRequest);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseQueryAggregatePrevotesRequest);
        return message;
    },
};
const baseQueryAggregatePrevotesResponse = {};
const QueryAggregatePrevotesResponse = {
    encode(message, writer = minimal.Writer.create()) {
        for (const v of message.aggregate_prevotes) {
            AggregateExchangeRatePrevote.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAggregatePrevotesResponse);
        message.aggregate_prevotes = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.aggregate_prevotes.push(AggregateExchangeRatePrevote.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryAggregatePrevotesResponse);
        message.aggregate_prevotes = [];
        if (object.aggregate_prevotes !== undefined &&
            object.aggregate_prevotes !== null) {
            for (const e of object.aggregate_prevotes) {
                message.aggregate_prevotes.push(AggregateExchangeRatePrevote.fromJSON(e));
            }
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.aggregate_prevotes) {
            obj.aggregate_prevotes = message.aggregate_prevotes.map((e) => e ? AggregateExchangeRatePrevote.toJSON(e) : undefined);
        }
        else {
            obj.aggregate_prevotes = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryAggregatePrevotesResponse);
        message.aggregate_prevotes = [];
        if (object.aggregate_prevotes !== undefined &&
            object.aggregate_prevotes !== null) {
            for (const e of object.aggregate_prevotes) {
                message.aggregate_prevotes.push(AggregateExchangeRatePrevote.fromPartial(e));
            }
        }
        return message;
    },
};
const baseQueryAggregateVoteRequest = { validator_addr: "" };
const QueryAggregateVoteRequest = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.validator_addr !== "") {
            writer.uint32(10).string(message.validator_addr);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAggregateVoteRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.validator_addr = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryAggregateVoteRequest);
        if (object.validator_addr !== undefined && object.validator_addr !== null) {
            message.validator_addr = String(object.validator_addr);
        }
        else {
            message.validator_addr = "";
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.validator_addr !== undefined &&
            (obj.validator_addr = message.validator_addr);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryAggregateVoteRequest);
        if (object.validator_addr !== undefined && object.validator_addr !== null) {
            message.validator_addr = object.validator_addr;
        }
        else {
            message.validator_addr = "";
        }
        return message;
    },
};
const baseQueryAggregateVoteResponse = {};
const QueryAggregateVoteResponse = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.aggregate_vote !== undefined) {
            AggregateExchangeRateVote.encode(message.aggregate_vote, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAggregateVoteResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.aggregate_vote = AggregateExchangeRateVote.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryAggregateVoteResponse);
        if (object.aggregate_vote !== undefined && object.aggregate_vote !== null) {
            message.aggregate_vote = AggregateExchangeRateVote.fromJSON(object.aggregate_vote);
        }
        else {
            message.aggregate_vote = undefined;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.aggregate_vote !== undefined &&
            (obj.aggregate_vote = message.aggregate_vote
                ? AggregateExchangeRateVote.toJSON(message.aggregate_vote)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryAggregateVoteResponse);
        if (object.aggregate_vote !== undefined && object.aggregate_vote !== null) {
            message.aggregate_vote = AggregateExchangeRateVote.fromPartial(object.aggregate_vote);
        }
        else {
            message.aggregate_vote = undefined;
        }
        return message;
    },
};
const baseQueryAggregateVotesRequest = {};
const QueryAggregateVotesRequest = {
    encode(_, writer = minimal.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAggregateVotesRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseQueryAggregateVotesRequest);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseQueryAggregateVotesRequest);
        return message;
    },
};
const baseQueryAggregateVotesResponse = {};
const QueryAggregateVotesResponse = {
    encode(message, writer = minimal.Writer.create()) {
        for (const v of message.aggregate_votes) {
            AggregateExchangeRateVote.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAggregateVotesResponse);
        message.aggregate_votes = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.aggregate_votes.push(AggregateExchangeRateVote.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryAggregateVotesResponse);
        message.aggregate_votes = [];
        if (object.aggregate_votes !== undefined &&
            object.aggregate_votes !== null) {
            for (const e of object.aggregate_votes) {
                message.aggregate_votes.push(AggregateExchangeRateVote.fromJSON(e));
            }
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.aggregate_votes) {
            obj.aggregate_votes = message.aggregate_votes.map((e) => e ? AggregateExchangeRateVote.toJSON(e) : undefined);
        }
        else {
            obj.aggregate_votes = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryAggregateVotesResponse);
        message.aggregate_votes = [];
        if (object.aggregate_votes !== undefined &&
            object.aggregate_votes !== null) {
            for (const e of object.aggregate_votes) {
                message.aggregate_votes.push(AggregateExchangeRateVote.fromPartial(e));
            }
        }
        return message;
    },
};
const query_baseQueryParamsRequest = {};
const kujira_oracle_types_query_QueryParamsRequest = {
    encode(_, writer = minimal.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, query_baseQueryParamsRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, query_baseQueryParamsRequest);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, query_baseQueryParamsRequest);
        return message;
    },
};
const query_baseQueryParamsResponse = {};
const kujira_oracle_types_query_QueryParamsResponse = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.params !== undefined) {
            oracle_Params.encode(message.params, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, query_baseQueryParamsResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.params = oracle_Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, query_baseQueryParamsResponse);
        if (object.params !== undefined && object.params !== null) {
            message.params = oracle_Params.fromJSON(object.params);
        }
        else {
            message.params = undefined;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.params !== undefined &&
            (obj.params = message.params ? oracle_Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, query_baseQueryParamsResponse);
        if (object.params !== undefined && object.params !== null) {
            message.params = oracle_Params.fromPartial(object.params);
        }
        else {
            message.params = undefined;
        }
        return message;
    },
};
class kujira_oracle_types_query_QueryClientImpl {
    constructor(rpc) {
        this.rpc = rpc;
    }
    ExchangeRate(request) {
        const data = QueryExchangeRateRequest.encode(request).finish();
        const promise = this.rpc.request("kujira.oracle.Query", "ExchangeRate", data);
        return promise.then((data) => QueryExchangeRateResponse.decode(new minimal.Reader(data)));
    }
    ExchangeRates(request) {
        const data = QueryExchangeRatesRequest.encode(request).finish();
        const promise = this.rpc.request("kujira.oracle.Query", "ExchangeRates", data);
        return promise.then((data) => QueryExchangeRatesResponse.decode(new minimal.Reader(data)));
    }
    Actives(request) {
        const data = QueryActivesRequest.encode(request).finish();
        const promise = this.rpc.request("kujira.oracle.Query", "Actives", data);
        return promise.then((data) => QueryActivesResponse.decode(new minimal.Reader(data)));
    }
    FeederDelegation(request) {
        const data = QueryFeederDelegationRequest.encode(request).finish();
        const promise = this.rpc.request("kujira.oracle.Query", "FeederDelegation", data);
        return promise.then((data) => QueryFeederDelegationResponse.decode(new minimal.Reader(data)));
    }
    MissCounter(request) {
        const data = QueryMissCounterRequest.encode(request).finish();
        const promise = this.rpc.request("kujira.oracle.Query", "MissCounter", data);
        return promise.then((data) => QueryMissCounterResponse.decode(new minimal.Reader(data)));
    }
    AggregatePrevote(request) {
        const data = QueryAggregatePrevoteRequest.encode(request).finish();
        const promise = this.rpc.request("kujira.oracle.Query", "AggregatePrevote", data);
        return promise.then((data) => QueryAggregatePrevoteResponse.decode(new minimal.Reader(data)));
    }
    AggregatePrevotes(request) {
        const data = QueryAggregatePrevotesRequest.encode(request).finish();
        const promise = this.rpc.request("kujira.oracle.Query", "AggregatePrevotes", data);
        return promise.then((data) => QueryAggregatePrevotesResponse.decode(new minimal.Reader(data)));
    }
    AggregateVote(request) {
        const data = QueryAggregateVoteRequest.encode(request).finish();
        const promise = this.rpc.request("kujira.oracle.Query", "AggregateVote", data);
        return promise.then((data) => QueryAggregateVoteResponse.decode(new minimal.Reader(data)));
    }
    AggregateVotes(request) {
        const data = QueryAggregateVotesRequest.encode(request).finish();
        const promise = this.rpc.request("kujira.oracle.Query", "AggregateVotes", data);
        return promise.then((data) => QueryAggregateVotesResponse.decode(new minimal.Reader(data)));
    }
    Params(request) {
        const data = kujira_oracle_types_query_QueryParamsRequest.encode(request).finish();
        const promise = this.rpc.request("kujira.oracle.Query", "Params", data);
        return promise.then((data) => kujira_oracle_types_query_QueryParamsResponse.decode(new minimal.Reader(data)));
    }
}

;// CONCATENATED MODULE: ./node_modules/kujira.js/lib/esm/kujira/kujira.oracle/queries.js
var kujira_oracle_queries_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};



function setupOracleExtension(base) {
    const rpc = (0,stargate_build.createProtobufRpcClient)(base);
    const queryService = new kujira_oracle_types_query_QueryClientImpl(rpc);
    return {
        oracle: {
            params: () => kujira_oracle_queries_awaiter(this, void 0, void 0, function* () {
                const { params } = yield queryService.Params({});
                (0,utils_build.assert)(params);
                return params;
            }),
            exchangeRate: (denom) => kujira_oracle_queries_awaiter(this, void 0, void 0, function* () { return queryService.ExchangeRate({ denom }); }),
            exchangeRates: () => kujira_oracle_queries_awaiter(this, void 0, void 0, function* () { return queryService.ExchangeRates({}); }),
            actives: () => kujira_oracle_queries_awaiter(this, void 0, void 0, function* () { return queryService.Actives({}); }),
            feederDelegation: (validator_addr) => kujira_oracle_queries_awaiter(this, void 0, void 0, function* () { return queryService.FeederDelegation({ validator_addr }); }),
            missCounter: (validator_addr) => kujira_oracle_queries_awaiter(this, void 0, void 0, function* () { return queryService.MissCounter({ validator_addr }); }),
            aggregatePrevote: (validator_addr) => kujira_oracle_queries_awaiter(this, void 0, void 0, function* () { return queryService.AggregatePrevote({ validator_addr }); }),
            aggregatePrevotes: () => kujira_oracle_queries_awaiter(this, void 0, void 0, function* () { return queryService.AggregatePrevotes({}); }),
            aggregateVote: (validator_addr) => kujira_oracle_queries_awaiter(this, void 0, void 0, function* () { return queryService.AggregateVote({ validator_addr }); }),
            aggregateVotes: () => kujira_oracle_queries_awaiter(this, void 0, void 0, function* () { return queryService.AggregateVotes({}); }),
        },
    };
}

;// CONCATENATED MODULE: ./node_modules/kujira.js/lib/esm/kujira/kujira.oracle/index.js





const kujira_oracle_types = [
    ["/kujira.oracle.MsgAggregateExchangeRateVote", MsgAggregateExchangeRateVote],
    [
        "/kujira.oracle.MsgAggregateExchangeRatePrevote",
        MsgAggregateExchangeRatePrevote,
    ],
    ["/kujira.oracle.MsgDelegateFeedConsent", MsgDelegateFeedConsent],
];
const MissingWalletError = new Error("wallet is required");
const kujira_oracle_registry = new proto_signing_build.Registry(kujira_oracle_types);
const kujira_oracle_msg = {
    msgAggregateExchangeRateVote: (data) => ({
        typeUrl: "/kujira.oracle.MsgAggregateExchangeRateVote",
        value: MsgAggregateExchangeRateVote.fromPartial(data),
    }),
    msgAggregateExchangeRatePrevote: (data) => ({
        typeUrl: "/kujira.oracle.MsgAggregateExchangeRatePrevote",
        value: MsgAggregateExchangeRatePrevote.fromPartial(data),
    }),
    msgDelegateFeedConsent: (data) => ({
        typeUrl: "/kujira.oracle.MsgDelegateFeedConsent",
        value: MsgDelegateFeedConsent.fromPartial(data),
    }),
};


;// CONCATENATED MODULE: ./node_modules/kujira.js/lib/esm/msg.js














const msg_msg = {
    authz: {
        msgExec: (i) => ({
            typeUrl: "/cosmos.authz.v1beta1.MsgExec",
            value: tx.MsgExec.fromPartial(i),
        }),
        msgGrant: (i) => ({
            typeUrl: "/cosmos.authz.v1beta1.MsgGrant",
            value: tx.MsgGrant.fromPartial(i),
        }),
        msgRevoke: (i) => ({
            typeUrl: "/cosmos.authz.v1beta1.MsgRevoke",
            value: tx.MsgRevoke.fromPartial(i),
        }),
    },
    bank: {
        msgSend: (i) => ({
            typeUrl: "/cosmos.bank.v1beta1.MsgSend",
            value: v1beta1_tx.MsgSend.fromPartial(i),
        }),
        msgMultiSend: (i) => ({
            typeUrl: "/cosmos.bank.v1beta1.MsgMultiSend",
            value: v1beta1_tx.MsgMultiSend.fromPartial(i),
        }),
        msgUpdateParams: (i) => ({
            typeUrl: "/cosmos.bank.v1beta1.MsgUpdateParams",
            value: v1beta1_tx.MsgUpdateParams.fromPartial(i),
        }),
    },
    distribution: {
        msgFundCommunityPool: (i) => ({
            typeUrl: "/cosmos.distribution.v1beta1.MsgFundCommunityPool",
            value: distribution_v1beta1_tx.MsgFundCommunityPool.fromJSON(i),
        }),
        msgSetWithdrawAddress: (i) => ({
            typeUrl: "/cosmos.distribution.v1beta1.MsgSetWithdrawAddress",
            value: distribution_v1beta1_tx.MsgSetWithdrawAddress.fromJSON(i),
        }),
        msgWithdrawDelegatorReward: (i) => ({
            typeUrl: "/cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward",
            value: distribution_v1beta1_tx.MsgWithdrawDelegatorReward.fromJSON(i),
        }),
        msgWithdrawValidatorCommission: (i) => ({
            typeUrl: "/cosmos.distribution.v1beta1.MsgWithdrawValidatorCommission",
            value: distribution_v1beta1_tx.MsgWithdrawValidatorCommission.fromJSON(i),
        }),
        msgUpdateParams: (i) => ({
            typeUrl: "/cosmos.distribution.v1beta1.MsgUpdateParams",
            value: distribution_v1beta1_tx.MsgUpdateParams.fromPartial(i),
        }),
    },
    denom: kujira_denom_msg,
    feegrant: {
        msgGrantAllowance: (i) => ({
            typeUrl: "/cosmos.feegrant.v1beta1.MsgGrantAllowance",
            value: feegrant_v1beta1_tx.MsgGrantAllowance.fromPartial(i),
        }),
        msgRevokeAllowance: (i) => ({
            typeUrl: "/cosmos.feegrant.v1beta1.MsgRevokeAllowance",
            value: feegrant_v1beta1_tx.MsgRevokeAllowance.fromPartial(i),
        }),
    },
    gov: {
        msgDeposit: (i) => ({
            typeUrl: "/cosmos.gov.v1.MsgDeposit",
            value: v1_tx.MsgDeposit.fromJSON(i),
        }),
        msgDepositBeta: (i) => ({
            typeUrl: "/cosmos.gov.v1beta1.MsgDeposit",
            value: gov_v1beta1_tx.MsgDeposit.fromJSON(i),
        }),
        msgSubmitProposal: (i) => ({
            typeUrl: "/cosmos.gov.v1.MsgSubmitProposal",
            value: v1_tx.MsgSubmitProposal.fromPartial(i),
        }),
        msgVote: (i) => ({
            typeUrl: "/cosmos.gov.v1.MsgVote",
            value: v1_tx.MsgVote.fromJSON(i),
        }),
        msgVoteBeta: (i) => ({
            typeUrl: "/cosmos.gov.v1beta1.MsgVote",
            value: gov_v1beta1_tx.MsgVote.fromJSON(i),
        }),
        msgVoteWeighted: (i) => ({
            typeUrl: "/cosmos.gov.v1.MsgVoteWeighted",
            value: v1_tx.MsgVoteWeighted.fromPartial(i),
        }),
        msgUpdateParams: (i) => ({
            typeUrl: "/cosmos.gov.v1.MsgUpdateParams",
            value: v1_tx.MsgUpdateParams.fromPartial(i),
        }),
    },
    oracle: kujira_oracle_msg,
    staking: {
        msgBeginRedelegate: (i) => ({
            typeUrl: "/cosmos.staking.v1beta1.MsgBeginRedelegate",
            value: staking_v1beta1_tx.MsgBeginRedelegate.fromPartial(i),
        }),
        msgCreateValidator: (i) => ({
            typeUrl: "/cosmos.staking.v1beta1.MsgCreateValidator",
            value: staking_v1beta1_tx.MsgCreateValidator.fromPartial(i),
        }),
        msgDelegate: (i) => ({
            typeUrl: "/cosmos.staking.v1beta1.MsgDelegate",
            value: staking_v1beta1_tx.MsgDelegate.fromJSON(i),
        }),
        msgEditValidator: (i) => ({
            typeUrl: "/cosmos.staking.v1beta1.MsgEditValidator",
            value: staking_v1beta1_tx.MsgEditValidator.fromPartial(i),
        }),
        msgUndelegate: (i) => ({
            typeUrl: "/cosmos.staking.v1beta1.MsgUndelegate",
            value: staking_v1beta1_tx.MsgUndelegate.fromPartial(i),
        }),
        msgCancelUnbondingDelegation: (i) => ({
            typeUrl: "/cosmos.staking.v1beta1.MsgCancelUnbondingDelegation",
            value: staking_v1beta1_tx.MsgCancelUnbondingDelegation.fromPartial(i),
        }),
        msgUpdateParams: (i) => ({
            typeUrl: "/cosmos.staking.v1beta1.MsgUpdateParams",
            value: staking_v1beta1_tx.MsgUpdateParams.fromPartial(i),
        }),
    },
    vesting: {
        msgCreateVestingAccount: (i) => ({
            typeUrl: "/cosmos.vesting.v1beta1.MsgCreateVestingAccount",
            value: vesting_v1beta1_tx.MsgCreateVestingAccount.fromPartial(i),
        }),
    },
    wasm: {
        msgClearAdmin: (i) => ({
            typeUrl: "/cosmwasm.wasm.v1.MsgClearAdmin",
            value: wasm_v1_tx.MsgClearAdmin.fromJSON(i),
        }),
        msgExecuteContract: (i) => ({
            typeUrl: "/cosmwasm.wasm.v1.MsgExecuteContract",
            value: wasm_v1_tx.MsgExecuteContract.fromPartial(i),
        }),
        msgMigrateContract: (i) => ({
            typeUrl: "/cosmwasm.wasm.v1.MsgMigrateContract",
            value: wasm_v1_tx.MsgMigrateContract.fromPartial(i),
        }),
        msgStoreCode: (i) => ({
            typeUrl: "/cosmwasm.wasm.v1.MsgStoreCode",
            value: wasm_v1_tx.MsgStoreCode.fromJSON(i),
        }),
        msgInstantiateContract: (i) => ({
            typeUrl: "/cosmwasm.wasm.v1.MsgInstantiateContract",
            value: wasm_v1_tx.MsgInstantiateContract.fromPartial(i),
        }),
        msgUpdateAdmin: (i) => ({
            typeUrl: "/cosmwasm.wasm.v1.MsgUpdateAdmin",
            value: wasm_v1_tx.MsgUpdateAdmin.fromPartial(i),
        }),
        msgInstantiateContract2: (i) => ({
            typeUrl: "/cosmwasm.wasm.v1.MsgInstantiateContract2",
            value: wasm_v1_tx.MsgInstantiateContract2.fromPartial(i),
        }),
        msgUpdateInstantiateConfig: (i) => ({
            typeUrl: "/cosmwasm.wasm.v1.MsgUpdateInstantiateConfig",
            value: wasm_v1_tx.MsgUpdateInstantiateConfig.fromPartial(i),
        }),
    },
    ibc: {
        msgTransfer: (i) => ({
            typeUrl: "/ibc.applications.transfer.v1.MsgTransfer",
            value: transfer_v1_tx.MsgTransfer.fromPartial(i),
        }),
    },
    gravity: msg,
    alliance: alliance_msg,
};

;// CONCATENATED MODULE: ./node_modules/kujira.js/lib/esm/orca/types.js
var Chain;
(function (Chain) {
    Chain["Avalanche"] = "Avalanche";
    Chain["Kujira"] = "Kujira";
    Chain["Polkadot"] = "Polkadot";
})(Chain || (Chain = {}));
var Protocol;
(function (Protocol) {
    Protocol["Acala"] = "Acala";
    Protocol["Karura"] = "Karura";
    Protocol["Mandala"] = "Mandala";
    Protocol["USK"] = "USK";
    Protocol["FIN"] = "FIN Margin";
    Protocol["PERP"] = "FIN Perpetuals";
})(Protocol || (Protocol = {}));
var MarketType;
(function (MarketType) {
    MarketType["Acala"] = "Lending";
    MarketType["Karura"] = "Lending";
    MarketType["Mandala"] = "Lending";
    MarketType["USK"] = "Lending";
    MarketType["FIN"] = "Margin";
    MarketType["PERP"] = "Perpetuals";
})(MarketType || (MarketType = {}));

;// CONCATENATED MODULE: ./node_modules/kujira.js/lib/esm/orca/index.js






const castBidPool = (response) => ({
    totalBidAmount: BigNumber.from(response.total_bid_amount),
    premiumRate: parseFloat(response.premium_rate),
    premiumRateInt: parseFixed(response.premium_rate, 18),
    currentEpoch: parseInt(response.current_epoch),
});
const castBid = (response) => ({
    idx: parseInt(response.idx),
    premiumSlot: response.premium_slot,
    amount: BigNumber.from(response.amount),
    pendingLiquidatedCollateral: BigNumber.from(response.pending_liquidated_collateral),
    waitEnd: (response.wait_end && new Date(parseInt(response.wait_end) * 1000)) || null,
});
const orca_FILTERED = [
    "kujira1pq2qqjuxwm93sxhr9s3vlpj7lrtjfdml68qjf3a3qfpw5ctj67nsdfmkrv",
    "kujira13wd3tqd3k2hldhcpqm6wnf00rdx98yf5a2sv3s7mzs7uwgqzvpnsk9kygc",
    "kujira1utx63kua509ys806g0nu87lpmrppwhfzguctj8p7qr9d8h8cj0hsavaw8e",
];
const insertMarket = (a, v) => {
    if (orca_FILTERED.includes(v.address))
        return a;
    const collateralDenom = denom_Denom.from(v.config.collateral_denom);
    return Object.assign(Object.assign({}, a), { [v.address]: {
            label: collateralDenom.symbol,
            chain: Chain.Kujira,
            protocol: Protocol.USK,
            collateralDenom,
            bidDenom: denom_Denom.from(v.config.bid_denom),
            repayDenom: denom_Denom.from(v.config.bid_denom),
            type: MarketType.USK,
            address: v.address,
            botFirst: false,
            activators: ["kujira16a03hk5ev6963a4yj3kcrvmh4hej3w3j70kv2n"],
            bidThreshold: bignumber/* BigNumber.from */.O$.from(v.config.bid_threshold),
            maxSlot: v.config.max_slot,
            premiumRatePerSlot: parseFloat(v.config.premium_rate_per_slot),
            premiumRatePerSlotInt: fixednumber_parseFixed(v.config.premium_rate_per_slot, 18),
            waitingPeriod: v.config.waiting_period,
            markets: v.config.markets,
            liquidationFee: parseFloat(v.config.liquidation_fee),
            withdrawalFee: parseFloat(v.config.withdrawal_fee),
        } });
};
const orca_MARKETS = {
    [network_MAINNET]: Object.values(resources_contracts[network_MAINNET].orca).reduce(insertMarket, {}),
    [TESTNET]: Object.values(resources_contracts[TESTNET].orca).reduce(insertMarket, {}),
    [POND]: {},
};
const getMarkets = (network) => {
    const markets = Object.values(orca_MARKETS[network || MAINNET]);
    return markets.sort((a, b) => a.collateralDenom.compare(b.collateralDenom));
};

;// CONCATENATED MODULE: ./node_modules/kujira.js/lib/esm/parsers.js

const addCoins = (a, b) => a.reduce(addCoin, b);
const addCoin = (a, b) => {
    const x = a.find((z) => z.denom === b.denom);
    return x
        ? a.map((x) => x.denom === b.denom
            ? Object.assign(Object.assign({}, x), { amount: (parseInt(x.amount) + parseInt(b.amount)).toString() }) : x)
        : [b, ...a];
};
const transfers = (address, events) => {
    return events.reduce((agg, e) => {
        var _a, _b, _c, _d;
        if (e.type === "coin_spent" &&
            ((_a = e.attributes.find((a) => a.key === "spender")) === null || _a === void 0 ? void 0 : _a.value) === address) {
            return {
                receive: agg.receive,
                send: addCoins(agg.send, parseCoins(((_b = e.attributes.find((a) => a.key === "amount")) === null || _b === void 0 ? void 0 : _b.value) || "")),
            };
        }
        if (e.type === "coin_received" &&
            ((_c = e.attributes.find((a) => a.key === "receiver")) === null || _c === void 0 ? void 0 : _c.value) === address) {
            return {
                send: agg.send,
                receive: addCoins(agg.send, parseCoins(((_d = e.attributes.find((a) => a.key === "amount")) === null || _d === void 0 ? void 0 : _d.value) || "")),
            };
        }
        return agg;
    }, { send: [], receive: [] });
};

;// CONCATENATED MODULE: ./node_modules/kujira.js/lib/esm/pilot.js
var pilot_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};



const castSale = (network, res) => ({
    label: Denom.from(res.amount.denom).symbol,
    collateralDenom: Denom.from(res.amount.denom),
    bidDenom: Denom.from(res.orca_config.bid_denom),
    address: res.orca_address,
    bidThreshold: BigNumber.from(res.orca_config.bid_threshold),
    maxSlot: res.orca_config.max_slot,
    premiumRatePerSlot: parseFloat(res.orca_config.premium_rate_per_slot),
    premiumRatePerSlotInt: parseFixed(res.orca_config.premium_rate_per_slot, 18),
    waitingPeriod: res.orca_config.waiting_period,
    markets: res.orca_config.markets,
    activators: ["kujira1mrwwpea5emn05wmj7d7eweppmw98qj2a642r0e"],
    sale: {
        idx: res.idx,
        title: res.title,
        owner: res.owner,
        beneficiary: res.beneficiary,
        description: res.description,
        price: parseFloat(res.price),
        amount: BigNumber.from(res.amount.amount),
        opens: new Date(parseInt(res.opens) / 1000000),
        closes: new Date(parseInt(res.closes) / 1000000),
        executed: res.executed ? new Date(parseInt(res.executed) / 1000000) : null,
        retracted: res.retracted
            ? new Date(parseInt(res.retracted) / 1000000)
            : null,
    },
    liquidationFee: parseFloat(res.orca_config.liquidation_fee),
    withdrawalFee: parseFloat(res.orca_config.withdrawal_fee),
});
const castPilot = (res) => ({
    address: res.address,
    owner: res.config.owner,
    deposit: res.config.deposit,
    orcaCodeId: res.config.orca_code_id,
    saleFee: parseFloat(res.config.sale_fee),
    withdrawalFee: parseFloat(res.config.withdrawal_fee),
});
const config = (network) => {
    const contract = contracts[network].pilot[0];
    if (!contract)
        return null;
    return castPilot(contract);
};
const pilot_getMarkets = (query, network) => pilot_awaiter(void 0, void 0, void 0, function* () {
    const contract = contracts[network].pilot.reverse()[0];
    if (!contract)
        return {};
    return query.wasm
        .queryContractSmart(contract.address, { sales: {} })
        .then((x) => x.sales.reduce((a, v) => (Object.assign(Object.assign({}, a), { [v.orca_address]: castSale(network, v) })), {}));
});

// EXTERNAL MODULE: ./node_modules/kujira.js/node_modules/cosmjs-types/cosmos/bank/v1beta1/query.js
var query = __webpack_require__(91586);
// EXTERNAL MODULE: ./node_modules/text-encoding/index.js
var text_encoding = __webpack_require__(48731);
;// CONCATENATED MODULE: ./node_modules/kujira.js/lib/esm/cosmos/bank.js
var bank_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};



function setupBankExtensionExtended(base) {
    const rpc = (0,stargate_build.createProtobufRpcClient)(base);
    // Use this service to get easy typed access to query methods
    // This cannot be used for proof verification
    const queryService = new query.QueryClientImpl(rpc);
    return {
        bank: Object.assign(Object.assign({}, (0,stargate_build.setupBankExtension)(base).bank), { allBalances: (address, pagination) => bank_awaiter(this, void 0, void 0, function* () {
                const { balances } = yield queryService.AllBalances({
                    address,
                    pagination,
                });
                return balances;
            }), spendableBalances: (address) => bank_awaiter(this, void 0, void 0, function* () {
                const { balances } = yield queryService.SpendableBalances({
                    address: address,
                });
                return balances;
            }) }),
    };
}

// EXTERNAL MODULE: ./node_modules/kujira.js/node_modules/@cosmjs/stargate/build/queryclient/index.js
var queryclient = __webpack_require__(46300);
// EXTERNAL MODULE: ./node_modules/kujira.js/node_modules/cosmjs-types/cosmos/gov/v1/query.js
var v1_query = __webpack_require__(51742);
;// CONCATENATED MODULE: ./node_modules/kujira.js/lib/esm/cosmos/gov.js
var gov_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};




function setupGovExtension(base) {
    const rpc = (0,stargate_build.createProtobufRpcClient)(base);
    // Use this service to get easy typed access to query methods
    // This cannot be used for proof verification
    const queryService = new v1_query.QueryClientImpl(rpc);
    return {
        gov: {
            params: (parametersType) => gov_awaiter(this, void 0, void 0, function* () {
                const response = yield queryService.Params({
                    paramsType: parametersType,
                });
                return response;
            }),
            proposal: (proposalId) => gov_awaiter(this, void 0, void 0, function* () {
                const response = yield queryService.Proposal({
                    proposalId: (0,queryclient.longify)(proposalId),
                });
                return response;
            }),
            proposals: (proposalStatus, depositorAddress, voterAddress, pagination) => gov_awaiter(this, void 0, void 0, function* () {
                const response = yield queryService.Proposals({
                    proposalStatus,
                    depositor: depositorAddress,
                    voter: voterAddress,
                    pagination: pagination && v1beta1_pagination.PageRequest.fromPartial(pagination),
                });
                return response;
            }),
            deposit: (proposalId, depositorAddress) => gov_awaiter(this, void 0, void 0, function* () {
                const response = yield queryService.Deposit({
                    proposalId: (0,queryclient.longify)(proposalId),
                    depositor: depositorAddress,
                });
                return response;
            }),
            deposits: (proposalId, pagination) => gov_awaiter(this, void 0, void 0, function* () {
                const response = yield queryService.Deposits({
                    proposalId: (0,queryclient.longify)(proposalId),
                    pagination: pagination && v1beta1_pagination.PageRequest.fromPartial(pagination),
                });
                return response;
            }),
            vote: (proposalId, voterAddress) => gov_awaiter(this, void 0, void 0, function* () {
                const response = yield queryService.Vote({
                    proposalId: (0,queryclient.longify)(proposalId),
                    voter: voterAddress,
                });
                return response;
            }),
            votes: (proposalId, pagination) => gov_awaiter(this, void 0, void 0, function* () {
                const response = yield queryService.Votes({
                    proposalId: (0,queryclient.longify)(proposalId),
                    pagination: pagination && v1beta1_pagination.PageRequest.fromPartial(pagination),
                });
                return response;
            }),
            tally: (proposalId) => gov_awaiter(this, void 0, void 0, function* () {
                const response = yield queryService.TallyResult({
                    proposalId: (0,queryclient.longify)(proposalId),
                });
                return response;
            }),
        },
    };
}

// EXTERNAL MODULE: ./node_modules/kujira.js/node_modules/@cosmjs/stargate/build/modules/staking/queries.js
var queries = __webpack_require__(88482);
// EXTERNAL MODULE: ./node_modules/kujira.js/node_modules/cosmjs-types/cosmos/staking/v1beta1/query.js
var v1beta1_query = __webpack_require__(13267);
;// CONCATENATED MODULE: ./node_modules/kujira.js/lib/esm/cosmos/staking.js
var staking_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};




function setupStakingExtension(base) {
    // Use this service to get easy typed access to query methods
    // This cannot be used for proof verification
    const rpc = (0,stargate_build.createProtobufRpcClient)(base);
    const queryService = new v1beta1_query.QueryClientImpl(rpc);
    return {
        staking: Object.assign(Object.assign({}, (0,queries.setupStakingExtension)(base).staking), { delegatorDelegations: (delegatorAddress, pagination) => staking_awaiter(this, void 0, void 0, function* () {
                const response = yield queryService.DelegatorDelegations({
                    delegatorAddr: delegatorAddress,
                    pagination: pagination && v1beta1_pagination.PageRequest.fromPartial(pagination),
                });
                return response;
            }), delegatorUnbondingDelegations: (delegatorAddress, pagination) => staking_awaiter(this, void 0, void 0, function* () {
                const response = yield queryService.DelegatorUnbondingDelegations({
                    delegatorAddr: delegatorAddress,
                    pagination: pagination && v1beta1_pagination.PageRequest.fromPartial(pagination),
                });
                return response;
            }), delegatorValidators: (delegatorAddress, pagination) => staking_awaiter(this, void 0, void 0, function* () {
                const response = yield queryService.DelegatorValidators({
                    delegatorAddr: delegatorAddress,
                    pagination: pagination && v1beta1_pagination.PageRequest.fromPartial(pagination),
                });
                return response;
            }), redelegations: (delegatorAddress, sourceValidatorAddress, destinationValidatorAddress, pagination) => staking_awaiter(this, void 0, void 0, function* () {
                const response = yield queryService.Redelegations({
                    delegatorAddr: delegatorAddress,
                    srcValidatorAddr: sourceValidatorAddress,
                    dstValidatorAddr: destinationValidatorAddress,
                    pagination: pagination && v1beta1_pagination.PageRequest.fromPartial(pagination),
                });
                return response;
            }), validatorDelegations: (validatorAddress, pagination) => staking_awaiter(this, void 0, void 0, function* () {
                const response = yield queryService.ValidatorDelegations({
                    validatorAddr: validatorAddress,
                    pagination: pagination && v1beta1_pagination.PageRequest.fromPartial(pagination),
                });
                return response;
            }), validators: (status, pagination) => staking_awaiter(this, void 0, void 0, function* () {
                const response = yield queryService.Validators({
                    status: status,
                    pagination: pagination && v1beta1_pagination.PageRequest.fromPartial(pagination),
                });
                return response;
            }), validatorUnbondingDelegations: (validatorAddress, pagination) => staking_awaiter(this, void 0, void 0, function* () {
                const response = yield queryService.ValidatorUnbondingDelegations({
                    validatorAddr: validatorAddress,
                    pagination: pagination && v1beta1_pagination.PageRequest.fromPartial(pagination),
                });
                return response;
            }) }),
    };
}

// EXTERNAL MODULE: ./node_modules/kujira.js/node_modules/cosmjs-types/cosmwasm/wasm/v1/query.js
var wasm_v1_query = __webpack_require__(14806);
;// CONCATENATED MODULE: ./node_modules/kujira.js/lib/esm/cosmwasm/wasm.js
var wasm_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};




function setupWasmExtensionExtended(base) {
    const rpc = (0,stargate_build.createProtobufRpcClient)(base);
    // Use this service to get easy typed access to query methods
    // This cannot be used for proof verification
    const queryService = new wasm_v1_query.QueryClientImpl(rpc);
    return {
        wasm: Object.assign(Object.assign({}, (0,build/* setupWasmExtension */.iy)(base).wasm), { listCodeInfo: (pageRequest) => wasm_awaiter(this, void 0, void 0, function* () {
                const request = {
                    pagination: pageRequest,
                };
                return queryService.Codes(request);
            }), listContractsByCodeId: (id, pageRequest) => wasm_awaiter(this, void 0, void 0, function* () {
                const request = {
                    codeId: long_default().fromNumber(id),
                    pagination: pageRequest,
                };
                return queryService.ContractsByCode(request);
            }), getContractCodeHistory: (address, pageRequest) => wasm_awaiter(this, void 0, void 0, function* () {
                const request = {
                    address: address,
                    pagination: pageRequest,
                };
                return queryService.ContractHistory(request);
            }), getAllContractState: (address, pageRequest) => wasm_awaiter(this, void 0, void 0, function* () {
                const request = {
                    address: address,
                    pagination: pageRequest,
                };
                return queryService.AllContractState(request);
            }) }),
    };
}

;// CONCATENATED MODULE: ./node_modules/kujira.js/lib/esm/kujira/kujira.scheduler/types/hook.js


const hook_protobufPackage = "kujira.scheduler";
const baseHook = { id: 0, executor: "", contract: "", frequency: 0 };
const Hook = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.id !== 0) {
            writer.uint32(8).uint64(message.id);
        }
        if (message.executor !== "") {
            writer.uint32(18).string(message.executor);
        }
        if (message.contract !== "") {
            writer.uint32(26).string(message.contract);
        }
        if (message.msg.length !== 0) {
            writer.uint32(34).bytes(message.msg);
        }
        if (message.frequency !== 0) {
            writer.uint32(40).int64(message.frequency);
        }
        for (const v of message.funds) {
            coin.Coin.encode(v, writer.uint32(50).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseHook);
        message.funds = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.id = reader.uint64().toNumber();
                    break;
                case 2:
                    message.executor = reader.string();
                    break;
                case 3:
                    message.contract = reader.string();
                    break;
                case 4:
                    message.msg = reader.bytes();
                    break;
                case 5:
                    message.frequency = reader.int64().toNumber();
                    break;
                case 6:
                    message.funds.push(coin.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseHook);
        message.funds = [];
        if (object.id !== undefined && object.id !== null) {
            message.id = Number(object.id);
        }
        else {
            message.id = 0;
        }
        if (object.executor !== undefined && object.executor !== null) {
            message.executor = String(object.executor);
        }
        else {
            message.executor = "";
        }
        if (object.contract !== undefined && object.contract !== null) {
            message.contract = String(object.contract);
        }
        else {
            message.contract = "";
        }
        if (object.msg !== undefined && object.msg !== null) {
            message.msg = hook_bytesFromBase64(object.msg);
        }
        if (object.frequency !== undefined && object.frequency !== null) {
            message.frequency = Number(object.frequency);
        }
        else {
            message.frequency = 0;
        }
        if (object.funds !== undefined && object.funds !== null) {
            for (const e of object.funds) {
                message.funds.push(coin.Coin.fromJSON(e));
            }
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.id !== undefined && (obj.id = message.id);
        message.executor !== undefined && (obj.executor = message.executor);
        message.contract !== undefined && (obj.contract = message.contract);
        message.msg !== undefined &&
            (obj.msg = hook_base64FromBytes(message.msg !== undefined ? message.msg : new Uint8Array()));
        message.frequency !== undefined && (obj.frequency = message.frequency);
        if (message.funds) {
            obj.funds = message.funds.map((e) => (e ? coin.Coin.toJSON(e) : undefined));
        }
        else {
            obj.funds = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseHook);
        message.funds = [];
        if (object.id !== undefined && object.id !== null) {
            message.id = object.id;
        }
        else {
            message.id = 0;
        }
        if (object.executor !== undefined && object.executor !== null) {
            message.executor = object.executor;
        }
        else {
            message.executor = "";
        }
        if (object.contract !== undefined && object.contract !== null) {
            message.contract = object.contract;
        }
        else {
            message.contract = "";
        }
        if (object.msg !== undefined && object.msg !== null) {
            message.msg = object.msg;
        }
        else {
            message.msg = new Uint8Array();
        }
        if (object.frequency !== undefined && object.frequency !== null) {
            message.frequency = object.frequency;
        }
        else {
            message.frequency = 0;
        }
        if (object.funds !== undefined && object.funds !== null) {
            for (const e of object.funds) {
                message.funds.push(coin.Coin.fromPartial(e));
            }
        }
        return message;
    },
};
function hook_bytesFromBase64(b64) {
    if (globalThis.Buffer) {
        return Uint8Array.from(globalThis.Buffer.from(b64, "base64"));
    }
    else {
        const bin = globalThis.atob(b64);
        const arr = new Uint8Array(bin.length);
        for (let i = 0; i < bin.length; ++i) {
            arr[i] = bin.charCodeAt(i);
        }
        return arr;
    }
}
function hook_base64FromBytes(arr) {
    if (globalThis.Buffer) {
        return globalThis.Buffer.from(arr).toString("base64");
    }
    else {
        const bin = [];
        arr.forEach((byte) => {
            bin.push(String.fromCharCode(byte));
        });
        return globalThis.btoa(bin.join(""));
    }
}

;// CONCATENATED MODULE: ./node_modules/kujira.js/lib/esm/kujira/kujira.scheduler/types/params.js

const kujira_scheduler_types_params_protobufPackage = "kujira.scheduler";
const params_baseParams = {};
const kujira_scheduler_types_params_Params = {
    encode(_, writer = minimal.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, params_baseParams);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, params_baseParams);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, params_baseParams);
        return message;
    },
};

;// CONCATENATED MODULE: ./node_modules/kujira.js/lib/esm/kujira/kujira.scheduler/types/query.js




const kujira_scheduler_types_query_protobufPackage = "kujira.scheduler";
const types_query_baseQueryParamsRequest = {};
const kujira_scheduler_types_query_QueryParamsRequest = {
    encode(_, writer = minimal.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, types_query_baseQueryParamsRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, types_query_baseQueryParamsRequest);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, types_query_baseQueryParamsRequest);
        return message;
    },
};
const types_query_baseQueryParamsResponse = {};
const kujira_scheduler_types_query_QueryParamsResponse = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.params !== undefined) {
            kujira_scheduler_types_params_Params.encode(message.params, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, types_query_baseQueryParamsResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.params = kujira_scheduler_types_params_Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, types_query_baseQueryParamsResponse);
        if (object.params !== undefined && object.params !== null) {
            message.params = kujira_scheduler_types_params_Params.fromJSON(object.params);
        }
        else {
            message.params = undefined;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.params !== undefined &&
            (obj.params = message.params ? kujira_scheduler_types_params_Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, types_query_baseQueryParamsResponse);
        if (object.params !== undefined && object.params !== null) {
            message.params = kujira_scheduler_types_params_Params.fromPartial(object.params);
        }
        else {
            message.params = undefined;
        }
        return message;
    },
};
const baseQueryGetHookRequest = { id: 0 };
const QueryGetHookRequest = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.id !== 0) {
            writer.uint32(8).uint64(message.id);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryGetHookRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.id = reader.uint64().toNumber();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryGetHookRequest);
        if (object.id !== undefined && object.id !== null) {
            message.id = Number(object.id);
        }
        else {
            message.id = 0;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.id !== undefined && (obj.id = message.id);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryGetHookRequest);
        if (object.id !== undefined && object.id !== null) {
            message.id = object.id;
        }
        else {
            message.id = 0;
        }
        return message;
    },
};
const baseQueryGetHookResponse = {};
const QueryGetHookResponse = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.Hook !== undefined) {
            Hook.encode(message.Hook, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryGetHookResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.Hook = Hook.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryGetHookResponse);
        if (object.Hook !== undefined && object.Hook !== null) {
            message.Hook = Hook.fromJSON(object.Hook);
        }
        else {
            message.Hook = undefined;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.Hook !== undefined &&
            (obj.Hook = message.Hook ? Hook.toJSON(message.Hook) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryGetHookResponse);
        if (object.Hook !== undefined && object.Hook !== null) {
            message.Hook = Hook.fromPartial(object.Hook);
        }
        else {
            message.Hook = undefined;
        }
        return message;
    },
};
const baseQueryAllHookRequest = {};
const QueryAllHookRequest = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.pagination !== undefined) {
            v1beta1_pagination.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllHookRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.pagination = v1beta1_pagination.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryAllHookRequest);
        if (object.pagination !== undefined && object.pagination !== null) {
            message.pagination = v1beta1_pagination.PageRequest.fromJSON(object.pagination);
        }
        else {
            message.pagination = undefined;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? v1beta1_pagination.PageRequest.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryAllHookRequest);
        if (object.pagination !== undefined && object.pagination !== null) {
            message.pagination = v1beta1_pagination.PageRequest.fromPartial(object.pagination);
        }
        else {
            message.pagination = undefined;
        }
        return message;
    },
};
const baseQueryAllHookResponse = {};
const QueryAllHookResponse = {
    encode(message, writer = minimal.Writer.create()) {
        for (const v of message.Hook) {
            Hook.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            v1beta1_pagination.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllHookResponse);
        message.Hook = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.Hook.push(Hook.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = v1beta1_pagination.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryAllHookResponse);
        message.Hook = [];
        if (object.Hook !== undefined && object.Hook !== null) {
            for (const e of object.Hook) {
                message.Hook.push(Hook.fromJSON(e));
            }
        }
        if (object.pagination !== undefined && object.pagination !== null) {
            message.pagination = v1beta1_pagination.PageResponse.fromJSON(object.pagination);
        }
        else {
            message.pagination = undefined;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.Hook) {
            obj.Hook = message.Hook.map((e) => (e ? Hook.toJSON(e) : undefined));
        }
        else {
            obj.Hook = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? v1beta1_pagination.PageResponse.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryAllHookResponse);
        message.Hook = [];
        if (object.Hook !== undefined && object.Hook !== null) {
            for (const e of object.Hook) {
                message.Hook.push(Hook.fromPartial(e));
            }
        }
        if (object.pagination !== undefined && object.pagination !== null) {
            message.pagination = v1beta1_pagination.PageResponse.fromPartial(object.pagination);
        }
        else {
            message.pagination = undefined;
        }
        return message;
    },
};
class kujira_scheduler_types_query_QueryClientImpl {
    constructor(rpc) {
        this.rpc = rpc;
    }
    Params(request) {
        const data = kujira_scheduler_types_query_QueryParamsRequest.encode(request).finish();
        const promise = this.rpc.request("kujira.scheduler.Query", "Params", data);
        return promise.then((data) => kujira_scheduler_types_query_QueryParamsResponse.decode(new minimal.Reader(data)));
    }
    Hook(request) {
        const data = QueryGetHookRequest.encode(request).finish();
        const promise = this.rpc.request("kujira.scheduler.Query", "Hook", data);
        return promise.then((data) => QueryGetHookResponse.decode(new minimal.Reader(data)));
    }
    HookAll(request) {
        const data = QueryAllHookRequest.encode(request).finish();
        const promise = this.rpc.request("kujira.scheduler.Query", "HookAll", data);
        return promise.then((data) => QueryAllHookResponse.decode(new minimal.Reader(data)));
    }
}

;// CONCATENATED MODULE: ./node_modules/kujira.js/lib/esm/kujira/kujira.scheduler/queries.js
var kujira_scheduler_queries_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};



function setupSchedulerExtension(base) {
    const rpc = (0,stargate_build.createProtobufRpcClient)(base);
    const queryService = new kujira_scheduler_types_query_QueryClientImpl(rpc);
    return {
        scheduler: {
            params: () => kujira_scheduler_queries_awaiter(this, void 0, void 0, function* () {
                const { params } = yield queryService.Params({});
                (0,utils_build.assert)(params);
                return params;
            }),
            hook: (id) => kujira_scheduler_queries_awaiter(this, void 0, void 0, function* () {
                const { Hook } = yield queryService.Hook({ id });
                (0,utils_build.assert)(Hook);
                return Hook;
            }),
            allHooks: (paginationKey) => kujira_scheduler_queries_awaiter(this, void 0, void 0, function* () {
                return queryService.HookAll({
                    pagination: (0,stargate_build.createPagination)(paginationKey),
                });
            }),
        },
    };
}

;// CONCATENATED MODULE: ./node_modules/kujira.js/lib/esm/kujira/kujira.scheduler/index.js


;// CONCATENATED MODULE: ./node_modules/kujira.js/lib/esm/queryClient.js
var queryClient_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};










const kujiraQueryClient = ({ client, }) => stargate_build.QueryClient.withExtensions(client, stargate_build.setupAuthExtension, stargate_build.setupAuthzExtension, setupBankExtensionExtended, setupDenomExtension, stargate_build.setupDistributionExtension, stargate_build.setupFeegrantExtension, setupGovExtension, setupOracleExtension, setupSchedulerExtension, stargate_build.setupSlashingExtension, setupStakingExtension, stargate_build.setupTxExtension, setupWasmExtensionExtended, stargate_build.setupIbcExtension, setupGravityExtension, setupAllianceExtension);
const fetchTokens = (query, paginationKey) => {
    return query.bank.totalSupply(paginationKey).then((xs) => queryClient_awaiter(void 0, void 0, void 0, function* () {
        var _a;
        return ((_a = xs.pagination) === null || _a === void 0 ? void 0 : _a.nextKey.toString())
            ? [...(yield fetchTokens(query, xs.pagination.nextKey)), ...xs.supply]
            : xs.supply;
    }));
};

// EXTERNAL MODULE: ./node_modules/kujira.js/node_modules/@cosmjs/cosmwasm-stargate/build/modules/index.js
var modules = __webpack_require__(60408);
// EXTERNAL MODULE: ./node_modules/kujira.js/node_modules/@cosmjs/stargate/build/modules/index.js
var build_modules = __webpack_require__(6749);
// EXTERNAL MODULE: ./node_modules/kujira.js/node_modules/cosmjs-types/cosmos/auth/v1beta1/auth.js
var auth = __webpack_require__(13394);
// EXTERNAL MODULE: ./node_modules/kujira.js/node_modules/cosmjs-types/cosmos/distribution/v1beta1/distribution.js
var distribution = __webpack_require__(45280);
// EXTERNAL MODULE: ./node_modules/kujira.js/node_modules/cosmjs-types/cosmos/gov/v1beta1/gov.js
var gov = __webpack_require__(48615);
// EXTERNAL MODULE: ./node_modules/kujira.js/node_modules/cosmjs-types/cosmos/params/v1beta1/params.js
var params = __webpack_require__(3123);
// EXTERNAL MODULE: ./node_modules/kujira.js/node_modules/cosmjs-types/cosmos/upgrade/v1beta1/tx.js
var upgrade_v1beta1_tx = __webpack_require__(27937);
// EXTERNAL MODULE: ./node_modules/kujira.js/node_modules/cosmjs-types/cosmos/upgrade/v1beta1/upgrade.js
var upgrade = __webpack_require__(19998);
// EXTERNAL MODULE: ./node_modules/kujira.js/node_modules/cosmjs-types/cosmwasm/wasm/v1/proposal.js
var proposal = __webpack_require__(97978);
// EXTERNAL MODULE: ./node_modules/kujira.js/node_modules/cosmjs-types/ibc/core/client/v1/client.js
var client = __webpack_require__(30085);
// EXTERNAL MODULE: ./node_modules/kujira.js/node_modules/cosmjs-types/ibc/lightclients/tendermint/v1/tendermint.js
var tendermint = __webpack_require__(24398);
// EXTERNAL MODULE: ./node_modules/kujira.js/node_modules/cosmjs-types/helpers.js
var helpers = __webpack_require__(92654);
;// CONCATENATED MODULE: ./node_modules/kujira.js/lib/esm/ethermint/types.js



/* eslint-disable */
const types_protobufPackage = "ethermint.types.v1";
function createBaseEthAccount() {
    return {
        baseAccount: undefined,
        codeHash: new Uint8Array(),
    };
}
const EthAccount = {
    typeUrl: "/ethermint.types.v1.EthAccount",
    encode(message, writer = minimal.Writer.create()) {
        if (message.baseAccount !== undefined) {
            auth.BaseAccount.encode(message.baseAccount, writer.uint32(10).fork()).ldelim();
        }
        if (message.codeHash.length !== 0) {
            writer.uint32(18).bytes(message.codeHash);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseEthAccount();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.baseAccount = auth.BaseAccount.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.codeHash = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const obj = createBaseEthAccount();
        if ((0,helpers.isSet)(object.baseAccount))
            obj.baseAccount = auth.BaseAccount.fromJSON(object.baseAccount);
        if ((0,helpers.isSet)(object.codeHash))
            obj.codeHash = (0,helpers.bytesFromBase64)(object.codeHash);
        return obj;
    },
    toJSON(message) {
        const obj = {};
        message.baseAccount !== undefined &&
            (obj.baseAccount = message.baseAccount
                ? auth.BaseAccount.toJSON(message.baseAccount)
                : undefined);
        message.codeHash !== undefined &&
            (obj.codeHash = (0,helpers.base64FromBytes)(message.codeHash !== undefined ? message.codeHash : new Uint8Array()));
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseEthAccount();
        if (object.baseAccount !== undefined && object.baseAccount !== null) {
            message.baseAccount = auth.BaseAccount.fromPartial(object.baseAccount);
        }
        message.codeHash = (_a = object.codeHash) !== null && _a !== void 0 ? _a : new Uint8Array();
        return message;
    },
};

;// CONCATENATED MODULE: ./node_modules/kujira.js/lib/esm/injective/types.js



/* eslint-disable */
const injective_types_protobufPackage = "injective.types.v1beta1";
function types_createBaseEthAccount() {
    return {
        baseAccount: undefined,
        codeHash: new Uint8Array(),
    };
}
const types_EthAccount = {
    typeUrl: "/injective.types.v1beta1.EthAccount",
    encode(message, writer = minimal.Writer.create()) {
        if (message.baseAccount !== undefined) {
            auth.BaseAccount.encode(message.baseAccount, writer.uint32(10).fork()).ldelim();
        }
        if (message.codeHash.length !== 0) {
            writer.uint32(18).bytes(message.codeHash);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = types_createBaseEthAccount();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.baseAccount = auth.BaseAccount.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.codeHash = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const obj = types_createBaseEthAccount();
        if ((0,helpers.isSet)(object.baseAccount))
            obj.baseAccount = auth.BaseAccount.fromJSON(object.baseAccount);
        if ((0,helpers.isSet)(object.codeHash))
            obj.codeHash = (0,helpers.bytesFromBase64)(object.codeHash);
        return obj;
    },
    toJSON(message) {
        const obj = {};
        message.baseAccount !== undefined &&
            (obj.baseAccount = message.baseAccount
                ? auth.BaseAccount.toJSON(message.baseAccount)
                : undefined);
        message.codeHash !== undefined &&
            (obj.codeHash = (0,helpers.base64FromBytes)(message.codeHash !== undefined ? message.codeHash : new Uint8Array()));
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = types_createBaseEthAccount();
        if (object.baseAccount !== undefined && object.baseAccount !== null) {
            message.baseAccount = auth.BaseAccount.fromPartial(object.baseAccount);
        }
        message.codeHash = (_a = object.codeHash) !== null && _a !== void 0 ? _a : new Uint8Array();
        return message;
    },
};

;// CONCATENATED MODULE: ./node_modules/kujira.js/lib/esm/kujira/kujira.scheduler/types/proposal.js



const proposal_protobufPackage = "kujira.scheduler";
const baseCreateHookProposal = {
    title: "",
    description: "",
    executor: "",
    contract: "",
    frequency: 0,
};
const CreateHookProposal = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.title !== "") {
            writer.uint32(10).string(message.title);
        }
        if (message.description !== "") {
            writer.uint32(18).string(message.description);
        }
        if (message.executor !== "") {
            writer.uint32(26).string(message.executor);
        }
        if (message.contract !== "") {
            writer.uint32(34).string(message.contract);
        }
        if (message.msg.length !== 0) {
            writer.uint32(42).bytes(message.msg);
        }
        if (message.frequency !== 0) {
            writer.uint32(48).int64(message.frequency);
        }
        for (const v of message.funds) {
            coin.Coin.encode(v, writer.uint32(58).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseCreateHookProposal);
        message.funds = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.title = reader.string();
                    break;
                case 2:
                    message.description = reader.string();
                    break;
                case 3:
                    message.executor = reader.string();
                    break;
                case 4:
                    message.contract = reader.string();
                    break;
                case 5:
                    message.msg = reader.bytes();
                    break;
                case 6:
                    message.frequency = reader.int64().toNumber();
                    break;
                case 7:
                    message.funds.push(coin.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseCreateHookProposal);
        message.funds = [];
        if (object.title !== undefined && object.title !== null) {
            message.title = String(object.title);
        }
        else {
            message.title = "";
        }
        if (object.description !== undefined && object.description !== null) {
            message.description = String(object.description);
        }
        else {
            message.description = "";
        }
        if (object.executor !== undefined && object.executor !== null) {
            message.executor = String(object.executor);
        }
        else {
            message.executor = "";
        }
        if (object.contract !== undefined && object.contract !== null) {
            message.contract = String(object.contract);
        }
        else {
            message.contract = "";
        }
        if (object.msg !== undefined && object.msg !== null) {
            message.msg = hook_bytesFromBase64(object.msg);
        }
        if (object.frequency !== undefined && object.frequency !== null) {
            message.frequency = Number(object.frequency);
        }
        else {
            message.frequency = 0;
        }
        if (object.funds !== undefined && object.funds !== null) {
            for (const e of object.funds) {
                message.funds.push(coin.Coin.fromJSON(e));
            }
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.title !== undefined && (obj.title = message.title);
        message.description !== undefined &&
            (obj.description = message.description);
        message.executor !== undefined && (obj.executor = message.executor);
        message.contract !== undefined && (obj.contract = message.contract);
        message.msg !== undefined &&
            (obj.msg = hook_base64FromBytes(message.msg !== undefined ? message.msg : new Uint8Array()));
        message.frequency !== undefined && (obj.frequency = message.frequency);
        if (message.funds) {
            obj.funds = message.funds.map((e) => (e ? coin.Coin.toJSON(e) : undefined));
        }
        else {
            obj.funds = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseCreateHookProposal);
        message.funds = [];
        if (object.title !== undefined && object.title !== null) {
            message.title = object.title;
        }
        else {
            message.title = "";
        }
        if (object.description !== undefined && object.description !== null) {
            message.description = object.description;
        }
        else {
            message.description = "";
        }
        if (object.executor !== undefined && object.executor !== null) {
            message.executor = object.executor;
        }
        else {
            message.executor = "";
        }
        if (object.contract !== undefined && object.contract !== null) {
            message.contract = object.contract;
        }
        else {
            message.contract = "";
        }
        if (object.msg !== undefined && object.msg !== null) {
            message.msg = object.msg;
        }
        else {
            message.msg = new Uint8Array();
        }
        if (object.frequency !== undefined && object.frequency !== null) {
            message.frequency = object.frequency;
        }
        else {
            message.frequency = 0;
        }
        if (object.funds !== undefined && object.funds !== null) {
            for (const e of object.funds) {
                message.funds.push(coin.Coin.fromPartial(e));
            }
        }
        return message;
    },
};
const baseUpdateHookProposal = {
    title: "",
    description: "",
    id: 0,
    executor: "",
    contract: "",
    frequency: 0,
};
const UpdateHookProposal = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.title !== "") {
            writer.uint32(10).string(message.title);
        }
        if (message.description !== "") {
            writer.uint32(18).string(message.description);
        }
        if (message.id !== 0) {
            writer.uint32(24).uint64(message.id);
        }
        if (message.executor !== "") {
            writer.uint32(34).string(message.executor);
        }
        if (message.contract !== "") {
            writer.uint32(42).string(message.contract);
        }
        if (message.msg.length !== 0) {
            writer.uint32(50).bytes(message.msg);
        }
        if (message.frequency !== 0) {
            writer.uint32(56).int64(message.frequency);
        }
        for (const v of message.funds) {
            coin.Coin.encode(v, writer.uint32(66).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseUpdateHookProposal);
        message.funds = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.title = reader.string();
                    break;
                case 2:
                    message.description = reader.string();
                    break;
                case 3:
                    message.id = reader.uint64().toNumber();
                    break;
                case 4:
                    message.executor = reader.string();
                    break;
                case 5:
                    message.contract = reader.string();
                    break;
                case 6:
                    message.msg = reader.bytes();
                    break;
                case 7:
                    message.frequency = reader.int64().toNumber();
                    break;
                case 8:
                    message.funds.push(coin.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseUpdateHookProposal);
        message.funds = [];
        if (object.title !== undefined && object.title !== null) {
            message.title = String(object.title);
        }
        else {
            message.title = "";
        }
        if (object.description !== undefined && object.description !== null) {
            message.description = String(object.description);
        }
        else {
            message.description = "";
        }
        if (object.id !== undefined && object.id !== null) {
            message.id = Number(object.id);
        }
        else {
            message.id = 0;
        }
        if (object.executor !== undefined && object.executor !== null) {
            message.executor = String(object.executor);
        }
        else {
            message.executor = "";
        }
        if (object.contract !== undefined && object.contract !== null) {
            message.contract = String(object.contract);
        }
        else {
            message.contract = "";
        }
        if (object.msg !== undefined && object.msg !== null) {
            message.msg = hook_bytesFromBase64(object.msg);
        }
        if (object.frequency !== undefined && object.frequency !== null) {
            message.frequency = Number(object.frequency);
        }
        else {
            message.frequency = 0;
        }
        if (object.funds !== undefined && object.funds !== null) {
            for (const e of object.funds) {
                message.funds.push(coin.Coin.fromJSON(e));
            }
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.title !== undefined && (obj.title = message.title);
        message.description !== undefined &&
            (obj.description = message.description);
        message.id !== undefined && (obj.id = message.id);
        message.executor !== undefined && (obj.executor = message.executor);
        message.contract !== undefined && (obj.contract = message.contract);
        message.msg !== undefined &&
            (obj.msg = hook_base64FromBytes(message.msg !== undefined ? message.msg : new Uint8Array()));
        message.frequency !== undefined && (obj.frequency = message.frequency);
        if (message.funds) {
            obj.funds = message.funds.map((e) => (e ? coin.Coin.toJSON(e) : undefined));
        }
        else {
            obj.funds = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseUpdateHookProposal);
        message.funds = [];
        if (object.title !== undefined && object.title !== null) {
            message.title = object.title;
        }
        else {
            message.title = "";
        }
        if (object.description !== undefined && object.description !== null) {
            message.description = object.description;
        }
        else {
            message.description = "";
        }
        if (object.id !== undefined && object.id !== null) {
            message.id = object.id;
        }
        else {
            message.id = 0;
        }
        if (object.executor !== undefined && object.executor !== null) {
            message.executor = object.executor;
        }
        else {
            message.executor = "";
        }
        if (object.contract !== undefined && object.contract !== null) {
            message.contract = object.contract;
        }
        else {
            message.contract = "";
        }
        if (object.msg !== undefined && object.msg !== null) {
            message.msg = object.msg;
        }
        else {
            message.msg = new Uint8Array();
        }
        if (object.frequency !== undefined && object.frequency !== null) {
            message.frequency = object.frequency;
        }
        else {
            message.frequency = 0;
        }
        if (object.funds !== undefined && object.funds !== null) {
            for (const e of object.funds) {
                message.funds.push(coin.Coin.fromPartial(e));
            }
        }
        return message;
    },
};
const baseDeleteHookProposal = {
    title: "",
    description: "",
    id: 0,
};
const DeleteHookProposal = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.title !== "") {
            writer.uint32(10).string(message.title);
        }
        if (message.description !== "") {
            writer.uint32(18).string(message.description);
        }
        if (message.id !== 0) {
            writer.uint32(24).uint64(message.id);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseDeleteHookProposal);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.title = reader.string();
                    break;
                case 2:
                    message.description = reader.string();
                    break;
                case 3:
                    message.id = reader.uint64().toNumber();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseDeleteHookProposal);
        if (object.title !== undefined && object.title !== null) {
            message.title = String(object.title);
        }
        else {
            message.title = "";
        }
        if (object.description !== undefined && object.description !== null) {
            message.description = String(object.description);
        }
        else {
            message.description = "";
        }
        if (object.id !== undefined && object.id !== null) {
            message.id = Number(object.id);
        }
        else {
            message.id = 0;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.title !== undefined && (obj.title = message.title);
        message.description !== undefined &&
            (obj.description = message.description);
        message.id !== undefined && (obj.id = message.id);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseDeleteHookProposal);
        if (object.title !== undefined && object.title !== null) {
            message.title = object.title;
        }
        else {
            message.title = "";
        }
        if (object.description !== undefined && object.description !== null) {
            message.description = object.description;
        }
        else {
            message.description = "";
        }
        if (object.id !== undefined && object.id !== null) {
            message.id = object.id;
        }
        else {
            message.id = 0;
        }
        return message;
    },
};

// EXTERNAL MODULE: ./node_modules/kujira.js/node_modules/cosmjs-types/cosmos/vesting/v1beta1/vesting.js
var vesting = __webpack_require__(90416);
;// CONCATENATED MODULE: ./node_modules/kujira.js/lib/esm/stride/vesting.js




const basePeriod = {
    startTime: (long_default()).ZERO,
    length: (long_default()).ZERO,
    actionType: 0,
};
const Period = {
    encode(message, writer = minimal.Writer.create()) {
        if (!message.startTime.isZero()) {
            writer.uint32(8).int64(message.startTime);
        }
        if (!message.length.isZero()) {
            writer.uint32(16).int64(message.length);
        }
        for (const v of message.amount) {
            coin.Coin.encode(v, writer.uint32(26).fork()).ldelim();
        }
        if (message.actionType !== 0) {
            writer.uint32(32).int32(message.actionType);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, basePeriod);
        message.amount = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.startTime = reader.int64();
                    break;
                case 2:
                    message.length = reader.int64();
                    break;
                case 3:
                    message.amount.push(coin.Coin.decode(reader, reader.uint32()));
                    break;
                case 4:
                    message.actionType = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, basePeriod);
        message.amount = [];
        if (object.startTime !== undefined && object.startTime !== null) {
            message.startTime = long_default().fromString(object.startTime);
        }
        else {
            message.startTime = (long_default()).ZERO;
        }
        if (object.length !== undefined && object.length !== null) {
            message.length = long_default().fromString(object.length);
        }
        else {
            message.length = (long_default()).ZERO;
        }
        if (object.amount !== undefined && object.amount !== null) {
            for (const e of object.amount) {
                message.amount.push(coin.Coin.fromJSON(e));
            }
        }
        if (object.actionType !== undefined && object.actionType !== null) {
            message.actionType = Number(object.actionType);
        }
        else {
            message.actionType = 0;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.startTime !== undefined &&
            (obj.startTime = (message.startTime || (long_default()).ZERO).toString());
        message.length !== undefined &&
            (obj.length = (message.length || (long_default()).ZERO).toString());
        if (message.amount) {
            obj.amount = message.amount.map((e) => (e ? coin.Coin.toJSON(e) : undefined));
        }
        else {
            obj.amount = [];
        }
        message.actionType !== undefined && (obj.actionType = message.actionType);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, basePeriod);
        message.amount = [];
        if (object.startTime !== undefined && object.startTime !== null) {
            message.startTime = object.startTime;
        }
        else {
            message.startTime = (long_default()).ZERO;
        }
        if (object.length !== undefined && object.length !== null) {
            message.length = object.length;
        }
        else {
            message.length = (long_default()).ZERO;
        }
        if (object.amount !== undefined && object.amount !== null) {
            for (const e of object.amount) {
                message.amount.push(coin.Coin.fromPartial(e));
            }
        }
        if (object.actionType !== undefined && object.actionType !== null) {
            message.actionType = object.actionType;
        }
        else {
            message.actionType = 0;
        }
        return message;
    },
};
function createBaseStridePeriodicVestingAccount() {
    return {
        baseVestingAccount: undefined,
        vestingPeriods: [],
    };
}
const vesting_StridePeriodicVestingAccount = {
    encode(message, writer = minimal.Writer.create()) {
        if (message.baseVestingAccount !== undefined) {
            vesting.BaseVestingAccount.encode(message.baseVestingAccount, writer.uint32(10).fork()).ldelim();
        }
        for (const v of message.vestingPeriods) {
            Period.encode(v, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseStridePeriodicVestingAccount();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.baseVestingAccount = vesting.BaseVestingAccount.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.vestingPeriods.push(Period.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseStridePeriodicVestingAccount();
        message.baseVestingAccount =
            object.baseVestingAccount !== undefined &&
                object.baseVestingAccount !== null
                ? vesting.BaseVestingAccount.fromPartial(object.baseVestingAccount)
                : undefined;
        message.vestingPeriods =
            ((_a = object.vestingPeriods) === null || _a === void 0 ? void 0 : _a.map((e) => Period.fromPartial(e))) || [];
        return message;
    },
};

;// CONCATENATED MODULE: ./node_modules/kujira.js/lib/esm/registry.js
/* provided dependency */ var registry_Buffer = __webpack_require__(48764)["Buffer"];



























const proposalTypes = [
    [
        "/cosmos.distribution.v1beta1.CommunityPoolSpendProposal",
        distribution.CommunityPoolSpendProposal,
    ],
    ["/cosmos.distribution.v1beta1.MsgCommunityPoolSpend", distribution_v1beta1_tx.MsgCommunityPoolSpend],
    ["/cosmos.params.v1beta1.ParameterChangeProposal", params.ParameterChangeProposal],
    ["/cosmos.params.v1beta1.MsgUpdateParams", v1beta1_tx.MsgUpdateParams],
    ["/cosmwasm.wasm.v1.StoreCodeProposal", proposal.StoreCodeProposal],
    [
        "/cosmwasm.wasm.v1.InstantiateContractProposal",
        proposal.InstantiateContractProposal,
    ],
    ["/cosmwasm.wasm.v1.MigrateContractProposal", proposal.MigrateContractProposal],
    ["/cosmwasm.wasm.v1.UpdateAdminProposal", proposal.UpdateAdminProposal],
    ["/cosmwasm.wasm.v1.ClearAdminProposal", proposal.ClearAdminProposal],
    ["/cosmwasm.wasm.v1.PinCodesProposal", proposal.PinCodesProposal],
    ["/cosmwasm.wasm.v1.UnpinCodesProposal", proposal.UnpinCodesProposal],
    ["/cosmwasm.wasm.v1.ExecuteContractProposal", proposal.ExecuteContractProposal],
    [
        "/cosmwasm.wasm.v1.UpdateInstantiateConfigProposal",
        proposal.UpdateInstantiateConfigProposal,
    ],
    ["/cosmwasm.wasm.v1.MsgStoreCode", wasm_v1_tx.MsgStoreCode],
    ["/cosmwasm.wasm.v1.MsgInstantiateContract", wasm_v1_tx.MsgInstantiateContract],
    ["/cosmwasm.wasm.v1.MsgMigrateContract", wasm_v1_tx.MsgMigrateContract],
    ["/cosmwasm.wasm.v1.MsgUpdateAdmin", wasm_v1_tx.MsgUpdateAdmin],
    ["/cosmwasm.wasm.v1.MsgClearAdmin", wasm_v1_tx.MsgClearAdmin],
    // ["/cosmwasm.wasm.v1.MsgPinCodes", MsgPinCodes],
    // ["/cosmwasm.wasm.v1.MsgUnpinCodes", MsgUnpinCodes],
    ["/cosmwasm.wasm.v1.MsgExecuteContract", wasm_v1_tx.MsgExecuteContract],
    ["/cosmwasm.wasm.v1.MsgUpdateInstantiateConfig", wasm_v1_tx.MsgUpdateInstantiateConfig],
    ["/cosmos.upgrade.v1beta1.SoftwareUpgradeProposal", upgrade.SoftwareUpgradeProposal],
    ["/cosmos.upgrade.v1beta1.MsgSoftwareUpgrade", upgrade_v1beta1_tx.MsgSoftwareUpgrade],
    ["/kujira.scheduler.CreateHookProposal", CreateHookProposal],
    ["/kujira.scheduler.UpdateHookProposal", UpdateHookProposal],
    ["/kujira.scheduler.DeleteHookProposal", DeleteHookProposal],
    ["/cosmos.gov.v1beta1.TextProposal", gov.TextProposal],
    ["/cosmos.gov.v1.MsgExecLegacyContent", v1_tx.MsgExecLegacyContent],
    ["/ibc.core.client.v1.ClientUpdateProposal", client.ClientUpdateProposal],
];
const extraIbc = [
    ["/ibc.lightclients.tendermint.v1.Header", tendermint.Header],
    ["/ibc.lightclients.tendermint.v1.ClientState", tendermint.ClientState],
    ["/ibc.lightclients.tendermint.v1.ConsensusState", tendermint.ConsensusState],
    ["/ibc.lightclients.tendermint.v1.Misbehaviour", tendermint.Misbehaviour],
];
const registry_types = [
    ...stargate_build.defaultRegistryTypes,
    [
        "/cosmos.staking.v1beta1.MsgCancelUnbondingDelegation",
        staking_v1beta1_tx.MsgCancelUnbondingDelegation,
    ],
    ...kujira_denom_types,
    // ...ethermintEvm.types,
    // ...ethermintFeemarket.types,
    ...kujira_oracle_types,
    ...modules.wasmTypes,
    ...build_modules.ibcTypes,
    ...proposalTypes,
    ...extraIbc,
    ...types,
    ...alliance_types,
];
const registry_registry = new proto_signing_build.Registry(registry_types);
const accountParser = (acc) => {
    var _a;
    switch (acc.typeUrl) {
        case "/stride.vesting.StridePeriodicVestingAccount":
            const baseAccount = (_a = StridePeriodicVestingAccount.decode(acc.value)
                .baseVestingAccount) === null || _a === void 0 ? void 0 : _a.baseAccount;
            assert(baseAccount);
            return s.accountFromAny({
                typeUrl: "/cosmos.auth.v1beta1.BaseAccount",
                value: BaseAccount.encode(baseAccount).finish(),
            });
        case "/injective.types.v1beta1.EthAccount":
            const injAccount = inj.EthAccount.decode(acc.value);
            const baseInjAccount = injAccount.baseAccount;
            const pubKey = baseInjAccount.pubKey;
            return {
                address: baseInjAccount.address,
                pubkey: pubKey
                    ? {
                        type: "/injective.crypto.v1beta1.ethsecp256k1.PubKey",
                        value: registry_Buffer.from(pubKey.value).toString("base64"),
                    }
                    : null,
                accountNumber: baseInjAccount.accountNumber.toNumber(),
                sequence: baseInjAccount.sequence.toNumber(),
            };
        case "/ethermint.types.v1.EthAccount":
            const account = eth.EthAccount.decode(acc.value);
            const baseEthAccount = account.baseAccount;
            const pubKeyEth = baseEthAccount.pubKey;
            return {
                address: baseEthAccount.address,
                pubkey: pubKeyEth
                    ? {
                        type: "/ethermint.crypto.v1.ethsecp256k1.PubKey",
                        value: registry_Buffer.from(pubKeyEth.value).toString("base64"),
                    }
                    : null,
                accountNumber: baseEthAccount.accountNumber.toNumber(),
                sequence: baseEthAccount.sequence.toNumber(),
            };
        default:
            return s.accountFromAny(acc);
    }
};

// EXTERNAL MODULE: ./node_modules/kujira.js/node_modules/@cosmjs/encoding/build/index.js
var encoding_build = __webpack_require__(87061);
// EXTERNAL MODULE: ./node_modules/kujira.js/node_modules/@cosmjs/tendermint-rpc/build/index.js
var tendermint_rpc_build = __webpack_require__(52474);
// EXTERNAL MODULE: ./node_modules/kujira.js/node_modules/cosmjs-types/cosmos/crypto/ed25519/keys.js
var keys = __webpack_require__(72360);
;// CONCATENATED MODULE: ./node_modules/kujira.js/lib/esm/utils.js



const setSignerAddress = (v) => {
    const decoded = v.consensusPubkey && PubKey.decode(v.consensusPubkey.value);
    const address = decoded && pubkeyToAddress("ed25519", decoded.key);
    return Object.assign(Object.assign({}, v), { signerAddress: (address && toBech32("kujiravalcons", fromHex(address))) || "" });
};

;// CONCATENATED MODULE: ./node_modules/kujira.js/lib/esm/index.js





















if (minimal.util.Long !== (long_default())) {
    minimal.util.Long = (long_default());
    (0,minimal.configure)();
}


/***/ }),

/***/ 57466:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

// See https://github.com/tendermint/tendermint/blob/f2ada0a604b4c0763bda2f64fac53d506d3beca7/docs/spec/blockchain/encoding.md#public-key-cryptography
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.pubkeyToAddress = exports.pubkeyToRawAddress = exports.rawSecp256k1PubkeyToRawAddress = exports.rawEd25519PubkeyToRawAddress = void 0;
const crypto_1 = __webpack_require__(45027);
const encoding_1 = __webpack_require__(87061);
const encoding_2 = __webpack_require__(30421);
const pubkeys_1 = __webpack_require__(23380);
function rawEd25519PubkeyToRawAddress(pubkeyData) {
    if (pubkeyData.length !== 32) {
        throw new Error(`Invalid Ed25519 pubkey length: ${pubkeyData.length}`);
    }
    return (0, crypto_1.sha256)(pubkeyData).slice(0, 20);
}
exports.rawEd25519PubkeyToRawAddress = rawEd25519PubkeyToRawAddress;
function rawSecp256k1PubkeyToRawAddress(pubkeyData) {
    if (pubkeyData.length !== 33) {
        throw new Error(`Invalid Secp256k1 pubkey length (compressed): ${pubkeyData.length}`);
    }
    return (0, crypto_1.ripemd160)((0, crypto_1.sha256)(pubkeyData));
}
exports.rawSecp256k1PubkeyToRawAddress = rawSecp256k1PubkeyToRawAddress;
// For secp256k1 this assumes we already have a compressed pubkey.
function pubkeyToRawAddress(pubkey) {
    if ((0, pubkeys_1.isSecp256k1Pubkey)(pubkey)) {
        const pubkeyData = (0, encoding_1.fromBase64)(pubkey.value);
        return rawSecp256k1PubkeyToRawAddress(pubkeyData);
    }
    else if ((0, pubkeys_1.isEd25519Pubkey)(pubkey)) {
        const pubkeyData = (0, encoding_1.fromBase64)(pubkey.value);
        return rawEd25519PubkeyToRawAddress(pubkeyData);
    }
    else if ((0, pubkeys_1.isMultisigThresholdPubkey)(pubkey)) {
        // https://github.com/tendermint/tendermint/blob/38b401657e4ad7a7eeb3c30a3cbf512037df3740/crypto/multisig/threshold_pubkey.go#L71-L74
        const pubkeyData = (0, encoding_2.encodeAminoPubkey)(pubkey);
        return (0, crypto_1.sha256)(pubkeyData).slice(0, 20);
    }
    else {
        throw new Error("Unsupported public key type");
    }
}
exports.pubkeyToRawAddress = pubkeyToRawAddress;
function pubkeyToAddress(pubkey, prefix) {
    return (0, encoding_1.toBech32)(prefix, pubkeyToRawAddress(pubkey));
}
exports.pubkeyToAddress = pubkeyToAddress;
//# sourceMappingURL=addresses.js.map

/***/ }),

/***/ 43994:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.addCoins = exports.parseCoins = exports.coins = exports.coin = void 0;
const math_1 = __webpack_require__(66021);
/**
 * Creates a coin.
 *
 * If your values do not exceed the safe integer range of JS numbers (53 bit),
 * you can use the number type here. This is the case for all typical Cosmos SDK
 * chains that use the default 6 decimals.
 *
 * In case you need to supportr larger values, use unsigned integer strings instead.
 */
function coin(amount, denom) {
    let outAmount;
    if (typeof amount === "number") {
        try {
            outAmount = new math_1.Uint53(amount).toString();
        }
        catch (_err) {
            throw new Error("Given amount is not a safe integer. Consider using a string instead to overcome the limitations of JS numbers.");
        }
    }
    else {
        if (!amount.match(/^[0-9]+$/)) {
            throw new Error("Invalid unsigned integer string format");
        }
        outAmount = amount.replace(/^0*/, "") || "0";
    }
    return {
        amount: outAmount,
        denom: denom,
    };
}
exports.coin = coin;
/**
 * Creates a list of coins with one element.
 */
function coins(amount, denom) {
    return [coin(amount, denom)];
}
exports.coins = coins;
/**
 * Takes a coins list like "819966000ucosm,700000000ustake" and parses it.
 *
 * A Stargate-ready variant of this function is available via:
 *
 * ```
 * import { parseCoins } from "@cosmjs/proto-signing";
 * // or
 * import { parseCoins } from "@cosmjs/stargate";
 * ```
 */
function parseCoins(input) {
    return input
        .replace(/\s/g, "")
        .split(",")
        .filter(Boolean)
        .map((part) => {
        const match = part.match(/^([0-9]+)([a-zA-Z]+)/);
        if (!match)
            throw new Error("Got an invalid coin string");
        return {
            amount: match[1].replace(/^0+/, "") || "0",
            denom: match[2],
        };
    });
}
exports.parseCoins = parseCoins;
/**
 * Function to sum up coins with type Coin
 */
function addCoins(lhs, rhs) {
    if (lhs.denom !== rhs.denom)
        throw new Error("Trying to add two coins with different denoms");
    return {
        amount: math_1.Decimal.fromAtomics(lhs.amount, 0).plus(math_1.Decimal.fromAtomics(rhs.amount, 0)).atomics,
        denom: lhs.denom,
    };
}
exports.addCoins = addCoins;
//# sourceMappingURL=coins.js.map

/***/ }),

/***/ 30421:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.encodeBech32Pubkey = exports.encodeAminoPubkey = exports.decodeBech32Pubkey = exports.decodeAminoPubkey = exports.encodeEd25519Pubkey = exports.encodeSecp256k1Pubkey = void 0;
const encoding_1 = __webpack_require__(87061);
const math_1 = __webpack_require__(66021);
const utils_1 = __webpack_require__(62584);
const pubkeys_1 = __webpack_require__(23380);
/**
 * Takes a Secp256k1 public key as raw bytes and returns the Amino JSON
 * representation of it (the type/value wrapper object).
 */
function encodeSecp256k1Pubkey(pubkey) {
    if (pubkey.length !== 33 || (pubkey[0] !== 0x02 && pubkey[0] !== 0x03)) {
        throw new Error("Public key must be compressed secp256k1, i.e. 33 bytes starting with 0x02 or 0x03");
    }
    return {
        type: pubkeys_1.pubkeyType.secp256k1,
        value: (0, encoding_1.toBase64)(pubkey),
    };
}
exports.encodeSecp256k1Pubkey = encodeSecp256k1Pubkey;
/**
 * Takes an Edd25519 public key as raw bytes and returns the Amino JSON
 * representation of it (the type/value wrapper object).
 */
function encodeEd25519Pubkey(pubkey) {
    if (pubkey.length !== 32) {
        throw new Error("Ed25519 public key must be 32 bytes long");
    }
    return {
        type: pubkeys_1.pubkeyType.ed25519,
        value: (0, encoding_1.toBase64)(pubkey),
    };
}
exports.encodeEd25519Pubkey = encodeEd25519Pubkey;
// As discussed in https://github.com/binance-chain/javascript-sdk/issues/163
// Prefixes listed here: https://github.com/tendermint/tendermint/blob/d419fffe18531317c28c29a292ad7d253f6cafdf/docs/spec/blockchain/encoding.md#public-key-cryptography
// Last bytes is varint-encoded length prefix
const pubkeyAminoPrefixSecp256k1 = (0, encoding_1.fromHex)("eb5ae987" + "21" /* fixed length */);
const pubkeyAminoPrefixEd25519 = (0, encoding_1.fromHex)("1624de64" + "20" /* fixed length */);
const pubkeyAminoPrefixSr25519 = (0, encoding_1.fromHex)("0dfb1005" + "20" /* fixed length */);
/** See https://github.com/tendermint/tendermint/commit/38b401657e4ad7a7eeb3c30a3cbf512037df3740 */
const pubkeyAminoPrefixMultisigThreshold = (0, encoding_1.fromHex)("22c1f7e2" /* variable length not included */);
/**
 * Decodes a pubkey in the Amino binary format to a type/value object.
 */
function decodeAminoPubkey(data) {
    if ((0, utils_1.arrayContentStartsWith)(data, pubkeyAminoPrefixSecp256k1)) {
        const rest = data.slice(pubkeyAminoPrefixSecp256k1.length);
        if (rest.length !== 33) {
            throw new Error("Invalid rest data length. Expected 33 bytes (compressed secp256k1 pubkey).");
        }
        return {
            type: pubkeys_1.pubkeyType.secp256k1,
            value: (0, encoding_1.toBase64)(rest),
        };
    }
    else if ((0, utils_1.arrayContentStartsWith)(data, pubkeyAminoPrefixEd25519)) {
        const rest = data.slice(pubkeyAminoPrefixEd25519.length);
        if (rest.length !== 32) {
            throw new Error("Invalid rest data length. Expected 32 bytes (Ed25519 pubkey).");
        }
        return {
            type: pubkeys_1.pubkeyType.ed25519,
            value: (0, encoding_1.toBase64)(rest),
        };
    }
    else if ((0, utils_1.arrayContentStartsWith)(data, pubkeyAminoPrefixSr25519)) {
        const rest = data.slice(pubkeyAminoPrefixSr25519.length);
        if (rest.length !== 32) {
            throw new Error("Invalid rest data length. Expected 32 bytes (Sr25519 pubkey).");
        }
        return {
            type: pubkeys_1.pubkeyType.sr25519,
            value: (0, encoding_1.toBase64)(rest),
        };
    }
    else if ((0, utils_1.arrayContentStartsWith)(data, pubkeyAminoPrefixMultisigThreshold)) {
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        return decodeMultisigPubkey(data);
    }
    else {
        throw new Error("Unsupported public key type. Amino data starts with: " + (0, encoding_1.toHex)(data.slice(0, 5)));
    }
}
exports.decodeAminoPubkey = decodeAminoPubkey;
/**
 * Decodes a bech32 pubkey to Amino binary, which is then decoded to a type/value object.
 * The bech32 prefix is ignored and discareded.
 *
 * @param bechEncoded the bech32 encoded pubkey
 */
function decodeBech32Pubkey(bechEncoded) {
    const { data } = (0, encoding_1.fromBech32)(bechEncoded);
    return decodeAminoPubkey(data);
}
exports.decodeBech32Pubkey = decodeBech32Pubkey;
/**
 * Uvarint decoder for Amino.
 * @see https://github.com/tendermint/go-amino/blob/8e779b71f40d175/decoder.go#L64-76
 * @returns varint as number, and bytes count occupied by varaint
 */
function decodeUvarint(reader) {
    if (reader.length < 1) {
        throw new Error("Can't decode varint. EOF");
    }
    if (reader[0] > 127) {
        throw new Error("Decoding numbers > 127 is not supported here. Please tell those lazy CosmJS maintainers to port the binary.Varint implementation from the Go standard library and write some tests.");
    }
    return [reader[0], 1];
}
/**
 * Decodes a multisig pubkey to type object.
 * Pubkey structure [ prefix + const + threshold + loop:(const + pubkeyLength + pubkey            ) ]
 *                  [   4b   + 1b    +  varint   + loop:(1b    +    varint    + pubkeyLength bytes) ]
 * @param data encoded pubkey
 */
function decodeMultisigPubkey(data) {
    const reader = Array.from(data);
    // remove multisig amino prefix;
    const prefixFromReader = reader.splice(0, pubkeyAminoPrefixMultisigThreshold.length);
    if (!(0, utils_1.arrayContentStartsWith)(prefixFromReader, pubkeyAminoPrefixMultisigThreshold)) {
        throw new Error("Invalid multisig prefix.");
    }
    // remove 0x08 threshold prefix;
    if (reader.shift() != 0x08) {
        throw new Error("Invalid multisig data. Expecting 0x08 prefix before threshold.");
    }
    // read threshold
    const [threshold, thresholdBytesLength] = decodeUvarint(reader);
    reader.splice(0, thresholdBytesLength);
    // read participants pubkeys
    const pubkeys = [];
    while (reader.length > 0) {
        // remove 0x12 threshold prefix;
        if (reader.shift() != 0x12) {
            throw new Error("Invalid multisig data. Expecting 0x12 prefix before participant pubkey length.");
        }
        // read pubkey length
        const [pubkeyLength, pubkeyLengthBytesSize] = decodeUvarint(reader);
        reader.splice(0, pubkeyLengthBytesSize);
        // verify that we can read pubkey
        if (reader.length < pubkeyLength) {
            throw new Error("Invalid multisig data length.");
        }
        // read and decode participant pubkey
        const encodedPubkey = reader.splice(0, pubkeyLength);
        const pubkey = decodeAminoPubkey(Uint8Array.from(encodedPubkey));
        pubkeys.push(pubkey);
    }
    return {
        type: pubkeys_1.pubkeyType.multisigThreshold,
        value: {
            threshold: threshold.toString(),
            pubkeys: pubkeys,
        },
    };
}
/**
 * Uvarint encoder for Amino. This is the same encoding as `binary.PutUvarint` from the Go
 * standard library.
 *
 * @see https://github.com/tendermint/go-amino/blob/8e779b71f40d175/encoder.go#L77-L85
 */
function encodeUvarint(value) {
    const checked = math_1.Uint53.fromString(value.toString()).toNumber();
    if (checked > 127) {
        throw new Error("Encoding numbers > 127 is not supported here. Please tell those lazy CosmJS maintainers to port the binary.PutUvarint implementation from the Go standard library and write some tests.");
    }
    return [checked];
}
/**
 * Encodes a public key to binary Amino.
 */
function encodeAminoPubkey(pubkey) {
    if ((0, pubkeys_1.isMultisigThresholdPubkey)(pubkey)) {
        const out = Array.from(pubkeyAminoPrefixMultisigThreshold);
        out.push(0x08); // TODO: What is this?
        out.push(...encodeUvarint(pubkey.value.threshold));
        for (const pubkeyData of pubkey.value.pubkeys.map((p) => encodeAminoPubkey(p))) {
            out.push(0x12); // TODO: What is this?
            out.push(...encodeUvarint(pubkeyData.length));
            out.push(...pubkeyData);
        }
        return new Uint8Array(out);
    }
    else if ((0, pubkeys_1.isEd25519Pubkey)(pubkey)) {
        return new Uint8Array([...pubkeyAminoPrefixEd25519, ...(0, encoding_1.fromBase64)(pubkey.value)]);
    }
    else if ((0, pubkeys_1.isSecp256k1Pubkey)(pubkey)) {
        return new Uint8Array([...pubkeyAminoPrefixSecp256k1, ...(0, encoding_1.fromBase64)(pubkey.value)]);
    }
    else {
        throw new Error("Unsupported pubkey type");
    }
}
exports.encodeAminoPubkey = encodeAminoPubkey;
/**
 * Encodes a public key to binary Amino and then to bech32.
 *
 * @param pubkey the public key to encode
 * @param prefix the bech32 prefix (human readable part)
 */
function encodeBech32Pubkey(pubkey, prefix) {
    return (0, encoding_1.toBech32)(prefix, encodeAminoPubkey(pubkey));
}
exports.encodeBech32Pubkey = encodeBech32Pubkey;
//# sourceMappingURL=encoding.js.map

/***/ }),

/***/ 98802:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.executeKdf = exports.makeStdTx = exports.isStdTx = exports.serializeSignDoc = exports.makeSignDoc = exports.encodeSecp256k1Signature = exports.decodeSignature = exports.Secp256k1Wallet = exports.Secp256k1HdWallet = exports.extractKdfConfiguration = exports.pubkeyType = exports.isSinglePubkey = exports.isSecp256k1Pubkey = exports.isMultisigThresholdPubkey = exports.isEd25519Pubkey = exports.makeCosmoshubPath = exports.createMultisigThresholdPubkey = exports.encodeSecp256k1Pubkey = exports.encodeEd25519Pubkey = exports.encodeBech32Pubkey = exports.encodeAminoPubkey = exports.decodeBech32Pubkey = exports.decodeAminoPubkey = exports.parseCoins = exports.coins = exports.coin = exports.addCoins = exports.rawSecp256k1PubkeyToRawAddress = exports.rawEd25519PubkeyToRawAddress = exports.pubkeyToRawAddress = exports.pubkeyToAddress = void 0;
var addresses_1 = __webpack_require__(57466);
Object.defineProperty(exports, "pubkeyToAddress", ({ enumerable: true, get: function () { return addresses_1.pubkeyToAddress; } }));
Object.defineProperty(exports, "pubkeyToRawAddress", ({ enumerable: true, get: function () { return addresses_1.pubkeyToRawAddress; } }));
Object.defineProperty(exports, "rawEd25519PubkeyToRawAddress", ({ enumerable: true, get: function () { return addresses_1.rawEd25519PubkeyToRawAddress; } }));
Object.defineProperty(exports, "rawSecp256k1PubkeyToRawAddress", ({ enumerable: true, get: function () { return addresses_1.rawSecp256k1PubkeyToRawAddress; } }));
var coins_1 = __webpack_require__(43994);
Object.defineProperty(exports, "addCoins", ({ enumerable: true, get: function () { return coins_1.addCoins; } }));
Object.defineProperty(exports, "coin", ({ enumerable: true, get: function () { return coins_1.coin; } }));
Object.defineProperty(exports, "coins", ({ enumerable: true, get: function () { return coins_1.coins; } }));
Object.defineProperty(exports, "parseCoins", ({ enumerable: true, get: function () { return coins_1.parseCoins; } }));
var encoding_1 = __webpack_require__(30421);
Object.defineProperty(exports, "decodeAminoPubkey", ({ enumerable: true, get: function () { return encoding_1.decodeAminoPubkey; } }));
Object.defineProperty(exports, "decodeBech32Pubkey", ({ enumerable: true, get: function () { return encoding_1.decodeBech32Pubkey; } }));
Object.defineProperty(exports, "encodeAminoPubkey", ({ enumerable: true, get: function () { return encoding_1.encodeAminoPubkey; } }));
Object.defineProperty(exports, "encodeBech32Pubkey", ({ enumerable: true, get: function () { return encoding_1.encodeBech32Pubkey; } }));
Object.defineProperty(exports, "encodeEd25519Pubkey", ({ enumerable: true, get: function () { return encoding_1.encodeEd25519Pubkey; } }));
Object.defineProperty(exports, "encodeSecp256k1Pubkey", ({ enumerable: true, get: function () { return encoding_1.encodeSecp256k1Pubkey; } }));
var multisig_1 = __webpack_require__(43278);
Object.defineProperty(exports, "createMultisigThresholdPubkey", ({ enumerable: true, get: function () { return multisig_1.createMultisigThresholdPubkey; } }));
var paths_1 = __webpack_require__(35928);
Object.defineProperty(exports, "makeCosmoshubPath", ({ enumerable: true, get: function () { return paths_1.makeCosmoshubPath; } }));
var pubkeys_1 = __webpack_require__(23380);
Object.defineProperty(exports, "isEd25519Pubkey", ({ enumerable: true, get: function () { return pubkeys_1.isEd25519Pubkey; } }));
Object.defineProperty(exports, "isMultisigThresholdPubkey", ({ enumerable: true, get: function () { return pubkeys_1.isMultisigThresholdPubkey; } }));
Object.defineProperty(exports, "isSecp256k1Pubkey", ({ enumerable: true, get: function () { return pubkeys_1.isSecp256k1Pubkey; } }));
Object.defineProperty(exports, "isSinglePubkey", ({ enumerable: true, get: function () { return pubkeys_1.isSinglePubkey; } }));
Object.defineProperty(exports, "pubkeyType", ({ enumerable: true, get: function () { return pubkeys_1.pubkeyType; } }));
var secp256k1hdwallet_1 = __webpack_require__(95880);
Object.defineProperty(exports, "extractKdfConfiguration", ({ enumerable: true, get: function () { return secp256k1hdwallet_1.extractKdfConfiguration; } }));
Object.defineProperty(exports, "Secp256k1HdWallet", ({ enumerable: true, get: function () { return secp256k1hdwallet_1.Secp256k1HdWallet; } }));
var secp256k1wallet_1 = __webpack_require__(28613);
Object.defineProperty(exports, "Secp256k1Wallet", ({ enumerable: true, get: function () { return secp256k1wallet_1.Secp256k1Wallet; } }));
var signature_1 = __webpack_require__(5227);
Object.defineProperty(exports, "decodeSignature", ({ enumerable: true, get: function () { return signature_1.decodeSignature; } }));
Object.defineProperty(exports, "encodeSecp256k1Signature", ({ enumerable: true, get: function () { return signature_1.encodeSecp256k1Signature; } }));
var signdoc_1 = __webpack_require__(37756);
Object.defineProperty(exports, "makeSignDoc", ({ enumerable: true, get: function () { return signdoc_1.makeSignDoc; } }));
Object.defineProperty(exports, "serializeSignDoc", ({ enumerable: true, get: function () { return signdoc_1.serializeSignDoc; } }));
var stdtx_1 = __webpack_require__(11398);
Object.defineProperty(exports, "isStdTx", ({ enumerable: true, get: function () { return stdtx_1.isStdTx; } }));
Object.defineProperty(exports, "makeStdTx", ({ enumerable: true, get: function () { return stdtx_1.makeStdTx; } }));
var wallet_1 = __webpack_require__(92505);
Object.defineProperty(exports, "executeKdf", ({ enumerable: true, get: function () { return wallet_1.executeKdf; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 43278:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.createMultisigThresholdPubkey = exports.compareArrays = void 0;
const encoding_1 = __webpack_require__(87061);
const math_1 = __webpack_require__(66021);
const addresses_1 = __webpack_require__(57466);
/**
 * Compare arrays lexicographically.
 *
 * Returns value < 0 if `a < b`.
 * Returns value > 0 if `a > b`.
 * Returns 0 if `a === b`.
 */
function compareArrays(a, b) {
    const aHex = (0, encoding_1.toHex)(a);
    const bHex = (0, encoding_1.toHex)(b);
    return aHex === bHex ? 0 : aHex < bHex ? -1 : 1;
}
exports.compareArrays = compareArrays;
function createMultisigThresholdPubkey(pubkeys, threshold, nosort = false) {
    const uintThreshold = new math_1.Uint53(threshold);
    if (uintThreshold.toNumber() > pubkeys.length) {
        throw new Error(`Threshold k = ${uintThreshold.toNumber()} exceeds number of keys n = ${pubkeys.length}`);
    }
    const outPubkeys = nosort
        ? pubkeys
        : Array.from(pubkeys).sort((lhs, rhs) => {
            // https://github.com/cosmos/cosmos-sdk/blob/v0.42.2/client/keys/add.go#L172-L174
            const addressLhs = (0, addresses_1.pubkeyToRawAddress)(lhs);
            const addressRhs = (0, addresses_1.pubkeyToRawAddress)(rhs);
            return compareArrays(addressLhs, addressRhs);
        });
    return {
        type: "tendermint/PubKeyMultisigThreshold",
        value: {
            threshold: uintThreshold.toString(),
            pubkeys: outPubkeys,
        },
    };
}
exports.createMultisigThresholdPubkey = createMultisigThresholdPubkey;
//# sourceMappingURL=multisig.js.map

/***/ }),

/***/ 35928:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.makeCosmoshubPath = void 0;
const crypto_1 = __webpack_require__(45027);
/**
 * The Cosmos Hub derivation path in the form `m/44'/118'/0'/0/a`
 * with 0-based account index `a`.
 */
function makeCosmoshubPath(a) {
    return [
        crypto_1.Slip10RawIndex.hardened(44),
        crypto_1.Slip10RawIndex.hardened(118),
        crypto_1.Slip10RawIndex.hardened(0),
        crypto_1.Slip10RawIndex.normal(0),
        crypto_1.Slip10RawIndex.normal(a),
    ];
}
exports.makeCosmoshubPath = makeCosmoshubPath;
//# sourceMappingURL=paths.js.map

/***/ }),

/***/ 23380:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.isMultisigThresholdPubkey = exports.isSinglePubkey = exports.pubkeyType = exports.isSecp256k1Pubkey = exports.isEd25519Pubkey = void 0;
function isEd25519Pubkey(pubkey) {
    return pubkey.type === "tendermint/PubKeyEd25519";
}
exports.isEd25519Pubkey = isEd25519Pubkey;
function isSecp256k1Pubkey(pubkey) {
    return pubkey.type === "tendermint/PubKeySecp256k1";
}
exports.isSecp256k1Pubkey = isSecp256k1Pubkey;
exports.pubkeyType = {
    /** @see https://github.com/tendermint/tendermint/blob/v0.33.0/crypto/ed25519/ed25519.go#L22 */
    secp256k1: "tendermint/PubKeySecp256k1",
    /** @see https://github.com/tendermint/tendermint/blob/v0.33.0/crypto/secp256k1/secp256k1.go#L23 */
    ed25519: "tendermint/PubKeyEd25519",
    /** @see https://github.com/tendermint/tendermint/blob/v0.33.0/crypto/sr25519/codec.go#L12 */
    sr25519: "tendermint/PubKeySr25519",
    multisigThreshold: "tendermint/PubKeyMultisigThreshold",
};
function isSinglePubkey(pubkey) {
    const singPubkeyTypes = [exports.pubkeyType.ed25519, exports.pubkeyType.secp256k1, exports.pubkeyType.sr25519];
    return singPubkeyTypes.includes(pubkey.type);
}
exports.isSinglePubkey = isSinglePubkey;
function isMultisigThresholdPubkey(pubkey) {
    return pubkey.type === "tendermint/PubKeyMultisigThreshold";
}
exports.isMultisigThresholdPubkey = isMultisigThresholdPubkey;
//# sourceMappingURL=pubkeys.js.map

/***/ }),

/***/ 95880:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Secp256k1HdWallet = exports.extractKdfConfiguration = void 0;
const crypto_1 = __webpack_require__(45027);
const encoding_1 = __webpack_require__(87061);
const utils_1 = __webpack_require__(62584);
const addresses_1 = __webpack_require__(57466);
const paths_1 = __webpack_require__(35928);
const signature_1 = __webpack_require__(5227);
const signdoc_1 = __webpack_require__(37756);
const wallet_1 = __webpack_require__(92505);
const serializationTypeV1 = "secp256k1wallet-v1";
/**
 * A KDF configuration that is not very strong but can be used on the main thread.
 * It takes about 1 second in Node.js 16.0.0 and should have similar runtimes in other modern Wasm hosts.
 */
const basicPasswordHashingOptions = {
    algorithm: "argon2id",
    params: {
        outputLength: 32,
        opsLimit: 24,
        memLimitKib: 12 * 1024,
    },
};
function isDerivationJson(thing) {
    if (!(0, utils_1.isNonNullObject)(thing))
        return false;
    if (typeof thing.hdPath !== "string")
        return false;
    if (typeof thing.prefix !== "string")
        return false;
    return true;
}
function extractKdfConfigurationV1(doc) {
    return doc.kdf;
}
function extractKdfConfiguration(serialization) {
    const root = JSON.parse(serialization);
    if (!(0, utils_1.isNonNullObject)(root))
        throw new Error("Root document is not an object.");
    switch (root.type) {
        case serializationTypeV1:
            return extractKdfConfigurationV1(root);
        default:
            throw new Error("Unsupported serialization type");
    }
}
exports.extractKdfConfiguration = extractKdfConfiguration;
const defaultOptions = {
    bip39Password: "",
    hdPaths: [(0, paths_1.makeCosmoshubPath)(0)],
    prefix: "cosmos",
};
class Secp256k1HdWallet {
    /**
     * Restores a wallet from the given BIP39 mnemonic.
     *
     * @param mnemonic Any valid English mnemonic.
     * @param options An optional `Secp256k1HdWalletOptions` object optionally containing a bip39Password, hdPaths, and prefix.
     */
    static async fromMnemonic(mnemonic, options = {}) {
        const mnemonicChecked = new crypto_1.EnglishMnemonic(mnemonic);
        const seed = await crypto_1.Bip39.mnemonicToSeed(mnemonicChecked, options.bip39Password);
        return new Secp256k1HdWallet(mnemonicChecked, {
            ...options,
            seed: seed,
        });
    }
    /**
     * Generates a new wallet with a BIP39 mnemonic of the given length.
     *
     * @param length The number of words in the mnemonic (12, 15, 18, 21 or 24).
     * @param options An optional `Secp256k1HdWalletOptions` object optionally containing a bip39Password, hdPaths, and prefix.
     */
    static async generate(length = 12, options = {}) {
        const entropyLength = 4 * Math.floor((11 * length) / 33);
        const entropy = crypto_1.Random.getBytes(entropyLength);
        const mnemonic = crypto_1.Bip39.encode(entropy);
        return Secp256k1HdWallet.fromMnemonic(mnemonic.toString(), options);
    }
    /**
     * Restores a wallet from an encrypted serialization.
     *
     * @param password The user provided password used to generate an encryption key via a KDF.
     *                 This is not normalized internally (see "Unicode normalization" to learn more).
     */
    static async deserialize(serialization, password) {
        const root = JSON.parse(serialization);
        if (!(0, utils_1.isNonNullObject)(root))
            throw new Error("Root document is not an object.");
        switch (root.type) {
            case serializationTypeV1:
                return Secp256k1HdWallet.deserializeTypeV1(serialization, password);
            default:
                throw new Error("Unsupported serialization type");
        }
    }
    /**
     * Restores a wallet from an encrypted serialization.
     *
     * This is an advanced alternative to calling `deserialize(serialization, password)` directly, which allows
     * you to offload the KDF execution to a non-UI thread (e.g. in a WebWorker).
     *
     * The caller is responsible for ensuring the key was derived with the given KDF configuration. This can be
     * done using `extractKdfConfiguration(serialization)` and `executeKdf(password, kdfConfiguration)` from this package.
     */
    static async deserializeWithEncryptionKey(serialization, encryptionKey) {
        const root = JSON.parse(serialization);
        if (!(0, utils_1.isNonNullObject)(root))
            throw new Error("Root document is not an object.");
        const untypedRoot = root;
        switch (untypedRoot.type) {
            case serializationTypeV1: {
                const decryptedBytes = await (0, wallet_1.decrypt)((0, encoding_1.fromBase64)(untypedRoot.data), encryptionKey, untypedRoot.encryption);
                const decryptedDocument = JSON.parse((0, encoding_1.fromUtf8)(decryptedBytes));
                const { mnemonic, accounts } = decryptedDocument;
                (0, utils_1.assert)(typeof mnemonic === "string");
                if (!Array.isArray(accounts))
                    throw new Error("Property 'accounts' is not an array");
                if (!accounts.every((account) => isDerivationJson(account))) {
                    throw new Error("Account is not in the correct format.");
                }
                const firstPrefix = accounts[0].prefix;
                if (!accounts.every(({ prefix }) => prefix === firstPrefix)) {
                    throw new Error("Accounts do not all have the same prefix");
                }
                const hdPaths = accounts.map(({ hdPath }) => (0, crypto_1.stringToPath)(hdPath));
                return Secp256k1HdWallet.fromMnemonic(mnemonic, {
                    hdPaths: hdPaths,
                    prefix: firstPrefix,
                });
            }
            default:
                throw new Error("Unsupported serialization type");
        }
    }
    static async deserializeTypeV1(serialization, password) {
        const root = JSON.parse(serialization);
        if (!(0, utils_1.isNonNullObject)(root))
            throw new Error("Root document is not an object.");
        const encryptionKey = await (0, wallet_1.executeKdf)(password, root.kdf);
        return Secp256k1HdWallet.deserializeWithEncryptionKey(serialization, encryptionKey);
    }
    constructor(mnemonic, options) {
        const hdPaths = options.hdPaths ?? defaultOptions.hdPaths;
        const prefix = options.prefix ?? defaultOptions.prefix;
        this.secret = mnemonic;
        this.seed = options.seed;
        this.accounts = hdPaths.map((hdPath) => ({
            hdPath: hdPath,
            prefix,
        }));
    }
    get mnemonic() {
        return this.secret.toString();
    }
    async getAccounts() {
        const accountsWithPrivkeys = await this.getAccountsWithPrivkeys();
        return accountsWithPrivkeys.map(({ algo, pubkey, address }) => ({
            algo: algo,
            pubkey: pubkey,
            address: address,
        }));
    }
    async signAmino(signerAddress, signDoc) {
        const accounts = await this.getAccountsWithPrivkeys();
        const account = accounts.find(({ address }) => address === signerAddress);
        if (account === undefined) {
            throw new Error(`Address ${signerAddress} not found in wallet`);
        }
        const { privkey, pubkey } = account;
        const message = (0, crypto_1.sha256)((0, signdoc_1.serializeSignDoc)(signDoc));
        const signature = await crypto_1.Secp256k1.createSignature(message, privkey);
        const signatureBytes = new Uint8Array([...signature.r(32), ...signature.s(32)]);
        return {
            signed: signDoc,
            signature: (0, signature_1.encodeSecp256k1Signature)(pubkey, signatureBytes),
        };
    }
    /**
     * Generates an encrypted serialization of this wallet.
     *
     * @param password The user provided password used to generate an encryption key via a KDF.
     *                 This is not normalized internally (see "Unicode normalization" to learn more).
     */
    async serialize(password) {
        const kdfConfiguration = basicPasswordHashingOptions;
        const encryptionKey = await (0, wallet_1.executeKdf)(password, kdfConfiguration);
        return this.serializeWithEncryptionKey(encryptionKey, kdfConfiguration);
    }
    /**
     * Generates an encrypted serialization of this wallet.
     *
     * This is an advanced alternative to calling `serialize(password)` directly, which allows you to
     * offload the KDF execution to a non-UI thread (e.g. in a WebWorker).
     *
     * The caller is responsible for ensuring the key was derived with the given KDF options. If this
     * is not the case, the wallet cannot be restored with the original password.
     */
    async serializeWithEncryptionKey(encryptionKey, kdfConfiguration) {
        const dataToEncrypt = {
            mnemonic: this.mnemonic,
            accounts: this.accounts.map(({ hdPath, prefix }) => ({
                hdPath: (0, crypto_1.pathToString)(hdPath),
                prefix: prefix,
            })),
        };
        const dataToEncryptRaw = (0, encoding_1.toUtf8)(JSON.stringify(dataToEncrypt));
        const encryptionConfiguration = {
            algorithm: wallet_1.supportedAlgorithms.xchacha20poly1305Ietf,
        };
        const encryptedData = await (0, wallet_1.encrypt)(dataToEncryptRaw, encryptionKey, encryptionConfiguration);
        const out = {
            type: serializationTypeV1,
            kdf: kdfConfiguration,
            encryption: encryptionConfiguration,
            data: (0, encoding_1.toBase64)(encryptedData),
        };
        return JSON.stringify(out);
    }
    async getKeyPair(hdPath) {
        const { privkey } = crypto_1.Slip10.derivePath(crypto_1.Slip10Curve.Secp256k1, this.seed, hdPath);
        const { pubkey } = await crypto_1.Secp256k1.makeKeypair(privkey);
        return {
            privkey: privkey,
            pubkey: crypto_1.Secp256k1.compressPubkey(pubkey),
        };
    }
    async getAccountsWithPrivkeys() {
        return Promise.all(this.accounts.map(async ({ hdPath, prefix }) => {
            const { privkey, pubkey } = await this.getKeyPair(hdPath);
            const address = (0, encoding_1.toBech32)(prefix, (0, addresses_1.rawSecp256k1PubkeyToRawAddress)(pubkey));
            return {
                algo: "secp256k1",
                privkey: privkey,
                pubkey: pubkey,
                address: address,
            };
        }));
    }
}
exports.Secp256k1HdWallet = Secp256k1HdWallet;
//# sourceMappingURL=secp256k1hdwallet.js.map

/***/ }),

/***/ 28613:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Secp256k1Wallet = void 0;
const crypto_1 = __webpack_require__(45027);
const encoding_1 = __webpack_require__(87061);
const addresses_1 = __webpack_require__(57466);
const signature_1 = __webpack_require__(5227);
const signdoc_1 = __webpack_require__(37756);
/**
 * A wallet that holds a single secp256k1 keypair.
 *
 * If you want to work with BIP39 mnemonics and multiple accounts, use Secp256k1HdWallet.
 */
class Secp256k1Wallet {
    /**
     * Creates a Secp256k1Wallet from the given private key
     *
     * @param privkey The private key.
     * @param prefix The bech32 address prefix (human readable part). Defaults to "cosmos".
     */
    static async fromKey(privkey, prefix = "cosmos") {
        const uncompressed = (await crypto_1.Secp256k1.makeKeypair(privkey)).pubkey;
        return new Secp256k1Wallet(privkey, crypto_1.Secp256k1.compressPubkey(uncompressed), prefix);
    }
    constructor(privkey, pubkey, prefix) {
        this.privkey = privkey;
        this.pubkey = pubkey;
        this.prefix = prefix;
    }
    get address() {
        return (0, encoding_1.toBech32)(this.prefix, (0, addresses_1.rawSecp256k1PubkeyToRawAddress)(this.pubkey));
    }
    async getAccounts() {
        return [
            {
                algo: "secp256k1",
                address: this.address,
                pubkey: this.pubkey,
            },
        ];
    }
    async signAmino(signerAddress, signDoc) {
        if (signerAddress !== this.address) {
            throw new Error(`Address ${signerAddress} not found in wallet`);
        }
        const message = new crypto_1.Sha256((0, signdoc_1.serializeSignDoc)(signDoc)).digest();
        const signature = await crypto_1.Secp256k1.createSignature(message, this.privkey);
        const signatureBytes = new Uint8Array([...signature.r(32), ...signature.s(32)]);
        return {
            signed: signDoc,
            signature: (0, signature_1.encodeSecp256k1Signature)(this.pubkey, signatureBytes),
        };
    }
}
exports.Secp256k1Wallet = Secp256k1Wallet;
//# sourceMappingURL=secp256k1wallet.js.map

/***/ }),

/***/ 5227:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.decodeSignature = exports.encodeSecp256k1Signature = void 0;
/* eslint-disable @typescript-eslint/naming-convention */
const encoding_1 = __webpack_require__(87061);
const encoding_2 = __webpack_require__(30421);
const pubkeys_1 = __webpack_require__(23380);
/**
 * Takes a binary pubkey and signature to create a signature object
 *
 * @param pubkey a compressed secp256k1 public key
 * @param signature a 64 byte fixed length representation of secp256k1 signature components r and s
 */
function encodeSecp256k1Signature(pubkey, signature) {
    if (signature.length !== 64) {
        throw new Error("Signature must be 64 bytes long. Cosmos SDK uses a 2x32 byte fixed length encoding for the secp256k1 signature integers r and s.");
    }
    return {
        pub_key: (0, encoding_2.encodeSecp256k1Pubkey)(pubkey),
        signature: (0, encoding_1.toBase64)(signature),
    };
}
exports.encodeSecp256k1Signature = encodeSecp256k1Signature;
function decodeSignature(signature) {
    switch (signature.pub_key.type) {
        // Note: please don't add cases here without writing additional unit tests
        case pubkeys_1.pubkeyType.secp256k1:
            return {
                pubkey: (0, encoding_1.fromBase64)(signature.pub_key.value),
                signature: (0, encoding_1.fromBase64)(signature.signature),
            };
        default:
            throw new Error("Unsupported pubkey type");
    }
}
exports.decodeSignature = decodeSignature;
//# sourceMappingURL=signature.js.map

/***/ }),

/***/ 37756:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.serializeSignDoc = exports.escapeCharacters = exports.makeSignDoc = exports.sortedJsonStringify = void 0;
/* eslint-disable @typescript-eslint/naming-convention */
const encoding_1 = __webpack_require__(87061);
const math_1 = __webpack_require__(66021);
function sortedObject(obj) {
    if (typeof obj !== "object" || obj === null) {
        return obj;
    }
    if (Array.isArray(obj)) {
        return obj.map(sortedObject);
    }
    const sortedKeys = Object.keys(obj).sort();
    const result = {};
    // NOTE: Use forEach instead of reduce for performance with large objects eg Wasm code
    sortedKeys.forEach((key) => {
        result[key] = sortedObject(obj[key]);
    });
    return result;
}
/** Returns a JSON string with objects sorted by key */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function sortedJsonStringify(obj) {
    return JSON.stringify(sortedObject(obj));
}
exports.sortedJsonStringify = sortedJsonStringify;
function makeSignDoc(msgs, fee, chainId, memo, accountNumber, sequence) {
    return {
        chain_id: chainId,
        account_number: math_1.Uint53.fromString(accountNumber.toString()).toString(),
        sequence: math_1.Uint53.fromString(sequence.toString()).toString(),
        fee: fee,
        msgs: msgs,
        memo: memo || "",
    };
}
exports.makeSignDoc = makeSignDoc;
/**
 * Takes a valid JSON document and performs the following escapings in string values:
 *
 * `&` -> `\u0026`
 * `<` -> `\u003c`
 * `>` -> `\u003e`
 *
 * Since those characters do not occur in other places of the JSON document, only
 * string values are affected.
 *
 * If the input is invalid JSON, the behaviour is undefined.
 */
function escapeCharacters(input) {
    // When we migrate to target es2021 or above, we can use replaceAll instead of global patterns.
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/replaceAll
    const amp = /&/g;
    const lt = /</g;
    const gt = />/g;
    return input.replace(amp, "\\u0026").replace(lt, "\\u003c").replace(gt, "\\u003e");
}
exports.escapeCharacters = escapeCharacters;
function serializeSignDoc(signDoc) {
    const serialized = escapeCharacters(sortedJsonStringify(signDoc));
    return (0, encoding_1.toUtf8)(serialized);
}
exports.serializeSignDoc = serializeSignDoc;
//# sourceMappingURL=signdoc.js.map

/***/ }),

/***/ 11398:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.makeStdTx = exports.isStdTx = void 0;
function isStdTx(txValue) {
    const { memo, msg, fee, signatures } = txValue;
    return (typeof memo === "string" && Array.isArray(msg) && typeof fee === "object" && Array.isArray(signatures));
}
exports.isStdTx = isStdTx;
function makeStdTx(content, signatures) {
    return {
        msg: content.msgs,
        fee: content.fee,
        memo: content.memo,
        signatures: Array.isArray(signatures) ? signatures : [signatures],
    };
}
exports.makeStdTx = makeStdTx;
//# sourceMappingURL=stdtx.js.map

/***/ }),

/***/ 92505:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.decrypt = exports.encrypt = exports.supportedAlgorithms = exports.executeKdf = exports.cosmjsSalt = void 0;
const crypto_1 = __webpack_require__(45027);
const encoding_1 = __webpack_require__(87061);
/**
 * A fixed salt is chosen to archive a deterministic password to key derivation.
 * This reduces the scope of a potential rainbow attack to all CosmJS users.
 * Must be 16 bytes due to implementation limitations.
 */
exports.cosmjsSalt = (0, encoding_1.toAscii)("The CosmJS salt.");
async function executeKdf(password, configuration) {
    switch (configuration.algorithm) {
        case "argon2id": {
            const options = configuration.params;
            if (!(0, crypto_1.isArgon2idOptions)(options))
                throw new Error("Invalid format of argon2id params");
            return crypto_1.Argon2id.execute(password, exports.cosmjsSalt, options);
        }
        default:
            throw new Error("Unsupported KDF algorithm");
    }
}
exports.executeKdf = executeKdf;
exports.supportedAlgorithms = {
    xchacha20poly1305Ietf: "xchacha20poly1305-ietf",
};
async function encrypt(plaintext, encryptionKey, config) {
    switch (config.algorithm) {
        case exports.supportedAlgorithms.xchacha20poly1305Ietf: {
            const nonce = crypto_1.Random.getBytes(crypto_1.xchacha20NonceLength);
            // Prepend fixed-length nonce to ciphertext as suggested in the example from https://github.com/jedisct1/libsodium.js#api
            return new Uint8Array([
                ...nonce,
                ...(await crypto_1.Xchacha20poly1305Ietf.encrypt(plaintext, encryptionKey, nonce)),
            ]);
        }
        default:
            throw new Error(`Unsupported encryption algorithm: '${config.algorithm}'`);
    }
}
exports.encrypt = encrypt;
async function decrypt(ciphertext, encryptionKey, config) {
    switch (config.algorithm) {
        case exports.supportedAlgorithms.xchacha20poly1305Ietf: {
            const nonce = ciphertext.slice(0, crypto_1.xchacha20NonceLength);
            return crypto_1.Xchacha20poly1305Ietf.decrypt(ciphertext.slice(crypto_1.xchacha20NonceLength), encryptionKey, nonce);
        }
        default:
            throw new Error(`Unsupported encryption algorithm: '${config.algorithm}'`);
    }
}
exports.decrypt = decrypt;
//# sourceMappingURL=wallet.js.map

/***/ }),

/***/ 56165:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CosmWasmClient = void 0;
/* eslint-disable @typescript-eslint/naming-convention */
const encoding_1 = __webpack_require__(87061);
const math_1 = __webpack_require__(66021);
const stargate_1 = __webpack_require__(66422);
const tendermint_rpc_1 = __webpack_require__(52474);
const utils_1 = __webpack_require__(62584);
const abci_1 = __webpack_require__(7088);
const types_1 = __webpack_require__(89675);
const modules_1 = __webpack_require__(60408);
class CosmWasmClient {
    /**
     * Creates an instance by connecting to the given Tendermint RPC endpoint.
     *
     * This uses auto-detection to decide between a Tendermint 0.37 and 0.34 client.
     * To set the Tendermint client explicitly, use `create`.
     */
    static async connect(endpoint) {
        // Tendermint/CometBFT 0.34/0.37 auto-detection. Starting with 0.37 we seem to get reliable versions again 🎉
        // Using 0.34 as the fallback.
        let tmClient;
        const tm37Client = await tendermint_rpc_1.Tendermint37Client.connect(endpoint);
        const version = (await tm37Client.status()).nodeInfo.version;
        if (version.startsWith("0.37.")) {
            tmClient = tm37Client;
        }
        else {
            tm37Client.disconnect();
            tmClient = await tendermint_rpc_1.Tendermint34Client.connect(endpoint);
        }
        return CosmWasmClient.create(tmClient);
    }
    /**
     * Creates an instance from a manually created Tendermint client.
     * Use this to use `Tendermint37Client` instead of `Tendermint34Client`.
     */
    static async create(tmClient) {
        return new CosmWasmClient(tmClient);
    }
    constructor(tmClient) {
        this.codesCache = new Map();
        if (tmClient) {
            this.tmClient = tmClient;
            this.queryClient = stargate_1.QueryClient.withExtensions(tmClient, stargate_1.setupAuthExtension, stargate_1.setupBankExtension, modules_1.setupWasmExtension, stargate_1.setupTxExtension);
        }
    }
    getTmClient() {
        return this.tmClient;
    }
    forceGetTmClient() {
        if (!this.tmClient) {
            throw new Error("Tendermint client not available. You cannot use online functionality in offline mode.");
        }
        return this.tmClient;
    }
    getQueryClient() {
        return this.queryClient;
    }
    forceGetQueryClient() {
        if (!this.queryClient) {
            throw new Error("Query client not available. You cannot use online functionality in offline mode.");
        }
        return this.queryClient;
    }
    async getChainId() {
        if (!this.chainId) {
            const response = await this.forceGetTmClient().status();
            const chainId = response.nodeInfo.network;
            if (!chainId)
                throw new Error("Chain ID must not be empty");
            this.chainId = chainId;
        }
        return this.chainId;
    }
    async getHeight() {
        const status = await this.forceGetTmClient().status();
        return status.syncInfo.latestBlockHeight;
    }
    async getAccount(searchAddress) {
        try {
            const account = await this.forceGetQueryClient().auth.account(searchAddress);
            return account ? (0, stargate_1.accountFromAny)(account) : null;
        }
        catch (error) {
            if (/rpc error: code = NotFound/i.test(error.toString())) {
                return null;
            }
            throw error;
        }
    }
    async getSequence(address) {
        const account = await this.getAccount(address);
        if (!account) {
            throw new Error(`Account '${address}' does not exist on chain. Send some tokens there before trying to query sequence.`);
        }
        return {
            accountNumber: account.accountNumber,
            sequence: account.sequence,
        };
    }
    async getBlock(height) {
        const response = await this.forceGetTmClient().block(height);
        return {
            id: (0, encoding_1.toHex)(response.blockId.hash).toUpperCase(),
            header: {
                version: {
                    block: new math_1.Uint53(response.block.header.version.block).toString(),
                    app: new math_1.Uint53(response.block.header.version.app).toString(),
                },
                height: response.block.header.height,
                chainId: response.block.header.chainId,
                time: (0, tendermint_rpc_1.toRfc3339WithNanoseconds)(response.block.header.time),
            },
            txs: response.block.txs,
        };
    }
    async getBalance(address, searchDenom) {
        return this.forceGetQueryClient().bank.balance(address, searchDenom);
    }
    async getTx(id) {
        const results = await this.txsQuery(`tx.hash='${id}'`);
        return results[0] ?? null;
    }
    async searchTx(query) {
        let rawQuery;
        if (typeof query === "string") {
            rawQuery = query;
        }
        else if (Array.isArray(query)) {
            rawQuery = query.map((t) => `${t.key}='${t.value}'`).join(" AND ");
        }
        else {
            throw new Error("Got unsupported query type. See CosmJS 0.31 CHANGELOG for API breaking changes here.");
        }
        return this.txsQuery(rawQuery);
    }
    disconnect() {
        if (this.tmClient)
            this.tmClient.disconnect();
    }
    /**
     * Broadcasts a signed transaction to the network and monitors its inclusion in a block.
     *
     * If broadcasting is rejected by the node for some reason (e.g. because of a CheckTx failure),
     * an error is thrown.
     *
     * If the transaction is not included in a block before the provided timeout, this errors with a `TimeoutError`.
     *
     * If the transaction is included in a block, a `DeliverTxResponse` is returned. The caller then
     * usually needs to check for execution success or failure.
     */
    // NOTE: This method is tested against slow chains and timeouts in the @cosmjs/stargate package.
    // Make sure it is kept in sync!
    async broadcastTx(tx, timeoutMs = 60000, pollIntervalMs = 3000) {
        let timedOut = false;
        const txPollTimeout = setTimeout(() => {
            timedOut = true;
        }, timeoutMs);
        const pollForTx = async (txId) => {
            if (timedOut) {
                throw new stargate_1.TimeoutError(`Transaction with ID ${txId} was submitted but was not yet found on the chain. You might want to check later. There was a wait of ${timeoutMs / 1000} seconds.`, txId);
            }
            await (0, utils_1.sleep)(pollIntervalMs);
            const result = await this.getTx(txId);
            return result
                ? {
                    code: result.code,
                    height: result.height,
                    txIndex: result.txIndex,
                    rawLog: result.rawLog,
                    transactionHash: txId,
                    events: result.events,
                    msgResponses: result.msgResponses,
                    gasUsed: result.gasUsed,
                    gasWanted: result.gasWanted,
                }
                : pollForTx(txId);
        };
        const transactionId = await this.broadcastTxSync(tx);
        return new Promise((resolve, reject) => pollForTx(transactionId).then((value) => {
            clearTimeout(txPollTimeout);
            resolve(value);
        }, (error) => {
            clearTimeout(txPollTimeout);
            reject(error);
        }));
    }
    /**
     * Broadcasts a signed transaction to the network without monitoring it.
     *
     * If broadcasting is rejected by the node for some reason (e.g. because of a CheckTx failure),
     * an error is thrown.
     *
     * If the transaction is broadcasted, a `string` containing the hash of the transaction is returned. The caller then
     * usually needs to check if the transaction was included in a block and was successful.
     *
     * @returns Returns the hash of the transaction
     */
    async broadcastTxSync(tx) {
        const broadcasted = await this.forceGetTmClient().broadcastTxSync({ tx });
        if (broadcasted.code) {
            return Promise.reject(new stargate_1.BroadcastTxError(broadcasted.code, broadcasted.codespace ?? "", broadcasted.log));
        }
        const transactionId = (0, encoding_1.toHex)(broadcasted.hash).toUpperCase();
        return transactionId;
    }
    /**
     * getCodes() returns all codes and is just looping through all pagination pages.
     *
     * This is potentially inefficient and advanced apps should consider creating
     * their own query client to handle pagination together with the app's screens.
     */
    async getCodes() {
        const allCodes = [];
        let startAtKey = undefined;
        do {
            const { codeInfos, pagination } = await this.forceGetQueryClient().wasm.listCodeInfo(startAtKey);
            const loadedCodes = codeInfos || [];
            allCodes.push(...loadedCodes);
            startAtKey = pagination?.nextKey;
        } while (startAtKey?.length !== 0);
        return allCodes.map((entry) => {
            (0, utils_1.assert)(entry.creator && entry.codeId && entry.dataHash, "entry incomplete");
            return {
                id: entry.codeId.toNumber(),
                creator: entry.creator,
                checksum: (0, encoding_1.toHex)(entry.dataHash),
            };
        });
    }
    async getCodeDetails(codeId) {
        const cached = this.codesCache.get(codeId);
        if (cached)
            return cached;
        const { codeInfo, data } = await this.forceGetQueryClient().wasm.getCode(codeId);
        (0, utils_1.assert)(codeInfo && codeInfo.codeId && codeInfo.creator && codeInfo.dataHash && data, "codeInfo missing or incomplete");
        const codeDetails = {
            id: codeInfo.codeId.toNumber(),
            creator: codeInfo.creator,
            checksum: (0, encoding_1.toHex)(codeInfo.dataHash),
            data: data,
        };
        this.codesCache.set(codeId, codeDetails);
        return codeDetails;
    }
    /**
     * getContracts() returns all contract instances for one code and is just looping through all pagination pages.
     *
     * This is potentially inefficient and advanced apps should consider creating
     * their own query client to handle pagination together with the app's screens.
     */
    async getContracts(codeId) {
        const allContracts = [];
        let startAtKey = undefined;
        do {
            const { contracts, pagination } = await this.forceGetQueryClient().wasm.listContractsByCodeId(codeId, startAtKey);
            allContracts.push(...contracts);
            startAtKey = pagination?.nextKey;
        } while (startAtKey?.length !== 0 && startAtKey !== undefined);
        return allContracts;
    }
    /**
     * Returns a list of contract addresses created by the given creator.
     * This just loops through all pagination pages.
     */
    async getContractsByCreator(creator) {
        const allContracts = [];
        let startAtKey = undefined;
        do {
            const { contractAddresses, pagination } = await this.forceGetQueryClient().wasm.listContractsByCreator(creator, startAtKey);
            allContracts.push(...contractAddresses);
            startAtKey = pagination?.nextKey;
        } while (startAtKey?.length !== 0 && startAtKey !== undefined);
        return allContracts;
    }
    /**
     * Throws an error if no contract was found at the address
     */
    async getContract(address) {
        const { address: retrievedAddress, contractInfo } = await this.forceGetQueryClient().wasm.getContractInfo(address);
        if (!contractInfo)
            throw new Error(`No contract found at address "${address}"`);
        (0, utils_1.assert)(retrievedAddress, "address missing");
        (0, utils_1.assert)(contractInfo.codeId && contractInfo.creator && contractInfo.label, "contractInfo incomplete");
        return {
            address: retrievedAddress,
            codeId: contractInfo.codeId.toNumber(),
            creator: contractInfo.creator,
            admin: contractInfo.admin || undefined,
            label: contractInfo.label,
            ibcPortId: contractInfo.ibcPortId || undefined,
        };
    }
    /**
     * Throws an error if no contract was found at the address
     */
    async getContractCodeHistory(address) {
        const result = await this.forceGetQueryClient().wasm.getContractCodeHistory(address);
        if (!result)
            throw new Error(`No contract history found for address "${address}"`);
        const operations = {
            [types_1.ContractCodeHistoryOperationType.CONTRACT_CODE_HISTORY_OPERATION_TYPE_INIT]: "Init",
            [types_1.ContractCodeHistoryOperationType.CONTRACT_CODE_HISTORY_OPERATION_TYPE_GENESIS]: "Genesis",
            [types_1.ContractCodeHistoryOperationType.CONTRACT_CODE_HISTORY_OPERATION_TYPE_MIGRATE]: "Migrate",
        };
        return (result.entries || []).map((entry) => {
            (0, utils_1.assert)(entry.operation && entry.codeId && entry.msg);
            return {
                operation: operations[entry.operation],
                codeId: entry.codeId.toNumber(),
                msg: JSON.parse((0, encoding_1.fromUtf8)(entry.msg)),
            };
        });
    }
    /**
     * Returns the data at the key if present (raw contract dependent storage data)
     * or null if no data at this key.
     *
     * Promise is rejected when contract does not exist.
     */
    async queryContractRaw(address, key) {
        // just test contract existence
        await this.getContract(address);
        const { data } = await this.forceGetQueryClient().wasm.queryContractRaw(address, key);
        return data ?? null;
    }
    /**
     * Makes a smart query on the contract, returns the parsed JSON document.
     *
     * Promise is rejected when contract does not exist.
     * Promise is rejected for invalid query format.
     * Promise is rejected for invalid response format.
     */
    async queryContractSmart(address, queryMsg) {
        try {
            return await this.forceGetQueryClient().wasm.queryContractSmart(address, queryMsg);
        }
        catch (error) {
            if (error instanceof Error) {
                if (error.message.startsWith("not found: contract")) {
                    throw new Error(`No contract found at address "${address}"`);
                }
                else {
                    throw error;
                }
            }
            else {
                throw error;
            }
        }
    }
    async txsQuery(query) {
        const results = await this.forceGetTmClient().txSearchAll({ query: query });
        return results.txs.map((tx) => {
            const txMsgData = abci_1.TxMsgData.decode(tx.result.data ?? new Uint8Array());
            return {
                height: tx.height,
                txIndex: tx.index,
                hash: (0, encoding_1.toHex)(tx.hash).toUpperCase(),
                code: tx.result.code,
                events: tx.result.events.map(stargate_1.fromTendermintEvent),
                rawLog: tx.result.log || "",
                tx: tx.tx,
                msgResponses: txMsgData.msgResponses,
                gasUsed: tx.result.gasUsed,
                gasWanted: tx.result.gasWanted,
            };
        });
    }
}
exports.CosmWasmClient = CosmWasmClient;
//# sourceMappingURL=cosmwasmclient.js.map

/***/ }),

/***/ 16389:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.fromBinary = exports.toBinary = void 0;
const encoding_1 = __webpack_require__(87061);
/**
 * Takes a value, serializes it to JSON and encodes it as base64.
 *
 * This can be used for creating values of fields that have the CosmWasm Binary type.
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function toBinary(obj) {
    return (0, encoding_1.toBase64)((0, encoding_1.toUtf8)(JSON.stringify(obj)));
}
exports.toBinary = toBinary;
/**
 * Takes a base64 string, decodes it and parses the content from JSON to an object.
 *
 * This can be used for parsing the values of a CosmWasm Binary field.
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function fromBinary(base64) {
    return JSON.parse((0, encoding_1.fromUtf8)((0, encoding_1.fromBase64)(base64)));
}
exports.fromBinary = fromBinary;
//# sourceMappingURL=encoding.js.map

/***/ }),

/***/ 40702:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
__webpack_unused_export__ = __webpack_unused_export__ = exports.iy = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = void 0;
var cosmwasmclient_1 = __webpack_require__(56165);
__webpack_unused_export__ = ({ enumerable: true, get: function () { return cosmwasmclient_1.CosmWasmClient; } });
var encoding_1 = __webpack_require__(16389);
__webpack_unused_export__ = ({ enumerable: true, get: function () { return encoding_1.fromBinary; } });
__webpack_unused_export__ = ({ enumerable: true, get: function () { return encoding_1.toBinary; } });
var instantiate2_1 = __webpack_require__(21763);
__webpack_unused_export__ = ({ enumerable: true, get: function () { return instantiate2_1._instantiate2AddressIntermediate; } });
__webpack_unused_export__ = ({ enumerable: true, get: function () { return instantiate2_1.instantiate2Address; } });
var modules_1 = __webpack_require__(60408);
__webpack_unused_export__ = ({ enumerable: true, get: function () { return modules_1.createWasmAminoConverters; } });
__webpack_unused_export__ = ({ enumerable: true, get: function () { return modules_1.isMsgClearAdminEncodeObject; } });
__webpack_unused_export__ = ({ enumerable: true, get: function () { return modules_1.isMsgExecuteEncodeObject; } });
__webpack_unused_export__ = ({ enumerable: true, get: function () { return modules_1.isMsgInstantiateContract2EncodeObject; } });
__webpack_unused_export__ = ({ enumerable: true, get: function () { return modules_1.isMsgInstantiateContractEncodeObject; } });
__webpack_unused_export__ = ({ enumerable: true, get: function () { return modules_1.isMsgMigrateEncodeObject; } });
__webpack_unused_export__ = ({ enumerable: true, get: function () { return modules_1.isMsgStoreCodeEncodeObject; } });
__webpack_unused_export__ = ({ enumerable: true, get: function () { return modules_1.isMsgUpdateAdminEncodeObject; } });
Object.defineProperty(exports, "iy", ({ enumerable: true, get: function () { return modules_1.setupWasmExtension; } }));
__webpack_unused_export__ = ({ enumerable: true, get: function () { return modules_1.wasmTypes; } });
var signingcosmwasmclient_1 = __webpack_require__(93603);
__webpack_unused_export__ = ({ enumerable: true, get: function () { return signingcosmwasmclient_1.SigningCosmWasmClient; } });
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 21763:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.instantiate2Address = exports._instantiate2AddressIntermediate = void 0;
const crypto_1 = __webpack_require__(45027);
const encoding_1 = __webpack_require__(87061);
const math_1 = __webpack_require__(66021);
const utils_1 = __webpack_require__(62584);
/**
 * The "Basic Address" Hash from
 * https://github.com/cosmos/cosmos-sdk/blob/v0.45.8/docs/architecture/adr-028-public-key-addresses.md
 */
function hash(type, key) {
    return new crypto_1.Sha256((0, crypto_1.sha256)((0, encoding_1.toAscii)(type))).update(key).digest();
}
/**
 * Takes an integer [0, 2**64-1] and returns a one-byte encoding of it.
 */
function toUint64(int) {
    return math_1.Uint64.fromNumber(int).toBytesBigEndian();
}
/**
 * Private function to export test vector data for https://github.com/cosmos/cosmjs/pull/1253.
 * Do not use in production code.
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
function _instantiate2AddressIntermediate(checksum, creator, salt, msg, prefix) {
    (0, utils_1.assert)(checksum.length === 32);
    const creatorData = (0, encoding_1.fromBech32)(creator).data;
    const msgData = typeof msg === "string" ? (0, encoding_1.toUtf8)(msg) : new Uint8Array();
    // Validate inputs
    if (salt.length < 1 || salt.length > 64)
        throw new Error("Salt must be between 1 and 64 bytes");
    const key = new Uint8Array([
        ...(0, encoding_1.toAscii)("wasm"),
        0x00,
        ...toUint64(checksum.length),
        ...checksum,
        ...toUint64(creatorData.length),
        ...creatorData,
        ...toUint64(salt.length),
        ...salt,
        ...toUint64(msgData.length),
        ...msgData,
    ]);
    const addressData = hash("module", key);
    const address = (0, encoding_1.toBech32)(prefix, addressData);
    return { key, addressData, address };
}
exports._instantiate2AddressIntermediate = _instantiate2AddressIntermediate;
/**
 * Predictable address generation for the MsgInstantiateContract2
 * introduced with wasmd 0.29.
 */
function instantiate2Address(checksum, creator, salt, prefix) {
    // Non-empty msg values are discouraged.
    // See https://medium.com/cosmwasm/dev-note-3-limitations-of-instantiate2-and-how-to-deal-with-them-a3f946874230.
    const msg = null;
    return _instantiate2AddressIntermediate(checksum, creator, salt, msg, prefix).address;
}
exports.instantiate2Address = instantiate2Address;
//# sourceMappingURL=instantiate2.js.map

/***/ }),

/***/ 60408:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.setupWasmExtension = exports.wasmTypes = exports.isMsgUpdateAdminEncodeObject = exports.isMsgStoreCodeEncodeObject = exports.isMsgMigrateEncodeObject = exports.isMsgInstantiateContractEncodeObject = exports.isMsgInstantiateContract2EncodeObject = exports.isMsgExecuteEncodeObject = exports.isMsgClearAdminEncodeObject = exports.createWasmAminoConverters = void 0;
var aminomessages_1 = __webpack_require__(7142);
Object.defineProperty(exports, "createWasmAminoConverters", ({ enumerable: true, get: function () { return aminomessages_1.createWasmAminoConverters; } }));
var messages_1 = __webpack_require__(26154);
Object.defineProperty(exports, "isMsgClearAdminEncodeObject", ({ enumerable: true, get: function () { return messages_1.isMsgClearAdminEncodeObject; } }));
Object.defineProperty(exports, "isMsgExecuteEncodeObject", ({ enumerable: true, get: function () { return messages_1.isMsgExecuteEncodeObject; } }));
Object.defineProperty(exports, "isMsgInstantiateContract2EncodeObject", ({ enumerable: true, get: function () { return messages_1.isMsgInstantiateContract2EncodeObject; } }));
Object.defineProperty(exports, "isMsgInstantiateContractEncodeObject", ({ enumerable: true, get: function () { return messages_1.isMsgInstantiateContractEncodeObject; } }));
Object.defineProperty(exports, "isMsgMigrateEncodeObject", ({ enumerable: true, get: function () { return messages_1.isMsgMigrateEncodeObject; } }));
Object.defineProperty(exports, "isMsgStoreCodeEncodeObject", ({ enumerable: true, get: function () { return messages_1.isMsgStoreCodeEncodeObject; } }));
Object.defineProperty(exports, "isMsgUpdateAdminEncodeObject", ({ enumerable: true, get: function () { return messages_1.isMsgUpdateAdminEncodeObject; } }));
Object.defineProperty(exports, "wasmTypes", ({ enumerable: true, get: function () { return messages_1.wasmTypes; } }));
var queries_1 = __webpack_require__(31410);
Object.defineProperty(exports, "setupWasmExtension", ({ enumerable: true, get: function () { return queries_1.setupWasmExtension; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 7142:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.createWasmAminoConverters = exports.accessTypeToString = exports.accessTypeFromString = void 0;
/* eslint-disable @typescript-eslint/naming-convention */
const encoding_1 = __webpack_require__(87061);
const types_1 = __webpack_require__(89675);
const long_1 = __importDefault(__webpack_require__(10648));
function accessTypeFromString(str) {
    switch (str) {
        case "Unspecified":
            return types_1.AccessType.ACCESS_TYPE_UNSPECIFIED;
        case "Nobody":
            return types_1.AccessType.ACCESS_TYPE_NOBODY;
        case "OnlyAddress":
            return types_1.AccessType.ACCESS_TYPE_ONLY_ADDRESS;
        case "Everybody":
            return types_1.AccessType.ACCESS_TYPE_EVERYBODY;
        case "AnyOfAddresses":
            return types_1.AccessType.ACCESS_TYPE_ANY_OF_ADDRESSES;
        default:
            return types_1.AccessType.UNRECOGNIZED;
    }
}
exports.accessTypeFromString = accessTypeFromString;
function accessTypeToString(object) {
    switch (object) {
        case types_1.AccessType.ACCESS_TYPE_UNSPECIFIED:
            return "Unspecified";
        case types_1.AccessType.ACCESS_TYPE_NOBODY:
            return "Nobody";
        case types_1.AccessType.ACCESS_TYPE_ONLY_ADDRESS:
            return "OnlyAddress";
        case types_1.AccessType.ACCESS_TYPE_EVERYBODY:
            return "Everybody";
        case types_1.AccessType.ACCESS_TYPE_ANY_OF_ADDRESSES:
            return "AnyOfAddresses";
        case types_1.AccessType.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.accessTypeToString = accessTypeToString;
function createWasmAminoConverters() {
    return {
        "/cosmwasm.wasm.v1.MsgStoreCode": {
            aminoType: "wasm/MsgStoreCode",
            toAmino: ({ sender, wasmByteCode, instantiatePermission, }) => ({
                sender: sender,
                wasm_byte_code: (0, encoding_1.toBase64)(wasmByteCode),
                instantiate_permission: instantiatePermission
                    ? {
                        permission: accessTypeToString(instantiatePermission.permission),
                        address: instantiatePermission.address || undefined,
                        addresses: instantiatePermission.addresses.length !== 0 ? instantiatePermission.addresses : undefined,
                    }
                    : undefined,
            }),
            fromAmino: ({ sender, wasm_byte_code, instantiate_permission, }) => ({
                sender: sender,
                wasmByteCode: (0, encoding_1.fromBase64)(wasm_byte_code),
                instantiatePermission: instantiate_permission
                    ? {
                        permission: accessTypeFromString(instantiate_permission.permission),
                        address: instantiate_permission.address ?? "",
                        addresses: instantiate_permission.addresses ?? [],
                    }
                    : undefined,
            }),
        },
        "/cosmwasm.wasm.v1.MsgInstantiateContract": {
            aminoType: "wasm/MsgInstantiateContract",
            toAmino: ({ sender, codeId, label, msg, funds, admin, }) => ({
                sender: sender,
                code_id: codeId.toString(),
                label: label,
                msg: JSON.parse((0, encoding_1.fromUtf8)(msg)),
                funds: funds,
                admin: admin || undefined,
            }),
            fromAmino: ({ sender, code_id, label, msg, funds, admin, }) => ({
                sender: sender,
                codeId: long_1.default.fromString(code_id),
                label: label,
                msg: (0, encoding_1.toUtf8)(JSON.stringify(msg)),
                funds: [...funds],
                admin: admin ?? "",
            }),
        },
        "/cosmwasm.wasm.v1.MsgInstantiateContract2": {
            aminoType: "wasm/MsgInstantiateContract2",
            toAmino: ({ sender, codeId, label, msg, funds, admin, salt, fixMsg, }) => ({
                sender: sender,
                code_id: codeId.toString(),
                label: label,
                msg: JSON.parse((0, encoding_1.fromUtf8)(msg)),
                funds: funds,
                admin: admin || undefined,
                salt: (0, encoding_1.toBase64)(salt),
                fix_msg: fixMsg,
            }),
            fromAmino: ({ sender, code_id, label, msg, funds, admin, salt, fix_msg, }) => ({
                sender: sender,
                codeId: long_1.default.fromString(code_id),
                label: label,
                msg: (0, encoding_1.toUtf8)(JSON.stringify(msg)),
                funds: [...funds],
                admin: admin ?? "",
                salt: (0, encoding_1.fromBase64)(salt),
                fixMsg: fix_msg,
            }),
        },
        "/cosmwasm.wasm.v1.MsgUpdateAdmin": {
            aminoType: "wasm/MsgUpdateAdmin",
            toAmino: ({ sender, newAdmin, contract }) => ({
                sender: sender,
                new_admin: newAdmin,
                contract: contract,
            }),
            fromAmino: ({ sender, new_admin, contract }) => ({
                sender: sender,
                newAdmin: new_admin,
                contract: contract,
            }),
        },
        "/cosmwasm.wasm.v1.MsgClearAdmin": {
            aminoType: "wasm/MsgClearAdmin",
            toAmino: ({ sender, contract }) => ({
                sender: sender,
                contract: contract,
            }),
            fromAmino: ({ sender, contract }) => ({
                sender: sender,
                contract: contract,
            }),
        },
        "/cosmwasm.wasm.v1.MsgExecuteContract": {
            aminoType: "wasm/MsgExecuteContract",
            toAmino: ({ sender, contract, msg, funds }) => ({
                sender: sender,
                contract: contract,
                msg: JSON.parse((0, encoding_1.fromUtf8)(msg)),
                funds: funds,
            }),
            fromAmino: ({ sender, contract, msg, funds, }) => ({
                sender: sender,
                contract: contract,
                msg: (0, encoding_1.toUtf8)(JSON.stringify(msg)),
                funds: [...funds],
            }),
        },
        "/cosmwasm.wasm.v1.MsgMigrateContract": {
            aminoType: "wasm/MsgMigrateContract",
            toAmino: ({ sender, contract, codeId, msg }) => ({
                sender: sender,
                contract: contract,
                code_id: codeId.toString(),
                msg: JSON.parse((0, encoding_1.fromUtf8)(msg)),
            }),
            fromAmino: ({ sender, contract, code_id, msg, }) => ({
                sender: sender,
                contract: contract,
                codeId: long_1.default.fromString(code_id),
                msg: (0, encoding_1.toUtf8)(JSON.stringify(msg)),
            }),
        },
    };
}
exports.createWasmAminoConverters = createWasmAminoConverters;
//# sourceMappingURL=aminomessages.js.map

/***/ }),

/***/ 26154:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.isMsgExecuteEncodeObject = exports.isMsgMigrateEncodeObject = exports.isMsgClearAdminEncodeObject = exports.isMsgUpdateAdminEncodeObject = exports.isMsgInstantiateContract2EncodeObject = exports.isMsgInstantiateContractEncodeObject = exports.isMsgStoreCodeEncodeObject = exports.wasmTypes = void 0;
const tx_1 = __webpack_require__(63949);
exports.wasmTypes = [
    ["/cosmwasm.wasm.v1.MsgClearAdmin", tx_1.MsgClearAdmin],
    ["/cosmwasm.wasm.v1.MsgExecuteContract", tx_1.MsgExecuteContract],
    ["/cosmwasm.wasm.v1.MsgMigrateContract", tx_1.MsgMigrateContract],
    ["/cosmwasm.wasm.v1.MsgStoreCode", tx_1.MsgStoreCode],
    ["/cosmwasm.wasm.v1.MsgInstantiateContract", tx_1.MsgInstantiateContract],
    ["/cosmwasm.wasm.v1.MsgInstantiateContract2", tx_1.MsgInstantiateContract2],
    ["/cosmwasm.wasm.v1.MsgUpdateAdmin", tx_1.MsgUpdateAdmin],
];
function isMsgStoreCodeEncodeObject(object) {
    return object.typeUrl === "/cosmwasm.wasm.v1.MsgStoreCode";
}
exports.isMsgStoreCodeEncodeObject = isMsgStoreCodeEncodeObject;
function isMsgInstantiateContractEncodeObject(object) {
    return (object.typeUrl === "/cosmwasm.wasm.v1.MsgInstantiateContract");
}
exports.isMsgInstantiateContractEncodeObject = isMsgInstantiateContractEncodeObject;
function isMsgInstantiateContract2EncodeObject(object) {
    return (object.typeUrl === "/cosmwasm.wasm.v1.MsgInstantiateContract2");
}
exports.isMsgInstantiateContract2EncodeObject = isMsgInstantiateContract2EncodeObject;
function isMsgUpdateAdminEncodeObject(object) {
    return object.typeUrl === "/cosmwasm.wasm.v1.MsgUpdateAdmin";
}
exports.isMsgUpdateAdminEncodeObject = isMsgUpdateAdminEncodeObject;
function isMsgClearAdminEncodeObject(object) {
    return object.typeUrl === "/cosmwasm.wasm.v1.MsgClearAdmin";
}
exports.isMsgClearAdminEncodeObject = isMsgClearAdminEncodeObject;
function isMsgMigrateEncodeObject(object) {
    return object.typeUrl === "/cosmwasm.wasm.v1.MsgMigrateContract";
}
exports.isMsgMigrateEncodeObject = isMsgMigrateEncodeObject;
function isMsgExecuteEncodeObject(object) {
    return object.typeUrl === "/cosmwasm.wasm.v1.MsgExecuteContract";
}
exports.isMsgExecuteEncodeObject = isMsgExecuteEncodeObject;
//# sourceMappingURL=messages.js.map

/***/ }),

/***/ 31410:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.setupWasmExtension = void 0;
const encoding_1 = __webpack_require__(87061);
const stargate_1 = __webpack_require__(66422);
const query_1 = __webpack_require__(14806);
const long_1 = __importDefault(__webpack_require__(10648));
function setupWasmExtension(base) {
    const rpc = (0, stargate_1.createProtobufRpcClient)(base);
    // Use this service to get easy typed access to query methods
    // This cannot be used for proof verification
    const queryService = new query_1.QueryClientImpl(rpc);
    return {
        wasm: {
            listCodeInfo: async (paginationKey) => {
                const request = {
                    pagination: (0, stargate_1.createPagination)(paginationKey),
                };
                return queryService.Codes(request);
            },
            getCode: async (id) => {
                const request = { codeId: long_1.default.fromNumber(id) };
                return queryService.Code(request);
            },
            listContractsByCodeId: async (id, paginationKey) => {
                const request = {
                    codeId: long_1.default.fromNumber(id),
                    pagination: (0, stargate_1.createPagination)(paginationKey),
                };
                return queryService.ContractsByCode(request);
            },
            listContractsByCreator: async (creator, paginationKey) => {
                const request = {
                    creatorAddress: creator,
                    pagination: (0, stargate_1.createPagination)(paginationKey),
                };
                return queryService.ContractsByCreator(request);
            },
            getContractInfo: async (address) => {
                const request = { address: address };
                return queryService.ContractInfo(request);
            },
            getContractCodeHistory: async (address, paginationKey) => {
                const request = {
                    address: address,
                    pagination: (0, stargate_1.createPagination)(paginationKey),
                };
                return queryService.ContractHistory(request);
            },
            getAllContractState: async (address, paginationKey) => {
                const request = {
                    address: address,
                    pagination: (0, stargate_1.createPagination)(paginationKey),
                };
                return queryService.AllContractState(request);
            },
            queryContractRaw: async (address, key) => {
                const request = { address: address, queryData: key };
                return queryService.RawContractState(request);
            },
            queryContractSmart: async (address, query) => {
                const request = { address: address, queryData: (0, encoding_1.toUtf8)(JSON.stringify(query)) };
                const { data } = await queryService.SmartContractState(request);
                // By convention, smart queries must return a valid JSON document (see https://github.com/CosmWasm/cosmwasm/issues/144)
                let responseText;
                try {
                    responseText = (0, encoding_1.fromUtf8)(data);
                }
                catch (error) {
                    throw new Error(`Could not UTF-8 decode smart query response from contract: ${error}`);
                }
                try {
                    return JSON.parse(responseText);
                }
                catch (error) {
                    throw new Error(`Could not JSON parse smart query response from contract: ${error}`);
                }
            },
        },
    };
}
exports.setupWasmExtension = setupWasmExtension;
//# sourceMappingURL=queries.js.map

/***/ }),

/***/ 93603:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.SigningCosmWasmClient = void 0;
/* eslint-disable @typescript-eslint/naming-convention */
const amino_1 = __webpack_require__(98802);
const crypto_1 = __webpack_require__(45027);
const encoding_1 = __webpack_require__(87061);
const math_1 = __webpack_require__(66021);
const proto_signing_1 = __webpack_require__(75216);
const stargate_1 = __webpack_require__(66422);
const tendermint_rpc_1 = __webpack_require__(52474);
const utils_1 = __webpack_require__(62584);
const tx_1 = __webpack_require__(80798);
const tx_2 = __webpack_require__(70381);
const signing_1 = __webpack_require__(83397);
const tx_3 = __webpack_require__(17921);
const tx_4 = __webpack_require__(63949);
const long_1 = __importDefault(__webpack_require__(10648));
const pako_1 = __importDefault(__webpack_require__(99591));
const cosmwasmclient_1 = __webpack_require__(56165);
const modules_1 = __webpack_require__(60408);
function createDeliverTxResponseErrorMessage(result) {
    return `Error when broadcasting tx ${result.transactionHash} at height ${result.height}. Code: ${result.code}; Raw log: ${result.rawLog}`;
}
class SigningCosmWasmClient extends cosmwasmclient_1.CosmWasmClient {
    /**
     * Creates an instance by connecting to the given Tendermint RPC endpoint.
     *
     * This uses auto-detection to decide between a Tendermint 0.37 and 0.34 client.
     * To set the Tendermint client explicitly, use `createWithSigner`.
     */
    static async connectWithSigner(endpoint, signer, options = {}) {
        // Tendermint/CometBFT 0.34/0.37 auto-detection. Starting with 0.37 we seem to get reliable versions again 🎉
        // Using 0.34 as the fallback.
        let tmClient;
        const tm37Client = await tendermint_rpc_1.Tendermint37Client.connect(endpoint);
        const version = (await tm37Client.status()).nodeInfo.version;
        if (version.startsWith("0.37.")) {
            tmClient = tm37Client;
        }
        else {
            tm37Client.disconnect();
            tmClient = await tendermint_rpc_1.Tendermint34Client.connect(endpoint);
        }
        return SigningCosmWasmClient.createWithSigner(tmClient, signer, options);
    }
    /**
     * Creates an instance from a manually created Tendermint client.
     * Use this to use `Tendermint37Client` instead of `Tendermint34Client`.
     */
    static async createWithSigner(tmClient, signer, options = {}) {
        return new SigningCosmWasmClient(tmClient, signer, options);
    }
    /**
     * Creates a client in offline mode.
     *
     * This should only be used in niche cases where you know exactly what you're doing,
     * e.g. when building an offline signing application.
     *
     * When you try to use online functionality with such a signer, an
     * exception will be raised.
     */
    static async offline(signer, options = {}) {
        return new SigningCosmWasmClient(undefined, signer, options);
    }
    constructor(tmClient, signer, options) {
        super(tmClient);
        const { registry = new proto_signing_1.Registry([...stargate_1.defaultRegistryTypes, ...modules_1.wasmTypes]), aminoTypes = new stargate_1.AminoTypes({
            ...(0, stargate_1.createDefaultAminoConverters)(),
            ...(0, modules_1.createWasmAminoConverters)(),
        }), } = options;
        this.registry = registry;
        this.aminoTypes = aminoTypes;
        this.signer = signer;
        this.broadcastTimeoutMs = options.broadcastTimeoutMs;
        this.broadcastPollIntervalMs = options.broadcastPollIntervalMs;
        this.gasPrice = options.gasPrice;
    }
    async simulate(signerAddress, messages, memo) {
        const anyMsgs = messages.map((m) => this.registry.encodeAsAny(m));
        const accountFromSigner = (await this.signer.getAccounts()).find((account) => account.address === signerAddress);
        if (!accountFromSigner) {
            throw new Error("Failed to retrieve account from signer");
        }
        const pubkey = (0, amino_1.encodeSecp256k1Pubkey)(accountFromSigner.pubkey);
        const { sequence } = await this.getSequence(signerAddress);
        const { gasInfo } = await this.forceGetQueryClient().tx.simulate(anyMsgs, memo, pubkey, sequence);
        (0, utils_1.assertDefined)(gasInfo);
        return math_1.Uint53.fromString(gasInfo.gasUsed.toString()).toNumber();
    }
    /** Uploads code and returns a receipt, including the code ID */
    async upload(senderAddress, wasmCode, fee, memo = "", instantiatePermission) {
        const compressed = pako_1.default.gzip(wasmCode, { level: 9 });
        const storeCodeMsg = {
            typeUrl: "/cosmwasm.wasm.v1.MsgStoreCode",
            value: tx_4.MsgStoreCode.fromPartial({
                sender: senderAddress,
                wasmByteCode: compressed,
                instantiatePermission,
            }),
        };
        // When uploading a contract, the simulation is only 1-2% away from the actual gas usage.
        // So we have a smaller default gas multiplier than signAndBroadcast.
        const usedFee = fee == "auto" ? 1.1 : fee;
        const result = await this.signAndBroadcast(senderAddress, [storeCodeMsg], usedFee, memo);
        if ((0, stargate_1.isDeliverTxFailure)(result)) {
            throw new Error(createDeliverTxResponseErrorMessage(result));
        }
        const parsedLogs = stargate_1.logs.parseRawLog(result.rawLog);
        const codeIdAttr = stargate_1.logs.findAttribute(parsedLogs, "store_code", "code_id");
        return {
            checksum: (0, encoding_1.toHex)((0, crypto_1.sha256)(wasmCode)),
            originalSize: wasmCode.length,
            compressedSize: compressed.length,
            codeId: Number.parseInt(codeIdAttr.value, 10),
            logs: parsedLogs,
            height: result.height,
            transactionHash: result.transactionHash,
            events: result.events,
            gasWanted: result.gasWanted,
            gasUsed: result.gasUsed,
        };
    }
    async instantiate(senderAddress, codeId, msg, label, fee, options = {}) {
        const instantiateContractMsg = {
            typeUrl: "/cosmwasm.wasm.v1.MsgInstantiateContract",
            value: tx_4.MsgInstantiateContract.fromPartial({
                sender: senderAddress,
                codeId: long_1.default.fromString(new math_1.Uint53(codeId).toString()),
                label: label,
                msg: (0, encoding_1.toUtf8)(JSON.stringify(msg)),
                funds: [...(options.funds || [])],
                admin: options.admin,
            }),
        };
        const result = await this.signAndBroadcast(senderAddress, [instantiateContractMsg], fee, options.memo);
        if ((0, stargate_1.isDeliverTxFailure)(result)) {
            throw new Error(createDeliverTxResponseErrorMessage(result));
        }
        const parsedLogs = stargate_1.logs.parseRawLog(result.rawLog);
        const contractAddressAttr = stargate_1.logs.findAttribute(parsedLogs, "instantiate", "_contract_address");
        return {
            contractAddress: contractAddressAttr.value,
            logs: parsedLogs,
            height: result.height,
            transactionHash: result.transactionHash,
            events: result.events,
            gasWanted: result.gasWanted,
            gasUsed: result.gasUsed,
        };
    }
    async instantiate2(senderAddress, codeId, salt, msg, label, fee, options = {}) {
        const instantiateContract2Msg = {
            typeUrl: "/cosmwasm.wasm.v1.MsgInstantiateContract2",
            value: tx_4.MsgInstantiateContract2.fromPartial({
                sender: senderAddress,
                codeId: long_1.default.fromString(new math_1.Uint53(codeId).toString()),
                label: label,
                msg: (0, encoding_1.toUtf8)(JSON.stringify(msg)),
                funds: [...(options.funds || [])],
                admin: options.admin,
                salt: salt,
                fixMsg: false,
            }),
        };
        const result = await this.signAndBroadcast(senderAddress, [instantiateContract2Msg], fee, options.memo);
        if ((0, stargate_1.isDeliverTxFailure)(result)) {
            throw new Error(createDeliverTxResponseErrorMessage(result));
        }
        const parsedLogs = stargate_1.logs.parseRawLog(result.rawLog);
        const contractAddressAttr = stargate_1.logs.findAttribute(parsedLogs, "instantiate", "_contract_address");
        return {
            contractAddress: contractAddressAttr.value,
            logs: parsedLogs,
            height: result.height,
            transactionHash: result.transactionHash,
            events: result.events,
            gasWanted: result.gasWanted,
            gasUsed: result.gasUsed,
        };
    }
    async updateAdmin(senderAddress, contractAddress, newAdmin, fee, memo = "") {
        const updateAdminMsg = {
            typeUrl: "/cosmwasm.wasm.v1.MsgUpdateAdmin",
            value: tx_4.MsgUpdateAdmin.fromPartial({
                sender: senderAddress,
                contract: contractAddress,
                newAdmin: newAdmin,
            }),
        };
        const result = await this.signAndBroadcast(senderAddress, [updateAdminMsg], fee, memo);
        if ((0, stargate_1.isDeliverTxFailure)(result)) {
            throw new Error(createDeliverTxResponseErrorMessage(result));
        }
        return {
            logs: stargate_1.logs.parseRawLog(result.rawLog),
            height: result.height,
            transactionHash: result.transactionHash,
            events: result.events,
            gasWanted: result.gasWanted,
            gasUsed: result.gasUsed,
        };
    }
    async clearAdmin(senderAddress, contractAddress, fee, memo = "") {
        const clearAdminMsg = {
            typeUrl: "/cosmwasm.wasm.v1.MsgClearAdmin",
            value: tx_4.MsgClearAdmin.fromPartial({
                sender: senderAddress,
                contract: contractAddress,
            }),
        };
        const result = await this.signAndBroadcast(senderAddress, [clearAdminMsg], fee, memo);
        if ((0, stargate_1.isDeliverTxFailure)(result)) {
            throw new Error(createDeliverTxResponseErrorMessage(result));
        }
        return {
            logs: stargate_1.logs.parseRawLog(result.rawLog),
            height: result.height,
            transactionHash: result.transactionHash,
            events: result.events,
            gasWanted: result.gasWanted,
            gasUsed: result.gasUsed,
        };
    }
    async migrate(senderAddress, contractAddress, codeId, migrateMsg, fee, memo = "") {
        const migrateContractMsg = {
            typeUrl: "/cosmwasm.wasm.v1.MsgMigrateContract",
            value: tx_4.MsgMigrateContract.fromPartial({
                sender: senderAddress,
                contract: contractAddress,
                codeId: long_1.default.fromString(new math_1.Uint53(codeId).toString()),
                msg: (0, encoding_1.toUtf8)(JSON.stringify(migrateMsg)),
            }),
        };
        const result = await this.signAndBroadcast(senderAddress, [migrateContractMsg], fee, memo);
        if ((0, stargate_1.isDeliverTxFailure)(result)) {
            throw new Error(createDeliverTxResponseErrorMessage(result));
        }
        return {
            logs: stargate_1.logs.parseRawLog(result.rawLog),
            height: result.height,
            transactionHash: result.transactionHash,
            events: result.events,
            gasWanted: result.gasWanted,
            gasUsed: result.gasUsed,
        };
    }
    async execute(senderAddress, contractAddress, msg, fee, memo = "", funds) {
        const instruction = {
            contractAddress: contractAddress,
            msg: msg,
            funds: funds,
        };
        return this.executeMultiple(senderAddress, [instruction], fee, memo);
    }
    /**
     * Like `execute` but allows executing multiple messages in one transaction.
     */
    async executeMultiple(senderAddress, instructions, fee, memo = "") {
        const msgs = instructions.map((i) => ({
            typeUrl: "/cosmwasm.wasm.v1.MsgExecuteContract",
            value: tx_4.MsgExecuteContract.fromPartial({
                sender: senderAddress,
                contract: i.contractAddress,
                msg: (0, encoding_1.toUtf8)(JSON.stringify(i.msg)),
                funds: [...(i.funds || [])],
            }),
        }));
        const result = await this.signAndBroadcast(senderAddress, msgs, fee, memo);
        if ((0, stargate_1.isDeliverTxFailure)(result)) {
            throw new Error(createDeliverTxResponseErrorMessage(result));
        }
        return {
            logs: stargate_1.logs.parseRawLog(result.rawLog),
            height: result.height,
            transactionHash: result.transactionHash,
            events: result.events,
            gasWanted: result.gasWanted,
            gasUsed: result.gasUsed,
        };
    }
    async sendTokens(senderAddress, recipientAddress, amount, fee, memo = "") {
        const sendMsg = {
            typeUrl: "/cosmos.bank.v1beta1.MsgSend",
            value: {
                fromAddress: senderAddress,
                toAddress: recipientAddress,
                amount: [...amount],
            },
        };
        return this.signAndBroadcast(senderAddress, [sendMsg], fee, memo);
    }
    async delegateTokens(delegatorAddress, validatorAddress, amount, fee, memo = "") {
        const delegateMsg = {
            typeUrl: "/cosmos.staking.v1beta1.MsgDelegate",
            value: tx_2.MsgDelegate.fromPartial({ delegatorAddress: delegatorAddress, validatorAddress, amount }),
        };
        return this.signAndBroadcast(delegatorAddress, [delegateMsg], fee, memo);
    }
    async undelegateTokens(delegatorAddress, validatorAddress, amount, fee, memo = "") {
        const undelegateMsg = {
            typeUrl: "/cosmos.staking.v1beta1.MsgUndelegate",
            value: tx_2.MsgUndelegate.fromPartial({ delegatorAddress: delegatorAddress, validatorAddress, amount }),
        };
        return this.signAndBroadcast(delegatorAddress, [undelegateMsg], fee, memo);
    }
    async withdrawRewards(delegatorAddress, validatorAddress, fee, memo = "") {
        const withdrawDelegatorRewardMsg = {
            typeUrl: "/cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward",
            value: tx_1.MsgWithdrawDelegatorReward.fromPartial({ delegatorAddress: delegatorAddress, validatorAddress }),
        };
        return this.signAndBroadcast(delegatorAddress, [withdrawDelegatorRewardMsg], fee, memo);
    }
    /**
     * Creates a transaction with the given messages, fee and memo. Then signs and broadcasts the transaction.
     *
     * @param signerAddress The address that will sign transactions using this instance. The signer must be able to sign with this address.
     * @param messages
     * @param fee
     * @param memo
     */
    async signAndBroadcast(signerAddress, messages, fee, memo = "") {
        let usedFee;
        if (fee == "auto" || typeof fee === "number") {
            (0, utils_1.assertDefined)(this.gasPrice, "Gas price must be set in the client options when auto gas is used.");
            const gasEstimation = await this.simulate(signerAddress, messages, memo);
            // Starting with Cosmos SDK 0.47, we see many cases in which 1.3 is not enough anymore
            // E.g. https://github.com/cosmos/cosmos-sdk/issues/16020
            const multiplier = typeof fee === "number" ? fee : 1.4;
            usedFee = (0, stargate_1.calculateFee)(Math.round(gasEstimation * multiplier), this.gasPrice);
        }
        else {
            usedFee = fee;
        }
        const txRaw = await this.sign(signerAddress, messages, usedFee, memo);
        const txBytes = tx_3.TxRaw.encode(txRaw).finish();
        return this.broadcastTx(txBytes, this.broadcastTimeoutMs, this.broadcastPollIntervalMs);
    }
    /**
     * Creates a transaction with the given messages, fee and memo. Then signs and broadcasts the transaction.
     *
     * This method is useful if you want to send a transaction in broadcast,
     * without waiting for it to be placed inside a block, because for example
     * I would like to receive the hash to later track the transaction with another tool.
     *
     * @param signerAddress The address that will sign transactions using this instance. The signer must be able to sign with this address.
     * @param messages
     * @param fee
     * @param memo
     *
     * @returns Returns the hash of the transaction
     */
    async signAndBroadcastSync(signerAddress, messages, fee, memo = "") {
        let usedFee;
        if (fee == "auto" || typeof fee === "number") {
            (0, utils_1.assertDefined)(this.gasPrice, "Gas price must be set in the client options when auto gas is used.");
            const gasEstimation = await this.simulate(signerAddress, messages, memo);
            const multiplier = typeof fee === "number" ? fee : 1.3;
            usedFee = (0, stargate_1.calculateFee)(Math.round(gasEstimation * multiplier), this.gasPrice);
        }
        else {
            usedFee = fee;
        }
        const txRaw = await this.sign(signerAddress, messages, usedFee, memo);
        const txBytes = tx_3.TxRaw.encode(txRaw).finish();
        return this.broadcastTxSync(txBytes);
    }
    async sign(signerAddress, messages, fee, memo, explicitSignerData) {
        let signerData;
        if (explicitSignerData) {
            signerData = explicitSignerData;
        }
        else {
            const { accountNumber, sequence } = await this.getSequence(signerAddress);
            const chainId = await this.getChainId();
            signerData = {
                accountNumber: accountNumber,
                sequence: sequence,
                chainId: chainId,
            };
        }
        return (0, proto_signing_1.isOfflineDirectSigner)(this.signer)
            ? this.signDirect(signerAddress, messages, fee, memo, signerData)
            : this.signAmino(signerAddress, messages, fee, memo, signerData);
    }
    async signAmino(signerAddress, messages, fee, memo, { accountNumber, sequence, chainId }) {
        (0, utils_1.assert)(!(0, proto_signing_1.isOfflineDirectSigner)(this.signer));
        const accountFromSigner = (await this.signer.getAccounts()).find((account) => account.address === signerAddress);
        if (!accountFromSigner) {
            throw new Error("Failed to retrieve account from signer");
        }
        const pubkey = (0, proto_signing_1.encodePubkey)((0, amino_1.encodeSecp256k1Pubkey)(accountFromSigner.pubkey));
        const signMode = signing_1.SignMode.SIGN_MODE_LEGACY_AMINO_JSON;
        const msgs = messages.map((msg) => this.aminoTypes.toAmino(msg));
        const signDoc = (0, amino_1.makeSignDoc)(msgs, fee, chainId, memo, accountNumber, sequence);
        const { signature, signed } = await this.signer.signAmino(signerAddress, signDoc);
        const signedTxBody = {
            typeUrl: "/cosmos.tx.v1beta1.TxBody",
            value: {
                messages: signed.msgs.map((msg) => this.aminoTypes.fromAmino(msg)),
                memo: signed.memo,
            },
        };
        const signedTxBodyBytes = this.registry.encode(signedTxBody);
        const signedGasLimit = math_1.Int53.fromString(signed.fee.gas).toNumber();
        const signedSequence = math_1.Int53.fromString(signed.sequence).toNumber();
        const signedAuthInfoBytes = (0, proto_signing_1.makeAuthInfoBytes)([{ pubkey, sequence: signedSequence }], signed.fee.amount, signedGasLimit, signed.fee.granter, signed.fee.payer, signMode);
        return tx_3.TxRaw.fromPartial({
            bodyBytes: signedTxBodyBytes,
            authInfoBytes: signedAuthInfoBytes,
            signatures: [(0, encoding_1.fromBase64)(signature.signature)],
        });
    }
    async signDirect(signerAddress, messages, fee, memo, { accountNumber, sequence, chainId }) {
        (0, utils_1.assert)((0, proto_signing_1.isOfflineDirectSigner)(this.signer));
        const accountFromSigner = (await this.signer.getAccounts()).find((account) => account.address === signerAddress);
        if (!accountFromSigner) {
            throw new Error("Failed to retrieve account from signer");
        }
        const pubkey = (0, proto_signing_1.encodePubkey)((0, amino_1.encodeSecp256k1Pubkey)(accountFromSigner.pubkey));
        const txBody = {
            typeUrl: "/cosmos.tx.v1beta1.TxBody",
            value: {
                messages: messages,
                memo: memo,
            },
        };
        const txBodyBytes = this.registry.encode(txBody);
        const gasLimit = math_1.Int53.fromString(fee.gas).toNumber();
        const authInfoBytes = (0, proto_signing_1.makeAuthInfoBytes)([{ pubkey, sequence }], fee.amount, gasLimit, fee.granter, fee.payer);
        const signDoc = (0, proto_signing_1.makeSignDoc)(txBodyBytes, authInfoBytes, chainId, accountNumber);
        const { signature, signed } = await this.signer.signDirect(signerAddress, signDoc);
        return tx_3.TxRaw.fromPartial({
            bodyBytes: signed.bodyBytes,
            authInfoBytes: signed.authInfoBytes,
            signatures: [(0, encoding_1.fromBase64)(signature.signature)],
        });
    }
}
exports.SigningCosmWasmClient = SigningCosmWasmClient;
//# sourceMappingURL=signingcosmwasmclient.js.map

/***/ }),

/***/ 90290:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Bip39 = exports.EnglishMnemonic = exports.mnemonicToEntropy = exports.entropyToMnemonic = void 0;
const encoding_1 = __webpack_require__(87061);
const pbkdf2_1 = __webpack_require__(20348);
const sha_1 = __webpack_require__(83293);
const wordlist = [
    "abandon",
    "ability",
    "able",
    "about",
    "above",
    "absent",
    "absorb",
    "abstract",
    "absurd",
    "abuse",
    "access",
    "accident",
    "account",
    "accuse",
    "achieve",
    "acid",
    "acoustic",
    "acquire",
    "across",
    "act",
    "action",
    "actor",
    "actress",
    "actual",
    "adapt",
    "add",
    "addict",
    "address",
    "adjust",
    "admit",
    "adult",
    "advance",
    "advice",
    "aerobic",
    "affair",
    "afford",
    "afraid",
    "again",
    "age",
    "agent",
    "agree",
    "ahead",
    "aim",
    "air",
    "airport",
    "aisle",
    "alarm",
    "album",
    "alcohol",
    "alert",
    "alien",
    "all",
    "alley",
    "allow",
    "almost",
    "alone",
    "alpha",
    "already",
    "also",
    "alter",
    "always",
    "amateur",
    "amazing",
    "among",
    "amount",
    "amused",
    "analyst",
    "anchor",
    "ancient",
    "anger",
    "angle",
    "angry",
    "animal",
    "ankle",
    "announce",
    "annual",
    "another",
    "answer",
    "antenna",
    "antique",
    "anxiety",
    "any",
    "apart",
    "apology",
    "appear",
    "apple",
    "approve",
    "april",
    "arch",
    "arctic",
    "area",
    "arena",
    "argue",
    "arm",
    "armed",
    "armor",
    "army",
    "around",
    "arrange",
    "arrest",
    "arrive",
    "arrow",
    "art",
    "artefact",
    "artist",
    "artwork",
    "ask",
    "aspect",
    "assault",
    "asset",
    "assist",
    "assume",
    "asthma",
    "athlete",
    "atom",
    "attack",
    "attend",
    "attitude",
    "attract",
    "auction",
    "audit",
    "august",
    "aunt",
    "author",
    "auto",
    "autumn",
    "average",
    "avocado",
    "avoid",
    "awake",
    "aware",
    "away",
    "awesome",
    "awful",
    "awkward",
    "axis",
    "baby",
    "bachelor",
    "bacon",
    "badge",
    "bag",
    "balance",
    "balcony",
    "ball",
    "bamboo",
    "banana",
    "banner",
    "bar",
    "barely",
    "bargain",
    "barrel",
    "base",
    "basic",
    "basket",
    "battle",
    "beach",
    "bean",
    "beauty",
    "because",
    "become",
    "beef",
    "before",
    "begin",
    "behave",
    "behind",
    "believe",
    "below",
    "belt",
    "bench",
    "benefit",
    "best",
    "betray",
    "better",
    "between",
    "beyond",
    "bicycle",
    "bid",
    "bike",
    "bind",
    "biology",
    "bird",
    "birth",
    "bitter",
    "black",
    "blade",
    "blame",
    "blanket",
    "blast",
    "bleak",
    "bless",
    "blind",
    "blood",
    "blossom",
    "blouse",
    "blue",
    "blur",
    "blush",
    "board",
    "boat",
    "body",
    "boil",
    "bomb",
    "bone",
    "bonus",
    "book",
    "boost",
    "border",
    "boring",
    "borrow",
    "boss",
    "bottom",
    "bounce",
    "box",
    "boy",
    "bracket",
    "brain",
    "brand",
    "brass",
    "brave",
    "bread",
    "breeze",
    "brick",
    "bridge",
    "brief",
    "bright",
    "bring",
    "brisk",
    "broccoli",
    "broken",
    "bronze",
    "broom",
    "brother",
    "brown",
    "brush",
    "bubble",
    "buddy",
    "budget",
    "buffalo",
    "build",
    "bulb",
    "bulk",
    "bullet",
    "bundle",
    "bunker",
    "burden",
    "burger",
    "burst",
    "bus",
    "business",
    "busy",
    "butter",
    "buyer",
    "buzz",
    "cabbage",
    "cabin",
    "cable",
    "cactus",
    "cage",
    "cake",
    "call",
    "calm",
    "camera",
    "camp",
    "can",
    "canal",
    "cancel",
    "candy",
    "cannon",
    "canoe",
    "canvas",
    "canyon",
    "capable",
    "capital",
    "captain",
    "car",
    "carbon",
    "card",
    "cargo",
    "carpet",
    "carry",
    "cart",
    "case",
    "cash",
    "casino",
    "castle",
    "casual",
    "cat",
    "catalog",
    "catch",
    "category",
    "cattle",
    "caught",
    "cause",
    "caution",
    "cave",
    "ceiling",
    "celery",
    "cement",
    "census",
    "century",
    "cereal",
    "certain",
    "chair",
    "chalk",
    "champion",
    "change",
    "chaos",
    "chapter",
    "charge",
    "chase",
    "chat",
    "cheap",
    "check",
    "cheese",
    "chef",
    "cherry",
    "chest",
    "chicken",
    "chief",
    "child",
    "chimney",
    "choice",
    "choose",
    "chronic",
    "chuckle",
    "chunk",
    "churn",
    "cigar",
    "cinnamon",
    "circle",
    "citizen",
    "city",
    "civil",
    "claim",
    "clap",
    "clarify",
    "claw",
    "clay",
    "clean",
    "clerk",
    "clever",
    "click",
    "client",
    "cliff",
    "climb",
    "clinic",
    "clip",
    "clock",
    "clog",
    "close",
    "cloth",
    "cloud",
    "clown",
    "club",
    "clump",
    "cluster",
    "clutch",
    "coach",
    "coast",
    "coconut",
    "code",
    "coffee",
    "coil",
    "coin",
    "collect",
    "color",
    "column",
    "combine",
    "come",
    "comfort",
    "comic",
    "common",
    "company",
    "concert",
    "conduct",
    "confirm",
    "congress",
    "connect",
    "consider",
    "control",
    "convince",
    "cook",
    "cool",
    "copper",
    "copy",
    "coral",
    "core",
    "corn",
    "correct",
    "cost",
    "cotton",
    "couch",
    "country",
    "couple",
    "course",
    "cousin",
    "cover",
    "coyote",
    "crack",
    "cradle",
    "craft",
    "cram",
    "crane",
    "crash",
    "crater",
    "crawl",
    "crazy",
    "cream",
    "credit",
    "creek",
    "crew",
    "cricket",
    "crime",
    "crisp",
    "critic",
    "crop",
    "cross",
    "crouch",
    "crowd",
    "crucial",
    "cruel",
    "cruise",
    "crumble",
    "crunch",
    "crush",
    "cry",
    "crystal",
    "cube",
    "culture",
    "cup",
    "cupboard",
    "curious",
    "current",
    "curtain",
    "curve",
    "cushion",
    "custom",
    "cute",
    "cycle",
    "dad",
    "damage",
    "damp",
    "dance",
    "danger",
    "daring",
    "dash",
    "daughter",
    "dawn",
    "day",
    "deal",
    "debate",
    "debris",
    "decade",
    "december",
    "decide",
    "decline",
    "decorate",
    "decrease",
    "deer",
    "defense",
    "define",
    "defy",
    "degree",
    "delay",
    "deliver",
    "demand",
    "demise",
    "denial",
    "dentist",
    "deny",
    "depart",
    "depend",
    "deposit",
    "depth",
    "deputy",
    "derive",
    "describe",
    "desert",
    "design",
    "desk",
    "despair",
    "destroy",
    "detail",
    "detect",
    "develop",
    "device",
    "devote",
    "diagram",
    "dial",
    "diamond",
    "diary",
    "dice",
    "diesel",
    "diet",
    "differ",
    "digital",
    "dignity",
    "dilemma",
    "dinner",
    "dinosaur",
    "direct",
    "dirt",
    "disagree",
    "discover",
    "disease",
    "dish",
    "dismiss",
    "disorder",
    "display",
    "distance",
    "divert",
    "divide",
    "divorce",
    "dizzy",
    "doctor",
    "document",
    "dog",
    "doll",
    "dolphin",
    "domain",
    "donate",
    "donkey",
    "donor",
    "door",
    "dose",
    "double",
    "dove",
    "draft",
    "dragon",
    "drama",
    "drastic",
    "draw",
    "dream",
    "dress",
    "drift",
    "drill",
    "drink",
    "drip",
    "drive",
    "drop",
    "drum",
    "dry",
    "duck",
    "dumb",
    "dune",
    "during",
    "dust",
    "dutch",
    "duty",
    "dwarf",
    "dynamic",
    "eager",
    "eagle",
    "early",
    "earn",
    "earth",
    "easily",
    "east",
    "easy",
    "echo",
    "ecology",
    "economy",
    "edge",
    "edit",
    "educate",
    "effort",
    "egg",
    "eight",
    "either",
    "elbow",
    "elder",
    "electric",
    "elegant",
    "element",
    "elephant",
    "elevator",
    "elite",
    "else",
    "embark",
    "embody",
    "embrace",
    "emerge",
    "emotion",
    "employ",
    "empower",
    "empty",
    "enable",
    "enact",
    "end",
    "endless",
    "endorse",
    "enemy",
    "energy",
    "enforce",
    "engage",
    "engine",
    "enhance",
    "enjoy",
    "enlist",
    "enough",
    "enrich",
    "enroll",
    "ensure",
    "enter",
    "entire",
    "entry",
    "envelope",
    "episode",
    "equal",
    "equip",
    "era",
    "erase",
    "erode",
    "erosion",
    "error",
    "erupt",
    "escape",
    "essay",
    "essence",
    "estate",
    "eternal",
    "ethics",
    "evidence",
    "evil",
    "evoke",
    "evolve",
    "exact",
    "example",
    "excess",
    "exchange",
    "excite",
    "exclude",
    "excuse",
    "execute",
    "exercise",
    "exhaust",
    "exhibit",
    "exile",
    "exist",
    "exit",
    "exotic",
    "expand",
    "expect",
    "expire",
    "explain",
    "expose",
    "express",
    "extend",
    "extra",
    "eye",
    "eyebrow",
    "fabric",
    "face",
    "faculty",
    "fade",
    "faint",
    "faith",
    "fall",
    "false",
    "fame",
    "family",
    "famous",
    "fan",
    "fancy",
    "fantasy",
    "farm",
    "fashion",
    "fat",
    "fatal",
    "father",
    "fatigue",
    "fault",
    "favorite",
    "feature",
    "february",
    "federal",
    "fee",
    "feed",
    "feel",
    "female",
    "fence",
    "festival",
    "fetch",
    "fever",
    "few",
    "fiber",
    "fiction",
    "field",
    "figure",
    "file",
    "film",
    "filter",
    "final",
    "find",
    "fine",
    "finger",
    "finish",
    "fire",
    "firm",
    "first",
    "fiscal",
    "fish",
    "fit",
    "fitness",
    "fix",
    "flag",
    "flame",
    "flash",
    "flat",
    "flavor",
    "flee",
    "flight",
    "flip",
    "float",
    "flock",
    "floor",
    "flower",
    "fluid",
    "flush",
    "fly",
    "foam",
    "focus",
    "fog",
    "foil",
    "fold",
    "follow",
    "food",
    "foot",
    "force",
    "forest",
    "forget",
    "fork",
    "fortune",
    "forum",
    "forward",
    "fossil",
    "foster",
    "found",
    "fox",
    "fragile",
    "frame",
    "frequent",
    "fresh",
    "friend",
    "fringe",
    "frog",
    "front",
    "frost",
    "frown",
    "frozen",
    "fruit",
    "fuel",
    "fun",
    "funny",
    "furnace",
    "fury",
    "future",
    "gadget",
    "gain",
    "galaxy",
    "gallery",
    "game",
    "gap",
    "garage",
    "garbage",
    "garden",
    "garlic",
    "garment",
    "gas",
    "gasp",
    "gate",
    "gather",
    "gauge",
    "gaze",
    "general",
    "genius",
    "genre",
    "gentle",
    "genuine",
    "gesture",
    "ghost",
    "giant",
    "gift",
    "giggle",
    "ginger",
    "giraffe",
    "girl",
    "give",
    "glad",
    "glance",
    "glare",
    "glass",
    "glide",
    "glimpse",
    "globe",
    "gloom",
    "glory",
    "glove",
    "glow",
    "glue",
    "goat",
    "goddess",
    "gold",
    "good",
    "goose",
    "gorilla",
    "gospel",
    "gossip",
    "govern",
    "gown",
    "grab",
    "grace",
    "grain",
    "grant",
    "grape",
    "grass",
    "gravity",
    "great",
    "green",
    "grid",
    "grief",
    "grit",
    "grocery",
    "group",
    "grow",
    "grunt",
    "guard",
    "guess",
    "guide",
    "guilt",
    "guitar",
    "gun",
    "gym",
    "habit",
    "hair",
    "half",
    "hammer",
    "hamster",
    "hand",
    "happy",
    "harbor",
    "hard",
    "harsh",
    "harvest",
    "hat",
    "have",
    "hawk",
    "hazard",
    "head",
    "health",
    "heart",
    "heavy",
    "hedgehog",
    "height",
    "hello",
    "helmet",
    "help",
    "hen",
    "hero",
    "hidden",
    "high",
    "hill",
    "hint",
    "hip",
    "hire",
    "history",
    "hobby",
    "hockey",
    "hold",
    "hole",
    "holiday",
    "hollow",
    "home",
    "honey",
    "hood",
    "hope",
    "horn",
    "horror",
    "horse",
    "hospital",
    "host",
    "hotel",
    "hour",
    "hover",
    "hub",
    "huge",
    "human",
    "humble",
    "humor",
    "hundred",
    "hungry",
    "hunt",
    "hurdle",
    "hurry",
    "hurt",
    "husband",
    "hybrid",
    "ice",
    "icon",
    "idea",
    "identify",
    "idle",
    "ignore",
    "ill",
    "illegal",
    "illness",
    "image",
    "imitate",
    "immense",
    "immune",
    "impact",
    "impose",
    "improve",
    "impulse",
    "inch",
    "include",
    "income",
    "increase",
    "index",
    "indicate",
    "indoor",
    "industry",
    "infant",
    "inflict",
    "inform",
    "inhale",
    "inherit",
    "initial",
    "inject",
    "injury",
    "inmate",
    "inner",
    "innocent",
    "input",
    "inquiry",
    "insane",
    "insect",
    "inside",
    "inspire",
    "install",
    "intact",
    "interest",
    "into",
    "invest",
    "invite",
    "involve",
    "iron",
    "island",
    "isolate",
    "issue",
    "item",
    "ivory",
    "jacket",
    "jaguar",
    "jar",
    "jazz",
    "jealous",
    "jeans",
    "jelly",
    "jewel",
    "job",
    "join",
    "joke",
    "journey",
    "joy",
    "judge",
    "juice",
    "jump",
    "jungle",
    "junior",
    "junk",
    "just",
    "kangaroo",
    "keen",
    "keep",
    "ketchup",
    "key",
    "kick",
    "kid",
    "kidney",
    "kind",
    "kingdom",
    "kiss",
    "kit",
    "kitchen",
    "kite",
    "kitten",
    "kiwi",
    "knee",
    "knife",
    "knock",
    "know",
    "lab",
    "label",
    "labor",
    "ladder",
    "lady",
    "lake",
    "lamp",
    "language",
    "laptop",
    "large",
    "later",
    "latin",
    "laugh",
    "laundry",
    "lava",
    "law",
    "lawn",
    "lawsuit",
    "layer",
    "lazy",
    "leader",
    "leaf",
    "learn",
    "leave",
    "lecture",
    "left",
    "leg",
    "legal",
    "legend",
    "leisure",
    "lemon",
    "lend",
    "length",
    "lens",
    "leopard",
    "lesson",
    "letter",
    "level",
    "liar",
    "liberty",
    "library",
    "license",
    "life",
    "lift",
    "light",
    "like",
    "limb",
    "limit",
    "link",
    "lion",
    "liquid",
    "list",
    "little",
    "live",
    "lizard",
    "load",
    "loan",
    "lobster",
    "local",
    "lock",
    "logic",
    "lonely",
    "long",
    "loop",
    "lottery",
    "loud",
    "lounge",
    "love",
    "loyal",
    "lucky",
    "luggage",
    "lumber",
    "lunar",
    "lunch",
    "luxury",
    "lyrics",
    "machine",
    "mad",
    "magic",
    "magnet",
    "maid",
    "mail",
    "main",
    "major",
    "make",
    "mammal",
    "man",
    "manage",
    "mandate",
    "mango",
    "mansion",
    "manual",
    "maple",
    "marble",
    "march",
    "margin",
    "marine",
    "market",
    "marriage",
    "mask",
    "mass",
    "master",
    "match",
    "material",
    "math",
    "matrix",
    "matter",
    "maximum",
    "maze",
    "meadow",
    "mean",
    "measure",
    "meat",
    "mechanic",
    "medal",
    "media",
    "melody",
    "melt",
    "member",
    "memory",
    "mention",
    "menu",
    "mercy",
    "merge",
    "merit",
    "merry",
    "mesh",
    "message",
    "metal",
    "method",
    "middle",
    "midnight",
    "milk",
    "million",
    "mimic",
    "mind",
    "minimum",
    "minor",
    "minute",
    "miracle",
    "mirror",
    "misery",
    "miss",
    "mistake",
    "mix",
    "mixed",
    "mixture",
    "mobile",
    "model",
    "modify",
    "mom",
    "moment",
    "monitor",
    "monkey",
    "monster",
    "month",
    "moon",
    "moral",
    "more",
    "morning",
    "mosquito",
    "mother",
    "motion",
    "motor",
    "mountain",
    "mouse",
    "move",
    "movie",
    "much",
    "muffin",
    "mule",
    "multiply",
    "muscle",
    "museum",
    "mushroom",
    "music",
    "must",
    "mutual",
    "myself",
    "mystery",
    "myth",
    "naive",
    "name",
    "napkin",
    "narrow",
    "nasty",
    "nation",
    "nature",
    "near",
    "neck",
    "need",
    "negative",
    "neglect",
    "neither",
    "nephew",
    "nerve",
    "nest",
    "net",
    "network",
    "neutral",
    "never",
    "news",
    "next",
    "nice",
    "night",
    "noble",
    "noise",
    "nominee",
    "noodle",
    "normal",
    "north",
    "nose",
    "notable",
    "note",
    "nothing",
    "notice",
    "novel",
    "now",
    "nuclear",
    "number",
    "nurse",
    "nut",
    "oak",
    "obey",
    "object",
    "oblige",
    "obscure",
    "observe",
    "obtain",
    "obvious",
    "occur",
    "ocean",
    "october",
    "odor",
    "off",
    "offer",
    "office",
    "often",
    "oil",
    "okay",
    "old",
    "olive",
    "olympic",
    "omit",
    "once",
    "one",
    "onion",
    "online",
    "only",
    "open",
    "opera",
    "opinion",
    "oppose",
    "option",
    "orange",
    "orbit",
    "orchard",
    "order",
    "ordinary",
    "organ",
    "orient",
    "original",
    "orphan",
    "ostrich",
    "other",
    "outdoor",
    "outer",
    "output",
    "outside",
    "oval",
    "oven",
    "over",
    "own",
    "owner",
    "oxygen",
    "oyster",
    "ozone",
    "pact",
    "paddle",
    "page",
    "pair",
    "palace",
    "palm",
    "panda",
    "panel",
    "panic",
    "panther",
    "paper",
    "parade",
    "parent",
    "park",
    "parrot",
    "party",
    "pass",
    "patch",
    "path",
    "patient",
    "patrol",
    "pattern",
    "pause",
    "pave",
    "payment",
    "peace",
    "peanut",
    "pear",
    "peasant",
    "pelican",
    "pen",
    "penalty",
    "pencil",
    "people",
    "pepper",
    "perfect",
    "permit",
    "person",
    "pet",
    "phone",
    "photo",
    "phrase",
    "physical",
    "piano",
    "picnic",
    "picture",
    "piece",
    "pig",
    "pigeon",
    "pill",
    "pilot",
    "pink",
    "pioneer",
    "pipe",
    "pistol",
    "pitch",
    "pizza",
    "place",
    "planet",
    "plastic",
    "plate",
    "play",
    "please",
    "pledge",
    "pluck",
    "plug",
    "plunge",
    "poem",
    "poet",
    "point",
    "polar",
    "pole",
    "police",
    "pond",
    "pony",
    "pool",
    "popular",
    "portion",
    "position",
    "possible",
    "post",
    "potato",
    "pottery",
    "poverty",
    "powder",
    "power",
    "practice",
    "praise",
    "predict",
    "prefer",
    "prepare",
    "present",
    "pretty",
    "prevent",
    "price",
    "pride",
    "primary",
    "print",
    "priority",
    "prison",
    "private",
    "prize",
    "problem",
    "process",
    "produce",
    "profit",
    "program",
    "project",
    "promote",
    "proof",
    "property",
    "prosper",
    "protect",
    "proud",
    "provide",
    "public",
    "pudding",
    "pull",
    "pulp",
    "pulse",
    "pumpkin",
    "punch",
    "pupil",
    "puppy",
    "purchase",
    "purity",
    "purpose",
    "purse",
    "push",
    "put",
    "puzzle",
    "pyramid",
    "quality",
    "quantum",
    "quarter",
    "question",
    "quick",
    "quit",
    "quiz",
    "quote",
    "rabbit",
    "raccoon",
    "race",
    "rack",
    "radar",
    "radio",
    "rail",
    "rain",
    "raise",
    "rally",
    "ramp",
    "ranch",
    "random",
    "range",
    "rapid",
    "rare",
    "rate",
    "rather",
    "raven",
    "raw",
    "razor",
    "ready",
    "real",
    "reason",
    "rebel",
    "rebuild",
    "recall",
    "receive",
    "recipe",
    "record",
    "recycle",
    "reduce",
    "reflect",
    "reform",
    "refuse",
    "region",
    "regret",
    "regular",
    "reject",
    "relax",
    "release",
    "relief",
    "rely",
    "remain",
    "remember",
    "remind",
    "remove",
    "render",
    "renew",
    "rent",
    "reopen",
    "repair",
    "repeat",
    "replace",
    "report",
    "require",
    "rescue",
    "resemble",
    "resist",
    "resource",
    "response",
    "result",
    "retire",
    "retreat",
    "return",
    "reunion",
    "reveal",
    "review",
    "reward",
    "rhythm",
    "rib",
    "ribbon",
    "rice",
    "rich",
    "ride",
    "ridge",
    "rifle",
    "right",
    "rigid",
    "ring",
    "riot",
    "ripple",
    "risk",
    "ritual",
    "rival",
    "river",
    "road",
    "roast",
    "robot",
    "robust",
    "rocket",
    "romance",
    "roof",
    "rookie",
    "room",
    "rose",
    "rotate",
    "rough",
    "round",
    "route",
    "royal",
    "rubber",
    "rude",
    "rug",
    "rule",
    "run",
    "runway",
    "rural",
    "sad",
    "saddle",
    "sadness",
    "safe",
    "sail",
    "salad",
    "salmon",
    "salon",
    "salt",
    "salute",
    "same",
    "sample",
    "sand",
    "satisfy",
    "satoshi",
    "sauce",
    "sausage",
    "save",
    "say",
    "scale",
    "scan",
    "scare",
    "scatter",
    "scene",
    "scheme",
    "school",
    "science",
    "scissors",
    "scorpion",
    "scout",
    "scrap",
    "screen",
    "script",
    "scrub",
    "sea",
    "search",
    "season",
    "seat",
    "second",
    "secret",
    "section",
    "security",
    "seed",
    "seek",
    "segment",
    "select",
    "sell",
    "seminar",
    "senior",
    "sense",
    "sentence",
    "series",
    "service",
    "session",
    "settle",
    "setup",
    "seven",
    "shadow",
    "shaft",
    "shallow",
    "share",
    "shed",
    "shell",
    "sheriff",
    "shield",
    "shift",
    "shine",
    "ship",
    "shiver",
    "shock",
    "shoe",
    "shoot",
    "shop",
    "short",
    "shoulder",
    "shove",
    "shrimp",
    "shrug",
    "shuffle",
    "shy",
    "sibling",
    "sick",
    "side",
    "siege",
    "sight",
    "sign",
    "silent",
    "silk",
    "silly",
    "silver",
    "similar",
    "simple",
    "since",
    "sing",
    "siren",
    "sister",
    "situate",
    "six",
    "size",
    "skate",
    "sketch",
    "ski",
    "skill",
    "skin",
    "skirt",
    "skull",
    "slab",
    "slam",
    "sleep",
    "slender",
    "slice",
    "slide",
    "slight",
    "slim",
    "slogan",
    "slot",
    "slow",
    "slush",
    "small",
    "smart",
    "smile",
    "smoke",
    "smooth",
    "snack",
    "snake",
    "snap",
    "sniff",
    "snow",
    "soap",
    "soccer",
    "social",
    "sock",
    "soda",
    "soft",
    "solar",
    "soldier",
    "solid",
    "solution",
    "solve",
    "someone",
    "song",
    "soon",
    "sorry",
    "sort",
    "soul",
    "sound",
    "soup",
    "source",
    "south",
    "space",
    "spare",
    "spatial",
    "spawn",
    "speak",
    "special",
    "speed",
    "spell",
    "spend",
    "sphere",
    "spice",
    "spider",
    "spike",
    "spin",
    "spirit",
    "split",
    "spoil",
    "sponsor",
    "spoon",
    "sport",
    "spot",
    "spray",
    "spread",
    "spring",
    "spy",
    "square",
    "squeeze",
    "squirrel",
    "stable",
    "stadium",
    "staff",
    "stage",
    "stairs",
    "stamp",
    "stand",
    "start",
    "state",
    "stay",
    "steak",
    "steel",
    "stem",
    "step",
    "stereo",
    "stick",
    "still",
    "sting",
    "stock",
    "stomach",
    "stone",
    "stool",
    "story",
    "stove",
    "strategy",
    "street",
    "strike",
    "strong",
    "struggle",
    "student",
    "stuff",
    "stumble",
    "style",
    "subject",
    "submit",
    "subway",
    "success",
    "such",
    "sudden",
    "suffer",
    "sugar",
    "suggest",
    "suit",
    "summer",
    "sun",
    "sunny",
    "sunset",
    "super",
    "supply",
    "supreme",
    "sure",
    "surface",
    "surge",
    "surprise",
    "surround",
    "survey",
    "suspect",
    "sustain",
    "swallow",
    "swamp",
    "swap",
    "swarm",
    "swear",
    "sweet",
    "swift",
    "swim",
    "swing",
    "switch",
    "sword",
    "symbol",
    "symptom",
    "syrup",
    "system",
    "table",
    "tackle",
    "tag",
    "tail",
    "talent",
    "talk",
    "tank",
    "tape",
    "target",
    "task",
    "taste",
    "tattoo",
    "taxi",
    "teach",
    "team",
    "tell",
    "ten",
    "tenant",
    "tennis",
    "tent",
    "term",
    "test",
    "text",
    "thank",
    "that",
    "theme",
    "then",
    "theory",
    "there",
    "they",
    "thing",
    "this",
    "thought",
    "three",
    "thrive",
    "throw",
    "thumb",
    "thunder",
    "ticket",
    "tide",
    "tiger",
    "tilt",
    "timber",
    "time",
    "tiny",
    "tip",
    "tired",
    "tissue",
    "title",
    "toast",
    "tobacco",
    "today",
    "toddler",
    "toe",
    "together",
    "toilet",
    "token",
    "tomato",
    "tomorrow",
    "tone",
    "tongue",
    "tonight",
    "tool",
    "tooth",
    "top",
    "topic",
    "topple",
    "torch",
    "tornado",
    "tortoise",
    "toss",
    "total",
    "tourist",
    "toward",
    "tower",
    "town",
    "toy",
    "track",
    "trade",
    "traffic",
    "tragic",
    "train",
    "transfer",
    "trap",
    "trash",
    "travel",
    "tray",
    "treat",
    "tree",
    "trend",
    "trial",
    "tribe",
    "trick",
    "trigger",
    "trim",
    "trip",
    "trophy",
    "trouble",
    "truck",
    "true",
    "truly",
    "trumpet",
    "trust",
    "truth",
    "try",
    "tube",
    "tuition",
    "tumble",
    "tuna",
    "tunnel",
    "turkey",
    "turn",
    "turtle",
    "twelve",
    "twenty",
    "twice",
    "twin",
    "twist",
    "two",
    "type",
    "typical",
    "ugly",
    "umbrella",
    "unable",
    "unaware",
    "uncle",
    "uncover",
    "under",
    "undo",
    "unfair",
    "unfold",
    "unhappy",
    "uniform",
    "unique",
    "unit",
    "universe",
    "unknown",
    "unlock",
    "until",
    "unusual",
    "unveil",
    "update",
    "upgrade",
    "uphold",
    "upon",
    "upper",
    "upset",
    "urban",
    "urge",
    "usage",
    "use",
    "used",
    "useful",
    "useless",
    "usual",
    "utility",
    "vacant",
    "vacuum",
    "vague",
    "valid",
    "valley",
    "valve",
    "van",
    "vanish",
    "vapor",
    "various",
    "vast",
    "vault",
    "vehicle",
    "velvet",
    "vendor",
    "venture",
    "venue",
    "verb",
    "verify",
    "version",
    "very",
    "vessel",
    "veteran",
    "viable",
    "vibrant",
    "vicious",
    "victory",
    "video",
    "view",
    "village",
    "vintage",
    "violin",
    "virtual",
    "virus",
    "visa",
    "visit",
    "visual",
    "vital",
    "vivid",
    "vocal",
    "voice",
    "void",
    "volcano",
    "volume",
    "vote",
    "voyage",
    "wage",
    "wagon",
    "wait",
    "walk",
    "wall",
    "walnut",
    "want",
    "warfare",
    "warm",
    "warrior",
    "wash",
    "wasp",
    "waste",
    "water",
    "wave",
    "way",
    "wealth",
    "weapon",
    "wear",
    "weasel",
    "weather",
    "web",
    "wedding",
    "weekend",
    "weird",
    "welcome",
    "west",
    "wet",
    "whale",
    "what",
    "wheat",
    "wheel",
    "when",
    "where",
    "whip",
    "whisper",
    "wide",
    "width",
    "wife",
    "wild",
    "will",
    "win",
    "window",
    "wine",
    "wing",
    "wink",
    "winner",
    "winter",
    "wire",
    "wisdom",
    "wise",
    "wish",
    "witness",
    "wolf",
    "woman",
    "wonder",
    "wood",
    "wool",
    "word",
    "work",
    "world",
    "worry",
    "worth",
    "wrap",
    "wreck",
    "wrestle",
    "wrist",
    "write",
    "wrong",
    "yard",
    "year",
    "yellow",
    "you",
    "young",
    "youth",
    "zebra",
    "zero",
    "zone",
    "zoo",
];
function bytesToBitstring(bytes) {
    return Array.from(bytes)
        .map((byte) => byte.toString(2).padStart(8, "0"))
        .join("");
}
function deriveChecksumBits(entropy) {
    const entropyLengthBits = entropy.length * 8; // "ENT" (in bits)
    const checksumLengthBits = entropyLengthBits / 32; // "CS" (in bits)
    const hash = (0, sha_1.sha256)(entropy);
    return bytesToBitstring(hash).slice(0, checksumLengthBits);
}
function bitstringToByte(bin) {
    return parseInt(bin, 2);
}
const allowedEntropyLengths = [16, 20, 24, 28, 32];
const allowedWordLengths = [12, 15, 18, 21, 24];
function entropyToMnemonic(entropy) {
    if (allowedEntropyLengths.indexOf(entropy.length) === -1) {
        throw new Error("invalid input length");
    }
    const entropyBits = bytesToBitstring(entropy);
    const checksumBits = deriveChecksumBits(entropy);
    const bits = entropyBits + checksumBits;
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const chunks = bits.match(/(.{11})/g);
    const words = chunks.map((binary) => {
        const index = bitstringToByte(binary);
        return wordlist[index];
    });
    return words.join(" ");
}
exports.entropyToMnemonic = entropyToMnemonic;
const invalidNumberOfWorks = "Invalid number of words";
const wordNotInWordlist = "Found word that is not in the wordlist";
const invalidEntropy = "Invalid entropy";
const invalidChecksum = "Invalid mnemonic checksum";
function normalize(str) {
    return str.normalize("NFKD");
}
function mnemonicToEntropy(mnemonic) {
    const words = normalize(mnemonic).split(" ");
    if (!allowedWordLengths.includes(words.length)) {
        throw new Error(invalidNumberOfWorks);
    }
    // convert word indices to 11 bit binary strings
    const bits = words
        .map((word) => {
        const index = wordlist.indexOf(word);
        if (index === -1) {
            throw new Error(wordNotInWordlist);
        }
        return index.toString(2).padStart(11, "0");
    })
        .join("");
    // split the binary string into ENT/CS
    const dividerIndex = Math.floor(bits.length / 33) * 32;
    const entropyBits = bits.slice(0, dividerIndex);
    const checksumBits = bits.slice(dividerIndex);
    // calculate the checksum and compare
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const entropyBytes = entropyBits.match(/(.{1,8})/g).map(bitstringToByte);
    if (entropyBytes.length < 16 || entropyBytes.length > 32 || entropyBytes.length % 4 !== 0) {
        throw new Error(invalidEntropy);
    }
    const entropy = Uint8Array.from(entropyBytes);
    const newChecksum = deriveChecksumBits(entropy);
    if (newChecksum !== checksumBits) {
        throw new Error(invalidChecksum);
    }
    return entropy;
}
exports.mnemonicToEntropy = mnemonicToEntropy;
class EnglishMnemonic {
    constructor(mnemonic) {
        if (!EnglishMnemonic.mnemonicMatcher.test(mnemonic)) {
            throw new Error("Invalid mnemonic format");
        }
        const words = mnemonic.split(" ");
        const allowedWordsLengths = [12, 15, 18, 21, 24];
        if (allowedWordsLengths.indexOf(words.length) === -1) {
            throw new Error(`Invalid word count in mnemonic (allowed: ${allowedWordsLengths} got: ${words.length})`);
        }
        for (const word of words) {
            if (EnglishMnemonic.wordlist.indexOf(word) === -1) {
                throw new Error("Mnemonic contains invalid word");
            }
        }
        // Throws with informative error message if mnemonic is not valid
        mnemonicToEntropy(mnemonic);
        this.data = mnemonic;
    }
    toString() {
        return this.data;
    }
}
exports.EnglishMnemonic = EnglishMnemonic;
EnglishMnemonic.wordlist = wordlist;
// list of space separated lower case words (1 or more)
EnglishMnemonic.mnemonicMatcher = /^[a-z]+( [a-z]+)*$/;
class Bip39 {
    /**
     * Encodes raw entropy of length 16, 20, 24, 28 or 32 bytes as an English mnemonic between 12 and 24 words.
     *
     * | Entropy            | Words |
     * |--------------------|-------|
     * | 128 bit (16 bytes) |    12 |
     * | 160 bit (20 bytes) |    15 |
     * | 192 bit (24 bytes) |    18 |
     * | 224 bit (28 bytes) |    21 |
     * | 256 bit (32 bytes) |    24 |
     *
     *
     * @see https://github.com/bitcoin/bips/blob/master/bip-0039.mediawiki#generating-the-mnemonic
     * @param entropy The entropy to be encoded. This must be cryptographically secure.
     */
    static encode(entropy) {
        return new EnglishMnemonic(entropyToMnemonic(entropy));
    }
    static decode(mnemonic) {
        return mnemonicToEntropy(mnemonic.toString());
    }
    static async mnemonicToSeed(mnemonic, password) {
        const mnemonicBytes = (0, encoding_1.toUtf8)(normalize(mnemonic.toString()));
        const salt = "mnemonic" + (password ? normalize(password) : "");
        const saltBytes = (0, encoding_1.toUtf8)(salt);
        return (0, pbkdf2_1.pbkdf2Sha512)(mnemonicBytes, saltBytes, 2048, 64);
    }
}
exports.Bip39 = Bip39;
//# sourceMappingURL=bip39.js.map

/***/ }),

/***/ 92135:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Hmac = void 0;
class Hmac {
    constructor(hashFunctionConstructor, originalKey) {
        // This implementation is based on https://en.wikipedia.org/wiki/HMAC#Implementation
        // with the addition of incremental hashing support. Thus part of the algorithm
        // is in the constructor and the rest in digest().
        const blockSize = new hashFunctionConstructor().blockSize;
        this.hash = (data) => new hashFunctionConstructor().update(data).digest();
        let key = originalKey;
        if (key.length > blockSize) {
            key = this.hash(key);
        }
        if (key.length < blockSize) {
            const zeroPadding = new Uint8Array(blockSize - key.length);
            key = new Uint8Array([...key, ...zeroPadding]);
        }
        // eslint-disable-next-line no-bitwise
        this.oKeyPad = key.map((keyByte) => keyByte ^ 0x5c);
        // eslint-disable-next-line no-bitwise
        this.iKeyPad = key.map((keyByte) => keyByte ^ 0x36);
        this.messageHasher = new hashFunctionConstructor();
        this.blockSize = blockSize;
        this.update(this.iKeyPad);
    }
    update(data) {
        this.messageHasher.update(data);
        return this;
    }
    digest() {
        const innerHash = this.messageHasher.digest();
        return this.hash(new Uint8Array([...this.oKeyPad, ...innerHash]));
    }
}
exports.Hmac = Hmac;
//# sourceMappingURL=hmac.js.map

/***/ }),

/***/ 45027:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.stringToPath = exports.Slip10RawIndex = exports.slip10CurveFromString = exports.Slip10Curve = exports.Slip10 = exports.pathToString = exports.sha512 = exports.Sha512 = exports.sha256 = exports.Sha256 = exports.Secp256k1Signature = exports.ExtendedSecp256k1Signature = exports.Secp256k1 = exports.ripemd160 = exports.Ripemd160 = exports.Random = exports.Xchacha20poly1305Ietf = exports.xchacha20NonceLength = exports.isArgon2idOptions = exports.Ed25519Keypair = exports.Ed25519 = exports.Argon2id = exports.keccak256 = exports.Keccak256 = exports.Hmac = exports.EnglishMnemonic = exports.Bip39 = void 0;
var bip39_1 = __webpack_require__(90290);
Object.defineProperty(exports, "Bip39", ({ enumerable: true, get: function () { return bip39_1.Bip39; } }));
Object.defineProperty(exports, "EnglishMnemonic", ({ enumerable: true, get: function () { return bip39_1.EnglishMnemonic; } }));
var hmac_1 = __webpack_require__(92135);
Object.defineProperty(exports, "Hmac", ({ enumerable: true, get: function () { return hmac_1.Hmac; } }));
var keccak_1 = __webpack_require__(98896);
Object.defineProperty(exports, "Keccak256", ({ enumerable: true, get: function () { return keccak_1.Keccak256; } }));
Object.defineProperty(exports, "keccak256", ({ enumerable: true, get: function () { return keccak_1.keccak256; } }));
var libsodium_1 = __webpack_require__(78670);
Object.defineProperty(exports, "Argon2id", ({ enumerable: true, get: function () { return libsodium_1.Argon2id; } }));
Object.defineProperty(exports, "Ed25519", ({ enumerable: true, get: function () { return libsodium_1.Ed25519; } }));
Object.defineProperty(exports, "Ed25519Keypair", ({ enumerable: true, get: function () { return libsodium_1.Ed25519Keypair; } }));
Object.defineProperty(exports, "isArgon2idOptions", ({ enumerable: true, get: function () { return libsodium_1.isArgon2idOptions; } }));
Object.defineProperty(exports, "xchacha20NonceLength", ({ enumerable: true, get: function () { return libsodium_1.xchacha20NonceLength; } }));
Object.defineProperty(exports, "Xchacha20poly1305Ietf", ({ enumerable: true, get: function () { return libsodium_1.Xchacha20poly1305Ietf; } }));
var random_1 = __webpack_require__(50920);
Object.defineProperty(exports, "Random", ({ enumerable: true, get: function () { return random_1.Random; } }));
var ripemd_1 = __webpack_require__(78909);
Object.defineProperty(exports, "Ripemd160", ({ enumerable: true, get: function () { return ripemd_1.Ripemd160; } }));
Object.defineProperty(exports, "ripemd160", ({ enumerable: true, get: function () { return ripemd_1.ripemd160; } }));
var secp256k1_1 = __webpack_require__(38001);
Object.defineProperty(exports, "Secp256k1", ({ enumerable: true, get: function () { return secp256k1_1.Secp256k1; } }));
var secp256k1signature_1 = __webpack_require__(71982);
Object.defineProperty(exports, "ExtendedSecp256k1Signature", ({ enumerable: true, get: function () { return secp256k1signature_1.ExtendedSecp256k1Signature; } }));
Object.defineProperty(exports, "Secp256k1Signature", ({ enumerable: true, get: function () { return secp256k1signature_1.Secp256k1Signature; } }));
var sha_1 = __webpack_require__(83293);
Object.defineProperty(exports, "Sha256", ({ enumerable: true, get: function () { return sha_1.Sha256; } }));
Object.defineProperty(exports, "sha256", ({ enumerable: true, get: function () { return sha_1.sha256; } }));
Object.defineProperty(exports, "Sha512", ({ enumerable: true, get: function () { return sha_1.Sha512; } }));
Object.defineProperty(exports, "sha512", ({ enumerable: true, get: function () { return sha_1.sha512; } }));
var slip10_1 = __webpack_require__(47327);
Object.defineProperty(exports, "pathToString", ({ enumerable: true, get: function () { return slip10_1.pathToString; } }));
Object.defineProperty(exports, "Slip10", ({ enumerable: true, get: function () { return slip10_1.Slip10; } }));
Object.defineProperty(exports, "Slip10Curve", ({ enumerable: true, get: function () { return slip10_1.Slip10Curve; } }));
Object.defineProperty(exports, "slip10CurveFromString", ({ enumerable: true, get: function () { return slip10_1.slip10CurveFromString; } }));
Object.defineProperty(exports, "Slip10RawIndex", ({ enumerable: true, get: function () { return slip10_1.Slip10RawIndex; } }));
Object.defineProperty(exports, "stringToPath", ({ enumerable: true, get: function () { return slip10_1.stringToPath; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 98896:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.keccak256 = exports.Keccak256 = void 0;
const sha3_1 = __webpack_require__(85426);
const utils_1 = __webpack_require__(6649);
class Keccak256 {
    constructor(firstData) {
        this.blockSize = 512 / 8;
        this.impl = sha3_1.keccak_256.create();
        if (firstData) {
            this.update(firstData);
        }
    }
    update(data) {
        this.impl.update((0, utils_1.toRealUint8Array)(data));
        return this;
    }
    digest() {
        return this.impl.digest();
    }
}
exports.Keccak256 = Keccak256;
/** Convenience function equivalent to `new Keccak256(data).digest()` */
function keccak256(data) {
    return new Keccak256(data).digest();
}
exports.keccak256 = keccak256;
//# sourceMappingURL=keccak.js.map

/***/ }),

/***/ 78670:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

// Keep all classes requiring libsodium-js in one file as having multiple
// requiring of the libsodium-wrappers module currently crashes browsers
//
// libsodium.js API: https://gist.github.com/webmaster128/b2dbe6d54d36dd168c9fabf441b9b09c
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Xchacha20poly1305Ietf = exports.xchacha20NonceLength = exports.Ed25519 = exports.Ed25519Keypair = exports.Argon2id = exports.isArgon2idOptions = void 0;
const utils_1 = __webpack_require__(62584);
// Using crypto_pwhash requires sumo. Once we migrate to a standalone
// Argon2 implementation, we can use the normal libsodium-wrappers
// again: https://github.com/cosmos/cosmjs/issues/1031
const libsodium_wrappers_sumo_1 = __importDefault(__webpack_require__(98948));
function isArgon2idOptions(thing) {
    if (!(0, utils_1.isNonNullObject)(thing))
        return false;
    if (typeof thing.outputLength !== "number")
        return false;
    if (typeof thing.opsLimit !== "number")
        return false;
    if (typeof thing.memLimitKib !== "number")
        return false;
    return true;
}
exports.isArgon2idOptions = isArgon2idOptions;
class Argon2id {
    static async execute(password, salt, options) {
        await libsodium_wrappers_sumo_1.default.ready;
        return libsodium_wrappers_sumo_1.default.crypto_pwhash(options.outputLength, password, salt, // libsodium only supports 16 byte salts and will throw when you don't respect that
        options.opsLimit, options.memLimitKib * 1024, libsodium_wrappers_sumo_1.default.crypto_pwhash_ALG_ARGON2ID13);
    }
}
exports.Argon2id = Argon2id;
class Ed25519Keypair {
    // a libsodium privkey has the format `<ed25519 privkey> + <ed25519 pubkey>`
    static fromLibsodiumPrivkey(libsodiumPrivkey) {
        if (libsodiumPrivkey.length !== 64) {
            throw new Error(`Unexpected key length ${libsodiumPrivkey.length}. Must be 64.`);
        }
        return new Ed25519Keypair(libsodiumPrivkey.slice(0, 32), libsodiumPrivkey.slice(32, 64));
    }
    constructor(privkey, pubkey) {
        this.privkey = privkey;
        this.pubkey = pubkey;
    }
    toLibsodiumPrivkey() {
        return new Uint8Array([...this.privkey, ...this.pubkey]);
    }
}
exports.Ed25519Keypair = Ed25519Keypair;
class Ed25519 {
    /**
     * Generates a keypair deterministically from a given 32 bytes seed.
     *
     * This seed equals the Ed25519 private key.
     * For implementation details see crypto_sign_seed_keypair in
     * https://download.libsodium.org/doc/public-key_cryptography/public-key_signatures.html
     * and diagram on https://blog.mozilla.org/warner/2011/11/29/ed25519-keys/
     */
    static async makeKeypair(seed) {
        await libsodium_wrappers_sumo_1.default.ready;
        const keypair = libsodium_wrappers_sumo_1.default.crypto_sign_seed_keypair(seed);
        return Ed25519Keypair.fromLibsodiumPrivkey(keypair.privateKey);
    }
    static async createSignature(message, keyPair) {
        await libsodium_wrappers_sumo_1.default.ready;
        return libsodium_wrappers_sumo_1.default.crypto_sign_detached(message, keyPair.toLibsodiumPrivkey());
    }
    static async verifySignature(signature, message, pubkey) {
        await libsodium_wrappers_sumo_1.default.ready;
        return libsodium_wrappers_sumo_1.default.crypto_sign_verify_detached(signature, message, pubkey);
    }
}
exports.Ed25519 = Ed25519;
/**
 * Nonce length in bytes for all flavours of XChaCha20.
 *
 * @see https://libsodium.gitbook.io/doc/advanced/stream_ciphers/xchacha20#notes
 */
exports.xchacha20NonceLength = 24;
class Xchacha20poly1305Ietf {
    static async encrypt(message, key, nonce) {
        await libsodium_wrappers_sumo_1.default.ready;
        const additionalData = null;
        return libsodium_wrappers_sumo_1.default.crypto_aead_xchacha20poly1305_ietf_encrypt(message, additionalData, null, // secret nonce: unused and should be null (https://download.libsodium.org/doc/secret-key_cryptography/aead/chacha20-poly1305/xchacha20-poly1305_construction)
        nonce, key);
    }
    static async decrypt(ciphertext, key, nonce) {
        await libsodium_wrappers_sumo_1.default.ready;
        const additionalData = null;
        return libsodium_wrappers_sumo_1.default.crypto_aead_xchacha20poly1305_ietf_decrypt(null, // secret nonce: unused and should be null (https://download.libsodium.org/doc/secret-key_cryptography/aead/chacha20-poly1305/xchacha20-poly1305_construction)
        ciphertext, additionalData, nonce, key);
    }
}
exports.Xchacha20poly1305Ietf = Xchacha20poly1305Ietf;
//# sourceMappingURL=libsodium.js.map

/***/ }),

/***/ 20348:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.pbkdf2Sha512 = exports.pbkdf2Sha512Noble = exports.pbkdf2Sha512NodeCrypto = exports.pbkdf2Sha512Subtle = exports.getSubtle = exports.getNodeCrypto = void 0;
const utils_1 = __webpack_require__(62584);
const pbkdf2_1 = __webpack_require__(29023);
const sha512_1 = __webpack_require__(86262);
/**
 * Returns the Node.js crypto module when available and `undefined`
 * otherwise.
 *
 * Detects an unimplemented fallback module from Webpack 5 and returns
 * `undefined` in that case.
 */
async function getNodeCrypto() {
    try {
        const nodeCrypto = await Promise.resolve().then(() => __importStar(__webpack_require__(42474)));
        // We get `Object{default: Object{}}` as a fallback when using
        // `crypto: false` in Webpack 5, which we interprete as unavailable.
        if (typeof nodeCrypto === "object" && Object.keys(nodeCrypto).length <= 1) {
            return undefined;
        }
        return nodeCrypto;
    }
    catch {
        return undefined;
    }
}
exports.getNodeCrypto = getNodeCrypto;
async function getSubtle() {
    // From Node.js 15 onwards, webcrypto is available in globalThis.
    // In version 15 and 16 this was stored under the webcrypto key.
    // With Node.js 17 it was moved to the same locations where browsers
    // make it available.
    // Loading `require("crypto")` here seems unnecessary since it only
    // causes issues with bundlers and does not increase compatibility.
    // Browsers and Node.js 17+
    let subtle = globalThis?.crypto?.subtle;
    // Node.js 15+
    if (!subtle)
        subtle = globalThis?.crypto?.webcrypto?.subtle;
    return subtle;
}
exports.getSubtle = getSubtle;
async function pbkdf2Sha512Subtle(
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
subtle, secret, salt, iterations, keylen) {
    (0, utils_1.assert)(subtle, "Argument subtle is falsy");
    (0, utils_1.assert)(typeof subtle === "object", "Argument subtle is not of type object");
    (0, utils_1.assert)(typeof subtle.importKey === "function", "subtle.importKey is not a function");
    (0, utils_1.assert)(typeof subtle.deriveBits === "function", "subtle.deriveBits is not a function");
    return subtle.importKey("raw", secret, { name: "PBKDF2" }, false, ["deriveBits"]).then((key) => subtle
        .deriveBits({
        name: "PBKDF2",
        salt: salt,
        iterations: iterations,
        hash: { name: "SHA-512" },
    }, key, keylen * 8)
        .then((buffer) => new Uint8Array(buffer)));
}
exports.pbkdf2Sha512Subtle = pbkdf2Sha512Subtle;
/**
 * Implements pbkdf2-sha512 using the Node.js crypro module (`import "crypto"`).
 * This does not use subtle from [Crypto](https://developer.mozilla.org/en-US/docs/Web/API/Crypto).
 */
async function pbkdf2Sha512NodeCrypto(
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
nodeCrypto, secret, salt, iterations, keylen) {
    (0, utils_1.assert)(nodeCrypto, "Argument nodeCrypto is falsy");
    (0, utils_1.assert)(typeof nodeCrypto === "object", "Argument nodeCrypto is not of type object");
    (0, utils_1.assert)(typeof nodeCrypto.pbkdf2 === "function", "nodeCrypto.pbkdf2 is not a function");
    return new Promise((resolve, reject) => {
        nodeCrypto.pbkdf2(secret, salt, iterations, keylen, "sha512", (error, result) => {
            if (error) {
                reject(error);
            }
            else {
                resolve(Uint8Array.from(result));
            }
        });
    });
}
exports.pbkdf2Sha512NodeCrypto = pbkdf2Sha512NodeCrypto;
async function pbkdf2Sha512Noble(secret, salt, iterations, keylen) {
    return (0, pbkdf2_1.pbkdf2Async)(sha512_1.sha512, secret, salt, { c: iterations, dkLen: keylen });
}
exports.pbkdf2Sha512Noble = pbkdf2Sha512Noble;
/**
 * A pbkdf2 implementation for BIP39. This is not exported at package level and thus a private API.
 */
async function pbkdf2Sha512(secret, salt, iterations, keylen) {
    const subtle = await getSubtle();
    if (subtle) {
        return pbkdf2Sha512Subtle(subtle, secret, salt, iterations, keylen);
    }
    else {
        const nodeCrypto = await getNodeCrypto();
        if (nodeCrypto) {
            return pbkdf2Sha512NodeCrypto(nodeCrypto, secret, salt, iterations, keylen);
        }
        else {
            return pbkdf2Sha512Noble(secret, salt, iterations, keylen);
        }
    }
}
exports.pbkdf2Sha512 = pbkdf2Sha512;
//# sourceMappingURL=pbkdf2.js.map

/***/ }),

/***/ 50920:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Random = void 0;
class Random {
    /**
     * Returns `count` cryptographically secure random bytes
     */
    static getBytes(count) {
        try {
            const globalObject = typeof window === "object" ? window : self;
            const cryptoApi = typeof globalObject.crypto !== "undefined" ? globalObject.crypto : globalObject.msCrypto;
            const out = new Uint8Array(count);
            cryptoApi.getRandomValues(out);
            return out;
        }
        catch {
            try {
                // eslint-disable-next-line @typescript-eslint/no-var-requires
                const crypto = __webpack_require__(42474);
                return new Uint8Array([...crypto.randomBytes(count)]);
            }
            catch {
                throw new Error("No secure random number generator found");
            }
        }
    }
}
exports.Random = Random;
//# sourceMappingURL=random.js.map

/***/ }),

/***/ 78909:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ripemd160 = exports.Ripemd160 = void 0;
const ripemd160_1 = __webpack_require__(70830);
const utils_1 = __webpack_require__(6649);
class Ripemd160 {
    constructor(firstData) {
        this.blockSize = 512 / 8;
        this.impl = ripemd160_1.ripemd160.create();
        if (firstData) {
            this.update(firstData);
        }
    }
    update(data) {
        this.impl.update((0, utils_1.toRealUint8Array)(data));
        return this;
    }
    digest() {
        return this.impl.digest();
    }
}
exports.Ripemd160 = Ripemd160;
/** Convenience function equivalent to `new Ripemd160(data).digest()` */
function ripemd160(data) {
    return new Ripemd160(data).digest();
}
exports.ripemd160 = ripemd160;
//# sourceMappingURL=ripemd.js.map

/***/ }),

/***/ 38001:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Secp256k1 = void 0;
const encoding_1 = __webpack_require__(87061);
const bn_js_1 = __importDefault(__webpack_require__(13550));
const elliptic_1 = __importDefault(__webpack_require__(86266));
const secp256k1signature_1 = __webpack_require__(71982);
const secp256k1 = new elliptic_1.default.ec("secp256k1");
const secp256k1N = new bn_js_1.default("FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEBAAEDCE6AF48A03BBFD25E8CD0364141", "hex");
class Secp256k1 {
    /**
     * Takes a 32 byte private key and returns a privkey/pubkey pair.
     *
     * The resulting pubkey is uncompressed. For the use in Cosmos it should
     * be compressed first using `Secp256k1.compressPubkey`.
     */
    static async makeKeypair(privkey) {
        if (privkey.length !== 32) {
            // is this check missing in secp256k1.validatePrivateKey?
            // https://github.com/bitjson/bitcoin-ts/issues/4
            throw new Error("input data is not a valid secp256k1 private key");
        }
        const keypair = secp256k1.keyFromPrivate(privkey);
        if (keypair.validate().result !== true) {
            throw new Error("input data is not a valid secp256k1 private key");
        }
        // range test that is not part of the elliptic implementation
        const privkeyAsBigInteger = new bn_js_1.default(privkey);
        if (privkeyAsBigInteger.gte(secp256k1N)) {
            // not strictly smaller than N
            throw new Error("input data is not a valid secp256k1 private key");
        }
        const out = {
            privkey: (0, encoding_1.fromHex)(keypair.getPrivate("hex")),
            // encodes uncompressed as
            // - 1-byte prefix "04"
            // - 32-byte x coordinate
            // - 32-byte y coordinate
            pubkey: Uint8Array.from(keypair.getPublic("array")),
        };
        return out;
    }
    /**
     * Creates a signature that is
     * - deterministic (RFC 6979)
     * - lowS signature
     * - DER encoded
     */
    static async createSignature(messageHash, privkey) {
        if (messageHash.length === 0) {
            throw new Error("Message hash must not be empty");
        }
        if (messageHash.length > 32) {
            throw new Error("Message hash length must not exceed 32 bytes");
        }
        const keypair = secp256k1.keyFromPrivate(privkey);
        // the `canonical` option ensures creation of lowS signature representations
        const { r, s, recoveryParam } = keypair.sign(messageHash, { canonical: true });
        if (typeof recoveryParam !== "number")
            throw new Error("Recovery param missing");
        return new secp256k1signature_1.ExtendedSecp256k1Signature(Uint8Array.from(r.toArray()), Uint8Array.from(s.toArray()), recoveryParam);
    }
    static async verifySignature(signature, messageHash, pubkey) {
        if (messageHash.length === 0) {
            throw new Error("Message hash must not be empty");
        }
        if (messageHash.length > 32) {
            throw new Error("Message hash length must not exceed 32 bytes");
        }
        const keypair = secp256k1.keyFromPublic(pubkey);
        // From https://github.com/indutny/elliptic:
        //
        //     Sign the message's hash (input must be an array, or a hex-string)
        //
        //     Signature MUST be either:
        //     1) DER-encoded signature as hex-string; or
        //     2) DER-encoded signature as buffer; or
        //     3) object with two hex-string properties (r and s); or
        //     4) object with two buffer properties (r and s)
        //
        // Uint8Array is not a Buffer, but elliptic seems to be happy with the interface
        // common to both types. Uint8Array is not an array of ints but the interface is
        // similar
        try {
            return keypair.verify(messageHash, signature.toDer());
        }
        catch (error) {
            return false;
        }
    }
    static recoverPubkey(signature, messageHash) {
        const signatureForElliptic = { r: (0, encoding_1.toHex)(signature.r()), s: (0, encoding_1.toHex)(signature.s()) };
        const point = secp256k1.recoverPubKey(messageHash, signatureForElliptic, signature.recovery);
        const keypair = secp256k1.keyFromPublic(point);
        return (0, encoding_1.fromHex)(keypair.getPublic(false, "hex"));
    }
    /**
     * Takes a compressed or uncompressed pubkey and return a compressed one.
     *
     * This function is idempotent.
     */
    static compressPubkey(pubkey) {
        switch (pubkey.length) {
            case 33:
                return pubkey;
            case 65:
                return Uint8Array.from(secp256k1.keyFromPublic(pubkey).getPublic(true, "array"));
            default:
                throw new Error("Invalid pubkey length");
        }
    }
    /**
     * Takes a compressed or uncompressed pubkey and returns an uncompressed one.
     *
     * This function is idempotent.
     */
    static uncompressPubkey(pubkey) {
        switch (pubkey.length) {
            case 33:
                return Uint8Array.from(secp256k1.keyFromPublic(pubkey).getPublic(false, "array"));
            case 65:
                return pubkey;
            default:
                throw new Error("Invalid pubkey length");
        }
    }
    static trimRecoveryByte(signature) {
        switch (signature.length) {
            case 64:
                return signature;
            case 65:
                return signature.slice(0, 64);
            default:
                throw new Error("Invalid signature length");
        }
    }
}
exports.Secp256k1 = Secp256k1;
//# sourceMappingURL=secp256k1.js.map

/***/ }),

/***/ 71982:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ExtendedSecp256k1Signature = exports.Secp256k1Signature = void 0;
function trimLeadingNullBytes(inData) {
    let numberOfLeadingNullBytes = 0;
    for (const byte of inData) {
        if (byte === 0x00) {
            numberOfLeadingNullBytes++;
        }
        else {
            break;
        }
    }
    return inData.slice(numberOfLeadingNullBytes);
}
const derTagInteger = 0x02;
class Secp256k1Signature {
    /**
     * Takes the pair of integers (r, s) as 2x32 byte of binary data.
     *
     * Note: This is the format Cosmos SDK uses natively.
     *
     * @param data a 64 byte value containing integers r and s.
     */
    static fromFixedLength(data) {
        if (data.length !== 64) {
            throw new Error(`Got invalid data length: ${data.length}. Expected 2x 32 bytes for the pair (r, s)`);
        }
        return new Secp256k1Signature(trimLeadingNullBytes(data.slice(0, 32)), trimLeadingNullBytes(data.slice(32, 64)));
    }
    static fromDer(data) {
        let pos = 0;
        if (data[pos++] !== 0x30) {
            throw new Error("Prefix 0x30 expected");
        }
        const bodyLength = data[pos++];
        if (data.length - pos !== bodyLength) {
            throw new Error("Data length mismatch detected");
        }
        // r
        const rTag = data[pos++];
        if (rTag !== derTagInteger) {
            throw new Error("INTEGER tag expected");
        }
        const rLength = data[pos++];
        if (rLength >= 0x80) {
            throw new Error("Decoding length values above 127 not supported");
        }
        const rData = data.slice(pos, pos + rLength);
        pos += rLength;
        // s
        const sTag = data[pos++];
        if (sTag !== derTagInteger) {
            throw new Error("INTEGER tag expected");
        }
        const sLength = data[pos++];
        if (sLength >= 0x80) {
            throw new Error("Decoding length values above 127 not supported");
        }
        const sData = data.slice(pos, pos + sLength);
        pos += sLength;
        return new Secp256k1Signature(
        // r/s data can contain leading 0 bytes to express integers being non-negative in DER
        trimLeadingNullBytes(rData), trimLeadingNullBytes(sData));
    }
    constructor(r, s) {
        if (r.length > 32 || r.length === 0 || r[0] === 0x00) {
            throw new Error("Unsigned integer r must be encoded as unpadded big endian.");
        }
        if (s.length > 32 || s.length === 0 || s[0] === 0x00) {
            throw new Error("Unsigned integer s must be encoded as unpadded big endian.");
        }
        this.data = {
            r: r,
            s: s,
        };
    }
    r(length) {
        if (length === undefined) {
            return this.data.r;
        }
        else {
            const paddingLength = length - this.data.r.length;
            if (paddingLength < 0) {
                throw new Error("Length too small to hold parameter r");
            }
            const padding = new Uint8Array(paddingLength);
            return new Uint8Array([...padding, ...this.data.r]);
        }
    }
    s(length) {
        if (length === undefined) {
            return this.data.s;
        }
        else {
            const paddingLength = length - this.data.s.length;
            if (paddingLength < 0) {
                throw new Error("Length too small to hold parameter s");
            }
            const padding = new Uint8Array(paddingLength);
            return new Uint8Array([...padding, ...this.data.s]);
        }
    }
    toFixedLength() {
        return new Uint8Array([...this.r(32), ...this.s(32)]);
    }
    toDer() {
        // DER supports negative integers but our data is unsigned. Thus we need to prepend
        // a leading 0 byte when the higest bit is set to differentiate nagative values
        const rEncoded = this.data.r[0] >= 0x80 ? new Uint8Array([0, ...this.data.r]) : this.data.r;
        const sEncoded = this.data.s[0] >= 0x80 ? new Uint8Array([0, ...this.data.s]) : this.data.s;
        const rLength = rEncoded.length;
        const sLength = sEncoded.length;
        const data = new Uint8Array([derTagInteger, rLength, ...rEncoded, derTagInteger, sLength, ...sEncoded]);
        return new Uint8Array([0x30, data.length, ...data]);
    }
}
exports.Secp256k1Signature = Secp256k1Signature;
/**
 * A Secp256k1Signature plus the recovery parameter
 */
class ExtendedSecp256k1Signature extends Secp256k1Signature {
    /**
     * Decode extended signature from the simple fixed length encoding
     * described in toFixedLength().
     */
    static fromFixedLength(data) {
        if (data.length !== 65) {
            throw new Error(`Got invalid data length ${data.length}. Expected 32 + 32 + 1`);
        }
        return new ExtendedSecp256k1Signature(trimLeadingNullBytes(data.slice(0, 32)), trimLeadingNullBytes(data.slice(32, 64)), data[64]);
    }
    constructor(r, s, recovery) {
        super(r, s);
        if (!Number.isInteger(recovery)) {
            throw new Error("The recovery parameter must be an integer.");
        }
        if (recovery < 0 || recovery > 4) {
            throw new Error("The recovery parameter must be one of 0, 1, 2, 3.");
        }
        this.recovery = recovery;
    }
    /**
     * A simple custom encoding that encodes the extended signature as
     * r (32 bytes) | s (32 bytes) | recovery param (1 byte)
     * where | denotes concatenation of bonary data.
     */
    toFixedLength() {
        return new Uint8Array([...this.r(32), ...this.s(32), this.recovery]);
    }
}
exports.ExtendedSecp256k1Signature = ExtendedSecp256k1Signature;
//# sourceMappingURL=secp256k1signature.js.map

/***/ }),

/***/ 83293:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.sha512 = exports.Sha512 = exports.sha256 = exports.Sha256 = void 0;
const sha256_1 = __webpack_require__(23061);
const sha512_1 = __webpack_require__(86262);
const utils_1 = __webpack_require__(6649);
class Sha256 {
    constructor(firstData) {
        this.blockSize = 512 / 8;
        this.impl = sha256_1.sha256.create();
        if (firstData) {
            this.update(firstData);
        }
    }
    update(data) {
        this.impl.update((0, utils_1.toRealUint8Array)(data));
        return this;
    }
    digest() {
        return this.impl.digest();
    }
}
exports.Sha256 = Sha256;
/** Convenience function equivalent to `new Sha256(data).digest()` */
function sha256(data) {
    return new Sha256(data).digest();
}
exports.sha256 = sha256;
class Sha512 {
    constructor(firstData) {
        this.blockSize = 1024 / 8;
        this.impl = sha512_1.sha512.create();
        if (firstData) {
            this.update(firstData);
        }
    }
    update(data) {
        this.impl.update((0, utils_1.toRealUint8Array)(data));
        return this;
    }
    digest() {
        return this.impl.digest();
    }
}
exports.Sha512 = Sha512;
/** Convenience function equivalent to `new Sha512(data).digest()` */
function sha512(data) {
    return new Sha512(data).digest();
}
exports.sha512 = sha512;
//# sourceMappingURL=sha.js.map

/***/ }),

/***/ 47327:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.stringToPath = exports.pathToString = exports.Slip10 = exports.Slip10RawIndex = exports.slip10CurveFromString = exports.Slip10Curve = void 0;
const encoding_1 = __webpack_require__(87061);
const math_1 = __webpack_require__(66021);
const bn_js_1 = __importDefault(__webpack_require__(13550));
const elliptic_1 = __importDefault(__webpack_require__(86266));
const hmac_1 = __webpack_require__(92135);
const sha_1 = __webpack_require__(83293);
/**
 * Raw values must match the curve string in SLIP-0010 master key generation
 *
 * @see https://github.com/satoshilabs/slips/blob/master/slip-0010.md#master-key-generation
 */
var Slip10Curve;
(function (Slip10Curve) {
    Slip10Curve["Secp256k1"] = "Bitcoin seed";
    Slip10Curve["Ed25519"] = "ed25519 seed";
})(Slip10Curve = exports.Slip10Curve || (exports.Slip10Curve = {}));
/**
 * Reverse mapping of Slip10Curve
 */
function slip10CurveFromString(curveString) {
    switch (curveString) {
        case Slip10Curve.Ed25519:
            return Slip10Curve.Ed25519;
        case Slip10Curve.Secp256k1:
            return Slip10Curve.Secp256k1;
        default:
            throw new Error(`Unknown curve string: '${curveString}'`);
    }
}
exports.slip10CurveFromString = slip10CurveFromString;
class Slip10RawIndex extends math_1.Uint32 {
    static hardened(hardenedIndex) {
        return new Slip10RawIndex(hardenedIndex + 2 ** 31);
    }
    static normal(normalIndex) {
        return new Slip10RawIndex(normalIndex);
    }
    isHardened() {
        return this.data >= 2 ** 31;
    }
}
exports.Slip10RawIndex = Slip10RawIndex;
const secp256k1 = new elliptic_1.default.ec("secp256k1");
// Universal private key derivation accoring to
// https://github.com/satoshilabs/slips/blob/master/slip-0010.md
class Slip10 {
    static derivePath(curve, seed, path) {
        let result = this.master(curve, seed);
        for (const rawIndex of path) {
            result = this.child(curve, result.privkey, result.chainCode, rawIndex);
        }
        return result;
    }
    static master(curve, seed) {
        const i = new hmac_1.Hmac(sha_1.Sha512, (0, encoding_1.toAscii)(curve)).update(seed).digest();
        const il = i.slice(0, 32);
        const ir = i.slice(32, 64);
        if (curve !== Slip10Curve.Ed25519 && (this.isZero(il) || this.isGteN(curve, il))) {
            return this.master(curve, i);
        }
        return {
            chainCode: ir,
            privkey: il,
        };
    }
    static child(curve, parentPrivkey, parentChainCode, rawIndex) {
        let i;
        if (rawIndex.isHardened()) {
            const payload = new Uint8Array([0x00, ...parentPrivkey, ...rawIndex.toBytesBigEndian()]);
            i = new hmac_1.Hmac(sha_1.Sha512, parentChainCode).update(payload).digest();
        }
        else {
            if (curve === Slip10Curve.Ed25519) {
                throw new Error("Normal keys are not allowed with ed25519");
            }
            else {
                // Step 1 of https://github.com/satoshilabs/slips/blob/master/slip-0010.md#private-parent-key--private-child-key
                // Calculate I = HMAC-SHA512(Key = c_par, Data = ser_P(point(k_par)) || ser_32(i)).
                // where the functions point() and ser_p() are defined in BIP-0032
                const data = new Uint8Array([
                    ...Slip10.serializedPoint(curve, new bn_js_1.default(parentPrivkey)),
                    ...rawIndex.toBytesBigEndian(),
                ]);
                i = new hmac_1.Hmac(sha_1.Sha512, parentChainCode).update(data).digest();
            }
        }
        return this.childImpl(curve, parentPrivkey, parentChainCode, rawIndex, i);
    }
    /**
     * Implementation of ser_P(point(k_par)) from BIP-0032
     *
     * @see https://github.com/bitcoin/bips/blob/master/bip-0032.mediawiki
     */
    static serializedPoint(curve, p) {
        switch (curve) {
            case Slip10Curve.Secp256k1:
                return (0, encoding_1.fromHex)(secp256k1.g.mul(p).encodeCompressed("hex"));
            default:
                throw new Error("curve not supported");
        }
    }
    static childImpl(curve, parentPrivkey, parentChainCode, rawIndex, i) {
        // step 2 (of the Private parent key → private child key algorithm)
        const il = i.slice(0, 32);
        const ir = i.slice(32, 64);
        // step 3
        const returnChainCode = ir;
        // step 4
        if (curve === Slip10Curve.Ed25519) {
            return {
                chainCode: returnChainCode,
                privkey: il,
            };
        }
        // step 5
        const n = this.n(curve);
        const returnChildKeyAsNumber = new bn_js_1.default(il).add(new bn_js_1.default(parentPrivkey)).mod(n);
        const returnChildKey = Uint8Array.from(returnChildKeyAsNumber.toArray("be", 32));
        // step 6
        if (this.isGteN(curve, il) || this.isZero(returnChildKey)) {
            const newI = new hmac_1.Hmac(sha_1.Sha512, parentChainCode)
                .update(new Uint8Array([0x01, ...ir, ...rawIndex.toBytesBigEndian()]))
                .digest();
            return this.childImpl(curve, parentPrivkey, parentChainCode, rawIndex, newI);
        }
        // step 7
        return {
            chainCode: returnChainCode,
            privkey: returnChildKey,
        };
    }
    static isZero(privkey) {
        return privkey.every((byte) => byte === 0);
    }
    static isGteN(curve, privkey) {
        const keyAsNumber = new bn_js_1.default(privkey);
        return keyAsNumber.gte(this.n(curve));
    }
    static n(curve) {
        switch (curve) {
            case Slip10Curve.Secp256k1:
                return new bn_js_1.default("FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEBAAEDCE6AF48A03BBFD25E8CD0364141", 16);
            default:
                throw new Error("curve not supported");
        }
    }
}
exports.Slip10 = Slip10;
function pathToString(path) {
    return path.reduce((current, component) => {
        const componentString = component.isHardened()
            ? `${component.toNumber() - 2 ** 31}'`
            : component.toString();
        return current + "/" + componentString;
    }, "m");
}
exports.pathToString = pathToString;
function stringToPath(input) {
    if (!input.startsWith("m"))
        throw new Error("Path string must start with 'm'");
    let rest = input.slice(1);
    const out = new Array();
    while (rest) {
        const match = rest.match(/^\/([0-9]+)('?)/);
        if (!match)
            throw new Error("Syntax error while reading path component");
        const [fullMatch, numberString, apostrophe] = match;
        const value = math_1.Uint53.fromString(numberString).toNumber();
        if (value >= 2 ** 31)
            throw new Error("Component value too high. Must not exceed 2**31-1.");
        if (apostrophe)
            out.push(Slip10RawIndex.hardened(value));
        else
            out.push(Slip10RawIndex.normal(value));
        rest = rest.slice(fullMatch.length);
    }
    return out;
}
exports.stringToPath = stringToPath;
//# sourceMappingURL=slip10.js.map

/***/ }),

/***/ 6649:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.toRealUint8Array = void 0;
// See https://github.com/paulmillr/noble-hashes/issues/25 for why this is needed
function toRealUint8Array(data) {
    if (data instanceof Uint8Array)
        return data;
    else
        return Uint8Array.from(data);
}
exports.toRealUint8Array = toRealUint8Array;
//# sourceMappingURL=utils.js.map

/***/ }),

/***/ 14157:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.fromAscii = exports.toAscii = void 0;
function toAscii(input) {
    const toNums = (str) => str.split("").map((x) => {
        const charCode = x.charCodeAt(0);
        // 0x00–0x1F control characters
        // 0x20–0x7E printable characters
        // 0x7F delete character
        // 0x80–0xFF out of 7 bit ascii range
        if (charCode < 0x20 || charCode > 0x7e) {
            throw new Error("Cannot encode character that is out of printable ASCII range: " + charCode);
        }
        return charCode;
    });
    return Uint8Array.from(toNums(input));
}
exports.toAscii = toAscii;
function fromAscii(data) {
    const fromNums = (listOfNumbers) => listOfNumbers.map((x) => {
        // 0x00–0x1F control characters
        // 0x20–0x7E printable characters
        // 0x7F delete character
        // 0x80–0xFF out of 7 bit ascii range
        if (x < 0x20 || x > 0x7e) {
            throw new Error("Cannot decode character that is out of printable ASCII range: " + x);
        }
        return String.fromCharCode(x);
    });
    return fromNums(Array.from(data)).join("");
}
exports.fromAscii = fromAscii;
//# sourceMappingURL=ascii.js.map

/***/ }),

/***/ 12849:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.fromBase64 = exports.toBase64 = void 0;
const base64js = __importStar(__webpack_require__(79742));
function toBase64(data) {
    return base64js.fromByteArray(data);
}
exports.toBase64 = toBase64;
function fromBase64(base64String) {
    if (!base64String.match(/^[a-zA-Z0-9+/]*={0,2}$/)) {
        throw new Error("Invalid base64 string format");
    }
    return base64js.toByteArray(base64String);
}
exports.fromBase64 = fromBase64;
//# sourceMappingURL=base64.js.map

/***/ }),

/***/ 74289:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.normalizeBech32 = exports.fromBech32 = exports.toBech32 = void 0;
const bech32 = __importStar(__webpack_require__(64738));
function toBech32(prefix, data, limit) {
    const address = bech32.encode(prefix, bech32.toWords(data), limit);
    return address;
}
exports.toBech32 = toBech32;
function fromBech32(address, limit = Infinity) {
    const decodedAddress = bech32.decode(address, limit);
    return {
        prefix: decodedAddress.prefix,
        data: new Uint8Array(bech32.fromWords(decodedAddress.words)),
    };
}
exports.fromBech32 = fromBech32;
/**
 * Takes a bech32 address and returns a normalized (i.e. lower case) representation of it.
 *
 * The input is validated along the way, which makes this significantly safer than
 * using `address.toLowerCase()`.
 */
function normalizeBech32(address) {
    const { prefix, data } = fromBech32(address);
    return toBech32(prefix, data);
}
exports.normalizeBech32 = normalizeBech32;
//# sourceMappingURL=bech32.js.map

/***/ }),

/***/ 20889:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.fromHex = exports.toHex = void 0;
function toHex(data) {
    let out = "";
    for (const byte of data) {
        out += ("0" + byte.toString(16)).slice(-2);
    }
    return out;
}
exports.toHex = toHex;
function fromHex(hexstring) {
    if (hexstring.length % 2 !== 0) {
        throw new Error("hex string length must be a multiple of 2");
    }
    const out = new Uint8Array(hexstring.length / 2);
    for (let i = 0; i < out.length; i++) {
        const j = 2 * i;
        const hexByteAsString = hexstring.slice(j, j + 2);
        if (!hexByteAsString.match(/[0-9a-f]{2}/i)) {
            throw new Error("hex string contains invalid characters");
        }
        out[i] = parseInt(hexByteAsString, 16);
    }
    return out;
}
exports.fromHex = fromHex;
//# sourceMappingURL=hex.js.map

/***/ }),

/***/ 87061:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.toUtf8 = exports.fromUtf8 = exports.toRfc3339 = exports.fromRfc3339 = exports.toHex = exports.fromHex = exports.toBech32 = exports.normalizeBech32 = exports.fromBech32 = exports.toBase64 = exports.fromBase64 = exports.toAscii = exports.fromAscii = void 0;
var ascii_1 = __webpack_require__(14157);
Object.defineProperty(exports, "fromAscii", ({ enumerable: true, get: function () { return ascii_1.fromAscii; } }));
Object.defineProperty(exports, "toAscii", ({ enumerable: true, get: function () { return ascii_1.toAscii; } }));
var base64_1 = __webpack_require__(12849);
Object.defineProperty(exports, "fromBase64", ({ enumerable: true, get: function () { return base64_1.fromBase64; } }));
Object.defineProperty(exports, "toBase64", ({ enumerable: true, get: function () { return base64_1.toBase64; } }));
var bech32_1 = __webpack_require__(74289);
Object.defineProperty(exports, "fromBech32", ({ enumerable: true, get: function () { return bech32_1.fromBech32; } }));
Object.defineProperty(exports, "normalizeBech32", ({ enumerable: true, get: function () { return bech32_1.normalizeBech32; } }));
Object.defineProperty(exports, "toBech32", ({ enumerable: true, get: function () { return bech32_1.toBech32; } }));
var hex_1 = __webpack_require__(20889);
Object.defineProperty(exports, "fromHex", ({ enumerable: true, get: function () { return hex_1.fromHex; } }));
Object.defineProperty(exports, "toHex", ({ enumerable: true, get: function () { return hex_1.toHex; } }));
var rfc3339_1 = __webpack_require__(2668);
Object.defineProperty(exports, "fromRfc3339", ({ enumerable: true, get: function () { return rfc3339_1.fromRfc3339; } }));
Object.defineProperty(exports, "toRfc3339", ({ enumerable: true, get: function () { return rfc3339_1.toRfc3339; } }));
var utf8_1 = __webpack_require__(58249);
Object.defineProperty(exports, "fromUtf8", ({ enumerable: true, get: function () { return utf8_1.fromUtf8; } }));
Object.defineProperty(exports, "toUtf8", ({ enumerable: true, get: function () { return utf8_1.toUtf8; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 2668:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.toRfc3339 = exports.fromRfc3339 = void 0;
const rfc3339Matcher = /^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2}):(\d{2})(\.\d{1,9})?((?:[+-]\d{2}:\d{2})|Z)$/;
function padded(integer, length = 2) {
    return integer.toString().padStart(length, "0");
}
function fromRfc3339(str) {
    const matches = rfc3339Matcher.exec(str);
    if (!matches) {
        throw new Error("Date string is not in RFC3339 format");
    }
    const year = +matches[1];
    const month = +matches[2];
    const day = +matches[3];
    const hour = +matches[4];
    const minute = +matches[5];
    const second = +matches[6];
    // fractional seconds match either undefined or a string like ".1", ".123456789"
    const milliSeconds = matches[7] ? Math.floor(+matches[7] * 1000) : 0;
    let tzOffsetSign;
    let tzOffsetHours;
    let tzOffsetMinutes;
    // if timezone is undefined, it must be Z or nothing (otherwise the group would have captured).
    if (matches[8] === "Z") {
        tzOffsetSign = 1;
        tzOffsetHours = 0;
        tzOffsetMinutes = 0;
    }
    else {
        tzOffsetSign = matches[8].substring(0, 1) === "-" ? -1 : 1;
        tzOffsetHours = +matches[8].substring(1, 3);
        tzOffsetMinutes = +matches[8].substring(4, 6);
    }
    const tzOffset = tzOffsetSign * (tzOffsetHours * 60 + tzOffsetMinutes) * 60; // seconds
    const timestamp = Date.UTC(year, month - 1, day, hour, minute, second, milliSeconds) - tzOffset * 1000;
    return new Date(timestamp);
}
exports.fromRfc3339 = fromRfc3339;
function toRfc3339(date) {
    const year = date.getUTCFullYear();
    const month = padded(date.getUTCMonth() + 1);
    const day = padded(date.getUTCDate());
    const hour = padded(date.getUTCHours());
    const minute = padded(date.getUTCMinutes());
    const second = padded(date.getUTCSeconds());
    const ms = padded(date.getUTCMilliseconds(), 3);
    return `${year}-${month}-${day}T${hour}:${minute}:${second}.${ms}Z`;
}
exports.toRfc3339 = toRfc3339;
//# sourceMappingURL=rfc3339.js.map

/***/ }),

/***/ 58249:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.fromUtf8 = exports.toUtf8 = void 0;
function toUtf8(str) {
    return new TextEncoder().encode(str);
}
exports.toUtf8 = toUtf8;
/**
 * Takes UTF-8 data and decodes it to a string.
 *
 * In lossy mode, the replacement character � is used to substitude invalid
 * encodings. By default lossy mode is off and invalid data will lead to exceptions.
 */
function fromUtf8(data, lossy = false) {
    const fatal = !lossy;
    return new TextDecoder("utf-8", { fatal }).decode(data);
}
exports.fromUtf8 = fromUtf8;
//# sourceMappingURL=utf8.js.map

/***/ }),

/***/ 64593:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.isJsonCompatibleDictionary = exports.isJsonCompatibleArray = exports.isJsonCompatibleValue = void 0;
function isJsonCompatibleValue(value) {
    if (typeof value === "string" ||
        typeof value === "number" ||
        typeof value === "boolean" ||
        value === null ||
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        isJsonCompatibleArray(value) ||
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        isJsonCompatibleDictionary(value)) {
        return true;
    }
    else {
        return false;
    }
}
exports.isJsonCompatibleValue = isJsonCompatibleValue;
function isJsonCompatibleArray(value) {
    if (!Array.isArray(value)) {
        return false;
    }
    for (const item of value) {
        if (!isJsonCompatibleValue(item)) {
            return false;
        }
    }
    // all items okay
    return true;
}
exports.isJsonCompatibleArray = isJsonCompatibleArray;
function isJsonCompatibleDictionary(data) {
    if (typeof data !== "object" || data === null) {
        // data must be a non-null object
        return false;
    }
    // Exclude special kind of objects like Array, Date or Uint8Array
    // Object.prototype.toString() returns a specified value:
    // http://www.ecma-international.org/ecma-262/7.0/index.html#sec-object.prototype.tostring
    if (Object.prototype.toString.call(data) !== "[object Object]") {
        return false;
    }
    return Object.values(data).every(isJsonCompatibleValue);
}
exports.isJsonCompatibleDictionary = isJsonCompatibleDictionary;
//# sourceMappingURL=compatibility.js.map

/***/ }),

/***/ 93596:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.makeJsonRpcId = void 0;
// Start with 10001 to avoid possible collisions with all hand-selected values like e.g. 1,2,3,42,100
let counter = 10000;
/**
 * Creates a new ID to be used for creating a JSON-RPC request.
 *
 * Multiple calls of this produce unique values.
 *
 * The output may be any value compatible to JSON-RPC request IDs with an undefined output format and generation logic.
 */
function makeJsonRpcId() {
    return (counter += 1);
}
exports.makeJsonRpcId = makeJsonRpcId;
//# sourceMappingURL=id.js.map

/***/ }),

/***/ 59606:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.jsonRpcCode = exports.isJsonRpcSuccessResponse = exports.isJsonRpcErrorResponse = exports.parseJsonRpcSuccessResponse = exports.parseJsonRpcResponse = exports.parseJsonRpcRequest = exports.parseJsonRpcId = exports.parseJsonRpcErrorResponse = exports.JsonRpcClient = exports.makeJsonRpcId = void 0;
var id_1 = __webpack_require__(93596);
Object.defineProperty(exports, "makeJsonRpcId", ({ enumerable: true, get: function () { return id_1.makeJsonRpcId; } }));
var jsonrpcclient_1 = __webpack_require__(2147);
Object.defineProperty(exports, "JsonRpcClient", ({ enumerable: true, get: function () { return jsonrpcclient_1.JsonRpcClient; } }));
var parse_1 = __webpack_require__(67553);
Object.defineProperty(exports, "parseJsonRpcErrorResponse", ({ enumerable: true, get: function () { return parse_1.parseJsonRpcErrorResponse; } }));
Object.defineProperty(exports, "parseJsonRpcId", ({ enumerable: true, get: function () { return parse_1.parseJsonRpcId; } }));
Object.defineProperty(exports, "parseJsonRpcRequest", ({ enumerable: true, get: function () { return parse_1.parseJsonRpcRequest; } }));
Object.defineProperty(exports, "parseJsonRpcResponse", ({ enumerable: true, get: function () { return parse_1.parseJsonRpcResponse; } }));
Object.defineProperty(exports, "parseJsonRpcSuccessResponse", ({ enumerable: true, get: function () { return parse_1.parseJsonRpcSuccessResponse; } }));
var types_1 = __webpack_require__(41947);
Object.defineProperty(exports, "isJsonRpcErrorResponse", ({ enumerable: true, get: function () { return types_1.isJsonRpcErrorResponse; } }));
Object.defineProperty(exports, "isJsonRpcSuccessResponse", ({ enumerable: true, get: function () { return types_1.isJsonRpcSuccessResponse; } }));
Object.defineProperty(exports, "jsonRpcCode", ({ enumerable: true, get: function () { return types_1.jsonRpcCode; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 2147:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.JsonRpcClient = void 0;
const stream_1 = __webpack_require__(2464);
const types_1 = __webpack_require__(41947);
/**
 * A thin wrapper that is used to bring together requests and responses by ID.
 *
 * Using this class is only advised for continous communication channels like
 * WebSockets or WebWorker messaging.
 */
class JsonRpcClient {
    constructor(connection) {
        this.connection = connection;
    }
    async run(request) {
        const filteredStream = this.connection.responseStream.filter((r) => r.id === request.id);
        const pendingResponses = (0, stream_1.firstEvent)(filteredStream);
        this.connection.sendRequest(request);
        const response = await pendingResponses;
        if ((0, types_1.isJsonRpcErrorResponse)(response)) {
            const error = response.error;
            throw new Error(`JSON RPC error: code=${error.code}; message='${error.message}'`);
        }
        return response;
    }
}
exports.JsonRpcClient = JsonRpcClient;
//# sourceMappingURL=jsonrpcclient.js.map

/***/ }),

/***/ 67553:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.parseJsonRpcResponse = exports.parseJsonRpcSuccessResponse = exports.parseJsonRpcErrorResponse = exports.parseJsonRpcRequest = exports.parseJsonRpcId = void 0;
const compatibility_1 = __webpack_require__(64593);
/**
 * Extracts ID field from request or response object.
 *
 * Returns `null` when no valid ID was found.
 */
function parseJsonRpcId(data) {
    if (!(0, compatibility_1.isJsonCompatibleDictionary)(data)) {
        throw new Error("Data must be JSON compatible dictionary");
    }
    const id = data.id;
    if (typeof id !== "number" && typeof id !== "string") {
        return null;
    }
    return id;
}
exports.parseJsonRpcId = parseJsonRpcId;
function parseJsonRpcRequest(data) {
    if (!(0, compatibility_1.isJsonCompatibleDictionary)(data)) {
        throw new Error("Data must be JSON compatible dictionary");
    }
    if (data.jsonrpc !== "2.0") {
        throw new Error(`Got unexpected jsonrpc version: ${data.jsonrpc}`);
    }
    const id = parseJsonRpcId(data);
    if (id === null) {
        throw new Error("Invalid id field");
    }
    const method = data.method;
    if (typeof method !== "string") {
        throw new Error("Invalid method field");
    }
    if (!(0, compatibility_1.isJsonCompatibleArray)(data.params) && !(0, compatibility_1.isJsonCompatibleDictionary)(data.params)) {
        throw new Error("Invalid params field");
    }
    return {
        jsonrpc: "2.0",
        id: id,
        method: method,
        params: data.params,
    };
}
exports.parseJsonRpcRequest = parseJsonRpcRequest;
function parseError(error) {
    if (typeof error.code !== "number") {
        throw new Error("Error property 'code' is not a number");
    }
    if (typeof error.message !== "string") {
        throw new Error("Error property 'message' is not a string");
    }
    let maybeUndefinedData;
    if (error.data === undefined) {
        maybeUndefinedData = undefined;
    }
    else if ((0, compatibility_1.isJsonCompatibleValue)(error.data)) {
        maybeUndefinedData = error.data;
    }
    else {
        throw new Error("Error property 'data' is defined but not a JSON compatible value.");
    }
    return {
        code: error.code,
        message: error.message,
        ...(maybeUndefinedData !== undefined ? { data: maybeUndefinedData } : {}),
    };
}
/** Throws if data is not a JsonRpcErrorResponse */
function parseJsonRpcErrorResponse(data) {
    if (!(0, compatibility_1.isJsonCompatibleDictionary)(data)) {
        throw new Error("Data must be JSON compatible dictionary");
    }
    if (data.jsonrpc !== "2.0") {
        throw new Error(`Got unexpected jsonrpc version: ${JSON.stringify(data)}`);
    }
    const id = data.id;
    if (typeof id !== "number" && typeof id !== "string" && id !== null) {
        throw new Error("Invalid id field");
    }
    if (typeof data.error === "undefined" || !(0, compatibility_1.isJsonCompatibleDictionary)(data.error)) {
        throw new Error("Invalid error field");
    }
    return {
        jsonrpc: "2.0",
        id: id,
        error: parseError(data.error),
    };
}
exports.parseJsonRpcErrorResponse = parseJsonRpcErrorResponse;
/** Throws if data is not a JsonRpcSuccessResponse */
function parseJsonRpcSuccessResponse(data) {
    if (!(0, compatibility_1.isJsonCompatibleDictionary)(data)) {
        throw new Error("Data must be JSON compatible dictionary");
    }
    if (data.jsonrpc !== "2.0") {
        throw new Error(`Got unexpected jsonrpc version: ${JSON.stringify(data)}`);
    }
    const id = data.id;
    if (typeof id !== "number" && typeof id !== "string") {
        throw new Error("Invalid id field");
    }
    if (typeof data.result === "undefined") {
        throw new Error("Invalid result field");
    }
    const result = data.result;
    return {
        jsonrpc: "2.0",
        id: id,
        result: result,
    };
}
exports.parseJsonRpcSuccessResponse = parseJsonRpcSuccessResponse;
/**
 * Returns a JsonRpcErrorResponse if input can be parsed as a JSON-RPC error. Otherwise parses
 * input as JsonRpcSuccessResponse. Throws if input is neither a valid error nor success response.
 */
function parseJsonRpcResponse(data) {
    let response;
    try {
        response = parseJsonRpcErrorResponse(data);
    }
    catch (_) {
        response = parseJsonRpcSuccessResponse(data);
    }
    return response;
}
exports.parseJsonRpcResponse = parseJsonRpcResponse;
//# sourceMappingURL=parse.js.map

/***/ }),

/***/ 41947:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.jsonRpcCode = exports.isJsonRpcSuccessResponse = exports.isJsonRpcErrorResponse = void 0;
function isJsonRpcErrorResponse(response) {
    return typeof response.error === "object";
}
exports.isJsonRpcErrorResponse = isJsonRpcErrorResponse;
function isJsonRpcSuccessResponse(response) {
    return !isJsonRpcErrorResponse(response);
}
exports.isJsonRpcSuccessResponse = isJsonRpcSuccessResponse;
/**
 * Error codes as specified in JSON-RPC 2.0
 *
 * @see https://www.jsonrpc.org/specification#error_object
 */
exports.jsonRpcCode = {
    parseError: -32700,
    invalidRequest: -32600,
    methodNotFound: -32601,
    invalidParams: -32602,
    internalError: -32603,
    // server error (Reserved for implementation-defined server-errors.):
    // -32000 to -32099
    serverError: {
        default: -32000,
    },
};
//# sourceMappingURL=types.js.map

/***/ }),

/***/ 37130:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Decimal = void 0;
const bn_js_1 = __importDefault(__webpack_require__(13550));
// Too large values lead to massive memory usage. Limit to something sensible.
// The largest value we need is 18 (Ether).
const maxFractionalDigits = 100;
/**
 * A type for arbitrary precision, non-negative decimals.
 *
 * Instances of this class are immutable.
 */
class Decimal {
    static fromUserInput(input, fractionalDigits) {
        Decimal.verifyFractionalDigits(fractionalDigits);
        const badCharacter = input.match(/[^0-9.]/);
        if (badCharacter) {
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            throw new Error(`Invalid character at position ${badCharacter.index + 1}`);
        }
        let whole;
        let fractional;
        if (input === "") {
            whole = "0";
            fractional = "";
        }
        else if (input.search(/\./) === -1) {
            // integer format, no separator
            whole = input;
            fractional = "";
        }
        else {
            const parts = input.split(".");
            switch (parts.length) {
                case 0:
                case 1:
                    throw new Error("Fewer than two elements in split result. This must not happen here.");
                case 2:
                    if (!parts[1])
                        throw new Error("Fractional part missing");
                    whole = parts[0];
                    fractional = parts[1].replace(/0+$/, "");
                    break;
                default:
                    throw new Error("More than one separator found");
            }
        }
        if (fractional.length > fractionalDigits) {
            throw new Error("Got more fractional digits than supported");
        }
        const quantity = `${whole}${fractional.padEnd(fractionalDigits, "0")}`;
        return new Decimal(quantity, fractionalDigits);
    }
    static fromAtomics(atomics, fractionalDigits) {
        Decimal.verifyFractionalDigits(fractionalDigits);
        return new Decimal(atomics, fractionalDigits);
    }
    /**
     * Creates a Decimal with value 0.0 and the given number of fractial digits.
     *
     * Fractional digits are not relevant for the value but needed to be able
     * to perform arithmetic operations with other decimals.
     */
    static zero(fractionalDigits) {
        Decimal.verifyFractionalDigits(fractionalDigits);
        return new Decimal("0", fractionalDigits);
    }
    /**
     * Creates a Decimal with value 1.0 and the given number of fractial digits.
     *
     * Fractional digits are not relevant for the value but needed to be able
     * to perform arithmetic operations with other decimals.
     */
    static one(fractionalDigits) {
        Decimal.verifyFractionalDigits(fractionalDigits);
        return new Decimal("1" + "0".repeat(fractionalDigits), fractionalDigits);
    }
    static verifyFractionalDigits(fractionalDigits) {
        if (!Number.isInteger(fractionalDigits))
            throw new Error("Fractional digits is not an integer");
        if (fractionalDigits < 0)
            throw new Error("Fractional digits must not be negative");
        if (fractionalDigits > maxFractionalDigits) {
            throw new Error(`Fractional digits must not exceed ${maxFractionalDigits}`);
        }
    }
    static compare(a, b) {
        if (a.fractionalDigits !== b.fractionalDigits)
            throw new Error("Fractional digits do not match");
        return a.data.atomics.cmp(new bn_js_1.default(b.atomics));
    }
    get atomics() {
        return this.data.atomics.toString();
    }
    get fractionalDigits() {
        return this.data.fractionalDigits;
    }
    constructor(atomics, fractionalDigits) {
        if (!atomics.match(/^[0-9]+$/)) {
            throw new Error("Invalid string format. Only non-negative integers in decimal representation supported.");
        }
        this.data = {
            atomics: new bn_js_1.default(atomics),
            fractionalDigits: fractionalDigits,
        };
    }
    /** Creates a new instance with the same value */
    clone() {
        return new Decimal(this.atomics, this.fractionalDigits);
    }
    /** Returns the greatest decimal <= this which has no fractional part (rounding down) */
    floor() {
        const factor = new bn_js_1.default(10).pow(new bn_js_1.default(this.data.fractionalDigits));
        const whole = this.data.atomics.div(factor);
        const fractional = this.data.atomics.mod(factor);
        if (fractional.isZero()) {
            return this.clone();
        }
        else {
            return Decimal.fromAtomics(whole.mul(factor).toString(), this.fractionalDigits);
        }
    }
    /** Returns the smallest decimal >= this which has no fractional part (rounding up) */
    ceil() {
        const factor = new bn_js_1.default(10).pow(new bn_js_1.default(this.data.fractionalDigits));
        const whole = this.data.atomics.div(factor);
        const fractional = this.data.atomics.mod(factor);
        if (fractional.isZero()) {
            return this.clone();
        }
        else {
            return Decimal.fromAtomics(whole.addn(1).mul(factor).toString(), this.fractionalDigits);
        }
    }
    toString() {
        const factor = new bn_js_1.default(10).pow(new bn_js_1.default(this.data.fractionalDigits));
        const whole = this.data.atomics.div(factor);
        const fractional = this.data.atomics.mod(factor);
        if (fractional.isZero()) {
            return whole.toString();
        }
        else {
            const fullFractionalPart = fractional.toString().padStart(this.data.fractionalDigits, "0");
            const trimmedFractionalPart = fullFractionalPart.replace(/0+$/, "");
            return `${whole.toString()}.${trimmedFractionalPart}`;
        }
    }
    /**
     * Returns an approximation as a float type. Only use this if no
     * exact calculation is required.
     */
    toFloatApproximation() {
        const out = Number(this.toString());
        if (Number.isNaN(out))
            throw new Error("Conversion to number failed");
        return out;
    }
    /**
     * a.plus(b) returns a+b.
     *
     * Both values need to have the same fractional digits.
     */
    plus(b) {
        if (this.fractionalDigits !== b.fractionalDigits)
            throw new Error("Fractional digits do not match");
        const sum = this.data.atomics.add(new bn_js_1.default(b.atomics));
        return new Decimal(sum.toString(), this.fractionalDigits);
    }
    /**
     * a.minus(b) returns a-b.
     *
     * Both values need to have the same fractional digits.
     * The resulting difference needs to be non-negative.
     */
    minus(b) {
        if (this.fractionalDigits !== b.fractionalDigits)
            throw new Error("Fractional digits do not match");
        const difference = this.data.atomics.sub(new bn_js_1.default(b.atomics));
        if (difference.ltn(0))
            throw new Error("Difference must not be negative");
        return new Decimal(difference.toString(), this.fractionalDigits);
    }
    /**
     * a.multiply(b) returns a*b.
     *
     * We only allow multiplication by unsigned integers to avoid rounding errors.
     */
    multiply(b) {
        const product = this.data.atomics.mul(new bn_js_1.default(b.toString()));
        return new Decimal(product.toString(), this.fractionalDigits);
    }
    equals(b) {
        return Decimal.compare(this, b) === 0;
    }
    isLessThan(b) {
        return Decimal.compare(this, b) < 0;
    }
    isLessThanOrEqual(b) {
        return Decimal.compare(this, b) <= 0;
    }
    isGreaterThan(b) {
        return Decimal.compare(this, b) > 0;
    }
    isGreaterThanOrEqual(b) {
        return Decimal.compare(this, b) >= 0;
    }
}
exports.Decimal = Decimal;
//# sourceMappingURL=decimal.js.map

/***/ }),

/***/ 66021:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Uint64 = exports.Uint53 = exports.Uint32 = exports.Int53 = exports.Decimal = void 0;
var decimal_1 = __webpack_require__(37130);
Object.defineProperty(exports, "Decimal", ({ enumerable: true, get: function () { return decimal_1.Decimal; } }));
var integers_1 = __webpack_require__(87965);
Object.defineProperty(exports, "Int53", ({ enumerable: true, get: function () { return integers_1.Int53; } }));
Object.defineProperty(exports, "Uint32", ({ enumerable: true, get: function () { return integers_1.Uint32; } }));
Object.defineProperty(exports, "Uint53", ({ enumerable: true, get: function () { return integers_1.Uint53; } }));
Object.defineProperty(exports, "Uint64", ({ enumerable: true, get: function () { return integers_1.Uint64; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 87965:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Uint64 = exports.Uint53 = exports.Int53 = exports.Uint32 = void 0;
/* eslint-disable no-bitwise */
const bn_js_1 = __importDefault(__webpack_require__(13550));
const uint64MaxValue = new bn_js_1.default("18446744073709551615", 10, "be");
class Uint32 {
    /** @deprecated use Uint32.fromBytes */
    static fromBigEndianBytes(bytes) {
        return Uint32.fromBytes(bytes);
    }
    /**
     * Creates a Uint32 from a fixed length byte array.
     *
     * @param bytes a list of exactly 4 bytes
     * @param endianess defaults to big endian
     */
    static fromBytes(bytes, endianess = "be") {
        if (bytes.length !== 4) {
            throw new Error("Invalid input length. Expected 4 bytes.");
        }
        for (let i = 0; i < bytes.length; ++i) {
            if (!Number.isInteger(bytes[i]) || bytes[i] > 255 || bytes[i] < 0) {
                throw new Error("Invalid value in byte. Found: " + bytes[i]);
            }
        }
        const beBytes = endianess === "be" ? bytes : Array.from(bytes).reverse();
        // Use mulitiplication instead of shifting since bitwise operators are defined
        // on SIGNED int32 in JavaScript and we don't want to risk surprises
        return new Uint32(beBytes[0] * 2 ** 24 + beBytes[1] * 2 ** 16 + beBytes[2] * 2 ** 8 + beBytes[3]);
    }
    static fromString(str) {
        if (!str.match(/^[0-9]+$/)) {
            throw new Error("Invalid string format");
        }
        return new Uint32(Number.parseInt(str, 10));
    }
    constructor(input) {
        if (Number.isNaN(input)) {
            throw new Error("Input is not a number");
        }
        if (!Number.isInteger(input)) {
            throw new Error("Input is not an integer");
        }
        if (input < 0 || input > 4294967295) {
            throw new Error("Input not in uint32 range: " + input.toString());
        }
        this.data = input;
    }
    toBytesBigEndian() {
        // Use division instead of shifting since bitwise operators are defined
        // on SIGNED int32 in JavaScript and we don't want to risk surprises
        return new Uint8Array([
            Math.floor(this.data / 2 ** 24) & 0xff,
            Math.floor(this.data / 2 ** 16) & 0xff,
            Math.floor(this.data / 2 ** 8) & 0xff,
            Math.floor(this.data / 2 ** 0) & 0xff,
        ]);
    }
    toBytesLittleEndian() {
        // Use division instead of shifting since bitwise operators are defined
        // on SIGNED int32 in JavaScript and we don't want to risk surprises
        return new Uint8Array([
            Math.floor(this.data / 2 ** 0) & 0xff,
            Math.floor(this.data / 2 ** 8) & 0xff,
            Math.floor(this.data / 2 ** 16) & 0xff,
            Math.floor(this.data / 2 ** 24) & 0xff,
        ]);
    }
    toNumber() {
        return this.data;
    }
    toBigInt() {
        return BigInt(this.toNumber());
    }
    toString() {
        return this.data.toString();
    }
}
exports.Uint32 = Uint32;
class Int53 {
    static fromString(str) {
        if (!str.match(/^-?[0-9]+$/)) {
            throw new Error("Invalid string format");
        }
        return new Int53(Number.parseInt(str, 10));
    }
    constructor(input) {
        if (Number.isNaN(input)) {
            throw new Error("Input is not a number");
        }
        if (!Number.isInteger(input)) {
            throw new Error("Input is not an integer");
        }
        if (input < Number.MIN_SAFE_INTEGER || input > Number.MAX_SAFE_INTEGER) {
            throw new Error("Input not in int53 range: " + input.toString());
        }
        this.data = input;
    }
    toNumber() {
        return this.data;
    }
    toBigInt() {
        return BigInt(this.toNumber());
    }
    toString() {
        return this.data.toString();
    }
}
exports.Int53 = Int53;
class Uint53 {
    static fromString(str) {
        const signed = Int53.fromString(str);
        return new Uint53(signed.toNumber());
    }
    constructor(input) {
        const signed = new Int53(input);
        if (signed.toNumber() < 0) {
            throw new Error("Input is negative");
        }
        this.data = signed;
    }
    toNumber() {
        return this.data.toNumber();
    }
    toBigInt() {
        return BigInt(this.toNumber());
    }
    toString() {
        return this.data.toString();
    }
}
exports.Uint53 = Uint53;
class Uint64 {
    /** @deprecated use Uint64.fromBytes */
    static fromBytesBigEndian(bytes) {
        return Uint64.fromBytes(bytes);
    }
    /**
     * Creates a Uint64 from a fixed length byte array.
     *
     * @param bytes a list of exactly 8 bytes
     * @param endianess defaults to big endian
     */
    static fromBytes(bytes, endianess = "be") {
        if (bytes.length !== 8) {
            throw new Error("Invalid input length. Expected 8 bytes.");
        }
        for (let i = 0; i < bytes.length; ++i) {
            if (!Number.isInteger(bytes[i]) || bytes[i] > 255 || bytes[i] < 0) {
                throw new Error("Invalid value in byte. Found: " + bytes[i]);
            }
        }
        const beBytes = endianess === "be" ? Array.from(bytes) : Array.from(bytes).reverse();
        return new Uint64(new bn_js_1.default(beBytes));
    }
    static fromString(str) {
        if (!str.match(/^[0-9]+$/)) {
            throw new Error("Invalid string format");
        }
        return new Uint64(new bn_js_1.default(str, 10, "be"));
    }
    static fromNumber(input) {
        if (Number.isNaN(input)) {
            throw new Error("Input is not a number");
        }
        if (!Number.isInteger(input)) {
            throw new Error("Input is not an integer");
        }
        let bigint;
        try {
            bigint = new bn_js_1.default(input);
        }
        catch {
            throw new Error("Input is not a safe integer");
        }
        return new Uint64(bigint);
    }
    constructor(data) {
        if (data.isNeg()) {
            throw new Error("Input is negative");
        }
        if (data.gt(uint64MaxValue)) {
            throw new Error("Input exceeds uint64 range");
        }
        this.data = data;
    }
    toBytesBigEndian() {
        return Uint8Array.from(this.data.toArray("be", 8));
    }
    toBytesLittleEndian() {
        return Uint8Array.from(this.data.toArray("le", 8));
    }
    toString() {
        return this.data.toString(10);
    }
    toBigInt() {
        return BigInt(this.toString());
    }
    toNumber() {
        return this.data.toNumber();
    }
}
exports.Uint64 = Uint64;
// Assign classes to unused variables in order to verify static interface conformance at compile time.
// Workaround for https://github.com/microsoft/TypeScript/issues/33892
const _int53Class = (/* unused pure expression or super */ null && (Int53));
const _uint53Class = (/* unused pure expression or super */ null && (Uint53));
const _uint32Class = (/* unused pure expression or super */ null && (Uint32));
const _uint64Class = (/* unused pure expression or super */ null && (Uint64));
//# sourceMappingURL=integers.js.map

/***/ }),

/***/ 45393:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.parseCoins = void 0;
/**
 * Takes a coins list like "819966000ucosm,700000000ustake" and parses it.
 *
 * This is a Stargate ready version of parseCoins from @cosmjs/amino.
 * It supports more denoms.
 */
function parseCoins(input) {
    return input
        .replace(/\s/g, "")
        .split(",")
        .filter(Boolean)
        .map((part) => {
        // Denom regex from Stargate (https://github.com/cosmos/cosmos-sdk/blob/v0.42.7/types/coin.go#L599-L601)
        const match = part.match(/^([0-9]+)([a-zA-Z][a-zA-Z0-9/]{2,127})$/);
        if (!match)
            throw new Error("Got an invalid coin string");
        return {
            amount: match[1].replace(/^0+/, "") || "0",
            denom: match[2],
        };
    });
}
exports.parseCoins = parseCoins;
//# sourceMappingURL=coins.js.map

/***/ }),

/***/ 94526:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.decodeTxRaw = void 0;
const tx_1 = __webpack_require__(17921);
/**
 * Takes a serialized TxRaw (the bytes stored in Tendermint) and decodes it into something usable.
 */
function decodeTxRaw(tx) {
    const txRaw = tx_1.TxRaw.decode(tx);
    return {
        authInfo: tx_1.AuthInfo.decode(txRaw.authInfoBytes),
        body: tx_1.TxBody.decode(txRaw.bodyBytes),
        signatures: txRaw.signatures,
    };
}
exports.decodeTxRaw = decodeTxRaw;
//# sourceMappingURL=decode.js.map

/***/ }),

/***/ 65900:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.DirectSecp256k1HdWallet = exports.extractKdfConfiguration = void 0;
const amino_1 = __webpack_require__(98802);
const crypto_1 = __webpack_require__(45027);
const encoding_1 = __webpack_require__(87061);
const utils_1 = __webpack_require__(62584);
const signing_1 = __webpack_require__(33578);
const wallet_1 = __webpack_require__(79449);
const serializationTypeV1 = "directsecp256k1hdwallet-v1";
/**
 * A KDF configuration that is not very strong but can be used on the main thread.
 * It takes about 1 second in Node.js 16.0.0 and should have similar runtimes in other modern Wasm hosts.
 */
const basicPasswordHashingOptions = {
    algorithm: "argon2id",
    params: {
        outputLength: 32,
        opsLimit: 24,
        memLimitKib: 12 * 1024,
    },
};
function isDerivationJson(thing) {
    if (!(0, utils_1.isNonNullObject)(thing))
        return false;
    if (typeof thing.hdPath !== "string")
        return false;
    if (typeof thing.prefix !== "string")
        return false;
    return true;
}
function extractKdfConfigurationV1(doc) {
    return doc.kdf;
}
function extractKdfConfiguration(serialization) {
    const root = JSON.parse(serialization);
    if (!(0, utils_1.isNonNullObject)(root))
        throw new Error("Root document is not an object.");
    switch (root.type) {
        case serializationTypeV1:
            return extractKdfConfigurationV1(root);
        default:
            throw new Error("Unsupported serialization type");
    }
}
exports.extractKdfConfiguration = extractKdfConfiguration;
const defaultOptions = {
    bip39Password: "",
    hdPaths: [(0, amino_1.makeCosmoshubPath)(0)],
    prefix: "cosmos",
};
/** A wallet for protobuf based signing using SIGN_MODE_DIRECT */
class DirectSecp256k1HdWallet {
    /**
     * Restores a wallet from the given BIP39 mnemonic.
     *
     * @param mnemonic Any valid English mnemonic.
     * @param options An optional `DirectSecp256k1HdWalletOptions` object optionally containing a bip39Password, hdPaths, and prefix.
     */
    static async fromMnemonic(mnemonic, options = {}) {
        const mnemonicChecked = new crypto_1.EnglishMnemonic(mnemonic);
        const seed = await crypto_1.Bip39.mnemonicToSeed(mnemonicChecked, options.bip39Password);
        return new DirectSecp256k1HdWallet(mnemonicChecked, {
            ...options,
            seed: seed,
        });
    }
    /**
     * Generates a new wallet with a BIP39 mnemonic of the given length.
     *
     * @param length The number of words in the mnemonic (12, 15, 18, 21 or 24).
     * @param options An optional `DirectSecp256k1HdWalletOptions` object optionally containing a bip39Password, hdPaths, and prefix.
     */
    static async generate(length = 12, options = {}) {
        const entropyLength = 4 * Math.floor((11 * length) / 33);
        const entropy = crypto_1.Random.getBytes(entropyLength);
        const mnemonic = crypto_1.Bip39.encode(entropy);
        return DirectSecp256k1HdWallet.fromMnemonic(mnemonic.toString(), options);
    }
    /**
     * Restores a wallet from an encrypted serialization.
     *
     * @param password The user provided password used to generate an encryption key via a KDF.
     *                 This is not normalized internally (see "Unicode normalization" to learn more).
     */
    static async deserialize(serialization, password) {
        const root = JSON.parse(serialization);
        if (!(0, utils_1.isNonNullObject)(root))
            throw new Error("Root document is not an object.");
        switch (root.type) {
            case serializationTypeV1:
                return DirectSecp256k1HdWallet.deserializeTypeV1(serialization, password);
            default:
                throw new Error("Unsupported serialization type");
        }
    }
    /**
     * Restores a wallet from an encrypted serialization.
     *
     * This is an advanced alternative to calling `deserialize(serialization, password)` directly, which allows
     * you to offload the KDF execution to a non-UI thread (e.g. in a WebWorker).
     *
     * The caller is responsible for ensuring the key was derived with the given KDF configuration. This can be
     * done using `extractKdfConfiguration(serialization)` and `executeKdf(password, kdfConfiguration)` from this package.
     */
    static async deserializeWithEncryptionKey(serialization, encryptionKey) {
        const root = JSON.parse(serialization);
        if (!(0, utils_1.isNonNullObject)(root))
            throw new Error("Root document is not an object.");
        const untypedRoot = root;
        switch (untypedRoot.type) {
            case serializationTypeV1: {
                const decryptedBytes = await (0, wallet_1.decrypt)((0, encoding_1.fromBase64)(untypedRoot.data), encryptionKey, untypedRoot.encryption);
                const decryptedDocument = JSON.parse((0, encoding_1.fromUtf8)(decryptedBytes));
                const { mnemonic, accounts } = decryptedDocument;
                (0, utils_1.assert)(typeof mnemonic === "string");
                if (!Array.isArray(accounts))
                    throw new Error("Property 'accounts' is not an array");
                if (!accounts.every((account) => isDerivationJson(account))) {
                    throw new Error("Account is not in the correct format.");
                }
                const firstPrefix = accounts[0].prefix;
                if (!accounts.every(({ prefix }) => prefix === firstPrefix)) {
                    throw new Error("Accounts do not all have the same prefix");
                }
                const hdPaths = accounts.map(({ hdPath }) => (0, crypto_1.stringToPath)(hdPath));
                return DirectSecp256k1HdWallet.fromMnemonic(mnemonic, {
                    hdPaths: hdPaths,
                    prefix: firstPrefix,
                });
            }
            default:
                throw new Error("Unsupported serialization type");
        }
    }
    static async deserializeTypeV1(serialization, password) {
        const root = JSON.parse(serialization);
        if (!(0, utils_1.isNonNullObject)(root))
            throw new Error("Root document is not an object.");
        const encryptionKey = await (0, wallet_1.executeKdf)(password, root.kdf);
        return DirectSecp256k1HdWallet.deserializeWithEncryptionKey(serialization, encryptionKey);
    }
    constructor(mnemonic, options) {
        const prefix = options.prefix ?? defaultOptions.prefix;
        const hdPaths = options.hdPaths ?? defaultOptions.hdPaths;
        this.secret = mnemonic;
        this.seed = options.seed;
        this.accounts = hdPaths.map((hdPath) => ({
            hdPath: hdPath,
            prefix: prefix,
        }));
    }
    get mnemonic() {
        return this.secret.toString();
    }
    async getAccounts() {
        const accountsWithPrivkeys = await this.getAccountsWithPrivkeys();
        return accountsWithPrivkeys.map(({ algo, pubkey, address }) => ({
            algo: algo,
            pubkey: pubkey,
            address: address,
        }));
    }
    async signDirect(signerAddress, signDoc) {
        const accounts = await this.getAccountsWithPrivkeys();
        const account = accounts.find(({ address }) => address === signerAddress);
        if (account === undefined) {
            throw new Error(`Address ${signerAddress} not found in wallet`);
        }
        const { privkey, pubkey } = account;
        const signBytes = (0, signing_1.makeSignBytes)(signDoc);
        const hashedMessage = (0, crypto_1.sha256)(signBytes);
        const signature = await crypto_1.Secp256k1.createSignature(hashedMessage, privkey);
        const signatureBytes = new Uint8Array([...signature.r(32), ...signature.s(32)]);
        const stdSignature = (0, amino_1.encodeSecp256k1Signature)(pubkey, signatureBytes);
        return {
            signed: signDoc,
            signature: stdSignature,
        };
    }
    /**
     * Generates an encrypted serialization of this wallet.
     *
     * @param password The user provided password used to generate an encryption key via a KDF.
     *                 This is not normalized internally (see "Unicode normalization" to learn more).
     */
    async serialize(password) {
        const kdfConfiguration = basicPasswordHashingOptions;
        const encryptionKey = await (0, wallet_1.executeKdf)(password, kdfConfiguration);
        return this.serializeWithEncryptionKey(encryptionKey, kdfConfiguration);
    }
    /**
     * Generates an encrypted serialization of this wallet.
     *
     * This is an advanced alternative to calling `serialize(password)` directly, which allows you to
     * offload the KDF execution to a non-UI thread (e.g. in a WebWorker).
     *
     * The caller is responsible for ensuring the key was derived with the given KDF options. If this
     * is not the case, the wallet cannot be restored with the original password.
     */
    async serializeWithEncryptionKey(encryptionKey, kdfConfiguration) {
        const dataToEncrypt = {
            mnemonic: this.mnemonic,
            accounts: this.accounts.map(({ hdPath, prefix }) => ({
                hdPath: (0, crypto_1.pathToString)(hdPath),
                prefix: prefix,
            })),
        };
        const dataToEncryptRaw = (0, encoding_1.toUtf8)(JSON.stringify(dataToEncrypt));
        const encryptionConfiguration = {
            algorithm: wallet_1.supportedAlgorithms.xchacha20poly1305Ietf,
        };
        const encryptedData = await (0, wallet_1.encrypt)(dataToEncryptRaw, encryptionKey, encryptionConfiguration);
        const out = {
            type: serializationTypeV1,
            kdf: kdfConfiguration,
            encryption: encryptionConfiguration,
            data: (0, encoding_1.toBase64)(encryptedData),
        };
        return JSON.stringify(out);
    }
    async getKeyPair(hdPath) {
        const { privkey } = crypto_1.Slip10.derivePath(crypto_1.Slip10Curve.Secp256k1, this.seed, hdPath);
        const { pubkey } = await crypto_1.Secp256k1.makeKeypair(privkey);
        return {
            privkey: privkey,
            pubkey: crypto_1.Secp256k1.compressPubkey(pubkey),
        };
    }
    async getAccountsWithPrivkeys() {
        return Promise.all(this.accounts.map(async ({ hdPath, prefix }) => {
            const { privkey, pubkey } = await this.getKeyPair(hdPath);
            const address = (0, encoding_1.toBech32)(prefix, (0, amino_1.rawSecp256k1PubkeyToRawAddress)(pubkey));
            return {
                algo: "secp256k1",
                privkey: privkey,
                pubkey: pubkey,
                address: address,
            };
        }));
    }
}
exports.DirectSecp256k1HdWallet = DirectSecp256k1HdWallet;
//# sourceMappingURL=directsecp256k1hdwallet.js.map

/***/ }),

/***/ 24470:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.DirectSecp256k1Wallet = void 0;
const amino_1 = __webpack_require__(98802);
const crypto_1 = __webpack_require__(45027);
const encoding_1 = __webpack_require__(87061);
const signing_1 = __webpack_require__(33578);
/**
 * A wallet that holds a single secp256k1 keypair.
 *
 * If you want to work with BIP39 mnemonics and multiple accounts, use DirectSecp256k1HdWallet.
 */
class DirectSecp256k1Wallet {
    /**
     * Creates a DirectSecp256k1Wallet from the given private key
     *
     * @param privkey The private key.
     * @param prefix The bech32 address prefix (human readable part). Defaults to "cosmos".
     */
    static async fromKey(privkey, prefix = "cosmos") {
        const uncompressed = (await crypto_1.Secp256k1.makeKeypair(privkey)).pubkey;
        return new DirectSecp256k1Wallet(privkey, crypto_1.Secp256k1.compressPubkey(uncompressed), prefix);
    }
    constructor(privkey, pubkey, prefix) {
        this.privkey = privkey;
        this.pubkey = pubkey;
        this.prefix = prefix;
    }
    get address() {
        return (0, encoding_1.toBech32)(this.prefix, (0, amino_1.rawSecp256k1PubkeyToRawAddress)(this.pubkey));
    }
    async getAccounts() {
        return [
            {
                algo: "secp256k1",
                address: this.address,
                pubkey: this.pubkey,
            },
        ];
    }
    async signDirect(address, signDoc) {
        const signBytes = (0, signing_1.makeSignBytes)(signDoc);
        if (address !== this.address) {
            throw new Error(`Address ${address} not found in wallet`);
        }
        const hashedMessage = (0, crypto_1.sha256)(signBytes);
        const signature = await crypto_1.Secp256k1.createSignature(hashedMessage, this.privkey);
        const signatureBytes = new Uint8Array([...signature.r(32), ...signature.s(32)]);
        const stdSignature = (0, amino_1.encodeSecp256k1Signature)(this.pubkey, signatureBytes);
        return {
            signed: signDoc,
            signature: stdSignature,
        };
    }
}
exports.DirectSecp256k1Wallet = DirectSecp256k1Wallet;
//# sourceMappingURL=directsecp256k1wallet.js.map

/***/ }),

/***/ 75216:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.coins = exports.coin = exports.executeKdf = exports.makeSignDoc = exports.makeSignBytes = exports.makeAuthInfoBytes = exports.isOfflineDirectSigner = exports.Registry = exports.isTxBodyEncodeObject = exports.isTsProtoGeneratedType = exports.isPbjsGeneratedType = exports.encodePubkey = exports.decodePubkey = exports.anyToSinglePubkey = exports.makeCosmoshubPath = exports.DirectSecp256k1Wallet = exports.extractKdfConfiguration = exports.DirectSecp256k1HdWallet = exports.decodeTxRaw = exports.parseCoins = void 0;
// This type happens to be shared between Amino and Direct sign modes
var coins_1 = __webpack_require__(45393);
Object.defineProperty(exports, "parseCoins", ({ enumerable: true, get: function () { return coins_1.parseCoins; } }));
var decode_1 = __webpack_require__(94526);
Object.defineProperty(exports, "decodeTxRaw", ({ enumerable: true, get: function () { return decode_1.decodeTxRaw; } }));
var directsecp256k1hdwallet_1 = __webpack_require__(65900);
Object.defineProperty(exports, "DirectSecp256k1HdWallet", ({ enumerable: true, get: function () { return directsecp256k1hdwallet_1.DirectSecp256k1HdWallet; } }));
Object.defineProperty(exports, "extractKdfConfiguration", ({ enumerable: true, get: function () { return directsecp256k1hdwallet_1.extractKdfConfiguration; } }));
var directsecp256k1wallet_1 = __webpack_require__(24470);
Object.defineProperty(exports, "DirectSecp256k1Wallet", ({ enumerable: true, get: function () { return directsecp256k1wallet_1.DirectSecp256k1Wallet; } }));
var paths_1 = __webpack_require__(735);
Object.defineProperty(exports, "makeCosmoshubPath", ({ enumerable: true, get: function () { return paths_1.makeCosmoshubPath; } }));
var pubkey_1 = __webpack_require__(9650);
Object.defineProperty(exports, "anyToSinglePubkey", ({ enumerable: true, get: function () { return pubkey_1.anyToSinglePubkey; } }));
Object.defineProperty(exports, "decodePubkey", ({ enumerable: true, get: function () { return pubkey_1.decodePubkey; } }));
Object.defineProperty(exports, "encodePubkey", ({ enumerable: true, get: function () { return pubkey_1.encodePubkey; } }));
var registry_1 = __webpack_require__(55563);
Object.defineProperty(exports, "isPbjsGeneratedType", ({ enumerable: true, get: function () { return registry_1.isPbjsGeneratedType; } }));
Object.defineProperty(exports, "isTsProtoGeneratedType", ({ enumerable: true, get: function () { return registry_1.isTsProtoGeneratedType; } }));
Object.defineProperty(exports, "isTxBodyEncodeObject", ({ enumerable: true, get: function () { return registry_1.isTxBodyEncodeObject; } }));
Object.defineProperty(exports, "Registry", ({ enumerable: true, get: function () { return registry_1.Registry; } }));
var signer_1 = __webpack_require__(85349);
Object.defineProperty(exports, "isOfflineDirectSigner", ({ enumerable: true, get: function () { return signer_1.isOfflineDirectSigner; } }));
var signing_1 = __webpack_require__(33578);
Object.defineProperty(exports, "makeAuthInfoBytes", ({ enumerable: true, get: function () { return signing_1.makeAuthInfoBytes; } }));
Object.defineProperty(exports, "makeSignBytes", ({ enumerable: true, get: function () { return signing_1.makeSignBytes; } }));
Object.defineProperty(exports, "makeSignDoc", ({ enumerable: true, get: function () { return signing_1.makeSignDoc; } }));
var wallet_1 = __webpack_require__(79449);
Object.defineProperty(exports, "executeKdf", ({ enumerable: true, get: function () { return wallet_1.executeKdf; } }));
var amino_1 = __webpack_require__(98802);
Object.defineProperty(exports, "coin", ({ enumerable: true, get: function () { return amino_1.coin; } }));
Object.defineProperty(exports, "coins", ({ enumerable: true, get: function () { return amino_1.coins; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 735:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.makeCosmoshubPath = void 0;
const crypto_1 = __webpack_require__(45027);
/**
 * The Cosmos Hub derivation path in the form `m/44'/118'/0'/0/a`
 * with 0-based account index `a`.
 */
function makeCosmoshubPath(a) {
    return [
        crypto_1.Slip10RawIndex.hardened(44),
        crypto_1.Slip10RawIndex.hardened(118),
        crypto_1.Slip10RawIndex.hardened(0),
        crypto_1.Slip10RawIndex.normal(0),
        crypto_1.Slip10RawIndex.normal(a),
    ];
}
exports.makeCosmoshubPath = makeCosmoshubPath;
//# sourceMappingURL=paths.js.map

/***/ }),

/***/ 9650:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.decodePubkey = exports.anyToSinglePubkey = exports.encodePubkey = void 0;
/* eslint-disable @typescript-eslint/naming-convention */
const amino_1 = __webpack_require__(98802);
const encoding_1 = __webpack_require__(87061);
const math_1 = __webpack_require__(66021);
const keys_1 = __webpack_require__(72360);
const keys_2 = __webpack_require__(51574);
const keys_3 = __webpack_require__(64277);
const any_1 = __webpack_require__(75654);
/**
 * Takes a pubkey in the Amino JSON object style (type/value wrapper)
 * and convertes it into a protobuf `Any`.
 *
 * This is the reverse operation to `decodePubkey`.
 */
function encodePubkey(pubkey) {
    if ((0, amino_1.isSecp256k1Pubkey)(pubkey)) {
        const pubkeyProto = keys_3.PubKey.fromPartial({
            key: (0, encoding_1.fromBase64)(pubkey.value),
        });
        return any_1.Any.fromPartial({
            typeUrl: "/cosmos.crypto.secp256k1.PubKey",
            value: Uint8Array.from(keys_3.PubKey.encode(pubkeyProto).finish()),
        });
    }
    else if ((0, amino_1.isEd25519Pubkey)(pubkey)) {
        const pubkeyProto = keys_1.PubKey.fromPartial({
            key: (0, encoding_1.fromBase64)(pubkey.value),
        });
        return any_1.Any.fromPartial({
            typeUrl: "/cosmos.crypto.ed25519.PubKey",
            value: Uint8Array.from(keys_1.PubKey.encode(pubkeyProto).finish()),
        });
    }
    else if ((0, amino_1.isMultisigThresholdPubkey)(pubkey)) {
        const pubkeyProto = keys_2.LegacyAminoPubKey.fromPartial({
            threshold: math_1.Uint53.fromString(pubkey.value.threshold).toNumber(),
            publicKeys: pubkey.value.pubkeys.map(encodePubkey),
        });
        return any_1.Any.fromPartial({
            typeUrl: "/cosmos.crypto.multisig.LegacyAminoPubKey",
            value: Uint8Array.from(keys_2.LegacyAminoPubKey.encode(pubkeyProto).finish()),
        });
    }
    else {
        throw new Error(`Pubkey type ${pubkey.type} not recognized`);
    }
}
exports.encodePubkey = encodePubkey;
/**
 * Decodes a single pubkey (i.e. not a multisig pubkey) from `Any` into
 * `SinglePubkey`.
 *
 * In most cases you probably want to use `decodePubkey`.
 */
function anyToSinglePubkey(pubkey) {
    switch (pubkey.typeUrl) {
        case "/cosmos.crypto.secp256k1.PubKey": {
            const { key } = keys_3.PubKey.decode(pubkey.value);
            return (0, amino_1.encodeSecp256k1Pubkey)(key);
        }
        case "/cosmos.crypto.ed25519.PubKey": {
            const { key } = keys_1.PubKey.decode(pubkey.value);
            return (0, amino_1.encodeEd25519Pubkey)(key);
        }
        default:
            throw new Error(`Pubkey type_url ${pubkey.typeUrl} not recognized as single public key type`);
    }
}
exports.anyToSinglePubkey = anyToSinglePubkey;
/**
 * Decodes a pubkey from a protobuf `Any` into `Pubkey`.
 * This supports single pubkeys such as Cosmos ed25519 and secp256k1 keys
 * as well as multisig threshold pubkeys.
 */
function decodePubkey(pubkey) {
    switch (pubkey.typeUrl) {
        case "/cosmos.crypto.secp256k1.PubKey":
        case "/cosmos.crypto.ed25519.PubKey": {
            return anyToSinglePubkey(pubkey);
        }
        case "/cosmos.crypto.multisig.LegacyAminoPubKey": {
            const { threshold, publicKeys } = keys_2.LegacyAminoPubKey.decode(pubkey.value);
            const out = {
                type: "tendermint/PubKeyMultisigThreshold",
                value: {
                    threshold: threshold.toString(),
                    pubkeys: publicKeys.map(anyToSinglePubkey),
                },
            };
            return out;
        }
        default:
            throw new Error(`Pubkey type_url ${pubkey.typeUrl} not recognized`);
    }
}
exports.decodePubkey = decodePubkey;
//# sourceMappingURL=pubkey.js.map

/***/ }),

/***/ 55563:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/* provided dependency */ var Buffer = __webpack_require__(48764)["Buffer"];

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Registry = exports.isTxBodyEncodeObject = exports.isPbjsGeneratedType = exports.isTsProtoGeneratedType = void 0;
/* eslint-disable @typescript-eslint/naming-convention */
const tx_1 = __webpack_require__(59534);
const coin_1 = __webpack_require__(81637);
const tx_2 = __webpack_require__(17921);
const any_1 = __webpack_require__(75654);
function isTsProtoGeneratedType(type) {
    return typeof type.fromPartial === "function";
}
exports.isTsProtoGeneratedType = isTsProtoGeneratedType;
function isPbjsGeneratedType(type) {
    return !isTsProtoGeneratedType(type);
}
exports.isPbjsGeneratedType = isPbjsGeneratedType;
const defaultTypeUrls = {
    cosmosCoin: "/cosmos.base.v1beta1.Coin",
    cosmosMsgSend: "/cosmos.bank.v1beta1.MsgSend",
    cosmosTxBody: "/cosmos.tx.v1beta1.TxBody",
    googleAny: "/google.protobuf.Any",
};
function isTxBodyEncodeObject(encodeObject) {
    return encodeObject.typeUrl === "/cosmos.tx.v1beta1.TxBody";
}
exports.isTxBodyEncodeObject = isTxBodyEncodeObject;
class Registry {
    /**
     * Creates a new Registry for mapping protobuf type identifiers/type URLs to
     * actual implementations. Those implementations are typically generated with ts-proto
     * but we also support protobuf.js as a type generator.
     *
     * If there is no parameter given, a `new Registry()` adds the types `Coin` and `MsgSend`
     * for historic reasons. Those can be overriden by customTypes.
     *
     * There are currently two methods for adding new types:
     * 1. Passing types to the constructor.
     * 2. Using the `register()` method
     */
    constructor(customTypes) {
        const { cosmosCoin, cosmosMsgSend } = defaultTypeUrls;
        this.types = customTypes
            ? new Map([...customTypes])
            : new Map([
                [cosmosCoin, coin_1.Coin],
                [cosmosMsgSend, tx_1.MsgSend],
            ]);
    }
    register(typeUrl, type) {
        this.types.set(typeUrl, type);
    }
    /**
     * Looks up a type that was previously added to the registry.
     *
     * The generator information (ts-proto or pbjs) gets lost along the way.
     * If you need to work with the result type in TypeScript, you can use:
     *
     * ```
     * import { assert } from "@cosmjs/utils";
     *
     * const Coin = registry.lookupType("/cosmos.base.v1beta1.Coin");
     * assert(Coin); // Ensures not unset
     * assert(isTsProtoGeneratedType(Coin)); // Ensures this is the type we expect
     *
     * // Coin is typed TsProtoGeneratedType now.
     * ```
     */
    lookupType(typeUrl) {
        return this.types.get(typeUrl);
    }
    lookupTypeWithError(typeUrl) {
        const type = this.lookupType(typeUrl);
        if (!type) {
            throw new Error(`Unregistered type url: ${typeUrl}`);
        }
        return type;
    }
    /**
     * Takes a typeUrl/value pair and encodes the value to protobuf if
     * the given type was previously registered.
     *
     * If the value has to be wrapped in an Any, this needs to be done
     * manually after this call. Or use `encodeAsAny` instead.
     */
    encode(encodeObject) {
        const { value, typeUrl } = encodeObject;
        if (isTxBodyEncodeObject(encodeObject)) {
            return this.encodeTxBody(value);
        }
        const type = this.lookupTypeWithError(typeUrl);
        const instance = isTsProtoGeneratedType(type) ? type.fromPartial(value) : type.create(value);
        return type.encode(instance).finish();
    }
    /**
     * Takes a typeUrl/value pair and encodes the value to an Any if
     * the given type was previously registered.
     */
    encodeAsAny(encodeObject) {
        const binaryValue = this.encode(encodeObject);
        return any_1.Any.fromPartial({
            typeUrl: encodeObject.typeUrl,
            value: binaryValue,
        });
    }
    encodeTxBody(txBodyFields) {
        const wrappedMessages = txBodyFields.messages.map((message) => this.encodeAsAny(message));
        const txBody = tx_2.TxBody.fromPartial({
            ...txBodyFields,
            messages: wrappedMessages,
        });
        return tx_2.TxBody.encode(txBody).finish();
    }
    decode({ typeUrl, value }) {
        if (typeUrl === defaultTypeUrls.cosmosTxBody) {
            return this.decodeTxBody(value);
        }
        const type = this.lookupTypeWithError(typeUrl);
        const decoded = type.decode(value);
        Object.entries(decoded).forEach(([key, val]) => {
            if (typeof Buffer !== "undefined" && typeof Buffer.isBuffer !== "undefined" && Buffer.isBuffer(val)) {
                decoded[key] = Uint8Array.from(val);
            }
        });
        return decoded;
    }
    decodeTxBody(txBody) {
        const decodedTxBody = tx_2.TxBody.decode(txBody);
        return {
            ...decodedTxBody,
            messages: decodedTxBody.messages.map(({ typeUrl: typeUrl, value }) => {
                if (!typeUrl) {
                    throw new Error("Missing type_url in Any");
                }
                if (!value) {
                    throw new Error("Missing value in Any");
                }
                return this.decode({ typeUrl, value });
            }),
        };
    }
}
exports.Registry = Registry;
//# sourceMappingURL=registry.js.map

/***/ }),

/***/ 85349:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.isOfflineDirectSigner = void 0;
function isOfflineDirectSigner(signer) {
    return signer.signDirect !== undefined;
}
exports.isOfflineDirectSigner = isOfflineDirectSigner;
//# sourceMappingURL=signer.js.map

/***/ }),

/***/ 33578:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.makeSignBytes = exports.makeSignDoc = exports.makeAuthInfoBytes = void 0;
/* eslint-disable @typescript-eslint/naming-convention */
const utils_1 = __webpack_require__(62584);
const signing_1 = __webpack_require__(83397);
const tx_1 = __webpack_require__(17921);
const long_1 = __importDefault(__webpack_require__(10648));
/**
 * Create signer infos from the provided signers.
 *
 * This implementation does not support different signing modes for the different signers.
 */
function makeSignerInfos(signers, signMode) {
    return signers.map(({ pubkey, sequence }) => ({
        publicKey: pubkey,
        modeInfo: {
            single: { mode: signMode },
        },
        sequence: long_1.default.fromNumber(sequence),
    }));
}
/**
 * Creates and serializes an AuthInfo document.
 *
 * This implementation does not support different signing modes for the different signers.
 */
function makeAuthInfoBytes(signers, feeAmount, gasLimit, feeGranter, feePayer, signMode = signing_1.SignMode.SIGN_MODE_DIRECT) {
    // Required arguments 4 and 5 were added in CosmJS 0.29. Use runtime checks to help our non-TS users.
    (0, utils_1.assert)(feeGranter === undefined || typeof feeGranter === "string", "feeGranter must be undefined or string");
    (0, utils_1.assert)(feePayer === undefined || typeof feePayer === "string", "feePayer must be undefined or string");
    const authInfo = tx_1.AuthInfo.fromPartial({
        signerInfos: makeSignerInfos(signers, signMode),
        fee: {
            amount: [...feeAmount],
            gasLimit: long_1.default.fromNumber(gasLimit),
            granter: feeGranter,
            payer: feePayer,
        },
    });
    return tx_1.AuthInfo.encode(authInfo).finish();
}
exports.makeAuthInfoBytes = makeAuthInfoBytes;
function makeSignDoc(bodyBytes, authInfoBytes, chainId, accountNumber) {
    return {
        bodyBytes: bodyBytes,
        authInfoBytes: authInfoBytes,
        chainId: chainId,
        accountNumber: long_1.default.fromNumber(accountNumber),
    };
}
exports.makeSignDoc = makeSignDoc;
function makeSignBytes({ accountNumber, authInfoBytes, bodyBytes, chainId }) {
    const signDoc = tx_1.SignDoc.fromPartial({
        accountNumber: accountNumber,
        authInfoBytes: authInfoBytes,
        bodyBytes: bodyBytes,
        chainId: chainId,
    });
    return tx_1.SignDoc.encode(signDoc).finish();
}
exports.makeSignBytes = makeSignBytes;
//# sourceMappingURL=signing.js.map

/***/ }),

/***/ 79449:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.decrypt = exports.encrypt = exports.supportedAlgorithms = exports.executeKdf = exports.cosmjsSalt = void 0;
const crypto_1 = __webpack_require__(45027);
const encoding_1 = __webpack_require__(87061);
/**
 * A fixed salt is chosen to archive a deterministic password to key derivation.
 * This reduces the scope of a potential rainbow attack to all CosmJS users.
 * Must be 16 bytes due to implementation limitations.
 */
exports.cosmjsSalt = (0, encoding_1.toAscii)("The CosmJS salt.");
async function executeKdf(password, configuration) {
    switch (configuration.algorithm) {
        case "argon2id": {
            const options = configuration.params;
            if (!(0, crypto_1.isArgon2idOptions)(options))
                throw new Error("Invalid format of argon2id params");
            return crypto_1.Argon2id.execute(password, exports.cosmjsSalt, options);
        }
        default:
            throw new Error("Unsupported KDF algorithm");
    }
}
exports.executeKdf = executeKdf;
exports.supportedAlgorithms = {
    xchacha20poly1305Ietf: "xchacha20poly1305-ietf",
};
async function encrypt(plaintext, encryptionKey, config) {
    switch (config.algorithm) {
        case exports.supportedAlgorithms.xchacha20poly1305Ietf: {
            const nonce = crypto_1.Random.getBytes(crypto_1.xchacha20NonceLength);
            // Prepend fixed-length nonce to ciphertext as suggested in the example from https://github.com/jedisct1/libsodium.js#api
            return new Uint8Array([
                ...nonce,
                ...(await crypto_1.Xchacha20poly1305Ietf.encrypt(plaintext, encryptionKey, nonce)),
            ]);
        }
        default:
            throw new Error(`Unsupported encryption algorithm: '${config.algorithm}'`);
    }
}
exports.encrypt = encrypt;
async function decrypt(ciphertext, encryptionKey, config) {
    switch (config.algorithm) {
        case exports.supportedAlgorithms.xchacha20poly1305Ietf: {
            const nonce = ciphertext.slice(0, crypto_1.xchacha20NonceLength);
            return crypto_1.Xchacha20poly1305Ietf.decrypt(ciphertext.slice(crypto_1.xchacha20NonceLength), encryptionKey, nonce);
        }
        default:
            throw new Error(`Unsupported encryption algorithm: '${config.algorithm}'`);
    }
}
exports.decrypt = decrypt;
//# sourceMappingURL=wallet.js.map

/***/ }),

/***/ 1568:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.StreamingSocket = exports.SocketWrapper = exports.ReconnectingSocket = exports.QueueingStreamingSocket = exports.ConnectionStatus = void 0;
var queueingstreamingsocket_1 = __webpack_require__(66489);
Object.defineProperty(exports, "ConnectionStatus", ({ enumerable: true, get: function () { return queueingstreamingsocket_1.ConnectionStatus; } }));
Object.defineProperty(exports, "QueueingStreamingSocket", ({ enumerable: true, get: function () { return queueingstreamingsocket_1.QueueingStreamingSocket; } }));
var reconnectingsocket_1 = __webpack_require__(29504);
Object.defineProperty(exports, "ReconnectingSocket", ({ enumerable: true, get: function () { return reconnectingsocket_1.ReconnectingSocket; } }));
var socketwrapper_1 = __webpack_require__(71421);
Object.defineProperty(exports, "SocketWrapper", ({ enumerable: true, get: function () { return socketwrapper_1.SocketWrapper; } }));
var streamingsocket_1 = __webpack_require__(7221);
Object.defineProperty(exports, "StreamingSocket", ({ enumerable: true, get: function () { return streamingsocket_1.StreamingSocket; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 66489:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.QueueingStreamingSocket = exports.ConnectionStatus = void 0;
const stream_1 = __webpack_require__(2464);
const xstream_1 = __webpack_require__(43813);
const streamingsocket_1 = __webpack_require__(7221);
var ConnectionStatus;
(function (ConnectionStatus) {
    ConnectionStatus[ConnectionStatus["Unconnected"] = 0] = "Unconnected";
    ConnectionStatus[ConnectionStatus["Connecting"] = 1] = "Connecting";
    ConnectionStatus[ConnectionStatus["Connected"] = 2] = "Connected";
    ConnectionStatus[ConnectionStatus["Disconnected"] = 3] = "Disconnected";
})(ConnectionStatus = exports.ConnectionStatus || (exports.ConnectionStatus = {}));
/**
 * A wrapper around StreamingSocket that can queue requests.
 */
class QueueingStreamingSocket {
    constructor(url, timeout = 10000, reconnectedHandler) {
        this.queue = [];
        this.isProcessingQueue = false;
        this.url = url;
        this.timeout = timeout;
        this.reconnectedHandler = reconnectedHandler;
        const eventProducer = {
            start: (listener) => (this.eventProducerListener = listener),
            stop: () => (this.eventProducerListener = undefined),
        };
        this.events = xstream_1.Stream.create(eventProducer);
        this.connectionStatusProducer = new stream_1.DefaultValueProducer(ConnectionStatus.Unconnected);
        this.connectionStatus = new stream_1.ValueAndUpdates(this.connectionStatusProducer);
        this.socket = new streamingsocket_1.StreamingSocket(this.url, this.timeout);
        this.socket.events.subscribe({
            next: (event) => {
                if (!this.eventProducerListener)
                    throw new Error("No event producer listener set");
                this.eventProducerListener.next(event);
            },
            error: () => this.connectionStatusProducer.update(ConnectionStatus.Disconnected),
        });
    }
    connect() {
        this.connectionStatusProducer.update(ConnectionStatus.Connecting);
        this.socket.connected.then(async () => {
            this.connectionStatusProducer.update(ConnectionStatus.Connected);
            return this.processQueue();
        }, () => this.connectionStatusProducer.update(ConnectionStatus.Disconnected));
        this.socket.connect();
    }
    disconnect() {
        this.connectionStatusProducer.update(ConnectionStatus.Disconnected);
        this.socket.disconnect();
    }
    reconnect() {
        this.socket = new streamingsocket_1.StreamingSocket(this.url, this.timeout);
        this.socket.events.subscribe({
            next: (event) => {
                if (!this.eventProducerListener)
                    throw new Error("No event producer listener set");
                this.eventProducerListener.next(event);
            },
            error: () => this.connectionStatusProducer.update(ConnectionStatus.Disconnected),
        });
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.socket.connected.then(() => {
            if (this.reconnectedHandler) {
                this.reconnectedHandler();
            }
        });
        this.connect();
    }
    getQueueLength() {
        return this.queue.length;
    }
    queueRequest(request) {
        this.queue.push(request);
        // We don’t need to wait for the queue to be processed.
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.processQueue();
    }
    async processQueue() {
        if (this.isProcessingQueue || this.connectionStatus.value !== ConnectionStatus.Connected) {
            return;
        }
        this.isProcessingQueue = true;
        let request;
        while ((request = this.queue.shift())) {
            try {
                await this.socket.send(request);
                this.isProcessingQueue = false;
            }
            catch (error) {
                // Probably the connection is down; will try again automatically when reconnected.
                this.queue.unshift(request);
                this.isProcessingQueue = false;
                return;
            }
        }
    }
}
exports.QueueingStreamingSocket = QueueingStreamingSocket;
//# sourceMappingURL=queueingstreamingsocket.js.map

/***/ }),

/***/ 29504:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ReconnectingSocket = void 0;
const xstream_1 = __webpack_require__(43813);
const queueingstreamingsocket_1 = __webpack_require__(66489);
/**
 * A wrapper around QueueingStreamingSocket that reconnects automatically.
 */
class ReconnectingSocket {
    /** Starts with a 0.1 second timeout, then doubles every attempt with a maximum timeout of 5 seconds. */
    static calculateTimeout(index) {
        return Math.min(2 ** index * 100, 5000);
    }
    constructor(url, timeout = 10000, reconnectedHandler) {
        this.unconnected = true;
        this.disconnected = false;
        this.timeoutIndex = 0;
        this.reconnectTimeout = null;
        const eventProducer = {
            start: (listener) => (this.eventProducerListener = listener),
            stop: () => (this.eventProducerListener = undefined),
        };
        this.events = xstream_1.Stream.create(eventProducer);
        this.socket = new queueingstreamingsocket_1.QueueingStreamingSocket(url, timeout, reconnectedHandler);
        this.socket.events.subscribe({
            next: (event) => {
                if (this.eventProducerListener) {
                    this.eventProducerListener.next(event);
                }
            },
            error: (error) => {
                if (this.eventProducerListener) {
                    this.eventProducerListener.error(error);
                }
            },
        });
        this.connectionStatus = this.socket.connectionStatus;
        this.connectionStatus.updates.subscribe({
            next: (status) => {
                if (status === queueingstreamingsocket_1.ConnectionStatus.Connected) {
                    this.timeoutIndex = 0;
                }
                if (status === queueingstreamingsocket_1.ConnectionStatus.Disconnected) {
                    if (this.reconnectTimeout) {
                        clearTimeout(this.reconnectTimeout);
                        this.reconnectTimeout = null;
                    }
                    this.reconnectTimeout = setTimeout(() => this.socket.reconnect(), ReconnectingSocket.calculateTimeout(this.timeoutIndex++));
                }
            },
        });
    }
    connect() {
        if (!this.unconnected) {
            throw new Error("Cannot connect: socket has already connected");
        }
        this.socket.connect();
        this.unconnected = false;
    }
    disconnect() {
        if (this.unconnected) {
            throw new Error("Cannot disconnect: socket has not yet connected");
        }
        this.socket.disconnect();
        if (this.eventProducerListener) {
            this.eventProducerListener.complete();
        }
        this.disconnected = true;
    }
    queueRequest(request) {
        if (this.disconnected) {
            throw new Error("Cannot queue request: socket has disconnected");
        }
        this.socket.queueRequest(request);
    }
}
exports.ReconnectingSocket = ReconnectingSocket;
//# sourceMappingURL=reconnectingsocket.js.map

/***/ }),

/***/ 71421:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(34155);

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.SocketWrapper = void 0;
const isomorphic_ws_1 = __importDefault(__webpack_require__(46792));
function environmentIsNodeJs() {
    return (typeof process !== "undefined" &&
        typeof process.versions !== "undefined" &&
        typeof process.versions.node !== "undefined");
}
/**
 * A thin wrapper around isomorphic-ws' WebSocket class that adds
 * - constant message/error/open/close handlers
 * - explict connection via a connect() method
 * - type support for events
 * - handling of corner cases in the open and close behaviour
 */
class SocketWrapper {
    constructor(url, messageHandler, errorHandler, openHandler, closeHandler, timeout = 10000) {
        this.closed = false;
        this.connected = new Promise((resolve, reject) => {
            this.connectedResolver = resolve;
            this.connectedRejecter = reject;
        });
        this.url = url;
        this.messageHandler = messageHandler;
        this.errorHandler = errorHandler;
        this.openHandler = openHandler;
        this.closeHandler = closeHandler;
        this.timeout = timeout;
    }
    /**
     * returns a promise that resolves when connection is open
     */
    connect() {
        const socket = new isomorphic_ws_1.default(this.url);
        socket.onerror = (error) => {
            this.clearTimeout();
            if (this.errorHandler) {
                this.errorHandler(error);
            }
        };
        socket.onmessage = (messageEvent) => {
            this.messageHandler({
                type: messageEvent.type,
                data: messageEvent.data,
            });
        };
        socket.onopen = (_) => {
            this.clearTimeout();
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            this.connectedResolver();
            if (this.openHandler) {
                this.openHandler();
            }
        };
        socket.onclose = (closeEvent) => {
            this.closed = true;
            if (this.closeHandler) {
                this.closeHandler(closeEvent);
            }
        };
        const started = Date.now();
        this.timeoutId = setTimeout(() => {
            socket.onmessage = () => 0;
            socket.onerror = () => 0;
            socket.onopen = () => 0;
            socket.onclose = () => 0;
            socket.close();
            this.socket = undefined;
            const elapsed = Math.floor(Date.now() - started);
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            this.connectedRejecter(`Connection attempt timed out after ${elapsed} ms`);
        }, this.timeout);
        this.socket = socket;
    }
    /**
     * Closes an established connection and aborts other connection states
     */
    disconnect() {
        if (!this.socket) {
            throw new Error("Socket undefined. This must be called after connecting.");
        }
        this.clearTimeout();
        switch (this.socket.readyState) {
            case isomorphic_ws_1.default.OPEN:
                this.socket.close(1000 /* Normal Closure */);
                break;
            case isomorphic_ws_1.default.CLOSED:
                // nothing to be done
                break;
            case isomorphic_ws_1.default.CONNECTING:
                // imitate missing abort API
                this.socket.onopen = () => 0;
                this.socket.onclose = () => 0;
                this.socket.onerror = () => 0;
                this.socket.onmessage = () => 0;
                this.socket = undefined;
                if (this.closeHandler) {
                    this.closeHandler({ wasClean: false, code: 4001 });
                }
                break;
            case isomorphic_ws_1.default.CLOSING:
                // already closing. Let it proceed
                break;
            default:
                throw new Error(`Unknown readyState: ${this.socket.readyState}`);
        }
    }
    async send(data) {
        return new Promise((resolve, reject) => {
            if (!this.socket) {
                throw new Error("Socket undefined. This must be called after connecting.");
            }
            if (this.closed) {
                throw new Error("Socket was closed, so no data can be sent anymore.");
            }
            // this exception should be thrown by send() automatically according to
            // https://developer.mozilla.org/de/docs/Web/API/WebSocket#send() but it does not work in browsers
            if (this.socket.readyState !== isomorphic_ws_1.default.OPEN) {
                throw new Error("Websocket is not open");
            }
            if (environmentIsNodeJs()) {
                this.socket.send(data, (err) => (err ? reject(err) : resolve()));
            }
            else {
                // Browser websocket send method does not accept a callback
                this.socket.send(data);
                resolve();
            }
        });
    }
    /**
     * Clears the timeout function, such that no timeout error will be raised anymore. This should be
     * called when the connection is established, a connection error occurred or the socket is disconnected.
     *
     * This method must not be called before `connect()`.
     * This method is idempotent.
     */
    clearTimeout() {
        if (!this.timeoutId) {
            throw new Error("Timeout ID not set. This should not happen and usually means connect() was not called.");
        }
        // Note: do not unset this.timeoutId to allow multiple calls to this function
        clearTimeout(this.timeoutId);
    }
}
exports.SocketWrapper = SocketWrapper;
//# sourceMappingURL=socketwrapper.js.map

/***/ }),

/***/ 7221:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.StreamingSocket = void 0;
const xstream_1 = __webpack_require__(43813);
const socketwrapper_1 = __webpack_require__(71421);
/**
 * A WebSocket wrapper that exposes all events as a stream.
 *
 * This underlying socket will not be closed when the stream has no listeners
 */
class StreamingSocket {
    constructor(url, timeout = 10000) {
        this.socket = new socketwrapper_1.SocketWrapper(url, (event) => {
            if (this.eventProducerListener) {
                this.eventProducerListener.next(event);
            }
        }, (errorEvent) => {
            if (this.eventProducerListener) {
                this.eventProducerListener.error(errorEvent);
            }
        }, () => {
            // socket opened
        }, (closeEvent) => {
            if (this.eventProducerListener) {
                if (closeEvent.wasClean) {
                    this.eventProducerListener.complete();
                }
                else {
                    this.eventProducerListener.error("Socket was closed unclean");
                }
            }
        }, timeout);
        this.connected = this.socket.connected;
        const eventProducer = {
            start: (listener) => (this.eventProducerListener = listener),
            stop: () => (this.eventProducerListener = undefined),
        };
        this.events = xstream_1.Stream.create(eventProducer);
    }
    connect() {
        this.socket.connect();
    }
    disconnect() {
        this.socket.disconnect();
    }
    async send(data) {
        return this.socket.send(data);
    }
}
exports.StreamingSocket = StreamingSocket;
//# sourceMappingURL=streamingsocket.js.map

/***/ }),

/***/ 58966:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.accountFromAny = void 0;
const math_1 = __webpack_require__(66021);
const proto_signing_1 = __webpack_require__(75216);
const utils_1 = __webpack_require__(62584);
const auth_1 = __webpack_require__(13394);
const vesting_1 = __webpack_require__(90416);
function uint64FromProto(input) {
    return math_1.Uint64.fromString(input.toString());
}
function accountFromBaseAccount(input) {
    const { address, pubKey, accountNumber, sequence } = input;
    const pubkey = pubKey ? (0, proto_signing_1.decodePubkey)(pubKey) : null;
    return {
        address: address,
        pubkey: pubkey,
        accountNumber: uint64FromProto(accountNumber).toNumber(),
        sequence: uint64FromProto(sequence).toNumber(),
    };
}
/**
 * Basic implementation of AccountParser. This is supposed to support the most relevant
 * common Cosmos SDK account types. If you need support for exotic account types,
 * you'll need to write your own account decoder.
 */
function accountFromAny(input) {
    const { typeUrl, value } = input;
    switch (typeUrl) {
        // auth
        case "/cosmos.auth.v1beta1.BaseAccount":
            return accountFromBaseAccount(auth_1.BaseAccount.decode(value));
        case "/cosmos.auth.v1beta1.ModuleAccount": {
            const baseAccount = auth_1.ModuleAccount.decode(value).baseAccount;
            (0, utils_1.assert)(baseAccount);
            return accountFromBaseAccount(baseAccount);
        }
        // vesting
        case "/cosmos.vesting.v1beta1.BaseVestingAccount": {
            const baseAccount = vesting_1.BaseVestingAccount.decode(value)?.baseAccount;
            (0, utils_1.assert)(baseAccount);
            return accountFromBaseAccount(baseAccount);
        }
        case "/cosmos.vesting.v1beta1.ContinuousVestingAccount": {
            const baseAccount = vesting_1.ContinuousVestingAccount.decode(value)?.baseVestingAccount?.baseAccount;
            (0, utils_1.assert)(baseAccount);
            return accountFromBaseAccount(baseAccount);
        }
        case "/cosmos.vesting.v1beta1.DelayedVestingAccount": {
            const baseAccount = vesting_1.DelayedVestingAccount.decode(value)?.baseVestingAccount?.baseAccount;
            (0, utils_1.assert)(baseAccount);
            return accountFromBaseAccount(baseAccount);
        }
        case "/cosmos.vesting.v1beta1.PeriodicVestingAccount": {
            const baseAccount = vesting_1.PeriodicVestingAccount.decode(value)?.baseVestingAccount?.baseAccount;
            (0, utils_1.assert)(baseAccount);
            return accountFromBaseAccount(baseAccount);
        }
        default:
            throw new Error(`Unsupported type: '${typeUrl}'`);
    }
}
exports.accountFromAny = accountFromAny;
//# sourceMappingURL=accounts.js.map

/***/ }),

/***/ 14162:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.AminoTypes = void 0;
/**
 * A map from Stargate message types as used in the messages's `Any` type
 * to Amino types.
 */
class AminoTypes {
    constructor(types) {
        this.register = types;
    }
    toAmino({ typeUrl, value }) {
        const converter = this.register[typeUrl];
        if (!converter) {
            throw new Error(`Type URL '${typeUrl}' does not exist in the Amino message type register. ` +
                "If you need support for this message type, you can pass in additional entries to the AminoTypes constructor. " +
                "If you think this message type should be included by default, please open an issue at https://github.com/cosmos/cosmjs/issues.");
        }
        return {
            type: converter.aminoType,
            value: converter.toAmino(value),
        };
    }
    fromAmino({ type, value }) {
        const matches = Object.entries(this.register).filter(([_typeUrl, { aminoType }]) => aminoType === type);
        switch (matches.length) {
            case 0: {
                throw new Error(`Amino type identifier '${type}' does not exist in the Amino message type register. ` +
                    "If you need support for this message type, you can pass in additional entries to the AminoTypes constructor. " +
                    "If you think this message type should be included by default, please open an issue at https://github.com/cosmos/cosmjs/issues.");
            }
            case 1: {
                const [typeUrl, converter] = matches[0];
                return {
                    typeUrl: typeUrl,
                    value: converter.fromAmino(value),
                };
            }
            default:
                throw new Error(`Multiple types are registered with Amino type identifier '${type}': '` +
                    matches
                        .map(([key, _value]) => key)
                        .sort()
                        .join("', '") +
                    "'. Thus fromAmino cannot be performed.");
        }
    }
}
exports.AminoTypes = AminoTypes;
//# sourceMappingURL=aminotypes.js.map

/***/ }),

/***/ 47737:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.fromTendermintEvent = void 0;
const encoding_1 = __webpack_require__(87061);
/**
 * Takes a Tendermint 0.34 or 0.37 event with binary encoded key and value
 * and converts it into an `Event` with string attributes.
 */
function fromTendermintEvent(event) {
    return {
        type: event.type,
        attributes: event.attributes.map((attr) => ({
            key: typeof attr.key == "string" ? attr.key : (0, encoding_1.fromUtf8)(attr.key, true),
            value: typeof attr.value == "string" ? attr.value : (0, encoding_1.fromUtf8)(attr.value, true),
        })),
    };
}
exports.fromTendermintEvent = fromTendermintEvent;
//# sourceMappingURL=events.js.map

/***/ }),

/***/ 5392:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.calculateFee = exports.GasPrice = void 0;
const math_1 = __webpack_require__(66021);
const proto_signing_1 = __webpack_require__(75216);
/**
 * Denom checker for the Cosmos SDK 0.42 denom pattern
 * (https://github.com/cosmos/cosmos-sdk/blob/v0.42.4/types/coin.go#L599-L601).
 *
 * This is like a regexp but with helpful error messages.
 */
function checkDenom(denom) {
    if (denom.length < 3 || denom.length > 128) {
        throw new Error("Denom must be between 3 and 128 characters");
    }
}
/**
 * A gas price, i.e. the price of a single unit of gas. This is typically a fraction of
 * the smallest fee token unit, such as 0.012utoken.
 */
class GasPrice {
    constructor(amount, denom) {
        this.amount = amount;
        this.denom = denom;
    }
    /**
     * Parses a gas price formatted as `<amount><denom>`, e.g. `GasPrice.fromString("0.012utoken")`.
     *
     * The denom must match the Cosmos SDK 0.42 pattern (https://github.com/cosmos/cosmos-sdk/blob/v0.42.4/types/coin.go#L599-L601).
     * See `GasPrice` in @cosmjs/stargate for a more generic matcher.
     *
     * Separators are not yet supported.
     */
    static fromString(gasPrice) {
        // Use Decimal.fromUserInput and checkDenom for detailed checks and helpful error messages
        const matchResult = gasPrice.match(/^([0-9.]+)([a-z][a-z0-9]*)$/i);
        if (!matchResult) {
            throw new Error("Invalid gas price string");
        }
        const [_, amount, denom] = matchResult;
        checkDenom(denom);
        const fractionalDigits = 18;
        const decimalAmount = math_1.Decimal.fromUserInput(amount, fractionalDigits);
        return new GasPrice(decimalAmount, denom);
    }
    /**
     * Returns a string representation of this gas price, e.g. "0.025uatom".
     * This can be used as an input to `GasPrice.fromString`.
     */
    toString() {
        return this.amount.toString() + this.denom;
    }
}
exports.GasPrice = GasPrice;
function calculateFee(gasLimit, gasPrice) {
    const processedGasPrice = typeof gasPrice === "string" ? GasPrice.fromString(gasPrice) : gasPrice;
    const { denom, amount: gasPriceAmount } = processedGasPrice;
    // Note: Amount can exceed the safe integer range (https://github.com/cosmos/cosmjs/issues/1134),
    // which we handle by converting from Decimal to string without going through number.
    const amount = gasPriceAmount.multiply(new math_1.Uint53(gasLimit)).ceil().toString();
    return {
        amount: (0, proto_signing_1.coins)(amount, denom),
        gas: gasLimit.toString(),
    };
}
exports.calculateFee = calculateFee;
//# sourceMappingURL=fee.js.map

/***/ }),

/***/ 66422:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.isMsgWithdrawDelegatorRewardEncodeObject = exports.isMsgVoteWeightedEncodeObject = exports.isMsgVoteEncodeObject = exports.isMsgUndelegateEncodeObject = exports.isMsgTransferEncodeObject = exports.isMsgSubmitProposalEncodeObject = exports.isMsgSendEncodeObject = exports.isMsgEditValidatorEncodeObject = exports.isMsgDepositEncodeObject = exports.isMsgDelegateEncodeObject = exports.isMsgCreateValidatorEncodeObject = exports.isMsgBeginRedelegateEncodeObject = exports.isAminoMsgWithdrawValidatorCommission = exports.isAminoMsgWithdrawDelegatorReward = exports.isAminoMsgVoteWeighted = exports.isAminoMsgVote = exports.isAminoMsgVerifyInvariant = exports.isAminoMsgUnjail = exports.isAminoMsgUndelegate = exports.isAminoMsgTransfer = exports.isAminoMsgSubmitProposal = exports.isAminoMsgSubmitEvidence = exports.isAminoMsgSetWithdrawAddress = exports.isAminoMsgSend = exports.isAminoMsgMultiSend = exports.isAminoMsgFundCommunityPool = exports.isAminoMsgEditValidator = exports.isAminoMsgDeposit = exports.isAminoMsgDelegate = exports.isAminoMsgCreateVestingAccount = exports.isAminoMsgCreateValidator = exports.isAminoMsgBeginRedelegate = exports.createVestingAminoConverters = exports.createStakingAminoConverters = exports.createSlashingAminoConverters = exports.createIbcAminoConverters = exports.createGroupAminoConverters = exports.createGovAminoConverters = exports.createFeegrantAminoConverters = exports.createEvidenceAminoConverters = exports.createDistributionAminoConverters = exports.createCrysisAminoConverters = exports.createBankAminoConverters = exports.createAuthzAminoConverters = exports.logs = exports.GasPrice = exports.calculateFee = exports.fromTendermintEvent = exports.AminoTypes = exports.accountFromAny = void 0;
exports.parseCoins = exports.makeCosmoshubPath = exports.coins = exports.coin = exports.TimeoutError = exports.StargateClient = exports.isDeliverTxSuccess = exports.isDeliverTxFailure = exports.BroadcastTxError = exports.assertIsDeliverTxSuccess = exports.assertIsDeliverTxFailure = exports.SigningStargateClient = exports.defaultRegistryTypes = exports.createDefaultAminoConverters = exports.QueryClient = exports.decodeCosmosSdkDecFromProto = exports.createProtobufRpcClient = exports.createPagination = exports.makeMultisignedTxBytes = exports.makeMultisignedTx = exports.setupTxExtension = exports.setupStakingExtension = exports.setupSlashingExtension = exports.setupMintExtension = exports.setupIbcExtension = exports.setupGovExtension = exports.setupFeegrantExtension = exports.setupDistributionExtension = exports.setupBankExtension = exports.setupAuthzExtension = exports.setupAuthExtension = void 0;
var accounts_1 = __webpack_require__(58966);
Object.defineProperty(exports, "accountFromAny", ({ enumerable: true, get: function () { return accounts_1.accountFromAny; } }));
var aminotypes_1 = __webpack_require__(14162);
Object.defineProperty(exports, "AminoTypes", ({ enumerable: true, get: function () { return aminotypes_1.AminoTypes; } }));
var events_1 = __webpack_require__(47737);
Object.defineProperty(exports, "fromTendermintEvent", ({ enumerable: true, get: function () { return events_1.fromTendermintEvent; } }));
var fee_1 = __webpack_require__(5392);
Object.defineProperty(exports, "calculateFee", ({ enumerable: true, get: function () { return fee_1.calculateFee; } }));
Object.defineProperty(exports, "GasPrice", ({ enumerable: true, get: function () { return fee_1.GasPrice; } }));
exports.logs = __importStar(__webpack_require__(16422));
var modules_1 = __webpack_require__(6749);
Object.defineProperty(exports, "createAuthzAminoConverters", ({ enumerable: true, get: function () { return modules_1.createAuthzAminoConverters; } }));
Object.defineProperty(exports, "createBankAminoConverters", ({ enumerable: true, get: function () { return modules_1.createBankAminoConverters; } }));
Object.defineProperty(exports, "createCrysisAminoConverters", ({ enumerable: true, get: function () { return modules_1.createCrysisAminoConverters; } }));
Object.defineProperty(exports, "createDistributionAminoConverters", ({ enumerable: true, get: function () { return modules_1.createDistributionAminoConverters; } }));
Object.defineProperty(exports, "createEvidenceAminoConverters", ({ enumerable: true, get: function () { return modules_1.createEvidenceAminoConverters; } }));
Object.defineProperty(exports, "createFeegrantAminoConverters", ({ enumerable: true, get: function () { return modules_1.createFeegrantAminoConverters; } }));
Object.defineProperty(exports, "createGovAminoConverters", ({ enumerable: true, get: function () { return modules_1.createGovAminoConverters; } }));
Object.defineProperty(exports, "createGroupAminoConverters", ({ enumerable: true, get: function () { return modules_1.createGroupAminoConverters; } }));
Object.defineProperty(exports, "createIbcAminoConverters", ({ enumerable: true, get: function () { return modules_1.createIbcAminoConverters; } }));
Object.defineProperty(exports, "createSlashingAminoConverters", ({ enumerable: true, get: function () { return modules_1.createSlashingAminoConverters; } }));
Object.defineProperty(exports, "createStakingAminoConverters", ({ enumerable: true, get: function () { return modules_1.createStakingAminoConverters; } }));
Object.defineProperty(exports, "createVestingAminoConverters", ({ enumerable: true, get: function () { return modules_1.createVestingAminoConverters; } }));
Object.defineProperty(exports, "isAminoMsgBeginRedelegate", ({ enumerable: true, get: function () { return modules_1.isAminoMsgBeginRedelegate; } }));
Object.defineProperty(exports, "isAminoMsgCreateValidator", ({ enumerable: true, get: function () { return modules_1.isAminoMsgCreateValidator; } }));
Object.defineProperty(exports, "isAminoMsgCreateVestingAccount", ({ enumerable: true, get: function () { return modules_1.isAminoMsgCreateVestingAccount; } }));
Object.defineProperty(exports, "isAminoMsgDelegate", ({ enumerable: true, get: function () { return modules_1.isAminoMsgDelegate; } }));
Object.defineProperty(exports, "isAminoMsgDeposit", ({ enumerable: true, get: function () { return modules_1.isAminoMsgDeposit; } }));
Object.defineProperty(exports, "isAminoMsgEditValidator", ({ enumerable: true, get: function () { return modules_1.isAminoMsgEditValidator; } }));
Object.defineProperty(exports, "isAminoMsgFundCommunityPool", ({ enumerable: true, get: function () { return modules_1.isAminoMsgFundCommunityPool; } }));
Object.defineProperty(exports, "isAminoMsgMultiSend", ({ enumerable: true, get: function () { return modules_1.isAminoMsgMultiSend; } }));
Object.defineProperty(exports, "isAminoMsgSend", ({ enumerable: true, get: function () { return modules_1.isAminoMsgSend; } }));
Object.defineProperty(exports, "isAminoMsgSetWithdrawAddress", ({ enumerable: true, get: function () { return modules_1.isAminoMsgSetWithdrawAddress; } }));
Object.defineProperty(exports, "isAminoMsgSubmitEvidence", ({ enumerable: true, get: function () { return modules_1.isAminoMsgSubmitEvidence; } }));
Object.defineProperty(exports, "isAminoMsgSubmitProposal", ({ enumerable: true, get: function () { return modules_1.isAminoMsgSubmitProposal; } }));
Object.defineProperty(exports, "isAminoMsgTransfer", ({ enumerable: true, get: function () { return modules_1.isAminoMsgTransfer; } }));
Object.defineProperty(exports, "isAminoMsgUndelegate", ({ enumerable: true, get: function () { return modules_1.isAminoMsgUndelegate; } }));
Object.defineProperty(exports, "isAminoMsgUnjail", ({ enumerable: true, get: function () { return modules_1.isAminoMsgUnjail; } }));
Object.defineProperty(exports, "isAminoMsgVerifyInvariant", ({ enumerable: true, get: function () { return modules_1.isAminoMsgVerifyInvariant; } }));
Object.defineProperty(exports, "isAminoMsgVote", ({ enumerable: true, get: function () { return modules_1.isAminoMsgVote; } }));
Object.defineProperty(exports, "isAminoMsgVoteWeighted", ({ enumerable: true, get: function () { return modules_1.isAminoMsgVoteWeighted; } }));
Object.defineProperty(exports, "isAminoMsgWithdrawDelegatorReward", ({ enumerable: true, get: function () { return modules_1.isAminoMsgWithdrawDelegatorReward; } }));
Object.defineProperty(exports, "isAminoMsgWithdrawValidatorCommission", ({ enumerable: true, get: function () { return modules_1.isAminoMsgWithdrawValidatorCommission; } }));
Object.defineProperty(exports, "isMsgBeginRedelegateEncodeObject", ({ enumerable: true, get: function () { return modules_1.isMsgBeginRedelegateEncodeObject; } }));
Object.defineProperty(exports, "isMsgCreateValidatorEncodeObject", ({ enumerable: true, get: function () { return modules_1.isMsgCreateValidatorEncodeObject; } }));
Object.defineProperty(exports, "isMsgDelegateEncodeObject", ({ enumerable: true, get: function () { return modules_1.isMsgDelegateEncodeObject; } }));
Object.defineProperty(exports, "isMsgDepositEncodeObject", ({ enumerable: true, get: function () { return modules_1.isMsgDepositEncodeObject; } }));
Object.defineProperty(exports, "isMsgEditValidatorEncodeObject", ({ enumerable: true, get: function () { return modules_1.isMsgEditValidatorEncodeObject; } }));
Object.defineProperty(exports, "isMsgSendEncodeObject", ({ enumerable: true, get: function () { return modules_1.isMsgSendEncodeObject; } }));
Object.defineProperty(exports, "isMsgSubmitProposalEncodeObject", ({ enumerable: true, get: function () { return modules_1.isMsgSubmitProposalEncodeObject; } }));
Object.defineProperty(exports, "isMsgTransferEncodeObject", ({ enumerable: true, get: function () { return modules_1.isMsgTransferEncodeObject; } }));
Object.defineProperty(exports, "isMsgUndelegateEncodeObject", ({ enumerable: true, get: function () { return modules_1.isMsgUndelegateEncodeObject; } }));
Object.defineProperty(exports, "isMsgVoteEncodeObject", ({ enumerable: true, get: function () { return modules_1.isMsgVoteEncodeObject; } }));
Object.defineProperty(exports, "isMsgVoteWeightedEncodeObject", ({ enumerable: true, get: function () { return modules_1.isMsgVoteWeightedEncodeObject; } }));
Object.defineProperty(exports, "isMsgWithdrawDelegatorRewardEncodeObject", ({ enumerable: true, get: function () { return modules_1.isMsgWithdrawDelegatorRewardEncodeObject; } }));
Object.defineProperty(exports, "setupAuthExtension", ({ enumerable: true, get: function () { return modules_1.setupAuthExtension; } }));
Object.defineProperty(exports, "setupAuthzExtension", ({ enumerable: true, get: function () { return modules_1.setupAuthzExtension; } }));
Object.defineProperty(exports, "setupBankExtension", ({ enumerable: true, get: function () { return modules_1.setupBankExtension; } }));
Object.defineProperty(exports, "setupDistributionExtension", ({ enumerable: true, get: function () { return modules_1.setupDistributionExtension; } }));
Object.defineProperty(exports, "setupFeegrantExtension", ({ enumerable: true, get: function () { return modules_1.setupFeegrantExtension; } }));
Object.defineProperty(exports, "setupGovExtension", ({ enumerable: true, get: function () { return modules_1.setupGovExtension; } }));
Object.defineProperty(exports, "setupIbcExtension", ({ enumerable: true, get: function () { return modules_1.setupIbcExtension; } }));
Object.defineProperty(exports, "setupMintExtension", ({ enumerable: true, get: function () { return modules_1.setupMintExtension; } }));
Object.defineProperty(exports, "setupSlashingExtension", ({ enumerable: true, get: function () { return modules_1.setupSlashingExtension; } }));
Object.defineProperty(exports, "setupStakingExtension", ({ enumerable: true, get: function () { return modules_1.setupStakingExtension; } }));
Object.defineProperty(exports, "setupTxExtension", ({ enumerable: true, get: function () { return modules_1.setupTxExtension; } }));
var multisignature_1 = __webpack_require__(55799);
Object.defineProperty(exports, "makeMultisignedTx", ({ enumerable: true, get: function () { return multisignature_1.makeMultisignedTx; } }));
Object.defineProperty(exports, "makeMultisignedTxBytes", ({ enumerable: true, get: function () { return multisignature_1.makeMultisignedTxBytes; } }));
var queryclient_1 = __webpack_require__(46300);
Object.defineProperty(exports, "createPagination", ({ enumerable: true, get: function () { return queryclient_1.createPagination; } }));
Object.defineProperty(exports, "createProtobufRpcClient", ({ enumerable: true, get: function () { return queryclient_1.createProtobufRpcClient; } }));
Object.defineProperty(exports, "decodeCosmosSdkDecFromProto", ({ enumerable: true, get: function () { return queryclient_1.decodeCosmosSdkDecFromProto; } }));
Object.defineProperty(exports, "QueryClient", ({ enumerable: true, get: function () { return queryclient_1.QueryClient; } }));
var signingstargateclient_1 = __webpack_require__(73110);
Object.defineProperty(exports, "createDefaultAminoConverters", ({ enumerable: true, get: function () { return signingstargateclient_1.createDefaultAminoConverters; } }));
Object.defineProperty(exports, "defaultRegistryTypes", ({ enumerable: true, get: function () { return signingstargateclient_1.defaultRegistryTypes; } }));
Object.defineProperty(exports, "SigningStargateClient", ({ enumerable: true, get: function () { return signingstargateclient_1.SigningStargateClient; } }));
var stargateclient_1 = __webpack_require__(38577);
Object.defineProperty(exports, "assertIsDeliverTxFailure", ({ enumerable: true, get: function () { return stargateclient_1.assertIsDeliverTxFailure; } }));
Object.defineProperty(exports, "assertIsDeliverTxSuccess", ({ enumerable: true, get: function () { return stargateclient_1.assertIsDeliverTxSuccess; } }));
Object.defineProperty(exports, "BroadcastTxError", ({ enumerable: true, get: function () { return stargateclient_1.BroadcastTxError; } }));
Object.defineProperty(exports, "isDeliverTxFailure", ({ enumerable: true, get: function () { return stargateclient_1.isDeliverTxFailure; } }));
Object.defineProperty(exports, "isDeliverTxSuccess", ({ enumerable: true, get: function () { return stargateclient_1.isDeliverTxSuccess; } }));
Object.defineProperty(exports, "StargateClient", ({ enumerable: true, get: function () { return stargateclient_1.StargateClient; } }));
Object.defineProperty(exports, "TimeoutError", ({ enumerable: true, get: function () { return stargateclient_1.TimeoutError; } }));
var proto_signing_1 = __webpack_require__(75216);
Object.defineProperty(exports, "coin", ({ enumerable: true, get: function () { return proto_signing_1.coin; } }));
Object.defineProperty(exports, "coins", ({ enumerable: true, get: function () { return proto_signing_1.coins; } }));
Object.defineProperty(exports, "makeCosmoshubPath", ({ enumerable: true, get: function () { return proto_signing_1.makeCosmoshubPath; } }));
Object.defineProperty(exports, "parseCoins", ({ enumerable: true, get: function () { return proto_signing_1.parseCoins; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 16422:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.findAttribute = exports.parseRawLog = exports.parseLogs = exports.parseLog = exports.parseEvent = exports.parseAttribute = void 0;
/* eslint-disable @typescript-eslint/naming-convention */
const utils_1 = __webpack_require__(62584);
function parseAttribute(input) {
    if (!(0, utils_1.isNonNullObject)(input))
        throw new Error("Attribute must be a non-null object");
    const { key, value } = input;
    if (typeof key !== "string" || !key)
        throw new Error("Attribute's key must be a non-empty string");
    if (typeof value !== "string" && typeof value !== "undefined") {
        throw new Error("Attribute's value must be a string or unset");
    }
    return {
        key: key,
        value: value || "",
    };
}
exports.parseAttribute = parseAttribute;
function parseEvent(input) {
    if (!(0, utils_1.isNonNullObject)(input))
        throw new Error("Event must be a non-null object");
    const { type, attributes } = input;
    if (typeof type !== "string" || type === "") {
        throw new Error(`Event type must be a non-empty string`);
    }
    if (!Array.isArray(attributes))
        throw new Error("Event's attributes must be an array");
    return {
        type: type,
        attributes: attributes.map(parseAttribute),
    };
}
exports.parseEvent = parseEvent;
function parseLog(input) {
    if (!(0, utils_1.isNonNullObject)(input))
        throw new Error("Log must be a non-null object");
    const { msg_index, log, events } = input;
    if (typeof msg_index !== "number")
        throw new Error("Log's msg_index must be a number");
    if (typeof log !== "string")
        throw new Error("Log's log must be a string");
    if (!Array.isArray(events))
        throw new Error("Log's events must be an array");
    return {
        msg_index: msg_index,
        log: log,
        events: events.map(parseEvent),
    };
}
exports.parseLog = parseLog;
function parseLogs(input) {
    if (!Array.isArray(input))
        throw new Error("Logs must be an array");
    return input.map(parseLog);
}
exports.parseLogs = parseLogs;
function parseRawLog(input = "[]") {
    const logsToParse = JSON.parse(input).map(({ events }, i) => ({
        msg_index: i,
        events,
        log: "",
    }));
    return parseLogs(logsToParse);
}
exports.parseRawLog = parseRawLog;
/**
 * Searches in logs for the first event of the given event type and in that event
 * for the first first attribute with the given attribute key.
 *
 * Throws if the attribute was not found.
 */
function findAttribute(logs, eventType, attrKey) {
    const firstLogs = logs.find(() => true);
    const out = firstLogs?.events
        .find((event) => event.type === eventType)
        ?.attributes.find((attr) => attr.key === attrKey);
    if (!out) {
        throw new Error(`Could not find attribute '${attrKey}' in first event of type '${eventType}' in first log.`);
    }
    return out;
}
exports.findAttribute = findAttribute;
//# sourceMappingURL=logs.js.map

/***/ }),

/***/ 99057:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.setupAuthExtension = void 0;
const query_1 = __webpack_require__(23043);
const queryclient_1 = __webpack_require__(46300);
function setupAuthExtension(base) {
    const rpc = (0, queryclient_1.createProtobufRpcClient)(base);
    // Use this service to get easy typed access to query methods
    // This cannot be used for proof verification
    const queryService = new query_1.QueryClientImpl(rpc);
    return {
        auth: {
            account: async (address) => {
                const { account } = await queryService.Account({ address: address });
                return account ?? null;
            },
        },
    };
}
exports.setupAuthExtension = setupAuthExtension;
//# sourceMappingURL=queries.js.map

/***/ }),

/***/ 70578:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.createAuthzAminoConverters = void 0;
function createAuthzAminoConverters() {
    return {
    // For Cosmos SDK < 0.46 the Amino JSON codec was broken on chain and thus inaccessible.
    // Now this can be implemented for 0.46+ chains, see
    // https://github.com/cosmos/cosmjs/issues/1092
    //
    // "/cosmos.authz.v1beta1.MsgGrant": IMPLEMENT ME,
    // "/cosmos.authz.v1beta1.MsgExec": IMPLEMENT ME,
    // "/cosmos.authz.v1beta1.MsgRevoke": IMPLEMENT ME,
    };
}
exports.createAuthzAminoConverters = createAuthzAminoConverters;
//# sourceMappingURL=aminomessages.js.map

/***/ }),

/***/ 39495:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.authzTypes = void 0;
const tx_1 = __webpack_require__(10892);
exports.authzTypes = [
    ["/cosmos.authz.v1beta1.MsgExec", tx_1.MsgExec],
    ["/cosmos.authz.v1beta1.MsgGrant", tx_1.MsgGrant],
    ["/cosmos.authz.v1beta1.MsgRevoke", tx_1.MsgRevoke],
];
//# sourceMappingURL=messages.js.map

/***/ }),

/***/ 32672:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.setupAuthzExtension = void 0;
const query_1 = __webpack_require__(80150);
const queryclient_1 = __webpack_require__(46300);
function setupAuthzExtension(base) {
    // Use this service to get easy typed access to query methods
    // This cannot be used for proof verification
    const rpc = (0, queryclient_1.createProtobufRpcClient)(base);
    const queryService = new query_1.QueryClientImpl(rpc);
    return {
        authz: {
            grants: async (granter, grantee, msgTypeUrl, paginationKey) => {
                return await queryService.Grants({
                    granter: granter,
                    grantee: grantee,
                    msgTypeUrl: msgTypeUrl,
                    pagination: (0, queryclient_1.createPagination)(paginationKey),
                });
            },
            granteeGrants: async (grantee, paginationKey) => {
                return await queryService.GranteeGrants({
                    grantee: grantee,
                    pagination: (0, queryclient_1.createPagination)(paginationKey),
                });
            },
            granterGrants: async (granter, paginationKey) => {
                return await queryService.GranterGrants({
                    granter: granter,
                    pagination: (0, queryclient_1.createPagination)(paginationKey),
                });
            },
        },
    };
}
exports.setupAuthzExtension = setupAuthzExtension;
//# sourceMappingURL=queries.js.map

/***/ }),

/***/ 30121:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.createBankAminoConverters = exports.isAminoMsgMultiSend = exports.isAminoMsgSend = void 0;
function isAminoMsgSend(msg) {
    return msg.type === "cosmos-sdk/MsgSend";
}
exports.isAminoMsgSend = isAminoMsgSend;
function isAminoMsgMultiSend(msg) {
    return msg.type === "cosmos-sdk/MsgMultiSend";
}
exports.isAminoMsgMultiSend = isAminoMsgMultiSend;
function createBankAminoConverters() {
    return {
        "/cosmos.bank.v1beta1.MsgSend": {
            aminoType: "cosmos-sdk/MsgSend",
            toAmino: ({ fromAddress, toAddress, amount }) => ({
                from_address: fromAddress,
                to_address: toAddress,
                amount: [...amount],
            }),
            fromAmino: ({ from_address, to_address, amount }) => ({
                fromAddress: from_address,
                toAddress: to_address,
                amount: [...amount],
            }),
        },
        "/cosmos.bank.v1beta1.MsgMultiSend": {
            aminoType: "cosmos-sdk/MsgMultiSend",
            toAmino: ({ inputs, outputs }) => ({
                inputs: inputs.map((input) => ({
                    address: input.address,
                    coins: [...input.coins],
                })),
                outputs: outputs.map((output) => ({
                    address: output.address,
                    coins: [...output.coins],
                })),
            }),
            fromAmino: ({ inputs, outputs }) => ({
                inputs: inputs.map((input) => ({
                    address: input.address,
                    coins: [...input.coins],
                })),
                outputs: outputs.map((output) => ({
                    address: output.address,
                    coins: [...output.coins],
                })),
            }),
        },
    };
}
exports.createBankAminoConverters = createBankAminoConverters;
//# sourceMappingURL=aminomessages.js.map

/***/ }),

/***/ 93045:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.isMsgSendEncodeObject = exports.bankTypes = void 0;
const tx_1 = __webpack_require__(59534);
exports.bankTypes = [
    ["/cosmos.bank.v1beta1.MsgMultiSend", tx_1.MsgMultiSend],
    ["/cosmos.bank.v1beta1.MsgSend", tx_1.MsgSend],
];
function isMsgSendEncodeObject(encodeObject) {
    return encodeObject.typeUrl === "/cosmos.bank.v1beta1.MsgSend";
}
exports.isMsgSendEncodeObject = isMsgSendEncodeObject;
//# sourceMappingURL=messages.js.map

/***/ }),

/***/ 28887:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.setupBankExtension = void 0;
/* eslint-disable @typescript-eslint/naming-convention */
const utils_1 = __webpack_require__(62584);
const query_1 = __webpack_require__(91586);
const queryclient_1 = __webpack_require__(46300);
function setupBankExtension(base) {
    const rpc = (0, queryclient_1.createProtobufRpcClient)(base);
    // Use this service to get easy typed access to query methods
    // This cannot be used for proof verification
    const queryService = new query_1.QueryClientImpl(rpc);
    return {
        bank: {
            balance: async (address, denom) => {
                const { balance } = await queryService.Balance({ address: address, denom: denom });
                (0, utils_1.assert)(balance);
                return balance;
            },
            allBalances: async (address) => {
                const { balances } = await queryService.AllBalances({ address: address });
                return balances;
            },
            totalSupply: async (paginationKey) => {
                const response = await queryService.TotalSupply({
                    pagination: (0, queryclient_1.createPagination)(paginationKey),
                });
                return response;
            },
            supplyOf: async (denom) => {
                const { amount } = await queryService.SupplyOf({ denom: denom });
                (0, utils_1.assert)(amount);
                return amount;
            },
            denomMetadata: async (denom) => {
                const { metadata } = await queryService.DenomMetadata({ denom });
                (0, utils_1.assert)(metadata);
                return metadata;
            },
            denomsMetadata: async () => {
                const { metadatas } = await queryService.DenomsMetadata({
                    pagination: undefined, // Not implemented
                });
                return metadatas;
            },
        },
    };
}
exports.setupBankExtension = setupBankExtension;
//# sourceMappingURL=queries.js.map

/***/ }),

/***/ 12085:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.createCrysisAminoConverters = exports.isAminoMsgVerifyInvariant = void 0;
function isAminoMsgVerifyInvariant(msg) {
    return msg.type === "cosmos-sdk/MsgVerifyInvariant";
}
exports.isAminoMsgVerifyInvariant = isAminoMsgVerifyInvariant;
function createCrysisAminoConverters() {
    throw new Error("Not implemented");
}
exports.createCrysisAminoConverters = createCrysisAminoConverters;
//# sourceMappingURL=aminomessages.js.map

/***/ }),

/***/ 41265:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.createDistributionAminoConverters = exports.isAminoMsgFundCommunityPool = exports.isAminoMsgWithdrawValidatorCommission = exports.isAminoMsgWithdrawDelegatorReward = exports.isAminoMsgSetWithdrawAddress = void 0;
function isAminoMsgSetWithdrawAddress(msg) {
    // NOTE: Type string and names diverge here!
    return msg.type === "cosmos-sdk/MsgModifyWithdrawAddress";
}
exports.isAminoMsgSetWithdrawAddress = isAminoMsgSetWithdrawAddress;
function isAminoMsgWithdrawDelegatorReward(msg) {
    // NOTE: Type string and names diverge here!
    return msg.type === "cosmos-sdk/MsgWithdrawDelegationReward";
}
exports.isAminoMsgWithdrawDelegatorReward = isAminoMsgWithdrawDelegatorReward;
function isAminoMsgWithdrawValidatorCommission(msg) {
    return msg.type === "cosmos-sdk/MsgWithdrawValidatorCommission";
}
exports.isAminoMsgWithdrawValidatorCommission = isAminoMsgWithdrawValidatorCommission;
function isAminoMsgFundCommunityPool(msg) {
    return msg.type === "cosmos-sdk/MsgFundCommunityPool";
}
exports.isAminoMsgFundCommunityPool = isAminoMsgFundCommunityPool;
function createDistributionAminoConverters() {
    return {
        "/cosmos.distribution.v1beta1.MsgFundCommunityPool": {
            aminoType: "cosmos-sdk/MsgFundCommunityPool",
            toAmino: ({ amount, depositor }) => ({
                amount: [...amount],
                depositor: depositor,
            }),
            fromAmino: ({ amount, depositor }) => ({
                amount: [...amount],
                depositor: depositor,
            }),
        },
        "/cosmos.distribution.v1beta1.MsgSetWithdrawAddress": {
            aminoType: "cosmos-sdk/MsgModifyWithdrawAddress",
            toAmino: ({ delegatorAddress, withdrawAddress, }) => ({
                delegator_address: delegatorAddress,
                withdraw_address: withdrawAddress,
            }),
            fromAmino: ({ delegator_address, withdraw_address, }) => ({
                delegatorAddress: delegator_address,
                withdrawAddress: withdraw_address,
            }),
        },
        "/cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward": {
            aminoType: "cosmos-sdk/MsgWithdrawDelegationReward",
            toAmino: ({ delegatorAddress, validatorAddress, }) => ({
                delegator_address: delegatorAddress,
                validator_address: validatorAddress,
            }),
            fromAmino: ({ delegator_address, validator_address, }) => ({
                delegatorAddress: delegator_address,
                validatorAddress: validator_address,
            }),
        },
        "/cosmos.distribution.v1beta1.MsgWithdrawValidatorCommission": {
            aminoType: "cosmos-sdk/MsgWithdrawValidatorCommission",
            toAmino: ({ validatorAddress, }) => ({
                validator_address: validatorAddress,
            }),
            fromAmino: ({ validator_address, }) => ({
                validatorAddress: validator_address,
            }),
        },
    };
}
exports.createDistributionAminoConverters = createDistributionAminoConverters;
//# sourceMappingURL=aminomessages.js.map

/***/ }),

/***/ 32551:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.isMsgWithdrawDelegatorRewardEncodeObject = exports.distributionTypes = void 0;
const tx_1 = __webpack_require__(80798);
exports.distributionTypes = [
    ["/cosmos.distribution.v1beta1.MsgFundCommunityPool", tx_1.MsgFundCommunityPool],
    ["/cosmos.distribution.v1beta1.MsgSetWithdrawAddress", tx_1.MsgSetWithdrawAddress],
    ["/cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward", tx_1.MsgWithdrawDelegatorReward],
    ["/cosmos.distribution.v1beta1.MsgWithdrawValidatorCommission", tx_1.MsgWithdrawValidatorCommission],
];
function isMsgWithdrawDelegatorRewardEncodeObject(object) {
    return (object.typeUrl ===
        "/cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward");
}
exports.isMsgWithdrawDelegatorRewardEncodeObject = isMsgWithdrawDelegatorRewardEncodeObject;
//# sourceMappingURL=messages.js.map

/***/ }),

/***/ 4953:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.setupDistributionExtension = void 0;
/* eslint-disable @typescript-eslint/naming-convention */
const query_1 = __webpack_require__(72731);
const long_1 = __importDefault(__webpack_require__(10648));
const queryclient_1 = __webpack_require__(46300);
function setupDistributionExtension(base) {
    const rpc = (0, queryclient_1.createProtobufRpcClient)(base);
    // Use this service to get easy typed access to query methods
    // This cannot be used for proof verification
    const queryService = new query_1.QueryClientImpl(rpc);
    return {
        distribution: {
            communityPool: async () => {
                const response = await queryService.CommunityPool({});
                return response;
            },
            delegationRewards: async (delegatorAddress, validatorAddress) => {
                const response = await queryService.DelegationRewards({
                    delegatorAddress: delegatorAddress,
                    validatorAddress: validatorAddress,
                });
                return response;
            },
            delegationTotalRewards: async (delegatorAddress) => {
                const response = await queryService.DelegationTotalRewards({
                    delegatorAddress: delegatorAddress,
                });
                return response;
            },
            delegatorValidators: async (delegatorAddress) => {
                const response = await queryService.DelegatorValidators({
                    delegatorAddress: delegatorAddress,
                });
                return response;
            },
            delegatorWithdrawAddress: async (delegatorAddress) => {
                const response = await queryService.DelegatorWithdrawAddress({
                    delegatorAddress: delegatorAddress,
                });
                return response;
            },
            params: async () => {
                const response = await queryService.Params({});
                return response;
            },
            validatorCommission: async (validatorAddress) => {
                const response = await queryService.ValidatorCommission({
                    validatorAddress: validatorAddress,
                });
                return response;
            },
            validatorOutstandingRewards: async (validatorAddress) => {
                const response = await queryService.ValidatorOutstandingRewards({
                    validatorAddress: validatorAddress,
                });
                return response;
            },
            validatorSlashes: async (validatorAddress, startingHeight, endingHeight, paginationKey) => {
                const response = await queryService.ValidatorSlashes({
                    validatorAddress: validatorAddress,
                    startingHeight: long_1.default.fromNumber(startingHeight, true),
                    endingHeight: long_1.default.fromNumber(endingHeight, true),
                    pagination: (0, queryclient_1.createPagination)(paginationKey),
                });
                return response;
            },
        },
    };
}
exports.setupDistributionExtension = setupDistributionExtension;
//# sourceMappingURL=queries.js.map

/***/ }),

/***/ 41801:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.createEvidenceAminoConverters = exports.isAminoMsgSubmitEvidence = void 0;
function isAminoMsgSubmitEvidence(msg) {
    return msg.type === "cosmos-sdk/MsgSubmitEvidence";
}
exports.isAminoMsgSubmitEvidence = isAminoMsgSubmitEvidence;
function createEvidenceAminoConverters() {
    throw new Error("Not implemented");
}
exports.createEvidenceAminoConverters = createEvidenceAminoConverters;
//# sourceMappingURL=aminomessages.js.map

/***/ }),

/***/ 31020:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.createFeegrantAminoConverters = void 0;
function createFeegrantAminoConverters() {
    return {
    // For Cosmos SDK < 0.46 the Amino JSON codec was broken on chain and thus inaccessible.
    // Now this can be implemented for 0.46+ chains, see
    // https://github.com/cosmos/cosmjs/issues/1092
    //
    // "/cosmos.feegrant.v1beta1.MsgGrantAllowance": IMPLEMENT_ME,
    // "/cosmos.feegrant.v1beta1.MsgRevokeAllowance": IMPLEMENT_ME,
    };
}
exports.createFeegrantAminoConverters = createFeegrantAminoConverters;
//# sourceMappingURL=aminomessages.js.map

/***/ }),

/***/ 34949:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.feegrantTypes = void 0;
const tx_1 = __webpack_require__(57431);
exports.feegrantTypes = [
    ["/cosmos.feegrant.v1beta1.MsgGrantAllowance", tx_1.MsgGrantAllowance],
    ["/cosmos.feegrant.v1beta1.MsgRevokeAllowance", tx_1.MsgRevokeAllowance],
];
//# sourceMappingURL=messages.js.map

/***/ }),

/***/ 8941:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.setupFeegrantExtension = void 0;
const query_1 = __webpack_require__(47613);
const queryclient_1 = __webpack_require__(46300);
function setupFeegrantExtension(base) {
    // Use this service to get easy typed access to query methods
    // This cannot be used for proof verification
    const rpc = (0, queryclient_1.createProtobufRpcClient)(base);
    const queryService = new query_1.QueryClientImpl(rpc);
    return {
        feegrant: {
            allowance: async (granter, grantee) => {
                const response = await queryService.Allowance({
                    granter: granter,
                    grantee: grantee,
                });
                return response;
            },
            allowances: async (grantee, paginationKey) => {
                const response = await queryService.Allowances({
                    grantee: grantee,
                    pagination: (0, queryclient_1.createPagination)(paginationKey),
                });
                return response;
            },
        },
    };
}
exports.setupFeegrantExtension = setupFeegrantExtension;
//# sourceMappingURL=queries.js.map

/***/ }),

/***/ 75900:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.createGovAminoConverters = exports.isAminoMsgDeposit = exports.isAminoMsgVoteWeighted = exports.isAminoMsgVote = exports.isAminoMsgSubmitProposal = void 0;
const math_1 = __webpack_require__(66021);
const utils_1 = __webpack_require__(62584);
const gov_1 = __webpack_require__(48615);
const any_1 = __webpack_require__(75654);
const long_1 = __importDefault(__webpack_require__(10648));
const queryclient_1 = __webpack_require__(46300);
function isAminoMsgSubmitProposal(msg) {
    return msg.type === "cosmos-sdk/MsgSubmitProposal";
}
exports.isAminoMsgSubmitProposal = isAminoMsgSubmitProposal;
function isAminoMsgVote(msg) {
    return msg.type === "cosmos-sdk/MsgVote";
}
exports.isAminoMsgVote = isAminoMsgVote;
function isAminoMsgVoteWeighted(msg) {
    return msg.type === "cosmos-sdk/MsgVoteWeighted";
}
exports.isAminoMsgVoteWeighted = isAminoMsgVoteWeighted;
function isAminoMsgDeposit(msg) {
    return msg.type === "cosmos-sdk/MsgDeposit";
}
exports.isAminoMsgDeposit = isAminoMsgDeposit;
function createGovAminoConverters() {
    // Gov v1 types missing, see
    // https://github.com/cosmos/cosmjs/issues/1442
    return {
        "/cosmos.gov.v1beta1.MsgDeposit": {
            aminoType: "cosmos-sdk/MsgDeposit",
            toAmino: ({ amount, depositor, proposalId }) => {
                return {
                    amount,
                    depositor,
                    proposal_id: proposalId.toString(),
                };
            },
            fromAmino: ({ amount, depositor, proposal_id }) => {
                return {
                    amount: Array.from(amount),
                    depositor,
                    proposalId: long_1.default.fromString(proposal_id),
                };
            },
        },
        "/cosmos.gov.v1beta1.MsgVote": {
            aminoType: "cosmos-sdk/MsgVote",
            toAmino: ({ option, proposalId, voter }) => {
                return {
                    option: option,
                    proposal_id: proposalId.toString(),
                    voter: voter,
                };
            },
            fromAmino: ({ option, proposal_id, voter }) => {
                return {
                    option: (0, gov_1.voteOptionFromJSON)(option),
                    proposalId: long_1.default.fromString(proposal_id),
                    voter: voter,
                };
            },
        },
        "/cosmos.gov.v1beta1.MsgVoteWeighted": {
            aminoType: "cosmos-sdk/MsgVoteWeighted",
            toAmino: ({ options, proposalId, voter }) => {
                return {
                    options: options.map((o) => ({
                        option: o.option,
                        // Weight is between 0 and 1, so we always have 20 characters when printing all trailing
                        // zeros (e.g. "0.700000000000000000" or "1.000000000000000000")
                        weight: (0, queryclient_1.decodeCosmosSdkDecFromProto)(o.weight).toString().padEnd(20, "0"),
                    })),
                    proposal_id: proposalId.toString(),
                    voter: voter,
                };
            },
            fromAmino: ({ options, proposal_id, voter }) => {
                return {
                    proposalId: long_1.default.fromString(proposal_id),
                    voter: voter,
                    options: options.map((o) => ({
                        option: (0, gov_1.voteOptionFromJSON)(o.option),
                        weight: math_1.Decimal.fromUserInput(o.weight, 18).atomics,
                    })),
                };
            },
        },
        "/cosmos.gov.v1beta1.MsgSubmitProposal": {
            aminoType: "cosmos-sdk/MsgSubmitProposal",
            toAmino: ({ initialDeposit, proposer, content, }) => {
                (0, utils_1.assertDefinedAndNotNull)(content);
                let proposal;
                switch (content.typeUrl) {
                    case "/cosmos.gov.v1beta1.TextProposal": {
                        const textProposal = gov_1.TextProposal.decode(content.value);
                        proposal = {
                            type: "cosmos-sdk/TextProposal",
                            value: {
                                description: textProposal.description,
                                title: textProposal.title,
                            },
                        };
                        break;
                    }
                    default:
                        throw new Error(`Unsupported proposal type: '${content.typeUrl}'`);
                }
                return {
                    initial_deposit: initialDeposit,
                    proposer: proposer,
                    content: proposal,
                };
            },
            fromAmino: ({ initial_deposit, proposer, content, }) => {
                let any_content;
                switch (content.type) {
                    case "cosmos-sdk/TextProposal": {
                        const { value } = content;
                        (0, utils_1.assert)((0, utils_1.isNonNullObject)(value));
                        const { title, description } = value;
                        (0, utils_1.assert)(typeof title === "string");
                        (0, utils_1.assert)(typeof description === "string");
                        any_content = any_1.Any.fromPartial({
                            typeUrl: "/cosmos.gov.v1beta1.TextProposal",
                            value: gov_1.TextProposal.encode(gov_1.TextProposal.fromPartial({
                                title: title,
                                description: description,
                            })).finish(),
                        });
                        break;
                    }
                    default:
                        throw new Error(`Unsupported proposal type: '${content.type}'`);
                }
                return {
                    initialDeposit: Array.from(initial_deposit),
                    proposer: proposer,
                    content: any_content,
                };
            },
        },
    };
}
exports.createGovAminoConverters = createGovAminoConverters;
//# sourceMappingURL=aminomessages.js.map

/***/ }),

/***/ 16984:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.isMsgVoteWeightedEncodeObject = exports.isMsgVoteEncodeObject = exports.isMsgSubmitProposalEncodeObject = exports.isMsgDepositEncodeObject = exports.govTypes = void 0;
const tx_1 = __webpack_require__(13037);
const tx_2 = __webpack_require__(37429);
exports.govTypes = [
    ["/cosmos.gov.v1.MsgDeposit", tx_1.MsgDeposit],
    ["/cosmos.gov.v1.MsgSubmitProposal", tx_1.MsgSubmitProposal],
    ["/cosmos.gov.v1.MsgUpdateParams", tx_1.MsgUpdateParams],
    ["/cosmos.gov.v1.MsgVote", tx_1.MsgVote],
    ["/cosmos.gov.v1.MsgVoteWeighted", tx_1.MsgVoteWeighted],
    ["/cosmos.gov.v1beta1.MsgDeposit", tx_2.MsgDeposit],
    ["/cosmos.gov.v1beta1.MsgSubmitProposal", tx_2.MsgSubmitProposal],
    ["/cosmos.gov.v1beta1.MsgVote", tx_2.MsgVote],
    ["/cosmos.gov.v1beta1.MsgVoteWeighted", tx_2.MsgVoteWeighted],
];
function isMsgDepositEncodeObject(object) {
    return object.typeUrl === "/cosmos.gov.v1beta1.MsgDeposit";
}
exports.isMsgDepositEncodeObject = isMsgDepositEncodeObject;
function isMsgSubmitProposalEncodeObject(object) {
    return object.typeUrl === "/cosmos.gov.v1beta1.MsgSubmitProposal";
}
exports.isMsgSubmitProposalEncodeObject = isMsgSubmitProposalEncodeObject;
function isMsgVoteEncodeObject(object) {
    return object.typeUrl === "/cosmos.gov.v1beta1.MsgVote";
}
exports.isMsgVoteEncodeObject = isMsgVoteEncodeObject;
function isMsgVoteWeightedEncodeObject(object) {
    return object.typeUrl === "/cosmos.gov.v1beta1.MsgVoteWeighted";
}
exports.isMsgVoteWeightedEncodeObject = isMsgVoteWeightedEncodeObject;
//# sourceMappingURL=messages.js.map

/***/ }),

/***/ 56122:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.setupGovExtension = void 0;
const query_1 = __webpack_require__(54583);
const queryclient_1 = __webpack_require__(46300);
function setupGovExtension(base) {
    const rpc = (0, queryclient_1.createProtobufRpcClient)(base);
    // Use this service to get easy typed access to query methods
    // This cannot be used for proof verification
    const queryService = new query_1.QueryClientImpl(rpc);
    return {
        gov: {
            params: async (parametersType) => {
                const response = await queryService.Params({ paramsType: parametersType });
                return response;
            },
            proposals: async (proposalStatus, depositorAddress, voterAddress, paginationKey) => {
                const response = await queryService.Proposals({
                    proposalStatus,
                    depositor: depositorAddress,
                    voter: voterAddress,
                    pagination: (0, queryclient_1.createPagination)(paginationKey),
                });
                return response;
            },
            proposal: async (proposalId) => {
                const response = await queryService.Proposal({ proposalId: (0, queryclient_1.longify)(proposalId) });
                return response;
            },
            deposits: async (proposalId, paginationKey) => {
                const response = await queryService.Deposits({
                    proposalId: (0, queryclient_1.longify)(proposalId),
                    pagination: (0, queryclient_1.createPagination)(paginationKey),
                });
                return response;
            },
            deposit: async (proposalId, depositorAddress) => {
                const response = await queryService.Deposit({
                    proposalId: (0, queryclient_1.longify)(proposalId),
                    depositor: depositorAddress,
                });
                return response;
            },
            tally: async (proposalId) => {
                const response = await queryService.TallyResult({
                    proposalId: (0, queryclient_1.longify)(proposalId),
                });
                return response;
            },
            votes: async (proposalId, paginationKey) => {
                const response = await queryService.Votes({
                    proposalId: (0, queryclient_1.longify)(proposalId),
                    pagination: (0, queryclient_1.createPagination)(paginationKey),
                });
                return response;
            },
            vote: async (proposalId, voterAddress) => {
                const response = await queryService.Vote({
                    proposalId: (0, queryclient_1.longify)(proposalId),
                    voter: voterAddress,
                });
                return response;
            },
        },
    };
}
exports.setupGovExtension = setupGovExtension;
//# sourceMappingURL=queries.js.map

/***/ }),

/***/ 92655:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.createGroupAminoConverters = void 0;
function createGroupAminoConverters() {
    // Missing, see https://github.com/cosmos/cosmjs/issues/1441
    return {};
}
exports.createGroupAminoConverters = createGroupAminoConverters;
//# sourceMappingURL=aminomessages.js.map

/***/ }),

/***/ 71102:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.groupTypes = void 0;
const tx_1 = __webpack_require__(80126);
exports.groupTypes = [
    ["/cosmos.group.v1.MsgCreateGroup", tx_1.MsgCreateGroup],
    ["/cosmos.group.v1.MsgCreateGroupPolicy", tx_1.MsgCreateGroupPolicy],
    ["/cosmos.group.v1.MsgCreateGroupWithPolicy", tx_1.MsgCreateGroupWithPolicy],
    ["/cosmos.group.v1.MsgExec", tx_1.MsgExec],
    ["/cosmos.group.v1.MsgLeaveGroup", tx_1.MsgLeaveGroup],
    ["/cosmos.group.v1.MsgSubmitProposal", tx_1.MsgSubmitProposal],
    ["/cosmos.group.v1.MsgUpdateGroupAdmin", tx_1.MsgUpdateGroupAdmin],
    ["/cosmos.group.v1.MsgUpdateGroupMembers", tx_1.MsgUpdateGroupMembers],
    ["/cosmos.group.v1.MsgUpdateGroupMetadata", tx_1.MsgUpdateGroupMetadata],
    ["/cosmos.group.v1.MsgUpdateGroupPolicyAdmin", tx_1.MsgUpdateGroupPolicyAdmin],
    ["/cosmos.group.v1.MsgUpdateGroupPolicyDecisionPolicy", tx_1.MsgUpdateGroupPolicyDecisionPolicy],
    ["/cosmos.group.v1.MsgUpdateGroupPolicyMetadata", tx_1.MsgUpdateGroupPolicyMetadata],
    ["/cosmos.group.v1.MsgVote", tx_1.MsgVote],
    ["/cosmos.group.v1.MsgWithdrawProposal", tx_1.MsgWithdrawProposal],
];
// There are no EncodeObject implementations for the new v1 message types because
// those things don't scale (https://github.com/cosmos/cosmjs/issues/1440). We need to
// address this more fundamentally. Users can use
// const msg = {
//   typeUrl: "/cosmos.group.v1.MsgCreateGroup",
//   value: MsgCreateGroup.fromPartial({ ... })
// }
// in their app.
//# sourceMappingURL=messages.js.map

/***/ }),

/***/ 71655:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.createIbcAminoConverters = exports.isAminoMsgTransfer = void 0;
const tx_1 = __webpack_require__(88313);
const long_1 = __importDefault(__webpack_require__(10648));
function isAminoMsgTransfer(msg) {
    return msg.type === "cosmos-sdk/MsgTransfer";
}
exports.isAminoMsgTransfer = isAminoMsgTransfer;
function omitDefault(input) {
    if (typeof input === "string") {
        return input === "" ? undefined : input;
    }
    if (typeof input === "number") {
        return input === 0 ? undefined : input;
    }
    if (long_1.default.isLong(input)) {
        return input.isZero() ? undefined : input;
    }
    throw new Error(`Got unsupported type '${typeof input}'`);
}
function createIbcAminoConverters() {
    return {
        "/ibc.applications.transfer.v1.MsgTransfer": {
            aminoType: "cosmos-sdk/MsgTransfer",
            toAmino: ({ sourcePort, sourceChannel, token, sender, receiver, timeoutHeight, timeoutTimestamp, memo, }) => ({
                source_port: sourcePort,
                source_channel: sourceChannel,
                token: token,
                sender: sender,
                receiver: receiver,
                timeout_height: timeoutHeight
                    ? {
                        revision_height: omitDefault(timeoutHeight.revisionHeight)?.toString(),
                        revision_number: omitDefault(timeoutHeight.revisionNumber)?.toString(),
                    }
                    : {},
                timeout_timestamp: omitDefault(timeoutTimestamp)?.toString(),
                memo: omitDefault(memo)?.toString(),
            }),
            fromAmino: ({ source_port, source_channel, token, sender, receiver, timeout_height, timeout_timestamp, memo, }) => tx_1.MsgTransfer.fromPartial({
                sourcePort: source_port,
                sourceChannel: source_channel,
                token: token,
                sender: sender,
                receiver: receiver,
                timeoutHeight: timeout_height
                    ? {
                        revisionHeight: long_1.default.fromString(timeout_height.revision_height || "0", true),
                        revisionNumber: long_1.default.fromString(timeout_height.revision_number || "0", true),
                    }
                    : undefined,
                timeoutTimestamp: long_1.default.fromString(timeout_timestamp || "0", true),
                memo: memo ?? "",
            }),
        },
    };
}
exports.createIbcAminoConverters = createIbcAminoConverters;
//# sourceMappingURL=aminomessages.js.map

/***/ }),

/***/ 72611:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.isMsgTransferEncodeObject = exports.ibcTypes = void 0;
const tx_1 = __webpack_require__(88313);
const tx_2 = __webpack_require__(11104);
const tx_3 = __webpack_require__(66519);
const tx_4 = __webpack_require__(41579);
exports.ibcTypes = [
    ["/ibc.applications.transfer.v1.MsgTransfer", tx_1.MsgTransfer],
    ["/ibc.core.channel.v1.MsgAcknowledgement", tx_2.MsgAcknowledgement],
    ["/ibc.core.channel.v1.MsgChannelCloseConfirm", tx_2.MsgChannelCloseConfirm],
    ["/ibc.core.channel.v1.MsgChannelCloseInit", tx_2.MsgChannelCloseInit],
    ["/ibc.core.channel.v1.MsgChannelOpenAck", tx_2.MsgChannelOpenAck],
    ["/ibc.core.channel.v1.MsgChannelOpenConfirm", tx_2.MsgChannelOpenConfirm],
    ["/ibc.core.channel.v1.MsgChannelOpenInit", tx_2.MsgChannelOpenInit],
    ["/ibc.core.channel.v1.MsgChannelOpenTry", tx_2.MsgChannelOpenTry],
    ["/ibc.core.channel.v1.MsgRecvPacket", tx_2.MsgRecvPacket],
    ["/ibc.core.channel.v1.MsgTimeout", tx_2.MsgTimeout],
    ["/ibc.core.channel.v1.MsgTimeoutOnClose", tx_2.MsgTimeoutOnClose],
    ["/ibc.core.client.v1.MsgCreateClient", tx_3.MsgCreateClient],
    ["/ibc.core.client.v1.MsgSubmitMisbehaviour", tx_3.MsgSubmitMisbehaviour],
    ["/ibc.core.client.v1.MsgUpdateClient", tx_3.MsgUpdateClient],
    ["/ibc.core.client.v1.MsgUpgradeClient", tx_3.MsgUpgradeClient],
    ["/ibc.core.connection.v1.MsgConnectionOpenAck", tx_4.MsgConnectionOpenAck],
    ["/ibc.core.connection.v1.MsgConnectionOpenConfirm", tx_4.MsgConnectionOpenConfirm],
    ["/ibc.core.connection.v1.MsgConnectionOpenInit", tx_4.MsgConnectionOpenInit],
    ["/ibc.core.connection.v1.MsgConnectionOpenTry", tx_4.MsgConnectionOpenTry],
];
function isMsgTransferEncodeObject(object) {
    return object.typeUrl === "/ibc.applications.transfer.v1.MsgTransfer";
}
exports.isMsgTransferEncodeObject = isMsgTransferEncodeObject;
//# sourceMappingURL=messages.js.map

/***/ }),

/***/ 51398:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.setupIbcExtension = void 0;
/* eslint-disable @typescript-eslint/naming-convention */
const encoding_1 = __webpack_require__(87061);
const math_1 = __webpack_require__(66021);
const query_1 = __webpack_require__(14007);
const channel_1 = __webpack_require__(24007);
const query_2 = __webpack_require__(6958);
const query_3 = __webpack_require__(52989);
const query_4 = __webpack_require__(67014);
const tendermint_1 = __webpack_require__(24398);
const long_1 = __importDefault(__webpack_require__(10648));
const queryclient_1 = __webpack_require__(46300);
function decodeTendermintClientStateAny(clientState) {
    if (clientState?.typeUrl !== "/ibc.lightclients.tendermint.v1.ClientState") {
        throw new Error(`Unexpected client state type: ${clientState?.typeUrl}`);
    }
    return tendermint_1.ClientState.decode(clientState.value);
}
function decodeTendermintConsensusStateAny(clientState) {
    if (clientState?.typeUrl !== "/ibc.lightclients.tendermint.v1.ConsensusState") {
        throw new Error(`Unexpected client state type: ${clientState?.typeUrl}`);
    }
    return tendermint_1.ConsensusState.decode(clientState.value);
}
function setupIbcExtension(base) {
    const rpc = (0, queryclient_1.createProtobufRpcClient)(base);
    // Use these services to get easy typed access to query methods
    // These cannot be used for proof verification
    const channelQueryService = new query_2.QueryClientImpl(rpc);
    const clientQueryService = new query_3.QueryClientImpl(rpc);
    const connectionQueryService = new query_4.QueryClientImpl(rpc);
    const transferQueryService = new query_1.QueryClientImpl(rpc);
    return {
        ibc: {
            channel: {
                channel: async (portId, channelId) => channelQueryService.Channel({
                    portId: portId,
                    channelId: channelId,
                }),
                channels: async (paginationKey) => channelQueryService.Channels({
                    pagination: (0, queryclient_1.createPagination)(paginationKey),
                }),
                allChannels: async () => {
                    const channels = [];
                    let response;
                    let key;
                    do {
                        response = await channelQueryService.Channels({
                            pagination: (0, queryclient_1.createPagination)(key),
                        });
                        channels.push(...response.channels);
                        key = response.pagination?.nextKey;
                    } while (key && key.length);
                    return {
                        channels: channels,
                        height: response.height,
                    };
                },
                connectionChannels: async (connection, paginationKey) => channelQueryService.ConnectionChannels({
                    connection: connection,
                    pagination: (0, queryclient_1.createPagination)(paginationKey),
                }),
                allConnectionChannels: async (connection) => {
                    const channels = [];
                    let response;
                    let key;
                    do {
                        response = await channelQueryService.ConnectionChannels({
                            connection: connection,
                            pagination: (0, queryclient_1.createPagination)(key),
                        });
                        channels.push(...response.channels);
                        key = response.pagination?.nextKey;
                    } while (key && key.length);
                    return {
                        channels: channels,
                        height: response.height,
                    };
                },
                clientState: async (portId, channelId) => channelQueryService.ChannelClientState({
                    portId: portId,
                    channelId: channelId,
                }),
                consensusState: async (portId, channelId, revisionNumber, revisionHeight) => channelQueryService.ChannelConsensusState({
                    portId: portId,
                    channelId: channelId,
                    revisionNumber: long_1.default.fromNumber(revisionNumber, true),
                    revisionHeight: long_1.default.fromNumber(revisionHeight, true),
                }),
                packetCommitment: async (portId, channelId, sequence) => channelQueryService.PacketCommitment({
                    portId: portId,
                    channelId: channelId,
                    sequence: long_1.default.fromNumber(sequence, true),
                }),
                packetCommitments: async (portId, channelId, paginationKey) => channelQueryService.PacketCommitments({
                    channelId: channelId,
                    portId: portId,
                    pagination: (0, queryclient_1.createPagination)(paginationKey),
                }),
                allPacketCommitments: async (portId, channelId) => {
                    const commitments = [];
                    let response;
                    let key;
                    do {
                        response = await channelQueryService.PacketCommitments({
                            channelId: channelId,
                            portId: portId,
                            pagination: (0, queryclient_1.createPagination)(key),
                        });
                        commitments.push(...response.commitments);
                        key = response.pagination?.nextKey;
                    } while (key && key.length);
                    return {
                        commitments: commitments,
                        height: response.height,
                    };
                },
                packetReceipt: async (portId, channelId, sequence) => channelQueryService.PacketReceipt({
                    portId: portId,
                    channelId: channelId,
                    sequence: long_1.default.fromNumber(sequence, true),
                }),
                packetAcknowledgement: async (portId, channelId, sequence) => channelQueryService.PacketAcknowledgement({
                    portId: portId,
                    channelId: channelId,
                    sequence: long_1.default.fromNumber(sequence, true),
                }),
                packetAcknowledgements: async (portId, channelId, paginationKey) => {
                    const request = query_2.QueryPacketAcknowledgementsRequest.fromPartial({
                        portId: portId,
                        channelId: channelId,
                        pagination: (0, queryclient_1.createPagination)(paginationKey),
                    });
                    return channelQueryService.PacketAcknowledgements(request);
                },
                allPacketAcknowledgements: async (portId, channelId) => {
                    const acknowledgements = [];
                    let response;
                    let key;
                    do {
                        const request = query_2.QueryPacketAcknowledgementsRequest.fromPartial({
                            channelId: channelId,
                            portId: portId,
                            pagination: (0, queryclient_1.createPagination)(key),
                        });
                        response = await channelQueryService.PacketAcknowledgements(request);
                        acknowledgements.push(...response.acknowledgements);
                        key = response.pagination?.nextKey;
                    } while (key && key.length);
                    return {
                        acknowledgements: acknowledgements,
                        height: response.height,
                    };
                },
                unreceivedPackets: async (portId, channelId, packetCommitmentSequences) => channelQueryService.UnreceivedPackets({
                    portId: portId,
                    channelId: channelId,
                    packetCommitmentSequences: packetCommitmentSequences.map((s) => long_1.default.fromNumber(s, true)),
                }),
                unreceivedAcks: async (portId, channelId, packetAckSequences) => channelQueryService.UnreceivedAcks({
                    portId: portId,
                    channelId: channelId,
                    packetAckSequences: packetAckSequences.map((s) => long_1.default.fromNumber(s, true)),
                }),
                nextSequenceReceive: async (portId, channelId) => channelQueryService.NextSequenceReceive({
                    portId: portId,
                    channelId: channelId,
                }),
            },
            client: {
                state: async (clientId) => clientQueryService.ClientState({ clientId }),
                states: async (paginationKey) => clientQueryService.ClientStates({
                    pagination: (0, queryclient_1.createPagination)(paginationKey),
                }),
                allStates: async () => {
                    const clientStates = [];
                    let response;
                    let key;
                    do {
                        response = await clientQueryService.ClientStates({
                            pagination: (0, queryclient_1.createPagination)(key),
                        });
                        clientStates.push(...response.clientStates);
                        key = response.pagination?.nextKey;
                    } while (key && key.length);
                    return {
                        clientStates: clientStates,
                    };
                },
                consensusState: async (clientId, consensusHeight) => clientQueryService.ConsensusState(query_3.QueryConsensusStateRequest.fromPartial({
                    clientId: clientId,
                    revisionHeight: consensusHeight !== undefined ? long_1.default.fromNumber(consensusHeight, true) : undefined,
                    latestHeight: consensusHeight === undefined,
                })),
                consensusStates: async (clientId, paginationKey) => clientQueryService.ConsensusStates({
                    clientId: clientId,
                    pagination: (0, queryclient_1.createPagination)(paginationKey),
                }),
                allConsensusStates: async (clientId) => {
                    const consensusStates = [];
                    let response;
                    let key;
                    do {
                        response = await clientQueryService.ConsensusStates({
                            clientId: clientId,
                            pagination: (0, queryclient_1.createPagination)(key),
                        });
                        consensusStates.push(...response.consensusStates);
                        key = response.pagination?.nextKey;
                    } while (key && key.length);
                    return {
                        consensusStates: consensusStates,
                    };
                },
                params: async () => clientQueryService.ClientParams({}),
                stateTm: async (clientId) => {
                    const response = await clientQueryService.ClientState({ clientId });
                    return decodeTendermintClientStateAny(response.clientState);
                },
                statesTm: async (paginationKey) => {
                    const { clientStates } = await clientQueryService.ClientStates({
                        pagination: (0, queryclient_1.createPagination)(paginationKey),
                    });
                    return clientStates.map(({ clientState }) => decodeTendermintClientStateAny(clientState));
                },
                allStatesTm: async () => {
                    const clientStates = [];
                    let response;
                    let key;
                    do {
                        response = await clientQueryService.ClientStates({
                            pagination: (0, queryclient_1.createPagination)(key),
                        });
                        clientStates.push(...response.clientStates);
                        key = response.pagination?.nextKey;
                    } while (key && key.length);
                    return clientStates.map(({ clientState }) => decodeTendermintClientStateAny(clientState));
                },
                consensusStateTm: async (clientId, consensusHeight) => {
                    const response = await clientQueryService.ConsensusState(query_3.QueryConsensusStateRequest.fromPartial({
                        clientId: clientId,
                        revisionHeight: consensusHeight?.revisionHeight,
                        revisionNumber: consensusHeight?.revisionNumber,
                        latestHeight: consensusHeight === undefined,
                    }));
                    return decodeTendermintConsensusStateAny(response.consensusState);
                },
            },
            connection: {
                connection: async (connectionId) => connectionQueryService.Connection({
                    connectionId: connectionId,
                }),
                connections: async (paginationKey) => connectionQueryService.Connections({
                    pagination: (0, queryclient_1.createPagination)(paginationKey),
                }),
                allConnections: async () => {
                    const connections = [];
                    let response;
                    let key;
                    do {
                        response = await connectionQueryService.Connections({
                            pagination: (0, queryclient_1.createPagination)(key),
                        });
                        connections.push(...response.connections);
                        key = response.pagination?.nextKey;
                    } while (key && key.length);
                    return {
                        connections: connections,
                        height: response.height,
                    };
                },
                clientConnections: async (clientId) => connectionQueryService.ClientConnections({
                    clientId: clientId,
                }),
                clientState: async (connectionId) => connectionQueryService.ConnectionClientState({
                    connectionId: connectionId,
                }),
                consensusState: async (connectionId, revisionHeight) => connectionQueryService.ConnectionConsensusState(query_4.QueryConnectionConsensusStateRequest.fromPartial({
                    connectionId: connectionId,
                    revisionHeight: long_1.default.fromNumber(revisionHeight, true),
                })),
            },
            transfer: {
                denomTrace: async (hash) => transferQueryService.DenomTrace({ hash: hash }),
                denomTraces: async (paginationKey) => transferQueryService.DenomTraces({
                    pagination: (0, queryclient_1.createPagination)(paginationKey),
                }),
                allDenomTraces: async () => {
                    const denomTraces = [];
                    let response;
                    let key;
                    do {
                        response = await transferQueryService.DenomTraces({
                            pagination: (0, queryclient_1.createPagination)(key),
                        });
                        denomTraces.push(...response.denomTraces);
                        key = response.pagination?.nextKey;
                    } while (key && key.length);
                    return {
                        denomTraces: denomTraces,
                    };
                },
                params: async () => transferQueryService.Params({}),
            },
            verified: {
                channel: {
                    channel: async (portId, channelId) => {
                        // keeper: https://github.com/cosmos/cosmos-sdk/blob/3bafd8255a502e5a9cee07391cf8261538245dfd/x/ibc/04-channel/keeper/keeper.go#L55-L65
                        // key: https://github.com/cosmos/cosmos-sdk/blob/ef0a7344af345882729598bc2958a21143930a6b/x/ibc/24-host/keys.go#L117-L120
                        const key = (0, encoding_1.toAscii)(`channelEnds/ports/${portId}/channels/${channelId}`);
                        const { value } = await base.queryStoreVerified("ibc", key);
                        return value.length ? channel_1.Channel.decode(value) : null;
                    },
                    packetCommitment: async (portId, channelId, sequence) => {
                        // keeper: https://github.com/cosmos/cosmos-sdk/blob/3bafd8255a502e5a9cee07391cf8261538245dfd/x/ibc/04-channel/keeper/keeper.go#L128-L133
                        // key: https://github.com/cosmos/cosmos-sdk/blob/ef0a7344af345882729598bc2958a21143930a6b/x/ibc/24-host/keys.go#L183-L185
                        const key = (0, encoding_1.toAscii)(`commitments/ports/${portId}/channels/${channelId}/packets/${sequence}`);
                        const { value } = await base.queryStoreVerified("ibc", key);
                        // keeper code doesn't parse, but returns raw
                        return value;
                    },
                    packetAcknowledgement: async (portId, channelId, sequence) => {
                        // keeper: https://github.com/cosmos/cosmos-sdk/blob/3bafd8255a502e5a9cee07391cf8261538245dfd/x/ibc/04-channel/keeper/keeper.go#L159-L166
                        // key: https://github.com/cosmos/cosmos-sdk/blob/ef0a7344af345882729598bc2958a21143930a6b/x/ibc/24-host/keys.go#L153-L156
                        const key = (0, encoding_1.toAscii)(`acks/ports/${portId}/channels/${channelId}/acknowledgements/${sequence}`);
                        const { value } = await base.queryStoreVerified("ibc", key);
                        // keeper code doesn't parse, but returns raw
                        return value;
                    },
                    nextSequenceReceive: async (portId, channelId) => {
                        // keeper: https://github.com/cosmos/cosmos-sdk/blob/3bafd8255a502e5a9cee07391cf8261538245dfd/x/ibc/04-channel/keeper/keeper.go#L92-L101
                        // key: https://github.com/cosmos/cosmos-sdk/blob/ef0a7344af345882729598bc2958a21143930a6b/x/ibc/24-host/keys.go#L133-L136
                        const key = (0, encoding_1.toAscii)(`seqAcks/ports/${portId}/channels/${channelId}/nextSequenceAck`);
                        const { value } = await base.queryStoreVerified("ibc", key);
                        return value.length ? math_1.Uint64.fromBytes(value).toNumber() : null;
                    },
                },
            },
        },
    };
}
exports.setupIbcExtension = setupIbcExtension;
//# sourceMappingURL=queries.js.map

/***/ }),

/***/ 6749:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.isAminoMsgCreateValidator = exports.isAminoMsgBeginRedelegate = exports.createStakingAminoConverters = exports.setupSlashingExtension = exports.isAminoMsgUnjail = exports.createSlashingAminoConverters = exports.setupMintExtension = exports.setupIbcExtension = exports.isMsgTransferEncodeObject = exports.ibcTypes = exports.isAminoMsgTransfer = exports.createIbcAminoConverters = exports.groupTypes = exports.createGroupAminoConverters = exports.setupGovExtension = exports.isMsgVoteWeightedEncodeObject = exports.isMsgVoteEncodeObject = exports.isMsgSubmitProposalEncodeObject = exports.isMsgDepositEncodeObject = exports.govTypes = exports.isAminoMsgVoteWeighted = exports.isAminoMsgVote = exports.isAminoMsgSubmitProposal = exports.isAminoMsgDeposit = exports.createGovAminoConverters = exports.setupFeegrantExtension = exports.feegrantTypes = exports.createFeegrantAminoConverters = exports.isAminoMsgSubmitEvidence = exports.createEvidenceAminoConverters = exports.setupDistributionExtension = exports.isMsgWithdrawDelegatorRewardEncodeObject = exports.distributionTypes = exports.isAminoMsgWithdrawValidatorCommission = exports.isAminoMsgWithdrawDelegatorReward = exports.isAminoMsgSetWithdrawAddress = exports.isAminoMsgFundCommunityPool = exports.createDistributionAminoConverters = exports.isAminoMsgVerifyInvariant = exports.createCrysisAminoConverters = exports.setupBankExtension = exports.isMsgSendEncodeObject = exports.bankTypes = exports.isAminoMsgSend = exports.isAminoMsgMultiSend = exports.createBankAminoConverters = exports.setupAuthzExtension = exports.authzTypes = exports.createAuthzAminoConverters = exports.setupAuthExtension = void 0;
exports.vestingTypes = exports.isAminoMsgCreateVestingAccount = exports.createVestingAminoConverters = exports.setupTxExtension = exports.setupStakingExtension = exports.stakingTypes = exports.isMsgUndelegateEncodeObject = exports.isMsgEditValidatorEncodeObject = exports.isMsgDelegateEncodeObject = exports.isMsgCreateValidatorEncodeObject = exports.isMsgBeginRedelegateEncodeObject = exports.isAminoMsgUndelegate = exports.isAminoMsgEditValidator = exports.isAminoMsgDelegate = void 0;
var queries_1 = __webpack_require__(99057);
Object.defineProperty(exports, "setupAuthExtension", ({ enumerable: true, get: function () { return queries_1.setupAuthExtension; } }));
var aminomessages_1 = __webpack_require__(70578);
Object.defineProperty(exports, "createAuthzAminoConverters", ({ enumerable: true, get: function () { return aminomessages_1.createAuthzAminoConverters; } }));
var messages_1 = __webpack_require__(39495);
Object.defineProperty(exports, "authzTypes", ({ enumerable: true, get: function () { return messages_1.authzTypes; } }));
var queries_2 = __webpack_require__(32672);
Object.defineProperty(exports, "setupAuthzExtension", ({ enumerable: true, get: function () { return queries_2.setupAuthzExtension; } }));
var aminomessages_2 = __webpack_require__(30121);
Object.defineProperty(exports, "createBankAminoConverters", ({ enumerable: true, get: function () { return aminomessages_2.createBankAminoConverters; } }));
Object.defineProperty(exports, "isAminoMsgMultiSend", ({ enumerable: true, get: function () { return aminomessages_2.isAminoMsgMultiSend; } }));
Object.defineProperty(exports, "isAminoMsgSend", ({ enumerable: true, get: function () { return aminomessages_2.isAminoMsgSend; } }));
var messages_2 = __webpack_require__(93045);
Object.defineProperty(exports, "bankTypes", ({ enumerable: true, get: function () { return messages_2.bankTypes; } }));
Object.defineProperty(exports, "isMsgSendEncodeObject", ({ enumerable: true, get: function () { return messages_2.isMsgSendEncodeObject; } }));
var queries_3 = __webpack_require__(28887);
Object.defineProperty(exports, "setupBankExtension", ({ enumerable: true, get: function () { return queries_3.setupBankExtension; } }));
var aminomessages_3 = __webpack_require__(12085);
Object.defineProperty(exports, "createCrysisAminoConverters", ({ enumerable: true, get: function () { return aminomessages_3.createCrysisAminoConverters; } }));
Object.defineProperty(exports, "isAminoMsgVerifyInvariant", ({ enumerable: true, get: function () { return aminomessages_3.isAminoMsgVerifyInvariant; } }));
var aminomessages_4 = __webpack_require__(41265);
Object.defineProperty(exports, "createDistributionAminoConverters", ({ enumerable: true, get: function () { return aminomessages_4.createDistributionAminoConverters; } }));
Object.defineProperty(exports, "isAminoMsgFundCommunityPool", ({ enumerable: true, get: function () { return aminomessages_4.isAminoMsgFundCommunityPool; } }));
Object.defineProperty(exports, "isAminoMsgSetWithdrawAddress", ({ enumerable: true, get: function () { return aminomessages_4.isAminoMsgSetWithdrawAddress; } }));
Object.defineProperty(exports, "isAminoMsgWithdrawDelegatorReward", ({ enumerable: true, get: function () { return aminomessages_4.isAminoMsgWithdrawDelegatorReward; } }));
Object.defineProperty(exports, "isAminoMsgWithdrawValidatorCommission", ({ enumerable: true, get: function () { return aminomessages_4.isAminoMsgWithdrawValidatorCommission; } }));
var messages_3 = __webpack_require__(32551);
Object.defineProperty(exports, "distributionTypes", ({ enumerable: true, get: function () { return messages_3.distributionTypes; } }));
Object.defineProperty(exports, "isMsgWithdrawDelegatorRewardEncodeObject", ({ enumerable: true, get: function () { return messages_3.isMsgWithdrawDelegatorRewardEncodeObject; } }));
var queries_4 = __webpack_require__(4953);
Object.defineProperty(exports, "setupDistributionExtension", ({ enumerable: true, get: function () { return queries_4.setupDistributionExtension; } }));
var aminomessages_5 = __webpack_require__(41801);
Object.defineProperty(exports, "createEvidenceAminoConverters", ({ enumerable: true, get: function () { return aminomessages_5.createEvidenceAminoConverters; } }));
Object.defineProperty(exports, "isAminoMsgSubmitEvidence", ({ enumerable: true, get: function () { return aminomessages_5.isAminoMsgSubmitEvidence; } }));
var aminomessages_6 = __webpack_require__(31020);
Object.defineProperty(exports, "createFeegrantAminoConverters", ({ enumerable: true, get: function () { return aminomessages_6.createFeegrantAminoConverters; } }));
var messages_4 = __webpack_require__(34949);
Object.defineProperty(exports, "feegrantTypes", ({ enumerable: true, get: function () { return messages_4.feegrantTypes; } }));
var queries_5 = __webpack_require__(8941);
Object.defineProperty(exports, "setupFeegrantExtension", ({ enumerable: true, get: function () { return queries_5.setupFeegrantExtension; } }));
var aminomessages_7 = __webpack_require__(75900);
Object.defineProperty(exports, "createGovAminoConverters", ({ enumerable: true, get: function () { return aminomessages_7.createGovAminoConverters; } }));
Object.defineProperty(exports, "isAminoMsgDeposit", ({ enumerable: true, get: function () { return aminomessages_7.isAminoMsgDeposit; } }));
Object.defineProperty(exports, "isAminoMsgSubmitProposal", ({ enumerable: true, get: function () { return aminomessages_7.isAminoMsgSubmitProposal; } }));
Object.defineProperty(exports, "isAminoMsgVote", ({ enumerable: true, get: function () { return aminomessages_7.isAminoMsgVote; } }));
Object.defineProperty(exports, "isAminoMsgVoteWeighted", ({ enumerable: true, get: function () { return aminomessages_7.isAminoMsgVoteWeighted; } }));
var messages_5 = __webpack_require__(16984);
Object.defineProperty(exports, "govTypes", ({ enumerable: true, get: function () { return messages_5.govTypes; } }));
Object.defineProperty(exports, "isMsgDepositEncodeObject", ({ enumerable: true, get: function () { return messages_5.isMsgDepositEncodeObject; } }));
Object.defineProperty(exports, "isMsgSubmitProposalEncodeObject", ({ enumerable: true, get: function () { return messages_5.isMsgSubmitProposalEncodeObject; } }));
Object.defineProperty(exports, "isMsgVoteEncodeObject", ({ enumerable: true, get: function () { return messages_5.isMsgVoteEncodeObject; } }));
Object.defineProperty(exports, "isMsgVoteWeightedEncodeObject", ({ enumerable: true, get: function () { return messages_5.isMsgVoteWeightedEncodeObject; } }));
var queries_6 = __webpack_require__(56122);
Object.defineProperty(exports, "setupGovExtension", ({ enumerable: true, get: function () { return queries_6.setupGovExtension; } }));
var aminomessages_8 = __webpack_require__(92655);
Object.defineProperty(exports, "createGroupAminoConverters", ({ enumerable: true, get: function () { return aminomessages_8.createGroupAminoConverters; } }));
var messages_6 = __webpack_require__(71102);
Object.defineProperty(exports, "groupTypes", ({ enumerable: true, get: function () { return messages_6.groupTypes; } }));
var aminomessages_9 = __webpack_require__(71655);
Object.defineProperty(exports, "createIbcAminoConverters", ({ enumerable: true, get: function () { return aminomessages_9.createIbcAminoConverters; } }));
Object.defineProperty(exports, "isAminoMsgTransfer", ({ enumerable: true, get: function () { return aminomessages_9.isAminoMsgTransfer; } }));
var messages_7 = __webpack_require__(72611);
Object.defineProperty(exports, "ibcTypes", ({ enumerable: true, get: function () { return messages_7.ibcTypes; } }));
Object.defineProperty(exports, "isMsgTransferEncodeObject", ({ enumerable: true, get: function () { return messages_7.isMsgTransferEncodeObject; } }));
var queries_7 = __webpack_require__(51398);
Object.defineProperty(exports, "setupIbcExtension", ({ enumerable: true, get: function () { return queries_7.setupIbcExtension; } }));
var queries_8 = __webpack_require__(29195);
Object.defineProperty(exports, "setupMintExtension", ({ enumerable: true, get: function () { return queries_8.setupMintExtension; } }));
var aminomessages_10 = __webpack_require__(22467);
Object.defineProperty(exports, "createSlashingAminoConverters", ({ enumerable: true, get: function () { return aminomessages_10.createSlashingAminoConverters; } }));
Object.defineProperty(exports, "isAminoMsgUnjail", ({ enumerable: true, get: function () { return aminomessages_10.isAminoMsgUnjail; } }));
var queries_9 = __webpack_require__(29400);
Object.defineProperty(exports, "setupSlashingExtension", ({ enumerable: true, get: function () { return queries_9.setupSlashingExtension; } }));
var aminomessages_11 = __webpack_require__(96020);
Object.defineProperty(exports, "createStakingAminoConverters", ({ enumerable: true, get: function () { return aminomessages_11.createStakingAminoConverters; } }));
Object.defineProperty(exports, "isAminoMsgBeginRedelegate", ({ enumerable: true, get: function () { return aminomessages_11.isAminoMsgBeginRedelegate; } }));
Object.defineProperty(exports, "isAminoMsgCreateValidator", ({ enumerable: true, get: function () { return aminomessages_11.isAminoMsgCreateValidator; } }));
Object.defineProperty(exports, "isAminoMsgDelegate", ({ enumerable: true, get: function () { return aminomessages_11.isAminoMsgDelegate; } }));
Object.defineProperty(exports, "isAminoMsgEditValidator", ({ enumerable: true, get: function () { return aminomessages_11.isAminoMsgEditValidator; } }));
Object.defineProperty(exports, "isAminoMsgUndelegate", ({ enumerable: true, get: function () { return aminomessages_11.isAminoMsgUndelegate; } }));
var messages_8 = __webpack_require__(47576);
Object.defineProperty(exports, "isMsgBeginRedelegateEncodeObject", ({ enumerable: true, get: function () { return messages_8.isMsgBeginRedelegateEncodeObject; } }));
Object.defineProperty(exports, "isMsgCreateValidatorEncodeObject", ({ enumerable: true, get: function () { return messages_8.isMsgCreateValidatorEncodeObject; } }));
Object.defineProperty(exports, "isMsgDelegateEncodeObject", ({ enumerable: true, get: function () { return messages_8.isMsgDelegateEncodeObject; } }));
Object.defineProperty(exports, "isMsgEditValidatorEncodeObject", ({ enumerable: true, get: function () { return messages_8.isMsgEditValidatorEncodeObject; } }));
Object.defineProperty(exports, "isMsgUndelegateEncodeObject", ({ enumerable: true, get: function () { return messages_8.isMsgUndelegateEncodeObject; } }));
Object.defineProperty(exports, "stakingTypes", ({ enumerable: true, get: function () { return messages_8.stakingTypes; } }));
var queries_10 = __webpack_require__(88482);
Object.defineProperty(exports, "setupStakingExtension", ({ enumerable: true, get: function () { return queries_10.setupStakingExtension; } }));
var queries_11 = __webpack_require__(83262);
Object.defineProperty(exports, "setupTxExtension", ({ enumerable: true, get: function () { return queries_11.setupTxExtension; } }));
var aminomessages_12 = __webpack_require__(80120);
Object.defineProperty(exports, "createVestingAminoConverters", ({ enumerable: true, get: function () { return aminomessages_12.createVestingAminoConverters; } }));
Object.defineProperty(exports, "isAminoMsgCreateVestingAccount", ({ enumerable: true, get: function () { return aminomessages_12.isAminoMsgCreateVestingAccount; } }));
var messages_9 = __webpack_require__(77345);
Object.defineProperty(exports, "vestingTypes", ({ enumerable: true, get: function () { return messages_9.vestingTypes; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 29195:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.setupMintExtension = void 0;
const utils_1 = __webpack_require__(62584);
const query_1 = __webpack_require__(84586);
const queryclient_1 = __webpack_require__(46300);
function setupMintExtension(base) {
    const rpc = (0, queryclient_1.createProtobufRpcClient)(base);
    // Use this service to get easy typed access to query methods
    // This cannot be used for proof verification
    const queryService = new query_1.QueryClientImpl(rpc);
    return {
        mint: {
            params: async () => {
                const { params } = await queryService.Params({});
                (0, utils_1.assert)(params);
                return {
                    blocksPerYear: params.blocksPerYear,
                    goalBonded: (0, queryclient_1.decodeCosmosSdkDecFromProto)(params.goalBonded),
                    inflationMin: (0, queryclient_1.decodeCosmosSdkDecFromProto)(params.inflationMin),
                    inflationMax: (0, queryclient_1.decodeCosmosSdkDecFromProto)(params.inflationMax),
                    inflationRateChange: (0, queryclient_1.decodeCosmosSdkDecFromProto)(params.inflationRateChange),
                    mintDenom: params.mintDenom,
                };
            },
            inflation: async () => {
                const { inflation } = await queryService.Inflation({});
                return (0, queryclient_1.decodeCosmosSdkDecFromProto)(inflation);
            },
            annualProvisions: async () => {
                const { annualProvisions } = await queryService.AnnualProvisions({});
                return (0, queryclient_1.decodeCosmosSdkDecFromProto)(annualProvisions);
            },
        },
    };
}
exports.setupMintExtension = setupMintExtension;
//# sourceMappingURL=queries.js.map

/***/ }),

/***/ 22467:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.createSlashingAminoConverters = exports.isAminoMsgUnjail = void 0;
function isAminoMsgUnjail(msg) {
    return msg.type === "cosmos-sdk/MsgUnjail";
}
exports.isAminoMsgUnjail = isAminoMsgUnjail;
function createSlashingAminoConverters() {
    throw new Error("Not implemented");
}
exports.createSlashingAminoConverters = createSlashingAminoConverters;
//# sourceMappingURL=aminomessages.js.map

/***/ }),

/***/ 29400:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.setupSlashingExtension = void 0;
const query_1 = __webpack_require__(38935);
const queryclient_1 = __webpack_require__(46300);
function setupSlashingExtension(base) {
    const rpc = (0, queryclient_1.createProtobufRpcClient)(base);
    const queryService = new query_1.QueryClientImpl(rpc);
    return {
        slashing: {
            signingInfo: async (consAddress) => {
                const response = await queryService.SigningInfo({
                    consAddress: consAddress,
                });
                return response;
            },
            signingInfos: async (paginationKey) => {
                const response = await queryService.SigningInfos({
                    pagination: (0, queryclient_1.createPagination)(paginationKey),
                });
                return response;
            },
            params: async () => {
                const response = await queryService.Params({});
                return response;
            },
        },
    };
}
exports.setupSlashingExtension = setupSlashingExtension;
//# sourceMappingURL=queries.js.map

/***/ }),

/***/ 96020:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.createStakingAminoConverters = exports.isAminoMsgUndelegate = exports.isAminoMsgBeginRedelegate = exports.isAminoMsgDelegate = exports.isAminoMsgEditValidator = exports.isAminoMsgCreateValidator = exports.protoDecimalToJson = void 0;
const math_1 = __webpack_require__(66021);
const proto_signing_1 = __webpack_require__(75216);
const utils_1 = __webpack_require__(62584);
function protoDecimalToJson(decimal) {
    const parsed = math_1.Decimal.fromAtomics(decimal, 18);
    const [whole, fractional] = parsed.toString().split(".");
    return `${whole}.${(fractional ?? "").padEnd(18, "0")}`;
}
exports.protoDecimalToJson = protoDecimalToJson;
function jsonDecimalToProto(decimal) {
    const parsed = math_1.Decimal.fromUserInput(decimal, 18);
    return parsed.atomics;
}
function isAminoMsgCreateValidator(msg) {
    return msg.type === "cosmos-sdk/MsgCreateValidator";
}
exports.isAminoMsgCreateValidator = isAminoMsgCreateValidator;
function isAminoMsgEditValidator(msg) {
    return msg.type === "cosmos-sdk/MsgEditValidator";
}
exports.isAminoMsgEditValidator = isAminoMsgEditValidator;
function isAminoMsgDelegate(msg) {
    return msg.type === "cosmos-sdk/MsgDelegate";
}
exports.isAminoMsgDelegate = isAminoMsgDelegate;
function isAminoMsgBeginRedelegate(msg) {
    return msg.type === "cosmos-sdk/MsgBeginRedelegate";
}
exports.isAminoMsgBeginRedelegate = isAminoMsgBeginRedelegate;
function isAminoMsgUndelegate(msg) {
    return msg.type === "cosmos-sdk/MsgUndelegate";
}
exports.isAminoMsgUndelegate = isAminoMsgUndelegate;
function createStakingAminoConverters() {
    return {
        "/cosmos.staking.v1beta1.MsgBeginRedelegate": {
            aminoType: "cosmos-sdk/MsgBeginRedelegate",
            toAmino: ({ delegatorAddress, validatorSrcAddress, validatorDstAddress, amount, }) => {
                (0, utils_1.assertDefinedAndNotNull)(amount, "missing amount");
                return {
                    delegator_address: delegatorAddress,
                    validator_src_address: validatorSrcAddress,
                    validator_dst_address: validatorDstAddress,
                    amount: amount,
                };
            },
            fromAmino: ({ delegator_address, validator_src_address, validator_dst_address, amount, }) => ({
                delegatorAddress: delegator_address,
                validatorSrcAddress: validator_src_address,
                validatorDstAddress: validator_dst_address,
                amount: amount,
            }),
        },
        "/cosmos.staking.v1beta1.MsgCreateValidator": {
            aminoType: "cosmos-sdk/MsgCreateValidator",
            toAmino: ({ description, commission, minSelfDelegation, delegatorAddress, validatorAddress, pubkey, value, }) => {
                (0, utils_1.assertDefinedAndNotNull)(description, "missing description");
                (0, utils_1.assertDefinedAndNotNull)(commission, "missing commission");
                (0, utils_1.assertDefinedAndNotNull)(pubkey, "missing pubkey");
                (0, utils_1.assertDefinedAndNotNull)(value, "missing value");
                return {
                    description: {
                        moniker: description.moniker,
                        identity: description.identity,
                        website: description.website,
                        security_contact: description.securityContact,
                        details: description.details,
                    },
                    commission: {
                        rate: protoDecimalToJson(commission.rate),
                        max_rate: protoDecimalToJson(commission.maxRate),
                        max_change_rate: protoDecimalToJson(commission.maxChangeRate),
                    },
                    min_self_delegation: minSelfDelegation,
                    delegator_address: delegatorAddress,
                    validator_address: validatorAddress,
                    pubkey: (0, proto_signing_1.decodePubkey)(pubkey),
                    value: value,
                };
            },
            fromAmino: ({ description, commission, min_self_delegation, delegator_address, validator_address, pubkey, value, }) => {
                return {
                    description: {
                        moniker: description.moniker,
                        identity: description.identity,
                        website: description.website,
                        securityContact: description.security_contact,
                        details: description.details,
                    },
                    commission: {
                        rate: jsonDecimalToProto(commission.rate),
                        maxRate: jsonDecimalToProto(commission.max_rate),
                        maxChangeRate: jsonDecimalToProto(commission.max_change_rate),
                    },
                    minSelfDelegation: min_self_delegation,
                    delegatorAddress: delegator_address,
                    validatorAddress: validator_address,
                    pubkey: (0, proto_signing_1.encodePubkey)(pubkey),
                    value: value,
                };
            },
        },
        "/cosmos.staking.v1beta1.MsgDelegate": {
            aminoType: "cosmos-sdk/MsgDelegate",
            toAmino: ({ delegatorAddress, validatorAddress, amount }) => {
                (0, utils_1.assertDefinedAndNotNull)(amount, "missing amount");
                return {
                    delegator_address: delegatorAddress,
                    validator_address: validatorAddress,
                    amount: amount,
                };
            },
            fromAmino: ({ delegator_address, validator_address, amount, }) => ({
                delegatorAddress: delegator_address,
                validatorAddress: validator_address,
                amount: amount,
            }),
        },
        "/cosmos.staking.v1beta1.MsgEditValidator": {
            aminoType: "cosmos-sdk/MsgEditValidator",
            toAmino: ({ description, commissionRate, minSelfDelegation, validatorAddress, }) => {
                (0, utils_1.assertDefinedAndNotNull)(description, "missing description");
                return {
                    description: {
                        moniker: description.moniker,
                        identity: description.identity,
                        website: description.website,
                        security_contact: description.securityContact,
                        details: description.details,
                    },
                    // empty string in the protobuf document means "do not change"
                    commission_rate: commissionRate ? protoDecimalToJson(commissionRate) : undefined,
                    // empty string in the protobuf document means "do not change"
                    min_self_delegation: minSelfDelegation ? minSelfDelegation : undefined,
                    validator_address: validatorAddress,
                };
            },
            fromAmino: ({ description, commission_rate, min_self_delegation, validator_address, }) => ({
                description: {
                    moniker: description.moniker,
                    identity: description.identity,
                    website: description.website,
                    securityContact: description.security_contact,
                    details: description.details,
                },
                // empty string in the protobuf document means "do not change"
                commissionRate: commission_rate ? jsonDecimalToProto(commission_rate) : "",
                // empty string in the protobuf document means "do not change"
                minSelfDelegation: min_self_delegation ?? "",
                validatorAddress: validator_address,
            }),
        },
        "/cosmos.staking.v1beta1.MsgUndelegate": {
            aminoType: "cosmos-sdk/MsgUndelegate",
            toAmino: ({ delegatorAddress, validatorAddress, amount, }) => {
                (0, utils_1.assertDefinedAndNotNull)(amount, "missing amount");
                return {
                    delegator_address: delegatorAddress,
                    validator_address: validatorAddress,
                    amount: amount,
                };
            },
            fromAmino: ({ delegator_address, validator_address, amount, }) => ({
                delegatorAddress: delegator_address,
                validatorAddress: validator_address,
                amount: amount,
            }),
        },
    };
}
exports.createStakingAminoConverters = createStakingAminoConverters;
//# sourceMappingURL=aminomessages.js.map

/***/ }),

/***/ 47576:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.isMsgUndelegateEncodeObject = exports.isMsgEditValidatorEncodeObject = exports.isMsgDelegateEncodeObject = exports.isMsgCreateValidatorEncodeObject = exports.isMsgBeginRedelegateEncodeObject = exports.stakingTypes = void 0;
const tx_1 = __webpack_require__(70381);
exports.stakingTypes = [
    ["/cosmos.staking.v1beta1.MsgBeginRedelegate", tx_1.MsgBeginRedelegate],
    ["/cosmos.staking.v1beta1.MsgCreateValidator", tx_1.MsgCreateValidator],
    ["/cosmos.staking.v1beta1.MsgDelegate", tx_1.MsgDelegate],
    ["/cosmos.staking.v1beta1.MsgEditValidator", tx_1.MsgEditValidator],
    ["/cosmos.staking.v1beta1.MsgUndelegate", tx_1.MsgUndelegate],
];
function isMsgBeginRedelegateEncodeObject(o) {
    return o.typeUrl === "/cosmos.staking.v1beta1.MsgBeginRedelegate";
}
exports.isMsgBeginRedelegateEncodeObject = isMsgBeginRedelegateEncodeObject;
function isMsgCreateValidatorEncodeObject(o) {
    return o.typeUrl === "/cosmos.staking.v1beta1.MsgCreateValidator";
}
exports.isMsgCreateValidatorEncodeObject = isMsgCreateValidatorEncodeObject;
function isMsgDelegateEncodeObject(object) {
    return object.typeUrl === "/cosmos.staking.v1beta1.MsgDelegate";
}
exports.isMsgDelegateEncodeObject = isMsgDelegateEncodeObject;
function isMsgEditValidatorEncodeObject(o) {
    return o.typeUrl === "/cosmos.staking.v1beta1.MsgEditValidator";
}
exports.isMsgEditValidatorEncodeObject = isMsgEditValidatorEncodeObject;
function isMsgUndelegateEncodeObject(object) {
    return object.typeUrl === "/cosmos.staking.v1beta1.MsgUndelegate";
}
exports.isMsgUndelegateEncodeObject = isMsgUndelegateEncodeObject;
//# sourceMappingURL=messages.js.map

/***/ }),

/***/ 88482:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.setupStakingExtension = void 0;
/* eslint-disable @typescript-eslint/naming-convention */
const query_1 = __webpack_require__(13267);
const long_1 = __importDefault(__webpack_require__(10648));
const queryclient_1 = __webpack_require__(46300);
function setupStakingExtension(base) {
    // Use this service to get easy typed access to query methods
    // This cannot be used for proof verification
    const rpc = (0, queryclient_1.createProtobufRpcClient)(base);
    const queryService = new query_1.QueryClientImpl(rpc);
    return {
        staking: {
            delegation: async (delegatorAddress, validatorAddress) => {
                const response = await queryService.Delegation({
                    delegatorAddr: delegatorAddress,
                    validatorAddr: validatorAddress,
                });
                return response;
            },
            delegatorDelegations: async (delegatorAddress, paginationKey) => {
                const response = await queryService.DelegatorDelegations({
                    delegatorAddr: delegatorAddress,
                    pagination: (0, queryclient_1.createPagination)(paginationKey),
                });
                return response;
            },
            delegatorUnbondingDelegations: async (delegatorAddress, paginationKey) => {
                const response = await queryService.DelegatorUnbondingDelegations({
                    delegatorAddr: delegatorAddress,
                    pagination: (0, queryclient_1.createPagination)(paginationKey),
                });
                return response;
            },
            delegatorValidator: async (delegatorAddress, validatorAddress) => {
                const response = await queryService.DelegatorValidator({
                    delegatorAddr: delegatorAddress,
                    validatorAddr: validatorAddress,
                });
                return response;
            },
            delegatorValidators: async (delegatorAddress, paginationKey) => {
                const response = await queryService.DelegatorValidators({
                    delegatorAddr: delegatorAddress,
                    pagination: (0, queryclient_1.createPagination)(paginationKey),
                });
                return response;
            },
            historicalInfo: async (height) => {
                const response = await queryService.HistoricalInfo({
                    height: long_1.default.fromNumber(height, true),
                });
                return response;
            },
            params: async () => {
                const response = await queryService.Params({});
                return response;
            },
            pool: async () => {
                const response = await queryService.Pool({});
                return response;
            },
            redelegations: async (delegatorAddress, sourceValidatorAddress, destinationValidatorAddress, paginationKey) => {
                const response = await queryService.Redelegations({
                    delegatorAddr: delegatorAddress,
                    srcValidatorAddr: sourceValidatorAddress,
                    dstValidatorAddr: destinationValidatorAddress,
                    pagination: (0, queryclient_1.createPagination)(paginationKey),
                });
                return response;
            },
            unbondingDelegation: async (delegatorAddress, validatorAddress) => {
                const response = await queryService.UnbondingDelegation({
                    delegatorAddr: delegatorAddress,
                    validatorAddr: validatorAddress,
                });
                return response;
            },
            validator: async (validatorAddress) => {
                const response = await queryService.Validator({ validatorAddr: validatorAddress });
                return response;
            },
            validatorDelegations: async (validatorAddress, paginationKey) => {
                const response = await queryService.ValidatorDelegations({
                    validatorAddr: validatorAddress,
                    pagination: (0, queryclient_1.createPagination)(paginationKey),
                });
                return response;
            },
            validators: async (status, paginationKey) => {
                const response = await queryService.Validators({
                    status: status,
                    pagination: (0, queryclient_1.createPagination)(paginationKey),
                });
                return response;
            },
            validatorUnbondingDelegations: async (validatorAddress, paginationKey) => {
                const response = await queryService.ValidatorUnbondingDelegations({
                    validatorAddr: validatorAddress,
                    pagination: (0, queryclient_1.createPagination)(paginationKey),
                });
                return response;
            },
        },
    };
}
exports.setupStakingExtension = setupStakingExtension;
//# sourceMappingURL=queries.js.map

/***/ }),

/***/ 83262:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.setupTxExtension = void 0;
const proto_signing_1 = __webpack_require__(75216);
const signing_1 = __webpack_require__(83397);
const service_1 = __webpack_require__(34184);
const tx_1 = __webpack_require__(17921);
const long_1 = __importDefault(__webpack_require__(10648));
const queryclient_1 = __webpack_require__(46300);
function setupTxExtension(base) {
    // Use this service to get easy typed access to query methods
    // This cannot be used for proof verification
    const rpc = (0, queryclient_1.createProtobufRpcClient)(base);
    const queryService = new service_1.ServiceClientImpl(rpc);
    return {
        tx: {
            getTx: async (txId) => {
                const request = {
                    hash: txId,
                };
                const response = await queryService.GetTx(request);
                return response;
            },
            simulate: async (messages, memo, signer, sequence) => {
                const tx = tx_1.Tx.fromPartial({
                    authInfo: tx_1.AuthInfo.fromPartial({
                        fee: tx_1.Fee.fromPartial({}),
                        signerInfos: [
                            {
                                publicKey: (0, proto_signing_1.encodePubkey)(signer),
                                sequence: long_1.default.fromNumber(sequence, true),
                                modeInfo: { single: { mode: signing_1.SignMode.SIGN_MODE_UNSPECIFIED } },
                            },
                        ],
                    }),
                    body: tx_1.TxBody.fromPartial({
                        messages: Array.from(messages),
                        memo: memo,
                    }),
                    signatures: [new Uint8Array()],
                });
                const request = service_1.SimulateRequest.fromPartial({
                    txBytes: tx_1.Tx.encode(tx).finish(),
                });
                const response = await queryService.Simulate(request);
                return response;
            },
        },
    };
}
exports.setupTxExtension = setupTxExtension;
//# sourceMappingURL=queries.js.map

/***/ }),

/***/ 80120:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.createVestingAminoConverters = exports.isAminoMsgCreateVestingAccount = void 0;
const long_1 = __importDefault(__webpack_require__(10648));
function isAminoMsgCreateVestingAccount(msg) {
    return msg.type === "cosmos-sdk/MsgCreateVestingAccount";
}
exports.isAminoMsgCreateVestingAccount = isAminoMsgCreateVestingAccount;
function createVestingAminoConverters() {
    return {
        "/cosmos.vesting.v1beta1.MsgCreateVestingAccount": {
            aminoType: "cosmos-sdk/MsgCreateVestingAccount",
            toAmino: ({ fromAddress, toAddress, amount, endTime, delayed, }) => ({
                from_address: fromAddress,
                to_address: toAddress,
                amount: [...amount],
                end_time: endTime.toString(),
                delayed: delayed,
            }),
            fromAmino: ({ from_address, to_address, amount, end_time, delayed, }) => ({
                fromAddress: from_address,
                toAddress: to_address,
                amount: [...amount],
                endTime: long_1.default.fromString(end_time),
                delayed: delayed,
            }),
        },
    };
}
exports.createVestingAminoConverters = createVestingAminoConverters;
//# sourceMappingURL=aminomessages.js.map

/***/ }),

/***/ 77345:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.vestingTypes = void 0;
const tx_1 = __webpack_require__(74762);
exports.vestingTypes = [
    ["/cosmos.vesting.v1beta1.MsgCreateVestingAccount", tx_1.MsgCreateVestingAccount],
];
//# sourceMappingURL=messages.js.map

/***/ }),

/***/ 55799:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.makeMultisignedTxBytes = exports.makeMultisignedTx = exports.makeCompactBitArray = void 0;
const amino_1 = __webpack_require__(98802);
const encoding_1 = __webpack_require__(87061);
const proto_signing_1 = __webpack_require__(75216);
const multisig_1 = __webpack_require__(50140);
const signing_1 = __webpack_require__(83397);
const tx_1 = __webpack_require__(17921);
const tx_2 = __webpack_require__(17921);
const long_1 = __importDefault(__webpack_require__(10648));
function makeCompactBitArray(bits) {
    const byteCount = Math.ceil(bits.length / 8);
    const extraBits = bits.length - Math.floor(bits.length / 8) * 8;
    const bytes = new Uint8Array(byteCount); // zero-filled
    bits.forEach((value, index) => {
        const bytePos = Math.floor(index / 8);
        const bitPos = index % 8;
        // eslint-disable-next-line no-bitwise
        if (value)
            bytes[bytePos] |= 0b1 << (8 - 1 - bitPos);
    });
    return multisig_1.CompactBitArray.fromPartial({ elems: bytes, extraBitsStored: extraBits });
}
exports.makeCompactBitArray = makeCompactBitArray;
/**
 * Creates a signed transaction from signer info, transaction body and signatures.
 * The result can be broadcasted after serialization.
 *
 * Consider using `makeMultisignedTxBytes` instead if you want to broadcast the
 * transaction immediately.
 */
function makeMultisignedTx(multisigPubkey, sequence, fee, bodyBytes, signatures) {
    const addresses = Array.from(signatures.keys());
    const prefix = (0, encoding_1.fromBech32)(addresses[0]).prefix;
    const signers = Array(multisigPubkey.value.pubkeys.length).fill(false);
    const signaturesList = new Array();
    for (let i = 0; i < multisigPubkey.value.pubkeys.length; i++) {
        const signerAddress = (0, amino_1.pubkeyToAddress)(multisigPubkey.value.pubkeys[i], prefix);
        const signature = signatures.get(signerAddress);
        if (signature) {
            signers[i] = true;
            signaturesList.push(signature);
        }
    }
    const signerInfo = {
        publicKey: (0, proto_signing_1.encodePubkey)(multisigPubkey),
        modeInfo: {
            multi: {
                bitarray: makeCompactBitArray(signers),
                modeInfos: signaturesList.map((_) => ({ single: { mode: signing_1.SignMode.SIGN_MODE_LEGACY_AMINO_JSON } })),
            },
        },
        sequence: long_1.default.fromNumber(sequence),
    };
    const authInfo = tx_1.AuthInfo.fromPartial({
        signerInfos: [signerInfo],
        fee: {
            amount: [...fee.amount],
            gasLimit: long_1.default.fromString(fee.gas),
        },
    });
    const authInfoBytes = tx_1.AuthInfo.encode(authInfo).finish();
    const signedTx = tx_2.TxRaw.fromPartial({
        bodyBytes: bodyBytes,
        authInfoBytes: authInfoBytes,
        signatures: [multisig_1.MultiSignature.encode(multisig_1.MultiSignature.fromPartial({ signatures: signaturesList })).finish()],
    });
    return signedTx;
}
exports.makeMultisignedTx = makeMultisignedTx;
/**
 * Creates a signed transaction from signer info, transaction body and signatures.
 * The result can be broadcasted.
 *
 * This is a wrapper around `makeMultisignedTx` that encodes the transaction for broadcasting.
 */
function makeMultisignedTxBytes(multisigPubkey, sequence, fee, bodyBytes, signatures) {
    const signedTx = makeMultisignedTx(multisigPubkey, sequence, fee, bodyBytes, signatures);
    return Uint8Array.from(tx_2.TxRaw.encode(signedTx).finish());
}
exports.makeMultisignedTxBytes = makeMultisignedTxBytes;
//# sourceMappingURL=multisignature.js.map

/***/ }),

/***/ 46300:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.longify = exports.decodeCosmosSdkDecFromProto = exports.createProtobufRpcClient = exports.createPagination = exports.QueryClient = void 0;
var queryclient_1 = __webpack_require__(85746);
Object.defineProperty(exports, "QueryClient", ({ enumerable: true, get: function () { return queryclient_1.QueryClient; } }));
var utils_1 = __webpack_require__(43646);
Object.defineProperty(exports, "createPagination", ({ enumerable: true, get: function () { return utils_1.createPagination; } }));
Object.defineProperty(exports, "createProtobufRpcClient", ({ enumerable: true, get: function () { return utils_1.createProtobufRpcClient; } }));
Object.defineProperty(exports, "decodeCosmosSdkDecFromProto", ({ enumerable: true, get: function () { return utils_1.decodeCosmosSdkDecFromProto; } }));
Object.defineProperty(exports, "longify", ({ enumerable: true, get: function () { return utils_1.longify; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 85746:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.QueryClient = void 0;
/* eslint-disable no-dupe-class-members, @typescript-eslint/ban-types, @typescript-eslint/naming-convention */
const ics23_1 = __webpack_require__(55201);
const encoding_1 = __webpack_require__(87061);
const stream_1 = __webpack_require__(2464);
const utils_1 = __webpack_require__(62584);
function checkAndParseOp(op, kind, key) {
    if (op.type !== kind) {
        throw new Error(`Op expected to be ${kind}, got "${op.type}`);
    }
    if (!(0, utils_1.arrayContentEquals)(key, op.key)) {
        throw new Error(`Proven key different than queried key.\nQuery: ${(0, encoding_1.toHex)(key)}\nProven: ${(0, encoding_1.toHex)(op.key)}`);
    }
    return ics23_1.ics23.CommitmentProof.decode(op.data);
}
class QueryClient {
    static withExtensions(tmClient, ...extensionSetups) {
        const client = new QueryClient(tmClient);
        const extensions = extensionSetups.map((setupExtension) => setupExtension(client));
        for (const extension of extensions) {
            (0, utils_1.assert)((0, utils_1.isNonNullObject)(extension), `Extension must be a non-null object`);
            for (const [moduleKey, moduleValue] of Object.entries(extension)) {
                (0, utils_1.assert)((0, utils_1.isNonNullObject)(moduleValue), `Module must be a non-null object. Found type ${typeof moduleValue} for module "${moduleKey}".`);
                const current = client[moduleKey] || {};
                client[moduleKey] = {
                    ...current,
                    ...moduleValue,
                };
            }
        }
        return client;
    }
    constructor(tmClient) {
        this.tmClient = tmClient;
    }
    /**
     * Queries the database store with a proof, which is then verified.
     *
     * Please note: the current implementation trusts block headers it gets from the PRC endpoint.
     */
    async queryStoreVerified(store, queryKey, desiredHeight) {
        const { height, proof, key, value } = await this.queryRawProof(store, queryKey, desiredHeight);
        const subProof = checkAndParseOp(proof.ops[0], "ics23:iavl", queryKey);
        const storeProof = checkAndParseOp(proof.ops[1], "ics23:simple", (0, encoding_1.toAscii)(store));
        // this must always be existence, if the store is not a typo
        (0, utils_1.assert)(storeProof.exist);
        (0, utils_1.assert)(storeProof.exist.value);
        // this may be exist or non-exist, depends on response
        if (!value || value.length === 0) {
            // non-existence check
            (0, utils_1.assert)(subProof.nonexist);
            // the subproof must map the desired key to the "value" of the storeProof
            (0, ics23_1.verifyNonExistence)(subProof.nonexist, ics23_1.iavlSpec, storeProof.exist.value, queryKey);
        }
        else {
            // existence check
            (0, utils_1.assert)(subProof.exist);
            (0, utils_1.assert)(subProof.exist.value);
            // the subproof must map the desired key to the "value" of the storeProof
            (0, ics23_1.verifyExistence)(subProof.exist, ics23_1.iavlSpec, storeProof.exist.value, queryKey, value);
        }
        // the store proof must map its declared value (root of subProof) to the appHash of the next block
        const header = await this.getNextHeader(height);
        (0, ics23_1.verifyExistence)(storeProof.exist, ics23_1.tendermintSpec, header.appHash, (0, encoding_1.toAscii)(store), storeProof.exist.value);
        return { key, value, height };
    }
    async queryRawProof(store, queryKey, desiredHeight) {
        const { key, value, height, proof, code, log } = await this.tmClient.abciQuery({
            // we need the StoreKey for the module, not the module name
            // https://github.com/cosmos/cosmos-sdk/blob/8cab43c8120fec5200c3459cbf4a92017bb6f287/x/auth/types/keys.go#L12
            path: `/store/${store}/key`,
            data: queryKey,
            prove: true,
            height: desiredHeight,
        });
        if (code) {
            throw new Error(`Query failed with (${code}): ${log}`);
        }
        if (!(0, utils_1.arrayContentEquals)(queryKey, key)) {
            throw new Error(`Response key ${(0, encoding_1.toHex)(key)} doesn't match query key ${(0, encoding_1.toHex)(queryKey)}`);
        }
        if (!height) {
            throw new Error("No query height returned");
        }
        if (!proof || proof.ops.length !== 2) {
            throw new Error(`Expected 2 proof ops, got ${proof?.ops.length ?? 0}. Are you using stargate?`);
        }
        // we don't need the results, but we can ensure the data is the proper format
        checkAndParseOp(proof.ops[0], "ics23:iavl", key);
        checkAndParseOp(proof.ops[1], "ics23:simple", (0, encoding_1.toAscii)(store));
        return {
            key: key,
            value: value,
            height: height,
            // need to clone this: readonly input / writeable output
            proof: {
                ops: [...proof.ops],
            },
        };
    }
    /**
     * Performs an ABCI query to Tendermint without requesting a proof.
     *
     * If the `desiredHeight` is set, a particular height is requested. Otherwise
     * the latest height is requested. The response contains the actual height of
     * the query.
     */
    async queryAbci(path, request, desiredHeight) {
        const response = await this.tmClient.abciQuery({
            path: path,
            data: request,
            prove: false,
            height: desiredHeight,
        });
        if (response.code) {
            throw new Error(`Query failed with (${response.code}): ${response.log}`);
        }
        if (!response.height) {
            throw new Error("No query height returned");
        }
        return {
            value: response.value,
            height: response.height,
        };
    }
    // this must return the header for height+1
    // throws an error if height is 0 or undefined
    async getNextHeader(height) {
        (0, utils_1.assertDefined)(height);
        if (height === 0) {
            throw new Error("Query returned height 0, cannot prove it");
        }
        const searchHeight = height + 1;
        let nextHeader;
        let headersSubscription;
        try {
            headersSubscription = this.tmClient.subscribeNewBlockHeader();
        }
        catch {
            // Ignore exception caused by non-WebSocket Tendermint clients
        }
        if (headersSubscription) {
            const firstHeader = await (0, stream_1.firstEvent)(headersSubscription);
            // The first header we get might not be n+1 but n+2 or even higher. In such cases we fall back on a query.
            if (firstHeader.height === searchHeight) {
                nextHeader = firstHeader;
            }
        }
        while (!nextHeader) {
            // start from current height to avoid backend error for minHeight in the future
            const correctHeader = (await this.tmClient.blockchain(height, searchHeight)).blockMetas
                .map((meta) => meta.header)
                .find((h) => h.height === searchHeight);
            if (correctHeader) {
                nextHeader = correctHeader;
            }
            else {
                await (0, utils_1.sleep)(1000);
            }
        }
        (0, utils_1.assert)(nextHeader.height === searchHeight, "Got wrong header. This is a bug in the logic above.");
        return nextHeader;
    }
}
exports.QueryClient = QueryClient;
//# sourceMappingURL=queryclient.js.map

/***/ }),

/***/ 43646:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.decodeCosmosSdkDecFromProto = exports.longify = exports.createProtobufRpcClient = exports.createPagination = exports.toAccAddress = void 0;
const encoding_1 = __webpack_require__(87061);
const math_1 = __webpack_require__(66021);
const pagination_1 = __webpack_require__(84043);
const long_1 = __importDefault(__webpack_require__(10648));
/**
 * Takes a bech32 encoded address and returns the data part. The prefix is ignored and discarded.
 * This is called AccAddress in Cosmos SDK, which is basically an alias for raw binary data.
 * The result is typically 20 bytes long but not restricted to that.
 */
function toAccAddress(address) {
    return (0, encoding_1.fromBech32)(address).data;
}
exports.toAccAddress = toAccAddress;
/**
 * If paginationKey is set, return a `PageRequest` with the given key.
 * If paginationKey is unset, return `undefined`.
 *
 * Use this with a query response's pagination next key to
 * request the next page.
 */
function createPagination(paginationKey) {
    return paginationKey ? pagination_1.PageRequest.fromPartial({ key: paginationKey }) : undefined;
}
exports.createPagination = createPagination;
function createProtobufRpcClient(base) {
    return {
        request: async (service, method, data) => {
            const path = `/${service}/${method}`;
            const response = await base.queryAbci(path, data, undefined);
            return response.value;
        },
    };
}
exports.createProtobufRpcClient = createProtobufRpcClient;
/**
 * Takes a uint64 value as string, number, Long or Uint64 and returns an unsigned Long instance
 * of it.
 */
function longify(value) {
    const checkedValue = math_1.Uint64.fromString(value.toString());
    return long_1.default.fromBytesBE([...checkedValue.toBytesBigEndian()], true);
}
exports.longify = longify;
/**
 * Takes a string or binary encoded `github.com/cosmos/cosmos-sdk/types.Dec` from the
 * protobuf API and converts it into a `Decimal` with 18 fractional digits.
 *
 * See https://github.com/cosmos/cosmos-sdk/issues/10863 for more context why this is needed.
 */
function decodeCosmosSdkDecFromProto(input) {
    const asString = typeof input === "string" ? input : (0, encoding_1.fromAscii)(input);
    return math_1.Decimal.fromAtomics(asString, 18);
}
exports.decodeCosmosSdkDecFromProto = decodeCosmosSdkDecFromProto;
//# sourceMappingURL=utils.js.map

/***/ }),

/***/ 73110:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.SigningStargateClient = exports.createDefaultAminoConverters = exports.defaultRegistryTypes = void 0;
const amino_1 = __webpack_require__(98802);
const encoding_1 = __webpack_require__(87061);
const math_1 = __webpack_require__(66021);
const proto_signing_1 = __webpack_require__(75216);
const tendermint_rpc_1 = __webpack_require__(52474);
const utils_1 = __webpack_require__(62584);
const coin_1 = __webpack_require__(81637);
const tx_1 = __webpack_require__(80798);
const tx_2 = __webpack_require__(70381);
const signing_1 = __webpack_require__(83397);
const tx_3 = __webpack_require__(17921);
const tx_4 = __webpack_require__(88313);
const long_1 = __importDefault(__webpack_require__(10648));
const aminotypes_1 = __webpack_require__(14162);
const fee_1 = __webpack_require__(5392);
const modules_1 = __webpack_require__(6749);
const modules_2 = __webpack_require__(6749);
const stargateclient_1 = __webpack_require__(38577);
exports.defaultRegistryTypes = [
    ["/cosmos.base.v1beta1.Coin", coin_1.Coin],
    ...modules_1.authzTypes,
    ...modules_1.bankTypes,
    ...modules_1.distributionTypes,
    ...modules_1.feegrantTypes,
    ...modules_1.govTypes,
    ...modules_1.groupTypes,
    ...modules_1.stakingTypes,
    ...modules_1.ibcTypes,
    ...modules_1.vestingTypes,
];
function createDefaultAminoConverters() {
    return {
        ...(0, modules_2.createAuthzAminoConverters)(),
        ...(0, modules_2.createBankAminoConverters)(),
        ...(0, modules_2.createDistributionAminoConverters)(),
        ...(0, modules_2.createGovAminoConverters)(),
        ...(0, modules_2.createStakingAminoConverters)(),
        ...(0, modules_2.createIbcAminoConverters)(),
        ...(0, modules_2.createFeegrantAminoConverters)(),
        ...(0, modules_2.createVestingAminoConverters)(),
    };
}
exports.createDefaultAminoConverters = createDefaultAminoConverters;
class SigningStargateClient extends stargateclient_1.StargateClient {
    /**
     * Creates an instance by connecting to the given Tendermint RPC endpoint.
     *
     * This uses auto-detection to decide between a Tendermint 0.37 and 0.34 client.
     * To set the Tendermint client explicitly, use `createWithSigner`.
     */
    static async connectWithSigner(endpoint, signer, options = {}) {
        // Tendermint/CometBFT 0.34/0.37 auto-detection. Starting with 0.37 we seem to get reliable versions again 🎉
        // Using 0.34 as the fallback.
        let tmClient;
        const tm37Client = await tendermint_rpc_1.Tendermint37Client.connect(endpoint);
        const version = (await tm37Client.status()).nodeInfo.version;
        if (version.startsWith("0.37.")) {
            tmClient = tm37Client;
        }
        else {
            tm37Client.disconnect();
            tmClient = await tendermint_rpc_1.Tendermint34Client.connect(endpoint);
        }
        return SigningStargateClient.createWithSigner(tmClient, signer, options);
    }
    /**
     * Creates an instance from a manually created Tendermint client.
     * Use this to use `Tendermint37Client` instead of `Tendermint34Client`.
     */
    static async createWithSigner(tmClient, signer, options = {}) {
        return new SigningStargateClient(tmClient, signer, options);
    }
    /**
     * Creates a client in offline mode.
     *
     * This should only be used in niche cases where you know exactly what you're doing,
     * e.g. when building an offline signing application.
     *
     * When you try to use online functionality with such a signer, an
     * exception will be raised.
     */
    static async offline(signer, options = {}) {
        return new SigningStargateClient(undefined, signer, options);
    }
    constructor(tmClient, signer, options) {
        super(tmClient, options);
        const { registry = new proto_signing_1.Registry(exports.defaultRegistryTypes), aminoTypes = new aminotypes_1.AminoTypes(createDefaultAminoConverters()), } = options;
        this.registry = registry;
        this.aminoTypes = aminoTypes;
        this.signer = signer;
        this.broadcastTimeoutMs = options.broadcastTimeoutMs;
        this.broadcastPollIntervalMs = options.broadcastPollIntervalMs;
        this.gasPrice = options.gasPrice;
    }
    async simulate(signerAddress, messages, memo) {
        const anyMsgs = messages.map((m) => this.registry.encodeAsAny(m));
        const accountFromSigner = (await this.signer.getAccounts()).find((account) => account.address === signerAddress);
        if (!accountFromSigner) {
            throw new Error("Failed to retrieve account from signer");
        }
        const pubkey = (0, amino_1.encodeSecp256k1Pubkey)(accountFromSigner.pubkey);
        const { sequence } = await this.getSequence(signerAddress);
        const { gasInfo } = await this.forceGetQueryClient().tx.simulate(anyMsgs, memo, pubkey, sequence);
        (0, utils_1.assertDefined)(gasInfo);
        return math_1.Uint53.fromString(gasInfo.gasUsed.toString()).toNumber();
    }
    async sendTokens(senderAddress, recipientAddress, amount, fee, memo = "") {
        const sendMsg = {
            typeUrl: "/cosmos.bank.v1beta1.MsgSend",
            value: {
                fromAddress: senderAddress,
                toAddress: recipientAddress,
                amount: [...amount],
            },
        };
        return this.signAndBroadcast(senderAddress, [sendMsg], fee, memo);
    }
    async delegateTokens(delegatorAddress, validatorAddress, amount, fee, memo = "") {
        const delegateMsg = {
            typeUrl: "/cosmos.staking.v1beta1.MsgDelegate",
            value: tx_2.MsgDelegate.fromPartial({
                delegatorAddress: delegatorAddress,
                validatorAddress: validatorAddress,
                amount: amount,
            }),
        };
        return this.signAndBroadcast(delegatorAddress, [delegateMsg], fee, memo);
    }
    async undelegateTokens(delegatorAddress, validatorAddress, amount, fee, memo = "") {
        const undelegateMsg = {
            typeUrl: "/cosmos.staking.v1beta1.MsgUndelegate",
            value: tx_2.MsgUndelegate.fromPartial({
                delegatorAddress: delegatorAddress,
                validatorAddress: validatorAddress,
                amount: amount,
            }),
        };
        return this.signAndBroadcast(delegatorAddress, [undelegateMsg], fee, memo);
    }
    async withdrawRewards(delegatorAddress, validatorAddress, fee, memo = "") {
        const withdrawMsg = {
            typeUrl: "/cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward",
            value: tx_1.MsgWithdrawDelegatorReward.fromPartial({
                delegatorAddress: delegatorAddress,
                validatorAddress: validatorAddress,
            }),
        };
        return this.signAndBroadcast(delegatorAddress, [withdrawMsg], fee, memo);
    }
    async sendIbcTokens(senderAddress, recipientAddress, transferAmount, sourcePort, sourceChannel, timeoutHeight, 
    /** timeout in seconds */
    timeoutTimestamp, fee, memo = "") {
        const timeoutTimestampNanoseconds = timeoutTimestamp
            ? long_1.default.fromNumber(timeoutTimestamp).multiply(1000000000)
            : undefined;
        const transferMsg = {
            typeUrl: "/ibc.applications.transfer.v1.MsgTransfer",
            value: tx_4.MsgTransfer.fromPartial({
                sourcePort: sourcePort,
                sourceChannel: sourceChannel,
                sender: senderAddress,
                receiver: recipientAddress,
                token: transferAmount,
                timeoutHeight: timeoutHeight,
                timeoutTimestamp: timeoutTimestampNanoseconds,
            }),
        };
        return this.signAndBroadcast(senderAddress, [transferMsg], fee, memo);
    }
    async signAndBroadcast(signerAddress, messages, fee, memo = "") {
        let usedFee;
        if (fee == "auto" || typeof fee === "number") {
            (0, utils_1.assertDefined)(this.gasPrice, "Gas price must be set in the client options when auto gas is used.");
            const gasEstimation = await this.simulate(signerAddress, messages, memo);
            // Starting with Cosmos SDK 0.47, we see many cases in which 1.3 is not enough anymore
            // E.g. https://github.com/cosmos/cosmos-sdk/issues/16020
            const multiplier = typeof fee === "number" ? fee : 1.4;
            usedFee = (0, fee_1.calculateFee)(Math.round(gasEstimation * multiplier), this.gasPrice);
        }
        else {
            usedFee = fee;
        }
        const txRaw = await this.sign(signerAddress, messages, usedFee, memo);
        const txBytes = tx_3.TxRaw.encode(txRaw).finish();
        return this.broadcastTx(txBytes, this.broadcastTimeoutMs, this.broadcastPollIntervalMs);
    }
    /**
     * This method is useful if you want to send a transaction in broadcast,
     * without waiting for it to be placed inside a block, because for example
     * I would like to receive the hash to later track the transaction with another tool.
     * @returns Returns the hash of the transaction
     */
    async signAndBroadcastSync(signerAddress, messages, fee, memo = "") {
        let usedFee;
        if (fee == "auto" || typeof fee === "number") {
            (0, utils_1.assertDefined)(this.gasPrice, "Gas price must be set in the client options when auto gas is used.");
            const gasEstimation = await this.simulate(signerAddress, messages, memo);
            const multiplier = typeof fee === "number" ? fee : 1.3;
            usedFee = (0, fee_1.calculateFee)(Math.round(gasEstimation * multiplier), this.gasPrice);
        }
        else {
            usedFee = fee;
        }
        const txRaw = await this.sign(signerAddress, messages, usedFee, memo);
        const txBytes = tx_3.TxRaw.encode(txRaw).finish();
        return this.broadcastTxSync(txBytes);
    }
    /**
     * Gets account number and sequence from the API, creates a sign doc,
     * creates a single signature and assembles the signed transaction.
     *
     * The sign mode (SIGN_MODE_DIRECT or SIGN_MODE_LEGACY_AMINO_JSON) is determined by this client's signer.
     *
     * You can pass signer data (account number, sequence and chain ID) explicitly instead of querying them
     * from the chain. This is needed when signing for a multisig account, but it also allows for offline signing
     * (See the SigningStargateClient.offline constructor).
     */
    async sign(signerAddress, messages, fee, memo, explicitSignerData) {
        let signerData;
        if (explicitSignerData) {
            signerData = explicitSignerData;
        }
        else {
            const { accountNumber, sequence } = await this.getSequence(signerAddress);
            const chainId = await this.getChainId();
            signerData = {
                accountNumber: accountNumber,
                sequence: sequence,
                chainId: chainId,
            };
        }
        return (0, proto_signing_1.isOfflineDirectSigner)(this.signer)
            ? this.signDirect(signerAddress, messages, fee, memo, signerData)
            : this.signAmino(signerAddress, messages, fee, memo, signerData);
    }
    async signAmino(signerAddress, messages, fee, memo, { accountNumber, sequence, chainId }) {
        (0, utils_1.assert)(!(0, proto_signing_1.isOfflineDirectSigner)(this.signer));
        const accountFromSigner = (await this.signer.getAccounts()).find((account) => account.address === signerAddress);
        if (!accountFromSigner) {
            throw new Error("Failed to retrieve account from signer");
        }
        const pubkey = (0, proto_signing_1.encodePubkey)((0, amino_1.encodeSecp256k1Pubkey)(accountFromSigner.pubkey));
        const signMode = signing_1.SignMode.SIGN_MODE_LEGACY_AMINO_JSON;
        const msgs = messages.map((msg) => this.aminoTypes.toAmino(msg));
        const signDoc = (0, amino_1.makeSignDoc)(msgs, fee, chainId, memo, accountNumber, sequence);
        const { signature, signed } = await this.signer.signAmino(signerAddress, signDoc);
        const signedTxBody = {
            messages: signed.msgs.map((msg) => this.aminoTypes.fromAmino(msg)),
            memo: signed.memo,
        };
        const signedTxBodyEncodeObject = {
            typeUrl: "/cosmos.tx.v1beta1.TxBody",
            value: signedTxBody,
        };
        const signedTxBodyBytes = this.registry.encode(signedTxBodyEncodeObject);
        const signedGasLimit = math_1.Int53.fromString(signed.fee.gas).toNumber();
        const signedSequence = math_1.Int53.fromString(signed.sequence).toNumber();
        const signedAuthInfoBytes = (0, proto_signing_1.makeAuthInfoBytes)([{ pubkey, sequence: signedSequence }], signed.fee.amount, signedGasLimit, signed.fee.granter, signed.fee.payer, signMode);
        return tx_3.TxRaw.fromPartial({
            bodyBytes: signedTxBodyBytes,
            authInfoBytes: signedAuthInfoBytes,
            signatures: [(0, encoding_1.fromBase64)(signature.signature)],
        });
    }
    async signDirect(signerAddress, messages, fee, memo, { accountNumber, sequence, chainId }) {
        (0, utils_1.assert)((0, proto_signing_1.isOfflineDirectSigner)(this.signer));
        const accountFromSigner = (await this.signer.getAccounts()).find((account) => account.address === signerAddress);
        if (!accountFromSigner) {
            throw new Error("Failed to retrieve account from signer");
        }
        const pubkey = (0, proto_signing_1.encodePubkey)((0, amino_1.encodeSecp256k1Pubkey)(accountFromSigner.pubkey));
        const txBodyEncodeObject = {
            typeUrl: "/cosmos.tx.v1beta1.TxBody",
            value: {
                messages: messages,
                memo: memo,
            },
        };
        const txBodyBytes = this.registry.encode(txBodyEncodeObject);
        const gasLimit = math_1.Int53.fromString(fee.gas).toNumber();
        const authInfoBytes = (0, proto_signing_1.makeAuthInfoBytes)([{ pubkey, sequence }], fee.amount, gasLimit, fee.granter, fee.payer);
        const signDoc = (0, proto_signing_1.makeSignDoc)(txBodyBytes, authInfoBytes, chainId, accountNumber);
        const { signature, signed } = await this.signer.signDirect(signerAddress, signDoc);
        return tx_3.TxRaw.fromPartial({
            bodyBytes: signed.bodyBytes,
            authInfoBytes: signed.authInfoBytes,
            signatures: [(0, encoding_1.fromBase64)(signature.signature)],
        });
    }
}
exports.SigningStargateClient = SigningStargateClient;
//# sourceMappingURL=signingstargateclient.js.map

/***/ }),

/***/ 38577:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.StargateClient = exports.BroadcastTxError = exports.assertIsDeliverTxFailure = exports.assertIsDeliverTxSuccess = exports.isDeliverTxSuccess = exports.isDeliverTxFailure = exports.TimeoutError = void 0;
/* eslint-disable @typescript-eslint/naming-convention */
const amino_1 = __webpack_require__(98802);
const encoding_1 = __webpack_require__(87061);
const math_1 = __webpack_require__(66021);
const tendermint_rpc_1 = __webpack_require__(52474);
const utils_1 = __webpack_require__(62584);
const abci_1 = __webpack_require__(7088);
const accounts_1 = __webpack_require__(58966);
const events_1 = __webpack_require__(47737);
const modules_1 = __webpack_require__(6749);
const queryclient_1 = __webpack_require__(46300);
class TimeoutError extends Error {
    constructor(message, txId) {
        super(message);
        this.txId = txId;
    }
}
exports.TimeoutError = TimeoutError;
function isDeliverTxFailure(result) {
    return !!result.code;
}
exports.isDeliverTxFailure = isDeliverTxFailure;
function isDeliverTxSuccess(result) {
    return !isDeliverTxFailure(result);
}
exports.isDeliverTxSuccess = isDeliverTxSuccess;
/**
 * Ensures the given result is a success. Throws a detailed error message otherwise.
 */
function assertIsDeliverTxSuccess(result) {
    if (isDeliverTxFailure(result)) {
        throw new Error(`Error when broadcasting tx ${result.transactionHash} at height ${result.height}. Code: ${result.code}; Raw log: ${result.rawLog}`);
    }
}
exports.assertIsDeliverTxSuccess = assertIsDeliverTxSuccess;
/**
 * Ensures the given result is a failure. Throws a detailed error message otherwise.
 */
function assertIsDeliverTxFailure(result) {
    if (isDeliverTxSuccess(result)) {
        throw new Error(`Transaction ${result.transactionHash} did not fail at height ${result.height}. Code: ${result.code}; Raw log: ${result.rawLog}`);
    }
}
exports.assertIsDeliverTxFailure = assertIsDeliverTxFailure;
/**
 * An error when broadcasting the transaction. This contains the CheckTx errors
 * from the blockchain. Once a transaction is included in a block no BroadcastTxError
 * is thrown, even if the execution fails (DeliverTx errors).
 */
class BroadcastTxError extends Error {
    constructor(code, codespace, log) {
        super(`Broadcasting transaction failed with code ${code} (codespace: ${codespace}). Log: ${log}`);
        this.code = code;
        this.codespace = codespace;
        this.log = log;
    }
}
exports.BroadcastTxError = BroadcastTxError;
class StargateClient {
    /**
     * Creates an instance by connecting to the given Tendermint RPC endpoint.
     *
     * This uses auto-detection to decide between a Tendermint 0.37 and 0.34 client.
     * To set the Tendermint client explicitly, use `create`.
     */
    static async connect(endpoint, options = {}) {
        // Tendermint/CometBFT 0.34/0.37 auto-detection. Starting with 0.37 we seem to get reliable versions again 🎉
        // Using 0.34 as the fallback.
        let tmClient;
        const tm37Client = await tendermint_rpc_1.Tendermint37Client.connect(endpoint);
        const version = (await tm37Client.status()).nodeInfo.version;
        if (version.startsWith("0.37.")) {
            tmClient = tm37Client;
        }
        else {
            tm37Client.disconnect();
            tmClient = await tendermint_rpc_1.Tendermint34Client.connect(endpoint);
        }
        return StargateClient.create(tmClient, options);
    }
    /**
     * Creates an instance from a manually created Tendermint client.
     * Use this to use `Tendermint37Client` instead of `Tendermint34Client`.
     */
    static async create(tmClient, options = {}) {
        return new StargateClient(tmClient, options);
    }
    constructor(tmClient, options) {
        if (tmClient) {
            this.tmClient = tmClient;
            this.queryClient = queryclient_1.QueryClient.withExtensions(tmClient, modules_1.setupAuthExtension, modules_1.setupBankExtension, modules_1.setupStakingExtension, modules_1.setupTxExtension);
        }
        const { accountParser = accounts_1.accountFromAny } = options;
        this.accountParser = accountParser;
    }
    getTmClient() {
        return this.tmClient;
    }
    forceGetTmClient() {
        if (!this.tmClient) {
            throw new Error("Tendermint client not available. You cannot use online functionality in offline mode.");
        }
        return this.tmClient;
    }
    getQueryClient() {
        return this.queryClient;
    }
    forceGetQueryClient() {
        if (!this.queryClient) {
            throw new Error("Query client not available. You cannot use online functionality in offline mode.");
        }
        return this.queryClient;
    }
    async getChainId() {
        if (!this.chainId) {
            const response = await this.forceGetTmClient().status();
            const chainId = response.nodeInfo.network;
            if (!chainId)
                throw new Error("Chain ID must not be empty");
            this.chainId = chainId;
        }
        return this.chainId;
    }
    async getHeight() {
        const status = await this.forceGetTmClient().status();
        return status.syncInfo.latestBlockHeight;
    }
    async getAccount(searchAddress) {
        try {
            const account = await this.forceGetQueryClient().auth.account(searchAddress);
            return account ? this.accountParser(account) : null;
        }
        catch (error) {
            if (/rpc error: code = NotFound/i.test(error.toString())) {
                return null;
            }
            throw error;
        }
    }
    async getSequence(address) {
        const account = await this.getAccount(address);
        if (!account) {
            throw new Error(`Account '${address}' does not exist on chain. Send some tokens there before trying to query sequence.`);
        }
        return {
            accountNumber: account.accountNumber,
            sequence: account.sequence,
        };
    }
    async getBlock(height) {
        const response = await this.forceGetTmClient().block(height);
        return {
            id: (0, encoding_1.toHex)(response.blockId.hash).toUpperCase(),
            header: {
                version: {
                    block: new math_1.Uint53(response.block.header.version.block).toString(),
                    app: new math_1.Uint53(response.block.header.version.app).toString(),
                },
                height: response.block.header.height,
                chainId: response.block.header.chainId,
                time: (0, tendermint_rpc_1.toRfc3339WithNanoseconds)(response.block.header.time),
            },
            txs: response.block.txs,
        };
    }
    async getBalance(address, searchDenom) {
        return this.forceGetQueryClient().bank.balance(address, searchDenom);
    }
    /**
     * Queries all balances for all denoms that belong to this address.
     *
     * Uses the grpc queries (which iterates over the store internally), and we cannot get
     * proofs from such a method.
     */
    async getAllBalances(address) {
        return this.forceGetQueryClient().bank.allBalances(address);
    }
    async getBalanceStaked(address) {
        const allDelegations = [];
        let startAtKey = undefined;
        do {
            const { delegationResponses, pagination } = await this.forceGetQueryClient().staking.delegatorDelegations(address, startAtKey);
            const loadedDelegations = delegationResponses || [];
            allDelegations.push(...loadedDelegations);
            startAtKey = pagination?.nextKey;
        } while (startAtKey !== undefined && startAtKey.length !== 0);
        const sumValues = allDelegations.reduce((previousValue, currentValue) => {
            // Safe because field is set to non-nullable (https://github.com/cosmos/cosmos-sdk/blob/v0.45.3/proto/cosmos/staking/v1beta1/staking.proto#L295)
            (0, utils_1.assert)(currentValue.balance);
            return previousValue !== null ? (0, amino_1.addCoins)(previousValue, currentValue.balance) : currentValue.balance;
        }, null);
        return sumValues;
    }
    async getDelegation(delegatorAddress, validatorAddress) {
        let delegatedAmount;
        try {
            delegatedAmount = (await this.forceGetQueryClient().staking.delegation(delegatorAddress, validatorAddress)).delegationResponse?.balance;
        }
        catch (e) {
            if (e.toString().includes("key not found")) {
                // ignore, `delegatedAmount` remains undefined
            }
            else {
                throw e;
            }
        }
        return delegatedAmount || null;
    }
    async getTx(id) {
        const results = await this.txsQuery(`tx.hash='${id}'`);
        return results[0] ?? null;
    }
    async searchTx(query) {
        let rawQuery;
        if (typeof query === "string") {
            rawQuery = query;
        }
        else if (Array.isArray(query)) {
            rawQuery = query.map((t) => `${t.key}='${t.value}'`).join(" AND ");
        }
        else {
            throw new Error("Got unsupported query type. See CosmJS 0.31 CHANGELOG for API breaking changes here.");
        }
        return this.txsQuery(rawQuery);
    }
    disconnect() {
        if (this.tmClient)
            this.tmClient.disconnect();
    }
    /**
     * Broadcasts a signed transaction to the network and monitors its inclusion in a block.
     *
     * If broadcasting is rejected by the node for some reason (e.g. because of a CheckTx failure),
     * an error is thrown.
     *
     * If the transaction is not included in a block before the provided timeout, this errors with a `TimeoutError`.
     *
     * If the transaction is included in a block, a `DeliverTxResponse` is returned. The caller then
     * usually needs to check for execution success or failure.
     */
    async broadcastTx(tx, timeoutMs = 60000, pollIntervalMs = 3000) {
        let timedOut = false;
        const txPollTimeout = setTimeout(() => {
            timedOut = true;
        }, timeoutMs);
        const pollForTx = async (txId) => {
            if (timedOut) {
                throw new TimeoutError(`Transaction with ID ${txId} was submitted but was not yet found on the chain. You might want to check later. There was a wait of ${timeoutMs / 1000} seconds.`, txId);
            }
            await (0, utils_1.sleep)(pollIntervalMs);
            const result = await this.getTx(txId);
            return result
                ? {
                    code: result.code,
                    height: result.height,
                    txIndex: result.txIndex,
                    events: result.events,
                    rawLog: result.rawLog,
                    transactionHash: txId,
                    msgResponses: result.msgResponses,
                    gasUsed: result.gasUsed,
                    gasWanted: result.gasWanted,
                }
                : pollForTx(txId);
        };
        const transactionId = await this.broadcastTxSync(tx);
        return new Promise((resolve, reject) => pollForTx(transactionId).then((value) => {
            clearTimeout(txPollTimeout);
            resolve(value);
        }, (error) => {
            clearTimeout(txPollTimeout);
            reject(error);
        }));
    }
    /**
     * Broadcasts a signed transaction to the network without monitoring it.
     *
     * If broadcasting is rejected by the node for some reason (e.g. because of a CheckTx failure),
     * an error is thrown.
     *
     * If the transaction is broadcasted, a `string` containing the hash of the transaction is returned. The caller then
     * usually needs to check if the transaction was included in a block and was successful.
     *
     * @returns Returns the hash of the transaction
     */
    async broadcastTxSync(tx) {
        const broadcasted = await this.forceGetTmClient().broadcastTxSync({ tx });
        if (broadcasted.code) {
            return Promise.reject(new BroadcastTxError(broadcasted.code, broadcasted.codespace ?? "", broadcasted.log));
        }
        const transactionId = (0, encoding_1.toHex)(broadcasted.hash).toUpperCase();
        return transactionId;
    }
    async txsQuery(query) {
        const results = await this.forceGetTmClient().txSearchAll({ query: query });
        return results.txs.map((tx) => {
            const txMsgData = abci_1.TxMsgData.decode(tx.result.data ?? new Uint8Array());
            return {
                height: tx.height,
                txIndex: tx.index,
                hash: (0, encoding_1.toHex)(tx.hash).toUpperCase(),
                code: tx.result.code,
                events: tx.result.events.map(events_1.fromTendermintEvent),
                rawLog: tx.result.log || "",
                tx: tx.tx,
                msgResponses: txMsgData.msgResponses,
                gasUsed: tx.result.gasUsed,
                gasWanted: tx.result.gasWanted,
            };
        });
    }
}
exports.StargateClient = StargateClient;
//# sourceMappingURL=stargateclient.js.map

/***/ }),

/***/ 83877:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.concat = void 0;
const xstream_1 = __webpack_require__(43813);
/**
 * An implementation of concat that buffers all source stream events
 *
 * Marble diagram:
 *
 * ```text
 * --1--2---3---4-|
 * -a--b-c--d-|
 * --------X---------Y---------Z-
 *           concat
 * --1--2---3---4-abcdXY-------Z-
 * ```
 *
 * This is inspired by RxJS's concat as documented at http://rxmarbles.com/#concat and behaves
 * differently than xstream's concat as discussed in https://github.com/staltz/xstream/issues/170.
 *
 */
function concat(...streams) {
    const subscriptions = new Array();
    const queues = new Array(); // one queue per stream
    const completedStreams = new Set();
    let activeStreamIndex = 0;
    function reset() {
        while (subscriptions.length > 0) {
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const subscription = subscriptions.shift();
            subscription.unsubscribe();
        }
        queues.length = 0;
        completedStreams.clear();
        activeStreamIndex = 0;
    }
    const producer = {
        start: (listener) => {
            streams.forEach((_) => queues.push([]));
            function emitAllQueuesEvents(streamIndex) {
                // eslint-disable-next-line no-constant-condition
                while (true) {
                    const element = queues[streamIndex].shift();
                    if (element === undefined) {
                        return;
                    }
                    listener.next(element);
                }
            }
            function isDone() {
                return activeStreamIndex >= streams.length;
            }
            if (isDone()) {
                listener.complete();
                return;
            }
            streams.forEach((stream, index) => {
                subscriptions.push(stream.subscribe({
                    next: (value) => {
                        if (index === activeStreamIndex) {
                            listener.next(value);
                        }
                        else {
                            queues[index].push(value);
                        }
                    },
                    complete: () => {
                        completedStreams.add(index);
                        while (completedStreams.has(activeStreamIndex)) {
                            // this stream completed: emit all and move on
                            emitAllQueuesEvents(activeStreamIndex);
                            activeStreamIndex++;
                        }
                        if (isDone()) {
                            listener.complete();
                        }
                        else {
                            // now active stream can have some events queued but did not yet complete
                            emitAllQueuesEvents(activeStreamIndex);
                        }
                    },
                    error: (error) => {
                        listener.error(error);
                        reset();
                    },
                }));
            });
        },
        stop: () => {
            reset();
        },
    };
    return xstream_1.Stream.create(producer);
}
exports.concat = concat;
//# sourceMappingURL=concat.js.map

/***/ }),

/***/ 13315:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.DefaultValueProducer = void 0;
// allows pre-producing values before anyone is listening
class DefaultValueProducer {
    get value() {
        return this.internalValue;
    }
    constructor(value, callbacks) {
        this.callbacks = callbacks;
        this.internalValue = value;
    }
    /**
     * Update the current value.
     *
     * If producer is active (i.e. someone is listening), this emits an event.
     * If not, just the current value is updated.
     */
    update(value) {
        this.internalValue = value;
        if (this.listener) {
            this.listener.next(value);
        }
    }
    /**
     * Produce an error
     */
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    error(error) {
        if (this.listener) {
            this.listener.error(error);
        }
    }
    /**
     * Called by the stream. Do not call this directly.
     */
    start(listener) {
        this.listener = listener;
        listener.next(this.internalValue);
        if (this.callbacks) {
            this.callbacks.onStarted();
        }
    }
    /**
     * Called by the stream. Do not call this directly.
     */
    stop() {
        if (this.callbacks) {
            this.callbacks.onStop();
        }
        this.listener = undefined;
    }
}
exports.DefaultValueProducer = DefaultValueProducer;
//# sourceMappingURL=defaultvalueproducer.js.map

/***/ }),

/***/ 78247:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.dropDuplicates = void 0;
/**
 * Drops duplicate values in a stream.
 *
 * Marble diagram:
 *
 * ```text
 * -1-1-1-2-4-3-3-4--
 *   dropDuplicates
 * -1-----2-4-3------
 * ```
 *
 * Each value must be uniquely identified by a string given by
 * valueToKey(value).
 *
 * Internally this maintains a set of keys that have been processed already,
 * i.e. memory consumption and Set lookup times should be considered when
 * using this function.
 */
function dropDuplicates(valueToKey) {
    const operand = (instream) => {
        const emittedKeys = new Set();
        const deduplicatedStream = instream
            .filter((value) => !emittedKeys.has(valueToKey(value)))
            .debug((value) => emittedKeys.add(valueToKey(value)));
        return deduplicatedStream;
    };
    return operand;
}
exports.dropDuplicates = dropDuplicates;
//# sourceMappingURL=dropduplicates.js.map

/***/ }),

/***/ 2464:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ValueAndUpdates = exports.toListPromise = exports.fromListPromise = exports.firstEvent = exports.dropDuplicates = exports.DefaultValueProducer = exports.concat = void 0;
var concat_1 = __webpack_require__(83877);
Object.defineProperty(exports, "concat", ({ enumerable: true, get: function () { return concat_1.concat; } }));
var defaultvalueproducer_1 = __webpack_require__(13315);
Object.defineProperty(exports, "DefaultValueProducer", ({ enumerable: true, get: function () { return defaultvalueproducer_1.DefaultValueProducer; } }));
var dropduplicates_1 = __webpack_require__(78247);
Object.defineProperty(exports, "dropDuplicates", ({ enumerable: true, get: function () { return dropduplicates_1.dropDuplicates; } }));
var promise_1 = __webpack_require__(60194);
Object.defineProperty(exports, "firstEvent", ({ enumerable: true, get: function () { return promise_1.firstEvent; } }));
Object.defineProperty(exports, "fromListPromise", ({ enumerable: true, get: function () { return promise_1.fromListPromise; } }));
Object.defineProperty(exports, "toListPromise", ({ enumerable: true, get: function () { return promise_1.toListPromise; } }));
__exportStar(__webpack_require__(57516), exports);
var valueandupdates_1 = __webpack_require__(36951);
Object.defineProperty(exports, "ValueAndUpdates", ({ enumerable: true, get: function () { return valueandupdates_1.ValueAndUpdates; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 60194:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.firstEvent = exports.toListPromise = exports.fromListPromise = void 0;
const xstream_1 = __webpack_require__(43813);
/**
 * Emits one event for each list element as soon as the promise resolves
 */
function fromListPromise(promise) {
    const producer = {
        start: (listener) => {
            // the code in `start` runs as soon as anyone listens to the stream
            promise
                .then((iterable) => {
                for (const element of iterable) {
                    listener.next(element);
                }
                listener.complete();
            })
                .catch((error) => listener.error(error));
        },
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        stop: () => { },
    };
    return xstream_1.Stream.create(producer);
}
exports.fromListPromise = fromListPromise;
/**
 * Listens to stream and collects events. When `count` events are collected,
 * the promise resolves with an array of events.
 *
 * Rejects if stream completes before `count` events are collected.
 */
async function toListPromise(stream, count) {
    return new Promise((resolve, reject) => {
        if (count === 0) {
            resolve([]);
            return;
        }
        const events = new Array();
        // take() unsubscribes from source stream automatically
        stream.take(count).subscribe({
            next: (event) => {
                events.push(event);
                if (events.length === count) {
                    resolve(events);
                }
            },
            complete: () => {
                reject(`Stream completed before all events could be collected. ` +
                    `Collected ${events.length}, expected ${count}`);
            },
            error: (error) => reject(error),
        });
    });
}
exports.toListPromise = toListPromise;
/**
 * Listens to stream, collects one event and revolves.
 *
 * Rejects if stream completes before one event was fired.
 */
async function firstEvent(stream) {
    return (await toListPromise(stream, 1))[0];
}
exports.firstEvent = firstEvent;
//# sourceMappingURL=promise.js.map

/***/ }),

/***/ 57516:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.lastValue = exports.asArray = exports.countStream = exports.Reducer = void 0;
// Reducer takes a stream of events T and a ReducerFunc, that
// materializes a state of type U.
class Reducer {
    constructor(stream, reducer, initState) {
        this.stream = stream;
        this.reducer = reducer;
        this.state = initState;
        this.completed = new Promise((resolve, reject) => {
            const subscription = this.stream.subscribe({
                next: (evt) => {
                    this.state = this.reducer(this.state, evt);
                },
                complete: () => {
                    resolve();
                    // this must happen after resolve, to ensure stream.subscribe() has finished
                    subscription.unsubscribe();
                },
                error: (err) => {
                    reject(err);
                    // the stream already closed on error, but unsubscribe to be safe
                    subscription.unsubscribe();
                },
            });
        });
    }
    // value returns current materialized state
    value() {
        return this.state;
    }
    // finished resolves on completed stream, rejects on stream error
    async finished() {
        return this.completed;
    }
}
exports.Reducer = Reducer;
function increment(sum, _) {
    return sum + 1;
}
// countStream returns a reducer that contains current count
// of events on the stream
function countStream(stream) {
    return new Reducer(stream, increment, 0);
}
exports.countStream = countStream;
function append(list, evt) {
    return [...list, evt];
}
// asArray maintains an array containing all events that have
// occurred on the stream
function asArray(stream) {
    return new Reducer(stream, append, []);
}
exports.asArray = asArray;
function last(_, event) {
    return event;
}
// lastValue returns the last value read from the stream, or undefined if no values sent
function lastValue(stream) {
    return new Reducer(stream, last, undefined);
}
exports.lastValue = lastValue;
//# sourceMappingURL=reducer.js.map

/***/ }),

/***/ 36951:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ValueAndUpdates = void 0;
const xstream_1 = __webpack_require__(43813);
/**
 * A read only wrapper around DefaultValueProducer that allows
 * to synchronously get the current value using the .value property
 * and listen to to updates by suscribing to the .updates stream
 */
class ValueAndUpdates {
    get value() {
        return this.producer.value;
    }
    constructor(producer) {
        this.producer = producer;
        this.updates = xstream_1.MemoryStream.createWithMemory(this.producer);
    }
    /**
     * Resolves as soon as search value is found.
     *
     * @param search either a value or a function that must return true when found
     * @returns the value of the update that caused the search match
     */
    async waitFor(search) {
        const searchImplementation = typeof search === "function" ? search : (value) => value === search;
        return new Promise((resolve, reject) => {
            const subscription = this.updates.subscribe({
                next: (newValue) => {
                    if (searchImplementation(newValue)) {
                        resolve(newValue);
                        // MemoryStream.subscribe() calls next with the last value.
                        // Make async to ensure the subscription exists
                        setTimeout(() => subscription.unsubscribe(), 0);
                    }
                },
                complete: () => {
                    subscription.unsubscribe();
                    reject("Update stream completed without expected value");
                },
                error: (error) => {
                    reject(error);
                },
            });
        });
    }
}
exports.ValueAndUpdates = ValueAndUpdates;
//# sourceMappingURL=valueandupdates.js.map

/***/ }),

/***/ 77230:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.pubkeyToAddress = exports.pubkeyToRawAddress = exports.rawSecp256k1PubkeyToRawAddress = exports.rawEd25519PubkeyToRawAddress = void 0;
const crypto_1 = __webpack_require__(45027);
const encoding_1 = __webpack_require__(87061);
function rawEd25519PubkeyToRawAddress(pubkeyData) {
    if (pubkeyData.length !== 32) {
        throw new Error(`Invalid Ed25519 pubkey length: ${pubkeyData.length}`);
    }
    return (0, crypto_1.sha256)(pubkeyData).slice(0, 20);
}
exports.rawEd25519PubkeyToRawAddress = rawEd25519PubkeyToRawAddress;
function rawSecp256k1PubkeyToRawAddress(pubkeyData) {
    if (pubkeyData.length !== 33) {
        throw new Error(`Invalid Secp256k1 pubkey length (compressed): ${pubkeyData.length}`);
    }
    return (0, crypto_1.ripemd160)((0, crypto_1.sha256)(pubkeyData));
}
exports.rawSecp256k1PubkeyToRawAddress = rawSecp256k1PubkeyToRawAddress;
/**
 * Returns Tendermint address as bytes.
 *
 * This is for addresses that are derived by the Tendermint keypair (typically Ed25519).
 * Sometimes those addresses are bech32-encoded and contain the term "cons" in the presix
 * ("cosmosvalcons1...").
 *
 * For secp256k1 this assumes we already have a compressed pubkey, which is the default in Cosmos.
 */
function pubkeyToRawAddress(type, data) {
    switch (type) {
        case "ed25519":
            return rawEd25519PubkeyToRawAddress(data);
        case "secp256k1":
            return rawSecp256k1PubkeyToRawAddress(data);
        default:
            // Keep this case here to guard against new types being added but not handled
            throw new Error(`Pubkey type ${type} not supported`);
    }
}
exports.pubkeyToRawAddress = pubkeyToRawAddress;
/**
 * Returns Tendermint address in uppercase hex format.
 *
 * This is for addresses that are derived by the Tendermint keypair (typically Ed25519).
 * Sometimes those addresses are bech32-encoded and contain the term "cons" in the presix
 * ("cosmosvalcons1...").
 *
 * For secp256k1 this assumes we already have a compressed pubkey, which is the default in Cosmos.
 */
function pubkeyToAddress(type, data) {
    return (0, encoding_1.toHex)(pubkeyToRawAddress(type, data)).toUpperCase();
}
exports.pubkeyToAddress = pubkeyToAddress;
//# sourceMappingURL=addresses.js.map

/***/ }),

/***/ 11756:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.DateTime = exports.toSeconds = exports.fromSeconds = exports.toRfc3339WithNanoseconds = exports.fromRfc3339WithNanoseconds = void 0;
const encoding_1 = __webpack_require__(87061);
const math_1 = __webpack_require__(66021);
function fromRfc3339WithNanoseconds(dateTimeString) {
    const out = (0, encoding_1.fromRfc3339)(dateTimeString);
    const nanosecondsMatch = dateTimeString.match(/\.(\d+)Z$/);
    const nanoseconds = nanosecondsMatch ? nanosecondsMatch[1].slice(3) : "";
    out.nanoseconds = parseInt(nanoseconds.padEnd(6, "0"), 10);
    return out;
}
exports.fromRfc3339WithNanoseconds = fromRfc3339WithNanoseconds;
function toRfc3339WithNanoseconds(dateTime) {
    const millisecondIso = dateTime.toISOString();
    const nanoseconds = dateTime.nanoseconds?.toString() ?? "";
    return `${millisecondIso.slice(0, -1)}${nanoseconds.padStart(6, "0")}Z`;
}
exports.toRfc3339WithNanoseconds = toRfc3339WithNanoseconds;
function fromSeconds(seconds, nanos = 0) {
    const checkedNanos = new math_1.Uint32(nanos).toNumber();
    if (checkedNanos > 999999999) {
        throw new Error("Nano seconds must not exceed 999999999");
    }
    const out = new Date(seconds * 1000 + Math.floor(checkedNanos / 1000000));
    out.nanoseconds = checkedNanos % 1000000;
    return out;
}
exports.fromSeconds = fromSeconds;
/**
 * Calculates the UNIX timestamp in seconds as well as the nanoseconds after the given second.
 *
 * This is useful when dealing with external systems like the protobuf type
 * [.google.protobuf.Timestamp](https://developers.google.com/protocol-buffers/docs/reference/google.protobuf#google.protobuf.Timestamp)
 * or any other system that does not use millisecond precision.
 */
function toSeconds(date) {
    return {
        seconds: Math.floor(date.getTime() / 1000),
        nanos: (date.getTime() % 1000) * 1000000 + (date.nanoseconds ?? 0),
    };
}
exports.toSeconds = toSeconds;
/** @deprecated Use fromRfc3339WithNanoseconds/toRfc3339WithNanoseconds instead */
class DateTime {
    /** @deprecated Use fromRfc3339WithNanoseconds instead */
    static decode(dateTimeString) {
        return fromRfc3339WithNanoseconds(dateTimeString);
    }
    /** @deprecated Use toRfc3339WithNanoseconds instead */
    static encode(dateTime) {
        return toRfc3339WithNanoseconds(dateTime);
    }
}
exports.DateTime = DateTime;
//# sourceMappingURL=dates.js.map

/***/ }),

/***/ 52474:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.BlockIdFlag = exports.isTendermint37Client = exports.isTendermint34Client = exports.Tendermint37Client = exports.tendermint37 = exports.Tendermint34Client = exports.tendermint34 = exports.VoteType = exports.SubscriptionEventType = exports.Method = exports.broadcastTxSyncSuccess = exports.broadcastTxCommitSuccess = exports.WebsocketClient = exports.HttpClient = exports.HttpBatchClient = exports.toSeconds = exports.toRfc3339WithNanoseconds = exports.fromSeconds = exports.fromRfc3339WithNanoseconds = exports.DateTime = exports.rawSecp256k1PubkeyToRawAddress = exports.rawEd25519PubkeyToRawAddress = exports.pubkeyToRawAddress = exports.pubkeyToAddress = void 0;
var addresses_1 = __webpack_require__(77230);
Object.defineProperty(exports, "pubkeyToAddress", ({ enumerable: true, get: function () { return addresses_1.pubkeyToAddress; } }));
Object.defineProperty(exports, "pubkeyToRawAddress", ({ enumerable: true, get: function () { return addresses_1.pubkeyToRawAddress; } }));
Object.defineProperty(exports, "rawEd25519PubkeyToRawAddress", ({ enumerable: true, get: function () { return addresses_1.rawEd25519PubkeyToRawAddress; } }));
Object.defineProperty(exports, "rawSecp256k1PubkeyToRawAddress", ({ enumerable: true, get: function () { return addresses_1.rawSecp256k1PubkeyToRawAddress; } }));
var dates_1 = __webpack_require__(11756);
Object.defineProperty(exports, "DateTime", ({ enumerable: true, get: function () { return dates_1.DateTime; } }));
Object.defineProperty(exports, "fromRfc3339WithNanoseconds", ({ enumerable: true, get: function () { return dates_1.fromRfc3339WithNanoseconds; } }));
Object.defineProperty(exports, "fromSeconds", ({ enumerable: true, get: function () { return dates_1.fromSeconds; } }));
Object.defineProperty(exports, "toRfc3339WithNanoseconds", ({ enumerable: true, get: function () { return dates_1.toRfc3339WithNanoseconds; } }));
Object.defineProperty(exports, "toSeconds", ({ enumerable: true, get: function () { return dates_1.toSeconds; } }));
// The public Tendermint34Client.create constructor allows manually choosing an RpcClient.
// This is currently the only way to switch to the HttpBatchClient (which may become default at some point).
// Due to this API, we make RPC client implementations public.
var rpcclients_1 = __webpack_require__(82492);
Object.defineProperty(exports, "HttpBatchClient", ({ enumerable: true, get: function () { return rpcclients_1.HttpBatchClient; } }));
Object.defineProperty(exports, "HttpClient", ({ enumerable: true, get: function () { return rpcclients_1.HttpClient; } }));
Object.defineProperty(exports, "WebsocketClient", ({ enumerable: true, get: function () { return rpcclients_1.WebsocketClient; } }));
var tendermint34_1 = __webpack_require__(2621);
Object.defineProperty(exports, "broadcastTxCommitSuccess", ({ enumerable: true, get: function () { return tendermint34_1.broadcastTxCommitSuccess; } }));
Object.defineProperty(exports, "broadcastTxSyncSuccess", ({ enumerable: true, get: function () { return tendermint34_1.broadcastTxSyncSuccess; } }));
Object.defineProperty(exports, "Method", ({ enumerable: true, get: function () { return tendermint34_1.Method; } }));
Object.defineProperty(exports, "SubscriptionEventType", ({ enumerable: true, get: function () { return tendermint34_1.SubscriptionEventType; } }));
Object.defineProperty(exports, "VoteType", ({ enumerable: true, get: function () { return tendermint34_1.VoteType; } }));
exports.tendermint34 = __importStar(__webpack_require__(2621));
var tendermint34_2 = __webpack_require__(2621);
Object.defineProperty(exports, "Tendermint34Client", ({ enumerable: true, get: function () { return tendermint34_2.Tendermint34Client; } }));
exports.tendermint37 = __importStar(__webpack_require__(15900));
var tendermint37_1 = __webpack_require__(15900);
Object.defineProperty(exports, "Tendermint37Client", ({ enumerable: true, get: function () { return tendermint37_1.Tendermint37Client; } }));
var tendermintclient_1 = __webpack_require__(95828);
Object.defineProperty(exports, "isTendermint34Client", ({ enumerable: true, get: function () { return tendermintclient_1.isTendermint34Client; } }));
Object.defineProperty(exports, "isTendermint37Client", ({ enumerable: true, get: function () { return tendermintclient_1.isTendermint37Client; } }));
var types_1 = __webpack_require__(26823);
Object.defineProperty(exports, "BlockIdFlag", ({ enumerable: true, get: function () { return types_1.BlockIdFlag; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 47450:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.smallIntToApi = exports.apiToBigInt = exports.apiToSmallInt = void 0;
const math_1 = __webpack_require__(66021);
const encodings_1 = __webpack_require__(87826);
/**
 * Takes an integer value from the Tendermint RPC API and
 * returns it as number.
 *
 * Only works within the safe integer range.
 */
function apiToSmallInt(input) {
    const asInt = typeof input === "number" ? new math_1.Int53(input) : math_1.Int53.fromString(input);
    return asInt.toNumber();
}
exports.apiToSmallInt = apiToSmallInt;
/**
 * Takes an integer value from the Tendermint RPC API and
 * returns it as BigInt.
 *
 * This supports the full uint64 and int64 ranges.
 */
function apiToBigInt(input) {
    (0, encodings_1.assertString)(input); // Runtime check on top of TypeScript just to be safe for semi-trusted API types
    if (!input.match(/^-?[0-9]+$/)) {
        throw new Error("Invalid string format");
    }
    return BigInt(input);
}
exports.apiToBigInt = apiToBigInt;
/**
 * Takes an integer in the safe integer range and returns
 * a string representation to be used in the Tendermint RPC API.
 */
function smallIntToApi(num) {
    return new math_1.Int53(num).toString();
}
exports.smallIntToApi = smallIntToApi;
//# sourceMappingURL=inthelpers.js.map

/***/ }),

/***/ 57657:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.createJsonRpcRequest = void 0;
const numbersWithoutZero = "123456789";
/** generates a random numeric character  */
function randomNumericChar() {
    return numbersWithoutZero[Math.floor(Math.random() * numbersWithoutZero.length)];
}
/**
 * An (absolutely not cryptographically secure) random integer > 0.
 */
function randomId() {
    return parseInt(Array.from({ length: 12 })
        .map(() => randomNumericChar())
        .join(""), 10);
}
/** Creates a JSON-RPC request with random ID */
// eslint-disable-next-line @typescript-eslint/ban-types
function createJsonRpcRequest(method, params) {
    const paramsCopy = params ? { ...params } : {};
    return {
        jsonrpc: "2.0",
        id: randomId(),
        method: method,
        params: paramsCopy,
    };
}
exports.createJsonRpcRequest = createJsonRpcRequest;
//# sourceMappingURL=jsonrpc.js.map

/***/ }),

/***/ 94662:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.http = void 0;
const axios_1 = __importDefault(__webpack_require__(9669));
function filterBadStatus(res) {
    if (res.status >= 400) {
        throw new Error(`Bad status on response: ${res.status}`);
    }
    return res;
}
/**
 * Node.js 18 comes with exprimental fetch support (https://nodejs.org/de/blog/announcements/v18-release-announce/).
 * This is nice, but the implementation does not yet work wekk for us. We
 * can just stick with axios on those systems for now.
 */
// eslint-disable-next-line @typescript-eslint/ban-types
function isExperimental(nodeJsFunc) {
    // This works because we get this info in node 18:
    //
    // > fetch.toString()
    // 'async function fetch(input, init = undefined) {\n' +
    // "    emitExperimentalWarning('The Fetch API');\n" +
    // '    return lazyUndici().fetch(input, init);\n' +
    // '  }'
    return nodeJsFunc.toString().includes("emitExperimentalWarning");
}
/**
 * Helper to work around missing CORS support in Tendermint (https://github.com/tendermint/tendermint/pull/2800)
 *
 * For some reason, fetch does not complain about missing server-side CORS support.
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
async function http(method, url, headers, request) {
    if (typeof fetch === "function" && !isExperimental(fetch)) {
        const settings = {
            method: method,
            body: request ? JSON.stringify(request) : undefined,
            headers: {
                // eslint-disable-next-line @typescript-eslint/naming-convention
                "Content-Type": "application/json",
                ...headers,
            },
        };
        return fetch(url, settings)
            .then(filterBadStatus)
            .then((res) => res.json());
    }
    else {
        return axios_1.default
            .request({ url: url, method: method, data: request, headers: headers })
            .then((res) => res.data);
    }
}
exports.http = http;
//# sourceMappingURL=http.js.map

/***/ }),

/***/ 97275:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.HttpBatchClient = void 0;
const json_rpc_1 = __webpack_require__(59606);
const http_1 = __webpack_require__(94662);
const rpcclient_1 = __webpack_require__(50040);
// Those values are private and can change any time.
// Does a user need to know them? I don't think so. You either set
// a custom value or leave the option field unset.
const defaultHttpBatchClientOptions = {
    dispatchInterval: 20,
    batchSizeLimit: 20,
};
class HttpBatchClient {
    constructor(endpoint, options = {}) {
        this.queue = [];
        this.options = {
            batchSizeLimit: options.batchSizeLimit ?? defaultHttpBatchClientOptions.batchSizeLimit,
            dispatchInterval: options.dispatchInterval ?? defaultHttpBatchClientOptions.dispatchInterval,
        };
        if (typeof endpoint === "string") {
            // accept host.name:port and assume http protocol
            this.url = (0, rpcclient_1.hasProtocol)(endpoint) ? endpoint : "http://" + endpoint;
        }
        else {
            this.url = endpoint.url;
            this.headers = endpoint.headers;
        }
        this.timer = setInterval(() => this.tick(), options.dispatchInterval);
        this.validate();
    }
    disconnect() {
        this.timer && clearInterval(this.timer);
        this.timer = undefined;
    }
    async execute(request) {
        return new Promise((resolve, reject) => {
            this.queue.push({ request, resolve, reject });
            if (this.queue.length >= this.options.batchSizeLimit) {
                // this train is full, let's go
                this.tick();
            }
        });
    }
    validate() {
        if (!this.options.batchSizeLimit ||
            !Number.isSafeInteger(this.options.batchSizeLimit) ||
            this.options.batchSizeLimit < 1) {
            throw new Error("batchSizeLimit must be a safe integer >= 1");
        }
    }
    /**
     * This is called in an interval where promise rejections cannot be handled.
     * So this is not async and HTTP errors need to be handled by the queued promises.
     */
    tick() {
        // Avoid race conditions
        const batch = this.queue.splice(0, this.options.batchSizeLimit);
        if (!batch.length)
            return;
        const requests = batch.map((s) => s.request);
        const requestIds = requests.map((request) => request.id);
        (0, http_1.http)("POST", this.url, this.headers, requests).then((raw) => {
            // Requests with a single entry return as an object
            const arr = Array.isArray(raw) ? raw : [raw];
            arr.forEach((el) => {
                const req = batch.find((s) => s.request.id === el.id);
                if (!req)
                    return;
                const { reject, resolve } = req;
                const response = (0, json_rpc_1.parseJsonRpcResponse)(el);
                if ((0, json_rpc_1.isJsonRpcErrorResponse)(response)) {
                    reject(new Error(JSON.stringify(response.error)));
                }
                else {
                    resolve(response);
                }
            });
        }, (error) => {
            for (const requestId of requestIds) {
                const req = batch.find((s) => s.request.id === requestId);
                if (!req)
                    return;
                req.reject(error);
            }
        });
    }
}
exports.HttpBatchClient = HttpBatchClient;
//# sourceMappingURL=httpbatchclient.js.map

/***/ }),

/***/ 54403:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.HttpClient = void 0;
const json_rpc_1 = __webpack_require__(59606);
const http_1 = __webpack_require__(94662);
const rpcclient_1 = __webpack_require__(50040);
class HttpClient {
    constructor(endpoint) {
        if (typeof endpoint === "string") {
            // accept host.name:port and assume http protocol
            this.url = (0, rpcclient_1.hasProtocol)(endpoint) ? endpoint : "http://" + endpoint;
        }
        else {
            this.url = endpoint.url;
            this.headers = endpoint.headers;
        }
    }
    disconnect() {
        // nothing to be done
    }
    async execute(request) {
        const response = (0, json_rpc_1.parseJsonRpcResponse)(await (0, http_1.http)("POST", this.url, this.headers, request));
        if ((0, json_rpc_1.isJsonRpcErrorResponse)(response)) {
            throw new Error(JSON.stringify(response.error));
        }
        return response;
    }
}
exports.HttpClient = HttpClient;
//# sourceMappingURL=httpclient.js.map

/***/ }),

/***/ 82492:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

// This folder contains Tendermint-specific RPC clients
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.WebsocketClient = exports.instanceOfRpcStreamingClient = exports.HttpClient = exports.HttpBatchClient = void 0;
var httpbatchclient_1 = __webpack_require__(97275);
Object.defineProperty(exports, "HttpBatchClient", ({ enumerable: true, get: function () { return httpbatchclient_1.HttpBatchClient; } }));
var httpclient_1 = __webpack_require__(54403);
Object.defineProperty(exports, "HttpClient", ({ enumerable: true, get: function () { return httpclient_1.HttpClient; } }));
var rpcclient_1 = __webpack_require__(50040);
Object.defineProperty(exports, "instanceOfRpcStreamingClient", ({ enumerable: true, get: function () { return rpcclient_1.instanceOfRpcStreamingClient; } }));
var websocketclient_1 = __webpack_require__(5397);
Object.defineProperty(exports, "WebsocketClient", ({ enumerable: true, get: function () { return websocketclient_1.WebsocketClient; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 50040:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.hasProtocol = exports.instanceOfRpcStreamingClient = void 0;
function instanceOfRpcStreamingClient(client) {
    return typeof client.listen === "function";
}
exports.instanceOfRpcStreamingClient = instanceOfRpcStreamingClient;
// Helpers for all RPC clients
function hasProtocol(url) {
    return url.search("://") !== -1;
}
exports.hasProtocol = hasProtocol;
//# sourceMappingURL=rpcclient.js.map

/***/ }),

/***/ 5397:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.WebsocketClient = void 0;
const json_rpc_1 = __webpack_require__(59606);
const socket_1 = __webpack_require__(1568);
const stream_1 = __webpack_require__(2464);
const xstream_1 = __webpack_require__(43813);
const rpcclient_1 = __webpack_require__(50040);
function defaultErrorHandler(error) {
    throw error;
}
function toJsonRpcResponse(message) {
    // this should never happen, but I want an alert if it does
    if (message.type !== "message") {
        throw new Error(`Unexcepted message type on websocket: ${message.type}`);
    }
    const jsonRpcEvent = (0, json_rpc_1.parseJsonRpcResponse)(JSON.parse(message.data));
    return jsonRpcEvent;
}
class RpcEventProducer {
    constructor(request, socket) {
        this.running = false;
        this.subscriptions = [];
        this.request = request;
        this.socket = socket;
    }
    /**
     * Implementation of Producer.start
     */
    start(listener) {
        if (this.running) {
            throw Error("Already started. Please stop first before restarting.");
        }
        this.running = true;
        this.connectToClient(listener);
        this.socket.queueRequest(JSON.stringify(this.request));
    }
    /**
     * Implementation of Producer.stop
     *
     * Called by the stream when the stream's last listener stopped listening
     * or when the producer completed.
     */
    stop() {
        this.running = false;
        // Tell the server we are done in order to save resources. We cannot wait for the result.
        // This may fail when socket connection is not open, thus ignore errors in queueRequest
        const endRequest = { ...this.request, method: "unsubscribe" };
        try {
            this.socket.queueRequest(JSON.stringify(endRequest));
        }
        catch (error) {
            if (error instanceof Error && error.message.match(/socket has disconnected/i)) {
                // ignore
            }
            else {
                throw error;
            }
        }
    }
    connectToClient(listener) {
        const responseStream = this.socket.events.map(toJsonRpcResponse);
        // this should unsubscribe itself, so doesn't need to be removed explicitly
        const idSubscription = responseStream
            .filter((response) => response.id === this.request.id)
            .subscribe({
            next: (response) => {
                if ((0, json_rpc_1.isJsonRpcErrorResponse)(response)) {
                    this.closeSubscriptions();
                    listener.error(JSON.stringify(response.error));
                }
                idSubscription.unsubscribe();
            },
        });
        // this will fire on a response (success or error)
        // Tendermint adds an "#event" suffix for events that follow a previous subscription
        // https://github.com/tendermint/tendermint/blob/v0.23.0/rpc/core/events.go#L107
        const idEventSubscription = responseStream
            .filter((response) => response.id === this.request.id)
            .subscribe({
            next: (response) => {
                if ((0, json_rpc_1.isJsonRpcErrorResponse)(response)) {
                    this.closeSubscriptions();
                    listener.error(JSON.stringify(response.error));
                }
                else {
                    listener.next(response.result);
                }
            },
        });
        // this will fire in case the websocket disconnects cleanly
        const nonResponseSubscription = responseStream.subscribe({
            error: (error) => {
                this.closeSubscriptions();
                listener.error(error);
            },
            complete: () => {
                this.closeSubscriptions();
                listener.complete();
            },
        });
        this.subscriptions.push(idSubscription, idEventSubscription, nonResponseSubscription);
    }
    closeSubscriptions() {
        for (const subscription of this.subscriptions) {
            subscription.unsubscribe();
        }
        // clear unused subscriptions
        this.subscriptions = [];
    }
}
class WebsocketClient {
    constructor(baseUrl, onError = defaultErrorHandler) {
        // Lazily create streams and use the same stream when listening to the same query twice.
        //
        // Creating streams is cheap since producer is not started as long as nobody listens to events. Thus this
        // map is never cleared and there is no need to do so. But unsubscribe all the subscriptions!
        this.subscriptionStreams = new Map();
        // accept host.name:port and assume ws protocol
        // make sure we don't end up with ...//websocket
        const path = baseUrl.endsWith("/") ? "websocket" : "/websocket";
        const cleanBaseUrl = (0, rpcclient_1.hasProtocol)(baseUrl) ? baseUrl : "ws://" + baseUrl;
        this.url = cleanBaseUrl + path;
        this.socket = new socket_1.ReconnectingSocket(this.url);
        const errorSubscription = this.socket.events.subscribe({
            error: (error) => {
                onError(error);
                errorSubscription.unsubscribe();
            },
        });
        this.jsonRpcResponseStream = this.socket.events.map(toJsonRpcResponse);
        this.socket.connect();
    }
    async execute(request) {
        const pendingResponse = this.responseForRequestId(request.id);
        this.socket.queueRequest(JSON.stringify(request));
        const response = await pendingResponse;
        if ((0, json_rpc_1.isJsonRpcErrorResponse)(response)) {
            throw new Error(JSON.stringify(response.error));
        }
        return response;
    }
    listen(request) {
        if (request.method !== "subscribe") {
            throw new Error(`Request method must be "subscribe" to start event listening`);
        }
        const query = request.params.query;
        if (typeof query !== "string") {
            throw new Error("request.params.query must be a string");
        }
        if (!this.subscriptionStreams.has(query)) {
            const producer = new RpcEventProducer(request, this.socket);
            const stream = xstream_1.Stream.create(producer);
            this.subscriptionStreams.set(query, stream);
        }
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return this.subscriptionStreams.get(query).filter((response) => response.query !== undefined);
    }
    /**
     * Resolves as soon as websocket is connected. execute() queues requests automatically,
     * so this should be required for testing purposes only.
     */
    async connected() {
        await this.socket.connectionStatus.waitFor(socket_1.ConnectionStatus.Connected);
    }
    disconnect() {
        this.socket.disconnect();
    }
    async responseForRequestId(id) {
        return (0, stream_1.firstEvent)(this.jsonRpcResponseStream.filter((r) => r.id === id));
    }
}
exports.WebsocketClient = WebsocketClient;
//# sourceMappingURL=websocketclient.js.map

/***/ }),

/***/ 38314:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.adaptor34 = void 0;
const hasher_1 = __webpack_require__(68490);
const requests_1 = __webpack_require__(36882);
const responses_1 = __webpack_require__(60003);
exports.adaptor34 = {
    params: requests_1.Params,
    responses: responses_1.Responses,
    hashTx: hasher_1.hashTx,
    hashBlock: hasher_1.hashBlock,
};
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 36882:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Params = void 0;
/* eslint-disable @typescript-eslint/naming-convention */
const encoding_1 = __webpack_require__(87061);
const inthelpers_1 = __webpack_require__(47450);
const jsonrpc_1 = __webpack_require__(57657);
const encodings_1 = __webpack_require__(87826);
const requests = __importStar(__webpack_require__(66118));
function encodeHeightParam(param) {
    return {
        height: (0, encodings_1.may)(inthelpers_1.smallIntToApi, param.height),
    };
}
function encodeBlockchainRequestParams(param) {
    return {
        minHeight: (0, encodings_1.may)(inthelpers_1.smallIntToApi, param.minHeight),
        maxHeight: (0, encodings_1.may)(inthelpers_1.smallIntToApi, param.maxHeight),
    };
}
function encodeBlockSearchParams(params) {
    return {
        query: params.query,
        page: (0, encodings_1.may)(inthelpers_1.smallIntToApi, params.page),
        per_page: (0, encodings_1.may)(inthelpers_1.smallIntToApi, params.per_page),
        order_by: params.order_by,
    };
}
function encodeAbciQueryParams(params) {
    return {
        path: (0, encodings_1.assertNotEmpty)(params.path),
        data: (0, encoding_1.toHex)(params.data),
        height: (0, encodings_1.may)(inthelpers_1.smallIntToApi, params.height),
        prove: params.prove,
    };
}
function encodeBroadcastTxParams(params) {
    return {
        tx: (0, encoding_1.toBase64)((0, encodings_1.assertNotEmpty)(params.tx)),
    };
}
function encodeTxParams(params) {
    return {
        hash: (0, encoding_1.toBase64)((0, encodings_1.assertNotEmpty)(params.hash)),
        prove: params.prove,
    };
}
function encodeTxSearchParams(params) {
    return {
        query: params.query,
        prove: params.prove,
        page: (0, encodings_1.may)(inthelpers_1.smallIntToApi, params.page),
        per_page: (0, encodings_1.may)(inthelpers_1.smallIntToApi, params.per_page),
        order_by: params.order_by,
    };
}
function encodeValidatorsParams(params) {
    return {
        height: (0, encodings_1.may)(inthelpers_1.smallIntToApi, params.height),
        page: (0, encodings_1.may)(inthelpers_1.smallIntToApi, params.page),
        per_page: (0, encodings_1.may)(inthelpers_1.smallIntToApi, params.per_page),
    };
}
class Params {
    static encodeAbciInfo(req) {
        return (0, jsonrpc_1.createJsonRpcRequest)(req.method);
    }
    static encodeAbciQuery(req) {
        return (0, jsonrpc_1.createJsonRpcRequest)(req.method, encodeAbciQueryParams(req.params));
    }
    static encodeBlock(req) {
        return (0, jsonrpc_1.createJsonRpcRequest)(req.method, encodeHeightParam(req.params));
    }
    static encodeBlockchain(req) {
        return (0, jsonrpc_1.createJsonRpcRequest)(req.method, encodeBlockchainRequestParams(req.params));
    }
    static encodeBlockResults(req) {
        return (0, jsonrpc_1.createJsonRpcRequest)(req.method, encodeHeightParam(req.params));
    }
    static encodeBlockSearch(req) {
        return (0, jsonrpc_1.createJsonRpcRequest)(req.method, encodeBlockSearchParams(req.params));
    }
    static encodeBroadcastTx(req) {
        return (0, jsonrpc_1.createJsonRpcRequest)(req.method, encodeBroadcastTxParams(req.params));
    }
    static encodeCommit(req) {
        return (0, jsonrpc_1.createJsonRpcRequest)(req.method, encodeHeightParam(req.params));
    }
    static encodeGenesis(req) {
        return (0, jsonrpc_1.createJsonRpcRequest)(req.method);
    }
    static encodeHealth(req) {
        return (0, jsonrpc_1.createJsonRpcRequest)(req.method);
    }
    static encodeNumUnconfirmedTxs(req) {
        return (0, jsonrpc_1.createJsonRpcRequest)(req.method);
    }
    static encodeStatus(req) {
        return (0, jsonrpc_1.createJsonRpcRequest)(req.method);
    }
    static encodeSubscribe(req) {
        const eventTag = { key: "tm.event", value: req.query.type };
        const query = requests.buildQuery({ tags: [eventTag], raw: req.query.raw });
        return (0, jsonrpc_1.createJsonRpcRequest)("subscribe", { query: query });
    }
    static encodeTx(req) {
        return (0, jsonrpc_1.createJsonRpcRequest)(req.method, encodeTxParams(req.params));
    }
    // TODO: encode params for query string???
    static encodeTxSearch(req) {
        return (0, jsonrpc_1.createJsonRpcRequest)(req.method, encodeTxSearchParams(req.params));
    }
    static encodeValidators(req) {
        return (0, jsonrpc_1.createJsonRpcRequest)(req.method, encodeValidatorsParams(req.params));
    }
}
exports.Params = Params;
//# sourceMappingURL=requests.js.map

/***/ }),

/***/ 60003:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Responses = exports.decodeValidatorInfo = exports.decodeValidatorGenesis = exports.decodeValidatorUpdate = exports.decodeEvent = void 0;
/* eslint-disable @typescript-eslint/naming-convention */
const encoding_1 = __webpack_require__(87061);
const utils_1 = __webpack_require__(62584);
const dates_1 = __webpack_require__(11756);
const inthelpers_1 = __webpack_require__(47450);
const types_1 = __webpack_require__(26823);
const encodings_1 = __webpack_require__(87826);
const hasher_1 = __webpack_require__(68490);
function decodeAbciInfo(data) {
    return {
        data: data.data,
        lastBlockHeight: (0, encodings_1.may)(inthelpers_1.apiToSmallInt, data.last_block_height),
        lastBlockAppHash: (0, encodings_1.may)(encoding_1.fromBase64, data.last_block_app_hash),
    };
}
function decodeQueryProof(data) {
    return {
        ops: data.ops.map((op) => ({
            type: op.type,
            key: (0, encoding_1.fromBase64)(op.key),
            data: (0, encoding_1.fromBase64)(op.data),
        })),
    };
}
function decodeAbciQuery(data) {
    return {
        key: (0, encoding_1.fromBase64)((0, encodings_1.assertString)(data.key ?? "")),
        value: (0, encoding_1.fromBase64)((0, encodings_1.assertString)(data.value ?? "")),
        proof: (0, encodings_1.may)(decodeQueryProof, data.proofOps),
        height: (0, encodings_1.may)(inthelpers_1.apiToSmallInt, data.height),
        code: (0, encodings_1.may)(inthelpers_1.apiToSmallInt, data.code),
        codespace: (0, encodings_1.assertString)(data.codespace ?? ""),
        index: (0, encodings_1.may)(inthelpers_1.apiToSmallInt, data.index),
        log: data.log,
        info: (0, encodings_1.assertString)(data.info ?? ""),
    };
}
function decodeAttribute(attribute) {
    return {
        key: (0, encoding_1.fromBase64)((0, encodings_1.assertNotEmpty)(attribute.key)),
        value: (0, encoding_1.fromBase64)((0, encodings_1.assertString)(attribute.value ?? "")),
    };
}
function decodeAttributes(attributes) {
    return (0, encodings_1.assertArray)(attributes).map(decodeAttribute);
}
function decodeEvent(event) {
    return {
        type: event.type,
        attributes: event.attributes ? decodeAttributes(event.attributes) : [],
    };
}
exports.decodeEvent = decodeEvent;
function decodeEvents(events) {
    return (0, encodings_1.assertArray)(events).map(decodeEvent);
}
function decodeTxData(data) {
    return {
        code: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNumber)(data.code ?? 0)),
        codespace: data.codespace,
        log: data.log,
        data: (0, encodings_1.may)(encoding_1.fromBase64, data.data),
        events: data.events ? decodeEvents(data.events) : [],
        gasWanted: (0, inthelpers_1.apiToSmallInt)(data.gas_wanted ?? "0"),
        gasUsed: (0, inthelpers_1.apiToSmallInt)(data.gas_used ?? "0"),
    };
}
function decodePubkey(data) {
    if ("Sum" in data) {
        // we don't need to check type because we're checking algorithm
        const [[algorithm, value]] = Object.entries(data.Sum.value);
        (0, utils_1.assert)(algorithm === "ed25519" || algorithm === "secp256k1", `unknown pubkey type: ${algorithm}`);
        return {
            algorithm,
            data: (0, encoding_1.fromBase64)((0, encodings_1.assertNotEmpty)(value)),
        };
    }
    else {
        switch (data.type) {
            // go-amino special code
            case "tendermint/PubKeyEd25519":
                return {
                    algorithm: "ed25519",
                    data: (0, encoding_1.fromBase64)((0, encodings_1.assertNotEmpty)(data.value)),
                };
            case "tendermint/PubKeySecp256k1":
                return {
                    algorithm: "secp256k1",
                    data: (0, encoding_1.fromBase64)((0, encodings_1.assertNotEmpty)(data.value)),
                };
            default:
                throw new Error(`unknown pubkey type: ${data.type}`);
        }
    }
}
/**
 * Note: we do not parse block.time_iota_ms for now because of this CHANGELOG entry
 *
 * > Add time_iota_ms to block's consensus parameters (not exposed to the application)
 * https://github.com/tendermint/tendermint/blob/master/CHANGELOG.md#v0310
 */
function decodeBlockParams(data) {
    return {
        maxBytes: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(data.max_bytes)),
        maxGas: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(data.max_gas)),
    };
}
function decodeEvidenceParams(data) {
    return {
        maxAgeNumBlocks: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(data.max_age_num_blocks)),
        maxAgeDuration: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(data.max_age_duration)),
    };
}
function decodeConsensusParams(data) {
    return {
        block: decodeBlockParams((0, encodings_1.assertObject)(data.block)),
        evidence: decodeEvidenceParams((0, encodings_1.assertObject)(data.evidence)),
    };
}
function decodeValidatorUpdate(data) {
    return {
        pubkey: decodePubkey((0, encodings_1.assertObject)(data.pub_key)),
        votingPower: (0, inthelpers_1.apiToBigInt)(data.power ?? "0"),
    };
}
exports.decodeValidatorUpdate = decodeValidatorUpdate;
function decodeBlockResults(data) {
    return {
        height: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(data.height)),
        results: (data.txs_results || []).map(decodeTxData),
        validatorUpdates: (data.validator_updates || []).map(decodeValidatorUpdate),
        consensusUpdates: (0, encodings_1.may)(decodeConsensusParams, data.consensus_param_updates),
        beginBlockEvents: decodeEvents(data.begin_block_events || []),
        endBlockEvents: decodeEvents(data.end_block_events || []),
    };
}
function decodeBlockId(data) {
    return {
        hash: (0, encoding_1.fromHex)((0, encodings_1.assertNotEmpty)(data.hash)),
        parts: {
            total: (0, encodings_1.assertNotEmpty)(data.parts.total),
            hash: (0, encoding_1.fromHex)((0, encodings_1.assertNotEmpty)(data.parts.hash)),
        },
    };
}
function decodeBlockVersion(data) {
    return {
        block: (0, inthelpers_1.apiToSmallInt)(data.block),
        app: (0, inthelpers_1.apiToSmallInt)(data.app ?? 0),
    };
}
function decodeHeader(data) {
    return {
        version: decodeBlockVersion(data.version),
        chainId: (0, encodings_1.assertNotEmpty)(data.chain_id),
        height: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(data.height)),
        time: (0, dates_1.fromRfc3339WithNanoseconds)((0, encodings_1.assertNotEmpty)(data.time)),
        // When there is no last block ID (i.e. this block's height is 1), we get an empty structure like this:
        // { hash: '', parts: { total: 0, hash: '' } }
        lastBlockId: data.last_block_id.hash ? decodeBlockId(data.last_block_id) : null,
        lastCommitHash: (0, encoding_1.fromHex)((0, encodings_1.assertSet)(data.last_commit_hash)),
        dataHash: (0, encoding_1.fromHex)((0, encodings_1.assertSet)(data.data_hash)),
        validatorsHash: (0, encoding_1.fromHex)((0, encodings_1.assertSet)(data.validators_hash)),
        nextValidatorsHash: (0, encoding_1.fromHex)((0, encodings_1.assertSet)(data.next_validators_hash)),
        consensusHash: (0, encoding_1.fromHex)((0, encodings_1.assertSet)(data.consensus_hash)),
        appHash: (0, encoding_1.fromHex)((0, encodings_1.assertSet)(data.app_hash)),
        lastResultsHash: (0, encoding_1.fromHex)((0, encodings_1.assertSet)(data.last_results_hash)),
        evidenceHash: (0, encoding_1.fromHex)((0, encodings_1.assertSet)(data.evidence_hash)),
        proposerAddress: (0, encoding_1.fromHex)((0, encodings_1.assertNotEmpty)(data.proposer_address)),
    };
}
function decodeBlockMeta(data) {
    return {
        blockId: decodeBlockId(data.block_id),
        blockSize: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(data.block_size)),
        header: decodeHeader(data.header),
        numTxs: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(data.num_txs)),
    };
}
function decodeBlockchain(data) {
    return {
        lastHeight: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(data.last_height)),
        blockMetas: (0, encodings_1.assertArray)(data.block_metas).map(decodeBlockMeta),
    };
}
function decodeBroadcastTxSync(data) {
    return {
        ...decodeTxData(data),
        hash: (0, encoding_1.fromHex)((0, encodings_1.assertNotEmpty)(data.hash)),
    };
}
function decodeBroadcastTxCommit(data) {
    return {
        height: (0, inthelpers_1.apiToSmallInt)(data.height),
        hash: (0, encoding_1.fromHex)((0, encodings_1.assertNotEmpty)(data.hash)),
        checkTx: decodeTxData((0, encodings_1.assertObject)(data.check_tx)),
        deliverTx: (0, encodings_1.may)(decodeTxData, data.deliver_tx),
    };
}
function decodeBlockIdFlag(blockIdFlag) {
    (0, utils_1.assert)(blockIdFlag in types_1.BlockIdFlag);
    return blockIdFlag;
}
/**
 * In some cases a timestamp is optional and set to the value 0 in Go.
 * This can lead to strings like "0001-01-01T00:00:00Z" (see https://github.com/cosmos/cosmjs/issues/704#issuecomment-797122415).
 * This decoder tries to clean up such encoding from the API and turn them
 * into undefined values.
 */
function decodeOptionalTime(timestamp) {
    const nonZeroTime = timestamp && !timestamp.startsWith("0001-01-01");
    return nonZeroTime ? (0, dates_1.fromRfc3339WithNanoseconds)(timestamp) : undefined;
}
function decodeCommitSignature(data) {
    return {
        blockIdFlag: decodeBlockIdFlag(data.block_id_flag),
        validatorAddress: data.validator_address ? (0, encoding_1.fromHex)(data.validator_address) : undefined,
        timestamp: decodeOptionalTime(data.timestamp),
        signature: data.signature ? (0, encoding_1.fromBase64)(data.signature) : undefined,
    };
}
function decodeCommit(data) {
    return {
        blockId: decodeBlockId((0, encodings_1.assertObject)(data.block_id)),
        height: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(data.height)),
        round: (0, inthelpers_1.apiToSmallInt)(data.round),
        signatures: (0, encodings_1.assertArray)(data.signatures).map(decodeCommitSignature),
    };
}
function decodeCommitResponse(data) {
    return {
        canonical: (0, encodings_1.assertBoolean)(data.canonical),
        header: decodeHeader(data.signed_header.header),
        commit: decodeCommit(data.signed_header.commit),
    };
}
function decodeValidatorGenesis(data) {
    return {
        address: (0, encoding_1.fromHex)((0, encodings_1.assertNotEmpty)(data.address)),
        pubkey: decodePubkey((0, encodings_1.assertObject)(data.pub_key)),
        votingPower: (0, inthelpers_1.apiToBigInt)((0, encodings_1.assertNotEmpty)(data.power)),
    };
}
exports.decodeValidatorGenesis = decodeValidatorGenesis;
function decodeGenesis(data) {
    return {
        genesisTime: (0, dates_1.fromRfc3339WithNanoseconds)((0, encodings_1.assertNotEmpty)(data.genesis_time)),
        chainId: (0, encodings_1.assertNotEmpty)(data.chain_id),
        consensusParams: decodeConsensusParams(data.consensus_params),
        validators: data.validators ? (0, encodings_1.assertArray)(data.validators).map(decodeValidatorGenesis) : [],
        appHash: (0, encoding_1.fromHex)((0, encodings_1.assertSet)(data.app_hash)),
        appState: data.app_state,
    };
}
function decodeValidatorInfo(data) {
    return {
        pubkey: decodePubkey((0, encodings_1.assertObject)(data.pub_key)),
        votingPower: (0, inthelpers_1.apiToBigInt)((0, encodings_1.assertNotEmpty)(data.voting_power)),
        address: (0, encoding_1.fromHex)((0, encodings_1.assertNotEmpty)(data.address)),
        proposerPriority: data.proposer_priority ? (0, inthelpers_1.apiToSmallInt)(data.proposer_priority) : undefined,
    };
}
exports.decodeValidatorInfo = decodeValidatorInfo;
function decodeNodeInfo(data) {
    return {
        id: (0, encoding_1.fromHex)((0, encodings_1.assertNotEmpty)(data.id)),
        listenAddr: (0, encodings_1.assertNotEmpty)(data.listen_addr),
        network: (0, encodings_1.assertNotEmpty)(data.network),
        version: (0, encodings_1.assertString)(data.version),
        channels: (0, encodings_1.assertNotEmpty)(data.channels),
        moniker: (0, encodings_1.assertNotEmpty)(data.moniker),
        other: (0, encodings_1.dictionaryToStringMap)(data.other),
        protocolVersion: {
            app: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(data.protocol_version.app)),
            block: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(data.protocol_version.block)),
            p2p: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(data.protocol_version.p2p)),
        },
    };
}
function decodeSyncInfo(data) {
    const earliestBlockHeight = data.earliest_block_height
        ? (0, inthelpers_1.apiToSmallInt)(data.earliest_block_height)
        : undefined;
    const earliestBlockTime = data.earliest_block_time
        ? (0, dates_1.fromRfc3339WithNanoseconds)(data.earliest_block_time)
        : undefined;
    return {
        earliestAppHash: data.earliest_app_hash ? (0, encoding_1.fromHex)(data.earliest_app_hash) : undefined,
        earliestBlockHash: data.earliest_block_hash ? (0, encoding_1.fromHex)(data.earliest_block_hash) : undefined,
        earliestBlockHeight: earliestBlockHeight || undefined,
        earliestBlockTime: earliestBlockTime?.getTime() ? earliestBlockTime : undefined,
        latestBlockHash: (0, encoding_1.fromHex)((0, encodings_1.assertNotEmpty)(data.latest_block_hash)),
        latestAppHash: (0, encoding_1.fromHex)((0, encodings_1.assertNotEmpty)(data.latest_app_hash)),
        latestBlockTime: (0, dates_1.fromRfc3339WithNanoseconds)((0, encodings_1.assertNotEmpty)(data.latest_block_time)),
        latestBlockHeight: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(data.latest_block_height)),
        catchingUp: (0, encodings_1.assertBoolean)(data.catching_up),
    };
}
function decodeStatus(data) {
    return {
        nodeInfo: decodeNodeInfo(data.node_info),
        syncInfo: decodeSyncInfo(data.sync_info),
        validatorInfo: decodeValidatorInfo(data.validator_info),
    };
}
function decodeTxProof(data) {
    return {
        data: (0, encoding_1.fromBase64)((0, encodings_1.assertNotEmpty)(data.data)),
        rootHash: (0, encoding_1.fromHex)((0, encodings_1.assertNotEmpty)(data.root_hash)),
        proof: {
            total: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(data.proof.total)),
            index: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(data.proof.index)),
            leafHash: (0, encoding_1.fromBase64)((0, encodings_1.assertNotEmpty)(data.proof.leaf_hash)),
            aunts: (0, encodings_1.assertArray)(data.proof.aunts).map(encoding_1.fromBase64),
        },
    };
}
function decodeTxResponse(data) {
    return {
        tx: (0, encoding_1.fromBase64)((0, encodings_1.assertNotEmpty)(data.tx)),
        result: decodeTxData((0, encodings_1.assertObject)(data.tx_result)),
        height: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(data.height)),
        index: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNumber)(data.index)),
        hash: (0, encoding_1.fromHex)((0, encodings_1.assertNotEmpty)(data.hash)),
        proof: (0, encodings_1.may)(decodeTxProof, data.proof),
    };
}
function decodeTxSearch(data) {
    return {
        totalCount: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(data.total_count)),
        txs: (0, encodings_1.assertArray)(data.txs).map(decodeTxResponse),
    };
}
function decodeTxEvent(data) {
    const tx = (0, encoding_1.fromBase64)((0, encodings_1.assertNotEmpty)(data.tx));
    return {
        tx: tx,
        hash: (0, hasher_1.hashTx)(tx),
        result: decodeTxData(data.result),
        height: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(data.height)),
    };
}
function decodeValidators(data) {
    return {
        blockHeight: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(data.block_height)),
        validators: (0, encodings_1.assertArray)(data.validators).map(decodeValidatorInfo),
        count: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(data.count)),
        total: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(data.total)),
    };
}
function decodeBlock(data) {
    return {
        header: decodeHeader((0, encodings_1.assertObject)(data.header)),
        // For the block at height 1, last commit is not set. This is represented in an empty object like this:
        // { height: '0', round: 0, block_id: { hash: '', parts: [Object] }, signatures: [] }
        lastCommit: data.last_commit.block_id.hash ? decodeCommit((0, encodings_1.assertObject)(data.last_commit)) : null,
        txs: data.data.txs ? (0, encodings_1.assertArray)(data.data.txs).map(encoding_1.fromBase64) : [],
        // Lift up .evidence.evidence to just .evidence
        // See https://github.com/tendermint/tendermint/issues/7697
        evidence: data.evidence?.evidence ?? [],
    };
}
function decodeBlockResponse(data) {
    return {
        blockId: decodeBlockId(data.block_id),
        block: decodeBlock(data.block),
    };
}
function decodeBlockSearch(data) {
    return {
        totalCount: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(data.total_count)),
        blocks: (0, encodings_1.assertArray)(data.blocks).map(decodeBlockResponse),
    };
}
function decodeNumUnconfirmedTxs(data) {
    return {
        total: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(data.total)),
        totalBytes: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(data.total_bytes)),
    };
}
class Responses {
    static decodeAbciInfo(response) {
        return decodeAbciInfo((0, encodings_1.assertObject)(response.result.response));
    }
    static decodeAbciQuery(response) {
        return decodeAbciQuery((0, encodings_1.assertObject)(response.result.response));
    }
    static decodeBlock(response) {
        return decodeBlockResponse(response.result);
    }
    static decodeBlockResults(response) {
        return decodeBlockResults(response.result);
    }
    static decodeBlockSearch(response) {
        return decodeBlockSearch(response.result);
    }
    static decodeBlockchain(response) {
        return decodeBlockchain(response.result);
    }
    static decodeBroadcastTxSync(response) {
        return decodeBroadcastTxSync(response.result);
    }
    static decodeBroadcastTxAsync(response) {
        return Responses.decodeBroadcastTxSync(response);
    }
    static decodeBroadcastTxCommit(response) {
        return decodeBroadcastTxCommit(response.result);
    }
    static decodeCommit(response) {
        return decodeCommitResponse(response.result);
    }
    static decodeGenesis(response) {
        return decodeGenesis((0, encodings_1.assertObject)(response.result.genesis));
    }
    static decodeHealth() {
        return null;
    }
    static decodeNumUnconfirmedTxs(response) {
        return decodeNumUnconfirmedTxs(response.result);
    }
    static decodeStatus(response) {
        return decodeStatus(response.result);
    }
    static decodeNewBlockEvent(event) {
        return decodeBlock(event.data.value.block);
    }
    static decodeNewBlockHeaderEvent(event) {
        return decodeHeader(event.data.value.header);
    }
    static decodeTxEvent(event) {
        return decodeTxEvent(event.data.value.TxResult);
    }
    static decodeTx(response) {
        return decodeTxResponse(response.result);
    }
    static decodeTxSearch(response) {
        return decodeTxSearch(response.result);
    }
    static decodeValidators(response) {
        return decodeValidators(response.result);
    }
}
exports.Responses = Responses;
//# sourceMappingURL=responses.js.map

/***/ }),

/***/ 87826:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.encodeBlockId = exports.encodeVersion = exports.encodeBytes = exports.encodeTime = exports.encodeUvarint = exports.encodeString = exports.dictionaryToStringMap = exports.may = exports.assertNotEmpty = exports.assertObject = exports.assertArray = exports.assertNumber = exports.assertString = exports.assertBoolean = exports.assertSet = void 0;
const encoding_1 = __webpack_require__(87061);
/**
 * A runtime checker that ensures a given value is set (i.e. not undefined or null)
 *
 * This is used when you want to verify that data at runtime matches the expected type.
 */
function assertSet(value) {
    if (value === undefined) {
        throw new Error("Value must not be undefined");
    }
    if (value === null) {
        throw new Error("Value must not be null");
    }
    return value;
}
exports.assertSet = assertSet;
/**
 * A runtime checker that ensures a given value is a boolean
 *
 * This is used when you want to verify that data at runtime matches the expected type.
 * This implies assertSet.
 */
function assertBoolean(value) {
    assertSet(value);
    if (typeof value !== "boolean") {
        throw new Error("Value must be a boolean");
    }
    return value;
}
exports.assertBoolean = assertBoolean;
/**
 * A runtime checker that ensures a given value is a string.
 *
 * This is used when you want to verify that data at runtime matches the expected type.
 * This implies assertSet.
 */
function assertString(value) {
    assertSet(value);
    if (typeof value !== "string") {
        throw new Error("Value must be a string");
    }
    return value;
}
exports.assertString = assertString;
/**
 * A runtime checker that ensures a given value is a number
 *
 * This is used when you want to verify that data at runtime matches the expected type.
 * This implies assertSet.
 */
function assertNumber(value) {
    assertSet(value);
    if (typeof value !== "number") {
        throw new Error("Value must be a number");
    }
    return value;
}
exports.assertNumber = assertNumber;
/**
 * A runtime checker that ensures a given value is an array
 *
 * This is used when you want to verify that data at runtime matches the expected type.
 * This implies assertSet.
 */
function assertArray(value) {
    assertSet(value);
    if (!Array.isArray(value)) {
        throw new Error("Value must be a an array");
    }
    return value;
}
exports.assertArray = assertArray;
/**
 * A runtime checker that ensures a given value is an object in the sense of JSON
 * (an unordered collection of key–value pairs where the keys are strings)
 *
 * This is used when you want to verify that data at runtime matches the expected type.
 * This implies assertSet.
 */
function assertObject(value) {
    assertSet(value);
    if (typeof value !== "object") {
        throw new Error("Value must be an object");
    }
    // Exclude special kind of objects like Array, Date or Uint8Array
    // Object.prototype.toString() returns a specified value:
    // http://www.ecma-international.org/ecma-262/7.0/index.html#sec-object.prototype.tostring
    if (Object.prototype.toString.call(value) !== "[object Object]") {
        throw new Error("Value must be a simple object");
    }
    return value;
}
exports.assertObject = assertObject;
/**
 * Throws an error if value matches the empty value for the
 * given type (array/string of length 0, number of value 0, ...)
 *
 * Otherwise returns the value.
 *
 * This implies assertSet
 */
function assertNotEmpty(value) {
    assertSet(value);
    if (typeof value === "number" && value === 0) {
        throw new Error("must provide a non-zero value");
    }
    else if (value.length === 0) {
        throw new Error("must provide a non-empty value");
    }
    return value;
}
exports.assertNotEmpty = assertNotEmpty;
// may will run the transform if value is defined, otherwise returns undefined
function may(transform, value) {
    return value === undefined || value === null ? undefined : transform(value);
}
exports.may = may;
function dictionaryToStringMap(obj) {
    const out = new Map();
    for (const key of Object.keys(obj)) {
        const value = obj[key];
        if (typeof value !== "string") {
            throw new Error("Found dictionary value of type other than string");
        }
        out.set(key, value);
    }
    return out;
}
exports.dictionaryToStringMap = dictionaryToStringMap;
// Encodings needed for hashing block headers
// Several of these functions are inspired by https://github.com/nomic-io/js-tendermint/blob/tendermint-0.30/src/
// See https://github.com/tendermint/go-amino/blob/v0.15.0/encoder.go#L193-L195
function encodeString(s) {
    const utf8 = (0, encoding_1.toUtf8)(s);
    return Uint8Array.from([utf8.length, ...utf8]);
}
exports.encodeString = encodeString;
// See https://github.com/tendermint/go-amino/blob/v0.15.0/encoder.go#L79-L87
function encodeUvarint(n) {
    return n >= 0x80
        ? // eslint-disable-next-line no-bitwise
            Uint8Array.from([(n & 0xff) | 0x80, ...encodeUvarint(n >> 7)])
        : // eslint-disable-next-line no-bitwise
            Uint8Array.from([n & 0xff]);
}
exports.encodeUvarint = encodeUvarint;
// See https://github.com/tendermint/go-amino/blob/v0.15.0/encoder.go#L134-L178
function encodeTime(time) {
    const milliseconds = time.getTime();
    const seconds = Math.floor(milliseconds / 1000);
    const secondsArray = seconds ? [0x08, ...encodeUvarint(seconds)] : new Uint8Array();
    const nanoseconds = (time.nanoseconds || 0) + (milliseconds % 1000) * 1e6;
    const nanosecondsArray = nanoseconds ? [0x10, ...encodeUvarint(nanoseconds)] : new Uint8Array();
    return Uint8Array.from([...secondsArray, ...nanosecondsArray]);
}
exports.encodeTime = encodeTime;
// See https://github.com/tendermint/go-amino/blob/v0.15.0/encoder.go#L180-L187
function encodeBytes(bytes) {
    // Since we're only dealing with short byte arrays we don't need a full VarBuffer implementation yet
    if (bytes.length >= 0x80)
        throw new Error("Not implemented for byte arrays of length 128 or more");
    return bytes.length ? Uint8Array.from([bytes.length, ...bytes]) : new Uint8Array();
}
exports.encodeBytes = encodeBytes;
function encodeVersion(version) {
    const blockArray = version.block
        ? Uint8Array.from([0x08, ...encodeUvarint(version.block)])
        : new Uint8Array();
    const appArray = version.app ? Uint8Array.from([0x10, ...encodeUvarint(version.app)]) : new Uint8Array();
    return Uint8Array.from([...blockArray, ...appArray]);
}
exports.encodeVersion = encodeVersion;
function encodeBlockId(blockId) {
    return Uint8Array.from([
        0x0a,
        blockId.hash.length,
        ...blockId.hash,
        0x12,
        blockId.parts.hash.length + 4,
        0x08,
        blockId.parts.total,
        0x12,
        blockId.parts.hash.length,
        ...blockId.parts.hash,
    ]);
}
exports.encodeBlockId = encodeBlockId;
//# sourceMappingURL=encodings.js.map

/***/ }),

/***/ 68490:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.hashBlock = exports.hashTx = void 0;
const crypto_1 = __webpack_require__(45027);
const encodings_1 = __webpack_require__(87826);
// hash is sha256
// https://github.com/tendermint/tendermint/blob/master/UPGRADING.md#v0260
function hashTx(tx) {
    return (0, crypto_1.sha256)(tx);
}
exports.hashTx = hashTx;
function getSplitPoint(n) {
    if (n < 1)
        throw new Error("Cannot split an empty tree");
    const largestPowerOf2 = 2 ** Math.floor(Math.log2(n));
    return largestPowerOf2 < n ? largestPowerOf2 : largestPowerOf2 / 2;
}
function hashLeaf(leaf) {
    const hash = new crypto_1.Sha256(Uint8Array.from([0]));
    hash.update(leaf);
    return hash.digest();
}
function hashInner(left, right) {
    const hash = new crypto_1.Sha256(Uint8Array.from([1]));
    hash.update(left);
    hash.update(right);
    return hash.digest();
}
// See https://github.com/tendermint/tendermint/blob/v0.31.8/docs/spec/blockchain/encoding.md#merkleroot
// Note: the hashes input may not actually be hashes, especially before a recursive call
function hashTree(hashes) {
    switch (hashes.length) {
        case 0:
            throw new Error("Cannot hash empty tree");
        case 1:
            return hashLeaf(hashes[0]);
        default: {
            const slicePoint = getSplitPoint(hashes.length);
            const left = hashTree(hashes.slice(0, slicePoint));
            const right = hashTree(hashes.slice(slicePoint));
            return hashInner(left, right);
        }
    }
}
function hashBlock(header) {
    if (!header.lastBlockId) {
        throw new Error("Hashing a block header with no last block ID (i.e. header at height 1) is not supported. If you need this, contributions are welcome. Please add documentation and test vectors for this case.");
    }
    const encodedFields = [
        (0, encodings_1.encodeVersion)(header.version),
        (0, encodings_1.encodeString)(header.chainId),
        (0, encodings_1.encodeUvarint)(header.height),
        (0, encodings_1.encodeTime)(header.time),
        (0, encodings_1.encodeBlockId)(header.lastBlockId),
        (0, encodings_1.encodeBytes)(header.lastCommitHash),
        (0, encodings_1.encodeBytes)(header.dataHash),
        (0, encodings_1.encodeBytes)(header.validatorsHash),
        (0, encodings_1.encodeBytes)(header.nextValidatorsHash),
        (0, encodings_1.encodeBytes)(header.consensusHash),
        (0, encodings_1.encodeBytes)(header.appHash),
        (0, encodings_1.encodeBytes)(header.lastResultsHash),
        (0, encodings_1.encodeBytes)(header.evidenceHash),
        (0, encodings_1.encodeBytes)(header.proposerAddress),
    ];
    return hashTree(encodedFields);
}
exports.hashBlock = hashBlock;
//# sourceMappingURL=hasher.js.map

/***/ }),

/***/ 2621:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

// Note: all exports in this module are publicly available via
// `import { tendermint34 } from "@cosmjs/tendermint-rpc"`
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Tendermint34Client = exports.VoteType = exports.broadcastTxSyncSuccess = exports.broadcastTxCommitSuccess = exports.SubscriptionEventType = exports.Method = void 0;
var requests_1 = __webpack_require__(66118);
Object.defineProperty(exports, "Method", ({ enumerable: true, get: function () { return requests_1.Method; } }));
Object.defineProperty(exports, "SubscriptionEventType", ({ enumerable: true, get: function () { return requests_1.SubscriptionEventType; } }));
var responses_1 = __webpack_require__(26881);
Object.defineProperty(exports, "broadcastTxCommitSuccess", ({ enumerable: true, get: function () { return responses_1.broadcastTxCommitSuccess; } }));
Object.defineProperty(exports, "broadcastTxSyncSuccess", ({ enumerable: true, get: function () { return responses_1.broadcastTxSyncSuccess; } }));
Object.defineProperty(exports, "VoteType", ({ enumerable: true, get: function () { return responses_1.VoteType; } }));
var tendermint34client_1 = __webpack_require__(41929);
Object.defineProperty(exports, "Tendermint34Client", ({ enumerable: true, get: function () { return tendermint34client_1.Tendermint34Client; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 66118:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

/* eslint-disable @typescript-eslint/naming-convention */
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.buildQuery = exports.SubscriptionEventType = exports.Method = void 0;
/**
 * RPC methods as documented in https://docs.tendermint.com/master/rpc/
 *
 * Enum raw value must match the spelling in the "shell" example call (snake_case)
 */
var Method;
(function (Method) {
    Method["AbciInfo"] = "abci_info";
    Method["AbciQuery"] = "abci_query";
    Method["Block"] = "block";
    /** Get block headers for minHeight <= height <= maxHeight. */
    Method["Blockchain"] = "blockchain";
    Method["BlockResults"] = "block_results";
    Method["BlockSearch"] = "block_search";
    Method["BroadcastTxAsync"] = "broadcast_tx_async";
    Method["BroadcastTxSync"] = "broadcast_tx_sync";
    Method["BroadcastTxCommit"] = "broadcast_tx_commit";
    Method["Commit"] = "commit";
    Method["Genesis"] = "genesis";
    Method["Health"] = "health";
    Method["NumUnconfirmedTxs"] = "num_unconfirmed_txs";
    Method["Status"] = "status";
    Method["Subscribe"] = "subscribe";
    Method["Tx"] = "tx";
    Method["TxSearch"] = "tx_search";
    Method["Validators"] = "validators";
    Method["Unsubscribe"] = "unsubscribe";
})(Method = exports.Method || (exports.Method = {}));
/**
 * Raw values must match the tendermint event name
 *
 * @see https://godoc.org/github.com/tendermint/tendermint/types#pkg-constants
 */
var SubscriptionEventType;
(function (SubscriptionEventType) {
    SubscriptionEventType["NewBlock"] = "NewBlock";
    SubscriptionEventType["NewBlockHeader"] = "NewBlockHeader";
    SubscriptionEventType["Tx"] = "Tx";
})(SubscriptionEventType = exports.SubscriptionEventType || (exports.SubscriptionEventType = {}));
function buildQuery(components) {
    const tags = components.tags ? components.tags : [];
    const tagComponents = tags.map((tag) => `${tag.key}='${tag.value}'`);
    const rawComponents = components.raw ? [components.raw] : [];
    return [...tagComponents, ...rawComponents].join(" AND ");
}
exports.buildQuery = buildQuery;
//# sourceMappingURL=requests.js.map

/***/ }),

/***/ 26881:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.VoteType = exports.broadcastTxCommitSuccess = exports.broadcastTxSyncSuccess = void 0;
/**
 * Returns true iff transaction made it successfully into the transaction pool
 */
function broadcastTxSyncSuccess(res) {
    // code must be 0 on success
    return res.code === 0;
}
exports.broadcastTxSyncSuccess = broadcastTxSyncSuccess;
/**
 * Returns true iff transaction made it successfully into a block
 * (i.e. success in `check_tx` and `deliver_tx` field)
 */
function broadcastTxCommitSuccess(response) {
    // code must be 0 on success
    // deliverTx may be present but empty on failure
    return response.checkTx.code === 0 && !!response.deliverTx && response.deliverTx.code === 0;
}
exports.broadcastTxCommitSuccess = broadcastTxCommitSuccess;
/**
 * raw values from https://github.com/tendermint/tendermint/blob/dfa9a9a30a666132425b29454e90a472aa579a48/types/vote.go#L44
 */
var VoteType;
(function (VoteType) {
    VoteType[VoteType["PreVote"] = 1] = "PreVote";
    VoteType[VoteType["PreCommit"] = 2] = "PreCommit";
})(VoteType = exports.VoteType || (exports.VoteType = {}));
//# sourceMappingURL=responses.js.map

/***/ }),

/***/ 41929:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Tendermint34Client = void 0;
const jsonrpc_1 = __webpack_require__(57657);
const rpcclients_1 = __webpack_require__(82492);
const adaptor_1 = __webpack_require__(38314);
const requests = __importStar(__webpack_require__(66118));
class Tendermint34Client {
    /**
     * Creates a new Tendermint client for the given endpoint.
     *
     * Uses HTTP when the URL schema is http or https. Uses WebSockets otherwise.
     */
    static async connect(endpoint) {
        let rpcClient;
        if (typeof endpoint === "object") {
            rpcClient = new rpcclients_1.HttpClient(endpoint);
        }
        else {
            const useHttp = endpoint.startsWith("http://") || endpoint.startsWith("https://");
            rpcClient = useHttp ? new rpcclients_1.HttpClient(endpoint) : new rpcclients_1.WebsocketClient(endpoint);
        }
        // For some very strange reason I don't understand, tests start to fail on some systems
        // (our CI) when skipping the status call before doing other queries. Sleeping a little
        // while did not help. Thus we query the version as a way to say "hi" to the backend,
        // even in cases where we don't use the result.
        const _version = await this.detectVersion(rpcClient);
        return Tendermint34Client.create(rpcClient);
    }
    /**
     * Creates a new Tendermint client given an RPC client.
     */
    static async create(rpcClient) {
        return new Tendermint34Client(rpcClient);
    }
    static async detectVersion(client) {
        const req = (0, jsonrpc_1.createJsonRpcRequest)(requests.Method.Status);
        const response = await client.execute(req);
        const result = response.result;
        if (!result || !result.node_info) {
            throw new Error("Unrecognized format for status response");
        }
        const version = result.node_info.version;
        if (typeof version !== "string") {
            throw new Error("Unrecognized version format: must be string");
        }
        return version;
    }
    /**
     * Use `Tendermint34Client.connect` or `Tendermint34Client.create` to create an instance.
     */
    constructor(client) {
        this.client = client;
        this.p = adaptor_1.adaptor34.params;
        this.r = adaptor_1.adaptor34.responses;
    }
    disconnect() {
        this.client.disconnect();
    }
    async abciInfo() {
        const query = { method: requests.Method.AbciInfo };
        return this.doCall(query, this.p.encodeAbciInfo, this.r.decodeAbciInfo);
    }
    async abciQuery(params) {
        const query = { params: params, method: requests.Method.AbciQuery };
        return this.doCall(query, this.p.encodeAbciQuery, this.r.decodeAbciQuery);
    }
    async block(height) {
        const query = { method: requests.Method.Block, params: { height: height } };
        return this.doCall(query, this.p.encodeBlock, this.r.decodeBlock);
    }
    async blockResults(height) {
        const query = {
            method: requests.Method.BlockResults,
            params: { height: height },
        };
        return this.doCall(query, this.p.encodeBlockResults, this.r.decodeBlockResults);
    }
    /**
     * Search for events that are in a block.
     *
     * NOTE
     * This method will error on any node that is running a Tendermint version lower than 0.34.9.
     *
     * @see https://docs.tendermint.com/master/rpc/#/Info/block_search
     */
    async blockSearch(params) {
        const query = { params: params, method: requests.Method.BlockSearch };
        const resp = await this.doCall(query, this.p.encodeBlockSearch, this.r.decodeBlockSearch);
        return {
            ...resp,
            // make sure we sort by height, as tendermint may be sorting by string value of the height
            blocks: [...resp.blocks].sort((a, b) => a.block.header.height - b.block.header.height),
        };
    }
    // this should paginate through all blockSearch options to ensure it returns all results.
    // starts with page 1 or whatever was provided (eg. to start on page 7)
    //
    // NOTE
    // This method will error on any node that is running a Tendermint version lower than 0.34.9.
    async blockSearchAll(params) {
        let page = params.page || 1;
        const blocks = [];
        let done = false;
        while (!done) {
            const resp = await this.blockSearch({ ...params, page: page });
            blocks.push(...resp.blocks);
            if (blocks.length < resp.totalCount) {
                page++;
            }
            else {
                done = true;
            }
        }
        // make sure we sort by height, as tendermint may be sorting by string value of the height
        // and the earlier items may be in a higher page than the later items
        blocks.sort((a, b) => a.block.header.height - b.block.header.height);
        return {
            totalCount: blocks.length,
            blocks: blocks,
        };
    }
    /**
     * Queries block headers filtered by minHeight <= height <= maxHeight.
     *
     * @param minHeight The minimum height to be included in the result. Defaults to 0.
     * @param maxHeight The maximum height to be included in the result. Defaults to infinity.
     */
    async blockchain(minHeight, maxHeight) {
        const query = {
            method: requests.Method.Blockchain,
            params: {
                minHeight: minHeight,
                maxHeight: maxHeight,
            },
        };
        return this.doCall(query, this.p.encodeBlockchain, this.r.decodeBlockchain);
    }
    /**
     * Broadcast transaction to mempool and wait for response
     *
     * @see https://docs.tendermint.com/master/rpc/#/Tx/broadcast_tx_sync
     */
    async broadcastTxSync(params) {
        const query = { params: params, method: requests.Method.BroadcastTxSync };
        return this.doCall(query, this.p.encodeBroadcastTx, this.r.decodeBroadcastTxSync);
    }
    /**
     * Broadcast transaction to mempool and do not wait for result
     *
     * @see https://docs.tendermint.com/master/rpc/#/Tx/broadcast_tx_async
     */
    async broadcastTxAsync(params) {
        const query = { params: params, method: requests.Method.BroadcastTxAsync };
        return this.doCall(query, this.p.encodeBroadcastTx, this.r.decodeBroadcastTxAsync);
    }
    /**
     * Broadcast transaction to mempool and wait for block
     *
     * @see https://docs.tendermint.com/master/rpc/#/Tx/broadcast_tx_commit
     */
    async broadcastTxCommit(params) {
        const query = { params: params, method: requests.Method.BroadcastTxCommit };
        return this.doCall(query, this.p.encodeBroadcastTx, this.r.decodeBroadcastTxCommit);
    }
    async commit(height) {
        const query = { method: requests.Method.Commit, params: { height: height } };
        return this.doCall(query, this.p.encodeCommit, this.r.decodeCommit);
    }
    async genesis() {
        const query = { method: requests.Method.Genesis };
        return this.doCall(query, this.p.encodeGenesis, this.r.decodeGenesis);
    }
    async health() {
        const query = { method: requests.Method.Health };
        return this.doCall(query, this.p.encodeHealth, this.r.decodeHealth);
    }
    async numUnconfirmedTxs() {
        const query = { method: requests.Method.NumUnconfirmedTxs };
        return this.doCall(query, this.p.encodeNumUnconfirmedTxs, this.r.decodeNumUnconfirmedTxs);
    }
    async status() {
        const query = { method: requests.Method.Status };
        return this.doCall(query, this.p.encodeStatus, this.r.decodeStatus);
    }
    subscribeNewBlock() {
        const request = {
            method: requests.Method.Subscribe,
            query: { type: requests.SubscriptionEventType.NewBlock },
        };
        return this.subscribe(request, this.r.decodeNewBlockEvent);
    }
    subscribeNewBlockHeader() {
        const request = {
            method: requests.Method.Subscribe,
            query: { type: requests.SubscriptionEventType.NewBlockHeader },
        };
        return this.subscribe(request, this.r.decodeNewBlockHeaderEvent);
    }
    subscribeTx(query) {
        const request = {
            method: requests.Method.Subscribe,
            query: {
                type: requests.SubscriptionEventType.Tx,
                raw: query,
            },
        };
        return this.subscribe(request, this.r.decodeTxEvent);
    }
    /**
     * Get a single transaction by hash
     *
     * @see https://docs.tendermint.com/master/rpc/#/Info/tx
     */
    async tx(params) {
        const query = { params: params, method: requests.Method.Tx };
        return this.doCall(query, this.p.encodeTx, this.r.decodeTx);
    }
    /**
     * Search for transactions that are in a block
     *
     * @see https://docs.tendermint.com/master/rpc/#/Info/tx_search
     */
    async txSearch(params) {
        const query = { params: params, method: requests.Method.TxSearch };
        return this.doCall(query, this.p.encodeTxSearch, this.r.decodeTxSearch);
    }
    // this should paginate through all txSearch options to ensure it returns all results.
    // starts with page 1 or whatever was provided (eg. to start on page 7)
    async txSearchAll(params) {
        let page = params.page || 1;
        const txs = [];
        let done = false;
        while (!done) {
            const resp = await this.txSearch({ ...params, page: page });
            txs.push(...resp.txs);
            if (txs.length < resp.totalCount) {
                page++;
            }
            else {
                done = true;
            }
        }
        return {
            totalCount: txs.length,
            txs: txs,
        };
    }
    async validators(params) {
        const query = {
            method: requests.Method.Validators,
            params: params,
        };
        return this.doCall(query, this.p.encodeValidators, this.r.decodeValidators);
    }
    async validatorsAll(height) {
        const validators = [];
        let page = 1;
        let done = false;
        let blockHeight = height;
        while (!done) {
            const response = await this.validators({
                per_page: 50,
                height: blockHeight,
                page: page,
            });
            validators.push(...response.validators);
            blockHeight = blockHeight || response.blockHeight;
            if (validators.length < response.total) {
                page++;
            }
            else {
                done = true;
            }
        }
        return {
            // NOTE: Default value is for type safety but this should always be set
            blockHeight: blockHeight ?? 0,
            count: validators.length,
            total: validators.length,
            validators: validators,
        };
    }
    // doCall is a helper to handle the encode/call/decode logic
    async doCall(request, encode, decode) {
        const req = encode(request);
        const result = await this.client.execute(req);
        return decode(result);
    }
    subscribe(request, decode) {
        if (!(0, rpcclients_1.instanceOfRpcStreamingClient)(this.client)) {
            throw new Error("This RPC client type cannot subscribe to events");
        }
        const req = this.p.encodeSubscribe(request);
        const eventStream = this.client.listen(req);
        return eventStream.map((event) => {
            return decode(event);
        });
    }
}
exports.Tendermint34Client = Tendermint34Client;
//# sourceMappingURL=tendermint34client.js.map

/***/ }),

/***/ 52904:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.adaptor37 = void 0;
const hasher_1 = __webpack_require__(9959);
const requests_1 = __webpack_require__(29548);
const responses_1 = __webpack_require__(39644);
exports.adaptor37 = {
    params: requests_1.Params,
    responses: responses_1.Responses,
    hashTx: hasher_1.hashTx,
    hashBlock: hasher_1.hashBlock,
};
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 29548:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Params = void 0;
/* eslint-disable @typescript-eslint/naming-convention */
const encoding_1 = __webpack_require__(87061);
const inthelpers_1 = __webpack_require__(47450);
const jsonrpc_1 = __webpack_require__(57657);
const encodings_1 = __webpack_require__(30708);
const requests = __importStar(__webpack_require__(59814));
function encodeHeightParam(param) {
    return {
        height: (0, encodings_1.may)(inthelpers_1.smallIntToApi, param.height),
    };
}
function encodeBlockchainRequestParams(param) {
    return {
        minHeight: (0, encodings_1.may)(inthelpers_1.smallIntToApi, param.minHeight),
        maxHeight: (0, encodings_1.may)(inthelpers_1.smallIntToApi, param.maxHeight),
    };
}
function encodeBlockSearchParams(params) {
    return {
        query: params.query,
        page: (0, encodings_1.may)(inthelpers_1.smallIntToApi, params.page),
        per_page: (0, encodings_1.may)(inthelpers_1.smallIntToApi, params.per_page),
        order_by: params.order_by,
    };
}
function encodeAbciQueryParams(params) {
    return {
        path: (0, encodings_1.assertNotEmpty)(params.path),
        data: (0, encoding_1.toHex)(params.data),
        height: (0, encodings_1.may)(inthelpers_1.smallIntToApi, params.height),
        prove: params.prove,
    };
}
function encodeBroadcastTxParams(params) {
    return {
        tx: (0, encoding_1.toBase64)((0, encodings_1.assertNotEmpty)(params.tx)),
    };
}
function encodeTxParams(params) {
    return {
        hash: (0, encoding_1.toBase64)((0, encodings_1.assertNotEmpty)(params.hash)),
        prove: params.prove,
    };
}
function encodeTxSearchParams(params) {
    return {
        query: params.query,
        prove: params.prove,
        page: (0, encodings_1.may)(inthelpers_1.smallIntToApi, params.page),
        per_page: (0, encodings_1.may)(inthelpers_1.smallIntToApi, params.per_page),
        order_by: params.order_by,
    };
}
function encodeValidatorsParams(params) {
    return {
        height: (0, encodings_1.may)(inthelpers_1.smallIntToApi, params.height),
        page: (0, encodings_1.may)(inthelpers_1.smallIntToApi, params.page),
        per_page: (0, encodings_1.may)(inthelpers_1.smallIntToApi, params.per_page),
    };
}
class Params {
    static encodeAbciInfo(req) {
        return (0, jsonrpc_1.createJsonRpcRequest)(req.method);
    }
    static encodeAbciQuery(req) {
        return (0, jsonrpc_1.createJsonRpcRequest)(req.method, encodeAbciQueryParams(req.params));
    }
    static encodeBlock(req) {
        return (0, jsonrpc_1.createJsonRpcRequest)(req.method, encodeHeightParam(req.params));
    }
    static encodeBlockchain(req) {
        return (0, jsonrpc_1.createJsonRpcRequest)(req.method, encodeBlockchainRequestParams(req.params));
    }
    static encodeBlockResults(req) {
        return (0, jsonrpc_1.createJsonRpcRequest)(req.method, encodeHeightParam(req.params));
    }
    static encodeBlockSearch(req) {
        return (0, jsonrpc_1.createJsonRpcRequest)(req.method, encodeBlockSearchParams(req.params));
    }
    static encodeBroadcastTx(req) {
        return (0, jsonrpc_1.createJsonRpcRequest)(req.method, encodeBroadcastTxParams(req.params));
    }
    static encodeCommit(req) {
        return (0, jsonrpc_1.createJsonRpcRequest)(req.method, encodeHeightParam(req.params));
    }
    static encodeGenesis(req) {
        return (0, jsonrpc_1.createJsonRpcRequest)(req.method);
    }
    static encodeHealth(req) {
        return (0, jsonrpc_1.createJsonRpcRequest)(req.method);
    }
    static encodeNumUnconfirmedTxs(req) {
        return (0, jsonrpc_1.createJsonRpcRequest)(req.method);
    }
    static encodeStatus(req) {
        return (0, jsonrpc_1.createJsonRpcRequest)(req.method);
    }
    static encodeSubscribe(req) {
        const eventTag = { key: "tm.event", value: req.query.type };
        const query = requests.buildQuery({ tags: [eventTag], raw: req.query.raw });
        return (0, jsonrpc_1.createJsonRpcRequest)("subscribe", { query: query });
    }
    static encodeTx(req) {
        return (0, jsonrpc_1.createJsonRpcRequest)(req.method, encodeTxParams(req.params));
    }
    // TODO: encode params for query string???
    static encodeTxSearch(req) {
        return (0, jsonrpc_1.createJsonRpcRequest)(req.method, encodeTxSearchParams(req.params));
    }
    static encodeValidators(req) {
        return (0, jsonrpc_1.createJsonRpcRequest)(req.method, encodeValidatorsParams(req.params));
    }
}
exports.Params = Params;
//# sourceMappingURL=requests.js.map

/***/ }),

/***/ 39644:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Responses = exports.decodeValidatorInfo = exports.decodeValidatorGenesis = exports.decodeValidatorUpdate = exports.decodeEvent = void 0;
/* eslint-disable @typescript-eslint/naming-convention */
const encoding_1 = __webpack_require__(87061);
const utils_1 = __webpack_require__(62584);
const dates_1 = __webpack_require__(11756);
const inthelpers_1 = __webpack_require__(47450);
const types_1 = __webpack_require__(26823);
const encodings_1 = __webpack_require__(30708);
const hasher_1 = __webpack_require__(9959);
function decodeAbciInfo(data) {
    return {
        data: data.data,
        lastBlockHeight: (0, encodings_1.may)(inthelpers_1.apiToSmallInt, data.last_block_height),
        lastBlockAppHash: (0, encodings_1.may)(encoding_1.fromBase64, data.last_block_app_hash),
    };
}
function decodeQueryProof(data) {
    return {
        ops: data.ops.map((op) => ({
            type: op.type,
            key: (0, encoding_1.fromBase64)(op.key),
            data: (0, encoding_1.fromBase64)(op.data),
        })),
    };
}
function decodeAbciQuery(data) {
    return {
        key: (0, encoding_1.fromBase64)((0, encodings_1.assertString)(data.key ?? "")),
        value: (0, encoding_1.fromBase64)((0, encodings_1.assertString)(data.value ?? "")),
        proof: (0, encodings_1.may)(decodeQueryProof, data.proofOps),
        height: (0, encodings_1.may)(inthelpers_1.apiToSmallInt, data.height),
        code: (0, encodings_1.may)(inthelpers_1.apiToSmallInt, data.code),
        codespace: (0, encodings_1.assertString)(data.codespace ?? ""),
        index: (0, encodings_1.may)(inthelpers_1.apiToSmallInt, data.index),
        log: data.log,
        info: (0, encodings_1.assertString)(data.info ?? ""),
    };
}
function decodeEventAttribute(attribute) {
    return {
        key: (0, encodings_1.assertNotEmpty)(attribute.key),
        value: attribute.value ?? "",
    };
}
function decodeAttributes(attributes) {
    return (0, encodings_1.assertArray)(attributes).map(decodeEventAttribute);
}
function decodeEvent(event) {
    return {
        type: event.type,
        attributes: event.attributes ? decodeAttributes(event.attributes) : [],
    };
}
exports.decodeEvent = decodeEvent;
function decodeEvents(events) {
    return (0, encodings_1.assertArray)(events).map(decodeEvent);
}
function decodeTxData(data) {
    return {
        code: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNumber)(data.code ?? 0)),
        codespace: data.codespace,
        log: data.log,
        data: (0, encodings_1.may)(encoding_1.fromBase64, data.data),
        events: data.events ? decodeEvents(data.events) : [],
        gasWanted: (0, inthelpers_1.apiToSmallInt)(data.gas_wanted ?? "0"),
        gasUsed: (0, inthelpers_1.apiToSmallInt)(data.gas_used ?? "0"),
    };
}
function decodePubkey(data) {
    if ("Sum" in data) {
        // we don't need to check type because we're checking algorithm
        const [[algorithm, value]] = Object.entries(data.Sum.value);
        (0, utils_1.assert)(algorithm === "ed25519" || algorithm === "secp256k1", `unknown pubkey type: ${algorithm}`);
        return {
            algorithm,
            data: (0, encoding_1.fromBase64)((0, encodings_1.assertNotEmpty)(value)),
        };
    }
    else {
        switch (data.type) {
            // go-amino special code
            case "tendermint/PubKeyEd25519":
                return {
                    algorithm: "ed25519",
                    data: (0, encoding_1.fromBase64)((0, encodings_1.assertNotEmpty)(data.value)),
                };
            case "tendermint/PubKeySecp256k1":
                return {
                    algorithm: "secp256k1",
                    data: (0, encoding_1.fromBase64)((0, encodings_1.assertNotEmpty)(data.value)),
                };
            default:
                throw new Error(`unknown pubkey type: ${data.type}`);
        }
    }
}
/**
 * Note: we do not parse block.time_iota_ms for now because of this CHANGELOG entry
 *
 * > Add time_iota_ms to block's consensus parameters (not exposed to the application)
 * https://github.com/tendermint/tendermint/blob/master/CHANGELOG.md#v0310
 */
function decodeBlockParams(data) {
    return {
        maxBytes: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(data.max_bytes)),
        maxGas: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(data.max_gas)),
    };
}
function decodeEvidenceParams(data) {
    return {
        maxAgeNumBlocks: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(data.max_age_num_blocks)),
        maxAgeDuration: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(data.max_age_duration)),
    };
}
function decodeConsensusParams(data) {
    return {
        block: decodeBlockParams((0, encodings_1.assertObject)(data.block)),
        evidence: decodeEvidenceParams((0, encodings_1.assertObject)(data.evidence)),
    };
}
function decodeValidatorUpdate(data) {
    return {
        pubkey: decodePubkey((0, encodings_1.assertObject)(data.pub_key)),
        votingPower: (0, inthelpers_1.apiToBigInt)(data.power ?? "0"),
    };
}
exports.decodeValidatorUpdate = decodeValidatorUpdate;
function decodeBlockResults(data) {
    return {
        height: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(data.height)),
        results: (data.txs_results || []).map(decodeTxData),
        validatorUpdates: (data.validator_updates || []).map(decodeValidatorUpdate),
        consensusUpdates: (0, encodings_1.may)(decodeConsensusParams, data.consensus_param_updates),
        beginBlockEvents: decodeEvents(data.begin_block_events || []),
        endBlockEvents: decodeEvents(data.end_block_events || []),
    };
}
function decodeBlockId(data) {
    return {
        hash: (0, encoding_1.fromHex)((0, encodings_1.assertNotEmpty)(data.hash)),
        parts: {
            total: (0, encodings_1.assertNotEmpty)(data.parts.total),
            hash: (0, encoding_1.fromHex)((0, encodings_1.assertNotEmpty)(data.parts.hash)),
        },
    };
}
function decodeBlockVersion(data) {
    return {
        block: (0, inthelpers_1.apiToSmallInt)(data.block),
        app: (0, inthelpers_1.apiToSmallInt)(data.app ?? 0),
    };
}
function decodeHeader(data) {
    return {
        version: decodeBlockVersion(data.version),
        chainId: (0, encodings_1.assertNotEmpty)(data.chain_id),
        height: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(data.height)),
        time: (0, dates_1.fromRfc3339WithNanoseconds)((0, encodings_1.assertNotEmpty)(data.time)),
        // When there is no last block ID (i.e. this block's height is 1), we get an empty structure like this:
        // { hash: '', parts: { total: 0, hash: '' } }
        lastBlockId: data.last_block_id.hash ? decodeBlockId(data.last_block_id) : null,
        lastCommitHash: (0, encoding_1.fromHex)((0, encodings_1.assertSet)(data.last_commit_hash)),
        dataHash: (0, encoding_1.fromHex)((0, encodings_1.assertSet)(data.data_hash)),
        validatorsHash: (0, encoding_1.fromHex)((0, encodings_1.assertSet)(data.validators_hash)),
        nextValidatorsHash: (0, encoding_1.fromHex)((0, encodings_1.assertSet)(data.next_validators_hash)),
        consensusHash: (0, encoding_1.fromHex)((0, encodings_1.assertSet)(data.consensus_hash)),
        appHash: (0, encoding_1.fromHex)((0, encodings_1.assertSet)(data.app_hash)),
        lastResultsHash: (0, encoding_1.fromHex)((0, encodings_1.assertSet)(data.last_results_hash)),
        evidenceHash: (0, encoding_1.fromHex)((0, encodings_1.assertSet)(data.evidence_hash)),
        proposerAddress: (0, encoding_1.fromHex)((0, encodings_1.assertNotEmpty)(data.proposer_address)),
    };
}
function decodeBlockMeta(data) {
    return {
        blockId: decodeBlockId(data.block_id),
        blockSize: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(data.block_size)),
        header: decodeHeader(data.header),
        numTxs: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(data.num_txs)),
    };
}
function decodeBlockchain(data) {
    return {
        lastHeight: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(data.last_height)),
        blockMetas: (0, encodings_1.assertArray)(data.block_metas).map(decodeBlockMeta),
    };
}
function decodeBroadcastTxSync(data) {
    return {
        ...decodeTxData(data),
        hash: (0, encoding_1.fromHex)((0, encodings_1.assertNotEmpty)(data.hash)),
    };
}
function decodeBroadcastTxCommit(data) {
    return {
        height: (0, inthelpers_1.apiToSmallInt)(data.height),
        hash: (0, encoding_1.fromHex)((0, encodings_1.assertNotEmpty)(data.hash)),
        checkTx: decodeTxData((0, encodings_1.assertObject)(data.check_tx)),
        deliverTx: (0, encodings_1.may)(decodeTxData, data.deliver_tx),
    };
}
function decodeBlockIdFlag(blockIdFlag) {
    (0, utils_1.assert)(blockIdFlag in types_1.BlockIdFlag);
    return blockIdFlag;
}
/**
 * In some cases a timestamp is optional and set to the value 0 in Go.
 * This can lead to strings like "0001-01-01T00:00:00Z" (see https://github.com/cosmos/cosmjs/issues/704#issuecomment-797122415).
 * This decoder tries to clean up such encoding from the API and turn them
 * into undefined values.
 */
function decodeOptionalTime(timestamp) {
    const nonZeroTime = timestamp && !timestamp.startsWith("0001-01-01");
    return nonZeroTime ? (0, dates_1.fromRfc3339WithNanoseconds)(timestamp) : undefined;
}
function decodeCommitSignature(data) {
    return {
        blockIdFlag: decodeBlockIdFlag(data.block_id_flag),
        validatorAddress: data.validator_address ? (0, encoding_1.fromHex)(data.validator_address) : undefined,
        timestamp: decodeOptionalTime(data.timestamp),
        signature: data.signature ? (0, encoding_1.fromBase64)(data.signature) : undefined,
    };
}
function decodeCommit(data) {
    return {
        blockId: decodeBlockId((0, encodings_1.assertObject)(data.block_id)),
        height: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(data.height)),
        round: (0, inthelpers_1.apiToSmallInt)(data.round),
        signatures: (0, encodings_1.assertArray)(data.signatures).map(decodeCommitSignature),
    };
}
function decodeCommitResponse(data) {
    return {
        canonical: (0, encodings_1.assertBoolean)(data.canonical),
        header: decodeHeader(data.signed_header.header),
        commit: decodeCommit(data.signed_header.commit),
    };
}
function decodeValidatorGenesis(data) {
    return {
        address: (0, encoding_1.fromHex)((0, encodings_1.assertNotEmpty)(data.address)),
        pubkey: decodePubkey((0, encodings_1.assertObject)(data.pub_key)),
        votingPower: (0, inthelpers_1.apiToBigInt)((0, encodings_1.assertNotEmpty)(data.power)),
    };
}
exports.decodeValidatorGenesis = decodeValidatorGenesis;
function decodeGenesis(data) {
    return {
        genesisTime: (0, dates_1.fromRfc3339WithNanoseconds)((0, encodings_1.assertNotEmpty)(data.genesis_time)),
        chainId: (0, encodings_1.assertNotEmpty)(data.chain_id),
        consensusParams: decodeConsensusParams(data.consensus_params),
        validators: data.validators ? (0, encodings_1.assertArray)(data.validators).map(decodeValidatorGenesis) : [],
        appHash: (0, encoding_1.fromHex)((0, encodings_1.assertSet)(data.app_hash)),
        appState: data.app_state,
    };
}
function decodeValidatorInfo(data) {
    return {
        pubkey: decodePubkey((0, encodings_1.assertObject)(data.pub_key)),
        votingPower: (0, inthelpers_1.apiToBigInt)((0, encodings_1.assertNotEmpty)(data.voting_power)),
        address: (0, encoding_1.fromHex)((0, encodings_1.assertNotEmpty)(data.address)),
        proposerPriority: data.proposer_priority ? (0, inthelpers_1.apiToSmallInt)(data.proposer_priority) : undefined,
    };
}
exports.decodeValidatorInfo = decodeValidatorInfo;
function decodeNodeInfo(data) {
    return {
        id: (0, encoding_1.fromHex)((0, encodings_1.assertNotEmpty)(data.id)),
        listenAddr: (0, encodings_1.assertNotEmpty)(data.listen_addr),
        network: (0, encodings_1.assertNotEmpty)(data.network),
        version: (0, encodings_1.assertString)(data.version),
        channels: (0, encodings_1.assertNotEmpty)(data.channels),
        moniker: (0, encodings_1.assertNotEmpty)(data.moniker),
        other: (0, encodings_1.dictionaryToStringMap)(data.other),
        protocolVersion: {
            app: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(data.protocol_version.app)),
            block: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(data.protocol_version.block)),
            p2p: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(data.protocol_version.p2p)),
        },
    };
}
function decodeSyncInfo(data) {
    const earliestBlockHeight = data.earliest_block_height
        ? (0, inthelpers_1.apiToSmallInt)(data.earliest_block_height)
        : undefined;
    const earliestBlockTime = data.earliest_block_time
        ? (0, dates_1.fromRfc3339WithNanoseconds)(data.earliest_block_time)
        : undefined;
    return {
        earliestAppHash: data.earliest_app_hash ? (0, encoding_1.fromHex)(data.earliest_app_hash) : undefined,
        earliestBlockHash: data.earliest_block_hash ? (0, encoding_1.fromHex)(data.earliest_block_hash) : undefined,
        earliestBlockHeight: earliestBlockHeight || undefined,
        earliestBlockTime: earliestBlockTime?.getTime() ? earliestBlockTime : undefined,
        latestBlockHash: (0, encoding_1.fromHex)((0, encodings_1.assertNotEmpty)(data.latest_block_hash)),
        latestAppHash: (0, encoding_1.fromHex)((0, encodings_1.assertNotEmpty)(data.latest_app_hash)),
        latestBlockTime: (0, dates_1.fromRfc3339WithNanoseconds)((0, encodings_1.assertNotEmpty)(data.latest_block_time)),
        latestBlockHeight: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(data.latest_block_height)),
        catchingUp: (0, encodings_1.assertBoolean)(data.catching_up),
    };
}
function decodeStatus(data) {
    return {
        nodeInfo: decodeNodeInfo(data.node_info),
        syncInfo: decodeSyncInfo(data.sync_info),
        validatorInfo: decodeValidatorInfo(data.validator_info),
    };
}
function decodeTxProof(data) {
    return {
        data: (0, encoding_1.fromBase64)((0, encodings_1.assertNotEmpty)(data.data)),
        rootHash: (0, encoding_1.fromHex)((0, encodings_1.assertNotEmpty)(data.root_hash)),
        proof: {
            total: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(data.proof.total)),
            index: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(data.proof.index)),
            leafHash: (0, encoding_1.fromBase64)((0, encodings_1.assertNotEmpty)(data.proof.leaf_hash)),
            aunts: (0, encodings_1.assertArray)(data.proof.aunts).map(encoding_1.fromBase64),
        },
    };
}
function decodeTxResponse(data) {
    return {
        tx: (0, encoding_1.fromBase64)((0, encodings_1.assertNotEmpty)(data.tx)),
        result: decodeTxData((0, encodings_1.assertObject)(data.tx_result)),
        height: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(data.height)),
        index: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNumber)(data.index)),
        hash: (0, encoding_1.fromHex)((0, encodings_1.assertNotEmpty)(data.hash)),
        proof: (0, encodings_1.may)(decodeTxProof, data.proof),
    };
}
function decodeTxSearch(data) {
    return {
        totalCount: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(data.total_count)),
        txs: (0, encodings_1.assertArray)(data.txs).map(decodeTxResponse),
    };
}
function decodeTxEvent(data) {
    const tx = (0, encoding_1.fromBase64)((0, encodings_1.assertNotEmpty)(data.tx));
    return {
        tx: tx,
        hash: (0, hasher_1.hashTx)(tx),
        result: decodeTxData(data.result),
        height: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(data.height)),
    };
}
function decodeValidators(data) {
    return {
        blockHeight: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(data.block_height)),
        validators: (0, encodings_1.assertArray)(data.validators).map(decodeValidatorInfo),
        count: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(data.count)),
        total: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(data.total)),
    };
}
function decodeBlock(data) {
    return {
        header: decodeHeader((0, encodings_1.assertObject)(data.header)),
        // For the block at height 1, last commit is not set. This is represented in an empty object like this:
        // { height: '0', round: 0, block_id: { hash: '', parts: [Object] }, signatures: [] }
        lastCommit: data.last_commit.block_id.hash ? decodeCommit((0, encodings_1.assertObject)(data.last_commit)) : null,
        txs: data.data.txs ? (0, encodings_1.assertArray)(data.data.txs).map(encoding_1.fromBase64) : [],
        // Lift up .evidence.evidence to just .evidence
        // See https://github.com/tendermint/tendermint/issues/7697
        evidence: data.evidence?.evidence ?? [],
    };
}
function decodeBlockResponse(data) {
    return {
        blockId: decodeBlockId(data.block_id),
        block: decodeBlock(data.block),
    };
}
function decodeBlockSearch(data) {
    return {
        totalCount: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(data.total_count)),
        blocks: (0, encodings_1.assertArray)(data.blocks).map(decodeBlockResponse),
    };
}
function decodeNumUnconfirmedTxs(data) {
    return {
        total: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(data.total)),
        totalBytes: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(data.total_bytes)),
    };
}
class Responses {
    static decodeAbciInfo(response) {
        return decodeAbciInfo((0, encodings_1.assertObject)(response.result.response));
    }
    static decodeAbciQuery(response) {
        return decodeAbciQuery((0, encodings_1.assertObject)(response.result.response));
    }
    static decodeBlock(response) {
        return decodeBlockResponse(response.result);
    }
    static decodeBlockResults(response) {
        return decodeBlockResults(response.result);
    }
    static decodeBlockSearch(response) {
        return decodeBlockSearch(response.result);
    }
    static decodeBlockchain(response) {
        return decodeBlockchain(response.result);
    }
    static decodeBroadcastTxSync(response) {
        return decodeBroadcastTxSync(response.result);
    }
    static decodeBroadcastTxAsync(response) {
        return Responses.decodeBroadcastTxSync(response);
    }
    static decodeBroadcastTxCommit(response) {
        return decodeBroadcastTxCommit(response.result);
    }
    static decodeCommit(response) {
        return decodeCommitResponse(response.result);
    }
    static decodeGenesis(response) {
        return decodeGenesis((0, encodings_1.assertObject)(response.result.genesis));
    }
    static decodeHealth() {
        return null;
    }
    static decodeNumUnconfirmedTxs(response) {
        return decodeNumUnconfirmedTxs(response.result);
    }
    static decodeStatus(response) {
        return decodeStatus(response.result);
    }
    static decodeNewBlockEvent(event) {
        return decodeBlock(event.data.value.block);
    }
    static decodeNewBlockHeaderEvent(event) {
        return decodeHeader(event.data.value.header);
    }
    static decodeTxEvent(event) {
        return decodeTxEvent(event.data.value.TxResult);
    }
    static decodeTx(response) {
        return decodeTxResponse(response.result);
    }
    static decodeTxSearch(response) {
        return decodeTxSearch(response.result);
    }
    static decodeValidators(response) {
        return decodeValidators(response.result);
    }
}
exports.Responses = Responses;
//# sourceMappingURL=responses.js.map

/***/ }),

/***/ 30708:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.encodeBlockId = exports.encodeVersion = exports.encodeBytes = exports.encodeTime = exports.encodeUvarint = exports.encodeString = exports.dictionaryToStringMap = exports.may = exports.assertNotEmpty = exports.assertObject = exports.assertArray = exports.assertNumber = exports.assertString = exports.assertBoolean = exports.assertSet = void 0;
const encoding_1 = __webpack_require__(87061);
/**
 * A runtime checker that ensures a given value is set (i.e. not undefined or null)
 *
 * This is used when you want to verify that data at runtime matches the expected type.
 */
function assertSet(value) {
    if (value === undefined) {
        throw new Error("Value must not be undefined");
    }
    if (value === null) {
        throw new Error("Value must not be null");
    }
    return value;
}
exports.assertSet = assertSet;
/**
 * A runtime checker that ensures a given value is a boolean
 *
 * This is used when you want to verify that data at runtime matches the expected type.
 * This implies assertSet.
 */
function assertBoolean(value) {
    assertSet(value);
    if (typeof value !== "boolean") {
        throw new Error("Value must be a boolean");
    }
    return value;
}
exports.assertBoolean = assertBoolean;
/**
 * A runtime checker that ensures a given value is a string.
 *
 * This is used when you want to verify that data at runtime matches the expected type.
 * This implies assertSet.
 */
function assertString(value) {
    assertSet(value);
    if (typeof value !== "string") {
        throw new Error("Value must be a string");
    }
    return value;
}
exports.assertString = assertString;
/**
 * A runtime checker that ensures a given value is a number
 *
 * This is used when you want to verify that data at runtime matches the expected type.
 * This implies assertSet.
 */
function assertNumber(value) {
    assertSet(value);
    if (typeof value !== "number") {
        throw new Error("Value must be a number");
    }
    return value;
}
exports.assertNumber = assertNumber;
/**
 * A runtime checker that ensures a given value is an array
 *
 * This is used when you want to verify that data at runtime matches the expected type.
 * This implies assertSet.
 */
function assertArray(value) {
    assertSet(value);
    if (!Array.isArray(value)) {
        throw new Error("Value must be a an array");
    }
    return value;
}
exports.assertArray = assertArray;
/**
 * A runtime checker that ensures a given value is an object in the sense of JSON
 * (an unordered collection of key–value pairs where the keys are strings)
 *
 * This is used when you want to verify that data at runtime matches the expected type.
 * This implies assertSet.
 */
function assertObject(value) {
    assertSet(value);
    if (typeof value !== "object") {
        throw new Error("Value must be an object");
    }
    // Exclude special kind of objects like Array, Date or Uint8Array
    // Object.prototype.toString() returns a specified value:
    // http://www.ecma-international.org/ecma-262/7.0/index.html#sec-object.prototype.tostring
    if (Object.prototype.toString.call(value) !== "[object Object]") {
        throw new Error("Value must be a simple object");
    }
    return value;
}
exports.assertObject = assertObject;
/**
 * Throws an error if value matches the empty value for the
 * given type (array/string of length 0, number of value 0, ...)
 *
 * Otherwise returns the value.
 *
 * This implies assertSet
 */
function assertNotEmpty(value) {
    assertSet(value);
    if (typeof value === "number" && value === 0) {
        throw new Error("must provide a non-zero value");
    }
    else if (value.length === 0) {
        throw new Error("must provide a non-empty value");
    }
    return value;
}
exports.assertNotEmpty = assertNotEmpty;
// may will run the transform if value is defined, otherwise returns undefined
function may(transform, value) {
    return value === undefined || value === null ? undefined : transform(value);
}
exports.may = may;
function dictionaryToStringMap(obj) {
    const out = new Map();
    for (const key of Object.keys(obj)) {
        const value = obj[key];
        if (typeof value !== "string") {
            throw new Error("Found dictionary value of type other than string");
        }
        out.set(key, value);
    }
    return out;
}
exports.dictionaryToStringMap = dictionaryToStringMap;
// Encodings needed for hashing block headers
// Several of these functions are inspired by https://github.com/nomic-io/js-tendermint/blob/tendermint-0.30/src/
// See https://github.com/tendermint/go-amino/blob/v0.15.0/encoder.go#L193-L195
function encodeString(s) {
    const utf8 = (0, encoding_1.toUtf8)(s);
    return Uint8Array.from([utf8.length, ...utf8]);
}
exports.encodeString = encodeString;
// See https://github.com/tendermint/go-amino/blob/v0.15.0/encoder.go#L79-L87
function encodeUvarint(n) {
    return n >= 0x80
        ? // eslint-disable-next-line no-bitwise
            Uint8Array.from([(n & 0xff) | 0x80, ...encodeUvarint(n >> 7)])
        : // eslint-disable-next-line no-bitwise
            Uint8Array.from([n & 0xff]);
}
exports.encodeUvarint = encodeUvarint;
// See https://github.com/tendermint/go-amino/blob/v0.15.0/encoder.go#L134-L178
function encodeTime(time) {
    const milliseconds = time.getTime();
    const seconds = Math.floor(milliseconds / 1000);
    const secondsArray = seconds ? [0x08, ...encodeUvarint(seconds)] : new Uint8Array();
    const nanoseconds = (time.nanoseconds || 0) + (milliseconds % 1000) * 1e6;
    const nanosecondsArray = nanoseconds ? [0x10, ...encodeUvarint(nanoseconds)] : new Uint8Array();
    return Uint8Array.from([...secondsArray, ...nanosecondsArray]);
}
exports.encodeTime = encodeTime;
// See https://github.com/tendermint/go-amino/blob/v0.15.0/encoder.go#L180-L187
function encodeBytes(bytes) {
    // Since we're only dealing with short byte arrays we don't need a full VarBuffer implementation yet
    if (bytes.length >= 0x80)
        throw new Error("Not implemented for byte arrays of length 128 or more");
    return bytes.length ? Uint8Array.from([bytes.length, ...bytes]) : new Uint8Array();
}
exports.encodeBytes = encodeBytes;
function encodeVersion(version) {
    const blockArray = version.block
        ? Uint8Array.from([0x08, ...encodeUvarint(version.block)])
        : new Uint8Array();
    const appArray = version.app ? Uint8Array.from([0x10, ...encodeUvarint(version.app)]) : new Uint8Array();
    return Uint8Array.from([...blockArray, ...appArray]);
}
exports.encodeVersion = encodeVersion;
function encodeBlockId(blockId) {
    return Uint8Array.from([
        0x0a,
        blockId.hash.length,
        ...blockId.hash,
        0x12,
        blockId.parts.hash.length + 4,
        0x08,
        blockId.parts.total,
        0x12,
        blockId.parts.hash.length,
        ...blockId.parts.hash,
    ]);
}
exports.encodeBlockId = encodeBlockId;
//# sourceMappingURL=encodings.js.map

/***/ }),

/***/ 9959:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.hashBlock = exports.hashTx = void 0;
const crypto_1 = __webpack_require__(45027);
const encodings_1 = __webpack_require__(30708);
// hash is sha256
// https://github.com/tendermint/tendermint/blob/master/UPGRADING.md#v0260
function hashTx(tx) {
    return (0, crypto_1.sha256)(tx);
}
exports.hashTx = hashTx;
function getSplitPoint(n) {
    if (n < 1)
        throw new Error("Cannot split an empty tree");
    const largestPowerOf2 = 2 ** Math.floor(Math.log2(n));
    return largestPowerOf2 < n ? largestPowerOf2 : largestPowerOf2 / 2;
}
function hashLeaf(leaf) {
    const hash = new crypto_1.Sha256(Uint8Array.from([0]));
    hash.update(leaf);
    return hash.digest();
}
function hashInner(left, right) {
    const hash = new crypto_1.Sha256(Uint8Array.from([1]));
    hash.update(left);
    hash.update(right);
    return hash.digest();
}
// See https://github.com/tendermint/tendermint/blob/v0.31.8/docs/spec/blockchain/encoding.md#merkleroot
// Note: the hashes input may not actually be hashes, especially before a recursive call
function hashTree(hashes) {
    switch (hashes.length) {
        case 0:
            throw new Error("Cannot hash empty tree");
        case 1:
            return hashLeaf(hashes[0]);
        default: {
            const slicePoint = getSplitPoint(hashes.length);
            const left = hashTree(hashes.slice(0, slicePoint));
            const right = hashTree(hashes.slice(slicePoint));
            return hashInner(left, right);
        }
    }
}
function hashBlock(header) {
    if (!header.lastBlockId) {
        throw new Error("Hashing a block header with no last block ID (i.e. header at height 1) is not supported. If you need this, contributions are welcome. Please add documentation and test vectors for this case.");
    }
    const encodedFields = [
        (0, encodings_1.encodeVersion)(header.version),
        (0, encodings_1.encodeString)(header.chainId),
        (0, encodings_1.encodeUvarint)(header.height),
        (0, encodings_1.encodeTime)(header.time),
        (0, encodings_1.encodeBlockId)(header.lastBlockId),
        (0, encodings_1.encodeBytes)(header.lastCommitHash),
        (0, encodings_1.encodeBytes)(header.dataHash),
        (0, encodings_1.encodeBytes)(header.validatorsHash),
        (0, encodings_1.encodeBytes)(header.nextValidatorsHash),
        (0, encodings_1.encodeBytes)(header.consensusHash),
        (0, encodings_1.encodeBytes)(header.appHash),
        (0, encodings_1.encodeBytes)(header.lastResultsHash),
        (0, encodings_1.encodeBytes)(header.evidenceHash),
        (0, encodings_1.encodeBytes)(header.proposerAddress),
    ];
    return hashTree(encodedFields);
}
exports.hashBlock = hashBlock;
//# sourceMappingURL=hasher.js.map

/***/ }),

/***/ 15900:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

// Note: all exports in this module are publicly available via
// `import { tendermint37 } from "@cosmjs/tendermint-rpc"`
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Tendermint37Client = exports.VoteType = exports.broadcastTxSyncSuccess = exports.broadcastTxCommitSuccess = exports.SubscriptionEventType = exports.Method = void 0;
var requests_1 = __webpack_require__(59814);
Object.defineProperty(exports, "Method", ({ enumerable: true, get: function () { return requests_1.Method; } }));
Object.defineProperty(exports, "SubscriptionEventType", ({ enumerable: true, get: function () { return requests_1.SubscriptionEventType; } }));
var responses_1 = __webpack_require__(61682);
Object.defineProperty(exports, "broadcastTxCommitSuccess", ({ enumerable: true, get: function () { return responses_1.broadcastTxCommitSuccess; } }));
Object.defineProperty(exports, "broadcastTxSyncSuccess", ({ enumerable: true, get: function () { return responses_1.broadcastTxSyncSuccess; } }));
Object.defineProperty(exports, "VoteType", ({ enumerable: true, get: function () { return responses_1.VoteType; } }));
var tendermint37client_1 = __webpack_require__(88263);
Object.defineProperty(exports, "Tendermint37Client", ({ enumerable: true, get: function () { return tendermint37client_1.Tendermint37Client; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 59814:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

/* eslint-disable @typescript-eslint/naming-convention */
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.buildQuery = exports.SubscriptionEventType = exports.Method = void 0;
/**
 * RPC methods as documented in https://docs.tendermint.com/master/rpc/
 *
 * Enum raw value must match the spelling in the "shell" example call (snake_case)
 */
var Method;
(function (Method) {
    Method["AbciInfo"] = "abci_info";
    Method["AbciQuery"] = "abci_query";
    Method["Block"] = "block";
    /** Get block headers for minHeight <= height <= maxHeight. */
    Method["Blockchain"] = "blockchain";
    Method["BlockResults"] = "block_results";
    Method["BlockSearch"] = "block_search";
    Method["BroadcastTxAsync"] = "broadcast_tx_async";
    Method["BroadcastTxSync"] = "broadcast_tx_sync";
    Method["BroadcastTxCommit"] = "broadcast_tx_commit";
    Method["Commit"] = "commit";
    Method["Genesis"] = "genesis";
    Method["Health"] = "health";
    Method["NumUnconfirmedTxs"] = "num_unconfirmed_txs";
    Method["Status"] = "status";
    Method["Subscribe"] = "subscribe";
    Method["Tx"] = "tx";
    Method["TxSearch"] = "tx_search";
    Method["Validators"] = "validators";
    Method["Unsubscribe"] = "unsubscribe";
})(Method = exports.Method || (exports.Method = {}));
/**
 * Raw values must match the tendermint event name
 *
 * @see https://godoc.org/github.com/tendermint/tendermint/types#pkg-constants
 */
var SubscriptionEventType;
(function (SubscriptionEventType) {
    SubscriptionEventType["NewBlock"] = "NewBlock";
    SubscriptionEventType["NewBlockHeader"] = "NewBlockHeader";
    SubscriptionEventType["Tx"] = "Tx";
})(SubscriptionEventType = exports.SubscriptionEventType || (exports.SubscriptionEventType = {}));
function buildQuery(components) {
    const tags = components.tags ? components.tags : [];
    const tagComponents = tags.map((tag) => `${tag.key}='${tag.value}'`);
    const rawComponents = components.raw ? [components.raw] : [];
    return [...tagComponents, ...rawComponents].join(" AND ");
}
exports.buildQuery = buildQuery;
//# sourceMappingURL=requests.js.map

/***/ }),

/***/ 61682:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.VoteType = exports.broadcastTxCommitSuccess = exports.broadcastTxSyncSuccess = void 0;
/**
 * Returns true iff transaction made it successfully into the transaction pool
 */
function broadcastTxSyncSuccess(res) {
    // code must be 0 on success
    return res.code === 0;
}
exports.broadcastTxSyncSuccess = broadcastTxSyncSuccess;
/**
 * Returns true iff transaction made it successfully into a block
 * (i.e. success in `check_tx` and `deliver_tx` field)
 */
function broadcastTxCommitSuccess(response) {
    // code must be 0 on success
    // deliverTx may be present but empty on failure
    return response.checkTx.code === 0 && !!response.deliverTx && response.deliverTx.code === 0;
}
exports.broadcastTxCommitSuccess = broadcastTxCommitSuccess;
/**
 * raw values from https://github.com/tendermint/tendermint/blob/dfa9a9a30a666132425b29454e90a472aa579a48/types/vote.go#L44
 */
var VoteType;
(function (VoteType) {
    VoteType[VoteType["PreVote"] = 1] = "PreVote";
    VoteType[VoteType["PreCommit"] = 2] = "PreCommit";
})(VoteType = exports.VoteType || (exports.VoteType = {}));
//# sourceMappingURL=responses.js.map

/***/ }),

/***/ 88263:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Tendermint37Client = void 0;
const jsonrpc_1 = __webpack_require__(57657);
const rpcclients_1 = __webpack_require__(82492);
const adaptor_1 = __webpack_require__(52904);
const requests = __importStar(__webpack_require__(59814));
class Tendermint37Client {
    /**
     * Creates a new Tendermint client for the given endpoint.
     *
     * Uses HTTP when the URL schema is http or https. Uses WebSockets otherwise.
     */
    static async connect(endpoint) {
        let rpcClient;
        if (typeof endpoint === "object") {
            rpcClient = new rpcclients_1.HttpClient(endpoint);
        }
        else {
            const useHttp = endpoint.startsWith("http://") || endpoint.startsWith("https://");
            rpcClient = useHttp ? new rpcclients_1.HttpClient(endpoint) : new rpcclients_1.WebsocketClient(endpoint);
        }
        // For some very strange reason I don't understand, tests start to fail on some systems
        // (our CI) when skipping the status call before doing other queries. Sleeping a little
        // while did not help. Thus we query the version as a way to say "hi" to the backend,
        // even in cases where we don't use the result.
        const _version = await this.detectVersion(rpcClient);
        return Tendermint37Client.create(rpcClient);
    }
    /**
     * Creates a new Tendermint client given an RPC client.
     */
    static async create(rpcClient) {
        return new Tendermint37Client(rpcClient);
    }
    static async detectVersion(client) {
        const req = (0, jsonrpc_1.createJsonRpcRequest)(requests.Method.Status);
        const response = await client.execute(req);
        const result = response.result;
        if (!result || !result.node_info) {
            throw new Error("Unrecognized format for status response");
        }
        const version = result.node_info.version;
        if (typeof version !== "string") {
            throw new Error("Unrecognized version format: must be string");
        }
        return version;
    }
    /**
     * Use `Tendermint37Client.connect` or `Tendermint37Client.create` to create an instance.
     */
    constructor(client) {
        this.client = client;
        this.p = adaptor_1.adaptor37.params;
        this.r = adaptor_1.adaptor37.responses;
    }
    disconnect() {
        this.client.disconnect();
    }
    async abciInfo() {
        const query = { method: requests.Method.AbciInfo };
        return this.doCall(query, this.p.encodeAbciInfo, this.r.decodeAbciInfo);
    }
    async abciQuery(params) {
        const query = { params: params, method: requests.Method.AbciQuery };
        return this.doCall(query, this.p.encodeAbciQuery, this.r.decodeAbciQuery);
    }
    async block(height) {
        const query = { method: requests.Method.Block, params: { height: height } };
        return this.doCall(query, this.p.encodeBlock, this.r.decodeBlock);
    }
    async blockResults(height) {
        const query = {
            method: requests.Method.BlockResults,
            params: { height: height },
        };
        return this.doCall(query, this.p.encodeBlockResults, this.r.decodeBlockResults);
    }
    /**
     * Search for events that are in a block.
     *
     * NOTE
     * This method will error on any node that is running a Tendermint version lower than 0.34.9.
     *
     * @see https://docs.tendermint.com/master/rpc/#/Info/block_search
     */
    async blockSearch(params) {
        const query = { params: params, method: requests.Method.BlockSearch };
        const resp = await this.doCall(query, this.p.encodeBlockSearch, this.r.decodeBlockSearch);
        return {
            ...resp,
            // make sure we sort by height, as tendermint may be sorting by string value of the height
            blocks: [...resp.blocks].sort((a, b) => a.block.header.height - b.block.header.height),
        };
    }
    // this should paginate through all blockSearch options to ensure it returns all results.
    // starts with page 1 or whatever was provided (eg. to start on page 7)
    //
    // NOTE
    // This method will error on any node that is running a Tendermint version lower than 0.34.9.
    async blockSearchAll(params) {
        let page = params.page || 1;
        const blocks = [];
        let done = false;
        while (!done) {
            const resp = await this.blockSearch({ ...params, page: page });
            blocks.push(...resp.blocks);
            if (blocks.length < resp.totalCount) {
                page++;
            }
            else {
                done = true;
            }
        }
        // make sure we sort by height, as tendermint may be sorting by string value of the height
        // and the earlier items may be in a higher page than the later items
        blocks.sort((a, b) => a.block.header.height - b.block.header.height);
        return {
            totalCount: blocks.length,
            blocks: blocks,
        };
    }
    /**
     * Queries block headers filtered by minHeight <= height <= maxHeight.
     *
     * @param minHeight The minimum height to be included in the result. Defaults to 0.
     * @param maxHeight The maximum height to be included in the result. Defaults to infinity.
     */
    async blockchain(minHeight, maxHeight) {
        const query = {
            method: requests.Method.Blockchain,
            params: {
                minHeight: minHeight,
                maxHeight: maxHeight,
            },
        };
        return this.doCall(query, this.p.encodeBlockchain, this.r.decodeBlockchain);
    }
    /**
     * Broadcast transaction to mempool and wait for response
     *
     * @see https://docs.tendermint.com/master/rpc/#/Tx/broadcast_tx_sync
     */
    async broadcastTxSync(params) {
        const query = { params: params, method: requests.Method.BroadcastTxSync };
        return this.doCall(query, this.p.encodeBroadcastTx, this.r.decodeBroadcastTxSync);
    }
    /**
     * Broadcast transaction to mempool and do not wait for result
     *
     * @see https://docs.tendermint.com/master/rpc/#/Tx/broadcast_tx_async
     */
    async broadcastTxAsync(params) {
        const query = { params: params, method: requests.Method.BroadcastTxAsync };
        return this.doCall(query, this.p.encodeBroadcastTx, this.r.decodeBroadcastTxAsync);
    }
    /**
     * Broadcast transaction to mempool and wait for block
     *
     * @see https://docs.tendermint.com/master/rpc/#/Tx/broadcast_tx_commit
     */
    async broadcastTxCommit(params) {
        const query = { params: params, method: requests.Method.BroadcastTxCommit };
        return this.doCall(query, this.p.encodeBroadcastTx, this.r.decodeBroadcastTxCommit);
    }
    async commit(height) {
        const query = { method: requests.Method.Commit, params: { height: height } };
        return this.doCall(query, this.p.encodeCommit, this.r.decodeCommit);
    }
    async genesis() {
        const query = { method: requests.Method.Genesis };
        return this.doCall(query, this.p.encodeGenesis, this.r.decodeGenesis);
    }
    async health() {
        const query = { method: requests.Method.Health };
        return this.doCall(query, this.p.encodeHealth, this.r.decodeHealth);
    }
    async numUnconfirmedTxs() {
        const query = { method: requests.Method.NumUnconfirmedTxs };
        return this.doCall(query, this.p.encodeNumUnconfirmedTxs, this.r.decodeNumUnconfirmedTxs);
    }
    async status() {
        const query = { method: requests.Method.Status };
        return this.doCall(query, this.p.encodeStatus, this.r.decodeStatus);
    }
    subscribeNewBlock() {
        const request = {
            method: requests.Method.Subscribe,
            query: { type: requests.SubscriptionEventType.NewBlock },
        };
        return this.subscribe(request, this.r.decodeNewBlockEvent);
    }
    subscribeNewBlockHeader() {
        const request = {
            method: requests.Method.Subscribe,
            query: { type: requests.SubscriptionEventType.NewBlockHeader },
        };
        return this.subscribe(request, this.r.decodeNewBlockHeaderEvent);
    }
    subscribeTx(query) {
        const request = {
            method: requests.Method.Subscribe,
            query: {
                type: requests.SubscriptionEventType.Tx,
                raw: query,
            },
        };
        return this.subscribe(request, this.r.decodeTxEvent);
    }
    /**
     * Get a single transaction by hash
     *
     * @see https://docs.tendermint.com/master/rpc/#/Info/tx
     */
    async tx(params) {
        const query = { params: params, method: requests.Method.Tx };
        return this.doCall(query, this.p.encodeTx, this.r.decodeTx);
    }
    /**
     * Search for transactions that are in a block
     *
     * @see https://docs.tendermint.com/master/rpc/#/Info/tx_search
     */
    async txSearch(params) {
        const query = { params: params, method: requests.Method.TxSearch };
        return this.doCall(query, this.p.encodeTxSearch, this.r.decodeTxSearch);
    }
    // this should paginate through all txSearch options to ensure it returns all results.
    // starts with page 1 or whatever was provided (eg. to start on page 7)
    async txSearchAll(params) {
        let page = params.page || 1;
        const txs = [];
        let done = false;
        while (!done) {
            const resp = await this.txSearch({ ...params, page: page });
            txs.push(...resp.txs);
            if (txs.length < resp.totalCount) {
                page++;
            }
            else {
                done = true;
            }
        }
        return {
            totalCount: txs.length,
            txs: txs,
        };
    }
    async validators(params) {
        const query = {
            method: requests.Method.Validators,
            params: params,
        };
        return this.doCall(query, this.p.encodeValidators, this.r.decodeValidators);
    }
    async validatorsAll(height) {
        const validators = [];
        let page = 1;
        let done = false;
        let blockHeight = height;
        while (!done) {
            const response = await this.validators({
                per_page: 50,
                height: blockHeight,
                page: page,
            });
            validators.push(...response.validators);
            blockHeight = blockHeight || response.blockHeight;
            if (validators.length < response.total) {
                page++;
            }
            else {
                done = true;
            }
        }
        return {
            // NOTE: Default value is for type safety but this should always be set
            blockHeight: blockHeight ?? 0,
            count: validators.length,
            total: validators.length,
            validators: validators,
        };
    }
    // doCall is a helper to handle the encode/call/decode logic
    async doCall(request, encode, decode) {
        const req = encode(request);
        const result = await this.client.execute(req);
        return decode(result);
    }
    subscribe(request, decode) {
        if (!(0, rpcclients_1.instanceOfRpcStreamingClient)(this.client)) {
            throw new Error("This RPC client type cannot subscribe to events");
        }
        const req = this.p.encodeSubscribe(request);
        const eventStream = this.client.listen(req);
        return eventStream.map((event) => {
            return decode(event);
        });
    }
}
exports.Tendermint37Client = Tendermint37Client;
//# sourceMappingURL=tendermint37client.js.map

/***/ }),

/***/ 95828:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.isTendermint37Client = exports.isTendermint34Client = void 0;
const tendermint34_1 = __webpack_require__(2621);
const tendermint37_1 = __webpack_require__(15900);
function isTendermint34Client(client) {
    return client instanceof tendermint34_1.Tendermint34Client;
}
exports.isTendermint34Client = isTendermint34Client;
function isTendermint37Client(client) {
    return client instanceof tendermint37_1.Tendermint37Client;
}
exports.isTendermint37Client = isTendermint37Client;
//# sourceMappingURL=tendermintclient.js.map

/***/ }),

/***/ 26823:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

// Types in this file are exported outside of the @cosmjs/tendermint-rpc package,
// e.g. as part of a request or response
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.BlockIdFlag = void 0;
var BlockIdFlag;
(function (BlockIdFlag) {
    BlockIdFlag[BlockIdFlag["Unknown"] = 0] = "Unknown";
    BlockIdFlag[BlockIdFlag["Absent"] = 1] = "Absent";
    BlockIdFlag[BlockIdFlag["Commit"] = 2] = "Commit";
    BlockIdFlag[BlockIdFlag["Nil"] = 3] = "Nil";
    BlockIdFlag[BlockIdFlag["Unrecognized"] = -1] = "Unrecognized";
})(BlockIdFlag = exports.BlockIdFlag || (exports.BlockIdFlag = {}));
//# sourceMappingURL=types.js.map

/***/ }),

/***/ 19038:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.arrayContentStartsWith = exports.arrayContentEquals = void 0;
/**
 * Compares the content of two arrays-like objects for equality.
 *
 * Equality is defined as having equal length and element values, where element equality means `===` returning `true`.
 *
 * This allows you to compare the content of a Buffer, Uint8Array or number[], ignoring the specific type.
 * As a consequence, this returns different results than Jasmine's `toEqual`, which ensures elements have the same type.
 */
function arrayContentEquals(a, b) {
    if (a.length !== b.length)
        return false;
    for (let i = 0; i < a.length; ++i) {
        if (a[i] !== b[i])
            return false;
    }
    return true;
}
exports.arrayContentEquals = arrayContentEquals;
/**
 * Checks if `a` starts with the contents of `b`.
 *
 * This requires equality of the element values, where element equality means `===` returning `true`.
 *
 * This allows you to compare the content of a Buffer, Uint8Array or number[], ignoring the specific type.
 * As a consequence, this returns different results than Jasmine's `toEqual`, which ensures elements have the same type.
 */
function arrayContentStartsWith(a, b) {
    if (a.length < b.length)
        return false;
    for (let i = 0; i < b.length; ++i) {
        if (a[i] !== b[i])
            return false;
    }
    return true;
}
exports.arrayContentStartsWith = arrayContentStartsWith;
//# sourceMappingURL=arrays.js.map

/***/ }),

/***/ 43371:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.assertDefinedAndNotNull = exports.assertDefined = exports.assert = void 0;
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function assert(condition, msg) {
    if (!condition) {
        throw new Error(msg || "condition is not truthy");
    }
}
exports.assert = assert;
function assertDefined(value, msg) {
    if (value === undefined) {
        throw new Error(msg ?? "value is undefined");
    }
}
exports.assertDefined = assertDefined;
function assertDefinedAndNotNull(value, msg) {
    if (value === undefined || value === null) {
        throw new Error(msg ?? "value is undefined or null");
    }
}
exports.assertDefinedAndNotNull = assertDefinedAndNotNull;
//# sourceMappingURL=assert.js.map

/***/ }),

/***/ 62584:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.isUint8Array = exports.isNonNullObject = exports.isDefined = exports.sleep = exports.assertDefinedAndNotNull = exports.assertDefined = exports.assert = exports.arrayContentStartsWith = exports.arrayContentEquals = void 0;
var arrays_1 = __webpack_require__(19038);
Object.defineProperty(exports, "arrayContentEquals", ({ enumerable: true, get: function () { return arrays_1.arrayContentEquals; } }));
Object.defineProperty(exports, "arrayContentStartsWith", ({ enumerable: true, get: function () { return arrays_1.arrayContentStartsWith; } }));
var assert_1 = __webpack_require__(43371);
Object.defineProperty(exports, "assert", ({ enumerable: true, get: function () { return assert_1.assert; } }));
Object.defineProperty(exports, "assertDefined", ({ enumerable: true, get: function () { return assert_1.assertDefined; } }));
Object.defineProperty(exports, "assertDefinedAndNotNull", ({ enumerable: true, get: function () { return assert_1.assertDefinedAndNotNull; } }));
var sleep_1 = __webpack_require__(7072);
Object.defineProperty(exports, "sleep", ({ enumerable: true, get: function () { return sleep_1.sleep; } }));
var typechecks_1 = __webpack_require__(78801);
Object.defineProperty(exports, "isDefined", ({ enumerable: true, get: function () { return typechecks_1.isDefined; } }));
Object.defineProperty(exports, "isNonNullObject", ({ enumerable: true, get: function () { return typechecks_1.isNonNullObject; } }));
Object.defineProperty(exports, "isUint8Array", ({ enumerable: true, get: function () { return typechecks_1.isUint8Array; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 7072:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.sleep = void 0;
async function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
}
exports.sleep = sleep;
//# sourceMappingURL=sleep.js.map

/***/ }),

/***/ 78801:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/* provided dependency */ var Buffer = __webpack_require__(48764)["Buffer"];

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.isDefined = exports.isUint8Array = exports.isNonNullObject = void 0;
/**
 * Checks if data is a non-null object (i.e. matches the TypeScript object type).
 *
 * Note: this returns true for arrays, which are objects in JavaScript
 * even though array and object are different types in JSON.
 *
 * @see https://www.typescriptlang.org/docs/handbook/basic-types.html#object
 */
// eslint-disable-next-line @typescript-eslint/ban-types
function isNonNullObject(data) {
    return typeof data === "object" && data !== null;
}
exports.isNonNullObject = isNonNullObject;
/**
 * Checks if data is an Uint8Array. Note: Buffer is treated as not a Uint8Array
 */
function isUint8Array(data) {
    if (!isNonNullObject(data))
        return false;
    // Avoid instanceof check which is unreliable in some JS environments
    // https://medium.com/@simonwarta/limitations-of-the-instanceof-operator-f4bcdbe7a400
    // Use check that was discussed in https://github.com/crypto-browserify/pbkdf2/pull/81
    if (Object.prototype.toString.call(data) !== "[object Uint8Array]")
        return false;
    if (typeof Buffer !== "undefined" && typeof Buffer.isBuffer !== "undefined") {
        // Buffer.isBuffer is available at runtime
        if (Buffer.isBuffer(data))
            return false;
    }
    return true;
}
exports.isUint8Array = isUint8Array;
/**
 * Checks if input is not undefined in a TypeScript-friendly way.
 *
 * This is convenient to use in e.g. `Array.filter` as it will convert
 * the type of a `Array<Foo | undefined>` to `Array<Foo>`.
 */
function isDefined(value) {
    return value !== undefined;
}
exports.isDefined = isDefined;
//# sourceMappingURL=typechecks.js.map

/***/ }),

/***/ 64738:
/***/ (function(module) {

"use strict";

var ALPHABET = 'qpzry9x8gf2tvdw0s3jn54khce6mua7l'

// pre-compute lookup table
var ALPHABET_MAP = {}
for (var z = 0; z < ALPHABET.length; z++) {
  var x = ALPHABET.charAt(z)

  if (ALPHABET_MAP[x] !== undefined) throw new TypeError(x + ' is ambiguous')
  ALPHABET_MAP[x] = z
}

function polymodStep (pre) {
  var b = pre >> 25
  return ((pre & 0x1FFFFFF) << 5) ^
    (-((b >> 0) & 1) & 0x3b6a57b2) ^
    (-((b >> 1) & 1) & 0x26508e6d) ^
    (-((b >> 2) & 1) & 0x1ea119fa) ^
    (-((b >> 3) & 1) & 0x3d4233dd) ^
    (-((b >> 4) & 1) & 0x2a1462b3)
}

function prefixChk (prefix) {
  var chk = 1
  for (var i = 0; i < prefix.length; ++i) {
    var c = prefix.charCodeAt(i)
    if (c < 33 || c > 126) return 'Invalid prefix (' + prefix + ')'

    chk = polymodStep(chk) ^ (c >> 5)
  }
  chk = polymodStep(chk)

  for (i = 0; i < prefix.length; ++i) {
    var v = prefix.charCodeAt(i)
    chk = polymodStep(chk) ^ (v & 0x1f)
  }
  return chk
}

function encode (prefix, words, LIMIT) {
  LIMIT = LIMIT || 90
  if ((prefix.length + 7 + words.length) > LIMIT) throw new TypeError('Exceeds length limit')

  prefix = prefix.toLowerCase()

  // determine chk mod
  var chk = prefixChk(prefix)
  if (typeof chk === 'string') throw new Error(chk)

  var result = prefix + '1'
  for (var i = 0; i < words.length; ++i) {
    var x = words[i]
    if ((x >> 5) !== 0) throw new Error('Non 5-bit word')

    chk = polymodStep(chk) ^ x
    result += ALPHABET.charAt(x)
  }

  for (i = 0; i < 6; ++i) {
    chk = polymodStep(chk)
  }
  chk ^= 1

  for (i = 0; i < 6; ++i) {
    var v = (chk >> ((5 - i) * 5)) & 0x1f
    result += ALPHABET.charAt(v)
  }

  return result
}

function __decode (str, LIMIT) {
  LIMIT = LIMIT || 90
  if (str.length < 8) return str + ' too short'
  if (str.length > LIMIT) return 'Exceeds length limit'

  // don't allow mixed case
  var lowered = str.toLowerCase()
  var uppered = str.toUpperCase()
  if (str !== lowered && str !== uppered) return 'Mixed-case string ' + str
  str = lowered

  var split = str.lastIndexOf('1')
  if (split === -1) return 'No separator character for ' + str
  if (split === 0) return 'Missing prefix for ' + str

  var prefix = str.slice(0, split)
  var wordChars = str.slice(split + 1)
  if (wordChars.length < 6) return 'Data too short'

  var chk = prefixChk(prefix)
  if (typeof chk === 'string') return chk

  var words = []
  for (var i = 0; i < wordChars.length; ++i) {
    var c = wordChars.charAt(i)
    var v = ALPHABET_MAP[c]
    if (v === undefined) return 'Unknown character ' + c
    chk = polymodStep(chk) ^ v

    // not in the checksum?
    if (i + 6 >= wordChars.length) continue
    words.push(v)
  }

  if (chk !== 1) return 'Invalid checksum for ' + str
  return { prefix: prefix, words: words }
}

function decodeUnsafe () {
  var res = __decode.apply(null, arguments)
  if (typeof res === 'object') return res
}

function decode (str) {
  var res = __decode.apply(null, arguments)
  if (typeof res === 'object') return res

  throw new Error(res)
}

function convert (data, inBits, outBits, pad) {
  var value = 0
  var bits = 0
  var maxV = (1 << outBits) - 1

  var result = []
  for (var i = 0; i < data.length; ++i) {
    value = (value << inBits) | data[i]
    bits += inBits

    while (bits >= outBits) {
      bits -= outBits
      result.push((value >> bits) & maxV)
    }
  }

  if (pad) {
    if (bits > 0) {
      result.push((value << (outBits - bits)) & maxV)
    }
  } else {
    if (bits >= inBits) return 'Excess padding'
    if ((value << (outBits - bits)) & maxV) return 'Non-zero padding'
  }

  return result
}

function toWordsUnsafe (bytes) {
  var res = convert(bytes, 8, 5, true)
  if (Array.isArray(res)) return res
}

function toWords (bytes) {
  var res = convert(bytes, 8, 5, true)
  if (Array.isArray(res)) return res

  throw new Error(res)
}

function fromWordsUnsafe (words) {
  var res = convert(words, 5, 8, false)
  if (Array.isArray(res)) return res
}

function fromWords (words) {
  var res = convert(words, 5, 8, false)
  if (Array.isArray(res)) return res

  throw new Error(res)
}

module.exports = {
  decodeUnsafe: decodeUnsafe,
  decode: decode,
  encode: encode,
  toWordsUnsafe: toWordsUnsafe,
  toWords: toWords,
  fromWordsUnsafe: fromWordsUnsafe,
  fromWords: fromWords
}


/***/ }),

/***/ 13394:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Params = exports.ModuleCredential = exports.ModuleAccount = exports.BaseAccount = exports.protobufPackage = void 0;
/* eslint-disable */
const any_1 = __webpack_require__(75654);
const helpers_1 = __webpack_require__(92654);
const _m0 = __importStar(__webpack_require__(62100));
exports.protobufPackage = "cosmos.auth.v1beta1";
function createBaseBaseAccount() {
    return {
        address: "",
        pubKey: undefined,
        accountNumber: helpers_1.Long.UZERO,
        sequence: helpers_1.Long.UZERO,
    };
}
exports.BaseAccount = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.address !== "") {
            writer.uint32(10).string(message.address);
        }
        if (message.pubKey !== undefined) {
            any_1.Any.encode(message.pubKey, writer.uint32(18).fork()).ldelim();
        }
        if (!message.accountNumber.isZero()) {
            writer.uint32(24).uint64(message.accountNumber);
        }
        if (!message.sequence.isZero()) {
            writer.uint32(32).uint64(message.sequence);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseBaseAccount();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.pubKey = any_1.Any.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.accountNumber = reader.uint64();
                    break;
                case 4:
                    message.sequence = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            address: (0, helpers_1.isSet)(object.address) ? String(object.address) : "",
            pubKey: (0, helpers_1.isSet)(object.pubKey) ? any_1.Any.fromJSON(object.pubKey) : undefined,
            accountNumber: (0, helpers_1.isSet)(object.accountNumber) ? helpers_1.Long.fromValue(object.accountNumber) : helpers_1.Long.UZERO,
            sequence: (0, helpers_1.isSet)(object.sequence) ? helpers_1.Long.fromValue(object.sequence) : helpers_1.Long.UZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.pubKey !== undefined && (obj.pubKey = message.pubKey ? any_1.Any.toJSON(message.pubKey) : undefined);
        message.accountNumber !== undefined &&
            (obj.accountNumber = (message.accountNumber || helpers_1.Long.UZERO).toString());
        message.sequence !== undefined && (obj.sequence = (message.sequence || helpers_1.Long.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseBaseAccount();
        message.address = object.address ?? "";
        message.pubKey =
            object.pubKey !== undefined && object.pubKey !== null ? any_1.Any.fromPartial(object.pubKey) : undefined;
        message.accountNumber =
            object.accountNumber !== undefined && object.accountNumber !== null
                ? helpers_1.Long.fromValue(object.accountNumber)
                : helpers_1.Long.UZERO;
        message.sequence =
            object.sequence !== undefined && object.sequence !== null
                ? helpers_1.Long.fromValue(object.sequence)
                : helpers_1.Long.UZERO;
        return message;
    },
};
function createBaseModuleAccount() {
    return {
        baseAccount: undefined,
        name: "",
        permissions: [],
    };
}
exports.ModuleAccount = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.baseAccount !== undefined) {
            exports.BaseAccount.encode(message.baseAccount, writer.uint32(10).fork()).ldelim();
        }
        if (message.name !== "") {
            writer.uint32(18).string(message.name);
        }
        for (const v of message.permissions) {
            writer.uint32(26).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseModuleAccount();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.baseAccount = exports.BaseAccount.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.name = reader.string();
                    break;
                case 3:
                    message.permissions.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            baseAccount: (0, helpers_1.isSet)(object.baseAccount) ? exports.BaseAccount.fromJSON(object.baseAccount) : undefined,
            name: (0, helpers_1.isSet)(object.name) ? String(object.name) : "",
            permissions: Array.isArray(object?.permissions) ? object.permissions.map((e) => String(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        message.baseAccount !== undefined &&
            (obj.baseAccount = message.baseAccount ? exports.BaseAccount.toJSON(message.baseAccount) : undefined);
        message.name !== undefined && (obj.name = message.name);
        if (message.permissions) {
            obj.permissions = message.permissions.map((e) => e);
        }
        else {
            obj.permissions = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseModuleAccount();
        message.baseAccount =
            object.baseAccount !== undefined && object.baseAccount !== null
                ? exports.BaseAccount.fromPartial(object.baseAccount)
                : undefined;
        message.name = object.name ?? "";
        message.permissions = object.permissions?.map((e) => e) || [];
        return message;
    },
};
function createBaseModuleCredential() {
    return {
        moduleName: "",
        derivationKeys: [],
    };
}
exports.ModuleCredential = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.moduleName !== "") {
            writer.uint32(10).string(message.moduleName);
        }
        for (const v of message.derivationKeys) {
            writer.uint32(18).bytes(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseModuleCredential();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.moduleName = reader.string();
                    break;
                case 2:
                    message.derivationKeys.push(reader.bytes());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            moduleName: (0, helpers_1.isSet)(object.moduleName) ? String(object.moduleName) : "",
            derivationKeys: Array.isArray(object?.derivationKeys)
                ? object.derivationKeys.map((e) => (0, helpers_1.bytesFromBase64)(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        message.moduleName !== undefined && (obj.moduleName = message.moduleName);
        if (message.derivationKeys) {
            obj.derivationKeys = message.derivationKeys.map((e) => (0, helpers_1.base64FromBytes)(e !== undefined ? e : new Uint8Array()));
        }
        else {
            obj.derivationKeys = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseModuleCredential();
        message.moduleName = object.moduleName ?? "";
        message.derivationKeys = object.derivationKeys?.map((e) => e) || [];
        return message;
    },
};
function createBaseParams() {
    return {
        maxMemoCharacters: helpers_1.Long.UZERO,
        txSigLimit: helpers_1.Long.UZERO,
        txSizeCostPerByte: helpers_1.Long.UZERO,
        sigVerifyCostEd25519: helpers_1.Long.UZERO,
        sigVerifyCostSecp256k1: helpers_1.Long.UZERO,
    };
}
exports.Params = {
    encode(message, writer = _m0.Writer.create()) {
        if (!message.maxMemoCharacters.isZero()) {
            writer.uint32(8).uint64(message.maxMemoCharacters);
        }
        if (!message.txSigLimit.isZero()) {
            writer.uint32(16).uint64(message.txSigLimit);
        }
        if (!message.txSizeCostPerByte.isZero()) {
            writer.uint32(24).uint64(message.txSizeCostPerByte);
        }
        if (!message.sigVerifyCostEd25519.isZero()) {
            writer.uint32(32).uint64(message.sigVerifyCostEd25519);
        }
        if (!message.sigVerifyCostSecp256k1.isZero()) {
            writer.uint32(40).uint64(message.sigVerifyCostSecp256k1);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseParams();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.maxMemoCharacters = reader.uint64();
                    break;
                case 2:
                    message.txSigLimit = reader.uint64();
                    break;
                case 3:
                    message.txSizeCostPerByte = reader.uint64();
                    break;
                case 4:
                    message.sigVerifyCostEd25519 = reader.uint64();
                    break;
                case 5:
                    message.sigVerifyCostSecp256k1 = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            maxMemoCharacters: (0, helpers_1.isSet)(object.maxMemoCharacters)
                ? helpers_1.Long.fromValue(object.maxMemoCharacters)
                : helpers_1.Long.UZERO,
            txSigLimit: (0, helpers_1.isSet)(object.txSigLimit) ? helpers_1.Long.fromValue(object.txSigLimit) : helpers_1.Long.UZERO,
            txSizeCostPerByte: (0, helpers_1.isSet)(object.txSizeCostPerByte)
                ? helpers_1.Long.fromValue(object.txSizeCostPerByte)
                : helpers_1.Long.UZERO,
            sigVerifyCostEd25519: (0, helpers_1.isSet)(object.sigVerifyCostEd25519)
                ? helpers_1.Long.fromValue(object.sigVerifyCostEd25519)
                : helpers_1.Long.UZERO,
            sigVerifyCostSecp256k1: (0, helpers_1.isSet)(object.sigVerifyCostSecp256k1)
                ? helpers_1.Long.fromValue(object.sigVerifyCostSecp256k1)
                : helpers_1.Long.UZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        message.maxMemoCharacters !== undefined &&
            (obj.maxMemoCharacters = (message.maxMemoCharacters || helpers_1.Long.UZERO).toString());
        message.txSigLimit !== undefined && (obj.txSigLimit = (message.txSigLimit || helpers_1.Long.UZERO).toString());
        message.txSizeCostPerByte !== undefined &&
            (obj.txSizeCostPerByte = (message.txSizeCostPerByte || helpers_1.Long.UZERO).toString());
        message.sigVerifyCostEd25519 !== undefined &&
            (obj.sigVerifyCostEd25519 = (message.sigVerifyCostEd25519 || helpers_1.Long.UZERO).toString());
        message.sigVerifyCostSecp256k1 !== undefined &&
            (obj.sigVerifyCostSecp256k1 = (message.sigVerifyCostSecp256k1 || helpers_1.Long.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseParams();
        message.maxMemoCharacters =
            object.maxMemoCharacters !== undefined && object.maxMemoCharacters !== null
                ? helpers_1.Long.fromValue(object.maxMemoCharacters)
                : helpers_1.Long.UZERO;
        message.txSigLimit =
            object.txSigLimit !== undefined && object.txSigLimit !== null
                ? helpers_1.Long.fromValue(object.txSigLimit)
                : helpers_1.Long.UZERO;
        message.txSizeCostPerByte =
            object.txSizeCostPerByte !== undefined && object.txSizeCostPerByte !== null
                ? helpers_1.Long.fromValue(object.txSizeCostPerByte)
                : helpers_1.Long.UZERO;
        message.sigVerifyCostEd25519 =
            object.sigVerifyCostEd25519 !== undefined && object.sigVerifyCostEd25519 !== null
                ? helpers_1.Long.fromValue(object.sigVerifyCostEd25519)
                : helpers_1.Long.UZERO;
        message.sigVerifyCostSecp256k1 =
            object.sigVerifyCostSecp256k1 !== undefined && object.sigVerifyCostSecp256k1 !== null
                ? helpers_1.Long.fromValue(object.sigVerifyCostSecp256k1)
                : helpers_1.Long.UZERO;
        return message;
    },
};
//# sourceMappingURL=auth.js.map

/***/ }),

/***/ 23043:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.QueryClientImpl = exports.QueryAccountInfoResponse = exports.QueryAccountInfoRequest = exports.QueryAccountAddressByIDResponse = exports.QueryAccountAddressByIDRequest = exports.AddressStringToBytesResponse = exports.AddressStringToBytesRequest = exports.AddressBytesToStringResponse = exports.AddressBytesToStringRequest = exports.Bech32PrefixResponse = exports.Bech32PrefixRequest = exports.QueryModuleAccountByNameResponse = exports.QueryModuleAccountByNameRequest = exports.QueryModuleAccountsResponse = exports.QueryModuleAccountsRequest = exports.QueryParamsResponse = exports.QueryParamsRequest = exports.QueryAccountResponse = exports.QueryAccountRequest = exports.QueryAccountsResponse = exports.QueryAccountsRequest = exports.protobufPackage = void 0;
/* eslint-disable */
const pagination_1 = __webpack_require__(84043);
const any_1 = __webpack_require__(75654);
const auth_1 = __webpack_require__(13394);
const helpers_1 = __webpack_require__(92654);
const _m0 = __importStar(__webpack_require__(62100));
exports.protobufPackage = "cosmos.auth.v1beta1";
function createBaseQueryAccountsRequest() {
    return {
        pagination: undefined,
    };
}
exports.QueryAccountsRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryAccountsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            pagination: (0, helpers_1.isSet)(object.pagination) ? pagination_1.PageRequest.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryAccountsRequest();
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryAccountsResponse() {
    return {
        accounts: [],
        pagination: undefined,
    };
}
exports.QueryAccountsResponse = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.accounts) {
            any_1.Any.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryAccountsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.accounts.push(any_1.Any.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            accounts: Array.isArray(object?.accounts) ? object.accounts.map((e) => any_1.Any.fromJSON(e)) : [],
            pagination: (0, helpers_1.isSet)(object.pagination) ? pagination_1.PageResponse.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.accounts) {
            obj.accounts = message.accounts.map((e) => (e ? any_1.Any.toJSON(e) : undefined));
        }
        else {
            obj.accounts = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryAccountsResponse();
        message.accounts = object.accounts?.map((e) => any_1.Any.fromPartial(e)) || [];
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryAccountRequest() {
    return {
        address: "",
    };
}
exports.QueryAccountRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.address !== "") {
            writer.uint32(10).string(message.address);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryAccountRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.address = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            address: (0, helpers_1.isSet)(object.address) ? String(object.address) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryAccountRequest();
        message.address = object.address ?? "";
        return message;
    },
};
function createBaseQueryAccountResponse() {
    return {
        account: undefined,
    };
}
exports.QueryAccountResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.account !== undefined) {
            any_1.Any.encode(message.account, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryAccountResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.account = any_1.Any.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            account: (0, helpers_1.isSet)(object.account) ? any_1.Any.fromJSON(object.account) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.account !== undefined &&
            (obj.account = message.account ? any_1.Any.toJSON(message.account) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryAccountResponse();
        message.account =
            object.account !== undefined && object.account !== null ? any_1.Any.fromPartial(object.account) : undefined;
        return message;
    },
};
function createBaseQueryParamsRequest() {
    return {};
}
exports.QueryParamsRequest = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryParamsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseQueryParamsRequest();
        return message;
    },
};
function createBaseQueryParamsResponse() {
    return {
        params: undefined,
    };
}
exports.QueryParamsResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.params !== undefined) {
            auth_1.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryParamsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.params = auth_1.Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            params: (0, helpers_1.isSet)(object.params) ? auth_1.Params.fromJSON(object.params) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.params !== undefined && (obj.params = message.params ? auth_1.Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryParamsResponse();
        message.params =
            object.params !== undefined && object.params !== null ? auth_1.Params.fromPartial(object.params) : undefined;
        return message;
    },
};
function createBaseQueryModuleAccountsRequest() {
    return {};
}
exports.QueryModuleAccountsRequest = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryModuleAccountsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseQueryModuleAccountsRequest();
        return message;
    },
};
function createBaseQueryModuleAccountsResponse() {
    return {
        accounts: [],
    };
}
exports.QueryModuleAccountsResponse = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.accounts) {
            any_1.Any.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryModuleAccountsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.accounts.push(any_1.Any.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            accounts: Array.isArray(object?.accounts) ? object.accounts.map((e) => any_1.Any.fromJSON(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.accounts) {
            obj.accounts = message.accounts.map((e) => (e ? any_1.Any.toJSON(e) : undefined));
        }
        else {
            obj.accounts = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryModuleAccountsResponse();
        message.accounts = object.accounts?.map((e) => any_1.Any.fromPartial(e)) || [];
        return message;
    },
};
function createBaseQueryModuleAccountByNameRequest() {
    return {
        name: "",
    };
}
exports.QueryModuleAccountByNameRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.name !== "") {
            writer.uint32(10).string(message.name);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryModuleAccountByNameRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.name = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            name: (0, helpers_1.isSet)(object.name) ? String(object.name) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.name !== undefined && (obj.name = message.name);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryModuleAccountByNameRequest();
        message.name = object.name ?? "";
        return message;
    },
};
function createBaseQueryModuleAccountByNameResponse() {
    return {
        account: undefined,
    };
}
exports.QueryModuleAccountByNameResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.account !== undefined) {
            any_1.Any.encode(message.account, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryModuleAccountByNameResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.account = any_1.Any.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            account: (0, helpers_1.isSet)(object.account) ? any_1.Any.fromJSON(object.account) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.account !== undefined &&
            (obj.account = message.account ? any_1.Any.toJSON(message.account) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryModuleAccountByNameResponse();
        message.account =
            object.account !== undefined && object.account !== null ? any_1.Any.fromPartial(object.account) : undefined;
        return message;
    },
};
function createBaseBech32PrefixRequest() {
    return {};
}
exports.Bech32PrefixRequest = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseBech32PrefixRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseBech32PrefixRequest();
        return message;
    },
};
function createBaseBech32PrefixResponse() {
    return {
        bech32Prefix: "",
    };
}
exports.Bech32PrefixResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.bech32Prefix !== "") {
            writer.uint32(10).string(message.bech32Prefix);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseBech32PrefixResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.bech32Prefix = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            bech32Prefix: (0, helpers_1.isSet)(object.bech32Prefix) ? String(object.bech32Prefix) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.bech32Prefix !== undefined && (obj.bech32Prefix = message.bech32Prefix);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseBech32PrefixResponse();
        message.bech32Prefix = object.bech32Prefix ?? "";
        return message;
    },
};
function createBaseAddressBytesToStringRequest() {
    return {
        addressBytes: new Uint8Array(),
    };
}
exports.AddressBytesToStringRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.addressBytes.length !== 0) {
            writer.uint32(10).bytes(message.addressBytes);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAddressBytesToStringRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.addressBytes = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            addressBytes: (0, helpers_1.isSet)(object.addressBytes) ? (0, helpers_1.bytesFromBase64)(object.addressBytes) : new Uint8Array(),
        };
    },
    toJSON(message) {
        const obj = {};
        message.addressBytes !== undefined &&
            (obj.addressBytes = (0, helpers_1.base64FromBytes)(message.addressBytes !== undefined ? message.addressBytes : new Uint8Array()));
        return obj;
    },
    fromPartial(object) {
        const message = createBaseAddressBytesToStringRequest();
        message.addressBytes = object.addressBytes ?? new Uint8Array();
        return message;
    },
};
function createBaseAddressBytesToStringResponse() {
    return {
        addressString: "",
    };
}
exports.AddressBytesToStringResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.addressString !== "") {
            writer.uint32(10).string(message.addressString);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAddressBytesToStringResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.addressString = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            addressString: (0, helpers_1.isSet)(object.addressString) ? String(object.addressString) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.addressString !== undefined && (obj.addressString = message.addressString);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseAddressBytesToStringResponse();
        message.addressString = object.addressString ?? "";
        return message;
    },
};
function createBaseAddressStringToBytesRequest() {
    return {
        addressString: "",
    };
}
exports.AddressStringToBytesRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.addressString !== "") {
            writer.uint32(10).string(message.addressString);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAddressStringToBytesRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.addressString = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            addressString: (0, helpers_1.isSet)(object.addressString) ? String(object.addressString) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.addressString !== undefined && (obj.addressString = message.addressString);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseAddressStringToBytesRequest();
        message.addressString = object.addressString ?? "";
        return message;
    },
};
function createBaseAddressStringToBytesResponse() {
    return {
        addressBytes: new Uint8Array(),
    };
}
exports.AddressStringToBytesResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.addressBytes.length !== 0) {
            writer.uint32(10).bytes(message.addressBytes);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAddressStringToBytesResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.addressBytes = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            addressBytes: (0, helpers_1.isSet)(object.addressBytes) ? (0, helpers_1.bytesFromBase64)(object.addressBytes) : new Uint8Array(),
        };
    },
    toJSON(message) {
        const obj = {};
        message.addressBytes !== undefined &&
            (obj.addressBytes = (0, helpers_1.base64FromBytes)(message.addressBytes !== undefined ? message.addressBytes : new Uint8Array()));
        return obj;
    },
    fromPartial(object) {
        const message = createBaseAddressStringToBytesResponse();
        message.addressBytes = object.addressBytes ?? new Uint8Array();
        return message;
    },
};
function createBaseQueryAccountAddressByIDRequest() {
    return {
        id: helpers_1.Long.ZERO,
        accountId: helpers_1.Long.UZERO,
    };
}
exports.QueryAccountAddressByIDRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (!message.id.isZero()) {
            writer.uint32(8).int64(message.id);
        }
        if (!message.accountId.isZero()) {
            writer.uint32(16).uint64(message.accountId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryAccountAddressByIDRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.id = reader.int64();
                    break;
                case 2:
                    message.accountId = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            id: (0, helpers_1.isSet)(object.id) ? helpers_1.Long.fromValue(object.id) : helpers_1.Long.ZERO,
            accountId: (0, helpers_1.isSet)(object.accountId) ? helpers_1.Long.fromValue(object.accountId) : helpers_1.Long.UZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        message.id !== undefined && (obj.id = (message.id || helpers_1.Long.ZERO).toString());
        message.accountId !== undefined && (obj.accountId = (message.accountId || helpers_1.Long.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryAccountAddressByIDRequest();
        message.id = object.id !== undefined && object.id !== null ? helpers_1.Long.fromValue(object.id) : helpers_1.Long.ZERO;
        message.accountId =
            object.accountId !== undefined && object.accountId !== null
                ? helpers_1.Long.fromValue(object.accountId)
                : helpers_1.Long.UZERO;
        return message;
    },
};
function createBaseQueryAccountAddressByIDResponse() {
    return {
        accountAddress: "",
    };
}
exports.QueryAccountAddressByIDResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.accountAddress !== "") {
            writer.uint32(10).string(message.accountAddress);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryAccountAddressByIDResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.accountAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            accountAddress: (0, helpers_1.isSet)(object.accountAddress) ? String(object.accountAddress) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.accountAddress !== undefined && (obj.accountAddress = message.accountAddress);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryAccountAddressByIDResponse();
        message.accountAddress = object.accountAddress ?? "";
        return message;
    },
};
function createBaseQueryAccountInfoRequest() {
    return {
        address: "",
    };
}
exports.QueryAccountInfoRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.address !== "") {
            writer.uint32(10).string(message.address);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryAccountInfoRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.address = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            address: (0, helpers_1.isSet)(object.address) ? String(object.address) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryAccountInfoRequest();
        message.address = object.address ?? "";
        return message;
    },
};
function createBaseQueryAccountInfoResponse() {
    return {
        info: undefined,
    };
}
exports.QueryAccountInfoResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.info !== undefined) {
            auth_1.BaseAccount.encode(message.info, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryAccountInfoResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.info = auth_1.BaseAccount.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            info: (0, helpers_1.isSet)(object.info) ? auth_1.BaseAccount.fromJSON(object.info) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.info !== undefined && (obj.info = message.info ? auth_1.BaseAccount.toJSON(message.info) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryAccountInfoResponse();
        message.info =
            object.info !== undefined && object.info !== null ? auth_1.BaseAccount.fromPartial(object.info) : undefined;
        return message;
    },
};
class QueryClientImpl {
    constructor(rpc) {
        this.rpc = rpc;
        this.Accounts = this.Accounts.bind(this);
        this.Account = this.Account.bind(this);
        this.AccountAddressByID = this.AccountAddressByID.bind(this);
        this.Params = this.Params.bind(this);
        this.ModuleAccounts = this.ModuleAccounts.bind(this);
        this.ModuleAccountByName = this.ModuleAccountByName.bind(this);
        this.Bech32Prefix = this.Bech32Prefix.bind(this);
        this.AddressBytesToString = this.AddressBytesToString.bind(this);
        this.AddressStringToBytes = this.AddressStringToBytes.bind(this);
        this.AccountInfo = this.AccountInfo.bind(this);
    }
    Accounts(request = {
        pagination: undefined,
    }) {
        const data = exports.QueryAccountsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.auth.v1beta1.Query", "Accounts", data);
        return promise.then((data) => exports.QueryAccountsResponse.decode(new _m0.Reader(data)));
    }
    Account(request) {
        const data = exports.QueryAccountRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.auth.v1beta1.Query", "Account", data);
        return promise.then((data) => exports.QueryAccountResponse.decode(new _m0.Reader(data)));
    }
    AccountAddressByID(request) {
        const data = exports.QueryAccountAddressByIDRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.auth.v1beta1.Query", "AccountAddressByID", data);
        return promise.then((data) => exports.QueryAccountAddressByIDResponse.decode(new _m0.Reader(data)));
    }
    Params(request = {}) {
        const data = exports.QueryParamsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.auth.v1beta1.Query", "Params", data);
        return promise.then((data) => exports.QueryParamsResponse.decode(new _m0.Reader(data)));
    }
    ModuleAccounts(request = {}) {
        const data = exports.QueryModuleAccountsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.auth.v1beta1.Query", "ModuleAccounts", data);
        return promise.then((data) => exports.QueryModuleAccountsResponse.decode(new _m0.Reader(data)));
    }
    ModuleAccountByName(request) {
        const data = exports.QueryModuleAccountByNameRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.auth.v1beta1.Query", "ModuleAccountByName", data);
        return promise.then((data) => exports.QueryModuleAccountByNameResponse.decode(new _m0.Reader(data)));
    }
    Bech32Prefix(request = {}) {
        const data = exports.Bech32PrefixRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.auth.v1beta1.Query", "Bech32Prefix", data);
        return promise.then((data) => exports.Bech32PrefixResponse.decode(new _m0.Reader(data)));
    }
    AddressBytesToString(request) {
        const data = exports.AddressBytesToStringRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.auth.v1beta1.Query", "AddressBytesToString", data);
        return promise.then((data) => exports.AddressBytesToStringResponse.decode(new _m0.Reader(data)));
    }
    AddressStringToBytes(request) {
        const data = exports.AddressStringToBytesRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.auth.v1beta1.Query", "AddressStringToBytes", data);
        return promise.then((data) => exports.AddressStringToBytesResponse.decode(new _m0.Reader(data)));
    }
    AccountInfo(request) {
        const data = exports.QueryAccountInfoRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.auth.v1beta1.Query", "AccountInfo", data);
        return promise.then((data) => exports.QueryAccountInfoResponse.decode(new _m0.Reader(data)));
    }
}
exports.QueryClientImpl = QueryClientImpl;
//# sourceMappingURL=query.js.map

/***/ }),

/***/ 69046:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.GrantQueueItem = exports.GrantAuthorization = exports.Grant = exports.GenericAuthorization = exports.protobufPackage = void 0;
/* eslint-disable */
const any_1 = __webpack_require__(75654);
const timestamp_1 = __webpack_require__(70147);
const _m0 = __importStar(__webpack_require__(62100));
const helpers_1 = __webpack_require__(92654);
exports.protobufPackage = "cosmos.authz.v1beta1";
function createBaseGenericAuthorization() {
    return {
        msg: "",
    };
}
exports.GenericAuthorization = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.msg !== "") {
            writer.uint32(10).string(message.msg);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGenericAuthorization();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.msg = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            msg: (0, helpers_1.isSet)(object.msg) ? String(object.msg) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.msg !== undefined && (obj.msg = message.msg);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseGenericAuthorization();
        message.msg = object.msg ?? "";
        return message;
    },
};
function createBaseGrant() {
    return {
        authorization: undefined,
        expiration: undefined,
    };
}
exports.Grant = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.authorization !== undefined) {
            any_1.Any.encode(message.authorization, writer.uint32(10).fork()).ldelim();
        }
        if (message.expiration !== undefined) {
            timestamp_1.Timestamp.encode(message.expiration, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGrant();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.authorization = any_1.Any.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.expiration = timestamp_1.Timestamp.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            authorization: (0, helpers_1.isSet)(object.authorization) ? any_1.Any.fromJSON(object.authorization) : undefined,
            expiration: (0, helpers_1.isSet)(object.expiration) ? (0, helpers_1.fromJsonTimestamp)(object.expiration) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.authorization !== undefined &&
            (obj.authorization = message.authorization ? any_1.Any.toJSON(message.authorization) : undefined);
        message.expiration !== undefined && (obj.expiration = (0, helpers_1.fromTimestamp)(message.expiration).toISOString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseGrant();
        message.authorization =
            object.authorization !== undefined && object.authorization !== null
                ? any_1.Any.fromPartial(object.authorization)
                : undefined;
        message.expiration =
            object.expiration !== undefined && object.expiration !== null
                ? timestamp_1.Timestamp.fromPartial(object.expiration)
                : undefined;
        return message;
    },
};
function createBaseGrantAuthorization() {
    return {
        granter: "",
        grantee: "",
        authorization: undefined,
        expiration: undefined,
    };
}
exports.GrantAuthorization = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.granter !== "") {
            writer.uint32(10).string(message.granter);
        }
        if (message.grantee !== "") {
            writer.uint32(18).string(message.grantee);
        }
        if (message.authorization !== undefined) {
            any_1.Any.encode(message.authorization, writer.uint32(26).fork()).ldelim();
        }
        if (message.expiration !== undefined) {
            timestamp_1.Timestamp.encode(message.expiration, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGrantAuthorization();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.granter = reader.string();
                    break;
                case 2:
                    message.grantee = reader.string();
                    break;
                case 3:
                    message.authorization = any_1.Any.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.expiration = timestamp_1.Timestamp.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            granter: (0, helpers_1.isSet)(object.granter) ? String(object.granter) : "",
            grantee: (0, helpers_1.isSet)(object.grantee) ? String(object.grantee) : "",
            authorization: (0, helpers_1.isSet)(object.authorization) ? any_1.Any.fromJSON(object.authorization) : undefined,
            expiration: (0, helpers_1.isSet)(object.expiration) ? (0, helpers_1.fromJsonTimestamp)(object.expiration) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.granter !== undefined && (obj.granter = message.granter);
        message.grantee !== undefined && (obj.grantee = message.grantee);
        message.authorization !== undefined &&
            (obj.authorization = message.authorization ? any_1.Any.toJSON(message.authorization) : undefined);
        message.expiration !== undefined && (obj.expiration = (0, helpers_1.fromTimestamp)(message.expiration).toISOString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseGrantAuthorization();
        message.granter = object.granter ?? "";
        message.grantee = object.grantee ?? "";
        message.authorization =
            object.authorization !== undefined && object.authorization !== null
                ? any_1.Any.fromPartial(object.authorization)
                : undefined;
        message.expiration =
            object.expiration !== undefined && object.expiration !== null
                ? timestamp_1.Timestamp.fromPartial(object.expiration)
                : undefined;
        return message;
    },
};
function createBaseGrantQueueItem() {
    return {
        msgTypeUrls: [],
    };
}
exports.GrantQueueItem = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.msgTypeUrls) {
            writer.uint32(10).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGrantQueueItem();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.msgTypeUrls.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            msgTypeUrls: Array.isArray(object?.msgTypeUrls) ? object.msgTypeUrls.map((e) => String(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.msgTypeUrls) {
            obj.msgTypeUrls = message.msgTypeUrls.map((e) => e);
        }
        else {
            obj.msgTypeUrls = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseGrantQueueItem();
        message.msgTypeUrls = object.msgTypeUrls?.map((e) => e) || [];
        return message;
    },
};
//# sourceMappingURL=authz.js.map

/***/ }),

/***/ 80150:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.QueryClientImpl = exports.QueryGranteeGrantsResponse = exports.QueryGranteeGrantsRequest = exports.QueryGranterGrantsResponse = exports.QueryGranterGrantsRequest = exports.QueryGrantsResponse = exports.QueryGrantsRequest = exports.protobufPackage = void 0;
/* eslint-disable */
const pagination_1 = __webpack_require__(84043);
const authz_1 = __webpack_require__(69046);
const _m0 = __importStar(__webpack_require__(62100));
const helpers_1 = __webpack_require__(92654);
exports.protobufPackage = "cosmos.authz.v1beta1";
function createBaseQueryGrantsRequest() {
    return {
        granter: "",
        grantee: "",
        msgTypeUrl: "",
        pagination: undefined,
    };
}
exports.QueryGrantsRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.granter !== "") {
            writer.uint32(10).string(message.granter);
        }
        if (message.grantee !== "") {
            writer.uint32(18).string(message.grantee);
        }
        if (message.msgTypeUrl !== "") {
            writer.uint32(26).string(message.msgTypeUrl);
        }
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryGrantsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.granter = reader.string();
                    break;
                case 2:
                    message.grantee = reader.string();
                    break;
                case 3:
                    message.msgTypeUrl = reader.string();
                    break;
                case 4:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            granter: (0, helpers_1.isSet)(object.granter) ? String(object.granter) : "",
            grantee: (0, helpers_1.isSet)(object.grantee) ? String(object.grantee) : "",
            msgTypeUrl: (0, helpers_1.isSet)(object.msgTypeUrl) ? String(object.msgTypeUrl) : "",
            pagination: (0, helpers_1.isSet)(object.pagination) ? pagination_1.PageRequest.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.granter !== undefined && (obj.granter = message.granter);
        message.grantee !== undefined && (obj.grantee = message.grantee);
        message.msgTypeUrl !== undefined && (obj.msgTypeUrl = message.msgTypeUrl);
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryGrantsRequest();
        message.granter = object.granter ?? "";
        message.grantee = object.grantee ?? "";
        message.msgTypeUrl = object.msgTypeUrl ?? "";
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryGrantsResponse() {
    return {
        grants: [],
        pagination: undefined,
    };
}
exports.QueryGrantsResponse = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.grants) {
            authz_1.Grant.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryGrantsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.grants.push(authz_1.Grant.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            grants: Array.isArray(object?.grants) ? object.grants.map((e) => authz_1.Grant.fromJSON(e)) : [],
            pagination: (0, helpers_1.isSet)(object.pagination) ? pagination_1.PageResponse.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.grants) {
            obj.grants = message.grants.map((e) => (e ? authz_1.Grant.toJSON(e) : undefined));
        }
        else {
            obj.grants = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryGrantsResponse();
        message.grants = object.grants?.map((e) => authz_1.Grant.fromPartial(e)) || [];
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryGranterGrantsRequest() {
    return {
        granter: "",
        pagination: undefined,
    };
}
exports.QueryGranterGrantsRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.granter !== "") {
            writer.uint32(10).string(message.granter);
        }
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryGranterGrantsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.granter = reader.string();
                    break;
                case 2:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            granter: (0, helpers_1.isSet)(object.granter) ? String(object.granter) : "",
            pagination: (0, helpers_1.isSet)(object.pagination) ? pagination_1.PageRequest.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.granter !== undefined && (obj.granter = message.granter);
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryGranterGrantsRequest();
        message.granter = object.granter ?? "";
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryGranterGrantsResponse() {
    return {
        grants: [],
        pagination: undefined,
    };
}
exports.QueryGranterGrantsResponse = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.grants) {
            authz_1.GrantAuthorization.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryGranterGrantsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.grants.push(authz_1.GrantAuthorization.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            grants: Array.isArray(object?.grants)
                ? object.grants.map((e) => authz_1.GrantAuthorization.fromJSON(e))
                : [],
            pagination: (0, helpers_1.isSet)(object.pagination) ? pagination_1.PageResponse.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.grants) {
            obj.grants = message.grants.map((e) => (e ? authz_1.GrantAuthorization.toJSON(e) : undefined));
        }
        else {
            obj.grants = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryGranterGrantsResponse();
        message.grants = object.grants?.map((e) => authz_1.GrantAuthorization.fromPartial(e)) || [];
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryGranteeGrantsRequest() {
    return {
        grantee: "",
        pagination: undefined,
    };
}
exports.QueryGranteeGrantsRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.grantee !== "") {
            writer.uint32(10).string(message.grantee);
        }
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryGranteeGrantsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.grantee = reader.string();
                    break;
                case 2:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            grantee: (0, helpers_1.isSet)(object.grantee) ? String(object.grantee) : "",
            pagination: (0, helpers_1.isSet)(object.pagination) ? pagination_1.PageRequest.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.grantee !== undefined && (obj.grantee = message.grantee);
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryGranteeGrantsRequest();
        message.grantee = object.grantee ?? "";
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryGranteeGrantsResponse() {
    return {
        grants: [],
        pagination: undefined,
    };
}
exports.QueryGranteeGrantsResponse = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.grants) {
            authz_1.GrantAuthorization.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryGranteeGrantsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.grants.push(authz_1.GrantAuthorization.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            grants: Array.isArray(object?.grants)
                ? object.grants.map((e) => authz_1.GrantAuthorization.fromJSON(e))
                : [],
            pagination: (0, helpers_1.isSet)(object.pagination) ? pagination_1.PageResponse.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.grants) {
            obj.grants = message.grants.map((e) => (e ? authz_1.GrantAuthorization.toJSON(e) : undefined));
        }
        else {
            obj.grants = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryGranteeGrantsResponse();
        message.grants = object.grants?.map((e) => authz_1.GrantAuthorization.fromPartial(e)) || [];
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
class QueryClientImpl {
    constructor(rpc) {
        this.rpc = rpc;
        this.Grants = this.Grants.bind(this);
        this.GranterGrants = this.GranterGrants.bind(this);
        this.GranteeGrants = this.GranteeGrants.bind(this);
    }
    Grants(request) {
        const data = exports.QueryGrantsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.authz.v1beta1.Query", "Grants", data);
        return promise.then((data) => exports.QueryGrantsResponse.decode(new _m0.Reader(data)));
    }
    GranterGrants(request) {
        const data = exports.QueryGranterGrantsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.authz.v1beta1.Query", "GranterGrants", data);
        return promise.then((data) => exports.QueryGranterGrantsResponse.decode(new _m0.Reader(data)));
    }
    GranteeGrants(request) {
        const data = exports.QueryGranteeGrantsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.authz.v1beta1.Query", "GranteeGrants", data);
        return promise.then((data) => exports.QueryGranteeGrantsResponse.decode(new _m0.Reader(data)));
    }
}
exports.QueryClientImpl = QueryClientImpl;
//# sourceMappingURL=query.js.map

/***/ }),

/***/ 10892:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MsgClientImpl = exports.MsgRevokeResponse = exports.MsgRevoke = exports.MsgGrantResponse = exports.MsgExec = exports.MsgExecResponse = exports.MsgGrant = exports.protobufPackage = void 0;
/* eslint-disable */
const authz_1 = __webpack_require__(69046);
const any_1 = __webpack_require__(75654);
const _m0 = __importStar(__webpack_require__(62100));
const helpers_1 = __webpack_require__(92654);
exports.protobufPackage = "cosmos.authz.v1beta1";
function createBaseMsgGrant() {
    return {
        granter: "",
        grantee: "",
        grant: undefined,
    };
}
exports.MsgGrant = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.granter !== "") {
            writer.uint32(10).string(message.granter);
        }
        if (message.grantee !== "") {
            writer.uint32(18).string(message.grantee);
        }
        if (message.grant !== undefined) {
            authz_1.Grant.encode(message.grant, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgGrant();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.granter = reader.string();
                    break;
                case 2:
                    message.grantee = reader.string();
                    break;
                case 3:
                    message.grant = authz_1.Grant.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            granter: (0, helpers_1.isSet)(object.granter) ? String(object.granter) : "",
            grantee: (0, helpers_1.isSet)(object.grantee) ? String(object.grantee) : "",
            grant: (0, helpers_1.isSet)(object.grant) ? authz_1.Grant.fromJSON(object.grant) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.granter !== undefined && (obj.granter = message.granter);
        message.grantee !== undefined && (obj.grantee = message.grantee);
        message.grant !== undefined && (obj.grant = message.grant ? authz_1.Grant.toJSON(message.grant) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgGrant();
        message.granter = object.granter ?? "";
        message.grantee = object.grantee ?? "";
        message.grant =
            object.grant !== undefined && object.grant !== null ? authz_1.Grant.fromPartial(object.grant) : undefined;
        return message;
    },
};
function createBaseMsgExecResponse() {
    return {
        results: [],
    };
}
exports.MsgExecResponse = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.results) {
            writer.uint32(10).bytes(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgExecResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.results.push(reader.bytes());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            results: Array.isArray(object?.results) ? object.results.map((e) => (0, helpers_1.bytesFromBase64)(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.results) {
            obj.results = message.results.map((e) => (0, helpers_1.base64FromBytes)(e !== undefined ? e : new Uint8Array()));
        }
        else {
            obj.results = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgExecResponse();
        message.results = object.results?.map((e) => e) || [];
        return message;
    },
};
function createBaseMsgExec() {
    return {
        grantee: "",
        msgs: [],
    };
}
exports.MsgExec = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.grantee !== "") {
            writer.uint32(10).string(message.grantee);
        }
        for (const v of message.msgs) {
            any_1.Any.encode(v, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgExec();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.grantee = reader.string();
                    break;
                case 2:
                    message.msgs.push(any_1.Any.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            grantee: (0, helpers_1.isSet)(object.grantee) ? String(object.grantee) : "",
            msgs: Array.isArray(object?.msgs) ? object.msgs.map((e) => any_1.Any.fromJSON(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        message.grantee !== undefined && (obj.grantee = message.grantee);
        if (message.msgs) {
            obj.msgs = message.msgs.map((e) => (e ? any_1.Any.toJSON(e) : undefined));
        }
        else {
            obj.msgs = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgExec();
        message.grantee = object.grantee ?? "";
        message.msgs = object.msgs?.map((e) => any_1.Any.fromPartial(e)) || [];
        return message;
    },
};
function createBaseMsgGrantResponse() {
    return {};
}
exports.MsgGrantResponse = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgGrantResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgGrantResponse();
        return message;
    },
};
function createBaseMsgRevoke() {
    return {
        granter: "",
        grantee: "",
        msgTypeUrl: "",
    };
}
exports.MsgRevoke = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.granter !== "") {
            writer.uint32(10).string(message.granter);
        }
        if (message.grantee !== "") {
            writer.uint32(18).string(message.grantee);
        }
        if (message.msgTypeUrl !== "") {
            writer.uint32(26).string(message.msgTypeUrl);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgRevoke();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.granter = reader.string();
                    break;
                case 2:
                    message.grantee = reader.string();
                    break;
                case 3:
                    message.msgTypeUrl = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            granter: (0, helpers_1.isSet)(object.granter) ? String(object.granter) : "",
            grantee: (0, helpers_1.isSet)(object.grantee) ? String(object.grantee) : "",
            msgTypeUrl: (0, helpers_1.isSet)(object.msgTypeUrl) ? String(object.msgTypeUrl) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.granter !== undefined && (obj.granter = message.granter);
        message.grantee !== undefined && (obj.grantee = message.grantee);
        message.msgTypeUrl !== undefined && (obj.msgTypeUrl = message.msgTypeUrl);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgRevoke();
        message.granter = object.granter ?? "";
        message.grantee = object.grantee ?? "";
        message.msgTypeUrl = object.msgTypeUrl ?? "";
        return message;
    },
};
function createBaseMsgRevokeResponse() {
    return {};
}
exports.MsgRevokeResponse = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgRevokeResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgRevokeResponse();
        return message;
    },
};
class MsgClientImpl {
    constructor(rpc) {
        this.rpc = rpc;
        this.Grant = this.Grant.bind(this);
        this.Exec = this.Exec.bind(this);
        this.Revoke = this.Revoke.bind(this);
    }
    Grant(request) {
        const data = exports.MsgGrant.encode(request).finish();
        const promise = this.rpc.request("cosmos.authz.v1beta1.Msg", "Grant", data);
        return promise.then((data) => exports.MsgGrantResponse.decode(new _m0.Reader(data)));
    }
    Exec(request) {
        const data = exports.MsgExec.encode(request).finish();
        const promise = this.rpc.request("cosmos.authz.v1beta1.Msg", "Exec", data);
        return promise.then((data) => exports.MsgExecResponse.decode(new _m0.Reader(data)));
    }
    Revoke(request) {
        const data = exports.MsgRevoke.encode(request).finish();
        const promise = this.rpc.request("cosmos.authz.v1beta1.Msg", "Revoke", data);
        return promise.then((data) => exports.MsgRevokeResponse.decode(new _m0.Reader(data)));
    }
}
exports.MsgClientImpl = MsgClientImpl;
//# sourceMappingURL=tx.js.map

/***/ }),

/***/ 674:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Metadata = exports.DenomUnit = exports.Supply = exports.Output = exports.Input = exports.SendEnabled = exports.Params = exports.protobufPackage = void 0;
/* eslint-disable */
const coin_1 = __webpack_require__(81637);
const _m0 = __importStar(__webpack_require__(62100));
const helpers_1 = __webpack_require__(92654);
exports.protobufPackage = "cosmos.bank.v1beta1";
function createBaseParams() {
    return {
        sendEnabled: [],
        defaultSendEnabled: false,
    };
}
exports.Params = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.sendEnabled) {
            exports.SendEnabled.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.defaultSendEnabled === true) {
            writer.uint32(16).bool(message.defaultSendEnabled);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseParams();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.sendEnabled.push(exports.SendEnabled.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.defaultSendEnabled = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            sendEnabled: Array.isArray(object?.sendEnabled)
                ? object.sendEnabled.map((e) => exports.SendEnabled.fromJSON(e))
                : [],
            defaultSendEnabled: (0, helpers_1.isSet)(object.defaultSendEnabled) ? Boolean(object.defaultSendEnabled) : false,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.sendEnabled) {
            obj.sendEnabled = message.sendEnabled.map((e) => (e ? exports.SendEnabled.toJSON(e) : undefined));
        }
        else {
            obj.sendEnabled = [];
        }
        message.defaultSendEnabled !== undefined && (obj.defaultSendEnabled = message.defaultSendEnabled);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseParams();
        message.sendEnabled = object.sendEnabled?.map((e) => exports.SendEnabled.fromPartial(e)) || [];
        message.defaultSendEnabled = object.defaultSendEnabled ?? false;
        return message;
    },
};
function createBaseSendEnabled() {
    return {
        denom: "",
        enabled: false,
    };
}
exports.SendEnabled = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.denom !== "") {
            writer.uint32(10).string(message.denom);
        }
        if (message.enabled === true) {
            writer.uint32(16).bool(message.enabled);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSendEnabled();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.denom = reader.string();
                    break;
                case 2:
                    message.enabled = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            denom: (0, helpers_1.isSet)(object.denom) ? String(object.denom) : "",
            enabled: (0, helpers_1.isSet)(object.enabled) ? Boolean(object.enabled) : false,
        };
    },
    toJSON(message) {
        const obj = {};
        message.denom !== undefined && (obj.denom = message.denom);
        message.enabled !== undefined && (obj.enabled = message.enabled);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseSendEnabled();
        message.denom = object.denom ?? "";
        message.enabled = object.enabled ?? false;
        return message;
    },
};
function createBaseInput() {
    return {
        address: "",
        coins: [],
    };
}
exports.Input = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.address !== "") {
            writer.uint32(10).string(message.address);
        }
        for (const v of message.coins) {
            coin_1.Coin.encode(v, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseInput();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.coins.push(coin_1.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            address: (0, helpers_1.isSet)(object.address) ? String(object.address) : "",
            coins: Array.isArray(object?.coins) ? object.coins.map((e) => coin_1.Coin.fromJSON(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        if (message.coins) {
            obj.coins = message.coins.map((e) => (e ? coin_1.Coin.toJSON(e) : undefined));
        }
        else {
            obj.coins = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseInput();
        message.address = object.address ?? "";
        message.coins = object.coins?.map((e) => coin_1.Coin.fromPartial(e)) || [];
        return message;
    },
};
function createBaseOutput() {
    return {
        address: "",
        coins: [],
    };
}
exports.Output = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.address !== "") {
            writer.uint32(10).string(message.address);
        }
        for (const v of message.coins) {
            coin_1.Coin.encode(v, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseOutput();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.coins.push(coin_1.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            address: (0, helpers_1.isSet)(object.address) ? String(object.address) : "",
            coins: Array.isArray(object?.coins) ? object.coins.map((e) => coin_1.Coin.fromJSON(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        if (message.coins) {
            obj.coins = message.coins.map((e) => (e ? coin_1.Coin.toJSON(e) : undefined));
        }
        else {
            obj.coins = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseOutput();
        message.address = object.address ?? "";
        message.coins = object.coins?.map((e) => coin_1.Coin.fromPartial(e)) || [];
        return message;
    },
};
function createBaseSupply() {
    return {
        total: [],
    };
}
exports.Supply = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.total) {
            coin_1.Coin.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSupply();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.total.push(coin_1.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            total: Array.isArray(object?.total) ? object.total.map((e) => coin_1.Coin.fromJSON(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.total) {
            obj.total = message.total.map((e) => (e ? coin_1.Coin.toJSON(e) : undefined));
        }
        else {
            obj.total = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseSupply();
        message.total = object.total?.map((e) => coin_1.Coin.fromPartial(e)) || [];
        return message;
    },
};
function createBaseDenomUnit() {
    return {
        denom: "",
        exponent: 0,
        aliases: [],
    };
}
exports.DenomUnit = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.denom !== "") {
            writer.uint32(10).string(message.denom);
        }
        if (message.exponent !== 0) {
            writer.uint32(16).uint32(message.exponent);
        }
        for (const v of message.aliases) {
            writer.uint32(26).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDenomUnit();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.denom = reader.string();
                    break;
                case 2:
                    message.exponent = reader.uint32();
                    break;
                case 3:
                    message.aliases.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            denom: (0, helpers_1.isSet)(object.denom) ? String(object.denom) : "",
            exponent: (0, helpers_1.isSet)(object.exponent) ? Number(object.exponent) : 0,
            aliases: Array.isArray(object?.aliases) ? object.aliases.map((e) => String(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        message.denom !== undefined && (obj.denom = message.denom);
        message.exponent !== undefined && (obj.exponent = Math.round(message.exponent));
        if (message.aliases) {
            obj.aliases = message.aliases.map((e) => e);
        }
        else {
            obj.aliases = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseDenomUnit();
        message.denom = object.denom ?? "";
        message.exponent = object.exponent ?? 0;
        message.aliases = object.aliases?.map((e) => e) || [];
        return message;
    },
};
function createBaseMetadata() {
    return {
        description: "",
        denomUnits: [],
        base: "",
        display: "",
        name: "",
        symbol: "",
        uri: "",
        uriHash: "",
    };
}
exports.Metadata = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.description !== "") {
            writer.uint32(10).string(message.description);
        }
        for (const v of message.denomUnits) {
            exports.DenomUnit.encode(v, writer.uint32(18).fork()).ldelim();
        }
        if (message.base !== "") {
            writer.uint32(26).string(message.base);
        }
        if (message.display !== "") {
            writer.uint32(34).string(message.display);
        }
        if (message.name !== "") {
            writer.uint32(42).string(message.name);
        }
        if (message.symbol !== "") {
            writer.uint32(50).string(message.symbol);
        }
        if (message.uri !== "") {
            writer.uint32(58).string(message.uri);
        }
        if (message.uriHash !== "") {
            writer.uint32(66).string(message.uriHash);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMetadata();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.description = reader.string();
                    break;
                case 2:
                    message.denomUnits.push(exports.DenomUnit.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.base = reader.string();
                    break;
                case 4:
                    message.display = reader.string();
                    break;
                case 5:
                    message.name = reader.string();
                    break;
                case 6:
                    message.symbol = reader.string();
                    break;
                case 7:
                    message.uri = reader.string();
                    break;
                case 8:
                    message.uriHash = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            description: (0, helpers_1.isSet)(object.description) ? String(object.description) : "",
            denomUnits: Array.isArray(object?.denomUnits)
                ? object.denomUnits.map((e) => exports.DenomUnit.fromJSON(e))
                : [],
            base: (0, helpers_1.isSet)(object.base) ? String(object.base) : "",
            display: (0, helpers_1.isSet)(object.display) ? String(object.display) : "",
            name: (0, helpers_1.isSet)(object.name) ? String(object.name) : "",
            symbol: (0, helpers_1.isSet)(object.symbol) ? String(object.symbol) : "",
            uri: (0, helpers_1.isSet)(object.uri) ? String(object.uri) : "",
            uriHash: (0, helpers_1.isSet)(object.uriHash) ? String(object.uriHash) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.description !== undefined && (obj.description = message.description);
        if (message.denomUnits) {
            obj.denomUnits = message.denomUnits.map((e) => (e ? exports.DenomUnit.toJSON(e) : undefined));
        }
        else {
            obj.denomUnits = [];
        }
        message.base !== undefined && (obj.base = message.base);
        message.display !== undefined && (obj.display = message.display);
        message.name !== undefined && (obj.name = message.name);
        message.symbol !== undefined && (obj.symbol = message.symbol);
        message.uri !== undefined && (obj.uri = message.uri);
        message.uriHash !== undefined && (obj.uriHash = message.uriHash);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMetadata();
        message.description = object.description ?? "";
        message.denomUnits = object.denomUnits?.map((e) => exports.DenomUnit.fromPartial(e)) || [];
        message.base = object.base ?? "";
        message.display = object.display ?? "";
        message.name = object.name ?? "";
        message.symbol = object.symbol ?? "";
        message.uri = object.uri ?? "";
        message.uriHash = object.uriHash ?? "";
        return message;
    },
};
//# sourceMappingURL=bank.js.map

/***/ }),

/***/ 91586:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.QueryClientImpl = exports.QuerySendEnabledResponse = exports.QuerySendEnabledRequest = exports.QueryDenomOwnersResponse = exports.DenomOwner = exports.QueryDenomOwnersRequest = exports.QueryDenomMetadataResponse = exports.QueryDenomMetadataRequest = exports.QueryDenomsMetadataResponse = exports.QueryDenomsMetadataRequest = exports.QueryParamsResponse = exports.QueryParamsRequest = exports.QuerySupplyOfResponse = exports.QuerySupplyOfRequest = exports.QueryTotalSupplyResponse = exports.QueryTotalSupplyRequest = exports.QuerySpendableBalanceByDenomResponse = exports.QuerySpendableBalanceByDenomRequest = exports.QuerySpendableBalancesResponse = exports.QuerySpendableBalancesRequest = exports.QueryAllBalancesResponse = exports.QueryAllBalancesRequest = exports.QueryBalanceResponse = exports.QueryBalanceRequest = exports.protobufPackage = void 0;
/* eslint-disable */
const pagination_1 = __webpack_require__(84043);
const coin_1 = __webpack_require__(81637);
const bank_1 = __webpack_require__(674);
const _m0 = __importStar(__webpack_require__(62100));
const helpers_1 = __webpack_require__(92654);
exports.protobufPackage = "cosmos.bank.v1beta1";
function createBaseQueryBalanceRequest() {
    return {
        address: "",
        denom: "",
    };
}
exports.QueryBalanceRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.address !== "") {
            writer.uint32(10).string(message.address);
        }
        if (message.denom !== "") {
            writer.uint32(18).string(message.denom);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryBalanceRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.denom = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            address: (0, helpers_1.isSet)(object.address) ? String(object.address) : "",
            denom: (0, helpers_1.isSet)(object.denom) ? String(object.denom) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.denom !== undefined && (obj.denom = message.denom);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryBalanceRequest();
        message.address = object.address ?? "";
        message.denom = object.denom ?? "";
        return message;
    },
};
function createBaseQueryBalanceResponse() {
    return {
        balance: undefined,
    };
}
exports.QueryBalanceResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.balance !== undefined) {
            coin_1.Coin.encode(message.balance, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryBalanceResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.balance = coin_1.Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            balance: (0, helpers_1.isSet)(object.balance) ? coin_1.Coin.fromJSON(object.balance) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.balance !== undefined &&
            (obj.balance = message.balance ? coin_1.Coin.toJSON(message.balance) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryBalanceResponse();
        message.balance =
            object.balance !== undefined && object.balance !== null ? coin_1.Coin.fromPartial(object.balance) : undefined;
        return message;
    },
};
function createBaseQueryAllBalancesRequest() {
    return {
        address: "",
        pagination: undefined,
    };
}
exports.QueryAllBalancesRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.address !== "") {
            writer.uint32(10).string(message.address);
        }
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryAllBalancesRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            address: (0, helpers_1.isSet)(object.address) ? String(object.address) : "",
            pagination: (0, helpers_1.isSet)(object.pagination) ? pagination_1.PageRequest.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryAllBalancesRequest();
        message.address = object.address ?? "";
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryAllBalancesResponse() {
    return {
        balances: [],
        pagination: undefined,
    };
}
exports.QueryAllBalancesResponse = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.balances) {
            coin_1.Coin.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryAllBalancesResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.balances.push(coin_1.Coin.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            balances: Array.isArray(object?.balances) ? object.balances.map((e) => coin_1.Coin.fromJSON(e)) : [],
            pagination: (0, helpers_1.isSet)(object.pagination) ? pagination_1.PageResponse.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.balances) {
            obj.balances = message.balances.map((e) => (e ? coin_1.Coin.toJSON(e) : undefined));
        }
        else {
            obj.balances = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryAllBalancesResponse();
        message.balances = object.balances?.map((e) => coin_1.Coin.fromPartial(e)) || [];
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQuerySpendableBalancesRequest() {
    return {
        address: "",
        pagination: undefined,
    };
}
exports.QuerySpendableBalancesRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.address !== "") {
            writer.uint32(10).string(message.address);
        }
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQuerySpendableBalancesRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            address: (0, helpers_1.isSet)(object.address) ? String(object.address) : "",
            pagination: (0, helpers_1.isSet)(object.pagination) ? pagination_1.PageRequest.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQuerySpendableBalancesRequest();
        message.address = object.address ?? "";
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQuerySpendableBalancesResponse() {
    return {
        balances: [],
        pagination: undefined,
    };
}
exports.QuerySpendableBalancesResponse = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.balances) {
            coin_1.Coin.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQuerySpendableBalancesResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.balances.push(coin_1.Coin.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            balances: Array.isArray(object?.balances) ? object.balances.map((e) => coin_1.Coin.fromJSON(e)) : [],
            pagination: (0, helpers_1.isSet)(object.pagination) ? pagination_1.PageResponse.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.balances) {
            obj.balances = message.balances.map((e) => (e ? coin_1.Coin.toJSON(e) : undefined));
        }
        else {
            obj.balances = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQuerySpendableBalancesResponse();
        message.balances = object.balances?.map((e) => coin_1.Coin.fromPartial(e)) || [];
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQuerySpendableBalanceByDenomRequest() {
    return {
        address: "",
        denom: "",
    };
}
exports.QuerySpendableBalanceByDenomRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.address !== "") {
            writer.uint32(10).string(message.address);
        }
        if (message.denom !== "") {
            writer.uint32(18).string(message.denom);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQuerySpendableBalanceByDenomRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.denom = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            address: (0, helpers_1.isSet)(object.address) ? String(object.address) : "",
            denom: (0, helpers_1.isSet)(object.denom) ? String(object.denom) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.denom !== undefined && (obj.denom = message.denom);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQuerySpendableBalanceByDenomRequest();
        message.address = object.address ?? "";
        message.denom = object.denom ?? "";
        return message;
    },
};
function createBaseQuerySpendableBalanceByDenomResponse() {
    return {
        balance: undefined,
    };
}
exports.QuerySpendableBalanceByDenomResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.balance !== undefined) {
            coin_1.Coin.encode(message.balance, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQuerySpendableBalanceByDenomResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.balance = coin_1.Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            balance: (0, helpers_1.isSet)(object.balance) ? coin_1.Coin.fromJSON(object.balance) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.balance !== undefined &&
            (obj.balance = message.balance ? coin_1.Coin.toJSON(message.balance) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQuerySpendableBalanceByDenomResponse();
        message.balance =
            object.balance !== undefined && object.balance !== null ? coin_1.Coin.fromPartial(object.balance) : undefined;
        return message;
    },
};
function createBaseQueryTotalSupplyRequest() {
    return {
        pagination: undefined,
    };
}
exports.QueryTotalSupplyRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryTotalSupplyRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            pagination: (0, helpers_1.isSet)(object.pagination) ? pagination_1.PageRequest.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryTotalSupplyRequest();
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryTotalSupplyResponse() {
    return {
        supply: [],
        pagination: undefined,
    };
}
exports.QueryTotalSupplyResponse = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.supply) {
            coin_1.Coin.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryTotalSupplyResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.supply.push(coin_1.Coin.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            supply: Array.isArray(object?.supply) ? object.supply.map((e) => coin_1.Coin.fromJSON(e)) : [],
            pagination: (0, helpers_1.isSet)(object.pagination) ? pagination_1.PageResponse.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.supply) {
            obj.supply = message.supply.map((e) => (e ? coin_1.Coin.toJSON(e) : undefined));
        }
        else {
            obj.supply = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryTotalSupplyResponse();
        message.supply = object.supply?.map((e) => coin_1.Coin.fromPartial(e)) || [];
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQuerySupplyOfRequest() {
    return {
        denom: "",
    };
}
exports.QuerySupplyOfRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.denom !== "") {
            writer.uint32(10).string(message.denom);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQuerySupplyOfRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.denom = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            denom: (0, helpers_1.isSet)(object.denom) ? String(object.denom) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.denom !== undefined && (obj.denom = message.denom);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQuerySupplyOfRequest();
        message.denom = object.denom ?? "";
        return message;
    },
};
function createBaseQuerySupplyOfResponse() {
    return {
        amount: undefined,
    };
}
exports.QuerySupplyOfResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.amount !== undefined) {
            coin_1.Coin.encode(message.amount, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQuerySupplyOfResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.amount = coin_1.Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            amount: (0, helpers_1.isSet)(object.amount) ? coin_1.Coin.fromJSON(object.amount) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.amount !== undefined && (obj.amount = message.amount ? coin_1.Coin.toJSON(message.amount) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQuerySupplyOfResponse();
        message.amount =
            object.amount !== undefined && object.amount !== null ? coin_1.Coin.fromPartial(object.amount) : undefined;
        return message;
    },
};
function createBaseQueryParamsRequest() {
    return {};
}
exports.QueryParamsRequest = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryParamsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseQueryParamsRequest();
        return message;
    },
};
function createBaseQueryParamsResponse() {
    return {
        params: undefined,
    };
}
exports.QueryParamsResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.params !== undefined) {
            bank_1.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryParamsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.params = bank_1.Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            params: (0, helpers_1.isSet)(object.params) ? bank_1.Params.fromJSON(object.params) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.params !== undefined && (obj.params = message.params ? bank_1.Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryParamsResponse();
        message.params =
            object.params !== undefined && object.params !== null ? bank_1.Params.fromPartial(object.params) : undefined;
        return message;
    },
};
function createBaseQueryDenomsMetadataRequest() {
    return {
        pagination: undefined,
    };
}
exports.QueryDenomsMetadataRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryDenomsMetadataRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            pagination: (0, helpers_1.isSet)(object.pagination) ? pagination_1.PageRequest.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryDenomsMetadataRequest();
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryDenomsMetadataResponse() {
    return {
        metadatas: [],
        pagination: undefined,
    };
}
exports.QueryDenomsMetadataResponse = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.metadatas) {
            bank_1.Metadata.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryDenomsMetadataResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.metadatas.push(bank_1.Metadata.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            metadatas: Array.isArray(object?.metadatas)
                ? object.metadatas.map((e) => bank_1.Metadata.fromJSON(e))
                : [],
            pagination: (0, helpers_1.isSet)(object.pagination) ? pagination_1.PageResponse.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.metadatas) {
            obj.metadatas = message.metadatas.map((e) => (e ? bank_1.Metadata.toJSON(e) : undefined));
        }
        else {
            obj.metadatas = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryDenomsMetadataResponse();
        message.metadatas = object.metadatas?.map((e) => bank_1.Metadata.fromPartial(e)) || [];
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryDenomMetadataRequest() {
    return {
        denom: "",
    };
}
exports.QueryDenomMetadataRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.denom !== "") {
            writer.uint32(10).string(message.denom);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryDenomMetadataRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.denom = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            denom: (0, helpers_1.isSet)(object.denom) ? String(object.denom) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.denom !== undefined && (obj.denom = message.denom);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryDenomMetadataRequest();
        message.denom = object.denom ?? "";
        return message;
    },
};
function createBaseQueryDenomMetadataResponse() {
    return {
        metadata: undefined,
    };
}
exports.QueryDenomMetadataResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.metadata !== undefined) {
            bank_1.Metadata.encode(message.metadata, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryDenomMetadataResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.metadata = bank_1.Metadata.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            metadata: (0, helpers_1.isSet)(object.metadata) ? bank_1.Metadata.fromJSON(object.metadata) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.metadata !== undefined &&
            (obj.metadata = message.metadata ? bank_1.Metadata.toJSON(message.metadata) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryDenomMetadataResponse();
        message.metadata =
            object.metadata !== undefined && object.metadata !== null
                ? bank_1.Metadata.fromPartial(object.metadata)
                : undefined;
        return message;
    },
};
function createBaseQueryDenomOwnersRequest() {
    return {
        denom: "",
        pagination: undefined,
    };
}
exports.QueryDenomOwnersRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.denom !== "") {
            writer.uint32(10).string(message.denom);
        }
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryDenomOwnersRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.denom = reader.string();
                    break;
                case 2:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            denom: (0, helpers_1.isSet)(object.denom) ? String(object.denom) : "",
            pagination: (0, helpers_1.isSet)(object.pagination) ? pagination_1.PageRequest.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.denom !== undefined && (obj.denom = message.denom);
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryDenomOwnersRequest();
        message.denom = object.denom ?? "";
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseDenomOwner() {
    return {
        address: "",
        balance: undefined,
    };
}
exports.DenomOwner = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.address !== "") {
            writer.uint32(10).string(message.address);
        }
        if (message.balance !== undefined) {
            coin_1.Coin.encode(message.balance, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDenomOwner();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.balance = coin_1.Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            address: (0, helpers_1.isSet)(object.address) ? String(object.address) : "",
            balance: (0, helpers_1.isSet)(object.balance) ? coin_1.Coin.fromJSON(object.balance) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.balance !== undefined &&
            (obj.balance = message.balance ? coin_1.Coin.toJSON(message.balance) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseDenomOwner();
        message.address = object.address ?? "";
        message.balance =
            object.balance !== undefined && object.balance !== null ? coin_1.Coin.fromPartial(object.balance) : undefined;
        return message;
    },
};
function createBaseQueryDenomOwnersResponse() {
    return {
        denomOwners: [],
        pagination: undefined,
    };
}
exports.QueryDenomOwnersResponse = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.denomOwners) {
            exports.DenomOwner.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryDenomOwnersResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.denomOwners.push(exports.DenomOwner.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            denomOwners: Array.isArray(object?.denomOwners)
                ? object.denomOwners.map((e) => exports.DenomOwner.fromJSON(e))
                : [],
            pagination: (0, helpers_1.isSet)(object.pagination) ? pagination_1.PageResponse.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.denomOwners) {
            obj.denomOwners = message.denomOwners.map((e) => (e ? exports.DenomOwner.toJSON(e) : undefined));
        }
        else {
            obj.denomOwners = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryDenomOwnersResponse();
        message.denomOwners = object.denomOwners?.map((e) => exports.DenomOwner.fromPartial(e)) || [];
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQuerySendEnabledRequest() {
    return {
        denoms: [],
        pagination: undefined,
    };
}
exports.QuerySendEnabledRequest = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.denoms) {
            writer.uint32(10).string(v);
        }
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(794).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQuerySendEnabledRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.denoms.push(reader.string());
                    break;
                case 99:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            denoms: Array.isArray(object?.denoms) ? object.denoms.map((e) => String(e)) : [],
            pagination: (0, helpers_1.isSet)(object.pagination) ? pagination_1.PageRequest.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.denoms) {
            obj.denoms = message.denoms.map((e) => e);
        }
        else {
            obj.denoms = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQuerySendEnabledRequest();
        message.denoms = object.denoms?.map((e) => e) || [];
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQuerySendEnabledResponse() {
    return {
        sendEnabled: [],
        pagination: undefined,
    };
}
exports.QuerySendEnabledResponse = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.sendEnabled) {
            bank_1.SendEnabled.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(794).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQuerySendEnabledResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.sendEnabled.push(bank_1.SendEnabled.decode(reader, reader.uint32()));
                    break;
                case 99:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            sendEnabled: Array.isArray(object?.sendEnabled)
                ? object.sendEnabled.map((e) => bank_1.SendEnabled.fromJSON(e))
                : [],
            pagination: (0, helpers_1.isSet)(object.pagination) ? pagination_1.PageResponse.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.sendEnabled) {
            obj.sendEnabled = message.sendEnabled.map((e) => (e ? bank_1.SendEnabled.toJSON(e) : undefined));
        }
        else {
            obj.sendEnabled = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQuerySendEnabledResponse();
        message.sendEnabled = object.sendEnabled?.map((e) => bank_1.SendEnabled.fromPartial(e)) || [];
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
class QueryClientImpl {
    constructor(rpc) {
        this.rpc = rpc;
        this.Balance = this.Balance.bind(this);
        this.AllBalances = this.AllBalances.bind(this);
        this.SpendableBalances = this.SpendableBalances.bind(this);
        this.SpendableBalanceByDenom = this.SpendableBalanceByDenom.bind(this);
        this.TotalSupply = this.TotalSupply.bind(this);
        this.SupplyOf = this.SupplyOf.bind(this);
        this.Params = this.Params.bind(this);
        this.DenomMetadata = this.DenomMetadata.bind(this);
        this.DenomsMetadata = this.DenomsMetadata.bind(this);
        this.DenomOwners = this.DenomOwners.bind(this);
        this.SendEnabled = this.SendEnabled.bind(this);
    }
    Balance(request) {
        const data = exports.QueryBalanceRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.bank.v1beta1.Query", "Balance", data);
        return promise.then((data) => exports.QueryBalanceResponse.decode(new _m0.Reader(data)));
    }
    AllBalances(request) {
        const data = exports.QueryAllBalancesRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.bank.v1beta1.Query", "AllBalances", data);
        return promise.then((data) => exports.QueryAllBalancesResponse.decode(new _m0.Reader(data)));
    }
    SpendableBalances(request) {
        const data = exports.QuerySpendableBalancesRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.bank.v1beta1.Query", "SpendableBalances", data);
        return promise.then((data) => exports.QuerySpendableBalancesResponse.decode(new _m0.Reader(data)));
    }
    SpendableBalanceByDenom(request) {
        const data = exports.QuerySpendableBalanceByDenomRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.bank.v1beta1.Query", "SpendableBalanceByDenom", data);
        return promise.then((data) => exports.QuerySpendableBalanceByDenomResponse.decode(new _m0.Reader(data)));
    }
    TotalSupply(request = {
        pagination: undefined,
    }) {
        const data = exports.QueryTotalSupplyRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.bank.v1beta1.Query", "TotalSupply", data);
        return promise.then((data) => exports.QueryTotalSupplyResponse.decode(new _m0.Reader(data)));
    }
    SupplyOf(request) {
        const data = exports.QuerySupplyOfRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.bank.v1beta1.Query", "SupplyOf", data);
        return promise.then((data) => exports.QuerySupplyOfResponse.decode(new _m0.Reader(data)));
    }
    Params(request = {}) {
        const data = exports.QueryParamsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.bank.v1beta1.Query", "Params", data);
        return promise.then((data) => exports.QueryParamsResponse.decode(new _m0.Reader(data)));
    }
    DenomMetadata(request) {
        const data = exports.QueryDenomMetadataRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.bank.v1beta1.Query", "DenomMetadata", data);
        return promise.then((data) => exports.QueryDenomMetadataResponse.decode(new _m0.Reader(data)));
    }
    DenomsMetadata(request = {
        pagination: undefined,
    }) {
        const data = exports.QueryDenomsMetadataRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.bank.v1beta1.Query", "DenomsMetadata", data);
        return promise.then((data) => exports.QueryDenomsMetadataResponse.decode(new _m0.Reader(data)));
    }
    DenomOwners(request) {
        const data = exports.QueryDenomOwnersRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.bank.v1beta1.Query", "DenomOwners", data);
        return promise.then((data) => exports.QueryDenomOwnersResponse.decode(new _m0.Reader(data)));
    }
    SendEnabled(request) {
        const data = exports.QuerySendEnabledRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.bank.v1beta1.Query", "SendEnabled", data);
        return promise.then((data) => exports.QuerySendEnabledResponse.decode(new _m0.Reader(data)));
    }
}
exports.QueryClientImpl = QueryClientImpl;
//# sourceMappingURL=query.js.map

/***/ }),

/***/ 59534:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MsgClientImpl = exports.MsgSetSendEnabledResponse = exports.MsgSetSendEnabled = exports.MsgUpdateParamsResponse = exports.MsgUpdateParams = exports.MsgMultiSendResponse = exports.MsgMultiSend = exports.MsgSendResponse = exports.MsgSend = exports.protobufPackage = void 0;
/* eslint-disable */
const coin_1 = __webpack_require__(81637);
const bank_1 = __webpack_require__(674);
const _m0 = __importStar(__webpack_require__(62100));
const helpers_1 = __webpack_require__(92654);
exports.protobufPackage = "cosmos.bank.v1beta1";
function createBaseMsgSend() {
    return {
        fromAddress: "",
        toAddress: "",
        amount: [],
    };
}
exports.MsgSend = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.fromAddress !== "") {
            writer.uint32(10).string(message.fromAddress);
        }
        if (message.toAddress !== "") {
            writer.uint32(18).string(message.toAddress);
        }
        for (const v of message.amount) {
            coin_1.Coin.encode(v, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgSend();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.fromAddress = reader.string();
                    break;
                case 2:
                    message.toAddress = reader.string();
                    break;
                case 3:
                    message.amount.push(coin_1.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            fromAddress: (0, helpers_1.isSet)(object.fromAddress) ? String(object.fromAddress) : "",
            toAddress: (0, helpers_1.isSet)(object.toAddress) ? String(object.toAddress) : "",
            amount: Array.isArray(object?.amount) ? object.amount.map((e) => coin_1.Coin.fromJSON(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        message.fromAddress !== undefined && (obj.fromAddress = message.fromAddress);
        message.toAddress !== undefined && (obj.toAddress = message.toAddress);
        if (message.amount) {
            obj.amount = message.amount.map((e) => (e ? coin_1.Coin.toJSON(e) : undefined));
        }
        else {
            obj.amount = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgSend();
        message.fromAddress = object.fromAddress ?? "";
        message.toAddress = object.toAddress ?? "";
        message.amount = object.amount?.map((e) => coin_1.Coin.fromPartial(e)) || [];
        return message;
    },
};
function createBaseMsgSendResponse() {
    return {};
}
exports.MsgSendResponse = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgSendResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgSendResponse();
        return message;
    },
};
function createBaseMsgMultiSend() {
    return {
        inputs: [],
        outputs: [],
    };
}
exports.MsgMultiSend = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.inputs) {
            bank_1.Input.encode(v, writer.uint32(10).fork()).ldelim();
        }
        for (const v of message.outputs) {
            bank_1.Output.encode(v, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgMultiSend();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.inputs.push(bank_1.Input.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.outputs.push(bank_1.Output.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            inputs: Array.isArray(object?.inputs) ? object.inputs.map((e) => bank_1.Input.fromJSON(e)) : [],
            outputs: Array.isArray(object?.outputs) ? object.outputs.map((e) => bank_1.Output.fromJSON(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.inputs) {
            obj.inputs = message.inputs.map((e) => (e ? bank_1.Input.toJSON(e) : undefined));
        }
        else {
            obj.inputs = [];
        }
        if (message.outputs) {
            obj.outputs = message.outputs.map((e) => (e ? bank_1.Output.toJSON(e) : undefined));
        }
        else {
            obj.outputs = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgMultiSend();
        message.inputs = object.inputs?.map((e) => bank_1.Input.fromPartial(e)) || [];
        message.outputs = object.outputs?.map((e) => bank_1.Output.fromPartial(e)) || [];
        return message;
    },
};
function createBaseMsgMultiSendResponse() {
    return {};
}
exports.MsgMultiSendResponse = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgMultiSendResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgMultiSendResponse();
        return message;
    },
};
function createBaseMsgUpdateParams() {
    return {
        authority: "",
        params: undefined,
    };
}
exports.MsgUpdateParams = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.authority !== "") {
            writer.uint32(10).string(message.authority);
        }
        if (message.params !== undefined) {
            bank_1.Params.encode(message.params, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgUpdateParams();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.authority = reader.string();
                    break;
                case 2:
                    message.params = bank_1.Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            authority: (0, helpers_1.isSet)(object.authority) ? String(object.authority) : "",
            params: (0, helpers_1.isSet)(object.params) ? bank_1.Params.fromJSON(object.params) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.authority !== undefined && (obj.authority = message.authority);
        message.params !== undefined && (obj.params = message.params ? bank_1.Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgUpdateParams();
        message.authority = object.authority ?? "";
        message.params =
            object.params !== undefined && object.params !== null ? bank_1.Params.fromPartial(object.params) : undefined;
        return message;
    },
};
function createBaseMsgUpdateParamsResponse() {
    return {};
}
exports.MsgUpdateParamsResponse = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgUpdateParamsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgUpdateParamsResponse();
        return message;
    },
};
function createBaseMsgSetSendEnabled() {
    return {
        authority: "",
        sendEnabled: [],
        useDefaultFor: [],
    };
}
exports.MsgSetSendEnabled = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.authority !== "") {
            writer.uint32(10).string(message.authority);
        }
        for (const v of message.sendEnabled) {
            bank_1.SendEnabled.encode(v, writer.uint32(18).fork()).ldelim();
        }
        for (const v of message.useDefaultFor) {
            writer.uint32(26).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgSetSendEnabled();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.authority = reader.string();
                    break;
                case 2:
                    message.sendEnabled.push(bank_1.SendEnabled.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.useDefaultFor.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            authority: (0, helpers_1.isSet)(object.authority) ? String(object.authority) : "",
            sendEnabled: Array.isArray(object?.sendEnabled)
                ? object.sendEnabled.map((e) => bank_1.SendEnabled.fromJSON(e))
                : [],
            useDefaultFor: Array.isArray(object?.useDefaultFor)
                ? object.useDefaultFor.map((e) => String(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        message.authority !== undefined && (obj.authority = message.authority);
        if (message.sendEnabled) {
            obj.sendEnabled = message.sendEnabled.map((e) => (e ? bank_1.SendEnabled.toJSON(e) : undefined));
        }
        else {
            obj.sendEnabled = [];
        }
        if (message.useDefaultFor) {
            obj.useDefaultFor = message.useDefaultFor.map((e) => e);
        }
        else {
            obj.useDefaultFor = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgSetSendEnabled();
        message.authority = object.authority ?? "";
        message.sendEnabled = object.sendEnabled?.map((e) => bank_1.SendEnabled.fromPartial(e)) || [];
        message.useDefaultFor = object.useDefaultFor?.map((e) => e) || [];
        return message;
    },
};
function createBaseMsgSetSendEnabledResponse() {
    return {};
}
exports.MsgSetSendEnabledResponse = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgSetSendEnabledResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgSetSendEnabledResponse();
        return message;
    },
};
class MsgClientImpl {
    constructor(rpc) {
        this.rpc = rpc;
        this.Send = this.Send.bind(this);
        this.MultiSend = this.MultiSend.bind(this);
        this.UpdateParams = this.UpdateParams.bind(this);
        this.SetSendEnabled = this.SetSendEnabled.bind(this);
    }
    Send(request) {
        const data = exports.MsgSend.encode(request).finish();
        const promise = this.rpc.request("cosmos.bank.v1beta1.Msg", "Send", data);
        return promise.then((data) => exports.MsgSendResponse.decode(new _m0.Reader(data)));
    }
    MultiSend(request) {
        const data = exports.MsgMultiSend.encode(request).finish();
        const promise = this.rpc.request("cosmos.bank.v1beta1.Msg", "MultiSend", data);
        return promise.then((data) => exports.MsgMultiSendResponse.decode(new _m0.Reader(data)));
    }
    UpdateParams(request) {
        const data = exports.MsgUpdateParams.encode(request).finish();
        const promise = this.rpc.request("cosmos.bank.v1beta1.Msg", "UpdateParams", data);
        return promise.then((data) => exports.MsgUpdateParamsResponse.decode(new _m0.Reader(data)));
    }
    SetSendEnabled(request) {
        const data = exports.MsgSetSendEnabled.encode(request).finish();
        const promise = this.rpc.request("cosmos.bank.v1beta1.Msg", "SetSendEnabled", data);
        return promise.then((data) => exports.MsgSetSendEnabledResponse.decode(new _m0.Reader(data)));
    }
}
exports.MsgClientImpl = MsgClientImpl;
//# sourceMappingURL=tx.js.map

/***/ }),

/***/ 7088:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.SearchTxsResult = exports.TxMsgData = exports.MsgData = exports.SimulationResponse = exports.Result = exports.GasInfo = exports.Attribute = exports.StringEvent = exports.ABCIMessageLog = exports.TxResponse = exports.protobufPackage = void 0;
/* eslint-disable */
const any_1 = __webpack_require__(75654);
const types_1 = __webpack_require__(35580);
const helpers_1 = __webpack_require__(92654);
const _m0 = __importStar(__webpack_require__(62100));
exports.protobufPackage = "cosmos.base.abci.v1beta1";
function createBaseTxResponse() {
    return {
        height: helpers_1.Long.ZERO,
        txhash: "",
        codespace: "",
        code: 0,
        data: "",
        rawLog: "",
        logs: [],
        info: "",
        gasWanted: helpers_1.Long.ZERO,
        gasUsed: helpers_1.Long.ZERO,
        tx: undefined,
        timestamp: "",
        events: [],
    };
}
exports.TxResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (!message.height.isZero()) {
            writer.uint32(8).int64(message.height);
        }
        if (message.txhash !== "") {
            writer.uint32(18).string(message.txhash);
        }
        if (message.codespace !== "") {
            writer.uint32(26).string(message.codespace);
        }
        if (message.code !== 0) {
            writer.uint32(32).uint32(message.code);
        }
        if (message.data !== "") {
            writer.uint32(42).string(message.data);
        }
        if (message.rawLog !== "") {
            writer.uint32(50).string(message.rawLog);
        }
        for (const v of message.logs) {
            exports.ABCIMessageLog.encode(v, writer.uint32(58).fork()).ldelim();
        }
        if (message.info !== "") {
            writer.uint32(66).string(message.info);
        }
        if (!message.gasWanted.isZero()) {
            writer.uint32(72).int64(message.gasWanted);
        }
        if (!message.gasUsed.isZero()) {
            writer.uint32(80).int64(message.gasUsed);
        }
        if (message.tx !== undefined) {
            any_1.Any.encode(message.tx, writer.uint32(90).fork()).ldelim();
        }
        if (message.timestamp !== "") {
            writer.uint32(98).string(message.timestamp);
        }
        for (const v of message.events) {
            types_1.Event.encode(v, writer.uint32(106).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTxResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.height = reader.int64();
                    break;
                case 2:
                    message.txhash = reader.string();
                    break;
                case 3:
                    message.codespace = reader.string();
                    break;
                case 4:
                    message.code = reader.uint32();
                    break;
                case 5:
                    message.data = reader.string();
                    break;
                case 6:
                    message.rawLog = reader.string();
                    break;
                case 7:
                    message.logs.push(exports.ABCIMessageLog.decode(reader, reader.uint32()));
                    break;
                case 8:
                    message.info = reader.string();
                    break;
                case 9:
                    message.gasWanted = reader.int64();
                    break;
                case 10:
                    message.gasUsed = reader.int64();
                    break;
                case 11:
                    message.tx = any_1.Any.decode(reader, reader.uint32());
                    break;
                case 12:
                    message.timestamp = reader.string();
                    break;
                case 13:
                    message.events.push(types_1.Event.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            height: (0, helpers_1.isSet)(object.height) ? helpers_1.Long.fromValue(object.height) : helpers_1.Long.ZERO,
            txhash: (0, helpers_1.isSet)(object.txhash) ? String(object.txhash) : "",
            codespace: (0, helpers_1.isSet)(object.codespace) ? String(object.codespace) : "",
            code: (0, helpers_1.isSet)(object.code) ? Number(object.code) : 0,
            data: (0, helpers_1.isSet)(object.data) ? String(object.data) : "",
            rawLog: (0, helpers_1.isSet)(object.rawLog) ? String(object.rawLog) : "",
            logs: Array.isArray(object?.logs) ? object.logs.map((e) => exports.ABCIMessageLog.fromJSON(e)) : [],
            info: (0, helpers_1.isSet)(object.info) ? String(object.info) : "",
            gasWanted: (0, helpers_1.isSet)(object.gasWanted) ? helpers_1.Long.fromValue(object.gasWanted) : helpers_1.Long.ZERO,
            gasUsed: (0, helpers_1.isSet)(object.gasUsed) ? helpers_1.Long.fromValue(object.gasUsed) : helpers_1.Long.ZERO,
            tx: (0, helpers_1.isSet)(object.tx) ? any_1.Any.fromJSON(object.tx) : undefined,
            timestamp: (0, helpers_1.isSet)(object.timestamp) ? String(object.timestamp) : "",
            events: Array.isArray(object?.events) ? object.events.map((e) => types_1.Event.fromJSON(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        message.height !== undefined && (obj.height = (message.height || helpers_1.Long.ZERO).toString());
        message.txhash !== undefined && (obj.txhash = message.txhash);
        message.codespace !== undefined && (obj.codespace = message.codespace);
        message.code !== undefined && (obj.code = Math.round(message.code));
        message.data !== undefined && (obj.data = message.data);
        message.rawLog !== undefined && (obj.rawLog = message.rawLog);
        if (message.logs) {
            obj.logs = message.logs.map((e) => (e ? exports.ABCIMessageLog.toJSON(e) : undefined));
        }
        else {
            obj.logs = [];
        }
        message.info !== undefined && (obj.info = message.info);
        message.gasWanted !== undefined && (obj.gasWanted = (message.gasWanted || helpers_1.Long.ZERO).toString());
        message.gasUsed !== undefined && (obj.gasUsed = (message.gasUsed || helpers_1.Long.ZERO).toString());
        message.tx !== undefined && (obj.tx = message.tx ? any_1.Any.toJSON(message.tx) : undefined);
        message.timestamp !== undefined && (obj.timestamp = message.timestamp);
        if (message.events) {
            obj.events = message.events.map((e) => (e ? types_1.Event.toJSON(e) : undefined));
        }
        else {
            obj.events = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseTxResponse();
        message.height =
            object.height !== undefined && object.height !== null ? helpers_1.Long.fromValue(object.height) : helpers_1.Long.ZERO;
        message.txhash = object.txhash ?? "";
        message.codespace = object.codespace ?? "";
        message.code = object.code ?? 0;
        message.data = object.data ?? "";
        message.rawLog = object.rawLog ?? "";
        message.logs = object.logs?.map((e) => exports.ABCIMessageLog.fromPartial(e)) || [];
        message.info = object.info ?? "";
        message.gasWanted =
            object.gasWanted !== undefined && object.gasWanted !== null
                ? helpers_1.Long.fromValue(object.gasWanted)
                : helpers_1.Long.ZERO;
        message.gasUsed =
            object.gasUsed !== undefined && object.gasUsed !== null ? helpers_1.Long.fromValue(object.gasUsed) : helpers_1.Long.ZERO;
        message.tx = object.tx !== undefined && object.tx !== null ? any_1.Any.fromPartial(object.tx) : undefined;
        message.timestamp = object.timestamp ?? "";
        message.events = object.events?.map((e) => types_1.Event.fromPartial(e)) || [];
        return message;
    },
};
function createBaseABCIMessageLog() {
    return {
        msgIndex: 0,
        log: "",
        events: [],
    };
}
exports.ABCIMessageLog = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.msgIndex !== 0) {
            writer.uint32(8).uint32(message.msgIndex);
        }
        if (message.log !== "") {
            writer.uint32(18).string(message.log);
        }
        for (const v of message.events) {
            exports.StringEvent.encode(v, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseABCIMessageLog();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.msgIndex = reader.uint32();
                    break;
                case 2:
                    message.log = reader.string();
                    break;
                case 3:
                    message.events.push(exports.StringEvent.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            msgIndex: (0, helpers_1.isSet)(object.msgIndex) ? Number(object.msgIndex) : 0,
            log: (0, helpers_1.isSet)(object.log) ? String(object.log) : "",
            events: Array.isArray(object?.events) ? object.events.map((e) => exports.StringEvent.fromJSON(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        message.msgIndex !== undefined && (obj.msgIndex = Math.round(message.msgIndex));
        message.log !== undefined && (obj.log = message.log);
        if (message.events) {
            obj.events = message.events.map((e) => (e ? exports.StringEvent.toJSON(e) : undefined));
        }
        else {
            obj.events = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseABCIMessageLog();
        message.msgIndex = object.msgIndex ?? 0;
        message.log = object.log ?? "";
        message.events = object.events?.map((e) => exports.StringEvent.fromPartial(e)) || [];
        return message;
    },
};
function createBaseStringEvent() {
    return {
        type: "",
        attributes: [],
    };
}
exports.StringEvent = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.type !== "") {
            writer.uint32(10).string(message.type);
        }
        for (const v of message.attributes) {
            exports.Attribute.encode(v, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseStringEvent();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.type = reader.string();
                    break;
                case 2:
                    message.attributes.push(exports.Attribute.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            type: (0, helpers_1.isSet)(object.type) ? String(object.type) : "",
            attributes: Array.isArray(object?.attributes)
                ? object.attributes.map((e) => exports.Attribute.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        message.type !== undefined && (obj.type = message.type);
        if (message.attributes) {
            obj.attributes = message.attributes.map((e) => (e ? exports.Attribute.toJSON(e) : undefined));
        }
        else {
            obj.attributes = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseStringEvent();
        message.type = object.type ?? "";
        message.attributes = object.attributes?.map((e) => exports.Attribute.fromPartial(e)) || [];
        return message;
    },
};
function createBaseAttribute() {
    return {
        key: "",
        value: "",
    };
}
exports.Attribute = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.key !== "") {
            writer.uint32(10).string(message.key);
        }
        if (message.value !== "") {
            writer.uint32(18).string(message.value);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAttribute();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.key = reader.string();
                    break;
                case 2:
                    message.value = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            key: (0, helpers_1.isSet)(object.key) ? String(object.key) : "",
            value: (0, helpers_1.isSet)(object.value) ? String(object.value) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.key !== undefined && (obj.key = message.key);
        message.value !== undefined && (obj.value = message.value);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseAttribute();
        message.key = object.key ?? "";
        message.value = object.value ?? "";
        return message;
    },
};
function createBaseGasInfo() {
    return {
        gasWanted: helpers_1.Long.UZERO,
        gasUsed: helpers_1.Long.UZERO,
    };
}
exports.GasInfo = {
    encode(message, writer = _m0.Writer.create()) {
        if (!message.gasWanted.isZero()) {
            writer.uint32(8).uint64(message.gasWanted);
        }
        if (!message.gasUsed.isZero()) {
            writer.uint32(16).uint64(message.gasUsed);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGasInfo();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.gasWanted = reader.uint64();
                    break;
                case 2:
                    message.gasUsed = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            gasWanted: (0, helpers_1.isSet)(object.gasWanted) ? helpers_1.Long.fromValue(object.gasWanted) : helpers_1.Long.UZERO,
            gasUsed: (0, helpers_1.isSet)(object.gasUsed) ? helpers_1.Long.fromValue(object.gasUsed) : helpers_1.Long.UZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        message.gasWanted !== undefined && (obj.gasWanted = (message.gasWanted || helpers_1.Long.UZERO).toString());
        message.gasUsed !== undefined && (obj.gasUsed = (message.gasUsed || helpers_1.Long.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseGasInfo();
        message.gasWanted =
            object.gasWanted !== undefined && object.gasWanted !== null
                ? helpers_1.Long.fromValue(object.gasWanted)
                : helpers_1.Long.UZERO;
        message.gasUsed =
            object.gasUsed !== undefined && object.gasUsed !== null ? helpers_1.Long.fromValue(object.gasUsed) : helpers_1.Long.UZERO;
        return message;
    },
};
function createBaseResult() {
    return {
        data: new Uint8Array(),
        log: "",
        events: [],
        msgResponses: [],
    };
}
exports.Result = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.data.length !== 0) {
            writer.uint32(10).bytes(message.data);
        }
        if (message.log !== "") {
            writer.uint32(18).string(message.log);
        }
        for (const v of message.events) {
            types_1.Event.encode(v, writer.uint32(26).fork()).ldelim();
        }
        for (const v of message.msgResponses) {
            any_1.Any.encode(v, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseResult();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.data = reader.bytes();
                    break;
                case 2:
                    message.log = reader.string();
                    break;
                case 3:
                    message.events.push(types_1.Event.decode(reader, reader.uint32()));
                    break;
                case 4:
                    message.msgResponses.push(any_1.Any.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            data: (0, helpers_1.isSet)(object.data) ? (0, helpers_1.bytesFromBase64)(object.data) : new Uint8Array(),
            log: (0, helpers_1.isSet)(object.log) ? String(object.log) : "",
            events: Array.isArray(object?.events) ? object.events.map((e) => types_1.Event.fromJSON(e)) : [],
            msgResponses: Array.isArray(object?.msgResponses)
                ? object.msgResponses.map((e) => any_1.Any.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        message.data !== undefined &&
            (obj.data = (0, helpers_1.base64FromBytes)(message.data !== undefined ? message.data : new Uint8Array()));
        message.log !== undefined && (obj.log = message.log);
        if (message.events) {
            obj.events = message.events.map((e) => (e ? types_1.Event.toJSON(e) : undefined));
        }
        else {
            obj.events = [];
        }
        if (message.msgResponses) {
            obj.msgResponses = message.msgResponses.map((e) => (e ? any_1.Any.toJSON(e) : undefined));
        }
        else {
            obj.msgResponses = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseResult();
        message.data = object.data ?? new Uint8Array();
        message.log = object.log ?? "";
        message.events = object.events?.map((e) => types_1.Event.fromPartial(e)) || [];
        message.msgResponses = object.msgResponses?.map((e) => any_1.Any.fromPartial(e)) || [];
        return message;
    },
};
function createBaseSimulationResponse() {
    return {
        gasInfo: undefined,
        result: undefined,
    };
}
exports.SimulationResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.gasInfo !== undefined) {
            exports.GasInfo.encode(message.gasInfo, writer.uint32(10).fork()).ldelim();
        }
        if (message.result !== undefined) {
            exports.Result.encode(message.result, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSimulationResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.gasInfo = exports.GasInfo.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.result = exports.Result.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            gasInfo: (0, helpers_1.isSet)(object.gasInfo) ? exports.GasInfo.fromJSON(object.gasInfo) : undefined,
            result: (0, helpers_1.isSet)(object.result) ? exports.Result.fromJSON(object.result) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.gasInfo !== undefined &&
            (obj.gasInfo = message.gasInfo ? exports.GasInfo.toJSON(message.gasInfo) : undefined);
        message.result !== undefined && (obj.result = message.result ? exports.Result.toJSON(message.result) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseSimulationResponse();
        message.gasInfo =
            object.gasInfo !== undefined && object.gasInfo !== null
                ? exports.GasInfo.fromPartial(object.gasInfo)
                : undefined;
        message.result =
            object.result !== undefined && object.result !== null ? exports.Result.fromPartial(object.result) : undefined;
        return message;
    },
};
function createBaseMsgData() {
    return {
        msgType: "",
        data: new Uint8Array(),
    };
}
exports.MsgData = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.msgType !== "") {
            writer.uint32(10).string(message.msgType);
        }
        if (message.data.length !== 0) {
            writer.uint32(18).bytes(message.data);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgData();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.msgType = reader.string();
                    break;
                case 2:
                    message.data = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            msgType: (0, helpers_1.isSet)(object.msgType) ? String(object.msgType) : "",
            data: (0, helpers_1.isSet)(object.data) ? (0, helpers_1.bytesFromBase64)(object.data) : new Uint8Array(),
        };
    },
    toJSON(message) {
        const obj = {};
        message.msgType !== undefined && (obj.msgType = message.msgType);
        message.data !== undefined &&
            (obj.data = (0, helpers_1.base64FromBytes)(message.data !== undefined ? message.data : new Uint8Array()));
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgData();
        message.msgType = object.msgType ?? "";
        message.data = object.data ?? new Uint8Array();
        return message;
    },
};
function createBaseTxMsgData() {
    return {
        data: [],
        msgResponses: [],
    };
}
exports.TxMsgData = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.data) {
            exports.MsgData.encode(v, writer.uint32(10).fork()).ldelim();
        }
        for (const v of message.msgResponses) {
            any_1.Any.encode(v, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTxMsgData();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.data.push(exports.MsgData.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.msgResponses.push(any_1.Any.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            data: Array.isArray(object?.data) ? object.data.map((e) => exports.MsgData.fromJSON(e)) : [],
            msgResponses: Array.isArray(object?.msgResponses)
                ? object.msgResponses.map((e) => any_1.Any.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.data) {
            obj.data = message.data.map((e) => (e ? exports.MsgData.toJSON(e) : undefined));
        }
        else {
            obj.data = [];
        }
        if (message.msgResponses) {
            obj.msgResponses = message.msgResponses.map((e) => (e ? any_1.Any.toJSON(e) : undefined));
        }
        else {
            obj.msgResponses = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseTxMsgData();
        message.data = object.data?.map((e) => exports.MsgData.fromPartial(e)) || [];
        message.msgResponses = object.msgResponses?.map((e) => any_1.Any.fromPartial(e)) || [];
        return message;
    },
};
function createBaseSearchTxsResult() {
    return {
        totalCount: helpers_1.Long.UZERO,
        count: helpers_1.Long.UZERO,
        pageNumber: helpers_1.Long.UZERO,
        pageTotal: helpers_1.Long.UZERO,
        limit: helpers_1.Long.UZERO,
        txs: [],
    };
}
exports.SearchTxsResult = {
    encode(message, writer = _m0.Writer.create()) {
        if (!message.totalCount.isZero()) {
            writer.uint32(8).uint64(message.totalCount);
        }
        if (!message.count.isZero()) {
            writer.uint32(16).uint64(message.count);
        }
        if (!message.pageNumber.isZero()) {
            writer.uint32(24).uint64(message.pageNumber);
        }
        if (!message.pageTotal.isZero()) {
            writer.uint32(32).uint64(message.pageTotal);
        }
        if (!message.limit.isZero()) {
            writer.uint32(40).uint64(message.limit);
        }
        for (const v of message.txs) {
            exports.TxResponse.encode(v, writer.uint32(50).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSearchTxsResult();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.totalCount = reader.uint64();
                    break;
                case 2:
                    message.count = reader.uint64();
                    break;
                case 3:
                    message.pageNumber = reader.uint64();
                    break;
                case 4:
                    message.pageTotal = reader.uint64();
                    break;
                case 5:
                    message.limit = reader.uint64();
                    break;
                case 6:
                    message.txs.push(exports.TxResponse.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            totalCount: (0, helpers_1.isSet)(object.totalCount) ? helpers_1.Long.fromValue(object.totalCount) : helpers_1.Long.UZERO,
            count: (0, helpers_1.isSet)(object.count) ? helpers_1.Long.fromValue(object.count) : helpers_1.Long.UZERO,
            pageNumber: (0, helpers_1.isSet)(object.pageNumber) ? helpers_1.Long.fromValue(object.pageNumber) : helpers_1.Long.UZERO,
            pageTotal: (0, helpers_1.isSet)(object.pageTotal) ? helpers_1.Long.fromValue(object.pageTotal) : helpers_1.Long.UZERO,
            limit: (0, helpers_1.isSet)(object.limit) ? helpers_1.Long.fromValue(object.limit) : helpers_1.Long.UZERO,
            txs: Array.isArray(object?.txs) ? object.txs.map((e) => exports.TxResponse.fromJSON(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        message.totalCount !== undefined && (obj.totalCount = (message.totalCount || helpers_1.Long.UZERO).toString());
        message.count !== undefined && (obj.count = (message.count || helpers_1.Long.UZERO).toString());
        message.pageNumber !== undefined && (obj.pageNumber = (message.pageNumber || helpers_1.Long.UZERO).toString());
        message.pageTotal !== undefined && (obj.pageTotal = (message.pageTotal || helpers_1.Long.UZERO).toString());
        message.limit !== undefined && (obj.limit = (message.limit || helpers_1.Long.UZERO).toString());
        if (message.txs) {
            obj.txs = message.txs.map((e) => (e ? exports.TxResponse.toJSON(e) : undefined));
        }
        else {
            obj.txs = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseSearchTxsResult();
        message.totalCount =
            object.totalCount !== undefined && object.totalCount !== null
                ? helpers_1.Long.fromValue(object.totalCount)
                : helpers_1.Long.UZERO;
        message.count =
            object.count !== undefined && object.count !== null ? helpers_1.Long.fromValue(object.count) : helpers_1.Long.UZERO;
        message.pageNumber =
            object.pageNumber !== undefined && object.pageNumber !== null
                ? helpers_1.Long.fromValue(object.pageNumber)
                : helpers_1.Long.UZERO;
        message.pageTotal =
            object.pageTotal !== undefined && object.pageTotal !== null
                ? helpers_1.Long.fromValue(object.pageTotal)
                : helpers_1.Long.UZERO;
        message.limit =
            object.limit !== undefined && object.limit !== null ? helpers_1.Long.fromValue(object.limit) : helpers_1.Long.UZERO;
        message.txs = object.txs?.map((e) => exports.TxResponse.fromPartial(e)) || [];
        return message;
    },
};
//# sourceMappingURL=abci.js.map

/***/ }),

/***/ 84043:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PageResponse = exports.PageRequest = exports.protobufPackage = void 0;
/* eslint-disable */
const helpers_1 = __webpack_require__(92654);
const _m0 = __importStar(__webpack_require__(62100));
exports.protobufPackage = "cosmos.base.query.v1beta1";
function createBasePageRequest() {
    return {
        key: new Uint8Array(),
        offset: helpers_1.Long.UZERO,
        limit: helpers_1.Long.UZERO,
        countTotal: false,
        reverse: false,
    };
}
exports.PageRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.key.length !== 0) {
            writer.uint32(10).bytes(message.key);
        }
        if (!message.offset.isZero()) {
            writer.uint32(16).uint64(message.offset);
        }
        if (!message.limit.isZero()) {
            writer.uint32(24).uint64(message.limit);
        }
        if (message.countTotal === true) {
            writer.uint32(32).bool(message.countTotal);
        }
        if (message.reverse === true) {
            writer.uint32(40).bool(message.reverse);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePageRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.key = reader.bytes();
                    break;
                case 2:
                    message.offset = reader.uint64();
                    break;
                case 3:
                    message.limit = reader.uint64();
                    break;
                case 4:
                    message.countTotal = reader.bool();
                    break;
                case 5:
                    message.reverse = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            key: (0, helpers_1.isSet)(object.key) ? (0, helpers_1.bytesFromBase64)(object.key) : new Uint8Array(),
            offset: (0, helpers_1.isSet)(object.offset) ? helpers_1.Long.fromValue(object.offset) : helpers_1.Long.UZERO,
            limit: (0, helpers_1.isSet)(object.limit) ? helpers_1.Long.fromValue(object.limit) : helpers_1.Long.UZERO,
            countTotal: (0, helpers_1.isSet)(object.countTotal) ? Boolean(object.countTotal) : false,
            reverse: (0, helpers_1.isSet)(object.reverse) ? Boolean(object.reverse) : false,
        };
    },
    toJSON(message) {
        const obj = {};
        message.key !== undefined &&
            (obj.key = (0, helpers_1.base64FromBytes)(message.key !== undefined ? message.key : new Uint8Array()));
        message.offset !== undefined && (obj.offset = (message.offset || helpers_1.Long.UZERO).toString());
        message.limit !== undefined && (obj.limit = (message.limit || helpers_1.Long.UZERO).toString());
        message.countTotal !== undefined && (obj.countTotal = message.countTotal);
        message.reverse !== undefined && (obj.reverse = message.reverse);
        return obj;
    },
    fromPartial(object) {
        const message = createBasePageRequest();
        message.key = object.key ?? new Uint8Array();
        message.offset =
            object.offset !== undefined && object.offset !== null ? helpers_1.Long.fromValue(object.offset) : helpers_1.Long.UZERO;
        message.limit =
            object.limit !== undefined && object.limit !== null ? helpers_1.Long.fromValue(object.limit) : helpers_1.Long.UZERO;
        message.countTotal = object.countTotal ?? false;
        message.reverse = object.reverse ?? false;
        return message;
    },
};
function createBasePageResponse() {
    return {
        nextKey: new Uint8Array(),
        total: helpers_1.Long.UZERO,
    };
}
exports.PageResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.nextKey.length !== 0) {
            writer.uint32(10).bytes(message.nextKey);
        }
        if (!message.total.isZero()) {
            writer.uint32(16).uint64(message.total);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePageResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.nextKey = reader.bytes();
                    break;
                case 2:
                    message.total = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            nextKey: (0, helpers_1.isSet)(object.nextKey) ? (0, helpers_1.bytesFromBase64)(object.nextKey) : new Uint8Array(),
            total: (0, helpers_1.isSet)(object.total) ? helpers_1.Long.fromValue(object.total) : helpers_1.Long.UZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        message.nextKey !== undefined &&
            (obj.nextKey = (0, helpers_1.base64FromBytes)(message.nextKey !== undefined ? message.nextKey : new Uint8Array()));
        message.total !== undefined && (obj.total = (message.total || helpers_1.Long.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        const message = createBasePageResponse();
        message.nextKey = object.nextKey ?? new Uint8Array();
        message.total =
            object.total !== undefined && object.total !== null ? helpers_1.Long.fromValue(object.total) : helpers_1.Long.UZERO;
        return message;
    },
};
//# sourceMappingURL=pagination.js.map

/***/ }),

/***/ 81637:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.DecProto = exports.IntProto = exports.DecCoin = exports.Coin = exports.protobufPackage = void 0;
/* eslint-disable */
const _m0 = __importStar(__webpack_require__(62100));
const helpers_1 = __webpack_require__(92654);
exports.protobufPackage = "cosmos.base.v1beta1";
function createBaseCoin() {
    return {
        denom: "",
        amount: "",
    };
}
exports.Coin = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.denom !== "") {
            writer.uint32(10).string(message.denom);
        }
        if (message.amount !== "") {
            writer.uint32(18).string(message.amount);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCoin();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.denom = reader.string();
                    break;
                case 2:
                    message.amount = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            denom: (0, helpers_1.isSet)(object.denom) ? String(object.denom) : "",
            amount: (0, helpers_1.isSet)(object.amount) ? String(object.amount) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.denom !== undefined && (obj.denom = message.denom);
        message.amount !== undefined && (obj.amount = message.amount);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseCoin();
        message.denom = object.denom ?? "";
        message.amount = object.amount ?? "";
        return message;
    },
};
function createBaseDecCoin() {
    return {
        denom: "",
        amount: "",
    };
}
exports.DecCoin = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.denom !== "") {
            writer.uint32(10).string(message.denom);
        }
        if (message.amount !== "") {
            writer.uint32(18).string(message.amount);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDecCoin();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.denom = reader.string();
                    break;
                case 2:
                    message.amount = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            denom: (0, helpers_1.isSet)(object.denom) ? String(object.denom) : "",
            amount: (0, helpers_1.isSet)(object.amount) ? String(object.amount) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.denom !== undefined && (obj.denom = message.denom);
        message.amount !== undefined && (obj.amount = message.amount);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseDecCoin();
        message.denom = object.denom ?? "";
        message.amount = object.amount ?? "";
        return message;
    },
};
function createBaseIntProto() {
    return {
        int: "",
    };
}
exports.IntProto = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.int !== "") {
            writer.uint32(10).string(message.int);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseIntProto();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.int = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            int: (0, helpers_1.isSet)(object.int) ? String(object.int) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.int !== undefined && (obj.int = message.int);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseIntProto();
        message.int = object.int ?? "";
        return message;
    },
};
function createBaseDecProto() {
    return {
        dec: "",
    };
}
exports.DecProto = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.dec !== "") {
            writer.uint32(10).string(message.dec);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDecProto();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.dec = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            dec: (0, helpers_1.isSet)(object.dec) ? String(object.dec) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.dec !== undefined && (obj.dec = message.dec);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseDecProto();
        message.dec = object.dec ?? "";
        return message;
    },
};
//# sourceMappingURL=coin.js.map

/***/ }),

/***/ 72360:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PrivKey = exports.PubKey = exports.protobufPackage = void 0;
/* eslint-disable */
const _m0 = __importStar(__webpack_require__(62100));
const helpers_1 = __webpack_require__(92654);
exports.protobufPackage = "cosmos.crypto.ed25519";
function createBasePubKey() {
    return {
        key: new Uint8Array(),
    };
}
exports.PubKey = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.key.length !== 0) {
            writer.uint32(10).bytes(message.key);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePubKey();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.key = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            key: (0, helpers_1.isSet)(object.key) ? (0, helpers_1.bytesFromBase64)(object.key) : new Uint8Array(),
        };
    },
    toJSON(message) {
        const obj = {};
        message.key !== undefined &&
            (obj.key = (0, helpers_1.base64FromBytes)(message.key !== undefined ? message.key : new Uint8Array()));
        return obj;
    },
    fromPartial(object) {
        const message = createBasePubKey();
        message.key = object.key ?? new Uint8Array();
        return message;
    },
};
function createBasePrivKey() {
    return {
        key: new Uint8Array(),
    };
}
exports.PrivKey = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.key.length !== 0) {
            writer.uint32(10).bytes(message.key);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePrivKey();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.key = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            key: (0, helpers_1.isSet)(object.key) ? (0, helpers_1.bytesFromBase64)(object.key) : new Uint8Array(),
        };
    },
    toJSON(message) {
        const obj = {};
        message.key !== undefined &&
            (obj.key = (0, helpers_1.base64FromBytes)(message.key !== undefined ? message.key : new Uint8Array()));
        return obj;
    },
    fromPartial(object) {
        const message = createBasePrivKey();
        message.key = object.key ?? new Uint8Array();
        return message;
    },
};
//# sourceMappingURL=keys.js.map

/***/ }),

/***/ 51574:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.LegacyAminoPubKey = exports.protobufPackage = void 0;
/* eslint-disable */
const any_1 = __webpack_require__(75654);
const _m0 = __importStar(__webpack_require__(62100));
const helpers_1 = __webpack_require__(92654);
exports.protobufPackage = "cosmos.crypto.multisig";
function createBaseLegacyAminoPubKey() {
    return {
        threshold: 0,
        publicKeys: [],
    };
}
exports.LegacyAminoPubKey = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.threshold !== 0) {
            writer.uint32(8).uint32(message.threshold);
        }
        for (const v of message.publicKeys) {
            any_1.Any.encode(v, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseLegacyAminoPubKey();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.threshold = reader.uint32();
                    break;
                case 2:
                    message.publicKeys.push(any_1.Any.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            threshold: (0, helpers_1.isSet)(object.threshold) ? Number(object.threshold) : 0,
            publicKeys: Array.isArray(object?.publicKeys) ? object.publicKeys.map((e) => any_1.Any.fromJSON(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        message.threshold !== undefined && (obj.threshold = Math.round(message.threshold));
        if (message.publicKeys) {
            obj.publicKeys = message.publicKeys.map((e) => (e ? any_1.Any.toJSON(e) : undefined));
        }
        else {
            obj.publicKeys = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseLegacyAminoPubKey();
        message.threshold = object.threshold ?? 0;
        message.publicKeys = object.publicKeys?.map((e) => any_1.Any.fromPartial(e)) || [];
        return message;
    },
};
//# sourceMappingURL=keys.js.map

/***/ }),

/***/ 50140:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CompactBitArray = exports.MultiSignature = exports.protobufPackage = void 0;
/* eslint-disable */
const _m0 = __importStar(__webpack_require__(62100));
const helpers_1 = __webpack_require__(92654);
exports.protobufPackage = "cosmos.crypto.multisig.v1beta1";
function createBaseMultiSignature() {
    return {
        signatures: [],
    };
}
exports.MultiSignature = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.signatures) {
            writer.uint32(10).bytes(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMultiSignature();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.signatures.push(reader.bytes());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            signatures: Array.isArray(object?.signatures)
                ? object.signatures.map((e) => (0, helpers_1.bytesFromBase64)(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.signatures) {
            obj.signatures = message.signatures.map((e) => (0, helpers_1.base64FromBytes)(e !== undefined ? e : new Uint8Array()));
        }
        else {
            obj.signatures = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMultiSignature();
        message.signatures = object.signatures?.map((e) => e) || [];
        return message;
    },
};
function createBaseCompactBitArray() {
    return {
        extraBitsStored: 0,
        elems: new Uint8Array(),
    };
}
exports.CompactBitArray = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.extraBitsStored !== 0) {
            writer.uint32(8).uint32(message.extraBitsStored);
        }
        if (message.elems.length !== 0) {
            writer.uint32(18).bytes(message.elems);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCompactBitArray();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.extraBitsStored = reader.uint32();
                    break;
                case 2:
                    message.elems = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            extraBitsStored: (0, helpers_1.isSet)(object.extraBitsStored) ? Number(object.extraBitsStored) : 0,
            elems: (0, helpers_1.isSet)(object.elems) ? (0, helpers_1.bytesFromBase64)(object.elems) : new Uint8Array(),
        };
    },
    toJSON(message) {
        const obj = {};
        message.extraBitsStored !== undefined && (obj.extraBitsStored = Math.round(message.extraBitsStored));
        message.elems !== undefined &&
            (obj.elems = (0, helpers_1.base64FromBytes)(message.elems !== undefined ? message.elems : new Uint8Array()));
        return obj;
    },
    fromPartial(object) {
        const message = createBaseCompactBitArray();
        message.extraBitsStored = object.extraBitsStored ?? 0;
        message.elems = object.elems ?? new Uint8Array();
        return message;
    },
};
//# sourceMappingURL=multisig.js.map

/***/ }),

/***/ 64277:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PrivKey = exports.PubKey = exports.protobufPackage = void 0;
/* eslint-disable */
const _m0 = __importStar(__webpack_require__(62100));
const helpers_1 = __webpack_require__(92654);
exports.protobufPackage = "cosmos.crypto.secp256k1";
function createBasePubKey() {
    return {
        key: new Uint8Array(),
    };
}
exports.PubKey = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.key.length !== 0) {
            writer.uint32(10).bytes(message.key);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePubKey();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.key = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            key: (0, helpers_1.isSet)(object.key) ? (0, helpers_1.bytesFromBase64)(object.key) : new Uint8Array(),
        };
    },
    toJSON(message) {
        const obj = {};
        message.key !== undefined &&
            (obj.key = (0, helpers_1.base64FromBytes)(message.key !== undefined ? message.key : new Uint8Array()));
        return obj;
    },
    fromPartial(object) {
        const message = createBasePubKey();
        message.key = object.key ?? new Uint8Array();
        return message;
    },
};
function createBasePrivKey() {
    return {
        key: new Uint8Array(),
    };
}
exports.PrivKey = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.key.length !== 0) {
            writer.uint32(10).bytes(message.key);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePrivKey();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.key = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            key: (0, helpers_1.isSet)(object.key) ? (0, helpers_1.bytesFromBase64)(object.key) : new Uint8Array(),
        };
    },
    toJSON(message) {
        const obj = {};
        message.key !== undefined &&
            (obj.key = (0, helpers_1.base64FromBytes)(message.key !== undefined ? message.key : new Uint8Array()));
        return obj;
    },
    fromPartial(object) {
        const message = createBasePrivKey();
        message.key = object.key ?? new Uint8Array();
        return message;
    },
};
//# sourceMappingURL=keys.js.map

/***/ }),

/***/ 45280:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CommunityPoolSpendProposalWithDeposit = exports.DelegationDelegatorReward = exports.DelegatorStartingInfo = exports.CommunityPoolSpendProposal = exports.FeePool = exports.ValidatorSlashEvents = exports.ValidatorSlashEvent = exports.ValidatorOutstandingRewards = exports.ValidatorAccumulatedCommission = exports.ValidatorCurrentRewards = exports.ValidatorHistoricalRewards = exports.Params = exports.protobufPackage = void 0;
/* eslint-disable */
const coin_1 = __webpack_require__(81637);
const helpers_1 = __webpack_require__(92654);
const _m0 = __importStar(__webpack_require__(62100));
exports.protobufPackage = "cosmos.distribution.v1beta1";
function createBaseParams() {
    return {
        communityTax: "",
        baseProposerReward: "",
        bonusProposerReward: "",
        withdrawAddrEnabled: false,
    };
}
exports.Params = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.communityTax !== "") {
            writer.uint32(10).string(message.communityTax);
        }
        if (message.baseProposerReward !== "") {
            writer.uint32(18).string(message.baseProposerReward);
        }
        if (message.bonusProposerReward !== "") {
            writer.uint32(26).string(message.bonusProposerReward);
        }
        if (message.withdrawAddrEnabled === true) {
            writer.uint32(32).bool(message.withdrawAddrEnabled);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseParams();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.communityTax = reader.string();
                    break;
                case 2:
                    message.baseProposerReward = reader.string();
                    break;
                case 3:
                    message.bonusProposerReward = reader.string();
                    break;
                case 4:
                    message.withdrawAddrEnabled = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            communityTax: (0, helpers_1.isSet)(object.communityTax) ? String(object.communityTax) : "",
            baseProposerReward: (0, helpers_1.isSet)(object.baseProposerReward) ? String(object.baseProposerReward) : "",
            bonusProposerReward: (0, helpers_1.isSet)(object.bonusProposerReward) ? String(object.bonusProposerReward) : "",
            withdrawAddrEnabled: (0, helpers_1.isSet)(object.withdrawAddrEnabled) ? Boolean(object.withdrawAddrEnabled) : false,
        };
    },
    toJSON(message) {
        const obj = {};
        message.communityTax !== undefined && (obj.communityTax = message.communityTax);
        message.baseProposerReward !== undefined && (obj.baseProposerReward = message.baseProposerReward);
        message.bonusProposerReward !== undefined && (obj.bonusProposerReward = message.bonusProposerReward);
        message.withdrawAddrEnabled !== undefined && (obj.withdrawAddrEnabled = message.withdrawAddrEnabled);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseParams();
        message.communityTax = object.communityTax ?? "";
        message.baseProposerReward = object.baseProposerReward ?? "";
        message.bonusProposerReward = object.bonusProposerReward ?? "";
        message.withdrawAddrEnabled = object.withdrawAddrEnabled ?? false;
        return message;
    },
};
function createBaseValidatorHistoricalRewards() {
    return {
        cumulativeRewardRatio: [],
        referenceCount: 0,
    };
}
exports.ValidatorHistoricalRewards = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.cumulativeRewardRatio) {
            coin_1.DecCoin.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.referenceCount !== 0) {
            writer.uint32(16).uint32(message.referenceCount);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseValidatorHistoricalRewards();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.cumulativeRewardRatio.push(coin_1.DecCoin.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.referenceCount = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            cumulativeRewardRatio: Array.isArray(object?.cumulativeRewardRatio)
                ? object.cumulativeRewardRatio.map((e) => coin_1.DecCoin.fromJSON(e))
                : [],
            referenceCount: (0, helpers_1.isSet)(object.referenceCount) ? Number(object.referenceCount) : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.cumulativeRewardRatio) {
            obj.cumulativeRewardRatio = message.cumulativeRewardRatio.map((e) => e ? coin_1.DecCoin.toJSON(e) : undefined);
        }
        else {
            obj.cumulativeRewardRatio = [];
        }
        message.referenceCount !== undefined && (obj.referenceCount = Math.round(message.referenceCount));
        return obj;
    },
    fromPartial(object) {
        const message = createBaseValidatorHistoricalRewards();
        message.cumulativeRewardRatio = object.cumulativeRewardRatio?.map((e) => coin_1.DecCoin.fromPartial(e)) || [];
        message.referenceCount = object.referenceCount ?? 0;
        return message;
    },
};
function createBaseValidatorCurrentRewards() {
    return {
        rewards: [],
        period: helpers_1.Long.UZERO,
    };
}
exports.ValidatorCurrentRewards = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.rewards) {
            coin_1.DecCoin.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (!message.period.isZero()) {
            writer.uint32(16).uint64(message.period);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseValidatorCurrentRewards();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.rewards.push(coin_1.DecCoin.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.period = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            rewards: Array.isArray(object?.rewards) ? object.rewards.map((e) => coin_1.DecCoin.fromJSON(e)) : [],
            period: (0, helpers_1.isSet)(object.period) ? helpers_1.Long.fromValue(object.period) : helpers_1.Long.UZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.rewards) {
            obj.rewards = message.rewards.map((e) => (e ? coin_1.DecCoin.toJSON(e) : undefined));
        }
        else {
            obj.rewards = [];
        }
        message.period !== undefined && (obj.period = (message.period || helpers_1.Long.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseValidatorCurrentRewards();
        message.rewards = object.rewards?.map((e) => coin_1.DecCoin.fromPartial(e)) || [];
        message.period =
            object.period !== undefined && object.period !== null ? helpers_1.Long.fromValue(object.period) : helpers_1.Long.UZERO;
        return message;
    },
};
function createBaseValidatorAccumulatedCommission() {
    return {
        commission: [],
    };
}
exports.ValidatorAccumulatedCommission = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.commission) {
            coin_1.DecCoin.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseValidatorAccumulatedCommission();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.commission.push(coin_1.DecCoin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            commission: Array.isArray(object?.commission)
                ? object.commission.map((e) => coin_1.DecCoin.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.commission) {
            obj.commission = message.commission.map((e) => (e ? coin_1.DecCoin.toJSON(e) : undefined));
        }
        else {
            obj.commission = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseValidatorAccumulatedCommission();
        message.commission = object.commission?.map((e) => coin_1.DecCoin.fromPartial(e)) || [];
        return message;
    },
};
function createBaseValidatorOutstandingRewards() {
    return {
        rewards: [],
    };
}
exports.ValidatorOutstandingRewards = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.rewards) {
            coin_1.DecCoin.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseValidatorOutstandingRewards();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.rewards.push(coin_1.DecCoin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            rewards: Array.isArray(object?.rewards) ? object.rewards.map((e) => coin_1.DecCoin.fromJSON(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.rewards) {
            obj.rewards = message.rewards.map((e) => (e ? coin_1.DecCoin.toJSON(e) : undefined));
        }
        else {
            obj.rewards = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseValidatorOutstandingRewards();
        message.rewards = object.rewards?.map((e) => coin_1.DecCoin.fromPartial(e)) || [];
        return message;
    },
};
function createBaseValidatorSlashEvent() {
    return {
        validatorPeriod: helpers_1.Long.UZERO,
        fraction: "",
    };
}
exports.ValidatorSlashEvent = {
    encode(message, writer = _m0.Writer.create()) {
        if (!message.validatorPeriod.isZero()) {
            writer.uint32(8).uint64(message.validatorPeriod);
        }
        if (message.fraction !== "") {
            writer.uint32(18).string(message.fraction);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseValidatorSlashEvent();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.validatorPeriod = reader.uint64();
                    break;
                case 2:
                    message.fraction = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            validatorPeriod: (0, helpers_1.isSet)(object.validatorPeriod) ? helpers_1.Long.fromValue(object.validatorPeriod) : helpers_1.Long.UZERO,
            fraction: (0, helpers_1.isSet)(object.fraction) ? String(object.fraction) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.validatorPeriod !== undefined &&
            (obj.validatorPeriod = (message.validatorPeriod || helpers_1.Long.UZERO).toString());
        message.fraction !== undefined && (obj.fraction = message.fraction);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseValidatorSlashEvent();
        message.validatorPeriod =
            object.validatorPeriod !== undefined && object.validatorPeriod !== null
                ? helpers_1.Long.fromValue(object.validatorPeriod)
                : helpers_1.Long.UZERO;
        message.fraction = object.fraction ?? "";
        return message;
    },
};
function createBaseValidatorSlashEvents() {
    return {
        validatorSlashEvents: [],
    };
}
exports.ValidatorSlashEvents = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.validatorSlashEvents) {
            exports.ValidatorSlashEvent.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseValidatorSlashEvents();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.validatorSlashEvents.push(exports.ValidatorSlashEvent.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            validatorSlashEvents: Array.isArray(object?.validatorSlashEvents)
                ? object.validatorSlashEvents.map((e) => exports.ValidatorSlashEvent.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.validatorSlashEvents) {
            obj.validatorSlashEvents = message.validatorSlashEvents.map((e) => e ? exports.ValidatorSlashEvent.toJSON(e) : undefined);
        }
        else {
            obj.validatorSlashEvents = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseValidatorSlashEvents();
        message.validatorSlashEvents =
            object.validatorSlashEvents?.map((e) => exports.ValidatorSlashEvent.fromPartial(e)) || [];
        return message;
    },
};
function createBaseFeePool() {
    return {
        communityPool: [],
    };
}
exports.FeePool = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.communityPool) {
            coin_1.DecCoin.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseFeePool();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.communityPool.push(coin_1.DecCoin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            communityPool: Array.isArray(object?.communityPool)
                ? object.communityPool.map((e) => coin_1.DecCoin.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.communityPool) {
            obj.communityPool = message.communityPool.map((e) => (e ? coin_1.DecCoin.toJSON(e) : undefined));
        }
        else {
            obj.communityPool = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseFeePool();
        message.communityPool = object.communityPool?.map((e) => coin_1.DecCoin.fromPartial(e)) || [];
        return message;
    },
};
function createBaseCommunityPoolSpendProposal() {
    return {
        title: "",
        description: "",
        recipient: "",
        amount: [],
    };
}
exports.CommunityPoolSpendProposal = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.title !== "") {
            writer.uint32(10).string(message.title);
        }
        if (message.description !== "") {
            writer.uint32(18).string(message.description);
        }
        if (message.recipient !== "") {
            writer.uint32(26).string(message.recipient);
        }
        for (const v of message.amount) {
            coin_1.Coin.encode(v, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCommunityPoolSpendProposal();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.title = reader.string();
                    break;
                case 2:
                    message.description = reader.string();
                    break;
                case 3:
                    message.recipient = reader.string();
                    break;
                case 4:
                    message.amount.push(coin_1.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            title: (0, helpers_1.isSet)(object.title) ? String(object.title) : "",
            description: (0, helpers_1.isSet)(object.description) ? String(object.description) : "",
            recipient: (0, helpers_1.isSet)(object.recipient) ? String(object.recipient) : "",
            amount: Array.isArray(object?.amount) ? object.amount.map((e) => coin_1.Coin.fromJSON(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        message.title !== undefined && (obj.title = message.title);
        message.description !== undefined && (obj.description = message.description);
        message.recipient !== undefined && (obj.recipient = message.recipient);
        if (message.amount) {
            obj.amount = message.amount.map((e) => (e ? coin_1.Coin.toJSON(e) : undefined));
        }
        else {
            obj.amount = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseCommunityPoolSpendProposal();
        message.title = object.title ?? "";
        message.description = object.description ?? "";
        message.recipient = object.recipient ?? "";
        message.amount = object.amount?.map((e) => coin_1.Coin.fromPartial(e)) || [];
        return message;
    },
};
function createBaseDelegatorStartingInfo() {
    return {
        previousPeriod: helpers_1.Long.UZERO,
        stake: "",
        height: helpers_1.Long.UZERO,
    };
}
exports.DelegatorStartingInfo = {
    encode(message, writer = _m0.Writer.create()) {
        if (!message.previousPeriod.isZero()) {
            writer.uint32(8).uint64(message.previousPeriod);
        }
        if (message.stake !== "") {
            writer.uint32(18).string(message.stake);
        }
        if (!message.height.isZero()) {
            writer.uint32(24).uint64(message.height);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDelegatorStartingInfo();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.previousPeriod = reader.uint64();
                    break;
                case 2:
                    message.stake = reader.string();
                    break;
                case 3:
                    message.height = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            previousPeriod: (0, helpers_1.isSet)(object.previousPeriod) ? helpers_1.Long.fromValue(object.previousPeriod) : helpers_1.Long.UZERO,
            stake: (0, helpers_1.isSet)(object.stake) ? String(object.stake) : "",
            height: (0, helpers_1.isSet)(object.height) ? helpers_1.Long.fromValue(object.height) : helpers_1.Long.UZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        message.previousPeriod !== undefined &&
            (obj.previousPeriod = (message.previousPeriod || helpers_1.Long.UZERO).toString());
        message.stake !== undefined && (obj.stake = message.stake);
        message.height !== undefined && (obj.height = (message.height || helpers_1.Long.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseDelegatorStartingInfo();
        message.previousPeriod =
            object.previousPeriod !== undefined && object.previousPeriod !== null
                ? helpers_1.Long.fromValue(object.previousPeriod)
                : helpers_1.Long.UZERO;
        message.stake = object.stake ?? "";
        message.height =
            object.height !== undefined && object.height !== null ? helpers_1.Long.fromValue(object.height) : helpers_1.Long.UZERO;
        return message;
    },
};
function createBaseDelegationDelegatorReward() {
    return {
        validatorAddress: "",
        reward: [],
    };
}
exports.DelegationDelegatorReward = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.validatorAddress !== "") {
            writer.uint32(10).string(message.validatorAddress);
        }
        for (const v of message.reward) {
            coin_1.DecCoin.encode(v, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDelegationDelegatorReward();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.validatorAddress = reader.string();
                    break;
                case 2:
                    message.reward.push(coin_1.DecCoin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            validatorAddress: (0, helpers_1.isSet)(object.validatorAddress) ? String(object.validatorAddress) : "",
            reward: Array.isArray(object?.reward) ? object.reward.map((e) => coin_1.DecCoin.fromJSON(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        if (message.reward) {
            obj.reward = message.reward.map((e) => (e ? coin_1.DecCoin.toJSON(e) : undefined));
        }
        else {
            obj.reward = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseDelegationDelegatorReward();
        message.validatorAddress = object.validatorAddress ?? "";
        message.reward = object.reward?.map((e) => coin_1.DecCoin.fromPartial(e)) || [];
        return message;
    },
};
function createBaseCommunityPoolSpendProposalWithDeposit() {
    return {
        title: "",
        description: "",
        recipient: "",
        amount: "",
        deposit: "",
    };
}
exports.CommunityPoolSpendProposalWithDeposit = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.title !== "") {
            writer.uint32(10).string(message.title);
        }
        if (message.description !== "") {
            writer.uint32(18).string(message.description);
        }
        if (message.recipient !== "") {
            writer.uint32(26).string(message.recipient);
        }
        if (message.amount !== "") {
            writer.uint32(34).string(message.amount);
        }
        if (message.deposit !== "") {
            writer.uint32(42).string(message.deposit);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCommunityPoolSpendProposalWithDeposit();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.title = reader.string();
                    break;
                case 2:
                    message.description = reader.string();
                    break;
                case 3:
                    message.recipient = reader.string();
                    break;
                case 4:
                    message.amount = reader.string();
                    break;
                case 5:
                    message.deposit = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            title: (0, helpers_1.isSet)(object.title) ? String(object.title) : "",
            description: (0, helpers_1.isSet)(object.description) ? String(object.description) : "",
            recipient: (0, helpers_1.isSet)(object.recipient) ? String(object.recipient) : "",
            amount: (0, helpers_1.isSet)(object.amount) ? String(object.amount) : "",
            deposit: (0, helpers_1.isSet)(object.deposit) ? String(object.deposit) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.title !== undefined && (obj.title = message.title);
        message.description !== undefined && (obj.description = message.description);
        message.recipient !== undefined && (obj.recipient = message.recipient);
        message.amount !== undefined && (obj.amount = message.amount);
        message.deposit !== undefined && (obj.deposit = message.deposit);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseCommunityPoolSpendProposalWithDeposit();
        message.title = object.title ?? "";
        message.description = object.description ?? "";
        message.recipient = object.recipient ?? "";
        message.amount = object.amount ?? "";
        message.deposit = object.deposit ?? "";
        return message;
    },
};
//# sourceMappingURL=distribution.js.map

/***/ }),

/***/ 72731:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.QueryClientImpl = exports.QueryCommunityPoolResponse = exports.QueryCommunityPoolRequest = exports.QueryDelegatorWithdrawAddressResponse = exports.QueryDelegatorWithdrawAddressRequest = exports.QueryDelegatorValidatorsResponse = exports.QueryDelegatorValidatorsRequest = exports.QueryDelegationTotalRewardsResponse = exports.QueryDelegationTotalRewardsRequest = exports.QueryDelegationRewardsResponse = exports.QueryDelegationRewardsRequest = exports.QueryValidatorSlashesResponse = exports.QueryValidatorSlashesRequest = exports.QueryValidatorCommissionResponse = exports.QueryValidatorCommissionRequest = exports.QueryValidatorOutstandingRewardsResponse = exports.QueryValidatorOutstandingRewardsRequest = exports.QueryValidatorDistributionInfoResponse = exports.QueryValidatorDistributionInfoRequest = exports.QueryParamsResponse = exports.QueryParamsRequest = exports.protobufPackage = void 0;
/* eslint-disable */
const pagination_1 = __webpack_require__(84043);
const distribution_1 = __webpack_require__(45280);
const coin_1 = __webpack_require__(81637);
const helpers_1 = __webpack_require__(92654);
const _m0 = __importStar(__webpack_require__(62100));
exports.protobufPackage = "cosmos.distribution.v1beta1";
function createBaseQueryParamsRequest() {
    return {};
}
exports.QueryParamsRequest = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryParamsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseQueryParamsRequest();
        return message;
    },
};
function createBaseQueryParamsResponse() {
    return {
        params: undefined,
    };
}
exports.QueryParamsResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.params !== undefined) {
            distribution_1.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryParamsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.params = distribution_1.Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            params: (0, helpers_1.isSet)(object.params) ? distribution_1.Params.fromJSON(object.params) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.params !== undefined && (obj.params = message.params ? distribution_1.Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryParamsResponse();
        message.params =
            object.params !== undefined && object.params !== null ? distribution_1.Params.fromPartial(object.params) : undefined;
        return message;
    },
};
function createBaseQueryValidatorDistributionInfoRequest() {
    return {
        validatorAddress: "",
    };
}
exports.QueryValidatorDistributionInfoRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.validatorAddress !== "") {
            writer.uint32(10).string(message.validatorAddress);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryValidatorDistributionInfoRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.validatorAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            validatorAddress: (0, helpers_1.isSet)(object.validatorAddress) ? String(object.validatorAddress) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryValidatorDistributionInfoRequest();
        message.validatorAddress = object.validatorAddress ?? "";
        return message;
    },
};
function createBaseQueryValidatorDistributionInfoResponse() {
    return {
        operatorAddress: "",
        selfBondRewards: [],
        commission: [],
    };
}
exports.QueryValidatorDistributionInfoResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.operatorAddress !== "") {
            writer.uint32(10).string(message.operatorAddress);
        }
        for (const v of message.selfBondRewards) {
            coin_1.DecCoin.encode(v, writer.uint32(18).fork()).ldelim();
        }
        for (const v of message.commission) {
            coin_1.DecCoin.encode(v, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryValidatorDistributionInfoResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.operatorAddress = reader.string();
                    break;
                case 2:
                    message.selfBondRewards.push(coin_1.DecCoin.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.commission.push(coin_1.DecCoin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            operatorAddress: (0, helpers_1.isSet)(object.operatorAddress) ? String(object.operatorAddress) : "",
            selfBondRewards: Array.isArray(object?.selfBondRewards)
                ? object.selfBondRewards.map((e) => coin_1.DecCoin.fromJSON(e))
                : [],
            commission: Array.isArray(object?.commission)
                ? object.commission.map((e) => coin_1.DecCoin.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        message.operatorAddress !== undefined && (obj.operatorAddress = message.operatorAddress);
        if (message.selfBondRewards) {
            obj.selfBondRewards = message.selfBondRewards.map((e) => (e ? coin_1.DecCoin.toJSON(e) : undefined));
        }
        else {
            obj.selfBondRewards = [];
        }
        if (message.commission) {
            obj.commission = message.commission.map((e) => (e ? coin_1.DecCoin.toJSON(e) : undefined));
        }
        else {
            obj.commission = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryValidatorDistributionInfoResponse();
        message.operatorAddress = object.operatorAddress ?? "";
        message.selfBondRewards = object.selfBondRewards?.map((e) => coin_1.DecCoin.fromPartial(e)) || [];
        message.commission = object.commission?.map((e) => coin_1.DecCoin.fromPartial(e)) || [];
        return message;
    },
};
function createBaseQueryValidatorOutstandingRewardsRequest() {
    return {
        validatorAddress: "",
    };
}
exports.QueryValidatorOutstandingRewardsRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.validatorAddress !== "") {
            writer.uint32(10).string(message.validatorAddress);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryValidatorOutstandingRewardsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.validatorAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            validatorAddress: (0, helpers_1.isSet)(object.validatorAddress) ? String(object.validatorAddress) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryValidatorOutstandingRewardsRequest();
        message.validatorAddress = object.validatorAddress ?? "";
        return message;
    },
};
function createBaseQueryValidatorOutstandingRewardsResponse() {
    return {
        rewards: undefined,
    };
}
exports.QueryValidatorOutstandingRewardsResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.rewards !== undefined) {
            distribution_1.ValidatorOutstandingRewards.encode(message.rewards, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryValidatorOutstandingRewardsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.rewards = distribution_1.ValidatorOutstandingRewards.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            rewards: (0, helpers_1.isSet)(object.rewards) ? distribution_1.ValidatorOutstandingRewards.fromJSON(object.rewards) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.rewards !== undefined &&
            (obj.rewards = message.rewards ? distribution_1.ValidatorOutstandingRewards.toJSON(message.rewards) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryValidatorOutstandingRewardsResponse();
        message.rewards =
            object.rewards !== undefined && object.rewards !== null
                ? distribution_1.ValidatorOutstandingRewards.fromPartial(object.rewards)
                : undefined;
        return message;
    },
};
function createBaseQueryValidatorCommissionRequest() {
    return {
        validatorAddress: "",
    };
}
exports.QueryValidatorCommissionRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.validatorAddress !== "") {
            writer.uint32(10).string(message.validatorAddress);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryValidatorCommissionRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.validatorAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            validatorAddress: (0, helpers_1.isSet)(object.validatorAddress) ? String(object.validatorAddress) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryValidatorCommissionRequest();
        message.validatorAddress = object.validatorAddress ?? "";
        return message;
    },
};
function createBaseQueryValidatorCommissionResponse() {
    return {
        commission: undefined,
    };
}
exports.QueryValidatorCommissionResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.commission !== undefined) {
            distribution_1.ValidatorAccumulatedCommission.encode(message.commission, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryValidatorCommissionResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.commission = distribution_1.ValidatorAccumulatedCommission.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            commission: (0, helpers_1.isSet)(object.commission)
                ? distribution_1.ValidatorAccumulatedCommission.fromJSON(object.commission)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.commission !== undefined &&
            (obj.commission = message.commission
                ? distribution_1.ValidatorAccumulatedCommission.toJSON(message.commission)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryValidatorCommissionResponse();
        message.commission =
            object.commission !== undefined && object.commission !== null
                ? distribution_1.ValidatorAccumulatedCommission.fromPartial(object.commission)
                : undefined;
        return message;
    },
};
function createBaseQueryValidatorSlashesRequest() {
    return {
        validatorAddress: "",
        startingHeight: helpers_1.Long.UZERO,
        endingHeight: helpers_1.Long.UZERO,
        pagination: undefined,
    };
}
exports.QueryValidatorSlashesRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.validatorAddress !== "") {
            writer.uint32(10).string(message.validatorAddress);
        }
        if (!message.startingHeight.isZero()) {
            writer.uint32(16).uint64(message.startingHeight);
        }
        if (!message.endingHeight.isZero()) {
            writer.uint32(24).uint64(message.endingHeight);
        }
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryValidatorSlashesRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.validatorAddress = reader.string();
                    break;
                case 2:
                    message.startingHeight = reader.uint64();
                    break;
                case 3:
                    message.endingHeight = reader.uint64();
                    break;
                case 4:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            validatorAddress: (0, helpers_1.isSet)(object.validatorAddress) ? String(object.validatorAddress) : "",
            startingHeight: (0, helpers_1.isSet)(object.startingHeight) ? helpers_1.Long.fromValue(object.startingHeight) : helpers_1.Long.UZERO,
            endingHeight: (0, helpers_1.isSet)(object.endingHeight) ? helpers_1.Long.fromValue(object.endingHeight) : helpers_1.Long.UZERO,
            pagination: (0, helpers_1.isSet)(object.pagination) ? pagination_1.PageRequest.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        message.startingHeight !== undefined &&
            (obj.startingHeight = (message.startingHeight || helpers_1.Long.UZERO).toString());
        message.endingHeight !== undefined &&
            (obj.endingHeight = (message.endingHeight || helpers_1.Long.UZERO).toString());
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryValidatorSlashesRequest();
        message.validatorAddress = object.validatorAddress ?? "";
        message.startingHeight =
            object.startingHeight !== undefined && object.startingHeight !== null
                ? helpers_1.Long.fromValue(object.startingHeight)
                : helpers_1.Long.UZERO;
        message.endingHeight =
            object.endingHeight !== undefined && object.endingHeight !== null
                ? helpers_1.Long.fromValue(object.endingHeight)
                : helpers_1.Long.UZERO;
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryValidatorSlashesResponse() {
    return {
        slashes: [],
        pagination: undefined,
    };
}
exports.QueryValidatorSlashesResponse = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.slashes) {
            distribution_1.ValidatorSlashEvent.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryValidatorSlashesResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.slashes.push(distribution_1.ValidatorSlashEvent.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            slashes: Array.isArray(object?.slashes)
                ? object.slashes.map((e) => distribution_1.ValidatorSlashEvent.fromJSON(e))
                : [],
            pagination: (0, helpers_1.isSet)(object.pagination) ? pagination_1.PageResponse.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.slashes) {
            obj.slashes = message.slashes.map((e) => (e ? distribution_1.ValidatorSlashEvent.toJSON(e) : undefined));
        }
        else {
            obj.slashes = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryValidatorSlashesResponse();
        message.slashes = object.slashes?.map((e) => distribution_1.ValidatorSlashEvent.fromPartial(e)) || [];
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryDelegationRewardsRequest() {
    return {
        delegatorAddress: "",
        validatorAddress: "",
    };
}
exports.QueryDelegationRewardsRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.delegatorAddress !== "") {
            writer.uint32(10).string(message.delegatorAddress);
        }
        if (message.validatorAddress !== "") {
            writer.uint32(18).string(message.validatorAddress);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryDelegationRewardsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            delegatorAddress: (0, helpers_1.isSet)(object.delegatorAddress) ? String(object.delegatorAddress) : "",
            validatorAddress: (0, helpers_1.isSet)(object.validatorAddress) ? String(object.validatorAddress) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryDelegationRewardsRequest();
        message.delegatorAddress = object.delegatorAddress ?? "";
        message.validatorAddress = object.validatorAddress ?? "";
        return message;
    },
};
function createBaseQueryDelegationRewardsResponse() {
    return {
        rewards: [],
    };
}
exports.QueryDelegationRewardsResponse = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.rewards) {
            coin_1.DecCoin.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryDelegationRewardsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.rewards.push(coin_1.DecCoin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            rewards: Array.isArray(object?.rewards) ? object.rewards.map((e) => coin_1.DecCoin.fromJSON(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.rewards) {
            obj.rewards = message.rewards.map((e) => (e ? coin_1.DecCoin.toJSON(e) : undefined));
        }
        else {
            obj.rewards = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryDelegationRewardsResponse();
        message.rewards = object.rewards?.map((e) => coin_1.DecCoin.fromPartial(e)) || [];
        return message;
    },
};
function createBaseQueryDelegationTotalRewardsRequest() {
    return {
        delegatorAddress: "",
    };
}
exports.QueryDelegationTotalRewardsRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.delegatorAddress !== "") {
            writer.uint32(10).string(message.delegatorAddress);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryDelegationTotalRewardsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            delegatorAddress: (0, helpers_1.isSet)(object.delegatorAddress) ? String(object.delegatorAddress) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryDelegationTotalRewardsRequest();
        message.delegatorAddress = object.delegatorAddress ?? "";
        return message;
    },
};
function createBaseQueryDelegationTotalRewardsResponse() {
    return {
        rewards: [],
        total: [],
    };
}
exports.QueryDelegationTotalRewardsResponse = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.rewards) {
            distribution_1.DelegationDelegatorReward.encode(v, writer.uint32(10).fork()).ldelim();
        }
        for (const v of message.total) {
            coin_1.DecCoin.encode(v, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryDelegationTotalRewardsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.rewards.push(distribution_1.DelegationDelegatorReward.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.total.push(coin_1.DecCoin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            rewards: Array.isArray(object?.rewards)
                ? object.rewards.map((e) => distribution_1.DelegationDelegatorReward.fromJSON(e))
                : [],
            total: Array.isArray(object?.total) ? object.total.map((e) => coin_1.DecCoin.fromJSON(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.rewards) {
            obj.rewards = message.rewards.map((e) => (e ? distribution_1.DelegationDelegatorReward.toJSON(e) : undefined));
        }
        else {
            obj.rewards = [];
        }
        if (message.total) {
            obj.total = message.total.map((e) => (e ? coin_1.DecCoin.toJSON(e) : undefined));
        }
        else {
            obj.total = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryDelegationTotalRewardsResponse();
        message.rewards = object.rewards?.map((e) => distribution_1.DelegationDelegatorReward.fromPartial(e)) || [];
        message.total = object.total?.map((e) => coin_1.DecCoin.fromPartial(e)) || [];
        return message;
    },
};
function createBaseQueryDelegatorValidatorsRequest() {
    return {
        delegatorAddress: "",
    };
}
exports.QueryDelegatorValidatorsRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.delegatorAddress !== "") {
            writer.uint32(10).string(message.delegatorAddress);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryDelegatorValidatorsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            delegatorAddress: (0, helpers_1.isSet)(object.delegatorAddress) ? String(object.delegatorAddress) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryDelegatorValidatorsRequest();
        message.delegatorAddress = object.delegatorAddress ?? "";
        return message;
    },
};
function createBaseQueryDelegatorValidatorsResponse() {
    return {
        validators: [],
    };
}
exports.QueryDelegatorValidatorsResponse = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.validators) {
            writer.uint32(10).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryDelegatorValidatorsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.validators.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            validators: Array.isArray(object?.validators) ? object.validators.map((e) => String(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.validators) {
            obj.validators = message.validators.map((e) => e);
        }
        else {
            obj.validators = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryDelegatorValidatorsResponse();
        message.validators = object.validators?.map((e) => e) || [];
        return message;
    },
};
function createBaseQueryDelegatorWithdrawAddressRequest() {
    return {
        delegatorAddress: "",
    };
}
exports.QueryDelegatorWithdrawAddressRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.delegatorAddress !== "") {
            writer.uint32(10).string(message.delegatorAddress);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryDelegatorWithdrawAddressRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            delegatorAddress: (0, helpers_1.isSet)(object.delegatorAddress) ? String(object.delegatorAddress) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryDelegatorWithdrawAddressRequest();
        message.delegatorAddress = object.delegatorAddress ?? "";
        return message;
    },
};
function createBaseQueryDelegatorWithdrawAddressResponse() {
    return {
        withdrawAddress: "",
    };
}
exports.QueryDelegatorWithdrawAddressResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.withdrawAddress !== "") {
            writer.uint32(10).string(message.withdrawAddress);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryDelegatorWithdrawAddressResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.withdrawAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            withdrawAddress: (0, helpers_1.isSet)(object.withdrawAddress) ? String(object.withdrawAddress) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.withdrawAddress !== undefined && (obj.withdrawAddress = message.withdrawAddress);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryDelegatorWithdrawAddressResponse();
        message.withdrawAddress = object.withdrawAddress ?? "";
        return message;
    },
};
function createBaseQueryCommunityPoolRequest() {
    return {};
}
exports.QueryCommunityPoolRequest = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryCommunityPoolRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseQueryCommunityPoolRequest();
        return message;
    },
};
function createBaseQueryCommunityPoolResponse() {
    return {
        pool: [],
    };
}
exports.QueryCommunityPoolResponse = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.pool) {
            coin_1.DecCoin.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryCommunityPoolResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.pool.push(coin_1.DecCoin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            pool: Array.isArray(object?.pool) ? object.pool.map((e) => coin_1.DecCoin.fromJSON(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.pool) {
            obj.pool = message.pool.map((e) => (e ? coin_1.DecCoin.toJSON(e) : undefined));
        }
        else {
            obj.pool = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryCommunityPoolResponse();
        message.pool = object.pool?.map((e) => coin_1.DecCoin.fromPartial(e)) || [];
        return message;
    },
};
class QueryClientImpl {
    constructor(rpc) {
        this.rpc = rpc;
        this.Params = this.Params.bind(this);
        this.ValidatorDistributionInfo = this.ValidatorDistributionInfo.bind(this);
        this.ValidatorOutstandingRewards = this.ValidatorOutstandingRewards.bind(this);
        this.ValidatorCommission = this.ValidatorCommission.bind(this);
        this.ValidatorSlashes = this.ValidatorSlashes.bind(this);
        this.DelegationRewards = this.DelegationRewards.bind(this);
        this.DelegationTotalRewards = this.DelegationTotalRewards.bind(this);
        this.DelegatorValidators = this.DelegatorValidators.bind(this);
        this.DelegatorWithdrawAddress = this.DelegatorWithdrawAddress.bind(this);
        this.CommunityPool = this.CommunityPool.bind(this);
    }
    Params(request = {}) {
        const data = exports.QueryParamsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.distribution.v1beta1.Query", "Params", data);
        return promise.then((data) => exports.QueryParamsResponse.decode(new _m0.Reader(data)));
    }
    ValidatorDistributionInfo(request) {
        const data = exports.QueryValidatorDistributionInfoRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.distribution.v1beta1.Query", "ValidatorDistributionInfo", data);
        return promise.then((data) => exports.QueryValidatorDistributionInfoResponse.decode(new _m0.Reader(data)));
    }
    ValidatorOutstandingRewards(request) {
        const data = exports.QueryValidatorOutstandingRewardsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.distribution.v1beta1.Query", "ValidatorOutstandingRewards", data);
        return promise.then((data) => exports.QueryValidatorOutstandingRewardsResponse.decode(new _m0.Reader(data)));
    }
    ValidatorCommission(request) {
        const data = exports.QueryValidatorCommissionRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.distribution.v1beta1.Query", "ValidatorCommission", data);
        return promise.then((data) => exports.QueryValidatorCommissionResponse.decode(new _m0.Reader(data)));
    }
    ValidatorSlashes(request) {
        const data = exports.QueryValidatorSlashesRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.distribution.v1beta1.Query", "ValidatorSlashes", data);
        return promise.then((data) => exports.QueryValidatorSlashesResponse.decode(new _m0.Reader(data)));
    }
    DelegationRewards(request) {
        const data = exports.QueryDelegationRewardsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.distribution.v1beta1.Query", "DelegationRewards", data);
        return promise.then((data) => exports.QueryDelegationRewardsResponse.decode(new _m0.Reader(data)));
    }
    DelegationTotalRewards(request) {
        const data = exports.QueryDelegationTotalRewardsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.distribution.v1beta1.Query", "DelegationTotalRewards", data);
        return promise.then((data) => exports.QueryDelegationTotalRewardsResponse.decode(new _m0.Reader(data)));
    }
    DelegatorValidators(request) {
        const data = exports.QueryDelegatorValidatorsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.distribution.v1beta1.Query", "DelegatorValidators", data);
        return promise.then((data) => exports.QueryDelegatorValidatorsResponse.decode(new _m0.Reader(data)));
    }
    DelegatorWithdrawAddress(request) {
        const data = exports.QueryDelegatorWithdrawAddressRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.distribution.v1beta1.Query", "DelegatorWithdrawAddress", data);
        return promise.then((data) => exports.QueryDelegatorWithdrawAddressResponse.decode(new _m0.Reader(data)));
    }
    CommunityPool(request = {}) {
        const data = exports.QueryCommunityPoolRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.distribution.v1beta1.Query", "CommunityPool", data);
        return promise.then((data) => exports.QueryCommunityPoolResponse.decode(new _m0.Reader(data)));
    }
}
exports.QueryClientImpl = QueryClientImpl;
//# sourceMappingURL=query.js.map

/***/ }),

/***/ 80798:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MsgClientImpl = exports.MsgCommunityPoolSpendResponse = exports.MsgCommunityPoolSpend = exports.MsgUpdateParamsResponse = exports.MsgUpdateParams = exports.MsgFundCommunityPoolResponse = exports.MsgFundCommunityPool = exports.MsgWithdrawValidatorCommissionResponse = exports.MsgWithdrawValidatorCommission = exports.MsgWithdrawDelegatorRewardResponse = exports.MsgWithdrawDelegatorReward = exports.MsgSetWithdrawAddressResponse = exports.MsgSetWithdrawAddress = exports.protobufPackage = void 0;
/* eslint-disable */
const coin_1 = __webpack_require__(81637);
const distribution_1 = __webpack_require__(45280);
const _m0 = __importStar(__webpack_require__(62100));
const helpers_1 = __webpack_require__(92654);
exports.protobufPackage = "cosmos.distribution.v1beta1";
function createBaseMsgSetWithdrawAddress() {
    return {
        delegatorAddress: "",
        withdrawAddress: "",
    };
}
exports.MsgSetWithdrawAddress = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.delegatorAddress !== "") {
            writer.uint32(10).string(message.delegatorAddress);
        }
        if (message.withdrawAddress !== "") {
            writer.uint32(18).string(message.withdrawAddress);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgSetWithdrawAddress();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.withdrawAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            delegatorAddress: (0, helpers_1.isSet)(object.delegatorAddress) ? String(object.delegatorAddress) : "",
            withdrawAddress: (0, helpers_1.isSet)(object.withdrawAddress) ? String(object.withdrawAddress) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.withdrawAddress !== undefined && (obj.withdrawAddress = message.withdrawAddress);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgSetWithdrawAddress();
        message.delegatorAddress = object.delegatorAddress ?? "";
        message.withdrawAddress = object.withdrawAddress ?? "";
        return message;
    },
};
function createBaseMsgSetWithdrawAddressResponse() {
    return {};
}
exports.MsgSetWithdrawAddressResponse = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgSetWithdrawAddressResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgSetWithdrawAddressResponse();
        return message;
    },
};
function createBaseMsgWithdrawDelegatorReward() {
    return {
        delegatorAddress: "",
        validatorAddress: "",
    };
}
exports.MsgWithdrawDelegatorReward = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.delegatorAddress !== "") {
            writer.uint32(10).string(message.delegatorAddress);
        }
        if (message.validatorAddress !== "") {
            writer.uint32(18).string(message.validatorAddress);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgWithdrawDelegatorReward();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            delegatorAddress: (0, helpers_1.isSet)(object.delegatorAddress) ? String(object.delegatorAddress) : "",
            validatorAddress: (0, helpers_1.isSet)(object.validatorAddress) ? String(object.validatorAddress) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgWithdrawDelegatorReward();
        message.delegatorAddress = object.delegatorAddress ?? "";
        message.validatorAddress = object.validatorAddress ?? "";
        return message;
    },
};
function createBaseMsgWithdrawDelegatorRewardResponse() {
    return {
        amount: [],
    };
}
exports.MsgWithdrawDelegatorRewardResponse = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.amount) {
            coin_1.Coin.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgWithdrawDelegatorRewardResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.amount.push(coin_1.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            amount: Array.isArray(object?.amount) ? object.amount.map((e) => coin_1.Coin.fromJSON(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.amount) {
            obj.amount = message.amount.map((e) => (e ? coin_1.Coin.toJSON(e) : undefined));
        }
        else {
            obj.amount = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgWithdrawDelegatorRewardResponse();
        message.amount = object.amount?.map((e) => coin_1.Coin.fromPartial(e)) || [];
        return message;
    },
};
function createBaseMsgWithdrawValidatorCommission() {
    return {
        validatorAddress: "",
    };
}
exports.MsgWithdrawValidatorCommission = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.validatorAddress !== "") {
            writer.uint32(10).string(message.validatorAddress);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgWithdrawValidatorCommission();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.validatorAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            validatorAddress: (0, helpers_1.isSet)(object.validatorAddress) ? String(object.validatorAddress) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgWithdrawValidatorCommission();
        message.validatorAddress = object.validatorAddress ?? "";
        return message;
    },
};
function createBaseMsgWithdrawValidatorCommissionResponse() {
    return {
        amount: [],
    };
}
exports.MsgWithdrawValidatorCommissionResponse = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.amount) {
            coin_1.Coin.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgWithdrawValidatorCommissionResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.amount.push(coin_1.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            amount: Array.isArray(object?.amount) ? object.amount.map((e) => coin_1.Coin.fromJSON(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.amount) {
            obj.amount = message.amount.map((e) => (e ? coin_1.Coin.toJSON(e) : undefined));
        }
        else {
            obj.amount = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgWithdrawValidatorCommissionResponse();
        message.amount = object.amount?.map((e) => coin_1.Coin.fromPartial(e)) || [];
        return message;
    },
};
function createBaseMsgFundCommunityPool() {
    return {
        amount: [],
        depositor: "",
    };
}
exports.MsgFundCommunityPool = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.amount) {
            coin_1.Coin.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.depositor !== "") {
            writer.uint32(18).string(message.depositor);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgFundCommunityPool();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.amount.push(coin_1.Coin.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.depositor = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            amount: Array.isArray(object?.amount) ? object.amount.map((e) => coin_1.Coin.fromJSON(e)) : [],
            depositor: (0, helpers_1.isSet)(object.depositor) ? String(object.depositor) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.amount) {
            obj.amount = message.amount.map((e) => (e ? coin_1.Coin.toJSON(e) : undefined));
        }
        else {
            obj.amount = [];
        }
        message.depositor !== undefined && (obj.depositor = message.depositor);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgFundCommunityPool();
        message.amount = object.amount?.map((e) => coin_1.Coin.fromPartial(e)) || [];
        message.depositor = object.depositor ?? "";
        return message;
    },
};
function createBaseMsgFundCommunityPoolResponse() {
    return {};
}
exports.MsgFundCommunityPoolResponse = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgFundCommunityPoolResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgFundCommunityPoolResponse();
        return message;
    },
};
function createBaseMsgUpdateParams() {
    return {
        authority: "",
        params: undefined,
    };
}
exports.MsgUpdateParams = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.authority !== "") {
            writer.uint32(10).string(message.authority);
        }
        if (message.params !== undefined) {
            distribution_1.Params.encode(message.params, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgUpdateParams();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.authority = reader.string();
                    break;
                case 2:
                    message.params = distribution_1.Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            authority: (0, helpers_1.isSet)(object.authority) ? String(object.authority) : "",
            params: (0, helpers_1.isSet)(object.params) ? distribution_1.Params.fromJSON(object.params) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.authority !== undefined && (obj.authority = message.authority);
        message.params !== undefined && (obj.params = message.params ? distribution_1.Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgUpdateParams();
        message.authority = object.authority ?? "";
        message.params =
            object.params !== undefined && object.params !== null ? distribution_1.Params.fromPartial(object.params) : undefined;
        return message;
    },
};
function createBaseMsgUpdateParamsResponse() {
    return {};
}
exports.MsgUpdateParamsResponse = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgUpdateParamsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgUpdateParamsResponse();
        return message;
    },
};
function createBaseMsgCommunityPoolSpend() {
    return {
        authority: "",
        recipient: "",
        amount: [],
    };
}
exports.MsgCommunityPoolSpend = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.authority !== "") {
            writer.uint32(10).string(message.authority);
        }
        if (message.recipient !== "") {
            writer.uint32(18).string(message.recipient);
        }
        for (const v of message.amount) {
            coin_1.Coin.encode(v, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgCommunityPoolSpend();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.authority = reader.string();
                    break;
                case 2:
                    message.recipient = reader.string();
                    break;
                case 3:
                    message.amount.push(coin_1.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            authority: (0, helpers_1.isSet)(object.authority) ? String(object.authority) : "",
            recipient: (0, helpers_1.isSet)(object.recipient) ? String(object.recipient) : "",
            amount: Array.isArray(object?.amount) ? object.amount.map((e) => coin_1.Coin.fromJSON(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        message.authority !== undefined && (obj.authority = message.authority);
        message.recipient !== undefined && (obj.recipient = message.recipient);
        if (message.amount) {
            obj.amount = message.amount.map((e) => (e ? coin_1.Coin.toJSON(e) : undefined));
        }
        else {
            obj.amount = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgCommunityPoolSpend();
        message.authority = object.authority ?? "";
        message.recipient = object.recipient ?? "";
        message.amount = object.amount?.map((e) => coin_1.Coin.fromPartial(e)) || [];
        return message;
    },
};
function createBaseMsgCommunityPoolSpendResponse() {
    return {};
}
exports.MsgCommunityPoolSpendResponse = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgCommunityPoolSpendResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgCommunityPoolSpendResponse();
        return message;
    },
};
class MsgClientImpl {
    constructor(rpc) {
        this.rpc = rpc;
        this.SetWithdrawAddress = this.SetWithdrawAddress.bind(this);
        this.WithdrawDelegatorReward = this.WithdrawDelegatorReward.bind(this);
        this.WithdrawValidatorCommission = this.WithdrawValidatorCommission.bind(this);
        this.FundCommunityPool = this.FundCommunityPool.bind(this);
        this.UpdateParams = this.UpdateParams.bind(this);
        this.CommunityPoolSpend = this.CommunityPoolSpend.bind(this);
    }
    SetWithdrawAddress(request) {
        const data = exports.MsgSetWithdrawAddress.encode(request).finish();
        const promise = this.rpc.request("cosmos.distribution.v1beta1.Msg", "SetWithdrawAddress", data);
        return promise.then((data) => exports.MsgSetWithdrawAddressResponse.decode(new _m0.Reader(data)));
    }
    WithdrawDelegatorReward(request) {
        const data = exports.MsgWithdrawDelegatorReward.encode(request).finish();
        const promise = this.rpc.request("cosmos.distribution.v1beta1.Msg", "WithdrawDelegatorReward", data);
        return promise.then((data) => exports.MsgWithdrawDelegatorRewardResponse.decode(new _m0.Reader(data)));
    }
    WithdrawValidatorCommission(request) {
        const data = exports.MsgWithdrawValidatorCommission.encode(request).finish();
        const promise = this.rpc.request("cosmos.distribution.v1beta1.Msg", "WithdrawValidatorCommission", data);
        return promise.then((data) => exports.MsgWithdrawValidatorCommissionResponse.decode(new _m0.Reader(data)));
    }
    FundCommunityPool(request) {
        const data = exports.MsgFundCommunityPool.encode(request).finish();
        const promise = this.rpc.request("cosmos.distribution.v1beta1.Msg", "FundCommunityPool", data);
        return promise.then((data) => exports.MsgFundCommunityPoolResponse.decode(new _m0.Reader(data)));
    }
    UpdateParams(request) {
        const data = exports.MsgUpdateParams.encode(request).finish();
        const promise = this.rpc.request("cosmos.distribution.v1beta1.Msg", "UpdateParams", data);
        return promise.then((data) => exports.MsgUpdateParamsResponse.decode(new _m0.Reader(data)));
    }
    CommunityPoolSpend(request) {
        const data = exports.MsgCommunityPoolSpend.encode(request).finish();
        const promise = this.rpc.request("cosmos.distribution.v1beta1.Msg", "CommunityPoolSpend", data);
        return promise.then((data) => exports.MsgCommunityPoolSpendResponse.decode(new _m0.Reader(data)));
    }
}
exports.MsgClientImpl = MsgClientImpl;
//# sourceMappingURL=tx.js.map

/***/ }),

/***/ 37517:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Grant = exports.AllowedMsgAllowance = exports.PeriodicAllowance = exports.BasicAllowance = exports.protobufPackage = void 0;
/* eslint-disable */
const coin_1 = __webpack_require__(81637);
const timestamp_1 = __webpack_require__(70147);
const duration_1 = __webpack_require__(9591);
const any_1 = __webpack_require__(75654);
const _m0 = __importStar(__webpack_require__(62100));
const helpers_1 = __webpack_require__(92654);
exports.protobufPackage = "cosmos.feegrant.v1beta1";
function createBaseBasicAllowance() {
    return {
        spendLimit: [],
        expiration: undefined,
    };
}
exports.BasicAllowance = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.spendLimit) {
            coin_1.Coin.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.expiration !== undefined) {
            timestamp_1.Timestamp.encode(message.expiration, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseBasicAllowance();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.spendLimit.push(coin_1.Coin.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.expiration = timestamp_1.Timestamp.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            spendLimit: Array.isArray(object?.spendLimit)
                ? object.spendLimit.map((e) => coin_1.Coin.fromJSON(e))
                : [],
            expiration: (0, helpers_1.isSet)(object.expiration) ? (0, helpers_1.fromJsonTimestamp)(object.expiration) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.spendLimit) {
            obj.spendLimit = message.spendLimit.map((e) => (e ? coin_1.Coin.toJSON(e) : undefined));
        }
        else {
            obj.spendLimit = [];
        }
        message.expiration !== undefined && (obj.expiration = (0, helpers_1.fromTimestamp)(message.expiration).toISOString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseBasicAllowance();
        message.spendLimit = object.spendLimit?.map((e) => coin_1.Coin.fromPartial(e)) || [];
        message.expiration =
            object.expiration !== undefined && object.expiration !== null
                ? timestamp_1.Timestamp.fromPartial(object.expiration)
                : undefined;
        return message;
    },
};
function createBasePeriodicAllowance() {
    return {
        basic: undefined,
        period: undefined,
        periodSpendLimit: [],
        periodCanSpend: [],
        periodReset: undefined,
    };
}
exports.PeriodicAllowance = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.basic !== undefined) {
            exports.BasicAllowance.encode(message.basic, writer.uint32(10).fork()).ldelim();
        }
        if (message.period !== undefined) {
            duration_1.Duration.encode(message.period, writer.uint32(18).fork()).ldelim();
        }
        for (const v of message.periodSpendLimit) {
            coin_1.Coin.encode(v, writer.uint32(26).fork()).ldelim();
        }
        for (const v of message.periodCanSpend) {
            coin_1.Coin.encode(v, writer.uint32(34).fork()).ldelim();
        }
        if (message.periodReset !== undefined) {
            timestamp_1.Timestamp.encode(message.periodReset, writer.uint32(42).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePeriodicAllowance();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.basic = exports.BasicAllowance.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.period = duration_1.Duration.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.periodSpendLimit.push(coin_1.Coin.decode(reader, reader.uint32()));
                    break;
                case 4:
                    message.periodCanSpend.push(coin_1.Coin.decode(reader, reader.uint32()));
                    break;
                case 5:
                    message.periodReset = timestamp_1.Timestamp.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            basic: (0, helpers_1.isSet)(object.basic) ? exports.BasicAllowance.fromJSON(object.basic) : undefined,
            period: (0, helpers_1.isSet)(object.period) ? duration_1.Duration.fromJSON(object.period) : undefined,
            periodSpendLimit: Array.isArray(object?.periodSpendLimit)
                ? object.periodSpendLimit.map((e) => coin_1.Coin.fromJSON(e))
                : [],
            periodCanSpend: Array.isArray(object?.periodCanSpend)
                ? object.periodCanSpend.map((e) => coin_1.Coin.fromJSON(e))
                : [],
            periodReset: (0, helpers_1.isSet)(object.periodReset) ? (0, helpers_1.fromJsonTimestamp)(object.periodReset) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.basic !== undefined &&
            (obj.basic = message.basic ? exports.BasicAllowance.toJSON(message.basic) : undefined);
        message.period !== undefined &&
            (obj.period = message.period ? duration_1.Duration.toJSON(message.period) : undefined);
        if (message.periodSpendLimit) {
            obj.periodSpendLimit = message.periodSpendLimit.map((e) => (e ? coin_1.Coin.toJSON(e) : undefined));
        }
        else {
            obj.periodSpendLimit = [];
        }
        if (message.periodCanSpend) {
            obj.periodCanSpend = message.periodCanSpend.map((e) => (e ? coin_1.Coin.toJSON(e) : undefined));
        }
        else {
            obj.periodCanSpend = [];
        }
        message.periodReset !== undefined && (obj.periodReset = (0, helpers_1.fromTimestamp)(message.periodReset).toISOString());
        return obj;
    },
    fromPartial(object) {
        const message = createBasePeriodicAllowance();
        message.basic =
            object.basic !== undefined && object.basic !== null
                ? exports.BasicAllowance.fromPartial(object.basic)
                : undefined;
        message.period =
            object.period !== undefined && object.period !== null ? duration_1.Duration.fromPartial(object.period) : undefined;
        message.periodSpendLimit = object.periodSpendLimit?.map((e) => coin_1.Coin.fromPartial(e)) || [];
        message.periodCanSpend = object.periodCanSpend?.map((e) => coin_1.Coin.fromPartial(e)) || [];
        message.periodReset =
            object.periodReset !== undefined && object.periodReset !== null
                ? timestamp_1.Timestamp.fromPartial(object.periodReset)
                : undefined;
        return message;
    },
};
function createBaseAllowedMsgAllowance() {
    return {
        allowance: undefined,
        allowedMessages: [],
    };
}
exports.AllowedMsgAllowance = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.allowance !== undefined) {
            any_1.Any.encode(message.allowance, writer.uint32(10).fork()).ldelim();
        }
        for (const v of message.allowedMessages) {
            writer.uint32(18).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAllowedMsgAllowance();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.allowance = any_1.Any.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.allowedMessages.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            allowance: (0, helpers_1.isSet)(object.allowance) ? any_1.Any.fromJSON(object.allowance) : undefined,
            allowedMessages: Array.isArray(object?.allowedMessages)
                ? object.allowedMessages.map((e) => String(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        message.allowance !== undefined &&
            (obj.allowance = message.allowance ? any_1.Any.toJSON(message.allowance) : undefined);
        if (message.allowedMessages) {
            obj.allowedMessages = message.allowedMessages.map((e) => e);
        }
        else {
            obj.allowedMessages = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseAllowedMsgAllowance();
        message.allowance =
            object.allowance !== undefined && object.allowance !== null
                ? any_1.Any.fromPartial(object.allowance)
                : undefined;
        message.allowedMessages = object.allowedMessages?.map((e) => e) || [];
        return message;
    },
};
function createBaseGrant() {
    return {
        granter: "",
        grantee: "",
        allowance: undefined,
    };
}
exports.Grant = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.granter !== "") {
            writer.uint32(10).string(message.granter);
        }
        if (message.grantee !== "") {
            writer.uint32(18).string(message.grantee);
        }
        if (message.allowance !== undefined) {
            any_1.Any.encode(message.allowance, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGrant();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.granter = reader.string();
                    break;
                case 2:
                    message.grantee = reader.string();
                    break;
                case 3:
                    message.allowance = any_1.Any.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            granter: (0, helpers_1.isSet)(object.granter) ? String(object.granter) : "",
            grantee: (0, helpers_1.isSet)(object.grantee) ? String(object.grantee) : "",
            allowance: (0, helpers_1.isSet)(object.allowance) ? any_1.Any.fromJSON(object.allowance) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.granter !== undefined && (obj.granter = message.granter);
        message.grantee !== undefined && (obj.grantee = message.grantee);
        message.allowance !== undefined &&
            (obj.allowance = message.allowance ? any_1.Any.toJSON(message.allowance) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseGrant();
        message.granter = object.granter ?? "";
        message.grantee = object.grantee ?? "";
        message.allowance =
            object.allowance !== undefined && object.allowance !== null
                ? any_1.Any.fromPartial(object.allowance)
                : undefined;
        return message;
    },
};
//# sourceMappingURL=feegrant.js.map

/***/ }),

/***/ 47613:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.QueryClientImpl = exports.QueryAllowancesByGranterResponse = exports.QueryAllowancesByGranterRequest = exports.QueryAllowancesResponse = exports.QueryAllowancesRequest = exports.QueryAllowanceResponse = exports.QueryAllowanceRequest = exports.protobufPackage = void 0;
/* eslint-disable */
const pagination_1 = __webpack_require__(84043);
const feegrant_1 = __webpack_require__(37517);
const _m0 = __importStar(__webpack_require__(62100));
const helpers_1 = __webpack_require__(92654);
exports.protobufPackage = "cosmos.feegrant.v1beta1";
function createBaseQueryAllowanceRequest() {
    return {
        granter: "",
        grantee: "",
    };
}
exports.QueryAllowanceRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.granter !== "") {
            writer.uint32(10).string(message.granter);
        }
        if (message.grantee !== "") {
            writer.uint32(18).string(message.grantee);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryAllowanceRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.granter = reader.string();
                    break;
                case 2:
                    message.grantee = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            granter: (0, helpers_1.isSet)(object.granter) ? String(object.granter) : "",
            grantee: (0, helpers_1.isSet)(object.grantee) ? String(object.grantee) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.granter !== undefined && (obj.granter = message.granter);
        message.grantee !== undefined && (obj.grantee = message.grantee);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryAllowanceRequest();
        message.granter = object.granter ?? "";
        message.grantee = object.grantee ?? "";
        return message;
    },
};
function createBaseQueryAllowanceResponse() {
    return {
        allowance: undefined,
    };
}
exports.QueryAllowanceResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.allowance !== undefined) {
            feegrant_1.Grant.encode(message.allowance, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryAllowanceResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.allowance = feegrant_1.Grant.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            allowance: (0, helpers_1.isSet)(object.allowance) ? feegrant_1.Grant.fromJSON(object.allowance) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.allowance !== undefined &&
            (obj.allowance = message.allowance ? feegrant_1.Grant.toJSON(message.allowance) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryAllowanceResponse();
        message.allowance =
            object.allowance !== undefined && object.allowance !== null
                ? feegrant_1.Grant.fromPartial(object.allowance)
                : undefined;
        return message;
    },
};
function createBaseQueryAllowancesRequest() {
    return {
        grantee: "",
        pagination: undefined,
    };
}
exports.QueryAllowancesRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.grantee !== "") {
            writer.uint32(10).string(message.grantee);
        }
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryAllowancesRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.grantee = reader.string();
                    break;
                case 2:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            grantee: (0, helpers_1.isSet)(object.grantee) ? String(object.grantee) : "",
            pagination: (0, helpers_1.isSet)(object.pagination) ? pagination_1.PageRequest.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.grantee !== undefined && (obj.grantee = message.grantee);
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryAllowancesRequest();
        message.grantee = object.grantee ?? "";
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryAllowancesResponse() {
    return {
        allowances: [],
        pagination: undefined,
    };
}
exports.QueryAllowancesResponse = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.allowances) {
            feegrant_1.Grant.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryAllowancesResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.allowances.push(feegrant_1.Grant.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            allowances: Array.isArray(object?.allowances)
                ? object.allowances.map((e) => feegrant_1.Grant.fromJSON(e))
                : [],
            pagination: (0, helpers_1.isSet)(object.pagination) ? pagination_1.PageResponse.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.allowances) {
            obj.allowances = message.allowances.map((e) => (e ? feegrant_1.Grant.toJSON(e) : undefined));
        }
        else {
            obj.allowances = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryAllowancesResponse();
        message.allowances = object.allowances?.map((e) => feegrant_1.Grant.fromPartial(e)) || [];
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryAllowancesByGranterRequest() {
    return {
        granter: "",
        pagination: undefined,
    };
}
exports.QueryAllowancesByGranterRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.granter !== "") {
            writer.uint32(10).string(message.granter);
        }
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryAllowancesByGranterRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.granter = reader.string();
                    break;
                case 2:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            granter: (0, helpers_1.isSet)(object.granter) ? String(object.granter) : "",
            pagination: (0, helpers_1.isSet)(object.pagination) ? pagination_1.PageRequest.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.granter !== undefined && (obj.granter = message.granter);
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryAllowancesByGranterRequest();
        message.granter = object.granter ?? "";
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryAllowancesByGranterResponse() {
    return {
        allowances: [],
        pagination: undefined,
    };
}
exports.QueryAllowancesByGranterResponse = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.allowances) {
            feegrant_1.Grant.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryAllowancesByGranterResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.allowances.push(feegrant_1.Grant.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            allowances: Array.isArray(object?.allowances)
                ? object.allowances.map((e) => feegrant_1.Grant.fromJSON(e))
                : [],
            pagination: (0, helpers_1.isSet)(object.pagination) ? pagination_1.PageResponse.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.allowances) {
            obj.allowances = message.allowances.map((e) => (e ? feegrant_1.Grant.toJSON(e) : undefined));
        }
        else {
            obj.allowances = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryAllowancesByGranterResponse();
        message.allowances = object.allowances?.map((e) => feegrant_1.Grant.fromPartial(e)) || [];
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
class QueryClientImpl {
    constructor(rpc) {
        this.rpc = rpc;
        this.Allowance = this.Allowance.bind(this);
        this.Allowances = this.Allowances.bind(this);
        this.AllowancesByGranter = this.AllowancesByGranter.bind(this);
    }
    Allowance(request) {
        const data = exports.QueryAllowanceRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.feegrant.v1beta1.Query", "Allowance", data);
        return promise.then((data) => exports.QueryAllowanceResponse.decode(new _m0.Reader(data)));
    }
    Allowances(request) {
        const data = exports.QueryAllowancesRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.feegrant.v1beta1.Query", "Allowances", data);
        return promise.then((data) => exports.QueryAllowancesResponse.decode(new _m0.Reader(data)));
    }
    AllowancesByGranter(request) {
        const data = exports.QueryAllowancesByGranterRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.feegrant.v1beta1.Query", "AllowancesByGranter", data);
        return promise.then((data) => exports.QueryAllowancesByGranterResponse.decode(new _m0.Reader(data)));
    }
}
exports.QueryClientImpl = QueryClientImpl;
//# sourceMappingURL=query.js.map

/***/ }),

/***/ 57431:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MsgClientImpl = exports.MsgRevokeAllowanceResponse = exports.MsgRevokeAllowance = exports.MsgGrantAllowanceResponse = exports.MsgGrantAllowance = exports.protobufPackage = void 0;
/* eslint-disable */
const any_1 = __webpack_require__(75654);
const _m0 = __importStar(__webpack_require__(62100));
const helpers_1 = __webpack_require__(92654);
exports.protobufPackage = "cosmos.feegrant.v1beta1";
function createBaseMsgGrantAllowance() {
    return {
        granter: "",
        grantee: "",
        allowance: undefined,
    };
}
exports.MsgGrantAllowance = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.granter !== "") {
            writer.uint32(10).string(message.granter);
        }
        if (message.grantee !== "") {
            writer.uint32(18).string(message.grantee);
        }
        if (message.allowance !== undefined) {
            any_1.Any.encode(message.allowance, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgGrantAllowance();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.granter = reader.string();
                    break;
                case 2:
                    message.grantee = reader.string();
                    break;
                case 3:
                    message.allowance = any_1.Any.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            granter: (0, helpers_1.isSet)(object.granter) ? String(object.granter) : "",
            grantee: (0, helpers_1.isSet)(object.grantee) ? String(object.grantee) : "",
            allowance: (0, helpers_1.isSet)(object.allowance) ? any_1.Any.fromJSON(object.allowance) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.granter !== undefined && (obj.granter = message.granter);
        message.grantee !== undefined && (obj.grantee = message.grantee);
        message.allowance !== undefined &&
            (obj.allowance = message.allowance ? any_1.Any.toJSON(message.allowance) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgGrantAllowance();
        message.granter = object.granter ?? "";
        message.grantee = object.grantee ?? "";
        message.allowance =
            object.allowance !== undefined && object.allowance !== null
                ? any_1.Any.fromPartial(object.allowance)
                : undefined;
        return message;
    },
};
function createBaseMsgGrantAllowanceResponse() {
    return {};
}
exports.MsgGrantAllowanceResponse = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgGrantAllowanceResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgGrantAllowanceResponse();
        return message;
    },
};
function createBaseMsgRevokeAllowance() {
    return {
        granter: "",
        grantee: "",
    };
}
exports.MsgRevokeAllowance = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.granter !== "") {
            writer.uint32(10).string(message.granter);
        }
        if (message.grantee !== "") {
            writer.uint32(18).string(message.grantee);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgRevokeAllowance();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.granter = reader.string();
                    break;
                case 2:
                    message.grantee = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            granter: (0, helpers_1.isSet)(object.granter) ? String(object.granter) : "",
            grantee: (0, helpers_1.isSet)(object.grantee) ? String(object.grantee) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.granter !== undefined && (obj.granter = message.granter);
        message.grantee !== undefined && (obj.grantee = message.grantee);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgRevokeAllowance();
        message.granter = object.granter ?? "";
        message.grantee = object.grantee ?? "";
        return message;
    },
};
function createBaseMsgRevokeAllowanceResponse() {
    return {};
}
exports.MsgRevokeAllowanceResponse = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgRevokeAllowanceResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgRevokeAllowanceResponse();
        return message;
    },
};
class MsgClientImpl {
    constructor(rpc) {
        this.rpc = rpc;
        this.GrantAllowance = this.GrantAllowance.bind(this);
        this.RevokeAllowance = this.RevokeAllowance.bind(this);
    }
    GrantAllowance(request) {
        const data = exports.MsgGrantAllowance.encode(request).finish();
        const promise = this.rpc.request("cosmos.feegrant.v1beta1.Msg", "GrantAllowance", data);
        return promise.then((data) => exports.MsgGrantAllowanceResponse.decode(new _m0.Reader(data)));
    }
    RevokeAllowance(request) {
        const data = exports.MsgRevokeAllowance.encode(request).finish();
        const promise = this.rpc.request("cosmos.feegrant.v1beta1.Msg", "RevokeAllowance", data);
        return promise.then((data) => exports.MsgRevokeAllowanceResponse.decode(new _m0.Reader(data)));
    }
}
exports.MsgClientImpl = MsgClientImpl;
//# sourceMappingURL=tx.js.map

/***/ }),

/***/ 17979:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Params = exports.TallyParams = exports.VotingParams = exports.DepositParams = exports.Vote = exports.TallyResult = exports.Proposal = exports.Deposit = exports.WeightedVoteOption = exports.proposalStatusToJSON = exports.proposalStatusFromJSON = exports.ProposalStatus = exports.voteOptionToJSON = exports.voteOptionFromJSON = exports.VoteOption = exports.protobufPackage = void 0;
/* eslint-disable */
const coin_1 = __webpack_require__(81637);
const any_1 = __webpack_require__(75654);
const timestamp_1 = __webpack_require__(70147);
const duration_1 = __webpack_require__(9591);
const helpers_1 = __webpack_require__(92654);
const _m0 = __importStar(__webpack_require__(62100));
exports.protobufPackage = "cosmos.gov.v1";
/** VoteOption enumerates the valid vote options for a given governance proposal. */
var VoteOption;
(function (VoteOption) {
    /** VOTE_OPTION_UNSPECIFIED - VOTE_OPTION_UNSPECIFIED defines a no-op vote option. */
    VoteOption[VoteOption["VOTE_OPTION_UNSPECIFIED"] = 0] = "VOTE_OPTION_UNSPECIFIED";
    /** VOTE_OPTION_YES - VOTE_OPTION_YES defines a yes vote option. */
    VoteOption[VoteOption["VOTE_OPTION_YES"] = 1] = "VOTE_OPTION_YES";
    /** VOTE_OPTION_ABSTAIN - VOTE_OPTION_ABSTAIN defines an abstain vote option. */
    VoteOption[VoteOption["VOTE_OPTION_ABSTAIN"] = 2] = "VOTE_OPTION_ABSTAIN";
    /** VOTE_OPTION_NO - VOTE_OPTION_NO defines a no vote option. */
    VoteOption[VoteOption["VOTE_OPTION_NO"] = 3] = "VOTE_OPTION_NO";
    /** VOTE_OPTION_NO_WITH_VETO - VOTE_OPTION_NO_WITH_VETO defines a no with veto vote option. */
    VoteOption[VoteOption["VOTE_OPTION_NO_WITH_VETO"] = 4] = "VOTE_OPTION_NO_WITH_VETO";
    VoteOption[VoteOption["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(VoteOption = exports.VoteOption || (exports.VoteOption = {}));
function voteOptionFromJSON(object) {
    switch (object) {
        case 0:
        case "VOTE_OPTION_UNSPECIFIED":
            return VoteOption.VOTE_OPTION_UNSPECIFIED;
        case 1:
        case "VOTE_OPTION_YES":
            return VoteOption.VOTE_OPTION_YES;
        case 2:
        case "VOTE_OPTION_ABSTAIN":
            return VoteOption.VOTE_OPTION_ABSTAIN;
        case 3:
        case "VOTE_OPTION_NO":
            return VoteOption.VOTE_OPTION_NO;
        case 4:
        case "VOTE_OPTION_NO_WITH_VETO":
            return VoteOption.VOTE_OPTION_NO_WITH_VETO;
        case -1:
        case "UNRECOGNIZED":
        default:
            return VoteOption.UNRECOGNIZED;
    }
}
exports.voteOptionFromJSON = voteOptionFromJSON;
function voteOptionToJSON(object) {
    switch (object) {
        case VoteOption.VOTE_OPTION_UNSPECIFIED:
            return "VOTE_OPTION_UNSPECIFIED";
        case VoteOption.VOTE_OPTION_YES:
            return "VOTE_OPTION_YES";
        case VoteOption.VOTE_OPTION_ABSTAIN:
            return "VOTE_OPTION_ABSTAIN";
        case VoteOption.VOTE_OPTION_NO:
            return "VOTE_OPTION_NO";
        case VoteOption.VOTE_OPTION_NO_WITH_VETO:
            return "VOTE_OPTION_NO_WITH_VETO";
        case VoteOption.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.voteOptionToJSON = voteOptionToJSON;
/** ProposalStatus enumerates the valid statuses of a proposal. */
var ProposalStatus;
(function (ProposalStatus) {
    /** PROPOSAL_STATUS_UNSPECIFIED - PROPOSAL_STATUS_UNSPECIFIED defines the default proposal status. */
    ProposalStatus[ProposalStatus["PROPOSAL_STATUS_UNSPECIFIED"] = 0] = "PROPOSAL_STATUS_UNSPECIFIED";
    /**
     * PROPOSAL_STATUS_DEPOSIT_PERIOD - PROPOSAL_STATUS_DEPOSIT_PERIOD defines a proposal status during the deposit
     * period.
     */
    ProposalStatus[ProposalStatus["PROPOSAL_STATUS_DEPOSIT_PERIOD"] = 1] = "PROPOSAL_STATUS_DEPOSIT_PERIOD";
    /**
     * PROPOSAL_STATUS_VOTING_PERIOD - PROPOSAL_STATUS_VOTING_PERIOD defines a proposal status during the voting
     * period.
     */
    ProposalStatus[ProposalStatus["PROPOSAL_STATUS_VOTING_PERIOD"] = 2] = "PROPOSAL_STATUS_VOTING_PERIOD";
    /**
     * PROPOSAL_STATUS_PASSED - PROPOSAL_STATUS_PASSED defines a proposal status of a proposal that has
     * passed.
     */
    ProposalStatus[ProposalStatus["PROPOSAL_STATUS_PASSED"] = 3] = "PROPOSAL_STATUS_PASSED";
    /**
     * PROPOSAL_STATUS_REJECTED - PROPOSAL_STATUS_REJECTED defines a proposal status of a proposal that has
     * been rejected.
     */
    ProposalStatus[ProposalStatus["PROPOSAL_STATUS_REJECTED"] = 4] = "PROPOSAL_STATUS_REJECTED";
    /**
     * PROPOSAL_STATUS_FAILED - PROPOSAL_STATUS_FAILED defines a proposal status of a proposal that has
     * failed.
     */
    ProposalStatus[ProposalStatus["PROPOSAL_STATUS_FAILED"] = 5] = "PROPOSAL_STATUS_FAILED";
    ProposalStatus[ProposalStatus["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(ProposalStatus = exports.ProposalStatus || (exports.ProposalStatus = {}));
function proposalStatusFromJSON(object) {
    switch (object) {
        case 0:
        case "PROPOSAL_STATUS_UNSPECIFIED":
            return ProposalStatus.PROPOSAL_STATUS_UNSPECIFIED;
        case 1:
        case "PROPOSAL_STATUS_DEPOSIT_PERIOD":
            return ProposalStatus.PROPOSAL_STATUS_DEPOSIT_PERIOD;
        case 2:
        case "PROPOSAL_STATUS_VOTING_PERIOD":
            return ProposalStatus.PROPOSAL_STATUS_VOTING_PERIOD;
        case 3:
        case "PROPOSAL_STATUS_PASSED":
            return ProposalStatus.PROPOSAL_STATUS_PASSED;
        case 4:
        case "PROPOSAL_STATUS_REJECTED":
            return ProposalStatus.PROPOSAL_STATUS_REJECTED;
        case 5:
        case "PROPOSAL_STATUS_FAILED":
            return ProposalStatus.PROPOSAL_STATUS_FAILED;
        case -1:
        case "UNRECOGNIZED":
        default:
            return ProposalStatus.UNRECOGNIZED;
    }
}
exports.proposalStatusFromJSON = proposalStatusFromJSON;
function proposalStatusToJSON(object) {
    switch (object) {
        case ProposalStatus.PROPOSAL_STATUS_UNSPECIFIED:
            return "PROPOSAL_STATUS_UNSPECIFIED";
        case ProposalStatus.PROPOSAL_STATUS_DEPOSIT_PERIOD:
            return "PROPOSAL_STATUS_DEPOSIT_PERIOD";
        case ProposalStatus.PROPOSAL_STATUS_VOTING_PERIOD:
            return "PROPOSAL_STATUS_VOTING_PERIOD";
        case ProposalStatus.PROPOSAL_STATUS_PASSED:
            return "PROPOSAL_STATUS_PASSED";
        case ProposalStatus.PROPOSAL_STATUS_REJECTED:
            return "PROPOSAL_STATUS_REJECTED";
        case ProposalStatus.PROPOSAL_STATUS_FAILED:
            return "PROPOSAL_STATUS_FAILED";
        case ProposalStatus.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.proposalStatusToJSON = proposalStatusToJSON;
function createBaseWeightedVoteOption() {
    return {
        option: 0,
        weight: "",
    };
}
exports.WeightedVoteOption = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.option !== 0) {
            writer.uint32(8).int32(message.option);
        }
        if (message.weight !== "") {
            writer.uint32(18).string(message.weight);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseWeightedVoteOption();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.option = reader.int32();
                    break;
                case 2:
                    message.weight = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            option: (0, helpers_1.isSet)(object.option) ? voteOptionFromJSON(object.option) : 0,
            weight: (0, helpers_1.isSet)(object.weight) ? String(object.weight) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.option !== undefined && (obj.option = voteOptionToJSON(message.option));
        message.weight !== undefined && (obj.weight = message.weight);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseWeightedVoteOption();
        message.option = object.option ?? 0;
        message.weight = object.weight ?? "";
        return message;
    },
};
function createBaseDeposit() {
    return {
        proposalId: helpers_1.Long.UZERO,
        depositor: "",
        amount: [],
    };
}
exports.Deposit = {
    encode(message, writer = _m0.Writer.create()) {
        if (!message.proposalId.isZero()) {
            writer.uint32(8).uint64(message.proposalId);
        }
        if (message.depositor !== "") {
            writer.uint32(18).string(message.depositor);
        }
        for (const v of message.amount) {
            coin_1.Coin.encode(v, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDeposit();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.depositor = reader.string();
                    break;
                case 3:
                    message.amount.push(coin_1.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            proposalId: (0, helpers_1.isSet)(object.proposalId) ? helpers_1.Long.fromValue(object.proposalId) : helpers_1.Long.UZERO,
            depositor: (0, helpers_1.isSet)(object.depositor) ? String(object.depositor) : "",
            amount: Array.isArray(object?.amount) ? object.amount.map((e) => coin_1.Coin.fromJSON(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || helpers_1.Long.UZERO).toString());
        message.depositor !== undefined && (obj.depositor = message.depositor);
        if (message.amount) {
            obj.amount = message.amount.map((e) => (e ? coin_1.Coin.toJSON(e) : undefined));
        }
        else {
            obj.amount = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseDeposit();
        message.proposalId =
            object.proposalId !== undefined && object.proposalId !== null
                ? helpers_1.Long.fromValue(object.proposalId)
                : helpers_1.Long.UZERO;
        message.depositor = object.depositor ?? "";
        message.amount = object.amount?.map((e) => coin_1.Coin.fromPartial(e)) || [];
        return message;
    },
};
function createBaseProposal() {
    return {
        id: helpers_1.Long.UZERO,
        messages: [],
        status: 0,
        finalTallyResult: undefined,
        submitTime: undefined,
        depositEndTime: undefined,
        totalDeposit: [],
        votingStartTime: undefined,
        votingEndTime: undefined,
        metadata: "",
        title: "",
        summary: "",
        proposer: "",
    };
}
exports.Proposal = {
    encode(message, writer = _m0.Writer.create()) {
        if (!message.id.isZero()) {
            writer.uint32(8).uint64(message.id);
        }
        for (const v of message.messages) {
            any_1.Any.encode(v, writer.uint32(18).fork()).ldelim();
        }
        if (message.status !== 0) {
            writer.uint32(24).int32(message.status);
        }
        if (message.finalTallyResult !== undefined) {
            exports.TallyResult.encode(message.finalTallyResult, writer.uint32(34).fork()).ldelim();
        }
        if (message.submitTime !== undefined) {
            timestamp_1.Timestamp.encode(message.submitTime, writer.uint32(42).fork()).ldelim();
        }
        if (message.depositEndTime !== undefined) {
            timestamp_1.Timestamp.encode(message.depositEndTime, writer.uint32(50).fork()).ldelim();
        }
        for (const v of message.totalDeposit) {
            coin_1.Coin.encode(v, writer.uint32(58).fork()).ldelim();
        }
        if (message.votingStartTime !== undefined) {
            timestamp_1.Timestamp.encode(message.votingStartTime, writer.uint32(66).fork()).ldelim();
        }
        if (message.votingEndTime !== undefined) {
            timestamp_1.Timestamp.encode(message.votingEndTime, writer.uint32(74).fork()).ldelim();
        }
        if (message.metadata !== "") {
            writer.uint32(82).string(message.metadata);
        }
        if (message.title !== "") {
            writer.uint32(90).string(message.title);
        }
        if (message.summary !== "") {
            writer.uint32(98).string(message.summary);
        }
        if (message.proposer !== "") {
            writer.uint32(106).string(message.proposer);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseProposal();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.id = reader.uint64();
                    break;
                case 2:
                    message.messages.push(any_1.Any.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.status = reader.int32();
                    break;
                case 4:
                    message.finalTallyResult = exports.TallyResult.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.submitTime = timestamp_1.Timestamp.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.depositEndTime = timestamp_1.Timestamp.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.totalDeposit.push(coin_1.Coin.decode(reader, reader.uint32()));
                    break;
                case 8:
                    message.votingStartTime = timestamp_1.Timestamp.decode(reader, reader.uint32());
                    break;
                case 9:
                    message.votingEndTime = timestamp_1.Timestamp.decode(reader, reader.uint32());
                    break;
                case 10:
                    message.metadata = reader.string();
                    break;
                case 11:
                    message.title = reader.string();
                    break;
                case 12:
                    message.summary = reader.string();
                    break;
                case 13:
                    message.proposer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            id: (0, helpers_1.isSet)(object.id) ? helpers_1.Long.fromValue(object.id) : helpers_1.Long.UZERO,
            messages: Array.isArray(object?.messages) ? object.messages.map((e) => any_1.Any.fromJSON(e)) : [],
            status: (0, helpers_1.isSet)(object.status) ? proposalStatusFromJSON(object.status) : 0,
            finalTallyResult: (0, helpers_1.isSet)(object.finalTallyResult)
                ? exports.TallyResult.fromJSON(object.finalTallyResult)
                : undefined,
            submitTime: (0, helpers_1.isSet)(object.submitTime) ? (0, helpers_1.fromJsonTimestamp)(object.submitTime) : undefined,
            depositEndTime: (0, helpers_1.isSet)(object.depositEndTime) ? (0, helpers_1.fromJsonTimestamp)(object.depositEndTime) : undefined,
            totalDeposit: Array.isArray(object?.totalDeposit)
                ? object.totalDeposit.map((e) => coin_1.Coin.fromJSON(e))
                : [],
            votingStartTime: (0, helpers_1.isSet)(object.votingStartTime) ? (0, helpers_1.fromJsonTimestamp)(object.votingStartTime) : undefined,
            votingEndTime: (0, helpers_1.isSet)(object.votingEndTime) ? (0, helpers_1.fromJsonTimestamp)(object.votingEndTime) : undefined,
            metadata: (0, helpers_1.isSet)(object.metadata) ? String(object.metadata) : "",
            title: (0, helpers_1.isSet)(object.title) ? String(object.title) : "",
            summary: (0, helpers_1.isSet)(object.summary) ? String(object.summary) : "",
            proposer: (0, helpers_1.isSet)(object.proposer) ? String(object.proposer) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.id !== undefined && (obj.id = (message.id || helpers_1.Long.UZERO).toString());
        if (message.messages) {
            obj.messages = message.messages.map((e) => (e ? any_1.Any.toJSON(e) : undefined));
        }
        else {
            obj.messages = [];
        }
        message.status !== undefined && (obj.status = proposalStatusToJSON(message.status));
        message.finalTallyResult !== undefined &&
            (obj.finalTallyResult = message.finalTallyResult
                ? exports.TallyResult.toJSON(message.finalTallyResult)
                : undefined);
        message.submitTime !== undefined && (obj.submitTime = (0, helpers_1.fromTimestamp)(message.submitTime).toISOString());
        message.depositEndTime !== undefined &&
            (obj.depositEndTime = (0, helpers_1.fromTimestamp)(message.depositEndTime).toISOString());
        if (message.totalDeposit) {
            obj.totalDeposit = message.totalDeposit.map((e) => (e ? coin_1.Coin.toJSON(e) : undefined));
        }
        else {
            obj.totalDeposit = [];
        }
        message.votingStartTime !== undefined &&
            (obj.votingStartTime = (0, helpers_1.fromTimestamp)(message.votingStartTime).toISOString());
        message.votingEndTime !== undefined &&
            (obj.votingEndTime = (0, helpers_1.fromTimestamp)(message.votingEndTime).toISOString());
        message.metadata !== undefined && (obj.metadata = message.metadata);
        message.title !== undefined && (obj.title = message.title);
        message.summary !== undefined && (obj.summary = message.summary);
        message.proposer !== undefined && (obj.proposer = message.proposer);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseProposal();
        message.id = object.id !== undefined && object.id !== null ? helpers_1.Long.fromValue(object.id) : helpers_1.Long.UZERO;
        message.messages = object.messages?.map((e) => any_1.Any.fromPartial(e)) || [];
        message.status = object.status ?? 0;
        message.finalTallyResult =
            object.finalTallyResult !== undefined && object.finalTallyResult !== null
                ? exports.TallyResult.fromPartial(object.finalTallyResult)
                : undefined;
        message.submitTime =
            object.submitTime !== undefined && object.submitTime !== null
                ? timestamp_1.Timestamp.fromPartial(object.submitTime)
                : undefined;
        message.depositEndTime =
            object.depositEndTime !== undefined && object.depositEndTime !== null
                ? timestamp_1.Timestamp.fromPartial(object.depositEndTime)
                : undefined;
        message.totalDeposit = object.totalDeposit?.map((e) => coin_1.Coin.fromPartial(e)) || [];
        message.votingStartTime =
            object.votingStartTime !== undefined && object.votingStartTime !== null
                ? timestamp_1.Timestamp.fromPartial(object.votingStartTime)
                : undefined;
        message.votingEndTime =
            object.votingEndTime !== undefined && object.votingEndTime !== null
                ? timestamp_1.Timestamp.fromPartial(object.votingEndTime)
                : undefined;
        message.metadata = object.metadata ?? "";
        message.title = object.title ?? "";
        message.summary = object.summary ?? "";
        message.proposer = object.proposer ?? "";
        return message;
    },
};
function createBaseTallyResult() {
    return {
        yesCount: "",
        abstainCount: "",
        noCount: "",
        noWithVetoCount: "",
    };
}
exports.TallyResult = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.yesCount !== "") {
            writer.uint32(10).string(message.yesCount);
        }
        if (message.abstainCount !== "") {
            writer.uint32(18).string(message.abstainCount);
        }
        if (message.noCount !== "") {
            writer.uint32(26).string(message.noCount);
        }
        if (message.noWithVetoCount !== "") {
            writer.uint32(34).string(message.noWithVetoCount);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTallyResult();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.yesCount = reader.string();
                    break;
                case 2:
                    message.abstainCount = reader.string();
                    break;
                case 3:
                    message.noCount = reader.string();
                    break;
                case 4:
                    message.noWithVetoCount = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            yesCount: (0, helpers_1.isSet)(object.yesCount) ? String(object.yesCount) : "",
            abstainCount: (0, helpers_1.isSet)(object.abstainCount) ? String(object.abstainCount) : "",
            noCount: (0, helpers_1.isSet)(object.noCount) ? String(object.noCount) : "",
            noWithVetoCount: (0, helpers_1.isSet)(object.noWithVetoCount) ? String(object.noWithVetoCount) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.yesCount !== undefined && (obj.yesCount = message.yesCount);
        message.abstainCount !== undefined && (obj.abstainCount = message.abstainCount);
        message.noCount !== undefined && (obj.noCount = message.noCount);
        message.noWithVetoCount !== undefined && (obj.noWithVetoCount = message.noWithVetoCount);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseTallyResult();
        message.yesCount = object.yesCount ?? "";
        message.abstainCount = object.abstainCount ?? "";
        message.noCount = object.noCount ?? "";
        message.noWithVetoCount = object.noWithVetoCount ?? "";
        return message;
    },
};
function createBaseVote() {
    return {
        proposalId: helpers_1.Long.UZERO,
        voter: "",
        options: [],
        metadata: "",
    };
}
exports.Vote = {
    encode(message, writer = _m0.Writer.create()) {
        if (!message.proposalId.isZero()) {
            writer.uint32(8).uint64(message.proposalId);
        }
        if (message.voter !== "") {
            writer.uint32(18).string(message.voter);
        }
        for (const v of message.options) {
            exports.WeightedVoteOption.encode(v, writer.uint32(34).fork()).ldelim();
        }
        if (message.metadata !== "") {
            writer.uint32(42).string(message.metadata);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVote();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.voter = reader.string();
                    break;
                case 4:
                    message.options.push(exports.WeightedVoteOption.decode(reader, reader.uint32()));
                    break;
                case 5:
                    message.metadata = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            proposalId: (0, helpers_1.isSet)(object.proposalId) ? helpers_1.Long.fromValue(object.proposalId) : helpers_1.Long.UZERO,
            voter: (0, helpers_1.isSet)(object.voter) ? String(object.voter) : "",
            options: Array.isArray(object?.options)
                ? object.options.map((e) => exports.WeightedVoteOption.fromJSON(e))
                : [],
            metadata: (0, helpers_1.isSet)(object.metadata) ? String(object.metadata) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || helpers_1.Long.UZERO).toString());
        message.voter !== undefined && (obj.voter = message.voter);
        if (message.options) {
            obj.options = message.options.map((e) => (e ? exports.WeightedVoteOption.toJSON(e) : undefined));
        }
        else {
            obj.options = [];
        }
        message.metadata !== undefined && (obj.metadata = message.metadata);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseVote();
        message.proposalId =
            object.proposalId !== undefined && object.proposalId !== null
                ? helpers_1.Long.fromValue(object.proposalId)
                : helpers_1.Long.UZERO;
        message.voter = object.voter ?? "";
        message.options = object.options?.map((e) => exports.WeightedVoteOption.fromPartial(e)) || [];
        message.metadata = object.metadata ?? "";
        return message;
    },
};
function createBaseDepositParams() {
    return {
        minDeposit: [],
        maxDepositPeriod: undefined,
    };
}
exports.DepositParams = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.minDeposit) {
            coin_1.Coin.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.maxDepositPeriod !== undefined) {
            duration_1.Duration.encode(message.maxDepositPeriod, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDepositParams();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.minDeposit.push(coin_1.Coin.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.maxDepositPeriod = duration_1.Duration.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            minDeposit: Array.isArray(object?.minDeposit)
                ? object.minDeposit.map((e) => coin_1.Coin.fromJSON(e))
                : [],
            maxDepositPeriod: (0, helpers_1.isSet)(object.maxDepositPeriod)
                ? duration_1.Duration.fromJSON(object.maxDepositPeriod)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.minDeposit) {
            obj.minDeposit = message.minDeposit.map((e) => (e ? coin_1.Coin.toJSON(e) : undefined));
        }
        else {
            obj.minDeposit = [];
        }
        message.maxDepositPeriod !== undefined &&
            (obj.maxDepositPeriod = message.maxDepositPeriod
                ? duration_1.Duration.toJSON(message.maxDepositPeriod)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseDepositParams();
        message.minDeposit = object.minDeposit?.map((e) => coin_1.Coin.fromPartial(e)) || [];
        message.maxDepositPeriod =
            object.maxDepositPeriod !== undefined && object.maxDepositPeriod !== null
                ? duration_1.Duration.fromPartial(object.maxDepositPeriod)
                : undefined;
        return message;
    },
};
function createBaseVotingParams() {
    return {
        votingPeriod: undefined,
    };
}
exports.VotingParams = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.votingPeriod !== undefined) {
            duration_1.Duration.encode(message.votingPeriod, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVotingParams();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.votingPeriod = duration_1.Duration.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            votingPeriod: (0, helpers_1.isSet)(object.votingPeriod) ? duration_1.Duration.fromJSON(object.votingPeriod) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.votingPeriod !== undefined &&
            (obj.votingPeriod = message.votingPeriod ? duration_1.Duration.toJSON(message.votingPeriod) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseVotingParams();
        message.votingPeriod =
            object.votingPeriod !== undefined && object.votingPeriod !== null
                ? duration_1.Duration.fromPartial(object.votingPeriod)
                : undefined;
        return message;
    },
};
function createBaseTallyParams() {
    return {
        quorum: "",
        threshold: "",
        vetoThreshold: "",
    };
}
exports.TallyParams = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.quorum !== "") {
            writer.uint32(10).string(message.quorum);
        }
        if (message.threshold !== "") {
            writer.uint32(18).string(message.threshold);
        }
        if (message.vetoThreshold !== "") {
            writer.uint32(26).string(message.vetoThreshold);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTallyParams();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.quorum = reader.string();
                    break;
                case 2:
                    message.threshold = reader.string();
                    break;
                case 3:
                    message.vetoThreshold = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            quorum: (0, helpers_1.isSet)(object.quorum) ? String(object.quorum) : "",
            threshold: (0, helpers_1.isSet)(object.threshold) ? String(object.threshold) : "",
            vetoThreshold: (0, helpers_1.isSet)(object.vetoThreshold) ? String(object.vetoThreshold) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.quorum !== undefined && (obj.quorum = message.quorum);
        message.threshold !== undefined && (obj.threshold = message.threshold);
        message.vetoThreshold !== undefined && (obj.vetoThreshold = message.vetoThreshold);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseTallyParams();
        message.quorum = object.quorum ?? "";
        message.threshold = object.threshold ?? "";
        message.vetoThreshold = object.vetoThreshold ?? "";
        return message;
    },
};
function createBaseParams() {
    return {
        minDeposit: [],
        maxDepositPeriod: undefined,
        votingPeriod: undefined,
        quorum: "",
        threshold: "",
        vetoThreshold: "",
        minInitialDepositRatio: "",
        burnVoteQuorum: false,
        burnProposalDepositPrevote: false,
        burnVoteVeto: false,
    };
}
exports.Params = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.minDeposit) {
            coin_1.Coin.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.maxDepositPeriod !== undefined) {
            duration_1.Duration.encode(message.maxDepositPeriod, writer.uint32(18).fork()).ldelim();
        }
        if (message.votingPeriod !== undefined) {
            duration_1.Duration.encode(message.votingPeriod, writer.uint32(26).fork()).ldelim();
        }
        if (message.quorum !== "") {
            writer.uint32(34).string(message.quorum);
        }
        if (message.threshold !== "") {
            writer.uint32(42).string(message.threshold);
        }
        if (message.vetoThreshold !== "") {
            writer.uint32(50).string(message.vetoThreshold);
        }
        if (message.minInitialDepositRatio !== "") {
            writer.uint32(58).string(message.minInitialDepositRatio);
        }
        if (message.burnVoteQuorum === true) {
            writer.uint32(104).bool(message.burnVoteQuorum);
        }
        if (message.burnProposalDepositPrevote === true) {
            writer.uint32(112).bool(message.burnProposalDepositPrevote);
        }
        if (message.burnVoteVeto === true) {
            writer.uint32(120).bool(message.burnVoteVeto);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseParams();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.minDeposit.push(coin_1.Coin.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.maxDepositPeriod = duration_1.Duration.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.votingPeriod = duration_1.Duration.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.quorum = reader.string();
                    break;
                case 5:
                    message.threshold = reader.string();
                    break;
                case 6:
                    message.vetoThreshold = reader.string();
                    break;
                case 7:
                    message.minInitialDepositRatio = reader.string();
                    break;
                case 13:
                    message.burnVoteQuorum = reader.bool();
                    break;
                case 14:
                    message.burnProposalDepositPrevote = reader.bool();
                    break;
                case 15:
                    message.burnVoteVeto = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            minDeposit: Array.isArray(object?.minDeposit)
                ? object.minDeposit.map((e) => coin_1.Coin.fromJSON(e))
                : [],
            maxDepositPeriod: (0, helpers_1.isSet)(object.maxDepositPeriod)
                ? duration_1.Duration.fromJSON(object.maxDepositPeriod)
                : undefined,
            votingPeriod: (0, helpers_1.isSet)(object.votingPeriod) ? duration_1.Duration.fromJSON(object.votingPeriod) : undefined,
            quorum: (0, helpers_1.isSet)(object.quorum) ? String(object.quorum) : "",
            threshold: (0, helpers_1.isSet)(object.threshold) ? String(object.threshold) : "",
            vetoThreshold: (0, helpers_1.isSet)(object.vetoThreshold) ? String(object.vetoThreshold) : "",
            minInitialDepositRatio: (0, helpers_1.isSet)(object.minInitialDepositRatio)
                ? String(object.minInitialDepositRatio)
                : "",
            burnVoteQuorum: (0, helpers_1.isSet)(object.burnVoteQuorum) ? Boolean(object.burnVoteQuorum) : false,
            burnProposalDepositPrevote: (0, helpers_1.isSet)(object.burnProposalDepositPrevote)
                ? Boolean(object.burnProposalDepositPrevote)
                : false,
            burnVoteVeto: (0, helpers_1.isSet)(object.burnVoteVeto) ? Boolean(object.burnVoteVeto) : false,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.minDeposit) {
            obj.minDeposit = message.minDeposit.map((e) => (e ? coin_1.Coin.toJSON(e) : undefined));
        }
        else {
            obj.minDeposit = [];
        }
        message.maxDepositPeriod !== undefined &&
            (obj.maxDepositPeriod = message.maxDepositPeriod
                ? duration_1.Duration.toJSON(message.maxDepositPeriod)
                : undefined);
        message.votingPeriod !== undefined &&
            (obj.votingPeriod = message.votingPeriod ? duration_1.Duration.toJSON(message.votingPeriod) : undefined);
        message.quorum !== undefined && (obj.quorum = message.quorum);
        message.threshold !== undefined && (obj.threshold = message.threshold);
        message.vetoThreshold !== undefined && (obj.vetoThreshold = message.vetoThreshold);
        message.minInitialDepositRatio !== undefined &&
            (obj.minInitialDepositRatio = message.minInitialDepositRatio);
        message.burnVoteQuorum !== undefined && (obj.burnVoteQuorum = message.burnVoteQuorum);
        message.burnProposalDepositPrevote !== undefined &&
            (obj.burnProposalDepositPrevote = message.burnProposalDepositPrevote);
        message.burnVoteVeto !== undefined && (obj.burnVoteVeto = message.burnVoteVeto);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseParams();
        message.minDeposit = object.minDeposit?.map((e) => coin_1.Coin.fromPartial(e)) || [];
        message.maxDepositPeriod =
            object.maxDepositPeriod !== undefined && object.maxDepositPeriod !== null
                ? duration_1.Duration.fromPartial(object.maxDepositPeriod)
                : undefined;
        message.votingPeriod =
            object.votingPeriod !== undefined && object.votingPeriod !== null
                ? duration_1.Duration.fromPartial(object.votingPeriod)
                : undefined;
        message.quorum = object.quorum ?? "";
        message.threshold = object.threshold ?? "";
        message.vetoThreshold = object.vetoThreshold ?? "";
        message.minInitialDepositRatio = object.minInitialDepositRatio ?? "";
        message.burnVoteQuorum = object.burnVoteQuorum ?? false;
        message.burnProposalDepositPrevote = object.burnProposalDepositPrevote ?? false;
        message.burnVoteVeto = object.burnVoteVeto ?? false;
        return message;
    },
};
//# sourceMappingURL=gov.js.map

/***/ }),

/***/ 51742:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.QueryClientImpl = exports.QueryTallyResultResponse = exports.QueryTallyResultRequest = exports.QueryDepositsResponse = exports.QueryDepositsRequest = exports.QueryDepositResponse = exports.QueryDepositRequest = exports.QueryParamsResponse = exports.QueryParamsRequest = exports.QueryVotesResponse = exports.QueryVotesRequest = exports.QueryVoteResponse = exports.QueryVoteRequest = exports.QueryProposalsResponse = exports.QueryProposalsRequest = exports.QueryProposalResponse = exports.QueryProposalRequest = exports.protobufPackage = void 0;
/* eslint-disable */
const gov_1 = __webpack_require__(17979);
const pagination_1 = __webpack_require__(84043);
const helpers_1 = __webpack_require__(92654);
const _m0 = __importStar(__webpack_require__(62100));
exports.protobufPackage = "cosmos.gov.v1";
function createBaseQueryProposalRequest() {
    return {
        proposalId: helpers_1.Long.UZERO,
    };
}
exports.QueryProposalRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (!message.proposalId.isZero()) {
            writer.uint32(8).uint64(message.proposalId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryProposalRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            proposalId: (0, helpers_1.isSet)(object.proposalId) ? helpers_1.Long.fromValue(object.proposalId) : helpers_1.Long.UZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || helpers_1.Long.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryProposalRequest();
        message.proposalId =
            object.proposalId !== undefined && object.proposalId !== null
                ? helpers_1.Long.fromValue(object.proposalId)
                : helpers_1.Long.UZERO;
        return message;
    },
};
function createBaseQueryProposalResponse() {
    return {
        proposal: undefined,
    };
}
exports.QueryProposalResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.proposal !== undefined) {
            gov_1.Proposal.encode(message.proposal, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryProposalResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.proposal = gov_1.Proposal.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            proposal: (0, helpers_1.isSet)(object.proposal) ? gov_1.Proposal.fromJSON(object.proposal) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.proposal !== undefined &&
            (obj.proposal = message.proposal ? gov_1.Proposal.toJSON(message.proposal) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryProposalResponse();
        message.proposal =
            object.proposal !== undefined && object.proposal !== null
                ? gov_1.Proposal.fromPartial(object.proposal)
                : undefined;
        return message;
    },
};
function createBaseQueryProposalsRequest() {
    return {
        proposalStatus: 0,
        voter: "",
        depositor: "",
        pagination: undefined,
    };
}
exports.QueryProposalsRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.proposalStatus !== 0) {
            writer.uint32(8).int32(message.proposalStatus);
        }
        if (message.voter !== "") {
            writer.uint32(18).string(message.voter);
        }
        if (message.depositor !== "") {
            writer.uint32(26).string(message.depositor);
        }
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryProposalsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.proposalStatus = reader.int32();
                    break;
                case 2:
                    message.voter = reader.string();
                    break;
                case 3:
                    message.depositor = reader.string();
                    break;
                case 4:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            proposalStatus: (0, helpers_1.isSet)(object.proposalStatus) ? (0, gov_1.proposalStatusFromJSON)(object.proposalStatus) : 0,
            voter: (0, helpers_1.isSet)(object.voter) ? String(object.voter) : "",
            depositor: (0, helpers_1.isSet)(object.depositor) ? String(object.depositor) : "",
            pagination: (0, helpers_1.isSet)(object.pagination) ? pagination_1.PageRequest.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.proposalStatus !== undefined &&
            (obj.proposalStatus = (0, gov_1.proposalStatusToJSON)(message.proposalStatus));
        message.voter !== undefined && (obj.voter = message.voter);
        message.depositor !== undefined && (obj.depositor = message.depositor);
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryProposalsRequest();
        message.proposalStatus = object.proposalStatus ?? 0;
        message.voter = object.voter ?? "";
        message.depositor = object.depositor ?? "";
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryProposalsResponse() {
    return {
        proposals: [],
        pagination: undefined,
    };
}
exports.QueryProposalsResponse = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.proposals) {
            gov_1.Proposal.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryProposalsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.proposals.push(gov_1.Proposal.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            proposals: Array.isArray(object?.proposals)
                ? object.proposals.map((e) => gov_1.Proposal.fromJSON(e))
                : [],
            pagination: (0, helpers_1.isSet)(object.pagination) ? pagination_1.PageResponse.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.proposals) {
            obj.proposals = message.proposals.map((e) => (e ? gov_1.Proposal.toJSON(e) : undefined));
        }
        else {
            obj.proposals = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryProposalsResponse();
        message.proposals = object.proposals?.map((e) => gov_1.Proposal.fromPartial(e)) || [];
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryVoteRequest() {
    return {
        proposalId: helpers_1.Long.UZERO,
        voter: "",
    };
}
exports.QueryVoteRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (!message.proposalId.isZero()) {
            writer.uint32(8).uint64(message.proposalId);
        }
        if (message.voter !== "") {
            writer.uint32(18).string(message.voter);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryVoteRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.voter = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            proposalId: (0, helpers_1.isSet)(object.proposalId) ? helpers_1.Long.fromValue(object.proposalId) : helpers_1.Long.UZERO,
            voter: (0, helpers_1.isSet)(object.voter) ? String(object.voter) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || helpers_1.Long.UZERO).toString());
        message.voter !== undefined && (obj.voter = message.voter);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryVoteRequest();
        message.proposalId =
            object.proposalId !== undefined && object.proposalId !== null
                ? helpers_1.Long.fromValue(object.proposalId)
                : helpers_1.Long.UZERO;
        message.voter = object.voter ?? "";
        return message;
    },
};
function createBaseQueryVoteResponse() {
    return {
        vote: undefined,
    };
}
exports.QueryVoteResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.vote !== undefined) {
            gov_1.Vote.encode(message.vote, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryVoteResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.vote = gov_1.Vote.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            vote: (0, helpers_1.isSet)(object.vote) ? gov_1.Vote.fromJSON(object.vote) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.vote !== undefined && (obj.vote = message.vote ? gov_1.Vote.toJSON(message.vote) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryVoteResponse();
        message.vote =
            object.vote !== undefined && object.vote !== null ? gov_1.Vote.fromPartial(object.vote) : undefined;
        return message;
    },
};
function createBaseQueryVotesRequest() {
    return {
        proposalId: helpers_1.Long.UZERO,
        pagination: undefined,
    };
}
exports.QueryVotesRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (!message.proposalId.isZero()) {
            writer.uint32(8).uint64(message.proposalId);
        }
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryVotesRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            proposalId: (0, helpers_1.isSet)(object.proposalId) ? helpers_1.Long.fromValue(object.proposalId) : helpers_1.Long.UZERO,
            pagination: (0, helpers_1.isSet)(object.pagination) ? pagination_1.PageRequest.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || helpers_1.Long.UZERO).toString());
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryVotesRequest();
        message.proposalId =
            object.proposalId !== undefined && object.proposalId !== null
                ? helpers_1.Long.fromValue(object.proposalId)
                : helpers_1.Long.UZERO;
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryVotesResponse() {
    return {
        votes: [],
        pagination: undefined,
    };
}
exports.QueryVotesResponse = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.votes) {
            gov_1.Vote.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryVotesResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.votes.push(gov_1.Vote.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            votes: Array.isArray(object?.votes) ? object.votes.map((e) => gov_1.Vote.fromJSON(e)) : [],
            pagination: (0, helpers_1.isSet)(object.pagination) ? pagination_1.PageResponse.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.votes) {
            obj.votes = message.votes.map((e) => (e ? gov_1.Vote.toJSON(e) : undefined));
        }
        else {
            obj.votes = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryVotesResponse();
        message.votes = object.votes?.map((e) => gov_1.Vote.fromPartial(e)) || [];
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryParamsRequest() {
    return {
        paramsType: "",
    };
}
exports.QueryParamsRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.paramsType !== "") {
            writer.uint32(10).string(message.paramsType);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryParamsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.paramsType = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            paramsType: (0, helpers_1.isSet)(object.paramsType) ? String(object.paramsType) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.paramsType !== undefined && (obj.paramsType = message.paramsType);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryParamsRequest();
        message.paramsType = object.paramsType ?? "";
        return message;
    },
};
function createBaseQueryParamsResponse() {
    return {
        votingParams: undefined,
        depositParams: undefined,
        tallyParams: undefined,
        params: undefined,
    };
}
exports.QueryParamsResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.votingParams !== undefined) {
            gov_1.VotingParams.encode(message.votingParams, writer.uint32(10).fork()).ldelim();
        }
        if (message.depositParams !== undefined) {
            gov_1.DepositParams.encode(message.depositParams, writer.uint32(18).fork()).ldelim();
        }
        if (message.tallyParams !== undefined) {
            gov_1.TallyParams.encode(message.tallyParams, writer.uint32(26).fork()).ldelim();
        }
        if (message.params !== undefined) {
            gov_1.Params.encode(message.params, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryParamsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.votingParams = gov_1.VotingParams.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.depositParams = gov_1.DepositParams.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.tallyParams = gov_1.TallyParams.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.params = gov_1.Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            votingParams: (0, helpers_1.isSet)(object.votingParams) ? gov_1.VotingParams.fromJSON(object.votingParams) : undefined,
            depositParams: (0, helpers_1.isSet)(object.depositParams) ? gov_1.DepositParams.fromJSON(object.depositParams) : undefined,
            tallyParams: (0, helpers_1.isSet)(object.tallyParams) ? gov_1.TallyParams.fromJSON(object.tallyParams) : undefined,
            params: (0, helpers_1.isSet)(object.params) ? gov_1.Params.fromJSON(object.params) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.votingParams !== undefined &&
            (obj.votingParams = message.votingParams ? gov_1.VotingParams.toJSON(message.votingParams) : undefined);
        message.depositParams !== undefined &&
            (obj.depositParams = message.depositParams ? gov_1.DepositParams.toJSON(message.depositParams) : undefined);
        message.tallyParams !== undefined &&
            (obj.tallyParams = message.tallyParams ? gov_1.TallyParams.toJSON(message.tallyParams) : undefined);
        message.params !== undefined && (obj.params = message.params ? gov_1.Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryParamsResponse();
        message.votingParams =
            object.votingParams !== undefined && object.votingParams !== null
                ? gov_1.VotingParams.fromPartial(object.votingParams)
                : undefined;
        message.depositParams =
            object.depositParams !== undefined && object.depositParams !== null
                ? gov_1.DepositParams.fromPartial(object.depositParams)
                : undefined;
        message.tallyParams =
            object.tallyParams !== undefined && object.tallyParams !== null
                ? gov_1.TallyParams.fromPartial(object.tallyParams)
                : undefined;
        message.params =
            object.params !== undefined && object.params !== null ? gov_1.Params.fromPartial(object.params) : undefined;
        return message;
    },
};
function createBaseQueryDepositRequest() {
    return {
        proposalId: helpers_1.Long.UZERO,
        depositor: "",
    };
}
exports.QueryDepositRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (!message.proposalId.isZero()) {
            writer.uint32(8).uint64(message.proposalId);
        }
        if (message.depositor !== "") {
            writer.uint32(18).string(message.depositor);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryDepositRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.depositor = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            proposalId: (0, helpers_1.isSet)(object.proposalId) ? helpers_1.Long.fromValue(object.proposalId) : helpers_1.Long.UZERO,
            depositor: (0, helpers_1.isSet)(object.depositor) ? String(object.depositor) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || helpers_1.Long.UZERO).toString());
        message.depositor !== undefined && (obj.depositor = message.depositor);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryDepositRequest();
        message.proposalId =
            object.proposalId !== undefined && object.proposalId !== null
                ? helpers_1.Long.fromValue(object.proposalId)
                : helpers_1.Long.UZERO;
        message.depositor = object.depositor ?? "";
        return message;
    },
};
function createBaseQueryDepositResponse() {
    return {
        deposit: undefined,
    };
}
exports.QueryDepositResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.deposit !== undefined) {
            gov_1.Deposit.encode(message.deposit, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryDepositResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.deposit = gov_1.Deposit.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            deposit: (0, helpers_1.isSet)(object.deposit) ? gov_1.Deposit.fromJSON(object.deposit) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.deposit !== undefined &&
            (obj.deposit = message.deposit ? gov_1.Deposit.toJSON(message.deposit) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryDepositResponse();
        message.deposit =
            object.deposit !== undefined && object.deposit !== null
                ? gov_1.Deposit.fromPartial(object.deposit)
                : undefined;
        return message;
    },
};
function createBaseQueryDepositsRequest() {
    return {
        proposalId: helpers_1.Long.UZERO,
        pagination: undefined,
    };
}
exports.QueryDepositsRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (!message.proposalId.isZero()) {
            writer.uint32(8).uint64(message.proposalId);
        }
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryDepositsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            proposalId: (0, helpers_1.isSet)(object.proposalId) ? helpers_1.Long.fromValue(object.proposalId) : helpers_1.Long.UZERO,
            pagination: (0, helpers_1.isSet)(object.pagination) ? pagination_1.PageRequest.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || helpers_1.Long.UZERO).toString());
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryDepositsRequest();
        message.proposalId =
            object.proposalId !== undefined && object.proposalId !== null
                ? helpers_1.Long.fromValue(object.proposalId)
                : helpers_1.Long.UZERO;
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryDepositsResponse() {
    return {
        deposits: [],
        pagination: undefined,
    };
}
exports.QueryDepositsResponse = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.deposits) {
            gov_1.Deposit.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryDepositsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.deposits.push(gov_1.Deposit.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            deposits: Array.isArray(object?.deposits) ? object.deposits.map((e) => gov_1.Deposit.fromJSON(e)) : [],
            pagination: (0, helpers_1.isSet)(object.pagination) ? pagination_1.PageResponse.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.deposits) {
            obj.deposits = message.deposits.map((e) => (e ? gov_1.Deposit.toJSON(e) : undefined));
        }
        else {
            obj.deposits = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryDepositsResponse();
        message.deposits = object.deposits?.map((e) => gov_1.Deposit.fromPartial(e)) || [];
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryTallyResultRequest() {
    return {
        proposalId: helpers_1.Long.UZERO,
    };
}
exports.QueryTallyResultRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (!message.proposalId.isZero()) {
            writer.uint32(8).uint64(message.proposalId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryTallyResultRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            proposalId: (0, helpers_1.isSet)(object.proposalId) ? helpers_1.Long.fromValue(object.proposalId) : helpers_1.Long.UZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || helpers_1.Long.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryTallyResultRequest();
        message.proposalId =
            object.proposalId !== undefined && object.proposalId !== null
                ? helpers_1.Long.fromValue(object.proposalId)
                : helpers_1.Long.UZERO;
        return message;
    },
};
function createBaseQueryTallyResultResponse() {
    return {
        tally: undefined,
    };
}
exports.QueryTallyResultResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.tally !== undefined) {
            gov_1.TallyResult.encode(message.tally, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryTallyResultResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.tally = gov_1.TallyResult.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            tally: (0, helpers_1.isSet)(object.tally) ? gov_1.TallyResult.fromJSON(object.tally) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.tally !== undefined &&
            (obj.tally = message.tally ? gov_1.TallyResult.toJSON(message.tally) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryTallyResultResponse();
        message.tally =
            object.tally !== undefined && object.tally !== null ? gov_1.TallyResult.fromPartial(object.tally) : undefined;
        return message;
    },
};
class QueryClientImpl {
    constructor(rpc) {
        this.rpc = rpc;
        this.Proposal = this.Proposal.bind(this);
        this.Proposals = this.Proposals.bind(this);
        this.Vote = this.Vote.bind(this);
        this.Votes = this.Votes.bind(this);
        this.Params = this.Params.bind(this);
        this.Deposit = this.Deposit.bind(this);
        this.Deposits = this.Deposits.bind(this);
        this.TallyResult = this.TallyResult.bind(this);
    }
    Proposal(request) {
        const data = exports.QueryProposalRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.gov.v1.Query", "Proposal", data);
        return promise.then((data) => exports.QueryProposalResponse.decode(new _m0.Reader(data)));
    }
    Proposals(request) {
        const data = exports.QueryProposalsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.gov.v1.Query", "Proposals", data);
        return promise.then((data) => exports.QueryProposalsResponse.decode(new _m0.Reader(data)));
    }
    Vote(request) {
        const data = exports.QueryVoteRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.gov.v1.Query", "Vote", data);
        return promise.then((data) => exports.QueryVoteResponse.decode(new _m0.Reader(data)));
    }
    Votes(request) {
        const data = exports.QueryVotesRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.gov.v1.Query", "Votes", data);
        return promise.then((data) => exports.QueryVotesResponse.decode(new _m0.Reader(data)));
    }
    Params(request) {
        const data = exports.QueryParamsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.gov.v1.Query", "Params", data);
        return promise.then((data) => exports.QueryParamsResponse.decode(new _m0.Reader(data)));
    }
    Deposit(request) {
        const data = exports.QueryDepositRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.gov.v1.Query", "Deposit", data);
        return promise.then((data) => exports.QueryDepositResponse.decode(new _m0.Reader(data)));
    }
    Deposits(request) {
        const data = exports.QueryDepositsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.gov.v1.Query", "Deposits", data);
        return promise.then((data) => exports.QueryDepositsResponse.decode(new _m0.Reader(data)));
    }
    TallyResult(request) {
        const data = exports.QueryTallyResultRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.gov.v1.Query", "TallyResult", data);
        return promise.then((data) => exports.QueryTallyResultResponse.decode(new _m0.Reader(data)));
    }
}
exports.QueryClientImpl = QueryClientImpl;
//# sourceMappingURL=query.js.map

/***/ }),

/***/ 13037:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MsgClientImpl = exports.MsgUpdateParamsResponse = exports.MsgUpdateParams = exports.MsgDepositResponse = exports.MsgDeposit = exports.MsgVoteWeightedResponse = exports.MsgVoteWeighted = exports.MsgVoteResponse = exports.MsgVote = exports.MsgExecLegacyContentResponse = exports.MsgExecLegacyContent = exports.MsgSubmitProposalResponse = exports.MsgSubmitProposal = exports.protobufPackage = void 0;
/* eslint-disable */
const any_1 = __webpack_require__(75654);
const coin_1 = __webpack_require__(81637);
const gov_1 = __webpack_require__(17979);
const helpers_1 = __webpack_require__(92654);
const _m0 = __importStar(__webpack_require__(62100));
exports.protobufPackage = "cosmos.gov.v1";
function createBaseMsgSubmitProposal() {
    return {
        messages: [],
        initialDeposit: [],
        proposer: "",
        metadata: "",
        title: "",
        summary: "",
    };
}
exports.MsgSubmitProposal = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.messages) {
            any_1.Any.encode(v, writer.uint32(10).fork()).ldelim();
        }
        for (const v of message.initialDeposit) {
            coin_1.Coin.encode(v, writer.uint32(18).fork()).ldelim();
        }
        if (message.proposer !== "") {
            writer.uint32(26).string(message.proposer);
        }
        if (message.metadata !== "") {
            writer.uint32(34).string(message.metadata);
        }
        if (message.title !== "") {
            writer.uint32(42).string(message.title);
        }
        if (message.summary !== "") {
            writer.uint32(50).string(message.summary);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgSubmitProposal();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.messages.push(any_1.Any.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.initialDeposit.push(coin_1.Coin.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.proposer = reader.string();
                    break;
                case 4:
                    message.metadata = reader.string();
                    break;
                case 5:
                    message.title = reader.string();
                    break;
                case 6:
                    message.summary = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            messages: Array.isArray(object?.messages) ? object.messages.map((e) => any_1.Any.fromJSON(e)) : [],
            initialDeposit: Array.isArray(object?.initialDeposit)
                ? object.initialDeposit.map((e) => coin_1.Coin.fromJSON(e))
                : [],
            proposer: (0, helpers_1.isSet)(object.proposer) ? String(object.proposer) : "",
            metadata: (0, helpers_1.isSet)(object.metadata) ? String(object.metadata) : "",
            title: (0, helpers_1.isSet)(object.title) ? String(object.title) : "",
            summary: (0, helpers_1.isSet)(object.summary) ? String(object.summary) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.messages) {
            obj.messages = message.messages.map((e) => (e ? any_1.Any.toJSON(e) : undefined));
        }
        else {
            obj.messages = [];
        }
        if (message.initialDeposit) {
            obj.initialDeposit = message.initialDeposit.map((e) => (e ? coin_1.Coin.toJSON(e) : undefined));
        }
        else {
            obj.initialDeposit = [];
        }
        message.proposer !== undefined && (obj.proposer = message.proposer);
        message.metadata !== undefined && (obj.metadata = message.metadata);
        message.title !== undefined && (obj.title = message.title);
        message.summary !== undefined && (obj.summary = message.summary);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgSubmitProposal();
        message.messages = object.messages?.map((e) => any_1.Any.fromPartial(e)) || [];
        message.initialDeposit = object.initialDeposit?.map((e) => coin_1.Coin.fromPartial(e)) || [];
        message.proposer = object.proposer ?? "";
        message.metadata = object.metadata ?? "";
        message.title = object.title ?? "";
        message.summary = object.summary ?? "";
        return message;
    },
};
function createBaseMsgSubmitProposalResponse() {
    return {
        proposalId: helpers_1.Long.UZERO,
    };
}
exports.MsgSubmitProposalResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (!message.proposalId.isZero()) {
            writer.uint32(8).uint64(message.proposalId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgSubmitProposalResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            proposalId: (0, helpers_1.isSet)(object.proposalId) ? helpers_1.Long.fromValue(object.proposalId) : helpers_1.Long.UZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || helpers_1.Long.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgSubmitProposalResponse();
        message.proposalId =
            object.proposalId !== undefined && object.proposalId !== null
                ? helpers_1.Long.fromValue(object.proposalId)
                : helpers_1.Long.UZERO;
        return message;
    },
};
function createBaseMsgExecLegacyContent() {
    return {
        content: undefined,
        authority: "",
    };
}
exports.MsgExecLegacyContent = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.content !== undefined) {
            any_1.Any.encode(message.content, writer.uint32(10).fork()).ldelim();
        }
        if (message.authority !== "") {
            writer.uint32(18).string(message.authority);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgExecLegacyContent();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.content = any_1.Any.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.authority = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            content: (0, helpers_1.isSet)(object.content) ? any_1.Any.fromJSON(object.content) : undefined,
            authority: (0, helpers_1.isSet)(object.authority) ? String(object.authority) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.content !== undefined &&
            (obj.content = message.content ? any_1.Any.toJSON(message.content) : undefined);
        message.authority !== undefined && (obj.authority = message.authority);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgExecLegacyContent();
        message.content =
            object.content !== undefined && object.content !== null ? any_1.Any.fromPartial(object.content) : undefined;
        message.authority = object.authority ?? "";
        return message;
    },
};
function createBaseMsgExecLegacyContentResponse() {
    return {};
}
exports.MsgExecLegacyContentResponse = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgExecLegacyContentResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgExecLegacyContentResponse();
        return message;
    },
};
function createBaseMsgVote() {
    return {
        proposalId: helpers_1.Long.UZERO,
        voter: "",
        option: 0,
        metadata: "",
    };
}
exports.MsgVote = {
    encode(message, writer = _m0.Writer.create()) {
        if (!message.proposalId.isZero()) {
            writer.uint32(8).uint64(message.proposalId);
        }
        if (message.voter !== "") {
            writer.uint32(18).string(message.voter);
        }
        if (message.option !== 0) {
            writer.uint32(24).int32(message.option);
        }
        if (message.metadata !== "") {
            writer.uint32(34).string(message.metadata);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgVote();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.voter = reader.string();
                    break;
                case 3:
                    message.option = reader.int32();
                    break;
                case 4:
                    message.metadata = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            proposalId: (0, helpers_1.isSet)(object.proposalId) ? helpers_1.Long.fromValue(object.proposalId) : helpers_1.Long.UZERO,
            voter: (0, helpers_1.isSet)(object.voter) ? String(object.voter) : "",
            option: (0, helpers_1.isSet)(object.option) ? (0, gov_1.voteOptionFromJSON)(object.option) : 0,
            metadata: (0, helpers_1.isSet)(object.metadata) ? String(object.metadata) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || helpers_1.Long.UZERO).toString());
        message.voter !== undefined && (obj.voter = message.voter);
        message.option !== undefined && (obj.option = (0, gov_1.voteOptionToJSON)(message.option));
        message.metadata !== undefined && (obj.metadata = message.metadata);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgVote();
        message.proposalId =
            object.proposalId !== undefined && object.proposalId !== null
                ? helpers_1.Long.fromValue(object.proposalId)
                : helpers_1.Long.UZERO;
        message.voter = object.voter ?? "";
        message.option = object.option ?? 0;
        message.metadata = object.metadata ?? "";
        return message;
    },
};
function createBaseMsgVoteResponse() {
    return {};
}
exports.MsgVoteResponse = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgVoteResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgVoteResponse();
        return message;
    },
};
function createBaseMsgVoteWeighted() {
    return {
        proposalId: helpers_1.Long.UZERO,
        voter: "",
        options: [],
        metadata: "",
    };
}
exports.MsgVoteWeighted = {
    encode(message, writer = _m0.Writer.create()) {
        if (!message.proposalId.isZero()) {
            writer.uint32(8).uint64(message.proposalId);
        }
        if (message.voter !== "") {
            writer.uint32(18).string(message.voter);
        }
        for (const v of message.options) {
            gov_1.WeightedVoteOption.encode(v, writer.uint32(26).fork()).ldelim();
        }
        if (message.metadata !== "") {
            writer.uint32(34).string(message.metadata);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgVoteWeighted();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.voter = reader.string();
                    break;
                case 3:
                    message.options.push(gov_1.WeightedVoteOption.decode(reader, reader.uint32()));
                    break;
                case 4:
                    message.metadata = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            proposalId: (0, helpers_1.isSet)(object.proposalId) ? helpers_1.Long.fromValue(object.proposalId) : helpers_1.Long.UZERO,
            voter: (0, helpers_1.isSet)(object.voter) ? String(object.voter) : "",
            options: Array.isArray(object?.options)
                ? object.options.map((e) => gov_1.WeightedVoteOption.fromJSON(e))
                : [],
            metadata: (0, helpers_1.isSet)(object.metadata) ? String(object.metadata) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || helpers_1.Long.UZERO).toString());
        message.voter !== undefined && (obj.voter = message.voter);
        if (message.options) {
            obj.options = message.options.map((e) => (e ? gov_1.WeightedVoteOption.toJSON(e) : undefined));
        }
        else {
            obj.options = [];
        }
        message.metadata !== undefined && (obj.metadata = message.metadata);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgVoteWeighted();
        message.proposalId =
            object.proposalId !== undefined && object.proposalId !== null
                ? helpers_1.Long.fromValue(object.proposalId)
                : helpers_1.Long.UZERO;
        message.voter = object.voter ?? "";
        message.options = object.options?.map((e) => gov_1.WeightedVoteOption.fromPartial(e)) || [];
        message.metadata = object.metadata ?? "";
        return message;
    },
};
function createBaseMsgVoteWeightedResponse() {
    return {};
}
exports.MsgVoteWeightedResponse = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgVoteWeightedResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgVoteWeightedResponse();
        return message;
    },
};
function createBaseMsgDeposit() {
    return {
        proposalId: helpers_1.Long.UZERO,
        depositor: "",
        amount: [],
    };
}
exports.MsgDeposit = {
    encode(message, writer = _m0.Writer.create()) {
        if (!message.proposalId.isZero()) {
            writer.uint32(8).uint64(message.proposalId);
        }
        if (message.depositor !== "") {
            writer.uint32(18).string(message.depositor);
        }
        for (const v of message.amount) {
            coin_1.Coin.encode(v, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgDeposit();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.depositor = reader.string();
                    break;
                case 3:
                    message.amount.push(coin_1.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            proposalId: (0, helpers_1.isSet)(object.proposalId) ? helpers_1.Long.fromValue(object.proposalId) : helpers_1.Long.UZERO,
            depositor: (0, helpers_1.isSet)(object.depositor) ? String(object.depositor) : "",
            amount: Array.isArray(object?.amount) ? object.amount.map((e) => coin_1.Coin.fromJSON(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || helpers_1.Long.UZERO).toString());
        message.depositor !== undefined && (obj.depositor = message.depositor);
        if (message.amount) {
            obj.amount = message.amount.map((e) => (e ? coin_1.Coin.toJSON(e) : undefined));
        }
        else {
            obj.amount = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgDeposit();
        message.proposalId =
            object.proposalId !== undefined && object.proposalId !== null
                ? helpers_1.Long.fromValue(object.proposalId)
                : helpers_1.Long.UZERO;
        message.depositor = object.depositor ?? "";
        message.amount = object.amount?.map((e) => coin_1.Coin.fromPartial(e)) || [];
        return message;
    },
};
function createBaseMsgDepositResponse() {
    return {};
}
exports.MsgDepositResponse = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgDepositResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgDepositResponse();
        return message;
    },
};
function createBaseMsgUpdateParams() {
    return {
        authority: "",
        params: undefined,
    };
}
exports.MsgUpdateParams = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.authority !== "") {
            writer.uint32(10).string(message.authority);
        }
        if (message.params !== undefined) {
            gov_1.Params.encode(message.params, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgUpdateParams();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.authority = reader.string();
                    break;
                case 2:
                    message.params = gov_1.Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            authority: (0, helpers_1.isSet)(object.authority) ? String(object.authority) : "",
            params: (0, helpers_1.isSet)(object.params) ? gov_1.Params.fromJSON(object.params) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.authority !== undefined && (obj.authority = message.authority);
        message.params !== undefined && (obj.params = message.params ? gov_1.Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgUpdateParams();
        message.authority = object.authority ?? "";
        message.params =
            object.params !== undefined && object.params !== null ? gov_1.Params.fromPartial(object.params) : undefined;
        return message;
    },
};
function createBaseMsgUpdateParamsResponse() {
    return {};
}
exports.MsgUpdateParamsResponse = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgUpdateParamsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgUpdateParamsResponse();
        return message;
    },
};
class MsgClientImpl {
    constructor(rpc) {
        this.rpc = rpc;
        this.SubmitProposal = this.SubmitProposal.bind(this);
        this.ExecLegacyContent = this.ExecLegacyContent.bind(this);
        this.Vote = this.Vote.bind(this);
        this.VoteWeighted = this.VoteWeighted.bind(this);
        this.Deposit = this.Deposit.bind(this);
        this.UpdateParams = this.UpdateParams.bind(this);
    }
    SubmitProposal(request) {
        const data = exports.MsgSubmitProposal.encode(request).finish();
        const promise = this.rpc.request("cosmos.gov.v1.Msg", "SubmitProposal", data);
        return promise.then((data) => exports.MsgSubmitProposalResponse.decode(new _m0.Reader(data)));
    }
    ExecLegacyContent(request) {
        const data = exports.MsgExecLegacyContent.encode(request).finish();
        const promise = this.rpc.request("cosmos.gov.v1.Msg", "ExecLegacyContent", data);
        return promise.then((data) => exports.MsgExecLegacyContentResponse.decode(new _m0.Reader(data)));
    }
    Vote(request) {
        const data = exports.MsgVote.encode(request).finish();
        const promise = this.rpc.request("cosmos.gov.v1.Msg", "Vote", data);
        return promise.then((data) => exports.MsgVoteResponse.decode(new _m0.Reader(data)));
    }
    VoteWeighted(request) {
        const data = exports.MsgVoteWeighted.encode(request).finish();
        const promise = this.rpc.request("cosmos.gov.v1.Msg", "VoteWeighted", data);
        return promise.then((data) => exports.MsgVoteWeightedResponse.decode(new _m0.Reader(data)));
    }
    Deposit(request) {
        const data = exports.MsgDeposit.encode(request).finish();
        const promise = this.rpc.request("cosmos.gov.v1.Msg", "Deposit", data);
        return promise.then((data) => exports.MsgDepositResponse.decode(new _m0.Reader(data)));
    }
    UpdateParams(request) {
        const data = exports.MsgUpdateParams.encode(request).finish();
        const promise = this.rpc.request("cosmos.gov.v1.Msg", "UpdateParams", data);
        return promise.then((data) => exports.MsgUpdateParamsResponse.decode(new _m0.Reader(data)));
    }
}
exports.MsgClientImpl = MsgClientImpl;
//# sourceMappingURL=tx.js.map

/***/ }),

/***/ 48615:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.TallyParams = exports.VotingParams = exports.DepositParams = exports.Vote = exports.TallyResult = exports.Proposal = exports.Deposit = exports.TextProposal = exports.WeightedVoteOption = exports.proposalStatusToJSON = exports.proposalStatusFromJSON = exports.ProposalStatus = exports.voteOptionToJSON = exports.voteOptionFromJSON = exports.VoteOption = exports.protobufPackage = void 0;
/* eslint-disable */
const coin_1 = __webpack_require__(81637);
const any_1 = __webpack_require__(75654);
const timestamp_1 = __webpack_require__(70147);
const duration_1 = __webpack_require__(9591);
const helpers_1 = __webpack_require__(92654);
const _m0 = __importStar(__webpack_require__(62100));
exports.protobufPackage = "cosmos.gov.v1beta1";
/** VoteOption enumerates the valid vote options for a given governance proposal. */
var VoteOption;
(function (VoteOption) {
    /** VOTE_OPTION_UNSPECIFIED - VOTE_OPTION_UNSPECIFIED defines a no-op vote option. */
    VoteOption[VoteOption["VOTE_OPTION_UNSPECIFIED"] = 0] = "VOTE_OPTION_UNSPECIFIED";
    /** VOTE_OPTION_YES - VOTE_OPTION_YES defines a yes vote option. */
    VoteOption[VoteOption["VOTE_OPTION_YES"] = 1] = "VOTE_OPTION_YES";
    /** VOTE_OPTION_ABSTAIN - VOTE_OPTION_ABSTAIN defines an abstain vote option. */
    VoteOption[VoteOption["VOTE_OPTION_ABSTAIN"] = 2] = "VOTE_OPTION_ABSTAIN";
    /** VOTE_OPTION_NO - VOTE_OPTION_NO defines a no vote option. */
    VoteOption[VoteOption["VOTE_OPTION_NO"] = 3] = "VOTE_OPTION_NO";
    /** VOTE_OPTION_NO_WITH_VETO - VOTE_OPTION_NO_WITH_VETO defines a no with veto vote option. */
    VoteOption[VoteOption["VOTE_OPTION_NO_WITH_VETO"] = 4] = "VOTE_OPTION_NO_WITH_VETO";
    VoteOption[VoteOption["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(VoteOption = exports.VoteOption || (exports.VoteOption = {}));
function voteOptionFromJSON(object) {
    switch (object) {
        case 0:
        case "VOTE_OPTION_UNSPECIFIED":
            return VoteOption.VOTE_OPTION_UNSPECIFIED;
        case 1:
        case "VOTE_OPTION_YES":
            return VoteOption.VOTE_OPTION_YES;
        case 2:
        case "VOTE_OPTION_ABSTAIN":
            return VoteOption.VOTE_OPTION_ABSTAIN;
        case 3:
        case "VOTE_OPTION_NO":
            return VoteOption.VOTE_OPTION_NO;
        case 4:
        case "VOTE_OPTION_NO_WITH_VETO":
            return VoteOption.VOTE_OPTION_NO_WITH_VETO;
        case -1:
        case "UNRECOGNIZED":
        default:
            return VoteOption.UNRECOGNIZED;
    }
}
exports.voteOptionFromJSON = voteOptionFromJSON;
function voteOptionToJSON(object) {
    switch (object) {
        case VoteOption.VOTE_OPTION_UNSPECIFIED:
            return "VOTE_OPTION_UNSPECIFIED";
        case VoteOption.VOTE_OPTION_YES:
            return "VOTE_OPTION_YES";
        case VoteOption.VOTE_OPTION_ABSTAIN:
            return "VOTE_OPTION_ABSTAIN";
        case VoteOption.VOTE_OPTION_NO:
            return "VOTE_OPTION_NO";
        case VoteOption.VOTE_OPTION_NO_WITH_VETO:
            return "VOTE_OPTION_NO_WITH_VETO";
        case VoteOption.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.voteOptionToJSON = voteOptionToJSON;
/** ProposalStatus enumerates the valid statuses of a proposal. */
var ProposalStatus;
(function (ProposalStatus) {
    /** PROPOSAL_STATUS_UNSPECIFIED - PROPOSAL_STATUS_UNSPECIFIED defines the default proposal status. */
    ProposalStatus[ProposalStatus["PROPOSAL_STATUS_UNSPECIFIED"] = 0] = "PROPOSAL_STATUS_UNSPECIFIED";
    /**
     * PROPOSAL_STATUS_DEPOSIT_PERIOD - PROPOSAL_STATUS_DEPOSIT_PERIOD defines a proposal status during the deposit
     * period.
     */
    ProposalStatus[ProposalStatus["PROPOSAL_STATUS_DEPOSIT_PERIOD"] = 1] = "PROPOSAL_STATUS_DEPOSIT_PERIOD";
    /**
     * PROPOSAL_STATUS_VOTING_PERIOD - PROPOSAL_STATUS_VOTING_PERIOD defines a proposal status during the voting
     * period.
     */
    ProposalStatus[ProposalStatus["PROPOSAL_STATUS_VOTING_PERIOD"] = 2] = "PROPOSAL_STATUS_VOTING_PERIOD";
    /**
     * PROPOSAL_STATUS_PASSED - PROPOSAL_STATUS_PASSED defines a proposal status of a proposal that has
     * passed.
     */
    ProposalStatus[ProposalStatus["PROPOSAL_STATUS_PASSED"] = 3] = "PROPOSAL_STATUS_PASSED";
    /**
     * PROPOSAL_STATUS_REJECTED - PROPOSAL_STATUS_REJECTED defines a proposal status of a proposal that has
     * been rejected.
     */
    ProposalStatus[ProposalStatus["PROPOSAL_STATUS_REJECTED"] = 4] = "PROPOSAL_STATUS_REJECTED";
    /**
     * PROPOSAL_STATUS_FAILED - PROPOSAL_STATUS_FAILED defines a proposal status of a proposal that has
     * failed.
     */
    ProposalStatus[ProposalStatus["PROPOSAL_STATUS_FAILED"] = 5] = "PROPOSAL_STATUS_FAILED";
    ProposalStatus[ProposalStatus["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(ProposalStatus = exports.ProposalStatus || (exports.ProposalStatus = {}));
function proposalStatusFromJSON(object) {
    switch (object) {
        case 0:
        case "PROPOSAL_STATUS_UNSPECIFIED":
            return ProposalStatus.PROPOSAL_STATUS_UNSPECIFIED;
        case 1:
        case "PROPOSAL_STATUS_DEPOSIT_PERIOD":
            return ProposalStatus.PROPOSAL_STATUS_DEPOSIT_PERIOD;
        case 2:
        case "PROPOSAL_STATUS_VOTING_PERIOD":
            return ProposalStatus.PROPOSAL_STATUS_VOTING_PERIOD;
        case 3:
        case "PROPOSAL_STATUS_PASSED":
            return ProposalStatus.PROPOSAL_STATUS_PASSED;
        case 4:
        case "PROPOSAL_STATUS_REJECTED":
            return ProposalStatus.PROPOSAL_STATUS_REJECTED;
        case 5:
        case "PROPOSAL_STATUS_FAILED":
            return ProposalStatus.PROPOSAL_STATUS_FAILED;
        case -1:
        case "UNRECOGNIZED":
        default:
            return ProposalStatus.UNRECOGNIZED;
    }
}
exports.proposalStatusFromJSON = proposalStatusFromJSON;
function proposalStatusToJSON(object) {
    switch (object) {
        case ProposalStatus.PROPOSAL_STATUS_UNSPECIFIED:
            return "PROPOSAL_STATUS_UNSPECIFIED";
        case ProposalStatus.PROPOSAL_STATUS_DEPOSIT_PERIOD:
            return "PROPOSAL_STATUS_DEPOSIT_PERIOD";
        case ProposalStatus.PROPOSAL_STATUS_VOTING_PERIOD:
            return "PROPOSAL_STATUS_VOTING_PERIOD";
        case ProposalStatus.PROPOSAL_STATUS_PASSED:
            return "PROPOSAL_STATUS_PASSED";
        case ProposalStatus.PROPOSAL_STATUS_REJECTED:
            return "PROPOSAL_STATUS_REJECTED";
        case ProposalStatus.PROPOSAL_STATUS_FAILED:
            return "PROPOSAL_STATUS_FAILED";
        case ProposalStatus.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.proposalStatusToJSON = proposalStatusToJSON;
function createBaseWeightedVoteOption() {
    return {
        option: 0,
        weight: "",
    };
}
exports.WeightedVoteOption = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.option !== 0) {
            writer.uint32(8).int32(message.option);
        }
        if (message.weight !== "") {
            writer.uint32(18).string(message.weight);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseWeightedVoteOption();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.option = reader.int32();
                    break;
                case 2:
                    message.weight = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            option: (0, helpers_1.isSet)(object.option) ? voteOptionFromJSON(object.option) : 0,
            weight: (0, helpers_1.isSet)(object.weight) ? String(object.weight) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.option !== undefined && (obj.option = voteOptionToJSON(message.option));
        message.weight !== undefined && (obj.weight = message.weight);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseWeightedVoteOption();
        message.option = object.option ?? 0;
        message.weight = object.weight ?? "";
        return message;
    },
};
function createBaseTextProposal() {
    return {
        title: "",
        description: "",
    };
}
exports.TextProposal = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.title !== "") {
            writer.uint32(10).string(message.title);
        }
        if (message.description !== "") {
            writer.uint32(18).string(message.description);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTextProposal();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.title = reader.string();
                    break;
                case 2:
                    message.description = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            title: (0, helpers_1.isSet)(object.title) ? String(object.title) : "",
            description: (0, helpers_1.isSet)(object.description) ? String(object.description) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.title !== undefined && (obj.title = message.title);
        message.description !== undefined && (obj.description = message.description);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseTextProposal();
        message.title = object.title ?? "";
        message.description = object.description ?? "";
        return message;
    },
};
function createBaseDeposit() {
    return {
        proposalId: helpers_1.Long.UZERO,
        depositor: "",
        amount: [],
    };
}
exports.Deposit = {
    encode(message, writer = _m0.Writer.create()) {
        if (!message.proposalId.isZero()) {
            writer.uint32(8).uint64(message.proposalId);
        }
        if (message.depositor !== "") {
            writer.uint32(18).string(message.depositor);
        }
        for (const v of message.amount) {
            coin_1.Coin.encode(v, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDeposit();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.depositor = reader.string();
                    break;
                case 3:
                    message.amount.push(coin_1.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            proposalId: (0, helpers_1.isSet)(object.proposalId) ? helpers_1.Long.fromValue(object.proposalId) : helpers_1.Long.UZERO,
            depositor: (0, helpers_1.isSet)(object.depositor) ? String(object.depositor) : "",
            amount: Array.isArray(object?.amount) ? object.amount.map((e) => coin_1.Coin.fromJSON(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || helpers_1.Long.UZERO).toString());
        message.depositor !== undefined && (obj.depositor = message.depositor);
        if (message.amount) {
            obj.amount = message.amount.map((e) => (e ? coin_1.Coin.toJSON(e) : undefined));
        }
        else {
            obj.amount = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseDeposit();
        message.proposalId =
            object.proposalId !== undefined && object.proposalId !== null
                ? helpers_1.Long.fromValue(object.proposalId)
                : helpers_1.Long.UZERO;
        message.depositor = object.depositor ?? "";
        message.amount = object.amount?.map((e) => coin_1.Coin.fromPartial(e)) || [];
        return message;
    },
};
function createBaseProposal() {
    return {
        proposalId: helpers_1.Long.UZERO,
        content: undefined,
        status: 0,
        finalTallyResult: undefined,
        submitTime: undefined,
        depositEndTime: undefined,
        totalDeposit: [],
        votingStartTime: undefined,
        votingEndTime: undefined,
    };
}
exports.Proposal = {
    encode(message, writer = _m0.Writer.create()) {
        if (!message.proposalId.isZero()) {
            writer.uint32(8).uint64(message.proposalId);
        }
        if (message.content !== undefined) {
            any_1.Any.encode(message.content, writer.uint32(18).fork()).ldelim();
        }
        if (message.status !== 0) {
            writer.uint32(24).int32(message.status);
        }
        if (message.finalTallyResult !== undefined) {
            exports.TallyResult.encode(message.finalTallyResult, writer.uint32(34).fork()).ldelim();
        }
        if (message.submitTime !== undefined) {
            timestamp_1.Timestamp.encode(message.submitTime, writer.uint32(42).fork()).ldelim();
        }
        if (message.depositEndTime !== undefined) {
            timestamp_1.Timestamp.encode(message.depositEndTime, writer.uint32(50).fork()).ldelim();
        }
        for (const v of message.totalDeposit) {
            coin_1.Coin.encode(v, writer.uint32(58).fork()).ldelim();
        }
        if (message.votingStartTime !== undefined) {
            timestamp_1.Timestamp.encode(message.votingStartTime, writer.uint32(66).fork()).ldelim();
        }
        if (message.votingEndTime !== undefined) {
            timestamp_1.Timestamp.encode(message.votingEndTime, writer.uint32(74).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseProposal();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.content = any_1.Any.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.status = reader.int32();
                    break;
                case 4:
                    message.finalTallyResult = exports.TallyResult.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.submitTime = timestamp_1.Timestamp.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.depositEndTime = timestamp_1.Timestamp.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.totalDeposit.push(coin_1.Coin.decode(reader, reader.uint32()));
                    break;
                case 8:
                    message.votingStartTime = timestamp_1.Timestamp.decode(reader, reader.uint32());
                    break;
                case 9:
                    message.votingEndTime = timestamp_1.Timestamp.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            proposalId: (0, helpers_1.isSet)(object.proposalId) ? helpers_1.Long.fromValue(object.proposalId) : helpers_1.Long.UZERO,
            content: (0, helpers_1.isSet)(object.content) ? any_1.Any.fromJSON(object.content) : undefined,
            status: (0, helpers_1.isSet)(object.status) ? proposalStatusFromJSON(object.status) : 0,
            finalTallyResult: (0, helpers_1.isSet)(object.finalTallyResult)
                ? exports.TallyResult.fromJSON(object.finalTallyResult)
                : undefined,
            submitTime: (0, helpers_1.isSet)(object.submitTime) ? (0, helpers_1.fromJsonTimestamp)(object.submitTime) : undefined,
            depositEndTime: (0, helpers_1.isSet)(object.depositEndTime) ? (0, helpers_1.fromJsonTimestamp)(object.depositEndTime) : undefined,
            totalDeposit: Array.isArray(object?.totalDeposit)
                ? object.totalDeposit.map((e) => coin_1.Coin.fromJSON(e))
                : [],
            votingStartTime: (0, helpers_1.isSet)(object.votingStartTime) ? (0, helpers_1.fromJsonTimestamp)(object.votingStartTime) : undefined,
            votingEndTime: (0, helpers_1.isSet)(object.votingEndTime) ? (0, helpers_1.fromJsonTimestamp)(object.votingEndTime) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || helpers_1.Long.UZERO).toString());
        message.content !== undefined &&
            (obj.content = message.content ? any_1.Any.toJSON(message.content) : undefined);
        message.status !== undefined && (obj.status = proposalStatusToJSON(message.status));
        message.finalTallyResult !== undefined &&
            (obj.finalTallyResult = message.finalTallyResult
                ? exports.TallyResult.toJSON(message.finalTallyResult)
                : undefined);
        message.submitTime !== undefined && (obj.submitTime = (0, helpers_1.fromTimestamp)(message.submitTime).toISOString());
        message.depositEndTime !== undefined &&
            (obj.depositEndTime = (0, helpers_1.fromTimestamp)(message.depositEndTime).toISOString());
        if (message.totalDeposit) {
            obj.totalDeposit = message.totalDeposit.map((e) => (e ? coin_1.Coin.toJSON(e) : undefined));
        }
        else {
            obj.totalDeposit = [];
        }
        message.votingStartTime !== undefined &&
            (obj.votingStartTime = (0, helpers_1.fromTimestamp)(message.votingStartTime).toISOString());
        message.votingEndTime !== undefined &&
            (obj.votingEndTime = (0, helpers_1.fromTimestamp)(message.votingEndTime).toISOString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseProposal();
        message.proposalId =
            object.proposalId !== undefined && object.proposalId !== null
                ? helpers_1.Long.fromValue(object.proposalId)
                : helpers_1.Long.UZERO;
        message.content =
            object.content !== undefined && object.content !== null ? any_1.Any.fromPartial(object.content) : undefined;
        message.status = object.status ?? 0;
        message.finalTallyResult =
            object.finalTallyResult !== undefined && object.finalTallyResult !== null
                ? exports.TallyResult.fromPartial(object.finalTallyResult)
                : undefined;
        message.submitTime =
            object.submitTime !== undefined && object.submitTime !== null
                ? timestamp_1.Timestamp.fromPartial(object.submitTime)
                : undefined;
        message.depositEndTime =
            object.depositEndTime !== undefined && object.depositEndTime !== null
                ? timestamp_1.Timestamp.fromPartial(object.depositEndTime)
                : undefined;
        message.totalDeposit = object.totalDeposit?.map((e) => coin_1.Coin.fromPartial(e)) || [];
        message.votingStartTime =
            object.votingStartTime !== undefined && object.votingStartTime !== null
                ? timestamp_1.Timestamp.fromPartial(object.votingStartTime)
                : undefined;
        message.votingEndTime =
            object.votingEndTime !== undefined && object.votingEndTime !== null
                ? timestamp_1.Timestamp.fromPartial(object.votingEndTime)
                : undefined;
        return message;
    },
};
function createBaseTallyResult() {
    return {
        yes: "",
        abstain: "",
        no: "",
        noWithVeto: "",
    };
}
exports.TallyResult = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.yes !== "") {
            writer.uint32(10).string(message.yes);
        }
        if (message.abstain !== "") {
            writer.uint32(18).string(message.abstain);
        }
        if (message.no !== "") {
            writer.uint32(26).string(message.no);
        }
        if (message.noWithVeto !== "") {
            writer.uint32(34).string(message.noWithVeto);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTallyResult();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.yes = reader.string();
                    break;
                case 2:
                    message.abstain = reader.string();
                    break;
                case 3:
                    message.no = reader.string();
                    break;
                case 4:
                    message.noWithVeto = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            yes: (0, helpers_1.isSet)(object.yes) ? String(object.yes) : "",
            abstain: (0, helpers_1.isSet)(object.abstain) ? String(object.abstain) : "",
            no: (0, helpers_1.isSet)(object.no) ? String(object.no) : "",
            noWithVeto: (0, helpers_1.isSet)(object.noWithVeto) ? String(object.noWithVeto) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.yes !== undefined && (obj.yes = message.yes);
        message.abstain !== undefined && (obj.abstain = message.abstain);
        message.no !== undefined && (obj.no = message.no);
        message.noWithVeto !== undefined && (obj.noWithVeto = message.noWithVeto);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseTallyResult();
        message.yes = object.yes ?? "";
        message.abstain = object.abstain ?? "";
        message.no = object.no ?? "";
        message.noWithVeto = object.noWithVeto ?? "";
        return message;
    },
};
function createBaseVote() {
    return {
        proposalId: helpers_1.Long.UZERO,
        voter: "",
        option: 0,
        options: [],
    };
}
exports.Vote = {
    encode(message, writer = _m0.Writer.create()) {
        if (!message.proposalId.isZero()) {
            writer.uint32(8).uint64(message.proposalId);
        }
        if (message.voter !== "") {
            writer.uint32(18).string(message.voter);
        }
        if (message.option !== 0) {
            writer.uint32(24).int32(message.option);
        }
        for (const v of message.options) {
            exports.WeightedVoteOption.encode(v, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVote();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.voter = reader.string();
                    break;
                case 3:
                    message.option = reader.int32();
                    break;
                case 4:
                    message.options.push(exports.WeightedVoteOption.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            proposalId: (0, helpers_1.isSet)(object.proposalId) ? helpers_1.Long.fromValue(object.proposalId) : helpers_1.Long.UZERO,
            voter: (0, helpers_1.isSet)(object.voter) ? String(object.voter) : "",
            option: (0, helpers_1.isSet)(object.option) ? voteOptionFromJSON(object.option) : 0,
            options: Array.isArray(object?.options)
                ? object.options.map((e) => exports.WeightedVoteOption.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || helpers_1.Long.UZERO).toString());
        message.voter !== undefined && (obj.voter = message.voter);
        message.option !== undefined && (obj.option = voteOptionToJSON(message.option));
        if (message.options) {
            obj.options = message.options.map((e) => (e ? exports.WeightedVoteOption.toJSON(e) : undefined));
        }
        else {
            obj.options = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseVote();
        message.proposalId =
            object.proposalId !== undefined && object.proposalId !== null
                ? helpers_1.Long.fromValue(object.proposalId)
                : helpers_1.Long.UZERO;
        message.voter = object.voter ?? "";
        message.option = object.option ?? 0;
        message.options = object.options?.map((e) => exports.WeightedVoteOption.fromPartial(e)) || [];
        return message;
    },
};
function createBaseDepositParams() {
    return {
        minDeposit: [],
        maxDepositPeriod: undefined,
    };
}
exports.DepositParams = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.minDeposit) {
            coin_1.Coin.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.maxDepositPeriod !== undefined) {
            duration_1.Duration.encode(message.maxDepositPeriod, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDepositParams();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.minDeposit.push(coin_1.Coin.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.maxDepositPeriod = duration_1.Duration.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            minDeposit: Array.isArray(object?.minDeposit)
                ? object.minDeposit.map((e) => coin_1.Coin.fromJSON(e))
                : [],
            maxDepositPeriod: (0, helpers_1.isSet)(object.maxDepositPeriod)
                ? duration_1.Duration.fromJSON(object.maxDepositPeriod)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.minDeposit) {
            obj.minDeposit = message.minDeposit.map((e) => (e ? coin_1.Coin.toJSON(e) : undefined));
        }
        else {
            obj.minDeposit = [];
        }
        message.maxDepositPeriod !== undefined &&
            (obj.maxDepositPeriod = message.maxDepositPeriod
                ? duration_1.Duration.toJSON(message.maxDepositPeriod)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseDepositParams();
        message.minDeposit = object.minDeposit?.map((e) => coin_1.Coin.fromPartial(e)) || [];
        message.maxDepositPeriod =
            object.maxDepositPeriod !== undefined && object.maxDepositPeriod !== null
                ? duration_1.Duration.fromPartial(object.maxDepositPeriod)
                : undefined;
        return message;
    },
};
function createBaseVotingParams() {
    return {
        votingPeriod: undefined,
    };
}
exports.VotingParams = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.votingPeriod !== undefined) {
            duration_1.Duration.encode(message.votingPeriod, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVotingParams();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.votingPeriod = duration_1.Duration.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            votingPeriod: (0, helpers_1.isSet)(object.votingPeriod) ? duration_1.Duration.fromJSON(object.votingPeriod) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.votingPeriod !== undefined &&
            (obj.votingPeriod = message.votingPeriod ? duration_1.Duration.toJSON(message.votingPeriod) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseVotingParams();
        message.votingPeriod =
            object.votingPeriod !== undefined && object.votingPeriod !== null
                ? duration_1.Duration.fromPartial(object.votingPeriod)
                : undefined;
        return message;
    },
};
function createBaseTallyParams() {
    return {
        quorum: new Uint8Array(),
        threshold: new Uint8Array(),
        vetoThreshold: new Uint8Array(),
    };
}
exports.TallyParams = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.quorum.length !== 0) {
            writer.uint32(10).bytes(message.quorum);
        }
        if (message.threshold.length !== 0) {
            writer.uint32(18).bytes(message.threshold);
        }
        if (message.vetoThreshold.length !== 0) {
            writer.uint32(26).bytes(message.vetoThreshold);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTallyParams();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.quorum = reader.bytes();
                    break;
                case 2:
                    message.threshold = reader.bytes();
                    break;
                case 3:
                    message.vetoThreshold = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            quorum: (0, helpers_1.isSet)(object.quorum) ? (0, helpers_1.bytesFromBase64)(object.quorum) : new Uint8Array(),
            threshold: (0, helpers_1.isSet)(object.threshold) ? (0, helpers_1.bytesFromBase64)(object.threshold) : new Uint8Array(),
            vetoThreshold: (0, helpers_1.isSet)(object.vetoThreshold) ? (0, helpers_1.bytesFromBase64)(object.vetoThreshold) : new Uint8Array(),
        };
    },
    toJSON(message) {
        const obj = {};
        message.quorum !== undefined &&
            (obj.quorum = (0, helpers_1.base64FromBytes)(message.quorum !== undefined ? message.quorum : new Uint8Array()));
        message.threshold !== undefined &&
            (obj.threshold = (0, helpers_1.base64FromBytes)(message.threshold !== undefined ? message.threshold : new Uint8Array()));
        message.vetoThreshold !== undefined &&
            (obj.vetoThreshold = (0, helpers_1.base64FromBytes)(message.vetoThreshold !== undefined ? message.vetoThreshold : new Uint8Array()));
        return obj;
    },
    fromPartial(object) {
        const message = createBaseTallyParams();
        message.quorum = object.quorum ?? new Uint8Array();
        message.threshold = object.threshold ?? new Uint8Array();
        message.vetoThreshold = object.vetoThreshold ?? new Uint8Array();
        return message;
    },
};
//# sourceMappingURL=gov.js.map

/***/ }),

/***/ 54583:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.QueryClientImpl = exports.QueryTallyResultResponse = exports.QueryTallyResultRequest = exports.QueryDepositsResponse = exports.QueryDepositsRequest = exports.QueryDepositResponse = exports.QueryDepositRequest = exports.QueryParamsResponse = exports.QueryParamsRequest = exports.QueryVotesResponse = exports.QueryVotesRequest = exports.QueryVoteResponse = exports.QueryVoteRequest = exports.QueryProposalsResponse = exports.QueryProposalsRequest = exports.QueryProposalResponse = exports.QueryProposalRequest = exports.protobufPackage = void 0;
/* eslint-disable */
const gov_1 = __webpack_require__(48615);
const pagination_1 = __webpack_require__(84043);
const helpers_1 = __webpack_require__(92654);
const _m0 = __importStar(__webpack_require__(62100));
exports.protobufPackage = "cosmos.gov.v1beta1";
function createBaseQueryProposalRequest() {
    return {
        proposalId: helpers_1.Long.UZERO,
    };
}
exports.QueryProposalRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (!message.proposalId.isZero()) {
            writer.uint32(8).uint64(message.proposalId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryProposalRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            proposalId: (0, helpers_1.isSet)(object.proposalId) ? helpers_1.Long.fromValue(object.proposalId) : helpers_1.Long.UZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || helpers_1.Long.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryProposalRequest();
        message.proposalId =
            object.proposalId !== undefined && object.proposalId !== null
                ? helpers_1.Long.fromValue(object.proposalId)
                : helpers_1.Long.UZERO;
        return message;
    },
};
function createBaseQueryProposalResponse() {
    return {
        proposal: undefined,
    };
}
exports.QueryProposalResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.proposal !== undefined) {
            gov_1.Proposal.encode(message.proposal, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryProposalResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.proposal = gov_1.Proposal.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            proposal: (0, helpers_1.isSet)(object.proposal) ? gov_1.Proposal.fromJSON(object.proposal) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.proposal !== undefined &&
            (obj.proposal = message.proposal ? gov_1.Proposal.toJSON(message.proposal) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryProposalResponse();
        message.proposal =
            object.proposal !== undefined && object.proposal !== null
                ? gov_1.Proposal.fromPartial(object.proposal)
                : undefined;
        return message;
    },
};
function createBaseQueryProposalsRequest() {
    return {
        proposalStatus: 0,
        voter: "",
        depositor: "",
        pagination: undefined,
    };
}
exports.QueryProposalsRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.proposalStatus !== 0) {
            writer.uint32(8).int32(message.proposalStatus);
        }
        if (message.voter !== "") {
            writer.uint32(18).string(message.voter);
        }
        if (message.depositor !== "") {
            writer.uint32(26).string(message.depositor);
        }
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryProposalsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.proposalStatus = reader.int32();
                    break;
                case 2:
                    message.voter = reader.string();
                    break;
                case 3:
                    message.depositor = reader.string();
                    break;
                case 4:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            proposalStatus: (0, helpers_1.isSet)(object.proposalStatus) ? (0, gov_1.proposalStatusFromJSON)(object.proposalStatus) : 0,
            voter: (0, helpers_1.isSet)(object.voter) ? String(object.voter) : "",
            depositor: (0, helpers_1.isSet)(object.depositor) ? String(object.depositor) : "",
            pagination: (0, helpers_1.isSet)(object.pagination) ? pagination_1.PageRequest.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.proposalStatus !== undefined &&
            (obj.proposalStatus = (0, gov_1.proposalStatusToJSON)(message.proposalStatus));
        message.voter !== undefined && (obj.voter = message.voter);
        message.depositor !== undefined && (obj.depositor = message.depositor);
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryProposalsRequest();
        message.proposalStatus = object.proposalStatus ?? 0;
        message.voter = object.voter ?? "";
        message.depositor = object.depositor ?? "";
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryProposalsResponse() {
    return {
        proposals: [],
        pagination: undefined,
    };
}
exports.QueryProposalsResponse = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.proposals) {
            gov_1.Proposal.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryProposalsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.proposals.push(gov_1.Proposal.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            proposals: Array.isArray(object?.proposals)
                ? object.proposals.map((e) => gov_1.Proposal.fromJSON(e))
                : [],
            pagination: (0, helpers_1.isSet)(object.pagination) ? pagination_1.PageResponse.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.proposals) {
            obj.proposals = message.proposals.map((e) => (e ? gov_1.Proposal.toJSON(e) : undefined));
        }
        else {
            obj.proposals = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryProposalsResponse();
        message.proposals = object.proposals?.map((e) => gov_1.Proposal.fromPartial(e)) || [];
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryVoteRequest() {
    return {
        proposalId: helpers_1.Long.UZERO,
        voter: "",
    };
}
exports.QueryVoteRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (!message.proposalId.isZero()) {
            writer.uint32(8).uint64(message.proposalId);
        }
        if (message.voter !== "") {
            writer.uint32(18).string(message.voter);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryVoteRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.voter = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            proposalId: (0, helpers_1.isSet)(object.proposalId) ? helpers_1.Long.fromValue(object.proposalId) : helpers_1.Long.UZERO,
            voter: (0, helpers_1.isSet)(object.voter) ? String(object.voter) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || helpers_1.Long.UZERO).toString());
        message.voter !== undefined && (obj.voter = message.voter);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryVoteRequest();
        message.proposalId =
            object.proposalId !== undefined && object.proposalId !== null
                ? helpers_1.Long.fromValue(object.proposalId)
                : helpers_1.Long.UZERO;
        message.voter = object.voter ?? "";
        return message;
    },
};
function createBaseQueryVoteResponse() {
    return {
        vote: undefined,
    };
}
exports.QueryVoteResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.vote !== undefined) {
            gov_1.Vote.encode(message.vote, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryVoteResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.vote = gov_1.Vote.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            vote: (0, helpers_1.isSet)(object.vote) ? gov_1.Vote.fromJSON(object.vote) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.vote !== undefined && (obj.vote = message.vote ? gov_1.Vote.toJSON(message.vote) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryVoteResponse();
        message.vote =
            object.vote !== undefined && object.vote !== null ? gov_1.Vote.fromPartial(object.vote) : undefined;
        return message;
    },
};
function createBaseQueryVotesRequest() {
    return {
        proposalId: helpers_1.Long.UZERO,
        pagination: undefined,
    };
}
exports.QueryVotesRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (!message.proposalId.isZero()) {
            writer.uint32(8).uint64(message.proposalId);
        }
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryVotesRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            proposalId: (0, helpers_1.isSet)(object.proposalId) ? helpers_1.Long.fromValue(object.proposalId) : helpers_1.Long.UZERO,
            pagination: (0, helpers_1.isSet)(object.pagination) ? pagination_1.PageRequest.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || helpers_1.Long.UZERO).toString());
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryVotesRequest();
        message.proposalId =
            object.proposalId !== undefined && object.proposalId !== null
                ? helpers_1.Long.fromValue(object.proposalId)
                : helpers_1.Long.UZERO;
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryVotesResponse() {
    return {
        votes: [],
        pagination: undefined,
    };
}
exports.QueryVotesResponse = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.votes) {
            gov_1.Vote.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryVotesResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.votes.push(gov_1.Vote.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            votes: Array.isArray(object?.votes) ? object.votes.map((e) => gov_1.Vote.fromJSON(e)) : [],
            pagination: (0, helpers_1.isSet)(object.pagination) ? pagination_1.PageResponse.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.votes) {
            obj.votes = message.votes.map((e) => (e ? gov_1.Vote.toJSON(e) : undefined));
        }
        else {
            obj.votes = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryVotesResponse();
        message.votes = object.votes?.map((e) => gov_1.Vote.fromPartial(e)) || [];
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryParamsRequest() {
    return {
        paramsType: "",
    };
}
exports.QueryParamsRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.paramsType !== "") {
            writer.uint32(10).string(message.paramsType);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryParamsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.paramsType = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            paramsType: (0, helpers_1.isSet)(object.paramsType) ? String(object.paramsType) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.paramsType !== undefined && (obj.paramsType = message.paramsType);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryParamsRequest();
        message.paramsType = object.paramsType ?? "";
        return message;
    },
};
function createBaseQueryParamsResponse() {
    return {
        votingParams: undefined,
        depositParams: undefined,
        tallyParams: undefined,
    };
}
exports.QueryParamsResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.votingParams !== undefined) {
            gov_1.VotingParams.encode(message.votingParams, writer.uint32(10).fork()).ldelim();
        }
        if (message.depositParams !== undefined) {
            gov_1.DepositParams.encode(message.depositParams, writer.uint32(18).fork()).ldelim();
        }
        if (message.tallyParams !== undefined) {
            gov_1.TallyParams.encode(message.tallyParams, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryParamsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.votingParams = gov_1.VotingParams.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.depositParams = gov_1.DepositParams.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.tallyParams = gov_1.TallyParams.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            votingParams: (0, helpers_1.isSet)(object.votingParams) ? gov_1.VotingParams.fromJSON(object.votingParams) : undefined,
            depositParams: (0, helpers_1.isSet)(object.depositParams) ? gov_1.DepositParams.fromJSON(object.depositParams) : undefined,
            tallyParams: (0, helpers_1.isSet)(object.tallyParams) ? gov_1.TallyParams.fromJSON(object.tallyParams) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.votingParams !== undefined &&
            (obj.votingParams = message.votingParams ? gov_1.VotingParams.toJSON(message.votingParams) : undefined);
        message.depositParams !== undefined &&
            (obj.depositParams = message.depositParams ? gov_1.DepositParams.toJSON(message.depositParams) : undefined);
        message.tallyParams !== undefined &&
            (obj.tallyParams = message.tallyParams ? gov_1.TallyParams.toJSON(message.tallyParams) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryParamsResponse();
        message.votingParams =
            object.votingParams !== undefined && object.votingParams !== null
                ? gov_1.VotingParams.fromPartial(object.votingParams)
                : undefined;
        message.depositParams =
            object.depositParams !== undefined && object.depositParams !== null
                ? gov_1.DepositParams.fromPartial(object.depositParams)
                : undefined;
        message.tallyParams =
            object.tallyParams !== undefined && object.tallyParams !== null
                ? gov_1.TallyParams.fromPartial(object.tallyParams)
                : undefined;
        return message;
    },
};
function createBaseQueryDepositRequest() {
    return {
        proposalId: helpers_1.Long.UZERO,
        depositor: "",
    };
}
exports.QueryDepositRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (!message.proposalId.isZero()) {
            writer.uint32(8).uint64(message.proposalId);
        }
        if (message.depositor !== "") {
            writer.uint32(18).string(message.depositor);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryDepositRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.depositor = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            proposalId: (0, helpers_1.isSet)(object.proposalId) ? helpers_1.Long.fromValue(object.proposalId) : helpers_1.Long.UZERO,
            depositor: (0, helpers_1.isSet)(object.depositor) ? String(object.depositor) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || helpers_1.Long.UZERO).toString());
        message.depositor !== undefined && (obj.depositor = message.depositor);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryDepositRequest();
        message.proposalId =
            object.proposalId !== undefined && object.proposalId !== null
                ? helpers_1.Long.fromValue(object.proposalId)
                : helpers_1.Long.UZERO;
        message.depositor = object.depositor ?? "";
        return message;
    },
};
function createBaseQueryDepositResponse() {
    return {
        deposit: undefined,
    };
}
exports.QueryDepositResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.deposit !== undefined) {
            gov_1.Deposit.encode(message.deposit, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryDepositResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.deposit = gov_1.Deposit.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            deposit: (0, helpers_1.isSet)(object.deposit) ? gov_1.Deposit.fromJSON(object.deposit) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.deposit !== undefined &&
            (obj.deposit = message.deposit ? gov_1.Deposit.toJSON(message.deposit) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryDepositResponse();
        message.deposit =
            object.deposit !== undefined && object.deposit !== null
                ? gov_1.Deposit.fromPartial(object.deposit)
                : undefined;
        return message;
    },
};
function createBaseQueryDepositsRequest() {
    return {
        proposalId: helpers_1.Long.UZERO,
        pagination: undefined,
    };
}
exports.QueryDepositsRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (!message.proposalId.isZero()) {
            writer.uint32(8).uint64(message.proposalId);
        }
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryDepositsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            proposalId: (0, helpers_1.isSet)(object.proposalId) ? helpers_1.Long.fromValue(object.proposalId) : helpers_1.Long.UZERO,
            pagination: (0, helpers_1.isSet)(object.pagination) ? pagination_1.PageRequest.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || helpers_1.Long.UZERO).toString());
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryDepositsRequest();
        message.proposalId =
            object.proposalId !== undefined && object.proposalId !== null
                ? helpers_1.Long.fromValue(object.proposalId)
                : helpers_1.Long.UZERO;
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryDepositsResponse() {
    return {
        deposits: [],
        pagination: undefined,
    };
}
exports.QueryDepositsResponse = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.deposits) {
            gov_1.Deposit.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryDepositsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.deposits.push(gov_1.Deposit.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            deposits: Array.isArray(object?.deposits) ? object.deposits.map((e) => gov_1.Deposit.fromJSON(e)) : [],
            pagination: (0, helpers_1.isSet)(object.pagination) ? pagination_1.PageResponse.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.deposits) {
            obj.deposits = message.deposits.map((e) => (e ? gov_1.Deposit.toJSON(e) : undefined));
        }
        else {
            obj.deposits = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryDepositsResponse();
        message.deposits = object.deposits?.map((e) => gov_1.Deposit.fromPartial(e)) || [];
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryTallyResultRequest() {
    return {
        proposalId: helpers_1.Long.UZERO,
    };
}
exports.QueryTallyResultRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (!message.proposalId.isZero()) {
            writer.uint32(8).uint64(message.proposalId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryTallyResultRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            proposalId: (0, helpers_1.isSet)(object.proposalId) ? helpers_1.Long.fromValue(object.proposalId) : helpers_1.Long.UZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || helpers_1.Long.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryTallyResultRequest();
        message.proposalId =
            object.proposalId !== undefined && object.proposalId !== null
                ? helpers_1.Long.fromValue(object.proposalId)
                : helpers_1.Long.UZERO;
        return message;
    },
};
function createBaseQueryTallyResultResponse() {
    return {
        tally: undefined,
    };
}
exports.QueryTallyResultResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.tally !== undefined) {
            gov_1.TallyResult.encode(message.tally, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryTallyResultResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.tally = gov_1.TallyResult.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            tally: (0, helpers_1.isSet)(object.tally) ? gov_1.TallyResult.fromJSON(object.tally) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.tally !== undefined &&
            (obj.tally = message.tally ? gov_1.TallyResult.toJSON(message.tally) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryTallyResultResponse();
        message.tally =
            object.tally !== undefined && object.tally !== null ? gov_1.TallyResult.fromPartial(object.tally) : undefined;
        return message;
    },
};
class QueryClientImpl {
    constructor(rpc) {
        this.rpc = rpc;
        this.Proposal = this.Proposal.bind(this);
        this.Proposals = this.Proposals.bind(this);
        this.Vote = this.Vote.bind(this);
        this.Votes = this.Votes.bind(this);
        this.Params = this.Params.bind(this);
        this.Deposit = this.Deposit.bind(this);
        this.Deposits = this.Deposits.bind(this);
        this.TallyResult = this.TallyResult.bind(this);
    }
    Proposal(request) {
        const data = exports.QueryProposalRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.gov.v1beta1.Query", "Proposal", data);
        return promise.then((data) => exports.QueryProposalResponse.decode(new _m0.Reader(data)));
    }
    Proposals(request) {
        const data = exports.QueryProposalsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.gov.v1beta1.Query", "Proposals", data);
        return promise.then((data) => exports.QueryProposalsResponse.decode(new _m0.Reader(data)));
    }
    Vote(request) {
        const data = exports.QueryVoteRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.gov.v1beta1.Query", "Vote", data);
        return promise.then((data) => exports.QueryVoteResponse.decode(new _m0.Reader(data)));
    }
    Votes(request) {
        const data = exports.QueryVotesRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.gov.v1beta1.Query", "Votes", data);
        return promise.then((data) => exports.QueryVotesResponse.decode(new _m0.Reader(data)));
    }
    Params(request) {
        const data = exports.QueryParamsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.gov.v1beta1.Query", "Params", data);
        return promise.then((data) => exports.QueryParamsResponse.decode(new _m0.Reader(data)));
    }
    Deposit(request) {
        const data = exports.QueryDepositRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.gov.v1beta1.Query", "Deposit", data);
        return promise.then((data) => exports.QueryDepositResponse.decode(new _m0.Reader(data)));
    }
    Deposits(request) {
        const data = exports.QueryDepositsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.gov.v1beta1.Query", "Deposits", data);
        return promise.then((data) => exports.QueryDepositsResponse.decode(new _m0.Reader(data)));
    }
    TallyResult(request) {
        const data = exports.QueryTallyResultRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.gov.v1beta1.Query", "TallyResult", data);
        return promise.then((data) => exports.QueryTallyResultResponse.decode(new _m0.Reader(data)));
    }
}
exports.QueryClientImpl = QueryClientImpl;
//# sourceMappingURL=query.js.map

/***/ }),

/***/ 37429:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MsgClientImpl = exports.MsgDepositResponse = exports.MsgDeposit = exports.MsgVoteWeightedResponse = exports.MsgVoteWeighted = exports.MsgVoteResponse = exports.MsgVote = exports.MsgSubmitProposalResponse = exports.MsgSubmitProposal = exports.protobufPackage = void 0;
/* eslint-disable */
const any_1 = __webpack_require__(75654);
const coin_1 = __webpack_require__(81637);
const gov_1 = __webpack_require__(48615);
const helpers_1 = __webpack_require__(92654);
const _m0 = __importStar(__webpack_require__(62100));
exports.protobufPackage = "cosmos.gov.v1beta1";
function createBaseMsgSubmitProposal() {
    return {
        content: undefined,
        initialDeposit: [],
        proposer: "",
    };
}
exports.MsgSubmitProposal = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.content !== undefined) {
            any_1.Any.encode(message.content, writer.uint32(10).fork()).ldelim();
        }
        for (const v of message.initialDeposit) {
            coin_1.Coin.encode(v, writer.uint32(18).fork()).ldelim();
        }
        if (message.proposer !== "") {
            writer.uint32(26).string(message.proposer);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgSubmitProposal();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.content = any_1.Any.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.initialDeposit.push(coin_1.Coin.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.proposer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            content: (0, helpers_1.isSet)(object.content) ? any_1.Any.fromJSON(object.content) : undefined,
            initialDeposit: Array.isArray(object?.initialDeposit)
                ? object.initialDeposit.map((e) => coin_1.Coin.fromJSON(e))
                : [],
            proposer: (0, helpers_1.isSet)(object.proposer) ? String(object.proposer) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.content !== undefined &&
            (obj.content = message.content ? any_1.Any.toJSON(message.content) : undefined);
        if (message.initialDeposit) {
            obj.initialDeposit = message.initialDeposit.map((e) => (e ? coin_1.Coin.toJSON(e) : undefined));
        }
        else {
            obj.initialDeposit = [];
        }
        message.proposer !== undefined && (obj.proposer = message.proposer);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgSubmitProposal();
        message.content =
            object.content !== undefined && object.content !== null ? any_1.Any.fromPartial(object.content) : undefined;
        message.initialDeposit = object.initialDeposit?.map((e) => coin_1.Coin.fromPartial(e)) || [];
        message.proposer = object.proposer ?? "";
        return message;
    },
};
function createBaseMsgSubmitProposalResponse() {
    return {
        proposalId: helpers_1.Long.UZERO,
    };
}
exports.MsgSubmitProposalResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (!message.proposalId.isZero()) {
            writer.uint32(8).uint64(message.proposalId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgSubmitProposalResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            proposalId: (0, helpers_1.isSet)(object.proposalId) ? helpers_1.Long.fromValue(object.proposalId) : helpers_1.Long.UZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || helpers_1.Long.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgSubmitProposalResponse();
        message.proposalId =
            object.proposalId !== undefined && object.proposalId !== null
                ? helpers_1.Long.fromValue(object.proposalId)
                : helpers_1.Long.UZERO;
        return message;
    },
};
function createBaseMsgVote() {
    return {
        proposalId: helpers_1.Long.UZERO,
        voter: "",
        option: 0,
    };
}
exports.MsgVote = {
    encode(message, writer = _m0.Writer.create()) {
        if (!message.proposalId.isZero()) {
            writer.uint32(8).uint64(message.proposalId);
        }
        if (message.voter !== "") {
            writer.uint32(18).string(message.voter);
        }
        if (message.option !== 0) {
            writer.uint32(24).int32(message.option);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgVote();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.voter = reader.string();
                    break;
                case 3:
                    message.option = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            proposalId: (0, helpers_1.isSet)(object.proposalId) ? helpers_1.Long.fromValue(object.proposalId) : helpers_1.Long.UZERO,
            voter: (0, helpers_1.isSet)(object.voter) ? String(object.voter) : "",
            option: (0, helpers_1.isSet)(object.option) ? (0, gov_1.voteOptionFromJSON)(object.option) : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || helpers_1.Long.UZERO).toString());
        message.voter !== undefined && (obj.voter = message.voter);
        message.option !== undefined && (obj.option = (0, gov_1.voteOptionToJSON)(message.option));
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgVote();
        message.proposalId =
            object.proposalId !== undefined && object.proposalId !== null
                ? helpers_1.Long.fromValue(object.proposalId)
                : helpers_1.Long.UZERO;
        message.voter = object.voter ?? "";
        message.option = object.option ?? 0;
        return message;
    },
};
function createBaseMsgVoteResponse() {
    return {};
}
exports.MsgVoteResponse = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgVoteResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgVoteResponse();
        return message;
    },
};
function createBaseMsgVoteWeighted() {
    return {
        proposalId: helpers_1.Long.UZERO,
        voter: "",
        options: [],
    };
}
exports.MsgVoteWeighted = {
    encode(message, writer = _m0.Writer.create()) {
        if (!message.proposalId.isZero()) {
            writer.uint32(8).uint64(message.proposalId);
        }
        if (message.voter !== "") {
            writer.uint32(18).string(message.voter);
        }
        for (const v of message.options) {
            gov_1.WeightedVoteOption.encode(v, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgVoteWeighted();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.voter = reader.string();
                    break;
                case 3:
                    message.options.push(gov_1.WeightedVoteOption.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            proposalId: (0, helpers_1.isSet)(object.proposalId) ? helpers_1.Long.fromValue(object.proposalId) : helpers_1.Long.UZERO,
            voter: (0, helpers_1.isSet)(object.voter) ? String(object.voter) : "",
            options: Array.isArray(object?.options)
                ? object.options.map((e) => gov_1.WeightedVoteOption.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || helpers_1.Long.UZERO).toString());
        message.voter !== undefined && (obj.voter = message.voter);
        if (message.options) {
            obj.options = message.options.map((e) => (e ? gov_1.WeightedVoteOption.toJSON(e) : undefined));
        }
        else {
            obj.options = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgVoteWeighted();
        message.proposalId =
            object.proposalId !== undefined && object.proposalId !== null
                ? helpers_1.Long.fromValue(object.proposalId)
                : helpers_1.Long.UZERO;
        message.voter = object.voter ?? "";
        message.options = object.options?.map((e) => gov_1.WeightedVoteOption.fromPartial(e)) || [];
        return message;
    },
};
function createBaseMsgVoteWeightedResponse() {
    return {};
}
exports.MsgVoteWeightedResponse = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgVoteWeightedResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgVoteWeightedResponse();
        return message;
    },
};
function createBaseMsgDeposit() {
    return {
        proposalId: helpers_1.Long.UZERO,
        depositor: "",
        amount: [],
    };
}
exports.MsgDeposit = {
    encode(message, writer = _m0.Writer.create()) {
        if (!message.proposalId.isZero()) {
            writer.uint32(8).uint64(message.proposalId);
        }
        if (message.depositor !== "") {
            writer.uint32(18).string(message.depositor);
        }
        for (const v of message.amount) {
            coin_1.Coin.encode(v, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgDeposit();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.depositor = reader.string();
                    break;
                case 3:
                    message.amount.push(coin_1.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            proposalId: (0, helpers_1.isSet)(object.proposalId) ? helpers_1.Long.fromValue(object.proposalId) : helpers_1.Long.UZERO,
            depositor: (0, helpers_1.isSet)(object.depositor) ? String(object.depositor) : "",
            amount: Array.isArray(object?.amount) ? object.amount.map((e) => coin_1.Coin.fromJSON(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || helpers_1.Long.UZERO).toString());
        message.depositor !== undefined && (obj.depositor = message.depositor);
        if (message.amount) {
            obj.amount = message.amount.map((e) => (e ? coin_1.Coin.toJSON(e) : undefined));
        }
        else {
            obj.amount = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgDeposit();
        message.proposalId =
            object.proposalId !== undefined && object.proposalId !== null
                ? helpers_1.Long.fromValue(object.proposalId)
                : helpers_1.Long.UZERO;
        message.depositor = object.depositor ?? "";
        message.amount = object.amount?.map((e) => coin_1.Coin.fromPartial(e)) || [];
        return message;
    },
};
function createBaseMsgDepositResponse() {
    return {};
}
exports.MsgDepositResponse = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgDepositResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgDepositResponse();
        return message;
    },
};
class MsgClientImpl {
    constructor(rpc) {
        this.rpc = rpc;
        this.SubmitProposal = this.SubmitProposal.bind(this);
        this.Vote = this.Vote.bind(this);
        this.VoteWeighted = this.VoteWeighted.bind(this);
        this.Deposit = this.Deposit.bind(this);
    }
    SubmitProposal(request) {
        const data = exports.MsgSubmitProposal.encode(request).finish();
        const promise = this.rpc.request("cosmos.gov.v1beta1.Msg", "SubmitProposal", data);
        return promise.then((data) => exports.MsgSubmitProposalResponse.decode(new _m0.Reader(data)));
    }
    Vote(request) {
        const data = exports.MsgVote.encode(request).finish();
        const promise = this.rpc.request("cosmos.gov.v1beta1.Msg", "Vote", data);
        return promise.then((data) => exports.MsgVoteResponse.decode(new _m0.Reader(data)));
    }
    VoteWeighted(request) {
        const data = exports.MsgVoteWeighted.encode(request).finish();
        const promise = this.rpc.request("cosmos.gov.v1beta1.Msg", "VoteWeighted", data);
        return promise.then((data) => exports.MsgVoteWeightedResponse.decode(new _m0.Reader(data)));
    }
    Deposit(request) {
        const data = exports.MsgDeposit.encode(request).finish();
        const promise = this.rpc.request("cosmos.gov.v1beta1.Msg", "Deposit", data);
        return promise.then((data) => exports.MsgDepositResponse.decode(new _m0.Reader(data)));
    }
}
exports.MsgClientImpl = MsgClientImpl;
//# sourceMappingURL=tx.js.map

/***/ }),

/***/ 80126:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MsgClientImpl = exports.MsgLeaveGroupResponse = exports.MsgLeaveGroup = exports.MsgExecResponse = exports.MsgExec = exports.MsgVoteResponse = exports.MsgVote = exports.MsgWithdrawProposalResponse = exports.MsgWithdrawProposal = exports.MsgSubmitProposalResponse = exports.MsgSubmitProposal = exports.MsgUpdateGroupPolicyMetadataResponse = exports.MsgUpdateGroupPolicyMetadata = exports.MsgUpdateGroupPolicyDecisionPolicyResponse = exports.MsgUpdateGroupPolicyDecisionPolicy = exports.MsgCreateGroupWithPolicyResponse = exports.MsgCreateGroupWithPolicy = exports.MsgUpdateGroupPolicyAdminResponse = exports.MsgUpdateGroupPolicyAdmin = exports.MsgCreateGroupPolicyResponse = exports.MsgCreateGroupPolicy = exports.MsgUpdateGroupMetadataResponse = exports.MsgUpdateGroupMetadata = exports.MsgUpdateGroupAdminResponse = exports.MsgUpdateGroupAdmin = exports.MsgUpdateGroupMembersResponse = exports.MsgUpdateGroupMembers = exports.MsgCreateGroupResponse = exports.MsgCreateGroup = exports.execToJSON = exports.execFromJSON = exports.Exec = exports.protobufPackage = void 0;
/* eslint-disable */
const types_1 = __webpack_require__(32946);
const any_1 = __webpack_require__(75654);
const helpers_1 = __webpack_require__(92654);
const _m0 = __importStar(__webpack_require__(62100));
exports.protobufPackage = "cosmos.group.v1";
/** Exec defines modes of execution of a proposal on creation or on new vote. */
var Exec;
(function (Exec) {
    /**
     * EXEC_UNSPECIFIED - An empty value means that there should be a separate
     * MsgExec request for the proposal to execute.
     */
    Exec[Exec["EXEC_UNSPECIFIED"] = 0] = "EXEC_UNSPECIFIED";
    /**
     * EXEC_TRY - Try to execute the proposal immediately.
     * If the proposal is not allowed per the DecisionPolicy,
     * the proposal will still be open and could
     * be executed at a later point.
     */
    Exec[Exec["EXEC_TRY"] = 1] = "EXEC_TRY";
    Exec[Exec["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(Exec = exports.Exec || (exports.Exec = {}));
function execFromJSON(object) {
    switch (object) {
        case 0:
        case "EXEC_UNSPECIFIED":
            return Exec.EXEC_UNSPECIFIED;
        case 1:
        case "EXEC_TRY":
            return Exec.EXEC_TRY;
        case -1:
        case "UNRECOGNIZED":
        default:
            return Exec.UNRECOGNIZED;
    }
}
exports.execFromJSON = execFromJSON;
function execToJSON(object) {
    switch (object) {
        case Exec.EXEC_UNSPECIFIED:
            return "EXEC_UNSPECIFIED";
        case Exec.EXEC_TRY:
            return "EXEC_TRY";
        case Exec.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.execToJSON = execToJSON;
function createBaseMsgCreateGroup() {
    return {
        admin: "",
        members: [],
        metadata: "",
    };
}
exports.MsgCreateGroup = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.admin !== "") {
            writer.uint32(10).string(message.admin);
        }
        for (const v of message.members) {
            types_1.MemberRequest.encode(v, writer.uint32(18).fork()).ldelim();
        }
        if (message.metadata !== "") {
            writer.uint32(26).string(message.metadata);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgCreateGroup();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.admin = reader.string();
                    break;
                case 2:
                    message.members.push(types_1.MemberRequest.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.metadata = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            admin: (0, helpers_1.isSet)(object.admin) ? String(object.admin) : "",
            members: Array.isArray(object?.members)
                ? object.members.map((e) => types_1.MemberRequest.fromJSON(e))
                : [],
            metadata: (0, helpers_1.isSet)(object.metadata) ? String(object.metadata) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.admin !== undefined && (obj.admin = message.admin);
        if (message.members) {
            obj.members = message.members.map((e) => (e ? types_1.MemberRequest.toJSON(e) : undefined));
        }
        else {
            obj.members = [];
        }
        message.metadata !== undefined && (obj.metadata = message.metadata);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgCreateGroup();
        message.admin = object.admin ?? "";
        message.members = object.members?.map((e) => types_1.MemberRequest.fromPartial(e)) || [];
        message.metadata = object.metadata ?? "";
        return message;
    },
};
function createBaseMsgCreateGroupResponse() {
    return {
        groupId: helpers_1.Long.UZERO,
    };
}
exports.MsgCreateGroupResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (!message.groupId.isZero()) {
            writer.uint32(8).uint64(message.groupId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgCreateGroupResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.groupId = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            groupId: (0, helpers_1.isSet)(object.groupId) ? helpers_1.Long.fromValue(object.groupId) : helpers_1.Long.UZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        message.groupId !== undefined && (obj.groupId = (message.groupId || helpers_1.Long.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgCreateGroupResponse();
        message.groupId =
            object.groupId !== undefined && object.groupId !== null ? helpers_1.Long.fromValue(object.groupId) : helpers_1.Long.UZERO;
        return message;
    },
};
function createBaseMsgUpdateGroupMembers() {
    return {
        admin: "",
        groupId: helpers_1.Long.UZERO,
        memberUpdates: [],
    };
}
exports.MsgUpdateGroupMembers = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.admin !== "") {
            writer.uint32(10).string(message.admin);
        }
        if (!message.groupId.isZero()) {
            writer.uint32(16).uint64(message.groupId);
        }
        for (const v of message.memberUpdates) {
            types_1.MemberRequest.encode(v, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgUpdateGroupMembers();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.admin = reader.string();
                    break;
                case 2:
                    message.groupId = reader.uint64();
                    break;
                case 3:
                    message.memberUpdates.push(types_1.MemberRequest.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            admin: (0, helpers_1.isSet)(object.admin) ? String(object.admin) : "",
            groupId: (0, helpers_1.isSet)(object.groupId) ? helpers_1.Long.fromValue(object.groupId) : helpers_1.Long.UZERO,
            memberUpdates: Array.isArray(object?.memberUpdates)
                ? object.memberUpdates.map((e) => types_1.MemberRequest.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        message.admin !== undefined && (obj.admin = message.admin);
        message.groupId !== undefined && (obj.groupId = (message.groupId || helpers_1.Long.UZERO).toString());
        if (message.memberUpdates) {
            obj.memberUpdates = message.memberUpdates.map((e) => (e ? types_1.MemberRequest.toJSON(e) : undefined));
        }
        else {
            obj.memberUpdates = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgUpdateGroupMembers();
        message.admin = object.admin ?? "";
        message.groupId =
            object.groupId !== undefined && object.groupId !== null ? helpers_1.Long.fromValue(object.groupId) : helpers_1.Long.UZERO;
        message.memberUpdates = object.memberUpdates?.map((e) => types_1.MemberRequest.fromPartial(e)) || [];
        return message;
    },
};
function createBaseMsgUpdateGroupMembersResponse() {
    return {};
}
exports.MsgUpdateGroupMembersResponse = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgUpdateGroupMembersResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgUpdateGroupMembersResponse();
        return message;
    },
};
function createBaseMsgUpdateGroupAdmin() {
    return {
        admin: "",
        groupId: helpers_1.Long.UZERO,
        newAdmin: "",
    };
}
exports.MsgUpdateGroupAdmin = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.admin !== "") {
            writer.uint32(10).string(message.admin);
        }
        if (!message.groupId.isZero()) {
            writer.uint32(16).uint64(message.groupId);
        }
        if (message.newAdmin !== "") {
            writer.uint32(26).string(message.newAdmin);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgUpdateGroupAdmin();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.admin = reader.string();
                    break;
                case 2:
                    message.groupId = reader.uint64();
                    break;
                case 3:
                    message.newAdmin = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            admin: (0, helpers_1.isSet)(object.admin) ? String(object.admin) : "",
            groupId: (0, helpers_1.isSet)(object.groupId) ? helpers_1.Long.fromValue(object.groupId) : helpers_1.Long.UZERO,
            newAdmin: (0, helpers_1.isSet)(object.newAdmin) ? String(object.newAdmin) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.admin !== undefined && (obj.admin = message.admin);
        message.groupId !== undefined && (obj.groupId = (message.groupId || helpers_1.Long.UZERO).toString());
        message.newAdmin !== undefined && (obj.newAdmin = message.newAdmin);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgUpdateGroupAdmin();
        message.admin = object.admin ?? "";
        message.groupId =
            object.groupId !== undefined && object.groupId !== null ? helpers_1.Long.fromValue(object.groupId) : helpers_1.Long.UZERO;
        message.newAdmin = object.newAdmin ?? "";
        return message;
    },
};
function createBaseMsgUpdateGroupAdminResponse() {
    return {};
}
exports.MsgUpdateGroupAdminResponse = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgUpdateGroupAdminResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgUpdateGroupAdminResponse();
        return message;
    },
};
function createBaseMsgUpdateGroupMetadata() {
    return {
        admin: "",
        groupId: helpers_1.Long.UZERO,
        metadata: "",
    };
}
exports.MsgUpdateGroupMetadata = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.admin !== "") {
            writer.uint32(10).string(message.admin);
        }
        if (!message.groupId.isZero()) {
            writer.uint32(16).uint64(message.groupId);
        }
        if (message.metadata !== "") {
            writer.uint32(26).string(message.metadata);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgUpdateGroupMetadata();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.admin = reader.string();
                    break;
                case 2:
                    message.groupId = reader.uint64();
                    break;
                case 3:
                    message.metadata = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            admin: (0, helpers_1.isSet)(object.admin) ? String(object.admin) : "",
            groupId: (0, helpers_1.isSet)(object.groupId) ? helpers_1.Long.fromValue(object.groupId) : helpers_1.Long.UZERO,
            metadata: (0, helpers_1.isSet)(object.metadata) ? String(object.metadata) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.admin !== undefined && (obj.admin = message.admin);
        message.groupId !== undefined && (obj.groupId = (message.groupId || helpers_1.Long.UZERO).toString());
        message.metadata !== undefined && (obj.metadata = message.metadata);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgUpdateGroupMetadata();
        message.admin = object.admin ?? "";
        message.groupId =
            object.groupId !== undefined && object.groupId !== null ? helpers_1.Long.fromValue(object.groupId) : helpers_1.Long.UZERO;
        message.metadata = object.metadata ?? "";
        return message;
    },
};
function createBaseMsgUpdateGroupMetadataResponse() {
    return {};
}
exports.MsgUpdateGroupMetadataResponse = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgUpdateGroupMetadataResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgUpdateGroupMetadataResponse();
        return message;
    },
};
function createBaseMsgCreateGroupPolicy() {
    return {
        admin: "",
        groupId: helpers_1.Long.UZERO,
        metadata: "",
        decisionPolicy: undefined,
    };
}
exports.MsgCreateGroupPolicy = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.admin !== "") {
            writer.uint32(10).string(message.admin);
        }
        if (!message.groupId.isZero()) {
            writer.uint32(16).uint64(message.groupId);
        }
        if (message.metadata !== "") {
            writer.uint32(26).string(message.metadata);
        }
        if (message.decisionPolicy !== undefined) {
            any_1.Any.encode(message.decisionPolicy, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgCreateGroupPolicy();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.admin = reader.string();
                    break;
                case 2:
                    message.groupId = reader.uint64();
                    break;
                case 3:
                    message.metadata = reader.string();
                    break;
                case 4:
                    message.decisionPolicy = any_1.Any.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            admin: (0, helpers_1.isSet)(object.admin) ? String(object.admin) : "",
            groupId: (0, helpers_1.isSet)(object.groupId) ? helpers_1.Long.fromValue(object.groupId) : helpers_1.Long.UZERO,
            metadata: (0, helpers_1.isSet)(object.metadata) ? String(object.metadata) : "",
            decisionPolicy: (0, helpers_1.isSet)(object.decisionPolicy) ? any_1.Any.fromJSON(object.decisionPolicy) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.admin !== undefined && (obj.admin = message.admin);
        message.groupId !== undefined && (obj.groupId = (message.groupId || helpers_1.Long.UZERO).toString());
        message.metadata !== undefined && (obj.metadata = message.metadata);
        message.decisionPolicy !== undefined &&
            (obj.decisionPolicy = message.decisionPolicy ? any_1.Any.toJSON(message.decisionPolicy) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgCreateGroupPolicy();
        message.admin = object.admin ?? "";
        message.groupId =
            object.groupId !== undefined && object.groupId !== null ? helpers_1.Long.fromValue(object.groupId) : helpers_1.Long.UZERO;
        message.metadata = object.metadata ?? "";
        message.decisionPolicy =
            object.decisionPolicy !== undefined && object.decisionPolicy !== null
                ? any_1.Any.fromPartial(object.decisionPolicy)
                : undefined;
        return message;
    },
};
function createBaseMsgCreateGroupPolicyResponse() {
    return {
        address: "",
    };
}
exports.MsgCreateGroupPolicyResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.address !== "") {
            writer.uint32(10).string(message.address);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgCreateGroupPolicyResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.address = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            address: (0, helpers_1.isSet)(object.address) ? String(object.address) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgCreateGroupPolicyResponse();
        message.address = object.address ?? "";
        return message;
    },
};
function createBaseMsgUpdateGroupPolicyAdmin() {
    return {
        admin: "",
        groupPolicyAddress: "",
        newAdmin: "",
    };
}
exports.MsgUpdateGroupPolicyAdmin = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.admin !== "") {
            writer.uint32(10).string(message.admin);
        }
        if (message.groupPolicyAddress !== "") {
            writer.uint32(18).string(message.groupPolicyAddress);
        }
        if (message.newAdmin !== "") {
            writer.uint32(26).string(message.newAdmin);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgUpdateGroupPolicyAdmin();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.admin = reader.string();
                    break;
                case 2:
                    message.groupPolicyAddress = reader.string();
                    break;
                case 3:
                    message.newAdmin = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            admin: (0, helpers_1.isSet)(object.admin) ? String(object.admin) : "",
            groupPolicyAddress: (0, helpers_1.isSet)(object.groupPolicyAddress) ? String(object.groupPolicyAddress) : "",
            newAdmin: (0, helpers_1.isSet)(object.newAdmin) ? String(object.newAdmin) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.admin !== undefined && (obj.admin = message.admin);
        message.groupPolicyAddress !== undefined && (obj.groupPolicyAddress = message.groupPolicyAddress);
        message.newAdmin !== undefined && (obj.newAdmin = message.newAdmin);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgUpdateGroupPolicyAdmin();
        message.admin = object.admin ?? "";
        message.groupPolicyAddress = object.groupPolicyAddress ?? "";
        message.newAdmin = object.newAdmin ?? "";
        return message;
    },
};
function createBaseMsgUpdateGroupPolicyAdminResponse() {
    return {};
}
exports.MsgUpdateGroupPolicyAdminResponse = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgUpdateGroupPolicyAdminResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgUpdateGroupPolicyAdminResponse();
        return message;
    },
};
function createBaseMsgCreateGroupWithPolicy() {
    return {
        admin: "",
        members: [],
        groupMetadata: "",
        groupPolicyMetadata: "",
        groupPolicyAsAdmin: false,
        decisionPolicy: undefined,
    };
}
exports.MsgCreateGroupWithPolicy = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.admin !== "") {
            writer.uint32(10).string(message.admin);
        }
        for (const v of message.members) {
            types_1.MemberRequest.encode(v, writer.uint32(18).fork()).ldelim();
        }
        if (message.groupMetadata !== "") {
            writer.uint32(26).string(message.groupMetadata);
        }
        if (message.groupPolicyMetadata !== "") {
            writer.uint32(34).string(message.groupPolicyMetadata);
        }
        if (message.groupPolicyAsAdmin === true) {
            writer.uint32(40).bool(message.groupPolicyAsAdmin);
        }
        if (message.decisionPolicy !== undefined) {
            any_1.Any.encode(message.decisionPolicy, writer.uint32(50).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgCreateGroupWithPolicy();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.admin = reader.string();
                    break;
                case 2:
                    message.members.push(types_1.MemberRequest.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.groupMetadata = reader.string();
                    break;
                case 4:
                    message.groupPolicyMetadata = reader.string();
                    break;
                case 5:
                    message.groupPolicyAsAdmin = reader.bool();
                    break;
                case 6:
                    message.decisionPolicy = any_1.Any.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            admin: (0, helpers_1.isSet)(object.admin) ? String(object.admin) : "",
            members: Array.isArray(object?.members)
                ? object.members.map((e) => types_1.MemberRequest.fromJSON(e))
                : [],
            groupMetadata: (0, helpers_1.isSet)(object.groupMetadata) ? String(object.groupMetadata) : "",
            groupPolicyMetadata: (0, helpers_1.isSet)(object.groupPolicyMetadata) ? String(object.groupPolicyMetadata) : "",
            groupPolicyAsAdmin: (0, helpers_1.isSet)(object.groupPolicyAsAdmin) ? Boolean(object.groupPolicyAsAdmin) : false,
            decisionPolicy: (0, helpers_1.isSet)(object.decisionPolicy) ? any_1.Any.fromJSON(object.decisionPolicy) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.admin !== undefined && (obj.admin = message.admin);
        if (message.members) {
            obj.members = message.members.map((e) => (e ? types_1.MemberRequest.toJSON(e) : undefined));
        }
        else {
            obj.members = [];
        }
        message.groupMetadata !== undefined && (obj.groupMetadata = message.groupMetadata);
        message.groupPolicyMetadata !== undefined && (obj.groupPolicyMetadata = message.groupPolicyMetadata);
        message.groupPolicyAsAdmin !== undefined && (obj.groupPolicyAsAdmin = message.groupPolicyAsAdmin);
        message.decisionPolicy !== undefined &&
            (obj.decisionPolicy = message.decisionPolicy ? any_1.Any.toJSON(message.decisionPolicy) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgCreateGroupWithPolicy();
        message.admin = object.admin ?? "";
        message.members = object.members?.map((e) => types_1.MemberRequest.fromPartial(e)) || [];
        message.groupMetadata = object.groupMetadata ?? "";
        message.groupPolicyMetadata = object.groupPolicyMetadata ?? "";
        message.groupPolicyAsAdmin = object.groupPolicyAsAdmin ?? false;
        message.decisionPolicy =
            object.decisionPolicy !== undefined && object.decisionPolicy !== null
                ? any_1.Any.fromPartial(object.decisionPolicy)
                : undefined;
        return message;
    },
};
function createBaseMsgCreateGroupWithPolicyResponse() {
    return {
        groupId: helpers_1.Long.UZERO,
        groupPolicyAddress: "",
    };
}
exports.MsgCreateGroupWithPolicyResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (!message.groupId.isZero()) {
            writer.uint32(8).uint64(message.groupId);
        }
        if (message.groupPolicyAddress !== "") {
            writer.uint32(18).string(message.groupPolicyAddress);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgCreateGroupWithPolicyResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.groupId = reader.uint64();
                    break;
                case 2:
                    message.groupPolicyAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            groupId: (0, helpers_1.isSet)(object.groupId) ? helpers_1.Long.fromValue(object.groupId) : helpers_1.Long.UZERO,
            groupPolicyAddress: (0, helpers_1.isSet)(object.groupPolicyAddress) ? String(object.groupPolicyAddress) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.groupId !== undefined && (obj.groupId = (message.groupId || helpers_1.Long.UZERO).toString());
        message.groupPolicyAddress !== undefined && (obj.groupPolicyAddress = message.groupPolicyAddress);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgCreateGroupWithPolicyResponse();
        message.groupId =
            object.groupId !== undefined && object.groupId !== null ? helpers_1.Long.fromValue(object.groupId) : helpers_1.Long.UZERO;
        message.groupPolicyAddress = object.groupPolicyAddress ?? "";
        return message;
    },
};
function createBaseMsgUpdateGroupPolicyDecisionPolicy() {
    return {
        admin: "",
        groupPolicyAddress: "",
        decisionPolicy: undefined,
    };
}
exports.MsgUpdateGroupPolicyDecisionPolicy = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.admin !== "") {
            writer.uint32(10).string(message.admin);
        }
        if (message.groupPolicyAddress !== "") {
            writer.uint32(18).string(message.groupPolicyAddress);
        }
        if (message.decisionPolicy !== undefined) {
            any_1.Any.encode(message.decisionPolicy, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgUpdateGroupPolicyDecisionPolicy();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.admin = reader.string();
                    break;
                case 2:
                    message.groupPolicyAddress = reader.string();
                    break;
                case 3:
                    message.decisionPolicy = any_1.Any.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            admin: (0, helpers_1.isSet)(object.admin) ? String(object.admin) : "",
            groupPolicyAddress: (0, helpers_1.isSet)(object.groupPolicyAddress) ? String(object.groupPolicyAddress) : "",
            decisionPolicy: (0, helpers_1.isSet)(object.decisionPolicy) ? any_1.Any.fromJSON(object.decisionPolicy) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.admin !== undefined && (obj.admin = message.admin);
        message.groupPolicyAddress !== undefined && (obj.groupPolicyAddress = message.groupPolicyAddress);
        message.decisionPolicy !== undefined &&
            (obj.decisionPolicy = message.decisionPolicy ? any_1.Any.toJSON(message.decisionPolicy) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgUpdateGroupPolicyDecisionPolicy();
        message.admin = object.admin ?? "";
        message.groupPolicyAddress = object.groupPolicyAddress ?? "";
        message.decisionPolicy =
            object.decisionPolicy !== undefined && object.decisionPolicy !== null
                ? any_1.Any.fromPartial(object.decisionPolicy)
                : undefined;
        return message;
    },
};
function createBaseMsgUpdateGroupPolicyDecisionPolicyResponse() {
    return {};
}
exports.MsgUpdateGroupPolicyDecisionPolicyResponse = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgUpdateGroupPolicyDecisionPolicyResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgUpdateGroupPolicyDecisionPolicyResponse();
        return message;
    },
};
function createBaseMsgUpdateGroupPolicyMetadata() {
    return {
        admin: "",
        groupPolicyAddress: "",
        metadata: "",
    };
}
exports.MsgUpdateGroupPolicyMetadata = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.admin !== "") {
            writer.uint32(10).string(message.admin);
        }
        if (message.groupPolicyAddress !== "") {
            writer.uint32(18).string(message.groupPolicyAddress);
        }
        if (message.metadata !== "") {
            writer.uint32(26).string(message.metadata);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgUpdateGroupPolicyMetadata();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.admin = reader.string();
                    break;
                case 2:
                    message.groupPolicyAddress = reader.string();
                    break;
                case 3:
                    message.metadata = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            admin: (0, helpers_1.isSet)(object.admin) ? String(object.admin) : "",
            groupPolicyAddress: (0, helpers_1.isSet)(object.groupPolicyAddress) ? String(object.groupPolicyAddress) : "",
            metadata: (0, helpers_1.isSet)(object.metadata) ? String(object.metadata) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.admin !== undefined && (obj.admin = message.admin);
        message.groupPolicyAddress !== undefined && (obj.groupPolicyAddress = message.groupPolicyAddress);
        message.metadata !== undefined && (obj.metadata = message.metadata);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgUpdateGroupPolicyMetadata();
        message.admin = object.admin ?? "";
        message.groupPolicyAddress = object.groupPolicyAddress ?? "";
        message.metadata = object.metadata ?? "";
        return message;
    },
};
function createBaseMsgUpdateGroupPolicyMetadataResponse() {
    return {};
}
exports.MsgUpdateGroupPolicyMetadataResponse = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgUpdateGroupPolicyMetadataResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgUpdateGroupPolicyMetadataResponse();
        return message;
    },
};
function createBaseMsgSubmitProposal() {
    return {
        groupPolicyAddress: "",
        proposers: [],
        metadata: "",
        messages: [],
        exec: 0,
        title: "",
        summary: "",
    };
}
exports.MsgSubmitProposal = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.groupPolicyAddress !== "") {
            writer.uint32(10).string(message.groupPolicyAddress);
        }
        for (const v of message.proposers) {
            writer.uint32(18).string(v);
        }
        if (message.metadata !== "") {
            writer.uint32(26).string(message.metadata);
        }
        for (const v of message.messages) {
            any_1.Any.encode(v, writer.uint32(34).fork()).ldelim();
        }
        if (message.exec !== 0) {
            writer.uint32(40).int32(message.exec);
        }
        if (message.title !== "") {
            writer.uint32(50).string(message.title);
        }
        if (message.summary !== "") {
            writer.uint32(58).string(message.summary);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgSubmitProposal();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.groupPolicyAddress = reader.string();
                    break;
                case 2:
                    message.proposers.push(reader.string());
                    break;
                case 3:
                    message.metadata = reader.string();
                    break;
                case 4:
                    message.messages.push(any_1.Any.decode(reader, reader.uint32()));
                    break;
                case 5:
                    message.exec = reader.int32();
                    break;
                case 6:
                    message.title = reader.string();
                    break;
                case 7:
                    message.summary = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            groupPolicyAddress: (0, helpers_1.isSet)(object.groupPolicyAddress) ? String(object.groupPolicyAddress) : "",
            proposers: Array.isArray(object?.proposers) ? object.proposers.map((e) => String(e)) : [],
            metadata: (0, helpers_1.isSet)(object.metadata) ? String(object.metadata) : "",
            messages: Array.isArray(object?.messages) ? object.messages.map((e) => any_1.Any.fromJSON(e)) : [],
            exec: (0, helpers_1.isSet)(object.exec) ? execFromJSON(object.exec) : 0,
            title: (0, helpers_1.isSet)(object.title) ? String(object.title) : "",
            summary: (0, helpers_1.isSet)(object.summary) ? String(object.summary) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.groupPolicyAddress !== undefined && (obj.groupPolicyAddress = message.groupPolicyAddress);
        if (message.proposers) {
            obj.proposers = message.proposers.map((e) => e);
        }
        else {
            obj.proposers = [];
        }
        message.metadata !== undefined && (obj.metadata = message.metadata);
        if (message.messages) {
            obj.messages = message.messages.map((e) => (e ? any_1.Any.toJSON(e) : undefined));
        }
        else {
            obj.messages = [];
        }
        message.exec !== undefined && (obj.exec = execToJSON(message.exec));
        message.title !== undefined && (obj.title = message.title);
        message.summary !== undefined && (obj.summary = message.summary);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgSubmitProposal();
        message.groupPolicyAddress = object.groupPolicyAddress ?? "";
        message.proposers = object.proposers?.map((e) => e) || [];
        message.metadata = object.metadata ?? "";
        message.messages = object.messages?.map((e) => any_1.Any.fromPartial(e)) || [];
        message.exec = object.exec ?? 0;
        message.title = object.title ?? "";
        message.summary = object.summary ?? "";
        return message;
    },
};
function createBaseMsgSubmitProposalResponse() {
    return {
        proposalId: helpers_1.Long.UZERO,
    };
}
exports.MsgSubmitProposalResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (!message.proposalId.isZero()) {
            writer.uint32(8).uint64(message.proposalId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgSubmitProposalResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            proposalId: (0, helpers_1.isSet)(object.proposalId) ? helpers_1.Long.fromValue(object.proposalId) : helpers_1.Long.UZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || helpers_1.Long.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgSubmitProposalResponse();
        message.proposalId =
            object.proposalId !== undefined && object.proposalId !== null
                ? helpers_1.Long.fromValue(object.proposalId)
                : helpers_1.Long.UZERO;
        return message;
    },
};
function createBaseMsgWithdrawProposal() {
    return {
        proposalId: helpers_1.Long.UZERO,
        address: "",
    };
}
exports.MsgWithdrawProposal = {
    encode(message, writer = _m0.Writer.create()) {
        if (!message.proposalId.isZero()) {
            writer.uint32(8).uint64(message.proposalId);
        }
        if (message.address !== "") {
            writer.uint32(18).string(message.address);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgWithdrawProposal();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.address = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            proposalId: (0, helpers_1.isSet)(object.proposalId) ? helpers_1.Long.fromValue(object.proposalId) : helpers_1.Long.UZERO,
            address: (0, helpers_1.isSet)(object.address) ? String(object.address) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || helpers_1.Long.UZERO).toString());
        message.address !== undefined && (obj.address = message.address);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgWithdrawProposal();
        message.proposalId =
            object.proposalId !== undefined && object.proposalId !== null
                ? helpers_1.Long.fromValue(object.proposalId)
                : helpers_1.Long.UZERO;
        message.address = object.address ?? "";
        return message;
    },
};
function createBaseMsgWithdrawProposalResponse() {
    return {};
}
exports.MsgWithdrawProposalResponse = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgWithdrawProposalResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgWithdrawProposalResponse();
        return message;
    },
};
function createBaseMsgVote() {
    return {
        proposalId: helpers_1.Long.UZERO,
        voter: "",
        option: 0,
        metadata: "",
        exec: 0,
    };
}
exports.MsgVote = {
    encode(message, writer = _m0.Writer.create()) {
        if (!message.proposalId.isZero()) {
            writer.uint32(8).uint64(message.proposalId);
        }
        if (message.voter !== "") {
            writer.uint32(18).string(message.voter);
        }
        if (message.option !== 0) {
            writer.uint32(24).int32(message.option);
        }
        if (message.metadata !== "") {
            writer.uint32(34).string(message.metadata);
        }
        if (message.exec !== 0) {
            writer.uint32(40).int32(message.exec);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgVote();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.voter = reader.string();
                    break;
                case 3:
                    message.option = reader.int32();
                    break;
                case 4:
                    message.metadata = reader.string();
                    break;
                case 5:
                    message.exec = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            proposalId: (0, helpers_1.isSet)(object.proposalId) ? helpers_1.Long.fromValue(object.proposalId) : helpers_1.Long.UZERO,
            voter: (0, helpers_1.isSet)(object.voter) ? String(object.voter) : "",
            option: (0, helpers_1.isSet)(object.option) ? (0, types_1.voteOptionFromJSON)(object.option) : 0,
            metadata: (0, helpers_1.isSet)(object.metadata) ? String(object.metadata) : "",
            exec: (0, helpers_1.isSet)(object.exec) ? execFromJSON(object.exec) : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || helpers_1.Long.UZERO).toString());
        message.voter !== undefined && (obj.voter = message.voter);
        message.option !== undefined && (obj.option = (0, types_1.voteOptionToJSON)(message.option));
        message.metadata !== undefined && (obj.metadata = message.metadata);
        message.exec !== undefined && (obj.exec = execToJSON(message.exec));
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgVote();
        message.proposalId =
            object.proposalId !== undefined && object.proposalId !== null
                ? helpers_1.Long.fromValue(object.proposalId)
                : helpers_1.Long.UZERO;
        message.voter = object.voter ?? "";
        message.option = object.option ?? 0;
        message.metadata = object.metadata ?? "";
        message.exec = object.exec ?? 0;
        return message;
    },
};
function createBaseMsgVoteResponse() {
    return {};
}
exports.MsgVoteResponse = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgVoteResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgVoteResponse();
        return message;
    },
};
function createBaseMsgExec() {
    return {
        proposalId: helpers_1.Long.UZERO,
        executor: "",
    };
}
exports.MsgExec = {
    encode(message, writer = _m0.Writer.create()) {
        if (!message.proposalId.isZero()) {
            writer.uint32(8).uint64(message.proposalId);
        }
        if (message.executor !== "") {
            writer.uint32(18).string(message.executor);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgExec();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.executor = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            proposalId: (0, helpers_1.isSet)(object.proposalId) ? helpers_1.Long.fromValue(object.proposalId) : helpers_1.Long.UZERO,
            executor: (0, helpers_1.isSet)(object.executor) ? String(object.executor) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || helpers_1.Long.UZERO).toString());
        message.executor !== undefined && (obj.executor = message.executor);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgExec();
        message.proposalId =
            object.proposalId !== undefined && object.proposalId !== null
                ? helpers_1.Long.fromValue(object.proposalId)
                : helpers_1.Long.UZERO;
        message.executor = object.executor ?? "";
        return message;
    },
};
function createBaseMsgExecResponse() {
    return {
        result: 0,
    };
}
exports.MsgExecResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.result !== 0) {
            writer.uint32(16).int32(message.result);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgExecResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 2:
                    message.result = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            result: (0, helpers_1.isSet)(object.result) ? (0, types_1.proposalExecutorResultFromJSON)(object.result) : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        message.result !== undefined && (obj.result = (0, types_1.proposalExecutorResultToJSON)(message.result));
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgExecResponse();
        message.result = object.result ?? 0;
        return message;
    },
};
function createBaseMsgLeaveGroup() {
    return {
        address: "",
        groupId: helpers_1.Long.UZERO,
    };
}
exports.MsgLeaveGroup = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.address !== "") {
            writer.uint32(10).string(message.address);
        }
        if (!message.groupId.isZero()) {
            writer.uint32(16).uint64(message.groupId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgLeaveGroup();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.groupId = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            address: (0, helpers_1.isSet)(object.address) ? String(object.address) : "",
            groupId: (0, helpers_1.isSet)(object.groupId) ? helpers_1.Long.fromValue(object.groupId) : helpers_1.Long.UZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.groupId !== undefined && (obj.groupId = (message.groupId || helpers_1.Long.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgLeaveGroup();
        message.address = object.address ?? "";
        message.groupId =
            object.groupId !== undefined && object.groupId !== null ? helpers_1.Long.fromValue(object.groupId) : helpers_1.Long.UZERO;
        return message;
    },
};
function createBaseMsgLeaveGroupResponse() {
    return {};
}
exports.MsgLeaveGroupResponse = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgLeaveGroupResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgLeaveGroupResponse();
        return message;
    },
};
class MsgClientImpl {
    constructor(rpc) {
        this.rpc = rpc;
        this.CreateGroup = this.CreateGroup.bind(this);
        this.UpdateGroupMembers = this.UpdateGroupMembers.bind(this);
        this.UpdateGroupAdmin = this.UpdateGroupAdmin.bind(this);
        this.UpdateGroupMetadata = this.UpdateGroupMetadata.bind(this);
        this.CreateGroupPolicy = this.CreateGroupPolicy.bind(this);
        this.CreateGroupWithPolicy = this.CreateGroupWithPolicy.bind(this);
        this.UpdateGroupPolicyAdmin = this.UpdateGroupPolicyAdmin.bind(this);
        this.UpdateGroupPolicyDecisionPolicy = this.UpdateGroupPolicyDecisionPolicy.bind(this);
        this.UpdateGroupPolicyMetadata = this.UpdateGroupPolicyMetadata.bind(this);
        this.SubmitProposal = this.SubmitProposal.bind(this);
        this.WithdrawProposal = this.WithdrawProposal.bind(this);
        this.Vote = this.Vote.bind(this);
        this.Exec = this.Exec.bind(this);
        this.LeaveGroup = this.LeaveGroup.bind(this);
    }
    CreateGroup(request) {
        const data = exports.MsgCreateGroup.encode(request).finish();
        const promise = this.rpc.request("cosmos.group.v1.Msg", "CreateGroup", data);
        return promise.then((data) => exports.MsgCreateGroupResponse.decode(new _m0.Reader(data)));
    }
    UpdateGroupMembers(request) {
        const data = exports.MsgUpdateGroupMembers.encode(request).finish();
        const promise = this.rpc.request("cosmos.group.v1.Msg", "UpdateGroupMembers", data);
        return promise.then((data) => exports.MsgUpdateGroupMembersResponse.decode(new _m0.Reader(data)));
    }
    UpdateGroupAdmin(request) {
        const data = exports.MsgUpdateGroupAdmin.encode(request).finish();
        const promise = this.rpc.request("cosmos.group.v1.Msg", "UpdateGroupAdmin", data);
        return promise.then((data) => exports.MsgUpdateGroupAdminResponse.decode(new _m0.Reader(data)));
    }
    UpdateGroupMetadata(request) {
        const data = exports.MsgUpdateGroupMetadata.encode(request).finish();
        const promise = this.rpc.request("cosmos.group.v1.Msg", "UpdateGroupMetadata", data);
        return promise.then((data) => exports.MsgUpdateGroupMetadataResponse.decode(new _m0.Reader(data)));
    }
    CreateGroupPolicy(request) {
        const data = exports.MsgCreateGroupPolicy.encode(request).finish();
        const promise = this.rpc.request("cosmos.group.v1.Msg", "CreateGroupPolicy", data);
        return promise.then((data) => exports.MsgCreateGroupPolicyResponse.decode(new _m0.Reader(data)));
    }
    CreateGroupWithPolicy(request) {
        const data = exports.MsgCreateGroupWithPolicy.encode(request).finish();
        const promise = this.rpc.request("cosmos.group.v1.Msg", "CreateGroupWithPolicy", data);
        return promise.then((data) => exports.MsgCreateGroupWithPolicyResponse.decode(new _m0.Reader(data)));
    }
    UpdateGroupPolicyAdmin(request) {
        const data = exports.MsgUpdateGroupPolicyAdmin.encode(request).finish();
        const promise = this.rpc.request("cosmos.group.v1.Msg", "UpdateGroupPolicyAdmin", data);
        return promise.then((data) => exports.MsgUpdateGroupPolicyAdminResponse.decode(new _m0.Reader(data)));
    }
    UpdateGroupPolicyDecisionPolicy(request) {
        const data = exports.MsgUpdateGroupPolicyDecisionPolicy.encode(request).finish();
        const promise = this.rpc.request("cosmos.group.v1.Msg", "UpdateGroupPolicyDecisionPolicy", data);
        return promise.then((data) => exports.MsgUpdateGroupPolicyDecisionPolicyResponse.decode(new _m0.Reader(data)));
    }
    UpdateGroupPolicyMetadata(request) {
        const data = exports.MsgUpdateGroupPolicyMetadata.encode(request).finish();
        const promise = this.rpc.request("cosmos.group.v1.Msg", "UpdateGroupPolicyMetadata", data);
        return promise.then((data) => exports.MsgUpdateGroupPolicyMetadataResponse.decode(new _m0.Reader(data)));
    }
    SubmitProposal(request) {
        const data = exports.MsgSubmitProposal.encode(request).finish();
        const promise = this.rpc.request("cosmos.group.v1.Msg", "SubmitProposal", data);
        return promise.then((data) => exports.MsgSubmitProposalResponse.decode(new _m0.Reader(data)));
    }
    WithdrawProposal(request) {
        const data = exports.MsgWithdrawProposal.encode(request).finish();
        const promise = this.rpc.request("cosmos.group.v1.Msg", "WithdrawProposal", data);
        return promise.then((data) => exports.MsgWithdrawProposalResponse.decode(new _m0.Reader(data)));
    }
    Vote(request) {
        const data = exports.MsgVote.encode(request).finish();
        const promise = this.rpc.request("cosmos.group.v1.Msg", "Vote", data);
        return promise.then((data) => exports.MsgVoteResponse.decode(new _m0.Reader(data)));
    }
    Exec(request) {
        const data = exports.MsgExec.encode(request).finish();
        const promise = this.rpc.request("cosmos.group.v1.Msg", "Exec", data);
        return promise.then((data) => exports.MsgExecResponse.decode(new _m0.Reader(data)));
    }
    LeaveGroup(request) {
        const data = exports.MsgLeaveGroup.encode(request).finish();
        const promise = this.rpc.request("cosmos.group.v1.Msg", "LeaveGroup", data);
        return promise.then((data) => exports.MsgLeaveGroupResponse.decode(new _m0.Reader(data)));
    }
}
exports.MsgClientImpl = MsgClientImpl;
//# sourceMappingURL=tx.js.map

/***/ }),

/***/ 32946:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Vote = exports.TallyResult = exports.Proposal = exports.GroupPolicyInfo = exports.GroupMember = exports.GroupInfo = exports.DecisionPolicyWindows = exports.PercentageDecisionPolicy = exports.ThresholdDecisionPolicy = exports.MemberRequest = exports.Member = exports.proposalExecutorResultToJSON = exports.proposalExecutorResultFromJSON = exports.ProposalExecutorResult = exports.proposalStatusToJSON = exports.proposalStatusFromJSON = exports.ProposalStatus = exports.voteOptionToJSON = exports.voteOptionFromJSON = exports.VoteOption = exports.protobufPackage = void 0;
/* eslint-disable */
const timestamp_1 = __webpack_require__(70147);
const duration_1 = __webpack_require__(9591);
const any_1 = __webpack_require__(75654);
const helpers_1 = __webpack_require__(92654);
const _m0 = __importStar(__webpack_require__(62100));
exports.protobufPackage = "cosmos.group.v1";
/** VoteOption enumerates the valid vote options for a given proposal. */
var VoteOption;
(function (VoteOption) {
    /**
     * VOTE_OPTION_UNSPECIFIED - VOTE_OPTION_UNSPECIFIED defines an unspecified vote option which will
     * return an error.
     */
    VoteOption[VoteOption["VOTE_OPTION_UNSPECIFIED"] = 0] = "VOTE_OPTION_UNSPECIFIED";
    /** VOTE_OPTION_YES - VOTE_OPTION_YES defines a yes vote option. */
    VoteOption[VoteOption["VOTE_OPTION_YES"] = 1] = "VOTE_OPTION_YES";
    /** VOTE_OPTION_ABSTAIN - VOTE_OPTION_ABSTAIN defines an abstain vote option. */
    VoteOption[VoteOption["VOTE_OPTION_ABSTAIN"] = 2] = "VOTE_OPTION_ABSTAIN";
    /** VOTE_OPTION_NO - VOTE_OPTION_NO defines a no vote option. */
    VoteOption[VoteOption["VOTE_OPTION_NO"] = 3] = "VOTE_OPTION_NO";
    /** VOTE_OPTION_NO_WITH_VETO - VOTE_OPTION_NO_WITH_VETO defines a no with veto vote option. */
    VoteOption[VoteOption["VOTE_OPTION_NO_WITH_VETO"] = 4] = "VOTE_OPTION_NO_WITH_VETO";
    VoteOption[VoteOption["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(VoteOption = exports.VoteOption || (exports.VoteOption = {}));
function voteOptionFromJSON(object) {
    switch (object) {
        case 0:
        case "VOTE_OPTION_UNSPECIFIED":
            return VoteOption.VOTE_OPTION_UNSPECIFIED;
        case 1:
        case "VOTE_OPTION_YES":
            return VoteOption.VOTE_OPTION_YES;
        case 2:
        case "VOTE_OPTION_ABSTAIN":
            return VoteOption.VOTE_OPTION_ABSTAIN;
        case 3:
        case "VOTE_OPTION_NO":
            return VoteOption.VOTE_OPTION_NO;
        case 4:
        case "VOTE_OPTION_NO_WITH_VETO":
            return VoteOption.VOTE_OPTION_NO_WITH_VETO;
        case -1:
        case "UNRECOGNIZED":
        default:
            return VoteOption.UNRECOGNIZED;
    }
}
exports.voteOptionFromJSON = voteOptionFromJSON;
function voteOptionToJSON(object) {
    switch (object) {
        case VoteOption.VOTE_OPTION_UNSPECIFIED:
            return "VOTE_OPTION_UNSPECIFIED";
        case VoteOption.VOTE_OPTION_YES:
            return "VOTE_OPTION_YES";
        case VoteOption.VOTE_OPTION_ABSTAIN:
            return "VOTE_OPTION_ABSTAIN";
        case VoteOption.VOTE_OPTION_NO:
            return "VOTE_OPTION_NO";
        case VoteOption.VOTE_OPTION_NO_WITH_VETO:
            return "VOTE_OPTION_NO_WITH_VETO";
        case VoteOption.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.voteOptionToJSON = voteOptionToJSON;
/** ProposalStatus defines proposal statuses. */
var ProposalStatus;
(function (ProposalStatus) {
    /** PROPOSAL_STATUS_UNSPECIFIED - An empty value is invalid and not allowed. */
    ProposalStatus[ProposalStatus["PROPOSAL_STATUS_UNSPECIFIED"] = 0] = "PROPOSAL_STATUS_UNSPECIFIED";
    /** PROPOSAL_STATUS_SUBMITTED - Initial status of a proposal when submitted. */
    ProposalStatus[ProposalStatus["PROPOSAL_STATUS_SUBMITTED"] = 1] = "PROPOSAL_STATUS_SUBMITTED";
    /**
     * PROPOSAL_STATUS_ACCEPTED - Final status of a proposal when the final tally is done and the outcome
     * passes the group policy's decision policy.
     */
    ProposalStatus[ProposalStatus["PROPOSAL_STATUS_ACCEPTED"] = 2] = "PROPOSAL_STATUS_ACCEPTED";
    /**
     * PROPOSAL_STATUS_REJECTED - Final status of a proposal when the final tally is done and the outcome
     * is rejected by the group policy's decision policy.
     */
    ProposalStatus[ProposalStatus["PROPOSAL_STATUS_REJECTED"] = 3] = "PROPOSAL_STATUS_REJECTED";
    /**
     * PROPOSAL_STATUS_ABORTED - Final status of a proposal when the group policy is modified before the
     * final tally.
     */
    ProposalStatus[ProposalStatus["PROPOSAL_STATUS_ABORTED"] = 4] = "PROPOSAL_STATUS_ABORTED";
    /**
     * PROPOSAL_STATUS_WITHDRAWN - A proposal can be withdrawn before the voting start time by the owner.
     * When this happens the final status is Withdrawn.
     */
    ProposalStatus[ProposalStatus["PROPOSAL_STATUS_WITHDRAWN"] = 5] = "PROPOSAL_STATUS_WITHDRAWN";
    ProposalStatus[ProposalStatus["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(ProposalStatus = exports.ProposalStatus || (exports.ProposalStatus = {}));
function proposalStatusFromJSON(object) {
    switch (object) {
        case 0:
        case "PROPOSAL_STATUS_UNSPECIFIED":
            return ProposalStatus.PROPOSAL_STATUS_UNSPECIFIED;
        case 1:
        case "PROPOSAL_STATUS_SUBMITTED":
            return ProposalStatus.PROPOSAL_STATUS_SUBMITTED;
        case 2:
        case "PROPOSAL_STATUS_ACCEPTED":
            return ProposalStatus.PROPOSAL_STATUS_ACCEPTED;
        case 3:
        case "PROPOSAL_STATUS_REJECTED":
            return ProposalStatus.PROPOSAL_STATUS_REJECTED;
        case 4:
        case "PROPOSAL_STATUS_ABORTED":
            return ProposalStatus.PROPOSAL_STATUS_ABORTED;
        case 5:
        case "PROPOSAL_STATUS_WITHDRAWN":
            return ProposalStatus.PROPOSAL_STATUS_WITHDRAWN;
        case -1:
        case "UNRECOGNIZED":
        default:
            return ProposalStatus.UNRECOGNIZED;
    }
}
exports.proposalStatusFromJSON = proposalStatusFromJSON;
function proposalStatusToJSON(object) {
    switch (object) {
        case ProposalStatus.PROPOSAL_STATUS_UNSPECIFIED:
            return "PROPOSAL_STATUS_UNSPECIFIED";
        case ProposalStatus.PROPOSAL_STATUS_SUBMITTED:
            return "PROPOSAL_STATUS_SUBMITTED";
        case ProposalStatus.PROPOSAL_STATUS_ACCEPTED:
            return "PROPOSAL_STATUS_ACCEPTED";
        case ProposalStatus.PROPOSAL_STATUS_REJECTED:
            return "PROPOSAL_STATUS_REJECTED";
        case ProposalStatus.PROPOSAL_STATUS_ABORTED:
            return "PROPOSAL_STATUS_ABORTED";
        case ProposalStatus.PROPOSAL_STATUS_WITHDRAWN:
            return "PROPOSAL_STATUS_WITHDRAWN";
        case ProposalStatus.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.proposalStatusToJSON = proposalStatusToJSON;
/** ProposalExecutorResult defines types of proposal executor results. */
var ProposalExecutorResult;
(function (ProposalExecutorResult) {
    /** PROPOSAL_EXECUTOR_RESULT_UNSPECIFIED - An empty value is not allowed. */
    ProposalExecutorResult[ProposalExecutorResult["PROPOSAL_EXECUTOR_RESULT_UNSPECIFIED"] = 0] = "PROPOSAL_EXECUTOR_RESULT_UNSPECIFIED";
    /** PROPOSAL_EXECUTOR_RESULT_NOT_RUN - We have not yet run the executor. */
    ProposalExecutorResult[ProposalExecutorResult["PROPOSAL_EXECUTOR_RESULT_NOT_RUN"] = 1] = "PROPOSAL_EXECUTOR_RESULT_NOT_RUN";
    /** PROPOSAL_EXECUTOR_RESULT_SUCCESS - The executor was successful and proposed action updated state. */
    ProposalExecutorResult[ProposalExecutorResult["PROPOSAL_EXECUTOR_RESULT_SUCCESS"] = 2] = "PROPOSAL_EXECUTOR_RESULT_SUCCESS";
    /** PROPOSAL_EXECUTOR_RESULT_FAILURE - The executor returned an error and proposed action didn't update state. */
    ProposalExecutorResult[ProposalExecutorResult["PROPOSAL_EXECUTOR_RESULT_FAILURE"] = 3] = "PROPOSAL_EXECUTOR_RESULT_FAILURE";
    ProposalExecutorResult[ProposalExecutorResult["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(ProposalExecutorResult = exports.ProposalExecutorResult || (exports.ProposalExecutorResult = {}));
function proposalExecutorResultFromJSON(object) {
    switch (object) {
        case 0:
        case "PROPOSAL_EXECUTOR_RESULT_UNSPECIFIED":
            return ProposalExecutorResult.PROPOSAL_EXECUTOR_RESULT_UNSPECIFIED;
        case 1:
        case "PROPOSAL_EXECUTOR_RESULT_NOT_RUN":
            return ProposalExecutorResult.PROPOSAL_EXECUTOR_RESULT_NOT_RUN;
        case 2:
        case "PROPOSAL_EXECUTOR_RESULT_SUCCESS":
            return ProposalExecutorResult.PROPOSAL_EXECUTOR_RESULT_SUCCESS;
        case 3:
        case "PROPOSAL_EXECUTOR_RESULT_FAILURE":
            return ProposalExecutorResult.PROPOSAL_EXECUTOR_RESULT_FAILURE;
        case -1:
        case "UNRECOGNIZED":
        default:
            return ProposalExecutorResult.UNRECOGNIZED;
    }
}
exports.proposalExecutorResultFromJSON = proposalExecutorResultFromJSON;
function proposalExecutorResultToJSON(object) {
    switch (object) {
        case ProposalExecutorResult.PROPOSAL_EXECUTOR_RESULT_UNSPECIFIED:
            return "PROPOSAL_EXECUTOR_RESULT_UNSPECIFIED";
        case ProposalExecutorResult.PROPOSAL_EXECUTOR_RESULT_NOT_RUN:
            return "PROPOSAL_EXECUTOR_RESULT_NOT_RUN";
        case ProposalExecutorResult.PROPOSAL_EXECUTOR_RESULT_SUCCESS:
            return "PROPOSAL_EXECUTOR_RESULT_SUCCESS";
        case ProposalExecutorResult.PROPOSAL_EXECUTOR_RESULT_FAILURE:
            return "PROPOSAL_EXECUTOR_RESULT_FAILURE";
        case ProposalExecutorResult.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.proposalExecutorResultToJSON = proposalExecutorResultToJSON;
function createBaseMember() {
    return {
        address: "",
        weight: "",
        metadata: "",
        addedAt: undefined,
    };
}
exports.Member = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.address !== "") {
            writer.uint32(10).string(message.address);
        }
        if (message.weight !== "") {
            writer.uint32(18).string(message.weight);
        }
        if (message.metadata !== "") {
            writer.uint32(26).string(message.metadata);
        }
        if (message.addedAt !== undefined) {
            timestamp_1.Timestamp.encode(message.addedAt, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMember();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.weight = reader.string();
                    break;
                case 3:
                    message.metadata = reader.string();
                    break;
                case 4:
                    message.addedAt = timestamp_1.Timestamp.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            address: (0, helpers_1.isSet)(object.address) ? String(object.address) : "",
            weight: (0, helpers_1.isSet)(object.weight) ? String(object.weight) : "",
            metadata: (0, helpers_1.isSet)(object.metadata) ? String(object.metadata) : "",
            addedAt: (0, helpers_1.isSet)(object.addedAt) ? (0, helpers_1.fromJsonTimestamp)(object.addedAt) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.weight !== undefined && (obj.weight = message.weight);
        message.metadata !== undefined && (obj.metadata = message.metadata);
        message.addedAt !== undefined && (obj.addedAt = (0, helpers_1.fromTimestamp)(message.addedAt).toISOString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMember();
        message.address = object.address ?? "";
        message.weight = object.weight ?? "";
        message.metadata = object.metadata ?? "";
        message.addedAt =
            object.addedAt !== undefined && object.addedAt !== null
                ? timestamp_1.Timestamp.fromPartial(object.addedAt)
                : undefined;
        return message;
    },
};
function createBaseMemberRequest() {
    return {
        address: "",
        weight: "",
        metadata: "",
    };
}
exports.MemberRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.address !== "") {
            writer.uint32(10).string(message.address);
        }
        if (message.weight !== "") {
            writer.uint32(18).string(message.weight);
        }
        if (message.metadata !== "") {
            writer.uint32(26).string(message.metadata);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMemberRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.weight = reader.string();
                    break;
                case 3:
                    message.metadata = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            address: (0, helpers_1.isSet)(object.address) ? String(object.address) : "",
            weight: (0, helpers_1.isSet)(object.weight) ? String(object.weight) : "",
            metadata: (0, helpers_1.isSet)(object.metadata) ? String(object.metadata) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.weight !== undefined && (obj.weight = message.weight);
        message.metadata !== undefined && (obj.metadata = message.metadata);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMemberRequest();
        message.address = object.address ?? "";
        message.weight = object.weight ?? "";
        message.metadata = object.metadata ?? "";
        return message;
    },
};
function createBaseThresholdDecisionPolicy() {
    return {
        threshold: "",
        windows: undefined,
    };
}
exports.ThresholdDecisionPolicy = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.threshold !== "") {
            writer.uint32(10).string(message.threshold);
        }
        if (message.windows !== undefined) {
            exports.DecisionPolicyWindows.encode(message.windows, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseThresholdDecisionPolicy();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.threshold = reader.string();
                    break;
                case 2:
                    message.windows = exports.DecisionPolicyWindows.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            threshold: (0, helpers_1.isSet)(object.threshold) ? String(object.threshold) : "",
            windows: (0, helpers_1.isSet)(object.windows) ? exports.DecisionPolicyWindows.fromJSON(object.windows) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.threshold !== undefined && (obj.threshold = message.threshold);
        message.windows !== undefined &&
            (obj.windows = message.windows ? exports.DecisionPolicyWindows.toJSON(message.windows) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseThresholdDecisionPolicy();
        message.threshold = object.threshold ?? "";
        message.windows =
            object.windows !== undefined && object.windows !== null
                ? exports.DecisionPolicyWindows.fromPartial(object.windows)
                : undefined;
        return message;
    },
};
function createBasePercentageDecisionPolicy() {
    return {
        percentage: "",
        windows: undefined,
    };
}
exports.PercentageDecisionPolicy = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.percentage !== "") {
            writer.uint32(10).string(message.percentage);
        }
        if (message.windows !== undefined) {
            exports.DecisionPolicyWindows.encode(message.windows, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePercentageDecisionPolicy();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.percentage = reader.string();
                    break;
                case 2:
                    message.windows = exports.DecisionPolicyWindows.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            percentage: (0, helpers_1.isSet)(object.percentage) ? String(object.percentage) : "",
            windows: (0, helpers_1.isSet)(object.windows) ? exports.DecisionPolicyWindows.fromJSON(object.windows) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.percentage !== undefined && (obj.percentage = message.percentage);
        message.windows !== undefined &&
            (obj.windows = message.windows ? exports.DecisionPolicyWindows.toJSON(message.windows) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBasePercentageDecisionPolicy();
        message.percentage = object.percentage ?? "";
        message.windows =
            object.windows !== undefined && object.windows !== null
                ? exports.DecisionPolicyWindows.fromPartial(object.windows)
                : undefined;
        return message;
    },
};
function createBaseDecisionPolicyWindows() {
    return {
        votingPeriod: undefined,
        minExecutionPeriod: undefined,
    };
}
exports.DecisionPolicyWindows = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.votingPeriod !== undefined) {
            duration_1.Duration.encode(message.votingPeriod, writer.uint32(10).fork()).ldelim();
        }
        if (message.minExecutionPeriod !== undefined) {
            duration_1.Duration.encode(message.minExecutionPeriod, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDecisionPolicyWindows();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.votingPeriod = duration_1.Duration.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.minExecutionPeriod = duration_1.Duration.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            votingPeriod: (0, helpers_1.isSet)(object.votingPeriod) ? duration_1.Duration.fromJSON(object.votingPeriod) : undefined,
            minExecutionPeriod: (0, helpers_1.isSet)(object.minExecutionPeriod)
                ? duration_1.Duration.fromJSON(object.minExecutionPeriod)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.votingPeriod !== undefined &&
            (obj.votingPeriod = message.votingPeriod ? duration_1.Duration.toJSON(message.votingPeriod) : undefined);
        message.minExecutionPeriod !== undefined &&
            (obj.minExecutionPeriod = message.minExecutionPeriod
                ? duration_1.Duration.toJSON(message.minExecutionPeriod)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseDecisionPolicyWindows();
        message.votingPeriod =
            object.votingPeriod !== undefined && object.votingPeriod !== null
                ? duration_1.Duration.fromPartial(object.votingPeriod)
                : undefined;
        message.minExecutionPeriod =
            object.minExecutionPeriod !== undefined && object.minExecutionPeriod !== null
                ? duration_1.Duration.fromPartial(object.minExecutionPeriod)
                : undefined;
        return message;
    },
};
function createBaseGroupInfo() {
    return {
        id: helpers_1.Long.UZERO,
        admin: "",
        metadata: "",
        version: helpers_1.Long.UZERO,
        totalWeight: "",
        createdAt: undefined,
    };
}
exports.GroupInfo = {
    encode(message, writer = _m0.Writer.create()) {
        if (!message.id.isZero()) {
            writer.uint32(8).uint64(message.id);
        }
        if (message.admin !== "") {
            writer.uint32(18).string(message.admin);
        }
        if (message.metadata !== "") {
            writer.uint32(26).string(message.metadata);
        }
        if (!message.version.isZero()) {
            writer.uint32(32).uint64(message.version);
        }
        if (message.totalWeight !== "") {
            writer.uint32(42).string(message.totalWeight);
        }
        if (message.createdAt !== undefined) {
            timestamp_1.Timestamp.encode(message.createdAt, writer.uint32(50).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGroupInfo();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.id = reader.uint64();
                    break;
                case 2:
                    message.admin = reader.string();
                    break;
                case 3:
                    message.metadata = reader.string();
                    break;
                case 4:
                    message.version = reader.uint64();
                    break;
                case 5:
                    message.totalWeight = reader.string();
                    break;
                case 6:
                    message.createdAt = timestamp_1.Timestamp.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            id: (0, helpers_1.isSet)(object.id) ? helpers_1.Long.fromValue(object.id) : helpers_1.Long.UZERO,
            admin: (0, helpers_1.isSet)(object.admin) ? String(object.admin) : "",
            metadata: (0, helpers_1.isSet)(object.metadata) ? String(object.metadata) : "",
            version: (0, helpers_1.isSet)(object.version) ? helpers_1.Long.fromValue(object.version) : helpers_1.Long.UZERO,
            totalWeight: (0, helpers_1.isSet)(object.totalWeight) ? String(object.totalWeight) : "",
            createdAt: (0, helpers_1.isSet)(object.createdAt) ? (0, helpers_1.fromJsonTimestamp)(object.createdAt) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.id !== undefined && (obj.id = (message.id || helpers_1.Long.UZERO).toString());
        message.admin !== undefined && (obj.admin = message.admin);
        message.metadata !== undefined && (obj.metadata = message.metadata);
        message.version !== undefined && (obj.version = (message.version || helpers_1.Long.UZERO).toString());
        message.totalWeight !== undefined && (obj.totalWeight = message.totalWeight);
        message.createdAt !== undefined && (obj.createdAt = (0, helpers_1.fromTimestamp)(message.createdAt).toISOString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseGroupInfo();
        message.id = object.id !== undefined && object.id !== null ? helpers_1.Long.fromValue(object.id) : helpers_1.Long.UZERO;
        message.admin = object.admin ?? "";
        message.metadata = object.metadata ?? "";
        message.version =
            object.version !== undefined && object.version !== null ? helpers_1.Long.fromValue(object.version) : helpers_1.Long.UZERO;
        message.totalWeight = object.totalWeight ?? "";
        message.createdAt =
            object.createdAt !== undefined && object.createdAt !== null
                ? timestamp_1.Timestamp.fromPartial(object.createdAt)
                : undefined;
        return message;
    },
};
function createBaseGroupMember() {
    return {
        groupId: helpers_1.Long.UZERO,
        member: undefined,
    };
}
exports.GroupMember = {
    encode(message, writer = _m0.Writer.create()) {
        if (!message.groupId.isZero()) {
            writer.uint32(8).uint64(message.groupId);
        }
        if (message.member !== undefined) {
            exports.Member.encode(message.member, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGroupMember();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.groupId = reader.uint64();
                    break;
                case 2:
                    message.member = exports.Member.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            groupId: (0, helpers_1.isSet)(object.groupId) ? helpers_1.Long.fromValue(object.groupId) : helpers_1.Long.UZERO,
            member: (0, helpers_1.isSet)(object.member) ? exports.Member.fromJSON(object.member) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.groupId !== undefined && (obj.groupId = (message.groupId || helpers_1.Long.UZERO).toString());
        message.member !== undefined && (obj.member = message.member ? exports.Member.toJSON(message.member) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseGroupMember();
        message.groupId =
            object.groupId !== undefined && object.groupId !== null ? helpers_1.Long.fromValue(object.groupId) : helpers_1.Long.UZERO;
        message.member =
            object.member !== undefined && object.member !== null ? exports.Member.fromPartial(object.member) : undefined;
        return message;
    },
};
function createBaseGroupPolicyInfo() {
    return {
        address: "",
        groupId: helpers_1.Long.UZERO,
        admin: "",
        metadata: "",
        version: helpers_1.Long.UZERO,
        decisionPolicy: undefined,
        createdAt: undefined,
    };
}
exports.GroupPolicyInfo = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.address !== "") {
            writer.uint32(10).string(message.address);
        }
        if (!message.groupId.isZero()) {
            writer.uint32(16).uint64(message.groupId);
        }
        if (message.admin !== "") {
            writer.uint32(26).string(message.admin);
        }
        if (message.metadata !== "") {
            writer.uint32(34).string(message.metadata);
        }
        if (!message.version.isZero()) {
            writer.uint32(40).uint64(message.version);
        }
        if (message.decisionPolicy !== undefined) {
            any_1.Any.encode(message.decisionPolicy, writer.uint32(50).fork()).ldelim();
        }
        if (message.createdAt !== undefined) {
            timestamp_1.Timestamp.encode(message.createdAt, writer.uint32(58).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGroupPolicyInfo();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.groupId = reader.uint64();
                    break;
                case 3:
                    message.admin = reader.string();
                    break;
                case 4:
                    message.metadata = reader.string();
                    break;
                case 5:
                    message.version = reader.uint64();
                    break;
                case 6:
                    message.decisionPolicy = any_1.Any.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.createdAt = timestamp_1.Timestamp.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            address: (0, helpers_1.isSet)(object.address) ? String(object.address) : "",
            groupId: (0, helpers_1.isSet)(object.groupId) ? helpers_1.Long.fromValue(object.groupId) : helpers_1.Long.UZERO,
            admin: (0, helpers_1.isSet)(object.admin) ? String(object.admin) : "",
            metadata: (0, helpers_1.isSet)(object.metadata) ? String(object.metadata) : "",
            version: (0, helpers_1.isSet)(object.version) ? helpers_1.Long.fromValue(object.version) : helpers_1.Long.UZERO,
            decisionPolicy: (0, helpers_1.isSet)(object.decisionPolicy) ? any_1.Any.fromJSON(object.decisionPolicy) : undefined,
            createdAt: (0, helpers_1.isSet)(object.createdAt) ? (0, helpers_1.fromJsonTimestamp)(object.createdAt) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.groupId !== undefined && (obj.groupId = (message.groupId || helpers_1.Long.UZERO).toString());
        message.admin !== undefined && (obj.admin = message.admin);
        message.metadata !== undefined && (obj.metadata = message.metadata);
        message.version !== undefined && (obj.version = (message.version || helpers_1.Long.UZERO).toString());
        message.decisionPolicy !== undefined &&
            (obj.decisionPolicy = message.decisionPolicy ? any_1.Any.toJSON(message.decisionPolicy) : undefined);
        message.createdAt !== undefined && (obj.createdAt = (0, helpers_1.fromTimestamp)(message.createdAt).toISOString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseGroupPolicyInfo();
        message.address = object.address ?? "";
        message.groupId =
            object.groupId !== undefined && object.groupId !== null ? helpers_1.Long.fromValue(object.groupId) : helpers_1.Long.UZERO;
        message.admin = object.admin ?? "";
        message.metadata = object.metadata ?? "";
        message.version =
            object.version !== undefined && object.version !== null ? helpers_1.Long.fromValue(object.version) : helpers_1.Long.UZERO;
        message.decisionPolicy =
            object.decisionPolicy !== undefined && object.decisionPolicy !== null
                ? any_1.Any.fromPartial(object.decisionPolicy)
                : undefined;
        message.createdAt =
            object.createdAt !== undefined && object.createdAt !== null
                ? timestamp_1.Timestamp.fromPartial(object.createdAt)
                : undefined;
        return message;
    },
};
function createBaseProposal() {
    return {
        id: helpers_1.Long.UZERO,
        groupPolicyAddress: "",
        metadata: "",
        proposers: [],
        submitTime: undefined,
        groupVersion: helpers_1.Long.UZERO,
        groupPolicyVersion: helpers_1.Long.UZERO,
        status: 0,
        finalTallyResult: undefined,
        votingPeriodEnd: undefined,
        executorResult: 0,
        messages: [],
        title: "",
        summary: "",
    };
}
exports.Proposal = {
    encode(message, writer = _m0.Writer.create()) {
        if (!message.id.isZero()) {
            writer.uint32(8).uint64(message.id);
        }
        if (message.groupPolicyAddress !== "") {
            writer.uint32(18).string(message.groupPolicyAddress);
        }
        if (message.metadata !== "") {
            writer.uint32(26).string(message.metadata);
        }
        for (const v of message.proposers) {
            writer.uint32(34).string(v);
        }
        if (message.submitTime !== undefined) {
            timestamp_1.Timestamp.encode(message.submitTime, writer.uint32(42).fork()).ldelim();
        }
        if (!message.groupVersion.isZero()) {
            writer.uint32(48).uint64(message.groupVersion);
        }
        if (!message.groupPolicyVersion.isZero()) {
            writer.uint32(56).uint64(message.groupPolicyVersion);
        }
        if (message.status !== 0) {
            writer.uint32(64).int32(message.status);
        }
        if (message.finalTallyResult !== undefined) {
            exports.TallyResult.encode(message.finalTallyResult, writer.uint32(74).fork()).ldelim();
        }
        if (message.votingPeriodEnd !== undefined) {
            timestamp_1.Timestamp.encode(message.votingPeriodEnd, writer.uint32(82).fork()).ldelim();
        }
        if (message.executorResult !== 0) {
            writer.uint32(88).int32(message.executorResult);
        }
        for (const v of message.messages) {
            any_1.Any.encode(v, writer.uint32(98).fork()).ldelim();
        }
        if (message.title !== "") {
            writer.uint32(106).string(message.title);
        }
        if (message.summary !== "") {
            writer.uint32(114).string(message.summary);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseProposal();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.id = reader.uint64();
                    break;
                case 2:
                    message.groupPolicyAddress = reader.string();
                    break;
                case 3:
                    message.metadata = reader.string();
                    break;
                case 4:
                    message.proposers.push(reader.string());
                    break;
                case 5:
                    message.submitTime = timestamp_1.Timestamp.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.groupVersion = reader.uint64();
                    break;
                case 7:
                    message.groupPolicyVersion = reader.uint64();
                    break;
                case 8:
                    message.status = reader.int32();
                    break;
                case 9:
                    message.finalTallyResult = exports.TallyResult.decode(reader, reader.uint32());
                    break;
                case 10:
                    message.votingPeriodEnd = timestamp_1.Timestamp.decode(reader, reader.uint32());
                    break;
                case 11:
                    message.executorResult = reader.int32();
                    break;
                case 12:
                    message.messages.push(any_1.Any.decode(reader, reader.uint32()));
                    break;
                case 13:
                    message.title = reader.string();
                    break;
                case 14:
                    message.summary = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            id: (0, helpers_1.isSet)(object.id) ? helpers_1.Long.fromValue(object.id) : helpers_1.Long.UZERO,
            groupPolicyAddress: (0, helpers_1.isSet)(object.groupPolicyAddress) ? String(object.groupPolicyAddress) : "",
            metadata: (0, helpers_1.isSet)(object.metadata) ? String(object.metadata) : "",
            proposers: Array.isArray(object?.proposers) ? object.proposers.map((e) => String(e)) : [],
            submitTime: (0, helpers_1.isSet)(object.submitTime) ? (0, helpers_1.fromJsonTimestamp)(object.submitTime) : undefined,
            groupVersion: (0, helpers_1.isSet)(object.groupVersion) ? helpers_1.Long.fromValue(object.groupVersion) : helpers_1.Long.UZERO,
            groupPolicyVersion: (0, helpers_1.isSet)(object.groupPolicyVersion)
                ? helpers_1.Long.fromValue(object.groupPolicyVersion)
                : helpers_1.Long.UZERO,
            status: (0, helpers_1.isSet)(object.status) ? proposalStatusFromJSON(object.status) : 0,
            finalTallyResult: (0, helpers_1.isSet)(object.finalTallyResult)
                ? exports.TallyResult.fromJSON(object.finalTallyResult)
                : undefined,
            votingPeriodEnd: (0, helpers_1.isSet)(object.votingPeriodEnd) ? (0, helpers_1.fromJsonTimestamp)(object.votingPeriodEnd) : undefined,
            executorResult: (0, helpers_1.isSet)(object.executorResult)
                ? proposalExecutorResultFromJSON(object.executorResult)
                : 0,
            messages: Array.isArray(object?.messages) ? object.messages.map((e) => any_1.Any.fromJSON(e)) : [],
            title: (0, helpers_1.isSet)(object.title) ? String(object.title) : "",
            summary: (0, helpers_1.isSet)(object.summary) ? String(object.summary) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.id !== undefined && (obj.id = (message.id || helpers_1.Long.UZERO).toString());
        message.groupPolicyAddress !== undefined && (obj.groupPolicyAddress = message.groupPolicyAddress);
        message.metadata !== undefined && (obj.metadata = message.metadata);
        if (message.proposers) {
            obj.proposers = message.proposers.map((e) => e);
        }
        else {
            obj.proposers = [];
        }
        message.submitTime !== undefined && (obj.submitTime = (0, helpers_1.fromTimestamp)(message.submitTime).toISOString());
        message.groupVersion !== undefined &&
            (obj.groupVersion = (message.groupVersion || helpers_1.Long.UZERO).toString());
        message.groupPolicyVersion !== undefined &&
            (obj.groupPolicyVersion = (message.groupPolicyVersion || helpers_1.Long.UZERO).toString());
        message.status !== undefined && (obj.status = proposalStatusToJSON(message.status));
        message.finalTallyResult !== undefined &&
            (obj.finalTallyResult = message.finalTallyResult
                ? exports.TallyResult.toJSON(message.finalTallyResult)
                : undefined);
        message.votingPeriodEnd !== undefined &&
            (obj.votingPeriodEnd = (0, helpers_1.fromTimestamp)(message.votingPeriodEnd).toISOString());
        message.executorResult !== undefined &&
            (obj.executorResult = proposalExecutorResultToJSON(message.executorResult));
        if (message.messages) {
            obj.messages = message.messages.map((e) => (e ? any_1.Any.toJSON(e) : undefined));
        }
        else {
            obj.messages = [];
        }
        message.title !== undefined && (obj.title = message.title);
        message.summary !== undefined && (obj.summary = message.summary);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseProposal();
        message.id = object.id !== undefined && object.id !== null ? helpers_1.Long.fromValue(object.id) : helpers_1.Long.UZERO;
        message.groupPolicyAddress = object.groupPolicyAddress ?? "";
        message.metadata = object.metadata ?? "";
        message.proposers = object.proposers?.map((e) => e) || [];
        message.submitTime =
            object.submitTime !== undefined && object.submitTime !== null
                ? timestamp_1.Timestamp.fromPartial(object.submitTime)
                : undefined;
        message.groupVersion =
            object.groupVersion !== undefined && object.groupVersion !== null
                ? helpers_1.Long.fromValue(object.groupVersion)
                : helpers_1.Long.UZERO;
        message.groupPolicyVersion =
            object.groupPolicyVersion !== undefined && object.groupPolicyVersion !== null
                ? helpers_1.Long.fromValue(object.groupPolicyVersion)
                : helpers_1.Long.UZERO;
        message.status = object.status ?? 0;
        message.finalTallyResult =
            object.finalTallyResult !== undefined && object.finalTallyResult !== null
                ? exports.TallyResult.fromPartial(object.finalTallyResult)
                : undefined;
        message.votingPeriodEnd =
            object.votingPeriodEnd !== undefined && object.votingPeriodEnd !== null
                ? timestamp_1.Timestamp.fromPartial(object.votingPeriodEnd)
                : undefined;
        message.executorResult = object.executorResult ?? 0;
        message.messages = object.messages?.map((e) => any_1.Any.fromPartial(e)) || [];
        message.title = object.title ?? "";
        message.summary = object.summary ?? "";
        return message;
    },
};
function createBaseTallyResult() {
    return {
        yesCount: "",
        abstainCount: "",
        noCount: "",
        noWithVetoCount: "",
    };
}
exports.TallyResult = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.yesCount !== "") {
            writer.uint32(10).string(message.yesCount);
        }
        if (message.abstainCount !== "") {
            writer.uint32(18).string(message.abstainCount);
        }
        if (message.noCount !== "") {
            writer.uint32(26).string(message.noCount);
        }
        if (message.noWithVetoCount !== "") {
            writer.uint32(34).string(message.noWithVetoCount);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTallyResult();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.yesCount = reader.string();
                    break;
                case 2:
                    message.abstainCount = reader.string();
                    break;
                case 3:
                    message.noCount = reader.string();
                    break;
                case 4:
                    message.noWithVetoCount = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            yesCount: (0, helpers_1.isSet)(object.yesCount) ? String(object.yesCount) : "",
            abstainCount: (0, helpers_1.isSet)(object.abstainCount) ? String(object.abstainCount) : "",
            noCount: (0, helpers_1.isSet)(object.noCount) ? String(object.noCount) : "",
            noWithVetoCount: (0, helpers_1.isSet)(object.noWithVetoCount) ? String(object.noWithVetoCount) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.yesCount !== undefined && (obj.yesCount = message.yesCount);
        message.abstainCount !== undefined && (obj.abstainCount = message.abstainCount);
        message.noCount !== undefined && (obj.noCount = message.noCount);
        message.noWithVetoCount !== undefined && (obj.noWithVetoCount = message.noWithVetoCount);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseTallyResult();
        message.yesCount = object.yesCount ?? "";
        message.abstainCount = object.abstainCount ?? "";
        message.noCount = object.noCount ?? "";
        message.noWithVetoCount = object.noWithVetoCount ?? "";
        return message;
    },
};
function createBaseVote() {
    return {
        proposalId: helpers_1.Long.UZERO,
        voter: "",
        option: 0,
        metadata: "",
        submitTime: undefined,
    };
}
exports.Vote = {
    encode(message, writer = _m0.Writer.create()) {
        if (!message.proposalId.isZero()) {
            writer.uint32(8).uint64(message.proposalId);
        }
        if (message.voter !== "") {
            writer.uint32(18).string(message.voter);
        }
        if (message.option !== 0) {
            writer.uint32(24).int32(message.option);
        }
        if (message.metadata !== "") {
            writer.uint32(34).string(message.metadata);
        }
        if (message.submitTime !== undefined) {
            timestamp_1.Timestamp.encode(message.submitTime, writer.uint32(42).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVote();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.voter = reader.string();
                    break;
                case 3:
                    message.option = reader.int32();
                    break;
                case 4:
                    message.metadata = reader.string();
                    break;
                case 5:
                    message.submitTime = timestamp_1.Timestamp.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            proposalId: (0, helpers_1.isSet)(object.proposalId) ? helpers_1.Long.fromValue(object.proposalId) : helpers_1.Long.UZERO,
            voter: (0, helpers_1.isSet)(object.voter) ? String(object.voter) : "",
            option: (0, helpers_1.isSet)(object.option) ? voteOptionFromJSON(object.option) : 0,
            metadata: (0, helpers_1.isSet)(object.metadata) ? String(object.metadata) : "",
            submitTime: (0, helpers_1.isSet)(object.submitTime) ? (0, helpers_1.fromJsonTimestamp)(object.submitTime) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || helpers_1.Long.UZERO).toString());
        message.voter !== undefined && (obj.voter = message.voter);
        message.option !== undefined && (obj.option = voteOptionToJSON(message.option));
        message.metadata !== undefined && (obj.metadata = message.metadata);
        message.submitTime !== undefined && (obj.submitTime = (0, helpers_1.fromTimestamp)(message.submitTime).toISOString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseVote();
        message.proposalId =
            object.proposalId !== undefined && object.proposalId !== null
                ? helpers_1.Long.fromValue(object.proposalId)
                : helpers_1.Long.UZERO;
        message.voter = object.voter ?? "";
        message.option = object.option ?? 0;
        message.metadata = object.metadata ?? "";
        message.submitTime =
            object.submitTime !== undefined && object.submitTime !== null
                ? timestamp_1.Timestamp.fromPartial(object.submitTime)
                : undefined;
        return message;
    },
};
//# sourceMappingURL=types.js.map

/***/ }),

/***/ 9703:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CompressedNonExistenceProof = exports.CompressedExistenceProof = exports.CompressedBatchEntry = exports.CompressedBatchProof = exports.BatchEntry = exports.BatchProof = exports.InnerSpec = exports.ProofSpec = exports.InnerOp = exports.LeafOp = exports.CommitmentProof = exports.NonExistenceProof = exports.ExistenceProof = exports.lengthOpToJSON = exports.lengthOpFromJSON = exports.LengthOp = exports.hashOpToJSON = exports.hashOpFromJSON = exports.HashOp = exports.protobufPackage = void 0;
/* eslint-disable */
const _m0 = __importStar(__webpack_require__(62100));
const helpers_1 = __webpack_require__(92654);
exports.protobufPackage = "cosmos.ics23.v1";
var HashOp;
(function (HashOp) {
    /** NO_HASH - NO_HASH is the default if no data passed. Note this is an illegal argument some places. */
    HashOp[HashOp["NO_HASH"] = 0] = "NO_HASH";
    HashOp[HashOp["SHA256"] = 1] = "SHA256";
    HashOp[HashOp["SHA512"] = 2] = "SHA512";
    HashOp[HashOp["KECCAK"] = 3] = "KECCAK";
    HashOp[HashOp["RIPEMD160"] = 4] = "RIPEMD160";
    /** BITCOIN - ripemd160(sha256(x)) */
    HashOp[HashOp["BITCOIN"] = 5] = "BITCOIN";
    HashOp[HashOp["SHA512_256"] = 6] = "SHA512_256";
    HashOp[HashOp["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(HashOp = exports.HashOp || (exports.HashOp = {}));
function hashOpFromJSON(object) {
    switch (object) {
        case 0:
        case "NO_HASH":
            return HashOp.NO_HASH;
        case 1:
        case "SHA256":
            return HashOp.SHA256;
        case 2:
        case "SHA512":
            return HashOp.SHA512;
        case 3:
        case "KECCAK":
            return HashOp.KECCAK;
        case 4:
        case "RIPEMD160":
            return HashOp.RIPEMD160;
        case 5:
        case "BITCOIN":
            return HashOp.BITCOIN;
        case 6:
        case "SHA512_256":
            return HashOp.SHA512_256;
        case -1:
        case "UNRECOGNIZED":
        default:
            return HashOp.UNRECOGNIZED;
    }
}
exports.hashOpFromJSON = hashOpFromJSON;
function hashOpToJSON(object) {
    switch (object) {
        case HashOp.NO_HASH:
            return "NO_HASH";
        case HashOp.SHA256:
            return "SHA256";
        case HashOp.SHA512:
            return "SHA512";
        case HashOp.KECCAK:
            return "KECCAK";
        case HashOp.RIPEMD160:
            return "RIPEMD160";
        case HashOp.BITCOIN:
            return "BITCOIN";
        case HashOp.SHA512_256:
            return "SHA512_256";
        case HashOp.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.hashOpToJSON = hashOpToJSON;
/**
 * LengthOp defines how to process the key and value of the LeafOp
 * to include length information. After encoding the length with the given
 * algorithm, the length will be prepended to the key and value bytes.
 * (Each one with it's own encoded length)
 */
var LengthOp;
(function (LengthOp) {
    /** NO_PREFIX - NO_PREFIX don't include any length info */
    LengthOp[LengthOp["NO_PREFIX"] = 0] = "NO_PREFIX";
    /** VAR_PROTO - VAR_PROTO uses protobuf (and go-amino) varint encoding of the length */
    LengthOp[LengthOp["VAR_PROTO"] = 1] = "VAR_PROTO";
    /** VAR_RLP - VAR_RLP uses rlp int encoding of the length */
    LengthOp[LengthOp["VAR_RLP"] = 2] = "VAR_RLP";
    /** FIXED32_BIG - FIXED32_BIG uses big-endian encoding of the length as a 32 bit integer */
    LengthOp[LengthOp["FIXED32_BIG"] = 3] = "FIXED32_BIG";
    /** FIXED32_LITTLE - FIXED32_LITTLE uses little-endian encoding of the length as a 32 bit integer */
    LengthOp[LengthOp["FIXED32_LITTLE"] = 4] = "FIXED32_LITTLE";
    /** FIXED64_BIG - FIXED64_BIG uses big-endian encoding of the length as a 64 bit integer */
    LengthOp[LengthOp["FIXED64_BIG"] = 5] = "FIXED64_BIG";
    /** FIXED64_LITTLE - FIXED64_LITTLE uses little-endian encoding of the length as a 64 bit integer */
    LengthOp[LengthOp["FIXED64_LITTLE"] = 6] = "FIXED64_LITTLE";
    /** REQUIRE_32_BYTES - REQUIRE_32_BYTES is like NONE, but will fail if the input is not exactly 32 bytes (sha256 output) */
    LengthOp[LengthOp["REQUIRE_32_BYTES"] = 7] = "REQUIRE_32_BYTES";
    /** REQUIRE_64_BYTES - REQUIRE_64_BYTES is like NONE, but will fail if the input is not exactly 64 bytes (sha512 output) */
    LengthOp[LengthOp["REQUIRE_64_BYTES"] = 8] = "REQUIRE_64_BYTES";
    LengthOp[LengthOp["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(LengthOp = exports.LengthOp || (exports.LengthOp = {}));
function lengthOpFromJSON(object) {
    switch (object) {
        case 0:
        case "NO_PREFIX":
            return LengthOp.NO_PREFIX;
        case 1:
        case "VAR_PROTO":
            return LengthOp.VAR_PROTO;
        case 2:
        case "VAR_RLP":
            return LengthOp.VAR_RLP;
        case 3:
        case "FIXED32_BIG":
            return LengthOp.FIXED32_BIG;
        case 4:
        case "FIXED32_LITTLE":
            return LengthOp.FIXED32_LITTLE;
        case 5:
        case "FIXED64_BIG":
            return LengthOp.FIXED64_BIG;
        case 6:
        case "FIXED64_LITTLE":
            return LengthOp.FIXED64_LITTLE;
        case 7:
        case "REQUIRE_32_BYTES":
            return LengthOp.REQUIRE_32_BYTES;
        case 8:
        case "REQUIRE_64_BYTES":
            return LengthOp.REQUIRE_64_BYTES;
        case -1:
        case "UNRECOGNIZED":
        default:
            return LengthOp.UNRECOGNIZED;
    }
}
exports.lengthOpFromJSON = lengthOpFromJSON;
function lengthOpToJSON(object) {
    switch (object) {
        case LengthOp.NO_PREFIX:
            return "NO_PREFIX";
        case LengthOp.VAR_PROTO:
            return "VAR_PROTO";
        case LengthOp.VAR_RLP:
            return "VAR_RLP";
        case LengthOp.FIXED32_BIG:
            return "FIXED32_BIG";
        case LengthOp.FIXED32_LITTLE:
            return "FIXED32_LITTLE";
        case LengthOp.FIXED64_BIG:
            return "FIXED64_BIG";
        case LengthOp.FIXED64_LITTLE:
            return "FIXED64_LITTLE";
        case LengthOp.REQUIRE_32_BYTES:
            return "REQUIRE_32_BYTES";
        case LengthOp.REQUIRE_64_BYTES:
            return "REQUIRE_64_BYTES";
        case LengthOp.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.lengthOpToJSON = lengthOpToJSON;
function createBaseExistenceProof() {
    return {
        key: new Uint8Array(),
        value: new Uint8Array(),
        leaf: undefined,
        path: [],
    };
}
exports.ExistenceProof = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.key.length !== 0) {
            writer.uint32(10).bytes(message.key);
        }
        if (message.value.length !== 0) {
            writer.uint32(18).bytes(message.value);
        }
        if (message.leaf !== undefined) {
            exports.LeafOp.encode(message.leaf, writer.uint32(26).fork()).ldelim();
        }
        for (const v of message.path) {
            exports.InnerOp.encode(v, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseExistenceProof();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.key = reader.bytes();
                    break;
                case 2:
                    message.value = reader.bytes();
                    break;
                case 3:
                    message.leaf = exports.LeafOp.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.path.push(exports.InnerOp.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            key: (0, helpers_1.isSet)(object.key) ? (0, helpers_1.bytesFromBase64)(object.key) : new Uint8Array(),
            value: (0, helpers_1.isSet)(object.value) ? (0, helpers_1.bytesFromBase64)(object.value) : new Uint8Array(),
            leaf: (0, helpers_1.isSet)(object.leaf) ? exports.LeafOp.fromJSON(object.leaf) : undefined,
            path: Array.isArray(object?.path) ? object.path.map((e) => exports.InnerOp.fromJSON(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        message.key !== undefined &&
            (obj.key = (0, helpers_1.base64FromBytes)(message.key !== undefined ? message.key : new Uint8Array()));
        message.value !== undefined &&
            (obj.value = (0, helpers_1.base64FromBytes)(message.value !== undefined ? message.value : new Uint8Array()));
        message.leaf !== undefined && (obj.leaf = message.leaf ? exports.LeafOp.toJSON(message.leaf) : undefined);
        if (message.path) {
            obj.path = message.path.map((e) => (e ? exports.InnerOp.toJSON(e) : undefined));
        }
        else {
            obj.path = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseExistenceProof();
        message.key = object.key ?? new Uint8Array();
        message.value = object.value ?? new Uint8Array();
        message.leaf =
            object.leaf !== undefined && object.leaf !== null ? exports.LeafOp.fromPartial(object.leaf) : undefined;
        message.path = object.path?.map((e) => exports.InnerOp.fromPartial(e)) || [];
        return message;
    },
};
function createBaseNonExistenceProof() {
    return {
        key: new Uint8Array(),
        left: undefined,
        right: undefined,
    };
}
exports.NonExistenceProof = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.key.length !== 0) {
            writer.uint32(10).bytes(message.key);
        }
        if (message.left !== undefined) {
            exports.ExistenceProof.encode(message.left, writer.uint32(18).fork()).ldelim();
        }
        if (message.right !== undefined) {
            exports.ExistenceProof.encode(message.right, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseNonExistenceProof();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.key = reader.bytes();
                    break;
                case 2:
                    message.left = exports.ExistenceProof.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.right = exports.ExistenceProof.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            key: (0, helpers_1.isSet)(object.key) ? (0, helpers_1.bytesFromBase64)(object.key) : new Uint8Array(),
            left: (0, helpers_1.isSet)(object.left) ? exports.ExistenceProof.fromJSON(object.left) : undefined,
            right: (0, helpers_1.isSet)(object.right) ? exports.ExistenceProof.fromJSON(object.right) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.key !== undefined &&
            (obj.key = (0, helpers_1.base64FromBytes)(message.key !== undefined ? message.key : new Uint8Array()));
        message.left !== undefined && (obj.left = message.left ? exports.ExistenceProof.toJSON(message.left) : undefined);
        message.right !== undefined &&
            (obj.right = message.right ? exports.ExistenceProof.toJSON(message.right) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseNonExistenceProof();
        message.key = object.key ?? new Uint8Array();
        message.left =
            object.left !== undefined && object.left !== null ? exports.ExistenceProof.fromPartial(object.left) : undefined;
        message.right =
            object.right !== undefined && object.right !== null
                ? exports.ExistenceProof.fromPartial(object.right)
                : undefined;
        return message;
    },
};
function createBaseCommitmentProof() {
    return {
        exist: undefined,
        nonexist: undefined,
        batch: undefined,
        compressed: undefined,
    };
}
exports.CommitmentProof = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.exist !== undefined) {
            exports.ExistenceProof.encode(message.exist, writer.uint32(10).fork()).ldelim();
        }
        if (message.nonexist !== undefined) {
            exports.NonExistenceProof.encode(message.nonexist, writer.uint32(18).fork()).ldelim();
        }
        if (message.batch !== undefined) {
            exports.BatchProof.encode(message.batch, writer.uint32(26).fork()).ldelim();
        }
        if (message.compressed !== undefined) {
            exports.CompressedBatchProof.encode(message.compressed, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCommitmentProof();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.exist = exports.ExistenceProof.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.nonexist = exports.NonExistenceProof.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.batch = exports.BatchProof.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.compressed = exports.CompressedBatchProof.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            exist: (0, helpers_1.isSet)(object.exist) ? exports.ExistenceProof.fromJSON(object.exist) : undefined,
            nonexist: (0, helpers_1.isSet)(object.nonexist) ? exports.NonExistenceProof.fromJSON(object.nonexist) : undefined,
            batch: (0, helpers_1.isSet)(object.batch) ? exports.BatchProof.fromJSON(object.batch) : undefined,
            compressed: (0, helpers_1.isSet)(object.compressed) ? exports.CompressedBatchProof.fromJSON(object.compressed) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.exist !== undefined &&
            (obj.exist = message.exist ? exports.ExistenceProof.toJSON(message.exist) : undefined);
        message.nonexist !== undefined &&
            (obj.nonexist = message.nonexist ? exports.NonExistenceProof.toJSON(message.nonexist) : undefined);
        message.batch !== undefined && (obj.batch = message.batch ? exports.BatchProof.toJSON(message.batch) : undefined);
        message.compressed !== undefined &&
            (obj.compressed = message.compressed ? exports.CompressedBatchProof.toJSON(message.compressed) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseCommitmentProof();
        message.exist =
            object.exist !== undefined && object.exist !== null
                ? exports.ExistenceProof.fromPartial(object.exist)
                : undefined;
        message.nonexist =
            object.nonexist !== undefined && object.nonexist !== null
                ? exports.NonExistenceProof.fromPartial(object.nonexist)
                : undefined;
        message.batch =
            object.batch !== undefined && object.batch !== null ? exports.BatchProof.fromPartial(object.batch) : undefined;
        message.compressed =
            object.compressed !== undefined && object.compressed !== null
                ? exports.CompressedBatchProof.fromPartial(object.compressed)
                : undefined;
        return message;
    },
};
function createBaseLeafOp() {
    return {
        hash: 0,
        prehashKey: 0,
        prehashValue: 0,
        length: 0,
        prefix: new Uint8Array(),
    };
}
exports.LeafOp = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.hash !== 0) {
            writer.uint32(8).int32(message.hash);
        }
        if (message.prehashKey !== 0) {
            writer.uint32(16).int32(message.prehashKey);
        }
        if (message.prehashValue !== 0) {
            writer.uint32(24).int32(message.prehashValue);
        }
        if (message.length !== 0) {
            writer.uint32(32).int32(message.length);
        }
        if (message.prefix.length !== 0) {
            writer.uint32(42).bytes(message.prefix);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseLeafOp();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.hash = reader.int32();
                    break;
                case 2:
                    message.prehashKey = reader.int32();
                    break;
                case 3:
                    message.prehashValue = reader.int32();
                    break;
                case 4:
                    message.length = reader.int32();
                    break;
                case 5:
                    message.prefix = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            hash: (0, helpers_1.isSet)(object.hash) ? hashOpFromJSON(object.hash) : 0,
            prehashKey: (0, helpers_1.isSet)(object.prehashKey) ? hashOpFromJSON(object.prehashKey) : 0,
            prehashValue: (0, helpers_1.isSet)(object.prehashValue) ? hashOpFromJSON(object.prehashValue) : 0,
            length: (0, helpers_1.isSet)(object.length) ? lengthOpFromJSON(object.length) : 0,
            prefix: (0, helpers_1.isSet)(object.prefix) ? (0, helpers_1.bytesFromBase64)(object.prefix) : new Uint8Array(),
        };
    },
    toJSON(message) {
        const obj = {};
        message.hash !== undefined && (obj.hash = hashOpToJSON(message.hash));
        message.prehashKey !== undefined && (obj.prehashKey = hashOpToJSON(message.prehashKey));
        message.prehashValue !== undefined && (obj.prehashValue = hashOpToJSON(message.prehashValue));
        message.length !== undefined && (obj.length = lengthOpToJSON(message.length));
        message.prefix !== undefined &&
            (obj.prefix = (0, helpers_1.base64FromBytes)(message.prefix !== undefined ? message.prefix : new Uint8Array()));
        return obj;
    },
    fromPartial(object) {
        const message = createBaseLeafOp();
        message.hash = object.hash ?? 0;
        message.prehashKey = object.prehashKey ?? 0;
        message.prehashValue = object.prehashValue ?? 0;
        message.length = object.length ?? 0;
        message.prefix = object.prefix ?? new Uint8Array();
        return message;
    },
};
function createBaseInnerOp() {
    return {
        hash: 0,
        prefix: new Uint8Array(),
        suffix: new Uint8Array(),
    };
}
exports.InnerOp = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.hash !== 0) {
            writer.uint32(8).int32(message.hash);
        }
        if (message.prefix.length !== 0) {
            writer.uint32(18).bytes(message.prefix);
        }
        if (message.suffix.length !== 0) {
            writer.uint32(26).bytes(message.suffix);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseInnerOp();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.hash = reader.int32();
                    break;
                case 2:
                    message.prefix = reader.bytes();
                    break;
                case 3:
                    message.suffix = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            hash: (0, helpers_1.isSet)(object.hash) ? hashOpFromJSON(object.hash) : 0,
            prefix: (0, helpers_1.isSet)(object.prefix) ? (0, helpers_1.bytesFromBase64)(object.prefix) : new Uint8Array(),
            suffix: (0, helpers_1.isSet)(object.suffix) ? (0, helpers_1.bytesFromBase64)(object.suffix) : new Uint8Array(),
        };
    },
    toJSON(message) {
        const obj = {};
        message.hash !== undefined && (obj.hash = hashOpToJSON(message.hash));
        message.prefix !== undefined &&
            (obj.prefix = (0, helpers_1.base64FromBytes)(message.prefix !== undefined ? message.prefix : new Uint8Array()));
        message.suffix !== undefined &&
            (obj.suffix = (0, helpers_1.base64FromBytes)(message.suffix !== undefined ? message.suffix : new Uint8Array()));
        return obj;
    },
    fromPartial(object) {
        const message = createBaseInnerOp();
        message.hash = object.hash ?? 0;
        message.prefix = object.prefix ?? new Uint8Array();
        message.suffix = object.suffix ?? new Uint8Array();
        return message;
    },
};
function createBaseProofSpec() {
    return {
        leafSpec: undefined,
        innerSpec: undefined,
        maxDepth: 0,
        minDepth: 0,
    };
}
exports.ProofSpec = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.leafSpec !== undefined) {
            exports.LeafOp.encode(message.leafSpec, writer.uint32(10).fork()).ldelim();
        }
        if (message.innerSpec !== undefined) {
            exports.InnerSpec.encode(message.innerSpec, writer.uint32(18).fork()).ldelim();
        }
        if (message.maxDepth !== 0) {
            writer.uint32(24).int32(message.maxDepth);
        }
        if (message.minDepth !== 0) {
            writer.uint32(32).int32(message.minDepth);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseProofSpec();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.leafSpec = exports.LeafOp.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.innerSpec = exports.InnerSpec.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.maxDepth = reader.int32();
                    break;
                case 4:
                    message.minDepth = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            leafSpec: (0, helpers_1.isSet)(object.leafSpec) ? exports.LeafOp.fromJSON(object.leafSpec) : undefined,
            innerSpec: (0, helpers_1.isSet)(object.innerSpec) ? exports.InnerSpec.fromJSON(object.innerSpec) : undefined,
            maxDepth: (0, helpers_1.isSet)(object.maxDepth) ? Number(object.maxDepth) : 0,
            minDepth: (0, helpers_1.isSet)(object.minDepth) ? Number(object.minDepth) : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        message.leafSpec !== undefined &&
            (obj.leafSpec = message.leafSpec ? exports.LeafOp.toJSON(message.leafSpec) : undefined);
        message.innerSpec !== undefined &&
            (obj.innerSpec = message.innerSpec ? exports.InnerSpec.toJSON(message.innerSpec) : undefined);
        message.maxDepth !== undefined && (obj.maxDepth = Math.round(message.maxDepth));
        message.minDepth !== undefined && (obj.minDepth = Math.round(message.minDepth));
        return obj;
    },
    fromPartial(object) {
        const message = createBaseProofSpec();
        message.leafSpec =
            object.leafSpec !== undefined && object.leafSpec !== null
                ? exports.LeafOp.fromPartial(object.leafSpec)
                : undefined;
        message.innerSpec =
            object.innerSpec !== undefined && object.innerSpec !== null
                ? exports.InnerSpec.fromPartial(object.innerSpec)
                : undefined;
        message.maxDepth = object.maxDepth ?? 0;
        message.minDepth = object.minDepth ?? 0;
        return message;
    },
};
function createBaseInnerSpec() {
    return {
        childOrder: [],
        childSize: 0,
        minPrefixLength: 0,
        maxPrefixLength: 0,
        emptyChild: new Uint8Array(),
        hash: 0,
    };
}
exports.InnerSpec = {
    encode(message, writer = _m0.Writer.create()) {
        writer.uint32(10).fork();
        for (const v of message.childOrder) {
            writer.int32(v);
        }
        writer.ldelim();
        if (message.childSize !== 0) {
            writer.uint32(16).int32(message.childSize);
        }
        if (message.minPrefixLength !== 0) {
            writer.uint32(24).int32(message.minPrefixLength);
        }
        if (message.maxPrefixLength !== 0) {
            writer.uint32(32).int32(message.maxPrefixLength);
        }
        if (message.emptyChild.length !== 0) {
            writer.uint32(42).bytes(message.emptyChild);
        }
        if (message.hash !== 0) {
            writer.uint32(48).int32(message.hash);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseInnerSpec();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if ((tag & 7) === 2) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.childOrder.push(reader.int32());
                        }
                    }
                    else {
                        message.childOrder.push(reader.int32());
                    }
                    break;
                case 2:
                    message.childSize = reader.int32();
                    break;
                case 3:
                    message.minPrefixLength = reader.int32();
                    break;
                case 4:
                    message.maxPrefixLength = reader.int32();
                    break;
                case 5:
                    message.emptyChild = reader.bytes();
                    break;
                case 6:
                    message.hash = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            childOrder: Array.isArray(object?.childOrder) ? object.childOrder.map((e) => Number(e)) : [],
            childSize: (0, helpers_1.isSet)(object.childSize) ? Number(object.childSize) : 0,
            minPrefixLength: (0, helpers_1.isSet)(object.minPrefixLength) ? Number(object.minPrefixLength) : 0,
            maxPrefixLength: (0, helpers_1.isSet)(object.maxPrefixLength) ? Number(object.maxPrefixLength) : 0,
            emptyChild: (0, helpers_1.isSet)(object.emptyChild) ? (0, helpers_1.bytesFromBase64)(object.emptyChild) : new Uint8Array(),
            hash: (0, helpers_1.isSet)(object.hash) ? hashOpFromJSON(object.hash) : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.childOrder) {
            obj.childOrder = message.childOrder.map((e) => Math.round(e));
        }
        else {
            obj.childOrder = [];
        }
        message.childSize !== undefined && (obj.childSize = Math.round(message.childSize));
        message.minPrefixLength !== undefined && (obj.minPrefixLength = Math.round(message.minPrefixLength));
        message.maxPrefixLength !== undefined && (obj.maxPrefixLength = Math.round(message.maxPrefixLength));
        message.emptyChild !== undefined &&
            (obj.emptyChild = (0, helpers_1.base64FromBytes)(message.emptyChild !== undefined ? message.emptyChild : new Uint8Array()));
        message.hash !== undefined && (obj.hash = hashOpToJSON(message.hash));
        return obj;
    },
    fromPartial(object) {
        const message = createBaseInnerSpec();
        message.childOrder = object.childOrder?.map((e) => e) || [];
        message.childSize = object.childSize ?? 0;
        message.minPrefixLength = object.minPrefixLength ?? 0;
        message.maxPrefixLength = object.maxPrefixLength ?? 0;
        message.emptyChild = object.emptyChild ?? new Uint8Array();
        message.hash = object.hash ?? 0;
        return message;
    },
};
function createBaseBatchProof() {
    return {
        entries: [],
    };
}
exports.BatchProof = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.entries) {
            exports.BatchEntry.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseBatchProof();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.entries.push(exports.BatchEntry.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            entries: Array.isArray(object?.entries) ? object.entries.map((e) => exports.BatchEntry.fromJSON(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.entries) {
            obj.entries = message.entries.map((e) => (e ? exports.BatchEntry.toJSON(e) : undefined));
        }
        else {
            obj.entries = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseBatchProof();
        message.entries = object.entries?.map((e) => exports.BatchEntry.fromPartial(e)) || [];
        return message;
    },
};
function createBaseBatchEntry() {
    return {
        exist: undefined,
        nonexist: undefined,
    };
}
exports.BatchEntry = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.exist !== undefined) {
            exports.ExistenceProof.encode(message.exist, writer.uint32(10).fork()).ldelim();
        }
        if (message.nonexist !== undefined) {
            exports.NonExistenceProof.encode(message.nonexist, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseBatchEntry();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.exist = exports.ExistenceProof.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.nonexist = exports.NonExistenceProof.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            exist: (0, helpers_1.isSet)(object.exist) ? exports.ExistenceProof.fromJSON(object.exist) : undefined,
            nonexist: (0, helpers_1.isSet)(object.nonexist) ? exports.NonExistenceProof.fromJSON(object.nonexist) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.exist !== undefined &&
            (obj.exist = message.exist ? exports.ExistenceProof.toJSON(message.exist) : undefined);
        message.nonexist !== undefined &&
            (obj.nonexist = message.nonexist ? exports.NonExistenceProof.toJSON(message.nonexist) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseBatchEntry();
        message.exist =
            object.exist !== undefined && object.exist !== null
                ? exports.ExistenceProof.fromPartial(object.exist)
                : undefined;
        message.nonexist =
            object.nonexist !== undefined && object.nonexist !== null
                ? exports.NonExistenceProof.fromPartial(object.nonexist)
                : undefined;
        return message;
    },
};
function createBaseCompressedBatchProof() {
    return {
        entries: [],
        lookupInners: [],
    };
}
exports.CompressedBatchProof = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.entries) {
            exports.CompressedBatchEntry.encode(v, writer.uint32(10).fork()).ldelim();
        }
        for (const v of message.lookupInners) {
            exports.InnerOp.encode(v, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCompressedBatchProof();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.entries.push(exports.CompressedBatchEntry.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.lookupInners.push(exports.InnerOp.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            entries: Array.isArray(object?.entries)
                ? object.entries.map((e) => exports.CompressedBatchEntry.fromJSON(e))
                : [],
            lookupInners: Array.isArray(object?.lookupInners)
                ? object.lookupInners.map((e) => exports.InnerOp.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.entries) {
            obj.entries = message.entries.map((e) => (e ? exports.CompressedBatchEntry.toJSON(e) : undefined));
        }
        else {
            obj.entries = [];
        }
        if (message.lookupInners) {
            obj.lookupInners = message.lookupInners.map((e) => (e ? exports.InnerOp.toJSON(e) : undefined));
        }
        else {
            obj.lookupInners = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseCompressedBatchProof();
        message.entries = object.entries?.map((e) => exports.CompressedBatchEntry.fromPartial(e)) || [];
        message.lookupInners = object.lookupInners?.map((e) => exports.InnerOp.fromPartial(e)) || [];
        return message;
    },
};
function createBaseCompressedBatchEntry() {
    return {
        exist: undefined,
        nonexist: undefined,
    };
}
exports.CompressedBatchEntry = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.exist !== undefined) {
            exports.CompressedExistenceProof.encode(message.exist, writer.uint32(10).fork()).ldelim();
        }
        if (message.nonexist !== undefined) {
            exports.CompressedNonExistenceProof.encode(message.nonexist, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCompressedBatchEntry();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.exist = exports.CompressedExistenceProof.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.nonexist = exports.CompressedNonExistenceProof.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            exist: (0, helpers_1.isSet)(object.exist) ? exports.CompressedExistenceProof.fromJSON(object.exist) : undefined,
            nonexist: (0, helpers_1.isSet)(object.nonexist) ? exports.CompressedNonExistenceProof.fromJSON(object.nonexist) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.exist !== undefined &&
            (obj.exist = message.exist ? exports.CompressedExistenceProof.toJSON(message.exist) : undefined);
        message.nonexist !== undefined &&
            (obj.nonexist = message.nonexist ? exports.CompressedNonExistenceProof.toJSON(message.nonexist) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseCompressedBatchEntry();
        message.exist =
            object.exist !== undefined && object.exist !== null
                ? exports.CompressedExistenceProof.fromPartial(object.exist)
                : undefined;
        message.nonexist =
            object.nonexist !== undefined && object.nonexist !== null
                ? exports.CompressedNonExistenceProof.fromPartial(object.nonexist)
                : undefined;
        return message;
    },
};
function createBaseCompressedExistenceProof() {
    return {
        key: new Uint8Array(),
        value: new Uint8Array(),
        leaf: undefined,
        path: [],
    };
}
exports.CompressedExistenceProof = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.key.length !== 0) {
            writer.uint32(10).bytes(message.key);
        }
        if (message.value.length !== 0) {
            writer.uint32(18).bytes(message.value);
        }
        if (message.leaf !== undefined) {
            exports.LeafOp.encode(message.leaf, writer.uint32(26).fork()).ldelim();
        }
        writer.uint32(34).fork();
        for (const v of message.path) {
            writer.int32(v);
        }
        writer.ldelim();
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCompressedExistenceProof();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.key = reader.bytes();
                    break;
                case 2:
                    message.value = reader.bytes();
                    break;
                case 3:
                    message.leaf = exports.LeafOp.decode(reader, reader.uint32());
                    break;
                case 4:
                    if ((tag & 7) === 2) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.path.push(reader.int32());
                        }
                    }
                    else {
                        message.path.push(reader.int32());
                    }
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            key: (0, helpers_1.isSet)(object.key) ? (0, helpers_1.bytesFromBase64)(object.key) : new Uint8Array(),
            value: (0, helpers_1.isSet)(object.value) ? (0, helpers_1.bytesFromBase64)(object.value) : new Uint8Array(),
            leaf: (0, helpers_1.isSet)(object.leaf) ? exports.LeafOp.fromJSON(object.leaf) : undefined,
            path: Array.isArray(object?.path) ? object.path.map((e) => Number(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        message.key !== undefined &&
            (obj.key = (0, helpers_1.base64FromBytes)(message.key !== undefined ? message.key : new Uint8Array()));
        message.value !== undefined &&
            (obj.value = (0, helpers_1.base64FromBytes)(message.value !== undefined ? message.value : new Uint8Array()));
        message.leaf !== undefined && (obj.leaf = message.leaf ? exports.LeafOp.toJSON(message.leaf) : undefined);
        if (message.path) {
            obj.path = message.path.map((e) => Math.round(e));
        }
        else {
            obj.path = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseCompressedExistenceProof();
        message.key = object.key ?? new Uint8Array();
        message.value = object.value ?? new Uint8Array();
        message.leaf =
            object.leaf !== undefined && object.leaf !== null ? exports.LeafOp.fromPartial(object.leaf) : undefined;
        message.path = object.path?.map((e) => e) || [];
        return message;
    },
};
function createBaseCompressedNonExistenceProof() {
    return {
        key: new Uint8Array(),
        left: undefined,
        right: undefined,
    };
}
exports.CompressedNonExistenceProof = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.key.length !== 0) {
            writer.uint32(10).bytes(message.key);
        }
        if (message.left !== undefined) {
            exports.CompressedExistenceProof.encode(message.left, writer.uint32(18).fork()).ldelim();
        }
        if (message.right !== undefined) {
            exports.CompressedExistenceProof.encode(message.right, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCompressedNonExistenceProof();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.key = reader.bytes();
                    break;
                case 2:
                    message.left = exports.CompressedExistenceProof.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.right = exports.CompressedExistenceProof.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            key: (0, helpers_1.isSet)(object.key) ? (0, helpers_1.bytesFromBase64)(object.key) : new Uint8Array(),
            left: (0, helpers_1.isSet)(object.left) ? exports.CompressedExistenceProof.fromJSON(object.left) : undefined,
            right: (0, helpers_1.isSet)(object.right) ? exports.CompressedExistenceProof.fromJSON(object.right) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.key !== undefined &&
            (obj.key = (0, helpers_1.base64FromBytes)(message.key !== undefined ? message.key : new Uint8Array()));
        message.left !== undefined &&
            (obj.left = message.left ? exports.CompressedExistenceProof.toJSON(message.left) : undefined);
        message.right !== undefined &&
            (obj.right = message.right ? exports.CompressedExistenceProof.toJSON(message.right) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseCompressedNonExistenceProof();
        message.key = object.key ?? new Uint8Array();
        message.left =
            object.left !== undefined && object.left !== null
                ? exports.CompressedExistenceProof.fromPartial(object.left)
                : undefined;
        message.right =
            object.right !== undefined && object.right !== null
                ? exports.CompressedExistenceProof.fromPartial(object.right)
                : undefined;
        return message;
    },
};
//# sourceMappingURL=proofs.js.map

/***/ }),

/***/ 81270:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Params = exports.Minter = exports.protobufPackage = void 0;
/* eslint-disable */
const helpers_1 = __webpack_require__(92654);
const _m0 = __importStar(__webpack_require__(62100));
exports.protobufPackage = "cosmos.mint.v1beta1";
function createBaseMinter() {
    return {
        inflation: "",
        annualProvisions: "",
    };
}
exports.Minter = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.inflation !== "") {
            writer.uint32(10).string(message.inflation);
        }
        if (message.annualProvisions !== "") {
            writer.uint32(18).string(message.annualProvisions);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMinter();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.inflation = reader.string();
                    break;
                case 2:
                    message.annualProvisions = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            inflation: (0, helpers_1.isSet)(object.inflation) ? String(object.inflation) : "",
            annualProvisions: (0, helpers_1.isSet)(object.annualProvisions) ? String(object.annualProvisions) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.inflation !== undefined && (obj.inflation = message.inflation);
        message.annualProvisions !== undefined && (obj.annualProvisions = message.annualProvisions);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMinter();
        message.inflation = object.inflation ?? "";
        message.annualProvisions = object.annualProvisions ?? "";
        return message;
    },
};
function createBaseParams() {
    return {
        mintDenom: "",
        inflationRateChange: "",
        inflationMax: "",
        inflationMin: "",
        goalBonded: "",
        blocksPerYear: helpers_1.Long.UZERO,
    };
}
exports.Params = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.mintDenom !== "") {
            writer.uint32(10).string(message.mintDenom);
        }
        if (message.inflationRateChange !== "") {
            writer.uint32(18).string(message.inflationRateChange);
        }
        if (message.inflationMax !== "") {
            writer.uint32(26).string(message.inflationMax);
        }
        if (message.inflationMin !== "") {
            writer.uint32(34).string(message.inflationMin);
        }
        if (message.goalBonded !== "") {
            writer.uint32(42).string(message.goalBonded);
        }
        if (!message.blocksPerYear.isZero()) {
            writer.uint32(48).uint64(message.blocksPerYear);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseParams();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.mintDenom = reader.string();
                    break;
                case 2:
                    message.inflationRateChange = reader.string();
                    break;
                case 3:
                    message.inflationMax = reader.string();
                    break;
                case 4:
                    message.inflationMin = reader.string();
                    break;
                case 5:
                    message.goalBonded = reader.string();
                    break;
                case 6:
                    message.blocksPerYear = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            mintDenom: (0, helpers_1.isSet)(object.mintDenom) ? String(object.mintDenom) : "",
            inflationRateChange: (0, helpers_1.isSet)(object.inflationRateChange) ? String(object.inflationRateChange) : "",
            inflationMax: (0, helpers_1.isSet)(object.inflationMax) ? String(object.inflationMax) : "",
            inflationMin: (0, helpers_1.isSet)(object.inflationMin) ? String(object.inflationMin) : "",
            goalBonded: (0, helpers_1.isSet)(object.goalBonded) ? String(object.goalBonded) : "",
            blocksPerYear: (0, helpers_1.isSet)(object.blocksPerYear) ? helpers_1.Long.fromValue(object.blocksPerYear) : helpers_1.Long.UZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        message.mintDenom !== undefined && (obj.mintDenom = message.mintDenom);
        message.inflationRateChange !== undefined && (obj.inflationRateChange = message.inflationRateChange);
        message.inflationMax !== undefined && (obj.inflationMax = message.inflationMax);
        message.inflationMin !== undefined && (obj.inflationMin = message.inflationMin);
        message.goalBonded !== undefined && (obj.goalBonded = message.goalBonded);
        message.blocksPerYear !== undefined &&
            (obj.blocksPerYear = (message.blocksPerYear || helpers_1.Long.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseParams();
        message.mintDenom = object.mintDenom ?? "";
        message.inflationRateChange = object.inflationRateChange ?? "";
        message.inflationMax = object.inflationMax ?? "";
        message.inflationMin = object.inflationMin ?? "";
        message.goalBonded = object.goalBonded ?? "";
        message.blocksPerYear =
            object.blocksPerYear !== undefined && object.blocksPerYear !== null
                ? helpers_1.Long.fromValue(object.blocksPerYear)
                : helpers_1.Long.UZERO;
        return message;
    },
};
//# sourceMappingURL=mint.js.map

/***/ }),

/***/ 84586:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.QueryClientImpl = exports.QueryAnnualProvisionsResponse = exports.QueryAnnualProvisionsRequest = exports.QueryInflationResponse = exports.QueryInflationRequest = exports.QueryParamsResponse = exports.QueryParamsRequest = exports.protobufPackage = void 0;
/* eslint-disable */
const mint_1 = __webpack_require__(81270);
const _m0 = __importStar(__webpack_require__(62100));
const helpers_1 = __webpack_require__(92654);
exports.protobufPackage = "cosmos.mint.v1beta1";
function createBaseQueryParamsRequest() {
    return {};
}
exports.QueryParamsRequest = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryParamsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseQueryParamsRequest();
        return message;
    },
};
function createBaseQueryParamsResponse() {
    return {
        params: undefined,
    };
}
exports.QueryParamsResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.params !== undefined) {
            mint_1.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryParamsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.params = mint_1.Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            params: (0, helpers_1.isSet)(object.params) ? mint_1.Params.fromJSON(object.params) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.params !== undefined && (obj.params = message.params ? mint_1.Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryParamsResponse();
        message.params =
            object.params !== undefined && object.params !== null ? mint_1.Params.fromPartial(object.params) : undefined;
        return message;
    },
};
function createBaseQueryInflationRequest() {
    return {};
}
exports.QueryInflationRequest = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryInflationRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseQueryInflationRequest();
        return message;
    },
};
function createBaseQueryInflationResponse() {
    return {
        inflation: new Uint8Array(),
    };
}
exports.QueryInflationResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.inflation.length !== 0) {
            writer.uint32(10).bytes(message.inflation);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryInflationResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.inflation = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            inflation: (0, helpers_1.isSet)(object.inflation) ? (0, helpers_1.bytesFromBase64)(object.inflation) : new Uint8Array(),
        };
    },
    toJSON(message) {
        const obj = {};
        message.inflation !== undefined &&
            (obj.inflation = (0, helpers_1.base64FromBytes)(message.inflation !== undefined ? message.inflation : new Uint8Array()));
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryInflationResponse();
        message.inflation = object.inflation ?? new Uint8Array();
        return message;
    },
};
function createBaseQueryAnnualProvisionsRequest() {
    return {};
}
exports.QueryAnnualProvisionsRequest = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryAnnualProvisionsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseQueryAnnualProvisionsRequest();
        return message;
    },
};
function createBaseQueryAnnualProvisionsResponse() {
    return {
        annualProvisions: new Uint8Array(),
    };
}
exports.QueryAnnualProvisionsResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.annualProvisions.length !== 0) {
            writer.uint32(10).bytes(message.annualProvisions);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryAnnualProvisionsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.annualProvisions = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            annualProvisions: (0, helpers_1.isSet)(object.annualProvisions)
                ? (0, helpers_1.bytesFromBase64)(object.annualProvisions)
                : new Uint8Array(),
        };
    },
    toJSON(message) {
        const obj = {};
        message.annualProvisions !== undefined &&
            (obj.annualProvisions = (0, helpers_1.base64FromBytes)(message.annualProvisions !== undefined ? message.annualProvisions : new Uint8Array()));
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryAnnualProvisionsResponse();
        message.annualProvisions = object.annualProvisions ?? new Uint8Array();
        return message;
    },
};
class QueryClientImpl {
    constructor(rpc) {
        this.rpc = rpc;
        this.Params = this.Params.bind(this);
        this.Inflation = this.Inflation.bind(this);
        this.AnnualProvisions = this.AnnualProvisions.bind(this);
    }
    Params(request = {}) {
        const data = exports.QueryParamsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.mint.v1beta1.Query", "Params", data);
        return promise.then((data) => exports.QueryParamsResponse.decode(new _m0.Reader(data)));
    }
    Inflation(request = {}) {
        const data = exports.QueryInflationRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.mint.v1beta1.Query", "Inflation", data);
        return promise.then((data) => exports.QueryInflationResponse.decode(new _m0.Reader(data)));
    }
    AnnualProvisions(request = {}) {
        const data = exports.QueryAnnualProvisionsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.mint.v1beta1.Query", "AnnualProvisions", data);
        return promise.then((data) => exports.QueryAnnualProvisionsResponse.decode(new _m0.Reader(data)));
    }
}
exports.QueryClientImpl = QueryClientImpl;
//# sourceMappingURL=query.js.map

/***/ }),

/***/ 3123:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ParamChange = exports.ParameterChangeProposal = exports.protobufPackage = void 0;
/* eslint-disable */
const _m0 = __importStar(__webpack_require__(62100));
const helpers_1 = __webpack_require__(92654);
exports.protobufPackage = "cosmos.params.v1beta1";
function createBaseParameterChangeProposal() {
    return {
        title: "",
        description: "",
        changes: [],
    };
}
exports.ParameterChangeProposal = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.title !== "") {
            writer.uint32(10).string(message.title);
        }
        if (message.description !== "") {
            writer.uint32(18).string(message.description);
        }
        for (const v of message.changes) {
            exports.ParamChange.encode(v, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseParameterChangeProposal();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.title = reader.string();
                    break;
                case 2:
                    message.description = reader.string();
                    break;
                case 3:
                    message.changes.push(exports.ParamChange.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            title: (0, helpers_1.isSet)(object.title) ? String(object.title) : "",
            description: (0, helpers_1.isSet)(object.description) ? String(object.description) : "",
            changes: Array.isArray(object?.changes) ? object.changes.map((e) => exports.ParamChange.fromJSON(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        message.title !== undefined && (obj.title = message.title);
        message.description !== undefined && (obj.description = message.description);
        if (message.changes) {
            obj.changes = message.changes.map((e) => (e ? exports.ParamChange.toJSON(e) : undefined));
        }
        else {
            obj.changes = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseParameterChangeProposal();
        message.title = object.title ?? "";
        message.description = object.description ?? "";
        message.changes = object.changes?.map((e) => exports.ParamChange.fromPartial(e)) || [];
        return message;
    },
};
function createBaseParamChange() {
    return {
        subspace: "",
        key: "",
        value: "",
    };
}
exports.ParamChange = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.subspace !== "") {
            writer.uint32(10).string(message.subspace);
        }
        if (message.key !== "") {
            writer.uint32(18).string(message.key);
        }
        if (message.value !== "") {
            writer.uint32(26).string(message.value);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseParamChange();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.subspace = reader.string();
                    break;
                case 2:
                    message.key = reader.string();
                    break;
                case 3:
                    message.value = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            subspace: (0, helpers_1.isSet)(object.subspace) ? String(object.subspace) : "",
            key: (0, helpers_1.isSet)(object.key) ? String(object.key) : "",
            value: (0, helpers_1.isSet)(object.value) ? String(object.value) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.subspace !== undefined && (obj.subspace = message.subspace);
        message.key !== undefined && (obj.key = message.key);
        message.value !== undefined && (obj.value = message.value);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseParamChange();
        message.subspace = object.subspace ?? "";
        message.key = object.key ?? "";
        message.value = object.value ?? "";
        return message;
    },
};
//# sourceMappingURL=params.js.map

/***/ }),

/***/ 38935:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.QueryClientImpl = exports.QuerySigningInfosResponse = exports.QuerySigningInfosRequest = exports.QuerySigningInfoResponse = exports.QuerySigningInfoRequest = exports.QueryParamsResponse = exports.QueryParamsRequest = exports.protobufPackage = void 0;
/* eslint-disable */
const pagination_1 = __webpack_require__(84043);
const slashing_1 = __webpack_require__(9798);
const _m0 = __importStar(__webpack_require__(62100));
const helpers_1 = __webpack_require__(92654);
exports.protobufPackage = "cosmos.slashing.v1beta1";
function createBaseQueryParamsRequest() {
    return {};
}
exports.QueryParamsRequest = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryParamsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseQueryParamsRequest();
        return message;
    },
};
function createBaseQueryParamsResponse() {
    return {
        params: undefined,
    };
}
exports.QueryParamsResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.params !== undefined) {
            slashing_1.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryParamsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.params = slashing_1.Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            params: (0, helpers_1.isSet)(object.params) ? slashing_1.Params.fromJSON(object.params) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.params !== undefined && (obj.params = message.params ? slashing_1.Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryParamsResponse();
        message.params =
            object.params !== undefined && object.params !== null ? slashing_1.Params.fromPartial(object.params) : undefined;
        return message;
    },
};
function createBaseQuerySigningInfoRequest() {
    return {
        consAddress: "",
    };
}
exports.QuerySigningInfoRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.consAddress !== "") {
            writer.uint32(10).string(message.consAddress);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQuerySigningInfoRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.consAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            consAddress: (0, helpers_1.isSet)(object.consAddress) ? String(object.consAddress) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.consAddress !== undefined && (obj.consAddress = message.consAddress);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQuerySigningInfoRequest();
        message.consAddress = object.consAddress ?? "";
        return message;
    },
};
function createBaseQuerySigningInfoResponse() {
    return {
        valSigningInfo: undefined,
    };
}
exports.QuerySigningInfoResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.valSigningInfo !== undefined) {
            slashing_1.ValidatorSigningInfo.encode(message.valSigningInfo, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQuerySigningInfoResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.valSigningInfo = slashing_1.ValidatorSigningInfo.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            valSigningInfo: (0, helpers_1.isSet)(object.valSigningInfo)
                ? slashing_1.ValidatorSigningInfo.fromJSON(object.valSigningInfo)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.valSigningInfo !== undefined &&
            (obj.valSigningInfo = message.valSigningInfo
                ? slashing_1.ValidatorSigningInfo.toJSON(message.valSigningInfo)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQuerySigningInfoResponse();
        message.valSigningInfo =
            object.valSigningInfo !== undefined && object.valSigningInfo !== null
                ? slashing_1.ValidatorSigningInfo.fromPartial(object.valSigningInfo)
                : undefined;
        return message;
    },
};
function createBaseQuerySigningInfosRequest() {
    return {
        pagination: undefined,
    };
}
exports.QuerySigningInfosRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQuerySigningInfosRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            pagination: (0, helpers_1.isSet)(object.pagination) ? pagination_1.PageRequest.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQuerySigningInfosRequest();
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQuerySigningInfosResponse() {
    return {
        info: [],
        pagination: undefined,
    };
}
exports.QuerySigningInfosResponse = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.info) {
            slashing_1.ValidatorSigningInfo.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQuerySigningInfosResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.info.push(slashing_1.ValidatorSigningInfo.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            info: Array.isArray(object?.info) ? object.info.map((e) => slashing_1.ValidatorSigningInfo.fromJSON(e)) : [],
            pagination: (0, helpers_1.isSet)(object.pagination) ? pagination_1.PageResponse.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.info) {
            obj.info = message.info.map((e) => (e ? slashing_1.ValidatorSigningInfo.toJSON(e) : undefined));
        }
        else {
            obj.info = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQuerySigningInfosResponse();
        message.info = object.info?.map((e) => slashing_1.ValidatorSigningInfo.fromPartial(e)) || [];
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
class QueryClientImpl {
    constructor(rpc) {
        this.rpc = rpc;
        this.Params = this.Params.bind(this);
        this.SigningInfo = this.SigningInfo.bind(this);
        this.SigningInfos = this.SigningInfos.bind(this);
    }
    Params(request = {}) {
        const data = exports.QueryParamsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.slashing.v1beta1.Query", "Params", data);
        return promise.then((data) => exports.QueryParamsResponse.decode(new _m0.Reader(data)));
    }
    SigningInfo(request) {
        const data = exports.QuerySigningInfoRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.slashing.v1beta1.Query", "SigningInfo", data);
        return promise.then((data) => exports.QuerySigningInfoResponse.decode(new _m0.Reader(data)));
    }
    SigningInfos(request = {
        pagination: undefined,
    }) {
        const data = exports.QuerySigningInfosRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.slashing.v1beta1.Query", "SigningInfos", data);
        return promise.then((data) => exports.QuerySigningInfosResponse.decode(new _m0.Reader(data)));
    }
}
exports.QueryClientImpl = QueryClientImpl;
//# sourceMappingURL=query.js.map

/***/ }),

/***/ 9798:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Params = exports.ValidatorSigningInfo = exports.protobufPackage = void 0;
/* eslint-disable */
const timestamp_1 = __webpack_require__(70147);
const duration_1 = __webpack_require__(9591);
const helpers_1 = __webpack_require__(92654);
const _m0 = __importStar(__webpack_require__(62100));
exports.protobufPackage = "cosmos.slashing.v1beta1";
function createBaseValidatorSigningInfo() {
    return {
        address: "",
        startHeight: helpers_1.Long.ZERO,
        indexOffset: helpers_1.Long.ZERO,
        jailedUntil: undefined,
        tombstoned: false,
        missedBlocksCounter: helpers_1.Long.ZERO,
    };
}
exports.ValidatorSigningInfo = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.address !== "") {
            writer.uint32(10).string(message.address);
        }
        if (!message.startHeight.isZero()) {
            writer.uint32(16).int64(message.startHeight);
        }
        if (!message.indexOffset.isZero()) {
            writer.uint32(24).int64(message.indexOffset);
        }
        if (message.jailedUntil !== undefined) {
            timestamp_1.Timestamp.encode(message.jailedUntil, writer.uint32(34).fork()).ldelim();
        }
        if (message.tombstoned === true) {
            writer.uint32(40).bool(message.tombstoned);
        }
        if (!message.missedBlocksCounter.isZero()) {
            writer.uint32(48).int64(message.missedBlocksCounter);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseValidatorSigningInfo();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.startHeight = reader.int64();
                    break;
                case 3:
                    message.indexOffset = reader.int64();
                    break;
                case 4:
                    message.jailedUntil = timestamp_1.Timestamp.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.tombstoned = reader.bool();
                    break;
                case 6:
                    message.missedBlocksCounter = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            address: (0, helpers_1.isSet)(object.address) ? String(object.address) : "",
            startHeight: (0, helpers_1.isSet)(object.startHeight) ? helpers_1.Long.fromValue(object.startHeight) : helpers_1.Long.ZERO,
            indexOffset: (0, helpers_1.isSet)(object.indexOffset) ? helpers_1.Long.fromValue(object.indexOffset) : helpers_1.Long.ZERO,
            jailedUntil: (0, helpers_1.isSet)(object.jailedUntil) ? (0, helpers_1.fromJsonTimestamp)(object.jailedUntil) : undefined,
            tombstoned: (0, helpers_1.isSet)(object.tombstoned) ? Boolean(object.tombstoned) : false,
            missedBlocksCounter: (0, helpers_1.isSet)(object.missedBlocksCounter)
                ? helpers_1.Long.fromValue(object.missedBlocksCounter)
                : helpers_1.Long.ZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.startHeight !== undefined && (obj.startHeight = (message.startHeight || helpers_1.Long.ZERO).toString());
        message.indexOffset !== undefined && (obj.indexOffset = (message.indexOffset || helpers_1.Long.ZERO).toString());
        message.jailedUntil !== undefined && (obj.jailedUntil = (0, helpers_1.fromTimestamp)(message.jailedUntil).toISOString());
        message.tombstoned !== undefined && (obj.tombstoned = message.tombstoned);
        message.missedBlocksCounter !== undefined &&
            (obj.missedBlocksCounter = (message.missedBlocksCounter || helpers_1.Long.ZERO).toString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseValidatorSigningInfo();
        message.address = object.address ?? "";
        message.startHeight =
            object.startHeight !== undefined && object.startHeight !== null
                ? helpers_1.Long.fromValue(object.startHeight)
                : helpers_1.Long.ZERO;
        message.indexOffset =
            object.indexOffset !== undefined && object.indexOffset !== null
                ? helpers_1.Long.fromValue(object.indexOffset)
                : helpers_1.Long.ZERO;
        message.jailedUntil =
            object.jailedUntil !== undefined && object.jailedUntil !== null
                ? timestamp_1.Timestamp.fromPartial(object.jailedUntil)
                : undefined;
        message.tombstoned = object.tombstoned ?? false;
        message.missedBlocksCounter =
            object.missedBlocksCounter !== undefined && object.missedBlocksCounter !== null
                ? helpers_1.Long.fromValue(object.missedBlocksCounter)
                : helpers_1.Long.ZERO;
        return message;
    },
};
function createBaseParams() {
    return {
        signedBlocksWindow: helpers_1.Long.ZERO,
        minSignedPerWindow: new Uint8Array(),
        downtimeJailDuration: undefined,
        slashFractionDoubleSign: new Uint8Array(),
        slashFractionDowntime: new Uint8Array(),
    };
}
exports.Params = {
    encode(message, writer = _m0.Writer.create()) {
        if (!message.signedBlocksWindow.isZero()) {
            writer.uint32(8).int64(message.signedBlocksWindow);
        }
        if (message.minSignedPerWindow.length !== 0) {
            writer.uint32(18).bytes(message.minSignedPerWindow);
        }
        if (message.downtimeJailDuration !== undefined) {
            duration_1.Duration.encode(message.downtimeJailDuration, writer.uint32(26).fork()).ldelim();
        }
        if (message.slashFractionDoubleSign.length !== 0) {
            writer.uint32(34).bytes(message.slashFractionDoubleSign);
        }
        if (message.slashFractionDowntime.length !== 0) {
            writer.uint32(42).bytes(message.slashFractionDowntime);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseParams();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.signedBlocksWindow = reader.int64();
                    break;
                case 2:
                    message.minSignedPerWindow = reader.bytes();
                    break;
                case 3:
                    message.downtimeJailDuration = duration_1.Duration.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.slashFractionDoubleSign = reader.bytes();
                    break;
                case 5:
                    message.slashFractionDowntime = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            signedBlocksWindow: (0, helpers_1.isSet)(object.signedBlocksWindow)
                ? helpers_1.Long.fromValue(object.signedBlocksWindow)
                : helpers_1.Long.ZERO,
            minSignedPerWindow: (0, helpers_1.isSet)(object.minSignedPerWindow)
                ? (0, helpers_1.bytesFromBase64)(object.minSignedPerWindow)
                : new Uint8Array(),
            downtimeJailDuration: (0, helpers_1.isSet)(object.downtimeJailDuration)
                ? duration_1.Duration.fromJSON(object.downtimeJailDuration)
                : undefined,
            slashFractionDoubleSign: (0, helpers_1.isSet)(object.slashFractionDoubleSign)
                ? (0, helpers_1.bytesFromBase64)(object.slashFractionDoubleSign)
                : new Uint8Array(),
            slashFractionDowntime: (0, helpers_1.isSet)(object.slashFractionDowntime)
                ? (0, helpers_1.bytesFromBase64)(object.slashFractionDowntime)
                : new Uint8Array(),
        };
    },
    toJSON(message) {
        const obj = {};
        message.signedBlocksWindow !== undefined &&
            (obj.signedBlocksWindow = (message.signedBlocksWindow || helpers_1.Long.ZERO).toString());
        message.minSignedPerWindow !== undefined &&
            (obj.minSignedPerWindow = (0, helpers_1.base64FromBytes)(message.minSignedPerWindow !== undefined ? message.minSignedPerWindow : new Uint8Array()));
        message.downtimeJailDuration !== undefined &&
            (obj.downtimeJailDuration = message.downtimeJailDuration
                ? duration_1.Duration.toJSON(message.downtimeJailDuration)
                : undefined);
        message.slashFractionDoubleSign !== undefined &&
            (obj.slashFractionDoubleSign = (0, helpers_1.base64FromBytes)(message.slashFractionDoubleSign !== undefined ? message.slashFractionDoubleSign : new Uint8Array()));
        message.slashFractionDowntime !== undefined &&
            (obj.slashFractionDowntime = (0, helpers_1.base64FromBytes)(message.slashFractionDowntime !== undefined ? message.slashFractionDowntime : new Uint8Array()));
        return obj;
    },
    fromPartial(object) {
        const message = createBaseParams();
        message.signedBlocksWindow =
            object.signedBlocksWindow !== undefined && object.signedBlocksWindow !== null
                ? helpers_1.Long.fromValue(object.signedBlocksWindow)
                : helpers_1.Long.ZERO;
        message.minSignedPerWindow = object.minSignedPerWindow ?? new Uint8Array();
        message.downtimeJailDuration =
            object.downtimeJailDuration !== undefined && object.downtimeJailDuration !== null
                ? duration_1.Duration.fromPartial(object.downtimeJailDuration)
                : undefined;
        message.slashFractionDoubleSign = object.slashFractionDoubleSign ?? new Uint8Array();
        message.slashFractionDowntime = object.slashFractionDowntime ?? new Uint8Array();
        return message;
    },
};
//# sourceMappingURL=slashing.js.map

/***/ }),

/***/ 13267:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.QueryClientImpl = exports.QueryParamsResponse = exports.QueryParamsRequest = exports.QueryPoolResponse = exports.QueryPoolRequest = exports.QueryHistoricalInfoResponse = exports.QueryHistoricalInfoRequest = exports.QueryDelegatorValidatorResponse = exports.QueryDelegatorValidatorRequest = exports.QueryDelegatorValidatorsResponse = exports.QueryDelegatorValidatorsRequest = exports.QueryRedelegationsResponse = exports.QueryRedelegationsRequest = exports.QueryDelegatorUnbondingDelegationsResponse = exports.QueryDelegatorUnbondingDelegationsRequest = exports.QueryDelegatorDelegationsResponse = exports.QueryDelegatorDelegationsRequest = exports.QueryUnbondingDelegationResponse = exports.QueryUnbondingDelegationRequest = exports.QueryDelegationResponse = exports.QueryDelegationRequest = exports.QueryValidatorUnbondingDelegationsResponse = exports.QueryValidatorUnbondingDelegationsRequest = exports.QueryValidatorDelegationsResponse = exports.QueryValidatorDelegationsRequest = exports.QueryValidatorResponse = exports.QueryValidatorRequest = exports.QueryValidatorsResponse = exports.QueryValidatorsRequest = exports.protobufPackage = void 0;
/* eslint-disable */
const pagination_1 = __webpack_require__(84043);
const staking_1 = __webpack_require__(79997);
const helpers_1 = __webpack_require__(92654);
const _m0 = __importStar(__webpack_require__(62100));
exports.protobufPackage = "cosmos.staking.v1beta1";
function createBaseQueryValidatorsRequest() {
    return {
        status: "",
        pagination: undefined,
    };
}
exports.QueryValidatorsRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.status !== "") {
            writer.uint32(10).string(message.status);
        }
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryValidatorsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.status = reader.string();
                    break;
                case 2:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            status: (0, helpers_1.isSet)(object.status) ? String(object.status) : "",
            pagination: (0, helpers_1.isSet)(object.pagination) ? pagination_1.PageRequest.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.status !== undefined && (obj.status = message.status);
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryValidatorsRequest();
        message.status = object.status ?? "";
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryValidatorsResponse() {
    return {
        validators: [],
        pagination: undefined,
    };
}
exports.QueryValidatorsResponse = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.validators) {
            staking_1.Validator.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryValidatorsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.validators.push(staking_1.Validator.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            validators: Array.isArray(object?.validators)
                ? object.validators.map((e) => staking_1.Validator.fromJSON(e))
                : [],
            pagination: (0, helpers_1.isSet)(object.pagination) ? pagination_1.PageResponse.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.validators) {
            obj.validators = message.validators.map((e) => (e ? staking_1.Validator.toJSON(e) : undefined));
        }
        else {
            obj.validators = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryValidatorsResponse();
        message.validators = object.validators?.map((e) => staking_1.Validator.fromPartial(e)) || [];
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryValidatorRequest() {
    return {
        validatorAddr: "",
    };
}
exports.QueryValidatorRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.validatorAddr !== "") {
            writer.uint32(10).string(message.validatorAddr);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryValidatorRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.validatorAddr = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            validatorAddr: (0, helpers_1.isSet)(object.validatorAddr) ? String(object.validatorAddr) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.validatorAddr !== undefined && (obj.validatorAddr = message.validatorAddr);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryValidatorRequest();
        message.validatorAddr = object.validatorAddr ?? "";
        return message;
    },
};
function createBaseQueryValidatorResponse() {
    return {
        validator: undefined,
    };
}
exports.QueryValidatorResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.validator !== undefined) {
            staking_1.Validator.encode(message.validator, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryValidatorResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.validator = staking_1.Validator.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            validator: (0, helpers_1.isSet)(object.validator) ? staking_1.Validator.fromJSON(object.validator) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.validator !== undefined &&
            (obj.validator = message.validator ? staking_1.Validator.toJSON(message.validator) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryValidatorResponse();
        message.validator =
            object.validator !== undefined && object.validator !== null
                ? staking_1.Validator.fromPartial(object.validator)
                : undefined;
        return message;
    },
};
function createBaseQueryValidatorDelegationsRequest() {
    return {
        validatorAddr: "",
        pagination: undefined,
    };
}
exports.QueryValidatorDelegationsRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.validatorAddr !== "") {
            writer.uint32(10).string(message.validatorAddr);
        }
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryValidatorDelegationsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.validatorAddr = reader.string();
                    break;
                case 2:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            validatorAddr: (0, helpers_1.isSet)(object.validatorAddr) ? String(object.validatorAddr) : "",
            pagination: (0, helpers_1.isSet)(object.pagination) ? pagination_1.PageRequest.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.validatorAddr !== undefined && (obj.validatorAddr = message.validatorAddr);
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryValidatorDelegationsRequest();
        message.validatorAddr = object.validatorAddr ?? "";
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryValidatorDelegationsResponse() {
    return {
        delegationResponses: [],
        pagination: undefined,
    };
}
exports.QueryValidatorDelegationsResponse = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.delegationResponses) {
            staking_1.DelegationResponse.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryValidatorDelegationsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.delegationResponses.push(staking_1.DelegationResponse.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            delegationResponses: Array.isArray(object?.delegationResponses)
                ? object.delegationResponses.map((e) => staking_1.DelegationResponse.fromJSON(e))
                : [],
            pagination: (0, helpers_1.isSet)(object.pagination) ? pagination_1.PageResponse.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.delegationResponses) {
            obj.delegationResponses = message.delegationResponses.map((e) => e ? staking_1.DelegationResponse.toJSON(e) : undefined);
        }
        else {
            obj.delegationResponses = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryValidatorDelegationsResponse();
        message.delegationResponses =
            object.delegationResponses?.map((e) => staking_1.DelegationResponse.fromPartial(e)) || [];
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryValidatorUnbondingDelegationsRequest() {
    return {
        validatorAddr: "",
        pagination: undefined,
    };
}
exports.QueryValidatorUnbondingDelegationsRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.validatorAddr !== "") {
            writer.uint32(10).string(message.validatorAddr);
        }
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryValidatorUnbondingDelegationsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.validatorAddr = reader.string();
                    break;
                case 2:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            validatorAddr: (0, helpers_1.isSet)(object.validatorAddr) ? String(object.validatorAddr) : "",
            pagination: (0, helpers_1.isSet)(object.pagination) ? pagination_1.PageRequest.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.validatorAddr !== undefined && (obj.validatorAddr = message.validatorAddr);
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryValidatorUnbondingDelegationsRequest();
        message.validatorAddr = object.validatorAddr ?? "";
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryValidatorUnbondingDelegationsResponse() {
    return {
        unbondingResponses: [],
        pagination: undefined,
    };
}
exports.QueryValidatorUnbondingDelegationsResponse = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.unbondingResponses) {
            staking_1.UnbondingDelegation.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryValidatorUnbondingDelegationsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.unbondingResponses.push(staking_1.UnbondingDelegation.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            unbondingResponses: Array.isArray(object?.unbondingResponses)
                ? object.unbondingResponses.map((e) => staking_1.UnbondingDelegation.fromJSON(e))
                : [],
            pagination: (0, helpers_1.isSet)(object.pagination) ? pagination_1.PageResponse.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.unbondingResponses) {
            obj.unbondingResponses = message.unbondingResponses.map((e) => e ? staking_1.UnbondingDelegation.toJSON(e) : undefined);
        }
        else {
            obj.unbondingResponses = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryValidatorUnbondingDelegationsResponse();
        message.unbondingResponses =
            object.unbondingResponses?.map((e) => staking_1.UnbondingDelegation.fromPartial(e)) || [];
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryDelegationRequest() {
    return {
        delegatorAddr: "",
        validatorAddr: "",
    };
}
exports.QueryDelegationRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.delegatorAddr !== "") {
            writer.uint32(10).string(message.delegatorAddr);
        }
        if (message.validatorAddr !== "") {
            writer.uint32(18).string(message.validatorAddr);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryDelegationRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.delegatorAddr = reader.string();
                    break;
                case 2:
                    message.validatorAddr = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            delegatorAddr: (0, helpers_1.isSet)(object.delegatorAddr) ? String(object.delegatorAddr) : "",
            validatorAddr: (0, helpers_1.isSet)(object.validatorAddr) ? String(object.validatorAddr) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.delegatorAddr !== undefined && (obj.delegatorAddr = message.delegatorAddr);
        message.validatorAddr !== undefined && (obj.validatorAddr = message.validatorAddr);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryDelegationRequest();
        message.delegatorAddr = object.delegatorAddr ?? "";
        message.validatorAddr = object.validatorAddr ?? "";
        return message;
    },
};
function createBaseQueryDelegationResponse() {
    return {
        delegationResponse: undefined,
    };
}
exports.QueryDelegationResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.delegationResponse !== undefined) {
            staking_1.DelegationResponse.encode(message.delegationResponse, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryDelegationResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.delegationResponse = staking_1.DelegationResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            delegationResponse: (0, helpers_1.isSet)(object.delegationResponse)
                ? staking_1.DelegationResponse.fromJSON(object.delegationResponse)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.delegationResponse !== undefined &&
            (obj.delegationResponse = message.delegationResponse
                ? staking_1.DelegationResponse.toJSON(message.delegationResponse)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryDelegationResponse();
        message.delegationResponse =
            object.delegationResponse !== undefined && object.delegationResponse !== null
                ? staking_1.DelegationResponse.fromPartial(object.delegationResponse)
                : undefined;
        return message;
    },
};
function createBaseQueryUnbondingDelegationRequest() {
    return {
        delegatorAddr: "",
        validatorAddr: "",
    };
}
exports.QueryUnbondingDelegationRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.delegatorAddr !== "") {
            writer.uint32(10).string(message.delegatorAddr);
        }
        if (message.validatorAddr !== "") {
            writer.uint32(18).string(message.validatorAddr);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryUnbondingDelegationRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.delegatorAddr = reader.string();
                    break;
                case 2:
                    message.validatorAddr = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            delegatorAddr: (0, helpers_1.isSet)(object.delegatorAddr) ? String(object.delegatorAddr) : "",
            validatorAddr: (0, helpers_1.isSet)(object.validatorAddr) ? String(object.validatorAddr) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.delegatorAddr !== undefined && (obj.delegatorAddr = message.delegatorAddr);
        message.validatorAddr !== undefined && (obj.validatorAddr = message.validatorAddr);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryUnbondingDelegationRequest();
        message.delegatorAddr = object.delegatorAddr ?? "";
        message.validatorAddr = object.validatorAddr ?? "";
        return message;
    },
};
function createBaseQueryUnbondingDelegationResponse() {
    return {
        unbond: undefined,
    };
}
exports.QueryUnbondingDelegationResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.unbond !== undefined) {
            staking_1.UnbondingDelegation.encode(message.unbond, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryUnbondingDelegationResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.unbond = staking_1.UnbondingDelegation.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            unbond: (0, helpers_1.isSet)(object.unbond) ? staking_1.UnbondingDelegation.fromJSON(object.unbond) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.unbond !== undefined &&
            (obj.unbond = message.unbond ? staking_1.UnbondingDelegation.toJSON(message.unbond) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryUnbondingDelegationResponse();
        message.unbond =
            object.unbond !== undefined && object.unbond !== null
                ? staking_1.UnbondingDelegation.fromPartial(object.unbond)
                : undefined;
        return message;
    },
};
function createBaseQueryDelegatorDelegationsRequest() {
    return {
        delegatorAddr: "",
        pagination: undefined,
    };
}
exports.QueryDelegatorDelegationsRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.delegatorAddr !== "") {
            writer.uint32(10).string(message.delegatorAddr);
        }
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryDelegatorDelegationsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.delegatorAddr = reader.string();
                    break;
                case 2:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            delegatorAddr: (0, helpers_1.isSet)(object.delegatorAddr) ? String(object.delegatorAddr) : "",
            pagination: (0, helpers_1.isSet)(object.pagination) ? pagination_1.PageRequest.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.delegatorAddr !== undefined && (obj.delegatorAddr = message.delegatorAddr);
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryDelegatorDelegationsRequest();
        message.delegatorAddr = object.delegatorAddr ?? "";
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryDelegatorDelegationsResponse() {
    return {
        delegationResponses: [],
        pagination: undefined,
    };
}
exports.QueryDelegatorDelegationsResponse = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.delegationResponses) {
            staking_1.DelegationResponse.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryDelegatorDelegationsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.delegationResponses.push(staking_1.DelegationResponse.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            delegationResponses: Array.isArray(object?.delegationResponses)
                ? object.delegationResponses.map((e) => staking_1.DelegationResponse.fromJSON(e))
                : [],
            pagination: (0, helpers_1.isSet)(object.pagination) ? pagination_1.PageResponse.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.delegationResponses) {
            obj.delegationResponses = message.delegationResponses.map((e) => e ? staking_1.DelegationResponse.toJSON(e) : undefined);
        }
        else {
            obj.delegationResponses = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryDelegatorDelegationsResponse();
        message.delegationResponses =
            object.delegationResponses?.map((e) => staking_1.DelegationResponse.fromPartial(e)) || [];
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryDelegatorUnbondingDelegationsRequest() {
    return {
        delegatorAddr: "",
        pagination: undefined,
    };
}
exports.QueryDelegatorUnbondingDelegationsRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.delegatorAddr !== "") {
            writer.uint32(10).string(message.delegatorAddr);
        }
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryDelegatorUnbondingDelegationsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.delegatorAddr = reader.string();
                    break;
                case 2:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            delegatorAddr: (0, helpers_1.isSet)(object.delegatorAddr) ? String(object.delegatorAddr) : "",
            pagination: (0, helpers_1.isSet)(object.pagination) ? pagination_1.PageRequest.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.delegatorAddr !== undefined && (obj.delegatorAddr = message.delegatorAddr);
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryDelegatorUnbondingDelegationsRequest();
        message.delegatorAddr = object.delegatorAddr ?? "";
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryDelegatorUnbondingDelegationsResponse() {
    return {
        unbondingResponses: [],
        pagination: undefined,
    };
}
exports.QueryDelegatorUnbondingDelegationsResponse = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.unbondingResponses) {
            staking_1.UnbondingDelegation.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryDelegatorUnbondingDelegationsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.unbondingResponses.push(staking_1.UnbondingDelegation.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            unbondingResponses: Array.isArray(object?.unbondingResponses)
                ? object.unbondingResponses.map((e) => staking_1.UnbondingDelegation.fromJSON(e))
                : [],
            pagination: (0, helpers_1.isSet)(object.pagination) ? pagination_1.PageResponse.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.unbondingResponses) {
            obj.unbondingResponses = message.unbondingResponses.map((e) => e ? staking_1.UnbondingDelegation.toJSON(e) : undefined);
        }
        else {
            obj.unbondingResponses = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryDelegatorUnbondingDelegationsResponse();
        message.unbondingResponses =
            object.unbondingResponses?.map((e) => staking_1.UnbondingDelegation.fromPartial(e)) || [];
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryRedelegationsRequest() {
    return {
        delegatorAddr: "",
        srcValidatorAddr: "",
        dstValidatorAddr: "",
        pagination: undefined,
    };
}
exports.QueryRedelegationsRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.delegatorAddr !== "") {
            writer.uint32(10).string(message.delegatorAddr);
        }
        if (message.srcValidatorAddr !== "") {
            writer.uint32(18).string(message.srcValidatorAddr);
        }
        if (message.dstValidatorAddr !== "") {
            writer.uint32(26).string(message.dstValidatorAddr);
        }
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryRedelegationsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.delegatorAddr = reader.string();
                    break;
                case 2:
                    message.srcValidatorAddr = reader.string();
                    break;
                case 3:
                    message.dstValidatorAddr = reader.string();
                    break;
                case 4:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            delegatorAddr: (0, helpers_1.isSet)(object.delegatorAddr) ? String(object.delegatorAddr) : "",
            srcValidatorAddr: (0, helpers_1.isSet)(object.srcValidatorAddr) ? String(object.srcValidatorAddr) : "",
            dstValidatorAddr: (0, helpers_1.isSet)(object.dstValidatorAddr) ? String(object.dstValidatorAddr) : "",
            pagination: (0, helpers_1.isSet)(object.pagination) ? pagination_1.PageRequest.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.delegatorAddr !== undefined && (obj.delegatorAddr = message.delegatorAddr);
        message.srcValidatorAddr !== undefined && (obj.srcValidatorAddr = message.srcValidatorAddr);
        message.dstValidatorAddr !== undefined && (obj.dstValidatorAddr = message.dstValidatorAddr);
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryRedelegationsRequest();
        message.delegatorAddr = object.delegatorAddr ?? "";
        message.srcValidatorAddr = object.srcValidatorAddr ?? "";
        message.dstValidatorAddr = object.dstValidatorAddr ?? "";
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryRedelegationsResponse() {
    return {
        redelegationResponses: [],
        pagination: undefined,
    };
}
exports.QueryRedelegationsResponse = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.redelegationResponses) {
            staking_1.RedelegationResponse.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryRedelegationsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.redelegationResponses.push(staking_1.RedelegationResponse.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            redelegationResponses: Array.isArray(object?.redelegationResponses)
                ? object.redelegationResponses.map((e) => staking_1.RedelegationResponse.fromJSON(e))
                : [],
            pagination: (0, helpers_1.isSet)(object.pagination) ? pagination_1.PageResponse.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.redelegationResponses) {
            obj.redelegationResponses = message.redelegationResponses.map((e) => e ? staking_1.RedelegationResponse.toJSON(e) : undefined);
        }
        else {
            obj.redelegationResponses = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryRedelegationsResponse();
        message.redelegationResponses =
            object.redelegationResponses?.map((e) => staking_1.RedelegationResponse.fromPartial(e)) || [];
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryDelegatorValidatorsRequest() {
    return {
        delegatorAddr: "",
        pagination: undefined,
    };
}
exports.QueryDelegatorValidatorsRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.delegatorAddr !== "") {
            writer.uint32(10).string(message.delegatorAddr);
        }
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryDelegatorValidatorsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.delegatorAddr = reader.string();
                    break;
                case 2:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            delegatorAddr: (0, helpers_1.isSet)(object.delegatorAddr) ? String(object.delegatorAddr) : "",
            pagination: (0, helpers_1.isSet)(object.pagination) ? pagination_1.PageRequest.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.delegatorAddr !== undefined && (obj.delegatorAddr = message.delegatorAddr);
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryDelegatorValidatorsRequest();
        message.delegatorAddr = object.delegatorAddr ?? "";
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryDelegatorValidatorsResponse() {
    return {
        validators: [],
        pagination: undefined,
    };
}
exports.QueryDelegatorValidatorsResponse = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.validators) {
            staking_1.Validator.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryDelegatorValidatorsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.validators.push(staking_1.Validator.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            validators: Array.isArray(object?.validators)
                ? object.validators.map((e) => staking_1.Validator.fromJSON(e))
                : [],
            pagination: (0, helpers_1.isSet)(object.pagination) ? pagination_1.PageResponse.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.validators) {
            obj.validators = message.validators.map((e) => (e ? staking_1.Validator.toJSON(e) : undefined));
        }
        else {
            obj.validators = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryDelegatorValidatorsResponse();
        message.validators = object.validators?.map((e) => staking_1.Validator.fromPartial(e)) || [];
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryDelegatorValidatorRequest() {
    return {
        delegatorAddr: "",
        validatorAddr: "",
    };
}
exports.QueryDelegatorValidatorRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.delegatorAddr !== "") {
            writer.uint32(10).string(message.delegatorAddr);
        }
        if (message.validatorAddr !== "") {
            writer.uint32(18).string(message.validatorAddr);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryDelegatorValidatorRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.delegatorAddr = reader.string();
                    break;
                case 2:
                    message.validatorAddr = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            delegatorAddr: (0, helpers_1.isSet)(object.delegatorAddr) ? String(object.delegatorAddr) : "",
            validatorAddr: (0, helpers_1.isSet)(object.validatorAddr) ? String(object.validatorAddr) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.delegatorAddr !== undefined && (obj.delegatorAddr = message.delegatorAddr);
        message.validatorAddr !== undefined && (obj.validatorAddr = message.validatorAddr);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryDelegatorValidatorRequest();
        message.delegatorAddr = object.delegatorAddr ?? "";
        message.validatorAddr = object.validatorAddr ?? "";
        return message;
    },
};
function createBaseQueryDelegatorValidatorResponse() {
    return {
        validator: undefined,
    };
}
exports.QueryDelegatorValidatorResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.validator !== undefined) {
            staking_1.Validator.encode(message.validator, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryDelegatorValidatorResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.validator = staking_1.Validator.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            validator: (0, helpers_1.isSet)(object.validator) ? staking_1.Validator.fromJSON(object.validator) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.validator !== undefined &&
            (obj.validator = message.validator ? staking_1.Validator.toJSON(message.validator) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryDelegatorValidatorResponse();
        message.validator =
            object.validator !== undefined && object.validator !== null
                ? staking_1.Validator.fromPartial(object.validator)
                : undefined;
        return message;
    },
};
function createBaseQueryHistoricalInfoRequest() {
    return {
        height: helpers_1.Long.ZERO,
    };
}
exports.QueryHistoricalInfoRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (!message.height.isZero()) {
            writer.uint32(8).int64(message.height);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryHistoricalInfoRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.height = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            height: (0, helpers_1.isSet)(object.height) ? helpers_1.Long.fromValue(object.height) : helpers_1.Long.ZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        message.height !== undefined && (obj.height = (message.height || helpers_1.Long.ZERO).toString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryHistoricalInfoRequest();
        message.height =
            object.height !== undefined && object.height !== null ? helpers_1.Long.fromValue(object.height) : helpers_1.Long.ZERO;
        return message;
    },
};
function createBaseQueryHistoricalInfoResponse() {
    return {
        hist: undefined,
    };
}
exports.QueryHistoricalInfoResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.hist !== undefined) {
            staking_1.HistoricalInfo.encode(message.hist, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryHistoricalInfoResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.hist = staking_1.HistoricalInfo.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            hist: (0, helpers_1.isSet)(object.hist) ? staking_1.HistoricalInfo.fromJSON(object.hist) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.hist !== undefined && (obj.hist = message.hist ? staking_1.HistoricalInfo.toJSON(message.hist) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryHistoricalInfoResponse();
        message.hist =
            object.hist !== undefined && object.hist !== null ? staking_1.HistoricalInfo.fromPartial(object.hist) : undefined;
        return message;
    },
};
function createBaseQueryPoolRequest() {
    return {};
}
exports.QueryPoolRequest = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryPoolRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseQueryPoolRequest();
        return message;
    },
};
function createBaseQueryPoolResponse() {
    return {
        pool: undefined,
    };
}
exports.QueryPoolResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.pool !== undefined) {
            staking_1.Pool.encode(message.pool, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryPoolResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.pool = staking_1.Pool.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            pool: (0, helpers_1.isSet)(object.pool) ? staking_1.Pool.fromJSON(object.pool) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.pool !== undefined && (obj.pool = message.pool ? staking_1.Pool.toJSON(message.pool) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryPoolResponse();
        message.pool =
            object.pool !== undefined && object.pool !== null ? staking_1.Pool.fromPartial(object.pool) : undefined;
        return message;
    },
};
function createBaseQueryParamsRequest() {
    return {};
}
exports.QueryParamsRequest = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryParamsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseQueryParamsRequest();
        return message;
    },
};
function createBaseQueryParamsResponse() {
    return {
        params: undefined,
    };
}
exports.QueryParamsResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.params !== undefined) {
            staking_1.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryParamsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.params = staking_1.Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            params: (0, helpers_1.isSet)(object.params) ? staking_1.Params.fromJSON(object.params) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.params !== undefined && (obj.params = message.params ? staking_1.Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryParamsResponse();
        message.params =
            object.params !== undefined && object.params !== null ? staking_1.Params.fromPartial(object.params) : undefined;
        return message;
    },
};
class QueryClientImpl {
    constructor(rpc) {
        this.rpc = rpc;
        this.Validators = this.Validators.bind(this);
        this.Validator = this.Validator.bind(this);
        this.ValidatorDelegations = this.ValidatorDelegations.bind(this);
        this.ValidatorUnbondingDelegations = this.ValidatorUnbondingDelegations.bind(this);
        this.Delegation = this.Delegation.bind(this);
        this.UnbondingDelegation = this.UnbondingDelegation.bind(this);
        this.DelegatorDelegations = this.DelegatorDelegations.bind(this);
        this.DelegatorUnbondingDelegations = this.DelegatorUnbondingDelegations.bind(this);
        this.Redelegations = this.Redelegations.bind(this);
        this.DelegatorValidators = this.DelegatorValidators.bind(this);
        this.DelegatorValidator = this.DelegatorValidator.bind(this);
        this.HistoricalInfo = this.HistoricalInfo.bind(this);
        this.Pool = this.Pool.bind(this);
        this.Params = this.Params.bind(this);
    }
    Validators(request) {
        const data = exports.QueryValidatorsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Query", "Validators", data);
        return promise.then((data) => exports.QueryValidatorsResponse.decode(new _m0.Reader(data)));
    }
    Validator(request) {
        const data = exports.QueryValidatorRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Query", "Validator", data);
        return promise.then((data) => exports.QueryValidatorResponse.decode(new _m0.Reader(data)));
    }
    ValidatorDelegations(request) {
        const data = exports.QueryValidatorDelegationsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Query", "ValidatorDelegations", data);
        return promise.then((data) => exports.QueryValidatorDelegationsResponse.decode(new _m0.Reader(data)));
    }
    ValidatorUnbondingDelegations(request) {
        const data = exports.QueryValidatorUnbondingDelegationsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Query", "ValidatorUnbondingDelegations", data);
        return promise.then((data) => exports.QueryValidatorUnbondingDelegationsResponse.decode(new _m0.Reader(data)));
    }
    Delegation(request) {
        const data = exports.QueryDelegationRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Query", "Delegation", data);
        return promise.then((data) => exports.QueryDelegationResponse.decode(new _m0.Reader(data)));
    }
    UnbondingDelegation(request) {
        const data = exports.QueryUnbondingDelegationRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Query", "UnbondingDelegation", data);
        return promise.then((data) => exports.QueryUnbondingDelegationResponse.decode(new _m0.Reader(data)));
    }
    DelegatorDelegations(request) {
        const data = exports.QueryDelegatorDelegationsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Query", "DelegatorDelegations", data);
        return promise.then((data) => exports.QueryDelegatorDelegationsResponse.decode(new _m0.Reader(data)));
    }
    DelegatorUnbondingDelegations(request) {
        const data = exports.QueryDelegatorUnbondingDelegationsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Query", "DelegatorUnbondingDelegations", data);
        return promise.then((data) => exports.QueryDelegatorUnbondingDelegationsResponse.decode(new _m0.Reader(data)));
    }
    Redelegations(request) {
        const data = exports.QueryRedelegationsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Query", "Redelegations", data);
        return promise.then((data) => exports.QueryRedelegationsResponse.decode(new _m0.Reader(data)));
    }
    DelegatorValidators(request) {
        const data = exports.QueryDelegatorValidatorsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Query", "DelegatorValidators", data);
        return promise.then((data) => exports.QueryDelegatorValidatorsResponse.decode(new _m0.Reader(data)));
    }
    DelegatorValidator(request) {
        const data = exports.QueryDelegatorValidatorRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Query", "DelegatorValidator", data);
        return promise.then((data) => exports.QueryDelegatorValidatorResponse.decode(new _m0.Reader(data)));
    }
    HistoricalInfo(request) {
        const data = exports.QueryHistoricalInfoRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Query", "HistoricalInfo", data);
        return promise.then((data) => exports.QueryHistoricalInfoResponse.decode(new _m0.Reader(data)));
    }
    Pool(request = {}) {
        const data = exports.QueryPoolRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Query", "Pool", data);
        return promise.then((data) => exports.QueryPoolResponse.decode(new _m0.Reader(data)));
    }
    Params(request = {}) {
        const data = exports.QueryParamsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Query", "Params", data);
        return promise.then((data) => exports.QueryParamsResponse.decode(new _m0.Reader(data)));
    }
}
exports.QueryClientImpl = QueryClientImpl;
//# sourceMappingURL=query.js.map

/***/ }),

/***/ 79997:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ValidatorUpdates = exports.Pool = exports.RedelegationResponse = exports.RedelegationEntryResponse = exports.DelegationResponse = exports.Params = exports.Redelegation = exports.RedelegationEntry = exports.UnbondingDelegationEntry = exports.UnbondingDelegation = exports.Delegation = exports.DVVTriplets = exports.DVVTriplet = exports.DVPairs = exports.DVPair = exports.ValAddresses = exports.Validator = exports.Description = exports.Commission = exports.CommissionRates = exports.HistoricalInfo = exports.infractionToJSON = exports.infractionFromJSON = exports.Infraction = exports.bondStatusToJSON = exports.bondStatusFromJSON = exports.BondStatus = exports.protobufPackage = void 0;
/* eslint-disable */
const types_1 = __webpack_require__(34681);
const timestamp_1 = __webpack_require__(70147);
const any_1 = __webpack_require__(75654);
const duration_1 = __webpack_require__(9591);
const coin_1 = __webpack_require__(81637);
const types_2 = __webpack_require__(35580);
const helpers_1 = __webpack_require__(92654);
const _m0 = __importStar(__webpack_require__(62100));
exports.protobufPackage = "cosmos.staking.v1beta1";
/** BondStatus is the status of a validator. */
var BondStatus;
(function (BondStatus) {
    /** BOND_STATUS_UNSPECIFIED - UNSPECIFIED defines an invalid validator status. */
    BondStatus[BondStatus["BOND_STATUS_UNSPECIFIED"] = 0] = "BOND_STATUS_UNSPECIFIED";
    /** BOND_STATUS_UNBONDED - UNBONDED defines a validator that is not bonded. */
    BondStatus[BondStatus["BOND_STATUS_UNBONDED"] = 1] = "BOND_STATUS_UNBONDED";
    /** BOND_STATUS_UNBONDING - UNBONDING defines a validator that is unbonding. */
    BondStatus[BondStatus["BOND_STATUS_UNBONDING"] = 2] = "BOND_STATUS_UNBONDING";
    /** BOND_STATUS_BONDED - BONDED defines a validator that is bonded. */
    BondStatus[BondStatus["BOND_STATUS_BONDED"] = 3] = "BOND_STATUS_BONDED";
    BondStatus[BondStatus["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(BondStatus = exports.BondStatus || (exports.BondStatus = {}));
function bondStatusFromJSON(object) {
    switch (object) {
        case 0:
        case "BOND_STATUS_UNSPECIFIED":
            return BondStatus.BOND_STATUS_UNSPECIFIED;
        case 1:
        case "BOND_STATUS_UNBONDED":
            return BondStatus.BOND_STATUS_UNBONDED;
        case 2:
        case "BOND_STATUS_UNBONDING":
            return BondStatus.BOND_STATUS_UNBONDING;
        case 3:
        case "BOND_STATUS_BONDED":
            return BondStatus.BOND_STATUS_BONDED;
        case -1:
        case "UNRECOGNIZED":
        default:
            return BondStatus.UNRECOGNIZED;
    }
}
exports.bondStatusFromJSON = bondStatusFromJSON;
function bondStatusToJSON(object) {
    switch (object) {
        case BondStatus.BOND_STATUS_UNSPECIFIED:
            return "BOND_STATUS_UNSPECIFIED";
        case BondStatus.BOND_STATUS_UNBONDED:
            return "BOND_STATUS_UNBONDED";
        case BondStatus.BOND_STATUS_UNBONDING:
            return "BOND_STATUS_UNBONDING";
        case BondStatus.BOND_STATUS_BONDED:
            return "BOND_STATUS_BONDED";
        case BondStatus.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.bondStatusToJSON = bondStatusToJSON;
/** Infraction indicates the infraction a validator commited. */
var Infraction;
(function (Infraction) {
    /** INFRACTION_UNSPECIFIED - UNSPECIFIED defines an empty infraction. */
    Infraction[Infraction["INFRACTION_UNSPECIFIED"] = 0] = "INFRACTION_UNSPECIFIED";
    /** INFRACTION_DOUBLE_SIGN - DOUBLE_SIGN defines a validator that double-signs a block. */
    Infraction[Infraction["INFRACTION_DOUBLE_SIGN"] = 1] = "INFRACTION_DOUBLE_SIGN";
    /** INFRACTION_DOWNTIME - DOWNTIME defines a validator that missed signing too many blocks. */
    Infraction[Infraction["INFRACTION_DOWNTIME"] = 2] = "INFRACTION_DOWNTIME";
    Infraction[Infraction["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(Infraction = exports.Infraction || (exports.Infraction = {}));
function infractionFromJSON(object) {
    switch (object) {
        case 0:
        case "INFRACTION_UNSPECIFIED":
            return Infraction.INFRACTION_UNSPECIFIED;
        case 1:
        case "INFRACTION_DOUBLE_SIGN":
            return Infraction.INFRACTION_DOUBLE_SIGN;
        case 2:
        case "INFRACTION_DOWNTIME":
            return Infraction.INFRACTION_DOWNTIME;
        case -1:
        case "UNRECOGNIZED":
        default:
            return Infraction.UNRECOGNIZED;
    }
}
exports.infractionFromJSON = infractionFromJSON;
function infractionToJSON(object) {
    switch (object) {
        case Infraction.INFRACTION_UNSPECIFIED:
            return "INFRACTION_UNSPECIFIED";
        case Infraction.INFRACTION_DOUBLE_SIGN:
            return "INFRACTION_DOUBLE_SIGN";
        case Infraction.INFRACTION_DOWNTIME:
            return "INFRACTION_DOWNTIME";
        case Infraction.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.infractionToJSON = infractionToJSON;
function createBaseHistoricalInfo() {
    return {
        header: undefined,
        valset: [],
    };
}
exports.HistoricalInfo = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.header !== undefined) {
            types_1.Header.encode(message.header, writer.uint32(10).fork()).ldelim();
        }
        for (const v of message.valset) {
            exports.Validator.encode(v, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseHistoricalInfo();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.header = types_1.Header.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.valset.push(exports.Validator.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            header: (0, helpers_1.isSet)(object.header) ? types_1.Header.fromJSON(object.header) : undefined,
            valset: Array.isArray(object?.valset) ? object.valset.map((e) => exports.Validator.fromJSON(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        message.header !== undefined && (obj.header = message.header ? types_1.Header.toJSON(message.header) : undefined);
        if (message.valset) {
            obj.valset = message.valset.map((e) => (e ? exports.Validator.toJSON(e) : undefined));
        }
        else {
            obj.valset = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseHistoricalInfo();
        message.header =
            object.header !== undefined && object.header !== null ? types_1.Header.fromPartial(object.header) : undefined;
        message.valset = object.valset?.map((e) => exports.Validator.fromPartial(e)) || [];
        return message;
    },
};
function createBaseCommissionRates() {
    return {
        rate: "",
        maxRate: "",
        maxChangeRate: "",
    };
}
exports.CommissionRates = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.rate !== "") {
            writer.uint32(10).string(message.rate);
        }
        if (message.maxRate !== "") {
            writer.uint32(18).string(message.maxRate);
        }
        if (message.maxChangeRate !== "") {
            writer.uint32(26).string(message.maxChangeRate);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCommissionRates();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.rate = reader.string();
                    break;
                case 2:
                    message.maxRate = reader.string();
                    break;
                case 3:
                    message.maxChangeRate = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            rate: (0, helpers_1.isSet)(object.rate) ? String(object.rate) : "",
            maxRate: (0, helpers_1.isSet)(object.maxRate) ? String(object.maxRate) : "",
            maxChangeRate: (0, helpers_1.isSet)(object.maxChangeRate) ? String(object.maxChangeRate) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.rate !== undefined && (obj.rate = message.rate);
        message.maxRate !== undefined && (obj.maxRate = message.maxRate);
        message.maxChangeRate !== undefined && (obj.maxChangeRate = message.maxChangeRate);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseCommissionRates();
        message.rate = object.rate ?? "";
        message.maxRate = object.maxRate ?? "";
        message.maxChangeRate = object.maxChangeRate ?? "";
        return message;
    },
};
function createBaseCommission() {
    return {
        commissionRates: undefined,
        updateTime: undefined,
    };
}
exports.Commission = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.commissionRates !== undefined) {
            exports.CommissionRates.encode(message.commissionRates, writer.uint32(10).fork()).ldelim();
        }
        if (message.updateTime !== undefined) {
            timestamp_1.Timestamp.encode(message.updateTime, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCommission();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.commissionRates = exports.CommissionRates.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.updateTime = timestamp_1.Timestamp.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            commissionRates: (0, helpers_1.isSet)(object.commissionRates)
                ? exports.CommissionRates.fromJSON(object.commissionRates)
                : undefined,
            updateTime: (0, helpers_1.isSet)(object.updateTime) ? (0, helpers_1.fromJsonTimestamp)(object.updateTime) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.commissionRates !== undefined &&
            (obj.commissionRates = message.commissionRates
                ? exports.CommissionRates.toJSON(message.commissionRates)
                : undefined);
        message.updateTime !== undefined && (obj.updateTime = (0, helpers_1.fromTimestamp)(message.updateTime).toISOString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseCommission();
        message.commissionRates =
            object.commissionRates !== undefined && object.commissionRates !== null
                ? exports.CommissionRates.fromPartial(object.commissionRates)
                : undefined;
        message.updateTime =
            object.updateTime !== undefined && object.updateTime !== null
                ? timestamp_1.Timestamp.fromPartial(object.updateTime)
                : undefined;
        return message;
    },
};
function createBaseDescription() {
    return {
        moniker: "",
        identity: "",
        website: "",
        securityContact: "",
        details: "",
    };
}
exports.Description = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.moniker !== "") {
            writer.uint32(10).string(message.moniker);
        }
        if (message.identity !== "") {
            writer.uint32(18).string(message.identity);
        }
        if (message.website !== "") {
            writer.uint32(26).string(message.website);
        }
        if (message.securityContact !== "") {
            writer.uint32(34).string(message.securityContact);
        }
        if (message.details !== "") {
            writer.uint32(42).string(message.details);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDescription();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.moniker = reader.string();
                    break;
                case 2:
                    message.identity = reader.string();
                    break;
                case 3:
                    message.website = reader.string();
                    break;
                case 4:
                    message.securityContact = reader.string();
                    break;
                case 5:
                    message.details = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            moniker: (0, helpers_1.isSet)(object.moniker) ? String(object.moniker) : "",
            identity: (0, helpers_1.isSet)(object.identity) ? String(object.identity) : "",
            website: (0, helpers_1.isSet)(object.website) ? String(object.website) : "",
            securityContact: (0, helpers_1.isSet)(object.securityContact) ? String(object.securityContact) : "",
            details: (0, helpers_1.isSet)(object.details) ? String(object.details) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.moniker !== undefined && (obj.moniker = message.moniker);
        message.identity !== undefined && (obj.identity = message.identity);
        message.website !== undefined && (obj.website = message.website);
        message.securityContact !== undefined && (obj.securityContact = message.securityContact);
        message.details !== undefined && (obj.details = message.details);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseDescription();
        message.moniker = object.moniker ?? "";
        message.identity = object.identity ?? "";
        message.website = object.website ?? "";
        message.securityContact = object.securityContact ?? "";
        message.details = object.details ?? "";
        return message;
    },
};
function createBaseValidator() {
    return {
        operatorAddress: "",
        consensusPubkey: undefined,
        jailed: false,
        status: 0,
        tokens: "",
        delegatorShares: "",
        description: undefined,
        unbondingHeight: helpers_1.Long.ZERO,
        unbondingTime: undefined,
        commission: undefined,
        minSelfDelegation: "",
        unbondingOnHoldRefCount: helpers_1.Long.ZERO,
        unbondingIds: [],
    };
}
exports.Validator = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.operatorAddress !== "") {
            writer.uint32(10).string(message.operatorAddress);
        }
        if (message.consensusPubkey !== undefined) {
            any_1.Any.encode(message.consensusPubkey, writer.uint32(18).fork()).ldelim();
        }
        if (message.jailed === true) {
            writer.uint32(24).bool(message.jailed);
        }
        if (message.status !== 0) {
            writer.uint32(32).int32(message.status);
        }
        if (message.tokens !== "") {
            writer.uint32(42).string(message.tokens);
        }
        if (message.delegatorShares !== "") {
            writer.uint32(50).string(message.delegatorShares);
        }
        if (message.description !== undefined) {
            exports.Description.encode(message.description, writer.uint32(58).fork()).ldelim();
        }
        if (!message.unbondingHeight.isZero()) {
            writer.uint32(64).int64(message.unbondingHeight);
        }
        if (message.unbondingTime !== undefined) {
            timestamp_1.Timestamp.encode(message.unbondingTime, writer.uint32(74).fork()).ldelim();
        }
        if (message.commission !== undefined) {
            exports.Commission.encode(message.commission, writer.uint32(82).fork()).ldelim();
        }
        if (message.minSelfDelegation !== "") {
            writer.uint32(90).string(message.minSelfDelegation);
        }
        if (!message.unbondingOnHoldRefCount.isZero()) {
            writer.uint32(96).int64(message.unbondingOnHoldRefCount);
        }
        writer.uint32(106).fork();
        for (const v of message.unbondingIds) {
            writer.uint64(v);
        }
        writer.ldelim();
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseValidator();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.operatorAddress = reader.string();
                    break;
                case 2:
                    message.consensusPubkey = any_1.Any.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.jailed = reader.bool();
                    break;
                case 4:
                    message.status = reader.int32();
                    break;
                case 5:
                    message.tokens = reader.string();
                    break;
                case 6:
                    message.delegatorShares = reader.string();
                    break;
                case 7:
                    message.description = exports.Description.decode(reader, reader.uint32());
                    break;
                case 8:
                    message.unbondingHeight = reader.int64();
                    break;
                case 9:
                    message.unbondingTime = timestamp_1.Timestamp.decode(reader, reader.uint32());
                    break;
                case 10:
                    message.commission = exports.Commission.decode(reader, reader.uint32());
                    break;
                case 11:
                    message.minSelfDelegation = reader.string();
                    break;
                case 12:
                    message.unbondingOnHoldRefCount = reader.int64();
                    break;
                case 13:
                    if ((tag & 7) === 2) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.unbondingIds.push(reader.uint64());
                        }
                    }
                    else {
                        message.unbondingIds.push(reader.uint64());
                    }
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            operatorAddress: (0, helpers_1.isSet)(object.operatorAddress) ? String(object.operatorAddress) : "",
            consensusPubkey: (0, helpers_1.isSet)(object.consensusPubkey) ? any_1.Any.fromJSON(object.consensusPubkey) : undefined,
            jailed: (0, helpers_1.isSet)(object.jailed) ? Boolean(object.jailed) : false,
            status: (0, helpers_1.isSet)(object.status) ? bondStatusFromJSON(object.status) : 0,
            tokens: (0, helpers_1.isSet)(object.tokens) ? String(object.tokens) : "",
            delegatorShares: (0, helpers_1.isSet)(object.delegatorShares) ? String(object.delegatorShares) : "",
            description: (0, helpers_1.isSet)(object.description) ? exports.Description.fromJSON(object.description) : undefined,
            unbondingHeight: (0, helpers_1.isSet)(object.unbondingHeight) ? helpers_1.Long.fromValue(object.unbondingHeight) : helpers_1.Long.ZERO,
            unbondingTime: (0, helpers_1.isSet)(object.unbondingTime) ? (0, helpers_1.fromJsonTimestamp)(object.unbondingTime) : undefined,
            commission: (0, helpers_1.isSet)(object.commission) ? exports.Commission.fromJSON(object.commission) : undefined,
            minSelfDelegation: (0, helpers_1.isSet)(object.minSelfDelegation) ? String(object.minSelfDelegation) : "",
            unbondingOnHoldRefCount: (0, helpers_1.isSet)(object.unbondingOnHoldRefCount)
                ? helpers_1.Long.fromValue(object.unbondingOnHoldRefCount)
                : helpers_1.Long.ZERO,
            unbondingIds: Array.isArray(object?.unbondingIds)
                ? object.unbondingIds.map((e) => helpers_1.Long.fromValue(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        message.operatorAddress !== undefined && (obj.operatorAddress = message.operatorAddress);
        message.consensusPubkey !== undefined &&
            (obj.consensusPubkey = message.consensusPubkey ? any_1.Any.toJSON(message.consensusPubkey) : undefined);
        message.jailed !== undefined && (obj.jailed = message.jailed);
        message.status !== undefined && (obj.status = bondStatusToJSON(message.status));
        message.tokens !== undefined && (obj.tokens = message.tokens);
        message.delegatorShares !== undefined && (obj.delegatorShares = message.delegatorShares);
        message.description !== undefined &&
            (obj.description = message.description ? exports.Description.toJSON(message.description) : undefined);
        message.unbondingHeight !== undefined &&
            (obj.unbondingHeight = (message.unbondingHeight || helpers_1.Long.ZERO).toString());
        message.unbondingTime !== undefined &&
            (obj.unbondingTime = (0, helpers_1.fromTimestamp)(message.unbondingTime).toISOString());
        message.commission !== undefined &&
            (obj.commission = message.commission ? exports.Commission.toJSON(message.commission) : undefined);
        message.minSelfDelegation !== undefined && (obj.minSelfDelegation = message.minSelfDelegation);
        message.unbondingOnHoldRefCount !== undefined &&
            (obj.unbondingOnHoldRefCount = (message.unbondingOnHoldRefCount || helpers_1.Long.ZERO).toString());
        if (message.unbondingIds) {
            obj.unbondingIds = message.unbondingIds.map((e) => (e || helpers_1.Long.UZERO).toString());
        }
        else {
            obj.unbondingIds = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseValidator();
        message.operatorAddress = object.operatorAddress ?? "";
        message.consensusPubkey =
            object.consensusPubkey !== undefined && object.consensusPubkey !== null
                ? any_1.Any.fromPartial(object.consensusPubkey)
                : undefined;
        message.jailed = object.jailed ?? false;
        message.status = object.status ?? 0;
        message.tokens = object.tokens ?? "";
        message.delegatorShares = object.delegatorShares ?? "";
        message.description =
            object.description !== undefined && object.description !== null
                ? exports.Description.fromPartial(object.description)
                : undefined;
        message.unbondingHeight =
            object.unbondingHeight !== undefined && object.unbondingHeight !== null
                ? helpers_1.Long.fromValue(object.unbondingHeight)
                : helpers_1.Long.ZERO;
        message.unbondingTime =
            object.unbondingTime !== undefined && object.unbondingTime !== null
                ? timestamp_1.Timestamp.fromPartial(object.unbondingTime)
                : undefined;
        message.commission =
            object.commission !== undefined && object.commission !== null
                ? exports.Commission.fromPartial(object.commission)
                : undefined;
        message.minSelfDelegation = object.minSelfDelegation ?? "";
        message.unbondingOnHoldRefCount =
            object.unbondingOnHoldRefCount !== undefined && object.unbondingOnHoldRefCount !== null
                ? helpers_1.Long.fromValue(object.unbondingOnHoldRefCount)
                : helpers_1.Long.ZERO;
        message.unbondingIds = object.unbondingIds?.map((e) => helpers_1.Long.fromValue(e)) || [];
        return message;
    },
};
function createBaseValAddresses() {
    return {
        addresses: [],
    };
}
exports.ValAddresses = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.addresses) {
            writer.uint32(10).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseValAddresses();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.addresses.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            addresses: Array.isArray(object?.addresses) ? object.addresses.map((e) => String(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.addresses) {
            obj.addresses = message.addresses.map((e) => e);
        }
        else {
            obj.addresses = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseValAddresses();
        message.addresses = object.addresses?.map((e) => e) || [];
        return message;
    },
};
function createBaseDVPair() {
    return {
        delegatorAddress: "",
        validatorAddress: "",
    };
}
exports.DVPair = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.delegatorAddress !== "") {
            writer.uint32(10).string(message.delegatorAddress);
        }
        if (message.validatorAddress !== "") {
            writer.uint32(18).string(message.validatorAddress);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDVPair();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            delegatorAddress: (0, helpers_1.isSet)(object.delegatorAddress) ? String(object.delegatorAddress) : "",
            validatorAddress: (0, helpers_1.isSet)(object.validatorAddress) ? String(object.validatorAddress) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseDVPair();
        message.delegatorAddress = object.delegatorAddress ?? "";
        message.validatorAddress = object.validatorAddress ?? "";
        return message;
    },
};
function createBaseDVPairs() {
    return {
        pairs: [],
    };
}
exports.DVPairs = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.pairs) {
            exports.DVPair.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDVPairs();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.pairs.push(exports.DVPair.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            pairs: Array.isArray(object?.pairs) ? object.pairs.map((e) => exports.DVPair.fromJSON(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.pairs) {
            obj.pairs = message.pairs.map((e) => (e ? exports.DVPair.toJSON(e) : undefined));
        }
        else {
            obj.pairs = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseDVPairs();
        message.pairs = object.pairs?.map((e) => exports.DVPair.fromPartial(e)) || [];
        return message;
    },
};
function createBaseDVVTriplet() {
    return {
        delegatorAddress: "",
        validatorSrcAddress: "",
        validatorDstAddress: "",
    };
}
exports.DVVTriplet = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.delegatorAddress !== "") {
            writer.uint32(10).string(message.delegatorAddress);
        }
        if (message.validatorSrcAddress !== "") {
            writer.uint32(18).string(message.validatorSrcAddress);
        }
        if (message.validatorDstAddress !== "") {
            writer.uint32(26).string(message.validatorDstAddress);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDVVTriplet();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorSrcAddress = reader.string();
                    break;
                case 3:
                    message.validatorDstAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            delegatorAddress: (0, helpers_1.isSet)(object.delegatorAddress) ? String(object.delegatorAddress) : "",
            validatorSrcAddress: (0, helpers_1.isSet)(object.validatorSrcAddress) ? String(object.validatorSrcAddress) : "",
            validatorDstAddress: (0, helpers_1.isSet)(object.validatorDstAddress) ? String(object.validatorDstAddress) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorSrcAddress !== undefined && (obj.validatorSrcAddress = message.validatorSrcAddress);
        message.validatorDstAddress !== undefined && (obj.validatorDstAddress = message.validatorDstAddress);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseDVVTriplet();
        message.delegatorAddress = object.delegatorAddress ?? "";
        message.validatorSrcAddress = object.validatorSrcAddress ?? "";
        message.validatorDstAddress = object.validatorDstAddress ?? "";
        return message;
    },
};
function createBaseDVVTriplets() {
    return {
        triplets: [],
    };
}
exports.DVVTriplets = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.triplets) {
            exports.DVVTriplet.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDVVTriplets();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.triplets.push(exports.DVVTriplet.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            triplets: Array.isArray(object?.triplets)
                ? object.triplets.map((e) => exports.DVVTriplet.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.triplets) {
            obj.triplets = message.triplets.map((e) => (e ? exports.DVVTriplet.toJSON(e) : undefined));
        }
        else {
            obj.triplets = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseDVVTriplets();
        message.triplets = object.triplets?.map((e) => exports.DVVTriplet.fromPartial(e)) || [];
        return message;
    },
};
function createBaseDelegation() {
    return {
        delegatorAddress: "",
        validatorAddress: "",
        shares: "",
    };
}
exports.Delegation = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.delegatorAddress !== "") {
            writer.uint32(10).string(message.delegatorAddress);
        }
        if (message.validatorAddress !== "") {
            writer.uint32(18).string(message.validatorAddress);
        }
        if (message.shares !== "") {
            writer.uint32(26).string(message.shares);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDelegation();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorAddress = reader.string();
                    break;
                case 3:
                    message.shares = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            delegatorAddress: (0, helpers_1.isSet)(object.delegatorAddress) ? String(object.delegatorAddress) : "",
            validatorAddress: (0, helpers_1.isSet)(object.validatorAddress) ? String(object.validatorAddress) : "",
            shares: (0, helpers_1.isSet)(object.shares) ? String(object.shares) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        message.shares !== undefined && (obj.shares = message.shares);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseDelegation();
        message.delegatorAddress = object.delegatorAddress ?? "";
        message.validatorAddress = object.validatorAddress ?? "";
        message.shares = object.shares ?? "";
        return message;
    },
};
function createBaseUnbondingDelegation() {
    return {
        delegatorAddress: "",
        validatorAddress: "",
        entries: [],
    };
}
exports.UnbondingDelegation = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.delegatorAddress !== "") {
            writer.uint32(10).string(message.delegatorAddress);
        }
        if (message.validatorAddress !== "") {
            writer.uint32(18).string(message.validatorAddress);
        }
        for (const v of message.entries) {
            exports.UnbondingDelegationEntry.encode(v, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUnbondingDelegation();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorAddress = reader.string();
                    break;
                case 3:
                    message.entries.push(exports.UnbondingDelegationEntry.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            delegatorAddress: (0, helpers_1.isSet)(object.delegatorAddress) ? String(object.delegatorAddress) : "",
            validatorAddress: (0, helpers_1.isSet)(object.validatorAddress) ? String(object.validatorAddress) : "",
            entries: Array.isArray(object?.entries)
                ? object.entries.map((e) => exports.UnbondingDelegationEntry.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        if (message.entries) {
            obj.entries = message.entries.map((e) => (e ? exports.UnbondingDelegationEntry.toJSON(e) : undefined));
        }
        else {
            obj.entries = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseUnbondingDelegation();
        message.delegatorAddress = object.delegatorAddress ?? "";
        message.validatorAddress = object.validatorAddress ?? "";
        message.entries = object.entries?.map((e) => exports.UnbondingDelegationEntry.fromPartial(e)) || [];
        return message;
    },
};
function createBaseUnbondingDelegationEntry() {
    return {
        creationHeight: helpers_1.Long.ZERO,
        completionTime: undefined,
        initialBalance: "",
        balance: "",
        unbondingId: helpers_1.Long.UZERO,
        unbondingOnHoldRefCount: helpers_1.Long.ZERO,
    };
}
exports.UnbondingDelegationEntry = {
    encode(message, writer = _m0.Writer.create()) {
        if (!message.creationHeight.isZero()) {
            writer.uint32(8).int64(message.creationHeight);
        }
        if (message.completionTime !== undefined) {
            timestamp_1.Timestamp.encode(message.completionTime, writer.uint32(18).fork()).ldelim();
        }
        if (message.initialBalance !== "") {
            writer.uint32(26).string(message.initialBalance);
        }
        if (message.balance !== "") {
            writer.uint32(34).string(message.balance);
        }
        if (!message.unbondingId.isZero()) {
            writer.uint32(40).uint64(message.unbondingId);
        }
        if (!message.unbondingOnHoldRefCount.isZero()) {
            writer.uint32(48).int64(message.unbondingOnHoldRefCount);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUnbondingDelegationEntry();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creationHeight = reader.int64();
                    break;
                case 2:
                    message.completionTime = timestamp_1.Timestamp.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.initialBalance = reader.string();
                    break;
                case 4:
                    message.balance = reader.string();
                    break;
                case 5:
                    message.unbondingId = reader.uint64();
                    break;
                case 6:
                    message.unbondingOnHoldRefCount = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            creationHeight: (0, helpers_1.isSet)(object.creationHeight) ? helpers_1.Long.fromValue(object.creationHeight) : helpers_1.Long.ZERO,
            completionTime: (0, helpers_1.isSet)(object.completionTime) ? (0, helpers_1.fromJsonTimestamp)(object.completionTime) : undefined,
            initialBalance: (0, helpers_1.isSet)(object.initialBalance) ? String(object.initialBalance) : "",
            balance: (0, helpers_1.isSet)(object.balance) ? String(object.balance) : "",
            unbondingId: (0, helpers_1.isSet)(object.unbondingId) ? helpers_1.Long.fromValue(object.unbondingId) : helpers_1.Long.UZERO,
            unbondingOnHoldRefCount: (0, helpers_1.isSet)(object.unbondingOnHoldRefCount)
                ? helpers_1.Long.fromValue(object.unbondingOnHoldRefCount)
                : helpers_1.Long.ZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        message.creationHeight !== undefined &&
            (obj.creationHeight = (message.creationHeight || helpers_1.Long.ZERO).toString());
        message.completionTime !== undefined &&
            (obj.completionTime = (0, helpers_1.fromTimestamp)(message.completionTime).toISOString());
        message.initialBalance !== undefined && (obj.initialBalance = message.initialBalance);
        message.balance !== undefined && (obj.balance = message.balance);
        message.unbondingId !== undefined && (obj.unbondingId = (message.unbondingId || helpers_1.Long.UZERO).toString());
        message.unbondingOnHoldRefCount !== undefined &&
            (obj.unbondingOnHoldRefCount = (message.unbondingOnHoldRefCount || helpers_1.Long.ZERO).toString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseUnbondingDelegationEntry();
        message.creationHeight =
            object.creationHeight !== undefined && object.creationHeight !== null
                ? helpers_1.Long.fromValue(object.creationHeight)
                : helpers_1.Long.ZERO;
        message.completionTime =
            object.completionTime !== undefined && object.completionTime !== null
                ? timestamp_1.Timestamp.fromPartial(object.completionTime)
                : undefined;
        message.initialBalance = object.initialBalance ?? "";
        message.balance = object.balance ?? "";
        message.unbondingId =
            object.unbondingId !== undefined && object.unbondingId !== null
                ? helpers_1.Long.fromValue(object.unbondingId)
                : helpers_1.Long.UZERO;
        message.unbondingOnHoldRefCount =
            object.unbondingOnHoldRefCount !== undefined && object.unbondingOnHoldRefCount !== null
                ? helpers_1.Long.fromValue(object.unbondingOnHoldRefCount)
                : helpers_1.Long.ZERO;
        return message;
    },
};
function createBaseRedelegationEntry() {
    return {
        creationHeight: helpers_1.Long.ZERO,
        completionTime: undefined,
        initialBalance: "",
        sharesDst: "",
        unbondingId: helpers_1.Long.UZERO,
        unbondingOnHoldRefCount: helpers_1.Long.ZERO,
    };
}
exports.RedelegationEntry = {
    encode(message, writer = _m0.Writer.create()) {
        if (!message.creationHeight.isZero()) {
            writer.uint32(8).int64(message.creationHeight);
        }
        if (message.completionTime !== undefined) {
            timestamp_1.Timestamp.encode(message.completionTime, writer.uint32(18).fork()).ldelim();
        }
        if (message.initialBalance !== "") {
            writer.uint32(26).string(message.initialBalance);
        }
        if (message.sharesDst !== "") {
            writer.uint32(34).string(message.sharesDst);
        }
        if (!message.unbondingId.isZero()) {
            writer.uint32(40).uint64(message.unbondingId);
        }
        if (!message.unbondingOnHoldRefCount.isZero()) {
            writer.uint32(48).int64(message.unbondingOnHoldRefCount);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRedelegationEntry();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creationHeight = reader.int64();
                    break;
                case 2:
                    message.completionTime = timestamp_1.Timestamp.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.initialBalance = reader.string();
                    break;
                case 4:
                    message.sharesDst = reader.string();
                    break;
                case 5:
                    message.unbondingId = reader.uint64();
                    break;
                case 6:
                    message.unbondingOnHoldRefCount = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            creationHeight: (0, helpers_1.isSet)(object.creationHeight) ? helpers_1.Long.fromValue(object.creationHeight) : helpers_1.Long.ZERO,
            completionTime: (0, helpers_1.isSet)(object.completionTime) ? (0, helpers_1.fromJsonTimestamp)(object.completionTime) : undefined,
            initialBalance: (0, helpers_1.isSet)(object.initialBalance) ? String(object.initialBalance) : "",
            sharesDst: (0, helpers_1.isSet)(object.sharesDst) ? String(object.sharesDst) : "",
            unbondingId: (0, helpers_1.isSet)(object.unbondingId) ? helpers_1.Long.fromValue(object.unbondingId) : helpers_1.Long.UZERO,
            unbondingOnHoldRefCount: (0, helpers_1.isSet)(object.unbondingOnHoldRefCount)
                ? helpers_1.Long.fromValue(object.unbondingOnHoldRefCount)
                : helpers_1.Long.ZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        message.creationHeight !== undefined &&
            (obj.creationHeight = (message.creationHeight || helpers_1.Long.ZERO).toString());
        message.completionTime !== undefined &&
            (obj.completionTime = (0, helpers_1.fromTimestamp)(message.completionTime).toISOString());
        message.initialBalance !== undefined && (obj.initialBalance = message.initialBalance);
        message.sharesDst !== undefined && (obj.sharesDst = message.sharesDst);
        message.unbondingId !== undefined && (obj.unbondingId = (message.unbondingId || helpers_1.Long.UZERO).toString());
        message.unbondingOnHoldRefCount !== undefined &&
            (obj.unbondingOnHoldRefCount = (message.unbondingOnHoldRefCount || helpers_1.Long.ZERO).toString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseRedelegationEntry();
        message.creationHeight =
            object.creationHeight !== undefined && object.creationHeight !== null
                ? helpers_1.Long.fromValue(object.creationHeight)
                : helpers_1.Long.ZERO;
        message.completionTime =
            object.completionTime !== undefined && object.completionTime !== null
                ? timestamp_1.Timestamp.fromPartial(object.completionTime)
                : undefined;
        message.initialBalance = object.initialBalance ?? "";
        message.sharesDst = object.sharesDst ?? "";
        message.unbondingId =
            object.unbondingId !== undefined && object.unbondingId !== null
                ? helpers_1.Long.fromValue(object.unbondingId)
                : helpers_1.Long.UZERO;
        message.unbondingOnHoldRefCount =
            object.unbondingOnHoldRefCount !== undefined && object.unbondingOnHoldRefCount !== null
                ? helpers_1.Long.fromValue(object.unbondingOnHoldRefCount)
                : helpers_1.Long.ZERO;
        return message;
    },
};
function createBaseRedelegation() {
    return {
        delegatorAddress: "",
        validatorSrcAddress: "",
        validatorDstAddress: "",
        entries: [],
    };
}
exports.Redelegation = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.delegatorAddress !== "") {
            writer.uint32(10).string(message.delegatorAddress);
        }
        if (message.validatorSrcAddress !== "") {
            writer.uint32(18).string(message.validatorSrcAddress);
        }
        if (message.validatorDstAddress !== "") {
            writer.uint32(26).string(message.validatorDstAddress);
        }
        for (const v of message.entries) {
            exports.RedelegationEntry.encode(v, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRedelegation();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorSrcAddress = reader.string();
                    break;
                case 3:
                    message.validatorDstAddress = reader.string();
                    break;
                case 4:
                    message.entries.push(exports.RedelegationEntry.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            delegatorAddress: (0, helpers_1.isSet)(object.delegatorAddress) ? String(object.delegatorAddress) : "",
            validatorSrcAddress: (0, helpers_1.isSet)(object.validatorSrcAddress) ? String(object.validatorSrcAddress) : "",
            validatorDstAddress: (0, helpers_1.isSet)(object.validatorDstAddress) ? String(object.validatorDstAddress) : "",
            entries: Array.isArray(object?.entries)
                ? object.entries.map((e) => exports.RedelegationEntry.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorSrcAddress !== undefined && (obj.validatorSrcAddress = message.validatorSrcAddress);
        message.validatorDstAddress !== undefined && (obj.validatorDstAddress = message.validatorDstAddress);
        if (message.entries) {
            obj.entries = message.entries.map((e) => (e ? exports.RedelegationEntry.toJSON(e) : undefined));
        }
        else {
            obj.entries = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseRedelegation();
        message.delegatorAddress = object.delegatorAddress ?? "";
        message.validatorSrcAddress = object.validatorSrcAddress ?? "";
        message.validatorDstAddress = object.validatorDstAddress ?? "";
        message.entries = object.entries?.map((e) => exports.RedelegationEntry.fromPartial(e)) || [];
        return message;
    },
};
function createBaseParams() {
    return {
        unbondingTime: undefined,
        maxValidators: 0,
        maxEntries: 0,
        historicalEntries: 0,
        bondDenom: "",
        minCommissionRate: "",
    };
}
exports.Params = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.unbondingTime !== undefined) {
            duration_1.Duration.encode(message.unbondingTime, writer.uint32(10).fork()).ldelim();
        }
        if (message.maxValidators !== 0) {
            writer.uint32(16).uint32(message.maxValidators);
        }
        if (message.maxEntries !== 0) {
            writer.uint32(24).uint32(message.maxEntries);
        }
        if (message.historicalEntries !== 0) {
            writer.uint32(32).uint32(message.historicalEntries);
        }
        if (message.bondDenom !== "") {
            writer.uint32(42).string(message.bondDenom);
        }
        if (message.minCommissionRate !== "") {
            writer.uint32(50).string(message.minCommissionRate);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseParams();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.unbondingTime = duration_1.Duration.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.maxValidators = reader.uint32();
                    break;
                case 3:
                    message.maxEntries = reader.uint32();
                    break;
                case 4:
                    message.historicalEntries = reader.uint32();
                    break;
                case 5:
                    message.bondDenom = reader.string();
                    break;
                case 6:
                    message.minCommissionRate = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            unbondingTime: (0, helpers_1.isSet)(object.unbondingTime) ? duration_1.Duration.fromJSON(object.unbondingTime) : undefined,
            maxValidators: (0, helpers_1.isSet)(object.maxValidators) ? Number(object.maxValidators) : 0,
            maxEntries: (0, helpers_1.isSet)(object.maxEntries) ? Number(object.maxEntries) : 0,
            historicalEntries: (0, helpers_1.isSet)(object.historicalEntries) ? Number(object.historicalEntries) : 0,
            bondDenom: (0, helpers_1.isSet)(object.bondDenom) ? String(object.bondDenom) : "",
            minCommissionRate: (0, helpers_1.isSet)(object.minCommissionRate) ? String(object.minCommissionRate) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.unbondingTime !== undefined &&
            (obj.unbondingTime = message.unbondingTime ? duration_1.Duration.toJSON(message.unbondingTime) : undefined);
        message.maxValidators !== undefined && (obj.maxValidators = Math.round(message.maxValidators));
        message.maxEntries !== undefined && (obj.maxEntries = Math.round(message.maxEntries));
        message.historicalEntries !== undefined &&
            (obj.historicalEntries = Math.round(message.historicalEntries));
        message.bondDenom !== undefined && (obj.bondDenom = message.bondDenom);
        message.minCommissionRate !== undefined && (obj.minCommissionRate = message.minCommissionRate);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseParams();
        message.unbondingTime =
            object.unbondingTime !== undefined && object.unbondingTime !== null
                ? duration_1.Duration.fromPartial(object.unbondingTime)
                : undefined;
        message.maxValidators = object.maxValidators ?? 0;
        message.maxEntries = object.maxEntries ?? 0;
        message.historicalEntries = object.historicalEntries ?? 0;
        message.bondDenom = object.bondDenom ?? "";
        message.minCommissionRate = object.minCommissionRate ?? "";
        return message;
    },
};
function createBaseDelegationResponse() {
    return {
        delegation: undefined,
        balance: undefined,
    };
}
exports.DelegationResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.delegation !== undefined) {
            exports.Delegation.encode(message.delegation, writer.uint32(10).fork()).ldelim();
        }
        if (message.balance !== undefined) {
            coin_1.Coin.encode(message.balance, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDelegationResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.delegation = exports.Delegation.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.balance = coin_1.Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            delegation: (0, helpers_1.isSet)(object.delegation) ? exports.Delegation.fromJSON(object.delegation) : undefined,
            balance: (0, helpers_1.isSet)(object.balance) ? coin_1.Coin.fromJSON(object.balance) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.delegation !== undefined &&
            (obj.delegation = message.delegation ? exports.Delegation.toJSON(message.delegation) : undefined);
        message.balance !== undefined &&
            (obj.balance = message.balance ? coin_1.Coin.toJSON(message.balance) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseDelegationResponse();
        message.delegation =
            object.delegation !== undefined && object.delegation !== null
                ? exports.Delegation.fromPartial(object.delegation)
                : undefined;
        message.balance =
            object.balance !== undefined && object.balance !== null ? coin_1.Coin.fromPartial(object.balance) : undefined;
        return message;
    },
};
function createBaseRedelegationEntryResponse() {
    return {
        redelegationEntry: undefined,
        balance: "",
    };
}
exports.RedelegationEntryResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.redelegationEntry !== undefined) {
            exports.RedelegationEntry.encode(message.redelegationEntry, writer.uint32(10).fork()).ldelim();
        }
        if (message.balance !== "") {
            writer.uint32(34).string(message.balance);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRedelegationEntryResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.redelegationEntry = exports.RedelegationEntry.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.balance = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            redelegationEntry: (0, helpers_1.isSet)(object.redelegationEntry)
                ? exports.RedelegationEntry.fromJSON(object.redelegationEntry)
                : undefined,
            balance: (0, helpers_1.isSet)(object.balance) ? String(object.balance) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.redelegationEntry !== undefined &&
            (obj.redelegationEntry = message.redelegationEntry
                ? exports.RedelegationEntry.toJSON(message.redelegationEntry)
                : undefined);
        message.balance !== undefined && (obj.balance = message.balance);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseRedelegationEntryResponse();
        message.redelegationEntry =
            object.redelegationEntry !== undefined && object.redelegationEntry !== null
                ? exports.RedelegationEntry.fromPartial(object.redelegationEntry)
                : undefined;
        message.balance = object.balance ?? "";
        return message;
    },
};
function createBaseRedelegationResponse() {
    return {
        redelegation: undefined,
        entries: [],
    };
}
exports.RedelegationResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.redelegation !== undefined) {
            exports.Redelegation.encode(message.redelegation, writer.uint32(10).fork()).ldelim();
        }
        for (const v of message.entries) {
            exports.RedelegationEntryResponse.encode(v, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRedelegationResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.redelegation = exports.Redelegation.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.entries.push(exports.RedelegationEntryResponse.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            redelegation: (0, helpers_1.isSet)(object.redelegation) ? exports.Redelegation.fromJSON(object.redelegation) : undefined,
            entries: Array.isArray(object?.entries)
                ? object.entries.map((e) => exports.RedelegationEntryResponse.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        message.redelegation !== undefined &&
            (obj.redelegation = message.redelegation ? exports.Redelegation.toJSON(message.redelegation) : undefined);
        if (message.entries) {
            obj.entries = message.entries.map((e) => (e ? exports.RedelegationEntryResponse.toJSON(e) : undefined));
        }
        else {
            obj.entries = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseRedelegationResponse();
        message.redelegation =
            object.redelegation !== undefined && object.redelegation !== null
                ? exports.Redelegation.fromPartial(object.redelegation)
                : undefined;
        message.entries = object.entries?.map((e) => exports.RedelegationEntryResponse.fromPartial(e)) || [];
        return message;
    },
};
function createBasePool() {
    return {
        notBondedTokens: "",
        bondedTokens: "",
    };
}
exports.Pool = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.notBondedTokens !== "") {
            writer.uint32(10).string(message.notBondedTokens);
        }
        if (message.bondedTokens !== "") {
            writer.uint32(18).string(message.bondedTokens);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePool();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.notBondedTokens = reader.string();
                    break;
                case 2:
                    message.bondedTokens = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            notBondedTokens: (0, helpers_1.isSet)(object.notBondedTokens) ? String(object.notBondedTokens) : "",
            bondedTokens: (0, helpers_1.isSet)(object.bondedTokens) ? String(object.bondedTokens) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.notBondedTokens !== undefined && (obj.notBondedTokens = message.notBondedTokens);
        message.bondedTokens !== undefined && (obj.bondedTokens = message.bondedTokens);
        return obj;
    },
    fromPartial(object) {
        const message = createBasePool();
        message.notBondedTokens = object.notBondedTokens ?? "";
        message.bondedTokens = object.bondedTokens ?? "";
        return message;
    },
};
function createBaseValidatorUpdates() {
    return {
        updates: [],
    };
}
exports.ValidatorUpdates = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.updates) {
            types_2.ValidatorUpdate.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseValidatorUpdates();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.updates.push(types_2.ValidatorUpdate.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            updates: Array.isArray(object?.updates)
                ? object.updates.map((e) => types_2.ValidatorUpdate.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.updates) {
            obj.updates = message.updates.map((e) => (e ? types_2.ValidatorUpdate.toJSON(e) : undefined));
        }
        else {
            obj.updates = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseValidatorUpdates();
        message.updates = object.updates?.map((e) => types_2.ValidatorUpdate.fromPartial(e)) || [];
        return message;
    },
};
//# sourceMappingURL=staking.js.map

/***/ }),

/***/ 70381:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MsgClientImpl = exports.MsgUpdateParamsResponse = exports.MsgUpdateParams = exports.MsgCancelUnbondingDelegationResponse = exports.MsgCancelUnbondingDelegation = exports.MsgUndelegateResponse = exports.MsgUndelegate = exports.MsgBeginRedelegateResponse = exports.MsgBeginRedelegate = exports.MsgDelegateResponse = exports.MsgDelegate = exports.MsgEditValidatorResponse = exports.MsgEditValidator = exports.MsgCreateValidatorResponse = exports.MsgCreateValidator = exports.protobufPackage = void 0;
/* eslint-disable */
const staking_1 = __webpack_require__(79997);
const any_1 = __webpack_require__(75654);
const coin_1 = __webpack_require__(81637);
const timestamp_1 = __webpack_require__(70147);
const helpers_1 = __webpack_require__(92654);
const _m0 = __importStar(__webpack_require__(62100));
exports.protobufPackage = "cosmos.staking.v1beta1";
function createBaseMsgCreateValidator() {
    return {
        description: undefined,
        commission: undefined,
        minSelfDelegation: "",
        delegatorAddress: "",
        validatorAddress: "",
        pubkey: undefined,
        value: undefined,
    };
}
exports.MsgCreateValidator = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.description !== undefined) {
            staking_1.Description.encode(message.description, writer.uint32(10).fork()).ldelim();
        }
        if (message.commission !== undefined) {
            staking_1.CommissionRates.encode(message.commission, writer.uint32(18).fork()).ldelim();
        }
        if (message.minSelfDelegation !== "") {
            writer.uint32(26).string(message.minSelfDelegation);
        }
        if (message.delegatorAddress !== "") {
            writer.uint32(34).string(message.delegatorAddress);
        }
        if (message.validatorAddress !== "") {
            writer.uint32(42).string(message.validatorAddress);
        }
        if (message.pubkey !== undefined) {
            any_1.Any.encode(message.pubkey, writer.uint32(50).fork()).ldelim();
        }
        if (message.value !== undefined) {
            coin_1.Coin.encode(message.value, writer.uint32(58).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgCreateValidator();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.description = staking_1.Description.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.commission = staking_1.CommissionRates.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.minSelfDelegation = reader.string();
                    break;
                case 4:
                    message.delegatorAddress = reader.string();
                    break;
                case 5:
                    message.validatorAddress = reader.string();
                    break;
                case 6:
                    message.pubkey = any_1.Any.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.value = coin_1.Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            description: (0, helpers_1.isSet)(object.description) ? staking_1.Description.fromJSON(object.description) : undefined,
            commission: (0, helpers_1.isSet)(object.commission) ? staking_1.CommissionRates.fromJSON(object.commission) : undefined,
            minSelfDelegation: (0, helpers_1.isSet)(object.minSelfDelegation) ? String(object.minSelfDelegation) : "",
            delegatorAddress: (0, helpers_1.isSet)(object.delegatorAddress) ? String(object.delegatorAddress) : "",
            validatorAddress: (0, helpers_1.isSet)(object.validatorAddress) ? String(object.validatorAddress) : "",
            pubkey: (0, helpers_1.isSet)(object.pubkey) ? any_1.Any.fromJSON(object.pubkey) : undefined,
            value: (0, helpers_1.isSet)(object.value) ? coin_1.Coin.fromJSON(object.value) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.description !== undefined &&
            (obj.description = message.description ? staking_1.Description.toJSON(message.description) : undefined);
        message.commission !== undefined &&
            (obj.commission = message.commission ? staking_1.CommissionRates.toJSON(message.commission) : undefined);
        message.minSelfDelegation !== undefined && (obj.minSelfDelegation = message.minSelfDelegation);
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        message.pubkey !== undefined && (obj.pubkey = message.pubkey ? any_1.Any.toJSON(message.pubkey) : undefined);
        message.value !== undefined && (obj.value = message.value ? coin_1.Coin.toJSON(message.value) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgCreateValidator();
        message.description =
            object.description !== undefined && object.description !== null
                ? staking_1.Description.fromPartial(object.description)
                : undefined;
        message.commission =
            object.commission !== undefined && object.commission !== null
                ? staking_1.CommissionRates.fromPartial(object.commission)
                : undefined;
        message.minSelfDelegation = object.minSelfDelegation ?? "";
        message.delegatorAddress = object.delegatorAddress ?? "";
        message.validatorAddress = object.validatorAddress ?? "";
        message.pubkey =
            object.pubkey !== undefined && object.pubkey !== null ? any_1.Any.fromPartial(object.pubkey) : undefined;
        message.value =
            object.value !== undefined && object.value !== null ? coin_1.Coin.fromPartial(object.value) : undefined;
        return message;
    },
};
function createBaseMsgCreateValidatorResponse() {
    return {};
}
exports.MsgCreateValidatorResponse = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgCreateValidatorResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgCreateValidatorResponse();
        return message;
    },
};
function createBaseMsgEditValidator() {
    return {
        description: undefined,
        validatorAddress: "",
        commissionRate: "",
        minSelfDelegation: "",
    };
}
exports.MsgEditValidator = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.description !== undefined) {
            staking_1.Description.encode(message.description, writer.uint32(10).fork()).ldelim();
        }
        if (message.validatorAddress !== "") {
            writer.uint32(18).string(message.validatorAddress);
        }
        if (message.commissionRate !== "") {
            writer.uint32(26).string(message.commissionRate);
        }
        if (message.minSelfDelegation !== "") {
            writer.uint32(34).string(message.minSelfDelegation);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgEditValidator();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.description = staking_1.Description.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.validatorAddress = reader.string();
                    break;
                case 3:
                    message.commissionRate = reader.string();
                    break;
                case 4:
                    message.minSelfDelegation = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            description: (0, helpers_1.isSet)(object.description) ? staking_1.Description.fromJSON(object.description) : undefined,
            validatorAddress: (0, helpers_1.isSet)(object.validatorAddress) ? String(object.validatorAddress) : "",
            commissionRate: (0, helpers_1.isSet)(object.commissionRate) ? String(object.commissionRate) : "",
            minSelfDelegation: (0, helpers_1.isSet)(object.minSelfDelegation) ? String(object.minSelfDelegation) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.description !== undefined &&
            (obj.description = message.description ? staking_1.Description.toJSON(message.description) : undefined);
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        message.commissionRate !== undefined && (obj.commissionRate = message.commissionRate);
        message.minSelfDelegation !== undefined && (obj.minSelfDelegation = message.minSelfDelegation);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgEditValidator();
        message.description =
            object.description !== undefined && object.description !== null
                ? staking_1.Description.fromPartial(object.description)
                : undefined;
        message.validatorAddress = object.validatorAddress ?? "";
        message.commissionRate = object.commissionRate ?? "";
        message.minSelfDelegation = object.minSelfDelegation ?? "";
        return message;
    },
};
function createBaseMsgEditValidatorResponse() {
    return {};
}
exports.MsgEditValidatorResponse = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgEditValidatorResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgEditValidatorResponse();
        return message;
    },
};
function createBaseMsgDelegate() {
    return {
        delegatorAddress: "",
        validatorAddress: "",
        amount: undefined,
    };
}
exports.MsgDelegate = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.delegatorAddress !== "") {
            writer.uint32(10).string(message.delegatorAddress);
        }
        if (message.validatorAddress !== "") {
            writer.uint32(18).string(message.validatorAddress);
        }
        if (message.amount !== undefined) {
            coin_1.Coin.encode(message.amount, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgDelegate();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorAddress = reader.string();
                    break;
                case 3:
                    message.amount = coin_1.Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            delegatorAddress: (0, helpers_1.isSet)(object.delegatorAddress) ? String(object.delegatorAddress) : "",
            validatorAddress: (0, helpers_1.isSet)(object.validatorAddress) ? String(object.validatorAddress) : "",
            amount: (0, helpers_1.isSet)(object.amount) ? coin_1.Coin.fromJSON(object.amount) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        message.amount !== undefined && (obj.amount = message.amount ? coin_1.Coin.toJSON(message.amount) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgDelegate();
        message.delegatorAddress = object.delegatorAddress ?? "";
        message.validatorAddress = object.validatorAddress ?? "";
        message.amount =
            object.amount !== undefined && object.amount !== null ? coin_1.Coin.fromPartial(object.amount) : undefined;
        return message;
    },
};
function createBaseMsgDelegateResponse() {
    return {};
}
exports.MsgDelegateResponse = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgDelegateResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgDelegateResponse();
        return message;
    },
};
function createBaseMsgBeginRedelegate() {
    return {
        delegatorAddress: "",
        validatorSrcAddress: "",
        validatorDstAddress: "",
        amount: undefined,
    };
}
exports.MsgBeginRedelegate = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.delegatorAddress !== "") {
            writer.uint32(10).string(message.delegatorAddress);
        }
        if (message.validatorSrcAddress !== "") {
            writer.uint32(18).string(message.validatorSrcAddress);
        }
        if (message.validatorDstAddress !== "") {
            writer.uint32(26).string(message.validatorDstAddress);
        }
        if (message.amount !== undefined) {
            coin_1.Coin.encode(message.amount, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgBeginRedelegate();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorSrcAddress = reader.string();
                    break;
                case 3:
                    message.validatorDstAddress = reader.string();
                    break;
                case 4:
                    message.amount = coin_1.Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            delegatorAddress: (0, helpers_1.isSet)(object.delegatorAddress) ? String(object.delegatorAddress) : "",
            validatorSrcAddress: (0, helpers_1.isSet)(object.validatorSrcAddress) ? String(object.validatorSrcAddress) : "",
            validatorDstAddress: (0, helpers_1.isSet)(object.validatorDstAddress) ? String(object.validatorDstAddress) : "",
            amount: (0, helpers_1.isSet)(object.amount) ? coin_1.Coin.fromJSON(object.amount) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorSrcAddress !== undefined && (obj.validatorSrcAddress = message.validatorSrcAddress);
        message.validatorDstAddress !== undefined && (obj.validatorDstAddress = message.validatorDstAddress);
        message.amount !== undefined && (obj.amount = message.amount ? coin_1.Coin.toJSON(message.amount) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgBeginRedelegate();
        message.delegatorAddress = object.delegatorAddress ?? "";
        message.validatorSrcAddress = object.validatorSrcAddress ?? "";
        message.validatorDstAddress = object.validatorDstAddress ?? "";
        message.amount =
            object.amount !== undefined && object.amount !== null ? coin_1.Coin.fromPartial(object.amount) : undefined;
        return message;
    },
};
function createBaseMsgBeginRedelegateResponse() {
    return {
        completionTime: undefined,
    };
}
exports.MsgBeginRedelegateResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.completionTime !== undefined) {
            timestamp_1.Timestamp.encode(message.completionTime, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgBeginRedelegateResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.completionTime = timestamp_1.Timestamp.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            completionTime: (0, helpers_1.isSet)(object.completionTime) ? (0, helpers_1.fromJsonTimestamp)(object.completionTime) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.completionTime !== undefined &&
            (obj.completionTime = (0, helpers_1.fromTimestamp)(message.completionTime).toISOString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgBeginRedelegateResponse();
        message.completionTime =
            object.completionTime !== undefined && object.completionTime !== null
                ? timestamp_1.Timestamp.fromPartial(object.completionTime)
                : undefined;
        return message;
    },
};
function createBaseMsgUndelegate() {
    return {
        delegatorAddress: "",
        validatorAddress: "",
        amount: undefined,
    };
}
exports.MsgUndelegate = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.delegatorAddress !== "") {
            writer.uint32(10).string(message.delegatorAddress);
        }
        if (message.validatorAddress !== "") {
            writer.uint32(18).string(message.validatorAddress);
        }
        if (message.amount !== undefined) {
            coin_1.Coin.encode(message.amount, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgUndelegate();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorAddress = reader.string();
                    break;
                case 3:
                    message.amount = coin_1.Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            delegatorAddress: (0, helpers_1.isSet)(object.delegatorAddress) ? String(object.delegatorAddress) : "",
            validatorAddress: (0, helpers_1.isSet)(object.validatorAddress) ? String(object.validatorAddress) : "",
            amount: (0, helpers_1.isSet)(object.amount) ? coin_1.Coin.fromJSON(object.amount) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        message.amount !== undefined && (obj.amount = message.amount ? coin_1.Coin.toJSON(message.amount) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgUndelegate();
        message.delegatorAddress = object.delegatorAddress ?? "";
        message.validatorAddress = object.validatorAddress ?? "";
        message.amount =
            object.amount !== undefined && object.amount !== null ? coin_1.Coin.fromPartial(object.amount) : undefined;
        return message;
    },
};
function createBaseMsgUndelegateResponse() {
    return {
        completionTime: undefined,
    };
}
exports.MsgUndelegateResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.completionTime !== undefined) {
            timestamp_1.Timestamp.encode(message.completionTime, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgUndelegateResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.completionTime = timestamp_1.Timestamp.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            completionTime: (0, helpers_1.isSet)(object.completionTime) ? (0, helpers_1.fromJsonTimestamp)(object.completionTime) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.completionTime !== undefined &&
            (obj.completionTime = (0, helpers_1.fromTimestamp)(message.completionTime).toISOString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgUndelegateResponse();
        message.completionTime =
            object.completionTime !== undefined && object.completionTime !== null
                ? timestamp_1.Timestamp.fromPartial(object.completionTime)
                : undefined;
        return message;
    },
};
function createBaseMsgCancelUnbondingDelegation() {
    return {
        delegatorAddress: "",
        validatorAddress: "",
        amount: undefined,
        creationHeight: helpers_1.Long.ZERO,
    };
}
exports.MsgCancelUnbondingDelegation = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.delegatorAddress !== "") {
            writer.uint32(10).string(message.delegatorAddress);
        }
        if (message.validatorAddress !== "") {
            writer.uint32(18).string(message.validatorAddress);
        }
        if (message.amount !== undefined) {
            coin_1.Coin.encode(message.amount, writer.uint32(26).fork()).ldelim();
        }
        if (!message.creationHeight.isZero()) {
            writer.uint32(32).int64(message.creationHeight);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgCancelUnbondingDelegation();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorAddress = reader.string();
                    break;
                case 3:
                    message.amount = coin_1.Coin.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.creationHeight = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            delegatorAddress: (0, helpers_1.isSet)(object.delegatorAddress) ? String(object.delegatorAddress) : "",
            validatorAddress: (0, helpers_1.isSet)(object.validatorAddress) ? String(object.validatorAddress) : "",
            amount: (0, helpers_1.isSet)(object.amount) ? coin_1.Coin.fromJSON(object.amount) : undefined,
            creationHeight: (0, helpers_1.isSet)(object.creationHeight) ? helpers_1.Long.fromValue(object.creationHeight) : helpers_1.Long.ZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        message.amount !== undefined && (obj.amount = message.amount ? coin_1.Coin.toJSON(message.amount) : undefined);
        message.creationHeight !== undefined &&
            (obj.creationHeight = (message.creationHeight || helpers_1.Long.ZERO).toString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgCancelUnbondingDelegation();
        message.delegatorAddress = object.delegatorAddress ?? "";
        message.validatorAddress = object.validatorAddress ?? "";
        message.amount =
            object.amount !== undefined && object.amount !== null ? coin_1.Coin.fromPartial(object.amount) : undefined;
        message.creationHeight =
            object.creationHeight !== undefined && object.creationHeight !== null
                ? helpers_1.Long.fromValue(object.creationHeight)
                : helpers_1.Long.ZERO;
        return message;
    },
};
function createBaseMsgCancelUnbondingDelegationResponse() {
    return {};
}
exports.MsgCancelUnbondingDelegationResponse = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgCancelUnbondingDelegationResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgCancelUnbondingDelegationResponse();
        return message;
    },
};
function createBaseMsgUpdateParams() {
    return {
        authority: "",
        params: undefined,
    };
}
exports.MsgUpdateParams = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.authority !== "") {
            writer.uint32(10).string(message.authority);
        }
        if (message.params !== undefined) {
            staking_1.Params.encode(message.params, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgUpdateParams();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.authority = reader.string();
                    break;
                case 2:
                    message.params = staking_1.Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            authority: (0, helpers_1.isSet)(object.authority) ? String(object.authority) : "",
            params: (0, helpers_1.isSet)(object.params) ? staking_1.Params.fromJSON(object.params) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.authority !== undefined && (obj.authority = message.authority);
        message.params !== undefined && (obj.params = message.params ? staking_1.Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgUpdateParams();
        message.authority = object.authority ?? "";
        message.params =
            object.params !== undefined && object.params !== null ? staking_1.Params.fromPartial(object.params) : undefined;
        return message;
    },
};
function createBaseMsgUpdateParamsResponse() {
    return {};
}
exports.MsgUpdateParamsResponse = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgUpdateParamsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgUpdateParamsResponse();
        return message;
    },
};
class MsgClientImpl {
    constructor(rpc) {
        this.rpc = rpc;
        this.CreateValidator = this.CreateValidator.bind(this);
        this.EditValidator = this.EditValidator.bind(this);
        this.Delegate = this.Delegate.bind(this);
        this.BeginRedelegate = this.BeginRedelegate.bind(this);
        this.Undelegate = this.Undelegate.bind(this);
        this.CancelUnbondingDelegation = this.CancelUnbondingDelegation.bind(this);
        this.UpdateParams = this.UpdateParams.bind(this);
    }
    CreateValidator(request) {
        const data = exports.MsgCreateValidator.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Msg", "CreateValidator", data);
        return promise.then((data) => exports.MsgCreateValidatorResponse.decode(new _m0.Reader(data)));
    }
    EditValidator(request) {
        const data = exports.MsgEditValidator.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Msg", "EditValidator", data);
        return promise.then((data) => exports.MsgEditValidatorResponse.decode(new _m0.Reader(data)));
    }
    Delegate(request) {
        const data = exports.MsgDelegate.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Msg", "Delegate", data);
        return promise.then((data) => exports.MsgDelegateResponse.decode(new _m0.Reader(data)));
    }
    BeginRedelegate(request) {
        const data = exports.MsgBeginRedelegate.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Msg", "BeginRedelegate", data);
        return promise.then((data) => exports.MsgBeginRedelegateResponse.decode(new _m0.Reader(data)));
    }
    Undelegate(request) {
        const data = exports.MsgUndelegate.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Msg", "Undelegate", data);
        return promise.then((data) => exports.MsgUndelegateResponse.decode(new _m0.Reader(data)));
    }
    CancelUnbondingDelegation(request) {
        const data = exports.MsgCancelUnbondingDelegation.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Msg", "CancelUnbondingDelegation", data);
        return promise.then((data) => exports.MsgCancelUnbondingDelegationResponse.decode(new _m0.Reader(data)));
    }
    UpdateParams(request) {
        const data = exports.MsgUpdateParams.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Msg", "UpdateParams", data);
        return promise.then((data) => exports.MsgUpdateParamsResponse.decode(new _m0.Reader(data)));
    }
}
exports.MsgClientImpl = MsgClientImpl;
//# sourceMappingURL=tx.js.map

/***/ }),

/***/ 83397:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.SignatureDescriptor_Data_Multi = exports.SignatureDescriptor_Data_Single = exports.SignatureDescriptor_Data = exports.SignatureDescriptor = exports.SignatureDescriptors = exports.signModeToJSON = exports.signModeFromJSON = exports.SignMode = exports.protobufPackage = void 0;
/* eslint-disable */
const multisig_1 = __webpack_require__(50140);
const any_1 = __webpack_require__(75654);
const helpers_1 = __webpack_require__(92654);
const _m0 = __importStar(__webpack_require__(62100));
exports.protobufPackage = "cosmos.tx.signing.v1beta1";
/**
 * SignMode represents a signing mode with its own security guarantees.
 *
 * This enum should be considered a registry of all known sign modes
 * in the Cosmos ecosystem. Apps are not expected to support all known
 * sign modes. Apps that would like to support custom  sign modes are
 * encouraged to open a small PR against this file to add a new case
 * to this SignMode enum describing their sign mode so that different
 * apps have a consistent version of this enum.
 */
var SignMode;
(function (SignMode) {
    /**
     * SIGN_MODE_UNSPECIFIED - SIGN_MODE_UNSPECIFIED specifies an unknown signing mode and will be
     * rejected.
     */
    SignMode[SignMode["SIGN_MODE_UNSPECIFIED"] = 0] = "SIGN_MODE_UNSPECIFIED";
    /**
     * SIGN_MODE_DIRECT - SIGN_MODE_DIRECT specifies a signing mode which uses SignDoc and is
     * verified with raw bytes from Tx.
     */
    SignMode[SignMode["SIGN_MODE_DIRECT"] = 1] = "SIGN_MODE_DIRECT";
    /**
     * SIGN_MODE_TEXTUAL - SIGN_MODE_TEXTUAL is a future signing mode that will verify some
     * human-readable textual representation on top of the binary representation
     * from SIGN_MODE_DIRECT. It is currently not supported.
     */
    SignMode[SignMode["SIGN_MODE_TEXTUAL"] = 2] = "SIGN_MODE_TEXTUAL";
    /**
     * SIGN_MODE_DIRECT_AUX - SIGN_MODE_DIRECT_AUX specifies a signing mode which uses
     * SignDocDirectAux. As opposed to SIGN_MODE_DIRECT, this sign mode does not
     * require signers signing over other signers' `signer_info`. It also allows
     * for adding Tips in transactions.
     *
     * Since: cosmos-sdk 0.46
     */
    SignMode[SignMode["SIGN_MODE_DIRECT_AUX"] = 3] = "SIGN_MODE_DIRECT_AUX";
    /**
     * SIGN_MODE_LEGACY_AMINO_JSON - SIGN_MODE_LEGACY_AMINO_JSON is a backwards compatibility mode which uses
     * Amino JSON and will be removed in the future.
     */
    SignMode[SignMode["SIGN_MODE_LEGACY_AMINO_JSON"] = 127] = "SIGN_MODE_LEGACY_AMINO_JSON";
    /**
     * SIGN_MODE_EIP_191 - SIGN_MODE_EIP_191 specifies the sign mode for EIP 191 signing on the Cosmos
     * SDK. Ref: https://eips.ethereum.org/EIPS/eip-191
     *
     * Currently, SIGN_MODE_EIP_191 is registered as a SignMode enum variant,
     * but is not implemented on the SDK by default. To enable EIP-191, you need
     * to pass a custom `TxConfig` that has an implementation of
     * `SignModeHandler` for EIP-191. The SDK may decide to fully support
     * EIP-191 in the future.
     *
     * Since: cosmos-sdk 0.45.2
     */
    SignMode[SignMode["SIGN_MODE_EIP_191"] = 191] = "SIGN_MODE_EIP_191";
    SignMode[SignMode["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(SignMode = exports.SignMode || (exports.SignMode = {}));
function signModeFromJSON(object) {
    switch (object) {
        case 0:
        case "SIGN_MODE_UNSPECIFIED":
            return SignMode.SIGN_MODE_UNSPECIFIED;
        case 1:
        case "SIGN_MODE_DIRECT":
            return SignMode.SIGN_MODE_DIRECT;
        case 2:
        case "SIGN_MODE_TEXTUAL":
            return SignMode.SIGN_MODE_TEXTUAL;
        case 3:
        case "SIGN_MODE_DIRECT_AUX":
            return SignMode.SIGN_MODE_DIRECT_AUX;
        case 127:
        case "SIGN_MODE_LEGACY_AMINO_JSON":
            return SignMode.SIGN_MODE_LEGACY_AMINO_JSON;
        case 191:
        case "SIGN_MODE_EIP_191":
            return SignMode.SIGN_MODE_EIP_191;
        case -1:
        case "UNRECOGNIZED":
        default:
            return SignMode.UNRECOGNIZED;
    }
}
exports.signModeFromJSON = signModeFromJSON;
function signModeToJSON(object) {
    switch (object) {
        case SignMode.SIGN_MODE_UNSPECIFIED:
            return "SIGN_MODE_UNSPECIFIED";
        case SignMode.SIGN_MODE_DIRECT:
            return "SIGN_MODE_DIRECT";
        case SignMode.SIGN_MODE_TEXTUAL:
            return "SIGN_MODE_TEXTUAL";
        case SignMode.SIGN_MODE_DIRECT_AUX:
            return "SIGN_MODE_DIRECT_AUX";
        case SignMode.SIGN_MODE_LEGACY_AMINO_JSON:
            return "SIGN_MODE_LEGACY_AMINO_JSON";
        case SignMode.SIGN_MODE_EIP_191:
            return "SIGN_MODE_EIP_191";
        case SignMode.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.signModeToJSON = signModeToJSON;
function createBaseSignatureDescriptors() {
    return {
        signatures: [],
    };
}
exports.SignatureDescriptors = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.signatures) {
            exports.SignatureDescriptor.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSignatureDescriptors();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.signatures.push(exports.SignatureDescriptor.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            signatures: Array.isArray(object?.signatures)
                ? object.signatures.map((e) => exports.SignatureDescriptor.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.signatures) {
            obj.signatures = message.signatures.map((e) => (e ? exports.SignatureDescriptor.toJSON(e) : undefined));
        }
        else {
            obj.signatures = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseSignatureDescriptors();
        message.signatures = object.signatures?.map((e) => exports.SignatureDescriptor.fromPartial(e)) || [];
        return message;
    },
};
function createBaseSignatureDescriptor() {
    return {
        publicKey: undefined,
        data: undefined,
        sequence: helpers_1.Long.UZERO,
    };
}
exports.SignatureDescriptor = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.publicKey !== undefined) {
            any_1.Any.encode(message.publicKey, writer.uint32(10).fork()).ldelim();
        }
        if (message.data !== undefined) {
            exports.SignatureDescriptor_Data.encode(message.data, writer.uint32(18).fork()).ldelim();
        }
        if (!message.sequence.isZero()) {
            writer.uint32(24).uint64(message.sequence);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSignatureDescriptor();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.publicKey = any_1.Any.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.data = exports.SignatureDescriptor_Data.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.sequence = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            publicKey: (0, helpers_1.isSet)(object.publicKey) ? any_1.Any.fromJSON(object.publicKey) : undefined,
            data: (0, helpers_1.isSet)(object.data) ? exports.SignatureDescriptor_Data.fromJSON(object.data) : undefined,
            sequence: (0, helpers_1.isSet)(object.sequence) ? helpers_1.Long.fromValue(object.sequence) : helpers_1.Long.UZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        message.publicKey !== undefined &&
            (obj.publicKey = message.publicKey ? any_1.Any.toJSON(message.publicKey) : undefined);
        message.data !== undefined &&
            (obj.data = message.data ? exports.SignatureDescriptor_Data.toJSON(message.data) : undefined);
        message.sequence !== undefined && (obj.sequence = (message.sequence || helpers_1.Long.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseSignatureDescriptor();
        message.publicKey =
            object.publicKey !== undefined && object.publicKey !== null
                ? any_1.Any.fromPartial(object.publicKey)
                : undefined;
        message.data =
            object.data !== undefined && object.data !== null
                ? exports.SignatureDescriptor_Data.fromPartial(object.data)
                : undefined;
        message.sequence =
            object.sequence !== undefined && object.sequence !== null
                ? helpers_1.Long.fromValue(object.sequence)
                : helpers_1.Long.UZERO;
        return message;
    },
};
function createBaseSignatureDescriptor_Data() {
    return {
        single: undefined,
        multi: undefined,
    };
}
exports.SignatureDescriptor_Data = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.single !== undefined) {
            exports.SignatureDescriptor_Data_Single.encode(message.single, writer.uint32(10).fork()).ldelim();
        }
        if (message.multi !== undefined) {
            exports.SignatureDescriptor_Data_Multi.encode(message.multi, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSignatureDescriptor_Data();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.single = exports.SignatureDescriptor_Data_Single.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.multi = exports.SignatureDescriptor_Data_Multi.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            single: (0, helpers_1.isSet)(object.single) ? exports.SignatureDescriptor_Data_Single.fromJSON(object.single) : undefined,
            multi: (0, helpers_1.isSet)(object.multi) ? exports.SignatureDescriptor_Data_Multi.fromJSON(object.multi) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.single !== undefined &&
            (obj.single = message.single ? exports.SignatureDescriptor_Data_Single.toJSON(message.single) : undefined);
        message.multi !== undefined &&
            (obj.multi = message.multi ? exports.SignatureDescriptor_Data_Multi.toJSON(message.multi) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseSignatureDescriptor_Data();
        message.single =
            object.single !== undefined && object.single !== null
                ? exports.SignatureDescriptor_Data_Single.fromPartial(object.single)
                : undefined;
        message.multi =
            object.multi !== undefined && object.multi !== null
                ? exports.SignatureDescriptor_Data_Multi.fromPartial(object.multi)
                : undefined;
        return message;
    },
};
function createBaseSignatureDescriptor_Data_Single() {
    return {
        mode: 0,
        signature: new Uint8Array(),
    };
}
exports.SignatureDescriptor_Data_Single = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.mode !== 0) {
            writer.uint32(8).int32(message.mode);
        }
        if (message.signature.length !== 0) {
            writer.uint32(18).bytes(message.signature);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSignatureDescriptor_Data_Single();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.mode = reader.int32();
                    break;
                case 2:
                    message.signature = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            mode: (0, helpers_1.isSet)(object.mode) ? signModeFromJSON(object.mode) : 0,
            signature: (0, helpers_1.isSet)(object.signature) ? (0, helpers_1.bytesFromBase64)(object.signature) : new Uint8Array(),
        };
    },
    toJSON(message) {
        const obj = {};
        message.mode !== undefined && (obj.mode = signModeToJSON(message.mode));
        message.signature !== undefined &&
            (obj.signature = (0, helpers_1.base64FromBytes)(message.signature !== undefined ? message.signature : new Uint8Array()));
        return obj;
    },
    fromPartial(object) {
        const message = createBaseSignatureDescriptor_Data_Single();
        message.mode = object.mode ?? 0;
        message.signature = object.signature ?? new Uint8Array();
        return message;
    },
};
function createBaseSignatureDescriptor_Data_Multi() {
    return {
        bitarray: undefined,
        signatures: [],
    };
}
exports.SignatureDescriptor_Data_Multi = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.bitarray !== undefined) {
            multisig_1.CompactBitArray.encode(message.bitarray, writer.uint32(10).fork()).ldelim();
        }
        for (const v of message.signatures) {
            exports.SignatureDescriptor_Data.encode(v, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSignatureDescriptor_Data_Multi();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.bitarray = multisig_1.CompactBitArray.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.signatures.push(exports.SignatureDescriptor_Data.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            bitarray: (0, helpers_1.isSet)(object.bitarray) ? multisig_1.CompactBitArray.fromJSON(object.bitarray) : undefined,
            signatures: Array.isArray(object?.signatures)
                ? object.signatures.map((e) => exports.SignatureDescriptor_Data.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        message.bitarray !== undefined &&
            (obj.bitarray = message.bitarray ? multisig_1.CompactBitArray.toJSON(message.bitarray) : undefined);
        if (message.signatures) {
            obj.signatures = message.signatures.map((e) => (e ? exports.SignatureDescriptor_Data.toJSON(e) : undefined));
        }
        else {
            obj.signatures = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseSignatureDescriptor_Data_Multi();
        message.bitarray =
            object.bitarray !== undefined && object.bitarray !== null
                ? multisig_1.CompactBitArray.fromPartial(object.bitarray)
                : undefined;
        message.signatures = object.signatures?.map((e) => exports.SignatureDescriptor_Data.fromPartial(e)) || [];
        return message;
    },
};
//# sourceMappingURL=signing.js.map

/***/ }),

/***/ 34184:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ServiceClientImpl = exports.TxDecodeAminoResponse = exports.TxDecodeAminoRequest = exports.TxEncodeAminoResponse = exports.TxEncodeAminoRequest = exports.TxEncodeResponse = exports.TxEncodeRequest = exports.TxDecodeResponse = exports.TxDecodeRequest = exports.GetBlockWithTxsResponse = exports.GetBlockWithTxsRequest = exports.GetTxResponse = exports.GetTxRequest = exports.SimulateResponse = exports.SimulateRequest = exports.BroadcastTxResponse = exports.BroadcastTxRequest = exports.GetTxsEventResponse = exports.GetTxsEventRequest = exports.broadcastModeToJSON = exports.broadcastModeFromJSON = exports.BroadcastMode = exports.orderByToJSON = exports.orderByFromJSON = exports.OrderBy = exports.protobufPackage = void 0;
/* eslint-disable */
const tx_1 = __webpack_require__(17921);
const pagination_1 = __webpack_require__(84043);
const abci_1 = __webpack_require__(7088);
const types_1 = __webpack_require__(34681);
const block_1 = __webpack_require__(25512);
const helpers_1 = __webpack_require__(92654);
const _m0 = __importStar(__webpack_require__(62100));
exports.protobufPackage = "cosmos.tx.v1beta1";
/** OrderBy defines the sorting order */
var OrderBy;
(function (OrderBy) {
    /** ORDER_BY_UNSPECIFIED - ORDER_BY_UNSPECIFIED specifies an unknown sorting order. OrderBy defaults to ASC in this case. */
    OrderBy[OrderBy["ORDER_BY_UNSPECIFIED"] = 0] = "ORDER_BY_UNSPECIFIED";
    /** ORDER_BY_ASC - ORDER_BY_ASC defines ascending order */
    OrderBy[OrderBy["ORDER_BY_ASC"] = 1] = "ORDER_BY_ASC";
    /** ORDER_BY_DESC - ORDER_BY_DESC defines descending order */
    OrderBy[OrderBy["ORDER_BY_DESC"] = 2] = "ORDER_BY_DESC";
    OrderBy[OrderBy["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(OrderBy = exports.OrderBy || (exports.OrderBy = {}));
function orderByFromJSON(object) {
    switch (object) {
        case 0:
        case "ORDER_BY_UNSPECIFIED":
            return OrderBy.ORDER_BY_UNSPECIFIED;
        case 1:
        case "ORDER_BY_ASC":
            return OrderBy.ORDER_BY_ASC;
        case 2:
        case "ORDER_BY_DESC":
            return OrderBy.ORDER_BY_DESC;
        case -1:
        case "UNRECOGNIZED":
        default:
            return OrderBy.UNRECOGNIZED;
    }
}
exports.orderByFromJSON = orderByFromJSON;
function orderByToJSON(object) {
    switch (object) {
        case OrderBy.ORDER_BY_UNSPECIFIED:
            return "ORDER_BY_UNSPECIFIED";
        case OrderBy.ORDER_BY_ASC:
            return "ORDER_BY_ASC";
        case OrderBy.ORDER_BY_DESC:
            return "ORDER_BY_DESC";
        case OrderBy.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.orderByToJSON = orderByToJSON;
/** BroadcastMode specifies the broadcast mode for the TxService.Broadcast RPC method. */
var BroadcastMode;
(function (BroadcastMode) {
    /** BROADCAST_MODE_UNSPECIFIED - zero-value for mode ordering */
    BroadcastMode[BroadcastMode["BROADCAST_MODE_UNSPECIFIED"] = 0] = "BROADCAST_MODE_UNSPECIFIED";
    /**
     * BROADCAST_MODE_BLOCK - DEPRECATED: use BROADCAST_MODE_SYNC instead,
     * BROADCAST_MODE_BLOCK is not supported by the SDK from v0.47.x onwards.
     */
    BroadcastMode[BroadcastMode["BROADCAST_MODE_BLOCK"] = 1] = "BROADCAST_MODE_BLOCK";
    /**
     * BROADCAST_MODE_SYNC - BROADCAST_MODE_SYNC defines a tx broadcasting mode where the client waits for
     * a CheckTx execution response only.
     */
    BroadcastMode[BroadcastMode["BROADCAST_MODE_SYNC"] = 2] = "BROADCAST_MODE_SYNC";
    /**
     * BROADCAST_MODE_ASYNC - BROADCAST_MODE_ASYNC defines a tx broadcasting mode where the client returns
     * immediately.
     */
    BroadcastMode[BroadcastMode["BROADCAST_MODE_ASYNC"] = 3] = "BROADCAST_MODE_ASYNC";
    BroadcastMode[BroadcastMode["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(BroadcastMode = exports.BroadcastMode || (exports.BroadcastMode = {}));
function broadcastModeFromJSON(object) {
    switch (object) {
        case 0:
        case "BROADCAST_MODE_UNSPECIFIED":
            return BroadcastMode.BROADCAST_MODE_UNSPECIFIED;
        case 1:
        case "BROADCAST_MODE_BLOCK":
            return BroadcastMode.BROADCAST_MODE_BLOCK;
        case 2:
        case "BROADCAST_MODE_SYNC":
            return BroadcastMode.BROADCAST_MODE_SYNC;
        case 3:
        case "BROADCAST_MODE_ASYNC":
            return BroadcastMode.BROADCAST_MODE_ASYNC;
        case -1:
        case "UNRECOGNIZED":
        default:
            return BroadcastMode.UNRECOGNIZED;
    }
}
exports.broadcastModeFromJSON = broadcastModeFromJSON;
function broadcastModeToJSON(object) {
    switch (object) {
        case BroadcastMode.BROADCAST_MODE_UNSPECIFIED:
            return "BROADCAST_MODE_UNSPECIFIED";
        case BroadcastMode.BROADCAST_MODE_BLOCK:
            return "BROADCAST_MODE_BLOCK";
        case BroadcastMode.BROADCAST_MODE_SYNC:
            return "BROADCAST_MODE_SYNC";
        case BroadcastMode.BROADCAST_MODE_ASYNC:
            return "BROADCAST_MODE_ASYNC";
        case BroadcastMode.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.broadcastModeToJSON = broadcastModeToJSON;
function createBaseGetTxsEventRequest() {
    return {
        events: [],
        pagination: undefined,
        orderBy: 0,
        page: helpers_1.Long.UZERO,
        limit: helpers_1.Long.UZERO,
    };
}
exports.GetTxsEventRequest = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.events) {
            writer.uint32(10).string(v);
        }
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        if (message.orderBy !== 0) {
            writer.uint32(24).int32(message.orderBy);
        }
        if (!message.page.isZero()) {
            writer.uint32(32).uint64(message.page);
        }
        if (!message.limit.isZero()) {
            writer.uint32(40).uint64(message.limit);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetTxsEventRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.events.push(reader.string());
                    break;
                case 2:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.orderBy = reader.int32();
                    break;
                case 4:
                    message.page = reader.uint64();
                    break;
                case 5:
                    message.limit = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            events: Array.isArray(object?.events) ? object.events.map((e) => String(e)) : [],
            pagination: (0, helpers_1.isSet)(object.pagination) ? pagination_1.PageRequest.fromJSON(object.pagination) : undefined,
            orderBy: (0, helpers_1.isSet)(object.orderBy) ? orderByFromJSON(object.orderBy) : 0,
            page: (0, helpers_1.isSet)(object.page) ? helpers_1.Long.fromValue(object.page) : helpers_1.Long.UZERO,
            limit: (0, helpers_1.isSet)(object.limit) ? helpers_1.Long.fromValue(object.limit) : helpers_1.Long.UZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.events) {
            obj.events = message.events.map((e) => e);
        }
        else {
            obj.events = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageRequest.toJSON(message.pagination) : undefined);
        message.orderBy !== undefined && (obj.orderBy = orderByToJSON(message.orderBy));
        message.page !== undefined && (obj.page = (message.page || helpers_1.Long.UZERO).toString());
        message.limit !== undefined && (obj.limit = (message.limit || helpers_1.Long.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseGetTxsEventRequest();
        message.events = object.events?.map((e) => e) || [];
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        message.orderBy = object.orderBy ?? 0;
        message.page =
            object.page !== undefined && object.page !== null ? helpers_1.Long.fromValue(object.page) : helpers_1.Long.UZERO;
        message.limit =
            object.limit !== undefined && object.limit !== null ? helpers_1.Long.fromValue(object.limit) : helpers_1.Long.UZERO;
        return message;
    },
};
function createBaseGetTxsEventResponse() {
    return {
        txs: [],
        txResponses: [],
        pagination: undefined,
        total: helpers_1.Long.UZERO,
    };
}
exports.GetTxsEventResponse = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.txs) {
            tx_1.Tx.encode(v, writer.uint32(10).fork()).ldelim();
        }
        for (const v of message.txResponses) {
            abci_1.TxResponse.encode(v, writer.uint32(18).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(26).fork()).ldelim();
        }
        if (!message.total.isZero()) {
            writer.uint32(32).uint64(message.total);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetTxsEventResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.txs.push(tx_1.Tx.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.txResponses.push(abci_1.TxResponse.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.total = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            txs: Array.isArray(object?.txs) ? object.txs.map((e) => tx_1.Tx.fromJSON(e)) : [],
            txResponses: Array.isArray(object?.txResponses)
                ? object.txResponses.map((e) => abci_1.TxResponse.fromJSON(e))
                : [],
            pagination: (0, helpers_1.isSet)(object.pagination) ? pagination_1.PageResponse.fromJSON(object.pagination) : undefined,
            total: (0, helpers_1.isSet)(object.total) ? helpers_1.Long.fromValue(object.total) : helpers_1.Long.UZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.txs) {
            obj.txs = message.txs.map((e) => (e ? tx_1.Tx.toJSON(e) : undefined));
        }
        else {
            obj.txs = [];
        }
        if (message.txResponses) {
            obj.txResponses = message.txResponses.map((e) => (e ? abci_1.TxResponse.toJSON(e) : undefined));
        }
        else {
            obj.txResponses = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageResponse.toJSON(message.pagination) : undefined);
        message.total !== undefined && (obj.total = (message.total || helpers_1.Long.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseGetTxsEventResponse();
        message.txs = object.txs?.map((e) => tx_1.Tx.fromPartial(e)) || [];
        message.txResponses = object.txResponses?.map((e) => abci_1.TxResponse.fromPartial(e)) || [];
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        message.total =
            object.total !== undefined && object.total !== null ? helpers_1.Long.fromValue(object.total) : helpers_1.Long.UZERO;
        return message;
    },
};
function createBaseBroadcastTxRequest() {
    return {
        txBytes: new Uint8Array(),
        mode: 0,
    };
}
exports.BroadcastTxRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.txBytes.length !== 0) {
            writer.uint32(10).bytes(message.txBytes);
        }
        if (message.mode !== 0) {
            writer.uint32(16).int32(message.mode);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseBroadcastTxRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.txBytes = reader.bytes();
                    break;
                case 2:
                    message.mode = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            txBytes: (0, helpers_1.isSet)(object.txBytes) ? (0, helpers_1.bytesFromBase64)(object.txBytes) : new Uint8Array(),
            mode: (0, helpers_1.isSet)(object.mode) ? broadcastModeFromJSON(object.mode) : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        message.txBytes !== undefined &&
            (obj.txBytes = (0, helpers_1.base64FromBytes)(message.txBytes !== undefined ? message.txBytes : new Uint8Array()));
        message.mode !== undefined && (obj.mode = broadcastModeToJSON(message.mode));
        return obj;
    },
    fromPartial(object) {
        const message = createBaseBroadcastTxRequest();
        message.txBytes = object.txBytes ?? new Uint8Array();
        message.mode = object.mode ?? 0;
        return message;
    },
};
function createBaseBroadcastTxResponse() {
    return {
        txResponse: undefined,
    };
}
exports.BroadcastTxResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.txResponse !== undefined) {
            abci_1.TxResponse.encode(message.txResponse, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseBroadcastTxResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.txResponse = abci_1.TxResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            txResponse: (0, helpers_1.isSet)(object.txResponse) ? abci_1.TxResponse.fromJSON(object.txResponse) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.txResponse !== undefined &&
            (obj.txResponse = message.txResponse ? abci_1.TxResponse.toJSON(message.txResponse) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseBroadcastTxResponse();
        message.txResponse =
            object.txResponse !== undefined && object.txResponse !== null
                ? abci_1.TxResponse.fromPartial(object.txResponse)
                : undefined;
        return message;
    },
};
function createBaseSimulateRequest() {
    return {
        tx: undefined,
        txBytes: new Uint8Array(),
    };
}
exports.SimulateRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.tx !== undefined) {
            tx_1.Tx.encode(message.tx, writer.uint32(10).fork()).ldelim();
        }
        if (message.txBytes.length !== 0) {
            writer.uint32(18).bytes(message.txBytes);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSimulateRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.tx = tx_1.Tx.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.txBytes = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            tx: (0, helpers_1.isSet)(object.tx) ? tx_1.Tx.fromJSON(object.tx) : undefined,
            txBytes: (0, helpers_1.isSet)(object.txBytes) ? (0, helpers_1.bytesFromBase64)(object.txBytes) : new Uint8Array(),
        };
    },
    toJSON(message) {
        const obj = {};
        message.tx !== undefined && (obj.tx = message.tx ? tx_1.Tx.toJSON(message.tx) : undefined);
        message.txBytes !== undefined &&
            (obj.txBytes = (0, helpers_1.base64FromBytes)(message.txBytes !== undefined ? message.txBytes : new Uint8Array()));
        return obj;
    },
    fromPartial(object) {
        const message = createBaseSimulateRequest();
        message.tx = object.tx !== undefined && object.tx !== null ? tx_1.Tx.fromPartial(object.tx) : undefined;
        message.txBytes = object.txBytes ?? new Uint8Array();
        return message;
    },
};
function createBaseSimulateResponse() {
    return {
        gasInfo: undefined,
        result: undefined,
    };
}
exports.SimulateResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.gasInfo !== undefined) {
            abci_1.GasInfo.encode(message.gasInfo, writer.uint32(10).fork()).ldelim();
        }
        if (message.result !== undefined) {
            abci_1.Result.encode(message.result, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSimulateResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.gasInfo = abci_1.GasInfo.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.result = abci_1.Result.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            gasInfo: (0, helpers_1.isSet)(object.gasInfo) ? abci_1.GasInfo.fromJSON(object.gasInfo) : undefined,
            result: (0, helpers_1.isSet)(object.result) ? abci_1.Result.fromJSON(object.result) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.gasInfo !== undefined &&
            (obj.gasInfo = message.gasInfo ? abci_1.GasInfo.toJSON(message.gasInfo) : undefined);
        message.result !== undefined && (obj.result = message.result ? abci_1.Result.toJSON(message.result) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseSimulateResponse();
        message.gasInfo =
            object.gasInfo !== undefined && object.gasInfo !== null
                ? abci_1.GasInfo.fromPartial(object.gasInfo)
                : undefined;
        message.result =
            object.result !== undefined && object.result !== null ? abci_1.Result.fromPartial(object.result) : undefined;
        return message;
    },
};
function createBaseGetTxRequest() {
    return {
        hash: "",
    };
}
exports.GetTxRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.hash !== "") {
            writer.uint32(10).string(message.hash);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetTxRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.hash = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            hash: (0, helpers_1.isSet)(object.hash) ? String(object.hash) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.hash !== undefined && (obj.hash = message.hash);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseGetTxRequest();
        message.hash = object.hash ?? "";
        return message;
    },
};
function createBaseGetTxResponse() {
    return {
        tx: undefined,
        txResponse: undefined,
    };
}
exports.GetTxResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.tx !== undefined) {
            tx_1.Tx.encode(message.tx, writer.uint32(10).fork()).ldelim();
        }
        if (message.txResponse !== undefined) {
            abci_1.TxResponse.encode(message.txResponse, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetTxResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.tx = tx_1.Tx.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.txResponse = abci_1.TxResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            tx: (0, helpers_1.isSet)(object.tx) ? tx_1.Tx.fromJSON(object.tx) : undefined,
            txResponse: (0, helpers_1.isSet)(object.txResponse) ? abci_1.TxResponse.fromJSON(object.txResponse) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.tx !== undefined && (obj.tx = message.tx ? tx_1.Tx.toJSON(message.tx) : undefined);
        message.txResponse !== undefined &&
            (obj.txResponse = message.txResponse ? abci_1.TxResponse.toJSON(message.txResponse) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseGetTxResponse();
        message.tx = object.tx !== undefined && object.tx !== null ? tx_1.Tx.fromPartial(object.tx) : undefined;
        message.txResponse =
            object.txResponse !== undefined && object.txResponse !== null
                ? abci_1.TxResponse.fromPartial(object.txResponse)
                : undefined;
        return message;
    },
};
function createBaseGetBlockWithTxsRequest() {
    return {
        height: helpers_1.Long.ZERO,
        pagination: undefined,
    };
}
exports.GetBlockWithTxsRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (!message.height.isZero()) {
            writer.uint32(8).int64(message.height);
        }
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetBlockWithTxsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.height = reader.int64();
                    break;
                case 2:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            height: (0, helpers_1.isSet)(object.height) ? helpers_1.Long.fromValue(object.height) : helpers_1.Long.ZERO,
            pagination: (0, helpers_1.isSet)(object.pagination) ? pagination_1.PageRequest.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.height !== undefined && (obj.height = (message.height || helpers_1.Long.ZERO).toString());
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseGetBlockWithTxsRequest();
        message.height =
            object.height !== undefined && object.height !== null ? helpers_1.Long.fromValue(object.height) : helpers_1.Long.ZERO;
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseGetBlockWithTxsResponse() {
    return {
        txs: [],
        blockId: undefined,
        block: undefined,
        pagination: undefined,
    };
}
exports.GetBlockWithTxsResponse = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.txs) {
            tx_1.Tx.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.blockId !== undefined) {
            types_1.BlockID.encode(message.blockId, writer.uint32(18).fork()).ldelim();
        }
        if (message.block !== undefined) {
            block_1.Block.encode(message.block, writer.uint32(26).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetBlockWithTxsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.txs.push(tx_1.Tx.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.blockId = types_1.BlockID.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.block = block_1.Block.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            txs: Array.isArray(object?.txs) ? object.txs.map((e) => tx_1.Tx.fromJSON(e)) : [],
            blockId: (0, helpers_1.isSet)(object.blockId) ? types_1.BlockID.fromJSON(object.blockId) : undefined,
            block: (0, helpers_1.isSet)(object.block) ? block_1.Block.fromJSON(object.block) : undefined,
            pagination: (0, helpers_1.isSet)(object.pagination) ? pagination_1.PageResponse.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.txs) {
            obj.txs = message.txs.map((e) => (e ? tx_1.Tx.toJSON(e) : undefined));
        }
        else {
            obj.txs = [];
        }
        message.blockId !== undefined &&
            (obj.blockId = message.blockId ? types_1.BlockID.toJSON(message.blockId) : undefined);
        message.block !== undefined && (obj.block = message.block ? block_1.Block.toJSON(message.block) : undefined);
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseGetBlockWithTxsResponse();
        message.txs = object.txs?.map((e) => tx_1.Tx.fromPartial(e)) || [];
        message.blockId =
            object.blockId !== undefined && object.blockId !== null
                ? types_1.BlockID.fromPartial(object.blockId)
                : undefined;
        message.block =
            object.block !== undefined && object.block !== null ? block_1.Block.fromPartial(object.block) : undefined;
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseTxDecodeRequest() {
    return {
        txBytes: new Uint8Array(),
    };
}
exports.TxDecodeRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.txBytes.length !== 0) {
            writer.uint32(10).bytes(message.txBytes);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTxDecodeRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.txBytes = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            txBytes: (0, helpers_1.isSet)(object.txBytes) ? (0, helpers_1.bytesFromBase64)(object.txBytes) : new Uint8Array(),
        };
    },
    toJSON(message) {
        const obj = {};
        message.txBytes !== undefined &&
            (obj.txBytes = (0, helpers_1.base64FromBytes)(message.txBytes !== undefined ? message.txBytes : new Uint8Array()));
        return obj;
    },
    fromPartial(object) {
        const message = createBaseTxDecodeRequest();
        message.txBytes = object.txBytes ?? new Uint8Array();
        return message;
    },
};
function createBaseTxDecodeResponse() {
    return {
        tx: undefined,
    };
}
exports.TxDecodeResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.tx !== undefined) {
            tx_1.Tx.encode(message.tx, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTxDecodeResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.tx = tx_1.Tx.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            tx: (0, helpers_1.isSet)(object.tx) ? tx_1.Tx.fromJSON(object.tx) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.tx !== undefined && (obj.tx = message.tx ? tx_1.Tx.toJSON(message.tx) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseTxDecodeResponse();
        message.tx = object.tx !== undefined && object.tx !== null ? tx_1.Tx.fromPartial(object.tx) : undefined;
        return message;
    },
};
function createBaseTxEncodeRequest() {
    return {
        tx: undefined,
    };
}
exports.TxEncodeRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.tx !== undefined) {
            tx_1.Tx.encode(message.tx, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTxEncodeRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.tx = tx_1.Tx.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            tx: (0, helpers_1.isSet)(object.tx) ? tx_1.Tx.fromJSON(object.tx) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.tx !== undefined && (obj.tx = message.tx ? tx_1.Tx.toJSON(message.tx) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseTxEncodeRequest();
        message.tx = object.tx !== undefined && object.tx !== null ? tx_1.Tx.fromPartial(object.tx) : undefined;
        return message;
    },
};
function createBaseTxEncodeResponse() {
    return {
        txBytes: new Uint8Array(),
    };
}
exports.TxEncodeResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.txBytes.length !== 0) {
            writer.uint32(10).bytes(message.txBytes);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTxEncodeResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.txBytes = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            txBytes: (0, helpers_1.isSet)(object.txBytes) ? (0, helpers_1.bytesFromBase64)(object.txBytes) : new Uint8Array(),
        };
    },
    toJSON(message) {
        const obj = {};
        message.txBytes !== undefined &&
            (obj.txBytes = (0, helpers_1.base64FromBytes)(message.txBytes !== undefined ? message.txBytes : new Uint8Array()));
        return obj;
    },
    fromPartial(object) {
        const message = createBaseTxEncodeResponse();
        message.txBytes = object.txBytes ?? new Uint8Array();
        return message;
    },
};
function createBaseTxEncodeAminoRequest() {
    return {
        aminoJson: "",
    };
}
exports.TxEncodeAminoRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.aminoJson !== "") {
            writer.uint32(10).string(message.aminoJson);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTxEncodeAminoRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.aminoJson = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            aminoJson: (0, helpers_1.isSet)(object.aminoJson) ? String(object.aminoJson) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.aminoJson !== undefined && (obj.aminoJson = message.aminoJson);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseTxEncodeAminoRequest();
        message.aminoJson = object.aminoJson ?? "";
        return message;
    },
};
function createBaseTxEncodeAminoResponse() {
    return {
        aminoBinary: new Uint8Array(),
    };
}
exports.TxEncodeAminoResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.aminoBinary.length !== 0) {
            writer.uint32(10).bytes(message.aminoBinary);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTxEncodeAminoResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.aminoBinary = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            aminoBinary: (0, helpers_1.isSet)(object.aminoBinary) ? (0, helpers_1.bytesFromBase64)(object.aminoBinary) : new Uint8Array(),
        };
    },
    toJSON(message) {
        const obj = {};
        message.aminoBinary !== undefined &&
            (obj.aminoBinary = (0, helpers_1.base64FromBytes)(message.aminoBinary !== undefined ? message.aminoBinary : new Uint8Array()));
        return obj;
    },
    fromPartial(object) {
        const message = createBaseTxEncodeAminoResponse();
        message.aminoBinary = object.aminoBinary ?? new Uint8Array();
        return message;
    },
};
function createBaseTxDecodeAminoRequest() {
    return {
        aminoBinary: new Uint8Array(),
    };
}
exports.TxDecodeAminoRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.aminoBinary.length !== 0) {
            writer.uint32(10).bytes(message.aminoBinary);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTxDecodeAminoRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.aminoBinary = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            aminoBinary: (0, helpers_1.isSet)(object.aminoBinary) ? (0, helpers_1.bytesFromBase64)(object.aminoBinary) : new Uint8Array(),
        };
    },
    toJSON(message) {
        const obj = {};
        message.aminoBinary !== undefined &&
            (obj.aminoBinary = (0, helpers_1.base64FromBytes)(message.aminoBinary !== undefined ? message.aminoBinary : new Uint8Array()));
        return obj;
    },
    fromPartial(object) {
        const message = createBaseTxDecodeAminoRequest();
        message.aminoBinary = object.aminoBinary ?? new Uint8Array();
        return message;
    },
};
function createBaseTxDecodeAminoResponse() {
    return {
        aminoJson: "",
    };
}
exports.TxDecodeAminoResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.aminoJson !== "") {
            writer.uint32(10).string(message.aminoJson);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTxDecodeAminoResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.aminoJson = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            aminoJson: (0, helpers_1.isSet)(object.aminoJson) ? String(object.aminoJson) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.aminoJson !== undefined && (obj.aminoJson = message.aminoJson);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseTxDecodeAminoResponse();
        message.aminoJson = object.aminoJson ?? "";
        return message;
    },
};
class ServiceClientImpl {
    constructor(rpc) {
        this.rpc = rpc;
        this.Simulate = this.Simulate.bind(this);
        this.GetTx = this.GetTx.bind(this);
        this.BroadcastTx = this.BroadcastTx.bind(this);
        this.GetTxsEvent = this.GetTxsEvent.bind(this);
        this.GetBlockWithTxs = this.GetBlockWithTxs.bind(this);
        this.TxDecode = this.TxDecode.bind(this);
        this.TxEncode = this.TxEncode.bind(this);
        this.TxEncodeAmino = this.TxEncodeAmino.bind(this);
        this.TxDecodeAmino = this.TxDecodeAmino.bind(this);
    }
    Simulate(request) {
        const data = exports.SimulateRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.tx.v1beta1.Service", "Simulate", data);
        return promise.then((data) => exports.SimulateResponse.decode(new _m0.Reader(data)));
    }
    GetTx(request) {
        const data = exports.GetTxRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.tx.v1beta1.Service", "GetTx", data);
        return promise.then((data) => exports.GetTxResponse.decode(new _m0.Reader(data)));
    }
    BroadcastTx(request) {
        const data = exports.BroadcastTxRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.tx.v1beta1.Service", "BroadcastTx", data);
        return promise.then((data) => exports.BroadcastTxResponse.decode(new _m0.Reader(data)));
    }
    GetTxsEvent(request) {
        const data = exports.GetTxsEventRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.tx.v1beta1.Service", "GetTxsEvent", data);
        return promise.then((data) => exports.GetTxsEventResponse.decode(new _m0.Reader(data)));
    }
    GetBlockWithTxs(request) {
        const data = exports.GetBlockWithTxsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.tx.v1beta1.Service", "GetBlockWithTxs", data);
        return promise.then((data) => exports.GetBlockWithTxsResponse.decode(new _m0.Reader(data)));
    }
    TxDecode(request) {
        const data = exports.TxDecodeRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.tx.v1beta1.Service", "TxDecode", data);
        return promise.then((data) => exports.TxDecodeResponse.decode(new _m0.Reader(data)));
    }
    TxEncode(request) {
        const data = exports.TxEncodeRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.tx.v1beta1.Service", "TxEncode", data);
        return promise.then((data) => exports.TxEncodeResponse.decode(new _m0.Reader(data)));
    }
    TxEncodeAmino(request) {
        const data = exports.TxEncodeAminoRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.tx.v1beta1.Service", "TxEncodeAmino", data);
        return promise.then((data) => exports.TxEncodeAminoResponse.decode(new _m0.Reader(data)));
    }
    TxDecodeAmino(request) {
        const data = exports.TxDecodeAminoRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.tx.v1beta1.Service", "TxDecodeAmino", data);
        return promise.then((data) => exports.TxDecodeAminoResponse.decode(new _m0.Reader(data)));
    }
}
exports.ServiceClientImpl = ServiceClientImpl;
//# sourceMappingURL=service.js.map

/***/ }),

/***/ 17921:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.AuxSignerData = exports.Tip = exports.Fee = exports.ModeInfo_Multi = exports.ModeInfo_Single = exports.ModeInfo = exports.SignerInfo = exports.AuthInfo = exports.TxBody = exports.SignDocDirectAux = exports.SignDoc = exports.TxRaw = exports.Tx = exports.protobufPackage = void 0;
/* eslint-disable */
const any_1 = __webpack_require__(75654);
const signing_1 = __webpack_require__(83397);
const multisig_1 = __webpack_require__(50140);
const coin_1 = __webpack_require__(81637);
const helpers_1 = __webpack_require__(92654);
const _m0 = __importStar(__webpack_require__(62100));
exports.protobufPackage = "cosmos.tx.v1beta1";
function createBaseTx() {
    return {
        body: undefined,
        authInfo: undefined,
        signatures: [],
    };
}
exports.Tx = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.body !== undefined) {
            exports.TxBody.encode(message.body, writer.uint32(10).fork()).ldelim();
        }
        if (message.authInfo !== undefined) {
            exports.AuthInfo.encode(message.authInfo, writer.uint32(18).fork()).ldelim();
        }
        for (const v of message.signatures) {
            writer.uint32(26).bytes(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTx();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.body = exports.TxBody.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.authInfo = exports.AuthInfo.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.signatures.push(reader.bytes());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            body: (0, helpers_1.isSet)(object.body) ? exports.TxBody.fromJSON(object.body) : undefined,
            authInfo: (0, helpers_1.isSet)(object.authInfo) ? exports.AuthInfo.fromJSON(object.authInfo) : undefined,
            signatures: Array.isArray(object?.signatures)
                ? object.signatures.map((e) => (0, helpers_1.bytesFromBase64)(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        message.body !== undefined && (obj.body = message.body ? exports.TxBody.toJSON(message.body) : undefined);
        message.authInfo !== undefined &&
            (obj.authInfo = message.authInfo ? exports.AuthInfo.toJSON(message.authInfo) : undefined);
        if (message.signatures) {
            obj.signatures = message.signatures.map((e) => (0, helpers_1.base64FromBytes)(e !== undefined ? e : new Uint8Array()));
        }
        else {
            obj.signatures = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseTx();
        message.body =
            object.body !== undefined && object.body !== null ? exports.TxBody.fromPartial(object.body) : undefined;
        message.authInfo =
            object.authInfo !== undefined && object.authInfo !== null
                ? exports.AuthInfo.fromPartial(object.authInfo)
                : undefined;
        message.signatures = object.signatures?.map((e) => e) || [];
        return message;
    },
};
function createBaseTxRaw() {
    return {
        bodyBytes: new Uint8Array(),
        authInfoBytes: new Uint8Array(),
        signatures: [],
    };
}
exports.TxRaw = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.bodyBytes.length !== 0) {
            writer.uint32(10).bytes(message.bodyBytes);
        }
        if (message.authInfoBytes.length !== 0) {
            writer.uint32(18).bytes(message.authInfoBytes);
        }
        for (const v of message.signatures) {
            writer.uint32(26).bytes(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTxRaw();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.bodyBytes = reader.bytes();
                    break;
                case 2:
                    message.authInfoBytes = reader.bytes();
                    break;
                case 3:
                    message.signatures.push(reader.bytes());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            bodyBytes: (0, helpers_1.isSet)(object.bodyBytes) ? (0, helpers_1.bytesFromBase64)(object.bodyBytes) : new Uint8Array(),
            authInfoBytes: (0, helpers_1.isSet)(object.authInfoBytes) ? (0, helpers_1.bytesFromBase64)(object.authInfoBytes) : new Uint8Array(),
            signatures: Array.isArray(object?.signatures)
                ? object.signatures.map((e) => (0, helpers_1.bytesFromBase64)(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        message.bodyBytes !== undefined &&
            (obj.bodyBytes = (0, helpers_1.base64FromBytes)(message.bodyBytes !== undefined ? message.bodyBytes : new Uint8Array()));
        message.authInfoBytes !== undefined &&
            (obj.authInfoBytes = (0, helpers_1.base64FromBytes)(message.authInfoBytes !== undefined ? message.authInfoBytes : new Uint8Array()));
        if (message.signatures) {
            obj.signatures = message.signatures.map((e) => (0, helpers_1.base64FromBytes)(e !== undefined ? e : new Uint8Array()));
        }
        else {
            obj.signatures = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseTxRaw();
        message.bodyBytes = object.bodyBytes ?? new Uint8Array();
        message.authInfoBytes = object.authInfoBytes ?? new Uint8Array();
        message.signatures = object.signatures?.map((e) => e) || [];
        return message;
    },
};
function createBaseSignDoc() {
    return {
        bodyBytes: new Uint8Array(),
        authInfoBytes: new Uint8Array(),
        chainId: "",
        accountNumber: helpers_1.Long.UZERO,
    };
}
exports.SignDoc = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.bodyBytes.length !== 0) {
            writer.uint32(10).bytes(message.bodyBytes);
        }
        if (message.authInfoBytes.length !== 0) {
            writer.uint32(18).bytes(message.authInfoBytes);
        }
        if (message.chainId !== "") {
            writer.uint32(26).string(message.chainId);
        }
        if (!message.accountNumber.isZero()) {
            writer.uint32(32).uint64(message.accountNumber);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSignDoc();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.bodyBytes = reader.bytes();
                    break;
                case 2:
                    message.authInfoBytes = reader.bytes();
                    break;
                case 3:
                    message.chainId = reader.string();
                    break;
                case 4:
                    message.accountNumber = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            bodyBytes: (0, helpers_1.isSet)(object.bodyBytes) ? (0, helpers_1.bytesFromBase64)(object.bodyBytes) : new Uint8Array(),
            authInfoBytes: (0, helpers_1.isSet)(object.authInfoBytes) ? (0, helpers_1.bytesFromBase64)(object.authInfoBytes) : new Uint8Array(),
            chainId: (0, helpers_1.isSet)(object.chainId) ? String(object.chainId) : "",
            accountNumber: (0, helpers_1.isSet)(object.accountNumber) ? helpers_1.Long.fromValue(object.accountNumber) : helpers_1.Long.UZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        message.bodyBytes !== undefined &&
            (obj.bodyBytes = (0, helpers_1.base64FromBytes)(message.bodyBytes !== undefined ? message.bodyBytes : new Uint8Array()));
        message.authInfoBytes !== undefined &&
            (obj.authInfoBytes = (0, helpers_1.base64FromBytes)(message.authInfoBytes !== undefined ? message.authInfoBytes : new Uint8Array()));
        message.chainId !== undefined && (obj.chainId = message.chainId);
        message.accountNumber !== undefined &&
            (obj.accountNumber = (message.accountNumber || helpers_1.Long.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseSignDoc();
        message.bodyBytes = object.bodyBytes ?? new Uint8Array();
        message.authInfoBytes = object.authInfoBytes ?? new Uint8Array();
        message.chainId = object.chainId ?? "";
        message.accountNumber =
            object.accountNumber !== undefined && object.accountNumber !== null
                ? helpers_1.Long.fromValue(object.accountNumber)
                : helpers_1.Long.UZERO;
        return message;
    },
};
function createBaseSignDocDirectAux() {
    return {
        bodyBytes: new Uint8Array(),
        publicKey: undefined,
        chainId: "",
        accountNumber: helpers_1.Long.UZERO,
        sequence: helpers_1.Long.UZERO,
        tip: undefined,
    };
}
exports.SignDocDirectAux = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.bodyBytes.length !== 0) {
            writer.uint32(10).bytes(message.bodyBytes);
        }
        if (message.publicKey !== undefined) {
            any_1.Any.encode(message.publicKey, writer.uint32(18).fork()).ldelim();
        }
        if (message.chainId !== "") {
            writer.uint32(26).string(message.chainId);
        }
        if (!message.accountNumber.isZero()) {
            writer.uint32(32).uint64(message.accountNumber);
        }
        if (!message.sequence.isZero()) {
            writer.uint32(40).uint64(message.sequence);
        }
        if (message.tip !== undefined) {
            exports.Tip.encode(message.tip, writer.uint32(50).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSignDocDirectAux();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.bodyBytes = reader.bytes();
                    break;
                case 2:
                    message.publicKey = any_1.Any.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.chainId = reader.string();
                    break;
                case 4:
                    message.accountNumber = reader.uint64();
                    break;
                case 5:
                    message.sequence = reader.uint64();
                    break;
                case 6:
                    message.tip = exports.Tip.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            bodyBytes: (0, helpers_1.isSet)(object.bodyBytes) ? (0, helpers_1.bytesFromBase64)(object.bodyBytes) : new Uint8Array(),
            publicKey: (0, helpers_1.isSet)(object.publicKey) ? any_1.Any.fromJSON(object.publicKey) : undefined,
            chainId: (0, helpers_1.isSet)(object.chainId) ? String(object.chainId) : "",
            accountNumber: (0, helpers_1.isSet)(object.accountNumber) ? helpers_1.Long.fromValue(object.accountNumber) : helpers_1.Long.UZERO,
            sequence: (0, helpers_1.isSet)(object.sequence) ? helpers_1.Long.fromValue(object.sequence) : helpers_1.Long.UZERO,
            tip: (0, helpers_1.isSet)(object.tip) ? exports.Tip.fromJSON(object.tip) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.bodyBytes !== undefined &&
            (obj.bodyBytes = (0, helpers_1.base64FromBytes)(message.bodyBytes !== undefined ? message.bodyBytes : new Uint8Array()));
        message.publicKey !== undefined &&
            (obj.publicKey = message.publicKey ? any_1.Any.toJSON(message.publicKey) : undefined);
        message.chainId !== undefined && (obj.chainId = message.chainId);
        message.accountNumber !== undefined &&
            (obj.accountNumber = (message.accountNumber || helpers_1.Long.UZERO).toString());
        message.sequence !== undefined && (obj.sequence = (message.sequence || helpers_1.Long.UZERO).toString());
        message.tip !== undefined && (obj.tip = message.tip ? exports.Tip.toJSON(message.tip) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseSignDocDirectAux();
        message.bodyBytes = object.bodyBytes ?? new Uint8Array();
        message.publicKey =
            object.publicKey !== undefined && object.publicKey !== null
                ? any_1.Any.fromPartial(object.publicKey)
                : undefined;
        message.chainId = object.chainId ?? "";
        message.accountNumber =
            object.accountNumber !== undefined && object.accountNumber !== null
                ? helpers_1.Long.fromValue(object.accountNumber)
                : helpers_1.Long.UZERO;
        message.sequence =
            object.sequence !== undefined && object.sequence !== null
                ? helpers_1.Long.fromValue(object.sequence)
                : helpers_1.Long.UZERO;
        message.tip = object.tip !== undefined && object.tip !== null ? exports.Tip.fromPartial(object.tip) : undefined;
        return message;
    },
};
function createBaseTxBody() {
    return {
        messages: [],
        memo: "",
        timeoutHeight: helpers_1.Long.UZERO,
        extensionOptions: [],
        nonCriticalExtensionOptions: [],
    };
}
exports.TxBody = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.messages) {
            any_1.Any.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.memo !== "") {
            writer.uint32(18).string(message.memo);
        }
        if (!message.timeoutHeight.isZero()) {
            writer.uint32(24).uint64(message.timeoutHeight);
        }
        for (const v of message.extensionOptions) {
            any_1.Any.encode(v, writer.uint32(8186).fork()).ldelim();
        }
        for (const v of message.nonCriticalExtensionOptions) {
            any_1.Any.encode(v, writer.uint32(16378).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTxBody();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.messages.push(any_1.Any.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.memo = reader.string();
                    break;
                case 3:
                    message.timeoutHeight = reader.uint64();
                    break;
                case 1023:
                    message.extensionOptions.push(any_1.Any.decode(reader, reader.uint32()));
                    break;
                case 2047:
                    message.nonCriticalExtensionOptions.push(any_1.Any.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            messages: Array.isArray(object?.messages) ? object.messages.map((e) => any_1.Any.fromJSON(e)) : [],
            memo: (0, helpers_1.isSet)(object.memo) ? String(object.memo) : "",
            timeoutHeight: (0, helpers_1.isSet)(object.timeoutHeight) ? helpers_1.Long.fromValue(object.timeoutHeight) : helpers_1.Long.UZERO,
            extensionOptions: Array.isArray(object?.extensionOptions)
                ? object.extensionOptions.map((e) => any_1.Any.fromJSON(e))
                : [],
            nonCriticalExtensionOptions: Array.isArray(object?.nonCriticalExtensionOptions)
                ? object.nonCriticalExtensionOptions.map((e) => any_1.Any.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.messages) {
            obj.messages = message.messages.map((e) => (e ? any_1.Any.toJSON(e) : undefined));
        }
        else {
            obj.messages = [];
        }
        message.memo !== undefined && (obj.memo = message.memo);
        message.timeoutHeight !== undefined &&
            (obj.timeoutHeight = (message.timeoutHeight || helpers_1.Long.UZERO).toString());
        if (message.extensionOptions) {
            obj.extensionOptions = message.extensionOptions.map((e) => (e ? any_1.Any.toJSON(e) : undefined));
        }
        else {
            obj.extensionOptions = [];
        }
        if (message.nonCriticalExtensionOptions) {
            obj.nonCriticalExtensionOptions = message.nonCriticalExtensionOptions.map((e) => e ? any_1.Any.toJSON(e) : undefined);
        }
        else {
            obj.nonCriticalExtensionOptions = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseTxBody();
        message.messages = object.messages?.map((e) => any_1.Any.fromPartial(e)) || [];
        message.memo = object.memo ?? "";
        message.timeoutHeight =
            object.timeoutHeight !== undefined && object.timeoutHeight !== null
                ? helpers_1.Long.fromValue(object.timeoutHeight)
                : helpers_1.Long.UZERO;
        message.extensionOptions = object.extensionOptions?.map((e) => any_1.Any.fromPartial(e)) || [];
        message.nonCriticalExtensionOptions =
            object.nonCriticalExtensionOptions?.map((e) => any_1.Any.fromPartial(e)) || [];
        return message;
    },
};
function createBaseAuthInfo() {
    return {
        signerInfos: [],
        fee: undefined,
        tip: undefined,
    };
}
exports.AuthInfo = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.signerInfos) {
            exports.SignerInfo.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.fee !== undefined) {
            exports.Fee.encode(message.fee, writer.uint32(18).fork()).ldelim();
        }
        if (message.tip !== undefined) {
            exports.Tip.encode(message.tip, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAuthInfo();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.signerInfos.push(exports.SignerInfo.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.fee = exports.Fee.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.tip = exports.Tip.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            signerInfos: Array.isArray(object?.signerInfos)
                ? object.signerInfos.map((e) => exports.SignerInfo.fromJSON(e))
                : [],
            fee: (0, helpers_1.isSet)(object.fee) ? exports.Fee.fromJSON(object.fee) : undefined,
            tip: (0, helpers_1.isSet)(object.tip) ? exports.Tip.fromJSON(object.tip) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.signerInfos) {
            obj.signerInfos = message.signerInfos.map((e) => (e ? exports.SignerInfo.toJSON(e) : undefined));
        }
        else {
            obj.signerInfos = [];
        }
        message.fee !== undefined && (obj.fee = message.fee ? exports.Fee.toJSON(message.fee) : undefined);
        message.tip !== undefined && (obj.tip = message.tip ? exports.Tip.toJSON(message.tip) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseAuthInfo();
        message.signerInfos = object.signerInfos?.map((e) => exports.SignerInfo.fromPartial(e)) || [];
        message.fee = object.fee !== undefined && object.fee !== null ? exports.Fee.fromPartial(object.fee) : undefined;
        message.tip = object.tip !== undefined && object.tip !== null ? exports.Tip.fromPartial(object.tip) : undefined;
        return message;
    },
};
function createBaseSignerInfo() {
    return {
        publicKey: undefined,
        modeInfo: undefined,
        sequence: helpers_1.Long.UZERO,
    };
}
exports.SignerInfo = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.publicKey !== undefined) {
            any_1.Any.encode(message.publicKey, writer.uint32(10).fork()).ldelim();
        }
        if (message.modeInfo !== undefined) {
            exports.ModeInfo.encode(message.modeInfo, writer.uint32(18).fork()).ldelim();
        }
        if (!message.sequence.isZero()) {
            writer.uint32(24).uint64(message.sequence);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSignerInfo();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.publicKey = any_1.Any.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.modeInfo = exports.ModeInfo.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.sequence = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            publicKey: (0, helpers_1.isSet)(object.publicKey) ? any_1.Any.fromJSON(object.publicKey) : undefined,
            modeInfo: (0, helpers_1.isSet)(object.modeInfo) ? exports.ModeInfo.fromJSON(object.modeInfo) : undefined,
            sequence: (0, helpers_1.isSet)(object.sequence) ? helpers_1.Long.fromValue(object.sequence) : helpers_1.Long.UZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        message.publicKey !== undefined &&
            (obj.publicKey = message.publicKey ? any_1.Any.toJSON(message.publicKey) : undefined);
        message.modeInfo !== undefined &&
            (obj.modeInfo = message.modeInfo ? exports.ModeInfo.toJSON(message.modeInfo) : undefined);
        message.sequence !== undefined && (obj.sequence = (message.sequence || helpers_1.Long.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseSignerInfo();
        message.publicKey =
            object.publicKey !== undefined && object.publicKey !== null
                ? any_1.Any.fromPartial(object.publicKey)
                : undefined;
        message.modeInfo =
            object.modeInfo !== undefined && object.modeInfo !== null
                ? exports.ModeInfo.fromPartial(object.modeInfo)
                : undefined;
        message.sequence =
            object.sequence !== undefined && object.sequence !== null
                ? helpers_1.Long.fromValue(object.sequence)
                : helpers_1.Long.UZERO;
        return message;
    },
};
function createBaseModeInfo() {
    return {
        single: undefined,
        multi: undefined,
    };
}
exports.ModeInfo = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.single !== undefined) {
            exports.ModeInfo_Single.encode(message.single, writer.uint32(10).fork()).ldelim();
        }
        if (message.multi !== undefined) {
            exports.ModeInfo_Multi.encode(message.multi, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseModeInfo();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.single = exports.ModeInfo_Single.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.multi = exports.ModeInfo_Multi.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            single: (0, helpers_1.isSet)(object.single) ? exports.ModeInfo_Single.fromJSON(object.single) : undefined,
            multi: (0, helpers_1.isSet)(object.multi) ? exports.ModeInfo_Multi.fromJSON(object.multi) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.single !== undefined &&
            (obj.single = message.single ? exports.ModeInfo_Single.toJSON(message.single) : undefined);
        message.multi !== undefined &&
            (obj.multi = message.multi ? exports.ModeInfo_Multi.toJSON(message.multi) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseModeInfo();
        message.single =
            object.single !== undefined && object.single !== null
                ? exports.ModeInfo_Single.fromPartial(object.single)
                : undefined;
        message.multi =
            object.multi !== undefined && object.multi !== null
                ? exports.ModeInfo_Multi.fromPartial(object.multi)
                : undefined;
        return message;
    },
};
function createBaseModeInfo_Single() {
    return {
        mode: 0,
    };
}
exports.ModeInfo_Single = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.mode !== 0) {
            writer.uint32(8).int32(message.mode);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseModeInfo_Single();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.mode = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            mode: (0, helpers_1.isSet)(object.mode) ? (0, signing_1.signModeFromJSON)(object.mode) : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        message.mode !== undefined && (obj.mode = (0, signing_1.signModeToJSON)(message.mode));
        return obj;
    },
    fromPartial(object) {
        const message = createBaseModeInfo_Single();
        message.mode = object.mode ?? 0;
        return message;
    },
};
function createBaseModeInfo_Multi() {
    return {
        bitarray: undefined,
        modeInfos: [],
    };
}
exports.ModeInfo_Multi = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.bitarray !== undefined) {
            multisig_1.CompactBitArray.encode(message.bitarray, writer.uint32(10).fork()).ldelim();
        }
        for (const v of message.modeInfos) {
            exports.ModeInfo.encode(v, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseModeInfo_Multi();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.bitarray = multisig_1.CompactBitArray.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.modeInfos.push(exports.ModeInfo.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            bitarray: (0, helpers_1.isSet)(object.bitarray) ? multisig_1.CompactBitArray.fromJSON(object.bitarray) : undefined,
            modeInfos: Array.isArray(object?.modeInfos)
                ? object.modeInfos.map((e) => exports.ModeInfo.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        message.bitarray !== undefined &&
            (obj.bitarray = message.bitarray ? multisig_1.CompactBitArray.toJSON(message.bitarray) : undefined);
        if (message.modeInfos) {
            obj.modeInfos = message.modeInfos.map((e) => (e ? exports.ModeInfo.toJSON(e) : undefined));
        }
        else {
            obj.modeInfos = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseModeInfo_Multi();
        message.bitarray =
            object.bitarray !== undefined && object.bitarray !== null
                ? multisig_1.CompactBitArray.fromPartial(object.bitarray)
                : undefined;
        message.modeInfos = object.modeInfos?.map((e) => exports.ModeInfo.fromPartial(e)) || [];
        return message;
    },
};
function createBaseFee() {
    return {
        amount: [],
        gasLimit: helpers_1.Long.UZERO,
        payer: "",
        granter: "",
    };
}
exports.Fee = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.amount) {
            coin_1.Coin.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (!message.gasLimit.isZero()) {
            writer.uint32(16).uint64(message.gasLimit);
        }
        if (message.payer !== "") {
            writer.uint32(26).string(message.payer);
        }
        if (message.granter !== "") {
            writer.uint32(34).string(message.granter);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseFee();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.amount.push(coin_1.Coin.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.gasLimit = reader.uint64();
                    break;
                case 3:
                    message.payer = reader.string();
                    break;
                case 4:
                    message.granter = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            amount: Array.isArray(object?.amount) ? object.amount.map((e) => coin_1.Coin.fromJSON(e)) : [],
            gasLimit: (0, helpers_1.isSet)(object.gasLimit) ? helpers_1.Long.fromValue(object.gasLimit) : helpers_1.Long.UZERO,
            payer: (0, helpers_1.isSet)(object.payer) ? String(object.payer) : "",
            granter: (0, helpers_1.isSet)(object.granter) ? String(object.granter) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.amount) {
            obj.amount = message.amount.map((e) => (e ? coin_1.Coin.toJSON(e) : undefined));
        }
        else {
            obj.amount = [];
        }
        message.gasLimit !== undefined && (obj.gasLimit = (message.gasLimit || helpers_1.Long.UZERO).toString());
        message.payer !== undefined && (obj.payer = message.payer);
        message.granter !== undefined && (obj.granter = message.granter);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseFee();
        message.amount = object.amount?.map((e) => coin_1.Coin.fromPartial(e)) || [];
        message.gasLimit =
            object.gasLimit !== undefined && object.gasLimit !== null
                ? helpers_1.Long.fromValue(object.gasLimit)
                : helpers_1.Long.UZERO;
        message.payer = object.payer ?? "";
        message.granter = object.granter ?? "";
        return message;
    },
};
function createBaseTip() {
    return {
        amount: [],
        tipper: "",
    };
}
exports.Tip = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.amount) {
            coin_1.Coin.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.tipper !== "") {
            writer.uint32(18).string(message.tipper);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTip();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.amount.push(coin_1.Coin.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.tipper = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            amount: Array.isArray(object?.amount) ? object.amount.map((e) => coin_1.Coin.fromJSON(e)) : [],
            tipper: (0, helpers_1.isSet)(object.tipper) ? String(object.tipper) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.amount) {
            obj.amount = message.amount.map((e) => (e ? coin_1.Coin.toJSON(e) : undefined));
        }
        else {
            obj.amount = [];
        }
        message.tipper !== undefined && (obj.tipper = message.tipper);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseTip();
        message.amount = object.amount?.map((e) => coin_1.Coin.fromPartial(e)) || [];
        message.tipper = object.tipper ?? "";
        return message;
    },
};
function createBaseAuxSignerData() {
    return {
        address: "",
        signDoc: undefined,
        mode: 0,
        sig: new Uint8Array(),
    };
}
exports.AuxSignerData = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.address !== "") {
            writer.uint32(10).string(message.address);
        }
        if (message.signDoc !== undefined) {
            exports.SignDocDirectAux.encode(message.signDoc, writer.uint32(18).fork()).ldelim();
        }
        if (message.mode !== 0) {
            writer.uint32(24).int32(message.mode);
        }
        if (message.sig.length !== 0) {
            writer.uint32(34).bytes(message.sig);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAuxSignerData();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.signDoc = exports.SignDocDirectAux.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.mode = reader.int32();
                    break;
                case 4:
                    message.sig = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            address: (0, helpers_1.isSet)(object.address) ? String(object.address) : "",
            signDoc: (0, helpers_1.isSet)(object.signDoc) ? exports.SignDocDirectAux.fromJSON(object.signDoc) : undefined,
            mode: (0, helpers_1.isSet)(object.mode) ? (0, signing_1.signModeFromJSON)(object.mode) : 0,
            sig: (0, helpers_1.isSet)(object.sig) ? (0, helpers_1.bytesFromBase64)(object.sig) : new Uint8Array(),
        };
    },
    toJSON(message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.signDoc !== undefined &&
            (obj.signDoc = message.signDoc ? exports.SignDocDirectAux.toJSON(message.signDoc) : undefined);
        message.mode !== undefined && (obj.mode = (0, signing_1.signModeToJSON)(message.mode));
        message.sig !== undefined &&
            (obj.sig = (0, helpers_1.base64FromBytes)(message.sig !== undefined ? message.sig : new Uint8Array()));
        return obj;
    },
    fromPartial(object) {
        const message = createBaseAuxSignerData();
        message.address = object.address ?? "";
        message.signDoc =
            object.signDoc !== undefined && object.signDoc !== null
                ? exports.SignDocDirectAux.fromPartial(object.signDoc)
                : undefined;
        message.mode = object.mode ?? 0;
        message.sig = object.sig ?? new Uint8Array();
        return message;
    },
};
//# sourceMappingURL=tx.js.map

/***/ }),

/***/ 27937:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MsgClientImpl = exports.MsgCancelUpgradeResponse = exports.MsgCancelUpgrade = exports.MsgSoftwareUpgradeResponse = exports.MsgSoftwareUpgrade = exports.protobufPackage = void 0;
/* eslint-disable */
const upgrade_1 = __webpack_require__(19998);
const _m0 = __importStar(__webpack_require__(62100));
const helpers_1 = __webpack_require__(92654);
exports.protobufPackage = "cosmos.upgrade.v1beta1";
function createBaseMsgSoftwareUpgrade() {
    return {
        authority: "",
        plan: undefined,
    };
}
exports.MsgSoftwareUpgrade = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.authority !== "") {
            writer.uint32(10).string(message.authority);
        }
        if (message.plan !== undefined) {
            upgrade_1.Plan.encode(message.plan, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgSoftwareUpgrade();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.authority = reader.string();
                    break;
                case 2:
                    message.plan = upgrade_1.Plan.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            authority: (0, helpers_1.isSet)(object.authority) ? String(object.authority) : "",
            plan: (0, helpers_1.isSet)(object.plan) ? upgrade_1.Plan.fromJSON(object.plan) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.authority !== undefined && (obj.authority = message.authority);
        message.plan !== undefined && (obj.plan = message.plan ? upgrade_1.Plan.toJSON(message.plan) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgSoftwareUpgrade();
        message.authority = object.authority ?? "";
        message.plan =
            object.plan !== undefined && object.plan !== null ? upgrade_1.Plan.fromPartial(object.plan) : undefined;
        return message;
    },
};
function createBaseMsgSoftwareUpgradeResponse() {
    return {};
}
exports.MsgSoftwareUpgradeResponse = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgSoftwareUpgradeResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgSoftwareUpgradeResponse();
        return message;
    },
};
function createBaseMsgCancelUpgrade() {
    return {
        authority: "",
    };
}
exports.MsgCancelUpgrade = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.authority !== "") {
            writer.uint32(10).string(message.authority);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgCancelUpgrade();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.authority = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            authority: (0, helpers_1.isSet)(object.authority) ? String(object.authority) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.authority !== undefined && (obj.authority = message.authority);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgCancelUpgrade();
        message.authority = object.authority ?? "";
        return message;
    },
};
function createBaseMsgCancelUpgradeResponse() {
    return {};
}
exports.MsgCancelUpgradeResponse = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgCancelUpgradeResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgCancelUpgradeResponse();
        return message;
    },
};
class MsgClientImpl {
    constructor(rpc) {
        this.rpc = rpc;
        this.SoftwareUpgrade = this.SoftwareUpgrade.bind(this);
        this.CancelUpgrade = this.CancelUpgrade.bind(this);
    }
    SoftwareUpgrade(request) {
        const data = exports.MsgSoftwareUpgrade.encode(request).finish();
        const promise = this.rpc.request("cosmos.upgrade.v1beta1.Msg", "SoftwareUpgrade", data);
        return promise.then((data) => exports.MsgSoftwareUpgradeResponse.decode(new _m0.Reader(data)));
    }
    CancelUpgrade(request) {
        const data = exports.MsgCancelUpgrade.encode(request).finish();
        const promise = this.rpc.request("cosmos.upgrade.v1beta1.Msg", "CancelUpgrade", data);
        return promise.then((data) => exports.MsgCancelUpgradeResponse.decode(new _m0.Reader(data)));
    }
}
exports.MsgClientImpl = MsgClientImpl;
//# sourceMappingURL=tx.js.map

/***/ }),

/***/ 19998:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ModuleVersion = exports.CancelSoftwareUpgradeProposal = exports.SoftwareUpgradeProposal = exports.Plan = exports.protobufPackage = void 0;
/* eslint-disable */
const timestamp_1 = __webpack_require__(70147);
const any_1 = __webpack_require__(75654);
const helpers_1 = __webpack_require__(92654);
const _m0 = __importStar(__webpack_require__(62100));
exports.protobufPackage = "cosmos.upgrade.v1beta1";
function createBasePlan() {
    return {
        name: "",
        time: undefined,
        height: helpers_1.Long.ZERO,
        info: "",
        upgradedClientState: undefined,
    };
}
exports.Plan = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.name !== "") {
            writer.uint32(10).string(message.name);
        }
        if (message.time !== undefined) {
            timestamp_1.Timestamp.encode(message.time, writer.uint32(18).fork()).ldelim();
        }
        if (!message.height.isZero()) {
            writer.uint32(24).int64(message.height);
        }
        if (message.info !== "") {
            writer.uint32(34).string(message.info);
        }
        if (message.upgradedClientState !== undefined) {
            any_1.Any.encode(message.upgradedClientState, writer.uint32(42).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlan();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.name = reader.string();
                    break;
                case 2:
                    message.time = timestamp_1.Timestamp.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.height = reader.int64();
                    break;
                case 4:
                    message.info = reader.string();
                    break;
                case 5:
                    message.upgradedClientState = any_1.Any.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            name: (0, helpers_1.isSet)(object.name) ? String(object.name) : "",
            time: (0, helpers_1.isSet)(object.time) ? (0, helpers_1.fromJsonTimestamp)(object.time) : undefined,
            height: (0, helpers_1.isSet)(object.height) ? helpers_1.Long.fromValue(object.height) : helpers_1.Long.ZERO,
            info: (0, helpers_1.isSet)(object.info) ? String(object.info) : "",
            upgradedClientState: (0, helpers_1.isSet)(object.upgradedClientState)
                ? any_1.Any.fromJSON(object.upgradedClientState)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.name !== undefined && (obj.name = message.name);
        message.time !== undefined && (obj.time = (0, helpers_1.fromTimestamp)(message.time).toISOString());
        message.height !== undefined && (obj.height = (message.height || helpers_1.Long.ZERO).toString());
        message.info !== undefined && (obj.info = message.info);
        message.upgradedClientState !== undefined &&
            (obj.upgradedClientState = message.upgradedClientState
                ? any_1.Any.toJSON(message.upgradedClientState)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBasePlan();
        message.name = object.name ?? "";
        message.time =
            object.time !== undefined && object.time !== null ? timestamp_1.Timestamp.fromPartial(object.time) : undefined;
        message.height =
            object.height !== undefined && object.height !== null ? helpers_1.Long.fromValue(object.height) : helpers_1.Long.ZERO;
        message.info = object.info ?? "";
        message.upgradedClientState =
            object.upgradedClientState !== undefined && object.upgradedClientState !== null
                ? any_1.Any.fromPartial(object.upgradedClientState)
                : undefined;
        return message;
    },
};
function createBaseSoftwareUpgradeProposal() {
    return {
        title: "",
        description: "",
        plan: undefined,
    };
}
exports.SoftwareUpgradeProposal = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.title !== "") {
            writer.uint32(10).string(message.title);
        }
        if (message.description !== "") {
            writer.uint32(18).string(message.description);
        }
        if (message.plan !== undefined) {
            exports.Plan.encode(message.plan, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSoftwareUpgradeProposal();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.title = reader.string();
                    break;
                case 2:
                    message.description = reader.string();
                    break;
                case 3:
                    message.plan = exports.Plan.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            title: (0, helpers_1.isSet)(object.title) ? String(object.title) : "",
            description: (0, helpers_1.isSet)(object.description) ? String(object.description) : "",
            plan: (0, helpers_1.isSet)(object.plan) ? exports.Plan.fromJSON(object.plan) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.title !== undefined && (obj.title = message.title);
        message.description !== undefined && (obj.description = message.description);
        message.plan !== undefined && (obj.plan = message.plan ? exports.Plan.toJSON(message.plan) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseSoftwareUpgradeProposal();
        message.title = object.title ?? "";
        message.description = object.description ?? "";
        message.plan =
            object.plan !== undefined && object.plan !== null ? exports.Plan.fromPartial(object.plan) : undefined;
        return message;
    },
};
function createBaseCancelSoftwareUpgradeProposal() {
    return {
        title: "",
        description: "",
    };
}
exports.CancelSoftwareUpgradeProposal = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.title !== "") {
            writer.uint32(10).string(message.title);
        }
        if (message.description !== "") {
            writer.uint32(18).string(message.description);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCancelSoftwareUpgradeProposal();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.title = reader.string();
                    break;
                case 2:
                    message.description = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            title: (0, helpers_1.isSet)(object.title) ? String(object.title) : "",
            description: (0, helpers_1.isSet)(object.description) ? String(object.description) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.title !== undefined && (obj.title = message.title);
        message.description !== undefined && (obj.description = message.description);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseCancelSoftwareUpgradeProposal();
        message.title = object.title ?? "";
        message.description = object.description ?? "";
        return message;
    },
};
function createBaseModuleVersion() {
    return {
        name: "",
        version: helpers_1.Long.UZERO,
    };
}
exports.ModuleVersion = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.name !== "") {
            writer.uint32(10).string(message.name);
        }
        if (!message.version.isZero()) {
            writer.uint32(16).uint64(message.version);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseModuleVersion();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.name = reader.string();
                    break;
                case 2:
                    message.version = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            name: (0, helpers_1.isSet)(object.name) ? String(object.name) : "",
            version: (0, helpers_1.isSet)(object.version) ? helpers_1.Long.fromValue(object.version) : helpers_1.Long.UZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        message.name !== undefined && (obj.name = message.name);
        message.version !== undefined && (obj.version = (message.version || helpers_1.Long.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseModuleVersion();
        message.name = object.name ?? "";
        message.version =
            object.version !== undefined && object.version !== null ? helpers_1.Long.fromValue(object.version) : helpers_1.Long.UZERO;
        return message;
    },
};
//# sourceMappingURL=upgrade.js.map

/***/ }),

/***/ 74762:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MsgClientImpl = exports.MsgCreatePeriodicVestingAccountResponse = exports.MsgCreatePeriodicVestingAccount = exports.MsgCreatePermanentLockedAccountResponse = exports.MsgCreatePermanentLockedAccount = exports.MsgCreateVestingAccountResponse = exports.MsgCreateVestingAccount = exports.protobufPackage = void 0;
/* eslint-disable */
const coin_1 = __webpack_require__(81637);
const vesting_1 = __webpack_require__(90416);
const helpers_1 = __webpack_require__(92654);
const _m0 = __importStar(__webpack_require__(62100));
exports.protobufPackage = "cosmos.vesting.v1beta1";
function createBaseMsgCreateVestingAccount() {
    return {
        fromAddress: "",
        toAddress: "",
        amount: [],
        endTime: helpers_1.Long.ZERO,
        delayed: false,
    };
}
exports.MsgCreateVestingAccount = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.fromAddress !== "") {
            writer.uint32(10).string(message.fromAddress);
        }
        if (message.toAddress !== "") {
            writer.uint32(18).string(message.toAddress);
        }
        for (const v of message.amount) {
            coin_1.Coin.encode(v, writer.uint32(26).fork()).ldelim();
        }
        if (!message.endTime.isZero()) {
            writer.uint32(32).int64(message.endTime);
        }
        if (message.delayed === true) {
            writer.uint32(40).bool(message.delayed);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgCreateVestingAccount();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.fromAddress = reader.string();
                    break;
                case 2:
                    message.toAddress = reader.string();
                    break;
                case 3:
                    message.amount.push(coin_1.Coin.decode(reader, reader.uint32()));
                    break;
                case 4:
                    message.endTime = reader.int64();
                    break;
                case 5:
                    message.delayed = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            fromAddress: (0, helpers_1.isSet)(object.fromAddress) ? String(object.fromAddress) : "",
            toAddress: (0, helpers_1.isSet)(object.toAddress) ? String(object.toAddress) : "",
            amount: Array.isArray(object?.amount) ? object.amount.map((e) => coin_1.Coin.fromJSON(e)) : [],
            endTime: (0, helpers_1.isSet)(object.endTime) ? helpers_1.Long.fromValue(object.endTime) : helpers_1.Long.ZERO,
            delayed: (0, helpers_1.isSet)(object.delayed) ? Boolean(object.delayed) : false,
        };
    },
    toJSON(message) {
        const obj = {};
        message.fromAddress !== undefined && (obj.fromAddress = message.fromAddress);
        message.toAddress !== undefined && (obj.toAddress = message.toAddress);
        if (message.amount) {
            obj.amount = message.amount.map((e) => (e ? coin_1.Coin.toJSON(e) : undefined));
        }
        else {
            obj.amount = [];
        }
        message.endTime !== undefined && (obj.endTime = (message.endTime || helpers_1.Long.ZERO).toString());
        message.delayed !== undefined && (obj.delayed = message.delayed);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgCreateVestingAccount();
        message.fromAddress = object.fromAddress ?? "";
        message.toAddress = object.toAddress ?? "";
        message.amount = object.amount?.map((e) => coin_1.Coin.fromPartial(e)) || [];
        message.endTime =
            object.endTime !== undefined && object.endTime !== null ? helpers_1.Long.fromValue(object.endTime) : helpers_1.Long.ZERO;
        message.delayed = object.delayed ?? false;
        return message;
    },
};
function createBaseMsgCreateVestingAccountResponse() {
    return {};
}
exports.MsgCreateVestingAccountResponse = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgCreateVestingAccountResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgCreateVestingAccountResponse();
        return message;
    },
};
function createBaseMsgCreatePermanentLockedAccount() {
    return {
        fromAddress: "",
        toAddress: "",
        amount: [],
    };
}
exports.MsgCreatePermanentLockedAccount = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.fromAddress !== "") {
            writer.uint32(10).string(message.fromAddress);
        }
        if (message.toAddress !== "") {
            writer.uint32(18).string(message.toAddress);
        }
        for (const v of message.amount) {
            coin_1.Coin.encode(v, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgCreatePermanentLockedAccount();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.fromAddress = reader.string();
                    break;
                case 2:
                    message.toAddress = reader.string();
                    break;
                case 3:
                    message.amount.push(coin_1.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            fromAddress: (0, helpers_1.isSet)(object.fromAddress) ? String(object.fromAddress) : "",
            toAddress: (0, helpers_1.isSet)(object.toAddress) ? String(object.toAddress) : "",
            amount: Array.isArray(object?.amount) ? object.amount.map((e) => coin_1.Coin.fromJSON(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        message.fromAddress !== undefined && (obj.fromAddress = message.fromAddress);
        message.toAddress !== undefined && (obj.toAddress = message.toAddress);
        if (message.amount) {
            obj.amount = message.amount.map((e) => (e ? coin_1.Coin.toJSON(e) : undefined));
        }
        else {
            obj.amount = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgCreatePermanentLockedAccount();
        message.fromAddress = object.fromAddress ?? "";
        message.toAddress = object.toAddress ?? "";
        message.amount = object.amount?.map((e) => coin_1.Coin.fromPartial(e)) || [];
        return message;
    },
};
function createBaseMsgCreatePermanentLockedAccountResponse() {
    return {};
}
exports.MsgCreatePermanentLockedAccountResponse = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgCreatePermanentLockedAccountResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgCreatePermanentLockedAccountResponse();
        return message;
    },
};
function createBaseMsgCreatePeriodicVestingAccount() {
    return {
        fromAddress: "",
        toAddress: "",
        startTime: helpers_1.Long.ZERO,
        vestingPeriods: [],
    };
}
exports.MsgCreatePeriodicVestingAccount = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.fromAddress !== "") {
            writer.uint32(10).string(message.fromAddress);
        }
        if (message.toAddress !== "") {
            writer.uint32(18).string(message.toAddress);
        }
        if (!message.startTime.isZero()) {
            writer.uint32(24).int64(message.startTime);
        }
        for (const v of message.vestingPeriods) {
            vesting_1.Period.encode(v, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgCreatePeriodicVestingAccount();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.fromAddress = reader.string();
                    break;
                case 2:
                    message.toAddress = reader.string();
                    break;
                case 3:
                    message.startTime = reader.int64();
                    break;
                case 4:
                    message.vestingPeriods.push(vesting_1.Period.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            fromAddress: (0, helpers_1.isSet)(object.fromAddress) ? String(object.fromAddress) : "",
            toAddress: (0, helpers_1.isSet)(object.toAddress) ? String(object.toAddress) : "",
            startTime: (0, helpers_1.isSet)(object.startTime) ? helpers_1.Long.fromValue(object.startTime) : helpers_1.Long.ZERO,
            vestingPeriods: Array.isArray(object?.vestingPeriods)
                ? object.vestingPeriods.map((e) => vesting_1.Period.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        message.fromAddress !== undefined && (obj.fromAddress = message.fromAddress);
        message.toAddress !== undefined && (obj.toAddress = message.toAddress);
        message.startTime !== undefined && (obj.startTime = (message.startTime || helpers_1.Long.ZERO).toString());
        if (message.vestingPeriods) {
            obj.vestingPeriods = message.vestingPeriods.map((e) => (e ? vesting_1.Period.toJSON(e) : undefined));
        }
        else {
            obj.vestingPeriods = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgCreatePeriodicVestingAccount();
        message.fromAddress = object.fromAddress ?? "";
        message.toAddress = object.toAddress ?? "";
        message.startTime =
            object.startTime !== undefined && object.startTime !== null
                ? helpers_1.Long.fromValue(object.startTime)
                : helpers_1.Long.ZERO;
        message.vestingPeriods = object.vestingPeriods?.map((e) => vesting_1.Period.fromPartial(e)) || [];
        return message;
    },
};
function createBaseMsgCreatePeriodicVestingAccountResponse() {
    return {};
}
exports.MsgCreatePeriodicVestingAccountResponse = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgCreatePeriodicVestingAccountResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgCreatePeriodicVestingAccountResponse();
        return message;
    },
};
class MsgClientImpl {
    constructor(rpc) {
        this.rpc = rpc;
        this.CreateVestingAccount = this.CreateVestingAccount.bind(this);
        this.CreatePermanentLockedAccount = this.CreatePermanentLockedAccount.bind(this);
        this.CreatePeriodicVestingAccount = this.CreatePeriodicVestingAccount.bind(this);
    }
    CreateVestingAccount(request) {
        const data = exports.MsgCreateVestingAccount.encode(request).finish();
        const promise = this.rpc.request("cosmos.vesting.v1beta1.Msg", "CreateVestingAccount", data);
        return promise.then((data) => exports.MsgCreateVestingAccountResponse.decode(new _m0.Reader(data)));
    }
    CreatePermanentLockedAccount(request) {
        const data = exports.MsgCreatePermanentLockedAccount.encode(request).finish();
        const promise = this.rpc.request("cosmos.vesting.v1beta1.Msg", "CreatePermanentLockedAccount", data);
        return promise.then((data) => exports.MsgCreatePermanentLockedAccountResponse.decode(new _m0.Reader(data)));
    }
    CreatePeriodicVestingAccount(request) {
        const data = exports.MsgCreatePeriodicVestingAccount.encode(request).finish();
        const promise = this.rpc.request("cosmos.vesting.v1beta1.Msg", "CreatePeriodicVestingAccount", data);
        return promise.then((data) => exports.MsgCreatePeriodicVestingAccountResponse.decode(new _m0.Reader(data)));
    }
}
exports.MsgClientImpl = MsgClientImpl;
//# sourceMappingURL=tx.js.map

/***/ }),

/***/ 90416:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PermanentLockedAccount = exports.PeriodicVestingAccount = exports.Period = exports.DelayedVestingAccount = exports.ContinuousVestingAccount = exports.BaseVestingAccount = exports.protobufPackage = void 0;
/* eslint-disable */
const auth_1 = __webpack_require__(13394);
const coin_1 = __webpack_require__(81637);
const helpers_1 = __webpack_require__(92654);
const _m0 = __importStar(__webpack_require__(62100));
exports.protobufPackage = "cosmos.vesting.v1beta1";
function createBaseBaseVestingAccount() {
    return {
        baseAccount: undefined,
        originalVesting: [],
        delegatedFree: [],
        delegatedVesting: [],
        endTime: helpers_1.Long.ZERO,
    };
}
exports.BaseVestingAccount = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.baseAccount !== undefined) {
            auth_1.BaseAccount.encode(message.baseAccount, writer.uint32(10).fork()).ldelim();
        }
        for (const v of message.originalVesting) {
            coin_1.Coin.encode(v, writer.uint32(18).fork()).ldelim();
        }
        for (const v of message.delegatedFree) {
            coin_1.Coin.encode(v, writer.uint32(26).fork()).ldelim();
        }
        for (const v of message.delegatedVesting) {
            coin_1.Coin.encode(v, writer.uint32(34).fork()).ldelim();
        }
        if (!message.endTime.isZero()) {
            writer.uint32(40).int64(message.endTime);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseBaseVestingAccount();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.baseAccount = auth_1.BaseAccount.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.originalVesting.push(coin_1.Coin.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.delegatedFree.push(coin_1.Coin.decode(reader, reader.uint32()));
                    break;
                case 4:
                    message.delegatedVesting.push(coin_1.Coin.decode(reader, reader.uint32()));
                    break;
                case 5:
                    message.endTime = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            baseAccount: (0, helpers_1.isSet)(object.baseAccount) ? auth_1.BaseAccount.fromJSON(object.baseAccount) : undefined,
            originalVesting: Array.isArray(object?.originalVesting)
                ? object.originalVesting.map((e) => coin_1.Coin.fromJSON(e))
                : [],
            delegatedFree: Array.isArray(object?.delegatedFree)
                ? object.delegatedFree.map((e) => coin_1.Coin.fromJSON(e))
                : [],
            delegatedVesting: Array.isArray(object?.delegatedVesting)
                ? object.delegatedVesting.map((e) => coin_1.Coin.fromJSON(e))
                : [],
            endTime: (0, helpers_1.isSet)(object.endTime) ? helpers_1.Long.fromValue(object.endTime) : helpers_1.Long.ZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        message.baseAccount !== undefined &&
            (obj.baseAccount = message.baseAccount ? auth_1.BaseAccount.toJSON(message.baseAccount) : undefined);
        if (message.originalVesting) {
            obj.originalVesting = message.originalVesting.map((e) => (e ? coin_1.Coin.toJSON(e) : undefined));
        }
        else {
            obj.originalVesting = [];
        }
        if (message.delegatedFree) {
            obj.delegatedFree = message.delegatedFree.map((e) => (e ? coin_1.Coin.toJSON(e) : undefined));
        }
        else {
            obj.delegatedFree = [];
        }
        if (message.delegatedVesting) {
            obj.delegatedVesting = message.delegatedVesting.map((e) => (e ? coin_1.Coin.toJSON(e) : undefined));
        }
        else {
            obj.delegatedVesting = [];
        }
        message.endTime !== undefined && (obj.endTime = (message.endTime || helpers_1.Long.ZERO).toString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseBaseVestingAccount();
        message.baseAccount =
            object.baseAccount !== undefined && object.baseAccount !== null
                ? auth_1.BaseAccount.fromPartial(object.baseAccount)
                : undefined;
        message.originalVesting = object.originalVesting?.map((e) => coin_1.Coin.fromPartial(e)) || [];
        message.delegatedFree = object.delegatedFree?.map((e) => coin_1.Coin.fromPartial(e)) || [];
        message.delegatedVesting = object.delegatedVesting?.map((e) => coin_1.Coin.fromPartial(e)) || [];
        message.endTime =
            object.endTime !== undefined && object.endTime !== null ? helpers_1.Long.fromValue(object.endTime) : helpers_1.Long.ZERO;
        return message;
    },
};
function createBaseContinuousVestingAccount() {
    return {
        baseVestingAccount: undefined,
        startTime: helpers_1.Long.ZERO,
    };
}
exports.ContinuousVestingAccount = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.baseVestingAccount !== undefined) {
            exports.BaseVestingAccount.encode(message.baseVestingAccount, writer.uint32(10).fork()).ldelim();
        }
        if (!message.startTime.isZero()) {
            writer.uint32(16).int64(message.startTime);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseContinuousVestingAccount();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.baseVestingAccount = exports.BaseVestingAccount.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.startTime = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            baseVestingAccount: (0, helpers_1.isSet)(object.baseVestingAccount)
                ? exports.BaseVestingAccount.fromJSON(object.baseVestingAccount)
                : undefined,
            startTime: (0, helpers_1.isSet)(object.startTime) ? helpers_1.Long.fromValue(object.startTime) : helpers_1.Long.ZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        message.baseVestingAccount !== undefined &&
            (obj.baseVestingAccount = message.baseVestingAccount
                ? exports.BaseVestingAccount.toJSON(message.baseVestingAccount)
                : undefined);
        message.startTime !== undefined && (obj.startTime = (message.startTime || helpers_1.Long.ZERO).toString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseContinuousVestingAccount();
        message.baseVestingAccount =
            object.baseVestingAccount !== undefined && object.baseVestingAccount !== null
                ? exports.BaseVestingAccount.fromPartial(object.baseVestingAccount)
                : undefined;
        message.startTime =
            object.startTime !== undefined && object.startTime !== null
                ? helpers_1.Long.fromValue(object.startTime)
                : helpers_1.Long.ZERO;
        return message;
    },
};
function createBaseDelayedVestingAccount() {
    return {
        baseVestingAccount: undefined,
    };
}
exports.DelayedVestingAccount = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.baseVestingAccount !== undefined) {
            exports.BaseVestingAccount.encode(message.baseVestingAccount, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDelayedVestingAccount();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.baseVestingAccount = exports.BaseVestingAccount.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            baseVestingAccount: (0, helpers_1.isSet)(object.baseVestingAccount)
                ? exports.BaseVestingAccount.fromJSON(object.baseVestingAccount)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.baseVestingAccount !== undefined &&
            (obj.baseVestingAccount = message.baseVestingAccount
                ? exports.BaseVestingAccount.toJSON(message.baseVestingAccount)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseDelayedVestingAccount();
        message.baseVestingAccount =
            object.baseVestingAccount !== undefined && object.baseVestingAccount !== null
                ? exports.BaseVestingAccount.fromPartial(object.baseVestingAccount)
                : undefined;
        return message;
    },
};
function createBasePeriod() {
    return {
        length: helpers_1.Long.ZERO,
        amount: [],
    };
}
exports.Period = {
    encode(message, writer = _m0.Writer.create()) {
        if (!message.length.isZero()) {
            writer.uint32(8).int64(message.length);
        }
        for (const v of message.amount) {
            coin_1.Coin.encode(v, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePeriod();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.length = reader.int64();
                    break;
                case 2:
                    message.amount.push(coin_1.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            length: (0, helpers_1.isSet)(object.length) ? helpers_1.Long.fromValue(object.length) : helpers_1.Long.ZERO,
            amount: Array.isArray(object?.amount) ? object.amount.map((e) => coin_1.Coin.fromJSON(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        message.length !== undefined && (obj.length = (message.length || helpers_1.Long.ZERO).toString());
        if (message.amount) {
            obj.amount = message.amount.map((e) => (e ? coin_1.Coin.toJSON(e) : undefined));
        }
        else {
            obj.amount = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBasePeriod();
        message.length =
            object.length !== undefined && object.length !== null ? helpers_1.Long.fromValue(object.length) : helpers_1.Long.ZERO;
        message.amount = object.amount?.map((e) => coin_1.Coin.fromPartial(e)) || [];
        return message;
    },
};
function createBasePeriodicVestingAccount() {
    return {
        baseVestingAccount: undefined,
        startTime: helpers_1.Long.ZERO,
        vestingPeriods: [],
    };
}
exports.PeriodicVestingAccount = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.baseVestingAccount !== undefined) {
            exports.BaseVestingAccount.encode(message.baseVestingAccount, writer.uint32(10).fork()).ldelim();
        }
        if (!message.startTime.isZero()) {
            writer.uint32(16).int64(message.startTime);
        }
        for (const v of message.vestingPeriods) {
            exports.Period.encode(v, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePeriodicVestingAccount();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.baseVestingAccount = exports.BaseVestingAccount.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.startTime = reader.int64();
                    break;
                case 3:
                    message.vestingPeriods.push(exports.Period.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            baseVestingAccount: (0, helpers_1.isSet)(object.baseVestingAccount)
                ? exports.BaseVestingAccount.fromJSON(object.baseVestingAccount)
                : undefined,
            startTime: (0, helpers_1.isSet)(object.startTime) ? helpers_1.Long.fromValue(object.startTime) : helpers_1.Long.ZERO,
            vestingPeriods: Array.isArray(object?.vestingPeriods)
                ? object.vestingPeriods.map((e) => exports.Period.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        message.baseVestingAccount !== undefined &&
            (obj.baseVestingAccount = message.baseVestingAccount
                ? exports.BaseVestingAccount.toJSON(message.baseVestingAccount)
                : undefined);
        message.startTime !== undefined && (obj.startTime = (message.startTime || helpers_1.Long.ZERO).toString());
        if (message.vestingPeriods) {
            obj.vestingPeriods = message.vestingPeriods.map((e) => (e ? exports.Period.toJSON(e) : undefined));
        }
        else {
            obj.vestingPeriods = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBasePeriodicVestingAccount();
        message.baseVestingAccount =
            object.baseVestingAccount !== undefined && object.baseVestingAccount !== null
                ? exports.BaseVestingAccount.fromPartial(object.baseVestingAccount)
                : undefined;
        message.startTime =
            object.startTime !== undefined && object.startTime !== null
                ? helpers_1.Long.fromValue(object.startTime)
                : helpers_1.Long.ZERO;
        message.vestingPeriods = object.vestingPeriods?.map((e) => exports.Period.fromPartial(e)) || [];
        return message;
    },
};
function createBasePermanentLockedAccount() {
    return {
        baseVestingAccount: undefined,
    };
}
exports.PermanentLockedAccount = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.baseVestingAccount !== undefined) {
            exports.BaseVestingAccount.encode(message.baseVestingAccount, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePermanentLockedAccount();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.baseVestingAccount = exports.BaseVestingAccount.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            baseVestingAccount: (0, helpers_1.isSet)(object.baseVestingAccount)
                ? exports.BaseVestingAccount.fromJSON(object.baseVestingAccount)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.baseVestingAccount !== undefined &&
            (obj.baseVestingAccount = message.baseVestingAccount
                ? exports.BaseVestingAccount.toJSON(message.baseVestingAccount)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBasePermanentLockedAccount();
        message.baseVestingAccount =
            object.baseVestingAccount !== undefined && object.baseVestingAccount !== null
                ? exports.BaseVestingAccount.fromPartial(object.baseVestingAccount)
                : undefined;
        return message;
    },
};
//# sourceMappingURL=vesting.js.map

/***/ }),

/***/ 48451:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.AcceptedMessagesFilter = exports.AcceptedMessageKeysFilter = exports.AllowAllMessagesFilter = exports.CombinedLimit = exports.MaxFundsLimit = exports.MaxCallsLimit = exports.ContractGrant = exports.ContractMigrationAuthorization = exports.ContractExecutionAuthorization = exports.protobufPackage = void 0;
/* eslint-disable */
const any_1 = __webpack_require__(75654);
const coin_1 = __webpack_require__(81637);
const helpers_1 = __webpack_require__(92654);
const _m0 = __importStar(__webpack_require__(62100));
exports.protobufPackage = "cosmwasm.wasm.v1";
function createBaseContractExecutionAuthorization() {
    return {
        grants: [],
    };
}
exports.ContractExecutionAuthorization = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.grants) {
            exports.ContractGrant.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseContractExecutionAuthorization();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.grants.push(exports.ContractGrant.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            grants: Array.isArray(object?.grants) ? object.grants.map((e) => exports.ContractGrant.fromJSON(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.grants) {
            obj.grants = message.grants.map((e) => (e ? exports.ContractGrant.toJSON(e) : undefined));
        }
        else {
            obj.grants = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseContractExecutionAuthorization();
        message.grants = object.grants?.map((e) => exports.ContractGrant.fromPartial(e)) || [];
        return message;
    },
};
function createBaseContractMigrationAuthorization() {
    return {
        grants: [],
    };
}
exports.ContractMigrationAuthorization = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.grants) {
            exports.ContractGrant.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseContractMigrationAuthorization();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.grants.push(exports.ContractGrant.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            grants: Array.isArray(object?.grants) ? object.grants.map((e) => exports.ContractGrant.fromJSON(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.grants) {
            obj.grants = message.grants.map((e) => (e ? exports.ContractGrant.toJSON(e) : undefined));
        }
        else {
            obj.grants = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseContractMigrationAuthorization();
        message.grants = object.grants?.map((e) => exports.ContractGrant.fromPartial(e)) || [];
        return message;
    },
};
function createBaseContractGrant() {
    return {
        contract: "",
        limit: undefined,
        filter: undefined,
    };
}
exports.ContractGrant = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.contract !== "") {
            writer.uint32(10).string(message.contract);
        }
        if (message.limit !== undefined) {
            any_1.Any.encode(message.limit, writer.uint32(18).fork()).ldelim();
        }
        if (message.filter !== undefined) {
            any_1.Any.encode(message.filter, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseContractGrant();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.contract = reader.string();
                    break;
                case 2:
                    message.limit = any_1.Any.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.filter = any_1.Any.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            contract: (0, helpers_1.isSet)(object.contract) ? String(object.contract) : "",
            limit: (0, helpers_1.isSet)(object.limit) ? any_1.Any.fromJSON(object.limit) : undefined,
            filter: (0, helpers_1.isSet)(object.filter) ? any_1.Any.fromJSON(object.filter) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.contract !== undefined && (obj.contract = message.contract);
        message.limit !== undefined && (obj.limit = message.limit ? any_1.Any.toJSON(message.limit) : undefined);
        message.filter !== undefined && (obj.filter = message.filter ? any_1.Any.toJSON(message.filter) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseContractGrant();
        message.contract = object.contract ?? "";
        message.limit =
            object.limit !== undefined && object.limit !== null ? any_1.Any.fromPartial(object.limit) : undefined;
        message.filter =
            object.filter !== undefined && object.filter !== null ? any_1.Any.fromPartial(object.filter) : undefined;
        return message;
    },
};
function createBaseMaxCallsLimit() {
    return {
        remaining: helpers_1.Long.UZERO,
    };
}
exports.MaxCallsLimit = {
    encode(message, writer = _m0.Writer.create()) {
        if (!message.remaining.isZero()) {
            writer.uint32(8).uint64(message.remaining);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMaxCallsLimit();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.remaining = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            remaining: (0, helpers_1.isSet)(object.remaining) ? helpers_1.Long.fromValue(object.remaining) : helpers_1.Long.UZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        message.remaining !== undefined && (obj.remaining = (message.remaining || helpers_1.Long.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMaxCallsLimit();
        message.remaining =
            object.remaining !== undefined && object.remaining !== null
                ? helpers_1.Long.fromValue(object.remaining)
                : helpers_1.Long.UZERO;
        return message;
    },
};
function createBaseMaxFundsLimit() {
    return {
        amounts: [],
    };
}
exports.MaxFundsLimit = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.amounts) {
            coin_1.Coin.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMaxFundsLimit();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.amounts.push(coin_1.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            amounts: Array.isArray(object?.amounts) ? object.amounts.map((e) => coin_1.Coin.fromJSON(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.amounts) {
            obj.amounts = message.amounts.map((e) => (e ? coin_1.Coin.toJSON(e) : undefined));
        }
        else {
            obj.amounts = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMaxFundsLimit();
        message.amounts = object.amounts?.map((e) => coin_1.Coin.fromPartial(e)) || [];
        return message;
    },
};
function createBaseCombinedLimit() {
    return {
        callsRemaining: helpers_1.Long.UZERO,
        amounts: [],
    };
}
exports.CombinedLimit = {
    encode(message, writer = _m0.Writer.create()) {
        if (!message.callsRemaining.isZero()) {
            writer.uint32(8).uint64(message.callsRemaining);
        }
        for (const v of message.amounts) {
            coin_1.Coin.encode(v, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCombinedLimit();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.callsRemaining = reader.uint64();
                    break;
                case 2:
                    message.amounts.push(coin_1.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            callsRemaining: (0, helpers_1.isSet)(object.callsRemaining) ? helpers_1.Long.fromValue(object.callsRemaining) : helpers_1.Long.UZERO,
            amounts: Array.isArray(object?.amounts) ? object.amounts.map((e) => coin_1.Coin.fromJSON(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        message.callsRemaining !== undefined &&
            (obj.callsRemaining = (message.callsRemaining || helpers_1.Long.UZERO).toString());
        if (message.amounts) {
            obj.amounts = message.amounts.map((e) => (e ? coin_1.Coin.toJSON(e) : undefined));
        }
        else {
            obj.amounts = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseCombinedLimit();
        message.callsRemaining =
            object.callsRemaining !== undefined && object.callsRemaining !== null
                ? helpers_1.Long.fromValue(object.callsRemaining)
                : helpers_1.Long.UZERO;
        message.amounts = object.amounts?.map((e) => coin_1.Coin.fromPartial(e)) || [];
        return message;
    },
};
function createBaseAllowAllMessagesFilter() {
    return {};
}
exports.AllowAllMessagesFilter = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAllowAllMessagesFilter();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseAllowAllMessagesFilter();
        return message;
    },
};
function createBaseAcceptedMessageKeysFilter() {
    return {
        keys: [],
    };
}
exports.AcceptedMessageKeysFilter = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.keys) {
            writer.uint32(10).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAcceptedMessageKeysFilter();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.keys.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            keys: Array.isArray(object?.keys) ? object.keys.map((e) => String(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.keys) {
            obj.keys = message.keys.map((e) => e);
        }
        else {
            obj.keys = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseAcceptedMessageKeysFilter();
        message.keys = object.keys?.map((e) => e) || [];
        return message;
    },
};
function createBaseAcceptedMessagesFilter() {
    return {
        messages: [],
    };
}
exports.AcceptedMessagesFilter = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.messages) {
            writer.uint32(10).bytes(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAcceptedMessagesFilter();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.messages.push(reader.bytes());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            messages: Array.isArray(object?.messages) ? object.messages.map((e) => (0, helpers_1.bytesFromBase64)(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.messages) {
            obj.messages = message.messages.map((e) => (0, helpers_1.base64FromBytes)(e !== undefined ? e : new Uint8Array()));
        }
        else {
            obj.messages = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseAcceptedMessagesFilter();
        message.messages = object.messages?.map((e) => e) || [];
        return message;
    },
};
//# sourceMappingURL=authz.js.map

/***/ }),

/***/ 97978:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.StoreAndInstantiateContractProposal = exports.UpdateInstantiateConfigProposal = exports.AccessConfigUpdate = exports.UnpinCodesProposal = exports.PinCodesProposal = exports.ClearAdminProposal = exports.UpdateAdminProposal = exports.ExecuteContractProposal = exports.SudoContractProposal = exports.MigrateContractProposal = exports.InstantiateContract2Proposal = exports.InstantiateContractProposal = exports.StoreCodeProposal = exports.protobufPackage = void 0;
/* eslint-disable */
const types_1 = __webpack_require__(89675);
const coin_1 = __webpack_require__(81637);
const helpers_1 = __webpack_require__(92654);
const _m0 = __importStar(__webpack_require__(62100));
exports.protobufPackage = "cosmwasm.wasm.v1";
function createBaseStoreCodeProposal() {
    return {
        title: "",
        description: "",
        runAs: "",
        wasmByteCode: new Uint8Array(),
        instantiatePermission: undefined,
        unpinCode: false,
        source: "",
        builder: "",
        codeHash: new Uint8Array(),
    };
}
exports.StoreCodeProposal = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.title !== "") {
            writer.uint32(10).string(message.title);
        }
        if (message.description !== "") {
            writer.uint32(18).string(message.description);
        }
        if (message.runAs !== "") {
            writer.uint32(26).string(message.runAs);
        }
        if (message.wasmByteCode.length !== 0) {
            writer.uint32(34).bytes(message.wasmByteCode);
        }
        if (message.instantiatePermission !== undefined) {
            types_1.AccessConfig.encode(message.instantiatePermission, writer.uint32(58).fork()).ldelim();
        }
        if (message.unpinCode === true) {
            writer.uint32(64).bool(message.unpinCode);
        }
        if (message.source !== "") {
            writer.uint32(74).string(message.source);
        }
        if (message.builder !== "") {
            writer.uint32(82).string(message.builder);
        }
        if (message.codeHash.length !== 0) {
            writer.uint32(90).bytes(message.codeHash);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseStoreCodeProposal();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.title = reader.string();
                    break;
                case 2:
                    message.description = reader.string();
                    break;
                case 3:
                    message.runAs = reader.string();
                    break;
                case 4:
                    message.wasmByteCode = reader.bytes();
                    break;
                case 7:
                    message.instantiatePermission = types_1.AccessConfig.decode(reader, reader.uint32());
                    break;
                case 8:
                    message.unpinCode = reader.bool();
                    break;
                case 9:
                    message.source = reader.string();
                    break;
                case 10:
                    message.builder = reader.string();
                    break;
                case 11:
                    message.codeHash = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            title: (0, helpers_1.isSet)(object.title) ? String(object.title) : "",
            description: (0, helpers_1.isSet)(object.description) ? String(object.description) : "",
            runAs: (0, helpers_1.isSet)(object.runAs) ? String(object.runAs) : "",
            wasmByteCode: (0, helpers_1.isSet)(object.wasmByteCode) ? (0, helpers_1.bytesFromBase64)(object.wasmByteCode) : new Uint8Array(),
            instantiatePermission: (0, helpers_1.isSet)(object.instantiatePermission)
                ? types_1.AccessConfig.fromJSON(object.instantiatePermission)
                : undefined,
            unpinCode: (0, helpers_1.isSet)(object.unpinCode) ? Boolean(object.unpinCode) : false,
            source: (0, helpers_1.isSet)(object.source) ? String(object.source) : "",
            builder: (0, helpers_1.isSet)(object.builder) ? String(object.builder) : "",
            codeHash: (0, helpers_1.isSet)(object.codeHash) ? (0, helpers_1.bytesFromBase64)(object.codeHash) : new Uint8Array(),
        };
    },
    toJSON(message) {
        const obj = {};
        message.title !== undefined && (obj.title = message.title);
        message.description !== undefined && (obj.description = message.description);
        message.runAs !== undefined && (obj.runAs = message.runAs);
        message.wasmByteCode !== undefined &&
            (obj.wasmByteCode = (0, helpers_1.base64FromBytes)(message.wasmByteCode !== undefined ? message.wasmByteCode : new Uint8Array()));
        message.instantiatePermission !== undefined &&
            (obj.instantiatePermission = message.instantiatePermission
                ? types_1.AccessConfig.toJSON(message.instantiatePermission)
                : undefined);
        message.unpinCode !== undefined && (obj.unpinCode = message.unpinCode);
        message.source !== undefined && (obj.source = message.source);
        message.builder !== undefined && (obj.builder = message.builder);
        message.codeHash !== undefined &&
            (obj.codeHash = (0, helpers_1.base64FromBytes)(message.codeHash !== undefined ? message.codeHash : new Uint8Array()));
        return obj;
    },
    fromPartial(object) {
        const message = createBaseStoreCodeProposal();
        message.title = object.title ?? "";
        message.description = object.description ?? "";
        message.runAs = object.runAs ?? "";
        message.wasmByteCode = object.wasmByteCode ?? new Uint8Array();
        message.instantiatePermission =
            object.instantiatePermission !== undefined && object.instantiatePermission !== null
                ? types_1.AccessConfig.fromPartial(object.instantiatePermission)
                : undefined;
        message.unpinCode = object.unpinCode ?? false;
        message.source = object.source ?? "";
        message.builder = object.builder ?? "";
        message.codeHash = object.codeHash ?? new Uint8Array();
        return message;
    },
};
function createBaseInstantiateContractProposal() {
    return {
        title: "",
        description: "",
        runAs: "",
        admin: "",
        codeId: helpers_1.Long.UZERO,
        label: "",
        msg: new Uint8Array(),
        funds: [],
    };
}
exports.InstantiateContractProposal = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.title !== "") {
            writer.uint32(10).string(message.title);
        }
        if (message.description !== "") {
            writer.uint32(18).string(message.description);
        }
        if (message.runAs !== "") {
            writer.uint32(26).string(message.runAs);
        }
        if (message.admin !== "") {
            writer.uint32(34).string(message.admin);
        }
        if (!message.codeId.isZero()) {
            writer.uint32(40).uint64(message.codeId);
        }
        if (message.label !== "") {
            writer.uint32(50).string(message.label);
        }
        if (message.msg.length !== 0) {
            writer.uint32(58).bytes(message.msg);
        }
        for (const v of message.funds) {
            coin_1.Coin.encode(v, writer.uint32(66).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseInstantiateContractProposal();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.title = reader.string();
                    break;
                case 2:
                    message.description = reader.string();
                    break;
                case 3:
                    message.runAs = reader.string();
                    break;
                case 4:
                    message.admin = reader.string();
                    break;
                case 5:
                    message.codeId = reader.uint64();
                    break;
                case 6:
                    message.label = reader.string();
                    break;
                case 7:
                    message.msg = reader.bytes();
                    break;
                case 8:
                    message.funds.push(coin_1.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            title: (0, helpers_1.isSet)(object.title) ? String(object.title) : "",
            description: (0, helpers_1.isSet)(object.description) ? String(object.description) : "",
            runAs: (0, helpers_1.isSet)(object.runAs) ? String(object.runAs) : "",
            admin: (0, helpers_1.isSet)(object.admin) ? String(object.admin) : "",
            codeId: (0, helpers_1.isSet)(object.codeId) ? helpers_1.Long.fromValue(object.codeId) : helpers_1.Long.UZERO,
            label: (0, helpers_1.isSet)(object.label) ? String(object.label) : "",
            msg: (0, helpers_1.isSet)(object.msg) ? (0, helpers_1.bytesFromBase64)(object.msg) : new Uint8Array(),
            funds: Array.isArray(object?.funds) ? object.funds.map((e) => coin_1.Coin.fromJSON(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        message.title !== undefined && (obj.title = message.title);
        message.description !== undefined && (obj.description = message.description);
        message.runAs !== undefined && (obj.runAs = message.runAs);
        message.admin !== undefined && (obj.admin = message.admin);
        message.codeId !== undefined && (obj.codeId = (message.codeId || helpers_1.Long.UZERO).toString());
        message.label !== undefined && (obj.label = message.label);
        message.msg !== undefined &&
            (obj.msg = (0, helpers_1.base64FromBytes)(message.msg !== undefined ? message.msg : new Uint8Array()));
        if (message.funds) {
            obj.funds = message.funds.map((e) => (e ? coin_1.Coin.toJSON(e) : undefined));
        }
        else {
            obj.funds = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseInstantiateContractProposal();
        message.title = object.title ?? "";
        message.description = object.description ?? "";
        message.runAs = object.runAs ?? "";
        message.admin = object.admin ?? "";
        message.codeId =
            object.codeId !== undefined && object.codeId !== null ? helpers_1.Long.fromValue(object.codeId) : helpers_1.Long.UZERO;
        message.label = object.label ?? "";
        message.msg = object.msg ?? new Uint8Array();
        message.funds = object.funds?.map((e) => coin_1.Coin.fromPartial(e)) || [];
        return message;
    },
};
function createBaseInstantiateContract2Proposal() {
    return {
        title: "",
        description: "",
        runAs: "",
        admin: "",
        codeId: helpers_1.Long.UZERO,
        label: "",
        msg: new Uint8Array(),
        funds: [],
        salt: new Uint8Array(),
        fixMsg: false,
    };
}
exports.InstantiateContract2Proposal = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.title !== "") {
            writer.uint32(10).string(message.title);
        }
        if (message.description !== "") {
            writer.uint32(18).string(message.description);
        }
        if (message.runAs !== "") {
            writer.uint32(26).string(message.runAs);
        }
        if (message.admin !== "") {
            writer.uint32(34).string(message.admin);
        }
        if (!message.codeId.isZero()) {
            writer.uint32(40).uint64(message.codeId);
        }
        if (message.label !== "") {
            writer.uint32(50).string(message.label);
        }
        if (message.msg.length !== 0) {
            writer.uint32(58).bytes(message.msg);
        }
        for (const v of message.funds) {
            coin_1.Coin.encode(v, writer.uint32(66).fork()).ldelim();
        }
        if (message.salt.length !== 0) {
            writer.uint32(74).bytes(message.salt);
        }
        if (message.fixMsg === true) {
            writer.uint32(80).bool(message.fixMsg);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseInstantiateContract2Proposal();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.title = reader.string();
                    break;
                case 2:
                    message.description = reader.string();
                    break;
                case 3:
                    message.runAs = reader.string();
                    break;
                case 4:
                    message.admin = reader.string();
                    break;
                case 5:
                    message.codeId = reader.uint64();
                    break;
                case 6:
                    message.label = reader.string();
                    break;
                case 7:
                    message.msg = reader.bytes();
                    break;
                case 8:
                    message.funds.push(coin_1.Coin.decode(reader, reader.uint32()));
                    break;
                case 9:
                    message.salt = reader.bytes();
                    break;
                case 10:
                    message.fixMsg = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            title: (0, helpers_1.isSet)(object.title) ? String(object.title) : "",
            description: (0, helpers_1.isSet)(object.description) ? String(object.description) : "",
            runAs: (0, helpers_1.isSet)(object.runAs) ? String(object.runAs) : "",
            admin: (0, helpers_1.isSet)(object.admin) ? String(object.admin) : "",
            codeId: (0, helpers_1.isSet)(object.codeId) ? helpers_1.Long.fromValue(object.codeId) : helpers_1.Long.UZERO,
            label: (0, helpers_1.isSet)(object.label) ? String(object.label) : "",
            msg: (0, helpers_1.isSet)(object.msg) ? (0, helpers_1.bytesFromBase64)(object.msg) : new Uint8Array(),
            funds: Array.isArray(object?.funds) ? object.funds.map((e) => coin_1.Coin.fromJSON(e)) : [],
            salt: (0, helpers_1.isSet)(object.salt) ? (0, helpers_1.bytesFromBase64)(object.salt) : new Uint8Array(),
            fixMsg: (0, helpers_1.isSet)(object.fixMsg) ? Boolean(object.fixMsg) : false,
        };
    },
    toJSON(message) {
        const obj = {};
        message.title !== undefined && (obj.title = message.title);
        message.description !== undefined && (obj.description = message.description);
        message.runAs !== undefined && (obj.runAs = message.runAs);
        message.admin !== undefined && (obj.admin = message.admin);
        message.codeId !== undefined && (obj.codeId = (message.codeId || helpers_1.Long.UZERO).toString());
        message.label !== undefined && (obj.label = message.label);
        message.msg !== undefined &&
            (obj.msg = (0, helpers_1.base64FromBytes)(message.msg !== undefined ? message.msg : new Uint8Array()));
        if (message.funds) {
            obj.funds = message.funds.map((e) => (e ? coin_1.Coin.toJSON(e) : undefined));
        }
        else {
            obj.funds = [];
        }
        message.salt !== undefined &&
            (obj.salt = (0, helpers_1.base64FromBytes)(message.salt !== undefined ? message.salt : new Uint8Array()));
        message.fixMsg !== undefined && (obj.fixMsg = message.fixMsg);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseInstantiateContract2Proposal();
        message.title = object.title ?? "";
        message.description = object.description ?? "";
        message.runAs = object.runAs ?? "";
        message.admin = object.admin ?? "";
        message.codeId =
            object.codeId !== undefined && object.codeId !== null ? helpers_1.Long.fromValue(object.codeId) : helpers_1.Long.UZERO;
        message.label = object.label ?? "";
        message.msg = object.msg ?? new Uint8Array();
        message.funds = object.funds?.map((e) => coin_1.Coin.fromPartial(e)) || [];
        message.salt = object.salt ?? new Uint8Array();
        message.fixMsg = object.fixMsg ?? false;
        return message;
    },
};
function createBaseMigrateContractProposal() {
    return {
        title: "",
        description: "",
        contract: "",
        codeId: helpers_1.Long.UZERO,
        msg: new Uint8Array(),
    };
}
exports.MigrateContractProposal = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.title !== "") {
            writer.uint32(10).string(message.title);
        }
        if (message.description !== "") {
            writer.uint32(18).string(message.description);
        }
        if (message.contract !== "") {
            writer.uint32(34).string(message.contract);
        }
        if (!message.codeId.isZero()) {
            writer.uint32(40).uint64(message.codeId);
        }
        if (message.msg.length !== 0) {
            writer.uint32(50).bytes(message.msg);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMigrateContractProposal();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.title = reader.string();
                    break;
                case 2:
                    message.description = reader.string();
                    break;
                case 4:
                    message.contract = reader.string();
                    break;
                case 5:
                    message.codeId = reader.uint64();
                    break;
                case 6:
                    message.msg = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            title: (0, helpers_1.isSet)(object.title) ? String(object.title) : "",
            description: (0, helpers_1.isSet)(object.description) ? String(object.description) : "",
            contract: (0, helpers_1.isSet)(object.contract) ? String(object.contract) : "",
            codeId: (0, helpers_1.isSet)(object.codeId) ? helpers_1.Long.fromValue(object.codeId) : helpers_1.Long.UZERO,
            msg: (0, helpers_1.isSet)(object.msg) ? (0, helpers_1.bytesFromBase64)(object.msg) : new Uint8Array(),
        };
    },
    toJSON(message) {
        const obj = {};
        message.title !== undefined && (obj.title = message.title);
        message.description !== undefined && (obj.description = message.description);
        message.contract !== undefined && (obj.contract = message.contract);
        message.codeId !== undefined && (obj.codeId = (message.codeId || helpers_1.Long.UZERO).toString());
        message.msg !== undefined &&
            (obj.msg = (0, helpers_1.base64FromBytes)(message.msg !== undefined ? message.msg : new Uint8Array()));
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMigrateContractProposal();
        message.title = object.title ?? "";
        message.description = object.description ?? "";
        message.contract = object.contract ?? "";
        message.codeId =
            object.codeId !== undefined && object.codeId !== null ? helpers_1.Long.fromValue(object.codeId) : helpers_1.Long.UZERO;
        message.msg = object.msg ?? new Uint8Array();
        return message;
    },
};
function createBaseSudoContractProposal() {
    return {
        title: "",
        description: "",
        contract: "",
        msg: new Uint8Array(),
    };
}
exports.SudoContractProposal = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.title !== "") {
            writer.uint32(10).string(message.title);
        }
        if (message.description !== "") {
            writer.uint32(18).string(message.description);
        }
        if (message.contract !== "") {
            writer.uint32(26).string(message.contract);
        }
        if (message.msg.length !== 0) {
            writer.uint32(34).bytes(message.msg);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSudoContractProposal();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.title = reader.string();
                    break;
                case 2:
                    message.description = reader.string();
                    break;
                case 3:
                    message.contract = reader.string();
                    break;
                case 4:
                    message.msg = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            title: (0, helpers_1.isSet)(object.title) ? String(object.title) : "",
            description: (0, helpers_1.isSet)(object.description) ? String(object.description) : "",
            contract: (0, helpers_1.isSet)(object.contract) ? String(object.contract) : "",
            msg: (0, helpers_1.isSet)(object.msg) ? (0, helpers_1.bytesFromBase64)(object.msg) : new Uint8Array(),
        };
    },
    toJSON(message) {
        const obj = {};
        message.title !== undefined && (obj.title = message.title);
        message.description !== undefined && (obj.description = message.description);
        message.contract !== undefined && (obj.contract = message.contract);
        message.msg !== undefined &&
            (obj.msg = (0, helpers_1.base64FromBytes)(message.msg !== undefined ? message.msg : new Uint8Array()));
        return obj;
    },
    fromPartial(object) {
        const message = createBaseSudoContractProposal();
        message.title = object.title ?? "";
        message.description = object.description ?? "";
        message.contract = object.contract ?? "";
        message.msg = object.msg ?? new Uint8Array();
        return message;
    },
};
function createBaseExecuteContractProposal() {
    return {
        title: "",
        description: "",
        runAs: "",
        contract: "",
        msg: new Uint8Array(),
        funds: [],
    };
}
exports.ExecuteContractProposal = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.title !== "") {
            writer.uint32(10).string(message.title);
        }
        if (message.description !== "") {
            writer.uint32(18).string(message.description);
        }
        if (message.runAs !== "") {
            writer.uint32(26).string(message.runAs);
        }
        if (message.contract !== "") {
            writer.uint32(34).string(message.contract);
        }
        if (message.msg.length !== 0) {
            writer.uint32(42).bytes(message.msg);
        }
        for (const v of message.funds) {
            coin_1.Coin.encode(v, writer.uint32(50).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseExecuteContractProposal();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.title = reader.string();
                    break;
                case 2:
                    message.description = reader.string();
                    break;
                case 3:
                    message.runAs = reader.string();
                    break;
                case 4:
                    message.contract = reader.string();
                    break;
                case 5:
                    message.msg = reader.bytes();
                    break;
                case 6:
                    message.funds.push(coin_1.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            title: (0, helpers_1.isSet)(object.title) ? String(object.title) : "",
            description: (0, helpers_1.isSet)(object.description) ? String(object.description) : "",
            runAs: (0, helpers_1.isSet)(object.runAs) ? String(object.runAs) : "",
            contract: (0, helpers_1.isSet)(object.contract) ? String(object.contract) : "",
            msg: (0, helpers_1.isSet)(object.msg) ? (0, helpers_1.bytesFromBase64)(object.msg) : new Uint8Array(),
            funds: Array.isArray(object?.funds) ? object.funds.map((e) => coin_1.Coin.fromJSON(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        message.title !== undefined && (obj.title = message.title);
        message.description !== undefined && (obj.description = message.description);
        message.runAs !== undefined && (obj.runAs = message.runAs);
        message.contract !== undefined && (obj.contract = message.contract);
        message.msg !== undefined &&
            (obj.msg = (0, helpers_1.base64FromBytes)(message.msg !== undefined ? message.msg : new Uint8Array()));
        if (message.funds) {
            obj.funds = message.funds.map((e) => (e ? coin_1.Coin.toJSON(e) : undefined));
        }
        else {
            obj.funds = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseExecuteContractProposal();
        message.title = object.title ?? "";
        message.description = object.description ?? "";
        message.runAs = object.runAs ?? "";
        message.contract = object.contract ?? "";
        message.msg = object.msg ?? new Uint8Array();
        message.funds = object.funds?.map((e) => coin_1.Coin.fromPartial(e)) || [];
        return message;
    },
};
function createBaseUpdateAdminProposal() {
    return {
        title: "",
        description: "",
        newAdmin: "",
        contract: "",
    };
}
exports.UpdateAdminProposal = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.title !== "") {
            writer.uint32(10).string(message.title);
        }
        if (message.description !== "") {
            writer.uint32(18).string(message.description);
        }
        if (message.newAdmin !== "") {
            writer.uint32(26).string(message.newAdmin);
        }
        if (message.contract !== "") {
            writer.uint32(34).string(message.contract);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUpdateAdminProposal();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.title = reader.string();
                    break;
                case 2:
                    message.description = reader.string();
                    break;
                case 3:
                    message.newAdmin = reader.string();
                    break;
                case 4:
                    message.contract = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            title: (0, helpers_1.isSet)(object.title) ? String(object.title) : "",
            description: (0, helpers_1.isSet)(object.description) ? String(object.description) : "",
            newAdmin: (0, helpers_1.isSet)(object.newAdmin) ? String(object.newAdmin) : "",
            contract: (0, helpers_1.isSet)(object.contract) ? String(object.contract) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.title !== undefined && (obj.title = message.title);
        message.description !== undefined && (obj.description = message.description);
        message.newAdmin !== undefined && (obj.newAdmin = message.newAdmin);
        message.contract !== undefined && (obj.contract = message.contract);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseUpdateAdminProposal();
        message.title = object.title ?? "";
        message.description = object.description ?? "";
        message.newAdmin = object.newAdmin ?? "";
        message.contract = object.contract ?? "";
        return message;
    },
};
function createBaseClearAdminProposal() {
    return {
        title: "",
        description: "",
        contract: "",
    };
}
exports.ClearAdminProposal = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.title !== "") {
            writer.uint32(10).string(message.title);
        }
        if (message.description !== "") {
            writer.uint32(18).string(message.description);
        }
        if (message.contract !== "") {
            writer.uint32(26).string(message.contract);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseClearAdminProposal();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.title = reader.string();
                    break;
                case 2:
                    message.description = reader.string();
                    break;
                case 3:
                    message.contract = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            title: (0, helpers_1.isSet)(object.title) ? String(object.title) : "",
            description: (0, helpers_1.isSet)(object.description) ? String(object.description) : "",
            contract: (0, helpers_1.isSet)(object.contract) ? String(object.contract) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.title !== undefined && (obj.title = message.title);
        message.description !== undefined && (obj.description = message.description);
        message.contract !== undefined && (obj.contract = message.contract);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseClearAdminProposal();
        message.title = object.title ?? "";
        message.description = object.description ?? "";
        message.contract = object.contract ?? "";
        return message;
    },
};
function createBasePinCodesProposal() {
    return {
        title: "",
        description: "",
        codeIds: [],
    };
}
exports.PinCodesProposal = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.title !== "") {
            writer.uint32(10).string(message.title);
        }
        if (message.description !== "") {
            writer.uint32(18).string(message.description);
        }
        writer.uint32(26).fork();
        for (const v of message.codeIds) {
            writer.uint64(v);
        }
        writer.ldelim();
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePinCodesProposal();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.title = reader.string();
                    break;
                case 2:
                    message.description = reader.string();
                    break;
                case 3:
                    if ((tag & 7) === 2) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.codeIds.push(reader.uint64());
                        }
                    }
                    else {
                        message.codeIds.push(reader.uint64());
                    }
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            title: (0, helpers_1.isSet)(object.title) ? String(object.title) : "",
            description: (0, helpers_1.isSet)(object.description) ? String(object.description) : "",
            codeIds: Array.isArray(object?.codeIds) ? object.codeIds.map((e) => helpers_1.Long.fromValue(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        message.title !== undefined && (obj.title = message.title);
        message.description !== undefined && (obj.description = message.description);
        if (message.codeIds) {
            obj.codeIds = message.codeIds.map((e) => (e || helpers_1.Long.UZERO).toString());
        }
        else {
            obj.codeIds = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBasePinCodesProposal();
        message.title = object.title ?? "";
        message.description = object.description ?? "";
        message.codeIds = object.codeIds?.map((e) => helpers_1.Long.fromValue(e)) || [];
        return message;
    },
};
function createBaseUnpinCodesProposal() {
    return {
        title: "",
        description: "",
        codeIds: [],
    };
}
exports.UnpinCodesProposal = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.title !== "") {
            writer.uint32(10).string(message.title);
        }
        if (message.description !== "") {
            writer.uint32(18).string(message.description);
        }
        writer.uint32(26).fork();
        for (const v of message.codeIds) {
            writer.uint64(v);
        }
        writer.ldelim();
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUnpinCodesProposal();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.title = reader.string();
                    break;
                case 2:
                    message.description = reader.string();
                    break;
                case 3:
                    if ((tag & 7) === 2) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.codeIds.push(reader.uint64());
                        }
                    }
                    else {
                        message.codeIds.push(reader.uint64());
                    }
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            title: (0, helpers_1.isSet)(object.title) ? String(object.title) : "",
            description: (0, helpers_1.isSet)(object.description) ? String(object.description) : "",
            codeIds: Array.isArray(object?.codeIds) ? object.codeIds.map((e) => helpers_1.Long.fromValue(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        message.title !== undefined && (obj.title = message.title);
        message.description !== undefined && (obj.description = message.description);
        if (message.codeIds) {
            obj.codeIds = message.codeIds.map((e) => (e || helpers_1.Long.UZERO).toString());
        }
        else {
            obj.codeIds = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseUnpinCodesProposal();
        message.title = object.title ?? "";
        message.description = object.description ?? "";
        message.codeIds = object.codeIds?.map((e) => helpers_1.Long.fromValue(e)) || [];
        return message;
    },
};
function createBaseAccessConfigUpdate() {
    return {
        codeId: helpers_1.Long.UZERO,
        instantiatePermission: undefined,
    };
}
exports.AccessConfigUpdate = {
    encode(message, writer = _m0.Writer.create()) {
        if (!message.codeId.isZero()) {
            writer.uint32(8).uint64(message.codeId);
        }
        if (message.instantiatePermission !== undefined) {
            types_1.AccessConfig.encode(message.instantiatePermission, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAccessConfigUpdate();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.codeId = reader.uint64();
                    break;
                case 2:
                    message.instantiatePermission = types_1.AccessConfig.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            codeId: (0, helpers_1.isSet)(object.codeId) ? helpers_1.Long.fromValue(object.codeId) : helpers_1.Long.UZERO,
            instantiatePermission: (0, helpers_1.isSet)(object.instantiatePermission)
                ? types_1.AccessConfig.fromJSON(object.instantiatePermission)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.codeId !== undefined && (obj.codeId = (message.codeId || helpers_1.Long.UZERO).toString());
        message.instantiatePermission !== undefined &&
            (obj.instantiatePermission = message.instantiatePermission
                ? types_1.AccessConfig.toJSON(message.instantiatePermission)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseAccessConfigUpdate();
        message.codeId =
            object.codeId !== undefined && object.codeId !== null ? helpers_1.Long.fromValue(object.codeId) : helpers_1.Long.UZERO;
        message.instantiatePermission =
            object.instantiatePermission !== undefined && object.instantiatePermission !== null
                ? types_1.AccessConfig.fromPartial(object.instantiatePermission)
                : undefined;
        return message;
    },
};
function createBaseUpdateInstantiateConfigProposal() {
    return {
        title: "",
        description: "",
        accessConfigUpdates: [],
    };
}
exports.UpdateInstantiateConfigProposal = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.title !== "") {
            writer.uint32(10).string(message.title);
        }
        if (message.description !== "") {
            writer.uint32(18).string(message.description);
        }
        for (const v of message.accessConfigUpdates) {
            exports.AccessConfigUpdate.encode(v, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUpdateInstantiateConfigProposal();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.title = reader.string();
                    break;
                case 2:
                    message.description = reader.string();
                    break;
                case 3:
                    message.accessConfigUpdates.push(exports.AccessConfigUpdate.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            title: (0, helpers_1.isSet)(object.title) ? String(object.title) : "",
            description: (0, helpers_1.isSet)(object.description) ? String(object.description) : "",
            accessConfigUpdates: Array.isArray(object?.accessConfigUpdates)
                ? object.accessConfigUpdates.map((e) => exports.AccessConfigUpdate.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        message.title !== undefined && (obj.title = message.title);
        message.description !== undefined && (obj.description = message.description);
        if (message.accessConfigUpdates) {
            obj.accessConfigUpdates = message.accessConfigUpdates.map((e) => e ? exports.AccessConfigUpdate.toJSON(e) : undefined);
        }
        else {
            obj.accessConfigUpdates = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseUpdateInstantiateConfigProposal();
        message.title = object.title ?? "";
        message.description = object.description ?? "";
        message.accessConfigUpdates =
            object.accessConfigUpdates?.map((e) => exports.AccessConfigUpdate.fromPartial(e)) || [];
        return message;
    },
};
function createBaseStoreAndInstantiateContractProposal() {
    return {
        title: "",
        description: "",
        runAs: "",
        wasmByteCode: new Uint8Array(),
        instantiatePermission: undefined,
        unpinCode: false,
        admin: "",
        label: "",
        msg: new Uint8Array(),
        funds: [],
        source: "",
        builder: "",
        codeHash: new Uint8Array(),
    };
}
exports.StoreAndInstantiateContractProposal = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.title !== "") {
            writer.uint32(10).string(message.title);
        }
        if (message.description !== "") {
            writer.uint32(18).string(message.description);
        }
        if (message.runAs !== "") {
            writer.uint32(26).string(message.runAs);
        }
        if (message.wasmByteCode.length !== 0) {
            writer.uint32(34).bytes(message.wasmByteCode);
        }
        if (message.instantiatePermission !== undefined) {
            types_1.AccessConfig.encode(message.instantiatePermission, writer.uint32(42).fork()).ldelim();
        }
        if (message.unpinCode === true) {
            writer.uint32(48).bool(message.unpinCode);
        }
        if (message.admin !== "") {
            writer.uint32(58).string(message.admin);
        }
        if (message.label !== "") {
            writer.uint32(66).string(message.label);
        }
        if (message.msg.length !== 0) {
            writer.uint32(74).bytes(message.msg);
        }
        for (const v of message.funds) {
            coin_1.Coin.encode(v, writer.uint32(82).fork()).ldelim();
        }
        if (message.source !== "") {
            writer.uint32(90).string(message.source);
        }
        if (message.builder !== "") {
            writer.uint32(98).string(message.builder);
        }
        if (message.codeHash.length !== 0) {
            writer.uint32(106).bytes(message.codeHash);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseStoreAndInstantiateContractProposal();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.title = reader.string();
                    break;
                case 2:
                    message.description = reader.string();
                    break;
                case 3:
                    message.runAs = reader.string();
                    break;
                case 4:
                    message.wasmByteCode = reader.bytes();
                    break;
                case 5:
                    message.instantiatePermission = types_1.AccessConfig.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.unpinCode = reader.bool();
                    break;
                case 7:
                    message.admin = reader.string();
                    break;
                case 8:
                    message.label = reader.string();
                    break;
                case 9:
                    message.msg = reader.bytes();
                    break;
                case 10:
                    message.funds.push(coin_1.Coin.decode(reader, reader.uint32()));
                    break;
                case 11:
                    message.source = reader.string();
                    break;
                case 12:
                    message.builder = reader.string();
                    break;
                case 13:
                    message.codeHash = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            title: (0, helpers_1.isSet)(object.title) ? String(object.title) : "",
            description: (0, helpers_1.isSet)(object.description) ? String(object.description) : "",
            runAs: (0, helpers_1.isSet)(object.runAs) ? String(object.runAs) : "",
            wasmByteCode: (0, helpers_1.isSet)(object.wasmByteCode) ? (0, helpers_1.bytesFromBase64)(object.wasmByteCode) : new Uint8Array(),
            instantiatePermission: (0, helpers_1.isSet)(object.instantiatePermission)
                ? types_1.AccessConfig.fromJSON(object.instantiatePermission)
                : undefined,
            unpinCode: (0, helpers_1.isSet)(object.unpinCode) ? Boolean(object.unpinCode) : false,
            admin: (0, helpers_1.isSet)(object.admin) ? String(object.admin) : "",
            label: (0, helpers_1.isSet)(object.label) ? String(object.label) : "",
            msg: (0, helpers_1.isSet)(object.msg) ? (0, helpers_1.bytesFromBase64)(object.msg) : new Uint8Array(),
            funds: Array.isArray(object?.funds) ? object.funds.map((e) => coin_1.Coin.fromJSON(e)) : [],
            source: (0, helpers_1.isSet)(object.source) ? String(object.source) : "",
            builder: (0, helpers_1.isSet)(object.builder) ? String(object.builder) : "",
            codeHash: (0, helpers_1.isSet)(object.codeHash) ? (0, helpers_1.bytesFromBase64)(object.codeHash) : new Uint8Array(),
        };
    },
    toJSON(message) {
        const obj = {};
        message.title !== undefined && (obj.title = message.title);
        message.description !== undefined && (obj.description = message.description);
        message.runAs !== undefined && (obj.runAs = message.runAs);
        message.wasmByteCode !== undefined &&
            (obj.wasmByteCode = (0, helpers_1.base64FromBytes)(message.wasmByteCode !== undefined ? message.wasmByteCode : new Uint8Array()));
        message.instantiatePermission !== undefined &&
            (obj.instantiatePermission = message.instantiatePermission
                ? types_1.AccessConfig.toJSON(message.instantiatePermission)
                : undefined);
        message.unpinCode !== undefined && (obj.unpinCode = message.unpinCode);
        message.admin !== undefined && (obj.admin = message.admin);
        message.label !== undefined && (obj.label = message.label);
        message.msg !== undefined &&
            (obj.msg = (0, helpers_1.base64FromBytes)(message.msg !== undefined ? message.msg : new Uint8Array()));
        if (message.funds) {
            obj.funds = message.funds.map((e) => (e ? coin_1.Coin.toJSON(e) : undefined));
        }
        else {
            obj.funds = [];
        }
        message.source !== undefined && (obj.source = message.source);
        message.builder !== undefined && (obj.builder = message.builder);
        message.codeHash !== undefined &&
            (obj.codeHash = (0, helpers_1.base64FromBytes)(message.codeHash !== undefined ? message.codeHash : new Uint8Array()));
        return obj;
    },
    fromPartial(object) {
        const message = createBaseStoreAndInstantiateContractProposal();
        message.title = object.title ?? "";
        message.description = object.description ?? "";
        message.runAs = object.runAs ?? "";
        message.wasmByteCode = object.wasmByteCode ?? new Uint8Array();
        message.instantiatePermission =
            object.instantiatePermission !== undefined && object.instantiatePermission !== null
                ? types_1.AccessConfig.fromPartial(object.instantiatePermission)
                : undefined;
        message.unpinCode = object.unpinCode ?? false;
        message.admin = object.admin ?? "";
        message.label = object.label ?? "";
        message.msg = object.msg ?? new Uint8Array();
        message.funds = object.funds?.map((e) => coin_1.Coin.fromPartial(e)) || [];
        message.source = object.source ?? "";
        message.builder = object.builder ?? "";
        message.codeHash = object.codeHash ?? new Uint8Array();
        return message;
    },
};
//# sourceMappingURL=proposal.js.map

/***/ }),

/***/ 14806:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.QueryClientImpl = exports.QueryContractsByCreatorResponse = exports.QueryContractsByCreatorRequest = exports.QueryParamsResponse = exports.QueryParamsRequest = exports.QueryPinnedCodesResponse = exports.QueryPinnedCodesRequest = exports.QueryCodesResponse = exports.QueryCodesRequest = exports.QueryCodeResponse = exports.CodeInfoResponse = exports.QueryCodeRequest = exports.QuerySmartContractStateResponse = exports.QuerySmartContractStateRequest = exports.QueryRawContractStateResponse = exports.QueryRawContractStateRequest = exports.QueryAllContractStateResponse = exports.QueryAllContractStateRequest = exports.QueryContractsByCodeResponse = exports.QueryContractsByCodeRequest = exports.QueryContractHistoryResponse = exports.QueryContractHistoryRequest = exports.QueryContractInfoResponse = exports.QueryContractInfoRequest = exports.protobufPackage = void 0;
/* eslint-disable */
const pagination_1 = __webpack_require__(84043);
const types_1 = __webpack_require__(89675);
const helpers_1 = __webpack_require__(92654);
const _m0 = __importStar(__webpack_require__(62100));
exports.protobufPackage = "cosmwasm.wasm.v1";
function createBaseQueryContractInfoRequest() {
    return {
        address: "",
    };
}
exports.QueryContractInfoRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.address !== "") {
            writer.uint32(10).string(message.address);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryContractInfoRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.address = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            address: (0, helpers_1.isSet)(object.address) ? String(object.address) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryContractInfoRequest();
        message.address = object.address ?? "";
        return message;
    },
};
function createBaseQueryContractInfoResponse() {
    return {
        address: "",
        contractInfo: undefined,
    };
}
exports.QueryContractInfoResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.address !== "") {
            writer.uint32(10).string(message.address);
        }
        if (message.contractInfo !== undefined) {
            types_1.ContractInfo.encode(message.contractInfo, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryContractInfoResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.contractInfo = types_1.ContractInfo.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            address: (0, helpers_1.isSet)(object.address) ? String(object.address) : "",
            contractInfo: (0, helpers_1.isSet)(object.contractInfo) ? types_1.ContractInfo.fromJSON(object.contractInfo) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.contractInfo !== undefined &&
            (obj.contractInfo = message.contractInfo ? types_1.ContractInfo.toJSON(message.contractInfo) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryContractInfoResponse();
        message.address = object.address ?? "";
        message.contractInfo =
            object.contractInfo !== undefined && object.contractInfo !== null
                ? types_1.ContractInfo.fromPartial(object.contractInfo)
                : undefined;
        return message;
    },
};
function createBaseQueryContractHistoryRequest() {
    return {
        address: "",
        pagination: undefined,
    };
}
exports.QueryContractHistoryRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.address !== "") {
            writer.uint32(10).string(message.address);
        }
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryContractHistoryRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            address: (0, helpers_1.isSet)(object.address) ? String(object.address) : "",
            pagination: (0, helpers_1.isSet)(object.pagination) ? pagination_1.PageRequest.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryContractHistoryRequest();
        message.address = object.address ?? "";
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryContractHistoryResponse() {
    return {
        entries: [],
        pagination: undefined,
    };
}
exports.QueryContractHistoryResponse = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.entries) {
            types_1.ContractCodeHistoryEntry.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryContractHistoryResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.entries.push(types_1.ContractCodeHistoryEntry.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            entries: Array.isArray(object?.entries)
                ? object.entries.map((e) => types_1.ContractCodeHistoryEntry.fromJSON(e))
                : [],
            pagination: (0, helpers_1.isSet)(object.pagination) ? pagination_1.PageResponse.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.entries) {
            obj.entries = message.entries.map((e) => (e ? types_1.ContractCodeHistoryEntry.toJSON(e) : undefined));
        }
        else {
            obj.entries = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryContractHistoryResponse();
        message.entries = object.entries?.map((e) => types_1.ContractCodeHistoryEntry.fromPartial(e)) || [];
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryContractsByCodeRequest() {
    return {
        codeId: helpers_1.Long.UZERO,
        pagination: undefined,
    };
}
exports.QueryContractsByCodeRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (!message.codeId.isZero()) {
            writer.uint32(8).uint64(message.codeId);
        }
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryContractsByCodeRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.codeId = reader.uint64();
                    break;
                case 2:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            codeId: (0, helpers_1.isSet)(object.codeId) ? helpers_1.Long.fromValue(object.codeId) : helpers_1.Long.UZERO,
            pagination: (0, helpers_1.isSet)(object.pagination) ? pagination_1.PageRequest.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.codeId !== undefined && (obj.codeId = (message.codeId || helpers_1.Long.UZERO).toString());
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryContractsByCodeRequest();
        message.codeId =
            object.codeId !== undefined && object.codeId !== null ? helpers_1.Long.fromValue(object.codeId) : helpers_1.Long.UZERO;
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryContractsByCodeResponse() {
    return {
        contracts: [],
        pagination: undefined,
    };
}
exports.QueryContractsByCodeResponse = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.contracts) {
            writer.uint32(10).string(v);
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryContractsByCodeResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.contracts.push(reader.string());
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            contracts: Array.isArray(object?.contracts) ? object.contracts.map((e) => String(e)) : [],
            pagination: (0, helpers_1.isSet)(object.pagination) ? pagination_1.PageResponse.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.contracts) {
            obj.contracts = message.contracts.map((e) => e);
        }
        else {
            obj.contracts = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryContractsByCodeResponse();
        message.contracts = object.contracts?.map((e) => e) || [];
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryAllContractStateRequest() {
    return {
        address: "",
        pagination: undefined,
    };
}
exports.QueryAllContractStateRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.address !== "") {
            writer.uint32(10).string(message.address);
        }
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryAllContractStateRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            address: (0, helpers_1.isSet)(object.address) ? String(object.address) : "",
            pagination: (0, helpers_1.isSet)(object.pagination) ? pagination_1.PageRequest.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryAllContractStateRequest();
        message.address = object.address ?? "";
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryAllContractStateResponse() {
    return {
        models: [],
        pagination: undefined,
    };
}
exports.QueryAllContractStateResponse = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.models) {
            types_1.Model.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryAllContractStateResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.models.push(types_1.Model.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            models: Array.isArray(object?.models) ? object.models.map((e) => types_1.Model.fromJSON(e)) : [],
            pagination: (0, helpers_1.isSet)(object.pagination) ? pagination_1.PageResponse.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.models) {
            obj.models = message.models.map((e) => (e ? types_1.Model.toJSON(e) : undefined));
        }
        else {
            obj.models = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryAllContractStateResponse();
        message.models = object.models?.map((e) => types_1.Model.fromPartial(e)) || [];
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryRawContractStateRequest() {
    return {
        address: "",
        queryData: new Uint8Array(),
    };
}
exports.QueryRawContractStateRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.address !== "") {
            writer.uint32(10).string(message.address);
        }
        if (message.queryData.length !== 0) {
            writer.uint32(18).bytes(message.queryData);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryRawContractStateRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.queryData = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            address: (0, helpers_1.isSet)(object.address) ? String(object.address) : "",
            queryData: (0, helpers_1.isSet)(object.queryData) ? (0, helpers_1.bytesFromBase64)(object.queryData) : new Uint8Array(),
        };
    },
    toJSON(message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.queryData !== undefined &&
            (obj.queryData = (0, helpers_1.base64FromBytes)(message.queryData !== undefined ? message.queryData : new Uint8Array()));
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryRawContractStateRequest();
        message.address = object.address ?? "";
        message.queryData = object.queryData ?? new Uint8Array();
        return message;
    },
};
function createBaseQueryRawContractStateResponse() {
    return {
        data: new Uint8Array(),
    };
}
exports.QueryRawContractStateResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.data.length !== 0) {
            writer.uint32(10).bytes(message.data);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryRawContractStateResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.data = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            data: (0, helpers_1.isSet)(object.data) ? (0, helpers_1.bytesFromBase64)(object.data) : new Uint8Array(),
        };
    },
    toJSON(message) {
        const obj = {};
        message.data !== undefined &&
            (obj.data = (0, helpers_1.base64FromBytes)(message.data !== undefined ? message.data : new Uint8Array()));
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryRawContractStateResponse();
        message.data = object.data ?? new Uint8Array();
        return message;
    },
};
function createBaseQuerySmartContractStateRequest() {
    return {
        address: "",
        queryData: new Uint8Array(),
    };
}
exports.QuerySmartContractStateRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.address !== "") {
            writer.uint32(10).string(message.address);
        }
        if (message.queryData.length !== 0) {
            writer.uint32(18).bytes(message.queryData);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQuerySmartContractStateRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.queryData = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            address: (0, helpers_1.isSet)(object.address) ? String(object.address) : "",
            queryData: (0, helpers_1.isSet)(object.queryData) ? (0, helpers_1.bytesFromBase64)(object.queryData) : new Uint8Array(),
        };
    },
    toJSON(message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.queryData !== undefined &&
            (obj.queryData = (0, helpers_1.base64FromBytes)(message.queryData !== undefined ? message.queryData : new Uint8Array()));
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQuerySmartContractStateRequest();
        message.address = object.address ?? "";
        message.queryData = object.queryData ?? new Uint8Array();
        return message;
    },
};
function createBaseQuerySmartContractStateResponse() {
    return {
        data: new Uint8Array(),
    };
}
exports.QuerySmartContractStateResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.data.length !== 0) {
            writer.uint32(10).bytes(message.data);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQuerySmartContractStateResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.data = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            data: (0, helpers_1.isSet)(object.data) ? (0, helpers_1.bytesFromBase64)(object.data) : new Uint8Array(),
        };
    },
    toJSON(message) {
        const obj = {};
        message.data !== undefined &&
            (obj.data = (0, helpers_1.base64FromBytes)(message.data !== undefined ? message.data : new Uint8Array()));
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQuerySmartContractStateResponse();
        message.data = object.data ?? new Uint8Array();
        return message;
    },
};
function createBaseQueryCodeRequest() {
    return {
        codeId: helpers_1.Long.UZERO,
    };
}
exports.QueryCodeRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (!message.codeId.isZero()) {
            writer.uint32(8).uint64(message.codeId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryCodeRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.codeId = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            codeId: (0, helpers_1.isSet)(object.codeId) ? helpers_1.Long.fromValue(object.codeId) : helpers_1.Long.UZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        message.codeId !== undefined && (obj.codeId = (message.codeId || helpers_1.Long.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryCodeRequest();
        message.codeId =
            object.codeId !== undefined && object.codeId !== null ? helpers_1.Long.fromValue(object.codeId) : helpers_1.Long.UZERO;
        return message;
    },
};
function createBaseCodeInfoResponse() {
    return {
        codeId: helpers_1.Long.UZERO,
        creator: "",
        dataHash: new Uint8Array(),
        instantiatePermission: undefined,
    };
}
exports.CodeInfoResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (!message.codeId.isZero()) {
            writer.uint32(8).uint64(message.codeId);
        }
        if (message.creator !== "") {
            writer.uint32(18).string(message.creator);
        }
        if (message.dataHash.length !== 0) {
            writer.uint32(26).bytes(message.dataHash);
        }
        if (message.instantiatePermission !== undefined) {
            types_1.AccessConfig.encode(message.instantiatePermission, writer.uint32(50).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCodeInfoResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.codeId = reader.uint64();
                    break;
                case 2:
                    message.creator = reader.string();
                    break;
                case 3:
                    message.dataHash = reader.bytes();
                    break;
                case 6:
                    message.instantiatePermission = types_1.AccessConfig.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            codeId: (0, helpers_1.isSet)(object.codeId) ? helpers_1.Long.fromValue(object.codeId) : helpers_1.Long.UZERO,
            creator: (0, helpers_1.isSet)(object.creator) ? String(object.creator) : "",
            dataHash: (0, helpers_1.isSet)(object.dataHash) ? (0, helpers_1.bytesFromBase64)(object.dataHash) : new Uint8Array(),
            instantiatePermission: (0, helpers_1.isSet)(object.instantiatePermission)
                ? types_1.AccessConfig.fromJSON(object.instantiatePermission)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.codeId !== undefined && (obj.codeId = (message.codeId || helpers_1.Long.UZERO).toString());
        message.creator !== undefined && (obj.creator = message.creator);
        message.dataHash !== undefined &&
            (obj.dataHash = (0, helpers_1.base64FromBytes)(message.dataHash !== undefined ? message.dataHash : new Uint8Array()));
        message.instantiatePermission !== undefined &&
            (obj.instantiatePermission = message.instantiatePermission
                ? types_1.AccessConfig.toJSON(message.instantiatePermission)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseCodeInfoResponse();
        message.codeId =
            object.codeId !== undefined && object.codeId !== null ? helpers_1.Long.fromValue(object.codeId) : helpers_1.Long.UZERO;
        message.creator = object.creator ?? "";
        message.dataHash = object.dataHash ?? new Uint8Array();
        message.instantiatePermission =
            object.instantiatePermission !== undefined && object.instantiatePermission !== null
                ? types_1.AccessConfig.fromPartial(object.instantiatePermission)
                : undefined;
        return message;
    },
};
function createBaseQueryCodeResponse() {
    return {
        codeInfo: undefined,
        data: new Uint8Array(),
    };
}
exports.QueryCodeResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.codeInfo !== undefined) {
            exports.CodeInfoResponse.encode(message.codeInfo, writer.uint32(10).fork()).ldelim();
        }
        if (message.data.length !== 0) {
            writer.uint32(18).bytes(message.data);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryCodeResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.codeInfo = exports.CodeInfoResponse.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.data = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            codeInfo: (0, helpers_1.isSet)(object.codeInfo) ? exports.CodeInfoResponse.fromJSON(object.codeInfo) : undefined,
            data: (0, helpers_1.isSet)(object.data) ? (0, helpers_1.bytesFromBase64)(object.data) : new Uint8Array(),
        };
    },
    toJSON(message) {
        const obj = {};
        message.codeInfo !== undefined &&
            (obj.codeInfo = message.codeInfo ? exports.CodeInfoResponse.toJSON(message.codeInfo) : undefined);
        message.data !== undefined &&
            (obj.data = (0, helpers_1.base64FromBytes)(message.data !== undefined ? message.data : new Uint8Array()));
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryCodeResponse();
        message.codeInfo =
            object.codeInfo !== undefined && object.codeInfo !== null
                ? exports.CodeInfoResponse.fromPartial(object.codeInfo)
                : undefined;
        message.data = object.data ?? new Uint8Array();
        return message;
    },
};
function createBaseQueryCodesRequest() {
    return {
        pagination: undefined,
    };
}
exports.QueryCodesRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryCodesRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            pagination: (0, helpers_1.isSet)(object.pagination) ? pagination_1.PageRequest.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryCodesRequest();
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryCodesResponse() {
    return {
        codeInfos: [],
        pagination: undefined,
    };
}
exports.QueryCodesResponse = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.codeInfos) {
            exports.CodeInfoResponse.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryCodesResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.codeInfos.push(exports.CodeInfoResponse.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            codeInfos: Array.isArray(object?.codeInfos)
                ? object.codeInfos.map((e) => exports.CodeInfoResponse.fromJSON(e))
                : [],
            pagination: (0, helpers_1.isSet)(object.pagination) ? pagination_1.PageResponse.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.codeInfos) {
            obj.codeInfos = message.codeInfos.map((e) => (e ? exports.CodeInfoResponse.toJSON(e) : undefined));
        }
        else {
            obj.codeInfos = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryCodesResponse();
        message.codeInfos = object.codeInfos?.map((e) => exports.CodeInfoResponse.fromPartial(e)) || [];
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryPinnedCodesRequest() {
    return {
        pagination: undefined,
    };
}
exports.QueryPinnedCodesRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryPinnedCodesRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 2:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            pagination: (0, helpers_1.isSet)(object.pagination) ? pagination_1.PageRequest.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryPinnedCodesRequest();
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryPinnedCodesResponse() {
    return {
        codeIds: [],
        pagination: undefined,
    };
}
exports.QueryPinnedCodesResponse = {
    encode(message, writer = _m0.Writer.create()) {
        writer.uint32(10).fork();
        for (const v of message.codeIds) {
            writer.uint64(v);
        }
        writer.ldelim();
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryPinnedCodesResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if ((tag & 7) === 2) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.codeIds.push(reader.uint64());
                        }
                    }
                    else {
                        message.codeIds.push(reader.uint64());
                    }
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            codeIds: Array.isArray(object?.codeIds) ? object.codeIds.map((e) => helpers_1.Long.fromValue(e)) : [],
            pagination: (0, helpers_1.isSet)(object.pagination) ? pagination_1.PageResponse.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.codeIds) {
            obj.codeIds = message.codeIds.map((e) => (e || helpers_1.Long.UZERO).toString());
        }
        else {
            obj.codeIds = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryPinnedCodesResponse();
        message.codeIds = object.codeIds?.map((e) => helpers_1.Long.fromValue(e)) || [];
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryParamsRequest() {
    return {};
}
exports.QueryParamsRequest = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryParamsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseQueryParamsRequest();
        return message;
    },
};
function createBaseQueryParamsResponse() {
    return {
        params: undefined,
    };
}
exports.QueryParamsResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.params !== undefined) {
            types_1.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryParamsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.params = types_1.Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            params: (0, helpers_1.isSet)(object.params) ? types_1.Params.fromJSON(object.params) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.params !== undefined && (obj.params = message.params ? types_1.Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryParamsResponse();
        message.params =
            object.params !== undefined && object.params !== null ? types_1.Params.fromPartial(object.params) : undefined;
        return message;
    },
};
function createBaseQueryContractsByCreatorRequest() {
    return {
        creatorAddress: "",
        pagination: undefined,
    };
}
exports.QueryContractsByCreatorRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.creatorAddress !== "") {
            writer.uint32(10).string(message.creatorAddress);
        }
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryContractsByCreatorRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creatorAddress = reader.string();
                    break;
                case 2:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            creatorAddress: (0, helpers_1.isSet)(object.creatorAddress) ? String(object.creatorAddress) : "",
            pagination: (0, helpers_1.isSet)(object.pagination) ? pagination_1.PageRequest.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.creatorAddress !== undefined && (obj.creatorAddress = message.creatorAddress);
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryContractsByCreatorRequest();
        message.creatorAddress = object.creatorAddress ?? "";
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryContractsByCreatorResponse() {
    return {
        contractAddresses: [],
        pagination: undefined,
    };
}
exports.QueryContractsByCreatorResponse = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.contractAddresses) {
            writer.uint32(10).string(v);
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryContractsByCreatorResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.contractAddresses.push(reader.string());
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            contractAddresses: Array.isArray(object?.contractAddresses)
                ? object.contractAddresses.map((e) => String(e))
                : [],
            pagination: (0, helpers_1.isSet)(object.pagination) ? pagination_1.PageResponse.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.contractAddresses) {
            obj.contractAddresses = message.contractAddresses.map((e) => e);
        }
        else {
            obj.contractAddresses = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryContractsByCreatorResponse();
        message.contractAddresses = object.contractAddresses?.map((e) => e) || [];
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
class QueryClientImpl {
    constructor(rpc) {
        this.rpc = rpc;
        this.ContractInfo = this.ContractInfo.bind(this);
        this.ContractHistory = this.ContractHistory.bind(this);
        this.ContractsByCode = this.ContractsByCode.bind(this);
        this.AllContractState = this.AllContractState.bind(this);
        this.RawContractState = this.RawContractState.bind(this);
        this.SmartContractState = this.SmartContractState.bind(this);
        this.Code = this.Code.bind(this);
        this.Codes = this.Codes.bind(this);
        this.PinnedCodes = this.PinnedCodes.bind(this);
        this.Params = this.Params.bind(this);
        this.ContractsByCreator = this.ContractsByCreator.bind(this);
    }
    ContractInfo(request) {
        const data = exports.QueryContractInfoRequest.encode(request).finish();
        const promise = this.rpc.request("cosmwasm.wasm.v1.Query", "ContractInfo", data);
        return promise.then((data) => exports.QueryContractInfoResponse.decode(new _m0.Reader(data)));
    }
    ContractHistory(request) {
        const data = exports.QueryContractHistoryRequest.encode(request).finish();
        const promise = this.rpc.request("cosmwasm.wasm.v1.Query", "ContractHistory", data);
        return promise.then((data) => exports.QueryContractHistoryResponse.decode(new _m0.Reader(data)));
    }
    ContractsByCode(request) {
        const data = exports.QueryContractsByCodeRequest.encode(request).finish();
        const promise = this.rpc.request("cosmwasm.wasm.v1.Query", "ContractsByCode", data);
        return promise.then((data) => exports.QueryContractsByCodeResponse.decode(new _m0.Reader(data)));
    }
    AllContractState(request) {
        const data = exports.QueryAllContractStateRequest.encode(request).finish();
        const promise = this.rpc.request("cosmwasm.wasm.v1.Query", "AllContractState", data);
        return promise.then((data) => exports.QueryAllContractStateResponse.decode(new _m0.Reader(data)));
    }
    RawContractState(request) {
        const data = exports.QueryRawContractStateRequest.encode(request).finish();
        const promise = this.rpc.request("cosmwasm.wasm.v1.Query", "RawContractState", data);
        return promise.then((data) => exports.QueryRawContractStateResponse.decode(new _m0.Reader(data)));
    }
    SmartContractState(request) {
        const data = exports.QuerySmartContractStateRequest.encode(request).finish();
        const promise = this.rpc.request("cosmwasm.wasm.v1.Query", "SmartContractState", data);
        return promise.then((data) => exports.QuerySmartContractStateResponse.decode(new _m0.Reader(data)));
    }
    Code(request) {
        const data = exports.QueryCodeRequest.encode(request).finish();
        const promise = this.rpc.request("cosmwasm.wasm.v1.Query", "Code", data);
        return promise.then((data) => exports.QueryCodeResponse.decode(new _m0.Reader(data)));
    }
    Codes(request = {
        pagination: undefined,
    }) {
        const data = exports.QueryCodesRequest.encode(request).finish();
        const promise = this.rpc.request("cosmwasm.wasm.v1.Query", "Codes", data);
        return promise.then((data) => exports.QueryCodesResponse.decode(new _m0.Reader(data)));
    }
    PinnedCodes(request = {
        pagination: undefined,
    }) {
        const data = exports.QueryPinnedCodesRequest.encode(request).finish();
        const promise = this.rpc.request("cosmwasm.wasm.v1.Query", "PinnedCodes", data);
        return promise.then((data) => exports.QueryPinnedCodesResponse.decode(new _m0.Reader(data)));
    }
    Params(request = {}) {
        const data = exports.QueryParamsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmwasm.wasm.v1.Query", "Params", data);
        return promise.then((data) => exports.QueryParamsResponse.decode(new _m0.Reader(data)));
    }
    ContractsByCreator(request) {
        const data = exports.QueryContractsByCreatorRequest.encode(request).finish();
        const promise = this.rpc.request("cosmwasm.wasm.v1.Query", "ContractsByCreator", data);
        return promise.then((data) => exports.QueryContractsByCreatorResponse.decode(new _m0.Reader(data)));
    }
}
exports.QueryClientImpl = QueryClientImpl;
//# sourceMappingURL=query.js.map

/***/ }),

/***/ 63949:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MsgClientImpl = exports.MsgUpdateInstantiateConfigResponse = exports.MsgUpdateInstantiateConfig = exports.MsgClearAdminResponse = exports.MsgClearAdmin = exports.MsgUpdateAdminResponse = exports.MsgUpdateAdmin = exports.MsgMigrateContractResponse = exports.MsgMigrateContract = exports.MsgExecuteContractResponse = exports.MsgExecuteContract = exports.MsgInstantiateContract2Response = exports.MsgInstantiateContractResponse = exports.MsgInstantiateContract2 = exports.MsgInstantiateContract = exports.MsgStoreCodeResponse = exports.MsgStoreCode = exports.protobufPackage = void 0;
/* eslint-disable */
const types_1 = __webpack_require__(89675);
const coin_1 = __webpack_require__(81637);
const helpers_1 = __webpack_require__(92654);
const _m0 = __importStar(__webpack_require__(62100));
exports.protobufPackage = "cosmwasm.wasm.v1";
function createBaseMsgStoreCode() {
    return {
        sender: "",
        wasmByteCode: new Uint8Array(),
        instantiatePermission: undefined,
    };
}
exports.MsgStoreCode = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.sender !== "") {
            writer.uint32(10).string(message.sender);
        }
        if (message.wasmByteCode.length !== 0) {
            writer.uint32(18).bytes(message.wasmByteCode);
        }
        if (message.instantiatePermission !== undefined) {
            types_1.AccessConfig.encode(message.instantiatePermission, writer.uint32(42).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgStoreCode();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.sender = reader.string();
                    break;
                case 2:
                    message.wasmByteCode = reader.bytes();
                    break;
                case 5:
                    message.instantiatePermission = types_1.AccessConfig.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            sender: (0, helpers_1.isSet)(object.sender) ? String(object.sender) : "",
            wasmByteCode: (0, helpers_1.isSet)(object.wasmByteCode) ? (0, helpers_1.bytesFromBase64)(object.wasmByteCode) : new Uint8Array(),
            instantiatePermission: (0, helpers_1.isSet)(object.instantiatePermission)
                ? types_1.AccessConfig.fromJSON(object.instantiatePermission)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.sender !== undefined && (obj.sender = message.sender);
        message.wasmByteCode !== undefined &&
            (obj.wasmByteCode = (0, helpers_1.base64FromBytes)(message.wasmByteCode !== undefined ? message.wasmByteCode : new Uint8Array()));
        message.instantiatePermission !== undefined &&
            (obj.instantiatePermission = message.instantiatePermission
                ? types_1.AccessConfig.toJSON(message.instantiatePermission)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgStoreCode();
        message.sender = object.sender ?? "";
        message.wasmByteCode = object.wasmByteCode ?? new Uint8Array();
        message.instantiatePermission =
            object.instantiatePermission !== undefined && object.instantiatePermission !== null
                ? types_1.AccessConfig.fromPartial(object.instantiatePermission)
                : undefined;
        return message;
    },
};
function createBaseMsgStoreCodeResponse() {
    return {
        codeId: helpers_1.Long.UZERO,
        checksum: new Uint8Array(),
    };
}
exports.MsgStoreCodeResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (!message.codeId.isZero()) {
            writer.uint32(8).uint64(message.codeId);
        }
        if (message.checksum.length !== 0) {
            writer.uint32(18).bytes(message.checksum);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgStoreCodeResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.codeId = reader.uint64();
                    break;
                case 2:
                    message.checksum = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            codeId: (0, helpers_1.isSet)(object.codeId) ? helpers_1.Long.fromValue(object.codeId) : helpers_1.Long.UZERO,
            checksum: (0, helpers_1.isSet)(object.checksum) ? (0, helpers_1.bytesFromBase64)(object.checksum) : new Uint8Array(),
        };
    },
    toJSON(message) {
        const obj = {};
        message.codeId !== undefined && (obj.codeId = (message.codeId || helpers_1.Long.UZERO).toString());
        message.checksum !== undefined &&
            (obj.checksum = (0, helpers_1.base64FromBytes)(message.checksum !== undefined ? message.checksum : new Uint8Array()));
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgStoreCodeResponse();
        message.codeId =
            object.codeId !== undefined && object.codeId !== null ? helpers_1.Long.fromValue(object.codeId) : helpers_1.Long.UZERO;
        message.checksum = object.checksum ?? new Uint8Array();
        return message;
    },
};
function createBaseMsgInstantiateContract() {
    return {
        sender: "",
        admin: "",
        codeId: helpers_1.Long.UZERO,
        label: "",
        msg: new Uint8Array(),
        funds: [],
    };
}
exports.MsgInstantiateContract = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.sender !== "") {
            writer.uint32(10).string(message.sender);
        }
        if (message.admin !== "") {
            writer.uint32(18).string(message.admin);
        }
        if (!message.codeId.isZero()) {
            writer.uint32(24).uint64(message.codeId);
        }
        if (message.label !== "") {
            writer.uint32(34).string(message.label);
        }
        if (message.msg.length !== 0) {
            writer.uint32(42).bytes(message.msg);
        }
        for (const v of message.funds) {
            coin_1.Coin.encode(v, writer.uint32(50).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgInstantiateContract();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.sender = reader.string();
                    break;
                case 2:
                    message.admin = reader.string();
                    break;
                case 3:
                    message.codeId = reader.uint64();
                    break;
                case 4:
                    message.label = reader.string();
                    break;
                case 5:
                    message.msg = reader.bytes();
                    break;
                case 6:
                    message.funds.push(coin_1.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            sender: (0, helpers_1.isSet)(object.sender) ? String(object.sender) : "",
            admin: (0, helpers_1.isSet)(object.admin) ? String(object.admin) : "",
            codeId: (0, helpers_1.isSet)(object.codeId) ? helpers_1.Long.fromValue(object.codeId) : helpers_1.Long.UZERO,
            label: (0, helpers_1.isSet)(object.label) ? String(object.label) : "",
            msg: (0, helpers_1.isSet)(object.msg) ? (0, helpers_1.bytesFromBase64)(object.msg) : new Uint8Array(),
            funds: Array.isArray(object?.funds) ? object.funds.map((e) => coin_1.Coin.fromJSON(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        message.sender !== undefined && (obj.sender = message.sender);
        message.admin !== undefined && (obj.admin = message.admin);
        message.codeId !== undefined && (obj.codeId = (message.codeId || helpers_1.Long.UZERO).toString());
        message.label !== undefined && (obj.label = message.label);
        message.msg !== undefined &&
            (obj.msg = (0, helpers_1.base64FromBytes)(message.msg !== undefined ? message.msg : new Uint8Array()));
        if (message.funds) {
            obj.funds = message.funds.map((e) => (e ? coin_1.Coin.toJSON(e) : undefined));
        }
        else {
            obj.funds = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgInstantiateContract();
        message.sender = object.sender ?? "";
        message.admin = object.admin ?? "";
        message.codeId =
            object.codeId !== undefined && object.codeId !== null ? helpers_1.Long.fromValue(object.codeId) : helpers_1.Long.UZERO;
        message.label = object.label ?? "";
        message.msg = object.msg ?? new Uint8Array();
        message.funds = object.funds?.map((e) => coin_1.Coin.fromPartial(e)) || [];
        return message;
    },
};
function createBaseMsgInstantiateContract2() {
    return {
        sender: "",
        admin: "",
        codeId: helpers_1.Long.UZERO,
        label: "",
        msg: new Uint8Array(),
        funds: [],
        salt: new Uint8Array(),
        fixMsg: false,
    };
}
exports.MsgInstantiateContract2 = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.sender !== "") {
            writer.uint32(10).string(message.sender);
        }
        if (message.admin !== "") {
            writer.uint32(18).string(message.admin);
        }
        if (!message.codeId.isZero()) {
            writer.uint32(24).uint64(message.codeId);
        }
        if (message.label !== "") {
            writer.uint32(34).string(message.label);
        }
        if (message.msg.length !== 0) {
            writer.uint32(42).bytes(message.msg);
        }
        for (const v of message.funds) {
            coin_1.Coin.encode(v, writer.uint32(50).fork()).ldelim();
        }
        if (message.salt.length !== 0) {
            writer.uint32(58).bytes(message.salt);
        }
        if (message.fixMsg === true) {
            writer.uint32(64).bool(message.fixMsg);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgInstantiateContract2();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.sender = reader.string();
                    break;
                case 2:
                    message.admin = reader.string();
                    break;
                case 3:
                    message.codeId = reader.uint64();
                    break;
                case 4:
                    message.label = reader.string();
                    break;
                case 5:
                    message.msg = reader.bytes();
                    break;
                case 6:
                    message.funds.push(coin_1.Coin.decode(reader, reader.uint32()));
                    break;
                case 7:
                    message.salt = reader.bytes();
                    break;
                case 8:
                    message.fixMsg = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            sender: (0, helpers_1.isSet)(object.sender) ? String(object.sender) : "",
            admin: (0, helpers_1.isSet)(object.admin) ? String(object.admin) : "",
            codeId: (0, helpers_1.isSet)(object.codeId) ? helpers_1.Long.fromValue(object.codeId) : helpers_1.Long.UZERO,
            label: (0, helpers_1.isSet)(object.label) ? String(object.label) : "",
            msg: (0, helpers_1.isSet)(object.msg) ? (0, helpers_1.bytesFromBase64)(object.msg) : new Uint8Array(),
            funds: Array.isArray(object?.funds) ? object.funds.map((e) => coin_1.Coin.fromJSON(e)) : [],
            salt: (0, helpers_1.isSet)(object.salt) ? (0, helpers_1.bytesFromBase64)(object.salt) : new Uint8Array(),
            fixMsg: (0, helpers_1.isSet)(object.fixMsg) ? Boolean(object.fixMsg) : false,
        };
    },
    toJSON(message) {
        const obj = {};
        message.sender !== undefined && (obj.sender = message.sender);
        message.admin !== undefined && (obj.admin = message.admin);
        message.codeId !== undefined && (obj.codeId = (message.codeId || helpers_1.Long.UZERO).toString());
        message.label !== undefined && (obj.label = message.label);
        message.msg !== undefined &&
            (obj.msg = (0, helpers_1.base64FromBytes)(message.msg !== undefined ? message.msg : new Uint8Array()));
        if (message.funds) {
            obj.funds = message.funds.map((e) => (e ? coin_1.Coin.toJSON(e) : undefined));
        }
        else {
            obj.funds = [];
        }
        message.salt !== undefined &&
            (obj.salt = (0, helpers_1.base64FromBytes)(message.salt !== undefined ? message.salt : new Uint8Array()));
        message.fixMsg !== undefined && (obj.fixMsg = message.fixMsg);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgInstantiateContract2();
        message.sender = object.sender ?? "";
        message.admin = object.admin ?? "";
        message.codeId =
            object.codeId !== undefined && object.codeId !== null ? helpers_1.Long.fromValue(object.codeId) : helpers_1.Long.UZERO;
        message.label = object.label ?? "";
        message.msg = object.msg ?? new Uint8Array();
        message.funds = object.funds?.map((e) => coin_1.Coin.fromPartial(e)) || [];
        message.salt = object.salt ?? new Uint8Array();
        message.fixMsg = object.fixMsg ?? false;
        return message;
    },
};
function createBaseMsgInstantiateContractResponse() {
    return {
        address: "",
        data: new Uint8Array(),
    };
}
exports.MsgInstantiateContractResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.address !== "") {
            writer.uint32(10).string(message.address);
        }
        if (message.data.length !== 0) {
            writer.uint32(18).bytes(message.data);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgInstantiateContractResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.data = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            address: (0, helpers_1.isSet)(object.address) ? String(object.address) : "",
            data: (0, helpers_1.isSet)(object.data) ? (0, helpers_1.bytesFromBase64)(object.data) : new Uint8Array(),
        };
    },
    toJSON(message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.data !== undefined &&
            (obj.data = (0, helpers_1.base64FromBytes)(message.data !== undefined ? message.data : new Uint8Array()));
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgInstantiateContractResponse();
        message.address = object.address ?? "";
        message.data = object.data ?? new Uint8Array();
        return message;
    },
};
function createBaseMsgInstantiateContract2Response() {
    return {
        address: "",
        data: new Uint8Array(),
    };
}
exports.MsgInstantiateContract2Response = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.address !== "") {
            writer.uint32(10).string(message.address);
        }
        if (message.data.length !== 0) {
            writer.uint32(18).bytes(message.data);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgInstantiateContract2Response();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.data = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            address: (0, helpers_1.isSet)(object.address) ? String(object.address) : "",
            data: (0, helpers_1.isSet)(object.data) ? (0, helpers_1.bytesFromBase64)(object.data) : new Uint8Array(),
        };
    },
    toJSON(message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.data !== undefined &&
            (obj.data = (0, helpers_1.base64FromBytes)(message.data !== undefined ? message.data : new Uint8Array()));
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgInstantiateContract2Response();
        message.address = object.address ?? "";
        message.data = object.data ?? new Uint8Array();
        return message;
    },
};
function createBaseMsgExecuteContract() {
    return {
        sender: "",
        contract: "",
        msg: new Uint8Array(),
        funds: [],
    };
}
exports.MsgExecuteContract = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.sender !== "") {
            writer.uint32(10).string(message.sender);
        }
        if (message.contract !== "") {
            writer.uint32(18).string(message.contract);
        }
        if (message.msg.length !== 0) {
            writer.uint32(26).bytes(message.msg);
        }
        for (const v of message.funds) {
            coin_1.Coin.encode(v, writer.uint32(42).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgExecuteContract();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.sender = reader.string();
                    break;
                case 2:
                    message.contract = reader.string();
                    break;
                case 3:
                    message.msg = reader.bytes();
                    break;
                case 5:
                    message.funds.push(coin_1.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            sender: (0, helpers_1.isSet)(object.sender) ? String(object.sender) : "",
            contract: (0, helpers_1.isSet)(object.contract) ? String(object.contract) : "",
            msg: (0, helpers_1.isSet)(object.msg) ? (0, helpers_1.bytesFromBase64)(object.msg) : new Uint8Array(),
            funds: Array.isArray(object?.funds) ? object.funds.map((e) => coin_1.Coin.fromJSON(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        message.sender !== undefined && (obj.sender = message.sender);
        message.contract !== undefined && (obj.contract = message.contract);
        message.msg !== undefined &&
            (obj.msg = (0, helpers_1.base64FromBytes)(message.msg !== undefined ? message.msg : new Uint8Array()));
        if (message.funds) {
            obj.funds = message.funds.map((e) => (e ? coin_1.Coin.toJSON(e) : undefined));
        }
        else {
            obj.funds = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgExecuteContract();
        message.sender = object.sender ?? "";
        message.contract = object.contract ?? "";
        message.msg = object.msg ?? new Uint8Array();
        message.funds = object.funds?.map((e) => coin_1.Coin.fromPartial(e)) || [];
        return message;
    },
};
function createBaseMsgExecuteContractResponse() {
    return {
        data: new Uint8Array(),
    };
}
exports.MsgExecuteContractResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.data.length !== 0) {
            writer.uint32(10).bytes(message.data);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgExecuteContractResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.data = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            data: (0, helpers_1.isSet)(object.data) ? (0, helpers_1.bytesFromBase64)(object.data) : new Uint8Array(),
        };
    },
    toJSON(message) {
        const obj = {};
        message.data !== undefined &&
            (obj.data = (0, helpers_1.base64FromBytes)(message.data !== undefined ? message.data : new Uint8Array()));
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgExecuteContractResponse();
        message.data = object.data ?? new Uint8Array();
        return message;
    },
};
function createBaseMsgMigrateContract() {
    return {
        sender: "",
        contract: "",
        codeId: helpers_1.Long.UZERO,
        msg: new Uint8Array(),
    };
}
exports.MsgMigrateContract = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.sender !== "") {
            writer.uint32(10).string(message.sender);
        }
        if (message.contract !== "") {
            writer.uint32(18).string(message.contract);
        }
        if (!message.codeId.isZero()) {
            writer.uint32(24).uint64(message.codeId);
        }
        if (message.msg.length !== 0) {
            writer.uint32(34).bytes(message.msg);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgMigrateContract();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.sender = reader.string();
                    break;
                case 2:
                    message.contract = reader.string();
                    break;
                case 3:
                    message.codeId = reader.uint64();
                    break;
                case 4:
                    message.msg = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            sender: (0, helpers_1.isSet)(object.sender) ? String(object.sender) : "",
            contract: (0, helpers_1.isSet)(object.contract) ? String(object.contract) : "",
            codeId: (0, helpers_1.isSet)(object.codeId) ? helpers_1.Long.fromValue(object.codeId) : helpers_1.Long.UZERO,
            msg: (0, helpers_1.isSet)(object.msg) ? (0, helpers_1.bytesFromBase64)(object.msg) : new Uint8Array(),
        };
    },
    toJSON(message) {
        const obj = {};
        message.sender !== undefined && (obj.sender = message.sender);
        message.contract !== undefined && (obj.contract = message.contract);
        message.codeId !== undefined && (obj.codeId = (message.codeId || helpers_1.Long.UZERO).toString());
        message.msg !== undefined &&
            (obj.msg = (0, helpers_1.base64FromBytes)(message.msg !== undefined ? message.msg : new Uint8Array()));
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgMigrateContract();
        message.sender = object.sender ?? "";
        message.contract = object.contract ?? "";
        message.codeId =
            object.codeId !== undefined && object.codeId !== null ? helpers_1.Long.fromValue(object.codeId) : helpers_1.Long.UZERO;
        message.msg = object.msg ?? new Uint8Array();
        return message;
    },
};
function createBaseMsgMigrateContractResponse() {
    return {
        data: new Uint8Array(),
    };
}
exports.MsgMigrateContractResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.data.length !== 0) {
            writer.uint32(10).bytes(message.data);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgMigrateContractResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.data = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            data: (0, helpers_1.isSet)(object.data) ? (0, helpers_1.bytesFromBase64)(object.data) : new Uint8Array(),
        };
    },
    toJSON(message) {
        const obj = {};
        message.data !== undefined &&
            (obj.data = (0, helpers_1.base64FromBytes)(message.data !== undefined ? message.data : new Uint8Array()));
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgMigrateContractResponse();
        message.data = object.data ?? new Uint8Array();
        return message;
    },
};
function createBaseMsgUpdateAdmin() {
    return {
        sender: "",
        newAdmin: "",
        contract: "",
    };
}
exports.MsgUpdateAdmin = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.sender !== "") {
            writer.uint32(10).string(message.sender);
        }
        if (message.newAdmin !== "") {
            writer.uint32(18).string(message.newAdmin);
        }
        if (message.contract !== "") {
            writer.uint32(26).string(message.contract);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgUpdateAdmin();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.sender = reader.string();
                    break;
                case 2:
                    message.newAdmin = reader.string();
                    break;
                case 3:
                    message.contract = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            sender: (0, helpers_1.isSet)(object.sender) ? String(object.sender) : "",
            newAdmin: (0, helpers_1.isSet)(object.newAdmin) ? String(object.newAdmin) : "",
            contract: (0, helpers_1.isSet)(object.contract) ? String(object.contract) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.sender !== undefined && (obj.sender = message.sender);
        message.newAdmin !== undefined && (obj.newAdmin = message.newAdmin);
        message.contract !== undefined && (obj.contract = message.contract);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgUpdateAdmin();
        message.sender = object.sender ?? "";
        message.newAdmin = object.newAdmin ?? "";
        message.contract = object.contract ?? "";
        return message;
    },
};
function createBaseMsgUpdateAdminResponse() {
    return {};
}
exports.MsgUpdateAdminResponse = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgUpdateAdminResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgUpdateAdminResponse();
        return message;
    },
};
function createBaseMsgClearAdmin() {
    return {
        sender: "",
        contract: "",
    };
}
exports.MsgClearAdmin = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.sender !== "") {
            writer.uint32(10).string(message.sender);
        }
        if (message.contract !== "") {
            writer.uint32(26).string(message.contract);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgClearAdmin();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.sender = reader.string();
                    break;
                case 3:
                    message.contract = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            sender: (0, helpers_1.isSet)(object.sender) ? String(object.sender) : "",
            contract: (0, helpers_1.isSet)(object.contract) ? String(object.contract) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.sender !== undefined && (obj.sender = message.sender);
        message.contract !== undefined && (obj.contract = message.contract);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgClearAdmin();
        message.sender = object.sender ?? "";
        message.contract = object.contract ?? "";
        return message;
    },
};
function createBaseMsgClearAdminResponse() {
    return {};
}
exports.MsgClearAdminResponse = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgClearAdminResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgClearAdminResponse();
        return message;
    },
};
function createBaseMsgUpdateInstantiateConfig() {
    return {
        sender: "",
        codeId: helpers_1.Long.UZERO,
        newInstantiatePermission: undefined,
    };
}
exports.MsgUpdateInstantiateConfig = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.sender !== "") {
            writer.uint32(10).string(message.sender);
        }
        if (!message.codeId.isZero()) {
            writer.uint32(16).uint64(message.codeId);
        }
        if (message.newInstantiatePermission !== undefined) {
            types_1.AccessConfig.encode(message.newInstantiatePermission, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgUpdateInstantiateConfig();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.sender = reader.string();
                    break;
                case 2:
                    message.codeId = reader.uint64();
                    break;
                case 3:
                    message.newInstantiatePermission = types_1.AccessConfig.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            sender: (0, helpers_1.isSet)(object.sender) ? String(object.sender) : "",
            codeId: (0, helpers_1.isSet)(object.codeId) ? helpers_1.Long.fromValue(object.codeId) : helpers_1.Long.UZERO,
            newInstantiatePermission: (0, helpers_1.isSet)(object.newInstantiatePermission)
                ? types_1.AccessConfig.fromJSON(object.newInstantiatePermission)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.sender !== undefined && (obj.sender = message.sender);
        message.codeId !== undefined && (obj.codeId = (message.codeId || helpers_1.Long.UZERO).toString());
        message.newInstantiatePermission !== undefined &&
            (obj.newInstantiatePermission = message.newInstantiatePermission
                ? types_1.AccessConfig.toJSON(message.newInstantiatePermission)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgUpdateInstantiateConfig();
        message.sender = object.sender ?? "";
        message.codeId =
            object.codeId !== undefined && object.codeId !== null ? helpers_1.Long.fromValue(object.codeId) : helpers_1.Long.UZERO;
        message.newInstantiatePermission =
            object.newInstantiatePermission !== undefined && object.newInstantiatePermission !== null
                ? types_1.AccessConfig.fromPartial(object.newInstantiatePermission)
                : undefined;
        return message;
    },
};
function createBaseMsgUpdateInstantiateConfigResponse() {
    return {};
}
exports.MsgUpdateInstantiateConfigResponse = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgUpdateInstantiateConfigResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgUpdateInstantiateConfigResponse();
        return message;
    },
};
class MsgClientImpl {
    constructor(rpc) {
        this.rpc = rpc;
        this.StoreCode = this.StoreCode.bind(this);
        this.InstantiateContract = this.InstantiateContract.bind(this);
        this.InstantiateContract2 = this.InstantiateContract2.bind(this);
        this.ExecuteContract = this.ExecuteContract.bind(this);
        this.MigrateContract = this.MigrateContract.bind(this);
        this.UpdateAdmin = this.UpdateAdmin.bind(this);
        this.ClearAdmin = this.ClearAdmin.bind(this);
        this.UpdateInstantiateConfig = this.UpdateInstantiateConfig.bind(this);
    }
    StoreCode(request) {
        const data = exports.MsgStoreCode.encode(request).finish();
        const promise = this.rpc.request("cosmwasm.wasm.v1.Msg", "StoreCode", data);
        return promise.then((data) => exports.MsgStoreCodeResponse.decode(new _m0.Reader(data)));
    }
    InstantiateContract(request) {
        const data = exports.MsgInstantiateContract.encode(request).finish();
        const promise = this.rpc.request("cosmwasm.wasm.v1.Msg", "InstantiateContract", data);
        return promise.then((data) => exports.MsgInstantiateContractResponse.decode(new _m0.Reader(data)));
    }
    InstantiateContract2(request) {
        const data = exports.MsgInstantiateContract2.encode(request).finish();
        const promise = this.rpc.request("cosmwasm.wasm.v1.Msg", "InstantiateContract2", data);
        return promise.then((data) => exports.MsgInstantiateContract2Response.decode(new _m0.Reader(data)));
    }
    ExecuteContract(request) {
        const data = exports.MsgExecuteContract.encode(request).finish();
        const promise = this.rpc.request("cosmwasm.wasm.v1.Msg", "ExecuteContract", data);
        return promise.then((data) => exports.MsgExecuteContractResponse.decode(new _m0.Reader(data)));
    }
    MigrateContract(request) {
        const data = exports.MsgMigrateContract.encode(request).finish();
        const promise = this.rpc.request("cosmwasm.wasm.v1.Msg", "MigrateContract", data);
        return promise.then((data) => exports.MsgMigrateContractResponse.decode(new _m0.Reader(data)));
    }
    UpdateAdmin(request) {
        const data = exports.MsgUpdateAdmin.encode(request).finish();
        const promise = this.rpc.request("cosmwasm.wasm.v1.Msg", "UpdateAdmin", data);
        return promise.then((data) => exports.MsgUpdateAdminResponse.decode(new _m0.Reader(data)));
    }
    ClearAdmin(request) {
        const data = exports.MsgClearAdmin.encode(request).finish();
        const promise = this.rpc.request("cosmwasm.wasm.v1.Msg", "ClearAdmin", data);
        return promise.then((data) => exports.MsgClearAdminResponse.decode(new _m0.Reader(data)));
    }
    UpdateInstantiateConfig(request) {
        const data = exports.MsgUpdateInstantiateConfig.encode(request).finish();
        const promise = this.rpc.request("cosmwasm.wasm.v1.Msg", "UpdateInstantiateConfig", data);
        return promise.then((data) => exports.MsgUpdateInstantiateConfigResponse.decode(new _m0.Reader(data)));
    }
}
exports.MsgClientImpl = MsgClientImpl;
//# sourceMappingURL=tx.js.map

/***/ }),

/***/ 89675:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Model = exports.AbsoluteTxPosition = exports.ContractCodeHistoryEntry = exports.ContractInfo = exports.CodeInfo = exports.Params = exports.AccessConfig = exports.AccessTypeParam = exports.contractCodeHistoryOperationTypeToJSON = exports.contractCodeHistoryOperationTypeFromJSON = exports.ContractCodeHistoryOperationType = exports.accessTypeToJSON = exports.accessTypeFromJSON = exports.AccessType = exports.protobufPackage = void 0;
/* eslint-disable */
const any_1 = __webpack_require__(75654);
const helpers_1 = __webpack_require__(92654);
const _m0 = __importStar(__webpack_require__(62100));
exports.protobufPackage = "cosmwasm.wasm.v1";
/** AccessType permission types */
var AccessType;
(function (AccessType) {
    /** ACCESS_TYPE_UNSPECIFIED - AccessTypeUnspecified placeholder for empty value */
    AccessType[AccessType["ACCESS_TYPE_UNSPECIFIED"] = 0] = "ACCESS_TYPE_UNSPECIFIED";
    /** ACCESS_TYPE_NOBODY - AccessTypeNobody forbidden */
    AccessType[AccessType["ACCESS_TYPE_NOBODY"] = 1] = "ACCESS_TYPE_NOBODY";
    /**
     * ACCESS_TYPE_ONLY_ADDRESS - AccessTypeOnlyAddress restricted to a single address
     * Deprecated: use AccessTypeAnyOfAddresses instead
     */
    AccessType[AccessType["ACCESS_TYPE_ONLY_ADDRESS"] = 2] = "ACCESS_TYPE_ONLY_ADDRESS";
    /** ACCESS_TYPE_EVERYBODY - AccessTypeEverybody unrestricted */
    AccessType[AccessType["ACCESS_TYPE_EVERYBODY"] = 3] = "ACCESS_TYPE_EVERYBODY";
    /** ACCESS_TYPE_ANY_OF_ADDRESSES - AccessTypeAnyOfAddresses allow any of the addresses */
    AccessType[AccessType["ACCESS_TYPE_ANY_OF_ADDRESSES"] = 4] = "ACCESS_TYPE_ANY_OF_ADDRESSES";
    AccessType[AccessType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(AccessType = exports.AccessType || (exports.AccessType = {}));
function accessTypeFromJSON(object) {
    switch (object) {
        case 0:
        case "ACCESS_TYPE_UNSPECIFIED":
            return AccessType.ACCESS_TYPE_UNSPECIFIED;
        case 1:
        case "ACCESS_TYPE_NOBODY":
            return AccessType.ACCESS_TYPE_NOBODY;
        case 2:
        case "ACCESS_TYPE_ONLY_ADDRESS":
            return AccessType.ACCESS_TYPE_ONLY_ADDRESS;
        case 3:
        case "ACCESS_TYPE_EVERYBODY":
            return AccessType.ACCESS_TYPE_EVERYBODY;
        case 4:
        case "ACCESS_TYPE_ANY_OF_ADDRESSES":
            return AccessType.ACCESS_TYPE_ANY_OF_ADDRESSES;
        case -1:
        case "UNRECOGNIZED":
        default:
            return AccessType.UNRECOGNIZED;
    }
}
exports.accessTypeFromJSON = accessTypeFromJSON;
function accessTypeToJSON(object) {
    switch (object) {
        case AccessType.ACCESS_TYPE_UNSPECIFIED:
            return "ACCESS_TYPE_UNSPECIFIED";
        case AccessType.ACCESS_TYPE_NOBODY:
            return "ACCESS_TYPE_NOBODY";
        case AccessType.ACCESS_TYPE_ONLY_ADDRESS:
            return "ACCESS_TYPE_ONLY_ADDRESS";
        case AccessType.ACCESS_TYPE_EVERYBODY:
            return "ACCESS_TYPE_EVERYBODY";
        case AccessType.ACCESS_TYPE_ANY_OF_ADDRESSES:
            return "ACCESS_TYPE_ANY_OF_ADDRESSES";
        case AccessType.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.accessTypeToJSON = accessTypeToJSON;
/** ContractCodeHistoryOperationType actions that caused a code change */
var ContractCodeHistoryOperationType;
(function (ContractCodeHistoryOperationType) {
    /** CONTRACT_CODE_HISTORY_OPERATION_TYPE_UNSPECIFIED - ContractCodeHistoryOperationTypeUnspecified placeholder for empty value */
    ContractCodeHistoryOperationType[ContractCodeHistoryOperationType["CONTRACT_CODE_HISTORY_OPERATION_TYPE_UNSPECIFIED"] = 0] = "CONTRACT_CODE_HISTORY_OPERATION_TYPE_UNSPECIFIED";
    /** CONTRACT_CODE_HISTORY_OPERATION_TYPE_INIT - ContractCodeHistoryOperationTypeInit on chain contract instantiation */
    ContractCodeHistoryOperationType[ContractCodeHistoryOperationType["CONTRACT_CODE_HISTORY_OPERATION_TYPE_INIT"] = 1] = "CONTRACT_CODE_HISTORY_OPERATION_TYPE_INIT";
    /** CONTRACT_CODE_HISTORY_OPERATION_TYPE_MIGRATE - ContractCodeHistoryOperationTypeMigrate code migration */
    ContractCodeHistoryOperationType[ContractCodeHistoryOperationType["CONTRACT_CODE_HISTORY_OPERATION_TYPE_MIGRATE"] = 2] = "CONTRACT_CODE_HISTORY_OPERATION_TYPE_MIGRATE";
    /** CONTRACT_CODE_HISTORY_OPERATION_TYPE_GENESIS - ContractCodeHistoryOperationTypeGenesis based on genesis data */
    ContractCodeHistoryOperationType[ContractCodeHistoryOperationType["CONTRACT_CODE_HISTORY_OPERATION_TYPE_GENESIS"] = 3] = "CONTRACT_CODE_HISTORY_OPERATION_TYPE_GENESIS";
    ContractCodeHistoryOperationType[ContractCodeHistoryOperationType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(ContractCodeHistoryOperationType = exports.ContractCodeHistoryOperationType || (exports.ContractCodeHistoryOperationType = {}));
function contractCodeHistoryOperationTypeFromJSON(object) {
    switch (object) {
        case 0:
        case "CONTRACT_CODE_HISTORY_OPERATION_TYPE_UNSPECIFIED":
            return ContractCodeHistoryOperationType.CONTRACT_CODE_HISTORY_OPERATION_TYPE_UNSPECIFIED;
        case 1:
        case "CONTRACT_CODE_HISTORY_OPERATION_TYPE_INIT":
            return ContractCodeHistoryOperationType.CONTRACT_CODE_HISTORY_OPERATION_TYPE_INIT;
        case 2:
        case "CONTRACT_CODE_HISTORY_OPERATION_TYPE_MIGRATE":
            return ContractCodeHistoryOperationType.CONTRACT_CODE_HISTORY_OPERATION_TYPE_MIGRATE;
        case 3:
        case "CONTRACT_CODE_HISTORY_OPERATION_TYPE_GENESIS":
            return ContractCodeHistoryOperationType.CONTRACT_CODE_HISTORY_OPERATION_TYPE_GENESIS;
        case -1:
        case "UNRECOGNIZED":
        default:
            return ContractCodeHistoryOperationType.UNRECOGNIZED;
    }
}
exports.contractCodeHistoryOperationTypeFromJSON = contractCodeHistoryOperationTypeFromJSON;
function contractCodeHistoryOperationTypeToJSON(object) {
    switch (object) {
        case ContractCodeHistoryOperationType.CONTRACT_CODE_HISTORY_OPERATION_TYPE_UNSPECIFIED:
            return "CONTRACT_CODE_HISTORY_OPERATION_TYPE_UNSPECIFIED";
        case ContractCodeHistoryOperationType.CONTRACT_CODE_HISTORY_OPERATION_TYPE_INIT:
            return "CONTRACT_CODE_HISTORY_OPERATION_TYPE_INIT";
        case ContractCodeHistoryOperationType.CONTRACT_CODE_HISTORY_OPERATION_TYPE_MIGRATE:
            return "CONTRACT_CODE_HISTORY_OPERATION_TYPE_MIGRATE";
        case ContractCodeHistoryOperationType.CONTRACT_CODE_HISTORY_OPERATION_TYPE_GENESIS:
            return "CONTRACT_CODE_HISTORY_OPERATION_TYPE_GENESIS";
        case ContractCodeHistoryOperationType.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.contractCodeHistoryOperationTypeToJSON = contractCodeHistoryOperationTypeToJSON;
function createBaseAccessTypeParam() {
    return {
        value: 0,
    };
}
exports.AccessTypeParam = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.value !== 0) {
            writer.uint32(8).int32(message.value);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAccessTypeParam();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.value = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            value: (0, helpers_1.isSet)(object.value) ? accessTypeFromJSON(object.value) : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        message.value !== undefined && (obj.value = accessTypeToJSON(message.value));
        return obj;
    },
    fromPartial(object) {
        const message = createBaseAccessTypeParam();
        message.value = object.value ?? 0;
        return message;
    },
};
function createBaseAccessConfig() {
    return {
        permission: 0,
        address: "",
        addresses: [],
    };
}
exports.AccessConfig = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.permission !== 0) {
            writer.uint32(8).int32(message.permission);
        }
        if (message.address !== "") {
            writer.uint32(18).string(message.address);
        }
        for (const v of message.addresses) {
            writer.uint32(26).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAccessConfig();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.permission = reader.int32();
                    break;
                case 2:
                    message.address = reader.string();
                    break;
                case 3:
                    message.addresses.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            permission: (0, helpers_1.isSet)(object.permission) ? accessTypeFromJSON(object.permission) : 0,
            address: (0, helpers_1.isSet)(object.address) ? String(object.address) : "",
            addresses: Array.isArray(object?.addresses) ? object.addresses.map((e) => String(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        message.permission !== undefined && (obj.permission = accessTypeToJSON(message.permission));
        message.address !== undefined && (obj.address = message.address);
        if (message.addresses) {
            obj.addresses = message.addresses.map((e) => e);
        }
        else {
            obj.addresses = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseAccessConfig();
        message.permission = object.permission ?? 0;
        message.address = object.address ?? "";
        message.addresses = object.addresses?.map((e) => e) || [];
        return message;
    },
};
function createBaseParams() {
    return {
        codeUploadAccess: undefined,
        instantiateDefaultPermission: 0,
    };
}
exports.Params = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.codeUploadAccess !== undefined) {
            exports.AccessConfig.encode(message.codeUploadAccess, writer.uint32(10).fork()).ldelim();
        }
        if (message.instantiateDefaultPermission !== 0) {
            writer.uint32(16).int32(message.instantiateDefaultPermission);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseParams();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.codeUploadAccess = exports.AccessConfig.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.instantiateDefaultPermission = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            codeUploadAccess: (0, helpers_1.isSet)(object.codeUploadAccess)
                ? exports.AccessConfig.fromJSON(object.codeUploadAccess)
                : undefined,
            instantiateDefaultPermission: (0, helpers_1.isSet)(object.instantiateDefaultPermission)
                ? accessTypeFromJSON(object.instantiateDefaultPermission)
                : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        message.codeUploadAccess !== undefined &&
            (obj.codeUploadAccess = message.codeUploadAccess
                ? exports.AccessConfig.toJSON(message.codeUploadAccess)
                : undefined);
        message.instantiateDefaultPermission !== undefined &&
            (obj.instantiateDefaultPermission = accessTypeToJSON(message.instantiateDefaultPermission));
        return obj;
    },
    fromPartial(object) {
        const message = createBaseParams();
        message.codeUploadAccess =
            object.codeUploadAccess !== undefined && object.codeUploadAccess !== null
                ? exports.AccessConfig.fromPartial(object.codeUploadAccess)
                : undefined;
        message.instantiateDefaultPermission = object.instantiateDefaultPermission ?? 0;
        return message;
    },
};
function createBaseCodeInfo() {
    return {
        codeHash: new Uint8Array(),
        creator: "",
        instantiateConfig: undefined,
    };
}
exports.CodeInfo = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.codeHash.length !== 0) {
            writer.uint32(10).bytes(message.codeHash);
        }
        if (message.creator !== "") {
            writer.uint32(18).string(message.creator);
        }
        if (message.instantiateConfig !== undefined) {
            exports.AccessConfig.encode(message.instantiateConfig, writer.uint32(42).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCodeInfo();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.codeHash = reader.bytes();
                    break;
                case 2:
                    message.creator = reader.string();
                    break;
                case 5:
                    message.instantiateConfig = exports.AccessConfig.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            codeHash: (0, helpers_1.isSet)(object.codeHash) ? (0, helpers_1.bytesFromBase64)(object.codeHash) : new Uint8Array(),
            creator: (0, helpers_1.isSet)(object.creator) ? String(object.creator) : "",
            instantiateConfig: (0, helpers_1.isSet)(object.instantiateConfig)
                ? exports.AccessConfig.fromJSON(object.instantiateConfig)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.codeHash !== undefined &&
            (obj.codeHash = (0, helpers_1.base64FromBytes)(message.codeHash !== undefined ? message.codeHash : new Uint8Array()));
        message.creator !== undefined && (obj.creator = message.creator);
        message.instantiateConfig !== undefined &&
            (obj.instantiateConfig = message.instantiateConfig
                ? exports.AccessConfig.toJSON(message.instantiateConfig)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseCodeInfo();
        message.codeHash = object.codeHash ?? new Uint8Array();
        message.creator = object.creator ?? "";
        message.instantiateConfig =
            object.instantiateConfig !== undefined && object.instantiateConfig !== null
                ? exports.AccessConfig.fromPartial(object.instantiateConfig)
                : undefined;
        return message;
    },
};
function createBaseContractInfo() {
    return {
        codeId: helpers_1.Long.UZERO,
        creator: "",
        admin: "",
        label: "",
        created: undefined,
        ibcPortId: "",
        extension: undefined,
    };
}
exports.ContractInfo = {
    encode(message, writer = _m0.Writer.create()) {
        if (!message.codeId.isZero()) {
            writer.uint32(8).uint64(message.codeId);
        }
        if (message.creator !== "") {
            writer.uint32(18).string(message.creator);
        }
        if (message.admin !== "") {
            writer.uint32(26).string(message.admin);
        }
        if (message.label !== "") {
            writer.uint32(34).string(message.label);
        }
        if (message.created !== undefined) {
            exports.AbsoluteTxPosition.encode(message.created, writer.uint32(42).fork()).ldelim();
        }
        if (message.ibcPortId !== "") {
            writer.uint32(50).string(message.ibcPortId);
        }
        if (message.extension !== undefined) {
            any_1.Any.encode(message.extension, writer.uint32(58).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseContractInfo();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.codeId = reader.uint64();
                    break;
                case 2:
                    message.creator = reader.string();
                    break;
                case 3:
                    message.admin = reader.string();
                    break;
                case 4:
                    message.label = reader.string();
                    break;
                case 5:
                    message.created = exports.AbsoluteTxPosition.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.ibcPortId = reader.string();
                    break;
                case 7:
                    message.extension = any_1.Any.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            codeId: (0, helpers_1.isSet)(object.codeId) ? helpers_1.Long.fromValue(object.codeId) : helpers_1.Long.UZERO,
            creator: (0, helpers_1.isSet)(object.creator) ? String(object.creator) : "",
            admin: (0, helpers_1.isSet)(object.admin) ? String(object.admin) : "",
            label: (0, helpers_1.isSet)(object.label) ? String(object.label) : "",
            created: (0, helpers_1.isSet)(object.created) ? exports.AbsoluteTxPosition.fromJSON(object.created) : undefined,
            ibcPortId: (0, helpers_1.isSet)(object.ibcPortId) ? String(object.ibcPortId) : "",
            extension: (0, helpers_1.isSet)(object.extension) ? any_1.Any.fromJSON(object.extension) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.codeId !== undefined && (obj.codeId = (message.codeId || helpers_1.Long.UZERO).toString());
        message.creator !== undefined && (obj.creator = message.creator);
        message.admin !== undefined && (obj.admin = message.admin);
        message.label !== undefined && (obj.label = message.label);
        message.created !== undefined &&
            (obj.created = message.created ? exports.AbsoluteTxPosition.toJSON(message.created) : undefined);
        message.ibcPortId !== undefined && (obj.ibcPortId = message.ibcPortId);
        message.extension !== undefined &&
            (obj.extension = message.extension ? any_1.Any.toJSON(message.extension) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseContractInfo();
        message.codeId =
            object.codeId !== undefined && object.codeId !== null ? helpers_1.Long.fromValue(object.codeId) : helpers_1.Long.UZERO;
        message.creator = object.creator ?? "";
        message.admin = object.admin ?? "";
        message.label = object.label ?? "";
        message.created =
            object.created !== undefined && object.created !== null
                ? exports.AbsoluteTxPosition.fromPartial(object.created)
                : undefined;
        message.ibcPortId = object.ibcPortId ?? "";
        message.extension =
            object.extension !== undefined && object.extension !== null
                ? any_1.Any.fromPartial(object.extension)
                : undefined;
        return message;
    },
};
function createBaseContractCodeHistoryEntry() {
    return {
        operation: 0,
        codeId: helpers_1.Long.UZERO,
        updated: undefined,
        msg: new Uint8Array(),
    };
}
exports.ContractCodeHistoryEntry = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.operation !== 0) {
            writer.uint32(8).int32(message.operation);
        }
        if (!message.codeId.isZero()) {
            writer.uint32(16).uint64(message.codeId);
        }
        if (message.updated !== undefined) {
            exports.AbsoluteTxPosition.encode(message.updated, writer.uint32(26).fork()).ldelim();
        }
        if (message.msg.length !== 0) {
            writer.uint32(34).bytes(message.msg);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseContractCodeHistoryEntry();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.operation = reader.int32();
                    break;
                case 2:
                    message.codeId = reader.uint64();
                    break;
                case 3:
                    message.updated = exports.AbsoluteTxPosition.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.msg = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            operation: (0, helpers_1.isSet)(object.operation) ? contractCodeHistoryOperationTypeFromJSON(object.operation) : 0,
            codeId: (0, helpers_1.isSet)(object.codeId) ? helpers_1.Long.fromValue(object.codeId) : helpers_1.Long.UZERO,
            updated: (0, helpers_1.isSet)(object.updated) ? exports.AbsoluteTxPosition.fromJSON(object.updated) : undefined,
            msg: (0, helpers_1.isSet)(object.msg) ? (0, helpers_1.bytesFromBase64)(object.msg) : new Uint8Array(),
        };
    },
    toJSON(message) {
        const obj = {};
        message.operation !== undefined &&
            (obj.operation = contractCodeHistoryOperationTypeToJSON(message.operation));
        message.codeId !== undefined && (obj.codeId = (message.codeId || helpers_1.Long.UZERO).toString());
        message.updated !== undefined &&
            (obj.updated = message.updated ? exports.AbsoluteTxPosition.toJSON(message.updated) : undefined);
        message.msg !== undefined &&
            (obj.msg = (0, helpers_1.base64FromBytes)(message.msg !== undefined ? message.msg : new Uint8Array()));
        return obj;
    },
    fromPartial(object) {
        const message = createBaseContractCodeHistoryEntry();
        message.operation = object.operation ?? 0;
        message.codeId =
            object.codeId !== undefined && object.codeId !== null ? helpers_1.Long.fromValue(object.codeId) : helpers_1.Long.UZERO;
        message.updated =
            object.updated !== undefined && object.updated !== null
                ? exports.AbsoluteTxPosition.fromPartial(object.updated)
                : undefined;
        message.msg = object.msg ?? new Uint8Array();
        return message;
    },
};
function createBaseAbsoluteTxPosition() {
    return {
        blockHeight: helpers_1.Long.UZERO,
        txIndex: helpers_1.Long.UZERO,
    };
}
exports.AbsoluteTxPosition = {
    encode(message, writer = _m0.Writer.create()) {
        if (!message.blockHeight.isZero()) {
            writer.uint32(8).uint64(message.blockHeight);
        }
        if (!message.txIndex.isZero()) {
            writer.uint32(16).uint64(message.txIndex);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAbsoluteTxPosition();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.blockHeight = reader.uint64();
                    break;
                case 2:
                    message.txIndex = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            blockHeight: (0, helpers_1.isSet)(object.blockHeight) ? helpers_1.Long.fromValue(object.blockHeight) : helpers_1.Long.UZERO,
            txIndex: (0, helpers_1.isSet)(object.txIndex) ? helpers_1.Long.fromValue(object.txIndex) : helpers_1.Long.UZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        message.blockHeight !== undefined && (obj.blockHeight = (message.blockHeight || helpers_1.Long.UZERO).toString());
        message.txIndex !== undefined && (obj.txIndex = (message.txIndex || helpers_1.Long.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseAbsoluteTxPosition();
        message.blockHeight =
            object.blockHeight !== undefined && object.blockHeight !== null
                ? helpers_1.Long.fromValue(object.blockHeight)
                : helpers_1.Long.UZERO;
        message.txIndex =
            object.txIndex !== undefined && object.txIndex !== null ? helpers_1.Long.fromValue(object.txIndex) : helpers_1.Long.UZERO;
        return message;
    },
};
function createBaseModel() {
    return {
        key: new Uint8Array(),
        value: new Uint8Array(),
    };
}
exports.Model = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.key.length !== 0) {
            writer.uint32(10).bytes(message.key);
        }
        if (message.value.length !== 0) {
            writer.uint32(18).bytes(message.value);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseModel();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.key = reader.bytes();
                    break;
                case 2:
                    message.value = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            key: (0, helpers_1.isSet)(object.key) ? (0, helpers_1.bytesFromBase64)(object.key) : new Uint8Array(),
            value: (0, helpers_1.isSet)(object.value) ? (0, helpers_1.bytesFromBase64)(object.value) : new Uint8Array(),
        };
    },
    toJSON(message) {
        const obj = {};
        message.key !== undefined &&
            (obj.key = (0, helpers_1.base64FromBytes)(message.key !== undefined ? message.key : new Uint8Array()));
        message.value !== undefined &&
            (obj.value = (0, helpers_1.base64FromBytes)(message.value !== undefined ? message.value : new Uint8Array()));
        return obj;
    },
    fromPartial(object) {
        const message = createBaseModel();
        message.key = object.key ?? new Uint8Array();
        message.value = object.value ?? new Uint8Array();
        return message;
    },
};
//# sourceMappingURL=types.js.map

/***/ }),

/***/ 75654:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Any = exports.protobufPackage = void 0;
/* eslint-disable */
const _m0 = __importStar(__webpack_require__(62100));
const helpers_1 = __webpack_require__(92654);
exports.protobufPackage = "google.protobuf";
function createBaseAny() {
    return {
        typeUrl: "",
        value: new Uint8Array(),
    };
}
exports.Any = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.typeUrl !== "") {
            writer.uint32(10).string(message.typeUrl);
        }
        if (message.value.length !== 0) {
            writer.uint32(18).bytes(message.value);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAny();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.typeUrl = reader.string();
                    break;
                case 2:
                    message.value = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            typeUrl: (0, helpers_1.isSet)(object.typeUrl) ? String(object.typeUrl) : "",
            value: (0, helpers_1.isSet)(object.value) ? (0, helpers_1.bytesFromBase64)(object.value) : new Uint8Array(),
        };
    },
    toJSON(message) {
        const obj = {};
        message.typeUrl !== undefined && (obj.typeUrl = message.typeUrl);
        message.value !== undefined &&
            (obj.value = (0, helpers_1.base64FromBytes)(message.value !== undefined ? message.value : new Uint8Array()));
        return obj;
    },
    fromPartial(object) {
        const message = createBaseAny();
        message.typeUrl = object.typeUrl ?? "";
        message.value = object.value ?? new Uint8Array();
        return message;
    },
};
//# sourceMappingURL=any.js.map

/***/ }),

/***/ 9591:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Duration = exports.protobufPackage = void 0;
/* eslint-disable */
const helpers_1 = __webpack_require__(92654);
const _m0 = __importStar(__webpack_require__(62100));
exports.protobufPackage = "google.protobuf";
function createBaseDuration() {
    return {
        seconds: helpers_1.Long.ZERO,
        nanos: 0,
    };
}
exports.Duration = {
    encode(message, writer = _m0.Writer.create()) {
        if (!message.seconds.isZero()) {
            writer.uint32(8).int64(message.seconds);
        }
        if (message.nanos !== 0) {
            writer.uint32(16).int32(message.nanos);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDuration();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.seconds = reader.int64();
                    break;
                case 2:
                    message.nanos = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            seconds: (0, helpers_1.isSet)(object.seconds) ? helpers_1.Long.fromValue(object.seconds) : helpers_1.Long.ZERO,
            nanos: (0, helpers_1.isSet)(object.nanos) ? Number(object.nanos) : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        message.seconds !== undefined && (obj.seconds = (message.seconds || helpers_1.Long.ZERO).toString());
        message.nanos !== undefined && (obj.nanos = Math.round(message.nanos));
        return obj;
    },
    fromPartial(object) {
        const message = createBaseDuration();
        message.seconds =
            object.seconds !== undefined && object.seconds !== null ? helpers_1.Long.fromValue(object.seconds) : helpers_1.Long.ZERO;
        message.nanos = object.nanos ?? 0;
        return message;
    },
};
//# sourceMappingURL=duration.js.map

/***/ }),

/***/ 70147:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Timestamp = exports.protobufPackage = void 0;
/* eslint-disable */
const helpers_1 = __webpack_require__(92654);
const _m0 = __importStar(__webpack_require__(62100));
exports.protobufPackage = "google.protobuf";
function createBaseTimestamp() {
    return {
        seconds: helpers_1.Long.ZERO,
        nanos: 0,
    };
}
exports.Timestamp = {
    encode(message, writer = _m0.Writer.create()) {
        if (!message.seconds.isZero()) {
            writer.uint32(8).int64(message.seconds);
        }
        if (message.nanos !== 0) {
            writer.uint32(16).int32(message.nanos);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTimestamp();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.seconds = reader.int64();
                    break;
                case 2:
                    message.nanos = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            seconds: (0, helpers_1.isSet)(object.seconds) ? helpers_1.Long.fromValue(object.seconds) : helpers_1.Long.ZERO,
            nanos: (0, helpers_1.isSet)(object.nanos) ? Number(object.nanos) : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        message.seconds !== undefined && (obj.seconds = (message.seconds || helpers_1.Long.ZERO).toString());
        message.nanos !== undefined && (obj.nanos = Math.round(message.nanos));
        return obj;
    },
    fromPartial(object) {
        const message = createBaseTimestamp();
        message.seconds =
            object.seconds !== undefined && object.seconds !== null ? helpers_1.Long.fromValue(object.seconds) : helpers_1.Long.ZERO;
        message.nanos = object.nanos ?? 0;
        return message;
    },
};
//# sourceMappingURL=timestamp.js.map

/***/ }),

/***/ 92654:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/* provided dependency */ var Buffer = __webpack_require__(48764)["Buffer"];

/* eslint-disable */
/**
 * This file and any referenced files were automatically generated by @osmonauts/telescope@0.94.1
 * DO NOT MODIFY BY HAND. Instead, download the latest proto files for your chain
 * and run the transpile command or yarn proto command to regenerate this bundle.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.fromJsonTimestamp = exports.fromTimestamp = exports.toTimestamp = exports.setPaginationParams = exports.isObject = exports.isSet = exports.fromDuration = exports.toDuration = exports.omitDefault = exports.base64FromBytes = exports.bytesFromBase64 = exports.Long = void 0;
const _m0 = __importStar(__webpack_require__(62100));
const long_1 = __importDefault(__webpack_require__(10648));
exports.Long = long_1.default;
// @ts-ignore
if (_m0.util.Long !== long_1.default) {
    _m0.util.Long = long_1.default;
    _m0.configure();
}
var globalThis = (() => {
    if (typeof globalThis !== "undefined")
        return globalThis;
    if (typeof self !== "undefined")
        return self;
    if (typeof window !== "undefined")
        return window;
    if (typeof __webpack_require__.g !== "undefined")
        return __webpack_require__.g;
    throw "Unable to locate global object";
})();
const atob = globalThis.atob || ((b64) => globalThis.Buffer.from(b64, "base64").toString("binary"));
function bytesFromBase64(b64) {
    const bin = atob(b64);
    const arr = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; ++i) {
        arr[i] = bin.charCodeAt(i);
    }
    return arr;
}
exports.bytesFromBase64 = bytesFromBase64;
const btoa = globalThis.btoa || ((bin) => globalThis.Buffer.from(bin, "binary").toString("base64"));
function base64FromBytes(arr) {
    const bin = [];
    arr.forEach((byte) => {
        bin.push(String.fromCharCode(byte));
    });
    return btoa(bin.join(""));
}
exports.base64FromBytes = base64FromBytes;
function omitDefault(input) {
    if (typeof input === "string") {
        return input === "" ? undefined : input;
    }
    if (typeof input === "number") {
        return input === 0 ? undefined : input;
    }
    if (long_1.default.isLong(input)) {
        return input.isZero() ? undefined : input;
    }
    throw new Error(`Got unsupported type ${typeof input}`);
}
exports.omitDefault = omitDefault;
function toDuration(duration) {
    return {
        seconds: long_1.default.fromNumber(Math.floor(parseInt(duration) / 1000000000)),
        nanos: parseInt(duration) % 1000000000,
    };
}
exports.toDuration = toDuration;
function fromDuration(duration) {
    return (parseInt(duration.seconds.toString()) * 1000000000 + duration.nanos).toString();
}
exports.fromDuration = fromDuration;
function isSet(value) {
    return value !== null && value !== undefined;
}
exports.isSet = isSet;
function isObject(value) {
    return typeof value === "object" && value !== null;
}
exports.isObject = isObject;
const setPaginationParams = (options, pagination) => {
    if (!pagination) {
        return options;
    }
    if (typeof pagination?.countTotal !== "undefined") {
        options.params["pagination.count_total"] = pagination.countTotal;
    }
    if (typeof pagination?.key !== "undefined") {
        // String to Uint8Array
        // let uint8arr = new Uint8Array(Buffer.from(data,'base64'));
        // Uint8Array to String
        options.params["pagination.key"] = Buffer.from(pagination.key).toString("base64");
    }
    if (typeof pagination?.limit !== "undefined") {
        options.params["pagination.limit"] = pagination.limit.toString();
    }
    if (typeof pagination?.offset !== "undefined") {
        options.params["pagination.offset"] = pagination.offset.toString();
    }
    if (typeof pagination?.reverse !== "undefined") {
        options.params["pagination.reverse"] = pagination.reverse;
    }
    return options;
};
exports.setPaginationParams = setPaginationParams;
function toTimestamp(date) {
    const seconds = numberToLong(date.getTime() / 1000);
    const nanos = (date.getTime() % 1000) * 1000000;
    return {
        seconds,
        nanos,
    };
}
exports.toTimestamp = toTimestamp;
function fromTimestamp(t) {
    let millis = t.seconds.toNumber() * 1000;
    millis += t.nanos / 1000000;
    return new Date(millis);
}
exports.fromTimestamp = fromTimestamp;
const fromJSON = (object) => {
    return {
        seconds: isSet(object.seconds) ? long_1.default.fromString(object.seconds) : long_1.default.ZERO,
        nanos: isSet(object.nanos) ? Number(object.nanos) : 0,
    };
};
const timestampFromJSON = (object) => {
    return {
        seconds: isSet(object.seconds) ? long_1.default.fromValue(object.seconds) : long_1.default.ZERO,
        nanos: isSet(object.nanos) ? Number(object.nanos) : 0,
    };
};
function fromJsonTimestamp(o) {
    if (o instanceof Date) {
        return toTimestamp(o);
    }
    else if (typeof o === "string") {
        return toTimestamp(new Date(o));
    }
    else {
        return timestampFromJSON(o);
    }
}
exports.fromJsonTimestamp = fromJsonTimestamp;
function numberToLong(number) {
    return long_1.default.fromNumber(number);
}
//# sourceMappingURL=helpers.js.map

/***/ }),

/***/ 14007:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.QueryClientImpl = exports.QueryEscrowAddressResponse = exports.QueryEscrowAddressRequest = exports.QueryDenomHashResponse = exports.QueryDenomHashRequest = exports.QueryParamsResponse = exports.QueryParamsRequest = exports.QueryDenomTracesResponse = exports.QueryDenomTracesRequest = exports.QueryDenomTraceResponse = exports.QueryDenomTraceRequest = exports.protobufPackage = void 0;
/* eslint-disable */
const pagination_1 = __webpack_require__(84043);
const transfer_1 = __webpack_require__(81691);
const _m0 = __importStar(__webpack_require__(62100));
const helpers_1 = __webpack_require__(92654);
exports.protobufPackage = "ibc.applications.transfer.v1";
function createBaseQueryDenomTraceRequest() {
    return {
        hash: "",
    };
}
exports.QueryDenomTraceRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.hash !== "") {
            writer.uint32(10).string(message.hash);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryDenomTraceRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.hash = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            hash: (0, helpers_1.isSet)(object.hash) ? String(object.hash) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.hash !== undefined && (obj.hash = message.hash);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryDenomTraceRequest();
        message.hash = object.hash ?? "";
        return message;
    },
};
function createBaseQueryDenomTraceResponse() {
    return {
        denomTrace: undefined,
    };
}
exports.QueryDenomTraceResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.denomTrace !== undefined) {
            transfer_1.DenomTrace.encode(message.denomTrace, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryDenomTraceResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.denomTrace = transfer_1.DenomTrace.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            denomTrace: (0, helpers_1.isSet)(object.denomTrace) ? transfer_1.DenomTrace.fromJSON(object.denomTrace) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.denomTrace !== undefined &&
            (obj.denomTrace = message.denomTrace ? transfer_1.DenomTrace.toJSON(message.denomTrace) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryDenomTraceResponse();
        message.denomTrace =
            object.denomTrace !== undefined && object.denomTrace !== null
                ? transfer_1.DenomTrace.fromPartial(object.denomTrace)
                : undefined;
        return message;
    },
};
function createBaseQueryDenomTracesRequest() {
    return {
        pagination: undefined,
    };
}
exports.QueryDenomTracesRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryDenomTracesRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            pagination: (0, helpers_1.isSet)(object.pagination) ? pagination_1.PageRequest.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryDenomTracesRequest();
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryDenomTracesResponse() {
    return {
        denomTraces: [],
        pagination: undefined,
    };
}
exports.QueryDenomTracesResponse = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.denomTraces) {
            transfer_1.DenomTrace.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryDenomTracesResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.denomTraces.push(transfer_1.DenomTrace.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            denomTraces: Array.isArray(object?.denomTraces)
                ? object.denomTraces.map((e) => transfer_1.DenomTrace.fromJSON(e))
                : [],
            pagination: (0, helpers_1.isSet)(object.pagination) ? pagination_1.PageResponse.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.denomTraces) {
            obj.denomTraces = message.denomTraces.map((e) => (e ? transfer_1.DenomTrace.toJSON(e) : undefined));
        }
        else {
            obj.denomTraces = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryDenomTracesResponse();
        message.denomTraces = object.denomTraces?.map((e) => transfer_1.DenomTrace.fromPartial(e)) || [];
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryParamsRequest() {
    return {};
}
exports.QueryParamsRequest = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryParamsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseQueryParamsRequest();
        return message;
    },
};
function createBaseQueryParamsResponse() {
    return {
        params: undefined,
    };
}
exports.QueryParamsResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.params !== undefined) {
            transfer_1.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryParamsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.params = transfer_1.Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            params: (0, helpers_1.isSet)(object.params) ? transfer_1.Params.fromJSON(object.params) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.params !== undefined && (obj.params = message.params ? transfer_1.Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryParamsResponse();
        message.params =
            object.params !== undefined && object.params !== null ? transfer_1.Params.fromPartial(object.params) : undefined;
        return message;
    },
};
function createBaseQueryDenomHashRequest() {
    return {
        trace: "",
    };
}
exports.QueryDenomHashRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.trace !== "") {
            writer.uint32(10).string(message.trace);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryDenomHashRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.trace = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            trace: (0, helpers_1.isSet)(object.trace) ? String(object.trace) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.trace !== undefined && (obj.trace = message.trace);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryDenomHashRequest();
        message.trace = object.trace ?? "";
        return message;
    },
};
function createBaseQueryDenomHashResponse() {
    return {
        hash: "",
    };
}
exports.QueryDenomHashResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.hash !== "") {
            writer.uint32(10).string(message.hash);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryDenomHashResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.hash = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            hash: (0, helpers_1.isSet)(object.hash) ? String(object.hash) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.hash !== undefined && (obj.hash = message.hash);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryDenomHashResponse();
        message.hash = object.hash ?? "";
        return message;
    },
};
function createBaseQueryEscrowAddressRequest() {
    return {
        portId: "",
        channelId: "",
    };
}
exports.QueryEscrowAddressRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.portId !== "") {
            writer.uint32(10).string(message.portId);
        }
        if (message.channelId !== "") {
            writer.uint32(18).string(message.channelId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryEscrowAddressRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            portId: (0, helpers_1.isSet)(object.portId) ? String(object.portId) : "",
            channelId: (0, helpers_1.isSet)(object.channelId) ? String(object.channelId) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryEscrowAddressRequest();
        message.portId = object.portId ?? "";
        message.channelId = object.channelId ?? "";
        return message;
    },
};
function createBaseQueryEscrowAddressResponse() {
    return {
        escrowAddress: "",
    };
}
exports.QueryEscrowAddressResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.escrowAddress !== "") {
            writer.uint32(10).string(message.escrowAddress);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryEscrowAddressResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.escrowAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            escrowAddress: (0, helpers_1.isSet)(object.escrowAddress) ? String(object.escrowAddress) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.escrowAddress !== undefined && (obj.escrowAddress = message.escrowAddress);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryEscrowAddressResponse();
        message.escrowAddress = object.escrowAddress ?? "";
        return message;
    },
};
class QueryClientImpl {
    constructor(rpc) {
        this.rpc = rpc;
        this.DenomTrace = this.DenomTrace.bind(this);
        this.DenomTraces = this.DenomTraces.bind(this);
        this.Params = this.Params.bind(this);
        this.DenomHash = this.DenomHash.bind(this);
        this.EscrowAddress = this.EscrowAddress.bind(this);
    }
    DenomTrace(request) {
        const data = exports.QueryDenomTraceRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.applications.transfer.v1.Query", "DenomTrace", data);
        return promise.then((data) => exports.QueryDenomTraceResponse.decode(new _m0.Reader(data)));
    }
    DenomTraces(request = {
        pagination: undefined,
    }) {
        const data = exports.QueryDenomTracesRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.applications.transfer.v1.Query", "DenomTraces", data);
        return promise.then((data) => exports.QueryDenomTracesResponse.decode(new _m0.Reader(data)));
    }
    Params(request = {}) {
        const data = exports.QueryParamsRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.applications.transfer.v1.Query", "Params", data);
        return promise.then((data) => exports.QueryParamsResponse.decode(new _m0.Reader(data)));
    }
    DenomHash(request) {
        const data = exports.QueryDenomHashRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.applications.transfer.v1.Query", "DenomHash", data);
        return promise.then((data) => exports.QueryDenomHashResponse.decode(new _m0.Reader(data)));
    }
    EscrowAddress(request) {
        const data = exports.QueryEscrowAddressRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.applications.transfer.v1.Query", "EscrowAddress", data);
        return promise.then((data) => exports.QueryEscrowAddressResponse.decode(new _m0.Reader(data)));
    }
}
exports.QueryClientImpl = QueryClientImpl;
//# sourceMappingURL=query.js.map

/***/ }),

/***/ 81691:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Params = exports.DenomTrace = exports.protobufPackage = void 0;
/* eslint-disable */
const _m0 = __importStar(__webpack_require__(62100));
const helpers_1 = __webpack_require__(92654);
exports.protobufPackage = "ibc.applications.transfer.v1";
function createBaseDenomTrace() {
    return {
        path: "",
        baseDenom: "",
    };
}
exports.DenomTrace = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.path !== "") {
            writer.uint32(10).string(message.path);
        }
        if (message.baseDenom !== "") {
            writer.uint32(18).string(message.baseDenom);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDenomTrace();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.path = reader.string();
                    break;
                case 2:
                    message.baseDenom = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            path: (0, helpers_1.isSet)(object.path) ? String(object.path) : "",
            baseDenom: (0, helpers_1.isSet)(object.baseDenom) ? String(object.baseDenom) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.path !== undefined && (obj.path = message.path);
        message.baseDenom !== undefined && (obj.baseDenom = message.baseDenom);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseDenomTrace();
        message.path = object.path ?? "";
        message.baseDenom = object.baseDenom ?? "";
        return message;
    },
};
function createBaseParams() {
    return {
        sendEnabled: false,
        receiveEnabled: false,
    };
}
exports.Params = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.sendEnabled === true) {
            writer.uint32(8).bool(message.sendEnabled);
        }
        if (message.receiveEnabled === true) {
            writer.uint32(16).bool(message.receiveEnabled);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseParams();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.sendEnabled = reader.bool();
                    break;
                case 2:
                    message.receiveEnabled = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            sendEnabled: (0, helpers_1.isSet)(object.sendEnabled) ? Boolean(object.sendEnabled) : false,
            receiveEnabled: (0, helpers_1.isSet)(object.receiveEnabled) ? Boolean(object.receiveEnabled) : false,
        };
    },
    toJSON(message) {
        const obj = {};
        message.sendEnabled !== undefined && (obj.sendEnabled = message.sendEnabled);
        message.receiveEnabled !== undefined && (obj.receiveEnabled = message.receiveEnabled);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseParams();
        message.sendEnabled = object.sendEnabled ?? false;
        message.receiveEnabled = object.receiveEnabled ?? false;
        return message;
    },
};
//# sourceMappingURL=transfer.js.map

/***/ }),

/***/ 88313:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MsgClientImpl = exports.MsgTransferResponse = exports.MsgTransfer = exports.protobufPackage = void 0;
/* eslint-disable */
const coin_1 = __webpack_require__(81637);
const client_1 = __webpack_require__(30085);
const helpers_1 = __webpack_require__(92654);
const _m0 = __importStar(__webpack_require__(62100));
exports.protobufPackage = "ibc.applications.transfer.v1";
function createBaseMsgTransfer() {
    return {
        sourcePort: "",
        sourceChannel: "",
        token: undefined,
        sender: "",
        receiver: "",
        timeoutHeight: undefined,
        timeoutTimestamp: helpers_1.Long.UZERO,
        memo: "",
    };
}
exports.MsgTransfer = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.sourcePort !== "") {
            writer.uint32(10).string(message.sourcePort);
        }
        if (message.sourceChannel !== "") {
            writer.uint32(18).string(message.sourceChannel);
        }
        if (message.token !== undefined) {
            coin_1.Coin.encode(message.token, writer.uint32(26).fork()).ldelim();
        }
        if (message.sender !== "") {
            writer.uint32(34).string(message.sender);
        }
        if (message.receiver !== "") {
            writer.uint32(42).string(message.receiver);
        }
        if (message.timeoutHeight !== undefined) {
            client_1.Height.encode(message.timeoutHeight, writer.uint32(50).fork()).ldelim();
        }
        if (!message.timeoutTimestamp.isZero()) {
            writer.uint32(56).uint64(message.timeoutTimestamp);
        }
        if (message.memo !== "") {
            writer.uint32(66).string(message.memo);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgTransfer();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.sourcePort = reader.string();
                    break;
                case 2:
                    message.sourceChannel = reader.string();
                    break;
                case 3:
                    message.token = coin_1.Coin.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.sender = reader.string();
                    break;
                case 5:
                    message.receiver = reader.string();
                    break;
                case 6:
                    message.timeoutHeight = client_1.Height.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.timeoutTimestamp = reader.uint64();
                    break;
                case 8:
                    message.memo = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            sourcePort: (0, helpers_1.isSet)(object.sourcePort) ? String(object.sourcePort) : "",
            sourceChannel: (0, helpers_1.isSet)(object.sourceChannel) ? String(object.sourceChannel) : "",
            token: (0, helpers_1.isSet)(object.token) ? coin_1.Coin.fromJSON(object.token) : undefined,
            sender: (0, helpers_1.isSet)(object.sender) ? String(object.sender) : "",
            receiver: (0, helpers_1.isSet)(object.receiver) ? String(object.receiver) : "",
            timeoutHeight: (0, helpers_1.isSet)(object.timeoutHeight) ? client_1.Height.fromJSON(object.timeoutHeight) : undefined,
            timeoutTimestamp: (0, helpers_1.isSet)(object.timeoutTimestamp) ? helpers_1.Long.fromValue(object.timeoutTimestamp) : helpers_1.Long.UZERO,
            memo: (0, helpers_1.isSet)(object.memo) ? String(object.memo) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.sourcePort !== undefined && (obj.sourcePort = message.sourcePort);
        message.sourceChannel !== undefined && (obj.sourceChannel = message.sourceChannel);
        message.token !== undefined && (obj.token = message.token ? coin_1.Coin.toJSON(message.token) : undefined);
        message.sender !== undefined && (obj.sender = message.sender);
        message.receiver !== undefined && (obj.receiver = message.receiver);
        message.timeoutHeight !== undefined &&
            (obj.timeoutHeight = message.timeoutHeight ? client_1.Height.toJSON(message.timeoutHeight) : undefined);
        message.timeoutTimestamp !== undefined &&
            (obj.timeoutTimestamp = (message.timeoutTimestamp || helpers_1.Long.UZERO).toString());
        message.memo !== undefined && (obj.memo = message.memo);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgTransfer();
        message.sourcePort = object.sourcePort ?? "";
        message.sourceChannel = object.sourceChannel ?? "";
        message.token =
            object.token !== undefined && object.token !== null ? coin_1.Coin.fromPartial(object.token) : undefined;
        message.sender = object.sender ?? "";
        message.receiver = object.receiver ?? "";
        message.timeoutHeight =
            object.timeoutHeight !== undefined && object.timeoutHeight !== null
                ? client_1.Height.fromPartial(object.timeoutHeight)
                : undefined;
        message.timeoutTimestamp =
            object.timeoutTimestamp !== undefined && object.timeoutTimestamp !== null
                ? helpers_1.Long.fromValue(object.timeoutTimestamp)
                : helpers_1.Long.UZERO;
        message.memo = object.memo ?? "";
        return message;
    },
};
function createBaseMsgTransferResponse() {
    return {
        sequence: helpers_1.Long.UZERO,
    };
}
exports.MsgTransferResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (!message.sequence.isZero()) {
            writer.uint32(8).uint64(message.sequence);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgTransferResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.sequence = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            sequence: (0, helpers_1.isSet)(object.sequence) ? helpers_1.Long.fromValue(object.sequence) : helpers_1.Long.UZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        message.sequence !== undefined && (obj.sequence = (message.sequence || helpers_1.Long.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgTransferResponse();
        message.sequence =
            object.sequence !== undefined && object.sequence !== null
                ? helpers_1.Long.fromValue(object.sequence)
                : helpers_1.Long.UZERO;
        return message;
    },
};
class MsgClientImpl {
    constructor(rpc) {
        this.rpc = rpc;
        this.Transfer = this.Transfer.bind(this);
    }
    Transfer(request) {
        const data = exports.MsgTransfer.encode(request).finish();
        const promise = this.rpc.request("ibc.applications.transfer.v1.Msg", "Transfer", data);
        return promise.then((data) => exports.MsgTransferResponse.decode(new _m0.Reader(data)));
    }
}
exports.MsgClientImpl = MsgClientImpl;
//# sourceMappingURL=tx.js.map

/***/ }),

/***/ 24007:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Acknowledgement = exports.PacketId = exports.PacketState = exports.Packet = exports.Counterparty = exports.IdentifiedChannel = exports.Channel = exports.orderToJSON = exports.orderFromJSON = exports.Order = exports.stateToJSON = exports.stateFromJSON = exports.State = exports.protobufPackage = void 0;
/* eslint-disable */
const client_1 = __webpack_require__(30085);
const helpers_1 = __webpack_require__(92654);
const _m0 = __importStar(__webpack_require__(62100));
exports.protobufPackage = "ibc.core.channel.v1";
/**
 * State defines if a channel is in one of the following states:
 * CLOSED, INIT, TRYOPEN, OPEN or UNINITIALIZED.
 */
var State;
(function (State) {
    /** STATE_UNINITIALIZED_UNSPECIFIED - Default State */
    State[State["STATE_UNINITIALIZED_UNSPECIFIED"] = 0] = "STATE_UNINITIALIZED_UNSPECIFIED";
    /** STATE_INIT - A channel has just started the opening handshake. */
    State[State["STATE_INIT"] = 1] = "STATE_INIT";
    /** STATE_TRYOPEN - A channel has acknowledged the handshake step on the counterparty chain. */
    State[State["STATE_TRYOPEN"] = 2] = "STATE_TRYOPEN";
    /**
     * STATE_OPEN - A channel has completed the handshake. Open channels are
     * ready to send and receive packets.
     */
    State[State["STATE_OPEN"] = 3] = "STATE_OPEN";
    /**
     * STATE_CLOSED - A channel has been closed and can no longer be used to send or receive
     * packets.
     */
    State[State["STATE_CLOSED"] = 4] = "STATE_CLOSED";
    State[State["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(State = exports.State || (exports.State = {}));
function stateFromJSON(object) {
    switch (object) {
        case 0:
        case "STATE_UNINITIALIZED_UNSPECIFIED":
            return State.STATE_UNINITIALIZED_UNSPECIFIED;
        case 1:
        case "STATE_INIT":
            return State.STATE_INIT;
        case 2:
        case "STATE_TRYOPEN":
            return State.STATE_TRYOPEN;
        case 3:
        case "STATE_OPEN":
            return State.STATE_OPEN;
        case 4:
        case "STATE_CLOSED":
            return State.STATE_CLOSED;
        case -1:
        case "UNRECOGNIZED":
        default:
            return State.UNRECOGNIZED;
    }
}
exports.stateFromJSON = stateFromJSON;
function stateToJSON(object) {
    switch (object) {
        case State.STATE_UNINITIALIZED_UNSPECIFIED:
            return "STATE_UNINITIALIZED_UNSPECIFIED";
        case State.STATE_INIT:
            return "STATE_INIT";
        case State.STATE_TRYOPEN:
            return "STATE_TRYOPEN";
        case State.STATE_OPEN:
            return "STATE_OPEN";
        case State.STATE_CLOSED:
            return "STATE_CLOSED";
        case State.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.stateToJSON = stateToJSON;
/** Order defines if a channel is ORDERED or UNORDERED */
var Order;
(function (Order) {
    /** ORDER_NONE_UNSPECIFIED - zero-value for channel ordering */
    Order[Order["ORDER_NONE_UNSPECIFIED"] = 0] = "ORDER_NONE_UNSPECIFIED";
    /**
     * ORDER_UNORDERED - packets can be delivered in any order, which may differ from the order in
     * which they were sent.
     */
    Order[Order["ORDER_UNORDERED"] = 1] = "ORDER_UNORDERED";
    /** ORDER_ORDERED - packets are delivered exactly in the order which they were sent */
    Order[Order["ORDER_ORDERED"] = 2] = "ORDER_ORDERED";
    Order[Order["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(Order = exports.Order || (exports.Order = {}));
function orderFromJSON(object) {
    switch (object) {
        case 0:
        case "ORDER_NONE_UNSPECIFIED":
            return Order.ORDER_NONE_UNSPECIFIED;
        case 1:
        case "ORDER_UNORDERED":
            return Order.ORDER_UNORDERED;
        case 2:
        case "ORDER_ORDERED":
            return Order.ORDER_ORDERED;
        case -1:
        case "UNRECOGNIZED":
        default:
            return Order.UNRECOGNIZED;
    }
}
exports.orderFromJSON = orderFromJSON;
function orderToJSON(object) {
    switch (object) {
        case Order.ORDER_NONE_UNSPECIFIED:
            return "ORDER_NONE_UNSPECIFIED";
        case Order.ORDER_UNORDERED:
            return "ORDER_UNORDERED";
        case Order.ORDER_ORDERED:
            return "ORDER_ORDERED";
        case Order.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.orderToJSON = orderToJSON;
function createBaseChannel() {
    return {
        state: 0,
        ordering: 0,
        counterparty: undefined,
        connectionHops: [],
        version: "",
    };
}
exports.Channel = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.state !== 0) {
            writer.uint32(8).int32(message.state);
        }
        if (message.ordering !== 0) {
            writer.uint32(16).int32(message.ordering);
        }
        if (message.counterparty !== undefined) {
            exports.Counterparty.encode(message.counterparty, writer.uint32(26).fork()).ldelim();
        }
        for (const v of message.connectionHops) {
            writer.uint32(34).string(v);
        }
        if (message.version !== "") {
            writer.uint32(42).string(message.version);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseChannel();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.state = reader.int32();
                    break;
                case 2:
                    message.ordering = reader.int32();
                    break;
                case 3:
                    message.counterparty = exports.Counterparty.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.connectionHops.push(reader.string());
                    break;
                case 5:
                    message.version = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            state: (0, helpers_1.isSet)(object.state) ? stateFromJSON(object.state) : 0,
            ordering: (0, helpers_1.isSet)(object.ordering) ? orderFromJSON(object.ordering) : 0,
            counterparty: (0, helpers_1.isSet)(object.counterparty) ? exports.Counterparty.fromJSON(object.counterparty) : undefined,
            connectionHops: Array.isArray(object?.connectionHops)
                ? object.connectionHops.map((e) => String(e))
                : [],
            version: (0, helpers_1.isSet)(object.version) ? String(object.version) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.state !== undefined && (obj.state = stateToJSON(message.state));
        message.ordering !== undefined && (obj.ordering = orderToJSON(message.ordering));
        message.counterparty !== undefined &&
            (obj.counterparty = message.counterparty ? exports.Counterparty.toJSON(message.counterparty) : undefined);
        if (message.connectionHops) {
            obj.connectionHops = message.connectionHops.map((e) => e);
        }
        else {
            obj.connectionHops = [];
        }
        message.version !== undefined && (obj.version = message.version);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseChannel();
        message.state = object.state ?? 0;
        message.ordering = object.ordering ?? 0;
        message.counterparty =
            object.counterparty !== undefined && object.counterparty !== null
                ? exports.Counterparty.fromPartial(object.counterparty)
                : undefined;
        message.connectionHops = object.connectionHops?.map((e) => e) || [];
        message.version = object.version ?? "";
        return message;
    },
};
function createBaseIdentifiedChannel() {
    return {
        state: 0,
        ordering: 0,
        counterparty: undefined,
        connectionHops: [],
        version: "",
        portId: "",
        channelId: "",
    };
}
exports.IdentifiedChannel = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.state !== 0) {
            writer.uint32(8).int32(message.state);
        }
        if (message.ordering !== 0) {
            writer.uint32(16).int32(message.ordering);
        }
        if (message.counterparty !== undefined) {
            exports.Counterparty.encode(message.counterparty, writer.uint32(26).fork()).ldelim();
        }
        for (const v of message.connectionHops) {
            writer.uint32(34).string(v);
        }
        if (message.version !== "") {
            writer.uint32(42).string(message.version);
        }
        if (message.portId !== "") {
            writer.uint32(50).string(message.portId);
        }
        if (message.channelId !== "") {
            writer.uint32(58).string(message.channelId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseIdentifiedChannel();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.state = reader.int32();
                    break;
                case 2:
                    message.ordering = reader.int32();
                    break;
                case 3:
                    message.counterparty = exports.Counterparty.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.connectionHops.push(reader.string());
                    break;
                case 5:
                    message.version = reader.string();
                    break;
                case 6:
                    message.portId = reader.string();
                    break;
                case 7:
                    message.channelId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            state: (0, helpers_1.isSet)(object.state) ? stateFromJSON(object.state) : 0,
            ordering: (0, helpers_1.isSet)(object.ordering) ? orderFromJSON(object.ordering) : 0,
            counterparty: (0, helpers_1.isSet)(object.counterparty) ? exports.Counterparty.fromJSON(object.counterparty) : undefined,
            connectionHops: Array.isArray(object?.connectionHops)
                ? object.connectionHops.map((e) => String(e))
                : [],
            version: (0, helpers_1.isSet)(object.version) ? String(object.version) : "",
            portId: (0, helpers_1.isSet)(object.portId) ? String(object.portId) : "",
            channelId: (0, helpers_1.isSet)(object.channelId) ? String(object.channelId) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.state !== undefined && (obj.state = stateToJSON(message.state));
        message.ordering !== undefined && (obj.ordering = orderToJSON(message.ordering));
        message.counterparty !== undefined &&
            (obj.counterparty = message.counterparty ? exports.Counterparty.toJSON(message.counterparty) : undefined);
        if (message.connectionHops) {
            obj.connectionHops = message.connectionHops.map((e) => e);
        }
        else {
            obj.connectionHops = [];
        }
        message.version !== undefined && (obj.version = message.version);
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseIdentifiedChannel();
        message.state = object.state ?? 0;
        message.ordering = object.ordering ?? 0;
        message.counterparty =
            object.counterparty !== undefined && object.counterparty !== null
                ? exports.Counterparty.fromPartial(object.counterparty)
                : undefined;
        message.connectionHops = object.connectionHops?.map((e) => e) || [];
        message.version = object.version ?? "";
        message.portId = object.portId ?? "";
        message.channelId = object.channelId ?? "";
        return message;
    },
};
function createBaseCounterparty() {
    return {
        portId: "",
        channelId: "",
    };
}
exports.Counterparty = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.portId !== "") {
            writer.uint32(10).string(message.portId);
        }
        if (message.channelId !== "") {
            writer.uint32(18).string(message.channelId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCounterparty();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            portId: (0, helpers_1.isSet)(object.portId) ? String(object.portId) : "",
            channelId: (0, helpers_1.isSet)(object.channelId) ? String(object.channelId) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseCounterparty();
        message.portId = object.portId ?? "";
        message.channelId = object.channelId ?? "";
        return message;
    },
};
function createBasePacket() {
    return {
        sequence: helpers_1.Long.UZERO,
        sourcePort: "",
        sourceChannel: "",
        destinationPort: "",
        destinationChannel: "",
        data: new Uint8Array(),
        timeoutHeight: undefined,
        timeoutTimestamp: helpers_1.Long.UZERO,
    };
}
exports.Packet = {
    encode(message, writer = _m0.Writer.create()) {
        if (!message.sequence.isZero()) {
            writer.uint32(8).uint64(message.sequence);
        }
        if (message.sourcePort !== "") {
            writer.uint32(18).string(message.sourcePort);
        }
        if (message.sourceChannel !== "") {
            writer.uint32(26).string(message.sourceChannel);
        }
        if (message.destinationPort !== "") {
            writer.uint32(34).string(message.destinationPort);
        }
        if (message.destinationChannel !== "") {
            writer.uint32(42).string(message.destinationChannel);
        }
        if (message.data.length !== 0) {
            writer.uint32(50).bytes(message.data);
        }
        if (message.timeoutHeight !== undefined) {
            client_1.Height.encode(message.timeoutHeight, writer.uint32(58).fork()).ldelim();
        }
        if (!message.timeoutTimestamp.isZero()) {
            writer.uint32(64).uint64(message.timeoutTimestamp);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePacket();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.sequence = reader.uint64();
                    break;
                case 2:
                    message.sourcePort = reader.string();
                    break;
                case 3:
                    message.sourceChannel = reader.string();
                    break;
                case 4:
                    message.destinationPort = reader.string();
                    break;
                case 5:
                    message.destinationChannel = reader.string();
                    break;
                case 6:
                    message.data = reader.bytes();
                    break;
                case 7:
                    message.timeoutHeight = client_1.Height.decode(reader, reader.uint32());
                    break;
                case 8:
                    message.timeoutTimestamp = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            sequence: (0, helpers_1.isSet)(object.sequence) ? helpers_1.Long.fromValue(object.sequence) : helpers_1.Long.UZERO,
            sourcePort: (0, helpers_1.isSet)(object.sourcePort) ? String(object.sourcePort) : "",
            sourceChannel: (0, helpers_1.isSet)(object.sourceChannel) ? String(object.sourceChannel) : "",
            destinationPort: (0, helpers_1.isSet)(object.destinationPort) ? String(object.destinationPort) : "",
            destinationChannel: (0, helpers_1.isSet)(object.destinationChannel) ? String(object.destinationChannel) : "",
            data: (0, helpers_1.isSet)(object.data) ? (0, helpers_1.bytesFromBase64)(object.data) : new Uint8Array(),
            timeoutHeight: (0, helpers_1.isSet)(object.timeoutHeight) ? client_1.Height.fromJSON(object.timeoutHeight) : undefined,
            timeoutTimestamp: (0, helpers_1.isSet)(object.timeoutTimestamp) ? helpers_1.Long.fromValue(object.timeoutTimestamp) : helpers_1.Long.UZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        message.sequence !== undefined && (obj.sequence = (message.sequence || helpers_1.Long.UZERO).toString());
        message.sourcePort !== undefined && (obj.sourcePort = message.sourcePort);
        message.sourceChannel !== undefined && (obj.sourceChannel = message.sourceChannel);
        message.destinationPort !== undefined && (obj.destinationPort = message.destinationPort);
        message.destinationChannel !== undefined && (obj.destinationChannel = message.destinationChannel);
        message.data !== undefined &&
            (obj.data = (0, helpers_1.base64FromBytes)(message.data !== undefined ? message.data : new Uint8Array()));
        message.timeoutHeight !== undefined &&
            (obj.timeoutHeight = message.timeoutHeight ? client_1.Height.toJSON(message.timeoutHeight) : undefined);
        message.timeoutTimestamp !== undefined &&
            (obj.timeoutTimestamp = (message.timeoutTimestamp || helpers_1.Long.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        const message = createBasePacket();
        message.sequence =
            object.sequence !== undefined && object.sequence !== null
                ? helpers_1.Long.fromValue(object.sequence)
                : helpers_1.Long.UZERO;
        message.sourcePort = object.sourcePort ?? "";
        message.sourceChannel = object.sourceChannel ?? "";
        message.destinationPort = object.destinationPort ?? "";
        message.destinationChannel = object.destinationChannel ?? "";
        message.data = object.data ?? new Uint8Array();
        message.timeoutHeight =
            object.timeoutHeight !== undefined && object.timeoutHeight !== null
                ? client_1.Height.fromPartial(object.timeoutHeight)
                : undefined;
        message.timeoutTimestamp =
            object.timeoutTimestamp !== undefined && object.timeoutTimestamp !== null
                ? helpers_1.Long.fromValue(object.timeoutTimestamp)
                : helpers_1.Long.UZERO;
        return message;
    },
};
function createBasePacketState() {
    return {
        portId: "",
        channelId: "",
        sequence: helpers_1.Long.UZERO,
        data: new Uint8Array(),
    };
}
exports.PacketState = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.portId !== "") {
            writer.uint32(10).string(message.portId);
        }
        if (message.channelId !== "") {
            writer.uint32(18).string(message.channelId);
        }
        if (!message.sequence.isZero()) {
            writer.uint32(24).uint64(message.sequence);
        }
        if (message.data.length !== 0) {
            writer.uint32(34).bytes(message.data);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePacketState();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                case 3:
                    message.sequence = reader.uint64();
                    break;
                case 4:
                    message.data = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            portId: (0, helpers_1.isSet)(object.portId) ? String(object.portId) : "",
            channelId: (0, helpers_1.isSet)(object.channelId) ? String(object.channelId) : "",
            sequence: (0, helpers_1.isSet)(object.sequence) ? helpers_1.Long.fromValue(object.sequence) : helpers_1.Long.UZERO,
            data: (0, helpers_1.isSet)(object.data) ? (0, helpers_1.bytesFromBase64)(object.data) : new Uint8Array(),
        };
    },
    toJSON(message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        message.sequence !== undefined && (obj.sequence = (message.sequence || helpers_1.Long.UZERO).toString());
        message.data !== undefined &&
            (obj.data = (0, helpers_1.base64FromBytes)(message.data !== undefined ? message.data : new Uint8Array()));
        return obj;
    },
    fromPartial(object) {
        const message = createBasePacketState();
        message.portId = object.portId ?? "";
        message.channelId = object.channelId ?? "";
        message.sequence =
            object.sequence !== undefined && object.sequence !== null
                ? helpers_1.Long.fromValue(object.sequence)
                : helpers_1.Long.UZERO;
        message.data = object.data ?? new Uint8Array();
        return message;
    },
};
function createBasePacketId() {
    return {
        portId: "",
        channelId: "",
        sequence: helpers_1.Long.UZERO,
    };
}
exports.PacketId = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.portId !== "") {
            writer.uint32(10).string(message.portId);
        }
        if (message.channelId !== "") {
            writer.uint32(18).string(message.channelId);
        }
        if (!message.sequence.isZero()) {
            writer.uint32(24).uint64(message.sequence);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePacketId();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                case 3:
                    message.sequence = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            portId: (0, helpers_1.isSet)(object.portId) ? String(object.portId) : "",
            channelId: (0, helpers_1.isSet)(object.channelId) ? String(object.channelId) : "",
            sequence: (0, helpers_1.isSet)(object.sequence) ? helpers_1.Long.fromValue(object.sequence) : helpers_1.Long.UZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        message.sequence !== undefined && (obj.sequence = (message.sequence || helpers_1.Long.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        const message = createBasePacketId();
        message.portId = object.portId ?? "";
        message.channelId = object.channelId ?? "";
        message.sequence =
            object.sequence !== undefined && object.sequence !== null
                ? helpers_1.Long.fromValue(object.sequence)
                : helpers_1.Long.UZERO;
        return message;
    },
};
function createBaseAcknowledgement() {
    return {
        result: undefined,
        error: undefined,
    };
}
exports.Acknowledgement = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.result !== undefined) {
            writer.uint32(170).bytes(message.result);
        }
        if (message.error !== undefined) {
            writer.uint32(178).string(message.error);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAcknowledgement();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 21:
                    message.result = reader.bytes();
                    break;
                case 22:
                    message.error = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            result: (0, helpers_1.isSet)(object.result) ? (0, helpers_1.bytesFromBase64)(object.result) : undefined,
            error: (0, helpers_1.isSet)(object.error) ? String(object.error) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.result !== undefined &&
            (obj.result = message.result !== undefined ? (0, helpers_1.base64FromBytes)(message.result) : undefined);
        message.error !== undefined && (obj.error = message.error);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseAcknowledgement();
        message.result = object.result ?? undefined;
        message.error = object.error ?? undefined;
        return message;
    },
};
//# sourceMappingURL=channel.js.map

/***/ }),

/***/ 6958:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.QueryClientImpl = exports.QueryNextSequenceReceiveResponse = exports.QueryNextSequenceReceiveRequest = exports.QueryUnreceivedAcksResponse = exports.QueryUnreceivedAcksRequest = exports.QueryUnreceivedPacketsResponse = exports.QueryUnreceivedPacketsRequest = exports.QueryPacketAcknowledgementsResponse = exports.QueryPacketAcknowledgementsRequest = exports.QueryPacketAcknowledgementResponse = exports.QueryPacketAcknowledgementRequest = exports.QueryPacketReceiptResponse = exports.QueryPacketReceiptRequest = exports.QueryPacketCommitmentsResponse = exports.QueryPacketCommitmentsRequest = exports.QueryPacketCommitmentResponse = exports.QueryPacketCommitmentRequest = exports.QueryChannelConsensusStateResponse = exports.QueryChannelConsensusStateRequest = exports.QueryChannelClientStateResponse = exports.QueryChannelClientStateRequest = exports.QueryConnectionChannelsResponse = exports.QueryConnectionChannelsRequest = exports.QueryChannelsResponse = exports.QueryChannelsRequest = exports.QueryChannelResponse = exports.QueryChannelRequest = exports.protobufPackage = void 0;
/* eslint-disable */
const pagination_1 = __webpack_require__(84043);
const channel_1 = __webpack_require__(24007);
const client_1 = __webpack_require__(30085);
const any_1 = __webpack_require__(75654);
const helpers_1 = __webpack_require__(92654);
const _m0 = __importStar(__webpack_require__(62100));
exports.protobufPackage = "ibc.core.channel.v1";
function createBaseQueryChannelRequest() {
    return {
        portId: "",
        channelId: "",
    };
}
exports.QueryChannelRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.portId !== "") {
            writer.uint32(10).string(message.portId);
        }
        if (message.channelId !== "") {
            writer.uint32(18).string(message.channelId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryChannelRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            portId: (0, helpers_1.isSet)(object.portId) ? String(object.portId) : "",
            channelId: (0, helpers_1.isSet)(object.channelId) ? String(object.channelId) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryChannelRequest();
        message.portId = object.portId ?? "";
        message.channelId = object.channelId ?? "";
        return message;
    },
};
function createBaseQueryChannelResponse() {
    return {
        channel: undefined,
        proof: new Uint8Array(),
        proofHeight: undefined,
    };
}
exports.QueryChannelResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.channel !== undefined) {
            channel_1.Channel.encode(message.channel, writer.uint32(10).fork()).ldelim();
        }
        if (message.proof.length !== 0) {
            writer.uint32(18).bytes(message.proof);
        }
        if (message.proofHeight !== undefined) {
            client_1.Height.encode(message.proofHeight, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryChannelResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.channel = channel_1.Channel.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.proof = reader.bytes();
                    break;
                case 3:
                    message.proofHeight = client_1.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            channel: (0, helpers_1.isSet)(object.channel) ? channel_1.Channel.fromJSON(object.channel) : undefined,
            proof: (0, helpers_1.isSet)(object.proof) ? (0, helpers_1.bytesFromBase64)(object.proof) : new Uint8Array(),
            proofHeight: (0, helpers_1.isSet)(object.proofHeight) ? client_1.Height.fromJSON(object.proofHeight) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.channel !== undefined &&
            (obj.channel = message.channel ? channel_1.Channel.toJSON(message.channel) : undefined);
        message.proof !== undefined &&
            (obj.proof = (0, helpers_1.base64FromBytes)(message.proof !== undefined ? message.proof : new Uint8Array()));
        message.proofHeight !== undefined &&
            (obj.proofHeight = message.proofHeight ? client_1.Height.toJSON(message.proofHeight) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryChannelResponse();
        message.channel =
            object.channel !== undefined && object.channel !== null
                ? channel_1.Channel.fromPartial(object.channel)
                : undefined;
        message.proof = object.proof ?? new Uint8Array();
        message.proofHeight =
            object.proofHeight !== undefined && object.proofHeight !== null
                ? client_1.Height.fromPartial(object.proofHeight)
                : undefined;
        return message;
    },
};
function createBaseQueryChannelsRequest() {
    return {
        pagination: undefined,
    };
}
exports.QueryChannelsRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryChannelsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            pagination: (0, helpers_1.isSet)(object.pagination) ? pagination_1.PageRequest.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryChannelsRequest();
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryChannelsResponse() {
    return {
        channels: [],
        pagination: undefined,
        height: undefined,
    };
}
exports.QueryChannelsResponse = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.channels) {
            channel_1.IdentifiedChannel.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        if (message.height !== undefined) {
            client_1.Height.encode(message.height, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryChannelsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.channels.push(channel_1.IdentifiedChannel.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.height = client_1.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            channels: Array.isArray(object?.channels)
                ? object.channels.map((e) => channel_1.IdentifiedChannel.fromJSON(e))
                : [],
            pagination: (0, helpers_1.isSet)(object.pagination) ? pagination_1.PageResponse.fromJSON(object.pagination) : undefined,
            height: (0, helpers_1.isSet)(object.height) ? client_1.Height.fromJSON(object.height) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.channels) {
            obj.channels = message.channels.map((e) => (e ? channel_1.IdentifiedChannel.toJSON(e) : undefined));
        }
        else {
            obj.channels = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageResponse.toJSON(message.pagination) : undefined);
        message.height !== undefined && (obj.height = message.height ? client_1.Height.toJSON(message.height) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryChannelsResponse();
        message.channels = object.channels?.map((e) => channel_1.IdentifiedChannel.fromPartial(e)) || [];
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        message.height =
            object.height !== undefined && object.height !== null ? client_1.Height.fromPartial(object.height) : undefined;
        return message;
    },
};
function createBaseQueryConnectionChannelsRequest() {
    return {
        connection: "",
        pagination: undefined,
    };
}
exports.QueryConnectionChannelsRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.connection !== "") {
            writer.uint32(10).string(message.connection);
        }
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryConnectionChannelsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.connection = reader.string();
                    break;
                case 2:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            connection: (0, helpers_1.isSet)(object.connection) ? String(object.connection) : "",
            pagination: (0, helpers_1.isSet)(object.pagination) ? pagination_1.PageRequest.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.connection !== undefined && (obj.connection = message.connection);
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryConnectionChannelsRequest();
        message.connection = object.connection ?? "";
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryConnectionChannelsResponse() {
    return {
        channels: [],
        pagination: undefined,
        height: undefined,
    };
}
exports.QueryConnectionChannelsResponse = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.channels) {
            channel_1.IdentifiedChannel.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        if (message.height !== undefined) {
            client_1.Height.encode(message.height, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryConnectionChannelsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.channels.push(channel_1.IdentifiedChannel.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.height = client_1.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            channels: Array.isArray(object?.channels)
                ? object.channels.map((e) => channel_1.IdentifiedChannel.fromJSON(e))
                : [],
            pagination: (0, helpers_1.isSet)(object.pagination) ? pagination_1.PageResponse.fromJSON(object.pagination) : undefined,
            height: (0, helpers_1.isSet)(object.height) ? client_1.Height.fromJSON(object.height) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.channels) {
            obj.channels = message.channels.map((e) => (e ? channel_1.IdentifiedChannel.toJSON(e) : undefined));
        }
        else {
            obj.channels = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageResponse.toJSON(message.pagination) : undefined);
        message.height !== undefined && (obj.height = message.height ? client_1.Height.toJSON(message.height) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryConnectionChannelsResponse();
        message.channels = object.channels?.map((e) => channel_1.IdentifiedChannel.fromPartial(e)) || [];
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        message.height =
            object.height !== undefined && object.height !== null ? client_1.Height.fromPartial(object.height) : undefined;
        return message;
    },
};
function createBaseQueryChannelClientStateRequest() {
    return {
        portId: "",
        channelId: "",
    };
}
exports.QueryChannelClientStateRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.portId !== "") {
            writer.uint32(10).string(message.portId);
        }
        if (message.channelId !== "") {
            writer.uint32(18).string(message.channelId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryChannelClientStateRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            portId: (0, helpers_1.isSet)(object.portId) ? String(object.portId) : "",
            channelId: (0, helpers_1.isSet)(object.channelId) ? String(object.channelId) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryChannelClientStateRequest();
        message.portId = object.portId ?? "";
        message.channelId = object.channelId ?? "";
        return message;
    },
};
function createBaseQueryChannelClientStateResponse() {
    return {
        identifiedClientState: undefined,
        proof: new Uint8Array(),
        proofHeight: undefined,
    };
}
exports.QueryChannelClientStateResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.identifiedClientState !== undefined) {
            client_1.IdentifiedClientState.encode(message.identifiedClientState, writer.uint32(10).fork()).ldelim();
        }
        if (message.proof.length !== 0) {
            writer.uint32(18).bytes(message.proof);
        }
        if (message.proofHeight !== undefined) {
            client_1.Height.encode(message.proofHeight, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryChannelClientStateResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.identifiedClientState = client_1.IdentifiedClientState.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.proof = reader.bytes();
                    break;
                case 3:
                    message.proofHeight = client_1.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            identifiedClientState: (0, helpers_1.isSet)(object.identifiedClientState)
                ? client_1.IdentifiedClientState.fromJSON(object.identifiedClientState)
                : undefined,
            proof: (0, helpers_1.isSet)(object.proof) ? (0, helpers_1.bytesFromBase64)(object.proof) : new Uint8Array(),
            proofHeight: (0, helpers_1.isSet)(object.proofHeight) ? client_1.Height.fromJSON(object.proofHeight) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.identifiedClientState !== undefined &&
            (obj.identifiedClientState = message.identifiedClientState
                ? client_1.IdentifiedClientState.toJSON(message.identifiedClientState)
                : undefined);
        message.proof !== undefined &&
            (obj.proof = (0, helpers_1.base64FromBytes)(message.proof !== undefined ? message.proof : new Uint8Array()));
        message.proofHeight !== undefined &&
            (obj.proofHeight = message.proofHeight ? client_1.Height.toJSON(message.proofHeight) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryChannelClientStateResponse();
        message.identifiedClientState =
            object.identifiedClientState !== undefined && object.identifiedClientState !== null
                ? client_1.IdentifiedClientState.fromPartial(object.identifiedClientState)
                : undefined;
        message.proof = object.proof ?? new Uint8Array();
        message.proofHeight =
            object.proofHeight !== undefined && object.proofHeight !== null
                ? client_1.Height.fromPartial(object.proofHeight)
                : undefined;
        return message;
    },
};
function createBaseQueryChannelConsensusStateRequest() {
    return {
        portId: "",
        channelId: "",
        revisionNumber: helpers_1.Long.UZERO,
        revisionHeight: helpers_1.Long.UZERO,
    };
}
exports.QueryChannelConsensusStateRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.portId !== "") {
            writer.uint32(10).string(message.portId);
        }
        if (message.channelId !== "") {
            writer.uint32(18).string(message.channelId);
        }
        if (!message.revisionNumber.isZero()) {
            writer.uint32(24).uint64(message.revisionNumber);
        }
        if (!message.revisionHeight.isZero()) {
            writer.uint32(32).uint64(message.revisionHeight);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryChannelConsensusStateRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                case 3:
                    message.revisionNumber = reader.uint64();
                    break;
                case 4:
                    message.revisionHeight = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            portId: (0, helpers_1.isSet)(object.portId) ? String(object.portId) : "",
            channelId: (0, helpers_1.isSet)(object.channelId) ? String(object.channelId) : "",
            revisionNumber: (0, helpers_1.isSet)(object.revisionNumber) ? helpers_1.Long.fromValue(object.revisionNumber) : helpers_1.Long.UZERO,
            revisionHeight: (0, helpers_1.isSet)(object.revisionHeight) ? helpers_1.Long.fromValue(object.revisionHeight) : helpers_1.Long.UZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        message.revisionNumber !== undefined &&
            (obj.revisionNumber = (message.revisionNumber || helpers_1.Long.UZERO).toString());
        message.revisionHeight !== undefined &&
            (obj.revisionHeight = (message.revisionHeight || helpers_1.Long.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryChannelConsensusStateRequest();
        message.portId = object.portId ?? "";
        message.channelId = object.channelId ?? "";
        message.revisionNumber =
            object.revisionNumber !== undefined && object.revisionNumber !== null
                ? helpers_1.Long.fromValue(object.revisionNumber)
                : helpers_1.Long.UZERO;
        message.revisionHeight =
            object.revisionHeight !== undefined && object.revisionHeight !== null
                ? helpers_1.Long.fromValue(object.revisionHeight)
                : helpers_1.Long.UZERO;
        return message;
    },
};
function createBaseQueryChannelConsensusStateResponse() {
    return {
        consensusState: undefined,
        clientId: "",
        proof: new Uint8Array(),
        proofHeight: undefined,
    };
}
exports.QueryChannelConsensusStateResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.consensusState !== undefined) {
            any_1.Any.encode(message.consensusState, writer.uint32(10).fork()).ldelim();
        }
        if (message.clientId !== "") {
            writer.uint32(18).string(message.clientId);
        }
        if (message.proof.length !== 0) {
            writer.uint32(26).bytes(message.proof);
        }
        if (message.proofHeight !== undefined) {
            client_1.Height.encode(message.proofHeight, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryChannelConsensusStateResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.consensusState = any_1.Any.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.clientId = reader.string();
                    break;
                case 3:
                    message.proof = reader.bytes();
                    break;
                case 4:
                    message.proofHeight = client_1.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            consensusState: (0, helpers_1.isSet)(object.consensusState) ? any_1.Any.fromJSON(object.consensusState) : undefined,
            clientId: (0, helpers_1.isSet)(object.clientId) ? String(object.clientId) : "",
            proof: (0, helpers_1.isSet)(object.proof) ? (0, helpers_1.bytesFromBase64)(object.proof) : new Uint8Array(),
            proofHeight: (0, helpers_1.isSet)(object.proofHeight) ? client_1.Height.fromJSON(object.proofHeight) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.consensusState !== undefined &&
            (obj.consensusState = message.consensusState ? any_1.Any.toJSON(message.consensusState) : undefined);
        message.clientId !== undefined && (obj.clientId = message.clientId);
        message.proof !== undefined &&
            (obj.proof = (0, helpers_1.base64FromBytes)(message.proof !== undefined ? message.proof : new Uint8Array()));
        message.proofHeight !== undefined &&
            (obj.proofHeight = message.proofHeight ? client_1.Height.toJSON(message.proofHeight) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryChannelConsensusStateResponse();
        message.consensusState =
            object.consensusState !== undefined && object.consensusState !== null
                ? any_1.Any.fromPartial(object.consensusState)
                : undefined;
        message.clientId = object.clientId ?? "";
        message.proof = object.proof ?? new Uint8Array();
        message.proofHeight =
            object.proofHeight !== undefined && object.proofHeight !== null
                ? client_1.Height.fromPartial(object.proofHeight)
                : undefined;
        return message;
    },
};
function createBaseQueryPacketCommitmentRequest() {
    return {
        portId: "",
        channelId: "",
        sequence: helpers_1.Long.UZERO,
    };
}
exports.QueryPacketCommitmentRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.portId !== "") {
            writer.uint32(10).string(message.portId);
        }
        if (message.channelId !== "") {
            writer.uint32(18).string(message.channelId);
        }
        if (!message.sequence.isZero()) {
            writer.uint32(24).uint64(message.sequence);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryPacketCommitmentRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                case 3:
                    message.sequence = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            portId: (0, helpers_1.isSet)(object.portId) ? String(object.portId) : "",
            channelId: (0, helpers_1.isSet)(object.channelId) ? String(object.channelId) : "",
            sequence: (0, helpers_1.isSet)(object.sequence) ? helpers_1.Long.fromValue(object.sequence) : helpers_1.Long.UZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        message.sequence !== undefined && (obj.sequence = (message.sequence || helpers_1.Long.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryPacketCommitmentRequest();
        message.portId = object.portId ?? "";
        message.channelId = object.channelId ?? "";
        message.sequence =
            object.sequence !== undefined && object.sequence !== null
                ? helpers_1.Long.fromValue(object.sequence)
                : helpers_1.Long.UZERO;
        return message;
    },
};
function createBaseQueryPacketCommitmentResponse() {
    return {
        commitment: new Uint8Array(),
        proof: new Uint8Array(),
        proofHeight: undefined,
    };
}
exports.QueryPacketCommitmentResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.commitment.length !== 0) {
            writer.uint32(10).bytes(message.commitment);
        }
        if (message.proof.length !== 0) {
            writer.uint32(18).bytes(message.proof);
        }
        if (message.proofHeight !== undefined) {
            client_1.Height.encode(message.proofHeight, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryPacketCommitmentResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.commitment = reader.bytes();
                    break;
                case 2:
                    message.proof = reader.bytes();
                    break;
                case 3:
                    message.proofHeight = client_1.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            commitment: (0, helpers_1.isSet)(object.commitment) ? (0, helpers_1.bytesFromBase64)(object.commitment) : new Uint8Array(),
            proof: (0, helpers_1.isSet)(object.proof) ? (0, helpers_1.bytesFromBase64)(object.proof) : new Uint8Array(),
            proofHeight: (0, helpers_1.isSet)(object.proofHeight) ? client_1.Height.fromJSON(object.proofHeight) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.commitment !== undefined &&
            (obj.commitment = (0, helpers_1.base64FromBytes)(message.commitment !== undefined ? message.commitment : new Uint8Array()));
        message.proof !== undefined &&
            (obj.proof = (0, helpers_1.base64FromBytes)(message.proof !== undefined ? message.proof : new Uint8Array()));
        message.proofHeight !== undefined &&
            (obj.proofHeight = message.proofHeight ? client_1.Height.toJSON(message.proofHeight) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryPacketCommitmentResponse();
        message.commitment = object.commitment ?? new Uint8Array();
        message.proof = object.proof ?? new Uint8Array();
        message.proofHeight =
            object.proofHeight !== undefined && object.proofHeight !== null
                ? client_1.Height.fromPartial(object.proofHeight)
                : undefined;
        return message;
    },
};
function createBaseQueryPacketCommitmentsRequest() {
    return {
        portId: "",
        channelId: "",
        pagination: undefined,
    };
}
exports.QueryPacketCommitmentsRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.portId !== "") {
            writer.uint32(10).string(message.portId);
        }
        if (message.channelId !== "") {
            writer.uint32(18).string(message.channelId);
        }
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryPacketCommitmentsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                case 3:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            portId: (0, helpers_1.isSet)(object.portId) ? String(object.portId) : "",
            channelId: (0, helpers_1.isSet)(object.channelId) ? String(object.channelId) : "",
            pagination: (0, helpers_1.isSet)(object.pagination) ? pagination_1.PageRequest.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryPacketCommitmentsRequest();
        message.portId = object.portId ?? "";
        message.channelId = object.channelId ?? "";
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryPacketCommitmentsResponse() {
    return {
        commitments: [],
        pagination: undefined,
        height: undefined,
    };
}
exports.QueryPacketCommitmentsResponse = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.commitments) {
            channel_1.PacketState.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        if (message.height !== undefined) {
            client_1.Height.encode(message.height, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryPacketCommitmentsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.commitments.push(channel_1.PacketState.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.height = client_1.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            commitments: Array.isArray(object?.commitments)
                ? object.commitments.map((e) => channel_1.PacketState.fromJSON(e))
                : [],
            pagination: (0, helpers_1.isSet)(object.pagination) ? pagination_1.PageResponse.fromJSON(object.pagination) : undefined,
            height: (0, helpers_1.isSet)(object.height) ? client_1.Height.fromJSON(object.height) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.commitments) {
            obj.commitments = message.commitments.map((e) => (e ? channel_1.PacketState.toJSON(e) : undefined));
        }
        else {
            obj.commitments = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageResponse.toJSON(message.pagination) : undefined);
        message.height !== undefined && (obj.height = message.height ? client_1.Height.toJSON(message.height) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryPacketCommitmentsResponse();
        message.commitments = object.commitments?.map((e) => channel_1.PacketState.fromPartial(e)) || [];
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        message.height =
            object.height !== undefined && object.height !== null ? client_1.Height.fromPartial(object.height) : undefined;
        return message;
    },
};
function createBaseQueryPacketReceiptRequest() {
    return {
        portId: "",
        channelId: "",
        sequence: helpers_1.Long.UZERO,
    };
}
exports.QueryPacketReceiptRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.portId !== "") {
            writer.uint32(10).string(message.portId);
        }
        if (message.channelId !== "") {
            writer.uint32(18).string(message.channelId);
        }
        if (!message.sequence.isZero()) {
            writer.uint32(24).uint64(message.sequence);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryPacketReceiptRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                case 3:
                    message.sequence = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            portId: (0, helpers_1.isSet)(object.portId) ? String(object.portId) : "",
            channelId: (0, helpers_1.isSet)(object.channelId) ? String(object.channelId) : "",
            sequence: (0, helpers_1.isSet)(object.sequence) ? helpers_1.Long.fromValue(object.sequence) : helpers_1.Long.UZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        message.sequence !== undefined && (obj.sequence = (message.sequence || helpers_1.Long.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryPacketReceiptRequest();
        message.portId = object.portId ?? "";
        message.channelId = object.channelId ?? "";
        message.sequence =
            object.sequence !== undefined && object.sequence !== null
                ? helpers_1.Long.fromValue(object.sequence)
                : helpers_1.Long.UZERO;
        return message;
    },
};
function createBaseQueryPacketReceiptResponse() {
    return {
        received: false,
        proof: new Uint8Array(),
        proofHeight: undefined,
    };
}
exports.QueryPacketReceiptResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.received === true) {
            writer.uint32(16).bool(message.received);
        }
        if (message.proof.length !== 0) {
            writer.uint32(26).bytes(message.proof);
        }
        if (message.proofHeight !== undefined) {
            client_1.Height.encode(message.proofHeight, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryPacketReceiptResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 2:
                    message.received = reader.bool();
                    break;
                case 3:
                    message.proof = reader.bytes();
                    break;
                case 4:
                    message.proofHeight = client_1.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            received: (0, helpers_1.isSet)(object.received) ? Boolean(object.received) : false,
            proof: (0, helpers_1.isSet)(object.proof) ? (0, helpers_1.bytesFromBase64)(object.proof) : new Uint8Array(),
            proofHeight: (0, helpers_1.isSet)(object.proofHeight) ? client_1.Height.fromJSON(object.proofHeight) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.received !== undefined && (obj.received = message.received);
        message.proof !== undefined &&
            (obj.proof = (0, helpers_1.base64FromBytes)(message.proof !== undefined ? message.proof : new Uint8Array()));
        message.proofHeight !== undefined &&
            (obj.proofHeight = message.proofHeight ? client_1.Height.toJSON(message.proofHeight) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryPacketReceiptResponse();
        message.received = object.received ?? false;
        message.proof = object.proof ?? new Uint8Array();
        message.proofHeight =
            object.proofHeight !== undefined && object.proofHeight !== null
                ? client_1.Height.fromPartial(object.proofHeight)
                : undefined;
        return message;
    },
};
function createBaseQueryPacketAcknowledgementRequest() {
    return {
        portId: "",
        channelId: "",
        sequence: helpers_1.Long.UZERO,
    };
}
exports.QueryPacketAcknowledgementRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.portId !== "") {
            writer.uint32(10).string(message.portId);
        }
        if (message.channelId !== "") {
            writer.uint32(18).string(message.channelId);
        }
        if (!message.sequence.isZero()) {
            writer.uint32(24).uint64(message.sequence);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryPacketAcknowledgementRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                case 3:
                    message.sequence = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            portId: (0, helpers_1.isSet)(object.portId) ? String(object.portId) : "",
            channelId: (0, helpers_1.isSet)(object.channelId) ? String(object.channelId) : "",
            sequence: (0, helpers_1.isSet)(object.sequence) ? helpers_1.Long.fromValue(object.sequence) : helpers_1.Long.UZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        message.sequence !== undefined && (obj.sequence = (message.sequence || helpers_1.Long.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryPacketAcknowledgementRequest();
        message.portId = object.portId ?? "";
        message.channelId = object.channelId ?? "";
        message.sequence =
            object.sequence !== undefined && object.sequence !== null
                ? helpers_1.Long.fromValue(object.sequence)
                : helpers_1.Long.UZERO;
        return message;
    },
};
function createBaseQueryPacketAcknowledgementResponse() {
    return {
        acknowledgement: new Uint8Array(),
        proof: new Uint8Array(),
        proofHeight: undefined,
    };
}
exports.QueryPacketAcknowledgementResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.acknowledgement.length !== 0) {
            writer.uint32(10).bytes(message.acknowledgement);
        }
        if (message.proof.length !== 0) {
            writer.uint32(18).bytes(message.proof);
        }
        if (message.proofHeight !== undefined) {
            client_1.Height.encode(message.proofHeight, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryPacketAcknowledgementResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.acknowledgement = reader.bytes();
                    break;
                case 2:
                    message.proof = reader.bytes();
                    break;
                case 3:
                    message.proofHeight = client_1.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            acknowledgement: (0, helpers_1.isSet)(object.acknowledgement)
                ? (0, helpers_1.bytesFromBase64)(object.acknowledgement)
                : new Uint8Array(),
            proof: (0, helpers_1.isSet)(object.proof) ? (0, helpers_1.bytesFromBase64)(object.proof) : new Uint8Array(),
            proofHeight: (0, helpers_1.isSet)(object.proofHeight) ? client_1.Height.fromJSON(object.proofHeight) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.acknowledgement !== undefined &&
            (obj.acknowledgement = (0, helpers_1.base64FromBytes)(message.acknowledgement !== undefined ? message.acknowledgement : new Uint8Array()));
        message.proof !== undefined &&
            (obj.proof = (0, helpers_1.base64FromBytes)(message.proof !== undefined ? message.proof : new Uint8Array()));
        message.proofHeight !== undefined &&
            (obj.proofHeight = message.proofHeight ? client_1.Height.toJSON(message.proofHeight) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryPacketAcknowledgementResponse();
        message.acknowledgement = object.acknowledgement ?? new Uint8Array();
        message.proof = object.proof ?? new Uint8Array();
        message.proofHeight =
            object.proofHeight !== undefined && object.proofHeight !== null
                ? client_1.Height.fromPartial(object.proofHeight)
                : undefined;
        return message;
    },
};
function createBaseQueryPacketAcknowledgementsRequest() {
    return {
        portId: "",
        channelId: "",
        pagination: undefined,
        packetCommitmentSequences: [],
    };
}
exports.QueryPacketAcknowledgementsRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.portId !== "") {
            writer.uint32(10).string(message.portId);
        }
        if (message.channelId !== "") {
            writer.uint32(18).string(message.channelId);
        }
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(26).fork()).ldelim();
        }
        writer.uint32(34).fork();
        for (const v of message.packetCommitmentSequences) {
            writer.uint64(v);
        }
        writer.ldelim();
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryPacketAcknowledgementsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                case 3:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                case 4:
                    if ((tag & 7) === 2) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.packetCommitmentSequences.push(reader.uint64());
                        }
                    }
                    else {
                        message.packetCommitmentSequences.push(reader.uint64());
                    }
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            portId: (0, helpers_1.isSet)(object.portId) ? String(object.portId) : "",
            channelId: (0, helpers_1.isSet)(object.channelId) ? String(object.channelId) : "",
            pagination: (0, helpers_1.isSet)(object.pagination) ? pagination_1.PageRequest.fromJSON(object.pagination) : undefined,
            packetCommitmentSequences: Array.isArray(object?.packetCommitmentSequences)
                ? object.packetCommitmentSequences.map((e) => helpers_1.Long.fromValue(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageRequest.toJSON(message.pagination) : undefined);
        if (message.packetCommitmentSequences) {
            obj.packetCommitmentSequences = message.packetCommitmentSequences.map((e) => (e || helpers_1.Long.UZERO).toString());
        }
        else {
            obj.packetCommitmentSequences = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryPacketAcknowledgementsRequest();
        message.portId = object.portId ?? "";
        message.channelId = object.channelId ?? "";
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        message.packetCommitmentSequences = object.packetCommitmentSequences?.map((e) => helpers_1.Long.fromValue(e)) || [];
        return message;
    },
};
function createBaseQueryPacketAcknowledgementsResponse() {
    return {
        acknowledgements: [],
        pagination: undefined,
        height: undefined,
    };
}
exports.QueryPacketAcknowledgementsResponse = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.acknowledgements) {
            channel_1.PacketState.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        if (message.height !== undefined) {
            client_1.Height.encode(message.height, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryPacketAcknowledgementsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.acknowledgements.push(channel_1.PacketState.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.height = client_1.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            acknowledgements: Array.isArray(object?.acknowledgements)
                ? object.acknowledgements.map((e) => channel_1.PacketState.fromJSON(e))
                : [],
            pagination: (0, helpers_1.isSet)(object.pagination) ? pagination_1.PageResponse.fromJSON(object.pagination) : undefined,
            height: (0, helpers_1.isSet)(object.height) ? client_1.Height.fromJSON(object.height) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.acknowledgements) {
            obj.acknowledgements = message.acknowledgements.map((e) => (e ? channel_1.PacketState.toJSON(e) : undefined));
        }
        else {
            obj.acknowledgements = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageResponse.toJSON(message.pagination) : undefined);
        message.height !== undefined && (obj.height = message.height ? client_1.Height.toJSON(message.height) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryPacketAcknowledgementsResponse();
        message.acknowledgements = object.acknowledgements?.map((e) => channel_1.PacketState.fromPartial(e)) || [];
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        message.height =
            object.height !== undefined && object.height !== null ? client_1.Height.fromPartial(object.height) : undefined;
        return message;
    },
};
function createBaseQueryUnreceivedPacketsRequest() {
    return {
        portId: "",
        channelId: "",
        packetCommitmentSequences: [],
    };
}
exports.QueryUnreceivedPacketsRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.portId !== "") {
            writer.uint32(10).string(message.portId);
        }
        if (message.channelId !== "") {
            writer.uint32(18).string(message.channelId);
        }
        writer.uint32(26).fork();
        for (const v of message.packetCommitmentSequences) {
            writer.uint64(v);
        }
        writer.ldelim();
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryUnreceivedPacketsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                case 3:
                    if ((tag & 7) === 2) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.packetCommitmentSequences.push(reader.uint64());
                        }
                    }
                    else {
                        message.packetCommitmentSequences.push(reader.uint64());
                    }
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            portId: (0, helpers_1.isSet)(object.portId) ? String(object.portId) : "",
            channelId: (0, helpers_1.isSet)(object.channelId) ? String(object.channelId) : "",
            packetCommitmentSequences: Array.isArray(object?.packetCommitmentSequences)
                ? object.packetCommitmentSequences.map((e) => helpers_1.Long.fromValue(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        if (message.packetCommitmentSequences) {
            obj.packetCommitmentSequences = message.packetCommitmentSequences.map((e) => (e || helpers_1.Long.UZERO).toString());
        }
        else {
            obj.packetCommitmentSequences = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryUnreceivedPacketsRequest();
        message.portId = object.portId ?? "";
        message.channelId = object.channelId ?? "";
        message.packetCommitmentSequences = object.packetCommitmentSequences?.map((e) => helpers_1.Long.fromValue(e)) || [];
        return message;
    },
};
function createBaseQueryUnreceivedPacketsResponse() {
    return {
        sequences: [],
        height: undefined,
    };
}
exports.QueryUnreceivedPacketsResponse = {
    encode(message, writer = _m0.Writer.create()) {
        writer.uint32(10).fork();
        for (const v of message.sequences) {
            writer.uint64(v);
        }
        writer.ldelim();
        if (message.height !== undefined) {
            client_1.Height.encode(message.height, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryUnreceivedPacketsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if ((tag & 7) === 2) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.sequences.push(reader.uint64());
                        }
                    }
                    else {
                        message.sequences.push(reader.uint64());
                    }
                    break;
                case 2:
                    message.height = client_1.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            sequences: Array.isArray(object?.sequences) ? object.sequences.map((e) => helpers_1.Long.fromValue(e)) : [],
            height: (0, helpers_1.isSet)(object.height) ? client_1.Height.fromJSON(object.height) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.sequences) {
            obj.sequences = message.sequences.map((e) => (e || helpers_1.Long.UZERO).toString());
        }
        else {
            obj.sequences = [];
        }
        message.height !== undefined && (obj.height = message.height ? client_1.Height.toJSON(message.height) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryUnreceivedPacketsResponse();
        message.sequences = object.sequences?.map((e) => helpers_1.Long.fromValue(e)) || [];
        message.height =
            object.height !== undefined && object.height !== null ? client_1.Height.fromPartial(object.height) : undefined;
        return message;
    },
};
function createBaseQueryUnreceivedAcksRequest() {
    return {
        portId: "",
        channelId: "",
        packetAckSequences: [],
    };
}
exports.QueryUnreceivedAcksRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.portId !== "") {
            writer.uint32(10).string(message.portId);
        }
        if (message.channelId !== "") {
            writer.uint32(18).string(message.channelId);
        }
        writer.uint32(26).fork();
        for (const v of message.packetAckSequences) {
            writer.uint64(v);
        }
        writer.ldelim();
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryUnreceivedAcksRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                case 3:
                    if ((tag & 7) === 2) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.packetAckSequences.push(reader.uint64());
                        }
                    }
                    else {
                        message.packetAckSequences.push(reader.uint64());
                    }
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            portId: (0, helpers_1.isSet)(object.portId) ? String(object.portId) : "",
            channelId: (0, helpers_1.isSet)(object.channelId) ? String(object.channelId) : "",
            packetAckSequences: Array.isArray(object?.packetAckSequences)
                ? object.packetAckSequences.map((e) => helpers_1.Long.fromValue(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        if (message.packetAckSequences) {
            obj.packetAckSequences = message.packetAckSequences.map((e) => (e || helpers_1.Long.UZERO).toString());
        }
        else {
            obj.packetAckSequences = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryUnreceivedAcksRequest();
        message.portId = object.portId ?? "";
        message.channelId = object.channelId ?? "";
        message.packetAckSequences = object.packetAckSequences?.map((e) => helpers_1.Long.fromValue(e)) || [];
        return message;
    },
};
function createBaseQueryUnreceivedAcksResponse() {
    return {
        sequences: [],
        height: undefined,
    };
}
exports.QueryUnreceivedAcksResponse = {
    encode(message, writer = _m0.Writer.create()) {
        writer.uint32(10).fork();
        for (const v of message.sequences) {
            writer.uint64(v);
        }
        writer.ldelim();
        if (message.height !== undefined) {
            client_1.Height.encode(message.height, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryUnreceivedAcksResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if ((tag & 7) === 2) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.sequences.push(reader.uint64());
                        }
                    }
                    else {
                        message.sequences.push(reader.uint64());
                    }
                    break;
                case 2:
                    message.height = client_1.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            sequences: Array.isArray(object?.sequences) ? object.sequences.map((e) => helpers_1.Long.fromValue(e)) : [],
            height: (0, helpers_1.isSet)(object.height) ? client_1.Height.fromJSON(object.height) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.sequences) {
            obj.sequences = message.sequences.map((e) => (e || helpers_1.Long.UZERO).toString());
        }
        else {
            obj.sequences = [];
        }
        message.height !== undefined && (obj.height = message.height ? client_1.Height.toJSON(message.height) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryUnreceivedAcksResponse();
        message.sequences = object.sequences?.map((e) => helpers_1.Long.fromValue(e)) || [];
        message.height =
            object.height !== undefined && object.height !== null ? client_1.Height.fromPartial(object.height) : undefined;
        return message;
    },
};
function createBaseQueryNextSequenceReceiveRequest() {
    return {
        portId: "",
        channelId: "",
    };
}
exports.QueryNextSequenceReceiveRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.portId !== "") {
            writer.uint32(10).string(message.portId);
        }
        if (message.channelId !== "") {
            writer.uint32(18).string(message.channelId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryNextSequenceReceiveRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            portId: (0, helpers_1.isSet)(object.portId) ? String(object.portId) : "",
            channelId: (0, helpers_1.isSet)(object.channelId) ? String(object.channelId) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryNextSequenceReceiveRequest();
        message.portId = object.portId ?? "";
        message.channelId = object.channelId ?? "";
        return message;
    },
};
function createBaseQueryNextSequenceReceiveResponse() {
    return {
        nextSequenceReceive: helpers_1.Long.UZERO,
        proof: new Uint8Array(),
        proofHeight: undefined,
    };
}
exports.QueryNextSequenceReceiveResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (!message.nextSequenceReceive.isZero()) {
            writer.uint32(8).uint64(message.nextSequenceReceive);
        }
        if (message.proof.length !== 0) {
            writer.uint32(18).bytes(message.proof);
        }
        if (message.proofHeight !== undefined) {
            client_1.Height.encode(message.proofHeight, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryNextSequenceReceiveResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.nextSequenceReceive = reader.uint64();
                    break;
                case 2:
                    message.proof = reader.bytes();
                    break;
                case 3:
                    message.proofHeight = client_1.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            nextSequenceReceive: (0, helpers_1.isSet)(object.nextSequenceReceive)
                ? helpers_1.Long.fromValue(object.nextSequenceReceive)
                : helpers_1.Long.UZERO,
            proof: (0, helpers_1.isSet)(object.proof) ? (0, helpers_1.bytesFromBase64)(object.proof) : new Uint8Array(),
            proofHeight: (0, helpers_1.isSet)(object.proofHeight) ? client_1.Height.fromJSON(object.proofHeight) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.nextSequenceReceive !== undefined &&
            (obj.nextSequenceReceive = (message.nextSequenceReceive || helpers_1.Long.UZERO).toString());
        message.proof !== undefined &&
            (obj.proof = (0, helpers_1.base64FromBytes)(message.proof !== undefined ? message.proof : new Uint8Array()));
        message.proofHeight !== undefined &&
            (obj.proofHeight = message.proofHeight ? client_1.Height.toJSON(message.proofHeight) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryNextSequenceReceiveResponse();
        message.nextSequenceReceive =
            object.nextSequenceReceive !== undefined && object.nextSequenceReceive !== null
                ? helpers_1.Long.fromValue(object.nextSequenceReceive)
                : helpers_1.Long.UZERO;
        message.proof = object.proof ?? new Uint8Array();
        message.proofHeight =
            object.proofHeight !== undefined && object.proofHeight !== null
                ? client_1.Height.fromPartial(object.proofHeight)
                : undefined;
        return message;
    },
};
class QueryClientImpl {
    constructor(rpc) {
        this.rpc = rpc;
        this.Channel = this.Channel.bind(this);
        this.Channels = this.Channels.bind(this);
        this.ConnectionChannels = this.ConnectionChannels.bind(this);
        this.ChannelClientState = this.ChannelClientState.bind(this);
        this.ChannelConsensusState = this.ChannelConsensusState.bind(this);
        this.PacketCommitment = this.PacketCommitment.bind(this);
        this.PacketCommitments = this.PacketCommitments.bind(this);
        this.PacketReceipt = this.PacketReceipt.bind(this);
        this.PacketAcknowledgement = this.PacketAcknowledgement.bind(this);
        this.PacketAcknowledgements = this.PacketAcknowledgements.bind(this);
        this.UnreceivedPackets = this.UnreceivedPackets.bind(this);
        this.UnreceivedAcks = this.UnreceivedAcks.bind(this);
        this.NextSequenceReceive = this.NextSequenceReceive.bind(this);
    }
    Channel(request) {
        const data = exports.QueryChannelRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Query", "Channel", data);
        return promise.then((data) => exports.QueryChannelResponse.decode(new _m0.Reader(data)));
    }
    Channels(request = {
        pagination: undefined,
    }) {
        const data = exports.QueryChannelsRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Query", "Channels", data);
        return promise.then((data) => exports.QueryChannelsResponse.decode(new _m0.Reader(data)));
    }
    ConnectionChannels(request) {
        const data = exports.QueryConnectionChannelsRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Query", "ConnectionChannels", data);
        return promise.then((data) => exports.QueryConnectionChannelsResponse.decode(new _m0.Reader(data)));
    }
    ChannelClientState(request) {
        const data = exports.QueryChannelClientStateRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Query", "ChannelClientState", data);
        return promise.then((data) => exports.QueryChannelClientStateResponse.decode(new _m0.Reader(data)));
    }
    ChannelConsensusState(request) {
        const data = exports.QueryChannelConsensusStateRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Query", "ChannelConsensusState", data);
        return promise.then((data) => exports.QueryChannelConsensusStateResponse.decode(new _m0.Reader(data)));
    }
    PacketCommitment(request) {
        const data = exports.QueryPacketCommitmentRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Query", "PacketCommitment", data);
        return promise.then((data) => exports.QueryPacketCommitmentResponse.decode(new _m0.Reader(data)));
    }
    PacketCommitments(request) {
        const data = exports.QueryPacketCommitmentsRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Query", "PacketCommitments", data);
        return promise.then((data) => exports.QueryPacketCommitmentsResponse.decode(new _m0.Reader(data)));
    }
    PacketReceipt(request) {
        const data = exports.QueryPacketReceiptRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Query", "PacketReceipt", data);
        return promise.then((data) => exports.QueryPacketReceiptResponse.decode(new _m0.Reader(data)));
    }
    PacketAcknowledgement(request) {
        const data = exports.QueryPacketAcknowledgementRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Query", "PacketAcknowledgement", data);
        return promise.then((data) => exports.QueryPacketAcknowledgementResponse.decode(new _m0.Reader(data)));
    }
    PacketAcknowledgements(request) {
        const data = exports.QueryPacketAcknowledgementsRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Query", "PacketAcknowledgements", data);
        return promise.then((data) => exports.QueryPacketAcknowledgementsResponse.decode(new _m0.Reader(data)));
    }
    UnreceivedPackets(request) {
        const data = exports.QueryUnreceivedPacketsRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Query", "UnreceivedPackets", data);
        return promise.then((data) => exports.QueryUnreceivedPacketsResponse.decode(new _m0.Reader(data)));
    }
    UnreceivedAcks(request) {
        const data = exports.QueryUnreceivedAcksRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Query", "UnreceivedAcks", data);
        return promise.then((data) => exports.QueryUnreceivedAcksResponse.decode(new _m0.Reader(data)));
    }
    NextSequenceReceive(request) {
        const data = exports.QueryNextSequenceReceiveRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Query", "NextSequenceReceive", data);
        return promise.then((data) => exports.QueryNextSequenceReceiveResponse.decode(new _m0.Reader(data)));
    }
}
exports.QueryClientImpl = QueryClientImpl;
//# sourceMappingURL=query.js.map

/***/ }),

/***/ 11104:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MsgClientImpl = exports.MsgAcknowledgementResponse = exports.MsgAcknowledgement = exports.MsgTimeoutOnCloseResponse = exports.MsgTimeoutOnClose = exports.MsgTimeoutResponse = exports.MsgTimeout = exports.MsgRecvPacketResponse = exports.MsgRecvPacket = exports.MsgChannelCloseConfirmResponse = exports.MsgChannelCloseConfirm = exports.MsgChannelCloseInitResponse = exports.MsgChannelCloseInit = exports.MsgChannelOpenConfirmResponse = exports.MsgChannelOpenConfirm = exports.MsgChannelOpenAckResponse = exports.MsgChannelOpenAck = exports.MsgChannelOpenTryResponse = exports.MsgChannelOpenTry = exports.MsgChannelOpenInitResponse = exports.MsgChannelOpenInit = exports.responseResultTypeToJSON = exports.responseResultTypeFromJSON = exports.ResponseResultType = exports.protobufPackage = void 0;
/* eslint-disable */
const channel_1 = __webpack_require__(24007);
const client_1 = __webpack_require__(30085);
const helpers_1 = __webpack_require__(92654);
const _m0 = __importStar(__webpack_require__(62100));
exports.protobufPackage = "ibc.core.channel.v1";
/** ResponseResultType defines the possible outcomes of the execution of a message */
var ResponseResultType;
(function (ResponseResultType) {
    /** RESPONSE_RESULT_TYPE_UNSPECIFIED - Default zero value enumeration */
    ResponseResultType[ResponseResultType["RESPONSE_RESULT_TYPE_UNSPECIFIED"] = 0] = "RESPONSE_RESULT_TYPE_UNSPECIFIED";
    /** RESPONSE_RESULT_TYPE_NOOP - The message did not call the IBC application callbacks (because, for example, the packet had already been relayed) */
    ResponseResultType[ResponseResultType["RESPONSE_RESULT_TYPE_NOOP"] = 1] = "RESPONSE_RESULT_TYPE_NOOP";
    /** RESPONSE_RESULT_TYPE_SUCCESS - The message was executed successfully */
    ResponseResultType[ResponseResultType["RESPONSE_RESULT_TYPE_SUCCESS"] = 2] = "RESPONSE_RESULT_TYPE_SUCCESS";
    ResponseResultType[ResponseResultType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(ResponseResultType = exports.ResponseResultType || (exports.ResponseResultType = {}));
function responseResultTypeFromJSON(object) {
    switch (object) {
        case 0:
        case "RESPONSE_RESULT_TYPE_UNSPECIFIED":
            return ResponseResultType.RESPONSE_RESULT_TYPE_UNSPECIFIED;
        case 1:
        case "RESPONSE_RESULT_TYPE_NOOP":
            return ResponseResultType.RESPONSE_RESULT_TYPE_NOOP;
        case 2:
        case "RESPONSE_RESULT_TYPE_SUCCESS":
            return ResponseResultType.RESPONSE_RESULT_TYPE_SUCCESS;
        case -1:
        case "UNRECOGNIZED":
        default:
            return ResponseResultType.UNRECOGNIZED;
    }
}
exports.responseResultTypeFromJSON = responseResultTypeFromJSON;
function responseResultTypeToJSON(object) {
    switch (object) {
        case ResponseResultType.RESPONSE_RESULT_TYPE_UNSPECIFIED:
            return "RESPONSE_RESULT_TYPE_UNSPECIFIED";
        case ResponseResultType.RESPONSE_RESULT_TYPE_NOOP:
            return "RESPONSE_RESULT_TYPE_NOOP";
        case ResponseResultType.RESPONSE_RESULT_TYPE_SUCCESS:
            return "RESPONSE_RESULT_TYPE_SUCCESS";
        case ResponseResultType.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.responseResultTypeToJSON = responseResultTypeToJSON;
function createBaseMsgChannelOpenInit() {
    return {
        portId: "",
        channel: undefined,
        signer: "",
    };
}
exports.MsgChannelOpenInit = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.portId !== "") {
            writer.uint32(10).string(message.portId);
        }
        if (message.channel !== undefined) {
            channel_1.Channel.encode(message.channel, writer.uint32(18).fork()).ldelim();
        }
        if (message.signer !== "") {
            writer.uint32(26).string(message.signer);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgChannelOpenInit();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channel = channel_1.Channel.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            portId: (0, helpers_1.isSet)(object.portId) ? String(object.portId) : "",
            channel: (0, helpers_1.isSet)(object.channel) ? channel_1.Channel.fromJSON(object.channel) : undefined,
            signer: (0, helpers_1.isSet)(object.signer) ? String(object.signer) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channel !== undefined &&
            (obj.channel = message.channel ? channel_1.Channel.toJSON(message.channel) : undefined);
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgChannelOpenInit();
        message.portId = object.portId ?? "";
        message.channel =
            object.channel !== undefined && object.channel !== null
                ? channel_1.Channel.fromPartial(object.channel)
                : undefined;
        message.signer = object.signer ?? "";
        return message;
    },
};
function createBaseMsgChannelOpenInitResponse() {
    return {
        channelId: "",
        version: "",
    };
}
exports.MsgChannelOpenInitResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.channelId !== "") {
            writer.uint32(10).string(message.channelId);
        }
        if (message.version !== "") {
            writer.uint32(18).string(message.version);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgChannelOpenInitResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.channelId = reader.string();
                    break;
                case 2:
                    message.version = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            channelId: (0, helpers_1.isSet)(object.channelId) ? String(object.channelId) : "",
            version: (0, helpers_1.isSet)(object.version) ? String(object.version) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.channelId !== undefined && (obj.channelId = message.channelId);
        message.version !== undefined && (obj.version = message.version);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgChannelOpenInitResponse();
        message.channelId = object.channelId ?? "";
        message.version = object.version ?? "";
        return message;
    },
};
function createBaseMsgChannelOpenTry() {
    return {
        portId: "",
        previousChannelId: "",
        channel: undefined,
        counterpartyVersion: "",
        proofInit: new Uint8Array(),
        proofHeight: undefined,
        signer: "",
    };
}
exports.MsgChannelOpenTry = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.portId !== "") {
            writer.uint32(10).string(message.portId);
        }
        if (message.previousChannelId !== "") {
            writer.uint32(18).string(message.previousChannelId);
        }
        if (message.channel !== undefined) {
            channel_1.Channel.encode(message.channel, writer.uint32(26).fork()).ldelim();
        }
        if (message.counterpartyVersion !== "") {
            writer.uint32(34).string(message.counterpartyVersion);
        }
        if (message.proofInit.length !== 0) {
            writer.uint32(42).bytes(message.proofInit);
        }
        if (message.proofHeight !== undefined) {
            client_1.Height.encode(message.proofHeight, writer.uint32(50).fork()).ldelim();
        }
        if (message.signer !== "") {
            writer.uint32(58).string(message.signer);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgChannelOpenTry();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.previousChannelId = reader.string();
                    break;
                case 3:
                    message.channel = channel_1.Channel.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.counterpartyVersion = reader.string();
                    break;
                case 5:
                    message.proofInit = reader.bytes();
                    break;
                case 6:
                    message.proofHeight = client_1.Height.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            portId: (0, helpers_1.isSet)(object.portId) ? String(object.portId) : "",
            previousChannelId: (0, helpers_1.isSet)(object.previousChannelId) ? String(object.previousChannelId) : "",
            channel: (0, helpers_1.isSet)(object.channel) ? channel_1.Channel.fromJSON(object.channel) : undefined,
            counterpartyVersion: (0, helpers_1.isSet)(object.counterpartyVersion) ? String(object.counterpartyVersion) : "",
            proofInit: (0, helpers_1.isSet)(object.proofInit) ? (0, helpers_1.bytesFromBase64)(object.proofInit) : new Uint8Array(),
            proofHeight: (0, helpers_1.isSet)(object.proofHeight) ? client_1.Height.fromJSON(object.proofHeight) : undefined,
            signer: (0, helpers_1.isSet)(object.signer) ? String(object.signer) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.previousChannelId !== undefined && (obj.previousChannelId = message.previousChannelId);
        message.channel !== undefined &&
            (obj.channel = message.channel ? channel_1.Channel.toJSON(message.channel) : undefined);
        message.counterpartyVersion !== undefined && (obj.counterpartyVersion = message.counterpartyVersion);
        message.proofInit !== undefined &&
            (obj.proofInit = (0, helpers_1.base64FromBytes)(message.proofInit !== undefined ? message.proofInit : new Uint8Array()));
        message.proofHeight !== undefined &&
            (obj.proofHeight = message.proofHeight ? client_1.Height.toJSON(message.proofHeight) : undefined);
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgChannelOpenTry();
        message.portId = object.portId ?? "";
        message.previousChannelId = object.previousChannelId ?? "";
        message.channel =
            object.channel !== undefined && object.channel !== null
                ? channel_1.Channel.fromPartial(object.channel)
                : undefined;
        message.counterpartyVersion = object.counterpartyVersion ?? "";
        message.proofInit = object.proofInit ?? new Uint8Array();
        message.proofHeight =
            object.proofHeight !== undefined && object.proofHeight !== null
                ? client_1.Height.fromPartial(object.proofHeight)
                : undefined;
        message.signer = object.signer ?? "";
        return message;
    },
};
function createBaseMsgChannelOpenTryResponse() {
    return {
        version: "",
    };
}
exports.MsgChannelOpenTryResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.version !== "") {
            writer.uint32(10).string(message.version);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgChannelOpenTryResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.version = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            version: (0, helpers_1.isSet)(object.version) ? String(object.version) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.version !== undefined && (obj.version = message.version);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgChannelOpenTryResponse();
        message.version = object.version ?? "";
        return message;
    },
};
function createBaseMsgChannelOpenAck() {
    return {
        portId: "",
        channelId: "",
        counterpartyChannelId: "",
        counterpartyVersion: "",
        proofTry: new Uint8Array(),
        proofHeight: undefined,
        signer: "",
    };
}
exports.MsgChannelOpenAck = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.portId !== "") {
            writer.uint32(10).string(message.portId);
        }
        if (message.channelId !== "") {
            writer.uint32(18).string(message.channelId);
        }
        if (message.counterpartyChannelId !== "") {
            writer.uint32(26).string(message.counterpartyChannelId);
        }
        if (message.counterpartyVersion !== "") {
            writer.uint32(34).string(message.counterpartyVersion);
        }
        if (message.proofTry.length !== 0) {
            writer.uint32(42).bytes(message.proofTry);
        }
        if (message.proofHeight !== undefined) {
            client_1.Height.encode(message.proofHeight, writer.uint32(50).fork()).ldelim();
        }
        if (message.signer !== "") {
            writer.uint32(58).string(message.signer);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgChannelOpenAck();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                case 3:
                    message.counterpartyChannelId = reader.string();
                    break;
                case 4:
                    message.counterpartyVersion = reader.string();
                    break;
                case 5:
                    message.proofTry = reader.bytes();
                    break;
                case 6:
                    message.proofHeight = client_1.Height.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            portId: (0, helpers_1.isSet)(object.portId) ? String(object.portId) : "",
            channelId: (0, helpers_1.isSet)(object.channelId) ? String(object.channelId) : "",
            counterpartyChannelId: (0, helpers_1.isSet)(object.counterpartyChannelId) ? String(object.counterpartyChannelId) : "",
            counterpartyVersion: (0, helpers_1.isSet)(object.counterpartyVersion) ? String(object.counterpartyVersion) : "",
            proofTry: (0, helpers_1.isSet)(object.proofTry) ? (0, helpers_1.bytesFromBase64)(object.proofTry) : new Uint8Array(),
            proofHeight: (0, helpers_1.isSet)(object.proofHeight) ? client_1.Height.fromJSON(object.proofHeight) : undefined,
            signer: (0, helpers_1.isSet)(object.signer) ? String(object.signer) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        message.counterpartyChannelId !== undefined &&
            (obj.counterpartyChannelId = message.counterpartyChannelId);
        message.counterpartyVersion !== undefined && (obj.counterpartyVersion = message.counterpartyVersion);
        message.proofTry !== undefined &&
            (obj.proofTry = (0, helpers_1.base64FromBytes)(message.proofTry !== undefined ? message.proofTry : new Uint8Array()));
        message.proofHeight !== undefined &&
            (obj.proofHeight = message.proofHeight ? client_1.Height.toJSON(message.proofHeight) : undefined);
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgChannelOpenAck();
        message.portId = object.portId ?? "";
        message.channelId = object.channelId ?? "";
        message.counterpartyChannelId = object.counterpartyChannelId ?? "";
        message.counterpartyVersion = object.counterpartyVersion ?? "";
        message.proofTry = object.proofTry ?? new Uint8Array();
        message.proofHeight =
            object.proofHeight !== undefined && object.proofHeight !== null
                ? client_1.Height.fromPartial(object.proofHeight)
                : undefined;
        message.signer = object.signer ?? "";
        return message;
    },
};
function createBaseMsgChannelOpenAckResponse() {
    return {};
}
exports.MsgChannelOpenAckResponse = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgChannelOpenAckResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgChannelOpenAckResponse();
        return message;
    },
};
function createBaseMsgChannelOpenConfirm() {
    return {
        portId: "",
        channelId: "",
        proofAck: new Uint8Array(),
        proofHeight: undefined,
        signer: "",
    };
}
exports.MsgChannelOpenConfirm = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.portId !== "") {
            writer.uint32(10).string(message.portId);
        }
        if (message.channelId !== "") {
            writer.uint32(18).string(message.channelId);
        }
        if (message.proofAck.length !== 0) {
            writer.uint32(26).bytes(message.proofAck);
        }
        if (message.proofHeight !== undefined) {
            client_1.Height.encode(message.proofHeight, writer.uint32(34).fork()).ldelim();
        }
        if (message.signer !== "") {
            writer.uint32(42).string(message.signer);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgChannelOpenConfirm();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                case 3:
                    message.proofAck = reader.bytes();
                    break;
                case 4:
                    message.proofHeight = client_1.Height.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            portId: (0, helpers_1.isSet)(object.portId) ? String(object.portId) : "",
            channelId: (0, helpers_1.isSet)(object.channelId) ? String(object.channelId) : "",
            proofAck: (0, helpers_1.isSet)(object.proofAck) ? (0, helpers_1.bytesFromBase64)(object.proofAck) : new Uint8Array(),
            proofHeight: (0, helpers_1.isSet)(object.proofHeight) ? client_1.Height.fromJSON(object.proofHeight) : undefined,
            signer: (0, helpers_1.isSet)(object.signer) ? String(object.signer) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        message.proofAck !== undefined &&
            (obj.proofAck = (0, helpers_1.base64FromBytes)(message.proofAck !== undefined ? message.proofAck : new Uint8Array()));
        message.proofHeight !== undefined &&
            (obj.proofHeight = message.proofHeight ? client_1.Height.toJSON(message.proofHeight) : undefined);
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgChannelOpenConfirm();
        message.portId = object.portId ?? "";
        message.channelId = object.channelId ?? "";
        message.proofAck = object.proofAck ?? new Uint8Array();
        message.proofHeight =
            object.proofHeight !== undefined && object.proofHeight !== null
                ? client_1.Height.fromPartial(object.proofHeight)
                : undefined;
        message.signer = object.signer ?? "";
        return message;
    },
};
function createBaseMsgChannelOpenConfirmResponse() {
    return {};
}
exports.MsgChannelOpenConfirmResponse = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgChannelOpenConfirmResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgChannelOpenConfirmResponse();
        return message;
    },
};
function createBaseMsgChannelCloseInit() {
    return {
        portId: "",
        channelId: "",
        signer: "",
    };
}
exports.MsgChannelCloseInit = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.portId !== "") {
            writer.uint32(10).string(message.portId);
        }
        if (message.channelId !== "") {
            writer.uint32(18).string(message.channelId);
        }
        if (message.signer !== "") {
            writer.uint32(26).string(message.signer);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgChannelCloseInit();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                case 3:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            portId: (0, helpers_1.isSet)(object.portId) ? String(object.portId) : "",
            channelId: (0, helpers_1.isSet)(object.channelId) ? String(object.channelId) : "",
            signer: (0, helpers_1.isSet)(object.signer) ? String(object.signer) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgChannelCloseInit();
        message.portId = object.portId ?? "";
        message.channelId = object.channelId ?? "";
        message.signer = object.signer ?? "";
        return message;
    },
};
function createBaseMsgChannelCloseInitResponse() {
    return {};
}
exports.MsgChannelCloseInitResponse = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgChannelCloseInitResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgChannelCloseInitResponse();
        return message;
    },
};
function createBaseMsgChannelCloseConfirm() {
    return {
        portId: "",
        channelId: "",
        proofInit: new Uint8Array(),
        proofHeight: undefined,
        signer: "",
    };
}
exports.MsgChannelCloseConfirm = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.portId !== "") {
            writer.uint32(10).string(message.portId);
        }
        if (message.channelId !== "") {
            writer.uint32(18).string(message.channelId);
        }
        if (message.proofInit.length !== 0) {
            writer.uint32(26).bytes(message.proofInit);
        }
        if (message.proofHeight !== undefined) {
            client_1.Height.encode(message.proofHeight, writer.uint32(34).fork()).ldelim();
        }
        if (message.signer !== "") {
            writer.uint32(42).string(message.signer);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgChannelCloseConfirm();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                case 3:
                    message.proofInit = reader.bytes();
                    break;
                case 4:
                    message.proofHeight = client_1.Height.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            portId: (0, helpers_1.isSet)(object.portId) ? String(object.portId) : "",
            channelId: (0, helpers_1.isSet)(object.channelId) ? String(object.channelId) : "",
            proofInit: (0, helpers_1.isSet)(object.proofInit) ? (0, helpers_1.bytesFromBase64)(object.proofInit) : new Uint8Array(),
            proofHeight: (0, helpers_1.isSet)(object.proofHeight) ? client_1.Height.fromJSON(object.proofHeight) : undefined,
            signer: (0, helpers_1.isSet)(object.signer) ? String(object.signer) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        message.proofInit !== undefined &&
            (obj.proofInit = (0, helpers_1.base64FromBytes)(message.proofInit !== undefined ? message.proofInit : new Uint8Array()));
        message.proofHeight !== undefined &&
            (obj.proofHeight = message.proofHeight ? client_1.Height.toJSON(message.proofHeight) : undefined);
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgChannelCloseConfirm();
        message.portId = object.portId ?? "";
        message.channelId = object.channelId ?? "";
        message.proofInit = object.proofInit ?? new Uint8Array();
        message.proofHeight =
            object.proofHeight !== undefined && object.proofHeight !== null
                ? client_1.Height.fromPartial(object.proofHeight)
                : undefined;
        message.signer = object.signer ?? "";
        return message;
    },
};
function createBaseMsgChannelCloseConfirmResponse() {
    return {};
}
exports.MsgChannelCloseConfirmResponse = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgChannelCloseConfirmResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgChannelCloseConfirmResponse();
        return message;
    },
};
function createBaseMsgRecvPacket() {
    return {
        packet: undefined,
        proofCommitment: new Uint8Array(),
        proofHeight: undefined,
        signer: "",
    };
}
exports.MsgRecvPacket = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.packet !== undefined) {
            channel_1.Packet.encode(message.packet, writer.uint32(10).fork()).ldelim();
        }
        if (message.proofCommitment.length !== 0) {
            writer.uint32(18).bytes(message.proofCommitment);
        }
        if (message.proofHeight !== undefined) {
            client_1.Height.encode(message.proofHeight, writer.uint32(26).fork()).ldelim();
        }
        if (message.signer !== "") {
            writer.uint32(34).string(message.signer);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgRecvPacket();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.packet = channel_1.Packet.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.proofCommitment = reader.bytes();
                    break;
                case 3:
                    message.proofHeight = client_1.Height.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            packet: (0, helpers_1.isSet)(object.packet) ? channel_1.Packet.fromJSON(object.packet) : undefined,
            proofCommitment: (0, helpers_1.isSet)(object.proofCommitment)
                ? (0, helpers_1.bytesFromBase64)(object.proofCommitment)
                : new Uint8Array(),
            proofHeight: (0, helpers_1.isSet)(object.proofHeight) ? client_1.Height.fromJSON(object.proofHeight) : undefined,
            signer: (0, helpers_1.isSet)(object.signer) ? String(object.signer) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.packet !== undefined && (obj.packet = message.packet ? channel_1.Packet.toJSON(message.packet) : undefined);
        message.proofCommitment !== undefined &&
            (obj.proofCommitment = (0, helpers_1.base64FromBytes)(message.proofCommitment !== undefined ? message.proofCommitment : new Uint8Array()));
        message.proofHeight !== undefined &&
            (obj.proofHeight = message.proofHeight ? client_1.Height.toJSON(message.proofHeight) : undefined);
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgRecvPacket();
        message.packet =
            object.packet !== undefined && object.packet !== null ? channel_1.Packet.fromPartial(object.packet) : undefined;
        message.proofCommitment = object.proofCommitment ?? new Uint8Array();
        message.proofHeight =
            object.proofHeight !== undefined && object.proofHeight !== null
                ? client_1.Height.fromPartial(object.proofHeight)
                : undefined;
        message.signer = object.signer ?? "";
        return message;
    },
};
function createBaseMsgRecvPacketResponse() {
    return {
        result: 0,
    };
}
exports.MsgRecvPacketResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.result !== 0) {
            writer.uint32(8).int32(message.result);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgRecvPacketResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.result = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            result: (0, helpers_1.isSet)(object.result) ? responseResultTypeFromJSON(object.result) : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        message.result !== undefined && (obj.result = responseResultTypeToJSON(message.result));
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgRecvPacketResponse();
        message.result = object.result ?? 0;
        return message;
    },
};
function createBaseMsgTimeout() {
    return {
        packet: undefined,
        proofUnreceived: new Uint8Array(),
        proofHeight: undefined,
        nextSequenceRecv: helpers_1.Long.UZERO,
        signer: "",
    };
}
exports.MsgTimeout = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.packet !== undefined) {
            channel_1.Packet.encode(message.packet, writer.uint32(10).fork()).ldelim();
        }
        if (message.proofUnreceived.length !== 0) {
            writer.uint32(18).bytes(message.proofUnreceived);
        }
        if (message.proofHeight !== undefined) {
            client_1.Height.encode(message.proofHeight, writer.uint32(26).fork()).ldelim();
        }
        if (!message.nextSequenceRecv.isZero()) {
            writer.uint32(32).uint64(message.nextSequenceRecv);
        }
        if (message.signer !== "") {
            writer.uint32(42).string(message.signer);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgTimeout();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.packet = channel_1.Packet.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.proofUnreceived = reader.bytes();
                    break;
                case 3:
                    message.proofHeight = client_1.Height.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.nextSequenceRecv = reader.uint64();
                    break;
                case 5:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            packet: (0, helpers_1.isSet)(object.packet) ? channel_1.Packet.fromJSON(object.packet) : undefined,
            proofUnreceived: (0, helpers_1.isSet)(object.proofUnreceived)
                ? (0, helpers_1.bytesFromBase64)(object.proofUnreceived)
                : new Uint8Array(),
            proofHeight: (0, helpers_1.isSet)(object.proofHeight) ? client_1.Height.fromJSON(object.proofHeight) : undefined,
            nextSequenceRecv: (0, helpers_1.isSet)(object.nextSequenceRecv) ? helpers_1.Long.fromValue(object.nextSequenceRecv) : helpers_1.Long.UZERO,
            signer: (0, helpers_1.isSet)(object.signer) ? String(object.signer) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.packet !== undefined && (obj.packet = message.packet ? channel_1.Packet.toJSON(message.packet) : undefined);
        message.proofUnreceived !== undefined &&
            (obj.proofUnreceived = (0, helpers_1.base64FromBytes)(message.proofUnreceived !== undefined ? message.proofUnreceived : new Uint8Array()));
        message.proofHeight !== undefined &&
            (obj.proofHeight = message.proofHeight ? client_1.Height.toJSON(message.proofHeight) : undefined);
        message.nextSequenceRecv !== undefined &&
            (obj.nextSequenceRecv = (message.nextSequenceRecv || helpers_1.Long.UZERO).toString());
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgTimeout();
        message.packet =
            object.packet !== undefined && object.packet !== null ? channel_1.Packet.fromPartial(object.packet) : undefined;
        message.proofUnreceived = object.proofUnreceived ?? new Uint8Array();
        message.proofHeight =
            object.proofHeight !== undefined && object.proofHeight !== null
                ? client_1.Height.fromPartial(object.proofHeight)
                : undefined;
        message.nextSequenceRecv =
            object.nextSequenceRecv !== undefined && object.nextSequenceRecv !== null
                ? helpers_1.Long.fromValue(object.nextSequenceRecv)
                : helpers_1.Long.UZERO;
        message.signer = object.signer ?? "";
        return message;
    },
};
function createBaseMsgTimeoutResponse() {
    return {
        result: 0,
    };
}
exports.MsgTimeoutResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.result !== 0) {
            writer.uint32(8).int32(message.result);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgTimeoutResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.result = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            result: (0, helpers_1.isSet)(object.result) ? responseResultTypeFromJSON(object.result) : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        message.result !== undefined && (obj.result = responseResultTypeToJSON(message.result));
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgTimeoutResponse();
        message.result = object.result ?? 0;
        return message;
    },
};
function createBaseMsgTimeoutOnClose() {
    return {
        packet: undefined,
        proofUnreceived: new Uint8Array(),
        proofClose: new Uint8Array(),
        proofHeight: undefined,
        nextSequenceRecv: helpers_1.Long.UZERO,
        signer: "",
    };
}
exports.MsgTimeoutOnClose = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.packet !== undefined) {
            channel_1.Packet.encode(message.packet, writer.uint32(10).fork()).ldelim();
        }
        if (message.proofUnreceived.length !== 0) {
            writer.uint32(18).bytes(message.proofUnreceived);
        }
        if (message.proofClose.length !== 0) {
            writer.uint32(26).bytes(message.proofClose);
        }
        if (message.proofHeight !== undefined) {
            client_1.Height.encode(message.proofHeight, writer.uint32(34).fork()).ldelim();
        }
        if (!message.nextSequenceRecv.isZero()) {
            writer.uint32(40).uint64(message.nextSequenceRecv);
        }
        if (message.signer !== "") {
            writer.uint32(50).string(message.signer);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgTimeoutOnClose();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.packet = channel_1.Packet.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.proofUnreceived = reader.bytes();
                    break;
                case 3:
                    message.proofClose = reader.bytes();
                    break;
                case 4:
                    message.proofHeight = client_1.Height.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.nextSequenceRecv = reader.uint64();
                    break;
                case 6:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            packet: (0, helpers_1.isSet)(object.packet) ? channel_1.Packet.fromJSON(object.packet) : undefined,
            proofUnreceived: (0, helpers_1.isSet)(object.proofUnreceived)
                ? (0, helpers_1.bytesFromBase64)(object.proofUnreceived)
                : new Uint8Array(),
            proofClose: (0, helpers_1.isSet)(object.proofClose) ? (0, helpers_1.bytesFromBase64)(object.proofClose) : new Uint8Array(),
            proofHeight: (0, helpers_1.isSet)(object.proofHeight) ? client_1.Height.fromJSON(object.proofHeight) : undefined,
            nextSequenceRecv: (0, helpers_1.isSet)(object.nextSequenceRecv) ? helpers_1.Long.fromValue(object.nextSequenceRecv) : helpers_1.Long.UZERO,
            signer: (0, helpers_1.isSet)(object.signer) ? String(object.signer) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.packet !== undefined && (obj.packet = message.packet ? channel_1.Packet.toJSON(message.packet) : undefined);
        message.proofUnreceived !== undefined &&
            (obj.proofUnreceived = (0, helpers_1.base64FromBytes)(message.proofUnreceived !== undefined ? message.proofUnreceived : new Uint8Array()));
        message.proofClose !== undefined &&
            (obj.proofClose = (0, helpers_1.base64FromBytes)(message.proofClose !== undefined ? message.proofClose : new Uint8Array()));
        message.proofHeight !== undefined &&
            (obj.proofHeight = message.proofHeight ? client_1.Height.toJSON(message.proofHeight) : undefined);
        message.nextSequenceRecv !== undefined &&
            (obj.nextSequenceRecv = (message.nextSequenceRecv || helpers_1.Long.UZERO).toString());
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgTimeoutOnClose();
        message.packet =
            object.packet !== undefined && object.packet !== null ? channel_1.Packet.fromPartial(object.packet) : undefined;
        message.proofUnreceived = object.proofUnreceived ?? new Uint8Array();
        message.proofClose = object.proofClose ?? new Uint8Array();
        message.proofHeight =
            object.proofHeight !== undefined && object.proofHeight !== null
                ? client_1.Height.fromPartial(object.proofHeight)
                : undefined;
        message.nextSequenceRecv =
            object.nextSequenceRecv !== undefined && object.nextSequenceRecv !== null
                ? helpers_1.Long.fromValue(object.nextSequenceRecv)
                : helpers_1.Long.UZERO;
        message.signer = object.signer ?? "";
        return message;
    },
};
function createBaseMsgTimeoutOnCloseResponse() {
    return {
        result: 0,
    };
}
exports.MsgTimeoutOnCloseResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.result !== 0) {
            writer.uint32(8).int32(message.result);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgTimeoutOnCloseResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.result = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            result: (0, helpers_1.isSet)(object.result) ? responseResultTypeFromJSON(object.result) : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        message.result !== undefined && (obj.result = responseResultTypeToJSON(message.result));
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgTimeoutOnCloseResponse();
        message.result = object.result ?? 0;
        return message;
    },
};
function createBaseMsgAcknowledgement() {
    return {
        packet: undefined,
        acknowledgement: new Uint8Array(),
        proofAcked: new Uint8Array(),
        proofHeight: undefined,
        signer: "",
    };
}
exports.MsgAcknowledgement = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.packet !== undefined) {
            channel_1.Packet.encode(message.packet, writer.uint32(10).fork()).ldelim();
        }
        if (message.acknowledgement.length !== 0) {
            writer.uint32(18).bytes(message.acknowledgement);
        }
        if (message.proofAcked.length !== 0) {
            writer.uint32(26).bytes(message.proofAcked);
        }
        if (message.proofHeight !== undefined) {
            client_1.Height.encode(message.proofHeight, writer.uint32(34).fork()).ldelim();
        }
        if (message.signer !== "") {
            writer.uint32(42).string(message.signer);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgAcknowledgement();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.packet = channel_1.Packet.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.acknowledgement = reader.bytes();
                    break;
                case 3:
                    message.proofAcked = reader.bytes();
                    break;
                case 4:
                    message.proofHeight = client_1.Height.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            packet: (0, helpers_1.isSet)(object.packet) ? channel_1.Packet.fromJSON(object.packet) : undefined,
            acknowledgement: (0, helpers_1.isSet)(object.acknowledgement)
                ? (0, helpers_1.bytesFromBase64)(object.acknowledgement)
                : new Uint8Array(),
            proofAcked: (0, helpers_1.isSet)(object.proofAcked) ? (0, helpers_1.bytesFromBase64)(object.proofAcked) : new Uint8Array(),
            proofHeight: (0, helpers_1.isSet)(object.proofHeight) ? client_1.Height.fromJSON(object.proofHeight) : undefined,
            signer: (0, helpers_1.isSet)(object.signer) ? String(object.signer) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.packet !== undefined && (obj.packet = message.packet ? channel_1.Packet.toJSON(message.packet) : undefined);
        message.acknowledgement !== undefined &&
            (obj.acknowledgement = (0, helpers_1.base64FromBytes)(message.acknowledgement !== undefined ? message.acknowledgement : new Uint8Array()));
        message.proofAcked !== undefined &&
            (obj.proofAcked = (0, helpers_1.base64FromBytes)(message.proofAcked !== undefined ? message.proofAcked : new Uint8Array()));
        message.proofHeight !== undefined &&
            (obj.proofHeight = message.proofHeight ? client_1.Height.toJSON(message.proofHeight) : undefined);
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgAcknowledgement();
        message.packet =
            object.packet !== undefined && object.packet !== null ? channel_1.Packet.fromPartial(object.packet) : undefined;
        message.acknowledgement = object.acknowledgement ?? new Uint8Array();
        message.proofAcked = object.proofAcked ?? new Uint8Array();
        message.proofHeight =
            object.proofHeight !== undefined && object.proofHeight !== null
                ? client_1.Height.fromPartial(object.proofHeight)
                : undefined;
        message.signer = object.signer ?? "";
        return message;
    },
};
function createBaseMsgAcknowledgementResponse() {
    return {
        result: 0,
    };
}
exports.MsgAcknowledgementResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.result !== 0) {
            writer.uint32(8).int32(message.result);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgAcknowledgementResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.result = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            result: (0, helpers_1.isSet)(object.result) ? responseResultTypeFromJSON(object.result) : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        message.result !== undefined && (obj.result = responseResultTypeToJSON(message.result));
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgAcknowledgementResponse();
        message.result = object.result ?? 0;
        return message;
    },
};
class MsgClientImpl {
    constructor(rpc) {
        this.rpc = rpc;
        this.ChannelOpenInit = this.ChannelOpenInit.bind(this);
        this.ChannelOpenTry = this.ChannelOpenTry.bind(this);
        this.ChannelOpenAck = this.ChannelOpenAck.bind(this);
        this.ChannelOpenConfirm = this.ChannelOpenConfirm.bind(this);
        this.ChannelCloseInit = this.ChannelCloseInit.bind(this);
        this.ChannelCloseConfirm = this.ChannelCloseConfirm.bind(this);
        this.RecvPacket = this.RecvPacket.bind(this);
        this.Timeout = this.Timeout.bind(this);
        this.TimeoutOnClose = this.TimeoutOnClose.bind(this);
        this.Acknowledgement = this.Acknowledgement.bind(this);
    }
    ChannelOpenInit(request) {
        const data = exports.MsgChannelOpenInit.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Msg", "ChannelOpenInit", data);
        return promise.then((data) => exports.MsgChannelOpenInitResponse.decode(new _m0.Reader(data)));
    }
    ChannelOpenTry(request) {
        const data = exports.MsgChannelOpenTry.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Msg", "ChannelOpenTry", data);
        return promise.then((data) => exports.MsgChannelOpenTryResponse.decode(new _m0.Reader(data)));
    }
    ChannelOpenAck(request) {
        const data = exports.MsgChannelOpenAck.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Msg", "ChannelOpenAck", data);
        return promise.then((data) => exports.MsgChannelOpenAckResponse.decode(new _m0.Reader(data)));
    }
    ChannelOpenConfirm(request) {
        const data = exports.MsgChannelOpenConfirm.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Msg", "ChannelOpenConfirm", data);
        return promise.then((data) => exports.MsgChannelOpenConfirmResponse.decode(new _m0.Reader(data)));
    }
    ChannelCloseInit(request) {
        const data = exports.MsgChannelCloseInit.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Msg", "ChannelCloseInit", data);
        return promise.then((data) => exports.MsgChannelCloseInitResponse.decode(new _m0.Reader(data)));
    }
    ChannelCloseConfirm(request) {
        const data = exports.MsgChannelCloseConfirm.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Msg", "ChannelCloseConfirm", data);
        return promise.then((data) => exports.MsgChannelCloseConfirmResponse.decode(new _m0.Reader(data)));
    }
    RecvPacket(request) {
        const data = exports.MsgRecvPacket.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Msg", "RecvPacket", data);
        return promise.then((data) => exports.MsgRecvPacketResponse.decode(new _m0.Reader(data)));
    }
    Timeout(request) {
        const data = exports.MsgTimeout.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Msg", "Timeout", data);
        return promise.then((data) => exports.MsgTimeoutResponse.decode(new _m0.Reader(data)));
    }
    TimeoutOnClose(request) {
        const data = exports.MsgTimeoutOnClose.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Msg", "TimeoutOnClose", data);
        return promise.then((data) => exports.MsgTimeoutOnCloseResponse.decode(new _m0.Reader(data)));
    }
    Acknowledgement(request) {
        const data = exports.MsgAcknowledgement.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Msg", "Acknowledgement", data);
        return promise.then((data) => exports.MsgAcknowledgementResponse.decode(new _m0.Reader(data)));
    }
}
exports.MsgClientImpl = MsgClientImpl;
//# sourceMappingURL=tx.js.map

/***/ }),

/***/ 30085:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Params = exports.Height = exports.UpgradeProposal = exports.ClientUpdateProposal = exports.ClientConsensusStates = exports.ConsensusStateWithHeight = exports.IdentifiedClientState = exports.protobufPackage = void 0;
/* eslint-disable */
const any_1 = __webpack_require__(75654);
const upgrade_1 = __webpack_require__(19998);
const helpers_1 = __webpack_require__(92654);
const _m0 = __importStar(__webpack_require__(62100));
exports.protobufPackage = "ibc.core.client.v1";
function createBaseIdentifiedClientState() {
    return {
        clientId: "",
        clientState: undefined,
    };
}
exports.IdentifiedClientState = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.clientId !== "") {
            writer.uint32(10).string(message.clientId);
        }
        if (message.clientState !== undefined) {
            any_1.Any.encode(message.clientState, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseIdentifiedClientState();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.clientState = any_1.Any.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            clientId: (0, helpers_1.isSet)(object.clientId) ? String(object.clientId) : "",
            clientState: (0, helpers_1.isSet)(object.clientState) ? any_1.Any.fromJSON(object.clientState) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        message.clientState !== undefined &&
            (obj.clientState = message.clientState ? any_1.Any.toJSON(message.clientState) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseIdentifiedClientState();
        message.clientId = object.clientId ?? "";
        message.clientState =
            object.clientState !== undefined && object.clientState !== null
                ? any_1.Any.fromPartial(object.clientState)
                : undefined;
        return message;
    },
};
function createBaseConsensusStateWithHeight() {
    return {
        height: undefined,
        consensusState: undefined,
    };
}
exports.ConsensusStateWithHeight = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.height !== undefined) {
            exports.Height.encode(message.height, writer.uint32(10).fork()).ldelim();
        }
        if (message.consensusState !== undefined) {
            any_1.Any.encode(message.consensusState, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseConsensusStateWithHeight();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.height = exports.Height.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.consensusState = any_1.Any.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            height: (0, helpers_1.isSet)(object.height) ? exports.Height.fromJSON(object.height) : undefined,
            consensusState: (0, helpers_1.isSet)(object.consensusState) ? any_1.Any.fromJSON(object.consensusState) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.height !== undefined && (obj.height = message.height ? exports.Height.toJSON(message.height) : undefined);
        message.consensusState !== undefined &&
            (obj.consensusState = message.consensusState ? any_1.Any.toJSON(message.consensusState) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseConsensusStateWithHeight();
        message.height =
            object.height !== undefined && object.height !== null ? exports.Height.fromPartial(object.height) : undefined;
        message.consensusState =
            object.consensusState !== undefined && object.consensusState !== null
                ? any_1.Any.fromPartial(object.consensusState)
                : undefined;
        return message;
    },
};
function createBaseClientConsensusStates() {
    return {
        clientId: "",
        consensusStates: [],
    };
}
exports.ClientConsensusStates = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.clientId !== "") {
            writer.uint32(10).string(message.clientId);
        }
        for (const v of message.consensusStates) {
            exports.ConsensusStateWithHeight.encode(v, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseClientConsensusStates();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.consensusStates.push(exports.ConsensusStateWithHeight.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            clientId: (0, helpers_1.isSet)(object.clientId) ? String(object.clientId) : "",
            consensusStates: Array.isArray(object?.consensusStates)
                ? object.consensusStates.map((e) => exports.ConsensusStateWithHeight.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        if (message.consensusStates) {
            obj.consensusStates = message.consensusStates.map((e) => e ? exports.ConsensusStateWithHeight.toJSON(e) : undefined);
        }
        else {
            obj.consensusStates = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseClientConsensusStates();
        message.clientId = object.clientId ?? "";
        message.consensusStates =
            object.consensusStates?.map((e) => exports.ConsensusStateWithHeight.fromPartial(e)) || [];
        return message;
    },
};
function createBaseClientUpdateProposal() {
    return {
        title: "",
        description: "",
        subjectClientId: "",
        substituteClientId: "",
    };
}
exports.ClientUpdateProposal = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.title !== "") {
            writer.uint32(10).string(message.title);
        }
        if (message.description !== "") {
            writer.uint32(18).string(message.description);
        }
        if (message.subjectClientId !== "") {
            writer.uint32(26).string(message.subjectClientId);
        }
        if (message.substituteClientId !== "") {
            writer.uint32(34).string(message.substituteClientId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseClientUpdateProposal();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.title = reader.string();
                    break;
                case 2:
                    message.description = reader.string();
                    break;
                case 3:
                    message.subjectClientId = reader.string();
                    break;
                case 4:
                    message.substituteClientId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            title: (0, helpers_1.isSet)(object.title) ? String(object.title) : "",
            description: (0, helpers_1.isSet)(object.description) ? String(object.description) : "",
            subjectClientId: (0, helpers_1.isSet)(object.subjectClientId) ? String(object.subjectClientId) : "",
            substituteClientId: (0, helpers_1.isSet)(object.substituteClientId) ? String(object.substituteClientId) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.title !== undefined && (obj.title = message.title);
        message.description !== undefined && (obj.description = message.description);
        message.subjectClientId !== undefined && (obj.subjectClientId = message.subjectClientId);
        message.substituteClientId !== undefined && (obj.substituteClientId = message.substituteClientId);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseClientUpdateProposal();
        message.title = object.title ?? "";
        message.description = object.description ?? "";
        message.subjectClientId = object.subjectClientId ?? "";
        message.substituteClientId = object.substituteClientId ?? "";
        return message;
    },
};
function createBaseUpgradeProposal() {
    return {
        title: "",
        description: "",
        plan: undefined,
        upgradedClientState: undefined,
    };
}
exports.UpgradeProposal = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.title !== "") {
            writer.uint32(10).string(message.title);
        }
        if (message.description !== "") {
            writer.uint32(18).string(message.description);
        }
        if (message.plan !== undefined) {
            upgrade_1.Plan.encode(message.plan, writer.uint32(26).fork()).ldelim();
        }
        if (message.upgradedClientState !== undefined) {
            any_1.Any.encode(message.upgradedClientState, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUpgradeProposal();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.title = reader.string();
                    break;
                case 2:
                    message.description = reader.string();
                    break;
                case 3:
                    message.plan = upgrade_1.Plan.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.upgradedClientState = any_1.Any.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            title: (0, helpers_1.isSet)(object.title) ? String(object.title) : "",
            description: (0, helpers_1.isSet)(object.description) ? String(object.description) : "",
            plan: (0, helpers_1.isSet)(object.plan) ? upgrade_1.Plan.fromJSON(object.plan) : undefined,
            upgradedClientState: (0, helpers_1.isSet)(object.upgradedClientState)
                ? any_1.Any.fromJSON(object.upgradedClientState)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.title !== undefined && (obj.title = message.title);
        message.description !== undefined && (obj.description = message.description);
        message.plan !== undefined && (obj.plan = message.plan ? upgrade_1.Plan.toJSON(message.plan) : undefined);
        message.upgradedClientState !== undefined &&
            (obj.upgradedClientState = message.upgradedClientState
                ? any_1.Any.toJSON(message.upgradedClientState)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseUpgradeProposal();
        message.title = object.title ?? "";
        message.description = object.description ?? "";
        message.plan =
            object.plan !== undefined && object.plan !== null ? upgrade_1.Plan.fromPartial(object.plan) : undefined;
        message.upgradedClientState =
            object.upgradedClientState !== undefined && object.upgradedClientState !== null
                ? any_1.Any.fromPartial(object.upgradedClientState)
                : undefined;
        return message;
    },
};
function createBaseHeight() {
    return {
        revisionNumber: helpers_1.Long.UZERO,
        revisionHeight: helpers_1.Long.UZERO,
    };
}
exports.Height = {
    encode(message, writer = _m0.Writer.create()) {
        if (!message.revisionNumber.isZero()) {
            writer.uint32(8).uint64(message.revisionNumber);
        }
        if (!message.revisionHeight.isZero()) {
            writer.uint32(16).uint64(message.revisionHeight);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseHeight();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.revisionNumber = reader.uint64();
                    break;
                case 2:
                    message.revisionHeight = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            revisionNumber: (0, helpers_1.isSet)(object.revisionNumber) ? helpers_1.Long.fromValue(object.revisionNumber) : helpers_1.Long.UZERO,
            revisionHeight: (0, helpers_1.isSet)(object.revisionHeight) ? helpers_1.Long.fromValue(object.revisionHeight) : helpers_1.Long.UZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        message.revisionNumber !== undefined &&
            (obj.revisionNumber = (message.revisionNumber || helpers_1.Long.UZERO).toString());
        message.revisionHeight !== undefined &&
            (obj.revisionHeight = (message.revisionHeight || helpers_1.Long.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseHeight();
        message.revisionNumber =
            object.revisionNumber !== undefined && object.revisionNumber !== null
                ? helpers_1.Long.fromValue(object.revisionNumber)
                : helpers_1.Long.UZERO;
        message.revisionHeight =
            object.revisionHeight !== undefined && object.revisionHeight !== null
                ? helpers_1.Long.fromValue(object.revisionHeight)
                : helpers_1.Long.UZERO;
        return message;
    },
};
function createBaseParams() {
    return {
        allowedClients: [],
    };
}
exports.Params = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.allowedClients) {
            writer.uint32(10).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseParams();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.allowedClients.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            allowedClients: Array.isArray(object?.allowedClients)
                ? object.allowedClients.map((e) => String(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.allowedClients) {
            obj.allowedClients = message.allowedClients.map((e) => e);
        }
        else {
            obj.allowedClients = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseParams();
        message.allowedClients = object.allowedClients?.map((e) => e) || [];
        return message;
    },
};
//# sourceMappingURL=client.js.map

/***/ }),

/***/ 52989:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.QueryClientImpl = exports.QueryUpgradedConsensusStateResponse = exports.QueryUpgradedConsensusStateRequest = exports.QueryUpgradedClientStateResponse = exports.QueryUpgradedClientStateRequest = exports.QueryClientParamsResponse = exports.QueryClientParamsRequest = exports.QueryClientStatusResponse = exports.QueryClientStatusRequest = exports.QueryConsensusStateHeightsResponse = exports.QueryConsensusStateHeightsRequest = exports.QueryConsensusStatesResponse = exports.QueryConsensusStatesRequest = exports.QueryConsensusStateResponse = exports.QueryConsensusStateRequest = exports.QueryClientStatesResponse = exports.QueryClientStatesRequest = exports.QueryClientStateResponse = exports.QueryClientStateRequest = exports.protobufPackage = void 0;
/* eslint-disable */
const pagination_1 = __webpack_require__(84043);
const any_1 = __webpack_require__(75654);
const client_1 = __webpack_require__(30085);
const helpers_1 = __webpack_require__(92654);
const _m0 = __importStar(__webpack_require__(62100));
exports.protobufPackage = "ibc.core.client.v1";
function createBaseQueryClientStateRequest() {
    return {
        clientId: "",
    };
}
exports.QueryClientStateRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.clientId !== "") {
            writer.uint32(10).string(message.clientId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryClientStateRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.clientId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            clientId: (0, helpers_1.isSet)(object.clientId) ? String(object.clientId) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryClientStateRequest();
        message.clientId = object.clientId ?? "";
        return message;
    },
};
function createBaseQueryClientStateResponse() {
    return {
        clientState: undefined,
        proof: new Uint8Array(),
        proofHeight: undefined,
    };
}
exports.QueryClientStateResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.clientState !== undefined) {
            any_1.Any.encode(message.clientState, writer.uint32(10).fork()).ldelim();
        }
        if (message.proof.length !== 0) {
            writer.uint32(18).bytes(message.proof);
        }
        if (message.proofHeight !== undefined) {
            client_1.Height.encode(message.proofHeight, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryClientStateResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.clientState = any_1.Any.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.proof = reader.bytes();
                    break;
                case 3:
                    message.proofHeight = client_1.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            clientState: (0, helpers_1.isSet)(object.clientState) ? any_1.Any.fromJSON(object.clientState) : undefined,
            proof: (0, helpers_1.isSet)(object.proof) ? (0, helpers_1.bytesFromBase64)(object.proof) : new Uint8Array(),
            proofHeight: (0, helpers_1.isSet)(object.proofHeight) ? client_1.Height.fromJSON(object.proofHeight) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.clientState !== undefined &&
            (obj.clientState = message.clientState ? any_1.Any.toJSON(message.clientState) : undefined);
        message.proof !== undefined &&
            (obj.proof = (0, helpers_1.base64FromBytes)(message.proof !== undefined ? message.proof : new Uint8Array()));
        message.proofHeight !== undefined &&
            (obj.proofHeight = message.proofHeight ? client_1.Height.toJSON(message.proofHeight) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryClientStateResponse();
        message.clientState =
            object.clientState !== undefined && object.clientState !== null
                ? any_1.Any.fromPartial(object.clientState)
                : undefined;
        message.proof = object.proof ?? new Uint8Array();
        message.proofHeight =
            object.proofHeight !== undefined && object.proofHeight !== null
                ? client_1.Height.fromPartial(object.proofHeight)
                : undefined;
        return message;
    },
};
function createBaseQueryClientStatesRequest() {
    return {
        pagination: undefined,
    };
}
exports.QueryClientStatesRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryClientStatesRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            pagination: (0, helpers_1.isSet)(object.pagination) ? pagination_1.PageRequest.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryClientStatesRequest();
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryClientStatesResponse() {
    return {
        clientStates: [],
        pagination: undefined,
    };
}
exports.QueryClientStatesResponse = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.clientStates) {
            client_1.IdentifiedClientState.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryClientStatesResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.clientStates.push(client_1.IdentifiedClientState.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            clientStates: Array.isArray(object?.clientStates)
                ? object.clientStates.map((e) => client_1.IdentifiedClientState.fromJSON(e))
                : [],
            pagination: (0, helpers_1.isSet)(object.pagination) ? pagination_1.PageResponse.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.clientStates) {
            obj.clientStates = message.clientStates.map((e) => (e ? client_1.IdentifiedClientState.toJSON(e) : undefined));
        }
        else {
            obj.clientStates = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryClientStatesResponse();
        message.clientStates = object.clientStates?.map((e) => client_1.IdentifiedClientState.fromPartial(e)) || [];
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryConsensusStateRequest() {
    return {
        clientId: "",
        revisionNumber: helpers_1.Long.UZERO,
        revisionHeight: helpers_1.Long.UZERO,
        latestHeight: false,
    };
}
exports.QueryConsensusStateRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.clientId !== "") {
            writer.uint32(10).string(message.clientId);
        }
        if (!message.revisionNumber.isZero()) {
            writer.uint32(16).uint64(message.revisionNumber);
        }
        if (!message.revisionHeight.isZero()) {
            writer.uint32(24).uint64(message.revisionHeight);
        }
        if (message.latestHeight === true) {
            writer.uint32(32).bool(message.latestHeight);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryConsensusStateRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.revisionNumber = reader.uint64();
                    break;
                case 3:
                    message.revisionHeight = reader.uint64();
                    break;
                case 4:
                    message.latestHeight = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            clientId: (0, helpers_1.isSet)(object.clientId) ? String(object.clientId) : "",
            revisionNumber: (0, helpers_1.isSet)(object.revisionNumber) ? helpers_1.Long.fromValue(object.revisionNumber) : helpers_1.Long.UZERO,
            revisionHeight: (0, helpers_1.isSet)(object.revisionHeight) ? helpers_1.Long.fromValue(object.revisionHeight) : helpers_1.Long.UZERO,
            latestHeight: (0, helpers_1.isSet)(object.latestHeight) ? Boolean(object.latestHeight) : false,
        };
    },
    toJSON(message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        message.revisionNumber !== undefined &&
            (obj.revisionNumber = (message.revisionNumber || helpers_1.Long.UZERO).toString());
        message.revisionHeight !== undefined &&
            (obj.revisionHeight = (message.revisionHeight || helpers_1.Long.UZERO).toString());
        message.latestHeight !== undefined && (obj.latestHeight = message.latestHeight);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryConsensusStateRequest();
        message.clientId = object.clientId ?? "";
        message.revisionNumber =
            object.revisionNumber !== undefined && object.revisionNumber !== null
                ? helpers_1.Long.fromValue(object.revisionNumber)
                : helpers_1.Long.UZERO;
        message.revisionHeight =
            object.revisionHeight !== undefined && object.revisionHeight !== null
                ? helpers_1.Long.fromValue(object.revisionHeight)
                : helpers_1.Long.UZERO;
        message.latestHeight = object.latestHeight ?? false;
        return message;
    },
};
function createBaseQueryConsensusStateResponse() {
    return {
        consensusState: undefined,
        proof: new Uint8Array(),
        proofHeight: undefined,
    };
}
exports.QueryConsensusStateResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.consensusState !== undefined) {
            any_1.Any.encode(message.consensusState, writer.uint32(10).fork()).ldelim();
        }
        if (message.proof.length !== 0) {
            writer.uint32(18).bytes(message.proof);
        }
        if (message.proofHeight !== undefined) {
            client_1.Height.encode(message.proofHeight, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryConsensusStateResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.consensusState = any_1.Any.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.proof = reader.bytes();
                    break;
                case 3:
                    message.proofHeight = client_1.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            consensusState: (0, helpers_1.isSet)(object.consensusState) ? any_1.Any.fromJSON(object.consensusState) : undefined,
            proof: (0, helpers_1.isSet)(object.proof) ? (0, helpers_1.bytesFromBase64)(object.proof) : new Uint8Array(),
            proofHeight: (0, helpers_1.isSet)(object.proofHeight) ? client_1.Height.fromJSON(object.proofHeight) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.consensusState !== undefined &&
            (obj.consensusState = message.consensusState ? any_1.Any.toJSON(message.consensusState) : undefined);
        message.proof !== undefined &&
            (obj.proof = (0, helpers_1.base64FromBytes)(message.proof !== undefined ? message.proof : new Uint8Array()));
        message.proofHeight !== undefined &&
            (obj.proofHeight = message.proofHeight ? client_1.Height.toJSON(message.proofHeight) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryConsensusStateResponse();
        message.consensusState =
            object.consensusState !== undefined && object.consensusState !== null
                ? any_1.Any.fromPartial(object.consensusState)
                : undefined;
        message.proof = object.proof ?? new Uint8Array();
        message.proofHeight =
            object.proofHeight !== undefined && object.proofHeight !== null
                ? client_1.Height.fromPartial(object.proofHeight)
                : undefined;
        return message;
    },
};
function createBaseQueryConsensusStatesRequest() {
    return {
        clientId: "",
        pagination: undefined,
    };
}
exports.QueryConsensusStatesRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.clientId !== "") {
            writer.uint32(10).string(message.clientId);
        }
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryConsensusStatesRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            clientId: (0, helpers_1.isSet)(object.clientId) ? String(object.clientId) : "",
            pagination: (0, helpers_1.isSet)(object.pagination) ? pagination_1.PageRequest.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryConsensusStatesRequest();
        message.clientId = object.clientId ?? "";
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryConsensusStatesResponse() {
    return {
        consensusStates: [],
        pagination: undefined,
    };
}
exports.QueryConsensusStatesResponse = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.consensusStates) {
            client_1.ConsensusStateWithHeight.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryConsensusStatesResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.consensusStates.push(client_1.ConsensusStateWithHeight.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            consensusStates: Array.isArray(object?.consensusStates)
                ? object.consensusStates.map((e) => client_1.ConsensusStateWithHeight.fromJSON(e))
                : [],
            pagination: (0, helpers_1.isSet)(object.pagination) ? pagination_1.PageResponse.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.consensusStates) {
            obj.consensusStates = message.consensusStates.map((e) => e ? client_1.ConsensusStateWithHeight.toJSON(e) : undefined);
        }
        else {
            obj.consensusStates = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryConsensusStatesResponse();
        message.consensusStates =
            object.consensusStates?.map((e) => client_1.ConsensusStateWithHeight.fromPartial(e)) || [];
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryConsensusStateHeightsRequest() {
    return {
        clientId: "",
        pagination: undefined,
    };
}
exports.QueryConsensusStateHeightsRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.clientId !== "") {
            writer.uint32(10).string(message.clientId);
        }
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryConsensusStateHeightsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            clientId: (0, helpers_1.isSet)(object.clientId) ? String(object.clientId) : "",
            pagination: (0, helpers_1.isSet)(object.pagination) ? pagination_1.PageRequest.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryConsensusStateHeightsRequest();
        message.clientId = object.clientId ?? "";
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryConsensusStateHeightsResponse() {
    return {
        consensusStateHeights: [],
        pagination: undefined,
    };
}
exports.QueryConsensusStateHeightsResponse = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.consensusStateHeights) {
            client_1.Height.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryConsensusStateHeightsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.consensusStateHeights.push(client_1.Height.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            consensusStateHeights: Array.isArray(object?.consensusStateHeights)
                ? object.consensusStateHeights.map((e) => client_1.Height.fromJSON(e))
                : [],
            pagination: (0, helpers_1.isSet)(object.pagination) ? pagination_1.PageResponse.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.consensusStateHeights) {
            obj.consensusStateHeights = message.consensusStateHeights.map((e) => e ? client_1.Height.toJSON(e) : undefined);
        }
        else {
            obj.consensusStateHeights = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryConsensusStateHeightsResponse();
        message.consensusStateHeights = object.consensusStateHeights?.map((e) => client_1.Height.fromPartial(e)) || [];
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryClientStatusRequest() {
    return {
        clientId: "",
    };
}
exports.QueryClientStatusRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.clientId !== "") {
            writer.uint32(10).string(message.clientId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryClientStatusRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.clientId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            clientId: (0, helpers_1.isSet)(object.clientId) ? String(object.clientId) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryClientStatusRequest();
        message.clientId = object.clientId ?? "";
        return message;
    },
};
function createBaseQueryClientStatusResponse() {
    return {
        status: "",
    };
}
exports.QueryClientStatusResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.status !== "") {
            writer.uint32(10).string(message.status);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryClientStatusResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.status = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            status: (0, helpers_1.isSet)(object.status) ? String(object.status) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.status !== undefined && (obj.status = message.status);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryClientStatusResponse();
        message.status = object.status ?? "";
        return message;
    },
};
function createBaseQueryClientParamsRequest() {
    return {};
}
exports.QueryClientParamsRequest = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryClientParamsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseQueryClientParamsRequest();
        return message;
    },
};
function createBaseQueryClientParamsResponse() {
    return {
        params: undefined,
    };
}
exports.QueryClientParamsResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.params !== undefined) {
            client_1.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryClientParamsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.params = client_1.Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            params: (0, helpers_1.isSet)(object.params) ? client_1.Params.fromJSON(object.params) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.params !== undefined && (obj.params = message.params ? client_1.Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryClientParamsResponse();
        message.params =
            object.params !== undefined && object.params !== null ? client_1.Params.fromPartial(object.params) : undefined;
        return message;
    },
};
function createBaseQueryUpgradedClientStateRequest() {
    return {};
}
exports.QueryUpgradedClientStateRequest = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryUpgradedClientStateRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseQueryUpgradedClientStateRequest();
        return message;
    },
};
function createBaseQueryUpgradedClientStateResponse() {
    return {
        upgradedClientState: undefined,
    };
}
exports.QueryUpgradedClientStateResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.upgradedClientState !== undefined) {
            any_1.Any.encode(message.upgradedClientState, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryUpgradedClientStateResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.upgradedClientState = any_1.Any.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            upgradedClientState: (0, helpers_1.isSet)(object.upgradedClientState)
                ? any_1.Any.fromJSON(object.upgradedClientState)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.upgradedClientState !== undefined &&
            (obj.upgradedClientState = message.upgradedClientState
                ? any_1.Any.toJSON(message.upgradedClientState)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryUpgradedClientStateResponse();
        message.upgradedClientState =
            object.upgradedClientState !== undefined && object.upgradedClientState !== null
                ? any_1.Any.fromPartial(object.upgradedClientState)
                : undefined;
        return message;
    },
};
function createBaseQueryUpgradedConsensusStateRequest() {
    return {};
}
exports.QueryUpgradedConsensusStateRequest = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryUpgradedConsensusStateRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseQueryUpgradedConsensusStateRequest();
        return message;
    },
};
function createBaseQueryUpgradedConsensusStateResponse() {
    return {
        upgradedConsensusState: undefined,
    };
}
exports.QueryUpgradedConsensusStateResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.upgradedConsensusState !== undefined) {
            any_1.Any.encode(message.upgradedConsensusState, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryUpgradedConsensusStateResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.upgradedConsensusState = any_1.Any.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            upgradedConsensusState: (0, helpers_1.isSet)(object.upgradedConsensusState)
                ? any_1.Any.fromJSON(object.upgradedConsensusState)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.upgradedConsensusState !== undefined &&
            (obj.upgradedConsensusState = message.upgradedConsensusState
                ? any_1.Any.toJSON(message.upgradedConsensusState)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryUpgradedConsensusStateResponse();
        message.upgradedConsensusState =
            object.upgradedConsensusState !== undefined && object.upgradedConsensusState !== null
                ? any_1.Any.fromPartial(object.upgradedConsensusState)
                : undefined;
        return message;
    },
};
class QueryClientImpl {
    constructor(rpc) {
        this.rpc = rpc;
        this.ClientState = this.ClientState.bind(this);
        this.ClientStates = this.ClientStates.bind(this);
        this.ConsensusState = this.ConsensusState.bind(this);
        this.ConsensusStates = this.ConsensusStates.bind(this);
        this.ConsensusStateHeights = this.ConsensusStateHeights.bind(this);
        this.ClientStatus = this.ClientStatus.bind(this);
        this.ClientParams = this.ClientParams.bind(this);
        this.UpgradedClientState = this.UpgradedClientState.bind(this);
        this.UpgradedConsensusState = this.UpgradedConsensusState.bind(this);
    }
    ClientState(request) {
        const data = exports.QueryClientStateRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.client.v1.Query", "ClientState", data);
        return promise.then((data) => exports.QueryClientStateResponse.decode(new _m0.Reader(data)));
    }
    ClientStates(request = {
        pagination: undefined,
    }) {
        const data = exports.QueryClientStatesRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.client.v1.Query", "ClientStates", data);
        return promise.then((data) => exports.QueryClientStatesResponse.decode(new _m0.Reader(data)));
    }
    ConsensusState(request) {
        const data = exports.QueryConsensusStateRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.client.v1.Query", "ConsensusState", data);
        return promise.then((data) => exports.QueryConsensusStateResponse.decode(new _m0.Reader(data)));
    }
    ConsensusStates(request) {
        const data = exports.QueryConsensusStatesRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.client.v1.Query", "ConsensusStates", data);
        return promise.then((data) => exports.QueryConsensusStatesResponse.decode(new _m0.Reader(data)));
    }
    ConsensusStateHeights(request) {
        const data = exports.QueryConsensusStateHeightsRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.client.v1.Query", "ConsensusStateHeights", data);
        return promise.then((data) => exports.QueryConsensusStateHeightsResponse.decode(new _m0.Reader(data)));
    }
    ClientStatus(request) {
        const data = exports.QueryClientStatusRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.client.v1.Query", "ClientStatus", data);
        return promise.then((data) => exports.QueryClientStatusResponse.decode(new _m0.Reader(data)));
    }
    ClientParams(request = {}) {
        const data = exports.QueryClientParamsRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.client.v1.Query", "ClientParams", data);
        return promise.then((data) => exports.QueryClientParamsResponse.decode(new _m0.Reader(data)));
    }
    UpgradedClientState(request = {}) {
        const data = exports.QueryUpgradedClientStateRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.client.v1.Query", "UpgradedClientState", data);
        return promise.then((data) => exports.QueryUpgradedClientStateResponse.decode(new _m0.Reader(data)));
    }
    UpgradedConsensusState(request = {}) {
        const data = exports.QueryUpgradedConsensusStateRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.client.v1.Query", "UpgradedConsensusState", data);
        return promise.then((data) => exports.QueryUpgradedConsensusStateResponse.decode(new _m0.Reader(data)));
    }
}
exports.QueryClientImpl = QueryClientImpl;
//# sourceMappingURL=query.js.map

/***/ }),

/***/ 66519:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MsgClientImpl = exports.MsgSubmitMisbehaviourResponse = exports.MsgSubmitMisbehaviour = exports.MsgUpgradeClientResponse = exports.MsgUpgradeClient = exports.MsgUpdateClientResponse = exports.MsgUpdateClient = exports.MsgCreateClientResponse = exports.MsgCreateClient = exports.protobufPackage = void 0;
/* eslint-disable */
const any_1 = __webpack_require__(75654);
const _m0 = __importStar(__webpack_require__(62100));
const helpers_1 = __webpack_require__(92654);
exports.protobufPackage = "ibc.core.client.v1";
function createBaseMsgCreateClient() {
    return {
        clientState: undefined,
        consensusState: undefined,
        signer: "",
    };
}
exports.MsgCreateClient = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.clientState !== undefined) {
            any_1.Any.encode(message.clientState, writer.uint32(10).fork()).ldelim();
        }
        if (message.consensusState !== undefined) {
            any_1.Any.encode(message.consensusState, writer.uint32(18).fork()).ldelim();
        }
        if (message.signer !== "") {
            writer.uint32(26).string(message.signer);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgCreateClient();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.clientState = any_1.Any.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.consensusState = any_1.Any.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            clientState: (0, helpers_1.isSet)(object.clientState) ? any_1.Any.fromJSON(object.clientState) : undefined,
            consensusState: (0, helpers_1.isSet)(object.consensusState) ? any_1.Any.fromJSON(object.consensusState) : undefined,
            signer: (0, helpers_1.isSet)(object.signer) ? String(object.signer) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.clientState !== undefined &&
            (obj.clientState = message.clientState ? any_1.Any.toJSON(message.clientState) : undefined);
        message.consensusState !== undefined &&
            (obj.consensusState = message.consensusState ? any_1.Any.toJSON(message.consensusState) : undefined);
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgCreateClient();
        message.clientState =
            object.clientState !== undefined && object.clientState !== null
                ? any_1.Any.fromPartial(object.clientState)
                : undefined;
        message.consensusState =
            object.consensusState !== undefined && object.consensusState !== null
                ? any_1.Any.fromPartial(object.consensusState)
                : undefined;
        message.signer = object.signer ?? "";
        return message;
    },
};
function createBaseMsgCreateClientResponse() {
    return {};
}
exports.MsgCreateClientResponse = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgCreateClientResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgCreateClientResponse();
        return message;
    },
};
function createBaseMsgUpdateClient() {
    return {
        clientId: "",
        clientMessage: undefined,
        signer: "",
    };
}
exports.MsgUpdateClient = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.clientId !== "") {
            writer.uint32(10).string(message.clientId);
        }
        if (message.clientMessage !== undefined) {
            any_1.Any.encode(message.clientMessage, writer.uint32(18).fork()).ldelim();
        }
        if (message.signer !== "") {
            writer.uint32(26).string(message.signer);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgUpdateClient();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.clientMessage = any_1.Any.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            clientId: (0, helpers_1.isSet)(object.clientId) ? String(object.clientId) : "",
            clientMessage: (0, helpers_1.isSet)(object.clientMessage) ? any_1.Any.fromJSON(object.clientMessage) : undefined,
            signer: (0, helpers_1.isSet)(object.signer) ? String(object.signer) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        message.clientMessage !== undefined &&
            (obj.clientMessage = message.clientMessage ? any_1.Any.toJSON(message.clientMessage) : undefined);
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgUpdateClient();
        message.clientId = object.clientId ?? "";
        message.clientMessage =
            object.clientMessage !== undefined && object.clientMessage !== null
                ? any_1.Any.fromPartial(object.clientMessage)
                : undefined;
        message.signer = object.signer ?? "";
        return message;
    },
};
function createBaseMsgUpdateClientResponse() {
    return {};
}
exports.MsgUpdateClientResponse = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgUpdateClientResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgUpdateClientResponse();
        return message;
    },
};
function createBaseMsgUpgradeClient() {
    return {
        clientId: "",
        clientState: undefined,
        consensusState: undefined,
        proofUpgradeClient: new Uint8Array(),
        proofUpgradeConsensusState: new Uint8Array(),
        signer: "",
    };
}
exports.MsgUpgradeClient = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.clientId !== "") {
            writer.uint32(10).string(message.clientId);
        }
        if (message.clientState !== undefined) {
            any_1.Any.encode(message.clientState, writer.uint32(18).fork()).ldelim();
        }
        if (message.consensusState !== undefined) {
            any_1.Any.encode(message.consensusState, writer.uint32(26).fork()).ldelim();
        }
        if (message.proofUpgradeClient.length !== 0) {
            writer.uint32(34).bytes(message.proofUpgradeClient);
        }
        if (message.proofUpgradeConsensusState.length !== 0) {
            writer.uint32(42).bytes(message.proofUpgradeConsensusState);
        }
        if (message.signer !== "") {
            writer.uint32(50).string(message.signer);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgUpgradeClient();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.clientState = any_1.Any.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.consensusState = any_1.Any.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.proofUpgradeClient = reader.bytes();
                    break;
                case 5:
                    message.proofUpgradeConsensusState = reader.bytes();
                    break;
                case 6:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            clientId: (0, helpers_1.isSet)(object.clientId) ? String(object.clientId) : "",
            clientState: (0, helpers_1.isSet)(object.clientState) ? any_1.Any.fromJSON(object.clientState) : undefined,
            consensusState: (0, helpers_1.isSet)(object.consensusState) ? any_1.Any.fromJSON(object.consensusState) : undefined,
            proofUpgradeClient: (0, helpers_1.isSet)(object.proofUpgradeClient)
                ? (0, helpers_1.bytesFromBase64)(object.proofUpgradeClient)
                : new Uint8Array(),
            proofUpgradeConsensusState: (0, helpers_1.isSet)(object.proofUpgradeConsensusState)
                ? (0, helpers_1.bytesFromBase64)(object.proofUpgradeConsensusState)
                : new Uint8Array(),
            signer: (0, helpers_1.isSet)(object.signer) ? String(object.signer) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        message.clientState !== undefined &&
            (obj.clientState = message.clientState ? any_1.Any.toJSON(message.clientState) : undefined);
        message.consensusState !== undefined &&
            (obj.consensusState = message.consensusState ? any_1.Any.toJSON(message.consensusState) : undefined);
        message.proofUpgradeClient !== undefined &&
            (obj.proofUpgradeClient = (0, helpers_1.base64FromBytes)(message.proofUpgradeClient !== undefined ? message.proofUpgradeClient : new Uint8Array()));
        message.proofUpgradeConsensusState !== undefined &&
            (obj.proofUpgradeConsensusState = (0, helpers_1.base64FromBytes)(message.proofUpgradeConsensusState !== undefined
                ? message.proofUpgradeConsensusState
                : new Uint8Array()));
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgUpgradeClient();
        message.clientId = object.clientId ?? "";
        message.clientState =
            object.clientState !== undefined && object.clientState !== null
                ? any_1.Any.fromPartial(object.clientState)
                : undefined;
        message.consensusState =
            object.consensusState !== undefined && object.consensusState !== null
                ? any_1.Any.fromPartial(object.consensusState)
                : undefined;
        message.proofUpgradeClient = object.proofUpgradeClient ?? new Uint8Array();
        message.proofUpgradeConsensusState = object.proofUpgradeConsensusState ?? new Uint8Array();
        message.signer = object.signer ?? "";
        return message;
    },
};
function createBaseMsgUpgradeClientResponse() {
    return {};
}
exports.MsgUpgradeClientResponse = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgUpgradeClientResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgUpgradeClientResponse();
        return message;
    },
};
function createBaseMsgSubmitMisbehaviour() {
    return {
        clientId: "",
        misbehaviour: undefined,
        signer: "",
    };
}
exports.MsgSubmitMisbehaviour = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.clientId !== "") {
            writer.uint32(10).string(message.clientId);
        }
        if (message.misbehaviour !== undefined) {
            any_1.Any.encode(message.misbehaviour, writer.uint32(18).fork()).ldelim();
        }
        if (message.signer !== "") {
            writer.uint32(26).string(message.signer);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgSubmitMisbehaviour();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.misbehaviour = any_1.Any.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            clientId: (0, helpers_1.isSet)(object.clientId) ? String(object.clientId) : "",
            misbehaviour: (0, helpers_1.isSet)(object.misbehaviour) ? any_1.Any.fromJSON(object.misbehaviour) : undefined,
            signer: (0, helpers_1.isSet)(object.signer) ? String(object.signer) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        message.misbehaviour !== undefined &&
            (obj.misbehaviour = message.misbehaviour ? any_1.Any.toJSON(message.misbehaviour) : undefined);
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgSubmitMisbehaviour();
        message.clientId = object.clientId ?? "";
        message.misbehaviour =
            object.misbehaviour !== undefined && object.misbehaviour !== null
                ? any_1.Any.fromPartial(object.misbehaviour)
                : undefined;
        message.signer = object.signer ?? "";
        return message;
    },
};
function createBaseMsgSubmitMisbehaviourResponse() {
    return {};
}
exports.MsgSubmitMisbehaviourResponse = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgSubmitMisbehaviourResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgSubmitMisbehaviourResponse();
        return message;
    },
};
class MsgClientImpl {
    constructor(rpc) {
        this.rpc = rpc;
        this.CreateClient = this.CreateClient.bind(this);
        this.UpdateClient = this.UpdateClient.bind(this);
        this.UpgradeClient = this.UpgradeClient.bind(this);
        this.SubmitMisbehaviour = this.SubmitMisbehaviour.bind(this);
    }
    CreateClient(request) {
        const data = exports.MsgCreateClient.encode(request).finish();
        const promise = this.rpc.request("ibc.core.client.v1.Msg", "CreateClient", data);
        return promise.then((data) => exports.MsgCreateClientResponse.decode(new _m0.Reader(data)));
    }
    UpdateClient(request) {
        const data = exports.MsgUpdateClient.encode(request).finish();
        const promise = this.rpc.request("ibc.core.client.v1.Msg", "UpdateClient", data);
        return promise.then((data) => exports.MsgUpdateClientResponse.decode(new _m0.Reader(data)));
    }
    UpgradeClient(request) {
        const data = exports.MsgUpgradeClient.encode(request).finish();
        const promise = this.rpc.request("ibc.core.client.v1.Msg", "UpgradeClient", data);
        return promise.then((data) => exports.MsgUpgradeClientResponse.decode(new _m0.Reader(data)));
    }
    SubmitMisbehaviour(request) {
        const data = exports.MsgSubmitMisbehaviour.encode(request).finish();
        const promise = this.rpc.request("ibc.core.client.v1.Msg", "SubmitMisbehaviour", data);
        return promise.then((data) => exports.MsgSubmitMisbehaviourResponse.decode(new _m0.Reader(data)));
    }
}
exports.MsgClientImpl = MsgClientImpl;
//# sourceMappingURL=tx.js.map

/***/ }),

/***/ 35408:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MerkleProof = exports.MerklePath = exports.MerklePrefix = exports.MerkleRoot = exports.protobufPackage = void 0;
/* eslint-disable */
const proofs_1 = __webpack_require__(9703);
const _m0 = __importStar(__webpack_require__(62100));
const helpers_1 = __webpack_require__(92654);
exports.protobufPackage = "ibc.core.commitment.v1";
function createBaseMerkleRoot() {
    return {
        hash: new Uint8Array(),
    };
}
exports.MerkleRoot = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.hash.length !== 0) {
            writer.uint32(10).bytes(message.hash);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMerkleRoot();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.hash = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            hash: (0, helpers_1.isSet)(object.hash) ? (0, helpers_1.bytesFromBase64)(object.hash) : new Uint8Array(),
        };
    },
    toJSON(message) {
        const obj = {};
        message.hash !== undefined &&
            (obj.hash = (0, helpers_1.base64FromBytes)(message.hash !== undefined ? message.hash : new Uint8Array()));
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMerkleRoot();
        message.hash = object.hash ?? new Uint8Array();
        return message;
    },
};
function createBaseMerklePrefix() {
    return {
        keyPrefix: new Uint8Array(),
    };
}
exports.MerklePrefix = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.keyPrefix.length !== 0) {
            writer.uint32(10).bytes(message.keyPrefix);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMerklePrefix();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.keyPrefix = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            keyPrefix: (0, helpers_1.isSet)(object.keyPrefix) ? (0, helpers_1.bytesFromBase64)(object.keyPrefix) : new Uint8Array(),
        };
    },
    toJSON(message) {
        const obj = {};
        message.keyPrefix !== undefined &&
            (obj.keyPrefix = (0, helpers_1.base64FromBytes)(message.keyPrefix !== undefined ? message.keyPrefix : new Uint8Array()));
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMerklePrefix();
        message.keyPrefix = object.keyPrefix ?? new Uint8Array();
        return message;
    },
};
function createBaseMerklePath() {
    return {
        keyPath: [],
    };
}
exports.MerklePath = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.keyPath) {
            writer.uint32(10).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMerklePath();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.keyPath.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            keyPath: Array.isArray(object?.keyPath) ? object.keyPath.map((e) => String(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.keyPath) {
            obj.keyPath = message.keyPath.map((e) => e);
        }
        else {
            obj.keyPath = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMerklePath();
        message.keyPath = object.keyPath?.map((e) => e) || [];
        return message;
    },
};
function createBaseMerkleProof() {
    return {
        proofs: [],
    };
}
exports.MerkleProof = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.proofs) {
            proofs_1.CommitmentProof.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMerkleProof();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.proofs.push(proofs_1.CommitmentProof.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            proofs: Array.isArray(object?.proofs) ? object.proofs.map((e) => proofs_1.CommitmentProof.fromJSON(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.proofs) {
            obj.proofs = message.proofs.map((e) => (e ? proofs_1.CommitmentProof.toJSON(e) : undefined));
        }
        else {
            obj.proofs = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMerkleProof();
        message.proofs = object.proofs?.map((e) => proofs_1.CommitmentProof.fromPartial(e)) || [];
        return message;
    },
};
//# sourceMappingURL=commitment.js.map

/***/ }),

/***/ 49215:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Params = exports.Version = exports.ConnectionPaths = exports.ClientPaths = exports.Counterparty = exports.IdentifiedConnection = exports.ConnectionEnd = exports.stateToJSON = exports.stateFromJSON = exports.State = exports.protobufPackage = void 0;
/* eslint-disable */
const commitment_1 = __webpack_require__(35408);
const helpers_1 = __webpack_require__(92654);
const _m0 = __importStar(__webpack_require__(62100));
exports.protobufPackage = "ibc.core.connection.v1";
/**
 * State defines if a connection is in one of the following states:
 * INIT, TRYOPEN, OPEN or UNINITIALIZED.
 */
var State;
(function (State) {
    /** STATE_UNINITIALIZED_UNSPECIFIED - Default State */
    State[State["STATE_UNINITIALIZED_UNSPECIFIED"] = 0] = "STATE_UNINITIALIZED_UNSPECIFIED";
    /** STATE_INIT - A connection end has just started the opening handshake. */
    State[State["STATE_INIT"] = 1] = "STATE_INIT";
    /**
     * STATE_TRYOPEN - A connection end has acknowledged the handshake step on the counterparty
     * chain.
     */
    State[State["STATE_TRYOPEN"] = 2] = "STATE_TRYOPEN";
    /** STATE_OPEN - A connection end has completed the handshake. */
    State[State["STATE_OPEN"] = 3] = "STATE_OPEN";
    State[State["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(State = exports.State || (exports.State = {}));
function stateFromJSON(object) {
    switch (object) {
        case 0:
        case "STATE_UNINITIALIZED_UNSPECIFIED":
            return State.STATE_UNINITIALIZED_UNSPECIFIED;
        case 1:
        case "STATE_INIT":
            return State.STATE_INIT;
        case 2:
        case "STATE_TRYOPEN":
            return State.STATE_TRYOPEN;
        case 3:
        case "STATE_OPEN":
            return State.STATE_OPEN;
        case -1:
        case "UNRECOGNIZED":
        default:
            return State.UNRECOGNIZED;
    }
}
exports.stateFromJSON = stateFromJSON;
function stateToJSON(object) {
    switch (object) {
        case State.STATE_UNINITIALIZED_UNSPECIFIED:
            return "STATE_UNINITIALIZED_UNSPECIFIED";
        case State.STATE_INIT:
            return "STATE_INIT";
        case State.STATE_TRYOPEN:
            return "STATE_TRYOPEN";
        case State.STATE_OPEN:
            return "STATE_OPEN";
        case State.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.stateToJSON = stateToJSON;
function createBaseConnectionEnd() {
    return {
        clientId: "",
        versions: [],
        state: 0,
        counterparty: undefined,
        delayPeriod: helpers_1.Long.UZERO,
    };
}
exports.ConnectionEnd = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.clientId !== "") {
            writer.uint32(10).string(message.clientId);
        }
        for (const v of message.versions) {
            exports.Version.encode(v, writer.uint32(18).fork()).ldelim();
        }
        if (message.state !== 0) {
            writer.uint32(24).int32(message.state);
        }
        if (message.counterparty !== undefined) {
            exports.Counterparty.encode(message.counterparty, writer.uint32(34).fork()).ldelim();
        }
        if (!message.delayPeriod.isZero()) {
            writer.uint32(40).uint64(message.delayPeriod);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseConnectionEnd();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.versions.push(exports.Version.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.state = reader.int32();
                    break;
                case 4:
                    message.counterparty = exports.Counterparty.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.delayPeriod = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            clientId: (0, helpers_1.isSet)(object.clientId) ? String(object.clientId) : "",
            versions: Array.isArray(object?.versions) ? object.versions.map((e) => exports.Version.fromJSON(e)) : [],
            state: (0, helpers_1.isSet)(object.state) ? stateFromJSON(object.state) : 0,
            counterparty: (0, helpers_1.isSet)(object.counterparty) ? exports.Counterparty.fromJSON(object.counterparty) : undefined,
            delayPeriod: (0, helpers_1.isSet)(object.delayPeriod) ? helpers_1.Long.fromValue(object.delayPeriod) : helpers_1.Long.UZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        if (message.versions) {
            obj.versions = message.versions.map((e) => (e ? exports.Version.toJSON(e) : undefined));
        }
        else {
            obj.versions = [];
        }
        message.state !== undefined && (obj.state = stateToJSON(message.state));
        message.counterparty !== undefined &&
            (obj.counterparty = message.counterparty ? exports.Counterparty.toJSON(message.counterparty) : undefined);
        message.delayPeriod !== undefined && (obj.delayPeriod = (message.delayPeriod || helpers_1.Long.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseConnectionEnd();
        message.clientId = object.clientId ?? "";
        message.versions = object.versions?.map((e) => exports.Version.fromPartial(e)) || [];
        message.state = object.state ?? 0;
        message.counterparty =
            object.counterparty !== undefined && object.counterparty !== null
                ? exports.Counterparty.fromPartial(object.counterparty)
                : undefined;
        message.delayPeriod =
            object.delayPeriod !== undefined && object.delayPeriod !== null
                ? helpers_1.Long.fromValue(object.delayPeriod)
                : helpers_1.Long.UZERO;
        return message;
    },
};
function createBaseIdentifiedConnection() {
    return {
        id: "",
        clientId: "",
        versions: [],
        state: 0,
        counterparty: undefined,
        delayPeriod: helpers_1.Long.UZERO,
    };
}
exports.IdentifiedConnection = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.id !== "") {
            writer.uint32(10).string(message.id);
        }
        if (message.clientId !== "") {
            writer.uint32(18).string(message.clientId);
        }
        for (const v of message.versions) {
            exports.Version.encode(v, writer.uint32(26).fork()).ldelim();
        }
        if (message.state !== 0) {
            writer.uint32(32).int32(message.state);
        }
        if (message.counterparty !== undefined) {
            exports.Counterparty.encode(message.counterparty, writer.uint32(42).fork()).ldelim();
        }
        if (!message.delayPeriod.isZero()) {
            writer.uint32(48).uint64(message.delayPeriod);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseIdentifiedConnection();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.id = reader.string();
                    break;
                case 2:
                    message.clientId = reader.string();
                    break;
                case 3:
                    message.versions.push(exports.Version.decode(reader, reader.uint32()));
                    break;
                case 4:
                    message.state = reader.int32();
                    break;
                case 5:
                    message.counterparty = exports.Counterparty.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.delayPeriod = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            id: (0, helpers_1.isSet)(object.id) ? String(object.id) : "",
            clientId: (0, helpers_1.isSet)(object.clientId) ? String(object.clientId) : "",
            versions: Array.isArray(object?.versions) ? object.versions.map((e) => exports.Version.fromJSON(e)) : [],
            state: (0, helpers_1.isSet)(object.state) ? stateFromJSON(object.state) : 0,
            counterparty: (0, helpers_1.isSet)(object.counterparty) ? exports.Counterparty.fromJSON(object.counterparty) : undefined,
            delayPeriod: (0, helpers_1.isSet)(object.delayPeriod) ? helpers_1.Long.fromValue(object.delayPeriod) : helpers_1.Long.UZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        message.id !== undefined && (obj.id = message.id);
        message.clientId !== undefined && (obj.clientId = message.clientId);
        if (message.versions) {
            obj.versions = message.versions.map((e) => (e ? exports.Version.toJSON(e) : undefined));
        }
        else {
            obj.versions = [];
        }
        message.state !== undefined && (obj.state = stateToJSON(message.state));
        message.counterparty !== undefined &&
            (obj.counterparty = message.counterparty ? exports.Counterparty.toJSON(message.counterparty) : undefined);
        message.delayPeriod !== undefined && (obj.delayPeriod = (message.delayPeriod || helpers_1.Long.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseIdentifiedConnection();
        message.id = object.id ?? "";
        message.clientId = object.clientId ?? "";
        message.versions = object.versions?.map((e) => exports.Version.fromPartial(e)) || [];
        message.state = object.state ?? 0;
        message.counterparty =
            object.counterparty !== undefined && object.counterparty !== null
                ? exports.Counterparty.fromPartial(object.counterparty)
                : undefined;
        message.delayPeriod =
            object.delayPeriod !== undefined && object.delayPeriod !== null
                ? helpers_1.Long.fromValue(object.delayPeriod)
                : helpers_1.Long.UZERO;
        return message;
    },
};
function createBaseCounterparty() {
    return {
        clientId: "",
        connectionId: "",
        prefix: undefined,
    };
}
exports.Counterparty = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.clientId !== "") {
            writer.uint32(10).string(message.clientId);
        }
        if (message.connectionId !== "") {
            writer.uint32(18).string(message.connectionId);
        }
        if (message.prefix !== undefined) {
            commitment_1.MerklePrefix.encode(message.prefix, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCounterparty();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.connectionId = reader.string();
                    break;
                case 3:
                    message.prefix = commitment_1.MerklePrefix.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            clientId: (0, helpers_1.isSet)(object.clientId) ? String(object.clientId) : "",
            connectionId: (0, helpers_1.isSet)(object.connectionId) ? String(object.connectionId) : "",
            prefix: (0, helpers_1.isSet)(object.prefix) ? commitment_1.MerklePrefix.fromJSON(object.prefix) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        message.connectionId !== undefined && (obj.connectionId = message.connectionId);
        message.prefix !== undefined &&
            (obj.prefix = message.prefix ? commitment_1.MerklePrefix.toJSON(message.prefix) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseCounterparty();
        message.clientId = object.clientId ?? "";
        message.connectionId = object.connectionId ?? "";
        message.prefix =
            object.prefix !== undefined && object.prefix !== null
                ? commitment_1.MerklePrefix.fromPartial(object.prefix)
                : undefined;
        return message;
    },
};
function createBaseClientPaths() {
    return {
        paths: [],
    };
}
exports.ClientPaths = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.paths) {
            writer.uint32(10).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseClientPaths();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.paths.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            paths: Array.isArray(object?.paths) ? object.paths.map((e) => String(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.paths) {
            obj.paths = message.paths.map((e) => e);
        }
        else {
            obj.paths = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseClientPaths();
        message.paths = object.paths?.map((e) => e) || [];
        return message;
    },
};
function createBaseConnectionPaths() {
    return {
        clientId: "",
        paths: [],
    };
}
exports.ConnectionPaths = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.clientId !== "") {
            writer.uint32(10).string(message.clientId);
        }
        for (const v of message.paths) {
            writer.uint32(18).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseConnectionPaths();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.paths.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            clientId: (0, helpers_1.isSet)(object.clientId) ? String(object.clientId) : "",
            paths: Array.isArray(object?.paths) ? object.paths.map((e) => String(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        if (message.paths) {
            obj.paths = message.paths.map((e) => e);
        }
        else {
            obj.paths = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseConnectionPaths();
        message.clientId = object.clientId ?? "";
        message.paths = object.paths?.map((e) => e) || [];
        return message;
    },
};
function createBaseVersion() {
    return {
        identifier: "",
        features: [],
    };
}
exports.Version = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.identifier !== "") {
            writer.uint32(10).string(message.identifier);
        }
        for (const v of message.features) {
            writer.uint32(18).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVersion();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.identifier = reader.string();
                    break;
                case 2:
                    message.features.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            identifier: (0, helpers_1.isSet)(object.identifier) ? String(object.identifier) : "",
            features: Array.isArray(object?.features) ? object.features.map((e) => String(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        message.identifier !== undefined && (obj.identifier = message.identifier);
        if (message.features) {
            obj.features = message.features.map((e) => e);
        }
        else {
            obj.features = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseVersion();
        message.identifier = object.identifier ?? "";
        message.features = object.features?.map((e) => e) || [];
        return message;
    },
};
function createBaseParams() {
    return {
        maxExpectedTimePerBlock: helpers_1.Long.UZERO,
    };
}
exports.Params = {
    encode(message, writer = _m0.Writer.create()) {
        if (!message.maxExpectedTimePerBlock.isZero()) {
            writer.uint32(8).uint64(message.maxExpectedTimePerBlock);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseParams();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.maxExpectedTimePerBlock = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            maxExpectedTimePerBlock: (0, helpers_1.isSet)(object.maxExpectedTimePerBlock)
                ? helpers_1.Long.fromValue(object.maxExpectedTimePerBlock)
                : helpers_1.Long.UZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        message.maxExpectedTimePerBlock !== undefined &&
            (obj.maxExpectedTimePerBlock = (message.maxExpectedTimePerBlock || helpers_1.Long.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseParams();
        message.maxExpectedTimePerBlock =
            object.maxExpectedTimePerBlock !== undefined && object.maxExpectedTimePerBlock !== null
                ? helpers_1.Long.fromValue(object.maxExpectedTimePerBlock)
                : helpers_1.Long.UZERO;
        return message;
    },
};
//# sourceMappingURL=connection.js.map

/***/ }),

/***/ 67014:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.QueryClientImpl = exports.QueryConnectionParamsResponse = exports.QueryConnectionParamsRequest = exports.QueryConnectionConsensusStateResponse = exports.QueryConnectionConsensusStateRequest = exports.QueryConnectionClientStateResponse = exports.QueryConnectionClientStateRequest = exports.QueryClientConnectionsResponse = exports.QueryClientConnectionsRequest = exports.QueryConnectionsResponse = exports.QueryConnectionsRequest = exports.QueryConnectionResponse = exports.QueryConnectionRequest = exports.protobufPackage = void 0;
/* eslint-disable */
const pagination_1 = __webpack_require__(84043);
const connection_1 = __webpack_require__(49215);
const client_1 = __webpack_require__(30085);
const any_1 = __webpack_require__(75654);
const helpers_1 = __webpack_require__(92654);
const _m0 = __importStar(__webpack_require__(62100));
exports.protobufPackage = "ibc.core.connection.v1";
function createBaseQueryConnectionRequest() {
    return {
        connectionId: "",
    };
}
exports.QueryConnectionRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.connectionId !== "") {
            writer.uint32(10).string(message.connectionId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryConnectionRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.connectionId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            connectionId: (0, helpers_1.isSet)(object.connectionId) ? String(object.connectionId) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.connectionId !== undefined && (obj.connectionId = message.connectionId);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryConnectionRequest();
        message.connectionId = object.connectionId ?? "";
        return message;
    },
};
function createBaseQueryConnectionResponse() {
    return {
        connection: undefined,
        proof: new Uint8Array(),
        proofHeight: undefined,
    };
}
exports.QueryConnectionResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.connection !== undefined) {
            connection_1.ConnectionEnd.encode(message.connection, writer.uint32(10).fork()).ldelim();
        }
        if (message.proof.length !== 0) {
            writer.uint32(18).bytes(message.proof);
        }
        if (message.proofHeight !== undefined) {
            client_1.Height.encode(message.proofHeight, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryConnectionResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.connection = connection_1.ConnectionEnd.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.proof = reader.bytes();
                    break;
                case 3:
                    message.proofHeight = client_1.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            connection: (0, helpers_1.isSet)(object.connection) ? connection_1.ConnectionEnd.fromJSON(object.connection) : undefined,
            proof: (0, helpers_1.isSet)(object.proof) ? (0, helpers_1.bytesFromBase64)(object.proof) : new Uint8Array(),
            proofHeight: (0, helpers_1.isSet)(object.proofHeight) ? client_1.Height.fromJSON(object.proofHeight) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.connection !== undefined &&
            (obj.connection = message.connection ? connection_1.ConnectionEnd.toJSON(message.connection) : undefined);
        message.proof !== undefined &&
            (obj.proof = (0, helpers_1.base64FromBytes)(message.proof !== undefined ? message.proof : new Uint8Array()));
        message.proofHeight !== undefined &&
            (obj.proofHeight = message.proofHeight ? client_1.Height.toJSON(message.proofHeight) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryConnectionResponse();
        message.connection =
            object.connection !== undefined && object.connection !== null
                ? connection_1.ConnectionEnd.fromPartial(object.connection)
                : undefined;
        message.proof = object.proof ?? new Uint8Array();
        message.proofHeight =
            object.proofHeight !== undefined && object.proofHeight !== null
                ? client_1.Height.fromPartial(object.proofHeight)
                : undefined;
        return message;
    },
};
function createBaseQueryConnectionsRequest() {
    return {
        pagination: undefined,
    };
}
exports.QueryConnectionsRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryConnectionsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            pagination: (0, helpers_1.isSet)(object.pagination) ? pagination_1.PageRequest.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryConnectionsRequest();
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryConnectionsResponse() {
    return {
        connections: [],
        pagination: undefined,
        height: undefined,
    };
}
exports.QueryConnectionsResponse = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.connections) {
            connection_1.IdentifiedConnection.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        if (message.height !== undefined) {
            client_1.Height.encode(message.height, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryConnectionsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.connections.push(connection_1.IdentifiedConnection.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.height = client_1.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            connections: Array.isArray(object?.connections)
                ? object.connections.map((e) => connection_1.IdentifiedConnection.fromJSON(e))
                : [],
            pagination: (0, helpers_1.isSet)(object.pagination) ? pagination_1.PageResponse.fromJSON(object.pagination) : undefined,
            height: (0, helpers_1.isSet)(object.height) ? client_1.Height.fromJSON(object.height) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.connections) {
            obj.connections = message.connections.map((e) => (e ? connection_1.IdentifiedConnection.toJSON(e) : undefined));
        }
        else {
            obj.connections = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageResponse.toJSON(message.pagination) : undefined);
        message.height !== undefined && (obj.height = message.height ? client_1.Height.toJSON(message.height) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryConnectionsResponse();
        message.connections = object.connections?.map((e) => connection_1.IdentifiedConnection.fromPartial(e)) || [];
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        message.height =
            object.height !== undefined && object.height !== null ? client_1.Height.fromPartial(object.height) : undefined;
        return message;
    },
};
function createBaseQueryClientConnectionsRequest() {
    return {
        clientId: "",
    };
}
exports.QueryClientConnectionsRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.clientId !== "") {
            writer.uint32(10).string(message.clientId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryClientConnectionsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.clientId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            clientId: (0, helpers_1.isSet)(object.clientId) ? String(object.clientId) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryClientConnectionsRequest();
        message.clientId = object.clientId ?? "";
        return message;
    },
};
function createBaseQueryClientConnectionsResponse() {
    return {
        connectionPaths: [],
        proof: new Uint8Array(),
        proofHeight: undefined,
    };
}
exports.QueryClientConnectionsResponse = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.connectionPaths) {
            writer.uint32(10).string(v);
        }
        if (message.proof.length !== 0) {
            writer.uint32(18).bytes(message.proof);
        }
        if (message.proofHeight !== undefined) {
            client_1.Height.encode(message.proofHeight, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryClientConnectionsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.connectionPaths.push(reader.string());
                    break;
                case 2:
                    message.proof = reader.bytes();
                    break;
                case 3:
                    message.proofHeight = client_1.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            connectionPaths: Array.isArray(object?.connectionPaths)
                ? object.connectionPaths.map((e) => String(e))
                : [],
            proof: (0, helpers_1.isSet)(object.proof) ? (0, helpers_1.bytesFromBase64)(object.proof) : new Uint8Array(),
            proofHeight: (0, helpers_1.isSet)(object.proofHeight) ? client_1.Height.fromJSON(object.proofHeight) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.connectionPaths) {
            obj.connectionPaths = message.connectionPaths.map((e) => e);
        }
        else {
            obj.connectionPaths = [];
        }
        message.proof !== undefined &&
            (obj.proof = (0, helpers_1.base64FromBytes)(message.proof !== undefined ? message.proof : new Uint8Array()));
        message.proofHeight !== undefined &&
            (obj.proofHeight = message.proofHeight ? client_1.Height.toJSON(message.proofHeight) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryClientConnectionsResponse();
        message.connectionPaths = object.connectionPaths?.map((e) => e) || [];
        message.proof = object.proof ?? new Uint8Array();
        message.proofHeight =
            object.proofHeight !== undefined && object.proofHeight !== null
                ? client_1.Height.fromPartial(object.proofHeight)
                : undefined;
        return message;
    },
};
function createBaseQueryConnectionClientStateRequest() {
    return {
        connectionId: "",
    };
}
exports.QueryConnectionClientStateRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.connectionId !== "") {
            writer.uint32(10).string(message.connectionId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryConnectionClientStateRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.connectionId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            connectionId: (0, helpers_1.isSet)(object.connectionId) ? String(object.connectionId) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.connectionId !== undefined && (obj.connectionId = message.connectionId);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryConnectionClientStateRequest();
        message.connectionId = object.connectionId ?? "";
        return message;
    },
};
function createBaseQueryConnectionClientStateResponse() {
    return {
        identifiedClientState: undefined,
        proof: new Uint8Array(),
        proofHeight: undefined,
    };
}
exports.QueryConnectionClientStateResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.identifiedClientState !== undefined) {
            client_1.IdentifiedClientState.encode(message.identifiedClientState, writer.uint32(10).fork()).ldelim();
        }
        if (message.proof.length !== 0) {
            writer.uint32(18).bytes(message.proof);
        }
        if (message.proofHeight !== undefined) {
            client_1.Height.encode(message.proofHeight, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryConnectionClientStateResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.identifiedClientState = client_1.IdentifiedClientState.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.proof = reader.bytes();
                    break;
                case 3:
                    message.proofHeight = client_1.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            identifiedClientState: (0, helpers_1.isSet)(object.identifiedClientState)
                ? client_1.IdentifiedClientState.fromJSON(object.identifiedClientState)
                : undefined,
            proof: (0, helpers_1.isSet)(object.proof) ? (0, helpers_1.bytesFromBase64)(object.proof) : new Uint8Array(),
            proofHeight: (0, helpers_1.isSet)(object.proofHeight) ? client_1.Height.fromJSON(object.proofHeight) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.identifiedClientState !== undefined &&
            (obj.identifiedClientState = message.identifiedClientState
                ? client_1.IdentifiedClientState.toJSON(message.identifiedClientState)
                : undefined);
        message.proof !== undefined &&
            (obj.proof = (0, helpers_1.base64FromBytes)(message.proof !== undefined ? message.proof : new Uint8Array()));
        message.proofHeight !== undefined &&
            (obj.proofHeight = message.proofHeight ? client_1.Height.toJSON(message.proofHeight) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryConnectionClientStateResponse();
        message.identifiedClientState =
            object.identifiedClientState !== undefined && object.identifiedClientState !== null
                ? client_1.IdentifiedClientState.fromPartial(object.identifiedClientState)
                : undefined;
        message.proof = object.proof ?? new Uint8Array();
        message.proofHeight =
            object.proofHeight !== undefined && object.proofHeight !== null
                ? client_1.Height.fromPartial(object.proofHeight)
                : undefined;
        return message;
    },
};
function createBaseQueryConnectionConsensusStateRequest() {
    return {
        connectionId: "",
        revisionNumber: helpers_1.Long.UZERO,
        revisionHeight: helpers_1.Long.UZERO,
    };
}
exports.QueryConnectionConsensusStateRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.connectionId !== "") {
            writer.uint32(10).string(message.connectionId);
        }
        if (!message.revisionNumber.isZero()) {
            writer.uint32(16).uint64(message.revisionNumber);
        }
        if (!message.revisionHeight.isZero()) {
            writer.uint32(24).uint64(message.revisionHeight);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryConnectionConsensusStateRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.connectionId = reader.string();
                    break;
                case 2:
                    message.revisionNumber = reader.uint64();
                    break;
                case 3:
                    message.revisionHeight = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            connectionId: (0, helpers_1.isSet)(object.connectionId) ? String(object.connectionId) : "",
            revisionNumber: (0, helpers_1.isSet)(object.revisionNumber) ? helpers_1.Long.fromValue(object.revisionNumber) : helpers_1.Long.UZERO,
            revisionHeight: (0, helpers_1.isSet)(object.revisionHeight) ? helpers_1.Long.fromValue(object.revisionHeight) : helpers_1.Long.UZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        message.connectionId !== undefined && (obj.connectionId = message.connectionId);
        message.revisionNumber !== undefined &&
            (obj.revisionNumber = (message.revisionNumber || helpers_1.Long.UZERO).toString());
        message.revisionHeight !== undefined &&
            (obj.revisionHeight = (message.revisionHeight || helpers_1.Long.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryConnectionConsensusStateRequest();
        message.connectionId = object.connectionId ?? "";
        message.revisionNumber =
            object.revisionNumber !== undefined && object.revisionNumber !== null
                ? helpers_1.Long.fromValue(object.revisionNumber)
                : helpers_1.Long.UZERO;
        message.revisionHeight =
            object.revisionHeight !== undefined && object.revisionHeight !== null
                ? helpers_1.Long.fromValue(object.revisionHeight)
                : helpers_1.Long.UZERO;
        return message;
    },
};
function createBaseQueryConnectionConsensusStateResponse() {
    return {
        consensusState: undefined,
        clientId: "",
        proof: new Uint8Array(),
        proofHeight: undefined,
    };
}
exports.QueryConnectionConsensusStateResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.consensusState !== undefined) {
            any_1.Any.encode(message.consensusState, writer.uint32(10).fork()).ldelim();
        }
        if (message.clientId !== "") {
            writer.uint32(18).string(message.clientId);
        }
        if (message.proof.length !== 0) {
            writer.uint32(26).bytes(message.proof);
        }
        if (message.proofHeight !== undefined) {
            client_1.Height.encode(message.proofHeight, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryConnectionConsensusStateResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.consensusState = any_1.Any.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.clientId = reader.string();
                    break;
                case 3:
                    message.proof = reader.bytes();
                    break;
                case 4:
                    message.proofHeight = client_1.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            consensusState: (0, helpers_1.isSet)(object.consensusState) ? any_1.Any.fromJSON(object.consensusState) : undefined,
            clientId: (0, helpers_1.isSet)(object.clientId) ? String(object.clientId) : "",
            proof: (0, helpers_1.isSet)(object.proof) ? (0, helpers_1.bytesFromBase64)(object.proof) : new Uint8Array(),
            proofHeight: (0, helpers_1.isSet)(object.proofHeight) ? client_1.Height.fromJSON(object.proofHeight) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.consensusState !== undefined &&
            (obj.consensusState = message.consensusState ? any_1.Any.toJSON(message.consensusState) : undefined);
        message.clientId !== undefined && (obj.clientId = message.clientId);
        message.proof !== undefined &&
            (obj.proof = (0, helpers_1.base64FromBytes)(message.proof !== undefined ? message.proof : new Uint8Array()));
        message.proofHeight !== undefined &&
            (obj.proofHeight = message.proofHeight ? client_1.Height.toJSON(message.proofHeight) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryConnectionConsensusStateResponse();
        message.consensusState =
            object.consensusState !== undefined && object.consensusState !== null
                ? any_1.Any.fromPartial(object.consensusState)
                : undefined;
        message.clientId = object.clientId ?? "";
        message.proof = object.proof ?? new Uint8Array();
        message.proofHeight =
            object.proofHeight !== undefined && object.proofHeight !== null
                ? client_1.Height.fromPartial(object.proofHeight)
                : undefined;
        return message;
    },
};
function createBaseQueryConnectionParamsRequest() {
    return {};
}
exports.QueryConnectionParamsRequest = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryConnectionParamsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseQueryConnectionParamsRequest();
        return message;
    },
};
function createBaseQueryConnectionParamsResponse() {
    return {
        params: undefined,
    };
}
exports.QueryConnectionParamsResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.params !== undefined) {
            client_1.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryConnectionParamsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.params = client_1.Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            params: (0, helpers_1.isSet)(object.params) ? client_1.Params.fromJSON(object.params) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.params !== undefined && (obj.params = message.params ? client_1.Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryConnectionParamsResponse();
        message.params =
            object.params !== undefined && object.params !== null ? client_1.Params.fromPartial(object.params) : undefined;
        return message;
    },
};
class QueryClientImpl {
    constructor(rpc) {
        this.rpc = rpc;
        this.Connection = this.Connection.bind(this);
        this.Connections = this.Connections.bind(this);
        this.ClientConnections = this.ClientConnections.bind(this);
        this.ConnectionClientState = this.ConnectionClientState.bind(this);
        this.ConnectionConsensusState = this.ConnectionConsensusState.bind(this);
        this.ConnectionParams = this.ConnectionParams.bind(this);
    }
    Connection(request) {
        const data = exports.QueryConnectionRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.connection.v1.Query", "Connection", data);
        return promise.then((data) => exports.QueryConnectionResponse.decode(new _m0.Reader(data)));
    }
    Connections(request = {
        pagination: undefined,
    }) {
        const data = exports.QueryConnectionsRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.connection.v1.Query", "Connections", data);
        return promise.then((data) => exports.QueryConnectionsResponse.decode(new _m0.Reader(data)));
    }
    ClientConnections(request) {
        const data = exports.QueryClientConnectionsRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.connection.v1.Query", "ClientConnections", data);
        return promise.then((data) => exports.QueryClientConnectionsResponse.decode(new _m0.Reader(data)));
    }
    ConnectionClientState(request) {
        const data = exports.QueryConnectionClientStateRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.connection.v1.Query", "ConnectionClientState", data);
        return promise.then((data) => exports.QueryConnectionClientStateResponse.decode(new _m0.Reader(data)));
    }
    ConnectionConsensusState(request) {
        const data = exports.QueryConnectionConsensusStateRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.connection.v1.Query", "ConnectionConsensusState", data);
        return promise.then((data) => exports.QueryConnectionConsensusStateResponse.decode(new _m0.Reader(data)));
    }
    ConnectionParams(request = {}) {
        const data = exports.QueryConnectionParamsRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.connection.v1.Query", "ConnectionParams", data);
        return promise.then((data) => exports.QueryConnectionParamsResponse.decode(new _m0.Reader(data)));
    }
}
exports.QueryClientImpl = QueryClientImpl;
//# sourceMappingURL=query.js.map

/***/ }),

/***/ 41579:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MsgClientImpl = exports.MsgConnectionOpenConfirmResponse = exports.MsgConnectionOpenConfirm = exports.MsgConnectionOpenAckResponse = exports.MsgConnectionOpenAck = exports.MsgConnectionOpenTryResponse = exports.MsgConnectionOpenTry = exports.MsgConnectionOpenInitResponse = exports.MsgConnectionOpenInit = exports.protobufPackage = void 0;
/* eslint-disable */
const connection_1 = __webpack_require__(49215);
const any_1 = __webpack_require__(75654);
const client_1 = __webpack_require__(30085);
const helpers_1 = __webpack_require__(92654);
const _m0 = __importStar(__webpack_require__(62100));
exports.protobufPackage = "ibc.core.connection.v1";
function createBaseMsgConnectionOpenInit() {
    return {
        clientId: "",
        counterparty: undefined,
        version: undefined,
        delayPeriod: helpers_1.Long.UZERO,
        signer: "",
    };
}
exports.MsgConnectionOpenInit = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.clientId !== "") {
            writer.uint32(10).string(message.clientId);
        }
        if (message.counterparty !== undefined) {
            connection_1.Counterparty.encode(message.counterparty, writer.uint32(18).fork()).ldelim();
        }
        if (message.version !== undefined) {
            connection_1.Version.encode(message.version, writer.uint32(26).fork()).ldelim();
        }
        if (!message.delayPeriod.isZero()) {
            writer.uint32(32).uint64(message.delayPeriod);
        }
        if (message.signer !== "") {
            writer.uint32(42).string(message.signer);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgConnectionOpenInit();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.counterparty = connection_1.Counterparty.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.version = connection_1.Version.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.delayPeriod = reader.uint64();
                    break;
                case 5:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            clientId: (0, helpers_1.isSet)(object.clientId) ? String(object.clientId) : "",
            counterparty: (0, helpers_1.isSet)(object.counterparty) ? connection_1.Counterparty.fromJSON(object.counterparty) : undefined,
            version: (0, helpers_1.isSet)(object.version) ? connection_1.Version.fromJSON(object.version) : undefined,
            delayPeriod: (0, helpers_1.isSet)(object.delayPeriod) ? helpers_1.Long.fromValue(object.delayPeriod) : helpers_1.Long.UZERO,
            signer: (0, helpers_1.isSet)(object.signer) ? String(object.signer) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        message.counterparty !== undefined &&
            (obj.counterparty = message.counterparty ? connection_1.Counterparty.toJSON(message.counterparty) : undefined);
        message.version !== undefined &&
            (obj.version = message.version ? connection_1.Version.toJSON(message.version) : undefined);
        message.delayPeriod !== undefined && (obj.delayPeriod = (message.delayPeriod || helpers_1.Long.UZERO).toString());
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgConnectionOpenInit();
        message.clientId = object.clientId ?? "";
        message.counterparty =
            object.counterparty !== undefined && object.counterparty !== null
                ? connection_1.Counterparty.fromPartial(object.counterparty)
                : undefined;
        message.version =
            object.version !== undefined && object.version !== null
                ? connection_1.Version.fromPartial(object.version)
                : undefined;
        message.delayPeriod =
            object.delayPeriod !== undefined && object.delayPeriod !== null
                ? helpers_1.Long.fromValue(object.delayPeriod)
                : helpers_1.Long.UZERO;
        message.signer = object.signer ?? "";
        return message;
    },
};
function createBaseMsgConnectionOpenInitResponse() {
    return {};
}
exports.MsgConnectionOpenInitResponse = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgConnectionOpenInitResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgConnectionOpenInitResponse();
        return message;
    },
};
function createBaseMsgConnectionOpenTry() {
    return {
        clientId: "",
        previousConnectionId: "",
        clientState: undefined,
        counterparty: undefined,
        delayPeriod: helpers_1.Long.UZERO,
        counterpartyVersions: [],
        proofHeight: undefined,
        proofInit: new Uint8Array(),
        proofClient: new Uint8Array(),
        proofConsensus: new Uint8Array(),
        consensusHeight: undefined,
        signer: "",
        hostConsensusStateProof: new Uint8Array(),
    };
}
exports.MsgConnectionOpenTry = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.clientId !== "") {
            writer.uint32(10).string(message.clientId);
        }
        if (message.previousConnectionId !== "") {
            writer.uint32(18).string(message.previousConnectionId);
        }
        if (message.clientState !== undefined) {
            any_1.Any.encode(message.clientState, writer.uint32(26).fork()).ldelim();
        }
        if (message.counterparty !== undefined) {
            connection_1.Counterparty.encode(message.counterparty, writer.uint32(34).fork()).ldelim();
        }
        if (!message.delayPeriod.isZero()) {
            writer.uint32(40).uint64(message.delayPeriod);
        }
        for (const v of message.counterpartyVersions) {
            connection_1.Version.encode(v, writer.uint32(50).fork()).ldelim();
        }
        if (message.proofHeight !== undefined) {
            client_1.Height.encode(message.proofHeight, writer.uint32(58).fork()).ldelim();
        }
        if (message.proofInit.length !== 0) {
            writer.uint32(66).bytes(message.proofInit);
        }
        if (message.proofClient.length !== 0) {
            writer.uint32(74).bytes(message.proofClient);
        }
        if (message.proofConsensus.length !== 0) {
            writer.uint32(82).bytes(message.proofConsensus);
        }
        if (message.consensusHeight !== undefined) {
            client_1.Height.encode(message.consensusHeight, writer.uint32(90).fork()).ldelim();
        }
        if (message.signer !== "") {
            writer.uint32(98).string(message.signer);
        }
        if (message.hostConsensusStateProof.length !== 0) {
            writer.uint32(106).bytes(message.hostConsensusStateProof);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgConnectionOpenTry();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.previousConnectionId = reader.string();
                    break;
                case 3:
                    message.clientState = any_1.Any.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.counterparty = connection_1.Counterparty.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.delayPeriod = reader.uint64();
                    break;
                case 6:
                    message.counterpartyVersions.push(connection_1.Version.decode(reader, reader.uint32()));
                    break;
                case 7:
                    message.proofHeight = client_1.Height.decode(reader, reader.uint32());
                    break;
                case 8:
                    message.proofInit = reader.bytes();
                    break;
                case 9:
                    message.proofClient = reader.bytes();
                    break;
                case 10:
                    message.proofConsensus = reader.bytes();
                    break;
                case 11:
                    message.consensusHeight = client_1.Height.decode(reader, reader.uint32());
                    break;
                case 12:
                    message.signer = reader.string();
                    break;
                case 13:
                    message.hostConsensusStateProof = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            clientId: (0, helpers_1.isSet)(object.clientId) ? String(object.clientId) : "",
            previousConnectionId: (0, helpers_1.isSet)(object.previousConnectionId) ? String(object.previousConnectionId) : "",
            clientState: (0, helpers_1.isSet)(object.clientState) ? any_1.Any.fromJSON(object.clientState) : undefined,
            counterparty: (0, helpers_1.isSet)(object.counterparty) ? connection_1.Counterparty.fromJSON(object.counterparty) : undefined,
            delayPeriod: (0, helpers_1.isSet)(object.delayPeriod) ? helpers_1.Long.fromValue(object.delayPeriod) : helpers_1.Long.UZERO,
            counterpartyVersions: Array.isArray(object?.counterpartyVersions)
                ? object.counterpartyVersions.map((e) => connection_1.Version.fromJSON(e))
                : [],
            proofHeight: (0, helpers_1.isSet)(object.proofHeight) ? client_1.Height.fromJSON(object.proofHeight) : undefined,
            proofInit: (0, helpers_1.isSet)(object.proofInit) ? (0, helpers_1.bytesFromBase64)(object.proofInit) : new Uint8Array(),
            proofClient: (0, helpers_1.isSet)(object.proofClient) ? (0, helpers_1.bytesFromBase64)(object.proofClient) : new Uint8Array(),
            proofConsensus: (0, helpers_1.isSet)(object.proofConsensus)
                ? (0, helpers_1.bytesFromBase64)(object.proofConsensus)
                : new Uint8Array(),
            consensusHeight: (0, helpers_1.isSet)(object.consensusHeight) ? client_1.Height.fromJSON(object.consensusHeight) : undefined,
            signer: (0, helpers_1.isSet)(object.signer) ? String(object.signer) : "",
            hostConsensusStateProof: (0, helpers_1.isSet)(object.hostConsensusStateProof)
                ? (0, helpers_1.bytesFromBase64)(object.hostConsensusStateProof)
                : new Uint8Array(),
        };
    },
    toJSON(message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        message.previousConnectionId !== undefined && (obj.previousConnectionId = message.previousConnectionId);
        message.clientState !== undefined &&
            (obj.clientState = message.clientState ? any_1.Any.toJSON(message.clientState) : undefined);
        message.counterparty !== undefined &&
            (obj.counterparty = message.counterparty ? connection_1.Counterparty.toJSON(message.counterparty) : undefined);
        message.delayPeriod !== undefined && (obj.delayPeriod = (message.delayPeriod || helpers_1.Long.UZERO).toString());
        if (message.counterpartyVersions) {
            obj.counterpartyVersions = message.counterpartyVersions.map((e) => (e ? connection_1.Version.toJSON(e) : undefined));
        }
        else {
            obj.counterpartyVersions = [];
        }
        message.proofHeight !== undefined &&
            (obj.proofHeight = message.proofHeight ? client_1.Height.toJSON(message.proofHeight) : undefined);
        message.proofInit !== undefined &&
            (obj.proofInit = (0, helpers_1.base64FromBytes)(message.proofInit !== undefined ? message.proofInit : new Uint8Array()));
        message.proofClient !== undefined &&
            (obj.proofClient = (0, helpers_1.base64FromBytes)(message.proofClient !== undefined ? message.proofClient : new Uint8Array()));
        message.proofConsensus !== undefined &&
            (obj.proofConsensus = (0, helpers_1.base64FromBytes)(message.proofConsensus !== undefined ? message.proofConsensus : new Uint8Array()));
        message.consensusHeight !== undefined &&
            (obj.consensusHeight = message.consensusHeight ? client_1.Height.toJSON(message.consensusHeight) : undefined);
        message.signer !== undefined && (obj.signer = message.signer);
        message.hostConsensusStateProof !== undefined &&
            (obj.hostConsensusStateProof = (0, helpers_1.base64FromBytes)(message.hostConsensusStateProof !== undefined ? message.hostConsensusStateProof : new Uint8Array()));
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgConnectionOpenTry();
        message.clientId = object.clientId ?? "";
        message.previousConnectionId = object.previousConnectionId ?? "";
        message.clientState =
            object.clientState !== undefined && object.clientState !== null
                ? any_1.Any.fromPartial(object.clientState)
                : undefined;
        message.counterparty =
            object.counterparty !== undefined && object.counterparty !== null
                ? connection_1.Counterparty.fromPartial(object.counterparty)
                : undefined;
        message.delayPeriod =
            object.delayPeriod !== undefined && object.delayPeriod !== null
                ? helpers_1.Long.fromValue(object.delayPeriod)
                : helpers_1.Long.UZERO;
        message.counterpartyVersions = object.counterpartyVersions?.map((e) => connection_1.Version.fromPartial(e)) || [];
        message.proofHeight =
            object.proofHeight !== undefined && object.proofHeight !== null
                ? client_1.Height.fromPartial(object.proofHeight)
                : undefined;
        message.proofInit = object.proofInit ?? new Uint8Array();
        message.proofClient = object.proofClient ?? new Uint8Array();
        message.proofConsensus = object.proofConsensus ?? new Uint8Array();
        message.consensusHeight =
            object.consensusHeight !== undefined && object.consensusHeight !== null
                ? client_1.Height.fromPartial(object.consensusHeight)
                : undefined;
        message.signer = object.signer ?? "";
        message.hostConsensusStateProof = object.hostConsensusStateProof ?? new Uint8Array();
        return message;
    },
};
function createBaseMsgConnectionOpenTryResponse() {
    return {};
}
exports.MsgConnectionOpenTryResponse = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgConnectionOpenTryResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgConnectionOpenTryResponse();
        return message;
    },
};
function createBaseMsgConnectionOpenAck() {
    return {
        connectionId: "",
        counterpartyConnectionId: "",
        version: undefined,
        clientState: undefined,
        proofHeight: undefined,
        proofTry: new Uint8Array(),
        proofClient: new Uint8Array(),
        proofConsensus: new Uint8Array(),
        consensusHeight: undefined,
        signer: "",
        hostConsensusStateProof: new Uint8Array(),
    };
}
exports.MsgConnectionOpenAck = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.connectionId !== "") {
            writer.uint32(10).string(message.connectionId);
        }
        if (message.counterpartyConnectionId !== "") {
            writer.uint32(18).string(message.counterpartyConnectionId);
        }
        if (message.version !== undefined) {
            connection_1.Version.encode(message.version, writer.uint32(26).fork()).ldelim();
        }
        if (message.clientState !== undefined) {
            any_1.Any.encode(message.clientState, writer.uint32(34).fork()).ldelim();
        }
        if (message.proofHeight !== undefined) {
            client_1.Height.encode(message.proofHeight, writer.uint32(42).fork()).ldelim();
        }
        if (message.proofTry.length !== 0) {
            writer.uint32(50).bytes(message.proofTry);
        }
        if (message.proofClient.length !== 0) {
            writer.uint32(58).bytes(message.proofClient);
        }
        if (message.proofConsensus.length !== 0) {
            writer.uint32(66).bytes(message.proofConsensus);
        }
        if (message.consensusHeight !== undefined) {
            client_1.Height.encode(message.consensusHeight, writer.uint32(74).fork()).ldelim();
        }
        if (message.signer !== "") {
            writer.uint32(82).string(message.signer);
        }
        if (message.hostConsensusStateProof.length !== 0) {
            writer.uint32(90).bytes(message.hostConsensusStateProof);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgConnectionOpenAck();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.connectionId = reader.string();
                    break;
                case 2:
                    message.counterpartyConnectionId = reader.string();
                    break;
                case 3:
                    message.version = connection_1.Version.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.clientState = any_1.Any.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.proofHeight = client_1.Height.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.proofTry = reader.bytes();
                    break;
                case 7:
                    message.proofClient = reader.bytes();
                    break;
                case 8:
                    message.proofConsensus = reader.bytes();
                    break;
                case 9:
                    message.consensusHeight = client_1.Height.decode(reader, reader.uint32());
                    break;
                case 10:
                    message.signer = reader.string();
                    break;
                case 11:
                    message.hostConsensusStateProof = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            connectionId: (0, helpers_1.isSet)(object.connectionId) ? String(object.connectionId) : "",
            counterpartyConnectionId: (0, helpers_1.isSet)(object.counterpartyConnectionId)
                ? String(object.counterpartyConnectionId)
                : "",
            version: (0, helpers_1.isSet)(object.version) ? connection_1.Version.fromJSON(object.version) : undefined,
            clientState: (0, helpers_1.isSet)(object.clientState) ? any_1.Any.fromJSON(object.clientState) : undefined,
            proofHeight: (0, helpers_1.isSet)(object.proofHeight) ? client_1.Height.fromJSON(object.proofHeight) : undefined,
            proofTry: (0, helpers_1.isSet)(object.proofTry) ? (0, helpers_1.bytesFromBase64)(object.proofTry) : new Uint8Array(),
            proofClient: (0, helpers_1.isSet)(object.proofClient) ? (0, helpers_1.bytesFromBase64)(object.proofClient) : new Uint8Array(),
            proofConsensus: (0, helpers_1.isSet)(object.proofConsensus)
                ? (0, helpers_1.bytesFromBase64)(object.proofConsensus)
                : new Uint8Array(),
            consensusHeight: (0, helpers_1.isSet)(object.consensusHeight) ? client_1.Height.fromJSON(object.consensusHeight) : undefined,
            signer: (0, helpers_1.isSet)(object.signer) ? String(object.signer) : "",
            hostConsensusStateProof: (0, helpers_1.isSet)(object.hostConsensusStateProof)
                ? (0, helpers_1.bytesFromBase64)(object.hostConsensusStateProof)
                : new Uint8Array(),
        };
    },
    toJSON(message) {
        const obj = {};
        message.connectionId !== undefined && (obj.connectionId = message.connectionId);
        message.counterpartyConnectionId !== undefined &&
            (obj.counterpartyConnectionId = message.counterpartyConnectionId);
        message.version !== undefined &&
            (obj.version = message.version ? connection_1.Version.toJSON(message.version) : undefined);
        message.clientState !== undefined &&
            (obj.clientState = message.clientState ? any_1.Any.toJSON(message.clientState) : undefined);
        message.proofHeight !== undefined &&
            (obj.proofHeight = message.proofHeight ? client_1.Height.toJSON(message.proofHeight) : undefined);
        message.proofTry !== undefined &&
            (obj.proofTry = (0, helpers_1.base64FromBytes)(message.proofTry !== undefined ? message.proofTry : new Uint8Array()));
        message.proofClient !== undefined &&
            (obj.proofClient = (0, helpers_1.base64FromBytes)(message.proofClient !== undefined ? message.proofClient : new Uint8Array()));
        message.proofConsensus !== undefined &&
            (obj.proofConsensus = (0, helpers_1.base64FromBytes)(message.proofConsensus !== undefined ? message.proofConsensus : new Uint8Array()));
        message.consensusHeight !== undefined &&
            (obj.consensusHeight = message.consensusHeight ? client_1.Height.toJSON(message.consensusHeight) : undefined);
        message.signer !== undefined && (obj.signer = message.signer);
        message.hostConsensusStateProof !== undefined &&
            (obj.hostConsensusStateProof = (0, helpers_1.base64FromBytes)(message.hostConsensusStateProof !== undefined ? message.hostConsensusStateProof : new Uint8Array()));
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgConnectionOpenAck();
        message.connectionId = object.connectionId ?? "";
        message.counterpartyConnectionId = object.counterpartyConnectionId ?? "";
        message.version =
            object.version !== undefined && object.version !== null
                ? connection_1.Version.fromPartial(object.version)
                : undefined;
        message.clientState =
            object.clientState !== undefined && object.clientState !== null
                ? any_1.Any.fromPartial(object.clientState)
                : undefined;
        message.proofHeight =
            object.proofHeight !== undefined && object.proofHeight !== null
                ? client_1.Height.fromPartial(object.proofHeight)
                : undefined;
        message.proofTry = object.proofTry ?? new Uint8Array();
        message.proofClient = object.proofClient ?? new Uint8Array();
        message.proofConsensus = object.proofConsensus ?? new Uint8Array();
        message.consensusHeight =
            object.consensusHeight !== undefined && object.consensusHeight !== null
                ? client_1.Height.fromPartial(object.consensusHeight)
                : undefined;
        message.signer = object.signer ?? "";
        message.hostConsensusStateProof = object.hostConsensusStateProof ?? new Uint8Array();
        return message;
    },
};
function createBaseMsgConnectionOpenAckResponse() {
    return {};
}
exports.MsgConnectionOpenAckResponse = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgConnectionOpenAckResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgConnectionOpenAckResponse();
        return message;
    },
};
function createBaseMsgConnectionOpenConfirm() {
    return {
        connectionId: "",
        proofAck: new Uint8Array(),
        proofHeight: undefined,
        signer: "",
    };
}
exports.MsgConnectionOpenConfirm = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.connectionId !== "") {
            writer.uint32(10).string(message.connectionId);
        }
        if (message.proofAck.length !== 0) {
            writer.uint32(18).bytes(message.proofAck);
        }
        if (message.proofHeight !== undefined) {
            client_1.Height.encode(message.proofHeight, writer.uint32(26).fork()).ldelim();
        }
        if (message.signer !== "") {
            writer.uint32(34).string(message.signer);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgConnectionOpenConfirm();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.connectionId = reader.string();
                    break;
                case 2:
                    message.proofAck = reader.bytes();
                    break;
                case 3:
                    message.proofHeight = client_1.Height.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            connectionId: (0, helpers_1.isSet)(object.connectionId) ? String(object.connectionId) : "",
            proofAck: (0, helpers_1.isSet)(object.proofAck) ? (0, helpers_1.bytesFromBase64)(object.proofAck) : new Uint8Array(),
            proofHeight: (0, helpers_1.isSet)(object.proofHeight) ? client_1.Height.fromJSON(object.proofHeight) : undefined,
            signer: (0, helpers_1.isSet)(object.signer) ? String(object.signer) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.connectionId !== undefined && (obj.connectionId = message.connectionId);
        message.proofAck !== undefined &&
            (obj.proofAck = (0, helpers_1.base64FromBytes)(message.proofAck !== undefined ? message.proofAck : new Uint8Array()));
        message.proofHeight !== undefined &&
            (obj.proofHeight = message.proofHeight ? client_1.Height.toJSON(message.proofHeight) : undefined);
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgConnectionOpenConfirm();
        message.connectionId = object.connectionId ?? "";
        message.proofAck = object.proofAck ?? new Uint8Array();
        message.proofHeight =
            object.proofHeight !== undefined && object.proofHeight !== null
                ? client_1.Height.fromPartial(object.proofHeight)
                : undefined;
        message.signer = object.signer ?? "";
        return message;
    },
};
function createBaseMsgConnectionOpenConfirmResponse() {
    return {};
}
exports.MsgConnectionOpenConfirmResponse = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgConnectionOpenConfirmResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgConnectionOpenConfirmResponse();
        return message;
    },
};
class MsgClientImpl {
    constructor(rpc) {
        this.rpc = rpc;
        this.ConnectionOpenInit = this.ConnectionOpenInit.bind(this);
        this.ConnectionOpenTry = this.ConnectionOpenTry.bind(this);
        this.ConnectionOpenAck = this.ConnectionOpenAck.bind(this);
        this.ConnectionOpenConfirm = this.ConnectionOpenConfirm.bind(this);
    }
    ConnectionOpenInit(request) {
        const data = exports.MsgConnectionOpenInit.encode(request).finish();
        const promise = this.rpc.request("ibc.core.connection.v1.Msg", "ConnectionOpenInit", data);
        return promise.then((data) => exports.MsgConnectionOpenInitResponse.decode(new _m0.Reader(data)));
    }
    ConnectionOpenTry(request) {
        const data = exports.MsgConnectionOpenTry.encode(request).finish();
        const promise = this.rpc.request("ibc.core.connection.v1.Msg", "ConnectionOpenTry", data);
        return promise.then((data) => exports.MsgConnectionOpenTryResponse.decode(new _m0.Reader(data)));
    }
    ConnectionOpenAck(request) {
        const data = exports.MsgConnectionOpenAck.encode(request).finish();
        const promise = this.rpc.request("ibc.core.connection.v1.Msg", "ConnectionOpenAck", data);
        return promise.then((data) => exports.MsgConnectionOpenAckResponse.decode(new _m0.Reader(data)));
    }
    ConnectionOpenConfirm(request) {
        const data = exports.MsgConnectionOpenConfirm.encode(request).finish();
        const promise = this.rpc.request("ibc.core.connection.v1.Msg", "ConnectionOpenConfirm", data);
        return promise.then((data) => exports.MsgConnectionOpenConfirmResponse.decode(new _m0.Reader(data)));
    }
}
exports.MsgClientImpl = MsgClientImpl;
//# sourceMappingURL=tx.js.map

/***/ }),

/***/ 24398:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Fraction = exports.Header = exports.Misbehaviour = exports.ConsensusState = exports.ClientState = exports.protobufPackage = void 0;
/* eslint-disable */
const duration_1 = __webpack_require__(9591);
const client_1 = __webpack_require__(30085);
const proofs_1 = __webpack_require__(9703);
const timestamp_1 = __webpack_require__(70147);
const commitment_1 = __webpack_require__(35408);
const types_1 = __webpack_require__(34681);
const validator_1 = __webpack_require__(25575);
const helpers_1 = __webpack_require__(92654);
const _m0 = __importStar(__webpack_require__(62100));
exports.protobufPackage = "ibc.lightclients.tendermint.v1";
function createBaseClientState() {
    return {
        chainId: "",
        trustLevel: undefined,
        trustingPeriod: undefined,
        unbondingPeriod: undefined,
        maxClockDrift: undefined,
        frozenHeight: undefined,
        latestHeight: undefined,
        proofSpecs: [],
        upgradePath: [],
        allowUpdateAfterExpiry: false,
        allowUpdateAfterMisbehaviour: false,
    };
}
exports.ClientState = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.chainId !== "") {
            writer.uint32(10).string(message.chainId);
        }
        if (message.trustLevel !== undefined) {
            exports.Fraction.encode(message.trustLevel, writer.uint32(18).fork()).ldelim();
        }
        if (message.trustingPeriod !== undefined) {
            duration_1.Duration.encode(message.trustingPeriod, writer.uint32(26).fork()).ldelim();
        }
        if (message.unbondingPeriod !== undefined) {
            duration_1.Duration.encode(message.unbondingPeriod, writer.uint32(34).fork()).ldelim();
        }
        if (message.maxClockDrift !== undefined) {
            duration_1.Duration.encode(message.maxClockDrift, writer.uint32(42).fork()).ldelim();
        }
        if (message.frozenHeight !== undefined) {
            client_1.Height.encode(message.frozenHeight, writer.uint32(50).fork()).ldelim();
        }
        if (message.latestHeight !== undefined) {
            client_1.Height.encode(message.latestHeight, writer.uint32(58).fork()).ldelim();
        }
        for (const v of message.proofSpecs) {
            proofs_1.ProofSpec.encode(v, writer.uint32(66).fork()).ldelim();
        }
        for (const v of message.upgradePath) {
            writer.uint32(74).string(v);
        }
        if (message.allowUpdateAfterExpiry === true) {
            writer.uint32(80).bool(message.allowUpdateAfterExpiry);
        }
        if (message.allowUpdateAfterMisbehaviour === true) {
            writer.uint32(88).bool(message.allowUpdateAfterMisbehaviour);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseClientState();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.chainId = reader.string();
                    break;
                case 2:
                    message.trustLevel = exports.Fraction.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.trustingPeriod = duration_1.Duration.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.unbondingPeriod = duration_1.Duration.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.maxClockDrift = duration_1.Duration.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.frozenHeight = client_1.Height.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.latestHeight = client_1.Height.decode(reader, reader.uint32());
                    break;
                case 8:
                    message.proofSpecs.push(proofs_1.ProofSpec.decode(reader, reader.uint32()));
                    break;
                case 9:
                    message.upgradePath.push(reader.string());
                    break;
                case 10:
                    message.allowUpdateAfterExpiry = reader.bool();
                    break;
                case 11:
                    message.allowUpdateAfterMisbehaviour = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            chainId: (0, helpers_1.isSet)(object.chainId) ? String(object.chainId) : "",
            trustLevel: (0, helpers_1.isSet)(object.trustLevel) ? exports.Fraction.fromJSON(object.trustLevel) : undefined,
            trustingPeriod: (0, helpers_1.isSet)(object.trustingPeriod) ? duration_1.Duration.fromJSON(object.trustingPeriod) : undefined,
            unbondingPeriod: (0, helpers_1.isSet)(object.unbondingPeriod) ? duration_1.Duration.fromJSON(object.unbondingPeriod) : undefined,
            maxClockDrift: (0, helpers_1.isSet)(object.maxClockDrift) ? duration_1.Duration.fromJSON(object.maxClockDrift) : undefined,
            frozenHeight: (0, helpers_1.isSet)(object.frozenHeight) ? client_1.Height.fromJSON(object.frozenHeight) : undefined,
            latestHeight: (0, helpers_1.isSet)(object.latestHeight) ? client_1.Height.fromJSON(object.latestHeight) : undefined,
            proofSpecs: Array.isArray(object?.proofSpecs)
                ? object.proofSpecs.map((e) => proofs_1.ProofSpec.fromJSON(e))
                : [],
            upgradePath: Array.isArray(object?.upgradePath) ? object.upgradePath.map((e) => String(e)) : [],
            allowUpdateAfterExpiry: (0, helpers_1.isSet)(object.allowUpdateAfterExpiry)
                ? Boolean(object.allowUpdateAfterExpiry)
                : false,
            allowUpdateAfterMisbehaviour: (0, helpers_1.isSet)(object.allowUpdateAfterMisbehaviour)
                ? Boolean(object.allowUpdateAfterMisbehaviour)
                : false,
        };
    },
    toJSON(message) {
        const obj = {};
        message.chainId !== undefined && (obj.chainId = message.chainId);
        message.trustLevel !== undefined &&
            (obj.trustLevel = message.trustLevel ? exports.Fraction.toJSON(message.trustLevel) : undefined);
        message.trustingPeriod !== undefined &&
            (obj.trustingPeriod = message.trustingPeriod ? duration_1.Duration.toJSON(message.trustingPeriod) : undefined);
        message.unbondingPeriod !== undefined &&
            (obj.unbondingPeriod = message.unbondingPeriod ? duration_1.Duration.toJSON(message.unbondingPeriod) : undefined);
        message.maxClockDrift !== undefined &&
            (obj.maxClockDrift = message.maxClockDrift ? duration_1.Duration.toJSON(message.maxClockDrift) : undefined);
        message.frozenHeight !== undefined &&
            (obj.frozenHeight = message.frozenHeight ? client_1.Height.toJSON(message.frozenHeight) : undefined);
        message.latestHeight !== undefined &&
            (obj.latestHeight = message.latestHeight ? client_1.Height.toJSON(message.latestHeight) : undefined);
        if (message.proofSpecs) {
            obj.proofSpecs = message.proofSpecs.map((e) => (e ? proofs_1.ProofSpec.toJSON(e) : undefined));
        }
        else {
            obj.proofSpecs = [];
        }
        if (message.upgradePath) {
            obj.upgradePath = message.upgradePath.map((e) => e);
        }
        else {
            obj.upgradePath = [];
        }
        message.allowUpdateAfterExpiry !== undefined &&
            (obj.allowUpdateAfterExpiry = message.allowUpdateAfterExpiry);
        message.allowUpdateAfterMisbehaviour !== undefined &&
            (obj.allowUpdateAfterMisbehaviour = message.allowUpdateAfterMisbehaviour);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseClientState();
        message.chainId = object.chainId ?? "";
        message.trustLevel =
            object.trustLevel !== undefined && object.trustLevel !== null
                ? exports.Fraction.fromPartial(object.trustLevel)
                : undefined;
        message.trustingPeriod =
            object.trustingPeriod !== undefined && object.trustingPeriod !== null
                ? duration_1.Duration.fromPartial(object.trustingPeriod)
                : undefined;
        message.unbondingPeriod =
            object.unbondingPeriod !== undefined && object.unbondingPeriod !== null
                ? duration_1.Duration.fromPartial(object.unbondingPeriod)
                : undefined;
        message.maxClockDrift =
            object.maxClockDrift !== undefined && object.maxClockDrift !== null
                ? duration_1.Duration.fromPartial(object.maxClockDrift)
                : undefined;
        message.frozenHeight =
            object.frozenHeight !== undefined && object.frozenHeight !== null
                ? client_1.Height.fromPartial(object.frozenHeight)
                : undefined;
        message.latestHeight =
            object.latestHeight !== undefined && object.latestHeight !== null
                ? client_1.Height.fromPartial(object.latestHeight)
                : undefined;
        message.proofSpecs = object.proofSpecs?.map((e) => proofs_1.ProofSpec.fromPartial(e)) || [];
        message.upgradePath = object.upgradePath?.map((e) => e) || [];
        message.allowUpdateAfterExpiry = object.allowUpdateAfterExpiry ?? false;
        message.allowUpdateAfterMisbehaviour = object.allowUpdateAfterMisbehaviour ?? false;
        return message;
    },
};
function createBaseConsensusState() {
    return {
        timestamp: undefined,
        root: undefined,
        nextValidatorsHash: new Uint8Array(),
    };
}
exports.ConsensusState = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.timestamp !== undefined) {
            timestamp_1.Timestamp.encode(message.timestamp, writer.uint32(10).fork()).ldelim();
        }
        if (message.root !== undefined) {
            commitment_1.MerkleRoot.encode(message.root, writer.uint32(18).fork()).ldelim();
        }
        if (message.nextValidatorsHash.length !== 0) {
            writer.uint32(26).bytes(message.nextValidatorsHash);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseConsensusState();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.timestamp = timestamp_1.Timestamp.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.root = commitment_1.MerkleRoot.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.nextValidatorsHash = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            timestamp: (0, helpers_1.isSet)(object.timestamp) ? (0, helpers_1.fromJsonTimestamp)(object.timestamp) : undefined,
            root: (0, helpers_1.isSet)(object.root) ? commitment_1.MerkleRoot.fromJSON(object.root) : undefined,
            nextValidatorsHash: (0, helpers_1.isSet)(object.nextValidatorsHash)
                ? (0, helpers_1.bytesFromBase64)(object.nextValidatorsHash)
                : new Uint8Array(),
        };
    },
    toJSON(message) {
        const obj = {};
        message.timestamp !== undefined && (obj.timestamp = (0, helpers_1.fromTimestamp)(message.timestamp).toISOString());
        message.root !== undefined && (obj.root = message.root ? commitment_1.MerkleRoot.toJSON(message.root) : undefined);
        message.nextValidatorsHash !== undefined &&
            (obj.nextValidatorsHash = (0, helpers_1.base64FromBytes)(message.nextValidatorsHash !== undefined ? message.nextValidatorsHash : new Uint8Array()));
        return obj;
    },
    fromPartial(object) {
        const message = createBaseConsensusState();
        message.timestamp =
            object.timestamp !== undefined && object.timestamp !== null
                ? timestamp_1.Timestamp.fromPartial(object.timestamp)
                : undefined;
        message.root =
            object.root !== undefined && object.root !== null ? commitment_1.MerkleRoot.fromPartial(object.root) : undefined;
        message.nextValidatorsHash = object.nextValidatorsHash ?? new Uint8Array();
        return message;
    },
};
function createBaseMisbehaviour() {
    return {
        clientId: "",
        header1: undefined,
        header2: undefined,
    };
}
exports.Misbehaviour = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.clientId !== "") {
            writer.uint32(10).string(message.clientId);
        }
        if (message.header1 !== undefined) {
            exports.Header.encode(message.header1, writer.uint32(18).fork()).ldelim();
        }
        if (message.header2 !== undefined) {
            exports.Header.encode(message.header2, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMisbehaviour();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.header1 = exports.Header.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.header2 = exports.Header.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            clientId: (0, helpers_1.isSet)(object.clientId) ? String(object.clientId) : "",
            header1: (0, helpers_1.isSet)(object.header1) ? exports.Header.fromJSON(object.header1) : undefined,
            header2: (0, helpers_1.isSet)(object.header2) ? exports.Header.fromJSON(object.header2) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        message.header1 !== undefined &&
            (obj.header1 = message.header1 ? exports.Header.toJSON(message.header1) : undefined);
        message.header2 !== undefined &&
            (obj.header2 = message.header2 ? exports.Header.toJSON(message.header2) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMisbehaviour();
        message.clientId = object.clientId ?? "";
        message.header1 =
            object.header1 !== undefined && object.header1 !== null
                ? exports.Header.fromPartial(object.header1)
                : undefined;
        message.header2 =
            object.header2 !== undefined && object.header2 !== null
                ? exports.Header.fromPartial(object.header2)
                : undefined;
        return message;
    },
};
function createBaseHeader() {
    return {
        signedHeader: undefined,
        validatorSet: undefined,
        trustedHeight: undefined,
        trustedValidators: undefined,
    };
}
exports.Header = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.signedHeader !== undefined) {
            types_1.SignedHeader.encode(message.signedHeader, writer.uint32(10).fork()).ldelim();
        }
        if (message.validatorSet !== undefined) {
            validator_1.ValidatorSet.encode(message.validatorSet, writer.uint32(18).fork()).ldelim();
        }
        if (message.trustedHeight !== undefined) {
            client_1.Height.encode(message.trustedHeight, writer.uint32(26).fork()).ldelim();
        }
        if (message.trustedValidators !== undefined) {
            validator_1.ValidatorSet.encode(message.trustedValidators, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseHeader();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.signedHeader = types_1.SignedHeader.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.validatorSet = validator_1.ValidatorSet.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.trustedHeight = client_1.Height.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.trustedValidators = validator_1.ValidatorSet.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            signedHeader: (0, helpers_1.isSet)(object.signedHeader) ? types_1.SignedHeader.fromJSON(object.signedHeader) : undefined,
            validatorSet: (0, helpers_1.isSet)(object.validatorSet) ? validator_1.ValidatorSet.fromJSON(object.validatorSet) : undefined,
            trustedHeight: (0, helpers_1.isSet)(object.trustedHeight) ? client_1.Height.fromJSON(object.trustedHeight) : undefined,
            trustedValidators: (0, helpers_1.isSet)(object.trustedValidators)
                ? validator_1.ValidatorSet.fromJSON(object.trustedValidators)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.signedHeader !== undefined &&
            (obj.signedHeader = message.signedHeader ? types_1.SignedHeader.toJSON(message.signedHeader) : undefined);
        message.validatorSet !== undefined &&
            (obj.validatorSet = message.validatorSet ? validator_1.ValidatorSet.toJSON(message.validatorSet) : undefined);
        message.trustedHeight !== undefined &&
            (obj.trustedHeight = message.trustedHeight ? client_1.Height.toJSON(message.trustedHeight) : undefined);
        message.trustedValidators !== undefined &&
            (obj.trustedValidators = message.trustedValidators
                ? validator_1.ValidatorSet.toJSON(message.trustedValidators)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseHeader();
        message.signedHeader =
            object.signedHeader !== undefined && object.signedHeader !== null
                ? types_1.SignedHeader.fromPartial(object.signedHeader)
                : undefined;
        message.validatorSet =
            object.validatorSet !== undefined && object.validatorSet !== null
                ? validator_1.ValidatorSet.fromPartial(object.validatorSet)
                : undefined;
        message.trustedHeight =
            object.trustedHeight !== undefined && object.trustedHeight !== null
                ? client_1.Height.fromPartial(object.trustedHeight)
                : undefined;
        message.trustedValidators =
            object.trustedValidators !== undefined && object.trustedValidators !== null
                ? validator_1.ValidatorSet.fromPartial(object.trustedValidators)
                : undefined;
        return message;
    },
};
function createBaseFraction() {
    return {
        numerator: helpers_1.Long.UZERO,
        denominator: helpers_1.Long.UZERO,
    };
}
exports.Fraction = {
    encode(message, writer = _m0.Writer.create()) {
        if (!message.numerator.isZero()) {
            writer.uint32(8).uint64(message.numerator);
        }
        if (!message.denominator.isZero()) {
            writer.uint32(16).uint64(message.denominator);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseFraction();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.numerator = reader.uint64();
                    break;
                case 2:
                    message.denominator = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            numerator: (0, helpers_1.isSet)(object.numerator) ? helpers_1.Long.fromValue(object.numerator) : helpers_1.Long.UZERO,
            denominator: (0, helpers_1.isSet)(object.denominator) ? helpers_1.Long.fromValue(object.denominator) : helpers_1.Long.UZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        message.numerator !== undefined && (obj.numerator = (message.numerator || helpers_1.Long.UZERO).toString());
        message.denominator !== undefined && (obj.denominator = (message.denominator || helpers_1.Long.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseFraction();
        message.numerator =
            object.numerator !== undefined && object.numerator !== null
                ? helpers_1.Long.fromValue(object.numerator)
                : helpers_1.Long.UZERO;
        message.denominator =
            object.denominator !== undefined && object.denominator !== null
                ? helpers_1.Long.fromValue(object.denominator)
                : helpers_1.Long.UZERO;
        return message;
    },
};
//# sourceMappingURL=tendermint.js.map

/***/ }),

/***/ 67858:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PublicKey = exports.protobufPackage = void 0;
/* eslint-disable */
const _m0 = __importStar(__webpack_require__(62100));
const helpers_1 = __webpack_require__(92654);
exports.protobufPackage = "tendermint.crypto";
function createBasePublicKey() {
    return {
        ed25519: undefined,
        secp256k1: undefined,
    };
}
exports.PublicKey = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.ed25519 !== undefined) {
            writer.uint32(10).bytes(message.ed25519);
        }
        if (message.secp256k1 !== undefined) {
            writer.uint32(18).bytes(message.secp256k1);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePublicKey();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.ed25519 = reader.bytes();
                    break;
                case 2:
                    message.secp256k1 = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            ed25519: (0, helpers_1.isSet)(object.ed25519) ? (0, helpers_1.bytesFromBase64)(object.ed25519) : undefined,
            secp256k1: (0, helpers_1.isSet)(object.secp256k1) ? (0, helpers_1.bytesFromBase64)(object.secp256k1) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.ed25519 !== undefined &&
            (obj.ed25519 = message.ed25519 !== undefined ? (0, helpers_1.base64FromBytes)(message.ed25519) : undefined);
        message.secp256k1 !== undefined &&
            (obj.secp256k1 = message.secp256k1 !== undefined ? (0, helpers_1.base64FromBytes)(message.secp256k1) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBasePublicKey();
        message.ed25519 = object.ed25519 ?? undefined;
        message.secp256k1 = object.secp256k1 ?? undefined;
        return message;
    },
};
//# sourceMappingURL=keys.js.map

/***/ }),

/***/ 21874:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ProofOps = exports.ProofOp = exports.DominoOp = exports.ValueOp = exports.Proof = exports.protobufPackage = void 0;
/* eslint-disable */
const helpers_1 = __webpack_require__(92654);
const _m0 = __importStar(__webpack_require__(62100));
exports.protobufPackage = "tendermint.crypto";
function createBaseProof() {
    return {
        total: helpers_1.Long.ZERO,
        index: helpers_1.Long.ZERO,
        leafHash: new Uint8Array(),
        aunts: [],
    };
}
exports.Proof = {
    encode(message, writer = _m0.Writer.create()) {
        if (!message.total.isZero()) {
            writer.uint32(8).int64(message.total);
        }
        if (!message.index.isZero()) {
            writer.uint32(16).int64(message.index);
        }
        if (message.leafHash.length !== 0) {
            writer.uint32(26).bytes(message.leafHash);
        }
        for (const v of message.aunts) {
            writer.uint32(34).bytes(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseProof();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.total = reader.int64();
                    break;
                case 2:
                    message.index = reader.int64();
                    break;
                case 3:
                    message.leafHash = reader.bytes();
                    break;
                case 4:
                    message.aunts.push(reader.bytes());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            total: (0, helpers_1.isSet)(object.total) ? helpers_1.Long.fromValue(object.total) : helpers_1.Long.ZERO,
            index: (0, helpers_1.isSet)(object.index) ? helpers_1.Long.fromValue(object.index) : helpers_1.Long.ZERO,
            leafHash: (0, helpers_1.isSet)(object.leafHash) ? (0, helpers_1.bytesFromBase64)(object.leafHash) : new Uint8Array(),
            aunts: Array.isArray(object?.aunts) ? object.aunts.map((e) => (0, helpers_1.bytesFromBase64)(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        message.total !== undefined && (obj.total = (message.total || helpers_1.Long.ZERO).toString());
        message.index !== undefined && (obj.index = (message.index || helpers_1.Long.ZERO).toString());
        message.leafHash !== undefined &&
            (obj.leafHash = (0, helpers_1.base64FromBytes)(message.leafHash !== undefined ? message.leafHash : new Uint8Array()));
        if (message.aunts) {
            obj.aunts = message.aunts.map((e) => (0, helpers_1.base64FromBytes)(e !== undefined ? e : new Uint8Array()));
        }
        else {
            obj.aunts = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseProof();
        message.total =
            object.total !== undefined && object.total !== null ? helpers_1.Long.fromValue(object.total) : helpers_1.Long.ZERO;
        message.index =
            object.index !== undefined && object.index !== null ? helpers_1.Long.fromValue(object.index) : helpers_1.Long.ZERO;
        message.leafHash = object.leafHash ?? new Uint8Array();
        message.aunts = object.aunts?.map((e) => e) || [];
        return message;
    },
};
function createBaseValueOp() {
    return {
        key: new Uint8Array(),
        proof: undefined,
    };
}
exports.ValueOp = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.key.length !== 0) {
            writer.uint32(10).bytes(message.key);
        }
        if (message.proof !== undefined) {
            exports.Proof.encode(message.proof, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseValueOp();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.key = reader.bytes();
                    break;
                case 2:
                    message.proof = exports.Proof.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            key: (0, helpers_1.isSet)(object.key) ? (0, helpers_1.bytesFromBase64)(object.key) : new Uint8Array(),
            proof: (0, helpers_1.isSet)(object.proof) ? exports.Proof.fromJSON(object.proof) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.key !== undefined &&
            (obj.key = (0, helpers_1.base64FromBytes)(message.key !== undefined ? message.key : new Uint8Array()));
        message.proof !== undefined && (obj.proof = message.proof ? exports.Proof.toJSON(message.proof) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseValueOp();
        message.key = object.key ?? new Uint8Array();
        message.proof =
            object.proof !== undefined && object.proof !== null ? exports.Proof.fromPartial(object.proof) : undefined;
        return message;
    },
};
function createBaseDominoOp() {
    return {
        key: "",
        input: "",
        output: "",
    };
}
exports.DominoOp = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.key !== "") {
            writer.uint32(10).string(message.key);
        }
        if (message.input !== "") {
            writer.uint32(18).string(message.input);
        }
        if (message.output !== "") {
            writer.uint32(26).string(message.output);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDominoOp();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.key = reader.string();
                    break;
                case 2:
                    message.input = reader.string();
                    break;
                case 3:
                    message.output = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            key: (0, helpers_1.isSet)(object.key) ? String(object.key) : "",
            input: (0, helpers_1.isSet)(object.input) ? String(object.input) : "",
            output: (0, helpers_1.isSet)(object.output) ? String(object.output) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.key !== undefined && (obj.key = message.key);
        message.input !== undefined && (obj.input = message.input);
        message.output !== undefined && (obj.output = message.output);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseDominoOp();
        message.key = object.key ?? "";
        message.input = object.input ?? "";
        message.output = object.output ?? "";
        return message;
    },
};
function createBaseProofOp() {
    return {
        type: "",
        key: new Uint8Array(),
        data: new Uint8Array(),
    };
}
exports.ProofOp = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.type !== "") {
            writer.uint32(10).string(message.type);
        }
        if (message.key.length !== 0) {
            writer.uint32(18).bytes(message.key);
        }
        if (message.data.length !== 0) {
            writer.uint32(26).bytes(message.data);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseProofOp();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.type = reader.string();
                    break;
                case 2:
                    message.key = reader.bytes();
                    break;
                case 3:
                    message.data = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            type: (0, helpers_1.isSet)(object.type) ? String(object.type) : "",
            key: (0, helpers_1.isSet)(object.key) ? (0, helpers_1.bytesFromBase64)(object.key) : new Uint8Array(),
            data: (0, helpers_1.isSet)(object.data) ? (0, helpers_1.bytesFromBase64)(object.data) : new Uint8Array(),
        };
    },
    toJSON(message) {
        const obj = {};
        message.type !== undefined && (obj.type = message.type);
        message.key !== undefined &&
            (obj.key = (0, helpers_1.base64FromBytes)(message.key !== undefined ? message.key : new Uint8Array()));
        message.data !== undefined &&
            (obj.data = (0, helpers_1.base64FromBytes)(message.data !== undefined ? message.data : new Uint8Array()));
        return obj;
    },
    fromPartial(object) {
        const message = createBaseProofOp();
        message.type = object.type ?? "";
        message.key = object.key ?? new Uint8Array();
        message.data = object.data ?? new Uint8Array();
        return message;
    },
};
function createBaseProofOps() {
    return {
        ops: [],
    };
}
exports.ProofOps = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.ops) {
            exports.ProofOp.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseProofOps();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.ops.push(exports.ProofOp.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            ops: Array.isArray(object?.ops) ? object.ops.map((e) => exports.ProofOp.fromJSON(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.ops) {
            obj.ops = message.ops.map((e) => (e ? exports.ProofOp.toJSON(e) : undefined));
        }
        else {
            obj.ops = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseProofOps();
        message.ops = object.ops?.map((e) => exports.ProofOp.fromPartial(e)) || [];
        return message;
    },
};
//# sourceMappingURL=proof.js.map

/***/ }),

/***/ 25512:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Block = exports.protobufPackage = void 0;
/* eslint-disable */
const types_1 = __webpack_require__(34681);
const evidence_1 = __webpack_require__(64296);
const _m0 = __importStar(__webpack_require__(62100));
const helpers_1 = __webpack_require__(92654);
exports.protobufPackage = "tendermint.types";
function createBaseBlock() {
    return {
        header: undefined,
        data: undefined,
        evidence: undefined,
        lastCommit: undefined,
    };
}
exports.Block = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.header !== undefined) {
            types_1.Header.encode(message.header, writer.uint32(10).fork()).ldelim();
        }
        if (message.data !== undefined) {
            types_1.Data.encode(message.data, writer.uint32(18).fork()).ldelim();
        }
        if (message.evidence !== undefined) {
            evidence_1.EvidenceList.encode(message.evidence, writer.uint32(26).fork()).ldelim();
        }
        if (message.lastCommit !== undefined) {
            types_1.Commit.encode(message.lastCommit, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseBlock();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.header = types_1.Header.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.data = types_1.Data.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.evidence = evidence_1.EvidenceList.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.lastCommit = types_1.Commit.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            header: (0, helpers_1.isSet)(object.header) ? types_1.Header.fromJSON(object.header) : undefined,
            data: (0, helpers_1.isSet)(object.data) ? types_1.Data.fromJSON(object.data) : undefined,
            evidence: (0, helpers_1.isSet)(object.evidence) ? evidence_1.EvidenceList.fromJSON(object.evidence) : undefined,
            lastCommit: (0, helpers_1.isSet)(object.lastCommit) ? types_1.Commit.fromJSON(object.lastCommit) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.header !== undefined && (obj.header = message.header ? types_1.Header.toJSON(message.header) : undefined);
        message.data !== undefined && (obj.data = message.data ? types_1.Data.toJSON(message.data) : undefined);
        message.evidence !== undefined &&
            (obj.evidence = message.evidence ? evidence_1.EvidenceList.toJSON(message.evidence) : undefined);
        message.lastCommit !== undefined &&
            (obj.lastCommit = message.lastCommit ? types_1.Commit.toJSON(message.lastCommit) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseBlock();
        message.header =
            object.header !== undefined && object.header !== null ? types_1.Header.fromPartial(object.header) : undefined;
        message.data =
            object.data !== undefined && object.data !== null ? types_1.Data.fromPartial(object.data) : undefined;
        message.evidence =
            object.evidence !== undefined && object.evidence !== null
                ? evidence_1.EvidenceList.fromPartial(object.evidence)
                : undefined;
        message.lastCommit =
            object.lastCommit !== undefined && object.lastCommit !== null
                ? types_1.Commit.fromPartial(object.lastCommit)
                : undefined;
        return message;
    },
};
//# sourceMappingURL=block.js.map

/***/ }),

/***/ 64296:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.EvidenceList = exports.LightClientAttackEvidence = exports.DuplicateVoteEvidence = exports.Evidence = exports.protobufPackage = void 0;
/* eslint-disable */
const types_1 = __webpack_require__(34681);
const timestamp_1 = __webpack_require__(70147);
const validator_1 = __webpack_require__(25575);
const helpers_1 = __webpack_require__(92654);
const _m0 = __importStar(__webpack_require__(62100));
exports.protobufPackage = "tendermint.types";
function createBaseEvidence() {
    return {
        duplicateVoteEvidence: undefined,
        lightClientAttackEvidence: undefined,
    };
}
exports.Evidence = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.duplicateVoteEvidence !== undefined) {
            exports.DuplicateVoteEvidence.encode(message.duplicateVoteEvidence, writer.uint32(10).fork()).ldelim();
        }
        if (message.lightClientAttackEvidence !== undefined) {
            exports.LightClientAttackEvidence.encode(message.lightClientAttackEvidence, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseEvidence();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.duplicateVoteEvidence = exports.DuplicateVoteEvidence.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.lightClientAttackEvidence = exports.LightClientAttackEvidence.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            duplicateVoteEvidence: (0, helpers_1.isSet)(object.duplicateVoteEvidence)
                ? exports.DuplicateVoteEvidence.fromJSON(object.duplicateVoteEvidence)
                : undefined,
            lightClientAttackEvidence: (0, helpers_1.isSet)(object.lightClientAttackEvidence)
                ? exports.LightClientAttackEvidence.fromJSON(object.lightClientAttackEvidence)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.duplicateVoteEvidence !== undefined &&
            (obj.duplicateVoteEvidence = message.duplicateVoteEvidence
                ? exports.DuplicateVoteEvidence.toJSON(message.duplicateVoteEvidence)
                : undefined);
        message.lightClientAttackEvidence !== undefined &&
            (obj.lightClientAttackEvidence = message.lightClientAttackEvidence
                ? exports.LightClientAttackEvidence.toJSON(message.lightClientAttackEvidence)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseEvidence();
        message.duplicateVoteEvidence =
            object.duplicateVoteEvidence !== undefined && object.duplicateVoteEvidence !== null
                ? exports.DuplicateVoteEvidence.fromPartial(object.duplicateVoteEvidence)
                : undefined;
        message.lightClientAttackEvidence =
            object.lightClientAttackEvidence !== undefined && object.lightClientAttackEvidence !== null
                ? exports.LightClientAttackEvidence.fromPartial(object.lightClientAttackEvidence)
                : undefined;
        return message;
    },
};
function createBaseDuplicateVoteEvidence() {
    return {
        voteA: undefined,
        voteB: undefined,
        totalVotingPower: helpers_1.Long.ZERO,
        validatorPower: helpers_1.Long.ZERO,
        timestamp: undefined,
    };
}
exports.DuplicateVoteEvidence = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.voteA !== undefined) {
            types_1.Vote.encode(message.voteA, writer.uint32(10).fork()).ldelim();
        }
        if (message.voteB !== undefined) {
            types_1.Vote.encode(message.voteB, writer.uint32(18).fork()).ldelim();
        }
        if (!message.totalVotingPower.isZero()) {
            writer.uint32(24).int64(message.totalVotingPower);
        }
        if (!message.validatorPower.isZero()) {
            writer.uint32(32).int64(message.validatorPower);
        }
        if (message.timestamp !== undefined) {
            timestamp_1.Timestamp.encode(message.timestamp, writer.uint32(42).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDuplicateVoteEvidence();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.voteA = types_1.Vote.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.voteB = types_1.Vote.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.totalVotingPower = reader.int64();
                    break;
                case 4:
                    message.validatorPower = reader.int64();
                    break;
                case 5:
                    message.timestamp = timestamp_1.Timestamp.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            voteA: (0, helpers_1.isSet)(object.voteA) ? types_1.Vote.fromJSON(object.voteA) : undefined,
            voteB: (0, helpers_1.isSet)(object.voteB) ? types_1.Vote.fromJSON(object.voteB) : undefined,
            totalVotingPower: (0, helpers_1.isSet)(object.totalVotingPower) ? helpers_1.Long.fromValue(object.totalVotingPower) : helpers_1.Long.ZERO,
            validatorPower: (0, helpers_1.isSet)(object.validatorPower) ? helpers_1.Long.fromValue(object.validatorPower) : helpers_1.Long.ZERO,
            timestamp: (0, helpers_1.isSet)(object.timestamp) ? (0, helpers_1.fromJsonTimestamp)(object.timestamp) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.voteA !== undefined && (obj.voteA = message.voteA ? types_1.Vote.toJSON(message.voteA) : undefined);
        message.voteB !== undefined && (obj.voteB = message.voteB ? types_1.Vote.toJSON(message.voteB) : undefined);
        message.totalVotingPower !== undefined &&
            (obj.totalVotingPower = (message.totalVotingPower || helpers_1.Long.ZERO).toString());
        message.validatorPower !== undefined &&
            (obj.validatorPower = (message.validatorPower || helpers_1.Long.ZERO).toString());
        message.timestamp !== undefined && (obj.timestamp = (0, helpers_1.fromTimestamp)(message.timestamp).toISOString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseDuplicateVoteEvidence();
        message.voteA =
            object.voteA !== undefined && object.voteA !== null ? types_1.Vote.fromPartial(object.voteA) : undefined;
        message.voteB =
            object.voteB !== undefined && object.voteB !== null ? types_1.Vote.fromPartial(object.voteB) : undefined;
        message.totalVotingPower =
            object.totalVotingPower !== undefined && object.totalVotingPower !== null
                ? helpers_1.Long.fromValue(object.totalVotingPower)
                : helpers_1.Long.ZERO;
        message.validatorPower =
            object.validatorPower !== undefined && object.validatorPower !== null
                ? helpers_1.Long.fromValue(object.validatorPower)
                : helpers_1.Long.ZERO;
        message.timestamp =
            object.timestamp !== undefined && object.timestamp !== null
                ? timestamp_1.Timestamp.fromPartial(object.timestamp)
                : undefined;
        return message;
    },
};
function createBaseLightClientAttackEvidence() {
    return {
        conflictingBlock: undefined,
        commonHeight: helpers_1.Long.ZERO,
        byzantineValidators: [],
        totalVotingPower: helpers_1.Long.ZERO,
        timestamp: undefined,
    };
}
exports.LightClientAttackEvidence = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.conflictingBlock !== undefined) {
            types_1.LightBlock.encode(message.conflictingBlock, writer.uint32(10).fork()).ldelim();
        }
        if (!message.commonHeight.isZero()) {
            writer.uint32(16).int64(message.commonHeight);
        }
        for (const v of message.byzantineValidators) {
            validator_1.Validator.encode(v, writer.uint32(26).fork()).ldelim();
        }
        if (!message.totalVotingPower.isZero()) {
            writer.uint32(32).int64(message.totalVotingPower);
        }
        if (message.timestamp !== undefined) {
            timestamp_1.Timestamp.encode(message.timestamp, writer.uint32(42).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseLightClientAttackEvidence();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.conflictingBlock = types_1.LightBlock.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.commonHeight = reader.int64();
                    break;
                case 3:
                    message.byzantineValidators.push(validator_1.Validator.decode(reader, reader.uint32()));
                    break;
                case 4:
                    message.totalVotingPower = reader.int64();
                    break;
                case 5:
                    message.timestamp = timestamp_1.Timestamp.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            conflictingBlock: (0, helpers_1.isSet)(object.conflictingBlock)
                ? types_1.LightBlock.fromJSON(object.conflictingBlock)
                : undefined,
            commonHeight: (0, helpers_1.isSet)(object.commonHeight) ? helpers_1.Long.fromValue(object.commonHeight) : helpers_1.Long.ZERO,
            byzantineValidators: Array.isArray(object?.byzantineValidators)
                ? object.byzantineValidators.map((e) => validator_1.Validator.fromJSON(e))
                : [],
            totalVotingPower: (0, helpers_1.isSet)(object.totalVotingPower) ? helpers_1.Long.fromValue(object.totalVotingPower) : helpers_1.Long.ZERO,
            timestamp: (0, helpers_1.isSet)(object.timestamp) ? (0, helpers_1.fromJsonTimestamp)(object.timestamp) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.conflictingBlock !== undefined &&
            (obj.conflictingBlock = message.conflictingBlock
                ? types_1.LightBlock.toJSON(message.conflictingBlock)
                : undefined);
        message.commonHeight !== undefined && (obj.commonHeight = (message.commonHeight || helpers_1.Long.ZERO).toString());
        if (message.byzantineValidators) {
            obj.byzantineValidators = message.byzantineValidators.map((e) => (e ? validator_1.Validator.toJSON(e) : undefined));
        }
        else {
            obj.byzantineValidators = [];
        }
        message.totalVotingPower !== undefined &&
            (obj.totalVotingPower = (message.totalVotingPower || helpers_1.Long.ZERO).toString());
        message.timestamp !== undefined && (obj.timestamp = (0, helpers_1.fromTimestamp)(message.timestamp).toISOString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseLightClientAttackEvidence();
        message.conflictingBlock =
            object.conflictingBlock !== undefined && object.conflictingBlock !== null
                ? types_1.LightBlock.fromPartial(object.conflictingBlock)
                : undefined;
        message.commonHeight =
            object.commonHeight !== undefined && object.commonHeight !== null
                ? helpers_1.Long.fromValue(object.commonHeight)
                : helpers_1.Long.ZERO;
        message.byzantineValidators = object.byzantineValidators?.map((e) => validator_1.Validator.fromPartial(e)) || [];
        message.totalVotingPower =
            object.totalVotingPower !== undefined && object.totalVotingPower !== null
                ? helpers_1.Long.fromValue(object.totalVotingPower)
                : helpers_1.Long.ZERO;
        message.timestamp =
            object.timestamp !== undefined && object.timestamp !== null
                ? timestamp_1.Timestamp.fromPartial(object.timestamp)
                : undefined;
        return message;
    },
};
function createBaseEvidenceList() {
    return {
        evidence: [],
    };
}
exports.EvidenceList = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.evidence) {
            exports.Evidence.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseEvidenceList();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.evidence.push(exports.Evidence.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            evidence: Array.isArray(object?.evidence) ? object.evidence.map((e) => exports.Evidence.fromJSON(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.evidence) {
            obj.evidence = message.evidence.map((e) => (e ? exports.Evidence.toJSON(e) : undefined));
        }
        else {
            obj.evidence = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseEvidenceList();
        message.evidence = object.evidence?.map((e) => exports.Evidence.fromPartial(e)) || [];
        return message;
    },
};
//# sourceMappingURL=evidence.js.map

/***/ }),

/***/ 13927:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.HashedParams = exports.VersionParams = exports.ValidatorParams = exports.EvidenceParams = exports.BlockParams = exports.ConsensusParams = exports.protobufPackage = void 0;
/* eslint-disable */
const duration_1 = __webpack_require__(9591);
const helpers_1 = __webpack_require__(92654);
const _m0 = __importStar(__webpack_require__(62100));
exports.protobufPackage = "tendermint.types";
function createBaseConsensusParams() {
    return {
        block: undefined,
        evidence: undefined,
        validator: undefined,
        version: undefined,
    };
}
exports.ConsensusParams = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.block !== undefined) {
            exports.BlockParams.encode(message.block, writer.uint32(10).fork()).ldelim();
        }
        if (message.evidence !== undefined) {
            exports.EvidenceParams.encode(message.evidence, writer.uint32(18).fork()).ldelim();
        }
        if (message.validator !== undefined) {
            exports.ValidatorParams.encode(message.validator, writer.uint32(26).fork()).ldelim();
        }
        if (message.version !== undefined) {
            exports.VersionParams.encode(message.version, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseConsensusParams();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.block = exports.BlockParams.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.evidence = exports.EvidenceParams.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.validator = exports.ValidatorParams.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.version = exports.VersionParams.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            block: (0, helpers_1.isSet)(object.block) ? exports.BlockParams.fromJSON(object.block) : undefined,
            evidence: (0, helpers_1.isSet)(object.evidence) ? exports.EvidenceParams.fromJSON(object.evidence) : undefined,
            validator: (0, helpers_1.isSet)(object.validator) ? exports.ValidatorParams.fromJSON(object.validator) : undefined,
            version: (0, helpers_1.isSet)(object.version) ? exports.VersionParams.fromJSON(object.version) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.block !== undefined &&
            (obj.block = message.block ? exports.BlockParams.toJSON(message.block) : undefined);
        message.evidence !== undefined &&
            (obj.evidence = message.evidence ? exports.EvidenceParams.toJSON(message.evidence) : undefined);
        message.validator !== undefined &&
            (obj.validator = message.validator ? exports.ValidatorParams.toJSON(message.validator) : undefined);
        message.version !== undefined &&
            (obj.version = message.version ? exports.VersionParams.toJSON(message.version) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseConsensusParams();
        message.block =
            object.block !== undefined && object.block !== null ? exports.BlockParams.fromPartial(object.block) : undefined;
        message.evidence =
            object.evidence !== undefined && object.evidence !== null
                ? exports.EvidenceParams.fromPartial(object.evidence)
                : undefined;
        message.validator =
            object.validator !== undefined && object.validator !== null
                ? exports.ValidatorParams.fromPartial(object.validator)
                : undefined;
        message.version =
            object.version !== undefined && object.version !== null
                ? exports.VersionParams.fromPartial(object.version)
                : undefined;
        return message;
    },
};
function createBaseBlockParams() {
    return {
        maxBytes: helpers_1.Long.ZERO,
        maxGas: helpers_1.Long.ZERO,
    };
}
exports.BlockParams = {
    encode(message, writer = _m0.Writer.create()) {
        if (!message.maxBytes.isZero()) {
            writer.uint32(8).int64(message.maxBytes);
        }
        if (!message.maxGas.isZero()) {
            writer.uint32(16).int64(message.maxGas);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseBlockParams();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.maxBytes = reader.int64();
                    break;
                case 2:
                    message.maxGas = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            maxBytes: (0, helpers_1.isSet)(object.maxBytes) ? helpers_1.Long.fromValue(object.maxBytes) : helpers_1.Long.ZERO,
            maxGas: (0, helpers_1.isSet)(object.maxGas) ? helpers_1.Long.fromValue(object.maxGas) : helpers_1.Long.ZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        message.maxBytes !== undefined && (obj.maxBytes = (message.maxBytes || helpers_1.Long.ZERO).toString());
        message.maxGas !== undefined && (obj.maxGas = (message.maxGas || helpers_1.Long.ZERO).toString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseBlockParams();
        message.maxBytes =
            object.maxBytes !== undefined && object.maxBytes !== null ? helpers_1.Long.fromValue(object.maxBytes) : helpers_1.Long.ZERO;
        message.maxGas =
            object.maxGas !== undefined && object.maxGas !== null ? helpers_1.Long.fromValue(object.maxGas) : helpers_1.Long.ZERO;
        return message;
    },
};
function createBaseEvidenceParams() {
    return {
        maxAgeNumBlocks: helpers_1.Long.ZERO,
        maxAgeDuration: undefined,
        maxBytes: helpers_1.Long.ZERO,
    };
}
exports.EvidenceParams = {
    encode(message, writer = _m0.Writer.create()) {
        if (!message.maxAgeNumBlocks.isZero()) {
            writer.uint32(8).int64(message.maxAgeNumBlocks);
        }
        if (message.maxAgeDuration !== undefined) {
            duration_1.Duration.encode(message.maxAgeDuration, writer.uint32(18).fork()).ldelim();
        }
        if (!message.maxBytes.isZero()) {
            writer.uint32(24).int64(message.maxBytes);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseEvidenceParams();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.maxAgeNumBlocks = reader.int64();
                    break;
                case 2:
                    message.maxAgeDuration = duration_1.Duration.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.maxBytes = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            maxAgeNumBlocks: (0, helpers_1.isSet)(object.maxAgeNumBlocks) ? helpers_1.Long.fromValue(object.maxAgeNumBlocks) : helpers_1.Long.ZERO,
            maxAgeDuration: (0, helpers_1.isSet)(object.maxAgeDuration) ? duration_1.Duration.fromJSON(object.maxAgeDuration) : undefined,
            maxBytes: (0, helpers_1.isSet)(object.maxBytes) ? helpers_1.Long.fromValue(object.maxBytes) : helpers_1.Long.ZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        message.maxAgeNumBlocks !== undefined &&
            (obj.maxAgeNumBlocks = (message.maxAgeNumBlocks || helpers_1.Long.ZERO).toString());
        message.maxAgeDuration !== undefined &&
            (obj.maxAgeDuration = message.maxAgeDuration ? duration_1.Duration.toJSON(message.maxAgeDuration) : undefined);
        message.maxBytes !== undefined && (obj.maxBytes = (message.maxBytes || helpers_1.Long.ZERO).toString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseEvidenceParams();
        message.maxAgeNumBlocks =
            object.maxAgeNumBlocks !== undefined && object.maxAgeNumBlocks !== null
                ? helpers_1.Long.fromValue(object.maxAgeNumBlocks)
                : helpers_1.Long.ZERO;
        message.maxAgeDuration =
            object.maxAgeDuration !== undefined && object.maxAgeDuration !== null
                ? duration_1.Duration.fromPartial(object.maxAgeDuration)
                : undefined;
        message.maxBytes =
            object.maxBytes !== undefined && object.maxBytes !== null ? helpers_1.Long.fromValue(object.maxBytes) : helpers_1.Long.ZERO;
        return message;
    },
};
function createBaseValidatorParams() {
    return {
        pubKeyTypes: [],
    };
}
exports.ValidatorParams = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.pubKeyTypes) {
            writer.uint32(10).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseValidatorParams();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.pubKeyTypes.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            pubKeyTypes: Array.isArray(object?.pubKeyTypes) ? object.pubKeyTypes.map((e) => String(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.pubKeyTypes) {
            obj.pubKeyTypes = message.pubKeyTypes.map((e) => e);
        }
        else {
            obj.pubKeyTypes = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseValidatorParams();
        message.pubKeyTypes = object.pubKeyTypes?.map((e) => e) || [];
        return message;
    },
};
function createBaseVersionParams() {
    return {
        app: helpers_1.Long.UZERO,
    };
}
exports.VersionParams = {
    encode(message, writer = _m0.Writer.create()) {
        if (!message.app.isZero()) {
            writer.uint32(8).uint64(message.app);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVersionParams();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.app = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            app: (0, helpers_1.isSet)(object.app) ? helpers_1.Long.fromValue(object.app) : helpers_1.Long.UZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        message.app !== undefined && (obj.app = (message.app || helpers_1.Long.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseVersionParams();
        message.app = object.app !== undefined && object.app !== null ? helpers_1.Long.fromValue(object.app) : helpers_1.Long.UZERO;
        return message;
    },
};
function createBaseHashedParams() {
    return {
        blockMaxBytes: helpers_1.Long.ZERO,
        blockMaxGas: helpers_1.Long.ZERO,
    };
}
exports.HashedParams = {
    encode(message, writer = _m0.Writer.create()) {
        if (!message.blockMaxBytes.isZero()) {
            writer.uint32(8).int64(message.blockMaxBytes);
        }
        if (!message.blockMaxGas.isZero()) {
            writer.uint32(16).int64(message.blockMaxGas);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseHashedParams();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.blockMaxBytes = reader.int64();
                    break;
                case 2:
                    message.blockMaxGas = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            blockMaxBytes: (0, helpers_1.isSet)(object.blockMaxBytes) ? helpers_1.Long.fromValue(object.blockMaxBytes) : helpers_1.Long.ZERO,
            blockMaxGas: (0, helpers_1.isSet)(object.blockMaxGas) ? helpers_1.Long.fromValue(object.blockMaxGas) : helpers_1.Long.ZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        message.blockMaxBytes !== undefined &&
            (obj.blockMaxBytes = (message.blockMaxBytes || helpers_1.Long.ZERO).toString());
        message.blockMaxGas !== undefined && (obj.blockMaxGas = (message.blockMaxGas || helpers_1.Long.ZERO).toString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseHashedParams();
        message.blockMaxBytes =
            object.blockMaxBytes !== undefined && object.blockMaxBytes !== null
                ? helpers_1.Long.fromValue(object.blockMaxBytes)
                : helpers_1.Long.ZERO;
        message.blockMaxGas =
            object.blockMaxGas !== undefined && object.blockMaxGas !== null
                ? helpers_1.Long.fromValue(object.blockMaxGas)
                : helpers_1.Long.ZERO;
        return message;
    },
};
//# sourceMappingURL=params.js.map

/***/ }),

/***/ 34681:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.TxProof = exports.BlockMeta = exports.LightBlock = exports.SignedHeader = exports.Proposal = exports.CommitSig = exports.Commit = exports.Vote = exports.Data = exports.Header = exports.BlockID = exports.Part = exports.PartSetHeader = exports.signedMsgTypeToJSON = exports.signedMsgTypeFromJSON = exports.SignedMsgType = exports.blockIDFlagToJSON = exports.blockIDFlagFromJSON = exports.BlockIDFlag = exports.protobufPackage = void 0;
/* eslint-disable */
const proof_1 = __webpack_require__(21874);
const types_1 = __webpack_require__(95564);
const timestamp_1 = __webpack_require__(70147);
const validator_1 = __webpack_require__(25575);
const helpers_1 = __webpack_require__(92654);
const _m0 = __importStar(__webpack_require__(62100));
exports.protobufPackage = "tendermint.types";
/** BlockIdFlag indicates which BlcokID the signature is for */
var BlockIDFlag;
(function (BlockIDFlag) {
    BlockIDFlag[BlockIDFlag["BLOCK_ID_FLAG_UNKNOWN"] = 0] = "BLOCK_ID_FLAG_UNKNOWN";
    BlockIDFlag[BlockIDFlag["BLOCK_ID_FLAG_ABSENT"] = 1] = "BLOCK_ID_FLAG_ABSENT";
    BlockIDFlag[BlockIDFlag["BLOCK_ID_FLAG_COMMIT"] = 2] = "BLOCK_ID_FLAG_COMMIT";
    BlockIDFlag[BlockIDFlag["BLOCK_ID_FLAG_NIL"] = 3] = "BLOCK_ID_FLAG_NIL";
    BlockIDFlag[BlockIDFlag["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(BlockIDFlag = exports.BlockIDFlag || (exports.BlockIDFlag = {}));
function blockIDFlagFromJSON(object) {
    switch (object) {
        case 0:
        case "BLOCK_ID_FLAG_UNKNOWN":
            return BlockIDFlag.BLOCK_ID_FLAG_UNKNOWN;
        case 1:
        case "BLOCK_ID_FLAG_ABSENT":
            return BlockIDFlag.BLOCK_ID_FLAG_ABSENT;
        case 2:
        case "BLOCK_ID_FLAG_COMMIT":
            return BlockIDFlag.BLOCK_ID_FLAG_COMMIT;
        case 3:
        case "BLOCK_ID_FLAG_NIL":
            return BlockIDFlag.BLOCK_ID_FLAG_NIL;
        case -1:
        case "UNRECOGNIZED":
        default:
            return BlockIDFlag.UNRECOGNIZED;
    }
}
exports.blockIDFlagFromJSON = blockIDFlagFromJSON;
function blockIDFlagToJSON(object) {
    switch (object) {
        case BlockIDFlag.BLOCK_ID_FLAG_UNKNOWN:
            return "BLOCK_ID_FLAG_UNKNOWN";
        case BlockIDFlag.BLOCK_ID_FLAG_ABSENT:
            return "BLOCK_ID_FLAG_ABSENT";
        case BlockIDFlag.BLOCK_ID_FLAG_COMMIT:
            return "BLOCK_ID_FLAG_COMMIT";
        case BlockIDFlag.BLOCK_ID_FLAG_NIL:
            return "BLOCK_ID_FLAG_NIL";
        case BlockIDFlag.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.blockIDFlagToJSON = blockIDFlagToJSON;
/** SignedMsgType is a type of signed message in the consensus. */
var SignedMsgType;
(function (SignedMsgType) {
    SignedMsgType[SignedMsgType["SIGNED_MSG_TYPE_UNKNOWN"] = 0] = "SIGNED_MSG_TYPE_UNKNOWN";
    /** SIGNED_MSG_TYPE_PREVOTE - Votes */
    SignedMsgType[SignedMsgType["SIGNED_MSG_TYPE_PREVOTE"] = 1] = "SIGNED_MSG_TYPE_PREVOTE";
    SignedMsgType[SignedMsgType["SIGNED_MSG_TYPE_PRECOMMIT"] = 2] = "SIGNED_MSG_TYPE_PRECOMMIT";
    /** SIGNED_MSG_TYPE_PROPOSAL - Proposals */
    SignedMsgType[SignedMsgType["SIGNED_MSG_TYPE_PROPOSAL"] = 32] = "SIGNED_MSG_TYPE_PROPOSAL";
    SignedMsgType[SignedMsgType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(SignedMsgType = exports.SignedMsgType || (exports.SignedMsgType = {}));
function signedMsgTypeFromJSON(object) {
    switch (object) {
        case 0:
        case "SIGNED_MSG_TYPE_UNKNOWN":
            return SignedMsgType.SIGNED_MSG_TYPE_UNKNOWN;
        case 1:
        case "SIGNED_MSG_TYPE_PREVOTE":
            return SignedMsgType.SIGNED_MSG_TYPE_PREVOTE;
        case 2:
        case "SIGNED_MSG_TYPE_PRECOMMIT":
            return SignedMsgType.SIGNED_MSG_TYPE_PRECOMMIT;
        case 32:
        case "SIGNED_MSG_TYPE_PROPOSAL":
            return SignedMsgType.SIGNED_MSG_TYPE_PROPOSAL;
        case -1:
        case "UNRECOGNIZED":
        default:
            return SignedMsgType.UNRECOGNIZED;
    }
}
exports.signedMsgTypeFromJSON = signedMsgTypeFromJSON;
function signedMsgTypeToJSON(object) {
    switch (object) {
        case SignedMsgType.SIGNED_MSG_TYPE_UNKNOWN:
            return "SIGNED_MSG_TYPE_UNKNOWN";
        case SignedMsgType.SIGNED_MSG_TYPE_PREVOTE:
            return "SIGNED_MSG_TYPE_PREVOTE";
        case SignedMsgType.SIGNED_MSG_TYPE_PRECOMMIT:
            return "SIGNED_MSG_TYPE_PRECOMMIT";
        case SignedMsgType.SIGNED_MSG_TYPE_PROPOSAL:
            return "SIGNED_MSG_TYPE_PROPOSAL";
        case SignedMsgType.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.signedMsgTypeToJSON = signedMsgTypeToJSON;
function createBasePartSetHeader() {
    return {
        total: 0,
        hash: new Uint8Array(),
    };
}
exports.PartSetHeader = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.total !== 0) {
            writer.uint32(8).uint32(message.total);
        }
        if (message.hash.length !== 0) {
            writer.uint32(18).bytes(message.hash);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePartSetHeader();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.total = reader.uint32();
                    break;
                case 2:
                    message.hash = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            total: (0, helpers_1.isSet)(object.total) ? Number(object.total) : 0,
            hash: (0, helpers_1.isSet)(object.hash) ? (0, helpers_1.bytesFromBase64)(object.hash) : new Uint8Array(),
        };
    },
    toJSON(message) {
        const obj = {};
        message.total !== undefined && (obj.total = Math.round(message.total));
        message.hash !== undefined &&
            (obj.hash = (0, helpers_1.base64FromBytes)(message.hash !== undefined ? message.hash : new Uint8Array()));
        return obj;
    },
    fromPartial(object) {
        const message = createBasePartSetHeader();
        message.total = object.total ?? 0;
        message.hash = object.hash ?? new Uint8Array();
        return message;
    },
};
function createBasePart() {
    return {
        index: 0,
        bytes: new Uint8Array(),
        proof: undefined,
    };
}
exports.Part = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.index !== 0) {
            writer.uint32(8).uint32(message.index);
        }
        if (message.bytes.length !== 0) {
            writer.uint32(18).bytes(message.bytes);
        }
        if (message.proof !== undefined) {
            proof_1.Proof.encode(message.proof, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePart();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.index = reader.uint32();
                    break;
                case 2:
                    message.bytes = reader.bytes();
                    break;
                case 3:
                    message.proof = proof_1.Proof.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            index: (0, helpers_1.isSet)(object.index) ? Number(object.index) : 0,
            bytes: (0, helpers_1.isSet)(object.bytes) ? (0, helpers_1.bytesFromBase64)(object.bytes) : new Uint8Array(),
            proof: (0, helpers_1.isSet)(object.proof) ? proof_1.Proof.fromJSON(object.proof) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.index !== undefined && (obj.index = Math.round(message.index));
        message.bytes !== undefined &&
            (obj.bytes = (0, helpers_1.base64FromBytes)(message.bytes !== undefined ? message.bytes : new Uint8Array()));
        message.proof !== undefined && (obj.proof = message.proof ? proof_1.Proof.toJSON(message.proof) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBasePart();
        message.index = object.index ?? 0;
        message.bytes = object.bytes ?? new Uint8Array();
        message.proof =
            object.proof !== undefined && object.proof !== null ? proof_1.Proof.fromPartial(object.proof) : undefined;
        return message;
    },
};
function createBaseBlockID() {
    return {
        hash: new Uint8Array(),
        partSetHeader: undefined,
    };
}
exports.BlockID = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.hash.length !== 0) {
            writer.uint32(10).bytes(message.hash);
        }
        if (message.partSetHeader !== undefined) {
            exports.PartSetHeader.encode(message.partSetHeader, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseBlockID();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.hash = reader.bytes();
                    break;
                case 2:
                    message.partSetHeader = exports.PartSetHeader.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            hash: (0, helpers_1.isSet)(object.hash) ? (0, helpers_1.bytesFromBase64)(object.hash) : new Uint8Array(),
            partSetHeader: (0, helpers_1.isSet)(object.partSetHeader) ? exports.PartSetHeader.fromJSON(object.partSetHeader) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.hash !== undefined &&
            (obj.hash = (0, helpers_1.base64FromBytes)(message.hash !== undefined ? message.hash : new Uint8Array()));
        message.partSetHeader !== undefined &&
            (obj.partSetHeader = message.partSetHeader ? exports.PartSetHeader.toJSON(message.partSetHeader) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseBlockID();
        message.hash = object.hash ?? new Uint8Array();
        message.partSetHeader =
            object.partSetHeader !== undefined && object.partSetHeader !== null
                ? exports.PartSetHeader.fromPartial(object.partSetHeader)
                : undefined;
        return message;
    },
};
function createBaseHeader() {
    return {
        version: undefined,
        chainId: "",
        height: helpers_1.Long.ZERO,
        time: undefined,
        lastBlockId: undefined,
        lastCommitHash: new Uint8Array(),
        dataHash: new Uint8Array(),
        validatorsHash: new Uint8Array(),
        nextValidatorsHash: new Uint8Array(),
        consensusHash: new Uint8Array(),
        appHash: new Uint8Array(),
        lastResultsHash: new Uint8Array(),
        evidenceHash: new Uint8Array(),
        proposerAddress: new Uint8Array(),
    };
}
exports.Header = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.version !== undefined) {
            types_1.Consensus.encode(message.version, writer.uint32(10).fork()).ldelim();
        }
        if (message.chainId !== "") {
            writer.uint32(18).string(message.chainId);
        }
        if (!message.height.isZero()) {
            writer.uint32(24).int64(message.height);
        }
        if (message.time !== undefined) {
            timestamp_1.Timestamp.encode(message.time, writer.uint32(34).fork()).ldelim();
        }
        if (message.lastBlockId !== undefined) {
            exports.BlockID.encode(message.lastBlockId, writer.uint32(42).fork()).ldelim();
        }
        if (message.lastCommitHash.length !== 0) {
            writer.uint32(50).bytes(message.lastCommitHash);
        }
        if (message.dataHash.length !== 0) {
            writer.uint32(58).bytes(message.dataHash);
        }
        if (message.validatorsHash.length !== 0) {
            writer.uint32(66).bytes(message.validatorsHash);
        }
        if (message.nextValidatorsHash.length !== 0) {
            writer.uint32(74).bytes(message.nextValidatorsHash);
        }
        if (message.consensusHash.length !== 0) {
            writer.uint32(82).bytes(message.consensusHash);
        }
        if (message.appHash.length !== 0) {
            writer.uint32(90).bytes(message.appHash);
        }
        if (message.lastResultsHash.length !== 0) {
            writer.uint32(98).bytes(message.lastResultsHash);
        }
        if (message.evidenceHash.length !== 0) {
            writer.uint32(106).bytes(message.evidenceHash);
        }
        if (message.proposerAddress.length !== 0) {
            writer.uint32(114).bytes(message.proposerAddress);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseHeader();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.version = types_1.Consensus.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.chainId = reader.string();
                    break;
                case 3:
                    message.height = reader.int64();
                    break;
                case 4:
                    message.time = timestamp_1.Timestamp.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.lastBlockId = exports.BlockID.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.lastCommitHash = reader.bytes();
                    break;
                case 7:
                    message.dataHash = reader.bytes();
                    break;
                case 8:
                    message.validatorsHash = reader.bytes();
                    break;
                case 9:
                    message.nextValidatorsHash = reader.bytes();
                    break;
                case 10:
                    message.consensusHash = reader.bytes();
                    break;
                case 11:
                    message.appHash = reader.bytes();
                    break;
                case 12:
                    message.lastResultsHash = reader.bytes();
                    break;
                case 13:
                    message.evidenceHash = reader.bytes();
                    break;
                case 14:
                    message.proposerAddress = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            version: (0, helpers_1.isSet)(object.version) ? types_1.Consensus.fromJSON(object.version) : undefined,
            chainId: (0, helpers_1.isSet)(object.chainId) ? String(object.chainId) : "",
            height: (0, helpers_1.isSet)(object.height) ? helpers_1.Long.fromValue(object.height) : helpers_1.Long.ZERO,
            time: (0, helpers_1.isSet)(object.time) ? (0, helpers_1.fromJsonTimestamp)(object.time) : undefined,
            lastBlockId: (0, helpers_1.isSet)(object.lastBlockId) ? exports.BlockID.fromJSON(object.lastBlockId) : undefined,
            lastCommitHash: (0, helpers_1.isSet)(object.lastCommitHash)
                ? (0, helpers_1.bytesFromBase64)(object.lastCommitHash)
                : new Uint8Array(),
            dataHash: (0, helpers_1.isSet)(object.dataHash) ? (0, helpers_1.bytesFromBase64)(object.dataHash) : new Uint8Array(),
            validatorsHash: (0, helpers_1.isSet)(object.validatorsHash)
                ? (0, helpers_1.bytesFromBase64)(object.validatorsHash)
                : new Uint8Array(),
            nextValidatorsHash: (0, helpers_1.isSet)(object.nextValidatorsHash)
                ? (0, helpers_1.bytesFromBase64)(object.nextValidatorsHash)
                : new Uint8Array(),
            consensusHash: (0, helpers_1.isSet)(object.consensusHash) ? (0, helpers_1.bytesFromBase64)(object.consensusHash) : new Uint8Array(),
            appHash: (0, helpers_1.isSet)(object.appHash) ? (0, helpers_1.bytesFromBase64)(object.appHash) : new Uint8Array(),
            lastResultsHash: (0, helpers_1.isSet)(object.lastResultsHash)
                ? (0, helpers_1.bytesFromBase64)(object.lastResultsHash)
                : new Uint8Array(),
            evidenceHash: (0, helpers_1.isSet)(object.evidenceHash) ? (0, helpers_1.bytesFromBase64)(object.evidenceHash) : new Uint8Array(),
            proposerAddress: (0, helpers_1.isSet)(object.proposerAddress)
                ? (0, helpers_1.bytesFromBase64)(object.proposerAddress)
                : new Uint8Array(),
        };
    },
    toJSON(message) {
        const obj = {};
        message.version !== undefined &&
            (obj.version = message.version ? types_1.Consensus.toJSON(message.version) : undefined);
        message.chainId !== undefined && (obj.chainId = message.chainId);
        message.height !== undefined && (obj.height = (message.height || helpers_1.Long.ZERO).toString());
        message.time !== undefined && (obj.time = (0, helpers_1.fromTimestamp)(message.time).toISOString());
        message.lastBlockId !== undefined &&
            (obj.lastBlockId = message.lastBlockId ? exports.BlockID.toJSON(message.lastBlockId) : undefined);
        message.lastCommitHash !== undefined &&
            (obj.lastCommitHash = (0, helpers_1.base64FromBytes)(message.lastCommitHash !== undefined ? message.lastCommitHash : new Uint8Array()));
        message.dataHash !== undefined &&
            (obj.dataHash = (0, helpers_1.base64FromBytes)(message.dataHash !== undefined ? message.dataHash : new Uint8Array()));
        message.validatorsHash !== undefined &&
            (obj.validatorsHash = (0, helpers_1.base64FromBytes)(message.validatorsHash !== undefined ? message.validatorsHash : new Uint8Array()));
        message.nextValidatorsHash !== undefined &&
            (obj.nextValidatorsHash = (0, helpers_1.base64FromBytes)(message.nextValidatorsHash !== undefined ? message.nextValidatorsHash : new Uint8Array()));
        message.consensusHash !== undefined &&
            (obj.consensusHash = (0, helpers_1.base64FromBytes)(message.consensusHash !== undefined ? message.consensusHash : new Uint8Array()));
        message.appHash !== undefined &&
            (obj.appHash = (0, helpers_1.base64FromBytes)(message.appHash !== undefined ? message.appHash : new Uint8Array()));
        message.lastResultsHash !== undefined &&
            (obj.lastResultsHash = (0, helpers_1.base64FromBytes)(message.lastResultsHash !== undefined ? message.lastResultsHash : new Uint8Array()));
        message.evidenceHash !== undefined &&
            (obj.evidenceHash = (0, helpers_1.base64FromBytes)(message.evidenceHash !== undefined ? message.evidenceHash : new Uint8Array()));
        message.proposerAddress !== undefined &&
            (obj.proposerAddress = (0, helpers_1.base64FromBytes)(message.proposerAddress !== undefined ? message.proposerAddress : new Uint8Array()));
        return obj;
    },
    fromPartial(object) {
        const message = createBaseHeader();
        message.version =
            object.version !== undefined && object.version !== null
                ? types_1.Consensus.fromPartial(object.version)
                : undefined;
        message.chainId = object.chainId ?? "";
        message.height =
            object.height !== undefined && object.height !== null ? helpers_1.Long.fromValue(object.height) : helpers_1.Long.ZERO;
        message.time =
            object.time !== undefined && object.time !== null ? timestamp_1.Timestamp.fromPartial(object.time) : undefined;
        message.lastBlockId =
            object.lastBlockId !== undefined && object.lastBlockId !== null
                ? exports.BlockID.fromPartial(object.lastBlockId)
                : undefined;
        message.lastCommitHash = object.lastCommitHash ?? new Uint8Array();
        message.dataHash = object.dataHash ?? new Uint8Array();
        message.validatorsHash = object.validatorsHash ?? new Uint8Array();
        message.nextValidatorsHash = object.nextValidatorsHash ?? new Uint8Array();
        message.consensusHash = object.consensusHash ?? new Uint8Array();
        message.appHash = object.appHash ?? new Uint8Array();
        message.lastResultsHash = object.lastResultsHash ?? new Uint8Array();
        message.evidenceHash = object.evidenceHash ?? new Uint8Array();
        message.proposerAddress = object.proposerAddress ?? new Uint8Array();
        return message;
    },
};
function createBaseData() {
    return {
        txs: [],
    };
}
exports.Data = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.txs) {
            writer.uint32(10).bytes(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseData();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.txs.push(reader.bytes());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            txs: Array.isArray(object?.txs) ? object.txs.map((e) => (0, helpers_1.bytesFromBase64)(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.txs) {
            obj.txs = message.txs.map((e) => (0, helpers_1.base64FromBytes)(e !== undefined ? e : new Uint8Array()));
        }
        else {
            obj.txs = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseData();
        message.txs = object.txs?.map((e) => e) || [];
        return message;
    },
};
function createBaseVote() {
    return {
        type: 0,
        height: helpers_1.Long.ZERO,
        round: 0,
        blockId: undefined,
        timestamp: undefined,
        validatorAddress: new Uint8Array(),
        validatorIndex: 0,
        signature: new Uint8Array(),
    };
}
exports.Vote = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.type !== 0) {
            writer.uint32(8).int32(message.type);
        }
        if (!message.height.isZero()) {
            writer.uint32(16).int64(message.height);
        }
        if (message.round !== 0) {
            writer.uint32(24).int32(message.round);
        }
        if (message.blockId !== undefined) {
            exports.BlockID.encode(message.blockId, writer.uint32(34).fork()).ldelim();
        }
        if (message.timestamp !== undefined) {
            timestamp_1.Timestamp.encode(message.timestamp, writer.uint32(42).fork()).ldelim();
        }
        if (message.validatorAddress.length !== 0) {
            writer.uint32(50).bytes(message.validatorAddress);
        }
        if (message.validatorIndex !== 0) {
            writer.uint32(56).int32(message.validatorIndex);
        }
        if (message.signature.length !== 0) {
            writer.uint32(66).bytes(message.signature);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVote();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.type = reader.int32();
                    break;
                case 2:
                    message.height = reader.int64();
                    break;
                case 3:
                    message.round = reader.int32();
                    break;
                case 4:
                    message.blockId = exports.BlockID.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.timestamp = timestamp_1.Timestamp.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.validatorAddress = reader.bytes();
                    break;
                case 7:
                    message.validatorIndex = reader.int32();
                    break;
                case 8:
                    message.signature = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            type: (0, helpers_1.isSet)(object.type) ? signedMsgTypeFromJSON(object.type) : 0,
            height: (0, helpers_1.isSet)(object.height) ? helpers_1.Long.fromValue(object.height) : helpers_1.Long.ZERO,
            round: (0, helpers_1.isSet)(object.round) ? Number(object.round) : 0,
            blockId: (0, helpers_1.isSet)(object.blockId) ? exports.BlockID.fromJSON(object.blockId) : undefined,
            timestamp: (0, helpers_1.isSet)(object.timestamp) ? (0, helpers_1.fromJsonTimestamp)(object.timestamp) : undefined,
            validatorAddress: (0, helpers_1.isSet)(object.validatorAddress)
                ? (0, helpers_1.bytesFromBase64)(object.validatorAddress)
                : new Uint8Array(),
            validatorIndex: (0, helpers_1.isSet)(object.validatorIndex) ? Number(object.validatorIndex) : 0,
            signature: (0, helpers_1.isSet)(object.signature) ? (0, helpers_1.bytesFromBase64)(object.signature) : new Uint8Array(),
        };
    },
    toJSON(message) {
        const obj = {};
        message.type !== undefined && (obj.type = signedMsgTypeToJSON(message.type));
        message.height !== undefined && (obj.height = (message.height || helpers_1.Long.ZERO).toString());
        message.round !== undefined && (obj.round = Math.round(message.round));
        message.blockId !== undefined &&
            (obj.blockId = message.blockId ? exports.BlockID.toJSON(message.blockId) : undefined);
        message.timestamp !== undefined && (obj.timestamp = (0, helpers_1.fromTimestamp)(message.timestamp).toISOString());
        message.validatorAddress !== undefined &&
            (obj.validatorAddress = (0, helpers_1.base64FromBytes)(message.validatorAddress !== undefined ? message.validatorAddress : new Uint8Array()));
        message.validatorIndex !== undefined && (obj.validatorIndex = Math.round(message.validatorIndex));
        message.signature !== undefined &&
            (obj.signature = (0, helpers_1.base64FromBytes)(message.signature !== undefined ? message.signature : new Uint8Array()));
        return obj;
    },
    fromPartial(object) {
        const message = createBaseVote();
        message.type = object.type ?? 0;
        message.height =
            object.height !== undefined && object.height !== null ? helpers_1.Long.fromValue(object.height) : helpers_1.Long.ZERO;
        message.round = object.round ?? 0;
        message.blockId =
            object.blockId !== undefined && object.blockId !== null
                ? exports.BlockID.fromPartial(object.blockId)
                : undefined;
        message.timestamp =
            object.timestamp !== undefined && object.timestamp !== null
                ? timestamp_1.Timestamp.fromPartial(object.timestamp)
                : undefined;
        message.validatorAddress = object.validatorAddress ?? new Uint8Array();
        message.validatorIndex = object.validatorIndex ?? 0;
        message.signature = object.signature ?? new Uint8Array();
        return message;
    },
};
function createBaseCommit() {
    return {
        height: helpers_1.Long.ZERO,
        round: 0,
        blockId: undefined,
        signatures: [],
    };
}
exports.Commit = {
    encode(message, writer = _m0.Writer.create()) {
        if (!message.height.isZero()) {
            writer.uint32(8).int64(message.height);
        }
        if (message.round !== 0) {
            writer.uint32(16).int32(message.round);
        }
        if (message.blockId !== undefined) {
            exports.BlockID.encode(message.blockId, writer.uint32(26).fork()).ldelim();
        }
        for (const v of message.signatures) {
            exports.CommitSig.encode(v, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCommit();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.height = reader.int64();
                    break;
                case 2:
                    message.round = reader.int32();
                    break;
                case 3:
                    message.blockId = exports.BlockID.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.signatures.push(exports.CommitSig.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            height: (0, helpers_1.isSet)(object.height) ? helpers_1.Long.fromValue(object.height) : helpers_1.Long.ZERO,
            round: (0, helpers_1.isSet)(object.round) ? Number(object.round) : 0,
            blockId: (0, helpers_1.isSet)(object.blockId) ? exports.BlockID.fromJSON(object.blockId) : undefined,
            signatures: Array.isArray(object?.signatures)
                ? object.signatures.map((e) => exports.CommitSig.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        message.height !== undefined && (obj.height = (message.height || helpers_1.Long.ZERO).toString());
        message.round !== undefined && (obj.round = Math.round(message.round));
        message.blockId !== undefined &&
            (obj.blockId = message.blockId ? exports.BlockID.toJSON(message.blockId) : undefined);
        if (message.signatures) {
            obj.signatures = message.signatures.map((e) => (e ? exports.CommitSig.toJSON(e) : undefined));
        }
        else {
            obj.signatures = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseCommit();
        message.height =
            object.height !== undefined && object.height !== null ? helpers_1.Long.fromValue(object.height) : helpers_1.Long.ZERO;
        message.round = object.round ?? 0;
        message.blockId =
            object.blockId !== undefined && object.blockId !== null
                ? exports.BlockID.fromPartial(object.blockId)
                : undefined;
        message.signatures = object.signatures?.map((e) => exports.CommitSig.fromPartial(e)) || [];
        return message;
    },
};
function createBaseCommitSig() {
    return {
        blockIdFlag: 0,
        validatorAddress: new Uint8Array(),
        timestamp: undefined,
        signature: new Uint8Array(),
    };
}
exports.CommitSig = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.blockIdFlag !== 0) {
            writer.uint32(8).int32(message.blockIdFlag);
        }
        if (message.validatorAddress.length !== 0) {
            writer.uint32(18).bytes(message.validatorAddress);
        }
        if (message.timestamp !== undefined) {
            timestamp_1.Timestamp.encode(message.timestamp, writer.uint32(26).fork()).ldelim();
        }
        if (message.signature.length !== 0) {
            writer.uint32(34).bytes(message.signature);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCommitSig();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.blockIdFlag = reader.int32();
                    break;
                case 2:
                    message.validatorAddress = reader.bytes();
                    break;
                case 3:
                    message.timestamp = timestamp_1.Timestamp.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.signature = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            blockIdFlag: (0, helpers_1.isSet)(object.blockIdFlag) ? blockIDFlagFromJSON(object.blockIdFlag) : 0,
            validatorAddress: (0, helpers_1.isSet)(object.validatorAddress)
                ? (0, helpers_1.bytesFromBase64)(object.validatorAddress)
                : new Uint8Array(),
            timestamp: (0, helpers_1.isSet)(object.timestamp) ? (0, helpers_1.fromJsonTimestamp)(object.timestamp) : undefined,
            signature: (0, helpers_1.isSet)(object.signature) ? (0, helpers_1.bytesFromBase64)(object.signature) : new Uint8Array(),
        };
    },
    toJSON(message) {
        const obj = {};
        message.blockIdFlag !== undefined && (obj.blockIdFlag = blockIDFlagToJSON(message.blockIdFlag));
        message.validatorAddress !== undefined &&
            (obj.validatorAddress = (0, helpers_1.base64FromBytes)(message.validatorAddress !== undefined ? message.validatorAddress : new Uint8Array()));
        message.timestamp !== undefined && (obj.timestamp = (0, helpers_1.fromTimestamp)(message.timestamp).toISOString());
        message.signature !== undefined &&
            (obj.signature = (0, helpers_1.base64FromBytes)(message.signature !== undefined ? message.signature : new Uint8Array()));
        return obj;
    },
    fromPartial(object) {
        const message = createBaseCommitSig();
        message.blockIdFlag = object.blockIdFlag ?? 0;
        message.validatorAddress = object.validatorAddress ?? new Uint8Array();
        message.timestamp =
            object.timestamp !== undefined && object.timestamp !== null
                ? timestamp_1.Timestamp.fromPartial(object.timestamp)
                : undefined;
        message.signature = object.signature ?? new Uint8Array();
        return message;
    },
};
function createBaseProposal() {
    return {
        type: 0,
        height: helpers_1.Long.ZERO,
        round: 0,
        polRound: 0,
        blockId: undefined,
        timestamp: undefined,
        signature: new Uint8Array(),
    };
}
exports.Proposal = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.type !== 0) {
            writer.uint32(8).int32(message.type);
        }
        if (!message.height.isZero()) {
            writer.uint32(16).int64(message.height);
        }
        if (message.round !== 0) {
            writer.uint32(24).int32(message.round);
        }
        if (message.polRound !== 0) {
            writer.uint32(32).int32(message.polRound);
        }
        if (message.blockId !== undefined) {
            exports.BlockID.encode(message.blockId, writer.uint32(42).fork()).ldelim();
        }
        if (message.timestamp !== undefined) {
            timestamp_1.Timestamp.encode(message.timestamp, writer.uint32(50).fork()).ldelim();
        }
        if (message.signature.length !== 0) {
            writer.uint32(58).bytes(message.signature);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseProposal();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.type = reader.int32();
                    break;
                case 2:
                    message.height = reader.int64();
                    break;
                case 3:
                    message.round = reader.int32();
                    break;
                case 4:
                    message.polRound = reader.int32();
                    break;
                case 5:
                    message.blockId = exports.BlockID.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.timestamp = timestamp_1.Timestamp.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.signature = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            type: (0, helpers_1.isSet)(object.type) ? signedMsgTypeFromJSON(object.type) : 0,
            height: (0, helpers_1.isSet)(object.height) ? helpers_1.Long.fromValue(object.height) : helpers_1.Long.ZERO,
            round: (0, helpers_1.isSet)(object.round) ? Number(object.round) : 0,
            polRound: (0, helpers_1.isSet)(object.polRound) ? Number(object.polRound) : 0,
            blockId: (0, helpers_1.isSet)(object.blockId) ? exports.BlockID.fromJSON(object.blockId) : undefined,
            timestamp: (0, helpers_1.isSet)(object.timestamp) ? (0, helpers_1.fromJsonTimestamp)(object.timestamp) : undefined,
            signature: (0, helpers_1.isSet)(object.signature) ? (0, helpers_1.bytesFromBase64)(object.signature) : new Uint8Array(),
        };
    },
    toJSON(message) {
        const obj = {};
        message.type !== undefined && (obj.type = signedMsgTypeToJSON(message.type));
        message.height !== undefined && (obj.height = (message.height || helpers_1.Long.ZERO).toString());
        message.round !== undefined && (obj.round = Math.round(message.round));
        message.polRound !== undefined && (obj.polRound = Math.round(message.polRound));
        message.blockId !== undefined &&
            (obj.blockId = message.blockId ? exports.BlockID.toJSON(message.blockId) : undefined);
        message.timestamp !== undefined && (obj.timestamp = (0, helpers_1.fromTimestamp)(message.timestamp).toISOString());
        message.signature !== undefined &&
            (obj.signature = (0, helpers_1.base64FromBytes)(message.signature !== undefined ? message.signature : new Uint8Array()));
        return obj;
    },
    fromPartial(object) {
        const message = createBaseProposal();
        message.type = object.type ?? 0;
        message.height =
            object.height !== undefined && object.height !== null ? helpers_1.Long.fromValue(object.height) : helpers_1.Long.ZERO;
        message.round = object.round ?? 0;
        message.polRound = object.polRound ?? 0;
        message.blockId =
            object.blockId !== undefined && object.blockId !== null
                ? exports.BlockID.fromPartial(object.blockId)
                : undefined;
        message.timestamp =
            object.timestamp !== undefined && object.timestamp !== null
                ? timestamp_1.Timestamp.fromPartial(object.timestamp)
                : undefined;
        message.signature = object.signature ?? new Uint8Array();
        return message;
    },
};
function createBaseSignedHeader() {
    return {
        header: undefined,
        commit: undefined,
    };
}
exports.SignedHeader = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.header !== undefined) {
            exports.Header.encode(message.header, writer.uint32(10).fork()).ldelim();
        }
        if (message.commit !== undefined) {
            exports.Commit.encode(message.commit, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSignedHeader();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.header = exports.Header.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.commit = exports.Commit.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            header: (0, helpers_1.isSet)(object.header) ? exports.Header.fromJSON(object.header) : undefined,
            commit: (0, helpers_1.isSet)(object.commit) ? exports.Commit.fromJSON(object.commit) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.header !== undefined && (obj.header = message.header ? exports.Header.toJSON(message.header) : undefined);
        message.commit !== undefined && (obj.commit = message.commit ? exports.Commit.toJSON(message.commit) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseSignedHeader();
        message.header =
            object.header !== undefined && object.header !== null ? exports.Header.fromPartial(object.header) : undefined;
        message.commit =
            object.commit !== undefined && object.commit !== null ? exports.Commit.fromPartial(object.commit) : undefined;
        return message;
    },
};
function createBaseLightBlock() {
    return {
        signedHeader: undefined,
        validatorSet: undefined,
    };
}
exports.LightBlock = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.signedHeader !== undefined) {
            exports.SignedHeader.encode(message.signedHeader, writer.uint32(10).fork()).ldelim();
        }
        if (message.validatorSet !== undefined) {
            validator_1.ValidatorSet.encode(message.validatorSet, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseLightBlock();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.signedHeader = exports.SignedHeader.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.validatorSet = validator_1.ValidatorSet.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            signedHeader: (0, helpers_1.isSet)(object.signedHeader) ? exports.SignedHeader.fromJSON(object.signedHeader) : undefined,
            validatorSet: (0, helpers_1.isSet)(object.validatorSet) ? validator_1.ValidatorSet.fromJSON(object.validatorSet) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.signedHeader !== undefined &&
            (obj.signedHeader = message.signedHeader ? exports.SignedHeader.toJSON(message.signedHeader) : undefined);
        message.validatorSet !== undefined &&
            (obj.validatorSet = message.validatorSet ? validator_1.ValidatorSet.toJSON(message.validatorSet) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseLightBlock();
        message.signedHeader =
            object.signedHeader !== undefined && object.signedHeader !== null
                ? exports.SignedHeader.fromPartial(object.signedHeader)
                : undefined;
        message.validatorSet =
            object.validatorSet !== undefined && object.validatorSet !== null
                ? validator_1.ValidatorSet.fromPartial(object.validatorSet)
                : undefined;
        return message;
    },
};
function createBaseBlockMeta() {
    return {
        blockId: undefined,
        blockSize: helpers_1.Long.ZERO,
        header: undefined,
        numTxs: helpers_1.Long.ZERO,
    };
}
exports.BlockMeta = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.blockId !== undefined) {
            exports.BlockID.encode(message.blockId, writer.uint32(10).fork()).ldelim();
        }
        if (!message.blockSize.isZero()) {
            writer.uint32(16).int64(message.blockSize);
        }
        if (message.header !== undefined) {
            exports.Header.encode(message.header, writer.uint32(26).fork()).ldelim();
        }
        if (!message.numTxs.isZero()) {
            writer.uint32(32).int64(message.numTxs);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseBlockMeta();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.blockId = exports.BlockID.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.blockSize = reader.int64();
                    break;
                case 3:
                    message.header = exports.Header.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.numTxs = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            blockId: (0, helpers_1.isSet)(object.blockId) ? exports.BlockID.fromJSON(object.blockId) : undefined,
            blockSize: (0, helpers_1.isSet)(object.blockSize) ? helpers_1.Long.fromValue(object.blockSize) : helpers_1.Long.ZERO,
            header: (0, helpers_1.isSet)(object.header) ? exports.Header.fromJSON(object.header) : undefined,
            numTxs: (0, helpers_1.isSet)(object.numTxs) ? helpers_1.Long.fromValue(object.numTxs) : helpers_1.Long.ZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        message.blockId !== undefined &&
            (obj.blockId = message.blockId ? exports.BlockID.toJSON(message.blockId) : undefined);
        message.blockSize !== undefined && (obj.blockSize = (message.blockSize || helpers_1.Long.ZERO).toString());
        message.header !== undefined && (obj.header = message.header ? exports.Header.toJSON(message.header) : undefined);
        message.numTxs !== undefined && (obj.numTxs = (message.numTxs || helpers_1.Long.ZERO).toString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseBlockMeta();
        message.blockId =
            object.blockId !== undefined && object.blockId !== null
                ? exports.BlockID.fromPartial(object.blockId)
                : undefined;
        message.blockSize =
            object.blockSize !== undefined && object.blockSize !== null
                ? helpers_1.Long.fromValue(object.blockSize)
                : helpers_1.Long.ZERO;
        message.header =
            object.header !== undefined && object.header !== null ? exports.Header.fromPartial(object.header) : undefined;
        message.numTxs =
            object.numTxs !== undefined && object.numTxs !== null ? helpers_1.Long.fromValue(object.numTxs) : helpers_1.Long.ZERO;
        return message;
    },
};
function createBaseTxProof() {
    return {
        rootHash: new Uint8Array(),
        data: new Uint8Array(),
        proof: undefined,
    };
}
exports.TxProof = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.rootHash.length !== 0) {
            writer.uint32(10).bytes(message.rootHash);
        }
        if (message.data.length !== 0) {
            writer.uint32(18).bytes(message.data);
        }
        if (message.proof !== undefined) {
            proof_1.Proof.encode(message.proof, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTxProof();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.rootHash = reader.bytes();
                    break;
                case 2:
                    message.data = reader.bytes();
                    break;
                case 3:
                    message.proof = proof_1.Proof.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            rootHash: (0, helpers_1.isSet)(object.rootHash) ? (0, helpers_1.bytesFromBase64)(object.rootHash) : new Uint8Array(),
            data: (0, helpers_1.isSet)(object.data) ? (0, helpers_1.bytesFromBase64)(object.data) : new Uint8Array(),
            proof: (0, helpers_1.isSet)(object.proof) ? proof_1.Proof.fromJSON(object.proof) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.rootHash !== undefined &&
            (obj.rootHash = (0, helpers_1.base64FromBytes)(message.rootHash !== undefined ? message.rootHash : new Uint8Array()));
        message.data !== undefined &&
            (obj.data = (0, helpers_1.base64FromBytes)(message.data !== undefined ? message.data : new Uint8Array()));
        message.proof !== undefined && (obj.proof = message.proof ? proof_1.Proof.toJSON(message.proof) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseTxProof();
        message.rootHash = object.rootHash ?? new Uint8Array();
        message.data = object.data ?? new Uint8Array();
        message.proof =
            object.proof !== undefined && object.proof !== null ? proof_1.Proof.fromPartial(object.proof) : undefined;
        return message;
    },
};
//# sourceMappingURL=types.js.map

/***/ }),

/***/ 25575:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.SimpleValidator = exports.Validator = exports.ValidatorSet = exports.protobufPackage = void 0;
/* eslint-disable */
const keys_1 = __webpack_require__(67858);
const helpers_1 = __webpack_require__(92654);
const _m0 = __importStar(__webpack_require__(62100));
exports.protobufPackage = "tendermint.types";
function createBaseValidatorSet() {
    return {
        validators: [],
        proposer: undefined,
        totalVotingPower: helpers_1.Long.ZERO,
    };
}
exports.ValidatorSet = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.validators) {
            exports.Validator.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.proposer !== undefined) {
            exports.Validator.encode(message.proposer, writer.uint32(18).fork()).ldelim();
        }
        if (!message.totalVotingPower.isZero()) {
            writer.uint32(24).int64(message.totalVotingPower);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseValidatorSet();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.validators.push(exports.Validator.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.proposer = exports.Validator.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.totalVotingPower = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            validators: Array.isArray(object?.validators)
                ? object.validators.map((e) => exports.Validator.fromJSON(e))
                : [],
            proposer: (0, helpers_1.isSet)(object.proposer) ? exports.Validator.fromJSON(object.proposer) : undefined,
            totalVotingPower: (0, helpers_1.isSet)(object.totalVotingPower) ? helpers_1.Long.fromValue(object.totalVotingPower) : helpers_1.Long.ZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.validators) {
            obj.validators = message.validators.map((e) => (e ? exports.Validator.toJSON(e) : undefined));
        }
        else {
            obj.validators = [];
        }
        message.proposer !== undefined &&
            (obj.proposer = message.proposer ? exports.Validator.toJSON(message.proposer) : undefined);
        message.totalVotingPower !== undefined &&
            (obj.totalVotingPower = (message.totalVotingPower || helpers_1.Long.ZERO).toString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseValidatorSet();
        message.validators = object.validators?.map((e) => exports.Validator.fromPartial(e)) || [];
        message.proposer =
            object.proposer !== undefined && object.proposer !== null
                ? exports.Validator.fromPartial(object.proposer)
                : undefined;
        message.totalVotingPower =
            object.totalVotingPower !== undefined && object.totalVotingPower !== null
                ? helpers_1.Long.fromValue(object.totalVotingPower)
                : helpers_1.Long.ZERO;
        return message;
    },
};
function createBaseValidator() {
    return {
        address: new Uint8Array(),
        pubKey: undefined,
        votingPower: helpers_1.Long.ZERO,
        proposerPriority: helpers_1.Long.ZERO,
    };
}
exports.Validator = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.address.length !== 0) {
            writer.uint32(10).bytes(message.address);
        }
        if (message.pubKey !== undefined) {
            keys_1.PublicKey.encode(message.pubKey, writer.uint32(18).fork()).ldelim();
        }
        if (!message.votingPower.isZero()) {
            writer.uint32(24).int64(message.votingPower);
        }
        if (!message.proposerPriority.isZero()) {
            writer.uint32(32).int64(message.proposerPriority);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseValidator();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.address = reader.bytes();
                    break;
                case 2:
                    message.pubKey = keys_1.PublicKey.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.votingPower = reader.int64();
                    break;
                case 4:
                    message.proposerPriority = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            address: (0, helpers_1.isSet)(object.address) ? (0, helpers_1.bytesFromBase64)(object.address) : new Uint8Array(),
            pubKey: (0, helpers_1.isSet)(object.pubKey) ? keys_1.PublicKey.fromJSON(object.pubKey) : undefined,
            votingPower: (0, helpers_1.isSet)(object.votingPower) ? helpers_1.Long.fromValue(object.votingPower) : helpers_1.Long.ZERO,
            proposerPriority: (0, helpers_1.isSet)(object.proposerPriority) ? helpers_1.Long.fromValue(object.proposerPriority) : helpers_1.Long.ZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        message.address !== undefined &&
            (obj.address = (0, helpers_1.base64FromBytes)(message.address !== undefined ? message.address : new Uint8Array()));
        message.pubKey !== undefined &&
            (obj.pubKey = message.pubKey ? keys_1.PublicKey.toJSON(message.pubKey) : undefined);
        message.votingPower !== undefined && (obj.votingPower = (message.votingPower || helpers_1.Long.ZERO).toString());
        message.proposerPriority !== undefined &&
            (obj.proposerPriority = (message.proposerPriority || helpers_1.Long.ZERO).toString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseValidator();
        message.address = object.address ?? new Uint8Array();
        message.pubKey =
            object.pubKey !== undefined && object.pubKey !== null
                ? keys_1.PublicKey.fromPartial(object.pubKey)
                : undefined;
        message.votingPower =
            object.votingPower !== undefined && object.votingPower !== null
                ? helpers_1.Long.fromValue(object.votingPower)
                : helpers_1.Long.ZERO;
        message.proposerPriority =
            object.proposerPriority !== undefined && object.proposerPriority !== null
                ? helpers_1.Long.fromValue(object.proposerPriority)
                : helpers_1.Long.ZERO;
        return message;
    },
};
function createBaseSimpleValidator() {
    return {
        pubKey: undefined,
        votingPower: helpers_1.Long.ZERO,
    };
}
exports.SimpleValidator = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.pubKey !== undefined) {
            keys_1.PublicKey.encode(message.pubKey, writer.uint32(10).fork()).ldelim();
        }
        if (!message.votingPower.isZero()) {
            writer.uint32(16).int64(message.votingPower);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSimpleValidator();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.pubKey = keys_1.PublicKey.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.votingPower = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            pubKey: (0, helpers_1.isSet)(object.pubKey) ? keys_1.PublicKey.fromJSON(object.pubKey) : undefined,
            votingPower: (0, helpers_1.isSet)(object.votingPower) ? helpers_1.Long.fromValue(object.votingPower) : helpers_1.Long.ZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        message.pubKey !== undefined &&
            (obj.pubKey = message.pubKey ? keys_1.PublicKey.toJSON(message.pubKey) : undefined);
        message.votingPower !== undefined && (obj.votingPower = (message.votingPower || helpers_1.Long.ZERO).toString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseSimpleValidator();
        message.pubKey =
            object.pubKey !== undefined && object.pubKey !== null
                ? keys_1.PublicKey.fromPartial(object.pubKey)
                : undefined;
        message.votingPower =
            object.votingPower !== undefined && object.votingPower !== null
                ? helpers_1.Long.fromValue(object.votingPower)
                : helpers_1.Long.ZERO;
        return message;
    },
};
//# sourceMappingURL=validator.js.map

/***/ }),

/***/ 95564:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Consensus = exports.App = exports.protobufPackage = void 0;
/* eslint-disable */
const helpers_1 = __webpack_require__(92654);
const _m0 = __importStar(__webpack_require__(62100));
exports.protobufPackage = "tendermint.version";
function createBaseApp() {
    return {
        protocol: helpers_1.Long.UZERO,
        software: "",
    };
}
exports.App = {
    encode(message, writer = _m0.Writer.create()) {
        if (!message.protocol.isZero()) {
            writer.uint32(8).uint64(message.protocol);
        }
        if (message.software !== "") {
            writer.uint32(18).string(message.software);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseApp();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.protocol = reader.uint64();
                    break;
                case 2:
                    message.software = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            protocol: (0, helpers_1.isSet)(object.protocol) ? helpers_1.Long.fromValue(object.protocol) : helpers_1.Long.UZERO,
            software: (0, helpers_1.isSet)(object.software) ? String(object.software) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.protocol !== undefined && (obj.protocol = (message.protocol || helpers_1.Long.UZERO).toString());
        message.software !== undefined && (obj.software = message.software);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseApp();
        message.protocol =
            object.protocol !== undefined && object.protocol !== null
                ? helpers_1.Long.fromValue(object.protocol)
                : helpers_1.Long.UZERO;
        message.software = object.software ?? "";
        return message;
    },
};
function createBaseConsensus() {
    return {
        block: helpers_1.Long.UZERO,
        app: helpers_1.Long.UZERO,
    };
}
exports.Consensus = {
    encode(message, writer = _m0.Writer.create()) {
        if (!message.block.isZero()) {
            writer.uint32(8).uint64(message.block);
        }
        if (!message.app.isZero()) {
            writer.uint32(16).uint64(message.app);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseConsensus();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.block = reader.uint64();
                    break;
                case 2:
                    message.app = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            block: (0, helpers_1.isSet)(object.block) ? helpers_1.Long.fromValue(object.block) : helpers_1.Long.UZERO,
            app: (0, helpers_1.isSet)(object.app) ? helpers_1.Long.fromValue(object.app) : helpers_1.Long.UZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        message.block !== undefined && (obj.block = (message.block || helpers_1.Long.UZERO).toString());
        message.app !== undefined && (obj.app = (message.app || helpers_1.Long.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseConsensus();
        message.block =
            object.block !== undefined && object.block !== null ? helpers_1.Long.fromValue(object.block) : helpers_1.Long.UZERO;
        message.app = object.app !== undefined && object.app !== null ? helpers_1.Long.fromValue(object.app) : helpers_1.Long.UZERO;
        return message;
    },
};
//# sourceMappingURL=types.js.map

/***/ }),

/***/ 10648:
/***/ (function(module) {

module.exports = Long;

/**
 * wasm optimizations, to do native i64 multiplication and divide
 */
var wasm = null;

try {
  wasm = new WebAssembly.Instance(new WebAssembly.Module(new Uint8Array([
    0, 97, 115, 109, 1, 0, 0, 0, 1, 13, 2, 96, 0, 1, 127, 96, 4, 127, 127, 127, 127, 1, 127, 3, 7, 6, 0, 1, 1, 1, 1, 1, 6, 6, 1, 127, 1, 65, 0, 11, 7, 50, 6, 3, 109, 117, 108, 0, 1, 5, 100, 105, 118, 95, 115, 0, 2, 5, 100, 105, 118, 95, 117, 0, 3, 5, 114, 101, 109, 95, 115, 0, 4, 5, 114, 101, 109, 95, 117, 0, 5, 8, 103, 101, 116, 95, 104, 105, 103, 104, 0, 0, 10, 191, 1, 6, 4, 0, 35, 0, 11, 36, 1, 1, 126, 32, 0, 173, 32, 1, 173, 66, 32, 134, 132, 32, 2, 173, 32, 3, 173, 66, 32, 134, 132, 126, 34, 4, 66, 32, 135, 167, 36, 0, 32, 4, 167, 11, 36, 1, 1, 126, 32, 0, 173, 32, 1, 173, 66, 32, 134, 132, 32, 2, 173, 32, 3, 173, 66, 32, 134, 132, 127, 34, 4, 66, 32, 135, 167, 36, 0, 32, 4, 167, 11, 36, 1, 1, 126, 32, 0, 173, 32, 1, 173, 66, 32, 134, 132, 32, 2, 173, 32, 3, 173, 66, 32, 134, 132, 128, 34, 4, 66, 32, 135, 167, 36, 0, 32, 4, 167, 11, 36, 1, 1, 126, 32, 0, 173, 32, 1, 173, 66, 32, 134, 132, 32, 2, 173, 32, 3, 173, 66, 32, 134, 132, 129, 34, 4, 66, 32, 135, 167, 36, 0, 32, 4, 167, 11, 36, 1, 1, 126, 32, 0, 173, 32, 1, 173, 66, 32, 134, 132, 32, 2, 173, 32, 3, 173, 66, 32, 134, 132, 130, 34, 4, 66, 32, 135, 167, 36, 0, 32, 4, 167, 11
  ])), {}).exports;
} catch (e) {
  // no wasm support :(
}

/**
 * Constructs a 64 bit two's-complement integer, given its low and high 32 bit values as *signed* integers.
 *  See the from* functions below for more convenient ways of constructing Longs.
 * @exports Long
 * @class A Long class for representing a 64 bit two's-complement integer value.
 * @param {number} low The low (signed) 32 bits of the long
 * @param {number} high The high (signed) 32 bits of the long
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @constructor
 */
function Long(low, high, unsigned) {

    /**
     * The low 32 bits as a signed value.
     * @type {number}
     */
    this.low = low | 0;

    /**
     * The high 32 bits as a signed value.
     * @type {number}
     */
    this.high = high | 0;

    /**
     * Whether unsigned or not.
     * @type {boolean}
     */
    this.unsigned = !!unsigned;
}

// The internal representation of a long is the two given signed, 32-bit values.
// We use 32-bit pieces because these are the size of integers on which
// Javascript performs bit-operations.  For operations like addition and
// multiplication, we split each number into 16 bit pieces, which can easily be
// multiplied within Javascript's floating-point representation without overflow
// or change in sign.
//
// In the algorithms below, we frequently reduce the negative case to the
// positive case by negating the input(s) and then post-processing the result.
// Note that we must ALWAYS check specially whether those values are MIN_VALUE
// (-2^63) because -MIN_VALUE == MIN_VALUE (since 2^63 cannot be represented as
// a positive number, it overflows back into a negative).  Not handling this
// case would often result in infinite recursion.
//
// Common constant values ZERO, ONE, NEG_ONE, etc. are defined below the from*
// methods on which they depend.

/**
 * An indicator used to reliably determine if an object is a Long or not.
 * @type {boolean}
 * @const
 * @private
 */
Long.prototype.__isLong__;

Object.defineProperty(Long.prototype, "__isLong__", { value: true });

/**
 * @function
 * @param {*} obj Object
 * @returns {boolean}
 * @inner
 */
function isLong(obj) {
    return (obj && obj["__isLong__"]) === true;
}

/**
 * Tests if the specified object is a Long.
 * @function
 * @param {*} obj Object
 * @returns {boolean}
 */
Long.isLong = isLong;

/**
 * A cache of the Long representations of small integer values.
 * @type {!Object}
 * @inner
 */
var INT_CACHE = {};

/**
 * A cache of the Long representations of small unsigned integer values.
 * @type {!Object}
 * @inner
 */
var UINT_CACHE = {};

/**
 * @param {number} value
 * @param {boolean=} unsigned
 * @returns {!Long}
 * @inner
 */
function fromInt(value, unsigned) {
    var obj, cachedObj, cache;
    if (unsigned) {
        value >>>= 0;
        if (cache = (0 <= value && value < 256)) {
            cachedObj = UINT_CACHE[value];
            if (cachedObj)
                return cachedObj;
        }
        obj = fromBits(value, (value | 0) < 0 ? -1 : 0, true);
        if (cache)
            UINT_CACHE[value] = obj;
        return obj;
    } else {
        value |= 0;
        if (cache = (-128 <= value && value < 128)) {
            cachedObj = INT_CACHE[value];
            if (cachedObj)
                return cachedObj;
        }
        obj = fromBits(value, value < 0 ? -1 : 0, false);
        if (cache)
            INT_CACHE[value] = obj;
        return obj;
    }
}

/**
 * Returns a Long representing the given 32 bit integer value.
 * @function
 * @param {number} value The 32 bit integer in question
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {!Long} The corresponding Long value
 */
Long.fromInt = fromInt;

/**
 * @param {number} value
 * @param {boolean=} unsigned
 * @returns {!Long}
 * @inner
 */
function fromNumber(value, unsigned) {
    if (isNaN(value))
        return unsigned ? UZERO : ZERO;
    if (unsigned) {
        if (value < 0)
            return UZERO;
        if (value >= TWO_PWR_64_DBL)
            return MAX_UNSIGNED_VALUE;
    } else {
        if (value <= -TWO_PWR_63_DBL)
            return MIN_VALUE;
        if (value + 1 >= TWO_PWR_63_DBL)
            return MAX_VALUE;
    }
    if (value < 0)
        return fromNumber(-value, unsigned).neg();
    return fromBits((value % TWO_PWR_32_DBL) | 0, (value / TWO_PWR_32_DBL) | 0, unsigned);
}

/**
 * Returns a Long representing the given value, provided that it is a finite number. Otherwise, zero is returned.
 * @function
 * @param {number} value The number in question
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {!Long} The corresponding Long value
 */
Long.fromNumber = fromNumber;

/**
 * @param {number} lowBits
 * @param {number} highBits
 * @param {boolean=} unsigned
 * @returns {!Long}
 * @inner
 */
function fromBits(lowBits, highBits, unsigned) {
    return new Long(lowBits, highBits, unsigned);
}

/**
 * Returns a Long representing the 64 bit integer that comes by concatenating the given low and high bits. Each is
 *  assumed to use 32 bits.
 * @function
 * @param {number} lowBits The low 32 bits
 * @param {number} highBits The high 32 bits
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {!Long} The corresponding Long value
 */
Long.fromBits = fromBits;

/**
 * @function
 * @param {number} base
 * @param {number} exponent
 * @returns {number}
 * @inner
 */
var pow_dbl = Math.pow; // Used 4 times (4*8 to 15+4)

/**
 * @param {string} str
 * @param {(boolean|number)=} unsigned
 * @param {number=} radix
 * @returns {!Long}
 * @inner
 */
function fromString(str, unsigned, radix) {
    if (str.length === 0)
        throw Error('empty string');
    if (str === "NaN" || str === "Infinity" || str === "+Infinity" || str === "-Infinity")
        return ZERO;
    if (typeof unsigned === 'number') {
        // For goog.math.long compatibility
        radix = unsigned,
        unsigned = false;
    } else {
        unsigned = !! unsigned;
    }
    radix = radix || 10;
    if (radix < 2 || 36 < radix)
        throw RangeError('radix');

    var p;
    if ((p = str.indexOf('-')) > 0)
        throw Error('interior hyphen');
    else if (p === 0) {
        return fromString(str.substring(1), unsigned, radix).neg();
    }

    // Do several (8) digits each time through the loop, so as to
    // minimize the calls to the very expensive emulated div.
    var radixToPower = fromNumber(pow_dbl(radix, 8));

    var result = ZERO;
    for (var i = 0; i < str.length; i += 8) {
        var size = Math.min(8, str.length - i),
            value = parseInt(str.substring(i, i + size), radix);
        if (size < 8) {
            var power = fromNumber(pow_dbl(radix, size));
            result = result.mul(power).add(fromNumber(value));
        } else {
            result = result.mul(radixToPower);
            result = result.add(fromNumber(value));
        }
    }
    result.unsigned = unsigned;
    return result;
}

/**
 * Returns a Long representation of the given string, written using the specified radix.
 * @function
 * @param {string} str The textual representation of the Long
 * @param {(boolean|number)=} unsigned Whether unsigned or not, defaults to signed
 * @param {number=} radix The radix in which the text is written (2-36), defaults to 10
 * @returns {!Long} The corresponding Long value
 */
Long.fromString = fromString;

/**
 * @function
 * @param {!Long|number|string|!{low: number, high: number, unsigned: boolean}} val
 * @param {boolean=} unsigned
 * @returns {!Long}
 * @inner
 */
function fromValue(val, unsigned) {
    if (typeof val === 'number')
        return fromNumber(val, unsigned);
    if (typeof val === 'string')
        return fromString(val, unsigned);
    // Throws for non-objects, converts non-instanceof Long:
    return fromBits(val.low, val.high, typeof unsigned === 'boolean' ? unsigned : val.unsigned);
}

/**
 * Converts the specified value to a Long using the appropriate from* function for its type.
 * @function
 * @param {!Long|number|string|!{low: number, high: number, unsigned: boolean}} val Value
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {!Long}
 */
Long.fromValue = fromValue;

// NOTE: the compiler should inline these constant values below and then remove these variables, so there should be
// no runtime penalty for these.

/**
 * @type {number}
 * @const
 * @inner
 */
var TWO_PWR_16_DBL = 1 << 16;

/**
 * @type {number}
 * @const
 * @inner
 */
var TWO_PWR_24_DBL = 1 << 24;

/**
 * @type {number}
 * @const
 * @inner
 */
var TWO_PWR_32_DBL = TWO_PWR_16_DBL * TWO_PWR_16_DBL;

/**
 * @type {number}
 * @const
 * @inner
 */
var TWO_PWR_64_DBL = TWO_PWR_32_DBL * TWO_PWR_32_DBL;

/**
 * @type {number}
 * @const
 * @inner
 */
var TWO_PWR_63_DBL = TWO_PWR_64_DBL / 2;

/**
 * @type {!Long}
 * @const
 * @inner
 */
var TWO_PWR_24 = fromInt(TWO_PWR_24_DBL);

/**
 * @type {!Long}
 * @inner
 */
var ZERO = fromInt(0);

/**
 * Signed zero.
 * @type {!Long}
 */
Long.ZERO = ZERO;

/**
 * @type {!Long}
 * @inner
 */
var UZERO = fromInt(0, true);

/**
 * Unsigned zero.
 * @type {!Long}
 */
Long.UZERO = UZERO;

/**
 * @type {!Long}
 * @inner
 */
var ONE = fromInt(1);

/**
 * Signed one.
 * @type {!Long}
 */
Long.ONE = ONE;

/**
 * @type {!Long}
 * @inner
 */
var UONE = fromInt(1, true);

/**
 * Unsigned one.
 * @type {!Long}
 */
Long.UONE = UONE;

/**
 * @type {!Long}
 * @inner
 */
var NEG_ONE = fromInt(-1);

/**
 * Signed negative one.
 * @type {!Long}
 */
Long.NEG_ONE = NEG_ONE;

/**
 * @type {!Long}
 * @inner
 */
var MAX_VALUE = fromBits(0xFFFFFFFF|0, 0x7FFFFFFF|0, false);

/**
 * Maximum signed value.
 * @type {!Long}
 */
Long.MAX_VALUE = MAX_VALUE;

/**
 * @type {!Long}
 * @inner
 */
var MAX_UNSIGNED_VALUE = fromBits(0xFFFFFFFF|0, 0xFFFFFFFF|0, true);

/**
 * Maximum unsigned value.
 * @type {!Long}
 */
Long.MAX_UNSIGNED_VALUE = MAX_UNSIGNED_VALUE;

/**
 * @type {!Long}
 * @inner
 */
var MIN_VALUE = fromBits(0, 0x80000000|0, false);

/**
 * Minimum signed value.
 * @type {!Long}
 */
Long.MIN_VALUE = MIN_VALUE;

/**
 * @alias Long.prototype
 * @inner
 */
var LongPrototype = Long.prototype;

/**
 * Converts the Long to a 32 bit integer, assuming it is a 32 bit integer.
 * @returns {number}
 */
LongPrototype.toInt = function toInt() {
    return this.unsigned ? this.low >>> 0 : this.low;
};

/**
 * Converts the Long to a the nearest floating-point representation of this value (double, 53 bit mantissa).
 * @returns {number}
 */
LongPrototype.toNumber = function toNumber() {
    if (this.unsigned)
        return ((this.high >>> 0) * TWO_PWR_32_DBL) + (this.low >>> 0);
    return this.high * TWO_PWR_32_DBL + (this.low >>> 0);
};

/**
 * Converts the Long to a string written in the specified radix.
 * @param {number=} radix Radix (2-36), defaults to 10
 * @returns {string}
 * @override
 * @throws {RangeError} If `radix` is out of range
 */
LongPrototype.toString = function toString(radix) {
    radix = radix || 10;
    if (radix < 2 || 36 < radix)
        throw RangeError('radix');
    if (this.isZero())
        return '0';
    if (this.isNegative()) { // Unsigned Longs are never negative
        if (this.eq(MIN_VALUE)) {
            // We need to change the Long value before it can be negated, so we remove
            // the bottom-most digit in this base and then recurse to do the rest.
            var radixLong = fromNumber(radix),
                div = this.div(radixLong),
                rem1 = div.mul(radixLong).sub(this);
            return div.toString(radix) + rem1.toInt().toString(radix);
        } else
            return '-' + this.neg().toString(radix);
    }

    // Do several (6) digits each time through the loop, so as to
    // minimize the calls to the very expensive emulated div.
    var radixToPower = fromNumber(pow_dbl(radix, 6), this.unsigned),
        rem = this;
    var result = '';
    while (true) {
        var remDiv = rem.div(radixToPower),
            intval = rem.sub(remDiv.mul(radixToPower)).toInt() >>> 0,
            digits = intval.toString(radix);
        rem = remDiv;
        if (rem.isZero())
            return digits + result;
        else {
            while (digits.length < 6)
                digits = '0' + digits;
            result = '' + digits + result;
        }
    }
};

/**
 * Gets the high 32 bits as a signed integer.
 * @returns {number} Signed high bits
 */
LongPrototype.getHighBits = function getHighBits() {
    return this.high;
};

/**
 * Gets the high 32 bits as an unsigned integer.
 * @returns {number} Unsigned high bits
 */
LongPrototype.getHighBitsUnsigned = function getHighBitsUnsigned() {
    return this.high >>> 0;
};

/**
 * Gets the low 32 bits as a signed integer.
 * @returns {number} Signed low bits
 */
LongPrototype.getLowBits = function getLowBits() {
    return this.low;
};

/**
 * Gets the low 32 bits as an unsigned integer.
 * @returns {number} Unsigned low bits
 */
LongPrototype.getLowBitsUnsigned = function getLowBitsUnsigned() {
    return this.low >>> 0;
};

/**
 * Gets the number of bits needed to represent the absolute value of this Long.
 * @returns {number}
 */
LongPrototype.getNumBitsAbs = function getNumBitsAbs() {
    if (this.isNegative()) // Unsigned Longs are never negative
        return this.eq(MIN_VALUE) ? 64 : this.neg().getNumBitsAbs();
    var val = this.high != 0 ? this.high : this.low;
    for (var bit = 31; bit > 0; bit--)
        if ((val & (1 << bit)) != 0)
            break;
    return this.high != 0 ? bit + 33 : bit + 1;
};

/**
 * Tests if this Long's value equals zero.
 * @returns {boolean}
 */
LongPrototype.isZero = function isZero() {
    return this.high === 0 && this.low === 0;
};

/**
 * Tests if this Long's value equals zero. This is an alias of {@link Long#isZero}.
 * @returns {boolean}
 */
LongPrototype.eqz = LongPrototype.isZero;

/**
 * Tests if this Long's value is negative.
 * @returns {boolean}
 */
LongPrototype.isNegative = function isNegative() {
    return !this.unsigned && this.high < 0;
};

/**
 * Tests if this Long's value is positive.
 * @returns {boolean}
 */
LongPrototype.isPositive = function isPositive() {
    return this.unsigned || this.high >= 0;
};

/**
 * Tests if this Long's value is odd.
 * @returns {boolean}
 */
LongPrototype.isOdd = function isOdd() {
    return (this.low & 1) === 1;
};

/**
 * Tests if this Long's value is even.
 * @returns {boolean}
 */
LongPrototype.isEven = function isEven() {
    return (this.low & 1) === 0;
};

/**
 * Tests if this Long's value equals the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */
LongPrototype.equals = function equals(other) {
    if (!isLong(other))
        other = fromValue(other);
    if (this.unsigned !== other.unsigned && (this.high >>> 31) === 1 && (other.high >>> 31) === 1)
        return false;
    return this.high === other.high && this.low === other.low;
};

/**
 * Tests if this Long's value equals the specified's. This is an alias of {@link Long#equals}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */
LongPrototype.eq = LongPrototype.equals;

/**
 * Tests if this Long's value differs from the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */
LongPrototype.notEquals = function notEquals(other) {
    return !this.eq(/* validates */ other);
};

/**
 * Tests if this Long's value differs from the specified's. This is an alias of {@link Long#notEquals}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */
LongPrototype.neq = LongPrototype.notEquals;

/**
 * Tests if this Long's value differs from the specified's. This is an alias of {@link Long#notEquals}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */
LongPrototype.ne = LongPrototype.notEquals;

/**
 * Tests if this Long's value is less than the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */
LongPrototype.lessThan = function lessThan(other) {
    return this.comp(/* validates */ other) < 0;
};

/**
 * Tests if this Long's value is less than the specified's. This is an alias of {@link Long#lessThan}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */
LongPrototype.lt = LongPrototype.lessThan;

/**
 * Tests if this Long's value is less than or equal the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */
LongPrototype.lessThanOrEqual = function lessThanOrEqual(other) {
    return this.comp(/* validates */ other) <= 0;
};

/**
 * Tests if this Long's value is less than or equal the specified's. This is an alias of {@link Long#lessThanOrEqual}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */
LongPrototype.lte = LongPrototype.lessThanOrEqual;

/**
 * Tests if this Long's value is less than or equal the specified's. This is an alias of {@link Long#lessThanOrEqual}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */
LongPrototype.le = LongPrototype.lessThanOrEqual;

/**
 * Tests if this Long's value is greater than the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */
LongPrototype.greaterThan = function greaterThan(other) {
    return this.comp(/* validates */ other) > 0;
};

/**
 * Tests if this Long's value is greater than the specified's. This is an alias of {@link Long#greaterThan}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */
LongPrototype.gt = LongPrototype.greaterThan;

/**
 * Tests if this Long's value is greater than or equal the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */
LongPrototype.greaterThanOrEqual = function greaterThanOrEqual(other) {
    return this.comp(/* validates */ other) >= 0;
};

/**
 * Tests if this Long's value is greater than or equal the specified's. This is an alias of {@link Long#greaterThanOrEqual}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */
LongPrototype.gte = LongPrototype.greaterThanOrEqual;

/**
 * Tests if this Long's value is greater than or equal the specified's. This is an alias of {@link Long#greaterThanOrEqual}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */
LongPrototype.ge = LongPrototype.greaterThanOrEqual;

/**
 * Compares this Long's value with the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {number} 0 if they are the same, 1 if the this is greater and -1
 *  if the given one is greater
 */
LongPrototype.compare = function compare(other) {
    if (!isLong(other))
        other = fromValue(other);
    if (this.eq(other))
        return 0;
    var thisNeg = this.isNegative(),
        otherNeg = other.isNegative();
    if (thisNeg && !otherNeg)
        return -1;
    if (!thisNeg && otherNeg)
        return 1;
    // At this point the sign bits are the same
    if (!this.unsigned)
        return this.sub(other).isNegative() ? -1 : 1;
    // Both are positive if at least one is unsigned
    return (other.high >>> 0) > (this.high >>> 0) || (other.high === this.high && (other.low >>> 0) > (this.low >>> 0)) ? -1 : 1;
};

/**
 * Compares this Long's value with the specified's. This is an alias of {@link Long#compare}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {number} 0 if they are the same, 1 if the this is greater and -1
 *  if the given one is greater
 */
LongPrototype.comp = LongPrototype.compare;

/**
 * Negates this Long's value.
 * @returns {!Long} Negated Long
 */
LongPrototype.negate = function negate() {
    if (!this.unsigned && this.eq(MIN_VALUE))
        return MIN_VALUE;
    return this.not().add(ONE);
};

/**
 * Negates this Long's value. This is an alias of {@link Long#negate}.
 * @function
 * @returns {!Long} Negated Long
 */
LongPrototype.neg = LongPrototype.negate;

/**
 * Returns the sum of this and the specified Long.
 * @param {!Long|number|string} addend Addend
 * @returns {!Long} Sum
 */
LongPrototype.add = function add(addend) {
    if (!isLong(addend))
        addend = fromValue(addend);

    // Divide each number into 4 chunks of 16 bits, and then sum the chunks.

    var a48 = this.high >>> 16;
    var a32 = this.high & 0xFFFF;
    var a16 = this.low >>> 16;
    var a00 = this.low & 0xFFFF;

    var b48 = addend.high >>> 16;
    var b32 = addend.high & 0xFFFF;
    var b16 = addend.low >>> 16;
    var b00 = addend.low & 0xFFFF;

    var c48 = 0, c32 = 0, c16 = 0, c00 = 0;
    c00 += a00 + b00;
    c16 += c00 >>> 16;
    c00 &= 0xFFFF;
    c16 += a16 + b16;
    c32 += c16 >>> 16;
    c16 &= 0xFFFF;
    c32 += a32 + b32;
    c48 += c32 >>> 16;
    c32 &= 0xFFFF;
    c48 += a48 + b48;
    c48 &= 0xFFFF;
    return fromBits((c16 << 16) | c00, (c48 << 16) | c32, this.unsigned);
};

/**
 * Returns the difference of this and the specified Long.
 * @param {!Long|number|string} subtrahend Subtrahend
 * @returns {!Long} Difference
 */
LongPrototype.subtract = function subtract(subtrahend) {
    if (!isLong(subtrahend))
        subtrahend = fromValue(subtrahend);
    return this.add(subtrahend.neg());
};

/**
 * Returns the difference of this and the specified Long. This is an alias of {@link Long#subtract}.
 * @function
 * @param {!Long|number|string} subtrahend Subtrahend
 * @returns {!Long} Difference
 */
LongPrototype.sub = LongPrototype.subtract;

/**
 * Returns the product of this and the specified Long.
 * @param {!Long|number|string} multiplier Multiplier
 * @returns {!Long} Product
 */
LongPrototype.multiply = function multiply(multiplier) {
    if (this.isZero())
        return ZERO;
    if (!isLong(multiplier))
        multiplier = fromValue(multiplier);

    // use wasm support if present
    if (wasm) {
        var low = wasm.mul(this.low,
                           this.high,
                           multiplier.low,
                           multiplier.high);
        return fromBits(low, wasm.get_high(), this.unsigned);
    }

    if (multiplier.isZero())
        return ZERO;
    if (this.eq(MIN_VALUE))
        return multiplier.isOdd() ? MIN_VALUE : ZERO;
    if (multiplier.eq(MIN_VALUE))
        return this.isOdd() ? MIN_VALUE : ZERO;

    if (this.isNegative()) {
        if (multiplier.isNegative())
            return this.neg().mul(multiplier.neg());
        else
            return this.neg().mul(multiplier).neg();
    } else if (multiplier.isNegative())
        return this.mul(multiplier.neg()).neg();

    // If both longs are small, use float multiplication
    if (this.lt(TWO_PWR_24) && multiplier.lt(TWO_PWR_24))
        return fromNumber(this.toNumber() * multiplier.toNumber(), this.unsigned);

    // Divide each long into 4 chunks of 16 bits, and then add up 4x4 products.
    // We can skip products that would overflow.

    var a48 = this.high >>> 16;
    var a32 = this.high & 0xFFFF;
    var a16 = this.low >>> 16;
    var a00 = this.low & 0xFFFF;

    var b48 = multiplier.high >>> 16;
    var b32 = multiplier.high & 0xFFFF;
    var b16 = multiplier.low >>> 16;
    var b00 = multiplier.low & 0xFFFF;

    var c48 = 0, c32 = 0, c16 = 0, c00 = 0;
    c00 += a00 * b00;
    c16 += c00 >>> 16;
    c00 &= 0xFFFF;
    c16 += a16 * b00;
    c32 += c16 >>> 16;
    c16 &= 0xFFFF;
    c16 += a00 * b16;
    c32 += c16 >>> 16;
    c16 &= 0xFFFF;
    c32 += a32 * b00;
    c48 += c32 >>> 16;
    c32 &= 0xFFFF;
    c32 += a16 * b16;
    c48 += c32 >>> 16;
    c32 &= 0xFFFF;
    c32 += a00 * b32;
    c48 += c32 >>> 16;
    c32 &= 0xFFFF;
    c48 += a48 * b00 + a32 * b16 + a16 * b32 + a00 * b48;
    c48 &= 0xFFFF;
    return fromBits((c16 << 16) | c00, (c48 << 16) | c32, this.unsigned);
};

/**
 * Returns the product of this and the specified Long. This is an alias of {@link Long#multiply}.
 * @function
 * @param {!Long|number|string} multiplier Multiplier
 * @returns {!Long} Product
 */
LongPrototype.mul = LongPrototype.multiply;

/**
 * Returns this Long divided by the specified. The result is signed if this Long is signed or
 *  unsigned if this Long is unsigned.
 * @param {!Long|number|string} divisor Divisor
 * @returns {!Long} Quotient
 */
LongPrototype.divide = function divide(divisor) {
    if (!isLong(divisor))
        divisor = fromValue(divisor);
    if (divisor.isZero())
        throw Error('division by zero');

    // use wasm support if present
    if (wasm) {
        // guard against signed division overflow: the largest
        // negative number / -1 would be 1 larger than the largest
        // positive number, due to two's complement.
        if (!this.unsigned &&
            this.high === -0x80000000 &&
            divisor.low === -1 && divisor.high === -1) {
            // be consistent with non-wasm code path
            return this;
        }
        var low = (this.unsigned ? wasm.div_u : wasm.div_s)(
            this.low,
            this.high,
            divisor.low,
            divisor.high
        );
        return fromBits(low, wasm.get_high(), this.unsigned);
    }

    if (this.isZero())
        return this.unsigned ? UZERO : ZERO;
    var approx, rem, res;
    if (!this.unsigned) {
        // This section is only relevant for signed longs and is derived from the
        // closure library as a whole.
        if (this.eq(MIN_VALUE)) {
            if (divisor.eq(ONE) || divisor.eq(NEG_ONE))
                return MIN_VALUE;  // recall that -MIN_VALUE == MIN_VALUE
            else if (divisor.eq(MIN_VALUE))
                return ONE;
            else {
                // At this point, we have |other| >= 2, so |this/other| < |MIN_VALUE|.
                var halfThis = this.shr(1);
                approx = halfThis.div(divisor).shl(1);
                if (approx.eq(ZERO)) {
                    return divisor.isNegative() ? ONE : NEG_ONE;
                } else {
                    rem = this.sub(divisor.mul(approx));
                    res = approx.add(rem.div(divisor));
                    return res;
                }
            }
        } else if (divisor.eq(MIN_VALUE))
            return this.unsigned ? UZERO : ZERO;
        if (this.isNegative()) {
            if (divisor.isNegative())
                return this.neg().div(divisor.neg());
            return this.neg().div(divisor).neg();
        } else if (divisor.isNegative())
            return this.div(divisor.neg()).neg();
        res = ZERO;
    } else {
        // The algorithm below has not been made for unsigned longs. It's therefore
        // required to take special care of the MSB prior to running it.
        if (!divisor.unsigned)
            divisor = divisor.toUnsigned();
        if (divisor.gt(this))
            return UZERO;
        if (divisor.gt(this.shru(1))) // 15 >>> 1 = 7 ; with divisor = 8 ; true
            return UONE;
        res = UZERO;
    }

    // Repeat the following until the remainder is less than other:  find a
    // floating-point that approximates remainder / other *from below*, add this
    // into the result, and subtract it from the remainder.  It is critical that
    // the approximate value is less than or equal to the real value so that the
    // remainder never becomes negative.
    rem = this;
    while (rem.gte(divisor)) {
        // Approximate the result of division. This may be a little greater or
        // smaller than the actual value.
        approx = Math.max(1, Math.floor(rem.toNumber() / divisor.toNumber()));

        // We will tweak the approximate result by changing it in the 48-th digit or
        // the smallest non-fractional digit, whichever is larger.
        var log2 = Math.ceil(Math.log(approx) / Math.LN2),
            delta = (log2 <= 48) ? 1 : pow_dbl(2, log2 - 48),

        // Decrease the approximation until it is smaller than the remainder.  Note
        // that if it is too large, the product overflows and is negative.
            approxRes = fromNumber(approx),
            approxRem = approxRes.mul(divisor);
        while (approxRem.isNegative() || approxRem.gt(rem)) {
            approx -= delta;
            approxRes = fromNumber(approx, this.unsigned);
            approxRem = approxRes.mul(divisor);
        }

        // We know the answer can't be zero... and actually, zero would cause
        // infinite recursion since we would make no progress.
        if (approxRes.isZero())
            approxRes = ONE;

        res = res.add(approxRes);
        rem = rem.sub(approxRem);
    }
    return res;
};

/**
 * Returns this Long divided by the specified. This is an alias of {@link Long#divide}.
 * @function
 * @param {!Long|number|string} divisor Divisor
 * @returns {!Long} Quotient
 */
LongPrototype.div = LongPrototype.divide;

/**
 * Returns this Long modulo the specified.
 * @param {!Long|number|string} divisor Divisor
 * @returns {!Long} Remainder
 */
LongPrototype.modulo = function modulo(divisor) {
    if (!isLong(divisor))
        divisor = fromValue(divisor);

    // use wasm support if present
    if (wasm) {
        var low = (this.unsigned ? wasm.rem_u : wasm.rem_s)(
            this.low,
            this.high,
            divisor.low,
            divisor.high
        );
        return fromBits(low, wasm.get_high(), this.unsigned);
    }

    return this.sub(this.div(divisor).mul(divisor));
};

/**
 * Returns this Long modulo the specified. This is an alias of {@link Long#modulo}.
 * @function
 * @param {!Long|number|string} divisor Divisor
 * @returns {!Long} Remainder
 */
LongPrototype.mod = LongPrototype.modulo;

/**
 * Returns this Long modulo the specified. This is an alias of {@link Long#modulo}.
 * @function
 * @param {!Long|number|string} divisor Divisor
 * @returns {!Long} Remainder
 */
LongPrototype.rem = LongPrototype.modulo;

/**
 * Returns the bitwise NOT of this Long.
 * @returns {!Long}
 */
LongPrototype.not = function not() {
    return fromBits(~this.low, ~this.high, this.unsigned);
};

/**
 * Returns the bitwise AND of this Long and the specified.
 * @param {!Long|number|string} other Other Long
 * @returns {!Long}
 */
LongPrototype.and = function and(other) {
    if (!isLong(other))
        other = fromValue(other);
    return fromBits(this.low & other.low, this.high & other.high, this.unsigned);
};

/**
 * Returns the bitwise OR of this Long and the specified.
 * @param {!Long|number|string} other Other Long
 * @returns {!Long}
 */
LongPrototype.or = function or(other) {
    if (!isLong(other))
        other = fromValue(other);
    return fromBits(this.low | other.low, this.high | other.high, this.unsigned);
};

/**
 * Returns the bitwise XOR of this Long and the given one.
 * @param {!Long|number|string} other Other Long
 * @returns {!Long}
 */
LongPrototype.xor = function xor(other) {
    if (!isLong(other))
        other = fromValue(other);
    return fromBits(this.low ^ other.low, this.high ^ other.high, this.unsigned);
};

/**
 * Returns this Long with bits shifted to the left by the given amount.
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */
LongPrototype.shiftLeft = function shiftLeft(numBits) {
    if (isLong(numBits))
        numBits = numBits.toInt();
    if ((numBits &= 63) === 0)
        return this;
    else if (numBits < 32)
        return fromBits(this.low << numBits, (this.high << numBits) | (this.low >>> (32 - numBits)), this.unsigned);
    else
        return fromBits(0, this.low << (numBits - 32), this.unsigned);
};

/**
 * Returns this Long with bits shifted to the left by the given amount. This is an alias of {@link Long#shiftLeft}.
 * @function
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */
LongPrototype.shl = LongPrototype.shiftLeft;

/**
 * Returns this Long with bits arithmetically shifted to the right by the given amount.
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */
LongPrototype.shiftRight = function shiftRight(numBits) {
    if (isLong(numBits))
        numBits = numBits.toInt();
    if ((numBits &= 63) === 0)
        return this;
    else if (numBits < 32)
        return fromBits((this.low >>> numBits) | (this.high << (32 - numBits)), this.high >> numBits, this.unsigned);
    else
        return fromBits(this.high >> (numBits - 32), this.high >= 0 ? 0 : -1, this.unsigned);
};

/**
 * Returns this Long with bits arithmetically shifted to the right by the given amount. This is an alias of {@link Long#shiftRight}.
 * @function
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */
LongPrototype.shr = LongPrototype.shiftRight;

/**
 * Returns this Long with bits logically shifted to the right by the given amount.
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */
LongPrototype.shiftRightUnsigned = function shiftRightUnsigned(numBits) {
    if (isLong(numBits))
        numBits = numBits.toInt();
    numBits &= 63;
    if (numBits === 0)
        return this;
    else {
        var high = this.high;
        if (numBits < 32) {
            var low = this.low;
            return fromBits((low >>> numBits) | (high << (32 - numBits)), high >>> numBits, this.unsigned);
        } else if (numBits === 32)
            return fromBits(high, 0, this.unsigned);
        else
            return fromBits(high >>> (numBits - 32), 0, this.unsigned);
    }
};

/**
 * Returns this Long with bits logically shifted to the right by the given amount. This is an alias of {@link Long#shiftRightUnsigned}.
 * @function
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */
LongPrototype.shru = LongPrototype.shiftRightUnsigned;

/**
 * Returns this Long with bits logically shifted to the right by the given amount. This is an alias of {@link Long#shiftRightUnsigned}.
 * @function
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */
LongPrototype.shr_u = LongPrototype.shiftRightUnsigned;

/**
 * Converts this Long to signed.
 * @returns {!Long} Signed long
 */
LongPrototype.toSigned = function toSigned() {
    if (!this.unsigned)
        return this;
    return fromBits(this.low, this.high, false);
};

/**
 * Converts this Long to unsigned.
 * @returns {!Long} Unsigned long
 */
LongPrototype.toUnsigned = function toUnsigned() {
    if (this.unsigned)
        return this;
    return fromBits(this.low, this.high, true);
};

/**
 * Converts this Long to its byte representation.
 * @param {boolean=} le Whether little or big endian, defaults to big endian
 * @returns {!Array.<number>} Byte representation
 */
LongPrototype.toBytes = function toBytes(le) {
    return le ? this.toBytesLE() : this.toBytesBE();
};

/**
 * Converts this Long to its little endian byte representation.
 * @returns {!Array.<number>} Little endian byte representation
 */
LongPrototype.toBytesLE = function toBytesLE() {
    var hi = this.high,
        lo = this.low;
    return [
        lo        & 0xff,
        lo >>>  8 & 0xff,
        lo >>> 16 & 0xff,
        lo >>> 24       ,
        hi        & 0xff,
        hi >>>  8 & 0xff,
        hi >>> 16 & 0xff,
        hi >>> 24
    ];
};

/**
 * Converts this Long to its big endian byte representation.
 * @returns {!Array.<number>} Big endian byte representation
 */
LongPrototype.toBytesBE = function toBytesBE() {
    var hi = this.high,
        lo = this.low;
    return [
        hi >>> 24       ,
        hi >>> 16 & 0xff,
        hi >>>  8 & 0xff,
        hi        & 0xff,
        lo >>> 24       ,
        lo >>> 16 & 0xff,
        lo >>>  8 & 0xff,
        lo        & 0xff
    ];
};

/**
 * Creates a Long from its byte representation.
 * @param {!Array.<number>} bytes Byte representation
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @param {boolean=} le Whether little or big endian, defaults to big endian
 * @returns {Long} The corresponding Long value
 */
Long.fromBytes = function fromBytes(bytes, unsigned, le) {
    return le ? Long.fromBytesLE(bytes, unsigned) : Long.fromBytesBE(bytes, unsigned);
};

/**
 * Creates a Long from its little endian byte representation.
 * @param {!Array.<number>} bytes Little endian byte representation
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {Long} The corresponding Long value
 */
Long.fromBytesLE = function fromBytesLE(bytes, unsigned) {
    return new Long(
        bytes[0]       |
        bytes[1] <<  8 |
        bytes[2] << 16 |
        bytes[3] << 24,
        bytes[4]       |
        bytes[5] <<  8 |
        bytes[6] << 16 |
        bytes[7] << 24,
        unsigned
    );
};

/**
 * Creates a Long from its big endian byte representation.
 * @param {!Array.<number>} bytes Big endian byte representation
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {Long} The corresponding Long value
 */
Long.fromBytesBE = function fromBytesBE(bytes, unsigned) {
    return new Long(
        bytes[4] << 24 |
        bytes[5] << 16 |
        bytes[6] <<  8 |
        bytes[7],
        bytes[0] << 24 |
        bytes[1] << 16 |
        bytes[2] <<  8 |
        bytes[3],
        unsigned
    );
};


/***/ }),

/***/ 6869:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!function(e){function r(e,r){"use strict";var t,a="uint8array",_=r.ready.then((function(){function a(){if(0!==t._sodium_init())throw new Error("libsodium was not correctly initialized.");for(var r=["crypto_aead_aegis128l_decrypt","crypto_aead_aegis128l_decrypt_detached","crypto_aead_aegis128l_encrypt","crypto_aead_aegis128l_encrypt_detached","crypto_aead_aegis128l_keygen","crypto_aead_aegis256_decrypt","crypto_aead_aegis256_decrypt_detached","crypto_aead_aegis256_encrypt","crypto_aead_aegis256_encrypt_detached","crypto_aead_aegis256_keygen","crypto_aead_chacha20poly1305_decrypt","crypto_aead_chacha20poly1305_decrypt_detached","crypto_aead_chacha20poly1305_encrypt","crypto_aead_chacha20poly1305_encrypt_detached","crypto_aead_chacha20poly1305_ietf_decrypt","crypto_aead_chacha20poly1305_ietf_decrypt_detached","crypto_aead_chacha20poly1305_ietf_encrypt","crypto_aead_chacha20poly1305_ietf_encrypt_detached","crypto_aead_chacha20poly1305_ietf_keygen","crypto_aead_chacha20poly1305_keygen","crypto_aead_xchacha20poly1305_ietf_decrypt","crypto_aead_xchacha20poly1305_ietf_decrypt_detached","crypto_aead_xchacha20poly1305_ietf_encrypt","crypto_aead_xchacha20poly1305_ietf_encrypt_detached","crypto_aead_xchacha20poly1305_ietf_keygen","crypto_auth","crypto_auth_hmacsha256","crypto_auth_hmacsha256_final","crypto_auth_hmacsha256_init","crypto_auth_hmacsha256_keygen","crypto_auth_hmacsha256_update","crypto_auth_hmacsha256_verify","crypto_auth_hmacsha512","crypto_auth_hmacsha512_final","crypto_auth_hmacsha512_init","crypto_auth_hmacsha512_keygen","crypto_auth_hmacsha512_update","crypto_auth_hmacsha512_verify","crypto_auth_keygen","crypto_auth_verify","crypto_box_beforenm","crypto_box_curve25519xchacha20poly1305_beforenm","crypto_box_curve25519xchacha20poly1305_detached","crypto_box_curve25519xchacha20poly1305_detached_afternm","crypto_box_curve25519xchacha20poly1305_easy","crypto_box_curve25519xchacha20poly1305_easy_afternm","crypto_box_curve25519xchacha20poly1305_keypair","crypto_box_curve25519xchacha20poly1305_open_detached","crypto_box_curve25519xchacha20poly1305_open_detached_afternm","crypto_box_curve25519xchacha20poly1305_open_easy","crypto_box_curve25519xchacha20poly1305_open_easy_afternm","crypto_box_curve25519xchacha20poly1305_seal","crypto_box_curve25519xchacha20poly1305_seal_open","crypto_box_curve25519xchacha20poly1305_seed_keypair","crypto_box_detached","crypto_box_easy","crypto_box_easy_afternm","crypto_box_keypair","crypto_box_open_detached","crypto_box_open_easy","crypto_box_open_easy_afternm","crypto_box_seal","crypto_box_seal_open","crypto_box_seed_keypair","crypto_core_ed25519_add","crypto_core_ed25519_from_hash","crypto_core_ed25519_from_uniform","crypto_core_ed25519_is_valid_point","crypto_core_ed25519_random","crypto_core_ed25519_scalar_add","crypto_core_ed25519_scalar_complement","crypto_core_ed25519_scalar_invert","crypto_core_ed25519_scalar_mul","crypto_core_ed25519_scalar_negate","crypto_core_ed25519_scalar_random","crypto_core_ed25519_scalar_reduce","crypto_core_ed25519_scalar_sub","crypto_core_ed25519_sub","crypto_core_hchacha20","crypto_core_hsalsa20","crypto_core_ristretto255_add","crypto_core_ristretto255_from_hash","crypto_core_ristretto255_is_valid_point","crypto_core_ristretto255_random","crypto_core_ristretto255_scalar_add","crypto_core_ristretto255_scalar_complement","crypto_core_ristretto255_scalar_invert","crypto_core_ristretto255_scalar_mul","crypto_core_ristretto255_scalar_negate","crypto_core_ristretto255_scalar_random","crypto_core_ristretto255_scalar_reduce","crypto_core_ristretto255_scalar_sub","crypto_core_ristretto255_sub","crypto_generichash","crypto_generichash_blake2b_salt_personal","crypto_generichash_final","crypto_generichash_init","crypto_generichash_keygen","crypto_generichash_update","crypto_hash","crypto_hash_sha256","crypto_hash_sha256_final","crypto_hash_sha256_init","crypto_hash_sha256_update","crypto_hash_sha512","crypto_hash_sha512_final","crypto_hash_sha512_init","crypto_hash_sha512_update","crypto_kdf_derive_from_key","crypto_kdf_keygen","crypto_kx_client_session_keys","crypto_kx_keypair","crypto_kx_seed_keypair","crypto_kx_server_session_keys","crypto_onetimeauth","crypto_onetimeauth_final","crypto_onetimeauth_init","crypto_onetimeauth_keygen","crypto_onetimeauth_update","crypto_onetimeauth_verify","crypto_pwhash","crypto_pwhash_scryptsalsa208sha256","crypto_pwhash_scryptsalsa208sha256_ll","crypto_pwhash_scryptsalsa208sha256_str","crypto_pwhash_scryptsalsa208sha256_str_verify","crypto_pwhash_str","crypto_pwhash_str_needs_rehash","crypto_pwhash_str_verify","crypto_scalarmult","crypto_scalarmult_base","crypto_scalarmult_ed25519","crypto_scalarmult_ed25519_base","crypto_scalarmult_ed25519_base_noclamp","crypto_scalarmult_ed25519_noclamp","crypto_scalarmult_ristretto255","crypto_scalarmult_ristretto255_base","crypto_secretbox_detached","crypto_secretbox_easy","crypto_secretbox_keygen","crypto_secretbox_open_detached","crypto_secretbox_open_easy","crypto_secretstream_xchacha20poly1305_init_pull","crypto_secretstream_xchacha20poly1305_init_push","crypto_secretstream_xchacha20poly1305_keygen","crypto_secretstream_xchacha20poly1305_pull","crypto_secretstream_xchacha20poly1305_push","crypto_secretstream_xchacha20poly1305_rekey","crypto_shorthash","crypto_shorthash_keygen","crypto_shorthash_siphashx24","crypto_sign","crypto_sign_detached","crypto_sign_ed25519_pk_to_curve25519","crypto_sign_ed25519_sk_to_curve25519","crypto_sign_ed25519_sk_to_pk","crypto_sign_ed25519_sk_to_seed","crypto_sign_final_create","crypto_sign_final_verify","crypto_sign_init","crypto_sign_keypair","crypto_sign_open","crypto_sign_seed_keypair","crypto_sign_update","crypto_sign_verify_detached","crypto_stream_chacha20","crypto_stream_chacha20_ietf_xor","crypto_stream_chacha20_ietf_xor_ic","crypto_stream_chacha20_keygen","crypto_stream_chacha20_xor","crypto_stream_chacha20_xor_ic","crypto_stream_keygen","crypto_stream_xchacha20_keygen","crypto_stream_xchacha20_xor","crypto_stream_xchacha20_xor_ic","randombytes_buf","randombytes_buf_deterministic","randombytes_close","randombytes_random","randombytes_set_implementation","randombytes_stir","randombytes_uniform","sodium_version_string"],a=[E,k,S,T,w,Y,B,A,K,M,I,N,L,U,O,C,R,P,G,X,D,F,V,H,q,j,z,W,J,Q,Z,$,ee,re,te,ae,_e,ne,se,ce,oe,he,pe,ye,ie,le,ue,de,ve,ge,be,fe,me,xe,Ee,ke,Se,Te,we,Ye,Be,Ae,Ke,Me,Ie,Ne,Le,Ue,Oe,Ce,Re,Pe,Ge,Xe,De,Fe,Ve,He,qe,je,ze,We,Je,Qe,Ze,$e,er,rr,tr,ar,_r,nr,sr,cr,or,hr,pr,yr,ir,lr,ur,dr,vr,gr,br,fr,mr,xr,Er,kr,Sr,Tr,wr,Yr,Br,Ar,Kr,Mr,Ir,Nr,Lr,Ur,Or,Cr,Rr,Pr,Gr,Xr,Dr,Fr,Vr,Hr,qr,jr,zr,Wr,Jr,Qr,Zr,$r,et,rt,tt,at,_t,nt,st,ct,ot,ht,pt,yt,it,lt,ut,dt,vt,gt,bt,ft,mt,xt,Et,kt,St,Tt,wt,Yt,Bt,At,Kt,Mt,It,Nt,Lt,Ut,Ot,Ct,Rt,Pt,Gt,Xt],_=0;_<a.length;_++)"function"==typeof t["_"+r[_]]&&(e[r[_]]=a[_]);var n=["SODIUM_LIBRARY_VERSION_MAJOR","SODIUM_LIBRARY_VERSION_MINOR","crypto_aead_chacha20poly1305_ABYTES","crypto_aead_chacha20poly1305_IETF_ABYTES","crypto_aead_chacha20poly1305_IETF_KEYBYTES","crypto_aead_chacha20poly1305_IETF_MESSAGEBYTES_MAX","crypto_aead_chacha20poly1305_IETF_NPUBBYTES","crypto_aead_chacha20poly1305_IETF_NSECBYTES","crypto_aead_chacha20poly1305_KEYBYTES","crypto_aead_chacha20poly1305_MESSAGEBYTES_MAX","crypto_aead_chacha20poly1305_NPUBBYTES","crypto_aead_chacha20poly1305_NSECBYTES","crypto_aead_chacha20poly1305_ietf_ABYTES","crypto_aead_chacha20poly1305_ietf_KEYBYTES","crypto_aead_chacha20poly1305_ietf_MESSAGEBYTES_MAX","crypto_aead_chacha20poly1305_ietf_NPUBBYTES","crypto_aead_chacha20poly1305_ietf_NSECBYTES","crypto_aead_xchacha20poly1305_IETF_ABYTES","crypto_aead_xchacha20poly1305_IETF_KEYBYTES","crypto_aead_xchacha20poly1305_IETF_MESSAGEBYTES_MAX","crypto_aead_xchacha20poly1305_IETF_NPUBBYTES","crypto_aead_xchacha20poly1305_IETF_NSECBYTES","crypto_aead_xchacha20poly1305_ietf_ABYTES","crypto_aead_xchacha20poly1305_ietf_KEYBYTES","crypto_aead_xchacha20poly1305_ietf_MESSAGEBYTES_MAX","crypto_aead_xchacha20poly1305_ietf_NPUBBYTES","crypto_aead_xchacha20poly1305_ietf_NSECBYTES","crypto_auth_BYTES","crypto_auth_KEYBYTES","crypto_auth_hmacsha256_BYTES","crypto_auth_hmacsha256_KEYBYTES","crypto_auth_hmacsha512256_BYTES","crypto_auth_hmacsha512256_KEYBYTES","crypto_auth_hmacsha512_BYTES","crypto_auth_hmacsha512_KEYBYTES","crypto_box_BEFORENMBYTES","crypto_box_MACBYTES","crypto_box_MESSAGEBYTES_MAX","crypto_box_NONCEBYTES","crypto_box_PUBLICKEYBYTES","crypto_box_SEALBYTES","crypto_box_SECRETKEYBYTES","crypto_box_SEEDBYTES","crypto_box_curve25519xchacha20poly1305_BEFORENMBYTES","crypto_box_curve25519xchacha20poly1305_MACBYTES","crypto_box_curve25519xchacha20poly1305_MESSAGEBYTES_MAX","crypto_box_curve25519xchacha20poly1305_NONCEBYTES","crypto_box_curve25519xchacha20poly1305_PUBLICKEYBYTES","crypto_box_curve25519xchacha20poly1305_SEALBYTES","crypto_box_curve25519xchacha20poly1305_SECRETKEYBYTES","crypto_box_curve25519xchacha20poly1305_SEEDBYTES","crypto_box_curve25519xsalsa20poly1305_BEFORENMBYTES","crypto_box_curve25519xsalsa20poly1305_MACBYTES","crypto_box_curve25519xsalsa20poly1305_MESSAGEBYTES_MAX","crypto_box_curve25519xsalsa20poly1305_NONCEBYTES","crypto_box_curve25519xsalsa20poly1305_PUBLICKEYBYTES","crypto_box_curve25519xsalsa20poly1305_SECRETKEYBYTES","crypto_box_curve25519xsalsa20poly1305_SEEDBYTES","crypto_core_ed25519_BYTES","crypto_core_ed25519_HASHBYTES","crypto_core_ed25519_NONREDUCEDSCALARBYTES","crypto_core_ed25519_SCALARBYTES","crypto_core_ed25519_UNIFORMBYTES","crypto_core_hchacha20_CONSTBYTES","crypto_core_hchacha20_INPUTBYTES","crypto_core_hchacha20_KEYBYTES","crypto_core_hchacha20_OUTPUTBYTES","crypto_core_hsalsa20_CONSTBYTES","crypto_core_hsalsa20_INPUTBYTES","crypto_core_hsalsa20_KEYBYTES","crypto_core_hsalsa20_OUTPUTBYTES","crypto_core_ristretto255_BYTES","crypto_core_ristretto255_HASHBYTES","crypto_core_ristretto255_NONREDUCEDSCALARBYTES","crypto_core_ristretto255_SCALARBYTES","crypto_core_salsa2012_CONSTBYTES","crypto_core_salsa2012_INPUTBYTES","crypto_core_salsa2012_KEYBYTES","crypto_core_salsa2012_OUTPUTBYTES","crypto_core_salsa20_CONSTBYTES","crypto_core_salsa20_INPUTBYTES","crypto_core_salsa20_KEYBYTES","crypto_core_salsa20_OUTPUTBYTES","crypto_generichash_BYTES","crypto_generichash_BYTES_MAX","crypto_generichash_BYTES_MIN","crypto_generichash_KEYBYTES","crypto_generichash_KEYBYTES_MAX","crypto_generichash_KEYBYTES_MIN","crypto_generichash_blake2b_BYTES","crypto_generichash_blake2b_BYTES_MAX","crypto_generichash_blake2b_BYTES_MIN","crypto_generichash_blake2b_KEYBYTES","crypto_generichash_blake2b_KEYBYTES_MAX","crypto_generichash_blake2b_KEYBYTES_MIN","crypto_generichash_blake2b_PERSONALBYTES","crypto_generichash_blake2b_SALTBYTES","crypto_hash_BYTES","crypto_hash_sha256_BYTES","crypto_hash_sha512_BYTES","crypto_kdf_BYTES_MAX","crypto_kdf_BYTES_MIN","crypto_kdf_CONTEXTBYTES","crypto_kdf_KEYBYTES","crypto_kdf_blake2b_BYTES_MAX","crypto_kdf_blake2b_BYTES_MIN","crypto_kdf_blake2b_CONTEXTBYTES","crypto_kdf_blake2b_KEYBYTES","crypto_kx_PUBLICKEYBYTES","crypto_kx_SECRETKEYBYTES","crypto_kx_SEEDBYTES","crypto_kx_SESSIONKEYBYTES","crypto_onetimeauth_BYTES","crypto_onetimeauth_KEYBYTES","crypto_onetimeauth_poly1305_BYTES","crypto_onetimeauth_poly1305_KEYBYTES","crypto_pwhash_ALG_ARGON2I13","crypto_pwhash_ALG_ARGON2ID13","crypto_pwhash_ALG_DEFAULT","crypto_pwhash_BYTES_MAX","crypto_pwhash_BYTES_MIN","crypto_pwhash_MEMLIMIT_INTERACTIVE","crypto_pwhash_MEMLIMIT_MAX","crypto_pwhash_MEMLIMIT_MIN","crypto_pwhash_MEMLIMIT_MODERATE","crypto_pwhash_MEMLIMIT_SENSITIVE","crypto_pwhash_OPSLIMIT_INTERACTIVE","crypto_pwhash_OPSLIMIT_MAX","crypto_pwhash_OPSLIMIT_MIN","crypto_pwhash_OPSLIMIT_MODERATE","crypto_pwhash_OPSLIMIT_SENSITIVE","crypto_pwhash_PASSWD_MAX","crypto_pwhash_PASSWD_MIN","crypto_pwhash_SALTBYTES","crypto_pwhash_STRBYTES","crypto_pwhash_argon2i_BYTES_MAX","crypto_pwhash_argon2i_BYTES_MIN","crypto_pwhash_argon2i_SALTBYTES","crypto_pwhash_argon2i_STRBYTES","crypto_pwhash_argon2id_BYTES_MAX","crypto_pwhash_argon2id_BYTES_MIN","crypto_pwhash_argon2id_SALTBYTES","crypto_pwhash_argon2id_STRBYTES","crypto_pwhash_scryptsalsa208sha256_BYTES_MAX","crypto_pwhash_scryptsalsa208sha256_BYTES_MIN","crypto_pwhash_scryptsalsa208sha256_MEMLIMIT_INTERACTIVE","crypto_pwhash_scryptsalsa208sha256_MEMLIMIT_MAX","crypto_pwhash_scryptsalsa208sha256_MEMLIMIT_MIN","crypto_pwhash_scryptsalsa208sha256_MEMLIMIT_SENSITIVE","crypto_pwhash_scryptsalsa208sha256_OPSLIMIT_INTERACTIVE","crypto_pwhash_scryptsalsa208sha256_OPSLIMIT_MAX","crypto_pwhash_scryptsalsa208sha256_OPSLIMIT_MIN","crypto_pwhash_scryptsalsa208sha256_OPSLIMIT_SENSITIVE","crypto_pwhash_scryptsalsa208sha256_SALTBYTES","crypto_pwhash_scryptsalsa208sha256_STRBYTES","crypto_scalarmult_BYTES","crypto_scalarmult_SCALARBYTES","crypto_scalarmult_curve25519_BYTES","crypto_scalarmult_curve25519_SCALARBYTES","crypto_scalarmult_ed25519_BYTES","crypto_scalarmult_ed25519_SCALARBYTES","crypto_scalarmult_ristretto255_BYTES","crypto_scalarmult_ristretto255_SCALARBYTES","crypto_secretbox_KEYBYTES","crypto_secretbox_MACBYTES","crypto_secretbox_MESSAGEBYTES_MAX","crypto_secretbox_NONCEBYTES","crypto_secretbox_xchacha20poly1305_KEYBYTES","crypto_secretbox_xchacha20poly1305_MACBYTES","crypto_secretbox_xchacha20poly1305_MESSAGEBYTES_MAX","crypto_secretbox_xchacha20poly1305_NONCEBYTES","crypto_secretbox_xsalsa20poly1305_KEYBYTES","crypto_secretbox_xsalsa20poly1305_MACBYTES","crypto_secretbox_xsalsa20poly1305_MESSAGEBYTES_MAX","crypto_secretbox_xsalsa20poly1305_NONCEBYTES","crypto_secretstream_xchacha20poly1305_ABYTES","crypto_secretstream_xchacha20poly1305_HEADERBYTES","crypto_secretstream_xchacha20poly1305_KEYBYTES","crypto_secretstream_xchacha20poly1305_MESSAGEBYTES_MAX","crypto_secretstream_xchacha20poly1305_TAG_FINAL","crypto_secretstream_xchacha20poly1305_TAG_MESSAGE","crypto_secretstream_xchacha20poly1305_TAG_PUSH","crypto_secretstream_xchacha20poly1305_TAG_REKEY","crypto_shorthash_BYTES","crypto_shorthash_KEYBYTES","crypto_shorthash_siphash24_BYTES","crypto_shorthash_siphash24_KEYBYTES","crypto_shorthash_siphashx24_BYTES","crypto_shorthash_siphashx24_KEYBYTES","crypto_sign_BYTES","crypto_sign_MESSAGEBYTES_MAX","crypto_sign_PUBLICKEYBYTES","crypto_sign_SECRETKEYBYTES","crypto_sign_SEEDBYTES","crypto_sign_ed25519_BYTES","crypto_sign_ed25519_MESSAGEBYTES_MAX","crypto_sign_ed25519_PUBLICKEYBYTES","crypto_sign_ed25519_SECRETKEYBYTES","crypto_sign_ed25519_SEEDBYTES","crypto_stream_KEYBYTES","crypto_stream_MESSAGEBYTES_MAX","crypto_stream_NONCEBYTES","crypto_stream_chacha20_IETF_KEYBYTES","crypto_stream_chacha20_IETF_MESSAGEBYTES_MAX","crypto_stream_chacha20_IETF_NONCEBYTES","crypto_stream_chacha20_KEYBYTES","crypto_stream_chacha20_MESSAGEBYTES_MAX","crypto_stream_chacha20_NONCEBYTES","crypto_stream_chacha20_ietf_KEYBYTES","crypto_stream_chacha20_ietf_MESSAGEBYTES_MAX","crypto_stream_chacha20_ietf_NONCEBYTES","crypto_stream_salsa2012_KEYBYTES","crypto_stream_salsa2012_MESSAGEBYTES_MAX","crypto_stream_salsa2012_NONCEBYTES","crypto_stream_salsa208_KEYBYTES","crypto_stream_salsa208_MESSAGEBYTES_MAX","crypto_stream_salsa208_NONCEBYTES","crypto_stream_salsa20_KEYBYTES","crypto_stream_salsa20_MESSAGEBYTES_MAX","crypto_stream_salsa20_NONCEBYTES","crypto_stream_xchacha20_KEYBYTES","crypto_stream_xchacha20_MESSAGEBYTES_MAX","crypto_stream_xchacha20_NONCEBYTES","crypto_stream_xsalsa20_KEYBYTES","crypto_stream_xsalsa20_MESSAGEBYTES_MAX","crypto_stream_xsalsa20_NONCEBYTES","crypto_verify_16_BYTES","crypto_verify_32_BYTES","crypto_verify_64_BYTES"];for(_=0;_<n.length;_++)"function"==typeof(c=t["_"+n[_].toLowerCase()])&&(e[n[_]]=c());var s=["SODIUM_VERSION_STRING","crypto_pwhash_STRPREFIX","crypto_pwhash_scryptsalsa208sha256_STRPREFIX"];for(_=0;_<s.length;_++){var c;"function"==typeof(c=t["_"+s[_].toLowerCase()])&&(e[s[_]]=t.UTF8ToString(c()))}}t=r;try{a();var _=new Uint8Array([98,97,108,108,115]),n=e.randombytes_buf(e.crypto_secretbox_NONCEBYTES),s=e.randombytes_buf(e.crypto_secretbox_KEYBYTES),c=e.crypto_secretbox_easy(_,n,s),o=e.crypto_secretbox_open_easy(c,n,s);if(e.memcmp(_,o))return}catch(e){if(null==t.useBackupModule)throw new Error("Both wasm and asm failed to load"+e)}t.useBackupModule(),a()}));function n(e){if("function"==typeof TextEncoder)return(new TextEncoder).encode(e);e=unescape(encodeURIComponent(e));for(var r=new Uint8Array(e.length),t=0,a=e.length;t<a;t++)r[t]=e.charCodeAt(t);return r}function s(e){if("function"==typeof TextDecoder)return new TextDecoder("utf-8",{fatal:!0}).decode(e);var r=8192,t=Math.ceil(e.length/r);if(t<=1)try{return decodeURIComponent(escape(String.fromCharCode.apply(null,e)))}catch(e){throw new TypeError("The encoded data was not valid.")}for(var a="",_=0,n=0;n<t;n++){var c=Array.prototype.slice.call(e,n*r+_,(n+1)*r+_);if(0!=c.length){var o,h=c.length,p=0;do{var y=c[--h];y>=240?(p=4,o=!0):y>=224?(p=3,o=!0):y>=192?(p=2,o=!0):y<128&&(p=1,o=!0)}while(!o);for(var i=p-(c.length-h),l=0;l<i;l++)_--,c.pop();a+=s(c)}}return a}function c(e){e=x(null,e,"input");for(var r,t,a,_="",n=0;n<e.length;n++)a=87+(t=15&e[n])+(t-10>>8&-39)<<8|87+(r=e[n]>>>4)+(r-10>>8&-39),_+=String.fromCharCode(255&a)+String.fromCharCode(a>>>8);return _}var o={ORIGINAL:1,ORIGINAL_NO_PADDING:3,URLSAFE:5,URLSAFE_NO_PADDING:7};function h(e){if(null==e)return o.URLSAFE_NO_PADDING;if(e!==o.ORIGINAL&&e!==o.ORIGINAL_NO_PADDING&&e!==o.URLSAFE&&e!=o.URLSAFE_NO_PADDING)throw new Error("unsupported base64 variant");return e}function p(e,r){r=h(r),e=x(_,e,"input");var a,_=[],n=0|Math.floor(e.length/3),c=e.length-3*n,o=4*n+(0!==c?0==(2&r)?4:2+(c>>>1):0),p=new u(o+1),y=d(e);return _.push(y),_.push(p.address),0===t._sodium_bin2base64(p.address,p.length,y,e.length,r)&&b(_,"conversion failed"),p.length=o,a=s(p.to_Uint8Array()),g(_),a}function y(e,r){var t=r||a;if(!i(t))throw new Error(t+" output format is not available");if(e instanceof u){if("uint8array"===t)return e.to_Uint8Array();if("text"===t)return s(e.to_Uint8Array());if("hex"===t)return c(e.to_Uint8Array());if("base64"===t)return p(e.to_Uint8Array(),o.URLSAFE_NO_PADDING);throw new Error('What is output format "'+t+'"?')}if("object"==typeof e){for(var _=Object.keys(e),n={},h=0;h<_.length;h++)n[_[h]]=y(e[_[h]],t);return n}if("string"==typeof e)return e;throw new TypeError("Cannot format output")}function i(e){for(var r=["uint8array","text","hex","base64"],t=0;t<r.length;t++)if(r[t]===e)return!0;return!1}function l(e){if(e){if("string"!=typeof e)throw new TypeError("When defined, the output format must be a string");if(!i(e))throw new Error(e+" is not a supported output format")}}function u(e){this.length=e,this.address=v(e)}function d(e){var r=v(e.length);return t.HEAPU8.set(e,r),r}function v(e){var r=t._malloc(e);if(0===r)throw{message:"_malloc() failed",length:e};return r}function g(e){if(e)for(var r=0;r<e.length;r++)a=e[r],t._free(a);var a}function b(e,r){throw g(e),new Error(r)}function f(e,r){throw g(e),new TypeError(r)}function m(e,r,t){null==r&&f(e,t+" cannot be null or undefined")}function x(e,r,t){return m(e,r,t),r instanceof Uint8Array?r:"string"==typeof r?n(r):void f(e,"unsupported input type for "+t)}function E(e,r,a,_,n,s){var c=[];l(s);var o=null;null!=e&&(o=d(e=x(c,e,"secret_nonce")),e.length,c.push(o)),r=x(c,r,"ciphertext");var h,p=t._crypto_aead_aegis128l_abytes(),i=r.length;i<p&&f(c,"ciphertext is too short"),h=d(r),c.push(h);var v=null,m=0;null!=a&&(v=d(a=x(c,a,"additional_data")),m=a.length,c.push(v)),_=x(c,_,"public_nonce");var E,k=0|t._crypto_aead_aegis128l_npubbytes();_.length!==k&&f(c,"invalid public_nonce length"),E=d(_),c.push(E),n=x(c,n,"key");var S,T=0|t._crypto_aead_aegis128l_keybytes();n.length!==T&&f(c,"invalid key length"),S=d(n),c.push(S);var w=new u(i-t._crypto_aead_aegis128l_abytes()|0),Y=w.address;if(c.push(Y),0===t._crypto_aead_aegis128l_decrypt(Y,null,o,h,i,0,v,m,0,E,S)){var B=y(w,s);return g(c),B}b(c,"ciphertext cannot be decrypted using that key")}function k(e,r,a,_,n,s,c){var o=[];l(c);var h=null;null!=e&&(h=d(e=x(o,e,"secret_nonce")),e.length,o.push(h));var p=d(r=x(o,r,"ciphertext")),i=r.length;o.push(p),a=x(o,a,"mac");var v,m=0|t._crypto_box_macbytes();a.length!==m&&f(o,"invalid mac length"),v=d(a),o.push(v);var E=null,k=0;null!=_&&(E=d(_=x(o,_,"additional_data")),k=_.length,o.push(E)),n=x(o,n,"public_nonce");var S,T=0|t._crypto_aead_aegis128l_npubbytes();n.length!==T&&f(o,"invalid public_nonce length"),S=d(n),o.push(S),s=x(o,s,"key");var w,Y=0|t._crypto_aead_aegis128l_keybytes();s.length!==Y&&f(o,"invalid key length"),w=d(s),o.push(w);var B=new u(0|i),A=B.address;if(o.push(A),0===t._crypto_aead_aegis128l_decrypt_detached(A,h,p,i,0,v,E,k,0,S,w)){var K=y(B,c);return g(o),K}b(o,"ciphertext cannot be decrypted using that key")}function S(e,r,a,_,n,s){var c=[];l(s);var o=d(e=x(c,e,"message")),h=e.length;c.push(o);var p=null,i=0;null!=r&&(p=d(r=x(c,r,"additional_data")),i=r.length,c.push(p));var v=null;null!=a&&(v=d(a=x(c,a,"secret_nonce")),a.length,c.push(v)),_=x(c,_,"public_nonce");var m,E=0|t._crypto_aead_aegis128l_npubbytes();_.length!==E&&f(c,"invalid public_nonce length"),m=d(_),c.push(m),n=x(c,n,"key");var k,S=0|t._crypto_aead_aegis128l_keybytes();n.length!==S&&f(c,"invalid key length"),k=d(n),c.push(k);var T=new u(h+t._crypto_aead_aegis128l_abytes()|0),w=T.address;if(c.push(w),0===t._crypto_aead_aegis128l_encrypt(w,null,o,h,0,p,i,0,v,m,k)){var Y=y(T,s);return g(c),Y}b(c,"invalid usage")}function T(e,r,a,_,n,s){var c=[];l(s);var o=d(e=x(c,e,"message")),h=e.length;c.push(o);var p=null,i=0;null!=r&&(p=d(r=x(c,r,"additional_data")),i=r.length,c.push(p));var v=null;null!=a&&(v=d(a=x(c,a,"secret_nonce")),a.length,c.push(v)),_=x(c,_,"public_nonce");var m,E=0|t._crypto_aead_aegis128l_npubbytes();_.length!==E&&f(c,"invalid public_nonce length"),m=d(_),c.push(m),n=x(c,n,"key");var k,S=0|t._crypto_aead_aegis128l_keybytes();n.length!==S&&f(c,"invalid key length"),k=d(n),c.push(k);var T=new u(0|h),w=T.address;c.push(w);var Y=new u(0|t._crypto_aead_aegis128l_abytes()),B=Y.address;if(c.push(B),0===t._crypto_aead_aegis128l_encrypt_detached(w,B,null,o,h,0,p,i,0,v,m,k)){var A=y({ciphertext:T,mac:Y},s);return g(c),A}b(c,"invalid usage")}function w(e){var r=[];l(e);var a=new u(0|t._crypto_aead_aegis128l_keybytes()),_=a.address;r.push(_),t._crypto_aead_aegis128l_keygen(_);var n=y(a,e);return g(r),n}function Y(e,r,a,_,n,s){var c=[];l(s);var o=null;null!=e&&(o=d(e=x(c,e,"secret_nonce")),e.length,c.push(o)),r=x(c,r,"ciphertext");var h,p=t._crypto_aead_aegis256_abytes(),i=r.length;i<p&&f(c,"ciphertext is too short"),h=d(r),c.push(h);var v=null,m=0;null!=a&&(v=d(a=x(c,a,"additional_data")),m=a.length,c.push(v)),_=x(c,_,"public_nonce");var E,k=0|t._crypto_aead_aegis256_npubbytes();_.length!==k&&f(c,"invalid public_nonce length"),E=d(_),c.push(E),n=x(c,n,"key");var S,T=0|t._crypto_aead_aegis256_keybytes();n.length!==T&&f(c,"invalid key length"),S=d(n),c.push(S);var w=new u(i-t._crypto_aead_aegis256_abytes()|0),Y=w.address;if(c.push(Y),0===t._crypto_aead_aegis256_decrypt(Y,null,o,h,i,0,v,m,0,E,S)){var B=y(w,s);return g(c),B}b(c,"ciphertext cannot be decrypted using that key")}function B(e,r,a,_,n,s,c){var o=[];l(c);var h=null;null!=e&&(h=d(e=x(o,e,"secret_nonce")),e.length,o.push(h));var p=d(r=x(o,r,"ciphertext")),i=r.length;o.push(p),a=x(o,a,"mac");var v,m=0|t._crypto_box_macbytes();a.length!==m&&f(o,"invalid mac length"),v=d(a),o.push(v);var E=null,k=0;null!=_&&(E=d(_=x(o,_,"additional_data")),k=_.length,o.push(E)),n=x(o,n,"public_nonce");var S,T=0|t._crypto_aead_aegis256_npubbytes();n.length!==T&&f(o,"invalid public_nonce length"),S=d(n),o.push(S),s=x(o,s,"key");var w,Y=0|t._crypto_aead_aegis256_keybytes();s.length!==Y&&f(o,"invalid key length"),w=d(s),o.push(w);var B=new u(0|i),A=B.address;if(o.push(A),0===t._crypto_aead_aegis256_decrypt_detached(A,h,p,i,0,v,E,k,0,S,w)){var K=y(B,c);return g(o),K}b(o,"ciphertext cannot be decrypted using that key")}function A(e,r,a,_,n,s){var c=[];l(s);var o=d(e=x(c,e,"message")),h=e.length;c.push(o);var p=null,i=0;null!=r&&(p=d(r=x(c,r,"additional_data")),i=r.length,c.push(p));var v=null;null!=a&&(v=d(a=x(c,a,"secret_nonce")),a.length,c.push(v)),_=x(c,_,"public_nonce");var m,E=0|t._crypto_aead_aegis256_npubbytes();_.length!==E&&f(c,"invalid public_nonce length"),m=d(_),c.push(m),n=x(c,n,"key");var k,S=0|t._crypto_aead_aegis256_keybytes();n.length!==S&&f(c,"invalid key length"),k=d(n),c.push(k);var T=new u(h+t._crypto_aead_aegis256_abytes()|0),w=T.address;if(c.push(w),0===t._crypto_aead_aegis256_encrypt(w,null,o,h,0,p,i,0,v,m,k)){var Y=y(T,s);return g(c),Y}b(c,"invalid usage")}function K(e,r,a,_,n,s){var c=[];l(s);var o=d(e=x(c,e,"message")),h=e.length;c.push(o);var p=null,i=0;null!=r&&(p=d(r=x(c,r,"additional_data")),i=r.length,c.push(p));var v=null;null!=a&&(v=d(a=x(c,a,"secret_nonce")),a.length,c.push(v)),_=x(c,_,"public_nonce");var m,E=0|t._crypto_aead_aegis256_npubbytes();_.length!==E&&f(c,"invalid public_nonce length"),m=d(_),c.push(m),n=x(c,n,"key");var k,S=0|t._crypto_aead_aegis256_keybytes();n.length!==S&&f(c,"invalid key length"),k=d(n),c.push(k);var T=new u(0|h),w=T.address;c.push(w);var Y=new u(0|t._crypto_aead_aegis256_abytes()),B=Y.address;if(c.push(B),0===t._crypto_aead_aegis256_encrypt_detached(w,B,null,o,h,0,p,i,0,v,m,k)){var A=y({ciphertext:T,mac:Y},s);return g(c),A}b(c,"invalid usage")}function M(e){var r=[];l(e);var a=new u(0|t._crypto_aead_aegis256_keybytes()),_=a.address;r.push(_),t._crypto_aead_aegis256_keygen(_);var n=y(a,e);return g(r),n}function I(e,r,a,_,n,s){var c=[];l(s);var o=null;null!=e&&(o=d(e=x(c,e,"secret_nonce")),e.length,c.push(o)),r=x(c,r,"ciphertext");var h,p=t._crypto_aead_chacha20poly1305_abytes(),i=r.length;i<p&&f(c,"ciphertext is too short"),h=d(r),c.push(h);var v=null,m=0;null!=a&&(v=d(a=x(c,a,"additional_data")),m=a.length,c.push(v)),_=x(c,_,"public_nonce");var E,k=0|t._crypto_aead_chacha20poly1305_npubbytes();_.length!==k&&f(c,"invalid public_nonce length"),E=d(_),c.push(E),n=x(c,n,"key");var S,T=0|t._crypto_aead_chacha20poly1305_keybytes();n.length!==T&&f(c,"invalid key length"),S=d(n),c.push(S);var w=new u(i-t._crypto_aead_chacha20poly1305_abytes()|0),Y=w.address;if(c.push(Y),0===t._crypto_aead_chacha20poly1305_decrypt(Y,null,o,h,i,0,v,m,0,E,S)){var B=y(w,s);return g(c),B}b(c,"ciphertext cannot be decrypted using that key")}function N(e,r,a,_,n,s,c){var o=[];l(c);var h=null;null!=e&&(h=d(e=x(o,e,"secret_nonce")),e.length,o.push(h));var p=d(r=x(o,r,"ciphertext")),i=r.length;o.push(p),a=x(o,a,"mac");var v,m=0|t._crypto_box_macbytes();a.length!==m&&f(o,"invalid mac length"),v=d(a),o.push(v);var E=null,k=0;null!=_&&(E=d(_=x(o,_,"additional_data")),k=_.length,o.push(E)),n=x(o,n,"public_nonce");var S,T=0|t._crypto_aead_chacha20poly1305_npubbytes();n.length!==T&&f(o,"invalid public_nonce length"),S=d(n),o.push(S),s=x(o,s,"key");var w,Y=0|t._crypto_aead_chacha20poly1305_keybytes();s.length!==Y&&f(o,"invalid key length"),w=d(s),o.push(w);var B=new u(0|i),A=B.address;if(o.push(A),0===t._crypto_aead_chacha20poly1305_decrypt_detached(A,h,p,i,0,v,E,k,0,S,w)){var K=y(B,c);return g(o),K}b(o,"ciphertext cannot be decrypted using that key")}function L(e,r,a,_,n,s){var c=[];l(s);var o=d(e=x(c,e,"message")),h=e.length;c.push(o);var p=null,i=0;null!=r&&(p=d(r=x(c,r,"additional_data")),i=r.length,c.push(p));var v=null;null!=a&&(v=d(a=x(c,a,"secret_nonce")),a.length,c.push(v)),_=x(c,_,"public_nonce");var m,E=0|t._crypto_aead_chacha20poly1305_npubbytes();_.length!==E&&f(c,"invalid public_nonce length"),m=d(_),c.push(m),n=x(c,n,"key");var k,S=0|t._crypto_aead_chacha20poly1305_keybytes();n.length!==S&&f(c,"invalid key length"),k=d(n),c.push(k);var T=new u(h+t._crypto_aead_chacha20poly1305_abytes()|0),w=T.address;if(c.push(w),0===t._crypto_aead_chacha20poly1305_encrypt(w,null,o,h,0,p,i,0,v,m,k)){var Y=y(T,s);return g(c),Y}b(c,"invalid usage")}function U(e,r,a,_,n,s){var c=[];l(s);var o=d(e=x(c,e,"message")),h=e.length;c.push(o);var p=null,i=0;null!=r&&(p=d(r=x(c,r,"additional_data")),i=r.length,c.push(p));var v=null;null!=a&&(v=d(a=x(c,a,"secret_nonce")),a.length,c.push(v)),_=x(c,_,"public_nonce");var m,E=0|t._crypto_aead_chacha20poly1305_npubbytes();_.length!==E&&f(c,"invalid public_nonce length"),m=d(_),c.push(m),n=x(c,n,"key");var k,S=0|t._crypto_aead_chacha20poly1305_keybytes();n.length!==S&&f(c,"invalid key length"),k=d(n),c.push(k);var T=new u(0|h),w=T.address;c.push(w);var Y=new u(0|t._crypto_aead_chacha20poly1305_abytes()),B=Y.address;if(c.push(B),0===t._crypto_aead_chacha20poly1305_encrypt_detached(w,B,null,o,h,0,p,i,0,v,m,k)){var A=y({ciphertext:T,mac:Y},s);return g(c),A}b(c,"invalid usage")}function O(e,r,a,_,n,s){var c=[];l(s);var o=null;null!=e&&(o=d(e=x(c,e,"secret_nonce")),e.length,c.push(o)),r=x(c,r,"ciphertext");var h,p=t._crypto_aead_chacha20poly1305_ietf_abytes(),i=r.length;i<p&&f(c,"ciphertext is too short"),h=d(r),c.push(h);var v=null,m=0;null!=a&&(v=d(a=x(c,a,"additional_data")),m=a.length,c.push(v)),_=x(c,_,"public_nonce");var E,k=0|t._crypto_aead_chacha20poly1305_ietf_npubbytes();_.length!==k&&f(c,"invalid public_nonce length"),E=d(_),c.push(E),n=x(c,n,"key");var S,T=0|t._crypto_aead_chacha20poly1305_ietf_keybytes();n.length!==T&&f(c,"invalid key length"),S=d(n),c.push(S);var w=new u(i-t._crypto_aead_chacha20poly1305_ietf_abytes()|0),Y=w.address;if(c.push(Y),0===t._crypto_aead_chacha20poly1305_ietf_decrypt(Y,null,o,h,i,0,v,m,0,E,S)){var B=y(w,s);return g(c),B}b(c,"ciphertext cannot be decrypted using that key")}function C(e,r,a,_,n,s,c){var o=[];l(c);var h=null;null!=e&&(h=d(e=x(o,e,"secret_nonce")),e.length,o.push(h));var p=d(r=x(o,r,"ciphertext")),i=r.length;o.push(p),a=x(o,a,"mac");var v,m=0|t._crypto_box_macbytes();a.length!==m&&f(o,"invalid mac length"),v=d(a),o.push(v);var E=null,k=0;null!=_&&(E=d(_=x(o,_,"additional_data")),k=_.length,o.push(E)),n=x(o,n,"public_nonce");var S,T=0|t._crypto_aead_chacha20poly1305_ietf_npubbytes();n.length!==T&&f(o,"invalid public_nonce length"),S=d(n),o.push(S),s=x(o,s,"key");var w,Y=0|t._crypto_aead_chacha20poly1305_ietf_keybytes();s.length!==Y&&f(o,"invalid key length"),w=d(s),o.push(w);var B=new u(0|i),A=B.address;if(o.push(A),0===t._crypto_aead_chacha20poly1305_ietf_decrypt_detached(A,h,p,i,0,v,E,k,0,S,w)){var K=y(B,c);return g(o),K}b(o,"ciphertext cannot be decrypted using that key")}function R(e,r,a,_,n,s){var c=[];l(s);var o=d(e=x(c,e,"message")),h=e.length;c.push(o);var p=null,i=0;null!=r&&(p=d(r=x(c,r,"additional_data")),i=r.length,c.push(p));var v=null;null!=a&&(v=d(a=x(c,a,"secret_nonce")),a.length,c.push(v)),_=x(c,_,"public_nonce");var m,E=0|t._crypto_aead_chacha20poly1305_ietf_npubbytes();_.length!==E&&f(c,"invalid public_nonce length"),m=d(_),c.push(m),n=x(c,n,"key");var k,S=0|t._crypto_aead_chacha20poly1305_ietf_keybytes();n.length!==S&&f(c,"invalid key length"),k=d(n),c.push(k);var T=new u(h+t._crypto_aead_chacha20poly1305_ietf_abytes()|0),w=T.address;if(c.push(w),0===t._crypto_aead_chacha20poly1305_ietf_encrypt(w,null,o,h,0,p,i,0,v,m,k)){var Y=y(T,s);return g(c),Y}b(c,"invalid usage")}function P(e,r,a,_,n,s){var c=[];l(s);var o=d(e=x(c,e,"message")),h=e.length;c.push(o);var p=null,i=0;null!=r&&(p=d(r=x(c,r,"additional_data")),i=r.length,c.push(p));var v=null;null!=a&&(v=d(a=x(c,a,"secret_nonce")),a.length,c.push(v)),_=x(c,_,"public_nonce");var m,E=0|t._crypto_aead_chacha20poly1305_ietf_npubbytes();_.length!==E&&f(c,"invalid public_nonce length"),m=d(_),c.push(m),n=x(c,n,"key");var k,S=0|t._crypto_aead_chacha20poly1305_ietf_keybytes();n.length!==S&&f(c,"invalid key length"),k=d(n),c.push(k);var T=new u(0|h),w=T.address;c.push(w);var Y=new u(0|t._crypto_aead_chacha20poly1305_ietf_abytes()),B=Y.address;if(c.push(B),0===t._crypto_aead_chacha20poly1305_ietf_encrypt_detached(w,B,null,o,h,0,p,i,0,v,m,k)){var A=y({ciphertext:T,mac:Y},s);return g(c),A}b(c,"invalid usage")}function G(e){var r=[];l(e);var a=new u(0|t._crypto_aead_chacha20poly1305_ietf_keybytes()),_=a.address;r.push(_),t._crypto_aead_chacha20poly1305_ietf_keygen(_);var n=y(a,e);return g(r),n}function X(e){var r=[];l(e);var a=new u(0|t._crypto_aead_chacha20poly1305_keybytes()),_=a.address;r.push(_),t._crypto_aead_chacha20poly1305_keygen(_);var n=y(a,e);return g(r),n}function D(e,r,a,_,n,s){var c=[];l(s);var o=null;null!=e&&(o=d(e=x(c,e,"secret_nonce")),e.length,c.push(o)),r=x(c,r,"ciphertext");var h,p=t._crypto_aead_xchacha20poly1305_ietf_abytes(),i=r.length;i<p&&f(c,"ciphertext is too short"),h=d(r),c.push(h);var v=null,m=0;null!=a&&(v=d(a=x(c,a,"additional_data")),m=a.length,c.push(v)),_=x(c,_,"public_nonce");var E,k=0|t._crypto_aead_xchacha20poly1305_ietf_npubbytes();_.length!==k&&f(c,"invalid public_nonce length"),E=d(_),c.push(E),n=x(c,n,"key");var S,T=0|t._crypto_aead_xchacha20poly1305_ietf_keybytes();n.length!==T&&f(c,"invalid key length"),S=d(n),c.push(S);var w=new u(i-t._crypto_aead_xchacha20poly1305_ietf_abytes()|0),Y=w.address;if(c.push(Y),0===t._crypto_aead_xchacha20poly1305_ietf_decrypt(Y,null,o,h,i,0,v,m,0,E,S)){var B=y(w,s);return g(c),B}b(c,"ciphertext cannot be decrypted using that key")}function F(e,r,a,_,n,s,c){var o=[];l(c);var h=null;null!=e&&(h=d(e=x(o,e,"secret_nonce")),e.length,o.push(h));var p=d(r=x(o,r,"ciphertext")),i=r.length;o.push(p),a=x(o,a,"mac");var v,m=0|t._crypto_box_macbytes();a.length!==m&&f(o,"invalid mac length"),v=d(a),o.push(v);var E=null,k=0;null!=_&&(E=d(_=x(o,_,"additional_data")),k=_.length,o.push(E)),n=x(o,n,"public_nonce");var S,T=0|t._crypto_aead_xchacha20poly1305_ietf_npubbytes();n.length!==T&&f(o,"invalid public_nonce length"),S=d(n),o.push(S),s=x(o,s,"key");var w,Y=0|t._crypto_aead_xchacha20poly1305_ietf_keybytes();s.length!==Y&&f(o,"invalid key length"),w=d(s),o.push(w);var B=new u(0|i),A=B.address;if(o.push(A),0===t._crypto_aead_xchacha20poly1305_ietf_decrypt_detached(A,h,p,i,0,v,E,k,0,S,w)){var K=y(B,c);return g(o),K}b(o,"ciphertext cannot be decrypted using that key")}function V(e,r,a,_,n,s){var c=[];l(s);var o=d(e=x(c,e,"message")),h=e.length;c.push(o);var p=null,i=0;null!=r&&(p=d(r=x(c,r,"additional_data")),i=r.length,c.push(p));var v=null;null!=a&&(v=d(a=x(c,a,"secret_nonce")),a.length,c.push(v)),_=x(c,_,"public_nonce");var m,E=0|t._crypto_aead_xchacha20poly1305_ietf_npubbytes();_.length!==E&&f(c,"invalid public_nonce length"),m=d(_),c.push(m),n=x(c,n,"key");var k,S=0|t._crypto_aead_xchacha20poly1305_ietf_keybytes();n.length!==S&&f(c,"invalid key length"),k=d(n),c.push(k);var T=new u(h+t._crypto_aead_xchacha20poly1305_ietf_abytes()|0),w=T.address;if(c.push(w),0===t._crypto_aead_xchacha20poly1305_ietf_encrypt(w,null,o,h,0,p,i,0,v,m,k)){var Y=y(T,s);return g(c),Y}b(c,"invalid usage")}function H(e,r,a,_,n,s){var c=[];l(s);var o=d(e=x(c,e,"message")),h=e.length;c.push(o);var p=null,i=0;null!=r&&(p=d(r=x(c,r,"additional_data")),i=r.length,c.push(p));var v=null;null!=a&&(v=d(a=x(c,a,"secret_nonce")),a.length,c.push(v)),_=x(c,_,"public_nonce");var m,E=0|t._crypto_aead_xchacha20poly1305_ietf_npubbytes();_.length!==E&&f(c,"invalid public_nonce length"),m=d(_),c.push(m),n=x(c,n,"key");var k,S=0|t._crypto_aead_xchacha20poly1305_ietf_keybytes();n.length!==S&&f(c,"invalid key length"),k=d(n),c.push(k);var T=new u(0|h),w=T.address;c.push(w);var Y=new u(0|t._crypto_aead_xchacha20poly1305_ietf_abytes()),B=Y.address;if(c.push(B),0===t._crypto_aead_xchacha20poly1305_ietf_encrypt_detached(w,B,null,o,h,0,p,i,0,v,m,k)){var A=y({ciphertext:T,mac:Y},s);return g(c),A}b(c,"invalid usage")}function q(e){var r=[];l(e);var a=new u(0|t._crypto_aead_xchacha20poly1305_ietf_keybytes()),_=a.address;r.push(_),t._crypto_aead_xchacha20poly1305_ietf_keygen(_);var n=y(a,e);return g(r),n}function j(e,r,a){var _=[];l(a);var n=d(e=x(_,e,"message")),s=e.length;_.push(n),r=x(_,r,"key");var c,o=0|t._crypto_auth_keybytes();r.length!==o&&f(_,"invalid key length"),c=d(r),_.push(c);var h=new u(0|t._crypto_auth_bytes()),p=h.address;if(_.push(p),0==(0|t._crypto_auth(p,n,s,0,c))){var i=y(h,a);return g(_),i}b(_,"invalid usage")}function z(e,r,a){var _=[];l(a);var n=d(e=x(_,e,"message")),s=e.length;_.push(n),r=x(_,r,"key");var c,o=0|t._crypto_auth_hmacsha256_keybytes();r.length!==o&&f(_,"invalid key length"),c=d(r),_.push(c);var h=new u(0|t._crypto_auth_hmacsha256_bytes()),p=h.address;if(_.push(p),0==(0|t._crypto_auth_hmacsha256(p,n,s,0,c))){var i=y(h,a);return g(_),i}b(_,"invalid usage")}function W(e,r){var a=[];l(r),m(a,e,"state_address");var _=new u(0|t._crypto_auth_hmacsha256_bytes()),n=_.address;if(a.push(n),0==(0|t._crypto_auth_hmacsha256_final(e,n))){var s=(t._free(e),y(_,r));return g(a),s}b(a,"invalid usage")}function J(e,r){var a=[];l(r);var _=null,n=0;null!=e&&(_=d(e=x(a,e,"key")),n=e.length,a.push(_));var s=new u(208).address;if(0==(0|t._crypto_auth_hmacsha256_init(s,_,n))){var c=s;return g(a),c}b(a,"invalid usage")}function Q(e){var r=[];l(e);var a=new u(0|t._crypto_auth_hmacsha256_keybytes()),_=a.address;r.push(_),t._crypto_auth_hmacsha256_keygen(_);var n=y(a,e);return g(r),n}function Z(e,r,a){var _=[];l(a),m(_,e,"state_address");var n=d(r=x(_,r,"message_chunk")),s=r.length;_.push(n),0!=(0|t._crypto_auth_hmacsha256_update(e,n,s))&&b(_,"invalid usage"),g(_)}function $(e,r,a){var _=[];e=x(_,e,"tag");var n,s=0|t._crypto_auth_hmacsha256_bytes();e.length!==s&&f(_,"invalid tag length"),n=d(e),_.push(n);var c=d(r=x(_,r,"message")),o=r.length;_.push(c),a=x(_,a,"key");var h,p=0|t._crypto_auth_hmacsha256_keybytes();a.length!==p&&f(_,"invalid key length"),h=d(a),_.push(h);var y=0==(0|t._crypto_auth_hmacsha256_verify(n,c,o,0,h));return g(_),y}function ee(e,r,a){var _=[];l(a);var n=d(e=x(_,e,"message")),s=e.length;_.push(n),r=x(_,r,"key");var c,o=0|t._crypto_auth_hmacsha512_keybytes();r.length!==o&&f(_,"invalid key length"),c=d(r),_.push(c);var h=new u(0|t._crypto_auth_hmacsha512_bytes()),p=h.address;if(_.push(p),0==(0|t._crypto_auth_hmacsha512(p,n,s,0,c))){var i=y(h,a);return g(_),i}b(_,"invalid usage")}function re(e,r){var a=[];l(r),m(a,e,"state_address");var _=new u(0|t._crypto_auth_hmacsha512_bytes()),n=_.address;if(a.push(n),0==(0|t._crypto_auth_hmacsha512_final(e,n))){var s=(t._free(e),y(_,r));return g(a),s}b(a,"invalid usage")}function te(e,r){var a=[];l(r);var _=null,n=0;null!=e&&(_=d(e=x(a,e,"key")),n=e.length,a.push(_));var s=new u(416).address;if(0==(0|t._crypto_auth_hmacsha512_init(s,_,n))){var c=s;return g(a),c}b(a,"invalid usage")}function ae(e){var r=[];l(e);var a=new u(0|t._crypto_auth_hmacsha512_keybytes()),_=a.address;r.push(_),t._crypto_auth_hmacsha512_keygen(_);var n=y(a,e);return g(r),n}function _e(e,r,a){var _=[];l(a),m(_,e,"state_address");var n=d(r=x(_,r,"message_chunk")),s=r.length;_.push(n),0!=(0|t._crypto_auth_hmacsha512_update(e,n,s))&&b(_,"invalid usage"),g(_)}function ne(e,r,a){var _=[];e=x(_,e,"tag");var n,s=0|t._crypto_auth_hmacsha512_bytes();e.length!==s&&f(_,"invalid tag length"),n=d(e),_.push(n);var c=d(r=x(_,r,"message")),o=r.length;_.push(c),a=x(_,a,"key");var h,p=0|t._crypto_auth_hmacsha512_keybytes();a.length!==p&&f(_,"invalid key length"),h=d(a),_.push(h);var y=0==(0|t._crypto_auth_hmacsha512_verify(n,c,o,0,h));return g(_),y}function se(e){var r=[];l(e);var a=new u(0|t._crypto_auth_keybytes()),_=a.address;r.push(_),t._crypto_auth_keygen(_);var n=y(a,e);return g(r),n}function ce(e,r,a){var _=[];e=x(_,e,"tag");var n,s=0|t._crypto_auth_bytes();e.length!==s&&f(_,"invalid tag length"),n=d(e),_.push(n);var c=d(r=x(_,r,"message")),o=r.length;_.push(c),a=x(_,a,"key");var h,p=0|t._crypto_auth_keybytes();a.length!==p&&f(_,"invalid key length"),h=d(a),_.push(h);var y=0==(0|t._crypto_auth_verify(n,c,o,0,h));return g(_),y}function oe(e,r,a){var _=[];l(a),e=x(_,e,"publicKey");var n,s=0|t._crypto_box_publickeybytes();e.length!==s&&f(_,"invalid publicKey length"),n=d(e),_.push(n),r=x(_,r,"privateKey");var c,o=0|t._crypto_box_secretkeybytes();r.length!==o&&f(_,"invalid privateKey length"),c=d(r),_.push(c);var h=new u(0|t._crypto_box_beforenmbytes()),p=h.address;if(_.push(p),0==(0|t._crypto_box_beforenm(p,n,c))){var i=y(h,a);return g(_),i}b(_,"invalid usage")}function he(e,r,a){var _=[];l(a),e=x(_,e,"publicKey");var n,s=0|t._crypto_box_curve25519xchacha20poly1305_publickeybytes();e.length!==s&&f(_,"invalid publicKey length"),n=d(e),_.push(n),r=x(_,r,"privateKey");var c,o=0|t._crypto_box_curve25519xchacha20poly1305_secretkeybytes();r.length!==o&&f(_,"invalid privateKey length"),c=d(r),_.push(c);var h=new u(0|t._crypto_box_curve25519xchacha20poly1305_beforenmbytes()),p=h.address;if(_.push(p),0==(0|t._crypto_box_curve25519xchacha20poly1305_beforenm(p,n,c))){var i=y(h,a);return g(_),i}b(_,"invalid usage")}function pe(e,r,a,_,n){var s=[];l(n);var c=d(e=x(s,e,"message")),o=e.length;s.push(c),r=x(s,r,"nonce");var h,p=0|t._crypto_box_curve25519xchacha20poly1305_noncebytes();r.length!==p&&f(s,"invalid nonce length"),h=d(r),s.push(h),a=x(s,a,"publicKey");var i,v=0|t._crypto_box_curve25519xchacha20poly1305_publickeybytes();a.length!==v&&f(s,"invalid publicKey length"),i=d(a),s.push(i),_=x(s,_,"privateKey");var m,E=0|t._crypto_box_curve25519xchacha20poly1305_secretkeybytes();_.length!==E&&f(s,"invalid privateKey length"),m=d(_),s.push(m);var k=new u(0|o),S=k.address;s.push(S);var T=new u(0|t._crypto_box_curve25519xchacha20poly1305_macbytes()),w=T.address;if(s.push(w),0==(0|t._crypto_box_curve25519xchacha20poly1305_detached(S,w,c,o,0,h,i,m))){var Y=y({ciphertext:k,mac:T},n);return g(s),Y}b(s,"invalid usage")}function ye(e,r,a,_){var n=[];l(_);var s=d(e=x(n,e,"message")),c=e.length;n.push(s),r=x(n,r,"nonce");var o,h=0|t._crypto_box_curve25519xchacha20poly1305_noncebytes();r.length!==h&&f(n,"invalid nonce length"),o=d(r),n.push(o),a=x(n,a,"sharedKey");var p,i=0|t._crypto_box_curve25519xchacha20poly1305_beforenmbytes();a.length!==i&&f(n,"invalid sharedKey length"),p=d(a),n.push(p);var v=new u(0|c),m=v.address;n.push(m);var E=new u(0|t._crypto_box_curve25519xchacha20poly1305_macbytes()),k=E.address;if(n.push(k),0==(0|t._crypto_box_curve25519xchacha20poly1305_detached_afternm(m,k,s,c,0,o,p))){var S=y({ciphertext:v,mac:E},_);return g(n),S}b(n,"invalid usage")}function ie(e,r,a,_,n){var s=[];l(n);var c=d(e=x(s,e,"message")),o=e.length;s.push(c),r=x(s,r,"nonce");var h,p=0|t._crypto_box_curve25519xchacha20poly1305_noncebytes();r.length!==p&&f(s,"invalid nonce length"),h=d(r),s.push(h),a=x(s,a,"publicKey");var i,v=0|t._crypto_box_curve25519xchacha20poly1305_publickeybytes();a.length!==v&&f(s,"invalid publicKey length"),i=d(a),s.push(i),_=x(s,_,"privateKey");var m,E=0|t._crypto_box_curve25519xchacha20poly1305_secretkeybytes();_.length!==E&&f(s,"invalid privateKey length"),m=d(_),s.push(m);var k=new u(o+t._crypto_box_curve25519xchacha20poly1305_macbytes()|0),S=k.address;if(s.push(S),0==(0|t._crypto_box_curve25519xchacha20poly1305_easy(S,c,o,0,h,i,m))){var T=y(k,n);return g(s),T}b(s,"invalid usage")}function le(e,r,a,_){var n=[];l(_);var s=d(e=x(n,e,"message")),c=e.length;n.push(s),r=x(n,r,"nonce");var o,h=0|t._crypto_box_curve25519xchacha20poly1305_noncebytes();r.length!==h&&f(n,"invalid nonce length"),o=d(r),n.push(o),a=x(n,a,"sharedKey");var p,i=0|t._crypto_box_curve25519xchacha20poly1305_beforenmbytes();a.length!==i&&f(n,"invalid sharedKey length"),p=d(a),n.push(p);var v=new u(c+t._crypto_box_curve25519xchacha20poly1305_macbytes()|0),m=v.address;if(n.push(m),0==(0|t._crypto_box_curve25519xchacha20poly1305_easy_afternm(m,s,c,0,o,p))){var E=y(v,_);return g(n),E}b(n,"invalid usage")}function ue(e){var r=[];l(e);var a=new u(0|t._crypto_box_curve25519xchacha20poly1305_publickeybytes()),_=a.address;r.push(_);var n=new u(0|t._crypto_box_curve25519xchacha20poly1305_secretkeybytes()),s=n.address;r.push(s),t._crypto_box_curve25519xchacha20poly1305_keypair(_,s);var c=y({publicKey:a,privateKey:n,keyType:"curve25519"},e);return g(r),c}function de(e,r,a,_,n,s){var c=[];l(s);var o=d(e=x(c,e,"ciphertext")),h=e.length;c.push(o),r=x(c,r,"mac");var p,i=0|t._crypto_box_curve25519xchacha20poly1305_macbytes();r.length!==i&&f(c,"invalid mac length"),p=d(r),c.push(p),a=x(c,a,"nonce");var v,m=0|t._crypto_box_curve25519xchacha20poly1305_noncebytes();a.length!==m&&f(c,"invalid nonce length"),v=d(a),c.push(v),_=x(c,_,"publicKey");var E,k=0|t._crypto_box_curve25519xchacha20poly1305_publickeybytes();_.length!==k&&f(c,"invalid publicKey length"),E=d(_),c.push(E),n=x(c,n,"privateKey");var S,T=0|t._crypto_box_curve25519xchacha20poly1305_secretkeybytes();n.length!==T&&f(c,"invalid privateKey length"),S=d(n),c.push(S);var w=new u(0|h),Y=w.address;if(c.push(Y),0==(0|t._crypto_box_curve25519xchacha20poly1305_open_detached(Y,o,p,h,0,v,E,S))){var B=y(w,s);return g(c),B}b(c,"incorrect key pair for the given ciphertext")}function ve(e,r,a,_,n){var s=[];l(n);var c=d(e=x(s,e,"ciphertext")),o=e.length;s.push(c),r=x(s,r,"mac");var h,p=0|t._crypto_box_curve25519xchacha20poly1305_macbytes();r.length!==p&&f(s,"invalid mac length"),h=d(r),s.push(h),a=x(s,a,"nonce");var i,v=0|t._crypto_box_curve25519xchacha20poly1305_noncebytes();a.length!==v&&f(s,"invalid nonce length"),i=d(a),s.push(i),_=x(s,_,"sharedKey");var m,E=0|t._crypto_box_curve25519xchacha20poly1305_beforenmbytes();_.length!==E&&f(s,"invalid sharedKey length"),m=d(_),s.push(m);var k=new u(0|o),S=k.address;if(s.push(S),0==(0|t._crypto_box_curve25519xchacha20poly1305_open_detached_afternm(S,c,h,o,0,i,m))){var T=y(k,n);return g(s),T}b(s,"incorrect secret key for the given ciphertext")}function ge(e,r,a,_,n){var s=[];l(n),e=x(s,e,"ciphertext");var c,o=t._crypto_box_curve25519xchacha20poly1305_macbytes(),h=e.length;h<o&&f(s,"ciphertext is too short"),c=d(e),s.push(c),r=x(s,r,"nonce");var p,i=0|t._crypto_box_curve25519xchacha20poly1305_noncebytes();r.length!==i&&f(s,"invalid nonce length"),p=d(r),s.push(p),a=x(s,a,"publicKey");var v,m=0|t._crypto_box_curve25519xchacha20poly1305_publickeybytes();a.length!==m&&f(s,"invalid publicKey length"),v=d(a),s.push(v),_=x(s,_,"privateKey");var E,k=0|t._crypto_box_curve25519xchacha20poly1305_secretkeybytes();_.length!==k&&f(s,"invalid privateKey length"),E=d(_),s.push(E);var S=new u(h-t._crypto_box_curve25519xchacha20poly1305_macbytes()|0),T=S.address;if(s.push(T),0==(0|t._crypto_box_curve25519xchacha20poly1305_open_easy(T,c,h,0,p,v,E))){var w=y(S,n);return g(s),w}b(s,"incorrect key pair for the given ciphertext")}function be(e,r,a,_){var n=[];l(_);var s=d(e=x(n,e,"ciphertext")),c=e.length;n.push(s),r=x(n,r,"nonce");var o,h=0|t._crypto_box_curve25519xchacha20poly1305_noncebytes();r.length!==h&&f(n,"invalid nonce length"),o=d(r),n.push(o),a=x(n,a,"sharedKey");var p,i=0|t._crypto_box_curve25519xchacha20poly1305_beforenmbytes();a.length!==i&&f(n,"invalid sharedKey length"),p=d(a),n.push(p);var v=new u(c-t._crypto_box_curve25519xchacha20poly1305_macbytes()|0),m=v.address;if(n.push(m),0==(0|t._crypto_box_curve25519xchacha20poly1305_open_easy_afternm(m,s,c,0,o,p))){var E=y(v,_);return g(n),E}b(n,"incorrect secret key for the given ciphertext")}function fe(e,r,a){var _=[];l(a);var n=d(e=x(_,e,"message")),s=e.length;_.push(n),r=x(_,r,"publicKey");var c,o=0|t._crypto_box_curve25519xchacha20poly1305_publickeybytes();r.length!==o&&f(_,"invalid publicKey length"),c=d(r),_.push(c);var h=new u(s+t._crypto_box_curve25519xchacha20poly1305_sealbytes()|0),p=h.address;_.push(p),t._crypto_box_curve25519xchacha20poly1305_seal(p,n,s,0,c);var i=y(h,a);return g(_),i}function me(e,r,a,_){var n=[];l(_),e=x(n,e,"ciphertext");var s,c=t._crypto_box_curve25519xchacha20poly1305_sealbytes(),o=e.length;o<c&&f(n,"ciphertext is too short"),s=d(e),n.push(s),r=x(n,r,"publicKey");var h,p=0|t._crypto_box_curve25519xchacha20poly1305_publickeybytes();r.length!==p&&f(n,"invalid publicKey length"),h=d(r),n.push(h),a=x(n,a,"secretKey");var i,v=0|t._crypto_box_curve25519xchacha20poly1305_secretkeybytes();a.length!==v&&f(n,"invalid secretKey length"),i=d(a),n.push(i);var b=new u(o-t._crypto_box_curve25519xchacha20poly1305_sealbytes()|0),m=b.address;n.push(m),t._crypto_box_curve25519xchacha20poly1305_seal_open(m,s,o,0,h,i);var E=y(b,_);return g(n),E}function xe(e,r){var a=[];l(r),e=x(a,e,"seed");var _,n=0|t._crypto_box_curve25519xchacha20poly1305_seedbytes();e.length!==n&&f(a,"invalid seed length"),_=d(e),a.push(_);var s=new u(0|t._crypto_box_curve25519xchacha20poly1305_publickeybytes()),c=s.address;a.push(c);var o=new u(0|t._crypto_box_curve25519xchacha20poly1305_secretkeybytes()),h=o.address;if(a.push(h),0==(0|t._crypto_box_curve25519xchacha20poly1305_seed_keypair(c,h,_))){var p={publicKey:y(s,r),privateKey:y(o,r),keyType:"x25519"};return g(a),p}b(a,"invalid usage")}function Ee(e,r,a,_,n){var s=[];l(n);var c=d(e=x(s,e,"message")),o=e.length;s.push(c),r=x(s,r,"nonce");var h,p=0|t._crypto_box_noncebytes();r.length!==p&&f(s,"invalid nonce length"),h=d(r),s.push(h),a=x(s,a,"publicKey");var i,v=0|t._crypto_box_publickeybytes();a.length!==v&&f(s,"invalid publicKey length"),i=d(a),s.push(i),_=x(s,_,"privateKey");var m,E=0|t._crypto_box_secretkeybytes();_.length!==E&&f(s,"invalid privateKey length"),m=d(_),s.push(m);var k=new u(0|o),S=k.address;s.push(S);var T=new u(0|t._crypto_box_macbytes()),w=T.address;if(s.push(w),0==(0|t._crypto_box_detached(S,w,c,o,0,h,i,m))){var Y=y({ciphertext:k,mac:T},n);return g(s),Y}b(s,"invalid usage")}function ke(e,r,a,_,n){var s=[];l(n);var c=d(e=x(s,e,"message")),o=e.length;s.push(c),r=x(s,r,"nonce");var h,p=0|t._crypto_box_noncebytes();r.length!==p&&f(s,"invalid nonce length"),h=d(r),s.push(h),a=x(s,a,"publicKey");var i,v=0|t._crypto_box_publickeybytes();a.length!==v&&f(s,"invalid publicKey length"),i=d(a),s.push(i),_=x(s,_,"privateKey");var m,E=0|t._crypto_box_secretkeybytes();_.length!==E&&f(s,"invalid privateKey length"),m=d(_),s.push(m);var k=new u(o+t._crypto_box_macbytes()|0),S=k.address;if(s.push(S),0==(0|t._crypto_box_easy(S,c,o,0,h,i,m))){var T=y(k,n);return g(s),T}b(s,"invalid usage")}function Se(e,r,a,_){var n=[];l(_);var s=d(e=x(n,e,"message")),c=e.length;n.push(s),r=x(n,r,"nonce");var o,h=0|t._crypto_box_noncebytes();r.length!==h&&f(n,"invalid nonce length"),o=d(r),n.push(o),a=x(n,a,"sharedKey");var p,i=0|t._crypto_box_beforenmbytes();a.length!==i&&f(n,"invalid sharedKey length"),p=d(a),n.push(p);var v=new u(c+t._crypto_box_macbytes()|0),m=v.address;if(n.push(m),0==(0|t._crypto_box_easy_afternm(m,s,c,0,o,p))){var E=y(v,_);return g(n),E}b(n,"invalid usage")}function Te(e){var r=[];l(e);var a=new u(0|t._crypto_box_publickeybytes()),_=a.address;r.push(_);var n=new u(0|t._crypto_box_secretkeybytes()),s=n.address;if(r.push(s),0==(0|t._crypto_box_keypair(_,s))){var c={publicKey:y(a,e),privateKey:y(n,e),keyType:"x25519"};return g(r),c}b(r,"internal error")}function we(e,r,a,_,n,s){var c=[];l(s);var o=d(e=x(c,e,"ciphertext")),h=e.length;c.push(o),r=x(c,r,"mac");var p,i=0|t._crypto_box_macbytes();r.length!==i&&f(c,"invalid mac length"),p=d(r),c.push(p),a=x(c,a,"nonce");var v,m=0|t._crypto_box_noncebytes();a.length!==m&&f(c,"invalid nonce length"),v=d(a),c.push(v),_=x(c,_,"publicKey");var E,k=0|t._crypto_box_publickeybytes();_.length!==k&&f(c,"invalid publicKey length"),E=d(_),c.push(E),n=x(c,n,"privateKey");var S,T=0|t._crypto_box_secretkeybytes();n.length!==T&&f(c,"invalid privateKey length"),S=d(n),c.push(S);var w=new u(0|h),Y=w.address;if(c.push(Y),0==(0|t._crypto_box_open_detached(Y,o,p,h,0,v,E,S))){var B=y(w,s);return g(c),B}b(c,"incorrect key pair for the given ciphertext")}function Ye(e,r,a,_,n){var s=[];l(n),e=x(s,e,"ciphertext");var c,o=t._crypto_box_macbytes(),h=e.length;h<o&&f(s,"ciphertext is too short"),c=d(e),s.push(c),r=x(s,r,"nonce");var p,i=0|t._crypto_box_noncebytes();r.length!==i&&f(s,"invalid nonce length"),p=d(r),s.push(p),a=x(s,a,"publicKey");var v,m=0|t._crypto_box_publickeybytes();a.length!==m&&f(s,"invalid publicKey length"),v=d(a),s.push(v),_=x(s,_,"privateKey");var E,k=0|t._crypto_box_secretkeybytes();_.length!==k&&f(s,"invalid privateKey length"),E=d(_),s.push(E);var S=new u(h-t._crypto_box_macbytes()|0),T=S.address;if(s.push(T),0==(0|t._crypto_box_open_easy(T,c,h,0,p,v,E))){var w=y(S,n);return g(s),w}b(s,"incorrect key pair for the given ciphertext")}function Be(e,r,a,_){var n=[];l(_);var s=d(e=x(n,e,"ciphertext")),c=e.length;n.push(s),r=x(n,r,"nonce");var o,h=0|t._crypto_box_noncebytes();r.length!==h&&f(n,"invalid nonce length"),o=d(r),n.push(o),a=x(n,a,"sharedKey");var p,i=0|t._crypto_box_beforenmbytes();a.length!==i&&f(n,"invalid sharedKey length"),p=d(a),n.push(p);var v=new u(c-t._crypto_box_macbytes()|0),m=v.address;if(n.push(m),0==(0|t._crypto_box_open_easy_afternm(m,s,c,0,o,p))){var E=y(v,_);return g(n),E}b(n,"incorrect secret key for the given ciphertext")}function Ae(e,r,a){var _=[];l(a);var n=d(e=x(_,e,"message")),s=e.length;_.push(n),r=x(_,r,"publicKey");var c,o=0|t._crypto_box_publickeybytes();r.length!==o&&f(_,"invalid publicKey length"),c=d(r),_.push(c);var h=new u(s+t._crypto_box_sealbytes()|0),p=h.address;if(_.push(p),0==(0|t._crypto_box_seal(p,n,s,0,c))){var i=y(h,a);return g(_),i}b(_,"invalid usage")}function Ke(e,r,a,_){var n=[];l(_),e=x(n,e,"ciphertext");var s,c=t._crypto_box_sealbytes(),o=e.length;o<c&&f(n,"ciphertext is too short"),s=d(e),n.push(s),r=x(n,r,"publicKey");var h,p=0|t._crypto_box_publickeybytes();r.length!==p&&f(n,"invalid publicKey length"),h=d(r),n.push(h),a=x(n,a,"privateKey");var i,v=0|t._crypto_box_secretkeybytes();a.length!==v&&f(n,"invalid privateKey length"),i=d(a),n.push(i);var m=new u(o-t._crypto_box_sealbytes()|0),E=m.address;if(n.push(E),0==(0|t._crypto_box_seal_open(E,s,o,0,h,i))){var k=y(m,_);return g(n),k}b(n,"incorrect key pair for the given ciphertext")}function Me(e,r){var a=[];l(r),e=x(a,e,"seed");var _,n=0|t._crypto_box_seedbytes();e.length!==n&&f(a,"invalid seed length"),_=d(e),a.push(_);var s=new u(0|t._crypto_box_publickeybytes()),c=s.address;a.push(c);var o=new u(0|t._crypto_box_secretkeybytes()),h=o.address;if(a.push(h),0==(0|t._crypto_box_seed_keypair(c,h,_))){var p={publicKey:y(s,r),privateKey:y(o,r),keyType:"x25519"};return g(a),p}b(a,"invalid usage")}function Ie(e,r,a){var _=[];l(a),e=x(_,e,"p");var n,s=0|t._crypto_core_ed25519_bytes();e.length!==s&&f(_,"invalid p length"),n=d(e),_.push(n),r=x(_,r,"q");var c,o=0|t._crypto_core_ed25519_bytes();r.length!==o&&f(_,"invalid q length"),c=d(r),_.push(c);var h=new u(0|t._crypto_core_ed25519_bytes()),p=h.address;if(_.push(p),0==(0|t._crypto_core_ed25519_add(p,n,c))){var i=y(h,a);return g(_),i}b(_,"input is an invalid element")}function Ne(e,r){var a=[];l(r);var _=d(e=x(a,e,"r"));e.length,a.push(_);var n=new u(0|t._crypto_core_ed25519_bytes()),s=n.address;if(a.push(s),0==(0|t._crypto_core_ed25519_from_hash(s,_))){var c=y(n,r);return g(a),c}b(a,"invalid usage")}function Le(e,r){var a=[];l(r);var _=d(e=x(a,e,"r"));e.length,a.push(_);var n=new u(0|t._crypto_core_ed25519_bytes()),s=n.address;if(a.push(s),0==(0|t._crypto_core_ed25519_from_uniform(s,_))){var c=y(n,r);return g(a),c}b(a,"invalid usage")}function Ue(e,r){var a=[];l(r),e=x(a,e,"repr");var _,n=0|t._crypto_core_ed25519_bytes();e.length!==n&&f(a,"invalid repr length"),_=d(e),a.push(_);var s=1==(0|t._crypto_core_ed25519_is_valid_point(_));return g(a),s}function Oe(e){var r=[];l(e);var a=new u(0|t._crypto_core_ed25519_bytes()),_=a.address;r.push(_),t._crypto_core_ed25519_random(_);var n=y(a,e);return g(r),n}function Ce(e,r,a){var _=[];l(a),e=x(_,e,"x");var n,s=0|t._crypto_core_ed25519_scalarbytes();e.length!==s&&f(_,"invalid x length"),n=d(e),_.push(n),r=x(_,r,"y");var c,o=0|t._crypto_core_ed25519_scalarbytes();r.length!==o&&f(_,"invalid y length"),c=d(r),_.push(c);var h=new u(0|t._crypto_core_ed25519_scalarbytes()),p=h.address;_.push(p),t._crypto_core_ed25519_scalar_add(p,n,c);var i=y(h,a);return g(_),i}function Re(e,r){var a=[];l(r),e=x(a,e,"s");var _,n=0|t._crypto_core_ed25519_scalarbytes();e.length!==n&&f(a,"invalid s length"),_=d(e),a.push(_);var s=new u(0|t._crypto_core_ed25519_scalarbytes()),c=s.address;a.push(c),t._crypto_core_ed25519_scalar_complement(c,_);var o=y(s,r);return g(a),o}function Pe(e,r){var a=[];l(r),e=x(a,e,"s");var _,n=0|t._crypto_core_ed25519_scalarbytes();e.length!==n&&f(a,"invalid s length"),_=d(e),a.push(_);var s=new u(0|t._crypto_core_ed25519_scalarbytes()),c=s.address;if(a.push(c),0==(0|t._crypto_core_ed25519_scalar_invert(c,_))){var o=y(s,r);return g(a),o}b(a,"invalid reciprocate")}function Ge(e,r,a){var _=[];l(a),e=x(_,e,"x");var n,s=0|t._crypto_core_ed25519_scalarbytes();e.length!==s&&f(_,"invalid x length"),n=d(e),_.push(n),r=x(_,r,"y");var c,o=0|t._crypto_core_ed25519_scalarbytes();r.length!==o&&f(_,"invalid y length"),c=d(r),_.push(c);var h=new u(0|t._crypto_core_ed25519_scalarbytes()),p=h.address;_.push(p),t._crypto_core_ed25519_scalar_mul(p,n,c);var i=y(h,a);return g(_),i}function Xe(e,r){var a=[];l(r),e=x(a,e,"s");var _,n=0|t._crypto_core_ed25519_scalarbytes();e.length!==n&&f(a,"invalid s length"),_=d(e),a.push(_);var s=new u(0|t._crypto_core_ed25519_scalarbytes()),c=s.address;a.push(c),t._crypto_core_ed25519_scalar_negate(c,_);var o=y(s,r);return g(a),o}function De(e){var r=[];l(e);var a=new u(0|t._crypto_core_ed25519_scalarbytes()),_=a.address;r.push(_),t._crypto_core_ed25519_scalar_random(_);var n=y(a,e);return g(r),n}function Fe(e,r){var a=[];l(r),e=x(a,e,"sample");var _,n=0|t._crypto_core_ed25519_nonreducedscalarbytes();e.length!==n&&f(a,"invalid sample length"),_=d(e),a.push(_);var s=new u(0|t._crypto_core_ed25519_scalarbytes()),c=s.address;a.push(c),t._crypto_core_ed25519_scalar_reduce(c,_);var o=y(s,r);return g(a),o}function Ve(e,r,a){var _=[];l(a),e=x(_,e,"x");var n,s=0|t._crypto_core_ed25519_scalarbytes();e.length!==s&&f(_,"invalid x length"),n=d(e),_.push(n),r=x(_,r,"y");var c,o=0|t._crypto_core_ed25519_scalarbytes();r.length!==o&&f(_,"invalid y length"),c=d(r),_.push(c);var h=new u(0|t._crypto_core_ed25519_scalarbytes()),p=h.address;_.push(p),t._crypto_core_ed25519_scalar_sub(p,n,c);var i=y(h,a);return g(_),i}function He(e,r,a){var _=[];l(a),e=x(_,e,"p");var n,s=0|t._crypto_core_ed25519_bytes();e.length!==s&&f(_,"invalid p length"),n=d(e),_.push(n),r=x(_,r,"q");var c,o=0|t._crypto_core_ed25519_bytes();r.length!==o&&f(_,"invalid q length"),c=d(r),_.push(c);var h=new u(0|t._crypto_core_ed25519_bytes()),p=h.address;if(_.push(p),0==(0|t._crypto_core_ed25519_sub(p,n,c))){var i=y(h,a);return g(_),i}b(_,"input is an invalid element")}function qe(e,r,a,_){var n=[];l(_),e=x(n,e,"input");var s,c=0|t._crypto_core_hchacha20_inputbytes();e.length!==c&&f(n,"invalid input length"),s=d(e),n.push(s),r=x(n,r,"privateKey");var o,h=0|t._crypto_core_hchacha20_keybytes();r.length!==h&&f(n,"invalid privateKey length"),o=d(r),n.push(o);var p=null;null!=a&&(p=d(a=x(n,a,"constant")),a.length,n.push(p));var i=new u(0|t._crypto_core_hchacha20_outputbytes()),v=i.address;if(n.push(v),0==(0|t._crypto_core_hchacha20(v,s,o,p))){var m=y(i,_);return g(n),m}b(n,"invalid usage")}function je(e,r,a,_){var n=[];l(_),e=x(n,e,"input");var s,c=0|t._crypto_core_hsalsa20_inputbytes();e.length!==c&&f(n,"invalid input length"),s=d(e),n.push(s),r=x(n,r,"privateKey");var o,h=0|t._crypto_core_hsalsa20_keybytes();r.length!==h&&f(n,"invalid privateKey length"),o=d(r),n.push(o);var p=null;null!=a&&(p=d(a=x(n,a,"constant")),a.length,n.push(p));var i=new u(0|t._crypto_core_hsalsa20_outputbytes()),v=i.address;if(n.push(v),0==(0|t._crypto_core_hsalsa20(v,s,o,p))){var m=y(i,_);return g(n),m}b(n,"invalid usage")}function ze(e,r,a){var _=[];l(a),e=x(_,e,"p");var n,s=0|t._crypto_core_ristretto255_bytes();e.length!==s&&f(_,"invalid p length"),n=d(e),_.push(n),r=x(_,r,"q");var c,o=0|t._crypto_core_ristretto255_bytes();r.length!==o&&f(_,"invalid q length"),c=d(r),_.push(c);var h=new u(0|t._crypto_core_ristretto255_bytes()),p=h.address;if(_.push(p),0==(0|t._crypto_core_ristretto255_add(p,n,c))){var i=y(h,a);return g(_),i}b(_,"input is an invalid element")}function We(e,r){var a=[];l(r);var _=d(e=x(a,e,"r"));e.length,a.push(_);var n=new u(0|t._crypto_core_ristretto255_bytes()),s=n.address;if(a.push(s),0==(0|t._crypto_core_ristretto255_from_hash(s,_))){var c=y(n,r);return g(a),c}b(a,"invalid usage")}function Je(e,r){var a=[];l(r),e=x(a,e,"repr");var _,n=0|t._crypto_core_ristretto255_bytes();e.length!==n&&f(a,"invalid repr length"),_=d(e),a.push(_);var s=1==(0|t._crypto_core_ristretto255_is_valid_point(_));return g(a),s}function Qe(e){var r=[];l(e);var a=new u(0|t._crypto_core_ristretto255_bytes()),_=a.address;r.push(_),t._crypto_core_ristretto255_random(_);var n=y(a,e);return g(r),n}function Ze(e,r,a){var _=[];l(a),e=x(_,e,"x");var n,s=0|t._crypto_core_ristretto255_scalarbytes();e.length!==s&&f(_,"invalid x length"),n=d(e),_.push(n),r=x(_,r,"y");var c,o=0|t._crypto_core_ristretto255_scalarbytes();r.length!==o&&f(_,"invalid y length"),c=d(r),_.push(c);var h=new u(0|t._crypto_core_ristretto255_scalarbytes()),p=h.address;_.push(p),t._crypto_core_ristretto255_scalar_add(p,n,c);var i=y(h,a);return g(_),i}function $e(e,r){var a=[];l(r),e=x(a,e,"s");var _,n=0|t._crypto_core_ristretto255_scalarbytes();e.length!==n&&f(a,"invalid s length"),_=d(e),a.push(_);var s=new u(0|t._crypto_core_ristretto255_scalarbytes()),c=s.address;a.push(c),t._crypto_core_ristretto255_scalar_complement(c,_);var o=y(s,r);return g(a),o}function er(e,r){var a=[];l(r),e=x(a,e,"s");var _,n=0|t._crypto_core_ristretto255_scalarbytes();e.length!==n&&f(a,"invalid s length"),_=d(e),a.push(_);var s=new u(0|t._crypto_core_ristretto255_scalarbytes()),c=s.address;if(a.push(c),0==(0|t._crypto_core_ristretto255_scalar_invert(c,_))){var o=y(s,r);return g(a),o}b(a,"invalid reciprocate")}function rr(e,r,a){var _=[];l(a),e=x(_,e,"x");var n,s=0|t._crypto_core_ristretto255_scalarbytes();e.length!==s&&f(_,"invalid x length"),n=d(e),_.push(n),r=x(_,r,"y");var c,o=0|t._crypto_core_ristretto255_scalarbytes();r.length!==o&&f(_,"invalid y length"),c=d(r),_.push(c);var h=new u(0|t._crypto_core_ristretto255_scalarbytes()),p=h.address;_.push(p),t._crypto_core_ristretto255_scalar_mul(p,n,c);var i=y(h,a);return g(_),i}function tr(e,r){var a=[];l(r),e=x(a,e,"s");var _,n=0|t._crypto_core_ristretto255_scalarbytes();e.length!==n&&f(a,"invalid s length"),_=d(e),a.push(_);var s=new u(0|t._crypto_core_ristretto255_scalarbytes()),c=s.address;a.push(c),t._crypto_core_ristretto255_scalar_negate(c,_);var o=y(s,r);return g(a),o}function ar(e){var r=[];l(e);var a=new u(0|t._crypto_core_ristretto255_scalarbytes()),_=a.address;r.push(_),t._crypto_core_ristretto255_scalar_random(_);var n=y(a,e);return g(r),n}function _r(e,r){var a=[];l(r),e=x(a,e,"sample");var _,n=0|t._crypto_core_ristretto255_nonreducedscalarbytes();e.length!==n&&f(a,"invalid sample length"),_=d(e),a.push(_);var s=new u(0|t._crypto_core_ristretto255_scalarbytes()),c=s.address;a.push(c),t._crypto_core_ristretto255_scalar_reduce(c,_);var o=y(s,r);return g(a),o}function nr(e,r,a){var _=[];l(a),e=x(_,e,"x");var n,s=0|t._crypto_core_ristretto255_scalarbytes();e.length!==s&&f(_,"invalid x length"),n=d(e),_.push(n),r=x(_,r,"y");var c,o=0|t._crypto_core_ristretto255_scalarbytes();r.length!==o&&f(_,"invalid y length"),c=d(r),_.push(c);var h=new u(0|t._crypto_core_ristretto255_scalarbytes()),p=h.address;_.push(p),t._crypto_core_ristretto255_scalar_sub(p,n,c);var i=y(h,a);return g(_),i}function sr(e,r,a){var _=[];l(a),e=x(_,e,"p");var n,s=0|t._crypto_core_ristretto255_bytes();e.length!==s&&f(_,"invalid p length"),n=d(e),_.push(n),r=x(_,r,"q");var c,o=0|t._crypto_core_ristretto255_bytes();r.length!==o&&f(_,"invalid q length"),c=d(r),_.push(c);var h=new u(0|t._crypto_core_ristretto255_bytes()),p=h.address;if(_.push(p),0==(0|t._crypto_core_ristretto255_sub(p,n,c))){var i=y(h,a);return g(_),i}b(_,"input is an invalid element")}function cr(e,r,a,_){var n=[];l(_),m(n,e,"hash_length"),("number"!=typeof e||(0|e)!==e||e<0)&&f(n,"hash_length must be an unsigned integer");var s=d(r=x(n,r,"message")),c=r.length;n.push(s);var o=null,h=0;null!=a&&(o=d(a=x(n,a,"key")),h=a.length,n.push(o));var p=new u(e|=0),i=p.address;if(n.push(i),0==(0|t._crypto_generichash(i,e,s,c,0,o,h))){var v=y(p,_);return g(n),v}b(n,"invalid usage")}function or(e,r,a,_,n){var s=[];l(n),m(s,e,"subkey_len"),("number"!=typeof e||(0|e)!==e||e<0)&&f(s,"subkey_len must be an unsigned integer");var c=null,o=0;null!=r&&(c=d(r=x(s,r,"key")),o=r.length,s.push(c));var h=null,p=0;null!=a&&(a=x(s,a,"id"),p=0|t._crypto_generichash_blake2b_saltbytes(),a.length!==p&&f(s,"invalid id length"),h=d(a),s.push(h));var i=null,v=0;null!=_&&(_=x(s,_,"ctx"),v=0|t._crypto_generichash_blake2b_personalbytes(),_.length!==v&&f(s,"invalid ctx length"),i=d(_),s.push(i));var E=new u(0|e),k=E.address;if(s.push(k),0==(0|t._crypto_generichash_blake2b_salt_personal(k,e,null,0,0,c,o,h,i))){var S=y(E,n);return g(s),S}b(s,"invalid usage")}function hr(e,r,a){var _=[];l(a),m(_,e,"state_address"),m(_,r,"hash_length"),("number"!=typeof r||(0|r)!==r||r<0)&&f(_,"hash_length must be an unsigned integer");var n=new u(r|=0),s=n.address;if(_.push(s),0==(0|t._crypto_generichash_final(e,s,r))){var c=(t._free(e),y(n,a));return g(_),c}b(_,"invalid usage")}function pr(e,r,a){var _=[];l(a);var n=null,s=0;null!=e&&(n=d(e=x(_,e,"key")),s=e.length,_.push(n)),m(_,r,"hash_length"),("number"!=typeof r||(0|r)!==r||r<0)&&f(_,"hash_length must be an unsigned integer");var c=new u(357).address;if(0==(0|t._crypto_generichash_init(c,n,s,r))){var o=c;return g(_),o}b(_,"invalid usage")}function yr(e){var r=[];l(e);var a=new u(0|t._crypto_generichash_keybytes()),_=a.address;r.push(_),t._crypto_generichash_keygen(_);var n=y(a,e);return g(r),n}function ir(e,r,a){var _=[];l(a),m(_,e,"state_address");var n=d(r=x(_,r,"message_chunk")),s=r.length;_.push(n),0!=(0|t._crypto_generichash_update(e,n,s))&&b(_,"invalid usage"),g(_)}function lr(e,r){var a=[];l(r);var _=d(e=x(a,e,"message")),n=e.length;a.push(_);var s=new u(0|t._crypto_hash_bytes()),c=s.address;if(a.push(c),0==(0|t._crypto_hash(c,_,n,0))){var o=y(s,r);return g(a),o}b(a,"invalid usage")}function ur(e,r){var a=[];l(r);var _=d(e=x(a,e,"message")),n=e.length;a.push(_);var s=new u(0|t._crypto_hash_sha256_bytes()),c=s.address;if(a.push(c),0==(0|t._crypto_hash_sha256(c,_,n,0))){var o=y(s,r);return g(a),o}b(a,"invalid usage")}function dr(e,r){var a=[];l(r),m(a,e,"state_address");var _=new u(0|t._crypto_hash_sha256_bytes()),n=_.address;if(a.push(n),0==(0|t._crypto_hash_sha256_final(e,n))){var s=(t._free(e),y(_,r));return g(a),s}b(a,"invalid usage")}function vr(e){var r=[];l(e);var a=new u(104).address;if(0==(0|t._crypto_hash_sha256_init(a))){var _=a;return g(r),_}b(r,"invalid usage")}function gr(e,r,a){var _=[];l(a),m(_,e,"state_address");var n=d(r=x(_,r,"message_chunk")),s=r.length;_.push(n),0!=(0|t._crypto_hash_sha256_update(e,n,s))&&b(_,"invalid usage"),g(_)}function br(e,r){var a=[];l(r);var _=d(e=x(a,e,"message")),n=e.length;a.push(_);var s=new u(0|t._crypto_hash_sha512_bytes()),c=s.address;if(a.push(c),0==(0|t._crypto_hash_sha512(c,_,n,0))){var o=y(s,r);return g(a),o}b(a,"invalid usage")}function fr(e,r){var a=[];l(r),m(a,e,"state_address");var _=new u(0|t._crypto_hash_sha512_bytes()),n=_.address;if(a.push(n),0==(0|t._crypto_hash_sha512_final(e,n))){var s=(t._free(e),y(_,r));return g(a),s}b(a,"invalid usage")}function mr(e){var r=[];l(e);var a=new u(208).address;if(0==(0|t._crypto_hash_sha512_init(a))){var _=a;return g(r),_}b(r,"invalid usage")}function xr(e,r,a){var _=[];l(a),m(_,e,"state_address");var n=d(r=x(_,r,"message_chunk")),s=r.length;_.push(n),0!=(0|t._crypto_hash_sha512_update(e,n,s))&&b(_,"invalid usage"),g(_)}function Er(e,r,a,_,s){var c=[];l(s),m(c,e,"subkey_len"),("number"!=typeof e||(0|e)!==e||e<0)&&f(c,"subkey_len must be an unsigned integer"),m(c,r,"subkey_id"),("number"!=typeof r||(0|r)!==r||r<0)&&f(c,"subkey_id must be an unsigned integer"),"string"!=typeof a&&f(c,"ctx must be a string"),a=n(a+"\0"),null!=h&&a.length-1!==h&&f(c,"invalid ctx length");var o=d(a),h=a.length-1;c.push(o),_=x(c,_,"key");var p,i=0|t._crypto_kdf_keybytes();_.length!==i&&f(c,"invalid key length"),p=d(_),c.push(p);var v=new u(0|e),b=v.address;c.push(b),t._crypto_kdf_derive_from_key(b,e,r,r>>>24>>>8,o,p);var E=y(v,s);return g(c),E}function kr(e){var r=[];l(e);var a=new u(0|t._crypto_kdf_keybytes()),_=a.address;r.push(_),t._crypto_kdf_keygen(_);var n=y(a,e);return g(r),n}function Sr(e,r,a,_){var n=[];l(_),e=x(n,e,"clientPublicKey");var s,c=0|t._crypto_kx_publickeybytes();e.length!==c&&f(n,"invalid clientPublicKey length"),s=d(e),n.push(s),r=x(n,r,"clientSecretKey");var o,h=0|t._crypto_kx_secretkeybytes();r.length!==h&&f(n,"invalid clientSecretKey length"),o=d(r),n.push(o),a=x(n,a,"serverPublicKey");var p,i=0|t._crypto_kx_publickeybytes();a.length!==i&&f(n,"invalid serverPublicKey length"),p=d(a),n.push(p);var v=new u(0|t._crypto_kx_sessionkeybytes()),m=v.address;n.push(m);var E=new u(0|t._crypto_kx_sessionkeybytes()),k=E.address;if(n.push(k),0==(0|t._crypto_kx_client_session_keys(m,k,s,o,p))){var S=y({sharedRx:v,sharedTx:E},_);return g(n),S}b(n,"invalid usage")}function Tr(e){var r=[];l(e);var a=new u(0|t._crypto_kx_publickeybytes()),_=a.address;r.push(_);var n=new u(0|t._crypto_kx_secretkeybytes()),s=n.address;if(r.push(s),0==(0|t._crypto_kx_keypair(_,s))){var c={publicKey:y(a,e),privateKey:y(n,e),keyType:"x25519"};return g(r),c}b(r,"internal error")}function wr(e,r){var a=[];l(r),e=x(a,e,"seed");var _,n=0|t._crypto_kx_seedbytes();e.length!==n&&f(a,"invalid seed length"),_=d(e),a.push(_);var s=new u(0|t._crypto_kx_publickeybytes()),c=s.address;a.push(c);var o=new u(0|t._crypto_kx_secretkeybytes()),h=o.address;if(a.push(h),0==(0|t._crypto_kx_seed_keypair(c,h,_))){var p={publicKey:y(s,r),privateKey:y(o,r),keyType:"x25519"};return g(a),p}b(a,"internal error")}function Yr(e,r,a,_){var n=[];l(_),e=x(n,e,"serverPublicKey");var s,c=0|t._crypto_kx_publickeybytes();e.length!==c&&f(n,"invalid serverPublicKey length"),s=d(e),n.push(s),r=x(n,r,"serverSecretKey");var o,h=0|t._crypto_kx_secretkeybytes();r.length!==h&&f(n,"invalid serverSecretKey length"),o=d(r),n.push(o),a=x(n,a,"clientPublicKey");var p,i=0|t._crypto_kx_publickeybytes();a.length!==i&&f(n,"invalid clientPublicKey length"),p=d(a),n.push(p);var v=new u(0|t._crypto_kx_sessionkeybytes()),m=v.address;n.push(m);var E=new u(0|t._crypto_kx_sessionkeybytes()),k=E.address;if(n.push(k),0==(0|t._crypto_kx_server_session_keys(m,k,s,o,p))){var S=y({sharedRx:v,sharedTx:E},_);return g(n),S}b(n,"invalid usage")}function Br(e,r,a){var _=[];l(a);var n=d(e=x(_,e,"message")),s=e.length;_.push(n),r=x(_,r,"key");var c,o=0|t._crypto_onetimeauth_keybytes();r.length!==o&&f(_,"invalid key length"),c=d(r),_.push(c);var h=new u(0|t._crypto_onetimeauth_bytes()),p=h.address;if(_.push(p),0==(0|t._crypto_onetimeauth(p,n,s,0,c))){var i=y(h,a);return g(_),i}b(_,"invalid usage")}function Ar(e,r){var a=[];l(r),m(a,e,"state_address");var _=new u(0|t._crypto_onetimeauth_bytes()),n=_.address;if(a.push(n),0==(0|t._crypto_onetimeauth_final(e,n))){var s=(t._free(e),y(_,r));return g(a),s}b(a,"invalid usage")}function Kr(e,r){var a=[];l(r);var _=null;null!=e&&(_=d(e=x(a,e,"key")),e.length,a.push(_));var n=new u(144).address;if(0==(0|t._crypto_onetimeauth_init(n,_))){var s=n;return g(a),s}b(a,"invalid usage")}function Mr(e){var r=[];l(e);var a=new u(0|t._crypto_onetimeauth_keybytes()),_=a.address;r.push(_),t._crypto_onetimeauth_keygen(_);var n=y(a,e);return g(r),n}function Ir(e,r,a){var _=[];l(a),m(_,e,"state_address");var n=d(r=x(_,r,"message_chunk")),s=r.length;_.push(n),0!=(0|t._crypto_onetimeauth_update(e,n,s))&&b(_,"invalid usage"),g(_)}function Nr(e,r,a){var _=[];e=x(_,e,"hash");var n,s=0|t._crypto_onetimeauth_bytes();e.length!==s&&f(_,"invalid hash length"),n=d(e),_.push(n);var c=d(r=x(_,r,"message")),o=r.length;_.push(c),a=x(_,a,"key");var h,p=0|t._crypto_onetimeauth_keybytes();a.length!==p&&f(_,"invalid key length"),h=d(a),_.push(h);var y=0==(0|t._crypto_onetimeauth_verify(n,c,o,0,h));return g(_),y}function Lr(e,r,a,_,n,s,c){var o=[];l(c),m(o,e,"keyLength"),("number"!=typeof e||(0|e)!==e||e<0)&&f(o,"keyLength must be an unsigned integer");var h=d(r=x(o,r,"password")),p=r.length;o.push(h),a=x(o,a,"salt");var i,v=0|t._crypto_pwhash_saltbytes();a.length!==v&&f(o,"invalid salt length"),i=d(a),o.push(i),m(o,_,"opsLimit"),("number"!=typeof _||(0|_)!==_||_<0)&&f(o,"opsLimit must be an unsigned integer"),m(o,n,"memLimit"),("number"!=typeof n||(0|n)!==n||n<0)&&f(o,"memLimit must be an unsigned integer"),m(o,s,"algorithm"),("number"!=typeof s||(0|s)!==s||s<0)&&f(o,"algorithm must be an unsigned integer");var E=new u(0|e),k=E.address;if(o.push(k),0==(0|t._crypto_pwhash(k,e,0,h,p,0,i,_,0,n,s))){var S=y(E,c);return g(o),S}b(o,"invalid usage")}function Ur(e,r,a,_,n,s){var c=[];l(s),m(c,e,"keyLength"),("number"!=typeof e||(0|e)!==e||e<0)&&f(c,"keyLength must be an unsigned integer");var o=d(r=x(c,r,"password")),h=r.length;c.push(o),a=x(c,a,"salt");var p,i=0|t._crypto_pwhash_scryptsalsa208sha256_saltbytes();a.length!==i&&f(c,"invalid salt length"),p=d(a),c.push(p),m(c,_,"opsLimit"),("number"!=typeof _||(0|_)!==_||_<0)&&f(c,"opsLimit must be an unsigned integer"),m(c,n,"memLimit"),("number"!=typeof n||(0|n)!==n||n<0)&&f(c,"memLimit must be an unsigned integer");var v=new u(0|e),E=v.address;if(c.push(E),0==(0|t._crypto_pwhash_scryptsalsa208sha256(E,e,0,o,h,0,p,_,0,n))){var k=y(v,s);return g(c),k}b(c,"invalid usage")}function Or(e,r,a,_,n,s,c){var o=[];l(c);var h=d(e=x(o,e,"password")),p=e.length;o.push(h);var i=d(r=x(o,r,"salt")),v=r.length;o.push(i),m(o,a,"opsLimit"),("number"!=typeof a||(0|a)!==a||a<0)&&f(o,"opsLimit must be an unsigned integer"),m(o,_,"r"),("number"!=typeof _||(0|_)!==_||_<0)&&f(o,"r must be an unsigned integer"),m(o,n,"p"),("number"!=typeof n||(0|n)!==n||n<0)&&f(o,"p must be an unsigned integer"),m(o,s,"keyLength"),("number"!=typeof s||(0|s)!==s||s<0)&&f(o,"keyLength must be an unsigned integer");var E=new u(0|s),k=E.address;if(o.push(k),0==(0|t._crypto_pwhash_scryptsalsa208sha256_ll(h,p,i,v,a,0,_,n,k,s))){var S=y(E,c);return g(o),S}b(o,"invalid usage")}function Cr(e,r,a,_){var n=[];l(_);var s=d(e=x(n,e,"password")),c=e.length;n.push(s),m(n,r,"opsLimit"),("number"!=typeof r||(0|r)!==r||r<0)&&f(n,"opsLimit must be an unsigned integer"),m(n,a,"memLimit"),("number"!=typeof a||(0|a)!==a||a<0)&&f(n,"memLimit must be an unsigned integer");var o=new u(0|t._crypto_pwhash_scryptsalsa208sha256_strbytes()).address;if(n.push(o),0==(0|t._crypto_pwhash_scryptsalsa208sha256_str(o,s,c,0,r,0,a))){var h=t.UTF8ToString(o);return g(n),h}b(n,"invalid usage")}function Rr(e,r,a){var _=[];l(a),"string"!=typeof e&&f(_,"hashed_password must be a string"),e=n(e+"\0"),null!=c&&e.length-1!==c&&f(_,"invalid hashed_password length");var s=d(e),c=e.length-1;_.push(s);var o=d(r=x(_,r,"password")),h=r.length;_.push(o);var p=0==(0|t._crypto_pwhash_scryptsalsa208sha256_str_verify(s,o,h,0));return g(_),p}function Pr(e,r,a,_){var n=[];l(_);var s=d(e=x(n,e,"password")),c=e.length;n.push(s),m(n,r,"opsLimit"),("number"!=typeof r||(0|r)!==r||r<0)&&f(n,"opsLimit must be an unsigned integer"),m(n,a,"memLimit"),("number"!=typeof a||(0|a)!==a||a<0)&&f(n,"memLimit must be an unsigned integer");var o=new u(0|t._crypto_pwhash_strbytes()).address;if(n.push(o),0==(0|t._crypto_pwhash_str(o,s,c,0,r,0,a))){var h=t.UTF8ToString(o);return g(n),h}b(n,"invalid usage")}function Gr(e,r,a,_){var s=[];l(_),"string"!=typeof e&&f(s,"hashed_password must be a string"),e=n(e+"\0"),null!=o&&e.length-1!==o&&f(s,"invalid hashed_password length");var c=d(e),o=e.length-1;s.push(c),m(s,r,"opsLimit"),("number"!=typeof r||(0|r)!==r||r<0)&&f(s,"opsLimit must be an unsigned integer"),m(s,a,"memLimit"),("number"!=typeof a||(0|a)!==a||a<0)&&f(s,"memLimit must be an unsigned integer");var h=0!=(0|t._crypto_pwhash_str_needs_rehash(c,r,0,a));return g(s),h}function Xr(e,r,a){var _=[];l(a),"string"!=typeof e&&f(_,"hashed_password must be a string"),e=n(e+"\0"),null!=c&&e.length-1!==c&&f(_,"invalid hashed_password length");var s=d(e),c=e.length-1;_.push(s);var o=d(r=x(_,r,"password")),h=r.length;_.push(o);var p=0==(0|t._crypto_pwhash_str_verify(s,o,h,0));return g(_),p}function Dr(e,r,a){var _=[];l(a),e=x(_,e,"privateKey");var n,s=0|t._crypto_scalarmult_scalarbytes();e.length!==s&&f(_,"invalid privateKey length"),n=d(e),_.push(n),r=x(_,r,"publicKey");var c,o=0|t._crypto_scalarmult_bytes();r.length!==o&&f(_,"invalid publicKey length"),c=d(r),_.push(c);var h=new u(0|t._crypto_scalarmult_bytes()),p=h.address;if(_.push(p),0==(0|t._crypto_scalarmult(p,n,c))){var i=y(h,a);return g(_),i}b(_,"weak public key")}function Fr(e,r){var a=[];l(r),e=x(a,e,"privateKey");var _,n=0|t._crypto_scalarmult_scalarbytes();e.length!==n&&f(a,"invalid privateKey length"),_=d(e),a.push(_);var s=new u(0|t._crypto_scalarmult_bytes()),c=s.address;if(a.push(c),0==(0|t._crypto_scalarmult_base(c,_))){var o=y(s,r);return g(a),o}b(a,"unknown error")}function Vr(e,r,a){var _=[];l(a),e=x(_,e,"n");var n,s=0|t._crypto_scalarmult_ed25519_scalarbytes();e.length!==s&&f(_,"invalid n length"),n=d(e),_.push(n),r=x(_,r,"p");var c,o=0|t._crypto_scalarmult_ed25519_bytes();r.length!==o&&f(_,"invalid p length"),c=d(r),_.push(c);var h=new u(0|t._crypto_scalarmult_ed25519_bytes()),p=h.address;if(_.push(p),0==(0|t._crypto_scalarmult_ed25519(p,n,c))){var i=y(h,a);return g(_),i}b(_,"invalid point or scalar is 0")}function Hr(e,r){var a=[];l(r),e=x(a,e,"scalar");var _,n=0|t._crypto_scalarmult_ed25519_scalarbytes();e.length!==n&&f(a,"invalid scalar length"),_=d(e),a.push(_);var s=new u(0|t._crypto_scalarmult_ed25519_bytes()),c=s.address;if(a.push(c),0==(0|t._crypto_scalarmult_ed25519_base(c,_))){var o=y(s,r);return g(a),o}b(a,"scalar is 0")}function qr(e,r){var a=[];l(r),e=x(a,e,"scalar");var _,n=0|t._crypto_scalarmult_ed25519_scalarbytes();e.length!==n&&f(a,"invalid scalar length"),_=d(e),a.push(_);var s=new u(0|t._crypto_scalarmult_ed25519_bytes()),c=s.address;if(a.push(c),0==(0|t._crypto_scalarmult_ed25519_base_noclamp(c,_))){var o=y(s,r);return g(a),o}b(a,"scalar is 0")}function jr(e,r,a){var _=[];l(a),e=x(_,e,"n");var n,s=0|t._crypto_scalarmult_ed25519_scalarbytes();e.length!==s&&f(_,"invalid n length"),n=d(e),_.push(n),r=x(_,r,"p");var c,o=0|t._crypto_scalarmult_ed25519_bytes();r.length!==o&&f(_,"invalid p length"),c=d(r),_.push(c);var h=new u(0|t._crypto_scalarmult_ed25519_bytes()),p=h.address;if(_.push(p),0==(0|t._crypto_scalarmult_ed25519_noclamp(p,n,c))){var i=y(h,a);return g(_),i}b(_,"invalid point or scalar is 0")}function zr(e,r,a){var _=[];l(a),e=x(_,e,"scalar");var n,s=0|t._crypto_scalarmult_ristretto255_scalarbytes();e.length!==s&&f(_,"invalid scalar length"),n=d(e),_.push(n),r=x(_,r,"element");var c,o=0|t._crypto_scalarmult_ristretto255_bytes();r.length!==o&&f(_,"invalid element length"),c=d(r),_.push(c);var h=new u(0|t._crypto_scalarmult_ristretto255_bytes()),p=h.address;if(_.push(p),0==(0|t._crypto_scalarmult_ristretto255(p,n,c))){var i=y(h,a);return g(_),i}b(_,"result is identity element")}function Wr(e,r){var a=[];l(r),e=x(a,e,"scalar");var _,n=0|t._crypto_core_ristretto255_scalarbytes();e.length!==n&&f(a,"invalid scalar length"),_=d(e),a.push(_);var s=new u(0|t._crypto_core_ristretto255_bytes()),c=s.address;if(a.push(c),0==(0|t._crypto_scalarmult_ristretto255_base(c,_))){var o=y(s,r);return g(a),o}b(a,"scalar is 0")}function Jr(e,r,a,_){var n=[];l(_);var s=d(e=x(n,e,"message")),c=e.length;n.push(s),r=x(n,r,"nonce");var o,h=0|t._crypto_secretbox_noncebytes();r.length!==h&&f(n,"invalid nonce length"),o=d(r),n.push(o),a=x(n,a,"key");var p,i=0|t._crypto_secretbox_keybytes();a.length!==i&&f(n,"invalid key length"),p=d(a),n.push(p);var v=new u(0|c),m=v.address;n.push(m);var E=new u(0|t._crypto_secretbox_macbytes()),k=E.address;if(n.push(k),0==(0|t._crypto_secretbox_detached(m,k,s,c,0,o,p))){var S=y({mac:E,cipher:v},_);return g(n),S}b(n,"invalid usage")}function Qr(e,r,a,_){var n=[];l(_);var s=d(e=x(n,e,"message")),c=e.length;n.push(s),r=x(n,r,"nonce");var o,h=0|t._crypto_secretbox_noncebytes();r.length!==h&&f(n,"invalid nonce length"),o=d(r),n.push(o),a=x(n,a,"key");var p,i=0|t._crypto_secretbox_keybytes();a.length!==i&&f(n,"invalid key length"),p=d(a),n.push(p);var v=new u(c+t._crypto_secretbox_macbytes()|0),m=v.address;if(n.push(m),0==(0|t._crypto_secretbox_easy(m,s,c,0,o,p))){var E=y(v,_);return g(n),E}b(n,"invalid usage")}function Zr(e){var r=[];l(e);var a=new u(0|t._crypto_secretbox_keybytes()),_=a.address;r.push(_),t._crypto_secretbox_keygen(_);var n=y(a,e);return g(r),n}function $r(e,r,a,_,n){var s=[];l(n);var c=d(e=x(s,e,"ciphertext")),o=e.length;s.push(c),r=x(s,r,"mac");var h,p=0|t._crypto_secretbox_macbytes();r.length!==p&&f(s,"invalid mac length"),h=d(r),s.push(h),a=x(s,a,"nonce");var i,v=0|t._crypto_secretbox_noncebytes();a.length!==v&&f(s,"invalid nonce length"),i=d(a),s.push(i),_=x(s,_,"key");var m,E=0|t._crypto_secretbox_keybytes();_.length!==E&&f(s,"invalid key length"),m=d(_),s.push(m);var k=new u(0|o),S=k.address;if(s.push(S),0==(0|t._crypto_secretbox_open_detached(S,c,h,o,0,i,m))){var T=y(k,n);return g(s),T}b(s,"wrong secret key for the given ciphertext")}function et(e,r,a,_){var n=[];l(_),e=x(n,e,"ciphertext");var s,c=t._crypto_secretbox_macbytes(),o=e.length;o<c&&f(n,"ciphertext is too short"),s=d(e),n.push(s),r=x(n,r,"nonce");var h,p=0|t._crypto_secretbox_noncebytes();r.length!==p&&f(n,"invalid nonce length"),h=d(r),n.push(h),a=x(n,a,"key");var i,v=0|t._crypto_secretbox_keybytes();a.length!==v&&f(n,"invalid key length"),i=d(a),n.push(i);var m=new u(o-t._crypto_secretbox_macbytes()|0),E=m.address;if(n.push(E),0==(0|t._crypto_secretbox_open_easy(E,s,o,0,h,i))){var k=y(m,_);return g(n),k}b(n,"wrong secret key for the given ciphertext")}function rt(e,r,a){var _=[];l(a),e=x(_,e,"header");var n,s=0|t._crypto_secretstream_xchacha20poly1305_headerbytes();e.length!==s&&f(_,"invalid header length"),n=d(e),_.push(n),r=x(_,r,"key");var c,o=0|t._crypto_secretstream_xchacha20poly1305_keybytes();r.length!==o&&f(_,"invalid key length"),c=d(r),_.push(c);var h=new u(52).address;if(0==(0|t._crypto_secretstream_xchacha20poly1305_init_pull(h,n,c))){var p=h;return g(_),p}b(_,"invalid usage")}function tt(e,r){var a=[];l(r),e=x(a,e,"key");var _,n=0|t._crypto_secretstream_xchacha20poly1305_keybytes();e.length!==n&&f(a,"invalid key length"),_=d(e),a.push(_);var s=new u(52).address,c=new u(0|t._crypto_secretstream_xchacha20poly1305_headerbytes()),o=c.address;if(a.push(o),0==(0|t._crypto_secretstream_xchacha20poly1305_init_push(s,o,_))){var h={state:s,header:y(c,r)};return g(a),h}b(a,"invalid usage")}function at(e){var r=[];l(e);var a=new u(0|t._crypto_secretstream_xchacha20poly1305_keybytes()),_=a.address;r.push(_),t._crypto_secretstream_xchacha20poly1305_keygen(_);var n=y(a,e);return g(r),n}function _t(e,r,a,_){var n=[];l(_),m(n,e,"state_address"),r=x(n,r,"cipher");var s,c=t._crypto_secretstream_xchacha20poly1305_abytes(),o=r.length;o<c&&f(n,"cipher is too short"),s=d(r),n.push(s);var h=null,p=0;null!=a&&(h=d(a=x(n,a,"ad")),p=a.length,n.push(h));var i=new u(o-t._crypto_secretstream_xchacha20poly1305_abytes()|0),b=i.address;n.push(b);var E,k=(E=v(1),n.push(E),(k=0===t._crypto_secretstream_xchacha20poly1305_pull(e,b,0,E,s,o,0,h,p)&&{tag:t.HEAPU8[E],message:i})&&{message:y(k.message,_),tag:k.tag});return g(n),k}function nt(e,r,a,_,n){var s=[];l(n),m(s,e,"state_address");var c=d(r=x(s,r,"message_chunk")),o=r.length;s.push(c);var h=null,p=0;null!=a&&(h=d(a=x(s,a,"ad")),p=a.length,s.push(h)),m(s,_,"tag"),("number"!=typeof _||(0|_)!==_||_<0)&&f(s,"tag must be an unsigned integer");var i=new u(o+t._crypto_secretstream_xchacha20poly1305_abytes()|0),v=i.address;if(s.push(v),0==(0|t._crypto_secretstream_xchacha20poly1305_push(e,v,0,c,o,0,h,p,0,_))){var E=y(i,n);return g(s),E}b(s,"invalid usage")}function st(e,r){var a=[];return l(r),m(a,e,"state_address"),t._crypto_secretstream_xchacha20poly1305_rekey(e),g(a),!0}function ct(e,r,a){var _=[];l(a);var n=d(e=x(_,e,"message")),s=e.length;_.push(n),r=x(_,r,"key");var c,o=0|t._crypto_shorthash_keybytes();r.length!==o&&f(_,"invalid key length"),c=d(r),_.push(c);var h=new u(0|t._crypto_shorthash_bytes()),p=h.address;if(_.push(p),0==(0|t._crypto_shorthash(p,n,s,0,c))){var i=y(h,a);return g(_),i}b(_,"invalid usage")}function ot(e){var r=[];l(e);var a=new u(0|t._crypto_shorthash_keybytes()),_=a.address;r.push(_),t._crypto_shorthash_keygen(_);var n=y(a,e);return g(r),n}function ht(e,r,a){var _=[];l(a);var n=d(e=x(_,e,"message")),s=e.length;_.push(n),r=x(_,r,"key");var c,o=0|t._crypto_shorthash_siphashx24_keybytes();r.length!==o&&f(_,"invalid key length"),c=d(r),_.push(c);var h=new u(0|t._crypto_shorthash_siphashx24_bytes()),p=h.address;if(_.push(p),0==(0|t._crypto_shorthash_siphashx24(p,n,s,0,c))){var i=y(h,a);return g(_),i}b(_,"invalid usage")}function pt(e,r,a){var _=[];l(a);var n=d(e=x(_,e,"message")),s=e.length;_.push(n),r=x(_,r,"privateKey");var c,o=0|t._crypto_sign_secretkeybytes();r.length!==o&&f(_,"invalid privateKey length"),c=d(r),_.push(c);var h=new u(e.length+t._crypto_sign_bytes()|0),p=h.address;if(_.push(p),0==(0|t._crypto_sign(p,null,n,s,0,c))){var i=y(h,a);return g(_),i}b(_,"invalid usage")}function yt(e,r,a){var _=[];l(a);var n=d(e=x(_,e,"message")),s=e.length;_.push(n),r=x(_,r,"privateKey");var c,o=0|t._crypto_sign_secretkeybytes();r.length!==o&&f(_,"invalid privateKey length"),c=d(r),_.push(c);var h=new u(0|t._crypto_sign_bytes()),p=h.address;if(_.push(p),0==(0|t._crypto_sign_detached(p,null,n,s,0,c))){var i=y(h,a);return g(_),i}b(_,"invalid usage")}function it(e,r){var a=[];l(r),e=x(a,e,"edPk");var _,n=0|t._crypto_sign_publickeybytes();e.length!==n&&f(a,"invalid edPk length"),_=d(e),a.push(_);var s=new u(0|t._crypto_scalarmult_scalarbytes()),c=s.address;if(a.push(c),0==(0|t._crypto_sign_ed25519_pk_to_curve25519(c,_))){var o=y(s,r);return g(a),o}b(a,"invalid key")}function lt(e,r){var a=[];l(r),e=x(a,e,"edSk");var _,n=0|t._crypto_sign_secretkeybytes();e.length!==n&&f(a,"invalid edSk length"),_=d(e),a.push(_);var s=new u(0|t._crypto_scalarmult_scalarbytes()),c=s.address;if(a.push(c),0==(0|t._crypto_sign_ed25519_sk_to_curve25519(c,_))){var o=y(s,r);return g(a),o}b(a,"invalid key")}function ut(e,r){var a=[];l(r),e=x(a,e,"privateKey");var _,n=0|t._crypto_sign_secretkeybytes();e.length!==n&&f(a,"invalid privateKey length"),_=d(e),a.push(_);var s=new u(0|t._crypto_sign_publickeybytes()),c=s.address;if(a.push(c),0==(0|t._crypto_sign_ed25519_sk_to_pk(c,_))){var o=y(s,r);return g(a),o}b(a,"invalid key")}function dt(e,r){var a=[];l(r),e=x(a,e,"privateKey");var _,n=0|t._crypto_sign_secretkeybytes();e.length!==n&&f(a,"invalid privateKey length"),_=d(e),a.push(_);var s=new u(0|t._crypto_sign_seedbytes()),c=s.address;if(a.push(c),0==(0|t._crypto_sign_ed25519_sk_to_seed(c,_))){var o=y(s,r);return g(a),o}b(a,"invalid key")}function vt(e,r,a){var _=[];l(a),m(_,e,"state_address"),r=x(_,r,"privateKey");var n,s=0|t._crypto_sign_secretkeybytes();r.length!==s&&f(_,"invalid privateKey length"),n=d(r),_.push(n);var c=new u(0|t._crypto_sign_bytes()),o=c.address;if(_.push(o),0==(0|t._crypto_sign_final_create(e,o,null,n))){var h=(t._free(e),y(c,a));return g(_),h}b(_,"invalid usage")}function gt(e,r,a,_){var n=[];l(_),m(n,e,"state_address"),r=x(n,r,"signature");var s,c=0|t._crypto_sign_bytes();r.length!==c&&f(n,"invalid signature length"),s=d(r),n.push(s),a=x(n,a,"publicKey");var o,h=0|t._crypto_sign_publickeybytes();a.length!==h&&f(n,"invalid publicKey length"),o=d(a),n.push(o);var p=0==(0|t._crypto_sign_final_verify(e,s,o));return g(n),p}function bt(e){var r=[];l(e);var a=new u(208).address;if(0==(0|t._crypto_sign_init(a))){var _=a;return g(r),_}b(r,"internal error")}function ft(e){var r=[];l(e);var a=new u(0|t._crypto_sign_publickeybytes()),_=a.address;r.push(_);var n=new u(0|t._crypto_sign_secretkeybytes()),s=n.address;if(r.push(s),0==(0|t._crypto_sign_keypair(_,s))){var c={publicKey:y(a,e),privateKey:y(n,e),keyType:"ed25519"};return g(r),c}b(r,"internal error")}function mt(e,r,a){var _=[];l(a),e=x(_,e,"signedMessage");var n,s=t._crypto_sign_bytes(),c=e.length;c<s&&f(_,"signedMessage is too short"),n=d(e),_.push(n),r=x(_,r,"publicKey");var o,h=0|t._crypto_sign_publickeybytes();r.length!==h&&f(_,"invalid publicKey length"),o=d(r),_.push(o);var p=new u(c-t._crypto_sign_bytes()|0),i=p.address;if(_.push(i),0==(0|t._crypto_sign_open(i,null,n,c,0,o))){var v=y(p,a);return g(_),v}b(_,"incorrect signature for the given public key")}function xt(e,r){var a=[];l(r),e=x(a,e,"seed");var _,n=0|t._crypto_sign_seedbytes();e.length!==n&&f(a,"invalid seed length"),_=d(e),a.push(_);var s=new u(0|t._crypto_sign_publickeybytes()),c=s.address;a.push(c);var o=new u(0|t._crypto_sign_secretkeybytes()),h=o.address;if(a.push(h),0==(0|t._crypto_sign_seed_keypair(c,h,_))){var p={publicKey:y(s,r),privateKey:y(o,r),keyType:"ed25519"};return g(a),p}b(a,"invalid usage")}function Et(e,r,a){var _=[];l(a),m(_,e,"state_address");var n=d(r=x(_,r,"message_chunk")),s=r.length;_.push(n),0!=(0|t._crypto_sign_update(e,n,s,0))&&b(_,"invalid usage"),g(_)}function kt(e,r,a){var _=[];e=x(_,e,"signature");var n,s=0|t._crypto_sign_bytes();e.length!==s&&f(_,"invalid signature length"),n=d(e),_.push(n);var c=d(r=x(_,r,"message")),o=r.length;_.push(c),a=x(_,a,"publicKey");var h,p=0|t._crypto_sign_publickeybytes();a.length!==p&&f(_,"invalid publicKey length"),h=d(a),_.push(h);var y=0==(0|t._crypto_sign_verify_detached(n,c,o,0,h));return g(_),y}function St(e,r,a,_){var n=[];l(_),m(n,e,"outLength"),("number"!=typeof e||(0|e)!==e||e<0)&&f(n,"outLength must be an unsigned integer"),r=x(n,r,"key");var s,c=0|t._crypto_stream_chacha20_keybytes();r.length!==c&&f(n,"invalid key length"),s=d(r),n.push(s),a=x(n,a,"nonce");var o,h=0|t._crypto_stream_chacha20_noncebytes();a.length!==h&&f(n,"invalid nonce length"),o=d(a),n.push(o);var p=new u(0|e),i=p.address;n.push(i),t._crypto_stream_chacha20(i,e,0,o,s);var v=y(p,_);return g(n),v}function Tt(e,r,a,_){var n=[];l(_);var s=d(e=x(n,e,"input_message")),c=e.length;n.push(s),r=x(n,r,"nonce");var o,h=0|t._crypto_stream_chacha20_ietf_noncebytes();r.length!==h&&f(n,"invalid nonce length"),o=d(r),n.push(o),a=x(n,a,"key");var p,i=0|t._crypto_stream_chacha20_ietf_keybytes();a.length!==i&&f(n,"invalid key length"),p=d(a),n.push(p);var v=new u(0|c),m=v.address;if(n.push(m),0===t._crypto_stream_chacha20_ietf_xor(m,s,c,0,o,p)){var E=y(v,_);return g(n),E}b(n,"invalid usage")}function wt(e,r,a,_,n){var s=[];l(n);var c=d(e=x(s,e,"input_message")),o=e.length;s.push(c),r=x(s,r,"nonce");var h,p=0|t._crypto_stream_chacha20_ietf_noncebytes();r.length!==p&&f(s,"invalid nonce length"),h=d(r),s.push(h),m(s,a,"nonce_increment"),("number"!=typeof a||(0|a)!==a||a<0)&&f(s,"nonce_increment must be an unsigned integer"),_=x(s,_,"key");var i,v=0|t._crypto_stream_chacha20_ietf_keybytes();_.length!==v&&f(s,"invalid key length"),i=d(_),s.push(i);var E=new u(0|o),k=E.address;if(s.push(k),0===t._crypto_stream_chacha20_ietf_xor_ic(k,c,o,0,h,a,i)){var S=y(E,n);return g(s),S}b(s,"invalid usage")}function Yt(e){var r=[];l(e);var a=new u(0|t._crypto_stream_chacha20_keybytes()),_=a.address;r.push(_),t._crypto_stream_chacha20_keygen(_);var n=y(a,e);return g(r),n}function Bt(e,r,a,_){var n=[];l(_);var s=d(e=x(n,e,"input_message")),c=e.length;n.push(s),r=x(n,r,"nonce");var o,h=0|t._crypto_stream_chacha20_noncebytes();r.length!==h&&f(n,"invalid nonce length"),o=d(r),n.push(o),a=x(n,a,"key");var p,i=0|t._crypto_stream_chacha20_keybytes();a.length!==i&&f(n,"invalid key length"),p=d(a),n.push(p);var v=new u(0|c),m=v.address;if(n.push(m),0===t._crypto_stream_chacha20_xor(m,s,c,0,o,p)){var E=y(v,_);return g(n),E}b(n,"invalid usage")}function At(e,r,a,_,n){var s=[];l(n);var c=d(e=x(s,e,"input_message")),o=e.length;s.push(c),r=x(s,r,"nonce");var h,p=0|t._crypto_stream_chacha20_noncebytes();r.length!==p&&f(s,"invalid nonce length"),h=d(r),s.push(h),m(s,a,"nonce_increment"),("number"!=typeof a||(0|a)!==a||a<0)&&f(s,"nonce_increment must be an unsigned integer"),_=x(s,_,"key");var i,v=0|t._crypto_stream_chacha20_keybytes();_.length!==v&&f(s,"invalid key length"),i=d(_),s.push(i);var E=new u(0|o),k=E.address;if(s.push(k),0===t._crypto_stream_chacha20_xor_ic(k,c,o,0,h,a,0,i)){var S=y(E,n);return g(s),S}b(s,"invalid usage")}function Kt(e){var r=[];l(e);var a=new u(0|t._crypto_stream_keybytes()),_=a.address;r.push(_),t._crypto_stream_keygen(_);var n=y(a,e);return g(r),n}function Mt(e){var r=[];l(e);var a=new u(0|t._crypto_stream_xchacha20_keybytes()),_=a.address;r.push(_),t._crypto_stream_xchacha20_keygen(_);var n=y(a,e);return g(r),n}function It(e,r,a,_){var n=[];l(_);var s=d(e=x(n,e,"input_message")),c=e.length;n.push(s),r=x(n,r,"nonce");var o,h=0|t._crypto_stream_xchacha20_noncebytes();r.length!==h&&f(n,"invalid nonce length"),o=d(r),n.push(o),a=x(n,a,"key");var p,i=0|t._crypto_stream_xchacha20_keybytes();a.length!==i&&f(n,"invalid key length"),p=d(a),n.push(p);var v=new u(0|c),m=v.address;if(n.push(m),0===t._crypto_stream_xchacha20_xor(m,s,c,0,o,p)){var E=y(v,_);return g(n),E}b(n,"invalid usage")}function Nt(e,r,a,_,n){var s=[];l(n);var c=d(e=x(s,e,"input_message")),o=e.length;s.push(c),r=x(s,r,"nonce");var h,p=0|t._crypto_stream_xchacha20_noncebytes();r.length!==p&&f(s,"invalid nonce length"),h=d(r),s.push(h),m(s,a,"nonce_increment"),("number"!=typeof a||(0|a)!==a||a<0)&&f(s,"nonce_increment must be an unsigned integer"),_=x(s,_,"key");var i,v=0|t._crypto_stream_xchacha20_keybytes();_.length!==v&&f(s,"invalid key length"),i=d(_),s.push(i);var E=new u(0|o),k=E.address;if(s.push(k),0===t._crypto_stream_xchacha20_xor_ic(k,c,o,0,h,a,0,i)){var S=y(E,n);return g(s),S}b(s,"invalid usage")}function Lt(e,r){var a=[];l(r),m(a,e,"length"),("number"!=typeof e||(0|e)!==e||e<0)&&f(a,"length must be an unsigned integer");var _=new u(0|e),n=_.address;a.push(n),t._randombytes_buf(n,e);var s=y(_,r);return g(a),s}function Ut(e,r,a){var _=[];l(a),m(_,e,"length"),("number"!=typeof e||(0|e)!==e||e<0)&&f(_,"length must be an unsigned integer"),r=x(_,r,"seed");var n,s=0|t._randombytes_seedbytes();r.length!==s&&f(_,"invalid seed length"),n=d(r),_.push(n);var c=new u(0|e),o=c.address;_.push(o),t._randombytes_buf_deterministic(o,e,n);var h=y(c,a);return g(_),h}function Ot(e){l(e),t._randombytes_close()}function Ct(e){l(e);var r=t._randombytes_random()>>>0;return g([]),r}function Rt(e,r){var a=[];l(r);for(var _=t._malloc(24),n=0;n<6;n++)t.setValue(_+4*n,t.Runtime.addFunction(e[["implementation_name","random","stir","uniform","buf","close"][n]]),"i32");0!=(0|t._randombytes_set_implementation(_))&&b(a,"unsupported implementation"),g(a)}function Pt(e){l(e),t._randombytes_stir()}function Gt(e,r){var a=[];l(r),m(a,e,"upper_bound"),("number"!=typeof e||(0|e)!==e||e<0)&&f(a,"upper_bound must be an unsigned integer");var _=t._randombytes_uniform(e)>>>0;return g(a),_}function Xt(){var e=t._sodium_version_string(),r=t.UTF8ToString(e);return g([]),r}return u.prototype.to_Uint8Array=function(){var e=new Uint8Array(this.length);return e.set(t.HEAPU8.subarray(this.address,this.address+this.length)),e},e.add=function(e,r){if(!(e instanceof Uint8Array&&r instanceof Uint8Array))throw new TypeError("Only Uint8Array instances can added");var t=e.length,a=0,_=0;if(r.length!=e.length)throw new TypeError("Arguments must have the same length");for(_=0;_<t;_++)a>>=8,a+=e[_]+r[_],e[_]=255&a},e.base64_variants=o,e.compare=function(e,r){if(!(e instanceof Uint8Array&&r instanceof Uint8Array))throw new TypeError("Only Uint8Array instances can be compared");if(e.length!==r.length)throw new TypeError("Only instances of identical length can be compared");for(var t=0,a=1,_=e.length;_-- >0;)t|=r[_]-e[_]>>8&a,a&=(r[_]^e[_])-1>>8;return t+t+a-1},e.from_base64=function(e,r){r=h(r);var a,_=[],n=new u(3*(e=x(_,e,"input")).length/4),s=d(e),c=v(4),o=v(4);return _.push(s),_.push(n.address),_.push(n.result_bin_len_p),_.push(n.b64_end_p),0!==t._sodium_base642bin(n.address,n.length,s,e.length,0,c,o,r)&&b(_,"invalid input"),t.getValue(o,"i32")-s!==e.length&&b(_,"incomplete input"),n.length=t.getValue(c,"i32"),a=n.to_Uint8Array(),g(_),a},e.from_hex=function(e){var r,a=[],_=new u((e=x(a,e,"input")).length/2),n=d(e),s=v(4);return a.push(n),a.push(_.address),a.push(_.hex_end_p),0!==t._sodium_hex2bin(_.address,_.length,n,e.length,0,0,s)&&b(a,"invalid input"),t.getValue(s,"i32")-n!==e.length&&b(a,"incomplete input"),r=_.to_Uint8Array(),g(a),r},e.from_string=n,e.increment=function(e){if(!(e instanceof Uint8Array))throw new TypeError("Only Uint8Array instances can be incremented");for(var r=256,t=0,a=e.length;t<a;t++)r>>=8,r+=e[t],e[t]=255&r},e.is_zero=function(e){if(!(e instanceof Uint8Array))throw new TypeError("Only Uint8Array instances can be checked");for(var r=0,t=0,a=e.length;t<a;t++)r|=e[t];return 0===r},e.libsodium=r,e.memcmp=function(e,r){if(!(e instanceof Uint8Array&&r instanceof Uint8Array))throw new TypeError("Only Uint8Array instances can be compared");if(e.length!==r.length)throw new TypeError("Only instances of identical length can be compared");for(var t=0,a=0,_=e.length;a<_;a++)t|=e[a]^r[a];return 0===t},e.memzero=function(e){if(!(e instanceof Uint8Array))throw new TypeError("Only Uint8Array instances can be wiped");for(var r=0,t=e.length;r<t;r++)e[r]=0},e.output_formats=function(){return["uint8array","text","hex","base64"]},e.pad=function(e,r){if(!(e instanceof Uint8Array))throw new TypeError("buffer must be a Uint8Array");if((r|=0)<=0)throw new Error("block size must be > 0");var a,_=[],n=v(4),s=1,c=0,o=0|e.length,h=new u(o+r);_.push(n),_.push(h.address);for(var p=h.address,y=h.address+o+r;p<y;p++)t.HEAPU8[p]=e[c],c+=s=1&~((65535&((o-=s)>>>48|o>>>32|o>>>16|o))-1>>16);return 0!==t._sodium_pad(n,h.address,e.length,r,h.length)&&b(_,"internal error"),h.length=t.getValue(n,"i32"),a=h.to_Uint8Array(),g(_),a},e.unpad=function(e,r){if(!(e instanceof Uint8Array))throw new TypeError("buffer must be a Uint8Array");if((r|=0)<=0)throw new Error("block size must be > 0");var a=[],_=d(e),n=v(4);return a.push(_),a.push(n),0!==t._sodium_unpad(n,_,e.length,r)&&b(a,"unsupported/invalid padding"),e=(e=new Uint8Array(e)).subarray(0,t.getValue(n,"i32")),g(a),e},e.ready=_,e.symbols=function(){return Object.keys(e).sort()},e.to_base64=p,e.to_hex=c,e.to_string=s,e}var t="object"==typeof e.sodium&&"function"==typeof e.sodium.onload?e.sodium.onload:null; true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports,__webpack_require__(94608)], __WEBPACK_AMD_DEFINE_FACTORY__ = (r),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):0,t&&e.sodium.ready.then((function(){t(e.sodium)}))}(this);


/***/ }),

/***/ 69260:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

(function (global, factory) {
   true ? factory(exports, __webpack_require__(11248), __webpack_require__(67294)) :
  0;
})(this, (function (exports, lottie, React) { 'use strict';

  function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

  var lottie__default = /*#__PURE__*/_interopDefaultLegacy(lottie);
  var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

  function _iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
      var _s,
        _e,
        _x,
        _r,
        _arr = [],
        _n = !0,
        _d = !1;
      try {
        if (_x = (_i = _i.call(arr)).next, 0 === i) {
          if (Object(_i) !== _i) return;
          _n = !1;
        } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
      } catch (err) {
        _d = !0, _e = err;
      } finally {
        try {
          if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
        } finally {
          if (_d) throw _e;
        }
      }
      return _arr;
    }
  }
  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread2(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }
    return target;
  }
  function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }
    return target;
  }
  function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
  }
  function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
  }
  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }
  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
    return arr2;
  }
  function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  function _toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
      var res = prim.call(input, hint || "default");
      if (typeof res !== "object") return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
  }

  var _excluded$1 = ["animationData", "loop", "autoplay", "initialSegment", "onComplete", "onLoopComplete", "onEnterFrame", "onSegmentStart", "onConfigReady", "onDataReady", "onDataFailed", "onLoadedImages", "onDOMLoaded", "onDestroy", "lottieRef", "renderer", "name", "assetsPath", "rendererSettings"];
  var useLottie = function useLottie(props, style) {
    var animationData = props.animationData,
      loop = props.loop,
      autoplay = props.autoplay,
      initialSegment = props.initialSegment,
      onComplete = props.onComplete,
      onLoopComplete = props.onLoopComplete,
      onEnterFrame = props.onEnterFrame,
      onSegmentStart = props.onSegmentStart,
      onConfigReady = props.onConfigReady,
      onDataReady = props.onDataReady,
      onDataFailed = props.onDataFailed,
      onLoadedImages = props.onLoadedImages,
      onDOMLoaded = props.onDOMLoaded,
      onDestroy = props.onDestroy;
      props.lottieRef;
      props.renderer;
      props.name;
      props.assetsPath;
      props.rendererSettings;
      var rest = _objectWithoutProperties(props, _excluded$1);
    var _useState = React.useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      animationLoaded = _useState2[0],
      setAnimationLoaded = _useState2[1];
    var animationInstanceRef = React.useRef();
    var animationContainer = React.useRef(null);
    /*
          ======================================
              INTERACTION METHODS
          ======================================
       */
    /**
     * Play
     */
    var play = function play() {
      var _a;
      (_a = animationInstanceRef.current) === null || _a === void 0 ? void 0 : _a.play();
    };
    /**
     * Stop
     */
    var stop = function stop() {
      var _a;
      (_a = animationInstanceRef.current) === null || _a === void 0 ? void 0 : _a.stop();
    };
    /**
     * Pause
     */
    var pause = function pause() {
      var _a;
      (_a = animationInstanceRef.current) === null || _a === void 0 ? void 0 : _a.pause();
    };
    /**
     * Set animation speed
     * @param speed
     */
    var setSpeed = function setSpeed(speed) {
      var _a;
      (_a = animationInstanceRef.current) === null || _a === void 0 ? void 0 : _a.setSpeed(speed);
    };
    /**
     * Got to frame and play
     * @param value
     * @param isFrame
     */
    var goToAndPlay = function goToAndPlay(value, isFrame) {
      var _a;
      (_a = animationInstanceRef.current) === null || _a === void 0 ? void 0 : _a.goToAndPlay(value, isFrame);
    };
    /**
     * Got to frame and stop
     * @param value
     * @param isFrame
     */
    var goToAndStop = function goToAndStop(value, isFrame) {
      var _a;
      (_a = animationInstanceRef.current) === null || _a === void 0 ? void 0 : _a.goToAndStop(value, isFrame);
    };
    /**
     * Set animation direction
     * @param direction
     */
    var setDirection = function setDirection(direction) {
      var _a;
      (_a = animationInstanceRef.current) === null || _a === void 0 ? void 0 : _a.setDirection(direction);
    };
    /**
     * Play animation segments
     * @param segments
     * @param forceFlag
     */
    var playSegments = function playSegments(segments, forceFlag) {
      var _a;
      (_a = animationInstanceRef.current) === null || _a === void 0 ? void 0 : _a.playSegments(segments, forceFlag);
    };
    /**
     * Set sub frames
     * @param useSubFrames
     */
    var setSubframe = function setSubframe(useSubFrames) {
      var _a;
      (_a = animationInstanceRef.current) === null || _a === void 0 ? void 0 : _a.setSubframe(useSubFrames);
    };
    /**
     * Get animation duration
     * @param inFrames
     */
    var getDuration = function getDuration(inFrames) {
      var _a;
      return (_a = animationInstanceRef.current) === null || _a === void 0 ? void 0 : _a.getDuration(inFrames);
    };
    /**
     * Destroy animation
     */
    var destroy = function destroy() {
      var _a;
      (_a = animationInstanceRef.current) === null || _a === void 0 ? void 0 : _a.destroy();
      // Removing the reference to the animation so separate cleanups are skipped.
      // Without it the internal `lottie-react` instance throws exceptions as it already cleared itself on destroy.
      animationInstanceRef.current = undefined;
    };
    /*
          ======================================
              LOTTIE
          ======================================
       */
    /**
     * Load a new animation, and if it's the case, destroy the previous one
     * @param {Object} forcedConfigs
     */
    var loadAnimation = function loadAnimation() {
      var forcedConfigs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _a;
      // Return if the container ref is null
      if (!animationContainer.current) {
        return;
      }
      // Destroy any previous instance
      (_a = animationInstanceRef.current) === null || _a === void 0 ? void 0 : _a.destroy();
      // Build the animation configuration
      var config = _objectSpread2(_objectSpread2(_objectSpread2({}, props), forcedConfigs), {}, {
        container: animationContainer.current
      });
      // Save the animation instance
      animationInstanceRef.current = lottie__default["default"].loadAnimation(config);
      setAnimationLoaded(!!animationInstanceRef.current);
      // Return a function that will clean up
      return function () {
        var _a;
        (_a = animationInstanceRef.current) === null || _a === void 0 ? void 0 : _a.destroy();
        animationInstanceRef.current = undefined;
      };
    };
    /**
     * (Re)Initialize when animation data changed
     */
    React.useEffect(function () {
      var onUnmount = loadAnimation();
      // Clean up on unmount
      return function () {
        return onUnmount === null || onUnmount === void 0 ? void 0 : onUnmount();
      };
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [animationData, loop]);
    // Update the autoplay state
    React.useEffect(function () {
      if (!animationInstanceRef.current) {
        return;
      }
      animationInstanceRef.current.autoplay = !!autoplay;
    }, [autoplay]);
    // Update the initial segment state
    React.useEffect(function () {
      if (!animationInstanceRef.current) {
        return;
      }
      // When null should reset to default animation length
      if (!initialSegment) {
        animationInstanceRef.current.resetSegments(true);
        return;
      }
      // If it's not a valid segment, do nothing
      if (!Array.isArray(initialSegment) || !initialSegment.length) {
        return;
      }
      // If the current position it's not in the new segment
      // set the current position to start
      if (animationInstanceRef.current.currentRawFrame < initialSegment[0] || animationInstanceRef.current.currentRawFrame > initialSegment[1]) {
        animationInstanceRef.current.currentRawFrame = initialSegment[0];
      }
      // Update the segment
      animationInstanceRef.current.setSegment(initialSegment[0], initialSegment[1]);
    }, [initialSegment]);
    /*
          ======================================
              EVENTS
          ======================================
       */
    /**
     * Reinitialize listener on change
     */
    React.useEffect(function () {
      var partialListeners = [{
        name: "complete",
        handler: onComplete
      }, {
        name: "loopComplete",
        handler: onLoopComplete
      }, {
        name: "enterFrame",
        handler: onEnterFrame
      }, {
        name: "segmentStart",
        handler: onSegmentStart
      }, {
        name: "config_ready",
        handler: onConfigReady
      }, {
        name: "data_ready",
        handler: onDataReady
      }, {
        name: "data_failed",
        handler: onDataFailed
      }, {
        name: "loaded_images",
        handler: onLoadedImages
      }, {
        name: "DOMLoaded",
        handler: onDOMLoaded
      }, {
        name: "destroy",
        handler: onDestroy
      }];
      var listeners = partialListeners.filter(function (listener) {
        return listener.handler != null;
      });
      if (!listeners.length) {
        return;
      }
      var deregisterList = listeners.map(
      /**
       * Handle the process of adding an event listener
       * @param {Listener} listener
       * @return {Function} Function that deregister the listener
       */
      function (listener) {
        var _a;
        (_a = animationInstanceRef.current) === null || _a === void 0 ? void 0 : _a.addEventListener(listener.name, listener.handler);
        // Return a function to deregister this listener
        return function () {
          var _a;
          (_a = animationInstanceRef.current) === null || _a === void 0 ? void 0 : _a.removeEventListener(listener.name, listener.handler);
        };
      });
      // Deregister listeners on unmount
      return function () {
        deregisterList.forEach(function (deregister) {
          return deregister();
        });
      };
    }, [onComplete, onLoopComplete, onEnterFrame, onSegmentStart, onConfigReady, onDataReady, onDataFailed, onLoadedImages, onDOMLoaded, onDestroy]);
    /**
     * Build the animation view
     */
    var View = /*#__PURE__*/React__default["default"].createElement("div", _objectSpread2({
      style: style,
      ref: animationContainer
    }, rest));
    return {
      View: View,
      play: play,
      stop: stop,
      pause: pause,
      setSpeed: setSpeed,
      goToAndStop: goToAndStop,
      goToAndPlay: goToAndPlay,
      setDirection: setDirection,
      playSegments: playSegments,
      setSubframe: setSubframe,
      getDuration: getDuration,
      destroy: destroy,
      animationContainerRef: animationContainer,
      animationLoaded: animationLoaded,
      animationItem: animationInstanceRef.current
    };
  };

  // helpers
  function getContainerVisibility(container) {
    var _container$getBoundin = container.getBoundingClientRect(),
      top = _container$getBoundin.top,
      height = _container$getBoundin.height;
    var current = window.innerHeight - top;
    var max = window.innerHeight + height;
    return current / max;
  }
  function getContainerCursorPosition(container, cursorX, cursorY) {
    var _container$getBoundin2 = container.getBoundingClientRect(),
      top = _container$getBoundin2.top,
      left = _container$getBoundin2.left,
      width = _container$getBoundin2.width,
      height = _container$getBoundin2.height;
    var x = (cursorX - left) / width;
    var y = (cursorY - top) / height;
    return {
      x: x,
      y: y
    };
  }
  var useInitInteractivity = function useInitInteractivity(_ref) {
    var wrapperRef = _ref.wrapperRef,
      animationItem = _ref.animationItem,
      mode = _ref.mode,
      actions = _ref.actions;
    React.useEffect(function () {
      var wrapper = wrapperRef.current;
      if (!wrapper || !animationItem || !actions.length) {
        return;
      }
      animationItem.stop();
      var scrollModeHandler = function scrollModeHandler() {
        var assignedSegment = null;
        var scrollHandler = function scrollHandler() {
          var currentPercent = getContainerVisibility(wrapper);
          // Find the first action that satisfies the current position conditions
          var action = actions.find(function (_ref2) {
            var visibility = _ref2.visibility;
            return visibility && currentPercent >= visibility[0] && currentPercent <= visibility[1];
          });
          // Skip if no matching action was found!
          if (!action) {
            return;
          }
          if (action.type === "seek" && action.visibility && action.frames.length === 2) {
            // Seek: Go to a frame based on player scroll position action
            var frameToGo = action.frames[0] + Math.ceil((currentPercent - action.visibility[0]) / (action.visibility[1] - action.visibility[0]) * action.frames[1]);
            //! goToAndStop must be relative to the start of the current segment
            animationItem.goToAndStop(frameToGo - animationItem.firstFrame - 1, true);
          }
          if (action.type === "loop") {
            // Loop: Loop a given frames
            if (assignedSegment === null) {
              // if not playing any segments currently. play those segments and save to state
              animationItem.playSegments(action.frames, true);
              assignedSegment = action.frames;
            } else {
              // if playing any segments currently.
              //check if segments in state are equal to the frames selected by action
              if (assignedSegment !== action.frames) {
                // if they are not equal. new segments are to be loaded
                animationItem.playSegments(action.frames, true);
                assignedSegment = action.frames;
              } else if (animationItem.isPaused) {
                // if they are equal the play method must be called only if lottie is paused
                animationItem.playSegments(action.frames, true);
                assignedSegment = action.frames;
              }
            }
          }
          if (action.type === "play" && animationItem.isPaused) {
            // Play: Reset segments and continue playing full animation from current position
            animationItem.resetSegments(true);
            animationItem.play();
          }
          if (action.type === "stop") {
            // Stop: Stop playback
            animationItem.goToAndStop(action.frames[0] - animationItem.firstFrame - 1, true);
          }
        };
        document.addEventListener("scroll", scrollHandler);
        return function () {
          document.removeEventListener("scroll", scrollHandler);
        };
      };
      var cursorModeHandler = function cursorModeHandler() {
        var handleCursor = function handleCursor(_x, _y) {
          var x = _x;
          var y = _y;
          // Resolve cursor position if cursor is inside container
          if (x !== -1 && y !== -1) {
            // Get container cursor position
            var pos = getContainerCursorPosition(wrapper, x, y);
            // Use the resolved position
            x = pos.x;
            y = pos.y;
          }
          // Find the first action that satisfies the current position conditions
          var action = actions.find(function (_ref3) {
            var position = _ref3.position;
            if (position && Array.isArray(position.x) && Array.isArray(position.y)) {
              return x >= position.x[0] && x <= position.x[1] && y >= position.y[0] && y <= position.y[1];
            }
            if (position && !Number.isNaN(position.x) && !Number.isNaN(position.y)) {
              return x === position.x && y === position.y;
            }
            return false;
          });
          // Skip if no matching action was found!
          if (!action) {
            return;
          }
          // Process action types:
          if (action.type === "seek" && action.position && Array.isArray(action.position.x) && Array.isArray(action.position.y) && action.frames.length === 2) {
            // Seek: Go to a frame based on player scroll position action
            var xPercent = (x - action.position.x[0]) / (action.position.x[1] - action.position.x[0]);
            var yPercent = (y - action.position.y[0]) / (action.position.y[1] - action.position.y[0]);
            animationItem.playSegments(action.frames, true);
            animationItem.goToAndStop(Math.ceil((xPercent + yPercent) / 2 * (action.frames[1] - action.frames[0])), true);
          }
          if (action.type === "loop") {
            animationItem.playSegments(action.frames, true);
          }
          if (action.type === "play") {
            // Play: Reset segments and continue playing full animation from current position
            if (animationItem.isPaused) {
              animationItem.resetSegments(false);
            }
            animationItem.playSegments(action.frames);
          }
          if (action.type === "stop") {
            animationItem.goToAndStop(action.frames[0], true);
          }
        };
        var mouseMoveHandler = function mouseMoveHandler(ev) {
          handleCursor(ev.clientX, ev.clientY);
        };
        var mouseOutHandler = function mouseOutHandler() {
          handleCursor(-1, -1);
        };
        wrapper.addEventListener("mousemove", mouseMoveHandler);
        wrapper.addEventListener("mouseout", mouseOutHandler);
        return function () {
          wrapper.removeEventListener("mousemove", mouseMoveHandler);
          wrapper.removeEventListener("mouseout", mouseOutHandler);
        };
      };
      switch (mode) {
        case "scroll":
          return scrollModeHandler();
        case "cursor":
          return cursorModeHandler();
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [mode, animationItem]);
  };
  var useLottieInteractivity = function useLottieInteractivity(_ref4) {
    var actions = _ref4.actions,
      mode = _ref4.mode,
      lottieObj = _ref4.lottieObj;
    var animationItem = lottieObj.animationItem,
      View = lottieObj.View,
      animationContainerRef = lottieObj.animationContainerRef;
    useInitInteractivity({
      actions: actions,
      animationItem: animationItem,
      mode: mode,
      wrapperRef: animationContainerRef
    });
    return View;
  };

  var _excluded = ["style", "interactivity"];
  var Lottie = function Lottie(props) {
    var _a, _b, _c;
    var style = props.style,
      interactivity = props.interactivity,
      lottieProps = _objectWithoutProperties(props, _excluded);
    /**
     * Initialize the 'useLottie' hook
     */
    var _useLottie = useLottie(lottieProps, style),
      View = _useLottie.View,
      play = _useLottie.play,
      stop = _useLottie.stop,
      pause = _useLottie.pause,
      setSpeed = _useLottie.setSpeed,
      goToAndStop = _useLottie.goToAndStop,
      goToAndPlay = _useLottie.goToAndPlay,
      setDirection = _useLottie.setDirection,
      playSegments = _useLottie.playSegments,
      setSubframe = _useLottie.setSubframe,
      getDuration = _useLottie.getDuration,
      destroy = _useLottie.destroy,
      animationContainerRef = _useLottie.animationContainerRef,
      animationLoaded = _useLottie.animationLoaded,
      animationItem = _useLottie.animationItem;
    /**
     * Make the hook variables/methods available through the provided 'lottieRef'
     */
    React.useEffect(function () {
      if (props.lottieRef) {
        props.lottieRef.current = {
          play: play,
          stop: stop,
          pause: pause,
          setSpeed: setSpeed,
          goToAndPlay: goToAndPlay,
          goToAndStop: goToAndStop,
          setDirection: setDirection,
          playSegments: playSegments,
          setSubframe: setSubframe,
          getDuration: getDuration,
          destroy: destroy,
          animationContainerRef: animationContainerRef,
          animationLoaded: animationLoaded,
          animationItem: animationItem
        };
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [(_a = props.lottieRef) === null || _a === void 0 ? void 0 : _a.current]);
    return useLottieInteractivity({
      lottieObj: {
        View: View,
        play: play,
        stop: stop,
        pause: pause,
        setSpeed: setSpeed,
        goToAndStop: goToAndStop,
        goToAndPlay: goToAndPlay,
        setDirection: setDirection,
        playSegments: playSegments,
        setSubframe: setSubframe,
        getDuration: getDuration,
        destroy: destroy,
        animationContainerRef: animationContainerRef,
        animationLoaded: animationLoaded,
        animationItem: animationItem
      },
      actions: (_b = interactivity === null || interactivity === void 0 ? void 0 : interactivity.actions) !== null && _b !== void 0 ? _b : [],
      mode: (_c = interactivity === null || interactivity === void 0 ? void 0 : interactivity.mode) !== null && _c !== void 0 ? _c : "scroll"
    });
  };

  Object.defineProperty(exports, 'LottiePlayer', {
    enumerable: true,
    get: function () { return lottie__default["default"]; }
  });
  exports["default"] = Lottie;
  exports.useLottie = useLottie;
  exports.useLottieInteractivity = useLottieInteractivity;

  Object.defineProperty(exports, '__esModule', { value: true });

}));
//# sourceMappingURL=index.umd.js.map


/***/ }),

/***/ 44019:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = __webpack_require__(14027);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.getDomainLocale = getDomainLocale;
var basePath = (/* unused pure expression or super */ null && ( false || ''));

function getDomainLocale(path, locale, locales, domainLocales) {
  if (false) { var finalLocale, proto, domain, target, detectDomainLocale, normalizeLocalePath; } else {
    return false;
  }
}

if ((typeof exports["default"] === 'function' || _typeof(exports["default"]) === 'object' && exports["default"] !== null) && typeof exports["default"].__esModule === 'undefined') {
  Object.defineProperty(exports["default"], '__esModule', {
    value: true
  });
  Object.assign(exports["default"], exports);
  module.exports = exports["default"];
}

/***/ }),

/***/ 7942:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = __webpack_require__(85696);

var _typeof = __webpack_require__(14027);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _interop_require_default = (__webpack_require__(81414)["default"]);

var _object_without_properties_loose = (__webpack_require__(6917)["default"]);

var _react = _interop_require_default(__webpack_require__(67294));

var _router = __webpack_require__(64957);

var _addLocale = __webpack_require__(57995);

var _routerContext = __webpack_require__(30647);

var _appRouterContext = __webpack_require__(51992);

var _useIntersection = __webpack_require__(90639);

var _getDomainLocale = __webpack_require__(44019);

var _addBasePath = __webpack_require__(70227); // @ts-ignore useTransition exist


var hasUseTransition = typeof _react["default"].useTransition !== 'undefined';
var prefetched = {};

function prefetch(router, href, as, options) {
  if ( false || !router) return;
  if (!(0, _router).isLocalURL(href)) return; // Prefetch the JSON page if asked (only in the client)
  // We need to handle a prefetch error here since we may be
  // loading with priority which can reject but we don't
  // want to force navigation since this is only a prefetch

  router.prefetch(href, as, options)["catch"](function (err) {
    if (false) {}
  });
  var curLocale = options && typeof options.locale !== 'undefined' ? options.locale : router && router.locale; // Join on an invalid URI character

  prefetched[href + '%' + as + (curLocale ? '%' + curLocale : '')] = true;
}

function isModifiedEvent(event) {
  var target = event.currentTarget.target;
  return target && target !== '_self' || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.nativeEvent && event.nativeEvent.which === 2;
}

function linkClicked(e, router, href, as, replace, soft, shallow, scroll, locale, startTransition) {
  var nodeName = e.currentTarget.nodeName; // anchors inside an svg have a lowercase nodeName

  var isAnchorNodeName = nodeName.toUpperCase() === 'A';

  if (isAnchorNodeName && (isModifiedEvent(e) || !(0, _router).isLocalURL(href))) {
    // ignore click for browser’s default behavior
    return;
  }

  e.preventDefault();

  var navigate = function navigate() {
    // If the router is an AppRouterInstance, then it'll have `softPush` and
    // `softReplace`.
    if ('softPush' in router && 'softReplace' in router) {
      // If we're doing a soft navigation, use the soft variants of
      // replace/push.
      var method = soft ? replace ? 'softReplace' : 'softPush' : replace ? 'replace' : 'push';
      router[method](href);
    } else {
      router[replace ? 'replace' : 'push'](href, as, {
        shallow: shallow,
        locale: locale,
        scroll: scroll
      });
    }
  };

  if (startTransition) {
    startTransition(navigate);
  } else {
    navigate();
  }
}

var Link = /*#__PURE__*/_react["default"].forwardRef(function LinkComponent(props, forwardedRef) {
  if (false) { var hasWarned, optionalProps, optionalPropsGuard, requiredProps, requiredPropsGuard, createPropError; }

  var children;

  var hrefProp = props.href,
      asProp = props.as,
      childrenProp = props.children,
      prefetchProp = props.prefetch,
      passHref = props.passHref,
      replace = props.replace,
      soft = props.soft,
      shallow = props.shallow,
      scroll = props.scroll,
      locale = props.locale,
      _onClick = props.onClick,
      _onMouseEnter = props.onMouseEnter,
      _onTouchStart = props.onTouchStart,
      _props$legacyBehavior = props.legacyBehavior,
      legacyBehavior = _props$legacyBehavior === void 0 ? Boolean(false) !== true : _props$legacyBehavior,
      restProps = _object_without_properties_loose(props, ["href", "as", "children", "prefetch", "passHref", "replace", "soft", "shallow", "scroll", "locale", "onClick", "onMouseEnter", "onTouchStart", "legacyBehavior"]);

  children = childrenProp;

  if (legacyBehavior && (typeof children === 'string' || typeof children === 'number')) {
    children = /*#__PURE__*/_react["default"].createElement("a", null, children);
  }

  var p = prefetchProp !== false;

  var _ref = hasUseTransition ? // There is no difference between renders in this case, only between using React 18 vs 17.
  // @ts-ignore useTransition exists
  // eslint-disable-next-line react-hooks/rules-of-hooks
  _react["default"].useTransition() : [],
      _ref2 = _slicedToArray(_ref, 2),

  /* isPending */
  startTransition = _ref2[1];

  var router = _react["default"].useContext(_routerContext.RouterContext); // TODO-APP: type error. Remove `as any`


  var appRouter = _react["default"].useContext(_appRouterContext.AppRouterContext);

  if (appRouter) {
    router = appRouter;
  }

  var _react$default$useMem = _react["default"].useMemo(function () {
    var _resolveHref = (0, _router).resolveHref(router, hrefProp, true),
        _resolveHref2 = _slicedToArray(_resolveHref, 2),
        resolvedHref = _resolveHref2[0],
        resolvedAs = _resolveHref2[1];

    return {
      href: resolvedHref,
      as: asProp ? (0, _router).resolveHref(router, asProp) : resolvedAs || resolvedHref
    };
  }, [router, hrefProp, asProp]),
      href = _react$default$useMem.href,
      as = _react$default$useMem.as;

  var previousHref = _react["default"].useRef(href);

  var previousAs = _react["default"].useRef(as); // This will return the first child, if multiple are provided it will throw an error


  var child;

  if (legacyBehavior) {
    if (false) {} else {
      child = _react["default"].Children.only(children);
    }
  }

  var childRef = legacyBehavior ? child && _typeof(child) === 'object' && child.ref : forwardedRef;

  var _useIntersection2 = (0, _useIntersection).useIntersection({
    rootMargin: '200px'
  }),
      _useIntersection3 = _slicedToArray(_useIntersection2, 3),
      setIntersectionRef = _useIntersection3[0],
      isVisible = _useIntersection3[1],
      resetVisible = _useIntersection3[2];

  var setRef = _react["default"].useCallback(function (el) {
    // Before the link getting observed, check if visible state need to be reset
    if (previousAs.current !== as || previousHref.current !== href) {
      resetVisible();
      previousAs.current = as;
      previousHref.current = href;
    }

    setIntersectionRef(el);

    if (childRef) {
      if (typeof childRef === 'function') childRef(el);else if (_typeof(childRef) === 'object') {
        childRef.current = el;
      }
    }
  }, [as, childRef, href, resetVisible, setIntersectionRef]);

  _react["default"].useEffect(function () {
    var shouldPrefetch = isVisible && p && (0, _router).isLocalURL(href);
    var curLocale = typeof locale !== 'undefined' ? locale : router && router.locale;
    var isPrefetched = prefetched[href + '%' + as + (curLocale ? '%' + curLocale : '')];

    if (shouldPrefetch && !isPrefetched) {
      prefetch(router, href, as, {
        locale: curLocale
      });
    }
  }, [as, href, isVisible, locale, p, router]);

  var childProps = {
    ref: setRef,
    onClick: function onClick(e) {
      if (false) {}

      if (!legacyBehavior && typeof _onClick === 'function') {
        _onClick(e);
      }

      if (legacyBehavior && child.props && typeof child.props.onClick === 'function') {
        child.props.onClick(e);
      }

      if (!e.defaultPrevented) {
        linkClicked(e, router, href, as, replace, soft, shallow, scroll, locale, appRouter ? startTransition : undefined);
      }
    },
    onMouseEnter: function onMouseEnter(e) {
      if (!legacyBehavior && typeof _onMouseEnter === 'function') {
        _onMouseEnter(e);
      }

      if (legacyBehavior && child.props && typeof child.props.onMouseEnter === 'function') {
        child.props.onMouseEnter(e);
      }

      if ((0, _router).isLocalURL(href)) {
        prefetch(router, href, as, {
          priority: true
        });
      }
    },
    onTouchStart: function onTouchStart(e) {
      if (!legacyBehavior && typeof _onTouchStart === 'function') {
        _onTouchStart(e);
      }

      if (legacyBehavior && child.props && typeof child.props.onTouchStart === 'function') {
        child.props.onTouchStart(e);
      }

      if ((0, _router).isLocalURL(href)) {
        prefetch(router, href, as, {
          priority: true
        });
      }
    }
  }; // If child is an <a> tag and doesn't have a href attribute, or if the 'passHref' property is
  // defined, we specify the current 'href', so that repetition is not needed by the user

  if (!legacyBehavior || passHref || child.type === 'a' && !('href' in child.props)) {
    var curLocale = typeof locale !== 'undefined' ? locale : router && router.locale; // we only render domain locales if we are currently on a domain locale
    // so that locale links are still visitable in development/preview envs

    var localeDomain = router && router.isLocaleDomain && (0, _getDomainLocale).getDomainLocale(as, curLocale, router.locales, router.domainLocales);
    childProps.href = localeDomain || (0, _addBasePath).addBasePath((0, _addLocale).addLocale(as, curLocale, router && router.defaultLocale));
  }

  return legacyBehavior ? /*#__PURE__*/_react["default"].cloneElement(child, childProps) : /*#__PURE__*/_react["default"].createElement("a", Object.assign({}, restProps, childProps), children);
});

var _default = Link;
exports["default"] = _default;

if ((typeof exports["default"] === 'function' || _typeof(exports["default"]) === 'object' && exports["default"] !== null) && typeof exports["default"].__esModule === 'undefined') {
  Object.defineProperty(exports["default"], '__esModule', {
    value: true
  });
  Object.assign(exports["default"], exports);
  module.exports = exports["default"];
}

/***/ }),

/***/ 90639:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = __webpack_require__(14027);

var _slicedToArray = __webpack_require__(85696);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.useIntersection = useIntersection;

var _react = __webpack_require__(67294);

var _requestIdleCallback = __webpack_require__(26286);

var hasIntersectionObserver = typeof IntersectionObserver === 'function';

function useIntersection(_ref) {
  var rootRef = _ref.rootRef,
      rootMargin = _ref.rootMargin,
      disabled = _ref.disabled;
  var isDisabled = disabled || !hasIntersectionObserver;
  var unobserve = (0, _react).useRef();

  var _useState = (0, _react).useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1];

  var _useState3 = (0, _react).useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      element = _useState4[0],
      setElement = _useState4[1];

  (0, _react).useEffect(function () {
    if (hasIntersectionObserver) {
      if (unobserve.current) {
        unobserve.current();
        unobserve.current = undefined;
      }

      if (isDisabled || visible) return;

      if (element && element.tagName) {
        unobserve.current = observe(element, function (isVisible) {
          return isVisible && setVisible(isVisible);
        }, {
          root: rootRef == null ? void 0 : rootRef.current,
          rootMargin: rootMargin
        });
      }

      return function () {
        unobserve.current == null ? void 0 : unobserve.current();
        unobserve.current = undefined;
      };
    } else {
      if (!visible) {
        var idleCallback = (0, _requestIdleCallback).requestIdleCallback(function () {
          return setVisible(true);
        });
        return function () {
          return (0, _requestIdleCallback).cancelIdleCallback(idleCallback);
        };
      }
    }
  }, [element, isDisabled, rootMargin, rootRef, visible]);
  var resetVisible = (0, _react).useCallback(function () {
    setVisible(false);
  }, []);
  return [setElement, visible, resetVisible];
}

var observers = new Map();
var idList = [];

function observe(element, callback, options) {
  var _createObserver = createObserver(options),
      id = _createObserver.id,
      observer = _createObserver.observer,
      elements = _createObserver.elements;

  elements.set(element, callback);
  observer.observe(element);
  return function unobserve() {
    elements["delete"](element);
    observer.unobserve(element); // Destroy observer when there's nothing left to watch:

    if (elements.size === 0) {
      observer.disconnect();
      observers["delete"](id);
      var index = idList.findIndex(function (obj) {
        return obj.root === id.root && obj.margin === id.margin;
      });

      if (index > -1) {
        idList.splice(index, 1);
      }
    }
  };
}

function createObserver(options) {
  var id = {
    root: options.root || null,
    margin: options.rootMargin || ''
  };
  var existing = idList.find(function (obj) {
    return obj.root === id.root && obj.margin === id.margin;
  });
  var instance;

  if (existing) {
    instance = observers.get(existing);

    if (instance) {
      return instance;
    }
  }

  var elements = new Map();
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var callback = elements.get(entry.target);
      var isVisible = entry.isIntersecting || entry.intersectionRatio > 0;

      if (callback && isVisible) {
        callback(isVisible);
      }
    });
  }, options);
  instance = {
    id: id,
    observer: observer,
    elements: elements
  };
  idList.push(id);
  observers.set(id, instance);
  return instance;
}

if ((typeof exports["default"] === 'function' || _typeof(exports["default"]) === 'object' && exports["default"] !== null) && typeof exports["default"].__esModule === 'undefined') {
  Object.defineProperty(exports["default"], '__esModule', {
    value: true
  });
  Object.assign(exports["default"], exports);
  module.exports = exports["default"];
}

/***/ }),

/***/ 51992:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.GlobalLayoutRouterContext = exports.LayoutRouterContext = exports.AppRouterContext = void 0;

var _interop_require_default = (__webpack_require__(81414)["default"]);

var _react = _interop_require_default(__webpack_require__(67294));

var AppRouterContext = _react["default"].createContext(null);

exports.AppRouterContext = AppRouterContext;

var LayoutRouterContext = _react["default"].createContext(null);

exports.LayoutRouterContext = LayoutRouterContext;

var GlobalLayoutRouterContext = _react["default"].createContext(null);

exports.GlobalLayoutRouterContext = GlobalLayoutRouterContext;

if (false) {}

/***/ }),

/***/ 66477:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

/* globals self */ exports.Headers = self.Headers;
exports.Request = self.Request;
exports.Response = self.Response;
exports.fetch = self.fetch;

//# sourceMappingURL=whatwg-fetch.js.map

/***/ }),

/***/ 41664:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(7942)


/***/ }),

/***/ 36429:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BaseAccount": function() { return /* binding */ BaseAccount; },
/* harmony export */   "ModuleAccount": function() { return /* binding */ ModuleAccount; },
/* harmony export */   "Params": function() { return /* binding */ Params; }
/* harmony export */ });
/* harmony import */ var _google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32106);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47895);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__);



/**
 * BaseAccount defines a base account type. It contains all the necessary fields
 * for basic account functionality. Any custom account type should extend this
 * type for additional functionality (e.g. vesting).
 */

function createBaseBaseAccount() {
  return {
    $typeUrl: "/cosmos.auth.v1beta1.BaseAccount",
    address: "",
    pubKey: undefined,
    accountNumber: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.UZERO */ .dK.UZERO,
    sequence: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.UZERO */ .dK.UZERO
  };
}

const BaseAccount = {
  typeUrl: "/cosmos.auth.v1beta1.BaseAccount",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (message.address !== "") {
      writer.uint32(10).string(message.address);
    }

    if (message.pubKey !== undefined) {
      _google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__.Any.encode(message.pubKey, writer.uint32(18).fork()).ldelim();
    }

    if (!message.accountNumber.isZero()) {
      writer.uint32(24).uint64(message.accountNumber);
    }

    if (!message.sequence.isZero()) {
      writer.uint32(32).uint64(message.sequence);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBaseAccount();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.address = reader.string();
          break;

        case 2:
          message.pubKey = _google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__.Any.decode(reader, reader.uint32());
          break;

        case 3:
          message.accountNumber = reader.uint64();
          break;

        case 4:
          message.sequence = reader.uint64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$address;

    const message = createBaseBaseAccount();
    message.address = (_object$address = object.address) !== null && _object$address !== void 0 ? _object$address : "";
    message.pubKey = object.pubKey !== undefined && object.pubKey !== null ? _google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__.Any.fromPartial(object.pubKey) : undefined;
    message.accountNumber = object.accountNumber !== undefined && object.accountNumber !== null ? _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromValue */ .dK.fromValue(object.accountNumber) : _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.UZERO */ .dK.UZERO;
    message.sequence = object.sequence !== undefined && object.sequence !== null ? _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromValue */ .dK.fromValue(object.sequence) : _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.UZERO */ .dK.UZERO;
    return message;
  },

  fromAmino(object) {
    return {
      address: object.address,
      pubKey: object !== null && object !== void 0 && object.pub_key ? _google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__.Any.fromAmino(object.pub_key) : undefined,
      accountNumber: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromString */ .dK.fromString(object.account_number),
      sequence: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromString */ .dK.fromString(object.sequence)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.address = message.address;
    obj.pub_key = message.pubKey ? _google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__.Any.toAmino(message.pubKey) : undefined;
    obj.account_number = message.accountNumber ? message.accountNumber.toString() : undefined;
    obj.sequence = message.sequence ? message.sequence.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return BaseAccount.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/BaseAccount",
      value: BaseAccount.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return BaseAccount.decode(message.value);
  },

  toProto(message) {
    return BaseAccount.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.auth.v1beta1.BaseAccount",
      value: BaseAccount.encode(message).finish()
    };
  }

};

function createBaseModuleAccount() {
  return {
    $typeUrl: "/cosmos.auth.v1beta1.ModuleAccount",
    baseAccount: undefined,
    name: "",
    permissions: []
  };
}

const ModuleAccount = {
  typeUrl: "/cosmos.auth.v1beta1.ModuleAccount",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (message.baseAccount !== undefined) {
      BaseAccount.encode(message.baseAccount, writer.uint32(10).fork()).ldelim();
    }

    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }

    for (const v of message.permissions) {
      writer.uint32(26).string(v);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseModuleAccount();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.baseAccount = BaseAccount.decode(reader, reader.uint32());
          break;

        case 2:
          message.name = reader.string();
          break;

        case 3:
          message.permissions.push(reader.string());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$name, _object$permissions;

    const message = createBaseModuleAccount();
    message.baseAccount = object.baseAccount !== undefined && object.baseAccount !== null ? BaseAccount.fromPartial(object.baseAccount) : undefined;
    message.name = (_object$name = object.name) !== null && _object$name !== void 0 ? _object$name : "";
    message.permissions = ((_object$permissions = object.permissions) === null || _object$permissions === void 0 ? void 0 : _object$permissions.map(e => e)) || [];
    return message;
  },

  fromAmino(object) {
    return {
      baseAccount: object !== null && object !== void 0 && object.base_account ? BaseAccount.fromAmino(object.base_account) : undefined,
      name: object.name,
      permissions: Array.isArray(object === null || object === void 0 ? void 0 : object.permissions) ? object.permissions.map(e => e) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.base_account = message.baseAccount ? BaseAccount.toAmino(message.baseAccount) : undefined;
    obj.name = message.name;

    if (message.permissions) {
      obj.permissions = message.permissions.map(e => e);
    } else {
      obj.permissions = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return ModuleAccount.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/ModuleAccount",
      value: ModuleAccount.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return ModuleAccount.decode(message.value);
  },

  toProto(message) {
    return ModuleAccount.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.auth.v1beta1.ModuleAccount",
      value: ModuleAccount.encode(message).finish()
    };
  }

};

function createBaseParams() {
  return {
    maxMemoCharacters: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.UZERO */ .dK.UZERO,
    txSigLimit: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.UZERO */ .dK.UZERO,
    txSizeCostPerByte: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.UZERO */ .dK.UZERO,
    sigVerifyCostEd25519: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.UZERO */ .dK.UZERO,
    sigVerifyCostSecp256k1: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.UZERO */ .dK.UZERO
  };
}

const Params = {
  typeUrl: "/cosmos.auth.v1beta1.Params",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (!message.maxMemoCharacters.isZero()) {
      writer.uint32(8).uint64(message.maxMemoCharacters);
    }

    if (!message.txSigLimit.isZero()) {
      writer.uint32(16).uint64(message.txSigLimit);
    }

    if (!message.txSizeCostPerByte.isZero()) {
      writer.uint32(24).uint64(message.txSizeCostPerByte);
    }

    if (!message.sigVerifyCostEd25519.isZero()) {
      writer.uint32(32).uint64(message.sigVerifyCostEd25519);
    }

    if (!message.sigVerifyCostSecp256k1.isZero()) {
      writer.uint32(40).uint64(message.sigVerifyCostSecp256k1);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseParams();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.maxMemoCharacters = reader.uint64();
          break;

        case 2:
          message.txSigLimit = reader.uint64();
          break;

        case 3:
          message.txSizeCostPerByte = reader.uint64();
          break;

        case 4:
          message.sigVerifyCostEd25519 = reader.uint64();
          break;

        case 5:
          message.sigVerifyCostSecp256k1 = reader.uint64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseParams();
    message.maxMemoCharacters = object.maxMemoCharacters !== undefined && object.maxMemoCharacters !== null ? _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromValue */ .dK.fromValue(object.maxMemoCharacters) : _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.UZERO */ .dK.UZERO;
    message.txSigLimit = object.txSigLimit !== undefined && object.txSigLimit !== null ? _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromValue */ .dK.fromValue(object.txSigLimit) : _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.UZERO */ .dK.UZERO;
    message.txSizeCostPerByte = object.txSizeCostPerByte !== undefined && object.txSizeCostPerByte !== null ? _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromValue */ .dK.fromValue(object.txSizeCostPerByte) : _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.UZERO */ .dK.UZERO;
    message.sigVerifyCostEd25519 = object.sigVerifyCostEd25519 !== undefined && object.sigVerifyCostEd25519 !== null ? _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromValue */ .dK.fromValue(object.sigVerifyCostEd25519) : _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.UZERO */ .dK.UZERO;
    message.sigVerifyCostSecp256k1 = object.sigVerifyCostSecp256k1 !== undefined && object.sigVerifyCostSecp256k1 !== null ? _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromValue */ .dK.fromValue(object.sigVerifyCostSecp256k1) : _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.UZERO */ .dK.UZERO;
    return message;
  },

  fromAmino(object) {
    return {
      maxMemoCharacters: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromString */ .dK.fromString(object.max_memo_characters),
      txSigLimit: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromString */ .dK.fromString(object.tx_sig_limit),
      txSizeCostPerByte: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromString */ .dK.fromString(object.tx_size_cost_per_byte),
      sigVerifyCostEd25519: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromString */ .dK.fromString(object.sig_verify_cost_ed25519),
      sigVerifyCostSecp256k1: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromString */ .dK.fromString(object.sig_verify_cost_secp256k1)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.max_memo_characters = message.maxMemoCharacters ? message.maxMemoCharacters.toString() : undefined;
    obj.tx_sig_limit = message.txSigLimit ? message.txSigLimit.toString() : undefined;
    obj.tx_size_cost_per_byte = message.txSizeCostPerByte ? message.txSizeCostPerByte.toString() : undefined;
    obj.sig_verify_cost_ed25519 = message.sigVerifyCostEd25519 ? message.sigVerifyCostEd25519.toString() : undefined;
    obj.sig_verify_cost_secp256k1 = message.sigVerifyCostSecp256k1 ? message.sigVerifyCostSecp256k1.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return Params.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/x/auth/Params",
      value: Params.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return Params.decode(message.value);
  },

  toProto(message) {
    return Params.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.auth.v1beta1.Params",
      value: Params.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 87634:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AccountI_FromAmino": function() { return /* binding */ AccountI_FromAmino; },
/* harmony export */   "AccountI_InterfaceDecoder": function() { return /* binding */ AccountI_InterfaceDecoder; },
/* harmony export */   "AccountI_ToAmino": function() { return /* binding */ AccountI_ToAmino; },
/* harmony export */   "ModuleAccountI_FromAmino": function() { return /* binding */ ModuleAccountI_FromAmino; },
/* harmony export */   "ModuleAccountI_InterfaceDecoder": function() { return /* binding */ ModuleAccountI_InterfaceDecoder; },
/* harmony export */   "ModuleAccountI_ToAmino": function() { return /* binding */ ModuleAccountI_ToAmino; },
/* harmony export */   "QueryAccountRequest": function() { return /* binding */ QueryAccountRequest; },
/* harmony export */   "QueryAccountResponse": function() { return /* binding */ QueryAccountResponse; },
/* harmony export */   "QueryAccountsRequest": function() { return /* binding */ QueryAccountsRequest; },
/* harmony export */   "QueryAccountsResponse": function() { return /* binding */ QueryAccountsResponse; },
/* harmony export */   "QueryModuleAccountsRequest": function() { return /* binding */ QueryModuleAccountsRequest; },
/* harmony export */   "QueryModuleAccountsResponse": function() { return /* binding */ QueryModuleAccountsResponse; },
/* harmony export */   "QueryParamsRequest": function() { return /* binding */ QueryParamsRequest; },
/* harmony export */   "QueryParamsResponse": function() { return /* binding */ QueryParamsResponse; }
/* harmony export */ });
/* harmony import */ var _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48978);
/* harmony import */ var _google_protobuf_any__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32106);
/* harmony import */ var _auth__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36429);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__);




/**
 * QueryAccountsRequest is the request type for the Query/Accounts RPC method.
 * 
 * Since: cosmos-sdk 0.43
 */

function createBaseQueryAccountsRequest() {
  return {
    pagination: undefined
  };
}

const QueryAccountsRequest = {
  typeUrl: "/cosmos.auth.v1beta1.QueryAccountsRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.pagination !== undefined) {
      _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryAccountsRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.pagination = _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseQueryAccountsRequest();
    message.pagination = object.pagination !== undefined && object.pagination !== null ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.fromPartial(object.pagination) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      pagination: object !== null && object !== void 0 && object.pagination ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.fromAmino(object.pagination) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.pagination = message.pagination ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.toAmino(message.pagination) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryAccountsRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryAccountsRequest",
      value: QueryAccountsRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryAccountsRequest.decode(message.value);
  },

  toProto(message) {
    return QueryAccountsRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.auth.v1beta1.QueryAccountsRequest",
      value: QueryAccountsRequest.encode(message).finish()
    };
  }

};

function createBaseQueryAccountsResponse() {
  return {
    accounts: [],
    pagination: undefined
  };
}

const QueryAccountsResponse = {
  typeUrl: "/cosmos.auth.v1beta1.QueryAccountsResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    for (const v of message.accounts) {
      _google_protobuf_any__WEBPACK_IMPORTED_MODULE_1__.Any.encode(v, writer.uint32(10).fork()).ldelim();
    }

    if (message.pagination !== undefined) {
      _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryAccountsResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.accounts.push(AccountI_InterfaceDecoder(reader));
          break;

        case 2:
          message.pagination = _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$accounts;

    const message = createBaseQueryAccountsResponse();
    message.accounts = ((_object$accounts = object.accounts) === null || _object$accounts === void 0 ? void 0 : _object$accounts.map(e => _google_protobuf_any__WEBPACK_IMPORTED_MODULE_1__.Any.fromPartial(e))) || [];
    message.pagination = object.pagination !== undefined && object.pagination !== null ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.fromPartial(object.pagination) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      accounts: Array.isArray(object === null || object === void 0 ? void 0 : object.accounts) ? object.accounts.map(e => AccountI_FromAmino(e)) : [],
      pagination: object !== null && object !== void 0 && object.pagination ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.fromAmino(object.pagination) : undefined
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.accounts) {
      obj.accounts = message.accounts.map(e => e ? AccountI_ToAmino(e) : undefined);
    } else {
      obj.accounts = [];
    }

    obj.pagination = message.pagination ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.toAmino(message.pagination) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryAccountsResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryAccountsResponse",
      value: QueryAccountsResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryAccountsResponse.decode(message.value);
  },

  toProto(message) {
    return QueryAccountsResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.auth.v1beta1.QueryAccountsResponse",
      value: QueryAccountsResponse.encode(message).finish()
    };
  }

};

function createBaseQueryAccountRequest() {
  return {
    address: ""
  };
}

const QueryAccountRequest = {
  typeUrl: "/cosmos.auth.v1beta1.QueryAccountRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.address !== "") {
      writer.uint32(10).string(message.address);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryAccountRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.address = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$address;

    const message = createBaseQueryAccountRequest();
    message.address = (_object$address = object.address) !== null && _object$address !== void 0 ? _object$address : "";
    return message;
  },

  fromAmino(object) {
    return {
      address: object.address
    };
  },

  toAmino(message) {
    const obj = {};
    obj.address = message.address;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryAccountRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryAccountRequest",
      value: QueryAccountRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryAccountRequest.decode(message.value);
  },

  toProto(message) {
    return QueryAccountRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.auth.v1beta1.QueryAccountRequest",
      value: QueryAccountRequest.encode(message).finish()
    };
  }

};

function createBaseQueryAccountResponse() {
  return {
    account: undefined
  };
}

const QueryAccountResponse = {
  typeUrl: "/cosmos.auth.v1beta1.QueryAccountResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.account !== undefined) {
      _google_protobuf_any__WEBPACK_IMPORTED_MODULE_1__.Any.encode(message.account, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryAccountResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.account = AccountI_InterfaceDecoder(reader);
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseQueryAccountResponse();
    message.account = object.account !== undefined && object.account !== null ? _google_protobuf_any__WEBPACK_IMPORTED_MODULE_1__.Any.fromPartial(object.account) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      account: object !== null && object !== void 0 && object.account ? AccountI_FromAmino(object.account) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.account = message.account ? AccountI_ToAmino(message.account) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryAccountResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryAccountResponse",
      value: QueryAccountResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryAccountResponse.decode(message.value);
  },

  toProto(message) {
    return QueryAccountResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.auth.v1beta1.QueryAccountResponse",
      value: QueryAccountResponse.encode(message).finish()
    };
  }

};

function createBaseQueryParamsRequest() {
  return {};
}

const QueryParamsRequest = {
  typeUrl: "/cosmos.auth.v1beta1.QueryParamsRequest",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryParamsRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseQueryParamsRequest();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return QueryParamsRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryParamsRequest",
      value: QueryParamsRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryParamsRequest.decode(message.value);
  },

  toProto(message) {
    return QueryParamsRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.auth.v1beta1.QueryParamsRequest",
      value: QueryParamsRequest.encode(message).finish()
    };
  }

};

function createBaseQueryParamsResponse() {
  return {
    params: undefined
  };
}

const QueryParamsResponse = {
  typeUrl: "/cosmos.auth.v1beta1.QueryParamsResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.params !== undefined) {
      _auth__WEBPACK_IMPORTED_MODULE_2__.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryParamsResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.params = _auth__WEBPACK_IMPORTED_MODULE_2__.Params.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseQueryParamsResponse();
    message.params = object.params !== undefined && object.params !== null ? _auth__WEBPACK_IMPORTED_MODULE_2__.Params.fromPartial(object.params) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      params: object !== null && object !== void 0 && object.params ? _auth__WEBPACK_IMPORTED_MODULE_2__.Params.fromAmino(object.params) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.params = message.params ? _auth__WEBPACK_IMPORTED_MODULE_2__.Params.toAmino(message.params) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryParamsResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryParamsResponse",
      value: QueryParamsResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryParamsResponse.decode(message.value);
  },

  toProto(message) {
    return QueryParamsResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.auth.v1beta1.QueryParamsResponse",
      value: QueryParamsResponse.encode(message).finish()
    };
  }

};

function createBaseQueryModuleAccountsRequest() {
  return {};
}

const QueryModuleAccountsRequest = {
  typeUrl: "/cosmos.auth.v1beta1.QueryModuleAccountsRequest",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryModuleAccountsRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseQueryModuleAccountsRequest();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return QueryModuleAccountsRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryModuleAccountsRequest",
      value: QueryModuleAccountsRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryModuleAccountsRequest.decode(message.value);
  },

  toProto(message) {
    return QueryModuleAccountsRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.auth.v1beta1.QueryModuleAccountsRequest",
      value: QueryModuleAccountsRequest.encode(message).finish()
    };
  }

};

function createBaseQueryModuleAccountsResponse() {
  return {
    accounts: []
  };
}

const QueryModuleAccountsResponse = {
  typeUrl: "/cosmos.auth.v1beta1.QueryModuleAccountsResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    for (const v of message.accounts) {
      _google_protobuf_any__WEBPACK_IMPORTED_MODULE_1__.Any.encode(v, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryModuleAccountsResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.accounts.push(ModuleAccountI_InterfaceDecoder(reader));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$accounts2;

    const message = createBaseQueryModuleAccountsResponse();
    message.accounts = ((_object$accounts2 = object.accounts) === null || _object$accounts2 === void 0 ? void 0 : _object$accounts2.map(e => _google_protobuf_any__WEBPACK_IMPORTED_MODULE_1__.Any.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      accounts: Array.isArray(object === null || object === void 0 ? void 0 : object.accounts) ? object.accounts.map(e => ModuleAccountI_FromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.accounts) {
      obj.accounts = message.accounts.map(e => e ? ModuleAccountI_ToAmino(e) : undefined);
    } else {
      obj.accounts = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return QueryModuleAccountsResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryModuleAccountsResponse",
      value: QueryModuleAccountsResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryModuleAccountsResponse.decode(message.value);
  },

  toProto(message) {
    return QueryModuleAccountsResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.auth.v1beta1.QueryModuleAccountsResponse",
      value: QueryModuleAccountsResponse.encode(message).finish()
    };
  }

};
const AccountI_InterfaceDecoder = input => {
  const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
  const data = _google_protobuf_any__WEBPACK_IMPORTED_MODULE_1__.Any.decode(reader, reader.uint32());

  switch (data.typeUrl) {
    case "/cosmos.auth.v1beta1.BaseAccount":
      return _auth__WEBPACK_IMPORTED_MODULE_2__.BaseAccount.decode(data.value);

    default:
      return data;
  }
};
const AccountI_FromAmino = content => {
  switch (content.type) {
    case "cosmos-sdk/BaseAccount":
      return _google_protobuf_any__WEBPACK_IMPORTED_MODULE_1__.Any.fromPartial({
        typeUrl: "/cosmos.auth.v1beta1.BaseAccount",
        value: _auth__WEBPACK_IMPORTED_MODULE_2__.BaseAccount.encode(_auth__WEBPACK_IMPORTED_MODULE_2__.BaseAccount.fromPartial(_auth__WEBPACK_IMPORTED_MODULE_2__.BaseAccount.fromAmino(content.value))).finish()
      });

    default:
      return _google_protobuf_any__WEBPACK_IMPORTED_MODULE_1__.Any.fromAmino(content);
  }
};
const AccountI_ToAmino = content => {
  switch (content.typeUrl) {
    case "/cosmos.auth.v1beta1.BaseAccount":
      return {
        type: "cosmos-sdk/BaseAccount",
        value: _auth__WEBPACK_IMPORTED_MODULE_2__.BaseAccount.toAmino(_auth__WEBPACK_IMPORTED_MODULE_2__.BaseAccount.decode(content.value))
      };

    default:
      return _google_protobuf_any__WEBPACK_IMPORTED_MODULE_1__.Any.toAmino(content);
  }
};
const ModuleAccountI_InterfaceDecoder = input => {
  const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
  const data = _google_protobuf_any__WEBPACK_IMPORTED_MODULE_1__.Any.decode(reader, reader.uint32());

  switch (data.typeUrl) {
    case "/cosmos.auth.v1beta1.ModuleAccount":
      return _auth__WEBPACK_IMPORTED_MODULE_2__.ModuleAccount.decode(data.value);

    default:
      return data;
  }
};
const ModuleAccountI_FromAmino = content => {
  switch (content.type) {
    case "cosmos-sdk/ModuleAccount":
      return _google_protobuf_any__WEBPACK_IMPORTED_MODULE_1__.Any.fromPartial({
        typeUrl: "/cosmos.auth.v1beta1.ModuleAccount",
        value: _auth__WEBPACK_IMPORTED_MODULE_2__.ModuleAccount.encode(_auth__WEBPACK_IMPORTED_MODULE_2__.ModuleAccount.fromPartial(_auth__WEBPACK_IMPORTED_MODULE_2__.ModuleAccount.fromAmino(content.value))).finish()
      });

    default:
      return _google_protobuf_any__WEBPACK_IMPORTED_MODULE_1__.Any.fromAmino(content);
  }
};
const ModuleAccountI_ToAmino = content => {
  switch (content.typeUrl) {
    case "/cosmos.auth.v1beta1.ModuleAccount":
      return {
        type: "cosmos-sdk/ModuleAccount",
        value: _auth__WEBPACK_IMPORTED_MODULE_2__.ModuleAccount.toAmino(_auth__WEBPACK_IMPORTED_MODULE_2__.ModuleAccount.decode(content.value))
      };

    default:
      return _google_protobuf_any__WEBPACK_IMPORTED_MODULE_1__.Any.toAmino(content);
  }
};

/***/ }),

/***/ 88436:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LCDQueryClient": function() { return /* binding */ LCDQueryClient; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4942);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47895);


class LCDQueryClient {
  constructor({
    requestClient
  }) {
    (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, "req", void 0);

    this.req = requestClient;
    this.accounts = this.accounts.bind(this);
    this.account = this.account.bind(this);
    this.params = this.params.bind(this);
    this.moduleAccounts = this.moduleAccounts.bind(this);
  }
  /* Accounts returns all the existing accounts
  
   Since: cosmos-sdk 0.43 */


  async accounts(params = {
    pagination: undefined
  }) {
    const options = {
      params: {}
    };

    if (typeof (params === null || params === void 0 ? void 0 : params.pagination) !== "undefined") {
      (0,_helpers__WEBPACK_IMPORTED_MODULE_0__/* .setPaginationParams */ .q6)(options, params.pagination);
    }

    const endpoint = `cosmos/auth/v1beta1/accounts`;
    return await this.req.get(endpoint, options);
  }
  /* Account returns account details based on address. */


  async account(params) {
    const endpoint = `cosmos/auth/v1beta1/accounts/${params.address}`;
    return await this.req.get(endpoint);
  }
  /* Params queries all parameters. */


  async params(_params = {}) {
    const endpoint = `cosmos/auth/v1beta1/params`;
    return await this.req.get(endpoint);
  }
  /* ModuleAccounts returns all the existing module accounts. */


  async moduleAccounts(_params = {}) {
    const endpoint = `cosmos/auth/v1beta1/module_accounts`;
    return await this.req.get(endpoint);
  }

}

/***/ }),

/***/ 80908:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QueryClientImpl": function() { return /* binding */ QueryClientImpl; },
/* harmony export */   "createRpcQueryExtension": function() { return /* binding */ createRpcQueryExtension; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4942);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78441);
/* harmony import */ var _cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87634);




/** Query defines the gRPC querier service. */

class QueryClientImpl {
  constructor(rpc) {
    (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, "rpc", void 0);

    this.rpc = rpc;
    this.accounts = this.accounts.bind(this);
    this.account = this.account.bind(this);
    this.params = this.params.bind(this);
    this.moduleAccounts = this.moduleAccounts.bind(this);
  }

  accounts(request = {
    pagination: undefined
  }) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryAccountsRequest.encode(request).finish();
    const promise = this.rpc.request("cosmos.auth.v1beta1.Query", "Accounts", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryAccountsResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  account(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryAccountRequest.encode(request).finish();
    const promise = this.rpc.request("cosmos.auth.v1beta1.Query", "Account", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryAccountResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  params(request = {}) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryParamsRequest.encode(request).finish();
    const promise = this.rpc.request("cosmos.auth.v1beta1.Query", "Params", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryParamsResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  moduleAccounts(request = {}) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryModuleAccountsRequest.encode(request).finish();
    const promise = this.rpc.request("cosmos.auth.v1beta1.Query", "ModuleAccounts", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryModuleAccountsResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

}
const createRpcQueryExtension = base => {
  const rpc = (0,_cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1__.createProtobufRpcClient)(base);
  const queryService = new QueryClientImpl(rpc);
  return {
    accounts(request) {
      return queryService.accounts(request);
    },

    account(request) {
      return queryService.account(request);
    },

    params(request) {
      return queryService.params(request);
    },

    moduleAccounts(request) {
      return queryService.moduleAccounts(request);
    }

  };
};

/***/ }),

/***/ 83421:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Authorization_FromAmino": function() { return /* binding */ Authorization_FromAmino; },
/* harmony export */   "Authorization_InterfaceDecoder": function() { return /* binding */ Authorization_InterfaceDecoder; },
/* harmony export */   "Authorization_ToAmino": function() { return /* binding */ Authorization_ToAmino; },
/* harmony export */   "GenericAuthorization": function() { return /* binding */ GenericAuthorization; },
/* harmony export */   "Grant": function() { return /* binding */ Grant; },
/* harmony export */   "GrantAuthorization": function() { return /* binding */ GrantAuthorization; }
/* harmony export */ });
/* harmony import */ var _google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32106);
/* harmony import */ var _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20633);
/* harmony import */ var _bank_v1beta1_authz__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19618);
/* harmony import */ var _staking_v1beta1_authz__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8682);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47895);






/**
 * GenericAuthorization gives the grantee unrestricted permissions to execute
 * the provided method on behalf of the granter's account.
 */

function createBaseGenericAuthorization() {
  return {
    $typeUrl: "/cosmos.authz.v1beta1.GenericAuthorization",
    msg: ""
  };
}

const GenericAuthorization = {
  typeUrl: "/cosmos.authz.v1beta1.GenericAuthorization",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    if (message.msg !== "") {
      writer.uint32(10).string(message.msg);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGenericAuthorization();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.msg = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$msg;

    const message = createBaseGenericAuthorization();
    message.msg = (_object$msg = object.msg) !== null && _object$msg !== void 0 ? _object$msg : "";
    return message;
  },

  fromAmino(object) {
    return {
      msg: object.msg
    };
  },

  toAmino(message) {
    const obj = {};
    obj.msg = message.msg;
    return obj;
  },

  fromAminoMsg(object) {
    return GenericAuthorization.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/GenericAuthorization",
      value: GenericAuthorization.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return GenericAuthorization.decode(message.value);
  },

  toProto(message) {
    return GenericAuthorization.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.authz.v1beta1.GenericAuthorization",
      value: GenericAuthorization.encode(message).finish()
    };
  }

};

function createBaseGrant() {
  return {
    authorization: undefined,
    expiration: undefined
  };
}

const Grant = {
  typeUrl: "/cosmos.authz.v1beta1.Grant",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    if (message.authorization !== undefined) {
      _google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__.Any.encode(message.authorization, writer.uint32(10).fork()).ldelim();
    }

    if (message.expiration !== undefined) {
      _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_1__.Timestamp.encode((0,_helpers__WEBPACK_IMPORTED_MODULE_5__/* .toTimestamp */ .Uq)(message.expiration), writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGrant();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.authorization = Authorization_InterfaceDecoder(reader);
          break;

        case 2:
          message.expiration = (0,_helpers__WEBPACK_IMPORTED_MODULE_5__/* .fromTimestamp */ .Ol)(_google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_1__.Timestamp.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$expiration;

    const message = createBaseGrant();
    message.authorization = object.authorization !== undefined && object.authorization !== null ? _google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__.Any.fromPartial(object.authorization) : undefined;
    message.expiration = (_object$expiration = object.expiration) !== null && _object$expiration !== void 0 ? _object$expiration : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      authorization: object !== null && object !== void 0 && object.authorization ? Authorization_FromAmino(object.authorization) : undefined,
      expiration: object !== null && object !== void 0 && object.expiration ? _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_1__.Timestamp.fromAmino(object.expiration) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.authorization = message.authorization ? Authorization_ToAmino(message.authorization) : undefined;
    obj.expiration = message.expiration ? _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_1__.Timestamp.toAmino(message.expiration) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return Grant.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/Grant",
      value: Grant.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return Grant.decode(message.value);
  },

  toProto(message) {
    return Grant.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.authz.v1beta1.Grant",
      value: Grant.encode(message).finish()
    };
  }

};

function createBaseGrantAuthorization() {
  return {
    granter: "",
    grantee: "",
    authorization: undefined,
    expiration: undefined
  };
}

const GrantAuthorization = {
  typeUrl: "/cosmos.authz.v1beta1.GrantAuthorization",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    if (message.granter !== "") {
      writer.uint32(10).string(message.granter);
    }

    if (message.grantee !== "") {
      writer.uint32(18).string(message.grantee);
    }

    if (message.authorization !== undefined) {
      _google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__.Any.encode(message.authorization, writer.uint32(26).fork()).ldelim();
    }

    if (message.expiration !== undefined) {
      _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_1__.Timestamp.encode((0,_helpers__WEBPACK_IMPORTED_MODULE_5__/* .toTimestamp */ .Uq)(message.expiration), writer.uint32(34).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGrantAuthorization();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.granter = reader.string();
          break;

        case 2:
          message.grantee = reader.string();
          break;

        case 3:
          message.authorization = Authorization_InterfaceDecoder(reader);
          break;

        case 4:
          message.expiration = (0,_helpers__WEBPACK_IMPORTED_MODULE_5__/* .fromTimestamp */ .Ol)(_google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_1__.Timestamp.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$granter, _object$grantee, _object$expiration2;

    const message = createBaseGrantAuthorization();
    message.granter = (_object$granter = object.granter) !== null && _object$granter !== void 0 ? _object$granter : "";
    message.grantee = (_object$grantee = object.grantee) !== null && _object$grantee !== void 0 ? _object$grantee : "";
    message.authorization = object.authorization !== undefined && object.authorization !== null ? _google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__.Any.fromPartial(object.authorization) : undefined;
    message.expiration = (_object$expiration2 = object.expiration) !== null && _object$expiration2 !== void 0 ? _object$expiration2 : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      granter: object.granter,
      grantee: object.grantee,
      authorization: object !== null && object !== void 0 && object.authorization ? Authorization_FromAmino(object.authorization) : undefined,
      expiration: object !== null && object !== void 0 && object.expiration ? _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_1__.Timestamp.fromAmino(object.expiration) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.granter = message.granter;
    obj.grantee = message.grantee;
    obj.authorization = message.authorization ? Authorization_ToAmino(message.authorization) : undefined;
    obj.expiration = message.expiration ? _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_1__.Timestamp.toAmino(message.expiration) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return GrantAuthorization.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/GrantAuthorization",
      value: GrantAuthorization.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return GrantAuthorization.decode(message.value);
  },

  toProto(message) {
    return GrantAuthorization.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.authz.v1beta1.GrantAuthorization",
      value: GrantAuthorization.encode(message).finish()
    };
  }

};
const Authorization_InterfaceDecoder = input => {
  const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
  const data = _google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__.Any.decode(reader, reader.uint32());

  switch (data.typeUrl) {
    case "/cosmos.authz.v1beta1.GenericAuthorization":
      return GenericAuthorization.decode(data.value);

    case "/cosmos.bank.v1beta1.SendAuthorization":
      return _bank_v1beta1_authz__WEBPACK_IMPORTED_MODULE_2__.SendAuthorization.decode(data.value);

    case "/cosmos.staking.v1beta1.StakeAuthorization":
      return _staking_v1beta1_authz__WEBPACK_IMPORTED_MODULE_3__.StakeAuthorization.decode(data.value);

    default:
      return data;
  }
};
const Authorization_FromAmino = content => {
  switch (content.type) {
    case "cosmos-sdk/GenericAuthorization":
      return _google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__.Any.fromPartial({
        typeUrl: "/cosmos.authz.v1beta1.GenericAuthorization",
        value: GenericAuthorization.encode(GenericAuthorization.fromPartial(GenericAuthorization.fromAmino(content.value))).finish()
      });

    case "cosmos-sdk/SendAuthorization":
      return _google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__.Any.fromPartial({
        typeUrl: "/cosmos.bank.v1beta1.SendAuthorization",
        value: _bank_v1beta1_authz__WEBPACK_IMPORTED_MODULE_2__.SendAuthorization.encode(_bank_v1beta1_authz__WEBPACK_IMPORTED_MODULE_2__.SendAuthorization.fromPartial(_bank_v1beta1_authz__WEBPACK_IMPORTED_MODULE_2__.SendAuthorization.fromAmino(content.value))).finish()
      });

    case "cosmos-sdk/StakeAuthorization":
      return _google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__.Any.fromPartial({
        typeUrl: "/cosmos.staking.v1beta1.StakeAuthorization",
        value: _staking_v1beta1_authz__WEBPACK_IMPORTED_MODULE_3__.StakeAuthorization.encode(_staking_v1beta1_authz__WEBPACK_IMPORTED_MODULE_3__.StakeAuthorization.fromPartial(_staking_v1beta1_authz__WEBPACK_IMPORTED_MODULE_3__.StakeAuthorization.fromAmino(content.value))).finish()
      });

    default:
      return _google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__.Any.fromAmino(content);
  }
};
const Authorization_ToAmino = content => {
  switch (content.typeUrl) {
    case "/cosmos.authz.v1beta1.GenericAuthorization":
      return {
        type: "cosmos-sdk/GenericAuthorization",
        value: GenericAuthorization.toAmino(GenericAuthorization.decode(content.value))
      };

    case "/cosmos.bank.v1beta1.SendAuthorization":
      return {
        type: "cosmos-sdk/SendAuthorization",
        value: _bank_v1beta1_authz__WEBPACK_IMPORTED_MODULE_2__.SendAuthorization.toAmino(_bank_v1beta1_authz__WEBPACK_IMPORTED_MODULE_2__.SendAuthorization.decode(content.value))
      };

    case "/cosmos.staking.v1beta1.StakeAuthorization":
      return {
        type: "cosmos-sdk/StakeAuthorization",
        value: _staking_v1beta1_authz__WEBPACK_IMPORTED_MODULE_3__.StakeAuthorization.toAmino(_staking_v1beta1_authz__WEBPACK_IMPORTED_MODULE_3__.StakeAuthorization.decode(content.value))
      };

    default:
      return _google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__.Any.toAmino(content);
  }
};

/***/ }),

/***/ 31482:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QueryGranteeGrantsRequest": function() { return /* binding */ QueryGranteeGrantsRequest; },
/* harmony export */   "QueryGranteeGrantsResponse": function() { return /* binding */ QueryGranteeGrantsResponse; },
/* harmony export */   "QueryGranterGrantsRequest": function() { return /* binding */ QueryGranterGrantsRequest; },
/* harmony export */   "QueryGranterGrantsResponse": function() { return /* binding */ QueryGranterGrantsResponse; },
/* harmony export */   "QueryGrantsRequest": function() { return /* binding */ QueryGrantsRequest; },
/* harmony export */   "QueryGrantsResponse": function() { return /* binding */ QueryGrantsResponse; }
/* harmony export */ });
/* harmony import */ var _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48978);
/* harmony import */ var _authz__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83421);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__);



/** QueryGrantsRequest is the request type for the Query/Grants RPC method. */

function createBaseQueryGrantsRequest() {
  return {
    granter: "",
    grantee: "",
    msgTypeUrl: "",
    pagination: undefined
  };
}

const QueryGrantsRequest = {
  typeUrl: "/cosmos.authz.v1beta1.QueryGrantsRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (message.granter !== "") {
      writer.uint32(10).string(message.granter);
    }

    if (message.grantee !== "") {
      writer.uint32(18).string(message.grantee);
    }

    if (message.msgTypeUrl !== "") {
      writer.uint32(26).string(message.msgTypeUrl);
    }

    if (message.pagination !== undefined) {
      _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.encode(message.pagination, writer.uint32(34).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryGrantsRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.granter = reader.string();
          break;

        case 2:
          message.grantee = reader.string();
          break;

        case 3:
          message.msgTypeUrl = reader.string();
          break;

        case 4:
          message.pagination = _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$granter, _object$grantee, _object$msgTypeUrl;

    const message = createBaseQueryGrantsRequest();
    message.granter = (_object$granter = object.granter) !== null && _object$granter !== void 0 ? _object$granter : "";
    message.grantee = (_object$grantee = object.grantee) !== null && _object$grantee !== void 0 ? _object$grantee : "";
    message.msgTypeUrl = (_object$msgTypeUrl = object.msgTypeUrl) !== null && _object$msgTypeUrl !== void 0 ? _object$msgTypeUrl : "";
    message.pagination = object.pagination !== undefined && object.pagination !== null ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.fromPartial(object.pagination) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      granter: object.granter,
      grantee: object.grantee,
      msgTypeUrl: object.msg_type_url,
      pagination: object !== null && object !== void 0 && object.pagination ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.fromAmino(object.pagination) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.granter = message.granter;
    obj.grantee = message.grantee;
    obj.msg_type_url = message.msgTypeUrl;
    obj.pagination = message.pagination ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.toAmino(message.pagination) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryGrantsRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryGrantsRequest",
      value: QueryGrantsRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryGrantsRequest.decode(message.value);
  },

  toProto(message) {
    return QueryGrantsRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.authz.v1beta1.QueryGrantsRequest",
      value: QueryGrantsRequest.encode(message).finish()
    };
  }

};

function createBaseQueryGrantsResponse() {
  return {
    grants: [],
    pagination: undefined
  };
}

const QueryGrantsResponse = {
  typeUrl: "/cosmos.authz.v1beta1.QueryGrantsResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    for (const v of message.grants) {
      _authz__WEBPACK_IMPORTED_MODULE_1__.Grant.encode(v, writer.uint32(10).fork()).ldelim();
    }

    if (message.pagination !== undefined) {
      _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryGrantsResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.grants.push(_authz__WEBPACK_IMPORTED_MODULE_1__.Grant.decode(reader, reader.uint32()));
          break;

        case 2:
          message.pagination = _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$grants;

    const message = createBaseQueryGrantsResponse();
    message.grants = ((_object$grants = object.grants) === null || _object$grants === void 0 ? void 0 : _object$grants.map(e => _authz__WEBPACK_IMPORTED_MODULE_1__.Grant.fromPartial(e))) || [];
    message.pagination = object.pagination !== undefined && object.pagination !== null ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.fromPartial(object.pagination) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      grants: Array.isArray(object === null || object === void 0 ? void 0 : object.grants) ? object.grants.map(e => _authz__WEBPACK_IMPORTED_MODULE_1__.Grant.fromAmino(e)) : [],
      pagination: object !== null && object !== void 0 && object.pagination ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.fromAmino(object.pagination) : undefined
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.grants) {
      obj.grants = message.grants.map(e => e ? _authz__WEBPACK_IMPORTED_MODULE_1__.Grant.toAmino(e) : undefined);
    } else {
      obj.grants = [];
    }

    obj.pagination = message.pagination ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.toAmino(message.pagination) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryGrantsResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryGrantsResponse",
      value: QueryGrantsResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryGrantsResponse.decode(message.value);
  },

  toProto(message) {
    return QueryGrantsResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.authz.v1beta1.QueryGrantsResponse",
      value: QueryGrantsResponse.encode(message).finish()
    };
  }

};

function createBaseQueryGranterGrantsRequest() {
  return {
    granter: "",
    pagination: undefined
  };
}

const QueryGranterGrantsRequest = {
  typeUrl: "/cosmos.authz.v1beta1.QueryGranterGrantsRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (message.granter !== "") {
      writer.uint32(10).string(message.granter);
    }

    if (message.pagination !== undefined) {
      _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryGranterGrantsRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.granter = reader.string();
          break;

        case 2:
          message.pagination = _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$granter2;

    const message = createBaseQueryGranterGrantsRequest();
    message.granter = (_object$granter2 = object.granter) !== null && _object$granter2 !== void 0 ? _object$granter2 : "";
    message.pagination = object.pagination !== undefined && object.pagination !== null ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.fromPartial(object.pagination) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      granter: object.granter,
      pagination: object !== null && object !== void 0 && object.pagination ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.fromAmino(object.pagination) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.granter = message.granter;
    obj.pagination = message.pagination ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.toAmino(message.pagination) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryGranterGrantsRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryGranterGrantsRequest",
      value: QueryGranterGrantsRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryGranterGrantsRequest.decode(message.value);
  },

  toProto(message) {
    return QueryGranterGrantsRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.authz.v1beta1.QueryGranterGrantsRequest",
      value: QueryGranterGrantsRequest.encode(message).finish()
    };
  }

};

function createBaseQueryGranterGrantsResponse() {
  return {
    grants: [],
    pagination: undefined
  };
}

const QueryGranterGrantsResponse = {
  typeUrl: "/cosmos.authz.v1beta1.QueryGranterGrantsResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    for (const v of message.grants) {
      _authz__WEBPACK_IMPORTED_MODULE_1__.GrantAuthorization.encode(v, writer.uint32(10).fork()).ldelim();
    }

    if (message.pagination !== undefined) {
      _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryGranterGrantsResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.grants.push(_authz__WEBPACK_IMPORTED_MODULE_1__.GrantAuthorization.decode(reader, reader.uint32()));
          break;

        case 2:
          message.pagination = _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$grants2;

    const message = createBaseQueryGranterGrantsResponse();
    message.grants = ((_object$grants2 = object.grants) === null || _object$grants2 === void 0 ? void 0 : _object$grants2.map(e => _authz__WEBPACK_IMPORTED_MODULE_1__.GrantAuthorization.fromPartial(e))) || [];
    message.pagination = object.pagination !== undefined && object.pagination !== null ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.fromPartial(object.pagination) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      grants: Array.isArray(object === null || object === void 0 ? void 0 : object.grants) ? object.grants.map(e => _authz__WEBPACK_IMPORTED_MODULE_1__.GrantAuthorization.fromAmino(e)) : [],
      pagination: object !== null && object !== void 0 && object.pagination ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.fromAmino(object.pagination) : undefined
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.grants) {
      obj.grants = message.grants.map(e => e ? _authz__WEBPACK_IMPORTED_MODULE_1__.GrantAuthorization.toAmino(e) : undefined);
    } else {
      obj.grants = [];
    }

    obj.pagination = message.pagination ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.toAmino(message.pagination) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryGranterGrantsResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryGranterGrantsResponse",
      value: QueryGranterGrantsResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryGranterGrantsResponse.decode(message.value);
  },

  toProto(message) {
    return QueryGranterGrantsResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.authz.v1beta1.QueryGranterGrantsResponse",
      value: QueryGranterGrantsResponse.encode(message).finish()
    };
  }

};

function createBaseQueryGranteeGrantsRequest() {
  return {
    grantee: "",
    pagination: undefined
  };
}

const QueryGranteeGrantsRequest = {
  typeUrl: "/cosmos.authz.v1beta1.QueryGranteeGrantsRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (message.grantee !== "") {
      writer.uint32(10).string(message.grantee);
    }

    if (message.pagination !== undefined) {
      _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryGranteeGrantsRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.grantee = reader.string();
          break;

        case 2:
          message.pagination = _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$grantee2;

    const message = createBaseQueryGranteeGrantsRequest();
    message.grantee = (_object$grantee2 = object.grantee) !== null && _object$grantee2 !== void 0 ? _object$grantee2 : "";
    message.pagination = object.pagination !== undefined && object.pagination !== null ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.fromPartial(object.pagination) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      grantee: object.grantee,
      pagination: object !== null && object !== void 0 && object.pagination ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.fromAmino(object.pagination) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.grantee = message.grantee;
    obj.pagination = message.pagination ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.toAmino(message.pagination) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryGranteeGrantsRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryGranteeGrantsRequest",
      value: QueryGranteeGrantsRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryGranteeGrantsRequest.decode(message.value);
  },

  toProto(message) {
    return QueryGranteeGrantsRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.authz.v1beta1.QueryGranteeGrantsRequest",
      value: QueryGranteeGrantsRequest.encode(message).finish()
    };
  }

};

function createBaseQueryGranteeGrantsResponse() {
  return {
    grants: [],
    pagination: undefined
  };
}

const QueryGranteeGrantsResponse = {
  typeUrl: "/cosmos.authz.v1beta1.QueryGranteeGrantsResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    for (const v of message.grants) {
      _authz__WEBPACK_IMPORTED_MODULE_1__.GrantAuthorization.encode(v, writer.uint32(10).fork()).ldelim();
    }

    if (message.pagination !== undefined) {
      _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryGranteeGrantsResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.grants.push(_authz__WEBPACK_IMPORTED_MODULE_1__.GrantAuthorization.decode(reader, reader.uint32()));
          break;

        case 2:
          message.pagination = _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$grants3;

    const message = createBaseQueryGranteeGrantsResponse();
    message.grants = ((_object$grants3 = object.grants) === null || _object$grants3 === void 0 ? void 0 : _object$grants3.map(e => _authz__WEBPACK_IMPORTED_MODULE_1__.GrantAuthorization.fromPartial(e))) || [];
    message.pagination = object.pagination !== undefined && object.pagination !== null ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.fromPartial(object.pagination) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      grants: Array.isArray(object === null || object === void 0 ? void 0 : object.grants) ? object.grants.map(e => _authz__WEBPACK_IMPORTED_MODULE_1__.GrantAuthorization.fromAmino(e)) : [],
      pagination: object !== null && object !== void 0 && object.pagination ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.fromAmino(object.pagination) : undefined
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.grants) {
      obj.grants = message.grants.map(e => e ? _authz__WEBPACK_IMPORTED_MODULE_1__.GrantAuthorization.toAmino(e) : undefined);
    } else {
      obj.grants = [];
    }

    obj.pagination = message.pagination ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.toAmino(message.pagination) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryGranteeGrantsResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryGranteeGrantsResponse",
      value: QueryGranteeGrantsResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryGranteeGrantsResponse.decode(message.value);
  },

  toProto(message) {
    return QueryGranteeGrantsResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.authz.v1beta1.QueryGranteeGrantsResponse",
      value: QueryGranteeGrantsResponse.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 73300:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LCDQueryClient": function() { return /* binding */ LCDQueryClient; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4942);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47895);


class LCDQueryClient {
  constructor({
    requestClient
  }) {
    (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, "req", void 0);

    this.req = requestClient;
    this.grants = this.grants.bind(this);
    this.granterGrants = this.granterGrants.bind(this);
    this.granteeGrants = this.granteeGrants.bind(this);
  }
  /* Returns list of `Authorization`, granted to the grantee by the granter. */


  async grants(params) {
    const options = {
      params: {}
    };

    if (typeof (params === null || params === void 0 ? void 0 : params.granter) !== "undefined") {
      options.params.granter = params.granter;
    }

    if (typeof (params === null || params === void 0 ? void 0 : params.grantee) !== "undefined") {
      options.params.grantee = params.grantee;
    }

    if (typeof (params === null || params === void 0 ? void 0 : params.msgTypeUrl) !== "undefined") {
      options.params.msg_type_url = params.msgTypeUrl;
    }

    if (typeof (params === null || params === void 0 ? void 0 : params.pagination) !== "undefined") {
      (0,_helpers__WEBPACK_IMPORTED_MODULE_0__/* .setPaginationParams */ .q6)(options, params.pagination);
    }

    const endpoint = `cosmos/authz/v1beta1/grants`;
    return await this.req.get(endpoint, options);
  }
  /* GranterGrants returns list of `Authorization`, granted by granter. */


  async granterGrants(params) {
    const options = {
      params: {}
    };

    if (typeof (params === null || params === void 0 ? void 0 : params.pagination) !== "undefined") {
      (0,_helpers__WEBPACK_IMPORTED_MODULE_0__/* .setPaginationParams */ .q6)(options, params.pagination);
    }

    const endpoint = `cosmos/authz/v1beta1/grants/granter/${params.granter}`;
    return await this.req.get(endpoint, options);
  }
  /* GranteeGrants returns a list of `GrantAuthorization` by grantee. */


  async granteeGrants(params) {
    const options = {
      params: {}
    };

    if (typeof (params === null || params === void 0 ? void 0 : params.pagination) !== "undefined") {
      (0,_helpers__WEBPACK_IMPORTED_MODULE_0__/* .setPaginationParams */ .q6)(options, params.pagination);
    }

    const endpoint = `cosmos/authz/v1beta1/grants/grantee/${params.grantee}`;
    return await this.req.get(endpoint, options);
  }

}

/***/ }),

/***/ 64139:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QueryClientImpl": function() { return /* binding */ QueryClientImpl; },
/* harmony export */   "createRpcQueryExtension": function() { return /* binding */ createRpcQueryExtension; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4942);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78441);
/* harmony import */ var _cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31482);




/** Query defines the gRPC querier service. */

class QueryClientImpl {
  constructor(rpc) {
    (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, "rpc", void 0);

    this.rpc = rpc;
    this.grants = this.grants.bind(this);
    this.granterGrants = this.granterGrants.bind(this);
    this.granteeGrants = this.granteeGrants.bind(this);
  }

  grants(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryGrantsRequest.encode(request).finish();
    const promise = this.rpc.request("cosmos.authz.v1beta1.Query", "Grants", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryGrantsResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  granterGrants(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryGranterGrantsRequest.encode(request).finish();
    const promise = this.rpc.request("cosmos.authz.v1beta1.Query", "GranterGrants", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryGranterGrantsResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  granteeGrants(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryGranteeGrantsRequest.encode(request).finish();
    const promise = this.rpc.request("cosmos.authz.v1beta1.Query", "GranteeGrants", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryGranteeGrantsResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

}
const createRpcQueryExtension = base => {
  const rpc = (0,_cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1__.createProtobufRpcClient)(base);
  const queryService = new QueryClientImpl(rpc);
  return {
    grants(request) {
      return queryService.grants(request);
    },

    granterGrants(request) {
      return queryService.granterGrants(request);
    },

    granteeGrants(request) {
      return queryService.granteeGrants(request);
    }

  };
};

/***/ }),

/***/ 51355:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Authz_Authorization_FromAmino": function() { return /* binding */ Authz_Authorization_FromAmino; },
/* harmony export */   "Authz_Authorization_InterfaceDecoder": function() { return /* binding */ Authz_Authorization_InterfaceDecoder; },
/* harmony export */   "Authz_Authorization_ToAmino": function() { return /* binding */ Authz_Authorization_ToAmino; },
/* harmony export */   "MsgExec": function() { return /* binding */ MsgExec; },
/* harmony export */   "MsgExecResponse": function() { return /* binding */ MsgExecResponse; },
/* harmony export */   "MsgGrant": function() { return /* binding */ MsgGrant; },
/* harmony export */   "MsgGrantResponse": function() { return /* binding */ MsgGrantResponse; },
/* harmony export */   "MsgRevoke": function() { return /* binding */ MsgRevoke; },
/* harmony export */   "MsgRevokeResponse": function() { return /* binding */ MsgRevokeResponse; },
/* harmony export */   "Sdk_Msg_FromAmino": function() { return /* binding */ Sdk_Msg_FromAmino; },
/* harmony export */   "Sdk_Msg_InterfaceDecoder": function() { return /* binding */ Sdk_Msg_InterfaceDecoder; },
/* harmony export */   "Sdk_Msg_ToAmino": function() { return /* binding */ Sdk_Msg_ToAmino; }
/* harmony export */ });
/* harmony import */ var _authz__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83421);
/* harmony import */ var _google_protobuf_any__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32106);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__);



/**
 * MsgGrant is a request type for Grant method. It declares authorization to the grantee
 * on behalf of the granter with the provided expiration time.
 */

function createBaseMsgGrant() {
  return {
    granter: "",
    grantee: "",
    grant: undefined
  };
}

const MsgGrant = {
  typeUrl: "/cosmos.authz.v1beta1.MsgGrant",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (message.granter !== "") {
      writer.uint32(10).string(message.granter);
    }

    if (message.grantee !== "") {
      writer.uint32(18).string(message.grantee);
    }

    if (message.grant !== undefined) {
      _authz__WEBPACK_IMPORTED_MODULE_0__.Grant.encode(message.grant, writer.uint32(26).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgGrant();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.granter = reader.string();
          break;

        case 2:
          message.grantee = reader.string();
          break;

        case 3:
          message.grant = _authz__WEBPACK_IMPORTED_MODULE_0__.Grant.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$granter, _object$grantee;

    const message = createBaseMsgGrant();
    message.granter = (_object$granter = object.granter) !== null && _object$granter !== void 0 ? _object$granter : "";
    message.grantee = (_object$grantee = object.grantee) !== null && _object$grantee !== void 0 ? _object$grantee : "";
    message.grant = object.grant !== undefined && object.grant !== null ? _authz__WEBPACK_IMPORTED_MODULE_0__.Grant.fromPartial(object.grant) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      granter: object.granter,
      grantee: object.grantee,
      grant: object !== null && object !== void 0 && object.grant ? _authz__WEBPACK_IMPORTED_MODULE_0__.Grant.fromAmino(object.grant) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.granter = message.granter;
    obj.grantee = message.grantee;
    obj.grant = message.grant ? _authz__WEBPACK_IMPORTED_MODULE_0__.Grant.toAmino(message.grant) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgGrant.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/MsgGrant",
      value: MsgGrant.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgGrant.decode(message.value);
  },

  toProto(message) {
    return MsgGrant.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.authz.v1beta1.MsgGrant",
      value: MsgGrant.encode(message).finish()
    };
  }

};

function createBaseMsgExecResponse() {
  return {
    results: []
  };
}

const MsgExecResponse = {
  typeUrl: "/cosmos.authz.v1beta1.MsgExecResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    for (const v of message.results) {
      writer.uint32(10).bytes(v);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgExecResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.results.push(reader.bytes());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$results;

    const message = createBaseMsgExecResponse();
    message.results = ((_object$results = object.results) === null || _object$results === void 0 ? void 0 : _object$results.map(e => e)) || [];
    return message;
  },

  fromAmino(object) {
    return {
      results: Array.isArray(object === null || object === void 0 ? void 0 : object.results) ? object.results.map(e => e) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.results) {
      obj.results = message.results.map(e => e);
    } else {
      obj.results = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return MsgExecResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/MsgExecResponse",
      value: MsgExecResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgExecResponse.decode(message.value);
  },

  toProto(message) {
    return MsgExecResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.authz.v1beta1.MsgExecResponse",
      value: MsgExecResponse.encode(message).finish()
    };
  }

};

function createBaseMsgExec() {
  return {
    grantee: "",
    msgs: []
  };
}

const MsgExec = {
  typeUrl: "/cosmos.authz.v1beta1.MsgExec",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (message.grantee !== "") {
      writer.uint32(10).string(message.grantee);
    }

    for (const v of message.msgs) {
      _google_protobuf_any__WEBPACK_IMPORTED_MODULE_1__.Any.encode(v, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgExec();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.grantee = reader.string();
          break;

        case 2:
          message.msgs.push(Sdk_MsgauthzAuthorization_InterfaceDecoder(reader));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$grantee2, _object$msgs;

    const message = createBaseMsgExec();
    message.grantee = (_object$grantee2 = object.grantee) !== null && _object$grantee2 !== void 0 ? _object$grantee2 : "";
    message.msgs = ((_object$msgs = object.msgs) === null || _object$msgs === void 0 ? void 0 : _object$msgs.map(e => _google_protobuf_any__WEBPACK_IMPORTED_MODULE_1__.Any.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      grantee: object.grantee,
      msgs: Array.isArray(object === null || object === void 0 ? void 0 : object.msgs) ? object.msgs.map(e => Sdk_MsgauthzAuthorization_FromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.grantee = message.grantee;

    if (message.msgs) {
      obj.msgs = message.msgs.map(e => e ? Sdk_MsgauthzAuthorization_ToAmino(e) : undefined);
    } else {
      obj.msgs = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return MsgExec.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/MsgExec",
      value: MsgExec.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgExec.decode(message.value);
  },

  toProto(message) {
    return MsgExec.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.authz.v1beta1.MsgExec",
      value: MsgExec.encode(message).finish()
    };
  }

};

function createBaseMsgGrantResponse() {
  return {};
}

const MsgGrantResponse = {
  typeUrl: "/cosmos.authz.v1beta1.MsgGrantResponse",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgGrantResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseMsgGrantResponse();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return MsgGrantResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/MsgGrantResponse",
      value: MsgGrantResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgGrantResponse.decode(message.value);
  },

  toProto(message) {
    return MsgGrantResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.authz.v1beta1.MsgGrantResponse",
      value: MsgGrantResponse.encode(message).finish()
    };
  }

};

function createBaseMsgRevoke() {
  return {
    granter: "",
    grantee: "",
    msgTypeUrl: ""
  };
}

const MsgRevoke = {
  typeUrl: "/cosmos.authz.v1beta1.MsgRevoke",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (message.granter !== "") {
      writer.uint32(10).string(message.granter);
    }

    if (message.grantee !== "") {
      writer.uint32(18).string(message.grantee);
    }

    if (message.msgTypeUrl !== "") {
      writer.uint32(26).string(message.msgTypeUrl);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgRevoke();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.granter = reader.string();
          break;

        case 2:
          message.grantee = reader.string();
          break;

        case 3:
          message.msgTypeUrl = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$granter2, _object$grantee3, _object$msgTypeUrl;

    const message = createBaseMsgRevoke();
    message.granter = (_object$granter2 = object.granter) !== null && _object$granter2 !== void 0 ? _object$granter2 : "";
    message.grantee = (_object$grantee3 = object.grantee) !== null && _object$grantee3 !== void 0 ? _object$grantee3 : "";
    message.msgTypeUrl = (_object$msgTypeUrl = object.msgTypeUrl) !== null && _object$msgTypeUrl !== void 0 ? _object$msgTypeUrl : "";
    return message;
  },

  fromAmino(object) {
    return {
      granter: object.granter,
      grantee: object.grantee,
      msgTypeUrl: object.msg_type_url
    };
  },

  toAmino(message) {
    const obj = {};
    obj.granter = message.granter;
    obj.grantee = message.grantee;
    obj.msg_type_url = message.msgTypeUrl;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgRevoke.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/MsgRevoke",
      value: MsgRevoke.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgRevoke.decode(message.value);
  },

  toProto(message) {
    return MsgRevoke.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.authz.v1beta1.MsgRevoke",
      value: MsgRevoke.encode(message).finish()
    };
  }

};

function createBaseMsgRevokeResponse() {
  return {};
}

const MsgRevokeResponse = {
  typeUrl: "/cosmos.authz.v1beta1.MsgRevokeResponse",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgRevokeResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseMsgRevokeResponse();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return MsgRevokeResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/MsgRevokeResponse",
      value: MsgRevokeResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgRevokeResponse.decode(message.value);
  },

  toProto(message) {
    return MsgRevokeResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.authz.v1beta1.MsgRevokeResponse",
      value: MsgRevokeResponse.encode(message).finish()
    };
  }

};
const Sdk_Msg_InterfaceDecoder = input => {
  const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
  const data = _google_protobuf_any__WEBPACK_IMPORTED_MODULE_1__.Any.decode(reader, reader.uint32());

  switch (data.typeUrl) {
    default:
      return data;
  }
};
const Sdk_Msg_FromAmino = content => {
  return _google_protobuf_any__WEBPACK_IMPORTED_MODULE_1__.Any.fromAmino(content);
};
const Sdk_Msg_ToAmino = content => {
  return _google_protobuf_any__WEBPACK_IMPORTED_MODULE_1__.Any.toAmino(content);
};
const Authz_Authorization_InterfaceDecoder = input => {
  const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
  const data = _google_protobuf_any__WEBPACK_IMPORTED_MODULE_1__.Any.decode(reader, reader.uint32());

  switch (data.typeUrl) {
    default:
      return data;
  }
};
const Authz_Authorization_FromAmino = content => {
  return _google_protobuf_any__WEBPACK_IMPORTED_MODULE_1__.Any.fromAmino(content);
};
const Authz_Authorization_ToAmino = content => {
  return _google_protobuf_any__WEBPACK_IMPORTED_MODULE_1__.Any.toAmino(content);
};

/***/ }),

/***/ 35773:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MsgClientImpl": function() { return /* binding */ MsgClientImpl; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4942);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _tx__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51355);



/** Msg defines the authz Msg service. */

class MsgClientImpl {
  constructor(rpc) {
    (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, "rpc", void 0);

    this.rpc = rpc;
    this.grant = this.grant.bind(this);
    this.exec = this.exec.bind(this);
    this.revoke = this.revoke.bind(this);
  }

  grant(request) {
    const data = _tx__WEBPACK_IMPORTED_MODULE_1__.MsgGrant.encode(request).finish();
    const promise = this.rpc.request("cosmos.authz.v1beta1.Msg", "Grant", data);
    return promise.then(data => _tx__WEBPACK_IMPORTED_MODULE_1__.MsgGrantResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  exec(request) {
    const data = _tx__WEBPACK_IMPORTED_MODULE_1__.MsgExec.encode(request).finish();
    const promise = this.rpc.request("cosmos.authz.v1beta1.Msg", "Exec", data);
    return promise.then(data => _tx__WEBPACK_IMPORTED_MODULE_1__.MsgExecResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  revoke(request) {
    const data = _tx__WEBPACK_IMPORTED_MODULE_1__.MsgRevoke.encode(request).finish();
    const promise = this.rpc.request("cosmos.authz.v1beta1.Msg", "Revoke", data);
    return promise.then(data => _tx__WEBPACK_IMPORTED_MODULE_1__.MsgRevokeResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

}

/***/ }),

/***/ 19618:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SendAuthorization": function() { return /* binding */ SendAuthorization; }
/* harmony export */ });
/* harmony import */ var _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26178);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__);


/**
 * SendAuthorization allows the grantee to spend up to spend_limit coins from
 * the granter's account.
 * 
 * Since: cosmos-sdk 0.43
 */

function createBaseSendAuthorization() {
  return {
    $typeUrl: "/cosmos.bank.v1beta1.SendAuthorization",
    spendLimit: []
  };
}

const SendAuthorization = {
  typeUrl: "/cosmos.bank.v1beta1.SendAuthorization",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Writer.create()) {
    for (const v of message.spendLimit) {
      _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.encode(v, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSendAuthorization();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.spendLimit.push(_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$spendLimit;

    const message = createBaseSendAuthorization();
    message.spendLimit = ((_object$spendLimit = object.spendLimit) === null || _object$spendLimit === void 0 ? void 0 : _object$spendLimit.map(e => _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      spendLimit: Array.isArray(object === null || object === void 0 ? void 0 : object.spend_limit) ? object.spend_limit.map(e => _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.spendLimit) {
      obj.spend_limit = message.spendLimit.map(e => e ? _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.toAmino(e) : undefined);
    } else {
      obj.spend_limit = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return SendAuthorization.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/SendAuthorization",
      value: SendAuthorization.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return SendAuthorization.decode(message.value);
  },

  toProto(message) {
    return SendAuthorization.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.bank.v1beta1.SendAuthorization",
      value: SendAuthorization.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 38986:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DenomUnit": function() { return /* binding */ DenomUnit; },
/* harmony export */   "Input": function() { return /* binding */ Input; },
/* harmony export */   "Metadata": function() { return /* binding */ Metadata; },
/* harmony export */   "Output": function() { return /* binding */ Output; },
/* harmony export */   "Params": function() { return /* binding */ Params; },
/* harmony export */   "SendEnabled": function() { return /* binding */ SendEnabled; },
/* harmony export */   "Supply": function() { return /* binding */ Supply; }
/* harmony export */ });
/* harmony import */ var _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26178);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__);


/** Params defines the parameters for the bank module. */

function createBaseParams() {
  return {
    sendEnabled: [],
    defaultSendEnabled: false
  };
}

const Params = {
  typeUrl: "/cosmos.bank.v1beta1.Params",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Writer.create()) {
    for (const v of message.sendEnabled) {
      SendEnabled.encode(v, writer.uint32(10).fork()).ldelim();
    }

    if (message.defaultSendEnabled === true) {
      writer.uint32(16).bool(message.defaultSendEnabled);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseParams();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.sendEnabled.push(SendEnabled.decode(reader, reader.uint32()));
          break;

        case 2:
          message.defaultSendEnabled = reader.bool();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$sendEnabled, _object$defaultSendEn;

    const message = createBaseParams();
    message.sendEnabled = ((_object$sendEnabled = object.sendEnabled) === null || _object$sendEnabled === void 0 ? void 0 : _object$sendEnabled.map(e => SendEnabled.fromPartial(e))) || [];
    message.defaultSendEnabled = (_object$defaultSendEn = object.defaultSendEnabled) !== null && _object$defaultSendEn !== void 0 ? _object$defaultSendEn : false;
    return message;
  },

  fromAmino(object) {
    return {
      sendEnabled: Array.isArray(object === null || object === void 0 ? void 0 : object.send_enabled) ? object.send_enabled.map(e => SendEnabled.fromAmino(e)) : [],
      defaultSendEnabled: object.default_send_enabled
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.sendEnabled) {
      obj.send_enabled = message.sendEnabled.map(e => e ? SendEnabled.toAmino(e) : undefined);
    } else {
      obj.send_enabled = [];
    }

    obj.default_send_enabled = message.defaultSendEnabled;
    return obj;
  },

  fromAminoMsg(object) {
    return Params.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/x/bank/Params",
      value: Params.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return Params.decode(message.value);
  },

  toProto(message) {
    return Params.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.bank.v1beta1.Params",
      value: Params.encode(message).finish()
    };
  }

};

function createBaseSendEnabled() {
  return {
    denom: "",
    enabled: false
  };
}

const SendEnabled = {
  typeUrl: "/cosmos.bank.v1beta1.SendEnabled",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Writer.create()) {
    if (message.denom !== "") {
      writer.uint32(10).string(message.denom);
    }

    if (message.enabled === true) {
      writer.uint32(16).bool(message.enabled);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSendEnabled();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.denom = reader.string();
          break;

        case 2:
          message.enabled = reader.bool();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$denom, _object$enabled;

    const message = createBaseSendEnabled();
    message.denom = (_object$denom = object.denom) !== null && _object$denom !== void 0 ? _object$denom : "";
    message.enabled = (_object$enabled = object.enabled) !== null && _object$enabled !== void 0 ? _object$enabled : false;
    return message;
  },

  fromAmino(object) {
    return {
      denom: object.denom,
      enabled: object.enabled
    };
  },

  toAmino(message) {
    const obj = {};
    obj.denom = message.denom;
    obj.enabled = message.enabled;
    return obj;
  },

  fromAminoMsg(object) {
    return SendEnabled.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/SendEnabled",
      value: SendEnabled.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return SendEnabled.decode(message.value);
  },

  toProto(message) {
    return SendEnabled.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.bank.v1beta1.SendEnabled",
      value: SendEnabled.encode(message).finish()
    };
  }

};

function createBaseInput() {
  return {
    address: "",
    coins: []
  };
}

const Input = {
  typeUrl: "/cosmos.bank.v1beta1.Input",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Writer.create()) {
    if (message.address !== "") {
      writer.uint32(10).string(message.address);
    }

    for (const v of message.coins) {
      _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.encode(v, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInput();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.address = reader.string();
          break;

        case 2:
          message.coins.push(_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$address, _object$coins;

    const message = createBaseInput();
    message.address = (_object$address = object.address) !== null && _object$address !== void 0 ? _object$address : "";
    message.coins = ((_object$coins = object.coins) === null || _object$coins === void 0 ? void 0 : _object$coins.map(e => _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      address: object.address,
      coins: Array.isArray(object === null || object === void 0 ? void 0 : object.coins) ? object.coins.map(e => _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.address = message.address;

    if (message.coins) {
      obj.coins = message.coins.map(e => e ? _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.toAmino(e) : undefined);
    } else {
      obj.coins = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return Input.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/Input",
      value: Input.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return Input.decode(message.value);
  },

  toProto(message) {
    return Input.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.bank.v1beta1.Input",
      value: Input.encode(message).finish()
    };
  }

};

function createBaseOutput() {
  return {
    address: "",
    coins: []
  };
}

const Output = {
  typeUrl: "/cosmos.bank.v1beta1.Output",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Writer.create()) {
    if (message.address !== "") {
      writer.uint32(10).string(message.address);
    }

    for (const v of message.coins) {
      _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.encode(v, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOutput();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.address = reader.string();
          break;

        case 2:
          message.coins.push(_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$address2, _object$coins2;

    const message = createBaseOutput();
    message.address = (_object$address2 = object.address) !== null && _object$address2 !== void 0 ? _object$address2 : "";
    message.coins = ((_object$coins2 = object.coins) === null || _object$coins2 === void 0 ? void 0 : _object$coins2.map(e => _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      address: object.address,
      coins: Array.isArray(object === null || object === void 0 ? void 0 : object.coins) ? object.coins.map(e => _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.address = message.address;

    if (message.coins) {
      obj.coins = message.coins.map(e => e ? _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.toAmino(e) : undefined);
    } else {
      obj.coins = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return Output.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/Output",
      value: Output.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return Output.decode(message.value);
  },

  toProto(message) {
    return Output.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.bank.v1beta1.Output",
      value: Output.encode(message).finish()
    };
  }

};

function createBaseSupply() {
  return {
    $typeUrl: "/cosmos.bank.v1beta1.Supply",
    total: []
  };
}

const Supply = {
  typeUrl: "/cosmos.bank.v1beta1.Supply",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Writer.create()) {
    for (const v of message.total) {
      _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.encode(v, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSupply();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.total.push(_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$total;

    const message = createBaseSupply();
    message.total = ((_object$total = object.total) === null || _object$total === void 0 ? void 0 : _object$total.map(e => _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      total: Array.isArray(object === null || object === void 0 ? void 0 : object.total) ? object.total.map(e => _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.total) {
      obj.total = message.total.map(e => e ? _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.toAmino(e) : undefined);
    } else {
      obj.total = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return Supply.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/Supply",
      value: Supply.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return Supply.decode(message.value);
  },

  toProto(message) {
    return Supply.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.bank.v1beta1.Supply",
      value: Supply.encode(message).finish()
    };
  }

};

function createBaseDenomUnit() {
  return {
    denom: "",
    exponent: 0,
    aliases: []
  };
}

const DenomUnit = {
  typeUrl: "/cosmos.bank.v1beta1.DenomUnit",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Writer.create()) {
    if (message.denom !== "") {
      writer.uint32(10).string(message.denom);
    }

    if (message.exponent !== 0) {
      writer.uint32(16).uint32(message.exponent);
    }

    for (const v of message.aliases) {
      writer.uint32(26).string(v);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDenomUnit();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.denom = reader.string();
          break;

        case 2:
          message.exponent = reader.uint32();
          break;

        case 3:
          message.aliases.push(reader.string());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$denom2, _object$exponent, _object$aliases;

    const message = createBaseDenomUnit();
    message.denom = (_object$denom2 = object.denom) !== null && _object$denom2 !== void 0 ? _object$denom2 : "";
    message.exponent = (_object$exponent = object.exponent) !== null && _object$exponent !== void 0 ? _object$exponent : 0;
    message.aliases = ((_object$aliases = object.aliases) === null || _object$aliases === void 0 ? void 0 : _object$aliases.map(e => e)) || [];
    return message;
  },

  fromAmino(object) {
    return {
      denom: object.denom,
      exponent: object.exponent,
      aliases: Array.isArray(object === null || object === void 0 ? void 0 : object.aliases) ? object.aliases.map(e => e) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.denom = message.denom;
    obj.exponent = message.exponent;

    if (message.aliases) {
      obj.aliases = message.aliases.map(e => e);
    } else {
      obj.aliases = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return DenomUnit.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/DenomUnit",
      value: DenomUnit.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return DenomUnit.decode(message.value);
  },

  toProto(message) {
    return DenomUnit.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.bank.v1beta1.DenomUnit",
      value: DenomUnit.encode(message).finish()
    };
  }

};

function createBaseMetadata() {
  return {
    description: "",
    denomUnits: [],
    base: "",
    display: "",
    name: "",
    symbol: ""
  };
}

const Metadata = {
  typeUrl: "/cosmos.bank.v1beta1.Metadata",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Writer.create()) {
    if (message.description !== "") {
      writer.uint32(10).string(message.description);
    }

    for (const v of message.denomUnits) {
      DenomUnit.encode(v, writer.uint32(18).fork()).ldelim();
    }

    if (message.base !== "") {
      writer.uint32(26).string(message.base);
    }

    if (message.display !== "") {
      writer.uint32(34).string(message.display);
    }

    if (message.name !== "") {
      writer.uint32(42).string(message.name);
    }

    if (message.symbol !== "") {
      writer.uint32(50).string(message.symbol);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMetadata();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.description = reader.string();
          break;

        case 2:
          message.denomUnits.push(DenomUnit.decode(reader, reader.uint32()));
          break;

        case 3:
          message.base = reader.string();
          break;

        case 4:
          message.display = reader.string();
          break;

        case 5:
          message.name = reader.string();
          break;

        case 6:
          message.symbol = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$description, _object$denomUnits, _object$base, _object$display, _object$name, _object$symbol;

    const message = createBaseMetadata();
    message.description = (_object$description = object.description) !== null && _object$description !== void 0 ? _object$description : "";
    message.denomUnits = ((_object$denomUnits = object.denomUnits) === null || _object$denomUnits === void 0 ? void 0 : _object$denomUnits.map(e => DenomUnit.fromPartial(e))) || [];
    message.base = (_object$base = object.base) !== null && _object$base !== void 0 ? _object$base : "";
    message.display = (_object$display = object.display) !== null && _object$display !== void 0 ? _object$display : "";
    message.name = (_object$name = object.name) !== null && _object$name !== void 0 ? _object$name : "";
    message.symbol = (_object$symbol = object.symbol) !== null && _object$symbol !== void 0 ? _object$symbol : "";
    return message;
  },

  fromAmino(object) {
    return {
      description: object.description,
      denomUnits: Array.isArray(object === null || object === void 0 ? void 0 : object.denom_units) ? object.denom_units.map(e => DenomUnit.fromAmino(e)) : [],
      base: object.base,
      display: object.display,
      name: object.name,
      symbol: object.symbol
    };
  },

  toAmino(message) {
    const obj = {};
    obj.description = message.description;

    if (message.denomUnits) {
      obj.denom_units = message.denomUnits.map(e => e ? DenomUnit.toAmino(e) : undefined);
    } else {
      obj.denom_units = [];
    }

    obj.base = message.base;
    obj.display = message.display;
    obj.name = message.name;
    obj.symbol = message.symbol;
    return obj;
  },

  fromAminoMsg(object) {
    return Metadata.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/Metadata",
      value: Metadata.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return Metadata.decode(message.value);
  },

  toProto(message) {
    return Metadata.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.bank.v1beta1.Metadata",
      value: Metadata.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 33444:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QueryAllBalancesRequest": function() { return /* binding */ QueryAllBalancesRequest; },
/* harmony export */   "QueryAllBalancesResponse": function() { return /* binding */ QueryAllBalancesResponse; },
/* harmony export */   "QueryBalanceRequest": function() { return /* binding */ QueryBalanceRequest; },
/* harmony export */   "QueryBalanceResponse": function() { return /* binding */ QueryBalanceResponse; },
/* harmony export */   "QueryBaseDenomRequest": function() { return /* binding */ QueryBaseDenomRequest; },
/* harmony export */   "QueryBaseDenomResponse": function() { return /* binding */ QueryBaseDenomResponse; },
/* harmony export */   "QueryDenomMetadataRequest": function() { return /* binding */ QueryDenomMetadataRequest; },
/* harmony export */   "QueryDenomMetadataResponse": function() { return /* binding */ QueryDenomMetadataResponse; },
/* harmony export */   "QueryDenomsMetadataRequest": function() { return /* binding */ QueryDenomsMetadataRequest; },
/* harmony export */   "QueryDenomsMetadataResponse": function() { return /* binding */ QueryDenomsMetadataResponse; },
/* harmony export */   "QueryParamsRequest": function() { return /* binding */ QueryParamsRequest; },
/* harmony export */   "QueryParamsResponse": function() { return /* binding */ QueryParamsResponse; },
/* harmony export */   "QuerySupplyOfRequest": function() { return /* binding */ QuerySupplyOfRequest; },
/* harmony export */   "QuerySupplyOfResponse": function() { return /* binding */ QuerySupplyOfResponse; },
/* harmony export */   "QuerySupplyOfWithoutOffsetRequest": function() { return /* binding */ QuerySupplyOfWithoutOffsetRequest; },
/* harmony export */   "QuerySupplyOfWithoutOffsetResponse": function() { return /* binding */ QuerySupplyOfWithoutOffsetResponse; },
/* harmony export */   "QueryTotalSupplyRequest": function() { return /* binding */ QueryTotalSupplyRequest; },
/* harmony export */   "QueryTotalSupplyResponse": function() { return /* binding */ QueryTotalSupplyResponse; },
/* harmony export */   "QueryTotalSupplyWithoutOffsetRequest": function() { return /* binding */ QueryTotalSupplyWithoutOffsetRequest; },
/* harmony export */   "QueryTotalSupplyWithoutOffsetResponse": function() { return /* binding */ QueryTotalSupplyWithoutOffsetResponse; }
/* harmony export */ });
/* harmony import */ var _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48978);
/* harmony import */ var _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26178);
/* harmony import */ var _bank__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38986);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__);




/** QueryBalanceRequest is the request type for the Query/Balance RPC method. */

function createBaseQueryBalanceRequest() {
  return {
    address: "",
    denom: ""
  };
}

const QueryBalanceRequest = {
  typeUrl: "/cosmos.bank.v1beta1.QueryBalanceRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.address !== "") {
      writer.uint32(10).string(message.address);
    }

    if (message.denom !== "") {
      writer.uint32(18).string(message.denom);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryBalanceRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.address = reader.string();
          break;

        case 2:
          message.denom = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$address, _object$denom;

    const message = createBaseQueryBalanceRequest();
    message.address = (_object$address = object.address) !== null && _object$address !== void 0 ? _object$address : "";
    message.denom = (_object$denom = object.denom) !== null && _object$denom !== void 0 ? _object$denom : "";
    return message;
  },

  fromAmino(object) {
    return {
      address: object.address,
      denom: object.denom
    };
  },

  toAmino(message) {
    const obj = {};
    obj.address = message.address;
    obj.denom = message.denom;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryBalanceRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryBalanceRequest",
      value: QueryBalanceRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryBalanceRequest.decode(message.value);
  },

  toProto(message) {
    return QueryBalanceRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.bank.v1beta1.QueryBalanceRequest",
      value: QueryBalanceRequest.encode(message).finish()
    };
  }

};

function createBaseQueryBalanceResponse() {
  return {
    balance: undefined
  };
}

const QueryBalanceResponse = {
  typeUrl: "/cosmos.bank.v1beta1.QueryBalanceResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.balance !== undefined) {
      _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.encode(message.balance, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryBalanceResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.balance = _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseQueryBalanceResponse();
    message.balance = object.balance !== undefined && object.balance !== null ? _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.fromPartial(object.balance) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      balance: object !== null && object !== void 0 && object.balance ? _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.fromAmino(object.balance) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.balance = message.balance ? _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.toAmino(message.balance) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryBalanceResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryBalanceResponse",
      value: QueryBalanceResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryBalanceResponse.decode(message.value);
  },

  toProto(message) {
    return QueryBalanceResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.bank.v1beta1.QueryBalanceResponse",
      value: QueryBalanceResponse.encode(message).finish()
    };
  }

};

function createBaseQueryAllBalancesRequest() {
  return {
    address: "",
    pagination: undefined
  };
}

const QueryAllBalancesRequest = {
  typeUrl: "/cosmos.bank.v1beta1.QueryAllBalancesRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.address !== "") {
      writer.uint32(10).string(message.address);
    }

    if (message.pagination !== undefined) {
      _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryAllBalancesRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.address = reader.string();
          break;

        case 2:
          message.pagination = _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$address2;

    const message = createBaseQueryAllBalancesRequest();
    message.address = (_object$address2 = object.address) !== null && _object$address2 !== void 0 ? _object$address2 : "";
    message.pagination = object.pagination !== undefined && object.pagination !== null ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.fromPartial(object.pagination) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      address: object.address,
      pagination: object !== null && object !== void 0 && object.pagination ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.fromAmino(object.pagination) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.address = message.address;
    obj.pagination = message.pagination ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.toAmino(message.pagination) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryAllBalancesRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryAllBalancesRequest",
      value: QueryAllBalancesRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryAllBalancesRequest.decode(message.value);
  },

  toProto(message) {
    return QueryAllBalancesRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.bank.v1beta1.QueryAllBalancesRequest",
      value: QueryAllBalancesRequest.encode(message).finish()
    };
  }

};

function createBaseQueryAllBalancesResponse() {
  return {
    balances: [],
    pagination: undefined
  };
}

const QueryAllBalancesResponse = {
  typeUrl: "/cosmos.bank.v1beta1.QueryAllBalancesResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    for (const v of message.balances) {
      _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.encode(v, writer.uint32(10).fork()).ldelim();
    }

    if (message.pagination !== undefined) {
      _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryAllBalancesResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.balances.push(_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.decode(reader, reader.uint32()));
          break;

        case 2:
          message.pagination = _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$balances;

    const message = createBaseQueryAllBalancesResponse();
    message.balances = ((_object$balances = object.balances) === null || _object$balances === void 0 ? void 0 : _object$balances.map(e => _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.fromPartial(e))) || [];
    message.pagination = object.pagination !== undefined && object.pagination !== null ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.fromPartial(object.pagination) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      balances: Array.isArray(object === null || object === void 0 ? void 0 : object.balances) ? object.balances.map(e => _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.fromAmino(e)) : [],
      pagination: object !== null && object !== void 0 && object.pagination ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.fromAmino(object.pagination) : undefined
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.balances) {
      obj.balances = message.balances.map(e => e ? _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.toAmino(e) : undefined);
    } else {
      obj.balances = [];
    }

    obj.pagination = message.pagination ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.toAmino(message.pagination) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryAllBalancesResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryAllBalancesResponse",
      value: QueryAllBalancesResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryAllBalancesResponse.decode(message.value);
  },

  toProto(message) {
    return QueryAllBalancesResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.bank.v1beta1.QueryAllBalancesResponse",
      value: QueryAllBalancesResponse.encode(message).finish()
    };
  }

};

function createBaseQueryTotalSupplyRequest() {
  return {
    pagination: undefined
  };
}

const QueryTotalSupplyRequest = {
  typeUrl: "/cosmos.bank.v1beta1.QueryTotalSupplyRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.pagination !== undefined) {
      _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryTotalSupplyRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.pagination = _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseQueryTotalSupplyRequest();
    message.pagination = object.pagination !== undefined && object.pagination !== null ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.fromPartial(object.pagination) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      pagination: object !== null && object !== void 0 && object.pagination ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.fromAmino(object.pagination) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.pagination = message.pagination ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.toAmino(message.pagination) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryTotalSupplyRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryTotalSupplyRequest",
      value: QueryTotalSupplyRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryTotalSupplyRequest.decode(message.value);
  },

  toProto(message) {
    return QueryTotalSupplyRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.bank.v1beta1.QueryTotalSupplyRequest",
      value: QueryTotalSupplyRequest.encode(message).finish()
    };
  }

};

function createBaseQueryTotalSupplyResponse() {
  return {
    supply: [],
    pagination: undefined
  };
}

const QueryTotalSupplyResponse = {
  typeUrl: "/cosmos.bank.v1beta1.QueryTotalSupplyResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    for (const v of message.supply) {
      _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.encode(v, writer.uint32(10).fork()).ldelim();
    }

    if (message.pagination !== undefined) {
      _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryTotalSupplyResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.supply.push(_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.decode(reader, reader.uint32()));
          break;

        case 2:
          message.pagination = _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$supply;

    const message = createBaseQueryTotalSupplyResponse();
    message.supply = ((_object$supply = object.supply) === null || _object$supply === void 0 ? void 0 : _object$supply.map(e => _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.fromPartial(e))) || [];
    message.pagination = object.pagination !== undefined && object.pagination !== null ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.fromPartial(object.pagination) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      supply: Array.isArray(object === null || object === void 0 ? void 0 : object.supply) ? object.supply.map(e => _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.fromAmino(e)) : [],
      pagination: object !== null && object !== void 0 && object.pagination ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.fromAmino(object.pagination) : undefined
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.supply) {
      obj.supply = message.supply.map(e => e ? _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.toAmino(e) : undefined);
    } else {
      obj.supply = [];
    }

    obj.pagination = message.pagination ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.toAmino(message.pagination) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryTotalSupplyResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryTotalSupplyResponse",
      value: QueryTotalSupplyResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryTotalSupplyResponse.decode(message.value);
  },

  toProto(message) {
    return QueryTotalSupplyResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.bank.v1beta1.QueryTotalSupplyResponse",
      value: QueryTotalSupplyResponse.encode(message).finish()
    };
  }

};

function createBaseQuerySupplyOfRequest() {
  return {
    denom: ""
  };
}

const QuerySupplyOfRequest = {
  typeUrl: "/cosmos.bank.v1beta1.QuerySupplyOfRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.denom !== "") {
      writer.uint32(10).string(message.denom);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQuerySupplyOfRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.denom = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$denom2;

    const message = createBaseQuerySupplyOfRequest();
    message.denom = (_object$denom2 = object.denom) !== null && _object$denom2 !== void 0 ? _object$denom2 : "";
    return message;
  },

  fromAmino(object) {
    return {
      denom: object.denom
    };
  },

  toAmino(message) {
    const obj = {};
    obj.denom = message.denom;
    return obj;
  },

  fromAminoMsg(object) {
    return QuerySupplyOfRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QuerySupplyOfRequest",
      value: QuerySupplyOfRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QuerySupplyOfRequest.decode(message.value);
  },

  toProto(message) {
    return QuerySupplyOfRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.bank.v1beta1.QuerySupplyOfRequest",
      value: QuerySupplyOfRequest.encode(message).finish()
    };
  }

};

function createBaseQuerySupplyOfResponse() {
  return {
    amount: undefined
  };
}

const QuerySupplyOfResponse = {
  typeUrl: "/cosmos.bank.v1beta1.QuerySupplyOfResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.amount !== undefined) {
      _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.encode(message.amount, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQuerySupplyOfResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.amount = _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseQuerySupplyOfResponse();
    message.amount = object.amount !== undefined && object.amount !== null ? _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.fromPartial(object.amount) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      amount: object !== null && object !== void 0 && object.amount ? _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.fromAmino(object.amount) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.amount = message.amount ? _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.toAmino(message.amount) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QuerySupplyOfResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QuerySupplyOfResponse",
      value: QuerySupplyOfResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QuerySupplyOfResponse.decode(message.value);
  },

  toProto(message) {
    return QuerySupplyOfResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.bank.v1beta1.QuerySupplyOfResponse",
      value: QuerySupplyOfResponse.encode(message).finish()
    };
  }

};

function createBaseQueryTotalSupplyWithoutOffsetRequest() {
  return {
    pagination: undefined
  };
}

const QueryTotalSupplyWithoutOffsetRequest = {
  typeUrl: "/cosmos.bank.v1beta1.QueryTotalSupplyWithoutOffsetRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.pagination !== undefined) {
      _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryTotalSupplyWithoutOffsetRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.pagination = _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseQueryTotalSupplyWithoutOffsetRequest();
    message.pagination = object.pagination !== undefined && object.pagination !== null ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.fromPartial(object.pagination) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      pagination: object !== null && object !== void 0 && object.pagination ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.fromAmino(object.pagination) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.pagination = message.pagination ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.toAmino(message.pagination) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryTotalSupplyWithoutOffsetRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryTotalSupplyWithoutOffsetRequest",
      value: QueryTotalSupplyWithoutOffsetRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryTotalSupplyWithoutOffsetRequest.decode(message.value);
  },

  toProto(message) {
    return QueryTotalSupplyWithoutOffsetRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.bank.v1beta1.QueryTotalSupplyWithoutOffsetRequest",
      value: QueryTotalSupplyWithoutOffsetRequest.encode(message).finish()
    };
  }

};

function createBaseQueryTotalSupplyWithoutOffsetResponse() {
  return {
    supply: [],
    pagination: undefined
  };
}

const QueryTotalSupplyWithoutOffsetResponse = {
  typeUrl: "/cosmos.bank.v1beta1.QueryTotalSupplyWithoutOffsetResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    for (const v of message.supply) {
      _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.encode(v, writer.uint32(10).fork()).ldelim();
    }

    if (message.pagination !== undefined) {
      _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryTotalSupplyWithoutOffsetResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.supply.push(_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.decode(reader, reader.uint32()));
          break;

        case 2:
          message.pagination = _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$supply2;

    const message = createBaseQueryTotalSupplyWithoutOffsetResponse();
    message.supply = ((_object$supply2 = object.supply) === null || _object$supply2 === void 0 ? void 0 : _object$supply2.map(e => _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.fromPartial(e))) || [];
    message.pagination = object.pagination !== undefined && object.pagination !== null ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.fromPartial(object.pagination) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      supply: Array.isArray(object === null || object === void 0 ? void 0 : object.supply) ? object.supply.map(e => _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.fromAmino(e)) : [],
      pagination: object !== null && object !== void 0 && object.pagination ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.fromAmino(object.pagination) : undefined
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.supply) {
      obj.supply = message.supply.map(e => e ? _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.toAmino(e) : undefined);
    } else {
      obj.supply = [];
    }

    obj.pagination = message.pagination ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.toAmino(message.pagination) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryTotalSupplyWithoutOffsetResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryTotalSupplyWithoutOffsetResponse",
      value: QueryTotalSupplyWithoutOffsetResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryTotalSupplyWithoutOffsetResponse.decode(message.value);
  },

  toProto(message) {
    return QueryTotalSupplyWithoutOffsetResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.bank.v1beta1.QueryTotalSupplyWithoutOffsetResponse",
      value: QueryTotalSupplyWithoutOffsetResponse.encode(message).finish()
    };
  }

};

function createBaseQuerySupplyOfWithoutOffsetRequest() {
  return {
    denom: ""
  };
}

const QuerySupplyOfWithoutOffsetRequest = {
  typeUrl: "/cosmos.bank.v1beta1.QuerySupplyOfWithoutOffsetRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.denom !== "") {
      writer.uint32(10).string(message.denom);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQuerySupplyOfWithoutOffsetRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.denom = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$denom3;

    const message = createBaseQuerySupplyOfWithoutOffsetRequest();
    message.denom = (_object$denom3 = object.denom) !== null && _object$denom3 !== void 0 ? _object$denom3 : "";
    return message;
  },

  fromAmino(object) {
    return {
      denom: object.denom
    };
  },

  toAmino(message) {
    const obj = {};
    obj.denom = message.denom;
    return obj;
  },

  fromAminoMsg(object) {
    return QuerySupplyOfWithoutOffsetRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QuerySupplyOfWithoutOffsetRequest",
      value: QuerySupplyOfWithoutOffsetRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QuerySupplyOfWithoutOffsetRequest.decode(message.value);
  },

  toProto(message) {
    return QuerySupplyOfWithoutOffsetRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.bank.v1beta1.QuerySupplyOfWithoutOffsetRequest",
      value: QuerySupplyOfWithoutOffsetRequest.encode(message).finish()
    };
  }

};

function createBaseQuerySupplyOfWithoutOffsetResponse() {
  return {
    amount: undefined
  };
}

const QuerySupplyOfWithoutOffsetResponse = {
  typeUrl: "/cosmos.bank.v1beta1.QuerySupplyOfWithoutOffsetResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.amount !== undefined) {
      _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.encode(message.amount, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQuerySupplyOfWithoutOffsetResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.amount = _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseQuerySupplyOfWithoutOffsetResponse();
    message.amount = object.amount !== undefined && object.amount !== null ? _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.fromPartial(object.amount) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      amount: object !== null && object !== void 0 && object.amount ? _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.fromAmino(object.amount) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.amount = message.amount ? _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.toAmino(message.amount) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QuerySupplyOfWithoutOffsetResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QuerySupplyOfWithoutOffsetResponse",
      value: QuerySupplyOfWithoutOffsetResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QuerySupplyOfWithoutOffsetResponse.decode(message.value);
  },

  toProto(message) {
    return QuerySupplyOfWithoutOffsetResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.bank.v1beta1.QuerySupplyOfWithoutOffsetResponse",
      value: QuerySupplyOfWithoutOffsetResponse.encode(message).finish()
    };
  }

};

function createBaseQueryParamsRequest() {
  return {};
}

const QueryParamsRequest = {
  typeUrl: "/cosmos.bank.v1beta1.QueryParamsRequest",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryParamsRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseQueryParamsRequest();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return QueryParamsRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryParamsRequest",
      value: QueryParamsRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryParamsRequest.decode(message.value);
  },

  toProto(message) {
    return QueryParamsRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.bank.v1beta1.QueryParamsRequest",
      value: QueryParamsRequest.encode(message).finish()
    };
  }

};

function createBaseQueryParamsResponse() {
  return {
    params: undefined
  };
}

const QueryParamsResponse = {
  typeUrl: "/cosmos.bank.v1beta1.QueryParamsResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.params !== undefined) {
      _bank__WEBPACK_IMPORTED_MODULE_2__.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryParamsResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.params = _bank__WEBPACK_IMPORTED_MODULE_2__.Params.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseQueryParamsResponse();
    message.params = object.params !== undefined && object.params !== null ? _bank__WEBPACK_IMPORTED_MODULE_2__.Params.fromPartial(object.params) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      params: object !== null && object !== void 0 && object.params ? _bank__WEBPACK_IMPORTED_MODULE_2__.Params.fromAmino(object.params) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.params = message.params ? _bank__WEBPACK_IMPORTED_MODULE_2__.Params.toAmino(message.params) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryParamsResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryParamsResponse",
      value: QueryParamsResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryParamsResponse.decode(message.value);
  },

  toProto(message) {
    return QueryParamsResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.bank.v1beta1.QueryParamsResponse",
      value: QueryParamsResponse.encode(message).finish()
    };
  }

};

function createBaseQueryDenomsMetadataRequest() {
  return {
    pagination: undefined
  };
}

const QueryDenomsMetadataRequest = {
  typeUrl: "/cosmos.bank.v1beta1.QueryDenomsMetadataRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.pagination !== undefined) {
      _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryDenomsMetadataRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.pagination = _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseQueryDenomsMetadataRequest();
    message.pagination = object.pagination !== undefined && object.pagination !== null ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.fromPartial(object.pagination) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      pagination: object !== null && object !== void 0 && object.pagination ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.fromAmino(object.pagination) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.pagination = message.pagination ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.toAmino(message.pagination) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryDenomsMetadataRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryDenomsMetadataRequest",
      value: QueryDenomsMetadataRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryDenomsMetadataRequest.decode(message.value);
  },

  toProto(message) {
    return QueryDenomsMetadataRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.bank.v1beta1.QueryDenomsMetadataRequest",
      value: QueryDenomsMetadataRequest.encode(message).finish()
    };
  }

};

function createBaseQueryDenomsMetadataResponse() {
  return {
    metadatas: [],
    pagination: undefined
  };
}

const QueryDenomsMetadataResponse = {
  typeUrl: "/cosmos.bank.v1beta1.QueryDenomsMetadataResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    for (const v of message.metadatas) {
      _bank__WEBPACK_IMPORTED_MODULE_2__.Metadata.encode(v, writer.uint32(10).fork()).ldelim();
    }

    if (message.pagination !== undefined) {
      _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryDenomsMetadataResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.metadatas.push(_bank__WEBPACK_IMPORTED_MODULE_2__.Metadata.decode(reader, reader.uint32()));
          break;

        case 2:
          message.pagination = _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$metadatas;

    const message = createBaseQueryDenomsMetadataResponse();
    message.metadatas = ((_object$metadatas = object.metadatas) === null || _object$metadatas === void 0 ? void 0 : _object$metadatas.map(e => _bank__WEBPACK_IMPORTED_MODULE_2__.Metadata.fromPartial(e))) || [];
    message.pagination = object.pagination !== undefined && object.pagination !== null ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.fromPartial(object.pagination) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      metadatas: Array.isArray(object === null || object === void 0 ? void 0 : object.metadatas) ? object.metadatas.map(e => _bank__WEBPACK_IMPORTED_MODULE_2__.Metadata.fromAmino(e)) : [],
      pagination: object !== null && object !== void 0 && object.pagination ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.fromAmino(object.pagination) : undefined
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.metadatas) {
      obj.metadatas = message.metadatas.map(e => e ? _bank__WEBPACK_IMPORTED_MODULE_2__.Metadata.toAmino(e) : undefined);
    } else {
      obj.metadatas = [];
    }

    obj.pagination = message.pagination ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.toAmino(message.pagination) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryDenomsMetadataResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryDenomsMetadataResponse",
      value: QueryDenomsMetadataResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryDenomsMetadataResponse.decode(message.value);
  },

  toProto(message) {
    return QueryDenomsMetadataResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.bank.v1beta1.QueryDenomsMetadataResponse",
      value: QueryDenomsMetadataResponse.encode(message).finish()
    };
  }

};

function createBaseQueryDenomMetadataRequest() {
  return {
    denom: ""
  };
}

const QueryDenomMetadataRequest = {
  typeUrl: "/cosmos.bank.v1beta1.QueryDenomMetadataRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.denom !== "") {
      writer.uint32(10).string(message.denom);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryDenomMetadataRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.denom = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$denom4;

    const message = createBaseQueryDenomMetadataRequest();
    message.denom = (_object$denom4 = object.denom) !== null && _object$denom4 !== void 0 ? _object$denom4 : "";
    return message;
  },

  fromAmino(object) {
    return {
      denom: object.denom
    };
  },

  toAmino(message) {
    const obj = {};
    obj.denom = message.denom;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryDenomMetadataRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryDenomMetadataRequest",
      value: QueryDenomMetadataRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryDenomMetadataRequest.decode(message.value);
  },

  toProto(message) {
    return QueryDenomMetadataRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.bank.v1beta1.QueryDenomMetadataRequest",
      value: QueryDenomMetadataRequest.encode(message).finish()
    };
  }

};

function createBaseQueryDenomMetadataResponse() {
  return {
    metadata: undefined
  };
}

const QueryDenomMetadataResponse = {
  typeUrl: "/cosmos.bank.v1beta1.QueryDenomMetadataResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.metadata !== undefined) {
      _bank__WEBPACK_IMPORTED_MODULE_2__.Metadata.encode(message.metadata, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryDenomMetadataResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.metadata = _bank__WEBPACK_IMPORTED_MODULE_2__.Metadata.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseQueryDenomMetadataResponse();
    message.metadata = object.metadata !== undefined && object.metadata !== null ? _bank__WEBPACK_IMPORTED_MODULE_2__.Metadata.fromPartial(object.metadata) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      metadata: object !== null && object !== void 0 && object.metadata ? _bank__WEBPACK_IMPORTED_MODULE_2__.Metadata.fromAmino(object.metadata) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.metadata = message.metadata ? _bank__WEBPACK_IMPORTED_MODULE_2__.Metadata.toAmino(message.metadata) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryDenomMetadataResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryDenomMetadataResponse",
      value: QueryDenomMetadataResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryDenomMetadataResponse.decode(message.value);
  },

  toProto(message) {
    return QueryDenomMetadataResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.bank.v1beta1.QueryDenomMetadataResponse",
      value: QueryDenomMetadataResponse.encode(message).finish()
    };
  }

};

function createBaseQueryBaseDenomRequest() {
  return {
    denom: ""
  };
}

const QueryBaseDenomRequest = {
  typeUrl: "/cosmos.bank.v1beta1.QueryBaseDenomRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.denom !== "") {
      writer.uint32(10).string(message.denom);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryBaseDenomRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.denom = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$denom5;

    const message = createBaseQueryBaseDenomRequest();
    message.denom = (_object$denom5 = object.denom) !== null && _object$denom5 !== void 0 ? _object$denom5 : "";
    return message;
  },

  fromAmino(object) {
    return {
      denom: object.denom
    };
  },

  toAmino(message) {
    const obj = {};
    obj.denom = message.denom;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryBaseDenomRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryBaseDenomRequest",
      value: QueryBaseDenomRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryBaseDenomRequest.decode(message.value);
  },

  toProto(message) {
    return QueryBaseDenomRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.bank.v1beta1.QueryBaseDenomRequest",
      value: QueryBaseDenomRequest.encode(message).finish()
    };
  }

};

function createBaseQueryBaseDenomResponse() {
  return {
    baseDenom: ""
  };
}

const QueryBaseDenomResponse = {
  typeUrl: "/cosmos.bank.v1beta1.QueryBaseDenomResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.baseDenom !== "") {
      writer.uint32(10).string(message.baseDenom);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryBaseDenomResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.baseDenom = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$baseDenom;

    const message = createBaseQueryBaseDenomResponse();
    message.baseDenom = (_object$baseDenom = object.baseDenom) !== null && _object$baseDenom !== void 0 ? _object$baseDenom : "";
    return message;
  },

  fromAmino(object) {
    return {
      baseDenom: object.base_denom
    };
  },

  toAmino(message) {
    const obj = {};
    obj.base_denom = message.baseDenom;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryBaseDenomResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryBaseDenomResponse",
      value: QueryBaseDenomResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryBaseDenomResponse.decode(message.value);
  },

  toProto(message) {
    return QueryBaseDenomResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.bank.v1beta1.QueryBaseDenomResponse",
      value: QueryBaseDenomResponse.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 79926:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LCDQueryClient": function() { return /* binding */ LCDQueryClient; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4942);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47895);


class LCDQueryClient {
  constructor({
    requestClient
  }) {
    (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, "req", void 0);

    this.req = requestClient;
    this.balance = this.balance.bind(this);
    this.allBalances = this.allBalances.bind(this);
    this.totalSupply = this.totalSupply.bind(this);
    this.supplyOf = this.supplyOf.bind(this);
    this.totalSupplyWithoutOffset = this.totalSupplyWithoutOffset.bind(this);
    this.supplyOfWithoutOffset = this.supplyOfWithoutOffset.bind(this);
    this.params = this.params.bind(this);
    this.denomMetadata = this.denomMetadata.bind(this);
    this.denomsMetadata = this.denomsMetadata.bind(this);
    this.baseDenom = this.baseDenom.bind(this);
  }
  /* Balance queries the balance of a single coin for a single account. */


  async balance(params) {
    const options = {
      params: {}
    };

    if (typeof (params === null || params === void 0 ? void 0 : params.denom) !== "undefined") {
      options.params.denom = params.denom;
    }

    const endpoint = `cosmos/bank/v1beta1/balances/${params.address}/by_denom`;
    return await this.req.get(endpoint, options);
  }
  /* AllBalances queries the balance of all coins for a single account. */


  async allBalances(params) {
    const options = {
      params: {}
    };

    if (typeof (params === null || params === void 0 ? void 0 : params.pagination) !== "undefined") {
      (0,_helpers__WEBPACK_IMPORTED_MODULE_0__/* .setPaginationParams */ .q6)(options, params.pagination);
    }

    const endpoint = `cosmos/bank/v1beta1/balances/${params.address}`;
    return await this.req.get(endpoint, options);
  }
  /* TotalSupply queries the total supply of all coins. */


  async totalSupply(params = {
    pagination: undefined
  }) {
    const options = {
      params: {}
    };

    if (typeof (params === null || params === void 0 ? void 0 : params.pagination) !== "undefined") {
      (0,_helpers__WEBPACK_IMPORTED_MODULE_0__/* .setPaginationParams */ .q6)(options, params.pagination);
    }

    const endpoint = `cosmos/bank/v1beta1/supply`;
    return await this.req.get(endpoint, options);
  }
  /* SupplyOf queries the supply of a single coin. */


  async supplyOf(params) {
    const endpoint = `cosmos/bank/v1beta1/supply/${params.denom}`;
    return await this.req.get(endpoint);
  }
  /* TotalSupplyWithoutOffset queries the total supply of all coins. */


  async totalSupplyWithoutOffset(params = {
    pagination: undefined
  }) {
    const options = {
      params: {}
    };

    if (typeof (params === null || params === void 0 ? void 0 : params.pagination) !== "undefined") {
      (0,_helpers__WEBPACK_IMPORTED_MODULE_0__/* .setPaginationParams */ .q6)(options, params.pagination);
    }

    const endpoint = `cosmos/bank/v1beta1/supply_without_offset`;
    return await this.req.get(endpoint, options);
  }
  /* SupplyOf queries the supply of a single coin. */


  async supplyOfWithoutOffset(params) {
    const endpoint = `cosmos/bank/v1beta1/supply_without_offset/${params.denom}`;
    return await this.req.get(endpoint);
  }
  /* Params queries the parameters of x/bank module. */


  async params(_params = {}) {
    const endpoint = `cosmos/bank/v1beta1/params`;
    return await this.req.get(endpoint);
  }
  /* DenomsMetadata queries the client metadata of a given coin denomination. */


  async denomMetadata(params) {
    const endpoint = `cosmos/bank/v1beta1/denoms_metadata/${params.denom}`;
    return await this.req.get(endpoint);
  }
  /* DenomsMetadata queries the client metadata for all registered coin denominations. */


  async denomsMetadata(params = {
    pagination: undefined
  }) {
    const options = {
      params: {}
    };

    if (typeof (params === null || params === void 0 ? void 0 : params.pagination) !== "undefined") {
      (0,_helpers__WEBPACK_IMPORTED_MODULE_0__/* .setPaginationParams */ .q6)(options, params.pagination);
    }

    const endpoint = `cosmos/bank/v1beta1/denoms_metadata`;
    return await this.req.get(endpoint, options);
  }
  /* BaseDenom queries for a base denomination given a denom that can either be
   the base denom itself or a metadata denom unit that maps to the base denom. */


  async baseDenom(params) {
    const options = {
      params: {}
    };

    if (typeof (params === null || params === void 0 ? void 0 : params.denom) !== "undefined") {
      options.params.denom = params.denom;
    }

    const endpoint = `cosmos/bank/v1beta1/base_denom`;
    return await this.req.get(endpoint, options);
  }

}

/***/ }),

/***/ 3889:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QueryClientImpl": function() { return /* binding */ QueryClientImpl; },
/* harmony export */   "createRpcQueryExtension": function() { return /* binding */ createRpcQueryExtension; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4942);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78441);
/* harmony import */ var _cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33444);




/** Query defines the gRPC querier service. */

class QueryClientImpl {
  constructor(rpc) {
    (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, "rpc", void 0);

    this.rpc = rpc;
    this.balance = this.balance.bind(this);
    this.allBalances = this.allBalances.bind(this);
    this.totalSupply = this.totalSupply.bind(this);
    this.supplyOf = this.supplyOf.bind(this);
    this.totalSupplyWithoutOffset = this.totalSupplyWithoutOffset.bind(this);
    this.supplyOfWithoutOffset = this.supplyOfWithoutOffset.bind(this);
    this.params = this.params.bind(this);
    this.denomMetadata = this.denomMetadata.bind(this);
    this.denomsMetadata = this.denomsMetadata.bind(this);
    this.baseDenom = this.baseDenom.bind(this);
  }

  balance(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryBalanceRequest.encode(request).finish();
    const promise = this.rpc.request("cosmos.bank.v1beta1.Query", "Balance", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryBalanceResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  allBalances(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryAllBalancesRequest.encode(request).finish();
    const promise = this.rpc.request("cosmos.bank.v1beta1.Query", "AllBalances", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryAllBalancesResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  totalSupply(request = {
    pagination: undefined
  }) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryTotalSupplyRequest.encode(request).finish();
    const promise = this.rpc.request("cosmos.bank.v1beta1.Query", "TotalSupply", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryTotalSupplyResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  supplyOf(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QuerySupplyOfRequest.encode(request).finish();
    const promise = this.rpc.request("cosmos.bank.v1beta1.Query", "SupplyOf", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QuerySupplyOfResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  totalSupplyWithoutOffset(request = {
    pagination: undefined
  }) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryTotalSupplyWithoutOffsetRequest.encode(request).finish();
    const promise = this.rpc.request("cosmos.bank.v1beta1.Query", "TotalSupplyWithoutOffset", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryTotalSupplyWithoutOffsetResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  supplyOfWithoutOffset(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QuerySupplyOfWithoutOffsetRequest.encode(request).finish();
    const promise = this.rpc.request("cosmos.bank.v1beta1.Query", "SupplyOfWithoutOffset", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QuerySupplyOfWithoutOffsetResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  params(request = {}) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryParamsRequest.encode(request).finish();
    const promise = this.rpc.request("cosmos.bank.v1beta1.Query", "Params", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryParamsResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  denomMetadata(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryDenomMetadataRequest.encode(request).finish();
    const promise = this.rpc.request("cosmos.bank.v1beta1.Query", "DenomMetadata", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryDenomMetadataResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  denomsMetadata(request = {
    pagination: undefined
  }) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryDenomsMetadataRequest.encode(request).finish();
    const promise = this.rpc.request("cosmos.bank.v1beta1.Query", "DenomsMetadata", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryDenomsMetadataResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  baseDenom(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryBaseDenomRequest.encode(request).finish();
    const promise = this.rpc.request("cosmos.bank.v1beta1.Query", "BaseDenom", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryBaseDenomResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

}
const createRpcQueryExtension = base => {
  const rpc = (0,_cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1__.createProtobufRpcClient)(base);
  const queryService = new QueryClientImpl(rpc);
  return {
    balance(request) {
      return queryService.balance(request);
    },

    allBalances(request) {
      return queryService.allBalances(request);
    },

    totalSupply(request) {
      return queryService.totalSupply(request);
    },

    supplyOf(request) {
      return queryService.supplyOf(request);
    },

    totalSupplyWithoutOffset(request) {
      return queryService.totalSupplyWithoutOffset(request);
    },

    supplyOfWithoutOffset(request) {
      return queryService.supplyOfWithoutOffset(request);
    },

    params(request) {
      return queryService.params(request);
    },

    denomMetadata(request) {
      return queryService.denomMetadata(request);
    },

    denomsMetadata(request) {
      return queryService.denomsMetadata(request);
    },

    baseDenom(request) {
      return queryService.baseDenom(request);
    }

  };
};

/***/ }),

/***/ 80276:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MsgMultiSend": function() { return /* binding */ MsgMultiSend; },
/* harmony export */   "MsgMultiSendResponse": function() { return /* binding */ MsgMultiSendResponse; },
/* harmony export */   "MsgSend": function() { return /* binding */ MsgSend; },
/* harmony export */   "MsgSendResponse": function() { return /* binding */ MsgSendResponse; }
/* harmony export */ });
/* harmony import */ var _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26178);
/* harmony import */ var _bank__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38986);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__);



/** MsgSend represents a message to send coins from one account to another. */

function createBaseMsgSend() {
  return {
    fromAddress: "",
    toAddress: "",
    amount: []
  };
}

const MsgSend = {
  typeUrl: "/cosmos.bank.v1beta1.MsgSend",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (message.fromAddress !== "") {
      writer.uint32(10).string(message.fromAddress);
    }

    if (message.toAddress !== "") {
      writer.uint32(18).string(message.toAddress);
    }

    for (const v of message.amount) {
      _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.encode(v, writer.uint32(26).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgSend();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.fromAddress = reader.string();
          break;

        case 2:
          message.toAddress = reader.string();
          break;

        case 3:
          message.amount.push(_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$fromAddress, _object$toAddress, _object$amount;

    const message = createBaseMsgSend();
    message.fromAddress = (_object$fromAddress = object.fromAddress) !== null && _object$fromAddress !== void 0 ? _object$fromAddress : "";
    message.toAddress = (_object$toAddress = object.toAddress) !== null && _object$toAddress !== void 0 ? _object$toAddress : "";
    message.amount = ((_object$amount = object.amount) === null || _object$amount === void 0 ? void 0 : _object$amount.map(e => _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      fromAddress: object.from_address,
      toAddress: object.to_address,
      amount: Array.isArray(object === null || object === void 0 ? void 0 : object.amount) ? object.amount.map(e => _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.from_address = message.fromAddress;
    obj.to_address = message.toAddress;

    if (message.amount) {
      obj.amount = message.amount.map(e => e ? _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.toAmino(e) : undefined);
    } else {
      obj.amount = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return MsgSend.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/MsgSend",
      value: MsgSend.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgSend.decode(message.value);
  },

  toProto(message) {
    return MsgSend.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.bank.v1beta1.MsgSend",
      value: MsgSend.encode(message).finish()
    };
  }

};

function createBaseMsgSendResponse() {
  return {};
}

const MsgSendResponse = {
  typeUrl: "/cosmos.bank.v1beta1.MsgSendResponse",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgSendResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseMsgSendResponse();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return MsgSendResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/MsgSendResponse",
      value: MsgSendResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgSendResponse.decode(message.value);
  },

  toProto(message) {
    return MsgSendResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.bank.v1beta1.MsgSendResponse",
      value: MsgSendResponse.encode(message).finish()
    };
  }

};

function createBaseMsgMultiSend() {
  return {
    inputs: [],
    outputs: []
  };
}

const MsgMultiSend = {
  typeUrl: "/cosmos.bank.v1beta1.MsgMultiSend",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    for (const v of message.inputs) {
      _bank__WEBPACK_IMPORTED_MODULE_1__.Input.encode(v, writer.uint32(10).fork()).ldelim();
    }

    for (const v of message.outputs) {
      _bank__WEBPACK_IMPORTED_MODULE_1__.Output.encode(v, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgMultiSend();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.inputs.push(_bank__WEBPACK_IMPORTED_MODULE_1__.Input.decode(reader, reader.uint32()));
          break;

        case 2:
          message.outputs.push(_bank__WEBPACK_IMPORTED_MODULE_1__.Output.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$inputs, _object$outputs;

    const message = createBaseMsgMultiSend();
    message.inputs = ((_object$inputs = object.inputs) === null || _object$inputs === void 0 ? void 0 : _object$inputs.map(e => _bank__WEBPACK_IMPORTED_MODULE_1__.Input.fromPartial(e))) || [];
    message.outputs = ((_object$outputs = object.outputs) === null || _object$outputs === void 0 ? void 0 : _object$outputs.map(e => _bank__WEBPACK_IMPORTED_MODULE_1__.Output.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      inputs: Array.isArray(object === null || object === void 0 ? void 0 : object.inputs) ? object.inputs.map(e => _bank__WEBPACK_IMPORTED_MODULE_1__.Input.fromAmino(e)) : [],
      outputs: Array.isArray(object === null || object === void 0 ? void 0 : object.outputs) ? object.outputs.map(e => _bank__WEBPACK_IMPORTED_MODULE_1__.Output.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.inputs) {
      obj.inputs = message.inputs.map(e => e ? _bank__WEBPACK_IMPORTED_MODULE_1__.Input.toAmino(e) : undefined);
    } else {
      obj.inputs = [];
    }

    if (message.outputs) {
      obj.outputs = message.outputs.map(e => e ? _bank__WEBPACK_IMPORTED_MODULE_1__.Output.toAmino(e) : undefined);
    } else {
      obj.outputs = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return MsgMultiSend.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/MsgMultiSend",
      value: MsgMultiSend.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgMultiSend.decode(message.value);
  },

  toProto(message) {
    return MsgMultiSend.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.bank.v1beta1.MsgMultiSend",
      value: MsgMultiSend.encode(message).finish()
    };
  }

};

function createBaseMsgMultiSendResponse() {
  return {};
}

const MsgMultiSendResponse = {
  typeUrl: "/cosmos.bank.v1beta1.MsgMultiSendResponse",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgMultiSendResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseMsgMultiSendResponse();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return MsgMultiSendResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/MsgMultiSendResponse",
      value: MsgMultiSendResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgMultiSendResponse.decode(message.value);
  },

  toProto(message) {
    return MsgMultiSendResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.bank.v1beta1.MsgMultiSendResponse",
      value: MsgMultiSendResponse.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 85579:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MsgClientImpl": function() { return /* binding */ MsgClientImpl; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4942);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _tx__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80276);



/** Msg defines the bank Msg service. */

class MsgClientImpl {
  constructor(rpc) {
    (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, "rpc", void 0);

    this.rpc = rpc;
    this.send = this.send.bind(this);
    this.multiSend = this.multiSend.bind(this);
  }

  send(request) {
    const data = _tx__WEBPACK_IMPORTED_MODULE_1__.MsgSend.encode(request).finish();
    const promise = this.rpc.request("cosmos.bank.v1beta1.Msg", "Send", data);
    return promise.then(data => _tx__WEBPACK_IMPORTED_MODULE_1__.MsgSendResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  multiSend(request) {
    const data = _tx__WEBPACK_IMPORTED_MODULE_1__.MsgMultiSend.encode(request).finish();
    const promise = this.rpc.request("cosmos.bank.v1beta1.Msg", "MultiSend", data);
    return promise.then(data => _tx__WEBPACK_IMPORTED_MODULE_1__.MsgMultiSendResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

}

/***/ }),

/***/ 93049:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ABCIMessageLog": function() { return /* binding */ ABCIMessageLog; },
/* harmony export */   "Attribute": function() { return /* binding */ Attribute; },
/* harmony export */   "GasInfo": function() { return /* binding */ GasInfo; },
/* harmony export */   "MsgData": function() { return /* binding */ MsgData; },
/* harmony export */   "Result": function() { return /* binding */ Result; },
/* harmony export */   "SearchTxsResult": function() { return /* binding */ SearchTxsResult; },
/* harmony export */   "SimulationResponse": function() { return /* binding */ SimulationResponse; },
/* harmony export */   "StringEvent": function() { return /* binding */ StringEvent; },
/* harmony export */   "TxMsgData": function() { return /* binding */ TxMsgData; },
/* harmony export */   "TxResponse": function() { return /* binding */ TxResponse; }
/* harmony export */ });
/* harmony import */ var _google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32106);
/* harmony import */ var _tendermint_abci_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10670);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47895);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__);




/**
 * TxResponse defines a structure containing relevant tx data and metadata. The
 * tags are stringified and the log is JSON decoded.
 */

function createBaseTxResponse() {
  return {
    height: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.ZERO */ .dK.ZERO,
    txhash: "",
    codespace: "",
    code: 0,
    data: "",
    rawLog: "",
    logs: [],
    info: "",
    gasWanted: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.ZERO */ .dK.ZERO,
    gasUsed: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.ZERO */ .dK.ZERO,
    tx: undefined,
    timestamp: "",
    events: []
  };
}

const TxResponse = {
  typeUrl: "/cosmos.base.abci.v1beta1.TxResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (!message.height.isZero()) {
      writer.uint32(8).int64(message.height);
    }

    if (message.txhash !== "") {
      writer.uint32(18).string(message.txhash);
    }

    if (message.codespace !== "") {
      writer.uint32(26).string(message.codespace);
    }

    if (message.code !== 0) {
      writer.uint32(32).uint32(message.code);
    }

    if (message.data !== "") {
      writer.uint32(42).string(message.data);
    }

    if (message.rawLog !== "") {
      writer.uint32(50).string(message.rawLog);
    }

    for (const v of message.logs) {
      ABCIMessageLog.encode(v, writer.uint32(58).fork()).ldelim();
    }

    if (message.info !== "") {
      writer.uint32(66).string(message.info);
    }

    if (!message.gasWanted.isZero()) {
      writer.uint32(72).int64(message.gasWanted);
    }

    if (!message.gasUsed.isZero()) {
      writer.uint32(80).int64(message.gasUsed);
    }

    if (message.tx !== undefined) {
      _google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__.Any.encode(message.tx, writer.uint32(90).fork()).ldelim();
    }

    if (message.timestamp !== "") {
      writer.uint32(98).string(message.timestamp);
    }

    for (const v of message.events) {
      _tendermint_abci_types__WEBPACK_IMPORTED_MODULE_1__.Event.encode(v, writer.uint32(106).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTxResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.height = reader.int64();
          break;

        case 2:
          message.txhash = reader.string();
          break;

        case 3:
          message.codespace = reader.string();
          break;

        case 4:
          message.code = reader.uint32();
          break;

        case 5:
          message.data = reader.string();
          break;

        case 6:
          message.rawLog = reader.string();
          break;

        case 7:
          message.logs.push(ABCIMessageLog.decode(reader, reader.uint32()));
          break;

        case 8:
          message.info = reader.string();
          break;

        case 9:
          message.gasWanted = reader.int64();
          break;

        case 10:
          message.gasUsed = reader.int64();
          break;

        case 11:
          message.tx = _google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__.Any.decode(reader, reader.uint32());
          break;

        case 12:
          message.timestamp = reader.string();
          break;

        case 13:
          message.events.push(_tendermint_abci_types__WEBPACK_IMPORTED_MODULE_1__.Event.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$txhash, _object$codespace, _object$code, _object$data, _object$rawLog, _object$logs, _object$info, _object$timestamp, _object$events;

    const message = createBaseTxResponse();
    message.height = object.height !== undefined && object.height !== null ? _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromValue */ .dK.fromValue(object.height) : _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.ZERO */ .dK.ZERO;
    message.txhash = (_object$txhash = object.txhash) !== null && _object$txhash !== void 0 ? _object$txhash : "";
    message.codespace = (_object$codespace = object.codespace) !== null && _object$codespace !== void 0 ? _object$codespace : "";
    message.code = (_object$code = object.code) !== null && _object$code !== void 0 ? _object$code : 0;
    message.data = (_object$data = object.data) !== null && _object$data !== void 0 ? _object$data : "";
    message.rawLog = (_object$rawLog = object.rawLog) !== null && _object$rawLog !== void 0 ? _object$rawLog : "";
    message.logs = ((_object$logs = object.logs) === null || _object$logs === void 0 ? void 0 : _object$logs.map(e => ABCIMessageLog.fromPartial(e))) || [];
    message.info = (_object$info = object.info) !== null && _object$info !== void 0 ? _object$info : "";
    message.gasWanted = object.gasWanted !== undefined && object.gasWanted !== null ? _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromValue */ .dK.fromValue(object.gasWanted) : _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.ZERO */ .dK.ZERO;
    message.gasUsed = object.gasUsed !== undefined && object.gasUsed !== null ? _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromValue */ .dK.fromValue(object.gasUsed) : _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.ZERO */ .dK.ZERO;
    message.tx = object.tx !== undefined && object.tx !== null ? _google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__.Any.fromPartial(object.tx) : undefined;
    message.timestamp = (_object$timestamp = object.timestamp) !== null && _object$timestamp !== void 0 ? _object$timestamp : "";
    message.events = ((_object$events = object.events) === null || _object$events === void 0 ? void 0 : _object$events.map(e => _tendermint_abci_types__WEBPACK_IMPORTED_MODULE_1__.Event.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      height: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromString */ .dK.fromString(object.height),
      txhash: object.txhash,
      codespace: object.codespace,
      code: object.code,
      data: object.data,
      rawLog: object.raw_log,
      logs: Array.isArray(object === null || object === void 0 ? void 0 : object.logs) ? object.logs.map(e => ABCIMessageLog.fromAmino(e)) : [],
      info: object.info,
      gasWanted: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromString */ .dK.fromString(object.gas_wanted),
      gasUsed: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromString */ .dK.fromString(object.gas_used),
      tx: object !== null && object !== void 0 && object.tx ? _google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__.Any.fromAmino(object.tx) : undefined,
      timestamp: object.timestamp,
      events: Array.isArray(object === null || object === void 0 ? void 0 : object.events) ? object.events.map(e => _tendermint_abci_types__WEBPACK_IMPORTED_MODULE_1__.Event.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.height = message.height ? message.height.toString() : undefined;
    obj.txhash = message.txhash;
    obj.codespace = message.codespace;
    obj.code = message.code;
    obj.data = message.data;
    obj.raw_log = message.rawLog;

    if (message.logs) {
      obj.logs = message.logs.map(e => e ? ABCIMessageLog.toAmino(e) : undefined);
    } else {
      obj.logs = [];
    }

    obj.info = message.info;
    obj.gas_wanted = message.gasWanted ? message.gasWanted.toString() : undefined;
    obj.gas_used = message.gasUsed ? message.gasUsed.toString() : undefined;
    obj.tx = message.tx ? _google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__.Any.toAmino(message.tx) : undefined;
    obj.timestamp = message.timestamp;

    if (message.events) {
      obj.events = message.events.map(e => e ? _tendermint_abci_types__WEBPACK_IMPORTED_MODULE_1__.Event.toAmino(e) : undefined);
    } else {
      obj.events = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return TxResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/TxResponse",
      value: TxResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return TxResponse.decode(message.value);
  },

  toProto(message) {
    return TxResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.base.abci.v1beta1.TxResponse",
      value: TxResponse.encode(message).finish()
    };
  }

};

function createBaseABCIMessageLog() {
  return {
    msgIndex: 0,
    log: "",
    events: []
  };
}

const ABCIMessageLog = {
  typeUrl: "/cosmos.base.abci.v1beta1.ABCIMessageLog",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.msgIndex !== 0) {
      writer.uint32(8).uint32(message.msgIndex);
    }

    if (message.log !== "") {
      writer.uint32(18).string(message.log);
    }

    for (const v of message.events) {
      StringEvent.encode(v, writer.uint32(26).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseABCIMessageLog();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.msgIndex = reader.uint32();
          break;

        case 2:
          message.log = reader.string();
          break;

        case 3:
          message.events.push(StringEvent.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$msgIndex, _object$log, _object$events2;

    const message = createBaseABCIMessageLog();
    message.msgIndex = (_object$msgIndex = object.msgIndex) !== null && _object$msgIndex !== void 0 ? _object$msgIndex : 0;
    message.log = (_object$log = object.log) !== null && _object$log !== void 0 ? _object$log : "";
    message.events = ((_object$events2 = object.events) === null || _object$events2 === void 0 ? void 0 : _object$events2.map(e => StringEvent.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      msgIndex: object.msg_index,
      log: object.log,
      events: Array.isArray(object === null || object === void 0 ? void 0 : object.events) ? object.events.map(e => StringEvent.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.msg_index = message.msgIndex;
    obj.log = message.log;

    if (message.events) {
      obj.events = message.events.map(e => e ? StringEvent.toAmino(e) : undefined);
    } else {
      obj.events = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return ABCIMessageLog.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/ABCIMessageLog",
      value: ABCIMessageLog.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return ABCIMessageLog.decode(message.value);
  },

  toProto(message) {
    return ABCIMessageLog.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.base.abci.v1beta1.ABCIMessageLog",
      value: ABCIMessageLog.encode(message).finish()
    };
  }

};

function createBaseStringEvent() {
  return {
    type: "",
    attributes: []
  };
}

const StringEvent = {
  typeUrl: "/cosmos.base.abci.v1beta1.StringEvent",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.type !== "") {
      writer.uint32(10).string(message.type);
    }

    for (const v of message.attributes) {
      Attribute.encode(v, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStringEvent();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.type = reader.string();
          break;

        case 2:
          message.attributes.push(Attribute.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$type, _object$attributes;

    const message = createBaseStringEvent();
    message.type = (_object$type = object.type) !== null && _object$type !== void 0 ? _object$type : "";
    message.attributes = ((_object$attributes = object.attributes) === null || _object$attributes === void 0 ? void 0 : _object$attributes.map(e => Attribute.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      type: object.type,
      attributes: Array.isArray(object === null || object === void 0 ? void 0 : object.attributes) ? object.attributes.map(e => Attribute.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.type = message.type;

    if (message.attributes) {
      obj.attributes = message.attributes.map(e => e ? Attribute.toAmino(e) : undefined);
    } else {
      obj.attributes = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return StringEvent.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/StringEvent",
      value: StringEvent.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return StringEvent.decode(message.value);
  },

  toProto(message) {
    return StringEvent.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.base.abci.v1beta1.StringEvent",
      value: StringEvent.encode(message).finish()
    };
  }

};

function createBaseAttribute() {
  return {
    key: "",
    value: ""
  };
}

const Attribute = {
  typeUrl: "/cosmos.base.abci.v1beta1.Attribute",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }

    if (message.value !== "") {
      writer.uint32(18).string(message.value);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAttribute();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.key = reader.string();
          break;

        case 2:
          message.value = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$key, _object$value;

    const message = createBaseAttribute();
    message.key = (_object$key = object.key) !== null && _object$key !== void 0 ? _object$key : "";
    message.value = (_object$value = object.value) !== null && _object$value !== void 0 ? _object$value : "";
    return message;
  },

  fromAmino(object) {
    return {
      key: object.key,
      value: object.value
    };
  },

  toAmino(message) {
    const obj = {};
    obj.key = message.key;
    obj.value = message.value;
    return obj;
  },

  fromAminoMsg(object) {
    return Attribute.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/Attribute",
      value: Attribute.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return Attribute.decode(message.value);
  },

  toProto(message) {
    return Attribute.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.base.abci.v1beta1.Attribute",
      value: Attribute.encode(message).finish()
    };
  }

};

function createBaseGasInfo() {
  return {
    gasWanted: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO,
    gasUsed: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO
  };
}

const GasInfo = {
  typeUrl: "/cosmos.base.abci.v1beta1.GasInfo",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (!message.gasWanted.isZero()) {
      writer.uint32(8).uint64(message.gasWanted);
    }

    if (!message.gasUsed.isZero()) {
      writer.uint32(16).uint64(message.gasUsed);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGasInfo();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.gasWanted = reader.uint64();
          break;

        case 2:
          message.gasUsed = reader.uint64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseGasInfo();
    message.gasWanted = object.gasWanted !== undefined && object.gasWanted !== null ? _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromValue */ .dK.fromValue(object.gasWanted) : _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO;
    message.gasUsed = object.gasUsed !== undefined && object.gasUsed !== null ? _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromValue */ .dK.fromValue(object.gasUsed) : _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO;
    return message;
  },

  fromAmino(object) {
    return {
      gasWanted: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromString */ .dK.fromString(object.gas_wanted),
      gasUsed: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromString */ .dK.fromString(object.gas_used)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.gas_wanted = message.gasWanted ? message.gasWanted.toString() : undefined;
    obj.gas_used = message.gasUsed ? message.gasUsed.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return GasInfo.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/GasInfo",
      value: GasInfo.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return GasInfo.decode(message.value);
  },

  toProto(message) {
    return GasInfo.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.base.abci.v1beta1.GasInfo",
      value: GasInfo.encode(message).finish()
    };
  }

};

function createBaseResult() {
  return {
    data: new Uint8Array(),
    log: "",
    events: []
  };
}

const Result = {
  typeUrl: "/cosmos.base.abci.v1beta1.Result",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.data.length !== 0) {
      writer.uint32(10).bytes(message.data);
    }

    if (message.log !== "") {
      writer.uint32(18).string(message.log);
    }

    for (const v of message.events) {
      _tendermint_abci_types__WEBPACK_IMPORTED_MODULE_1__.Event.encode(v, writer.uint32(26).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseResult();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.data = reader.bytes();
          break;

        case 2:
          message.log = reader.string();
          break;

        case 3:
          message.events.push(_tendermint_abci_types__WEBPACK_IMPORTED_MODULE_1__.Event.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$data2, _object$log2, _object$events3;

    const message = createBaseResult();
    message.data = (_object$data2 = object.data) !== null && _object$data2 !== void 0 ? _object$data2 : new Uint8Array();
    message.log = (_object$log2 = object.log) !== null && _object$log2 !== void 0 ? _object$log2 : "";
    message.events = ((_object$events3 = object.events) === null || _object$events3 === void 0 ? void 0 : _object$events3.map(e => _tendermint_abci_types__WEBPACK_IMPORTED_MODULE_1__.Event.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      data: object.data,
      log: object.log,
      events: Array.isArray(object === null || object === void 0 ? void 0 : object.events) ? object.events.map(e => _tendermint_abci_types__WEBPACK_IMPORTED_MODULE_1__.Event.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.data = message.data;
    obj.log = message.log;

    if (message.events) {
      obj.events = message.events.map(e => e ? _tendermint_abci_types__WEBPACK_IMPORTED_MODULE_1__.Event.toAmino(e) : undefined);
    } else {
      obj.events = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return Result.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/Result",
      value: Result.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return Result.decode(message.value);
  },

  toProto(message) {
    return Result.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.base.abci.v1beta1.Result",
      value: Result.encode(message).finish()
    };
  }

};

function createBaseSimulationResponse() {
  return {
    gasInfo: undefined,
    result: undefined
  };
}

const SimulationResponse = {
  typeUrl: "/cosmos.base.abci.v1beta1.SimulationResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.gasInfo !== undefined) {
      GasInfo.encode(message.gasInfo, writer.uint32(10).fork()).ldelim();
    }

    if (message.result !== undefined) {
      Result.encode(message.result, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSimulationResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.gasInfo = GasInfo.decode(reader, reader.uint32());
          break;

        case 2:
          message.result = Result.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseSimulationResponse();
    message.gasInfo = object.gasInfo !== undefined && object.gasInfo !== null ? GasInfo.fromPartial(object.gasInfo) : undefined;
    message.result = object.result !== undefined && object.result !== null ? Result.fromPartial(object.result) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      gasInfo: object !== null && object !== void 0 && object.gas_info ? GasInfo.fromAmino(object.gas_info) : undefined,
      result: object !== null && object !== void 0 && object.result ? Result.fromAmino(object.result) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.gas_info = message.gasInfo ? GasInfo.toAmino(message.gasInfo) : undefined;
    obj.result = message.result ? Result.toAmino(message.result) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return SimulationResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/SimulationResponse",
      value: SimulationResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return SimulationResponse.decode(message.value);
  },

  toProto(message) {
    return SimulationResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.base.abci.v1beta1.SimulationResponse",
      value: SimulationResponse.encode(message).finish()
    };
  }

};

function createBaseMsgData() {
  return {
    msgType: "",
    data: new Uint8Array()
  };
}

const MsgData = {
  typeUrl: "/cosmos.base.abci.v1beta1.MsgData",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.msgType !== "") {
      writer.uint32(10).string(message.msgType);
    }

    if (message.data.length !== 0) {
      writer.uint32(18).bytes(message.data);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgData();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.msgType = reader.string();
          break;

        case 2:
          message.data = reader.bytes();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$msgType, _object$data3;

    const message = createBaseMsgData();
    message.msgType = (_object$msgType = object.msgType) !== null && _object$msgType !== void 0 ? _object$msgType : "";
    message.data = (_object$data3 = object.data) !== null && _object$data3 !== void 0 ? _object$data3 : new Uint8Array();
    return message;
  },

  fromAmino(object) {
    return {
      msgType: object.msg_type,
      data: object.data
    };
  },

  toAmino(message) {
    const obj = {};
    obj.msg_type = message.msgType;
    obj.data = message.data;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgData.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/MsgData",
      value: MsgData.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgData.decode(message.value);
  },

  toProto(message) {
    return MsgData.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.base.abci.v1beta1.MsgData",
      value: MsgData.encode(message).finish()
    };
  }

};

function createBaseTxMsgData() {
  return {
    data: []
  };
}

const TxMsgData = {
  typeUrl: "/cosmos.base.abci.v1beta1.TxMsgData",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    for (const v of message.data) {
      MsgData.encode(v, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTxMsgData();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.data.push(MsgData.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$data4;

    const message = createBaseTxMsgData();
    message.data = ((_object$data4 = object.data) === null || _object$data4 === void 0 ? void 0 : _object$data4.map(e => MsgData.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      data: Array.isArray(object === null || object === void 0 ? void 0 : object.data) ? object.data.map(e => MsgData.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.data) {
      obj.data = message.data.map(e => e ? MsgData.toAmino(e) : undefined);
    } else {
      obj.data = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return TxMsgData.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/TxMsgData",
      value: TxMsgData.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return TxMsgData.decode(message.value);
  },

  toProto(message) {
    return TxMsgData.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.base.abci.v1beta1.TxMsgData",
      value: TxMsgData.encode(message).finish()
    };
  }

};

function createBaseSearchTxsResult() {
  return {
    totalCount: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO,
    count: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO,
    pageNumber: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO,
    pageTotal: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO,
    limit: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO,
    txs: []
  };
}

const SearchTxsResult = {
  typeUrl: "/cosmos.base.abci.v1beta1.SearchTxsResult",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (!message.totalCount.isZero()) {
      writer.uint32(8).uint64(message.totalCount);
    }

    if (!message.count.isZero()) {
      writer.uint32(16).uint64(message.count);
    }

    if (!message.pageNumber.isZero()) {
      writer.uint32(24).uint64(message.pageNumber);
    }

    if (!message.pageTotal.isZero()) {
      writer.uint32(32).uint64(message.pageTotal);
    }

    if (!message.limit.isZero()) {
      writer.uint32(40).uint64(message.limit);
    }

    for (const v of message.txs) {
      TxResponse.encode(v, writer.uint32(50).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSearchTxsResult();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.totalCount = reader.uint64();
          break;

        case 2:
          message.count = reader.uint64();
          break;

        case 3:
          message.pageNumber = reader.uint64();
          break;

        case 4:
          message.pageTotal = reader.uint64();
          break;

        case 5:
          message.limit = reader.uint64();
          break;

        case 6:
          message.txs.push(TxResponse.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$txs;

    const message = createBaseSearchTxsResult();
    message.totalCount = object.totalCount !== undefined && object.totalCount !== null ? _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromValue */ .dK.fromValue(object.totalCount) : _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO;
    message.count = object.count !== undefined && object.count !== null ? _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromValue */ .dK.fromValue(object.count) : _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO;
    message.pageNumber = object.pageNumber !== undefined && object.pageNumber !== null ? _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromValue */ .dK.fromValue(object.pageNumber) : _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO;
    message.pageTotal = object.pageTotal !== undefined && object.pageTotal !== null ? _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromValue */ .dK.fromValue(object.pageTotal) : _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO;
    message.limit = object.limit !== undefined && object.limit !== null ? _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromValue */ .dK.fromValue(object.limit) : _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO;
    message.txs = ((_object$txs = object.txs) === null || _object$txs === void 0 ? void 0 : _object$txs.map(e => TxResponse.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      totalCount: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromString */ .dK.fromString(object.total_count),
      count: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromString */ .dK.fromString(object.count),
      pageNumber: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromString */ .dK.fromString(object.page_number),
      pageTotal: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromString */ .dK.fromString(object.page_total),
      limit: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromString */ .dK.fromString(object.limit),
      txs: Array.isArray(object === null || object === void 0 ? void 0 : object.txs) ? object.txs.map(e => TxResponse.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.total_count = message.totalCount ? message.totalCount.toString() : undefined;
    obj.count = message.count ? message.count.toString() : undefined;
    obj.page_number = message.pageNumber ? message.pageNumber.toString() : undefined;
    obj.page_total = message.pageTotal ? message.pageTotal.toString() : undefined;
    obj.limit = message.limit ? message.limit.toString() : undefined;

    if (message.txs) {
      obj.txs = message.txs.map(e => e ? TxResponse.toAmino(e) : undefined);
    } else {
      obj.txs = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return SearchTxsResult.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/SearchTxsResult",
      value: SearchTxsResult.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return SearchTxsResult.decode(message.value);
  },

  toProto(message) {
    return SearchTxsResult.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.base.abci.v1beta1.SearchTxsResult",
      value: SearchTxsResult.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 34318:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ConfigRequest": function() { return /* binding */ ConfigRequest; },
/* harmony export */   "ConfigResponse": function() { return /* binding */ ConfigResponse; }
/* harmony export */ });
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__);

/** ConfigRequest defines the request structure for the Config gRPC query. */

function createBaseConfigRequest() {
  return {};
}

const ConfigRequest = {
  typeUrl: "/cosmos.base.node.v1beta1.ConfigRequest",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseConfigRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseConfigRequest();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return ConfigRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/ConfigRequest",
      value: ConfigRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return ConfigRequest.decode(message.value);
  },

  toProto(message) {
    return ConfigRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.base.node.v1beta1.ConfigRequest",
      value: ConfigRequest.encode(message).finish()
    };
  }

};

function createBaseConfigResponse() {
  return {
    minimumGasPrice: ""
  };
}

const ConfigResponse = {
  typeUrl: "/cosmos.base.node.v1beta1.ConfigResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Writer.create()) {
    if (message.minimumGasPrice !== "") {
      writer.uint32(10).string(message.minimumGasPrice);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseConfigResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.minimumGasPrice = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$minimumGasPri;

    const message = createBaseConfigResponse();
    message.minimumGasPrice = (_object$minimumGasPri = object.minimumGasPrice) !== null && _object$minimumGasPri !== void 0 ? _object$minimumGasPri : "";
    return message;
  },

  fromAmino(object) {
    return {
      minimumGasPrice: object.minimum_gas_price
    };
  },

  toAmino(message) {
    const obj = {};
    obj.minimum_gas_price = message.minimumGasPrice;
    return obj;
  },

  fromAminoMsg(object) {
    return ConfigResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/ConfigResponse",
      value: ConfigResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return ConfigResponse.decode(message.value);
  },

  toProto(message) {
    return ConfigResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.base.node.v1beta1.ConfigResponse",
      value: ConfigResponse.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 91318:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LCDQueryClient": function() { return /* binding */ LCDQueryClient; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4942);

class LCDQueryClient {
  constructor({
    requestClient
  }) {
    (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, "req", void 0);

    this.req = requestClient;
    this.config = this.config.bind(this);
  }
  /* Config queries for the operator configuration. */


  async config(_params = {}) {
    const endpoint = `cosmos/base/node/v1beta1/config`;
    return await this.req.get(endpoint);
  }

}

/***/ }),

/***/ 12345:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ServiceClientImpl": function() { return /* binding */ ServiceClientImpl; },
/* harmony export */   "createRpcQueryExtension": function() { return /* binding */ createRpcQueryExtension; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4942);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78441);
/* harmony import */ var _cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34318);




/** Service defines the gRPC querier service for node related queries. */

class ServiceClientImpl {
  constructor(rpc) {
    (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, "rpc", void 0);

    this.rpc = rpc;
    this.config = this.config.bind(this);
  }

  config(request = {}) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.ConfigRequest.encode(request).finish();
    const promise = this.rpc.request("cosmos.base.node.v1beta1.Service", "Config", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.ConfigResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

}
const createRpcQueryExtension = base => {
  const rpc = (0,_cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1__.createProtobufRpcClient)(base);
  const queryService = new ServiceClientImpl(rpc);
  return {
    config(request) {
      return queryService.config(request);
    }

  };
};

/***/ }),

/***/ 48978:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "PageRequest": function() { return /* binding */ PageRequest; },
/* harmony export */   "PageResponse": function() { return /* binding */ PageResponse; }
/* harmony export */ });
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47895);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__);


/**
 * PageRequest is to be embedded in gRPC request messages for efficient
 * pagination. Ex:
 * 
 *  message SomeRequest {
 *          Foo some_parameter = 1;
 *          PageRequest pagination = 2;
 *  }
 */

function createBasePageRequest() {
  return {
    key: new Uint8Array(),
    offset: _helpers__WEBPACK_IMPORTED_MODULE_0__/* .Long.UZERO */ .dK.UZERO,
    limit: _helpers__WEBPACK_IMPORTED_MODULE_0__/* .Long.UZERO */ .dK.UZERO,
    countTotal: false,
    reverse: false
  };
}

const PageRequest = {
  typeUrl: "/cosmos.base.query.v1beta1.PageRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Writer.create()) {
    if (message.key.length !== 0) {
      writer.uint32(10).bytes(message.key);
    }

    if (!message.offset.isZero()) {
      writer.uint32(16).uint64(message.offset);
    }

    if (!message.limit.isZero()) {
      writer.uint32(24).uint64(message.limit);
    }

    if (message.countTotal === true) {
      writer.uint32(32).bool(message.countTotal);
    }

    if (message.reverse === true) {
      writer.uint32(40).bool(message.reverse);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePageRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.key = reader.bytes();
          break;

        case 2:
          message.offset = reader.uint64();
          break;

        case 3:
          message.limit = reader.uint64();
          break;

        case 4:
          message.countTotal = reader.bool();
          break;

        case 5:
          message.reverse = reader.bool();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$key, _object$countTotal, _object$reverse;

    const message = createBasePageRequest();
    message.key = (_object$key = object.key) !== null && _object$key !== void 0 ? _object$key : new Uint8Array();
    message.offset = object.offset !== undefined && object.offset !== null ? _helpers__WEBPACK_IMPORTED_MODULE_0__/* .Long.fromValue */ .dK.fromValue(object.offset) : _helpers__WEBPACK_IMPORTED_MODULE_0__/* .Long.UZERO */ .dK.UZERO;
    message.limit = object.limit !== undefined && object.limit !== null ? _helpers__WEBPACK_IMPORTED_MODULE_0__/* .Long.fromValue */ .dK.fromValue(object.limit) : _helpers__WEBPACK_IMPORTED_MODULE_0__/* .Long.UZERO */ .dK.UZERO;
    message.countTotal = (_object$countTotal = object.countTotal) !== null && _object$countTotal !== void 0 ? _object$countTotal : false;
    message.reverse = (_object$reverse = object.reverse) !== null && _object$reverse !== void 0 ? _object$reverse : false;
    return message;
  },

  fromAmino(object) {
    return {
      key: object.key,
      offset: _helpers__WEBPACK_IMPORTED_MODULE_0__/* .Long.fromString */ .dK.fromString(object.offset),
      limit: _helpers__WEBPACK_IMPORTED_MODULE_0__/* .Long.fromString */ .dK.fromString(object.limit),
      countTotal: object.count_total,
      reverse: object.reverse
    };
  },

  toAmino(message) {
    const obj = {};
    obj.key = message.key;
    obj.offset = message.offset ? message.offset.toString() : undefined;
    obj.limit = message.limit ? message.limit.toString() : undefined;
    obj.count_total = message.countTotal;
    obj.reverse = message.reverse;
    return obj;
  },

  fromAminoMsg(object) {
    return PageRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/PageRequest",
      value: PageRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return PageRequest.decode(message.value);
  },

  toProto(message) {
    return PageRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.base.query.v1beta1.PageRequest",
      value: PageRequest.encode(message).finish()
    };
  }

};

function createBasePageResponse() {
  return {
    nextKey: new Uint8Array(),
    total: _helpers__WEBPACK_IMPORTED_MODULE_0__/* .Long.UZERO */ .dK.UZERO
  };
}

const PageResponse = {
  typeUrl: "/cosmos.base.query.v1beta1.PageResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Writer.create()) {
    if (message.nextKey.length !== 0) {
      writer.uint32(10).bytes(message.nextKey);
    }

    if (!message.total.isZero()) {
      writer.uint32(16).uint64(message.total);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePageResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.nextKey = reader.bytes();
          break;

        case 2:
          message.total = reader.uint64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$nextKey;

    const message = createBasePageResponse();
    message.nextKey = (_object$nextKey = object.nextKey) !== null && _object$nextKey !== void 0 ? _object$nextKey : new Uint8Array();
    message.total = object.total !== undefined && object.total !== null ? _helpers__WEBPACK_IMPORTED_MODULE_0__/* .Long.fromValue */ .dK.fromValue(object.total) : _helpers__WEBPACK_IMPORTED_MODULE_0__/* .Long.UZERO */ .dK.UZERO;
    return message;
  },

  fromAmino(object) {
    return {
      nextKey: object.next_key,
      total: _helpers__WEBPACK_IMPORTED_MODULE_0__/* .Long.fromString */ .dK.fromString(object.total)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.next_key = message.nextKey;
    obj.total = message.total ? message.total.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return PageResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/PageResponse",
      value: PageResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return PageResponse.decode(message.value);
  },

  toProto(message) {
    return PageResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.base.query.v1beta1.PageResponse",
      value: PageResponse.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 26178:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Coin": function() { return /* binding */ Coin; },
/* harmony export */   "DecCoin": function() { return /* binding */ DecCoin; },
/* harmony export */   "DecProto": function() { return /* binding */ DecProto; },
/* harmony export */   "IntProto": function() { return /* binding */ IntProto; }
/* harmony export */ });
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__);

/**
 * Coin defines a token with a denomination and an amount.
 * 
 * NOTE: The amount field is an Int which implements the custom method
 * signatures required by gogoproto.
 */

function createBaseCoin() {
  return {
    denom: "",
    amount: ""
  };
}

const Coin = {
  typeUrl: "/cosmos.base.v1beta1.Coin",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Writer.create()) {
    if (message.denom !== "") {
      writer.uint32(10).string(message.denom);
    }

    if (message.amount !== "") {
      writer.uint32(18).string(message.amount);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCoin();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.denom = reader.string();
          break;

        case 2:
          message.amount = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$denom, _object$amount;

    const message = createBaseCoin();
    message.denom = (_object$denom = object.denom) !== null && _object$denom !== void 0 ? _object$denom : "";
    message.amount = (_object$amount = object.amount) !== null && _object$amount !== void 0 ? _object$amount : "";
    return message;
  },

  fromAmino(object) {
    return {
      denom: object.denom,
      amount: object.amount
    };
  },

  toAmino(message) {
    const obj = {};
    obj.denom = message.denom;
    obj.amount = message.amount;
    return obj;
  },

  fromAminoMsg(object) {
    return Coin.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/Coin",
      value: Coin.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return Coin.decode(message.value);
  },

  toProto(message) {
    return Coin.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.base.v1beta1.Coin",
      value: Coin.encode(message).finish()
    };
  }

};

function createBaseDecCoin() {
  return {
    denom: "",
    amount: ""
  };
}

const DecCoin = {
  typeUrl: "/cosmos.base.v1beta1.DecCoin",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Writer.create()) {
    if (message.denom !== "") {
      writer.uint32(10).string(message.denom);
    }

    if (message.amount !== "") {
      writer.uint32(18).string(message.amount);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDecCoin();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.denom = reader.string();
          break;

        case 2:
          message.amount = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$denom2, _object$amount2;

    const message = createBaseDecCoin();
    message.denom = (_object$denom2 = object.denom) !== null && _object$denom2 !== void 0 ? _object$denom2 : "";
    message.amount = (_object$amount2 = object.amount) !== null && _object$amount2 !== void 0 ? _object$amount2 : "";
    return message;
  },

  fromAmino(object) {
    return {
      denom: object.denom,
      amount: object.amount
    };
  },

  toAmino(message) {
    const obj = {};
    obj.denom = message.denom;
    obj.amount = message.amount;
    return obj;
  },

  fromAminoMsg(object) {
    return DecCoin.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/DecCoin",
      value: DecCoin.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return DecCoin.decode(message.value);
  },

  toProto(message) {
    return DecCoin.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.base.v1beta1.DecCoin",
      value: DecCoin.encode(message).finish()
    };
  }

};

function createBaseIntProto() {
  return {
    int: ""
  };
}

const IntProto = {
  typeUrl: "/cosmos.base.v1beta1.IntProto",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Writer.create()) {
    if (message.int !== "") {
      writer.uint32(10).string(message.int);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseIntProto();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.int = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$int;

    const message = createBaseIntProto();
    message.int = (_object$int = object.int) !== null && _object$int !== void 0 ? _object$int : "";
    return message;
  },

  fromAmino(object) {
    return {
      int: object.int
    };
  },

  toAmino(message) {
    const obj = {};
    obj.int = message.int;
    return obj;
  },

  fromAminoMsg(object) {
    return IntProto.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/IntProto",
      value: IntProto.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return IntProto.decode(message.value);
  },

  toProto(message) {
    return IntProto.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.base.v1beta1.IntProto",
      value: IntProto.encode(message).finish()
    };
  }

};

function createBaseDecProto() {
  return {
    dec: ""
  };
}

const DecProto = {
  typeUrl: "/cosmos.base.v1beta1.DecProto",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Writer.create()) {
    if (message.dec !== "") {
      writer.uint32(10).string(message.dec);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDecProto();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.dec = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$dec;

    const message = createBaseDecProto();
    message.dec = (_object$dec = object.dec) !== null && _object$dec !== void 0 ? _object$dec : "";
    return message;
  },

  fromAmino(object) {
    return {
      dec: object.dec
    };
  },

  toAmino(message) {
    const obj = {};
    obj.dec = message.dec;
    return obj;
  },

  fromAminoMsg(object) {
    return DecProto.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/DecProto",
      value: DecProto.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return DecProto.decode(message.value);
  },

  toProto(message) {
    return DecProto.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.base.v1beta1.DecProto",
      value: DecProto.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 35301:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ CompactBitArray; }
/* harmony export */ });
/* unused harmony export MultiSignature */
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__);

/**
 * MultiSignature wraps the signatures from a multisig.LegacyAminoPubKey.
 * See cosmos.tx.v1betata1.ModeInfo.Multi for how to specify which signers
 * signed and with which modes.
 */

function createBaseMultiSignature() {
  return {
    signatures: []
  };
}

const MultiSignature = {
  typeUrl: "/cosmos.crypto.multisig.v1beta1.MultiSignature",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Writer.create()) {
    for (const v of message.signatures) {
      writer.uint32(10).bytes(v);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMultiSignature();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.signatures.push(reader.bytes());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$signatures;

    const message = createBaseMultiSignature();
    message.signatures = ((_object$signatures = object.signatures) === null || _object$signatures === void 0 ? void 0 : _object$signatures.map(e => e)) || [];
    return message;
  },

  fromAmino(object) {
    return {
      signatures: Array.isArray(object === null || object === void 0 ? void 0 : object.signatures) ? object.signatures.map(e => e) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.signatures) {
      obj.signatures = message.signatures.map(e => e);
    } else {
      obj.signatures = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return MultiSignature.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/MultiSignature",
      value: MultiSignature.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MultiSignature.decode(message.value);
  },

  toProto(message) {
    return MultiSignature.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.crypto.multisig.v1beta1.MultiSignature",
      value: MultiSignature.encode(message).finish()
    };
  }

};

function createBaseCompactBitArray() {
  return {
    extraBitsStored: 0,
    elems: new Uint8Array()
  };
}

const CompactBitArray = {
  typeUrl: "/cosmos.crypto.multisig.v1beta1.CompactBitArray",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Writer.create()) {
    if (message.extraBitsStored !== 0) {
      writer.uint32(8).uint32(message.extraBitsStored);
    }

    if (message.elems.length !== 0) {
      writer.uint32(18).bytes(message.elems);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCompactBitArray();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.extraBitsStored = reader.uint32();
          break;

        case 2:
          message.elems = reader.bytes();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$extraBitsStor, _object$elems;

    const message = createBaseCompactBitArray();
    message.extraBitsStored = (_object$extraBitsStor = object.extraBitsStored) !== null && _object$extraBitsStor !== void 0 ? _object$extraBitsStor : 0;
    message.elems = (_object$elems = object.elems) !== null && _object$elems !== void 0 ? _object$elems : new Uint8Array();
    return message;
  },

  fromAmino(object) {
    return {
      extraBitsStored: object.extra_bits_stored,
      elems: object.elems
    };
  },

  toAmino(message) {
    const obj = {};
    obj.extra_bits_stored = message.extraBitsStored;
    obj.elems = message.elems;
    return obj;
  },

  fromAminoMsg(object) {
    return CompactBitArray.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/CompactBitArray",
      value: CompactBitArray.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return CompactBitArray.decode(message.value);
  },

  toProto(message) {
    return CompactBitArray.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.crypto.multisig.v1beta1.CompactBitArray",
      value: CompactBitArray.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 82622:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CommunityPoolSpendProposal": function() { return /* binding */ CommunityPoolSpendProposal; },
/* harmony export */   "CommunityPoolSpendProposalWithDeposit": function() { return /* binding */ CommunityPoolSpendProposalWithDeposit; },
/* harmony export */   "DelegationDelegatorReward": function() { return /* binding */ DelegationDelegatorReward; },
/* harmony export */   "DelegatorStartingInfo": function() { return /* binding */ DelegatorStartingInfo; },
/* harmony export */   "FeePool": function() { return /* binding */ FeePool; },
/* harmony export */   "Params": function() { return /* binding */ Params; },
/* harmony export */   "ValidatorAccumulatedCommission": function() { return /* binding */ ValidatorAccumulatedCommission; },
/* harmony export */   "ValidatorCurrentRewards": function() { return /* binding */ ValidatorCurrentRewards; },
/* harmony export */   "ValidatorHistoricalRewards": function() { return /* binding */ ValidatorHistoricalRewards; },
/* harmony export */   "ValidatorOutstandingRewards": function() { return /* binding */ ValidatorOutstandingRewards; },
/* harmony export */   "ValidatorSlashEvent": function() { return /* binding */ ValidatorSlashEvent; },
/* harmony export */   "ValidatorSlashEvents": function() { return /* binding */ ValidatorSlashEvents; }
/* harmony export */ });
/* harmony import */ var _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26178);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47895);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__);



/** Params defines the set of params for the distribution module. */

function createBaseParams() {
  return {
    communityTax: "",
    baseProposerReward: "",
    bonusProposerReward: "",
    withdrawAddrEnabled: false
  };
}

const Params = {
  typeUrl: "/cosmos.distribution.v1beta1.Params",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (message.communityTax !== "") {
      writer.uint32(10).string(message.communityTax);
    }

    if (message.baseProposerReward !== "") {
      writer.uint32(18).string(message.baseProposerReward);
    }

    if (message.bonusProposerReward !== "") {
      writer.uint32(26).string(message.bonusProposerReward);
    }

    if (message.withdrawAddrEnabled === true) {
      writer.uint32(32).bool(message.withdrawAddrEnabled);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseParams();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.communityTax = reader.string();
          break;

        case 2:
          message.baseProposerReward = reader.string();
          break;

        case 3:
          message.bonusProposerReward = reader.string();
          break;

        case 4:
          message.withdrawAddrEnabled = reader.bool();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$communityTax, _object$baseProposerR, _object$bonusProposer, _object$withdrawAddrE;

    const message = createBaseParams();
    message.communityTax = (_object$communityTax = object.communityTax) !== null && _object$communityTax !== void 0 ? _object$communityTax : "";
    message.baseProposerReward = (_object$baseProposerR = object.baseProposerReward) !== null && _object$baseProposerR !== void 0 ? _object$baseProposerR : "";
    message.bonusProposerReward = (_object$bonusProposer = object.bonusProposerReward) !== null && _object$bonusProposer !== void 0 ? _object$bonusProposer : "";
    message.withdrawAddrEnabled = (_object$withdrawAddrE = object.withdrawAddrEnabled) !== null && _object$withdrawAddrE !== void 0 ? _object$withdrawAddrE : false;
    return message;
  },

  fromAmino(object) {
    return {
      communityTax: object.community_tax,
      baseProposerReward: object.base_proposer_reward,
      bonusProposerReward: object.bonus_proposer_reward,
      withdrawAddrEnabled: object.withdraw_addr_enabled
    };
  },

  toAmino(message) {
    const obj = {};
    obj.community_tax = message.communityTax;
    obj.base_proposer_reward = message.baseProposerReward;
    obj.bonus_proposer_reward = message.bonusProposerReward;
    obj.withdraw_addr_enabled = message.withdrawAddrEnabled;
    return obj;
  },

  fromAminoMsg(object) {
    return Params.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/x/distribution/Params",
      value: Params.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return Params.decode(message.value);
  },

  toProto(message) {
    return Params.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.distribution.v1beta1.Params",
      value: Params.encode(message).finish()
    };
  }

};

function createBaseValidatorHistoricalRewards() {
  return {
    cumulativeRewardRatio: [],
    referenceCount: 0
  };
}

const ValidatorHistoricalRewards = {
  typeUrl: "/cosmos.distribution.v1beta1.ValidatorHistoricalRewards",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    for (const v of message.cumulativeRewardRatio) {
      _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.DecCoin.encode(v, writer.uint32(10).fork()).ldelim();
    }

    if (message.referenceCount !== 0) {
      writer.uint32(16).uint32(message.referenceCount);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseValidatorHistoricalRewards();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.cumulativeRewardRatio.push(_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.DecCoin.decode(reader, reader.uint32()));
          break;

        case 2:
          message.referenceCount = reader.uint32();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$cumulativeRew, _object$referenceCoun;

    const message = createBaseValidatorHistoricalRewards();
    message.cumulativeRewardRatio = ((_object$cumulativeRew = object.cumulativeRewardRatio) === null || _object$cumulativeRew === void 0 ? void 0 : _object$cumulativeRew.map(e => _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.DecCoin.fromPartial(e))) || [];
    message.referenceCount = (_object$referenceCoun = object.referenceCount) !== null && _object$referenceCoun !== void 0 ? _object$referenceCoun : 0;
    return message;
  },

  fromAmino(object) {
    return {
      cumulativeRewardRatio: Array.isArray(object === null || object === void 0 ? void 0 : object.cumulative_reward_ratio) ? object.cumulative_reward_ratio.map(e => _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.DecCoin.fromAmino(e)) : [],
      referenceCount: object.reference_count
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.cumulativeRewardRatio) {
      obj.cumulative_reward_ratio = message.cumulativeRewardRatio.map(e => e ? _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.DecCoin.toAmino(e) : undefined);
    } else {
      obj.cumulative_reward_ratio = [];
    }

    obj.reference_count = message.referenceCount;
    return obj;
  },

  fromAminoMsg(object) {
    return ValidatorHistoricalRewards.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/ValidatorHistoricalRewards",
      value: ValidatorHistoricalRewards.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return ValidatorHistoricalRewards.decode(message.value);
  },

  toProto(message) {
    return ValidatorHistoricalRewards.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.distribution.v1beta1.ValidatorHistoricalRewards",
      value: ValidatorHistoricalRewards.encode(message).finish()
    };
  }

};

function createBaseValidatorCurrentRewards() {
  return {
    rewards: [],
    period: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.UZERO */ .dK.UZERO
  };
}

const ValidatorCurrentRewards = {
  typeUrl: "/cosmos.distribution.v1beta1.ValidatorCurrentRewards",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    for (const v of message.rewards) {
      _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.DecCoin.encode(v, writer.uint32(10).fork()).ldelim();
    }

    if (!message.period.isZero()) {
      writer.uint32(16).uint64(message.period);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseValidatorCurrentRewards();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.rewards.push(_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.DecCoin.decode(reader, reader.uint32()));
          break;

        case 2:
          message.period = reader.uint64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$rewards;

    const message = createBaseValidatorCurrentRewards();
    message.rewards = ((_object$rewards = object.rewards) === null || _object$rewards === void 0 ? void 0 : _object$rewards.map(e => _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.DecCoin.fromPartial(e))) || [];
    message.period = object.period !== undefined && object.period !== null ? _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromValue */ .dK.fromValue(object.period) : _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.UZERO */ .dK.UZERO;
    return message;
  },

  fromAmino(object) {
    return {
      rewards: Array.isArray(object === null || object === void 0 ? void 0 : object.rewards) ? object.rewards.map(e => _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.DecCoin.fromAmino(e)) : [],
      period: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromString */ .dK.fromString(object.period)
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.rewards) {
      obj.rewards = message.rewards.map(e => e ? _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.DecCoin.toAmino(e) : undefined);
    } else {
      obj.rewards = [];
    }

    obj.period = message.period ? message.period.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return ValidatorCurrentRewards.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/ValidatorCurrentRewards",
      value: ValidatorCurrentRewards.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return ValidatorCurrentRewards.decode(message.value);
  },

  toProto(message) {
    return ValidatorCurrentRewards.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.distribution.v1beta1.ValidatorCurrentRewards",
      value: ValidatorCurrentRewards.encode(message).finish()
    };
  }

};

function createBaseValidatorAccumulatedCommission() {
  return {
    commission: []
  };
}

const ValidatorAccumulatedCommission = {
  typeUrl: "/cosmos.distribution.v1beta1.ValidatorAccumulatedCommission",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    for (const v of message.commission) {
      _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.DecCoin.encode(v, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseValidatorAccumulatedCommission();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.commission.push(_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.DecCoin.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$commission;

    const message = createBaseValidatorAccumulatedCommission();
    message.commission = ((_object$commission = object.commission) === null || _object$commission === void 0 ? void 0 : _object$commission.map(e => _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.DecCoin.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      commission: Array.isArray(object === null || object === void 0 ? void 0 : object.commission) ? object.commission.map(e => _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.DecCoin.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.commission) {
      obj.commission = message.commission.map(e => e ? _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.DecCoin.toAmino(e) : undefined);
    } else {
      obj.commission = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return ValidatorAccumulatedCommission.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/ValidatorAccumulatedCommission",
      value: ValidatorAccumulatedCommission.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return ValidatorAccumulatedCommission.decode(message.value);
  },

  toProto(message) {
    return ValidatorAccumulatedCommission.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.distribution.v1beta1.ValidatorAccumulatedCommission",
      value: ValidatorAccumulatedCommission.encode(message).finish()
    };
  }

};

function createBaseValidatorOutstandingRewards() {
  return {
    rewards: []
  };
}

const ValidatorOutstandingRewards = {
  typeUrl: "/cosmos.distribution.v1beta1.ValidatorOutstandingRewards",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    for (const v of message.rewards) {
      _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.DecCoin.encode(v, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseValidatorOutstandingRewards();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.rewards.push(_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.DecCoin.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$rewards2;

    const message = createBaseValidatorOutstandingRewards();
    message.rewards = ((_object$rewards2 = object.rewards) === null || _object$rewards2 === void 0 ? void 0 : _object$rewards2.map(e => _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.DecCoin.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      rewards: Array.isArray(object === null || object === void 0 ? void 0 : object.rewards) ? object.rewards.map(e => _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.DecCoin.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.rewards) {
      obj.rewards = message.rewards.map(e => e ? _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.DecCoin.toAmino(e) : undefined);
    } else {
      obj.rewards = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return ValidatorOutstandingRewards.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/ValidatorOutstandingRewards",
      value: ValidatorOutstandingRewards.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return ValidatorOutstandingRewards.decode(message.value);
  },

  toProto(message) {
    return ValidatorOutstandingRewards.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.distribution.v1beta1.ValidatorOutstandingRewards",
      value: ValidatorOutstandingRewards.encode(message).finish()
    };
  }

};

function createBaseValidatorSlashEvent() {
  return {
    validatorPeriod: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.UZERO */ .dK.UZERO,
    fraction: ""
  };
}

const ValidatorSlashEvent = {
  typeUrl: "/cosmos.distribution.v1beta1.ValidatorSlashEvent",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (!message.validatorPeriod.isZero()) {
      writer.uint32(8).uint64(message.validatorPeriod);
    }

    if (message.fraction !== "") {
      writer.uint32(18).string(message.fraction);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseValidatorSlashEvent();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.validatorPeriod = reader.uint64();
          break;

        case 2:
          message.fraction = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$fraction;

    const message = createBaseValidatorSlashEvent();
    message.validatorPeriod = object.validatorPeriod !== undefined && object.validatorPeriod !== null ? _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromValue */ .dK.fromValue(object.validatorPeriod) : _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.UZERO */ .dK.UZERO;
    message.fraction = (_object$fraction = object.fraction) !== null && _object$fraction !== void 0 ? _object$fraction : "";
    return message;
  },

  fromAmino(object) {
    return {
      validatorPeriod: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromString */ .dK.fromString(object.validator_period),
      fraction: object.fraction
    };
  },

  toAmino(message) {
    const obj = {};
    obj.validator_period = message.validatorPeriod ? message.validatorPeriod.toString() : undefined;
    obj.fraction = message.fraction;
    return obj;
  },

  fromAminoMsg(object) {
    return ValidatorSlashEvent.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/ValidatorSlashEvent",
      value: ValidatorSlashEvent.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return ValidatorSlashEvent.decode(message.value);
  },

  toProto(message) {
    return ValidatorSlashEvent.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.distribution.v1beta1.ValidatorSlashEvent",
      value: ValidatorSlashEvent.encode(message).finish()
    };
  }

};

function createBaseValidatorSlashEvents() {
  return {
    validatorSlashEvents: []
  };
}

const ValidatorSlashEvents = {
  typeUrl: "/cosmos.distribution.v1beta1.ValidatorSlashEvents",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    for (const v of message.validatorSlashEvents) {
      ValidatorSlashEvent.encode(v, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseValidatorSlashEvents();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.validatorSlashEvents.push(ValidatorSlashEvent.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$validatorSlas;

    const message = createBaseValidatorSlashEvents();
    message.validatorSlashEvents = ((_object$validatorSlas = object.validatorSlashEvents) === null || _object$validatorSlas === void 0 ? void 0 : _object$validatorSlas.map(e => ValidatorSlashEvent.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      validatorSlashEvents: Array.isArray(object === null || object === void 0 ? void 0 : object.validator_slash_events) ? object.validator_slash_events.map(e => ValidatorSlashEvent.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.validatorSlashEvents) {
      obj.validator_slash_events = message.validatorSlashEvents.map(e => e ? ValidatorSlashEvent.toAmino(e) : undefined);
    } else {
      obj.validator_slash_events = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return ValidatorSlashEvents.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/ValidatorSlashEvents",
      value: ValidatorSlashEvents.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return ValidatorSlashEvents.decode(message.value);
  },

  toProto(message) {
    return ValidatorSlashEvents.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.distribution.v1beta1.ValidatorSlashEvents",
      value: ValidatorSlashEvents.encode(message).finish()
    };
  }

};

function createBaseFeePool() {
  return {
    communityPool: []
  };
}

const FeePool = {
  typeUrl: "/cosmos.distribution.v1beta1.FeePool",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    for (const v of message.communityPool) {
      _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.DecCoin.encode(v, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFeePool();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.communityPool.push(_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.DecCoin.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$communityPool;

    const message = createBaseFeePool();
    message.communityPool = ((_object$communityPool = object.communityPool) === null || _object$communityPool === void 0 ? void 0 : _object$communityPool.map(e => _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.DecCoin.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      communityPool: Array.isArray(object === null || object === void 0 ? void 0 : object.community_pool) ? object.community_pool.map(e => _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.DecCoin.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.communityPool) {
      obj.community_pool = message.communityPool.map(e => e ? _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.DecCoin.toAmino(e) : undefined);
    } else {
      obj.community_pool = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return FeePool.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/FeePool",
      value: FeePool.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return FeePool.decode(message.value);
  },

  toProto(message) {
    return FeePool.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.distribution.v1beta1.FeePool",
      value: FeePool.encode(message).finish()
    };
  }

};

function createBaseCommunityPoolSpendProposal() {
  return {
    title: "",
    description: "",
    recipient: "",
    amount: []
  };
}

const CommunityPoolSpendProposal = {
  typeUrl: "/cosmos.distribution.v1beta1.CommunityPoolSpendProposal",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (message.title !== "") {
      writer.uint32(10).string(message.title);
    }

    if (message.description !== "") {
      writer.uint32(18).string(message.description);
    }

    if (message.recipient !== "") {
      writer.uint32(26).string(message.recipient);
    }

    for (const v of message.amount) {
      _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.encode(v, writer.uint32(34).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCommunityPoolSpendProposal();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.title = reader.string();
          break;

        case 2:
          message.description = reader.string();
          break;

        case 3:
          message.recipient = reader.string();
          break;

        case 4:
          message.amount.push(_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$title, _object$description, _object$recipient, _object$amount;

    const message = createBaseCommunityPoolSpendProposal();
    message.title = (_object$title = object.title) !== null && _object$title !== void 0 ? _object$title : "";
    message.description = (_object$description = object.description) !== null && _object$description !== void 0 ? _object$description : "";
    message.recipient = (_object$recipient = object.recipient) !== null && _object$recipient !== void 0 ? _object$recipient : "";
    message.amount = ((_object$amount = object.amount) === null || _object$amount === void 0 ? void 0 : _object$amount.map(e => _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      title: object.title,
      description: object.description,
      recipient: object.recipient,
      amount: Array.isArray(object === null || object === void 0 ? void 0 : object.amount) ? object.amount.map(e => _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.title = message.title;
    obj.description = message.description;
    obj.recipient = message.recipient;

    if (message.amount) {
      obj.amount = message.amount.map(e => e ? _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.toAmino(e) : undefined);
    } else {
      obj.amount = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return CommunityPoolSpendProposal.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/CommunityPoolSpendProposal",
      value: CommunityPoolSpendProposal.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return CommunityPoolSpendProposal.decode(message.value);
  },

  toProto(message) {
    return CommunityPoolSpendProposal.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.distribution.v1beta1.CommunityPoolSpendProposal",
      value: CommunityPoolSpendProposal.encode(message).finish()
    };
  }

};

function createBaseDelegatorStartingInfo() {
  return {
    previousPeriod: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.UZERO */ .dK.UZERO,
    stake: "",
    height: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.UZERO */ .dK.UZERO
  };
}

const DelegatorStartingInfo = {
  typeUrl: "/cosmos.distribution.v1beta1.DelegatorStartingInfo",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (!message.previousPeriod.isZero()) {
      writer.uint32(8).uint64(message.previousPeriod);
    }

    if (message.stake !== "") {
      writer.uint32(18).string(message.stake);
    }

    if (!message.height.isZero()) {
      writer.uint32(24).uint64(message.height);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDelegatorStartingInfo();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.previousPeriod = reader.uint64();
          break;

        case 2:
          message.stake = reader.string();
          break;

        case 3:
          message.height = reader.uint64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$stake;

    const message = createBaseDelegatorStartingInfo();
    message.previousPeriod = object.previousPeriod !== undefined && object.previousPeriod !== null ? _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromValue */ .dK.fromValue(object.previousPeriod) : _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.UZERO */ .dK.UZERO;
    message.stake = (_object$stake = object.stake) !== null && _object$stake !== void 0 ? _object$stake : "";
    message.height = object.height !== undefined && object.height !== null ? _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromValue */ .dK.fromValue(object.height) : _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.UZERO */ .dK.UZERO;
    return message;
  },

  fromAmino(object) {
    return {
      previousPeriod: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromString */ .dK.fromString(object.previous_period),
      stake: object.stake,
      height: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromString */ .dK.fromString(object.height)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.previous_period = message.previousPeriod ? message.previousPeriod.toString() : undefined;
    obj.stake = message.stake;
    obj.height = message.height ? message.height.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return DelegatorStartingInfo.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/DelegatorStartingInfo",
      value: DelegatorStartingInfo.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return DelegatorStartingInfo.decode(message.value);
  },

  toProto(message) {
    return DelegatorStartingInfo.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.distribution.v1beta1.DelegatorStartingInfo",
      value: DelegatorStartingInfo.encode(message).finish()
    };
  }

};

function createBaseDelegationDelegatorReward() {
  return {
    validatorAddress: "",
    reward: []
  };
}

const DelegationDelegatorReward = {
  typeUrl: "/cosmos.distribution.v1beta1.DelegationDelegatorReward",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (message.validatorAddress !== "") {
      writer.uint32(10).string(message.validatorAddress);
    }

    for (const v of message.reward) {
      _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.DecCoin.encode(v, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDelegationDelegatorReward();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.validatorAddress = reader.string();
          break;

        case 2:
          message.reward.push(_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.DecCoin.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$validatorAddr, _object$reward;

    const message = createBaseDelegationDelegatorReward();
    message.validatorAddress = (_object$validatorAddr = object.validatorAddress) !== null && _object$validatorAddr !== void 0 ? _object$validatorAddr : "";
    message.reward = ((_object$reward = object.reward) === null || _object$reward === void 0 ? void 0 : _object$reward.map(e => _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.DecCoin.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      validatorAddress: object.validator_address,
      reward: Array.isArray(object === null || object === void 0 ? void 0 : object.reward) ? object.reward.map(e => _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.DecCoin.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.validator_address = message.validatorAddress;

    if (message.reward) {
      obj.reward = message.reward.map(e => e ? _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.DecCoin.toAmino(e) : undefined);
    } else {
      obj.reward = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return DelegationDelegatorReward.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/DelegationDelegatorReward",
      value: DelegationDelegatorReward.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return DelegationDelegatorReward.decode(message.value);
  },

  toProto(message) {
    return DelegationDelegatorReward.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.distribution.v1beta1.DelegationDelegatorReward",
      value: DelegationDelegatorReward.encode(message).finish()
    };
  }

};

function createBaseCommunityPoolSpendProposalWithDeposit() {
  return {
    title: "",
    description: "",
    recipient: "",
    amount: "",
    deposit: ""
  };
}

const CommunityPoolSpendProposalWithDeposit = {
  typeUrl: "/cosmos.distribution.v1beta1.CommunityPoolSpendProposalWithDeposit",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (message.title !== "") {
      writer.uint32(10).string(message.title);
    }

    if (message.description !== "") {
      writer.uint32(18).string(message.description);
    }

    if (message.recipient !== "") {
      writer.uint32(26).string(message.recipient);
    }

    if (message.amount !== "") {
      writer.uint32(34).string(message.amount);
    }

    if (message.deposit !== "") {
      writer.uint32(42).string(message.deposit);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCommunityPoolSpendProposalWithDeposit();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.title = reader.string();
          break;

        case 2:
          message.description = reader.string();
          break;

        case 3:
          message.recipient = reader.string();
          break;

        case 4:
          message.amount = reader.string();
          break;

        case 5:
          message.deposit = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$title2, _object$description2, _object$recipient2, _object$amount2, _object$deposit;

    const message = createBaseCommunityPoolSpendProposalWithDeposit();
    message.title = (_object$title2 = object.title) !== null && _object$title2 !== void 0 ? _object$title2 : "";
    message.description = (_object$description2 = object.description) !== null && _object$description2 !== void 0 ? _object$description2 : "";
    message.recipient = (_object$recipient2 = object.recipient) !== null && _object$recipient2 !== void 0 ? _object$recipient2 : "";
    message.amount = (_object$amount2 = object.amount) !== null && _object$amount2 !== void 0 ? _object$amount2 : "";
    message.deposit = (_object$deposit = object.deposit) !== null && _object$deposit !== void 0 ? _object$deposit : "";
    return message;
  },

  fromAmino(object) {
    return {
      title: object.title,
      description: object.description,
      recipient: object.recipient,
      amount: object.amount,
      deposit: object.deposit
    };
  },

  toAmino(message) {
    const obj = {};
    obj.title = message.title;
    obj.description = message.description;
    obj.recipient = message.recipient;
    obj.amount = message.amount;
    obj.deposit = message.deposit;
    return obj;
  },

  fromAminoMsg(object) {
    return CommunityPoolSpendProposalWithDeposit.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/CommunityPoolSpendProposalWithDeposit",
      value: CommunityPoolSpendProposalWithDeposit.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return CommunityPoolSpendProposalWithDeposit.decode(message.value);
  },

  toProto(message) {
    return CommunityPoolSpendProposalWithDeposit.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.distribution.v1beta1.CommunityPoolSpendProposalWithDeposit",
      value: CommunityPoolSpendProposalWithDeposit.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 54909:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QueryCommunityPoolRequest": function() { return /* binding */ QueryCommunityPoolRequest; },
/* harmony export */   "QueryCommunityPoolResponse": function() { return /* binding */ QueryCommunityPoolResponse; },
/* harmony export */   "QueryDelegationRewardsRequest": function() { return /* binding */ QueryDelegationRewardsRequest; },
/* harmony export */   "QueryDelegationRewardsResponse": function() { return /* binding */ QueryDelegationRewardsResponse; },
/* harmony export */   "QueryDelegationTotalRewardsRequest": function() { return /* binding */ QueryDelegationTotalRewardsRequest; },
/* harmony export */   "QueryDelegationTotalRewardsResponse": function() { return /* binding */ QueryDelegationTotalRewardsResponse; },
/* harmony export */   "QueryDelegatorValidatorsRequest": function() { return /* binding */ QueryDelegatorValidatorsRequest; },
/* harmony export */   "QueryDelegatorValidatorsResponse": function() { return /* binding */ QueryDelegatorValidatorsResponse; },
/* harmony export */   "QueryDelegatorWithdrawAddressRequest": function() { return /* binding */ QueryDelegatorWithdrawAddressRequest; },
/* harmony export */   "QueryDelegatorWithdrawAddressResponse": function() { return /* binding */ QueryDelegatorWithdrawAddressResponse; },
/* harmony export */   "QueryParamsRequest": function() { return /* binding */ QueryParamsRequest; },
/* harmony export */   "QueryParamsResponse": function() { return /* binding */ QueryParamsResponse; },
/* harmony export */   "QueryValidatorCommissionRequest": function() { return /* binding */ QueryValidatorCommissionRequest; },
/* harmony export */   "QueryValidatorCommissionResponse": function() { return /* binding */ QueryValidatorCommissionResponse; },
/* harmony export */   "QueryValidatorOutstandingRewardsRequest": function() { return /* binding */ QueryValidatorOutstandingRewardsRequest; },
/* harmony export */   "QueryValidatorOutstandingRewardsResponse": function() { return /* binding */ QueryValidatorOutstandingRewardsResponse; },
/* harmony export */   "QueryValidatorSlashesRequest": function() { return /* binding */ QueryValidatorSlashesRequest; },
/* harmony export */   "QueryValidatorSlashesResponse": function() { return /* binding */ QueryValidatorSlashesResponse; }
/* harmony export */ });
/* harmony import */ var _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48978);
/* harmony import */ var _distribution__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82622);
/* harmony import */ var _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26178);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47895);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__);





/** QueryParamsRequest is the request type for the Query/Params RPC method. */

function createBaseQueryParamsRequest() {
  return {};
}

const QueryParamsRequest = {
  typeUrl: "/cosmos.distribution.v1beta1.QueryParamsRequest",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryParamsRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseQueryParamsRequest();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return QueryParamsRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryParamsRequest",
      value: QueryParamsRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryParamsRequest.decode(message.value);
  },

  toProto(message) {
    return QueryParamsRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.distribution.v1beta1.QueryParamsRequest",
      value: QueryParamsRequest.encode(message).finish()
    };
  }

};

function createBaseQueryParamsResponse() {
  return {
    params: undefined
  };
}

const QueryParamsResponse = {
  typeUrl: "/cosmos.distribution.v1beta1.QueryParamsResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    if (message.params !== undefined) {
      _distribution__WEBPACK_IMPORTED_MODULE_1__.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryParamsResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.params = _distribution__WEBPACK_IMPORTED_MODULE_1__.Params.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseQueryParamsResponse();
    message.params = object.params !== undefined && object.params !== null ? _distribution__WEBPACK_IMPORTED_MODULE_1__.Params.fromPartial(object.params) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      params: object !== null && object !== void 0 && object.params ? _distribution__WEBPACK_IMPORTED_MODULE_1__.Params.fromAmino(object.params) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.params = message.params ? _distribution__WEBPACK_IMPORTED_MODULE_1__.Params.toAmino(message.params) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryParamsResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryParamsResponse",
      value: QueryParamsResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryParamsResponse.decode(message.value);
  },

  toProto(message) {
    return QueryParamsResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.distribution.v1beta1.QueryParamsResponse",
      value: QueryParamsResponse.encode(message).finish()
    };
  }

};

function createBaseQueryValidatorOutstandingRewardsRequest() {
  return {
    validatorAddress: ""
  };
}

const QueryValidatorOutstandingRewardsRequest = {
  typeUrl: "/cosmos.distribution.v1beta1.QueryValidatorOutstandingRewardsRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    if (message.validatorAddress !== "") {
      writer.uint32(10).string(message.validatorAddress);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryValidatorOutstandingRewardsRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.validatorAddress = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$validatorAddr;

    const message = createBaseQueryValidatorOutstandingRewardsRequest();
    message.validatorAddress = (_object$validatorAddr = object.validatorAddress) !== null && _object$validatorAddr !== void 0 ? _object$validatorAddr : "";
    return message;
  },

  fromAmino(object) {
    return {
      validatorAddress: object.validator_address
    };
  },

  toAmino(message) {
    const obj = {};
    obj.validator_address = message.validatorAddress;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryValidatorOutstandingRewardsRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryValidatorOutstandingRewardsRequest",
      value: QueryValidatorOutstandingRewardsRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryValidatorOutstandingRewardsRequest.decode(message.value);
  },

  toProto(message) {
    return QueryValidatorOutstandingRewardsRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.distribution.v1beta1.QueryValidatorOutstandingRewardsRequest",
      value: QueryValidatorOutstandingRewardsRequest.encode(message).finish()
    };
  }

};

function createBaseQueryValidatorOutstandingRewardsResponse() {
  return {
    rewards: undefined
  };
}

const QueryValidatorOutstandingRewardsResponse = {
  typeUrl: "/cosmos.distribution.v1beta1.QueryValidatorOutstandingRewardsResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    if (message.rewards !== undefined) {
      _distribution__WEBPACK_IMPORTED_MODULE_1__.ValidatorOutstandingRewards.encode(message.rewards, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryValidatorOutstandingRewardsResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.rewards = _distribution__WEBPACK_IMPORTED_MODULE_1__.ValidatorOutstandingRewards.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseQueryValidatorOutstandingRewardsResponse();
    message.rewards = object.rewards !== undefined && object.rewards !== null ? _distribution__WEBPACK_IMPORTED_MODULE_1__.ValidatorOutstandingRewards.fromPartial(object.rewards) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      rewards: object !== null && object !== void 0 && object.rewards ? _distribution__WEBPACK_IMPORTED_MODULE_1__.ValidatorOutstandingRewards.fromAmino(object.rewards) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.rewards = message.rewards ? _distribution__WEBPACK_IMPORTED_MODULE_1__.ValidatorOutstandingRewards.toAmino(message.rewards) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryValidatorOutstandingRewardsResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryValidatorOutstandingRewardsResponse",
      value: QueryValidatorOutstandingRewardsResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryValidatorOutstandingRewardsResponse.decode(message.value);
  },

  toProto(message) {
    return QueryValidatorOutstandingRewardsResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.distribution.v1beta1.QueryValidatorOutstandingRewardsResponse",
      value: QueryValidatorOutstandingRewardsResponse.encode(message).finish()
    };
  }

};

function createBaseQueryValidatorCommissionRequest() {
  return {
    validatorAddress: ""
  };
}

const QueryValidatorCommissionRequest = {
  typeUrl: "/cosmos.distribution.v1beta1.QueryValidatorCommissionRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    if (message.validatorAddress !== "") {
      writer.uint32(10).string(message.validatorAddress);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryValidatorCommissionRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.validatorAddress = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$validatorAddr2;

    const message = createBaseQueryValidatorCommissionRequest();
    message.validatorAddress = (_object$validatorAddr2 = object.validatorAddress) !== null && _object$validatorAddr2 !== void 0 ? _object$validatorAddr2 : "";
    return message;
  },

  fromAmino(object) {
    return {
      validatorAddress: object.validator_address
    };
  },

  toAmino(message) {
    const obj = {};
    obj.validator_address = message.validatorAddress;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryValidatorCommissionRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryValidatorCommissionRequest",
      value: QueryValidatorCommissionRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryValidatorCommissionRequest.decode(message.value);
  },

  toProto(message) {
    return QueryValidatorCommissionRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.distribution.v1beta1.QueryValidatorCommissionRequest",
      value: QueryValidatorCommissionRequest.encode(message).finish()
    };
  }

};

function createBaseQueryValidatorCommissionResponse() {
  return {
    commission: undefined
  };
}

const QueryValidatorCommissionResponse = {
  typeUrl: "/cosmos.distribution.v1beta1.QueryValidatorCommissionResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    if (message.commission !== undefined) {
      _distribution__WEBPACK_IMPORTED_MODULE_1__.ValidatorAccumulatedCommission.encode(message.commission, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryValidatorCommissionResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.commission = _distribution__WEBPACK_IMPORTED_MODULE_1__.ValidatorAccumulatedCommission.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseQueryValidatorCommissionResponse();
    message.commission = object.commission !== undefined && object.commission !== null ? _distribution__WEBPACK_IMPORTED_MODULE_1__.ValidatorAccumulatedCommission.fromPartial(object.commission) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      commission: object !== null && object !== void 0 && object.commission ? _distribution__WEBPACK_IMPORTED_MODULE_1__.ValidatorAccumulatedCommission.fromAmino(object.commission) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.commission = message.commission ? _distribution__WEBPACK_IMPORTED_MODULE_1__.ValidatorAccumulatedCommission.toAmino(message.commission) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryValidatorCommissionResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryValidatorCommissionResponse",
      value: QueryValidatorCommissionResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryValidatorCommissionResponse.decode(message.value);
  },

  toProto(message) {
    return QueryValidatorCommissionResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.distribution.v1beta1.QueryValidatorCommissionResponse",
      value: QueryValidatorCommissionResponse.encode(message).finish()
    };
  }

};

function createBaseQueryValidatorSlashesRequest() {
  return {
    validatorAddress: "",
    startingHeight: _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.UZERO */ .dK.UZERO,
    endingHeight: _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.UZERO */ .dK.UZERO,
    pagination: undefined
  };
}

const QueryValidatorSlashesRequest = {
  typeUrl: "/cosmos.distribution.v1beta1.QueryValidatorSlashesRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    if (message.validatorAddress !== "") {
      writer.uint32(10).string(message.validatorAddress);
    }

    if (!message.startingHeight.isZero()) {
      writer.uint32(16).uint64(message.startingHeight);
    }

    if (!message.endingHeight.isZero()) {
      writer.uint32(24).uint64(message.endingHeight);
    }

    if (message.pagination !== undefined) {
      _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.encode(message.pagination, writer.uint32(34).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryValidatorSlashesRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.validatorAddress = reader.string();
          break;

        case 2:
          message.startingHeight = reader.uint64();
          break;

        case 3:
          message.endingHeight = reader.uint64();
          break;

        case 4:
          message.pagination = _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$validatorAddr3;

    const message = createBaseQueryValidatorSlashesRequest();
    message.validatorAddress = (_object$validatorAddr3 = object.validatorAddress) !== null && _object$validatorAddr3 !== void 0 ? _object$validatorAddr3 : "";
    message.startingHeight = object.startingHeight !== undefined && object.startingHeight !== null ? _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.fromValue */ .dK.fromValue(object.startingHeight) : _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.UZERO */ .dK.UZERO;
    message.endingHeight = object.endingHeight !== undefined && object.endingHeight !== null ? _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.fromValue */ .dK.fromValue(object.endingHeight) : _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.UZERO */ .dK.UZERO;
    message.pagination = object.pagination !== undefined && object.pagination !== null ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.fromPartial(object.pagination) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      validatorAddress: object.validator_address,
      startingHeight: _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.fromString */ .dK.fromString(object.starting_height),
      endingHeight: _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.fromString */ .dK.fromString(object.ending_height),
      pagination: object !== null && object !== void 0 && object.pagination ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.fromAmino(object.pagination) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.validator_address = message.validatorAddress;
    obj.starting_height = message.startingHeight ? message.startingHeight.toString() : undefined;
    obj.ending_height = message.endingHeight ? message.endingHeight.toString() : undefined;
    obj.pagination = message.pagination ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.toAmino(message.pagination) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryValidatorSlashesRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryValidatorSlashesRequest",
      value: QueryValidatorSlashesRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryValidatorSlashesRequest.decode(message.value);
  },

  toProto(message) {
    return QueryValidatorSlashesRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.distribution.v1beta1.QueryValidatorSlashesRequest",
      value: QueryValidatorSlashesRequest.encode(message).finish()
    };
  }

};

function createBaseQueryValidatorSlashesResponse() {
  return {
    slashes: [],
    pagination: undefined
  };
}

const QueryValidatorSlashesResponse = {
  typeUrl: "/cosmos.distribution.v1beta1.QueryValidatorSlashesResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    for (const v of message.slashes) {
      _distribution__WEBPACK_IMPORTED_MODULE_1__.ValidatorSlashEvent.encode(v, writer.uint32(10).fork()).ldelim();
    }

    if (message.pagination !== undefined) {
      _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryValidatorSlashesResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.slashes.push(_distribution__WEBPACK_IMPORTED_MODULE_1__.ValidatorSlashEvent.decode(reader, reader.uint32()));
          break;

        case 2:
          message.pagination = _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$slashes;

    const message = createBaseQueryValidatorSlashesResponse();
    message.slashes = ((_object$slashes = object.slashes) === null || _object$slashes === void 0 ? void 0 : _object$slashes.map(e => _distribution__WEBPACK_IMPORTED_MODULE_1__.ValidatorSlashEvent.fromPartial(e))) || [];
    message.pagination = object.pagination !== undefined && object.pagination !== null ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.fromPartial(object.pagination) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      slashes: Array.isArray(object === null || object === void 0 ? void 0 : object.slashes) ? object.slashes.map(e => _distribution__WEBPACK_IMPORTED_MODULE_1__.ValidatorSlashEvent.fromAmino(e)) : [],
      pagination: object !== null && object !== void 0 && object.pagination ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.fromAmino(object.pagination) : undefined
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.slashes) {
      obj.slashes = message.slashes.map(e => e ? _distribution__WEBPACK_IMPORTED_MODULE_1__.ValidatorSlashEvent.toAmino(e) : undefined);
    } else {
      obj.slashes = [];
    }

    obj.pagination = message.pagination ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.toAmino(message.pagination) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryValidatorSlashesResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryValidatorSlashesResponse",
      value: QueryValidatorSlashesResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryValidatorSlashesResponse.decode(message.value);
  },

  toProto(message) {
    return QueryValidatorSlashesResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.distribution.v1beta1.QueryValidatorSlashesResponse",
      value: QueryValidatorSlashesResponse.encode(message).finish()
    };
  }

};

function createBaseQueryDelegationRewardsRequest() {
  return {
    delegatorAddress: "",
    validatorAddress: ""
  };
}

const QueryDelegationRewardsRequest = {
  typeUrl: "/cosmos.distribution.v1beta1.QueryDelegationRewardsRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    if (message.delegatorAddress !== "") {
      writer.uint32(10).string(message.delegatorAddress);
    }

    if (message.validatorAddress !== "") {
      writer.uint32(18).string(message.validatorAddress);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryDelegationRewardsRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.delegatorAddress = reader.string();
          break;

        case 2:
          message.validatorAddress = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$delegatorAddr, _object$validatorAddr4;

    const message = createBaseQueryDelegationRewardsRequest();
    message.delegatorAddress = (_object$delegatorAddr = object.delegatorAddress) !== null && _object$delegatorAddr !== void 0 ? _object$delegatorAddr : "";
    message.validatorAddress = (_object$validatorAddr4 = object.validatorAddress) !== null && _object$validatorAddr4 !== void 0 ? _object$validatorAddr4 : "";
    return message;
  },

  fromAmino(object) {
    return {
      delegatorAddress: object.delegator_address,
      validatorAddress: object.validator_address
    };
  },

  toAmino(message) {
    const obj = {};
    obj.delegator_address = message.delegatorAddress;
    obj.validator_address = message.validatorAddress;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryDelegationRewardsRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryDelegationRewardsRequest",
      value: QueryDelegationRewardsRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryDelegationRewardsRequest.decode(message.value);
  },

  toProto(message) {
    return QueryDelegationRewardsRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.distribution.v1beta1.QueryDelegationRewardsRequest",
      value: QueryDelegationRewardsRequest.encode(message).finish()
    };
  }

};

function createBaseQueryDelegationRewardsResponse() {
  return {
    rewards: []
  };
}

const QueryDelegationRewardsResponse = {
  typeUrl: "/cosmos.distribution.v1beta1.QueryDelegationRewardsResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    for (const v of message.rewards) {
      _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_2__.DecCoin.encode(v, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryDelegationRewardsResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.rewards.push(_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_2__.DecCoin.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$rewards;

    const message = createBaseQueryDelegationRewardsResponse();
    message.rewards = ((_object$rewards = object.rewards) === null || _object$rewards === void 0 ? void 0 : _object$rewards.map(e => _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_2__.DecCoin.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      rewards: Array.isArray(object === null || object === void 0 ? void 0 : object.rewards) ? object.rewards.map(e => _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_2__.DecCoin.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.rewards) {
      obj.rewards = message.rewards.map(e => e ? _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_2__.DecCoin.toAmino(e) : undefined);
    } else {
      obj.rewards = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return QueryDelegationRewardsResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryDelegationRewardsResponse",
      value: QueryDelegationRewardsResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryDelegationRewardsResponse.decode(message.value);
  },

  toProto(message) {
    return QueryDelegationRewardsResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.distribution.v1beta1.QueryDelegationRewardsResponse",
      value: QueryDelegationRewardsResponse.encode(message).finish()
    };
  }

};

function createBaseQueryDelegationTotalRewardsRequest() {
  return {
    delegatorAddress: ""
  };
}

const QueryDelegationTotalRewardsRequest = {
  typeUrl: "/cosmos.distribution.v1beta1.QueryDelegationTotalRewardsRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    if (message.delegatorAddress !== "") {
      writer.uint32(10).string(message.delegatorAddress);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryDelegationTotalRewardsRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.delegatorAddress = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$delegatorAddr2;

    const message = createBaseQueryDelegationTotalRewardsRequest();
    message.delegatorAddress = (_object$delegatorAddr2 = object.delegatorAddress) !== null && _object$delegatorAddr2 !== void 0 ? _object$delegatorAddr2 : "";
    return message;
  },

  fromAmino(object) {
    return {
      delegatorAddress: object.delegator_address
    };
  },

  toAmino(message) {
    const obj = {};
    obj.delegator_address = message.delegatorAddress;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryDelegationTotalRewardsRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryDelegationTotalRewardsRequest",
      value: QueryDelegationTotalRewardsRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryDelegationTotalRewardsRequest.decode(message.value);
  },

  toProto(message) {
    return QueryDelegationTotalRewardsRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.distribution.v1beta1.QueryDelegationTotalRewardsRequest",
      value: QueryDelegationTotalRewardsRequest.encode(message).finish()
    };
  }

};

function createBaseQueryDelegationTotalRewardsResponse() {
  return {
    rewards: [],
    total: []
  };
}

const QueryDelegationTotalRewardsResponse = {
  typeUrl: "/cosmos.distribution.v1beta1.QueryDelegationTotalRewardsResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    for (const v of message.rewards) {
      _distribution__WEBPACK_IMPORTED_MODULE_1__.DelegationDelegatorReward.encode(v, writer.uint32(10).fork()).ldelim();
    }

    for (const v of message.total) {
      _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_2__.DecCoin.encode(v, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryDelegationTotalRewardsResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.rewards.push(_distribution__WEBPACK_IMPORTED_MODULE_1__.DelegationDelegatorReward.decode(reader, reader.uint32()));
          break;

        case 2:
          message.total.push(_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_2__.DecCoin.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$rewards2, _object$total;

    const message = createBaseQueryDelegationTotalRewardsResponse();
    message.rewards = ((_object$rewards2 = object.rewards) === null || _object$rewards2 === void 0 ? void 0 : _object$rewards2.map(e => _distribution__WEBPACK_IMPORTED_MODULE_1__.DelegationDelegatorReward.fromPartial(e))) || [];
    message.total = ((_object$total = object.total) === null || _object$total === void 0 ? void 0 : _object$total.map(e => _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_2__.DecCoin.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      rewards: Array.isArray(object === null || object === void 0 ? void 0 : object.rewards) ? object.rewards.map(e => _distribution__WEBPACK_IMPORTED_MODULE_1__.DelegationDelegatorReward.fromAmino(e)) : [],
      total: Array.isArray(object === null || object === void 0 ? void 0 : object.total) ? object.total.map(e => _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_2__.DecCoin.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.rewards) {
      obj.rewards = message.rewards.map(e => e ? _distribution__WEBPACK_IMPORTED_MODULE_1__.DelegationDelegatorReward.toAmino(e) : undefined);
    } else {
      obj.rewards = [];
    }

    if (message.total) {
      obj.total = message.total.map(e => e ? _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_2__.DecCoin.toAmino(e) : undefined);
    } else {
      obj.total = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return QueryDelegationTotalRewardsResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryDelegationTotalRewardsResponse",
      value: QueryDelegationTotalRewardsResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryDelegationTotalRewardsResponse.decode(message.value);
  },

  toProto(message) {
    return QueryDelegationTotalRewardsResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.distribution.v1beta1.QueryDelegationTotalRewardsResponse",
      value: QueryDelegationTotalRewardsResponse.encode(message).finish()
    };
  }

};

function createBaseQueryDelegatorValidatorsRequest() {
  return {
    delegatorAddress: ""
  };
}

const QueryDelegatorValidatorsRequest = {
  typeUrl: "/cosmos.distribution.v1beta1.QueryDelegatorValidatorsRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    if (message.delegatorAddress !== "") {
      writer.uint32(10).string(message.delegatorAddress);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryDelegatorValidatorsRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.delegatorAddress = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$delegatorAddr3;

    const message = createBaseQueryDelegatorValidatorsRequest();
    message.delegatorAddress = (_object$delegatorAddr3 = object.delegatorAddress) !== null && _object$delegatorAddr3 !== void 0 ? _object$delegatorAddr3 : "";
    return message;
  },

  fromAmino(object) {
    return {
      delegatorAddress: object.delegator_address
    };
  },

  toAmino(message) {
    const obj = {};
    obj.delegator_address = message.delegatorAddress;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryDelegatorValidatorsRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryDelegatorValidatorsRequest",
      value: QueryDelegatorValidatorsRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryDelegatorValidatorsRequest.decode(message.value);
  },

  toProto(message) {
    return QueryDelegatorValidatorsRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.distribution.v1beta1.QueryDelegatorValidatorsRequest",
      value: QueryDelegatorValidatorsRequest.encode(message).finish()
    };
  }

};

function createBaseQueryDelegatorValidatorsResponse() {
  return {
    validators: []
  };
}

const QueryDelegatorValidatorsResponse = {
  typeUrl: "/cosmos.distribution.v1beta1.QueryDelegatorValidatorsResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    for (const v of message.validators) {
      writer.uint32(10).string(v);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryDelegatorValidatorsResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.validators.push(reader.string());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$validators;

    const message = createBaseQueryDelegatorValidatorsResponse();
    message.validators = ((_object$validators = object.validators) === null || _object$validators === void 0 ? void 0 : _object$validators.map(e => e)) || [];
    return message;
  },

  fromAmino(object) {
    return {
      validators: Array.isArray(object === null || object === void 0 ? void 0 : object.validators) ? object.validators.map(e => e) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.validators) {
      obj.validators = message.validators.map(e => e);
    } else {
      obj.validators = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return QueryDelegatorValidatorsResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryDelegatorValidatorsResponse",
      value: QueryDelegatorValidatorsResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryDelegatorValidatorsResponse.decode(message.value);
  },

  toProto(message) {
    return QueryDelegatorValidatorsResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.distribution.v1beta1.QueryDelegatorValidatorsResponse",
      value: QueryDelegatorValidatorsResponse.encode(message).finish()
    };
  }

};

function createBaseQueryDelegatorWithdrawAddressRequest() {
  return {
    delegatorAddress: ""
  };
}

const QueryDelegatorWithdrawAddressRequest = {
  typeUrl: "/cosmos.distribution.v1beta1.QueryDelegatorWithdrawAddressRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    if (message.delegatorAddress !== "") {
      writer.uint32(10).string(message.delegatorAddress);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryDelegatorWithdrawAddressRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.delegatorAddress = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$delegatorAddr4;

    const message = createBaseQueryDelegatorWithdrawAddressRequest();
    message.delegatorAddress = (_object$delegatorAddr4 = object.delegatorAddress) !== null && _object$delegatorAddr4 !== void 0 ? _object$delegatorAddr4 : "";
    return message;
  },

  fromAmino(object) {
    return {
      delegatorAddress: object.delegator_address
    };
  },

  toAmino(message) {
    const obj = {};
    obj.delegator_address = message.delegatorAddress;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryDelegatorWithdrawAddressRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryDelegatorWithdrawAddressRequest",
      value: QueryDelegatorWithdrawAddressRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryDelegatorWithdrawAddressRequest.decode(message.value);
  },

  toProto(message) {
    return QueryDelegatorWithdrawAddressRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.distribution.v1beta1.QueryDelegatorWithdrawAddressRequest",
      value: QueryDelegatorWithdrawAddressRequest.encode(message).finish()
    };
  }

};

function createBaseQueryDelegatorWithdrawAddressResponse() {
  return {
    withdrawAddress: ""
  };
}

const QueryDelegatorWithdrawAddressResponse = {
  typeUrl: "/cosmos.distribution.v1beta1.QueryDelegatorWithdrawAddressResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    if (message.withdrawAddress !== "") {
      writer.uint32(10).string(message.withdrawAddress);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryDelegatorWithdrawAddressResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.withdrawAddress = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$withdrawAddre;

    const message = createBaseQueryDelegatorWithdrawAddressResponse();
    message.withdrawAddress = (_object$withdrawAddre = object.withdrawAddress) !== null && _object$withdrawAddre !== void 0 ? _object$withdrawAddre : "";
    return message;
  },

  fromAmino(object) {
    return {
      withdrawAddress: object.withdraw_address
    };
  },

  toAmino(message) {
    const obj = {};
    obj.withdraw_address = message.withdrawAddress;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryDelegatorWithdrawAddressResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryDelegatorWithdrawAddressResponse",
      value: QueryDelegatorWithdrawAddressResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryDelegatorWithdrawAddressResponse.decode(message.value);
  },

  toProto(message) {
    return QueryDelegatorWithdrawAddressResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.distribution.v1beta1.QueryDelegatorWithdrawAddressResponse",
      value: QueryDelegatorWithdrawAddressResponse.encode(message).finish()
    };
  }

};

function createBaseQueryCommunityPoolRequest() {
  return {};
}

const QueryCommunityPoolRequest = {
  typeUrl: "/cosmos.distribution.v1beta1.QueryCommunityPoolRequest",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryCommunityPoolRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseQueryCommunityPoolRequest();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return QueryCommunityPoolRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryCommunityPoolRequest",
      value: QueryCommunityPoolRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryCommunityPoolRequest.decode(message.value);
  },

  toProto(message) {
    return QueryCommunityPoolRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.distribution.v1beta1.QueryCommunityPoolRequest",
      value: QueryCommunityPoolRequest.encode(message).finish()
    };
  }

};

function createBaseQueryCommunityPoolResponse() {
  return {
    pool: []
  };
}

const QueryCommunityPoolResponse = {
  typeUrl: "/cosmos.distribution.v1beta1.QueryCommunityPoolResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    for (const v of message.pool) {
      _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_2__.DecCoin.encode(v, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryCommunityPoolResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.pool.push(_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_2__.DecCoin.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$pool;

    const message = createBaseQueryCommunityPoolResponse();
    message.pool = ((_object$pool = object.pool) === null || _object$pool === void 0 ? void 0 : _object$pool.map(e => _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_2__.DecCoin.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      pool: Array.isArray(object === null || object === void 0 ? void 0 : object.pool) ? object.pool.map(e => _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_2__.DecCoin.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.pool) {
      obj.pool = message.pool.map(e => e ? _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_2__.DecCoin.toAmino(e) : undefined);
    } else {
      obj.pool = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return QueryCommunityPoolResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryCommunityPoolResponse",
      value: QueryCommunityPoolResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryCommunityPoolResponse.decode(message.value);
  },

  toProto(message) {
    return QueryCommunityPoolResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.distribution.v1beta1.QueryCommunityPoolResponse",
      value: QueryCommunityPoolResponse.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 39:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LCDQueryClient": function() { return /* binding */ LCDQueryClient; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4942);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47895);


class LCDQueryClient {
  constructor({
    requestClient
  }) {
    (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, "req", void 0);

    this.req = requestClient;
    this.params = this.params.bind(this);
    this.validatorOutstandingRewards = this.validatorOutstandingRewards.bind(this);
    this.validatorCommission = this.validatorCommission.bind(this);
    this.validatorSlashes = this.validatorSlashes.bind(this);
    this.delegationRewards = this.delegationRewards.bind(this);
    this.delegationTotalRewards = this.delegationTotalRewards.bind(this);
    this.delegatorValidators = this.delegatorValidators.bind(this);
    this.delegatorWithdrawAddress = this.delegatorWithdrawAddress.bind(this);
    this.communityPool = this.communityPool.bind(this);
  }
  /* Params queries params of the distribution module. */


  async params(_params = {}) {
    const endpoint = `cosmos/distribution/v1beta1/params`;
    return await this.req.get(endpoint);
  }
  /* ValidatorOutstandingRewards queries rewards of a validator address. */


  async validatorOutstandingRewards(params) {
    const endpoint = `cosmos/distribution/v1beta1/validators/${params.validatorAddress}/outstanding_rewards`;
    return await this.req.get(endpoint);
  }
  /* ValidatorCommission queries accumulated commission for a validator. */


  async validatorCommission(params) {
    const endpoint = `cosmos/distribution/v1beta1/validators/${params.validatorAddress}/commission`;
    return await this.req.get(endpoint);
  }
  /* ValidatorSlashes queries slash events of a validator. */


  async validatorSlashes(params) {
    const options = {
      params: {}
    };

    if (typeof (params === null || params === void 0 ? void 0 : params.startingHeight) !== "undefined") {
      options.params.starting_height = params.startingHeight;
    }

    if (typeof (params === null || params === void 0 ? void 0 : params.endingHeight) !== "undefined") {
      options.params.ending_height = params.endingHeight;
    }

    if (typeof (params === null || params === void 0 ? void 0 : params.pagination) !== "undefined") {
      (0,_helpers__WEBPACK_IMPORTED_MODULE_0__/* .setPaginationParams */ .q6)(options, params.pagination);
    }

    const endpoint = `cosmos/distribution/v1beta1/validators/${params.validatorAddress}/slashes`;
    return await this.req.get(endpoint, options);
  }
  /* DelegationRewards queries the total rewards accrued by a delegation. */


  async delegationRewards(params) {
    const endpoint = `cosmos/distribution/v1beta1/delegators/${params.delegatorAddress}/rewards/${params.validatorAddress}`;
    return await this.req.get(endpoint);
  }
  /* DelegationTotalRewards queries the total rewards accrued by a each
   validator. */


  async delegationTotalRewards(params) {
    const endpoint = `cosmos/distribution/v1beta1/delegators/${params.delegatorAddress}/rewards`;
    return await this.req.get(endpoint);
  }
  /* DelegatorValidators queries the validators of a delegator. */


  async delegatorValidators(params) {
    const endpoint = `cosmos/distribution/v1beta1/delegators/${params.delegatorAddress}/validators`;
    return await this.req.get(endpoint);
  }
  /* DelegatorWithdrawAddress queries withdraw address of a delegator. */


  async delegatorWithdrawAddress(params) {
    const endpoint = `cosmos/distribution/v1beta1/delegators/${params.delegatorAddress}/withdraw_address`;
    return await this.req.get(endpoint);
  }
  /* CommunityPool queries the community pool coins. */


  async communityPool(_params = {}) {
    const endpoint = `cosmos/distribution/v1beta1/community_pool`;
    return await this.req.get(endpoint);
  }

}

/***/ }),

/***/ 23727:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QueryClientImpl": function() { return /* binding */ QueryClientImpl; },
/* harmony export */   "createRpcQueryExtension": function() { return /* binding */ createRpcQueryExtension; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4942);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78441);
/* harmony import */ var _cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54909);




/** Query defines the gRPC querier service for distribution module. */

class QueryClientImpl {
  constructor(rpc) {
    (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, "rpc", void 0);

    this.rpc = rpc;
    this.params = this.params.bind(this);
    this.validatorOutstandingRewards = this.validatorOutstandingRewards.bind(this);
    this.validatorCommission = this.validatorCommission.bind(this);
    this.validatorSlashes = this.validatorSlashes.bind(this);
    this.delegationRewards = this.delegationRewards.bind(this);
    this.delegationTotalRewards = this.delegationTotalRewards.bind(this);
    this.delegatorValidators = this.delegatorValidators.bind(this);
    this.delegatorWithdrawAddress = this.delegatorWithdrawAddress.bind(this);
    this.communityPool = this.communityPool.bind(this);
  }

  params(request = {}) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryParamsRequest.encode(request).finish();
    const promise = this.rpc.request("cosmos.distribution.v1beta1.Query", "Params", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryParamsResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  validatorOutstandingRewards(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryValidatorOutstandingRewardsRequest.encode(request).finish();
    const promise = this.rpc.request("cosmos.distribution.v1beta1.Query", "ValidatorOutstandingRewards", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryValidatorOutstandingRewardsResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  validatorCommission(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryValidatorCommissionRequest.encode(request).finish();
    const promise = this.rpc.request("cosmos.distribution.v1beta1.Query", "ValidatorCommission", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryValidatorCommissionResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  validatorSlashes(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryValidatorSlashesRequest.encode(request).finish();
    const promise = this.rpc.request("cosmos.distribution.v1beta1.Query", "ValidatorSlashes", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryValidatorSlashesResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  delegationRewards(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryDelegationRewardsRequest.encode(request).finish();
    const promise = this.rpc.request("cosmos.distribution.v1beta1.Query", "DelegationRewards", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryDelegationRewardsResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  delegationTotalRewards(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryDelegationTotalRewardsRequest.encode(request).finish();
    const promise = this.rpc.request("cosmos.distribution.v1beta1.Query", "DelegationTotalRewards", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryDelegationTotalRewardsResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  delegatorValidators(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryDelegatorValidatorsRequest.encode(request).finish();
    const promise = this.rpc.request("cosmos.distribution.v1beta1.Query", "DelegatorValidators", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryDelegatorValidatorsResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  delegatorWithdrawAddress(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryDelegatorWithdrawAddressRequest.encode(request).finish();
    const promise = this.rpc.request("cosmos.distribution.v1beta1.Query", "DelegatorWithdrawAddress", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryDelegatorWithdrawAddressResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  communityPool(request = {}) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryCommunityPoolRequest.encode(request).finish();
    const promise = this.rpc.request("cosmos.distribution.v1beta1.Query", "CommunityPool", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryCommunityPoolResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

}
const createRpcQueryExtension = base => {
  const rpc = (0,_cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1__.createProtobufRpcClient)(base);
  const queryService = new QueryClientImpl(rpc);
  return {
    params(request) {
      return queryService.params(request);
    },

    validatorOutstandingRewards(request) {
      return queryService.validatorOutstandingRewards(request);
    },

    validatorCommission(request) {
      return queryService.validatorCommission(request);
    },

    validatorSlashes(request) {
      return queryService.validatorSlashes(request);
    },

    delegationRewards(request) {
      return queryService.delegationRewards(request);
    },

    delegationTotalRewards(request) {
      return queryService.delegationTotalRewards(request);
    },

    delegatorValidators(request) {
      return queryService.delegatorValidators(request);
    },

    delegatorWithdrawAddress(request) {
      return queryService.delegatorWithdrawAddress(request);
    },

    communityPool(request) {
      return queryService.communityPool(request);
    }

  };
};

/***/ }),

/***/ 97966:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MsgFundCommunityPool": function() { return /* binding */ MsgFundCommunityPool; },
/* harmony export */   "MsgFundCommunityPoolResponse": function() { return /* binding */ MsgFundCommunityPoolResponse; },
/* harmony export */   "MsgSetWithdrawAddress": function() { return /* binding */ MsgSetWithdrawAddress; },
/* harmony export */   "MsgSetWithdrawAddressResponse": function() { return /* binding */ MsgSetWithdrawAddressResponse; },
/* harmony export */   "MsgWithdrawDelegatorReward": function() { return /* binding */ MsgWithdrawDelegatorReward; },
/* harmony export */   "MsgWithdrawDelegatorRewardResponse": function() { return /* binding */ MsgWithdrawDelegatorRewardResponse; },
/* harmony export */   "MsgWithdrawValidatorCommission": function() { return /* binding */ MsgWithdrawValidatorCommission; },
/* harmony export */   "MsgWithdrawValidatorCommissionResponse": function() { return /* binding */ MsgWithdrawValidatorCommissionResponse; }
/* harmony export */ });
/* harmony import */ var _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26178);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__);


/**
 * MsgSetWithdrawAddress sets the withdraw address for
 * a delegator (or validator self-delegation).
 */

function createBaseMsgSetWithdrawAddress() {
  return {
    delegatorAddress: "",
    withdrawAddress: ""
  };
}

const MsgSetWithdrawAddress = {
  typeUrl: "/cosmos.distribution.v1beta1.MsgSetWithdrawAddress",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Writer.create()) {
    if (message.delegatorAddress !== "") {
      writer.uint32(10).string(message.delegatorAddress);
    }

    if (message.withdrawAddress !== "") {
      writer.uint32(18).string(message.withdrawAddress);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgSetWithdrawAddress();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.delegatorAddress = reader.string();
          break;

        case 2:
          message.withdrawAddress = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$delegatorAddr, _object$withdrawAddre;

    const message = createBaseMsgSetWithdrawAddress();
    message.delegatorAddress = (_object$delegatorAddr = object.delegatorAddress) !== null && _object$delegatorAddr !== void 0 ? _object$delegatorAddr : "";
    message.withdrawAddress = (_object$withdrawAddre = object.withdrawAddress) !== null && _object$withdrawAddre !== void 0 ? _object$withdrawAddre : "";
    return message;
  },

  fromAmino(object) {
    return {
      delegatorAddress: object.delegator_address,
      withdrawAddress: object.withdraw_address
    };
  },

  toAmino(message) {
    const obj = {};
    obj.delegator_address = message.delegatorAddress;
    obj.withdraw_address = message.withdrawAddress;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgSetWithdrawAddress.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/MsgModifyWithdrawAddress",
      value: MsgSetWithdrawAddress.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgSetWithdrawAddress.decode(message.value);
  },

  toProto(message) {
    return MsgSetWithdrawAddress.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.distribution.v1beta1.MsgSetWithdrawAddress",
      value: MsgSetWithdrawAddress.encode(message).finish()
    };
  }

};

function createBaseMsgSetWithdrawAddressResponse() {
  return {};
}

const MsgSetWithdrawAddressResponse = {
  typeUrl: "/cosmos.distribution.v1beta1.MsgSetWithdrawAddressResponse",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgSetWithdrawAddressResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseMsgSetWithdrawAddressResponse();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return MsgSetWithdrawAddressResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/MsgSetWithdrawAddressResponse",
      value: MsgSetWithdrawAddressResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgSetWithdrawAddressResponse.decode(message.value);
  },

  toProto(message) {
    return MsgSetWithdrawAddressResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.distribution.v1beta1.MsgSetWithdrawAddressResponse",
      value: MsgSetWithdrawAddressResponse.encode(message).finish()
    };
  }

};

function createBaseMsgWithdrawDelegatorReward() {
  return {
    delegatorAddress: "",
    validatorAddress: ""
  };
}

const MsgWithdrawDelegatorReward = {
  typeUrl: "/cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Writer.create()) {
    if (message.delegatorAddress !== "") {
      writer.uint32(10).string(message.delegatorAddress);
    }

    if (message.validatorAddress !== "") {
      writer.uint32(18).string(message.validatorAddress);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgWithdrawDelegatorReward();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.delegatorAddress = reader.string();
          break;

        case 2:
          message.validatorAddress = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$delegatorAddr2, _object$validatorAddr;

    const message = createBaseMsgWithdrawDelegatorReward();
    message.delegatorAddress = (_object$delegatorAddr2 = object.delegatorAddress) !== null && _object$delegatorAddr2 !== void 0 ? _object$delegatorAddr2 : "";
    message.validatorAddress = (_object$validatorAddr = object.validatorAddress) !== null && _object$validatorAddr !== void 0 ? _object$validatorAddr : "";
    return message;
  },

  fromAmino(object) {
    return {
      delegatorAddress: object.delegator_address,
      validatorAddress: object.validator_address
    };
  },

  toAmino(message) {
    const obj = {};
    obj.delegator_address = message.delegatorAddress;
    obj.validator_address = message.validatorAddress;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgWithdrawDelegatorReward.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/MsgWithdrawDelegationReward",
      value: MsgWithdrawDelegatorReward.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgWithdrawDelegatorReward.decode(message.value);
  },

  toProto(message) {
    return MsgWithdrawDelegatorReward.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward",
      value: MsgWithdrawDelegatorReward.encode(message).finish()
    };
  }

};

function createBaseMsgWithdrawDelegatorRewardResponse() {
  return {};
}

const MsgWithdrawDelegatorRewardResponse = {
  typeUrl: "/cosmos.distribution.v1beta1.MsgWithdrawDelegatorRewardResponse",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgWithdrawDelegatorRewardResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseMsgWithdrawDelegatorRewardResponse();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return MsgWithdrawDelegatorRewardResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/MsgWithdrawDelegatorRewardResponse",
      value: MsgWithdrawDelegatorRewardResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgWithdrawDelegatorRewardResponse.decode(message.value);
  },

  toProto(message) {
    return MsgWithdrawDelegatorRewardResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.distribution.v1beta1.MsgWithdrawDelegatorRewardResponse",
      value: MsgWithdrawDelegatorRewardResponse.encode(message).finish()
    };
  }

};

function createBaseMsgWithdrawValidatorCommission() {
  return {
    validatorAddress: ""
  };
}

const MsgWithdrawValidatorCommission = {
  typeUrl: "/cosmos.distribution.v1beta1.MsgWithdrawValidatorCommission",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Writer.create()) {
    if (message.validatorAddress !== "") {
      writer.uint32(10).string(message.validatorAddress);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgWithdrawValidatorCommission();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.validatorAddress = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$validatorAddr2;

    const message = createBaseMsgWithdrawValidatorCommission();
    message.validatorAddress = (_object$validatorAddr2 = object.validatorAddress) !== null && _object$validatorAddr2 !== void 0 ? _object$validatorAddr2 : "";
    return message;
  },

  fromAmino(object) {
    return {
      validatorAddress: object.validator_address
    };
  },

  toAmino(message) {
    const obj = {};
    obj.validator_address = message.validatorAddress;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgWithdrawValidatorCommission.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/MsgWithdrawValCommission",
      value: MsgWithdrawValidatorCommission.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgWithdrawValidatorCommission.decode(message.value);
  },

  toProto(message) {
    return MsgWithdrawValidatorCommission.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.distribution.v1beta1.MsgWithdrawValidatorCommission",
      value: MsgWithdrawValidatorCommission.encode(message).finish()
    };
  }

};

function createBaseMsgWithdrawValidatorCommissionResponse() {
  return {};
}

const MsgWithdrawValidatorCommissionResponse = {
  typeUrl: "/cosmos.distribution.v1beta1.MsgWithdrawValidatorCommissionResponse",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgWithdrawValidatorCommissionResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseMsgWithdrawValidatorCommissionResponse();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return MsgWithdrawValidatorCommissionResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/MsgWithdrawValidatorCommissionResponse",
      value: MsgWithdrawValidatorCommissionResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgWithdrawValidatorCommissionResponse.decode(message.value);
  },

  toProto(message) {
    return MsgWithdrawValidatorCommissionResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.distribution.v1beta1.MsgWithdrawValidatorCommissionResponse",
      value: MsgWithdrawValidatorCommissionResponse.encode(message).finish()
    };
  }

};

function createBaseMsgFundCommunityPool() {
  return {
    amount: [],
    depositor: ""
  };
}

const MsgFundCommunityPool = {
  typeUrl: "/cosmos.distribution.v1beta1.MsgFundCommunityPool",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Writer.create()) {
    for (const v of message.amount) {
      _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.encode(v, writer.uint32(10).fork()).ldelim();
    }

    if (message.depositor !== "") {
      writer.uint32(18).string(message.depositor);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgFundCommunityPool();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.amount.push(_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.decode(reader, reader.uint32()));
          break;

        case 2:
          message.depositor = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$amount, _object$depositor;

    const message = createBaseMsgFundCommunityPool();
    message.amount = ((_object$amount = object.amount) === null || _object$amount === void 0 ? void 0 : _object$amount.map(e => _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.fromPartial(e))) || [];
    message.depositor = (_object$depositor = object.depositor) !== null && _object$depositor !== void 0 ? _object$depositor : "";
    return message;
  },

  fromAmino(object) {
    return {
      amount: Array.isArray(object === null || object === void 0 ? void 0 : object.amount) ? object.amount.map(e => _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.fromAmino(e)) : [],
      depositor: object.depositor
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.amount) {
      obj.amount = message.amount.map(e => e ? _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.toAmino(e) : undefined);
    } else {
      obj.amount = [];
    }

    obj.depositor = message.depositor;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgFundCommunityPool.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/MsgFundCommunityPool",
      value: MsgFundCommunityPool.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgFundCommunityPool.decode(message.value);
  },

  toProto(message) {
    return MsgFundCommunityPool.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.distribution.v1beta1.MsgFundCommunityPool",
      value: MsgFundCommunityPool.encode(message).finish()
    };
  }

};

function createBaseMsgFundCommunityPoolResponse() {
  return {};
}

const MsgFundCommunityPoolResponse = {
  typeUrl: "/cosmos.distribution.v1beta1.MsgFundCommunityPoolResponse",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgFundCommunityPoolResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseMsgFundCommunityPoolResponse();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return MsgFundCommunityPoolResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/MsgFundCommunityPoolResponse",
      value: MsgFundCommunityPoolResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgFundCommunityPoolResponse.decode(message.value);
  },

  toProto(message) {
    return MsgFundCommunityPoolResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.distribution.v1beta1.MsgFundCommunityPoolResponse",
      value: MsgFundCommunityPoolResponse.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 9689:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MsgClientImpl": function() { return /* binding */ MsgClientImpl; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4942);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _tx__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97966);



/** Msg defines the distribution Msg service. */

class MsgClientImpl {
  constructor(rpc) {
    (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, "rpc", void 0);

    this.rpc = rpc;
    this.setWithdrawAddress = this.setWithdrawAddress.bind(this);
    this.withdrawDelegatorReward = this.withdrawDelegatorReward.bind(this);
    this.withdrawValidatorCommission = this.withdrawValidatorCommission.bind(this);
    this.fundCommunityPool = this.fundCommunityPool.bind(this);
  }

  setWithdrawAddress(request) {
    const data = _tx__WEBPACK_IMPORTED_MODULE_1__.MsgSetWithdrawAddress.encode(request).finish();
    const promise = this.rpc.request("cosmos.distribution.v1beta1.Msg", "SetWithdrawAddress", data);
    return promise.then(data => _tx__WEBPACK_IMPORTED_MODULE_1__.MsgSetWithdrawAddressResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  withdrawDelegatorReward(request) {
    const data = _tx__WEBPACK_IMPORTED_MODULE_1__.MsgWithdrawDelegatorReward.encode(request).finish();
    const promise = this.rpc.request("cosmos.distribution.v1beta1.Msg", "WithdrawDelegatorReward", data);
    return promise.then(data => _tx__WEBPACK_IMPORTED_MODULE_1__.MsgWithdrawDelegatorRewardResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  withdrawValidatorCommission(request) {
    const data = _tx__WEBPACK_IMPORTED_MODULE_1__.MsgWithdrawValidatorCommission.encode(request).finish();
    const promise = this.rpc.request("cosmos.distribution.v1beta1.Msg", "WithdrawValidatorCommission", data);
    return promise.then(data => _tx__WEBPACK_IMPORTED_MODULE_1__.MsgWithdrawValidatorCommissionResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  fundCommunityPool(request) {
    const data = _tx__WEBPACK_IMPORTED_MODULE_1__.MsgFundCommunityPool.encode(request).finish();
    const promise = this.rpc.request("cosmos.distribution.v1beta1.Msg", "FundCommunityPool", data);
    return promise.then(data => _tx__WEBPACK_IMPORTED_MODULE_1__.MsgFundCommunityPoolResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

}

/***/ }),

/***/ 95180:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Content_FromAmino": function() { return /* binding */ Content_FromAmino; },
/* harmony export */   "Content_InterfaceDecoder": function() { return /* binding */ Content_InterfaceDecoder; },
/* harmony export */   "Content_ToAmino": function() { return /* binding */ Content_ToAmino; },
/* harmony export */   "Deposit": function() { return /* binding */ Deposit; },
/* harmony export */   "DepositParams": function() { return /* binding */ DepositParams; },
/* harmony export */   "Proposal": function() { return /* binding */ Proposal; },
/* harmony export */   "ProposalStatus": function() { return /* binding */ ProposalStatus; },
/* harmony export */   "ProposalStatusAmino": function() { return /* binding */ ProposalStatusAmino; },
/* harmony export */   "ProposalStatusSDKType": function() { return /* binding */ ProposalStatusSDKType; },
/* harmony export */   "ProposalVotingPeriod": function() { return /* binding */ ProposalVotingPeriod; },
/* harmony export */   "TallyParams": function() { return /* binding */ TallyParams; },
/* harmony export */   "TallyResult": function() { return /* binding */ TallyResult; },
/* harmony export */   "TextProposal": function() { return /* binding */ TextProposal; },
/* harmony export */   "Vote": function() { return /* binding */ Vote; },
/* harmony export */   "VoteOption": function() { return /* binding */ VoteOption; },
/* harmony export */   "VoteOptionAmino": function() { return /* binding */ VoteOptionAmino; },
/* harmony export */   "VoteOptionSDKType": function() { return /* binding */ VoteOptionSDKType; },
/* harmony export */   "VotingParams": function() { return /* binding */ VotingParams; },
/* harmony export */   "WeightedVoteOption": function() { return /* binding */ WeightedVoteOption; },
/* harmony export */   "proposalStatusFromJSON": function() { return /* binding */ proposalStatusFromJSON; },
/* harmony export */   "proposalStatusToJSON": function() { return /* binding */ proposalStatusToJSON; },
/* harmony export */   "voteOptionFromJSON": function() { return /* binding */ voteOptionFromJSON; },
/* harmony export */   "voteOptionToJSON": function() { return /* binding */ voteOptionToJSON; }
/* harmony export */ });
/* harmony import */ var _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26178);
/* harmony import */ var _google_protobuf_any__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32106);
/* harmony import */ var _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20633);
/* harmony import */ var _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6499);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47895);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__);






/** VoteOption enumerates the valid vote options for a given governance proposal. */

let VoteOption;

(function (VoteOption) {
  VoteOption[VoteOption["VOTE_OPTION_UNSPECIFIED"] = 0] = "VOTE_OPTION_UNSPECIFIED";
  VoteOption[VoteOption["VOTE_OPTION_YES"] = 1] = "VOTE_OPTION_YES";
  VoteOption[VoteOption["VOTE_OPTION_ABSTAIN"] = 2] = "VOTE_OPTION_ABSTAIN";
  VoteOption[VoteOption["VOTE_OPTION_NO"] = 3] = "VOTE_OPTION_NO";
  VoteOption[VoteOption["VOTE_OPTION_NO_WITH_VETO"] = 4] = "VOTE_OPTION_NO_WITH_VETO";
  VoteOption[VoteOption["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(VoteOption || (VoteOption = {}));

const VoteOptionSDKType = VoteOption;
const VoteOptionAmino = VoteOption;
function voteOptionFromJSON(object) {
  switch (object) {
    case 0:
    case "VOTE_OPTION_UNSPECIFIED":
      return VoteOption.VOTE_OPTION_UNSPECIFIED;

    case 1:
    case "VOTE_OPTION_YES":
      return VoteOption.VOTE_OPTION_YES;

    case 2:
    case "VOTE_OPTION_ABSTAIN":
      return VoteOption.VOTE_OPTION_ABSTAIN;

    case 3:
    case "VOTE_OPTION_NO":
      return VoteOption.VOTE_OPTION_NO;

    case 4:
    case "VOTE_OPTION_NO_WITH_VETO":
      return VoteOption.VOTE_OPTION_NO_WITH_VETO;

    case -1:
    case "UNRECOGNIZED":
    default:
      return VoteOption.UNRECOGNIZED;
  }
}
function voteOptionToJSON(object) {
  switch (object) {
    case VoteOption.VOTE_OPTION_UNSPECIFIED:
      return "VOTE_OPTION_UNSPECIFIED";

    case VoteOption.VOTE_OPTION_YES:
      return "VOTE_OPTION_YES";

    case VoteOption.VOTE_OPTION_ABSTAIN:
      return "VOTE_OPTION_ABSTAIN";

    case VoteOption.VOTE_OPTION_NO:
      return "VOTE_OPTION_NO";

    case VoteOption.VOTE_OPTION_NO_WITH_VETO:
      return "VOTE_OPTION_NO_WITH_VETO";

    case VoteOption.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
/** ProposalStatus enumerates the valid statuses of a proposal. */

let ProposalStatus;

(function (ProposalStatus) {
  ProposalStatus[ProposalStatus["PROPOSAL_STATUS_UNSPECIFIED"] = 0] = "PROPOSAL_STATUS_UNSPECIFIED";
  ProposalStatus[ProposalStatus["PROPOSAL_STATUS_DEPOSIT_PERIOD"] = 1] = "PROPOSAL_STATUS_DEPOSIT_PERIOD";
  ProposalStatus[ProposalStatus["PROPOSAL_STATUS_VOTING_PERIOD"] = 2] = "PROPOSAL_STATUS_VOTING_PERIOD";
  ProposalStatus[ProposalStatus["PROPOSAL_STATUS_PASSED"] = 3] = "PROPOSAL_STATUS_PASSED";
  ProposalStatus[ProposalStatus["PROPOSAL_STATUS_REJECTED"] = 4] = "PROPOSAL_STATUS_REJECTED";
  ProposalStatus[ProposalStatus["PROPOSAL_STATUS_FAILED"] = 5] = "PROPOSAL_STATUS_FAILED";
  ProposalStatus[ProposalStatus["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(ProposalStatus || (ProposalStatus = {}));

const ProposalStatusSDKType = ProposalStatus;
const ProposalStatusAmino = ProposalStatus;
function proposalStatusFromJSON(object) {
  switch (object) {
    case 0:
    case "PROPOSAL_STATUS_UNSPECIFIED":
      return ProposalStatus.PROPOSAL_STATUS_UNSPECIFIED;

    case 1:
    case "PROPOSAL_STATUS_DEPOSIT_PERIOD":
      return ProposalStatus.PROPOSAL_STATUS_DEPOSIT_PERIOD;

    case 2:
    case "PROPOSAL_STATUS_VOTING_PERIOD":
      return ProposalStatus.PROPOSAL_STATUS_VOTING_PERIOD;

    case 3:
    case "PROPOSAL_STATUS_PASSED":
      return ProposalStatus.PROPOSAL_STATUS_PASSED;

    case 4:
    case "PROPOSAL_STATUS_REJECTED":
      return ProposalStatus.PROPOSAL_STATUS_REJECTED;

    case 5:
    case "PROPOSAL_STATUS_FAILED":
      return ProposalStatus.PROPOSAL_STATUS_FAILED;

    case -1:
    case "UNRECOGNIZED":
    default:
      return ProposalStatus.UNRECOGNIZED;
  }
}
function proposalStatusToJSON(object) {
  switch (object) {
    case ProposalStatus.PROPOSAL_STATUS_UNSPECIFIED:
      return "PROPOSAL_STATUS_UNSPECIFIED";

    case ProposalStatus.PROPOSAL_STATUS_DEPOSIT_PERIOD:
      return "PROPOSAL_STATUS_DEPOSIT_PERIOD";

    case ProposalStatus.PROPOSAL_STATUS_VOTING_PERIOD:
      return "PROPOSAL_STATUS_VOTING_PERIOD";

    case ProposalStatus.PROPOSAL_STATUS_PASSED:
      return "PROPOSAL_STATUS_PASSED";

    case ProposalStatus.PROPOSAL_STATUS_REJECTED:
      return "PROPOSAL_STATUS_REJECTED";

    case ProposalStatus.PROPOSAL_STATUS_FAILED:
      return "PROPOSAL_STATUS_FAILED";

    case ProposalStatus.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
/**
 * WeightedVoteOption defines a unit of vote for vote split.
 * 
 * Since: cosmos-sdk 0.43
 */

function createBaseWeightedVoteOption() {
  return {
    option: 0,
    weight: ""
  };
}

const WeightedVoteOption = {
  typeUrl: "/cosmos.gov.v1beta1.WeightedVoteOption",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Writer.create()) {
    if (message.option !== 0) {
      writer.uint32(8).int32(message.option);
    }

    if (message.weight !== "") {
      writer.uint32(18).string(message.weight);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWeightedVoteOption();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.option = reader.int32();
          break;

        case 2:
          message.weight = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$option, _object$weight;

    const message = createBaseWeightedVoteOption();
    message.option = (_object$option = object.option) !== null && _object$option !== void 0 ? _object$option : 0;
    message.weight = (_object$weight = object.weight) !== null && _object$weight !== void 0 ? _object$weight : "";
    return message;
  },

  fromAmino(object) {
    return {
      option: (0,_helpers__WEBPACK_IMPORTED_MODULE_4__/* .isSet */ .DM)(object.option) ? voteOptionFromJSON(object.option) : 0,
      weight: object.weight
    };
  },

  toAmino(message) {
    const obj = {};
    obj.option = message.option;
    obj.weight = message.weight;
    return obj;
  },

  fromAminoMsg(object) {
    return WeightedVoteOption.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/WeightedVoteOption",
      value: WeightedVoteOption.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return WeightedVoteOption.decode(message.value);
  },

  toProto(message) {
    return WeightedVoteOption.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.gov.v1beta1.WeightedVoteOption",
      value: WeightedVoteOption.encode(message).finish()
    };
  }

};

function createBaseTextProposal() {
  return {
    $typeUrl: "/cosmos.gov.v1beta1.TextProposal",
    title: "",
    description: ""
  };
}

const TextProposal = {
  typeUrl: "/cosmos.gov.v1beta1.TextProposal",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Writer.create()) {
    if (message.title !== "") {
      writer.uint32(10).string(message.title);
    }

    if (message.description !== "") {
      writer.uint32(18).string(message.description);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTextProposal();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.title = reader.string();
          break;

        case 2:
          message.description = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$title, _object$description;

    const message = createBaseTextProposal();
    message.title = (_object$title = object.title) !== null && _object$title !== void 0 ? _object$title : "";
    message.description = (_object$description = object.description) !== null && _object$description !== void 0 ? _object$description : "";
    return message;
  },

  fromAmino(object) {
    return {
      title: object.title,
      description: object.description
    };
  },

  toAmino(message) {
    const obj = {};
    obj.title = message.title;
    obj.description = message.description;
    return obj;
  },

  fromAminoMsg(object) {
    return TextProposal.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/TextProposal",
      value: TextProposal.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return TextProposal.decode(message.value);
  },

  toProto(message) {
    return TextProposal.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.gov.v1beta1.TextProposal",
      value: TextProposal.encode(message).finish()
    };
  }

};

function createBaseDeposit() {
  return {
    proposalId: _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.UZERO */ .dK.UZERO,
    depositor: "",
    amount: []
  };
}

const Deposit = {
  typeUrl: "/cosmos.gov.v1beta1.Deposit",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Writer.create()) {
    if (!message.proposalId.isZero()) {
      writer.uint32(8).uint64(message.proposalId);
    }

    if (message.depositor !== "") {
      writer.uint32(18).string(message.depositor);
    }

    for (const v of message.amount) {
      _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.encode(v, writer.uint32(26).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeposit();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.proposalId = reader.uint64();
          break;

        case 2:
          message.depositor = reader.string();
          break;

        case 3:
          message.amount.push(_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$depositor, _object$amount;

    const message = createBaseDeposit();
    message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.fromValue */ .dK.fromValue(object.proposalId) : _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.UZERO */ .dK.UZERO;
    message.depositor = (_object$depositor = object.depositor) !== null && _object$depositor !== void 0 ? _object$depositor : "";
    message.amount = ((_object$amount = object.amount) === null || _object$amount === void 0 ? void 0 : _object$amount.map(e => _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      proposalId: _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.fromString */ .dK.fromString(object.proposal_id),
      depositor: object.depositor,
      amount: Array.isArray(object === null || object === void 0 ? void 0 : object.amount) ? object.amount.map(e => _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.proposal_id = message.proposalId ? message.proposalId.toString() : undefined;
    obj.depositor = message.depositor;

    if (message.amount) {
      obj.amount = message.amount.map(e => e ? _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.toAmino(e) : undefined);
    } else {
      obj.amount = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return Deposit.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/Deposit",
      value: Deposit.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return Deposit.decode(message.value);
  },

  toProto(message) {
    return Deposit.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.gov.v1beta1.Deposit",
      value: Deposit.encode(message).finish()
    };
  }

};

function createBaseProposal() {
  return {
    proposalId: _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.UZERO */ .dK.UZERO,
    content: undefined,
    status: 0,
    finalTallyResult: undefined,
    submitTime: undefined,
    depositEndTime: undefined,
    totalDeposit: [],
    votingStartTime: undefined,
    votingEndTime: undefined,
    isExpedited: false
  };
}

const Proposal = {
  typeUrl: "/cosmos.gov.v1beta1.Proposal",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Writer.create()) {
    if (!message.proposalId.isZero()) {
      writer.uint32(8).uint64(message.proposalId);
    }

    if (message.content !== undefined) {
      _google_protobuf_any__WEBPACK_IMPORTED_MODULE_1__.Any.encode(message.content, writer.uint32(18).fork()).ldelim();
    }

    if (message.status !== 0) {
      writer.uint32(24).int32(message.status);
    }

    if (message.finalTallyResult !== undefined) {
      TallyResult.encode(message.finalTallyResult, writer.uint32(34).fork()).ldelim();
    }

    if (message.submitTime !== undefined) {
      _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_2__.Timestamp.encode((0,_helpers__WEBPACK_IMPORTED_MODULE_4__/* .toTimestamp */ .Uq)(message.submitTime), writer.uint32(42).fork()).ldelim();
    }

    if (message.depositEndTime !== undefined) {
      _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_2__.Timestamp.encode((0,_helpers__WEBPACK_IMPORTED_MODULE_4__/* .toTimestamp */ .Uq)(message.depositEndTime), writer.uint32(50).fork()).ldelim();
    }

    for (const v of message.totalDeposit) {
      _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.encode(v, writer.uint32(58).fork()).ldelim();
    }

    if (message.votingStartTime !== undefined) {
      _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_2__.Timestamp.encode((0,_helpers__WEBPACK_IMPORTED_MODULE_4__/* .toTimestamp */ .Uq)(message.votingStartTime), writer.uint32(66).fork()).ldelim();
    }

    if (message.votingEndTime !== undefined) {
      _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_2__.Timestamp.encode((0,_helpers__WEBPACK_IMPORTED_MODULE_4__/* .toTimestamp */ .Uq)(message.votingEndTime), writer.uint32(74).fork()).ldelim();
    }

    if (message.isExpedited === true) {
      writer.uint32(80).bool(message.isExpedited);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseProposal();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.proposalId = reader.uint64();
          break;

        case 2:
          message.content = Content_InterfaceDecoder(reader);
          break;

        case 3:
          message.status = reader.int32();
          break;

        case 4:
          message.finalTallyResult = TallyResult.decode(reader, reader.uint32());
          break;

        case 5:
          message.submitTime = (0,_helpers__WEBPACK_IMPORTED_MODULE_4__/* .fromTimestamp */ .Ol)(_google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_2__.Timestamp.decode(reader, reader.uint32()));
          break;

        case 6:
          message.depositEndTime = (0,_helpers__WEBPACK_IMPORTED_MODULE_4__/* .fromTimestamp */ .Ol)(_google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_2__.Timestamp.decode(reader, reader.uint32()));
          break;

        case 7:
          message.totalDeposit.push(_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.decode(reader, reader.uint32()));
          break;

        case 8:
          message.votingStartTime = (0,_helpers__WEBPACK_IMPORTED_MODULE_4__/* .fromTimestamp */ .Ol)(_google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_2__.Timestamp.decode(reader, reader.uint32()));
          break;

        case 9:
          message.votingEndTime = (0,_helpers__WEBPACK_IMPORTED_MODULE_4__/* .fromTimestamp */ .Ol)(_google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_2__.Timestamp.decode(reader, reader.uint32()));
          break;

        case 10:
          message.isExpedited = reader.bool();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$status, _object$submitTime, _object$depositEndTim, _object$totalDeposit, _object$votingStartTi, _object$votingEndTime, _object$isExpedited;

    const message = createBaseProposal();
    message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.fromValue */ .dK.fromValue(object.proposalId) : _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.UZERO */ .dK.UZERO;
    message.content = object.content !== undefined && object.content !== null ? _google_protobuf_any__WEBPACK_IMPORTED_MODULE_1__.Any.fromPartial(object.content) : undefined;
    message.status = (_object$status = object.status) !== null && _object$status !== void 0 ? _object$status : 0;
    message.finalTallyResult = object.finalTallyResult !== undefined && object.finalTallyResult !== null ? TallyResult.fromPartial(object.finalTallyResult) : undefined;
    message.submitTime = (_object$submitTime = object.submitTime) !== null && _object$submitTime !== void 0 ? _object$submitTime : undefined;
    message.depositEndTime = (_object$depositEndTim = object.depositEndTime) !== null && _object$depositEndTim !== void 0 ? _object$depositEndTim : undefined;
    message.totalDeposit = ((_object$totalDeposit = object.totalDeposit) === null || _object$totalDeposit === void 0 ? void 0 : _object$totalDeposit.map(e => _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.fromPartial(e))) || [];
    message.votingStartTime = (_object$votingStartTi = object.votingStartTime) !== null && _object$votingStartTi !== void 0 ? _object$votingStartTi : undefined;
    message.votingEndTime = (_object$votingEndTime = object.votingEndTime) !== null && _object$votingEndTime !== void 0 ? _object$votingEndTime : undefined;
    message.isExpedited = (_object$isExpedited = object.isExpedited) !== null && _object$isExpedited !== void 0 ? _object$isExpedited : false;
    return message;
  },

  fromAmino(object) {
    return {
      proposalId: _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.fromString */ .dK.fromString(object.proposal_id),
      content: object !== null && object !== void 0 && object.content ? Content_FromAmino(object.content) : undefined,
      status: (0,_helpers__WEBPACK_IMPORTED_MODULE_4__/* .isSet */ .DM)(object.status) ? proposalStatusFromJSON(object.status) : 0,
      finalTallyResult: object !== null && object !== void 0 && object.final_tally_result ? TallyResult.fromAmino(object.final_tally_result) : undefined,
      submitTime: object !== null && object !== void 0 && object.submit_time ? _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_2__.Timestamp.fromAmino(object.submit_time) : undefined,
      depositEndTime: object !== null && object !== void 0 && object.deposit_end_time ? _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_2__.Timestamp.fromAmino(object.deposit_end_time) : undefined,
      totalDeposit: Array.isArray(object === null || object === void 0 ? void 0 : object.total_deposit) ? object.total_deposit.map(e => _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.fromAmino(e)) : [],
      votingStartTime: object !== null && object !== void 0 && object.voting_start_time ? _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_2__.Timestamp.fromAmino(object.voting_start_time) : undefined,
      votingEndTime: object !== null && object !== void 0 && object.voting_end_time ? _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_2__.Timestamp.fromAmino(object.voting_end_time) : undefined,
      isExpedited: object.is_expedited
    };
  },

  toAmino(message) {
    const obj = {};
    obj.proposal_id = message.proposalId ? message.proposalId.toString() : undefined;
    obj.content = message.content ? Content_ToAmino(message.content) : undefined;
    obj.status = message.status;
    obj.final_tally_result = message.finalTallyResult ? TallyResult.toAmino(message.finalTallyResult) : undefined;
    obj.submit_time = message.submitTime ? _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_2__.Timestamp.toAmino(message.submitTime) : undefined;
    obj.deposit_end_time = message.depositEndTime ? _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_2__.Timestamp.toAmino(message.depositEndTime) : undefined;

    if (message.totalDeposit) {
      obj.total_deposit = message.totalDeposit.map(e => e ? _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.toAmino(e) : undefined);
    } else {
      obj.total_deposit = [];
    }

    obj.voting_start_time = message.votingStartTime ? _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_2__.Timestamp.toAmino(message.votingStartTime) : undefined;
    obj.voting_end_time = message.votingEndTime ? _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_2__.Timestamp.toAmino(message.votingEndTime) : undefined;
    obj.is_expedited = message.isExpedited;
    return obj;
  },

  fromAminoMsg(object) {
    return Proposal.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/Proposal",
      value: Proposal.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return Proposal.decode(message.value);
  },

  toProto(message) {
    return Proposal.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.gov.v1beta1.Proposal",
      value: Proposal.encode(message).finish()
    };
  }

};

function createBaseTallyResult() {
  return {
    yes: "",
    abstain: "",
    no: "",
    noWithVeto: ""
  };
}

const TallyResult = {
  typeUrl: "/cosmos.gov.v1beta1.TallyResult",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Writer.create()) {
    if (message.yes !== "") {
      writer.uint32(10).string(message.yes);
    }

    if (message.abstain !== "") {
      writer.uint32(18).string(message.abstain);
    }

    if (message.no !== "") {
      writer.uint32(26).string(message.no);
    }

    if (message.noWithVeto !== "") {
      writer.uint32(34).string(message.noWithVeto);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTallyResult();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.yes = reader.string();
          break;

        case 2:
          message.abstain = reader.string();
          break;

        case 3:
          message.no = reader.string();
          break;

        case 4:
          message.noWithVeto = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$yes, _object$abstain, _object$no, _object$noWithVeto;

    const message = createBaseTallyResult();
    message.yes = (_object$yes = object.yes) !== null && _object$yes !== void 0 ? _object$yes : "";
    message.abstain = (_object$abstain = object.abstain) !== null && _object$abstain !== void 0 ? _object$abstain : "";
    message.no = (_object$no = object.no) !== null && _object$no !== void 0 ? _object$no : "";
    message.noWithVeto = (_object$noWithVeto = object.noWithVeto) !== null && _object$noWithVeto !== void 0 ? _object$noWithVeto : "";
    return message;
  },

  fromAmino(object) {
    return {
      yes: object.yes,
      abstain: object.abstain,
      no: object.no,
      noWithVeto: object.no_with_veto
    };
  },

  toAmino(message) {
    const obj = {};
    obj.yes = message.yes;
    obj.abstain = message.abstain;
    obj.no = message.no;
    obj.no_with_veto = message.noWithVeto;
    return obj;
  },

  fromAminoMsg(object) {
    return TallyResult.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/TallyResult",
      value: TallyResult.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return TallyResult.decode(message.value);
  },

  toProto(message) {
    return TallyResult.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.gov.v1beta1.TallyResult",
      value: TallyResult.encode(message).finish()
    };
  }

};

function createBaseVote() {
  return {
    proposalId: _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.UZERO */ .dK.UZERO,
    voter: "",
    option: 0,
    options: []
  };
}

const Vote = {
  typeUrl: "/cosmos.gov.v1beta1.Vote",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Writer.create()) {
    if (!message.proposalId.isZero()) {
      writer.uint32(8).uint64(message.proposalId);
    }

    if (message.voter !== "") {
      writer.uint32(18).string(message.voter);
    }

    if (message.option !== 0) {
      writer.uint32(24).int32(message.option);
    }

    for (const v of message.options) {
      WeightedVoteOption.encode(v, writer.uint32(34).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVote();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.proposalId = reader.uint64();
          break;

        case 2:
          message.voter = reader.string();
          break;

        case 3:
          message.option = reader.int32();
          break;

        case 4:
          message.options.push(WeightedVoteOption.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$voter, _object$option2, _object$options;

    const message = createBaseVote();
    message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.fromValue */ .dK.fromValue(object.proposalId) : _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.UZERO */ .dK.UZERO;
    message.voter = (_object$voter = object.voter) !== null && _object$voter !== void 0 ? _object$voter : "";
    message.option = (_object$option2 = object.option) !== null && _object$option2 !== void 0 ? _object$option2 : 0;
    message.options = ((_object$options = object.options) === null || _object$options === void 0 ? void 0 : _object$options.map(e => WeightedVoteOption.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      proposalId: _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.fromString */ .dK.fromString(object.proposal_id),
      voter: object.voter,
      option: (0,_helpers__WEBPACK_IMPORTED_MODULE_4__/* .isSet */ .DM)(object.option) ? voteOptionFromJSON(object.option) : 0,
      options: Array.isArray(object === null || object === void 0 ? void 0 : object.options) ? object.options.map(e => WeightedVoteOption.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.proposal_id = message.proposalId ? message.proposalId.toString() : undefined;
    obj.voter = message.voter;
    obj.option = message.option;

    if (message.options) {
      obj.options = message.options.map(e => e ? WeightedVoteOption.toAmino(e) : undefined);
    } else {
      obj.options = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return Vote.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/Vote",
      value: Vote.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return Vote.decode(message.value);
  },

  toProto(message) {
    return Vote.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.gov.v1beta1.Vote",
      value: Vote.encode(message).finish()
    };
  }

};

function createBaseDepositParams() {
  return {
    minDeposit: [],
    maxDepositPeriod: undefined,
    minExpeditedDeposit: [],
    minInitialDepositRatio: ""
  };
}

const DepositParams = {
  typeUrl: "/cosmos.gov.v1beta1.DepositParams",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Writer.create()) {
    for (const v of message.minDeposit) {
      _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.encode(v, writer.uint32(10).fork()).ldelim();
    }

    if (message.maxDepositPeriod !== undefined) {
      _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_3__.Duration.encode(message.maxDepositPeriod, writer.uint32(18).fork()).ldelim();
    }

    for (const v of message.minExpeditedDeposit) {
      _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.encode(v, writer.uint32(26).fork()).ldelim();
    }

    if (message.minInitialDepositRatio !== "") {
      writer.uint32(34).string(message.minInitialDepositRatio);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDepositParams();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.minDeposit.push(_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.decode(reader, reader.uint32()));
          break;

        case 2:
          message.maxDepositPeriod = _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_3__.Duration.decode(reader, reader.uint32());
          break;

        case 3:
          message.minExpeditedDeposit.push(_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.decode(reader, reader.uint32()));
          break;

        case 4:
          message.minInitialDepositRatio = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$minDeposit, _object$minExpeditedD, _object$minInitialDep;

    const message = createBaseDepositParams();
    message.minDeposit = ((_object$minDeposit = object.minDeposit) === null || _object$minDeposit === void 0 ? void 0 : _object$minDeposit.map(e => _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.fromPartial(e))) || [];
    message.maxDepositPeriod = object.maxDepositPeriod !== undefined && object.maxDepositPeriod !== null ? _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_3__.Duration.fromPartial(object.maxDepositPeriod) : undefined;
    message.minExpeditedDeposit = ((_object$minExpeditedD = object.minExpeditedDeposit) === null || _object$minExpeditedD === void 0 ? void 0 : _object$minExpeditedD.map(e => _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.fromPartial(e))) || [];
    message.minInitialDepositRatio = (_object$minInitialDep = object.minInitialDepositRatio) !== null && _object$minInitialDep !== void 0 ? _object$minInitialDep : "";
    return message;
  },

  fromAmino(object) {
    return {
      minDeposit: Array.isArray(object === null || object === void 0 ? void 0 : object.min_deposit) ? object.min_deposit.map(e => _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.fromAmino(e)) : [],
      maxDepositPeriod: object !== null && object !== void 0 && object.max_deposit_period ? _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_3__.Duration.fromAmino(object.max_deposit_period) : undefined,
      minExpeditedDeposit: Array.isArray(object === null || object === void 0 ? void 0 : object.min_expedited_deposit) ? object.min_expedited_deposit.map(e => _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.fromAmino(e)) : [],
      minInitialDepositRatio: object.min_initial_deposit_ratio
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.minDeposit) {
      obj.min_deposit = message.minDeposit.map(e => e ? _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.toAmino(e) : undefined);
    } else {
      obj.min_deposit = [];
    }

    obj.max_deposit_period = message.maxDepositPeriod ? _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_3__.Duration.toAmino(message.maxDepositPeriod) : undefined;

    if (message.minExpeditedDeposit) {
      obj.min_expedited_deposit = message.minExpeditedDeposit.map(e => e ? _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.toAmino(e) : undefined);
    } else {
      obj.min_expedited_deposit = [];
    }

    obj.min_initial_deposit_ratio = message.minInitialDepositRatio;
    return obj;
  },

  fromAminoMsg(object) {
    return DepositParams.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/DepositParams",
      value: DepositParams.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return DepositParams.decode(message.value);
  },

  toProto(message) {
    return DepositParams.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.gov.v1beta1.DepositParams",
      value: DepositParams.encode(message).finish()
    };
  }

};

function createBaseVotingParams() {
  return {
    votingPeriod: undefined,
    proposalVotingPeriods: [],
    expeditedVotingPeriod: undefined
  };
}

const VotingParams = {
  typeUrl: "/cosmos.gov.v1beta1.VotingParams",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Writer.create()) {
    if (message.votingPeriod !== undefined) {
      _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_3__.Duration.encode(message.votingPeriod, writer.uint32(10).fork()).ldelim();
    }

    for (const v of message.proposalVotingPeriods) {
      ProposalVotingPeriod.encode(v, writer.uint32(18).fork()).ldelim();
    }

    if (message.expeditedVotingPeriod !== undefined) {
      _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_3__.Duration.encode(message.expeditedVotingPeriod, writer.uint32(26).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVotingParams();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.votingPeriod = _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_3__.Duration.decode(reader, reader.uint32());
          break;

        case 2:
          message.proposalVotingPeriods.push(ProposalVotingPeriod.decode(reader, reader.uint32()));
          break;

        case 3:
          message.expeditedVotingPeriod = _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_3__.Duration.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$proposalVotin;

    const message = createBaseVotingParams();
    message.votingPeriod = object.votingPeriod !== undefined && object.votingPeriod !== null ? _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_3__.Duration.fromPartial(object.votingPeriod) : undefined;
    message.proposalVotingPeriods = ((_object$proposalVotin = object.proposalVotingPeriods) === null || _object$proposalVotin === void 0 ? void 0 : _object$proposalVotin.map(e => ProposalVotingPeriod.fromPartial(e))) || [];
    message.expeditedVotingPeriod = object.expeditedVotingPeriod !== undefined && object.expeditedVotingPeriod !== null ? _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_3__.Duration.fromPartial(object.expeditedVotingPeriod) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      votingPeriod: object !== null && object !== void 0 && object.voting_period ? _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_3__.Duration.fromAmino(object.voting_period) : undefined,
      proposalVotingPeriods: Array.isArray(object === null || object === void 0 ? void 0 : object.proposal_voting_periods) ? object.proposal_voting_periods.map(e => ProposalVotingPeriod.fromAmino(e)) : [],
      expeditedVotingPeriod: object !== null && object !== void 0 && object.expedited_voting_period ? _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_3__.Duration.fromAmino(object.expedited_voting_period) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.voting_period = message.votingPeriod ? _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_3__.Duration.toAmino(message.votingPeriod) : undefined;

    if (message.proposalVotingPeriods) {
      obj.proposal_voting_periods = message.proposalVotingPeriods.map(e => e ? ProposalVotingPeriod.toAmino(e) : undefined);
    } else {
      obj.proposal_voting_periods = [];
    }

    obj.expedited_voting_period = message.expeditedVotingPeriod ? _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_3__.Duration.toAmino(message.expeditedVotingPeriod) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return VotingParams.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/VotingParams",
      value: VotingParams.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return VotingParams.decode(message.value);
  },

  toProto(message) {
    return VotingParams.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.gov.v1beta1.VotingParams",
      value: VotingParams.encode(message).finish()
    };
  }

};

function createBaseTallyParams() {
  return {
    quorum: new Uint8Array(),
    threshold: new Uint8Array(),
    vetoThreshold: new Uint8Array(),
    expeditedThreshold: new Uint8Array()
  };
}

const TallyParams = {
  typeUrl: "/cosmos.gov.v1beta1.TallyParams",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Writer.create()) {
    if (message.quorum.length !== 0) {
      writer.uint32(10).bytes(message.quorum);
    }

    if (message.threshold.length !== 0) {
      writer.uint32(18).bytes(message.threshold);
    }

    if (message.vetoThreshold.length !== 0) {
      writer.uint32(26).bytes(message.vetoThreshold);
    }

    if (message.expeditedThreshold.length !== 0) {
      writer.uint32(34).bytes(message.expeditedThreshold);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTallyParams();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.quorum = reader.bytes();
          break;

        case 2:
          message.threshold = reader.bytes();
          break;

        case 3:
          message.vetoThreshold = reader.bytes();
          break;

        case 4:
          message.expeditedThreshold = reader.bytes();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$quorum, _object$threshold, _object$vetoThreshold, _object$expeditedThre;

    const message = createBaseTallyParams();
    message.quorum = (_object$quorum = object.quorum) !== null && _object$quorum !== void 0 ? _object$quorum : new Uint8Array();
    message.threshold = (_object$threshold = object.threshold) !== null && _object$threshold !== void 0 ? _object$threshold : new Uint8Array();
    message.vetoThreshold = (_object$vetoThreshold = object.vetoThreshold) !== null && _object$vetoThreshold !== void 0 ? _object$vetoThreshold : new Uint8Array();
    message.expeditedThreshold = (_object$expeditedThre = object.expeditedThreshold) !== null && _object$expeditedThre !== void 0 ? _object$expeditedThre : new Uint8Array();
    return message;
  },

  fromAmino(object) {
    return {
      quorum: object.quorum,
      threshold: object.threshold,
      vetoThreshold: object.veto_threshold,
      expeditedThreshold: object.expedited_threshold
    };
  },

  toAmino(message) {
    const obj = {};
    obj.quorum = message.quorum;
    obj.threshold = message.threshold;
    obj.veto_threshold = message.vetoThreshold;
    obj.expedited_threshold = message.expeditedThreshold;
    return obj;
  },

  fromAminoMsg(object) {
    return TallyParams.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/TallyParams",
      value: TallyParams.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return TallyParams.decode(message.value);
  },

  toProto(message) {
    return TallyParams.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.gov.v1beta1.TallyParams",
      value: TallyParams.encode(message).finish()
    };
  }

};

function createBaseProposalVotingPeriod() {
  return {
    proposalType: "",
    votingPeriod: undefined
  };
}

const ProposalVotingPeriod = {
  typeUrl: "/cosmos.gov.v1beta1.ProposalVotingPeriod",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Writer.create()) {
    if (message.proposalType !== "") {
      writer.uint32(10).string(message.proposalType);
    }

    if (message.votingPeriod !== undefined) {
      _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_3__.Duration.encode(message.votingPeriod, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseProposalVotingPeriod();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.proposalType = reader.string();
          break;

        case 2:
          message.votingPeriod = _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_3__.Duration.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$proposalType;

    const message = createBaseProposalVotingPeriod();
    message.proposalType = (_object$proposalType = object.proposalType) !== null && _object$proposalType !== void 0 ? _object$proposalType : "";
    message.votingPeriod = object.votingPeriod !== undefined && object.votingPeriod !== null ? _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_3__.Duration.fromPartial(object.votingPeriod) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      proposalType: object.proposal_type,
      votingPeriod: object !== null && object !== void 0 && object.voting_period ? _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_3__.Duration.fromAmino(object.voting_period) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.proposal_type = message.proposalType;
    obj.voting_period = message.votingPeriod ? _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_3__.Duration.toAmino(message.votingPeriod) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return ProposalVotingPeriod.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/ProposalVotingPeriod",
      value: ProposalVotingPeriod.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return ProposalVotingPeriod.decode(message.value);
  },

  toProto(message) {
    return ProposalVotingPeriod.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.gov.v1beta1.ProposalVotingPeriod",
      value: ProposalVotingPeriod.encode(message).finish()
    };
  }

};
const Content_InterfaceDecoder = input => {
  const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader(input);
  const data = _google_protobuf_any__WEBPACK_IMPORTED_MODULE_1__.Any.decode(reader, reader.uint32());

  switch (data.typeUrl) {
    case "/cosmos.gov.v1beta1.TextProposal":
      return TextProposal.decode(data.value);

    default:
      return data;
  }
};
const Content_FromAmino = content => {
  switch (content.type) {
    case "cosmos-sdk/TextProposal":
      return _google_protobuf_any__WEBPACK_IMPORTED_MODULE_1__.Any.fromPartial({
        typeUrl: "/cosmos.gov.v1beta1.TextProposal",
        value: TextProposal.encode(TextProposal.fromPartial(TextProposal.fromAmino(content.value))).finish()
      });

    default:
      return _google_protobuf_any__WEBPACK_IMPORTED_MODULE_1__.Any.fromAmino(content);
  }
};
const Content_ToAmino = content => {
  switch (content.typeUrl) {
    case "/cosmos.gov.v1beta1.TextProposal":
      return {
        type: "cosmos-sdk/TextProposal",
        value: TextProposal.toAmino(TextProposal.decode(content.value))
      };

    default:
      return _google_protobuf_any__WEBPACK_IMPORTED_MODULE_1__.Any.toAmino(content);
  }
};

/***/ }),

/***/ 71814:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QueryDepositRequest": function() { return /* binding */ QueryDepositRequest; },
/* harmony export */   "QueryDepositResponse": function() { return /* binding */ QueryDepositResponse; },
/* harmony export */   "QueryDepositsRequest": function() { return /* binding */ QueryDepositsRequest; },
/* harmony export */   "QueryDepositsResponse": function() { return /* binding */ QueryDepositsResponse; },
/* harmony export */   "QueryParamsRequest": function() { return /* binding */ QueryParamsRequest; },
/* harmony export */   "QueryParamsResponse": function() { return /* binding */ QueryParamsResponse; },
/* harmony export */   "QueryProposalRequest": function() { return /* binding */ QueryProposalRequest; },
/* harmony export */   "QueryProposalResponse": function() { return /* binding */ QueryProposalResponse; },
/* harmony export */   "QueryProposalsRequest": function() { return /* binding */ QueryProposalsRequest; },
/* harmony export */   "QueryProposalsResponse": function() { return /* binding */ QueryProposalsResponse; },
/* harmony export */   "QueryTallyResultRequest": function() { return /* binding */ QueryTallyResultRequest; },
/* harmony export */   "QueryTallyResultResponse": function() { return /* binding */ QueryTallyResultResponse; },
/* harmony export */   "QueryVoteRequest": function() { return /* binding */ QueryVoteRequest; },
/* harmony export */   "QueryVoteResponse": function() { return /* binding */ QueryVoteResponse; },
/* harmony export */   "QueryVotesRequest": function() { return /* binding */ QueryVotesRequest; },
/* harmony export */   "QueryVotesResponse": function() { return /* binding */ QueryVotesResponse; }
/* harmony export */ });
/* harmony import */ var _gov__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95180);
/* harmony import */ var _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48978);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47895);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__);




/** QueryProposalRequest is the request type for the Query/Proposal RPC method. */

function createBaseQueryProposalRequest() {
  return {
    proposalId: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO
  };
}

const QueryProposalRequest = {
  typeUrl: "/cosmos.gov.v1beta1.QueryProposalRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (!message.proposalId.isZero()) {
      writer.uint32(8).uint64(message.proposalId);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryProposalRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.proposalId = reader.uint64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseQueryProposalRequest();
    message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromValue */ .dK.fromValue(object.proposalId) : _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO;
    return message;
  },

  fromAmino(object) {
    return {
      proposalId: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromString */ .dK.fromString(object.proposal_id)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.proposal_id = message.proposalId ? message.proposalId.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryProposalRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryProposalRequest",
      value: QueryProposalRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryProposalRequest.decode(message.value);
  },

  toProto(message) {
    return QueryProposalRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.gov.v1beta1.QueryProposalRequest",
      value: QueryProposalRequest.encode(message).finish()
    };
  }

};

function createBaseQueryProposalResponse() {
  return {
    proposal: undefined
  };
}

const QueryProposalResponse = {
  typeUrl: "/cosmos.gov.v1beta1.QueryProposalResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.proposal !== undefined) {
      _gov__WEBPACK_IMPORTED_MODULE_0__.Proposal.encode(message.proposal, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryProposalResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.proposal = _gov__WEBPACK_IMPORTED_MODULE_0__.Proposal.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseQueryProposalResponse();
    message.proposal = object.proposal !== undefined && object.proposal !== null ? _gov__WEBPACK_IMPORTED_MODULE_0__.Proposal.fromPartial(object.proposal) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      proposal: object !== null && object !== void 0 && object.proposal ? _gov__WEBPACK_IMPORTED_MODULE_0__.Proposal.fromAmino(object.proposal) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.proposal = message.proposal ? _gov__WEBPACK_IMPORTED_MODULE_0__.Proposal.toAmino(message.proposal) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryProposalResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryProposalResponse",
      value: QueryProposalResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryProposalResponse.decode(message.value);
  },

  toProto(message) {
    return QueryProposalResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.gov.v1beta1.QueryProposalResponse",
      value: QueryProposalResponse.encode(message).finish()
    };
  }

};

function createBaseQueryProposalsRequest() {
  return {
    proposalStatus: 0,
    voter: "",
    depositor: "",
    pagination: undefined
  };
}

const QueryProposalsRequest = {
  typeUrl: "/cosmos.gov.v1beta1.QueryProposalsRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.proposalStatus !== 0) {
      writer.uint32(8).int32(message.proposalStatus);
    }

    if (message.voter !== "") {
      writer.uint32(18).string(message.voter);
    }

    if (message.depositor !== "") {
      writer.uint32(26).string(message.depositor);
    }

    if (message.pagination !== undefined) {
      _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_1__.PageRequest.encode(message.pagination, writer.uint32(34).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryProposalsRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.proposalStatus = reader.int32();
          break;

        case 2:
          message.voter = reader.string();
          break;

        case 3:
          message.depositor = reader.string();
          break;

        case 4:
          message.pagination = _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_1__.PageRequest.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$proposalStatu, _object$voter, _object$depositor;

    const message = createBaseQueryProposalsRequest();
    message.proposalStatus = (_object$proposalStatu = object.proposalStatus) !== null && _object$proposalStatu !== void 0 ? _object$proposalStatu : 0;
    message.voter = (_object$voter = object.voter) !== null && _object$voter !== void 0 ? _object$voter : "";
    message.depositor = (_object$depositor = object.depositor) !== null && _object$depositor !== void 0 ? _object$depositor : "";
    message.pagination = object.pagination !== undefined && object.pagination !== null ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_1__.PageRequest.fromPartial(object.pagination) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      proposalStatus: (0,_helpers__WEBPACK_IMPORTED_MODULE_2__/* .isSet */ .DM)(object.proposal_status) ? (0,_gov__WEBPACK_IMPORTED_MODULE_0__.proposalStatusFromJSON)(object.proposal_status) : 0,
      voter: object.voter,
      depositor: object.depositor,
      pagination: object !== null && object !== void 0 && object.pagination ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_1__.PageRequest.fromAmino(object.pagination) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.proposal_status = message.proposalStatus;
    obj.voter = message.voter;
    obj.depositor = message.depositor;
    obj.pagination = message.pagination ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_1__.PageRequest.toAmino(message.pagination) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryProposalsRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryProposalsRequest",
      value: QueryProposalsRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryProposalsRequest.decode(message.value);
  },

  toProto(message) {
    return QueryProposalsRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.gov.v1beta1.QueryProposalsRequest",
      value: QueryProposalsRequest.encode(message).finish()
    };
  }

};

function createBaseQueryProposalsResponse() {
  return {
    proposals: [],
    pagination: undefined
  };
}

const QueryProposalsResponse = {
  typeUrl: "/cosmos.gov.v1beta1.QueryProposalsResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    for (const v of message.proposals) {
      _gov__WEBPACK_IMPORTED_MODULE_0__.Proposal.encode(v, writer.uint32(10).fork()).ldelim();
    }

    if (message.pagination !== undefined) {
      _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_1__.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryProposalsResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.proposals.push(_gov__WEBPACK_IMPORTED_MODULE_0__.Proposal.decode(reader, reader.uint32()));
          break;

        case 2:
          message.pagination = _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_1__.PageResponse.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$proposals;

    const message = createBaseQueryProposalsResponse();
    message.proposals = ((_object$proposals = object.proposals) === null || _object$proposals === void 0 ? void 0 : _object$proposals.map(e => _gov__WEBPACK_IMPORTED_MODULE_0__.Proposal.fromPartial(e))) || [];
    message.pagination = object.pagination !== undefined && object.pagination !== null ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_1__.PageResponse.fromPartial(object.pagination) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      proposals: Array.isArray(object === null || object === void 0 ? void 0 : object.proposals) ? object.proposals.map(e => _gov__WEBPACK_IMPORTED_MODULE_0__.Proposal.fromAmino(e)) : [],
      pagination: object !== null && object !== void 0 && object.pagination ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_1__.PageResponse.fromAmino(object.pagination) : undefined
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.proposals) {
      obj.proposals = message.proposals.map(e => e ? _gov__WEBPACK_IMPORTED_MODULE_0__.Proposal.toAmino(e) : undefined);
    } else {
      obj.proposals = [];
    }

    obj.pagination = message.pagination ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_1__.PageResponse.toAmino(message.pagination) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryProposalsResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryProposalsResponse",
      value: QueryProposalsResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryProposalsResponse.decode(message.value);
  },

  toProto(message) {
    return QueryProposalsResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.gov.v1beta1.QueryProposalsResponse",
      value: QueryProposalsResponse.encode(message).finish()
    };
  }

};

function createBaseQueryVoteRequest() {
  return {
    proposalId: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO,
    voter: ""
  };
}

const QueryVoteRequest = {
  typeUrl: "/cosmos.gov.v1beta1.QueryVoteRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (!message.proposalId.isZero()) {
      writer.uint32(8).uint64(message.proposalId);
    }

    if (message.voter !== "") {
      writer.uint32(18).string(message.voter);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryVoteRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.proposalId = reader.uint64();
          break;

        case 2:
          message.voter = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$voter2;

    const message = createBaseQueryVoteRequest();
    message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromValue */ .dK.fromValue(object.proposalId) : _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO;
    message.voter = (_object$voter2 = object.voter) !== null && _object$voter2 !== void 0 ? _object$voter2 : "";
    return message;
  },

  fromAmino(object) {
    return {
      proposalId: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromString */ .dK.fromString(object.proposal_id),
      voter: object.voter
    };
  },

  toAmino(message) {
    const obj = {};
    obj.proposal_id = message.proposalId ? message.proposalId.toString() : undefined;
    obj.voter = message.voter;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryVoteRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryVoteRequest",
      value: QueryVoteRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryVoteRequest.decode(message.value);
  },

  toProto(message) {
    return QueryVoteRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.gov.v1beta1.QueryVoteRequest",
      value: QueryVoteRequest.encode(message).finish()
    };
  }

};

function createBaseQueryVoteResponse() {
  return {
    vote: undefined
  };
}

const QueryVoteResponse = {
  typeUrl: "/cosmos.gov.v1beta1.QueryVoteResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.vote !== undefined) {
      _gov__WEBPACK_IMPORTED_MODULE_0__.Vote.encode(message.vote, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryVoteResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.vote = _gov__WEBPACK_IMPORTED_MODULE_0__.Vote.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseQueryVoteResponse();
    message.vote = object.vote !== undefined && object.vote !== null ? _gov__WEBPACK_IMPORTED_MODULE_0__.Vote.fromPartial(object.vote) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      vote: object !== null && object !== void 0 && object.vote ? _gov__WEBPACK_IMPORTED_MODULE_0__.Vote.fromAmino(object.vote) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.vote = message.vote ? _gov__WEBPACK_IMPORTED_MODULE_0__.Vote.toAmino(message.vote) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryVoteResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryVoteResponse",
      value: QueryVoteResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryVoteResponse.decode(message.value);
  },

  toProto(message) {
    return QueryVoteResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.gov.v1beta1.QueryVoteResponse",
      value: QueryVoteResponse.encode(message).finish()
    };
  }

};

function createBaseQueryVotesRequest() {
  return {
    proposalId: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO,
    pagination: undefined
  };
}

const QueryVotesRequest = {
  typeUrl: "/cosmos.gov.v1beta1.QueryVotesRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (!message.proposalId.isZero()) {
      writer.uint32(8).uint64(message.proposalId);
    }

    if (message.pagination !== undefined) {
      _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_1__.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryVotesRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.proposalId = reader.uint64();
          break;

        case 2:
          message.pagination = _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_1__.PageRequest.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseQueryVotesRequest();
    message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromValue */ .dK.fromValue(object.proposalId) : _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO;
    message.pagination = object.pagination !== undefined && object.pagination !== null ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_1__.PageRequest.fromPartial(object.pagination) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      proposalId: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromString */ .dK.fromString(object.proposal_id),
      pagination: object !== null && object !== void 0 && object.pagination ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_1__.PageRequest.fromAmino(object.pagination) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.proposal_id = message.proposalId ? message.proposalId.toString() : undefined;
    obj.pagination = message.pagination ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_1__.PageRequest.toAmino(message.pagination) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryVotesRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryVotesRequest",
      value: QueryVotesRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryVotesRequest.decode(message.value);
  },

  toProto(message) {
    return QueryVotesRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.gov.v1beta1.QueryVotesRequest",
      value: QueryVotesRequest.encode(message).finish()
    };
  }

};

function createBaseQueryVotesResponse() {
  return {
    votes: [],
    pagination: undefined
  };
}

const QueryVotesResponse = {
  typeUrl: "/cosmos.gov.v1beta1.QueryVotesResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    for (const v of message.votes) {
      _gov__WEBPACK_IMPORTED_MODULE_0__.Vote.encode(v, writer.uint32(10).fork()).ldelim();
    }

    if (message.pagination !== undefined) {
      _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_1__.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryVotesResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.votes.push(_gov__WEBPACK_IMPORTED_MODULE_0__.Vote.decode(reader, reader.uint32()));
          break;

        case 2:
          message.pagination = _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_1__.PageResponse.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$votes;

    const message = createBaseQueryVotesResponse();
    message.votes = ((_object$votes = object.votes) === null || _object$votes === void 0 ? void 0 : _object$votes.map(e => _gov__WEBPACK_IMPORTED_MODULE_0__.Vote.fromPartial(e))) || [];
    message.pagination = object.pagination !== undefined && object.pagination !== null ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_1__.PageResponse.fromPartial(object.pagination) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      votes: Array.isArray(object === null || object === void 0 ? void 0 : object.votes) ? object.votes.map(e => _gov__WEBPACK_IMPORTED_MODULE_0__.Vote.fromAmino(e)) : [],
      pagination: object !== null && object !== void 0 && object.pagination ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_1__.PageResponse.fromAmino(object.pagination) : undefined
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.votes) {
      obj.votes = message.votes.map(e => e ? _gov__WEBPACK_IMPORTED_MODULE_0__.Vote.toAmino(e) : undefined);
    } else {
      obj.votes = [];
    }

    obj.pagination = message.pagination ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_1__.PageResponse.toAmino(message.pagination) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryVotesResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryVotesResponse",
      value: QueryVotesResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryVotesResponse.decode(message.value);
  },

  toProto(message) {
    return QueryVotesResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.gov.v1beta1.QueryVotesResponse",
      value: QueryVotesResponse.encode(message).finish()
    };
  }

};

function createBaseQueryParamsRequest() {
  return {
    paramsType: ""
  };
}

const QueryParamsRequest = {
  typeUrl: "/cosmos.gov.v1beta1.QueryParamsRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.paramsType !== "") {
      writer.uint32(10).string(message.paramsType);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryParamsRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.paramsType = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$paramsType;

    const message = createBaseQueryParamsRequest();
    message.paramsType = (_object$paramsType = object.paramsType) !== null && _object$paramsType !== void 0 ? _object$paramsType : "";
    return message;
  },

  fromAmino(object) {
    return {
      paramsType: object.params_type
    };
  },

  toAmino(message) {
    const obj = {};
    obj.params_type = message.paramsType;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryParamsRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryParamsRequest",
      value: QueryParamsRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryParamsRequest.decode(message.value);
  },

  toProto(message) {
    return QueryParamsRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.gov.v1beta1.QueryParamsRequest",
      value: QueryParamsRequest.encode(message).finish()
    };
  }

};

function createBaseQueryParamsResponse() {
  return {
    votingParams: undefined,
    depositParams: undefined,
    tallyParams: undefined
  };
}

const QueryParamsResponse = {
  typeUrl: "/cosmos.gov.v1beta1.QueryParamsResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.votingParams !== undefined) {
      _gov__WEBPACK_IMPORTED_MODULE_0__.VotingParams.encode(message.votingParams, writer.uint32(10).fork()).ldelim();
    }

    if (message.depositParams !== undefined) {
      _gov__WEBPACK_IMPORTED_MODULE_0__.DepositParams.encode(message.depositParams, writer.uint32(18).fork()).ldelim();
    }

    if (message.tallyParams !== undefined) {
      _gov__WEBPACK_IMPORTED_MODULE_0__.TallyParams.encode(message.tallyParams, writer.uint32(26).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryParamsResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.votingParams = _gov__WEBPACK_IMPORTED_MODULE_0__.VotingParams.decode(reader, reader.uint32());
          break;

        case 2:
          message.depositParams = _gov__WEBPACK_IMPORTED_MODULE_0__.DepositParams.decode(reader, reader.uint32());
          break;

        case 3:
          message.tallyParams = _gov__WEBPACK_IMPORTED_MODULE_0__.TallyParams.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseQueryParamsResponse();
    message.votingParams = object.votingParams !== undefined && object.votingParams !== null ? _gov__WEBPACK_IMPORTED_MODULE_0__.VotingParams.fromPartial(object.votingParams) : undefined;
    message.depositParams = object.depositParams !== undefined && object.depositParams !== null ? _gov__WEBPACK_IMPORTED_MODULE_0__.DepositParams.fromPartial(object.depositParams) : undefined;
    message.tallyParams = object.tallyParams !== undefined && object.tallyParams !== null ? _gov__WEBPACK_IMPORTED_MODULE_0__.TallyParams.fromPartial(object.tallyParams) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      votingParams: object !== null && object !== void 0 && object.voting_params ? _gov__WEBPACK_IMPORTED_MODULE_0__.VotingParams.fromAmino(object.voting_params) : undefined,
      depositParams: object !== null && object !== void 0 && object.deposit_params ? _gov__WEBPACK_IMPORTED_MODULE_0__.DepositParams.fromAmino(object.deposit_params) : undefined,
      tallyParams: object !== null && object !== void 0 && object.tally_params ? _gov__WEBPACK_IMPORTED_MODULE_0__.TallyParams.fromAmino(object.tally_params) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.voting_params = message.votingParams ? _gov__WEBPACK_IMPORTED_MODULE_0__.VotingParams.toAmino(message.votingParams) : undefined;
    obj.deposit_params = message.depositParams ? _gov__WEBPACK_IMPORTED_MODULE_0__.DepositParams.toAmino(message.depositParams) : undefined;
    obj.tally_params = message.tallyParams ? _gov__WEBPACK_IMPORTED_MODULE_0__.TallyParams.toAmino(message.tallyParams) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryParamsResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryParamsResponse",
      value: QueryParamsResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryParamsResponse.decode(message.value);
  },

  toProto(message) {
    return QueryParamsResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.gov.v1beta1.QueryParamsResponse",
      value: QueryParamsResponse.encode(message).finish()
    };
  }

};

function createBaseQueryDepositRequest() {
  return {
    proposalId: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO,
    depositor: ""
  };
}

const QueryDepositRequest = {
  typeUrl: "/cosmos.gov.v1beta1.QueryDepositRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (!message.proposalId.isZero()) {
      writer.uint32(8).uint64(message.proposalId);
    }

    if (message.depositor !== "") {
      writer.uint32(18).string(message.depositor);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryDepositRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.proposalId = reader.uint64();
          break;

        case 2:
          message.depositor = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$depositor2;

    const message = createBaseQueryDepositRequest();
    message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromValue */ .dK.fromValue(object.proposalId) : _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO;
    message.depositor = (_object$depositor2 = object.depositor) !== null && _object$depositor2 !== void 0 ? _object$depositor2 : "";
    return message;
  },

  fromAmino(object) {
    return {
      proposalId: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromString */ .dK.fromString(object.proposal_id),
      depositor: object.depositor
    };
  },

  toAmino(message) {
    const obj = {};
    obj.proposal_id = message.proposalId ? message.proposalId.toString() : undefined;
    obj.depositor = message.depositor;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryDepositRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryDepositRequest",
      value: QueryDepositRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryDepositRequest.decode(message.value);
  },

  toProto(message) {
    return QueryDepositRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.gov.v1beta1.QueryDepositRequest",
      value: QueryDepositRequest.encode(message).finish()
    };
  }

};

function createBaseQueryDepositResponse() {
  return {
    deposit: undefined
  };
}

const QueryDepositResponse = {
  typeUrl: "/cosmos.gov.v1beta1.QueryDepositResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.deposit !== undefined) {
      _gov__WEBPACK_IMPORTED_MODULE_0__.Deposit.encode(message.deposit, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryDepositResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.deposit = _gov__WEBPACK_IMPORTED_MODULE_0__.Deposit.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseQueryDepositResponse();
    message.deposit = object.deposit !== undefined && object.deposit !== null ? _gov__WEBPACK_IMPORTED_MODULE_0__.Deposit.fromPartial(object.deposit) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      deposit: object !== null && object !== void 0 && object.deposit ? _gov__WEBPACK_IMPORTED_MODULE_0__.Deposit.fromAmino(object.deposit) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.deposit = message.deposit ? _gov__WEBPACK_IMPORTED_MODULE_0__.Deposit.toAmino(message.deposit) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryDepositResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryDepositResponse",
      value: QueryDepositResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryDepositResponse.decode(message.value);
  },

  toProto(message) {
    return QueryDepositResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.gov.v1beta1.QueryDepositResponse",
      value: QueryDepositResponse.encode(message).finish()
    };
  }

};

function createBaseQueryDepositsRequest() {
  return {
    proposalId: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO,
    pagination: undefined
  };
}

const QueryDepositsRequest = {
  typeUrl: "/cosmos.gov.v1beta1.QueryDepositsRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (!message.proposalId.isZero()) {
      writer.uint32(8).uint64(message.proposalId);
    }

    if (message.pagination !== undefined) {
      _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_1__.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryDepositsRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.proposalId = reader.uint64();
          break;

        case 2:
          message.pagination = _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_1__.PageRequest.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseQueryDepositsRequest();
    message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromValue */ .dK.fromValue(object.proposalId) : _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO;
    message.pagination = object.pagination !== undefined && object.pagination !== null ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_1__.PageRequest.fromPartial(object.pagination) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      proposalId: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromString */ .dK.fromString(object.proposal_id),
      pagination: object !== null && object !== void 0 && object.pagination ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_1__.PageRequest.fromAmino(object.pagination) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.proposal_id = message.proposalId ? message.proposalId.toString() : undefined;
    obj.pagination = message.pagination ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_1__.PageRequest.toAmino(message.pagination) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryDepositsRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryDepositsRequest",
      value: QueryDepositsRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryDepositsRequest.decode(message.value);
  },

  toProto(message) {
    return QueryDepositsRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.gov.v1beta1.QueryDepositsRequest",
      value: QueryDepositsRequest.encode(message).finish()
    };
  }

};

function createBaseQueryDepositsResponse() {
  return {
    deposits: [],
    pagination: undefined
  };
}

const QueryDepositsResponse = {
  typeUrl: "/cosmos.gov.v1beta1.QueryDepositsResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    for (const v of message.deposits) {
      _gov__WEBPACK_IMPORTED_MODULE_0__.Deposit.encode(v, writer.uint32(10).fork()).ldelim();
    }

    if (message.pagination !== undefined) {
      _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_1__.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryDepositsResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.deposits.push(_gov__WEBPACK_IMPORTED_MODULE_0__.Deposit.decode(reader, reader.uint32()));
          break;

        case 2:
          message.pagination = _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_1__.PageResponse.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$deposits;

    const message = createBaseQueryDepositsResponse();
    message.deposits = ((_object$deposits = object.deposits) === null || _object$deposits === void 0 ? void 0 : _object$deposits.map(e => _gov__WEBPACK_IMPORTED_MODULE_0__.Deposit.fromPartial(e))) || [];
    message.pagination = object.pagination !== undefined && object.pagination !== null ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_1__.PageResponse.fromPartial(object.pagination) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      deposits: Array.isArray(object === null || object === void 0 ? void 0 : object.deposits) ? object.deposits.map(e => _gov__WEBPACK_IMPORTED_MODULE_0__.Deposit.fromAmino(e)) : [],
      pagination: object !== null && object !== void 0 && object.pagination ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_1__.PageResponse.fromAmino(object.pagination) : undefined
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.deposits) {
      obj.deposits = message.deposits.map(e => e ? _gov__WEBPACK_IMPORTED_MODULE_0__.Deposit.toAmino(e) : undefined);
    } else {
      obj.deposits = [];
    }

    obj.pagination = message.pagination ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_1__.PageResponse.toAmino(message.pagination) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryDepositsResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryDepositsResponse",
      value: QueryDepositsResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryDepositsResponse.decode(message.value);
  },

  toProto(message) {
    return QueryDepositsResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.gov.v1beta1.QueryDepositsResponse",
      value: QueryDepositsResponse.encode(message).finish()
    };
  }

};

function createBaseQueryTallyResultRequest() {
  return {
    proposalId: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO
  };
}

const QueryTallyResultRequest = {
  typeUrl: "/cosmos.gov.v1beta1.QueryTallyResultRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (!message.proposalId.isZero()) {
      writer.uint32(8).uint64(message.proposalId);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryTallyResultRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.proposalId = reader.uint64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseQueryTallyResultRequest();
    message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromValue */ .dK.fromValue(object.proposalId) : _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO;
    return message;
  },

  fromAmino(object) {
    return {
      proposalId: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromString */ .dK.fromString(object.proposal_id)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.proposal_id = message.proposalId ? message.proposalId.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryTallyResultRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryTallyResultRequest",
      value: QueryTallyResultRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryTallyResultRequest.decode(message.value);
  },

  toProto(message) {
    return QueryTallyResultRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.gov.v1beta1.QueryTallyResultRequest",
      value: QueryTallyResultRequest.encode(message).finish()
    };
  }

};

function createBaseQueryTallyResultResponse() {
  return {
    tally: undefined
  };
}

const QueryTallyResultResponse = {
  typeUrl: "/cosmos.gov.v1beta1.QueryTallyResultResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.tally !== undefined) {
      _gov__WEBPACK_IMPORTED_MODULE_0__.TallyResult.encode(message.tally, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryTallyResultResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.tally = _gov__WEBPACK_IMPORTED_MODULE_0__.TallyResult.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseQueryTallyResultResponse();
    message.tally = object.tally !== undefined && object.tally !== null ? _gov__WEBPACK_IMPORTED_MODULE_0__.TallyResult.fromPartial(object.tally) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      tally: object !== null && object !== void 0 && object.tally ? _gov__WEBPACK_IMPORTED_MODULE_0__.TallyResult.fromAmino(object.tally) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.tally = message.tally ? _gov__WEBPACK_IMPORTED_MODULE_0__.TallyResult.toAmino(message.tally) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryTallyResultResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryTallyResultResponse",
      value: QueryTallyResultResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryTallyResultResponse.decode(message.value);
  },

  toProto(message) {
    return QueryTallyResultResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.gov.v1beta1.QueryTallyResultResponse",
      value: QueryTallyResultResponse.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 3571:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LCDQueryClient": function() { return /* binding */ LCDQueryClient; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4942);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47895);


class LCDQueryClient {
  constructor({
    requestClient
  }) {
    (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, "req", void 0);

    this.req = requestClient;
    this.proposal = this.proposal.bind(this);
    this.proposals = this.proposals.bind(this);
    this.vote = this.vote.bind(this);
    this.votes = this.votes.bind(this);
    this.params = this.params.bind(this);
    this.deposit = this.deposit.bind(this);
    this.deposits = this.deposits.bind(this);
    this.tallyResult = this.tallyResult.bind(this);
  }
  /* Proposal queries proposal details based on ProposalID. */


  async proposal(params) {
    const endpoint = `cosmos/gov/v1beta1/proposals/${params.proposalId}`;
    return await this.req.get(endpoint);
  }
  /* Proposals queries all proposals based on given status. */


  async proposals(params) {
    const options = {
      params: {}
    };

    if (typeof (params === null || params === void 0 ? void 0 : params.proposalStatus) !== "undefined") {
      options.params.proposal_status = params.proposalStatus;
    }

    if (typeof (params === null || params === void 0 ? void 0 : params.voter) !== "undefined") {
      options.params.voter = params.voter;
    }

    if (typeof (params === null || params === void 0 ? void 0 : params.depositor) !== "undefined") {
      options.params.depositor = params.depositor;
    }

    if (typeof (params === null || params === void 0 ? void 0 : params.pagination) !== "undefined") {
      (0,_helpers__WEBPACK_IMPORTED_MODULE_0__/* .setPaginationParams */ .q6)(options, params.pagination);
    }

    const endpoint = `cosmos/gov/v1beta1/proposals`;
    return await this.req.get(endpoint, options);
  }
  /* Vote queries voted information based on proposalID, voterAddr. */


  async vote(params) {
    const endpoint = `cosmos/gov/v1beta1/proposals/${params.proposalId}/votes/${params.voter}`;
    return await this.req.get(endpoint);
  }
  /* Votes queries votes of a given proposal. */


  async votes(params) {
    const options = {
      params: {}
    };

    if (typeof (params === null || params === void 0 ? void 0 : params.pagination) !== "undefined") {
      (0,_helpers__WEBPACK_IMPORTED_MODULE_0__/* .setPaginationParams */ .q6)(options, params.pagination);
    }

    const endpoint = `cosmos/gov/v1beta1/proposals/${params.proposalId}/votes`;
    return await this.req.get(endpoint, options);
  }
  /* Params queries all parameters of the gov module. */


  async params(params) {
    const endpoint = `cosmos/gov/v1beta1/params/${params.paramsType}`;
    return await this.req.get(endpoint);
  }
  /* Deposit queries single deposit information based proposalID, depositAddr. */


  async deposit(params) {
    const endpoint = `cosmos/gov/v1beta1/proposals/${params.proposalId}/deposits/${params.depositor}`;
    return await this.req.get(endpoint);
  }
  /* Deposits queries all deposits of a single proposal. */


  async deposits(params) {
    const options = {
      params: {}
    };

    if (typeof (params === null || params === void 0 ? void 0 : params.pagination) !== "undefined") {
      (0,_helpers__WEBPACK_IMPORTED_MODULE_0__/* .setPaginationParams */ .q6)(options, params.pagination);
    }

    const endpoint = `cosmos/gov/v1beta1/proposals/${params.proposalId}/deposits`;
    return await this.req.get(endpoint, options);
  }
  /* TallyResult queries the tally of a proposal vote. */


  async tallyResult(params) {
    const endpoint = `cosmos/gov/v1beta1/proposals/${params.proposalId}/tally`;
    return await this.req.get(endpoint);
  }

}

/***/ }),

/***/ 96921:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QueryClientImpl": function() { return /* binding */ QueryClientImpl; },
/* harmony export */   "createRpcQueryExtension": function() { return /* binding */ createRpcQueryExtension; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4942);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78441);
/* harmony import */ var _cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71814);




/** Query defines the gRPC querier service for gov module */

class QueryClientImpl {
  constructor(rpc) {
    (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, "rpc", void 0);

    this.rpc = rpc;
    this.proposal = this.proposal.bind(this);
    this.proposals = this.proposals.bind(this);
    this.vote = this.vote.bind(this);
    this.votes = this.votes.bind(this);
    this.params = this.params.bind(this);
    this.deposit = this.deposit.bind(this);
    this.deposits = this.deposits.bind(this);
    this.tallyResult = this.tallyResult.bind(this);
  }

  proposal(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryProposalRequest.encode(request).finish();
    const promise = this.rpc.request("cosmos.gov.v1beta1.Query", "Proposal", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryProposalResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  proposals(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryProposalsRequest.encode(request).finish();
    const promise = this.rpc.request("cosmos.gov.v1beta1.Query", "Proposals", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryProposalsResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  vote(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryVoteRequest.encode(request).finish();
    const promise = this.rpc.request("cosmos.gov.v1beta1.Query", "Vote", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryVoteResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  votes(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryVotesRequest.encode(request).finish();
    const promise = this.rpc.request("cosmos.gov.v1beta1.Query", "Votes", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryVotesResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  params(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryParamsRequest.encode(request).finish();
    const promise = this.rpc.request("cosmos.gov.v1beta1.Query", "Params", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryParamsResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  deposit(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryDepositRequest.encode(request).finish();
    const promise = this.rpc.request("cosmos.gov.v1beta1.Query", "Deposit", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryDepositResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  deposits(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryDepositsRequest.encode(request).finish();
    const promise = this.rpc.request("cosmos.gov.v1beta1.Query", "Deposits", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryDepositsResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  tallyResult(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryTallyResultRequest.encode(request).finish();
    const promise = this.rpc.request("cosmos.gov.v1beta1.Query", "TallyResult", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryTallyResultResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

}
const createRpcQueryExtension = base => {
  const rpc = (0,_cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1__.createProtobufRpcClient)(base);
  const queryService = new QueryClientImpl(rpc);
  return {
    proposal(request) {
      return queryService.proposal(request);
    },

    proposals(request) {
      return queryService.proposals(request);
    },

    vote(request) {
      return queryService.vote(request);
    },

    votes(request) {
      return queryService.votes(request);
    },

    params(request) {
      return queryService.params(request);
    },

    deposit(request) {
      return queryService.deposit(request);
    },

    deposits(request) {
      return queryService.deposits(request);
    },

    tallyResult(request) {
      return queryService.tallyResult(request);
    }

  };
};

/***/ }),

/***/ 98551:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Content_FromAmino": function() { return /* binding */ Content_FromAmino; },
/* harmony export */   "Content_InterfaceDecoder": function() { return /* binding */ Content_InterfaceDecoder; },
/* harmony export */   "Content_ToAmino": function() { return /* binding */ Content_ToAmino; },
/* harmony export */   "MsgDeposit": function() { return /* binding */ MsgDeposit; },
/* harmony export */   "MsgDepositResponse": function() { return /* binding */ MsgDepositResponse; },
/* harmony export */   "MsgSubmitProposal": function() { return /* binding */ MsgSubmitProposal; },
/* harmony export */   "MsgSubmitProposalResponse": function() { return /* binding */ MsgSubmitProposalResponse; },
/* harmony export */   "MsgVote": function() { return /* binding */ MsgVote; },
/* harmony export */   "MsgVoteResponse": function() { return /* binding */ MsgVoteResponse; },
/* harmony export */   "MsgVoteWeighted": function() { return /* binding */ MsgVoteWeighted; },
/* harmony export */   "MsgVoteWeightedResponse": function() { return /* binding */ MsgVoteWeightedResponse; }
/* harmony export */ });
/* harmony import */ var _google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32106);
/* harmony import */ var _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26178);
/* harmony import */ var _gov__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95180);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47895);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__);





/**
 * MsgSubmitProposal defines an sdk.Msg type that supports submitting arbitrary
 * proposal Content.
 */

function createBaseMsgSubmitProposal() {
  return {
    content: undefined,
    initialDeposit: [],
    proposer: "",
    isExpedited: false
  };
}

const MsgSubmitProposal = {
  typeUrl: "/cosmos.gov.v1beta1.MsgSubmitProposal",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    if (message.content !== undefined) {
      _google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__.Any.encode(message.content, writer.uint32(10).fork()).ldelim();
    }

    for (const v of message.initialDeposit) {
      _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.encode(v, writer.uint32(18).fork()).ldelim();
    }

    if (message.proposer !== "") {
      writer.uint32(26).string(message.proposer);
    }

    if (message.isExpedited === true) {
      writer.uint32(32).bool(message.isExpedited);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgSubmitProposal();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.content = Content_InterfaceDecoder(reader);
          break;

        case 2:
          message.initialDeposit.push(_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.decode(reader, reader.uint32()));
          break;

        case 3:
          message.proposer = reader.string();
          break;

        case 4:
          message.isExpedited = reader.bool();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$initialDeposi, _object$proposer, _object$isExpedited;

    const message = createBaseMsgSubmitProposal();
    message.content = object.content !== undefined && object.content !== null ? _google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__.Any.fromPartial(object.content) : undefined;
    message.initialDeposit = ((_object$initialDeposi = object.initialDeposit) === null || _object$initialDeposi === void 0 ? void 0 : _object$initialDeposi.map(e => _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.fromPartial(e))) || [];
    message.proposer = (_object$proposer = object.proposer) !== null && _object$proposer !== void 0 ? _object$proposer : "";
    message.isExpedited = (_object$isExpedited = object.isExpedited) !== null && _object$isExpedited !== void 0 ? _object$isExpedited : false;
    return message;
  },

  fromAmino(object) {
    return {
      content: object !== null && object !== void 0 && object.content ? Content_FromAmino(object.content) : undefined,
      initialDeposit: Array.isArray(object === null || object === void 0 ? void 0 : object.initial_deposit) ? object.initial_deposit.map(e => _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.fromAmino(e)) : [],
      proposer: object.proposer,
      isExpedited: object.is_expedited
    };
  },

  toAmino(message) {
    const obj = {};
    obj.content = message.content ? Content_ToAmino(message.content) : undefined;

    if (message.initialDeposit) {
      obj.initial_deposit = message.initialDeposit.map(e => e ? _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.toAmino(e) : undefined);
    } else {
      obj.initial_deposit = [];
    }

    obj.proposer = message.proposer;
    obj.is_expedited = message.isExpedited;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgSubmitProposal.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/v1/MsgSubmitProposal",
      value: MsgSubmitProposal.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgSubmitProposal.decode(message.value);
  },

  toProto(message) {
    return MsgSubmitProposal.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.gov.v1beta1.MsgSubmitProposal",
      value: MsgSubmitProposal.encode(message).finish()
    };
  }

};

function createBaseMsgSubmitProposalResponse() {
  return {
    proposalId: _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.UZERO */ .dK.UZERO
  };
}

const MsgSubmitProposalResponse = {
  typeUrl: "/cosmos.gov.v1beta1.MsgSubmitProposalResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    if (!message.proposalId.isZero()) {
      writer.uint32(8).uint64(message.proposalId);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgSubmitProposalResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.proposalId = reader.uint64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseMsgSubmitProposalResponse();
    message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.fromValue */ .dK.fromValue(object.proposalId) : _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.UZERO */ .dK.UZERO;
    return message;
  },

  fromAmino(object) {
    return {
      proposalId: _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.fromString */ .dK.fromString(object.proposal_id)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.proposal_id = message.proposalId ? message.proposalId.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgSubmitProposalResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/MsgSubmitProposalResponse",
      value: MsgSubmitProposalResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgSubmitProposalResponse.decode(message.value);
  },

  toProto(message) {
    return MsgSubmitProposalResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.gov.v1beta1.MsgSubmitProposalResponse",
      value: MsgSubmitProposalResponse.encode(message).finish()
    };
  }

};

function createBaseMsgVote() {
  return {
    proposalId: _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.UZERO */ .dK.UZERO,
    voter: "",
    option: 0
  };
}

const MsgVote = {
  typeUrl: "/cosmos.gov.v1beta1.MsgVote",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    if (!message.proposalId.isZero()) {
      writer.uint32(8).uint64(message.proposalId);
    }

    if (message.voter !== "") {
      writer.uint32(18).string(message.voter);
    }

    if (message.option !== 0) {
      writer.uint32(24).int32(message.option);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgVote();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.proposalId = reader.uint64();
          break;

        case 2:
          message.voter = reader.string();
          break;

        case 3:
          message.option = reader.int32();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$voter, _object$option;

    const message = createBaseMsgVote();
    message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.fromValue */ .dK.fromValue(object.proposalId) : _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.UZERO */ .dK.UZERO;
    message.voter = (_object$voter = object.voter) !== null && _object$voter !== void 0 ? _object$voter : "";
    message.option = (_object$option = object.option) !== null && _object$option !== void 0 ? _object$option : 0;
    return message;
  },

  fromAmino(object) {
    return {
      proposalId: _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.fromString */ .dK.fromString(object.proposal_id),
      voter: object.voter,
      option: (0,_helpers__WEBPACK_IMPORTED_MODULE_3__/* .isSet */ .DM)(object.option) ? (0,_gov__WEBPACK_IMPORTED_MODULE_2__.voteOptionFromJSON)(object.option) : 0
    };
  },

  toAmino(message) {
    const obj = {};
    obj.proposal_id = message.proposalId ? message.proposalId.toString() : undefined;
    obj.voter = message.voter;
    obj.option = message.option;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgVote.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/v1/MsgVote",
      value: MsgVote.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgVote.decode(message.value);
  },

  toProto(message) {
    return MsgVote.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.gov.v1beta1.MsgVote",
      value: MsgVote.encode(message).finish()
    };
  }

};

function createBaseMsgVoteResponse() {
  return {};
}

const MsgVoteResponse = {
  typeUrl: "/cosmos.gov.v1beta1.MsgVoteResponse",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgVoteResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseMsgVoteResponse();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return MsgVoteResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/MsgVoteResponse",
      value: MsgVoteResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgVoteResponse.decode(message.value);
  },

  toProto(message) {
    return MsgVoteResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.gov.v1beta1.MsgVoteResponse",
      value: MsgVoteResponse.encode(message).finish()
    };
  }

};

function createBaseMsgVoteWeighted() {
  return {
    proposalId: _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.UZERO */ .dK.UZERO,
    voter: "",
    options: []
  };
}

const MsgVoteWeighted = {
  typeUrl: "/cosmos.gov.v1beta1.MsgVoteWeighted",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    if (!message.proposalId.isZero()) {
      writer.uint32(8).uint64(message.proposalId);
    }

    if (message.voter !== "") {
      writer.uint32(18).string(message.voter);
    }

    for (const v of message.options) {
      _gov__WEBPACK_IMPORTED_MODULE_2__.WeightedVoteOption.encode(v, writer.uint32(26).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgVoteWeighted();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.proposalId = reader.uint64();
          break;

        case 2:
          message.voter = reader.string();
          break;

        case 3:
          message.options.push(_gov__WEBPACK_IMPORTED_MODULE_2__.WeightedVoteOption.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$voter2, _object$options;

    const message = createBaseMsgVoteWeighted();
    message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.fromValue */ .dK.fromValue(object.proposalId) : _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.UZERO */ .dK.UZERO;
    message.voter = (_object$voter2 = object.voter) !== null && _object$voter2 !== void 0 ? _object$voter2 : "";
    message.options = ((_object$options = object.options) === null || _object$options === void 0 ? void 0 : _object$options.map(e => _gov__WEBPACK_IMPORTED_MODULE_2__.WeightedVoteOption.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      proposalId: _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.fromString */ .dK.fromString(object.proposal_id),
      voter: object.voter,
      options: Array.isArray(object === null || object === void 0 ? void 0 : object.options) ? object.options.map(e => _gov__WEBPACK_IMPORTED_MODULE_2__.WeightedVoteOption.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.proposal_id = message.proposalId ? message.proposalId.toString() : undefined;
    obj.voter = message.voter;

    if (message.options) {
      obj.options = message.options.map(e => e ? _gov__WEBPACK_IMPORTED_MODULE_2__.WeightedVoteOption.toAmino(e) : undefined);
    } else {
      obj.options = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return MsgVoteWeighted.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/v1/MsgVoteWeighted",
      value: MsgVoteWeighted.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgVoteWeighted.decode(message.value);
  },

  toProto(message) {
    return MsgVoteWeighted.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.gov.v1beta1.MsgVoteWeighted",
      value: MsgVoteWeighted.encode(message).finish()
    };
  }

};

function createBaseMsgVoteWeightedResponse() {
  return {};
}

const MsgVoteWeightedResponse = {
  typeUrl: "/cosmos.gov.v1beta1.MsgVoteWeightedResponse",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgVoteWeightedResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseMsgVoteWeightedResponse();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return MsgVoteWeightedResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/MsgVoteWeightedResponse",
      value: MsgVoteWeightedResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgVoteWeightedResponse.decode(message.value);
  },

  toProto(message) {
    return MsgVoteWeightedResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.gov.v1beta1.MsgVoteWeightedResponse",
      value: MsgVoteWeightedResponse.encode(message).finish()
    };
  }

};

function createBaseMsgDeposit() {
  return {
    proposalId: _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.UZERO */ .dK.UZERO,
    depositor: "",
    amount: []
  };
}

const MsgDeposit = {
  typeUrl: "/cosmos.gov.v1beta1.MsgDeposit",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    if (!message.proposalId.isZero()) {
      writer.uint32(8).uint64(message.proposalId);
    }

    if (message.depositor !== "") {
      writer.uint32(18).string(message.depositor);
    }

    for (const v of message.amount) {
      _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.encode(v, writer.uint32(26).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgDeposit();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.proposalId = reader.uint64();
          break;

        case 2:
          message.depositor = reader.string();
          break;

        case 3:
          message.amount.push(_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$depositor, _object$amount;

    const message = createBaseMsgDeposit();
    message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.fromValue */ .dK.fromValue(object.proposalId) : _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.UZERO */ .dK.UZERO;
    message.depositor = (_object$depositor = object.depositor) !== null && _object$depositor !== void 0 ? _object$depositor : "";
    message.amount = ((_object$amount = object.amount) === null || _object$amount === void 0 ? void 0 : _object$amount.map(e => _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      proposalId: _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.fromString */ .dK.fromString(object.proposal_id),
      depositor: object.depositor,
      amount: Array.isArray(object === null || object === void 0 ? void 0 : object.amount) ? object.amount.map(e => _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.proposal_id = message.proposalId ? message.proposalId.toString() : undefined;
    obj.depositor = message.depositor;

    if (message.amount) {
      obj.amount = message.amount.map(e => e ? _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.toAmino(e) : undefined);
    } else {
      obj.amount = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return MsgDeposit.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/v1/MsgDeposit",
      value: MsgDeposit.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgDeposit.decode(message.value);
  },

  toProto(message) {
    return MsgDeposit.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.gov.v1beta1.MsgDeposit",
      value: MsgDeposit.encode(message).finish()
    };
  }

};

function createBaseMsgDepositResponse() {
  return {};
}

const MsgDepositResponse = {
  typeUrl: "/cosmos.gov.v1beta1.MsgDepositResponse",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgDepositResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseMsgDepositResponse();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return MsgDepositResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/MsgDepositResponse",
      value: MsgDepositResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgDepositResponse.decode(message.value);
  },

  toProto(message) {
    return MsgDepositResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.gov.v1beta1.MsgDepositResponse",
      value: MsgDepositResponse.encode(message).finish()
    };
  }

};
const Content_InterfaceDecoder = input => {
  const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
  const data = _google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__.Any.decode(reader, reader.uint32());

  switch (data.typeUrl) {
    case "/cosmos.gov.v1beta1.TextProposal":
      return _gov__WEBPACK_IMPORTED_MODULE_2__.TextProposal.decode(data.value);

    default:
      return data;
  }
};
const Content_FromAmino = content => {
  switch (content.type) {
    case "cosmos-sdk/TextProposal":
      return _google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__.Any.fromPartial({
        typeUrl: "/cosmos.gov.v1beta1.TextProposal",
        value: _gov__WEBPACK_IMPORTED_MODULE_2__.TextProposal.encode(_gov__WEBPACK_IMPORTED_MODULE_2__.TextProposal.fromPartial(_gov__WEBPACK_IMPORTED_MODULE_2__.TextProposal.fromAmino(content.value))).finish()
      });

    default:
      return _google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__.Any.fromAmino(content);
  }
};
const Content_ToAmino = content => {
  switch (content.typeUrl) {
    case "/cosmos.gov.v1beta1.TextProposal":
      return {
        type: "cosmos-sdk/TextProposal",
        value: _gov__WEBPACK_IMPORTED_MODULE_2__.TextProposal.toAmino(_gov__WEBPACK_IMPORTED_MODULE_2__.TextProposal.decode(content.value))
      };

    default:
      return _google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__.Any.toAmino(content);
  }
};

/***/ }),

/***/ 3207:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MsgClientImpl": function() { return /* binding */ MsgClientImpl; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4942);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _tx__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98551);



/** Msg defines the bank Msg service. */

class MsgClientImpl {
  constructor(rpc) {
    (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, "rpc", void 0);

    this.rpc = rpc;
    this.submitProposal = this.submitProposal.bind(this);
    this.vote = this.vote.bind(this);
    this.voteWeighted = this.voteWeighted.bind(this);
    this.deposit = this.deposit.bind(this);
  }

  submitProposal(request) {
    const data = _tx__WEBPACK_IMPORTED_MODULE_1__.MsgSubmitProposal.encode(request).finish();
    const promise = this.rpc.request("cosmos.gov.v1beta1.Msg", "SubmitProposal", data);
    return promise.then(data => _tx__WEBPACK_IMPORTED_MODULE_1__.MsgSubmitProposalResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  vote(request) {
    const data = _tx__WEBPACK_IMPORTED_MODULE_1__.MsgVote.encode(request).finish();
    const promise = this.rpc.request("cosmos.gov.v1beta1.Msg", "Vote", data);
    return promise.then(data => _tx__WEBPACK_IMPORTED_MODULE_1__.MsgVoteResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  voteWeighted(request) {
    const data = _tx__WEBPACK_IMPORTED_MODULE_1__.MsgVoteWeighted.encode(request).finish();
    const promise = this.rpc.request("cosmos.gov.v1beta1.Msg", "VoteWeighted", data);
    return promise.then(data => _tx__WEBPACK_IMPORTED_MODULE_1__.MsgVoteWeightedResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  deposit(request) {
    const data = _tx__WEBPACK_IMPORTED_MODULE_1__.MsgDeposit.encode(request).finish();
    const promise = this.rpc.request("cosmos.gov.v1beta1.Msg", "Deposit", data);
    return promise.then(data => _tx__WEBPACK_IMPORTED_MODULE_1__.MsgDepositResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

}

/***/ }),

/***/ 19033:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BatchEntry": function() { return /* binding */ BatchEntry; },
/* harmony export */   "BatchProof": function() { return /* binding */ BatchProof; },
/* harmony export */   "CommitmentProof": function() { return /* binding */ CommitmentProof; },
/* harmony export */   "CompressedBatchEntry": function() { return /* binding */ CompressedBatchEntry; },
/* harmony export */   "CompressedBatchProof": function() { return /* binding */ CompressedBatchProof; },
/* harmony export */   "CompressedExistenceProof": function() { return /* binding */ CompressedExistenceProof; },
/* harmony export */   "CompressedNonExistenceProof": function() { return /* binding */ CompressedNonExistenceProof; },
/* harmony export */   "ExistenceProof": function() { return /* binding */ ExistenceProof; },
/* harmony export */   "HashOp": function() { return /* binding */ HashOp; },
/* harmony export */   "HashOpAmino": function() { return /* binding */ HashOpAmino; },
/* harmony export */   "HashOpSDKType": function() { return /* binding */ HashOpSDKType; },
/* harmony export */   "InnerOp": function() { return /* binding */ InnerOp; },
/* harmony export */   "InnerSpec": function() { return /* binding */ InnerSpec; },
/* harmony export */   "LeafOp": function() { return /* binding */ LeafOp; },
/* harmony export */   "LengthOp": function() { return /* binding */ LengthOp; },
/* harmony export */   "LengthOpAmino": function() { return /* binding */ LengthOpAmino; },
/* harmony export */   "LengthOpSDKType": function() { return /* binding */ LengthOpSDKType; },
/* harmony export */   "NonExistenceProof": function() { return /* binding */ NonExistenceProof; },
/* harmony export */   "ProofSpec": function() { return /* binding */ ProofSpec; },
/* harmony export */   "hashOpFromJSON": function() { return /* binding */ hashOpFromJSON; },
/* harmony export */   "hashOpToJSON": function() { return /* binding */ hashOpToJSON; },
/* harmony export */   "lengthOpFromJSON": function() { return /* binding */ lengthOpFromJSON; },
/* harmony export */   "lengthOpToJSON": function() { return /* binding */ lengthOpToJSON; }
/* harmony export */ });
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47895);


let HashOp;

(function (HashOp) {
  HashOp[HashOp["NO_HASH"] = 0] = "NO_HASH";
  HashOp[HashOp["SHA256"] = 1] = "SHA256";
  HashOp[HashOp["SHA512"] = 2] = "SHA512";
  HashOp[HashOp["KECCAK"] = 3] = "KECCAK";
  HashOp[HashOp["RIPEMD160"] = 4] = "RIPEMD160";
  HashOp[HashOp["BITCOIN"] = 5] = "BITCOIN";
  HashOp[HashOp["SHA512_256"] = 6] = "SHA512_256";
  HashOp[HashOp["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(HashOp || (HashOp = {}));

const HashOpSDKType = HashOp;
const HashOpAmino = HashOp;
function hashOpFromJSON(object) {
  switch (object) {
    case 0:
    case "NO_HASH":
      return HashOp.NO_HASH;

    case 1:
    case "SHA256":
      return HashOp.SHA256;

    case 2:
    case "SHA512":
      return HashOp.SHA512;

    case 3:
    case "KECCAK":
      return HashOp.KECCAK;

    case 4:
    case "RIPEMD160":
      return HashOp.RIPEMD160;

    case 5:
    case "BITCOIN":
      return HashOp.BITCOIN;

    case 6:
    case "SHA512_256":
      return HashOp.SHA512_256;

    case -1:
    case "UNRECOGNIZED":
    default:
      return HashOp.UNRECOGNIZED;
  }
}
function hashOpToJSON(object) {
  switch (object) {
    case HashOp.NO_HASH:
      return "NO_HASH";

    case HashOp.SHA256:
      return "SHA256";

    case HashOp.SHA512:
      return "SHA512";

    case HashOp.KECCAK:
      return "KECCAK";

    case HashOp.RIPEMD160:
      return "RIPEMD160";

    case HashOp.BITCOIN:
      return "BITCOIN";

    case HashOp.SHA512_256:
      return "SHA512_256";

    case HashOp.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
/**
 * LengthOp defines how to process the key and value of the LeafOp
 * to include length information. After encoding the length with the given
 * algorithm, the length will be prepended to the key and value bytes.
 * (Each one with it's own encoded length)
 */

let LengthOp;

(function (LengthOp) {
  LengthOp[LengthOp["NO_PREFIX"] = 0] = "NO_PREFIX";
  LengthOp[LengthOp["VAR_PROTO"] = 1] = "VAR_PROTO";
  LengthOp[LengthOp["VAR_RLP"] = 2] = "VAR_RLP";
  LengthOp[LengthOp["FIXED32_BIG"] = 3] = "FIXED32_BIG";
  LengthOp[LengthOp["FIXED32_LITTLE"] = 4] = "FIXED32_LITTLE";
  LengthOp[LengthOp["FIXED64_BIG"] = 5] = "FIXED64_BIG";
  LengthOp[LengthOp["FIXED64_LITTLE"] = 6] = "FIXED64_LITTLE";
  LengthOp[LengthOp["REQUIRE_32_BYTES"] = 7] = "REQUIRE_32_BYTES";
  LengthOp[LengthOp["REQUIRE_64_BYTES"] = 8] = "REQUIRE_64_BYTES";
  LengthOp[LengthOp["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(LengthOp || (LengthOp = {}));

const LengthOpSDKType = LengthOp;
const LengthOpAmino = LengthOp;
function lengthOpFromJSON(object) {
  switch (object) {
    case 0:
    case "NO_PREFIX":
      return LengthOp.NO_PREFIX;

    case 1:
    case "VAR_PROTO":
      return LengthOp.VAR_PROTO;

    case 2:
    case "VAR_RLP":
      return LengthOp.VAR_RLP;

    case 3:
    case "FIXED32_BIG":
      return LengthOp.FIXED32_BIG;

    case 4:
    case "FIXED32_LITTLE":
      return LengthOp.FIXED32_LITTLE;

    case 5:
    case "FIXED64_BIG":
      return LengthOp.FIXED64_BIG;

    case 6:
    case "FIXED64_LITTLE":
      return LengthOp.FIXED64_LITTLE;

    case 7:
    case "REQUIRE_32_BYTES":
      return LengthOp.REQUIRE_32_BYTES;

    case 8:
    case "REQUIRE_64_BYTES":
      return LengthOp.REQUIRE_64_BYTES;

    case -1:
    case "UNRECOGNIZED":
    default:
      return LengthOp.UNRECOGNIZED;
  }
}
function lengthOpToJSON(object) {
  switch (object) {
    case LengthOp.NO_PREFIX:
      return "NO_PREFIX";

    case LengthOp.VAR_PROTO:
      return "VAR_PROTO";

    case LengthOp.VAR_RLP:
      return "VAR_RLP";

    case LengthOp.FIXED32_BIG:
      return "FIXED32_BIG";

    case LengthOp.FIXED32_LITTLE:
      return "FIXED32_LITTLE";

    case LengthOp.FIXED64_BIG:
      return "FIXED64_BIG";

    case LengthOp.FIXED64_LITTLE:
      return "FIXED64_LITTLE";

    case LengthOp.REQUIRE_32_BYTES:
      return "REQUIRE_32_BYTES";

    case LengthOp.REQUIRE_64_BYTES:
      return "REQUIRE_64_BYTES";

    case LengthOp.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
/**
 * ExistenceProof takes a key and a value and a set of steps to perform on it.
 * The result of peforming all these steps will provide a "root hash", which can
 * be compared to the value in a header.
 * 
 * Since it is computationally infeasible to produce a hash collission for any of the used
 * cryptographic hash functions, if someone can provide a series of operations to transform
 * a given key and value into a root hash that matches some trusted root, these key and values
 * must be in the referenced merkle tree.
 * 
 * The only possible issue is maliablity in LeafOp, such as providing extra prefix data,
 * which should be controlled by a spec. Eg. with lengthOp as NONE,
 * prefix = FOO, key = BAR, value = CHOICE
 * and
 * prefix = F, key = OOBAR, value = CHOICE
 * would produce the same value.
 * 
 * With LengthOp this is tricker but not impossible. Which is why the "leafPrefixEqual" field
 * in the ProofSpec is valuable to prevent this mutability. And why all trees should
 * length-prefix the data before hashing it.
 */

function createBaseExistenceProof() {
  return {
    key: new Uint8Array(),
    value: new Uint8Array(),
    leaf: undefined,
    path: []
  };
}

const ExistenceProof = {
  typeUrl: "/cosmos.ics23.v1.ExistenceProof",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Writer.create()) {
    if (message.key.length !== 0) {
      writer.uint32(10).bytes(message.key);
    }

    if (message.value.length !== 0) {
      writer.uint32(18).bytes(message.value);
    }

    if (message.leaf !== undefined) {
      LeafOp.encode(message.leaf, writer.uint32(26).fork()).ldelim();
    }

    for (const v of message.path) {
      InnerOp.encode(v, writer.uint32(34).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseExistenceProof();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.key = reader.bytes();
          break;

        case 2:
          message.value = reader.bytes();
          break;

        case 3:
          message.leaf = LeafOp.decode(reader, reader.uint32());
          break;

        case 4:
          message.path.push(InnerOp.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$key, _object$value, _object$path;

    const message = createBaseExistenceProof();
    message.key = (_object$key = object.key) !== null && _object$key !== void 0 ? _object$key : new Uint8Array();
    message.value = (_object$value = object.value) !== null && _object$value !== void 0 ? _object$value : new Uint8Array();
    message.leaf = object.leaf !== undefined && object.leaf !== null ? LeafOp.fromPartial(object.leaf) : undefined;
    message.path = ((_object$path = object.path) === null || _object$path === void 0 ? void 0 : _object$path.map(e => InnerOp.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      key: object.key,
      value: object.value,
      leaf: object !== null && object !== void 0 && object.leaf ? LeafOp.fromAmino(object.leaf) : undefined,
      path: Array.isArray(object === null || object === void 0 ? void 0 : object.path) ? object.path.map(e => InnerOp.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.key = message.key;
    obj.value = message.value;
    obj.leaf = message.leaf ? LeafOp.toAmino(message.leaf) : undefined;

    if (message.path) {
      obj.path = message.path.map(e => e ? InnerOp.toAmino(e) : undefined);
    } else {
      obj.path = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return ExistenceProof.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/ExistenceProof",
      value: ExistenceProof.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return ExistenceProof.decode(message.value);
  },

  toProto(message) {
    return ExistenceProof.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.ics23.v1.ExistenceProof",
      value: ExistenceProof.encode(message).finish()
    };
  }

};

function createBaseNonExistenceProof() {
  return {
    key: new Uint8Array(),
    left: undefined,
    right: undefined
  };
}

const NonExistenceProof = {
  typeUrl: "/cosmos.ics23.v1.NonExistenceProof",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Writer.create()) {
    if (message.key.length !== 0) {
      writer.uint32(10).bytes(message.key);
    }

    if (message.left !== undefined) {
      ExistenceProof.encode(message.left, writer.uint32(18).fork()).ldelim();
    }

    if (message.right !== undefined) {
      ExistenceProof.encode(message.right, writer.uint32(26).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseNonExistenceProof();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.key = reader.bytes();
          break;

        case 2:
          message.left = ExistenceProof.decode(reader, reader.uint32());
          break;

        case 3:
          message.right = ExistenceProof.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$key2;

    const message = createBaseNonExistenceProof();
    message.key = (_object$key2 = object.key) !== null && _object$key2 !== void 0 ? _object$key2 : new Uint8Array();
    message.left = object.left !== undefined && object.left !== null ? ExistenceProof.fromPartial(object.left) : undefined;
    message.right = object.right !== undefined && object.right !== null ? ExistenceProof.fromPartial(object.right) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      key: object.key,
      left: object !== null && object !== void 0 && object.left ? ExistenceProof.fromAmino(object.left) : undefined,
      right: object !== null && object !== void 0 && object.right ? ExistenceProof.fromAmino(object.right) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.key = message.key;
    obj.left = message.left ? ExistenceProof.toAmino(message.left) : undefined;
    obj.right = message.right ? ExistenceProof.toAmino(message.right) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return NonExistenceProof.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/NonExistenceProof",
      value: NonExistenceProof.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return NonExistenceProof.decode(message.value);
  },

  toProto(message) {
    return NonExistenceProof.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.ics23.v1.NonExistenceProof",
      value: NonExistenceProof.encode(message).finish()
    };
  }

};

function createBaseCommitmentProof() {
  return {
    exist: undefined,
    nonexist: undefined,
    batch: undefined,
    compressed: undefined
  };
}

const CommitmentProof = {
  typeUrl: "/cosmos.ics23.v1.CommitmentProof",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Writer.create()) {
    if (message.exist !== undefined) {
      ExistenceProof.encode(message.exist, writer.uint32(10).fork()).ldelim();
    }

    if (message.nonexist !== undefined) {
      NonExistenceProof.encode(message.nonexist, writer.uint32(18).fork()).ldelim();
    }

    if (message.batch !== undefined) {
      BatchProof.encode(message.batch, writer.uint32(26).fork()).ldelim();
    }

    if (message.compressed !== undefined) {
      CompressedBatchProof.encode(message.compressed, writer.uint32(34).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCommitmentProof();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.exist = ExistenceProof.decode(reader, reader.uint32());
          break;

        case 2:
          message.nonexist = NonExistenceProof.decode(reader, reader.uint32());
          break;

        case 3:
          message.batch = BatchProof.decode(reader, reader.uint32());
          break;

        case 4:
          message.compressed = CompressedBatchProof.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseCommitmentProof();
    message.exist = object.exist !== undefined && object.exist !== null ? ExistenceProof.fromPartial(object.exist) : undefined;
    message.nonexist = object.nonexist !== undefined && object.nonexist !== null ? NonExistenceProof.fromPartial(object.nonexist) : undefined;
    message.batch = object.batch !== undefined && object.batch !== null ? BatchProof.fromPartial(object.batch) : undefined;
    message.compressed = object.compressed !== undefined && object.compressed !== null ? CompressedBatchProof.fromPartial(object.compressed) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      exist: object !== null && object !== void 0 && object.exist ? ExistenceProof.fromAmino(object.exist) : undefined,
      nonexist: object !== null && object !== void 0 && object.nonexist ? NonExistenceProof.fromAmino(object.nonexist) : undefined,
      batch: object !== null && object !== void 0 && object.batch ? BatchProof.fromAmino(object.batch) : undefined,
      compressed: object !== null && object !== void 0 && object.compressed ? CompressedBatchProof.fromAmino(object.compressed) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.exist = message.exist ? ExistenceProof.toAmino(message.exist) : undefined;
    obj.nonexist = message.nonexist ? NonExistenceProof.toAmino(message.nonexist) : undefined;
    obj.batch = message.batch ? BatchProof.toAmino(message.batch) : undefined;
    obj.compressed = message.compressed ? CompressedBatchProof.toAmino(message.compressed) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return CommitmentProof.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/CommitmentProof",
      value: CommitmentProof.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return CommitmentProof.decode(message.value);
  },

  toProto(message) {
    return CommitmentProof.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.ics23.v1.CommitmentProof",
      value: CommitmentProof.encode(message).finish()
    };
  }

};

function createBaseLeafOp() {
  return {
    hash: 0,
    prehashKey: 0,
    prehashValue: 0,
    length: 0,
    prefix: new Uint8Array()
  };
}

const LeafOp = {
  typeUrl: "/cosmos.ics23.v1.LeafOp",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Writer.create()) {
    if (message.hash !== 0) {
      writer.uint32(8).int32(message.hash);
    }

    if (message.prehashKey !== 0) {
      writer.uint32(16).int32(message.prehashKey);
    }

    if (message.prehashValue !== 0) {
      writer.uint32(24).int32(message.prehashValue);
    }

    if (message.length !== 0) {
      writer.uint32(32).int32(message.length);
    }

    if (message.prefix.length !== 0) {
      writer.uint32(42).bytes(message.prefix);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLeafOp();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.hash = reader.int32();
          break;

        case 2:
          message.prehashKey = reader.int32();
          break;

        case 3:
          message.prehashValue = reader.int32();
          break;

        case 4:
          message.length = reader.int32();
          break;

        case 5:
          message.prefix = reader.bytes();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$hash, _object$prehashKey, _object$prehashValue, _object$length, _object$prefix;

    const message = createBaseLeafOp();
    message.hash = (_object$hash = object.hash) !== null && _object$hash !== void 0 ? _object$hash : 0;
    message.prehashKey = (_object$prehashKey = object.prehashKey) !== null && _object$prehashKey !== void 0 ? _object$prehashKey : 0;
    message.prehashValue = (_object$prehashValue = object.prehashValue) !== null && _object$prehashValue !== void 0 ? _object$prehashValue : 0;
    message.length = (_object$length = object.length) !== null && _object$length !== void 0 ? _object$length : 0;
    message.prefix = (_object$prefix = object.prefix) !== null && _object$prefix !== void 0 ? _object$prefix : new Uint8Array();
    return message;
  },

  fromAmino(object) {
    return {
      hash: (0,_helpers__WEBPACK_IMPORTED_MODULE_1__/* .isSet */ .DM)(object.hash) ? hashOpFromJSON(object.hash) : 0,
      prehashKey: (0,_helpers__WEBPACK_IMPORTED_MODULE_1__/* .isSet */ .DM)(object.prehash_key) ? hashOpFromJSON(object.prehash_key) : 0,
      prehashValue: (0,_helpers__WEBPACK_IMPORTED_MODULE_1__/* .isSet */ .DM)(object.prehash_value) ? hashOpFromJSON(object.prehash_value) : 0,
      length: (0,_helpers__WEBPACK_IMPORTED_MODULE_1__/* .isSet */ .DM)(object.length) ? lengthOpFromJSON(object.length) : 0,
      prefix: object.prefix
    };
  },

  toAmino(message) {
    const obj = {};
    obj.hash = message.hash;
    obj.prehash_key = message.prehashKey;
    obj.prehash_value = message.prehashValue;
    obj.length = message.length;
    obj.prefix = message.prefix;
    return obj;
  },

  fromAminoMsg(object) {
    return LeafOp.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/LeafOp",
      value: LeafOp.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return LeafOp.decode(message.value);
  },

  toProto(message) {
    return LeafOp.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.ics23.v1.LeafOp",
      value: LeafOp.encode(message).finish()
    };
  }

};

function createBaseInnerOp() {
  return {
    hash: 0,
    prefix: new Uint8Array(),
    suffix: new Uint8Array()
  };
}

const InnerOp = {
  typeUrl: "/cosmos.ics23.v1.InnerOp",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Writer.create()) {
    if (message.hash !== 0) {
      writer.uint32(8).int32(message.hash);
    }

    if (message.prefix.length !== 0) {
      writer.uint32(18).bytes(message.prefix);
    }

    if (message.suffix.length !== 0) {
      writer.uint32(26).bytes(message.suffix);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInnerOp();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.hash = reader.int32();
          break;

        case 2:
          message.prefix = reader.bytes();
          break;

        case 3:
          message.suffix = reader.bytes();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$hash2, _object$prefix2, _object$suffix;

    const message = createBaseInnerOp();
    message.hash = (_object$hash2 = object.hash) !== null && _object$hash2 !== void 0 ? _object$hash2 : 0;
    message.prefix = (_object$prefix2 = object.prefix) !== null && _object$prefix2 !== void 0 ? _object$prefix2 : new Uint8Array();
    message.suffix = (_object$suffix = object.suffix) !== null && _object$suffix !== void 0 ? _object$suffix : new Uint8Array();
    return message;
  },

  fromAmino(object) {
    return {
      hash: (0,_helpers__WEBPACK_IMPORTED_MODULE_1__/* .isSet */ .DM)(object.hash) ? hashOpFromJSON(object.hash) : 0,
      prefix: object.prefix,
      suffix: object.suffix
    };
  },

  toAmino(message) {
    const obj = {};
    obj.hash = message.hash;
    obj.prefix = message.prefix;
    obj.suffix = message.suffix;
    return obj;
  },

  fromAminoMsg(object) {
    return InnerOp.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/InnerOp",
      value: InnerOp.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return InnerOp.decode(message.value);
  },

  toProto(message) {
    return InnerOp.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.ics23.v1.InnerOp",
      value: InnerOp.encode(message).finish()
    };
  }

};

function createBaseProofSpec() {
  return {
    leafSpec: undefined,
    innerSpec: undefined,
    maxDepth: 0,
    minDepth: 0
  };
}

const ProofSpec = {
  typeUrl: "/cosmos.ics23.v1.ProofSpec",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Writer.create()) {
    if (message.leafSpec !== undefined) {
      LeafOp.encode(message.leafSpec, writer.uint32(10).fork()).ldelim();
    }

    if (message.innerSpec !== undefined) {
      InnerSpec.encode(message.innerSpec, writer.uint32(18).fork()).ldelim();
    }

    if (message.maxDepth !== 0) {
      writer.uint32(24).int32(message.maxDepth);
    }

    if (message.minDepth !== 0) {
      writer.uint32(32).int32(message.minDepth);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseProofSpec();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.leafSpec = LeafOp.decode(reader, reader.uint32());
          break;

        case 2:
          message.innerSpec = InnerSpec.decode(reader, reader.uint32());
          break;

        case 3:
          message.maxDepth = reader.int32();
          break;

        case 4:
          message.minDepth = reader.int32();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$maxDepth, _object$minDepth;

    const message = createBaseProofSpec();
    message.leafSpec = object.leafSpec !== undefined && object.leafSpec !== null ? LeafOp.fromPartial(object.leafSpec) : undefined;
    message.innerSpec = object.innerSpec !== undefined && object.innerSpec !== null ? InnerSpec.fromPartial(object.innerSpec) : undefined;
    message.maxDepth = (_object$maxDepth = object.maxDepth) !== null && _object$maxDepth !== void 0 ? _object$maxDepth : 0;
    message.minDepth = (_object$minDepth = object.minDepth) !== null && _object$minDepth !== void 0 ? _object$minDepth : 0;
    return message;
  },

  fromAmino(object) {
    return {
      leafSpec: object !== null && object !== void 0 && object.leaf_spec ? LeafOp.fromAmino(object.leaf_spec) : undefined,
      innerSpec: object !== null && object !== void 0 && object.inner_spec ? InnerSpec.fromAmino(object.inner_spec) : undefined,
      maxDepth: object.max_depth,
      minDepth: object.min_depth
    };
  },

  toAmino(message) {
    const obj = {};
    obj.leaf_spec = message.leafSpec ? LeafOp.toAmino(message.leafSpec) : undefined;
    obj.inner_spec = message.innerSpec ? InnerSpec.toAmino(message.innerSpec) : undefined;
    obj.max_depth = message.maxDepth;
    obj.min_depth = message.minDepth;
    return obj;
  },

  fromAminoMsg(object) {
    return ProofSpec.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/ProofSpec",
      value: ProofSpec.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return ProofSpec.decode(message.value);
  },

  toProto(message) {
    return ProofSpec.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.ics23.v1.ProofSpec",
      value: ProofSpec.encode(message).finish()
    };
  }

};

function createBaseInnerSpec() {
  return {
    childOrder: [],
    childSize: 0,
    minPrefixLength: 0,
    maxPrefixLength: 0,
    emptyChild: new Uint8Array(),
    hash: 0
  };
}

const InnerSpec = {
  typeUrl: "/cosmos.ics23.v1.InnerSpec",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Writer.create()) {
    writer.uint32(10).fork();

    for (const v of message.childOrder) {
      writer.int32(v);
    }

    writer.ldelim();

    if (message.childSize !== 0) {
      writer.uint32(16).int32(message.childSize);
    }

    if (message.minPrefixLength !== 0) {
      writer.uint32(24).int32(message.minPrefixLength);
    }

    if (message.maxPrefixLength !== 0) {
      writer.uint32(32).int32(message.maxPrefixLength);
    }

    if (message.emptyChild.length !== 0) {
      writer.uint32(42).bytes(message.emptyChild);
    }

    if (message.hash !== 0) {
      writer.uint32(48).int32(message.hash);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInnerSpec();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          if ((tag & 7) === 2) {
            const end2 = reader.uint32() + reader.pos;

            while (reader.pos < end2) {
              message.childOrder.push(reader.int32());
            }
          } else {
            message.childOrder.push(reader.int32());
          }

          break;

        case 2:
          message.childSize = reader.int32();
          break;

        case 3:
          message.minPrefixLength = reader.int32();
          break;

        case 4:
          message.maxPrefixLength = reader.int32();
          break;

        case 5:
          message.emptyChild = reader.bytes();
          break;

        case 6:
          message.hash = reader.int32();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$childOrder, _object$childSize, _object$minPrefixLeng, _object$maxPrefixLeng, _object$emptyChild, _object$hash3;

    const message = createBaseInnerSpec();
    message.childOrder = ((_object$childOrder = object.childOrder) === null || _object$childOrder === void 0 ? void 0 : _object$childOrder.map(e => e)) || [];
    message.childSize = (_object$childSize = object.childSize) !== null && _object$childSize !== void 0 ? _object$childSize : 0;
    message.minPrefixLength = (_object$minPrefixLeng = object.minPrefixLength) !== null && _object$minPrefixLeng !== void 0 ? _object$minPrefixLeng : 0;
    message.maxPrefixLength = (_object$maxPrefixLeng = object.maxPrefixLength) !== null && _object$maxPrefixLeng !== void 0 ? _object$maxPrefixLeng : 0;
    message.emptyChild = (_object$emptyChild = object.emptyChild) !== null && _object$emptyChild !== void 0 ? _object$emptyChild : new Uint8Array();
    message.hash = (_object$hash3 = object.hash) !== null && _object$hash3 !== void 0 ? _object$hash3 : 0;
    return message;
  },

  fromAmino(object) {
    return {
      childOrder: Array.isArray(object === null || object === void 0 ? void 0 : object.child_order) ? object.child_order.map(e => e) : [],
      childSize: object.child_size,
      minPrefixLength: object.min_prefix_length,
      maxPrefixLength: object.max_prefix_length,
      emptyChild: object.empty_child,
      hash: (0,_helpers__WEBPACK_IMPORTED_MODULE_1__/* .isSet */ .DM)(object.hash) ? hashOpFromJSON(object.hash) : 0
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.childOrder) {
      obj.child_order = message.childOrder.map(e => e);
    } else {
      obj.child_order = [];
    }

    obj.child_size = message.childSize;
    obj.min_prefix_length = message.minPrefixLength;
    obj.max_prefix_length = message.maxPrefixLength;
    obj.empty_child = message.emptyChild;
    obj.hash = message.hash;
    return obj;
  },

  fromAminoMsg(object) {
    return InnerSpec.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/InnerSpec",
      value: InnerSpec.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return InnerSpec.decode(message.value);
  },

  toProto(message) {
    return InnerSpec.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.ics23.v1.InnerSpec",
      value: InnerSpec.encode(message).finish()
    };
  }

};

function createBaseBatchProof() {
  return {
    entries: []
  };
}

const BatchProof = {
  typeUrl: "/cosmos.ics23.v1.BatchProof",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Writer.create()) {
    for (const v of message.entries) {
      BatchEntry.encode(v, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBatchProof();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.entries.push(BatchEntry.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$entries;

    const message = createBaseBatchProof();
    message.entries = ((_object$entries = object.entries) === null || _object$entries === void 0 ? void 0 : _object$entries.map(e => BatchEntry.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      entries: Array.isArray(object === null || object === void 0 ? void 0 : object.entries) ? object.entries.map(e => BatchEntry.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.entries) {
      obj.entries = message.entries.map(e => e ? BatchEntry.toAmino(e) : undefined);
    } else {
      obj.entries = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return BatchProof.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/BatchProof",
      value: BatchProof.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return BatchProof.decode(message.value);
  },

  toProto(message) {
    return BatchProof.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.ics23.v1.BatchProof",
      value: BatchProof.encode(message).finish()
    };
  }

};

function createBaseBatchEntry() {
  return {
    exist: undefined,
    nonexist: undefined
  };
}

const BatchEntry = {
  typeUrl: "/cosmos.ics23.v1.BatchEntry",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Writer.create()) {
    if (message.exist !== undefined) {
      ExistenceProof.encode(message.exist, writer.uint32(10).fork()).ldelim();
    }

    if (message.nonexist !== undefined) {
      NonExistenceProof.encode(message.nonexist, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBatchEntry();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.exist = ExistenceProof.decode(reader, reader.uint32());
          break;

        case 2:
          message.nonexist = NonExistenceProof.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseBatchEntry();
    message.exist = object.exist !== undefined && object.exist !== null ? ExistenceProof.fromPartial(object.exist) : undefined;
    message.nonexist = object.nonexist !== undefined && object.nonexist !== null ? NonExistenceProof.fromPartial(object.nonexist) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      exist: object !== null && object !== void 0 && object.exist ? ExistenceProof.fromAmino(object.exist) : undefined,
      nonexist: object !== null && object !== void 0 && object.nonexist ? NonExistenceProof.fromAmino(object.nonexist) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.exist = message.exist ? ExistenceProof.toAmino(message.exist) : undefined;
    obj.nonexist = message.nonexist ? NonExistenceProof.toAmino(message.nonexist) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return BatchEntry.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/BatchEntry",
      value: BatchEntry.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return BatchEntry.decode(message.value);
  },

  toProto(message) {
    return BatchEntry.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.ics23.v1.BatchEntry",
      value: BatchEntry.encode(message).finish()
    };
  }

};

function createBaseCompressedBatchProof() {
  return {
    entries: [],
    lookupInners: []
  };
}

const CompressedBatchProof = {
  typeUrl: "/cosmos.ics23.v1.CompressedBatchProof",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Writer.create()) {
    for (const v of message.entries) {
      CompressedBatchEntry.encode(v, writer.uint32(10).fork()).ldelim();
    }

    for (const v of message.lookupInners) {
      InnerOp.encode(v, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCompressedBatchProof();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.entries.push(CompressedBatchEntry.decode(reader, reader.uint32()));
          break;

        case 2:
          message.lookupInners.push(InnerOp.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$entries2, _object$lookupInners;

    const message = createBaseCompressedBatchProof();
    message.entries = ((_object$entries2 = object.entries) === null || _object$entries2 === void 0 ? void 0 : _object$entries2.map(e => CompressedBatchEntry.fromPartial(e))) || [];
    message.lookupInners = ((_object$lookupInners = object.lookupInners) === null || _object$lookupInners === void 0 ? void 0 : _object$lookupInners.map(e => InnerOp.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      entries: Array.isArray(object === null || object === void 0 ? void 0 : object.entries) ? object.entries.map(e => CompressedBatchEntry.fromAmino(e)) : [],
      lookupInners: Array.isArray(object === null || object === void 0 ? void 0 : object.lookup_inners) ? object.lookup_inners.map(e => InnerOp.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.entries) {
      obj.entries = message.entries.map(e => e ? CompressedBatchEntry.toAmino(e) : undefined);
    } else {
      obj.entries = [];
    }

    if (message.lookupInners) {
      obj.lookup_inners = message.lookupInners.map(e => e ? InnerOp.toAmino(e) : undefined);
    } else {
      obj.lookup_inners = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return CompressedBatchProof.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/CompressedBatchProof",
      value: CompressedBatchProof.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return CompressedBatchProof.decode(message.value);
  },

  toProto(message) {
    return CompressedBatchProof.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.ics23.v1.CompressedBatchProof",
      value: CompressedBatchProof.encode(message).finish()
    };
  }

};

function createBaseCompressedBatchEntry() {
  return {
    exist: undefined,
    nonexist: undefined
  };
}

const CompressedBatchEntry = {
  typeUrl: "/cosmos.ics23.v1.CompressedBatchEntry",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Writer.create()) {
    if (message.exist !== undefined) {
      CompressedExistenceProof.encode(message.exist, writer.uint32(10).fork()).ldelim();
    }

    if (message.nonexist !== undefined) {
      CompressedNonExistenceProof.encode(message.nonexist, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCompressedBatchEntry();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.exist = CompressedExistenceProof.decode(reader, reader.uint32());
          break;

        case 2:
          message.nonexist = CompressedNonExistenceProof.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseCompressedBatchEntry();
    message.exist = object.exist !== undefined && object.exist !== null ? CompressedExistenceProof.fromPartial(object.exist) : undefined;
    message.nonexist = object.nonexist !== undefined && object.nonexist !== null ? CompressedNonExistenceProof.fromPartial(object.nonexist) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      exist: object !== null && object !== void 0 && object.exist ? CompressedExistenceProof.fromAmino(object.exist) : undefined,
      nonexist: object !== null && object !== void 0 && object.nonexist ? CompressedNonExistenceProof.fromAmino(object.nonexist) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.exist = message.exist ? CompressedExistenceProof.toAmino(message.exist) : undefined;
    obj.nonexist = message.nonexist ? CompressedNonExistenceProof.toAmino(message.nonexist) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return CompressedBatchEntry.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/CompressedBatchEntry",
      value: CompressedBatchEntry.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return CompressedBatchEntry.decode(message.value);
  },

  toProto(message) {
    return CompressedBatchEntry.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.ics23.v1.CompressedBatchEntry",
      value: CompressedBatchEntry.encode(message).finish()
    };
  }

};

function createBaseCompressedExistenceProof() {
  return {
    key: new Uint8Array(),
    value: new Uint8Array(),
    leaf: undefined,
    path: []
  };
}

const CompressedExistenceProof = {
  typeUrl: "/cosmos.ics23.v1.CompressedExistenceProof",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Writer.create()) {
    if (message.key.length !== 0) {
      writer.uint32(10).bytes(message.key);
    }

    if (message.value.length !== 0) {
      writer.uint32(18).bytes(message.value);
    }

    if (message.leaf !== undefined) {
      LeafOp.encode(message.leaf, writer.uint32(26).fork()).ldelim();
    }

    writer.uint32(34).fork();

    for (const v of message.path) {
      writer.int32(v);
    }

    writer.ldelim();
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCompressedExistenceProof();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.key = reader.bytes();
          break;

        case 2:
          message.value = reader.bytes();
          break;

        case 3:
          message.leaf = LeafOp.decode(reader, reader.uint32());
          break;

        case 4:
          if ((tag & 7) === 2) {
            const end2 = reader.uint32() + reader.pos;

            while (reader.pos < end2) {
              message.path.push(reader.int32());
            }
          } else {
            message.path.push(reader.int32());
          }

          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$key3, _object$value2, _object$path2;

    const message = createBaseCompressedExistenceProof();
    message.key = (_object$key3 = object.key) !== null && _object$key3 !== void 0 ? _object$key3 : new Uint8Array();
    message.value = (_object$value2 = object.value) !== null && _object$value2 !== void 0 ? _object$value2 : new Uint8Array();
    message.leaf = object.leaf !== undefined && object.leaf !== null ? LeafOp.fromPartial(object.leaf) : undefined;
    message.path = ((_object$path2 = object.path) === null || _object$path2 === void 0 ? void 0 : _object$path2.map(e => e)) || [];
    return message;
  },

  fromAmino(object) {
    return {
      key: object.key,
      value: object.value,
      leaf: object !== null && object !== void 0 && object.leaf ? LeafOp.fromAmino(object.leaf) : undefined,
      path: Array.isArray(object === null || object === void 0 ? void 0 : object.path) ? object.path.map(e => e) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.key = message.key;
    obj.value = message.value;
    obj.leaf = message.leaf ? LeafOp.toAmino(message.leaf) : undefined;

    if (message.path) {
      obj.path = message.path.map(e => e);
    } else {
      obj.path = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return CompressedExistenceProof.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/CompressedExistenceProof",
      value: CompressedExistenceProof.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return CompressedExistenceProof.decode(message.value);
  },

  toProto(message) {
    return CompressedExistenceProof.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.ics23.v1.CompressedExistenceProof",
      value: CompressedExistenceProof.encode(message).finish()
    };
  }

};

function createBaseCompressedNonExistenceProof() {
  return {
    key: new Uint8Array(),
    left: undefined,
    right: undefined
  };
}

const CompressedNonExistenceProof = {
  typeUrl: "/cosmos.ics23.v1.CompressedNonExistenceProof",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Writer.create()) {
    if (message.key.length !== 0) {
      writer.uint32(10).bytes(message.key);
    }

    if (message.left !== undefined) {
      CompressedExistenceProof.encode(message.left, writer.uint32(18).fork()).ldelim();
    }

    if (message.right !== undefined) {
      CompressedExistenceProof.encode(message.right, writer.uint32(26).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCompressedNonExistenceProof();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.key = reader.bytes();
          break;

        case 2:
          message.left = CompressedExistenceProof.decode(reader, reader.uint32());
          break;

        case 3:
          message.right = CompressedExistenceProof.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$key4;

    const message = createBaseCompressedNonExistenceProof();
    message.key = (_object$key4 = object.key) !== null && _object$key4 !== void 0 ? _object$key4 : new Uint8Array();
    message.left = object.left !== undefined && object.left !== null ? CompressedExistenceProof.fromPartial(object.left) : undefined;
    message.right = object.right !== undefined && object.right !== null ? CompressedExistenceProof.fromPartial(object.right) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      key: object.key,
      left: object !== null && object !== void 0 && object.left ? CompressedExistenceProof.fromAmino(object.left) : undefined,
      right: object !== null && object !== void 0 && object.right ? CompressedExistenceProof.fromAmino(object.right) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.key = message.key;
    obj.left = message.left ? CompressedExistenceProof.toAmino(message.left) : undefined;
    obj.right = message.right ? CompressedExistenceProof.toAmino(message.right) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return CompressedNonExistenceProof.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/CompressedNonExistenceProof",
      value: CompressedNonExistenceProof.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return CompressedNonExistenceProof.decode(message.value);
  },

  toProto(message) {
    return CompressedNonExistenceProof.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.ics23.v1.CompressedNonExistenceProof",
      value: CompressedNonExistenceProof.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 8682:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AuthorizationType": function() { return /* binding */ AuthorizationType; },
/* harmony export */   "AuthorizationTypeAmino": function() { return /* binding */ AuthorizationTypeAmino; },
/* harmony export */   "AuthorizationTypeSDKType": function() { return /* binding */ AuthorizationTypeSDKType; },
/* harmony export */   "StakeAuthorization": function() { return /* binding */ StakeAuthorization; },
/* harmony export */   "StakeAuthorization_Validators": function() { return /* binding */ StakeAuthorization_Validators; },
/* harmony export */   "authorizationTypeFromJSON": function() { return /* binding */ authorizationTypeFromJSON; },
/* harmony export */   "authorizationTypeToJSON": function() { return /* binding */ authorizationTypeToJSON; }
/* harmony export */ });
/* harmony import */ var _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26178);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47895);



/**
 * AuthorizationType defines the type of staking module authorization type
 * 
 * Since: cosmos-sdk 0.43
 */

let AuthorizationType;

(function (AuthorizationType) {
  AuthorizationType[AuthorizationType["AUTHORIZATION_TYPE_UNSPECIFIED"] = 0] = "AUTHORIZATION_TYPE_UNSPECIFIED";
  AuthorizationType[AuthorizationType["AUTHORIZATION_TYPE_DELEGATE"] = 1] = "AUTHORIZATION_TYPE_DELEGATE";
  AuthorizationType[AuthorizationType["AUTHORIZATION_TYPE_UNDELEGATE"] = 2] = "AUTHORIZATION_TYPE_UNDELEGATE";
  AuthorizationType[AuthorizationType["AUTHORIZATION_TYPE_REDELEGATE"] = 3] = "AUTHORIZATION_TYPE_REDELEGATE";
  AuthorizationType[AuthorizationType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(AuthorizationType || (AuthorizationType = {}));

const AuthorizationTypeSDKType = AuthorizationType;
const AuthorizationTypeAmino = AuthorizationType;
function authorizationTypeFromJSON(object) {
  switch (object) {
    case 0:
    case "AUTHORIZATION_TYPE_UNSPECIFIED":
      return AuthorizationType.AUTHORIZATION_TYPE_UNSPECIFIED;

    case 1:
    case "AUTHORIZATION_TYPE_DELEGATE":
      return AuthorizationType.AUTHORIZATION_TYPE_DELEGATE;

    case 2:
    case "AUTHORIZATION_TYPE_UNDELEGATE":
      return AuthorizationType.AUTHORIZATION_TYPE_UNDELEGATE;

    case 3:
    case "AUTHORIZATION_TYPE_REDELEGATE":
      return AuthorizationType.AUTHORIZATION_TYPE_REDELEGATE;

    case -1:
    case "UNRECOGNIZED":
    default:
      return AuthorizationType.UNRECOGNIZED;
  }
}
function authorizationTypeToJSON(object) {
  switch (object) {
    case AuthorizationType.AUTHORIZATION_TYPE_UNSPECIFIED:
      return "AUTHORIZATION_TYPE_UNSPECIFIED";

    case AuthorizationType.AUTHORIZATION_TYPE_DELEGATE:
      return "AUTHORIZATION_TYPE_DELEGATE";

    case AuthorizationType.AUTHORIZATION_TYPE_UNDELEGATE:
      return "AUTHORIZATION_TYPE_UNDELEGATE";

    case AuthorizationType.AUTHORIZATION_TYPE_REDELEGATE:
      return "AUTHORIZATION_TYPE_REDELEGATE";

    case AuthorizationType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
/**
 * StakeAuthorization defines authorization for delegate/undelegate/redelegate.
 * 
 * Since: cosmos-sdk 0.43
 */

function createBaseStakeAuthorization() {
  return {
    $typeUrl: "/cosmos.staking.v1beta1.StakeAuthorization",
    maxTokens: undefined,
    allowList: undefined,
    denyList: undefined,
    authorizationType: 0
  };
}

const StakeAuthorization = {
  typeUrl: "/cosmos.staking.v1beta1.StakeAuthorization",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Writer.create()) {
    if (message.maxTokens !== undefined) {
      _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.encode(message.maxTokens, writer.uint32(10).fork()).ldelim();
    }

    if (message.allowList !== undefined) {
      StakeAuthorization_Validators.encode(message.allowList, writer.uint32(18).fork()).ldelim();
    }

    if (message.denyList !== undefined) {
      StakeAuthorization_Validators.encode(message.denyList, writer.uint32(26).fork()).ldelim();
    }

    if (message.authorizationType !== 0) {
      writer.uint32(32).int32(message.authorizationType);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStakeAuthorization();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.maxTokens = _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.decode(reader, reader.uint32());
          break;

        case 2:
          message.allowList = StakeAuthorization_Validators.decode(reader, reader.uint32());
          break;

        case 3:
          message.denyList = StakeAuthorization_Validators.decode(reader, reader.uint32());
          break;

        case 4:
          message.authorizationType = reader.int32();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$authorization;

    const message = createBaseStakeAuthorization();
    message.maxTokens = object.maxTokens !== undefined && object.maxTokens !== null ? _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.fromPartial(object.maxTokens) : undefined;
    message.allowList = object.allowList !== undefined && object.allowList !== null ? StakeAuthorization_Validators.fromPartial(object.allowList) : undefined;
    message.denyList = object.denyList !== undefined && object.denyList !== null ? StakeAuthorization_Validators.fromPartial(object.denyList) : undefined;
    message.authorizationType = (_object$authorization = object.authorizationType) !== null && _object$authorization !== void 0 ? _object$authorization : 0;
    return message;
  },

  fromAmino(object) {
    return {
      maxTokens: object !== null && object !== void 0 && object.max_tokens ? _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.fromAmino(object.max_tokens) : undefined,
      allowList: object !== null && object !== void 0 && object.allow_list ? StakeAuthorization_Validators.fromAmino(object.allow_list) : undefined,
      denyList: object !== null && object !== void 0 && object.deny_list ? StakeAuthorization_Validators.fromAmino(object.deny_list) : undefined,
      authorizationType: (0,_helpers__WEBPACK_IMPORTED_MODULE_2__/* .isSet */ .DM)(object.authorization_type) ? authorizationTypeFromJSON(object.authorization_type) : 0
    };
  },

  toAmino(message) {
    const obj = {};
    obj.max_tokens = message.maxTokens ? _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.toAmino(message.maxTokens) : undefined;
    obj.allow_list = message.allowList ? StakeAuthorization_Validators.toAmino(message.allowList) : undefined;
    obj.deny_list = message.denyList ? StakeAuthorization_Validators.toAmino(message.denyList) : undefined;
    obj.authorization_type = message.authorizationType;
    return obj;
  },

  fromAminoMsg(object) {
    return StakeAuthorization.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/StakeAuthorization",
      value: StakeAuthorization.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return StakeAuthorization.decode(message.value);
  },

  toProto(message) {
    return StakeAuthorization.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.StakeAuthorization",
      value: StakeAuthorization.encode(message).finish()
    };
  }

};

function createBaseStakeAuthorization_Validators() {
  return {
    address: []
  };
}

const StakeAuthorization_Validators = {
  typeUrl: "/cosmos.staking.v1beta1.Validators",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Writer.create()) {
    for (const v of message.address) {
      writer.uint32(10).string(v);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStakeAuthorization_Validators();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.address.push(reader.string());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$address;

    const message = createBaseStakeAuthorization_Validators();
    message.address = ((_object$address = object.address) === null || _object$address === void 0 ? void 0 : _object$address.map(e => e)) || [];
    return message;
  },

  fromAmino(object) {
    return {
      address: Array.isArray(object === null || object === void 0 ? void 0 : object.address) ? object.address.map(e => e) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.address) {
      obj.address = message.address.map(e => e);
    } else {
      obj.address = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return StakeAuthorization_Validators.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/Validators",
      value: StakeAuthorization_Validators.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return StakeAuthorization_Validators.decode(message.value);
  },

  toProto(message) {
    return StakeAuthorization_Validators.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.Validators",
      value: StakeAuthorization_Validators.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 75317:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QueryDelegationRequest": function() { return /* binding */ QueryDelegationRequest; },
/* harmony export */   "QueryDelegationResponse": function() { return /* binding */ QueryDelegationResponse; },
/* harmony export */   "QueryDelegatorDelegationsRequest": function() { return /* binding */ QueryDelegatorDelegationsRequest; },
/* harmony export */   "QueryDelegatorDelegationsResponse": function() { return /* binding */ QueryDelegatorDelegationsResponse; },
/* harmony export */   "QueryDelegatorUnbondingDelegationsRequest": function() { return /* binding */ QueryDelegatorUnbondingDelegationsRequest; },
/* harmony export */   "QueryDelegatorUnbondingDelegationsResponse": function() { return /* binding */ QueryDelegatorUnbondingDelegationsResponse; },
/* harmony export */   "QueryDelegatorValidatorRequest": function() { return /* binding */ QueryDelegatorValidatorRequest; },
/* harmony export */   "QueryDelegatorValidatorResponse": function() { return /* binding */ QueryDelegatorValidatorResponse; },
/* harmony export */   "QueryDelegatorValidatorsRequest": function() { return /* binding */ QueryDelegatorValidatorsRequest; },
/* harmony export */   "QueryDelegatorValidatorsResponse": function() { return /* binding */ QueryDelegatorValidatorsResponse; },
/* harmony export */   "QueryHistoricalInfoRequest": function() { return /* binding */ QueryHistoricalInfoRequest; },
/* harmony export */   "QueryHistoricalInfoResponse": function() { return /* binding */ QueryHistoricalInfoResponse; },
/* harmony export */   "QueryParamsRequest": function() { return /* binding */ QueryParamsRequest; },
/* harmony export */   "QueryParamsResponse": function() { return /* binding */ QueryParamsResponse; },
/* harmony export */   "QueryPoolRequest": function() { return /* binding */ QueryPoolRequest; },
/* harmony export */   "QueryPoolResponse": function() { return /* binding */ QueryPoolResponse; },
/* harmony export */   "QueryRedelegationsRequest": function() { return /* binding */ QueryRedelegationsRequest; },
/* harmony export */   "QueryRedelegationsResponse": function() { return /* binding */ QueryRedelegationsResponse; },
/* harmony export */   "QueryUnbondingDelegationRequest": function() { return /* binding */ QueryUnbondingDelegationRequest; },
/* harmony export */   "QueryUnbondingDelegationResponse": function() { return /* binding */ QueryUnbondingDelegationResponse; },
/* harmony export */   "QueryValidatorDelegationsRequest": function() { return /* binding */ QueryValidatorDelegationsRequest; },
/* harmony export */   "QueryValidatorDelegationsResponse": function() { return /* binding */ QueryValidatorDelegationsResponse; },
/* harmony export */   "QueryValidatorRequest": function() { return /* binding */ QueryValidatorRequest; },
/* harmony export */   "QueryValidatorResponse": function() { return /* binding */ QueryValidatorResponse; },
/* harmony export */   "QueryValidatorUnbondingDelegationsRequest": function() { return /* binding */ QueryValidatorUnbondingDelegationsRequest; },
/* harmony export */   "QueryValidatorUnbondingDelegationsResponse": function() { return /* binding */ QueryValidatorUnbondingDelegationsResponse; },
/* harmony export */   "QueryValidatorsRequest": function() { return /* binding */ QueryValidatorsRequest; },
/* harmony export */   "QueryValidatorsResponse": function() { return /* binding */ QueryValidatorsResponse; }
/* harmony export */ });
/* harmony import */ var _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48978);
/* harmony import */ var _staking__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56959);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47895);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__);




/** QueryValidatorsRequest is request type for Query/Validators RPC method. */

function createBaseQueryValidatorsRequest() {
  return {
    status: "",
    pagination: undefined
  };
}

const QueryValidatorsRequest = {
  typeUrl: "/cosmos.staking.v1beta1.QueryValidatorsRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.status !== "") {
      writer.uint32(10).string(message.status);
    }

    if (message.pagination !== undefined) {
      _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryValidatorsRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.status = reader.string();
          break;

        case 2:
          message.pagination = _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$status;

    const message = createBaseQueryValidatorsRequest();
    message.status = (_object$status = object.status) !== null && _object$status !== void 0 ? _object$status : "";
    message.pagination = object.pagination !== undefined && object.pagination !== null ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.fromPartial(object.pagination) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      status: object.status,
      pagination: object !== null && object !== void 0 && object.pagination ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.fromAmino(object.pagination) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.status = message.status;
    obj.pagination = message.pagination ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.toAmino(message.pagination) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryValidatorsRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryValidatorsRequest",
      value: QueryValidatorsRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryValidatorsRequest.decode(message.value);
  },

  toProto(message) {
    return QueryValidatorsRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.QueryValidatorsRequest",
      value: QueryValidatorsRequest.encode(message).finish()
    };
  }

};

function createBaseQueryValidatorsResponse() {
  return {
    validators: [],
    pagination: undefined
  };
}

const QueryValidatorsResponse = {
  typeUrl: "/cosmos.staking.v1beta1.QueryValidatorsResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    for (const v of message.validators) {
      _staking__WEBPACK_IMPORTED_MODULE_1__.Validator.encode(v, writer.uint32(10).fork()).ldelim();
    }

    if (message.pagination !== undefined) {
      _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryValidatorsResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.validators.push(_staking__WEBPACK_IMPORTED_MODULE_1__.Validator.decode(reader, reader.uint32()));
          break;

        case 2:
          message.pagination = _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$validators;

    const message = createBaseQueryValidatorsResponse();
    message.validators = ((_object$validators = object.validators) === null || _object$validators === void 0 ? void 0 : _object$validators.map(e => _staking__WEBPACK_IMPORTED_MODULE_1__.Validator.fromPartial(e))) || [];
    message.pagination = object.pagination !== undefined && object.pagination !== null ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.fromPartial(object.pagination) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      validators: Array.isArray(object === null || object === void 0 ? void 0 : object.validators) ? object.validators.map(e => _staking__WEBPACK_IMPORTED_MODULE_1__.Validator.fromAmino(e)) : [],
      pagination: object !== null && object !== void 0 && object.pagination ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.fromAmino(object.pagination) : undefined
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.validators) {
      obj.validators = message.validators.map(e => e ? _staking__WEBPACK_IMPORTED_MODULE_1__.Validator.toAmino(e) : undefined);
    } else {
      obj.validators = [];
    }

    obj.pagination = message.pagination ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.toAmino(message.pagination) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryValidatorsResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryValidatorsResponse",
      value: QueryValidatorsResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryValidatorsResponse.decode(message.value);
  },

  toProto(message) {
    return QueryValidatorsResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.QueryValidatorsResponse",
      value: QueryValidatorsResponse.encode(message).finish()
    };
  }

};

function createBaseQueryValidatorRequest() {
  return {
    validatorAddr: ""
  };
}

const QueryValidatorRequest = {
  typeUrl: "/cosmos.staking.v1beta1.QueryValidatorRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.validatorAddr !== "") {
      writer.uint32(10).string(message.validatorAddr);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryValidatorRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.validatorAddr = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$validatorAddr;

    const message = createBaseQueryValidatorRequest();
    message.validatorAddr = (_object$validatorAddr = object.validatorAddr) !== null && _object$validatorAddr !== void 0 ? _object$validatorAddr : "";
    return message;
  },

  fromAmino(object) {
    return {
      validatorAddr: object.validator_addr
    };
  },

  toAmino(message) {
    const obj = {};
    obj.validator_addr = message.validatorAddr;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryValidatorRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryValidatorRequest",
      value: QueryValidatorRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryValidatorRequest.decode(message.value);
  },

  toProto(message) {
    return QueryValidatorRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.QueryValidatorRequest",
      value: QueryValidatorRequest.encode(message).finish()
    };
  }

};

function createBaseQueryValidatorResponse() {
  return {
    validator: undefined
  };
}

const QueryValidatorResponse = {
  typeUrl: "/cosmos.staking.v1beta1.QueryValidatorResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.validator !== undefined) {
      _staking__WEBPACK_IMPORTED_MODULE_1__.Validator.encode(message.validator, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryValidatorResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.validator = _staking__WEBPACK_IMPORTED_MODULE_1__.Validator.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseQueryValidatorResponse();
    message.validator = object.validator !== undefined && object.validator !== null ? _staking__WEBPACK_IMPORTED_MODULE_1__.Validator.fromPartial(object.validator) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      validator: object !== null && object !== void 0 && object.validator ? _staking__WEBPACK_IMPORTED_MODULE_1__.Validator.fromAmino(object.validator) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.validator = message.validator ? _staking__WEBPACK_IMPORTED_MODULE_1__.Validator.toAmino(message.validator) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryValidatorResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryValidatorResponse",
      value: QueryValidatorResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryValidatorResponse.decode(message.value);
  },

  toProto(message) {
    return QueryValidatorResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.QueryValidatorResponse",
      value: QueryValidatorResponse.encode(message).finish()
    };
  }

};

function createBaseQueryValidatorDelegationsRequest() {
  return {
    validatorAddr: "",
    pagination: undefined
  };
}

const QueryValidatorDelegationsRequest = {
  typeUrl: "/cosmos.staking.v1beta1.QueryValidatorDelegationsRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.validatorAddr !== "") {
      writer.uint32(10).string(message.validatorAddr);
    }

    if (message.pagination !== undefined) {
      _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryValidatorDelegationsRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.validatorAddr = reader.string();
          break;

        case 2:
          message.pagination = _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$validatorAddr2;

    const message = createBaseQueryValidatorDelegationsRequest();
    message.validatorAddr = (_object$validatorAddr2 = object.validatorAddr) !== null && _object$validatorAddr2 !== void 0 ? _object$validatorAddr2 : "";
    message.pagination = object.pagination !== undefined && object.pagination !== null ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.fromPartial(object.pagination) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      validatorAddr: object.validator_addr,
      pagination: object !== null && object !== void 0 && object.pagination ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.fromAmino(object.pagination) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.validator_addr = message.validatorAddr;
    obj.pagination = message.pagination ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.toAmino(message.pagination) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryValidatorDelegationsRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryValidatorDelegationsRequest",
      value: QueryValidatorDelegationsRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryValidatorDelegationsRequest.decode(message.value);
  },

  toProto(message) {
    return QueryValidatorDelegationsRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.QueryValidatorDelegationsRequest",
      value: QueryValidatorDelegationsRequest.encode(message).finish()
    };
  }

};

function createBaseQueryValidatorDelegationsResponse() {
  return {
    delegationResponses: [],
    pagination: undefined
  };
}

const QueryValidatorDelegationsResponse = {
  typeUrl: "/cosmos.staking.v1beta1.QueryValidatorDelegationsResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    for (const v of message.delegationResponses) {
      _staking__WEBPACK_IMPORTED_MODULE_1__.DelegationResponse.encode(v, writer.uint32(10).fork()).ldelim();
    }

    if (message.pagination !== undefined) {
      _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryValidatorDelegationsResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.delegationResponses.push(_staking__WEBPACK_IMPORTED_MODULE_1__.DelegationResponse.decode(reader, reader.uint32()));
          break;

        case 2:
          message.pagination = _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$delegationRes;

    const message = createBaseQueryValidatorDelegationsResponse();
    message.delegationResponses = ((_object$delegationRes = object.delegationResponses) === null || _object$delegationRes === void 0 ? void 0 : _object$delegationRes.map(e => _staking__WEBPACK_IMPORTED_MODULE_1__.DelegationResponse.fromPartial(e))) || [];
    message.pagination = object.pagination !== undefined && object.pagination !== null ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.fromPartial(object.pagination) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      delegationResponses: Array.isArray(object === null || object === void 0 ? void 0 : object.delegation_responses) ? object.delegation_responses.map(e => _staking__WEBPACK_IMPORTED_MODULE_1__.DelegationResponse.fromAmino(e)) : [],
      pagination: object !== null && object !== void 0 && object.pagination ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.fromAmino(object.pagination) : undefined
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.delegationResponses) {
      obj.delegation_responses = message.delegationResponses.map(e => e ? _staking__WEBPACK_IMPORTED_MODULE_1__.DelegationResponse.toAmino(e) : undefined);
    } else {
      obj.delegation_responses = [];
    }

    obj.pagination = message.pagination ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.toAmino(message.pagination) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryValidatorDelegationsResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryValidatorDelegationsResponse",
      value: QueryValidatorDelegationsResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryValidatorDelegationsResponse.decode(message.value);
  },

  toProto(message) {
    return QueryValidatorDelegationsResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.QueryValidatorDelegationsResponse",
      value: QueryValidatorDelegationsResponse.encode(message).finish()
    };
  }

};

function createBaseQueryValidatorUnbondingDelegationsRequest() {
  return {
    validatorAddr: "",
    pagination: undefined
  };
}

const QueryValidatorUnbondingDelegationsRequest = {
  typeUrl: "/cosmos.staking.v1beta1.QueryValidatorUnbondingDelegationsRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.validatorAddr !== "") {
      writer.uint32(10).string(message.validatorAddr);
    }

    if (message.pagination !== undefined) {
      _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryValidatorUnbondingDelegationsRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.validatorAddr = reader.string();
          break;

        case 2:
          message.pagination = _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$validatorAddr3;

    const message = createBaseQueryValidatorUnbondingDelegationsRequest();
    message.validatorAddr = (_object$validatorAddr3 = object.validatorAddr) !== null && _object$validatorAddr3 !== void 0 ? _object$validatorAddr3 : "";
    message.pagination = object.pagination !== undefined && object.pagination !== null ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.fromPartial(object.pagination) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      validatorAddr: object.validator_addr,
      pagination: object !== null && object !== void 0 && object.pagination ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.fromAmino(object.pagination) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.validator_addr = message.validatorAddr;
    obj.pagination = message.pagination ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.toAmino(message.pagination) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryValidatorUnbondingDelegationsRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryValidatorUnbondingDelegationsRequest",
      value: QueryValidatorUnbondingDelegationsRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryValidatorUnbondingDelegationsRequest.decode(message.value);
  },

  toProto(message) {
    return QueryValidatorUnbondingDelegationsRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.QueryValidatorUnbondingDelegationsRequest",
      value: QueryValidatorUnbondingDelegationsRequest.encode(message).finish()
    };
  }

};

function createBaseQueryValidatorUnbondingDelegationsResponse() {
  return {
    unbondingResponses: [],
    pagination: undefined
  };
}

const QueryValidatorUnbondingDelegationsResponse = {
  typeUrl: "/cosmos.staking.v1beta1.QueryValidatorUnbondingDelegationsResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    for (const v of message.unbondingResponses) {
      _staking__WEBPACK_IMPORTED_MODULE_1__.UnbondingDelegation.encode(v, writer.uint32(10).fork()).ldelim();
    }

    if (message.pagination !== undefined) {
      _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryValidatorUnbondingDelegationsResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.unbondingResponses.push(_staking__WEBPACK_IMPORTED_MODULE_1__.UnbondingDelegation.decode(reader, reader.uint32()));
          break;

        case 2:
          message.pagination = _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$unbondingResp;

    const message = createBaseQueryValidatorUnbondingDelegationsResponse();
    message.unbondingResponses = ((_object$unbondingResp = object.unbondingResponses) === null || _object$unbondingResp === void 0 ? void 0 : _object$unbondingResp.map(e => _staking__WEBPACK_IMPORTED_MODULE_1__.UnbondingDelegation.fromPartial(e))) || [];
    message.pagination = object.pagination !== undefined && object.pagination !== null ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.fromPartial(object.pagination) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      unbondingResponses: Array.isArray(object === null || object === void 0 ? void 0 : object.unbonding_responses) ? object.unbonding_responses.map(e => _staking__WEBPACK_IMPORTED_MODULE_1__.UnbondingDelegation.fromAmino(e)) : [],
      pagination: object !== null && object !== void 0 && object.pagination ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.fromAmino(object.pagination) : undefined
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.unbondingResponses) {
      obj.unbonding_responses = message.unbondingResponses.map(e => e ? _staking__WEBPACK_IMPORTED_MODULE_1__.UnbondingDelegation.toAmino(e) : undefined);
    } else {
      obj.unbonding_responses = [];
    }

    obj.pagination = message.pagination ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.toAmino(message.pagination) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryValidatorUnbondingDelegationsResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryValidatorUnbondingDelegationsResponse",
      value: QueryValidatorUnbondingDelegationsResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryValidatorUnbondingDelegationsResponse.decode(message.value);
  },

  toProto(message) {
    return QueryValidatorUnbondingDelegationsResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.QueryValidatorUnbondingDelegationsResponse",
      value: QueryValidatorUnbondingDelegationsResponse.encode(message).finish()
    };
  }

};

function createBaseQueryDelegationRequest() {
  return {
    delegatorAddr: "",
    validatorAddr: ""
  };
}

const QueryDelegationRequest = {
  typeUrl: "/cosmos.staking.v1beta1.QueryDelegationRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.delegatorAddr !== "") {
      writer.uint32(10).string(message.delegatorAddr);
    }

    if (message.validatorAddr !== "") {
      writer.uint32(18).string(message.validatorAddr);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryDelegationRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.delegatorAddr = reader.string();
          break;

        case 2:
          message.validatorAddr = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$delegatorAddr, _object$validatorAddr4;

    const message = createBaseQueryDelegationRequest();
    message.delegatorAddr = (_object$delegatorAddr = object.delegatorAddr) !== null && _object$delegatorAddr !== void 0 ? _object$delegatorAddr : "";
    message.validatorAddr = (_object$validatorAddr4 = object.validatorAddr) !== null && _object$validatorAddr4 !== void 0 ? _object$validatorAddr4 : "";
    return message;
  },

  fromAmino(object) {
    return {
      delegatorAddr: object.delegator_addr,
      validatorAddr: object.validator_addr
    };
  },

  toAmino(message) {
    const obj = {};
    obj.delegator_addr = message.delegatorAddr;
    obj.validator_addr = message.validatorAddr;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryDelegationRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryDelegationRequest",
      value: QueryDelegationRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryDelegationRequest.decode(message.value);
  },

  toProto(message) {
    return QueryDelegationRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.QueryDelegationRequest",
      value: QueryDelegationRequest.encode(message).finish()
    };
  }

};

function createBaseQueryDelegationResponse() {
  return {
    delegationResponse: undefined
  };
}

const QueryDelegationResponse = {
  typeUrl: "/cosmos.staking.v1beta1.QueryDelegationResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.delegationResponse !== undefined) {
      _staking__WEBPACK_IMPORTED_MODULE_1__.DelegationResponse.encode(message.delegationResponse, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryDelegationResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.delegationResponse = _staking__WEBPACK_IMPORTED_MODULE_1__.DelegationResponse.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseQueryDelegationResponse();
    message.delegationResponse = object.delegationResponse !== undefined && object.delegationResponse !== null ? _staking__WEBPACK_IMPORTED_MODULE_1__.DelegationResponse.fromPartial(object.delegationResponse) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      delegationResponse: object !== null && object !== void 0 && object.delegation_response ? _staking__WEBPACK_IMPORTED_MODULE_1__.DelegationResponse.fromAmino(object.delegation_response) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.delegation_response = message.delegationResponse ? _staking__WEBPACK_IMPORTED_MODULE_1__.DelegationResponse.toAmino(message.delegationResponse) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryDelegationResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryDelegationResponse",
      value: QueryDelegationResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryDelegationResponse.decode(message.value);
  },

  toProto(message) {
    return QueryDelegationResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.QueryDelegationResponse",
      value: QueryDelegationResponse.encode(message).finish()
    };
  }

};

function createBaseQueryUnbondingDelegationRequest() {
  return {
    delegatorAddr: "",
    validatorAddr: ""
  };
}

const QueryUnbondingDelegationRequest = {
  typeUrl: "/cosmos.staking.v1beta1.QueryUnbondingDelegationRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.delegatorAddr !== "") {
      writer.uint32(10).string(message.delegatorAddr);
    }

    if (message.validatorAddr !== "") {
      writer.uint32(18).string(message.validatorAddr);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryUnbondingDelegationRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.delegatorAddr = reader.string();
          break;

        case 2:
          message.validatorAddr = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$delegatorAddr2, _object$validatorAddr5;

    const message = createBaseQueryUnbondingDelegationRequest();
    message.delegatorAddr = (_object$delegatorAddr2 = object.delegatorAddr) !== null && _object$delegatorAddr2 !== void 0 ? _object$delegatorAddr2 : "";
    message.validatorAddr = (_object$validatorAddr5 = object.validatorAddr) !== null && _object$validatorAddr5 !== void 0 ? _object$validatorAddr5 : "";
    return message;
  },

  fromAmino(object) {
    return {
      delegatorAddr: object.delegator_addr,
      validatorAddr: object.validator_addr
    };
  },

  toAmino(message) {
    const obj = {};
    obj.delegator_addr = message.delegatorAddr;
    obj.validator_addr = message.validatorAddr;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryUnbondingDelegationRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryUnbondingDelegationRequest",
      value: QueryUnbondingDelegationRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryUnbondingDelegationRequest.decode(message.value);
  },

  toProto(message) {
    return QueryUnbondingDelegationRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.QueryUnbondingDelegationRequest",
      value: QueryUnbondingDelegationRequest.encode(message).finish()
    };
  }

};

function createBaseQueryUnbondingDelegationResponse() {
  return {
    unbond: undefined
  };
}

const QueryUnbondingDelegationResponse = {
  typeUrl: "/cosmos.staking.v1beta1.QueryUnbondingDelegationResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.unbond !== undefined) {
      _staking__WEBPACK_IMPORTED_MODULE_1__.UnbondingDelegation.encode(message.unbond, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryUnbondingDelegationResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.unbond = _staking__WEBPACK_IMPORTED_MODULE_1__.UnbondingDelegation.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseQueryUnbondingDelegationResponse();
    message.unbond = object.unbond !== undefined && object.unbond !== null ? _staking__WEBPACK_IMPORTED_MODULE_1__.UnbondingDelegation.fromPartial(object.unbond) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      unbond: object !== null && object !== void 0 && object.unbond ? _staking__WEBPACK_IMPORTED_MODULE_1__.UnbondingDelegation.fromAmino(object.unbond) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.unbond = message.unbond ? _staking__WEBPACK_IMPORTED_MODULE_1__.UnbondingDelegation.toAmino(message.unbond) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryUnbondingDelegationResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryUnbondingDelegationResponse",
      value: QueryUnbondingDelegationResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryUnbondingDelegationResponse.decode(message.value);
  },

  toProto(message) {
    return QueryUnbondingDelegationResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.QueryUnbondingDelegationResponse",
      value: QueryUnbondingDelegationResponse.encode(message).finish()
    };
  }

};

function createBaseQueryDelegatorDelegationsRequest() {
  return {
    delegatorAddr: "",
    pagination: undefined
  };
}

const QueryDelegatorDelegationsRequest = {
  typeUrl: "/cosmos.staking.v1beta1.QueryDelegatorDelegationsRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.delegatorAddr !== "") {
      writer.uint32(10).string(message.delegatorAddr);
    }

    if (message.pagination !== undefined) {
      _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryDelegatorDelegationsRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.delegatorAddr = reader.string();
          break;

        case 2:
          message.pagination = _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$delegatorAddr3;

    const message = createBaseQueryDelegatorDelegationsRequest();
    message.delegatorAddr = (_object$delegatorAddr3 = object.delegatorAddr) !== null && _object$delegatorAddr3 !== void 0 ? _object$delegatorAddr3 : "";
    message.pagination = object.pagination !== undefined && object.pagination !== null ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.fromPartial(object.pagination) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      delegatorAddr: object.delegator_addr,
      pagination: object !== null && object !== void 0 && object.pagination ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.fromAmino(object.pagination) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.delegator_addr = message.delegatorAddr;
    obj.pagination = message.pagination ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.toAmino(message.pagination) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryDelegatorDelegationsRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryDelegatorDelegationsRequest",
      value: QueryDelegatorDelegationsRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryDelegatorDelegationsRequest.decode(message.value);
  },

  toProto(message) {
    return QueryDelegatorDelegationsRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.QueryDelegatorDelegationsRequest",
      value: QueryDelegatorDelegationsRequest.encode(message).finish()
    };
  }

};

function createBaseQueryDelegatorDelegationsResponse() {
  return {
    delegationResponses: [],
    pagination: undefined
  };
}

const QueryDelegatorDelegationsResponse = {
  typeUrl: "/cosmos.staking.v1beta1.QueryDelegatorDelegationsResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    for (const v of message.delegationResponses) {
      _staking__WEBPACK_IMPORTED_MODULE_1__.DelegationResponse.encode(v, writer.uint32(10).fork()).ldelim();
    }

    if (message.pagination !== undefined) {
      _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryDelegatorDelegationsResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.delegationResponses.push(_staking__WEBPACK_IMPORTED_MODULE_1__.DelegationResponse.decode(reader, reader.uint32()));
          break;

        case 2:
          message.pagination = _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$delegationRes2;

    const message = createBaseQueryDelegatorDelegationsResponse();
    message.delegationResponses = ((_object$delegationRes2 = object.delegationResponses) === null || _object$delegationRes2 === void 0 ? void 0 : _object$delegationRes2.map(e => _staking__WEBPACK_IMPORTED_MODULE_1__.DelegationResponse.fromPartial(e))) || [];
    message.pagination = object.pagination !== undefined && object.pagination !== null ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.fromPartial(object.pagination) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      delegationResponses: Array.isArray(object === null || object === void 0 ? void 0 : object.delegation_responses) ? object.delegation_responses.map(e => _staking__WEBPACK_IMPORTED_MODULE_1__.DelegationResponse.fromAmino(e)) : [],
      pagination: object !== null && object !== void 0 && object.pagination ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.fromAmino(object.pagination) : undefined
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.delegationResponses) {
      obj.delegation_responses = message.delegationResponses.map(e => e ? _staking__WEBPACK_IMPORTED_MODULE_1__.DelegationResponse.toAmino(e) : undefined);
    } else {
      obj.delegation_responses = [];
    }

    obj.pagination = message.pagination ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.toAmino(message.pagination) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryDelegatorDelegationsResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryDelegatorDelegationsResponse",
      value: QueryDelegatorDelegationsResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryDelegatorDelegationsResponse.decode(message.value);
  },

  toProto(message) {
    return QueryDelegatorDelegationsResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.QueryDelegatorDelegationsResponse",
      value: QueryDelegatorDelegationsResponse.encode(message).finish()
    };
  }

};

function createBaseQueryDelegatorUnbondingDelegationsRequest() {
  return {
    delegatorAddr: "",
    pagination: undefined
  };
}

const QueryDelegatorUnbondingDelegationsRequest = {
  typeUrl: "/cosmos.staking.v1beta1.QueryDelegatorUnbondingDelegationsRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.delegatorAddr !== "") {
      writer.uint32(10).string(message.delegatorAddr);
    }

    if (message.pagination !== undefined) {
      _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryDelegatorUnbondingDelegationsRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.delegatorAddr = reader.string();
          break;

        case 2:
          message.pagination = _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$delegatorAddr4;

    const message = createBaseQueryDelegatorUnbondingDelegationsRequest();
    message.delegatorAddr = (_object$delegatorAddr4 = object.delegatorAddr) !== null && _object$delegatorAddr4 !== void 0 ? _object$delegatorAddr4 : "";
    message.pagination = object.pagination !== undefined && object.pagination !== null ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.fromPartial(object.pagination) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      delegatorAddr: object.delegator_addr,
      pagination: object !== null && object !== void 0 && object.pagination ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.fromAmino(object.pagination) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.delegator_addr = message.delegatorAddr;
    obj.pagination = message.pagination ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.toAmino(message.pagination) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryDelegatorUnbondingDelegationsRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryDelegatorUnbondingDelegationsRequest",
      value: QueryDelegatorUnbondingDelegationsRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryDelegatorUnbondingDelegationsRequest.decode(message.value);
  },

  toProto(message) {
    return QueryDelegatorUnbondingDelegationsRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.QueryDelegatorUnbondingDelegationsRequest",
      value: QueryDelegatorUnbondingDelegationsRequest.encode(message).finish()
    };
  }

};

function createBaseQueryDelegatorUnbondingDelegationsResponse() {
  return {
    unbondingResponses: [],
    pagination: undefined
  };
}

const QueryDelegatorUnbondingDelegationsResponse = {
  typeUrl: "/cosmos.staking.v1beta1.QueryDelegatorUnbondingDelegationsResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    for (const v of message.unbondingResponses) {
      _staking__WEBPACK_IMPORTED_MODULE_1__.UnbondingDelegation.encode(v, writer.uint32(10).fork()).ldelim();
    }

    if (message.pagination !== undefined) {
      _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryDelegatorUnbondingDelegationsResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.unbondingResponses.push(_staking__WEBPACK_IMPORTED_MODULE_1__.UnbondingDelegation.decode(reader, reader.uint32()));
          break;

        case 2:
          message.pagination = _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$unbondingResp2;

    const message = createBaseQueryDelegatorUnbondingDelegationsResponse();
    message.unbondingResponses = ((_object$unbondingResp2 = object.unbondingResponses) === null || _object$unbondingResp2 === void 0 ? void 0 : _object$unbondingResp2.map(e => _staking__WEBPACK_IMPORTED_MODULE_1__.UnbondingDelegation.fromPartial(e))) || [];
    message.pagination = object.pagination !== undefined && object.pagination !== null ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.fromPartial(object.pagination) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      unbondingResponses: Array.isArray(object === null || object === void 0 ? void 0 : object.unbonding_responses) ? object.unbonding_responses.map(e => _staking__WEBPACK_IMPORTED_MODULE_1__.UnbondingDelegation.fromAmino(e)) : [],
      pagination: object !== null && object !== void 0 && object.pagination ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.fromAmino(object.pagination) : undefined
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.unbondingResponses) {
      obj.unbonding_responses = message.unbondingResponses.map(e => e ? _staking__WEBPACK_IMPORTED_MODULE_1__.UnbondingDelegation.toAmino(e) : undefined);
    } else {
      obj.unbonding_responses = [];
    }

    obj.pagination = message.pagination ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.toAmino(message.pagination) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryDelegatorUnbondingDelegationsResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryDelegatorUnbondingDelegationsResponse",
      value: QueryDelegatorUnbondingDelegationsResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryDelegatorUnbondingDelegationsResponse.decode(message.value);
  },

  toProto(message) {
    return QueryDelegatorUnbondingDelegationsResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.QueryDelegatorUnbondingDelegationsResponse",
      value: QueryDelegatorUnbondingDelegationsResponse.encode(message).finish()
    };
  }

};

function createBaseQueryRedelegationsRequest() {
  return {
    delegatorAddr: "",
    srcValidatorAddr: "",
    dstValidatorAddr: "",
    pagination: undefined
  };
}

const QueryRedelegationsRequest = {
  typeUrl: "/cosmos.staking.v1beta1.QueryRedelegationsRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.delegatorAddr !== "") {
      writer.uint32(10).string(message.delegatorAddr);
    }

    if (message.srcValidatorAddr !== "") {
      writer.uint32(18).string(message.srcValidatorAddr);
    }

    if (message.dstValidatorAddr !== "") {
      writer.uint32(26).string(message.dstValidatorAddr);
    }

    if (message.pagination !== undefined) {
      _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.encode(message.pagination, writer.uint32(34).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryRedelegationsRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.delegatorAddr = reader.string();
          break;

        case 2:
          message.srcValidatorAddr = reader.string();
          break;

        case 3:
          message.dstValidatorAddr = reader.string();
          break;

        case 4:
          message.pagination = _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$delegatorAddr5, _object$srcValidatorA, _object$dstValidatorA;

    const message = createBaseQueryRedelegationsRequest();
    message.delegatorAddr = (_object$delegatorAddr5 = object.delegatorAddr) !== null && _object$delegatorAddr5 !== void 0 ? _object$delegatorAddr5 : "";
    message.srcValidatorAddr = (_object$srcValidatorA = object.srcValidatorAddr) !== null && _object$srcValidatorA !== void 0 ? _object$srcValidatorA : "";
    message.dstValidatorAddr = (_object$dstValidatorA = object.dstValidatorAddr) !== null && _object$dstValidatorA !== void 0 ? _object$dstValidatorA : "";
    message.pagination = object.pagination !== undefined && object.pagination !== null ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.fromPartial(object.pagination) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      delegatorAddr: object.delegator_addr,
      srcValidatorAddr: object.src_validator_addr,
      dstValidatorAddr: object.dst_validator_addr,
      pagination: object !== null && object !== void 0 && object.pagination ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.fromAmino(object.pagination) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.delegator_addr = message.delegatorAddr;
    obj.src_validator_addr = message.srcValidatorAddr;
    obj.dst_validator_addr = message.dstValidatorAddr;
    obj.pagination = message.pagination ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.toAmino(message.pagination) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryRedelegationsRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryRedelegationsRequest",
      value: QueryRedelegationsRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryRedelegationsRequest.decode(message.value);
  },

  toProto(message) {
    return QueryRedelegationsRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.QueryRedelegationsRequest",
      value: QueryRedelegationsRequest.encode(message).finish()
    };
  }

};

function createBaseQueryRedelegationsResponse() {
  return {
    redelegationResponses: [],
    pagination: undefined
  };
}

const QueryRedelegationsResponse = {
  typeUrl: "/cosmos.staking.v1beta1.QueryRedelegationsResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    for (const v of message.redelegationResponses) {
      _staking__WEBPACK_IMPORTED_MODULE_1__.RedelegationResponse.encode(v, writer.uint32(10).fork()).ldelim();
    }

    if (message.pagination !== undefined) {
      _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryRedelegationsResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.redelegationResponses.push(_staking__WEBPACK_IMPORTED_MODULE_1__.RedelegationResponse.decode(reader, reader.uint32()));
          break;

        case 2:
          message.pagination = _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$redelegationR;

    const message = createBaseQueryRedelegationsResponse();
    message.redelegationResponses = ((_object$redelegationR = object.redelegationResponses) === null || _object$redelegationR === void 0 ? void 0 : _object$redelegationR.map(e => _staking__WEBPACK_IMPORTED_MODULE_1__.RedelegationResponse.fromPartial(e))) || [];
    message.pagination = object.pagination !== undefined && object.pagination !== null ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.fromPartial(object.pagination) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      redelegationResponses: Array.isArray(object === null || object === void 0 ? void 0 : object.redelegation_responses) ? object.redelegation_responses.map(e => _staking__WEBPACK_IMPORTED_MODULE_1__.RedelegationResponse.fromAmino(e)) : [],
      pagination: object !== null && object !== void 0 && object.pagination ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.fromAmino(object.pagination) : undefined
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.redelegationResponses) {
      obj.redelegation_responses = message.redelegationResponses.map(e => e ? _staking__WEBPACK_IMPORTED_MODULE_1__.RedelegationResponse.toAmino(e) : undefined);
    } else {
      obj.redelegation_responses = [];
    }

    obj.pagination = message.pagination ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.toAmino(message.pagination) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryRedelegationsResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryRedelegationsResponse",
      value: QueryRedelegationsResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryRedelegationsResponse.decode(message.value);
  },

  toProto(message) {
    return QueryRedelegationsResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.QueryRedelegationsResponse",
      value: QueryRedelegationsResponse.encode(message).finish()
    };
  }

};

function createBaseQueryDelegatorValidatorsRequest() {
  return {
    delegatorAddr: "",
    pagination: undefined
  };
}

const QueryDelegatorValidatorsRequest = {
  typeUrl: "/cosmos.staking.v1beta1.QueryDelegatorValidatorsRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.delegatorAddr !== "") {
      writer.uint32(10).string(message.delegatorAddr);
    }

    if (message.pagination !== undefined) {
      _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryDelegatorValidatorsRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.delegatorAddr = reader.string();
          break;

        case 2:
          message.pagination = _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$delegatorAddr6;

    const message = createBaseQueryDelegatorValidatorsRequest();
    message.delegatorAddr = (_object$delegatorAddr6 = object.delegatorAddr) !== null && _object$delegatorAddr6 !== void 0 ? _object$delegatorAddr6 : "";
    message.pagination = object.pagination !== undefined && object.pagination !== null ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.fromPartial(object.pagination) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      delegatorAddr: object.delegator_addr,
      pagination: object !== null && object !== void 0 && object.pagination ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.fromAmino(object.pagination) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.delegator_addr = message.delegatorAddr;
    obj.pagination = message.pagination ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.toAmino(message.pagination) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryDelegatorValidatorsRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryDelegatorValidatorsRequest",
      value: QueryDelegatorValidatorsRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryDelegatorValidatorsRequest.decode(message.value);
  },

  toProto(message) {
    return QueryDelegatorValidatorsRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.QueryDelegatorValidatorsRequest",
      value: QueryDelegatorValidatorsRequest.encode(message).finish()
    };
  }

};

function createBaseQueryDelegatorValidatorsResponse() {
  return {
    validators: [],
    pagination: undefined
  };
}

const QueryDelegatorValidatorsResponse = {
  typeUrl: "/cosmos.staking.v1beta1.QueryDelegatorValidatorsResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    for (const v of message.validators) {
      _staking__WEBPACK_IMPORTED_MODULE_1__.Validator.encode(v, writer.uint32(10).fork()).ldelim();
    }

    if (message.pagination !== undefined) {
      _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryDelegatorValidatorsResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.validators.push(_staking__WEBPACK_IMPORTED_MODULE_1__.Validator.decode(reader, reader.uint32()));
          break;

        case 2:
          message.pagination = _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$validators2;

    const message = createBaseQueryDelegatorValidatorsResponse();
    message.validators = ((_object$validators2 = object.validators) === null || _object$validators2 === void 0 ? void 0 : _object$validators2.map(e => _staking__WEBPACK_IMPORTED_MODULE_1__.Validator.fromPartial(e))) || [];
    message.pagination = object.pagination !== undefined && object.pagination !== null ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.fromPartial(object.pagination) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      validators: Array.isArray(object === null || object === void 0 ? void 0 : object.validators) ? object.validators.map(e => _staking__WEBPACK_IMPORTED_MODULE_1__.Validator.fromAmino(e)) : [],
      pagination: object !== null && object !== void 0 && object.pagination ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.fromAmino(object.pagination) : undefined
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.validators) {
      obj.validators = message.validators.map(e => e ? _staking__WEBPACK_IMPORTED_MODULE_1__.Validator.toAmino(e) : undefined);
    } else {
      obj.validators = [];
    }

    obj.pagination = message.pagination ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.toAmino(message.pagination) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryDelegatorValidatorsResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryDelegatorValidatorsResponse",
      value: QueryDelegatorValidatorsResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryDelegatorValidatorsResponse.decode(message.value);
  },

  toProto(message) {
    return QueryDelegatorValidatorsResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.QueryDelegatorValidatorsResponse",
      value: QueryDelegatorValidatorsResponse.encode(message).finish()
    };
  }

};

function createBaseQueryDelegatorValidatorRequest() {
  return {
    delegatorAddr: "",
    validatorAddr: ""
  };
}

const QueryDelegatorValidatorRequest = {
  typeUrl: "/cosmos.staking.v1beta1.QueryDelegatorValidatorRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.delegatorAddr !== "") {
      writer.uint32(10).string(message.delegatorAddr);
    }

    if (message.validatorAddr !== "") {
      writer.uint32(18).string(message.validatorAddr);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryDelegatorValidatorRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.delegatorAddr = reader.string();
          break;

        case 2:
          message.validatorAddr = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$delegatorAddr7, _object$validatorAddr6;

    const message = createBaseQueryDelegatorValidatorRequest();
    message.delegatorAddr = (_object$delegatorAddr7 = object.delegatorAddr) !== null && _object$delegatorAddr7 !== void 0 ? _object$delegatorAddr7 : "";
    message.validatorAddr = (_object$validatorAddr6 = object.validatorAddr) !== null && _object$validatorAddr6 !== void 0 ? _object$validatorAddr6 : "";
    return message;
  },

  fromAmino(object) {
    return {
      delegatorAddr: object.delegator_addr,
      validatorAddr: object.validator_addr
    };
  },

  toAmino(message) {
    const obj = {};
    obj.delegator_addr = message.delegatorAddr;
    obj.validator_addr = message.validatorAddr;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryDelegatorValidatorRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryDelegatorValidatorRequest",
      value: QueryDelegatorValidatorRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryDelegatorValidatorRequest.decode(message.value);
  },

  toProto(message) {
    return QueryDelegatorValidatorRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.QueryDelegatorValidatorRequest",
      value: QueryDelegatorValidatorRequest.encode(message).finish()
    };
  }

};

function createBaseQueryDelegatorValidatorResponse() {
  return {
    validator: undefined
  };
}

const QueryDelegatorValidatorResponse = {
  typeUrl: "/cosmos.staking.v1beta1.QueryDelegatorValidatorResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.validator !== undefined) {
      _staking__WEBPACK_IMPORTED_MODULE_1__.Validator.encode(message.validator, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryDelegatorValidatorResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.validator = _staking__WEBPACK_IMPORTED_MODULE_1__.Validator.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseQueryDelegatorValidatorResponse();
    message.validator = object.validator !== undefined && object.validator !== null ? _staking__WEBPACK_IMPORTED_MODULE_1__.Validator.fromPartial(object.validator) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      validator: object !== null && object !== void 0 && object.validator ? _staking__WEBPACK_IMPORTED_MODULE_1__.Validator.fromAmino(object.validator) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.validator = message.validator ? _staking__WEBPACK_IMPORTED_MODULE_1__.Validator.toAmino(message.validator) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryDelegatorValidatorResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryDelegatorValidatorResponse",
      value: QueryDelegatorValidatorResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryDelegatorValidatorResponse.decode(message.value);
  },

  toProto(message) {
    return QueryDelegatorValidatorResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.QueryDelegatorValidatorResponse",
      value: QueryDelegatorValidatorResponse.encode(message).finish()
    };
  }

};

function createBaseQueryHistoricalInfoRequest() {
  return {
    height: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.ZERO */ .dK.ZERO
  };
}

const QueryHistoricalInfoRequest = {
  typeUrl: "/cosmos.staking.v1beta1.QueryHistoricalInfoRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (!message.height.isZero()) {
      writer.uint32(8).int64(message.height);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryHistoricalInfoRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.height = reader.int64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseQueryHistoricalInfoRequest();
    message.height = object.height !== undefined && object.height !== null ? _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromValue */ .dK.fromValue(object.height) : _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.ZERO */ .dK.ZERO;
    return message;
  },

  fromAmino(object) {
    return {
      height: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromString */ .dK.fromString(object.height)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.height = message.height ? message.height.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryHistoricalInfoRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryHistoricalInfoRequest",
      value: QueryHistoricalInfoRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryHistoricalInfoRequest.decode(message.value);
  },

  toProto(message) {
    return QueryHistoricalInfoRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.QueryHistoricalInfoRequest",
      value: QueryHistoricalInfoRequest.encode(message).finish()
    };
  }

};

function createBaseQueryHistoricalInfoResponse() {
  return {
    hist: undefined
  };
}

const QueryHistoricalInfoResponse = {
  typeUrl: "/cosmos.staking.v1beta1.QueryHistoricalInfoResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.hist !== undefined) {
      _staking__WEBPACK_IMPORTED_MODULE_1__.HistoricalInfo.encode(message.hist, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryHistoricalInfoResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.hist = _staking__WEBPACK_IMPORTED_MODULE_1__.HistoricalInfo.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseQueryHistoricalInfoResponse();
    message.hist = object.hist !== undefined && object.hist !== null ? _staking__WEBPACK_IMPORTED_MODULE_1__.HistoricalInfo.fromPartial(object.hist) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      hist: object !== null && object !== void 0 && object.hist ? _staking__WEBPACK_IMPORTED_MODULE_1__.HistoricalInfo.fromAmino(object.hist) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.hist = message.hist ? _staking__WEBPACK_IMPORTED_MODULE_1__.HistoricalInfo.toAmino(message.hist) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryHistoricalInfoResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryHistoricalInfoResponse",
      value: QueryHistoricalInfoResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryHistoricalInfoResponse.decode(message.value);
  },

  toProto(message) {
    return QueryHistoricalInfoResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.QueryHistoricalInfoResponse",
      value: QueryHistoricalInfoResponse.encode(message).finish()
    };
  }

};

function createBaseQueryPoolRequest() {
  return {};
}

const QueryPoolRequest = {
  typeUrl: "/cosmos.staking.v1beta1.QueryPoolRequest",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryPoolRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseQueryPoolRequest();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return QueryPoolRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryPoolRequest",
      value: QueryPoolRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryPoolRequest.decode(message.value);
  },

  toProto(message) {
    return QueryPoolRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.QueryPoolRequest",
      value: QueryPoolRequest.encode(message).finish()
    };
  }

};

function createBaseQueryPoolResponse() {
  return {
    pool: undefined
  };
}

const QueryPoolResponse = {
  typeUrl: "/cosmos.staking.v1beta1.QueryPoolResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.pool !== undefined) {
      _staking__WEBPACK_IMPORTED_MODULE_1__.Pool.encode(message.pool, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryPoolResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.pool = _staking__WEBPACK_IMPORTED_MODULE_1__.Pool.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseQueryPoolResponse();
    message.pool = object.pool !== undefined && object.pool !== null ? _staking__WEBPACK_IMPORTED_MODULE_1__.Pool.fromPartial(object.pool) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      pool: object !== null && object !== void 0 && object.pool ? _staking__WEBPACK_IMPORTED_MODULE_1__.Pool.fromAmino(object.pool) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.pool = message.pool ? _staking__WEBPACK_IMPORTED_MODULE_1__.Pool.toAmino(message.pool) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryPoolResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryPoolResponse",
      value: QueryPoolResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryPoolResponse.decode(message.value);
  },

  toProto(message) {
    return QueryPoolResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.QueryPoolResponse",
      value: QueryPoolResponse.encode(message).finish()
    };
  }

};

function createBaseQueryParamsRequest() {
  return {};
}

const QueryParamsRequest = {
  typeUrl: "/cosmos.staking.v1beta1.QueryParamsRequest",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryParamsRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseQueryParamsRequest();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return QueryParamsRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryParamsRequest",
      value: QueryParamsRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryParamsRequest.decode(message.value);
  },

  toProto(message) {
    return QueryParamsRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.QueryParamsRequest",
      value: QueryParamsRequest.encode(message).finish()
    };
  }

};

function createBaseQueryParamsResponse() {
  return {
    params: undefined
  };
}

const QueryParamsResponse = {
  typeUrl: "/cosmos.staking.v1beta1.QueryParamsResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.params !== undefined) {
      _staking__WEBPACK_IMPORTED_MODULE_1__.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryParamsResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.params = _staking__WEBPACK_IMPORTED_MODULE_1__.Params.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseQueryParamsResponse();
    message.params = object.params !== undefined && object.params !== null ? _staking__WEBPACK_IMPORTED_MODULE_1__.Params.fromPartial(object.params) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      params: object !== null && object !== void 0 && object.params ? _staking__WEBPACK_IMPORTED_MODULE_1__.Params.fromAmino(object.params) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.params = message.params ? _staking__WEBPACK_IMPORTED_MODULE_1__.Params.toAmino(message.params) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryParamsResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryParamsResponse",
      value: QueryParamsResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryParamsResponse.decode(message.value);
  },

  toProto(message) {
    return QueryParamsResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.QueryParamsResponse",
      value: QueryParamsResponse.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 24800:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LCDQueryClient": function() { return /* binding */ LCDQueryClient; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4942);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47895);


class LCDQueryClient {
  constructor({
    requestClient
  }) {
    (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, "req", void 0);

    this.req = requestClient;
    this.validators = this.validators.bind(this);
    this.validator = this.validator.bind(this);
    this.validatorDelegations = this.validatorDelegations.bind(this);
    this.validatorUnbondingDelegations = this.validatorUnbondingDelegations.bind(this);
    this.delegation = this.delegation.bind(this);
    this.unbondingDelegation = this.unbondingDelegation.bind(this);
    this.delegatorDelegations = this.delegatorDelegations.bind(this);
    this.delegatorUnbondingDelegations = this.delegatorUnbondingDelegations.bind(this);
    this.redelegations = this.redelegations.bind(this);
    this.delegatorValidators = this.delegatorValidators.bind(this);
    this.delegatorValidator = this.delegatorValidator.bind(this);
    this.historicalInfo = this.historicalInfo.bind(this);
    this.pool = this.pool.bind(this);
    this.params = this.params.bind(this);
  }
  /* Validators queries all validators that match the given status. */


  async validators(params) {
    const options = {
      params: {}
    };

    if (typeof (params === null || params === void 0 ? void 0 : params.status) !== "undefined") {
      options.params.status = params.status;
    }

    if (typeof (params === null || params === void 0 ? void 0 : params.pagination) !== "undefined") {
      (0,_helpers__WEBPACK_IMPORTED_MODULE_0__/* .setPaginationParams */ .q6)(options, params.pagination);
    }

    const endpoint = `cosmos/staking/v1beta1/validators`;
    return await this.req.get(endpoint, options);
  }
  /* Validator queries validator info for given validator address. */


  async validator(params) {
    const endpoint = `cosmos/staking/v1beta1/validators/${params.validatorAddr}`;
    return await this.req.get(endpoint);
  }
  /* ValidatorDelegations queries delegate info for given validator. */


  async validatorDelegations(params) {
    const options = {
      params: {}
    };

    if (typeof (params === null || params === void 0 ? void 0 : params.pagination) !== "undefined") {
      (0,_helpers__WEBPACK_IMPORTED_MODULE_0__/* .setPaginationParams */ .q6)(options, params.pagination);
    }

    const endpoint = `cosmos/staking/v1beta1/validators/${params.validatorAddr}/delegations`;
    return await this.req.get(endpoint, options);
  }
  /* ValidatorUnbondingDelegations queries unbonding delegations of a validator. */


  async validatorUnbondingDelegations(params) {
    const options = {
      params: {}
    };

    if (typeof (params === null || params === void 0 ? void 0 : params.pagination) !== "undefined") {
      (0,_helpers__WEBPACK_IMPORTED_MODULE_0__/* .setPaginationParams */ .q6)(options, params.pagination);
    }

    const endpoint = `cosmos/staking/v1beta1/validators/${params.validatorAddr}/unbonding_delegations`;
    return await this.req.get(endpoint, options);
  }
  /* Delegation queries delegate info for given validator delegator pair. */


  async delegation(params) {
    const endpoint = `cosmos/staking/v1beta1/validators/${params.validatorAddr}/delegations/${params.delegatorAddr}`;
    return await this.req.get(endpoint);
  }
  /* UnbondingDelegation queries unbonding info for given validator delegator
   pair. */


  async unbondingDelegation(params) {
    const endpoint = `cosmos/staking/v1beta1/validators/${params.validatorAddr}/delegations/${params.delegatorAddr}/unbonding_delegation`;
    return await this.req.get(endpoint);
  }
  /* DelegatorDelegations queries all delegations of a given delegator address. */


  async delegatorDelegations(params) {
    const options = {
      params: {}
    };

    if (typeof (params === null || params === void 0 ? void 0 : params.pagination) !== "undefined") {
      (0,_helpers__WEBPACK_IMPORTED_MODULE_0__/* .setPaginationParams */ .q6)(options, params.pagination);
    }

    const endpoint = `cosmos/staking/v1beta1/delegations/${params.delegatorAddr}`;
    return await this.req.get(endpoint, options);
  }
  /* DelegatorUnbondingDelegations queries all unbonding delegations of a given
   delegator address. */


  async delegatorUnbondingDelegations(params) {
    const options = {
      params: {}
    };

    if (typeof (params === null || params === void 0 ? void 0 : params.pagination) !== "undefined") {
      (0,_helpers__WEBPACK_IMPORTED_MODULE_0__/* .setPaginationParams */ .q6)(options, params.pagination);
    }

    const endpoint = `cosmos/staking/v1beta1/delegators/${params.delegatorAddr}/unbonding_delegations`;
    return await this.req.get(endpoint, options);
  }
  /* Redelegations queries redelegations of given address. */


  async redelegations(params) {
    const options = {
      params: {}
    };

    if (typeof (params === null || params === void 0 ? void 0 : params.srcValidatorAddr) !== "undefined") {
      options.params.src_validator_addr = params.srcValidatorAddr;
    }

    if (typeof (params === null || params === void 0 ? void 0 : params.dstValidatorAddr) !== "undefined") {
      options.params.dst_validator_addr = params.dstValidatorAddr;
    }

    if (typeof (params === null || params === void 0 ? void 0 : params.pagination) !== "undefined") {
      (0,_helpers__WEBPACK_IMPORTED_MODULE_0__/* .setPaginationParams */ .q6)(options, params.pagination);
    }

    const endpoint = `cosmos/staking/v1beta1/delegators/${params.delegatorAddr}/redelegations`;
    return await this.req.get(endpoint, options);
  }
  /* DelegatorValidators queries all validators info for given delegator
   address. */


  async delegatorValidators(params) {
    const options = {
      params: {}
    };

    if (typeof (params === null || params === void 0 ? void 0 : params.pagination) !== "undefined") {
      (0,_helpers__WEBPACK_IMPORTED_MODULE_0__/* .setPaginationParams */ .q6)(options, params.pagination);
    }

    const endpoint = `cosmos/staking/v1beta1/delegators/${params.delegatorAddr}/validators`;
    return await this.req.get(endpoint, options);
  }
  /* DelegatorValidator queries validator info for given delegator validator
   pair. */


  async delegatorValidator(params) {
    const endpoint = `cosmos/staking/v1beta1/delegators/${params.delegatorAddr}/validators/${params.validatorAddr}`;
    return await this.req.get(endpoint);
  }
  /* HistoricalInfo queries the historical info for given height. */


  async historicalInfo(params) {
    const endpoint = `cosmos/staking/v1beta1/historical_info/${params.height}`;
    return await this.req.get(endpoint);
  }
  /* Pool queries the pool info. */


  async pool(_params = {}) {
    const endpoint = `cosmos/staking/v1beta1/pool`;
    return await this.req.get(endpoint);
  }
  /* Parameters queries the staking parameters. */


  async params(_params = {}) {
    const endpoint = `cosmos/staking/v1beta1/params`;
    return await this.req.get(endpoint);
  }

}

/***/ }),

/***/ 56860:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QueryClientImpl": function() { return /* binding */ QueryClientImpl; },
/* harmony export */   "createRpcQueryExtension": function() { return /* binding */ createRpcQueryExtension; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4942);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78441);
/* harmony import */ var _cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75317);




/** Query defines the gRPC querier service. */

class QueryClientImpl {
  constructor(rpc) {
    (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, "rpc", void 0);

    this.rpc = rpc;
    this.validators = this.validators.bind(this);
    this.validator = this.validator.bind(this);
    this.validatorDelegations = this.validatorDelegations.bind(this);
    this.validatorUnbondingDelegations = this.validatorUnbondingDelegations.bind(this);
    this.delegation = this.delegation.bind(this);
    this.unbondingDelegation = this.unbondingDelegation.bind(this);
    this.delegatorDelegations = this.delegatorDelegations.bind(this);
    this.delegatorUnbondingDelegations = this.delegatorUnbondingDelegations.bind(this);
    this.redelegations = this.redelegations.bind(this);
    this.delegatorValidators = this.delegatorValidators.bind(this);
    this.delegatorValidator = this.delegatorValidator.bind(this);
    this.historicalInfo = this.historicalInfo.bind(this);
    this.pool = this.pool.bind(this);
    this.params = this.params.bind(this);
  }

  validators(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryValidatorsRequest.encode(request).finish();
    const promise = this.rpc.request("cosmos.staking.v1beta1.Query", "Validators", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryValidatorsResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  validator(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryValidatorRequest.encode(request).finish();
    const promise = this.rpc.request("cosmos.staking.v1beta1.Query", "Validator", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryValidatorResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  validatorDelegations(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryValidatorDelegationsRequest.encode(request).finish();
    const promise = this.rpc.request("cosmos.staking.v1beta1.Query", "ValidatorDelegations", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryValidatorDelegationsResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  validatorUnbondingDelegations(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryValidatorUnbondingDelegationsRequest.encode(request).finish();
    const promise = this.rpc.request("cosmos.staking.v1beta1.Query", "ValidatorUnbondingDelegations", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryValidatorUnbondingDelegationsResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  delegation(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryDelegationRequest.encode(request).finish();
    const promise = this.rpc.request("cosmos.staking.v1beta1.Query", "Delegation", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryDelegationResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  unbondingDelegation(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryUnbondingDelegationRequest.encode(request).finish();
    const promise = this.rpc.request("cosmos.staking.v1beta1.Query", "UnbondingDelegation", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryUnbondingDelegationResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  delegatorDelegations(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryDelegatorDelegationsRequest.encode(request).finish();
    const promise = this.rpc.request("cosmos.staking.v1beta1.Query", "DelegatorDelegations", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryDelegatorDelegationsResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  delegatorUnbondingDelegations(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryDelegatorUnbondingDelegationsRequest.encode(request).finish();
    const promise = this.rpc.request("cosmos.staking.v1beta1.Query", "DelegatorUnbondingDelegations", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryDelegatorUnbondingDelegationsResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  redelegations(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryRedelegationsRequest.encode(request).finish();
    const promise = this.rpc.request("cosmos.staking.v1beta1.Query", "Redelegations", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryRedelegationsResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  delegatorValidators(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryDelegatorValidatorsRequest.encode(request).finish();
    const promise = this.rpc.request("cosmos.staking.v1beta1.Query", "DelegatorValidators", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryDelegatorValidatorsResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  delegatorValidator(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryDelegatorValidatorRequest.encode(request).finish();
    const promise = this.rpc.request("cosmos.staking.v1beta1.Query", "DelegatorValidator", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryDelegatorValidatorResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  historicalInfo(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryHistoricalInfoRequest.encode(request).finish();
    const promise = this.rpc.request("cosmos.staking.v1beta1.Query", "HistoricalInfo", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryHistoricalInfoResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  pool(request = {}) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryPoolRequest.encode(request).finish();
    const promise = this.rpc.request("cosmos.staking.v1beta1.Query", "Pool", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryPoolResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  params(request = {}) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryParamsRequest.encode(request).finish();
    const promise = this.rpc.request("cosmos.staking.v1beta1.Query", "Params", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryParamsResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

}
const createRpcQueryExtension = base => {
  const rpc = (0,_cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1__.createProtobufRpcClient)(base);
  const queryService = new QueryClientImpl(rpc);
  return {
    validators(request) {
      return queryService.validators(request);
    },

    validator(request) {
      return queryService.validator(request);
    },

    validatorDelegations(request) {
      return queryService.validatorDelegations(request);
    },

    validatorUnbondingDelegations(request) {
      return queryService.validatorUnbondingDelegations(request);
    },

    delegation(request) {
      return queryService.delegation(request);
    },

    unbondingDelegation(request) {
      return queryService.unbondingDelegation(request);
    },

    delegatorDelegations(request) {
      return queryService.delegatorDelegations(request);
    },

    delegatorUnbondingDelegations(request) {
      return queryService.delegatorUnbondingDelegations(request);
    },

    redelegations(request) {
      return queryService.redelegations(request);
    },

    delegatorValidators(request) {
      return queryService.delegatorValidators(request);
    },

    delegatorValidator(request) {
      return queryService.delegatorValidator(request);
    },

    historicalInfo(request) {
      return queryService.historicalInfo(request);
    },

    pool(request) {
      return queryService.pool(request);
    },

    params(request) {
      return queryService.params(request);
    }

  };
};

/***/ }),

/***/ 56959:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BondStatus": function() { return /* binding */ BondStatus; },
/* harmony export */   "BondStatusAmino": function() { return /* binding */ BondStatusAmino; },
/* harmony export */   "BondStatusSDKType": function() { return /* binding */ BondStatusSDKType; },
/* harmony export */   "Commission": function() { return /* binding */ Commission; },
/* harmony export */   "CommissionRates": function() { return /* binding */ CommissionRates; },
/* harmony export */   "Cosmos_cryptoPubKey_FromAmino": function() { return /* binding */ Cosmos_cryptoPubKey_FromAmino; },
/* harmony export */   "Cosmos_cryptoPubKey_InterfaceDecoder": function() { return /* binding */ Cosmos_cryptoPubKey_InterfaceDecoder; },
/* harmony export */   "Cosmos_cryptoPubKey_ToAmino": function() { return /* binding */ Cosmos_cryptoPubKey_ToAmino; },
/* harmony export */   "DVPair": function() { return /* binding */ DVPair; },
/* harmony export */   "DVPairs": function() { return /* binding */ DVPairs; },
/* harmony export */   "DVVTriplet": function() { return /* binding */ DVVTriplet; },
/* harmony export */   "DVVTriplets": function() { return /* binding */ DVVTriplets; },
/* harmony export */   "Delegation": function() { return /* binding */ Delegation; },
/* harmony export */   "DelegationResponse": function() { return /* binding */ DelegationResponse; },
/* harmony export */   "Description": function() { return /* binding */ Description; },
/* harmony export */   "HistoricalInfo": function() { return /* binding */ HistoricalInfo; },
/* harmony export */   "Params": function() { return /* binding */ Params; },
/* harmony export */   "Pool": function() { return /* binding */ Pool; },
/* harmony export */   "Redelegation": function() { return /* binding */ Redelegation; },
/* harmony export */   "RedelegationEntry": function() { return /* binding */ RedelegationEntry; },
/* harmony export */   "RedelegationEntryResponse": function() { return /* binding */ RedelegationEntryResponse; },
/* harmony export */   "RedelegationResponse": function() { return /* binding */ RedelegationResponse; },
/* harmony export */   "UnbondingDelegation": function() { return /* binding */ UnbondingDelegation; },
/* harmony export */   "UnbondingDelegationEntry": function() { return /* binding */ UnbondingDelegationEntry; },
/* harmony export */   "ValAddresses": function() { return /* binding */ ValAddresses; },
/* harmony export */   "Validator": function() { return /* binding */ Validator; },
/* harmony export */   "bondStatusFromJSON": function() { return /* binding */ bondStatusFromJSON; },
/* harmony export */   "bondStatusToJSON": function() { return /* binding */ bondStatusToJSON; }
/* harmony export */ });
/* harmony import */ var _tendermint_types_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87572);
/* harmony import */ var _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20633);
/* harmony import */ var _google_protobuf_any__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32106);
/* harmony import */ var _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6499);
/* harmony import */ var _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26178);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47895);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _cosmjs_encoding__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(71555);
/* harmony import */ var _cosmjs_amino__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(52105);









/** BondStatus is the status of a validator. */

let BondStatus;

(function (BondStatus) {
  BondStatus[BondStatus["BOND_STATUS_UNSPECIFIED"] = 0] = "BOND_STATUS_UNSPECIFIED";
  BondStatus[BondStatus["BOND_STATUS_UNBONDED"] = 1] = "BOND_STATUS_UNBONDED";
  BondStatus[BondStatus["BOND_STATUS_UNBONDING"] = 2] = "BOND_STATUS_UNBONDING";
  BondStatus[BondStatus["BOND_STATUS_BONDED"] = 3] = "BOND_STATUS_BONDED";
  BondStatus[BondStatus["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(BondStatus || (BondStatus = {}));

const BondStatusSDKType = BondStatus;
const BondStatusAmino = BondStatus;
function bondStatusFromJSON(object) {
  switch (object) {
    case 0:
    case "BOND_STATUS_UNSPECIFIED":
      return BondStatus.BOND_STATUS_UNSPECIFIED;

    case 1:
    case "BOND_STATUS_UNBONDED":
      return BondStatus.BOND_STATUS_UNBONDED;

    case 2:
    case "BOND_STATUS_UNBONDING":
      return BondStatus.BOND_STATUS_UNBONDING;

    case 3:
    case "BOND_STATUS_BONDED":
      return BondStatus.BOND_STATUS_BONDED;

    case -1:
    case "UNRECOGNIZED":
    default:
      return BondStatus.UNRECOGNIZED;
  }
}
function bondStatusToJSON(object) {
  switch (object) {
    case BondStatus.BOND_STATUS_UNSPECIFIED:
      return "BOND_STATUS_UNSPECIFIED";

    case BondStatus.BOND_STATUS_UNBONDED:
      return "BOND_STATUS_UNBONDED";

    case BondStatus.BOND_STATUS_UNBONDING:
      return "BOND_STATUS_UNBONDING";

    case BondStatus.BOND_STATUS_BONDED:
      return "BOND_STATUS_BONDED";

    case BondStatus.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
/**
 * HistoricalInfo contains header and validator information for a given block.
 * It is stored as part of staking module's state, which persists the `n` most
 * recent HistoricalInfo
 * (`n` is set by the staking module's `historical_entries` parameter).
 */

function createBaseHistoricalInfo() {
  return {
    header: undefined,
    valset: []
  };
}

const HistoricalInfo = {
  typeUrl: "/cosmos.staking.v1beta1.HistoricalInfo",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    if (message.header !== undefined) {
      _tendermint_types_types__WEBPACK_IMPORTED_MODULE_0__.Header.encode(message.header, writer.uint32(10).fork()).ldelim();
    }

    for (const v of message.valset) {
      Validator.encode(v, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseHistoricalInfo();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.header = _tendermint_types_types__WEBPACK_IMPORTED_MODULE_0__.Header.decode(reader, reader.uint32());
          break;

        case 2:
          message.valset.push(Validator.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$valset;

    const message = createBaseHistoricalInfo();
    message.header = object.header !== undefined && object.header !== null ? _tendermint_types_types__WEBPACK_IMPORTED_MODULE_0__.Header.fromPartial(object.header) : undefined;
    message.valset = ((_object$valset = object.valset) === null || _object$valset === void 0 ? void 0 : _object$valset.map(e => Validator.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      header: object !== null && object !== void 0 && object.header ? _tendermint_types_types__WEBPACK_IMPORTED_MODULE_0__.Header.fromAmino(object.header) : undefined,
      valset: Array.isArray(object === null || object === void 0 ? void 0 : object.valset) ? object.valset.map(e => Validator.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.header = message.header ? _tendermint_types_types__WEBPACK_IMPORTED_MODULE_0__.Header.toAmino(message.header) : undefined;

    if (message.valset) {
      obj.valset = message.valset.map(e => e ? Validator.toAmino(e) : undefined);
    } else {
      obj.valset = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return HistoricalInfo.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/HistoricalInfo",
      value: HistoricalInfo.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return HistoricalInfo.decode(message.value);
  },

  toProto(message) {
    return HistoricalInfo.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.HistoricalInfo",
      value: HistoricalInfo.encode(message).finish()
    };
  }

};

function createBaseCommissionRates() {
  return {
    rate: "",
    maxRate: "",
    maxChangeRate: ""
  };
}

const CommissionRates = {
  typeUrl: "/cosmos.staking.v1beta1.CommissionRates",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    if (message.rate !== "") {
      writer.uint32(10).string(message.rate);
    }

    if (message.maxRate !== "") {
      writer.uint32(18).string(message.maxRate);
    }

    if (message.maxChangeRate !== "") {
      writer.uint32(26).string(message.maxChangeRate);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCommissionRates();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.rate = reader.string();
          break;

        case 2:
          message.maxRate = reader.string();
          break;

        case 3:
          message.maxChangeRate = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$rate, _object$maxRate, _object$maxChangeRate;

    const message = createBaseCommissionRates();
    message.rate = (_object$rate = object.rate) !== null && _object$rate !== void 0 ? _object$rate : "";
    message.maxRate = (_object$maxRate = object.maxRate) !== null && _object$maxRate !== void 0 ? _object$maxRate : "";
    message.maxChangeRate = (_object$maxChangeRate = object.maxChangeRate) !== null && _object$maxChangeRate !== void 0 ? _object$maxChangeRate : "";
    return message;
  },

  fromAmino(object) {
    return {
      rate: object.rate,
      maxRate: object.max_rate,
      maxChangeRate: object.max_change_rate
    };
  },

  toAmino(message) {
    const obj = {};
    obj.rate = message.rate;
    obj.max_rate = message.maxRate;
    obj.max_change_rate = message.maxChangeRate;
    return obj;
  },

  fromAminoMsg(object) {
    return CommissionRates.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/CommissionRates",
      value: CommissionRates.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return CommissionRates.decode(message.value);
  },

  toProto(message) {
    return CommissionRates.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.CommissionRates",
      value: CommissionRates.encode(message).finish()
    };
  }

};

function createBaseCommission() {
  return {
    commissionRates: undefined,
    updateTime: undefined
  };
}

const Commission = {
  typeUrl: "/cosmos.staking.v1beta1.Commission",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    if (message.commissionRates !== undefined) {
      CommissionRates.encode(message.commissionRates, writer.uint32(10).fork()).ldelim();
    }

    if (message.updateTime !== undefined) {
      _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_1__.Timestamp.encode((0,_helpers__WEBPACK_IMPORTED_MODULE_5__/* .toTimestamp */ .Uq)(message.updateTime), writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCommission();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.commissionRates = CommissionRates.decode(reader, reader.uint32());
          break;

        case 2:
          message.updateTime = (0,_helpers__WEBPACK_IMPORTED_MODULE_5__/* .fromTimestamp */ .Ol)(_google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_1__.Timestamp.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$updateTime;

    const message = createBaseCommission();
    message.commissionRates = object.commissionRates !== undefined && object.commissionRates !== null ? CommissionRates.fromPartial(object.commissionRates) : undefined;
    message.updateTime = (_object$updateTime = object.updateTime) !== null && _object$updateTime !== void 0 ? _object$updateTime : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      commissionRates: object !== null && object !== void 0 && object.commission_rates ? CommissionRates.fromAmino(object.commission_rates) : undefined,
      updateTime: object !== null && object !== void 0 && object.update_time ? _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_1__.Timestamp.fromAmino(object.update_time) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.commission_rates = message.commissionRates ? CommissionRates.toAmino(message.commissionRates) : undefined;
    obj.update_time = message.updateTime ? _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_1__.Timestamp.toAmino(message.updateTime) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return Commission.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/Commission",
      value: Commission.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return Commission.decode(message.value);
  },

  toProto(message) {
    return Commission.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.Commission",
      value: Commission.encode(message).finish()
    };
  }

};

function createBaseDescription() {
  return {
    moniker: "",
    identity: "",
    website: "",
    securityContact: "",
    details: ""
  };
}

const Description = {
  typeUrl: "/cosmos.staking.v1beta1.Description",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    if (message.moniker !== "") {
      writer.uint32(10).string(message.moniker);
    }

    if (message.identity !== "") {
      writer.uint32(18).string(message.identity);
    }

    if (message.website !== "") {
      writer.uint32(26).string(message.website);
    }

    if (message.securityContact !== "") {
      writer.uint32(34).string(message.securityContact);
    }

    if (message.details !== "") {
      writer.uint32(42).string(message.details);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDescription();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.moniker = reader.string();
          break;

        case 2:
          message.identity = reader.string();
          break;

        case 3:
          message.website = reader.string();
          break;

        case 4:
          message.securityContact = reader.string();
          break;

        case 5:
          message.details = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$moniker, _object$identity, _object$website, _object$securityConta, _object$details;

    const message = createBaseDescription();
    message.moniker = (_object$moniker = object.moniker) !== null && _object$moniker !== void 0 ? _object$moniker : "";
    message.identity = (_object$identity = object.identity) !== null && _object$identity !== void 0 ? _object$identity : "";
    message.website = (_object$website = object.website) !== null && _object$website !== void 0 ? _object$website : "";
    message.securityContact = (_object$securityConta = object.securityContact) !== null && _object$securityConta !== void 0 ? _object$securityConta : "";
    message.details = (_object$details = object.details) !== null && _object$details !== void 0 ? _object$details : "";
    return message;
  },

  fromAmino(object) {
    return {
      moniker: object.moniker,
      identity: object.identity,
      website: object.website,
      securityContact: object.security_contact,
      details: object.details
    };
  },

  toAmino(message) {
    const obj = {};
    obj.moniker = message.moniker;
    obj.identity = message.identity;
    obj.website = message.website;
    obj.security_contact = message.securityContact;
    obj.details = message.details;
    return obj;
  },

  fromAminoMsg(object) {
    return Description.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/Description",
      value: Description.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return Description.decode(message.value);
  },

  toProto(message) {
    return Description.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.Description",
      value: Description.encode(message).finish()
    };
  }

};

function createBaseValidator() {
  return {
    operatorAddress: "",
    consensusPubkey: undefined,
    jailed: false,
    status: 0,
    tokens: "",
    delegatorShares: "",
    description: undefined,
    unbondingHeight: _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.ZERO */ .dK.ZERO,
    unbondingTime: undefined,
    commission: undefined,
    minSelfDelegation: ""
  };
}

const Validator = {
  typeUrl: "/cosmos.staking.v1beta1.Validator",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    if (message.operatorAddress !== "") {
      writer.uint32(10).string(message.operatorAddress);
    }

    if (message.consensusPubkey !== undefined) {
      _google_protobuf_any__WEBPACK_IMPORTED_MODULE_2__.Any.encode(message.consensusPubkey, writer.uint32(18).fork()).ldelim();
    }

    if (message.jailed === true) {
      writer.uint32(24).bool(message.jailed);
    }

    if (message.status !== 0) {
      writer.uint32(32).int32(message.status);
    }

    if (message.tokens !== "") {
      writer.uint32(42).string(message.tokens);
    }

    if (message.delegatorShares !== "") {
      writer.uint32(50).string(message.delegatorShares);
    }

    if (message.description !== undefined) {
      Description.encode(message.description, writer.uint32(58).fork()).ldelim();
    }

    if (!message.unbondingHeight.isZero()) {
      writer.uint32(64).int64(message.unbondingHeight);
    }

    if (message.unbondingTime !== undefined) {
      _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_1__.Timestamp.encode((0,_helpers__WEBPACK_IMPORTED_MODULE_5__/* .toTimestamp */ .Uq)(message.unbondingTime), writer.uint32(74).fork()).ldelim();
    }

    if (message.commission !== undefined) {
      Commission.encode(message.commission, writer.uint32(82).fork()).ldelim();
    }

    if (message.minSelfDelegation !== "") {
      writer.uint32(90).string(message.minSelfDelegation);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseValidator();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.operatorAddress = reader.string();
          break;

        case 2:
          message.consensusPubkey = Cosmos_cryptoPubKey_InterfaceDecoder(reader);
          break;

        case 3:
          message.jailed = reader.bool();
          break;

        case 4:
          message.status = reader.int32();
          break;

        case 5:
          message.tokens = reader.string();
          break;

        case 6:
          message.delegatorShares = reader.string();
          break;

        case 7:
          message.description = Description.decode(reader, reader.uint32());
          break;

        case 8:
          message.unbondingHeight = reader.int64();
          break;

        case 9:
          message.unbondingTime = (0,_helpers__WEBPACK_IMPORTED_MODULE_5__/* .fromTimestamp */ .Ol)(_google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_1__.Timestamp.decode(reader, reader.uint32()));
          break;

        case 10:
          message.commission = Commission.decode(reader, reader.uint32());
          break;

        case 11:
          message.minSelfDelegation = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$operatorAddre, _object$jailed, _object$status, _object$tokens, _object$delegatorShar, _object$unbondingTime, _object$minSelfDelega;

    const message = createBaseValidator();
    message.operatorAddress = (_object$operatorAddre = object.operatorAddress) !== null && _object$operatorAddre !== void 0 ? _object$operatorAddre : "";
    message.consensusPubkey = object.consensusPubkey !== undefined && object.consensusPubkey !== null ? _google_protobuf_any__WEBPACK_IMPORTED_MODULE_2__.Any.fromPartial(object.consensusPubkey) : undefined;
    message.jailed = (_object$jailed = object.jailed) !== null && _object$jailed !== void 0 ? _object$jailed : false;
    message.status = (_object$status = object.status) !== null && _object$status !== void 0 ? _object$status : 0;
    message.tokens = (_object$tokens = object.tokens) !== null && _object$tokens !== void 0 ? _object$tokens : "";
    message.delegatorShares = (_object$delegatorShar = object.delegatorShares) !== null && _object$delegatorShar !== void 0 ? _object$delegatorShar : "";
    message.description = object.description !== undefined && object.description !== null ? Description.fromPartial(object.description) : undefined;
    message.unbondingHeight = object.unbondingHeight !== undefined && object.unbondingHeight !== null ? _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.fromValue */ .dK.fromValue(object.unbondingHeight) : _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.ZERO */ .dK.ZERO;
    message.unbondingTime = (_object$unbondingTime = object.unbondingTime) !== null && _object$unbondingTime !== void 0 ? _object$unbondingTime : undefined;
    message.commission = object.commission !== undefined && object.commission !== null ? Commission.fromPartial(object.commission) : undefined;
    message.minSelfDelegation = (_object$minSelfDelega = object.minSelfDelegation) !== null && _object$minSelfDelega !== void 0 ? _object$minSelfDelega : "";
    return message;
  },

  fromAmino(object) {
    return {
      operatorAddress: object.operator_address,
      consensusPubkey: (0,_cosmjs_amino__WEBPACK_IMPORTED_MODULE_8__/* .encodeBech32Pubkey */ .N2)({
        type: "tendermint/PubKeySecp256k1",
        value: (0,_cosmjs_encoding__WEBPACK_IMPORTED_MODULE_7__.toBase64)(object.consensus_pubkey.value)
      }, "cosmos"),
      jailed: object.jailed,
      status: (0,_helpers__WEBPACK_IMPORTED_MODULE_5__/* .isSet */ .DM)(object.status) ? bondStatusFromJSON(object.status) : 0,
      tokens: object.tokens,
      delegatorShares: object.delegator_shares,
      description: object !== null && object !== void 0 && object.description ? Description.fromAmino(object.description) : undefined,
      unbondingHeight: _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.fromString */ .dK.fromString(object.unbonding_height),
      unbondingTime: object !== null && object !== void 0 && object.unbonding_time ? _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_1__.Timestamp.fromAmino(object.unbonding_time) : undefined,
      commission: object !== null && object !== void 0 && object.commission ? Commission.fromAmino(object.commission) : undefined,
      minSelfDelegation: object.min_self_delegation
    };
  },

  toAmino(message) {
    const obj = {};
    obj.operator_address = message.operatorAddress;
    obj.consensus_pubkey = message.consensusPubkey ? {
      typeUrl: "/cosmos.crypto.secp256k1.PubKey",
      value: (0,_cosmjs_encoding__WEBPACK_IMPORTED_MODULE_7__.fromBase64)((0,_cosmjs_amino__WEBPACK_IMPORTED_MODULE_8__/* .decodeBech32Pubkey */ .xC)(message.consensusPubkey).value)
    } : undefined;
    obj.jailed = message.jailed;
    obj.status = message.status;
    obj.tokens = message.tokens;
    obj.delegator_shares = message.delegatorShares;
    obj.description = message.description ? Description.toAmino(message.description) : undefined;
    obj.unbonding_height = message.unbondingHeight ? message.unbondingHeight.toString() : undefined;
    obj.unbonding_time = message.unbondingTime ? _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_1__.Timestamp.toAmino(message.unbondingTime) : undefined;
    obj.commission = message.commission ? Commission.toAmino(message.commission) : undefined;
    obj.min_self_delegation = message.minSelfDelegation;
    return obj;
  },

  fromAminoMsg(object) {
    return Validator.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/Validator",
      value: Validator.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return Validator.decode(message.value);
  },

  toProto(message) {
    return Validator.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.Validator",
      value: Validator.encode(message).finish()
    };
  }

};

function createBaseValAddresses() {
  return {
    addresses: []
  };
}

const ValAddresses = {
  typeUrl: "/cosmos.staking.v1beta1.ValAddresses",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    for (const v of message.addresses) {
      writer.uint32(10).string(v);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseValAddresses();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.addresses.push(reader.string());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$addresses;

    const message = createBaseValAddresses();
    message.addresses = ((_object$addresses = object.addresses) === null || _object$addresses === void 0 ? void 0 : _object$addresses.map(e => e)) || [];
    return message;
  },

  fromAmino(object) {
    return {
      addresses: Array.isArray(object === null || object === void 0 ? void 0 : object.addresses) ? object.addresses.map(e => e) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.addresses) {
      obj.addresses = message.addresses.map(e => e);
    } else {
      obj.addresses = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return ValAddresses.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/ValAddresses",
      value: ValAddresses.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return ValAddresses.decode(message.value);
  },

  toProto(message) {
    return ValAddresses.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.ValAddresses",
      value: ValAddresses.encode(message).finish()
    };
  }

};

function createBaseDVPair() {
  return {
    delegatorAddress: "",
    validatorAddress: ""
  };
}

const DVPair = {
  typeUrl: "/cosmos.staking.v1beta1.DVPair",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    if (message.delegatorAddress !== "") {
      writer.uint32(10).string(message.delegatorAddress);
    }

    if (message.validatorAddress !== "") {
      writer.uint32(18).string(message.validatorAddress);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDVPair();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.delegatorAddress = reader.string();
          break;

        case 2:
          message.validatorAddress = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$delegatorAddr, _object$validatorAddr;

    const message = createBaseDVPair();
    message.delegatorAddress = (_object$delegatorAddr = object.delegatorAddress) !== null && _object$delegatorAddr !== void 0 ? _object$delegatorAddr : "";
    message.validatorAddress = (_object$validatorAddr = object.validatorAddress) !== null && _object$validatorAddr !== void 0 ? _object$validatorAddr : "";
    return message;
  },

  fromAmino(object) {
    return {
      delegatorAddress: object.delegator_address,
      validatorAddress: object.validator_address
    };
  },

  toAmino(message) {
    const obj = {};
    obj.delegator_address = message.delegatorAddress;
    obj.validator_address = message.validatorAddress;
    return obj;
  },

  fromAminoMsg(object) {
    return DVPair.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/DVPair",
      value: DVPair.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return DVPair.decode(message.value);
  },

  toProto(message) {
    return DVPair.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.DVPair",
      value: DVPair.encode(message).finish()
    };
  }

};

function createBaseDVPairs() {
  return {
    pairs: []
  };
}

const DVPairs = {
  typeUrl: "/cosmos.staking.v1beta1.DVPairs",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    for (const v of message.pairs) {
      DVPair.encode(v, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDVPairs();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.pairs.push(DVPair.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$pairs;

    const message = createBaseDVPairs();
    message.pairs = ((_object$pairs = object.pairs) === null || _object$pairs === void 0 ? void 0 : _object$pairs.map(e => DVPair.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      pairs: Array.isArray(object === null || object === void 0 ? void 0 : object.pairs) ? object.pairs.map(e => DVPair.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.pairs) {
      obj.pairs = message.pairs.map(e => e ? DVPair.toAmino(e) : undefined);
    } else {
      obj.pairs = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return DVPairs.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/DVPairs",
      value: DVPairs.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return DVPairs.decode(message.value);
  },

  toProto(message) {
    return DVPairs.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.DVPairs",
      value: DVPairs.encode(message).finish()
    };
  }

};

function createBaseDVVTriplet() {
  return {
    delegatorAddress: "",
    validatorSrcAddress: "",
    validatorDstAddress: ""
  };
}

const DVVTriplet = {
  typeUrl: "/cosmos.staking.v1beta1.DVVTriplet",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    if (message.delegatorAddress !== "") {
      writer.uint32(10).string(message.delegatorAddress);
    }

    if (message.validatorSrcAddress !== "") {
      writer.uint32(18).string(message.validatorSrcAddress);
    }

    if (message.validatorDstAddress !== "") {
      writer.uint32(26).string(message.validatorDstAddress);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDVVTriplet();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.delegatorAddress = reader.string();
          break;

        case 2:
          message.validatorSrcAddress = reader.string();
          break;

        case 3:
          message.validatorDstAddress = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$delegatorAddr2, _object$validatorSrcA, _object$validatorDstA;

    const message = createBaseDVVTriplet();
    message.delegatorAddress = (_object$delegatorAddr2 = object.delegatorAddress) !== null && _object$delegatorAddr2 !== void 0 ? _object$delegatorAddr2 : "";
    message.validatorSrcAddress = (_object$validatorSrcA = object.validatorSrcAddress) !== null && _object$validatorSrcA !== void 0 ? _object$validatorSrcA : "";
    message.validatorDstAddress = (_object$validatorDstA = object.validatorDstAddress) !== null && _object$validatorDstA !== void 0 ? _object$validatorDstA : "";
    return message;
  },

  fromAmino(object) {
    return {
      delegatorAddress: object.delegator_address,
      validatorSrcAddress: object.validator_src_address,
      validatorDstAddress: object.validator_dst_address
    };
  },

  toAmino(message) {
    const obj = {};
    obj.delegator_address = message.delegatorAddress;
    obj.validator_src_address = message.validatorSrcAddress;
    obj.validator_dst_address = message.validatorDstAddress;
    return obj;
  },

  fromAminoMsg(object) {
    return DVVTriplet.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/DVVTriplet",
      value: DVVTriplet.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return DVVTriplet.decode(message.value);
  },

  toProto(message) {
    return DVVTriplet.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.DVVTriplet",
      value: DVVTriplet.encode(message).finish()
    };
  }

};

function createBaseDVVTriplets() {
  return {
    triplets: []
  };
}

const DVVTriplets = {
  typeUrl: "/cosmos.staking.v1beta1.DVVTriplets",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    for (const v of message.triplets) {
      DVVTriplet.encode(v, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDVVTriplets();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.triplets.push(DVVTriplet.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$triplets;

    const message = createBaseDVVTriplets();
    message.triplets = ((_object$triplets = object.triplets) === null || _object$triplets === void 0 ? void 0 : _object$triplets.map(e => DVVTriplet.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      triplets: Array.isArray(object === null || object === void 0 ? void 0 : object.triplets) ? object.triplets.map(e => DVVTriplet.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.triplets) {
      obj.triplets = message.triplets.map(e => e ? DVVTriplet.toAmino(e) : undefined);
    } else {
      obj.triplets = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return DVVTriplets.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/DVVTriplets",
      value: DVVTriplets.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return DVVTriplets.decode(message.value);
  },

  toProto(message) {
    return DVVTriplets.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.DVVTriplets",
      value: DVVTriplets.encode(message).finish()
    };
  }

};

function createBaseDelegation() {
  return {
    delegatorAddress: "",
    validatorAddress: "",
    shares: ""
  };
}

const Delegation = {
  typeUrl: "/cosmos.staking.v1beta1.Delegation",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    if (message.delegatorAddress !== "") {
      writer.uint32(10).string(message.delegatorAddress);
    }

    if (message.validatorAddress !== "") {
      writer.uint32(18).string(message.validatorAddress);
    }

    if (message.shares !== "") {
      writer.uint32(26).string(message.shares);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDelegation();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.delegatorAddress = reader.string();
          break;

        case 2:
          message.validatorAddress = reader.string();
          break;

        case 3:
          message.shares = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$delegatorAddr3, _object$validatorAddr2, _object$shares;

    const message = createBaseDelegation();
    message.delegatorAddress = (_object$delegatorAddr3 = object.delegatorAddress) !== null && _object$delegatorAddr3 !== void 0 ? _object$delegatorAddr3 : "";
    message.validatorAddress = (_object$validatorAddr2 = object.validatorAddress) !== null && _object$validatorAddr2 !== void 0 ? _object$validatorAddr2 : "";
    message.shares = (_object$shares = object.shares) !== null && _object$shares !== void 0 ? _object$shares : "";
    return message;
  },

  fromAmino(object) {
    return {
      delegatorAddress: object.delegator_address,
      validatorAddress: object.validator_address,
      shares: object.shares
    };
  },

  toAmino(message) {
    const obj = {};
    obj.delegator_address = message.delegatorAddress;
    obj.validator_address = message.validatorAddress;
    obj.shares = message.shares;
    return obj;
  },

  fromAminoMsg(object) {
    return Delegation.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/Delegation",
      value: Delegation.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return Delegation.decode(message.value);
  },

  toProto(message) {
    return Delegation.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.Delegation",
      value: Delegation.encode(message).finish()
    };
  }

};

function createBaseUnbondingDelegation() {
  return {
    delegatorAddress: "",
    validatorAddress: "",
    entries: []
  };
}

const UnbondingDelegation = {
  typeUrl: "/cosmos.staking.v1beta1.UnbondingDelegation",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    if (message.delegatorAddress !== "") {
      writer.uint32(10).string(message.delegatorAddress);
    }

    if (message.validatorAddress !== "") {
      writer.uint32(18).string(message.validatorAddress);
    }

    for (const v of message.entries) {
      UnbondingDelegationEntry.encode(v, writer.uint32(26).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUnbondingDelegation();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.delegatorAddress = reader.string();
          break;

        case 2:
          message.validatorAddress = reader.string();
          break;

        case 3:
          message.entries.push(UnbondingDelegationEntry.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$delegatorAddr4, _object$validatorAddr3, _object$entries;

    const message = createBaseUnbondingDelegation();
    message.delegatorAddress = (_object$delegatorAddr4 = object.delegatorAddress) !== null && _object$delegatorAddr4 !== void 0 ? _object$delegatorAddr4 : "";
    message.validatorAddress = (_object$validatorAddr3 = object.validatorAddress) !== null && _object$validatorAddr3 !== void 0 ? _object$validatorAddr3 : "";
    message.entries = ((_object$entries = object.entries) === null || _object$entries === void 0 ? void 0 : _object$entries.map(e => UnbondingDelegationEntry.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      delegatorAddress: object.delegator_address,
      validatorAddress: object.validator_address,
      entries: Array.isArray(object === null || object === void 0 ? void 0 : object.entries) ? object.entries.map(e => UnbondingDelegationEntry.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.delegator_address = message.delegatorAddress;
    obj.validator_address = message.validatorAddress;

    if (message.entries) {
      obj.entries = message.entries.map(e => e ? UnbondingDelegationEntry.toAmino(e) : undefined);
    } else {
      obj.entries = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return UnbondingDelegation.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/UnbondingDelegation",
      value: UnbondingDelegation.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return UnbondingDelegation.decode(message.value);
  },

  toProto(message) {
    return UnbondingDelegation.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.UnbondingDelegation",
      value: UnbondingDelegation.encode(message).finish()
    };
  }

};

function createBaseUnbondingDelegationEntry() {
  return {
    creationHeight: _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.ZERO */ .dK.ZERO,
    completionTime: undefined,
    initialBalance: "",
    balance: ""
  };
}

const UnbondingDelegationEntry = {
  typeUrl: "/cosmos.staking.v1beta1.UnbondingDelegationEntry",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    if (!message.creationHeight.isZero()) {
      writer.uint32(8).int64(message.creationHeight);
    }

    if (message.completionTime !== undefined) {
      _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_1__.Timestamp.encode((0,_helpers__WEBPACK_IMPORTED_MODULE_5__/* .toTimestamp */ .Uq)(message.completionTime), writer.uint32(18).fork()).ldelim();
    }

    if (message.initialBalance !== "") {
      writer.uint32(26).string(message.initialBalance);
    }

    if (message.balance !== "") {
      writer.uint32(34).string(message.balance);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUnbondingDelegationEntry();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.creationHeight = reader.int64();
          break;

        case 2:
          message.completionTime = (0,_helpers__WEBPACK_IMPORTED_MODULE_5__/* .fromTimestamp */ .Ol)(_google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_1__.Timestamp.decode(reader, reader.uint32()));
          break;

        case 3:
          message.initialBalance = reader.string();
          break;

        case 4:
          message.balance = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$completionTim, _object$initialBalanc, _object$balance;

    const message = createBaseUnbondingDelegationEntry();
    message.creationHeight = object.creationHeight !== undefined && object.creationHeight !== null ? _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.fromValue */ .dK.fromValue(object.creationHeight) : _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.ZERO */ .dK.ZERO;
    message.completionTime = (_object$completionTim = object.completionTime) !== null && _object$completionTim !== void 0 ? _object$completionTim : undefined;
    message.initialBalance = (_object$initialBalanc = object.initialBalance) !== null && _object$initialBalanc !== void 0 ? _object$initialBalanc : "";
    message.balance = (_object$balance = object.balance) !== null && _object$balance !== void 0 ? _object$balance : "";
    return message;
  },

  fromAmino(object) {
    return {
      creationHeight: _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.fromString */ .dK.fromString(object.creation_height),
      completionTime: object !== null && object !== void 0 && object.completion_time ? _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_1__.Timestamp.fromAmino(object.completion_time) : undefined,
      initialBalance: object.initial_balance,
      balance: object.balance
    };
  },

  toAmino(message) {
    const obj = {};
    obj.creation_height = message.creationHeight ? message.creationHeight.toString() : undefined;
    obj.completion_time = message.completionTime ? _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_1__.Timestamp.toAmino(message.completionTime) : undefined;
    obj.initial_balance = message.initialBalance;
    obj.balance = message.balance;
    return obj;
  },

  fromAminoMsg(object) {
    return UnbondingDelegationEntry.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/UnbondingDelegationEntry",
      value: UnbondingDelegationEntry.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return UnbondingDelegationEntry.decode(message.value);
  },

  toProto(message) {
    return UnbondingDelegationEntry.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.UnbondingDelegationEntry",
      value: UnbondingDelegationEntry.encode(message).finish()
    };
  }

};

function createBaseRedelegationEntry() {
  return {
    creationHeight: _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.ZERO */ .dK.ZERO,
    completionTime: undefined,
    initialBalance: "",
    sharesDst: ""
  };
}

const RedelegationEntry = {
  typeUrl: "/cosmos.staking.v1beta1.RedelegationEntry",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    if (!message.creationHeight.isZero()) {
      writer.uint32(8).int64(message.creationHeight);
    }

    if (message.completionTime !== undefined) {
      _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_1__.Timestamp.encode((0,_helpers__WEBPACK_IMPORTED_MODULE_5__/* .toTimestamp */ .Uq)(message.completionTime), writer.uint32(18).fork()).ldelim();
    }

    if (message.initialBalance !== "") {
      writer.uint32(26).string(message.initialBalance);
    }

    if (message.sharesDst !== "") {
      writer.uint32(34).string(message.sharesDst);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRedelegationEntry();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.creationHeight = reader.int64();
          break;

        case 2:
          message.completionTime = (0,_helpers__WEBPACK_IMPORTED_MODULE_5__/* .fromTimestamp */ .Ol)(_google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_1__.Timestamp.decode(reader, reader.uint32()));
          break;

        case 3:
          message.initialBalance = reader.string();
          break;

        case 4:
          message.sharesDst = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$completionTim2, _object$initialBalanc2, _object$sharesDst;

    const message = createBaseRedelegationEntry();
    message.creationHeight = object.creationHeight !== undefined && object.creationHeight !== null ? _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.fromValue */ .dK.fromValue(object.creationHeight) : _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.ZERO */ .dK.ZERO;
    message.completionTime = (_object$completionTim2 = object.completionTime) !== null && _object$completionTim2 !== void 0 ? _object$completionTim2 : undefined;
    message.initialBalance = (_object$initialBalanc2 = object.initialBalance) !== null && _object$initialBalanc2 !== void 0 ? _object$initialBalanc2 : "";
    message.sharesDst = (_object$sharesDst = object.sharesDst) !== null && _object$sharesDst !== void 0 ? _object$sharesDst : "";
    return message;
  },

  fromAmino(object) {
    return {
      creationHeight: _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.fromString */ .dK.fromString(object.creation_height),
      completionTime: object !== null && object !== void 0 && object.completion_time ? _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_1__.Timestamp.fromAmino(object.completion_time) : undefined,
      initialBalance: object.initial_balance,
      sharesDst: object.shares_dst
    };
  },

  toAmino(message) {
    const obj = {};
    obj.creation_height = message.creationHeight ? message.creationHeight.toString() : undefined;
    obj.completion_time = message.completionTime ? _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_1__.Timestamp.toAmino(message.completionTime) : undefined;
    obj.initial_balance = message.initialBalance;
    obj.shares_dst = message.sharesDst;
    return obj;
  },

  fromAminoMsg(object) {
    return RedelegationEntry.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/RedelegationEntry",
      value: RedelegationEntry.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return RedelegationEntry.decode(message.value);
  },

  toProto(message) {
    return RedelegationEntry.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.RedelegationEntry",
      value: RedelegationEntry.encode(message).finish()
    };
  }

};

function createBaseRedelegation() {
  return {
    delegatorAddress: "",
    validatorSrcAddress: "",
    validatorDstAddress: "",
    entries: []
  };
}

const Redelegation = {
  typeUrl: "/cosmos.staking.v1beta1.Redelegation",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    if (message.delegatorAddress !== "") {
      writer.uint32(10).string(message.delegatorAddress);
    }

    if (message.validatorSrcAddress !== "") {
      writer.uint32(18).string(message.validatorSrcAddress);
    }

    if (message.validatorDstAddress !== "") {
      writer.uint32(26).string(message.validatorDstAddress);
    }

    for (const v of message.entries) {
      RedelegationEntry.encode(v, writer.uint32(34).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRedelegation();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.delegatorAddress = reader.string();
          break;

        case 2:
          message.validatorSrcAddress = reader.string();
          break;

        case 3:
          message.validatorDstAddress = reader.string();
          break;

        case 4:
          message.entries.push(RedelegationEntry.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$delegatorAddr5, _object$validatorSrcA2, _object$validatorDstA2, _object$entries2;

    const message = createBaseRedelegation();
    message.delegatorAddress = (_object$delegatorAddr5 = object.delegatorAddress) !== null && _object$delegatorAddr5 !== void 0 ? _object$delegatorAddr5 : "";
    message.validatorSrcAddress = (_object$validatorSrcA2 = object.validatorSrcAddress) !== null && _object$validatorSrcA2 !== void 0 ? _object$validatorSrcA2 : "";
    message.validatorDstAddress = (_object$validatorDstA2 = object.validatorDstAddress) !== null && _object$validatorDstA2 !== void 0 ? _object$validatorDstA2 : "";
    message.entries = ((_object$entries2 = object.entries) === null || _object$entries2 === void 0 ? void 0 : _object$entries2.map(e => RedelegationEntry.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      delegatorAddress: object.delegator_address,
      validatorSrcAddress: object.validator_src_address,
      validatorDstAddress: object.validator_dst_address,
      entries: Array.isArray(object === null || object === void 0 ? void 0 : object.entries) ? object.entries.map(e => RedelegationEntry.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.delegator_address = message.delegatorAddress;
    obj.validator_src_address = message.validatorSrcAddress;
    obj.validator_dst_address = message.validatorDstAddress;

    if (message.entries) {
      obj.entries = message.entries.map(e => e ? RedelegationEntry.toAmino(e) : undefined);
    } else {
      obj.entries = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return Redelegation.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/Redelegation",
      value: Redelegation.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return Redelegation.decode(message.value);
  },

  toProto(message) {
    return Redelegation.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.Redelegation",
      value: Redelegation.encode(message).finish()
    };
  }

};

function createBaseParams() {
  return {
    unbondingTime: undefined,
    maxValidators: 0,
    maxEntries: 0,
    historicalEntries: 0,
    bondDenom: "",
    minCommissionRate: "",
    minSelfDelegation: ""
  };
}

const Params = {
  typeUrl: "/cosmos.staking.v1beta1.Params",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    if (message.unbondingTime !== undefined) {
      _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_3__.Duration.encode(message.unbondingTime, writer.uint32(10).fork()).ldelim();
    }

    if (message.maxValidators !== 0) {
      writer.uint32(16).uint32(message.maxValidators);
    }

    if (message.maxEntries !== 0) {
      writer.uint32(24).uint32(message.maxEntries);
    }

    if (message.historicalEntries !== 0) {
      writer.uint32(32).uint32(message.historicalEntries);
    }

    if (message.bondDenom !== "") {
      writer.uint32(42).string(message.bondDenom);
    }

    if (message.minCommissionRate !== "") {
      writer.uint32(50).string(message.minCommissionRate);
    }

    if (message.minSelfDelegation !== "") {
      writer.uint32(58).string(message.minSelfDelegation);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseParams();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.unbondingTime = _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_3__.Duration.decode(reader, reader.uint32());
          break;

        case 2:
          message.maxValidators = reader.uint32();
          break;

        case 3:
          message.maxEntries = reader.uint32();
          break;

        case 4:
          message.historicalEntries = reader.uint32();
          break;

        case 5:
          message.bondDenom = reader.string();
          break;

        case 6:
          message.minCommissionRate = reader.string();
          break;

        case 7:
          message.minSelfDelegation = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$maxValidators, _object$maxEntries, _object$historicalEnt, _object$bondDenom, _object$minCommission, _object$minSelfDelega2;

    const message = createBaseParams();
    message.unbondingTime = object.unbondingTime !== undefined && object.unbondingTime !== null ? _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_3__.Duration.fromPartial(object.unbondingTime) : undefined;
    message.maxValidators = (_object$maxValidators = object.maxValidators) !== null && _object$maxValidators !== void 0 ? _object$maxValidators : 0;
    message.maxEntries = (_object$maxEntries = object.maxEntries) !== null && _object$maxEntries !== void 0 ? _object$maxEntries : 0;
    message.historicalEntries = (_object$historicalEnt = object.historicalEntries) !== null && _object$historicalEnt !== void 0 ? _object$historicalEnt : 0;
    message.bondDenom = (_object$bondDenom = object.bondDenom) !== null && _object$bondDenom !== void 0 ? _object$bondDenom : "";
    message.minCommissionRate = (_object$minCommission = object.minCommissionRate) !== null && _object$minCommission !== void 0 ? _object$minCommission : "";
    message.minSelfDelegation = (_object$minSelfDelega2 = object.minSelfDelegation) !== null && _object$minSelfDelega2 !== void 0 ? _object$minSelfDelega2 : "";
    return message;
  },

  fromAmino(object) {
    return {
      unbondingTime: object !== null && object !== void 0 && object.unbonding_time ? _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_3__.Duration.fromAmino(object.unbonding_time) : undefined,
      maxValidators: object.max_validators,
      maxEntries: object.max_entries,
      historicalEntries: object.historical_entries,
      bondDenom: object.bond_denom,
      minCommissionRate: object.min_commission_rate,
      minSelfDelegation: object.min_self_delegation
    };
  },

  toAmino(message) {
    const obj = {};
    obj.unbonding_time = message.unbondingTime ? _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_3__.Duration.toAmino(message.unbondingTime) : undefined;
    obj.max_validators = message.maxValidators;
    obj.max_entries = message.maxEntries;
    obj.historical_entries = message.historicalEntries;
    obj.bond_denom = message.bondDenom;
    obj.min_commission_rate = message.minCommissionRate;
    obj.min_self_delegation = message.minSelfDelegation;
    return obj;
  },

  fromAminoMsg(object) {
    return Params.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/x/staking/Params",
      value: Params.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return Params.decode(message.value);
  },

  toProto(message) {
    return Params.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.Params",
      value: Params.encode(message).finish()
    };
  }

};

function createBaseDelegationResponse() {
  return {
    delegation: undefined,
    balance: undefined
  };
}

const DelegationResponse = {
  typeUrl: "/cosmos.staking.v1beta1.DelegationResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    if (message.delegation !== undefined) {
      Delegation.encode(message.delegation, writer.uint32(10).fork()).ldelim();
    }

    if (message.balance !== undefined) {
      _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_4__.Coin.encode(message.balance, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDelegationResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.delegation = Delegation.decode(reader, reader.uint32());
          break;

        case 2:
          message.balance = _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_4__.Coin.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseDelegationResponse();
    message.delegation = object.delegation !== undefined && object.delegation !== null ? Delegation.fromPartial(object.delegation) : undefined;
    message.balance = object.balance !== undefined && object.balance !== null ? _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_4__.Coin.fromPartial(object.balance) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      delegation: object !== null && object !== void 0 && object.delegation ? Delegation.fromAmino(object.delegation) : undefined,
      balance: object !== null && object !== void 0 && object.balance ? _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_4__.Coin.fromAmino(object.balance) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.delegation = message.delegation ? Delegation.toAmino(message.delegation) : undefined;
    obj.balance = message.balance ? _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_4__.Coin.toAmino(message.balance) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return DelegationResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/DelegationResponse",
      value: DelegationResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return DelegationResponse.decode(message.value);
  },

  toProto(message) {
    return DelegationResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.DelegationResponse",
      value: DelegationResponse.encode(message).finish()
    };
  }

};

function createBaseRedelegationEntryResponse() {
  return {
    redelegationEntry: undefined,
    balance: ""
  };
}

const RedelegationEntryResponse = {
  typeUrl: "/cosmos.staking.v1beta1.RedelegationEntryResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    if (message.redelegationEntry !== undefined) {
      RedelegationEntry.encode(message.redelegationEntry, writer.uint32(10).fork()).ldelim();
    }

    if (message.balance !== "") {
      writer.uint32(34).string(message.balance);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRedelegationEntryResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.redelegationEntry = RedelegationEntry.decode(reader, reader.uint32());
          break;

        case 4:
          message.balance = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$balance2;

    const message = createBaseRedelegationEntryResponse();
    message.redelegationEntry = object.redelegationEntry !== undefined && object.redelegationEntry !== null ? RedelegationEntry.fromPartial(object.redelegationEntry) : undefined;
    message.balance = (_object$balance2 = object.balance) !== null && _object$balance2 !== void 0 ? _object$balance2 : "";
    return message;
  },

  fromAmino(object) {
    return {
      redelegationEntry: object !== null && object !== void 0 && object.redelegation_entry ? RedelegationEntry.fromAmino(object.redelegation_entry) : undefined,
      balance: object.balance
    };
  },

  toAmino(message) {
    const obj = {};
    obj.redelegation_entry = message.redelegationEntry ? RedelegationEntry.toAmino(message.redelegationEntry) : undefined;
    obj.balance = message.balance;
    return obj;
  },

  fromAminoMsg(object) {
    return RedelegationEntryResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/RedelegationEntryResponse",
      value: RedelegationEntryResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return RedelegationEntryResponse.decode(message.value);
  },

  toProto(message) {
    return RedelegationEntryResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.RedelegationEntryResponse",
      value: RedelegationEntryResponse.encode(message).finish()
    };
  }

};

function createBaseRedelegationResponse() {
  return {
    redelegation: undefined,
    entries: []
  };
}

const RedelegationResponse = {
  typeUrl: "/cosmos.staking.v1beta1.RedelegationResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    if (message.redelegation !== undefined) {
      Redelegation.encode(message.redelegation, writer.uint32(10).fork()).ldelim();
    }

    for (const v of message.entries) {
      RedelegationEntryResponse.encode(v, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRedelegationResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.redelegation = Redelegation.decode(reader, reader.uint32());
          break;

        case 2:
          message.entries.push(RedelegationEntryResponse.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$entries3;

    const message = createBaseRedelegationResponse();
    message.redelegation = object.redelegation !== undefined && object.redelegation !== null ? Redelegation.fromPartial(object.redelegation) : undefined;
    message.entries = ((_object$entries3 = object.entries) === null || _object$entries3 === void 0 ? void 0 : _object$entries3.map(e => RedelegationEntryResponse.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      redelegation: object !== null && object !== void 0 && object.redelegation ? Redelegation.fromAmino(object.redelegation) : undefined,
      entries: Array.isArray(object === null || object === void 0 ? void 0 : object.entries) ? object.entries.map(e => RedelegationEntryResponse.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.redelegation = message.redelegation ? Redelegation.toAmino(message.redelegation) : undefined;

    if (message.entries) {
      obj.entries = message.entries.map(e => e ? RedelegationEntryResponse.toAmino(e) : undefined);
    } else {
      obj.entries = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return RedelegationResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/RedelegationResponse",
      value: RedelegationResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return RedelegationResponse.decode(message.value);
  },

  toProto(message) {
    return RedelegationResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.RedelegationResponse",
      value: RedelegationResponse.encode(message).finish()
    };
  }

};

function createBasePool() {
  return {
    notBondedTokens: "",
    bondedTokens: ""
  };
}

const Pool = {
  typeUrl: "/cosmos.staking.v1beta1.Pool",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    if (message.notBondedTokens !== "") {
      writer.uint32(10).string(message.notBondedTokens);
    }

    if (message.bondedTokens !== "") {
      writer.uint32(18).string(message.bondedTokens);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePool();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.notBondedTokens = reader.string();
          break;

        case 2:
          message.bondedTokens = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$notBondedToke, _object$bondedTokens;

    const message = createBasePool();
    message.notBondedTokens = (_object$notBondedToke = object.notBondedTokens) !== null && _object$notBondedToke !== void 0 ? _object$notBondedToke : "";
    message.bondedTokens = (_object$bondedTokens = object.bondedTokens) !== null && _object$bondedTokens !== void 0 ? _object$bondedTokens : "";
    return message;
  },

  fromAmino(object) {
    return {
      notBondedTokens: object.not_bonded_tokens,
      bondedTokens: object.bonded_tokens
    };
  },

  toAmino(message) {
    const obj = {};
    obj.not_bonded_tokens = message.notBondedTokens;
    obj.bonded_tokens = message.bondedTokens;
    return obj;
  },

  fromAminoMsg(object) {
    return Pool.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/Pool",
      value: Pool.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return Pool.decode(message.value);
  },

  toProto(message) {
    return Pool.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.Pool",
      value: Pool.encode(message).finish()
    };
  }

};
const Cosmos_cryptoPubKey_InterfaceDecoder = input => {
  const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
  const data = _google_protobuf_any__WEBPACK_IMPORTED_MODULE_2__.Any.decode(reader, reader.uint32());

  switch (data.typeUrl) {
    default:
      return data;
  }
};
const Cosmos_cryptoPubKey_FromAmino = content => {
  return (0,_cosmjs_amino__WEBPACK_IMPORTED_MODULE_8__/* .encodeBech32Pubkey */ .N2)({
    type: "tendermint/PubKeySecp256k1",
    value: (0,_cosmjs_encoding__WEBPACK_IMPORTED_MODULE_7__.toBase64)(content.value)
  }, "cosmos");
};
const Cosmos_cryptoPubKey_ToAmino = content => {
  return {
    typeUrl: "/cosmos.crypto.secp256k1.PubKey",
    value: (0,_cosmjs_encoding__WEBPACK_IMPORTED_MODULE_7__.fromBase64)((0,_cosmjs_amino__WEBPACK_IMPORTED_MODULE_8__/* .decodeBech32Pubkey */ .xC)(content).value)
  };
};

/***/ }),

/***/ 9605:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cosmos_cryptoPubKey_FromAmino": function() { return /* binding */ Cosmos_cryptoPubKey_FromAmino; },
/* harmony export */   "Cosmos_cryptoPubKey_InterfaceDecoder": function() { return /* binding */ Cosmos_cryptoPubKey_InterfaceDecoder; },
/* harmony export */   "Cosmos_cryptoPubKey_ToAmino": function() { return /* binding */ Cosmos_cryptoPubKey_ToAmino; },
/* harmony export */   "MsgBeginRedelegate": function() { return /* binding */ MsgBeginRedelegate; },
/* harmony export */   "MsgBeginRedelegateResponse": function() { return /* binding */ MsgBeginRedelegateResponse; },
/* harmony export */   "MsgCreateValidator": function() { return /* binding */ MsgCreateValidator; },
/* harmony export */   "MsgCreateValidatorResponse": function() { return /* binding */ MsgCreateValidatorResponse; },
/* harmony export */   "MsgDelegate": function() { return /* binding */ MsgDelegate; },
/* harmony export */   "MsgDelegateResponse": function() { return /* binding */ MsgDelegateResponse; },
/* harmony export */   "MsgEditValidator": function() { return /* binding */ MsgEditValidator; },
/* harmony export */   "MsgEditValidatorResponse": function() { return /* binding */ MsgEditValidatorResponse; },
/* harmony export */   "MsgUndelegate": function() { return /* binding */ MsgUndelegate; },
/* harmony export */   "MsgUndelegateResponse": function() { return /* binding */ MsgUndelegateResponse; }
/* harmony export */ });
/* harmony import */ var _staking__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56959);
/* harmony import */ var _google_protobuf_any__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32106);
/* harmony import */ var _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26178);
/* harmony import */ var _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20633);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _cosmjs_encoding__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(71555);
/* harmony import */ var _cosmjs_amino__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52105);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(47895);








/** MsgCreateValidator defines a SDK message for creating a new validator. */

function createBaseMsgCreateValidator() {
  return {
    description: undefined,
    commission: undefined,
    minSelfDelegation: "",
    delegatorAddress: "",
    validatorAddress: "",
    pubkey: undefined,
    value: undefined
  };
}

const MsgCreateValidator = {
  typeUrl: "/cosmos.staking.v1beta1.MsgCreateValidator",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    if (message.description !== undefined) {
      _staking__WEBPACK_IMPORTED_MODULE_0__.Description.encode(message.description, writer.uint32(10).fork()).ldelim();
    }

    if (message.commission !== undefined) {
      _staking__WEBPACK_IMPORTED_MODULE_0__.CommissionRates.encode(message.commission, writer.uint32(18).fork()).ldelim();
    }

    if (message.minSelfDelegation !== "") {
      writer.uint32(26).string(message.minSelfDelegation);
    }

    if (message.delegatorAddress !== "") {
      writer.uint32(34).string(message.delegatorAddress);
    }

    if (message.validatorAddress !== "") {
      writer.uint32(42).string(message.validatorAddress);
    }

    if (message.pubkey !== undefined) {
      _google_protobuf_any__WEBPACK_IMPORTED_MODULE_1__.Any.encode(message.pubkey, writer.uint32(50).fork()).ldelim();
    }

    if (message.value !== undefined) {
      _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_2__.Coin.encode(message.value, writer.uint32(58).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgCreateValidator();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.description = _staking__WEBPACK_IMPORTED_MODULE_0__.Description.decode(reader, reader.uint32());
          break;

        case 2:
          message.commission = _staking__WEBPACK_IMPORTED_MODULE_0__.CommissionRates.decode(reader, reader.uint32());
          break;

        case 3:
          message.minSelfDelegation = reader.string();
          break;

        case 4:
          message.delegatorAddress = reader.string();
          break;

        case 5:
          message.validatorAddress = reader.string();
          break;

        case 6:
          message.pubkey = Cosmos_cryptoPubKey_InterfaceDecoder(reader);
          break;

        case 7:
          message.value = _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_2__.Coin.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$minSelfDelega, _object$delegatorAddr, _object$validatorAddr;

    const message = createBaseMsgCreateValidator();
    message.description = object.description !== undefined && object.description !== null ? _staking__WEBPACK_IMPORTED_MODULE_0__.Description.fromPartial(object.description) : undefined;
    message.commission = object.commission !== undefined && object.commission !== null ? _staking__WEBPACK_IMPORTED_MODULE_0__.CommissionRates.fromPartial(object.commission) : undefined;
    message.minSelfDelegation = (_object$minSelfDelega = object.minSelfDelegation) !== null && _object$minSelfDelega !== void 0 ? _object$minSelfDelega : "";
    message.delegatorAddress = (_object$delegatorAddr = object.delegatorAddress) !== null && _object$delegatorAddr !== void 0 ? _object$delegatorAddr : "";
    message.validatorAddress = (_object$validatorAddr = object.validatorAddress) !== null && _object$validatorAddr !== void 0 ? _object$validatorAddr : "";
    message.pubkey = object.pubkey !== undefined && object.pubkey !== null ? _google_protobuf_any__WEBPACK_IMPORTED_MODULE_1__.Any.fromPartial(object.pubkey) : undefined;
    message.value = object.value !== undefined && object.value !== null ? _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_2__.Coin.fromPartial(object.value) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      description: object !== null && object !== void 0 && object.description ? _staking__WEBPACK_IMPORTED_MODULE_0__.Description.fromAmino(object.description) : undefined,
      commission: object !== null && object !== void 0 && object.commission ? _staking__WEBPACK_IMPORTED_MODULE_0__.CommissionRates.fromAmino(object.commission) : undefined,
      minSelfDelegation: object.min_self_delegation,
      delegatorAddress: object.delegator_address,
      validatorAddress: object.validator_address,
      pubkey: (0,_cosmjs_amino__WEBPACK_IMPORTED_MODULE_6__/* .encodeBech32Pubkey */ .N2)({
        type: "tendermint/PubKeySecp256k1",
        value: (0,_cosmjs_encoding__WEBPACK_IMPORTED_MODULE_5__.toBase64)(object.pubkey.value)
      }, "cosmos"),
      value: object !== null && object !== void 0 && object.value ? _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_2__.Coin.fromAmino(object.value) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.description = message.description ? _staking__WEBPACK_IMPORTED_MODULE_0__.Description.toAmino(message.description) : undefined;
    obj.commission = message.commission ? _staking__WEBPACK_IMPORTED_MODULE_0__.CommissionRates.toAmino(message.commission) : undefined;
    obj.min_self_delegation = message.minSelfDelegation;
    obj.delegator_address = message.delegatorAddress;
    obj.validator_address = message.validatorAddress;
    obj.pubkey = message.pubkey ? {
      typeUrl: "/cosmos.crypto.secp256k1.PubKey",
      value: (0,_cosmjs_encoding__WEBPACK_IMPORTED_MODULE_5__.fromBase64)((0,_cosmjs_amino__WEBPACK_IMPORTED_MODULE_6__/* .decodeBech32Pubkey */ .xC)(message.pubkey).value)
    } : undefined;
    obj.value = message.value ? _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_2__.Coin.toAmino(message.value) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgCreateValidator.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/MsgCreateValidator",
      value: MsgCreateValidator.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgCreateValidator.decode(message.value);
  },

  toProto(message) {
    return MsgCreateValidator.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.MsgCreateValidator",
      value: MsgCreateValidator.encode(message).finish()
    };
  }

};

function createBaseMsgCreateValidatorResponse() {
  return {};
}

const MsgCreateValidatorResponse = {
  typeUrl: "/cosmos.staking.v1beta1.MsgCreateValidatorResponse",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgCreateValidatorResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseMsgCreateValidatorResponse();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return MsgCreateValidatorResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/MsgCreateValidatorResponse",
      value: MsgCreateValidatorResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgCreateValidatorResponse.decode(message.value);
  },

  toProto(message) {
    return MsgCreateValidatorResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.MsgCreateValidatorResponse",
      value: MsgCreateValidatorResponse.encode(message).finish()
    };
  }

};

function createBaseMsgEditValidator() {
  return {
    description: undefined,
    validatorAddress: "",
    commissionRate: "",
    minSelfDelegation: ""
  };
}

const MsgEditValidator = {
  typeUrl: "/cosmos.staking.v1beta1.MsgEditValidator",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    if (message.description !== undefined) {
      _staking__WEBPACK_IMPORTED_MODULE_0__.Description.encode(message.description, writer.uint32(10).fork()).ldelim();
    }

    if (message.validatorAddress !== "") {
      writer.uint32(18).string(message.validatorAddress);
    }

    if (message.commissionRate !== "") {
      writer.uint32(26).string(message.commissionRate);
    }

    if (message.minSelfDelegation !== "") {
      writer.uint32(34).string(message.minSelfDelegation);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgEditValidator();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.description = _staking__WEBPACK_IMPORTED_MODULE_0__.Description.decode(reader, reader.uint32());
          break;

        case 2:
          message.validatorAddress = reader.string();
          break;

        case 3:
          message.commissionRate = reader.string();
          break;

        case 4:
          message.minSelfDelegation = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$validatorAddr2, _object$commissionRat, _object$minSelfDelega2;

    const message = createBaseMsgEditValidator();
    message.description = object.description !== undefined && object.description !== null ? _staking__WEBPACK_IMPORTED_MODULE_0__.Description.fromPartial(object.description) : undefined;
    message.validatorAddress = (_object$validatorAddr2 = object.validatorAddress) !== null && _object$validatorAddr2 !== void 0 ? _object$validatorAddr2 : "";
    message.commissionRate = (_object$commissionRat = object.commissionRate) !== null && _object$commissionRat !== void 0 ? _object$commissionRat : "";
    message.minSelfDelegation = (_object$minSelfDelega2 = object.minSelfDelegation) !== null && _object$minSelfDelega2 !== void 0 ? _object$minSelfDelega2 : "";
    return message;
  },

  fromAmino(object) {
    return {
      description: object !== null && object !== void 0 && object.description ? _staking__WEBPACK_IMPORTED_MODULE_0__.Description.fromAmino(object.description) : undefined,
      validatorAddress: object.validator_address,
      commissionRate: object.commission_rate,
      minSelfDelegation: object.min_self_delegation
    };
  },

  toAmino(message) {
    const obj = {};
    obj.description = message.description ? _staking__WEBPACK_IMPORTED_MODULE_0__.Description.toAmino(message.description) : undefined;
    obj.validator_address = message.validatorAddress;
    obj.commission_rate = message.commissionRate;
    obj.min_self_delegation = message.minSelfDelegation;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgEditValidator.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/MsgEditValidator",
      value: MsgEditValidator.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgEditValidator.decode(message.value);
  },

  toProto(message) {
    return MsgEditValidator.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.MsgEditValidator",
      value: MsgEditValidator.encode(message).finish()
    };
  }

};

function createBaseMsgEditValidatorResponse() {
  return {};
}

const MsgEditValidatorResponse = {
  typeUrl: "/cosmos.staking.v1beta1.MsgEditValidatorResponse",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgEditValidatorResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseMsgEditValidatorResponse();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return MsgEditValidatorResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/MsgEditValidatorResponse",
      value: MsgEditValidatorResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgEditValidatorResponse.decode(message.value);
  },

  toProto(message) {
    return MsgEditValidatorResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.MsgEditValidatorResponse",
      value: MsgEditValidatorResponse.encode(message).finish()
    };
  }

};

function createBaseMsgDelegate() {
  return {
    delegatorAddress: "",
    validatorAddress: "",
    amount: undefined
  };
}

const MsgDelegate = {
  typeUrl: "/cosmos.staking.v1beta1.MsgDelegate",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    if (message.delegatorAddress !== "") {
      writer.uint32(10).string(message.delegatorAddress);
    }

    if (message.validatorAddress !== "") {
      writer.uint32(18).string(message.validatorAddress);
    }

    if (message.amount !== undefined) {
      _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_2__.Coin.encode(message.amount, writer.uint32(26).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgDelegate();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.delegatorAddress = reader.string();
          break;

        case 2:
          message.validatorAddress = reader.string();
          break;

        case 3:
          message.amount = _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_2__.Coin.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$delegatorAddr2, _object$validatorAddr3;

    const message = createBaseMsgDelegate();
    message.delegatorAddress = (_object$delegatorAddr2 = object.delegatorAddress) !== null && _object$delegatorAddr2 !== void 0 ? _object$delegatorAddr2 : "";
    message.validatorAddress = (_object$validatorAddr3 = object.validatorAddress) !== null && _object$validatorAddr3 !== void 0 ? _object$validatorAddr3 : "";
    message.amount = object.amount !== undefined && object.amount !== null ? _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_2__.Coin.fromPartial(object.amount) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      delegatorAddress: object.delegator_address,
      validatorAddress: object.validator_address,
      amount: object !== null && object !== void 0 && object.amount ? _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_2__.Coin.fromAmino(object.amount) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.delegator_address = message.delegatorAddress;
    obj.validator_address = message.validatorAddress;
    obj.amount = message.amount ? _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_2__.Coin.toAmino(message.amount) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgDelegate.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/MsgDelegate",
      value: MsgDelegate.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgDelegate.decode(message.value);
  },

  toProto(message) {
    return MsgDelegate.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.MsgDelegate",
      value: MsgDelegate.encode(message).finish()
    };
  }

};

function createBaseMsgDelegateResponse() {
  return {};
}

const MsgDelegateResponse = {
  typeUrl: "/cosmos.staking.v1beta1.MsgDelegateResponse",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgDelegateResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseMsgDelegateResponse();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return MsgDelegateResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/MsgDelegateResponse",
      value: MsgDelegateResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgDelegateResponse.decode(message.value);
  },

  toProto(message) {
    return MsgDelegateResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.MsgDelegateResponse",
      value: MsgDelegateResponse.encode(message).finish()
    };
  }

};

function createBaseMsgBeginRedelegate() {
  return {
    delegatorAddress: "",
    validatorSrcAddress: "",
    validatorDstAddress: "",
    amount: undefined
  };
}

const MsgBeginRedelegate = {
  typeUrl: "/cosmos.staking.v1beta1.MsgBeginRedelegate",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    if (message.delegatorAddress !== "") {
      writer.uint32(10).string(message.delegatorAddress);
    }

    if (message.validatorSrcAddress !== "") {
      writer.uint32(18).string(message.validatorSrcAddress);
    }

    if (message.validatorDstAddress !== "") {
      writer.uint32(26).string(message.validatorDstAddress);
    }

    if (message.amount !== undefined) {
      _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_2__.Coin.encode(message.amount, writer.uint32(34).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgBeginRedelegate();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.delegatorAddress = reader.string();
          break;

        case 2:
          message.validatorSrcAddress = reader.string();
          break;

        case 3:
          message.validatorDstAddress = reader.string();
          break;

        case 4:
          message.amount = _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_2__.Coin.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$delegatorAddr3, _object$validatorSrcA, _object$validatorDstA;

    const message = createBaseMsgBeginRedelegate();
    message.delegatorAddress = (_object$delegatorAddr3 = object.delegatorAddress) !== null && _object$delegatorAddr3 !== void 0 ? _object$delegatorAddr3 : "";
    message.validatorSrcAddress = (_object$validatorSrcA = object.validatorSrcAddress) !== null && _object$validatorSrcA !== void 0 ? _object$validatorSrcA : "";
    message.validatorDstAddress = (_object$validatorDstA = object.validatorDstAddress) !== null && _object$validatorDstA !== void 0 ? _object$validatorDstA : "";
    message.amount = object.amount !== undefined && object.amount !== null ? _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_2__.Coin.fromPartial(object.amount) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      delegatorAddress: object.delegator_address,
      validatorSrcAddress: object.validator_src_address,
      validatorDstAddress: object.validator_dst_address,
      amount: object !== null && object !== void 0 && object.amount ? _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_2__.Coin.fromAmino(object.amount) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.delegator_address = message.delegatorAddress;
    obj.validator_src_address = message.validatorSrcAddress;
    obj.validator_dst_address = message.validatorDstAddress;
    obj.amount = message.amount ? _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_2__.Coin.toAmino(message.amount) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgBeginRedelegate.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/MsgBeginRedelegate",
      value: MsgBeginRedelegate.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgBeginRedelegate.decode(message.value);
  },

  toProto(message) {
    return MsgBeginRedelegate.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.MsgBeginRedelegate",
      value: MsgBeginRedelegate.encode(message).finish()
    };
  }

};

function createBaseMsgBeginRedelegateResponse() {
  return {
    completionTime: undefined
  };
}

const MsgBeginRedelegateResponse = {
  typeUrl: "/cosmos.staking.v1beta1.MsgBeginRedelegateResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    if (message.completionTime !== undefined) {
      _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_3__.Timestamp.encode((0,_helpers__WEBPACK_IMPORTED_MODULE_7__/* .toTimestamp */ .Uq)(message.completionTime), writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgBeginRedelegateResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.completionTime = (0,_helpers__WEBPACK_IMPORTED_MODULE_7__/* .fromTimestamp */ .Ol)(_google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_3__.Timestamp.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$completionTim;

    const message = createBaseMsgBeginRedelegateResponse();
    message.completionTime = (_object$completionTim = object.completionTime) !== null && _object$completionTim !== void 0 ? _object$completionTim : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      completionTime: object !== null && object !== void 0 && object.completion_time ? _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_3__.Timestamp.fromAmino(object.completion_time) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.completion_time = message.completionTime ? _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_3__.Timestamp.toAmino(message.completionTime) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgBeginRedelegateResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/MsgBeginRedelegateResponse",
      value: MsgBeginRedelegateResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgBeginRedelegateResponse.decode(message.value);
  },

  toProto(message) {
    return MsgBeginRedelegateResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.MsgBeginRedelegateResponse",
      value: MsgBeginRedelegateResponse.encode(message).finish()
    };
  }

};

function createBaseMsgUndelegate() {
  return {
    delegatorAddress: "",
    validatorAddress: "",
    amount: undefined
  };
}

const MsgUndelegate = {
  typeUrl: "/cosmos.staking.v1beta1.MsgUndelegate",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    if (message.delegatorAddress !== "") {
      writer.uint32(10).string(message.delegatorAddress);
    }

    if (message.validatorAddress !== "") {
      writer.uint32(18).string(message.validatorAddress);
    }

    if (message.amount !== undefined) {
      _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_2__.Coin.encode(message.amount, writer.uint32(26).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgUndelegate();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.delegatorAddress = reader.string();
          break;

        case 2:
          message.validatorAddress = reader.string();
          break;

        case 3:
          message.amount = _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_2__.Coin.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$delegatorAddr4, _object$validatorAddr4;

    const message = createBaseMsgUndelegate();
    message.delegatorAddress = (_object$delegatorAddr4 = object.delegatorAddress) !== null && _object$delegatorAddr4 !== void 0 ? _object$delegatorAddr4 : "";
    message.validatorAddress = (_object$validatorAddr4 = object.validatorAddress) !== null && _object$validatorAddr4 !== void 0 ? _object$validatorAddr4 : "";
    message.amount = object.amount !== undefined && object.amount !== null ? _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_2__.Coin.fromPartial(object.amount) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      delegatorAddress: object.delegator_address,
      validatorAddress: object.validator_address,
      amount: object !== null && object !== void 0 && object.amount ? _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_2__.Coin.fromAmino(object.amount) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.delegator_address = message.delegatorAddress;
    obj.validator_address = message.validatorAddress;
    obj.amount = message.amount ? _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_2__.Coin.toAmino(message.amount) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgUndelegate.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/MsgUndelegate",
      value: MsgUndelegate.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgUndelegate.decode(message.value);
  },

  toProto(message) {
    return MsgUndelegate.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.MsgUndelegate",
      value: MsgUndelegate.encode(message).finish()
    };
  }

};

function createBaseMsgUndelegateResponse() {
  return {
    completionTime: undefined
  };
}

const MsgUndelegateResponse = {
  typeUrl: "/cosmos.staking.v1beta1.MsgUndelegateResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    if (message.completionTime !== undefined) {
      _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_3__.Timestamp.encode((0,_helpers__WEBPACK_IMPORTED_MODULE_7__/* .toTimestamp */ .Uq)(message.completionTime), writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgUndelegateResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.completionTime = (0,_helpers__WEBPACK_IMPORTED_MODULE_7__/* .fromTimestamp */ .Ol)(_google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_3__.Timestamp.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$completionTim2;

    const message = createBaseMsgUndelegateResponse();
    message.completionTime = (_object$completionTim2 = object.completionTime) !== null && _object$completionTim2 !== void 0 ? _object$completionTim2 : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      completionTime: object !== null && object !== void 0 && object.completion_time ? _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_3__.Timestamp.fromAmino(object.completion_time) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.completion_time = message.completionTime ? _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_3__.Timestamp.toAmino(message.completionTime) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgUndelegateResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/MsgUndelegateResponse",
      value: MsgUndelegateResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgUndelegateResponse.decode(message.value);
  },

  toProto(message) {
    return MsgUndelegateResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.MsgUndelegateResponse",
      value: MsgUndelegateResponse.encode(message).finish()
    };
  }

};
const Cosmos_cryptoPubKey_InterfaceDecoder = input => {
  const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
  const data = _google_protobuf_any__WEBPACK_IMPORTED_MODULE_1__.Any.decode(reader, reader.uint32());

  switch (data.typeUrl) {
    default:
      return data;
  }
};
const Cosmos_cryptoPubKey_FromAmino = content => {
  return (0,_cosmjs_amino__WEBPACK_IMPORTED_MODULE_6__/* .encodeBech32Pubkey */ .N2)({
    type: "tendermint/PubKeySecp256k1",
    value: (0,_cosmjs_encoding__WEBPACK_IMPORTED_MODULE_5__.toBase64)(content.value)
  }, "cosmos");
};
const Cosmos_cryptoPubKey_ToAmino = content => {
  return {
    typeUrl: "/cosmos.crypto.secp256k1.PubKey",
    value: (0,_cosmjs_encoding__WEBPACK_IMPORTED_MODULE_5__.fromBase64)((0,_cosmjs_amino__WEBPACK_IMPORTED_MODULE_6__/* .decodeBech32Pubkey */ .xC)(content).value)
  };
};

/***/ }),

/***/ 34191:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MsgClientImpl": function() { return /* binding */ MsgClientImpl; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4942);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _tx__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9605);



/** Msg defines the staking Msg service. */

class MsgClientImpl {
  constructor(rpc) {
    (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, "rpc", void 0);

    this.rpc = rpc;
    this.createValidator = this.createValidator.bind(this);
    this.editValidator = this.editValidator.bind(this);
    this.delegate = this.delegate.bind(this);
    this.beginRedelegate = this.beginRedelegate.bind(this);
    this.undelegate = this.undelegate.bind(this);
  }

  createValidator(request) {
    const data = _tx__WEBPACK_IMPORTED_MODULE_1__.MsgCreateValidator.encode(request).finish();
    const promise = this.rpc.request("cosmos.staking.v1beta1.Msg", "CreateValidator", data);
    return promise.then(data => _tx__WEBPACK_IMPORTED_MODULE_1__.MsgCreateValidatorResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  editValidator(request) {
    const data = _tx__WEBPACK_IMPORTED_MODULE_1__.MsgEditValidator.encode(request).finish();
    const promise = this.rpc.request("cosmos.staking.v1beta1.Msg", "EditValidator", data);
    return promise.then(data => _tx__WEBPACK_IMPORTED_MODULE_1__.MsgEditValidatorResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  delegate(request) {
    const data = _tx__WEBPACK_IMPORTED_MODULE_1__.MsgDelegate.encode(request).finish();
    const promise = this.rpc.request("cosmos.staking.v1beta1.Msg", "Delegate", data);
    return promise.then(data => _tx__WEBPACK_IMPORTED_MODULE_1__.MsgDelegateResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  beginRedelegate(request) {
    const data = _tx__WEBPACK_IMPORTED_MODULE_1__.MsgBeginRedelegate.encode(request).finish();
    const promise = this.rpc.request("cosmos.staking.v1beta1.Msg", "BeginRedelegate", data);
    return promise.then(data => _tx__WEBPACK_IMPORTED_MODULE_1__.MsgBeginRedelegateResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  undelegate(request) {
    const data = _tx__WEBPACK_IMPORTED_MODULE_1__.MsgUndelegate.encode(request).finish();
    const promise = this.rpc.request("cosmos.staking.v1beta1.Msg", "Undelegate", data);
    return promise.then(data => _tx__WEBPACK_IMPORTED_MODULE_1__.MsgUndelegateResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

}

/***/ }),

/***/ 80828:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SignMode": function() { return /* binding */ SignMode; },
/* harmony export */   "SignModeAmino": function() { return /* binding */ SignModeAmino; },
/* harmony export */   "SignModeSDKType": function() { return /* binding */ SignModeSDKType; },
/* harmony export */   "SignatureDescriptor": function() { return /* binding */ SignatureDescriptor; },
/* harmony export */   "SignatureDescriptor_Data": function() { return /* binding */ SignatureDescriptor_Data; },
/* harmony export */   "SignatureDescriptor_Data_Multi": function() { return /* binding */ SignatureDescriptor_Data_Multi; },
/* harmony export */   "SignatureDescriptor_Data_Single": function() { return /* binding */ SignatureDescriptor_Data_Single; },
/* harmony export */   "SignatureDescriptors": function() { return /* binding */ SignatureDescriptors; },
/* harmony export */   "signModeFromJSON": function() { return /* binding */ signModeFromJSON; },
/* harmony export */   "signModeToJSON": function() { return /* binding */ signModeToJSON; }
/* harmony export */ });
/* harmony import */ var _crypto_multisig_v1beta1_multisig__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35301);
/* harmony import */ var _google_protobuf_any__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32106);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47895);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__);




/** SignMode represents a signing mode with its own security guarantees. */

let SignMode;

(function (SignMode) {
  SignMode[SignMode["SIGN_MODE_UNSPECIFIED"] = 0] = "SIGN_MODE_UNSPECIFIED";
  SignMode[SignMode["SIGN_MODE_DIRECT"] = 1] = "SIGN_MODE_DIRECT";
  SignMode[SignMode["SIGN_MODE_TEXTUAL"] = 2] = "SIGN_MODE_TEXTUAL";
  SignMode[SignMode["SIGN_MODE_LEGACY_AMINO_JSON"] = 127] = "SIGN_MODE_LEGACY_AMINO_JSON";
  SignMode[SignMode["SIGN_MODE_EIP_191"] = 191] = "SIGN_MODE_EIP_191";
  SignMode[SignMode["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(SignMode || (SignMode = {}));

const SignModeSDKType = SignMode;
const SignModeAmino = SignMode;
function signModeFromJSON(object) {
  switch (object) {
    case 0:
    case "SIGN_MODE_UNSPECIFIED":
      return SignMode.SIGN_MODE_UNSPECIFIED;

    case 1:
    case "SIGN_MODE_DIRECT":
      return SignMode.SIGN_MODE_DIRECT;

    case 2:
    case "SIGN_MODE_TEXTUAL":
      return SignMode.SIGN_MODE_TEXTUAL;

    case 127:
    case "SIGN_MODE_LEGACY_AMINO_JSON":
      return SignMode.SIGN_MODE_LEGACY_AMINO_JSON;

    case 191:
    case "SIGN_MODE_EIP_191":
      return SignMode.SIGN_MODE_EIP_191;

    case -1:
    case "UNRECOGNIZED":
    default:
      return SignMode.UNRECOGNIZED;
  }
}
function signModeToJSON(object) {
  switch (object) {
    case SignMode.SIGN_MODE_UNSPECIFIED:
      return "SIGN_MODE_UNSPECIFIED";

    case SignMode.SIGN_MODE_DIRECT:
      return "SIGN_MODE_DIRECT";

    case SignMode.SIGN_MODE_TEXTUAL:
      return "SIGN_MODE_TEXTUAL";

    case SignMode.SIGN_MODE_LEGACY_AMINO_JSON:
      return "SIGN_MODE_LEGACY_AMINO_JSON";

    case SignMode.SIGN_MODE_EIP_191:
      return "SIGN_MODE_EIP_191";

    case SignMode.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
/** SignatureDescriptors wraps multiple SignatureDescriptor's. */

function createBaseSignatureDescriptors() {
  return {
    signatures: []
  };
}

const SignatureDescriptors = {
  typeUrl: "/cosmos.tx.signing.v1beta1.SignatureDescriptors",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    for (const v of message.signatures) {
      SignatureDescriptor.encode(v, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSignatureDescriptors();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.signatures.push(SignatureDescriptor.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$signatures;

    const message = createBaseSignatureDescriptors();
    message.signatures = ((_object$signatures = object.signatures) === null || _object$signatures === void 0 ? void 0 : _object$signatures.map(e => SignatureDescriptor.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      signatures: Array.isArray(object === null || object === void 0 ? void 0 : object.signatures) ? object.signatures.map(e => SignatureDescriptor.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.signatures) {
      obj.signatures = message.signatures.map(e => e ? SignatureDescriptor.toAmino(e) : undefined);
    } else {
      obj.signatures = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return SignatureDescriptors.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/SignatureDescriptors",
      value: SignatureDescriptors.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return SignatureDescriptors.decode(message.value);
  },

  toProto(message) {
    return SignatureDescriptors.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.tx.signing.v1beta1.SignatureDescriptors",
      value: SignatureDescriptors.encode(message).finish()
    };
  }

};

function createBaseSignatureDescriptor() {
  return {
    publicKey: undefined,
    data: undefined,
    sequence: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO
  };
}

const SignatureDescriptor = {
  typeUrl: "/cosmos.tx.signing.v1beta1.SignatureDescriptor",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.publicKey !== undefined) {
      _google_protobuf_any__WEBPACK_IMPORTED_MODULE_1__.Any.encode(message.publicKey, writer.uint32(10).fork()).ldelim();
    }

    if (message.data !== undefined) {
      SignatureDescriptor_Data.encode(message.data, writer.uint32(18).fork()).ldelim();
    }

    if (!message.sequence.isZero()) {
      writer.uint32(24).uint64(message.sequence);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSignatureDescriptor();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.publicKey = _google_protobuf_any__WEBPACK_IMPORTED_MODULE_1__.Any.decode(reader, reader.uint32());
          break;

        case 2:
          message.data = SignatureDescriptor_Data.decode(reader, reader.uint32());
          break;

        case 3:
          message.sequence = reader.uint64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseSignatureDescriptor();
    message.publicKey = object.publicKey !== undefined && object.publicKey !== null ? _google_protobuf_any__WEBPACK_IMPORTED_MODULE_1__.Any.fromPartial(object.publicKey) : undefined;
    message.data = object.data !== undefined && object.data !== null ? SignatureDescriptor_Data.fromPartial(object.data) : undefined;
    message.sequence = object.sequence !== undefined && object.sequence !== null ? _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromValue */ .dK.fromValue(object.sequence) : _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO;
    return message;
  },

  fromAmino(object) {
    return {
      publicKey: object !== null && object !== void 0 && object.public_key ? _google_protobuf_any__WEBPACK_IMPORTED_MODULE_1__.Any.fromAmino(object.public_key) : undefined,
      data: object !== null && object !== void 0 && object.data ? SignatureDescriptor_Data.fromAmino(object.data) : undefined,
      sequence: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromString */ .dK.fromString(object.sequence)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.public_key = message.publicKey ? _google_protobuf_any__WEBPACK_IMPORTED_MODULE_1__.Any.toAmino(message.publicKey) : undefined;
    obj.data = message.data ? SignatureDescriptor_Data.toAmino(message.data) : undefined;
    obj.sequence = message.sequence ? message.sequence.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return SignatureDescriptor.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/SignatureDescriptor",
      value: SignatureDescriptor.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return SignatureDescriptor.decode(message.value);
  },

  toProto(message) {
    return SignatureDescriptor.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.tx.signing.v1beta1.SignatureDescriptor",
      value: SignatureDescriptor.encode(message).finish()
    };
  }

};

function createBaseSignatureDescriptor_Data() {
  return {
    single: undefined,
    multi: undefined
  };
}

const SignatureDescriptor_Data = {
  typeUrl: "/cosmos.tx.signing.v1beta1.Data",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.single !== undefined) {
      SignatureDescriptor_Data_Single.encode(message.single, writer.uint32(10).fork()).ldelim();
    }

    if (message.multi !== undefined) {
      SignatureDescriptor_Data_Multi.encode(message.multi, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSignatureDescriptor_Data();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.single = SignatureDescriptor_Data_Single.decode(reader, reader.uint32());
          break;

        case 2:
          message.multi = SignatureDescriptor_Data_Multi.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseSignatureDescriptor_Data();
    message.single = object.single !== undefined && object.single !== null ? SignatureDescriptor_Data_Single.fromPartial(object.single) : undefined;
    message.multi = object.multi !== undefined && object.multi !== null ? SignatureDescriptor_Data_Multi.fromPartial(object.multi) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      single: object !== null && object !== void 0 && object.single ? SignatureDescriptor_Data_Single.fromAmino(object.single) : undefined,
      multi: object !== null && object !== void 0 && object.multi ? SignatureDescriptor_Data_Multi.fromAmino(object.multi) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.single = message.single ? SignatureDescriptor_Data_Single.toAmino(message.single) : undefined;
    obj.multi = message.multi ? SignatureDescriptor_Data_Multi.toAmino(message.multi) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return SignatureDescriptor_Data.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/Data",
      value: SignatureDescriptor_Data.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return SignatureDescriptor_Data.decode(message.value);
  },

  toProto(message) {
    return SignatureDescriptor_Data.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.tx.signing.v1beta1.Data",
      value: SignatureDescriptor_Data.encode(message).finish()
    };
  }

};

function createBaseSignatureDescriptor_Data_Single() {
  return {
    mode: 0,
    signature: new Uint8Array()
  };
}

const SignatureDescriptor_Data_Single = {
  typeUrl: "/cosmos.tx.signing.v1beta1.Single",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.mode !== 0) {
      writer.uint32(8).int32(message.mode);
    }

    if (message.signature.length !== 0) {
      writer.uint32(18).bytes(message.signature);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSignatureDescriptor_Data_Single();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.mode = reader.int32();
          break;

        case 2:
          message.signature = reader.bytes();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$mode, _object$signature;

    const message = createBaseSignatureDescriptor_Data_Single();
    message.mode = (_object$mode = object.mode) !== null && _object$mode !== void 0 ? _object$mode : 0;
    message.signature = (_object$signature = object.signature) !== null && _object$signature !== void 0 ? _object$signature : new Uint8Array();
    return message;
  },

  fromAmino(object) {
    return {
      mode: (0,_helpers__WEBPACK_IMPORTED_MODULE_2__/* .isSet */ .DM)(object.mode) ? signModeFromJSON(object.mode) : 0,
      signature: object.signature
    };
  },

  toAmino(message) {
    const obj = {};
    obj.mode = message.mode;
    obj.signature = message.signature;
    return obj;
  },

  fromAminoMsg(object) {
    return SignatureDescriptor_Data_Single.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/Single",
      value: SignatureDescriptor_Data_Single.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return SignatureDescriptor_Data_Single.decode(message.value);
  },

  toProto(message) {
    return SignatureDescriptor_Data_Single.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.tx.signing.v1beta1.Single",
      value: SignatureDescriptor_Data_Single.encode(message).finish()
    };
  }

};

function createBaseSignatureDescriptor_Data_Multi() {
  return {
    bitarray: undefined,
    signatures: []
  };
}

const SignatureDescriptor_Data_Multi = {
  typeUrl: "/cosmos.tx.signing.v1beta1.Multi",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.bitarray !== undefined) {
      _crypto_multisig_v1beta1_multisig__WEBPACK_IMPORTED_MODULE_0__/* .CompactBitArray.encode */ .x.encode(message.bitarray, writer.uint32(10).fork()).ldelim();
    }

    for (const v of message.signatures) {
      SignatureDescriptor_Data.encode(v, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSignatureDescriptor_Data_Multi();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.bitarray = _crypto_multisig_v1beta1_multisig__WEBPACK_IMPORTED_MODULE_0__/* .CompactBitArray.decode */ .x.decode(reader, reader.uint32());
          break;

        case 2:
          message.signatures.push(SignatureDescriptor_Data.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$signatures2;

    const message = createBaseSignatureDescriptor_Data_Multi();
    message.bitarray = object.bitarray !== undefined && object.bitarray !== null ? _crypto_multisig_v1beta1_multisig__WEBPACK_IMPORTED_MODULE_0__/* .CompactBitArray.fromPartial */ .x.fromPartial(object.bitarray) : undefined;
    message.signatures = ((_object$signatures2 = object.signatures) === null || _object$signatures2 === void 0 ? void 0 : _object$signatures2.map(e => SignatureDescriptor_Data.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      bitarray: object !== null && object !== void 0 && object.bitarray ? _crypto_multisig_v1beta1_multisig__WEBPACK_IMPORTED_MODULE_0__/* .CompactBitArray.fromAmino */ .x.fromAmino(object.bitarray) : undefined,
      signatures: Array.isArray(object === null || object === void 0 ? void 0 : object.signatures) ? object.signatures.map(e => SignatureDescriptor_Data.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.bitarray = message.bitarray ? _crypto_multisig_v1beta1_multisig__WEBPACK_IMPORTED_MODULE_0__/* .CompactBitArray.toAmino */ .x.toAmino(message.bitarray) : undefined;

    if (message.signatures) {
      obj.signatures = message.signatures.map(e => e ? SignatureDescriptor_Data.toAmino(e) : undefined);
    } else {
      obj.signatures = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return SignatureDescriptor_Data_Multi.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/Multi",
      value: SignatureDescriptor_Data_Multi.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return SignatureDescriptor_Data_Multi.decode(message.value);
  },

  toProto(message) {
    return SignatureDescriptor_Data_Multi.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.tx.signing.v1beta1.Multi",
      value: SignatureDescriptor_Data_Multi.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 89242:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BroadcastMode": function() { return /* binding */ BroadcastMode; },
/* harmony export */   "BroadcastModeAmino": function() { return /* binding */ BroadcastModeAmino; },
/* harmony export */   "BroadcastModeSDKType": function() { return /* binding */ BroadcastModeSDKType; },
/* harmony export */   "BroadcastTxRequest": function() { return /* binding */ BroadcastTxRequest; },
/* harmony export */   "BroadcastTxResponse": function() { return /* binding */ BroadcastTxResponse; },
/* harmony export */   "GetTxRequest": function() { return /* binding */ GetTxRequest; },
/* harmony export */   "GetTxResponse": function() { return /* binding */ GetTxResponse; },
/* harmony export */   "GetTxsEventRequest": function() { return /* binding */ GetTxsEventRequest; },
/* harmony export */   "GetTxsEventResponse": function() { return /* binding */ GetTxsEventResponse; },
/* harmony export */   "OrderBy": function() { return /* binding */ OrderBy; },
/* harmony export */   "OrderByAmino": function() { return /* binding */ OrderByAmino; },
/* harmony export */   "OrderBySDKType": function() { return /* binding */ OrderBySDKType; },
/* harmony export */   "SimulateRequest": function() { return /* binding */ SimulateRequest; },
/* harmony export */   "SimulateResponse": function() { return /* binding */ SimulateResponse; },
/* harmony export */   "broadcastModeFromJSON": function() { return /* binding */ broadcastModeFromJSON; },
/* harmony export */   "broadcastModeToJSON": function() { return /* binding */ broadcastModeToJSON; },
/* harmony export */   "orderByFromJSON": function() { return /* binding */ orderByFromJSON; },
/* harmony export */   "orderByToJSON": function() { return /* binding */ orderByToJSON; }
/* harmony export */ });
/* harmony import */ var _tx__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20673);
/* harmony import */ var _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48978);
/* harmony import */ var _base_abci_v1beta1_abci__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93049);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47895);





/** OrderBy defines the sorting order */

let OrderBy;

(function (OrderBy) {
  OrderBy[OrderBy["ORDER_BY_UNSPECIFIED"] = 0] = "ORDER_BY_UNSPECIFIED";
  OrderBy[OrderBy["ORDER_BY_ASC"] = 1] = "ORDER_BY_ASC";
  OrderBy[OrderBy["ORDER_BY_DESC"] = 2] = "ORDER_BY_DESC";
  OrderBy[OrderBy["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(OrderBy || (OrderBy = {}));

const OrderBySDKType = OrderBy;
const OrderByAmino = OrderBy;
function orderByFromJSON(object) {
  switch (object) {
    case 0:
    case "ORDER_BY_UNSPECIFIED":
      return OrderBy.ORDER_BY_UNSPECIFIED;

    case 1:
    case "ORDER_BY_ASC":
      return OrderBy.ORDER_BY_ASC;

    case 2:
    case "ORDER_BY_DESC":
      return OrderBy.ORDER_BY_DESC;

    case -1:
    case "UNRECOGNIZED":
    default:
      return OrderBy.UNRECOGNIZED;
  }
}
function orderByToJSON(object) {
  switch (object) {
    case OrderBy.ORDER_BY_UNSPECIFIED:
      return "ORDER_BY_UNSPECIFIED";

    case OrderBy.ORDER_BY_ASC:
      return "ORDER_BY_ASC";

    case OrderBy.ORDER_BY_DESC:
      return "ORDER_BY_DESC";

    case OrderBy.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
/** BroadcastMode specifies the broadcast mode for the TxService.Broadcast RPC method. */

let BroadcastMode;

(function (BroadcastMode) {
  BroadcastMode[BroadcastMode["BROADCAST_MODE_UNSPECIFIED"] = 0] = "BROADCAST_MODE_UNSPECIFIED";
  BroadcastMode[BroadcastMode["BROADCAST_MODE_BLOCK"] = 1] = "BROADCAST_MODE_BLOCK";
  BroadcastMode[BroadcastMode["BROADCAST_MODE_SYNC"] = 2] = "BROADCAST_MODE_SYNC";
  BroadcastMode[BroadcastMode["BROADCAST_MODE_ASYNC"] = 3] = "BROADCAST_MODE_ASYNC";
  BroadcastMode[BroadcastMode["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(BroadcastMode || (BroadcastMode = {}));

const BroadcastModeSDKType = BroadcastMode;
const BroadcastModeAmino = BroadcastMode;
function broadcastModeFromJSON(object) {
  switch (object) {
    case 0:
    case "BROADCAST_MODE_UNSPECIFIED":
      return BroadcastMode.BROADCAST_MODE_UNSPECIFIED;

    case 1:
    case "BROADCAST_MODE_BLOCK":
      return BroadcastMode.BROADCAST_MODE_BLOCK;

    case 2:
    case "BROADCAST_MODE_SYNC":
      return BroadcastMode.BROADCAST_MODE_SYNC;

    case 3:
    case "BROADCAST_MODE_ASYNC":
      return BroadcastMode.BROADCAST_MODE_ASYNC;

    case -1:
    case "UNRECOGNIZED":
    default:
      return BroadcastMode.UNRECOGNIZED;
  }
}
function broadcastModeToJSON(object) {
  switch (object) {
    case BroadcastMode.BROADCAST_MODE_UNSPECIFIED:
      return "BROADCAST_MODE_UNSPECIFIED";

    case BroadcastMode.BROADCAST_MODE_BLOCK:
      return "BROADCAST_MODE_BLOCK";

    case BroadcastMode.BROADCAST_MODE_SYNC:
      return "BROADCAST_MODE_SYNC";

    case BroadcastMode.BROADCAST_MODE_ASYNC:
      return "BROADCAST_MODE_ASYNC";

    case BroadcastMode.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
/**
 * GetTxsEventRequest is the request type for the Service.TxsByEvents
 * RPC method.
 */

function createBaseGetTxsEventRequest() {
  return {
    events: [],
    pagination: undefined,
    orderBy: 0
  };
}

const GetTxsEventRequest = {
  typeUrl: "/cosmos.tx.v1beta1.GetTxsEventRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    for (const v of message.events) {
      writer.uint32(10).string(v);
    }

    if (message.pagination !== undefined) {
      _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_1__.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
    }

    if (message.orderBy !== 0) {
      writer.uint32(24).int32(message.orderBy);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetTxsEventRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.events.push(reader.string());
          break;

        case 2:
          message.pagination = _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_1__.PageRequest.decode(reader, reader.uint32());
          break;

        case 3:
          message.orderBy = reader.int32();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$events, _object$orderBy;

    const message = createBaseGetTxsEventRequest();
    message.events = ((_object$events = object.events) === null || _object$events === void 0 ? void 0 : _object$events.map(e => e)) || [];
    message.pagination = object.pagination !== undefined && object.pagination !== null ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_1__.PageRequest.fromPartial(object.pagination) : undefined;
    message.orderBy = (_object$orderBy = object.orderBy) !== null && _object$orderBy !== void 0 ? _object$orderBy : 0;
    return message;
  },

  fromAmino(object) {
    return {
      events: Array.isArray(object === null || object === void 0 ? void 0 : object.events) ? object.events.map(e => e) : [],
      pagination: object !== null && object !== void 0 && object.pagination ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_1__.PageRequest.fromAmino(object.pagination) : undefined,
      orderBy: (0,_helpers__WEBPACK_IMPORTED_MODULE_4__/* .isSet */ .DM)(object.order_by) ? orderByFromJSON(object.order_by) : 0
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.events) {
      obj.events = message.events.map(e => e);
    } else {
      obj.events = [];
    }

    obj.pagination = message.pagination ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_1__.PageRequest.toAmino(message.pagination) : undefined;
    obj.order_by = message.orderBy;
    return obj;
  },

  fromAminoMsg(object) {
    return GetTxsEventRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/GetTxsEventRequest",
      value: GetTxsEventRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return GetTxsEventRequest.decode(message.value);
  },

  toProto(message) {
    return GetTxsEventRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.tx.v1beta1.GetTxsEventRequest",
      value: GetTxsEventRequest.encode(message).finish()
    };
  }

};

function createBaseGetTxsEventResponse() {
  return {
    txs: [],
    txResponses: [],
    pagination: undefined
  };
}

const GetTxsEventResponse = {
  typeUrl: "/cosmos.tx.v1beta1.GetTxsEventResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    for (const v of message.txs) {
      _tx__WEBPACK_IMPORTED_MODULE_0__.Tx.encode(v, writer.uint32(10).fork()).ldelim();
    }

    for (const v of message.txResponses) {
      _base_abci_v1beta1_abci__WEBPACK_IMPORTED_MODULE_2__.TxResponse.encode(v, writer.uint32(18).fork()).ldelim();
    }

    if (message.pagination !== undefined) {
      _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_1__.PageResponse.encode(message.pagination, writer.uint32(26).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetTxsEventResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.txs.push(_tx__WEBPACK_IMPORTED_MODULE_0__.Tx.decode(reader, reader.uint32()));
          break;

        case 2:
          message.txResponses.push(_base_abci_v1beta1_abci__WEBPACK_IMPORTED_MODULE_2__.TxResponse.decode(reader, reader.uint32()));
          break;

        case 3:
          message.pagination = _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_1__.PageResponse.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$txs, _object$txResponses;

    const message = createBaseGetTxsEventResponse();
    message.txs = ((_object$txs = object.txs) === null || _object$txs === void 0 ? void 0 : _object$txs.map(e => _tx__WEBPACK_IMPORTED_MODULE_0__.Tx.fromPartial(e))) || [];
    message.txResponses = ((_object$txResponses = object.txResponses) === null || _object$txResponses === void 0 ? void 0 : _object$txResponses.map(e => _base_abci_v1beta1_abci__WEBPACK_IMPORTED_MODULE_2__.TxResponse.fromPartial(e))) || [];
    message.pagination = object.pagination !== undefined && object.pagination !== null ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_1__.PageResponse.fromPartial(object.pagination) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      txs: Array.isArray(object === null || object === void 0 ? void 0 : object.txs) ? object.txs.map(e => _tx__WEBPACK_IMPORTED_MODULE_0__.Tx.fromAmino(e)) : [],
      txResponses: Array.isArray(object === null || object === void 0 ? void 0 : object.tx_responses) ? object.tx_responses.map(e => _base_abci_v1beta1_abci__WEBPACK_IMPORTED_MODULE_2__.TxResponse.fromAmino(e)) : [],
      pagination: object !== null && object !== void 0 && object.pagination ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_1__.PageResponse.fromAmino(object.pagination) : undefined
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.txs) {
      obj.txs = message.txs.map(e => e ? _tx__WEBPACK_IMPORTED_MODULE_0__.Tx.toAmino(e) : undefined);
    } else {
      obj.txs = [];
    }

    if (message.txResponses) {
      obj.tx_responses = message.txResponses.map(e => e ? _base_abci_v1beta1_abci__WEBPACK_IMPORTED_MODULE_2__.TxResponse.toAmino(e) : undefined);
    } else {
      obj.tx_responses = [];
    }

    obj.pagination = message.pagination ? _base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_1__.PageResponse.toAmino(message.pagination) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return GetTxsEventResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/GetTxsEventResponse",
      value: GetTxsEventResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return GetTxsEventResponse.decode(message.value);
  },

  toProto(message) {
    return GetTxsEventResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.tx.v1beta1.GetTxsEventResponse",
      value: GetTxsEventResponse.encode(message).finish()
    };
  }

};

function createBaseBroadcastTxRequest() {
  return {
    txBytes: new Uint8Array(),
    mode: 0
  };
}

const BroadcastTxRequest = {
  typeUrl: "/cosmos.tx.v1beta1.BroadcastTxRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.txBytes.length !== 0) {
      writer.uint32(10).bytes(message.txBytes);
    }

    if (message.mode !== 0) {
      writer.uint32(16).int32(message.mode);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBroadcastTxRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.txBytes = reader.bytes();
          break;

        case 2:
          message.mode = reader.int32();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$txBytes, _object$mode;

    const message = createBaseBroadcastTxRequest();
    message.txBytes = (_object$txBytes = object.txBytes) !== null && _object$txBytes !== void 0 ? _object$txBytes : new Uint8Array();
    message.mode = (_object$mode = object.mode) !== null && _object$mode !== void 0 ? _object$mode : 0;
    return message;
  },

  fromAmino(object) {
    return {
      txBytes: object.tx_bytes,
      mode: (0,_helpers__WEBPACK_IMPORTED_MODULE_4__/* .isSet */ .DM)(object.mode) ? broadcastModeFromJSON(object.mode) : 0
    };
  },

  toAmino(message) {
    const obj = {};
    obj.tx_bytes = message.txBytes;
    obj.mode = message.mode;
    return obj;
  },

  fromAminoMsg(object) {
    return BroadcastTxRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/BroadcastTxRequest",
      value: BroadcastTxRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return BroadcastTxRequest.decode(message.value);
  },

  toProto(message) {
    return BroadcastTxRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.tx.v1beta1.BroadcastTxRequest",
      value: BroadcastTxRequest.encode(message).finish()
    };
  }

};

function createBaseBroadcastTxResponse() {
  return {
    txResponse: undefined
  };
}

const BroadcastTxResponse = {
  typeUrl: "/cosmos.tx.v1beta1.BroadcastTxResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.txResponse !== undefined) {
      _base_abci_v1beta1_abci__WEBPACK_IMPORTED_MODULE_2__.TxResponse.encode(message.txResponse, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBroadcastTxResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.txResponse = _base_abci_v1beta1_abci__WEBPACK_IMPORTED_MODULE_2__.TxResponse.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseBroadcastTxResponse();
    message.txResponse = object.txResponse !== undefined && object.txResponse !== null ? _base_abci_v1beta1_abci__WEBPACK_IMPORTED_MODULE_2__.TxResponse.fromPartial(object.txResponse) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      txResponse: object !== null && object !== void 0 && object.tx_response ? _base_abci_v1beta1_abci__WEBPACK_IMPORTED_MODULE_2__.TxResponse.fromAmino(object.tx_response) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.tx_response = message.txResponse ? _base_abci_v1beta1_abci__WEBPACK_IMPORTED_MODULE_2__.TxResponse.toAmino(message.txResponse) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return BroadcastTxResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/BroadcastTxResponse",
      value: BroadcastTxResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return BroadcastTxResponse.decode(message.value);
  },

  toProto(message) {
    return BroadcastTxResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.tx.v1beta1.BroadcastTxResponse",
      value: BroadcastTxResponse.encode(message).finish()
    };
  }

};

function createBaseSimulateRequest() {
  return {
    tx: undefined,
    txBytes: new Uint8Array()
  };
}

const SimulateRequest = {
  typeUrl: "/cosmos.tx.v1beta1.SimulateRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.tx !== undefined) {
      _tx__WEBPACK_IMPORTED_MODULE_0__.Tx.encode(message.tx, writer.uint32(10).fork()).ldelim();
    }

    if (message.txBytes.length !== 0) {
      writer.uint32(18).bytes(message.txBytes);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSimulateRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.tx = _tx__WEBPACK_IMPORTED_MODULE_0__.Tx.decode(reader, reader.uint32());
          break;

        case 2:
          message.txBytes = reader.bytes();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$txBytes2;

    const message = createBaseSimulateRequest();
    message.tx = object.tx !== undefined && object.tx !== null ? _tx__WEBPACK_IMPORTED_MODULE_0__.Tx.fromPartial(object.tx) : undefined;
    message.txBytes = (_object$txBytes2 = object.txBytes) !== null && _object$txBytes2 !== void 0 ? _object$txBytes2 : new Uint8Array();
    return message;
  },

  fromAmino(object) {
    return {
      tx: object !== null && object !== void 0 && object.tx ? _tx__WEBPACK_IMPORTED_MODULE_0__.Tx.fromAmino(object.tx) : undefined,
      txBytes: object.tx_bytes
    };
  },

  toAmino(message) {
    const obj = {};
    obj.tx = message.tx ? _tx__WEBPACK_IMPORTED_MODULE_0__.Tx.toAmino(message.tx) : undefined;
    obj.tx_bytes = message.txBytes;
    return obj;
  },

  fromAminoMsg(object) {
    return SimulateRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/SimulateRequest",
      value: SimulateRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return SimulateRequest.decode(message.value);
  },

  toProto(message) {
    return SimulateRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.tx.v1beta1.SimulateRequest",
      value: SimulateRequest.encode(message).finish()
    };
  }

};

function createBaseSimulateResponse() {
  return {
    gasInfo: undefined,
    result: undefined
  };
}

const SimulateResponse = {
  typeUrl: "/cosmos.tx.v1beta1.SimulateResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.gasInfo !== undefined) {
      _base_abci_v1beta1_abci__WEBPACK_IMPORTED_MODULE_2__.GasInfo.encode(message.gasInfo, writer.uint32(10).fork()).ldelim();
    }

    if (message.result !== undefined) {
      _base_abci_v1beta1_abci__WEBPACK_IMPORTED_MODULE_2__.Result.encode(message.result, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSimulateResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.gasInfo = _base_abci_v1beta1_abci__WEBPACK_IMPORTED_MODULE_2__.GasInfo.decode(reader, reader.uint32());
          break;

        case 2:
          message.result = _base_abci_v1beta1_abci__WEBPACK_IMPORTED_MODULE_2__.Result.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseSimulateResponse();
    message.gasInfo = object.gasInfo !== undefined && object.gasInfo !== null ? _base_abci_v1beta1_abci__WEBPACK_IMPORTED_MODULE_2__.GasInfo.fromPartial(object.gasInfo) : undefined;
    message.result = object.result !== undefined && object.result !== null ? _base_abci_v1beta1_abci__WEBPACK_IMPORTED_MODULE_2__.Result.fromPartial(object.result) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      gasInfo: object !== null && object !== void 0 && object.gas_info ? _base_abci_v1beta1_abci__WEBPACK_IMPORTED_MODULE_2__.GasInfo.fromAmino(object.gas_info) : undefined,
      result: object !== null && object !== void 0 && object.result ? _base_abci_v1beta1_abci__WEBPACK_IMPORTED_MODULE_2__.Result.fromAmino(object.result) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.gas_info = message.gasInfo ? _base_abci_v1beta1_abci__WEBPACK_IMPORTED_MODULE_2__.GasInfo.toAmino(message.gasInfo) : undefined;
    obj.result = message.result ? _base_abci_v1beta1_abci__WEBPACK_IMPORTED_MODULE_2__.Result.toAmino(message.result) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return SimulateResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/SimulateResponse",
      value: SimulateResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return SimulateResponse.decode(message.value);
  },

  toProto(message) {
    return SimulateResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.tx.v1beta1.SimulateResponse",
      value: SimulateResponse.encode(message).finish()
    };
  }

};

function createBaseGetTxRequest() {
  return {
    hash: ""
  };
}

const GetTxRequest = {
  typeUrl: "/cosmos.tx.v1beta1.GetTxRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.hash !== "") {
      writer.uint32(10).string(message.hash);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetTxRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.hash = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$hash;

    const message = createBaseGetTxRequest();
    message.hash = (_object$hash = object.hash) !== null && _object$hash !== void 0 ? _object$hash : "";
    return message;
  },

  fromAmino(object) {
    return {
      hash: object.hash
    };
  },

  toAmino(message) {
    const obj = {};
    obj.hash = message.hash;
    return obj;
  },

  fromAminoMsg(object) {
    return GetTxRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/GetTxRequest",
      value: GetTxRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return GetTxRequest.decode(message.value);
  },

  toProto(message) {
    return GetTxRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.tx.v1beta1.GetTxRequest",
      value: GetTxRequest.encode(message).finish()
    };
  }

};

function createBaseGetTxResponse() {
  return {
    tx: undefined,
    txResponse: undefined
  };
}

const GetTxResponse = {
  typeUrl: "/cosmos.tx.v1beta1.GetTxResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.tx !== undefined) {
      _tx__WEBPACK_IMPORTED_MODULE_0__.Tx.encode(message.tx, writer.uint32(10).fork()).ldelim();
    }

    if (message.txResponse !== undefined) {
      _base_abci_v1beta1_abci__WEBPACK_IMPORTED_MODULE_2__.TxResponse.encode(message.txResponse, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetTxResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.tx = _tx__WEBPACK_IMPORTED_MODULE_0__.Tx.decode(reader, reader.uint32());
          break;

        case 2:
          message.txResponse = _base_abci_v1beta1_abci__WEBPACK_IMPORTED_MODULE_2__.TxResponse.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseGetTxResponse();
    message.tx = object.tx !== undefined && object.tx !== null ? _tx__WEBPACK_IMPORTED_MODULE_0__.Tx.fromPartial(object.tx) : undefined;
    message.txResponse = object.txResponse !== undefined && object.txResponse !== null ? _base_abci_v1beta1_abci__WEBPACK_IMPORTED_MODULE_2__.TxResponse.fromPartial(object.txResponse) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      tx: object !== null && object !== void 0 && object.tx ? _tx__WEBPACK_IMPORTED_MODULE_0__.Tx.fromAmino(object.tx) : undefined,
      txResponse: object !== null && object !== void 0 && object.tx_response ? _base_abci_v1beta1_abci__WEBPACK_IMPORTED_MODULE_2__.TxResponse.fromAmino(object.tx_response) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.tx = message.tx ? _tx__WEBPACK_IMPORTED_MODULE_0__.Tx.toAmino(message.tx) : undefined;
    obj.tx_response = message.txResponse ? _base_abci_v1beta1_abci__WEBPACK_IMPORTED_MODULE_2__.TxResponse.toAmino(message.txResponse) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return GetTxResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/GetTxResponse",
      value: GetTxResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return GetTxResponse.decode(message.value);
  },

  toProto(message) {
    return GetTxResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.tx.v1beta1.GetTxResponse",
      value: GetTxResponse.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 57994:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LCDQueryClient": function() { return /* binding */ LCDQueryClient; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4942);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47895);


class LCDQueryClient {
  constructor({
    requestClient
  }) {
    (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, "req", void 0);

    this.req = requestClient;
    this.getTx = this.getTx.bind(this);
    this.getTxsEvent = this.getTxsEvent.bind(this);
  }
  /* GetTx fetches a tx by hash. */


  async getTx(params) {
    const endpoint = `cosmos/tx/v1beta1/txs/${params.hash}`;
    return await this.req.get(endpoint);
  }
  /* GetTxsEvent fetches txs by event. */


  async getTxsEvent(params) {
    const options = {
      params: {}
    };

    if (typeof (params === null || params === void 0 ? void 0 : params.events) !== "undefined") {
      options.params.events = params.events;
    }

    if (typeof (params === null || params === void 0 ? void 0 : params.pagination) !== "undefined") {
      (0,_helpers__WEBPACK_IMPORTED_MODULE_0__/* .setPaginationParams */ .q6)(options, params.pagination);
    }

    if (typeof (params === null || params === void 0 ? void 0 : params.orderBy) !== "undefined") {
      options.params.order_by = params.orderBy;
    }

    const endpoint = `cosmos/tx/v1beta1/txs`;
    return await this.req.get(endpoint, options);
  }

}

/***/ }),

/***/ 82478:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ServiceClientImpl": function() { return /* binding */ ServiceClientImpl; },
/* harmony export */   "createRpcQueryExtension": function() { return /* binding */ createRpcQueryExtension; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4942);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78441);
/* harmony import */ var _cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89242);




/** Service defines a gRPC service for interacting with transactions. */

class ServiceClientImpl {
  constructor(rpc) {
    (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, "rpc", void 0);

    this.rpc = rpc;
    this.simulate = this.simulate.bind(this);
    this.getTx = this.getTx.bind(this);
    this.broadcastTx = this.broadcastTx.bind(this);
    this.getTxsEvent = this.getTxsEvent.bind(this);
  }

  simulate(request) {
    const data = _service__WEBPACK_IMPORTED_MODULE_2__.SimulateRequest.encode(request).finish();
    const promise = this.rpc.request("cosmos.tx.v1beta1.Service", "Simulate", data);
    return promise.then(data => _service__WEBPACK_IMPORTED_MODULE_2__.SimulateResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  getTx(request) {
    const data = _service__WEBPACK_IMPORTED_MODULE_2__.GetTxRequest.encode(request).finish();
    const promise = this.rpc.request("cosmos.tx.v1beta1.Service", "GetTx", data);
    return promise.then(data => _service__WEBPACK_IMPORTED_MODULE_2__.GetTxResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  broadcastTx(request) {
    const data = _service__WEBPACK_IMPORTED_MODULE_2__.BroadcastTxRequest.encode(request).finish();
    const promise = this.rpc.request("cosmos.tx.v1beta1.Service", "BroadcastTx", data);
    return promise.then(data => _service__WEBPACK_IMPORTED_MODULE_2__.BroadcastTxResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  getTxsEvent(request) {
    const data = _service__WEBPACK_IMPORTED_MODULE_2__.GetTxsEventRequest.encode(request).finish();
    const promise = this.rpc.request("cosmos.tx.v1beta1.Service", "GetTxsEvent", data);
    return promise.then(data => _service__WEBPACK_IMPORTED_MODULE_2__.GetTxsEventResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

}
const createRpcQueryExtension = base => {
  const rpc = (0,_cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1__.createProtobufRpcClient)(base);
  const queryService = new ServiceClientImpl(rpc);
  return {
    simulate(request) {
      return queryService.simulate(request);
    },

    getTx(request) {
      return queryService.getTx(request);
    },

    broadcastTx(request) {
      return queryService.broadcastTx(request);
    },

    getTxsEvent(request) {
      return queryService.getTxsEvent(request);
    }

  };
};

/***/ }),

/***/ 20673:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AuthInfo": function() { return /* binding */ AuthInfo; },
/* harmony export */   "Fee": function() { return /* binding */ Fee; },
/* harmony export */   "ModeInfo": function() { return /* binding */ ModeInfo; },
/* harmony export */   "ModeInfo_Multi": function() { return /* binding */ ModeInfo_Multi; },
/* harmony export */   "ModeInfo_Single": function() { return /* binding */ ModeInfo_Single; },
/* harmony export */   "SignDoc": function() { return /* binding */ SignDoc; },
/* harmony export */   "SignerInfo": function() { return /* binding */ SignerInfo; },
/* harmony export */   "Tx": function() { return /* binding */ Tx; },
/* harmony export */   "TxBody": function() { return /* binding */ TxBody; },
/* harmony export */   "TxRaw": function() { return /* binding */ TxRaw; }
/* harmony export */ });
/* harmony import */ var _google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32106);
/* harmony import */ var _signing_v1beta1_signing__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80828);
/* harmony import */ var _crypto_multisig_v1beta1_multisig__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35301);
/* harmony import */ var _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26178);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47895);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__);






/** Tx is the standard type used for broadcasting transactions. */

function createBaseTx() {
  return {
    body: undefined,
    authInfo: undefined,
    signatures: []
  };
}

const Tx = {
  typeUrl: "/cosmos.tx.v1beta1.Tx",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Writer.create()) {
    if (message.body !== undefined) {
      TxBody.encode(message.body, writer.uint32(10).fork()).ldelim();
    }

    if (message.authInfo !== undefined) {
      AuthInfo.encode(message.authInfo, writer.uint32(18).fork()).ldelim();
    }

    for (const v of message.signatures) {
      writer.uint32(26).bytes(v);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTx();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.body = TxBody.decode(reader, reader.uint32());
          break;

        case 2:
          message.authInfo = AuthInfo.decode(reader, reader.uint32());
          break;

        case 3:
          message.signatures.push(reader.bytes());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$signatures;

    const message = createBaseTx();
    message.body = object.body !== undefined && object.body !== null ? TxBody.fromPartial(object.body) : undefined;
    message.authInfo = object.authInfo !== undefined && object.authInfo !== null ? AuthInfo.fromPartial(object.authInfo) : undefined;
    message.signatures = ((_object$signatures = object.signatures) === null || _object$signatures === void 0 ? void 0 : _object$signatures.map(e => e)) || [];
    return message;
  },

  fromAmino(object) {
    return {
      body: object !== null && object !== void 0 && object.body ? TxBody.fromAmino(object.body) : undefined,
      authInfo: object !== null && object !== void 0 && object.auth_info ? AuthInfo.fromAmino(object.auth_info) : undefined,
      signatures: Array.isArray(object === null || object === void 0 ? void 0 : object.signatures) ? object.signatures.map(e => e) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.body = message.body ? TxBody.toAmino(message.body) : undefined;
    obj.auth_info = message.authInfo ? AuthInfo.toAmino(message.authInfo) : undefined;

    if (message.signatures) {
      obj.signatures = message.signatures.map(e => e);
    } else {
      obj.signatures = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return Tx.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/Tx",
      value: Tx.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return Tx.decode(message.value);
  },

  toProto(message) {
    return Tx.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.tx.v1beta1.Tx",
      value: Tx.encode(message).finish()
    };
  }

};

function createBaseTxRaw() {
  return {
    bodyBytes: new Uint8Array(),
    authInfoBytes: new Uint8Array(),
    signatures: []
  };
}

const TxRaw = {
  typeUrl: "/cosmos.tx.v1beta1.TxRaw",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Writer.create()) {
    if (message.bodyBytes.length !== 0) {
      writer.uint32(10).bytes(message.bodyBytes);
    }

    if (message.authInfoBytes.length !== 0) {
      writer.uint32(18).bytes(message.authInfoBytes);
    }

    for (const v of message.signatures) {
      writer.uint32(26).bytes(v);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTxRaw();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.bodyBytes = reader.bytes();
          break;

        case 2:
          message.authInfoBytes = reader.bytes();
          break;

        case 3:
          message.signatures.push(reader.bytes());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$bodyBytes, _object$authInfoBytes, _object$signatures2;

    const message = createBaseTxRaw();
    message.bodyBytes = (_object$bodyBytes = object.bodyBytes) !== null && _object$bodyBytes !== void 0 ? _object$bodyBytes : new Uint8Array();
    message.authInfoBytes = (_object$authInfoBytes = object.authInfoBytes) !== null && _object$authInfoBytes !== void 0 ? _object$authInfoBytes : new Uint8Array();
    message.signatures = ((_object$signatures2 = object.signatures) === null || _object$signatures2 === void 0 ? void 0 : _object$signatures2.map(e => e)) || [];
    return message;
  },

  fromAmino(object) {
    return {
      bodyBytes: object.body_bytes,
      authInfoBytes: object.auth_info_bytes,
      signatures: Array.isArray(object === null || object === void 0 ? void 0 : object.signatures) ? object.signatures.map(e => e) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.body_bytes = message.bodyBytes;
    obj.auth_info_bytes = message.authInfoBytes;

    if (message.signatures) {
      obj.signatures = message.signatures.map(e => e);
    } else {
      obj.signatures = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return TxRaw.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/TxRaw",
      value: TxRaw.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return TxRaw.decode(message.value);
  },

  toProto(message) {
    return TxRaw.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.tx.v1beta1.TxRaw",
      value: TxRaw.encode(message).finish()
    };
  }

};

function createBaseSignDoc() {
  return {
    bodyBytes: new Uint8Array(),
    authInfoBytes: new Uint8Array(),
    chainId: "",
    accountNumber: _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.UZERO */ .dK.UZERO
  };
}

const SignDoc = {
  typeUrl: "/cosmos.tx.v1beta1.SignDoc",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Writer.create()) {
    if (message.bodyBytes.length !== 0) {
      writer.uint32(10).bytes(message.bodyBytes);
    }

    if (message.authInfoBytes.length !== 0) {
      writer.uint32(18).bytes(message.authInfoBytes);
    }

    if (message.chainId !== "") {
      writer.uint32(26).string(message.chainId);
    }

    if (!message.accountNumber.isZero()) {
      writer.uint32(32).uint64(message.accountNumber);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSignDoc();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.bodyBytes = reader.bytes();
          break;

        case 2:
          message.authInfoBytes = reader.bytes();
          break;

        case 3:
          message.chainId = reader.string();
          break;

        case 4:
          message.accountNumber = reader.uint64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$bodyBytes2, _object$authInfoBytes2, _object$chainId;

    const message = createBaseSignDoc();
    message.bodyBytes = (_object$bodyBytes2 = object.bodyBytes) !== null && _object$bodyBytes2 !== void 0 ? _object$bodyBytes2 : new Uint8Array();
    message.authInfoBytes = (_object$authInfoBytes2 = object.authInfoBytes) !== null && _object$authInfoBytes2 !== void 0 ? _object$authInfoBytes2 : new Uint8Array();
    message.chainId = (_object$chainId = object.chainId) !== null && _object$chainId !== void 0 ? _object$chainId : "";
    message.accountNumber = object.accountNumber !== undefined && object.accountNumber !== null ? _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.fromValue */ .dK.fromValue(object.accountNumber) : _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.UZERO */ .dK.UZERO;
    return message;
  },

  fromAmino(object) {
    return {
      bodyBytes: object.body_bytes,
      authInfoBytes: object.auth_info_bytes,
      chainId: object.chain_id,
      accountNumber: _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.fromString */ .dK.fromString(object.account_number)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.body_bytes = message.bodyBytes;
    obj.auth_info_bytes = message.authInfoBytes;
    obj.chain_id = message.chainId;
    obj.account_number = message.accountNumber ? message.accountNumber.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return SignDoc.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/SignDoc",
      value: SignDoc.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return SignDoc.decode(message.value);
  },

  toProto(message) {
    return SignDoc.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.tx.v1beta1.SignDoc",
      value: SignDoc.encode(message).finish()
    };
  }

};

function createBaseTxBody() {
  return {
    messages: [],
    memo: "",
    timeoutHeight: _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.UZERO */ .dK.UZERO,
    extensionOptions: [],
    nonCriticalExtensionOptions: []
  };
}

const TxBody = {
  typeUrl: "/cosmos.tx.v1beta1.TxBody",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Writer.create()) {
    for (const v of message.messages) {
      _google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__.Any.encode(v, writer.uint32(10).fork()).ldelim();
    }

    if (message.memo !== "") {
      writer.uint32(18).string(message.memo);
    }

    if (!message.timeoutHeight.isZero()) {
      writer.uint32(24).uint64(message.timeoutHeight);
    }

    for (const v of message.extensionOptions) {
      _google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__.Any.encode(v, writer.uint32(8186).fork()).ldelim();
    }

    for (const v of message.nonCriticalExtensionOptions) {
      _google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__.Any.encode(v, writer.uint32(16378).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTxBody();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.messages.push(_google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__.Any.decode(reader, reader.uint32()));
          break;

        case 2:
          message.memo = reader.string();
          break;

        case 3:
          message.timeoutHeight = reader.uint64();
          break;

        case 1023:
          message.extensionOptions.push(_google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__.Any.decode(reader, reader.uint32()));
          break;

        case 2047:
          message.nonCriticalExtensionOptions.push(_google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__.Any.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$messages, _object$memo, _object$extensionOpti, _object$nonCriticalEx;

    const message = createBaseTxBody();
    message.messages = ((_object$messages = object.messages) === null || _object$messages === void 0 ? void 0 : _object$messages.map(e => _google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__.Any.fromPartial(e))) || [];
    message.memo = (_object$memo = object.memo) !== null && _object$memo !== void 0 ? _object$memo : "";
    message.timeoutHeight = object.timeoutHeight !== undefined && object.timeoutHeight !== null ? _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.fromValue */ .dK.fromValue(object.timeoutHeight) : _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.UZERO */ .dK.UZERO;
    message.extensionOptions = ((_object$extensionOpti = object.extensionOptions) === null || _object$extensionOpti === void 0 ? void 0 : _object$extensionOpti.map(e => _google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__.Any.fromPartial(e))) || [];
    message.nonCriticalExtensionOptions = ((_object$nonCriticalEx = object.nonCriticalExtensionOptions) === null || _object$nonCriticalEx === void 0 ? void 0 : _object$nonCriticalEx.map(e => _google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__.Any.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      messages: Array.isArray(object === null || object === void 0 ? void 0 : object.messages) ? object.messages.map(e => _google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__.Any.fromAmino(e)) : [],
      memo: object.memo,
      timeoutHeight: _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.fromString */ .dK.fromString(object.timeout_height),
      extensionOptions: Array.isArray(object === null || object === void 0 ? void 0 : object.extension_options) ? object.extension_options.map(e => _google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__.Any.fromAmino(e)) : [],
      nonCriticalExtensionOptions: Array.isArray(object === null || object === void 0 ? void 0 : object.non_critical_extension_options) ? object.non_critical_extension_options.map(e => _google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__.Any.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.messages) {
      obj.messages = message.messages.map(e => e ? _google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__.Any.toAmino(e) : undefined);
    } else {
      obj.messages = [];
    }

    obj.memo = message.memo;
    obj.timeout_height = message.timeoutHeight ? message.timeoutHeight.toString() : undefined;

    if (message.extensionOptions) {
      obj.extension_options = message.extensionOptions.map(e => e ? _google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__.Any.toAmino(e) : undefined);
    } else {
      obj.extension_options = [];
    }

    if (message.nonCriticalExtensionOptions) {
      obj.non_critical_extension_options = message.nonCriticalExtensionOptions.map(e => e ? _google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__.Any.toAmino(e) : undefined);
    } else {
      obj.non_critical_extension_options = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return TxBody.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/TxBody",
      value: TxBody.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return TxBody.decode(message.value);
  },

  toProto(message) {
    return TxBody.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.tx.v1beta1.TxBody",
      value: TxBody.encode(message).finish()
    };
  }

};

function createBaseAuthInfo() {
  return {
    signerInfos: [],
    fee: undefined
  };
}

const AuthInfo = {
  typeUrl: "/cosmos.tx.v1beta1.AuthInfo",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Writer.create()) {
    for (const v of message.signerInfos) {
      SignerInfo.encode(v, writer.uint32(10).fork()).ldelim();
    }

    if (message.fee !== undefined) {
      Fee.encode(message.fee, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAuthInfo();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.signerInfos.push(SignerInfo.decode(reader, reader.uint32()));
          break;

        case 2:
          message.fee = Fee.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$signerInfos;

    const message = createBaseAuthInfo();
    message.signerInfos = ((_object$signerInfos = object.signerInfos) === null || _object$signerInfos === void 0 ? void 0 : _object$signerInfos.map(e => SignerInfo.fromPartial(e))) || [];
    message.fee = object.fee !== undefined && object.fee !== null ? Fee.fromPartial(object.fee) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      signerInfos: Array.isArray(object === null || object === void 0 ? void 0 : object.signer_infos) ? object.signer_infos.map(e => SignerInfo.fromAmino(e)) : [],
      fee: object !== null && object !== void 0 && object.fee ? Fee.fromAmino(object.fee) : undefined
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.signerInfos) {
      obj.signer_infos = message.signerInfos.map(e => e ? SignerInfo.toAmino(e) : undefined);
    } else {
      obj.signer_infos = [];
    }

    obj.fee = message.fee ? Fee.toAmino(message.fee) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return AuthInfo.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/AuthInfo",
      value: AuthInfo.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return AuthInfo.decode(message.value);
  },

  toProto(message) {
    return AuthInfo.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.tx.v1beta1.AuthInfo",
      value: AuthInfo.encode(message).finish()
    };
  }

};

function createBaseSignerInfo() {
  return {
    publicKey: undefined,
    modeInfo: undefined,
    sequence: _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.UZERO */ .dK.UZERO
  };
}

const SignerInfo = {
  typeUrl: "/cosmos.tx.v1beta1.SignerInfo",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Writer.create()) {
    if (message.publicKey !== undefined) {
      _google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__.Any.encode(message.publicKey, writer.uint32(10).fork()).ldelim();
    }

    if (message.modeInfo !== undefined) {
      ModeInfo.encode(message.modeInfo, writer.uint32(18).fork()).ldelim();
    }

    if (!message.sequence.isZero()) {
      writer.uint32(24).uint64(message.sequence);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSignerInfo();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.publicKey = _google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__.Any.decode(reader, reader.uint32());
          break;

        case 2:
          message.modeInfo = ModeInfo.decode(reader, reader.uint32());
          break;

        case 3:
          message.sequence = reader.uint64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseSignerInfo();
    message.publicKey = object.publicKey !== undefined && object.publicKey !== null ? _google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__.Any.fromPartial(object.publicKey) : undefined;
    message.modeInfo = object.modeInfo !== undefined && object.modeInfo !== null ? ModeInfo.fromPartial(object.modeInfo) : undefined;
    message.sequence = object.sequence !== undefined && object.sequence !== null ? _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.fromValue */ .dK.fromValue(object.sequence) : _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.UZERO */ .dK.UZERO;
    return message;
  },

  fromAmino(object) {
    return {
      publicKey: object !== null && object !== void 0 && object.public_key ? _google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__.Any.fromAmino(object.public_key) : undefined,
      modeInfo: object !== null && object !== void 0 && object.mode_info ? ModeInfo.fromAmino(object.mode_info) : undefined,
      sequence: _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.fromString */ .dK.fromString(object.sequence)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.public_key = message.publicKey ? _google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__.Any.toAmino(message.publicKey) : undefined;
    obj.mode_info = message.modeInfo ? ModeInfo.toAmino(message.modeInfo) : undefined;
    obj.sequence = message.sequence ? message.sequence.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return SignerInfo.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/SignerInfo",
      value: SignerInfo.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return SignerInfo.decode(message.value);
  },

  toProto(message) {
    return SignerInfo.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.tx.v1beta1.SignerInfo",
      value: SignerInfo.encode(message).finish()
    };
  }

};

function createBaseModeInfo() {
  return {
    single: undefined,
    multi: undefined
  };
}

const ModeInfo = {
  typeUrl: "/cosmos.tx.v1beta1.ModeInfo",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Writer.create()) {
    if (message.single !== undefined) {
      ModeInfo_Single.encode(message.single, writer.uint32(10).fork()).ldelim();
    }

    if (message.multi !== undefined) {
      ModeInfo_Multi.encode(message.multi, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseModeInfo();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.single = ModeInfo_Single.decode(reader, reader.uint32());
          break;

        case 2:
          message.multi = ModeInfo_Multi.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseModeInfo();
    message.single = object.single !== undefined && object.single !== null ? ModeInfo_Single.fromPartial(object.single) : undefined;
    message.multi = object.multi !== undefined && object.multi !== null ? ModeInfo_Multi.fromPartial(object.multi) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      single: object !== null && object !== void 0 && object.single ? ModeInfo_Single.fromAmino(object.single) : undefined,
      multi: object !== null && object !== void 0 && object.multi ? ModeInfo_Multi.fromAmino(object.multi) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.single = message.single ? ModeInfo_Single.toAmino(message.single) : undefined;
    obj.multi = message.multi ? ModeInfo_Multi.toAmino(message.multi) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return ModeInfo.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/ModeInfo",
      value: ModeInfo.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return ModeInfo.decode(message.value);
  },

  toProto(message) {
    return ModeInfo.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.tx.v1beta1.ModeInfo",
      value: ModeInfo.encode(message).finish()
    };
  }

};

function createBaseModeInfo_Single() {
  return {
    mode: 0
  };
}

const ModeInfo_Single = {
  typeUrl: "/cosmos.tx.v1beta1.Single",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Writer.create()) {
    if (message.mode !== 0) {
      writer.uint32(8).int32(message.mode);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseModeInfo_Single();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.mode = reader.int32();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$mode;

    const message = createBaseModeInfo_Single();
    message.mode = (_object$mode = object.mode) !== null && _object$mode !== void 0 ? _object$mode : 0;
    return message;
  },

  fromAmino(object) {
    return {
      mode: (0,_helpers__WEBPACK_IMPORTED_MODULE_4__/* .isSet */ .DM)(object.mode) ? (0,_signing_v1beta1_signing__WEBPACK_IMPORTED_MODULE_1__.signModeFromJSON)(object.mode) : 0
    };
  },

  toAmino(message) {
    const obj = {};
    obj.mode = message.mode;
    return obj;
  },

  fromAminoMsg(object) {
    return ModeInfo_Single.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/Single",
      value: ModeInfo_Single.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return ModeInfo_Single.decode(message.value);
  },

  toProto(message) {
    return ModeInfo_Single.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.tx.v1beta1.Single",
      value: ModeInfo_Single.encode(message).finish()
    };
  }

};

function createBaseModeInfo_Multi() {
  return {
    bitarray: undefined,
    modeInfos: []
  };
}

const ModeInfo_Multi = {
  typeUrl: "/cosmos.tx.v1beta1.Multi",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Writer.create()) {
    if (message.bitarray !== undefined) {
      _crypto_multisig_v1beta1_multisig__WEBPACK_IMPORTED_MODULE_2__/* .CompactBitArray.encode */ .x.encode(message.bitarray, writer.uint32(10).fork()).ldelim();
    }

    for (const v of message.modeInfos) {
      ModeInfo.encode(v, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseModeInfo_Multi();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.bitarray = _crypto_multisig_v1beta1_multisig__WEBPACK_IMPORTED_MODULE_2__/* .CompactBitArray.decode */ .x.decode(reader, reader.uint32());
          break;

        case 2:
          message.modeInfos.push(ModeInfo.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$modeInfos;

    const message = createBaseModeInfo_Multi();
    message.bitarray = object.bitarray !== undefined && object.bitarray !== null ? _crypto_multisig_v1beta1_multisig__WEBPACK_IMPORTED_MODULE_2__/* .CompactBitArray.fromPartial */ .x.fromPartial(object.bitarray) : undefined;
    message.modeInfos = ((_object$modeInfos = object.modeInfos) === null || _object$modeInfos === void 0 ? void 0 : _object$modeInfos.map(e => ModeInfo.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      bitarray: object !== null && object !== void 0 && object.bitarray ? _crypto_multisig_v1beta1_multisig__WEBPACK_IMPORTED_MODULE_2__/* .CompactBitArray.fromAmino */ .x.fromAmino(object.bitarray) : undefined,
      modeInfos: Array.isArray(object === null || object === void 0 ? void 0 : object.mode_infos) ? object.mode_infos.map(e => ModeInfo.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.bitarray = message.bitarray ? _crypto_multisig_v1beta1_multisig__WEBPACK_IMPORTED_MODULE_2__/* .CompactBitArray.toAmino */ .x.toAmino(message.bitarray) : undefined;

    if (message.modeInfos) {
      obj.mode_infos = message.modeInfos.map(e => e ? ModeInfo.toAmino(e) : undefined);
    } else {
      obj.mode_infos = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return ModeInfo_Multi.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/Multi",
      value: ModeInfo_Multi.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return ModeInfo_Multi.decode(message.value);
  },

  toProto(message) {
    return ModeInfo_Multi.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.tx.v1beta1.Multi",
      value: ModeInfo_Multi.encode(message).finish()
    };
  }

};

function createBaseFee() {
  return {
    amount: [],
    gasLimit: _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.UZERO */ .dK.UZERO,
    payer: "",
    granter: ""
  };
}

const Fee = {
  typeUrl: "/cosmos.tx.v1beta1.Fee",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Writer.create()) {
    for (const v of message.amount) {
      _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_3__.Coin.encode(v, writer.uint32(10).fork()).ldelim();
    }

    if (!message.gasLimit.isZero()) {
      writer.uint32(16).uint64(message.gasLimit);
    }

    if (message.payer !== "") {
      writer.uint32(26).string(message.payer);
    }

    if (message.granter !== "") {
      writer.uint32(34).string(message.granter);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFee();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.amount.push(_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_3__.Coin.decode(reader, reader.uint32()));
          break;

        case 2:
          message.gasLimit = reader.uint64();
          break;

        case 3:
          message.payer = reader.string();
          break;

        case 4:
          message.granter = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$amount, _object$payer, _object$granter;

    const message = createBaseFee();
    message.amount = ((_object$amount = object.amount) === null || _object$amount === void 0 ? void 0 : _object$amount.map(e => _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_3__.Coin.fromPartial(e))) || [];
    message.gasLimit = object.gasLimit !== undefined && object.gasLimit !== null ? _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.fromValue */ .dK.fromValue(object.gasLimit) : _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.UZERO */ .dK.UZERO;
    message.payer = (_object$payer = object.payer) !== null && _object$payer !== void 0 ? _object$payer : "";
    message.granter = (_object$granter = object.granter) !== null && _object$granter !== void 0 ? _object$granter : "";
    return message;
  },

  fromAmino(object) {
    return {
      amount: Array.isArray(object === null || object === void 0 ? void 0 : object.amount) ? object.amount.map(e => _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_3__.Coin.fromAmino(e)) : [],
      gasLimit: _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.fromString */ .dK.fromString(object.gas_limit),
      payer: object.payer,
      granter: object.granter
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.amount) {
      obj.amount = message.amount.map(e => e ? _base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_3__.Coin.toAmino(e) : undefined);
    } else {
      obj.amount = [];
    }

    obj.gas_limit = message.gasLimit ? message.gasLimit.toString() : undefined;
    obj.payer = message.payer;
    obj.granter = message.granter;
    return obj;
  },

  fromAminoMsg(object) {
    return Fee.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/Fee",
      value: Fee.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return Fee.decode(message.value);
  },

  toProto(message) {
    return Fee.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.tx.v1beta1.Fee",
      value: Fee.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 72526:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QueryAppliedPlanRequest": function() { return /* binding */ QueryAppliedPlanRequest; },
/* harmony export */   "QueryAppliedPlanResponse": function() { return /* binding */ QueryAppliedPlanResponse; },
/* harmony export */   "QueryCurrentPlanRequest": function() { return /* binding */ QueryCurrentPlanRequest; },
/* harmony export */   "QueryCurrentPlanResponse": function() { return /* binding */ QueryCurrentPlanResponse; },
/* harmony export */   "QueryModuleVersionsRequest": function() { return /* binding */ QueryModuleVersionsRequest; },
/* harmony export */   "QueryModuleVersionsResponse": function() { return /* binding */ QueryModuleVersionsResponse; },
/* harmony export */   "QueryUpgradedConsensusStateRequest": function() { return /* binding */ QueryUpgradedConsensusStateRequest; },
/* harmony export */   "QueryUpgradedConsensusStateResponse": function() { return /* binding */ QueryUpgradedConsensusStateResponse; }
/* harmony export */ });
/* harmony import */ var _upgrade__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(60184);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47895);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__);



/**
 * QueryCurrentPlanRequest is the request type for the Query/CurrentPlan RPC
 * method.
 */

function createBaseQueryCurrentPlanRequest() {
  return {};
}

const QueryCurrentPlanRequest = {
  typeUrl: "/cosmos.upgrade.v1beta1.QueryCurrentPlanRequest",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryCurrentPlanRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseQueryCurrentPlanRequest();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return QueryCurrentPlanRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryCurrentPlanRequest",
      value: QueryCurrentPlanRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryCurrentPlanRequest.decode(message.value);
  },

  toProto(message) {
    return QueryCurrentPlanRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.upgrade.v1beta1.QueryCurrentPlanRequest",
      value: QueryCurrentPlanRequest.encode(message).finish()
    };
  }

};

function createBaseQueryCurrentPlanResponse() {
  return {
    plan: undefined
  };
}

const QueryCurrentPlanResponse = {
  typeUrl: "/cosmos.upgrade.v1beta1.QueryCurrentPlanResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (message.plan !== undefined) {
      _upgrade__WEBPACK_IMPORTED_MODULE_0__.Plan.encode(message.plan, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryCurrentPlanResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.plan = _upgrade__WEBPACK_IMPORTED_MODULE_0__.Plan.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseQueryCurrentPlanResponse();
    message.plan = object.plan !== undefined && object.plan !== null ? _upgrade__WEBPACK_IMPORTED_MODULE_0__.Plan.fromPartial(object.plan) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      plan: object !== null && object !== void 0 && object.plan ? _upgrade__WEBPACK_IMPORTED_MODULE_0__.Plan.fromAmino(object.plan) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.plan = message.plan ? _upgrade__WEBPACK_IMPORTED_MODULE_0__.Plan.toAmino(message.plan) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryCurrentPlanResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryCurrentPlanResponse",
      value: QueryCurrentPlanResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryCurrentPlanResponse.decode(message.value);
  },

  toProto(message) {
    return QueryCurrentPlanResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.upgrade.v1beta1.QueryCurrentPlanResponse",
      value: QueryCurrentPlanResponse.encode(message).finish()
    };
  }

};

function createBaseQueryAppliedPlanRequest() {
  return {
    name: ""
  };
}

const QueryAppliedPlanRequest = {
  typeUrl: "/cosmos.upgrade.v1beta1.QueryAppliedPlanRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryAppliedPlanRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.name = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$name;

    const message = createBaseQueryAppliedPlanRequest();
    message.name = (_object$name = object.name) !== null && _object$name !== void 0 ? _object$name : "";
    return message;
  },

  fromAmino(object) {
    return {
      name: object.name
    };
  },

  toAmino(message) {
    const obj = {};
    obj.name = message.name;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryAppliedPlanRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryAppliedPlanRequest",
      value: QueryAppliedPlanRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryAppliedPlanRequest.decode(message.value);
  },

  toProto(message) {
    return QueryAppliedPlanRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.upgrade.v1beta1.QueryAppliedPlanRequest",
      value: QueryAppliedPlanRequest.encode(message).finish()
    };
  }

};

function createBaseQueryAppliedPlanResponse() {
  return {
    height: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.ZERO */ .dK.ZERO
  };
}

const QueryAppliedPlanResponse = {
  typeUrl: "/cosmos.upgrade.v1beta1.QueryAppliedPlanResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (!message.height.isZero()) {
      writer.uint32(8).int64(message.height);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryAppliedPlanResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.height = reader.int64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseQueryAppliedPlanResponse();
    message.height = object.height !== undefined && object.height !== null ? _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromValue */ .dK.fromValue(object.height) : _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.ZERO */ .dK.ZERO;
    return message;
  },

  fromAmino(object) {
    return {
      height: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromString */ .dK.fromString(object.height)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.height = message.height ? message.height.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryAppliedPlanResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryAppliedPlanResponse",
      value: QueryAppliedPlanResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryAppliedPlanResponse.decode(message.value);
  },

  toProto(message) {
    return QueryAppliedPlanResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.upgrade.v1beta1.QueryAppliedPlanResponse",
      value: QueryAppliedPlanResponse.encode(message).finish()
    };
  }

};

function createBaseQueryUpgradedConsensusStateRequest() {
  return {
    lastHeight: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.ZERO */ .dK.ZERO
  };
}

const QueryUpgradedConsensusStateRequest = {
  typeUrl: "/cosmos.upgrade.v1beta1.QueryUpgradedConsensusStateRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (!message.lastHeight.isZero()) {
      writer.uint32(8).int64(message.lastHeight);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryUpgradedConsensusStateRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.lastHeight = reader.int64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseQueryUpgradedConsensusStateRequest();
    message.lastHeight = object.lastHeight !== undefined && object.lastHeight !== null ? _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromValue */ .dK.fromValue(object.lastHeight) : _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.ZERO */ .dK.ZERO;
    return message;
  },

  fromAmino(object) {
    return {
      lastHeight: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromString */ .dK.fromString(object.last_height)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.last_height = message.lastHeight ? message.lastHeight.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryUpgradedConsensusStateRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryUpgradedConsensusStateRequest",
      value: QueryUpgradedConsensusStateRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryUpgradedConsensusStateRequest.decode(message.value);
  },

  toProto(message) {
    return QueryUpgradedConsensusStateRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.upgrade.v1beta1.QueryUpgradedConsensusStateRequest",
      value: QueryUpgradedConsensusStateRequest.encode(message).finish()
    };
  }

};

function createBaseQueryUpgradedConsensusStateResponse() {
  return {
    upgradedConsensusState: new Uint8Array()
  };
}

const QueryUpgradedConsensusStateResponse = {
  typeUrl: "/cosmos.upgrade.v1beta1.QueryUpgradedConsensusStateResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (message.upgradedConsensusState.length !== 0) {
      writer.uint32(18).bytes(message.upgradedConsensusState);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryUpgradedConsensusStateResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 2:
          message.upgradedConsensusState = reader.bytes();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$upgradedConse;

    const message = createBaseQueryUpgradedConsensusStateResponse();
    message.upgradedConsensusState = (_object$upgradedConse = object.upgradedConsensusState) !== null && _object$upgradedConse !== void 0 ? _object$upgradedConse : new Uint8Array();
    return message;
  },

  fromAmino(object) {
    return {
      upgradedConsensusState: object.upgraded_consensus_state
    };
  },

  toAmino(message) {
    const obj = {};
    obj.upgraded_consensus_state = message.upgradedConsensusState;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryUpgradedConsensusStateResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryUpgradedConsensusStateResponse",
      value: QueryUpgradedConsensusStateResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryUpgradedConsensusStateResponse.decode(message.value);
  },

  toProto(message) {
    return QueryUpgradedConsensusStateResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.upgrade.v1beta1.QueryUpgradedConsensusStateResponse",
      value: QueryUpgradedConsensusStateResponse.encode(message).finish()
    };
  }

};

function createBaseQueryModuleVersionsRequest() {
  return {
    moduleName: ""
  };
}

const QueryModuleVersionsRequest = {
  typeUrl: "/cosmos.upgrade.v1beta1.QueryModuleVersionsRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (message.moduleName !== "") {
      writer.uint32(10).string(message.moduleName);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryModuleVersionsRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.moduleName = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$moduleName;

    const message = createBaseQueryModuleVersionsRequest();
    message.moduleName = (_object$moduleName = object.moduleName) !== null && _object$moduleName !== void 0 ? _object$moduleName : "";
    return message;
  },

  fromAmino(object) {
    return {
      moduleName: object.module_name
    };
  },

  toAmino(message) {
    const obj = {};
    obj.module_name = message.moduleName;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryModuleVersionsRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryModuleVersionsRequest",
      value: QueryModuleVersionsRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryModuleVersionsRequest.decode(message.value);
  },

  toProto(message) {
    return QueryModuleVersionsRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.upgrade.v1beta1.QueryModuleVersionsRequest",
      value: QueryModuleVersionsRequest.encode(message).finish()
    };
  }

};

function createBaseQueryModuleVersionsResponse() {
  return {
    moduleVersions: []
  };
}

const QueryModuleVersionsResponse = {
  typeUrl: "/cosmos.upgrade.v1beta1.QueryModuleVersionsResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    for (const v of message.moduleVersions) {
      _upgrade__WEBPACK_IMPORTED_MODULE_0__.ModuleVersion.encode(v, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryModuleVersionsResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.moduleVersions.push(_upgrade__WEBPACK_IMPORTED_MODULE_0__.ModuleVersion.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$moduleVersion;

    const message = createBaseQueryModuleVersionsResponse();
    message.moduleVersions = ((_object$moduleVersion = object.moduleVersions) === null || _object$moduleVersion === void 0 ? void 0 : _object$moduleVersion.map(e => _upgrade__WEBPACK_IMPORTED_MODULE_0__.ModuleVersion.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      moduleVersions: Array.isArray(object === null || object === void 0 ? void 0 : object.module_versions) ? object.module_versions.map(e => _upgrade__WEBPACK_IMPORTED_MODULE_0__.ModuleVersion.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.moduleVersions) {
      obj.module_versions = message.moduleVersions.map(e => e ? _upgrade__WEBPACK_IMPORTED_MODULE_0__.ModuleVersion.toAmino(e) : undefined);
    } else {
      obj.module_versions = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return QueryModuleVersionsResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryModuleVersionsResponse",
      value: QueryModuleVersionsResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryModuleVersionsResponse.decode(message.value);
  },

  toProto(message) {
    return QueryModuleVersionsResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.upgrade.v1beta1.QueryModuleVersionsResponse",
      value: QueryModuleVersionsResponse.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 67931:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LCDQueryClient": function() { return /* binding */ LCDQueryClient; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4942);

class LCDQueryClient {
  constructor({
    requestClient
  }) {
    (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, "req", void 0);

    this.req = requestClient;
    this.currentPlan = this.currentPlan.bind(this);
    this.appliedPlan = this.appliedPlan.bind(this);
    this.upgradedConsensusState = this.upgradedConsensusState.bind(this);
    this.moduleVersions = this.moduleVersions.bind(this);
  }
  /* CurrentPlan queries the current upgrade plan. */


  async currentPlan(_params = {}) {
    const endpoint = `cosmos/upgrade/v1beta1/current_plan`;
    return await this.req.get(endpoint);
  }
  /* AppliedPlan queries a previously applied upgrade plan by its name. */


  async appliedPlan(params) {
    const endpoint = `cosmos/upgrade/v1beta1/applied_plan/${params.name}`;
    return await this.req.get(endpoint);
  }
  /* UpgradedConsensusState queries the consensus state that will serve
   as a trusted kernel for the next version of this chain. It will only be
   stored at the last height of this chain.
   UpgradedConsensusState RPC not supported with legacy querier
   This rpc is deprecated now that IBC has its own replacement
   (https://github.com/cosmos/ibc-go/blob/2c880a22e9f9cc75f62b527ca94aa75ce1106001/proto/ibc/core/client/v1/query.proto#L54) */


  async upgradedConsensusState(params) {
    const endpoint = `cosmos/upgrade/v1beta1/upgraded_consensus_state/${params.lastHeight}`;
    return await this.req.get(endpoint);
  }
  /* ModuleVersions queries the list of module versions from state.
  
   Since: cosmos-sdk 0.43 */


  async moduleVersions(params) {
    const options = {
      params: {}
    };

    if (typeof (params === null || params === void 0 ? void 0 : params.moduleName) !== "undefined") {
      options.params.module_name = params.moduleName;
    }

    const endpoint = `cosmos/upgrade/v1beta1/module_versions`;
    return await this.req.get(endpoint, options);
  }

}

/***/ }),

/***/ 94898:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QueryClientImpl": function() { return /* binding */ QueryClientImpl; },
/* harmony export */   "createRpcQueryExtension": function() { return /* binding */ createRpcQueryExtension; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4942);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78441);
/* harmony import */ var _cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72526);




/** Query defines the gRPC upgrade querier service. */

class QueryClientImpl {
  constructor(rpc) {
    (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, "rpc", void 0);

    this.rpc = rpc;
    this.currentPlan = this.currentPlan.bind(this);
    this.appliedPlan = this.appliedPlan.bind(this);
    this.upgradedConsensusState = this.upgradedConsensusState.bind(this);
    this.moduleVersions = this.moduleVersions.bind(this);
  }

  currentPlan(request = {}) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryCurrentPlanRequest.encode(request).finish();
    const promise = this.rpc.request("cosmos.upgrade.v1beta1.Query", "CurrentPlan", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryCurrentPlanResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  appliedPlan(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryAppliedPlanRequest.encode(request).finish();
    const promise = this.rpc.request("cosmos.upgrade.v1beta1.Query", "AppliedPlan", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryAppliedPlanResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  upgradedConsensusState(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryUpgradedConsensusStateRequest.encode(request).finish();
    const promise = this.rpc.request("cosmos.upgrade.v1beta1.Query", "UpgradedConsensusState", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryUpgradedConsensusStateResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  moduleVersions(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryModuleVersionsRequest.encode(request).finish();
    const promise = this.rpc.request("cosmos.upgrade.v1beta1.Query", "ModuleVersions", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryModuleVersionsResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

}
const createRpcQueryExtension = base => {
  const rpc = (0,_cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1__.createProtobufRpcClient)(base);
  const queryService = new QueryClientImpl(rpc);
  return {
    currentPlan(request) {
      return queryService.currentPlan(request);
    },

    appliedPlan(request) {
      return queryService.appliedPlan(request);
    },

    upgradedConsensusState(request) {
      return queryService.upgradedConsensusState(request);
    },

    moduleVersions(request) {
      return queryService.moduleVersions(request);
    }

  };
};

/***/ }),

/***/ 60184:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CancelSoftwareUpgradeProposal": function() { return /* binding */ CancelSoftwareUpgradeProposal; },
/* harmony export */   "ModuleVersion": function() { return /* binding */ ModuleVersion; },
/* harmony export */   "Plan": function() { return /* binding */ Plan; },
/* harmony export */   "SoftwareUpgradeProposal": function() { return /* binding */ SoftwareUpgradeProposal; }
/* harmony export */ });
/* harmony import */ var _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20633);
/* harmony import */ var _google_protobuf_any__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32106);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47895);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__);




/** Plan specifies information about a planned upgrade and when it should occur. */

function createBasePlan() {
  return {
    name: "",
    time: undefined,
    height: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.ZERO */ .dK.ZERO,
    info: "",
    upgradedClientState: undefined
  };
}

const Plan = {
  typeUrl: "/cosmos.upgrade.v1beta1.Plan",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }

    if (message.time !== undefined) {
      _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_0__.Timestamp.encode((0,_helpers__WEBPACK_IMPORTED_MODULE_2__/* .toTimestamp */ .Uq)(message.time), writer.uint32(18).fork()).ldelim();
    }

    if (!message.height.isZero()) {
      writer.uint32(24).int64(message.height);
    }

    if (message.info !== "") {
      writer.uint32(34).string(message.info);
    }

    if (message.upgradedClientState !== undefined) {
      _google_protobuf_any__WEBPACK_IMPORTED_MODULE_1__.Any.encode(message.upgradedClientState, writer.uint32(42).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlan();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.name = reader.string();
          break;

        case 2:
          message.time = (0,_helpers__WEBPACK_IMPORTED_MODULE_2__/* .fromTimestamp */ .Ol)(_google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_0__.Timestamp.decode(reader, reader.uint32()));
          break;

        case 3:
          message.height = reader.int64();
          break;

        case 4:
          message.info = reader.string();
          break;

        case 5:
          message.upgradedClientState = _google_protobuf_any__WEBPACK_IMPORTED_MODULE_1__.Any.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$name, _object$time, _object$info;

    const message = createBasePlan();
    message.name = (_object$name = object.name) !== null && _object$name !== void 0 ? _object$name : "";
    message.time = (_object$time = object.time) !== null && _object$time !== void 0 ? _object$time : undefined;
    message.height = object.height !== undefined && object.height !== null ? _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromValue */ .dK.fromValue(object.height) : _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.ZERO */ .dK.ZERO;
    message.info = (_object$info = object.info) !== null && _object$info !== void 0 ? _object$info : "";
    message.upgradedClientState = object.upgradedClientState !== undefined && object.upgradedClientState !== null ? _google_protobuf_any__WEBPACK_IMPORTED_MODULE_1__.Any.fromPartial(object.upgradedClientState) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      name: object.name,
      time: object !== null && object !== void 0 && object.time ? _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_0__.Timestamp.fromAmino(object.time) : undefined,
      height: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromString */ .dK.fromString(object.height),
      info: object.info,
      upgradedClientState: object !== null && object !== void 0 && object.upgraded_client_state ? _google_protobuf_any__WEBPACK_IMPORTED_MODULE_1__.Any.fromAmino(object.upgraded_client_state) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.name = message.name;
    obj.time = message.time ? _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_0__.Timestamp.toAmino(message.time) : undefined;
    obj.height = message.height ? message.height.toString() : undefined;
    obj.info = message.info;
    obj.upgraded_client_state = message.upgradedClientState ? _google_protobuf_any__WEBPACK_IMPORTED_MODULE_1__.Any.toAmino(message.upgradedClientState) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return Plan.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/Plan",
      value: Plan.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return Plan.decode(message.value);
  },

  toProto(message) {
    return Plan.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.upgrade.v1beta1.Plan",
      value: Plan.encode(message).finish()
    };
  }

};

function createBaseSoftwareUpgradeProposal() {
  return {
    title: "",
    description: "",
    plan: undefined
  };
}

const SoftwareUpgradeProposal = {
  typeUrl: "/cosmos.upgrade.v1beta1.SoftwareUpgradeProposal",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.title !== "") {
      writer.uint32(10).string(message.title);
    }

    if (message.description !== "") {
      writer.uint32(18).string(message.description);
    }

    if (message.plan !== undefined) {
      Plan.encode(message.plan, writer.uint32(26).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSoftwareUpgradeProposal();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.title = reader.string();
          break;

        case 2:
          message.description = reader.string();
          break;

        case 3:
          message.plan = Plan.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$title, _object$description;

    const message = createBaseSoftwareUpgradeProposal();
    message.title = (_object$title = object.title) !== null && _object$title !== void 0 ? _object$title : "";
    message.description = (_object$description = object.description) !== null && _object$description !== void 0 ? _object$description : "";
    message.plan = object.plan !== undefined && object.plan !== null ? Plan.fromPartial(object.plan) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      title: object.title,
      description: object.description,
      plan: object !== null && object !== void 0 && object.plan ? Plan.fromAmino(object.plan) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.title = message.title;
    obj.description = message.description;
    obj.plan = message.plan ? Plan.toAmino(message.plan) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return SoftwareUpgradeProposal.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/SoftwareUpgradeProposal",
      value: SoftwareUpgradeProposal.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return SoftwareUpgradeProposal.decode(message.value);
  },

  toProto(message) {
    return SoftwareUpgradeProposal.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.upgrade.v1beta1.SoftwareUpgradeProposal",
      value: SoftwareUpgradeProposal.encode(message).finish()
    };
  }

};

function createBaseCancelSoftwareUpgradeProposal() {
  return {
    title: "",
    description: ""
  };
}

const CancelSoftwareUpgradeProposal = {
  typeUrl: "/cosmos.upgrade.v1beta1.CancelSoftwareUpgradeProposal",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.title !== "") {
      writer.uint32(10).string(message.title);
    }

    if (message.description !== "") {
      writer.uint32(18).string(message.description);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCancelSoftwareUpgradeProposal();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.title = reader.string();
          break;

        case 2:
          message.description = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$title2, _object$description2;

    const message = createBaseCancelSoftwareUpgradeProposal();
    message.title = (_object$title2 = object.title) !== null && _object$title2 !== void 0 ? _object$title2 : "";
    message.description = (_object$description2 = object.description) !== null && _object$description2 !== void 0 ? _object$description2 : "";
    return message;
  },

  fromAmino(object) {
    return {
      title: object.title,
      description: object.description
    };
  },

  toAmino(message) {
    const obj = {};
    obj.title = message.title;
    obj.description = message.description;
    return obj;
  },

  fromAminoMsg(object) {
    return CancelSoftwareUpgradeProposal.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/CancelSoftwareUpgradeProposal",
      value: CancelSoftwareUpgradeProposal.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return CancelSoftwareUpgradeProposal.decode(message.value);
  },

  toProto(message) {
    return CancelSoftwareUpgradeProposal.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.upgrade.v1beta1.CancelSoftwareUpgradeProposal",
      value: CancelSoftwareUpgradeProposal.encode(message).finish()
    };
  }

};

function createBaseModuleVersion() {
  return {
    name: "",
    version: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO
  };
}

const ModuleVersion = {
  typeUrl: "/cosmos.upgrade.v1beta1.ModuleVersion",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }

    if (!message.version.isZero()) {
      writer.uint32(16).uint64(message.version);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseModuleVersion();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.name = reader.string();
          break;

        case 2:
          message.version = reader.uint64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$name2;

    const message = createBaseModuleVersion();
    message.name = (_object$name2 = object.name) !== null && _object$name2 !== void 0 ? _object$name2 : "";
    message.version = object.version !== undefined && object.version !== null ? _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromValue */ .dK.fromValue(object.version) : _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO;
    return message;
  },

  fromAmino(object) {
    return {
      name: object.name,
      version: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromString */ .dK.fromString(object.version)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.name = message.name;
    obj.version = message.version ? message.version.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return ModuleVersion.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/ModuleVersion",
      value: ModuleVersion.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return ModuleVersion.decode(message.value);
  },

  toProto(message) {
    return ModuleVersion.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.upgrade.v1beta1.ModuleVersion",
      value: ModuleVersion.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 58980:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CodeInfoResponse": function() { return /* binding */ CodeInfoResponse; },
/* harmony export */   "QueryAllContractStateRequest": function() { return /* binding */ QueryAllContractStateRequest; },
/* harmony export */   "QueryAllContractStateResponse": function() { return /* binding */ QueryAllContractStateResponse; },
/* harmony export */   "QueryCodeRequest": function() { return /* binding */ QueryCodeRequest; },
/* harmony export */   "QueryCodeResponse": function() { return /* binding */ QueryCodeResponse; },
/* harmony export */   "QueryCodesRequest": function() { return /* binding */ QueryCodesRequest; },
/* harmony export */   "QueryCodesResponse": function() { return /* binding */ QueryCodesResponse; },
/* harmony export */   "QueryContractHistoryRequest": function() { return /* binding */ QueryContractHistoryRequest; },
/* harmony export */   "QueryContractHistoryResponse": function() { return /* binding */ QueryContractHistoryResponse; },
/* harmony export */   "QueryContractInfoRequest": function() { return /* binding */ QueryContractInfoRequest; },
/* harmony export */   "QueryContractInfoResponse": function() { return /* binding */ QueryContractInfoResponse; },
/* harmony export */   "QueryContractsByCodeRequest": function() { return /* binding */ QueryContractsByCodeRequest; },
/* harmony export */   "QueryContractsByCodeResponse": function() { return /* binding */ QueryContractsByCodeResponse; },
/* harmony export */   "QueryContractsByCreatorRequest": function() { return /* binding */ QueryContractsByCreatorRequest; },
/* harmony export */   "QueryContractsByCreatorResponse": function() { return /* binding */ QueryContractsByCreatorResponse; },
/* harmony export */   "QueryParamsRequest": function() { return /* binding */ QueryParamsRequest; },
/* harmony export */   "QueryParamsResponse": function() { return /* binding */ QueryParamsResponse; },
/* harmony export */   "QueryPinnedCodesRequest": function() { return /* binding */ QueryPinnedCodesRequest; },
/* harmony export */   "QueryPinnedCodesResponse": function() { return /* binding */ QueryPinnedCodesResponse; },
/* harmony export */   "QueryRawContractStateRequest": function() { return /* binding */ QueryRawContractStateRequest; },
/* harmony export */   "QueryRawContractStateResponse": function() { return /* binding */ QueryRawContractStateResponse; },
/* harmony export */   "QuerySmartContractStateRequest": function() { return /* binding */ QuerySmartContractStateRequest; },
/* harmony export */   "QuerySmartContractStateResponse": function() { return /* binding */ QuerySmartContractStateResponse; }
/* harmony export */ });
/* harmony import */ var _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48978);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12315);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47895);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _cosmjs_encoding__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71555);





/**
 * QueryContractInfoRequest is the request type for the Query/ContractInfo RPC
 * method
 */

function createBaseQueryContractInfoRequest() {
  return {
    address: ""
  };
}

const QueryContractInfoRequest = {
  typeUrl: "/cosmwasm.wasm.v1.QueryContractInfoRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.address !== "") {
      writer.uint32(10).string(message.address);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryContractInfoRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.address = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$address;

    const message = createBaseQueryContractInfoRequest();
    message.address = (_object$address = object.address) !== null && _object$address !== void 0 ? _object$address : "";
    return message;
  },

  fromAmino(object) {
    return {
      address: object.address
    };
  },

  toAmino(message) {
    const obj = {};
    obj.address = message.address;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryContractInfoRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "wasm/QueryContractInfoRequest",
      value: QueryContractInfoRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryContractInfoRequest.decode(message.value);
  },

  toProto(message) {
    return QueryContractInfoRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.QueryContractInfoRequest",
      value: QueryContractInfoRequest.encode(message).finish()
    };
  }

};

function createBaseQueryContractInfoResponse() {
  return {
    address: "",
    contractInfo: undefined
  };
}

const QueryContractInfoResponse = {
  typeUrl: "/cosmwasm.wasm.v1.QueryContractInfoResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.address !== "") {
      writer.uint32(10).string(message.address);
    }

    if (message.contractInfo !== undefined) {
      _types__WEBPACK_IMPORTED_MODULE_1__.ContractInfo.encode(message.contractInfo, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryContractInfoResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.address = reader.string();
          break;

        case 2:
          message.contractInfo = _types__WEBPACK_IMPORTED_MODULE_1__.ContractInfo.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$address2;

    const message = createBaseQueryContractInfoResponse();
    message.address = (_object$address2 = object.address) !== null && _object$address2 !== void 0 ? _object$address2 : "";
    message.contractInfo = object.contractInfo !== undefined && object.contractInfo !== null ? _types__WEBPACK_IMPORTED_MODULE_1__.ContractInfo.fromPartial(object.contractInfo) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      address: object.address,
      contractInfo: object !== null && object !== void 0 && object.contract_info ? _types__WEBPACK_IMPORTED_MODULE_1__.ContractInfo.fromAmino(object.contract_info) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.address = message.address;
    obj.contract_info = message.contractInfo ? _types__WEBPACK_IMPORTED_MODULE_1__.ContractInfo.toAmino(message.contractInfo) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryContractInfoResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "wasm/QueryContractInfoResponse",
      value: QueryContractInfoResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryContractInfoResponse.decode(message.value);
  },

  toProto(message) {
    return QueryContractInfoResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.QueryContractInfoResponse",
      value: QueryContractInfoResponse.encode(message).finish()
    };
  }

};

function createBaseQueryContractHistoryRequest() {
  return {
    address: "",
    pagination: undefined
  };
}

const QueryContractHistoryRequest = {
  typeUrl: "/cosmwasm.wasm.v1.QueryContractHistoryRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.address !== "") {
      writer.uint32(10).string(message.address);
    }

    if (message.pagination !== undefined) {
      _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryContractHistoryRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.address = reader.string();
          break;

        case 2:
          message.pagination = _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$address3;

    const message = createBaseQueryContractHistoryRequest();
    message.address = (_object$address3 = object.address) !== null && _object$address3 !== void 0 ? _object$address3 : "";
    message.pagination = object.pagination !== undefined && object.pagination !== null ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.fromPartial(object.pagination) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      address: object.address,
      pagination: object !== null && object !== void 0 && object.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.fromAmino(object.pagination) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.address = message.address;
    obj.pagination = message.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.toAmino(message.pagination) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryContractHistoryRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "wasm/QueryContractHistoryRequest",
      value: QueryContractHistoryRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryContractHistoryRequest.decode(message.value);
  },

  toProto(message) {
    return QueryContractHistoryRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.QueryContractHistoryRequest",
      value: QueryContractHistoryRequest.encode(message).finish()
    };
  }

};

function createBaseQueryContractHistoryResponse() {
  return {
    entries: [],
    pagination: undefined
  };
}

const QueryContractHistoryResponse = {
  typeUrl: "/cosmwasm.wasm.v1.QueryContractHistoryResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    for (const v of message.entries) {
      _types__WEBPACK_IMPORTED_MODULE_1__.ContractCodeHistoryEntry.encode(v, writer.uint32(10).fork()).ldelim();
    }

    if (message.pagination !== undefined) {
      _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryContractHistoryResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.entries.push(_types__WEBPACK_IMPORTED_MODULE_1__.ContractCodeHistoryEntry.decode(reader, reader.uint32()));
          break;

        case 2:
          message.pagination = _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$entries;

    const message = createBaseQueryContractHistoryResponse();
    message.entries = ((_object$entries = object.entries) === null || _object$entries === void 0 ? void 0 : _object$entries.map(e => _types__WEBPACK_IMPORTED_MODULE_1__.ContractCodeHistoryEntry.fromPartial(e))) || [];
    message.pagination = object.pagination !== undefined && object.pagination !== null ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.fromPartial(object.pagination) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      entries: Array.isArray(object === null || object === void 0 ? void 0 : object.entries) ? object.entries.map(e => _types__WEBPACK_IMPORTED_MODULE_1__.ContractCodeHistoryEntry.fromAmino(e)) : [],
      pagination: object !== null && object !== void 0 && object.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.fromAmino(object.pagination) : undefined
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.entries) {
      obj.entries = message.entries.map(e => e ? _types__WEBPACK_IMPORTED_MODULE_1__.ContractCodeHistoryEntry.toAmino(e) : undefined);
    } else {
      obj.entries = [];
    }

    obj.pagination = message.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.toAmino(message.pagination) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryContractHistoryResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "wasm/QueryContractHistoryResponse",
      value: QueryContractHistoryResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryContractHistoryResponse.decode(message.value);
  },

  toProto(message) {
    return QueryContractHistoryResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.QueryContractHistoryResponse",
      value: QueryContractHistoryResponse.encode(message).finish()
    };
  }

};

function createBaseQueryContractsByCodeRequest() {
  return {
    codeId: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO,
    pagination: undefined
  };
}

const QueryContractsByCodeRequest = {
  typeUrl: "/cosmwasm.wasm.v1.QueryContractsByCodeRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (!message.codeId.isZero()) {
      writer.uint32(8).uint64(message.codeId);
    }

    if (message.pagination !== undefined) {
      _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryContractsByCodeRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.codeId = reader.uint64();
          break;

        case 2:
          message.pagination = _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseQueryContractsByCodeRequest();
    message.codeId = object.codeId !== undefined && object.codeId !== null ? _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromValue */ .dK.fromValue(object.codeId) : _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO;
    message.pagination = object.pagination !== undefined && object.pagination !== null ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.fromPartial(object.pagination) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      codeId: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromString */ .dK.fromString(object.code_id),
      pagination: object !== null && object !== void 0 && object.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.fromAmino(object.pagination) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.code_id = message.codeId ? message.codeId.toString() : undefined;
    obj.pagination = message.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.toAmino(message.pagination) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryContractsByCodeRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "wasm/QueryContractsByCodeRequest",
      value: QueryContractsByCodeRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryContractsByCodeRequest.decode(message.value);
  },

  toProto(message) {
    return QueryContractsByCodeRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.QueryContractsByCodeRequest",
      value: QueryContractsByCodeRequest.encode(message).finish()
    };
  }

};

function createBaseQueryContractsByCodeResponse() {
  return {
    contracts: [],
    pagination: undefined
  };
}

const QueryContractsByCodeResponse = {
  typeUrl: "/cosmwasm.wasm.v1.QueryContractsByCodeResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    for (const v of message.contracts) {
      writer.uint32(10).string(v);
    }

    if (message.pagination !== undefined) {
      _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryContractsByCodeResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.contracts.push(reader.string());
          break;

        case 2:
          message.pagination = _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$contracts;

    const message = createBaseQueryContractsByCodeResponse();
    message.contracts = ((_object$contracts = object.contracts) === null || _object$contracts === void 0 ? void 0 : _object$contracts.map(e => e)) || [];
    message.pagination = object.pagination !== undefined && object.pagination !== null ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.fromPartial(object.pagination) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      contracts: Array.isArray(object === null || object === void 0 ? void 0 : object.contracts) ? object.contracts.map(e => e) : [],
      pagination: object !== null && object !== void 0 && object.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.fromAmino(object.pagination) : undefined
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.contracts) {
      obj.contracts = message.contracts.map(e => e);
    } else {
      obj.contracts = [];
    }

    obj.pagination = message.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.toAmino(message.pagination) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryContractsByCodeResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "wasm/QueryContractsByCodeResponse",
      value: QueryContractsByCodeResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryContractsByCodeResponse.decode(message.value);
  },

  toProto(message) {
    return QueryContractsByCodeResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.QueryContractsByCodeResponse",
      value: QueryContractsByCodeResponse.encode(message).finish()
    };
  }

};

function createBaseQueryAllContractStateRequest() {
  return {
    address: "",
    pagination: undefined
  };
}

const QueryAllContractStateRequest = {
  typeUrl: "/cosmwasm.wasm.v1.QueryAllContractStateRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.address !== "") {
      writer.uint32(10).string(message.address);
    }

    if (message.pagination !== undefined) {
      _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryAllContractStateRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.address = reader.string();
          break;

        case 2:
          message.pagination = _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$address4;

    const message = createBaseQueryAllContractStateRequest();
    message.address = (_object$address4 = object.address) !== null && _object$address4 !== void 0 ? _object$address4 : "";
    message.pagination = object.pagination !== undefined && object.pagination !== null ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.fromPartial(object.pagination) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      address: object.address,
      pagination: object !== null && object !== void 0 && object.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.fromAmino(object.pagination) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.address = message.address;
    obj.pagination = message.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.toAmino(message.pagination) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryAllContractStateRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "wasm/QueryAllContractStateRequest",
      value: QueryAllContractStateRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryAllContractStateRequest.decode(message.value);
  },

  toProto(message) {
    return QueryAllContractStateRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.QueryAllContractStateRequest",
      value: QueryAllContractStateRequest.encode(message).finish()
    };
  }

};

function createBaseQueryAllContractStateResponse() {
  return {
    models: [],
    pagination: undefined
  };
}

const QueryAllContractStateResponse = {
  typeUrl: "/cosmwasm.wasm.v1.QueryAllContractStateResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    for (const v of message.models) {
      _types__WEBPACK_IMPORTED_MODULE_1__.Model.encode(v, writer.uint32(10).fork()).ldelim();
    }

    if (message.pagination !== undefined) {
      _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryAllContractStateResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.models.push(_types__WEBPACK_IMPORTED_MODULE_1__.Model.decode(reader, reader.uint32()));
          break;

        case 2:
          message.pagination = _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$models;

    const message = createBaseQueryAllContractStateResponse();
    message.models = ((_object$models = object.models) === null || _object$models === void 0 ? void 0 : _object$models.map(e => _types__WEBPACK_IMPORTED_MODULE_1__.Model.fromPartial(e))) || [];
    message.pagination = object.pagination !== undefined && object.pagination !== null ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.fromPartial(object.pagination) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      models: Array.isArray(object === null || object === void 0 ? void 0 : object.models) ? object.models.map(e => _types__WEBPACK_IMPORTED_MODULE_1__.Model.fromAmino(e)) : [],
      pagination: object !== null && object !== void 0 && object.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.fromAmino(object.pagination) : undefined
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.models) {
      obj.models = message.models.map(e => e ? _types__WEBPACK_IMPORTED_MODULE_1__.Model.toAmino(e) : undefined);
    } else {
      obj.models = [];
    }

    obj.pagination = message.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.toAmino(message.pagination) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryAllContractStateResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "wasm/QueryAllContractStateResponse",
      value: QueryAllContractStateResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryAllContractStateResponse.decode(message.value);
  },

  toProto(message) {
    return QueryAllContractStateResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.QueryAllContractStateResponse",
      value: QueryAllContractStateResponse.encode(message).finish()
    };
  }

};

function createBaseQueryRawContractStateRequest() {
  return {
    address: "",
    queryData: new Uint8Array()
  };
}

const QueryRawContractStateRequest = {
  typeUrl: "/cosmwasm.wasm.v1.QueryRawContractStateRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.address !== "") {
      writer.uint32(10).string(message.address);
    }

    if (message.queryData.length !== 0) {
      writer.uint32(18).bytes(message.queryData);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryRawContractStateRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.address = reader.string();
          break;

        case 2:
          message.queryData = reader.bytes();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$address5, _object$queryData;

    const message = createBaseQueryRawContractStateRequest();
    message.address = (_object$address5 = object.address) !== null && _object$address5 !== void 0 ? _object$address5 : "";
    message.queryData = (_object$queryData = object.queryData) !== null && _object$queryData !== void 0 ? _object$queryData : new Uint8Array();
    return message;
  },

  fromAmino(object) {
    return {
      address: object.address,
      queryData: object.query_data
    };
  },

  toAmino(message) {
    const obj = {};
    obj.address = message.address;
    obj.query_data = message.queryData;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryRawContractStateRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "wasm/QueryRawContractStateRequest",
      value: QueryRawContractStateRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryRawContractStateRequest.decode(message.value);
  },

  toProto(message) {
    return QueryRawContractStateRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.QueryRawContractStateRequest",
      value: QueryRawContractStateRequest.encode(message).finish()
    };
  }

};

function createBaseQueryRawContractStateResponse() {
  return {
    data: new Uint8Array()
  };
}

const QueryRawContractStateResponse = {
  typeUrl: "/cosmwasm.wasm.v1.QueryRawContractStateResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.data.length !== 0) {
      writer.uint32(10).bytes(message.data);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryRawContractStateResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.data = reader.bytes();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$data;

    const message = createBaseQueryRawContractStateResponse();
    message.data = (_object$data = object.data) !== null && _object$data !== void 0 ? _object$data : new Uint8Array();
    return message;
  },

  fromAmino(object) {
    return {
      data: object.data
    };
  },

  toAmino(message) {
    const obj = {};
    obj.data = message.data;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryRawContractStateResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "wasm/QueryRawContractStateResponse",
      value: QueryRawContractStateResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryRawContractStateResponse.decode(message.value);
  },

  toProto(message) {
    return QueryRawContractStateResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.QueryRawContractStateResponse",
      value: QueryRawContractStateResponse.encode(message).finish()
    };
  }

};

function createBaseQuerySmartContractStateRequest() {
  return {
    address: "",
    queryData: new Uint8Array()
  };
}

const QuerySmartContractStateRequest = {
  typeUrl: "/cosmwasm.wasm.v1.QuerySmartContractStateRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.address !== "") {
      writer.uint32(10).string(message.address);
    }

    if (message.queryData.length !== 0) {
      writer.uint32(18).bytes(message.queryData);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQuerySmartContractStateRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.address = reader.string();
          break;

        case 2:
          message.queryData = reader.bytes();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$address6, _object$queryData2;

    const message = createBaseQuerySmartContractStateRequest();
    message.address = (_object$address6 = object.address) !== null && _object$address6 !== void 0 ? _object$address6 : "";
    message.queryData = (_object$queryData2 = object.queryData) !== null && _object$queryData2 !== void 0 ? _object$queryData2 : new Uint8Array();
    return message;
  },

  fromAmino(object) {
    return {
      address: object.address,
      queryData: (0,_cosmjs_encoding__WEBPACK_IMPORTED_MODULE_4__.toUtf8)(JSON.stringify(object.query_data))
    };
  },

  toAmino(message) {
    const obj = {};
    obj.address = message.address;
    obj.query_data = message.queryData ? JSON.parse((0,_cosmjs_encoding__WEBPACK_IMPORTED_MODULE_4__.fromUtf8)(message.queryData)) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QuerySmartContractStateRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "wasm/QuerySmartContractStateRequest",
      value: QuerySmartContractStateRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QuerySmartContractStateRequest.decode(message.value);
  },

  toProto(message) {
    return QuerySmartContractStateRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.QuerySmartContractStateRequest",
      value: QuerySmartContractStateRequest.encode(message).finish()
    };
  }

};

function createBaseQuerySmartContractStateResponse() {
  return {
    data: new Uint8Array()
  };
}

const QuerySmartContractStateResponse = {
  typeUrl: "/cosmwasm.wasm.v1.QuerySmartContractStateResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.data.length !== 0) {
      writer.uint32(10).bytes(message.data);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQuerySmartContractStateResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.data = reader.bytes();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$data2;

    const message = createBaseQuerySmartContractStateResponse();
    message.data = (_object$data2 = object.data) !== null && _object$data2 !== void 0 ? _object$data2 : new Uint8Array();
    return message;
  },

  fromAmino(object) {
    return {
      data: (0,_cosmjs_encoding__WEBPACK_IMPORTED_MODULE_4__.toUtf8)(JSON.stringify(object.data))
    };
  },

  toAmino(message) {
    const obj = {};
    obj.data = message.data ? JSON.parse((0,_cosmjs_encoding__WEBPACK_IMPORTED_MODULE_4__.fromUtf8)(message.data)) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QuerySmartContractStateResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "wasm/QuerySmartContractStateResponse",
      value: QuerySmartContractStateResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QuerySmartContractStateResponse.decode(message.value);
  },

  toProto(message) {
    return QuerySmartContractStateResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.QuerySmartContractStateResponse",
      value: QuerySmartContractStateResponse.encode(message).finish()
    };
  }

};

function createBaseQueryCodeRequest() {
  return {
    codeId: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO
  };
}

const QueryCodeRequest = {
  typeUrl: "/cosmwasm.wasm.v1.QueryCodeRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (!message.codeId.isZero()) {
      writer.uint32(8).uint64(message.codeId);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryCodeRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.codeId = reader.uint64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseQueryCodeRequest();
    message.codeId = object.codeId !== undefined && object.codeId !== null ? _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromValue */ .dK.fromValue(object.codeId) : _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO;
    return message;
  },

  fromAmino(object) {
    return {
      codeId: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromString */ .dK.fromString(object.code_id)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.code_id = message.codeId ? message.codeId.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryCodeRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "wasm/QueryCodeRequest",
      value: QueryCodeRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryCodeRequest.decode(message.value);
  },

  toProto(message) {
    return QueryCodeRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.QueryCodeRequest",
      value: QueryCodeRequest.encode(message).finish()
    };
  }

};

function createBaseCodeInfoResponse() {
  return {
    codeId: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO,
    creator: "",
    dataHash: new Uint8Array(),
    instantiatePermission: undefined
  };
}

const CodeInfoResponse = {
  typeUrl: "/cosmwasm.wasm.v1.CodeInfoResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (!message.codeId.isZero()) {
      writer.uint32(8).uint64(message.codeId);
    }

    if (message.creator !== "") {
      writer.uint32(18).string(message.creator);
    }

    if (message.dataHash.length !== 0) {
      writer.uint32(26).bytes(message.dataHash);
    }

    if (message.instantiatePermission !== undefined) {
      _types__WEBPACK_IMPORTED_MODULE_1__.AccessConfig.encode(message.instantiatePermission, writer.uint32(50).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCodeInfoResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.codeId = reader.uint64();
          break;

        case 2:
          message.creator = reader.string();
          break;

        case 3:
          message.dataHash = reader.bytes();
          break;

        case 6:
          message.instantiatePermission = _types__WEBPACK_IMPORTED_MODULE_1__.AccessConfig.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$creator, _object$dataHash;

    const message = createBaseCodeInfoResponse();
    message.codeId = object.codeId !== undefined && object.codeId !== null ? _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromValue */ .dK.fromValue(object.codeId) : _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO;
    message.creator = (_object$creator = object.creator) !== null && _object$creator !== void 0 ? _object$creator : "";
    message.dataHash = (_object$dataHash = object.dataHash) !== null && _object$dataHash !== void 0 ? _object$dataHash : new Uint8Array();
    message.instantiatePermission = object.instantiatePermission !== undefined && object.instantiatePermission !== null ? _types__WEBPACK_IMPORTED_MODULE_1__.AccessConfig.fromPartial(object.instantiatePermission) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      codeId: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromString */ .dK.fromString(object.code_id),
      creator: object.creator,
      dataHash: object.data_hash,
      instantiatePermission: object !== null && object !== void 0 && object.instantiate_permission ? _types__WEBPACK_IMPORTED_MODULE_1__.AccessConfig.fromAmino(object.instantiate_permission) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.code_id = message.codeId ? message.codeId.toString() : undefined;
    obj.creator = message.creator;
    obj.data_hash = message.dataHash;
    obj.instantiate_permission = message.instantiatePermission ? _types__WEBPACK_IMPORTED_MODULE_1__.AccessConfig.toAmino(message.instantiatePermission) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return CodeInfoResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "wasm/CodeInfoResponse",
      value: CodeInfoResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return CodeInfoResponse.decode(message.value);
  },

  toProto(message) {
    return CodeInfoResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.CodeInfoResponse",
      value: CodeInfoResponse.encode(message).finish()
    };
  }

};

function createBaseQueryCodeResponse() {
  return {
    codeInfo: undefined,
    data: new Uint8Array()
  };
}

const QueryCodeResponse = {
  typeUrl: "/cosmwasm.wasm.v1.QueryCodeResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.codeInfo !== undefined) {
      CodeInfoResponse.encode(message.codeInfo, writer.uint32(10).fork()).ldelim();
    }

    if (message.data.length !== 0) {
      writer.uint32(18).bytes(message.data);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryCodeResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.codeInfo = CodeInfoResponse.decode(reader, reader.uint32());
          break;

        case 2:
          message.data = reader.bytes();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$data3;

    const message = createBaseQueryCodeResponse();
    message.codeInfo = object.codeInfo !== undefined && object.codeInfo !== null ? CodeInfoResponse.fromPartial(object.codeInfo) : undefined;
    message.data = (_object$data3 = object.data) !== null && _object$data3 !== void 0 ? _object$data3 : new Uint8Array();
    return message;
  },

  fromAmino(object) {
    return {
      codeInfo: object !== null && object !== void 0 && object.code_info ? CodeInfoResponse.fromAmino(object.code_info) : undefined,
      data: object.data
    };
  },

  toAmino(message) {
    const obj = {};
    obj.code_info = message.codeInfo ? CodeInfoResponse.toAmino(message.codeInfo) : undefined;
    obj.data = message.data;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryCodeResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "wasm/QueryCodeResponse",
      value: QueryCodeResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryCodeResponse.decode(message.value);
  },

  toProto(message) {
    return QueryCodeResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.QueryCodeResponse",
      value: QueryCodeResponse.encode(message).finish()
    };
  }

};

function createBaseQueryCodesRequest() {
  return {
    pagination: undefined
  };
}

const QueryCodesRequest = {
  typeUrl: "/cosmwasm.wasm.v1.QueryCodesRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.pagination !== undefined) {
      _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryCodesRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.pagination = _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseQueryCodesRequest();
    message.pagination = object.pagination !== undefined && object.pagination !== null ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.fromPartial(object.pagination) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      pagination: object !== null && object !== void 0 && object.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.fromAmino(object.pagination) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.pagination = message.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.toAmino(message.pagination) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryCodesRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "wasm/QueryCodesRequest",
      value: QueryCodesRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryCodesRequest.decode(message.value);
  },

  toProto(message) {
    return QueryCodesRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.QueryCodesRequest",
      value: QueryCodesRequest.encode(message).finish()
    };
  }

};

function createBaseQueryCodesResponse() {
  return {
    codeInfos: [],
    pagination: undefined
  };
}

const QueryCodesResponse = {
  typeUrl: "/cosmwasm.wasm.v1.QueryCodesResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    for (const v of message.codeInfos) {
      CodeInfoResponse.encode(v, writer.uint32(10).fork()).ldelim();
    }

    if (message.pagination !== undefined) {
      _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryCodesResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.codeInfos.push(CodeInfoResponse.decode(reader, reader.uint32()));
          break;

        case 2:
          message.pagination = _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$codeInfos;

    const message = createBaseQueryCodesResponse();
    message.codeInfos = ((_object$codeInfos = object.codeInfos) === null || _object$codeInfos === void 0 ? void 0 : _object$codeInfos.map(e => CodeInfoResponse.fromPartial(e))) || [];
    message.pagination = object.pagination !== undefined && object.pagination !== null ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.fromPartial(object.pagination) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      codeInfos: Array.isArray(object === null || object === void 0 ? void 0 : object.code_infos) ? object.code_infos.map(e => CodeInfoResponse.fromAmino(e)) : [],
      pagination: object !== null && object !== void 0 && object.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.fromAmino(object.pagination) : undefined
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.codeInfos) {
      obj.code_infos = message.codeInfos.map(e => e ? CodeInfoResponse.toAmino(e) : undefined);
    } else {
      obj.code_infos = [];
    }

    obj.pagination = message.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.toAmino(message.pagination) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryCodesResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "wasm/QueryCodesResponse",
      value: QueryCodesResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryCodesResponse.decode(message.value);
  },

  toProto(message) {
    return QueryCodesResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.QueryCodesResponse",
      value: QueryCodesResponse.encode(message).finish()
    };
  }

};

function createBaseQueryPinnedCodesRequest() {
  return {
    pagination: undefined
  };
}

const QueryPinnedCodesRequest = {
  typeUrl: "/cosmwasm.wasm.v1.QueryPinnedCodesRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.pagination !== undefined) {
      _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryPinnedCodesRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 2:
          message.pagination = _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseQueryPinnedCodesRequest();
    message.pagination = object.pagination !== undefined && object.pagination !== null ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.fromPartial(object.pagination) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      pagination: object !== null && object !== void 0 && object.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.fromAmino(object.pagination) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.pagination = message.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.toAmino(message.pagination) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryPinnedCodesRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "wasm/QueryPinnedCodesRequest",
      value: QueryPinnedCodesRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryPinnedCodesRequest.decode(message.value);
  },

  toProto(message) {
    return QueryPinnedCodesRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.QueryPinnedCodesRequest",
      value: QueryPinnedCodesRequest.encode(message).finish()
    };
  }

};

function createBaseQueryPinnedCodesResponse() {
  return {
    codeIds: [],
    pagination: undefined
  };
}

const QueryPinnedCodesResponse = {
  typeUrl: "/cosmwasm.wasm.v1.QueryPinnedCodesResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    writer.uint32(10).fork();

    for (const v of message.codeIds) {
      writer.uint64(v);
    }

    writer.ldelim();

    if (message.pagination !== undefined) {
      _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryPinnedCodesResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          if ((tag & 7) === 2) {
            const end2 = reader.uint32() + reader.pos;

            while (reader.pos < end2) {
              message.codeIds.push(reader.uint64());
            }
          } else {
            message.codeIds.push(reader.uint64());
          }

          break;

        case 2:
          message.pagination = _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$codeIds;

    const message = createBaseQueryPinnedCodesResponse();
    message.codeIds = ((_object$codeIds = object.codeIds) === null || _object$codeIds === void 0 ? void 0 : _object$codeIds.map(e => _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromValue */ .dK.fromValue(e))) || [];
    message.pagination = object.pagination !== undefined && object.pagination !== null ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.fromPartial(object.pagination) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      codeIds: Array.isArray(object === null || object === void 0 ? void 0 : object.code_ids) ? object.code_ids.map(e => e) : [],
      pagination: object !== null && object !== void 0 && object.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.fromAmino(object.pagination) : undefined
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.codeIds) {
      obj.code_ids = message.codeIds.map(e => e);
    } else {
      obj.code_ids = [];
    }

    obj.pagination = message.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.toAmino(message.pagination) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryPinnedCodesResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "wasm/QueryPinnedCodesResponse",
      value: QueryPinnedCodesResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryPinnedCodesResponse.decode(message.value);
  },

  toProto(message) {
    return QueryPinnedCodesResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.QueryPinnedCodesResponse",
      value: QueryPinnedCodesResponse.encode(message).finish()
    };
  }

};

function createBaseQueryParamsRequest() {
  return {};
}

const QueryParamsRequest = {
  typeUrl: "/cosmwasm.wasm.v1.QueryParamsRequest",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryParamsRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseQueryParamsRequest();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return QueryParamsRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "wasm/QueryParamsRequest",
      value: QueryParamsRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryParamsRequest.decode(message.value);
  },

  toProto(message) {
    return QueryParamsRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.QueryParamsRequest",
      value: QueryParamsRequest.encode(message).finish()
    };
  }

};

function createBaseQueryParamsResponse() {
  return {
    params: undefined
  };
}

const QueryParamsResponse = {
  typeUrl: "/cosmwasm.wasm.v1.QueryParamsResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.params !== undefined) {
      _types__WEBPACK_IMPORTED_MODULE_1__.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryParamsResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.params = _types__WEBPACK_IMPORTED_MODULE_1__.Params.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseQueryParamsResponse();
    message.params = object.params !== undefined && object.params !== null ? _types__WEBPACK_IMPORTED_MODULE_1__.Params.fromPartial(object.params) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      params: object !== null && object !== void 0 && object.params ? _types__WEBPACK_IMPORTED_MODULE_1__.Params.fromAmino(object.params) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.params = message.params ? _types__WEBPACK_IMPORTED_MODULE_1__.Params.toAmino(message.params) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryParamsResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "wasm/QueryParamsResponse",
      value: QueryParamsResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryParamsResponse.decode(message.value);
  },

  toProto(message) {
    return QueryParamsResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.QueryParamsResponse",
      value: QueryParamsResponse.encode(message).finish()
    };
  }

};

function createBaseQueryContractsByCreatorRequest() {
  return {
    creatorAddress: "",
    pagination: undefined
  };
}

const QueryContractsByCreatorRequest = {
  typeUrl: "/cosmwasm.wasm.v1.QueryContractsByCreatorRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.creatorAddress !== "") {
      writer.uint32(10).string(message.creatorAddress);
    }

    if (message.pagination !== undefined) {
      _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryContractsByCreatorRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.creatorAddress = reader.string();
          break;

        case 2:
          message.pagination = _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$creatorAddres;

    const message = createBaseQueryContractsByCreatorRequest();
    message.creatorAddress = (_object$creatorAddres = object.creatorAddress) !== null && _object$creatorAddres !== void 0 ? _object$creatorAddres : "";
    message.pagination = object.pagination !== undefined && object.pagination !== null ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.fromPartial(object.pagination) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      creatorAddress: object.creator_address,
      pagination: object !== null && object !== void 0 && object.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.fromAmino(object.pagination) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.creator_address = message.creatorAddress;
    obj.pagination = message.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.toAmino(message.pagination) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryContractsByCreatorRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "wasm/QueryContractsByCreatorRequest",
      value: QueryContractsByCreatorRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryContractsByCreatorRequest.decode(message.value);
  },

  toProto(message) {
    return QueryContractsByCreatorRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.QueryContractsByCreatorRequest",
      value: QueryContractsByCreatorRequest.encode(message).finish()
    };
  }

};

function createBaseQueryContractsByCreatorResponse() {
  return {
    contractAddresses: [],
    pagination: undefined
  };
}

const QueryContractsByCreatorResponse = {
  typeUrl: "/cosmwasm.wasm.v1.QueryContractsByCreatorResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    for (const v of message.contractAddresses) {
      writer.uint32(10).string(v);
    }

    if (message.pagination !== undefined) {
      _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryContractsByCreatorResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.contractAddresses.push(reader.string());
          break;

        case 2:
          message.pagination = _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$contractAddre;

    const message = createBaseQueryContractsByCreatorResponse();
    message.contractAddresses = ((_object$contractAddre = object.contractAddresses) === null || _object$contractAddre === void 0 ? void 0 : _object$contractAddre.map(e => e)) || [];
    message.pagination = object.pagination !== undefined && object.pagination !== null ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.fromPartial(object.pagination) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      contractAddresses: Array.isArray(object === null || object === void 0 ? void 0 : object.contract_addresses) ? object.contract_addresses.map(e => e) : [],
      pagination: object !== null && object !== void 0 && object.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.fromAmino(object.pagination) : undefined
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.contractAddresses) {
      obj.contract_addresses = message.contractAddresses.map(e => e);
    } else {
      obj.contract_addresses = [];
    }

    obj.pagination = message.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.toAmino(message.pagination) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryContractsByCreatorResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "wasm/QueryContractsByCreatorResponse",
      value: QueryContractsByCreatorResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryContractsByCreatorResponse.decode(message.value);
  },

  toProto(message) {
    return QueryContractsByCreatorResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.QueryContractsByCreatorResponse",
      value: QueryContractsByCreatorResponse.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 77927:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LCDQueryClient": function() { return /* binding */ LCDQueryClient; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4942);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47895);


class LCDQueryClient {
  constructor({
    requestClient
  }) {
    (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, "req", void 0);

    this.req = requestClient;
    this.contractInfo = this.contractInfo.bind(this);
    this.contractHistory = this.contractHistory.bind(this);
    this.contractsByCode = this.contractsByCode.bind(this);
    this.allContractState = this.allContractState.bind(this);
    this.rawContractState = this.rawContractState.bind(this);
    this.smartContractState = this.smartContractState.bind(this);
    this.code = this.code.bind(this);
    this.codes = this.codes.bind(this);
    this.pinnedCodes = this.pinnedCodes.bind(this);
    this.params = this.params.bind(this);
    this.contractsByCreator = this.contractsByCreator.bind(this);
  }
  /* ContractInfo gets the contract meta data */


  async contractInfo(params) {
    const endpoint = `cosmwasm/wasm/v1/contract/${params.address}`;
    return await this.req.get(endpoint);
  }
  /* ContractHistory gets the contract code history */


  async contractHistory(params) {
    const options = {
      params: {}
    };

    if (typeof (params === null || params === void 0 ? void 0 : params.pagination) !== "undefined") {
      (0,_helpers__WEBPACK_IMPORTED_MODULE_0__/* .setPaginationParams */ .q6)(options, params.pagination);
    }

    const endpoint = `cosmwasm/wasm/v1/contract/${params.address}/history`;
    return await this.req.get(endpoint, options);
  }
  /* ContractsByCode lists all smart contracts for a code id */


  async contractsByCode(params) {
    const options = {
      params: {}
    };

    if (typeof (params === null || params === void 0 ? void 0 : params.pagination) !== "undefined") {
      (0,_helpers__WEBPACK_IMPORTED_MODULE_0__/* .setPaginationParams */ .q6)(options, params.pagination);
    }

    const endpoint = `cosmwasm/wasm/v1/code/${params.codeId}/contracts`;
    return await this.req.get(endpoint, options);
  }
  /* AllContractState gets all raw store data for a single contract */


  async allContractState(params) {
    const options = {
      params: {}
    };

    if (typeof (params === null || params === void 0 ? void 0 : params.pagination) !== "undefined") {
      (0,_helpers__WEBPACK_IMPORTED_MODULE_0__/* .setPaginationParams */ .q6)(options, params.pagination);
    }

    const endpoint = `cosmwasm/wasm/v1/contract/${params.address}/state`;
    return await this.req.get(endpoint, options);
  }
  /* RawContractState gets single key from the raw store data of a contract */


  async rawContractState(params) {
    const endpoint = `cosmwasm/wasm/v1/contract/${params.address}/raw/${params.queryData}`;
    return await this.req.get(endpoint);
  }
  /* SmartContractState get smart query result from the contract */


  async smartContractState(params) {
    const endpoint = `cosmwasm/wasm/v1/contract/${params.address}/smart/${params.queryData}`;
    return await this.req.get(endpoint);
  }
  /* Code gets the binary code and metadata for a singe wasm code */


  async code(params) {
    const endpoint = `cosmwasm/wasm/v1/code/${params.codeId}`;
    return await this.req.get(endpoint);
  }
  /* Codes gets the metadata for all stored wasm codes */


  async codes(params = {
    pagination: undefined
  }) {
    const options = {
      params: {}
    };

    if (typeof (params === null || params === void 0 ? void 0 : params.pagination) !== "undefined") {
      (0,_helpers__WEBPACK_IMPORTED_MODULE_0__/* .setPaginationParams */ .q6)(options, params.pagination);
    }

    const endpoint = `cosmwasm/wasm/v1/code`;
    return await this.req.get(endpoint, options);
  }
  /* PinnedCodes gets the pinned code ids */


  async pinnedCodes(params = {
    pagination: undefined
  }) {
    const options = {
      params: {}
    };

    if (typeof (params === null || params === void 0 ? void 0 : params.pagination) !== "undefined") {
      (0,_helpers__WEBPACK_IMPORTED_MODULE_0__/* .setPaginationParams */ .q6)(options, params.pagination);
    }

    const endpoint = `cosmwasm/wasm/v1/codes/pinned`;
    return await this.req.get(endpoint, options);
  }
  /* Params gets the module params */


  async params(_params = {}) {
    const endpoint = `cosmwasm/wasm/v1/codes/params`;
    return await this.req.get(endpoint);
  }
  /* ContractsByCreator gets the contracts by creator */


  async contractsByCreator(params) {
    const options = {
      params: {}
    };

    if (typeof (params === null || params === void 0 ? void 0 : params.pagination) !== "undefined") {
      (0,_helpers__WEBPACK_IMPORTED_MODULE_0__/* .setPaginationParams */ .q6)(options, params.pagination);
    }

    const endpoint = `cosmwasm/wasm/v1/contracts/creator/${params.creatorAddress}`;
    return await this.req.get(endpoint, options);
  }

}

/***/ }),

/***/ 63564:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QueryClientImpl": function() { return /* binding */ QueryClientImpl; },
/* harmony export */   "createRpcQueryExtension": function() { return /* binding */ createRpcQueryExtension; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4942);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78441);
/* harmony import */ var _cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58980);




/** Query provides defines the gRPC querier service */

class QueryClientImpl {
  constructor(rpc) {
    (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, "rpc", void 0);

    this.rpc = rpc;
    this.contractInfo = this.contractInfo.bind(this);
    this.contractHistory = this.contractHistory.bind(this);
    this.contractsByCode = this.contractsByCode.bind(this);
    this.allContractState = this.allContractState.bind(this);
    this.rawContractState = this.rawContractState.bind(this);
    this.smartContractState = this.smartContractState.bind(this);
    this.code = this.code.bind(this);
    this.codes = this.codes.bind(this);
    this.pinnedCodes = this.pinnedCodes.bind(this);
    this.params = this.params.bind(this);
    this.contractsByCreator = this.contractsByCreator.bind(this);
  }

  contractInfo(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryContractInfoRequest.encode(request).finish();
    const promise = this.rpc.request("cosmwasm.wasm.v1.Query", "ContractInfo", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryContractInfoResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  contractHistory(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryContractHistoryRequest.encode(request).finish();
    const promise = this.rpc.request("cosmwasm.wasm.v1.Query", "ContractHistory", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryContractHistoryResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  contractsByCode(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryContractsByCodeRequest.encode(request).finish();
    const promise = this.rpc.request("cosmwasm.wasm.v1.Query", "ContractsByCode", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryContractsByCodeResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  allContractState(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryAllContractStateRequest.encode(request).finish();
    const promise = this.rpc.request("cosmwasm.wasm.v1.Query", "AllContractState", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryAllContractStateResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  rawContractState(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryRawContractStateRequest.encode(request).finish();
    const promise = this.rpc.request("cosmwasm.wasm.v1.Query", "RawContractState", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryRawContractStateResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  smartContractState(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QuerySmartContractStateRequest.encode(request).finish();
    const promise = this.rpc.request("cosmwasm.wasm.v1.Query", "SmartContractState", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QuerySmartContractStateResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  code(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryCodeRequest.encode(request).finish();
    const promise = this.rpc.request("cosmwasm.wasm.v1.Query", "Code", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryCodeResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  codes(request = {
    pagination: undefined
  }) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryCodesRequest.encode(request).finish();
    const promise = this.rpc.request("cosmwasm.wasm.v1.Query", "Codes", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryCodesResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  pinnedCodes(request = {
    pagination: undefined
  }) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryPinnedCodesRequest.encode(request).finish();
    const promise = this.rpc.request("cosmwasm.wasm.v1.Query", "PinnedCodes", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryPinnedCodesResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  params(request = {}) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryParamsRequest.encode(request).finish();
    const promise = this.rpc.request("cosmwasm.wasm.v1.Query", "Params", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryParamsResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  contractsByCreator(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryContractsByCreatorRequest.encode(request).finish();
    const promise = this.rpc.request("cosmwasm.wasm.v1.Query", "ContractsByCreator", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryContractsByCreatorResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

}
const createRpcQueryExtension = base => {
  const rpc = (0,_cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1__.createProtobufRpcClient)(base);
  const queryService = new QueryClientImpl(rpc);
  return {
    contractInfo(request) {
      return queryService.contractInfo(request);
    },

    contractHistory(request) {
      return queryService.contractHistory(request);
    },

    contractsByCode(request) {
      return queryService.contractsByCode(request);
    },

    allContractState(request) {
      return queryService.allContractState(request);
    },

    rawContractState(request) {
      return queryService.rawContractState(request);
    },

    smartContractState(request) {
      return queryService.smartContractState(request);
    },

    code(request) {
      return queryService.code(request);
    },

    codes(request) {
      return queryService.codes(request);
    },

    pinnedCodes(request) {
      return queryService.pinnedCodes(request);
    },

    params(request) {
      return queryService.params(request);
    },

    contractsByCreator(request) {
      return queryService.contractsByCreator(request);
    }

  };
};

/***/ }),

/***/ 88547:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MsgClearAdmin": function() { return /* binding */ MsgClearAdmin; },
/* harmony export */   "MsgClearAdminResponse": function() { return /* binding */ MsgClearAdminResponse; },
/* harmony export */   "MsgExecuteContract": function() { return /* binding */ MsgExecuteContract; },
/* harmony export */   "MsgExecuteContractResponse": function() { return /* binding */ MsgExecuteContractResponse; },
/* harmony export */   "MsgInstantiateContract": function() { return /* binding */ MsgInstantiateContract; },
/* harmony export */   "MsgInstantiateContract2": function() { return /* binding */ MsgInstantiateContract2; },
/* harmony export */   "MsgInstantiateContract2Response": function() { return /* binding */ MsgInstantiateContract2Response; },
/* harmony export */   "MsgInstantiateContractResponse": function() { return /* binding */ MsgInstantiateContractResponse; },
/* harmony export */   "MsgMigrateContract": function() { return /* binding */ MsgMigrateContract; },
/* harmony export */   "MsgMigrateContractResponse": function() { return /* binding */ MsgMigrateContractResponse; },
/* harmony export */   "MsgPinCodes": function() { return /* binding */ MsgPinCodes; },
/* harmony export */   "MsgPinCodesResponse": function() { return /* binding */ MsgPinCodesResponse; },
/* harmony export */   "MsgStoreAndInstantiateContract": function() { return /* binding */ MsgStoreAndInstantiateContract; },
/* harmony export */   "MsgStoreAndInstantiateContractResponse": function() { return /* binding */ MsgStoreAndInstantiateContractResponse; },
/* harmony export */   "MsgStoreCode": function() { return /* binding */ MsgStoreCode; },
/* harmony export */   "MsgStoreCodeResponse": function() { return /* binding */ MsgStoreCodeResponse; },
/* harmony export */   "MsgSudoContract": function() { return /* binding */ MsgSudoContract; },
/* harmony export */   "MsgSudoContractResponse": function() { return /* binding */ MsgSudoContractResponse; },
/* harmony export */   "MsgUnpinCodes": function() { return /* binding */ MsgUnpinCodes; },
/* harmony export */   "MsgUnpinCodesResponse": function() { return /* binding */ MsgUnpinCodesResponse; },
/* harmony export */   "MsgUpdateAdmin": function() { return /* binding */ MsgUpdateAdmin; },
/* harmony export */   "MsgUpdateAdminResponse": function() { return /* binding */ MsgUpdateAdminResponse; },
/* harmony export */   "MsgUpdateInstantiateConfig": function() { return /* binding */ MsgUpdateInstantiateConfig; },
/* harmony export */   "MsgUpdateInstantiateConfigResponse": function() { return /* binding */ MsgUpdateInstantiateConfigResponse; },
/* harmony export */   "MsgUpdateParams": function() { return /* binding */ MsgUpdateParams; },
/* harmony export */   "MsgUpdateParamsResponse": function() { return /* binding */ MsgUpdateParamsResponse; }
/* harmony export */ });
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12315);
/* harmony import */ var _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26178);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47895);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _cosmjs_encoding__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71555);





/** MsgStoreCode submit Wasm code to the system */

function createBaseMsgStoreCode() {
  return {
    sender: "",
    wasmByteCode: new Uint8Array(),
    instantiatePermission: undefined
  };
}

const MsgStoreCode = {
  typeUrl: "/cosmwasm.wasm.v1.MsgStoreCode",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.sender !== "") {
      writer.uint32(10).string(message.sender);
    }

    if (message.wasmByteCode.length !== 0) {
      writer.uint32(18).bytes(message.wasmByteCode);
    }

    if (message.instantiatePermission !== undefined) {
      _types__WEBPACK_IMPORTED_MODULE_0__.AccessConfig.encode(message.instantiatePermission, writer.uint32(42).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgStoreCode();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.sender = reader.string();
          break;

        case 2:
          message.wasmByteCode = reader.bytes();
          break;

        case 5:
          message.instantiatePermission = _types__WEBPACK_IMPORTED_MODULE_0__.AccessConfig.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$sender, _object$wasmByteCode;

    const message = createBaseMsgStoreCode();
    message.sender = (_object$sender = object.sender) !== null && _object$sender !== void 0 ? _object$sender : "";
    message.wasmByteCode = (_object$wasmByteCode = object.wasmByteCode) !== null && _object$wasmByteCode !== void 0 ? _object$wasmByteCode : new Uint8Array();
    message.instantiatePermission = object.instantiatePermission !== undefined && object.instantiatePermission !== null ? _types__WEBPACK_IMPORTED_MODULE_0__.AccessConfig.fromPartial(object.instantiatePermission) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      sender: object.sender,
      wasmByteCode: (0,_cosmjs_encoding__WEBPACK_IMPORTED_MODULE_4__.fromBase64)(object.wasm_byte_code),
      instantiatePermission: object !== null && object !== void 0 && object.instantiate_permission ? _types__WEBPACK_IMPORTED_MODULE_0__.AccessConfig.fromAmino(object.instantiate_permission) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.sender = message.sender;
    obj.wasm_byte_code = message.wasmByteCode ? (0,_cosmjs_encoding__WEBPACK_IMPORTED_MODULE_4__.toBase64)(message.wasmByteCode) : undefined;
    obj.instantiate_permission = message.instantiatePermission ? _types__WEBPACK_IMPORTED_MODULE_0__.AccessConfig.toAmino(message.instantiatePermission) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgStoreCode.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "wasm/MsgStoreCode",
      value: MsgStoreCode.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgStoreCode.decode(message.value);
  },

  toProto(message) {
    return MsgStoreCode.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.MsgStoreCode",
      value: MsgStoreCode.encode(message).finish()
    };
  }

};

function createBaseMsgStoreCodeResponse() {
  return {
    codeId: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO,
    checksum: new Uint8Array()
  };
}

const MsgStoreCodeResponse = {
  typeUrl: "/cosmwasm.wasm.v1.MsgStoreCodeResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (!message.codeId.isZero()) {
      writer.uint32(8).uint64(message.codeId);
    }

    if (message.checksum.length !== 0) {
      writer.uint32(18).bytes(message.checksum);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgStoreCodeResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.codeId = reader.uint64();
          break;

        case 2:
          message.checksum = reader.bytes();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$checksum;

    const message = createBaseMsgStoreCodeResponse();
    message.codeId = object.codeId !== undefined && object.codeId !== null ? _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromValue */ .dK.fromValue(object.codeId) : _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO;
    message.checksum = (_object$checksum = object.checksum) !== null && _object$checksum !== void 0 ? _object$checksum : new Uint8Array();
    return message;
  },

  fromAmino(object) {
    return {
      codeId: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromString */ .dK.fromString(object.code_id),
      checksum: object.checksum
    };
  },

  toAmino(message) {
    const obj = {};
    obj.code_id = message.codeId ? message.codeId.toString() : undefined;
    obj.checksum = message.checksum;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgStoreCodeResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "wasm/MsgStoreCodeResponse",
      value: MsgStoreCodeResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgStoreCodeResponse.decode(message.value);
  },

  toProto(message) {
    return MsgStoreCodeResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.MsgStoreCodeResponse",
      value: MsgStoreCodeResponse.encode(message).finish()
    };
  }

};

function createBaseMsgInstantiateContract() {
  return {
    sender: "",
    admin: "",
    codeId: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO,
    label: "",
    msg: new Uint8Array(),
    funds: []
  };
}

const MsgInstantiateContract = {
  typeUrl: "/cosmwasm.wasm.v1.MsgInstantiateContract",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.sender !== "") {
      writer.uint32(10).string(message.sender);
    }

    if (message.admin !== "") {
      writer.uint32(18).string(message.admin);
    }

    if (!message.codeId.isZero()) {
      writer.uint32(24).uint64(message.codeId);
    }

    if (message.label !== "") {
      writer.uint32(34).string(message.label);
    }

    if (message.msg.length !== 0) {
      writer.uint32(42).bytes(message.msg);
    }

    for (const v of message.funds) {
      _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.encode(v, writer.uint32(50).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgInstantiateContract();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.sender = reader.string();
          break;

        case 2:
          message.admin = reader.string();
          break;

        case 3:
          message.codeId = reader.uint64();
          break;

        case 4:
          message.label = reader.string();
          break;

        case 5:
          message.msg = reader.bytes();
          break;

        case 6:
          message.funds.push(_cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$sender2, _object$admin, _object$label, _object$msg, _object$funds;

    const message = createBaseMsgInstantiateContract();
    message.sender = (_object$sender2 = object.sender) !== null && _object$sender2 !== void 0 ? _object$sender2 : "";
    message.admin = (_object$admin = object.admin) !== null && _object$admin !== void 0 ? _object$admin : "";
    message.codeId = object.codeId !== undefined && object.codeId !== null ? _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromValue */ .dK.fromValue(object.codeId) : _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO;
    message.label = (_object$label = object.label) !== null && _object$label !== void 0 ? _object$label : "";
    message.msg = (_object$msg = object.msg) !== null && _object$msg !== void 0 ? _object$msg : new Uint8Array();
    message.funds = ((_object$funds = object.funds) === null || _object$funds === void 0 ? void 0 : _object$funds.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      sender: object.sender,
      admin: object.admin,
      codeId: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromString */ .dK.fromString(object.code_id),
      label: object.label,
      msg: (0,_cosmjs_encoding__WEBPACK_IMPORTED_MODULE_4__.toUtf8)(JSON.stringify(object.msg)),
      funds: Array.isArray(object === null || object === void 0 ? void 0 : object.funds) ? object.funds.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.sender = message.sender;
    obj.admin = message.admin;
    obj.code_id = message.codeId ? message.codeId.toString() : undefined;
    obj.label = message.label;
    obj.msg = message.msg ? JSON.parse((0,_cosmjs_encoding__WEBPACK_IMPORTED_MODULE_4__.fromUtf8)(message.msg)) : undefined;

    if (message.funds) {
      obj.funds = message.funds.map(e => e ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.toAmino(e) : undefined);
    } else {
      obj.funds = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return MsgInstantiateContract.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "wasm/MsgInstantiateContract",
      value: MsgInstantiateContract.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgInstantiateContract.decode(message.value);
  },

  toProto(message) {
    return MsgInstantiateContract.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.MsgInstantiateContract",
      value: MsgInstantiateContract.encode(message).finish()
    };
  }

};

function createBaseMsgInstantiateContractResponse() {
  return {
    address: "",
    data: new Uint8Array()
  };
}

const MsgInstantiateContractResponse = {
  typeUrl: "/cosmwasm.wasm.v1.MsgInstantiateContractResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.address !== "") {
      writer.uint32(10).string(message.address);
    }

    if (message.data.length !== 0) {
      writer.uint32(18).bytes(message.data);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgInstantiateContractResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.address = reader.string();
          break;

        case 2:
          message.data = reader.bytes();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$address, _object$data;

    const message = createBaseMsgInstantiateContractResponse();
    message.address = (_object$address = object.address) !== null && _object$address !== void 0 ? _object$address : "";
    message.data = (_object$data = object.data) !== null && _object$data !== void 0 ? _object$data : new Uint8Array();
    return message;
  },

  fromAmino(object) {
    return {
      address: object.address,
      data: object.data
    };
  },

  toAmino(message) {
    const obj = {};
    obj.address = message.address;
    obj.data = message.data;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgInstantiateContractResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "wasm/MsgInstantiateContractResponse",
      value: MsgInstantiateContractResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgInstantiateContractResponse.decode(message.value);
  },

  toProto(message) {
    return MsgInstantiateContractResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.MsgInstantiateContractResponse",
      value: MsgInstantiateContractResponse.encode(message).finish()
    };
  }

};

function createBaseMsgInstantiateContract2() {
  return {
    sender: "",
    admin: "",
    codeId: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO,
    label: "",
    msg: new Uint8Array(),
    funds: [],
    salt: new Uint8Array(),
    fixMsg: false
  };
}

const MsgInstantiateContract2 = {
  typeUrl: "/cosmwasm.wasm.v1.MsgInstantiateContract2",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.sender !== "") {
      writer.uint32(10).string(message.sender);
    }

    if (message.admin !== "") {
      writer.uint32(18).string(message.admin);
    }

    if (!message.codeId.isZero()) {
      writer.uint32(24).uint64(message.codeId);
    }

    if (message.label !== "") {
      writer.uint32(34).string(message.label);
    }

    if (message.msg.length !== 0) {
      writer.uint32(42).bytes(message.msg);
    }

    for (const v of message.funds) {
      _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.encode(v, writer.uint32(50).fork()).ldelim();
    }

    if (message.salt.length !== 0) {
      writer.uint32(58).bytes(message.salt);
    }

    if (message.fixMsg === true) {
      writer.uint32(64).bool(message.fixMsg);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgInstantiateContract2();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.sender = reader.string();
          break;

        case 2:
          message.admin = reader.string();
          break;

        case 3:
          message.codeId = reader.uint64();
          break;

        case 4:
          message.label = reader.string();
          break;

        case 5:
          message.msg = reader.bytes();
          break;

        case 6:
          message.funds.push(_cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.decode(reader, reader.uint32()));
          break;

        case 7:
          message.salt = reader.bytes();
          break;

        case 8:
          message.fixMsg = reader.bool();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$sender3, _object$admin2, _object$label2, _object$msg2, _object$funds2, _object$salt, _object$fixMsg;

    const message = createBaseMsgInstantiateContract2();
    message.sender = (_object$sender3 = object.sender) !== null && _object$sender3 !== void 0 ? _object$sender3 : "";
    message.admin = (_object$admin2 = object.admin) !== null && _object$admin2 !== void 0 ? _object$admin2 : "";
    message.codeId = object.codeId !== undefined && object.codeId !== null ? _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromValue */ .dK.fromValue(object.codeId) : _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO;
    message.label = (_object$label2 = object.label) !== null && _object$label2 !== void 0 ? _object$label2 : "";
    message.msg = (_object$msg2 = object.msg) !== null && _object$msg2 !== void 0 ? _object$msg2 : new Uint8Array();
    message.funds = ((_object$funds2 = object.funds) === null || _object$funds2 === void 0 ? void 0 : _object$funds2.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.fromPartial(e))) || [];
    message.salt = (_object$salt = object.salt) !== null && _object$salt !== void 0 ? _object$salt : new Uint8Array();
    message.fixMsg = (_object$fixMsg = object.fixMsg) !== null && _object$fixMsg !== void 0 ? _object$fixMsg : false;
    return message;
  },

  fromAmino(object) {
    return {
      sender: object.sender,
      admin: object.admin,
      codeId: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromString */ .dK.fromString(object.code_id),
      label: object.label,
      msg: (0,_cosmjs_encoding__WEBPACK_IMPORTED_MODULE_4__.toUtf8)(JSON.stringify(object.msg)),
      funds: Array.isArray(object === null || object === void 0 ? void 0 : object.funds) ? object.funds.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.fromAmino(e)) : [],
      salt: object.salt,
      fixMsg: object.fix_msg
    };
  },

  toAmino(message) {
    const obj = {};
    obj.sender = message.sender;
    obj.admin = message.admin;
    obj.code_id = message.codeId ? message.codeId.toString() : undefined;
    obj.label = message.label;
    obj.msg = message.msg ? JSON.parse((0,_cosmjs_encoding__WEBPACK_IMPORTED_MODULE_4__.fromUtf8)(message.msg)) : undefined;

    if (message.funds) {
      obj.funds = message.funds.map(e => e ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.toAmino(e) : undefined);
    } else {
      obj.funds = [];
    }

    obj.salt = message.salt;
    obj.fix_msg = message.fixMsg;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgInstantiateContract2.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "wasm/MsgInstantiateContract2",
      value: MsgInstantiateContract2.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgInstantiateContract2.decode(message.value);
  },

  toProto(message) {
    return MsgInstantiateContract2.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.MsgInstantiateContract2",
      value: MsgInstantiateContract2.encode(message).finish()
    };
  }

};

function createBaseMsgInstantiateContract2Response() {
  return {
    address: "",
    data: new Uint8Array()
  };
}

const MsgInstantiateContract2Response = {
  typeUrl: "/cosmwasm.wasm.v1.MsgInstantiateContract2Response",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.address !== "") {
      writer.uint32(10).string(message.address);
    }

    if (message.data.length !== 0) {
      writer.uint32(18).bytes(message.data);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgInstantiateContract2Response();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.address = reader.string();
          break;

        case 2:
          message.data = reader.bytes();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$address2, _object$data2;

    const message = createBaseMsgInstantiateContract2Response();
    message.address = (_object$address2 = object.address) !== null && _object$address2 !== void 0 ? _object$address2 : "";
    message.data = (_object$data2 = object.data) !== null && _object$data2 !== void 0 ? _object$data2 : new Uint8Array();
    return message;
  },

  fromAmino(object) {
    return {
      address: object.address,
      data: object.data
    };
  },

  toAmino(message) {
    const obj = {};
    obj.address = message.address;
    obj.data = message.data;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgInstantiateContract2Response.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "wasm/MsgInstantiateContract2Response",
      value: MsgInstantiateContract2Response.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgInstantiateContract2Response.decode(message.value);
  },

  toProto(message) {
    return MsgInstantiateContract2Response.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.MsgInstantiateContract2Response",
      value: MsgInstantiateContract2Response.encode(message).finish()
    };
  }

};

function createBaseMsgExecuteContract() {
  return {
    sender: "",
    contract: "",
    msg: new Uint8Array(),
    funds: []
  };
}

const MsgExecuteContract = {
  typeUrl: "/cosmwasm.wasm.v1.MsgExecuteContract",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.sender !== "") {
      writer.uint32(10).string(message.sender);
    }

    if (message.contract !== "") {
      writer.uint32(18).string(message.contract);
    }

    if (message.msg.length !== 0) {
      writer.uint32(26).bytes(message.msg);
    }

    for (const v of message.funds) {
      _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.encode(v, writer.uint32(42).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgExecuteContract();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.sender = reader.string();
          break;

        case 2:
          message.contract = reader.string();
          break;

        case 3:
          message.msg = reader.bytes();
          break;

        case 5:
          message.funds.push(_cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$sender4, _object$contract, _object$msg3, _object$funds3;

    const message = createBaseMsgExecuteContract();
    message.sender = (_object$sender4 = object.sender) !== null && _object$sender4 !== void 0 ? _object$sender4 : "";
    message.contract = (_object$contract = object.contract) !== null && _object$contract !== void 0 ? _object$contract : "";
    message.msg = (_object$msg3 = object.msg) !== null && _object$msg3 !== void 0 ? _object$msg3 : new Uint8Array();
    message.funds = ((_object$funds3 = object.funds) === null || _object$funds3 === void 0 ? void 0 : _object$funds3.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      sender: object.sender,
      contract: object.contract,
      msg: (0,_cosmjs_encoding__WEBPACK_IMPORTED_MODULE_4__.toUtf8)(JSON.stringify(object.msg)),
      funds: Array.isArray(object === null || object === void 0 ? void 0 : object.funds) ? object.funds.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.sender = message.sender;
    obj.contract = message.contract;
    obj.msg = message.msg ? JSON.parse((0,_cosmjs_encoding__WEBPACK_IMPORTED_MODULE_4__.fromUtf8)(message.msg)) : undefined;

    if (message.funds) {
      obj.funds = message.funds.map(e => e ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.toAmino(e) : undefined);
    } else {
      obj.funds = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return MsgExecuteContract.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "wasm/MsgExecuteContract",
      value: MsgExecuteContract.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgExecuteContract.decode(message.value);
  },

  toProto(message) {
    return MsgExecuteContract.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.MsgExecuteContract",
      value: MsgExecuteContract.encode(message).finish()
    };
  }

};

function createBaseMsgExecuteContractResponse() {
  return {
    data: new Uint8Array()
  };
}

const MsgExecuteContractResponse = {
  typeUrl: "/cosmwasm.wasm.v1.MsgExecuteContractResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.data.length !== 0) {
      writer.uint32(10).bytes(message.data);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgExecuteContractResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.data = reader.bytes();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$data3;

    const message = createBaseMsgExecuteContractResponse();
    message.data = (_object$data3 = object.data) !== null && _object$data3 !== void 0 ? _object$data3 : new Uint8Array();
    return message;
  },

  fromAmino(object) {
    return {
      data: object.data
    };
  },

  toAmino(message) {
    const obj = {};
    obj.data = message.data;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgExecuteContractResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "wasm/MsgExecuteContractResponse",
      value: MsgExecuteContractResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgExecuteContractResponse.decode(message.value);
  },

  toProto(message) {
    return MsgExecuteContractResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.MsgExecuteContractResponse",
      value: MsgExecuteContractResponse.encode(message).finish()
    };
  }

};

function createBaseMsgMigrateContract() {
  return {
    sender: "",
    contract: "",
    codeId: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO,
    msg: new Uint8Array()
  };
}

const MsgMigrateContract = {
  typeUrl: "/cosmwasm.wasm.v1.MsgMigrateContract",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.sender !== "") {
      writer.uint32(10).string(message.sender);
    }

    if (message.contract !== "") {
      writer.uint32(18).string(message.contract);
    }

    if (!message.codeId.isZero()) {
      writer.uint32(24).uint64(message.codeId);
    }

    if (message.msg.length !== 0) {
      writer.uint32(34).bytes(message.msg);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgMigrateContract();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.sender = reader.string();
          break;

        case 2:
          message.contract = reader.string();
          break;

        case 3:
          message.codeId = reader.uint64();
          break;

        case 4:
          message.msg = reader.bytes();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$sender5, _object$contract2, _object$msg4;

    const message = createBaseMsgMigrateContract();
    message.sender = (_object$sender5 = object.sender) !== null && _object$sender5 !== void 0 ? _object$sender5 : "";
    message.contract = (_object$contract2 = object.contract) !== null && _object$contract2 !== void 0 ? _object$contract2 : "";
    message.codeId = object.codeId !== undefined && object.codeId !== null ? _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromValue */ .dK.fromValue(object.codeId) : _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO;
    message.msg = (_object$msg4 = object.msg) !== null && _object$msg4 !== void 0 ? _object$msg4 : new Uint8Array();
    return message;
  },

  fromAmino(object) {
    return {
      sender: object.sender,
      contract: object.contract,
      codeId: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromString */ .dK.fromString(object.code_id),
      msg: (0,_cosmjs_encoding__WEBPACK_IMPORTED_MODULE_4__.toUtf8)(JSON.stringify(object.msg))
    };
  },

  toAmino(message) {
    const obj = {};
    obj.sender = message.sender;
    obj.contract = message.contract;
    obj.code_id = message.codeId ? message.codeId.toString() : undefined;
    obj.msg = message.msg ? JSON.parse((0,_cosmjs_encoding__WEBPACK_IMPORTED_MODULE_4__.fromUtf8)(message.msg)) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgMigrateContract.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "wasm/MsgMigrateContract",
      value: MsgMigrateContract.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgMigrateContract.decode(message.value);
  },

  toProto(message) {
    return MsgMigrateContract.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.MsgMigrateContract",
      value: MsgMigrateContract.encode(message).finish()
    };
  }

};

function createBaseMsgMigrateContractResponse() {
  return {
    data: new Uint8Array()
  };
}

const MsgMigrateContractResponse = {
  typeUrl: "/cosmwasm.wasm.v1.MsgMigrateContractResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.data.length !== 0) {
      writer.uint32(10).bytes(message.data);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgMigrateContractResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.data = reader.bytes();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$data4;

    const message = createBaseMsgMigrateContractResponse();
    message.data = (_object$data4 = object.data) !== null && _object$data4 !== void 0 ? _object$data4 : new Uint8Array();
    return message;
  },

  fromAmino(object) {
    return {
      data: object.data
    };
  },

  toAmino(message) {
    const obj = {};
    obj.data = message.data;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgMigrateContractResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "wasm/MsgMigrateContractResponse",
      value: MsgMigrateContractResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgMigrateContractResponse.decode(message.value);
  },

  toProto(message) {
    return MsgMigrateContractResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.MsgMigrateContractResponse",
      value: MsgMigrateContractResponse.encode(message).finish()
    };
  }

};

function createBaseMsgUpdateAdmin() {
  return {
    sender: "",
    newAdmin: "",
    contract: ""
  };
}

const MsgUpdateAdmin = {
  typeUrl: "/cosmwasm.wasm.v1.MsgUpdateAdmin",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.sender !== "") {
      writer.uint32(10).string(message.sender);
    }

    if (message.newAdmin !== "") {
      writer.uint32(18).string(message.newAdmin);
    }

    if (message.contract !== "") {
      writer.uint32(26).string(message.contract);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgUpdateAdmin();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.sender = reader.string();
          break;

        case 2:
          message.newAdmin = reader.string();
          break;

        case 3:
          message.contract = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$sender6, _object$newAdmin, _object$contract3;

    const message = createBaseMsgUpdateAdmin();
    message.sender = (_object$sender6 = object.sender) !== null && _object$sender6 !== void 0 ? _object$sender6 : "";
    message.newAdmin = (_object$newAdmin = object.newAdmin) !== null && _object$newAdmin !== void 0 ? _object$newAdmin : "";
    message.contract = (_object$contract3 = object.contract) !== null && _object$contract3 !== void 0 ? _object$contract3 : "";
    return message;
  },

  fromAmino(object) {
    return {
      sender: object.sender,
      newAdmin: object.new_admin,
      contract: object.contract
    };
  },

  toAmino(message) {
    const obj = {};
    obj.sender = message.sender;
    obj.new_admin = message.newAdmin;
    obj.contract = message.contract;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgUpdateAdmin.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "wasm/MsgUpdateAdmin",
      value: MsgUpdateAdmin.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgUpdateAdmin.decode(message.value);
  },

  toProto(message) {
    return MsgUpdateAdmin.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.MsgUpdateAdmin",
      value: MsgUpdateAdmin.encode(message).finish()
    };
  }

};

function createBaseMsgUpdateAdminResponse() {
  return {};
}

const MsgUpdateAdminResponse = {
  typeUrl: "/cosmwasm.wasm.v1.MsgUpdateAdminResponse",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgUpdateAdminResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseMsgUpdateAdminResponse();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return MsgUpdateAdminResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "wasm/MsgUpdateAdminResponse",
      value: MsgUpdateAdminResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgUpdateAdminResponse.decode(message.value);
  },

  toProto(message) {
    return MsgUpdateAdminResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.MsgUpdateAdminResponse",
      value: MsgUpdateAdminResponse.encode(message).finish()
    };
  }

};

function createBaseMsgClearAdmin() {
  return {
    sender: "",
    contract: ""
  };
}

const MsgClearAdmin = {
  typeUrl: "/cosmwasm.wasm.v1.MsgClearAdmin",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.sender !== "") {
      writer.uint32(10).string(message.sender);
    }

    if (message.contract !== "") {
      writer.uint32(26).string(message.contract);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgClearAdmin();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.sender = reader.string();
          break;

        case 3:
          message.contract = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$sender7, _object$contract4;

    const message = createBaseMsgClearAdmin();
    message.sender = (_object$sender7 = object.sender) !== null && _object$sender7 !== void 0 ? _object$sender7 : "";
    message.contract = (_object$contract4 = object.contract) !== null && _object$contract4 !== void 0 ? _object$contract4 : "";
    return message;
  },

  fromAmino(object) {
    return {
      sender: object.sender,
      contract: object.contract
    };
  },

  toAmino(message) {
    const obj = {};
    obj.sender = message.sender;
    obj.contract = message.contract;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgClearAdmin.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "wasm/MsgClearAdmin",
      value: MsgClearAdmin.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgClearAdmin.decode(message.value);
  },

  toProto(message) {
    return MsgClearAdmin.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.MsgClearAdmin",
      value: MsgClearAdmin.encode(message).finish()
    };
  }

};

function createBaseMsgClearAdminResponse() {
  return {};
}

const MsgClearAdminResponse = {
  typeUrl: "/cosmwasm.wasm.v1.MsgClearAdminResponse",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgClearAdminResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseMsgClearAdminResponse();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return MsgClearAdminResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "wasm/MsgClearAdminResponse",
      value: MsgClearAdminResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgClearAdminResponse.decode(message.value);
  },

  toProto(message) {
    return MsgClearAdminResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.MsgClearAdminResponse",
      value: MsgClearAdminResponse.encode(message).finish()
    };
  }

};

function createBaseMsgUpdateInstantiateConfig() {
  return {
    sender: "",
    codeId: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO,
    newInstantiatePermission: undefined
  };
}

const MsgUpdateInstantiateConfig = {
  typeUrl: "/cosmwasm.wasm.v1.MsgUpdateInstantiateConfig",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.sender !== "") {
      writer.uint32(10).string(message.sender);
    }

    if (!message.codeId.isZero()) {
      writer.uint32(16).uint64(message.codeId);
    }

    if (message.newInstantiatePermission !== undefined) {
      _types__WEBPACK_IMPORTED_MODULE_0__.AccessConfig.encode(message.newInstantiatePermission, writer.uint32(26).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgUpdateInstantiateConfig();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.sender = reader.string();
          break;

        case 2:
          message.codeId = reader.uint64();
          break;

        case 3:
          message.newInstantiatePermission = _types__WEBPACK_IMPORTED_MODULE_0__.AccessConfig.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$sender8;

    const message = createBaseMsgUpdateInstantiateConfig();
    message.sender = (_object$sender8 = object.sender) !== null && _object$sender8 !== void 0 ? _object$sender8 : "";
    message.codeId = object.codeId !== undefined && object.codeId !== null ? _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromValue */ .dK.fromValue(object.codeId) : _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO;
    message.newInstantiatePermission = object.newInstantiatePermission !== undefined && object.newInstantiatePermission !== null ? _types__WEBPACK_IMPORTED_MODULE_0__.AccessConfig.fromPartial(object.newInstantiatePermission) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      sender: object.sender,
      codeId: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromString */ .dK.fromString(object.code_id),
      newInstantiatePermission: object !== null && object !== void 0 && object.new_instantiate_permission ? _types__WEBPACK_IMPORTED_MODULE_0__.AccessConfig.fromAmino(object.new_instantiate_permission) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.sender = message.sender;
    obj.code_id = message.codeId ? message.codeId.toString() : undefined;
    obj.new_instantiate_permission = message.newInstantiatePermission ? _types__WEBPACK_IMPORTED_MODULE_0__.AccessConfig.toAmino(message.newInstantiatePermission) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgUpdateInstantiateConfig.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "wasm/MsgUpdateInstantiateConfig",
      value: MsgUpdateInstantiateConfig.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgUpdateInstantiateConfig.decode(message.value);
  },

  toProto(message) {
    return MsgUpdateInstantiateConfig.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.MsgUpdateInstantiateConfig",
      value: MsgUpdateInstantiateConfig.encode(message).finish()
    };
  }

};

function createBaseMsgUpdateInstantiateConfigResponse() {
  return {};
}

const MsgUpdateInstantiateConfigResponse = {
  typeUrl: "/cosmwasm.wasm.v1.MsgUpdateInstantiateConfigResponse",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgUpdateInstantiateConfigResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseMsgUpdateInstantiateConfigResponse();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return MsgUpdateInstantiateConfigResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "wasm/MsgUpdateInstantiateConfigResponse",
      value: MsgUpdateInstantiateConfigResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgUpdateInstantiateConfigResponse.decode(message.value);
  },

  toProto(message) {
    return MsgUpdateInstantiateConfigResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.MsgUpdateInstantiateConfigResponse",
      value: MsgUpdateInstantiateConfigResponse.encode(message).finish()
    };
  }

};

function createBaseMsgUpdateParams() {
  return {
    authority: "",
    params: undefined
  };
}

const MsgUpdateParams = {
  typeUrl: "/cosmwasm.wasm.v1.MsgUpdateParams",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.authority !== "") {
      writer.uint32(10).string(message.authority);
    }

    if (message.params !== undefined) {
      _types__WEBPACK_IMPORTED_MODULE_0__.Params.encode(message.params, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgUpdateParams();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.authority = reader.string();
          break;

        case 2:
          message.params = _types__WEBPACK_IMPORTED_MODULE_0__.Params.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$authority;

    const message = createBaseMsgUpdateParams();
    message.authority = (_object$authority = object.authority) !== null && _object$authority !== void 0 ? _object$authority : "";
    message.params = object.params !== undefined && object.params !== null ? _types__WEBPACK_IMPORTED_MODULE_0__.Params.fromPartial(object.params) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      authority: object.authority,
      params: object !== null && object !== void 0 && object.params ? _types__WEBPACK_IMPORTED_MODULE_0__.Params.fromAmino(object.params) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.authority = message.authority;
    obj.params = message.params ? _types__WEBPACK_IMPORTED_MODULE_0__.Params.toAmino(message.params) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgUpdateParams.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "wasm/MsgUpdateParams",
      value: MsgUpdateParams.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgUpdateParams.decode(message.value);
  },

  toProto(message) {
    return MsgUpdateParams.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.MsgUpdateParams",
      value: MsgUpdateParams.encode(message).finish()
    };
  }

};

function createBaseMsgUpdateParamsResponse() {
  return {};
}

const MsgUpdateParamsResponse = {
  typeUrl: "/cosmwasm.wasm.v1.MsgUpdateParamsResponse",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgUpdateParamsResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseMsgUpdateParamsResponse();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return MsgUpdateParamsResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "wasm/MsgUpdateParamsResponse",
      value: MsgUpdateParamsResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgUpdateParamsResponse.decode(message.value);
  },

  toProto(message) {
    return MsgUpdateParamsResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.MsgUpdateParamsResponse",
      value: MsgUpdateParamsResponse.encode(message).finish()
    };
  }

};

function createBaseMsgSudoContract() {
  return {
    authority: "",
    contract: "",
    msg: new Uint8Array()
  };
}

const MsgSudoContract = {
  typeUrl: "/cosmwasm.wasm.v1.MsgSudoContract",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.authority !== "") {
      writer.uint32(10).string(message.authority);
    }

    if (message.contract !== "") {
      writer.uint32(18).string(message.contract);
    }

    if (message.msg.length !== 0) {
      writer.uint32(26).bytes(message.msg);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgSudoContract();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.authority = reader.string();
          break;

        case 2:
          message.contract = reader.string();
          break;

        case 3:
          message.msg = reader.bytes();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$authority2, _object$contract5, _object$msg5;

    const message = createBaseMsgSudoContract();
    message.authority = (_object$authority2 = object.authority) !== null && _object$authority2 !== void 0 ? _object$authority2 : "";
    message.contract = (_object$contract5 = object.contract) !== null && _object$contract5 !== void 0 ? _object$contract5 : "";
    message.msg = (_object$msg5 = object.msg) !== null && _object$msg5 !== void 0 ? _object$msg5 : new Uint8Array();
    return message;
  },

  fromAmino(object) {
    return {
      authority: object.authority,
      contract: object.contract,
      msg: (0,_cosmjs_encoding__WEBPACK_IMPORTED_MODULE_4__.toUtf8)(JSON.stringify(object.msg))
    };
  },

  toAmino(message) {
    const obj = {};
    obj.authority = message.authority;
    obj.contract = message.contract;
    obj.msg = message.msg ? JSON.parse((0,_cosmjs_encoding__WEBPACK_IMPORTED_MODULE_4__.fromUtf8)(message.msg)) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgSudoContract.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "wasm/MsgSudoContract",
      value: MsgSudoContract.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgSudoContract.decode(message.value);
  },

  toProto(message) {
    return MsgSudoContract.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.MsgSudoContract",
      value: MsgSudoContract.encode(message).finish()
    };
  }

};

function createBaseMsgSudoContractResponse() {
  return {
    data: new Uint8Array()
  };
}

const MsgSudoContractResponse = {
  typeUrl: "/cosmwasm.wasm.v1.MsgSudoContractResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.data.length !== 0) {
      writer.uint32(10).bytes(message.data);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgSudoContractResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.data = reader.bytes();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$data5;

    const message = createBaseMsgSudoContractResponse();
    message.data = (_object$data5 = object.data) !== null && _object$data5 !== void 0 ? _object$data5 : new Uint8Array();
    return message;
  },

  fromAmino(object) {
    return {
      data: object.data
    };
  },

  toAmino(message) {
    const obj = {};
    obj.data = message.data;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgSudoContractResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "wasm/MsgSudoContractResponse",
      value: MsgSudoContractResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgSudoContractResponse.decode(message.value);
  },

  toProto(message) {
    return MsgSudoContractResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.MsgSudoContractResponse",
      value: MsgSudoContractResponse.encode(message).finish()
    };
  }

};

function createBaseMsgPinCodes() {
  return {
    authority: "",
    codeIds: []
  };
}

const MsgPinCodes = {
  typeUrl: "/cosmwasm.wasm.v1.MsgPinCodes",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.authority !== "") {
      writer.uint32(10).string(message.authority);
    }

    writer.uint32(18).fork();

    for (const v of message.codeIds) {
      writer.uint64(v);
    }

    writer.ldelim();
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgPinCodes();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.authority = reader.string();
          break;

        case 2:
          if ((tag & 7) === 2) {
            const end2 = reader.uint32() + reader.pos;

            while (reader.pos < end2) {
              message.codeIds.push(reader.uint64());
            }
          } else {
            message.codeIds.push(reader.uint64());
          }

          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$authority3, _object$codeIds;

    const message = createBaseMsgPinCodes();
    message.authority = (_object$authority3 = object.authority) !== null && _object$authority3 !== void 0 ? _object$authority3 : "";
    message.codeIds = ((_object$codeIds = object.codeIds) === null || _object$codeIds === void 0 ? void 0 : _object$codeIds.map(e => _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromValue */ .dK.fromValue(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      authority: object.authority,
      codeIds: Array.isArray(object === null || object === void 0 ? void 0 : object.code_ids) ? object.code_ids.map(e => e) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.authority = message.authority;

    if (message.codeIds) {
      obj.code_ids = message.codeIds.map(e => e);
    } else {
      obj.code_ids = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return MsgPinCodes.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "wasm/MsgPinCodes",
      value: MsgPinCodes.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgPinCodes.decode(message.value);
  },

  toProto(message) {
    return MsgPinCodes.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.MsgPinCodes",
      value: MsgPinCodes.encode(message).finish()
    };
  }

};

function createBaseMsgPinCodesResponse() {
  return {};
}

const MsgPinCodesResponse = {
  typeUrl: "/cosmwasm.wasm.v1.MsgPinCodesResponse",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgPinCodesResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseMsgPinCodesResponse();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return MsgPinCodesResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "wasm/MsgPinCodesResponse",
      value: MsgPinCodesResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgPinCodesResponse.decode(message.value);
  },

  toProto(message) {
    return MsgPinCodesResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.MsgPinCodesResponse",
      value: MsgPinCodesResponse.encode(message).finish()
    };
  }

};

function createBaseMsgUnpinCodes() {
  return {
    authority: "",
    codeIds: []
  };
}

const MsgUnpinCodes = {
  typeUrl: "/cosmwasm.wasm.v1.MsgUnpinCodes",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.authority !== "") {
      writer.uint32(10).string(message.authority);
    }

    writer.uint32(18).fork();

    for (const v of message.codeIds) {
      writer.uint64(v);
    }

    writer.ldelim();
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgUnpinCodes();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.authority = reader.string();
          break;

        case 2:
          if ((tag & 7) === 2) {
            const end2 = reader.uint32() + reader.pos;

            while (reader.pos < end2) {
              message.codeIds.push(reader.uint64());
            }
          } else {
            message.codeIds.push(reader.uint64());
          }

          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$authority4, _object$codeIds2;

    const message = createBaseMsgUnpinCodes();
    message.authority = (_object$authority4 = object.authority) !== null && _object$authority4 !== void 0 ? _object$authority4 : "";
    message.codeIds = ((_object$codeIds2 = object.codeIds) === null || _object$codeIds2 === void 0 ? void 0 : _object$codeIds2.map(e => _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromValue */ .dK.fromValue(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      authority: object.authority,
      codeIds: Array.isArray(object === null || object === void 0 ? void 0 : object.code_ids) ? object.code_ids.map(e => e) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.authority = message.authority;

    if (message.codeIds) {
      obj.code_ids = message.codeIds.map(e => e);
    } else {
      obj.code_ids = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return MsgUnpinCodes.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "wasm/MsgUnpinCodes",
      value: MsgUnpinCodes.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgUnpinCodes.decode(message.value);
  },

  toProto(message) {
    return MsgUnpinCodes.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.MsgUnpinCodes",
      value: MsgUnpinCodes.encode(message).finish()
    };
  }

};

function createBaseMsgUnpinCodesResponse() {
  return {};
}

const MsgUnpinCodesResponse = {
  typeUrl: "/cosmwasm.wasm.v1.MsgUnpinCodesResponse",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgUnpinCodesResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseMsgUnpinCodesResponse();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return MsgUnpinCodesResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "wasm/MsgUnpinCodesResponse",
      value: MsgUnpinCodesResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgUnpinCodesResponse.decode(message.value);
  },

  toProto(message) {
    return MsgUnpinCodesResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.MsgUnpinCodesResponse",
      value: MsgUnpinCodesResponse.encode(message).finish()
    };
  }

};

function createBaseMsgStoreAndInstantiateContract() {
  return {
    authority: "",
    wasmByteCode: new Uint8Array(),
    instantiatePermission: undefined,
    unpinCode: false,
    admin: "",
    label: "",
    msg: new Uint8Array(),
    funds: [],
    source: "",
    builder: "",
    codeHash: new Uint8Array()
  };
}

const MsgStoreAndInstantiateContract = {
  typeUrl: "/cosmwasm.wasm.v1.MsgStoreAndInstantiateContract",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.authority !== "") {
      writer.uint32(10).string(message.authority);
    }

    if (message.wasmByteCode.length !== 0) {
      writer.uint32(26).bytes(message.wasmByteCode);
    }

    if (message.instantiatePermission !== undefined) {
      _types__WEBPACK_IMPORTED_MODULE_0__.AccessConfig.encode(message.instantiatePermission, writer.uint32(34).fork()).ldelim();
    }

    if (message.unpinCode === true) {
      writer.uint32(40).bool(message.unpinCode);
    }

    if (message.admin !== "") {
      writer.uint32(50).string(message.admin);
    }

    if (message.label !== "") {
      writer.uint32(58).string(message.label);
    }

    if (message.msg.length !== 0) {
      writer.uint32(66).bytes(message.msg);
    }

    for (const v of message.funds) {
      _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.encode(v, writer.uint32(74).fork()).ldelim();
    }

    if (message.source !== "") {
      writer.uint32(82).string(message.source);
    }

    if (message.builder !== "") {
      writer.uint32(90).string(message.builder);
    }

    if (message.codeHash.length !== 0) {
      writer.uint32(98).bytes(message.codeHash);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgStoreAndInstantiateContract();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.authority = reader.string();
          break;

        case 3:
          message.wasmByteCode = reader.bytes();
          break;

        case 4:
          message.instantiatePermission = _types__WEBPACK_IMPORTED_MODULE_0__.AccessConfig.decode(reader, reader.uint32());
          break;

        case 5:
          message.unpinCode = reader.bool();
          break;

        case 6:
          message.admin = reader.string();
          break;

        case 7:
          message.label = reader.string();
          break;

        case 8:
          message.msg = reader.bytes();
          break;

        case 9:
          message.funds.push(_cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.decode(reader, reader.uint32()));
          break;

        case 10:
          message.source = reader.string();
          break;

        case 11:
          message.builder = reader.string();
          break;

        case 12:
          message.codeHash = reader.bytes();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$authority5, _object$wasmByteCode2, _object$unpinCode, _object$admin3, _object$label3, _object$msg6, _object$funds4, _object$source, _object$builder, _object$codeHash;

    const message = createBaseMsgStoreAndInstantiateContract();
    message.authority = (_object$authority5 = object.authority) !== null && _object$authority5 !== void 0 ? _object$authority5 : "";
    message.wasmByteCode = (_object$wasmByteCode2 = object.wasmByteCode) !== null && _object$wasmByteCode2 !== void 0 ? _object$wasmByteCode2 : new Uint8Array();
    message.instantiatePermission = object.instantiatePermission !== undefined && object.instantiatePermission !== null ? _types__WEBPACK_IMPORTED_MODULE_0__.AccessConfig.fromPartial(object.instantiatePermission) : undefined;
    message.unpinCode = (_object$unpinCode = object.unpinCode) !== null && _object$unpinCode !== void 0 ? _object$unpinCode : false;
    message.admin = (_object$admin3 = object.admin) !== null && _object$admin3 !== void 0 ? _object$admin3 : "";
    message.label = (_object$label3 = object.label) !== null && _object$label3 !== void 0 ? _object$label3 : "";
    message.msg = (_object$msg6 = object.msg) !== null && _object$msg6 !== void 0 ? _object$msg6 : new Uint8Array();
    message.funds = ((_object$funds4 = object.funds) === null || _object$funds4 === void 0 ? void 0 : _object$funds4.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.fromPartial(e))) || [];
    message.source = (_object$source = object.source) !== null && _object$source !== void 0 ? _object$source : "";
    message.builder = (_object$builder = object.builder) !== null && _object$builder !== void 0 ? _object$builder : "";
    message.codeHash = (_object$codeHash = object.codeHash) !== null && _object$codeHash !== void 0 ? _object$codeHash : new Uint8Array();
    return message;
  },

  fromAmino(object) {
    return {
      authority: object.authority,
      wasmByteCode: (0,_cosmjs_encoding__WEBPACK_IMPORTED_MODULE_4__.fromBase64)(object.wasm_byte_code),
      instantiatePermission: object !== null && object !== void 0 && object.instantiate_permission ? _types__WEBPACK_IMPORTED_MODULE_0__.AccessConfig.fromAmino(object.instantiate_permission) : undefined,
      unpinCode: object.unpin_code,
      admin: object.admin,
      label: object.label,
      msg: (0,_cosmjs_encoding__WEBPACK_IMPORTED_MODULE_4__.toUtf8)(JSON.stringify(object.msg)),
      funds: Array.isArray(object === null || object === void 0 ? void 0 : object.funds) ? object.funds.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.fromAmino(e)) : [],
      source: object.source,
      builder: object.builder,
      codeHash: object.code_hash
    };
  },

  toAmino(message) {
    const obj = {};
    obj.authority = message.authority;
    obj.wasm_byte_code = message.wasmByteCode ? (0,_cosmjs_encoding__WEBPACK_IMPORTED_MODULE_4__.toBase64)(message.wasmByteCode) : undefined;
    obj.instantiate_permission = message.instantiatePermission ? _types__WEBPACK_IMPORTED_MODULE_0__.AccessConfig.toAmino(message.instantiatePermission) : undefined;
    obj.unpin_code = message.unpinCode;
    obj.admin = message.admin;
    obj.label = message.label;
    obj.msg = message.msg ? JSON.parse((0,_cosmjs_encoding__WEBPACK_IMPORTED_MODULE_4__.fromUtf8)(message.msg)) : undefined;

    if (message.funds) {
      obj.funds = message.funds.map(e => e ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.toAmino(e) : undefined);
    } else {
      obj.funds = [];
    }

    obj.source = message.source;
    obj.builder = message.builder;
    obj.code_hash = message.codeHash;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgStoreAndInstantiateContract.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "wasm/MsgStoreAndInstantiateContract",
      value: MsgStoreAndInstantiateContract.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgStoreAndInstantiateContract.decode(message.value);
  },

  toProto(message) {
    return MsgStoreAndInstantiateContract.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.MsgStoreAndInstantiateContract",
      value: MsgStoreAndInstantiateContract.encode(message).finish()
    };
  }

};

function createBaseMsgStoreAndInstantiateContractResponse() {
  return {
    address: "",
    data: new Uint8Array()
  };
}

const MsgStoreAndInstantiateContractResponse = {
  typeUrl: "/cosmwasm.wasm.v1.MsgStoreAndInstantiateContractResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.address !== "") {
      writer.uint32(10).string(message.address);
    }

    if (message.data.length !== 0) {
      writer.uint32(18).bytes(message.data);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgStoreAndInstantiateContractResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.address = reader.string();
          break;

        case 2:
          message.data = reader.bytes();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$address3, _object$data6;

    const message = createBaseMsgStoreAndInstantiateContractResponse();
    message.address = (_object$address3 = object.address) !== null && _object$address3 !== void 0 ? _object$address3 : "";
    message.data = (_object$data6 = object.data) !== null && _object$data6 !== void 0 ? _object$data6 : new Uint8Array();
    return message;
  },

  fromAmino(object) {
    return {
      address: object.address,
      data: object.data
    };
  },

  toAmino(message) {
    const obj = {};
    obj.address = message.address;
    obj.data = message.data;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgStoreAndInstantiateContractResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "wasm/MsgStoreAndInstantiateContractResponse",
      value: MsgStoreAndInstantiateContractResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgStoreAndInstantiateContractResponse.decode(message.value);
  },

  toProto(message) {
    return MsgStoreAndInstantiateContractResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.MsgStoreAndInstantiateContractResponse",
      value: MsgStoreAndInstantiateContractResponse.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 20891:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MsgClientImpl": function() { return /* binding */ MsgClientImpl; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4942);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _tx__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88547);



/** Msg defines the wasm Msg service. */

class MsgClientImpl {
  constructor(rpc) {
    (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, "rpc", void 0);

    this.rpc = rpc;
    this.storeCode = this.storeCode.bind(this);
    this.instantiateContract = this.instantiateContract.bind(this);
    this.instantiateContract2 = this.instantiateContract2.bind(this);
    this.executeContract = this.executeContract.bind(this);
    this.migrateContract = this.migrateContract.bind(this);
    this.updateAdmin = this.updateAdmin.bind(this);
    this.clearAdmin = this.clearAdmin.bind(this);
    this.updateInstantiateConfig = this.updateInstantiateConfig.bind(this);
    this.updateParams = this.updateParams.bind(this);
    this.sudoContract = this.sudoContract.bind(this);
    this.pinCodes = this.pinCodes.bind(this);
    this.unpinCodes = this.unpinCodes.bind(this);
    this.storeAndInstantiateContract = this.storeAndInstantiateContract.bind(this);
  }

  storeCode(request) {
    const data = _tx__WEBPACK_IMPORTED_MODULE_1__.MsgStoreCode.encode(request).finish();
    const promise = this.rpc.request("cosmwasm.wasm.v1.Msg", "StoreCode", data);
    return promise.then(data => _tx__WEBPACK_IMPORTED_MODULE_1__.MsgStoreCodeResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  instantiateContract(request) {
    const data = _tx__WEBPACK_IMPORTED_MODULE_1__.MsgInstantiateContract.encode(request).finish();
    const promise = this.rpc.request("cosmwasm.wasm.v1.Msg", "InstantiateContract", data);
    return promise.then(data => _tx__WEBPACK_IMPORTED_MODULE_1__.MsgInstantiateContractResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  instantiateContract2(request) {
    const data = _tx__WEBPACK_IMPORTED_MODULE_1__.MsgInstantiateContract2.encode(request).finish();
    const promise = this.rpc.request("cosmwasm.wasm.v1.Msg", "InstantiateContract2", data);
    return promise.then(data => _tx__WEBPACK_IMPORTED_MODULE_1__.MsgInstantiateContract2Response.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  executeContract(request) {
    const data = _tx__WEBPACK_IMPORTED_MODULE_1__.MsgExecuteContract.encode(request).finish();
    const promise = this.rpc.request("cosmwasm.wasm.v1.Msg", "ExecuteContract", data);
    return promise.then(data => _tx__WEBPACK_IMPORTED_MODULE_1__.MsgExecuteContractResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  migrateContract(request) {
    const data = _tx__WEBPACK_IMPORTED_MODULE_1__.MsgMigrateContract.encode(request).finish();
    const promise = this.rpc.request("cosmwasm.wasm.v1.Msg", "MigrateContract", data);
    return promise.then(data => _tx__WEBPACK_IMPORTED_MODULE_1__.MsgMigrateContractResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  updateAdmin(request) {
    const data = _tx__WEBPACK_IMPORTED_MODULE_1__.MsgUpdateAdmin.encode(request).finish();
    const promise = this.rpc.request("cosmwasm.wasm.v1.Msg", "UpdateAdmin", data);
    return promise.then(data => _tx__WEBPACK_IMPORTED_MODULE_1__.MsgUpdateAdminResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  clearAdmin(request) {
    const data = _tx__WEBPACK_IMPORTED_MODULE_1__.MsgClearAdmin.encode(request).finish();
    const promise = this.rpc.request("cosmwasm.wasm.v1.Msg", "ClearAdmin", data);
    return promise.then(data => _tx__WEBPACK_IMPORTED_MODULE_1__.MsgClearAdminResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  updateInstantiateConfig(request) {
    const data = _tx__WEBPACK_IMPORTED_MODULE_1__.MsgUpdateInstantiateConfig.encode(request).finish();
    const promise = this.rpc.request("cosmwasm.wasm.v1.Msg", "UpdateInstantiateConfig", data);
    return promise.then(data => _tx__WEBPACK_IMPORTED_MODULE_1__.MsgUpdateInstantiateConfigResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  updateParams(request) {
    const data = _tx__WEBPACK_IMPORTED_MODULE_1__.MsgUpdateParams.encode(request).finish();
    const promise = this.rpc.request("cosmwasm.wasm.v1.Msg", "UpdateParams", data);
    return promise.then(data => _tx__WEBPACK_IMPORTED_MODULE_1__.MsgUpdateParamsResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  sudoContract(request) {
    const data = _tx__WEBPACK_IMPORTED_MODULE_1__.MsgSudoContract.encode(request).finish();
    const promise = this.rpc.request("cosmwasm.wasm.v1.Msg", "SudoContract", data);
    return promise.then(data => _tx__WEBPACK_IMPORTED_MODULE_1__.MsgSudoContractResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  pinCodes(request) {
    const data = _tx__WEBPACK_IMPORTED_MODULE_1__.MsgPinCodes.encode(request).finish();
    const promise = this.rpc.request("cosmwasm.wasm.v1.Msg", "PinCodes", data);
    return promise.then(data => _tx__WEBPACK_IMPORTED_MODULE_1__.MsgPinCodesResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  unpinCodes(request) {
    const data = _tx__WEBPACK_IMPORTED_MODULE_1__.MsgUnpinCodes.encode(request).finish();
    const promise = this.rpc.request("cosmwasm.wasm.v1.Msg", "UnpinCodes", data);
    return promise.then(data => _tx__WEBPACK_IMPORTED_MODULE_1__.MsgUnpinCodesResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  storeAndInstantiateContract(request) {
    const data = _tx__WEBPACK_IMPORTED_MODULE_1__.MsgStoreAndInstantiateContract.encode(request).finish();
    const promise = this.rpc.request("cosmwasm.wasm.v1.Msg", "StoreAndInstantiateContract", data);
    return promise.then(data => _tx__WEBPACK_IMPORTED_MODULE_1__.MsgStoreAndInstantiateContractResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

}

/***/ }),

/***/ 12315:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AbsoluteTxPosition": function() { return /* binding */ AbsoluteTxPosition; },
/* harmony export */   "AccessConfig": function() { return /* binding */ AccessConfig; },
/* harmony export */   "AccessType": function() { return /* binding */ AccessType; },
/* harmony export */   "AccessTypeAmino": function() { return /* binding */ AccessTypeAmino; },
/* harmony export */   "AccessTypeParam": function() { return /* binding */ AccessTypeParam; },
/* harmony export */   "AccessTypeSDKType": function() { return /* binding */ AccessTypeSDKType; },
/* harmony export */   "CodeInfo": function() { return /* binding */ CodeInfo; },
/* harmony export */   "ContractCodeHistoryEntry": function() { return /* binding */ ContractCodeHistoryEntry; },
/* harmony export */   "ContractCodeHistoryOperationType": function() { return /* binding */ ContractCodeHistoryOperationType; },
/* harmony export */   "ContractCodeHistoryOperationTypeAmino": function() { return /* binding */ ContractCodeHistoryOperationTypeAmino; },
/* harmony export */   "ContractCodeHistoryOperationTypeSDKType": function() { return /* binding */ ContractCodeHistoryOperationTypeSDKType; },
/* harmony export */   "ContractInfo": function() { return /* binding */ ContractInfo; },
/* harmony export */   "Cosmwasm_wasmv1ContractInfoExtension_FromAmino": function() { return /* binding */ Cosmwasm_wasmv1ContractInfoExtension_FromAmino; },
/* harmony export */   "Cosmwasm_wasmv1ContractInfoExtension_InterfaceDecoder": function() { return /* binding */ Cosmwasm_wasmv1ContractInfoExtension_InterfaceDecoder; },
/* harmony export */   "Cosmwasm_wasmv1ContractInfoExtension_ToAmino": function() { return /* binding */ Cosmwasm_wasmv1ContractInfoExtension_ToAmino; },
/* harmony export */   "Model": function() { return /* binding */ Model; },
/* harmony export */   "Params": function() { return /* binding */ Params; },
/* harmony export */   "accessTypeFromJSON": function() { return /* binding */ accessTypeFromJSON; },
/* harmony export */   "accessTypeToJSON": function() { return /* binding */ accessTypeToJSON; },
/* harmony export */   "contractCodeHistoryOperationTypeFromJSON": function() { return /* binding */ contractCodeHistoryOperationTypeFromJSON; },
/* harmony export */   "contractCodeHistoryOperationTypeToJSON": function() { return /* binding */ contractCodeHistoryOperationTypeToJSON; }
/* harmony export */ });
/* harmony import */ var _google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32106);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47895);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _cosmjs_encoding__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71555);




/** AccessType permission types */

let AccessType;

(function (AccessType) {
  AccessType[AccessType["ACCESS_TYPE_UNSPECIFIED"] = 0] = "ACCESS_TYPE_UNSPECIFIED";
  AccessType[AccessType["ACCESS_TYPE_NOBODY"] = 1] = "ACCESS_TYPE_NOBODY";
  AccessType[AccessType["ACCESS_TYPE_ONLY_ADDRESS"] = 2] = "ACCESS_TYPE_ONLY_ADDRESS";
  AccessType[AccessType["ACCESS_TYPE_EVERYBODY"] = 3] = "ACCESS_TYPE_EVERYBODY";
  AccessType[AccessType["ACCESS_TYPE_ANY_OF_ADDRESSES"] = 4] = "ACCESS_TYPE_ANY_OF_ADDRESSES";
  AccessType[AccessType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(AccessType || (AccessType = {}));

const AccessTypeSDKType = AccessType;
const AccessTypeAmino = AccessType;
function accessTypeFromJSON(object) {
  switch (object) {
    case 0:
    case "ACCESS_TYPE_UNSPECIFIED":
      return AccessType.ACCESS_TYPE_UNSPECIFIED;

    case 1:
    case "ACCESS_TYPE_NOBODY":
      return AccessType.ACCESS_TYPE_NOBODY;

    case 2:
    case "ACCESS_TYPE_ONLY_ADDRESS":
      return AccessType.ACCESS_TYPE_ONLY_ADDRESS;

    case 3:
    case "ACCESS_TYPE_EVERYBODY":
      return AccessType.ACCESS_TYPE_EVERYBODY;

    case 4:
    case "ACCESS_TYPE_ANY_OF_ADDRESSES":
      return AccessType.ACCESS_TYPE_ANY_OF_ADDRESSES;

    case -1:
    case "UNRECOGNIZED":
    default:
      return AccessType.UNRECOGNIZED;
  }
}
function accessTypeToJSON(object) {
  switch (object) {
    case AccessType.ACCESS_TYPE_UNSPECIFIED:
      return "ACCESS_TYPE_UNSPECIFIED";

    case AccessType.ACCESS_TYPE_NOBODY:
      return "ACCESS_TYPE_NOBODY";

    case AccessType.ACCESS_TYPE_ONLY_ADDRESS:
      return "ACCESS_TYPE_ONLY_ADDRESS";

    case AccessType.ACCESS_TYPE_EVERYBODY:
      return "ACCESS_TYPE_EVERYBODY";

    case AccessType.ACCESS_TYPE_ANY_OF_ADDRESSES:
      return "ACCESS_TYPE_ANY_OF_ADDRESSES";

    case AccessType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
/** ContractCodeHistoryOperationType actions that caused a code change */

let ContractCodeHistoryOperationType;

(function (ContractCodeHistoryOperationType) {
  ContractCodeHistoryOperationType[ContractCodeHistoryOperationType["CONTRACT_CODE_HISTORY_OPERATION_TYPE_UNSPECIFIED"] = 0] = "CONTRACT_CODE_HISTORY_OPERATION_TYPE_UNSPECIFIED";
  ContractCodeHistoryOperationType[ContractCodeHistoryOperationType["CONTRACT_CODE_HISTORY_OPERATION_TYPE_INIT"] = 1] = "CONTRACT_CODE_HISTORY_OPERATION_TYPE_INIT";
  ContractCodeHistoryOperationType[ContractCodeHistoryOperationType["CONTRACT_CODE_HISTORY_OPERATION_TYPE_MIGRATE"] = 2] = "CONTRACT_CODE_HISTORY_OPERATION_TYPE_MIGRATE";
  ContractCodeHistoryOperationType[ContractCodeHistoryOperationType["CONTRACT_CODE_HISTORY_OPERATION_TYPE_GENESIS"] = 3] = "CONTRACT_CODE_HISTORY_OPERATION_TYPE_GENESIS";
  ContractCodeHistoryOperationType[ContractCodeHistoryOperationType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(ContractCodeHistoryOperationType || (ContractCodeHistoryOperationType = {}));

const ContractCodeHistoryOperationTypeSDKType = ContractCodeHistoryOperationType;
const ContractCodeHistoryOperationTypeAmino = ContractCodeHistoryOperationType;
function contractCodeHistoryOperationTypeFromJSON(object) {
  switch (object) {
    case 0:
    case "CONTRACT_CODE_HISTORY_OPERATION_TYPE_UNSPECIFIED":
      return ContractCodeHistoryOperationType.CONTRACT_CODE_HISTORY_OPERATION_TYPE_UNSPECIFIED;

    case 1:
    case "CONTRACT_CODE_HISTORY_OPERATION_TYPE_INIT":
      return ContractCodeHistoryOperationType.CONTRACT_CODE_HISTORY_OPERATION_TYPE_INIT;

    case 2:
    case "CONTRACT_CODE_HISTORY_OPERATION_TYPE_MIGRATE":
      return ContractCodeHistoryOperationType.CONTRACT_CODE_HISTORY_OPERATION_TYPE_MIGRATE;

    case 3:
    case "CONTRACT_CODE_HISTORY_OPERATION_TYPE_GENESIS":
      return ContractCodeHistoryOperationType.CONTRACT_CODE_HISTORY_OPERATION_TYPE_GENESIS;

    case -1:
    case "UNRECOGNIZED":
    default:
      return ContractCodeHistoryOperationType.UNRECOGNIZED;
  }
}
function contractCodeHistoryOperationTypeToJSON(object) {
  switch (object) {
    case ContractCodeHistoryOperationType.CONTRACT_CODE_HISTORY_OPERATION_TYPE_UNSPECIFIED:
      return "CONTRACT_CODE_HISTORY_OPERATION_TYPE_UNSPECIFIED";

    case ContractCodeHistoryOperationType.CONTRACT_CODE_HISTORY_OPERATION_TYPE_INIT:
      return "CONTRACT_CODE_HISTORY_OPERATION_TYPE_INIT";

    case ContractCodeHistoryOperationType.CONTRACT_CODE_HISTORY_OPERATION_TYPE_MIGRATE:
      return "CONTRACT_CODE_HISTORY_OPERATION_TYPE_MIGRATE";

    case ContractCodeHistoryOperationType.CONTRACT_CODE_HISTORY_OPERATION_TYPE_GENESIS:
      return "CONTRACT_CODE_HISTORY_OPERATION_TYPE_GENESIS";

    case ContractCodeHistoryOperationType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
/** AccessTypeParam */

function createBaseAccessTypeParam() {
  return {
    value: 0
  };
}

const AccessTypeParam = {
  typeUrl: "/cosmwasm.wasm.v1.AccessTypeParam",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (message.value !== 0) {
      writer.uint32(8).int32(message.value);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAccessTypeParam();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.value = reader.int32();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$value;

    const message = createBaseAccessTypeParam();
    message.value = (_object$value = object.value) !== null && _object$value !== void 0 ? _object$value : 0;
    return message;
  },

  fromAmino(object) {
    return {
      value: (0,_helpers__WEBPACK_IMPORTED_MODULE_1__/* .isSet */ .DM)(object.value) ? accessTypeFromJSON(object.value) : 0
    };
  },

  toAmino(message) {
    const obj = {};
    obj.value = message.value;
    return obj;
  },

  fromAminoMsg(object) {
    return AccessTypeParam.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "wasm/AccessTypeParam",
      value: AccessTypeParam.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return AccessTypeParam.decode(message.value);
  },

  toProto(message) {
    return AccessTypeParam.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.AccessTypeParam",
      value: AccessTypeParam.encode(message).finish()
    };
  }

};

function createBaseAccessConfig() {
  return {
    permission: 0,
    address: "",
    addresses: []
  };
}

const AccessConfig = {
  typeUrl: "/cosmwasm.wasm.v1.AccessConfig",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (message.permission !== 0) {
      writer.uint32(8).int32(message.permission);
    }

    if (message.address !== "") {
      writer.uint32(18).string(message.address);
    }

    for (const v of message.addresses) {
      writer.uint32(26).string(v);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAccessConfig();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.permission = reader.int32();
          break;

        case 2:
          message.address = reader.string();
          break;

        case 3:
          message.addresses.push(reader.string());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$permission, _object$address, _object$addresses;

    const message = createBaseAccessConfig();
    message.permission = (_object$permission = object.permission) !== null && _object$permission !== void 0 ? _object$permission : 0;
    message.address = (_object$address = object.address) !== null && _object$address !== void 0 ? _object$address : "";
    message.addresses = ((_object$addresses = object.addresses) === null || _object$addresses === void 0 ? void 0 : _object$addresses.map(e => e)) || [];
    return message;
  },

  fromAmino(object) {
    return {
      permission: (0,_helpers__WEBPACK_IMPORTED_MODULE_1__/* .isSet */ .DM)(object.permission) ? accessTypeFromJSON(object.permission) : 0,
      address: object.address,
      addresses: Array.isArray(object === null || object === void 0 ? void 0 : object.addresses) ? object.addresses.map(e => e) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.permission = message.permission;
    obj.address = message.address;

    if (message.addresses) {
      obj.addresses = message.addresses.map(e => e);
    } else {
      obj.addresses = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return AccessConfig.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "wasm/AccessConfig",
      value: AccessConfig.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return AccessConfig.decode(message.value);
  },

  toProto(message) {
    return AccessConfig.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.AccessConfig",
      value: AccessConfig.encode(message).finish()
    };
  }

};

function createBaseParams() {
  return {
    codeUploadAccess: undefined,
    instantiateDefaultPermission: 0
  };
}

const Params = {
  typeUrl: "/cosmwasm.wasm.v1.Params",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (message.codeUploadAccess !== undefined) {
      AccessConfig.encode(message.codeUploadAccess, writer.uint32(10).fork()).ldelim();
    }

    if (message.instantiateDefaultPermission !== 0) {
      writer.uint32(16).int32(message.instantiateDefaultPermission);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseParams();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.codeUploadAccess = AccessConfig.decode(reader, reader.uint32());
          break;

        case 2:
          message.instantiateDefaultPermission = reader.int32();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$instantiateDe;

    const message = createBaseParams();
    message.codeUploadAccess = object.codeUploadAccess !== undefined && object.codeUploadAccess !== null ? AccessConfig.fromPartial(object.codeUploadAccess) : undefined;
    message.instantiateDefaultPermission = (_object$instantiateDe = object.instantiateDefaultPermission) !== null && _object$instantiateDe !== void 0 ? _object$instantiateDe : 0;
    return message;
  },

  fromAmino(object) {
    return {
      codeUploadAccess: object !== null && object !== void 0 && object.code_upload_access ? AccessConfig.fromAmino(object.code_upload_access) : undefined,
      instantiateDefaultPermission: (0,_helpers__WEBPACK_IMPORTED_MODULE_1__/* .isSet */ .DM)(object.instantiate_default_permission) ? accessTypeFromJSON(object.instantiate_default_permission) : 0
    };
  },

  toAmino(message) {
    const obj = {};
    obj.code_upload_access = message.codeUploadAccess ? AccessConfig.toAmino(message.codeUploadAccess) : undefined;
    obj.instantiate_default_permission = message.instantiateDefaultPermission;
    return obj;
  },

  fromAminoMsg(object) {
    return Params.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "wasm/Params",
      value: Params.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return Params.decode(message.value);
  },

  toProto(message) {
    return Params.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.Params",
      value: Params.encode(message).finish()
    };
  }

};

function createBaseCodeInfo() {
  return {
    codeHash: new Uint8Array(),
    creator: "",
    instantiateConfig: undefined
  };
}

const CodeInfo = {
  typeUrl: "/cosmwasm.wasm.v1.CodeInfo",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (message.codeHash.length !== 0) {
      writer.uint32(10).bytes(message.codeHash);
    }

    if (message.creator !== "") {
      writer.uint32(18).string(message.creator);
    }

    if (message.instantiateConfig !== undefined) {
      AccessConfig.encode(message.instantiateConfig, writer.uint32(42).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCodeInfo();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.codeHash = reader.bytes();
          break;

        case 2:
          message.creator = reader.string();
          break;

        case 5:
          message.instantiateConfig = AccessConfig.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$codeHash, _object$creator;

    const message = createBaseCodeInfo();
    message.codeHash = (_object$codeHash = object.codeHash) !== null && _object$codeHash !== void 0 ? _object$codeHash : new Uint8Array();
    message.creator = (_object$creator = object.creator) !== null && _object$creator !== void 0 ? _object$creator : "";
    message.instantiateConfig = object.instantiateConfig !== undefined && object.instantiateConfig !== null ? AccessConfig.fromPartial(object.instantiateConfig) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      codeHash: object.code_hash,
      creator: object.creator,
      instantiateConfig: object !== null && object !== void 0 && object.instantiate_config ? AccessConfig.fromAmino(object.instantiate_config) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.code_hash = message.codeHash;
    obj.creator = message.creator;
    obj.instantiate_config = message.instantiateConfig ? AccessConfig.toAmino(message.instantiateConfig) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return CodeInfo.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "wasm/CodeInfo",
      value: CodeInfo.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return CodeInfo.decode(message.value);
  },

  toProto(message) {
    return CodeInfo.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.CodeInfo",
      value: CodeInfo.encode(message).finish()
    };
  }

};

function createBaseContractInfo() {
  return {
    codeId: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.UZERO */ .dK.UZERO,
    creator: "",
    admin: "",
    label: "",
    created: undefined,
    ibcPortId: "",
    extension: undefined
  };
}

const ContractInfo = {
  typeUrl: "/cosmwasm.wasm.v1.ContractInfo",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (!message.codeId.isZero()) {
      writer.uint32(8).uint64(message.codeId);
    }

    if (message.creator !== "") {
      writer.uint32(18).string(message.creator);
    }

    if (message.admin !== "") {
      writer.uint32(26).string(message.admin);
    }

    if (message.label !== "") {
      writer.uint32(34).string(message.label);
    }

    if (message.created !== undefined) {
      AbsoluteTxPosition.encode(message.created, writer.uint32(42).fork()).ldelim();
    }

    if (message.ibcPortId !== "") {
      writer.uint32(50).string(message.ibcPortId);
    }

    if (message.extension !== undefined) {
      _google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__.Any.encode(message.extension, writer.uint32(58).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseContractInfo();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.codeId = reader.uint64();
          break;

        case 2:
          message.creator = reader.string();
          break;

        case 3:
          message.admin = reader.string();
          break;

        case 4:
          message.label = reader.string();
          break;

        case 5:
          message.created = AbsoluteTxPosition.decode(reader, reader.uint32());
          break;

        case 6:
          message.ibcPortId = reader.string();
          break;

        case 7:
          message.extension = Cosmwasm_wasmv1ContractInfoExtension_InterfaceDecoder(reader);
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$creator2, _object$admin, _object$label, _object$ibcPortId;

    const message = createBaseContractInfo();
    message.codeId = object.codeId !== undefined && object.codeId !== null ? _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromValue */ .dK.fromValue(object.codeId) : _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.UZERO */ .dK.UZERO;
    message.creator = (_object$creator2 = object.creator) !== null && _object$creator2 !== void 0 ? _object$creator2 : "";
    message.admin = (_object$admin = object.admin) !== null && _object$admin !== void 0 ? _object$admin : "";
    message.label = (_object$label = object.label) !== null && _object$label !== void 0 ? _object$label : "";
    message.created = object.created !== undefined && object.created !== null ? AbsoluteTxPosition.fromPartial(object.created) : undefined;
    message.ibcPortId = (_object$ibcPortId = object.ibcPortId) !== null && _object$ibcPortId !== void 0 ? _object$ibcPortId : "";
    message.extension = object.extension !== undefined && object.extension !== null ? _google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__.Any.fromPartial(object.extension) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      codeId: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromString */ .dK.fromString(object.code_id),
      creator: object.creator,
      admin: object.admin,
      label: object.label,
      created: object !== null && object !== void 0 && object.created ? AbsoluteTxPosition.fromAmino(object.created) : undefined,
      ibcPortId: object.ibc_port_id,
      extension: object !== null && object !== void 0 && object.extension ? Cosmwasm_wasmv1ContractInfoExtension_FromAmino(object.extension) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.code_id = message.codeId ? message.codeId.toString() : undefined;
    obj.creator = message.creator;
    obj.admin = message.admin;
    obj.label = message.label;
    obj.created = message.created ? AbsoluteTxPosition.toAmino(message.created) : undefined;
    obj.ibc_port_id = message.ibcPortId;
    obj.extension = message.extension ? Cosmwasm_wasmv1ContractInfoExtension_ToAmino(message.extension) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return ContractInfo.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "wasm/ContractInfo",
      value: ContractInfo.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return ContractInfo.decode(message.value);
  },

  toProto(message) {
    return ContractInfo.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.ContractInfo",
      value: ContractInfo.encode(message).finish()
    };
  }

};

function createBaseContractCodeHistoryEntry() {
  return {
    operation: 0,
    codeId: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.UZERO */ .dK.UZERO,
    updated: undefined,
    msg: new Uint8Array()
  };
}

const ContractCodeHistoryEntry = {
  typeUrl: "/cosmwasm.wasm.v1.ContractCodeHistoryEntry",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (message.operation !== 0) {
      writer.uint32(8).int32(message.operation);
    }

    if (!message.codeId.isZero()) {
      writer.uint32(16).uint64(message.codeId);
    }

    if (message.updated !== undefined) {
      AbsoluteTxPosition.encode(message.updated, writer.uint32(26).fork()).ldelim();
    }

    if (message.msg.length !== 0) {
      writer.uint32(34).bytes(message.msg);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseContractCodeHistoryEntry();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.operation = reader.int32();
          break;

        case 2:
          message.codeId = reader.uint64();
          break;

        case 3:
          message.updated = AbsoluteTxPosition.decode(reader, reader.uint32());
          break;

        case 4:
          message.msg = reader.bytes();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$operation, _object$msg;

    const message = createBaseContractCodeHistoryEntry();
    message.operation = (_object$operation = object.operation) !== null && _object$operation !== void 0 ? _object$operation : 0;
    message.codeId = object.codeId !== undefined && object.codeId !== null ? _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromValue */ .dK.fromValue(object.codeId) : _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.UZERO */ .dK.UZERO;
    message.updated = object.updated !== undefined && object.updated !== null ? AbsoluteTxPosition.fromPartial(object.updated) : undefined;
    message.msg = (_object$msg = object.msg) !== null && _object$msg !== void 0 ? _object$msg : new Uint8Array();
    return message;
  },

  fromAmino(object) {
    return {
      operation: (0,_helpers__WEBPACK_IMPORTED_MODULE_1__/* .isSet */ .DM)(object.operation) ? contractCodeHistoryOperationTypeFromJSON(object.operation) : 0,
      codeId: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromString */ .dK.fromString(object.code_id),
      updated: object !== null && object !== void 0 && object.updated ? AbsoluteTxPosition.fromAmino(object.updated) : undefined,
      msg: (0,_cosmjs_encoding__WEBPACK_IMPORTED_MODULE_3__.toUtf8)(JSON.stringify(object.msg))
    };
  },

  toAmino(message) {
    const obj = {};
    obj.operation = message.operation;
    obj.code_id = message.codeId ? message.codeId.toString() : undefined;
    obj.updated = message.updated ? AbsoluteTxPosition.toAmino(message.updated) : undefined;
    obj.msg = message.msg ? JSON.parse((0,_cosmjs_encoding__WEBPACK_IMPORTED_MODULE_3__.fromUtf8)(message.msg)) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return ContractCodeHistoryEntry.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "wasm/ContractCodeHistoryEntry",
      value: ContractCodeHistoryEntry.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return ContractCodeHistoryEntry.decode(message.value);
  },

  toProto(message) {
    return ContractCodeHistoryEntry.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.ContractCodeHistoryEntry",
      value: ContractCodeHistoryEntry.encode(message).finish()
    };
  }

};

function createBaseAbsoluteTxPosition() {
  return {
    blockHeight: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.UZERO */ .dK.UZERO,
    txIndex: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.UZERO */ .dK.UZERO
  };
}

const AbsoluteTxPosition = {
  typeUrl: "/cosmwasm.wasm.v1.AbsoluteTxPosition",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (!message.blockHeight.isZero()) {
      writer.uint32(8).uint64(message.blockHeight);
    }

    if (!message.txIndex.isZero()) {
      writer.uint32(16).uint64(message.txIndex);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAbsoluteTxPosition();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.blockHeight = reader.uint64();
          break;

        case 2:
          message.txIndex = reader.uint64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseAbsoluteTxPosition();
    message.blockHeight = object.blockHeight !== undefined && object.blockHeight !== null ? _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromValue */ .dK.fromValue(object.blockHeight) : _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.UZERO */ .dK.UZERO;
    message.txIndex = object.txIndex !== undefined && object.txIndex !== null ? _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromValue */ .dK.fromValue(object.txIndex) : _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.UZERO */ .dK.UZERO;
    return message;
  },

  fromAmino(object) {
    return {
      blockHeight: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromString */ .dK.fromString(object.block_height),
      txIndex: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromString */ .dK.fromString(object.tx_index)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.block_height = message.blockHeight ? message.blockHeight.toString() : undefined;
    obj.tx_index = message.txIndex ? message.txIndex.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return AbsoluteTxPosition.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "wasm/AbsoluteTxPosition",
      value: AbsoluteTxPosition.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return AbsoluteTxPosition.decode(message.value);
  },

  toProto(message) {
    return AbsoluteTxPosition.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.AbsoluteTxPosition",
      value: AbsoluteTxPosition.encode(message).finish()
    };
  }

};

function createBaseModel() {
  return {
    key: new Uint8Array(),
    value: new Uint8Array()
  };
}

const Model = {
  typeUrl: "/cosmwasm.wasm.v1.Model",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (message.key.length !== 0) {
      writer.uint32(10).bytes(message.key);
    }

    if (message.value.length !== 0) {
      writer.uint32(18).bytes(message.value);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseModel();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.key = reader.bytes();
          break;

        case 2:
          message.value = reader.bytes();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$key, _object$value2;

    const message = createBaseModel();
    message.key = (_object$key = object.key) !== null && _object$key !== void 0 ? _object$key : new Uint8Array();
    message.value = (_object$value2 = object.value) !== null && _object$value2 !== void 0 ? _object$value2 : new Uint8Array();
    return message;
  },

  fromAmino(object) {
    return {
      key: object.key,
      value: object.value
    };
  },

  toAmino(message) {
    const obj = {};
    obj.key = message.key;
    obj.value = message.value;
    return obj;
  },

  fromAminoMsg(object) {
    return Model.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "wasm/Model",
      value: Model.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return Model.decode(message.value);
  },

  toProto(message) {
    return Model.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.Model",
      value: Model.encode(message).finish()
    };
  }

};
const Cosmwasm_wasmv1ContractInfoExtension_InterfaceDecoder = input => {
  const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
  const data = _google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__.Any.decode(reader, reader.uint32());

  switch (data.typeUrl) {
    default:
      return data;
  }
};
const Cosmwasm_wasmv1ContractInfoExtension_FromAmino = content => {
  return _google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__.Any.fromAmino(content);
};
const Cosmwasm_wasmv1ContractInfoExtension_ToAmino = content => {
  return _google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__.Any.toAmino(content);
};

/***/ }),

/***/ 32106:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Any": function() { return /* binding */ Any; }
/* harmony export */ });
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__);

/**
 * `Any` contains an arbitrary serialized protocol buffer message along with a
 * URL that describes the type of the serialized message.
 * 
 * Protobuf library provides support to pack/unpack Any values in the form
 * of utility functions or additional generated methods of the Any type.
 * 
 * Example 1: Pack and unpack a message in C++.
 * 
 *     Foo foo = ...;
 *     Any any;
 *     any.PackFrom(foo);
 *     ...
 *     if (any.UnpackTo(&foo)) {
 *       ...
 *     }
 * 
 * Example 2: Pack and unpack a message in Java.
 * 
 *     Foo foo = ...;
 *     Any any = Any.pack(foo);
 *     ...
 *     if (any.is(Foo.class)) {
 *       foo = any.unpack(Foo.class);
 *     }
 * 
 *  Example 3: Pack and unpack a message in Python.
 * 
 *     foo = Foo(...)
 *     any = Any()
 *     any.Pack(foo)
 *     ...
 *     if any.Is(Foo.DESCRIPTOR):
 *       any.Unpack(foo)
 *       ...
 * 
 *  Example 4: Pack and unpack a message in Go
 * 
 *      foo := &pb.Foo{...}
 *      any, err := ptypes.MarshalAny(foo)
 *      ...
 *      foo := &pb.Foo{}
 *      if err := ptypes.UnmarshalAny(any, foo); err != nil {
 *        ...
 *      }
 * 
 * The pack methods provided by protobuf library will by default use
 * 'type.googleapis.com/full.type.name' as the type URL and the unpack
 * methods only use the fully qualified type name after the last '/'
 * in the type URL, for example "foo.bar.com/x/y.z" will yield type
 * name "y.z".
 * 
 * 
 * JSON
 * ====
 * The JSON representation of an `Any` value uses the regular
 * representation of the deserialized, embedded message, with an
 * additional field `@type` which contains the type URL. Example:
 * 
 *     package google.profile;
 *     message Person {
 *       string first_name = 1;
 *       string last_name = 2;
 *     }
 * 
 *     {
 *       "@type": "type.googleapis.com/google.profile.Person",
 *       "firstName": <string>,
 *       "lastName": <string>
 *     }
 * 
 * If the embedded message type is well-known and has a custom JSON
 * representation, that representation will be embedded adding a field
 * `value` which holds the custom JSON in addition to the `@type`
 * field. Example (for message [google.protobuf.Duration][]):
 * 
 *     {
 *       "@type": "type.googleapis.com/google.protobuf.Duration",
 *       "value": "1.212s"
 *     }
 */

function createBaseAny() {
  return {
    $typeUrl: "/google.protobuf.Any",
    typeUrl: "",
    value: new Uint8Array()
  };
}

const Any = {
  typeUrl: "/google.protobuf.Any",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Writer.create()) {
    if (message.typeUrl !== "") {
      writer.uint32(10).string(message.typeUrl);
    }

    if (message.value.length !== 0) {
      writer.uint32(18).bytes(message.value);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAny();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.typeUrl = reader.string();
          break;

        case 2:
          message.value = reader.bytes();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$typeUrl, _object$value;

    const message = createBaseAny();
    message.typeUrl = (_object$typeUrl = object.typeUrl) !== null && _object$typeUrl !== void 0 ? _object$typeUrl : "";
    message.value = (_object$value = object.value) !== null && _object$value !== void 0 ? _object$value : new Uint8Array();
    return message;
  },

  fromAmino(object) {
    return {
      typeUrl: object.type_url,
      value: object.value
    };
  },

  toAmino(message) {
    const obj = {};
    obj.type_url = message.typeUrl;
    obj.value = message.value;
    return obj;
  },

  fromAminoMsg(object) {
    return Any.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return Any.decode(message.value);
  },

  toProto(message) {
    return Any.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/google.protobuf.Any",
      value: Any.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 6499:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Duration": function() { return /* binding */ Duration; }
/* harmony export */ });
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47895);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__);


/**
 * A Duration represents a signed, fixed-length span of time represented
 * as a count of seconds and fractions of seconds at nanosecond
 * resolution. It is independent of any calendar and concepts like "day"
 * or "month". It is related to Timestamp in that the difference between
 * two Timestamp values is a Duration and it can be added or subtracted
 * from a Timestamp. Range is approximately +-10,000 years.
 * 
 * # Examples
 * 
 * Example 1: Compute Duration from two Timestamps in pseudo code.
 * 
 *     Timestamp start = ...;
 *     Timestamp end = ...;
 *     Duration duration = ...;
 * 
 *     duration.seconds = end.seconds - start.seconds;
 *     duration.nanos = end.nanos - start.nanos;
 * 
 *     if (duration.seconds < 0 && duration.nanos > 0) {
 *       duration.seconds += 1;
 *       duration.nanos -= 1000000000;
 *     } else if (durations.seconds > 0 && duration.nanos < 0) {
 *       duration.seconds -= 1;
 *       duration.nanos += 1000000000;
 *     }
 * 
 * Example 2: Compute Timestamp from Timestamp + Duration in pseudo code.
 * 
 *     Timestamp start = ...;
 *     Duration duration = ...;
 *     Timestamp end = ...;
 * 
 *     end.seconds = start.seconds + duration.seconds;
 *     end.nanos = start.nanos + duration.nanos;
 * 
 *     if (end.nanos < 0) {
 *       end.seconds -= 1;
 *       end.nanos += 1000000000;
 *     } else if (end.nanos >= 1000000000) {
 *       end.seconds += 1;
 *       end.nanos -= 1000000000;
 *     }
 * 
 * Example 3: Compute Duration from datetime.timedelta in Python.
 * 
 *     td = datetime.timedelta(days=3, minutes=10)
 *     duration = Duration()
 *     duration.FromTimedelta(td)
 * 
 * # JSON Mapping
 * 
 * In JSON format, the Duration type is encoded as a string rather than an
 * object, where the string ends in the suffix "s" (indicating seconds) and
 * is preceded by the number of seconds, with nanoseconds expressed as
 * fractional seconds. For example, 3 seconds with 0 nanoseconds should be
 * encoded in JSON format as "3s", while 3 seconds and 1 nanosecond should
 * be expressed in JSON format as "3.000000001s", and 3 seconds and 1
 * microsecond should be expressed in JSON format as "3.000001s".
 */

function createBaseDuration() {
  return {
    seconds: _helpers__WEBPACK_IMPORTED_MODULE_0__/* .Long.ZERO */ .dK.ZERO,
    nanos: 0
  };
}

const Duration = {
  typeUrl: "/google.protobuf.Duration",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Writer.create()) {
    if (!message.seconds.isZero()) {
      writer.uint32(8).int64(message.seconds);
    }

    if (message.nanos !== 0) {
      writer.uint32(16).int32(message.nanos);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDuration();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.seconds = reader.int64();
          break;

        case 2:
          message.nanos = reader.int32();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$nanos;

    const message = createBaseDuration();
    message.seconds = object.seconds !== undefined && object.seconds !== null ? _helpers__WEBPACK_IMPORTED_MODULE_0__/* .Long.fromValue */ .dK.fromValue(object.seconds) : _helpers__WEBPACK_IMPORTED_MODULE_0__/* .Long.ZERO */ .dK.ZERO;
    message.nanos = (_object$nanos = object.nanos) !== null && _object$nanos !== void 0 ? _object$nanos : 0;
    return message;
  },

  fromAmino(object) {
    const value = parseInt(object);
    return {
      seconds: _helpers__WEBPACK_IMPORTED_MODULE_0__/* .Long.fromNumber */ .dK.fromNumber(Math.floor(value / 1000000000)),
      nanos: value % 1000000000
    };
  },

  toAmino(message) {
    return (message.seconds.toInt() * 1000000000 + message.nanos).toString();
  },

  fromAminoMsg(object) {
    return Duration.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return Duration.decode(message.value);
  },

  toProto(message) {
    return Duration.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/google.protobuf.Duration",
      value: Duration.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 20633:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Timestamp": function() { return /* binding */ Timestamp; }
/* harmony export */ });
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47895);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__);


/**
 * A Timestamp represents a point in time independent of any time zone or local
 * calendar, encoded as a count of seconds and fractions of seconds at
 * nanosecond resolution. The count is relative to an epoch at UTC midnight on
 * January 1, 1970, in the proleptic Gregorian calendar which extends the
 * Gregorian calendar backwards to year one.
 * 
 * All minutes are 60 seconds long. Leap seconds are "smeared" so that no leap
 * second table is needed for interpretation, using a [24-hour linear
 * smear](https://developers.google.com/time/smear).
 * 
 * The range is from 0001-01-01T00:00:00Z to 9999-12-31T23:59:59.999999999Z. By
 * restricting to that range, we ensure that we can convert to and from [RFC
 * 3339](https://www.ietf.org/rfc/rfc3339.txt) date strings.
 * 
 * # Examples
 * 
 * Example 1: Compute Timestamp from POSIX `time()`.
 * 
 *     Timestamp timestamp;
 *     timestamp.set_seconds(time(NULL));
 *     timestamp.set_nanos(0);
 * 
 * Example 2: Compute Timestamp from POSIX `gettimeofday()`.
 * 
 *     struct timeval tv;
 *     gettimeofday(&tv, NULL);
 * 
 *     Timestamp timestamp;
 *     timestamp.set_seconds(tv.tv_sec);
 *     timestamp.set_nanos(tv.tv_usec * 1000);
 * 
 * Example 3: Compute Timestamp from Win32 `GetSystemTimeAsFileTime()`.
 * 
 *     FILETIME ft;
 *     GetSystemTimeAsFileTime(&ft);
 *     UINT64 ticks = (((UINT64)ft.dwHighDateTime) << 32) | ft.dwLowDateTime;
 * 
 *     // A Windows tick is 100 nanoseconds. Windows epoch 1601-01-01T00:00:00Z
 *     // is 11644473600 seconds before Unix epoch 1970-01-01T00:00:00Z.
 *     Timestamp timestamp;
 *     timestamp.set_seconds((INT64) ((ticks / 10000000) - 11644473600LL));
 *     timestamp.set_nanos((INT32) ((ticks % 10000000) * 100));
 * 
 * Example 4: Compute Timestamp from Java `System.currentTimeMillis()`.
 * 
 *     long millis = System.currentTimeMillis();
 * 
 *     Timestamp timestamp = Timestamp.newBuilder().setSeconds(millis / 1000)
 *         .setNanos((int) ((millis % 1000) * 1000000)).build();
 * 
 * 
 * Example 5: Compute Timestamp from current time in Python.
 * 
 *     timestamp = Timestamp()
 *     timestamp.GetCurrentTime()
 * 
 * # JSON Mapping
 * 
 * In JSON format, the Timestamp type is encoded as a string in the
 * [RFC 3339](https://www.ietf.org/rfc/rfc3339.txt) format. That is, the
 * format is "{year}-{month}-{day}T{hour}:{min}:{sec}[.{frac_sec}]Z"
 * where {year} is always expressed using four digits while {month}, {day},
 * {hour}, {min}, and {sec} are zero-padded to two digits each. The fractional
 * seconds, which can go up to 9 digits (i.e. up to 1 nanosecond resolution),
 * are optional. The "Z" suffix indicates the timezone ("UTC"); the timezone
 * is required. A proto3 JSON serializer should always use UTC (as indicated by
 * "Z") when printing the Timestamp type and a proto3 JSON parser should be
 * able to accept both UTC and other timezones (as indicated by an offset).
 * 
 * For example, "2017-01-15T01:30:15.01Z" encodes 15.01 seconds past
 * 01:30 UTC on January 15, 2017.
 * 
 * In JavaScript, one can convert a Date object to this format using the
 * standard
 * [toISOString()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toISOString)
 * method. In Python, a standard `datetime.datetime` object can be converted
 * to this format using
 * [`strftime`](https://docs.python.org/2/library/time.html#time.strftime) with
 * the time format spec '%Y-%m-%dT%H:%M:%S.%fZ'. Likewise, in Java, one can use
 * the Joda Time's [`ISODateTimeFormat.dateTime()`](
 * http://www.joda.org/joda-time/apidocs/org/joda/time/format/ISODateTimeFormat.html#dateTime%2D%2D
 * ) to obtain a formatter capable of generating timestamps in this format.
 */

function createBaseTimestamp() {
  return {
    seconds: _helpers__WEBPACK_IMPORTED_MODULE_0__/* .Long.ZERO */ .dK.ZERO,
    nanos: 0
  };
}

const Timestamp = {
  typeUrl: "/google.protobuf.Timestamp",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Writer.create()) {
    if (!message.seconds.isZero()) {
      writer.uint32(8).int64(message.seconds);
    }

    if (message.nanos !== 0) {
      writer.uint32(16).int32(message.nanos);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTimestamp();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.seconds = reader.int64();
          break;

        case 2:
          message.nanos = reader.int32();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$nanos;

    const message = createBaseTimestamp();
    message.seconds = object.seconds !== undefined && object.seconds !== null ? _helpers__WEBPACK_IMPORTED_MODULE_0__/* .Long.fromValue */ .dK.fromValue(object.seconds) : _helpers__WEBPACK_IMPORTED_MODULE_0__/* .Long.ZERO */ .dK.ZERO;
    message.nanos = (_object$nanos = object.nanos) !== null && _object$nanos !== void 0 ? _object$nanos : 0;
    return message;
  },

  fromAmino(object) {
    return {
      seconds: _helpers__WEBPACK_IMPORTED_MODULE_0__/* .Long.fromString */ .dK.fromString(object.seconds),
      nanos: object.nanos
    };
  },

  toAmino(message) {
    const obj = {};
    obj.seconds = message.seconds ? message.seconds.toString() : undefined;
    obj.nanos = message.nanos;
    return obj;
  },

  fromAminoMsg(object) {
    return Timestamp.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return Timestamp.decode(message.value);
  },

  toProto(message) {
    return Timestamp.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/google.protobuf.Timestamp",
      value: Timestamp.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 47895:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DM": function() { return /* binding */ isSet; },
/* harmony export */   "Ol": function() { return /* binding */ fromTimestamp; },
/* harmony export */   "Uq": function() { return /* binding */ toTimestamp; },
/* harmony export */   "dK": function() { return /* reexport safe */ long__WEBPACK_IMPORTED_MODULE_1__.Z; },
/* harmony export */   "q6": function() { return /* binding */ setPaginationParams; }
/* harmony export */ });
/* unused harmony exports bytesFromBase64, base64FromBytes, omitDefault, toDuration, fromDuration, isObject, fromJsonTimestamp */
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var long__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72080);
/* provided dependency */ var Buffer = __webpack_require__(48764)["Buffer"];
/**
* This file and any referenced files were automatically generated by @osmonauts/telescope@0.90.0
* DO NOT MODIFY BY HAND. Instead, download the latest proto files for your chain
* and run the transpile command or yarn proto command to regenerate this bundle.
*/

 // @ts-ignore

if (protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.util.Long !== long__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z) {
  protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.util.Long = long__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z;

  protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.configure();
}



var globalThis = (() => {
  if (typeof globalThis !== 'undefined') return globalThis;
  if (typeof self !== 'undefined') return self;
  if (typeof window !== 'undefined') return window;
  if (typeof __webpack_require__.g !== 'undefined') return __webpack_require__.g;
  throw 'Unable to locate global object';
})();

const atob = globalThis.atob || (b64 => globalThis.Buffer.from(b64, 'base64').toString('binary'));

function bytesFromBase64(b64) {
  const bin = atob(b64);
  const arr = new Uint8Array(bin.length);

  for (let i = 0; i < bin.length; ++i) {
    arr[i] = bin.charCodeAt(i);
  }

  return arr;
}

const btoa = globalThis.btoa || (bin => globalThis.Buffer.from(bin, 'binary').toString('base64'));

function base64FromBytes(arr) {
  const bin = [];
  arr.forEach(byte => {
    bin.push(String.fromCharCode(byte));
  });
  return btoa(bin.join(''));
}
;
function omitDefault(input) {
  if (typeof input === "string") {
    return input === "" ? undefined : input;
  }

  if (typeof input === "number") {
    return input === 0 ? undefined : input;
  }

  if (Long.isLong(input)) {
    return input.isZero() ? undefined : input;
  }

  throw new Error(`Got unsupported type ${typeof input}`);
}
;
function toDuration(duration) {
  return {
    seconds: Long.fromNumber(Math.floor(parseInt(duration) / 1000000000)),
    nanos: parseInt(duration) % 1000000000
  };
}
;
function fromDuration(duration) {
  return (parseInt(duration.seconds.toString()) * 1000000000 + duration.nanos).toString();
}
;
function isSet(value) {
  return value !== null && value !== undefined;
}
;
function isObject(value) {
  return typeof value === 'object' && value !== null;
}
;
;
;
;
const setPaginationParams = (options, pagination) => {
  if (!pagination) {
    return options;
  }

  if (typeof (pagination === null || pagination === void 0 ? void 0 : pagination.countTotal) !== "undefined") {
    options.params['pagination.count_total'] = pagination.countTotal;
  }

  if (typeof (pagination === null || pagination === void 0 ? void 0 : pagination.key) !== "undefined") {
    // String to Uint8Array
    // let uint8arr = new Uint8Array(Buffer.from(data,'base64')); 
    // Uint8Array to String
    options.params['pagination.key'] = Buffer.from(pagination.key).toString('base64');
  }

  if (typeof (pagination === null || pagination === void 0 ? void 0 : pagination.limit) !== "undefined") {
    options.params["pagination.limit"] = pagination.limit.toString();
  }

  if (typeof (pagination === null || pagination === void 0 ? void 0 : pagination.offset) !== "undefined") {
    options.params["pagination.offset"] = pagination.offset.toString();
  }

  if (typeof (pagination === null || pagination === void 0 ? void 0 : pagination.reverse) !== "undefined") {
    options.params['pagination.reverse'] = pagination.reverse;
  }

  return options;
};
;
function toTimestamp(date) {
  const seconds = numberToLong(date.getTime() / 1000);
  const nanos = date.getTime() % 1000 * 1000000;
  return {
    seconds,
    nanos
  };
}
;
function fromTimestamp(t) {
  let millis = t.seconds.toNumber() * 1000;
  millis += t.nanos / 1000000;
  return new Date(millis);
}
;

const fromJSON = object => {
  return {
    seconds: isSet(object.seconds) ? Long.fromString(object.seconds) : Long.ZERO,
    nanos: isSet(object.nanos) ? Number(object.nanos) : 0
  };
};

const timestampFromJSON = object => {
  return {
    seconds: isSet(object.seconds) ? Long.fromValue(object.seconds) : Long.ZERO,
    nanos: isSet(object.nanos) ? Number(object.nanos) : 0
  };
};

function fromJsonTimestamp(o) {
  if (o instanceof Date) {
    return toTimestamp(o);
  } else if (typeof o === "string") {
    return toTimestamp(new Date(o));
  } else {
    return timestampFromJSON(o);
  }
}

function numberToLong(number) {
  return long__WEBPACK_IMPORTED_MODULE_1__/* ["default"].fromNumber */ .Z.fromNumber(number);
}

/***/ }),

/***/ 20989:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fee": function() { return /* binding */ Fee; },
/* harmony export */   "IdentifiedPacketFees": function() { return /* binding */ IdentifiedPacketFees; },
/* harmony export */   "PacketFee": function() { return /* binding */ PacketFee; },
/* harmony export */   "PacketFees": function() { return /* binding */ PacketFees; }
/* harmony export */ });
/* harmony import */ var _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26178);
/* harmony import */ var _core_channel_v1_channel__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53624);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__);



/** Fee defines the ICS29 receive, acknowledgement and timeout fees */

function createBaseFee() {
  return {
    recvFee: [],
    ackFee: [],
    timeoutFee: []
  };
}

const Fee = {
  typeUrl: "/ibc.applications.fee.v1.Fee",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    for (const v of message.recvFee) {
      _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.encode(v, writer.uint32(10).fork()).ldelim();
    }

    for (const v of message.ackFee) {
      _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.encode(v, writer.uint32(18).fork()).ldelim();
    }

    for (const v of message.timeoutFee) {
      _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.encode(v, writer.uint32(26).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFee();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.recvFee.push(_cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.decode(reader, reader.uint32()));
          break;

        case 2:
          message.ackFee.push(_cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.decode(reader, reader.uint32()));
          break;

        case 3:
          message.timeoutFee.push(_cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$recvFee, _object$ackFee, _object$timeoutFee;

    const message = createBaseFee();
    message.recvFee = ((_object$recvFee = object.recvFee) === null || _object$recvFee === void 0 ? void 0 : _object$recvFee.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.fromPartial(e))) || [];
    message.ackFee = ((_object$ackFee = object.ackFee) === null || _object$ackFee === void 0 ? void 0 : _object$ackFee.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.fromPartial(e))) || [];
    message.timeoutFee = ((_object$timeoutFee = object.timeoutFee) === null || _object$timeoutFee === void 0 ? void 0 : _object$timeoutFee.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      recvFee: Array.isArray(object === null || object === void 0 ? void 0 : object.recv_fee) ? object.recv_fee.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.fromAmino(e)) : [],
      ackFee: Array.isArray(object === null || object === void 0 ? void 0 : object.ack_fee) ? object.ack_fee.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.fromAmino(e)) : [],
      timeoutFee: Array.isArray(object === null || object === void 0 ? void 0 : object.timeout_fee) ? object.timeout_fee.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.recvFee) {
      obj.recv_fee = message.recvFee.map(e => e ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.toAmino(e) : undefined);
    } else {
      obj.recv_fee = [];
    }

    if (message.ackFee) {
      obj.ack_fee = message.ackFee.map(e => e ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.toAmino(e) : undefined);
    } else {
      obj.ack_fee = [];
    }

    if (message.timeoutFee) {
      obj.timeout_fee = message.timeoutFee.map(e => e ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.toAmino(e) : undefined);
    } else {
      obj.timeout_fee = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return Fee.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/Fee",
      value: Fee.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return Fee.decode(message.value);
  },

  toProto(message) {
    return Fee.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.applications.fee.v1.Fee",
      value: Fee.encode(message).finish()
    };
  }

};

function createBasePacketFee() {
  return {
    fee: undefined,
    refundAddress: "",
    relayers: []
  };
}

const PacketFee = {
  typeUrl: "/ibc.applications.fee.v1.PacketFee",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (message.fee !== undefined) {
      Fee.encode(message.fee, writer.uint32(10).fork()).ldelim();
    }

    if (message.refundAddress !== "") {
      writer.uint32(18).string(message.refundAddress);
    }

    for (const v of message.relayers) {
      writer.uint32(26).string(v);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePacketFee();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.fee = Fee.decode(reader, reader.uint32());
          break;

        case 2:
          message.refundAddress = reader.string();
          break;

        case 3:
          message.relayers.push(reader.string());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$refundAddress, _object$relayers;

    const message = createBasePacketFee();
    message.fee = object.fee !== undefined && object.fee !== null ? Fee.fromPartial(object.fee) : undefined;
    message.refundAddress = (_object$refundAddress = object.refundAddress) !== null && _object$refundAddress !== void 0 ? _object$refundAddress : "";
    message.relayers = ((_object$relayers = object.relayers) === null || _object$relayers === void 0 ? void 0 : _object$relayers.map(e => e)) || [];
    return message;
  },

  fromAmino(object) {
    return {
      fee: object !== null && object !== void 0 && object.fee ? Fee.fromAmino(object.fee) : undefined,
      refundAddress: object.refund_address,
      relayers: Array.isArray(object === null || object === void 0 ? void 0 : object.relayers) ? object.relayers.map(e => e) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.fee = message.fee ? Fee.toAmino(message.fee) : undefined;
    obj.refund_address = message.refundAddress;

    if (message.relayers) {
      obj.relayers = message.relayers.map(e => e);
    } else {
      obj.relayers = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return PacketFee.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/PacketFee",
      value: PacketFee.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return PacketFee.decode(message.value);
  },

  toProto(message) {
    return PacketFee.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.applications.fee.v1.PacketFee",
      value: PacketFee.encode(message).finish()
    };
  }

};

function createBasePacketFees() {
  return {
    packetFees: []
  };
}

const PacketFees = {
  typeUrl: "/ibc.applications.fee.v1.PacketFees",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    for (const v of message.packetFees) {
      PacketFee.encode(v, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePacketFees();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.packetFees.push(PacketFee.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$packetFees;

    const message = createBasePacketFees();
    message.packetFees = ((_object$packetFees = object.packetFees) === null || _object$packetFees === void 0 ? void 0 : _object$packetFees.map(e => PacketFee.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      packetFees: Array.isArray(object === null || object === void 0 ? void 0 : object.packet_fees) ? object.packet_fees.map(e => PacketFee.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.packetFees) {
      obj.packet_fees = message.packetFees.map(e => e ? PacketFee.toAmino(e) : undefined);
    } else {
      obj.packet_fees = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return PacketFees.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/PacketFees",
      value: PacketFees.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return PacketFees.decode(message.value);
  },

  toProto(message) {
    return PacketFees.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.applications.fee.v1.PacketFees",
      value: PacketFees.encode(message).finish()
    };
  }

};

function createBaseIdentifiedPacketFees() {
  return {
    packetId: undefined,
    packetFees: []
  };
}

const IdentifiedPacketFees = {
  typeUrl: "/ibc.applications.fee.v1.IdentifiedPacketFees",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (message.packetId !== undefined) {
      _core_channel_v1_channel__WEBPACK_IMPORTED_MODULE_1__.PacketId.encode(message.packetId, writer.uint32(10).fork()).ldelim();
    }

    for (const v of message.packetFees) {
      PacketFee.encode(v, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseIdentifiedPacketFees();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.packetId = _core_channel_v1_channel__WEBPACK_IMPORTED_MODULE_1__.PacketId.decode(reader, reader.uint32());
          break;

        case 2:
          message.packetFees.push(PacketFee.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$packetFees2;

    const message = createBaseIdentifiedPacketFees();
    message.packetId = object.packetId !== undefined && object.packetId !== null ? _core_channel_v1_channel__WEBPACK_IMPORTED_MODULE_1__.PacketId.fromPartial(object.packetId) : undefined;
    message.packetFees = ((_object$packetFees2 = object.packetFees) === null || _object$packetFees2 === void 0 ? void 0 : _object$packetFees2.map(e => PacketFee.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      packetId: object !== null && object !== void 0 && object.packet_id ? _core_channel_v1_channel__WEBPACK_IMPORTED_MODULE_1__.PacketId.fromAmino(object.packet_id) : undefined,
      packetFees: Array.isArray(object === null || object === void 0 ? void 0 : object.packet_fees) ? object.packet_fees.map(e => PacketFee.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.packet_id = message.packetId ? _core_channel_v1_channel__WEBPACK_IMPORTED_MODULE_1__.PacketId.toAmino(message.packetId) : undefined;

    if (message.packetFees) {
      obj.packet_fees = message.packetFees.map(e => e ? PacketFee.toAmino(e) : undefined);
    } else {
      obj.packet_fees = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return IdentifiedPacketFees.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/IdentifiedPacketFees",
      value: IdentifiedPacketFees.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return IdentifiedPacketFees.decode(message.value);
  },

  toProto(message) {
    return IdentifiedPacketFees.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.applications.fee.v1.IdentifiedPacketFees",
      value: IdentifiedPacketFees.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 16789:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FeeEnabledChannel": function() { return /* binding */ FeeEnabledChannel; },
/* harmony export */   "ForwardRelayerAddress": function() { return /* binding */ ForwardRelayerAddress; },
/* harmony export */   "GenesisState": function() { return /* binding */ GenesisState; },
/* harmony export */   "RegisteredCounterpartyPayee": function() { return /* binding */ RegisteredCounterpartyPayee; },
/* harmony export */   "RegisteredPayee": function() { return /* binding */ RegisteredPayee; }
/* harmony export */ });
/* harmony import */ var _fee__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20989);
/* harmony import */ var _core_channel_v1_channel__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53624);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__);



/** GenesisState defines the ICS29 fee middleware genesis state */

function createBaseGenesisState() {
  return {
    identifiedFees: [],
    feeEnabledChannels: [],
    registeredPayees: [],
    registeredCounterpartyPayees: [],
    forwardRelayers: []
  };
}

const GenesisState = {
  typeUrl: "/ibc.applications.fee.v1.GenesisState",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    for (const v of message.identifiedFees) {
      _fee__WEBPACK_IMPORTED_MODULE_0__.IdentifiedPacketFees.encode(v, writer.uint32(10).fork()).ldelim();
    }

    for (const v of message.feeEnabledChannels) {
      FeeEnabledChannel.encode(v, writer.uint32(18).fork()).ldelim();
    }

    for (const v of message.registeredPayees) {
      RegisteredPayee.encode(v, writer.uint32(26).fork()).ldelim();
    }

    for (const v of message.registeredCounterpartyPayees) {
      RegisteredCounterpartyPayee.encode(v, writer.uint32(34).fork()).ldelim();
    }

    for (const v of message.forwardRelayers) {
      ForwardRelayerAddress.encode(v, writer.uint32(42).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGenesisState();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.identifiedFees.push(_fee__WEBPACK_IMPORTED_MODULE_0__.IdentifiedPacketFees.decode(reader, reader.uint32()));
          break;

        case 2:
          message.feeEnabledChannels.push(FeeEnabledChannel.decode(reader, reader.uint32()));
          break;

        case 3:
          message.registeredPayees.push(RegisteredPayee.decode(reader, reader.uint32()));
          break;

        case 4:
          message.registeredCounterpartyPayees.push(RegisteredCounterpartyPayee.decode(reader, reader.uint32()));
          break;

        case 5:
          message.forwardRelayers.push(ForwardRelayerAddress.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$identifiedFee, _object$feeEnabledCha, _object$registeredPay, _object$registeredCou, _object$forwardRelaye;

    const message = createBaseGenesisState();
    message.identifiedFees = ((_object$identifiedFee = object.identifiedFees) === null || _object$identifiedFee === void 0 ? void 0 : _object$identifiedFee.map(e => _fee__WEBPACK_IMPORTED_MODULE_0__.IdentifiedPacketFees.fromPartial(e))) || [];
    message.feeEnabledChannels = ((_object$feeEnabledCha = object.feeEnabledChannels) === null || _object$feeEnabledCha === void 0 ? void 0 : _object$feeEnabledCha.map(e => FeeEnabledChannel.fromPartial(e))) || [];
    message.registeredPayees = ((_object$registeredPay = object.registeredPayees) === null || _object$registeredPay === void 0 ? void 0 : _object$registeredPay.map(e => RegisteredPayee.fromPartial(e))) || [];
    message.registeredCounterpartyPayees = ((_object$registeredCou = object.registeredCounterpartyPayees) === null || _object$registeredCou === void 0 ? void 0 : _object$registeredCou.map(e => RegisteredCounterpartyPayee.fromPartial(e))) || [];
    message.forwardRelayers = ((_object$forwardRelaye = object.forwardRelayers) === null || _object$forwardRelaye === void 0 ? void 0 : _object$forwardRelaye.map(e => ForwardRelayerAddress.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      identifiedFees: Array.isArray(object === null || object === void 0 ? void 0 : object.identified_fees) ? object.identified_fees.map(e => _fee__WEBPACK_IMPORTED_MODULE_0__.IdentifiedPacketFees.fromAmino(e)) : [],
      feeEnabledChannels: Array.isArray(object === null || object === void 0 ? void 0 : object.fee_enabled_channels) ? object.fee_enabled_channels.map(e => FeeEnabledChannel.fromAmino(e)) : [],
      registeredPayees: Array.isArray(object === null || object === void 0 ? void 0 : object.registered_payees) ? object.registered_payees.map(e => RegisteredPayee.fromAmino(e)) : [],
      registeredCounterpartyPayees: Array.isArray(object === null || object === void 0 ? void 0 : object.registered_counterparty_payees) ? object.registered_counterparty_payees.map(e => RegisteredCounterpartyPayee.fromAmino(e)) : [],
      forwardRelayers: Array.isArray(object === null || object === void 0 ? void 0 : object.forward_relayers) ? object.forward_relayers.map(e => ForwardRelayerAddress.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.identifiedFees) {
      obj.identified_fees = message.identifiedFees.map(e => e ? _fee__WEBPACK_IMPORTED_MODULE_0__.IdentifiedPacketFees.toAmino(e) : undefined);
    } else {
      obj.identified_fees = [];
    }

    if (message.feeEnabledChannels) {
      obj.fee_enabled_channels = message.feeEnabledChannels.map(e => e ? FeeEnabledChannel.toAmino(e) : undefined);
    } else {
      obj.fee_enabled_channels = [];
    }

    if (message.registeredPayees) {
      obj.registered_payees = message.registeredPayees.map(e => e ? RegisteredPayee.toAmino(e) : undefined);
    } else {
      obj.registered_payees = [];
    }

    if (message.registeredCounterpartyPayees) {
      obj.registered_counterparty_payees = message.registeredCounterpartyPayees.map(e => e ? RegisteredCounterpartyPayee.toAmino(e) : undefined);
    } else {
      obj.registered_counterparty_payees = [];
    }

    if (message.forwardRelayers) {
      obj.forward_relayers = message.forwardRelayers.map(e => e ? ForwardRelayerAddress.toAmino(e) : undefined);
    } else {
      obj.forward_relayers = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return GenesisState.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/GenesisState",
      value: GenesisState.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return GenesisState.decode(message.value);
  },

  toProto(message) {
    return GenesisState.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.applications.fee.v1.GenesisState",
      value: GenesisState.encode(message).finish()
    };
  }

};

function createBaseFeeEnabledChannel() {
  return {
    portId: "",
    channelId: ""
  };
}

const FeeEnabledChannel = {
  typeUrl: "/ibc.applications.fee.v1.FeeEnabledChannel",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (message.portId !== "") {
      writer.uint32(10).string(message.portId);
    }

    if (message.channelId !== "") {
      writer.uint32(18).string(message.channelId);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFeeEnabledChannel();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.portId = reader.string();
          break;

        case 2:
          message.channelId = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$portId, _object$channelId;

    const message = createBaseFeeEnabledChannel();
    message.portId = (_object$portId = object.portId) !== null && _object$portId !== void 0 ? _object$portId : "";
    message.channelId = (_object$channelId = object.channelId) !== null && _object$channelId !== void 0 ? _object$channelId : "";
    return message;
  },

  fromAmino(object) {
    return {
      portId: object.port_id,
      channelId: object.channel_id
    };
  },

  toAmino(message) {
    const obj = {};
    obj.port_id = message.portId;
    obj.channel_id = message.channelId;
    return obj;
  },

  fromAminoMsg(object) {
    return FeeEnabledChannel.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/FeeEnabledChannel",
      value: FeeEnabledChannel.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return FeeEnabledChannel.decode(message.value);
  },

  toProto(message) {
    return FeeEnabledChannel.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.applications.fee.v1.FeeEnabledChannel",
      value: FeeEnabledChannel.encode(message).finish()
    };
  }

};

function createBaseRegisteredPayee() {
  return {
    channelId: "",
    relayer: "",
    payee: ""
  };
}

const RegisteredPayee = {
  typeUrl: "/ibc.applications.fee.v1.RegisteredPayee",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (message.channelId !== "") {
      writer.uint32(10).string(message.channelId);
    }

    if (message.relayer !== "") {
      writer.uint32(18).string(message.relayer);
    }

    if (message.payee !== "") {
      writer.uint32(26).string(message.payee);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRegisteredPayee();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.channelId = reader.string();
          break;

        case 2:
          message.relayer = reader.string();
          break;

        case 3:
          message.payee = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$channelId2, _object$relayer, _object$payee;

    const message = createBaseRegisteredPayee();
    message.channelId = (_object$channelId2 = object.channelId) !== null && _object$channelId2 !== void 0 ? _object$channelId2 : "";
    message.relayer = (_object$relayer = object.relayer) !== null && _object$relayer !== void 0 ? _object$relayer : "";
    message.payee = (_object$payee = object.payee) !== null && _object$payee !== void 0 ? _object$payee : "";
    return message;
  },

  fromAmino(object) {
    return {
      channelId: object.channel_id,
      relayer: object.relayer,
      payee: object.payee
    };
  },

  toAmino(message) {
    const obj = {};
    obj.channel_id = message.channelId;
    obj.relayer = message.relayer;
    obj.payee = message.payee;
    return obj;
  },

  fromAminoMsg(object) {
    return RegisteredPayee.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/RegisteredPayee",
      value: RegisteredPayee.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return RegisteredPayee.decode(message.value);
  },

  toProto(message) {
    return RegisteredPayee.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.applications.fee.v1.RegisteredPayee",
      value: RegisteredPayee.encode(message).finish()
    };
  }

};

function createBaseRegisteredCounterpartyPayee() {
  return {
    channelId: "",
    relayer: "",
    counterpartyPayee: ""
  };
}

const RegisteredCounterpartyPayee = {
  typeUrl: "/ibc.applications.fee.v1.RegisteredCounterpartyPayee",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (message.channelId !== "") {
      writer.uint32(10).string(message.channelId);
    }

    if (message.relayer !== "") {
      writer.uint32(18).string(message.relayer);
    }

    if (message.counterpartyPayee !== "") {
      writer.uint32(26).string(message.counterpartyPayee);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRegisteredCounterpartyPayee();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.channelId = reader.string();
          break;

        case 2:
          message.relayer = reader.string();
          break;

        case 3:
          message.counterpartyPayee = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$channelId3, _object$relayer2, _object$counterpartyP;

    const message = createBaseRegisteredCounterpartyPayee();
    message.channelId = (_object$channelId3 = object.channelId) !== null && _object$channelId3 !== void 0 ? _object$channelId3 : "";
    message.relayer = (_object$relayer2 = object.relayer) !== null && _object$relayer2 !== void 0 ? _object$relayer2 : "";
    message.counterpartyPayee = (_object$counterpartyP = object.counterpartyPayee) !== null && _object$counterpartyP !== void 0 ? _object$counterpartyP : "";
    return message;
  },

  fromAmino(object) {
    return {
      channelId: object.channel_id,
      relayer: object.relayer,
      counterpartyPayee: object.counterparty_payee
    };
  },

  toAmino(message) {
    const obj = {};
    obj.channel_id = message.channelId;
    obj.relayer = message.relayer;
    obj.counterparty_payee = message.counterpartyPayee;
    return obj;
  },

  fromAminoMsg(object) {
    return RegisteredCounterpartyPayee.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/RegisteredCounterpartyPayee",
      value: RegisteredCounterpartyPayee.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return RegisteredCounterpartyPayee.decode(message.value);
  },

  toProto(message) {
    return RegisteredCounterpartyPayee.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.applications.fee.v1.RegisteredCounterpartyPayee",
      value: RegisteredCounterpartyPayee.encode(message).finish()
    };
  }

};

function createBaseForwardRelayerAddress() {
  return {
    address: "",
    packetId: undefined
  };
}

const ForwardRelayerAddress = {
  typeUrl: "/ibc.applications.fee.v1.ForwardRelayerAddress",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (message.address !== "") {
      writer.uint32(10).string(message.address);
    }

    if (message.packetId !== undefined) {
      _core_channel_v1_channel__WEBPACK_IMPORTED_MODULE_1__.PacketId.encode(message.packetId, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseForwardRelayerAddress();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.address = reader.string();
          break;

        case 2:
          message.packetId = _core_channel_v1_channel__WEBPACK_IMPORTED_MODULE_1__.PacketId.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$address;

    const message = createBaseForwardRelayerAddress();
    message.address = (_object$address = object.address) !== null && _object$address !== void 0 ? _object$address : "";
    message.packetId = object.packetId !== undefined && object.packetId !== null ? _core_channel_v1_channel__WEBPACK_IMPORTED_MODULE_1__.PacketId.fromPartial(object.packetId) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      address: object.address,
      packetId: object !== null && object !== void 0 && object.packet_id ? _core_channel_v1_channel__WEBPACK_IMPORTED_MODULE_1__.PacketId.fromAmino(object.packet_id) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.address = message.address;
    obj.packet_id = message.packetId ? _core_channel_v1_channel__WEBPACK_IMPORTED_MODULE_1__.PacketId.toAmino(message.packetId) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return ForwardRelayerAddress.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/ForwardRelayerAddress",
      value: ForwardRelayerAddress.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return ForwardRelayerAddress.decode(message.value);
  },

  toProto(message) {
    return ForwardRelayerAddress.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.applications.fee.v1.ForwardRelayerAddress",
      value: ForwardRelayerAddress.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 65705:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QueryCounterpartyPayeeRequest": function() { return /* binding */ QueryCounterpartyPayeeRequest; },
/* harmony export */   "QueryCounterpartyPayeeResponse": function() { return /* binding */ QueryCounterpartyPayeeResponse; },
/* harmony export */   "QueryFeeEnabledChannelRequest": function() { return /* binding */ QueryFeeEnabledChannelRequest; },
/* harmony export */   "QueryFeeEnabledChannelResponse": function() { return /* binding */ QueryFeeEnabledChannelResponse; },
/* harmony export */   "QueryFeeEnabledChannelsRequest": function() { return /* binding */ QueryFeeEnabledChannelsRequest; },
/* harmony export */   "QueryFeeEnabledChannelsResponse": function() { return /* binding */ QueryFeeEnabledChannelsResponse; },
/* harmony export */   "QueryIncentivizedPacketRequest": function() { return /* binding */ QueryIncentivizedPacketRequest; },
/* harmony export */   "QueryIncentivizedPacketResponse": function() { return /* binding */ QueryIncentivizedPacketResponse; },
/* harmony export */   "QueryIncentivizedPacketsForChannelRequest": function() { return /* binding */ QueryIncentivizedPacketsForChannelRequest; },
/* harmony export */   "QueryIncentivizedPacketsForChannelResponse": function() { return /* binding */ QueryIncentivizedPacketsForChannelResponse; },
/* harmony export */   "QueryIncentivizedPacketsRequest": function() { return /* binding */ QueryIncentivizedPacketsRequest; },
/* harmony export */   "QueryIncentivizedPacketsResponse": function() { return /* binding */ QueryIncentivizedPacketsResponse; },
/* harmony export */   "QueryPayeeRequest": function() { return /* binding */ QueryPayeeRequest; },
/* harmony export */   "QueryPayeeResponse": function() { return /* binding */ QueryPayeeResponse; },
/* harmony export */   "QueryTotalAckFeesRequest": function() { return /* binding */ QueryTotalAckFeesRequest; },
/* harmony export */   "QueryTotalAckFeesResponse": function() { return /* binding */ QueryTotalAckFeesResponse; },
/* harmony export */   "QueryTotalRecvFeesRequest": function() { return /* binding */ QueryTotalRecvFeesRequest; },
/* harmony export */   "QueryTotalRecvFeesResponse": function() { return /* binding */ QueryTotalRecvFeesResponse; },
/* harmony export */   "QueryTotalTimeoutFeesRequest": function() { return /* binding */ QueryTotalTimeoutFeesRequest; },
/* harmony export */   "QueryTotalTimeoutFeesResponse": function() { return /* binding */ QueryTotalTimeoutFeesResponse; }
/* harmony export */ });
/* harmony import */ var _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48978);
/* harmony import */ var _core_channel_v1_channel__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53624);
/* harmony import */ var _fee__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20989);
/* harmony import */ var _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26178);
/* harmony import */ var _genesis__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(16789);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47895);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__);







/** QueryIncentivizedPacketsRequest defines the request type for the IncentivizedPackets rpc */

function createBaseQueryIncentivizedPacketsRequest() {
  return {
    pagination: undefined,
    queryHeight: _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.UZERO */ .dK.UZERO
  };
}

const QueryIncentivizedPacketsRequest = {
  typeUrl: "/ibc.applications.fee.v1.QueryIncentivizedPacketsRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    if (message.pagination !== undefined) {
      _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
    }

    if (!message.queryHeight.isZero()) {
      writer.uint32(16).uint64(message.queryHeight);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryIncentivizedPacketsRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.pagination = _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.decode(reader, reader.uint32());
          break;

        case 2:
          message.queryHeight = reader.uint64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseQueryIncentivizedPacketsRequest();
    message.pagination = object.pagination !== undefined && object.pagination !== null ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.fromPartial(object.pagination) : undefined;
    message.queryHeight = object.queryHeight !== undefined && object.queryHeight !== null ? _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.fromValue */ .dK.fromValue(object.queryHeight) : _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.UZERO */ .dK.UZERO;
    return message;
  },

  fromAmino(object) {
    return {
      pagination: object !== null && object !== void 0 && object.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.fromAmino(object.pagination) : undefined,
      queryHeight: _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.fromString */ .dK.fromString(object.query_height)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.pagination = message.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.toAmino(message.pagination) : undefined;
    obj.query_height = message.queryHeight ? message.queryHeight.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryIncentivizedPacketsRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryIncentivizedPacketsRequest",
      value: QueryIncentivizedPacketsRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryIncentivizedPacketsRequest.decode(message.value);
  },

  toProto(message) {
    return QueryIncentivizedPacketsRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.applications.fee.v1.QueryIncentivizedPacketsRequest",
      value: QueryIncentivizedPacketsRequest.encode(message).finish()
    };
  }

};

function createBaseQueryIncentivizedPacketsResponse() {
  return {
    incentivizedPackets: [],
    pagination: undefined
  };
}

const QueryIncentivizedPacketsResponse = {
  typeUrl: "/ibc.applications.fee.v1.QueryIncentivizedPacketsResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    for (const v of message.incentivizedPackets) {
      _fee__WEBPACK_IMPORTED_MODULE_2__.IdentifiedPacketFees.encode(v, writer.uint32(10).fork()).ldelim();
    }

    if (message.pagination !== undefined) {
      _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryIncentivizedPacketsResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.incentivizedPackets.push(_fee__WEBPACK_IMPORTED_MODULE_2__.IdentifiedPacketFees.decode(reader, reader.uint32()));
          break;

        case 2:
          message.pagination = _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$incentivizedP;

    const message = createBaseQueryIncentivizedPacketsResponse();
    message.incentivizedPackets = ((_object$incentivizedP = object.incentivizedPackets) === null || _object$incentivizedP === void 0 ? void 0 : _object$incentivizedP.map(e => _fee__WEBPACK_IMPORTED_MODULE_2__.IdentifiedPacketFees.fromPartial(e))) || [];
    message.pagination = object.pagination !== undefined && object.pagination !== null ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.fromPartial(object.pagination) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      incentivizedPackets: Array.isArray(object === null || object === void 0 ? void 0 : object.incentivized_packets) ? object.incentivized_packets.map(e => _fee__WEBPACK_IMPORTED_MODULE_2__.IdentifiedPacketFees.fromAmino(e)) : [],
      pagination: object !== null && object !== void 0 && object.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.fromAmino(object.pagination) : undefined
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.incentivizedPackets) {
      obj.incentivized_packets = message.incentivizedPackets.map(e => e ? _fee__WEBPACK_IMPORTED_MODULE_2__.IdentifiedPacketFees.toAmino(e) : undefined);
    } else {
      obj.incentivized_packets = [];
    }

    obj.pagination = message.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.toAmino(message.pagination) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryIncentivizedPacketsResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryIncentivizedPacketsResponse",
      value: QueryIncentivizedPacketsResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryIncentivizedPacketsResponse.decode(message.value);
  },

  toProto(message) {
    return QueryIncentivizedPacketsResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.applications.fee.v1.QueryIncentivizedPacketsResponse",
      value: QueryIncentivizedPacketsResponse.encode(message).finish()
    };
  }

};

function createBaseQueryIncentivizedPacketRequest() {
  return {
    packetId: undefined,
    queryHeight: _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.UZERO */ .dK.UZERO
  };
}

const QueryIncentivizedPacketRequest = {
  typeUrl: "/ibc.applications.fee.v1.QueryIncentivizedPacketRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    if (message.packetId !== undefined) {
      _core_channel_v1_channel__WEBPACK_IMPORTED_MODULE_1__.PacketId.encode(message.packetId, writer.uint32(10).fork()).ldelim();
    }

    if (!message.queryHeight.isZero()) {
      writer.uint32(16).uint64(message.queryHeight);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryIncentivizedPacketRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.packetId = _core_channel_v1_channel__WEBPACK_IMPORTED_MODULE_1__.PacketId.decode(reader, reader.uint32());
          break;

        case 2:
          message.queryHeight = reader.uint64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseQueryIncentivizedPacketRequest();
    message.packetId = object.packetId !== undefined && object.packetId !== null ? _core_channel_v1_channel__WEBPACK_IMPORTED_MODULE_1__.PacketId.fromPartial(object.packetId) : undefined;
    message.queryHeight = object.queryHeight !== undefined && object.queryHeight !== null ? _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.fromValue */ .dK.fromValue(object.queryHeight) : _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.UZERO */ .dK.UZERO;
    return message;
  },

  fromAmino(object) {
    return {
      packetId: object !== null && object !== void 0 && object.packet_id ? _core_channel_v1_channel__WEBPACK_IMPORTED_MODULE_1__.PacketId.fromAmino(object.packet_id) : undefined,
      queryHeight: _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.fromString */ .dK.fromString(object.query_height)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.packet_id = message.packetId ? _core_channel_v1_channel__WEBPACK_IMPORTED_MODULE_1__.PacketId.toAmino(message.packetId) : undefined;
    obj.query_height = message.queryHeight ? message.queryHeight.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryIncentivizedPacketRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryIncentivizedPacketRequest",
      value: QueryIncentivizedPacketRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryIncentivizedPacketRequest.decode(message.value);
  },

  toProto(message) {
    return QueryIncentivizedPacketRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.applications.fee.v1.QueryIncentivizedPacketRequest",
      value: QueryIncentivizedPacketRequest.encode(message).finish()
    };
  }

};

function createBaseQueryIncentivizedPacketResponse() {
  return {
    incentivizedPacket: undefined
  };
}

const QueryIncentivizedPacketResponse = {
  typeUrl: "/ibc.applications.fee.v1.QueryIncentivizedPacketResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    if (message.incentivizedPacket !== undefined) {
      _fee__WEBPACK_IMPORTED_MODULE_2__.IdentifiedPacketFees.encode(message.incentivizedPacket, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryIncentivizedPacketResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.incentivizedPacket = _fee__WEBPACK_IMPORTED_MODULE_2__.IdentifiedPacketFees.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseQueryIncentivizedPacketResponse();
    message.incentivizedPacket = object.incentivizedPacket !== undefined && object.incentivizedPacket !== null ? _fee__WEBPACK_IMPORTED_MODULE_2__.IdentifiedPacketFees.fromPartial(object.incentivizedPacket) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      incentivizedPacket: object !== null && object !== void 0 && object.incentivized_packet ? _fee__WEBPACK_IMPORTED_MODULE_2__.IdentifiedPacketFees.fromAmino(object.incentivized_packet) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.incentivized_packet = message.incentivizedPacket ? _fee__WEBPACK_IMPORTED_MODULE_2__.IdentifiedPacketFees.toAmino(message.incentivizedPacket) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryIncentivizedPacketResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryIncentivizedPacketResponse",
      value: QueryIncentivizedPacketResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryIncentivizedPacketResponse.decode(message.value);
  },

  toProto(message) {
    return QueryIncentivizedPacketResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.applications.fee.v1.QueryIncentivizedPacketResponse",
      value: QueryIncentivizedPacketResponse.encode(message).finish()
    };
  }

};

function createBaseQueryIncentivizedPacketsForChannelRequest() {
  return {
    pagination: undefined,
    portId: "",
    channelId: "",
    queryHeight: _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.UZERO */ .dK.UZERO
  };
}

const QueryIncentivizedPacketsForChannelRequest = {
  typeUrl: "/ibc.applications.fee.v1.QueryIncentivizedPacketsForChannelRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    if (message.pagination !== undefined) {
      _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
    }

    if (message.portId !== "") {
      writer.uint32(18).string(message.portId);
    }

    if (message.channelId !== "") {
      writer.uint32(26).string(message.channelId);
    }

    if (!message.queryHeight.isZero()) {
      writer.uint32(32).uint64(message.queryHeight);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryIncentivizedPacketsForChannelRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.pagination = _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.decode(reader, reader.uint32());
          break;

        case 2:
          message.portId = reader.string();
          break;

        case 3:
          message.channelId = reader.string();
          break;

        case 4:
          message.queryHeight = reader.uint64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$portId, _object$channelId;

    const message = createBaseQueryIncentivizedPacketsForChannelRequest();
    message.pagination = object.pagination !== undefined && object.pagination !== null ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.fromPartial(object.pagination) : undefined;
    message.portId = (_object$portId = object.portId) !== null && _object$portId !== void 0 ? _object$portId : "";
    message.channelId = (_object$channelId = object.channelId) !== null && _object$channelId !== void 0 ? _object$channelId : "";
    message.queryHeight = object.queryHeight !== undefined && object.queryHeight !== null ? _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.fromValue */ .dK.fromValue(object.queryHeight) : _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.UZERO */ .dK.UZERO;
    return message;
  },

  fromAmino(object) {
    return {
      pagination: object !== null && object !== void 0 && object.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.fromAmino(object.pagination) : undefined,
      portId: object.port_id,
      channelId: object.channel_id,
      queryHeight: _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.fromString */ .dK.fromString(object.query_height)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.pagination = message.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.toAmino(message.pagination) : undefined;
    obj.port_id = message.portId;
    obj.channel_id = message.channelId;
    obj.query_height = message.queryHeight ? message.queryHeight.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryIncentivizedPacketsForChannelRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryIncentivizedPacketsForChannelRequest",
      value: QueryIncentivizedPacketsForChannelRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryIncentivizedPacketsForChannelRequest.decode(message.value);
  },

  toProto(message) {
    return QueryIncentivizedPacketsForChannelRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.applications.fee.v1.QueryIncentivizedPacketsForChannelRequest",
      value: QueryIncentivizedPacketsForChannelRequest.encode(message).finish()
    };
  }

};

function createBaseQueryIncentivizedPacketsForChannelResponse() {
  return {
    incentivizedPackets: [],
    pagination: undefined
  };
}

const QueryIncentivizedPacketsForChannelResponse = {
  typeUrl: "/ibc.applications.fee.v1.QueryIncentivizedPacketsForChannelResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    for (const v of message.incentivizedPackets) {
      _fee__WEBPACK_IMPORTED_MODULE_2__.IdentifiedPacketFees.encode(v, writer.uint32(10).fork()).ldelim();
    }

    if (message.pagination !== undefined) {
      _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryIncentivizedPacketsForChannelResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.incentivizedPackets.push(_fee__WEBPACK_IMPORTED_MODULE_2__.IdentifiedPacketFees.decode(reader, reader.uint32()));
          break;

        case 2:
          message.pagination = _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$incentivizedP2;

    const message = createBaseQueryIncentivizedPacketsForChannelResponse();
    message.incentivizedPackets = ((_object$incentivizedP2 = object.incentivizedPackets) === null || _object$incentivizedP2 === void 0 ? void 0 : _object$incentivizedP2.map(e => _fee__WEBPACK_IMPORTED_MODULE_2__.IdentifiedPacketFees.fromPartial(e))) || [];
    message.pagination = object.pagination !== undefined && object.pagination !== null ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.fromPartial(object.pagination) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      incentivizedPackets: Array.isArray(object === null || object === void 0 ? void 0 : object.incentivized_packets) ? object.incentivized_packets.map(e => _fee__WEBPACK_IMPORTED_MODULE_2__.IdentifiedPacketFees.fromAmino(e)) : [],
      pagination: object !== null && object !== void 0 && object.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.fromAmino(object.pagination) : undefined
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.incentivizedPackets) {
      obj.incentivized_packets = message.incentivizedPackets.map(e => e ? _fee__WEBPACK_IMPORTED_MODULE_2__.IdentifiedPacketFees.toAmino(e) : undefined);
    } else {
      obj.incentivized_packets = [];
    }

    obj.pagination = message.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.toAmino(message.pagination) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryIncentivizedPacketsForChannelResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryIncentivizedPacketsForChannelResponse",
      value: QueryIncentivizedPacketsForChannelResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryIncentivizedPacketsForChannelResponse.decode(message.value);
  },

  toProto(message) {
    return QueryIncentivizedPacketsForChannelResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.applications.fee.v1.QueryIncentivizedPacketsForChannelResponse",
      value: QueryIncentivizedPacketsForChannelResponse.encode(message).finish()
    };
  }

};

function createBaseQueryTotalRecvFeesRequest() {
  return {
    packetId: undefined
  };
}

const QueryTotalRecvFeesRequest = {
  typeUrl: "/ibc.applications.fee.v1.QueryTotalRecvFeesRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    if (message.packetId !== undefined) {
      _core_channel_v1_channel__WEBPACK_IMPORTED_MODULE_1__.PacketId.encode(message.packetId, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryTotalRecvFeesRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.packetId = _core_channel_v1_channel__WEBPACK_IMPORTED_MODULE_1__.PacketId.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseQueryTotalRecvFeesRequest();
    message.packetId = object.packetId !== undefined && object.packetId !== null ? _core_channel_v1_channel__WEBPACK_IMPORTED_MODULE_1__.PacketId.fromPartial(object.packetId) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      packetId: object !== null && object !== void 0 && object.packet_id ? _core_channel_v1_channel__WEBPACK_IMPORTED_MODULE_1__.PacketId.fromAmino(object.packet_id) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.packet_id = message.packetId ? _core_channel_v1_channel__WEBPACK_IMPORTED_MODULE_1__.PacketId.toAmino(message.packetId) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryTotalRecvFeesRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryTotalRecvFeesRequest",
      value: QueryTotalRecvFeesRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryTotalRecvFeesRequest.decode(message.value);
  },

  toProto(message) {
    return QueryTotalRecvFeesRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.applications.fee.v1.QueryTotalRecvFeesRequest",
      value: QueryTotalRecvFeesRequest.encode(message).finish()
    };
  }

};

function createBaseQueryTotalRecvFeesResponse() {
  return {
    recvFees: []
  };
}

const QueryTotalRecvFeesResponse = {
  typeUrl: "/ibc.applications.fee.v1.QueryTotalRecvFeesResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    for (const v of message.recvFees) {
      _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_3__.Coin.encode(v, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryTotalRecvFeesResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.recvFees.push(_cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_3__.Coin.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$recvFees;

    const message = createBaseQueryTotalRecvFeesResponse();
    message.recvFees = ((_object$recvFees = object.recvFees) === null || _object$recvFees === void 0 ? void 0 : _object$recvFees.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_3__.Coin.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      recvFees: Array.isArray(object === null || object === void 0 ? void 0 : object.recv_fees) ? object.recv_fees.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_3__.Coin.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.recvFees) {
      obj.recv_fees = message.recvFees.map(e => e ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_3__.Coin.toAmino(e) : undefined);
    } else {
      obj.recv_fees = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return QueryTotalRecvFeesResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryTotalRecvFeesResponse",
      value: QueryTotalRecvFeesResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryTotalRecvFeesResponse.decode(message.value);
  },

  toProto(message) {
    return QueryTotalRecvFeesResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.applications.fee.v1.QueryTotalRecvFeesResponse",
      value: QueryTotalRecvFeesResponse.encode(message).finish()
    };
  }

};

function createBaseQueryTotalAckFeesRequest() {
  return {
    packetId: undefined
  };
}

const QueryTotalAckFeesRequest = {
  typeUrl: "/ibc.applications.fee.v1.QueryTotalAckFeesRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    if (message.packetId !== undefined) {
      _core_channel_v1_channel__WEBPACK_IMPORTED_MODULE_1__.PacketId.encode(message.packetId, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryTotalAckFeesRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.packetId = _core_channel_v1_channel__WEBPACK_IMPORTED_MODULE_1__.PacketId.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseQueryTotalAckFeesRequest();
    message.packetId = object.packetId !== undefined && object.packetId !== null ? _core_channel_v1_channel__WEBPACK_IMPORTED_MODULE_1__.PacketId.fromPartial(object.packetId) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      packetId: object !== null && object !== void 0 && object.packet_id ? _core_channel_v1_channel__WEBPACK_IMPORTED_MODULE_1__.PacketId.fromAmino(object.packet_id) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.packet_id = message.packetId ? _core_channel_v1_channel__WEBPACK_IMPORTED_MODULE_1__.PacketId.toAmino(message.packetId) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryTotalAckFeesRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryTotalAckFeesRequest",
      value: QueryTotalAckFeesRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryTotalAckFeesRequest.decode(message.value);
  },

  toProto(message) {
    return QueryTotalAckFeesRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.applications.fee.v1.QueryTotalAckFeesRequest",
      value: QueryTotalAckFeesRequest.encode(message).finish()
    };
  }

};

function createBaseQueryTotalAckFeesResponse() {
  return {
    ackFees: []
  };
}

const QueryTotalAckFeesResponse = {
  typeUrl: "/ibc.applications.fee.v1.QueryTotalAckFeesResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    for (const v of message.ackFees) {
      _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_3__.Coin.encode(v, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryTotalAckFeesResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.ackFees.push(_cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_3__.Coin.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$ackFees;

    const message = createBaseQueryTotalAckFeesResponse();
    message.ackFees = ((_object$ackFees = object.ackFees) === null || _object$ackFees === void 0 ? void 0 : _object$ackFees.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_3__.Coin.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      ackFees: Array.isArray(object === null || object === void 0 ? void 0 : object.ack_fees) ? object.ack_fees.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_3__.Coin.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.ackFees) {
      obj.ack_fees = message.ackFees.map(e => e ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_3__.Coin.toAmino(e) : undefined);
    } else {
      obj.ack_fees = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return QueryTotalAckFeesResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryTotalAckFeesResponse",
      value: QueryTotalAckFeesResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryTotalAckFeesResponse.decode(message.value);
  },

  toProto(message) {
    return QueryTotalAckFeesResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.applications.fee.v1.QueryTotalAckFeesResponse",
      value: QueryTotalAckFeesResponse.encode(message).finish()
    };
  }

};

function createBaseQueryTotalTimeoutFeesRequest() {
  return {
    packetId: undefined
  };
}

const QueryTotalTimeoutFeesRequest = {
  typeUrl: "/ibc.applications.fee.v1.QueryTotalTimeoutFeesRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    if (message.packetId !== undefined) {
      _core_channel_v1_channel__WEBPACK_IMPORTED_MODULE_1__.PacketId.encode(message.packetId, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryTotalTimeoutFeesRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.packetId = _core_channel_v1_channel__WEBPACK_IMPORTED_MODULE_1__.PacketId.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseQueryTotalTimeoutFeesRequest();
    message.packetId = object.packetId !== undefined && object.packetId !== null ? _core_channel_v1_channel__WEBPACK_IMPORTED_MODULE_1__.PacketId.fromPartial(object.packetId) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      packetId: object !== null && object !== void 0 && object.packet_id ? _core_channel_v1_channel__WEBPACK_IMPORTED_MODULE_1__.PacketId.fromAmino(object.packet_id) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.packet_id = message.packetId ? _core_channel_v1_channel__WEBPACK_IMPORTED_MODULE_1__.PacketId.toAmino(message.packetId) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryTotalTimeoutFeesRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryTotalTimeoutFeesRequest",
      value: QueryTotalTimeoutFeesRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryTotalTimeoutFeesRequest.decode(message.value);
  },

  toProto(message) {
    return QueryTotalTimeoutFeesRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.applications.fee.v1.QueryTotalTimeoutFeesRequest",
      value: QueryTotalTimeoutFeesRequest.encode(message).finish()
    };
  }

};

function createBaseQueryTotalTimeoutFeesResponse() {
  return {
    timeoutFees: []
  };
}

const QueryTotalTimeoutFeesResponse = {
  typeUrl: "/ibc.applications.fee.v1.QueryTotalTimeoutFeesResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    for (const v of message.timeoutFees) {
      _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_3__.Coin.encode(v, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryTotalTimeoutFeesResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.timeoutFees.push(_cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_3__.Coin.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$timeoutFees;

    const message = createBaseQueryTotalTimeoutFeesResponse();
    message.timeoutFees = ((_object$timeoutFees = object.timeoutFees) === null || _object$timeoutFees === void 0 ? void 0 : _object$timeoutFees.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_3__.Coin.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      timeoutFees: Array.isArray(object === null || object === void 0 ? void 0 : object.timeout_fees) ? object.timeout_fees.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_3__.Coin.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.timeoutFees) {
      obj.timeout_fees = message.timeoutFees.map(e => e ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_3__.Coin.toAmino(e) : undefined);
    } else {
      obj.timeout_fees = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return QueryTotalTimeoutFeesResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryTotalTimeoutFeesResponse",
      value: QueryTotalTimeoutFeesResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryTotalTimeoutFeesResponse.decode(message.value);
  },

  toProto(message) {
    return QueryTotalTimeoutFeesResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.applications.fee.v1.QueryTotalTimeoutFeesResponse",
      value: QueryTotalTimeoutFeesResponse.encode(message).finish()
    };
  }

};

function createBaseQueryPayeeRequest() {
  return {
    channelId: "",
    relayer: ""
  };
}

const QueryPayeeRequest = {
  typeUrl: "/ibc.applications.fee.v1.QueryPayeeRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    if (message.channelId !== "") {
      writer.uint32(10).string(message.channelId);
    }

    if (message.relayer !== "") {
      writer.uint32(18).string(message.relayer);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryPayeeRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.channelId = reader.string();
          break;

        case 2:
          message.relayer = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$channelId2, _object$relayer;

    const message = createBaseQueryPayeeRequest();
    message.channelId = (_object$channelId2 = object.channelId) !== null && _object$channelId2 !== void 0 ? _object$channelId2 : "";
    message.relayer = (_object$relayer = object.relayer) !== null && _object$relayer !== void 0 ? _object$relayer : "";
    return message;
  },

  fromAmino(object) {
    return {
      channelId: object.channel_id,
      relayer: object.relayer
    };
  },

  toAmino(message) {
    const obj = {};
    obj.channel_id = message.channelId;
    obj.relayer = message.relayer;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryPayeeRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryPayeeRequest",
      value: QueryPayeeRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryPayeeRequest.decode(message.value);
  },

  toProto(message) {
    return QueryPayeeRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.applications.fee.v1.QueryPayeeRequest",
      value: QueryPayeeRequest.encode(message).finish()
    };
  }

};

function createBaseQueryPayeeResponse() {
  return {
    payeeAddress: ""
  };
}

const QueryPayeeResponse = {
  typeUrl: "/ibc.applications.fee.v1.QueryPayeeResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    if (message.payeeAddress !== "") {
      writer.uint32(10).string(message.payeeAddress);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryPayeeResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.payeeAddress = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$payeeAddress;

    const message = createBaseQueryPayeeResponse();
    message.payeeAddress = (_object$payeeAddress = object.payeeAddress) !== null && _object$payeeAddress !== void 0 ? _object$payeeAddress : "";
    return message;
  },

  fromAmino(object) {
    return {
      payeeAddress: object.payee_address
    };
  },

  toAmino(message) {
    const obj = {};
    obj.payee_address = message.payeeAddress;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryPayeeResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryPayeeResponse",
      value: QueryPayeeResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryPayeeResponse.decode(message.value);
  },

  toProto(message) {
    return QueryPayeeResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.applications.fee.v1.QueryPayeeResponse",
      value: QueryPayeeResponse.encode(message).finish()
    };
  }

};

function createBaseQueryCounterpartyPayeeRequest() {
  return {
    channelId: "",
    relayer: ""
  };
}

const QueryCounterpartyPayeeRequest = {
  typeUrl: "/ibc.applications.fee.v1.QueryCounterpartyPayeeRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    if (message.channelId !== "") {
      writer.uint32(10).string(message.channelId);
    }

    if (message.relayer !== "") {
      writer.uint32(18).string(message.relayer);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryCounterpartyPayeeRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.channelId = reader.string();
          break;

        case 2:
          message.relayer = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$channelId3, _object$relayer2;

    const message = createBaseQueryCounterpartyPayeeRequest();
    message.channelId = (_object$channelId3 = object.channelId) !== null && _object$channelId3 !== void 0 ? _object$channelId3 : "";
    message.relayer = (_object$relayer2 = object.relayer) !== null && _object$relayer2 !== void 0 ? _object$relayer2 : "";
    return message;
  },

  fromAmino(object) {
    return {
      channelId: object.channel_id,
      relayer: object.relayer
    };
  },

  toAmino(message) {
    const obj = {};
    obj.channel_id = message.channelId;
    obj.relayer = message.relayer;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryCounterpartyPayeeRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryCounterpartyPayeeRequest",
      value: QueryCounterpartyPayeeRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryCounterpartyPayeeRequest.decode(message.value);
  },

  toProto(message) {
    return QueryCounterpartyPayeeRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.applications.fee.v1.QueryCounterpartyPayeeRequest",
      value: QueryCounterpartyPayeeRequest.encode(message).finish()
    };
  }

};

function createBaseQueryCounterpartyPayeeResponse() {
  return {
    counterpartyPayee: ""
  };
}

const QueryCounterpartyPayeeResponse = {
  typeUrl: "/ibc.applications.fee.v1.QueryCounterpartyPayeeResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    if (message.counterpartyPayee !== "") {
      writer.uint32(10).string(message.counterpartyPayee);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryCounterpartyPayeeResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.counterpartyPayee = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$counterpartyP;

    const message = createBaseQueryCounterpartyPayeeResponse();
    message.counterpartyPayee = (_object$counterpartyP = object.counterpartyPayee) !== null && _object$counterpartyP !== void 0 ? _object$counterpartyP : "";
    return message;
  },

  fromAmino(object) {
    return {
      counterpartyPayee: object.counterparty_payee
    };
  },

  toAmino(message) {
    const obj = {};
    obj.counterparty_payee = message.counterpartyPayee;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryCounterpartyPayeeResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryCounterpartyPayeeResponse",
      value: QueryCounterpartyPayeeResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryCounterpartyPayeeResponse.decode(message.value);
  },

  toProto(message) {
    return QueryCounterpartyPayeeResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.applications.fee.v1.QueryCounterpartyPayeeResponse",
      value: QueryCounterpartyPayeeResponse.encode(message).finish()
    };
  }

};

function createBaseQueryFeeEnabledChannelsRequest() {
  return {
    pagination: undefined,
    queryHeight: _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.UZERO */ .dK.UZERO
  };
}

const QueryFeeEnabledChannelsRequest = {
  typeUrl: "/ibc.applications.fee.v1.QueryFeeEnabledChannelsRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    if (message.pagination !== undefined) {
      _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
    }

    if (!message.queryHeight.isZero()) {
      writer.uint32(16).uint64(message.queryHeight);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryFeeEnabledChannelsRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.pagination = _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.decode(reader, reader.uint32());
          break;

        case 2:
          message.queryHeight = reader.uint64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseQueryFeeEnabledChannelsRequest();
    message.pagination = object.pagination !== undefined && object.pagination !== null ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.fromPartial(object.pagination) : undefined;
    message.queryHeight = object.queryHeight !== undefined && object.queryHeight !== null ? _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.fromValue */ .dK.fromValue(object.queryHeight) : _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.UZERO */ .dK.UZERO;
    return message;
  },

  fromAmino(object) {
    return {
      pagination: object !== null && object !== void 0 && object.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.fromAmino(object.pagination) : undefined,
      queryHeight: _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.fromString */ .dK.fromString(object.query_height)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.pagination = message.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.toAmino(message.pagination) : undefined;
    obj.query_height = message.queryHeight ? message.queryHeight.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryFeeEnabledChannelsRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryFeeEnabledChannelsRequest",
      value: QueryFeeEnabledChannelsRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryFeeEnabledChannelsRequest.decode(message.value);
  },

  toProto(message) {
    return QueryFeeEnabledChannelsRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.applications.fee.v1.QueryFeeEnabledChannelsRequest",
      value: QueryFeeEnabledChannelsRequest.encode(message).finish()
    };
  }

};

function createBaseQueryFeeEnabledChannelsResponse() {
  return {
    feeEnabledChannels: [],
    pagination: undefined
  };
}

const QueryFeeEnabledChannelsResponse = {
  typeUrl: "/ibc.applications.fee.v1.QueryFeeEnabledChannelsResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    for (const v of message.feeEnabledChannels) {
      _genesis__WEBPACK_IMPORTED_MODULE_4__.FeeEnabledChannel.encode(v, writer.uint32(10).fork()).ldelim();
    }

    if (message.pagination !== undefined) {
      _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryFeeEnabledChannelsResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.feeEnabledChannels.push(_genesis__WEBPACK_IMPORTED_MODULE_4__.FeeEnabledChannel.decode(reader, reader.uint32()));
          break;

        case 2:
          message.pagination = _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$feeEnabledCha;

    const message = createBaseQueryFeeEnabledChannelsResponse();
    message.feeEnabledChannels = ((_object$feeEnabledCha = object.feeEnabledChannels) === null || _object$feeEnabledCha === void 0 ? void 0 : _object$feeEnabledCha.map(e => _genesis__WEBPACK_IMPORTED_MODULE_4__.FeeEnabledChannel.fromPartial(e))) || [];
    message.pagination = object.pagination !== undefined && object.pagination !== null ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.fromPartial(object.pagination) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      feeEnabledChannels: Array.isArray(object === null || object === void 0 ? void 0 : object.fee_enabled_channels) ? object.fee_enabled_channels.map(e => _genesis__WEBPACK_IMPORTED_MODULE_4__.FeeEnabledChannel.fromAmino(e)) : [],
      pagination: object !== null && object !== void 0 && object.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.fromAmino(object.pagination) : undefined
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.feeEnabledChannels) {
      obj.fee_enabled_channels = message.feeEnabledChannels.map(e => e ? _genesis__WEBPACK_IMPORTED_MODULE_4__.FeeEnabledChannel.toAmino(e) : undefined);
    } else {
      obj.fee_enabled_channels = [];
    }

    obj.pagination = message.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.toAmino(message.pagination) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryFeeEnabledChannelsResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryFeeEnabledChannelsResponse",
      value: QueryFeeEnabledChannelsResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryFeeEnabledChannelsResponse.decode(message.value);
  },

  toProto(message) {
    return QueryFeeEnabledChannelsResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.applications.fee.v1.QueryFeeEnabledChannelsResponse",
      value: QueryFeeEnabledChannelsResponse.encode(message).finish()
    };
  }

};

function createBaseQueryFeeEnabledChannelRequest() {
  return {
    portId: "",
    channelId: ""
  };
}

const QueryFeeEnabledChannelRequest = {
  typeUrl: "/ibc.applications.fee.v1.QueryFeeEnabledChannelRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    if (message.portId !== "") {
      writer.uint32(10).string(message.portId);
    }

    if (message.channelId !== "") {
      writer.uint32(18).string(message.channelId);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryFeeEnabledChannelRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.portId = reader.string();
          break;

        case 2:
          message.channelId = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$portId2, _object$channelId4;

    const message = createBaseQueryFeeEnabledChannelRequest();
    message.portId = (_object$portId2 = object.portId) !== null && _object$portId2 !== void 0 ? _object$portId2 : "";
    message.channelId = (_object$channelId4 = object.channelId) !== null && _object$channelId4 !== void 0 ? _object$channelId4 : "";
    return message;
  },

  fromAmino(object) {
    return {
      portId: object.port_id,
      channelId: object.channel_id
    };
  },

  toAmino(message) {
    const obj = {};
    obj.port_id = message.portId;
    obj.channel_id = message.channelId;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryFeeEnabledChannelRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryFeeEnabledChannelRequest",
      value: QueryFeeEnabledChannelRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryFeeEnabledChannelRequest.decode(message.value);
  },

  toProto(message) {
    return QueryFeeEnabledChannelRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.applications.fee.v1.QueryFeeEnabledChannelRequest",
      value: QueryFeeEnabledChannelRequest.encode(message).finish()
    };
  }

};

function createBaseQueryFeeEnabledChannelResponse() {
  return {
    feeEnabled: false
  };
}

const QueryFeeEnabledChannelResponse = {
  typeUrl: "/ibc.applications.fee.v1.QueryFeeEnabledChannelResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    if (message.feeEnabled === true) {
      writer.uint32(8).bool(message.feeEnabled);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryFeeEnabledChannelResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.feeEnabled = reader.bool();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$feeEnabled;

    const message = createBaseQueryFeeEnabledChannelResponse();
    message.feeEnabled = (_object$feeEnabled = object.feeEnabled) !== null && _object$feeEnabled !== void 0 ? _object$feeEnabled : false;
    return message;
  },

  fromAmino(object) {
    return {
      feeEnabled: object.fee_enabled
    };
  },

  toAmino(message) {
    const obj = {};
    obj.fee_enabled = message.feeEnabled;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryFeeEnabledChannelResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryFeeEnabledChannelResponse",
      value: QueryFeeEnabledChannelResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryFeeEnabledChannelResponse.decode(message.value);
  },

  toProto(message) {
    return QueryFeeEnabledChannelResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.applications.fee.v1.QueryFeeEnabledChannelResponse",
      value: QueryFeeEnabledChannelResponse.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 79903:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LCDQueryClient": function() { return /* binding */ LCDQueryClient; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4942);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47895);


class LCDQueryClient {
  constructor({
    requestClient
  }) {
    (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, "req", void 0);

    this.req = requestClient;
    this.incentivizedPackets = this.incentivizedPackets.bind(this);
    this.incentivizedPacket = this.incentivizedPacket.bind(this);
    this.incentivizedPacketsForChannel = this.incentivizedPacketsForChannel.bind(this);
    this.totalRecvFees = this.totalRecvFees.bind(this);
    this.totalAckFees = this.totalAckFees.bind(this);
    this.totalTimeoutFees = this.totalTimeoutFees.bind(this);
    this.payee = this.payee.bind(this);
    this.counterpartyPayee = this.counterpartyPayee.bind(this);
    this.feeEnabledChannels = this.feeEnabledChannels.bind(this);
    this.feeEnabledChannel = this.feeEnabledChannel.bind(this);
  }
  /* IncentivizedPackets returns all incentivized packets and their associated fees */


  async incentivizedPackets(params) {
    const options = {
      params: {}
    };

    if (typeof (params === null || params === void 0 ? void 0 : params.pagination) !== "undefined") {
      (0,_helpers__WEBPACK_IMPORTED_MODULE_0__/* .setPaginationParams */ .q6)(options, params.pagination);
    }

    if (typeof (params === null || params === void 0 ? void 0 : params.queryHeight) !== "undefined") {
      options.params.query_height = params.queryHeight;
    }

    const endpoint = `ibc/apps/fee/v1/incentivized_packets`;
    return await this.req.get(endpoint, options);
  }
  /* IncentivizedPacket returns all packet fees for a packet given its identifier */


  async incentivizedPacket(params) {
    const options = {
      params: {}
    };

    if (typeof (params === null || params === void 0 ? void 0 : params.packetId) !== "undefined") {
      options.params.packet_id = params.packetId;
    }

    if (typeof (params === null || params === void 0 ? void 0 : params.queryHeight) !== "undefined") {
      options.params.query_height = params.queryHeight;
    }

    const endpoint = `ibc/apps/fee/v1/channels/${params.packetId.channel_id}/ports/${params.packetId.port_id}/sequences/${params.packetId.sequence}/incentivized_packet`;
    return await this.req.get(endpoint, options);
  }
  /* Gets all incentivized packets for a specific channel */


  async incentivizedPacketsForChannel(params) {
    const options = {
      params: {}
    };

    if (typeof (params === null || params === void 0 ? void 0 : params.pagination) !== "undefined") {
      (0,_helpers__WEBPACK_IMPORTED_MODULE_0__/* .setPaginationParams */ .q6)(options, params.pagination);
    }

    if (typeof (params === null || params === void 0 ? void 0 : params.queryHeight) !== "undefined") {
      options.params.query_height = params.queryHeight;
    }

    const endpoint = `ibc/apps/fee/v1/channels/${params.channelId}/ports/${params.portId}/incentivized_packets`;
    return await this.req.get(endpoint, options);
  }
  /* TotalRecvFees returns the total receive fees for a packet given its identifier */


  async totalRecvFees(params) {
    const options = {
      params: {}
    };

    if (typeof (params === null || params === void 0 ? void 0 : params.packetId) !== "undefined") {
      options.params.packet_id = params.packetId;
    }

    const endpoint = `ibc/apps/fee/v1/channels/${params.packetId.channel_id}/ports/${params.packetId.port_id}/sequences/${params.packetId.sequence}/total_recv_fees`;
    return await this.req.get(endpoint, options);
  }
  /* TotalAckFees returns the total acknowledgement fees for a packet given its identifier */


  async totalAckFees(params) {
    const options = {
      params: {}
    };

    if (typeof (params === null || params === void 0 ? void 0 : params.packetId) !== "undefined") {
      options.params.packet_id = params.packetId;
    }

    const endpoint = `ibc/apps/fee/v1/channels/${params.packetId.channel_id}/ports/${params.packetId.port_id}/sequences/${params.packetId.sequence}/total_ack_fees`;
    return await this.req.get(endpoint, options);
  }
  /* TotalTimeoutFees returns the total timeout fees for a packet given its identifier */


  async totalTimeoutFees(params) {
    const options = {
      params: {}
    };

    if (typeof (params === null || params === void 0 ? void 0 : params.packetId) !== "undefined") {
      options.params.packet_id = params.packetId;
    }

    const endpoint = `ibc/apps/fee/v1/channels/${params.packetId.channel_id}/ports/${params.packetId.port_id}/sequences/${params.packetId.sequence}/total_timeout_fees`;
    return await this.req.get(endpoint, options);
  }
  /* Payee returns the registered payee address for a specific channel given the relayer address */


  async payee(params) {
    const endpoint = `ibc/apps/fee/v1/channels/${params.channelId}/relayers/${params.relayer}/payee`;
    return await this.req.get(endpoint);
  }
  /* CounterpartyPayee returns the registered counterparty payee for forward relaying */


  async counterpartyPayee(params) {
    const endpoint = `ibc/apps/fee/v1/channels/${params.channelId}/relayers/${params.relayer}/counterparty_payee`;
    return await this.req.get(endpoint);
  }
  /* FeeEnabledChannels returns a list of all fee enabled channels */


  async feeEnabledChannels(params) {
    const options = {
      params: {}
    };

    if (typeof (params === null || params === void 0 ? void 0 : params.pagination) !== "undefined") {
      (0,_helpers__WEBPACK_IMPORTED_MODULE_0__/* .setPaginationParams */ .q6)(options, params.pagination);
    }

    if (typeof (params === null || params === void 0 ? void 0 : params.queryHeight) !== "undefined") {
      options.params.query_height = params.queryHeight;
    }

    const endpoint = `ibc/apps/fee/v1/fee_enabled`;
    return await this.req.get(endpoint, options);
  }
  /* FeeEnabledChannel returns true if the provided port and channel identifiers belong to a fee enabled channel */


  async feeEnabledChannel(params) {
    const endpoint = `ibc/apps/fee/v1/channels/${params.channelId}/ports/${params.portId}/fee_enabled`;
    return await this.req.get(endpoint);
  }

}

/***/ }),

/***/ 87300:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QueryClientImpl": function() { return /* binding */ QueryClientImpl; },
/* harmony export */   "createRpcQueryExtension": function() { return /* binding */ createRpcQueryExtension; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4942);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78441);
/* harmony import */ var _cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65705);




/** Query defines the ICS29 gRPC querier service. */

class QueryClientImpl {
  constructor(rpc) {
    (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, "rpc", void 0);

    this.rpc = rpc;
    this.incentivizedPackets = this.incentivizedPackets.bind(this);
    this.incentivizedPacket = this.incentivizedPacket.bind(this);
    this.incentivizedPacketsForChannel = this.incentivizedPacketsForChannel.bind(this);
    this.totalRecvFees = this.totalRecvFees.bind(this);
    this.totalAckFees = this.totalAckFees.bind(this);
    this.totalTimeoutFees = this.totalTimeoutFees.bind(this);
    this.payee = this.payee.bind(this);
    this.counterpartyPayee = this.counterpartyPayee.bind(this);
    this.feeEnabledChannels = this.feeEnabledChannels.bind(this);
    this.feeEnabledChannel = this.feeEnabledChannel.bind(this);
  }

  incentivizedPackets(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryIncentivizedPacketsRequest.encode(request).finish();
    const promise = this.rpc.request("ibc.applications.fee.v1.Query", "IncentivizedPackets", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryIncentivizedPacketsResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  incentivizedPacket(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryIncentivizedPacketRequest.encode(request).finish();
    const promise = this.rpc.request("ibc.applications.fee.v1.Query", "IncentivizedPacket", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryIncentivizedPacketResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  incentivizedPacketsForChannel(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryIncentivizedPacketsForChannelRequest.encode(request).finish();
    const promise = this.rpc.request("ibc.applications.fee.v1.Query", "IncentivizedPacketsForChannel", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryIncentivizedPacketsForChannelResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  totalRecvFees(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryTotalRecvFeesRequest.encode(request).finish();
    const promise = this.rpc.request("ibc.applications.fee.v1.Query", "TotalRecvFees", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryTotalRecvFeesResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  totalAckFees(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryTotalAckFeesRequest.encode(request).finish();
    const promise = this.rpc.request("ibc.applications.fee.v1.Query", "TotalAckFees", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryTotalAckFeesResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  totalTimeoutFees(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryTotalTimeoutFeesRequest.encode(request).finish();
    const promise = this.rpc.request("ibc.applications.fee.v1.Query", "TotalTimeoutFees", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryTotalTimeoutFeesResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  payee(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryPayeeRequest.encode(request).finish();
    const promise = this.rpc.request("ibc.applications.fee.v1.Query", "Payee", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryPayeeResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  counterpartyPayee(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryCounterpartyPayeeRequest.encode(request).finish();
    const promise = this.rpc.request("ibc.applications.fee.v1.Query", "CounterpartyPayee", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryCounterpartyPayeeResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  feeEnabledChannels(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryFeeEnabledChannelsRequest.encode(request).finish();
    const promise = this.rpc.request("ibc.applications.fee.v1.Query", "FeeEnabledChannels", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryFeeEnabledChannelsResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  feeEnabledChannel(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryFeeEnabledChannelRequest.encode(request).finish();
    const promise = this.rpc.request("ibc.applications.fee.v1.Query", "FeeEnabledChannel", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryFeeEnabledChannelResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

}
const createRpcQueryExtension = base => {
  const rpc = (0,_cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1__.createProtobufRpcClient)(base);
  const queryService = new QueryClientImpl(rpc);
  return {
    incentivizedPackets(request) {
      return queryService.incentivizedPackets(request);
    },

    incentivizedPacket(request) {
      return queryService.incentivizedPacket(request);
    },

    incentivizedPacketsForChannel(request) {
      return queryService.incentivizedPacketsForChannel(request);
    },

    totalRecvFees(request) {
      return queryService.totalRecvFees(request);
    },

    totalAckFees(request) {
      return queryService.totalAckFees(request);
    },

    totalTimeoutFees(request) {
      return queryService.totalTimeoutFees(request);
    },

    payee(request) {
      return queryService.payee(request);
    },

    counterpartyPayee(request) {
      return queryService.counterpartyPayee(request);
    },

    feeEnabledChannels(request) {
      return queryService.feeEnabledChannels(request);
    },

    feeEnabledChannel(request) {
      return queryService.feeEnabledChannel(request);
    }

  };
};

/***/ }),

/***/ 43930:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MsgPayPacketFee": function() { return /* binding */ MsgPayPacketFee; },
/* harmony export */   "MsgPayPacketFeeAsync": function() { return /* binding */ MsgPayPacketFeeAsync; },
/* harmony export */   "MsgPayPacketFeeAsyncResponse": function() { return /* binding */ MsgPayPacketFeeAsyncResponse; },
/* harmony export */   "MsgPayPacketFeeResponse": function() { return /* binding */ MsgPayPacketFeeResponse; },
/* harmony export */   "MsgRegisterCounterpartyPayee": function() { return /* binding */ MsgRegisterCounterpartyPayee; },
/* harmony export */   "MsgRegisterCounterpartyPayeeResponse": function() { return /* binding */ MsgRegisterCounterpartyPayeeResponse; },
/* harmony export */   "MsgRegisterPayee": function() { return /* binding */ MsgRegisterPayee; },
/* harmony export */   "MsgRegisterPayeeResponse": function() { return /* binding */ MsgRegisterPayeeResponse; }
/* harmony export */ });
/* harmony import */ var _fee__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20989);
/* harmony import */ var _core_channel_v1_channel__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53624);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__);



/** MsgRegisterPayee defines the request type for the RegisterPayee rpc */

function createBaseMsgRegisterPayee() {
  return {
    portId: "",
    channelId: "",
    relayer: "",
    payee: ""
  };
}

const MsgRegisterPayee = {
  typeUrl: "/ibc.applications.fee.v1.MsgRegisterPayee",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (message.portId !== "") {
      writer.uint32(10).string(message.portId);
    }

    if (message.channelId !== "") {
      writer.uint32(18).string(message.channelId);
    }

    if (message.relayer !== "") {
      writer.uint32(26).string(message.relayer);
    }

    if (message.payee !== "") {
      writer.uint32(34).string(message.payee);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgRegisterPayee();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.portId = reader.string();
          break;

        case 2:
          message.channelId = reader.string();
          break;

        case 3:
          message.relayer = reader.string();
          break;

        case 4:
          message.payee = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$portId, _object$channelId, _object$relayer, _object$payee;

    const message = createBaseMsgRegisterPayee();
    message.portId = (_object$portId = object.portId) !== null && _object$portId !== void 0 ? _object$portId : "";
    message.channelId = (_object$channelId = object.channelId) !== null && _object$channelId !== void 0 ? _object$channelId : "";
    message.relayer = (_object$relayer = object.relayer) !== null && _object$relayer !== void 0 ? _object$relayer : "";
    message.payee = (_object$payee = object.payee) !== null && _object$payee !== void 0 ? _object$payee : "";
    return message;
  },

  fromAmino(object) {
    return {
      portId: object.port_id,
      channelId: object.channel_id,
      relayer: object.relayer,
      payee: object.payee
    };
  },

  toAmino(message) {
    const obj = {};
    obj.port_id = message.portId;
    obj.channel_id = message.channelId;
    obj.relayer = message.relayer;
    obj.payee = message.payee;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgRegisterPayee.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/MsgRegisterPayee",
      value: MsgRegisterPayee.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgRegisterPayee.decode(message.value);
  },

  toProto(message) {
    return MsgRegisterPayee.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.applications.fee.v1.MsgRegisterPayee",
      value: MsgRegisterPayee.encode(message).finish()
    };
  }

};

function createBaseMsgRegisterPayeeResponse() {
  return {};
}

const MsgRegisterPayeeResponse = {
  typeUrl: "/ibc.applications.fee.v1.MsgRegisterPayeeResponse",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgRegisterPayeeResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseMsgRegisterPayeeResponse();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return MsgRegisterPayeeResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/MsgRegisterPayeeResponse",
      value: MsgRegisterPayeeResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgRegisterPayeeResponse.decode(message.value);
  },

  toProto(message) {
    return MsgRegisterPayeeResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.applications.fee.v1.MsgRegisterPayeeResponse",
      value: MsgRegisterPayeeResponse.encode(message).finish()
    };
  }

};

function createBaseMsgRegisterCounterpartyPayee() {
  return {
    portId: "",
    channelId: "",
    relayer: "",
    counterpartyPayee: ""
  };
}

const MsgRegisterCounterpartyPayee = {
  typeUrl: "/ibc.applications.fee.v1.MsgRegisterCounterpartyPayee",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (message.portId !== "") {
      writer.uint32(10).string(message.portId);
    }

    if (message.channelId !== "") {
      writer.uint32(18).string(message.channelId);
    }

    if (message.relayer !== "") {
      writer.uint32(26).string(message.relayer);
    }

    if (message.counterpartyPayee !== "") {
      writer.uint32(34).string(message.counterpartyPayee);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgRegisterCounterpartyPayee();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.portId = reader.string();
          break;

        case 2:
          message.channelId = reader.string();
          break;

        case 3:
          message.relayer = reader.string();
          break;

        case 4:
          message.counterpartyPayee = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$portId2, _object$channelId2, _object$relayer2, _object$counterpartyP;

    const message = createBaseMsgRegisterCounterpartyPayee();
    message.portId = (_object$portId2 = object.portId) !== null && _object$portId2 !== void 0 ? _object$portId2 : "";
    message.channelId = (_object$channelId2 = object.channelId) !== null && _object$channelId2 !== void 0 ? _object$channelId2 : "";
    message.relayer = (_object$relayer2 = object.relayer) !== null && _object$relayer2 !== void 0 ? _object$relayer2 : "";
    message.counterpartyPayee = (_object$counterpartyP = object.counterpartyPayee) !== null && _object$counterpartyP !== void 0 ? _object$counterpartyP : "";
    return message;
  },

  fromAmino(object) {
    return {
      portId: object.port_id,
      channelId: object.channel_id,
      relayer: object.relayer,
      counterpartyPayee: object.counterparty_payee
    };
  },

  toAmino(message) {
    const obj = {};
    obj.port_id = message.portId;
    obj.channel_id = message.channelId;
    obj.relayer = message.relayer;
    obj.counterparty_payee = message.counterpartyPayee;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgRegisterCounterpartyPayee.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/MsgRegisterCounterpartyPayee",
      value: MsgRegisterCounterpartyPayee.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgRegisterCounterpartyPayee.decode(message.value);
  },

  toProto(message) {
    return MsgRegisterCounterpartyPayee.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.applications.fee.v1.MsgRegisterCounterpartyPayee",
      value: MsgRegisterCounterpartyPayee.encode(message).finish()
    };
  }

};

function createBaseMsgRegisterCounterpartyPayeeResponse() {
  return {};
}

const MsgRegisterCounterpartyPayeeResponse = {
  typeUrl: "/ibc.applications.fee.v1.MsgRegisterCounterpartyPayeeResponse",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgRegisterCounterpartyPayeeResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseMsgRegisterCounterpartyPayeeResponse();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return MsgRegisterCounterpartyPayeeResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/MsgRegisterCounterpartyPayeeResponse",
      value: MsgRegisterCounterpartyPayeeResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgRegisterCounterpartyPayeeResponse.decode(message.value);
  },

  toProto(message) {
    return MsgRegisterCounterpartyPayeeResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.applications.fee.v1.MsgRegisterCounterpartyPayeeResponse",
      value: MsgRegisterCounterpartyPayeeResponse.encode(message).finish()
    };
  }

};

function createBaseMsgPayPacketFee() {
  return {
    fee: undefined,
    sourcePortId: "",
    sourceChannelId: "",
    signer: "",
    relayers: []
  };
}

const MsgPayPacketFee = {
  typeUrl: "/ibc.applications.fee.v1.MsgPayPacketFee",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (message.fee !== undefined) {
      _fee__WEBPACK_IMPORTED_MODULE_0__.Fee.encode(message.fee, writer.uint32(10).fork()).ldelim();
    }

    if (message.sourcePortId !== "") {
      writer.uint32(18).string(message.sourcePortId);
    }

    if (message.sourceChannelId !== "") {
      writer.uint32(26).string(message.sourceChannelId);
    }

    if (message.signer !== "") {
      writer.uint32(34).string(message.signer);
    }

    for (const v of message.relayers) {
      writer.uint32(42).string(v);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgPayPacketFee();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.fee = _fee__WEBPACK_IMPORTED_MODULE_0__.Fee.decode(reader, reader.uint32());
          break;

        case 2:
          message.sourcePortId = reader.string();
          break;

        case 3:
          message.sourceChannelId = reader.string();
          break;

        case 4:
          message.signer = reader.string();
          break;

        case 5:
          message.relayers.push(reader.string());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$sourcePortId, _object$sourceChannel, _object$signer, _object$relayers;

    const message = createBaseMsgPayPacketFee();
    message.fee = object.fee !== undefined && object.fee !== null ? _fee__WEBPACK_IMPORTED_MODULE_0__.Fee.fromPartial(object.fee) : undefined;
    message.sourcePortId = (_object$sourcePortId = object.sourcePortId) !== null && _object$sourcePortId !== void 0 ? _object$sourcePortId : "";
    message.sourceChannelId = (_object$sourceChannel = object.sourceChannelId) !== null && _object$sourceChannel !== void 0 ? _object$sourceChannel : "";
    message.signer = (_object$signer = object.signer) !== null && _object$signer !== void 0 ? _object$signer : "";
    message.relayers = ((_object$relayers = object.relayers) === null || _object$relayers === void 0 ? void 0 : _object$relayers.map(e => e)) || [];
    return message;
  },

  fromAmino(object) {
    return {
      fee: object !== null && object !== void 0 && object.fee ? _fee__WEBPACK_IMPORTED_MODULE_0__.Fee.fromAmino(object.fee) : undefined,
      sourcePortId: object.source_port_id,
      sourceChannelId: object.source_channel_id,
      signer: object.signer,
      relayers: Array.isArray(object === null || object === void 0 ? void 0 : object.relayers) ? object.relayers.map(e => e) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.fee = message.fee ? _fee__WEBPACK_IMPORTED_MODULE_0__.Fee.toAmino(message.fee) : undefined;
    obj.source_port_id = message.sourcePortId;
    obj.source_channel_id = message.sourceChannelId;
    obj.signer = message.signer;

    if (message.relayers) {
      obj.relayers = message.relayers.map(e => e);
    } else {
      obj.relayers = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return MsgPayPacketFee.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/MsgPayPacketFee",
      value: MsgPayPacketFee.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgPayPacketFee.decode(message.value);
  },

  toProto(message) {
    return MsgPayPacketFee.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.applications.fee.v1.MsgPayPacketFee",
      value: MsgPayPacketFee.encode(message).finish()
    };
  }

};

function createBaseMsgPayPacketFeeResponse() {
  return {};
}

const MsgPayPacketFeeResponse = {
  typeUrl: "/ibc.applications.fee.v1.MsgPayPacketFeeResponse",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgPayPacketFeeResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseMsgPayPacketFeeResponse();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return MsgPayPacketFeeResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/MsgPayPacketFeeResponse",
      value: MsgPayPacketFeeResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgPayPacketFeeResponse.decode(message.value);
  },

  toProto(message) {
    return MsgPayPacketFeeResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.applications.fee.v1.MsgPayPacketFeeResponse",
      value: MsgPayPacketFeeResponse.encode(message).finish()
    };
  }

};

function createBaseMsgPayPacketFeeAsync() {
  return {
    packetId: undefined,
    packetFee: undefined
  };
}

const MsgPayPacketFeeAsync = {
  typeUrl: "/ibc.applications.fee.v1.MsgPayPacketFeeAsync",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (message.packetId !== undefined) {
      _core_channel_v1_channel__WEBPACK_IMPORTED_MODULE_1__.PacketId.encode(message.packetId, writer.uint32(10).fork()).ldelim();
    }

    if (message.packetFee !== undefined) {
      _fee__WEBPACK_IMPORTED_MODULE_0__.PacketFee.encode(message.packetFee, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgPayPacketFeeAsync();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.packetId = _core_channel_v1_channel__WEBPACK_IMPORTED_MODULE_1__.PacketId.decode(reader, reader.uint32());
          break;

        case 2:
          message.packetFee = _fee__WEBPACK_IMPORTED_MODULE_0__.PacketFee.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseMsgPayPacketFeeAsync();
    message.packetId = object.packetId !== undefined && object.packetId !== null ? _core_channel_v1_channel__WEBPACK_IMPORTED_MODULE_1__.PacketId.fromPartial(object.packetId) : undefined;
    message.packetFee = object.packetFee !== undefined && object.packetFee !== null ? _fee__WEBPACK_IMPORTED_MODULE_0__.PacketFee.fromPartial(object.packetFee) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      packetId: object !== null && object !== void 0 && object.packet_id ? _core_channel_v1_channel__WEBPACK_IMPORTED_MODULE_1__.PacketId.fromAmino(object.packet_id) : undefined,
      packetFee: object !== null && object !== void 0 && object.packet_fee ? _fee__WEBPACK_IMPORTED_MODULE_0__.PacketFee.fromAmino(object.packet_fee) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.packet_id = message.packetId ? _core_channel_v1_channel__WEBPACK_IMPORTED_MODULE_1__.PacketId.toAmino(message.packetId) : undefined;
    obj.packet_fee = message.packetFee ? _fee__WEBPACK_IMPORTED_MODULE_0__.PacketFee.toAmino(message.packetFee) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgPayPacketFeeAsync.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/MsgPayPacketFeeAsync",
      value: MsgPayPacketFeeAsync.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgPayPacketFeeAsync.decode(message.value);
  },

  toProto(message) {
    return MsgPayPacketFeeAsync.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.applications.fee.v1.MsgPayPacketFeeAsync",
      value: MsgPayPacketFeeAsync.encode(message).finish()
    };
  }

};

function createBaseMsgPayPacketFeeAsyncResponse() {
  return {};
}

const MsgPayPacketFeeAsyncResponse = {
  typeUrl: "/ibc.applications.fee.v1.MsgPayPacketFeeAsyncResponse",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgPayPacketFeeAsyncResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseMsgPayPacketFeeAsyncResponse();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return MsgPayPacketFeeAsyncResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/MsgPayPacketFeeAsyncResponse",
      value: MsgPayPacketFeeAsyncResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgPayPacketFeeAsyncResponse.decode(message.value);
  },

  toProto(message) {
    return MsgPayPacketFeeAsyncResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.applications.fee.v1.MsgPayPacketFeeAsyncResponse",
      value: MsgPayPacketFeeAsyncResponse.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 30472:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MsgClientImpl": function() { return /* binding */ MsgClientImpl; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4942);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _tx__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43930);



/** Msg defines the ICS29 Msg service. */

class MsgClientImpl {
  constructor(rpc) {
    (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, "rpc", void 0);

    this.rpc = rpc;
    this.registerPayee = this.registerPayee.bind(this);
    this.registerCounterpartyPayee = this.registerCounterpartyPayee.bind(this);
    this.payPacketFee = this.payPacketFee.bind(this);
    this.payPacketFeeAsync = this.payPacketFeeAsync.bind(this);
  }

  registerPayee(request) {
    const data = _tx__WEBPACK_IMPORTED_MODULE_1__.MsgRegisterPayee.encode(request).finish();
    const promise = this.rpc.request("ibc.applications.fee.v1.Msg", "RegisterPayee", data);
    return promise.then(data => _tx__WEBPACK_IMPORTED_MODULE_1__.MsgRegisterPayeeResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  registerCounterpartyPayee(request) {
    const data = _tx__WEBPACK_IMPORTED_MODULE_1__.MsgRegisterCounterpartyPayee.encode(request).finish();
    const promise = this.rpc.request("ibc.applications.fee.v1.Msg", "RegisterCounterpartyPayee", data);
    return promise.then(data => _tx__WEBPACK_IMPORTED_MODULE_1__.MsgRegisterCounterpartyPayeeResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  payPacketFee(request) {
    const data = _tx__WEBPACK_IMPORTED_MODULE_1__.MsgPayPacketFee.encode(request).finish();
    const promise = this.rpc.request("ibc.applications.fee.v1.Msg", "PayPacketFee", data);
    return promise.then(data => _tx__WEBPACK_IMPORTED_MODULE_1__.MsgPayPacketFeeResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  payPacketFeeAsync(request) {
    const data = _tx__WEBPACK_IMPORTED_MODULE_1__.MsgPayPacketFeeAsync.encode(request).finish();
    const promise = this.rpc.request("ibc.applications.fee.v1.Msg", "PayPacketFeeAsync", data);
    return promise.then(data => _tx__WEBPACK_IMPORTED_MODULE_1__.MsgPayPacketFeeAsyncResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

}

/***/ }),

/***/ 46261:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Params": function() { return /* binding */ Params; }
/* harmony export */ });
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__);

/**
 * Params defines the set of on-chain interchain accounts parameters.
 * The following parameters may be used to disable the controller submodule.
 */

function createBaseParams() {
  return {
    controllerEnabled: false
  };
}

const Params = {
  typeUrl: "/ibc.applications.interchain_accounts.controller.v1.Params",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Writer.create()) {
    if (message.controllerEnabled === true) {
      writer.uint32(8).bool(message.controllerEnabled);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseParams();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.controllerEnabled = reader.bool();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$controllerEna;

    const message = createBaseParams();
    message.controllerEnabled = (_object$controllerEna = object.controllerEnabled) !== null && _object$controllerEna !== void 0 ? _object$controllerEna : false;
    return message;
  },

  fromAmino(object) {
    return {
      controllerEnabled: object.controller_enabled
    };
  },

  toAmino(message) {
    const obj = {};
    obj.controller_enabled = message.controllerEnabled;
    return obj;
  },

  fromAminoMsg(object) {
    return Params.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/Params",
      value: Params.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return Params.decode(message.value);
  },

  toProto(message) {
    return Params.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.applications.interchain_accounts.controller.v1.Params",
      value: Params.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 2082:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QueryInterchainAccountRequest": function() { return /* binding */ QueryInterchainAccountRequest; },
/* harmony export */   "QueryInterchainAccountResponse": function() { return /* binding */ QueryInterchainAccountResponse; },
/* harmony export */   "QueryParamsRequest": function() { return /* binding */ QueryParamsRequest; },
/* harmony export */   "QueryParamsResponse": function() { return /* binding */ QueryParamsResponse; }
/* harmony export */ });
/* harmony import */ var _controller__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46261);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__);


/** QueryInterchainAccountRequest is the request type for the Query/InterchainAccount RPC method. */

function createBaseQueryInterchainAccountRequest() {
  return {
    owner: "",
    connectionId: ""
  };
}

const QueryInterchainAccountRequest = {
  typeUrl: "/ibc.applications.interchain_accounts.controller.v1.QueryInterchainAccountRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Writer.create()) {
    if (message.owner !== "") {
      writer.uint32(10).string(message.owner);
    }

    if (message.connectionId !== "") {
      writer.uint32(18).string(message.connectionId);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryInterchainAccountRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.owner = reader.string();
          break;

        case 2:
          message.connectionId = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$owner, _object$connectionId;

    const message = createBaseQueryInterchainAccountRequest();
    message.owner = (_object$owner = object.owner) !== null && _object$owner !== void 0 ? _object$owner : "";
    message.connectionId = (_object$connectionId = object.connectionId) !== null && _object$connectionId !== void 0 ? _object$connectionId : "";
    return message;
  },

  fromAmino(object) {
    return {
      owner: object.owner,
      connectionId: object.connection_id
    };
  },

  toAmino(message) {
    const obj = {};
    obj.owner = message.owner;
    obj.connection_id = message.connectionId;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryInterchainAccountRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryInterchainAccountRequest",
      value: QueryInterchainAccountRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryInterchainAccountRequest.decode(message.value);
  },

  toProto(message) {
    return QueryInterchainAccountRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.applications.interchain_accounts.controller.v1.QueryInterchainAccountRequest",
      value: QueryInterchainAccountRequest.encode(message).finish()
    };
  }

};

function createBaseQueryInterchainAccountResponse() {
  return {
    address: ""
  };
}

const QueryInterchainAccountResponse = {
  typeUrl: "/ibc.applications.interchain_accounts.controller.v1.QueryInterchainAccountResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Writer.create()) {
    if (message.address !== "") {
      writer.uint32(10).string(message.address);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryInterchainAccountResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.address = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$address;

    const message = createBaseQueryInterchainAccountResponse();
    message.address = (_object$address = object.address) !== null && _object$address !== void 0 ? _object$address : "";
    return message;
  },

  fromAmino(object) {
    return {
      address: object.address
    };
  },

  toAmino(message) {
    const obj = {};
    obj.address = message.address;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryInterchainAccountResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryInterchainAccountResponse",
      value: QueryInterchainAccountResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryInterchainAccountResponse.decode(message.value);
  },

  toProto(message) {
    return QueryInterchainAccountResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.applications.interchain_accounts.controller.v1.QueryInterchainAccountResponse",
      value: QueryInterchainAccountResponse.encode(message).finish()
    };
  }

};

function createBaseQueryParamsRequest() {
  return {};
}

const QueryParamsRequest = {
  typeUrl: "/ibc.applications.interchain_accounts.controller.v1.QueryParamsRequest",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryParamsRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseQueryParamsRequest();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return QueryParamsRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryParamsRequest",
      value: QueryParamsRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryParamsRequest.decode(message.value);
  },

  toProto(message) {
    return QueryParamsRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.applications.interchain_accounts.controller.v1.QueryParamsRequest",
      value: QueryParamsRequest.encode(message).finish()
    };
  }

};

function createBaseQueryParamsResponse() {
  return {
    params: undefined
  };
}

const QueryParamsResponse = {
  typeUrl: "/ibc.applications.interchain_accounts.controller.v1.QueryParamsResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Writer.create()) {
    if (message.params !== undefined) {
      _controller__WEBPACK_IMPORTED_MODULE_0__.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryParamsResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.params = _controller__WEBPACK_IMPORTED_MODULE_0__.Params.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseQueryParamsResponse();
    message.params = object.params !== undefined && object.params !== null ? _controller__WEBPACK_IMPORTED_MODULE_0__.Params.fromPartial(object.params) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      params: object !== null && object !== void 0 && object.params ? _controller__WEBPACK_IMPORTED_MODULE_0__.Params.fromAmino(object.params) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.params = message.params ? _controller__WEBPACK_IMPORTED_MODULE_0__.Params.toAmino(message.params) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryParamsResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryParamsResponse",
      value: QueryParamsResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryParamsResponse.decode(message.value);
  },

  toProto(message) {
    return QueryParamsResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.applications.interchain_accounts.controller.v1.QueryParamsResponse",
      value: QueryParamsResponse.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 45789:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LCDQueryClient": function() { return /* binding */ LCDQueryClient; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4942);

class LCDQueryClient {
  constructor({
    requestClient
  }) {
    (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, "req", void 0);

    this.req = requestClient;
    this.interchainAccount = this.interchainAccount.bind(this);
    this.params = this.params.bind(this);
  }
  /* InterchainAccount returns the interchain account address for a given owner address on a given connection */


  async interchainAccount(params) {
    const endpoint = `ibc/apps/interchain_accounts/controller/v1/owners/${params.owner}/connections/${params.connectionId}`;
    return await this.req.get(endpoint);
  }
  /* Params queries all parameters of the ICA controller submodule. */


  async params(_params = {}) {
    const endpoint = `ibc/apps/interchain_accounts/controller/v1/params`;
    return await this.req.get(endpoint);
  }

}

/***/ }),

/***/ 6318:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QueryClientImpl": function() { return /* binding */ QueryClientImpl; },
/* harmony export */   "createRpcQueryExtension": function() { return /* binding */ createRpcQueryExtension; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4942);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78441);
/* harmony import */ var _cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2082);




/** Query provides defines the gRPC querier service. */

class QueryClientImpl {
  constructor(rpc) {
    (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, "rpc", void 0);

    this.rpc = rpc;
    this.interchainAccount = this.interchainAccount.bind(this);
    this.params = this.params.bind(this);
  }

  interchainAccount(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryInterchainAccountRequest.encode(request).finish();
    const promise = this.rpc.request("ibc.applications.interchain_accounts.controller.v1.Query", "InterchainAccount", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryInterchainAccountResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  params(request = {}) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryParamsRequest.encode(request).finish();
    const promise = this.rpc.request("ibc.applications.interchain_accounts.controller.v1.Query", "Params", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryParamsResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

}
const createRpcQueryExtension = base => {
  const rpc = (0,_cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1__.createProtobufRpcClient)(base);
  const queryService = new QueryClientImpl(rpc);
  return {
    interchainAccount(request) {
      return queryService.interchainAccount(request);
    },

    params(request) {
      return queryService.params(request);
    }

  };
};

/***/ }),

/***/ 51982:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MsgRegisterInterchainAccount": function() { return /* binding */ MsgRegisterInterchainAccount; },
/* harmony export */   "MsgRegisterInterchainAccountResponse": function() { return /* binding */ MsgRegisterInterchainAccountResponse; },
/* harmony export */   "MsgSendTx": function() { return /* binding */ MsgSendTx; },
/* harmony export */   "MsgSendTxResponse": function() { return /* binding */ MsgSendTxResponse; }
/* harmony export */ });
/* harmony import */ var _v1_packet__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2088);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47895);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__);



/** MsgRegisterInterchainAccount defines the payload for Msg/RegisterAccount */

function createBaseMsgRegisterInterchainAccount() {
  return {
    owner: "",
    connectionId: "",
    version: ""
  };
}

const MsgRegisterInterchainAccount = {
  typeUrl: "/ibc.applications.interchain_accounts.controller.v1.MsgRegisterInterchainAccount",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (message.owner !== "") {
      writer.uint32(10).string(message.owner);
    }

    if (message.connectionId !== "") {
      writer.uint32(18).string(message.connectionId);
    }

    if (message.version !== "") {
      writer.uint32(26).string(message.version);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgRegisterInterchainAccount();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.owner = reader.string();
          break;

        case 2:
          message.connectionId = reader.string();
          break;

        case 3:
          message.version = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$owner, _object$connectionId, _object$version;

    const message = createBaseMsgRegisterInterchainAccount();
    message.owner = (_object$owner = object.owner) !== null && _object$owner !== void 0 ? _object$owner : "";
    message.connectionId = (_object$connectionId = object.connectionId) !== null && _object$connectionId !== void 0 ? _object$connectionId : "";
    message.version = (_object$version = object.version) !== null && _object$version !== void 0 ? _object$version : "";
    return message;
  },

  fromAmino(object) {
    return {
      owner: object.owner,
      connectionId: object.connection_id,
      version: object.version
    };
  },

  toAmino(message) {
    const obj = {};
    obj.owner = message.owner;
    obj.connection_id = message.connectionId;
    obj.version = message.version;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgRegisterInterchainAccount.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/MsgRegisterInterchainAccount",
      value: MsgRegisterInterchainAccount.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgRegisterInterchainAccount.decode(message.value);
  },

  toProto(message) {
    return MsgRegisterInterchainAccount.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.applications.interchain_accounts.controller.v1.MsgRegisterInterchainAccount",
      value: MsgRegisterInterchainAccount.encode(message).finish()
    };
  }

};

function createBaseMsgRegisterInterchainAccountResponse() {
  return {
    channelId: "",
    portId: ""
  };
}

const MsgRegisterInterchainAccountResponse = {
  typeUrl: "/ibc.applications.interchain_accounts.controller.v1.MsgRegisterInterchainAccountResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (message.channelId !== "") {
      writer.uint32(10).string(message.channelId);
    }

    if (message.portId !== "") {
      writer.uint32(18).string(message.portId);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgRegisterInterchainAccountResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.channelId = reader.string();
          break;

        case 2:
          message.portId = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$channelId, _object$portId;

    const message = createBaseMsgRegisterInterchainAccountResponse();
    message.channelId = (_object$channelId = object.channelId) !== null && _object$channelId !== void 0 ? _object$channelId : "";
    message.portId = (_object$portId = object.portId) !== null && _object$portId !== void 0 ? _object$portId : "";
    return message;
  },

  fromAmino(object) {
    return {
      channelId: object.channel_id,
      portId: object.port_id
    };
  },

  toAmino(message) {
    const obj = {};
    obj.channel_id = message.channelId;
    obj.port_id = message.portId;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgRegisterInterchainAccountResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/MsgRegisterInterchainAccountResponse",
      value: MsgRegisterInterchainAccountResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgRegisterInterchainAccountResponse.decode(message.value);
  },

  toProto(message) {
    return MsgRegisterInterchainAccountResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.applications.interchain_accounts.controller.v1.MsgRegisterInterchainAccountResponse",
      value: MsgRegisterInterchainAccountResponse.encode(message).finish()
    };
  }

};

function createBaseMsgSendTx() {
  return {
    owner: "",
    connectionId: "",
    packetData: undefined,
    relativeTimeout: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.UZERO */ .dK.UZERO
  };
}

const MsgSendTx = {
  typeUrl: "/ibc.applications.interchain_accounts.controller.v1.MsgSendTx",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (message.owner !== "") {
      writer.uint32(10).string(message.owner);
    }

    if (message.connectionId !== "") {
      writer.uint32(18).string(message.connectionId);
    }

    if (message.packetData !== undefined) {
      _v1_packet__WEBPACK_IMPORTED_MODULE_0__.InterchainAccountPacketData.encode(message.packetData, writer.uint32(26).fork()).ldelim();
    }

    if (!message.relativeTimeout.isZero()) {
      writer.uint32(32).uint64(message.relativeTimeout);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgSendTx();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.owner = reader.string();
          break;

        case 2:
          message.connectionId = reader.string();
          break;

        case 3:
          message.packetData = _v1_packet__WEBPACK_IMPORTED_MODULE_0__.InterchainAccountPacketData.decode(reader, reader.uint32());
          break;

        case 4:
          message.relativeTimeout = reader.uint64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$owner2, _object$connectionId2;

    const message = createBaseMsgSendTx();
    message.owner = (_object$owner2 = object.owner) !== null && _object$owner2 !== void 0 ? _object$owner2 : "";
    message.connectionId = (_object$connectionId2 = object.connectionId) !== null && _object$connectionId2 !== void 0 ? _object$connectionId2 : "";
    message.packetData = object.packetData !== undefined && object.packetData !== null ? _v1_packet__WEBPACK_IMPORTED_MODULE_0__.InterchainAccountPacketData.fromPartial(object.packetData) : undefined;
    message.relativeTimeout = object.relativeTimeout !== undefined && object.relativeTimeout !== null ? _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromValue */ .dK.fromValue(object.relativeTimeout) : _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.UZERO */ .dK.UZERO;
    return message;
  },

  fromAmino(object) {
    return {
      owner: object.owner,
      connectionId: object.connection_id,
      packetData: object !== null && object !== void 0 && object.packet_data ? _v1_packet__WEBPACK_IMPORTED_MODULE_0__.InterchainAccountPacketData.fromAmino(object.packet_data) : undefined,
      relativeTimeout: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromString */ .dK.fromString(object.relative_timeout)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.owner = message.owner;
    obj.connection_id = message.connectionId;
    obj.packet_data = message.packetData ? _v1_packet__WEBPACK_IMPORTED_MODULE_0__.InterchainAccountPacketData.toAmino(message.packetData) : undefined;
    obj.relative_timeout = message.relativeTimeout ? message.relativeTimeout.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgSendTx.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/MsgSendTx",
      value: MsgSendTx.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgSendTx.decode(message.value);
  },

  toProto(message) {
    return MsgSendTx.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.applications.interchain_accounts.controller.v1.MsgSendTx",
      value: MsgSendTx.encode(message).finish()
    };
  }

};

function createBaseMsgSendTxResponse() {
  return {
    sequence: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.UZERO */ .dK.UZERO
  };
}

const MsgSendTxResponse = {
  typeUrl: "/ibc.applications.interchain_accounts.controller.v1.MsgSendTxResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (!message.sequence.isZero()) {
      writer.uint32(8).uint64(message.sequence);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgSendTxResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.sequence = reader.uint64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseMsgSendTxResponse();
    message.sequence = object.sequence !== undefined && object.sequence !== null ? _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromValue */ .dK.fromValue(object.sequence) : _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.UZERO */ .dK.UZERO;
    return message;
  },

  fromAmino(object) {
    return {
      sequence: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromString */ .dK.fromString(object.sequence)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.sequence = message.sequence ? message.sequence.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgSendTxResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/MsgSendTxResponse",
      value: MsgSendTxResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgSendTxResponse.decode(message.value);
  },

  toProto(message) {
    return MsgSendTxResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.applications.interchain_accounts.controller.v1.MsgSendTxResponse",
      value: MsgSendTxResponse.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 27147:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MsgClientImpl": function() { return /* binding */ MsgClientImpl; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4942);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _tx__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51982);



/** Msg defines the 27-interchain-accounts/controller Msg service. */

class MsgClientImpl {
  constructor(rpc) {
    (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, "rpc", void 0);

    this.rpc = rpc;
    this.registerInterchainAccount = this.registerInterchainAccount.bind(this);
    this.sendTx = this.sendTx.bind(this);
  }

  registerInterchainAccount(request) {
    const data = _tx__WEBPACK_IMPORTED_MODULE_1__.MsgRegisterInterchainAccount.encode(request).finish();
    const promise = this.rpc.request("ibc.applications.interchain_accounts.controller.v1.Msg", "RegisterInterchainAccount", data);
    return promise.then(data => _tx__WEBPACK_IMPORTED_MODULE_1__.MsgRegisterInterchainAccountResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  sendTx(request) {
    const data = _tx__WEBPACK_IMPORTED_MODULE_1__.MsgSendTx.encode(request).finish();
    const promise = this.rpc.request("ibc.applications.interchain_accounts.controller.v1.Msg", "SendTx", data);
    return promise.then(data => _tx__WEBPACK_IMPORTED_MODULE_1__.MsgSendTxResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

}

/***/ }),

/***/ 78983:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Params": function() { return /* binding */ Params; }
/* harmony export */ });
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__);

/**
 * Params defines the set of on-chain interchain accounts parameters.
 * The following parameters may be used to disable the host submodule.
 */

function createBaseParams() {
  return {
    hostEnabled: false,
    allowMessages: []
  };
}

const Params = {
  typeUrl: "/ibc.applications.interchain_accounts.host.v1.Params",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Writer.create()) {
    if (message.hostEnabled === true) {
      writer.uint32(8).bool(message.hostEnabled);
    }

    for (const v of message.allowMessages) {
      writer.uint32(18).string(v);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseParams();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.hostEnabled = reader.bool();
          break;

        case 2:
          message.allowMessages.push(reader.string());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$hostEnabled, _object$allowMessages;

    const message = createBaseParams();
    message.hostEnabled = (_object$hostEnabled = object.hostEnabled) !== null && _object$hostEnabled !== void 0 ? _object$hostEnabled : false;
    message.allowMessages = ((_object$allowMessages = object.allowMessages) === null || _object$allowMessages === void 0 ? void 0 : _object$allowMessages.map(e => e)) || [];
    return message;
  },

  fromAmino(object) {
    return {
      hostEnabled: object.host_enabled,
      allowMessages: Array.isArray(object === null || object === void 0 ? void 0 : object.allow_messages) ? object.allow_messages.map(e => e) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.host_enabled = message.hostEnabled;

    if (message.allowMessages) {
      obj.allow_messages = message.allowMessages.map(e => e);
    } else {
      obj.allow_messages = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return Params.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/Params",
      value: Params.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return Params.decode(message.value);
  },

  toProto(message) {
    return Params.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.applications.interchain_accounts.host.v1.Params",
      value: Params.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 59643:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QueryParamsRequest": function() { return /* binding */ QueryParamsRequest; },
/* harmony export */   "QueryParamsResponse": function() { return /* binding */ QueryParamsResponse; }
/* harmony export */ });
/* harmony import */ var _host__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78983);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__);


/** QueryParamsRequest is the request type for the Query/Params RPC method. */

function createBaseQueryParamsRequest() {
  return {};
}

const QueryParamsRequest = {
  typeUrl: "/ibc.applications.interchain_accounts.host.v1.QueryParamsRequest",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryParamsRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseQueryParamsRequest();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return QueryParamsRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryParamsRequest",
      value: QueryParamsRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryParamsRequest.decode(message.value);
  },

  toProto(message) {
    return QueryParamsRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.applications.interchain_accounts.host.v1.QueryParamsRequest",
      value: QueryParamsRequest.encode(message).finish()
    };
  }

};

function createBaseQueryParamsResponse() {
  return {
    params: undefined
  };
}

const QueryParamsResponse = {
  typeUrl: "/ibc.applications.interchain_accounts.host.v1.QueryParamsResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Writer.create()) {
    if (message.params !== undefined) {
      _host__WEBPACK_IMPORTED_MODULE_0__.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryParamsResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.params = _host__WEBPACK_IMPORTED_MODULE_0__.Params.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseQueryParamsResponse();
    message.params = object.params !== undefined && object.params !== null ? _host__WEBPACK_IMPORTED_MODULE_0__.Params.fromPartial(object.params) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      params: object !== null && object !== void 0 && object.params ? _host__WEBPACK_IMPORTED_MODULE_0__.Params.fromAmino(object.params) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.params = message.params ? _host__WEBPACK_IMPORTED_MODULE_0__.Params.toAmino(message.params) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryParamsResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryParamsResponse",
      value: QueryParamsResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryParamsResponse.decode(message.value);
  },

  toProto(message) {
    return QueryParamsResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.applications.interchain_accounts.host.v1.QueryParamsResponse",
      value: QueryParamsResponse.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 41918:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LCDQueryClient": function() { return /* binding */ LCDQueryClient; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4942);

class LCDQueryClient {
  constructor({
    requestClient
  }) {
    (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, "req", void 0);

    this.req = requestClient;
    this.params = this.params.bind(this);
  }
  /* Params queries all parameters of the ICA host submodule. */


  async params(_params = {}) {
    const endpoint = `ibc/apps/interchain_accounts/host/v1/params`;
    return await this.req.get(endpoint);
  }

}

/***/ }),

/***/ 7651:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QueryClientImpl": function() { return /* binding */ QueryClientImpl; },
/* harmony export */   "createRpcQueryExtension": function() { return /* binding */ createRpcQueryExtension; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4942);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78441);
/* harmony import */ var _cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59643);




/** Query provides defines the gRPC querier service. */

class QueryClientImpl {
  constructor(rpc) {
    (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, "rpc", void 0);

    this.rpc = rpc;
    this.params = this.params.bind(this);
  }

  params(request = {}) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryParamsRequest.encode(request).finish();
    const promise = this.rpc.request("ibc.applications.interchain_accounts.host.v1.Query", "Params", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryParamsResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

}
const createRpcQueryExtension = base => {
  const rpc = (0,_cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1__.createProtobufRpcClient)(base);
  const queryService = new QueryClientImpl(rpc);
  return {
    params(request) {
      return queryService.params(request);
    }

  };
};

/***/ }),

/***/ 2088:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CosmosTx": function() { return /* binding */ CosmosTx; },
/* harmony export */   "InterchainAccountPacketData": function() { return /* binding */ InterchainAccountPacketData; },
/* harmony export */   "Type": function() { return /* binding */ Type; },
/* harmony export */   "TypeAmino": function() { return /* binding */ TypeAmino; },
/* harmony export */   "TypeSDKType": function() { return /* binding */ TypeSDKType; },
/* harmony export */   "typeFromJSON": function() { return /* binding */ typeFromJSON; },
/* harmony export */   "typeToJSON": function() { return /* binding */ typeToJSON; }
/* harmony export */ });
/* harmony import */ var _google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32106);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47895);



/**
 * Type defines a classification of message issued from a controller chain to its associated interchain accounts
 * host
 */

let Type;

(function (Type) {
  Type[Type["TYPE_UNSPECIFIED"] = 0] = "TYPE_UNSPECIFIED";
  Type[Type["TYPE_EXECUTE_TX"] = 1] = "TYPE_EXECUTE_TX";
  Type[Type["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(Type || (Type = {}));

const TypeSDKType = Type;
const TypeAmino = Type;
function typeFromJSON(object) {
  switch (object) {
    case 0:
    case "TYPE_UNSPECIFIED":
      return Type.TYPE_UNSPECIFIED;

    case 1:
    case "TYPE_EXECUTE_TX":
      return Type.TYPE_EXECUTE_TX;

    case -1:
    case "UNRECOGNIZED":
    default:
      return Type.UNRECOGNIZED;
  }
}
function typeToJSON(object) {
  switch (object) {
    case Type.TYPE_UNSPECIFIED:
      return "TYPE_UNSPECIFIED";

    case Type.TYPE_EXECUTE_TX:
      return "TYPE_EXECUTE_TX";

    case Type.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
/** InterchainAccountPacketData is comprised of a raw transaction, type of transaction and optional memo field. */

function createBaseInterchainAccountPacketData() {
  return {
    type: 0,
    data: new Uint8Array(),
    memo: ""
  };
}

const InterchainAccountPacketData = {
  typeUrl: "/ibc.applications.interchain_accounts.v1.InterchainAccountPacketData",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Writer.create()) {
    if (message.type !== 0) {
      writer.uint32(8).int32(message.type);
    }

    if (message.data.length !== 0) {
      writer.uint32(18).bytes(message.data);
    }

    if (message.memo !== "") {
      writer.uint32(26).string(message.memo);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInterchainAccountPacketData();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.type = reader.int32();
          break;

        case 2:
          message.data = reader.bytes();
          break;

        case 3:
          message.memo = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$type, _object$data, _object$memo;

    const message = createBaseInterchainAccountPacketData();
    message.type = (_object$type = object.type) !== null && _object$type !== void 0 ? _object$type : 0;
    message.data = (_object$data = object.data) !== null && _object$data !== void 0 ? _object$data : new Uint8Array();
    message.memo = (_object$memo = object.memo) !== null && _object$memo !== void 0 ? _object$memo : "";
    return message;
  },

  fromAmino(object) {
    return {
      type: (0,_helpers__WEBPACK_IMPORTED_MODULE_2__/* .isSet */ .DM)(object.type) ? typeFromJSON(object.type) : 0,
      data: object.data,
      memo: object.memo
    };
  },

  toAmino(message) {
    const obj = {};
    obj.type = message.type;
    obj.data = message.data;
    obj.memo = message.memo;
    return obj;
  },

  fromAminoMsg(object) {
    return InterchainAccountPacketData.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/InterchainAccountPacketData",
      value: InterchainAccountPacketData.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return InterchainAccountPacketData.decode(message.value);
  },

  toProto(message) {
    return InterchainAccountPacketData.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.applications.interchain_accounts.v1.InterchainAccountPacketData",
      value: InterchainAccountPacketData.encode(message).finish()
    };
  }

};

function createBaseCosmosTx() {
  return {
    messages: []
  };
}

const CosmosTx = {
  typeUrl: "/ibc.applications.interchain_accounts.v1.CosmosTx",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Writer.create()) {
    for (const v of message.messages) {
      _google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__.Any.encode(v, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCosmosTx();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.messages.push(_google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__.Any.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$messages;

    const message = createBaseCosmosTx();
    message.messages = ((_object$messages = object.messages) === null || _object$messages === void 0 ? void 0 : _object$messages.map(e => _google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__.Any.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      messages: Array.isArray(object === null || object === void 0 ? void 0 : object.messages) ? object.messages.map(e => _google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__.Any.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.messages) {
      obj.messages = message.messages.map(e => e ? _google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__.Any.toAmino(e) : undefined);
    } else {
      obj.messages = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return CosmosTx.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/CosmosTx",
      value: CosmosTx.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return CosmosTx.decode(message.value);
  },

  toProto(message) {
    return CosmosTx.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.applications.interchain_accounts.v1.CosmosTx",
      value: CosmosTx.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 87502:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QueryDenomHashRequest": function() { return /* binding */ QueryDenomHashRequest; },
/* harmony export */   "QueryDenomHashResponse": function() { return /* binding */ QueryDenomHashResponse; },
/* harmony export */   "QueryDenomTraceRequest": function() { return /* binding */ QueryDenomTraceRequest; },
/* harmony export */   "QueryDenomTraceResponse": function() { return /* binding */ QueryDenomTraceResponse; },
/* harmony export */   "QueryDenomTracesRequest": function() { return /* binding */ QueryDenomTracesRequest; },
/* harmony export */   "QueryDenomTracesResponse": function() { return /* binding */ QueryDenomTracesResponse; },
/* harmony export */   "QueryEscrowAddressRequest": function() { return /* binding */ QueryEscrowAddressRequest; },
/* harmony export */   "QueryEscrowAddressResponse": function() { return /* binding */ QueryEscrowAddressResponse; },
/* harmony export */   "QueryParamsRequest": function() { return /* binding */ QueryParamsRequest; },
/* harmony export */   "QueryParamsResponse": function() { return /* binding */ QueryParamsResponse; }
/* harmony export */ });
/* harmony import */ var _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48978);
/* harmony import */ var _transfer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24845);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__);



/**
 * QueryDenomTraceRequest is the request type for the Query/DenomTrace RPC
 * method
 */

function createBaseQueryDenomTraceRequest() {
  return {
    hash: ""
  };
}

const QueryDenomTraceRequest = {
  typeUrl: "/ibc.applications.transfer.v1.QueryDenomTraceRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (message.hash !== "") {
      writer.uint32(10).string(message.hash);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryDenomTraceRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.hash = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$hash;

    const message = createBaseQueryDenomTraceRequest();
    message.hash = (_object$hash = object.hash) !== null && _object$hash !== void 0 ? _object$hash : "";
    return message;
  },

  fromAmino(object) {
    return {
      hash: object.hash
    };
  },

  toAmino(message) {
    const obj = {};
    obj.hash = message.hash;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryDenomTraceRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryDenomTraceRequest",
      value: QueryDenomTraceRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryDenomTraceRequest.decode(message.value);
  },

  toProto(message) {
    return QueryDenomTraceRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.applications.transfer.v1.QueryDenomTraceRequest",
      value: QueryDenomTraceRequest.encode(message).finish()
    };
  }

};

function createBaseQueryDenomTraceResponse() {
  return {
    denomTrace: undefined
  };
}

const QueryDenomTraceResponse = {
  typeUrl: "/ibc.applications.transfer.v1.QueryDenomTraceResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (message.denomTrace !== undefined) {
      _transfer__WEBPACK_IMPORTED_MODULE_1__.DenomTrace.encode(message.denomTrace, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryDenomTraceResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.denomTrace = _transfer__WEBPACK_IMPORTED_MODULE_1__.DenomTrace.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseQueryDenomTraceResponse();
    message.denomTrace = object.denomTrace !== undefined && object.denomTrace !== null ? _transfer__WEBPACK_IMPORTED_MODULE_1__.DenomTrace.fromPartial(object.denomTrace) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      denomTrace: object !== null && object !== void 0 && object.denom_trace ? _transfer__WEBPACK_IMPORTED_MODULE_1__.DenomTrace.fromAmino(object.denom_trace) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.denom_trace = message.denomTrace ? _transfer__WEBPACK_IMPORTED_MODULE_1__.DenomTrace.toAmino(message.denomTrace) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryDenomTraceResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryDenomTraceResponse",
      value: QueryDenomTraceResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryDenomTraceResponse.decode(message.value);
  },

  toProto(message) {
    return QueryDenomTraceResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.applications.transfer.v1.QueryDenomTraceResponse",
      value: QueryDenomTraceResponse.encode(message).finish()
    };
  }

};

function createBaseQueryDenomTracesRequest() {
  return {
    pagination: undefined
  };
}

const QueryDenomTracesRequest = {
  typeUrl: "/ibc.applications.transfer.v1.QueryDenomTracesRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (message.pagination !== undefined) {
      _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryDenomTracesRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.pagination = _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseQueryDenomTracesRequest();
    message.pagination = object.pagination !== undefined && object.pagination !== null ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.fromPartial(object.pagination) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      pagination: object !== null && object !== void 0 && object.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.fromAmino(object.pagination) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.pagination = message.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.toAmino(message.pagination) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryDenomTracesRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryDenomTracesRequest",
      value: QueryDenomTracesRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryDenomTracesRequest.decode(message.value);
  },

  toProto(message) {
    return QueryDenomTracesRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.applications.transfer.v1.QueryDenomTracesRequest",
      value: QueryDenomTracesRequest.encode(message).finish()
    };
  }

};

function createBaseQueryDenomTracesResponse() {
  return {
    denomTraces: [],
    pagination: undefined
  };
}

const QueryDenomTracesResponse = {
  typeUrl: "/ibc.applications.transfer.v1.QueryDenomTracesResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    for (const v of message.denomTraces) {
      _transfer__WEBPACK_IMPORTED_MODULE_1__.DenomTrace.encode(v, writer.uint32(10).fork()).ldelim();
    }

    if (message.pagination !== undefined) {
      _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryDenomTracesResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.denomTraces.push(_transfer__WEBPACK_IMPORTED_MODULE_1__.DenomTrace.decode(reader, reader.uint32()));
          break;

        case 2:
          message.pagination = _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$denomTraces;

    const message = createBaseQueryDenomTracesResponse();
    message.denomTraces = ((_object$denomTraces = object.denomTraces) === null || _object$denomTraces === void 0 ? void 0 : _object$denomTraces.map(e => _transfer__WEBPACK_IMPORTED_MODULE_1__.DenomTrace.fromPartial(e))) || [];
    message.pagination = object.pagination !== undefined && object.pagination !== null ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.fromPartial(object.pagination) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      denomTraces: Array.isArray(object === null || object === void 0 ? void 0 : object.denom_traces) ? object.denom_traces.map(e => _transfer__WEBPACK_IMPORTED_MODULE_1__.DenomTrace.fromAmino(e)) : [],
      pagination: object !== null && object !== void 0 && object.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.fromAmino(object.pagination) : undefined
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.denomTraces) {
      obj.denom_traces = message.denomTraces.map(e => e ? _transfer__WEBPACK_IMPORTED_MODULE_1__.DenomTrace.toAmino(e) : undefined);
    } else {
      obj.denom_traces = [];
    }

    obj.pagination = message.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.toAmino(message.pagination) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryDenomTracesResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryDenomTracesResponse",
      value: QueryDenomTracesResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryDenomTracesResponse.decode(message.value);
  },

  toProto(message) {
    return QueryDenomTracesResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.applications.transfer.v1.QueryDenomTracesResponse",
      value: QueryDenomTracesResponse.encode(message).finish()
    };
  }

};

function createBaseQueryParamsRequest() {
  return {};
}

const QueryParamsRequest = {
  typeUrl: "/ibc.applications.transfer.v1.QueryParamsRequest",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryParamsRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseQueryParamsRequest();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return QueryParamsRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryParamsRequest",
      value: QueryParamsRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryParamsRequest.decode(message.value);
  },

  toProto(message) {
    return QueryParamsRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.applications.transfer.v1.QueryParamsRequest",
      value: QueryParamsRequest.encode(message).finish()
    };
  }

};

function createBaseQueryParamsResponse() {
  return {
    params: undefined
  };
}

const QueryParamsResponse = {
  typeUrl: "/ibc.applications.transfer.v1.QueryParamsResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (message.params !== undefined) {
      _transfer__WEBPACK_IMPORTED_MODULE_1__.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryParamsResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.params = _transfer__WEBPACK_IMPORTED_MODULE_1__.Params.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseQueryParamsResponse();
    message.params = object.params !== undefined && object.params !== null ? _transfer__WEBPACK_IMPORTED_MODULE_1__.Params.fromPartial(object.params) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      params: object !== null && object !== void 0 && object.params ? _transfer__WEBPACK_IMPORTED_MODULE_1__.Params.fromAmino(object.params) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.params = message.params ? _transfer__WEBPACK_IMPORTED_MODULE_1__.Params.toAmino(message.params) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryParamsResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryParamsResponse",
      value: QueryParamsResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryParamsResponse.decode(message.value);
  },

  toProto(message) {
    return QueryParamsResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.applications.transfer.v1.QueryParamsResponse",
      value: QueryParamsResponse.encode(message).finish()
    };
  }

};

function createBaseQueryDenomHashRequest() {
  return {
    trace: ""
  };
}

const QueryDenomHashRequest = {
  typeUrl: "/ibc.applications.transfer.v1.QueryDenomHashRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (message.trace !== "") {
      writer.uint32(10).string(message.trace);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryDenomHashRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.trace = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$trace;

    const message = createBaseQueryDenomHashRequest();
    message.trace = (_object$trace = object.trace) !== null && _object$trace !== void 0 ? _object$trace : "";
    return message;
  },

  fromAmino(object) {
    return {
      trace: object.trace
    };
  },

  toAmino(message) {
    const obj = {};
    obj.trace = message.trace;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryDenomHashRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryDenomHashRequest",
      value: QueryDenomHashRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryDenomHashRequest.decode(message.value);
  },

  toProto(message) {
    return QueryDenomHashRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.applications.transfer.v1.QueryDenomHashRequest",
      value: QueryDenomHashRequest.encode(message).finish()
    };
  }

};

function createBaseQueryDenomHashResponse() {
  return {
    hash: ""
  };
}

const QueryDenomHashResponse = {
  typeUrl: "/ibc.applications.transfer.v1.QueryDenomHashResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (message.hash !== "") {
      writer.uint32(10).string(message.hash);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryDenomHashResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.hash = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$hash2;

    const message = createBaseQueryDenomHashResponse();
    message.hash = (_object$hash2 = object.hash) !== null && _object$hash2 !== void 0 ? _object$hash2 : "";
    return message;
  },

  fromAmino(object) {
    return {
      hash: object.hash
    };
  },

  toAmino(message) {
    const obj = {};
    obj.hash = message.hash;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryDenomHashResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryDenomHashResponse",
      value: QueryDenomHashResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryDenomHashResponse.decode(message.value);
  },

  toProto(message) {
    return QueryDenomHashResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.applications.transfer.v1.QueryDenomHashResponse",
      value: QueryDenomHashResponse.encode(message).finish()
    };
  }

};

function createBaseQueryEscrowAddressRequest() {
  return {
    portId: "",
    channelId: ""
  };
}

const QueryEscrowAddressRequest = {
  typeUrl: "/ibc.applications.transfer.v1.QueryEscrowAddressRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (message.portId !== "") {
      writer.uint32(10).string(message.portId);
    }

    if (message.channelId !== "") {
      writer.uint32(18).string(message.channelId);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryEscrowAddressRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.portId = reader.string();
          break;

        case 2:
          message.channelId = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$portId, _object$channelId;

    const message = createBaseQueryEscrowAddressRequest();
    message.portId = (_object$portId = object.portId) !== null && _object$portId !== void 0 ? _object$portId : "";
    message.channelId = (_object$channelId = object.channelId) !== null && _object$channelId !== void 0 ? _object$channelId : "";
    return message;
  },

  fromAmino(object) {
    return {
      portId: object.port_id,
      channelId: object.channel_id
    };
  },

  toAmino(message) {
    const obj = {};
    obj.port_id = message.portId;
    obj.channel_id = message.channelId;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryEscrowAddressRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryEscrowAddressRequest",
      value: QueryEscrowAddressRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryEscrowAddressRequest.decode(message.value);
  },

  toProto(message) {
    return QueryEscrowAddressRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.applications.transfer.v1.QueryEscrowAddressRequest",
      value: QueryEscrowAddressRequest.encode(message).finish()
    };
  }

};

function createBaseQueryEscrowAddressResponse() {
  return {
    escrowAddress: ""
  };
}

const QueryEscrowAddressResponse = {
  typeUrl: "/ibc.applications.transfer.v1.QueryEscrowAddressResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (message.escrowAddress !== "") {
      writer.uint32(10).string(message.escrowAddress);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryEscrowAddressResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.escrowAddress = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$escrowAddress;

    const message = createBaseQueryEscrowAddressResponse();
    message.escrowAddress = (_object$escrowAddress = object.escrowAddress) !== null && _object$escrowAddress !== void 0 ? _object$escrowAddress : "";
    return message;
  },

  fromAmino(object) {
    return {
      escrowAddress: object.escrow_address
    };
  },

  toAmino(message) {
    const obj = {};
    obj.escrow_address = message.escrowAddress;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryEscrowAddressResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryEscrowAddressResponse",
      value: QueryEscrowAddressResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryEscrowAddressResponse.decode(message.value);
  },

  toProto(message) {
    return QueryEscrowAddressResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.applications.transfer.v1.QueryEscrowAddressResponse",
      value: QueryEscrowAddressResponse.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 95693:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LCDQueryClient": function() { return /* binding */ LCDQueryClient; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4942);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47895);


class LCDQueryClient {
  constructor({
    requestClient
  }) {
    (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, "req", void 0);

    this.req = requestClient;
    this.denomTrace = this.denomTrace.bind(this);
    this.denomTraces = this.denomTraces.bind(this);
    this.params = this.params.bind(this);
    this.denomHash = this.denomHash.bind(this);
    this.escrowAddress = this.escrowAddress.bind(this);
  }
  /* DenomTrace queries a denomination trace information. */


  async denomTrace(params) {
    const options = {
      params: {}
    };

    if (typeof (params === null || params === void 0 ? void 0 : params.hash) !== "undefined") {
      options.params.hash = params.hash;
    }

    const endpoint = `ibc/apps/transfer/v1/denom_traces/${params.hash}`;
    return await this.req.get(endpoint, options);
  }
  /* DenomTraces queries all denomination traces. */


  async denomTraces(params = {
    pagination: undefined
  }) {
    const options = {
      params: {}
    };

    if (typeof (params === null || params === void 0 ? void 0 : params.pagination) !== "undefined") {
      (0,_helpers__WEBPACK_IMPORTED_MODULE_0__/* .setPaginationParams */ .q6)(options, params.pagination);
    }

    const endpoint = `ibc/apps/transfer/v1/denom_traces`;
    return await this.req.get(endpoint, options);
  }
  /* Params queries all parameters of the ibc-transfer module. */


  async params(_params = {}) {
    const endpoint = `ibc/apps/transfer/v1/params`;
    return await this.req.get(endpoint);
  }
  /* DenomHash queries a denomination hash information. */


  async denomHash(params) {
    const options = {
      params: {}
    };

    if (typeof (params === null || params === void 0 ? void 0 : params.trace) !== "undefined") {
      options.params.trace = params.trace;
    }

    const endpoint = `ibc/apps/transfer/v1/denom_hashes/${params.trace}`;
    return await this.req.get(endpoint, options);
  }
  /* EscrowAddress returns the escrow address for a particular port and channel id. */


  async escrowAddress(params) {
    const endpoint = `ibc/apps/transfer/v1/channels/${params.channelId}/ports/${params.portId}/escrow_address`;
    return await this.req.get(endpoint);
  }

}

/***/ }),

/***/ 13159:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QueryClientImpl": function() { return /* binding */ QueryClientImpl; },
/* harmony export */   "createRpcQueryExtension": function() { return /* binding */ createRpcQueryExtension; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4942);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78441);
/* harmony import */ var _cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87502);




/** Query provides defines the gRPC querier service. */

class QueryClientImpl {
  constructor(rpc) {
    (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, "rpc", void 0);

    this.rpc = rpc;
    this.denomTrace = this.denomTrace.bind(this);
    this.denomTraces = this.denomTraces.bind(this);
    this.params = this.params.bind(this);
    this.denomHash = this.denomHash.bind(this);
    this.escrowAddress = this.escrowAddress.bind(this);
  }

  denomTrace(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryDenomTraceRequest.encode(request).finish();
    const promise = this.rpc.request("ibc.applications.transfer.v1.Query", "DenomTrace", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryDenomTraceResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  denomTraces(request = {
    pagination: undefined
  }) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryDenomTracesRequest.encode(request).finish();
    const promise = this.rpc.request("ibc.applications.transfer.v1.Query", "DenomTraces", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryDenomTracesResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  params(request = {}) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryParamsRequest.encode(request).finish();
    const promise = this.rpc.request("ibc.applications.transfer.v1.Query", "Params", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryParamsResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  denomHash(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryDenomHashRequest.encode(request).finish();
    const promise = this.rpc.request("ibc.applications.transfer.v1.Query", "DenomHash", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryDenomHashResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  escrowAddress(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryEscrowAddressRequest.encode(request).finish();
    const promise = this.rpc.request("ibc.applications.transfer.v1.Query", "EscrowAddress", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryEscrowAddressResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

}
const createRpcQueryExtension = base => {
  const rpc = (0,_cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1__.createProtobufRpcClient)(base);
  const queryService = new QueryClientImpl(rpc);
  return {
    denomTrace(request) {
      return queryService.denomTrace(request);
    },

    denomTraces(request) {
      return queryService.denomTraces(request);
    },

    params(request) {
      return queryService.params(request);
    },

    denomHash(request) {
      return queryService.denomHash(request);
    },

    escrowAddress(request) {
      return queryService.escrowAddress(request);
    }

  };
};

/***/ }),

/***/ 24845:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DenomTrace": function() { return /* binding */ DenomTrace; },
/* harmony export */   "Params": function() { return /* binding */ Params; }
/* harmony export */ });
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__);

/**
 * DenomTrace contains the base denomination for ICS20 fungible tokens and the
 * source tracing information path.
 */

function createBaseDenomTrace() {
  return {
    path: "",
    baseDenom: ""
  };
}

const DenomTrace = {
  typeUrl: "/ibc.applications.transfer.v1.DenomTrace",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Writer.create()) {
    if (message.path !== "") {
      writer.uint32(10).string(message.path);
    }

    if (message.baseDenom !== "") {
      writer.uint32(18).string(message.baseDenom);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDenomTrace();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.path = reader.string();
          break;

        case 2:
          message.baseDenom = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$path, _object$baseDenom;

    const message = createBaseDenomTrace();
    message.path = (_object$path = object.path) !== null && _object$path !== void 0 ? _object$path : "";
    message.baseDenom = (_object$baseDenom = object.baseDenom) !== null && _object$baseDenom !== void 0 ? _object$baseDenom : "";
    return message;
  },

  fromAmino(object) {
    return {
      path: object.path,
      baseDenom: object.base_denom
    };
  },

  toAmino(message) {
    const obj = {};
    obj.path = message.path;
    obj.base_denom = message.baseDenom;
    return obj;
  },

  fromAminoMsg(object) {
    return DenomTrace.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/DenomTrace",
      value: DenomTrace.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return DenomTrace.decode(message.value);
  },

  toProto(message) {
    return DenomTrace.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.applications.transfer.v1.DenomTrace",
      value: DenomTrace.encode(message).finish()
    };
  }

};

function createBaseParams() {
  return {
    sendEnabled: false,
    receiveEnabled: false
  };
}

const Params = {
  typeUrl: "/ibc.applications.transfer.v1.Params",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Writer.create()) {
    if (message.sendEnabled === true) {
      writer.uint32(8).bool(message.sendEnabled);
    }

    if (message.receiveEnabled === true) {
      writer.uint32(16).bool(message.receiveEnabled);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseParams();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.sendEnabled = reader.bool();
          break;

        case 2:
          message.receiveEnabled = reader.bool();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$sendEnabled, _object$receiveEnable;

    const message = createBaseParams();
    message.sendEnabled = (_object$sendEnabled = object.sendEnabled) !== null && _object$sendEnabled !== void 0 ? _object$sendEnabled : false;
    message.receiveEnabled = (_object$receiveEnable = object.receiveEnabled) !== null && _object$receiveEnable !== void 0 ? _object$receiveEnable : false;
    return message;
  },

  fromAmino(object) {
    return {
      sendEnabled: object.send_enabled,
      receiveEnabled: object.receive_enabled
    };
  },

  toAmino(message) {
    const obj = {};
    obj.send_enabled = message.sendEnabled;
    obj.receive_enabled = message.receiveEnabled;
    return obj;
  },

  fromAminoMsg(object) {
    return Params.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/Params",
      value: Params.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return Params.decode(message.value);
  },

  toProto(message) {
    return Params.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.applications.transfer.v1.Params",
      value: Params.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 71016:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MsgTransfer": function() { return /* binding */ MsgTransfer; },
/* harmony export */   "MsgTransferResponse": function() { return /* binding */ MsgTransferResponse; }
/* harmony export */ });
/* harmony import */ var _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26178);
/* harmony import */ var _core_client_v1_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45802);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47895);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__);




/**
 * MsgTransfer defines a msg to transfer fungible tokens (i.e Coins) between
 * ICS20 enabled chains. See ICS Spec here:
 * https://github.com/cosmos/ibc/tree/master/spec/app/ics-020-fungible-token-transfer#data-structures
 */

function createBaseMsgTransfer() {
  return {
    sourcePort: "",
    sourceChannel: "",
    token: undefined,
    sender: "",
    receiver: "",
    timeoutHeight: undefined,
    timeoutTimestamp: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO,
    memo: ""
  };
}

const MsgTransfer = {
  typeUrl: "/ibc.applications.transfer.v1.MsgTransfer",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.sourcePort !== "") {
      writer.uint32(10).string(message.sourcePort);
    }

    if (message.sourceChannel !== "") {
      writer.uint32(18).string(message.sourceChannel);
    }

    if (message.token !== undefined) {
      _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.encode(message.token, writer.uint32(26).fork()).ldelim();
    }

    if (message.sender !== "") {
      writer.uint32(34).string(message.sender);
    }

    if (message.receiver !== "") {
      writer.uint32(42).string(message.receiver);
    }

    if (message.timeoutHeight !== undefined) {
      _core_client_v1_client__WEBPACK_IMPORTED_MODULE_1__.Height.encode(message.timeoutHeight, writer.uint32(50).fork()).ldelim();
    }

    if (!message.timeoutTimestamp.isZero()) {
      writer.uint32(56).uint64(message.timeoutTimestamp);
    }

    if (message.memo !== "") {
      writer.uint32(66).string(message.memo);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgTransfer();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.sourcePort = reader.string();
          break;

        case 2:
          message.sourceChannel = reader.string();
          break;

        case 3:
          message.token = _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.decode(reader, reader.uint32());
          break;

        case 4:
          message.sender = reader.string();
          break;

        case 5:
          message.receiver = reader.string();
          break;

        case 6:
          message.timeoutHeight = _core_client_v1_client__WEBPACK_IMPORTED_MODULE_1__.Height.decode(reader, reader.uint32());
          break;

        case 7:
          message.timeoutTimestamp = reader.uint64();
          break;

        case 8:
          message.memo = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$sourcePort, _object$sourceChannel, _object$sender, _object$receiver, _object$memo;

    const message = createBaseMsgTransfer();
    message.sourcePort = (_object$sourcePort = object.sourcePort) !== null && _object$sourcePort !== void 0 ? _object$sourcePort : "";
    message.sourceChannel = (_object$sourceChannel = object.sourceChannel) !== null && _object$sourceChannel !== void 0 ? _object$sourceChannel : "";
    message.token = object.token !== undefined && object.token !== null ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.fromPartial(object.token) : undefined;
    message.sender = (_object$sender = object.sender) !== null && _object$sender !== void 0 ? _object$sender : "";
    message.receiver = (_object$receiver = object.receiver) !== null && _object$receiver !== void 0 ? _object$receiver : "";
    message.timeoutHeight = object.timeoutHeight !== undefined && object.timeoutHeight !== null ? _core_client_v1_client__WEBPACK_IMPORTED_MODULE_1__.Height.fromPartial(object.timeoutHeight) : undefined;
    message.timeoutTimestamp = object.timeoutTimestamp !== undefined && object.timeoutTimestamp !== null ? _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromValue */ .dK.fromValue(object.timeoutTimestamp) : _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO;
    message.memo = (_object$memo = object.memo) !== null && _object$memo !== void 0 ? _object$memo : "";
    return message;
  },

  fromAmino(object) {
    return {
      sourcePort: object.source_port,
      sourceChannel: object.source_channel,
      token: object !== null && object !== void 0 && object.token ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.fromAmino(object.token) : undefined,
      sender: object.sender,
      receiver: object.receiver,
      timeoutHeight: object !== null && object !== void 0 && object.timeout_height ? _core_client_v1_client__WEBPACK_IMPORTED_MODULE_1__.Height.fromAmino(object.timeout_height) : undefined,
      timeoutTimestamp: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromString */ .dK.fromString(object.timeout_timestamp),
      memo: object.memo
    };
  },

  toAmino(message) {
    const obj = {};
    obj.source_port = message.sourcePort;
    obj.source_channel = message.sourceChannel;
    obj.token = message.token ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.toAmino(message.token) : undefined;
    obj.sender = message.sender;
    obj.receiver = message.receiver;
    obj.timeout_height = message.timeoutHeight ? _core_client_v1_client__WEBPACK_IMPORTED_MODULE_1__.Height.toAmino(message.timeoutHeight) : {};
    obj.timeout_timestamp = message.timeoutTimestamp ? message.timeoutTimestamp.toString() : undefined;
    obj.memo = message.memo;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgTransfer.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/MsgTransfer",
      value: MsgTransfer.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgTransfer.decode(message.value);
  },

  toProto(message) {
    return MsgTransfer.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.applications.transfer.v1.MsgTransfer",
      value: MsgTransfer.encode(message).finish()
    };
  }

};

function createBaseMsgTransferResponse() {
  return {
    sequence: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO
  };
}

const MsgTransferResponse = {
  typeUrl: "/ibc.applications.transfer.v1.MsgTransferResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (!message.sequence.isZero()) {
      writer.uint32(8).uint64(message.sequence);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgTransferResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.sequence = reader.uint64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseMsgTransferResponse();
    message.sequence = object.sequence !== undefined && object.sequence !== null ? _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromValue */ .dK.fromValue(object.sequence) : _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO;
    return message;
  },

  fromAmino(object) {
    return {
      sequence: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromString */ .dK.fromString(object.sequence)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.sequence = message.sequence ? message.sequence.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgTransferResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/MsgTransferResponse",
      value: MsgTransferResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgTransferResponse.decode(message.value);
  },

  toProto(message) {
    return MsgTransferResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.applications.transfer.v1.MsgTransferResponse",
      value: MsgTransferResponse.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 69402:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MsgClientImpl": function() { return /* binding */ MsgClientImpl; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4942);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _tx__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71016);



/** Msg defines the ibc/transfer Msg service. */

class MsgClientImpl {
  constructor(rpc) {
    (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, "rpc", void 0);

    this.rpc = rpc;
    this.transfer = this.transfer.bind(this);
  }

  transfer(request) {
    const data = _tx__WEBPACK_IMPORTED_MODULE_1__.MsgTransfer.encode(request).finish();
    const promise = this.rpc.request("ibc.applications.transfer.v1.Msg", "Transfer", data);
    return promise.then(data => _tx__WEBPACK_IMPORTED_MODULE_1__.MsgTransferResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

}

/***/ }),

/***/ 53624:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Acknowledgement": function() { return /* binding */ Acknowledgement; },
/* harmony export */   "Channel": function() { return /* binding */ Channel; },
/* harmony export */   "Counterparty": function() { return /* binding */ Counterparty; },
/* harmony export */   "IdentifiedChannel": function() { return /* binding */ IdentifiedChannel; },
/* harmony export */   "Order": function() { return /* binding */ Order; },
/* harmony export */   "OrderAmino": function() { return /* binding */ OrderAmino; },
/* harmony export */   "OrderSDKType": function() { return /* binding */ OrderSDKType; },
/* harmony export */   "Packet": function() { return /* binding */ Packet; },
/* harmony export */   "PacketId": function() { return /* binding */ PacketId; },
/* harmony export */   "PacketState": function() { return /* binding */ PacketState; },
/* harmony export */   "State": function() { return /* binding */ State; },
/* harmony export */   "StateAmino": function() { return /* binding */ StateAmino; },
/* harmony export */   "StateSDKType": function() { return /* binding */ StateSDKType; },
/* harmony export */   "orderFromJSON": function() { return /* binding */ orderFromJSON; },
/* harmony export */   "orderToJSON": function() { return /* binding */ orderToJSON; },
/* harmony export */   "stateFromJSON": function() { return /* binding */ stateFromJSON; },
/* harmony export */   "stateToJSON": function() { return /* binding */ stateToJSON; }
/* harmony export */ });
/* harmony import */ var _client_v1_client__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45802);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47895);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__);



/**
 * State defines if a channel is in one of the following states:
 * CLOSED, INIT, TRYOPEN, OPEN or UNINITIALIZED.
 */

let State;

(function (State) {
  State[State["STATE_UNINITIALIZED_UNSPECIFIED"] = 0] = "STATE_UNINITIALIZED_UNSPECIFIED";
  State[State["STATE_INIT"] = 1] = "STATE_INIT";
  State[State["STATE_TRYOPEN"] = 2] = "STATE_TRYOPEN";
  State[State["STATE_OPEN"] = 3] = "STATE_OPEN";
  State[State["STATE_CLOSED"] = 4] = "STATE_CLOSED";
  State[State["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(State || (State = {}));

const StateSDKType = State;
const StateAmino = State;
function stateFromJSON(object) {
  switch (object) {
    case 0:
    case "STATE_UNINITIALIZED_UNSPECIFIED":
      return State.STATE_UNINITIALIZED_UNSPECIFIED;

    case 1:
    case "STATE_INIT":
      return State.STATE_INIT;

    case 2:
    case "STATE_TRYOPEN":
      return State.STATE_TRYOPEN;

    case 3:
    case "STATE_OPEN":
      return State.STATE_OPEN;

    case 4:
    case "STATE_CLOSED":
      return State.STATE_CLOSED;

    case -1:
    case "UNRECOGNIZED":
    default:
      return State.UNRECOGNIZED;
  }
}
function stateToJSON(object) {
  switch (object) {
    case State.STATE_UNINITIALIZED_UNSPECIFIED:
      return "STATE_UNINITIALIZED_UNSPECIFIED";

    case State.STATE_INIT:
      return "STATE_INIT";

    case State.STATE_TRYOPEN:
      return "STATE_TRYOPEN";

    case State.STATE_OPEN:
      return "STATE_OPEN";

    case State.STATE_CLOSED:
      return "STATE_CLOSED";

    case State.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
/** Order defines if a channel is ORDERED or UNORDERED */

let Order;

(function (Order) {
  Order[Order["ORDER_NONE_UNSPECIFIED"] = 0] = "ORDER_NONE_UNSPECIFIED";
  Order[Order["ORDER_UNORDERED"] = 1] = "ORDER_UNORDERED";
  Order[Order["ORDER_ORDERED"] = 2] = "ORDER_ORDERED";
  Order[Order["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(Order || (Order = {}));

const OrderSDKType = Order;
const OrderAmino = Order;
function orderFromJSON(object) {
  switch (object) {
    case 0:
    case "ORDER_NONE_UNSPECIFIED":
      return Order.ORDER_NONE_UNSPECIFIED;

    case 1:
    case "ORDER_UNORDERED":
      return Order.ORDER_UNORDERED;

    case 2:
    case "ORDER_ORDERED":
      return Order.ORDER_ORDERED;

    case -1:
    case "UNRECOGNIZED":
    default:
      return Order.UNRECOGNIZED;
  }
}
function orderToJSON(object) {
  switch (object) {
    case Order.ORDER_NONE_UNSPECIFIED:
      return "ORDER_NONE_UNSPECIFIED";

    case Order.ORDER_UNORDERED:
      return "ORDER_UNORDERED";

    case Order.ORDER_ORDERED:
      return "ORDER_ORDERED";

    case Order.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
/**
 * Channel defines pipeline for exactly-once packet delivery between specific
 * modules on separate blockchains, which has at least one end capable of
 * sending packets and one end capable of receiving packets.
 */

function createBaseChannel() {
  return {
    state: 0,
    ordering: 0,
    counterparty: undefined,
    connectionHops: [],
    version: ""
  };
}

const Channel = {
  typeUrl: "/ibc.core.channel.v1.Channel",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (message.state !== 0) {
      writer.uint32(8).int32(message.state);
    }

    if (message.ordering !== 0) {
      writer.uint32(16).int32(message.ordering);
    }

    if (message.counterparty !== undefined) {
      Counterparty.encode(message.counterparty, writer.uint32(26).fork()).ldelim();
    }

    for (const v of message.connectionHops) {
      writer.uint32(34).string(v);
    }

    if (message.version !== "") {
      writer.uint32(42).string(message.version);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseChannel();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.state = reader.int32();
          break;

        case 2:
          message.ordering = reader.int32();
          break;

        case 3:
          message.counterparty = Counterparty.decode(reader, reader.uint32());
          break;

        case 4:
          message.connectionHops.push(reader.string());
          break;

        case 5:
          message.version = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$state, _object$ordering, _object$connectionHop, _object$version;

    const message = createBaseChannel();
    message.state = (_object$state = object.state) !== null && _object$state !== void 0 ? _object$state : 0;
    message.ordering = (_object$ordering = object.ordering) !== null && _object$ordering !== void 0 ? _object$ordering : 0;
    message.counterparty = object.counterparty !== undefined && object.counterparty !== null ? Counterparty.fromPartial(object.counterparty) : undefined;
    message.connectionHops = ((_object$connectionHop = object.connectionHops) === null || _object$connectionHop === void 0 ? void 0 : _object$connectionHop.map(e => e)) || [];
    message.version = (_object$version = object.version) !== null && _object$version !== void 0 ? _object$version : "";
    return message;
  },

  fromAmino(object) {
    return {
      state: (0,_helpers__WEBPACK_IMPORTED_MODULE_1__/* .isSet */ .DM)(object.state) ? stateFromJSON(object.state) : 0,
      ordering: (0,_helpers__WEBPACK_IMPORTED_MODULE_1__/* .isSet */ .DM)(object.ordering) ? orderFromJSON(object.ordering) : 0,
      counterparty: object !== null && object !== void 0 && object.counterparty ? Counterparty.fromAmino(object.counterparty) : undefined,
      connectionHops: Array.isArray(object === null || object === void 0 ? void 0 : object.connection_hops) ? object.connection_hops.map(e => e) : [],
      version: object.version
    };
  },

  toAmino(message) {
    const obj = {};
    obj.state = message.state;
    obj.ordering = message.ordering;
    obj.counterparty = message.counterparty ? Counterparty.toAmino(message.counterparty) : undefined;

    if (message.connectionHops) {
      obj.connection_hops = message.connectionHops.map(e => e);
    } else {
      obj.connection_hops = [];
    }

    obj.version = message.version;
    return obj;
  },

  fromAminoMsg(object) {
    return Channel.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/Channel",
      value: Channel.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return Channel.decode(message.value);
  },

  toProto(message) {
    return Channel.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.channel.v1.Channel",
      value: Channel.encode(message).finish()
    };
  }

};

function createBaseIdentifiedChannel() {
  return {
    state: 0,
    ordering: 0,
    counterparty: undefined,
    connectionHops: [],
    version: "",
    portId: "",
    channelId: ""
  };
}

const IdentifiedChannel = {
  typeUrl: "/ibc.core.channel.v1.IdentifiedChannel",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (message.state !== 0) {
      writer.uint32(8).int32(message.state);
    }

    if (message.ordering !== 0) {
      writer.uint32(16).int32(message.ordering);
    }

    if (message.counterparty !== undefined) {
      Counterparty.encode(message.counterparty, writer.uint32(26).fork()).ldelim();
    }

    for (const v of message.connectionHops) {
      writer.uint32(34).string(v);
    }

    if (message.version !== "") {
      writer.uint32(42).string(message.version);
    }

    if (message.portId !== "") {
      writer.uint32(50).string(message.portId);
    }

    if (message.channelId !== "") {
      writer.uint32(58).string(message.channelId);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseIdentifiedChannel();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.state = reader.int32();
          break;

        case 2:
          message.ordering = reader.int32();
          break;

        case 3:
          message.counterparty = Counterparty.decode(reader, reader.uint32());
          break;

        case 4:
          message.connectionHops.push(reader.string());
          break;

        case 5:
          message.version = reader.string();
          break;

        case 6:
          message.portId = reader.string();
          break;

        case 7:
          message.channelId = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$state2, _object$ordering2, _object$connectionHop2, _object$version2, _object$portId, _object$channelId;

    const message = createBaseIdentifiedChannel();
    message.state = (_object$state2 = object.state) !== null && _object$state2 !== void 0 ? _object$state2 : 0;
    message.ordering = (_object$ordering2 = object.ordering) !== null && _object$ordering2 !== void 0 ? _object$ordering2 : 0;
    message.counterparty = object.counterparty !== undefined && object.counterparty !== null ? Counterparty.fromPartial(object.counterparty) : undefined;
    message.connectionHops = ((_object$connectionHop2 = object.connectionHops) === null || _object$connectionHop2 === void 0 ? void 0 : _object$connectionHop2.map(e => e)) || [];
    message.version = (_object$version2 = object.version) !== null && _object$version2 !== void 0 ? _object$version2 : "";
    message.portId = (_object$portId = object.portId) !== null && _object$portId !== void 0 ? _object$portId : "";
    message.channelId = (_object$channelId = object.channelId) !== null && _object$channelId !== void 0 ? _object$channelId : "";
    return message;
  },

  fromAmino(object) {
    return {
      state: (0,_helpers__WEBPACK_IMPORTED_MODULE_1__/* .isSet */ .DM)(object.state) ? stateFromJSON(object.state) : 0,
      ordering: (0,_helpers__WEBPACK_IMPORTED_MODULE_1__/* .isSet */ .DM)(object.ordering) ? orderFromJSON(object.ordering) : 0,
      counterparty: object !== null && object !== void 0 && object.counterparty ? Counterparty.fromAmino(object.counterparty) : undefined,
      connectionHops: Array.isArray(object === null || object === void 0 ? void 0 : object.connection_hops) ? object.connection_hops.map(e => e) : [],
      version: object.version,
      portId: object.port_id,
      channelId: object.channel_id
    };
  },

  toAmino(message) {
    const obj = {};
    obj.state = message.state;
    obj.ordering = message.ordering;
    obj.counterparty = message.counterparty ? Counterparty.toAmino(message.counterparty) : undefined;

    if (message.connectionHops) {
      obj.connection_hops = message.connectionHops.map(e => e);
    } else {
      obj.connection_hops = [];
    }

    obj.version = message.version;
    obj.port_id = message.portId;
    obj.channel_id = message.channelId;
    return obj;
  },

  fromAminoMsg(object) {
    return IdentifiedChannel.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/IdentifiedChannel",
      value: IdentifiedChannel.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return IdentifiedChannel.decode(message.value);
  },

  toProto(message) {
    return IdentifiedChannel.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.channel.v1.IdentifiedChannel",
      value: IdentifiedChannel.encode(message).finish()
    };
  }

};

function createBaseCounterparty() {
  return {
    portId: "",
    channelId: ""
  };
}

const Counterparty = {
  typeUrl: "/ibc.core.channel.v1.Counterparty",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (message.portId !== "") {
      writer.uint32(10).string(message.portId);
    }

    if (message.channelId !== "") {
      writer.uint32(18).string(message.channelId);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCounterparty();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.portId = reader.string();
          break;

        case 2:
          message.channelId = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$portId2, _object$channelId2;

    const message = createBaseCounterparty();
    message.portId = (_object$portId2 = object.portId) !== null && _object$portId2 !== void 0 ? _object$portId2 : "";
    message.channelId = (_object$channelId2 = object.channelId) !== null && _object$channelId2 !== void 0 ? _object$channelId2 : "";
    return message;
  },

  fromAmino(object) {
    return {
      portId: object.port_id,
      channelId: object.channel_id
    };
  },

  toAmino(message) {
    const obj = {};
    obj.port_id = message.portId;
    obj.channel_id = message.channelId;
    return obj;
  },

  fromAminoMsg(object) {
    return Counterparty.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/Counterparty",
      value: Counterparty.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return Counterparty.decode(message.value);
  },

  toProto(message) {
    return Counterparty.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.channel.v1.Counterparty",
      value: Counterparty.encode(message).finish()
    };
  }

};

function createBasePacket() {
  return {
    sequence: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.UZERO */ .dK.UZERO,
    sourcePort: "",
    sourceChannel: "",
    destinationPort: "",
    destinationChannel: "",
    data: new Uint8Array(),
    timeoutHeight: undefined,
    timeoutTimestamp: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.UZERO */ .dK.UZERO
  };
}

const Packet = {
  typeUrl: "/ibc.core.channel.v1.Packet",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (!message.sequence.isZero()) {
      writer.uint32(8).uint64(message.sequence);
    }

    if (message.sourcePort !== "") {
      writer.uint32(18).string(message.sourcePort);
    }

    if (message.sourceChannel !== "") {
      writer.uint32(26).string(message.sourceChannel);
    }

    if (message.destinationPort !== "") {
      writer.uint32(34).string(message.destinationPort);
    }

    if (message.destinationChannel !== "") {
      writer.uint32(42).string(message.destinationChannel);
    }

    if (message.data.length !== 0) {
      writer.uint32(50).bytes(message.data);
    }

    if (message.timeoutHeight !== undefined) {
      _client_v1_client__WEBPACK_IMPORTED_MODULE_0__.Height.encode(message.timeoutHeight, writer.uint32(58).fork()).ldelim();
    }

    if (!message.timeoutTimestamp.isZero()) {
      writer.uint32(64).uint64(message.timeoutTimestamp);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePacket();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.sequence = reader.uint64();
          break;

        case 2:
          message.sourcePort = reader.string();
          break;

        case 3:
          message.sourceChannel = reader.string();
          break;

        case 4:
          message.destinationPort = reader.string();
          break;

        case 5:
          message.destinationChannel = reader.string();
          break;

        case 6:
          message.data = reader.bytes();
          break;

        case 7:
          message.timeoutHeight = _client_v1_client__WEBPACK_IMPORTED_MODULE_0__.Height.decode(reader, reader.uint32());
          break;

        case 8:
          message.timeoutTimestamp = reader.uint64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$sourcePort, _object$sourceChannel, _object$destinationPo, _object$destinationCh, _object$data;

    const message = createBasePacket();
    message.sequence = object.sequence !== undefined && object.sequence !== null ? _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromValue */ .dK.fromValue(object.sequence) : _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.UZERO */ .dK.UZERO;
    message.sourcePort = (_object$sourcePort = object.sourcePort) !== null && _object$sourcePort !== void 0 ? _object$sourcePort : "";
    message.sourceChannel = (_object$sourceChannel = object.sourceChannel) !== null && _object$sourceChannel !== void 0 ? _object$sourceChannel : "";
    message.destinationPort = (_object$destinationPo = object.destinationPort) !== null && _object$destinationPo !== void 0 ? _object$destinationPo : "";
    message.destinationChannel = (_object$destinationCh = object.destinationChannel) !== null && _object$destinationCh !== void 0 ? _object$destinationCh : "";
    message.data = (_object$data = object.data) !== null && _object$data !== void 0 ? _object$data : new Uint8Array();
    message.timeoutHeight = object.timeoutHeight !== undefined && object.timeoutHeight !== null ? _client_v1_client__WEBPACK_IMPORTED_MODULE_0__.Height.fromPartial(object.timeoutHeight) : undefined;
    message.timeoutTimestamp = object.timeoutTimestamp !== undefined && object.timeoutTimestamp !== null ? _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromValue */ .dK.fromValue(object.timeoutTimestamp) : _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.UZERO */ .dK.UZERO;
    return message;
  },

  fromAmino(object) {
    return {
      sequence: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromString */ .dK.fromString(object.sequence),
      sourcePort: object.source_port,
      sourceChannel: object.source_channel,
      destinationPort: object.destination_port,
      destinationChannel: object.destination_channel,
      data: object.data,
      timeoutHeight: object !== null && object !== void 0 && object.timeout_height ? _client_v1_client__WEBPACK_IMPORTED_MODULE_0__.Height.fromAmino(object.timeout_height) : undefined,
      timeoutTimestamp: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromString */ .dK.fromString(object.timeout_timestamp)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.sequence = message.sequence ? message.sequence.toString() : undefined;
    obj.source_port = message.sourcePort;
    obj.source_channel = message.sourceChannel;
    obj.destination_port = message.destinationPort;
    obj.destination_channel = message.destinationChannel;
    obj.data = message.data;
    obj.timeout_height = message.timeoutHeight ? _client_v1_client__WEBPACK_IMPORTED_MODULE_0__.Height.toAmino(message.timeoutHeight) : {};
    obj.timeout_timestamp = message.timeoutTimestamp ? message.timeoutTimestamp.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return Packet.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/Packet",
      value: Packet.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return Packet.decode(message.value);
  },

  toProto(message) {
    return Packet.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.channel.v1.Packet",
      value: Packet.encode(message).finish()
    };
  }

};

function createBasePacketState() {
  return {
    portId: "",
    channelId: "",
    sequence: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.UZERO */ .dK.UZERO,
    data: new Uint8Array()
  };
}

const PacketState = {
  typeUrl: "/ibc.core.channel.v1.PacketState",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (message.portId !== "") {
      writer.uint32(10).string(message.portId);
    }

    if (message.channelId !== "") {
      writer.uint32(18).string(message.channelId);
    }

    if (!message.sequence.isZero()) {
      writer.uint32(24).uint64(message.sequence);
    }

    if (message.data.length !== 0) {
      writer.uint32(34).bytes(message.data);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePacketState();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.portId = reader.string();
          break;

        case 2:
          message.channelId = reader.string();
          break;

        case 3:
          message.sequence = reader.uint64();
          break;

        case 4:
          message.data = reader.bytes();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$portId3, _object$channelId3, _object$data2;

    const message = createBasePacketState();
    message.portId = (_object$portId3 = object.portId) !== null && _object$portId3 !== void 0 ? _object$portId3 : "";
    message.channelId = (_object$channelId3 = object.channelId) !== null && _object$channelId3 !== void 0 ? _object$channelId3 : "";
    message.sequence = object.sequence !== undefined && object.sequence !== null ? _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromValue */ .dK.fromValue(object.sequence) : _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.UZERO */ .dK.UZERO;
    message.data = (_object$data2 = object.data) !== null && _object$data2 !== void 0 ? _object$data2 : new Uint8Array();
    return message;
  },

  fromAmino(object) {
    return {
      portId: object.port_id,
      channelId: object.channel_id,
      sequence: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromString */ .dK.fromString(object.sequence),
      data: object.data
    };
  },

  toAmino(message) {
    const obj = {};
    obj.port_id = message.portId;
    obj.channel_id = message.channelId;
    obj.sequence = message.sequence ? message.sequence.toString() : undefined;
    obj.data = message.data;
    return obj;
  },

  fromAminoMsg(object) {
    return PacketState.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/PacketState",
      value: PacketState.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return PacketState.decode(message.value);
  },

  toProto(message) {
    return PacketState.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.channel.v1.PacketState",
      value: PacketState.encode(message).finish()
    };
  }

};

function createBasePacketId() {
  return {
    portId: "",
    channelId: "",
    sequence: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.UZERO */ .dK.UZERO
  };
}

const PacketId = {
  typeUrl: "/ibc.core.channel.v1.PacketId",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (message.portId !== "") {
      writer.uint32(10).string(message.portId);
    }

    if (message.channelId !== "") {
      writer.uint32(18).string(message.channelId);
    }

    if (!message.sequence.isZero()) {
      writer.uint32(24).uint64(message.sequence);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePacketId();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.portId = reader.string();
          break;

        case 2:
          message.channelId = reader.string();
          break;

        case 3:
          message.sequence = reader.uint64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$portId4, _object$channelId4;

    const message = createBasePacketId();
    message.portId = (_object$portId4 = object.portId) !== null && _object$portId4 !== void 0 ? _object$portId4 : "";
    message.channelId = (_object$channelId4 = object.channelId) !== null && _object$channelId4 !== void 0 ? _object$channelId4 : "";
    message.sequence = object.sequence !== undefined && object.sequence !== null ? _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromValue */ .dK.fromValue(object.sequence) : _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.UZERO */ .dK.UZERO;
    return message;
  },

  fromAmino(object) {
    return {
      portId: object.port_id,
      channelId: object.channel_id,
      sequence: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromString */ .dK.fromString(object.sequence)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.port_id = message.portId;
    obj.channel_id = message.channelId;
    obj.sequence = message.sequence ? message.sequence.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return PacketId.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/PacketId",
      value: PacketId.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return PacketId.decode(message.value);
  },

  toProto(message) {
    return PacketId.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.channel.v1.PacketId",
      value: PacketId.encode(message).finish()
    };
  }

};

function createBaseAcknowledgement() {
  return {
    result: undefined,
    error: undefined
  };
}

const Acknowledgement = {
  typeUrl: "/ibc.core.channel.v1.Acknowledgement",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (message.result !== undefined) {
      writer.uint32(170).bytes(message.result);
    }

    if (message.error !== undefined) {
      writer.uint32(178).string(message.error);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAcknowledgement();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 21:
          message.result = reader.bytes();
          break;

        case 22:
          message.error = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$result, _object$error;

    const message = createBaseAcknowledgement();
    message.result = (_object$result = object.result) !== null && _object$result !== void 0 ? _object$result : undefined;
    message.error = (_object$error = object.error) !== null && _object$error !== void 0 ? _object$error : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      result: object === null || object === void 0 ? void 0 : object.result,
      error: object === null || object === void 0 ? void 0 : object.error
    };
  },

  toAmino(message) {
    const obj = {};
    obj.result = message.result;
    obj.error = message.error;
    return obj;
  },

  fromAminoMsg(object) {
    return Acknowledgement.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/Acknowledgement",
      value: Acknowledgement.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return Acknowledgement.decode(message.value);
  },

  toProto(message) {
    return Acknowledgement.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.channel.v1.Acknowledgement",
      value: Acknowledgement.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 28397:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QueryChannelClientStateRequest": function() { return /* binding */ QueryChannelClientStateRequest; },
/* harmony export */   "QueryChannelClientStateResponse": function() { return /* binding */ QueryChannelClientStateResponse; },
/* harmony export */   "QueryChannelConsensusStateRequest": function() { return /* binding */ QueryChannelConsensusStateRequest; },
/* harmony export */   "QueryChannelConsensusStateResponse": function() { return /* binding */ QueryChannelConsensusStateResponse; },
/* harmony export */   "QueryChannelRequest": function() { return /* binding */ QueryChannelRequest; },
/* harmony export */   "QueryChannelResponse": function() { return /* binding */ QueryChannelResponse; },
/* harmony export */   "QueryChannelsRequest": function() { return /* binding */ QueryChannelsRequest; },
/* harmony export */   "QueryChannelsResponse": function() { return /* binding */ QueryChannelsResponse; },
/* harmony export */   "QueryConnectionChannelsRequest": function() { return /* binding */ QueryConnectionChannelsRequest; },
/* harmony export */   "QueryConnectionChannelsResponse": function() { return /* binding */ QueryConnectionChannelsResponse; },
/* harmony export */   "QueryNextSequenceReceiveRequest": function() { return /* binding */ QueryNextSequenceReceiveRequest; },
/* harmony export */   "QueryNextSequenceReceiveResponse": function() { return /* binding */ QueryNextSequenceReceiveResponse; },
/* harmony export */   "QueryPacketAcknowledgementRequest": function() { return /* binding */ QueryPacketAcknowledgementRequest; },
/* harmony export */   "QueryPacketAcknowledgementResponse": function() { return /* binding */ QueryPacketAcknowledgementResponse; },
/* harmony export */   "QueryPacketAcknowledgementsRequest": function() { return /* binding */ QueryPacketAcknowledgementsRequest; },
/* harmony export */   "QueryPacketAcknowledgementsResponse": function() { return /* binding */ QueryPacketAcknowledgementsResponse; },
/* harmony export */   "QueryPacketCommitmentRequest": function() { return /* binding */ QueryPacketCommitmentRequest; },
/* harmony export */   "QueryPacketCommitmentResponse": function() { return /* binding */ QueryPacketCommitmentResponse; },
/* harmony export */   "QueryPacketCommitmentsRequest": function() { return /* binding */ QueryPacketCommitmentsRequest; },
/* harmony export */   "QueryPacketCommitmentsResponse": function() { return /* binding */ QueryPacketCommitmentsResponse; },
/* harmony export */   "QueryPacketReceiptRequest": function() { return /* binding */ QueryPacketReceiptRequest; },
/* harmony export */   "QueryPacketReceiptResponse": function() { return /* binding */ QueryPacketReceiptResponse; },
/* harmony export */   "QueryUnreceivedAcksRequest": function() { return /* binding */ QueryUnreceivedAcksRequest; },
/* harmony export */   "QueryUnreceivedAcksResponse": function() { return /* binding */ QueryUnreceivedAcksResponse; },
/* harmony export */   "QueryUnreceivedPacketsRequest": function() { return /* binding */ QueryUnreceivedPacketsRequest; },
/* harmony export */   "QueryUnreceivedPacketsResponse": function() { return /* binding */ QueryUnreceivedPacketsResponse; }
/* harmony export */ });
/* harmony import */ var _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48978);
/* harmony import */ var _channel__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53624);
/* harmony import */ var _client_v1_client__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45802);
/* harmony import */ var _google_protobuf_any__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32106);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47895);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__);






/** QueryChannelRequest is the request type for the Query/Channel RPC method */

function createBaseQueryChannelRequest() {
  return {
    portId: "",
    channelId: ""
  };
}

const QueryChannelRequest = {
  typeUrl: "/ibc.core.channel.v1.QueryChannelRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Writer.create()) {
    if (message.portId !== "") {
      writer.uint32(10).string(message.portId);
    }

    if (message.channelId !== "") {
      writer.uint32(18).string(message.channelId);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryChannelRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.portId = reader.string();
          break;

        case 2:
          message.channelId = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$portId, _object$channelId;

    const message = createBaseQueryChannelRequest();
    message.portId = (_object$portId = object.portId) !== null && _object$portId !== void 0 ? _object$portId : "";
    message.channelId = (_object$channelId = object.channelId) !== null && _object$channelId !== void 0 ? _object$channelId : "";
    return message;
  },

  fromAmino(object) {
    return {
      portId: object.port_id,
      channelId: object.channel_id
    };
  },

  toAmino(message) {
    const obj = {};
    obj.port_id = message.portId;
    obj.channel_id = message.channelId;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryChannelRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryChannelRequest",
      value: QueryChannelRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryChannelRequest.decode(message.value);
  },

  toProto(message) {
    return QueryChannelRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.channel.v1.QueryChannelRequest",
      value: QueryChannelRequest.encode(message).finish()
    };
  }

};

function createBaseQueryChannelResponse() {
  return {
    channel: undefined,
    proof: new Uint8Array(),
    proofHeight: undefined
  };
}

const QueryChannelResponse = {
  typeUrl: "/ibc.core.channel.v1.QueryChannelResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Writer.create()) {
    if (message.channel !== undefined) {
      _channel__WEBPACK_IMPORTED_MODULE_1__.Channel.encode(message.channel, writer.uint32(10).fork()).ldelim();
    }

    if (message.proof.length !== 0) {
      writer.uint32(18).bytes(message.proof);
    }

    if (message.proofHeight !== undefined) {
      _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.encode(message.proofHeight, writer.uint32(26).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryChannelResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.channel = _channel__WEBPACK_IMPORTED_MODULE_1__.Channel.decode(reader, reader.uint32());
          break;

        case 2:
          message.proof = reader.bytes();
          break;

        case 3:
          message.proofHeight = _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$proof;

    const message = createBaseQueryChannelResponse();
    message.channel = object.channel !== undefined && object.channel !== null ? _channel__WEBPACK_IMPORTED_MODULE_1__.Channel.fromPartial(object.channel) : undefined;
    message.proof = (_object$proof = object.proof) !== null && _object$proof !== void 0 ? _object$proof : new Uint8Array();
    message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.fromPartial(object.proofHeight) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      channel: object !== null && object !== void 0 && object.channel ? _channel__WEBPACK_IMPORTED_MODULE_1__.Channel.fromAmino(object.channel) : undefined,
      proof: object.proof,
      proofHeight: object !== null && object !== void 0 && object.proof_height ? _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.fromAmino(object.proof_height) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.channel = message.channel ? _channel__WEBPACK_IMPORTED_MODULE_1__.Channel.toAmino(message.channel) : undefined;
    obj.proof = message.proof;
    obj.proof_height = message.proofHeight ? _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.toAmino(message.proofHeight) : {};
    return obj;
  },

  fromAminoMsg(object) {
    return QueryChannelResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryChannelResponse",
      value: QueryChannelResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryChannelResponse.decode(message.value);
  },

  toProto(message) {
    return QueryChannelResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.channel.v1.QueryChannelResponse",
      value: QueryChannelResponse.encode(message).finish()
    };
  }

};

function createBaseQueryChannelsRequest() {
  return {
    pagination: undefined
  };
}

const QueryChannelsRequest = {
  typeUrl: "/ibc.core.channel.v1.QueryChannelsRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Writer.create()) {
    if (message.pagination !== undefined) {
      _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryChannelsRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.pagination = _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseQueryChannelsRequest();
    message.pagination = object.pagination !== undefined && object.pagination !== null ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.fromPartial(object.pagination) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      pagination: object !== null && object !== void 0 && object.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.fromAmino(object.pagination) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.pagination = message.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.toAmino(message.pagination) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryChannelsRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryChannelsRequest",
      value: QueryChannelsRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryChannelsRequest.decode(message.value);
  },

  toProto(message) {
    return QueryChannelsRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.channel.v1.QueryChannelsRequest",
      value: QueryChannelsRequest.encode(message).finish()
    };
  }

};

function createBaseQueryChannelsResponse() {
  return {
    channels: [],
    pagination: undefined,
    height: undefined
  };
}

const QueryChannelsResponse = {
  typeUrl: "/ibc.core.channel.v1.QueryChannelsResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Writer.create()) {
    for (const v of message.channels) {
      _channel__WEBPACK_IMPORTED_MODULE_1__.IdentifiedChannel.encode(v, writer.uint32(10).fork()).ldelim();
    }

    if (message.pagination !== undefined) {
      _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
    }

    if (message.height !== undefined) {
      _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.encode(message.height, writer.uint32(26).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryChannelsResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.channels.push(_channel__WEBPACK_IMPORTED_MODULE_1__.IdentifiedChannel.decode(reader, reader.uint32()));
          break;

        case 2:
          message.pagination = _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.decode(reader, reader.uint32());
          break;

        case 3:
          message.height = _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$channels;

    const message = createBaseQueryChannelsResponse();
    message.channels = ((_object$channels = object.channels) === null || _object$channels === void 0 ? void 0 : _object$channels.map(e => _channel__WEBPACK_IMPORTED_MODULE_1__.IdentifiedChannel.fromPartial(e))) || [];
    message.pagination = object.pagination !== undefined && object.pagination !== null ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.fromPartial(object.pagination) : undefined;
    message.height = object.height !== undefined && object.height !== null ? _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.fromPartial(object.height) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      channels: Array.isArray(object === null || object === void 0 ? void 0 : object.channels) ? object.channels.map(e => _channel__WEBPACK_IMPORTED_MODULE_1__.IdentifiedChannel.fromAmino(e)) : [],
      pagination: object !== null && object !== void 0 && object.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.fromAmino(object.pagination) : undefined,
      height: object !== null && object !== void 0 && object.height ? _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.fromAmino(object.height) : undefined
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.channels) {
      obj.channels = message.channels.map(e => e ? _channel__WEBPACK_IMPORTED_MODULE_1__.IdentifiedChannel.toAmino(e) : undefined);
    } else {
      obj.channels = [];
    }

    obj.pagination = message.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.toAmino(message.pagination) : undefined;
    obj.height = message.height ? _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.toAmino(message.height) : {};
    return obj;
  },

  fromAminoMsg(object) {
    return QueryChannelsResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryChannelsResponse",
      value: QueryChannelsResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryChannelsResponse.decode(message.value);
  },

  toProto(message) {
    return QueryChannelsResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.channel.v1.QueryChannelsResponse",
      value: QueryChannelsResponse.encode(message).finish()
    };
  }

};

function createBaseQueryConnectionChannelsRequest() {
  return {
    connection: "",
    pagination: undefined
  };
}

const QueryConnectionChannelsRequest = {
  typeUrl: "/ibc.core.channel.v1.QueryConnectionChannelsRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Writer.create()) {
    if (message.connection !== "") {
      writer.uint32(10).string(message.connection);
    }

    if (message.pagination !== undefined) {
      _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryConnectionChannelsRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.connection = reader.string();
          break;

        case 2:
          message.pagination = _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$connection;

    const message = createBaseQueryConnectionChannelsRequest();
    message.connection = (_object$connection = object.connection) !== null && _object$connection !== void 0 ? _object$connection : "";
    message.pagination = object.pagination !== undefined && object.pagination !== null ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.fromPartial(object.pagination) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      connection: object.connection,
      pagination: object !== null && object !== void 0 && object.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.fromAmino(object.pagination) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.connection = message.connection;
    obj.pagination = message.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.toAmino(message.pagination) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryConnectionChannelsRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryConnectionChannelsRequest",
      value: QueryConnectionChannelsRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryConnectionChannelsRequest.decode(message.value);
  },

  toProto(message) {
    return QueryConnectionChannelsRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.channel.v1.QueryConnectionChannelsRequest",
      value: QueryConnectionChannelsRequest.encode(message).finish()
    };
  }

};

function createBaseQueryConnectionChannelsResponse() {
  return {
    channels: [],
    pagination: undefined,
    height: undefined
  };
}

const QueryConnectionChannelsResponse = {
  typeUrl: "/ibc.core.channel.v1.QueryConnectionChannelsResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Writer.create()) {
    for (const v of message.channels) {
      _channel__WEBPACK_IMPORTED_MODULE_1__.IdentifiedChannel.encode(v, writer.uint32(10).fork()).ldelim();
    }

    if (message.pagination !== undefined) {
      _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
    }

    if (message.height !== undefined) {
      _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.encode(message.height, writer.uint32(26).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryConnectionChannelsResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.channels.push(_channel__WEBPACK_IMPORTED_MODULE_1__.IdentifiedChannel.decode(reader, reader.uint32()));
          break;

        case 2:
          message.pagination = _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.decode(reader, reader.uint32());
          break;

        case 3:
          message.height = _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$channels2;

    const message = createBaseQueryConnectionChannelsResponse();
    message.channels = ((_object$channels2 = object.channels) === null || _object$channels2 === void 0 ? void 0 : _object$channels2.map(e => _channel__WEBPACK_IMPORTED_MODULE_1__.IdentifiedChannel.fromPartial(e))) || [];
    message.pagination = object.pagination !== undefined && object.pagination !== null ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.fromPartial(object.pagination) : undefined;
    message.height = object.height !== undefined && object.height !== null ? _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.fromPartial(object.height) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      channels: Array.isArray(object === null || object === void 0 ? void 0 : object.channels) ? object.channels.map(e => _channel__WEBPACK_IMPORTED_MODULE_1__.IdentifiedChannel.fromAmino(e)) : [],
      pagination: object !== null && object !== void 0 && object.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.fromAmino(object.pagination) : undefined,
      height: object !== null && object !== void 0 && object.height ? _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.fromAmino(object.height) : undefined
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.channels) {
      obj.channels = message.channels.map(e => e ? _channel__WEBPACK_IMPORTED_MODULE_1__.IdentifiedChannel.toAmino(e) : undefined);
    } else {
      obj.channels = [];
    }

    obj.pagination = message.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.toAmino(message.pagination) : undefined;
    obj.height = message.height ? _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.toAmino(message.height) : {};
    return obj;
  },

  fromAminoMsg(object) {
    return QueryConnectionChannelsResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryConnectionChannelsResponse",
      value: QueryConnectionChannelsResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryConnectionChannelsResponse.decode(message.value);
  },

  toProto(message) {
    return QueryConnectionChannelsResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.channel.v1.QueryConnectionChannelsResponse",
      value: QueryConnectionChannelsResponse.encode(message).finish()
    };
  }

};

function createBaseQueryChannelClientStateRequest() {
  return {
    portId: "",
    channelId: ""
  };
}

const QueryChannelClientStateRequest = {
  typeUrl: "/ibc.core.channel.v1.QueryChannelClientStateRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Writer.create()) {
    if (message.portId !== "") {
      writer.uint32(10).string(message.portId);
    }

    if (message.channelId !== "") {
      writer.uint32(18).string(message.channelId);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryChannelClientStateRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.portId = reader.string();
          break;

        case 2:
          message.channelId = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$portId2, _object$channelId2;

    const message = createBaseQueryChannelClientStateRequest();
    message.portId = (_object$portId2 = object.portId) !== null && _object$portId2 !== void 0 ? _object$portId2 : "";
    message.channelId = (_object$channelId2 = object.channelId) !== null && _object$channelId2 !== void 0 ? _object$channelId2 : "";
    return message;
  },

  fromAmino(object) {
    return {
      portId: object.port_id,
      channelId: object.channel_id
    };
  },

  toAmino(message) {
    const obj = {};
    obj.port_id = message.portId;
    obj.channel_id = message.channelId;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryChannelClientStateRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryChannelClientStateRequest",
      value: QueryChannelClientStateRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryChannelClientStateRequest.decode(message.value);
  },

  toProto(message) {
    return QueryChannelClientStateRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.channel.v1.QueryChannelClientStateRequest",
      value: QueryChannelClientStateRequest.encode(message).finish()
    };
  }

};

function createBaseQueryChannelClientStateResponse() {
  return {
    identifiedClientState: undefined,
    proof: new Uint8Array(),
    proofHeight: undefined
  };
}

const QueryChannelClientStateResponse = {
  typeUrl: "/ibc.core.channel.v1.QueryChannelClientStateResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Writer.create()) {
    if (message.identifiedClientState !== undefined) {
      _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.IdentifiedClientState.encode(message.identifiedClientState, writer.uint32(10).fork()).ldelim();
    }

    if (message.proof.length !== 0) {
      writer.uint32(18).bytes(message.proof);
    }

    if (message.proofHeight !== undefined) {
      _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.encode(message.proofHeight, writer.uint32(26).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryChannelClientStateResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.identifiedClientState = _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.IdentifiedClientState.decode(reader, reader.uint32());
          break;

        case 2:
          message.proof = reader.bytes();
          break;

        case 3:
          message.proofHeight = _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$proof2;

    const message = createBaseQueryChannelClientStateResponse();
    message.identifiedClientState = object.identifiedClientState !== undefined && object.identifiedClientState !== null ? _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.IdentifiedClientState.fromPartial(object.identifiedClientState) : undefined;
    message.proof = (_object$proof2 = object.proof) !== null && _object$proof2 !== void 0 ? _object$proof2 : new Uint8Array();
    message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.fromPartial(object.proofHeight) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      identifiedClientState: object !== null && object !== void 0 && object.identified_client_state ? _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.IdentifiedClientState.fromAmino(object.identified_client_state) : undefined,
      proof: object.proof,
      proofHeight: object !== null && object !== void 0 && object.proof_height ? _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.fromAmino(object.proof_height) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.identified_client_state = message.identifiedClientState ? _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.IdentifiedClientState.toAmino(message.identifiedClientState) : undefined;
    obj.proof = message.proof;
    obj.proof_height = message.proofHeight ? _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.toAmino(message.proofHeight) : {};
    return obj;
  },

  fromAminoMsg(object) {
    return QueryChannelClientStateResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryChannelClientStateResponse",
      value: QueryChannelClientStateResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryChannelClientStateResponse.decode(message.value);
  },

  toProto(message) {
    return QueryChannelClientStateResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.channel.v1.QueryChannelClientStateResponse",
      value: QueryChannelClientStateResponse.encode(message).finish()
    };
  }

};

function createBaseQueryChannelConsensusStateRequest() {
  return {
    portId: "",
    channelId: "",
    revisionNumber: _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.UZERO */ .dK.UZERO,
    revisionHeight: _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.UZERO */ .dK.UZERO
  };
}

const QueryChannelConsensusStateRequest = {
  typeUrl: "/ibc.core.channel.v1.QueryChannelConsensusStateRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Writer.create()) {
    if (message.portId !== "") {
      writer.uint32(10).string(message.portId);
    }

    if (message.channelId !== "") {
      writer.uint32(18).string(message.channelId);
    }

    if (!message.revisionNumber.isZero()) {
      writer.uint32(24).uint64(message.revisionNumber);
    }

    if (!message.revisionHeight.isZero()) {
      writer.uint32(32).uint64(message.revisionHeight);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryChannelConsensusStateRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.portId = reader.string();
          break;

        case 2:
          message.channelId = reader.string();
          break;

        case 3:
          message.revisionNumber = reader.uint64();
          break;

        case 4:
          message.revisionHeight = reader.uint64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$portId3, _object$channelId3;

    const message = createBaseQueryChannelConsensusStateRequest();
    message.portId = (_object$portId3 = object.portId) !== null && _object$portId3 !== void 0 ? _object$portId3 : "";
    message.channelId = (_object$channelId3 = object.channelId) !== null && _object$channelId3 !== void 0 ? _object$channelId3 : "";
    message.revisionNumber = object.revisionNumber !== undefined && object.revisionNumber !== null ? _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.fromValue */ .dK.fromValue(object.revisionNumber) : _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.UZERO */ .dK.UZERO;
    message.revisionHeight = object.revisionHeight !== undefined && object.revisionHeight !== null ? _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.fromValue */ .dK.fromValue(object.revisionHeight) : _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.UZERO */ .dK.UZERO;
    return message;
  },

  fromAmino(object) {
    return {
      portId: object.port_id,
      channelId: object.channel_id,
      revisionNumber: _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.fromString */ .dK.fromString(object.revision_number),
      revisionHeight: _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.fromString */ .dK.fromString(object.revision_height)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.port_id = message.portId;
    obj.channel_id = message.channelId;
    obj.revision_number = message.revisionNumber ? message.revisionNumber.toString() : undefined;
    obj.revision_height = message.revisionHeight ? message.revisionHeight.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryChannelConsensusStateRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryChannelConsensusStateRequest",
      value: QueryChannelConsensusStateRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryChannelConsensusStateRequest.decode(message.value);
  },

  toProto(message) {
    return QueryChannelConsensusStateRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.channel.v1.QueryChannelConsensusStateRequest",
      value: QueryChannelConsensusStateRequest.encode(message).finish()
    };
  }

};

function createBaseQueryChannelConsensusStateResponse() {
  return {
    consensusState: undefined,
    clientId: "",
    proof: new Uint8Array(),
    proofHeight: undefined
  };
}

const QueryChannelConsensusStateResponse = {
  typeUrl: "/ibc.core.channel.v1.QueryChannelConsensusStateResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Writer.create()) {
    if (message.consensusState !== undefined) {
      _google_protobuf_any__WEBPACK_IMPORTED_MODULE_3__.Any.encode(message.consensusState, writer.uint32(10).fork()).ldelim();
    }

    if (message.clientId !== "") {
      writer.uint32(18).string(message.clientId);
    }

    if (message.proof.length !== 0) {
      writer.uint32(26).bytes(message.proof);
    }

    if (message.proofHeight !== undefined) {
      _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.encode(message.proofHeight, writer.uint32(34).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryChannelConsensusStateResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.consensusState = _google_protobuf_any__WEBPACK_IMPORTED_MODULE_3__.Any.decode(reader, reader.uint32());
          break;

        case 2:
          message.clientId = reader.string();
          break;

        case 3:
          message.proof = reader.bytes();
          break;

        case 4:
          message.proofHeight = _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$clientId, _object$proof3;

    const message = createBaseQueryChannelConsensusStateResponse();
    message.consensusState = object.consensusState !== undefined && object.consensusState !== null ? _google_protobuf_any__WEBPACK_IMPORTED_MODULE_3__.Any.fromPartial(object.consensusState) : undefined;
    message.clientId = (_object$clientId = object.clientId) !== null && _object$clientId !== void 0 ? _object$clientId : "";
    message.proof = (_object$proof3 = object.proof) !== null && _object$proof3 !== void 0 ? _object$proof3 : new Uint8Array();
    message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.fromPartial(object.proofHeight) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      consensusState: object !== null && object !== void 0 && object.consensus_state ? _google_protobuf_any__WEBPACK_IMPORTED_MODULE_3__.Any.fromAmino(object.consensus_state) : undefined,
      clientId: object.client_id,
      proof: object.proof,
      proofHeight: object !== null && object !== void 0 && object.proof_height ? _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.fromAmino(object.proof_height) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.consensus_state = message.consensusState ? _google_protobuf_any__WEBPACK_IMPORTED_MODULE_3__.Any.toAmino(message.consensusState) : undefined;
    obj.client_id = message.clientId;
    obj.proof = message.proof;
    obj.proof_height = message.proofHeight ? _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.toAmino(message.proofHeight) : {};
    return obj;
  },

  fromAminoMsg(object) {
    return QueryChannelConsensusStateResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryChannelConsensusStateResponse",
      value: QueryChannelConsensusStateResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryChannelConsensusStateResponse.decode(message.value);
  },

  toProto(message) {
    return QueryChannelConsensusStateResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.channel.v1.QueryChannelConsensusStateResponse",
      value: QueryChannelConsensusStateResponse.encode(message).finish()
    };
  }

};

function createBaseQueryPacketCommitmentRequest() {
  return {
    portId: "",
    channelId: "",
    sequence: _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.UZERO */ .dK.UZERO
  };
}

const QueryPacketCommitmentRequest = {
  typeUrl: "/ibc.core.channel.v1.QueryPacketCommitmentRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Writer.create()) {
    if (message.portId !== "") {
      writer.uint32(10).string(message.portId);
    }

    if (message.channelId !== "") {
      writer.uint32(18).string(message.channelId);
    }

    if (!message.sequence.isZero()) {
      writer.uint32(24).uint64(message.sequence);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryPacketCommitmentRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.portId = reader.string();
          break;

        case 2:
          message.channelId = reader.string();
          break;

        case 3:
          message.sequence = reader.uint64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$portId4, _object$channelId4;

    const message = createBaseQueryPacketCommitmentRequest();
    message.portId = (_object$portId4 = object.portId) !== null && _object$portId4 !== void 0 ? _object$portId4 : "";
    message.channelId = (_object$channelId4 = object.channelId) !== null && _object$channelId4 !== void 0 ? _object$channelId4 : "";
    message.sequence = object.sequence !== undefined && object.sequence !== null ? _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.fromValue */ .dK.fromValue(object.sequence) : _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.UZERO */ .dK.UZERO;
    return message;
  },

  fromAmino(object) {
    return {
      portId: object.port_id,
      channelId: object.channel_id,
      sequence: _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.fromString */ .dK.fromString(object.sequence)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.port_id = message.portId;
    obj.channel_id = message.channelId;
    obj.sequence = message.sequence ? message.sequence.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryPacketCommitmentRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryPacketCommitmentRequest",
      value: QueryPacketCommitmentRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryPacketCommitmentRequest.decode(message.value);
  },

  toProto(message) {
    return QueryPacketCommitmentRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.channel.v1.QueryPacketCommitmentRequest",
      value: QueryPacketCommitmentRequest.encode(message).finish()
    };
  }

};

function createBaseQueryPacketCommitmentResponse() {
  return {
    commitment: new Uint8Array(),
    proof: new Uint8Array(),
    proofHeight: undefined
  };
}

const QueryPacketCommitmentResponse = {
  typeUrl: "/ibc.core.channel.v1.QueryPacketCommitmentResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Writer.create()) {
    if (message.commitment.length !== 0) {
      writer.uint32(10).bytes(message.commitment);
    }

    if (message.proof.length !== 0) {
      writer.uint32(18).bytes(message.proof);
    }

    if (message.proofHeight !== undefined) {
      _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.encode(message.proofHeight, writer.uint32(26).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryPacketCommitmentResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.commitment = reader.bytes();
          break;

        case 2:
          message.proof = reader.bytes();
          break;

        case 3:
          message.proofHeight = _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$commitment, _object$proof4;

    const message = createBaseQueryPacketCommitmentResponse();
    message.commitment = (_object$commitment = object.commitment) !== null && _object$commitment !== void 0 ? _object$commitment : new Uint8Array();
    message.proof = (_object$proof4 = object.proof) !== null && _object$proof4 !== void 0 ? _object$proof4 : new Uint8Array();
    message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.fromPartial(object.proofHeight) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      commitment: object.commitment,
      proof: object.proof,
      proofHeight: object !== null && object !== void 0 && object.proof_height ? _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.fromAmino(object.proof_height) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.commitment = message.commitment;
    obj.proof = message.proof;
    obj.proof_height = message.proofHeight ? _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.toAmino(message.proofHeight) : {};
    return obj;
  },

  fromAminoMsg(object) {
    return QueryPacketCommitmentResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryPacketCommitmentResponse",
      value: QueryPacketCommitmentResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryPacketCommitmentResponse.decode(message.value);
  },

  toProto(message) {
    return QueryPacketCommitmentResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.channel.v1.QueryPacketCommitmentResponse",
      value: QueryPacketCommitmentResponse.encode(message).finish()
    };
  }

};

function createBaseQueryPacketCommitmentsRequest() {
  return {
    portId: "",
    channelId: "",
    pagination: undefined
  };
}

const QueryPacketCommitmentsRequest = {
  typeUrl: "/ibc.core.channel.v1.QueryPacketCommitmentsRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Writer.create()) {
    if (message.portId !== "") {
      writer.uint32(10).string(message.portId);
    }

    if (message.channelId !== "") {
      writer.uint32(18).string(message.channelId);
    }

    if (message.pagination !== undefined) {
      _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.encode(message.pagination, writer.uint32(26).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryPacketCommitmentsRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.portId = reader.string();
          break;

        case 2:
          message.channelId = reader.string();
          break;

        case 3:
          message.pagination = _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$portId5, _object$channelId5;

    const message = createBaseQueryPacketCommitmentsRequest();
    message.portId = (_object$portId5 = object.portId) !== null && _object$portId5 !== void 0 ? _object$portId5 : "";
    message.channelId = (_object$channelId5 = object.channelId) !== null && _object$channelId5 !== void 0 ? _object$channelId5 : "";
    message.pagination = object.pagination !== undefined && object.pagination !== null ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.fromPartial(object.pagination) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      portId: object.port_id,
      channelId: object.channel_id,
      pagination: object !== null && object !== void 0 && object.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.fromAmino(object.pagination) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.port_id = message.portId;
    obj.channel_id = message.channelId;
    obj.pagination = message.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.toAmino(message.pagination) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryPacketCommitmentsRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryPacketCommitmentsRequest",
      value: QueryPacketCommitmentsRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryPacketCommitmentsRequest.decode(message.value);
  },

  toProto(message) {
    return QueryPacketCommitmentsRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.channel.v1.QueryPacketCommitmentsRequest",
      value: QueryPacketCommitmentsRequest.encode(message).finish()
    };
  }

};

function createBaseQueryPacketCommitmentsResponse() {
  return {
    commitments: [],
    pagination: undefined,
    height: undefined
  };
}

const QueryPacketCommitmentsResponse = {
  typeUrl: "/ibc.core.channel.v1.QueryPacketCommitmentsResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Writer.create()) {
    for (const v of message.commitments) {
      _channel__WEBPACK_IMPORTED_MODULE_1__.PacketState.encode(v, writer.uint32(10).fork()).ldelim();
    }

    if (message.pagination !== undefined) {
      _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
    }

    if (message.height !== undefined) {
      _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.encode(message.height, writer.uint32(26).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryPacketCommitmentsResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.commitments.push(_channel__WEBPACK_IMPORTED_MODULE_1__.PacketState.decode(reader, reader.uint32()));
          break;

        case 2:
          message.pagination = _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.decode(reader, reader.uint32());
          break;

        case 3:
          message.height = _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$commitments;

    const message = createBaseQueryPacketCommitmentsResponse();
    message.commitments = ((_object$commitments = object.commitments) === null || _object$commitments === void 0 ? void 0 : _object$commitments.map(e => _channel__WEBPACK_IMPORTED_MODULE_1__.PacketState.fromPartial(e))) || [];
    message.pagination = object.pagination !== undefined && object.pagination !== null ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.fromPartial(object.pagination) : undefined;
    message.height = object.height !== undefined && object.height !== null ? _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.fromPartial(object.height) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      commitments: Array.isArray(object === null || object === void 0 ? void 0 : object.commitments) ? object.commitments.map(e => _channel__WEBPACK_IMPORTED_MODULE_1__.PacketState.fromAmino(e)) : [],
      pagination: object !== null && object !== void 0 && object.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.fromAmino(object.pagination) : undefined,
      height: object !== null && object !== void 0 && object.height ? _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.fromAmino(object.height) : undefined
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.commitments) {
      obj.commitments = message.commitments.map(e => e ? _channel__WEBPACK_IMPORTED_MODULE_1__.PacketState.toAmino(e) : undefined);
    } else {
      obj.commitments = [];
    }

    obj.pagination = message.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.toAmino(message.pagination) : undefined;
    obj.height = message.height ? _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.toAmino(message.height) : {};
    return obj;
  },

  fromAminoMsg(object) {
    return QueryPacketCommitmentsResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryPacketCommitmentsResponse",
      value: QueryPacketCommitmentsResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryPacketCommitmentsResponse.decode(message.value);
  },

  toProto(message) {
    return QueryPacketCommitmentsResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.channel.v1.QueryPacketCommitmentsResponse",
      value: QueryPacketCommitmentsResponse.encode(message).finish()
    };
  }

};

function createBaseQueryPacketReceiptRequest() {
  return {
    portId: "",
    channelId: "",
    sequence: _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.UZERO */ .dK.UZERO
  };
}

const QueryPacketReceiptRequest = {
  typeUrl: "/ibc.core.channel.v1.QueryPacketReceiptRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Writer.create()) {
    if (message.portId !== "") {
      writer.uint32(10).string(message.portId);
    }

    if (message.channelId !== "") {
      writer.uint32(18).string(message.channelId);
    }

    if (!message.sequence.isZero()) {
      writer.uint32(24).uint64(message.sequence);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryPacketReceiptRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.portId = reader.string();
          break;

        case 2:
          message.channelId = reader.string();
          break;

        case 3:
          message.sequence = reader.uint64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$portId6, _object$channelId6;

    const message = createBaseQueryPacketReceiptRequest();
    message.portId = (_object$portId6 = object.portId) !== null && _object$portId6 !== void 0 ? _object$portId6 : "";
    message.channelId = (_object$channelId6 = object.channelId) !== null && _object$channelId6 !== void 0 ? _object$channelId6 : "";
    message.sequence = object.sequence !== undefined && object.sequence !== null ? _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.fromValue */ .dK.fromValue(object.sequence) : _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.UZERO */ .dK.UZERO;
    return message;
  },

  fromAmino(object) {
    return {
      portId: object.port_id,
      channelId: object.channel_id,
      sequence: _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.fromString */ .dK.fromString(object.sequence)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.port_id = message.portId;
    obj.channel_id = message.channelId;
    obj.sequence = message.sequence ? message.sequence.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryPacketReceiptRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryPacketReceiptRequest",
      value: QueryPacketReceiptRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryPacketReceiptRequest.decode(message.value);
  },

  toProto(message) {
    return QueryPacketReceiptRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.channel.v1.QueryPacketReceiptRequest",
      value: QueryPacketReceiptRequest.encode(message).finish()
    };
  }

};

function createBaseQueryPacketReceiptResponse() {
  return {
    received: false,
    proof: new Uint8Array(),
    proofHeight: undefined
  };
}

const QueryPacketReceiptResponse = {
  typeUrl: "/ibc.core.channel.v1.QueryPacketReceiptResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Writer.create()) {
    if (message.received === true) {
      writer.uint32(16).bool(message.received);
    }

    if (message.proof.length !== 0) {
      writer.uint32(26).bytes(message.proof);
    }

    if (message.proofHeight !== undefined) {
      _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.encode(message.proofHeight, writer.uint32(34).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryPacketReceiptResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 2:
          message.received = reader.bool();
          break;

        case 3:
          message.proof = reader.bytes();
          break;

        case 4:
          message.proofHeight = _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$received, _object$proof5;

    const message = createBaseQueryPacketReceiptResponse();
    message.received = (_object$received = object.received) !== null && _object$received !== void 0 ? _object$received : false;
    message.proof = (_object$proof5 = object.proof) !== null && _object$proof5 !== void 0 ? _object$proof5 : new Uint8Array();
    message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.fromPartial(object.proofHeight) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      received: object.received,
      proof: object.proof,
      proofHeight: object !== null && object !== void 0 && object.proof_height ? _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.fromAmino(object.proof_height) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.received = message.received;
    obj.proof = message.proof;
    obj.proof_height = message.proofHeight ? _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.toAmino(message.proofHeight) : {};
    return obj;
  },

  fromAminoMsg(object) {
    return QueryPacketReceiptResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryPacketReceiptResponse",
      value: QueryPacketReceiptResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryPacketReceiptResponse.decode(message.value);
  },

  toProto(message) {
    return QueryPacketReceiptResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.channel.v1.QueryPacketReceiptResponse",
      value: QueryPacketReceiptResponse.encode(message).finish()
    };
  }

};

function createBaseQueryPacketAcknowledgementRequest() {
  return {
    portId: "",
    channelId: "",
    sequence: _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.UZERO */ .dK.UZERO
  };
}

const QueryPacketAcknowledgementRequest = {
  typeUrl: "/ibc.core.channel.v1.QueryPacketAcknowledgementRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Writer.create()) {
    if (message.portId !== "") {
      writer.uint32(10).string(message.portId);
    }

    if (message.channelId !== "") {
      writer.uint32(18).string(message.channelId);
    }

    if (!message.sequence.isZero()) {
      writer.uint32(24).uint64(message.sequence);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryPacketAcknowledgementRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.portId = reader.string();
          break;

        case 2:
          message.channelId = reader.string();
          break;

        case 3:
          message.sequence = reader.uint64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$portId7, _object$channelId7;

    const message = createBaseQueryPacketAcknowledgementRequest();
    message.portId = (_object$portId7 = object.portId) !== null && _object$portId7 !== void 0 ? _object$portId7 : "";
    message.channelId = (_object$channelId7 = object.channelId) !== null && _object$channelId7 !== void 0 ? _object$channelId7 : "";
    message.sequence = object.sequence !== undefined && object.sequence !== null ? _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.fromValue */ .dK.fromValue(object.sequence) : _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.UZERO */ .dK.UZERO;
    return message;
  },

  fromAmino(object) {
    return {
      portId: object.port_id,
      channelId: object.channel_id,
      sequence: _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.fromString */ .dK.fromString(object.sequence)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.port_id = message.portId;
    obj.channel_id = message.channelId;
    obj.sequence = message.sequence ? message.sequence.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryPacketAcknowledgementRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryPacketAcknowledgementRequest",
      value: QueryPacketAcknowledgementRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryPacketAcknowledgementRequest.decode(message.value);
  },

  toProto(message) {
    return QueryPacketAcknowledgementRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.channel.v1.QueryPacketAcknowledgementRequest",
      value: QueryPacketAcknowledgementRequest.encode(message).finish()
    };
  }

};

function createBaseQueryPacketAcknowledgementResponse() {
  return {
    acknowledgement: new Uint8Array(),
    proof: new Uint8Array(),
    proofHeight: undefined
  };
}

const QueryPacketAcknowledgementResponse = {
  typeUrl: "/ibc.core.channel.v1.QueryPacketAcknowledgementResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Writer.create()) {
    if (message.acknowledgement.length !== 0) {
      writer.uint32(10).bytes(message.acknowledgement);
    }

    if (message.proof.length !== 0) {
      writer.uint32(18).bytes(message.proof);
    }

    if (message.proofHeight !== undefined) {
      _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.encode(message.proofHeight, writer.uint32(26).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryPacketAcknowledgementResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.acknowledgement = reader.bytes();
          break;

        case 2:
          message.proof = reader.bytes();
          break;

        case 3:
          message.proofHeight = _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$acknowledgeme, _object$proof6;

    const message = createBaseQueryPacketAcknowledgementResponse();
    message.acknowledgement = (_object$acknowledgeme = object.acknowledgement) !== null && _object$acknowledgeme !== void 0 ? _object$acknowledgeme : new Uint8Array();
    message.proof = (_object$proof6 = object.proof) !== null && _object$proof6 !== void 0 ? _object$proof6 : new Uint8Array();
    message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.fromPartial(object.proofHeight) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      acknowledgement: object.acknowledgement,
      proof: object.proof,
      proofHeight: object !== null && object !== void 0 && object.proof_height ? _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.fromAmino(object.proof_height) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.acknowledgement = message.acknowledgement;
    obj.proof = message.proof;
    obj.proof_height = message.proofHeight ? _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.toAmino(message.proofHeight) : {};
    return obj;
  },

  fromAminoMsg(object) {
    return QueryPacketAcknowledgementResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryPacketAcknowledgementResponse",
      value: QueryPacketAcknowledgementResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryPacketAcknowledgementResponse.decode(message.value);
  },

  toProto(message) {
    return QueryPacketAcknowledgementResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.channel.v1.QueryPacketAcknowledgementResponse",
      value: QueryPacketAcknowledgementResponse.encode(message).finish()
    };
  }

};

function createBaseQueryPacketAcknowledgementsRequest() {
  return {
    portId: "",
    channelId: "",
    pagination: undefined,
    packetCommitmentSequences: []
  };
}

const QueryPacketAcknowledgementsRequest = {
  typeUrl: "/ibc.core.channel.v1.QueryPacketAcknowledgementsRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Writer.create()) {
    if (message.portId !== "") {
      writer.uint32(10).string(message.portId);
    }

    if (message.channelId !== "") {
      writer.uint32(18).string(message.channelId);
    }

    if (message.pagination !== undefined) {
      _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.encode(message.pagination, writer.uint32(26).fork()).ldelim();
    }

    writer.uint32(34).fork();

    for (const v of message.packetCommitmentSequences) {
      writer.uint64(v);
    }

    writer.ldelim();
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryPacketAcknowledgementsRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.portId = reader.string();
          break;

        case 2:
          message.channelId = reader.string();
          break;

        case 3:
          message.pagination = _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.decode(reader, reader.uint32());
          break;

        case 4:
          if ((tag & 7) === 2) {
            const end2 = reader.uint32() + reader.pos;

            while (reader.pos < end2) {
              message.packetCommitmentSequences.push(reader.uint64());
            }
          } else {
            message.packetCommitmentSequences.push(reader.uint64());
          }

          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$portId8, _object$channelId8, _object$packetCommitm;

    const message = createBaseQueryPacketAcknowledgementsRequest();
    message.portId = (_object$portId8 = object.portId) !== null && _object$portId8 !== void 0 ? _object$portId8 : "";
    message.channelId = (_object$channelId8 = object.channelId) !== null && _object$channelId8 !== void 0 ? _object$channelId8 : "";
    message.pagination = object.pagination !== undefined && object.pagination !== null ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.fromPartial(object.pagination) : undefined;
    message.packetCommitmentSequences = ((_object$packetCommitm = object.packetCommitmentSequences) === null || _object$packetCommitm === void 0 ? void 0 : _object$packetCommitm.map(e => _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.fromValue */ .dK.fromValue(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      portId: object.port_id,
      channelId: object.channel_id,
      pagination: object !== null && object !== void 0 && object.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.fromAmino(object.pagination) : undefined,
      packetCommitmentSequences: Array.isArray(object === null || object === void 0 ? void 0 : object.packet_commitment_sequences) ? object.packet_commitment_sequences.map(e => e) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.port_id = message.portId;
    obj.channel_id = message.channelId;
    obj.pagination = message.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.toAmino(message.pagination) : undefined;

    if (message.packetCommitmentSequences) {
      obj.packet_commitment_sequences = message.packetCommitmentSequences.map(e => e);
    } else {
      obj.packet_commitment_sequences = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return QueryPacketAcknowledgementsRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryPacketAcknowledgementsRequest",
      value: QueryPacketAcknowledgementsRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryPacketAcknowledgementsRequest.decode(message.value);
  },

  toProto(message) {
    return QueryPacketAcknowledgementsRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.channel.v1.QueryPacketAcknowledgementsRequest",
      value: QueryPacketAcknowledgementsRequest.encode(message).finish()
    };
  }

};

function createBaseQueryPacketAcknowledgementsResponse() {
  return {
    acknowledgements: [],
    pagination: undefined,
    height: undefined
  };
}

const QueryPacketAcknowledgementsResponse = {
  typeUrl: "/ibc.core.channel.v1.QueryPacketAcknowledgementsResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Writer.create()) {
    for (const v of message.acknowledgements) {
      _channel__WEBPACK_IMPORTED_MODULE_1__.PacketState.encode(v, writer.uint32(10).fork()).ldelim();
    }

    if (message.pagination !== undefined) {
      _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
    }

    if (message.height !== undefined) {
      _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.encode(message.height, writer.uint32(26).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryPacketAcknowledgementsResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.acknowledgements.push(_channel__WEBPACK_IMPORTED_MODULE_1__.PacketState.decode(reader, reader.uint32()));
          break;

        case 2:
          message.pagination = _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.decode(reader, reader.uint32());
          break;

        case 3:
          message.height = _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$acknowledgeme2;

    const message = createBaseQueryPacketAcknowledgementsResponse();
    message.acknowledgements = ((_object$acknowledgeme2 = object.acknowledgements) === null || _object$acknowledgeme2 === void 0 ? void 0 : _object$acknowledgeme2.map(e => _channel__WEBPACK_IMPORTED_MODULE_1__.PacketState.fromPartial(e))) || [];
    message.pagination = object.pagination !== undefined && object.pagination !== null ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.fromPartial(object.pagination) : undefined;
    message.height = object.height !== undefined && object.height !== null ? _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.fromPartial(object.height) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      acknowledgements: Array.isArray(object === null || object === void 0 ? void 0 : object.acknowledgements) ? object.acknowledgements.map(e => _channel__WEBPACK_IMPORTED_MODULE_1__.PacketState.fromAmino(e)) : [],
      pagination: object !== null && object !== void 0 && object.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.fromAmino(object.pagination) : undefined,
      height: object !== null && object !== void 0 && object.height ? _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.fromAmino(object.height) : undefined
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.acknowledgements) {
      obj.acknowledgements = message.acknowledgements.map(e => e ? _channel__WEBPACK_IMPORTED_MODULE_1__.PacketState.toAmino(e) : undefined);
    } else {
      obj.acknowledgements = [];
    }

    obj.pagination = message.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.toAmino(message.pagination) : undefined;
    obj.height = message.height ? _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.toAmino(message.height) : {};
    return obj;
  },

  fromAminoMsg(object) {
    return QueryPacketAcknowledgementsResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryPacketAcknowledgementsResponse",
      value: QueryPacketAcknowledgementsResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryPacketAcknowledgementsResponse.decode(message.value);
  },

  toProto(message) {
    return QueryPacketAcknowledgementsResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.channel.v1.QueryPacketAcknowledgementsResponse",
      value: QueryPacketAcknowledgementsResponse.encode(message).finish()
    };
  }

};

function createBaseQueryUnreceivedPacketsRequest() {
  return {
    portId: "",
    channelId: "",
    packetCommitmentSequences: []
  };
}

const QueryUnreceivedPacketsRequest = {
  typeUrl: "/ibc.core.channel.v1.QueryUnreceivedPacketsRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Writer.create()) {
    if (message.portId !== "") {
      writer.uint32(10).string(message.portId);
    }

    if (message.channelId !== "") {
      writer.uint32(18).string(message.channelId);
    }

    writer.uint32(26).fork();

    for (const v of message.packetCommitmentSequences) {
      writer.uint64(v);
    }

    writer.ldelim();
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryUnreceivedPacketsRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.portId = reader.string();
          break;

        case 2:
          message.channelId = reader.string();
          break;

        case 3:
          if ((tag & 7) === 2) {
            const end2 = reader.uint32() + reader.pos;

            while (reader.pos < end2) {
              message.packetCommitmentSequences.push(reader.uint64());
            }
          } else {
            message.packetCommitmentSequences.push(reader.uint64());
          }

          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$portId9, _object$channelId9, _object$packetCommitm2;

    const message = createBaseQueryUnreceivedPacketsRequest();
    message.portId = (_object$portId9 = object.portId) !== null && _object$portId9 !== void 0 ? _object$portId9 : "";
    message.channelId = (_object$channelId9 = object.channelId) !== null && _object$channelId9 !== void 0 ? _object$channelId9 : "";
    message.packetCommitmentSequences = ((_object$packetCommitm2 = object.packetCommitmentSequences) === null || _object$packetCommitm2 === void 0 ? void 0 : _object$packetCommitm2.map(e => _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.fromValue */ .dK.fromValue(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      portId: object.port_id,
      channelId: object.channel_id,
      packetCommitmentSequences: Array.isArray(object === null || object === void 0 ? void 0 : object.packet_commitment_sequences) ? object.packet_commitment_sequences.map(e => e) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.port_id = message.portId;
    obj.channel_id = message.channelId;

    if (message.packetCommitmentSequences) {
      obj.packet_commitment_sequences = message.packetCommitmentSequences.map(e => e);
    } else {
      obj.packet_commitment_sequences = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return QueryUnreceivedPacketsRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryUnreceivedPacketsRequest",
      value: QueryUnreceivedPacketsRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryUnreceivedPacketsRequest.decode(message.value);
  },

  toProto(message) {
    return QueryUnreceivedPacketsRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.channel.v1.QueryUnreceivedPacketsRequest",
      value: QueryUnreceivedPacketsRequest.encode(message).finish()
    };
  }

};

function createBaseQueryUnreceivedPacketsResponse() {
  return {
    sequences: [],
    height: undefined
  };
}

const QueryUnreceivedPacketsResponse = {
  typeUrl: "/ibc.core.channel.v1.QueryUnreceivedPacketsResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Writer.create()) {
    writer.uint32(10).fork();

    for (const v of message.sequences) {
      writer.uint64(v);
    }

    writer.ldelim();

    if (message.height !== undefined) {
      _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.encode(message.height, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryUnreceivedPacketsResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          if ((tag & 7) === 2) {
            const end2 = reader.uint32() + reader.pos;

            while (reader.pos < end2) {
              message.sequences.push(reader.uint64());
            }
          } else {
            message.sequences.push(reader.uint64());
          }

          break;

        case 2:
          message.height = _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$sequences;

    const message = createBaseQueryUnreceivedPacketsResponse();
    message.sequences = ((_object$sequences = object.sequences) === null || _object$sequences === void 0 ? void 0 : _object$sequences.map(e => _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.fromValue */ .dK.fromValue(e))) || [];
    message.height = object.height !== undefined && object.height !== null ? _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.fromPartial(object.height) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      sequences: Array.isArray(object === null || object === void 0 ? void 0 : object.sequences) ? object.sequences.map(e => e) : [],
      height: object !== null && object !== void 0 && object.height ? _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.fromAmino(object.height) : undefined
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.sequences) {
      obj.sequences = message.sequences.map(e => e);
    } else {
      obj.sequences = [];
    }

    obj.height = message.height ? _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.toAmino(message.height) : {};
    return obj;
  },

  fromAminoMsg(object) {
    return QueryUnreceivedPacketsResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryUnreceivedPacketsResponse",
      value: QueryUnreceivedPacketsResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryUnreceivedPacketsResponse.decode(message.value);
  },

  toProto(message) {
    return QueryUnreceivedPacketsResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.channel.v1.QueryUnreceivedPacketsResponse",
      value: QueryUnreceivedPacketsResponse.encode(message).finish()
    };
  }

};

function createBaseQueryUnreceivedAcksRequest() {
  return {
    portId: "",
    channelId: "",
    packetAckSequences: []
  };
}

const QueryUnreceivedAcksRequest = {
  typeUrl: "/ibc.core.channel.v1.QueryUnreceivedAcksRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Writer.create()) {
    if (message.portId !== "") {
      writer.uint32(10).string(message.portId);
    }

    if (message.channelId !== "") {
      writer.uint32(18).string(message.channelId);
    }

    writer.uint32(26).fork();

    for (const v of message.packetAckSequences) {
      writer.uint64(v);
    }

    writer.ldelim();
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryUnreceivedAcksRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.portId = reader.string();
          break;

        case 2:
          message.channelId = reader.string();
          break;

        case 3:
          if ((tag & 7) === 2) {
            const end2 = reader.uint32() + reader.pos;

            while (reader.pos < end2) {
              message.packetAckSequences.push(reader.uint64());
            }
          } else {
            message.packetAckSequences.push(reader.uint64());
          }

          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$portId10, _object$channelId10, _object$packetAckSequ;

    const message = createBaseQueryUnreceivedAcksRequest();
    message.portId = (_object$portId10 = object.portId) !== null && _object$portId10 !== void 0 ? _object$portId10 : "";
    message.channelId = (_object$channelId10 = object.channelId) !== null && _object$channelId10 !== void 0 ? _object$channelId10 : "";
    message.packetAckSequences = ((_object$packetAckSequ = object.packetAckSequences) === null || _object$packetAckSequ === void 0 ? void 0 : _object$packetAckSequ.map(e => _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.fromValue */ .dK.fromValue(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      portId: object.port_id,
      channelId: object.channel_id,
      packetAckSequences: Array.isArray(object === null || object === void 0 ? void 0 : object.packet_ack_sequences) ? object.packet_ack_sequences.map(e => e) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.port_id = message.portId;
    obj.channel_id = message.channelId;

    if (message.packetAckSequences) {
      obj.packet_ack_sequences = message.packetAckSequences.map(e => e);
    } else {
      obj.packet_ack_sequences = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return QueryUnreceivedAcksRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryUnreceivedAcksRequest",
      value: QueryUnreceivedAcksRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryUnreceivedAcksRequest.decode(message.value);
  },

  toProto(message) {
    return QueryUnreceivedAcksRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.channel.v1.QueryUnreceivedAcksRequest",
      value: QueryUnreceivedAcksRequest.encode(message).finish()
    };
  }

};

function createBaseQueryUnreceivedAcksResponse() {
  return {
    sequences: [],
    height: undefined
  };
}

const QueryUnreceivedAcksResponse = {
  typeUrl: "/ibc.core.channel.v1.QueryUnreceivedAcksResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Writer.create()) {
    writer.uint32(10).fork();

    for (const v of message.sequences) {
      writer.uint64(v);
    }

    writer.ldelim();

    if (message.height !== undefined) {
      _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.encode(message.height, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryUnreceivedAcksResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          if ((tag & 7) === 2) {
            const end2 = reader.uint32() + reader.pos;

            while (reader.pos < end2) {
              message.sequences.push(reader.uint64());
            }
          } else {
            message.sequences.push(reader.uint64());
          }

          break;

        case 2:
          message.height = _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$sequences2;

    const message = createBaseQueryUnreceivedAcksResponse();
    message.sequences = ((_object$sequences2 = object.sequences) === null || _object$sequences2 === void 0 ? void 0 : _object$sequences2.map(e => _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.fromValue */ .dK.fromValue(e))) || [];
    message.height = object.height !== undefined && object.height !== null ? _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.fromPartial(object.height) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      sequences: Array.isArray(object === null || object === void 0 ? void 0 : object.sequences) ? object.sequences.map(e => e) : [],
      height: object !== null && object !== void 0 && object.height ? _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.fromAmino(object.height) : undefined
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.sequences) {
      obj.sequences = message.sequences.map(e => e);
    } else {
      obj.sequences = [];
    }

    obj.height = message.height ? _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.toAmino(message.height) : {};
    return obj;
  },

  fromAminoMsg(object) {
    return QueryUnreceivedAcksResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryUnreceivedAcksResponse",
      value: QueryUnreceivedAcksResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryUnreceivedAcksResponse.decode(message.value);
  },

  toProto(message) {
    return QueryUnreceivedAcksResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.channel.v1.QueryUnreceivedAcksResponse",
      value: QueryUnreceivedAcksResponse.encode(message).finish()
    };
  }

};

function createBaseQueryNextSequenceReceiveRequest() {
  return {
    portId: "",
    channelId: ""
  };
}

const QueryNextSequenceReceiveRequest = {
  typeUrl: "/ibc.core.channel.v1.QueryNextSequenceReceiveRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Writer.create()) {
    if (message.portId !== "") {
      writer.uint32(10).string(message.portId);
    }

    if (message.channelId !== "") {
      writer.uint32(18).string(message.channelId);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryNextSequenceReceiveRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.portId = reader.string();
          break;

        case 2:
          message.channelId = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$portId11, _object$channelId11;

    const message = createBaseQueryNextSequenceReceiveRequest();
    message.portId = (_object$portId11 = object.portId) !== null && _object$portId11 !== void 0 ? _object$portId11 : "";
    message.channelId = (_object$channelId11 = object.channelId) !== null && _object$channelId11 !== void 0 ? _object$channelId11 : "";
    return message;
  },

  fromAmino(object) {
    return {
      portId: object.port_id,
      channelId: object.channel_id
    };
  },

  toAmino(message) {
    const obj = {};
    obj.port_id = message.portId;
    obj.channel_id = message.channelId;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryNextSequenceReceiveRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryNextSequenceReceiveRequest",
      value: QueryNextSequenceReceiveRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryNextSequenceReceiveRequest.decode(message.value);
  },

  toProto(message) {
    return QueryNextSequenceReceiveRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.channel.v1.QueryNextSequenceReceiveRequest",
      value: QueryNextSequenceReceiveRequest.encode(message).finish()
    };
  }

};

function createBaseQueryNextSequenceReceiveResponse() {
  return {
    nextSequenceReceive: _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.UZERO */ .dK.UZERO,
    proof: new Uint8Array(),
    proofHeight: undefined
  };
}

const QueryNextSequenceReceiveResponse = {
  typeUrl: "/ibc.core.channel.v1.QueryNextSequenceReceiveResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Writer.create()) {
    if (!message.nextSequenceReceive.isZero()) {
      writer.uint32(8).uint64(message.nextSequenceReceive);
    }

    if (message.proof.length !== 0) {
      writer.uint32(18).bytes(message.proof);
    }

    if (message.proofHeight !== undefined) {
      _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.encode(message.proofHeight, writer.uint32(26).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryNextSequenceReceiveResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.nextSequenceReceive = reader.uint64();
          break;

        case 2:
          message.proof = reader.bytes();
          break;

        case 3:
          message.proofHeight = _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$proof7;

    const message = createBaseQueryNextSequenceReceiveResponse();
    message.nextSequenceReceive = object.nextSequenceReceive !== undefined && object.nextSequenceReceive !== null ? _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.fromValue */ .dK.fromValue(object.nextSequenceReceive) : _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.UZERO */ .dK.UZERO;
    message.proof = (_object$proof7 = object.proof) !== null && _object$proof7 !== void 0 ? _object$proof7 : new Uint8Array();
    message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.fromPartial(object.proofHeight) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      nextSequenceReceive: _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.fromString */ .dK.fromString(object.next_sequence_receive),
      proof: object.proof,
      proofHeight: object !== null && object !== void 0 && object.proof_height ? _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.fromAmino(object.proof_height) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.next_sequence_receive = message.nextSequenceReceive ? message.nextSequenceReceive.toString() : undefined;
    obj.proof = message.proof;
    obj.proof_height = message.proofHeight ? _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.toAmino(message.proofHeight) : {};
    return obj;
  },

  fromAminoMsg(object) {
    return QueryNextSequenceReceiveResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryNextSequenceReceiveResponse",
      value: QueryNextSequenceReceiveResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryNextSequenceReceiveResponse.decode(message.value);
  },

  toProto(message) {
    return QueryNextSequenceReceiveResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.channel.v1.QueryNextSequenceReceiveResponse",
      value: QueryNextSequenceReceiveResponse.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 18320:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LCDQueryClient": function() { return /* binding */ LCDQueryClient; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4942);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47895);


class LCDQueryClient {
  constructor({
    requestClient
  }) {
    (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, "req", void 0);

    this.req = requestClient;
    this.channel = this.channel.bind(this);
    this.channels = this.channels.bind(this);
    this.connectionChannels = this.connectionChannels.bind(this);
    this.channelClientState = this.channelClientState.bind(this);
    this.channelConsensusState = this.channelConsensusState.bind(this);
    this.packetCommitment = this.packetCommitment.bind(this);
    this.packetCommitments = this.packetCommitments.bind(this);
    this.packetReceipt = this.packetReceipt.bind(this);
    this.packetAcknowledgement = this.packetAcknowledgement.bind(this);
    this.packetAcknowledgements = this.packetAcknowledgements.bind(this);
    this.unreceivedPackets = this.unreceivedPackets.bind(this);
    this.unreceivedAcks = this.unreceivedAcks.bind(this);
    this.nextSequenceReceive = this.nextSequenceReceive.bind(this);
  }
  /* Channel queries an IBC Channel. */


  async channel(params) {
    const endpoint = `ibc/core/channel/v1/channels/${params.channelId}/ports/${params.portId}`;
    return await this.req.get(endpoint);
  }
  /* Channels queries all the IBC channels of a chain. */


  async channels(params = {
    pagination: undefined
  }) {
    const options = {
      params: {}
    };

    if (typeof (params === null || params === void 0 ? void 0 : params.pagination) !== "undefined") {
      (0,_helpers__WEBPACK_IMPORTED_MODULE_0__/* .setPaginationParams */ .q6)(options, params.pagination);
    }

    const endpoint = `ibc/core/channel/v1/channels`;
    return await this.req.get(endpoint, options);
  }
  /* ConnectionChannels queries all the channels associated with a connection
   end. */


  async connectionChannels(params) {
    const options = {
      params: {}
    };

    if (typeof (params === null || params === void 0 ? void 0 : params.pagination) !== "undefined") {
      (0,_helpers__WEBPACK_IMPORTED_MODULE_0__/* .setPaginationParams */ .q6)(options, params.pagination);
    }

    const endpoint = `ibc/core/channel/v1/connections/${params.connection}/channels`;
    return await this.req.get(endpoint, options);
  }
  /* ChannelClientState queries for the client state for the channel associated
   with the provided channel identifiers. */


  async channelClientState(params) {
    const endpoint = `ibc/core/channel/v1/channels/${params.channelId}/ports/${params.portId}/client_state`;
    return await this.req.get(endpoint);
  }
  /* ChannelConsensusState queries for the consensus state for the channel
   associated with the provided channel identifiers. */


  async channelConsensusState(params) {
    const endpoint = `ibc/core/channel/v1/channels/${params.channelId}/ports/${params.portId}/consensus_state/revision/${params.revisionNumber}/height/${params.revisionHeight}`;
    return await this.req.get(endpoint);
  }
  /* PacketCommitment queries a stored packet commitment hash. */


  async packetCommitment(params) {
    const endpoint = `ibc/core/channel/v1/channels/${params.channelId}/ports/${params.portId}/packet_commitments/${params.sequence}`;
    return await this.req.get(endpoint);
  }
  /* PacketCommitments returns all the packet commitments hashes associated
   with a channel. */


  async packetCommitments(params) {
    const options = {
      params: {}
    };

    if (typeof (params === null || params === void 0 ? void 0 : params.pagination) !== "undefined") {
      (0,_helpers__WEBPACK_IMPORTED_MODULE_0__/* .setPaginationParams */ .q6)(options, params.pagination);
    }

    const endpoint = `ibc/core/channel/v1/channels/${params.channelId}/ports/${params.portId}/packet_commitments`;
    return await this.req.get(endpoint, options);
  }
  /* PacketReceipt queries if a given packet sequence has been received on the
   queried chain */


  async packetReceipt(params) {
    const endpoint = `ibc/core/channel/v1/channels/${params.channelId}/ports/${params.portId}/packet_receipts/${params.sequence}`;
    return await this.req.get(endpoint);
  }
  /* PacketAcknowledgement queries a stored packet acknowledgement hash. */


  async packetAcknowledgement(params) {
    const endpoint = `ibc/core/channel/v1/channels/${params.channelId}/ports/${params.portId}/packet_acks/${params.sequence}`;
    return await this.req.get(endpoint);
  }
  /* PacketAcknowledgements returns all the packet acknowledgements associated
   with a channel. */


  async packetAcknowledgements(params) {
    const options = {
      params: {}
    };

    if (typeof (params === null || params === void 0 ? void 0 : params.pagination) !== "undefined") {
      (0,_helpers__WEBPACK_IMPORTED_MODULE_0__/* .setPaginationParams */ .q6)(options, params.pagination);
    }

    if (typeof (params === null || params === void 0 ? void 0 : params.packetCommitmentSequences) !== "undefined") {
      options.params.packet_commitment_sequences = params.packetCommitmentSequences;
    }

    const endpoint = `ibc/core/channel/v1/channels/${params.channelId}/ports/${params.portId}/packet_acknowledgements`;
    return await this.req.get(endpoint, options);
  }
  /* UnreceivedPackets returns all the unreceived IBC packets associated with a
   channel and sequences. */


  async unreceivedPackets(params) {
    const endpoint = `ibc/core/channel/v1/channels/${params.channelId}/ports/${params.portId}/packet_commitments/${params.packetCommitmentSequences}/unreceived_packets`;
    return await this.req.get(endpoint);
  }
  /* UnreceivedAcks returns all the unreceived IBC acknowledgements associated
   with a channel and sequences. */


  async unreceivedAcks(params) {
    const endpoint = `ibc/core/channel/v1/channels/${params.channelId}/ports/${params.portId}/packet_commitments/${params.packetAckSequences}/unreceived_acks`;
    return await this.req.get(endpoint);
  }
  /* NextSequenceReceive returns the next receive sequence for a given channel. */


  async nextSequenceReceive(params) {
    const endpoint = `ibc/core/channel/v1/channels/${params.channelId}/ports/${params.portId}/next_sequence`;
    return await this.req.get(endpoint);
  }

}

/***/ }),

/***/ 34693:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QueryClientImpl": function() { return /* binding */ QueryClientImpl; },
/* harmony export */   "createRpcQueryExtension": function() { return /* binding */ createRpcQueryExtension; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4942);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78441);
/* harmony import */ var _cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28397);




/** Query provides defines the gRPC querier service */

class QueryClientImpl {
  constructor(rpc) {
    (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, "rpc", void 0);

    this.rpc = rpc;
    this.channel = this.channel.bind(this);
    this.channels = this.channels.bind(this);
    this.connectionChannels = this.connectionChannels.bind(this);
    this.channelClientState = this.channelClientState.bind(this);
    this.channelConsensusState = this.channelConsensusState.bind(this);
    this.packetCommitment = this.packetCommitment.bind(this);
    this.packetCommitments = this.packetCommitments.bind(this);
    this.packetReceipt = this.packetReceipt.bind(this);
    this.packetAcknowledgement = this.packetAcknowledgement.bind(this);
    this.packetAcknowledgements = this.packetAcknowledgements.bind(this);
    this.unreceivedPackets = this.unreceivedPackets.bind(this);
    this.unreceivedAcks = this.unreceivedAcks.bind(this);
    this.nextSequenceReceive = this.nextSequenceReceive.bind(this);
  }

  channel(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryChannelRequest.encode(request).finish();
    const promise = this.rpc.request("ibc.core.channel.v1.Query", "Channel", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryChannelResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  channels(request = {
    pagination: undefined
  }) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryChannelsRequest.encode(request).finish();
    const promise = this.rpc.request("ibc.core.channel.v1.Query", "Channels", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryChannelsResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  connectionChannels(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryConnectionChannelsRequest.encode(request).finish();
    const promise = this.rpc.request("ibc.core.channel.v1.Query", "ConnectionChannels", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryConnectionChannelsResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  channelClientState(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryChannelClientStateRequest.encode(request).finish();
    const promise = this.rpc.request("ibc.core.channel.v1.Query", "ChannelClientState", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryChannelClientStateResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  channelConsensusState(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryChannelConsensusStateRequest.encode(request).finish();
    const promise = this.rpc.request("ibc.core.channel.v1.Query", "ChannelConsensusState", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryChannelConsensusStateResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  packetCommitment(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryPacketCommitmentRequest.encode(request).finish();
    const promise = this.rpc.request("ibc.core.channel.v1.Query", "PacketCommitment", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryPacketCommitmentResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  packetCommitments(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryPacketCommitmentsRequest.encode(request).finish();
    const promise = this.rpc.request("ibc.core.channel.v1.Query", "PacketCommitments", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryPacketCommitmentsResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  packetReceipt(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryPacketReceiptRequest.encode(request).finish();
    const promise = this.rpc.request("ibc.core.channel.v1.Query", "PacketReceipt", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryPacketReceiptResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  packetAcknowledgement(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryPacketAcknowledgementRequest.encode(request).finish();
    const promise = this.rpc.request("ibc.core.channel.v1.Query", "PacketAcknowledgement", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryPacketAcknowledgementResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  packetAcknowledgements(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryPacketAcknowledgementsRequest.encode(request).finish();
    const promise = this.rpc.request("ibc.core.channel.v1.Query", "PacketAcknowledgements", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryPacketAcknowledgementsResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  unreceivedPackets(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryUnreceivedPacketsRequest.encode(request).finish();
    const promise = this.rpc.request("ibc.core.channel.v1.Query", "UnreceivedPackets", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryUnreceivedPacketsResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  unreceivedAcks(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryUnreceivedAcksRequest.encode(request).finish();
    const promise = this.rpc.request("ibc.core.channel.v1.Query", "UnreceivedAcks", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryUnreceivedAcksResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  nextSequenceReceive(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryNextSequenceReceiveRequest.encode(request).finish();
    const promise = this.rpc.request("ibc.core.channel.v1.Query", "NextSequenceReceive", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryNextSequenceReceiveResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

}
const createRpcQueryExtension = base => {
  const rpc = (0,_cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1__.createProtobufRpcClient)(base);
  const queryService = new QueryClientImpl(rpc);
  return {
    channel(request) {
      return queryService.channel(request);
    },

    channels(request) {
      return queryService.channels(request);
    },

    connectionChannels(request) {
      return queryService.connectionChannels(request);
    },

    channelClientState(request) {
      return queryService.channelClientState(request);
    },

    channelConsensusState(request) {
      return queryService.channelConsensusState(request);
    },

    packetCommitment(request) {
      return queryService.packetCommitment(request);
    },

    packetCommitments(request) {
      return queryService.packetCommitments(request);
    },

    packetReceipt(request) {
      return queryService.packetReceipt(request);
    },

    packetAcknowledgement(request) {
      return queryService.packetAcknowledgement(request);
    },

    packetAcknowledgements(request) {
      return queryService.packetAcknowledgements(request);
    },

    unreceivedPackets(request) {
      return queryService.unreceivedPackets(request);
    },

    unreceivedAcks(request) {
      return queryService.unreceivedAcks(request);
    },

    nextSequenceReceive(request) {
      return queryService.nextSequenceReceive(request);
    }

  };
};

/***/ }),

/***/ 63239:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MsgAcknowledgement": function() { return /* binding */ MsgAcknowledgement; },
/* harmony export */   "MsgAcknowledgementResponse": function() { return /* binding */ MsgAcknowledgementResponse; },
/* harmony export */   "MsgChannelCloseConfirm": function() { return /* binding */ MsgChannelCloseConfirm; },
/* harmony export */   "MsgChannelCloseConfirmResponse": function() { return /* binding */ MsgChannelCloseConfirmResponse; },
/* harmony export */   "MsgChannelCloseInit": function() { return /* binding */ MsgChannelCloseInit; },
/* harmony export */   "MsgChannelCloseInitResponse": function() { return /* binding */ MsgChannelCloseInitResponse; },
/* harmony export */   "MsgChannelOpenAck": function() { return /* binding */ MsgChannelOpenAck; },
/* harmony export */   "MsgChannelOpenAckResponse": function() { return /* binding */ MsgChannelOpenAckResponse; },
/* harmony export */   "MsgChannelOpenConfirm": function() { return /* binding */ MsgChannelOpenConfirm; },
/* harmony export */   "MsgChannelOpenConfirmResponse": function() { return /* binding */ MsgChannelOpenConfirmResponse; },
/* harmony export */   "MsgChannelOpenInit": function() { return /* binding */ MsgChannelOpenInit; },
/* harmony export */   "MsgChannelOpenInitResponse": function() { return /* binding */ MsgChannelOpenInitResponse; },
/* harmony export */   "MsgChannelOpenTry": function() { return /* binding */ MsgChannelOpenTry; },
/* harmony export */   "MsgChannelOpenTryResponse": function() { return /* binding */ MsgChannelOpenTryResponse; },
/* harmony export */   "MsgRecvPacket": function() { return /* binding */ MsgRecvPacket; },
/* harmony export */   "MsgRecvPacketResponse": function() { return /* binding */ MsgRecvPacketResponse; },
/* harmony export */   "MsgTimeout": function() { return /* binding */ MsgTimeout; },
/* harmony export */   "MsgTimeoutOnClose": function() { return /* binding */ MsgTimeoutOnClose; },
/* harmony export */   "MsgTimeoutOnCloseResponse": function() { return /* binding */ MsgTimeoutOnCloseResponse; },
/* harmony export */   "MsgTimeoutResponse": function() { return /* binding */ MsgTimeoutResponse; },
/* harmony export */   "ResponseResultType": function() { return /* binding */ ResponseResultType; },
/* harmony export */   "ResponseResultTypeAmino": function() { return /* binding */ ResponseResultTypeAmino; },
/* harmony export */   "ResponseResultTypeSDKType": function() { return /* binding */ ResponseResultTypeSDKType; },
/* harmony export */   "responseResultTypeFromJSON": function() { return /* binding */ responseResultTypeFromJSON; },
/* harmony export */   "responseResultTypeToJSON": function() { return /* binding */ responseResultTypeToJSON; }
/* harmony export */ });
/* harmony import */ var _channel__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53624);
/* harmony import */ var _client_v1_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45802);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47895);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__);




/** ResponseResultType defines the possible outcomes of the execution of a message */

let ResponseResultType;

(function (ResponseResultType) {
  ResponseResultType[ResponseResultType["RESPONSE_RESULT_TYPE_UNSPECIFIED"] = 0] = "RESPONSE_RESULT_TYPE_UNSPECIFIED";
  ResponseResultType[ResponseResultType["RESPONSE_RESULT_TYPE_NOOP"] = 1] = "RESPONSE_RESULT_TYPE_NOOP";
  ResponseResultType[ResponseResultType["RESPONSE_RESULT_TYPE_SUCCESS"] = 2] = "RESPONSE_RESULT_TYPE_SUCCESS";
  ResponseResultType[ResponseResultType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(ResponseResultType || (ResponseResultType = {}));

const ResponseResultTypeSDKType = ResponseResultType;
const ResponseResultTypeAmino = ResponseResultType;
function responseResultTypeFromJSON(object) {
  switch (object) {
    case 0:
    case "RESPONSE_RESULT_TYPE_UNSPECIFIED":
      return ResponseResultType.RESPONSE_RESULT_TYPE_UNSPECIFIED;

    case 1:
    case "RESPONSE_RESULT_TYPE_NOOP":
      return ResponseResultType.RESPONSE_RESULT_TYPE_NOOP;

    case 2:
    case "RESPONSE_RESULT_TYPE_SUCCESS":
      return ResponseResultType.RESPONSE_RESULT_TYPE_SUCCESS;

    case -1:
    case "UNRECOGNIZED":
    default:
      return ResponseResultType.UNRECOGNIZED;
  }
}
function responseResultTypeToJSON(object) {
  switch (object) {
    case ResponseResultType.RESPONSE_RESULT_TYPE_UNSPECIFIED:
      return "RESPONSE_RESULT_TYPE_UNSPECIFIED";

    case ResponseResultType.RESPONSE_RESULT_TYPE_NOOP:
      return "RESPONSE_RESULT_TYPE_NOOP";

    case ResponseResultType.RESPONSE_RESULT_TYPE_SUCCESS:
      return "RESPONSE_RESULT_TYPE_SUCCESS";

    case ResponseResultType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
/**
 * MsgChannelOpenInit defines an sdk.Msg to initialize a channel handshake. It
 * is called by a relayer on Chain A.
 */

function createBaseMsgChannelOpenInit() {
  return {
    portId: "",
    channel: undefined,
    signer: ""
  };
}

const MsgChannelOpenInit = {
  typeUrl: "/ibc.core.channel.v1.MsgChannelOpenInit",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.portId !== "") {
      writer.uint32(10).string(message.portId);
    }

    if (message.channel !== undefined) {
      _channel__WEBPACK_IMPORTED_MODULE_0__.Channel.encode(message.channel, writer.uint32(18).fork()).ldelim();
    }

    if (message.signer !== "") {
      writer.uint32(26).string(message.signer);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgChannelOpenInit();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.portId = reader.string();
          break;

        case 2:
          message.channel = _channel__WEBPACK_IMPORTED_MODULE_0__.Channel.decode(reader, reader.uint32());
          break;

        case 3:
          message.signer = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$portId, _object$signer;

    const message = createBaseMsgChannelOpenInit();
    message.portId = (_object$portId = object.portId) !== null && _object$portId !== void 0 ? _object$portId : "";
    message.channel = object.channel !== undefined && object.channel !== null ? _channel__WEBPACK_IMPORTED_MODULE_0__.Channel.fromPartial(object.channel) : undefined;
    message.signer = (_object$signer = object.signer) !== null && _object$signer !== void 0 ? _object$signer : "";
    return message;
  },

  fromAmino(object) {
    return {
      portId: object.port_id,
      channel: object !== null && object !== void 0 && object.channel ? _channel__WEBPACK_IMPORTED_MODULE_0__.Channel.fromAmino(object.channel) : undefined,
      signer: object.signer
    };
  },

  toAmino(message) {
    const obj = {};
    obj.port_id = message.portId;
    obj.channel = message.channel ? _channel__WEBPACK_IMPORTED_MODULE_0__.Channel.toAmino(message.channel) : undefined;
    obj.signer = message.signer;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgChannelOpenInit.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/MsgChannelOpenInit",
      value: MsgChannelOpenInit.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgChannelOpenInit.decode(message.value);
  },

  toProto(message) {
    return MsgChannelOpenInit.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.channel.v1.MsgChannelOpenInit",
      value: MsgChannelOpenInit.encode(message).finish()
    };
  }

};

function createBaseMsgChannelOpenInitResponse() {
  return {
    channelId: "",
    version: ""
  };
}

const MsgChannelOpenInitResponse = {
  typeUrl: "/ibc.core.channel.v1.MsgChannelOpenInitResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.channelId !== "") {
      writer.uint32(10).string(message.channelId);
    }

    if (message.version !== "") {
      writer.uint32(18).string(message.version);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgChannelOpenInitResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.channelId = reader.string();
          break;

        case 2:
          message.version = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$channelId, _object$version;

    const message = createBaseMsgChannelOpenInitResponse();
    message.channelId = (_object$channelId = object.channelId) !== null && _object$channelId !== void 0 ? _object$channelId : "";
    message.version = (_object$version = object.version) !== null && _object$version !== void 0 ? _object$version : "";
    return message;
  },

  fromAmino(object) {
    return {
      channelId: object.channel_id,
      version: object.version
    };
  },

  toAmino(message) {
    const obj = {};
    obj.channel_id = message.channelId;
    obj.version = message.version;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgChannelOpenInitResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/MsgChannelOpenInitResponse",
      value: MsgChannelOpenInitResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgChannelOpenInitResponse.decode(message.value);
  },

  toProto(message) {
    return MsgChannelOpenInitResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.channel.v1.MsgChannelOpenInitResponse",
      value: MsgChannelOpenInitResponse.encode(message).finish()
    };
  }

};

function createBaseMsgChannelOpenTry() {
  return {
    portId: "",
    previousChannelId: "",
    channel: undefined,
    counterpartyVersion: "",
    proofInit: new Uint8Array(),
    proofHeight: undefined,
    signer: ""
  };
}

const MsgChannelOpenTry = {
  typeUrl: "/ibc.core.channel.v1.MsgChannelOpenTry",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.portId !== "") {
      writer.uint32(10).string(message.portId);
    }

    if (message.previousChannelId !== "") {
      writer.uint32(18).string(message.previousChannelId);
    }

    if (message.channel !== undefined) {
      _channel__WEBPACK_IMPORTED_MODULE_0__.Channel.encode(message.channel, writer.uint32(26).fork()).ldelim();
    }

    if (message.counterpartyVersion !== "") {
      writer.uint32(34).string(message.counterpartyVersion);
    }

    if (message.proofInit.length !== 0) {
      writer.uint32(42).bytes(message.proofInit);
    }

    if (message.proofHeight !== undefined) {
      _client_v1_client__WEBPACK_IMPORTED_MODULE_1__.Height.encode(message.proofHeight, writer.uint32(50).fork()).ldelim();
    }

    if (message.signer !== "") {
      writer.uint32(58).string(message.signer);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgChannelOpenTry();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.portId = reader.string();
          break;

        case 2:
          message.previousChannelId = reader.string();
          break;

        case 3:
          message.channel = _channel__WEBPACK_IMPORTED_MODULE_0__.Channel.decode(reader, reader.uint32());
          break;

        case 4:
          message.counterpartyVersion = reader.string();
          break;

        case 5:
          message.proofInit = reader.bytes();
          break;

        case 6:
          message.proofHeight = _client_v1_client__WEBPACK_IMPORTED_MODULE_1__.Height.decode(reader, reader.uint32());
          break;

        case 7:
          message.signer = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$portId2, _object$previousChann, _object$counterpartyV, _object$proofInit, _object$signer2;

    const message = createBaseMsgChannelOpenTry();
    message.portId = (_object$portId2 = object.portId) !== null && _object$portId2 !== void 0 ? _object$portId2 : "";
    message.previousChannelId = (_object$previousChann = object.previousChannelId) !== null && _object$previousChann !== void 0 ? _object$previousChann : "";
    message.channel = object.channel !== undefined && object.channel !== null ? _channel__WEBPACK_IMPORTED_MODULE_0__.Channel.fromPartial(object.channel) : undefined;
    message.counterpartyVersion = (_object$counterpartyV = object.counterpartyVersion) !== null && _object$counterpartyV !== void 0 ? _object$counterpartyV : "";
    message.proofInit = (_object$proofInit = object.proofInit) !== null && _object$proofInit !== void 0 ? _object$proofInit : new Uint8Array();
    message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? _client_v1_client__WEBPACK_IMPORTED_MODULE_1__.Height.fromPartial(object.proofHeight) : undefined;
    message.signer = (_object$signer2 = object.signer) !== null && _object$signer2 !== void 0 ? _object$signer2 : "";
    return message;
  },

  fromAmino(object) {
    return {
      portId: object.port_id,
      previousChannelId: object.previous_channel_id,
      channel: object !== null && object !== void 0 && object.channel ? _channel__WEBPACK_IMPORTED_MODULE_0__.Channel.fromAmino(object.channel) : undefined,
      counterpartyVersion: object.counterparty_version,
      proofInit: object.proof_init,
      proofHeight: object !== null && object !== void 0 && object.proof_height ? _client_v1_client__WEBPACK_IMPORTED_MODULE_1__.Height.fromAmino(object.proof_height) : undefined,
      signer: object.signer
    };
  },

  toAmino(message) {
    const obj = {};
    obj.port_id = message.portId;
    obj.previous_channel_id = message.previousChannelId;
    obj.channel = message.channel ? _channel__WEBPACK_IMPORTED_MODULE_0__.Channel.toAmino(message.channel) : undefined;
    obj.counterparty_version = message.counterpartyVersion;
    obj.proof_init = message.proofInit;
    obj.proof_height = message.proofHeight ? _client_v1_client__WEBPACK_IMPORTED_MODULE_1__.Height.toAmino(message.proofHeight) : {};
    obj.signer = message.signer;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgChannelOpenTry.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/MsgChannelOpenTry",
      value: MsgChannelOpenTry.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgChannelOpenTry.decode(message.value);
  },

  toProto(message) {
    return MsgChannelOpenTry.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.channel.v1.MsgChannelOpenTry",
      value: MsgChannelOpenTry.encode(message).finish()
    };
  }

};

function createBaseMsgChannelOpenTryResponse() {
  return {
    version: "",
    channelId: ""
  };
}

const MsgChannelOpenTryResponse = {
  typeUrl: "/ibc.core.channel.v1.MsgChannelOpenTryResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.version !== "") {
      writer.uint32(10).string(message.version);
    }

    if (message.channelId !== "") {
      writer.uint32(18).string(message.channelId);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgChannelOpenTryResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.version = reader.string();
          break;

        case 2:
          message.channelId = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$version2, _object$channelId2;

    const message = createBaseMsgChannelOpenTryResponse();
    message.version = (_object$version2 = object.version) !== null && _object$version2 !== void 0 ? _object$version2 : "";
    message.channelId = (_object$channelId2 = object.channelId) !== null && _object$channelId2 !== void 0 ? _object$channelId2 : "";
    return message;
  },

  fromAmino(object) {
    return {
      version: object.version,
      channelId: object.channel_id
    };
  },

  toAmino(message) {
    const obj = {};
    obj.version = message.version;
    obj.channel_id = message.channelId;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgChannelOpenTryResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/MsgChannelOpenTryResponse",
      value: MsgChannelOpenTryResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgChannelOpenTryResponse.decode(message.value);
  },

  toProto(message) {
    return MsgChannelOpenTryResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.channel.v1.MsgChannelOpenTryResponse",
      value: MsgChannelOpenTryResponse.encode(message).finish()
    };
  }

};

function createBaseMsgChannelOpenAck() {
  return {
    portId: "",
    channelId: "",
    counterpartyChannelId: "",
    counterpartyVersion: "",
    proofTry: new Uint8Array(),
    proofHeight: undefined,
    signer: ""
  };
}

const MsgChannelOpenAck = {
  typeUrl: "/ibc.core.channel.v1.MsgChannelOpenAck",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.portId !== "") {
      writer.uint32(10).string(message.portId);
    }

    if (message.channelId !== "") {
      writer.uint32(18).string(message.channelId);
    }

    if (message.counterpartyChannelId !== "") {
      writer.uint32(26).string(message.counterpartyChannelId);
    }

    if (message.counterpartyVersion !== "") {
      writer.uint32(34).string(message.counterpartyVersion);
    }

    if (message.proofTry.length !== 0) {
      writer.uint32(42).bytes(message.proofTry);
    }

    if (message.proofHeight !== undefined) {
      _client_v1_client__WEBPACK_IMPORTED_MODULE_1__.Height.encode(message.proofHeight, writer.uint32(50).fork()).ldelim();
    }

    if (message.signer !== "") {
      writer.uint32(58).string(message.signer);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgChannelOpenAck();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.portId = reader.string();
          break;

        case 2:
          message.channelId = reader.string();
          break;

        case 3:
          message.counterpartyChannelId = reader.string();
          break;

        case 4:
          message.counterpartyVersion = reader.string();
          break;

        case 5:
          message.proofTry = reader.bytes();
          break;

        case 6:
          message.proofHeight = _client_v1_client__WEBPACK_IMPORTED_MODULE_1__.Height.decode(reader, reader.uint32());
          break;

        case 7:
          message.signer = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$portId3, _object$channelId3, _object$counterpartyC, _object$counterpartyV2, _object$proofTry, _object$signer3;

    const message = createBaseMsgChannelOpenAck();
    message.portId = (_object$portId3 = object.portId) !== null && _object$portId3 !== void 0 ? _object$portId3 : "";
    message.channelId = (_object$channelId3 = object.channelId) !== null && _object$channelId3 !== void 0 ? _object$channelId3 : "";
    message.counterpartyChannelId = (_object$counterpartyC = object.counterpartyChannelId) !== null && _object$counterpartyC !== void 0 ? _object$counterpartyC : "";
    message.counterpartyVersion = (_object$counterpartyV2 = object.counterpartyVersion) !== null && _object$counterpartyV2 !== void 0 ? _object$counterpartyV2 : "";
    message.proofTry = (_object$proofTry = object.proofTry) !== null && _object$proofTry !== void 0 ? _object$proofTry : new Uint8Array();
    message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? _client_v1_client__WEBPACK_IMPORTED_MODULE_1__.Height.fromPartial(object.proofHeight) : undefined;
    message.signer = (_object$signer3 = object.signer) !== null && _object$signer3 !== void 0 ? _object$signer3 : "";
    return message;
  },

  fromAmino(object) {
    return {
      portId: object.port_id,
      channelId: object.channel_id,
      counterpartyChannelId: object.counterparty_channel_id,
      counterpartyVersion: object.counterparty_version,
      proofTry: object.proof_try,
      proofHeight: object !== null && object !== void 0 && object.proof_height ? _client_v1_client__WEBPACK_IMPORTED_MODULE_1__.Height.fromAmino(object.proof_height) : undefined,
      signer: object.signer
    };
  },

  toAmino(message) {
    const obj = {};
    obj.port_id = message.portId;
    obj.channel_id = message.channelId;
    obj.counterparty_channel_id = message.counterpartyChannelId;
    obj.counterparty_version = message.counterpartyVersion;
    obj.proof_try = message.proofTry;
    obj.proof_height = message.proofHeight ? _client_v1_client__WEBPACK_IMPORTED_MODULE_1__.Height.toAmino(message.proofHeight) : {};
    obj.signer = message.signer;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgChannelOpenAck.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/MsgChannelOpenAck",
      value: MsgChannelOpenAck.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgChannelOpenAck.decode(message.value);
  },

  toProto(message) {
    return MsgChannelOpenAck.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.channel.v1.MsgChannelOpenAck",
      value: MsgChannelOpenAck.encode(message).finish()
    };
  }

};

function createBaseMsgChannelOpenAckResponse() {
  return {};
}

const MsgChannelOpenAckResponse = {
  typeUrl: "/ibc.core.channel.v1.MsgChannelOpenAckResponse",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgChannelOpenAckResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseMsgChannelOpenAckResponse();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return MsgChannelOpenAckResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/MsgChannelOpenAckResponse",
      value: MsgChannelOpenAckResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgChannelOpenAckResponse.decode(message.value);
  },

  toProto(message) {
    return MsgChannelOpenAckResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.channel.v1.MsgChannelOpenAckResponse",
      value: MsgChannelOpenAckResponse.encode(message).finish()
    };
  }

};

function createBaseMsgChannelOpenConfirm() {
  return {
    portId: "",
    channelId: "",
    proofAck: new Uint8Array(),
    proofHeight: undefined,
    signer: ""
  };
}

const MsgChannelOpenConfirm = {
  typeUrl: "/ibc.core.channel.v1.MsgChannelOpenConfirm",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.portId !== "") {
      writer.uint32(10).string(message.portId);
    }

    if (message.channelId !== "") {
      writer.uint32(18).string(message.channelId);
    }

    if (message.proofAck.length !== 0) {
      writer.uint32(26).bytes(message.proofAck);
    }

    if (message.proofHeight !== undefined) {
      _client_v1_client__WEBPACK_IMPORTED_MODULE_1__.Height.encode(message.proofHeight, writer.uint32(34).fork()).ldelim();
    }

    if (message.signer !== "") {
      writer.uint32(42).string(message.signer);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgChannelOpenConfirm();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.portId = reader.string();
          break;

        case 2:
          message.channelId = reader.string();
          break;

        case 3:
          message.proofAck = reader.bytes();
          break;

        case 4:
          message.proofHeight = _client_v1_client__WEBPACK_IMPORTED_MODULE_1__.Height.decode(reader, reader.uint32());
          break;

        case 5:
          message.signer = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$portId4, _object$channelId4, _object$proofAck, _object$signer4;

    const message = createBaseMsgChannelOpenConfirm();
    message.portId = (_object$portId4 = object.portId) !== null && _object$portId4 !== void 0 ? _object$portId4 : "";
    message.channelId = (_object$channelId4 = object.channelId) !== null && _object$channelId4 !== void 0 ? _object$channelId4 : "";
    message.proofAck = (_object$proofAck = object.proofAck) !== null && _object$proofAck !== void 0 ? _object$proofAck : new Uint8Array();
    message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? _client_v1_client__WEBPACK_IMPORTED_MODULE_1__.Height.fromPartial(object.proofHeight) : undefined;
    message.signer = (_object$signer4 = object.signer) !== null && _object$signer4 !== void 0 ? _object$signer4 : "";
    return message;
  },

  fromAmino(object) {
    return {
      portId: object.port_id,
      channelId: object.channel_id,
      proofAck: object.proof_ack,
      proofHeight: object !== null && object !== void 0 && object.proof_height ? _client_v1_client__WEBPACK_IMPORTED_MODULE_1__.Height.fromAmino(object.proof_height) : undefined,
      signer: object.signer
    };
  },

  toAmino(message) {
    const obj = {};
    obj.port_id = message.portId;
    obj.channel_id = message.channelId;
    obj.proof_ack = message.proofAck;
    obj.proof_height = message.proofHeight ? _client_v1_client__WEBPACK_IMPORTED_MODULE_1__.Height.toAmino(message.proofHeight) : {};
    obj.signer = message.signer;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgChannelOpenConfirm.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/MsgChannelOpenConfirm",
      value: MsgChannelOpenConfirm.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgChannelOpenConfirm.decode(message.value);
  },

  toProto(message) {
    return MsgChannelOpenConfirm.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.channel.v1.MsgChannelOpenConfirm",
      value: MsgChannelOpenConfirm.encode(message).finish()
    };
  }

};

function createBaseMsgChannelOpenConfirmResponse() {
  return {};
}

const MsgChannelOpenConfirmResponse = {
  typeUrl: "/ibc.core.channel.v1.MsgChannelOpenConfirmResponse",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgChannelOpenConfirmResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseMsgChannelOpenConfirmResponse();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return MsgChannelOpenConfirmResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/MsgChannelOpenConfirmResponse",
      value: MsgChannelOpenConfirmResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgChannelOpenConfirmResponse.decode(message.value);
  },

  toProto(message) {
    return MsgChannelOpenConfirmResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.channel.v1.MsgChannelOpenConfirmResponse",
      value: MsgChannelOpenConfirmResponse.encode(message).finish()
    };
  }

};

function createBaseMsgChannelCloseInit() {
  return {
    portId: "",
    channelId: "",
    signer: ""
  };
}

const MsgChannelCloseInit = {
  typeUrl: "/ibc.core.channel.v1.MsgChannelCloseInit",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.portId !== "") {
      writer.uint32(10).string(message.portId);
    }

    if (message.channelId !== "") {
      writer.uint32(18).string(message.channelId);
    }

    if (message.signer !== "") {
      writer.uint32(26).string(message.signer);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgChannelCloseInit();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.portId = reader.string();
          break;

        case 2:
          message.channelId = reader.string();
          break;

        case 3:
          message.signer = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$portId5, _object$channelId5, _object$signer5;

    const message = createBaseMsgChannelCloseInit();
    message.portId = (_object$portId5 = object.portId) !== null && _object$portId5 !== void 0 ? _object$portId5 : "";
    message.channelId = (_object$channelId5 = object.channelId) !== null && _object$channelId5 !== void 0 ? _object$channelId5 : "";
    message.signer = (_object$signer5 = object.signer) !== null && _object$signer5 !== void 0 ? _object$signer5 : "";
    return message;
  },

  fromAmino(object) {
    return {
      portId: object.port_id,
      channelId: object.channel_id,
      signer: object.signer
    };
  },

  toAmino(message) {
    const obj = {};
    obj.port_id = message.portId;
    obj.channel_id = message.channelId;
    obj.signer = message.signer;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgChannelCloseInit.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/MsgChannelCloseInit",
      value: MsgChannelCloseInit.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgChannelCloseInit.decode(message.value);
  },

  toProto(message) {
    return MsgChannelCloseInit.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.channel.v1.MsgChannelCloseInit",
      value: MsgChannelCloseInit.encode(message).finish()
    };
  }

};

function createBaseMsgChannelCloseInitResponse() {
  return {};
}

const MsgChannelCloseInitResponse = {
  typeUrl: "/ibc.core.channel.v1.MsgChannelCloseInitResponse",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgChannelCloseInitResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseMsgChannelCloseInitResponse();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return MsgChannelCloseInitResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/MsgChannelCloseInitResponse",
      value: MsgChannelCloseInitResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgChannelCloseInitResponse.decode(message.value);
  },

  toProto(message) {
    return MsgChannelCloseInitResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.channel.v1.MsgChannelCloseInitResponse",
      value: MsgChannelCloseInitResponse.encode(message).finish()
    };
  }

};

function createBaseMsgChannelCloseConfirm() {
  return {
    portId: "",
    channelId: "",
    proofInit: new Uint8Array(),
    proofHeight: undefined,
    signer: ""
  };
}

const MsgChannelCloseConfirm = {
  typeUrl: "/ibc.core.channel.v1.MsgChannelCloseConfirm",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.portId !== "") {
      writer.uint32(10).string(message.portId);
    }

    if (message.channelId !== "") {
      writer.uint32(18).string(message.channelId);
    }

    if (message.proofInit.length !== 0) {
      writer.uint32(26).bytes(message.proofInit);
    }

    if (message.proofHeight !== undefined) {
      _client_v1_client__WEBPACK_IMPORTED_MODULE_1__.Height.encode(message.proofHeight, writer.uint32(34).fork()).ldelim();
    }

    if (message.signer !== "") {
      writer.uint32(42).string(message.signer);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgChannelCloseConfirm();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.portId = reader.string();
          break;

        case 2:
          message.channelId = reader.string();
          break;

        case 3:
          message.proofInit = reader.bytes();
          break;

        case 4:
          message.proofHeight = _client_v1_client__WEBPACK_IMPORTED_MODULE_1__.Height.decode(reader, reader.uint32());
          break;

        case 5:
          message.signer = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$portId6, _object$channelId6, _object$proofInit2, _object$signer6;

    const message = createBaseMsgChannelCloseConfirm();
    message.portId = (_object$portId6 = object.portId) !== null && _object$portId6 !== void 0 ? _object$portId6 : "";
    message.channelId = (_object$channelId6 = object.channelId) !== null && _object$channelId6 !== void 0 ? _object$channelId6 : "";
    message.proofInit = (_object$proofInit2 = object.proofInit) !== null && _object$proofInit2 !== void 0 ? _object$proofInit2 : new Uint8Array();
    message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? _client_v1_client__WEBPACK_IMPORTED_MODULE_1__.Height.fromPartial(object.proofHeight) : undefined;
    message.signer = (_object$signer6 = object.signer) !== null && _object$signer6 !== void 0 ? _object$signer6 : "";
    return message;
  },

  fromAmino(object) {
    return {
      portId: object.port_id,
      channelId: object.channel_id,
      proofInit: object.proof_init,
      proofHeight: object !== null && object !== void 0 && object.proof_height ? _client_v1_client__WEBPACK_IMPORTED_MODULE_1__.Height.fromAmino(object.proof_height) : undefined,
      signer: object.signer
    };
  },

  toAmino(message) {
    const obj = {};
    obj.port_id = message.portId;
    obj.channel_id = message.channelId;
    obj.proof_init = message.proofInit;
    obj.proof_height = message.proofHeight ? _client_v1_client__WEBPACK_IMPORTED_MODULE_1__.Height.toAmino(message.proofHeight) : {};
    obj.signer = message.signer;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgChannelCloseConfirm.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/MsgChannelCloseConfirm",
      value: MsgChannelCloseConfirm.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgChannelCloseConfirm.decode(message.value);
  },

  toProto(message) {
    return MsgChannelCloseConfirm.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.channel.v1.MsgChannelCloseConfirm",
      value: MsgChannelCloseConfirm.encode(message).finish()
    };
  }

};

function createBaseMsgChannelCloseConfirmResponse() {
  return {};
}

const MsgChannelCloseConfirmResponse = {
  typeUrl: "/ibc.core.channel.v1.MsgChannelCloseConfirmResponse",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgChannelCloseConfirmResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseMsgChannelCloseConfirmResponse();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return MsgChannelCloseConfirmResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/MsgChannelCloseConfirmResponse",
      value: MsgChannelCloseConfirmResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgChannelCloseConfirmResponse.decode(message.value);
  },

  toProto(message) {
    return MsgChannelCloseConfirmResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.channel.v1.MsgChannelCloseConfirmResponse",
      value: MsgChannelCloseConfirmResponse.encode(message).finish()
    };
  }

};

function createBaseMsgRecvPacket() {
  return {
    packet: undefined,
    proofCommitment: new Uint8Array(),
    proofHeight: undefined,
    signer: ""
  };
}

const MsgRecvPacket = {
  typeUrl: "/ibc.core.channel.v1.MsgRecvPacket",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.packet !== undefined) {
      _channel__WEBPACK_IMPORTED_MODULE_0__.Packet.encode(message.packet, writer.uint32(10).fork()).ldelim();
    }

    if (message.proofCommitment.length !== 0) {
      writer.uint32(18).bytes(message.proofCommitment);
    }

    if (message.proofHeight !== undefined) {
      _client_v1_client__WEBPACK_IMPORTED_MODULE_1__.Height.encode(message.proofHeight, writer.uint32(26).fork()).ldelim();
    }

    if (message.signer !== "") {
      writer.uint32(34).string(message.signer);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgRecvPacket();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.packet = _channel__WEBPACK_IMPORTED_MODULE_0__.Packet.decode(reader, reader.uint32());
          break;

        case 2:
          message.proofCommitment = reader.bytes();
          break;

        case 3:
          message.proofHeight = _client_v1_client__WEBPACK_IMPORTED_MODULE_1__.Height.decode(reader, reader.uint32());
          break;

        case 4:
          message.signer = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$proofCommitme, _object$signer7;

    const message = createBaseMsgRecvPacket();
    message.packet = object.packet !== undefined && object.packet !== null ? _channel__WEBPACK_IMPORTED_MODULE_0__.Packet.fromPartial(object.packet) : undefined;
    message.proofCommitment = (_object$proofCommitme = object.proofCommitment) !== null && _object$proofCommitme !== void 0 ? _object$proofCommitme : new Uint8Array();
    message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? _client_v1_client__WEBPACK_IMPORTED_MODULE_1__.Height.fromPartial(object.proofHeight) : undefined;
    message.signer = (_object$signer7 = object.signer) !== null && _object$signer7 !== void 0 ? _object$signer7 : "";
    return message;
  },

  fromAmino(object) {
    return {
      packet: object !== null && object !== void 0 && object.packet ? _channel__WEBPACK_IMPORTED_MODULE_0__.Packet.fromAmino(object.packet) : undefined,
      proofCommitment: object.proof_commitment,
      proofHeight: object !== null && object !== void 0 && object.proof_height ? _client_v1_client__WEBPACK_IMPORTED_MODULE_1__.Height.fromAmino(object.proof_height) : undefined,
      signer: object.signer
    };
  },

  toAmino(message) {
    const obj = {};
    obj.packet = message.packet ? _channel__WEBPACK_IMPORTED_MODULE_0__.Packet.toAmino(message.packet) : undefined;
    obj.proof_commitment = message.proofCommitment;
    obj.proof_height = message.proofHeight ? _client_v1_client__WEBPACK_IMPORTED_MODULE_1__.Height.toAmino(message.proofHeight) : {};
    obj.signer = message.signer;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgRecvPacket.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/MsgRecvPacket",
      value: MsgRecvPacket.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgRecvPacket.decode(message.value);
  },

  toProto(message) {
    return MsgRecvPacket.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.channel.v1.MsgRecvPacket",
      value: MsgRecvPacket.encode(message).finish()
    };
  }

};

function createBaseMsgRecvPacketResponse() {
  return {
    result: 0
  };
}

const MsgRecvPacketResponse = {
  typeUrl: "/ibc.core.channel.v1.MsgRecvPacketResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.result !== 0) {
      writer.uint32(8).int32(message.result);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgRecvPacketResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.result = reader.int32();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$result;

    const message = createBaseMsgRecvPacketResponse();
    message.result = (_object$result = object.result) !== null && _object$result !== void 0 ? _object$result : 0;
    return message;
  },

  fromAmino(object) {
    return {
      result: (0,_helpers__WEBPACK_IMPORTED_MODULE_2__/* .isSet */ .DM)(object.result) ? responseResultTypeFromJSON(object.result) : 0
    };
  },

  toAmino(message) {
    const obj = {};
    obj.result = message.result;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgRecvPacketResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/MsgRecvPacketResponse",
      value: MsgRecvPacketResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgRecvPacketResponse.decode(message.value);
  },

  toProto(message) {
    return MsgRecvPacketResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.channel.v1.MsgRecvPacketResponse",
      value: MsgRecvPacketResponse.encode(message).finish()
    };
  }

};

function createBaseMsgTimeout() {
  return {
    packet: undefined,
    proofUnreceived: new Uint8Array(),
    proofHeight: undefined,
    nextSequenceRecv: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO,
    signer: ""
  };
}

const MsgTimeout = {
  typeUrl: "/ibc.core.channel.v1.MsgTimeout",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.packet !== undefined) {
      _channel__WEBPACK_IMPORTED_MODULE_0__.Packet.encode(message.packet, writer.uint32(10).fork()).ldelim();
    }

    if (message.proofUnreceived.length !== 0) {
      writer.uint32(18).bytes(message.proofUnreceived);
    }

    if (message.proofHeight !== undefined) {
      _client_v1_client__WEBPACK_IMPORTED_MODULE_1__.Height.encode(message.proofHeight, writer.uint32(26).fork()).ldelim();
    }

    if (!message.nextSequenceRecv.isZero()) {
      writer.uint32(32).uint64(message.nextSequenceRecv);
    }

    if (message.signer !== "") {
      writer.uint32(42).string(message.signer);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgTimeout();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.packet = _channel__WEBPACK_IMPORTED_MODULE_0__.Packet.decode(reader, reader.uint32());
          break;

        case 2:
          message.proofUnreceived = reader.bytes();
          break;

        case 3:
          message.proofHeight = _client_v1_client__WEBPACK_IMPORTED_MODULE_1__.Height.decode(reader, reader.uint32());
          break;

        case 4:
          message.nextSequenceRecv = reader.uint64();
          break;

        case 5:
          message.signer = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$proofUnreceiv, _object$signer8;

    const message = createBaseMsgTimeout();
    message.packet = object.packet !== undefined && object.packet !== null ? _channel__WEBPACK_IMPORTED_MODULE_0__.Packet.fromPartial(object.packet) : undefined;
    message.proofUnreceived = (_object$proofUnreceiv = object.proofUnreceived) !== null && _object$proofUnreceiv !== void 0 ? _object$proofUnreceiv : new Uint8Array();
    message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? _client_v1_client__WEBPACK_IMPORTED_MODULE_1__.Height.fromPartial(object.proofHeight) : undefined;
    message.nextSequenceRecv = object.nextSequenceRecv !== undefined && object.nextSequenceRecv !== null ? _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromValue */ .dK.fromValue(object.nextSequenceRecv) : _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO;
    message.signer = (_object$signer8 = object.signer) !== null && _object$signer8 !== void 0 ? _object$signer8 : "";
    return message;
  },

  fromAmino(object) {
    return {
      packet: object !== null && object !== void 0 && object.packet ? _channel__WEBPACK_IMPORTED_MODULE_0__.Packet.fromAmino(object.packet) : undefined,
      proofUnreceived: object.proof_unreceived,
      proofHeight: object !== null && object !== void 0 && object.proof_height ? _client_v1_client__WEBPACK_IMPORTED_MODULE_1__.Height.fromAmino(object.proof_height) : undefined,
      nextSequenceRecv: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromString */ .dK.fromString(object.next_sequence_recv),
      signer: object.signer
    };
  },

  toAmino(message) {
    const obj = {};
    obj.packet = message.packet ? _channel__WEBPACK_IMPORTED_MODULE_0__.Packet.toAmino(message.packet) : undefined;
    obj.proof_unreceived = message.proofUnreceived;
    obj.proof_height = message.proofHeight ? _client_v1_client__WEBPACK_IMPORTED_MODULE_1__.Height.toAmino(message.proofHeight) : {};
    obj.next_sequence_recv = message.nextSequenceRecv ? message.nextSequenceRecv.toString() : undefined;
    obj.signer = message.signer;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgTimeout.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/MsgTimeout",
      value: MsgTimeout.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgTimeout.decode(message.value);
  },

  toProto(message) {
    return MsgTimeout.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.channel.v1.MsgTimeout",
      value: MsgTimeout.encode(message).finish()
    };
  }

};

function createBaseMsgTimeoutResponse() {
  return {
    result: 0
  };
}

const MsgTimeoutResponse = {
  typeUrl: "/ibc.core.channel.v1.MsgTimeoutResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.result !== 0) {
      writer.uint32(8).int32(message.result);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgTimeoutResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.result = reader.int32();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$result2;

    const message = createBaseMsgTimeoutResponse();
    message.result = (_object$result2 = object.result) !== null && _object$result2 !== void 0 ? _object$result2 : 0;
    return message;
  },

  fromAmino(object) {
    return {
      result: (0,_helpers__WEBPACK_IMPORTED_MODULE_2__/* .isSet */ .DM)(object.result) ? responseResultTypeFromJSON(object.result) : 0
    };
  },

  toAmino(message) {
    const obj = {};
    obj.result = message.result;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgTimeoutResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/MsgTimeoutResponse",
      value: MsgTimeoutResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgTimeoutResponse.decode(message.value);
  },

  toProto(message) {
    return MsgTimeoutResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.channel.v1.MsgTimeoutResponse",
      value: MsgTimeoutResponse.encode(message).finish()
    };
  }

};

function createBaseMsgTimeoutOnClose() {
  return {
    packet: undefined,
    proofUnreceived: new Uint8Array(),
    proofClose: new Uint8Array(),
    proofHeight: undefined,
    nextSequenceRecv: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO,
    signer: ""
  };
}

const MsgTimeoutOnClose = {
  typeUrl: "/ibc.core.channel.v1.MsgTimeoutOnClose",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.packet !== undefined) {
      _channel__WEBPACK_IMPORTED_MODULE_0__.Packet.encode(message.packet, writer.uint32(10).fork()).ldelim();
    }

    if (message.proofUnreceived.length !== 0) {
      writer.uint32(18).bytes(message.proofUnreceived);
    }

    if (message.proofClose.length !== 0) {
      writer.uint32(26).bytes(message.proofClose);
    }

    if (message.proofHeight !== undefined) {
      _client_v1_client__WEBPACK_IMPORTED_MODULE_1__.Height.encode(message.proofHeight, writer.uint32(34).fork()).ldelim();
    }

    if (!message.nextSequenceRecv.isZero()) {
      writer.uint32(40).uint64(message.nextSequenceRecv);
    }

    if (message.signer !== "") {
      writer.uint32(50).string(message.signer);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgTimeoutOnClose();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.packet = _channel__WEBPACK_IMPORTED_MODULE_0__.Packet.decode(reader, reader.uint32());
          break;

        case 2:
          message.proofUnreceived = reader.bytes();
          break;

        case 3:
          message.proofClose = reader.bytes();
          break;

        case 4:
          message.proofHeight = _client_v1_client__WEBPACK_IMPORTED_MODULE_1__.Height.decode(reader, reader.uint32());
          break;

        case 5:
          message.nextSequenceRecv = reader.uint64();
          break;

        case 6:
          message.signer = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$proofUnreceiv2, _object$proofClose, _object$signer9;

    const message = createBaseMsgTimeoutOnClose();
    message.packet = object.packet !== undefined && object.packet !== null ? _channel__WEBPACK_IMPORTED_MODULE_0__.Packet.fromPartial(object.packet) : undefined;
    message.proofUnreceived = (_object$proofUnreceiv2 = object.proofUnreceived) !== null && _object$proofUnreceiv2 !== void 0 ? _object$proofUnreceiv2 : new Uint8Array();
    message.proofClose = (_object$proofClose = object.proofClose) !== null && _object$proofClose !== void 0 ? _object$proofClose : new Uint8Array();
    message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? _client_v1_client__WEBPACK_IMPORTED_MODULE_1__.Height.fromPartial(object.proofHeight) : undefined;
    message.nextSequenceRecv = object.nextSequenceRecv !== undefined && object.nextSequenceRecv !== null ? _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromValue */ .dK.fromValue(object.nextSequenceRecv) : _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO;
    message.signer = (_object$signer9 = object.signer) !== null && _object$signer9 !== void 0 ? _object$signer9 : "";
    return message;
  },

  fromAmino(object) {
    return {
      packet: object !== null && object !== void 0 && object.packet ? _channel__WEBPACK_IMPORTED_MODULE_0__.Packet.fromAmino(object.packet) : undefined,
      proofUnreceived: object.proof_unreceived,
      proofClose: object.proof_close,
      proofHeight: object !== null && object !== void 0 && object.proof_height ? _client_v1_client__WEBPACK_IMPORTED_MODULE_1__.Height.fromAmino(object.proof_height) : undefined,
      nextSequenceRecv: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromString */ .dK.fromString(object.next_sequence_recv),
      signer: object.signer
    };
  },

  toAmino(message) {
    const obj = {};
    obj.packet = message.packet ? _channel__WEBPACK_IMPORTED_MODULE_0__.Packet.toAmino(message.packet) : undefined;
    obj.proof_unreceived = message.proofUnreceived;
    obj.proof_close = message.proofClose;
    obj.proof_height = message.proofHeight ? _client_v1_client__WEBPACK_IMPORTED_MODULE_1__.Height.toAmino(message.proofHeight) : {};
    obj.next_sequence_recv = message.nextSequenceRecv ? message.nextSequenceRecv.toString() : undefined;
    obj.signer = message.signer;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgTimeoutOnClose.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/MsgTimeoutOnClose",
      value: MsgTimeoutOnClose.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgTimeoutOnClose.decode(message.value);
  },

  toProto(message) {
    return MsgTimeoutOnClose.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.channel.v1.MsgTimeoutOnClose",
      value: MsgTimeoutOnClose.encode(message).finish()
    };
  }

};

function createBaseMsgTimeoutOnCloseResponse() {
  return {
    result: 0
  };
}

const MsgTimeoutOnCloseResponse = {
  typeUrl: "/ibc.core.channel.v1.MsgTimeoutOnCloseResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.result !== 0) {
      writer.uint32(8).int32(message.result);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgTimeoutOnCloseResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.result = reader.int32();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$result3;

    const message = createBaseMsgTimeoutOnCloseResponse();
    message.result = (_object$result3 = object.result) !== null && _object$result3 !== void 0 ? _object$result3 : 0;
    return message;
  },

  fromAmino(object) {
    return {
      result: (0,_helpers__WEBPACK_IMPORTED_MODULE_2__/* .isSet */ .DM)(object.result) ? responseResultTypeFromJSON(object.result) : 0
    };
  },

  toAmino(message) {
    const obj = {};
    obj.result = message.result;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgTimeoutOnCloseResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/MsgTimeoutOnCloseResponse",
      value: MsgTimeoutOnCloseResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgTimeoutOnCloseResponse.decode(message.value);
  },

  toProto(message) {
    return MsgTimeoutOnCloseResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.channel.v1.MsgTimeoutOnCloseResponse",
      value: MsgTimeoutOnCloseResponse.encode(message).finish()
    };
  }

};

function createBaseMsgAcknowledgement() {
  return {
    packet: undefined,
    acknowledgement: new Uint8Array(),
    proofAcked: new Uint8Array(),
    proofHeight: undefined,
    signer: ""
  };
}

const MsgAcknowledgement = {
  typeUrl: "/ibc.core.channel.v1.MsgAcknowledgement",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.packet !== undefined) {
      _channel__WEBPACK_IMPORTED_MODULE_0__.Packet.encode(message.packet, writer.uint32(10).fork()).ldelim();
    }

    if (message.acknowledgement.length !== 0) {
      writer.uint32(18).bytes(message.acknowledgement);
    }

    if (message.proofAcked.length !== 0) {
      writer.uint32(26).bytes(message.proofAcked);
    }

    if (message.proofHeight !== undefined) {
      _client_v1_client__WEBPACK_IMPORTED_MODULE_1__.Height.encode(message.proofHeight, writer.uint32(34).fork()).ldelim();
    }

    if (message.signer !== "") {
      writer.uint32(42).string(message.signer);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgAcknowledgement();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.packet = _channel__WEBPACK_IMPORTED_MODULE_0__.Packet.decode(reader, reader.uint32());
          break;

        case 2:
          message.acknowledgement = reader.bytes();
          break;

        case 3:
          message.proofAcked = reader.bytes();
          break;

        case 4:
          message.proofHeight = _client_v1_client__WEBPACK_IMPORTED_MODULE_1__.Height.decode(reader, reader.uint32());
          break;

        case 5:
          message.signer = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$acknowledgeme, _object$proofAcked, _object$signer10;

    const message = createBaseMsgAcknowledgement();
    message.packet = object.packet !== undefined && object.packet !== null ? _channel__WEBPACK_IMPORTED_MODULE_0__.Packet.fromPartial(object.packet) : undefined;
    message.acknowledgement = (_object$acknowledgeme = object.acknowledgement) !== null && _object$acknowledgeme !== void 0 ? _object$acknowledgeme : new Uint8Array();
    message.proofAcked = (_object$proofAcked = object.proofAcked) !== null && _object$proofAcked !== void 0 ? _object$proofAcked : new Uint8Array();
    message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? _client_v1_client__WEBPACK_IMPORTED_MODULE_1__.Height.fromPartial(object.proofHeight) : undefined;
    message.signer = (_object$signer10 = object.signer) !== null && _object$signer10 !== void 0 ? _object$signer10 : "";
    return message;
  },

  fromAmino(object) {
    return {
      packet: object !== null && object !== void 0 && object.packet ? _channel__WEBPACK_IMPORTED_MODULE_0__.Packet.fromAmino(object.packet) : undefined,
      acknowledgement: object.acknowledgement,
      proofAcked: object.proof_acked,
      proofHeight: object !== null && object !== void 0 && object.proof_height ? _client_v1_client__WEBPACK_IMPORTED_MODULE_1__.Height.fromAmino(object.proof_height) : undefined,
      signer: object.signer
    };
  },

  toAmino(message) {
    const obj = {};
    obj.packet = message.packet ? _channel__WEBPACK_IMPORTED_MODULE_0__.Packet.toAmino(message.packet) : undefined;
    obj.acknowledgement = message.acknowledgement;
    obj.proof_acked = message.proofAcked;
    obj.proof_height = message.proofHeight ? _client_v1_client__WEBPACK_IMPORTED_MODULE_1__.Height.toAmino(message.proofHeight) : {};
    obj.signer = message.signer;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgAcknowledgement.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/MsgAcknowledgement",
      value: MsgAcknowledgement.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgAcknowledgement.decode(message.value);
  },

  toProto(message) {
    return MsgAcknowledgement.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.channel.v1.MsgAcknowledgement",
      value: MsgAcknowledgement.encode(message).finish()
    };
  }

};

function createBaseMsgAcknowledgementResponse() {
  return {
    result: 0
  };
}

const MsgAcknowledgementResponse = {
  typeUrl: "/ibc.core.channel.v1.MsgAcknowledgementResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.result !== 0) {
      writer.uint32(8).int32(message.result);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgAcknowledgementResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.result = reader.int32();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$result4;

    const message = createBaseMsgAcknowledgementResponse();
    message.result = (_object$result4 = object.result) !== null && _object$result4 !== void 0 ? _object$result4 : 0;
    return message;
  },

  fromAmino(object) {
    return {
      result: (0,_helpers__WEBPACK_IMPORTED_MODULE_2__/* .isSet */ .DM)(object.result) ? responseResultTypeFromJSON(object.result) : 0
    };
  },

  toAmino(message) {
    const obj = {};
    obj.result = message.result;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgAcknowledgementResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/MsgAcknowledgementResponse",
      value: MsgAcknowledgementResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgAcknowledgementResponse.decode(message.value);
  },

  toProto(message) {
    return MsgAcknowledgementResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.channel.v1.MsgAcknowledgementResponse",
      value: MsgAcknowledgementResponse.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 81922:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MsgClientImpl": function() { return /* binding */ MsgClientImpl; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4942);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _tx__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63239);



/** Msg defines the ibc/channel Msg service. */

class MsgClientImpl {
  constructor(rpc) {
    (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, "rpc", void 0);

    this.rpc = rpc;
    this.channelOpenInit = this.channelOpenInit.bind(this);
    this.channelOpenTry = this.channelOpenTry.bind(this);
    this.channelOpenAck = this.channelOpenAck.bind(this);
    this.channelOpenConfirm = this.channelOpenConfirm.bind(this);
    this.channelCloseInit = this.channelCloseInit.bind(this);
    this.channelCloseConfirm = this.channelCloseConfirm.bind(this);
    this.recvPacket = this.recvPacket.bind(this);
    this.timeout = this.timeout.bind(this);
    this.timeoutOnClose = this.timeoutOnClose.bind(this);
    this.acknowledgement = this.acknowledgement.bind(this);
  }

  channelOpenInit(request) {
    const data = _tx__WEBPACK_IMPORTED_MODULE_1__.MsgChannelOpenInit.encode(request).finish();
    const promise = this.rpc.request("ibc.core.channel.v1.Msg", "ChannelOpenInit", data);
    return promise.then(data => _tx__WEBPACK_IMPORTED_MODULE_1__.MsgChannelOpenInitResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  channelOpenTry(request) {
    const data = _tx__WEBPACK_IMPORTED_MODULE_1__.MsgChannelOpenTry.encode(request).finish();
    const promise = this.rpc.request("ibc.core.channel.v1.Msg", "ChannelOpenTry", data);
    return promise.then(data => _tx__WEBPACK_IMPORTED_MODULE_1__.MsgChannelOpenTryResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  channelOpenAck(request) {
    const data = _tx__WEBPACK_IMPORTED_MODULE_1__.MsgChannelOpenAck.encode(request).finish();
    const promise = this.rpc.request("ibc.core.channel.v1.Msg", "ChannelOpenAck", data);
    return promise.then(data => _tx__WEBPACK_IMPORTED_MODULE_1__.MsgChannelOpenAckResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  channelOpenConfirm(request) {
    const data = _tx__WEBPACK_IMPORTED_MODULE_1__.MsgChannelOpenConfirm.encode(request).finish();
    const promise = this.rpc.request("ibc.core.channel.v1.Msg", "ChannelOpenConfirm", data);
    return promise.then(data => _tx__WEBPACK_IMPORTED_MODULE_1__.MsgChannelOpenConfirmResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  channelCloseInit(request) {
    const data = _tx__WEBPACK_IMPORTED_MODULE_1__.MsgChannelCloseInit.encode(request).finish();
    const promise = this.rpc.request("ibc.core.channel.v1.Msg", "ChannelCloseInit", data);
    return promise.then(data => _tx__WEBPACK_IMPORTED_MODULE_1__.MsgChannelCloseInitResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  channelCloseConfirm(request) {
    const data = _tx__WEBPACK_IMPORTED_MODULE_1__.MsgChannelCloseConfirm.encode(request).finish();
    const promise = this.rpc.request("ibc.core.channel.v1.Msg", "ChannelCloseConfirm", data);
    return promise.then(data => _tx__WEBPACK_IMPORTED_MODULE_1__.MsgChannelCloseConfirmResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  recvPacket(request) {
    const data = _tx__WEBPACK_IMPORTED_MODULE_1__.MsgRecvPacket.encode(request).finish();
    const promise = this.rpc.request("ibc.core.channel.v1.Msg", "RecvPacket", data);
    return promise.then(data => _tx__WEBPACK_IMPORTED_MODULE_1__.MsgRecvPacketResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  timeout(request) {
    const data = _tx__WEBPACK_IMPORTED_MODULE_1__.MsgTimeout.encode(request).finish();
    const promise = this.rpc.request("ibc.core.channel.v1.Msg", "Timeout", data);
    return promise.then(data => _tx__WEBPACK_IMPORTED_MODULE_1__.MsgTimeoutResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  timeoutOnClose(request) {
    const data = _tx__WEBPACK_IMPORTED_MODULE_1__.MsgTimeoutOnClose.encode(request).finish();
    const promise = this.rpc.request("ibc.core.channel.v1.Msg", "TimeoutOnClose", data);
    return promise.then(data => _tx__WEBPACK_IMPORTED_MODULE_1__.MsgTimeoutOnCloseResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  acknowledgement(request) {
    const data = _tx__WEBPACK_IMPORTED_MODULE_1__.MsgAcknowledgement.encode(request).finish();
    const promise = this.rpc.request("ibc.core.channel.v1.Msg", "Acknowledgement", data);
    return promise.then(data => _tx__WEBPACK_IMPORTED_MODULE_1__.MsgAcknowledgementResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

}

/***/ }),

/***/ 45802:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ClientConsensusStates": function() { return /* binding */ ClientConsensusStates; },
/* harmony export */   "ClientUpdateProposal": function() { return /* binding */ ClientUpdateProposal; },
/* harmony export */   "ConsensusStateWithHeight": function() { return /* binding */ ConsensusStateWithHeight; },
/* harmony export */   "Height": function() { return /* binding */ Height; },
/* harmony export */   "IdentifiedClientState": function() { return /* binding */ IdentifiedClientState; },
/* harmony export */   "Params": function() { return /* binding */ Params; },
/* harmony export */   "UpgradeProposal": function() { return /* binding */ UpgradeProposal; }
/* harmony export */ });
/* harmony import */ var _google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32106);
/* harmony import */ var _cosmos_upgrade_v1beta1_upgrade__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60184);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47895);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__);




/**
 * IdentifiedClientState defines a client state with an additional client
 * identifier field.
 */

function createBaseIdentifiedClientState() {
  return {
    clientId: "",
    clientState: undefined
  };
}

const IdentifiedClientState = {
  typeUrl: "/ibc.core.client.v1.IdentifiedClientState",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.clientId !== "") {
      writer.uint32(10).string(message.clientId);
    }

    if (message.clientState !== undefined) {
      _google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__.Any.encode(message.clientState, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseIdentifiedClientState();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.clientId = reader.string();
          break;

        case 2:
          message.clientState = _google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__.Any.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$clientId;

    const message = createBaseIdentifiedClientState();
    message.clientId = (_object$clientId = object.clientId) !== null && _object$clientId !== void 0 ? _object$clientId : "";
    message.clientState = object.clientState !== undefined && object.clientState !== null ? _google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__.Any.fromPartial(object.clientState) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      clientId: object.client_id,
      clientState: object !== null && object !== void 0 && object.client_state ? _google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__.Any.fromAmino(object.client_state) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.client_id = message.clientId;
    obj.client_state = message.clientState ? _google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__.Any.toAmino(message.clientState) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return IdentifiedClientState.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/IdentifiedClientState",
      value: IdentifiedClientState.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return IdentifiedClientState.decode(message.value);
  },

  toProto(message) {
    return IdentifiedClientState.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.client.v1.IdentifiedClientState",
      value: IdentifiedClientState.encode(message).finish()
    };
  }

};

function createBaseConsensusStateWithHeight() {
  return {
    height: undefined,
    consensusState: undefined
  };
}

const ConsensusStateWithHeight = {
  typeUrl: "/ibc.core.client.v1.ConsensusStateWithHeight",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.height !== undefined) {
      Height.encode(message.height, writer.uint32(10).fork()).ldelim();
    }

    if (message.consensusState !== undefined) {
      _google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__.Any.encode(message.consensusState, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseConsensusStateWithHeight();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.height = Height.decode(reader, reader.uint32());
          break;

        case 2:
          message.consensusState = _google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__.Any.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseConsensusStateWithHeight();
    message.height = object.height !== undefined && object.height !== null ? Height.fromPartial(object.height) : undefined;
    message.consensusState = object.consensusState !== undefined && object.consensusState !== null ? _google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__.Any.fromPartial(object.consensusState) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      height: object !== null && object !== void 0 && object.height ? Height.fromAmino(object.height) : undefined,
      consensusState: object !== null && object !== void 0 && object.consensus_state ? _google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__.Any.fromAmino(object.consensus_state) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.height = message.height ? Height.toAmino(message.height) : undefined;
    obj.consensus_state = message.consensusState ? _google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__.Any.toAmino(message.consensusState) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return ConsensusStateWithHeight.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/ConsensusStateWithHeight",
      value: ConsensusStateWithHeight.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return ConsensusStateWithHeight.decode(message.value);
  },

  toProto(message) {
    return ConsensusStateWithHeight.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.client.v1.ConsensusStateWithHeight",
      value: ConsensusStateWithHeight.encode(message).finish()
    };
  }

};

function createBaseClientConsensusStates() {
  return {
    clientId: "",
    consensusStates: []
  };
}

const ClientConsensusStates = {
  typeUrl: "/ibc.core.client.v1.ClientConsensusStates",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.clientId !== "") {
      writer.uint32(10).string(message.clientId);
    }

    for (const v of message.consensusStates) {
      ConsensusStateWithHeight.encode(v, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseClientConsensusStates();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.clientId = reader.string();
          break;

        case 2:
          message.consensusStates.push(ConsensusStateWithHeight.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$clientId2, _object$consensusStat;

    const message = createBaseClientConsensusStates();
    message.clientId = (_object$clientId2 = object.clientId) !== null && _object$clientId2 !== void 0 ? _object$clientId2 : "";
    message.consensusStates = ((_object$consensusStat = object.consensusStates) === null || _object$consensusStat === void 0 ? void 0 : _object$consensusStat.map(e => ConsensusStateWithHeight.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      clientId: object.client_id,
      consensusStates: Array.isArray(object === null || object === void 0 ? void 0 : object.consensus_states) ? object.consensus_states.map(e => ConsensusStateWithHeight.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.client_id = message.clientId;

    if (message.consensusStates) {
      obj.consensus_states = message.consensusStates.map(e => e ? ConsensusStateWithHeight.toAmino(e) : undefined);
    } else {
      obj.consensus_states = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return ClientConsensusStates.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/ClientConsensusStates",
      value: ClientConsensusStates.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return ClientConsensusStates.decode(message.value);
  },

  toProto(message) {
    return ClientConsensusStates.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.client.v1.ClientConsensusStates",
      value: ClientConsensusStates.encode(message).finish()
    };
  }

};

function createBaseClientUpdateProposal() {
  return {
    $typeUrl: "/ibc.core.client.v1.ClientUpdateProposal",
    title: "",
    description: "",
    subjectClientId: "",
    substituteClientId: ""
  };
}

const ClientUpdateProposal = {
  typeUrl: "/ibc.core.client.v1.ClientUpdateProposal",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.title !== "") {
      writer.uint32(10).string(message.title);
    }

    if (message.description !== "") {
      writer.uint32(18).string(message.description);
    }

    if (message.subjectClientId !== "") {
      writer.uint32(26).string(message.subjectClientId);
    }

    if (message.substituteClientId !== "") {
      writer.uint32(34).string(message.substituteClientId);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseClientUpdateProposal();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.title = reader.string();
          break;

        case 2:
          message.description = reader.string();
          break;

        case 3:
          message.subjectClientId = reader.string();
          break;

        case 4:
          message.substituteClientId = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$title, _object$description, _object$subjectClient, _object$substituteCli;

    const message = createBaseClientUpdateProposal();
    message.title = (_object$title = object.title) !== null && _object$title !== void 0 ? _object$title : "";
    message.description = (_object$description = object.description) !== null && _object$description !== void 0 ? _object$description : "";
    message.subjectClientId = (_object$subjectClient = object.subjectClientId) !== null && _object$subjectClient !== void 0 ? _object$subjectClient : "";
    message.substituteClientId = (_object$substituteCli = object.substituteClientId) !== null && _object$substituteCli !== void 0 ? _object$substituteCli : "";
    return message;
  },

  fromAmino(object) {
    return {
      title: object.title,
      description: object.description,
      subjectClientId: object.subject_client_id,
      substituteClientId: object.substitute_client_id
    };
  },

  toAmino(message) {
    const obj = {};
    obj.title = message.title;
    obj.description = message.description;
    obj.subject_client_id = message.subjectClientId;
    obj.substitute_client_id = message.substituteClientId;
    return obj;
  },

  fromAminoMsg(object) {
    return ClientUpdateProposal.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/ClientUpdateProposal",
      value: ClientUpdateProposal.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return ClientUpdateProposal.decode(message.value);
  },

  toProto(message) {
    return ClientUpdateProposal.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.client.v1.ClientUpdateProposal",
      value: ClientUpdateProposal.encode(message).finish()
    };
  }

};

function createBaseUpgradeProposal() {
  return {
    $typeUrl: "/ibc.core.client.v1.UpgradeProposal",
    title: "",
    description: "",
    plan: undefined,
    upgradedClientState: undefined
  };
}

const UpgradeProposal = {
  typeUrl: "/ibc.core.client.v1.UpgradeProposal",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.title !== "") {
      writer.uint32(10).string(message.title);
    }

    if (message.description !== "") {
      writer.uint32(18).string(message.description);
    }

    if (message.plan !== undefined) {
      _cosmos_upgrade_v1beta1_upgrade__WEBPACK_IMPORTED_MODULE_1__.Plan.encode(message.plan, writer.uint32(26).fork()).ldelim();
    }

    if (message.upgradedClientState !== undefined) {
      _google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__.Any.encode(message.upgradedClientState, writer.uint32(34).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpgradeProposal();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.title = reader.string();
          break;

        case 2:
          message.description = reader.string();
          break;

        case 3:
          message.plan = _cosmos_upgrade_v1beta1_upgrade__WEBPACK_IMPORTED_MODULE_1__.Plan.decode(reader, reader.uint32());
          break;

        case 4:
          message.upgradedClientState = _google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__.Any.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$title2, _object$description2;

    const message = createBaseUpgradeProposal();
    message.title = (_object$title2 = object.title) !== null && _object$title2 !== void 0 ? _object$title2 : "";
    message.description = (_object$description2 = object.description) !== null && _object$description2 !== void 0 ? _object$description2 : "";
    message.plan = object.plan !== undefined && object.plan !== null ? _cosmos_upgrade_v1beta1_upgrade__WEBPACK_IMPORTED_MODULE_1__.Plan.fromPartial(object.plan) : undefined;
    message.upgradedClientState = object.upgradedClientState !== undefined && object.upgradedClientState !== null ? _google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__.Any.fromPartial(object.upgradedClientState) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      title: object.title,
      description: object.description,
      plan: object !== null && object !== void 0 && object.plan ? _cosmos_upgrade_v1beta1_upgrade__WEBPACK_IMPORTED_MODULE_1__.Plan.fromAmino(object.plan) : undefined,
      upgradedClientState: object !== null && object !== void 0 && object.upgraded_client_state ? _google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__.Any.fromAmino(object.upgraded_client_state) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.title = message.title;
    obj.description = message.description;
    obj.plan = message.plan ? _cosmos_upgrade_v1beta1_upgrade__WEBPACK_IMPORTED_MODULE_1__.Plan.toAmino(message.plan) : undefined;
    obj.upgraded_client_state = message.upgradedClientState ? _google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__.Any.toAmino(message.upgradedClientState) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return UpgradeProposal.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/UpgradeProposal",
      value: UpgradeProposal.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return UpgradeProposal.decode(message.value);
  },

  toProto(message) {
    return UpgradeProposal.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.client.v1.UpgradeProposal",
      value: UpgradeProposal.encode(message).finish()
    };
  }

};

function createBaseHeight() {
  return {
    revisionNumber: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO,
    revisionHeight: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO
  };
}

const Height = {
  typeUrl: "/ibc.core.client.v1.Height",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (!message.revisionNumber.isZero()) {
      writer.uint32(8).uint64(message.revisionNumber);
    }

    if (!message.revisionHeight.isZero()) {
      writer.uint32(16).uint64(message.revisionHeight);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseHeight();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.revisionNumber = reader.uint64();
          break;

        case 2:
          message.revisionHeight = reader.uint64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseHeight();
    message.revisionNumber = object.revisionNumber !== undefined && object.revisionNumber !== null ? _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromValue */ .dK.fromValue(object.revisionNumber) : _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO;
    message.revisionHeight = object.revisionHeight !== undefined && object.revisionHeight !== null ? _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromValue */ .dK.fromValue(object.revisionHeight) : _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO;
    return message;
  },

  fromAmino(object) {
    return {
      revisionNumber: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromString */ .dK.fromString(object.revision_number || "0", true),
      revisionHeight: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromString */ .dK.fromString(object.revision_height || "0", true)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.revision_number = message.revisionNumber ? message.revisionNumber.toString() : undefined;
    obj.revision_height = message.revisionHeight ? message.revisionHeight.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return Height.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/Height",
      value: Height.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return Height.decode(message.value);
  },

  toProto(message) {
    return Height.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.client.v1.Height",
      value: Height.encode(message).finish()
    };
  }

};

function createBaseParams() {
  return {
    allowedClients: []
  };
}

const Params = {
  typeUrl: "/ibc.core.client.v1.Params",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    for (const v of message.allowedClients) {
      writer.uint32(10).string(v);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseParams();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.allowedClients.push(reader.string());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$allowedClient;

    const message = createBaseParams();
    message.allowedClients = ((_object$allowedClient = object.allowedClients) === null || _object$allowedClient === void 0 ? void 0 : _object$allowedClient.map(e => e)) || [];
    return message;
  },

  fromAmino(object) {
    return {
      allowedClients: Array.isArray(object === null || object === void 0 ? void 0 : object.allowed_clients) ? object.allowed_clients.map(e => e) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.allowedClients) {
      obj.allowed_clients = message.allowedClients.map(e => e);
    } else {
      obj.allowed_clients = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return Params.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/Params",
      value: Params.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return Params.decode(message.value);
  },

  toProto(message) {
    return Params.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.client.v1.Params",
      value: Params.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 95638:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QueryClientParamsRequest": function() { return /* binding */ QueryClientParamsRequest; },
/* harmony export */   "QueryClientParamsResponse": function() { return /* binding */ QueryClientParamsResponse; },
/* harmony export */   "QueryClientStateRequest": function() { return /* binding */ QueryClientStateRequest; },
/* harmony export */   "QueryClientStateResponse": function() { return /* binding */ QueryClientStateResponse; },
/* harmony export */   "QueryClientStatesRequest": function() { return /* binding */ QueryClientStatesRequest; },
/* harmony export */   "QueryClientStatesResponse": function() { return /* binding */ QueryClientStatesResponse; },
/* harmony export */   "QueryClientStatusRequest": function() { return /* binding */ QueryClientStatusRequest; },
/* harmony export */   "QueryClientStatusResponse": function() { return /* binding */ QueryClientStatusResponse; },
/* harmony export */   "QueryConsensusStateHeightsRequest": function() { return /* binding */ QueryConsensusStateHeightsRequest; },
/* harmony export */   "QueryConsensusStateHeightsResponse": function() { return /* binding */ QueryConsensusStateHeightsResponse; },
/* harmony export */   "QueryConsensusStateRequest": function() { return /* binding */ QueryConsensusStateRequest; },
/* harmony export */   "QueryConsensusStateResponse": function() { return /* binding */ QueryConsensusStateResponse; },
/* harmony export */   "QueryConsensusStatesRequest": function() { return /* binding */ QueryConsensusStatesRequest; },
/* harmony export */   "QueryConsensusStatesResponse": function() { return /* binding */ QueryConsensusStatesResponse; },
/* harmony export */   "QueryUpgradedClientStateRequest": function() { return /* binding */ QueryUpgradedClientStateRequest; },
/* harmony export */   "QueryUpgradedClientStateResponse": function() { return /* binding */ QueryUpgradedClientStateResponse; },
/* harmony export */   "QueryUpgradedConsensusStateRequest": function() { return /* binding */ QueryUpgradedConsensusStateRequest; },
/* harmony export */   "QueryUpgradedConsensusStateResponse": function() { return /* binding */ QueryUpgradedConsensusStateResponse; }
/* harmony export */ });
/* harmony import */ var _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48978);
/* harmony import */ var _google_protobuf_any__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32106);
/* harmony import */ var _client__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45802);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47895);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__);





/**
 * QueryClientStateRequest is the request type for the Query/ClientState RPC
 * method
 */

function createBaseQueryClientStateRequest() {
  return {
    clientId: ""
  };
}

const QueryClientStateRequest = {
  typeUrl: "/ibc.core.client.v1.QueryClientStateRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    if (message.clientId !== "") {
      writer.uint32(10).string(message.clientId);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryClientStateRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.clientId = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$clientId;

    const message = createBaseQueryClientStateRequest();
    message.clientId = (_object$clientId = object.clientId) !== null && _object$clientId !== void 0 ? _object$clientId : "";
    return message;
  },

  fromAmino(object) {
    return {
      clientId: object.client_id
    };
  },

  toAmino(message) {
    const obj = {};
    obj.client_id = message.clientId;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryClientStateRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryClientStateRequest",
      value: QueryClientStateRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryClientStateRequest.decode(message.value);
  },

  toProto(message) {
    return QueryClientStateRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.client.v1.QueryClientStateRequest",
      value: QueryClientStateRequest.encode(message).finish()
    };
  }

};

function createBaseQueryClientStateResponse() {
  return {
    clientState: undefined,
    proof: new Uint8Array(),
    proofHeight: undefined
  };
}

const QueryClientStateResponse = {
  typeUrl: "/ibc.core.client.v1.QueryClientStateResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    if (message.clientState !== undefined) {
      _google_protobuf_any__WEBPACK_IMPORTED_MODULE_1__.Any.encode(message.clientState, writer.uint32(10).fork()).ldelim();
    }

    if (message.proof.length !== 0) {
      writer.uint32(18).bytes(message.proof);
    }

    if (message.proofHeight !== undefined) {
      _client__WEBPACK_IMPORTED_MODULE_2__.Height.encode(message.proofHeight, writer.uint32(26).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryClientStateResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.clientState = _google_protobuf_any__WEBPACK_IMPORTED_MODULE_1__.Any.decode(reader, reader.uint32());
          break;

        case 2:
          message.proof = reader.bytes();
          break;

        case 3:
          message.proofHeight = _client__WEBPACK_IMPORTED_MODULE_2__.Height.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$proof;

    const message = createBaseQueryClientStateResponse();
    message.clientState = object.clientState !== undefined && object.clientState !== null ? _google_protobuf_any__WEBPACK_IMPORTED_MODULE_1__.Any.fromPartial(object.clientState) : undefined;
    message.proof = (_object$proof = object.proof) !== null && _object$proof !== void 0 ? _object$proof : new Uint8Array();
    message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? _client__WEBPACK_IMPORTED_MODULE_2__.Height.fromPartial(object.proofHeight) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      clientState: object !== null && object !== void 0 && object.client_state ? _google_protobuf_any__WEBPACK_IMPORTED_MODULE_1__.Any.fromAmino(object.client_state) : undefined,
      proof: object.proof,
      proofHeight: object !== null && object !== void 0 && object.proof_height ? _client__WEBPACK_IMPORTED_MODULE_2__.Height.fromAmino(object.proof_height) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.client_state = message.clientState ? _google_protobuf_any__WEBPACK_IMPORTED_MODULE_1__.Any.toAmino(message.clientState) : undefined;
    obj.proof = message.proof;
    obj.proof_height = message.proofHeight ? _client__WEBPACK_IMPORTED_MODULE_2__.Height.toAmino(message.proofHeight) : {};
    return obj;
  },

  fromAminoMsg(object) {
    return QueryClientStateResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryClientStateResponse",
      value: QueryClientStateResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryClientStateResponse.decode(message.value);
  },

  toProto(message) {
    return QueryClientStateResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.client.v1.QueryClientStateResponse",
      value: QueryClientStateResponse.encode(message).finish()
    };
  }

};

function createBaseQueryClientStatesRequest() {
  return {
    pagination: undefined
  };
}

const QueryClientStatesRequest = {
  typeUrl: "/ibc.core.client.v1.QueryClientStatesRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    if (message.pagination !== undefined) {
      _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryClientStatesRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.pagination = _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseQueryClientStatesRequest();
    message.pagination = object.pagination !== undefined && object.pagination !== null ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.fromPartial(object.pagination) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      pagination: object !== null && object !== void 0 && object.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.fromAmino(object.pagination) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.pagination = message.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.toAmino(message.pagination) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryClientStatesRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryClientStatesRequest",
      value: QueryClientStatesRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryClientStatesRequest.decode(message.value);
  },

  toProto(message) {
    return QueryClientStatesRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.client.v1.QueryClientStatesRequest",
      value: QueryClientStatesRequest.encode(message).finish()
    };
  }

};

function createBaseQueryClientStatesResponse() {
  return {
    clientStates: [],
    pagination: undefined
  };
}

const QueryClientStatesResponse = {
  typeUrl: "/ibc.core.client.v1.QueryClientStatesResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    for (const v of message.clientStates) {
      _client__WEBPACK_IMPORTED_MODULE_2__.IdentifiedClientState.encode(v, writer.uint32(10).fork()).ldelim();
    }

    if (message.pagination !== undefined) {
      _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryClientStatesResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.clientStates.push(_client__WEBPACK_IMPORTED_MODULE_2__.IdentifiedClientState.decode(reader, reader.uint32()));
          break;

        case 2:
          message.pagination = _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$clientStates;

    const message = createBaseQueryClientStatesResponse();
    message.clientStates = ((_object$clientStates = object.clientStates) === null || _object$clientStates === void 0 ? void 0 : _object$clientStates.map(e => _client__WEBPACK_IMPORTED_MODULE_2__.IdentifiedClientState.fromPartial(e))) || [];
    message.pagination = object.pagination !== undefined && object.pagination !== null ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.fromPartial(object.pagination) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      clientStates: Array.isArray(object === null || object === void 0 ? void 0 : object.client_states) ? object.client_states.map(e => _client__WEBPACK_IMPORTED_MODULE_2__.IdentifiedClientState.fromAmino(e)) : [],
      pagination: object !== null && object !== void 0 && object.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.fromAmino(object.pagination) : undefined
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.clientStates) {
      obj.client_states = message.clientStates.map(e => e ? _client__WEBPACK_IMPORTED_MODULE_2__.IdentifiedClientState.toAmino(e) : undefined);
    } else {
      obj.client_states = [];
    }

    obj.pagination = message.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.toAmino(message.pagination) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryClientStatesResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryClientStatesResponse",
      value: QueryClientStatesResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryClientStatesResponse.decode(message.value);
  },

  toProto(message) {
    return QueryClientStatesResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.client.v1.QueryClientStatesResponse",
      value: QueryClientStatesResponse.encode(message).finish()
    };
  }

};

function createBaseQueryConsensusStateRequest() {
  return {
    clientId: "",
    revisionNumber: _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.UZERO */ .dK.UZERO,
    revisionHeight: _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.UZERO */ .dK.UZERO,
    latestHeight: false
  };
}

const QueryConsensusStateRequest = {
  typeUrl: "/ibc.core.client.v1.QueryConsensusStateRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    if (message.clientId !== "") {
      writer.uint32(10).string(message.clientId);
    }

    if (!message.revisionNumber.isZero()) {
      writer.uint32(16).uint64(message.revisionNumber);
    }

    if (!message.revisionHeight.isZero()) {
      writer.uint32(24).uint64(message.revisionHeight);
    }

    if (message.latestHeight === true) {
      writer.uint32(32).bool(message.latestHeight);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryConsensusStateRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.clientId = reader.string();
          break;

        case 2:
          message.revisionNumber = reader.uint64();
          break;

        case 3:
          message.revisionHeight = reader.uint64();
          break;

        case 4:
          message.latestHeight = reader.bool();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$clientId2, _object$latestHeight;

    const message = createBaseQueryConsensusStateRequest();
    message.clientId = (_object$clientId2 = object.clientId) !== null && _object$clientId2 !== void 0 ? _object$clientId2 : "";
    message.revisionNumber = object.revisionNumber !== undefined && object.revisionNumber !== null ? _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.fromValue */ .dK.fromValue(object.revisionNumber) : _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.UZERO */ .dK.UZERO;
    message.revisionHeight = object.revisionHeight !== undefined && object.revisionHeight !== null ? _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.fromValue */ .dK.fromValue(object.revisionHeight) : _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.UZERO */ .dK.UZERO;
    message.latestHeight = (_object$latestHeight = object.latestHeight) !== null && _object$latestHeight !== void 0 ? _object$latestHeight : false;
    return message;
  },

  fromAmino(object) {
    return {
      clientId: object.client_id,
      revisionNumber: _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.fromString */ .dK.fromString(object.revision_number),
      revisionHeight: _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.fromString */ .dK.fromString(object.revision_height),
      latestHeight: object.latest_height
    };
  },

  toAmino(message) {
    const obj = {};
    obj.client_id = message.clientId;
    obj.revision_number = message.revisionNumber ? message.revisionNumber.toString() : undefined;
    obj.revision_height = message.revisionHeight ? message.revisionHeight.toString() : undefined;
    obj.latest_height = message.latestHeight;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryConsensusStateRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryConsensusStateRequest",
      value: QueryConsensusStateRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryConsensusStateRequest.decode(message.value);
  },

  toProto(message) {
    return QueryConsensusStateRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.client.v1.QueryConsensusStateRequest",
      value: QueryConsensusStateRequest.encode(message).finish()
    };
  }

};

function createBaseQueryConsensusStateResponse() {
  return {
    consensusState: undefined,
    proof: new Uint8Array(),
    proofHeight: undefined
  };
}

const QueryConsensusStateResponse = {
  typeUrl: "/ibc.core.client.v1.QueryConsensusStateResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    if (message.consensusState !== undefined) {
      _google_protobuf_any__WEBPACK_IMPORTED_MODULE_1__.Any.encode(message.consensusState, writer.uint32(10).fork()).ldelim();
    }

    if (message.proof.length !== 0) {
      writer.uint32(18).bytes(message.proof);
    }

    if (message.proofHeight !== undefined) {
      _client__WEBPACK_IMPORTED_MODULE_2__.Height.encode(message.proofHeight, writer.uint32(26).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryConsensusStateResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.consensusState = _google_protobuf_any__WEBPACK_IMPORTED_MODULE_1__.Any.decode(reader, reader.uint32());
          break;

        case 2:
          message.proof = reader.bytes();
          break;

        case 3:
          message.proofHeight = _client__WEBPACK_IMPORTED_MODULE_2__.Height.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$proof2;

    const message = createBaseQueryConsensusStateResponse();
    message.consensusState = object.consensusState !== undefined && object.consensusState !== null ? _google_protobuf_any__WEBPACK_IMPORTED_MODULE_1__.Any.fromPartial(object.consensusState) : undefined;
    message.proof = (_object$proof2 = object.proof) !== null && _object$proof2 !== void 0 ? _object$proof2 : new Uint8Array();
    message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? _client__WEBPACK_IMPORTED_MODULE_2__.Height.fromPartial(object.proofHeight) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      consensusState: object !== null && object !== void 0 && object.consensus_state ? _google_protobuf_any__WEBPACK_IMPORTED_MODULE_1__.Any.fromAmino(object.consensus_state) : undefined,
      proof: object.proof,
      proofHeight: object !== null && object !== void 0 && object.proof_height ? _client__WEBPACK_IMPORTED_MODULE_2__.Height.fromAmino(object.proof_height) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.consensus_state = message.consensusState ? _google_protobuf_any__WEBPACK_IMPORTED_MODULE_1__.Any.toAmino(message.consensusState) : undefined;
    obj.proof = message.proof;
    obj.proof_height = message.proofHeight ? _client__WEBPACK_IMPORTED_MODULE_2__.Height.toAmino(message.proofHeight) : {};
    return obj;
  },

  fromAminoMsg(object) {
    return QueryConsensusStateResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryConsensusStateResponse",
      value: QueryConsensusStateResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryConsensusStateResponse.decode(message.value);
  },

  toProto(message) {
    return QueryConsensusStateResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.client.v1.QueryConsensusStateResponse",
      value: QueryConsensusStateResponse.encode(message).finish()
    };
  }

};

function createBaseQueryConsensusStatesRequest() {
  return {
    clientId: "",
    pagination: undefined
  };
}

const QueryConsensusStatesRequest = {
  typeUrl: "/ibc.core.client.v1.QueryConsensusStatesRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    if (message.clientId !== "") {
      writer.uint32(10).string(message.clientId);
    }

    if (message.pagination !== undefined) {
      _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryConsensusStatesRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.clientId = reader.string();
          break;

        case 2:
          message.pagination = _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$clientId3;

    const message = createBaseQueryConsensusStatesRequest();
    message.clientId = (_object$clientId3 = object.clientId) !== null && _object$clientId3 !== void 0 ? _object$clientId3 : "";
    message.pagination = object.pagination !== undefined && object.pagination !== null ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.fromPartial(object.pagination) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      clientId: object.client_id,
      pagination: object !== null && object !== void 0 && object.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.fromAmino(object.pagination) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.client_id = message.clientId;
    obj.pagination = message.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.toAmino(message.pagination) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryConsensusStatesRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryConsensusStatesRequest",
      value: QueryConsensusStatesRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryConsensusStatesRequest.decode(message.value);
  },

  toProto(message) {
    return QueryConsensusStatesRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.client.v1.QueryConsensusStatesRequest",
      value: QueryConsensusStatesRequest.encode(message).finish()
    };
  }

};

function createBaseQueryConsensusStatesResponse() {
  return {
    consensusStates: [],
    pagination: undefined
  };
}

const QueryConsensusStatesResponse = {
  typeUrl: "/ibc.core.client.v1.QueryConsensusStatesResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    for (const v of message.consensusStates) {
      _client__WEBPACK_IMPORTED_MODULE_2__.ConsensusStateWithHeight.encode(v, writer.uint32(10).fork()).ldelim();
    }

    if (message.pagination !== undefined) {
      _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryConsensusStatesResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.consensusStates.push(_client__WEBPACK_IMPORTED_MODULE_2__.ConsensusStateWithHeight.decode(reader, reader.uint32()));
          break;

        case 2:
          message.pagination = _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$consensusStat;

    const message = createBaseQueryConsensusStatesResponse();
    message.consensusStates = ((_object$consensusStat = object.consensusStates) === null || _object$consensusStat === void 0 ? void 0 : _object$consensusStat.map(e => _client__WEBPACK_IMPORTED_MODULE_2__.ConsensusStateWithHeight.fromPartial(e))) || [];
    message.pagination = object.pagination !== undefined && object.pagination !== null ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.fromPartial(object.pagination) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      consensusStates: Array.isArray(object === null || object === void 0 ? void 0 : object.consensus_states) ? object.consensus_states.map(e => _client__WEBPACK_IMPORTED_MODULE_2__.ConsensusStateWithHeight.fromAmino(e)) : [],
      pagination: object !== null && object !== void 0 && object.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.fromAmino(object.pagination) : undefined
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.consensusStates) {
      obj.consensus_states = message.consensusStates.map(e => e ? _client__WEBPACK_IMPORTED_MODULE_2__.ConsensusStateWithHeight.toAmino(e) : undefined);
    } else {
      obj.consensus_states = [];
    }

    obj.pagination = message.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.toAmino(message.pagination) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryConsensusStatesResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryConsensusStatesResponse",
      value: QueryConsensusStatesResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryConsensusStatesResponse.decode(message.value);
  },

  toProto(message) {
    return QueryConsensusStatesResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.client.v1.QueryConsensusStatesResponse",
      value: QueryConsensusStatesResponse.encode(message).finish()
    };
  }

};

function createBaseQueryConsensusStateHeightsRequest() {
  return {
    clientId: "",
    pagination: undefined
  };
}

const QueryConsensusStateHeightsRequest = {
  typeUrl: "/ibc.core.client.v1.QueryConsensusStateHeightsRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    if (message.clientId !== "") {
      writer.uint32(10).string(message.clientId);
    }

    if (message.pagination !== undefined) {
      _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryConsensusStateHeightsRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.clientId = reader.string();
          break;

        case 2:
          message.pagination = _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$clientId4;

    const message = createBaseQueryConsensusStateHeightsRequest();
    message.clientId = (_object$clientId4 = object.clientId) !== null && _object$clientId4 !== void 0 ? _object$clientId4 : "";
    message.pagination = object.pagination !== undefined && object.pagination !== null ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.fromPartial(object.pagination) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      clientId: object.client_id,
      pagination: object !== null && object !== void 0 && object.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.fromAmino(object.pagination) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.client_id = message.clientId;
    obj.pagination = message.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.toAmino(message.pagination) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryConsensusStateHeightsRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryConsensusStateHeightsRequest",
      value: QueryConsensusStateHeightsRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryConsensusStateHeightsRequest.decode(message.value);
  },

  toProto(message) {
    return QueryConsensusStateHeightsRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.client.v1.QueryConsensusStateHeightsRequest",
      value: QueryConsensusStateHeightsRequest.encode(message).finish()
    };
  }

};

function createBaseQueryConsensusStateHeightsResponse() {
  return {
    consensusStateHeights: [],
    pagination: undefined
  };
}

const QueryConsensusStateHeightsResponse = {
  typeUrl: "/ibc.core.client.v1.QueryConsensusStateHeightsResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    for (const v of message.consensusStateHeights) {
      _client__WEBPACK_IMPORTED_MODULE_2__.Height.encode(v, writer.uint32(10).fork()).ldelim();
    }

    if (message.pagination !== undefined) {
      _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryConsensusStateHeightsResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.consensusStateHeights.push(_client__WEBPACK_IMPORTED_MODULE_2__.Height.decode(reader, reader.uint32()));
          break;

        case 2:
          message.pagination = _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$consensusStat2;

    const message = createBaseQueryConsensusStateHeightsResponse();
    message.consensusStateHeights = ((_object$consensusStat2 = object.consensusStateHeights) === null || _object$consensusStat2 === void 0 ? void 0 : _object$consensusStat2.map(e => _client__WEBPACK_IMPORTED_MODULE_2__.Height.fromPartial(e))) || [];
    message.pagination = object.pagination !== undefined && object.pagination !== null ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.fromPartial(object.pagination) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      consensusStateHeights: Array.isArray(object === null || object === void 0 ? void 0 : object.consensus_state_heights) ? object.consensus_state_heights.map(e => _client__WEBPACK_IMPORTED_MODULE_2__.Height.fromAmino(e)) : [],
      pagination: object !== null && object !== void 0 && object.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.fromAmino(object.pagination) : undefined
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.consensusStateHeights) {
      obj.consensus_state_heights = message.consensusStateHeights.map(e => e ? _client__WEBPACK_IMPORTED_MODULE_2__.Height.toAmino(e) : undefined);
    } else {
      obj.consensus_state_heights = [];
    }

    obj.pagination = message.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.toAmino(message.pagination) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryConsensusStateHeightsResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryConsensusStateHeightsResponse",
      value: QueryConsensusStateHeightsResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryConsensusStateHeightsResponse.decode(message.value);
  },

  toProto(message) {
    return QueryConsensusStateHeightsResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.client.v1.QueryConsensusStateHeightsResponse",
      value: QueryConsensusStateHeightsResponse.encode(message).finish()
    };
  }

};

function createBaseQueryClientStatusRequest() {
  return {
    clientId: ""
  };
}

const QueryClientStatusRequest = {
  typeUrl: "/ibc.core.client.v1.QueryClientStatusRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    if (message.clientId !== "") {
      writer.uint32(10).string(message.clientId);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryClientStatusRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.clientId = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$clientId5;

    const message = createBaseQueryClientStatusRequest();
    message.clientId = (_object$clientId5 = object.clientId) !== null && _object$clientId5 !== void 0 ? _object$clientId5 : "";
    return message;
  },

  fromAmino(object) {
    return {
      clientId: object.client_id
    };
  },

  toAmino(message) {
    const obj = {};
    obj.client_id = message.clientId;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryClientStatusRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryClientStatusRequest",
      value: QueryClientStatusRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryClientStatusRequest.decode(message.value);
  },

  toProto(message) {
    return QueryClientStatusRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.client.v1.QueryClientStatusRequest",
      value: QueryClientStatusRequest.encode(message).finish()
    };
  }

};

function createBaseQueryClientStatusResponse() {
  return {
    status: ""
  };
}

const QueryClientStatusResponse = {
  typeUrl: "/ibc.core.client.v1.QueryClientStatusResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    if (message.status !== "") {
      writer.uint32(10).string(message.status);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryClientStatusResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.status = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$status;

    const message = createBaseQueryClientStatusResponse();
    message.status = (_object$status = object.status) !== null && _object$status !== void 0 ? _object$status : "";
    return message;
  },

  fromAmino(object) {
    return {
      status: object.status
    };
  },

  toAmino(message) {
    const obj = {};
    obj.status = message.status;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryClientStatusResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryClientStatusResponse",
      value: QueryClientStatusResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryClientStatusResponse.decode(message.value);
  },

  toProto(message) {
    return QueryClientStatusResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.client.v1.QueryClientStatusResponse",
      value: QueryClientStatusResponse.encode(message).finish()
    };
  }

};

function createBaseQueryClientParamsRequest() {
  return {};
}

const QueryClientParamsRequest = {
  typeUrl: "/ibc.core.client.v1.QueryClientParamsRequest",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryClientParamsRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseQueryClientParamsRequest();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return QueryClientParamsRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryClientParamsRequest",
      value: QueryClientParamsRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryClientParamsRequest.decode(message.value);
  },

  toProto(message) {
    return QueryClientParamsRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.client.v1.QueryClientParamsRequest",
      value: QueryClientParamsRequest.encode(message).finish()
    };
  }

};

function createBaseQueryClientParamsResponse() {
  return {
    params: undefined
  };
}

const QueryClientParamsResponse = {
  typeUrl: "/ibc.core.client.v1.QueryClientParamsResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    if (message.params !== undefined) {
      _client__WEBPACK_IMPORTED_MODULE_2__.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryClientParamsResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.params = _client__WEBPACK_IMPORTED_MODULE_2__.Params.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseQueryClientParamsResponse();
    message.params = object.params !== undefined && object.params !== null ? _client__WEBPACK_IMPORTED_MODULE_2__.Params.fromPartial(object.params) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      params: object !== null && object !== void 0 && object.params ? _client__WEBPACK_IMPORTED_MODULE_2__.Params.fromAmino(object.params) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.params = message.params ? _client__WEBPACK_IMPORTED_MODULE_2__.Params.toAmino(message.params) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryClientParamsResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryClientParamsResponse",
      value: QueryClientParamsResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryClientParamsResponse.decode(message.value);
  },

  toProto(message) {
    return QueryClientParamsResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.client.v1.QueryClientParamsResponse",
      value: QueryClientParamsResponse.encode(message).finish()
    };
  }

};

function createBaseQueryUpgradedClientStateRequest() {
  return {};
}

const QueryUpgradedClientStateRequest = {
  typeUrl: "/ibc.core.client.v1.QueryUpgradedClientStateRequest",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryUpgradedClientStateRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseQueryUpgradedClientStateRequest();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return QueryUpgradedClientStateRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryUpgradedClientStateRequest",
      value: QueryUpgradedClientStateRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryUpgradedClientStateRequest.decode(message.value);
  },

  toProto(message) {
    return QueryUpgradedClientStateRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.client.v1.QueryUpgradedClientStateRequest",
      value: QueryUpgradedClientStateRequest.encode(message).finish()
    };
  }

};

function createBaseQueryUpgradedClientStateResponse() {
  return {
    upgradedClientState: undefined
  };
}

const QueryUpgradedClientStateResponse = {
  typeUrl: "/ibc.core.client.v1.QueryUpgradedClientStateResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    if (message.upgradedClientState !== undefined) {
      _google_protobuf_any__WEBPACK_IMPORTED_MODULE_1__.Any.encode(message.upgradedClientState, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryUpgradedClientStateResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.upgradedClientState = _google_protobuf_any__WEBPACK_IMPORTED_MODULE_1__.Any.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseQueryUpgradedClientStateResponse();
    message.upgradedClientState = object.upgradedClientState !== undefined && object.upgradedClientState !== null ? _google_protobuf_any__WEBPACK_IMPORTED_MODULE_1__.Any.fromPartial(object.upgradedClientState) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      upgradedClientState: object !== null && object !== void 0 && object.upgraded_client_state ? _google_protobuf_any__WEBPACK_IMPORTED_MODULE_1__.Any.fromAmino(object.upgraded_client_state) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.upgraded_client_state = message.upgradedClientState ? _google_protobuf_any__WEBPACK_IMPORTED_MODULE_1__.Any.toAmino(message.upgradedClientState) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryUpgradedClientStateResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryUpgradedClientStateResponse",
      value: QueryUpgradedClientStateResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryUpgradedClientStateResponse.decode(message.value);
  },

  toProto(message) {
    return QueryUpgradedClientStateResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.client.v1.QueryUpgradedClientStateResponse",
      value: QueryUpgradedClientStateResponse.encode(message).finish()
    };
  }

};

function createBaseQueryUpgradedConsensusStateRequest() {
  return {};
}

const QueryUpgradedConsensusStateRequest = {
  typeUrl: "/ibc.core.client.v1.QueryUpgradedConsensusStateRequest",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryUpgradedConsensusStateRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseQueryUpgradedConsensusStateRequest();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return QueryUpgradedConsensusStateRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryUpgradedConsensusStateRequest",
      value: QueryUpgradedConsensusStateRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryUpgradedConsensusStateRequest.decode(message.value);
  },

  toProto(message) {
    return QueryUpgradedConsensusStateRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.client.v1.QueryUpgradedConsensusStateRequest",
      value: QueryUpgradedConsensusStateRequest.encode(message).finish()
    };
  }

};

function createBaseQueryUpgradedConsensusStateResponse() {
  return {
    upgradedConsensusState: undefined
  };
}

const QueryUpgradedConsensusStateResponse = {
  typeUrl: "/ibc.core.client.v1.QueryUpgradedConsensusStateResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    if (message.upgradedConsensusState !== undefined) {
      _google_protobuf_any__WEBPACK_IMPORTED_MODULE_1__.Any.encode(message.upgradedConsensusState, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryUpgradedConsensusStateResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.upgradedConsensusState = _google_protobuf_any__WEBPACK_IMPORTED_MODULE_1__.Any.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseQueryUpgradedConsensusStateResponse();
    message.upgradedConsensusState = object.upgradedConsensusState !== undefined && object.upgradedConsensusState !== null ? _google_protobuf_any__WEBPACK_IMPORTED_MODULE_1__.Any.fromPartial(object.upgradedConsensusState) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      upgradedConsensusState: object !== null && object !== void 0 && object.upgraded_consensus_state ? _google_protobuf_any__WEBPACK_IMPORTED_MODULE_1__.Any.fromAmino(object.upgraded_consensus_state) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.upgraded_consensus_state = message.upgradedConsensusState ? _google_protobuf_any__WEBPACK_IMPORTED_MODULE_1__.Any.toAmino(message.upgradedConsensusState) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryUpgradedConsensusStateResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryUpgradedConsensusStateResponse",
      value: QueryUpgradedConsensusStateResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryUpgradedConsensusStateResponse.decode(message.value);
  },

  toProto(message) {
    return QueryUpgradedConsensusStateResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.client.v1.QueryUpgradedConsensusStateResponse",
      value: QueryUpgradedConsensusStateResponse.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 58251:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LCDQueryClient": function() { return /* binding */ LCDQueryClient; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4942);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47895);


class LCDQueryClient {
  constructor({
    requestClient
  }) {
    (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, "req", void 0);

    this.req = requestClient;
    this.clientState = this.clientState.bind(this);
    this.clientStates = this.clientStates.bind(this);
    this.consensusState = this.consensusState.bind(this);
    this.consensusStates = this.consensusStates.bind(this);
    this.consensusStateHeights = this.consensusStateHeights.bind(this);
    this.clientStatus = this.clientStatus.bind(this);
    this.clientParams = this.clientParams.bind(this);
    this.upgradedClientState = this.upgradedClientState.bind(this);
    this.upgradedConsensusState = this.upgradedConsensusState.bind(this);
  }
  /* ClientState queries an IBC light client. */


  async clientState(params) {
    const endpoint = `ibc/core/client/v1/client_states/${params.clientId}`;
    return await this.req.get(endpoint);
  }
  /* ClientStates queries all the IBC light clients of a chain. */


  async clientStates(params = {
    pagination: undefined
  }) {
    const options = {
      params: {}
    };

    if (typeof (params === null || params === void 0 ? void 0 : params.pagination) !== "undefined") {
      (0,_helpers__WEBPACK_IMPORTED_MODULE_0__/* .setPaginationParams */ .q6)(options, params.pagination);
    }

    const endpoint = `ibc/core/client/v1/client_states`;
    return await this.req.get(endpoint, options);
  }
  /* ConsensusState queries a consensus state associated with a client state at
   a given height. */


  async consensusState(params) {
    const options = {
      params: {}
    };

    if (typeof (params === null || params === void 0 ? void 0 : params.latestHeight) !== "undefined") {
      options.params.latest_height = params.latestHeight;
    }

    const endpoint = `ibc/core/client/v1/consensus_states/${params.clientId}/revision/${params.revisionNumber}/height/${params.revisionHeight}`;
    return await this.req.get(endpoint, options);
  }
  /* ConsensusStates queries all the consensus state associated with a given
   client. */


  async consensusStates(params) {
    const options = {
      params: {}
    };

    if (typeof (params === null || params === void 0 ? void 0 : params.pagination) !== "undefined") {
      (0,_helpers__WEBPACK_IMPORTED_MODULE_0__/* .setPaginationParams */ .q6)(options, params.pagination);
    }

    const endpoint = `ibc/core/client/v1/consensus_states/${params.clientId}`;
    return await this.req.get(endpoint, options);
  }
  /* ConsensusStateHeights queries the height of every consensus states associated with a given client. */


  async consensusStateHeights(params) {
    const options = {
      params: {}
    };

    if (typeof (params === null || params === void 0 ? void 0 : params.pagination) !== "undefined") {
      (0,_helpers__WEBPACK_IMPORTED_MODULE_0__/* .setPaginationParams */ .q6)(options, params.pagination);
    }

    const endpoint = `ibc/core/client/v1/consensus_states/${params.clientId}/heights`;
    return await this.req.get(endpoint, options);
  }
  /* Status queries the status of an IBC client. */


  async clientStatus(params) {
    const endpoint = `ibc/core/client/v1/client_status/${params.clientId}`;
    return await this.req.get(endpoint);
  }
  /* ClientParams queries all parameters of the ibc client submodule. */


  async clientParams(_params = {}) {
    const endpoint = `ibc/core/client/v1/params`;
    return await this.req.get(endpoint);
  }
  /* UpgradedClientState queries an Upgraded IBC light client. */


  async upgradedClientState(_params = {}) {
    const endpoint = `ibc/core/client/v1/upgraded_client_states`;
    return await this.req.get(endpoint);
  }
  /* UpgradedConsensusState queries an Upgraded IBC consensus state. */


  async upgradedConsensusState(_params = {}) {
    const endpoint = `ibc/core/client/v1/upgraded_consensus_states`;
    return await this.req.get(endpoint);
  }

}

/***/ }),

/***/ 93738:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QueryClientImpl": function() { return /* binding */ QueryClientImpl; },
/* harmony export */   "createRpcQueryExtension": function() { return /* binding */ createRpcQueryExtension; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4942);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78441);
/* harmony import */ var _cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95638);




/** Query provides defines the gRPC querier service */

class QueryClientImpl {
  constructor(rpc) {
    (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, "rpc", void 0);

    this.rpc = rpc;
    this.clientState = this.clientState.bind(this);
    this.clientStates = this.clientStates.bind(this);
    this.consensusState = this.consensusState.bind(this);
    this.consensusStates = this.consensusStates.bind(this);
    this.consensusStateHeights = this.consensusStateHeights.bind(this);
    this.clientStatus = this.clientStatus.bind(this);
    this.clientParams = this.clientParams.bind(this);
    this.upgradedClientState = this.upgradedClientState.bind(this);
    this.upgradedConsensusState = this.upgradedConsensusState.bind(this);
  }

  clientState(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryClientStateRequest.encode(request).finish();
    const promise = this.rpc.request("ibc.core.client.v1.Query", "ClientState", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryClientStateResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  clientStates(request = {
    pagination: undefined
  }) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryClientStatesRequest.encode(request).finish();
    const promise = this.rpc.request("ibc.core.client.v1.Query", "ClientStates", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryClientStatesResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  consensusState(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryConsensusStateRequest.encode(request).finish();
    const promise = this.rpc.request("ibc.core.client.v1.Query", "ConsensusState", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryConsensusStateResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  consensusStates(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryConsensusStatesRequest.encode(request).finish();
    const promise = this.rpc.request("ibc.core.client.v1.Query", "ConsensusStates", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryConsensusStatesResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  consensusStateHeights(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryConsensusStateHeightsRequest.encode(request).finish();
    const promise = this.rpc.request("ibc.core.client.v1.Query", "ConsensusStateHeights", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryConsensusStateHeightsResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  clientStatus(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryClientStatusRequest.encode(request).finish();
    const promise = this.rpc.request("ibc.core.client.v1.Query", "ClientStatus", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryClientStatusResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  clientParams(request = {}) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryClientParamsRequest.encode(request).finish();
    const promise = this.rpc.request("ibc.core.client.v1.Query", "ClientParams", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryClientParamsResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  upgradedClientState(request = {}) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryUpgradedClientStateRequest.encode(request).finish();
    const promise = this.rpc.request("ibc.core.client.v1.Query", "UpgradedClientState", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryUpgradedClientStateResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  upgradedConsensusState(request = {}) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryUpgradedConsensusStateRequest.encode(request).finish();
    const promise = this.rpc.request("ibc.core.client.v1.Query", "UpgradedConsensusState", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryUpgradedConsensusStateResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

}
const createRpcQueryExtension = base => {
  const rpc = (0,_cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1__.createProtobufRpcClient)(base);
  const queryService = new QueryClientImpl(rpc);
  return {
    clientState(request) {
      return queryService.clientState(request);
    },

    clientStates(request) {
      return queryService.clientStates(request);
    },

    consensusState(request) {
      return queryService.consensusState(request);
    },

    consensusStates(request) {
      return queryService.consensusStates(request);
    },

    consensusStateHeights(request) {
      return queryService.consensusStateHeights(request);
    },

    clientStatus(request) {
      return queryService.clientStatus(request);
    },

    clientParams(request) {
      return queryService.clientParams(request);
    },

    upgradedClientState(request) {
      return queryService.upgradedClientState(request);
    },

    upgradedConsensusState(request) {
      return queryService.upgradedConsensusState(request);
    }

  };
};

/***/ }),

/***/ 33550:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MsgCreateClient": function() { return /* binding */ MsgCreateClient; },
/* harmony export */   "MsgCreateClientResponse": function() { return /* binding */ MsgCreateClientResponse; },
/* harmony export */   "MsgSubmitMisbehaviour": function() { return /* binding */ MsgSubmitMisbehaviour; },
/* harmony export */   "MsgSubmitMisbehaviourResponse": function() { return /* binding */ MsgSubmitMisbehaviourResponse; },
/* harmony export */   "MsgUpdateClient": function() { return /* binding */ MsgUpdateClient; },
/* harmony export */   "MsgUpdateClientResponse": function() { return /* binding */ MsgUpdateClientResponse; },
/* harmony export */   "MsgUpgradeClient": function() { return /* binding */ MsgUpgradeClient; },
/* harmony export */   "MsgUpgradeClientResponse": function() { return /* binding */ MsgUpgradeClientResponse; }
/* harmony export */ });
/* harmony import */ var _google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32106);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__);


/** MsgCreateClient defines a message to create an IBC client */

function createBaseMsgCreateClient() {
  return {
    clientState: undefined,
    consensusState: undefined,
    signer: ""
  };
}

const MsgCreateClient = {
  typeUrl: "/ibc.core.client.v1.MsgCreateClient",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Writer.create()) {
    if (message.clientState !== undefined) {
      _google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__.Any.encode(message.clientState, writer.uint32(10).fork()).ldelim();
    }

    if (message.consensusState !== undefined) {
      _google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__.Any.encode(message.consensusState, writer.uint32(18).fork()).ldelim();
    }

    if (message.signer !== "") {
      writer.uint32(26).string(message.signer);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgCreateClient();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.clientState = _google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__.Any.decode(reader, reader.uint32());
          break;

        case 2:
          message.consensusState = _google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__.Any.decode(reader, reader.uint32());
          break;

        case 3:
          message.signer = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$signer;

    const message = createBaseMsgCreateClient();
    message.clientState = object.clientState !== undefined && object.clientState !== null ? _google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__.Any.fromPartial(object.clientState) : undefined;
    message.consensusState = object.consensusState !== undefined && object.consensusState !== null ? _google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__.Any.fromPartial(object.consensusState) : undefined;
    message.signer = (_object$signer = object.signer) !== null && _object$signer !== void 0 ? _object$signer : "";
    return message;
  },

  fromAmino(object) {
    return {
      clientState: object !== null && object !== void 0 && object.client_state ? _google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__.Any.fromAmino(object.client_state) : undefined,
      consensusState: object !== null && object !== void 0 && object.consensus_state ? _google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__.Any.fromAmino(object.consensus_state) : undefined,
      signer: object.signer
    };
  },

  toAmino(message) {
    const obj = {};
    obj.client_state = message.clientState ? _google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__.Any.toAmino(message.clientState) : undefined;
    obj.consensus_state = message.consensusState ? _google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__.Any.toAmino(message.consensusState) : undefined;
    obj.signer = message.signer;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgCreateClient.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/MsgCreateClient",
      value: MsgCreateClient.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgCreateClient.decode(message.value);
  },

  toProto(message) {
    return MsgCreateClient.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.client.v1.MsgCreateClient",
      value: MsgCreateClient.encode(message).finish()
    };
  }

};

function createBaseMsgCreateClientResponse() {
  return {};
}

const MsgCreateClientResponse = {
  typeUrl: "/ibc.core.client.v1.MsgCreateClientResponse",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgCreateClientResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseMsgCreateClientResponse();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return MsgCreateClientResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/MsgCreateClientResponse",
      value: MsgCreateClientResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgCreateClientResponse.decode(message.value);
  },

  toProto(message) {
    return MsgCreateClientResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.client.v1.MsgCreateClientResponse",
      value: MsgCreateClientResponse.encode(message).finish()
    };
  }

};

function createBaseMsgUpdateClient() {
  return {
    clientId: "",
    clientMessage: undefined,
    signer: ""
  };
}

const MsgUpdateClient = {
  typeUrl: "/ibc.core.client.v1.MsgUpdateClient",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Writer.create()) {
    if (message.clientId !== "") {
      writer.uint32(10).string(message.clientId);
    }

    if (message.clientMessage !== undefined) {
      _google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__.Any.encode(message.clientMessage, writer.uint32(18).fork()).ldelim();
    }

    if (message.signer !== "") {
      writer.uint32(26).string(message.signer);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgUpdateClient();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.clientId = reader.string();
          break;

        case 2:
          message.clientMessage = _google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__.Any.decode(reader, reader.uint32());
          break;

        case 3:
          message.signer = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$clientId, _object$signer2;

    const message = createBaseMsgUpdateClient();
    message.clientId = (_object$clientId = object.clientId) !== null && _object$clientId !== void 0 ? _object$clientId : "";
    message.clientMessage = object.clientMessage !== undefined && object.clientMessage !== null ? _google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__.Any.fromPartial(object.clientMessage) : undefined;
    message.signer = (_object$signer2 = object.signer) !== null && _object$signer2 !== void 0 ? _object$signer2 : "";
    return message;
  },

  fromAmino(object) {
    return {
      clientId: object.client_id,
      clientMessage: object !== null && object !== void 0 && object.client_message ? _google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__.Any.fromAmino(object.client_message) : undefined,
      signer: object.signer
    };
  },

  toAmino(message) {
    const obj = {};
    obj.client_id = message.clientId;
    obj.client_message = message.clientMessage ? _google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__.Any.toAmino(message.clientMessage) : undefined;
    obj.signer = message.signer;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgUpdateClient.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/MsgUpdateClient",
      value: MsgUpdateClient.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgUpdateClient.decode(message.value);
  },

  toProto(message) {
    return MsgUpdateClient.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.client.v1.MsgUpdateClient",
      value: MsgUpdateClient.encode(message).finish()
    };
  }

};

function createBaseMsgUpdateClientResponse() {
  return {};
}

const MsgUpdateClientResponse = {
  typeUrl: "/ibc.core.client.v1.MsgUpdateClientResponse",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgUpdateClientResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseMsgUpdateClientResponse();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return MsgUpdateClientResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/MsgUpdateClientResponse",
      value: MsgUpdateClientResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgUpdateClientResponse.decode(message.value);
  },

  toProto(message) {
    return MsgUpdateClientResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.client.v1.MsgUpdateClientResponse",
      value: MsgUpdateClientResponse.encode(message).finish()
    };
  }

};

function createBaseMsgUpgradeClient() {
  return {
    clientId: "",
    clientState: undefined,
    consensusState: undefined,
    proofUpgradeClient: new Uint8Array(),
    proofUpgradeConsensusState: new Uint8Array(),
    signer: ""
  };
}

const MsgUpgradeClient = {
  typeUrl: "/ibc.core.client.v1.MsgUpgradeClient",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Writer.create()) {
    if (message.clientId !== "") {
      writer.uint32(10).string(message.clientId);
    }

    if (message.clientState !== undefined) {
      _google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__.Any.encode(message.clientState, writer.uint32(18).fork()).ldelim();
    }

    if (message.consensusState !== undefined) {
      _google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__.Any.encode(message.consensusState, writer.uint32(26).fork()).ldelim();
    }

    if (message.proofUpgradeClient.length !== 0) {
      writer.uint32(34).bytes(message.proofUpgradeClient);
    }

    if (message.proofUpgradeConsensusState.length !== 0) {
      writer.uint32(42).bytes(message.proofUpgradeConsensusState);
    }

    if (message.signer !== "") {
      writer.uint32(50).string(message.signer);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgUpgradeClient();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.clientId = reader.string();
          break;

        case 2:
          message.clientState = _google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__.Any.decode(reader, reader.uint32());
          break;

        case 3:
          message.consensusState = _google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__.Any.decode(reader, reader.uint32());
          break;

        case 4:
          message.proofUpgradeClient = reader.bytes();
          break;

        case 5:
          message.proofUpgradeConsensusState = reader.bytes();
          break;

        case 6:
          message.signer = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$clientId2, _object$proofUpgradeC, _object$proofUpgradeC2, _object$signer3;

    const message = createBaseMsgUpgradeClient();
    message.clientId = (_object$clientId2 = object.clientId) !== null && _object$clientId2 !== void 0 ? _object$clientId2 : "";
    message.clientState = object.clientState !== undefined && object.clientState !== null ? _google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__.Any.fromPartial(object.clientState) : undefined;
    message.consensusState = object.consensusState !== undefined && object.consensusState !== null ? _google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__.Any.fromPartial(object.consensusState) : undefined;
    message.proofUpgradeClient = (_object$proofUpgradeC = object.proofUpgradeClient) !== null && _object$proofUpgradeC !== void 0 ? _object$proofUpgradeC : new Uint8Array();
    message.proofUpgradeConsensusState = (_object$proofUpgradeC2 = object.proofUpgradeConsensusState) !== null && _object$proofUpgradeC2 !== void 0 ? _object$proofUpgradeC2 : new Uint8Array();
    message.signer = (_object$signer3 = object.signer) !== null && _object$signer3 !== void 0 ? _object$signer3 : "";
    return message;
  },

  fromAmino(object) {
    return {
      clientId: object.client_id,
      clientState: object !== null && object !== void 0 && object.client_state ? _google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__.Any.fromAmino(object.client_state) : undefined,
      consensusState: object !== null && object !== void 0 && object.consensus_state ? _google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__.Any.fromAmino(object.consensus_state) : undefined,
      proofUpgradeClient: object.proof_upgrade_client,
      proofUpgradeConsensusState: object.proof_upgrade_consensus_state,
      signer: object.signer
    };
  },

  toAmino(message) {
    const obj = {};
    obj.client_id = message.clientId;
    obj.client_state = message.clientState ? _google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__.Any.toAmino(message.clientState) : undefined;
    obj.consensus_state = message.consensusState ? _google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__.Any.toAmino(message.consensusState) : undefined;
    obj.proof_upgrade_client = message.proofUpgradeClient;
    obj.proof_upgrade_consensus_state = message.proofUpgradeConsensusState;
    obj.signer = message.signer;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgUpgradeClient.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/MsgUpgradeClient",
      value: MsgUpgradeClient.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgUpgradeClient.decode(message.value);
  },

  toProto(message) {
    return MsgUpgradeClient.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.client.v1.MsgUpgradeClient",
      value: MsgUpgradeClient.encode(message).finish()
    };
  }

};

function createBaseMsgUpgradeClientResponse() {
  return {};
}

const MsgUpgradeClientResponse = {
  typeUrl: "/ibc.core.client.v1.MsgUpgradeClientResponse",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgUpgradeClientResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseMsgUpgradeClientResponse();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return MsgUpgradeClientResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/MsgUpgradeClientResponse",
      value: MsgUpgradeClientResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgUpgradeClientResponse.decode(message.value);
  },

  toProto(message) {
    return MsgUpgradeClientResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.client.v1.MsgUpgradeClientResponse",
      value: MsgUpgradeClientResponse.encode(message).finish()
    };
  }

};

function createBaseMsgSubmitMisbehaviour() {
  return {
    clientId: "",
    misbehaviour: undefined,
    signer: ""
  };
}

const MsgSubmitMisbehaviour = {
  typeUrl: "/ibc.core.client.v1.MsgSubmitMisbehaviour",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Writer.create()) {
    if (message.clientId !== "") {
      writer.uint32(10).string(message.clientId);
    }

    if (message.misbehaviour !== undefined) {
      _google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__.Any.encode(message.misbehaviour, writer.uint32(18).fork()).ldelim();
    }

    if (message.signer !== "") {
      writer.uint32(26).string(message.signer);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgSubmitMisbehaviour();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.clientId = reader.string();
          break;

        case 2:
          message.misbehaviour = _google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__.Any.decode(reader, reader.uint32());
          break;

        case 3:
          message.signer = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$clientId3, _object$signer4;

    const message = createBaseMsgSubmitMisbehaviour();
    message.clientId = (_object$clientId3 = object.clientId) !== null && _object$clientId3 !== void 0 ? _object$clientId3 : "";
    message.misbehaviour = object.misbehaviour !== undefined && object.misbehaviour !== null ? _google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__.Any.fromPartial(object.misbehaviour) : undefined;
    message.signer = (_object$signer4 = object.signer) !== null && _object$signer4 !== void 0 ? _object$signer4 : "";
    return message;
  },

  fromAmino(object) {
    return {
      clientId: object.client_id,
      misbehaviour: object !== null && object !== void 0 && object.misbehaviour ? _google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__.Any.fromAmino(object.misbehaviour) : undefined,
      signer: object.signer
    };
  },

  toAmino(message) {
    const obj = {};
    obj.client_id = message.clientId;
    obj.misbehaviour = message.misbehaviour ? _google_protobuf_any__WEBPACK_IMPORTED_MODULE_0__.Any.toAmino(message.misbehaviour) : undefined;
    obj.signer = message.signer;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgSubmitMisbehaviour.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/MsgSubmitMisbehaviour",
      value: MsgSubmitMisbehaviour.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgSubmitMisbehaviour.decode(message.value);
  },

  toProto(message) {
    return MsgSubmitMisbehaviour.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.client.v1.MsgSubmitMisbehaviour",
      value: MsgSubmitMisbehaviour.encode(message).finish()
    };
  }

};

function createBaseMsgSubmitMisbehaviourResponse() {
  return {};
}

const MsgSubmitMisbehaviourResponse = {
  typeUrl: "/ibc.core.client.v1.MsgSubmitMisbehaviourResponse",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgSubmitMisbehaviourResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseMsgSubmitMisbehaviourResponse();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return MsgSubmitMisbehaviourResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/MsgSubmitMisbehaviourResponse",
      value: MsgSubmitMisbehaviourResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgSubmitMisbehaviourResponse.decode(message.value);
  },

  toProto(message) {
    return MsgSubmitMisbehaviourResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.client.v1.MsgSubmitMisbehaviourResponse",
      value: MsgSubmitMisbehaviourResponse.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 25430:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MsgClientImpl": function() { return /* binding */ MsgClientImpl; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4942);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _tx__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33550);



/** Msg defines the ibc/client Msg service. */

class MsgClientImpl {
  constructor(rpc) {
    (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, "rpc", void 0);

    this.rpc = rpc;
    this.createClient = this.createClient.bind(this);
    this.updateClient = this.updateClient.bind(this);
    this.upgradeClient = this.upgradeClient.bind(this);
    this.submitMisbehaviour = this.submitMisbehaviour.bind(this);
  }

  createClient(request) {
    const data = _tx__WEBPACK_IMPORTED_MODULE_1__.MsgCreateClient.encode(request).finish();
    const promise = this.rpc.request("ibc.core.client.v1.Msg", "CreateClient", data);
    return promise.then(data => _tx__WEBPACK_IMPORTED_MODULE_1__.MsgCreateClientResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  updateClient(request) {
    const data = _tx__WEBPACK_IMPORTED_MODULE_1__.MsgUpdateClient.encode(request).finish();
    const promise = this.rpc.request("ibc.core.client.v1.Msg", "UpdateClient", data);
    return promise.then(data => _tx__WEBPACK_IMPORTED_MODULE_1__.MsgUpdateClientResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  upgradeClient(request) {
    const data = _tx__WEBPACK_IMPORTED_MODULE_1__.MsgUpgradeClient.encode(request).finish();
    const promise = this.rpc.request("ibc.core.client.v1.Msg", "UpgradeClient", data);
    return promise.then(data => _tx__WEBPACK_IMPORTED_MODULE_1__.MsgUpgradeClientResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  submitMisbehaviour(request) {
    const data = _tx__WEBPACK_IMPORTED_MODULE_1__.MsgSubmitMisbehaviour.encode(request).finish();
    const promise = this.rpc.request("ibc.core.client.v1.Msg", "SubmitMisbehaviour", data);
    return promise.then(data => _tx__WEBPACK_IMPORTED_MODULE_1__.MsgSubmitMisbehaviourResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

}

/***/ }),

/***/ 48768:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MerklePath": function() { return /* binding */ MerklePath; },
/* harmony export */   "MerklePrefix": function() { return /* binding */ MerklePrefix; },
/* harmony export */   "MerkleProof": function() { return /* binding */ MerkleProof; },
/* harmony export */   "MerkleRoot": function() { return /* binding */ MerkleRoot; }
/* harmony export */ });
/* harmony import */ var _cosmos_ics23_v1_proofs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19033);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__);


/**
 * MerkleRoot defines a merkle root hash.
 * In the Cosmos SDK, the AppHash of a block header becomes the root.
 */

function createBaseMerkleRoot() {
  return {
    hash: new Uint8Array()
  };
}

const MerkleRoot = {
  typeUrl: "/ibc.core.commitment.v1.MerkleRoot",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Writer.create()) {
    if (message.hash.length !== 0) {
      writer.uint32(10).bytes(message.hash);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMerkleRoot();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.hash = reader.bytes();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$hash;

    const message = createBaseMerkleRoot();
    message.hash = (_object$hash = object.hash) !== null && _object$hash !== void 0 ? _object$hash : new Uint8Array();
    return message;
  },

  fromAmino(object) {
    return {
      hash: object.hash
    };
  },

  toAmino(message) {
    const obj = {};
    obj.hash = message.hash;
    return obj;
  },

  fromAminoMsg(object) {
    return MerkleRoot.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/MerkleRoot",
      value: MerkleRoot.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MerkleRoot.decode(message.value);
  },

  toProto(message) {
    return MerkleRoot.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.commitment.v1.MerkleRoot",
      value: MerkleRoot.encode(message).finish()
    };
  }

};

function createBaseMerklePrefix() {
  return {
    keyPrefix: new Uint8Array()
  };
}

const MerklePrefix = {
  typeUrl: "/ibc.core.commitment.v1.MerklePrefix",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Writer.create()) {
    if (message.keyPrefix.length !== 0) {
      writer.uint32(10).bytes(message.keyPrefix);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMerklePrefix();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.keyPrefix = reader.bytes();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$keyPrefix;

    const message = createBaseMerklePrefix();
    message.keyPrefix = (_object$keyPrefix = object.keyPrefix) !== null && _object$keyPrefix !== void 0 ? _object$keyPrefix : new Uint8Array();
    return message;
  },

  fromAmino(object) {
    return {
      keyPrefix: object.key_prefix
    };
  },

  toAmino(message) {
    const obj = {};
    obj.key_prefix = message.keyPrefix;
    return obj;
  },

  fromAminoMsg(object) {
    return MerklePrefix.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/MerklePrefix",
      value: MerklePrefix.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MerklePrefix.decode(message.value);
  },

  toProto(message) {
    return MerklePrefix.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.commitment.v1.MerklePrefix",
      value: MerklePrefix.encode(message).finish()
    };
  }

};

function createBaseMerklePath() {
  return {
    keyPath: []
  };
}

const MerklePath = {
  typeUrl: "/ibc.core.commitment.v1.MerklePath",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Writer.create()) {
    for (const v of message.keyPath) {
      writer.uint32(10).string(v);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMerklePath();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.keyPath.push(reader.string());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$keyPath;

    const message = createBaseMerklePath();
    message.keyPath = ((_object$keyPath = object.keyPath) === null || _object$keyPath === void 0 ? void 0 : _object$keyPath.map(e => e)) || [];
    return message;
  },

  fromAmino(object) {
    return {
      keyPath: Array.isArray(object === null || object === void 0 ? void 0 : object.key_path) ? object.key_path.map(e => e) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.keyPath) {
      obj.key_path = message.keyPath.map(e => e);
    } else {
      obj.key_path = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return MerklePath.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/MerklePath",
      value: MerklePath.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MerklePath.decode(message.value);
  },

  toProto(message) {
    return MerklePath.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.commitment.v1.MerklePath",
      value: MerklePath.encode(message).finish()
    };
  }

};

function createBaseMerkleProof() {
  return {
    proofs: []
  };
}

const MerkleProof = {
  typeUrl: "/ibc.core.commitment.v1.MerkleProof",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Writer.create()) {
    for (const v of message.proofs) {
      _cosmos_ics23_v1_proofs__WEBPACK_IMPORTED_MODULE_0__.CommitmentProof.encode(v, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMerkleProof();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.proofs.push(_cosmos_ics23_v1_proofs__WEBPACK_IMPORTED_MODULE_0__.CommitmentProof.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$proofs;

    const message = createBaseMerkleProof();
    message.proofs = ((_object$proofs = object.proofs) === null || _object$proofs === void 0 ? void 0 : _object$proofs.map(e => _cosmos_ics23_v1_proofs__WEBPACK_IMPORTED_MODULE_0__.CommitmentProof.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      proofs: Array.isArray(object === null || object === void 0 ? void 0 : object.proofs) ? object.proofs.map(e => _cosmos_ics23_v1_proofs__WEBPACK_IMPORTED_MODULE_0__.CommitmentProof.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.proofs) {
      obj.proofs = message.proofs.map(e => e ? _cosmos_ics23_v1_proofs__WEBPACK_IMPORTED_MODULE_0__.CommitmentProof.toAmino(e) : undefined);
    } else {
      obj.proofs = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return MerkleProof.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/MerkleProof",
      value: MerkleProof.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MerkleProof.decode(message.value);
  },

  toProto(message) {
    return MerkleProof.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.commitment.v1.MerkleProof",
      value: MerkleProof.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 14659:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ClientPaths": function() { return /* binding */ ClientPaths; },
/* harmony export */   "ConnectionEnd": function() { return /* binding */ ConnectionEnd; },
/* harmony export */   "ConnectionPaths": function() { return /* binding */ ConnectionPaths; },
/* harmony export */   "Counterparty": function() { return /* binding */ Counterparty; },
/* harmony export */   "IdentifiedConnection": function() { return /* binding */ IdentifiedConnection; },
/* harmony export */   "Params": function() { return /* binding */ Params; },
/* harmony export */   "State": function() { return /* binding */ State; },
/* harmony export */   "StateAmino": function() { return /* binding */ StateAmino; },
/* harmony export */   "StateSDKType": function() { return /* binding */ StateSDKType; },
/* harmony export */   "Version": function() { return /* binding */ Version; },
/* harmony export */   "stateFromJSON": function() { return /* binding */ stateFromJSON; },
/* harmony export */   "stateToJSON": function() { return /* binding */ stateToJSON; }
/* harmony export */ });
/* harmony import */ var _commitment_v1_commitment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48768);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47895);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__);



/**
 * State defines if a connection is in one of the following states:
 * INIT, TRYOPEN, OPEN or UNINITIALIZED.
 */

let State;

(function (State) {
  State[State["STATE_UNINITIALIZED_UNSPECIFIED"] = 0] = "STATE_UNINITIALIZED_UNSPECIFIED";
  State[State["STATE_INIT"] = 1] = "STATE_INIT";
  State[State["STATE_TRYOPEN"] = 2] = "STATE_TRYOPEN";
  State[State["STATE_OPEN"] = 3] = "STATE_OPEN";
  State[State["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(State || (State = {}));

const StateSDKType = State;
const StateAmino = State;
function stateFromJSON(object) {
  switch (object) {
    case 0:
    case "STATE_UNINITIALIZED_UNSPECIFIED":
      return State.STATE_UNINITIALIZED_UNSPECIFIED;

    case 1:
    case "STATE_INIT":
      return State.STATE_INIT;

    case 2:
    case "STATE_TRYOPEN":
      return State.STATE_TRYOPEN;

    case 3:
    case "STATE_OPEN":
      return State.STATE_OPEN;

    case -1:
    case "UNRECOGNIZED":
    default:
      return State.UNRECOGNIZED;
  }
}
function stateToJSON(object) {
  switch (object) {
    case State.STATE_UNINITIALIZED_UNSPECIFIED:
      return "STATE_UNINITIALIZED_UNSPECIFIED";

    case State.STATE_INIT:
      return "STATE_INIT";

    case State.STATE_TRYOPEN:
      return "STATE_TRYOPEN";

    case State.STATE_OPEN:
      return "STATE_OPEN";

    case State.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
/**
 * ConnectionEnd defines a stateful object on a chain connected to another
 * separate one.
 * NOTE: there must only be 2 defined ConnectionEnds to establish
 * a connection between two chains.
 */

function createBaseConnectionEnd() {
  return {
    clientId: "",
    versions: [],
    state: 0,
    counterparty: undefined,
    delayPeriod: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.UZERO */ .dK.UZERO
  };
}

const ConnectionEnd = {
  typeUrl: "/ibc.core.connection.v1.ConnectionEnd",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (message.clientId !== "") {
      writer.uint32(10).string(message.clientId);
    }

    for (const v of message.versions) {
      Version.encode(v, writer.uint32(18).fork()).ldelim();
    }

    if (message.state !== 0) {
      writer.uint32(24).int32(message.state);
    }

    if (message.counterparty !== undefined) {
      Counterparty.encode(message.counterparty, writer.uint32(34).fork()).ldelim();
    }

    if (!message.delayPeriod.isZero()) {
      writer.uint32(40).uint64(message.delayPeriod);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseConnectionEnd();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.clientId = reader.string();
          break;

        case 2:
          message.versions.push(Version.decode(reader, reader.uint32()));
          break;

        case 3:
          message.state = reader.int32();
          break;

        case 4:
          message.counterparty = Counterparty.decode(reader, reader.uint32());
          break;

        case 5:
          message.delayPeriod = reader.uint64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$clientId, _object$versions, _object$state;

    const message = createBaseConnectionEnd();
    message.clientId = (_object$clientId = object.clientId) !== null && _object$clientId !== void 0 ? _object$clientId : "";
    message.versions = ((_object$versions = object.versions) === null || _object$versions === void 0 ? void 0 : _object$versions.map(e => Version.fromPartial(e))) || [];
    message.state = (_object$state = object.state) !== null && _object$state !== void 0 ? _object$state : 0;
    message.counterparty = object.counterparty !== undefined && object.counterparty !== null ? Counterparty.fromPartial(object.counterparty) : undefined;
    message.delayPeriod = object.delayPeriod !== undefined && object.delayPeriod !== null ? _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromValue */ .dK.fromValue(object.delayPeriod) : _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.UZERO */ .dK.UZERO;
    return message;
  },

  fromAmino(object) {
    return {
      clientId: object.client_id,
      versions: Array.isArray(object === null || object === void 0 ? void 0 : object.versions) ? object.versions.map(e => Version.fromAmino(e)) : [],
      state: (0,_helpers__WEBPACK_IMPORTED_MODULE_1__/* .isSet */ .DM)(object.state) ? stateFromJSON(object.state) : 0,
      counterparty: object !== null && object !== void 0 && object.counterparty ? Counterparty.fromAmino(object.counterparty) : undefined,
      delayPeriod: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromString */ .dK.fromString(object.delay_period)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.client_id = message.clientId;

    if (message.versions) {
      obj.versions = message.versions.map(e => e ? Version.toAmino(e) : undefined);
    } else {
      obj.versions = [];
    }

    obj.state = message.state;
    obj.counterparty = message.counterparty ? Counterparty.toAmino(message.counterparty) : undefined;
    obj.delay_period = message.delayPeriod ? message.delayPeriod.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return ConnectionEnd.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/ConnectionEnd",
      value: ConnectionEnd.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return ConnectionEnd.decode(message.value);
  },

  toProto(message) {
    return ConnectionEnd.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.connection.v1.ConnectionEnd",
      value: ConnectionEnd.encode(message).finish()
    };
  }

};

function createBaseIdentifiedConnection() {
  return {
    id: "",
    clientId: "",
    versions: [],
    state: 0,
    counterparty: undefined,
    delayPeriod: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.UZERO */ .dK.UZERO
  };
}

const IdentifiedConnection = {
  typeUrl: "/ibc.core.connection.v1.IdentifiedConnection",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }

    if (message.clientId !== "") {
      writer.uint32(18).string(message.clientId);
    }

    for (const v of message.versions) {
      Version.encode(v, writer.uint32(26).fork()).ldelim();
    }

    if (message.state !== 0) {
      writer.uint32(32).int32(message.state);
    }

    if (message.counterparty !== undefined) {
      Counterparty.encode(message.counterparty, writer.uint32(42).fork()).ldelim();
    }

    if (!message.delayPeriod.isZero()) {
      writer.uint32(48).uint64(message.delayPeriod);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseIdentifiedConnection();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.id = reader.string();
          break;

        case 2:
          message.clientId = reader.string();
          break;

        case 3:
          message.versions.push(Version.decode(reader, reader.uint32()));
          break;

        case 4:
          message.state = reader.int32();
          break;

        case 5:
          message.counterparty = Counterparty.decode(reader, reader.uint32());
          break;

        case 6:
          message.delayPeriod = reader.uint64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$id, _object$clientId2, _object$versions2, _object$state2;

    const message = createBaseIdentifiedConnection();
    message.id = (_object$id = object.id) !== null && _object$id !== void 0 ? _object$id : "";
    message.clientId = (_object$clientId2 = object.clientId) !== null && _object$clientId2 !== void 0 ? _object$clientId2 : "";
    message.versions = ((_object$versions2 = object.versions) === null || _object$versions2 === void 0 ? void 0 : _object$versions2.map(e => Version.fromPartial(e))) || [];
    message.state = (_object$state2 = object.state) !== null && _object$state2 !== void 0 ? _object$state2 : 0;
    message.counterparty = object.counterparty !== undefined && object.counterparty !== null ? Counterparty.fromPartial(object.counterparty) : undefined;
    message.delayPeriod = object.delayPeriod !== undefined && object.delayPeriod !== null ? _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromValue */ .dK.fromValue(object.delayPeriod) : _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.UZERO */ .dK.UZERO;
    return message;
  },

  fromAmino(object) {
    return {
      id: object.id,
      clientId: object.client_id,
      versions: Array.isArray(object === null || object === void 0 ? void 0 : object.versions) ? object.versions.map(e => Version.fromAmino(e)) : [],
      state: (0,_helpers__WEBPACK_IMPORTED_MODULE_1__/* .isSet */ .DM)(object.state) ? stateFromJSON(object.state) : 0,
      counterparty: object !== null && object !== void 0 && object.counterparty ? Counterparty.fromAmino(object.counterparty) : undefined,
      delayPeriod: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromString */ .dK.fromString(object.delay_period)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.id = message.id;
    obj.client_id = message.clientId;

    if (message.versions) {
      obj.versions = message.versions.map(e => e ? Version.toAmino(e) : undefined);
    } else {
      obj.versions = [];
    }

    obj.state = message.state;
    obj.counterparty = message.counterparty ? Counterparty.toAmino(message.counterparty) : undefined;
    obj.delay_period = message.delayPeriod ? message.delayPeriod.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return IdentifiedConnection.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/IdentifiedConnection",
      value: IdentifiedConnection.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return IdentifiedConnection.decode(message.value);
  },

  toProto(message) {
    return IdentifiedConnection.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.connection.v1.IdentifiedConnection",
      value: IdentifiedConnection.encode(message).finish()
    };
  }

};

function createBaseCounterparty() {
  return {
    clientId: "",
    connectionId: "",
    prefix: undefined
  };
}

const Counterparty = {
  typeUrl: "/ibc.core.connection.v1.Counterparty",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (message.clientId !== "") {
      writer.uint32(10).string(message.clientId);
    }

    if (message.connectionId !== "") {
      writer.uint32(18).string(message.connectionId);
    }

    if (message.prefix !== undefined) {
      _commitment_v1_commitment__WEBPACK_IMPORTED_MODULE_0__.MerklePrefix.encode(message.prefix, writer.uint32(26).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCounterparty();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.clientId = reader.string();
          break;

        case 2:
          message.connectionId = reader.string();
          break;

        case 3:
          message.prefix = _commitment_v1_commitment__WEBPACK_IMPORTED_MODULE_0__.MerklePrefix.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$clientId3, _object$connectionId;

    const message = createBaseCounterparty();
    message.clientId = (_object$clientId3 = object.clientId) !== null && _object$clientId3 !== void 0 ? _object$clientId3 : "";
    message.connectionId = (_object$connectionId = object.connectionId) !== null && _object$connectionId !== void 0 ? _object$connectionId : "";
    message.prefix = object.prefix !== undefined && object.prefix !== null ? _commitment_v1_commitment__WEBPACK_IMPORTED_MODULE_0__.MerklePrefix.fromPartial(object.prefix) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      clientId: object.client_id,
      connectionId: object.connection_id,
      prefix: object !== null && object !== void 0 && object.prefix ? _commitment_v1_commitment__WEBPACK_IMPORTED_MODULE_0__.MerklePrefix.fromAmino(object.prefix) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.client_id = message.clientId;
    obj.connection_id = message.connectionId;
    obj.prefix = message.prefix ? _commitment_v1_commitment__WEBPACK_IMPORTED_MODULE_0__.MerklePrefix.toAmino(message.prefix) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return Counterparty.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/Counterparty",
      value: Counterparty.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return Counterparty.decode(message.value);
  },

  toProto(message) {
    return Counterparty.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.connection.v1.Counterparty",
      value: Counterparty.encode(message).finish()
    };
  }

};

function createBaseClientPaths() {
  return {
    paths: []
  };
}

const ClientPaths = {
  typeUrl: "/ibc.core.connection.v1.ClientPaths",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    for (const v of message.paths) {
      writer.uint32(10).string(v);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseClientPaths();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.paths.push(reader.string());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$paths;

    const message = createBaseClientPaths();
    message.paths = ((_object$paths = object.paths) === null || _object$paths === void 0 ? void 0 : _object$paths.map(e => e)) || [];
    return message;
  },

  fromAmino(object) {
    return {
      paths: Array.isArray(object === null || object === void 0 ? void 0 : object.paths) ? object.paths.map(e => e) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.paths) {
      obj.paths = message.paths.map(e => e);
    } else {
      obj.paths = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return ClientPaths.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/ClientPaths",
      value: ClientPaths.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return ClientPaths.decode(message.value);
  },

  toProto(message) {
    return ClientPaths.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.connection.v1.ClientPaths",
      value: ClientPaths.encode(message).finish()
    };
  }

};

function createBaseConnectionPaths() {
  return {
    clientId: "",
    paths: []
  };
}

const ConnectionPaths = {
  typeUrl: "/ibc.core.connection.v1.ConnectionPaths",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (message.clientId !== "") {
      writer.uint32(10).string(message.clientId);
    }

    for (const v of message.paths) {
      writer.uint32(18).string(v);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseConnectionPaths();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.clientId = reader.string();
          break;

        case 2:
          message.paths.push(reader.string());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$clientId4, _object$paths2;

    const message = createBaseConnectionPaths();
    message.clientId = (_object$clientId4 = object.clientId) !== null && _object$clientId4 !== void 0 ? _object$clientId4 : "";
    message.paths = ((_object$paths2 = object.paths) === null || _object$paths2 === void 0 ? void 0 : _object$paths2.map(e => e)) || [];
    return message;
  },

  fromAmino(object) {
    return {
      clientId: object.client_id,
      paths: Array.isArray(object === null || object === void 0 ? void 0 : object.paths) ? object.paths.map(e => e) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.client_id = message.clientId;

    if (message.paths) {
      obj.paths = message.paths.map(e => e);
    } else {
      obj.paths = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return ConnectionPaths.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/ConnectionPaths",
      value: ConnectionPaths.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return ConnectionPaths.decode(message.value);
  },

  toProto(message) {
    return ConnectionPaths.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.connection.v1.ConnectionPaths",
      value: ConnectionPaths.encode(message).finish()
    };
  }

};

function createBaseVersion() {
  return {
    identifier: "",
    features: []
  };
}

const Version = {
  typeUrl: "/ibc.core.connection.v1.Version",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (message.identifier !== "") {
      writer.uint32(10).string(message.identifier);
    }

    for (const v of message.features) {
      writer.uint32(18).string(v);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVersion();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.identifier = reader.string();
          break;

        case 2:
          message.features.push(reader.string());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$identifier, _object$features;

    const message = createBaseVersion();
    message.identifier = (_object$identifier = object.identifier) !== null && _object$identifier !== void 0 ? _object$identifier : "";
    message.features = ((_object$features = object.features) === null || _object$features === void 0 ? void 0 : _object$features.map(e => e)) || [];
    return message;
  },

  fromAmino(object) {
    return {
      identifier: object.identifier,
      features: Array.isArray(object === null || object === void 0 ? void 0 : object.features) ? object.features.map(e => e) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.identifier = message.identifier;

    if (message.features) {
      obj.features = message.features.map(e => e);
    } else {
      obj.features = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return Version.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/Version",
      value: Version.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return Version.decode(message.value);
  },

  toProto(message) {
    return Version.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.connection.v1.Version",
      value: Version.encode(message).finish()
    };
  }

};

function createBaseParams() {
  return {
    maxExpectedTimePerBlock: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.UZERO */ .dK.UZERO
  };
}

const Params = {
  typeUrl: "/ibc.core.connection.v1.Params",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (!message.maxExpectedTimePerBlock.isZero()) {
      writer.uint32(8).uint64(message.maxExpectedTimePerBlock);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseParams();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.maxExpectedTimePerBlock = reader.uint64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseParams();
    message.maxExpectedTimePerBlock = object.maxExpectedTimePerBlock !== undefined && object.maxExpectedTimePerBlock !== null ? _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromValue */ .dK.fromValue(object.maxExpectedTimePerBlock) : _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.UZERO */ .dK.UZERO;
    return message;
  },

  fromAmino(object) {
    return {
      maxExpectedTimePerBlock: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromString */ .dK.fromString(object.max_expected_time_per_block)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.max_expected_time_per_block = message.maxExpectedTimePerBlock ? message.maxExpectedTimePerBlock.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return Params.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/Params",
      value: Params.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return Params.decode(message.value);
  },

  toProto(message) {
    return Params.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.connection.v1.Params",
      value: Params.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 44266:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QueryClientConnectionsRequest": function() { return /* binding */ QueryClientConnectionsRequest; },
/* harmony export */   "QueryClientConnectionsResponse": function() { return /* binding */ QueryClientConnectionsResponse; },
/* harmony export */   "QueryConnectionClientStateRequest": function() { return /* binding */ QueryConnectionClientStateRequest; },
/* harmony export */   "QueryConnectionClientStateResponse": function() { return /* binding */ QueryConnectionClientStateResponse; },
/* harmony export */   "QueryConnectionConsensusStateRequest": function() { return /* binding */ QueryConnectionConsensusStateRequest; },
/* harmony export */   "QueryConnectionConsensusStateResponse": function() { return /* binding */ QueryConnectionConsensusStateResponse; },
/* harmony export */   "QueryConnectionParamsRequest": function() { return /* binding */ QueryConnectionParamsRequest; },
/* harmony export */   "QueryConnectionParamsResponse": function() { return /* binding */ QueryConnectionParamsResponse; },
/* harmony export */   "QueryConnectionRequest": function() { return /* binding */ QueryConnectionRequest; },
/* harmony export */   "QueryConnectionResponse": function() { return /* binding */ QueryConnectionResponse; },
/* harmony export */   "QueryConnectionsRequest": function() { return /* binding */ QueryConnectionsRequest; },
/* harmony export */   "QueryConnectionsResponse": function() { return /* binding */ QueryConnectionsResponse; }
/* harmony export */ });
/* harmony import */ var _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48978);
/* harmony import */ var _connection__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14659);
/* harmony import */ var _client_v1_client__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45802);
/* harmony import */ var _google_protobuf_any__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32106);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47895);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__);






/**
 * QueryConnectionRequest is the request type for the Query/Connection RPC
 * method
 */

function createBaseQueryConnectionRequest() {
  return {
    connectionId: ""
  };
}

const QueryConnectionRequest = {
  typeUrl: "/ibc.core.connection.v1.QueryConnectionRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Writer.create()) {
    if (message.connectionId !== "") {
      writer.uint32(10).string(message.connectionId);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryConnectionRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.connectionId = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$connectionId;

    const message = createBaseQueryConnectionRequest();
    message.connectionId = (_object$connectionId = object.connectionId) !== null && _object$connectionId !== void 0 ? _object$connectionId : "";
    return message;
  },

  fromAmino(object) {
    return {
      connectionId: object.connection_id
    };
  },

  toAmino(message) {
    const obj = {};
    obj.connection_id = message.connectionId;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryConnectionRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryConnectionRequest",
      value: QueryConnectionRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryConnectionRequest.decode(message.value);
  },

  toProto(message) {
    return QueryConnectionRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.connection.v1.QueryConnectionRequest",
      value: QueryConnectionRequest.encode(message).finish()
    };
  }

};

function createBaseQueryConnectionResponse() {
  return {
    connection: undefined,
    proof: new Uint8Array(),
    proofHeight: undefined
  };
}

const QueryConnectionResponse = {
  typeUrl: "/ibc.core.connection.v1.QueryConnectionResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Writer.create()) {
    if (message.connection !== undefined) {
      _connection__WEBPACK_IMPORTED_MODULE_1__.ConnectionEnd.encode(message.connection, writer.uint32(10).fork()).ldelim();
    }

    if (message.proof.length !== 0) {
      writer.uint32(18).bytes(message.proof);
    }

    if (message.proofHeight !== undefined) {
      _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.encode(message.proofHeight, writer.uint32(26).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryConnectionResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.connection = _connection__WEBPACK_IMPORTED_MODULE_1__.ConnectionEnd.decode(reader, reader.uint32());
          break;

        case 2:
          message.proof = reader.bytes();
          break;

        case 3:
          message.proofHeight = _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$proof;

    const message = createBaseQueryConnectionResponse();
    message.connection = object.connection !== undefined && object.connection !== null ? _connection__WEBPACK_IMPORTED_MODULE_1__.ConnectionEnd.fromPartial(object.connection) : undefined;
    message.proof = (_object$proof = object.proof) !== null && _object$proof !== void 0 ? _object$proof : new Uint8Array();
    message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.fromPartial(object.proofHeight) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      connection: object !== null && object !== void 0 && object.connection ? _connection__WEBPACK_IMPORTED_MODULE_1__.ConnectionEnd.fromAmino(object.connection) : undefined,
      proof: object.proof,
      proofHeight: object !== null && object !== void 0 && object.proof_height ? _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.fromAmino(object.proof_height) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.connection = message.connection ? _connection__WEBPACK_IMPORTED_MODULE_1__.ConnectionEnd.toAmino(message.connection) : undefined;
    obj.proof = message.proof;
    obj.proof_height = message.proofHeight ? _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.toAmino(message.proofHeight) : {};
    return obj;
  },

  fromAminoMsg(object) {
    return QueryConnectionResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryConnectionResponse",
      value: QueryConnectionResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryConnectionResponse.decode(message.value);
  },

  toProto(message) {
    return QueryConnectionResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.connection.v1.QueryConnectionResponse",
      value: QueryConnectionResponse.encode(message).finish()
    };
  }

};

function createBaseQueryConnectionsRequest() {
  return {
    pagination: undefined
  };
}

const QueryConnectionsRequest = {
  typeUrl: "/ibc.core.connection.v1.QueryConnectionsRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Writer.create()) {
    if (message.pagination !== undefined) {
      _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryConnectionsRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.pagination = _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseQueryConnectionsRequest();
    message.pagination = object.pagination !== undefined && object.pagination !== null ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.fromPartial(object.pagination) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      pagination: object !== null && object !== void 0 && object.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.fromAmino(object.pagination) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.pagination = message.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.toAmino(message.pagination) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryConnectionsRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryConnectionsRequest",
      value: QueryConnectionsRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryConnectionsRequest.decode(message.value);
  },

  toProto(message) {
    return QueryConnectionsRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.connection.v1.QueryConnectionsRequest",
      value: QueryConnectionsRequest.encode(message).finish()
    };
  }

};

function createBaseQueryConnectionsResponse() {
  return {
    connections: [],
    pagination: undefined,
    height: undefined
  };
}

const QueryConnectionsResponse = {
  typeUrl: "/ibc.core.connection.v1.QueryConnectionsResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Writer.create()) {
    for (const v of message.connections) {
      _connection__WEBPACK_IMPORTED_MODULE_1__.IdentifiedConnection.encode(v, writer.uint32(10).fork()).ldelim();
    }

    if (message.pagination !== undefined) {
      _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
    }

    if (message.height !== undefined) {
      _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.encode(message.height, writer.uint32(26).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryConnectionsResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.connections.push(_connection__WEBPACK_IMPORTED_MODULE_1__.IdentifiedConnection.decode(reader, reader.uint32()));
          break;

        case 2:
          message.pagination = _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.decode(reader, reader.uint32());
          break;

        case 3:
          message.height = _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$connections;

    const message = createBaseQueryConnectionsResponse();
    message.connections = ((_object$connections = object.connections) === null || _object$connections === void 0 ? void 0 : _object$connections.map(e => _connection__WEBPACK_IMPORTED_MODULE_1__.IdentifiedConnection.fromPartial(e))) || [];
    message.pagination = object.pagination !== undefined && object.pagination !== null ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.fromPartial(object.pagination) : undefined;
    message.height = object.height !== undefined && object.height !== null ? _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.fromPartial(object.height) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      connections: Array.isArray(object === null || object === void 0 ? void 0 : object.connections) ? object.connections.map(e => _connection__WEBPACK_IMPORTED_MODULE_1__.IdentifiedConnection.fromAmino(e)) : [],
      pagination: object !== null && object !== void 0 && object.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.fromAmino(object.pagination) : undefined,
      height: object !== null && object !== void 0 && object.height ? _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.fromAmino(object.height) : undefined
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.connections) {
      obj.connections = message.connections.map(e => e ? _connection__WEBPACK_IMPORTED_MODULE_1__.IdentifiedConnection.toAmino(e) : undefined);
    } else {
      obj.connections = [];
    }

    obj.pagination = message.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.toAmino(message.pagination) : undefined;
    obj.height = message.height ? _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.toAmino(message.height) : {};
    return obj;
  },

  fromAminoMsg(object) {
    return QueryConnectionsResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryConnectionsResponse",
      value: QueryConnectionsResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryConnectionsResponse.decode(message.value);
  },

  toProto(message) {
    return QueryConnectionsResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.connection.v1.QueryConnectionsResponse",
      value: QueryConnectionsResponse.encode(message).finish()
    };
  }

};

function createBaseQueryClientConnectionsRequest() {
  return {
    clientId: ""
  };
}

const QueryClientConnectionsRequest = {
  typeUrl: "/ibc.core.connection.v1.QueryClientConnectionsRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Writer.create()) {
    if (message.clientId !== "") {
      writer.uint32(10).string(message.clientId);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryClientConnectionsRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.clientId = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$clientId;

    const message = createBaseQueryClientConnectionsRequest();
    message.clientId = (_object$clientId = object.clientId) !== null && _object$clientId !== void 0 ? _object$clientId : "";
    return message;
  },

  fromAmino(object) {
    return {
      clientId: object.client_id
    };
  },

  toAmino(message) {
    const obj = {};
    obj.client_id = message.clientId;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryClientConnectionsRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryClientConnectionsRequest",
      value: QueryClientConnectionsRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryClientConnectionsRequest.decode(message.value);
  },

  toProto(message) {
    return QueryClientConnectionsRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.connection.v1.QueryClientConnectionsRequest",
      value: QueryClientConnectionsRequest.encode(message).finish()
    };
  }

};

function createBaseQueryClientConnectionsResponse() {
  return {
    connectionPaths: [],
    proof: new Uint8Array(),
    proofHeight: undefined
  };
}

const QueryClientConnectionsResponse = {
  typeUrl: "/ibc.core.connection.v1.QueryClientConnectionsResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Writer.create()) {
    for (const v of message.connectionPaths) {
      writer.uint32(10).string(v);
    }

    if (message.proof.length !== 0) {
      writer.uint32(18).bytes(message.proof);
    }

    if (message.proofHeight !== undefined) {
      _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.encode(message.proofHeight, writer.uint32(26).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryClientConnectionsResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.connectionPaths.push(reader.string());
          break;

        case 2:
          message.proof = reader.bytes();
          break;

        case 3:
          message.proofHeight = _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$connectionPat, _object$proof2;

    const message = createBaseQueryClientConnectionsResponse();
    message.connectionPaths = ((_object$connectionPat = object.connectionPaths) === null || _object$connectionPat === void 0 ? void 0 : _object$connectionPat.map(e => e)) || [];
    message.proof = (_object$proof2 = object.proof) !== null && _object$proof2 !== void 0 ? _object$proof2 : new Uint8Array();
    message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.fromPartial(object.proofHeight) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      connectionPaths: Array.isArray(object === null || object === void 0 ? void 0 : object.connection_paths) ? object.connection_paths.map(e => e) : [],
      proof: object.proof,
      proofHeight: object !== null && object !== void 0 && object.proof_height ? _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.fromAmino(object.proof_height) : undefined
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.connectionPaths) {
      obj.connection_paths = message.connectionPaths.map(e => e);
    } else {
      obj.connection_paths = [];
    }

    obj.proof = message.proof;
    obj.proof_height = message.proofHeight ? _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.toAmino(message.proofHeight) : {};
    return obj;
  },

  fromAminoMsg(object) {
    return QueryClientConnectionsResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryClientConnectionsResponse",
      value: QueryClientConnectionsResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryClientConnectionsResponse.decode(message.value);
  },

  toProto(message) {
    return QueryClientConnectionsResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.connection.v1.QueryClientConnectionsResponse",
      value: QueryClientConnectionsResponse.encode(message).finish()
    };
  }

};

function createBaseQueryConnectionClientStateRequest() {
  return {
    connectionId: ""
  };
}

const QueryConnectionClientStateRequest = {
  typeUrl: "/ibc.core.connection.v1.QueryConnectionClientStateRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Writer.create()) {
    if (message.connectionId !== "") {
      writer.uint32(10).string(message.connectionId);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryConnectionClientStateRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.connectionId = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$connectionId2;

    const message = createBaseQueryConnectionClientStateRequest();
    message.connectionId = (_object$connectionId2 = object.connectionId) !== null && _object$connectionId2 !== void 0 ? _object$connectionId2 : "";
    return message;
  },

  fromAmino(object) {
    return {
      connectionId: object.connection_id
    };
  },

  toAmino(message) {
    const obj = {};
    obj.connection_id = message.connectionId;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryConnectionClientStateRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryConnectionClientStateRequest",
      value: QueryConnectionClientStateRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryConnectionClientStateRequest.decode(message.value);
  },

  toProto(message) {
    return QueryConnectionClientStateRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.connection.v1.QueryConnectionClientStateRequest",
      value: QueryConnectionClientStateRequest.encode(message).finish()
    };
  }

};

function createBaseQueryConnectionClientStateResponse() {
  return {
    identifiedClientState: undefined,
    proof: new Uint8Array(),
    proofHeight: undefined
  };
}

const QueryConnectionClientStateResponse = {
  typeUrl: "/ibc.core.connection.v1.QueryConnectionClientStateResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Writer.create()) {
    if (message.identifiedClientState !== undefined) {
      _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.IdentifiedClientState.encode(message.identifiedClientState, writer.uint32(10).fork()).ldelim();
    }

    if (message.proof.length !== 0) {
      writer.uint32(18).bytes(message.proof);
    }

    if (message.proofHeight !== undefined) {
      _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.encode(message.proofHeight, writer.uint32(26).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryConnectionClientStateResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.identifiedClientState = _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.IdentifiedClientState.decode(reader, reader.uint32());
          break;

        case 2:
          message.proof = reader.bytes();
          break;

        case 3:
          message.proofHeight = _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$proof3;

    const message = createBaseQueryConnectionClientStateResponse();
    message.identifiedClientState = object.identifiedClientState !== undefined && object.identifiedClientState !== null ? _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.IdentifiedClientState.fromPartial(object.identifiedClientState) : undefined;
    message.proof = (_object$proof3 = object.proof) !== null && _object$proof3 !== void 0 ? _object$proof3 : new Uint8Array();
    message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.fromPartial(object.proofHeight) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      identifiedClientState: object !== null && object !== void 0 && object.identified_client_state ? _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.IdentifiedClientState.fromAmino(object.identified_client_state) : undefined,
      proof: object.proof,
      proofHeight: object !== null && object !== void 0 && object.proof_height ? _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.fromAmino(object.proof_height) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.identified_client_state = message.identifiedClientState ? _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.IdentifiedClientState.toAmino(message.identifiedClientState) : undefined;
    obj.proof = message.proof;
    obj.proof_height = message.proofHeight ? _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.toAmino(message.proofHeight) : {};
    return obj;
  },

  fromAminoMsg(object) {
    return QueryConnectionClientStateResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryConnectionClientStateResponse",
      value: QueryConnectionClientStateResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryConnectionClientStateResponse.decode(message.value);
  },

  toProto(message) {
    return QueryConnectionClientStateResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.connection.v1.QueryConnectionClientStateResponse",
      value: QueryConnectionClientStateResponse.encode(message).finish()
    };
  }

};

function createBaseQueryConnectionConsensusStateRequest() {
  return {
    connectionId: "",
    revisionNumber: _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.UZERO */ .dK.UZERO,
    revisionHeight: _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.UZERO */ .dK.UZERO
  };
}

const QueryConnectionConsensusStateRequest = {
  typeUrl: "/ibc.core.connection.v1.QueryConnectionConsensusStateRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Writer.create()) {
    if (message.connectionId !== "") {
      writer.uint32(10).string(message.connectionId);
    }

    if (!message.revisionNumber.isZero()) {
      writer.uint32(16).uint64(message.revisionNumber);
    }

    if (!message.revisionHeight.isZero()) {
      writer.uint32(24).uint64(message.revisionHeight);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryConnectionConsensusStateRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.connectionId = reader.string();
          break;

        case 2:
          message.revisionNumber = reader.uint64();
          break;

        case 3:
          message.revisionHeight = reader.uint64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$connectionId3;

    const message = createBaseQueryConnectionConsensusStateRequest();
    message.connectionId = (_object$connectionId3 = object.connectionId) !== null && _object$connectionId3 !== void 0 ? _object$connectionId3 : "";
    message.revisionNumber = object.revisionNumber !== undefined && object.revisionNumber !== null ? _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.fromValue */ .dK.fromValue(object.revisionNumber) : _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.UZERO */ .dK.UZERO;
    message.revisionHeight = object.revisionHeight !== undefined && object.revisionHeight !== null ? _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.fromValue */ .dK.fromValue(object.revisionHeight) : _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.UZERO */ .dK.UZERO;
    return message;
  },

  fromAmino(object) {
    return {
      connectionId: object.connection_id,
      revisionNumber: _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.fromString */ .dK.fromString(object.revision_number),
      revisionHeight: _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.fromString */ .dK.fromString(object.revision_height)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.connection_id = message.connectionId;
    obj.revision_number = message.revisionNumber ? message.revisionNumber.toString() : undefined;
    obj.revision_height = message.revisionHeight ? message.revisionHeight.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryConnectionConsensusStateRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryConnectionConsensusStateRequest",
      value: QueryConnectionConsensusStateRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryConnectionConsensusStateRequest.decode(message.value);
  },

  toProto(message) {
    return QueryConnectionConsensusStateRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.connection.v1.QueryConnectionConsensusStateRequest",
      value: QueryConnectionConsensusStateRequest.encode(message).finish()
    };
  }

};

function createBaseQueryConnectionConsensusStateResponse() {
  return {
    consensusState: undefined,
    clientId: "",
    proof: new Uint8Array(),
    proofHeight: undefined
  };
}

const QueryConnectionConsensusStateResponse = {
  typeUrl: "/ibc.core.connection.v1.QueryConnectionConsensusStateResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Writer.create()) {
    if (message.consensusState !== undefined) {
      _google_protobuf_any__WEBPACK_IMPORTED_MODULE_3__.Any.encode(message.consensusState, writer.uint32(10).fork()).ldelim();
    }

    if (message.clientId !== "") {
      writer.uint32(18).string(message.clientId);
    }

    if (message.proof.length !== 0) {
      writer.uint32(26).bytes(message.proof);
    }

    if (message.proofHeight !== undefined) {
      _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.encode(message.proofHeight, writer.uint32(34).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryConnectionConsensusStateResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.consensusState = _google_protobuf_any__WEBPACK_IMPORTED_MODULE_3__.Any.decode(reader, reader.uint32());
          break;

        case 2:
          message.clientId = reader.string();
          break;

        case 3:
          message.proof = reader.bytes();
          break;

        case 4:
          message.proofHeight = _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$clientId2, _object$proof4;

    const message = createBaseQueryConnectionConsensusStateResponse();
    message.consensusState = object.consensusState !== undefined && object.consensusState !== null ? _google_protobuf_any__WEBPACK_IMPORTED_MODULE_3__.Any.fromPartial(object.consensusState) : undefined;
    message.clientId = (_object$clientId2 = object.clientId) !== null && _object$clientId2 !== void 0 ? _object$clientId2 : "";
    message.proof = (_object$proof4 = object.proof) !== null && _object$proof4 !== void 0 ? _object$proof4 : new Uint8Array();
    message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.fromPartial(object.proofHeight) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      consensusState: object !== null && object !== void 0 && object.consensus_state ? _google_protobuf_any__WEBPACK_IMPORTED_MODULE_3__.Any.fromAmino(object.consensus_state) : undefined,
      clientId: object.client_id,
      proof: object.proof,
      proofHeight: object !== null && object !== void 0 && object.proof_height ? _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.fromAmino(object.proof_height) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.consensus_state = message.consensusState ? _google_protobuf_any__WEBPACK_IMPORTED_MODULE_3__.Any.toAmino(message.consensusState) : undefined;
    obj.client_id = message.clientId;
    obj.proof = message.proof;
    obj.proof_height = message.proofHeight ? _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.toAmino(message.proofHeight) : {};
    return obj;
  },

  fromAminoMsg(object) {
    return QueryConnectionConsensusStateResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryConnectionConsensusStateResponse",
      value: QueryConnectionConsensusStateResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryConnectionConsensusStateResponse.decode(message.value);
  },

  toProto(message) {
    return QueryConnectionConsensusStateResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.connection.v1.QueryConnectionConsensusStateResponse",
      value: QueryConnectionConsensusStateResponse.encode(message).finish()
    };
  }

};

function createBaseQueryConnectionParamsRequest() {
  return {};
}

const QueryConnectionParamsRequest = {
  typeUrl: "/ibc.core.connection.v1.QueryConnectionParamsRequest",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryConnectionParamsRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseQueryConnectionParamsRequest();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return QueryConnectionParamsRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryConnectionParamsRequest",
      value: QueryConnectionParamsRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryConnectionParamsRequest.decode(message.value);
  },

  toProto(message) {
    return QueryConnectionParamsRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.connection.v1.QueryConnectionParamsRequest",
      value: QueryConnectionParamsRequest.encode(message).finish()
    };
  }

};

function createBaseQueryConnectionParamsResponse() {
  return {
    params: undefined
  };
}

const QueryConnectionParamsResponse = {
  typeUrl: "/ibc.core.connection.v1.QueryConnectionParamsResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Writer.create()) {
    if (message.params !== undefined) {
      _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryConnectionParamsResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.params = _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Params.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseQueryConnectionParamsResponse();
    message.params = object.params !== undefined && object.params !== null ? _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Params.fromPartial(object.params) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      params: object !== null && object !== void 0 && object.params ? _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Params.fromAmino(object.params) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.params = message.params ? _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Params.toAmino(message.params) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryConnectionParamsResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryConnectionParamsResponse",
      value: QueryConnectionParamsResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryConnectionParamsResponse.decode(message.value);
  },

  toProto(message) {
    return QueryConnectionParamsResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.connection.v1.QueryConnectionParamsResponse",
      value: QueryConnectionParamsResponse.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 15428:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LCDQueryClient": function() { return /* binding */ LCDQueryClient; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4942);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47895);


class LCDQueryClient {
  constructor({
    requestClient
  }) {
    (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, "req", void 0);

    this.req = requestClient;
    this.connection = this.connection.bind(this);
    this.connections = this.connections.bind(this);
    this.clientConnections = this.clientConnections.bind(this);
    this.connectionClientState = this.connectionClientState.bind(this);
    this.connectionConsensusState = this.connectionConsensusState.bind(this);
    this.connectionParams = this.connectionParams.bind(this);
  }
  /* Connection queries an IBC connection end. */


  async connection(params) {
    const endpoint = `ibc/core/connection/v1/connections/${params.connectionId}`;
    return await this.req.get(endpoint);
  }
  /* Connections queries all the IBC connections of a chain. */


  async connections(params = {
    pagination: undefined
  }) {
    const options = {
      params: {}
    };

    if (typeof (params === null || params === void 0 ? void 0 : params.pagination) !== "undefined") {
      (0,_helpers__WEBPACK_IMPORTED_MODULE_0__/* .setPaginationParams */ .q6)(options, params.pagination);
    }

    const endpoint = `ibc/core/connection/v1/connections`;
    return await this.req.get(endpoint, options);
  }
  /* ClientConnections queries the connection paths associated with a client
   state. */


  async clientConnections(params) {
    const endpoint = `ibc/core/connection/v1/client_connections/${params.clientId}`;
    return await this.req.get(endpoint);
  }
  /* ConnectionClientState queries the client state associated with the
   connection. */


  async connectionClientState(params) {
    const endpoint = `ibc/core/connection/v1/connections/${params.connectionId}/client_state`;
    return await this.req.get(endpoint);
  }
  /* ConnectionConsensusState queries the consensus state associated with the
   connection. */


  async connectionConsensusState(params) {
    const endpoint = `ibc/core/connection/v1/connections/${params.connectionId}/consensus_state/revision/${params.revisionNumber}/height/${params.revisionHeight}`;
    return await this.req.get(endpoint);
  }
  /* ConnectionParams queries all parameters of the ibc connection submodule. */


  async connectionParams(_params = {}) {
    const endpoint = `ibc/core/connection/v1/params`;
    return await this.req.get(endpoint);
  }

}

/***/ }),

/***/ 50290:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QueryClientImpl": function() { return /* binding */ QueryClientImpl; },
/* harmony export */   "createRpcQueryExtension": function() { return /* binding */ createRpcQueryExtension; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4942);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78441);
/* harmony import */ var _cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44266);




/** Query provides defines the gRPC querier service */

class QueryClientImpl {
  constructor(rpc) {
    (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, "rpc", void 0);

    this.rpc = rpc;
    this.connection = this.connection.bind(this);
    this.connections = this.connections.bind(this);
    this.clientConnections = this.clientConnections.bind(this);
    this.connectionClientState = this.connectionClientState.bind(this);
    this.connectionConsensusState = this.connectionConsensusState.bind(this);
    this.connectionParams = this.connectionParams.bind(this);
  }

  connection(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryConnectionRequest.encode(request).finish();
    const promise = this.rpc.request("ibc.core.connection.v1.Query", "Connection", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryConnectionResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  connections(request = {
    pagination: undefined
  }) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryConnectionsRequest.encode(request).finish();
    const promise = this.rpc.request("ibc.core.connection.v1.Query", "Connections", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryConnectionsResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  clientConnections(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryClientConnectionsRequest.encode(request).finish();
    const promise = this.rpc.request("ibc.core.connection.v1.Query", "ClientConnections", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryClientConnectionsResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  connectionClientState(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryConnectionClientStateRequest.encode(request).finish();
    const promise = this.rpc.request("ibc.core.connection.v1.Query", "ConnectionClientState", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryConnectionClientStateResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  connectionConsensusState(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryConnectionConsensusStateRequest.encode(request).finish();
    const promise = this.rpc.request("ibc.core.connection.v1.Query", "ConnectionConsensusState", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryConnectionConsensusStateResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  connectionParams(request = {}) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryConnectionParamsRequest.encode(request).finish();
    const promise = this.rpc.request("ibc.core.connection.v1.Query", "ConnectionParams", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryConnectionParamsResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

}
const createRpcQueryExtension = base => {
  const rpc = (0,_cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1__.createProtobufRpcClient)(base);
  const queryService = new QueryClientImpl(rpc);
  return {
    connection(request) {
      return queryService.connection(request);
    },

    connections(request) {
      return queryService.connections(request);
    },

    clientConnections(request) {
      return queryService.clientConnections(request);
    },

    connectionClientState(request) {
      return queryService.connectionClientState(request);
    },

    connectionConsensusState(request) {
      return queryService.connectionConsensusState(request);
    },

    connectionParams(request) {
      return queryService.connectionParams(request);
    }

  };
};

/***/ }),

/***/ 35111:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MsgConnectionOpenAck": function() { return /* binding */ MsgConnectionOpenAck; },
/* harmony export */   "MsgConnectionOpenAckResponse": function() { return /* binding */ MsgConnectionOpenAckResponse; },
/* harmony export */   "MsgConnectionOpenConfirm": function() { return /* binding */ MsgConnectionOpenConfirm; },
/* harmony export */   "MsgConnectionOpenConfirmResponse": function() { return /* binding */ MsgConnectionOpenConfirmResponse; },
/* harmony export */   "MsgConnectionOpenInit": function() { return /* binding */ MsgConnectionOpenInit; },
/* harmony export */   "MsgConnectionOpenInitResponse": function() { return /* binding */ MsgConnectionOpenInitResponse; },
/* harmony export */   "MsgConnectionOpenTry": function() { return /* binding */ MsgConnectionOpenTry; },
/* harmony export */   "MsgConnectionOpenTryResponse": function() { return /* binding */ MsgConnectionOpenTryResponse; }
/* harmony export */ });
/* harmony import */ var _connection__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14659);
/* harmony import */ var _google_protobuf_any__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32106);
/* harmony import */ var _client_v1_client__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45802);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47895);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__);





/**
 * MsgConnectionOpenInit defines the msg sent by an account on Chain A to
 * initialize a connection with Chain B.
 */

function createBaseMsgConnectionOpenInit() {
  return {
    clientId: "",
    counterparty: undefined,
    version: undefined,
    delayPeriod: _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.UZERO */ .dK.UZERO,
    signer: ""
  };
}

const MsgConnectionOpenInit = {
  typeUrl: "/ibc.core.connection.v1.MsgConnectionOpenInit",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    if (message.clientId !== "") {
      writer.uint32(10).string(message.clientId);
    }

    if (message.counterparty !== undefined) {
      _connection__WEBPACK_IMPORTED_MODULE_0__.Counterparty.encode(message.counterparty, writer.uint32(18).fork()).ldelim();
    }

    if (message.version !== undefined) {
      _connection__WEBPACK_IMPORTED_MODULE_0__.Version.encode(message.version, writer.uint32(26).fork()).ldelim();
    }

    if (!message.delayPeriod.isZero()) {
      writer.uint32(32).uint64(message.delayPeriod);
    }

    if (message.signer !== "") {
      writer.uint32(42).string(message.signer);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgConnectionOpenInit();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.clientId = reader.string();
          break;

        case 2:
          message.counterparty = _connection__WEBPACK_IMPORTED_MODULE_0__.Counterparty.decode(reader, reader.uint32());
          break;

        case 3:
          message.version = _connection__WEBPACK_IMPORTED_MODULE_0__.Version.decode(reader, reader.uint32());
          break;

        case 4:
          message.delayPeriod = reader.uint64();
          break;

        case 5:
          message.signer = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$clientId, _object$signer;

    const message = createBaseMsgConnectionOpenInit();
    message.clientId = (_object$clientId = object.clientId) !== null && _object$clientId !== void 0 ? _object$clientId : "";
    message.counterparty = object.counterparty !== undefined && object.counterparty !== null ? _connection__WEBPACK_IMPORTED_MODULE_0__.Counterparty.fromPartial(object.counterparty) : undefined;
    message.version = object.version !== undefined && object.version !== null ? _connection__WEBPACK_IMPORTED_MODULE_0__.Version.fromPartial(object.version) : undefined;
    message.delayPeriod = object.delayPeriod !== undefined && object.delayPeriod !== null ? _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.fromValue */ .dK.fromValue(object.delayPeriod) : _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.UZERO */ .dK.UZERO;
    message.signer = (_object$signer = object.signer) !== null && _object$signer !== void 0 ? _object$signer : "";
    return message;
  },

  fromAmino(object) {
    return {
      clientId: object.client_id,
      counterparty: object !== null && object !== void 0 && object.counterparty ? _connection__WEBPACK_IMPORTED_MODULE_0__.Counterparty.fromAmino(object.counterparty) : undefined,
      version: object !== null && object !== void 0 && object.version ? _connection__WEBPACK_IMPORTED_MODULE_0__.Version.fromAmino(object.version) : undefined,
      delayPeriod: _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.fromString */ .dK.fromString(object.delay_period),
      signer: object.signer
    };
  },

  toAmino(message) {
    const obj = {};
    obj.client_id = message.clientId;
    obj.counterparty = message.counterparty ? _connection__WEBPACK_IMPORTED_MODULE_0__.Counterparty.toAmino(message.counterparty) : undefined;
    obj.version = message.version ? _connection__WEBPACK_IMPORTED_MODULE_0__.Version.toAmino(message.version) : undefined;
    obj.delay_period = message.delayPeriod ? message.delayPeriod.toString() : undefined;
    obj.signer = message.signer;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgConnectionOpenInit.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/MsgConnectionOpenInit",
      value: MsgConnectionOpenInit.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgConnectionOpenInit.decode(message.value);
  },

  toProto(message) {
    return MsgConnectionOpenInit.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.connection.v1.MsgConnectionOpenInit",
      value: MsgConnectionOpenInit.encode(message).finish()
    };
  }

};

function createBaseMsgConnectionOpenInitResponse() {
  return {};
}

const MsgConnectionOpenInitResponse = {
  typeUrl: "/ibc.core.connection.v1.MsgConnectionOpenInitResponse",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgConnectionOpenInitResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseMsgConnectionOpenInitResponse();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return MsgConnectionOpenInitResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/MsgConnectionOpenInitResponse",
      value: MsgConnectionOpenInitResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgConnectionOpenInitResponse.decode(message.value);
  },

  toProto(message) {
    return MsgConnectionOpenInitResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.connection.v1.MsgConnectionOpenInitResponse",
      value: MsgConnectionOpenInitResponse.encode(message).finish()
    };
  }

};

function createBaseMsgConnectionOpenTry() {
  return {
    clientId: "",
    previousConnectionId: "",
    clientState: undefined,
    counterparty: undefined,
    delayPeriod: _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.UZERO */ .dK.UZERO,
    counterpartyVersions: [],
    proofHeight: undefined,
    proofInit: new Uint8Array(),
    proofClient: new Uint8Array(),
    proofConsensus: new Uint8Array(),
    consensusHeight: undefined,
    signer: "",
    hostConsensusStateProof: new Uint8Array()
  };
}

const MsgConnectionOpenTry = {
  typeUrl: "/ibc.core.connection.v1.MsgConnectionOpenTry",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    if (message.clientId !== "") {
      writer.uint32(10).string(message.clientId);
    }

    if (message.previousConnectionId !== "") {
      writer.uint32(18).string(message.previousConnectionId);
    }

    if (message.clientState !== undefined) {
      _google_protobuf_any__WEBPACK_IMPORTED_MODULE_1__.Any.encode(message.clientState, writer.uint32(26).fork()).ldelim();
    }

    if (message.counterparty !== undefined) {
      _connection__WEBPACK_IMPORTED_MODULE_0__.Counterparty.encode(message.counterparty, writer.uint32(34).fork()).ldelim();
    }

    if (!message.delayPeriod.isZero()) {
      writer.uint32(40).uint64(message.delayPeriod);
    }

    for (const v of message.counterpartyVersions) {
      _connection__WEBPACK_IMPORTED_MODULE_0__.Version.encode(v, writer.uint32(50).fork()).ldelim();
    }

    if (message.proofHeight !== undefined) {
      _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.encode(message.proofHeight, writer.uint32(58).fork()).ldelim();
    }

    if (message.proofInit.length !== 0) {
      writer.uint32(66).bytes(message.proofInit);
    }

    if (message.proofClient.length !== 0) {
      writer.uint32(74).bytes(message.proofClient);
    }

    if (message.proofConsensus.length !== 0) {
      writer.uint32(82).bytes(message.proofConsensus);
    }

    if (message.consensusHeight !== undefined) {
      _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.encode(message.consensusHeight, writer.uint32(90).fork()).ldelim();
    }

    if (message.signer !== "") {
      writer.uint32(98).string(message.signer);
    }

    if (message.hostConsensusStateProof.length !== 0) {
      writer.uint32(106).bytes(message.hostConsensusStateProof);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgConnectionOpenTry();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.clientId = reader.string();
          break;

        case 2:
          message.previousConnectionId = reader.string();
          break;

        case 3:
          message.clientState = _google_protobuf_any__WEBPACK_IMPORTED_MODULE_1__.Any.decode(reader, reader.uint32());
          break;

        case 4:
          message.counterparty = _connection__WEBPACK_IMPORTED_MODULE_0__.Counterparty.decode(reader, reader.uint32());
          break;

        case 5:
          message.delayPeriod = reader.uint64();
          break;

        case 6:
          message.counterpartyVersions.push(_connection__WEBPACK_IMPORTED_MODULE_0__.Version.decode(reader, reader.uint32()));
          break;

        case 7:
          message.proofHeight = _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.decode(reader, reader.uint32());
          break;

        case 8:
          message.proofInit = reader.bytes();
          break;

        case 9:
          message.proofClient = reader.bytes();
          break;

        case 10:
          message.proofConsensus = reader.bytes();
          break;

        case 11:
          message.consensusHeight = _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.decode(reader, reader.uint32());
          break;

        case 12:
          message.signer = reader.string();
          break;

        case 13:
          message.hostConsensusStateProof = reader.bytes();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$clientId2, _object$previousConne, _object$counterpartyV, _object$proofInit, _object$proofClient, _object$proofConsensu, _object$signer2, _object$hostConsensus;

    const message = createBaseMsgConnectionOpenTry();
    message.clientId = (_object$clientId2 = object.clientId) !== null && _object$clientId2 !== void 0 ? _object$clientId2 : "";
    message.previousConnectionId = (_object$previousConne = object.previousConnectionId) !== null && _object$previousConne !== void 0 ? _object$previousConne : "";
    message.clientState = object.clientState !== undefined && object.clientState !== null ? _google_protobuf_any__WEBPACK_IMPORTED_MODULE_1__.Any.fromPartial(object.clientState) : undefined;
    message.counterparty = object.counterparty !== undefined && object.counterparty !== null ? _connection__WEBPACK_IMPORTED_MODULE_0__.Counterparty.fromPartial(object.counterparty) : undefined;
    message.delayPeriod = object.delayPeriod !== undefined && object.delayPeriod !== null ? _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.fromValue */ .dK.fromValue(object.delayPeriod) : _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.UZERO */ .dK.UZERO;
    message.counterpartyVersions = ((_object$counterpartyV = object.counterpartyVersions) === null || _object$counterpartyV === void 0 ? void 0 : _object$counterpartyV.map(e => _connection__WEBPACK_IMPORTED_MODULE_0__.Version.fromPartial(e))) || [];
    message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.fromPartial(object.proofHeight) : undefined;
    message.proofInit = (_object$proofInit = object.proofInit) !== null && _object$proofInit !== void 0 ? _object$proofInit : new Uint8Array();
    message.proofClient = (_object$proofClient = object.proofClient) !== null && _object$proofClient !== void 0 ? _object$proofClient : new Uint8Array();
    message.proofConsensus = (_object$proofConsensu = object.proofConsensus) !== null && _object$proofConsensu !== void 0 ? _object$proofConsensu : new Uint8Array();
    message.consensusHeight = object.consensusHeight !== undefined && object.consensusHeight !== null ? _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.fromPartial(object.consensusHeight) : undefined;
    message.signer = (_object$signer2 = object.signer) !== null && _object$signer2 !== void 0 ? _object$signer2 : "";
    message.hostConsensusStateProof = (_object$hostConsensus = object.hostConsensusStateProof) !== null && _object$hostConsensus !== void 0 ? _object$hostConsensus : new Uint8Array();
    return message;
  },

  fromAmino(object) {
    return {
      clientId: object.client_id,
      previousConnectionId: object.previous_connection_id,
      clientState: object !== null && object !== void 0 && object.client_state ? _google_protobuf_any__WEBPACK_IMPORTED_MODULE_1__.Any.fromAmino(object.client_state) : undefined,
      counterparty: object !== null && object !== void 0 && object.counterparty ? _connection__WEBPACK_IMPORTED_MODULE_0__.Counterparty.fromAmino(object.counterparty) : undefined,
      delayPeriod: _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.fromString */ .dK.fromString(object.delay_period),
      counterpartyVersions: Array.isArray(object === null || object === void 0 ? void 0 : object.counterparty_versions) ? object.counterparty_versions.map(e => _connection__WEBPACK_IMPORTED_MODULE_0__.Version.fromAmino(e)) : [],
      proofHeight: object !== null && object !== void 0 && object.proof_height ? _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.fromAmino(object.proof_height) : undefined,
      proofInit: object.proof_init,
      proofClient: object.proof_client,
      proofConsensus: object.proof_consensus,
      consensusHeight: object !== null && object !== void 0 && object.consensus_height ? _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.fromAmino(object.consensus_height) : undefined,
      signer: object.signer,
      hostConsensusStateProof: object.host_consensus_state_proof
    };
  },

  toAmino(message) {
    const obj = {};
    obj.client_id = message.clientId;
    obj.previous_connection_id = message.previousConnectionId;
    obj.client_state = message.clientState ? _google_protobuf_any__WEBPACK_IMPORTED_MODULE_1__.Any.toAmino(message.clientState) : undefined;
    obj.counterparty = message.counterparty ? _connection__WEBPACK_IMPORTED_MODULE_0__.Counterparty.toAmino(message.counterparty) : undefined;
    obj.delay_period = message.delayPeriod ? message.delayPeriod.toString() : undefined;

    if (message.counterpartyVersions) {
      obj.counterparty_versions = message.counterpartyVersions.map(e => e ? _connection__WEBPACK_IMPORTED_MODULE_0__.Version.toAmino(e) : undefined);
    } else {
      obj.counterparty_versions = [];
    }

    obj.proof_height = message.proofHeight ? _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.toAmino(message.proofHeight) : {};
    obj.proof_init = message.proofInit;
    obj.proof_client = message.proofClient;
    obj.proof_consensus = message.proofConsensus;
    obj.consensus_height = message.consensusHeight ? _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.toAmino(message.consensusHeight) : {};
    obj.signer = message.signer;
    obj.host_consensus_state_proof = message.hostConsensusStateProof;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgConnectionOpenTry.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/MsgConnectionOpenTry",
      value: MsgConnectionOpenTry.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgConnectionOpenTry.decode(message.value);
  },

  toProto(message) {
    return MsgConnectionOpenTry.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.connection.v1.MsgConnectionOpenTry",
      value: MsgConnectionOpenTry.encode(message).finish()
    };
  }

};

function createBaseMsgConnectionOpenTryResponse() {
  return {};
}

const MsgConnectionOpenTryResponse = {
  typeUrl: "/ibc.core.connection.v1.MsgConnectionOpenTryResponse",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgConnectionOpenTryResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseMsgConnectionOpenTryResponse();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return MsgConnectionOpenTryResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/MsgConnectionOpenTryResponse",
      value: MsgConnectionOpenTryResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgConnectionOpenTryResponse.decode(message.value);
  },

  toProto(message) {
    return MsgConnectionOpenTryResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.connection.v1.MsgConnectionOpenTryResponse",
      value: MsgConnectionOpenTryResponse.encode(message).finish()
    };
  }

};

function createBaseMsgConnectionOpenAck() {
  return {
    connectionId: "",
    counterpartyConnectionId: "",
    version: undefined,
    clientState: undefined,
    proofHeight: undefined,
    proofTry: new Uint8Array(),
    proofClient: new Uint8Array(),
    proofConsensus: new Uint8Array(),
    consensusHeight: undefined,
    signer: "",
    hostConsensusStateProof: new Uint8Array()
  };
}

const MsgConnectionOpenAck = {
  typeUrl: "/ibc.core.connection.v1.MsgConnectionOpenAck",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    if (message.connectionId !== "") {
      writer.uint32(10).string(message.connectionId);
    }

    if (message.counterpartyConnectionId !== "") {
      writer.uint32(18).string(message.counterpartyConnectionId);
    }

    if (message.version !== undefined) {
      _connection__WEBPACK_IMPORTED_MODULE_0__.Version.encode(message.version, writer.uint32(26).fork()).ldelim();
    }

    if (message.clientState !== undefined) {
      _google_protobuf_any__WEBPACK_IMPORTED_MODULE_1__.Any.encode(message.clientState, writer.uint32(34).fork()).ldelim();
    }

    if (message.proofHeight !== undefined) {
      _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.encode(message.proofHeight, writer.uint32(42).fork()).ldelim();
    }

    if (message.proofTry.length !== 0) {
      writer.uint32(50).bytes(message.proofTry);
    }

    if (message.proofClient.length !== 0) {
      writer.uint32(58).bytes(message.proofClient);
    }

    if (message.proofConsensus.length !== 0) {
      writer.uint32(66).bytes(message.proofConsensus);
    }

    if (message.consensusHeight !== undefined) {
      _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.encode(message.consensusHeight, writer.uint32(74).fork()).ldelim();
    }

    if (message.signer !== "") {
      writer.uint32(82).string(message.signer);
    }

    if (message.hostConsensusStateProof.length !== 0) {
      writer.uint32(90).bytes(message.hostConsensusStateProof);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgConnectionOpenAck();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.connectionId = reader.string();
          break;

        case 2:
          message.counterpartyConnectionId = reader.string();
          break;

        case 3:
          message.version = _connection__WEBPACK_IMPORTED_MODULE_0__.Version.decode(reader, reader.uint32());
          break;

        case 4:
          message.clientState = _google_protobuf_any__WEBPACK_IMPORTED_MODULE_1__.Any.decode(reader, reader.uint32());
          break;

        case 5:
          message.proofHeight = _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.decode(reader, reader.uint32());
          break;

        case 6:
          message.proofTry = reader.bytes();
          break;

        case 7:
          message.proofClient = reader.bytes();
          break;

        case 8:
          message.proofConsensus = reader.bytes();
          break;

        case 9:
          message.consensusHeight = _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.decode(reader, reader.uint32());
          break;

        case 10:
          message.signer = reader.string();
          break;

        case 11:
          message.hostConsensusStateProof = reader.bytes();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$connectionId, _object$counterpartyC, _object$proofTry, _object$proofClient2, _object$proofConsensu2, _object$signer3, _object$hostConsensus2;

    const message = createBaseMsgConnectionOpenAck();
    message.connectionId = (_object$connectionId = object.connectionId) !== null && _object$connectionId !== void 0 ? _object$connectionId : "";
    message.counterpartyConnectionId = (_object$counterpartyC = object.counterpartyConnectionId) !== null && _object$counterpartyC !== void 0 ? _object$counterpartyC : "";
    message.version = object.version !== undefined && object.version !== null ? _connection__WEBPACK_IMPORTED_MODULE_0__.Version.fromPartial(object.version) : undefined;
    message.clientState = object.clientState !== undefined && object.clientState !== null ? _google_protobuf_any__WEBPACK_IMPORTED_MODULE_1__.Any.fromPartial(object.clientState) : undefined;
    message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.fromPartial(object.proofHeight) : undefined;
    message.proofTry = (_object$proofTry = object.proofTry) !== null && _object$proofTry !== void 0 ? _object$proofTry : new Uint8Array();
    message.proofClient = (_object$proofClient2 = object.proofClient) !== null && _object$proofClient2 !== void 0 ? _object$proofClient2 : new Uint8Array();
    message.proofConsensus = (_object$proofConsensu2 = object.proofConsensus) !== null && _object$proofConsensu2 !== void 0 ? _object$proofConsensu2 : new Uint8Array();
    message.consensusHeight = object.consensusHeight !== undefined && object.consensusHeight !== null ? _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.fromPartial(object.consensusHeight) : undefined;
    message.signer = (_object$signer3 = object.signer) !== null && _object$signer3 !== void 0 ? _object$signer3 : "";
    message.hostConsensusStateProof = (_object$hostConsensus2 = object.hostConsensusStateProof) !== null && _object$hostConsensus2 !== void 0 ? _object$hostConsensus2 : new Uint8Array();
    return message;
  },

  fromAmino(object) {
    return {
      connectionId: object.connection_id,
      counterpartyConnectionId: object.counterparty_connection_id,
      version: object !== null && object !== void 0 && object.version ? _connection__WEBPACK_IMPORTED_MODULE_0__.Version.fromAmino(object.version) : undefined,
      clientState: object !== null && object !== void 0 && object.client_state ? _google_protobuf_any__WEBPACK_IMPORTED_MODULE_1__.Any.fromAmino(object.client_state) : undefined,
      proofHeight: object !== null && object !== void 0 && object.proof_height ? _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.fromAmino(object.proof_height) : undefined,
      proofTry: object.proof_try,
      proofClient: object.proof_client,
      proofConsensus: object.proof_consensus,
      consensusHeight: object !== null && object !== void 0 && object.consensus_height ? _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.fromAmino(object.consensus_height) : undefined,
      signer: object.signer,
      hostConsensusStateProof: object.host_consensus_state_proof
    };
  },

  toAmino(message) {
    const obj = {};
    obj.connection_id = message.connectionId;
    obj.counterparty_connection_id = message.counterpartyConnectionId;
    obj.version = message.version ? _connection__WEBPACK_IMPORTED_MODULE_0__.Version.toAmino(message.version) : undefined;
    obj.client_state = message.clientState ? _google_protobuf_any__WEBPACK_IMPORTED_MODULE_1__.Any.toAmino(message.clientState) : undefined;
    obj.proof_height = message.proofHeight ? _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.toAmino(message.proofHeight) : {};
    obj.proof_try = message.proofTry;
    obj.proof_client = message.proofClient;
    obj.proof_consensus = message.proofConsensus;
    obj.consensus_height = message.consensusHeight ? _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.toAmino(message.consensusHeight) : {};
    obj.signer = message.signer;
    obj.host_consensus_state_proof = message.hostConsensusStateProof;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgConnectionOpenAck.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/MsgConnectionOpenAck",
      value: MsgConnectionOpenAck.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgConnectionOpenAck.decode(message.value);
  },

  toProto(message) {
    return MsgConnectionOpenAck.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.connection.v1.MsgConnectionOpenAck",
      value: MsgConnectionOpenAck.encode(message).finish()
    };
  }

};

function createBaseMsgConnectionOpenAckResponse() {
  return {};
}

const MsgConnectionOpenAckResponse = {
  typeUrl: "/ibc.core.connection.v1.MsgConnectionOpenAckResponse",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgConnectionOpenAckResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseMsgConnectionOpenAckResponse();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return MsgConnectionOpenAckResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/MsgConnectionOpenAckResponse",
      value: MsgConnectionOpenAckResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgConnectionOpenAckResponse.decode(message.value);
  },

  toProto(message) {
    return MsgConnectionOpenAckResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.connection.v1.MsgConnectionOpenAckResponse",
      value: MsgConnectionOpenAckResponse.encode(message).finish()
    };
  }

};

function createBaseMsgConnectionOpenConfirm() {
  return {
    connectionId: "",
    proofAck: new Uint8Array(),
    proofHeight: undefined,
    signer: ""
  };
}

const MsgConnectionOpenConfirm = {
  typeUrl: "/ibc.core.connection.v1.MsgConnectionOpenConfirm",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    if (message.connectionId !== "") {
      writer.uint32(10).string(message.connectionId);
    }

    if (message.proofAck.length !== 0) {
      writer.uint32(18).bytes(message.proofAck);
    }

    if (message.proofHeight !== undefined) {
      _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.encode(message.proofHeight, writer.uint32(26).fork()).ldelim();
    }

    if (message.signer !== "") {
      writer.uint32(34).string(message.signer);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgConnectionOpenConfirm();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.connectionId = reader.string();
          break;

        case 2:
          message.proofAck = reader.bytes();
          break;

        case 3:
          message.proofHeight = _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.decode(reader, reader.uint32());
          break;

        case 4:
          message.signer = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$connectionId2, _object$proofAck, _object$signer4;

    const message = createBaseMsgConnectionOpenConfirm();
    message.connectionId = (_object$connectionId2 = object.connectionId) !== null && _object$connectionId2 !== void 0 ? _object$connectionId2 : "";
    message.proofAck = (_object$proofAck = object.proofAck) !== null && _object$proofAck !== void 0 ? _object$proofAck : new Uint8Array();
    message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.fromPartial(object.proofHeight) : undefined;
    message.signer = (_object$signer4 = object.signer) !== null && _object$signer4 !== void 0 ? _object$signer4 : "";
    return message;
  },

  fromAmino(object) {
    return {
      connectionId: object.connection_id,
      proofAck: object.proof_ack,
      proofHeight: object !== null && object !== void 0 && object.proof_height ? _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.fromAmino(object.proof_height) : undefined,
      signer: object.signer
    };
  },

  toAmino(message) {
    const obj = {};
    obj.connection_id = message.connectionId;
    obj.proof_ack = message.proofAck;
    obj.proof_height = message.proofHeight ? _client_v1_client__WEBPACK_IMPORTED_MODULE_2__.Height.toAmino(message.proofHeight) : {};
    obj.signer = message.signer;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgConnectionOpenConfirm.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/MsgConnectionOpenConfirm",
      value: MsgConnectionOpenConfirm.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgConnectionOpenConfirm.decode(message.value);
  },

  toProto(message) {
    return MsgConnectionOpenConfirm.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.connection.v1.MsgConnectionOpenConfirm",
      value: MsgConnectionOpenConfirm.encode(message).finish()
    };
  }

};

function createBaseMsgConnectionOpenConfirmResponse() {
  return {};
}

const MsgConnectionOpenConfirmResponse = {
  typeUrl: "/ibc.core.connection.v1.MsgConnectionOpenConfirmResponse",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgConnectionOpenConfirmResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseMsgConnectionOpenConfirmResponse();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return MsgConnectionOpenConfirmResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/MsgConnectionOpenConfirmResponse",
      value: MsgConnectionOpenConfirmResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgConnectionOpenConfirmResponse.decode(message.value);
  },

  toProto(message) {
    return MsgConnectionOpenConfirmResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.connection.v1.MsgConnectionOpenConfirmResponse",
      value: MsgConnectionOpenConfirmResponse.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 10990:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MsgClientImpl": function() { return /* binding */ MsgClientImpl; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4942);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _tx__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35111);



/** Msg defines the ibc/connection Msg service. */

class MsgClientImpl {
  constructor(rpc) {
    (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, "rpc", void 0);

    this.rpc = rpc;
    this.connectionOpenInit = this.connectionOpenInit.bind(this);
    this.connectionOpenTry = this.connectionOpenTry.bind(this);
    this.connectionOpenAck = this.connectionOpenAck.bind(this);
    this.connectionOpenConfirm = this.connectionOpenConfirm.bind(this);
  }

  connectionOpenInit(request) {
    const data = _tx__WEBPACK_IMPORTED_MODULE_1__.MsgConnectionOpenInit.encode(request).finish();
    const promise = this.rpc.request("ibc.core.connection.v1.Msg", "ConnectionOpenInit", data);
    return promise.then(data => _tx__WEBPACK_IMPORTED_MODULE_1__.MsgConnectionOpenInitResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  connectionOpenTry(request) {
    const data = _tx__WEBPACK_IMPORTED_MODULE_1__.MsgConnectionOpenTry.encode(request).finish();
    const promise = this.rpc.request("ibc.core.connection.v1.Msg", "ConnectionOpenTry", data);
    return promise.then(data => _tx__WEBPACK_IMPORTED_MODULE_1__.MsgConnectionOpenTryResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  connectionOpenAck(request) {
    const data = _tx__WEBPACK_IMPORTED_MODULE_1__.MsgConnectionOpenAck.encode(request).finish();
    const promise = this.rpc.request("ibc.core.connection.v1.Msg", "ConnectionOpenAck", data);
    return promise.then(data => _tx__WEBPACK_IMPORTED_MODULE_1__.MsgConnectionOpenAckResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  connectionOpenConfirm(request) {
    const data = _tx__WEBPACK_IMPORTED_MODULE_1__.MsgConnectionOpenConfirm.encode(request).finish();
    const promise = this.rpc.request("ibc.core.connection.v1.Msg", "ConnectionOpenConfirm", data);
    return promise.then(data => _tx__WEBPACK_IMPORTED_MODULE_1__.MsgConnectionOpenConfirmResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

}

/***/ }),

/***/ 55621:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Params": function() { return /* binding */ Params; }
/* harmony export */ });
/* harmony import */ var _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6499);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47895);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__);




function createBaseParams() {
  return {
    authorizedTickSpacing: [],
    authorizedSpreadFactors: [],
    balancerSharesRewardDiscount: "",
    authorizedQuoteDenoms: [],
    authorizedUptimes: [],
    isPermissionlessPoolCreationEnabled: false
  };
}

const Params = {
  typeUrl: "/osmosis.concentratedliquidity.Params",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    writer.uint32(10).fork();

    for (const v of message.authorizedTickSpacing) {
      writer.uint64(v);
    }

    writer.ldelim();

    for (const v of message.authorizedSpreadFactors) {
      writer.uint32(18).string(v);
    }

    if (message.balancerSharesRewardDiscount !== "") {
      writer.uint32(26).string(message.balancerSharesRewardDiscount);
    }

    for (const v of message.authorizedQuoteDenoms) {
      writer.uint32(34).string(v);
    }

    for (const v of message.authorizedUptimes) {
      _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_0__.Duration.encode(v, writer.uint32(42).fork()).ldelim();
    }

    if (message.isPermissionlessPoolCreationEnabled === true) {
      writer.uint32(48).bool(message.isPermissionlessPoolCreationEnabled);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseParams();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          if ((tag & 7) === 2) {
            const end2 = reader.uint32() + reader.pos;

            while (reader.pos < end2) {
              message.authorizedTickSpacing.push(reader.uint64());
            }
          } else {
            message.authorizedTickSpacing.push(reader.uint64());
          }

          break;

        case 2:
          message.authorizedSpreadFactors.push(reader.string());
          break;

        case 3:
          message.balancerSharesRewardDiscount = reader.string();
          break;

        case 4:
          message.authorizedQuoteDenoms.push(reader.string());
          break;

        case 5:
          message.authorizedUptimes.push(_google_protobuf_duration__WEBPACK_IMPORTED_MODULE_0__.Duration.decode(reader, reader.uint32()));
          break;

        case 6:
          message.isPermissionlessPoolCreationEnabled = reader.bool();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$authorizedTic, _object$authorizedSpr, _object$balancerShare, _object$authorizedQuo, _object$authorizedUpt, _object$isPermissionl;

    const message = createBaseParams();
    message.authorizedTickSpacing = ((_object$authorizedTic = object.authorizedTickSpacing) === null || _object$authorizedTic === void 0 ? void 0 : _object$authorizedTic.map(e => _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromValue */ .dK.fromValue(e))) || [];
    message.authorizedSpreadFactors = ((_object$authorizedSpr = object.authorizedSpreadFactors) === null || _object$authorizedSpr === void 0 ? void 0 : _object$authorizedSpr.map(e => e)) || [];
    message.balancerSharesRewardDiscount = (_object$balancerShare = object.balancerSharesRewardDiscount) !== null && _object$balancerShare !== void 0 ? _object$balancerShare : "";
    message.authorizedQuoteDenoms = ((_object$authorizedQuo = object.authorizedQuoteDenoms) === null || _object$authorizedQuo === void 0 ? void 0 : _object$authorizedQuo.map(e => e)) || [];
    message.authorizedUptimes = ((_object$authorizedUpt = object.authorizedUptimes) === null || _object$authorizedUpt === void 0 ? void 0 : _object$authorizedUpt.map(e => _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_0__.Duration.fromPartial(e))) || [];
    message.isPermissionlessPoolCreationEnabled = (_object$isPermissionl = object.isPermissionlessPoolCreationEnabled) !== null && _object$isPermissionl !== void 0 ? _object$isPermissionl : false;
    return message;
  },

  fromAmino(object) {
    return {
      authorizedTickSpacing: Array.isArray(object === null || object === void 0 ? void 0 : object.authorized_tick_spacing) ? object.authorized_tick_spacing.map(e => e) : [],
      authorizedSpreadFactors: Array.isArray(object === null || object === void 0 ? void 0 : object.authorized_spread_factors) ? object.authorized_spread_factors.map(e => e) : [],
      balancerSharesRewardDiscount: object.balancer_shares_reward_discount,
      authorizedQuoteDenoms: Array.isArray(object === null || object === void 0 ? void 0 : object.authorized_quote_denoms) ? object.authorized_quote_denoms.map(e => e) : [],
      authorizedUptimes: Array.isArray(object === null || object === void 0 ? void 0 : object.authorized_uptimes) ? object.authorized_uptimes.map(e => _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_0__.Duration.fromAmino(e)) : [],
      isPermissionlessPoolCreationEnabled: object.is_permissionless_pool_creation_enabled
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.authorizedTickSpacing) {
      obj.authorized_tick_spacing = message.authorizedTickSpacing.map(e => e);
    } else {
      obj.authorized_tick_spacing = [];
    }

    if (message.authorizedSpreadFactors) {
      obj.authorized_spread_factors = message.authorizedSpreadFactors.map(e => e);
    } else {
      obj.authorized_spread_factors = [];
    }

    obj.balancer_shares_reward_discount = message.balancerSharesRewardDiscount;

    if (message.authorizedQuoteDenoms) {
      obj.authorized_quote_denoms = message.authorizedQuoteDenoms.map(e => e);
    } else {
      obj.authorized_quote_denoms = [];
    }

    if (message.authorizedUptimes) {
      obj.authorized_uptimes = message.authorizedUptimes.map(e => e ? _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_0__.Duration.toAmino(e) : undefined);
    } else {
      obj.authorized_uptimes = [];
    }

    obj.is_permissionless_pool_creation_enabled = message.isPermissionlessPoolCreationEnabled;
    return obj;
  },

  fromAminoMsg(object) {
    return Params.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/concentratedliquidity/params",
      value: Params.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return Params.decode(message.value);
  },

  toProto(message) {
    return Params.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.concentratedliquidity.Params",
      value: Params.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 37486:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ MsgCreateConcentratedPool; },
/* harmony export */   "j": function() { return /* binding */ MsgCreateConcentratedPoolResponse; }
/* harmony export */ });
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47895);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__);


/** ===================== MsgCreateConcentratedPool */

function createBaseMsgCreateConcentratedPool() {
  return {
    sender: "",
    denom0: "",
    denom1: "",
    tickSpacing: _helpers__WEBPACK_IMPORTED_MODULE_0__/* .Long.UZERO */ .dK.UZERO,
    spreadFactor: ""
  };
}

const MsgCreateConcentratedPool = {
  typeUrl: "/osmosis.concentratedliquidity.poolmodel.concentrated.v1beta1.MsgCreateConcentratedPool",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Writer.create()) {
    if (message.sender !== "") {
      writer.uint32(10).string(message.sender);
    }

    if (message.denom0 !== "") {
      writer.uint32(18).string(message.denom0);
    }

    if (message.denom1 !== "") {
      writer.uint32(26).string(message.denom1);
    }

    if (!message.tickSpacing.isZero()) {
      writer.uint32(32).uint64(message.tickSpacing);
    }

    if (message.spreadFactor !== "") {
      writer.uint32(42).string(message.spreadFactor);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgCreateConcentratedPool();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.sender = reader.string();
          break;

        case 2:
          message.denom0 = reader.string();
          break;

        case 3:
          message.denom1 = reader.string();
          break;

        case 4:
          message.tickSpacing = reader.uint64();
          break;

        case 5:
          message.spreadFactor = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$sender, _object$denom, _object$denom2, _object$spreadFactor;

    const message = createBaseMsgCreateConcentratedPool();
    message.sender = (_object$sender = object.sender) !== null && _object$sender !== void 0 ? _object$sender : "";
    message.denom0 = (_object$denom = object.denom0) !== null && _object$denom !== void 0 ? _object$denom : "";
    message.denom1 = (_object$denom2 = object.denom1) !== null && _object$denom2 !== void 0 ? _object$denom2 : "";
    message.tickSpacing = object.tickSpacing !== undefined && object.tickSpacing !== null ? _helpers__WEBPACK_IMPORTED_MODULE_0__/* .Long.fromValue */ .dK.fromValue(object.tickSpacing) : _helpers__WEBPACK_IMPORTED_MODULE_0__/* .Long.UZERO */ .dK.UZERO;
    message.spreadFactor = (_object$spreadFactor = object.spreadFactor) !== null && _object$spreadFactor !== void 0 ? _object$spreadFactor : "";
    return message;
  },

  fromAmino(object) {
    return {
      sender: object.sender,
      denom0: object.denom0,
      denom1: object.denom1,
      tickSpacing: _helpers__WEBPACK_IMPORTED_MODULE_0__/* .Long.fromString */ .dK.fromString(object.tick_spacing),
      spreadFactor: object.spread_factor
    };
  },

  toAmino(message) {
    const obj = {};
    obj.sender = message.sender;
    obj.denom0 = message.denom0;
    obj.denom1 = message.denom1;
    obj.tick_spacing = message.tickSpacing ? message.tickSpacing.toString() : undefined;
    obj.spread_factor = message.spreadFactor;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgCreateConcentratedPool.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/concentratedliquidity/poolmodel/concentrated/create-concentrated-pool",
      value: MsgCreateConcentratedPool.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgCreateConcentratedPool.decode(message.value);
  },

  toProto(message) {
    return MsgCreateConcentratedPool.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.concentratedliquidity.poolmodel.concentrated.v1beta1.MsgCreateConcentratedPool",
      value: MsgCreateConcentratedPool.encode(message).finish()
    };
  }

};

function createBaseMsgCreateConcentratedPoolResponse() {
  return {
    poolId: _helpers__WEBPACK_IMPORTED_MODULE_0__/* .Long.UZERO */ .dK.UZERO
  };
}

const MsgCreateConcentratedPoolResponse = {
  typeUrl: "/osmosis.concentratedliquidity.poolmodel.concentrated.v1beta1.MsgCreateConcentratedPoolResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Writer.create()) {
    if (!message.poolId.isZero()) {
      writer.uint32(8).uint64(message.poolId);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgCreateConcentratedPoolResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.poolId = reader.uint64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseMsgCreateConcentratedPoolResponse();
    message.poolId = object.poolId !== undefined && object.poolId !== null ? _helpers__WEBPACK_IMPORTED_MODULE_0__/* .Long.fromValue */ .dK.fromValue(object.poolId) : _helpers__WEBPACK_IMPORTED_MODULE_0__/* .Long.UZERO */ .dK.UZERO;
    return message;
  },

  fromAmino(object) {
    return {
      poolId: _helpers__WEBPACK_IMPORTED_MODULE_0__/* .Long.fromString */ .dK.fromString(object.pool_id)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.pool_id = message.poolId ? message.poolId.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgCreateConcentratedPoolResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/concentratedliquidity/poolmodel/concentrated/create-concentrated-pool-response",
      value: MsgCreateConcentratedPoolResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgCreateConcentratedPoolResponse.decode(message.value);
  },

  toProto(message) {
    return MsgCreateConcentratedPoolResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.concentratedliquidity.poolmodel.concentrated.v1beta1.MsgCreateConcentratedPoolResponse",
      value: MsgCreateConcentratedPoolResponse.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 4343:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ Pool; }
/* harmony export */ });
/* harmony import */ var _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20633);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47895);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__);




function createBasePool() {
  return {
    $typeUrl: "/osmosis.concentratedliquidity.v1beta1.Pool",
    address: "",
    incentivesAddress: "",
    spreadRewardsAddress: "",
    id: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.UZERO */ .dK.UZERO,
    currentTickLiquidity: "",
    token0: "",
    token1: "",
    currentSqrtPrice: "",
    currentTick: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.ZERO */ .dK.ZERO,
    tickSpacing: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.UZERO */ .dK.UZERO,
    exponentAtPriceOne: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.ZERO */ .dK.ZERO,
    spreadFactor: "",
    lastLiquidityUpdate: undefined
  };
}

const Pool = {
  typeUrl: "/osmosis.concentratedliquidity.v1beta1.Pool",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (message.address !== "") {
      writer.uint32(10).string(message.address);
    }

    if (message.incentivesAddress !== "") {
      writer.uint32(18).string(message.incentivesAddress);
    }

    if (message.spreadRewardsAddress !== "") {
      writer.uint32(26).string(message.spreadRewardsAddress);
    }

    if (!message.id.isZero()) {
      writer.uint32(32).uint64(message.id);
    }

    if (message.currentTickLiquidity !== "") {
      writer.uint32(42).string(message.currentTickLiquidity);
    }

    if (message.token0 !== "") {
      writer.uint32(50).string(message.token0);
    }

    if (message.token1 !== "") {
      writer.uint32(58).string(message.token1);
    }

    if (message.currentSqrtPrice !== "") {
      writer.uint32(66).string(message.currentSqrtPrice);
    }

    if (!message.currentTick.isZero()) {
      writer.uint32(72).int64(message.currentTick);
    }

    if (!message.tickSpacing.isZero()) {
      writer.uint32(80).uint64(message.tickSpacing);
    }

    if (!message.exponentAtPriceOne.isZero()) {
      writer.uint32(88).int64(message.exponentAtPriceOne);
    }

    if (message.spreadFactor !== "") {
      writer.uint32(98).string(message.spreadFactor);
    }

    if (message.lastLiquidityUpdate !== undefined) {
      _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_0__.Timestamp.encode((0,_helpers__WEBPACK_IMPORTED_MODULE_1__/* .toTimestamp */ .Uq)(message.lastLiquidityUpdate), writer.uint32(106).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePool();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.address = reader.string();
          break;

        case 2:
          message.incentivesAddress = reader.string();
          break;

        case 3:
          message.spreadRewardsAddress = reader.string();
          break;

        case 4:
          message.id = reader.uint64();
          break;

        case 5:
          message.currentTickLiquidity = reader.string();
          break;

        case 6:
          message.token0 = reader.string();
          break;

        case 7:
          message.token1 = reader.string();
          break;

        case 8:
          message.currentSqrtPrice = reader.string();
          break;

        case 9:
          message.currentTick = reader.int64();
          break;

        case 10:
          message.tickSpacing = reader.uint64();
          break;

        case 11:
          message.exponentAtPriceOne = reader.int64();
          break;

        case 12:
          message.spreadFactor = reader.string();
          break;

        case 13:
          message.lastLiquidityUpdate = (0,_helpers__WEBPACK_IMPORTED_MODULE_1__/* .fromTimestamp */ .Ol)(_google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_0__.Timestamp.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$address, _object$incentivesAdd, _object$spreadRewards, _object$currentTickLi, _object$token, _object$token2, _object$currentSqrtPr, _object$spreadFactor, _object$lastLiquidity;

    const message = createBasePool();
    message.address = (_object$address = object.address) !== null && _object$address !== void 0 ? _object$address : "";
    message.incentivesAddress = (_object$incentivesAdd = object.incentivesAddress) !== null && _object$incentivesAdd !== void 0 ? _object$incentivesAdd : "";
    message.spreadRewardsAddress = (_object$spreadRewards = object.spreadRewardsAddress) !== null && _object$spreadRewards !== void 0 ? _object$spreadRewards : "";
    message.id = object.id !== undefined && object.id !== null ? _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromValue */ .dK.fromValue(object.id) : _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.UZERO */ .dK.UZERO;
    message.currentTickLiquidity = (_object$currentTickLi = object.currentTickLiquidity) !== null && _object$currentTickLi !== void 0 ? _object$currentTickLi : "";
    message.token0 = (_object$token = object.token0) !== null && _object$token !== void 0 ? _object$token : "";
    message.token1 = (_object$token2 = object.token1) !== null && _object$token2 !== void 0 ? _object$token2 : "";
    message.currentSqrtPrice = (_object$currentSqrtPr = object.currentSqrtPrice) !== null && _object$currentSqrtPr !== void 0 ? _object$currentSqrtPr : "";
    message.currentTick = object.currentTick !== undefined && object.currentTick !== null ? _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromValue */ .dK.fromValue(object.currentTick) : _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.ZERO */ .dK.ZERO;
    message.tickSpacing = object.tickSpacing !== undefined && object.tickSpacing !== null ? _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromValue */ .dK.fromValue(object.tickSpacing) : _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.UZERO */ .dK.UZERO;
    message.exponentAtPriceOne = object.exponentAtPriceOne !== undefined && object.exponentAtPriceOne !== null ? _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromValue */ .dK.fromValue(object.exponentAtPriceOne) : _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.ZERO */ .dK.ZERO;
    message.spreadFactor = (_object$spreadFactor = object.spreadFactor) !== null && _object$spreadFactor !== void 0 ? _object$spreadFactor : "";
    message.lastLiquidityUpdate = (_object$lastLiquidity = object.lastLiquidityUpdate) !== null && _object$lastLiquidity !== void 0 ? _object$lastLiquidity : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      address: object.address,
      incentivesAddress: object.incentives_address,
      spreadRewardsAddress: object.spread_rewards_address,
      id: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromString */ .dK.fromString(object.id),
      currentTickLiquidity: object.current_tick_liquidity,
      token0: object.token0,
      token1: object.token1,
      currentSqrtPrice: object.current_sqrt_price,
      currentTick: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromString */ .dK.fromString(object.current_tick),
      tickSpacing: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromString */ .dK.fromString(object.tick_spacing),
      exponentAtPriceOne: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromString */ .dK.fromString(object.exponent_at_price_one),
      spreadFactor: object.spread_factor,
      lastLiquidityUpdate: object !== null && object !== void 0 && object.last_liquidity_update ? _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_0__.Timestamp.fromAmino(object.last_liquidity_update) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.address = message.address;
    obj.incentives_address = message.incentivesAddress;
    obj.spread_rewards_address = message.spreadRewardsAddress;
    obj.id = message.id ? message.id.toString() : undefined;
    obj.current_tick_liquidity = message.currentTickLiquidity;
    obj.token0 = message.token0;
    obj.token1 = message.token1;
    obj.current_sqrt_price = message.currentSqrtPrice;
    obj.current_tick = message.currentTick ? message.currentTick.toString() : undefined;
    obj.tick_spacing = message.tickSpacing ? message.tickSpacing.toString() : undefined;
    obj.exponent_at_price_one = message.exponentAtPriceOne ? message.exponentAtPriceOne.toString() : undefined;
    obj.spread_factor = message.spreadFactor;
    obj.last_liquidity_update = message.lastLiquidityUpdate ? _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_0__.Timestamp.toAmino(message.lastLiquidityUpdate) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return Pool.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/concentratedliquidity/pool",
      value: Pool.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return Pool.decode(message.value);
  },

  toProto(message) {
    return Pool.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.concentratedliquidity.v1beta1.Pool",
      value: Pool.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 8481:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$n": function() { return /* binding */ MsgCollectIncentivesResponse; },
/* harmony export */   "AY": function() { return /* binding */ MsgAddToPositionResponse; },
/* harmony export */   "Ar": function() { return /* binding */ MsgWithdrawPosition; },
/* harmony export */   "DT": function() { return /* binding */ MsgCollectSpreadRewardsResponse; },
/* harmony export */   "ON": function() { return /* binding */ MsgCollectIncentives; },
/* harmony export */   "Rr": function() { return /* binding */ MsgCreatePositionResponse; },
/* harmony export */   "Vg": function() { return /* binding */ MsgAddToPosition; },
/* harmony export */   "W5": function() { return /* binding */ MsgCreatePosition; },
/* harmony export */   "gC": function() { return /* binding */ MsgCollectSpreadRewards; },
/* harmony export */   "vL": function() { return /* binding */ MsgWithdrawPositionResponse; }
/* harmony export */ });
/* unused harmony exports MsgFungifyChargedPositions, MsgFungifyChargedPositionsResponse */
/* harmony import */ var _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26178);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47895);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__);



/** ===================== MsgCreatePosition */

function createBaseMsgCreatePosition() {
  return {
    poolId: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.UZERO */ .dK.UZERO,
    sender: "",
    lowerTick: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.ZERO */ .dK.ZERO,
    upperTick: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.ZERO */ .dK.ZERO,
    tokensProvided: [],
    tokenMinAmount0: "",
    tokenMinAmount1: ""
  };
}

const MsgCreatePosition = {
  typeUrl: "/osmosis.concentratedliquidity.v1beta1.MsgCreatePosition",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (!message.poolId.isZero()) {
      writer.uint32(8).uint64(message.poolId);
    }

    if (message.sender !== "") {
      writer.uint32(18).string(message.sender);
    }

    if (!message.lowerTick.isZero()) {
      writer.uint32(24).int64(message.lowerTick);
    }

    if (!message.upperTick.isZero()) {
      writer.uint32(32).int64(message.upperTick);
    }

    for (const v of message.tokensProvided) {
      _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.encode(v, writer.uint32(42).fork()).ldelim();
    }

    if (message.tokenMinAmount0 !== "") {
      writer.uint32(50).string(message.tokenMinAmount0);
    }

    if (message.tokenMinAmount1 !== "") {
      writer.uint32(58).string(message.tokenMinAmount1);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgCreatePosition();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.poolId = reader.uint64();
          break;

        case 2:
          message.sender = reader.string();
          break;

        case 3:
          message.lowerTick = reader.int64();
          break;

        case 4:
          message.upperTick = reader.int64();
          break;

        case 5:
          message.tokensProvided.push(_cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.decode(reader, reader.uint32()));
          break;

        case 6:
          message.tokenMinAmount0 = reader.string();
          break;

        case 7:
          message.tokenMinAmount1 = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$sender, _object$tokensProvide, _object$tokenMinAmoun, _object$tokenMinAmoun2;

    const message = createBaseMsgCreatePosition();
    message.poolId = object.poolId !== undefined && object.poolId !== null ? _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromValue */ .dK.fromValue(object.poolId) : _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.UZERO */ .dK.UZERO;
    message.sender = (_object$sender = object.sender) !== null && _object$sender !== void 0 ? _object$sender : "";
    message.lowerTick = object.lowerTick !== undefined && object.lowerTick !== null ? _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromValue */ .dK.fromValue(object.lowerTick) : _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.ZERO */ .dK.ZERO;
    message.upperTick = object.upperTick !== undefined && object.upperTick !== null ? _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromValue */ .dK.fromValue(object.upperTick) : _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.ZERO */ .dK.ZERO;
    message.tokensProvided = ((_object$tokensProvide = object.tokensProvided) === null || _object$tokensProvide === void 0 ? void 0 : _object$tokensProvide.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.fromPartial(e))) || [];
    message.tokenMinAmount0 = (_object$tokenMinAmoun = object.tokenMinAmount0) !== null && _object$tokenMinAmoun !== void 0 ? _object$tokenMinAmoun : "";
    message.tokenMinAmount1 = (_object$tokenMinAmoun2 = object.tokenMinAmount1) !== null && _object$tokenMinAmoun2 !== void 0 ? _object$tokenMinAmoun2 : "";
    return message;
  },

  fromAmino(object) {
    return {
      poolId: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromString */ .dK.fromString(object.pool_id),
      sender: object.sender,
      lowerTick: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromString */ .dK.fromString(object.lower_tick),
      upperTick: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromString */ .dK.fromString(object.upper_tick),
      tokensProvided: Array.isArray(object === null || object === void 0 ? void 0 : object.tokens_provided) ? object.tokens_provided.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.fromAmino(e)) : [],
      tokenMinAmount0: object.token_min_amount0,
      tokenMinAmount1: object.token_min_amount1
    };
  },

  toAmino(message) {
    const obj = {};
    obj.pool_id = message.poolId ? message.poolId.toString() : undefined;
    obj.sender = message.sender;
    obj.lower_tick = message.lowerTick ? message.lowerTick.toString() : undefined;
    obj.upper_tick = message.upperTick ? message.upperTick.toString() : undefined;

    if (message.tokensProvided) {
      obj.tokens_provided = message.tokensProvided.map(e => e ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.toAmino(e) : undefined);
    } else {
      obj.tokens_provided = [];
    }

    obj.token_min_amount0 = message.tokenMinAmount0;
    obj.token_min_amount1 = message.tokenMinAmount1;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgCreatePosition.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/concentratedliquidity/create-position",
      value: MsgCreatePosition.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgCreatePosition.decode(message.value);
  },

  toProto(message) {
    return MsgCreatePosition.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.concentratedliquidity.v1beta1.MsgCreatePosition",
      value: MsgCreatePosition.encode(message).finish()
    };
  }

};

function createBaseMsgCreatePositionResponse() {
  return {
    positionId: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.UZERO */ .dK.UZERO,
    amount0: "",
    amount1: "",
    liquidityCreated: "",
    lowerTick: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.ZERO */ .dK.ZERO,
    upperTick: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.ZERO */ .dK.ZERO
  };
}

const MsgCreatePositionResponse = {
  typeUrl: "/osmosis.concentratedliquidity.v1beta1.MsgCreatePositionResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (!message.positionId.isZero()) {
      writer.uint32(8).uint64(message.positionId);
    }

    if (message.amount0 !== "") {
      writer.uint32(18).string(message.amount0);
    }

    if (message.amount1 !== "") {
      writer.uint32(26).string(message.amount1);
    }

    if (message.liquidityCreated !== "") {
      writer.uint32(42).string(message.liquidityCreated);
    }

    if (!message.lowerTick.isZero()) {
      writer.uint32(48).int64(message.lowerTick);
    }

    if (!message.upperTick.isZero()) {
      writer.uint32(56).int64(message.upperTick);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgCreatePositionResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.positionId = reader.uint64();
          break;

        case 2:
          message.amount0 = reader.string();
          break;

        case 3:
          message.amount1 = reader.string();
          break;

        case 5:
          message.liquidityCreated = reader.string();
          break;

        case 6:
          message.lowerTick = reader.int64();
          break;

        case 7:
          message.upperTick = reader.int64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$amount, _object$amount2, _object$liquidityCrea;

    const message = createBaseMsgCreatePositionResponse();
    message.positionId = object.positionId !== undefined && object.positionId !== null ? _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromValue */ .dK.fromValue(object.positionId) : _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.UZERO */ .dK.UZERO;
    message.amount0 = (_object$amount = object.amount0) !== null && _object$amount !== void 0 ? _object$amount : "";
    message.amount1 = (_object$amount2 = object.amount1) !== null && _object$amount2 !== void 0 ? _object$amount2 : "";
    message.liquidityCreated = (_object$liquidityCrea = object.liquidityCreated) !== null && _object$liquidityCrea !== void 0 ? _object$liquidityCrea : "";
    message.lowerTick = object.lowerTick !== undefined && object.lowerTick !== null ? _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromValue */ .dK.fromValue(object.lowerTick) : _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.ZERO */ .dK.ZERO;
    message.upperTick = object.upperTick !== undefined && object.upperTick !== null ? _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromValue */ .dK.fromValue(object.upperTick) : _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.ZERO */ .dK.ZERO;
    return message;
  },

  fromAmino(object) {
    return {
      positionId: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromString */ .dK.fromString(object.position_id),
      amount0: object.amount0,
      amount1: object.amount1,
      liquidityCreated: object.liquidity_created,
      lowerTick: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromString */ .dK.fromString(object.lower_tick),
      upperTick: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromString */ .dK.fromString(object.upper_tick)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.position_id = message.positionId ? message.positionId.toString() : undefined;
    obj.amount0 = message.amount0;
    obj.amount1 = message.amount1;
    obj.liquidity_created = message.liquidityCreated;
    obj.lower_tick = message.lowerTick ? message.lowerTick.toString() : undefined;
    obj.upper_tick = message.upperTick ? message.upperTick.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgCreatePositionResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/concentratedliquidity/create-position-response",
      value: MsgCreatePositionResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgCreatePositionResponse.decode(message.value);
  },

  toProto(message) {
    return MsgCreatePositionResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.concentratedliquidity.v1beta1.MsgCreatePositionResponse",
      value: MsgCreatePositionResponse.encode(message).finish()
    };
  }

};

function createBaseMsgAddToPosition() {
  return {
    positionId: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.UZERO */ .dK.UZERO,
    sender: "",
    amount0: "",
    amount1: "",
    tokenMinAmount0: "",
    tokenMinAmount1: ""
  };
}

const MsgAddToPosition = {
  typeUrl: "/osmosis.concentratedliquidity.v1beta1.MsgAddToPosition",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (!message.positionId.isZero()) {
      writer.uint32(8).uint64(message.positionId);
    }

    if (message.sender !== "") {
      writer.uint32(18).string(message.sender);
    }

    if (message.amount0 !== "") {
      writer.uint32(26).string(message.amount0);
    }

    if (message.amount1 !== "") {
      writer.uint32(34).string(message.amount1);
    }

    if (message.tokenMinAmount0 !== "") {
      writer.uint32(42).string(message.tokenMinAmount0);
    }

    if (message.tokenMinAmount1 !== "") {
      writer.uint32(50).string(message.tokenMinAmount1);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgAddToPosition();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.positionId = reader.uint64();
          break;

        case 2:
          message.sender = reader.string();
          break;

        case 3:
          message.amount0 = reader.string();
          break;

        case 4:
          message.amount1 = reader.string();
          break;

        case 5:
          message.tokenMinAmount0 = reader.string();
          break;

        case 6:
          message.tokenMinAmount1 = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$sender2, _object$amount3, _object$amount4, _object$tokenMinAmoun3, _object$tokenMinAmoun4;

    const message = createBaseMsgAddToPosition();
    message.positionId = object.positionId !== undefined && object.positionId !== null ? _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromValue */ .dK.fromValue(object.positionId) : _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.UZERO */ .dK.UZERO;
    message.sender = (_object$sender2 = object.sender) !== null && _object$sender2 !== void 0 ? _object$sender2 : "";
    message.amount0 = (_object$amount3 = object.amount0) !== null && _object$amount3 !== void 0 ? _object$amount3 : "";
    message.amount1 = (_object$amount4 = object.amount1) !== null && _object$amount4 !== void 0 ? _object$amount4 : "";
    message.tokenMinAmount0 = (_object$tokenMinAmoun3 = object.tokenMinAmount0) !== null && _object$tokenMinAmoun3 !== void 0 ? _object$tokenMinAmoun3 : "";
    message.tokenMinAmount1 = (_object$tokenMinAmoun4 = object.tokenMinAmount1) !== null && _object$tokenMinAmoun4 !== void 0 ? _object$tokenMinAmoun4 : "";
    return message;
  },

  fromAmino(object) {
    return {
      positionId: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromString */ .dK.fromString(object.position_id),
      sender: object.sender,
      amount0: object.amount0,
      amount1: object.amount1,
      tokenMinAmount0: object.token_min_amount0,
      tokenMinAmount1: object.token_min_amount1
    };
  },

  toAmino(message) {
    const obj = {};
    obj.position_id = message.positionId ? message.positionId.toString() : undefined;
    obj.sender = message.sender;
    obj.amount0 = message.amount0;
    obj.amount1 = message.amount1;
    obj.token_min_amount0 = message.tokenMinAmount0;
    obj.token_min_amount1 = message.tokenMinAmount1;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgAddToPosition.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/concentratedliquidity/add-to-position",
      value: MsgAddToPosition.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgAddToPosition.decode(message.value);
  },

  toProto(message) {
    return MsgAddToPosition.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.concentratedliquidity.v1beta1.MsgAddToPosition",
      value: MsgAddToPosition.encode(message).finish()
    };
  }

};

function createBaseMsgAddToPositionResponse() {
  return {
    positionId: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.UZERO */ .dK.UZERO,
    amount0: "",
    amount1: ""
  };
}

const MsgAddToPositionResponse = {
  typeUrl: "/osmosis.concentratedliquidity.v1beta1.MsgAddToPositionResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (!message.positionId.isZero()) {
      writer.uint32(8).uint64(message.positionId);
    }

    if (message.amount0 !== "") {
      writer.uint32(18).string(message.amount0);
    }

    if (message.amount1 !== "") {
      writer.uint32(26).string(message.amount1);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgAddToPositionResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.positionId = reader.uint64();
          break;

        case 2:
          message.amount0 = reader.string();
          break;

        case 3:
          message.amount1 = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$amount5, _object$amount6;

    const message = createBaseMsgAddToPositionResponse();
    message.positionId = object.positionId !== undefined && object.positionId !== null ? _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromValue */ .dK.fromValue(object.positionId) : _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.UZERO */ .dK.UZERO;
    message.amount0 = (_object$amount5 = object.amount0) !== null && _object$amount5 !== void 0 ? _object$amount5 : "";
    message.amount1 = (_object$amount6 = object.amount1) !== null && _object$amount6 !== void 0 ? _object$amount6 : "";
    return message;
  },

  fromAmino(object) {
    return {
      positionId: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromString */ .dK.fromString(object.position_id),
      amount0: object.amount0,
      amount1: object.amount1
    };
  },

  toAmino(message) {
    const obj = {};
    obj.position_id = message.positionId ? message.positionId.toString() : undefined;
    obj.amount0 = message.amount0;
    obj.amount1 = message.amount1;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgAddToPositionResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/concentratedliquidity/add-to-position-response",
      value: MsgAddToPositionResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgAddToPositionResponse.decode(message.value);
  },

  toProto(message) {
    return MsgAddToPositionResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.concentratedliquidity.v1beta1.MsgAddToPositionResponse",
      value: MsgAddToPositionResponse.encode(message).finish()
    };
  }

};

function createBaseMsgWithdrawPosition() {
  return {
    positionId: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.UZERO */ .dK.UZERO,
    sender: "",
    liquidityAmount: ""
  };
}

const MsgWithdrawPosition = {
  typeUrl: "/osmosis.concentratedliquidity.v1beta1.MsgWithdrawPosition",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (!message.positionId.isZero()) {
      writer.uint32(8).uint64(message.positionId);
    }

    if (message.sender !== "") {
      writer.uint32(18).string(message.sender);
    }

    if (message.liquidityAmount !== "") {
      writer.uint32(26).string(message.liquidityAmount);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgWithdrawPosition();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.positionId = reader.uint64();
          break;

        case 2:
          message.sender = reader.string();
          break;

        case 3:
          message.liquidityAmount = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$sender3, _object$liquidityAmou;

    const message = createBaseMsgWithdrawPosition();
    message.positionId = object.positionId !== undefined && object.positionId !== null ? _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromValue */ .dK.fromValue(object.positionId) : _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.UZERO */ .dK.UZERO;
    message.sender = (_object$sender3 = object.sender) !== null && _object$sender3 !== void 0 ? _object$sender3 : "";
    message.liquidityAmount = (_object$liquidityAmou = object.liquidityAmount) !== null && _object$liquidityAmou !== void 0 ? _object$liquidityAmou : "";
    return message;
  },

  fromAmino(object) {
    return {
      positionId: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromString */ .dK.fromString(object.position_id),
      sender: object.sender,
      liquidityAmount: object.liquidity_amount
    };
  },

  toAmino(message) {
    const obj = {};
    obj.position_id = message.positionId ? message.positionId.toString() : undefined;
    obj.sender = message.sender;
    obj.liquidity_amount = message.liquidityAmount;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgWithdrawPosition.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/concentratedliquidity/withdraw-position",
      value: MsgWithdrawPosition.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgWithdrawPosition.decode(message.value);
  },

  toProto(message) {
    return MsgWithdrawPosition.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.concentratedliquidity.v1beta1.MsgWithdrawPosition",
      value: MsgWithdrawPosition.encode(message).finish()
    };
  }

};

function createBaseMsgWithdrawPositionResponse() {
  return {
    amount0: "",
    amount1: ""
  };
}

const MsgWithdrawPositionResponse = {
  typeUrl: "/osmosis.concentratedliquidity.v1beta1.MsgWithdrawPositionResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (message.amount0 !== "") {
      writer.uint32(10).string(message.amount0);
    }

    if (message.amount1 !== "") {
      writer.uint32(18).string(message.amount1);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgWithdrawPositionResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.amount0 = reader.string();
          break;

        case 2:
          message.amount1 = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$amount7, _object$amount8;

    const message = createBaseMsgWithdrawPositionResponse();
    message.amount0 = (_object$amount7 = object.amount0) !== null && _object$amount7 !== void 0 ? _object$amount7 : "";
    message.amount1 = (_object$amount8 = object.amount1) !== null && _object$amount8 !== void 0 ? _object$amount8 : "";
    return message;
  },

  fromAmino(object) {
    return {
      amount0: object.amount0,
      amount1: object.amount1
    };
  },

  toAmino(message) {
    const obj = {};
    obj.amount0 = message.amount0;
    obj.amount1 = message.amount1;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgWithdrawPositionResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/concentratedliquidity/withdraw-position-response",
      value: MsgWithdrawPositionResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgWithdrawPositionResponse.decode(message.value);
  },

  toProto(message) {
    return MsgWithdrawPositionResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.concentratedliquidity.v1beta1.MsgWithdrawPositionResponse",
      value: MsgWithdrawPositionResponse.encode(message).finish()
    };
  }

};

function createBaseMsgCollectSpreadRewards() {
  return {
    positionIds: [],
    sender: ""
  };
}

const MsgCollectSpreadRewards = {
  typeUrl: "/osmosis.concentratedliquidity.v1beta1.MsgCollectSpreadRewards",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    writer.uint32(10).fork();

    for (const v of message.positionIds) {
      writer.uint64(v);
    }

    writer.ldelim();

    if (message.sender !== "") {
      writer.uint32(18).string(message.sender);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgCollectSpreadRewards();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          if ((tag & 7) === 2) {
            const end2 = reader.uint32() + reader.pos;

            while (reader.pos < end2) {
              message.positionIds.push(reader.uint64());
            }
          } else {
            message.positionIds.push(reader.uint64());
          }

          break;

        case 2:
          message.sender = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$positionIds, _object$sender4;

    const message = createBaseMsgCollectSpreadRewards();
    message.positionIds = ((_object$positionIds = object.positionIds) === null || _object$positionIds === void 0 ? void 0 : _object$positionIds.map(e => _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromValue */ .dK.fromValue(e))) || [];
    message.sender = (_object$sender4 = object.sender) !== null && _object$sender4 !== void 0 ? _object$sender4 : "";
    return message;
  },

  fromAmino(object) {
    return {
      positionIds: Array.isArray(object === null || object === void 0 ? void 0 : object.position_ids) ? object.position_ids.map(e => e) : [],
      sender: object.sender
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.positionIds) {
      obj.position_ids = message.positionIds.map(e => e);
    } else {
      obj.position_ids = [];
    }

    obj.sender = message.sender;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgCollectSpreadRewards.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/concentratedliquidity/collect-spread-rewards",
      value: MsgCollectSpreadRewards.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgCollectSpreadRewards.decode(message.value);
  },

  toProto(message) {
    return MsgCollectSpreadRewards.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.concentratedliquidity.v1beta1.MsgCollectSpreadRewards",
      value: MsgCollectSpreadRewards.encode(message).finish()
    };
  }

};

function createBaseMsgCollectSpreadRewardsResponse() {
  return {
    collectedSpreadRewards: []
  };
}

const MsgCollectSpreadRewardsResponse = {
  typeUrl: "/osmosis.concentratedliquidity.v1beta1.MsgCollectSpreadRewardsResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    for (const v of message.collectedSpreadRewards) {
      _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.encode(v, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgCollectSpreadRewardsResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.collectedSpreadRewards.push(_cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$collectedSpre;

    const message = createBaseMsgCollectSpreadRewardsResponse();
    message.collectedSpreadRewards = ((_object$collectedSpre = object.collectedSpreadRewards) === null || _object$collectedSpre === void 0 ? void 0 : _object$collectedSpre.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      collectedSpreadRewards: Array.isArray(object === null || object === void 0 ? void 0 : object.collected_spread_rewards) ? object.collected_spread_rewards.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.collectedSpreadRewards) {
      obj.collected_spread_rewards = message.collectedSpreadRewards.map(e => e ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.toAmino(e) : undefined);
    } else {
      obj.collected_spread_rewards = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return MsgCollectSpreadRewardsResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/concentratedliquidity/collect-spread-rewards-response",
      value: MsgCollectSpreadRewardsResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgCollectSpreadRewardsResponse.decode(message.value);
  },

  toProto(message) {
    return MsgCollectSpreadRewardsResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.concentratedliquidity.v1beta1.MsgCollectSpreadRewardsResponse",
      value: MsgCollectSpreadRewardsResponse.encode(message).finish()
    };
  }

};

function createBaseMsgCollectIncentives() {
  return {
    positionIds: [],
    sender: ""
  };
}

const MsgCollectIncentives = {
  typeUrl: "/osmosis.concentratedliquidity.v1beta1.MsgCollectIncentives",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    writer.uint32(10).fork();

    for (const v of message.positionIds) {
      writer.uint64(v);
    }

    writer.ldelim();

    if (message.sender !== "") {
      writer.uint32(18).string(message.sender);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgCollectIncentives();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          if ((tag & 7) === 2) {
            const end2 = reader.uint32() + reader.pos;

            while (reader.pos < end2) {
              message.positionIds.push(reader.uint64());
            }
          } else {
            message.positionIds.push(reader.uint64());
          }

          break;

        case 2:
          message.sender = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$positionIds2, _object$sender5;

    const message = createBaseMsgCollectIncentives();
    message.positionIds = ((_object$positionIds2 = object.positionIds) === null || _object$positionIds2 === void 0 ? void 0 : _object$positionIds2.map(e => _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromValue */ .dK.fromValue(e))) || [];
    message.sender = (_object$sender5 = object.sender) !== null && _object$sender5 !== void 0 ? _object$sender5 : "";
    return message;
  },

  fromAmino(object) {
    return {
      positionIds: Array.isArray(object === null || object === void 0 ? void 0 : object.position_ids) ? object.position_ids.map(e => e) : [],
      sender: object.sender
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.positionIds) {
      obj.position_ids = message.positionIds.map(e => e);
    } else {
      obj.position_ids = [];
    }

    obj.sender = message.sender;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgCollectIncentives.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/concentratedliquidity/collect-incentives",
      value: MsgCollectIncentives.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgCollectIncentives.decode(message.value);
  },

  toProto(message) {
    return MsgCollectIncentives.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.concentratedliquidity.v1beta1.MsgCollectIncentives",
      value: MsgCollectIncentives.encode(message).finish()
    };
  }

};

function createBaseMsgCollectIncentivesResponse() {
  return {
    collectedIncentives: [],
    forfeitedIncentives: []
  };
}

const MsgCollectIncentivesResponse = {
  typeUrl: "/osmosis.concentratedliquidity.v1beta1.MsgCollectIncentivesResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    for (const v of message.collectedIncentives) {
      _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.encode(v, writer.uint32(10).fork()).ldelim();
    }

    for (const v of message.forfeitedIncentives) {
      _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.encode(v, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgCollectIncentivesResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.collectedIncentives.push(_cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.decode(reader, reader.uint32()));
          break;

        case 2:
          message.forfeitedIncentives.push(_cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$collectedInce, _object$forfeitedInce;

    const message = createBaseMsgCollectIncentivesResponse();
    message.collectedIncentives = ((_object$collectedInce = object.collectedIncentives) === null || _object$collectedInce === void 0 ? void 0 : _object$collectedInce.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.fromPartial(e))) || [];
    message.forfeitedIncentives = ((_object$forfeitedInce = object.forfeitedIncentives) === null || _object$forfeitedInce === void 0 ? void 0 : _object$forfeitedInce.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      collectedIncentives: Array.isArray(object === null || object === void 0 ? void 0 : object.collected_incentives) ? object.collected_incentives.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.fromAmino(e)) : [],
      forfeitedIncentives: Array.isArray(object === null || object === void 0 ? void 0 : object.forfeited_incentives) ? object.forfeited_incentives.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.collectedIncentives) {
      obj.collected_incentives = message.collectedIncentives.map(e => e ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.toAmino(e) : undefined);
    } else {
      obj.collected_incentives = [];
    }

    if (message.forfeitedIncentives) {
      obj.forfeited_incentives = message.forfeitedIncentives.map(e => e ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.toAmino(e) : undefined);
    } else {
      obj.forfeited_incentives = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return MsgCollectIncentivesResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/concentratedliquidity/collect-incentives-response",
      value: MsgCollectIncentivesResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgCollectIncentivesResponse.decode(message.value);
  },

  toProto(message) {
    return MsgCollectIncentivesResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.concentratedliquidity.v1beta1.MsgCollectIncentivesResponse",
      value: MsgCollectIncentivesResponse.encode(message).finish()
    };
  }

};

function createBaseMsgFungifyChargedPositions() {
  return {
    positionIds: [],
    sender: ""
  };
}

const MsgFungifyChargedPositions = {
  typeUrl: "/osmosis.concentratedliquidity.v1beta1.MsgFungifyChargedPositions",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    writer.uint32(10).fork();

    for (const v of message.positionIds) {
      writer.uint64(v);
    }

    writer.ldelim();

    if (message.sender !== "") {
      writer.uint32(18).string(message.sender);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgFungifyChargedPositions();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          if ((tag & 7) === 2) {
            const end2 = reader.uint32() + reader.pos;

            while (reader.pos < end2) {
              message.positionIds.push(reader.uint64());
            }
          } else {
            message.positionIds.push(reader.uint64());
          }

          break;

        case 2:
          message.sender = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$positionIds3, _object$sender6;

    const message = createBaseMsgFungifyChargedPositions();
    message.positionIds = ((_object$positionIds3 = object.positionIds) === null || _object$positionIds3 === void 0 ? void 0 : _object$positionIds3.map(e => _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromValue */ .dK.fromValue(e))) || [];
    message.sender = (_object$sender6 = object.sender) !== null && _object$sender6 !== void 0 ? _object$sender6 : "";
    return message;
  },

  fromAmino(object) {
    return {
      positionIds: Array.isArray(object === null || object === void 0 ? void 0 : object.position_ids) ? object.position_ids.map(e => e) : [],
      sender: object.sender
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.positionIds) {
      obj.position_ids = message.positionIds.map(e => e);
    } else {
      obj.position_ids = [];
    }

    obj.sender = message.sender;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgFungifyChargedPositions.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/concentratedliquidity/fungify-charged-positions",
      value: MsgFungifyChargedPositions.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgFungifyChargedPositions.decode(message.value);
  },

  toProto(message) {
    return MsgFungifyChargedPositions.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.concentratedliquidity.v1beta1.MsgFungifyChargedPositions",
      value: MsgFungifyChargedPositions.encode(message).finish()
    };
  }

};

function createBaseMsgFungifyChargedPositionsResponse() {
  return {
    newPositionId: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.UZERO */ .dK.UZERO
  };
}

const MsgFungifyChargedPositionsResponse = {
  typeUrl: "/osmosis.concentratedliquidity.v1beta1.MsgFungifyChargedPositionsResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (!message.newPositionId.isZero()) {
      writer.uint32(8).uint64(message.newPositionId);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgFungifyChargedPositionsResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.newPositionId = reader.uint64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseMsgFungifyChargedPositionsResponse();
    message.newPositionId = object.newPositionId !== undefined && object.newPositionId !== null ? _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromValue */ .dK.fromValue(object.newPositionId) : _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.UZERO */ .dK.UZERO;
    return message;
  },

  fromAmino(object) {
    return {
      newPositionId: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromString */ .dK.fromString(object.new_position_id)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.new_position_id = message.newPositionId ? message.newPositionId.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgFungifyChargedPositionsResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/concentratedliquidity/fungify-charged-positions-response",
      value: MsgFungifyChargedPositionsResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgFungifyChargedPositionsResponse.decode(message.value);
  },

  toProto(message) {
    return MsgFungifyChargedPositionsResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.concentratedliquidity.v1beta1.MsgFungifyChargedPositionsResponse",
      value: MsgFungifyChargedPositionsResponse.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 17186:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CosmWasmPool": function() { return /* binding */ CosmWasmPool; }
/* harmony export */ });
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47895);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__);



function createBaseCosmWasmPool() {
  return {
    $typeUrl: "/osmosis.cosmwasmpool.v1beta1.CosmWasmPool",
    contractAddress: "",
    poolId: _helpers__WEBPACK_IMPORTED_MODULE_0__/* .Long.UZERO */ .dK.UZERO,
    codeId: _helpers__WEBPACK_IMPORTED_MODULE_0__/* .Long.UZERO */ .dK.UZERO,
    instantiateMsg: new Uint8Array()
  };
}

const CosmWasmPool = {
  typeUrl: "/osmosis.cosmwasmpool.v1beta1.CosmWasmPool",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Writer.create()) {
    if (message.contractAddress !== "") {
      writer.uint32(10).string(message.contractAddress);
    }

    if (!message.poolId.isZero()) {
      writer.uint32(16).uint64(message.poolId);
    }

    if (!message.codeId.isZero()) {
      writer.uint32(24).uint64(message.codeId);
    }

    if (message.instantiateMsg.length !== 0) {
      writer.uint32(34).bytes(message.instantiateMsg);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCosmWasmPool();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.contractAddress = reader.string();
          break;

        case 2:
          message.poolId = reader.uint64();
          break;

        case 3:
          message.codeId = reader.uint64();
          break;

        case 4:
          message.instantiateMsg = reader.bytes();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$contractAddre, _object$instantiateMs;

    const message = createBaseCosmWasmPool();
    message.contractAddress = (_object$contractAddre = object.contractAddress) !== null && _object$contractAddre !== void 0 ? _object$contractAddre : "";
    message.poolId = object.poolId !== undefined && object.poolId !== null ? _helpers__WEBPACK_IMPORTED_MODULE_0__/* .Long.fromValue */ .dK.fromValue(object.poolId) : _helpers__WEBPACK_IMPORTED_MODULE_0__/* .Long.UZERO */ .dK.UZERO;
    message.codeId = object.codeId !== undefined && object.codeId !== null ? _helpers__WEBPACK_IMPORTED_MODULE_0__/* .Long.fromValue */ .dK.fromValue(object.codeId) : _helpers__WEBPACK_IMPORTED_MODULE_0__/* .Long.UZERO */ .dK.UZERO;
    message.instantiateMsg = (_object$instantiateMs = object.instantiateMsg) !== null && _object$instantiateMs !== void 0 ? _object$instantiateMs : new Uint8Array();
    return message;
  },

  fromAmino(object) {
    return {
      contractAddress: object.contract_address,
      poolId: _helpers__WEBPACK_IMPORTED_MODULE_0__/* .Long.fromString */ .dK.fromString(object.pool_id),
      codeId: _helpers__WEBPACK_IMPORTED_MODULE_0__/* .Long.fromString */ .dK.fromString(object.code_id),
      instantiateMsg: object.instantiate_msg
    };
  },

  toAmino(message) {
    const obj = {};
    obj.contract_address = message.contractAddress;
    obj.pool_id = message.poolId ? message.poolId.toString() : undefined;
    obj.code_id = message.codeId ? message.codeId.toString() : undefined;
    obj.instantiate_msg = message.instantiateMsg;
    return obj;
  },

  fromAminoMsg(object) {
    return CosmWasmPool.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/cosmwasmpool/cosm-wasm-pool",
      value: CosmWasmPool.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return CosmWasmPool.decode(message.value);
  },

  toProto(message) {
    return CosmWasmPool.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.cosmwasmpool.v1beta1.CosmWasmPool",
      value: CosmWasmPool.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 33140:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Params": function() { return /* binding */ Params; }
/* harmony export */ });
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47895);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__);



function createBaseParams() {
  return {
    codeIdWhitelist: [],
    poolMigrationLimit: _helpers__WEBPACK_IMPORTED_MODULE_0__/* .Long.UZERO */ .dK.UZERO
  };
}

const Params = {
  typeUrl: "/osmosis.cosmwasmpool.v1beta1.Params",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Writer.create()) {
    writer.uint32(10).fork();

    for (const v of message.codeIdWhitelist) {
      writer.uint64(v);
    }

    writer.ldelim();

    if (!message.poolMigrationLimit.isZero()) {
      writer.uint32(16).uint64(message.poolMigrationLimit);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseParams();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          if ((tag & 7) === 2) {
            const end2 = reader.uint32() + reader.pos;

            while (reader.pos < end2) {
              message.codeIdWhitelist.push(reader.uint64());
            }
          } else {
            message.codeIdWhitelist.push(reader.uint64());
          }

          break;

        case 2:
          message.poolMigrationLimit = reader.uint64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$codeIdWhiteli;

    const message = createBaseParams();
    message.codeIdWhitelist = ((_object$codeIdWhiteli = object.codeIdWhitelist) === null || _object$codeIdWhiteli === void 0 ? void 0 : _object$codeIdWhiteli.map(e => _helpers__WEBPACK_IMPORTED_MODULE_0__/* .Long.fromValue */ .dK.fromValue(e))) || [];
    message.poolMigrationLimit = object.poolMigrationLimit !== undefined && object.poolMigrationLimit !== null ? _helpers__WEBPACK_IMPORTED_MODULE_0__/* .Long.fromValue */ .dK.fromValue(object.poolMigrationLimit) : _helpers__WEBPACK_IMPORTED_MODULE_0__/* .Long.UZERO */ .dK.UZERO;
    return message;
  },

  fromAmino(object) {
    return {
      codeIdWhitelist: Array.isArray(object === null || object === void 0 ? void 0 : object.code_id_whitelist) ? object.code_id_whitelist.map(e => e) : [],
      poolMigrationLimit: _helpers__WEBPACK_IMPORTED_MODULE_0__/* .Long.fromString */ .dK.fromString(object.pool_migration_limit)
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.codeIdWhitelist) {
      obj.code_id_whitelist = message.codeIdWhitelist.map(e => e);
    } else {
      obj.code_id_whitelist = [];
    }

    obj.pool_migration_limit = message.poolMigrationLimit ? message.poolMigrationLimit.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return Params.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/cosmwasmpool/params",
      value: Params.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return Params.decode(message.value);
  },

  toProto(message) {
    return Params.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.cosmwasmpool.v1beta1.Params",
      value: Params.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 40000:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ContractInfoByPoolIdRequest": function() { return /* binding */ ContractInfoByPoolIdRequest; },
/* harmony export */   "ContractInfoByPoolIdResponse": function() { return /* binding */ ContractInfoByPoolIdResponse; },
/* harmony export */   "ParamsRequest": function() { return /* binding */ ParamsRequest; },
/* harmony export */   "ParamsResponse": function() { return /* binding */ ParamsResponse; },
/* harmony export */   "PoolI_FromAmino": function() { return /* binding */ PoolI_FromAmino; },
/* harmony export */   "PoolI_InterfaceDecoder": function() { return /* binding */ PoolI_InterfaceDecoder; },
/* harmony export */   "PoolI_ToAmino": function() { return /* binding */ PoolI_ToAmino; },
/* harmony export */   "PoolsRequest": function() { return /* binding */ PoolsRequest; },
/* harmony export */   "PoolsResponse": function() { return /* binding */ PoolsResponse; }
/* harmony export */ });
/* harmony import */ var _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48978);
/* harmony import */ var _params__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33140);
/* harmony import */ var _google_protobuf_any__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32106);
/* harmony import */ var _concentrated_liquidity_pool__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4343);
/* harmony import */ var _model_pool__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(17186);
/* harmony import */ var _gamm_pool_models_balancer_balancerPool__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4075);
/* harmony import */ var _gamm_pool_models_stableswap_stableswap_pool__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(66761);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(47895);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_8__);









/** =============================== ContractInfoByPoolId */

function createBaseParamsRequest() {
  return {};
}

const ParamsRequest = {
  typeUrl: "/osmosis.cosmwasmpool.v1beta1.ParamsRequest",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_8__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_8__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_8__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseParamsRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseParamsRequest();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return ParamsRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/cosmwasmpool/params-request",
      value: ParamsRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return ParamsRequest.decode(message.value);
  },

  toProto(message) {
    return ParamsRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.cosmwasmpool.v1beta1.ParamsRequest",
      value: ParamsRequest.encode(message).finish()
    };
  }

};

function createBaseParamsResponse() {
  return {
    params: undefined
  };
}

const ParamsResponse = {
  typeUrl: "/osmosis.cosmwasmpool.v1beta1.ParamsResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_8__.Writer.create()) {
    if (message.params !== undefined) {
      _params__WEBPACK_IMPORTED_MODULE_1__.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_8__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_8__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseParamsResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.params = _params__WEBPACK_IMPORTED_MODULE_1__.Params.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseParamsResponse();
    message.params = object.params !== undefined && object.params !== null ? _params__WEBPACK_IMPORTED_MODULE_1__.Params.fromPartial(object.params) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      params: object !== null && object !== void 0 && object.params ? _params__WEBPACK_IMPORTED_MODULE_1__.Params.fromAmino(object.params) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.params = message.params ? _params__WEBPACK_IMPORTED_MODULE_1__.Params.toAmino(message.params) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return ParamsResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/cosmwasmpool/params-response",
      value: ParamsResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return ParamsResponse.decode(message.value);
  },

  toProto(message) {
    return ParamsResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.cosmwasmpool.v1beta1.ParamsResponse",
      value: ParamsResponse.encode(message).finish()
    };
  }

};

function createBasePoolsRequest() {
  return {
    pagination: undefined
  };
}

const PoolsRequest = {
  typeUrl: "/osmosis.cosmwasmpool.v1beta1.PoolsRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_8__.Writer.create()) {
    if (message.pagination !== undefined) {
      _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_8__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_8__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePoolsRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 2:
          message.pagination = _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBasePoolsRequest();
    message.pagination = object.pagination !== undefined && object.pagination !== null ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.fromPartial(object.pagination) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      pagination: object !== null && object !== void 0 && object.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.fromAmino(object.pagination) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.pagination = message.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.toAmino(message.pagination) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return PoolsRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/cosmwasmpool/pools-request",
      value: PoolsRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return PoolsRequest.decode(message.value);
  },

  toProto(message) {
    return PoolsRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.cosmwasmpool.v1beta1.PoolsRequest",
      value: PoolsRequest.encode(message).finish()
    };
  }

};

function createBasePoolsResponse() {
  return {
    pools: [],
    pagination: undefined
  };
}

const PoolsResponse = {
  typeUrl: "/osmosis.cosmwasmpool.v1beta1.PoolsResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_8__.Writer.create()) {
    for (const v of message.pools) {
      _google_protobuf_any__WEBPACK_IMPORTED_MODULE_2__.Any.encode(v, writer.uint32(10).fork()).ldelim();
    }

    if (message.pagination !== undefined) {
      _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_8__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_8__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePoolsResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.pools.push(PoolI_InterfaceDecoder(reader));
          break;

        case 2:
          message.pagination = _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$pools;

    const message = createBasePoolsResponse();
    message.pools = ((_object$pools = object.pools) === null || _object$pools === void 0 ? void 0 : _object$pools.map(e => _google_protobuf_any__WEBPACK_IMPORTED_MODULE_2__.Any.fromPartial(e))) || [];
    message.pagination = object.pagination !== undefined && object.pagination !== null ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.fromPartial(object.pagination) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      pools: Array.isArray(object === null || object === void 0 ? void 0 : object.pools) ? object.pools.map(e => PoolI_FromAmino(e)) : [],
      pagination: object !== null && object !== void 0 && object.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.fromAmino(object.pagination) : undefined
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.pools) {
      obj.pools = message.pools.map(e => e ? PoolI_ToAmino(e) : undefined);
    } else {
      obj.pools = [];
    }

    obj.pagination = message.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.toAmino(message.pagination) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return PoolsResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/cosmwasmpool/pools-response",
      value: PoolsResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return PoolsResponse.decode(message.value);
  },

  toProto(message) {
    return PoolsResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.cosmwasmpool.v1beta1.PoolsResponse",
      value: PoolsResponse.encode(message).finish()
    };
  }

};

function createBaseContractInfoByPoolIdRequest() {
  return {
    poolId: _helpers__WEBPACK_IMPORTED_MODULE_7__/* .Long.UZERO */ .dK.UZERO
  };
}

const ContractInfoByPoolIdRequest = {
  typeUrl: "/osmosis.cosmwasmpool.v1beta1.ContractInfoByPoolIdRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_8__.Writer.create()) {
    if (!message.poolId.isZero()) {
      writer.uint32(8).uint64(message.poolId);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_8__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_8__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseContractInfoByPoolIdRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.poolId = reader.uint64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseContractInfoByPoolIdRequest();
    message.poolId = object.poolId !== undefined && object.poolId !== null ? _helpers__WEBPACK_IMPORTED_MODULE_7__/* .Long.fromValue */ .dK.fromValue(object.poolId) : _helpers__WEBPACK_IMPORTED_MODULE_7__/* .Long.UZERO */ .dK.UZERO;
    return message;
  },

  fromAmino(object) {
    return {
      poolId: _helpers__WEBPACK_IMPORTED_MODULE_7__/* .Long.fromString */ .dK.fromString(object.pool_id)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.pool_id = message.poolId ? message.poolId.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return ContractInfoByPoolIdRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/cosmwasmpool/contract-info-by-pool-id-request",
      value: ContractInfoByPoolIdRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return ContractInfoByPoolIdRequest.decode(message.value);
  },

  toProto(message) {
    return ContractInfoByPoolIdRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.cosmwasmpool.v1beta1.ContractInfoByPoolIdRequest",
      value: ContractInfoByPoolIdRequest.encode(message).finish()
    };
  }

};

function createBaseContractInfoByPoolIdResponse() {
  return {
    contractAddress: "",
    codeId: _helpers__WEBPACK_IMPORTED_MODULE_7__/* .Long.UZERO */ .dK.UZERO
  };
}

const ContractInfoByPoolIdResponse = {
  typeUrl: "/osmosis.cosmwasmpool.v1beta1.ContractInfoByPoolIdResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_8__.Writer.create()) {
    if (message.contractAddress !== "") {
      writer.uint32(10).string(message.contractAddress);
    }

    if (!message.codeId.isZero()) {
      writer.uint32(16).uint64(message.codeId);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_8__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_8__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseContractInfoByPoolIdResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.contractAddress = reader.string();
          break;

        case 2:
          message.codeId = reader.uint64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$contractAddre;

    const message = createBaseContractInfoByPoolIdResponse();
    message.contractAddress = (_object$contractAddre = object.contractAddress) !== null && _object$contractAddre !== void 0 ? _object$contractAddre : "";
    message.codeId = object.codeId !== undefined && object.codeId !== null ? _helpers__WEBPACK_IMPORTED_MODULE_7__/* .Long.fromValue */ .dK.fromValue(object.codeId) : _helpers__WEBPACK_IMPORTED_MODULE_7__/* .Long.UZERO */ .dK.UZERO;
    return message;
  },

  fromAmino(object) {
    return {
      contractAddress: object.contract_address,
      codeId: _helpers__WEBPACK_IMPORTED_MODULE_7__/* .Long.fromString */ .dK.fromString(object.code_id)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.contract_address = message.contractAddress;
    obj.code_id = message.codeId ? message.codeId.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return ContractInfoByPoolIdResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/cosmwasmpool/contract-info-by-pool-id-response",
      value: ContractInfoByPoolIdResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return ContractInfoByPoolIdResponse.decode(message.value);
  },

  toProto(message) {
    return ContractInfoByPoolIdResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.cosmwasmpool.v1beta1.ContractInfoByPoolIdResponse",
      value: ContractInfoByPoolIdResponse.encode(message).finish()
    };
  }

};
const PoolI_InterfaceDecoder = input => {
  const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_8__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_8__.Reader(input);
  const data = _google_protobuf_any__WEBPACK_IMPORTED_MODULE_2__.Any.decode(reader, reader.uint32());

  switch (data.typeUrl) {
    case "/osmosis.concentratedliquidity.v1beta1.Pool":
      return _concentrated_liquidity_pool__WEBPACK_IMPORTED_MODULE_3__/* .Pool.decode */ .K.decode(data.value);

    case "/osmosis.cosmwasmpool.v1beta1.CosmWasmPool":
      return _model_pool__WEBPACK_IMPORTED_MODULE_4__.CosmWasmPool.decode(data.value);

    case "/osmosis.gamm.v1beta1.Pool":
      return _gamm_pool_models_balancer_balancerPool__WEBPACK_IMPORTED_MODULE_5__.Pool.decode(data.value);

    case "/osmosis.gamm.poolmodels.stableswap.v1beta1.Pool":
      return _gamm_pool_models_stableswap_stableswap_pool__WEBPACK_IMPORTED_MODULE_6__.Pool.decode(data.value);

    default:
      return data;
  }
};
const PoolI_FromAmino = content => {
  switch (content.type) {
    case "osmosis/concentratedliquidity/pool":
      return _google_protobuf_any__WEBPACK_IMPORTED_MODULE_2__.Any.fromPartial({
        typeUrl: "/osmosis.concentratedliquidity.v1beta1.Pool",
        value: _concentrated_liquidity_pool__WEBPACK_IMPORTED_MODULE_3__/* .Pool.encode */ .K.encode(_concentrated_liquidity_pool__WEBPACK_IMPORTED_MODULE_3__/* .Pool.fromPartial */ .K.fromPartial(_concentrated_liquidity_pool__WEBPACK_IMPORTED_MODULE_3__/* .Pool.fromAmino */ .K.fromAmino(content.value))).finish()
      });

    case "osmosis/cosmwasmpool/cosm-wasm-pool":
      return _google_protobuf_any__WEBPACK_IMPORTED_MODULE_2__.Any.fromPartial({
        typeUrl: "/osmosis.cosmwasmpool.v1beta1.CosmWasmPool",
        value: _model_pool__WEBPACK_IMPORTED_MODULE_4__.CosmWasmPool.encode(_model_pool__WEBPACK_IMPORTED_MODULE_4__.CosmWasmPool.fromPartial(_model_pool__WEBPACK_IMPORTED_MODULE_4__.CosmWasmPool.fromAmino(content.value))).finish()
      });

    case "osmosis/gamm/BalancerPool":
      return _google_protobuf_any__WEBPACK_IMPORTED_MODULE_2__.Any.fromPartial({
        typeUrl: "/osmosis.gamm.v1beta1.Pool",
        value: _gamm_pool_models_balancer_balancerPool__WEBPACK_IMPORTED_MODULE_5__.Pool.encode(_gamm_pool_models_balancer_balancerPool__WEBPACK_IMPORTED_MODULE_5__.Pool.fromPartial(_gamm_pool_models_balancer_balancerPool__WEBPACK_IMPORTED_MODULE_5__.Pool.fromAmino(content.value))).finish()
      });

    case "osmosis/gamm/StableswapPool":
      return _google_protobuf_any__WEBPACK_IMPORTED_MODULE_2__.Any.fromPartial({
        typeUrl: "/osmosis.gamm.poolmodels.stableswap.v1beta1.Pool",
        value: _gamm_pool_models_stableswap_stableswap_pool__WEBPACK_IMPORTED_MODULE_6__.Pool.encode(_gamm_pool_models_stableswap_stableswap_pool__WEBPACK_IMPORTED_MODULE_6__.Pool.fromPartial(_gamm_pool_models_stableswap_stableswap_pool__WEBPACK_IMPORTED_MODULE_6__.Pool.fromAmino(content.value))).finish()
      });

    default:
      return _google_protobuf_any__WEBPACK_IMPORTED_MODULE_2__.Any.fromAmino(content);
  }
};
const PoolI_ToAmino = content => {
  switch (content.typeUrl) {
    case "/osmosis.concentratedliquidity.v1beta1.Pool":
      return {
        type: "osmosis/concentratedliquidity/pool",
        value: _concentrated_liquidity_pool__WEBPACK_IMPORTED_MODULE_3__/* .Pool.toAmino */ .K.toAmino(_concentrated_liquidity_pool__WEBPACK_IMPORTED_MODULE_3__/* .Pool.decode */ .K.decode(content.value))
      };

    case "/osmosis.cosmwasmpool.v1beta1.CosmWasmPool":
      return {
        type: "osmosis/cosmwasmpool/cosm-wasm-pool",
        value: _model_pool__WEBPACK_IMPORTED_MODULE_4__.CosmWasmPool.toAmino(_model_pool__WEBPACK_IMPORTED_MODULE_4__.CosmWasmPool.decode(content.value))
      };

    case "/osmosis.gamm.v1beta1.Pool":
      return {
        type: "osmosis/gamm/BalancerPool",
        value: _gamm_pool_models_balancer_balancerPool__WEBPACK_IMPORTED_MODULE_5__.Pool.toAmino(_gamm_pool_models_balancer_balancerPool__WEBPACK_IMPORTED_MODULE_5__.Pool.decode(content.value))
      };

    case "/osmosis.gamm.poolmodels.stableswap.v1beta1.Pool":
      return {
        type: "osmosis/gamm/StableswapPool",
        value: _gamm_pool_models_stableswap_stableswap_pool__WEBPACK_IMPORTED_MODULE_6__.Pool.toAmino(_gamm_pool_models_stableswap_stableswap_pool__WEBPACK_IMPORTED_MODULE_6__.Pool.decode(content.value))
      };

    default:
      return _google_protobuf_any__WEBPACK_IMPORTED_MODULE_2__.Any.toAmino(content);
  }
};

/***/ }),

/***/ 53193:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LCDQueryClient": function() { return /* binding */ LCDQueryClient; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4942);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47895);


class LCDQueryClient {
  constructor({
    requestClient
  }) {
    (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, "req", void 0);

    this.req = requestClient;
    this.pools = this.pools.bind(this);
    this.params = this.params.bind(this);
    this.contractInfoByPoolId = this.contractInfoByPoolId.bind(this);
  }
  /* Pools returns all cosmwasm pools */


  async pools(params = {
    pagination: undefined
  }) {
    const options = {
      params: {}
    };

    if (typeof (params === null || params === void 0 ? void 0 : params.pagination) !== "undefined") {
      (0,_helpers__WEBPACK_IMPORTED_MODULE_0__/* .setPaginationParams */ .q6)(options, params.pagination);
    }

    const endpoint = `osmosis/cosmwasmpool/v1beta1/pools`;
    return await this.req.get(endpoint, options);
  }
  /* Params returns the parameters of the x/cosmwasmpool module. */


  async params(_params = {}) {
    const endpoint = `osmosis/cosmwasmpool/v1beta1/params`;
    return await this.req.get(endpoint);
  }
  /* ContractInfoByPoolId */


  async contractInfoByPoolId(params) {
    const options = {
      params: {}
    };

    if (typeof (params === null || params === void 0 ? void 0 : params.poolId) !== "undefined") {
      options.params.pool_id = params.poolId;
    }

    const endpoint = `osmosis/cosmwasmpool/v1beta1/contract_info`;
    return await this.req.get(endpoint, options);
  }

}

/***/ }),

/***/ 61887:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QueryClientImpl": function() { return /* binding */ QueryClientImpl; },
/* harmony export */   "createRpcQueryExtension": function() { return /* binding */ createRpcQueryExtension; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4942);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78441);
/* harmony import */ var _cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40000);




class QueryClientImpl {
  constructor(rpc) {
    (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, "rpc", void 0);

    this.rpc = rpc;
    this.pools = this.pools.bind(this);
    this.params = this.params.bind(this);
    this.contractInfoByPoolId = this.contractInfoByPoolId.bind(this);
  }

  pools(request = {
    pagination: undefined
  }) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.PoolsRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.cosmwasmpool.v1beta1.Query", "Pools", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.PoolsResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  params(request = {}) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.ParamsRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.cosmwasmpool.v1beta1.Query", "Params", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.ParamsResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  contractInfoByPoolId(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.ContractInfoByPoolIdRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.cosmwasmpool.v1beta1.Query", "ContractInfoByPoolId", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.ContractInfoByPoolIdResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

}
const createRpcQueryExtension = base => {
  const rpc = (0,_cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1__.createProtobufRpcClient)(base);
  const queryService = new QueryClientImpl(rpc);
  return {
    pools(request) {
      return queryService.pools(request);
    },

    params(request) {
      return queryService.params(request);
    },

    contractInfoByPoolId(request) {
      return queryService.contractInfoByPoolId(request);
    }

  };
};

/***/ }),

/***/ 44525:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Downtime": function() { return /* binding */ Downtime; },
/* harmony export */   "DowntimeAmino": function() { return /* binding */ DowntimeAmino; },
/* harmony export */   "DowntimeSDKType": function() { return /* binding */ DowntimeSDKType; },
/* harmony export */   "downtimeFromJSON": function() { return /* binding */ downtimeFromJSON; },
/* harmony export */   "downtimeToJSON": function() { return /* binding */ downtimeToJSON; }
/* harmony export */ });
let Downtime;

(function (Downtime) {
  Downtime[Downtime["DURATION_30S"] = 0] = "DURATION_30S";
  Downtime[Downtime["DURATION_1M"] = 1] = "DURATION_1M";
  Downtime[Downtime["DURATION_2M"] = 2] = "DURATION_2M";
  Downtime[Downtime["DURATION_3M"] = 3] = "DURATION_3M";
  Downtime[Downtime["DURATION_4M"] = 4] = "DURATION_4M";
  Downtime[Downtime["DURATION_5M"] = 5] = "DURATION_5M";
  Downtime[Downtime["DURATION_10M"] = 6] = "DURATION_10M";
  Downtime[Downtime["DURATION_20M"] = 7] = "DURATION_20M";
  Downtime[Downtime["DURATION_30M"] = 8] = "DURATION_30M";
  Downtime[Downtime["DURATION_40M"] = 9] = "DURATION_40M";
  Downtime[Downtime["DURATION_50M"] = 10] = "DURATION_50M";
  Downtime[Downtime["DURATION_1H"] = 11] = "DURATION_1H";
  Downtime[Downtime["DURATION_1_5H"] = 12] = "DURATION_1_5H";
  Downtime[Downtime["DURATION_2H"] = 13] = "DURATION_2H";
  Downtime[Downtime["DURATION_2_5H"] = 14] = "DURATION_2_5H";
  Downtime[Downtime["DURATION_3H"] = 15] = "DURATION_3H";
  Downtime[Downtime["DURATION_4H"] = 16] = "DURATION_4H";
  Downtime[Downtime["DURATION_5H"] = 17] = "DURATION_5H";
  Downtime[Downtime["DURATION_6H"] = 18] = "DURATION_6H";
  Downtime[Downtime["DURATION_9H"] = 19] = "DURATION_9H";
  Downtime[Downtime["DURATION_12H"] = 20] = "DURATION_12H";
  Downtime[Downtime["DURATION_18H"] = 21] = "DURATION_18H";
  Downtime[Downtime["DURATION_24H"] = 22] = "DURATION_24H";
  Downtime[Downtime["DURATION_36H"] = 23] = "DURATION_36H";
  Downtime[Downtime["DURATION_48H"] = 24] = "DURATION_48H";
  Downtime[Downtime["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(Downtime || (Downtime = {}));

const DowntimeSDKType = Downtime;
const DowntimeAmino = Downtime;
function downtimeFromJSON(object) {
  switch (object) {
    case 0:
    case "DURATION_30S":
      return Downtime.DURATION_30S;

    case 1:
    case "DURATION_1M":
      return Downtime.DURATION_1M;

    case 2:
    case "DURATION_2M":
      return Downtime.DURATION_2M;

    case 3:
    case "DURATION_3M":
      return Downtime.DURATION_3M;

    case 4:
    case "DURATION_4M":
      return Downtime.DURATION_4M;

    case 5:
    case "DURATION_5M":
      return Downtime.DURATION_5M;

    case 6:
    case "DURATION_10M":
      return Downtime.DURATION_10M;

    case 7:
    case "DURATION_20M":
      return Downtime.DURATION_20M;

    case 8:
    case "DURATION_30M":
      return Downtime.DURATION_30M;

    case 9:
    case "DURATION_40M":
      return Downtime.DURATION_40M;

    case 10:
    case "DURATION_50M":
      return Downtime.DURATION_50M;

    case 11:
    case "DURATION_1H":
      return Downtime.DURATION_1H;

    case 12:
    case "DURATION_1_5H":
      return Downtime.DURATION_1_5H;

    case 13:
    case "DURATION_2H":
      return Downtime.DURATION_2H;

    case 14:
    case "DURATION_2_5H":
      return Downtime.DURATION_2_5H;

    case 15:
    case "DURATION_3H":
      return Downtime.DURATION_3H;

    case 16:
    case "DURATION_4H":
      return Downtime.DURATION_4H;

    case 17:
    case "DURATION_5H":
      return Downtime.DURATION_5H;

    case 18:
    case "DURATION_6H":
      return Downtime.DURATION_6H;

    case 19:
    case "DURATION_9H":
      return Downtime.DURATION_9H;

    case 20:
    case "DURATION_12H":
      return Downtime.DURATION_12H;

    case 21:
    case "DURATION_18H":
      return Downtime.DURATION_18H;

    case 22:
    case "DURATION_24H":
      return Downtime.DURATION_24H;

    case 23:
    case "DURATION_36H":
      return Downtime.DURATION_36H;

    case 24:
    case "DURATION_48H":
      return Downtime.DURATION_48H;

    case -1:
    case "UNRECOGNIZED":
    default:
      return Downtime.UNRECOGNIZED;
  }
}
function downtimeToJSON(object) {
  switch (object) {
    case Downtime.DURATION_30S:
      return "DURATION_30S";

    case Downtime.DURATION_1M:
      return "DURATION_1M";

    case Downtime.DURATION_2M:
      return "DURATION_2M";

    case Downtime.DURATION_3M:
      return "DURATION_3M";

    case Downtime.DURATION_4M:
      return "DURATION_4M";

    case Downtime.DURATION_5M:
      return "DURATION_5M";

    case Downtime.DURATION_10M:
      return "DURATION_10M";

    case Downtime.DURATION_20M:
      return "DURATION_20M";

    case Downtime.DURATION_30M:
      return "DURATION_30M";

    case Downtime.DURATION_40M:
      return "DURATION_40M";

    case Downtime.DURATION_50M:
      return "DURATION_50M";

    case Downtime.DURATION_1H:
      return "DURATION_1H";

    case Downtime.DURATION_1_5H:
      return "DURATION_1_5H";

    case Downtime.DURATION_2H:
      return "DURATION_2H";

    case Downtime.DURATION_2_5H:
      return "DURATION_2_5H";

    case Downtime.DURATION_3H:
      return "DURATION_3H";

    case Downtime.DURATION_4H:
      return "DURATION_4H";

    case Downtime.DURATION_5H:
      return "DURATION_5H";

    case Downtime.DURATION_6H:
      return "DURATION_6H";

    case Downtime.DURATION_9H:
      return "DURATION_9H";

    case Downtime.DURATION_12H:
      return "DURATION_12H";

    case Downtime.DURATION_18H:
      return "DURATION_18H";

    case Downtime.DURATION_24H:
      return "DURATION_24H";

    case Downtime.DURATION_36H:
      return "DURATION_36H";

    case Downtime.DURATION_48H:
      return "DURATION_48H";

    case Downtime.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/***/ }),

/***/ 30623:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RecoveredSinceDowntimeOfLengthRequest": function() { return /* binding */ RecoveredSinceDowntimeOfLengthRequest; },
/* harmony export */   "RecoveredSinceDowntimeOfLengthResponse": function() { return /* binding */ RecoveredSinceDowntimeOfLengthResponse; }
/* harmony export */ });
/* harmony import */ var _downtime_duration__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44525);
/* harmony import */ var _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6499);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47895);




/**
 * Query for has it been at least $RECOVERY_DURATION units of time,
 * since the chain has been down for $DOWNTIME_DURATION.
 */

function createBaseRecoveredSinceDowntimeOfLengthRequest() {
  return {
    downtime: 0,
    recovery: undefined
  };
}

const RecoveredSinceDowntimeOfLengthRequest = {
  typeUrl: "/osmosis.downtimedetector.v1beta1.RecoveredSinceDowntimeOfLengthRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (message.downtime !== 0) {
      writer.uint32(8).int32(message.downtime);
    }

    if (message.recovery !== undefined) {
      _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_1__.Duration.encode(message.recovery, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRecoveredSinceDowntimeOfLengthRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.downtime = reader.int32();
          break;

        case 2:
          message.recovery = _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_1__.Duration.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$downtime;

    const message = createBaseRecoveredSinceDowntimeOfLengthRequest();
    message.downtime = (_object$downtime = object.downtime) !== null && _object$downtime !== void 0 ? _object$downtime : 0;
    message.recovery = object.recovery !== undefined && object.recovery !== null ? _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_1__.Duration.fromPartial(object.recovery) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      downtime: (0,_helpers__WEBPACK_IMPORTED_MODULE_3__/* .isSet */ .DM)(object.downtime) ? (0,_downtime_duration__WEBPACK_IMPORTED_MODULE_0__.downtimeFromJSON)(object.downtime) : 0,
      recovery: object !== null && object !== void 0 && object.recovery ? _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_1__.Duration.fromAmino(object.recovery) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.downtime = message.downtime;
    obj.recovery = message.recovery ? _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_1__.Duration.toAmino(message.recovery) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return RecoveredSinceDowntimeOfLengthRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/downtimedetector/recovered-since-downtime-of-length-request",
      value: RecoveredSinceDowntimeOfLengthRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return RecoveredSinceDowntimeOfLengthRequest.decode(message.value);
  },

  toProto(message) {
    return RecoveredSinceDowntimeOfLengthRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.downtimedetector.v1beta1.RecoveredSinceDowntimeOfLengthRequest",
      value: RecoveredSinceDowntimeOfLengthRequest.encode(message).finish()
    };
  }

};

function createBaseRecoveredSinceDowntimeOfLengthResponse() {
  return {
    succesfullyRecovered: false
  };
}

const RecoveredSinceDowntimeOfLengthResponse = {
  typeUrl: "/osmosis.downtimedetector.v1beta1.RecoveredSinceDowntimeOfLengthResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (message.succesfullyRecovered === true) {
      writer.uint32(8).bool(message.succesfullyRecovered);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRecoveredSinceDowntimeOfLengthResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.succesfullyRecovered = reader.bool();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$succesfullyRe;

    const message = createBaseRecoveredSinceDowntimeOfLengthResponse();
    message.succesfullyRecovered = (_object$succesfullyRe = object.succesfullyRecovered) !== null && _object$succesfullyRe !== void 0 ? _object$succesfullyRe : false;
    return message;
  },

  fromAmino(object) {
    return {
      succesfullyRecovered: object.succesfully_recovered
    };
  },

  toAmino(message) {
    const obj = {};
    obj.succesfully_recovered = message.succesfullyRecovered;
    return obj;
  },

  fromAminoMsg(object) {
    return RecoveredSinceDowntimeOfLengthResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/downtimedetector/recovered-since-downtime-of-length-response",
      value: RecoveredSinceDowntimeOfLengthResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return RecoveredSinceDowntimeOfLengthResponse.decode(message.value);
  },

  toProto(message) {
    return RecoveredSinceDowntimeOfLengthResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.downtimedetector.v1beta1.RecoveredSinceDowntimeOfLengthResponse",
      value: RecoveredSinceDowntimeOfLengthResponse.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 90377:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LCDQueryClient": function() { return /* binding */ LCDQueryClient; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4942);

class LCDQueryClient {
  constructor({
    requestClient
  }) {
    (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, "req", void 0);

    this.req = requestClient;
    this.recoveredSinceDowntimeOfLength = this.recoveredSinceDowntimeOfLength.bind(this);
  }
  /* RecoveredSinceDowntimeOfLength */


  async recoveredSinceDowntimeOfLength(params) {
    const options = {
      params: {}
    };

    if (typeof (params === null || params === void 0 ? void 0 : params.downtime) !== "undefined") {
      options.params.downtime = params.downtime;
    }

    if (typeof (params === null || params === void 0 ? void 0 : params.recovery) !== "undefined") {
      options.params.recovery = params.recovery;
    }

    const endpoint = `osmosis/downtime-detector/v1beta1/RecoveredSinceDowntimeOfLength`;
    return await this.req.get(endpoint, options);
  }

}

/***/ }),

/***/ 59173:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QueryClientImpl": function() { return /* binding */ QueryClientImpl; },
/* harmony export */   "createRpcQueryExtension": function() { return /* binding */ createRpcQueryExtension; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4942);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78441);
/* harmony import */ var _cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30623);




class QueryClientImpl {
  constructor(rpc) {
    (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, "rpc", void 0);

    this.rpc = rpc;
    this.recoveredSinceDowntimeOfLength = this.recoveredSinceDowntimeOfLength.bind(this);
  }

  recoveredSinceDowntimeOfLength(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.RecoveredSinceDowntimeOfLengthRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.downtimedetector.v1beta1.Query", "RecoveredSinceDowntimeOfLength", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.RecoveredSinceDowntimeOfLengthResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

}
const createRpcQueryExtension = base => {
  const rpc = (0,_cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1__.createProtobufRpcClient)(base);
  const queryService = new QueryClientImpl(rpc);
  return {
    recoveredSinceDowntimeOfLength(request) {
      return queryService.recoveredSinceDowntimeOfLength(request);
    }

  };
};

/***/ }),

/***/ 54871:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EpochInfo": function() { return /* binding */ EpochInfo; },
/* harmony export */   "GenesisState": function() { return /* binding */ GenesisState; }
/* harmony export */ });
/* harmony import */ var _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20633);
/* harmony import */ var _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6499);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47895);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__);




/**
 * EpochInfo is a struct that describes the data going into
 * a timer defined by the x/epochs module.
 */

function createBaseEpochInfo() {
  return {
    identifier: "",
    startTime: undefined,
    duration: undefined,
    currentEpoch: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.ZERO */ .dK.ZERO,
    currentEpochStartTime: undefined,
    epochCountingStarted: false,
    currentEpochStartHeight: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.ZERO */ .dK.ZERO
  };
}

const EpochInfo = {
  typeUrl: "/osmosis.epochs.v1beta1.EpochInfo",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.identifier !== "") {
      writer.uint32(10).string(message.identifier);
    }

    if (message.startTime !== undefined) {
      _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_0__.Timestamp.encode((0,_helpers__WEBPACK_IMPORTED_MODULE_2__/* .toTimestamp */ .Uq)(message.startTime), writer.uint32(18).fork()).ldelim();
    }

    if (message.duration !== undefined) {
      _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_1__.Duration.encode(message.duration, writer.uint32(26).fork()).ldelim();
    }

    if (!message.currentEpoch.isZero()) {
      writer.uint32(32).int64(message.currentEpoch);
    }

    if (message.currentEpochStartTime !== undefined) {
      _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_0__.Timestamp.encode((0,_helpers__WEBPACK_IMPORTED_MODULE_2__/* .toTimestamp */ .Uq)(message.currentEpochStartTime), writer.uint32(42).fork()).ldelim();
    }

    if (message.epochCountingStarted === true) {
      writer.uint32(48).bool(message.epochCountingStarted);
    }

    if (!message.currentEpochStartHeight.isZero()) {
      writer.uint32(64).int64(message.currentEpochStartHeight);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEpochInfo();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.identifier = reader.string();
          break;

        case 2:
          message.startTime = (0,_helpers__WEBPACK_IMPORTED_MODULE_2__/* .fromTimestamp */ .Ol)(_google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_0__.Timestamp.decode(reader, reader.uint32()));
          break;

        case 3:
          message.duration = _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_1__.Duration.decode(reader, reader.uint32());
          break;

        case 4:
          message.currentEpoch = reader.int64();
          break;

        case 5:
          message.currentEpochStartTime = (0,_helpers__WEBPACK_IMPORTED_MODULE_2__/* .fromTimestamp */ .Ol)(_google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_0__.Timestamp.decode(reader, reader.uint32()));
          break;

        case 6:
          message.epochCountingStarted = reader.bool();
          break;

        case 8:
          message.currentEpochStartHeight = reader.int64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$identifier, _object$startTime, _object$currentEpochS, _object$epochCounting;

    const message = createBaseEpochInfo();
    message.identifier = (_object$identifier = object.identifier) !== null && _object$identifier !== void 0 ? _object$identifier : "";
    message.startTime = (_object$startTime = object.startTime) !== null && _object$startTime !== void 0 ? _object$startTime : undefined;
    message.duration = object.duration !== undefined && object.duration !== null ? _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_1__.Duration.fromPartial(object.duration) : undefined;
    message.currentEpoch = object.currentEpoch !== undefined && object.currentEpoch !== null ? _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromValue */ .dK.fromValue(object.currentEpoch) : _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.ZERO */ .dK.ZERO;
    message.currentEpochStartTime = (_object$currentEpochS = object.currentEpochStartTime) !== null && _object$currentEpochS !== void 0 ? _object$currentEpochS : undefined;
    message.epochCountingStarted = (_object$epochCounting = object.epochCountingStarted) !== null && _object$epochCounting !== void 0 ? _object$epochCounting : false;
    message.currentEpochStartHeight = object.currentEpochStartHeight !== undefined && object.currentEpochStartHeight !== null ? _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromValue */ .dK.fromValue(object.currentEpochStartHeight) : _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.ZERO */ .dK.ZERO;
    return message;
  },

  fromAmino(object) {
    return {
      identifier: object.identifier,
      startTime: object !== null && object !== void 0 && object.start_time ? _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_0__.Timestamp.fromAmino(object.start_time) : undefined,
      duration: object !== null && object !== void 0 && object.duration ? _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_1__.Duration.fromAmino(object.duration) : undefined,
      currentEpoch: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromString */ .dK.fromString(object.current_epoch),
      currentEpochStartTime: object !== null && object !== void 0 && object.current_epoch_start_time ? _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_0__.Timestamp.fromAmino(object.current_epoch_start_time) : undefined,
      epochCountingStarted: object.epoch_counting_started,
      currentEpochStartHeight: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromString */ .dK.fromString(object.current_epoch_start_height)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.identifier = message.identifier;
    obj.start_time = message.startTime ? _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_0__.Timestamp.toAmino(message.startTime) : undefined;
    obj.duration = message.duration ? _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_1__.Duration.toAmino(message.duration) : undefined;
    obj.current_epoch = message.currentEpoch ? message.currentEpoch.toString() : undefined;
    obj.current_epoch_start_time = message.currentEpochStartTime ? _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_0__.Timestamp.toAmino(message.currentEpochStartTime) : undefined;
    obj.epoch_counting_started = message.epochCountingStarted;
    obj.current_epoch_start_height = message.currentEpochStartHeight ? message.currentEpochStartHeight.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return EpochInfo.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/epochs/epoch-info",
      value: EpochInfo.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return EpochInfo.decode(message.value);
  },

  toProto(message) {
    return EpochInfo.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.epochs.v1beta1.EpochInfo",
      value: EpochInfo.encode(message).finish()
    };
  }

};

function createBaseGenesisState() {
  return {
    epochs: []
  };
}

const GenesisState = {
  typeUrl: "/osmosis.epochs.v1beta1.GenesisState",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    for (const v of message.epochs) {
      EpochInfo.encode(v, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGenesisState();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.epochs.push(EpochInfo.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$epochs;

    const message = createBaseGenesisState();
    message.epochs = ((_object$epochs = object.epochs) === null || _object$epochs === void 0 ? void 0 : _object$epochs.map(e => EpochInfo.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      epochs: Array.isArray(object === null || object === void 0 ? void 0 : object.epochs) ? object.epochs.map(e => EpochInfo.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.epochs) {
      obj.epochs = message.epochs.map(e => e ? EpochInfo.toAmino(e) : undefined);
    } else {
      obj.epochs = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return GenesisState.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/epochs/genesis-state",
      value: GenesisState.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return GenesisState.decode(message.value);
  },

  toProto(message) {
    return GenesisState.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.epochs.v1beta1.GenesisState",
      value: GenesisState.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 19775:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QueryCurrentEpochRequest": function() { return /* binding */ QueryCurrentEpochRequest; },
/* harmony export */   "QueryCurrentEpochResponse": function() { return /* binding */ QueryCurrentEpochResponse; },
/* harmony export */   "QueryEpochsInfoRequest": function() { return /* binding */ QueryEpochsInfoRequest; },
/* harmony export */   "QueryEpochsInfoResponse": function() { return /* binding */ QueryEpochsInfoResponse; }
/* harmony export */ });
/* harmony import */ var _genesis__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54871);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47895);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__);




function createBaseQueryEpochsInfoRequest() {
  return {};
}

const QueryEpochsInfoRequest = {
  typeUrl: "/osmosis.epochs.v1beta1.QueryEpochsInfoRequest",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryEpochsInfoRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseQueryEpochsInfoRequest();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return QueryEpochsInfoRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/epochs/query-epochs-info-request",
      value: QueryEpochsInfoRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryEpochsInfoRequest.decode(message.value);
  },

  toProto(message) {
    return QueryEpochsInfoRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.epochs.v1beta1.QueryEpochsInfoRequest",
      value: QueryEpochsInfoRequest.encode(message).finish()
    };
  }

};

function createBaseQueryEpochsInfoResponse() {
  return {
    epochs: []
  };
}

const QueryEpochsInfoResponse = {
  typeUrl: "/osmosis.epochs.v1beta1.QueryEpochsInfoResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    for (const v of message.epochs) {
      _genesis__WEBPACK_IMPORTED_MODULE_0__.EpochInfo.encode(v, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryEpochsInfoResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.epochs.push(_genesis__WEBPACK_IMPORTED_MODULE_0__.EpochInfo.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$epochs;

    const message = createBaseQueryEpochsInfoResponse();
    message.epochs = ((_object$epochs = object.epochs) === null || _object$epochs === void 0 ? void 0 : _object$epochs.map(e => _genesis__WEBPACK_IMPORTED_MODULE_0__.EpochInfo.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      epochs: Array.isArray(object === null || object === void 0 ? void 0 : object.epochs) ? object.epochs.map(e => _genesis__WEBPACK_IMPORTED_MODULE_0__.EpochInfo.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.epochs) {
      obj.epochs = message.epochs.map(e => e ? _genesis__WEBPACK_IMPORTED_MODULE_0__.EpochInfo.toAmino(e) : undefined);
    } else {
      obj.epochs = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return QueryEpochsInfoResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/epochs/query-epochs-info-response",
      value: QueryEpochsInfoResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryEpochsInfoResponse.decode(message.value);
  },

  toProto(message) {
    return QueryEpochsInfoResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.epochs.v1beta1.QueryEpochsInfoResponse",
      value: QueryEpochsInfoResponse.encode(message).finish()
    };
  }

};

function createBaseQueryCurrentEpochRequest() {
  return {
    identifier: ""
  };
}

const QueryCurrentEpochRequest = {
  typeUrl: "/osmosis.epochs.v1beta1.QueryCurrentEpochRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (message.identifier !== "") {
      writer.uint32(10).string(message.identifier);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryCurrentEpochRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.identifier = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$identifier;

    const message = createBaseQueryCurrentEpochRequest();
    message.identifier = (_object$identifier = object.identifier) !== null && _object$identifier !== void 0 ? _object$identifier : "";
    return message;
  },

  fromAmino(object) {
    return {
      identifier: object.identifier
    };
  },

  toAmino(message) {
    const obj = {};
    obj.identifier = message.identifier;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryCurrentEpochRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/epochs/query-current-epoch-request",
      value: QueryCurrentEpochRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryCurrentEpochRequest.decode(message.value);
  },

  toProto(message) {
    return QueryCurrentEpochRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.epochs.v1beta1.QueryCurrentEpochRequest",
      value: QueryCurrentEpochRequest.encode(message).finish()
    };
  }

};

function createBaseQueryCurrentEpochResponse() {
  return {
    currentEpoch: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.ZERO */ .dK.ZERO
  };
}

const QueryCurrentEpochResponse = {
  typeUrl: "/osmosis.epochs.v1beta1.QueryCurrentEpochResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (!message.currentEpoch.isZero()) {
      writer.uint32(8).int64(message.currentEpoch);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryCurrentEpochResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.currentEpoch = reader.int64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseQueryCurrentEpochResponse();
    message.currentEpoch = object.currentEpoch !== undefined && object.currentEpoch !== null ? _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromValue */ .dK.fromValue(object.currentEpoch) : _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.ZERO */ .dK.ZERO;
    return message;
  },

  fromAmino(object) {
    return {
      currentEpoch: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromString */ .dK.fromString(object.current_epoch)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.current_epoch = message.currentEpoch ? message.currentEpoch.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryCurrentEpochResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/epochs/query-current-epoch-response",
      value: QueryCurrentEpochResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryCurrentEpochResponse.decode(message.value);
  },

  toProto(message) {
    return QueryCurrentEpochResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.epochs.v1beta1.QueryCurrentEpochResponse",
      value: QueryCurrentEpochResponse.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 35305:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LCDQueryClient": function() { return /* binding */ LCDQueryClient; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4942);

class LCDQueryClient {
  constructor({
    requestClient
  }) {
    (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, "req", void 0);

    this.req = requestClient;
    this.epochInfos = this.epochInfos.bind(this);
    this.currentEpoch = this.currentEpoch.bind(this);
  }
  /* EpochInfos provide running epochInfos */


  async epochInfos(_params = {}) {
    const endpoint = `osmosis/epochs/v1beta1/epochs`;
    return await this.req.get(endpoint);
  }
  /* CurrentEpoch provide current epoch of specified identifier */


  async currentEpoch(params) {
    const options = {
      params: {}
    };

    if (typeof (params === null || params === void 0 ? void 0 : params.identifier) !== "undefined") {
      options.params.identifier = params.identifier;
    }

    const endpoint = `osmosis/epochs/v1beta1/current_epoch`;
    return await this.req.get(endpoint, options);
  }

}

/***/ }),

/***/ 69163:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QueryClientImpl": function() { return /* binding */ QueryClientImpl; },
/* harmony export */   "createRpcQueryExtension": function() { return /* binding */ createRpcQueryExtension; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4942);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78441);
/* harmony import */ var _cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19775);




/** Query defines the gRPC querier service. */

class QueryClientImpl {
  constructor(rpc) {
    (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, "rpc", void 0);

    this.rpc = rpc;
    this.epochInfos = this.epochInfos.bind(this);
    this.currentEpoch = this.currentEpoch.bind(this);
  }

  epochInfos(request = {}) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryEpochsInfoRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.epochs.v1beta1.Query", "EpochInfos", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryEpochsInfoResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  currentEpoch(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryCurrentEpochRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.epochs.v1beta1.Query", "CurrentEpoch", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryCurrentEpochResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

}
const createRpcQueryExtension = base => {
  const rpc = (0,_cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1__.createProtobufRpcClient)(base);
  const queryService = new QueryClientImpl(rpc);
  return {
    epochInfos(request) {
      return queryService.epochInfos(request);
    },

    currentEpoch(request) {
      return queryService.currentEpoch(request);
    }

  };
};

/***/ }),

/***/ 4075:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Pool": function() { return /* binding */ Pool; },
/* harmony export */   "PoolAsset": function() { return /* binding */ PoolAsset; },
/* harmony export */   "PoolParams": function() { return /* binding */ PoolParams; },
/* harmony export */   "SmoothWeightChangeParams": function() { return /* binding */ SmoothWeightChangeParams; }
/* harmony export */ });
/* harmony import */ var _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20633);
/* harmony import */ var _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6499);
/* harmony import */ var _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26178);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47895);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__);





/**
 * Parameters for changing the weights in a balancer pool smoothly from
 * a start weight and end weight over a period of time.
 * Currently, the only smooth change supported is linear changing between
 * the two weights, but more types may be added in the future.
 * When these parameters are set, the weight w(t) for pool time `t` is the
 * following:
 *   t <= start_time: w(t) = initial_pool_weights
 *   start_time < t <= start_time + duration:
 *     w(t) = initial_pool_weights + (t - start_time) *
 *       (target_pool_weights - initial_pool_weights) / (duration)
 *   t > start_time + duration: w(t) = target_pool_weights
 */

function createBaseSmoothWeightChangeParams() {
  return {
    startTime: undefined,
    duration: undefined,
    initialPoolWeights: [],
    targetPoolWeights: []
  };
}

const SmoothWeightChangeParams = {
  typeUrl: "/osmosis.gamm.v1beta1.SmoothWeightChangeParams",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    if (message.startTime !== undefined) {
      _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_0__.Timestamp.encode((0,_helpers__WEBPACK_IMPORTED_MODULE_3__/* .toTimestamp */ .Uq)(message.startTime), writer.uint32(10).fork()).ldelim();
    }

    if (message.duration !== undefined) {
      _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_1__.Duration.encode(message.duration, writer.uint32(18).fork()).ldelim();
    }

    for (const v of message.initialPoolWeights) {
      PoolAsset.encode(v, writer.uint32(26).fork()).ldelim();
    }

    for (const v of message.targetPoolWeights) {
      PoolAsset.encode(v, writer.uint32(34).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSmoothWeightChangeParams();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.startTime = (0,_helpers__WEBPACK_IMPORTED_MODULE_3__/* .fromTimestamp */ .Ol)(_google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_0__.Timestamp.decode(reader, reader.uint32()));
          break;

        case 2:
          message.duration = _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_1__.Duration.decode(reader, reader.uint32());
          break;

        case 3:
          message.initialPoolWeights.push(PoolAsset.decode(reader, reader.uint32()));
          break;

        case 4:
          message.targetPoolWeights.push(PoolAsset.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$startTime, _object$initialPoolWe, _object$targetPoolWei;

    const message = createBaseSmoothWeightChangeParams();
    message.startTime = (_object$startTime = object.startTime) !== null && _object$startTime !== void 0 ? _object$startTime : undefined;
    message.duration = object.duration !== undefined && object.duration !== null ? _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_1__.Duration.fromPartial(object.duration) : undefined;
    message.initialPoolWeights = ((_object$initialPoolWe = object.initialPoolWeights) === null || _object$initialPoolWe === void 0 ? void 0 : _object$initialPoolWe.map(e => PoolAsset.fromPartial(e))) || [];
    message.targetPoolWeights = ((_object$targetPoolWei = object.targetPoolWeights) === null || _object$targetPoolWei === void 0 ? void 0 : _object$targetPoolWei.map(e => PoolAsset.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      startTime: object !== null && object !== void 0 && object.start_time ? _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_0__.Timestamp.fromAmino(object.start_time) : undefined,
      duration: object !== null && object !== void 0 && object.duration ? _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_1__.Duration.fromAmino(object.duration) : undefined,
      initialPoolWeights: Array.isArray(object === null || object === void 0 ? void 0 : object.initial_pool_weights) ? object.initial_pool_weights.map(e => PoolAsset.fromAmino(e)) : [],
      targetPoolWeights: Array.isArray(object === null || object === void 0 ? void 0 : object.target_pool_weights) ? object.target_pool_weights.map(e => PoolAsset.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.start_time = message.startTime ? _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_0__.Timestamp.toAmino(message.startTime) : undefined;
    obj.duration = message.duration ? _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_1__.Duration.toAmino(message.duration) : undefined;

    if (message.initialPoolWeights) {
      obj.initial_pool_weights = message.initialPoolWeights.map(e => e ? PoolAsset.toAmino(e) : undefined);
    } else {
      obj.initial_pool_weights = [];
    }

    if (message.targetPoolWeights) {
      obj.target_pool_weights = message.targetPoolWeights.map(e => e ? PoolAsset.toAmino(e) : undefined);
    } else {
      obj.target_pool_weights = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return SmoothWeightChangeParams.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/gamm/smooth-weight-change-params",
      value: SmoothWeightChangeParams.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return SmoothWeightChangeParams.decode(message.value);
  },

  toProto(message) {
    return SmoothWeightChangeParams.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.SmoothWeightChangeParams",
      value: SmoothWeightChangeParams.encode(message).finish()
    };
  }

};

function createBasePoolParams() {
  return {
    swapFee: "",
    exitFee: "",
    smoothWeightChangeParams: undefined
  };
}

const PoolParams = {
  typeUrl: "/osmosis.gamm.v1beta1.PoolParams",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    if (message.swapFee !== "") {
      writer.uint32(10).string(message.swapFee);
    }

    if (message.exitFee !== "") {
      writer.uint32(18).string(message.exitFee);
    }

    if (message.smoothWeightChangeParams !== undefined) {
      SmoothWeightChangeParams.encode(message.smoothWeightChangeParams, writer.uint32(26).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePoolParams();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.swapFee = reader.string();
          break;

        case 2:
          message.exitFee = reader.string();
          break;

        case 3:
          message.smoothWeightChangeParams = SmoothWeightChangeParams.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$swapFee, _object$exitFee;

    const message = createBasePoolParams();
    message.swapFee = (_object$swapFee = object.swapFee) !== null && _object$swapFee !== void 0 ? _object$swapFee : "";
    message.exitFee = (_object$exitFee = object.exitFee) !== null && _object$exitFee !== void 0 ? _object$exitFee : "";
    message.smoothWeightChangeParams = object.smoothWeightChangeParams !== undefined && object.smoothWeightChangeParams !== null ? SmoothWeightChangeParams.fromPartial(object.smoothWeightChangeParams) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      swapFee: object.swap_fee,
      exitFee: object.exit_fee,
      smoothWeightChangeParams: object !== null && object !== void 0 && object.smooth_weight_change_params ? SmoothWeightChangeParams.fromAmino(object.smooth_weight_change_params) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.swap_fee = message.swapFee;
    obj.exit_fee = message.exitFee;
    obj.smooth_weight_change_params = message.smoothWeightChangeParams ? SmoothWeightChangeParams.toAmino(message.smoothWeightChangeParams) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return PoolParams.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/gamm/BalancerPoolParams",
      value: PoolParams.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return PoolParams.decode(message.value);
  },

  toProto(message) {
    return PoolParams.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.PoolParams",
      value: PoolParams.encode(message).finish()
    };
  }

};

function createBasePoolAsset() {
  return {
    token: undefined,
    weight: ""
  };
}

const PoolAsset = {
  typeUrl: "/osmosis.gamm.v1beta1.PoolAsset",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    if (message.token !== undefined) {
      _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_2__.Coin.encode(message.token, writer.uint32(10).fork()).ldelim();
    }

    if (message.weight !== "") {
      writer.uint32(18).string(message.weight);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePoolAsset();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.token = _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_2__.Coin.decode(reader, reader.uint32());
          break;

        case 2:
          message.weight = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$weight;

    const message = createBasePoolAsset();
    message.token = object.token !== undefined && object.token !== null ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_2__.Coin.fromPartial(object.token) : undefined;
    message.weight = (_object$weight = object.weight) !== null && _object$weight !== void 0 ? _object$weight : "";
    return message;
  },

  fromAmino(object) {
    return {
      token: object !== null && object !== void 0 && object.token ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_2__.Coin.fromAmino(object.token) : undefined,
      weight: object.weight
    };
  },

  toAmino(message) {
    const obj = {};
    obj.token = message.token ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_2__.Coin.toAmino(message.token) : undefined;
    obj.weight = message.weight;
    return obj;
  },

  fromAminoMsg(object) {
    return PoolAsset.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/gamm/pool-asset",
      value: PoolAsset.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return PoolAsset.decode(message.value);
  },

  toProto(message) {
    return PoolAsset.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.PoolAsset",
      value: PoolAsset.encode(message).finish()
    };
  }

};

function createBasePool() {
  return {
    $typeUrl: "/osmosis.gamm.v1beta1.Pool",
    address: "",
    id: _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.UZERO */ .dK.UZERO,
    poolParams: undefined,
    futurePoolGovernor: "",
    totalShares: undefined,
    poolAssets: [],
    totalWeight: ""
  };
}

const Pool = {
  typeUrl: "/osmosis.gamm.v1beta1.Pool",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    if (message.address !== "") {
      writer.uint32(10).string(message.address);
    }

    if (!message.id.isZero()) {
      writer.uint32(16).uint64(message.id);
    }

    if (message.poolParams !== undefined) {
      PoolParams.encode(message.poolParams, writer.uint32(26).fork()).ldelim();
    }

    if (message.futurePoolGovernor !== "") {
      writer.uint32(34).string(message.futurePoolGovernor);
    }

    if (message.totalShares !== undefined) {
      _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_2__.Coin.encode(message.totalShares, writer.uint32(42).fork()).ldelim();
    }

    for (const v of message.poolAssets) {
      PoolAsset.encode(v, writer.uint32(50).fork()).ldelim();
    }

    if (message.totalWeight !== "") {
      writer.uint32(58).string(message.totalWeight);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePool();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.address = reader.string();
          break;

        case 2:
          message.id = reader.uint64();
          break;

        case 3:
          message.poolParams = PoolParams.decode(reader, reader.uint32());
          break;

        case 4:
          message.futurePoolGovernor = reader.string();
          break;

        case 5:
          message.totalShares = _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_2__.Coin.decode(reader, reader.uint32());
          break;

        case 6:
          message.poolAssets.push(PoolAsset.decode(reader, reader.uint32()));
          break;

        case 7:
          message.totalWeight = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$address, _object$futurePoolGov, _object$poolAssets, _object$totalWeight;

    const message = createBasePool();
    message.address = (_object$address = object.address) !== null && _object$address !== void 0 ? _object$address : "";
    message.id = object.id !== undefined && object.id !== null ? _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.fromValue */ .dK.fromValue(object.id) : _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.UZERO */ .dK.UZERO;
    message.poolParams = object.poolParams !== undefined && object.poolParams !== null ? PoolParams.fromPartial(object.poolParams) : undefined;
    message.futurePoolGovernor = (_object$futurePoolGov = object.futurePoolGovernor) !== null && _object$futurePoolGov !== void 0 ? _object$futurePoolGov : "";
    message.totalShares = object.totalShares !== undefined && object.totalShares !== null ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_2__.Coin.fromPartial(object.totalShares) : undefined;
    message.poolAssets = ((_object$poolAssets = object.poolAssets) === null || _object$poolAssets === void 0 ? void 0 : _object$poolAssets.map(e => PoolAsset.fromPartial(e))) || [];
    message.totalWeight = (_object$totalWeight = object.totalWeight) !== null && _object$totalWeight !== void 0 ? _object$totalWeight : "";
    return message;
  },

  fromAmino(object) {
    return {
      address: object.address,
      id: _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.fromString */ .dK.fromString(object.id),
      poolParams: object !== null && object !== void 0 && object.pool_params ? PoolParams.fromAmino(object.pool_params) : undefined,
      futurePoolGovernor: object.future_pool_governor,
      totalShares: object !== null && object !== void 0 && object.total_shares ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_2__.Coin.fromAmino(object.total_shares) : undefined,
      poolAssets: Array.isArray(object === null || object === void 0 ? void 0 : object.pool_assets) ? object.pool_assets.map(e => PoolAsset.fromAmino(e)) : [],
      totalWeight: object.total_weight
    };
  },

  toAmino(message) {
    const obj = {};
    obj.address = message.address;
    obj.id = message.id ? message.id.toString() : undefined;
    obj.pool_params = message.poolParams ? PoolParams.toAmino(message.poolParams) : undefined;
    obj.future_pool_governor = message.futurePoolGovernor;
    obj.total_shares = message.totalShares ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_2__.Coin.toAmino(message.totalShares) : undefined;

    if (message.poolAssets) {
      obj.pool_assets = message.poolAssets.map(e => e ? PoolAsset.toAmino(e) : undefined);
    } else {
      obj.pool_assets = [];
    }

    obj.total_weight = message.totalWeight;
    return obj;
  },

  fromAminoMsg(object) {
    return Pool.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/gamm/BalancerPool",
      value: Pool.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return Pool.decode(message.value);
  },

  toProto(message) {
    return Pool.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.Pool",
      value: Pool.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 48858:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MsgCreateBalancerPool": function() { return /* binding */ MsgCreateBalancerPool; },
/* harmony export */   "MsgCreateBalancerPoolResponse": function() { return /* binding */ MsgCreateBalancerPoolResponse; }
/* harmony export */ });
/* harmony import */ var _balancerPool__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4075);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47895);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__);



/** ===================== MsgCreatePool */

function createBaseMsgCreateBalancerPool() {
  return {
    sender: "",
    poolParams: undefined,
    poolAssets: [],
    futurePoolGovernor: ""
  };
}

const MsgCreateBalancerPool = {
  typeUrl: "/osmosis.gamm.poolmodels.balancer.v1beta1.MsgCreateBalancerPool",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (message.sender !== "") {
      writer.uint32(10).string(message.sender);
    }

    if (message.poolParams !== undefined) {
      _balancerPool__WEBPACK_IMPORTED_MODULE_0__.PoolParams.encode(message.poolParams, writer.uint32(18).fork()).ldelim();
    }

    for (const v of message.poolAssets) {
      _balancerPool__WEBPACK_IMPORTED_MODULE_0__.PoolAsset.encode(v, writer.uint32(26).fork()).ldelim();
    }

    if (message.futurePoolGovernor !== "") {
      writer.uint32(34).string(message.futurePoolGovernor);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgCreateBalancerPool();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.sender = reader.string();
          break;

        case 2:
          message.poolParams = _balancerPool__WEBPACK_IMPORTED_MODULE_0__.PoolParams.decode(reader, reader.uint32());
          break;

        case 3:
          message.poolAssets.push(_balancerPool__WEBPACK_IMPORTED_MODULE_0__.PoolAsset.decode(reader, reader.uint32()));
          break;

        case 4:
          message.futurePoolGovernor = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$sender, _object$poolAssets, _object$futurePoolGov;

    const message = createBaseMsgCreateBalancerPool();
    message.sender = (_object$sender = object.sender) !== null && _object$sender !== void 0 ? _object$sender : "";
    message.poolParams = object.poolParams !== undefined && object.poolParams !== null ? _balancerPool__WEBPACK_IMPORTED_MODULE_0__.PoolParams.fromPartial(object.poolParams) : undefined;
    message.poolAssets = ((_object$poolAssets = object.poolAssets) === null || _object$poolAssets === void 0 ? void 0 : _object$poolAssets.map(e => _balancerPool__WEBPACK_IMPORTED_MODULE_0__.PoolAsset.fromPartial(e))) || [];
    message.futurePoolGovernor = (_object$futurePoolGov = object.futurePoolGovernor) !== null && _object$futurePoolGov !== void 0 ? _object$futurePoolGov : "";
    return message;
  },

  fromAmino(object) {
    return {
      sender: object.sender,
      poolParams: object !== null && object !== void 0 && object.pool_params ? _balancerPool__WEBPACK_IMPORTED_MODULE_0__.PoolParams.fromAmino(object.pool_params) : undefined,
      poolAssets: Array.isArray(object === null || object === void 0 ? void 0 : object.pool_assets) ? object.pool_assets.map(e => _balancerPool__WEBPACK_IMPORTED_MODULE_0__.PoolAsset.fromAmino(e)) : [],
      futurePoolGovernor: object.future_pool_governor
    };
  },

  toAmino(message) {
    const obj = {};
    obj.sender = message.sender;
    obj.pool_params = message.poolParams ? _balancerPool__WEBPACK_IMPORTED_MODULE_0__.PoolParams.toAmino(message.poolParams) : undefined;

    if (message.poolAssets) {
      obj.pool_assets = message.poolAssets.map(e => e ? _balancerPool__WEBPACK_IMPORTED_MODULE_0__.PoolAsset.toAmino(e) : undefined);
    } else {
      obj.pool_assets = [];
    }

    obj.future_pool_governor = message.futurePoolGovernor;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgCreateBalancerPool.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/gamm/create-balancer-pool",
      value: MsgCreateBalancerPool.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgCreateBalancerPool.decode(message.value);
  },

  toProto(message) {
    return MsgCreateBalancerPool.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.gamm.poolmodels.balancer.v1beta1.MsgCreateBalancerPool",
      value: MsgCreateBalancerPool.encode(message).finish()
    };
  }

};

function createBaseMsgCreateBalancerPoolResponse() {
  return {
    poolId: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.UZERO */ .dK.UZERO
  };
}

const MsgCreateBalancerPoolResponse = {
  typeUrl: "/osmosis.gamm.poolmodels.balancer.v1beta1.MsgCreateBalancerPoolResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (!message.poolId.isZero()) {
      writer.uint32(8).uint64(message.poolId);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgCreateBalancerPoolResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.poolId = reader.uint64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseMsgCreateBalancerPoolResponse();
    message.poolId = object.poolId !== undefined && object.poolId !== null ? _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromValue */ .dK.fromValue(object.poolId) : _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.UZERO */ .dK.UZERO;
    return message;
  },

  fromAmino(object) {
    return {
      poolId: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromString */ .dK.fromString(object.pool_id)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.pool_id = message.poolId ? message.poolId.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgCreateBalancerPoolResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/gamm/poolmodels/balancer/create-balancer-pool-response",
      value: MsgCreateBalancerPoolResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgCreateBalancerPoolResponse.decode(message.value);
  },

  toProto(message) {
    return MsgCreateBalancerPoolResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.gamm.poolmodels.balancer.v1beta1.MsgCreateBalancerPoolResponse",
      value: MsgCreateBalancerPoolResponse.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 62360:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MsgClientImpl": function() { return /* binding */ MsgClientImpl; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4942);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _tx__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48858);



class MsgClientImpl {
  constructor(rpc) {
    (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, "rpc", void 0);

    this.rpc = rpc;
    this.createBalancerPool = this.createBalancerPool.bind(this);
  }

  createBalancerPool(request) {
    const data = _tx__WEBPACK_IMPORTED_MODULE_1__.MsgCreateBalancerPool.encode(request).finish();
    const promise = this.rpc.request("osmosis.gamm.poolmodels.balancer.v1beta1.Msg", "CreateBalancerPool", data);
    return promise.then(data => _tx__WEBPACK_IMPORTED_MODULE_1__.MsgCreateBalancerPoolResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

}

/***/ }),

/***/ 66761:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Pool": function() { return /* binding */ Pool; },
/* harmony export */   "PoolParams": function() { return /* binding */ PoolParams; }
/* harmony export */ });
/* harmony import */ var _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26178);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47895);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__);



/**
 * PoolParams defined the parameters that will be managed by the pool
 * governance in the future. This params are not managed by the chain
 * governance. Instead they will be managed by the token holders of the pool.
 * The pool's token holders are specified in future_pool_governor.
 */

function createBasePoolParams() {
  return {
    swapFee: "",
    exitFee: ""
  };
}

const PoolParams = {
  typeUrl: "/osmosis.gamm.poolmodels.stableswap.v1beta1.PoolParams",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (message.swapFee !== "") {
      writer.uint32(10).string(message.swapFee);
    }

    if (message.exitFee !== "") {
      writer.uint32(18).string(message.exitFee);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePoolParams();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.swapFee = reader.string();
          break;

        case 2:
          message.exitFee = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$swapFee, _object$exitFee;

    const message = createBasePoolParams();
    message.swapFee = (_object$swapFee = object.swapFee) !== null && _object$swapFee !== void 0 ? _object$swapFee : "";
    message.exitFee = (_object$exitFee = object.exitFee) !== null && _object$exitFee !== void 0 ? _object$exitFee : "";
    return message;
  },

  fromAmino(object) {
    return {
      swapFee: object.swap_fee,
      exitFee: object.exit_fee
    };
  },

  toAmino(message) {
    const obj = {};
    obj.swap_fee = message.swapFee;
    obj.exit_fee = message.exitFee;
    return obj;
  },

  fromAminoMsg(object) {
    return PoolParams.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/gamm/StableswapPoolParams",
      value: PoolParams.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return PoolParams.decode(message.value);
  },

  toProto(message) {
    return PoolParams.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.gamm.poolmodels.stableswap.v1beta1.PoolParams",
      value: PoolParams.encode(message).finish()
    };
  }

};

function createBasePool() {
  return {
    $typeUrl: "/osmosis.gamm.poolmodels.stableswap.v1beta1.Pool",
    address: "",
    id: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.UZERO */ .dK.UZERO,
    poolParams: undefined,
    futurePoolGovernor: "",
    totalShares: undefined,
    poolLiquidity: [],
    scalingFactors: [],
    scalingFactorController: ""
  };
}

const Pool = {
  typeUrl: "/osmosis.gamm.poolmodels.stableswap.v1beta1.Pool",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (message.address !== "") {
      writer.uint32(10).string(message.address);
    }

    if (!message.id.isZero()) {
      writer.uint32(16).uint64(message.id);
    }

    if (message.poolParams !== undefined) {
      PoolParams.encode(message.poolParams, writer.uint32(26).fork()).ldelim();
    }

    if (message.futurePoolGovernor !== "") {
      writer.uint32(34).string(message.futurePoolGovernor);
    }

    if (message.totalShares !== undefined) {
      _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.encode(message.totalShares, writer.uint32(42).fork()).ldelim();
    }

    for (const v of message.poolLiquidity) {
      _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.encode(v, writer.uint32(50).fork()).ldelim();
    }

    writer.uint32(58).fork();

    for (const v of message.scalingFactors) {
      writer.uint64(v);
    }

    writer.ldelim();

    if (message.scalingFactorController !== "") {
      writer.uint32(66).string(message.scalingFactorController);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePool();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.address = reader.string();
          break;

        case 2:
          message.id = reader.uint64();
          break;

        case 3:
          message.poolParams = PoolParams.decode(reader, reader.uint32());
          break;

        case 4:
          message.futurePoolGovernor = reader.string();
          break;

        case 5:
          message.totalShares = _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.decode(reader, reader.uint32());
          break;

        case 6:
          message.poolLiquidity.push(_cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.decode(reader, reader.uint32()));
          break;

        case 7:
          if ((tag & 7) === 2) {
            const end2 = reader.uint32() + reader.pos;

            while (reader.pos < end2) {
              message.scalingFactors.push(reader.uint64());
            }
          } else {
            message.scalingFactors.push(reader.uint64());
          }

          break;

        case 8:
          message.scalingFactorController = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$address, _object$futurePoolGov, _object$poolLiquidity, _object$scalingFactor, _object$scalingFactor2;

    const message = createBasePool();
    message.address = (_object$address = object.address) !== null && _object$address !== void 0 ? _object$address : "";
    message.id = object.id !== undefined && object.id !== null ? _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromValue */ .dK.fromValue(object.id) : _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.UZERO */ .dK.UZERO;
    message.poolParams = object.poolParams !== undefined && object.poolParams !== null ? PoolParams.fromPartial(object.poolParams) : undefined;
    message.futurePoolGovernor = (_object$futurePoolGov = object.futurePoolGovernor) !== null && _object$futurePoolGov !== void 0 ? _object$futurePoolGov : "";
    message.totalShares = object.totalShares !== undefined && object.totalShares !== null ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.fromPartial(object.totalShares) : undefined;
    message.poolLiquidity = ((_object$poolLiquidity = object.poolLiquidity) === null || _object$poolLiquidity === void 0 ? void 0 : _object$poolLiquidity.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.fromPartial(e))) || [];
    message.scalingFactors = ((_object$scalingFactor = object.scalingFactors) === null || _object$scalingFactor === void 0 ? void 0 : _object$scalingFactor.map(e => _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromValue */ .dK.fromValue(e))) || [];
    message.scalingFactorController = (_object$scalingFactor2 = object.scalingFactorController) !== null && _object$scalingFactor2 !== void 0 ? _object$scalingFactor2 : "";
    return message;
  },

  fromAmino(object) {
    return {
      address: object.address,
      id: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromString */ .dK.fromString(object.id),
      poolParams: object !== null && object !== void 0 && object.pool_params ? PoolParams.fromAmino(object.pool_params) : undefined,
      futurePoolGovernor: object.future_pool_governor,
      totalShares: object !== null && object !== void 0 && object.total_shares ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.fromAmino(object.total_shares) : undefined,
      poolLiquidity: Array.isArray(object === null || object === void 0 ? void 0 : object.pool_liquidity) ? object.pool_liquidity.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.fromAmino(e)) : [],
      scalingFactors: Array.isArray(object === null || object === void 0 ? void 0 : object.scaling_factors) ? object.scaling_factors.map(e => e) : [],
      scalingFactorController: object.scaling_factor_controller
    };
  },

  toAmino(message) {
    const obj = {};
    obj.address = message.address;
    obj.id = message.id ? message.id.toString() : undefined;
    obj.pool_params = message.poolParams ? PoolParams.toAmino(message.poolParams) : undefined;
    obj.future_pool_governor = message.futurePoolGovernor;
    obj.total_shares = message.totalShares ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.toAmino(message.totalShares) : undefined;

    if (message.poolLiquidity) {
      obj.pool_liquidity = message.poolLiquidity.map(e => e ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.toAmino(e) : undefined);
    } else {
      obj.pool_liquidity = [];
    }

    if (message.scalingFactors) {
      obj.scaling_factors = message.scalingFactors.map(e => e);
    } else {
      obj.scaling_factors = [];
    }

    obj.scaling_factor_controller = message.scalingFactorController;
    return obj;
  },

  fromAminoMsg(object) {
    return Pool.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/gamm/StableswapPool",
      value: Pool.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return Pool.decode(message.value);
  },

  toProto(message) {
    return Pool.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.gamm.poolmodels.stableswap.v1beta1.Pool",
      value: Pool.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 9195:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MsgCreateStableswapPool": function() { return /* binding */ MsgCreateStableswapPool; },
/* harmony export */   "MsgCreateStableswapPoolResponse": function() { return /* binding */ MsgCreateStableswapPoolResponse; },
/* harmony export */   "MsgStableSwapAdjustScalingFactors": function() { return /* binding */ MsgStableSwapAdjustScalingFactors; },
/* harmony export */   "MsgStableSwapAdjustScalingFactorsResponse": function() { return /* binding */ MsgStableSwapAdjustScalingFactorsResponse; }
/* harmony export */ });
/* harmony import */ var _stableswap_pool__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66761);
/* harmony import */ var _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26178);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47895);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__);




/** ===================== MsgCreatePool */

function createBaseMsgCreateStableswapPool() {
  return {
    sender: "",
    poolParams: undefined,
    initialPoolLiquidity: [],
    scalingFactors: [],
    futurePoolGovernor: "",
    scalingFactorController: ""
  };
}

const MsgCreateStableswapPool = {
  typeUrl: "/osmosis.gamm.poolmodels.stableswap.v1beta1.MsgCreateStableswapPool",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.sender !== "") {
      writer.uint32(10).string(message.sender);
    }

    if (message.poolParams !== undefined) {
      _stableswap_pool__WEBPACK_IMPORTED_MODULE_0__.PoolParams.encode(message.poolParams, writer.uint32(18).fork()).ldelim();
    }

    for (const v of message.initialPoolLiquidity) {
      _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.encode(v, writer.uint32(26).fork()).ldelim();
    }

    writer.uint32(34).fork();

    for (const v of message.scalingFactors) {
      writer.uint64(v);
    }

    writer.ldelim();

    if (message.futurePoolGovernor !== "") {
      writer.uint32(42).string(message.futurePoolGovernor);
    }

    if (message.scalingFactorController !== "") {
      writer.uint32(50).string(message.scalingFactorController);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgCreateStableswapPool();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.sender = reader.string();
          break;

        case 2:
          message.poolParams = _stableswap_pool__WEBPACK_IMPORTED_MODULE_0__.PoolParams.decode(reader, reader.uint32());
          break;

        case 3:
          message.initialPoolLiquidity.push(_cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.decode(reader, reader.uint32()));
          break;

        case 4:
          if ((tag & 7) === 2) {
            const end2 = reader.uint32() + reader.pos;

            while (reader.pos < end2) {
              message.scalingFactors.push(reader.uint64());
            }
          } else {
            message.scalingFactors.push(reader.uint64());
          }

          break;

        case 5:
          message.futurePoolGovernor = reader.string();
          break;

        case 6:
          message.scalingFactorController = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$sender, _object$initialPoolLi, _object$scalingFactor, _object$futurePoolGov, _object$scalingFactor2;

    const message = createBaseMsgCreateStableswapPool();
    message.sender = (_object$sender = object.sender) !== null && _object$sender !== void 0 ? _object$sender : "";
    message.poolParams = object.poolParams !== undefined && object.poolParams !== null ? _stableswap_pool__WEBPACK_IMPORTED_MODULE_0__.PoolParams.fromPartial(object.poolParams) : undefined;
    message.initialPoolLiquidity = ((_object$initialPoolLi = object.initialPoolLiquidity) === null || _object$initialPoolLi === void 0 ? void 0 : _object$initialPoolLi.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.fromPartial(e))) || [];
    message.scalingFactors = ((_object$scalingFactor = object.scalingFactors) === null || _object$scalingFactor === void 0 ? void 0 : _object$scalingFactor.map(e => _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromValue */ .dK.fromValue(e))) || [];
    message.futurePoolGovernor = (_object$futurePoolGov = object.futurePoolGovernor) !== null && _object$futurePoolGov !== void 0 ? _object$futurePoolGov : "";
    message.scalingFactorController = (_object$scalingFactor2 = object.scalingFactorController) !== null && _object$scalingFactor2 !== void 0 ? _object$scalingFactor2 : "";
    return message;
  },

  fromAmino(object) {
    return {
      sender: object.sender,
      poolParams: object !== null && object !== void 0 && object.pool_params ? _stableswap_pool__WEBPACK_IMPORTED_MODULE_0__.PoolParams.fromAmino(object.pool_params) : undefined,
      initialPoolLiquidity: Array.isArray(object === null || object === void 0 ? void 0 : object.initial_pool_liquidity) ? object.initial_pool_liquidity.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.fromAmino(e)) : [],
      scalingFactors: Array.isArray(object === null || object === void 0 ? void 0 : object.scaling_factors) ? object.scaling_factors.map(e => e) : [],
      futurePoolGovernor: object.future_pool_governor,
      scalingFactorController: object.scaling_factor_controller
    };
  },

  toAmino(message) {
    const obj = {};
    obj.sender = message.sender;
    obj.pool_params = message.poolParams ? _stableswap_pool__WEBPACK_IMPORTED_MODULE_0__.PoolParams.toAmino(message.poolParams) : undefined;

    if (message.initialPoolLiquidity) {
      obj.initial_pool_liquidity = message.initialPoolLiquidity.map(e => e ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.toAmino(e) : undefined);
    } else {
      obj.initial_pool_liquidity = [];
    }

    if (message.scalingFactors) {
      obj.scaling_factors = message.scalingFactors.map(e => e);
    } else {
      obj.scaling_factors = [];
    }

    obj.future_pool_governor = message.futurePoolGovernor;
    obj.scaling_factor_controller = message.scalingFactorController;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgCreateStableswapPool.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/gamm/create-stableswap-pool",
      value: MsgCreateStableswapPool.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgCreateStableswapPool.decode(message.value);
  },

  toProto(message) {
    return MsgCreateStableswapPool.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.gamm.poolmodels.stableswap.v1beta1.MsgCreateStableswapPool",
      value: MsgCreateStableswapPool.encode(message).finish()
    };
  }

};

function createBaseMsgCreateStableswapPoolResponse() {
  return {
    poolId: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO
  };
}

const MsgCreateStableswapPoolResponse = {
  typeUrl: "/osmosis.gamm.poolmodels.stableswap.v1beta1.MsgCreateStableswapPoolResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (!message.poolId.isZero()) {
      writer.uint32(8).uint64(message.poolId);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgCreateStableswapPoolResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.poolId = reader.uint64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseMsgCreateStableswapPoolResponse();
    message.poolId = object.poolId !== undefined && object.poolId !== null ? _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromValue */ .dK.fromValue(object.poolId) : _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO;
    return message;
  },

  fromAmino(object) {
    return {
      poolId: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromString */ .dK.fromString(object.pool_id)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.pool_id = message.poolId ? message.poolId.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgCreateStableswapPoolResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/gamm/create-stableswap-pool-response",
      value: MsgCreateStableswapPoolResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgCreateStableswapPoolResponse.decode(message.value);
  },

  toProto(message) {
    return MsgCreateStableswapPoolResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.gamm.poolmodels.stableswap.v1beta1.MsgCreateStableswapPoolResponse",
      value: MsgCreateStableswapPoolResponse.encode(message).finish()
    };
  }

};

function createBaseMsgStableSwapAdjustScalingFactors() {
  return {
    sender: "",
    poolId: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO,
    scalingFactors: []
  };
}

const MsgStableSwapAdjustScalingFactors = {
  typeUrl: "/osmosis.gamm.poolmodels.stableswap.v1beta1.MsgStableSwapAdjustScalingFactors",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.sender !== "") {
      writer.uint32(10).string(message.sender);
    }

    if (!message.poolId.isZero()) {
      writer.uint32(16).uint64(message.poolId);
    }

    writer.uint32(26).fork();

    for (const v of message.scalingFactors) {
      writer.uint64(v);
    }

    writer.ldelim();
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgStableSwapAdjustScalingFactors();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.sender = reader.string();
          break;

        case 2:
          message.poolId = reader.uint64();
          break;

        case 3:
          if ((tag & 7) === 2) {
            const end2 = reader.uint32() + reader.pos;

            while (reader.pos < end2) {
              message.scalingFactors.push(reader.uint64());
            }
          } else {
            message.scalingFactors.push(reader.uint64());
          }

          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$sender2, _object$scalingFactor3;

    const message = createBaseMsgStableSwapAdjustScalingFactors();
    message.sender = (_object$sender2 = object.sender) !== null && _object$sender2 !== void 0 ? _object$sender2 : "";
    message.poolId = object.poolId !== undefined && object.poolId !== null ? _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromValue */ .dK.fromValue(object.poolId) : _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO;
    message.scalingFactors = ((_object$scalingFactor3 = object.scalingFactors) === null || _object$scalingFactor3 === void 0 ? void 0 : _object$scalingFactor3.map(e => _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromValue */ .dK.fromValue(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      sender: object.sender,
      poolId: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromString */ .dK.fromString(object.pool_id),
      scalingFactors: Array.isArray(object === null || object === void 0 ? void 0 : object.scaling_factors) ? object.scaling_factors.map(e => e) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.sender = message.sender;
    obj.pool_id = message.poolId ? message.poolId.toString() : undefined;

    if (message.scalingFactors) {
      obj.scaling_factors = message.scalingFactors.map(e => e);
    } else {
      obj.scaling_factors = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return MsgStableSwapAdjustScalingFactors.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/gamm/stableswap-adjust-scaling-factors",
      value: MsgStableSwapAdjustScalingFactors.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgStableSwapAdjustScalingFactors.decode(message.value);
  },

  toProto(message) {
    return MsgStableSwapAdjustScalingFactors.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.gamm.poolmodels.stableswap.v1beta1.MsgStableSwapAdjustScalingFactors",
      value: MsgStableSwapAdjustScalingFactors.encode(message).finish()
    };
  }

};

function createBaseMsgStableSwapAdjustScalingFactorsResponse() {
  return {};
}

const MsgStableSwapAdjustScalingFactorsResponse = {
  typeUrl: "/osmosis.gamm.poolmodels.stableswap.v1beta1.MsgStableSwapAdjustScalingFactorsResponse",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgStableSwapAdjustScalingFactorsResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseMsgStableSwapAdjustScalingFactorsResponse();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return MsgStableSwapAdjustScalingFactorsResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/gamm/stable-swap-adjust-scaling-factors-response",
      value: MsgStableSwapAdjustScalingFactorsResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgStableSwapAdjustScalingFactorsResponse.decode(message.value);
  },

  toProto(message) {
    return MsgStableSwapAdjustScalingFactorsResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.gamm.poolmodels.stableswap.v1beta1.MsgStableSwapAdjustScalingFactorsResponse",
      value: MsgStableSwapAdjustScalingFactorsResponse.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 37343:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MsgClientImpl": function() { return /* binding */ MsgClientImpl; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4942);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _tx__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9195);



class MsgClientImpl {
  constructor(rpc) {
    (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, "rpc", void 0);

    this.rpc = rpc;
    this.createStableswapPool = this.createStableswapPool.bind(this);
    this.stableSwapAdjustScalingFactors = this.stableSwapAdjustScalingFactors.bind(this);
  }

  createStableswapPool(request) {
    const data = _tx__WEBPACK_IMPORTED_MODULE_1__.MsgCreateStableswapPool.encode(request).finish();
    const promise = this.rpc.request("osmosis.gamm.poolmodels.stableswap.v1beta1.Msg", "CreateStableswapPool", data);
    return promise.then(data => _tx__WEBPACK_IMPORTED_MODULE_1__.MsgCreateStableswapPoolResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  stableSwapAdjustScalingFactors(request) {
    const data = _tx__WEBPACK_IMPORTED_MODULE_1__.MsgStableSwapAdjustScalingFactors.encode(request).finish();
    const promise = this.rpc.request("osmosis.gamm.poolmodels.stableswap.v1beta1.Msg", "StableSwapAdjustScalingFactors", data);
    return promise.then(data => _tx__WEBPACK_IMPORTED_MODULE_1__.MsgStableSwapAdjustScalingFactorsResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

}

/***/ }),

/***/ 1126:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "PoolI_FromAmino": function() { return /* binding */ PoolI_FromAmino; },
/* harmony export */   "PoolI_InterfaceDecoder": function() { return /* binding */ PoolI_InterfaceDecoder; },
/* harmony export */   "PoolI_ToAmino": function() { return /* binding */ PoolI_ToAmino; },
/* harmony export */   "QueryCalcExitPoolCoinsFromSharesRequest": function() { return /* binding */ QueryCalcExitPoolCoinsFromSharesRequest; },
/* harmony export */   "QueryCalcExitPoolCoinsFromSharesResponse": function() { return /* binding */ QueryCalcExitPoolCoinsFromSharesResponse; },
/* harmony export */   "QueryCalcJoinPoolNoSwapSharesRequest": function() { return /* binding */ QueryCalcJoinPoolNoSwapSharesRequest; },
/* harmony export */   "QueryCalcJoinPoolNoSwapSharesResponse": function() { return /* binding */ QueryCalcJoinPoolNoSwapSharesResponse; },
/* harmony export */   "QueryCalcJoinPoolSharesRequest": function() { return /* binding */ QueryCalcJoinPoolSharesRequest; },
/* harmony export */   "QueryCalcJoinPoolSharesResponse": function() { return /* binding */ QueryCalcJoinPoolSharesResponse; },
/* harmony export */   "QueryConcentratedPoolIdLinkFromCFMMRequest": function() { return /* binding */ QueryConcentratedPoolIdLinkFromCFMMRequest; },
/* harmony export */   "QueryConcentratedPoolIdLinkFromCFMMResponse": function() { return /* binding */ QueryConcentratedPoolIdLinkFromCFMMResponse; },
/* harmony export */   "QueryNumPoolsRequest": function() { return /* binding */ QueryNumPoolsRequest; },
/* harmony export */   "QueryNumPoolsResponse": function() { return /* binding */ QueryNumPoolsResponse; },
/* harmony export */   "QueryPoolParamsRequest": function() { return /* binding */ QueryPoolParamsRequest; },
/* harmony export */   "QueryPoolParamsResponse": function() { return /* binding */ QueryPoolParamsResponse; },
/* harmony export */   "QueryPoolRequest": function() { return /* binding */ QueryPoolRequest; },
/* harmony export */   "QueryPoolResponse": function() { return /* binding */ QueryPoolResponse; },
/* harmony export */   "QueryPoolTypeRequest": function() { return /* binding */ QueryPoolTypeRequest; },
/* harmony export */   "QueryPoolTypeResponse": function() { return /* binding */ QueryPoolTypeResponse; },
/* harmony export */   "QueryPoolsRequest": function() { return /* binding */ QueryPoolsRequest; },
/* harmony export */   "QueryPoolsResponse": function() { return /* binding */ QueryPoolsResponse; },
/* harmony export */   "QueryPoolsWithFilterRequest": function() { return /* binding */ QueryPoolsWithFilterRequest; },
/* harmony export */   "QueryPoolsWithFilterResponse": function() { return /* binding */ QueryPoolsWithFilterResponse; },
/* harmony export */   "QuerySpotPriceRequest": function() { return /* binding */ QuerySpotPriceRequest; },
/* harmony export */   "QuerySpotPriceResponse": function() { return /* binding */ QuerySpotPriceResponse; },
/* harmony export */   "QuerySwapExactAmountInRequest": function() { return /* binding */ QuerySwapExactAmountInRequest; },
/* harmony export */   "QuerySwapExactAmountInResponse": function() { return /* binding */ QuerySwapExactAmountInResponse; },
/* harmony export */   "QuerySwapExactAmountOutRequest": function() { return /* binding */ QuerySwapExactAmountOutRequest; },
/* harmony export */   "QuerySwapExactAmountOutResponse": function() { return /* binding */ QuerySwapExactAmountOutResponse; },
/* harmony export */   "QueryTotalLiquidityRequest": function() { return /* binding */ QueryTotalLiquidityRequest; },
/* harmony export */   "QueryTotalLiquidityResponse": function() { return /* binding */ QueryTotalLiquidityResponse; },
/* harmony export */   "QueryTotalPoolLiquidityRequest": function() { return /* binding */ QueryTotalPoolLiquidityRequest; },
/* harmony export */   "QueryTotalPoolLiquidityResponse": function() { return /* binding */ QueryTotalPoolLiquidityResponse; },
/* harmony export */   "QueryTotalSharesRequest": function() { return /* binding */ QueryTotalSharesRequest; },
/* harmony export */   "QueryTotalSharesResponse": function() { return /* binding */ QueryTotalSharesResponse; }
/* harmony export */ });
/* harmony import */ var _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48978);
/* harmony import */ var _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26178);
/* harmony import */ var _poolmanager_v1beta1_swap_route__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23569);
/* harmony import */ var _google_protobuf_any__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32106);
/* harmony import */ var _concentrated_liquidity_pool__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4343);
/* harmony import */ var _cosmwasmpool_v1beta1_model_pool__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(17186);
/* harmony import */ var _pool_models_balancer_balancerPool__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4075);
/* harmony import */ var _pool_models_stableswap_stableswap_pool__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(66761);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47895);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__);










/**
 * =============================== Pool
 * Deprecated: please use the alternative in x/poolmanager
 */

/** @deprecated */

function createBaseQueryPoolRequest() {
  return {
    poolId: _helpers__WEBPACK_IMPORTED_MODULE_8__/* .Long.UZERO */ .dK.UZERO
  };
}

const QueryPoolRequest = {
  typeUrl: "/osmosis.gamm.v1beta1.QueryPoolRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Writer.create()) {
    if (!message.poolId.isZero()) {
      writer.uint32(8).uint64(message.poolId);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryPoolRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.poolId = reader.uint64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseQueryPoolRequest();
    message.poolId = object.poolId !== undefined && object.poolId !== null ? _helpers__WEBPACK_IMPORTED_MODULE_8__/* .Long.fromValue */ .dK.fromValue(object.poolId) : _helpers__WEBPACK_IMPORTED_MODULE_8__/* .Long.UZERO */ .dK.UZERO;
    return message;
  },

  fromAmino(object) {
    return {
      poolId: _helpers__WEBPACK_IMPORTED_MODULE_8__/* .Long.fromString */ .dK.fromString(object.pool_id)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.pool_id = message.poolId ? message.poolId.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryPoolRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/gamm/query-pool-request",
      value: QueryPoolRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryPoolRequest.decode(message.value);
  },

  toProto(message) {
    return QueryPoolRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.QueryPoolRequest",
      value: QueryPoolRequest.encode(message).finish()
    };
  }

};

function createBaseQueryPoolResponse() {
  return {
    pool: undefined
  };
}

const QueryPoolResponse = {
  typeUrl: "/osmosis.gamm.v1beta1.QueryPoolResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Writer.create()) {
    if (message.pool !== undefined) {
      _google_protobuf_any__WEBPACK_IMPORTED_MODULE_3__.Any.encode(message.pool, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryPoolResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.pool = PoolI_InterfaceDecoder(reader);
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseQueryPoolResponse();
    message.pool = object.pool !== undefined && object.pool !== null ? _google_protobuf_any__WEBPACK_IMPORTED_MODULE_3__.Any.fromPartial(object.pool) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      pool: object !== null && object !== void 0 && object.pool ? PoolI_FromAmino(object.pool) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.pool = message.pool ? PoolI_ToAmino(message.pool) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryPoolResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/gamm/query-pool-response",
      value: QueryPoolResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryPoolResponse.decode(message.value);
  },

  toProto(message) {
    return QueryPoolResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.QueryPoolResponse",
      value: QueryPoolResponse.encode(message).finish()
    };
  }

};

function createBaseQueryPoolsRequest() {
  return {
    pagination: undefined
  };
}

const QueryPoolsRequest = {
  typeUrl: "/osmosis.gamm.v1beta1.QueryPoolsRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Writer.create()) {
    if (message.pagination !== undefined) {
      _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryPoolsRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 2:
          message.pagination = _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseQueryPoolsRequest();
    message.pagination = object.pagination !== undefined && object.pagination !== null ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.fromPartial(object.pagination) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      pagination: object !== null && object !== void 0 && object.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.fromAmino(object.pagination) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.pagination = message.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.toAmino(message.pagination) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryPoolsRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/gamm/query-pools-request",
      value: QueryPoolsRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryPoolsRequest.decode(message.value);
  },

  toProto(message) {
    return QueryPoolsRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.QueryPoolsRequest",
      value: QueryPoolsRequest.encode(message).finish()
    };
  }

};

function createBaseQueryPoolsResponse() {
  return {
    pools: [],
    pagination: undefined
  };
}

const QueryPoolsResponse = {
  typeUrl: "/osmosis.gamm.v1beta1.QueryPoolsResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Writer.create()) {
    for (const v of message.pools) {
      _google_protobuf_any__WEBPACK_IMPORTED_MODULE_3__.Any.encode(v, writer.uint32(10).fork()).ldelim();
    }

    if (message.pagination !== undefined) {
      _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryPoolsResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.pools.push(PoolI_InterfaceDecoder(reader));
          break;

        case 2:
          message.pagination = _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$pools;

    const message = createBaseQueryPoolsResponse();
    message.pools = ((_object$pools = object.pools) === null || _object$pools === void 0 ? void 0 : _object$pools.map(e => _google_protobuf_any__WEBPACK_IMPORTED_MODULE_3__.Any.fromPartial(e))) || [];
    message.pagination = object.pagination !== undefined && object.pagination !== null ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.fromPartial(object.pagination) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      pools: Array.isArray(object === null || object === void 0 ? void 0 : object.pools) ? object.pools.map(e => PoolI_FromAmino(e)) : [],
      pagination: object !== null && object !== void 0 && object.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.fromAmino(object.pagination) : undefined
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.pools) {
      obj.pools = message.pools.map(e => e ? PoolI_ToAmino(e) : undefined);
    } else {
      obj.pools = [];
    }

    obj.pagination = message.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.toAmino(message.pagination) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryPoolsResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/gamm/query-pools-response",
      value: QueryPoolsResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryPoolsResponse.decode(message.value);
  },

  toProto(message) {
    return QueryPoolsResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.QueryPoolsResponse",
      value: QueryPoolsResponse.encode(message).finish()
    };
  }

};

function createBaseQueryNumPoolsRequest() {
  return {};
}

const QueryNumPoolsRequest = {
  typeUrl: "/osmosis.gamm.v1beta1.QueryNumPoolsRequest",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryNumPoolsRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseQueryNumPoolsRequest();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return QueryNumPoolsRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/gamm/query-num-pools-request",
      value: QueryNumPoolsRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryNumPoolsRequest.decode(message.value);
  },

  toProto(message) {
    return QueryNumPoolsRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.QueryNumPoolsRequest",
      value: QueryNumPoolsRequest.encode(message).finish()
    };
  }

};

function createBaseQueryNumPoolsResponse() {
  return {
    numPools: _helpers__WEBPACK_IMPORTED_MODULE_8__/* .Long.UZERO */ .dK.UZERO
  };
}

const QueryNumPoolsResponse = {
  typeUrl: "/osmosis.gamm.v1beta1.QueryNumPoolsResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Writer.create()) {
    if (!message.numPools.isZero()) {
      writer.uint32(8).uint64(message.numPools);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryNumPoolsResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.numPools = reader.uint64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseQueryNumPoolsResponse();
    message.numPools = object.numPools !== undefined && object.numPools !== null ? _helpers__WEBPACK_IMPORTED_MODULE_8__/* .Long.fromValue */ .dK.fromValue(object.numPools) : _helpers__WEBPACK_IMPORTED_MODULE_8__/* .Long.UZERO */ .dK.UZERO;
    return message;
  },

  fromAmino(object) {
    return {
      numPools: _helpers__WEBPACK_IMPORTED_MODULE_8__/* .Long.fromString */ .dK.fromString(object.num_pools)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.num_pools = message.numPools ? message.numPools.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryNumPoolsResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/gamm/query-num-pools-response",
      value: QueryNumPoolsResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryNumPoolsResponse.decode(message.value);
  },

  toProto(message) {
    return QueryNumPoolsResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.QueryNumPoolsResponse",
      value: QueryNumPoolsResponse.encode(message).finish()
    };
  }

};

function createBaseQueryPoolTypeRequest() {
  return {
    poolId: _helpers__WEBPACK_IMPORTED_MODULE_8__/* .Long.UZERO */ .dK.UZERO
  };
}

const QueryPoolTypeRequest = {
  typeUrl: "/osmosis.gamm.v1beta1.QueryPoolTypeRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Writer.create()) {
    if (!message.poolId.isZero()) {
      writer.uint32(8).uint64(message.poolId);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryPoolTypeRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.poolId = reader.uint64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseQueryPoolTypeRequest();
    message.poolId = object.poolId !== undefined && object.poolId !== null ? _helpers__WEBPACK_IMPORTED_MODULE_8__/* .Long.fromValue */ .dK.fromValue(object.poolId) : _helpers__WEBPACK_IMPORTED_MODULE_8__/* .Long.UZERO */ .dK.UZERO;
    return message;
  },

  fromAmino(object) {
    return {
      poolId: _helpers__WEBPACK_IMPORTED_MODULE_8__/* .Long.fromString */ .dK.fromString(object.pool_id)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.pool_id = message.poolId ? message.poolId.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryPoolTypeRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/gamm/query-pool-type-request",
      value: QueryPoolTypeRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryPoolTypeRequest.decode(message.value);
  },

  toProto(message) {
    return QueryPoolTypeRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.QueryPoolTypeRequest",
      value: QueryPoolTypeRequest.encode(message).finish()
    };
  }

};

function createBaseQueryPoolTypeResponse() {
  return {
    poolType: ""
  };
}

const QueryPoolTypeResponse = {
  typeUrl: "/osmosis.gamm.v1beta1.QueryPoolTypeResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Writer.create()) {
    if (message.poolType !== "") {
      writer.uint32(10).string(message.poolType);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryPoolTypeResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.poolType = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$poolType;

    const message = createBaseQueryPoolTypeResponse();
    message.poolType = (_object$poolType = object.poolType) !== null && _object$poolType !== void 0 ? _object$poolType : "";
    return message;
  },

  fromAmino(object) {
    return {
      poolType: object.pool_type
    };
  },

  toAmino(message) {
    const obj = {};
    obj.pool_type = message.poolType;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryPoolTypeResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/gamm/query-pool-type-response",
      value: QueryPoolTypeResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryPoolTypeResponse.decode(message.value);
  },

  toProto(message) {
    return QueryPoolTypeResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.QueryPoolTypeResponse",
      value: QueryPoolTypeResponse.encode(message).finish()
    };
  }

};

function createBaseQueryCalcJoinPoolSharesRequest() {
  return {
    poolId: _helpers__WEBPACK_IMPORTED_MODULE_8__/* .Long.UZERO */ .dK.UZERO,
    tokensIn: []
  };
}

const QueryCalcJoinPoolSharesRequest = {
  typeUrl: "/osmosis.gamm.v1beta1.QueryCalcJoinPoolSharesRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Writer.create()) {
    if (!message.poolId.isZero()) {
      writer.uint32(8).uint64(message.poolId);
    }

    for (const v of message.tokensIn) {
      _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.encode(v, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryCalcJoinPoolSharesRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.poolId = reader.uint64();
          break;

        case 2:
          message.tokensIn.push(_cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$tokensIn;

    const message = createBaseQueryCalcJoinPoolSharesRequest();
    message.poolId = object.poolId !== undefined && object.poolId !== null ? _helpers__WEBPACK_IMPORTED_MODULE_8__/* .Long.fromValue */ .dK.fromValue(object.poolId) : _helpers__WEBPACK_IMPORTED_MODULE_8__/* .Long.UZERO */ .dK.UZERO;
    message.tokensIn = ((_object$tokensIn = object.tokensIn) === null || _object$tokensIn === void 0 ? void 0 : _object$tokensIn.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      poolId: _helpers__WEBPACK_IMPORTED_MODULE_8__/* .Long.fromString */ .dK.fromString(object.pool_id),
      tokensIn: Array.isArray(object === null || object === void 0 ? void 0 : object.tokens_in) ? object.tokens_in.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.pool_id = message.poolId ? message.poolId.toString() : undefined;

    if (message.tokensIn) {
      obj.tokens_in = message.tokensIn.map(e => e ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.toAmino(e) : undefined);
    } else {
      obj.tokens_in = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return QueryCalcJoinPoolSharesRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/gamm/query-calc-join-pool-shares-request",
      value: QueryCalcJoinPoolSharesRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryCalcJoinPoolSharesRequest.decode(message.value);
  },

  toProto(message) {
    return QueryCalcJoinPoolSharesRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.QueryCalcJoinPoolSharesRequest",
      value: QueryCalcJoinPoolSharesRequest.encode(message).finish()
    };
  }

};

function createBaseQueryCalcJoinPoolSharesResponse() {
  return {
    shareOutAmount: "",
    tokensOut: []
  };
}

const QueryCalcJoinPoolSharesResponse = {
  typeUrl: "/osmosis.gamm.v1beta1.QueryCalcJoinPoolSharesResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Writer.create()) {
    if (message.shareOutAmount !== "") {
      writer.uint32(10).string(message.shareOutAmount);
    }

    for (const v of message.tokensOut) {
      _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.encode(v, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryCalcJoinPoolSharesResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.shareOutAmount = reader.string();
          break;

        case 2:
          message.tokensOut.push(_cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$shareOutAmoun, _object$tokensOut;

    const message = createBaseQueryCalcJoinPoolSharesResponse();
    message.shareOutAmount = (_object$shareOutAmoun = object.shareOutAmount) !== null && _object$shareOutAmoun !== void 0 ? _object$shareOutAmoun : "";
    message.tokensOut = ((_object$tokensOut = object.tokensOut) === null || _object$tokensOut === void 0 ? void 0 : _object$tokensOut.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      shareOutAmount: object.share_out_amount,
      tokensOut: Array.isArray(object === null || object === void 0 ? void 0 : object.tokens_out) ? object.tokens_out.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.share_out_amount = message.shareOutAmount;

    if (message.tokensOut) {
      obj.tokens_out = message.tokensOut.map(e => e ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.toAmino(e) : undefined);
    } else {
      obj.tokens_out = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return QueryCalcJoinPoolSharesResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/gamm/query-calc-join-pool-shares-response",
      value: QueryCalcJoinPoolSharesResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryCalcJoinPoolSharesResponse.decode(message.value);
  },

  toProto(message) {
    return QueryCalcJoinPoolSharesResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.QueryCalcJoinPoolSharesResponse",
      value: QueryCalcJoinPoolSharesResponse.encode(message).finish()
    };
  }

};

function createBaseQueryCalcExitPoolCoinsFromSharesRequest() {
  return {
    poolId: _helpers__WEBPACK_IMPORTED_MODULE_8__/* .Long.UZERO */ .dK.UZERO,
    shareInAmount: ""
  };
}

const QueryCalcExitPoolCoinsFromSharesRequest = {
  typeUrl: "/osmosis.gamm.v1beta1.QueryCalcExitPoolCoinsFromSharesRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Writer.create()) {
    if (!message.poolId.isZero()) {
      writer.uint32(8).uint64(message.poolId);
    }

    if (message.shareInAmount !== "") {
      writer.uint32(18).string(message.shareInAmount);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryCalcExitPoolCoinsFromSharesRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.poolId = reader.uint64();
          break;

        case 2:
          message.shareInAmount = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$shareInAmount;

    const message = createBaseQueryCalcExitPoolCoinsFromSharesRequest();
    message.poolId = object.poolId !== undefined && object.poolId !== null ? _helpers__WEBPACK_IMPORTED_MODULE_8__/* .Long.fromValue */ .dK.fromValue(object.poolId) : _helpers__WEBPACK_IMPORTED_MODULE_8__/* .Long.UZERO */ .dK.UZERO;
    message.shareInAmount = (_object$shareInAmount = object.shareInAmount) !== null && _object$shareInAmount !== void 0 ? _object$shareInAmount : "";
    return message;
  },

  fromAmino(object) {
    return {
      poolId: _helpers__WEBPACK_IMPORTED_MODULE_8__/* .Long.fromString */ .dK.fromString(object.pool_id),
      shareInAmount: object.share_in_amount
    };
  },

  toAmino(message) {
    const obj = {};
    obj.pool_id = message.poolId ? message.poolId.toString() : undefined;
    obj.share_in_amount = message.shareInAmount;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryCalcExitPoolCoinsFromSharesRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/gamm/query-calc-exit-pool-coins-from-shares-request",
      value: QueryCalcExitPoolCoinsFromSharesRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryCalcExitPoolCoinsFromSharesRequest.decode(message.value);
  },

  toProto(message) {
    return QueryCalcExitPoolCoinsFromSharesRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.QueryCalcExitPoolCoinsFromSharesRequest",
      value: QueryCalcExitPoolCoinsFromSharesRequest.encode(message).finish()
    };
  }

};

function createBaseQueryCalcExitPoolCoinsFromSharesResponse() {
  return {
    tokensOut: []
  };
}

const QueryCalcExitPoolCoinsFromSharesResponse = {
  typeUrl: "/osmosis.gamm.v1beta1.QueryCalcExitPoolCoinsFromSharesResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Writer.create()) {
    for (const v of message.tokensOut) {
      _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.encode(v, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryCalcExitPoolCoinsFromSharesResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.tokensOut.push(_cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$tokensOut2;

    const message = createBaseQueryCalcExitPoolCoinsFromSharesResponse();
    message.tokensOut = ((_object$tokensOut2 = object.tokensOut) === null || _object$tokensOut2 === void 0 ? void 0 : _object$tokensOut2.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      tokensOut: Array.isArray(object === null || object === void 0 ? void 0 : object.tokens_out) ? object.tokens_out.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.tokensOut) {
      obj.tokens_out = message.tokensOut.map(e => e ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.toAmino(e) : undefined);
    } else {
      obj.tokens_out = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return QueryCalcExitPoolCoinsFromSharesResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/gamm/query-calc-exit-pool-coins-from-shares-response",
      value: QueryCalcExitPoolCoinsFromSharesResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryCalcExitPoolCoinsFromSharesResponse.decode(message.value);
  },

  toProto(message) {
    return QueryCalcExitPoolCoinsFromSharesResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.QueryCalcExitPoolCoinsFromSharesResponse",
      value: QueryCalcExitPoolCoinsFromSharesResponse.encode(message).finish()
    };
  }

};

function createBaseQueryPoolParamsRequest() {
  return {
    poolId: _helpers__WEBPACK_IMPORTED_MODULE_8__/* .Long.UZERO */ .dK.UZERO
  };
}

const QueryPoolParamsRequest = {
  typeUrl: "/osmosis.gamm.v1beta1.QueryPoolParamsRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Writer.create()) {
    if (!message.poolId.isZero()) {
      writer.uint32(8).uint64(message.poolId);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryPoolParamsRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.poolId = reader.uint64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseQueryPoolParamsRequest();
    message.poolId = object.poolId !== undefined && object.poolId !== null ? _helpers__WEBPACK_IMPORTED_MODULE_8__/* .Long.fromValue */ .dK.fromValue(object.poolId) : _helpers__WEBPACK_IMPORTED_MODULE_8__/* .Long.UZERO */ .dK.UZERO;
    return message;
  },

  fromAmino(object) {
    return {
      poolId: _helpers__WEBPACK_IMPORTED_MODULE_8__/* .Long.fromString */ .dK.fromString(object.pool_id)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.pool_id = message.poolId ? message.poolId.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryPoolParamsRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/gamm/query-pool-params-request",
      value: QueryPoolParamsRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryPoolParamsRequest.decode(message.value);
  },

  toProto(message) {
    return QueryPoolParamsRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.QueryPoolParamsRequest",
      value: QueryPoolParamsRequest.encode(message).finish()
    };
  }

};

function createBaseQueryPoolParamsResponse() {
  return {
    params: undefined
  };
}

const QueryPoolParamsResponse = {
  typeUrl: "/osmosis.gamm.v1beta1.QueryPoolParamsResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Writer.create()) {
    if (message.params !== undefined) {
      _google_protobuf_any__WEBPACK_IMPORTED_MODULE_3__.Any.encode(message.params, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryPoolParamsResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.params = _google_protobuf_any__WEBPACK_IMPORTED_MODULE_3__.Any.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseQueryPoolParamsResponse();
    message.params = object.params !== undefined && object.params !== null ? _google_protobuf_any__WEBPACK_IMPORTED_MODULE_3__.Any.fromPartial(object.params) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      params: object !== null && object !== void 0 && object.params ? _google_protobuf_any__WEBPACK_IMPORTED_MODULE_3__.Any.fromAmino(object.params) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.params = message.params ? _google_protobuf_any__WEBPACK_IMPORTED_MODULE_3__.Any.toAmino(message.params) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryPoolParamsResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/gamm/query-pool-params-response",
      value: QueryPoolParamsResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryPoolParamsResponse.decode(message.value);
  },

  toProto(message) {
    return QueryPoolParamsResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.QueryPoolParamsResponse",
      value: QueryPoolParamsResponse.encode(message).finish()
    };
  }

};

function createBaseQueryTotalPoolLiquidityRequest() {
  return {
    poolId: _helpers__WEBPACK_IMPORTED_MODULE_8__/* .Long.UZERO */ .dK.UZERO
  };
}

const QueryTotalPoolLiquidityRequest = {
  typeUrl: "/osmosis.gamm.v1beta1.QueryTotalPoolLiquidityRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Writer.create()) {
    if (!message.poolId.isZero()) {
      writer.uint32(8).uint64(message.poolId);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryTotalPoolLiquidityRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.poolId = reader.uint64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseQueryTotalPoolLiquidityRequest();
    message.poolId = object.poolId !== undefined && object.poolId !== null ? _helpers__WEBPACK_IMPORTED_MODULE_8__/* .Long.fromValue */ .dK.fromValue(object.poolId) : _helpers__WEBPACK_IMPORTED_MODULE_8__/* .Long.UZERO */ .dK.UZERO;
    return message;
  },

  fromAmino(object) {
    return {
      poolId: _helpers__WEBPACK_IMPORTED_MODULE_8__/* .Long.fromString */ .dK.fromString(object.pool_id)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.pool_id = message.poolId ? message.poolId.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryTotalPoolLiquidityRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/gamm/query-total-pool-liquidity-request",
      value: QueryTotalPoolLiquidityRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryTotalPoolLiquidityRequest.decode(message.value);
  },

  toProto(message) {
    return QueryTotalPoolLiquidityRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.QueryTotalPoolLiquidityRequest",
      value: QueryTotalPoolLiquidityRequest.encode(message).finish()
    };
  }

};

function createBaseQueryTotalPoolLiquidityResponse() {
  return {
    liquidity: []
  };
}

const QueryTotalPoolLiquidityResponse = {
  typeUrl: "/osmosis.gamm.v1beta1.QueryTotalPoolLiquidityResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Writer.create()) {
    for (const v of message.liquidity) {
      _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.encode(v, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryTotalPoolLiquidityResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.liquidity.push(_cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$liquidity;

    const message = createBaseQueryTotalPoolLiquidityResponse();
    message.liquidity = ((_object$liquidity = object.liquidity) === null || _object$liquidity === void 0 ? void 0 : _object$liquidity.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      liquidity: Array.isArray(object === null || object === void 0 ? void 0 : object.liquidity) ? object.liquidity.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.liquidity) {
      obj.liquidity = message.liquidity.map(e => e ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.toAmino(e) : undefined);
    } else {
      obj.liquidity = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return QueryTotalPoolLiquidityResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/gamm/query-total-pool-liquidity-response",
      value: QueryTotalPoolLiquidityResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryTotalPoolLiquidityResponse.decode(message.value);
  },

  toProto(message) {
    return QueryTotalPoolLiquidityResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.QueryTotalPoolLiquidityResponse",
      value: QueryTotalPoolLiquidityResponse.encode(message).finish()
    };
  }

};

function createBaseQueryTotalSharesRequest() {
  return {
    poolId: _helpers__WEBPACK_IMPORTED_MODULE_8__/* .Long.UZERO */ .dK.UZERO
  };
}

const QueryTotalSharesRequest = {
  typeUrl: "/osmosis.gamm.v1beta1.QueryTotalSharesRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Writer.create()) {
    if (!message.poolId.isZero()) {
      writer.uint32(8).uint64(message.poolId);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryTotalSharesRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.poolId = reader.uint64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseQueryTotalSharesRequest();
    message.poolId = object.poolId !== undefined && object.poolId !== null ? _helpers__WEBPACK_IMPORTED_MODULE_8__/* .Long.fromValue */ .dK.fromValue(object.poolId) : _helpers__WEBPACK_IMPORTED_MODULE_8__/* .Long.UZERO */ .dK.UZERO;
    return message;
  },

  fromAmino(object) {
    return {
      poolId: _helpers__WEBPACK_IMPORTED_MODULE_8__/* .Long.fromString */ .dK.fromString(object.pool_id)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.pool_id = message.poolId ? message.poolId.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryTotalSharesRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/gamm/query-total-shares-request",
      value: QueryTotalSharesRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryTotalSharesRequest.decode(message.value);
  },

  toProto(message) {
    return QueryTotalSharesRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.QueryTotalSharesRequest",
      value: QueryTotalSharesRequest.encode(message).finish()
    };
  }

};

function createBaseQueryTotalSharesResponse() {
  return {
    totalShares: undefined
  };
}

const QueryTotalSharesResponse = {
  typeUrl: "/osmosis.gamm.v1beta1.QueryTotalSharesResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Writer.create()) {
    if (message.totalShares !== undefined) {
      _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.encode(message.totalShares, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryTotalSharesResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.totalShares = _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseQueryTotalSharesResponse();
    message.totalShares = object.totalShares !== undefined && object.totalShares !== null ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.fromPartial(object.totalShares) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      totalShares: object !== null && object !== void 0 && object.total_shares ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.fromAmino(object.total_shares) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.total_shares = message.totalShares ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.toAmino(message.totalShares) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryTotalSharesResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/gamm/query-total-shares-response",
      value: QueryTotalSharesResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryTotalSharesResponse.decode(message.value);
  },

  toProto(message) {
    return QueryTotalSharesResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.QueryTotalSharesResponse",
      value: QueryTotalSharesResponse.encode(message).finish()
    };
  }

};

function createBaseQueryCalcJoinPoolNoSwapSharesRequest() {
  return {
    poolId: _helpers__WEBPACK_IMPORTED_MODULE_8__/* .Long.UZERO */ .dK.UZERO,
    tokensIn: []
  };
}

const QueryCalcJoinPoolNoSwapSharesRequest = {
  typeUrl: "/osmosis.gamm.v1beta1.QueryCalcJoinPoolNoSwapSharesRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Writer.create()) {
    if (!message.poolId.isZero()) {
      writer.uint32(8).uint64(message.poolId);
    }

    for (const v of message.tokensIn) {
      _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.encode(v, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryCalcJoinPoolNoSwapSharesRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.poolId = reader.uint64();
          break;

        case 2:
          message.tokensIn.push(_cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$tokensIn2;

    const message = createBaseQueryCalcJoinPoolNoSwapSharesRequest();
    message.poolId = object.poolId !== undefined && object.poolId !== null ? _helpers__WEBPACK_IMPORTED_MODULE_8__/* .Long.fromValue */ .dK.fromValue(object.poolId) : _helpers__WEBPACK_IMPORTED_MODULE_8__/* .Long.UZERO */ .dK.UZERO;
    message.tokensIn = ((_object$tokensIn2 = object.tokensIn) === null || _object$tokensIn2 === void 0 ? void 0 : _object$tokensIn2.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      poolId: _helpers__WEBPACK_IMPORTED_MODULE_8__/* .Long.fromString */ .dK.fromString(object.pool_id),
      tokensIn: Array.isArray(object === null || object === void 0 ? void 0 : object.tokens_in) ? object.tokens_in.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.pool_id = message.poolId ? message.poolId.toString() : undefined;

    if (message.tokensIn) {
      obj.tokens_in = message.tokensIn.map(e => e ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.toAmino(e) : undefined);
    } else {
      obj.tokens_in = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return QueryCalcJoinPoolNoSwapSharesRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/gamm/query-calc-join-pool-no-swap-shares-request",
      value: QueryCalcJoinPoolNoSwapSharesRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryCalcJoinPoolNoSwapSharesRequest.decode(message.value);
  },

  toProto(message) {
    return QueryCalcJoinPoolNoSwapSharesRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.QueryCalcJoinPoolNoSwapSharesRequest",
      value: QueryCalcJoinPoolNoSwapSharesRequest.encode(message).finish()
    };
  }

};

function createBaseQueryCalcJoinPoolNoSwapSharesResponse() {
  return {
    tokensOut: [],
    sharesOut: ""
  };
}

const QueryCalcJoinPoolNoSwapSharesResponse = {
  typeUrl: "/osmosis.gamm.v1beta1.QueryCalcJoinPoolNoSwapSharesResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Writer.create()) {
    for (const v of message.tokensOut) {
      _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.encode(v, writer.uint32(10).fork()).ldelim();
    }

    if (message.sharesOut !== "") {
      writer.uint32(18).string(message.sharesOut);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryCalcJoinPoolNoSwapSharesResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.tokensOut.push(_cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.decode(reader, reader.uint32()));
          break;

        case 2:
          message.sharesOut = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$tokensOut3, _object$sharesOut;

    const message = createBaseQueryCalcJoinPoolNoSwapSharesResponse();
    message.tokensOut = ((_object$tokensOut3 = object.tokensOut) === null || _object$tokensOut3 === void 0 ? void 0 : _object$tokensOut3.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.fromPartial(e))) || [];
    message.sharesOut = (_object$sharesOut = object.sharesOut) !== null && _object$sharesOut !== void 0 ? _object$sharesOut : "";
    return message;
  },

  fromAmino(object) {
    return {
      tokensOut: Array.isArray(object === null || object === void 0 ? void 0 : object.tokens_out) ? object.tokens_out.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.fromAmino(e)) : [],
      sharesOut: object.shares_out
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.tokensOut) {
      obj.tokens_out = message.tokensOut.map(e => e ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.toAmino(e) : undefined);
    } else {
      obj.tokens_out = [];
    }

    obj.shares_out = message.sharesOut;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryCalcJoinPoolNoSwapSharesResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/gamm/query-calc-join-pool-no-swap-shares-response",
      value: QueryCalcJoinPoolNoSwapSharesResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryCalcJoinPoolNoSwapSharesResponse.decode(message.value);
  },

  toProto(message) {
    return QueryCalcJoinPoolNoSwapSharesResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.QueryCalcJoinPoolNoSwapSharesResponse",
      value: QueryCalcJoinPoolNoSwapSharesResponse.encode(message).finish()
    };
  }

};

function createBaseQuerySpotPriceRequest() {
  return {
    poolId: _helpers__WEBPACK_IMPORTED_MODULE_8__/* .Long.UZERO */ .dK.UZERO,
    baseAssetDenom: "",
    quoteAssetDenom: ""
  };
}

const QuerySpotPriceRequest = {
  typeUrl: "/osmosis.gamm.v1beta1.QuerySpotPriceRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Writer.create()) {
    if (!message.poolId.isZero()) {
      writer.uint32(8).uint64(message.poolId);
    }

    if (message.baseAssetDenom !== "") {
      writer.uint32(18).string(message.baseAssetDenom);
    }

    if (message.quoteAssetDenom !== "") {
      writer.uint32(26).string(message.quoteAssetDenom);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQuerySpotPriceRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.poolId = reader.uint64();
          break;

        case 2:
          message.baseAssetDenom = reader.string();
          break;

        case 3:
          message.quoteAssetDenom = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$baseAssetDeno, _object$quoteAssetDen;

    const message = createBaseQuerySpotPriceRequest();
    message.poolId = object.poolId !== undefined && object.poolId !== null ? _helpers__WEBPACK_IMPORTED_MODULE_8__/* .Long.fromValue */ .dK.fromValue(object.poolId) : _helpers__WEBPACK_IMPORTED_MODULE_8__/* .Long.UZERO */ .dK.UZERO;
    message.baseAssetDenom = (_object$baseAssetDeno = object.baseAssetDenom) !== null && _object$baseAssetDeno !== void 0 ? _object$baseAssetDeno : "";
    message.quoteAssetDenom = (_object$quoteAssetDen = object.quoteAssetDenom) !== null && _object$quoteAssetDen !== void 0 ? _object$quoteAssetDen : "";
    return message;
  },

  fromAmino(object) {
    return {
      poolId: _helpers__WEBPACK_IMPORTED_MODULE_8__/* .Long.fromString */ .dK.fromString(object.pool_id),
      baseAssetDenom: object.base_asset_denom,
      quoteAssetDenom: object.quote_asset_denom
    };
  },

  toAmino(message) {
    const obj = {};
    obj.pool_id = message.poolId ? message.poolId.toString() : undefined;
    obj.base_asset_denom = message.baseAssetDenom;
    obj.quote_asset_denom = message.quoteAssetDenom;
    return obj;
  },

  fromAminoMsg(object) {
    return QuerySpotPriceRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/gamm/query-spot-price-request",
      value: QuerySpotPriceRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QuerySpotPriceRequest.decode(message.value);
  },

  toProto(message) {
    return QuerySpotPriceRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.QuerySpotPriceRequest",
      value: QuerySpotPriceRequest.encode(message).finish()
    };
  }

};

function createBaseQueryPoolsWithFilterRequest() {
  return {
    minLiquidity: "",
    poolType: "",
    pagination: undefined
  };
}

const QueryPoolsWithFilterRequest = {
  typeUrl: "/osmosis.gamm.v1beta1.QueryPoolsWithFilterRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Writer.create()) {
    if (message.minLiquidity !== "") {
      writer.uint32(10).string(message.minLiquidity);
    }

    if (message.poolType !== "") {
      writer.uint32(18).string(message.poolType);
    }

    if (message.pagination !== undefined) {
      _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.encode(message.pagination, writer.uint32(26).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryPoolsWithFilterRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.minLiquidity = reader.string();
          break;

        case 2:
          message.poolType = reader.string();
          break;

        case 3:
          message.pagination = _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$minLiquidity, _object$poolType2;

    const message = createBaseQueryPoolsWithFilterRequest();
    message.minLiquidity = (_object$minLiquidity = object.minLiquidity) !== null && _object$minLiquidity !== void 0 ? _object$minLiquidity : "";
    message.poolType = (_object$poolType2 = object.poolType) !== null && _object$poolType2 !== void 0 ? _object$poolType2 : "";
    message.pagination = object.pagination !== undefined && object.pagination !== null ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.fromPartial(object.pagination) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      minLiquidity: object.min_liquidity,
      poolType: object.pool_type,
      pagination: object !== null && object !== void 0 && object.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.fromAmino(object.pagination) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.min_liquidity = message.minLiquidity;
    obj.pool_type = message.poolType;
    obj.pagination = message.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.toAmino(message.pagination) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryPoolsWithFilterRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/gamm/query-pools-with-filter-request",
      value: QueryPoolsWithFilterRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryPoolsWithFilterRequest.decode(message.value);
  },

  toProto(message) {
    return QueryPoolsWithFilterRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.QueryPoolsWithFilterRequest",
      value: QueryPoolsWithFilterRequest.encode(message).finish()
    };
  }

};

function createBaseQueryPoolsWithFilterResponse() {
  return {
    pools: [],
    pagination: undefined
  };
}

const QueryPoolsWithFilterResponse = {
  typeUrl: "/osmosis.gamm.v1beta1.QueryPoolsWithFilterResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Writer.create()) {
    for (const v of message.pools) {
      _google_protobuf_any__WEBPACK_IMPORTED_MODULE_3__.Any.encode(v, writer.uint32(10).fork()).ldelim();
    }

    if (message.pagination !== undefined) {
      _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryPoolsWithFilterResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.pools.push(PoolI_InterfaceDecoder(reader));
          break;

        case 2:
          message.pagination = _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$pools2;

    const message = createBaseQueryPoolsWithFilterResponse();
    message.pools = ((_object$pools2 = object.pools) === null || _object$pools2 === void 0 ? void 0 : _object$pools2.map(e => _google_protobuf_any__WEBPACK_IMPORTED_MODULE_3__.Any.fromPartial(e))) || [];
    message.pagination = object.pagination !== undefined && object.pagination !== null ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.fromPartial(object.pagination) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      pools: Array.isArray(object === null || object === void 0 ? void 0 : object.pools) ? object.pools.map(e => PoolI_FromAmino(e)) : [],
      pagination: object !== null && object !== void 0 && object.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.fromAmino(object.pagination) : undefined
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.pools) {
      obj.pools = message.pools.map(e => e ? PoolI_ToAmino(e) : undefined);
    } else {
      obj.pools = [];
    }

    obj.pagination = message.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.toAmino(message.pagination) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryPoolsWithFilterResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/gamm/query-pools-with-filter-response",
      value: QueryPoolsWithFilterResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryPoolsWithFilterResponse.decode(message.value);
  },

  toProto(message) {
    return QueryPoolsWithFilterResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.QueryPoolsWithFilterResponse",
      value: QueryPoolsWithFilterResponse.encode(message).finish()
    };
  }

};

function createBaseQuerySpotPriceResponse() {
  return {
    spotPrice: ""
  };
}

const QuerySpotPriceResponse = {
  typeUrl: "/osmosis.gamm.v1beta1.QuerySpotPriceResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Writer.create()) {
    if (message.spotPrice !== "") {
      writer.uint32(10).string(message.spotPrice);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQuerySpotPriceResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.spotPrice = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$spotPrice;

    const message = createBaseQuerySpotPriceResponse();
    message.spotPrice = (_object$spotPrice = object.spotPrice) !== null && _object$spotPrice !== void 0 ? _object$spotPrice : "";
    return message;
  },

  fromAmino(object) {
    return {
      spotPrice: object.spot_price
    };
  },

  toAmino(message) {
    const obj = {};
    obj.spot_price = message.spotPrice;
    return obj;
  },

  fromAminoMsg(object) {
    return QuerySpotPriceResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/gamm/query-spot-price-response",
      value: QuerySpotPriceResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QuerySpotPriceResponse.decode(message.value);
  },

  toProto(message) {
    return QuerySpotPriceResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.QuerySpotPriceResponse",
      value: QuerySpotPriceResponse.encode(message).finish()
    };
  }

};

function createBaseQuerySwapExactAmountInRequest() {
  return {
    sender: "",
    poolId: _helpers__WEBPACK_IMPORTED_MODULE_8__/* .Long.UZERO */ .dK.UZERO,
    tokenIn: "",
    routes: []
  };
}

const QuerySwapExactAmountInRequest = {
  typeUrl: "/osmosis.gamm.v1beta1.QuerySwapExactAmountInRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Writer.create()) {
    if (message.sender !== "") {
      writer.uint32(10).string(message.sender);
    }

    if (!message.poolId.isZero()) {
      writer.uint32(16).uint64(message.poolId);
    }

    if (message.tokenIn !== "") {
      writer.uint32(26).string(message.tokenIn);
    }

    for (const v of message.routes) {
      _poolmanager_v1beta1_swap_route__WEBPACK_IMPORTED_MODULE_2__.SwapAmountInRoute.encode(v, writer.uint32(34).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQuerySwapExactAmountInRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.sender = reader.string();
          break;

        case 2:
          message.poolId = reader.uint64();
          break;

        case 3:
          message.tokenIn = reader.string();
          break;

        case 4:
          message.routes.push(_poolmanager_v1beta1_swap_route__WEBPACK_IMPORTED_MODULE_2__.SwapAmountInRoute.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$sender, _object$tokenIn, _object$routes;

    const message = createBaseQuerySwapExactAmountInRequest();
    message.sender = (_object$sender = object.sender) !== null && _object$sender !== void 0 ? _object$sender : "";
    message.poolId = object.poolId !== undefined && object.poolId !== null ? _helpers__WEBPACK_IMPORTED_MODULE_8__/* .Long.fromValue */ .dK.fromValue(object.poolId) : _helpers__WEBPACK_IMPORTED_MODULE_8__/* .Long.UZERO */ .dK.UZERO;
    message.tokenIn = (_object$tokenIn = object.tokenIn) !== null && _object$tokenIn !== void 0 ? _object$tokenIn : "";
    message.routes = ((_object$routes = object.routes) === null || _object$routes === void 0 ? void 0 : _object$routes.map(e => _poolmanager_v1beta1_swap_route__WEBPACK_IMPORTED_MODULE_2__.SwapAmountInRoute.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      sender: object.sender,
      poolId: _helpers__WEBPACK_IMPORTED_MODULE_8__/* .Long.fromString */ .dK.fromString(object.pool_id),
      tokenIn: object.token_in,
      routes: Array.isArray(object === null || object === void 0 ? void 0 : object.routes) ? object.routes.map(e => _poolmanager_v1beta1_swap_route__WEBPACK_IMPORTED_MODULE_2__.SwapAmountInRoute.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.sender = message.sender;
    obj.pool_id = message.poolId ? message.poolId.toString() : undefined;
    obj.token_in = message.tokenIn;

    if (message.routes) {
      obj.routes = message.routes.map(e => e ? _poolmanager_v1beta1_swap_route__WEBPACK_IMPORTED_MODULE_2__.SwapAmountInRoute.toAmino(e) : undefined);
    } else {
      obj.routes = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return QuerySwapExactAmountInRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/gamm/query-swap-exact-amount-in-request",
      value: QuerySwapExactAmountInRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QuerySwapExactAmountInRequest.decode(message.value);
  },

  toProto(message) {
    return QuerySwapExactAmountInRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.QuerySwapExactAmountInRequest",
      value: QuerySwapExactAmountInRequest.encode(message).finish()
    };
  }

};

function createBaseQuerySwapExactAmountInResponse() {
  return {
    tokenOutAmount: ""
  };
}

const QuerySwapExactAmountInResponse = {
  typeUrl: "/osmosis.gamm.v1beta1.QuerySwapExactAmountInResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Writer.create()) {
    if (message.tokenOutAmount !== "") {
      writer.uint32(10).string(message.tokenOutAmount);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQuerySwapExactAmountInResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.tokenOutAmount = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$tokenOutAmoun;

    const message = createBaseQuerySwapExactAmountInResponse();
    message.tokenOutAmount = (_object$tokenOutAmoun = object.tokenOutAmount) !== null && _object$tokenOutAmoun !== void 0 ? _object$tokenOutAmoun : "";
    return message;
  },

  fromAmino(object) {
    return {
      tokenOutAmount: object.token_out_amount
    };
  },

  toAmino(message) {
    const obj = {};
    obj.token_out_amount = message.tokenOutAmount;
    return obj;
  },

  fromAminoMsg(object) {
    return QuerySwapExactAmountInResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/gamm/query-swap-exact-amount-in-response",
      value: QuerySwapExactAmountInResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QuerySwapExactAmountInResponse.decode(message.value);
  },

  toProto(message) {
    return QuerySwapExactAmountInResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.QuerySwapExactAmountInResponse",
      value: QuerySwapExactAmountInResponse.encode(message).finish()
    };
  }

};

function createBaseQuerySwapExactAmountOutRequest() {
  return {
    sender: "",
    poolId: _helpers__WEBPACK_IMPORTED_MODULE_8__/* .Long.UZERO */ .dK.UZERO,
    routes: [],
    tokenOut: ""
  };
}

const QuerySwapExactAmountOutRequest = {
  typeUrl: "/osmosis.gamm.v1beta1.QuerySwapExactAmountOutRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Writer.create()) {
    if (message.sender !== "") {
      writer.uint32(10).string(message.sender);
    }

    if (!message.poolId.isZero()) {
      writer.uint32(16).uint64(message.poolId);
    }

    for (const v of message.routes) {
      _poolmanager_v1beta1_swap_route__WEBPACK_IMPORTED_MODULE_2__.SwapAmountOutRoute.encode(v, writer.uint32(26).fork()).ldelim();
    }

    if (message.tokenOut !== "") {
      writer.uint32(34).string(message.tokenOut);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQuerySwapExactAmountOutRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.sender = reader.string();
          break;

        case 2:
          message.poolId = reader.uint64();
          break;

        case 3:
          message.routes.push(_poolmanager_v1beta1_swap_route__WEBPACK_IMPORTED_MODULE_2__.SwapAmountOutRoute.decode(reader, reader.uint32()));
          break;

        case 4:
          message.tokenOut = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$sender2, _object$routes2, _object$tokenOut;

    const message = createBaseQuerySwapExactAmountOutRequest();
    message.sender = (_object$sender2 = object.sender) !== null && _object$sender2 !== void 0 ? _object$sender2 : "";
    message.poolId = object.poolId !== undefined && object.poolId !== null ? _helpers__WEBPACK_IMPORTED_MODULE_8__/* .Long.fromValue */ .dK.fromValue(object.poolId) : _helpers__WEBPACK_IMPORTED_MODULE_8__/* .Long.UZERO */ .dK.UZERO;
    message.routes = ((_object$routes2 = object.routes) === null || _object$routes2 === void 0 ? void 0 : _object$routes2.map(e => _poolmanager_v1beta1_swap_route__WEBPACK_IMPORTED_MODULE_2__.SwapAmountOutRoute.fromPartial(e))) || [];
    message.tokenOut = (_object$tokenOut = object.tokenOut) !== null && _object$tokenOut !== void 0 ? _object$tokenOut : "";
    return message;
  },

  fromAmino(object) {
    return {
      sender: object.sender,
      poolId: _helpers__WEBPACK_IMPORTED_MODULE_8__/* .Long.fromString */ .dK.fromString(object.pool_id),
      routes: Array.isArray(object === null || object === void 0 ? void 0 : object.routes) ? object.routes.map(e => _poolmanager_v1beta1_swap_route__WEBPACK_IMPORTED_MODULE_2__.SwapAmountOutRoute.fromAmino(e)) : [],
      tokenOut: object.token_out
    };
  },

  toAmino(message) {
    const obj = {};
    obj.sender = message.sender;
    obj.pool_id = message.poolId ? message.poolId.toString() : undefined;

    if (message.routes) {
      obj.routes = message.routes.map(e => e ? _poolmanager_v1beta1_swap_route__WEBPACK_IMPORTED_MODULE_2__.SwapAmountOutRoute.toAmino(e) : undefined);
    } else {
      obj.routes = [];
    }

    obj.token_out = message.tokenOut;
    return obj;
  },

  fromAminoMsg(object) {
    return QuerySwapExactAmountOutRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/gamm/query-swap-exact-amount-out-request",
      value: QuerySwapExactAmountOutRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QuerySwapExactAmountOutRequest.decode(message.value);
  },

  toProto(message) {
    return QuerySwapExactAmountOutRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.QuerySwapExactAmountOutRequest",
      value: QuerySwapExactAmountOutRequest.encode(message).finish()
    };
  }

};

function createBaseQuerySwapExactAmountOutResponse() {
  return {
    tokenInAmount: ""
  };
}

const QuerySwapExactAmountOutResponse = {
  typeUrl: "/osmosis.gamm.v1beta1.QuerySwapExactAmountOutResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Writer.create()) {
    if (message.tokenInAmount !== "") {
      writer.uint32(10).string(message.tokenInAmount);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQuerySwapExactAmountOutResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.tokenInAmount = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$tokenInAmount;

    const message = createBaseQuerySwapExactAmountOutResponse();
    message.tokenInAmount = (_object$tokenInAmount = object.tokenInAmount) !== null && _object$tokenInAmount !== void 0 ? _object$tokenInAmount : "";
    return message;
  },

  fromAmino(object) {
    return {
      tokenInAmount: object.token_in_amount
    };
  },

  toAmino(message) {
    const obj = {};
    obj.token_in_amount = message.tokenInAmount;
    return obj;
  },

  fromAminoMsg(object) {
    return QuerySwapExactAmountOutResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/gamm/query-swap-exact-amount-out-response",
      value: QuerySwapExactAmountOutResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QuerySwapExactAmountOutResponse.decode(message.value);
  },

  toProto(message) {
    return QuerySwapExactAmountOutResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.QuerySwapExactAmountOutResponse",
      value: QuerySwapExactAmountOutResponse.encode(message).finish()
    };
  }

};

function createBaseQueryTotalLiquidityRequest() {
  return {};
}

const QueryTotalLiquidityRequest = {
  typeUrl: "/osmosis.gamm.v1beta1.QueryTotalLiquidityRequest",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryTotalLiquidityRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseQueryTotalLiquidityRequest();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return QueryTotalLiquidityRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/gamm/query-total-liquidity-request",
      value: QueryTotalLiquidityRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryTotalLiquidityRequest.decode(message.value);
  },

  toProto(message) {
    return QueryTotalLiquidityRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.QueryTotalLiquidityRequest",
      value: QueryTotalLiquidityRequest.encode(message).finish()
    };
  }

};

function createBaseQueryTotalLiquidityResponse() {
  return {
    liquidity: []
  };
}

const QueryTotalLiquidityResponse = {
  typeUrl: "/osmosis.gamm.v1beta1.QueryTotalLiquidityResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Writer.create()) {
    for (const v of message.liquidity) {
      _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.encode(v, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryTotalLiquidityResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.liquidity.push(_cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$liquidity2;

    const message = createBaseQueryTotalLiquidityResponse();
    message.liquidity = ((_object$liquidity2 = object.liquidity) === null || _object$liquidity2 === void 0 ? void 0 : _object$liquidity2.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      liquidity: Array.isArray(object === null || object === void 0 ? void 0 : object.liquidity) ? object.liquidity.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.liquidity) {
      obj.liquidity = message.liquidity.map(e => e ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.toAmino(e) : undefined);
    } else {
      obj.liquidity = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return QueryTotalLiquidityResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/gamm/query-total-liquidity-response",
      value: QueryTotalLiquidityResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryTotalLiquidityResponse.decode(message.value);
  },

  toProto(message) {
    return QueryTotalLiquidityResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.QueryTotalLiquidityResponse",
      value: QueryTotalLiquidityResponse.encode(message).finish()
    };
  }

};

function createBaseQueryConcentratedPoolIdLinkFromCFMMRequest() {
  return {
    cfmmPoolId: _helpers__WEBPACK_IMPORTED_MODULE_8__/* .Long.UZERO */ .dK.UZERO
  };
}

const QueryConcentratedPoolIdLinkFromCFMMRequest = {
  typeUrl: "/osmosis.gamm.v1beta1.QueryConcentratedPoolIdLinkFromCFMMRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Writer.create()) {
    if (!message.cfmmPoolId.isZero()) {
      writer.uint32(8).uint64(message.cfmmPoolId);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryConcentratedPoolIdLinkFromCFMMRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.cfmmPoolId = reader.uint64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseQueryConcentratedPoolIdLinkFromCFMMRequest();
    message.cfmmPoolId = object.cfmmPoolId !== undefined && object.cfmmPoolId !== null ? _helpers__WEBPACK_IMPORTED_MODULE_8__/* .Long.fromValue */ .dK.fromValue(object.cfmmPoolId) : _helpers__WEBPACK_IMPORTED_MODULE_8__/* .Long.UZERO */ .dK.UZERO;
    return message;
  },

  fromAmino(object) {
    return {
      cfmmPoolId: _helpers__WEBPACK_IMPORTED_MODULE_8__/* .Long.fromString */ .dK.fromString(object.cfmm_pool_id)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.cfmm_pool_id = message.cfmmPoolId ? message.cfmmPoolId.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryConcentratedPoolIdLinkFromCFMMRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/gamm/query-concentrated-pool-id-link-from-cfmm-request",
      value: QueryConcentratedPoolIdLinkFromCFMMRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryConcentratedPoolIdLinkFromCFMMRequest.decode(message.value);
  },

  toProto(message) {
    return QueryConcentratedPoolIdLinkFromCFMMRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.QueryConcentratedPoolIdLinkFromCFMMRequest",
      value: QueryConcentratedPoolIdLinkFromCFMMRequest.encode(message).finish()
    };
  }

};

function createBaseQueryConcentratedPoolIdLinkFromCFMMResponse() {
  return {
    concentratedPoolId: _helpers__WEBPACK_IMPORTED_MODULE_8__/* .Long.UZERO */ .dK.UZERO
  };
}

const QueryConcentratedPoolIdLinkFromCFMMResponse = {
  typeUrl: "/osmosis.gamm.v1beta1.QueryConcentratedPoolIdLinkFromCFMMResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Writer.create()) {
    if (!message.concentratedPoolId.isZero()) {
      writer.uint32(8).uint64(message.concentratedPoolId);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryConcentratedPoolIdLinkFromCFMMResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.concentratedPoolId = reader.uint64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseQueryConcentratedPoolIdLinkFromCFMMResponse();
    message.concentratedPoolId = object.concentratedPoolId !== undefined && object.concentratedPoolId !== null ? _helpers__WEBPACK_IMPORTED_MODULE_8__/* .Long.fromValue */ .dK.fromValue(object.concentratedPoolId) : _helpers__WEBPACK_IMPORTED_MODULE_8__/* .Long.UZERO */ .dK.UZERO;
    return message;
  },

  fromAmino(object) {
    return {
      concentratedPoolId: _helpers__WEBPACK_IMPORTED_MODULE_8__/* .Long.fromString */ .dK.fromString(object.concentrated_pool_id)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.concentrated_pool_id = message.concentratedPoolId ? message.concentratedPoolId.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryConcentratedPoolIdLinkFromCFMMResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/gamm/query-concentrated-pool-id-link-from-cfmm-response",
      value: QueryConcentratedPoolIdLinkFromCFMMResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryConcentratedPoolIdLinkFromCFMMResponse.decode(message.value);
  },

  toProto(message) {
    return QueryConcentratedPoolIdLinkFromCFMMResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.QueryConcentratedPoolIdLinkFromCFMMResponse",
      value: QueryConcentratedPoolIdLinkFromCFMMResponse.encode(message).finish()
    };
  }

};
const PoolI_InterfaceDecoder = input => {
  const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Reader(input);
  const data = _google_protobuf_any__WEBPACK_IMPORTED_MODULE_3__.Any.decode(reader, reader.uint32());

  switch (data.typeUrl) {
    case "/osmosis.concentratedliquidity.v1beta1.Pool":
      return _concentrated_liquidity_pool__WEBPACK_IMPORTED_MODULE_4__/* .Pool.decode */ .K.decode(data.value);

    case "/osmosis.cosmwasmpool.v1beta1.CosmWasmPool":
      return _cosmwasmpool_v1beta1_model_pool__WEBPACK_IMPORTED_MODULE_5__.CosmWasmPool.decode(data.value);

    case "/osmosis.gamm.v1beta1.Pool":
      return _pool_models_balancer_balancerPool__WEBPACK_IMPORTED_MODULE_6__.Pool.decode(data.value);

    case "/osmosis.gamm.poolmodels.stableswap.v1beta1.Pool":
      return _pool_models_stableswap_stableswap_pool__WEBPACK_IMPORTED_MODULE_7__.Pool.decode(data.value);

    default:
      return data;
  }
};
const PoolI_FromAmino = content => {
  switch (content.type) {
    case "osmosis/concentratedliquidity/pool":
      return _google_protobuf_any__WEBPACK_IMPORTED_MODULE_3__.Any.fromPartial({
        typeUrl: "/osmosis.concentratedliquidity.v1beta1.Pool",
        value: _concentrated_liquidity_pool__WEBPACK_IMPORTED_MODULE_4__/* .Pool.encode */ .K.encode(_concentrated_liquidity_pool__WEBPACK_IMPORTED_MODULE_4__/* .Pool.fromPartial */ .K.fromPartial(_concentrated_liquidity_pool__WEBPACK_IMPORTED_MODULE_4__/* .Pool.fromAmino */ .K.fromAmino(content.value))).finish()
      });

    case "osmosis/cosmwasmpool/cosm-wasm-pool":
      return _google_protobuf_any__WEBPACK_IMPORTED_MODULE_3__.Any.fromPartial({
        typeUrl: "/osmosis.cosmwasmpool.v1beta1.CosmWasmPool",
        value: _cosmwasmpool_v1beta1_model_pool__WEBPACK_IMPORTED_MODULE_5__.CosmWasmPool.encode(_cosmwasmpool_v1beta1_model_pool__WEBPACK_IMPORTED_MODULE_5__.CosmWasmPool.fromPartial(_cosmwasmpool_v1beta1_model_pool__WEBPACK_IMPORTED_MODULE_5__.CosmWasmPool.fromAmino(content.value))).finish()
      });

    case "osmosis/gamm/BalancerPool":
      return _google_protobuf_any__WEBPACK_IMPORTED_MODULE_3__.Any.fromPartial({
        typeUrl: "/osmosis.gamm.v1beta1.Pool",
        value: _pool_models_balancer_balancerPool__WEBPACK_IMPORTED_MODULE_6__.Pool.encode(_pool_models_balancer_balancerPool__WEBPACK_IMPORTED_MODULE_6__.Pool.fromPartial(_pool_models_balancer_balancerPool__WEBPACK_IMPORTED_MODULE_6__.Pool.fromAmino(content.value))).finish()
      });

    case "osmosis/gamm/StableswapPool":
      return _google_protobuf_any__WEBPACK_IMPORTED_MODULE_3__.Any.fromPartial({
        typeUrl: "/osmosis.gamm.poolmodels.stableswap.v1beta1.Pool",
        value: _pool_models_stableswap_stableswap_pool__WEBPACK_IMPORTED_MODULE_7__.Pool.encode(_pool_models_stableswap_stableswap_pool__WEBPACK_IMPORTED_MODULE_7__.Pool.fromPartial(_pool_models_stableswap_stableswap_pool__WEBPACK_IMPORTED_MODULE_7__.Pool.fromAmino(content.value))).finish()
      });

    default:
      return _google_protobuf_any__WEBPACK_IMPORTED_MODULE_3__.Any.fromAmino(content);
  }
};
const PoolI_ToAmino = content => {
  switch (content.typeUrl) {
    case "/osmosis.concentratedliquidity.v1beta1.Pool":
      return {
        type: "osmosis/concentratedliquidity/pool",
        value: _concentrated_liquidity_pool__WEBPACK_IMPORTED_MODULE_4__/* .Pool.toAmino */ .K.toAmino(_concentrated_liquidity_pool__WEBPACK_IMPORTED_MODULE_4__/* .Pool.decode */ .K.decode(content.value))
      };

    case "/osmosis.cosmwasmpool.v1beta1.CosmWasmPool":
      return {
        type: "osmosis/cosmwasmpool/cosm-wasm-pool",
        value: _cosmwasmpool_v1beta1_model_pool__WEBPACK_IMPORTED_MODULE_5__.CosmWasmPool.toAmino(_cosmwasmpool_v1beta1_model_pool__WEBPACK_IMPORTED_MODULE_5__.CosmWasmPool.decode(content.value))
      };

    case "/osmosis.gamm.v1beta1.Pool":
      return {
        type: "osmosis/gamm/BalancerPool",
        value: _pool_models_balancer_balancerPool__WEBPACK_IMPORTED_MODULE_6__.Pool.toAmino(_pool_models_balancer_balancerPool__WEBPACK_IMPORTED_MODULE_6__.Pool.decode(content.value))
      };

    case "/osmosis.gamm.poolmodels.stableswap.v1beta1.Pool":
      return {
        type: "osmosis/gamm/StableswapPool",
        value: _pool_models_stableswap_stableswap_pool__WEBPACK_IMPORTED_MODULE_7__.Pool.toAmino(_pool_models_stableswap_stableswap_pool__WEBPACK_IMPORTED_MODULE_7__.Pool.decode(content.value))
      };

    default:
      return _google_protobuf_any__WEBPACK_IMPORTED_MODULE_3__.Any.toAmino(content);
  }
};

/***/ }),

/***/ 62743:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LCDQueryClient": function() { return /* binding */ LCDQueryClient; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4942);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47895);


class LCDQueryClient {
  constructor({
    requestClient
  }) {
    (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, "req", void 0);

    this.req = requestClient;
    this.pools = this.pools.bind(this);
    this.numPools = this.numPools.bind(this);
    this.totalLiquidity = this.totalLiquidity.bind(this);
    this.poolsWithFilter = this.poolsWithFilter.bind(this);
    this.pool = this.pool.bind(this);
    this.poolType = this.poolType.bind(this);
    this.calcJoinPoolShares = this.calcJoinPoolShares.bind(this);
    this.calcExitPoolCoinsFromShares = this.calcExitPoolCoinsFromShares.bind(this);
    this.poolParams = this.poolParams.bind(this);
    this.totalPoolLiquidity = this.totalPoolLiquidity.bind(this);
    this.totalShares = this.totalShares.bind(this);
    this.spotPrice = this.spotPrice.bind(this);
    this.estimateSwapExactAmountIn = this.estimateSwapExactAmountIn.bind(this);
    this.estimateSwapExactAmountOut = this.estimateSwapExactAmountOut.bind(this);
    this.concentratedPoolIdLinkFromCFMM = this.concentratedPoolIdLinkFromCFMM.bind(this);
  }
  /* Pools */


  async pools(params = {
    pagination: undefined
  }) {
    const options = {
      params: {}
    };

    if (typeof (params === null || params === void 0 ? void 0 : params.pagination) !== "undefined") {
      (0,_helpers__WEBPACK_IMPORTED_MODULE_0__/* .setPaginationParams */ .q6)(options, params.pagination);
    }

    const endpoint = `osmosis/gamm/v1beta1/pools`;
    return await this.req.get(endpoint, options);
  }
  /* Deprecated: please use the alternative in x/poolmanager */


  async numPools(_params = {}) {
    const endpoint = `osmosis/gamm/v1beta1/num_pools`;
    return await this.req.get(endpoint);
  }
  /* TotalLiquidity */


  async totalLiquidity(_params = {}) {
    const endpoint = `osmosis/gamm/v1beta1/total_liquidity`;
    return await this.req.get(endpoint);
  }
  /* PoolsWithFilter allows you to query specific pools with requested
   parameters */


  async poolsWithFilter(params) {
    const options = {
      params: {}
    };

    if (typeof (params === null || params === void 0 ? void 0 : params.minLiquidity) !== "undefined") {
      options.params.min_liquidity = params.minLiquidity;
    }

    if (typeof (params === null || params === void 0 ? void 0 : params.poolType) !== "undefined") {
      options.params.pool_type = params.poolType;
    }

    if (typeof (params === null || params === void 0 ? void 0 : params.pagination) !== "undefined") {
      (0,_helpers__WEBPACK_IMPORTED_MODULE_0__/* .setPaginationParams */ .q6)(options, params.pagination);
    }

    const endpoint = `osmosis/gamm/v1beta1/filtered_pools`;
    return await this.req.get(endpoint, options);
  }
  /* Deprecated: please use the alternative in x/poolmanager */


  async pool(params) {
    const endpoint = `osmosis/gamm/v1beta1/pools/${params.poolId}`;
    return await this.req.get(endpoint);
  }
  /* PoolType returns the type of the pool.
   Returns "Balancer" as a string literal when the pool is a balancer pool.
   Errors if the pool is failed to be type caseted. */


  async poolType(params) {
    const endpoint = `osmosis/gamm/v1beta1/pool_type/${params.poolId}`;
    return await this.req.get(endpoint);
  }
  /* CalcJoinPoolShares */


  async calcJoinPoolShares(params) {
    const options = {
      params: {}
    };

    if (typeof (params === null || params === void 0 ? void 0 : params.tokensIn) !== "undefined") {
      options.params.tokens_in = params.tokensIn;
    }

    const endpoint = `osmosis/gamm/v1beta1/pools/${params.poolId}/join_swap_exact_in`;
    return await this.req.get(endpoint, options);
  }
  /* CalcExitPoolCoinsFromShares */


  async calcExitPoolCoinsFromShares(params) {
    const options = {
      params: {}
    };

    if (typeof (params === null || params === void 0 ? void 0 : params.shareInAmount) !== "undefined") {
      options.params.share_in_amount = params.shareInAmount;
    }

    const endpoint = `osmosis/gamm/v1beta1/pools/${params.poolId}/exit_swap_share_amount_in`;
    return await this.req.get(endpoint, options);
  }
  /* PoolParams */


  async poolParams(params) {
    const endpoint = `osmosis/gamm/v1beta1/pools/${params.poolId}/params`;
    return await this.req.get(endpoint);
  }
  /* Deprecated: please use the alternative in x/poolmanager */


  async totalPoolLiquidity(params) {
    const endpoint = `osmosis/gamm/v1beta1/pools/${params.poolId}/total_pool_liquidity`;
    return await this.req.get(endpoint);
  }
  /* TotalShares */


  async totalShares(params) {
    const endpoint = `osmosis/gamm/v1beta1/pools/${params.poolId}/total_shares`;
    return await this.req.get(endpoint);
  }
  /* SpotPrice defines a gRPC query handler that returns the spot price given
   a base denomination and a quote denomination. */


  async spotPrice(params) {
    const options = {
      params: {}
    };

    if (typeof (params === null || params === void 0 ? void 0 : params.baseAssetDenom) !== "undefined") {
      options.params.base_asset_denom = params.baseAssetDenom;
    }

    if (typeof (params === null || params === void 0 ? void 0 : params.quoteAssetDenom) !== "undefined") {
      options.params.quote_asset_denom = params.quoteAssetDenom;
    }

    const endpoint = `osmosis/gamm/v1beta1/pools/${params.poolId}/prices`;
    return await this.req.get(endpoint, options);
  }
  /* Deprecated: please use the alternative in x/poolmanager */


  async estimateSwapExactAmountIn(params) {
    const options = {
      params: {}
    };

    if (typeof (params === null || params === void 0 ? void 0 : params.sender) !== "undefined") {
      options.params.sender = params.sender;
    }

    if (typeof (params === null || params === void 0 ? void 0 : params.tokenIn) !== "undefined") {
      options.params.token_in = params.tokenIn;
    }

    if (typeof (params === null || params === void 0 ? void 0 : params.routes) !== "undefined") {
      options.params.routes = params.routes;
    }

    const endpoint = `osmosis/gamm/v1beta1/${params.poolId}/estimate/swap_exact_amount_in`;
    return await this.req.get(endpoint, options);
  }
  /* Deprecated: please use the alternative in x/poolmanager */


  async estimateSwapExactAmountOut(params) {
    const options = {
      params: {}
    };

    if (typeof (params === null || params === void 0 ? void 0 : params.sender) !== "undefined") {
      options.params.sender = params.sender;
    }

    if (typeof (params === null || params === void 0 ? void 0 : params.routes) !== "undefined") {
      options.params.routes = params.routes;
    }

    if (typeof (params === null || params === void 0 ? void 0 : params.tokenOut) !== "undefined") {
      options.params.token_out = params.tokenOut;
    }

    const endpoint = `osmosis/gamm/v1beta1/${params.poolId}/estimate/swap_exact_amount_out`;
    return await this.req.get(endpoint, options);
  }
  /* ConcentratedPoolIdLinkFromBalancer returns the pool id of the concentrated
   pool that is linked with the given CFMM pool. */


  async concentratedPoolIdLinkFromCFMM(params) {
    const endpoint = `osmosis/gamm/v1beta1/concentrated_pool_id_link_from_cfmm/${params.cfmmPoolId}`;
    return await this.req.get(endpoint);
  }

}

/***/ }),

/***/ 47198:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QueryClientImpl": function() { return /* binding */ QueryClientImpl; },
/* harmony export */   "createRpcQueryExtension": function() { return /* binding */ createRpcQueryExtension; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4942);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78441);
/* harmony import */ var _cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1126);




class QueryClientImpl {
  constructor(rpc) {
    (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, "rpc", void 0);

    this.rpc = rpc;
    this.pools = this.pools.bind(this);
    this.numPools = this.numPools.bind(this);
    this.totalLiquidity = this.totalLiquidity.bind(this);
    this.poolsWithFilter = this.poolsWithFilter.bind(this);
    this.pool = this.pool.bind(this);
    this.poolType = this.poolType.bind(this);
    this.calcJoinPoolNoSwapShares = this.calcJoinPoolNoSwapShares.bind(this);
    this.calcJoinPoolShares = this.calcJoinPoolShares.bind(this);
    this.calcExitPoolCoinsFromShares = this.calcExitPoolCoinsFromShares.bind(this);
    this.poolParams = this.poolParams.bind(this);
    this.totalPoolLiquidity = this.totalPoolLiquidity.bind(this);
    this.totalShares = this.totalShares.bind(this);
    this.spotPrice = this.spotPrice.bind(this);
    this.estimateSwapExactAmountIn = this.estimateSwapExactAmountIn.bind(this);
    this.estimateSwapExactAmountOut = this.estimateSwapExactAmountOut.bind(this);
    this.concentratedPoolIdLinkFromCFMM = this.concentratedPoolIdLinkFromCFMM.bind(this);
  }

  pools(request = {
    pagination: undefined
  }) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryPoolsRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.gamm.v1beta1.Query", "Pools", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryPoolsResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  numPools(request = {}) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryNumPoolsRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.gamm.v1beta1.Query", "NumPools", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryNumPoolsResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  totalLiquidity(request = {}) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryTotalLiquidityRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.gamm.v1beta1.Query", "TotalLiquidity", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryTotalLiquidityResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  poolsWithFilter(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryPoolsWithFilterRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.gamm.v1beta1.Query", "PoolsWithFilter", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryPoolsWithFilterResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  pool(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryPoolRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.gamm.v1beta1.Query", "Pool", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryPoolResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  poolType(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryPoolTypeRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.gamm.v1beta1.Query", "PoolType", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryPoolTypeResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  calcJoinPoolNoSwapShares(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryCalcJoinPoolNoSwapSharesRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.gamm.v1beta1.Query", "CalcJoinPoolNoSwapShares", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryCalcJoinPoolNoSwapSharesResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  calcJoinPoolShares(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryCalcJoinPoolSharesRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.gamm.v1beta1.Query", "CalcJoinPoolShares", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryCalcJoinPoolSharesResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  calcExitPoolCoinsFromShares(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryCalcExitPoolCoinsFromSharesRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.gamm.v1beta1.Query", "CalcExitPoolCoinsFromShares", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryCalcExitPoolCoinsFromSharesResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  poolParams(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryPoolParamsRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.gamm.v1beta1.Query", "PoolParams", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryPoolParamsResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  totalPoolLiquidity(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryTotalPoolLiquidityRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.gamm.v1beta1.Query", "TotalPoolLiquidity", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryTotalPoolLiquidityResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  totalShares(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryTotalSharesRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.gamm.v1beta1.Query", "TotalShares", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryTotalSharesResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  spotPrice(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QuerySpotPriceRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.gamm.v1beta1.Query", "SpotPrice", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QuerySpotPriceResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  estimateSwapExactAmountIn(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QuerySwapExactAmountInRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.gamm.v1beta1.Query", "EstimateSwapExactAmountIn", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QuerySwapExactAmountInResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  estimateSwapExactAmountOut(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QuerySwapExactAmountOutRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.gamm.v1beta1.Query", "EstimateSwapExactAmountOut", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QuerySwapExactAmountOutResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  concentratedPoolIdLinkFromCFMM(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryConcentratedPoolIdLinkFromCFMMRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.gamm.v1beta1.Query", "ConcentratedPoolIdLinkFromCFMM", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryConcentratedPoolIdLinkFromCFMMResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

}
const createRpcQueryExtension = base => {
  const rpc = (0,_cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1__.createProtobufRpcClient)(base);
  const queryService = new QueryClientImpl(rpc);
  return {
    pools(request) {
      return queryService.pools(request);
    },

    numPools(request) {
      return queryService.numPools(request);
    },

    totalLiquidity(request) {
      return queryService.totalLiquidity(request);
    },

    poolsWithFilter(request) {
      return queryService.poolsWithFilter(request);
    },

    pool(request) {
      return queryService.pool(request);
    },

    poolType(request) {
      return queryService.poolType(request);
    },

    calcJoinPoolNoSwapShares(request) {
      return queryService.calcJoinPoolNoSwapShares(request);
    },

    calcJoinPoolShares(request) {
      return queryService.calcJoinPoolShares(request);
    },

    calcExitPoolCoinsFromShares(request) {
      return queryService.calcExitPoolCoinsFromShares(request);
    },

    poolParams(request) {
      return queryService.poolParams(request);
    },

    totalPoolLiquidity(request) {
      return queryService.totalPoolLiquidity(request);
    },

    totalShares(request) {
      return queryService.totalShares(request);
    },

    spotPrice(request) {
      return queryService.spotPrice(request);
    },

    estimateSwapExactAmountIn(request) {
      return queryService.estimateSwapExactAmountIn(request);
    },

    estimateSwapExactAmountOut(request) {
      return queryService.estimateSwapExactAmountOut(request);
    },

    concentratedPoolIdLinkFromCFMM(request) {
      return queryService.concentratedPoolIdLinkFromCFMM(request);
    }

  };
};

/***/ }),

/***/ 86537:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MsgExitPool": function() { return /* binding */ MsgExitPool; },
/* harmony export */   "MsgExitPoolResponse": function() { return /* binding */ MsgExitPoolResponse; },
/* harmony export */   "MsgExitSwapExternAmountOut": function() { return /* binding */ MsgExitSwapExternAmountOut; },
/* harmony export */   "MsgExitSwapExternAmountOutResponse": function() { return /* binding */ MsgExitSwapExternAmountOutResponse; },
/* harmony export */   "MsgExitSwapShareAmountIn": function() { return /* binding */ MsgExitSwapShareAmountIn; },
/* harmony export */   "MsgExitSwapShareAmountInResponse": function() { return /* binding */ MsgExitSwapShareAmountInResponse; },
/* harmony export */   "MsgJoinPool": function() { return /* binding */ MsgJoinPool; },
/* harmony export */   "MsgJoinPoolResponse": function() { return /* binding */ MsgJoinPoolResponse; },
/* harmony export */   "MsgJoinSwapExternAmountIn": function() { return /* binding */ MsgJoinSwapExternAmountIn; },
/* harmony export */   "MsgJoinSwapExternAmountInResponse": function() { return /* binding */ MsgJoinSwapExternAmountInResponse; },
/* harmony export */   "MsgJoinSwapShareAmountOut": function() { return /* binding */ MsgJoinSwapShareAmountOut; },
/* harmony export */   "MsgJoinSwapShareAmountOutResponse": function() { return /* binding */ MsgJoinSwapShareAmountOutResponse; },
/* harmony export */   "MsgSwapExactAmountIn": function() { return /* binding */ MsgSwapExactAmountIn; },
/* harmony export */   "MsgSwapExactAmountInResponse": function() { return /* binding */ MsgSwapExactAmountInResponse; },
/* harmony export */   "MsgSwapExactAmountOut": function() { return /* binding */ MsgSwapExactAmountOut; },
/* harmony export */   "MsgSwapExactAmountOutResponse": function() { return /* binding */ MsgSwapExactAmountOutResponse; }
/* harmony export */ });
/* harmony import */ var _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26178);
/* harmony import */ var _poolmanager_v1beta1_swap_route__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23569);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47895);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__);




/**
 * ===================== MsgJoinPool
 * This is really MsgJoinPoolNoSwap
 */

function createBaseMsgJoinPool() {
  return {
    sender: "",
    poolId: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO,
    shareOutAmount: "",
    tokenInMaxs: []
  };
}

const MsgJoinPool = {
  typeUrl: "/osmosis.gamm.v1beta1.MsgJoinPool",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.sender !== "") {
      writer.uint32(10).string(message.sender);
    }

    if (!message.poolId.isZero()) {
      writer.uint32(16).uint64(message.poolId);
    }

    if (message.shareOutAmount !== "") {
      writer.uint32(26).string(message.shareOutAmount);
    }

    for (const v of message.tokenInMaxs) {
      _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.encode(v, writer.uint32(34).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgJoinPool();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.sender = reader.string();
          break;

        case 2:
          message.poolId = reader.uint64();
          break;

        case 3:
          message.shareOutAmount = reader.string();
          break;

        case 4:
          message.tokenInMaxs.push(_cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$sender, _object$shareOutAmoun, _object$tokenInMaxs;

    const message = createBaseMsgJoinPool();
    message.sender = (_object$sender = object.sender) !== null && _object$sender !== void 0 ? _object$sender : "";
    message.poolId = object.poolId !== undefined && object.poolId !== null ? _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromValue */ .dK.fromValue(object.poolId) : _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO;
    message.shareOutAmount = (_object$shareOutAmoun = object.shareOutAmount) !== null && _object$shareOutAmoun !== void 0 ? _object$shareOutAmoun : "";
    message.tokenInMaxs = ((_object$tokenInMaxs = object.tokenInMaxs) === null || _object$tokenInMaxs === void 0 ? void 0 : _object$tokenInMaxs.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      sender: object.sender,
      poolId: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromString */ .dK.fromString(object.pool_id),
      shareOutAmount: object.share_out_amount,
      tokenInMaxs: Array.isArray(object === null || object === void 0 ? void 0 : object.token_in_maxs) ? object.token_in_maxs.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.sender = message.sender;
    obj.pool_id = message.poolId ? message.poolId.toString() : undefined;
    obj.share_out_amount = message.shareOutAmount;

    if (message.tokenInMaxs) {
      obj.token_in_maxs = message.tokenInMaxs.map(e => e ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.toAmino(e) : undefined);
    } else {
      obj.token_in_maxs = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return MsgJoinPool.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/gamm/join-pool",
      value: MsgJoinPool.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgJoinPool.decode(message.value);
  },

  toProto(message) {
    return MsgJoinPool.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.MsgJoinPool",
      value: MsgJoinPool.encode(message).finish()
    };
  }

};

function createBaseMsgJoinPoolResponse() {
  return {
    shareOutAmount: "",
    tokenIn: []
  };
}

const MsgJoinPoolResponse = {
  typeUrl: "/osmosis.gamm.v1beta1.MsgJoinPoolResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.shareOutAmount !== "") {
      writer.uint32(10).string(message.shareOutAmount);
    }

    for (const v of message.tokenIn) {
      _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.encode(v, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgJoinPoolResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.shareOutAmount = reader.string();
          break;

        case 2:
          message.tokenIn.push(_cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$shareOutAmoun2, _object$tokenIn;

    const message = createBaseMsgJoinPoolResponse();
    message.shareOutAmount = (_object$shareOutAmoun2 = object.shareOutAmount) !== null && _object$shareOutAmoun2 !== void 0 ? _object$shareOutAmoun2 : "";
    message.tokenIn = ((_object$tokenIn = object.tokenIn) === null || _object$tokenIn === void 0 ? void 0 : _object$tokenIn.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      shareOutAmount: object.share_out_amount,
      tokenIn: Array.isArray(object === null || object === void 0 ? void 0 : object.token_in) ? object.token_in.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.share_out_amount = message.shareOutAmount;

    if (message.tokenIn) {
      obj.token_in = message.tokenIn.map(e => e ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.toAmino(e) : undefined);
    } else {
      obj.token_in = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return MsgJoinPoolResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/gamm/join-pool-response",
      value: MsgJoinPoolResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgJoinPoolResponse.decode(message.value);
  },

  toProto(message) {
    return MsgJoinPoolResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.MsgJoinPoolResponse",
      value: MsgJoinPoolResponse.encode(message).finish()
    };
  }

};

function createBaseMsgExitPool() {
  return {
    sender: "",
    poolId: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO,
    shareInAmount: "",
    tokenOutMins: []
  };
}

const MsgExitPool = {
  typeUrl: "/osmosis.gamm.v1beta1.MsgExitPool",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.sender !== "") {
      writer.uint32(10).string(message.sender);
    }

    if (!message.poolId.isZero()) {
      writer.uint32(16).uint64(message.poolId);
    }

    if (message.shareInAmount !== "") {
      writer.uint32(26).string(message.shareInAmount);
    }

    for (const v of message.tokenOutMins) {
      _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.encode(v, writer.uint32(34).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgExitPool();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.sender = reader.string();
          break;

        case 2:
          message.poolId = reader.uint64();
          break;

        case 3:
          message.shareInAmount = reader.string();
          break;

        case 4:
          message.tokenOutMins.push(_cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$sender2, _object$shareInAmount, _object$tokenOutMins;

    const message = createBaseMsgExitPool();
    message.sender = (_object$sender2 = object.sender) !== null && _object$sender2 !== void 0 ? _object$sender2 : "";
    message.poolId = object.poolId !== undefined && object.poolId !== null ? _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromValue */ .dK.fromValue(object.poolId) : _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO;
    message.shareInAmount = (_object$shareInAmount = object.shareInAmount) !== null && _object$shareInAmount !== void 0 ? _object$shareInAmount : "";
    message.tokenOutMins = ((_object$tokenOutMins = object.tokenOutMins) === null || _object$tokenOutMins === void 0 ? void 0 : _object$tokenOutMins.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      sender: object.sender,
      poolId: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromString */ .dK.fromString(object.pool_id),
      shareInAmount: object.share_in_amount,
      tokenOutMins: Array.isArray(object === null || object === void 0 ? void 0 : object.token_out_mins) ? object.token_out_mins.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.sender = message.sender;
    obj.pool_id = message.poolId ? message.poolId.toString() : undefined;
    obj.share_in_amount = message.shareInAmount;

    if (message.tokenOutMins) {
      obj.token_out_mins = message.tokenOutMins.map(e => e ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.toAmino(e) : undefined);
    } else {
      obj.token_out_mins = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return MsgExitPool.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/gamm/exit-pool",
      value: MsgExitPool.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgExitPool.decode(message.value);
  },

  toProto(message) {
    return MsgExitPool.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.MsgExitPool",
      value: MsgExitPool.encode(message).finish()
    };
  }

};

function createBaseMsgExitPoolResponse() {
  return {
    tokenOut: []
  };
}

const MsgExitPoolResponse = {
  typeUrl: "/osmosis.gamm.v1beta1.MsgExitPoolResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    for (const v of message.tokenOut) {
      _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.encode(v, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgExitPoolResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.tokenOut.push(_cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$tokenOut;

    const message = createBaseMsgExitPoolResponse();
    message.tokenOut = ((_object$tokenOut = object.tokenOut) === null || _object$tokenOut === void 0 ? void 0 : _object$tokenOut.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      tokenOut: Array.isArray(object === null || object === void 0 ? void 0 : object.token_out) ? object.token_out.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.tokenOut) {
      obj.token_out = message.tokenOut.map(e => e ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.toAmino(e) : undefined);
    } else {
      obj.token_out = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return MsgExitPoolResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/gamm/exit-pool-response",
      value: MsgExitPoolResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgExitPoolResponse.decode(message.value);
  },

  toProto(message) {
    return MsgExitPoolResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.MsgExitPoolResponse",
      value: MsgExitPoolResponse.encode(message).finish()
    };
  }

};

function createBaseMsgSwapExactAmountIn() {
  return {
    sender: "",
    routes: [],
    tokenIn: undefined,
    tokenOutMinAmount: ""
  };
}

const MsgSwapExactAmountIn = {
  typeUrl: "/osmosis.gamm.v1beta1.MsgSwapExactAmountIn",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.sender !== "") {
      writer.uint32(10).string(message.sender);
    }

    for (const v of message.routes) {
      _poolmanager_v1beta1_swap_route__WEBPACK_IMPORTED_MODULE_1__.SwapAmountInRoute.encode(v, writer.uint32(18).fork()).ldelim();
    }

    if (message.tokenIn !== undefined) {
      _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.encode(message.tokenIn, writer.uint32(26).fork()).ldelim();
    }

    if (message.tokenOutMinAmount !== "") {
      writer.uint32(34).string(message.tokenOutMinAmount);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgSwapExactAmountIn();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.sender = reader.string();
          break;

        case 2:
          message.routes.push(_poolmanager_v1beta1_swap_route__WEBPACK_IMPORTED_MODULE_1__.SwapAmountInRoute.decode(reader, reader.uint32()));
          break;

        case 3:
          message.tokenIn = _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.decode(reader, reader.uint32());
          break;

        case 4:
          message.tokenOutMinAmount = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$sender3, _object$routes, _object$tokenOutMinAm;

    const message = createBaseMsgSwapExactAmountIn();
    message.sender = (_object$sender3 = object.sender) !== null && _object$sender3 !== void 0 ? _object$sender3 : "";
    message.routes = ((_object$routes = object.routes) === null || _object$routes === void 0 ? void 0 : _object$routes.map(e => _poolmanager_v1beta1_swap_route__WEBPACK_IMPORTED_MODULE_1__.SwapAmountInRoute.fromPartial(e))) || [];
    message.tokenIn = object.tokenIn !== undefined && object.tokenIn !== null ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.fromPartial(object.tokenIn) : undefined;
    message.tokenOutMinAmount = (_object$tokenOutMinAm = object.tokenOutMinAmount) !== null && _object$tokenOutMinAm !== void 0 ? _object$tokenOutMinAm : "";
    return message;
  },

  fromAmino(object) {
    return {
      sender: object.sender,
      routes: Array.isArray(object === null || object === void 0 ? void 0 : object.routes) ? object.routes.map(e => _poolmanager_v1beta1_swap_route__WEBPACK_IMPORTED_MODULE_1__.SwapAmountInRoute.fromAmino(e)) : [],
      tokenIn: object !== null && object !== void 0 && object.token_in ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.fromAmino(object.token_in) : undefined,
      tokenOutMinAmount: object.token_out_min_amount
    };
  },

  toAmino(message) {
    const obj = {};
    obj.sender = message.sender;

    if (message.routes) {
      obj.routes = message.routes.map(e => e ? _poolmanager_v1beta1_swap_route__WEBPACK_IMPORTED_MODULE_1__.SwapAmountInRoute.toAmino(e) : undefined);
    } else {
      obj.routes = [];
    }

    obj.token_in = message.tokenIn ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.toAmino(message.tokenIn) : undefined;
    obj.token_out_min_amount = message.tokenOutMinAmount;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgSwapExactAmountIn.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/gamm/swap-exact-amount-in",
      value: MsgSwapExactAmountIn.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgSwapExactAmountIn.decode(message.value);
  },

  toProto(message) {
    return MsgSwapExactAmountIn.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.MsgSwapExactAmountIn",
      value: MsgSwapExactAmountIn.encode(message).finish()
    };
  }

};

function createBaseMsgSwapExactAmountInResponse() {
  return {
    tokenOutAmount: ""
  };
}

const MsgSwapExactAmountInResponse = {
  typeUrl: "/osmosis.gamm.v1beta1.MsgSwapExactAmountInResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.tokenOutAmount !== "") {
      writer.uint32(10).string(message.tokenOutAmount);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgSwapExactAmountInResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.tokenOutAmount = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$tokenOutAmoun;

    const message = createBaseMsgSwapExactAmountInResponse();
    message.tokenOutAmount = (_object$tokenOutAmoun = object.tokenOutAmount) !== null && _object$tokenOutAmoun !== void 0 ? _object$tokenOutAmoun : "";
    return message;
  },

  fromAmino(object) {
    return {
      tokenOutAmount: object.token_out_amount
    };
  },

  toAmino(message) {
    const obj = {};
    obj.token_out_amount = message.tokenOutAmount;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgSwapExactAmountInResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/gamm/swap-exact-amount-in-response",
      value: MsgSwapExactAmountInResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgSwapExactAmountInResponse.decode(message.value);
  },

  toProto(message) {
    return MsgSwapExactAmountInResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.MsgSwapExactAmountInResponse",
      value: MsgSwapExactAmountInResponse.encode(message).finish()
    };
  }

};

function createBaseMsgSwapExactAmountOut() {
  return {
    sender: "",
    routes: [],
    tokenInMaxAmount: "",
    tokenOut: undefined
  };
}

const MsgSwapExactAmountOut = {
  typeUrl: "/osmosis.gamm.v1beta1.MsgSwapExactAmountOut",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.sender !== "") {
      writer.uint32(10).string(message.sender);
    }

    for (const v of message.routes) {
      _poolmanager_v1beta1_swap_route__WEBPACK_IMPORTED_MODULE_1__.SwapAmountOutRoute.encode(v, writer.uint32(18).fork()).ldelim();
    }

    if (message.tokenInMaxAmount !== "") {
      writer.uint32(26).string(message.tokenInMaxAmount);
    }

    if (message.tokenOut !== undefined) {
      _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.encode(message.tokenOut, writer.uint32(34).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgSwapExactAmountOut();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.sender = reader.string();
          break;

        case 2:
          message.routes.push(_poolmanager_v1beta1_swap_route__WEBPACK_IMPORTED_MODULE_1__.SwapAmountOutRoute.decode(reader, reader.uint32()));
          break;

        case 3:
          message.tokenInMaxAmount = reader.string();
          break;

        case 4:
          message.tokenOut = _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$sender4, _object$routes2, _object$tokenInMaxAmo;

    const message = createBaseMsgSwapExactAmountOut();
    message.sender = (_object$sender4 = object.sender) !== null && _object$sender4 !== void 0 ? _object$sender4 : "";
    message.routes = ((_object$routes2 = object.routes) === null || _object$routes2 === void 0 ? void 0 : _object$routes2.map(e => _poolmanager_v1beta1_swap_route__WEBPACK_IMPORTED_MODULE_1__.SwapAmountOutRoute.fromPartial(e))) || [];
    message.tokenInMaxAmount = (_object$tokenInMaxAmo = object.tokenInMaxAmount) !== null && _object$tokenInMaxAmo !== void 0 ? _object$tokenInMaxAmo : "";
    message.tokenOut = object.tokenOut !== undefined && object.tokenOut !== null ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.fromPartial(object.tokenOut) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      sender: object.sender,
      routes: Array.isArray(object === null || object === void 0 ? void 0 : object.routes) ? object.routes.map(e => _poolmanager_v1beta1_swap_route__WEBPACK_IMPORTED_MODULE_1__.SwapAmountOutRoute.fromAmino(e)) : [],
      tokenInMaxAmount: object.token_in_max_amount,
      tokenOut: object !== null && object !== void 0 && object.token_out ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.fromAmino(object.token_out) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.sender = message.sender;

    if (message.routes) {
      obj.routes = message.routes.map(e => e ? _poolmanager_v1beta1_swap_route__WEBPACK_IMPORTED_MODULE_1__.SwapAmountOutRoute.toAmino(e) : undefined);
    } else {
      obj.routes = [];
    }

    obj.token_in_max_amount = message.tokenInMaxAmount;
    obj.token_out = message.tokenOut ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.toAmino(message.tokenOut) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgSwapExactAmountOut.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/gamm/swap-exact-amount-out",
      value: MsgSwapExactAmountOut.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgSwapExactAmountOut.decode(message.value);
  },

  toProto(message) {
    return MsgSwapExactAmountOut.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.MsgSwapExactAmountOut",
      value: MsgSwapExactAmountOut.encode(message).finish()
    };
  }

};

function createBaseMsgSwapExactAmountOutResponse() {
  return {
    tokenInAmount: ""
  };
}

const MsgSwapExactAmountOutResponse = {
  typeUrl: "/osmosis.gamm.v1beta1.MsgSwapExactAmountOutResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.tokenInAmount !== "") {
      writer.uint32(10).string(message.tokenInAmount);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgSwapExactAmountOutResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.tokenInAmount = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$tokenInAmount;

    const message = createBaseMsgSwapExactAmountOutResponse();
    message.tokenInAmount = (_object$tokenInAmount = object.tokenInAmount) !== null && _object$tokenInAmount !== void 0 ? _object$tokenInAmount : "";
    return message;
  },

  fromAmino(object) {
    return {
      tokenInAmount: object.token_in_amount
    };
  },

  toAmino(message) {
    const obj = {};
    obj.token_in_amount = message.tokenInAmount;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgSwapExactAmountOutResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/gamm/swap-exact-amount-out-response",
      value: MsgSwapExactAmountOutResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgSwapExactAmountOutResponse.decode(message.value);
  },

  toProto(message) {
    return MsgSwapExactAmountOutResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.MsgSwapExactAmountOutResponse",
      value: MsgSwapExactAmountOutResponse.encode(message).finish()
    };
  }

};

function createBaseMsgJoinSwapExternAmountIn() {
  return {
    sender: "",
    poolId: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO,
    tokenIn: undefined,
    shareOutMinAmount: ""
  };
}

const MsgJoinSwapExternAmountIn = {
  typeUrl: "/osmosis.gamm.v1beta1.MsgJoinSwapExternAmountIn",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.sender !== "") {
      writer.uint32(10).string(message.sender);
    }

    if (!message.poolId.isZero()) {
      writer.uint32(16).uint64(message.poolId);
    }

    if (message.tokenIn !== undefined) {
      _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.encode(message.tokenIn, writer.uint32(26).fork()).ldelim();
    }

    if (message.shareOutMinAmount !== "") {
      writer.uint32(34).string(message.shareOutMinAmount);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgJoinSwapExternAmountIn();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.sender = reader.string();
          break;

        case 2:
          message.poolId = reader.uint64();
          break;

        case 3:
          message.tokenIn = _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.decode(reader, reader.uint32());
          break;

        case 4:
          message.shareOutMinAmount = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$sender5, _object$shareOutMinAm;

    const message = createBaseMsgJoinSwapExternAmountIn();
    message.sender = (_object$sender5 = object.sender) !== null && _object$sender5 !== void 0 ? _object$sender5 : "";
    message.poolId = object.poolId !== undefined && object.poolId !== null ? _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromValue */ .dK.fromValue(object.poolId) : _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO;
    message.tokenIn = object.tokenIn !== undefined && object.tokenIn !== null ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.fromPartial(object.tokenIn) : undefined;
    message.shareOutMinAmount = (_object$shareOutMinAm = object.shareOutMinAmount) !== null && _object$shareOutMinAm !== void 0 ? _object$shareOutMinAm : "";
    return message;
  },

  fromAmino(object) {
    return {
      sender: object.sender,
      poolId: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromString */ .dK.fromString(object.pool_id),
      tokenIn: object !== null && object !== void 0 && object.token_in ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.fromAmino(object.token_in) : undefined,
      shareOutMinAmount: object.share_out_min_amount
    };
  },

  toAmino(message) {
    const obj = {};
    obj.sender = message.sender;
    obj.pool_id = message.poolId ? message.poolId.toString() : undefined;
    obj.token_in = message.tokenIn ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.toAmino(message.tokenIn) : undefined;
    obj.share_out_min_amount = message.shareOutMinAmount;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgJoinSwapExternAmountIn.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/gamm/join-swap-extern-amount-in",
      value: MsgJoinSwapExternAmountIn.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgJoinSwapExternAmountIn.decode(message.value);
  },

  toProto(message) {
    return MsgJoinSwapExternAmountIn.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.MsgJoinSwapExternAmountIn",
      value: MsgJoinSwapExternAmountIn.encode(message).finish()
    };
  }

};

function createBaseMsgJoinSwapExternAmountInResponse() {
  return {
    shareOutAmount: ""
  };
}

const MsgJoinSwapExternAmountInResponse = {
  typeUrl: "/osmosis.gamm.v1beta1.MsgJoinSwapExternAmountInResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.shareOutAmount !== "") {
      writer.uint32(10).string(message.shareOutAmount);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgJoinSwapExternAmountInResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.shareOutAmount = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$shareOutAmoun3;

    const message = createBaseMsgJoinSwapExternAmountInResponse();
    message.shareOutAmount = (_object$shareOutAmoun3 = object.shareOutAmount) !== null && _object$shareOutAmoun3 !== void 0 ? _object$shareOutAmoun3 : "";
    return message;
  },

  fromAmino(object) {
    return {
      shareOutAmount: object.share_out_amount
    };
  },

  toAmino(message) {
    const obj = {};
    obj.share_out_amount = message.shareOutAmount;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgJoinSwapExternAmountInResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/gamm/join-swap-extern-amount-in-response",
      value: MsgJoinSwapExternAmountInResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgJoinSwapExternAmountInResponse.decode(message.value);
  },

  toProto(message) {
    return MsgJoinSwapExternAmountInResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.MsgJoinSwapExternAmountInResponse",
      value: MsgJoinSwapExternAmountInResponse.encode(message).finish()
    };
  }

};

function createBaseMsgJoinSwapShareAmountOut() {
  return {
    sender: "",
    poolId: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO,
    tokenInDenom: "",
    shareOutAmount: "",
    tokenInMaxAmount: ""
  };
}

const MsgJoinSwapShareAmountOut = {
  typeUrl: "/osmosis.gamm.v1beta1.MsgJoinSwapShareAmountOut",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.sender !== "") {
      writer.uint32(10).string(message.sender);
    }

    if (!message.poolId.isZero()) {
      writer.uint32(16).uint64(message.poolId);
    }

    if (message.tokenInDenom !== "") {
      writer.uint32(26).string(message.tokenInDenom);
    }

    if (message.shareOutAmount !== "") {
      writer.uint32(34).string(message.shareOutAmount);
    }

    if (message.tokenInMaxAmount !== "") {
      writer.uint32(42).string(message.tokenInMaxAmount);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgJoinSwapShareAmountOut();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.sender = reader.string();
          break;

        case 2:
          message.poolId = reader.uint64();
          break;

        case 3:
          message.tokenInDenom = reader.string();
          break;

        case 4:
          message.shareOutAmount = reader.string();
          break;

        case 5:
          message.tokenInMaxAmount = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$sender6, _object$tokenInDenom, _object$shareOutAmoun4, _object$tokenInMaxAmo2;

    const message = createBaseMsgJoinSwapShareAmountOut();
    message.sender = (_object$sender6 = object.sender) !== null && _object$sender6 !== void 0 ? _object$sender6 : "";
    message.poolId = object.poolId !== undefined && object.poolId !== null ? _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromValue */ .dK.fromValue(object.poolId) : _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO;
    message.tokenInDenom = (_object$tokenInDenom = object.tokenInDenom) !== null && _object$tokenInDenom !== void 0 ? _object$tokenInDenom : "";
    message.shareOutAmount = (_object$shareOutAmoun4 = object.shareOutAmount) !== null && _object$shareOutAmoun4 !== void 0 ? _object$shareOutAmoun4 : "";
    message.tokenInMaxAmount = (_object$tokenInMaxAmo2 = object.tokenInMaxAmount) !== null && _object$tokenInMaxAmo2 !== void 0 ? _object$tokenInMaxAmo2 : "";
    return message;
  },

  fromAmino(object) {
    return {
      sender: object.sender,
      poolId: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromString */ .dK.fromString(object.pool_id),
      tokenInDenom: object.token_in_denom,
      shareOutAmount: object.share_out_amount,
      tokenInMaxAmount: object.token_in_max_amount
    };
  },

  toAmino(message) {
    const obj = {};
    obj.sender = message.sender;
    obj.pool_id = message.poolId ? message.poolId.toString() : undefined;
    obj.token_in_denom = message.tokenInDenom;
    obj.share_out_amount = message.shareOutAmount;
    obj.token_in_max_amount = message.tokenInMaxAmount;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgJoinSwapShareAmountOut.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/gamm/join-swap-share-amount-out",
      value: MsgJoinSwapShareAmountOut.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgJoinSwapShareAmountOut.decode(message.value);
  },

  toProto(message) {
    return MsgJoinSwapShareAmountOut.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.MsgJoinSwapShareAmountOut",
      value: MsgJoinSwapShareAmountOut.encode(message).finish()
    };
  }

};

function createBaseMsgJoinSwapShareAmountOutResponse() {
  return {
    tokenInAmount: ""
  };
}

const MsgJoinSwapShareAmountOutResponse = {
  typeUrl: "/osmosis.gamm.v1beta1.MsgJoinSwapShareAmountOutResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.tokenInAmount !== "") {
      writer.uint32(10).string(message.tokenInAmount);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgJoinSwapShareAmountOutResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.tokenInAmount = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$tokenInAmount2;

    const message = createBaseMsgJoinSwapShareAmountOutResponse();
    message.tokenInAmount = (_object$tokenInAmount2 = object.tokenInAmount) !== null && _object$tokenInAmount2 !== void 0 ? _object$tokenInAmount2 : "";
    return message;
  },

  fromAmino(object) {
    return {
      tokenInAmount: object.token_in_amount
    };
  },

  toAmino(message) {
    const obj = {};
    obj.token_in_amount = message.tokenInAmount;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgJoinSwapShareAmountOutResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/gamm/join-swap-share-amount-out-response",
      value: MsgJoinSwapShareAmountOutResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgJoinSwapShareAmountOutResponse.decode(message.value);
  },

  toProto(message) {
    return MsgJoinSwapShareAmountOutResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.MsgJoinSwapShareAmountOutResponse",
      value: MsgJoinSwapShareAmountOutResponse.encode(message).finish()
    };
  }

};

function createBaseMsgExitSwapShareAmountIn() {
  return {
    sender: "",
    poolId: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO,
    tokenOutDenom: "",
    shareInAmount: "",
    tokenOutMinAmount: ""
  };
}

const MsgExitSwapShareAmountIn = {
  typeUrl: "/osmosis.gamm.v1beta1.MsgExitSwapShareAmountIn",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.sender !== "") {
      writer.uint32(10).string(message.sender);
    }

    if (!message.poolId.isZero()) {
      writer.uint32(16).uint64(message.poolId);
    }

    if (message.tokenOutDenom !== "") {
      writer.uint32(26).string(message.tokenOutDenom);
    }

    if (message.shareInAmount !== "") {
      writer.uint32(34).string(message.shareInAmount);
    }

    if (message.tokenOutMinAmount !== "") {
      writer.uint32(42).string(message.tokenOutMinAmount);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgExitSwapShareAmountIn();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.sender = reader.string();
          break;

        case 2:
          message.poolId = reader.uint64();
          break;

        case 3:
          message.tokenOutDenom = reader.string();
          break;

        case 4:
          message.shareInAmount = reader.string();
          break;

        case 5:
          message.tokenOutMinAmount = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$sender7, _object$tokenOutDenom, _object$shareInAmount2, _object$tokenOutMinAm2;

    const message = createBaseMsgExitSwapShareAmountIn();
    message.sender = (_object$sender7 = object.sender) !== null && _object$sender7 !== void 0 ? _object$sender7 : "";
    message.poolId = object.poolId !== undefined && object.poolId !== null ? _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromValue */ .dK.fromValue(object.poolId) : _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO;
    message.tokenOutDenom = (_object$tokenOutDenom = object.tokenOutDenom) !== null && _object$tokenOutDenom !== void 0 ? _object$tokenOutDenom : "";
    message.shareInAmount = (_object$shareInAmount2 = object.shareInAmount) !== null && _object$shareInAmount2 !== void 0 ? _object$shareInAmount2 : "";
    message.tokenOutMinAmount = (_object$tokenOutMinAm2 = object.tokenOutMinAmount) !== null && _object$tokenOutMinAm2 !== void 0 ? _object$tokenOutMinAm2 : "";
    return message;
  },

  fromAmino(object) {
    return {
      sender: object.sender,
      poolId: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromString */ .dK.fromString(object.pool_id),
      tokenOutDenom: object.token_out_denom,
      shareInAmount: object.share_in_amount,
      tokenOutMinAmount: object.token_out_min_amount
    };
  },

  toAmino(message) {
    const obj = {};
    obj.sender = message.sender;
    obj.pool_id = message.poolId ? message.poolId.toString() : undefined;
    obj.token_out_denom = message.tokenOutDenom;
    obj.share_in_amount = message.shareInAmount;
    obj.token_out_min_amount = message.tokenOutMinAmount;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgExitSwapShareAmountIn.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/gamm/exit-swap-share-amount-in",
      value: MsgExitSwapShareAmountIn.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgExitSwapShareAmountIn.decode(message.value);
  },

  toProto(message) {
    return MsgExitSwapShareAmountIn.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.MsgExitSwapShareAmountIn",
      value: MsgExitSwapShareAmountIn.encode(message).finish()
    };
  }

};

function createBaseMsgExitSwapShareAmountInResponse() {
  return {
    tokenOutAmount: ""
  };
}

const MsgExitSwapShareAmountInResponse = {
  typeUrl: "/osmosis.gamm.v1beta1.MsgExitSwapShareAmountInResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.tokenOutAmount !== "") {
      writer.uint32(10).string(message.tokenOutAmount);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgExitSwapShareAmountInResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.tokenOutAmount = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$tokenOutAmoun2;

    const message = createBaseMsgExitSwapShareAmountInResponse();
    message.tokenOutAmount = (_object$tokenOutAmoun2 = object.tokenOutAmount) !== null && _object$tokenOutAmoun2 !== void 0 ? _object$tokenOutAmoun2 : "";
    return message;
  },

  fromAmino(object) {
    return {
      tokenOutAmount: object.token_out_amount
    };
  },

  toAmino(message) {
    const obj = {};
    obj.token_out_amount = message.tokenOutAmount;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgExitSwapShareAmountInResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/gamm/exit-swap-share-amount-in-response",
      value: MsgExitSwapShareAmountInResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgExitSwapShareAmountInResponse.decode(message.value);
  },

  toProto(message) {
    return MsgExitSwapShareAmountInResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.MsgExitSwapShareAmountInResponse",
      value: MsgExitSwapShareAmountInResponse.encode(message).finish()
    };
  }

};

function createBaseMsgExitSwapExternAmountOut() {
  return {
    sender: "",
    poolId: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO,
    tokenOut: undefined,
    shareInMaxAmount: ""
  };
}

const MsgExitSwapExternAmountOut = {
  typeUrl: "/osmosis.gamm.v1beta1.MsgExitSwapExternAmountOut",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.sender !== "") {
      writer.uint32(10).string(message.sender);
    }

    if (!message.poolId.isZero()) {
      writer.uint32(16).uint64(message.poolId);
    }

    if (message.tokenOut !== undefined) {
      _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.encode(message.tokenOut, writer.uint32(26).fork()).ldelim();
    }

    if (message.shareInMaxAmount !== "") {
      writer.uint32(34).string(message.shareInMaxAmount);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgExitSwapExternAmountOut();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.sender = reader.string();
          break;

        case 2:
          message.poolId = reader.uint64();
          break;

        case 3:
          message.tokenOut = _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.decode(reader, reader.uint32());
          break;

        case 4:
          message.shareInMaxAmount = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$sender8, _object$shareInMaxAmo;

    const message = createBaseMsgExitSwapExternAmountOut();
    message.sender = (_object$sender8 = object.sender) !== null && _object$sender8 !== void 0 ? _object$sender8 : "";
    message.poolId = object.poolId !== undefined && object.poolId !== null ? _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromValue */ .dK.fromValue(object.poolId) : _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO;
    message.tokenOut = object.tokenOut !== undefined && object.tokenOut !== null ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.fromPartial(object.tokenOut) : undefined;
    message.shareInMaxAmount = (_object$shareInMaxAmo = object.shareInMaxAmount) !== null && _object$shareInMaxAmo !== void 0 ? _object$shareInMaxAmo : "";
    return message;
  },

  fromAmino(object) {
    return {
      sender: object.sender,
      poolId: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromString */ .dK.fromString(object.pool_id),
      tokenOut: object !== null && object !== void 0 && object.token_out ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.fromAmino(object.token_out) : undefined,
      shareInMaxAmount: object.share_in_max_amount
    };
  },

  toAmino(message) {
    const obj = {};
    obj.sender = message.sender;
    obj.pool_id = message.poolId ? message.poolId.toString() : undefined;
    obj.token_out = message.tokenOut ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.toAmino(message.tokenOut) : undefined;
    obj.share_in_max_amount = message.shareInMaxAmount;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgExitSwapExternAmountOut.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/gamm/exit-swap-extern-amount-out",
      value: MsgExitSwapExternAmountOut.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgExitSwapExternAmountOut.decode(message.value);
  },

  toProto(message) {
    return MsgExitSwapExternAmountOut.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.MsgExitSwapExternAmountOut",
      value: MsgExitSwapExternAmountOut.encode(message).finish()
    };
  }

};

function createBaseMsgExitSwapExternAmountOutResponse() {
  return {
    shareInAmount: ""
  };
}

const MsgExitSwapExternAmountOutResponse = {
  typeUrl: "/osmosis.gamm.v1beta1.MsgExitSwapExternAmountOutResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.shareInAmount !== "") {
      writer.uint32(10).string(message.shareInAmount);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgExitSwapExternAmountOutResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.shareInAmount = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$shareInAmount3;

    const message = createBaseMsgExitSwapExternAmountOutResponse();
    message.shareInAmount = (_object$shareInAmount3 = object.shareInAmount) !== null && _object$shareInAmount3 !== void 0 ? _object$shareInAmount3 : "";
    return message;
  },

  fromAmino(object) {
    return {
      shareInAmount: object.share_in_amount
    };
  },

  toAmino(message) {
    const obj = {};
    obj.share_in_amount = message.shareInAmount;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgExitSwapExternAmountOutResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/gamm/exit-swap-extern-amount-out-response",
      value: MsgExitSwapExternAmountOutResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgExitSwapExternAmountOutResponse.decode(message.value);
  },

  toProto(message) {
    return MsgExitSwapExternAmountOutResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.MsgExitSwapExternAmountOutResponse",
      value: MsgExitSwapExternAmountOutResponse.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 89713:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MsgClientImpl": function() { return /* binding */ MsgClientImpl; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4942);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _tx__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86537);



class MsgClientImpl {
  constructor(rpc) {
    (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, "rpc", void 0);

    this.rpc = rpc;
    this.joinPool = this.joinPool.bind(this);
    this.exitPool = this.exitPool.bind(this);
    this.swapExactAmountIn = this.swapExactAmountIn.bind(this);
    this.swapExactAmountOut = this.swapExactAmountOut.bind(this);
    this.joinSwapExternAmountIn = this.joinSwapExternAmountIn.bind(this);
    this.joinSwapShareAmountOut = this.joinSwapShareAmountOut.bind(this);
    this.exitSwapExternAmountOut = this.exitSwapExternAmountOut.bind(this);
    this.exitSwapShareAmountIn = this.exitSwapShareAmountIn.bind(this);
  }

  joinPool(request) {
    const data = _tx__WEBPACK_IMPORTED_MODULE_1__.MsgJoinPool.encode(request).finish();
    const promise = this.rpc.request("osmosis.gamm.v1beta1.Msg", "JoinPool", data);
    return promise.then(data => _tx__WEBPACK_IMPORTED_MODULE_1__.MsgJoinPoolResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  exitPool(request) {
    const data = _tx__WEBPACK_IMPORTED_MODULE_1__.MsgExitPool.encode(request).finish();
    const promise = this.rpc.request("osmosis.gamm.v1beta1.Msg", "ExitPool", data);
    return promise.then(data => _tx__WEBPACK_IMPORTED_MODULE_1__.MsgExitPoolResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  swapExactAmountIn(request) {
    const data = _tx__WEBPACK_IMPORTED_MODULE_1__.MsgSwapExactAmountIn.encode(request).finish();
    const promise = this.rpc.request("osmosis.gamm.v1beta1.Msg", "SwapExactAmountIn", data);
    return promise.then(data => _tx__WEBPACK_IMPORTED_MODULE_1__.MsgSwapExactAmountInResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  swapExactAmountOut(request) {
    const data = _tx__WEBPACK_IMPORTED_MODULE_1__.MsgSwapExactAmountOut.encode(request).finish();
    const promise = this.rpc.request("osmosis.gamm.v1beta1.Msg", "SwapExactAmountOut", data);
    return promise.then(data => _tx__WEBPACK_IMPORTED_MODULE_1__.MsgSwapExactAmountOutResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  joinSwapExternAmountIn(request) {
    const data = _tx__WEBPACK_IMPORTED_MODULE_1__.MsgJoinSwapExternAmountIn.encode(request).finish();
    const promise = this.rpc.request("osmosis.gamm.v1beta1.Msg", "JoinSwapExternAmountIn", data);
    return promise.then(data => _tx__WEBPACK_IMPORTED_MODULE_1__.MsgJoinSwapExternAmountInResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  joinSwapShareAmountOut(request) {
    const data = _tx__WEBPACK_IMPORTED_MODULE_1__.MsgJoinSwapShareAmountOut.encode(request).finish();
    const promise = this.rpc.request("osmosis.gamm.v1beta1.Msg", "JoinSwapShareAmountOut", data);
    return promise.then(data => _tx__WEBPACK_IMPORTED_MODULE_1__.MsgJoinSwapShareAmountOutResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  exitSwapExternAmountOut(request) {
    const data = _tx__WEBPACK_IMPORTED_MODULE_1__.MsgExitSwapExternAmountOut.encode(request).finish();
    const promise = this.rpc.request("osmosis.gamm.v1beta1.Msg", "ExitSwapExternAmountOut", data);
    return promise.then(data => _tx__WEBPACK_IMPORTED_MODULE_1__.MsgExitSwapExternAmountOutResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  exitSwapShareAmountIn(request) {
    const data = _tx__WEBPACK_IMPORTED_MODULE_1__.MsgExitSwapShareAmountIn.encode(request).finish();
    const promise = this.rpc.request("osmosis.gamm.v1beta1.Msg", "ExitSwapShareAmountIn", data);
    return promise.then(data => _tx__WEBPACK_IMPORTED_MODULE_1__.MsgExitSwapShareAmountInResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

}

/***/ }),

/***/ 80643:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QuerySpotPriceRequest": function() { return /* binding */ QuerySpotPriceRequest; },
/* harmony export */   "QuerySpotPriceResponse": function() { return /* binding */ QuerySpotPriceResponse; }
/* harmony export */ });
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47895);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__);


/** Deprecated: please use alternate in x/poolmanager */

/** @deprecated */

function createBaseQuerySpotPriceRequest() {
  return {
    poolId: _helpers__WEBPACK_IMPORTED_MODULE_0__/* .Long.UZERO */ .dK.UZERO,
    baseAssetDenom: "",
    quoteAssetDenom: ""
  };
}

const QuerySpotPriceRequest = {
  typeUrl: "/osmosis.gamm.v2.QuerySpotPriceRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Writer.create()) {
    if (!message.poolId.isZero()) {
      writer.uint32(8).uint64(message.poolId);
    }

    if (message.baseAssetDenom !== "") {
      writer.uint32(18).string(message.baseAssetDenom);
    }

    if (message.quoteAssetDenom !== "") {
      writer.uint32(26).string(message.quoteAssetDenom);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQuerySpotPriceRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.poolId = reader.uint64();
          break;

        case 2:
          message.baseAssetDenom = reader.string();
          break;

        case 3:
          message.quoteAssetDenom = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$baseAssetDeno, _object$quoteAssetDen;

    const message = createBaseQuerySpotPriceRequest();
    message.poolId = object.poolId !== undefined && object.poolId !== null ? _helpers__WEBPACK_IMPORTED_MODULE_0__/* .Long.fromValue */ .dK.fromValue(object.poolId) : _helpers__WEBPACK_IMPORTED_MODULE_0__/* .Long.UZERO */ .dK.UZERO;
    message.baseAssetDenom = (_object$baseAssetDeno = object.baseAssetDenom) !== null && _object$baseAssetDeno !== void 0 ? _object$baseAssetDeno : "";
    message.quoteAssetDenom = (_object$quoteAssetDen = object.quoteAssetDenom) !== null && _object$quoteAssetDen !== void 0 ? _object$quoteAssetDen : "";
    return message;
  },

  fromAmino(object) {
    return {
      poolId: _helpers__WEBPACK_IMPORTED_MODULE_0__/* .Long.fromString */ .dK.fromString(object.pool_id),
      baseAssetDenom: object.base_asset_denom,
      quoteAssetDenom: object.quote_asset_denom
    };
  },

  toAmino(message) {
    const obj = {};
    obj.pool_id = message.poolId ? message.poolId.toString() : undefined;
    obj.base_asset_denom = message.baseAssetDenom;
    obj.quote_asset_denom = message.quoteAssetDenom;
    return obj;
  },

  fromAminoMsg(object) {
    return QuerySpotPriceRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/gamm/v2/query-spot-price-request",
      value: QuerySpotPriceRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QuerySpotPriceRequest.decode(message.value);
  },

  toProto(message) {
    return QuerySpotPriceRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.gamm.v2.QuerySpotPriceRequest",
      value: QuerySpotPriceRequest.encode(message).finish()
    };
  }

};

function createBaseQuerySpotPriceResponse() {
  return {
    spotPrice: ""
  };
}

const QuerySpotPriceResponse = {
  typeUrl: "/osmosis.gamm.v2.QuerySpotPriceResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Writer.create()) {
    if (message.spotPrice !== "") {
      writer.uint32(10).string(message.spotPrice);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQuerySpotPriceResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.spotPrice = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$spotPrice;

    const message = createBaseQuerySpotPriceResponse();
    message.spotPrice = (_object$spotPrice = object.spotPrice) !== null && _object$spotPrice !== void 0 ? _object$spotPrice : "";
    return message;
  },

  fromAmino(object) {
    return {
      spotPrice: object.spot_price
    };
  },

  toAmino(message) {
    const obj = {};
    obj.spot_price = message.spotPrice;
    return obj;
  },

  fromAminoMsg(object) {
    return QuerySpotPriceResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/gamm/v2/query-spot-price-response",
      value: QuerySpotPriceResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QuerySpotPriceResponse.decode(message.value);
  },

  toProto(message) {
    return QuerySpotPriceResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.gamm.v2.QuerySpotPriceResponse",
      value: QuerySpotPriceResponse.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 44507:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LCDQueryClient": function() { return /* binding */ LCDQueryClient; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4942);

class LCDQueryClient {
  constructor({
    requestClient
  }) {
    (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, "req", void 0);

    this.req = requestClient;
    this.spotPrice = this.spotPrice.bind(this);
  }
  /* Deprecated: please use alternate in x/poolmanager */


  async spotPrice(params) {
    const options = {
      params: {}
    };

    if (typeof (params === null || params === void 0 ? void 0 : params.baseAssetDenom) !== "undefined") {
      options.params.base_asset_denom = params.baseAssetDenom;
    }

    if (typeof (params === null || params === void 0 ? void 0 : params.quoteAssetDenom) !== "undefined") {
      options.params.quote_asset_denom = params.quoteAssetDenom;
    }

    const endpoint = `osmosis/gamm/v2/pools/${params.poolId}/prices`;
    return await this.req.get(endpoint, options);
  }

}

/***/ }),

/***/ 8329:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QueryClientImpl": function() { return /* binding */ QueryClientImpl; },
/* harmony export */   "createRpcQueryExtension": function() { return /* binding */ createRpcQueryExtension; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4942);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78441);
/* harmony import */ var _cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80643);




class QueryClientImpl {
  constructor(rpc) {
    (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, "rpc", void 0);

    this.rpc = rpc;
    this.spotPrice = this.spotPrice.bind(this);
  }

  spotPrice(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QuerySpotPriceRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.gamm.v2.Query", "SpotPrice", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QuerySpotPriceResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

}
const createRpcQueryExtension = base => {
  const rpc = (0,_cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1__.createProtobufRpcClient)(base);
  const queryService = new QueryClientImpl(rpc);
  return {
    spotPrice(request) {
      return queryService.spotPrice(request);
    }

  };
};

/***/ }),

/***/ 78369:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Params": function() { return /* binding */ Params; }
/* harmony export */ });
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__);

/** Params defines the parameters for the ibc-rate-limit module. */

function createBaseParams() {
  return {
    contractAddress: ""
  };
}

const Params = {
  typeUrl: "/osmosis.ibcratelimit.v1beta1.Params",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Writer.create()) {
    if (message.contractAddress !== "") {
      writer.uint32(10).string(message.contractAddress);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseParams();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.contractAddress = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$contractAddre;

    const message = createBaseParams();
    message.contractAddress = (_object$contractAddre = object.contractAddress) !== null && _object$contractAddre !== void 0 ? _object$contractAddre : "";
    return message;
  },

  fromAmino(object) {
    return {
      contractAddress: object.contract_address
    };
  },

  toAmino(message) {
    const obj = {};
    obj.contract_address = message.contractAddress;
    return obj;
  },

  fromAminoMsg(object) {
    return Params.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/ibcratelimit/params",
      value: Params.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return Params.decode(message.value);
  },

  toProto(message) {
    return Params.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.ibcratelimit.v1beta1.Params",
      value: Params.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 52885:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ParamsRequest": function() { return /* binding */ ParamsRequest; },
/* harmony export */   "ParamsResponse": function() { return /* binding */ ParamsResponse; }
/* harmony export */ });
/* harmony import */ var _params__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78369);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__);


/** ParamsRequest is the request type for the Query/Params RPC method. */

function createBaseParamsRequest() {
  return {};
}

const ParamsRequest = {
  typeUrl: "/osmosis.ibcratelimit.v1beta1.ParamsRequest",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseParamsRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseParamsRequest();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return ParamsRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/ibcratelimit/params-request",
      value: ParamsRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return ParamsRequest.decode(message.value);
  },

  toProto(message) {
    return ParamsRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.ibcratelimit.v1beta1.ParamsRequest",
      value: ParamsRequest.encode(message).finish()
    };
  }

};

function createBaseParamsResponse() {
  return {
    params: undefined
  };
}

const ParamsResponse = {
  typeUrl: "/osmosis.ibcratelimit.v1beta1.ParamsResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Writer.create()) {
    if (message.params !== undefined) {
      _params__WEBPACK_IMPORTED_MODULE_0__.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseParamsResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.params = _params__WEBPACK_IMPORTED_MODULE_0__.Params.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseParamsResponse();
    message.params = object.params !== undefined && object.params !== null ? _params__WEBPACK_IMPORTED_MODULE_0__.Params.fromPartial(object.params) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      params: object !== null && object !== void 0 && object.params ? _params__WEBPACK_IMPORTED_MODULE_0__.Params.fromAmino(object.params) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.params = message.params ? _params__WEBPACK_IMPORTED_MODULE_0__.Params.toAmino(message.params) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return ParamsResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/ibcratelimit/params-response",
      value: ParamsResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return ParamsResponse.decode(message.value);
  },

  toProto(message) {
    return ParamsResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.ibcratelimit.v1beta1.ParamsResponse",
      value: ParamsResponse.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 37545:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LCDQueryClient": function() { return /* binding */ LCDQueryClient; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4942);

class LCDQueryClient {
  constructor({
    requestClient
  }) {
    (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, "req", void 0);

    this.req = requestClient;
    this.params = this.params.bind(this);
  }
  /* Params defines a gRPC query method that returns the ibc-rate-limit module's
   parameters. */


  async params(_params = {}) {
    const endpoint = `osmosis/ibc-rate-limit/v1beta1/params`;
    return await this.req.get(endpoint);
  }

}

/***/ }),

/***/ 9804:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QueryClientImpl": function() { return /* binding */ QueryClientImpl; },
/* harmony export */   "createRpcQueryExtension": function() { return /* binding */ createRpcQueryExtension; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4942);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78441);
/* harmony import */ var _cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52885);




/** Query defines the gRPC querier service. */

class QueryClientImpl {
  constructor(rpc) {
    (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, "rpc", void 0);

    this.rpc = rpc;
    this.params = this.params.bind(this);
  }

  params(request = {}) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.ParamsRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.ibcratelimit.v1beta1.Query", "Params", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.ParamsResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

}
const createRpcQueryExtension = base => {
  const rpc = (0,_cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1__.createProtobufRpcClient)(base);
  const queryService = new QueryClientImpl(rpc);
  return {
    params(request) {
      return queryService.params(request);
    }

  };
};

/***/ }),

/***/ 61927:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gauge": function() { return /* binding */ Gauge; },
/* harmony export */   "LockableDurationsInfo": function() { return /* binding */ LockableDurationsInfo; }
/* harmony export */ });
/* harmony import */ var _lockup_lock__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24902);
/* harmony import */ var _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26178);
/* harmony import */ var _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20633);
/* harmony import */ var _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6499);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47895);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__);






/**
 * Gauge is an object that stores and distributes yields to recipients who
 * satisfy certain conditions. Currently gauges support conditions around the
 * duration for which a given denom is locked.
 */

function createBaseGauge() {
  return {
    id: _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.UZERO */ .dK.UZERO,
    isPerpetual: false,
    distributeTo: undefined,
    coins: [],
    startTime: undefined,
    numEpochsPaidOver: _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.UZERO */ .dK.UZERO,
    filledEpochs: _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.UZERO */ .dK.UZERO,
    distributedCoins: []
  };
}

const Gauge = {
  typeUrl: "/osmosis.incentives.Gauge",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Writer.create()) {
    if (!message.id.isZero()) {
      writer.uint32(8).uint64(message.id);
    }

    if (message.isPerpetual === true) {
      writer.uint32(16).bool(message.isPerpetual);
    }

    if (message.distributeTo !== undefined) {
      _lockup_lock__WEBPACK_IMPORTED_MODULE_0__.QueryCondition.encode(message.distributeTo, writer.uint32(26).fork()).ldelim();
    }

    for (const v of message.coins) {
      _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.encode(v, writer.uint32(34).fork()).ldelim();
    }

    if (message.startTime !== undefined) {
      _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_2__.Timestamp.encode((0,_helpers__WEBPACK_IMPORTED_MODULE_4__/* .toTimestamp */ .Uq)(message.startTime), writer.uint32(42).fork()).ldelim();
    }

    if (!message.numEpochsPaidOver.isZero()) {
      writer.uint32(48).uint64(message.numEpochsPaidOver);
    }

    if (!message.filledEpochs.isZero()) {
      writer.uint32(56).uint64(message.filledEpochs);
    }

    for (const v of message.distributedCoins) {
      _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.encode(v, writer.uint32(66).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGauge();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.id = reader.uint64();
          break;

        case 2:
          message.isPerpetual = reader.bool();
          break;

        case 3:
          message.distributeTo = _lockup_lock__WEBPACK_IMPORTED_MODULE_0__.QueryCondition.decode(reader, reader.uint32());
          break;

        case 4:
          message.coins.push(_cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.decode(reader, reader.uint32()));
          break;

        case 5:
          message.startTime = (0,_helpers__WEBPACK_IMPORTED_MODULE_4__/* .fromTimestamp */ .Ol)(_google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_2__.Timestamp.decode(reader, reader.uint32()));
          break;

        case 6:
          message.numEpochsPaidOver = reader.uint64();
          break;

        case 7:
          message.filledEpochs = reader.uint64();
          break;

        case 8:
          message.distributedCoins.push(_cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$isPerpetual, _object$coins, _object$startTime, _object$distributedCo;

    const message = createBaseGauge();
    message.id = object.id !== undefined && object.id !== null ? _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.fromValue */ .dK.fromValue(object.id) : _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.UZERO */ .dK.UZERO;
    message.isPerpetual = (_object$isPerpetual = object.isPerpetual) !== null && _object$isPerpetual !== void 0 ? _object$isPerpetual : false;
    message.distributeTo = object.distributeTo !== undefined && object.distributeTo !== null ? _lockup_lock__WEBPACK_IMPORTED_MODULE_0__.QueryCondition.fromPartial(object.distributeTo) : undefined;
    message.coins = ((_object$coins = object.coins) === null || _object$coins === void 0 ? void 0 : _object$coins.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.fromPartial(e))) || [];
    message.startTime = (_object$startTime = object.startTime) !== null && _object$startTime !== void 0 ? _object$startTime : undefined;
    message.numEpochsPaidOver = object.numEpochsPaidOver !== undefined && object.numEpochsPaidOver !== null ? _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.fromValue */ .dK.fromValue(object.numEpochsPaidOver) : _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.UZERO */ .dK.UZERO;
    message.filledEpochs = object.filledEpochs !== undefined && object.filledEpochs !== null ? _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.fromValue */ .dK.fromValue(object.filledEpochs) : _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.UZERO */ .dK.UZERO;
    message.distributedCoins = ((_object$distributedCo = object.distributedCoins) === null || _object$distributedCo === void 0 ? void 0 : _object$distributedCo.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      id: _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.fromString */ .dK.fromString(object.id),
      isPerpetual: object.is_perpetual,
      distributeTo: object !== null && object !== void 0 && object.distribute_to ? _lockup_lock__WEBPACK_IMPORTED_MODULE_0__.QueryCondition.fromAmino(object.distribute_to) : undefined,
      coins: Array.isArray(object === null || object === void 0 ? void 0 : object.coins) ? object.coins.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.fromAmino(e)) : [],
      startTime: object !== null && object !== void 0 && object.start_time ? _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_2__.Timestamp.fromAmino(object.start_time) : undefined,
      numEpochsPaidOver: _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.fromString */ .dK.fromString(object.num_epochs_paid_over),
      filledEpochs: _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.fromString */ .dK.fromString(object.filled_epochs),
      distributedCoins: Array.isArray(object === null || object === void 0 ? void 0 : object.distributed_coins) ? object.distributed_coins.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.id = message.id ? message.id.toString() : undefined;
    obj.is_perpetual = message.isPerpetual;
    obj.distribute_to = message.distributeTo ? _lockup_lock__WEBPACK_IMPORTED_MODULE_0__.QueryCondition.toAmino(message.distributeTo) : undefined;

    if (message.coins) {
      obj.coins = message.coins.map(e => e ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.toAmino(e) : undefined);
    } else {
      obj.coins = [];
    }

    obj.start_time = message.startTime ? _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_2__.Timestamp.toAmino(message.startTime) : undefined;
    obj.num_epochs_paid_over = message.numEpochsPaidOver ? message.numEpochsPaidOver.toString() : undefined;
    obj.filled_epochs = message.filledEpochs ? message.filledEpochs.toString() : undefined;

    if (message.distributedCoins) {
      obj.distributed_coins = message.distributedCoins.map(e => e ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.toAmino(e) : undefined);
    } else {
      obj.distributed_coins = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return Gauge.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/incentives/gauge",
      value: Gauge.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return Gauge.decode(message.value);
  },

  toProto(message) {
    return Gauge.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.incentives.Gauge",
      value: Gauge.encode(message).finish()
    };
  }

};

function createBaseLockableDurationsInfo() {
  return {
    lockableDurations: []
  };
}

const LockableDurationsInfo = {
  typeUrl: "/osmosis.incentives.LockableDurationsInfo",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Writer.create()) {
    for (const v of message.lockableDurations) {
      _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_3__.Duration.encode(v, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLockableDurationsInfo();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.lockableDurations.push(_google_protobuf_duration__WEBPACK_IMPORTED_MODULE_3__.Duration.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$lockableDurat;

    const message = createBaseLockableDurationsInfo();
    message.lockableDurations = ((_object$lockableDurat = object.lockableDurations) === null || _object$lockableDurat === void 0 ? void 0 : _object$lockableDurat.map(e => _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_3__.Duration.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      lockableDurations: Array.isArray(object === null || object === void 0 ? void 0 : object.lockable_durations) ? object.lockable_durations.map(e => _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_3__.Duration.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.lockableDurations) {
      obj.lockable_durations = message.lockableDurations.map(e => e ? _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_3__.Duration.toAmino(e) : undefined);
    } else {
      obj.lockable_durations = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return LockableDurationsInfo.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/incentives/lockable-durations-info",
      value: LockableDurationsInfo.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return LockableDurationsInfo.decode(message.value);
  },

  toProto(message) {
    return LockableDurationsInfo.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.incentives.LockableDurationsInfo",
      value: LockableDurationsInfo.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 89221:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ActiveGaugesPerDenomRequest": function() { return /* binding */ ActiveGaugesPerDenomRequest; },
/* harmony export */   "ActiveGaugesPerDenomResponse": function() { return /* binding */ ActiveGaugesPerDenomResponse; },
/* harmony export */   "ActiveGaugesRequest": function() { return /* binding */ ActiveGaugesRequest; },
/* harmony export */   "ActiveGaugesResponse": function() { return /* binding */ ActiveGaugesResponse; },
/* harmony export */   "GaugeByIDRequest": function() { return /* binding */ GaugeByIDRequest; },
/* harmony export */   "GaugeByIDResponse": function() { return /* binding */ GaugeByIDResponse; },
/* harmony export */   "GaugesRequest": function() { return /* binding */ GaugesRequest; },
/* harmony export */   "GaugesResponse": function() { return /* binding */ GaugesResponse; },
/* harmony export */   "ModuleToDistributeCoinsRequest": function() { return /* binding */ ModuleToDistributeCoinsRequest; },
/* harmony export */   "ModuleToDistributeCoinsResponse": function() { return /* binding */ ModuleToDistributeCoinsResponse; },
/* harmony export */   "QueryLockableDurationsRequest": function() { return /* binding */ QueryLockableDurationsRequest; },
/* harmony export */   "QueryLockableDurationsResponse": function() { return /* binding */ QueryLockableDurationsResponse; },
/* harmony export */   "RewardsEstRequest": function() { return /* binding */ RewardsEstRequest; },
/* harmony export */   "RewardsEstResponse": function() { return /* binding */ RewardsEstResponse; },
/* harmony export */   "UpcomingGaugesPerDenomRequest": function() { return /* binding */ UpcomingGaugesPerDenomRequest; },
/* harmony export */   "UpcomingGaugesPerDenomResponse": function() { return /* binding */ UpcomingGaugesPerDenomResponse; },
/* harmony export */   "UpcomingGaugesRequest": function() { return /* binding */ UpcomingGaugesRequest; },
/* harmony export */   "UpcomingGaugesResponse": function() { return /* binding */ UpcomingGaugesResponse; }
/* harmony export */ });
/* harmony import */ var _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48978);
/* harmony import */ var _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26178);
/* harmony import */ var _gauge__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61927);
/* harmony import */ var _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6499);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47895);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__);







function createBaseModuleToDistributeCoinsRequest() {
  return {};
}

const ModuleToDistributeCoinsRequest = {
  typeUrl: "/osmosis.incentives.ModuleToDistributeCoinsRequest",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseModuleToDistributeCoinsRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseModuleToDistributeCoinsRequest();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return ModuleToDistributeCoinsRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/incentives/module-to-distribute-coins-request",
      value: ModuleToDistributeCoinsRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return ModuleToDistributeCoinsRequest.decode(message.value);
  },

  toProto(message) {
    return ModuleToDistributeCoinsRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.incentives.ModuleToDistributeCoinsRequest",
      value: ModuleToDistributeCoinsRequest.encode(message).finish()
    };
  }

};

function createBaseModuleToDistributeCoinsResponse() {
  return {
    coins: []
  };
}

const ModuleToDistributeCoinsResponse = {
  typeUrl: "/osmosis.incentives.ModuleToDistributeCoinsResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Writer.create()) {
    for (const v of message.coins) {
      _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.encode(v, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseModuleToDistributeCoinsResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.coins.push(_cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$coins;

    const message = createBaseModuleToDistributeCoinsResponse();
    message.coins = ((_object$coins = object.coins) === null || _object$coins === void 0 ? void 0 : _object$coins.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      coins: Array.isArray(object === null || object === void 0 ? void 0 : object.coins) ? object.coins.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.coins) {
      obj.coins = message.coins.map(e => e ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.toAmino(e) : undefined);
    } else {
      obj.coins = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return ModuleToDistributeCoinsResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/incentives/module-to-distribute-coins-response",
      value: ModuleToDistributeCoinsResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return ModuleToDistributeCoinsResponse.decode(message.value);
  },

  toProto(message) {
    return ModuleToDistributeCoinsResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.incentives.ModuleToDistributeCoinsResponse",
      value: ModuleToDistributeCoinsResponse.encode(message).finish()
    };
  }

};

function createBaseGaugeByIDRequest() {
  return {
    id: _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.UZERO */ .dK.UZERO
  };
}

const GaugeByIDRequest = {
  typeUrl: "/osmosis.incentives.GaugeByIDRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Writer.create()) {
    if (!message.id.isZero()) {
      writer.uint32(8).uint64(message.id);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGaugeByIDRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.id = reader.uint64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseGaugeByIDRequest();
    message.id = object.id !== undefined && object.id !== null ? _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.fromValue */ .dK.fromValue(object.id) : _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.UZERO */ .dK.UZERO;
    return message;
  },

  fromAmino(object) {
    return {
      id: _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.fromString */ .dK.fromString(object.id)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.id = message.id ? message.id.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return GaugeByIDRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/incentives/gauge-by-id-request",
      value: GaugeByIDRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return GaugeByIDRequest.decode(message.value);
  },

  toProto(message) {
    return GaugeByIDRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.incentives.GaugeByIDRequest",
      value: GaugeByIDRequest.encode(message).finish()
    };
  }

};

function createBaseGaugeByIDResponse() {
  return {
    gauge: undefined
  };
}

const GaugeByIDResponse = {
  typeUrl: "/osmosis.incentives.GaugeByIDResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Writer.create()) {
    if (message.gauge !== undefined) {
      _gauge__WEBPACK_IMPORTED_MODULE_2__.Gauge.encode(message.gauge, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGaugeByIDResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.gauge = _gauge__WEBPACK_IMPORTED_MODULE_2__.Gauge.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseGaugeByIDResponse();
    message.gauge = object.gauge !== undefined && object.gauge !== null ? _gauge__WEBPACK_IMPORTED_MODULE_2__.Gauge.fromPartial(object.gauge) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      gauge: object !== null && object !== void 0 && object.gauge ? _gauge__WEBPACK_IMPORTED_MODULE_2__.Gauge.fromAmino(object.gauge) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.gauge = message.gauge ? _gauge__WEBPACK_IMPORTED_MODULE_2__.Gauge.toAmino(message.gauge) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return GaugeByIDResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/incentives/gauge-by-id-response",
      value: GaugeByIDResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return GaugeByIDResponse.decode(message.value);
  },

  toProto(message) {
    return GaugeByIDResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.incentives.GaugeByIDResponse",
      value: GaugeByIDResponse.encode(message).finish()
    };
  }

};

function createBaseGaugesRequest() {
  return {
    pagination: undefined
  };
}

const GaugesRequest = {
  typeUrl: "/osmosis.incentives.GaugesRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Writer.create()) {
    if (message.pagination !== undefined) {
      _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGaugesRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.pagination = _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseGaugesRequest();
    message.pagination = object.pagination !== undefined && object.pagination !== null ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.fromPartial(object.pagination) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      pagination: object !== null && object !== void 0 && object.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.fromAmino(object.pagination) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.pagination = message.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.toAmino(message.pagination) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return GaugesRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/incentives/gauges-request",
      value: GaugesRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return GaugesRequest.decode(message.value);
  },

  toProto(message) {
    return GaugesRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.incentives.GaugesRequest",
      value: GaugesRequest.encode(message).finish()
    };
  }

};

function createBaseGaugesResponse() {
  return {
    data: [],
    pagination: undefined
  };
}

const GaugesResponse = {
  typeUrl: "/osmosis.incentives.GaugesResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Writer.create()) {
    for (const v of message.data) {
      _gauge__WEBPACK_IMPORTED_MODULE_2__.Gauge.encode(v, writer.uint32(10).fork()).ldelim();
    }

    if (message.pagination !== undefined) {
      _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGaugesResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.data.push(_gauge__WEBPACK_IMPORTED_MODULE_2__.Gauge.decode(reader, reader.uint32()));
          break;

        case 2:
          message.pagination = _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$data;

    const message = createBaseGaugesResponse();
    message.data = ((_object$data = object.data) === null || _object$data === void 0 ? void 0 : _object$data.map(e => _gauge__WEBPACK_IMPORTED_MODULE_2__.Gauge.fromPartial(e))) || [];
    message.pagination = object.pagination !== undefined && object.pagination !== null ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.fromPartial(object.pagination) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      data: Array.isArray(object === null || object === void 0 ? void 0 : object.data) ? object.data.map(e => _gauge__WEBPACK_IMPORTED_MODULE_2__.Gauge.fromAmino(e)) : [],
      pagination: object !== null && object !== void 0 && object.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.fromAmino(object.pagination) : undefined
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.data) {
      obj.data = message.data.map(e => e ? _gauge__WEBPACK_IMPORTED_MODULE_2__.Gauge.toAmino(e) : undefined);
    } else {
      obj.data = [];
    }

    obj.pagination = message.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.toAmino(message.pagination) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return GaugesResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/incentives/gauges-response",
      value: GaugesResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return GaugesResponse.decode(message.value);
  },

  toProto(message) {
    return GaugesResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.incentives.GaugesResponse",
      value: GaugesResponse.encode(message).finish()
    };
  }

};

function createBaseActiveGaugesRequest() {
  return {
    pagination: undefined
  };
}

const ActiveGaugesRequest = {
  typeUrl: "/osmosis.incentives.ActiveGaugesRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Writer.create()) {
    if (message.pagination !== undefined) {
      _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseActiveGaugesRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.pagination = _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseActiveGaugesRequest();
    message.pagination = object.pagination !== undefined && object.pagination !== null ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.fromPartial(object.pagination) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      pagination: object !== null && object !== void 0 && object.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.fromAmino(object.pagination) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.pagination = message.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.toAmino(message.pagination) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return ActiveGaugesRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/incentives/active-gauges-request",
      value: ActiveGaugesRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return ActiveGaugesRequest.decode(message.value);
  },

  toProto(message) {
    return ActiveGaugesRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.incentives.ActiveGaugesRequest",
      value: ActiveGaugesRequest.encode(message).finish()
    };
  }

};

function createBaseActiveGaugesResponse() {
  return {
    data: [],
    pagination: undefined
  };
}

const ActiveGaugesResponse = {
  typeUrl: "/osmosis.incentives.ActiveGaugesResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Writer.create()) {
    for (const v of message.data) {
      _gauge__WEBPACK_IMPORTED_MODULE_2__.Gauge.encode(v, writer.uint32(10).fork()).ldelim();
    }

    if (message.pagination !== undefined) {
      _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseActiveGaugesResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.data.push(_gauge__WEBPACK_IMPORTED_MODULE_2__.Gauge.decode(reader, reader.uint32()));
          break;

        case 2:
          message.pagination = _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$data2;

    const message = createBaseActiveGaugesResponse();
    message.data = ((_object$data2 = object.data) === null || _object$data2 === void 0 ? void 0 : _object$data2.map(e => _gauge__WEBPACK_IMPORTED_MODULE_2__.Gauge.fromPartial(e))) || [];
    message.pagination = object.pagination !== undefined && object.pagination !== null ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.fromPartial(object.pagination) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      data: Array.isArray(object === null || object === void 0 ? void 0 : object.data) ? object.data.map(e => _gauge__WEBPACK_IMPORTED_MODULE_2__.Gauge.fromAmino(e)) : [],
      pagination: object !== null && object !== void 0 && object.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.fromAmino(object.pagination) : undefined
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.data) {
      obj.data = message.data.map(e => e ? _gauge__WEBPACK_IMPORTED_MODULE_2__.Gauge.toAmino(e) : undefined);
    } else {
      obj.data = [];
    }

    obj.pagination = message.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.toAmino(message.pagination) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return ActiveGaugesResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/incentives/active-gauges-response",
      value: ActiveGaugesResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return ActiveGaugesResponse.decode(message.value);
  },

  toProto(message) {
    return ActiveGaugesResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.incentives.ActiveGaugesResponse",
      value: ActiveGaugesResponse.encode(message).finish()
    };
  }

};

function createBaseActiveGaugesPerDenomRequest() {
  return {
    denom: "",
    pagination: undefined
  };
}

const ActiveGaugesPerDenomRequest = {
  typeUrl: "/osmosis.incentives.ActiveGaugesPerDenomRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Writer.create()) {
    if (message.denom !== "") {
      writer.uint32(10).string(message.denom);
    }

    if (message.pagination !== undefined) {
      _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseActiveGaugesPerDenomRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.denom = reader.string();
          break;

        case 2:
          message.pagination = _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$denom;

    const message = createBaseActiveGaugesPerDenomRequest();
    message.denom = (_object$denom = object.denom) !== null && _object$denom !== void 0 ? _object$denom : "";
    message.pagination = object.pagination !== undefined && object.pagination !== null ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.fromPartial(object.pagination) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      denom: object.denom,
      pagination: object !== null && object !== void 0 && object.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.fromAmino(object.pagination) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.denom = message.denom;
    obj.pagination = message.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.toAmino(message.pagination) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return ActiveGaugesPerDenomRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/incentives/active-gauges-per-denom-request",
      value: ActiveGaugesPerDenomRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return ActiveGaugesPerDenomRequest.decode(message.value);
  },

  toProto(message) {
    return ActiveGaugesPerDenomRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.incentives.ActiveGaugesPerDenomRequest",
      value: ActiveGaugesPerDenomRequest.encode(message).finish()
    };
  }

};

function createBaseActiveGaugesPerDenomResponse() {
  return {
    data: [],
    pagination: undefined
  };
}

const ActiveGaugesPerDenomResponse = {
  typeUrl: "/osmosis.incentives.ActiveGaugesPerDenomResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Writer.create()) {
    for (const v of message.data) {
      _gauge__WEBPACK_IMPORTED_MODULE_2__.Gauge.encode(v, writer.uint32(10).fork()).ldelim();
    }

    if (message.pagination !== undefined) {
      _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseActiveGaugesPerDenomResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.data.push(_gauge__WEBPACK_IMPORTED_MODULE_2__.Gauge.decode(reader, reader.uint32()));
          break;

        case 2:
          message.pagination = _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$data3;

    const message = createBaseActiveGaugesPerDenomResponse();
    message.data = ((_object$data3 = object.data) === null || _object$data3 === void 0 ? void 0 : _object$data3.map(e => _gauge__WEBPACK_IMPORTED_MODULE_2__.Gauge.fromPartial(e))) || [];
    message.pagination = object.pagination !== undefined && object.pagination !== null ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.fromPartial(object.pagination) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      data: Array.isArray(object === null || object === void 0 ? void 0 : object.data) ? object.data.map(e => _gauge__WEBPACK_IMPORTED_MODULE_2__.Gauge.fromAmino(e)) : [],
      pagination: object !== null && object !== void 0 && object.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.fromAmino(object.pagination) : undefined
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.data) {
      obj.data = message.data.map(e => e ? _gauge__WEBPACK_IMPORTED_MODULE_2__.Gauge.toAmino(e) : undefined);
    } else {
      obj.data = [];
    }

    obj.pagination = message.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.toAmino(message.pagination) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return ActiveGaugesPerDenomResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/incentives/active-gauges-per-denom-response",
      value: ActiveGaugesPerDenomResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return ActiveGaugesPerDenomResponse.decode(message.value);
  },

  toProto(message) {
    return ActiveGaugesPerDenomResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.incentives.ActiveGaugesPerDenomResponse",
      value: ActiveGaugesPerDenomResponse.encode(message).finish()
    };
  }

};

function createBaseUpcomingGaugesRequest() {
  return {
    pagination: undefined
  };
}

const UpcomingGaugesRequest = {
  typeUrl: "/osmosis.incentives.UpcomingGaugesRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Writer.create()) {
    if (message.pagination !== undefined) {
      _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpcomingGaugesRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.pagination = _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseUpcomingGaugesRequest();
    message.pagination = object.pagination !== undefined && object.pagination !== null ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.fromPartial(object.pagination) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      pagination: object !== null && object !== void 0 && object.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.fromAmino(object.pagination) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.pagination = message.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.toAmino(message.pagination) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return UpcomingGaugesRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/incentives/upcoming-gauges-request",
      value: UpcomingGaugesRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return UpcomingGaugesRequest.decode(message.value);
  },

  toProto(message) {
    return UpcomingGaugesRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.incentives.UpcomingGaugesRequest",
      value: UpcomingGaugesRequest.encode(message).finish()
    };
  }

};

function createBaseUpcomingGaugesResponse() {
  return {
    data: [],
    pagination: undefined
  };
}

const UpcomingGaugesResponse = {
  typeUrl: "/osmosis.incentives.UpcomingGaugesResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Writer.create()) {
    for (const v of message.data) {
      _gauge__WEBPACK_IMPORTED_MODULE_2__.Gauge.encode(v, writer.uint32(10).fork()).ldelim();
    }

    if (message.pagination !== undefined) {
      _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpcomingGaugesResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.data.push(_gauge__WEBPACK_IMPORTED_MODULE_2__.Gauge.decode(reader, reader.uint32()));
          break;

        case 2:
          message.pagination = _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$data4;

    const message = createBaseUpcomingGaugesResponse();
    message.data = ((_object$data4 = object.data) === null || _object$data4 === void 0 ? void 0 : _object$data4.map(e => _gauge__WEBPACK_IMPORTED_MODULE_2__.Gauge.fromPartial(e))) || [];
    message.pagination = object.pagination !== undefined && object.pagination !== null ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.fromPartial(object.pagination) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      data: Array.isArray(object === null || object === void 0 ? void 0 : object.data) ? object.data.map(e => _gauge__WEBPACK_IMPORTED_MODULE_2__.Gauge.fromAmino(e)) : [],
      pagination: object !== null && object !== void 0 && object.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.fromAmino(object.pagination) : undefined
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.data) {
      obj.data = message.data.map(e => e ? _gauge__WEBPACK_IMPORTED_MODULE_2__.Gauge.toAmino(e) : undefined);
    } else {
      obj.data = [];
    }

    obj.pagination = message.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.toAmino(message.pagination) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return UpcomingGaugesResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/incentives/upcoming-gauges-response",
      value: UpcomingGaugesResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return UpcomingGaugesResponse.decode(message.value);
  },

  toProto(message) {
    return UpcomingGaugesResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.incentives.UpcomingGaugesResponse",
      value: UpcomingGaugesResponse.encode(message).finish()
    };
  }

};

function createBaseUpcomingGaugesPerDenomRequest() {
  return {
    denom: "",
    pagination: undefined
  };
}

const UpcomingGaugesPerDenomRequest = {
  typeUrl: "/osmosis.incentives.UpcomingGaugesPerDenomRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Writer.create()) {
    if (message.denom !== "") {
      writer.uint32(10).string(message.denom);
    }

    if (message.pagination !== undefined) {
      _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpcomingGaugesPerDenomRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.denom = reader.string();
          break;

        case 2:
          message.pagination = _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$denom2;

    const message = createBaseUpcomingGaugesPerDenomRequest();
    message.denom = (_object$denom2 = object.denom) !== null && _object$denom2 !== void 0 ? _object$denom2 : "";
    message.pagination = object.pagination !== undefined && object.pagination !== null ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.fromPartial(object.pagination) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      denom: object.denom,
      pagination: object !== null && object !== void 0 && object.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.fromAmino(object.pagination) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.denom = message.denom;
    obj.pagination = message.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.toAmino(message.pagination) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return UpcomingGaugesPerDenomRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/incentives/upcoming-gauges-per-denom-request",
      value: UpcomingGaugesPerDenomRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return UpcomingGaugesPerDenomRequest.decode(message.value);
  },

  toProto(message) {
    return UpcomingGaugesPerDenomRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.incentives.UpcomingGaugesPerDenomRequest",
      value: UpcomingGaugesPerDenomRequest.encode(message).finish()
    };
  }

};

function createBaseUpcomingGaugesPerDenomResponse() {
  return {
    upcomingGauges: [],
    pagination: undefined
  };
}

const UpcomingGaugesPerDenomResponse = {
  typeUrl: "/osmosis.incentives.UpcomingGaugesPerDenomResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Writer.create()) {
    for (const v of message.upcomingGauges) {
      _gauge__WEBPACK_IMPORTED_MODULE_2__.Gauge.encode(v, writer.uint32(10).fork()).ldelim();
    }

    if (message.pagination !== undefined) {
      _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpcomingGaugesPerDenomResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.upcomingGauges.push(_gauge__WEBPACK_IMPORTED_MODULE_2__.Gauge.decode(reader, reader.uint32()));
          break;

        case 2:
          message.pagination = _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$upcomingGauge;

    const message = createBaseUpcomingGaugesPerDenomResponse();
    message.upcomingGauges = ((_object$upcomingGauge = object.upcomingGauges) === null || _object$upcomingGauge === void 0 ? void 0 : _object$upcomingGauge.map(e => _gauge__WEBPACK_IMPORTED_MODULE_2__.Gauge.fromPartial(e))) || [];
    message.pagination = object.pagination !== undefined && object.pagination !== null ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.fromPartial(object.pagination) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      upcomingGauges: Array.isArray(object === null || object === void 0 ? void 0 : object.upcoming_gauges) ? object.upcoming_gauges.map(e => _gauge__WEBPACK_IMPORTED_MODULE_2__.Gauge.fromAmino(e)) : [],
      pagination: object !== null && object !== void 0 && object.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.fromAmino(object.pagination) : undefined
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.upcomingGauges) {
      obj.upcoming_gauges = message.upcomingGauges.map(e => e ? _gauge__WEBPACK_IMPORTED_MODULE_2__.Gauge.toAmino(e) : undefined);
    } else {
      obj.upcoming_gauges = [];
    }

    obj.pagination = message.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.toAmino(message.pagination) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return UpcomingGaugesPerDenomResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/incentives/upcoming-gauges-per-denom-response",
      value: UpcomingGaugesPerDenomResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return UpcomingGaugesPerDenomResponse.decode(message.value);
  },

  toProto(message) {
    return UpcomingGaugesPerDenomResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.incentives.UpcomingGaugesPerDenomResponse",
      value: UpcomingGaugesPerDenomResponse.encode(message).finish()
    };
  }

};

function createBaseRewardsEstRequest() {
  return {
    owner: "",
    lockIds: [],
    endEpoch: _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.ZERO */ .dK.ZERO
  };
}

const RewardsEstRequest = {
  typeUrl: "/osmosis.incentives.RewardsEstRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Writer.create()) {
    if (message.owner !== "") {
      writer.uint32(10).string(message.owner);
    }

    writer.uint32(18).fork();

    for (const v of message.lockIds) {
      writer.uint64(v);
    }

    writer.ldelim();

    if (!message.endEpoch.isZero()) {
      writer.uint32(24).int64(message.endEpoch);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRewardsEstRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.owner = reader.string();
          break;

        case 2:
          if ((tag & 7) === 2) {
            const end2 = reader.uint32() + reader.pos;

            while (reader.pos < end2) {
              message.lockIds.push(reader.uint64());
            }
          } else {
            message.lockIds.push(reader.uint64());
          }

          break;

        case 3:
          message.endEpoch = reader.int64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$owner, _object$lockIds;

    const message = createBaseRewardsEstRequest();
    message.owner = (_object$owner = object.owner) !== null && _object$owner !== void 0 ? _object$owner : "";
    message.lockIds = ((_object$lockIds = object.lockIds) === null || _object$lockIds === void 0 ? void 0 : _object$lockIds.map(e => _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.fromValue */ .dK.fromValue(e))) || [];
    message.endEpoch = object.endEpoch !== undefined && object.endEpoch !== null ? _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.fromValue */ .dK.fromValue(object.endEpoch) : _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.ZERO */ .dK.ZERO;
    return message;
  },

  fromAmino(object) {
    return {
      owner: object.owner,
      lockIds: Array.isArray(object === null || object === void 0 ? void 0 : object.lock_ids) ? object.lock_ids.map(e => e) : [],
      endEpoch: _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.fromString */ .dK.fromString(object.end_epoch)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.owner = message.owner;

    if (message.lockIds) {
      obj.lock_ids = message.lockIds.map(e => e);
    } else {
      obj.lock_ids = [];
    }

    obj.end_epoch = message.endEpoch ? message.endEpoch.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return RewardsEstRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/incentives/rewards-est-request",
      value: RewardsEstRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return RewardsEstRequest.decode(message.value);
  },

  toProto(message) {
    return RewardsEstRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.incentives.RewardsEstRequest",
      value: RewardsEstRequest.encode(message).finish()
    };
  }

};

function createBaseRewardsEstResponse() {
  return {
    coins: []
  };
}

const RewardsEstResponse = {
  typeUrl: "/osmosis.incentives.RewardsEstResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Writer.create()) {
    for (const v of message.coins) {
      _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.encode(v, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRewardsEstResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.coins.push(_cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$coins2;

    const message = createBaseRewardsEstResponse();
    message.coins = ((_object$coins2 = object.coins) === null || _object$coins2 === void 0 ? void 0 : _object$coins2.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      coins: Array.isArray(object === null || object === void 0 ? void 0 : object.coins) ? object.coins.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.coins) {
      obj.coins = message.coins.map(e => e ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.toAmino(e) : undefined);
    } else {
      obj.coins = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return RewardsEstResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/incentives/rewards-est-response",
      value: RewardsEstResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return RewardsEstResponse.decode(message.value);
  },

  toProto(message) {
    return RewardsEstResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.incentives.RewardsEstResponse",
      value: RewardsEstResponse.encode(message).finish()
    };
  }

};

function createBaseQueryLockableDurationsRequest() {
  return {};
}

const QueryLockableDurationsRequest = {
  typeUrl: "/osmosis.incentives.QueryLockableDurationsRequest",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryLockableDurationsRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseQueryLockableDurationsRequest();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return QueryLockableDurationsRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/incentives/query-lockable-durations-request",
      value: QueryLockableDurationsRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryLockableDurationsRequest.decode(message.value);
  },

  toProto(message) {
    return QueryLockableDurationsRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.incentives.QueryLockableDurationsRequest",
      value: QueryLockableDurationsRequest.encode(message).finish()
    };
  }

};

function createBaseQueryLockableDurationsResponse() {
  return {
    lockableDurations: []
  };
}

const QueryLockableDurationsResponse = {
  typeUrl: "/osmosis.incentives.QueryLockableDurationsResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Writer.create()) {
    for (const v of message.lockableDurations) {
      _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_3__.Duration.encode(v, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryLockableDurationsResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.lockableDurations.push(_google_protobuf_duration__WEBPACK_IMPORTED_MODULE_3__.Duration.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$lockableDurat;

    const message = createBaseQueryLockableDurationsResponse();
    message.lockableDurations = ((_object$lockableDurat = object.lockableDurations) === null || _object$lockableDurat === void 0 ? void 0 : _object$lockableDurat.map(e => _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_3__.Duration.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      lockableDurations: Array.isArray(object === null || object === void 0 ? void 0 : object.lockable_durations) ? object.lockable_durations.map(e => _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_3__.Duration.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.lockableDurations) {
      obj.lockable_durations = message.lockableDurations.map(e => e ? _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_3__.Duration.toAmino(e) : undefined);
    } else {
      obj.lockable_durations = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return QueryLockableDurationsResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/incentives/query-lockable-durations-response",
      value: QueryLockableDurationsResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryLockableDurationsResponse.decode(message.value);
  },

  toProto(message) {
    return QueryLockableDurationsResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.incentives.QueryLockableDurationsResponse",
      value: QueryLockableDurationsResponse.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 29265:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LCDQueryClient": function() { return /* binding */ LCDQueryClient; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4942);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47895);


class LCDQueryClient {
  constructor({
    requestClient
  }) {
    (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, "req", void 0);

    this.req = requestClient;
    this.moduleToDistributeCoins = this.moduleToDistributeCoins.bind(this);
    this.gaugeByID = this.gaugeByID.bind(this);
    this.gauges = this.gauges.bind(this);
    this.activeGauges = this.activeGauges.bind(this);
    this.activeGaugesPerDenom = this.activeGaugesPerDenom.bind(this);
    this.upcomingGauges = this.upcomingGauges.bind(this);
    this.upcomingGaugesPerDenom = this.upcomingGaugesPerDenom.bind(this);
    this.rewardsEst = this.rewardsEst.bind(this);
    this.lockableDurations = this.lockableDurations.bind(this);
  }
  /* ModuleToDistributeCoins returns coins that are going to be distributed */


  async moduleToDistributeCoins(_params = {}) {
    const endpoint = `osmosis/incentives/v1beta1/module_to_distribute_coins`;
    return await this.req.get(endpoint);
  }
  /* GaugeByID returns gauges by their respective ID */


  async gaugeByID(params) {
    const endpoint = `osmosis/incentives/v1beta1/gauge_by_id/${params.id}`;
    return await this.req.get(endpoint);
  }
  /* Gauges returns both upcoming and active gauges */


  async gauges(params = {
    pagination: undefined
  }) {
    const options = {
      params: {}
    };

    if (typeof (params === null || params === void 0 ? void 0 : params.pagination) !== "undefined") {
      (0,_helpers__WEBPACK_IMPORTED_MODULE_0__/* .setPaginationParams */ .q6)(options, params.pagination);
    }

    const endpoint = `osmosis/incentives/v1beta1/gauges`;
    return await this.req.get(endpoint, options);
  }
  /* ActiveGauges returns active gauges */


  async activeGauges(params = {
    pagination: undefined
  }) {
    const options = {
      params: {}
    };

    if (typeof (params === null || params === void 0 ? void 0 : params.pagination) !== "undefined") {
      (0,_helpers__WEBPACK_IMPORTED_MODULE_0__/* .setPaginationParams */ .q6)(options, params.pagination);
    }

    const endpoint = `osmosis/incentives/v1beta1/active_gauges`;
    return await this.req.get(endpoint, options);
  }
  /* ActiveGaugesPerDenom returns active gauges by denom */


  async activeGaugesPerDenom(params) {
    const options = {
      params: {}
    };

    if (typeof (params === null || params === void 0 ? void 0 : params.denom) !== "undefined") {
      options.params.denom = params.denom;
    }

    if (typeof (params === null || params === void 0 ? void 0 : params.pagination) !== "undefined") {
      (0,_helpers__WEBPACK_IMPORTED_MODULE_0__/* .setPaginationParams */ .q6)(options, params.pagination);
    }

    const endpoint = `osmosis/incentives/v1beta1/active_gauges_per_denom`;
    return await this.req.get(endpoint, options);
  }
  /* Returns scheduled gauges that have not yet occured */


  async upcomingGauges(params = {
    pagination: undefined
  }) {
    const options = {
      params: {}
    };

    if (typeof (params === null || params === void 0 ? void 0 : params.pagination) !== "undefined") {
      (0,_helpers__WEBPACK_IMPORTED_MODULE_0__/* .setPaginationParams */ .q6)(options, params.pagination);
    }

    const endpoint = `osmosis/incentives/v1beta1/upcoming_gauges`;
    return await this.req.get(endpoint, options);
  }
  /* UpcomingGaugesPerDenom returns scheduled gauges that have not yet occured
   by denom */


  async upcomingGaugesPerDenom(params) {
    const options = {
      params: {}
    };

    if (typeof (params === null || params === void 0 ? void 0 : params.denom) !== "undefined") {
      options.params.denom = params.denom;
    }

    if (typeof (params === null || params === void 0 ? void 0 : params.pagination) !== "undefined") {
      (0,_helpers__WEBPACK_IMPORTED_MODULE_0__/* .setPaginationParams */ .q6)(options, params.pagination);
    }

    const endpoint = `osmosis/incentives/v1beta1/upcoming_gauges_per_denom`;
    return await this.req.get(endpoint, options);
  }
  /* RewardsEst returns an estimate of the rewards from now until a specified
   time in the future The querier either provides an address or a set of locks
   for which they want to find the associated rewards */


  async rewardsEst(params) {
    const options = {
      params: {}
    };

    if (typeof (params === null || params === void 0 ? void 0 : params.lockIds) !== "undefined") {
      options.params.lock_ids = params.lockIds;
    }

    if (typeof (params === null || params === void 0 ? void 0 : params.endEpoch) !== "undefined") {
      options.params.end_epoch = params.endEpoch;
    }

    const endpoint = `osmosis/incentives/v1beta1/rewards_est/${params.owner}`;
    return await this.req.get(endpoint, options);
  }
  /* LockableDurations returns lockable durations that are valid to distribute
   incentives for */


  async lockableDurations(_params = {}) {
    const endpoint = `osmosis/incentives/v1beta1/lockable_durations`;
    return await this.req.get(endpoint);
  }

}

/***/ }),

/***/ 39088:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QueryClientImpl": function() { return /* binding */ QueryClientImpl; },
/* harmony export */   "createRpcQueryExtension": function() { return /* binding */ createRpcQueryExtension; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4942);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78441);
/* harmony import */ var _cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89221);




/** Query defines the gRPC querier service */

class QueryClientImpl {
  constructor(rpc) {
    (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, "rpc", void 0);

    this.rpc = rpc;
    this.moduleToDistributeCoins = this.moduleToDistributeCoins.bind(this);
    this.gaugeByID = this.gaugeByID.bind(this);
    this.gauges = this.gauges.bind(this);
    this.activeGauges = this.activeGauges.bind(this);
    this.activeGaugesPerDenom = this.activeGaugesPerDenom.bind(this);
    this.upcomingGauges = this.upcomingGauges.bind(this);
    this.upcomingGaugesPerDenom = this.upcomingGaugesPerDenom.bind(this);
    this.rewardsEst = this.rewardsEst.bind(this);
    this.lockableDurations = this.lockableDurations.bind(this);
  }

  moduleToDistributeCoins(request = {}) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.ModuleToDistributeCoinsRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.incentives.Query", "ModuleToDistributeCoins", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.ModuleToDistributeCoinsResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  gaugeByID(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.GaugeByIDRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.incentives.Query", "GaugeByID", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.GaugeByIDResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  gauges(request = {
    pagination: undefined
  }) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.GaugesRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.incentives.Query", "Gauges", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.GaugesResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  activeGauges(request = {
    pagination: undefined
  }) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.ActiveGaugesRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.incentives.Query", "ActiveGauges", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.ActiveGaugesResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  activeGaugesPerDenom(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.ActiveGaugesPerDenomRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.incentives.Query", "ActiveGaugesPerDenom", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.ActiveGaugesPerDenomResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  upcomingGauges(request = {
    pagination: undefined
  }) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.UpcomingGaugesRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.incentives.Query", "UpcomingGauges", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.UpcomingGaugesResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  upcomingGaugesPerDenom(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.UpcomingGaugesPerDenomRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.incentives.Query", "UpcomingGaugesPerDenom", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.UpcomingGaugesPerDenomResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  rewardsEst(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.RewardsEstRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.incentives.Query", "RewardsEst", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.RewardsEstResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  lockableDurations(request = {}) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryLockableDurationsRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.incentives.Query", "LockableDurations", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryLockableDurationsResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

}
const createRpcQueryExtension = base => {
  const rpc = (0,_cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1__.createProtobufRpcClient)(base);
  const queryService = new QueryClientImpl(rpc);
  return {
    moduleToDistributeCoins(request) {
      return queryService.moduleToDistributeCoins(request);
    },

    gaugeByID(request) {
      return queryService.gaugeByID(request);
    },

    gauges(request) {
      return queryService.gauges(request);
    },

    activeGauges(request) {
      return queryService.activeGauges(request);
    },

    activeGaugesPerDenom(request) {
      return queryService.activeGaugesPerDenom(request);
    },

    upcomingGauges(request) {
      return queryService.upcomingGauges(request);
    },

    upcomingGaugesPerDenom(request) {
      return queryService.upcomingGaugesPerDenom(request);
    },

    rewardsEst(request) {
      return queryService.rewardsEst(request);
    },

    lockableDurations(request) {
      return queryService.lockableDurations(request);
    }

  };
};

/***/ }),

/***/ 13265:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MsgAddToGauge": function() { return /* binding */ MsgAddToGauge; },
/* harmony export */   "MsgAddToGaugeResponse": function() { return /* binding */ MsgAddToGaugeResponse; },
/* harmony export */   "MsgCreateGauge": function() { return /* binding */ MsgCreateGauge; },
/* harmony export */   "MsgCreateGaugeResponse": function() { return /* binding */ MsgCreateGaugeResponse; }
/* harmony export */ });
/* harmony import */ var _lockup_lock__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24902);
/* harmony import */ var _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26178);
/* harmony import */ var _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20633);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47895);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__);





/** MsgCreateGauge creates a gague to distribute rewards to users */

function createBaseMsgCreateGauge() {
  return {
    isPerpetual: false,
    owner: "",
    distributeTo: undefined,
    coins: [],
    startTime: undefined,
    numEpochsPaidOver: _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.UZERO */ .dK.UZERO,
    poolId: _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.UZERO */ .dK.UZERO
  };
}

const MsgCreateGauge = {
  typeUrl: "/osmosis.incentives.MsgCreateGauge",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    if (message.isPerpetual === true) {
      writer.uint32(8).bool(message.isPerpetual);
    }

    if (message.owner !== "") {
      writer.uint32(18).string(message.owner);
    }

    if (message.distributeTo !== undefined) {
      _lockup_lock__WEBPACK_IMPORTED_MODULE_0__.QueryCondition.encode(message.distributeTo, writer.uint32(26).fork()).ldelim();
    }

    for (const v of message.coins) {
      _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.encode(v, writer.uint32(34).fork()).ldelim();
    }

    if (message.startTime !== undefined) {
      _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_2__.Timestamp.encode((0,_helpers__WEBPACK_IMPORTED_MODULE_3__/* .toTimestamp */ .Uq)(message.startTime), writer.uint32(42).fork()).ldelim();
    }

    if (!message.numEpochsPaidOver.isZero()) {
      writer.uint32(48).uint64(message.numEpochsPaidOver);
    }

    if (!message.poolId.isZero()) {
      writer.uint32(56).uint64(message.poolId);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgCreateGauge();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.isPerpetual = reader.bool();
          break;

        case 2:
          message.owner = reader.string();
          break;

        case 3:
          message.distributeTo = _lockup_lock__WEBPACK_IMPORTED_MODULE_0__.QueryCondition.decode(reader, reader.uint32());
          break;

        case 4:
          message.coins.push(_cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.decode(reader, reader.uint32()));
          break;

        case 5:
          message.startTime = (0,_helpers__WEBPACK_IMPORTED_MODULE_3__/* .fromTimestamp */ .Ol)(_google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_2__.Timestamp.decode(reader, reader.uint32()));
          break;

        case 6:
          message.numEpochsPaidOver = reader.uint64();
          break;

        case 7:
          message.poolId = reader.uint64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$isPerpetual, _object$owner, _object$coins, _object$startTime;

    const message = createBaseMsgCreateGauge();
    message.isPerpetual = (_object$isPerpetual = object.isPerpetual) !== null && _object$isPerpetual !== void 0 ? _object$isPerpetual : false;
    message.owner = (_object$owner = object.owner) !== null && _object$owner !== void 0 ? _object$owner : "";
    message.distributeTo = object.distributeTo !== undefined && object.distributeTo !== null ? _lockup_lock__WEBPACK_IMPORTED_MODULE_0__.QueryCondition.fromPartial(object.distributeTo) : undefined;
    message.coins = ((_object$coins = object.coins) === null || _object$coins === void 0 ? void 0 : _object$coins.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.fromPartial(e))) || [];
    message.startTime = (_object$startTime = object.startTime) !== null && _object$startTime !== void 0 ? _object$startTime : undefined;
    message.numEpochsPaidOver = object.numEpochsPaidOver !== undefined && object.numEpochsPaidOver !== null ? _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.fromValue */ .dK.fromValue(object.numEpochsPaidOver) : _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.UZERO */ .dK.UZERO;
    message.poolId = object.poolId !== undefined && object.poolId !== null ? _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.fromValue */ .dK.fromValue(object.poolId) : _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.UZERO */ .dK.UZERO;
    return message;
  },

  fromAmino(object) {
    return {
      isPerpetual: object.is_perpetual,
      owner: object.owner,
      distributeTo: object !== null && object !== void 0 && object.distribute_to ? _lockup_lock__WEBPACK_IMPORTED_MODULE_0__.QueryCondition.fromAmino(object.distribute_to) : undefined,
      coins: Array.isArray(object === null || object === void 0 ? void 0 : object.coins) ? object.coins.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.fromAmino(e)) : [],
      startTime: object !== null && object !== void 0 && object.start_time ? _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_2__.Timestamp.fromAmino(object.start_time) : undefined,
      numEpochsPaidOver: _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.fromString */ .dK.fromString(object.num_epochs_paid_over),
      poolId: _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.fromString */ .dK.fromString(object.pool_id)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.is_perpetual = message.isPerpetual;
    obj.owner = message.owner;
    obj.distribute_to = message.distributeTo ? _lockup_lock__WEBPACK_IMPORTED_MODULE_0__.QueryCondition.toAmino(message.distributeTo) : undefined;

    if (message.coins) {
      obj.coins = message.coins.map(e => e ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.toAmino(e) : undefined);
    } else {
      obj.coins = [];
    }

    obj.start_time = message.startTime ? _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_2__.Timestamp.toAmino(message.startTime) : undefined;
    obj.num_epochs_paid_over = message.numEpochsPaidOver ? message.numEpochsPaidOver.toString() : undefined;
    obj.pool_id = message.poolId ? message.poolId.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgCreateGauge.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/incentives/create-gauge",
      value: MsgCreateGauge.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgCreateGauge.decode(message.value);
  },

  toProto(message) {
    return MsgCreateGauge.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.incentives.MsgCreateGauge",
      value: MsgCreateGauge.encode(message).finish()
    };
  }

};

function createBaseMsgCreateGaugeResponse() {
  return {};
}

const MsgCreateGaugeResponse = {
  typeUrl: "/osmosis.incentives.MsgCreateGaugeResponse",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgCreateGaugeResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseMsgCreateGaugeResponse();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return MsgCreateGaugeResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/incentives/create-gauge-response",
      value: MsgCreateGaugeResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgCreateGaugeResponse.decode(message.value);
  },

  toProto(message) {
    return MsgCreateGaugeResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.incentives.MsgCreateGaugeResponse",
      value: MsgCreateGaugeResponse.encode(message).finish()
    };
  }

};

function createBaseMsgAddToGauge() {
  return {
    owner: "",
    gaugeId: _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.UZERO */ .dK.UZERO,
    rewards: []
  };
}

const MsgAddToGauge = {
  typeUrl: "/osmosis.incentives.MsgAddToGauge",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    if (message.owner !== "") {
      writer.uint32(10).string(message.owner);
    }

    if (!message.gaugeId.isZero()) {
      writer.uint32(16).uint64(message.gaugeId);
    }

    for (const v of message.rewards) {
      _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.encode(v, writer.uint32(26).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgAddToGauge();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.owner = reader.string();
          break;

        case 2:
          message.gaugeId = reader.uint64();
          break;

        case 3:
          message.rewards.push(_cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$owner2, _object$rewards;

    const message = createBaseMsgAddToGauge();
    message.owner = (_object$owner2 = object.owner) !== null && _object$owner2 !== void 0 ? _object$owner2 : "";
    message.gaugeId = object.gaugeId !== undefined && object.gaugeId !== null ? _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.fromValue */ .dK.fromValue(object.gaugeId) : _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.UZERO */ .dK.UZERO;
    message.rewards = ((_object$rewards = object.rewards) === null || _object$rewards === void 0 ? void 0 : _object$rewards.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      owner: object.owner,
      gaugeId: _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.fromString */ .dK.fromString(object.gauge_id),
      rewards: Array.isArray(object === null || object === void 0 ? void 0 : object.rewards) ? object.rewards.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.owner = message.owner;
    obj.gauge_id = message.gaugeId ? message.gaugeId.toString() : undefined;

    if (message.rewards) {
      obj.rewards = message.rewards.map(e => e ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.toAmino(e) : undefined);
    } else {
      obj.rewards = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return MsgAddToGauge.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/incentives/add-to-gauge",
      value: MsgAddToGauge.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgAddToGauge.decode(message.value);
  },

  toProto(message) {
    return MsgAddToGauge.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.incentives.MsgAddToGauge",
      value: MsgAddToGauge.encode(message).finish()
    };
  }

};

function createBaseMsgAddToGaugeResponse() {
  return {};
}

const MsgAddToGaugeResponse = {
  typeUrl: "/osmosis.incentives.MsgAddToGaugeResponse",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgAddToGaugeResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseMsgAddToGaugeResponse();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return MsgAddToGaugeResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/incentives/add-to-gauge-response",
      value: MsgAddToGaugeResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgAddToGaugeResponse.decode(message.value);
  },

  toProto(message) {
    return MsgAddToGaugeResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.incentives.MsgAddToGaugeResponse",
      value: MsgAddToGaugeResponse.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 30521:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MsgClientImpl": function() { return /* binding */ MsgClientImpl; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4942);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _tx__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13265);



class MsgClientImpl {
  constructor(rpc) {
    (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, "rpc", void 0);

    this.rpc = rpc;
    this.createGauge = this.createGauge.bind(this);
    this.addToGauge = this.addToGauge.bind(this);
  }

  createGauge(request) {
    const data = _tx__WEBPACK_IMPORTED_MODULE_1__.MsgCreateGauge.encode(request).finish();
    const promise = this.rpc.request("osmosis.incentives.Msg", "CreateGauge", data);
    return promise.then(data => _tx__WEBPACK_IMPORTED_MODULE_1__.MsgCreateGaugeResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  addToGauge(request) {
    const data = _tx__WEBPACK_IMPORTED_MODULE_1__.MsgAddToGauge.encode(request).finish();
    const promise = this.rpc.request("osmosis.incentives.Msg", "AddToGauge", data);
    return promise.then(data => _tx__WEBPACK_IMPORTED_MODULE_1__.MsgAddToGaugeResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

}

/***/ }),

/***/ 24902:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LockQueryType": function() { return /* binding */ LockQueryType; },
/* harmony export */   "LockQueryTypeAmino": function() { return /* binding */ LockQueryTypeAmino; },
/* harmony export */   "LockQueryTypeSDKType": function() { return /* binding */ LockQueryTypeSDKType; },
/* harmony export */   "PeriodLock": function() { return /* binding */ PeriodLock; },
/* harmony export */   "QueryCondition": function() { return /* binding */ QueryCondition; },
/* harmony export */   "SyntheticLock": function() { return /* binding */ SyntheticLock; },
/* harmony export */   "lockQueryTypeFromJSON": function() { return /* binding */ lockQueryTypeFromJSON; },
/* harmony export */   "lockQueryTypeToJSON": function() { return /* binding */ lockQueryTypeToJSON; }
/* harmony export */ });
/* harmony import */ var _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6499);
/* harmony import */ var _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20633);
/* harmony import */ var _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26178);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47895);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__);





/**
 * LockQueryType defines the type of the lock query that can
 * either be by duration or start time of the lock.
 */

let LockQueryType;

(function (LockQueryType) {
  LockQueryType[LockQueryType["ByDuration"] = 0] = "ByDuration";
  LockQueryType[LockQueryType["ByTime"] = 1] = "ByTime";
  LockQueryType[LockQueryType["NoLock"] = 2] = "NoLock";
  LockQueryType[LockQueryType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(LockQueryType || (LockQueryType = {}));

const LockQueryTypeSDKType = LockQueryType;
const LockQueryTypeAmino = LockQueryType;
function lockQueryTypeFromJSON(object) {
  switch (object) {
    case 0:
    case "ByDuration":
      return LockQueryType.ByDuration;

    case 1:
    case "ByTime":
      return LockQueryType.ByTime;

    case 2:
    case "NoLock":
      return LockQueryType.NoLock;

    case -1:
    case "UNRECOGNIZED":
    default:
      return LockQueryType.UNRECOGNIZED;
  }
}
function lockQueryTypeToJSON(object) {
  switch (object) {
    case LockQueryType.ByDuration:
      return "ByDuration";

    case LockQueryType.ByTime:
      return "ByTime";

    case LockQueryType.NoLock:
      return "NoLock";

    case LockQueryType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
/**
 * PeriodLock is a single lock unit by period defined by the x/lockup module.
 * It's a record of a locked coin at a specific time. It stores owner, duration,
 * unlock time and the number of coins locked. A state of a period lock is
 * created upon lock creation, and deleted once the lock has been matured after
 * the `duration` has passed since unbonding started.
 */

function createBasePeriodLock() {
  return {
    ID: _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.UZERO */ .dK.UZERO,
    owner: "",
    duration: undefined,
    endTime: undefined,
    coins: [],
    rewardReceiverAddress: ""
  };
}

const PeriodLock = {
  typeUrl: "/osmosis.lockup.PeriodLock",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    if (!message.ID.isZero()) {
      writer.uint32(8).uint64(message.ID);
    }

    if (message.owner !== "") {
      writer.uint32(18).string(message.owner);
    }

    if (message.duration !== undefined) {
      _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_0__.Duration.encode(message.duration, writer.uint32(26).fork()).ldelim();
    }

    if (message.endTime !== undefined) {
      _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_1__.Timestamp.encode((0,_helpers__WEBPACK_IMPORTED_MODULE_3__/* .toTimestamp */ .Uq)(message.endTime), writer.uint32(34).fork()).ldelim();
    }

    for (const v of message.coins) {
      _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_2__.Coin.encode(v, writer.uint32(42).fork()).ldelim();
    }

    if (message.rewardReceiverAddress !== "") {
      writer.uint32(50).string(message.rewardReceiverAddress);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePeriodLock();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.ID = reader.uint64();
          break;

        case 2:
          message.owner = reader.string();
          break;

        case 3:
          message.duration = _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_0__.Duration.decode(reader, reader.uint32());
          break;

        case 4:
          message.endTime = (0,_helpers__WEBPACK_IMPORTED_MODULE_3__/* .fromTimestamp */ .Ol)(_google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_1__.Timestamp.decode(reader, reader.uint32()));
          break;

        case 5:
          message.coins.push(_cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_2__.Coin.decode(reader, reader.uint32()));
          break;

        case 6:
          message.rewardReceiverAddress = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$owner, _object$endTime, _object$coins, _object$rewardReceive;

    const message = createBasePeriodLock();
    message.ID = object.ID !== undefined && object.ID !== null ? _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.fromValue */ .dK.fromValue(object.ID) : _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.UZERO */ .dK.UZERO;
    message.owner = (_object$owner = object.owner) !== null && _object$owner !== void 0 ? _object$owner : "";
    message.duration = object.duration !== undefined && object.duration !== null ? _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_0__.Duration.fromPartial(object.duration) : undefined;
    message.endTime = (_object$endTime = object.endTime) !== null && _object$endTime !== void 0 ? _object$endTime : undefined;
    message.coins = ((_object$coins = object.coins) === null || _object$coins === void 0 ? void 0 : _object$coins.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_2__.Coin.fromPartial(e))) || [];
    message.rewardReceiverAddress = (_object$rewardReceive = object.rewardReceiverAddress) !== null && _object$rewardReceive !== void 0 ? _object$rewardReceive : "";
    return message;
  },

  fromAmino(object) {
    return {
      ID: _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.fromString */ .dK.fromString(object.ID),
      owner: object.owner,
      duration: object !== null && object !== void 0 && object.duration ? _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_0__.Duration.fromAmino(object.duration) : undefined,
      endTime: object !== null && object !== void 0 && object.end_time ? _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_1__.Timestamp.fromAmino(object.end_time) : undefined,
      coins: Array.isArray(object === null || object === void 0 ? void 0 : object.coins) ? object.coins.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_2__.Coin.fromAmino(e)) : [],
      rewardReceiverAddress: object.reward_receiver_address
    };
  },

  toAmino(message) {
    const obj = {};
    obj.ID = message.ID ? message.ID.toString() : undefined;
    obj.owner = message.owner;
    obj.duration = message.duration ? _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_0__.Duration.toAmino(message.duration) : undefined;
    obj.end_time = message.endTime ? _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_1__.Timestamp.toAmino(message.endTime) : undefined;

    if (message.coins) {
      obj.coins = message.coins.map(e => e ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_2__.Coin.toAmino(e) : undefined);
    } else {
      obj.coins = [];
    }

    obj.reward_receiver_address = message.rewardReceiverAddress;
    return obj;
  },

  fromAminoMsg(object) {
    return PeriodLock.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/lockup/period-lock",
      value: PeriodLock.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return PeriodLock.decode(message.value);
  },

  toProto(message) {
    return PeriodLock.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.lockup.PeriodLock",
      value: PeriodLock.encode(message).finish()
    };
  }

};

function createBaseQueryCondition() {
  return {
    lockQueryType: 0,
    denom: "",
    duration: undefined,
    timestamp: undefined
  };
}

const QueryCondition = {
  typeUrl: "/osmosis.lockup.QueryCondition",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    if (message.lockQueryType !== 0) {
      writer.uint32(8).int32(message.lockQueryType);
    }

    if (message.denom !== "") {
      writer.uint32(18).string(message.denom);
    }

    if (message.duration !== undefined) {
      _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_0__.Duration.encode(message.duration, writer.uint32(26).fork()).ldelim();
    }

    if (message.timestamp !== undefined) {
      _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_1__.Timestamp.encode((0,_helpers__WEBPACK_IMPORTED_MODULE_3__/* .toTimestamp */ .Uq)(message.timestamp), writer.uint32(34).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryCondition();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.lockQueryType = reader.int32();
          break;

        case 2:
          message.denom = reader.string();
          break;

        case 3:
          message.duration = _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_0__.Duration.decode(reader, reader.uint32());
          break;

        case 4:
          message.timestamp = (0,_helpers__WEBPACK_IMPORTED_MODULE_3__/* .fromTimestamp */ .Ol)(_google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_1__.Timestamp.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$lockQueryType, _object$denom, _object$timestamp;

    const message = createBaseQueryCondition();
    message.lockQueryType = (_object$lockQueryType = object.lockQueryType) !== null && _object$lockQueryType !== void 0 ? _object$lockQueryType : 0;
    message.denom = (_object$denom = object.denom) !== null && _object$denom !== void 0 ? _object$denom : "";
    message.duration = object.duration !== undefined && object.duration !== null ? _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_0__.Duration.fromPartial(object.duration) : undefined;
    message.timestamp = (_object$timestamp = object.timestamp) !== null && _object$timestamp !== void 0 ? _object$timestamp : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      lockQueryType: (0,_helpers__WEBPACK_IMPORTED_MODULE_3__/* .isSet */ .DM)(object.lock_query_type) ? lockQueryTypeFromJSON(object.lock_query_type) : 0,
      denom: object.denom,
      duration: object !== null && object !== void 0 && object.duration ? _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_0__.Duration.fromAmino(object.duration) : undefined,
      timestamp: object !== null && object !== void 0 && object.timestamp ? _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_1__.Timestamp.fromAmino(object.timestamp) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.lock_query_type = message.lockQueryType;
    obj.denom = message.denom;
    obj.duration = message.duration ? _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_0__.Duration.toAmino(message.duration) : undefined;
    obj.timestamp = message.timestamp ? _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_1__.Timestamp.toAmino(message.timestamp) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryCondition.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/lockup/query-condition",
      value: QueryCondition.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryCondition.decode(message.value);
  },

  toProto(message) {
    return QueryCondition.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.lockup.QueryCondition",
      value: QueryCondition.encode(message).finish()
    };
  }

};

function createBaseSyntheticLock() {
  return {
    underlyingLockId: _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.UZERO */ .dK.UZERO,
    synthDenom: "",
    endTime: undefined,
    duration: undefined
  };
}

const SyntheticLock = {
  typeUrl: "/osmosis.lockup.SyntheticLock",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    if (!message.underlyingLockId.isZero()) {
      writer.uint32(8).uint64(message.underlyingLockId);
    }

    if (message.synthDenom !== "") {
      writer.uint32(18).string(message.synthDenom);
    }

    if (message.endTime !== undefined) {
      _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_1__.Timestamp.encode((0,_helpers__WEBPACK_IMPORTED_MODULE_3__/* .toTimestamp */ .Uq)(message.endTime), writer.uint32(26).fork()).ldelim();
    }

    if (message.duration !== undefined) {
      _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_0__.Duration.encode(message.duration, writer.uint32(34).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSyntheticLock();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.underlyingLockId = reader.uint64();
          break;

        case 2:
          message.synthDenom = reader.string();
          break;

        case 3:
          message.endTime = (0,_helpers__WEBPACK_IMPORTED_MODULE_3__/* .fromTimestamp */ .Ol)(_google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_1__.Timestamp.decode(reader, reader.uint32()));
          break;

        case 4:
          message.duration = _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_0__.Duration.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$synthDenom, _object$endTime2;

    const message = createBaseSyntheticLock();
    message.underlyingLockId = object.underlyingLockId !== undefined && object.underlyingLockId !== null ? _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.fromValue */ .dK.fromValue(object.underlyingLockId) : _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.UZERO */ .dK.UZERO;
    message.synthDenom = (_object$synthDenom = object.synthDenom) !== null && _object$synthDenom !== void 0 ? _object$synthDenom : "";
    message.endTime = (_object$endTime2 = object.endTime) !== null && _object$endTime2 !== void 0 ? _object$endTime2 : undefined;
    message.duration = object.duration !== undefined && object.duration !== null ? _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_0__.Duration.fromPartial(object.duration) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      underlyingLockId: _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.fromString */ .dK.fromString(object.underlying_lock_id),
      synthDenom: object.synth_denom,
      endTime: object !== null && object !== void 0 && object.end_time ? _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_1__.Timestamp.fromAmino(object.end_time) : undefined,
      duration: object !== null && object !== void 0 && object.duration ? _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_0__.Duration.fromAmino(object.duration) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.underlying_lock_id = message.underlyingLockId ? message.underlyingLockId.toString() : undefined;
    obj.synth_denom = message.synthDenom;
    obj.end_time = message.endTime ? _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_1__.Timestamp.toAmino(message.endTime) : undefined;
    obj.duration = message.duration ? _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_0__.Duration.toAmino(message.duration) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return SyntheticLock.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/lockup/synthetic-lock",
      value: SyntheticLock.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return SyntheticLock.decode(message.value);
  },

  toProto(message) {
    return SyntheticLock.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.lockup.SyntheticLock",
      value: SyntheticLock.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 13381:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Params": function() { return /* binding */ Params; }
/* harmony export */ });
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__);


function createBaseParams() {
  return {
    forceUnlockAllowedAddresses: []
  };
}

const Params = {
  typeUrl: "/osmosis.lockup.Params",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Writer.create()) {
    for (const v of message.forceUnlockAllowedAddresses) {
      writer.uint32(10).string(v);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseParams();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.forceUnlockAllowedAddresses.push(reader.string());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$forceUnlockAl;

    const message = createBaseParams();
    message.forceUnlockAllowedAddresses = ((_object$forceUnlockAl = object.forceUnlockAllowedAddresses) === null || _object$forceUnlockAl === void 0 ? void 0 : _object$forceUnlockAl.map(e => e)) || [];
    return message;
  },

  fromAmino(object) {
    return {
      forceUnlockAllowedAddresses: Array.isArray(object === null || object === void 0 ? void 0 : object.force_unlock_allowed_addresses) ? object.force_unlock_allowed_addresses.map(e => e) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.forceUnlockAllowedAddresses) {
      obj.force_unlock_allowed_addresses = message.forceUnlockAllowedAddresses.map(e => e);
    } else {
      obj.force_unlock_allowed_addresses = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return Params.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/lockup/params",
      value: Params.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return Params.decode(message.value);
  },

  toProto(message) {
    return Params.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.lockup.Params",
      value: Params.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 10792:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AccountLockedCoinsRequest": function() { return /* binding */ AccountLockedCoinsRequest; },
/* harmony export */   "AccountLockedCoinsResponse": function() { return /* binding */ AccountLockedCoinsResponse; },
/* harmony export */   "AccountLockedDurationRequest": function() { return /* binding */ AccountLockedDurationRequest; },
/* harmony export */   "AccountLockedDurationResponse": function() { return /* binding */ AccountLockedDurationResponse; },
/* harmony export */   "AccountLockedLongerDurationDenomRequest": function() { return /* binding */ AccountLockedLongerDurationDenomRequest; },
/* harmony export */   "AccountLockedLongerDurationDenomResponse": function() { return /* binding */ AccountLockedLongerDurationDenomResponse; },
/* harmony export */   "AccountLockedLongerDurationNotUnlockingOnlyRequest": function() { return /* binding */ AccountLockedLongerDurationNotUnlockingOnlyRequest; },
/* harmony export */   "AccountLockedLongerDurationNotUnlockingOnlyResponse": function() { return /* binding */ AccountLockedLongerDurationNotUnlockingOnlyResponse; },
/* harmony export */   "AccountLockedLongerDurationRequest": function() { return /* binding */ AccountLockedLongerDurationRequest; },
/* harmony export */   "AccountLockedLongerDurationResponse": function() { return /* binding */ AccountLockedLongerDurationResponse; },
/* harmony export */   "AccountLockedPastTimeDenomRequest": function() { return /* binding */ AccountLockedPastTimeDenomRequest; },
/* harmony export */   "AccountLockedPastTimeDenomResponse": function() { return /* binding */ AccountLockedPastTimeDenomResponse; },
/* harmony export */   "AccountLockedPastTimeNotUnlockingOnlyRequest": function() { return /* binding */ AccountLockedPastTimeNotUnlockingOnlyRequest; },
/* harmony export */   "AccountLockedPastTimeNotUnlockingOnlyResponse": function() { return /* binding */ AccountLockedPastTimeNotUnlockingOnlyResponse; },
/* harmony export */   "AccountLockedPastTimeRequest": function() { return /* binding */ AccountLockedPastTimeRequest; },
/* harmony export */   "AccountLockedPastTimeResponse": function() { return /* binding */ AccountLockedPastTimeResponse; },
/* harmony export */   "AccountUnlockableCoinsRequest": function() { return /* binding */ AccountUnlockableCoinsRequest; },
/* harmony export */   "AccountUnlockableCoinsResponse": function() { return /* binding */ AccountUnlockableCoinsResponse; },
/* harmony export */   "AccountUnlockedBeforeTimeRequest": function() { return /* binding */ AccountUnlockedBeforeTimeRequest; },
/* harmony export */   "AccountUnlockedBeforeTimeResponse": function() { return /* binding */ AccountUnlockedBeforeTimeResponse; },
/* harmony export */   "AccountUnlockingCoinsRequest": function() { return /* binding */ AccountUnlockingCoinsRequest; },
/* harmony export */   "AccountUnlockingCoinsResponse": function() { return /* binding */ AccountUnlockingCoinsResponse; },
/* harmony export */   "LockRewardReceiverRequest": function() { return /* binding */ LockRewardReceiverRequest; },
/* harmony export */   "LockRewardReceiverResponse": function() { return /* binding */ LockRewardReceiverResponse; },
/* harmony export */   "LockedDenomRequest": function() { return /* binding */ LockedDenomRequest; },
/* harmony export */   "LockedDenomResponse": function() { return /* binding */ LockedDenomResponse; },
/* harmony export */   "LockedRequest": function() { return /* binding */ LockedRequest; },
/* harmony export */   "LockedResponse": function() { return /* binding */ LockedResponse; },
/* harmony export */   "ModuleBalanceRequest": function() { return /* binding */ ModuleBalanceRequest; },
/* harmony export */   "ModuleBalanceResponse": function() { return /* binding */ ModuleBalanceResponse; },
/* harmony export */   "ModuleLockedAmountRequest": function() { return /* binding */ ModuleLockedAmountRequest; },
/* harmony export */   "ModuleLockedAmountResponse": function() { return /* binding */ ModuleLockedAmountResponse; },
/* harmony export */   "NextLockIDRequest": function() { return /* binding */ NextLockIDRequest; },
/* harmony export */   "NextLockIDResponse": function() { return /* binding */ NextLockIDResponse; },
/* harmony export */   "QueryParamsRequest": function() { return /* binding */ QueryParamsRequest; },
/* harmony export */   "QueryParamsResponse": function() { return /* binding */ QueryParamsResponse; },
/* harmony export */   "SyntheticLockupByLockupIDRequest": function() { return /* binding */ SyntheticLockupByLockupIDRequest; },
/* harmony export */   "SyntheticLockupByLockupIDResponse": function() { return /* binding */ SyntheticLockupByLockupIDResponse; },
/* harmony export */   "SyntheticLockupsByLockupIDRequest": function() { return /* binding */ SyntheticLockupsByLockupIDRequest; },
/* harmony export */   "SyntheticLockupsByLockupIDResponse": function() { return /* binding */ SyntheticLockupsByLockupIDResponse; }
/* harmony export */ });
/* harmony import */ var _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20633);
/* harmony import */ var _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6499);
/* harmony import */ var _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26178);
/* harmony import */ var _lock__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24902);
/* harmony import */ var _params__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(13381);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47895);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__);








function createBaseModuleBalanceRequest() {
  return {};
}

const ModuleBalanceRequest = {
  typeUrl: "/osmosis.lockup.ModuleBalanceRequest",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseModuleBalanceRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseModuleBalanceRequest();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return ModuleBalanceRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/lockup/module-balance-request",
      value: ModuleBalanceRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return ModuleBalanceRequest.decode(message.value);
  },

  toProto(message) {
    return ModuleBalanceRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.lockup.ModuleBalanceRequest",
      value: ModuleBalanceRequest.encode(message).finish()
    };
  }

};

function createBaseModuleBalanceResponse() {
  return {
    coins: []
  };
}

const ModuleBalanceResponse = {
  typeUrl: "/osmosis.lockup.ModuleBalanceResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    for (const v of message.coins) {
      _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_2__.Coin.encode(v, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseModuleBalanceResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.coins.push(_cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_2__.Coin.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$coins;

    const message = createBaseModuleBalanceResponse();
    message.coins = ((_object$coins = object.coins) === null || _object$coins === void 0 ? void 0 : _object$coins.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_2__.Coin.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      coins: Array.isArray(object === null || object === void 0 ? void 0 : object.coins) ? object.coins.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_2__.Coin.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.coins) {
      obj.coins = message.coins.map(e => e ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_2__.Coin.toAmino(e) : undefined);
    } else {
      obj.coins = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return ModuleBalanceResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/lockup/module-balance-response",
      value: ModuleBalanceResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return ModuleBalanceResponse.decode(message.value);
  },

  toProto(message) {
    return ModuleBalanceResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.lockup.ModuleBalanceResponse",
      value: ModuleBalanceResponse.encode(message).finish()
    };
  }

};

function createBaseModuleLockedAmountRequest() {
  return {};
}

const ModuleLockedAmountRequest = {
  typeUrl: "/osmosis.lockup.ModuleLockedAmountRequest",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseModuleLockedAmountRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseModuleLockedAmountRequest();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return ModuleLockedAmountRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/lockup/module-locked-amount-request",
      value: ModuleLockedAmountRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return ModuleLockedAmountRequest.decode(message.value);
  },

  toProto(message) {
    return ModuleLockedAmountRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.lockup.ModuleLockedAmountRequest",
      value: ModuleLockedAmountRequest.encode(message).finish()
    };
  }

};

function createBaseModuleLockedAmountResponse() {
  return {
    coins: []
  };
}

const ModuleLockedAmountResponse = {
  typeUrl: "/osmosis.lockup.ModuleLockedAmountResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    for (const v of message.coins) {
      _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_2__.Coin.encode(v, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseModuleLockedAmountResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.coins.push(_cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_2__.Coin.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$coins2;

    const message = createBaseModuleLockedAmountResponse();
    message.coins = ((_object$coins2 = object.coins) === null || _object$coins2 === void 0 ? void 0 : _object$coins2.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_2__.Coin.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      coins: Array.isArray(object === null || object === void 0 ? void 0 : object.coins) ? object.coins.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_2__.Coin.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.coins) {
      obj.coins = message.coins.map(e => e ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_2__.Coin.toAmino(e) : undefined);
    } else {
      obj.coins = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return ModuleLockedAmountResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/lockup/module-locked-amount-response",
      value: ModuleLockedAmountResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return ModuleLockedAmountResponse.decode(message.value);
  },

  toProto(message) {
    return ModuleLockedAmountResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.lockup.ModuleLockedAmountResponse",
      value: ModuleLockedAmountResponse.encode(message).finish()
    };
  }

};

function createBaseAccountUnlockableCoinsRequest() {
  return {
    owner: ""
  };
}

const AccountUnlockableCoinsRequest = {
  typeUrl: "/osmosis.lockup.AccountUnlockableCoinsRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    if (message.owner !== "") {
      writer.uint32(10).string(message.owner);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAccountUnlockableCoinsRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.owner = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$owner;

    const message = createBaseAccountUnlockableCoinsRequest();
    message.owner = (_object$owner = object.owner) !== null && _object$owner !== void 0 ? _object$owner : "";
    return message;
  },

  fromAmino(object) {
    return {
      owner: object.owner
    };
  },

  toAmino(message) {
    const obj = {};
    obj.owner = message.owner;
    return obj;
  },

  fromAminoMsg(object) {
    return AccountUnlockableCoinsRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/lockup/account-unlockable-coins-request",
      value: AccountUnlockableCoinsRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return AccountUnlockableCoinsRequest.decode(message.value);
  },

  toProto(message) {
    return AccountUnlockableCoinsRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.lockup.AccountUnlockableCoinsRequest",
      value: AccountUnlockableCoinsRequest.encode(message).finish()
    };
  }

};

function createBaseAccountUnlockableCoinsResponse() {
  return {
    coins: []
  };
}

const AccountUnlockableCoinsResponse = {
  typeUrl: "/osmosis.lockup.AccountUnlockableCoinsResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    for (const v of message.coins) {
      _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_2__.Coin.encode(v, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAccountUnlockableCoinsResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.coins.push(_cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_2__.Coin.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$coins3;

    const message = createBaseAccountUnlockableCoinsResponse();
    message.coins = ((_object$coins3 = object.coins) === null || _object$coins3 === void 0 ? void 0 : _object$coins3.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_2__.Coin.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      coins: Array.isArray(object === null || object === void 0 ? void 0 : object.coins) ? object.coins.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_2__.Coin.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.coins) {
      obj.coins = message.coins.map(e => e ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_2__.Coin.toAmino(e) : undefined);
    } else {
      obj.coins = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return AccountUnlockableCoinsResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/lockup/account-unlockable-coins-response",
      value: AccountUnlockableCoinsResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return AccountUnlockableCoinsResponse.decode(message.value);
  },

  toProto(message) {
    return AccountUnlockableCoinsResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.lockup.AccountUnlockableCoinsResponse",
      value: AccountUnlockableCoinsResponse.encode(message).finish()
    };
  }

};

function createBaseAccountUnlockingCoinsRequest() {
  return {
    owner: ""
  };
}

const AccountUnlockingCoinsRequest = {
  typeUrl: "/osmosis.lockup.AccountUnlockingCoinsRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    if (message.owner !== "") {
      writer.uint32(10).string(message.owner);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAccountUnlockingCoinsRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.owner = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$owner2;

    const message = createBaseAccountUnlockingCoinsRequest();
    message.owner = (_object$owner2 = object.owner) !== null && _object$owner2 !== void 0 ? _object$owner2 : "";
    return message;
  },

  fromAmino(object) {
    return {
      owner: object.owner
    };
  },

  toAmino(message) {
    const obj = {};
    obj.owner = message.owner;
    return obj;
  },

  fromAminoMsg(object) {
    return AccountUnlockingCoinsRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/lockup/account-unlocking-coins-request",
      value: AccountUnlockingCoinsRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return AccountUnlockingCoinsRequest.decode(message.value);
  },

  toProto(message) {
    return AccountUnlockingCoinsRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.lockup.AccountUnlockingCoinsRequest",
      value: AccountUnlockingCoinsRequest.encode(message).finish()
    };
  }

};

function createBaseAccountUnlockingCoinsResponse() {
  return {
    coins: []
  };
}

const AccountUnlockingCoinsResponse = {
  typeUrl: "/osmosis.lockup.AccountUnlockingCoinsResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    for (const v of message.coins) {
      _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_2__.Coin.encode(v, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAccountUnlockingCoinsResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.coins.push(_cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_2__.Coin.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$coins4;

    const message = createBaseAccountUnlockingCoinsResponse();
    message.coins = ((_object$coins4 = object.coins) === null || _object$coins4 === void 0 ? void 0 : _object$coins4.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_2__.Coin.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      coins: Array.isArray(object === null || object === void 0 ? void 0 : object.coins) ? object.coins.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_2__.Coin.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.coins) {
      obj.coins = message.coins.map(e => e ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_2__.Coin.toAmino(e) : undefined);
    } else {
      obj.coins = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return AccountUnlockingCoinsResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/lockup/account-unlocking-coins-response",
      value: AccountUnlockingCoinsResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return AccountUnlockingCoinsResponse.decode(message.value);
  },

  toProto(message) {
    return AccountUnlockingCoinsResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.lockup.AccountUnlockingCoinsResponse",
      value: AccountUnlockingCoinsResponse.encode(message).finish()
    };
  }

};

function createBaseAccountLockedCoinsRequest() {
  return {
    owner: ""
  };
}

const AccountLockedCoinsRequest = {
  typeUrl: "/osmosis.lockup.AccountLockedCoinsRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    if (message.owner !== "") {
      writer.uint32(10).string(message.owner);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAccountLockedCoinsRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.owner = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$owner3;

    const message = createBaseAccountLockedCoinsRequest();
    message.owner = (_object$owner3 = object.owner) !== null && _object$owner3 !== void 0 ? _object$owner3 : "";
    return message;
  },

  fromAmino(object) {
    return {
      owner: object.owner
    };
  },

  toAmino(message) {
    const obj = {};
    obj.owner = message.owner;
    return obj;
  },

  fromAminoMsg(object) {
    return AccountLockedCoinsRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/lockup/account-locked-coins-request",
      value: AccountLockedCoinsRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return AccountLockedCoinsRequest.decode(message.value);
  },

  toProto(message) {
    return AccountLockedCoinsRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.lockup.AccountLockedCoinsRequest",
      value: AccountLockedCoinsRequest.encode(message).finish()
    };
  }

};

function createBaseAccountLockedCoinsResponse() {
  return {
    coins: []
  };
}

const AccountLockedCoinsResponse = {
  typeUrl: "/osmosis.lockup.AccountLockedCoinsResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    for (const v of message.coins) {
      _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_2__.Coin.encode(v, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAccountLockedCoinsResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.coins.push(_cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_2__.Coin.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$coins5;

    const message = createBaseAccountLockedCoinsResponse();
    message.coins = ((_object$coins5 = object.coins) === null || _object$coins5 === void 0 ? void 0 : _object$coins5.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_2__.Coin.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      coins: Array.isArray(object === null || object === void 0 ? void 0 : object.coins) ? object.coins.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_2__.Coin.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.coins) {
      obj.coins = message.coins.map(e => e ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_2__.Coin.toAmino(e) : undefined);
    } else {
      obj.coins = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return AccountLockedCoinsResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/lockup/account-locked-coins-response",
      value: AccountLockedCoinsResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return AccountLockedCoinsResponse.decode(message.value);
  },

  toProto(message) {
    return AccountLockedCoinsResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.lockup.AccountLockedCoinsResponse",
      value: AccountLockedCoinsResponse.encode(message).finish()
    };
  }

};

function createBaseAccountLockedPastTimeRequest() {
  return {
    owner: "",
    timestamp: undefined
  };
}

const AccountLockedPastTimeRequest = {
  typeUrl: "/osmosis.lockup.AccountLockedPastTimeRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    if (message.owner !== "") {
      writer.uint32(10).string(message.owner);
    }

    if (message.timestamp !== undefined) {
      _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_0__.Timestamp.encode((0,_helpers__WEBPACK_IMPORTED_MODULE_5__/* .toTimestamp */ .Uq)(message.timestamp), writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAccountLockedPastTimeRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.owner = reader.string();
          break;

        case 2:
          message.timestamp = (0,_helpers__WEBPACK_IMPORTED_MODULE_5__/* .fromTimestamp */ .Ol)(_google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_0__.Timestamp.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$owner4, _object$timestamp;

    const message = createBaseAccountLockedPastTimeRequest();
    message.owner = (_object$owner4 = object.owner) !== null && _object$owner4 !== void 0 ? _object$owner4 : "";
    message.timestamp = (_object$timestamp = object.timestamp) !== null && _object$timestamp !== void 0 ? _object$timestamp : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      owner: object.owner,
      timestamp: object !== null && object !== void 0 && object.timestamp ? _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_0__.Timestamp.fromAmino(object.timestamp) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.owner = message.owner;
    obj.timestamp = message.timestamp ? _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_0__.Timestamp.toAmino(message.timestamp) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return AccountLockedPastTimeRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/lockup/account-locked-past-time-request",
      value: AccountLockedPastTimeRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return AccountLockedPastTimeRequest.decode(message.value);
  },

  toProto(message) {
    return AccountLockedPastTimeRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.lockup.AccountLockedPastTimeRequest",
      value: AccountLockedPastTimeRequest.encode(message).finish()
    };
  }

};

function createBaseAccountLockedPastTimeResponse() {
  return {
    locks: []
  };
}

const AccountLockedPastTimeResponse = {
  typeUrl: "/osmosis.lockup.AccountLockedPastTimeResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    for (const v of message.locks) {
      _lock__WEBPACK_IMPORTED_MODULE_3__.PeriodLock.encode(v, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAccountLockedPastTimeResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.locks.push(_lock__WEBPACK_IMPORTED_MODULE_3__.PeriodLock.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$locks;

    const message = createBaseAccountLockedPastTimeResponse();
    message.locks = ((_object$locks = object.locks) === null || _object$locks === void 0 ? void 0 : _object$locks.map(e => _lock__WEBPACK_IMPORTED_MODULE_3__.PeriodLock.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      locks: Array.isArray(object === null || object === void 0 ? void 0 : object.locks) ? object.locks.map(e => _lock__WEBPACK_IMPORTED_MODULE_3__.PeriodLock.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.locks) {
      obj.locks = message.locks.map(e => e ? _lock__WEBPACK_IMPORTED_MODULE_3__.PeriodLock.toAmino(e) : undefined);
    } else {
      obj.locks = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return AccountLockedPastTimeResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/lockup/account-locked-past-time-response",
      value: AccountLockedPastTimeResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return AccountLockedPastTimeResponse.decode(message.value);
  },

  toProto(message) {
    return AccountLockedPastTimeResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.lockup.AccountLockedPastTimeResponse",
      value: AccountLockedPastTimeResponse.encode(message).finish()
    };
  }

};

function createBaseAccountLockedPastTimeNotUnlockingOnlyRequest() {
  return {
    owner: "",
    timestamp: undefined
  };
}

const AccountLockedPastTimeNotUnlockingOnlyRequest = {
  typeUrl: "/osmosis.lockup.AccountLockedPastTimeNotUnlockingOnlyRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    if (message.owner !== "") {
      writer.uint32(10).string(message.owner);
    }

    if (message.timestamp !== undefined) {
      _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_0__.Timestamp.encode((0,_helpers__WEBPACK_IMPORTED_MODULE_5__/* .toTimestamp */ .Uq)(message.timestamp), writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAccountLockedPastTimeNotUnlockingOnlyRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.owner = reader.string();
          break;

        case 2:
          message.timestamp = (0,_helpers__WEBPACK_IMPORTED_MODULE_5__/* .fromTimestamp */ .Ol)(_google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_0__.Timestamp.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$owner5, _object$timestamp2;

    const message = createBaseAccountLockedPastTimeNotUnlockingOnlyRequest();
    message.owner = (_object$owner5 = object.owner) !== null && _object$owner5 !== void 0 ? _object$owner5 : "";
    message.timestamp = (_object$timestamp2 = object.timestamp) !== null && _object$timestamp2 !== void 0 ? _object$timestamp2 : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      owner: object.owner,
      timestamp: object !== null && object !== void 0 && object.timestamp ? _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_0__.Timestamp.fromAmino(object.timestamp) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.owner = message.owner;
    obj.timestamp = message.timestamp ? _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_0__.Timestamp.toAmino(message.timestamp) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return AccountLockedPastTimeNotUnlockingOnlyRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/lockup/account-locked-past-time-not-unlocking-only-request",
      value: AccountLockedPastTimeNotUnlockingOnlyRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return AccountLockedPastTimeNotUnlockingOnlyRequest.decode(message.value);
  },

  toProto(message) {
    return AccountLockedPastTimeNotUnlockingOnlyRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.lockup.AccountLockedPastTimeNotUnlockingOnlyRequest",
      value: AccountLockedPastTimeNotUnlockingOnlyRequest.encode(message).finish()
    };
  }

};

function createBaseAccountLockedPastTimeNotUnlockingOnlyResponse() {
  return {
    locks: []
  };
}

const AccountLockedPastTimeNotUnlockingOnlyResponse = {
  typeUrl: "/osmosis.lockup.AccountLockedPastTimeNotUnlockingOnlyResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    for (const v of message.locks) {
      _lock__WEBPACK_IMPORTED_MODULE_3__.PeriodLock.encode(v, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAccountLockedPastTimeNotUnlockingOnlyResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.locks.push(_lock__WEBPACK_IMPORTED_MODULE_3__.PeriodLock.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$locks2;

    const message = createBaseAccountLockedPastTimeNotUnlockingOnlyResponse();
    message.locks = ((_object$locks2 = object.locks) === null || _object$locks2 === void 0 ? void 0 : _object$locks2.map(e => _lock__WEBPACK_IMPORTED_MODULE_3__.PeriodLock.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      locks: Array.isArray(object === null || object === void 0 ? void 0 : object.locks) ? object.locks.map(e => _lock__WEBPACK_IMPORTED_MODULE_3__.PeriodLock.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.locks) {
      obj.locks = message.locks.map(e => e ? _lock__WEBPACK_IMPORTED_MODULE_3__.PeriodLock.toAmino(e) : undefined);
    } else {
      obj.locks = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return AccountLockedPastTimeNotUnlockingOnlyResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/lockup/account-locked-past-time-not-unlocking-only-response",
      value: AccountLockedPastTimeNotUnlockingOnlyResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return AccountLockedPastTimeNotUnlockingOnlyResponse.decode(message.value);
  },

  toProto(message) {
    return AccountLockedPastTimeNotUnlockingOnlyResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.lockup.AccountLockedPastTimeNotUnlockingOnlyResponse",
      value: AccountLockedPastTimeNotUnlockingOnlyResponse.encode(message).finish()
    };
  }

};

function createBaseAccountUnlockedBeforeTimeRequest() {
  return {
    owner: "",
    timestamp: undefined
  };
}

const AccountUnlockedBeforeTimeRequest = {
  typeUrl: "/osmosis.lockup.AccountUnlockedBeforeTimeRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    if (message.owner !== "") {
      writer.uint32(10).string(message.owner);
    }

    if (message.timestamp !== undefined) {
      _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_0__.Timestamp.encode((0,_helpers__WEBPACK_IMPORTED_MODULE_5__/* .toTimestamp */ .Uq)(message.timestamp), writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAccountUnlockedBeforeTimeRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.owner = reader.string();
          break;

        case 2:
          message.timestamp = (0,_helpers__WEBPACK_IMPORTED_MODULE_5__/* .fromTimestamp */ .Ol)(_google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_0__.Timestamp.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$owner6, _object$timestamp3;

    const message = createBaseAccountUnlockedBeforeTimeRequest();
    message.owner = (_object$owner6 = object.owner) !== null && _object$owner6 !== void 0 ? _object$owner6 : "";
    message.timestamp = (_object$timestamp3 = object.timestamp) !== null && _object$timestamp3 !== void 0 ? _object$timestamp3 : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      owner: object.owner,
      timestamp: object !== null && object !== void 0 && object.timestamp ? _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_0__.Timestamp.fromAmino(object.timestamp) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.owner = message.owner;
    obj.timestamp = message.timestamp ? _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_0__.Timestamp.toAmino(message.timestamp) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return AccountUnlockedBeforeTimeRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/lockup/account-unlocked-before-time-request",
      value: AccountUnlockedBeforeTimeRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return AccountUnlockedBeforeTimeRequest.decode(message.value);
  },

  toProto(message) {
    return AccountUnlockedBeforeTimeRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.lockup.AccountUnlockedBeforeTimeRequest",
      value: AccountUnlockedBeforeTimeRequest.encode(message).finish()
    };
  }

};

function createBaseAccountUnlockedBeforeTimeResponse() {
  return {
    locks: []
  };
}

const AccountUnlockedBeforeTimeResponse = {
  typeUrl: "/osmosis.lockup.AccountUnlockedBeforeTimeResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    for (const v of message.locks) {
      _lock__WEBPACK_IMPORTED_MODULE_3__.PeriodLock.encode(v, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAccountUnlockedBeforeTimeResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.locks.push(_lock__WEBPACK_IMPORTED_MODULE_3__.PeriodLock.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$locks3;

    const message = createBaseAccountUnlockedBeforeTimeResponse();
    message.locks = ((_object$locks3 = object.locks) === null || _object$locks3 === void 0 ? void 0 : _object$locks3.map(e => _lock__WEBPACK_IMPORTED_MODULE_3__.PeriodLock.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      locks: Array.isArray(object === null || object === void 0 ? void 0 : object.locks) ? object.locks.map(e => _lock__WEBPACK_IMPORTED_MODULE_3__.PeriodLock.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.locks) {
      obj.locks = message.locks.map(e => e ? _lock__WEBPACK_IMPORTED_MODULE_3__.PeriodLock.toAmino(e) : undefined);
    } else {
      obj.locks = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return AccountUnlockedBeforeTimeResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/lockup/account-unlocked-before-time-response",
      value: AccountUnlockedBeforeTimeResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return AccountUnlockedBeforeTimeResponse.decode(message.value);
  },

  toProto(message) {
    return AccountUnlockedBeforeTimeResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.lockup.AccountUnlockedBeforeTimeResponse",
      value: AccountUnlockedBeforeTimeResponse.encode(message).finish()
    };
  }

};

function createBaseAccountLockedPastTimeDenomRequest() {
  return {
    owner: "",
    timestamp: undefined,
    denom: ""
  };
}

const AccountLockedPastTimeDenomRequest = {
  typeUrl: "/osmosis.lockup.AccountLockedPastTimeDenomRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    if (message.owner !== "") {
      writer.uint32(10).string(message.owner);
    }

    if (message.timestamp !== undefined) {
      _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_0__.Timestamp.encode((0,_helpers__WEBPACK_IMPORTED_MODULE_5__/* .toTimestamp */ .Uq)(message.timestamp), writer.uint32(18).fork()).ldelim();
    }

    if (message.denom !== "") {
      writer.uint32(26).string(message.denom);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAccountLockedPastTimeDenomRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.owner = reader.string();
          break;

        case 2:
          message.timestamp = (0,_helpers__WEBPACK_IMPORTED_MODULE_5__/* .fromTimestamp */ .Ol)(_google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_0__.Timestamp.decode(reader, reader.uint32()));
          break;

        case 3:
          message.denom = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$owner7, _object$timestamp4, _object$denom;

    const message = createBaseAccountLockedPastTimeDenomRequest();
    message.owner = (_object$owner7 = object.owner) !== null && _object$owner7 !== void 0 ? _object$owner7 : "";
    message.timestamp = (_object$timestamp4 = object.timestamp) !== null && _object$timestamp4 !== void 0 ? _object$timestamp4 : undefined;
    message.denom = (_object$denom = object.denom) !== null && _object$denom !== void 0 ? _object$denom : "";
    return message;
  },

  fromAmino(object) {
    return {
      owner: object.owner,
      timestamp: object !== null && object !== void 0 && object.timestamp ? _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_0__.Timestamp.fromAmino(object.timestamp) : undefined,
      denom: object.denom
    };
  },

  toAmino(message) {
    const obj = {};
    obj.owner = message.owner;
    obj.timestamp = message.timestamp ? _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_0__.Timestamp.toAmino(message.timestamp) : undefined;
    obj.denom = message.denom;
    return obj;
  },

  fromAminoMsg(object) {
    return AccountLockedPastTimeDenomRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/lockup/account-locked-past-time-denom-request",
      value: AccountLockedPastTimeDenomRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return AccountLockedPastTimeDenomRequest.decode(message.value);
  },

  toProto(message) {
    return AccountLockedPastTimeDenomRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.lockup.AccountLockedPastTimeDenomRequest",
      value: AccountLockedPastTimeDenomRequest.encode(message).finish()
    };
  }

};

function createBaseAccountLockedPastTimeDenomResponse() {
  return {
    locks: []
  };
}

const AccountLockedPastTimeDenomResponse = {
  typeUrl: "/osmosis.lockup.AccountLockedPastTimeDenomResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    for (const v of message.locks) {
      _lock__WEBPACK_IMPORTED_MODULE_3__.PeriodLock.encode(v, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAccountLockedPastTimeDenomResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.locks.push(_lock__WEBPACK_IMPORTED_MODULE_3__.PeriodLock.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$locks4;

    const message = createBaseAccountLockedPastTimeDenomResponse();
    message.locks = ((_object$locks4 = object.locks) === null || _object$locks4 === void 0 ? void 0 : _object$locks4.map(e => _lock__WEBPACK_IMPORTED_MODULE_3__.PeriodLock.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      locks: Array.isArray(object === null || object === void 0 ? void 0 : object.locks) ? object.locks.map(e => _lock__WEBPACK_IMPORTED_MODULE_3__.PeriodLock.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.locks) {
      obj.locks = message.locks.map(e => e ? _lock__WEBPACK_IMPORTED_MODULE_3__.PeriodLock.toAmino(e) : undefined);
    } else {
      obj.locks = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return AccountLockedPastTimeDenomResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/lockup/account-locked-past-time-denom-response",
      value: AccountLockedPastTimeDenomResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return AccountLockedPastTimeDenomResponse.decode(message.value);
  },

  toProto(message) {
    return AccountLockedPastTimeDenomResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.lockup.AccountLockedPastTimeDenomResponse",
      value: AccountLockedPastTimeDenomResponse.encode(message).finish()
    };
  }

};

function createBaseLockedDenomRequest() {
  return {
    denom: "",
    duration: undefined
  };
}

const LockedDenomRequest = {
  typeUrl: "/osmosis.lockup.LockedDenomRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    if (message.denom !== "") {
      writer.uint32(10).string(message.denom);
    }

    if (message.duration !== undefined) {
      _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_1__.Duration.encode(message.duration, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLockedDenomRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.denom = reader.string();
          break;

        case 2:
          message.duration = _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_1__.Duration.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$denom2;

    const message = createBaseLockedDenomRequest();
    message.denom = (_object$denom2 = object.denom) !== null && _object$denom2 !== void 0 ? _object$denom2 : "";
    message.duration = object.duration !== undefined && object.duration !== null ? _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_1__.Duration.fromPartial(object.duration) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      denom: object.denom,
      duration: object !== null && object !== void 0 && object.duration ? _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_1__.Duration.fromAmino(object.duration) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.denom = message.denom;
    obj.duration = message.duration ? _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_1__.Duration.toAmino(message.duration) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return LockedDenomRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/lockup/locked-denom-request",
      value: LockedDenomRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return LockedDenomRequest.decode(message.value);
  },

  toProto(message) {
    return LockedDenomRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.lockup.LockedDenomRequest",
      value: LockedDenomRequest.encode(message).finish()
    };
  }

};

function createBaseLockedDenomResponse() {
  return {
    amount: ""
  };
}

const LockedDenomResponse = {
  typeUrl: "/osmosis.lockup.LockedDenomResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    if (message.amount !== "") {
      writer.uint32(10).string(message.amount);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLockedDenomResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.amount = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$amount;

    const message = createBaseLockedDenomResponse();
    message.amount = (_object$amount = object.amount) !== null && _object$amount !== void 0 ? _object$amount : "";
    return message;
  },

  fromAmino(object) {
    return {
      amount: object.amount
    };
  },

  toAmino(message) {
    const obj = {};
    obj.amount = message.amount;
    return obj;
  },

  fromAminoMsg(object) {
    return LockedDenomResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/lockup/locked-denom-response",
      value: LockedDenomResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return LockedDenomResponse.decode(message.value);
  },

  toProto(message) {
    return LockedDenomResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.lockup.LockedDenomResponse",
      value: LockedDenomResponse.encode(message).finish()
    };
  }

};

function createBaseLockedRequest() {
  return {
    lockId: _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.UZERO */ .dK.UZERO
  };
}

const LockedRequest = {
  typeUrl: "/osmosis.lockup.LockedRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    if (!message.lockId.isZero()) {
      writer.uint32(8).uint64(message.lockId);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLockedRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.lockId = reader.uint64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseLockedRequest();
    message.lockId = object.lockId !== undefined && object.lockId !== null ? _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.fromValue */ .dK.fromValue(object.lockId) : _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.UZERO */ .dK.UZERO;
    return message;
  },

  fromAmino(object) {
    return {
      lockId: _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.fromString */ .dK.fromString(object.lock_id)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.lock_id = message.lockId ? message.lockId.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return LockedRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/lockup/locked-request",
      value: LockedRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return LockedRequest.decode(message.value);
  },

  toProto(message) {
    return LockedRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.lockup.LockedRequest",
      value: LockedRequest.encode(message).finish()
    };
  }

};

function createBaseLockedResponse() {
  return {
    lock: undefined
  };
}

const LockedResponse = {
  typeUrl: "/osmosis.lockup.LockedResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    if (message.lock !== undefined) {
      _lock__WEBPACK_IMPORTED_MODULE_3__.PeriodLock.encode(message.lock, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLockedResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.lock = _lock__WEBPACK_IMPORTED_MODULE_3__.PeriodLock.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseLockedResponse();
    message.lock = object.lock !== undefined && object.lock !== null ? _lock__WEBPACK_IMPORTED_MODULE_3__.PeriodLock.fromPartial(object.lock) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      lock: object !== null && object !== void 0 && object.lock ? _lock__WEBPACK_IMPORTED_MODULE_3__.PeriodLock.fromAmino(object.lock) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.lock = message.lock ? _lock__WEBPACK_IMPORTED_MODULE_3__.PeriodLock.toAmino(message.lock) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return LockedResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/lockup/locked-response",
      value: LockedResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return LockedResponse.decode(message.value);
  },

  toProto(message) {
    return LockedResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.lockup.LockedResponse",
      value: LockedResponse.encode(message).finish()
    };
  }

};

function createBaseLockRewardReceiverRequest() {
  return {
    lockId: _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.UZERO */ .dK.UZERO
  };
}

const LockRewardReceiverRequest = {
  typeUrl: "/osmosis.lockup.LockRewardReceiverRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    if (!message.lockId.isZero()) {
      writer.uint32(8).uint64(message.lockId);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLockRewardReceiverRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.lockId = reader.uint64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseLockRewardReceiverRequest();
    message.lockId = object.lockId !== undefined && object.lockId !== null ? _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.fromValue */ .dK.fromValue(object.lockId) : _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.UZERO */ .dK.UZERO;
    return message;
  },

  fromAmino(object) {
    return {
      lockId: _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.fromString */ .dK.fromString(object.lock_id)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.lock_id = message.lockId ? message.lockId.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return LockRewardReceiverRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/lockup/lock-reward-receiver-request",
      value: LockRewardReceiverRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return LockRewardReceiverRequest.decode(message.value);
  },

  toProto(message) {
    return LockRewardReceiverRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.lockup.LockRewardReceiverRequest",
      value: LockRewardReceiverRequest.encode(message).finish()
    };
  }

};

function createBaseLockRewardReceiverResponse() {
  return {
    rewardReceiver: ""
  };
}

const LockRewardReceiverResponse = {
  typeUrl: "/osmosis.lockup.LockRewardReceiverResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    if (message.rewardReceiver !== "") {
      writer.uint32(10).string(message.rewardReceiver);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLockRewardReceiverResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.rewardReceiver = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$rewardReceive;

    const message = createBaseLockRewardReceiverResponse();
    message.rewardReceiver = (_object$rewardReceive = object.rewardReceiver) !== null && _object$rewardReceive !== void 0 ? _object$rewardReceive : "";
    return message;
  },

  fromAmino(object) {
    return {
      rewardReceiver: object.reward_receiver
    };
  },

  toAmino(message) {
    const obj = {};
    obj.reward_receiver = message.rewardReceiver;
    return obj;
  },

  fromAminoMsg(object) {
    return LockRewardReceiverResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/lockup/lock-reward-receiver-response",
      value: LockRewardReceiverResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return LockRewardReceiverResponse.decode(message.value);
  },

  toProto(message) {
    return LockRewardReceiverResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.lockup.LockRewardReceiverResponse",
      value: LockRewardReceiverResponse.encode(message).finish()
    };
  }

};

function createBaseNextLockIDRequest() {
  return {};
}

const NextLockIDRequest = {
  typeUrl: "/osmosis.lockup.NextLockIDRequest",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseNextLockIDRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseNextLockIDRequest();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return NextLockIDRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/lockup/next-lock-id-request",
      value: NextLockIDRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return NextLockIDRequest.decode(message.value);
  },

  toProto(message) {
    return NextLockIDRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.lockup.NextLockIDRequest",
      value: NextLockIDRequest.encode(message).finish()
    };
  }

};

function createBaseNextLockIDResponse() {
  return {
    lockId: _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.UZERO */ .dK.UZERO
  };
}

const NextLockIDResponse = {
  typeUrl: "/osmosis.lockup.NextLockIDResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    if (!message.lockId.isZero()) {
      writer.uint32(8).uint64(message.lockId);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseNextLockIDResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.lockId = reader.uint64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseNextLockIDResponse();
    message.lockId = object.lockId !== undefined && object.lockId !== null ? _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.fromValue */ .dK.fromValue(object.lockId) : _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.UZERO */ .dK.UZERO;
    return message;
  },

  fromAmino(object) {
    return {
      lockId: _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.fromString */ .dK.fromString(object.lock_id)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.lock_id = message.lockId ? message.lockId.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return NextLockIDResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/lockup/next-lock-id-response",
      value: NextLockIDResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return NextLockIDResponse.decode(message.value);
  },

  toProto(message) {
    return NextLockIDResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.lockup.NextLockIDResponse",
      value: NextLockIDResponse.encode(message).finish()
    };
  }

};

function createBaseSyntheticLockupsByLockupIDRequest() {
  return {
    lockId: _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.UZERO */ .dK.UZERO
  };
}

const SyntheticLockupsByLockupIDRequest = {
  typeUrl: "/osmosis.lockup.SyntheticLockupsByLockupIDRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    if (!message.lockId.isZero()) {
      writer.uint32(8).uint64(message.lockId);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSyntheticLockupsByLockupIDRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.lockId = reader.uint64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseSyntheticLockupsByLockupIDRequest();
    message.lockId = object.lockId !== undefined && object.lockId !== null ? _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.fromValue */ .dK.fromValue(object.lockId) : _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.UZERO */ .dK.UZERO;
    return message;
  },

  fromAmino(object) {
    return {
      lockId: _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.fromString */ .dK.fromString(object.lock_id)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.lock_id = message.lockId ? message.lockId.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return SyntheticLockupsByLockupIDRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/lockup/synthetic-lockups-by-lockup-id-request",
      value: SyntheticLockupsByLockupIDRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return SyntheticLockupsByLockupIDRequest.decode(message.value);
  },

  toProto(message) {
    return SyntheticLockupsByLockupIDRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.lockup.SyntheticLockupsByLockupIDRequest",
      value: SyntheticLockupsByLockupIDRequest.encode(message).finish()
    };
  }

};

function createBaseSyntheticLockupsByLockupIDResponse() {
  return {
    syntheticLocks: []
  };
}

const SyntheticLockupsByLockupIDResponse = {
  typeUrl: "/osmosis.lockup.SyntheticLockupsByLockupIDResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    for (const v of message.syntheticLocks) {
      _lock__WEBPACK_IMPORTED_MODULE_3__.SyntheticLock.encode(v, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSyntheticLockupsByLockupIDResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.syntheticLocks.push(_lock__WEBPACK_IMPORTED_MODULE_3__.SyntheticLock.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$syntheticLock;

    const message = createBaseSyntheticLockupsByLockupIDResponse();
    message.syntheticLocks = ((_object$syntheticLock = object.syntheticLocks) === null || _object$syntheticLock === void 0 ? void 0 : _object$syntheticLock.map(e => _lock__WEBPACK_IMPORTED_MODULE_3__.SyntheticLock.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      syntheticLocks: Array.isArray(object === null || object === void 0 ? void 0 : object.synthetic_locks) ? object.synthetic_locks.map(e => _lock__WEBPACK_IMPORTED_MODULE_3__.SyntheticLock.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.syntheticLocks) {
      obj.synthetic_locks = message.syntheticLocks.map(e => e ? _lock__WEBPACK_IMPORTED_MODULE_3__.SyntheticLock.toAmino(e) : undefined);
    } else {
      obj.synthetic_locks = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return SyntheticLockupsByLockupIDResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/lockup/synthetic-lockups-by-lockup-id-response",
      value: SyntheticLockupsByLockupIDResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return SyntheticLockupsByLockupIDResponse.decode(message.value);
  },

  toProto(message) {
    return SyntheticLockupsByLockupIDResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.lockup.SyntheticLockupsByLockupIDResponse",
      value: SyntheticLockupsByLockupIDResponse.encode(message).finish()
    };
  }

};

function createBaseSyntheticLockupByLockupIDRequest() {
  return {
    lockId: _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.UZERO */ .dK.UZERO
  };
}

const SyntheticLockupByLockupIDRequest = {
  typeUrl: "/osmosis.lockup.SyntheticLockupByLockupIDRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    if (!message.lockId.isZero()) {
      writer.uint32(8).uint64(message.lockId);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSyntheticLockupByLockupIDRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.lockId = reader.uint64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseSyntheticLockupByLockupIDRequest();
    message.lockId = object.lockId !== undefined && object.lockId !== null ? _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.fromValue */ .dK.fromValue(object.lockId) : _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.UZERO */ .dK.UZERO;
    return message;
  },

  fromAmino(object) {
    return {
      lockId: _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.fromString */ .dK.fromString(object.lock_id)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.lock_id = message.lockId ? message.lockId.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return SyntheticLockupByLockupIDRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/lockup/synthetic-lockup-by-lockup-id-request",
      value: SyntheticLockupByLockupIDRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return SyntheticLockupByLockupIDRequest.decode(message.value);
  },

  toProto(message) {
    return SyntheticLockupByLockupIDRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.lockup.SyntheticLockupByLockupIDRequest",
      value: SyntheticLockupByLockupIDRequest.encode(message).finish()
    };
  }

};

function createBaseSyntheticLockupByLockupIDResponse() {
  return {
    syntheticLock: undefined
  };
}

const SyntheticLockupByLockupIDResponse = {
  typeUrl: "/osmosis.lockup.SyntheticLockupByLockupIDResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    if (message.syntheticLock !== undefined) {
      _lock__WEBPACK_IMPORTED_MODULE_3__.SyntheticLock.encode(message.syntheticLock, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSyntheticLockupByLockupIDResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.syntheticLock = _lock__WEBPACK_IMPORTED_MODULE_3__.SyntheticLock.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseSyntheticLockupByLockupIDResponse();
    message.syntheticLock = object.syntheticLock !== undefined && object.syntheticLock !== null ? _lock__WEBPACK_IMPORTED_MODULE_3__.SyntheticLock.fromPartial(object.syntheticLock) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      syntheticLock: object !== null && object !== void 0 && object.synthetic_lock ? _lock__WEBPACK_IMPORTED_MODULE_3__.SyntheticLock.fromAmino(object.synthetic_lock) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.synthetic_lock = message.syntheticLock ? _lock__WEBPACK_IMPORTED_MODULE_3__.SyntheticLock.toAmino(message.syntheticLock) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return SyntheticLockupByLockupIDResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/lockup/synthetic-lockup-by-lockup-id-response",
      value: SyntheticLockupByLockupIDResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return SyntheticLockupByLockupIDResponse.decode(message.value);
  },

  toProto(message) {
    return SyntheticLockupByLockupIDResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.lockup.SyntheticLockupByLockupIDResponse",
      value: SyntheticLockupByLockupIDResponse.encode(message).finish()
    };
  }

};

function createBaseAccountLockedLongerDurationRequest() {
  return {
    owner: "",
    duration: undefined
  };
}

const AccountLockedLongerDurationRequest = {
  typeUrl: "/osmosis.lockup.AccountLockedLongerDurationRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    if (message.owner !== "") {
      writer.uint32(10).string(message.owner);
    }

    if (message.duration !== undefined) {
      _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_1__.Duration.encode(message.duration, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAccountLockedLongerDurationRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.owner = reader.string();
          break;

        case 2:
          message.duration = _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_1__.Duration.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$owner8;

    const message = createBaseAccountLockedLongerDurationRequest();
    message.owner = (_object$owner8 = object.owner) !== null && _object$owner8 !== void 0 ? _object$owner8 : "";
    message.duration = object.duration !== undefined && object.duration !== null ? _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_1__.Duration.fromPartial(object.duration) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      owner: object.owner,
      duration: object !== null && object !== void 0 && object.duration ? _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_1__.Duration.fromAmino(object.duration) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.owner = message.owner;
    obj.duration = message.duration ? _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_1__.Duration.toAmino(message.duration) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return AccountLockedLongerDurationRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/lockup/account-locked-longer-duration-request",
      value: AccountLockedLongerDurationRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return AccountLockedLongerDurationRequest.decode(message.value);
  },

  toProto(message) {
    return AccountLockedLongerDurationRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.lockup.AccountLockedLongerDurationRequest",
      value: AccountLockedLongerDurationRequest.encode(message).finish()
    };
  }

};

function createBaseAccountLockedLongerDurationResponse() {
  return {
    locks: []
  };
}

const AccountLockedLongerDurationResponse = {
  typeUrl: "/osmosis.lockup.AccountLockedLongerDurationResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    for (const v of message.locks) {
      _lock__WEBPACK_IMPORTED_MODULE_3__.PeriodLock.encode(v, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAccountLockedLongerDurationResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.locks.push(_lock__WEBPACK_IMPORTED_MODULE_3__.PeriodLock.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$locks5;

    const message = createBaseAccountLockedLongerDurationResponse();
    message.locks = ((_object$locks5 = object.locks) === null || _object$locks5 === void 0 ? void 0 : _object$locks5.map(e => _lock__WEBPACK_IMPORTED_MODULE_3__.PeriodLock.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      locks: Array.isArray(object === null || object === void 0 ? void 0 : object.locks) ? object.locks.map(e => _lock__WEBPACK_IMPORTED_MODULE_3__.PeriodLock.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.locks) {
      obj.locks = message.locks.map(e => e ? _lock__WEBPACK_IMPORTED_MODULE_3__.PeriodLock.toAmino(e) : undefined);
    } else {
      obj.locks = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return AccountLockedLongerDurationResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/lockup/account-locked-longer-duration-response",
      value: AccountLockedLongerDurationResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return AccountLockedLongerDurationResponse.decode(message.value);
  },

  toProto(message) {
    return AccountLockedLongerDurationResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.lockup.AccountLockedLongerDurationResponse",
      value: AccountLockedLongerDurationResponse.encode(message).finish()
    };
  }

};

function createBaseAccountLockedDurationRequest() {
  return {
    owner: "",
    duration: undefined
  };
}

const AccountLockedDurationRequest = {
  typeUrl: "/osmosis.lockup.AccountLockedDurationRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    if (message.owner !== "") {
      writer.uint32(10).string(message.owner);
    }

    if (message.duration !== undefined) {
      _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_1__.Duration.encode(message.duration, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAccountLockedDurationRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.owner = reader.string();
          break;

        case 2:
          message.duration = _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_1__.Duration.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$owner9;

    const message = createBaseAccountLockedDurationRequest();
    message.owner = (_object$owner9 = object.owner) !== null && _object$owner9 !== void 0 ? _object$owner9 : "";
    message.duration = object.duration !== undefined && object.duration !== null ? _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_1__.Duration.fromPartial(object.duration) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      owner: object.owner,
      duration: object !== null && object !== void 0 && object.duration ? _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_1__.Duration.fromAmino(object.duration) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.owner = message.owner;
    obj.duration = message.duration ? _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_1__.Duration.toAmino(message.duration) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return AccountLockedDurationRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/lockup/account-locked-duration-request",
      value: AccountLockedDurationRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return AccountLockedDurationRequest.decode(message.value);
  },

  toProto(message) {
    return AccountLockedDurationRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.lockup.AccountLockedDurationRequest",
      value: AccountLockedDurationRequest.encode(message).finish()
    };
  }

};

function createBaseAccountLockedDurationResponse() {
  return {
    locks: []
  };
}

const AccountLockedDurationResponse = {
  typeUrl: "/osmosis.lockup.AccountLockedDurationResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    for (const v of message.locks) {
      _lock__WEBPACK_IMPORTED_MODULE_3__.PeriodLock.encode(v, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAccountLockedDurationResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.locks.push(_lock__WEBPACK_IMPORTED_MODULE_3__.PeriodLock.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$locks6;

    const message = createBaseAccountLockedDurationResponse();
    message.locks = ((_object$locks6 = object.locks) === null || _object$locks6 === void 0 ? void 0 : _object$locks6.map(e => _lock__WEBPACK_IMPORTED_MODULE_3__.PeriodLock.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      locks: Array.isArray(object === null || object === void 0 ? void 0 : object.locks) ? object.locks.map(e => _lock__WEBPACK_IMPORTED_MODULE_3__.PeriodLock.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.locks) {
      obj.locks = message.locks.map(e => e ? _lock__WEBPACK_IMPORTED_MODULE_3__.PeriodLock.toAmino(e) : undefined);
    } else {
      obj.locks = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return AccountLockedDurationResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/lockup/account-locked-duration-response",
      value: AccountLockedDurationResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return AccountLockedDurationResponse.decode(message.value);
  },

  toProto(message) {
    return AccountLockedDurationResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.lockup.AccountLockedDurationResponse",
      value: AccountLockedDurationResponse.encode(message).finish()
    };
  }

};

function createBaseAccountLockedLongerDurationNotUnlockingOnlyRequest() {
  return {
    owner: "",
    duration: undefined
  };
}

const AccountLockedLongerDurationNotUnlockingOnlyRequest = {
  typeUrl: "/osmosis.lockup.AccountLockedLongerDurationNotUnlockingOnlyRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    if (message.owner !== "") {
      writer.uint32(10).string(message.owner);
    }

    if (message.duration !== undefined) {
      _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_1__.Duration.encode(message.duration, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAccountLockedLongerDurationNotUnlockingOnlyRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.owner = reader.string();
          break;

        case 2:
          message.duration = _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_1__.Duration.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$owner10;

    const message = createBaseAccountLockedLongerDurationNotUnlockingOnlyRequest();
    message.owner = (_object$owner10 = object.owner) !== null && _object$owner10 !== void 0 ? _object$owner10 : "";
    message.duration = object.duration !== undefined && object.duration !== null ? _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_1__.Duration.fromPartial(object.duration) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      owner: object.owner,
      duration: object !== null && object !== void 0 && object.duration ? _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_1__.Duration.fromAmino(object.duration) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.owner = message.owner;
    obj.duration = message.duration ? _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_1__.Duration.toAmino(message.duration) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return AccountLockedLongerDurationNotUnlockingOnlyRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/lockup/account-locked-longer-duration-not-unlocking-only-request",
      value: AccountLockedLongerDurationNotUnlockingOnlyRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return AccountLockedLongerDurationNotUnlockingOnlyRequest.decode(message.value);
  },

  toProto(message) {
    return AccountLockedLongerDurationNotUnlockingOnlyRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.lockup.AccountLockedLongerDurationNotUnlockingOnlyRequest",
      value: AccountLockedLongerDurationNotUnlockingOnlyRequest.encode(message).finish()
    };
  }

};

function createBaseAccountLockedLongerDurationNotUnlockingOnlyResponse() {
  return {
    locks: []
  };
}

const AccountLockedLongerDurationNotUnlockingOnlyResponse = {
  typeUrl: "/osmosis.lockup.AccountLockedLongerDurationNotUnlockingOnlyResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    for (const v of message.locks) {
      _lock__WEBPACK_IMPORTED_MODULE_3__.PeriodLock.encode(v, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAccountLockedLongerDurationNotUnlockingOnlyResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.locks.push(_lock__WEBPACK_IMPORTED_MODULE_3__.PeriodLock.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$locks7;

    const message = createBaseAccountLockedLongerDurationNotUnlockingOnlyResponse();
    message.locks = ((_object$locks7 = object.locks) === null || _object$locks7 === void 0 ? void 0 : _object$locks7.map(e => _lock__WEBPACK_IMPORTED_MODULE_3__.PeriodLock.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      locks: Array.isArray(object === null || object === void 0 ? void 0 : object.locks) ? object.locks.map(e => _lock__WEBPACK_IMPORTED_MODULE_3__.PeriodLock.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.locks) {
      obj.locks = message.locks.map(e => e ? _lock__WEBPACK_IMPORTED_MODULE_3__.PeriodLock.toAmino(e) : undefined);
    } else {
      obj.locks = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return AccountLockedLongerDurationNotUnlockingOnlyResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/lockup/account-locked-longer-duration-not-unlocking-only-response",
      value: AccountLockedLongerDurationNotUnlockingOnlyResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return AccountLockedLongerDurationNotUnlockingOnlyResponse.decode(message.value);
  },

  toProto(message) {
    return AccountLockedLongerDurationNotUnlockingOnlyResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.lockup.AccountLockedLongerDurationNotUnlockingOnlyResponse",
      value: AccountLockedLongerDurationNotUnlockingOnlyResponse.encode(message).finish()
    };
  }

};

function createBaseAccountLockedLongerDurationDenomRequest() {
  return {
    owner: "",
    duration: undefined,
    denom: ""
  };
}

const AccountLockedLongerDurationDenomRequest = {
  typeUrl: "/osmosis.lockup.AccountLockedLongerDurationDenomRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    if (message.owner !== "") {
      writer.uint32(10).string(message.owner);
    }

    if (message.duration !== undefined) {
      _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_1__.Duration.encode(message.duration, writer.uint32(18).fork()).ldelim();
    }

    if (message.denom !== "") {
      writer.uint32(26).string(message.denom);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAccountLockedLongerDurationDenomRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.owner = reader.string();
          break;

        case 2:
          message.duration = _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_1__.Duration.decode(reader, reader.uint32());
          break;

        case 3:
          message.denom = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$owner11, _object$denom3;

    const message = createBaseAccountLockedLongerDurationDenomRequest();
    message.owner = (_object$owner11 = object.owner) !== null && _object$owner11 !== void 0 ? _object$owner11 : "";
    message.duration = object.duration !== undefined && object.duration !== null ? _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_1__.Duration.fromPartial(object.duration) : undefined;
    message.denom = (_object$denom3 = object.denom) !== null && _object$denom3 !== void 0 ? _object$denom3 : "";
    return message;
  },

  fromAmino(object) {
    return {
      owner: object.owner,
      duration: object !== null && object !== void 0 && object.duration ? _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_1__.Duration.fromAmino(object.duration) : undefined,
      denom: object.denom
    };
  },

  toAmino(message) {
    const obj = {};
    obj.owner = message.owner;
    obj.duration = message.duration ? _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_1__.Duration.toAmino(message.duration) : undefined;
    obj.denom = message.denom;
    return obj;
  },

  fromAminoMsg(object) {
    return AccountLockedLongerDurationDenomRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/lockup/account-locked-longer-duration-denom-request",
      value: AccountLockedLongerDurationDenomRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return AccountLockedLongerDurationDenomRequest.decode(message.value);
  },

  toProto(message) {
    return AccountLockedLongerDurationDenomRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.lockup.AccountLockedLongerDurationDenomRequest",
      value: AccountLockedLongerDurationDenomRequest.encode(message).finish()
    };
  }

};

function createBaseAccountLockedLongerDurationDenomResponse() {
  return {
    locks: []
  };
}

const AccountLockedLongerDurationDenomResponse = {
  typeUrl: "/osmosis.lockup.AccountLockedLongerDurationDenomResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    for (const v of message.locks) {
      _lock__WEBPACK_IMPORTED_MODULE_3__.PeriodLock.encode(v, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAccountLockedLongerDurationDenomResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.locks.push(_lock__WEBPACK_IMPORTED_MODULE_3__.PeriodLock.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$locks8;

    const message = createBaseAccountLockedLongerDurationDenomResponse();
    message.locks = ((_object$locks8 = object.locks) === null || _object$locks8 === void 0 ? void 0 : _object$locks8.map(e => _lock__WEBPACK_IMPORTED_MODULE_3__.PeriodLock.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      locks: Array.isArray(object === null || object === void 0 ? void 0 : object.locks) ? object.locks.map(e => _lock__WEBPACK_IMPORTED_MODULE_3__.PeriodLock.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.locks) {
      obj.locks = message.locks.map(e => e ? _lock__WEBPACK_IMPORTED_MODULE_3__.PeriodLock.toAmino(e) : undefined);
    } else {
      obj.locks = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return AccountLockedLongerDurationDenomResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/lockup/account-locked-longer-duration-denom-response",
      value: AccountLockedLongerDurationDenomResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return AccountLockedLongerDurationDenomResponse.decode(message.value);
  },

  toProto(message) {
    return AccountLockedLongerDurationDenomResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.lockup.AccountLockedLongerDurationDenomResponse",
      value: AccountLockedLongerDurationDenomResponse.encode(message).finish()
    };
  }

};

function createBaseQueryParamsRequest() {
  return {};
}

const QueryParamsRequest = {
  typeUrl: "/osmosis.lockup.QueryParamsRequest",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryParamsRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseQueryParamsRequest();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return QueryParamsRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/lockup/query-params-request",
      value: QueryParamsRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryParamsRequest.decode(message.value);
  },

  toProto(message) {
    return QueryParamsRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.lockup.QueryParamsRequest",
      value: QueryParamsRequest.encode(message).finish()
    };
  }

};

function createBaseQueryParamsResponse() {
  return {
    params: undefined
  };
}

const QueryParamsResponse = {
  typeUrl: "/osmosis.lockup.QueryParamsResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    if (message.params !== undefined) {
      _params__WEBPACK_IMPORTED_MODULE_4__.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryParamsResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.params = _params__WEBPACK_IMPORTED_MODULE_4__.Params.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseQueryParamsResponse();
    message.params = object.params !== undefined && object.params !== null ? _params__WEBPACK_IMPORTED_MODULE_4__.Params.fromPartial(object.params) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      params: object !== null && object !== void 0 && object.params ? _params__WEBPACK_IMPORTED_MODULE_4__.Params.fromAmino(object.params) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.params = message.params ? _params__WEBPACK_IMPORTED_MODULE_4__.Params.toAmino(message.params) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryParamsResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/lockup/query-params-response",
      value: QueryParamsResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryParamsResponse.decode(message.value);
  },

  toProto(message) {
    return QueryParamsResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.lockup.QueryParamsResponse",
      value: QueryParamsResponse.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 78268:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LCDQueryClient": function() { return /* binding */ LCDQueryClient; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4942);

class LCDQueryClient {
  constructor({
    requestClient
  }) {
    (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, "req", void 0);

    this.req = requestClient;
    this.moduleBalance = this.moduleBalance.bind(this);
    this.moduleLockedAmount = this.moduleLockedAmount.bind(this);
    this.accountUnlockableCoins = this.accountUnlockableCoins.bind(this);
    this.accountUnlockingCoins = this.accountUnlockingCoins.bind(this);
    this.accountLockedCoins = this.accountLockedCoins.bind(this);
    this.accountLockedPastTime = this.accountLockedPastTime.bind(this);
    this.accountLockedPastTimeNotUnlockingOnly = this.accountLockedPastTimeNotUnlockingOnly.bind(this);
    this.accountUnlockedBeforeTime = this.accountUnlockedBeforeTime.bind(this);
    this.accountLockedPastTimeDenom = this.accountLockedPastTimeDenom.bind(this);
    this.lockedDenom = this.lockedDenom.bind(this);
    this.lockedByID = this.lockedByID.bind(this);
    this.lockRewardReceiver = this.lockRewardReceiver.bind(this);
    this.nextLockID = this.nextLockID.bind(this);
    this.syntheticLockupsByLockupID = this.syntheticLockupsByLockupID.bind(this);
    this.syntheticLockupByLockupID = this.syntheticLockupByLockupID.bind(this);
    this.accountLockedLongerDuration = this.accountLockedLongerDuration.bind(this);
    this.accountLockedDuration = this.accountLockedDuration.bind(this);
    this.accountLockedLongerDurationNotUnlockingOnly = this.accountLockedLongerDurationNotUnlockingOnly.bind(this);
    this.accountLockedLongerDurationDenom = this.accountLockedLongerDurationDenom.bind(this);
    this.params = this.params.bind(this);
  }
  /* Return full balance of the module */


  async moduleBalance(_params = {}) {
    const endpoint = `osmosis/lockup/v1beta1/module_balance`;
    return await this.req.get(endpoint);
  }
  /* Return locked balance of the module */


  async moduleLockedAmount(_params = {}) {
    const endpoint = `osmosis/lockup/v1beta1/module_locked_amount`;
    return await this.req.get(endpoint);
  }
  /* Returns unlockable coins which are not withdrawn yet */


  async accountUnlockableCoins(params) {
    const endpoint = `osmosis/lockup/v1beta1/account_unlockable_coins/${params.owner}`;
    return await this.req.get(endpoint);
  }
  /* Returns unlocking coins */


  async accountUnlockingCoins(params) {
    const endpoint = `osmosis/lockup/v1beta1/account_unlocking_coins/${params.owner}`;
    return await this.req.get(endpoint);
  }
  /* Return a locked coins that can't be withdrawn */


  async accountLockedCoins(params) {
    const endpoint = `osmosis/lockup/v1beta1/account_locked_coins/${params.owner}`;
    return await this.req.get(endpoint);
  }
  /* Returns locked records of an account with unlock time beyond timestamp */


  async accountLockedPastTime(params) {
    const options = {
      params: {}
    };

    if (typeof (params === null || params === void 0 ? void 0 : params.timestamp) !== "undefined") {
      options.params.timestamp = params.timestamp;
    }

    const endpoint = `osmosis/lockup/v1beta1/account_locked_pasttime/${params.owner}`;
    return await this.req.get(endpoint, options);
  }
  /* Returns locked records of an account with unlock time beyond timestamp
   excluding tokens started unlocking */


  async accountLockedPastTimeNotUnlockingOnly(params) {
    const options = {
      params: {}
    };

    if (typeof (params === null || params === void 0 ? void 0 : params.timestamp) !== "undefined") {
      options.params.timestamp = params.timestamp;
    }

    const endpoint = `osmosis/lockup/v1beta1/account_locked_pasttime_not_unlocking_only/${params.owner}`;
    return await this.req.get(endpoint, options);
  }
  /* Returns unlocked records with unlock time before timestamp */


  async accountUnlockedBeforeTime(params) {
    const options = {
      params: {}
    };

    if (typeof (params === null || params === void 0 ? void 0 : params.timestamp) !== "undefined") {
      options.params.timestamp = params.timestamp;
    }

    const endpoint = `osmosis/lockup/v1beta1/account_unlocked_before_time/${params.owner}`;
    return await this.req.get(endpoint, options);
  }
  /* Returns lock records by address, timestamp, denom */


  async accountLockedPastTimeDenom(params) {
    const options = {
      params: {}
    };

    if (typeof (params === null || params === void 0 ? void 0 : params.timestamp) !== "undefined") {
      options.params.timestamp = params.timestamp;
    }

    if (typeof (params === null || params === void 0 ? void 0 : params.denom) !== "undefined") {
      options.params.denom = params.denom;
    }

    const endpoint = `osmosis/lockup/v1beta1/account_locked_pasttime_denom/${params.owner}`;
    return await this.req.get(endpoint, options);
  }
  /* Returns total locked per denom with longer past given time */


  async lockedDenom(params) {
    const options = {
      params: {}
    };

    if (typeof (params === null || params === void 0 ? void 0 : params.denom) !== "undefined") {
      options.params.denom = params.denom;
    }

    if (typeof (params === null || params === void 0 ? void 0 : params.duration) !== "undefined") {
      options.params.duration = params.duration;
    }

    const endpoint = `osmosis/lockup/v1beta1/locked_denom`;
    return await this.req.get(endpoint, options);
  }
  /* Returns lock record by id */


  async lockedByID(params) {
    const endpoint = `osmosis/lockup/v1beta1/locked_by_id/${params.lockId}`;
    return await this.req.get(endpoint);
  }
  /* Returns lock record by id */


  async lockRewardReceiver(params) {
    const endpoint = `osmosis/lockup/v1beta1/lock_reward_receiver/${params.lockId}`;
    return await this.req.get(endpoint);
  }
  /* Returns next lock ID */


  async nextLockID(_params = {}) {
    const endpoint = `osmosis/lockup/v1beta1/next_lock_id`;
    return await this.req.get(endpoint);
  }
  /* Returns synthetic lockup by native lockup id
   Deprecated: use SyntheticLockupByLockupID instead */


  async syntheticLockupsByLockupID(params) {
    const endpoint = `osmosis/lockup/v1beta1/synthetic_lockups_by_lock_id/${params.lockId}`;
    return await this.req.get(endpoint);
  }
  /* Returns synthetic lockup by native lockup id */


  async syntheticLockupByLockupID(params) {
    const endpoint = `osmosis/lockup/v1beta1/synthetic_lockup_by_lock_id/${params.lockId}`;
    return await this.req.get(endpoint);
  }
  /* Returns account locked records with longer duration */


  async accountLockedLongerDuration(params) {
    const options = {
      params: {}
    };

    if (typeof (params === null || params === void 0 ? void 0 : params.duration) !== "undefined") {
      options.params.duration = params.duration;
    }

    const endpoint = `osmosis/lockup/v1beta1/account_locked_longer_duration/${params.owner}`;
    return await this.req.get(endpoint, options);
  }
  /* Returns account locked records with a specific duration */


  async accountLockedDuration(params) {
    const options = {
      params: {}
    };

    if (typeof (params === null || params === void 0 ? void 0 : params.duration) !== "undefined") {
      options.params.duration = params.duration;
    }

    const endpoint = `osmosis/lockup/v1beta1/account_locked_duration/${params.owner}`;
    return await this.req.get(endpoint, options);
  }
  /* Returns account locked records with longer duration excluding tokens
   started unlocking */


  async accountLockedLongerDurationNotUnlockingOnly(params) {
    const options = {
      params: {}
    };

    if (typeof (params === null || params === void 0 ? void 0 : params.duration) !== "undefined") {
      options.params.duration = params.duration;
    }

    const endpoint = `osmosis/lockup/v1beta1/account_locked_longer_duration_not_unlocking_only/${params.owner}`;
    return await this.req.get(endpoint, options);
  }
  /* Returns account's locked records for a denom with longer duration */


  async accountLockedLongerDurationDenom(params) {
    const options = {
      params: {}
    };

    if (typeof (params === null || params === void 0 ? void 0 : params.duration) !== "undefined") {
      options.params.duration = params.duration;
    }

    if (typeof (params === null || params === void 0 ? void 0 : params.denom) !== "undefined") {
      options.params.denom = params.denom;
    }

    const endpoint = `osmosis/lockup/v1beta1/account_locked_longer_duration_denom/${params.owner}`;
    return await this.req.get(endpoint, options);
  }
  /* Params returns lockup params. */


  async params(_params = {}) {
    const endpoint = `osmosis/lockup/v1beta1/params`;
    return await this.req.get(endpoint);
  }

}

/***/ }),

/***/ 17525:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QueryClientImpl": function() { return /* binding */ QueryClientImpl; },
/* harmony export */   "createRpcQueryExtension": function() { return /* binding */ createRpcQueryExtension; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4942);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78441);
/* harmony import */ var _cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10792);




/** Query defines the gRPC querier service. */

class QueryClientImpl {
  constructor(rpc) {
    (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, "rpc", void 0);

    this.rpc = rpc;
    this.moduleBalance = this.moduleBalance.bind(this);
    this.moduleLockedAmount = this.moduleLockedAmount.bind(this);
    this.accountUnlockableCoins = this.accountUnlockableCoins.bind(this);
    this.accountUnlockingCoins = this.accountUnlockingCoins.bind(this);
    this.accountLockedCoins = this.accountLockedCoins.bind(this);
    this.accountLockedPastTime = this.accountLockedPastTime.bind(this);
    this.accountLockedPastTimeNotUnlockingOnly = this.accountLockedPastTimeNotUnlockingOnly.bind(this);
    this.accountUnlockedBeforeTime = this.accountUnlockedBeforeTime.bind(this);
    this.accountLockedPastTimeDenom = this.accountLockedPastTimeDenom.bind(this);
    this.lockedDenom = this.lockedDenom.bind(this);
    this.lockedByID = this.lockedByID.bind(this);
    this.lockRewardReceiver = this.lockRewardReceiver.bind(this);
    this.nextLockID = this.nextLockID.bind(this);
    this.syntheticLockupsByLockupID = this.syntheticLockupsByLockupID.bind(this);
    this.syntheticLockupByLockupID = this.syntheticLockupByLockupID.bind(this);
    this.accountLockedLongerDuration = this.accountLockedLongerDuration.bind(this);
    this.accountLockedDuration = this.accountLockedDuration.bind(this);
    this.accountLockedLongerDurationNotUnlockingOnly = this.accountLockedLongerDurationNotUnlockingOnly.bind(this);
    this.accountLockedLongerDurationDenom = this.accountLockedLongerDurationDenom.bind(this);
    this.params = this.params.bind(this);
  }

  moduleBalance(request = {}) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.ModuleBalanceRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.lockup.Query", "ModuleBalance", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.ModuleBalanceResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  moduleLockedAmount(request = {}) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.ModuleLockedAmountRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.lockup.Query", "ModuleLockedAmount", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.ModuleLockedAmountResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  accountUnlockableCoins(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.AccountUnlockableCoinsRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.lockup.Query", "AccountUnlockableCoins", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.AccountUnlockableCoinsResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  accountUnlockingCoins(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.AccountUnlockingCoinsRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.lockup.Query", "AccountUnlockingCoins", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.AccountUnlockingCoinsResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  accountLockedCoins(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.AccountLockedCoinsRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.lockup.Query", "AccountLockedCoins", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.AccountLockedCoinsResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  accountLockedPastTime(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.AccountLockedPastTimeRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.lockup.Query", "AccountLockedPastTime", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.AccountLockedPastTimeResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  accountLockedPastTimeNotUnlockingOnly(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.AccountLockedPastTimeNotUnlockingOnlyRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.lockup.Query", "AccountLockedPastTimeNotUnlockingOnly", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.AccountLockedPastTimeNotUnlockingOnlyResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  accountUnlockedBeforeTime(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.AccountUnlockedBeforeTimeRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.lockup.Query", "AccountUnlockedBeforeTime", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.AccountUnlockedBeforeTimeResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  accountLockedPastTimeDenom(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.AccountLockedPastTimeDenomRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.lockup.Query", "AccountLockedPastTimeDenom", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.AccountLockedPastTimeDenomResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  lockedDenom(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.LockedDenomRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.lockup.Query", "LockedDenom", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.LockedDenomResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  lockedByID(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.LockedRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.lockup.Query", "LockedByID", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.LockedResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  lockRewardReceiver(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.LockRewardReceiverRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.lockup.Query", "LockRewardReceiver", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.LockRewardReceiverResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  nextLockID(request = {}) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.NextLockIDRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.lockup.Query", "NextLockID", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.NextLockIDResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  syntheticLockupsByLockupID(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.SyntheticLockupsByLockupIDRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.lockup.Query", "SyntheticLockupsByLockupID", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.SyntheticLockupsByLockupIDResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  syntheticLockupByLockupID(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.SyntheticLockupByLockupIDRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.lockup.Query", "SyntheticLockupByLockupID", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.SyntheticLockupByLockupIDResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  accountLockedLongerDuration(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.AccountLockedLongerDurationRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.lockup.Query", "AccountLockedLongerDuration", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.AccountLockedLongerDurationResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  accountLockedDuration(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.AccountLockedDurationRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.lockup.Query", "AccountLockedDuration", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.AccountLockedDurationResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  accountLockedLongerDurationNotUnlockingOnly(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.AccountLockedLongerDurationNotUnlockingOnlyRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.lockup.Query", "AccountLockedLongerDurationNotUnlockingOnly", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.AccountLockedLongerDurationNotUnlockingOnlyResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  accountLockedLongerDurationDenom(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.AccountLockedLongerDurationDenomRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.lockup.Query", "AccountLockedLongerDurationDenom", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.AccountLockedLongerDurationDenomResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  params(request = {}) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryParamsRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.lockup.Query", "Params", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryParamsResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

}
const createRpcQueryExtension = base => {
  const rpc = (0,_cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1__.createProtobufRpcClient)(base);
  const queryService = new QueryClientImpl(rpc);
  return {
    moduleBalance(request) {
      return queryService.moduleBalance(request);
    },

    moduleLockedAmount(request) {
      return queryService.moduleLockedAmount(request);
    },

    accountUnlockableCoins(request) {
      return queryService.accountUnlockableCoins(request);
    },

    accountUnlockingCoins(request) {
      return queryService.accountUnlockingCoins(request);
    },

    accountLockedCoins(request) {
      return queryService.accountLockedCoins(request);
    },

    accountLockedPastTime(request) {
      return queryService.accountLockedPastTime(request);
    },

    accountLockedPastTimeNotUnlockingOnly(request) {
      return queryService.accountLockedPastTimeNotUnlockingOnly(request);
    },

    accountUnlockedBeforeTime(request) {
      return queryService.accountUnlockedBeforeTime(request);
    },

    accountLockedPastTimeDenom(request) {
      return queryService.accountLockedPastTimeDenom(request);
    },

    lockedDenom(request) {
      return queryService.lockedDenom(request);
    },

    lockedByID(request) {
      return queryService.lockedByID(request);
    },

    lockRewardReceiver(request) {
      return queryService.lockRewardReceiver(request);
    },

    nextLockID(request) {
      return queryService.nextLockID(request);
    },

    syntheticLockupsByLockupID(request) {
      return queryService.syntheticLockupsByLockupID(request);
    },

    syntheticLockupByLockupID(request) {
      return queryService.syntheticLockupByLockupID(request);
    },

    accountLockedLongerDuration(request) {
      return queryService.accountLockedLongerDuration(request);
    },

    accountLockedDuration(request) {
      return queryService.accountLockedDuration(request);
    },

    accountLockedLongerDurationNotUnlockingOnly(request) {
      return queryService.accountLockedLongerDurationNotUnlockingOnly(request);
    },

    accountLockedLongerDurationDenom(request) {
      return queryService.accountLockedLongerDurationDenom(request);
    },

    params(request) {
      return queryService.params(request);
    }

  };
};

/***/ }),

/***/ 63784:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MsgBeginUnlocking": function() { return /* binding */ MsgBeginUnlocking; },
/* harmony export */   "MsgBeginUnlockingAll": function() { return /* binding */ MsgBeginUnlockingAll; },
/* harmony export */   "MsgBeginUnlockingAllResponse": function() { return /* binding */ MsgBeginUnlockingAllResponse; },
/* harmony export */   "MsgBeginUnlockingResponse": function() { return /* binding */ MsgBeginUnlockingResponse; },
/* harmony export */   "MsgExtendLockup": function() { return /* binding */ MsgExtendLockup; },
/* harmony export */   "MsgExtendLockupResponse": function() { return /* binding */ MsgExtendLockupResponse; },
/* harmony export */   "MsgForceUnlock": function() { return /* binding */ MsgForceUnlock; },
/* harmony export */   "MsgForceUnlockResponse": function() { return /* binding */ MsgForceUnlockResponse; },
/* harmony export */   "MsgLockTokens": function() { return /* binding */ MsgLockTokens; },
/* harmony export */   "MsgLockTokensResponse": function() { return /* binding */ MsgLockTokensResponse; },
/* harmony export */   "MsgSetRewardReceiverAddress": function() { return /* binding */ MsgSetRewardReceiverAddress; },
/* harmony export */   "MsgSetRewardReceiverAddressResponse": function() { return /* binding */ MsgSetRewardReceiverAddressResponse; }
/* harmony export */ });
/* harmony import */ var _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6499);
/* harmony import */ var _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26178);
/* harmony import */ var _lock__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24902);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47895);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__);






function createBaseMsgLockTokens() {
  return {
    owner: "",
    duration: undefined,
    coins: []
  };
}

const MsgLockTokens = {
  typeUrl: "/osmosis.lockup.MsgLockTokens",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    if (message.owner !== "") {
      writer.uint32(10).string(message.owner);
    }

    if (message.duration !== undefined) {
      _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_0__.Duration.encode(message.duration, writer.uint32(18).fork()).ldelim();
    }

    for (const v of message.coins) {
      _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.encode(v, writer.uint32(26).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgLockTokens();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.owner = reader.string();
          break;

        case 2:
          message.duration = _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_0__.Duration.decode(reader, reader.uint32());
          break;

        case 3:
          message.coins.push(_cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$owner, _object$coins;

    const message = createBaseMsgLockTokens();
    message.owner = (_object$owner = object.owner) !== null && _object$owner !== void 0 ? _object$owner : "";
    message.duration = object.duration !== undefined && object.duration !== null ? _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_0__.Duration.fromPartial(object.duration) : undefined;
    message.coins = ((_object$coins = object.coins) === null || _object$coins === void 0 ? void 0 : _object$coins.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      owner: object.owner,
      duration: object !== null && object !== void 0 && object.duration ? _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_0__.Duration.fromAmino(object.duration) : undefined,
      coins: Array.isArray(object === null || object === void 0 ? void 0 : object.coins) ? object.coins.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.owner = message.owner;
    obj.duration = message.duration ? _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_0__.Duration.toAmino(message.duration) : undefined;

    if (message.coins) {
      obj.coins = message.coins.map(e => e ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.toAmino(e) : undefined);
    } else {
      obj.coins = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return MsgLockTokens.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/lockup/lock-tokens",
      value: MsgLockTokens.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgLockTokens.decode(message.value);
  },

  toProto(message) {
    return MsgLockTokens.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.lockup.MsgLockTokens",
      value: MsgLockTokens.encode(message).finish()
    };
  }

};

function createBaseMsgLockTokensResponse() {
  return {
    ID: _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.UZERO */ .dK.UZERO
  };
}

const MsgLockTokensResponse = {
  typeUrl: "/osmosis.lockup.MsgLockTokensResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    if (!message.ID.isZero()) {
      writer.uint32(8).uint64(message.ID);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgLockTokensResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.ID = reader.uint64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseMsgLockTokensResponse();
    message.ID = object.ID !== undefined && object.ID !== null ? _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.fromValue */ .dK.fromValue(object.ID) : _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.UZERO */ .dK.UZERO;
    return message;
  },

  fromAmino(object) {
    return {
      ID: _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.fromString */ .dK.fromString(object.ID)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.ID = message.ID ? message.ID.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgLockTokensResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/lockup/lock-tokens-response",
      value: MsgLockTokensResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgLockTokensResponse.decode(message.value);
  },

  toProto(message) {
    return MsgLockTokensResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.lockup.MsgLockTokensResponse",
      value: MsgLockTokensResponse.encode(message).finish()
    };
  }

};

function createBaseMsgBeginUnlockingAll() {
  return {
    owner: ""
  };
}

const MsgBeginUnlockingAll = {
  typeUrl: "/osmosis.lockup.MsgBeginUnlockingAll",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    if (message.owner !== "") {
      writer.uint32(10).string(message.owner);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgBeginUnlockingAll();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.owner = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$owner2;

    const message = createBaseMsgBeginUnlockingAll();
    message.owner = (_object$owner2 = object.owner) !== null && _object$owner2 !== void 0 ? _object$owner2 : "";
    return message;
  },

  fromAmino(object) {
    return {
      owner: object.owner
    };
  },

  toAmino(message) {
    const obj = {};
    obj.owner = message.owner;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgBeginUnlockingAll.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/lockup/begin-unlock-tokens",
      value: MsgBeginUnlockingAll.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgBeginUnlockingAll.decode(message.value);
  },

  toProto(message) {
    return MsgBeginUnlockingAll.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.lockup.MsgBeginUnlockingAll",
      value: MsgBeginUnlockingAll.encode(message).finish()
    };
  }

};

function createBaseMsgBeginUnlockingAllResponse() {
  return {
    unlocks: []
  };
}

const MsgBeginUnlockingAllResponse = {
  typeUrl: "/osmosis.lockup.MsgBeginUnlockingAllResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    for (const v of message.unlocks) {
      _lock__WEBPACK_IMPORTED_MODULE_2__.PeriodLock.encode(v, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgBeginUnlockingAllResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.unlocks.push(_lock__WEBPACK_IMPORTED_MODULE_2__.PeriodLock.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$unlocks;

    const message = createBaseMsgBeginUnlockingAllResponse();
    message.unlocks = ((_object$unlocks = object.unlocks) === null || _object$unlocks === void 0 ? void 0 : _object$unlocks.map(e => _lock__WEBPACK_IMPORTED_MODULE_2__.PeriodLock.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      unlocks: Array.isArray(object === null || object === void 0 ? void 0 : object.unlocks) ? object.unlocks.map(e => _lock__WEBPACK_IMPORTED_MODULE_2__.PeriodLock.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.unlocks) {
      obj.unlocks = message.unlocks.map(e => e ? _lock__WEBPACK_IMPORTED_MODULE_2__.PeriodLock.toAmino(e) : undefined);
    } else {
      obj.unlocks = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return MsgBeginUnlockingAllResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/lockup/begin-unlocking-all-response",
      value: MsgBeginUnlockingAllResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgBeginUnlockingAllResponse.decode(message.value);
  },

  toProto(message) {
    return MsgBeginUnlockingAllResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.lockup.MsgBeginUnlockingAllResponse",
      value: MsgBeginUnlockingAllResponse.encode(message).finish()
    };
  }

};

function createBaseMsgBeginUnlocking() {
  return {
    owner: "",
    ID: _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.UZERO */ .dK.UZERO,
    coins: []
  };
}

const MsgBeginUnlocking = {
  typeUrl: "/osmosis.lockup.MsgBeginUnlocking",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    if (message.owner !== "") {
      writer.uint32(10).string(message.owner);
    }

    if (!message.ID.isZero()) {
      writer.uint32(16).uint64(message.ID);
    }

    for (const v of message.coins) {
      _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.encode(v, writer.uint32(26).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgBeginUnlocking();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.owner = reader.string();
          break;

        case 2:
          message.ID = reader.uint64();
          break;

        case 3:
          message.coins.push(_cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$owner3, _object$coins2;

    const message = createBaseMsgBeginUnlocking();
    message.owner = (_object$owner3 = object.owner) !== null && _object$owner3 !== void 0 ? _object$owner3 : "";
    message.ID = object.ID !== undefined && object.ID !== null ? _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.fromValue */ .dK.fromValue(object.ID) : _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.UZERO */ .dK.UZERO;
    message.coins = ((_object$coins2 = object.coins) === null || _object$coins2 === void 0 ? void 0 : _object$coins2.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      owner: object.owner,
      ID: _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.fromString */ .dK.fromString(object.ID),
      coins: Array.isArray(object === null || object === void 0 ? void 0 : object.coins) ? object.coins.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.owner = message.owner;
    obj.ID = message.ID ? message.ID.toString() : undefined;

    if (message.coins) {
      obj.coins = message.coins.map(e => e ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.toAmino(e) : undefined);
    } else {
      obj.coins = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return MsgBeginUnlocking.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/lockup/begin-unlock-period-lock",
      value: MsgBeginUnlocking.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgBeginUnlocking.decode(message.value);
  },

  toProto(message) {
    return MsgBeginUnlocking.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.lockup.MsgBeginUnlocking",
      value: MsgBeginUnlocking.encode(message).finish()
    };
  }

};

function createBaseMsgBeginUnlockingResponse() {
  return {
    success: false,
    unlockingLockID: _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.UZERO */ .dK.UZERO
  };
}

const MsgBeginUnlockingResponse = {
  typeUrl: "/osmosis.lockup.MsgBeginUnlockingResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    if (message.success === true) {
      writer.uint32(8).bool(message.success);
    }

    if (!message.unlockingLockID.isZero()) {
      writer.uint32(16).uint64(message.unlockingLockID);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgBeginUnlockingResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.success = reader.bool();
          break;

        case 2:
          message.unlockingLockID = reader.uint64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$success;

    const message = createBaseMsgBeginUnlockingResponse();
    message.success = (_object$success = object.success) !== null && _object$success !== void 0 ? _object$success : false;
    message.unlockingLockID = object.unlockingLockID !== undefined && object.unlockingLockID !== null ? _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.fromValue */ .dK.fromValue(object.unlockingLockID) : _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.UZERO */ .dK.UZERO;
    return message;
  },

  fromAmino(object) {
    return {
      success: object.success,
      unlockingLockID: _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.fromString */ .dK.fromString(object.unlockingLockID)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.success = message.success;
    obj.unlockingLockID = message.unlockingLockID ? message.unlockingLockID.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgBeginUnlockingResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/lockup/begin-unlocking-response",
      value: MsgBeginUnlockingResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgBeginUnlockingResponse.decode(message.value);
  },

  toProto(message) {
    return MsgBeginUnlockingResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.lockup.MsgBeginUnlockingResponse",
      value: MsgBeginUnlockingResponse.encode(message).finish()
    };
  }

};

function createBaseMsgExtendLockup() {
  return {
    owner: "",
    ID: _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.UZERO */ .dK.UZERO,
    duration: undefined
  };
}

const MsgExtendLockup = {
  typeUrl: "/osmosis.lockup.MsgExtendLockup",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    if (message.owner !== "") {
      writer.uint32(10).string(message.owner);
    }

    if (!message.ID.isZero()) {
      writer.uint32(16).uint64(message.ID);
    }

    if (message.duration !== undefined) {
      _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_0__.Duration.encode(message.duration, writer.uint32(26).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgExtendLockup();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.owner = reader.string();
          break;

        case 2:
          message.ID = reader.uint64();
          break;

        case 3:
          message.duration = _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_0__.Duration.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$owner4;

    const message = createBaseMsgExtendLockup();
    message.owner = (_object$owner4 = object.owner) !== null && _object$owner4 !== void 0 ? _object$owner4 : "";
    message.ID = object.ID !== undefined && object.ID !== null ? _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.fromValue */ .dK.fromValue(object.ID) : _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.UZERO */ .dK.UZERO;
    message.duration = object.duration !== undefined && object.duration !== null ? _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_0__.Duration.fromPartial(object.duration) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      owner: object.owner,
      ID: _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.fromString */ .dK.fromString(object.ID),
      duration: object !== null && object !== void 0 && object.duration ? _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_0__.Duration.fromAmino(object.duration) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.owner = message.owner;
    obj.ID = message.ID ? message.ID.toString() : undefined;
    obj.duration = message.duration ? _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_0__.Duration.toAmino(message.duration) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgExtendLockup.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/lockup/extend-lockup",
      value: MsgExtendLockup.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgExtendLockup.decode(message.value);
  },

  toProto(message) {
    return MsgExtendLockup.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.lockup.MsgExtendLockup",
      value: MsgExtendLockup.encode(message).finish()
    };
  }

};

function createBaseMsgExtendLockupResponse() {
  return {
    success: false
  };
}

const MsgExtendLockupResponse = {
  typeUrl: "/osmosis.lockup.MsgExtendLockupResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    if (message.success === true) {
      writer.uint32(8).bool(message.success);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgExtendLockupResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.success = reader.bool();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$success2;

    const message = createBaseMsgExtendLockupResponse();
    message.success = (_object$success2 = object.success) !== null && _object$success2 !== void 0 ? _object$success2 : false;
    return message;
  },

  fromAmino(object) {
    return {
      success: object.success
    };
  },

  toAmino(message) {
    const obj = {};
    obj.success = message.success;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgExtendLockupResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/lockup/extend-lockup-response",
      value: MsgExtendLockupResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgExtendLockupResponse.decode(message.value);
  },

  toProto(message) {
    return MsgExtendLockupResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.lockup.MsgExtendLockupResponse",
      value: MsgExtendLockupResponse.encode(message).finish()
    };
  }

};

function createBaseMsgForceUnlock() {
  return {
    owner: "",
    ID: _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.UZERO */ .dK.UZERO,
    coins: []
  };
}

const MsgForceUnlock = {
  typeUrl: "/osmosis.lockup.MsgForceUnlock",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    if (message.owner !== "") {
      writer.uint32(10).string(message.owner);
    }

    if (!message.ID.isZero()) {
      writer.uint32(16).uint64(message.ID);
    }

    for (const v of message.coins) {
      _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.encode(v, writer.uint32(26).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgForceUnlock();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.owner = reader.string();
          break;

        case 2:
          message.ID = reader.uint64();
          break;

        case 3:
          message.coins.push(_cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$owner5, _object$coins3;

    const message = createBaseMsgForceUnlock();
    message.owner = (_object$owner5 = object.owner) !== null && _object$owner5 !== void 0 ? _object$owner5 : "";
    message.ID = object.ID !== undefined && object.ID !== null ? _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.fromValue */ .dK.fromValue(object.ID) : _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.UZERO */ .dK.UZERO;
    message.coins = ((_object$coins3 = object.coins) === null || _object$coins3 === void 0 ? void 0 : _object$coins3.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      owner: object.owner,
      ID: _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.fromString */ .dK.fromString(object.ID),
      coins: Array.isArray(object === null || object === void 0 ? void 0 : object.coins) ? object.coins.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.owner = message.owner;
    obj.ID = message.ID ? message.ID.toString() : undefined;

    if (message.coins) {
      obj.coins = message.coins.map(e => e ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.toAmino(e) : undefined);
    } else {
      obj.coins = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return MsgForceUnlock.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/lockup/force-unlock",
      value: MsgForceUnlock.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgForceUnlock.decode(message.value);
  },

  toProto(message) {
    return MsgForceUnlock.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.lockup.MsgForceUnlock",
      value: MsgForceUnlock.encode(message).finish()
    };
  }

};

function createBaseMsgForceUnlockResponse() {
  return {
    success: false
  };
}

const MsgForceUnlockResponse = {
  typeUrl: "/osmosis.lockup.MsgForceUnlockResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    if (message.success === true) {
      writer.uint32(8).bool(message.success);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgForceUnlockResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.success = reader.bool();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$success3;

    const message = createBaseMsgForceUnlockResponse();
    message.success = (_object$success3 = object.success) !== null && _object$success3 !== void 0 ? _object$success3 : false;
    return message;
  },

  fromAmino(object) {
    return {
      success: object.success
    };
  },

  toAmino(message) {
    const obj = {};
    obj.success = message.success;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgForceUnlockResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/lockup/force-unlock-response",
      value: MsgForceUnlockResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgForceUnlockResponse.decode(message.value);
  },

  toProto(message) {
    return MsgForceUnlockResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.lockup.MsgForceUnlockResponse",
      value: MsgForceUnlockResponse.encode(message).finish()
    };
  }

};

function createBaseMsgSetRewardReceiverAddress() {
  return {
    owner: "",
    lockID: _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.UZERO */ .dK.UZERO,
    rewardReceiver: ""
  };
}

const MsgSetRewardReceiverAddress = {
  typeUrl: "/osmosis.lockup.MsgSetRewardReceiverAddress",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    if (message.owner !== "") {
      writer.uint32(10).string(message.owner);
    }

    if (!message.lockID.isZero()) {
      writer.uint32(16).uint64(message.lockID);
    }

    if (message.rewardReceiver !== "") {
      writer.uint32(26).string(message.rewardReceiver);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgSetRewardReceiverAddress();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.owner = reader.string();
          break;

        case 2:
          message.lockID = reader.uint64();
          break;

        case 3:
          message.rewardReceiver = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$owner6, _object$rewardReceive;

    const message = createBaseMsgSetRewardReceiverAddress();
    message.owner = (_object$owner6 = object.owner) !== null && _object$owner6 !== void 0 ? _object$owner6 : "";
    message.lockID = object.lockID !== undefined && object.lockID !== null ? _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.fromValue */ .dK.fromValue(object.lockID) : _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.UZERO */ .dK.UZERO;
    message.rewardReceiver = (_object$rewardReceive = object.rewardReceiver) !== null && _object$rewardReceive !== void 0 ? _object$rewardReceive : "";
    return message;
  },

  fromAmino(object) {
    return {
      owner: object.owner,
      lockID: _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.fromString */ .dK.fromString(object.lockID),
      rewardReceiver: object.reward_receiver
    };
  },

  toAmino(message) {
    const obj = {};
    obj.owner = message.owner;
    obj.lockID = message.lockID ? message.lockID.toString() : undefined;
    obj.reward_receiver = message.rewardReceiver;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgSetRewardReceiverAddress.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/lockup/set-reward-receiver-address",
      value: MsgSetRewardReceiverAddress.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgSetRewardReceiverAddress.decode(message.value);
  },

  toProto(message) {
    return MsgSetRewardReceiverAddress.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.lockup.MsgSetRewardReceiverAddress",
      value: MsgSetRewardReceiverAddress.encode(message).finish()
    };
  }

};

function createBaseMsgSetRewardReceiverAddressResponse() {
  return {
    success: false
  };
}

const MsgSetRewardReceiverAddressResponse = {
  typeUrl: "/osmosis.lockup.MsgSetRewardReceiverAddressResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    if (message.success === true) {
      writer.uint32(8).bool(message.success);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgSetRewardReceiverAddressResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.success = reader.bool();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$success4;

    const message = createBaseMsgSetRewardReceiverAddressResponse();
    message.success = (_object$success4 = object.success) !== null && _object$success4 !== void 0 ? _object$success4 : false;
    return message;
  },

  fromAmino(object) {
    return {
      success: object.success
    };
  },

  toAmino(message) {
    const obj = {};
    obj.success = message.success;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgSetRewardReceiverAddressResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/lockup/set-reward-receiver-address-response",
      value: MsgSetRewardReceiverAddressResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgSetRewardReceiverAddressResponse.decode(message.value);
  },

  toProto(message) {
    return MsgSetRewardReceiverAddressResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.lockup.MsgSetRewardReceiverAddressResponse",
      value: MsgSetRewardReceiverAddressResponse.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 49168:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MsgClientImpl": function() { return /* binding */ MsgClientImpl; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4942);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _tx__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63784);



/** Msg defines the Msg service. */

class MsgClientImpl {
  constructor(rpc) {
    (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, "rpc", void 0);

    this.rpc = rpc;
    this.lockTokens = this.lockTokens.bind(this);
    this.beginUnlockingAll = this.beginUnlockingAll.bind(this);
    this.beginUnlocking = this.beginUnlocking.bind(this);
    this.extendLockup = this.extendLockup.bind(this);
    this.forceUnlock = this.forceUnlock.bind(this);
    this.setRewardReceiverAddress = this.setRewardReceiverAddress.bind(this);
  }

  lockTokens(request) {
    const data = _tx__WEBPACK_IMPORTED_MODULE_1__.MsgLockTokens.encode(request).finish();
    const promise = this.rpc.request("osmosis.lockup.Msg", "LockTokens", data);
    return promise.then(data => _tx__WEBPACK_IMPORTED_MODULE_1__.MsgLockTokensResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  beginUnlockingAll(request) {
    const data = _tx__WEBPACK_IMPORTED_MODULE_1__.MsgBeginUnlockingAll.encode(request).finish();
    const promise = this.rpc.request("osmosis.lockup.Msg", "BeginUnlockingAll", data);
    return promise.then(data => _tx__WEBPACK_IMPORTED_MODULE_1__.MsgBeginUnlockingAllResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  beginUnlocking(request) {
    const data = _tx__WEBPACK_IMPORTED_MODULE_1__.MsgBeginUnlocking.encode(request).finish();
    const promise = this.rpc.request("osmosis.lockup.Msg", "BeginUnlocking", data);
    return promise.then(data => _tx__WEBPACK_IMPORTED_MODULE_1__.MsgBeginUnlockingResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  extendLockup(request) {
    const data = _tx__WEBPACK_IMPORTED_MODULE_1__.MsgExtendLockup.encode(request).finish();
    const promise = this.rpc.request("osmosis.lockup.Msg", "ExtendLockup", data);
    return promise.then(data => _tx__WEBPACK_IMPORTED_MODULE_1__.MsgExtendLockupResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  forceUnlock(request) {
    const data = _tx__WEBPACK_IMPORTED_MODULE_1__.MsgForceUnlock.encode(request).finish();
    const promise = this.rpc.request("osmosis.lockup.Msg", "ForceUnlock", data);
    return promise.then(data => _tx__WEBPACK_IMPORTED_MODULE_1__.MsgForceUnlockResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  setRewardReceiverAddress(request) {
    const data = _tx__WEBPACK_IMPORTED_MODULE_1__.MsgSetRewardReceiverAddress.encode(request).finish();
    const promise = this.rpc.request("osmosis.lockup.Msg", "SetRewardReceiverAddress", data);
    return promise.then(data => _tx__WEBPACK_IMPORTED_MODULE_1__.MsgSetRewardReceiverAddressResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

}

/***/ }),

/***/ 57200:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DistributionProportions": function() { return /* binding */ DistributionProportions; },
/* harmony export */   "Minter": function() { return /* binding */ Minter; },
/* harmony export */   "Params": function() { return /* binding */ Params; },
/* harmony export */   "WeightedAddress": function() { return /* binding */ WeightedAddress; }
/* harmony export */ });
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47895);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__);


/** Minter represents the minting state. */

function createBaseMinter() {
  return {
    epochProvisions: ""
  };
}

const Minter = {
  typeUrl: "/osmosis.mint.v1beta1.Minter",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Writer.create()) {
    if (message.epochProvisions !== "") {
      writer.uint32(10).string(message.epochProvisions);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMinter();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.epochProvisions = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$epochProvisio;

    const message = createBaseMinter();
    message.epochProvisions = (_object$epochProvisio = object.epochProvisions) !== null && _object$epochProvisio !== void 0 ? _object$epochProvisio : "";
    return message;
  },

  fromAmino(object) {
    return {
      epochProvisions: object.epoch_provisions
    };
  },

  toAmino(message) {
    const obj = {};
    obj.epoch_provisions = message.epochProvisions;
    return obj;
  },

  fromAminoMsg(object) {
    return Minter.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/mint/minter",
      value: Minter.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return Minter.decode(message.value);
  },

  toProto(message) {
    return Minter.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.mint.v1beta1.Minter",
      value: Minter.encode(message).finish()
    };
  }

};

function createBaseWeightedAddress() {
  return {
    address: "",
    weight: ""
  };
}

const WeightedAddress = {
  typeUrl: "/osmosis.mint.v1beta1.WeightedAddress",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Writer.create()) {
    if (message.address !== "") {
      writer.uint32(10).string(message.address);
    }

    if (message.weight !== "") {
      writer.uint32(18).string(message.weight);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWeightedAddress();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.address = reader.string();
          break;

        case 2:
          message.weight = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$address, _object$weight;

    const message = createBaseWeightedAddress();
    message.address = (_object$address = object.address) !== null && _object$address !== void 0 ? _object$address : "";
    message.weight = (_object$weight = object.weight) !== null && _object$weight !== void 0 ? _object$weight : "";
    return message;
  },

  fromAmino(object) {
    return {
      address: object.address,
      weight: object.weight
    };
  },

  toAmino(message) {
    const obj = {};
    obj.address = message.address;
    obj.weight = message.weight;
    return obj;
  },

  fromAminoMsg(object) {
    return WeightedAddress.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/mint/weighted-address",
      value: WeightedAddress.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return WeightedAddress.decode(message.value);
  },

  toProto(message) {
    return WeightedAddress.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.mint.v1beta1.WeightedAddress",
      value: WeightedAddress.encode(message).finish()
    };
  }

};

function createBaseDistributionProportions() {
  return {
    staking: "",
    poolIncentives: "",
    developerRewards: "",
    communityPool: ""
  };
}

const DistributionProportions = {
  typeUrl: "/osmosis.mint.v1beta1.DistributionProportions",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Writer.create()) {
    if (message.staking !== "") {
      writer.uint32(10).string(message.staking);
    }

    if (message.poolIncentives !== "") {
      writer.uint32(18).string(message.poolIncentives);
    }

    if (message.developerRewards !== "") {
      writer.uint32(26).string(message.developerRewards);
    }

    if (message.communityPool !== "") {
      writer.uint32(34).string(message.communityPool);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDistributionProportions();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.staking = reader.string();
          break;

        case 2:
          message.poolIncentives = reader.string();
          break;

        case 3:
          message.developerRewards = reader.string();
          break;

        case 4:
          message.communityPool = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$staking, _object$poolIncentive, _object$developerRewa, _object$communityPool;

    const message = createBaseDistributionProportions();
    message.staking = (_object$staking = object.staking) !== null && _object$staking !== void 0 ? _object$staking : "";
    message.poolIncentives = (_object$poolIncentive = object.poolIncentives) !== null && _object$poolIncentive !== void 0 ? _object$poolIncentive : "";
    message.developerRewards = (_object$developerRewa = object.developerRewards) !== null && _object$developerRewa !== void 0 ? _object$developerRewa : "";
    message.communityPool = (_object$communityPool = object.communityPool) !== null && _object$communityPool !== void 0 ? _object$communityPool : "";
    return message;
  },

  fromAmino(object) {
    return {
      staking: object.staking,
      poolIncentives: object.pool_incentives,
      developerRewards: object.developer_rewards,
      communityPool: object.community_pool
    };
  },

  toAmino(message) {
    const obj = {};
    obj.staking = message.staking;
    obj.pool_incentives = message.poolIncentives;
    obj.developer_rewards = message.developerRewards;
    obj.community_pool = message.communityPool;
    return obj;
  },

  fromAminoMsg(object) {
    return DistributionProportions.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/mint/distribution-proportions",
      value: DistributionProportions.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return DistributionProportions.decode(message.value);
  },

  toProto(message) {
    return DistributionProportions.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.mint.v1beta1.DistributionProportions",
      value: DistributionProportions.encode(message).finish()
    };
  }

};

function createBaseParams() {
  return {
    mintDenom: "",
    genesisEpochProvisions: "",
    epochIdentifier: "",
    reductionPeriodInEpochs: _helpers__WEBPACK_IMPORTED_MODULE_0__/* .Long.ZERO */ .dK.ZERO,
    reductionFactor: "",
    distributionProportions: undefined,
    weightedDeveloperRewardsReceivers: [],
    mintingRewardsDistributionStartEpoch: _helpers__WEBPACK_IMPORTED_MODULE_0__/* .Long.ZERO */ .dK.ZERO
  };
}

const Params = {
  typeUrl: "/osmosis.mint.v1beta1.Params",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Writer.create()) {
    if (message.mintDenom !== "") {
      writer.uint32(10).string(message.mintDenom);
    }

    if (message.genesisEpochProvisions !== "") {
      writer.uint32(18).string(message.genesisEpochProvisions);
    }

    if (message.epochIdentifier !== "") {
      writer.uint32(26).string(message.epochIdentifier);
    }

    if (!message.reductionPeriodInEpochs.isZero()) {
      writer.uint32(32).int64(message.reductionPeriodInEpochs);
    }

    if (message.reductionFactor !== "") {
      writer.uint32(42).string(message.reductionFactor);
    }

    if (message.distributionProportions !== undefined) {
      DistributionProportions.encode(message.distributionProportions, writer.uint32(50).fork()).ldelim();
    }

    for (const v of message.weightedDeveloperRewardsReceivers) {
      WeightedAddress.encode(v, writer.uint32(58).fork()).ldelim();
    }

    if (!message.mintingRewardsDistributionStartEpoch.isZero()) {
      writer.uint32(64).int64(message.mintingRewardsDistributionStartEpoch);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseParams();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.mintDenom = reader.string();
          break;

        case 2:
          message.genesisEpochProvisions = reader.string();
          break;

        case 3:
          message.epochIdentifier = reader.string();
          break;

        case 4:
          message.reductionPeriodInEpochs = reader.int64();
          break;

        case 5:
          message.reductionFactor = reader.string();
          break;

        case 6:
          message.distributionProportions = DistributionProportions.decode(reader, reader.uint32());
          break;

        case 7:
          message.weightedDeveloperRewardsReceivers.push(WeightedAddress.decode(reader, reader.uint32()));
          break;

        case 8:
          message.mintingRewardsDistributionStartEpoch = reader.int64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$mintDenom, _object$genesisEpochP, _object$epochIdentifi, _object$reductionFact, _object$weightedDevel;

    const message = createBaseParams();
    message.mintDenom = (_object$mintDenom = object.mintDenom) !== null && _object$mintDenom !== void 0 ? _object$mintDenom : "";
    message.genesisEpochProvisions = (_object$genesisEpochP = object.genesisEpochProvisions) !== null && _object$genesisEpochP !== void 0 ? _object$genesisEpochP : "";
    message.epochIdentifier = (_object$epochIdentifi = object.epochIdentifier) !== null && _object$epochIdentifi !== void 0 ? _object$epochIdentifi : "";
    message.reductionPeriodInEpochs = object.reductionPeriodInEpochs !== undefined && object.reductionPeriodInEpochs !== null ? _helpers__WEBPACK_IMPORTED_MODULE_0__/* .Long.fromValue */ .dK.fromValue(object.reductionPeriodInEpochs) : _helpers__WEBPACK_IMPORTED_MODULE_0__/* .Long.ZERO */ .dK.ZERO;
    message.reductionFactor = (_object$reductionFact = object.reductionFactor) !== null && _object$reductionFact !== void 0 ? _object$reductionFact : "";
    message.distributionProportions = object.distributionProportions !== undefined && object.distributionProportions !== null ? DistributionProportions.fromPartial(object.distributionProportions) : undefined;
    message.weightedDeveloperRewardsReceivers = ((_object$weightedDevel = object.weightedDeveloperRewardsReceivers) === null || _object$weightedDevel === void 0 ? void 0 : _object$weightedDevel.map(e => WeightedAddress.fromPartial(e))) || [];
    message.mintingRewardsDistributionStartEpoch = object.mintingRewardsDistributionStartEpoch !== undefined && object.mintingRewardsDistributionStartEpoch !== null ? _helpers__WEBPACK_IMPORTED_MODULE_0__/* .Long.fromValue */ .dK.fromValue(object.mintingRewardsDistributionStartEpoch) : _helpers__WEBPACK_IMPORTED_MODULE_0__/* .Long.ZERO */ .dK.ZERO;
    return message;
  },

  fromAmino(object) {
    return {
      mintDenom: object.mint_denom,
      genesisEpochProvisions: object.genesis_epoch_provisions,
      epochIdentifier: object.epoch_identifier,
      reductionPeriodInEpochs: _helpers__WEBPACK_IMPORTED_MODULE_0__/* .Long.fromString */ .dK.fromString(object.reduction_period_in_epochs),
      reductionFactor: object.reduction_factor,
      distributionProportions: object !== null && object !== void 0 && object.distribution_proportions ? DistributionProportions.fromAmino(object.distribution_proportions) : undefined,
      weightedDeveloperRewardsReceivers: Array.isArray(object === null || object === void 0 ? void 0 : object.weighted_developer_rewards_receivers) ? object.weighted_developer_rewards_receivers.map(e => WeightedAddress.fromAmino(e)) : [],
      mintingRewardsDistributionStartEpoch: _helpers__WEBPACK_IMPORTED_MODULE_0__/* .Long.fromString */ .dK.fromString(object.minting_rewards_distribution_start_epoch)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.mint_denom = message.mintDenom;
    obj.genesis_epoch_provisions = message.genesisEpochProvisions;
    obj.epoch_identifier = message.epochIdentifier;
    obj.reduction_period_in_epochs = message.reductionPeriodInEpochs ? message.reductionPeriodInEpochs.toString() : undefined;
    obj.reduction_factor = message.reductionFactor;
    obj.distribution_proportions = message.distributionProportions ? DistributionProportions.toAmino(message.distributionProportions) : undefined;

    if (message.weightedDeveloperRewardsReceivers) {
      obj.weighted_developer_rewards_receivers = message.weightedDeveloperRewardsReceivers.map(e => e ? WeightedAddress.toAmino(e) : undefined);
    } else {
      obj.weighted_developer_rewards_receivers = [];
    }

    obj.minting_rewards_distribution_start_epoch = message.mintingRewardsDistributionStartEpoch ? message.mintingRewardsDistributionStartEpoch.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return Params.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/mint/params",
      value: Params.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return Params.decode(message.value);
  },

  toProto(message) {
    return Params.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.mint.v1beta1.Params",
      value: Params.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 59485:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QueryEpochProvisionsRequest": function() { return /* binding */ QueryEpochProvisionsRequest; },
/* harmony export */   "QueryEpochProvisionsResponse": function() { return /* binding */ QueryEpochProvisionsResponse; },
/* harmony export */   "QueryParamsRequest": function() { return /* binding */ QueryParamsRequest; },
/* harmony export */   "QueryParamsResponse": function() { return /* binding */ QueryParamsResponse; }
/* harmony export */ });
/* harmony import */ var _mint__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(57200);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__);


/** QueryParamsRequest is the request type for the Query/Params RPC method. */

function createBaseQueryParamsRequest() {
  return {};
}

const QueryParamsRequest = {
  typeUrl: "/osmosis.mint.v1beta1.QueryParamsRequest",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryParamsRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseQueryParamsRequest();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return QueryParamsRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/mint/query-params-request",
      value: QueryParamsRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryParamsRequest.decode(message.value);
  },

  toProto(message) {
    return QueryParamsRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.mint.v1beta1.QueryParamsRequest",
      value: QueryParamsRequest.encode(message).finish()
    };
  }

};

function createBaseQueryParamsResponse() {
  return {
    params: undefined
  };
}

const QueryParamsResponse = {
  typeUrl: "/osmosis.mint.v1beta1.QueryParamsResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Writer.create()) {
    if (message.params !== undefined) {
      _mint__WEBPACK_IMPORTED_MODULE_0__.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryParamsResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.params = _mint__WEBPACK_IMPORTED_MODULE_0__.Params.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseQueryParamsResponse();
    message.params = object.params !== undefined && object.params !== null ? _mint__WEBPACK_IMPORTED_MODULE_0__.Params.fromPartial(object.params) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      params: object !== null && object !== void 0 && object.params ? _mint__WEBPACK_IMPORTED_MODULE_0__.Params.fromAmino(object.params) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.params = message.params ? _mint__WEBPACK_IMPORTED_MODULE_0__.Params.toAmino(message.params) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryParamsResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/mint/query-params-response",
      value: QueryParamsResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryParamsResponse.decode(message.value);
  },

  toProto(message) {
    return QueryParamsResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.mint.v1beta1.QueryParamsResponse",
      value: QueryParamsResponse.encode(message).finish()
    };
  }

};

function createBaseQueryEpochProvisionsRequest() {
  return {};
}

const QueryEpochProvisionsRequest = {
  typeUrl: "/osmosis.mint.v1beta1.QueryEpochProvisionsRequest",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryEpochProvisionsRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseQueryEpochProvisionsRequest();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return QueryEpochProvisionsRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/mint/query-epoch-provisions-request",
      value: QueryEpochProvisionsRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryEpochProvisionsRequest.decode(message.value);
  },

  toProto(message) {
    return QueryEpochProvisionsRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.mint.v1beta1.QueryEpochProvisionsRequest",
      value: QueryEpochProvisionsRequest.encode(message).finish()
    };
  }

};

function createBaseQueryEpochProvisionsResponse() {
  return {
    epochProvisions: new Uint8Array()
  };
}

const QueryEpochProvisionsResponse = {
  typeUrl: "/osmosis.mint.v1beta1.QueryEpochProvisionsResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Writer.create()) {
    if (message.epochProvisions.length !== 0) {
      writer.uint32(10).bytes(message.epochProvisions);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryEpochProvisionsResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.epochProvisions = reader.bytes();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$epochProvisio;

    const message = createBaseQueryEpochProvisionsResponse();
    message.epochProvisions = (_object$epochProvisio = object.epochProvisions) !== null && _object$epochProvisio !== void 0 ? _object$epochProvisio : new Uint8Array();
    return message;
  },

  fromAmino(object) {
    return {
      epochProvisions: object.epoch_provisions
    };
  },

  toAmino(message) {
    const obj = {};
    obj.epoch_provisions = message.epochProvisions;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryEpochProvisionsResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/mint/query-epoch-provisions-response",
      value: QueryEpochProvisionsResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryEpochProvisionsResponse.decode(message.value);
  },

  toProto(message) {
    return QueryEpochProvisionsResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.mint.v1beta1.QueryEpochProvisionsResponse",
      value: QueryEpochProvisionsResponse.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 81867:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LCDQueryClient": function() { return /* binding */ LCDQueryClient; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4942);

class LCDQueryClient {
  constructor({
    requestClient
  }) {
    (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, "req", void 0);

    this.req = requestClient;
    this.params = this.params.bind(this);
    this.epochProvisions = this.epochProvisions.bind(this);
  }
  /* Params returns the total set of minting parameters. */


  async params(_params = {}) {
    const endpoint = `osmosis/mint/v1beta1/params`;
    return await this.req.get(endpoint);
  }
  /* EpochProvisions returns the current minting epoch provisions value. */


  async epochProvisions(_params = {}) {
    const endpoint = `osmosis/mint/v1beta1/epoch_provisions`;
    return await this.req.get(endpoint);
  }

}

/***/ }),

/***/ 9992:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QueryClientImpl": function() { return /* binding */ QueryClientImpl; },
/* harmony export */   "createRpcQueryExtension": function() { return /* binding */ createRpcQueryExtension; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4942);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78441);
/* harmony import */ var _cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59485);




/** Query provides defines the gRPC querier service. */

class QueryClientImpl {
  constructor(rpc) {
    (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, "rpc", void 0);

    this.rpc = rpc;
    this.params = this.params.bind(this);
    this.epochProvisions = this.epochProvisions.bind(this);
  }

  params(request = {}) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryParamsRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.mint.v1beta1.Query", "Params", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryParamsResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  epochProvisions(request = {}) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryEpochProvisionsRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.mint.v1beta1.Query", "EpochProvisions", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryEpochProvisionsResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

}
const createRpcQueryExtension = base => {
  const rpc = (0,_cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1__.createProtobufRpcClient)(base);
  const queryService = new QueryClientImpl(rpc);
  return {
    params(request) {
      return queryService.params(request);
    },

    epochProvisions(request) {
      return queryService.epochProvisions(request);
    }

  };
};

/***/ }),

/***/ 52993:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DistrInfo": function() { return /* binding */ DistrInfo; },
/* harmony export */   "DistrRecord": function() { return /* binding */ DistrRecord; },
/* harmony export */   "LockableDurationsInfo": function() { return /* binding */ LockableDurationsInfo; },
/* harmony export */   "Params": function() { return /* binding */ Params; },
/* harmony export */   "PoolToGauge": function() { return /* binding */ PoolToGauge; },
/* harmony export */   "PoolToGauges": function() { return /* binding */ PoolToGauges; }
/* harmony export */ });
/* harmony import */ var _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6499);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47895);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__);




function createBaseParams() {
  return {
    mintedDenom: ""
  };
}

const Params = {
  typeUrl: "/osmosis.poolincentives.v1beta1.Params",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (message.mintedDenom !== "") {
      writer.uint32(10).string(message.mintedDenom);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseParams();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.mintedDenom = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$mintedDenom;

    const message = createBaseParams();
    message.mintedDenom = (_object$mintedDenom = object.mintedDenom) !== null && _object$mintedDenom !== void 0 ? _object$mintedDenom : "";
    return message;
  },

  fromAmino(object) {
    return {
      mintedDenom: object.minted_denom
    };
  },

  toAmino(message) {
    const obj = {};
    obj.minted_denom = message.mintedDenom;
    return obj;
  },

  fromAminoMsg(object) {
    return Params.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/poolincentives/params",
      value: Params.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return Params.decode(message.value);
  },

  toProto(message) {
    return Params.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.poolincentives.v1beta1.Params",
      value: Params.encode(message).finish()
    };
  }

};

function createBaseLockableDurationsInfo() {
  return {
    lockableDurations: []
  };
}

const LockableDurationsInfo = {
  typeUrl: "/osmosis.poolincentives.v1beta1.LockableDurationsInfo",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    for (const v of message.lockableDurations) {
      _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_0__.Duration.encode(v, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLockableDurationsInfo();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.lockableDurations.push(_google_protobuf_duration__WEBPACK_IMPORTED_MODULE_0__.Duration.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$lockableDurat;

    const message = createBaseLockableDurationsInfo();
    message.lockableDurations = ((_object$lockableDurat = object.lockableDurations) === null || _object$lockableDurat === void 0 ? void 0 : _object$lockableDurat.map(e => _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_0__.Duration.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      lockableDurations: Array.isArray(object === null || object === void 0 ? void 0 : object.lockable_durations) ? object.lockable_durations.map(e => _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_0__.Duration.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.lockableDurations) {
      obj.lockable_durations = message.lockableDurations.map(e => e ? _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_0__.Duration.toAmino(e) : undefined);
    } else {
      obj.lockable_durations = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return LockableDurationsInfo.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/poolincentives/lockable-durations-info",
      value: LockableDurationsInfo.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return LockableDurationsInfo.decode(message.value);
  },

  toProto(message) {
    return LockableDurationsInfo.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.poolincentives.v1beta1.LockableDurationsInfo",
      value: LockableDurationsInfo.encode(message).finish()
    };
  }

};

function createBaseDistrInfo() {
  return {
    totalWeight: "",
    records: []
  };
}

const DistrInfo = {
  typeUrl: "/osmosis.poolincentives.v1beta1.DistrInfo",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (message.totalWeight !== "") {
      writer.uint32(10).string(message.totalWeight);
    }

    for (const v of message.records) {
      DistrRecord.encode(v, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDistrInfo();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.totalWeight = reader.string();
          break;

        case 2:
          message.records.push(DistrRecord.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$totalWeight, _object$records;

    const message = createBaseDistrInfo();
    message.totalWeight = (_object$totalWeight = object.totalWeight) !== null && _object$totalWeight !== void 0 ? _object$totalWeight : "";
    message.records = ((_object$records = object.records) === null || _object$records === void 0 ? void 0 : _object$records.map(e => DistrRecord.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      totalWeight: object.total_weight,
      records: Array.isArray(object === null || object === void 0 ? void 0 : object.records) ? object.records.map(e => DistrRecord.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.total_weight = message.totalWeight;

    if (message.records) {
      obj.records = message.records.map(e => e ? DistrRecord.toAmino(e) : undefined);
    } else {
      obj.records = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return DistrInfo.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/poolincentives/distr-info",
      value: DistrInfo.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return DistrInfo.decode(message.value);
  },

  toProto(message) {
    return DistrInfo.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.poolincentives.v1beta1.DistrInfo",
      value: DistrInfo.encode(message).finish()
    };
  }

};

function createBaseDistrRecord() {
  return {
    gaugeId: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.UZERO */ .dK.UZERO,
    weight: ""
  };
}

const DistrRecord = {
  typeUrl: "/osmosis.poolincentives.v1beta1.DistrRecord",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (!message.gaugeId.isZero()) {
      writer.uint32(8).uint64(message.gaugeId);
    }

    if (message.weight !== "") {
      writer.uint32(18).string(message.weight);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDistrRecord();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.gaugeId = reader.uint64();
          break;

        case 2:
          message.weight = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$weight;

    const message = createBaseDistrRecord();
    message.gaugeId = object.gaugeId !== undefined && object.gaugeId !== null ? _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromValue */ .dK.fromValue(object.gaugeId) : _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.UZERO */ .dK.UZERO;
    message.weight = (_object$weight = object.weight) !== null && _object$weight !== void 0 ? _object$weight : "";
    return message;
  },

  fromAmino(object) {
    return {
      gaugeId: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromString */ .dK.fromString(object.gauge_id),
      weight: object.weight
    };
  },

  toAmino(message) {
    const obj = {};
    obj.gauge_id = message.gaugeId ? message.gaugeId.toString() : undefined;
    obj.weight = message.weight;
    return obj;
  },

  fromAminoMsg(object) {
    return DistrRecord.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/poolincentives/distr-record",
      value: DistrRecord.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return DistrRecord.decode(message.value);
  },

  toProto(message) {
    return DistrRecord.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.poolincentives.v1beta1.DistrRecord",
      value: DistrRecord.encode(message).finish()
    };
  }

};

function createBasePoolToGauge() {
  return {
    poolId: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.UZERO */ .dK.UZERO,
    gaugeId: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.UZERO */ .dK.UZERO,
    duration: undefined
  };
}

const PoolToGauge = {
  typeUrl: "/osmosis.poolincentives.v1beta1.PoolToGauge",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (!message.poolId.isZero()) {
      writer.uint32(8).uint64(message.poolId);
    }

    if (!message.gaugeId.isZero()) {
      writer.uint32(16).uint64(message.gaugeId);
    }

    if (message.duration !== undefined) {
      _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_0__.Duration.encode(message.duration, writer.uint32(26).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePoolToGauge();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.poolId = reader.uint64();
          break;

        case 2:
          message.gaugeId = reader.uint64();
          break;

        case 3:
          message.duration = _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_0__.Duration.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBasePoolToGauge();
    message.poolId = object.poolId !== undefined && object.poolId !== null ? _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromValue */ .dK.fromValue(object.poolId) : _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.UZERO */ .dK.UZERO;
    message.gaugeId = object.gaugeId !== undefined && object.gaugeId !== null ? _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromValue */ .dK.fromValue(object.gaugeId) : _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.UZERO */ .dK.UZERO;
    message.duration = object.duration !== undefined && object.duration !== null ? _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_0__.Duration.fromPartial(object.duration) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      poolId: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromString */ .dK.fromString(object.pool_id),
      gaugeId: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromString */ .dK.fromString(object.gauge_id),
      duration: object !== null && object !== void 0 && object.duration ? _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_0__.Duration.fromAmino(object.duration) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.pool_id = message.poolId ? message.poolId.toString() : undefined;
    obj.gauge_id = message.gaugeId ? message.gaugeId.toString() : undefined;
    obj.duration = message.duration ? _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_0__.Duration.toAmino(message.duration) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return PoolToGauge.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/poolincentives/pool-to-gauge",
      value: PoolToGauge.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return PoolToGauge.decode(message.value);
  },

  toProto(message) {
    return PoolToGauge.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.poolincentives.v1beta1.PoolToGauge",
      value: PoolToGauge.encode(message).finish()
    };
  }

};

function createBasePoolToGauges() {
  return {
    poolToGauge: []
  };
}

const PoolToGauges = {
  typeUrl: "/osmosis.poolincentives.v1beta1.PoolToGauges",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    for (const v of message.poolToGauge) {
      PoolToGauge.encode(v, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePoolToGauges();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 2:
          message.poolToGauge.push(PoolToGauge.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$poolToGauge;

    const message = createBasePoolToGauges();
    message.poolToGauge = ((_object$poolToGauge = object.poolToGauge) === null || _object$poolToGauge === void 0 ? void 0 : _object$poolToGauge.map(e => PoolToGauge.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      poolToGauge: Array.isArray(object === null || object === void 0 ? void 0 : object.pool_to_gauge) ? object.pool_to_gauge.map(e => PoolToGauge.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.poolToGauge) {
      obj.pool_to_gauge = message.poolToGauge.map(e => e ? PoolToGauge.toAmino(e) : undefined);
    } else {
      obj.pool_to_gauge = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return PoolToGauges.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/poolincentives/pool-to-gauges",
      value: PoolToGauges.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return PoolToGauges.decode(message.value);
  },

  toProto(message) {
    return PoolToGauges.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.poolincentives.v1beta1.PoolToGauges",
      value: PoolToGauges.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 32889:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "IncentivizedPool": function() { return /* binding */ IncentivizedPool; },
/* harmony export */   "QueryDistrInfoRequest": function() { return /* binding */ QueryDistrInfoRequest; },
/* harmony export */   "QueryDistrInfoResponse": function() { return /* binding */ QueryDistrInfoResponse; },
/* harmony export */   "QueryExternalIncentiveGaugesRequest": function() { return /* binding */ QueryExternalIncentiveGaugesRequest; },
/* harmony export */   "QueryExternalIncentiveGaugesResponse": function() { return /* binding */ QueryExternalIncentiveGaugesResponse; },
/* harmony export */   "QueryGaugeIdsRequest": function() { return /* binding */ QueryGaugeIdsRequest; },
/* harmony export */   "QueryGaugeIdsResponse": function() { return /* binding */ QueryGaugeIdsResponse; },
/* harmony export */   "QueryGaugeIdsResponse_GaugeIdWithDuration": function() { return /* binding */ QueryGaugeIdsResponse_GaugeIdWithDuration; },
/* harmony export */   "QueryIncentivizedPoolsRequest": function() { return /* binding */ QueryIncentivizedPoolsRequest; },
/* harmony export */   "QueryIncentivizedPoolsResponse": function() { return /* binding */ QueryIncentivizedPoolsResponse; },
/* harmony export */   "QueryLockableDurationsRequest": function() { return /* binding */ QueryLockableDurationsRequest; },
/* harmony export */   "QueryLockableDurationsResponse": function() { return /* binding */ QueryLockableDurationsResponse; },
/* harmony export */   "QueryParamsRequest": function() { return /* binding */ QueryParamsRequest; },
/* harmony export */   "QueryParamsResponse": function() { return /* binding */ QueryParamsResponse; }
/* harmony export */ });
/* harmony import */ var _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6499);
/* harmony import */ var _incentives__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52993);
/* harmony import */ var _incentives_gauge__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61927);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47895);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__);






function createBaseQueryGaugeIdsRequest() {
  return {
    poolId: _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.UZERO */ .dK.UZERO
  };
}

const QueryGaugeIdsRequest = {
  typeUrl: "/osmosis.poolincentives.v1beta1.QueryGaugeIdsRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    if (!message.poolId.isZero()) {
      writer.uint32(8).uint64(message.poolId);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryGaugeIdsRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.poolId = reader.uint64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseQueryGaugeIdsRequest();
    message.poolId = object.poolId !== undefined && object.poolId !== null ? _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.fromValue */ .dK.fromValue(object.poolId) : _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.UZERO */ .dK.UZERO;
    return message;
  },

  fromAmino(object) {
    return {
      poolId: _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.fromString */ .dK.fromString(object.pool_id)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.pool_id = message.poolId ? message.poolId.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryGaugeIdsRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/poolincentives/query-gauge-ids-request",
      value: QueryGaugeIdsRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryGaugeIdsRequest.decode(message.value);
  },

  toProto(message) {
    return QueryGaugeIdsRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.poolincentives.v1beta1.QueryGaugeIdsRequest",
      value: QueryGaugeIdsRequest.encode(message).finish()
    };
  }

};

function createBaseQueryGaugeIdsResponse() {
  return {
    gaugeIdsWithDuration: []
  };
}

const QueryGaugeIdsResponse = {
  typeUrl: "/osmosis.poolincentives.v1beta1.QueryGaugeIdsResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    for (const v of message.gaugeIdsWithDuration) {
      QueryGaugeIdsResponse_GaugeIdWithDuration.encode(v, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryGaugeIdsResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.gaugeIdsWithDuration.push(QueryGaugeIdsResponse_GaugeIdWithDuration.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$gaugeIdsWithD;

    const message = createBaseQueryGaugeIdsResponse();
    message.gaugeIdsWithDuration = ((_object$gaugeIdsWithD = object.gaugeIdsWithDuration) === null || _object$gaugeIdsWithD === void 0 ? void 0 : _object$gaugeIdsWithD.map(e => QueryGaugeIdsResponse_GaugeIdWithDuration.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      gaugeIdsWithDuration: Array.isArray(object === null || object === void 0 ? void 0 : object.gauge_ids_with_duration) ? object.gauge_ids_with_duration.map(e => QueryGaugeIdsResponse_GaugeIdWithDuration.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.gaugeIdsWithDuration) {
      obj.gauge_ids_with_duration = message.gaugeIdsWithDuration.map(e => e ? QueryGaugeIdsResponse_GaugeIdWithDuration.toAmino(e) : undefined);
    } else {
      obj.gauge_ids_with_duration = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return QueryGaugeIdsResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/poolincentives/query-gauge-ids-response",
      value: QueryGaugeIdsResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryGaugeIdsResponse.decode(message.value);
  },

  toProto(message) {
    return QueryGaugeIdsResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.poolincentives.v1beta1.QueryGaugeIdsResponse",
      value: QueryGaugeIdsResponse.encode(message).finish()
    };
  }

};

function createBaseQueryGaugeIdsResponse_GaugeIdWithDuration() {
  return {
    gaugeId: _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.UZERO */ .dK.UZERO,
    duration: undefined,
    gaugeIncentivePercentage: ""
  };
}

const QueryGaugeIdsResponse_GaugeIdWithDuration = {
  typeUrl: "/osmosis.poolincentives.v1beta1.GaugeIdWithDuration",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    if (!message.gaugeId.isZero()) {
      writer.uint32(8).uint64(message.gaugeId);
    }

    if (message.duration !== undefined) {
      _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_0__.Duration.encode(message.duration, writer.uint32(18).fork()).ldelim();
    }

    if (message.gaugeIncentivePercentage !== "") {
      writer.uint32(26).string(message.gaugeIncentivePercentage);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryGaugeIdsResponse_GaugeIdWithDuration();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.gaugeId = reader.uint64();
          break;

        case 2:
          message.duration = _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_0__.Duration.decode(reader, reader.uint32());
          break;

        case 3:
          message.gaugeIncentivePercentage = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$gaugeIncentiv;

    const message = createBaseQueryGaugeIdsResponse_GaugeIdWithDuration();
    message.gaugeId = object.gaugeId !== undefined && object.gaugeId !== null ? _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.fromValue */ .dK.fromValue(object.gaugeId) : _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.UZERO */ .dK.UZERO;
    message.duration = object.duration !== undefined && object.duration !== null ? _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_0__.Duration.fromPartial(object.duration) : undefined;
    message.gaugeIncentivePercentage = (_object$gaugeIncentiv = object.gaugeIncentivePercentage) !== null && _object$gaugeIncentiv !== void 0 ? _object$gaugeIncentiv : "";
    return message;
  },

  fromAmino(object) {
    return {
      gaugeId: _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.fromString */ .dK.fromString(object.gauge_id),
      duration: object !== null && object !== void 0 && object.duration ? _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_0__.Duration.fromAmino(object.duration) : undefined,
      gaugeIncentivePercentage: object.gauge_incentive_percentage
    };
  },

  toAmino(message) {
    const obj = {};
    obj.gauge_id = message.gaugeId ? message.gaugeId.toString() : undefined;
    obj.duration = message.duration ? _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_0__.Duration.toAmino(message.duration) : undefined;
    obj.gauge_incentive_percentage = message.gaugeIncentivePercentage;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryGaugeIdsResponse_GaugeIdWithDuration.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/poolincentives/gauge-id-with-duration",
      value: QueryGaugeIdsResponse_GaugeIdWithDuration.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryGaugeIdsResponse_GaugeIdWithDuration.decode(message.value);
  },

  toProto(message) {
    return QueryGaugeIdsResponse_GaugeIdWithDuration.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.poolincentives.v1beta1.GaugeIdWithDuration",
      value: QueryGaugeIdsResponse_GaugeIdWithDuration.encode(message).finish()
    };
  }

};

function createBaseQueryDistrInfoRequest() {
  return {};
}

const QueryDistrInfoRequest = {
  typeUrl: "/osmosis.poolincentives.v1beta1.QueryDistrInfoRequest",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryDistrInfoRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseQueryDistrInfoRequest();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return QueryDistrInfoRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/poolincentives/query-distr-info-request",
      value: QueryDistrInfoRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryDistrInfoRequest.decode(message.value);
  },

  toProto(message) {
    return QueryDistrInfoRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.poolincentives.v1beta1.QueryDistrInfoRequest",
      value: QueryDistrInfoRequest.encode(message).finish()
    };
  }

};

function createBaseQueryDistrInfoResponse() {
  return {
    distrInfo: undefined
  };
}

const QueryDistrInfoResponse = {
  typeUrl: "/osmosis.poolincentives.v1beta1.QueryDistrInfoResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    if (message.distrInfo !== undefined) {
      _incentives__WEBPACK_IMPORTED_MODULE_1__.DistrInfo.encode(message.distrInfo, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryDistrInfoResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.distrInfo = _incentives__WEBPACK_IMPORTED_MODULE_1__.DistrInfo.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseQueryDistrInfoResponse();
    message.distrInfo = object.distrInfo !== undefined && object.distrInfo !== null ? _incentives__WEBPACK_IMPORTED_MODULE_1__.DistrInfo.fromPartial(object.distrInfo) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      distrInfo: object !== null && object !== void 0 && object.distr_info ? _incentives__WEBPACK_IMPORTED_MODULE_1__.DistrInfo.fromAmino(object.distr_info) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.distr_info = message.distrInfo ? _incentives__WEBPACK_IMPORTED_MODULE_1__.DistrInfo.toAmino(message.distrInfo) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryDistrInfoResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/poolincentives/query-distr-info-response",
      value: QueryDistrInfoResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryDistrInfoResponse.decode(message.value);
  },

  toProto(message) {
    return QueryDistrInfoResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.poolincentives.v1beta1.QueryDistrInfoResponse",
      value: QueryDistrInfoResponse.encode(message).finish()
    };
  }

};

function createBaseQueryParamsRequest() {
  return {};
}

const QueryParamsRequest = {
  typeUrl: "/osmosis.poolincentives.v1beta1.QueryParamsRequest",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryParamsRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseQueryParamsRequest();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return QueryParamsRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/poolincentives/query-params-request",
      value: QueryParamsRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryParamsRequest.decode(message.value);
  },

  toProto(message) {
    return QueryParamsRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.poolincentives.v1beta1.QueryParamsRequest",
      value: QueryParamsRequest.encode(message).finish()
    };
  }

};

function createBaseQueryParamsResponse() {
  return {
    params: undefined
  };
}

const QueryParamsResponse = {
  typeUrl: "/osmosis.poolincentives.v1beta1.QueryParamsResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    if (message.params !== undefined) {
      _incentives__WEBPACK_IMPORTED_MODULE_1__.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryParamsResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.params = _incentives__WEBPACK_IMPORTED_MODULE_1__.Params.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseQueryParamsResponse();
    message.params = object.params !== undefined && object.params !== null ? _incentives__WEBPACK_IMPORTED_MODULE_1__.Params.fromPartial(object.params) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      params: object !== null && object !== void 0 && object.params ? _incentives__WEBPACK_IMPORTED_MODULE_1__.Params.fromAmino(object.params) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.params = message.params ? _incentives__WEBPACK_IMPORTED_MODULE_1__.Params.toAmino(message.params) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryParamsResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/poolincentives/query-params-response",
      value: QueryParamsResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryParamsResponse.decode(message.value);
  },

  toProto(message) {
    return QueryParamsResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.poolincentives.v1beta1.QueryParamsResponse",
      value: QueryParamsResponse.encode(message).finish()
    };
  }

};

function createBaseQueryLockableDurationsRequest() {
  return {};
}

const QueryLockableDurationsRequest = {
  typeUrl: "/osmosis.poolincentives.v1beta1.QueryLockableDurationsRequest",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryLockableDurationsRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseQueryLockableDurationsRequest();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return QueryLockableDurationsRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/poolincentives/query-lockable-durations-request",
      value: QueryLockableDurationsRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryLockableDurationsRequest.decode(message.value);
  },

  toProto(message) {
    return QueryLockableDurationsRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.poolincentives.v1beta1.QueryLockableDurationsRequest",
      value: QueryLockableDurationsRequest.encode(message).finish()
    };
  }

};

function createBaseQueryLockableDurationsResponse() {
  return {
    lockableDurations: []
  };
}

const QueryLockableDurationsResponse = {
  typeUrl: "/osmosis.poolincentives.v1beta1.QueryLockableDurationsResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    for (const v of message.lockableDurations) {
      _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_0__.Duration.encode(v, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryLockableDurationsResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.lockableDurations.push(_google_protobuf_duration__WEBPACK_IMPORTED_MODULE_0__.Duration.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$lockableDurat;

    const message = createBaseQueryLockableDurationsResponse();
    message.lockableDurations = ((_object$lockableDurat = object.lockableDurations) === null || _object$lockableDurat === void 0 ? void 0 : _object$lockableDurat.map(e => _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_0__.Duration.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      lockableDurations: Array.isArray(object === null || object === void 0 ? void 0 : object.lockable_durations) ? object.lockable_durations.map(e => _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_0__.Duration.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.lockableDurations) {
      obj.lockable_durations = message.lockableDurations.map(e => e ? _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_0__.Duration.toAmino(e) : undefined);
    } else {
      obj.lockable_durations = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return QueryLockableDurationsResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/poolincentives/query-lockable-durations-response",
      value: QueryLockableDurationsResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryLockableDurationsResponse.decode(message.value);
  },

  toProto(message) {
    return QueryLockableDurationsResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.poolincentives.v1beta1.QueryLockableDurationsResponse",
      value: QueryLockableDurationsResponse.encode(message).finish()
    };
  }

};

function createBaseQueryIncentivizedPoolsRequest() {
  return {};
}

const QueryIncentivizedPoolsRequest = {
  typeUrl: "/osmosis.poolincentives.v1beta1.QueryIncentivizedPoolsRequest",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryIncentivizedPoolsRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseQueryIncentivizedPoolsRequest();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return QueryIncentivizedPoolsRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/poolincentives/query-incentivized-pools-request",
      value: QueryIncentivizedPoolsRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryIncentivizedPoolsRequest.decode(message.value);
  },

  toProto(message) {
    return QueryIncentivizedPoolsRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.poolincentives.v1beta1.QueryIncentivizedPoolsRequest",
      value: QueryIncentivizedPoolsRequest.encode(message).finish()
    };
  }

};

function createBaseIncentivizedPool() {
  return {
    poolId: _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.UZERO */ .dK.UZERO,
    lockableDuration: undefined,
    gaugeId: _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.UZERO */ .dK.UZERO
  };
}

const IncentivizedPool = {
  typeUrl: "/osmosis.poolincentives.v1beta1.IncentivizedPool",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    if (!message.poolId.isZero()) {
      writer.uint32(8).uint64(message.poolId);
    }

    if (message.lockableDuration !== undefined) {
      _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_0__.Duration.encode(message.lockableDuration, writer.uint32(18).fork()).ldelim();
    }

    if (!message.gaugeId.isZero()) {
      writer.uint32(24).uint64(message.gaugeId);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseIncentivizedPool();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.poolId = reader.uint64();
          break;

        case 2:
          message.lockableDuration = _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_0__.Duration.decode(reader, reader.uint32());
          break;

        case 3:
          message.gaugeId = reader.uint64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseIncentivizedPool();
    message.poolId = object.poolId !== undefined && object.poolId !== null ? _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.fromValue */ .dK.fromValue(object.poolId) : _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.UZERO */ .dK.UZERO;
    message.lockableDuration = object.lockableDuration !== undefined && object.lockableDuration !== null ? _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_0__.Duration.fromPartial(object.lockableDuration) : undefined;
    message.gaugeId = object.gaugeId !== undefined && object.gaugeId !== null ? _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.fromValue */ .dK.fromValue(object.gaugeId) : _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.UZERO */ .dK.UZERO;
    return message;
  },

  fromAmino(object) {
    return {
      poolId: _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.fromString */ .dK.fromString(object.pool_id),
      lockableDuration: object !== null && object !== void 0 && object.lockable_duration ? _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_0__.Duration.fromAmino(object.lockable_duration) : undefined,
      gaugeId: _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.fromString */ .dK.fromString(object.gauge_id)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.pool_id = message.poolId ? message.poolId.toString() : undefined;
    obj.lockable_duration = message.lockableDuration ? _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_0__.Duration.toAmino(message.lockableDuration) : undefined;
    obj.gauge_id = message.gaugeId ? message.gaugeId.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return IncentivizedPool.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/poolincentives/incentivized-pool",
      value: IncentivizedPool.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return IncentivizedPool.decode(message.value);
  },

  toProto(message) {
    return IncentivizedPool.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.poolincentives.v1beta1.IncentivizedPool",
      value: IncentivizedPool.encode(message).finish()
    };
  }

};

function createBaseQueryIncentivizedPoolsResponse() {
  return {
    incentivizedPools: []
  };
}

const QueryIncentivizedPoolsResponse = {
  typeUrl: "/osmosis.poolincentives.v1beta1.QueryIncentivizedPoolsResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    for (const v of message.incentivizedPools) {
      IncentivizedPool.encode(v, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryIncentivizedPoolsResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.incentivizedPools.push(IncentivizedPool.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$incentivizedP;

    const message = createBaseQueryIncentivizedPoolsResponse();
    message.incentivizedPools = ((_object$incentivizedP = object.incentivizedPools) === null || _object$incentivizedP === void 0 ? void 0 : _object$incentivizedP.map(e => IncentivizedPool.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      incentivizedPools: Array.isArray(object === null || object === void 0 ? void 0 : object.incentivized_pools) ? object.incentivized_pools.map(e => IncentivizedPool.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.incentivizedPools) {
      obj.incentivized_pools = message.incentivizedPools.map(e => e ? IncentivizedPool.toAmino(e) : undefined);
    } else {
      obj.incentivized_pools = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return QueryIncentivizedPoolsResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/poolincentives/query-incentivized-pools-response",
      value: QueryIncentivizedPoolsResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryIncentivizedPoolsResponse.decode(message.value);
  },

  toProto(message) {
    return QueryIncentivizedPoolsResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.poolincentives.v1beta1.QueryIncentivizedPoolsResponse",
      value: QueryIncentivizedPoolsResponse.encode(message).finish()
    };
  }

};

function createBaseQueryExternalIncentiveGaugesRequest() {
  return {};
}

const QueryExternalIncentiveGaugesRequest = {
  typeUrl: "/osmosis.poolincentives.v1beta1.QueryExternalIncentiveGaugesRequest",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryExternalIncentiveGaugesRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseQueryExternalIncentiveGaugesRequest();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return QueryExternalIncentiveGaugesRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/poolincentives/query-external-incentive-gauges-request",
      value: QueryExternalIncentiveGaugesRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryExternalIncentiveGaugesRequest.decode(message.value);
  },

  toProto(message) {
    return QueryExternalIncentiveGaugesRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.poolincentives.v1beta1.QueryExternalIncentiveGaugesRequest",
      value: QueryExternalIncentiveGaugesRequest.encode(message).finish()
    };
  }

};

function createBaseQueryExternalIncentiveGaugesResponse() {
  return {
    data: []
  };
}

const QueryExternalIncentiveGaugesResponse = {
  typeUrl: "/osmosis.poolincentives.v1beta1.QueryExternalIncentiveGaugesResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    for (const v of message.data) {
      _incentives_gauge__WEBPACK_IMPORTED_MODULE_2__.Gauge.encode(v, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryExternalIncentiveGaugesResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.data.push(_incentives_gauge__WEBPACK_IMPORTED_MODULE_2__.Gauge.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$data;

    const message = createBaseQueryExternalIncentiveGaugesResponse();
    message.data = ((_object$data = object.data) === null || _object$data === void 0 ? void 0 : _object$data.map(e => _incentives_gauge__WEBPACK_IMPORTED_MODULE_2__.Gauge.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      data: Array.isArray(object === null || object === void 0 ? void 0 : object.data) ? object.data.map(e => _incentives_gauge__WEBPACK_IMPORTED_MODULE_2__.Gauge.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.data) {
      obj.data = message.data.map(e => e ? _incentives_gauge__WEBPACK_IMPORTED_MODULE_2__.Gauge.toAmino(e) : undefined);
    } else {
      obj.data = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return QueryExternalIncentiveGaugesResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/poolincentives/query-external-incentive-gauges-response",
      value: QueryExternalIncentiveGaugesResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryExternalIncentiveGaugesResponse.decode(message.value);
  },

  toProto(message) {
    return QueryExternalIncentiveGaugesResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.poolincentives.v1beta1.QueryExternalIncentiveGaugesResponse",
      value: QueryExternalIncentiveGaugesResponse.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 57788:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LCDQueryClient": function() { return /* binding */ LCDQueryClient; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4942);

class LCDQueryClient {
  constructor({
    requestClient
  }) {
    (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, "req", void 0);

    this.req = requestClient;
    this.gaugeIds = this.gaugeIds.bind(this);
    this.distrInfo = this.distrInfo.bind(this);
    this.params = this.params.bind(this);
    this.lockableDurations = this.lockableDurations.bind(this);
    this.incentivizedPools = this.incentivizedPools.bind(this);
    this.externalIncentiveGauges = this.externalIncentiveGauges.bind(this);
  }
  /* GaugeIds takes the pool id and returns the matching gauge ids and durations */


  async gaugeIds(params) {
    const endpoint = `osmosis/pool-incentives/v1beta1/gauge-ids/${params.poolId}`;
    return await this.req.get(endpoint);
  }
  /* DistrInfo returns the pool's matching gauge ids and weights. */


  async distrInfo(_params = {}) {
    const endpoint = `osmosis/pool-incentives/v1beta1/distr_info`;
    return await this.req.get(endpoint);
  }
  /* Params returns pool incentives params. */


  async params(_params = {}) {
    const endpoint = `osmosis/pool-incentives/v1beta1/params`;
    return await this.req.get(endpoint);
  }
  /* LockableDurations returns lock durations for pools. */


  async lockableDurations(_params = {}) {
    const endpoint = `osmosis/pool-incentives/v1beta1/lockable_durations`;
    return await this.req.get(endpoint);
  }
  /* IncentivizedPools returns currently incentivized pools */


  async incentivizedPools(_params = {}) {
    const endpoint = `osmosis/pool-incentives/v1beta1/incentivized_pools`;
    return await this.req.get(endpoint);
  }
  /* ExternalIncentiveGauges returns external incentive gauges. */


  async externalIncentiveGauges(_params = {}) {
    const endpoint = `osmosis/pool-incentives/v1beta1/external_incentive_gauges`;
    return await this.req.get(endpoint);
  }

}

/***/ }),

/***/ 80709:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QueryClientImpl": function() { return /* binding */ QueryClientImpl; },
/* harmony export */   "createRpcQueryExtension": function() { return /* binding */ createRpcQueryExtension; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4942);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78441);
/* harmony import */ var _cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32889);




class QueryClientImpl {
  constructor(rpc) {
    (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, "rpc", void 0);

    this.rpc = rpc;
    this.gaugeIds = this.gaugeIds.bind(this);
    this.distrInfo = this.distrInfo.bind(this);
    this.params = this.params.bind(this);
    this.lockableDurations = this.lockableDurations.bind(this);
    this.incentivizedPools = this.incentivizedPools.bind(this);
    this.externalIncentiveGauges = this.externalIncentiveGauges.bind(this);
  }

  gaugeIds(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryGaugeIdsRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.poolincentives.v1beta1.Query", "GaugeIds", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryGaugeIdsResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  distrInfo(request = {}) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryDistrInfoRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.poolincentives.v1beta1.Query", "DistrInfo", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryDistrInfoResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  params(request = {}) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryParamsRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.poolincentives.v1beta1.Query", "Params", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryParamsResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  lockableDurations(request = {}) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryLockableDurationsRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.poolincentives.v1beta1.Query", "LockableDurations", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryLockableDurationsResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  incentivizedPools(request = {}) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryIncentivizedPoolsRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.poolincentives.v1beta1.Query", "IncentivizedPools", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryIncentivizedPoolsResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  externalIncentiveGauges(request = {}) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryExternalIncentiveGaugesRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.poolincentives.v1beta1.Query", "ExternalIncentiveGauges", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryExternalIncentiveGaugesResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

}
const createRpcQueryExtension = base => {
  const rpc = (0,_cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1__.createProtobufRpcClient)(base);
  const queryService = new QueryClientImpl(rpc);
  return {
    gaugeIds(request) {
      return queryService.gaugeIds(request);
    },

    distrInfo(request) {
      return queryService.distrInfo(request);
    },

    params(request) {
      return queryService.params(request);
    },

    lockableDurations(request) {
      return queryService.lockableDurations(request);
    },

    incentivizedPools(request) {
      return queryService.incentivizedPools(request);
    },

    externalIncentiveGauges(request) {
      return queryService.externalIncentiveGauges(request);
    }

  };
};

/***/ }),

/***/ 11721:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GenesisState": function() { return /* binding */ GenesisState; },
/* harmony export */   "Params": function() { return /* binding */ Params; }
/* harmony export */ });
/* harmony import */ var _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26178);
/* harmony import */ var _module_route__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61103);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47895);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__);




/** Params holds parameters for the poolmanager module */

function createBaseParams() {
  return {
    poolCreationFee: []
  };
}

const Params = {
  typeUrl: "/osmosis.poolmanager.v1beta1.Params",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    for (const v of message.poolCreationFee) {
      _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.encode(v, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseParams();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.poolCreationFee.push(_cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$poolCreationF;

    const message = createBaseParams();
    message.poolCreationFee = ((_object$poolCreationF = object.poolCreationFee) === null || _object$poolCreationF === void 0 ? void 0 : _object$poolCreationF.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      poolCreationFee: Array.isArray(object === null || object === void 0 ? void 0 : object.pool_creation_fee) ? object.pool_creation_fee.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.poolCreationFee) {
      obj.pool_creation_fee = message.poolCreationFee.map(e => e ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.toAmino(e) : undefined);
    } else {
      obj.pool_creation_fee = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return Params.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/poolmanager/params",
      value: Params.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return Params.decode(message.value);
  },

  toProto(message) {
    return Params.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.poolmanager.v1beta1.Params",
      value: Params.encode(message).finish()
    };
  }

};

function createBaseGenesisState() {
  return {
    nextPoolId: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO,
    params: undefined,
    poolRoutes: []
  };
}

const GenesisState = {
  typeUrl: "/osmosis.poolmanager.v1beta1.GenesisState",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (!message.nextPoolId.isZero()) {
      writer.uint32(8).uint64(message.nextPoolId);
    }

    if (message.params !== undefined) {
      Params.encode(message.params, writer.uint32(18).fork()).ldelim();
    }

    for (const v of message.poolRoutes) {
      _module_route__WEBPACK_IMPORTED_MODULE_1__.ModuleRoute.encode(v, writer.uint32(26).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGenesisState();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.nextPoolId = reader.uint64();
          break;

        case 2:
          message.params = Params.decode(reader, reader.uint32());
          break;

        case 3:
          message.poolRoutes.push(_module_route__WEBPACK_IMPORTED_MODULE_1__.ModuleRoute.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$poolRoutes;

    const message = createBaseGenesisState();
    message.nextPoolId = object.nextPoolId !== undefined && object.nextPoolId !== null ? _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromValue */ .dK.fromValue(object.nextPoolId) : _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO;
    message.params = object.params !== undefined && object.params !== null ? Params.fromPartial(object.params) : undefined;
    message.poolRoutes = ((_object$poolRoutes = object.poolRoutes) === null || _object$poolRoutes === void 0 ? void 0 : _object$poolRoutes.map(e => _module_route__WEBPACK_IMPORTED_MODULE_1__.ModuleRoute.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      nextPoolId: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromString */ .dK.fromString(object.next_pool_id),
      params: object !== null && object !== void 0 && object.params ? Params.fromAmino(object.params) : undefined,
      poolRoutes: Array.isArray(object === null || object === void 0 ? void 0 : object.pool_routes) ? object.pool_routes.map(e => _module_route__WEBPACK_IMPORTED_MODULE_1__.ModuleRoute.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.next_pool_id = message.nextPoolId ? message.nextPoolId.toString() : undefined;
    obj.params = message.params ? Params.toAmino(message.params) : undefined;

    if (message.poolRoutes) {
      obj.pool_routes = message.poolRoutes.map(e => e ? _module_route__WEBPACK_IMPORTED_MODULE_1__.ModuleRoute.toAmino(e) : undefined);
    } else {
      obj.pool_routes = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return GenesisState.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/poolmanager/genesis-state",
      value: GenesisState.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return GenesisState.decode(message.value);
  },

  toProto(message) {
    return GenesisState.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.poolmanager.v1beta1.GenesisState",
      value: GenesisState.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 61103:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ModuleRoute": function() { return /* binding */ ModuleRoute; },
/* harmony export */   "PoolType": function() { return /* binding */ PoolType; },
/* harmony export */   "PoolTypeAmino": function() { return /* binding */ PoolTypeAmino; },
/* harmony export */   "PoolTypeSDKType": function() { return /* binding */ PoolTypeSDKType; },
/* harmony export */   "poolTypeFromJSON": function() { return /* binding */ poolTypeFromJSON; },
/* harmony export */   "poolTypeToJSON": function() { return /* binding */ poolTypeToJSON; }
/* harmony export */ });
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47895);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__);


/** PoolType is an enumeration of all supported pool types. */

let PoolType;

(function (PoolType) {
  PoolType[PoolType["Balancer"] = 0] = "Balancer";
  PoolType[PoolType["Stableswap"] = 1] = "Stableswap";
  PoolType[PoolType["Concentrated"] = 2] = "Concentrated";
  PoolType[PoolType["CosmWasm"] = 3] = "CosmWasm";
  PoolType[PoolType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(PoolType || (PoolType = {}));

const PoolTypeSDKType = PoolType;
const PoolTypeAmino = PoolType;
function poolTypeFromJSON(object) {
  switch (object) {
    case 0:
    case "Balancer":
      return PoolType.Balancer;

    case 1:
    case "Stableswap":
      return PoolType.Stableswap;

    case 2:
    case "Concentrated":
      return PoolType.Concentrated;

    case 3:
    case "CosmWasm":
      return PoolType.CosmWasm;

    case -1:
    case "UNRECOGNIZED":
    default:
      return PoolType.UNRECOGNIZED;
  }
}
function poolTypeToJSON(object) {
  switch (object) {
    case PoolType.Balancer:
      return "Balancer";

    case PoolType.Stableswap:
      return "Stableswap";

    case PoolType.Concentrated:
      return "Concentrated";

    case PoolType.CosmWasm:
      return "CosmWasm";

    case PoolType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
/**
 * ModuleRouter defines a route encapsulating pool type.
 * It is used as the value of a mapping from pool id to the pool type,
 * allowing the pool manager to know which module to route swaps to given the
 * pool id.
 */

function createBaseModuleRoute() {
  return {
    poolType: 0,
    poolId: undefined
  };
}

const ModuleRoute = {
  typeUrl: "/osmosis.poolmanager.v1beta1.ModuleRoute",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Writer.create()) {
    if (message.poolType !== 0) {
      writer.uint32(8).int32(message.poolType);
    }

    if (message.poolId !== undefined) {
      writer.uint32(16).uint64(message.poolId);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseModuleRoute();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.poolType = reader.int32();
          break;

        case 2:
          message.poolId = reader.uint64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$poolType;

    const message = createBaseModuleRoute();
    message.poolType = (_object$poolType = object.poolType) !== null && _object$poolType !== void 0 ? _object$poolType : 0;
    message.poolId = object.poolId !== undefined && object.poolId !== null ? _helpers__WEBPACK_IMPORTED_MODULE_0__/* .Long.fromValue */ .dK.fromValue(object.poolId) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      poolType: (0,_helpers__WEBPACK_IMPORTED_MODULE_0__/* .isSet */ .DM)(object.pool_type) ? poolTypeFromJSON(object.pool_type) : 0,
      poolId: object !== null && object !== void 0 && object.pool_id ? _helpers__WEBPACK_IMPORTED_MODULE_0__/* .Long.fromString */ .dK.fromString(object.pool_id) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.pool_type = message.poolType;
    obj.pool_id = message.poolId ? message.poolId.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return ModuleRoute.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/poolmanager/module-route",
      value: ModuleRoute.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return ModuleRoute.decode(message.value);
  },

  toProto(message) {
    return ModuleRoute.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.poolmanager.v1beta1.ModuleRoute",
      value: ModuleRoute.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 38569:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AllPoolsRequest": function() { return /* binding */ AllPoolsRequest; },
/* harmony export */   "AllPoolsResponse": function() { return /* binding */ AllPoolsResponse; },
/* harmony export */   "EstimateSinglePoolSwapExactAmountInRequest": function() { return /* binding */ EstimateSinglePoolSwapExactAmountInRequest; },
/* harmony export */   "EstimateSinglePoolSwapExactAmountOutRequest": function() { return /* binding */ EstimateSinglePoolSwapExactAmountOutRequest; },
/* harmony export */   "EstimateSwapExactAmountInRequest": function() { return /* binding */ EstimateSwapExactAmountInRequest; },
/* harmony export */   "EstimateSwapExactAmountInResponse": function() { return /* binding */ EstimateSwapExactAmountInResponse; },
/* harmony export */   "EstimateSwapExactAmountOutRequest": function() { return /* binding */ EstimateSwapExactAmountOutRequest; },
/* harmony export */   "EstimateSwapExactAmountOutResponse": function() { return /* binding */ EstimateSwapExactAmountOutResponse; },
/* harmony export */   "NumPoolsRequest": function() { return /* binding */ NumPoolsRequest; },
/* harmony export */   "NumPoolsResponse": function() { return /* binding */ NumPoolsResponse; },
/* harmony export */   "ParamsRequest": function() { return /* binding */ ParamsRequest; },
/* harmony export */   "ParamsResponse": function() { return /* binding */ ParamsResponse; },
/* harmony export */   "PoolI_FromAmino": function() { return /* binding */ PoolI_FromAmino; },
/* harmony export */   "PoolI_InterfaceDecoder": function() { return /* binding */ PoolI_InterfaceDecoder; },
/* harmony export */   "PoolI_ToAmino": function() { return /* binding */ PoolI_ToAmino; },
/* harmony export */   "PoolRequest": function() { return /* binding */ PoolRequest; },
/* harmony export */   "PoolResponse": function() { return /* binding */ PoolResponse; },
/* harmony export */   "SpotPriceRequest": function() { return /* binding */ SpotPriceRequest; },
/* harmony export */   "SpotPriceResponse": function() { return /* binding */ SpotPriceResponse; },
/* harmony export */   "TotalPoolLiquidityRequest": function() { return /* binding */ TotalPoolLiquidityRequest; },
/* harmony export */   "TotalPoolLiquidityResponse": function() { return /* binding */ TotalPoolLiquidityResponse; }
/* harmony export */ });
/* harmony import */ var _swap_route__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23569);
/* harmony import */ var _genesis__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11721);
/* harmony import */ var _google_protobuf_any__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32106);
/* harmony import */ var _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26178);
/* harmony import */ var _concentrated_liquidity_pool__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4343);
/* harmony import */ var _cosmwasmpool_v1beta1_model_pool__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(17186);
/* harmony import */ var _gamm_pool_models_balancer_balancerPool__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4075);
/* harmony import */ var _gamm_pool_models_stableswap_stableswap_pool__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(66761);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47895);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__);










/** =============================== Params */

function createBaseParamsRequest() {
  return {};
}

const ParamsRequest = {
  typeUrl: "/osmosis.poolmanager.v1beta1.ParamsRequest",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseParamsRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseParamsRequest();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return ParamsRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/poolmanager/params-request",
      value: ParamsRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return ParamsRequest.decode(message.value);
  },

  toProto(message) {
    return ParamsRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.poolmanager.v1beta1.ParamsRequest",
      value: ParamsRequest.encode(message).finish()
    };
  }

};

function createBaseParamsResponse() {
  return {
    params: undefined
  };
}

const ParamsResponse = {
  typeUrl: "/osmosis.poolmanager.v1beta1.ParamsResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Writer.create()) {
    if (message.params !== undefined) {
      _genesis__WEBPACK_IMPORTED_MODULE_1__.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseParamsResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.params = _genesis__WEBPACK_IMPORTED_MODULE_1__.Params.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseParamsResponse();
    message.params = object.params !== undefined && object.params !== null ? _genesis__WEBPACK_IMPORTED_MODULE_1__.Params.fromPartial(object.params) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      params: object !== null && object !== void 0 && object.params ? _genesis__WEBPACK_IMPORTED_MODULE_1__.Params.fromAmino(object.params) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.params = message.params ? _genesis__WEBPACK_IMPORTED_MODULE_1__.Params.toAmino(message.params) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return ParamsResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/poolmanager/params-response",
      value: ParamsResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return ParamsResponse.decode(message.value);
  },

  toProto(message) {
    return ParamsResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.poolmanager.v1beta1.ParamsResponse",
      value: ParamsResponse.encode(message).finish()
    };
  }

};

function createBaseEstimateSwapExactAmountInRequest() {
  return {
    poolId: _helpers__WEBPACK_IMPORTED_MODULE_8__/* .Long.UZERO */ .dK.UZERO,
    tokenIn: "",
    routes: []
  };
}

const EstimateSwapExactAmountInRequest = {
  typeUrl: "/osmosis.poolmanager.v1beta1.EstimateSwapExactAmountInRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Writer.create()) {
    if (!message.poolId.isZero()) {
      writer.uint32(16).uint64(message.poolId);
    }

    if (message.tokenIn !== "") {
      writer.uint32(26).string(message.tokenIn);
    }

    for (const v of message.routes) {
      _swap_route__WEBPACK_IMPORTED_MODULE_0__.SwapAmountInRoute.encode(v, writer.uint32(34).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEstimateSwapExactAmountInRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 2:
          message.poolId = reader.uint64();
          break;

        case 3:
          message.tokenIn = reader.string();
          break;

        case 4:
          message.routes.push(_swap_route__WEBPACK_IMPORTED_MODULE_0__.SwapAmountInRoute.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$tokenIn, _object$routes;

    const message = createBaseEstimateSwapExactAmountInRequest();
    message.poolId = object.poolId !== undefined && object.poolId !== null ? _helpers__WEBPACK_IMPORTED_MODULE_8__/* .Long.fromValue */ .dK.fromValue(object.poolId) : _helpers__WEBPACK_IMPORTED_MODULE_8__/* .Long.UZERO */ .dK.UZERO;
    message.tokenIn = (_object$tokenIn = object.tokenIn) !== null && _object$tokenIn !== void 0 ? _object$tokenIn : "";
    message.routes = ((_object$routes = object.routes) === null || _object$routes === void 0 ? void 0 : _object$routes.map(e => _swap_route__WEBPACK_IMPORTED_MODULE_0__.SwapAmountInRoute.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      poolId: _helpers__WEBPACK_IMPORTED_MODULE_8__/* .Long.fromString */ .dK.fromString(object.pool_id),
      tokenIn: object.token_in,
      routes: Array.isArray(object === null || object === void 0 ? void 0 : object.routes) ? object.routes.map(e => _swap_route__WEBPACK_IMPORTED_MODULE_0__.SwapAmountInRoute.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.pool_id = message.poolId ? message.poolId.toString() : undefined;
    obj.token_in = message.tokenIn;

    if (message.routes) {
      obj.routes = message.routes.map(e => e ? _swap_route__WEBPACK_IMPORTED_MODULE_0__.SwapAmountInRoute.toAmino(e) : undefined);
    } else {
      obj.routes = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return EstimateSwapExactAmountInRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/poolmanager/estimate-swap-exact-amount-in-request",
      value: EstimateSwapExactAmountInRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return EstimateSwapExactAmountInRequest.decode(message.value);
  },

  toProto(message) {
    return EstimateSwapExactAmountInRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.poolmanager.v1beta1.EstimateSwapExactAmountInRequest",
      value: EstimateSwapExactAmountInRequest.encode(message).finish()
    };
  }

};

function createBaseEstimateSinglePoolSwapExactAmountInRequest() {
  return {
    poolId: _helpers__WEBPACK_IMPORTED_MODULE_8__/* .Long.UZERO */ .dK.UZERO,
    tokenIn: "",
    tokenOutDenom: ""
  };
}

const EstimateSinglePoolSwapExactAmountInRequest = {
  typeUrl: "/osmosis.poolmanager.v1beta1.EstimateSinglePoolSwapExactAmountInRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Writer.create()) {
    if (!message.poolId.isZero()) {
      writer.uint32(8).uint64(message.poolId);
    }

    if (message.tokenIn !== "") {
      writer.uint32(18).string(message.tokenIn);
    }

    if (message.tokenOutDenom !== "") {
      writer.uint32(26).string(message.tokenOutDenom);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEstimateSinglePoolSwapExactAmountInRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.poolId = reader.uint64();
          break;

        case 2:
          message.tokenIn = reader.string();
          break;

        case 3:
          message.tokenOutDenom = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$tokenIn2, _object$tokenOutDenom;

    const message = createBaseEstimateSinglePoolSwapExactAmountInRequest();
    message.poolId = object.poolId !== undefined && object.poolId !== null ? _helpers__WEBPACK_IMPORTED_MODULE_8__/* .Long.fromValue */ .dK.fromValue(object.poolId) : _helpers__WEBPACK_IMPORTED_MODULE_8__/* .Long.UZERO */ .dK.UZERO;
    message.tokenIn = (_object$tokenIn2 = object.tokenIn) !== null && _object$tokenIn2 !== void 0 ? _object$tokenIn2 : "";
    message.tokenOutDenom = (_object$tokenOutDenom = object.tokenOutDenom) !== null && _object$tokenOutDenom !== void 0 ? _object$tokenOutDenom : "";
    return message;
  },

  fromAmino(object) {
    return {
      poolId: _helpers__WEBPACK_IMPORTED_MODULE_8__/* .Long.fromString */ .dK.fromString(object.pool_id),
      tokenIn: object.token_in,
      tokenOutDenom: object.token_out_denom
    };
  },

  toAmino(message) {
    const obj = {};
    obj.pool_id = message.poolId ? message.poolId.toString() : undefined;
    obj.token_in = message.tokenIn;
    obj.token_out_denom = message.tokenOutDenom;
    return obj;
  },

  fromAminoMsg(object) {
    return EstimateSinglePoolSwapExactAmountInRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/poolmanager/estimate-single-pool-swap-exact-amount-in-request",
      value: EstimateSinglePoolSwapExactAmountInRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return EstimateSinglePoolSwapExactAmountInRequest.decode(message.value);
  },

  toProto(message) {
    return EstimateSinglePoolSwapExactAmountInRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.poolmanager.v1beta1.EstimateSinglePoolSwapExactAmountInRequest",
      value: EstimateSinglePoolSwapExactAmountInRequest.encode(message).finish()
    };
  }

};

function createBaseEstimateSwapExactAmountInResponse() {
  return {
    tokenOutAmount: ""
  };
}

const EstimateSwapExactAmountInResponse = {
  typeUrl: "/osmosis.poolmanager.v1beta1.EstimateSwapExactAmountInResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Writer.create()) {
    if (message.tokenOutAmount !== "") {
      writer.uint32(10).string(message.tokenOutAmount);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEstimateSwapExactAmountInResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.tokenOutAmount = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$tokenOutAmoun;

    const message = createBaseEstimateSwapExactAmountInResponse();
    message.tokenOutAmount = (_object$tokenOutAmoun = object.tokenOutAmount) !== null && _object$tokenOutAmoun !== void 0 ? _object$tokenOutAmoun : "";
    return message;
  },

  fromAmino(object) {
    return {
      tokenOutAmount: object.token_out_amount
    };
  },

  toAmino(message) {
    const obj = {};
    obj.token_out_amount = message.tokenOutAmount;
    return obj;
  },

  fromAminoMsg(object) {
    return EstimateSwapExactAmountInResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/poolmanager/estimate-swap-exact-amount-in-response",
      value: EstimateSwapExactAmountInResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return EstimateSwapExactAmountInResponse.decode(message.value);
  },

  toProto(message) {
    return EstimateSwapExactAmountInResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.poolmanager.v1beta1.EstimateSwapExactAmountInResponse",
      value: EstimateSwapExactAmountInResponse.encode(message).finish()
    };
  }

};

function createBaseEstimateSwapExactAmountOutRequest() {
  return {
    poolId: _helpers__WEBPACK_IMPORTED_MODULE_8__/* .Long.UZERO */ .dK.UZERO,
    routes: [],
    tokenOut: ""
  };
}

const EstimateSwapExactAmountOutRequest = {
  typeUrl: "/osmosis.poolmanager.v1beta1.EstimateSwapExactAmountOutRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Writer.create()) {
    if (!message.poolId.isZero()) {
      writer.uint32(16).uint64(message.poolId);
    }

    for (const v of message.routes) {
      _swap_route__WEBPACK_IMPORTED_MODULE_0__.SwapAmountOutRoute.encode(v, writer.uint32(26).fork()).ldelim();
    }

    if (message.tokenOut !== "") {
      writer.uint32(34).string(message.tokenOut);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEstimateSwapExactAmountOutRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 2:
          message.poolId = reader.uint64();
          break;

        case 3:
          message.routes.push(_swap_route__WEBPACK_IMPORTED_MODULE_0__.SwapAmountOutRoute.decode(reader, reader.uint32()));
          break;

        case 4:
          message.tokenOut = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$routes2, _object$tokenOut;

    const message = createBaseEstimateSwapExactAmountOutRequest();
    message.poolId = object.poolId !== undefined && object.poolId !== null ? _helpers__WEBPACK_IMPORTED_MODULE_8__/* .Long.fromValue */ .dK.fromValue(object.poolId) : _helpers__WEBPACK_IMPORTED_MODULE_8__/* .Long.UZERO */ .dK.UZERO;
    message.routes = ((_object$routes2 = object.routes) === null || _object$routes2 === void 0 ? void 0 : _object$routes2.map(e => _swap_route__WEBPACK_IMPORTED_MODULE_0__.SwapAmountOutRoute.fromPartial(e))) || [];
    message.tokenOut = (_object$tokenOut = object.tokenOut) !== null && _object$tokenOut !== void 0 ? _object$tokenOut : "";
    return message;
  },

  fromAmino(object) {
    return {
      poolId: _helpers__WEBPACK_IMPORTED_MODULE_8__/* .Long.fromString */ .dK.fromString(object.pool_id),
      routes: Array.isArray(object === null || object === void 0 ? void 0 : object.routes) ? object.routes.map(e => _swap_route__WEBPACK_IMPORTED_MODULE_0__.SwapAmountOutRoute.fromAmino(e)) : [],
      tokenOut: object.token_out
    };
  },

  toAmino(message) {
    const obj = {};
    obj.pool_id = message.poolId ? message.poolId.toString() : undefined;

    if (message.routes) {
      obj.routes = message.routes.map(e => e ? _swap_route__WEBPACK_IMPORTED_MODULE_0__.SwapAmountOutRoute.toAmino(e) : undefined);
    } else {
      obj.routes = [];
    }

    obj.token_out = message.tokenOut;
    return obj;
  },

  fromAminoMsg(object) {
    return EstimateSwapExactAmountOutRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/poolmanager/estimate-swap-exact-amount-out-request",
      value: EstimateSwapExactAmountOutRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return EstimateSwapExactAmountOutRequest.decode(message.value);
  },

  toProto(message) {
    return EstimateSwapExactAmountOutRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.poolmanager.v1beta1.EstimateSwapExactAmountOutRequest",
      value: EstimateSwapExactAmountOutRequest.encode(message).finish()
    };
  }

};

function createBaseEstimateSinglePoolSwapExactAmountOutRequest() {
  return {
    poolId: _helpers__WEBPACK_IMPORTED_MODULE_8__/* .Long.UZERO */ .dK.UZERO,
    tokenInDenom: "",
    tokenOut: ""
  };
}

const EstimateSinglePoolSwapExactAmountOutRequest = {
  typeUrl: "/osmosis.poolmanager.v1beta1.EstimateSinglePoolSwapExactAmountOutRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Writer.create()) {
    if (!message.poolId.isZero()) {
      writer.uint32(8).uint64(message.poolId);
    }

    if (message.tokenInDenom !== "") {
      writer.uint32(18).string(message.tokenInDenom);
    }

    if (message.tokenOut !== "") {
      writer.uint32(26).string(message.tokenOut);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEstimateSinglePoolSwapExactAmountOutRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.poolId = reader.uint64();
          break;

        case 2:
          message.tokenInDenom = reader.string();
          break;

        case 3:
          message.tokenOut = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$tokenInDenom, _object$tokenOut2;

    const message = createBaseEstimateSinglePoolSwapExactAmountOutRequest();
    message.poolId = object.poolId !== undefined && object.poolId !== null ? _helpers__WEBPACK_IMPORTED_MODULE_8__/* .Long.fromValue */ .dK.fromValue(object.poolId) : _helpers__WEBPACK_IMPORTED_MODULE_8__/* .Long.UZERO */ .dK.UZERO;
    message.tokenInDenom = (_object$tokenInDenom = object.tokenInDenom) !== null && _object$tokenInDenom !== void 0 ? _object$tokenInDenom : "";
    message.tokenOut = (_object$tokenOut2 = object.tokenOut) !== null && _object$tokenOut2 !== void 0 ? _object$tokenOut2 : "";
    return message;
  },

  fromAmino(object) {
    return {
      poolId: _helpers__WEBPACK_IMPORTED_MODULE_8__/* .Long.fromString */ .dK.fromString(object.pool_id),
      tokenInDenom: object.token_in_denom,
      tokenOut: object.token_out
    };
  },

  toAmino(message) {
    const obj = {};
    obj.pool_id = message.poolId ? message.poolId.toString() : undefined;
    obj.token_in_denom = message.tokenInDenom;
    obj.token_out = message.tokenOut;
    return obj;
  },

  fromAminoMsg(object) {
    return EstimateSinglePoolSwapExactAmountOutRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/poolmanager/estimate-single-pool-swap-exact-amount-out-request",
      value: EstimateSinglePoolSwapExactAmountOutRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return EstimateSinglePoolSwapExactAmountOutRequest.decode(message.value);
  },

  toProto(message) {
    return EstimateSinglePoolSwapExactAmountOutRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.poolmanager.v1beta1.EstimateSinglePoolSwapExactAmountOutRequest",
      value: EstimateSinglePoolSwapExactAmountOutRequest.encode(message).finish()
    };
  }

};

function createBaseEstimateSwapExactAmountOutResponse() {
  return {
    tokenInAmount: ""
  };
}

const EstimateSwapExactAmountOutResponse = {
  typeUrl: "/osmosis.poolmanager.v1beta1.EstimateSwapExactAmountOutResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Writer.create()) {
    if (message.tokenInAmount !== "") {
      writer.uint32(10).string(message.tokenInAmount);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEstimateSwapExactAmountOutResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.tokenInAmount = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$tokenInAmount;

    const message = createBaseEstimateSwapExactAmountOutResponse();
    message.tokenInAmount = (_object$tokenInAmount = object.tokenInAmount) !== null && _object$tokenInAmount !== void 0 ? _object$tokenInAmount : "";
    return message;
  },

  fromAmino(object) {
    return {
      tokenInAmount: object.token_in_amount
    };
  },

  toAmino(message) {
    const obj = {};
    obj.token_in_amount = message.tokenInAmount;
    return obj;
  },

  fromAminoMsg(object) {
    return EstimateSwapExactAmountOutResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/poolmanager/estimate-swap-exact-amount-out-response",
      value: EstimateSwapExactAmountOutResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return EstimateSwapExactAmountOutResponse.decode(message.value);
  },

  toProto(message) {
    return EstimateSwapExactAmountOutResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.poolmanager.v1beta1.EstimateSwapExactAmountOutResponse",
      value: EstimateSwapExactAmountOutResponse.encode(message).finish()
    };
  }

};

function createBaseNumPoolsRequest() {
  return {};
}

const NumPoolsRequest = {
  typeUrl: "/osmosis.poolmanager.v1beta1.NumPoolsRequest",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseNumPoolsRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseNumPoolsRequest();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return NumPoolsRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/poolmanager/num-pools-request",
      value: NumPoolsRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return NumPoolsRequest.decode(message.value);
  },

  toProto(message) {
    return NumPoolsRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.poolmanager.v1beta1.NumPoolsRequest",
      value: NumPoolsRequest.encode(message).finish()
    };
  }

};

function createBaseNumPoolsResponse() {
  return {
    numPools: _helpers__WEBPACK_IMPORTED_MODULE_8__/* .Long.UZERO */ .dK.UZERO
  };
}

const NumPoolsResponse = {
  typeUrl: "/osmosis.poolmanager.v1beta1.NumPoolsResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Writer.create()) {
    if (!message.numPools.isZero()) {
      writer.uint32(8).uint64(message.numPools);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseNumPoolsResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.numPools = reader.uint64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseNumPoolsResponse();
    message.numPools = object.numPools !== undefined && object.numPools !== null ? _helpers__WEBPACK_IMPORTED_MODULE_8__/* .Long.fromValue */ .dK.fromValue(object.numPools) : _helpers__WEBPACK_IMPORTED_MODULE_8__/* .Long.UZERO */ .dK.UZERO;
    return message;
  },

  fromAmino(object) {
    return {
      numPools: _helpers__WEBPACK_IMPORTED_MODULE_8__/* .Long.fromString */ .dK.fromString(object.num_pools)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.num_pools = message.numPools ? message.numPools.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return NumPoolsResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/poolmanager/num-pools-response",
      value: NumPoolsResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return NumPoolsResponse.decode(message.value);
  },

  toProto(message) {
    return NumPoolsResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.poolmanager.v1beta1.NumPoolsResponse",
      value: NumPoolsResponse.encode(message).finish()
    };
  }

};

function createBasePoolRequest() {
  return {
    poolId: _helpers__WEBPACK_IMPORTED_MODULE_8__/* .Long.UZERO */ .dK.UZERO
  };
}

const PoolRequest = {
  typeUrl: "/osmosis.poolmanager.v1beta1.PoolRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Writer.create()) {
    if (!message.poolId.isZero()) {
      writer.uint32(8).uint64(message.poolId);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePoolRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.poolId = reader.uint64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBasePoolRequest();
    message.poolId = object.poolId !== undefined && object.poolId !== null ? _helpers__WEBPACK_IMPORTED_MODULE_8__/* .Long.fromValue */ .dK.fromValue(object.poolId) : _helpers__WEBPACK_IMPORTED_MODULE_8__/* .Long.UZERO */ .dK.UZERO;
    return message;
  },

  fromAmino(object) {
    return {
      poolId: _helpers__WEBPACK_IMPORTED_MODULE_8__/* .Long.fromString */ .dK.fromString(object.pool_id)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.pool_id = message.poolId ? message.poolId.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return PoolRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/poolmanager/pool-request",
      value: PoolRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return PoolRequest.decode(message.value);
  },

  toProto(message) {
    return PoolRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.poolmanager.v1beta1.PoolRequest",
      value: PoolRequest.encode(message).finish()
    };
  }

};

function createBasePoolResponse() {
  return {
    pool: undefined
  };
}

const PoolResponse = {
  typeUrl: "/osmosis.poolmanager.v1beta1.PoolResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Writer.create()) {
    if (message.pool !== undefined) {
      _google_protobuf_any__WEBPACK_IMPORTED_MODULE_2__.Any.encode(message.pool, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePoolResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.pool = PoolI_InterfaceDecoder(reader);
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBasePoolResponse();
    message.pool = object.pool !== undefined && object.pool !== null ? _google_protobuf_any__WEBPACK_IMPORTED_MODULE_2__.Any.fromPartial(object.pool) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      pool: object !== null && object !== void 0 && object.pool ? PoolI_FromAmino(object.pool) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.pool = message.pool ? PoolI_ToAmino(message.pool) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return PoolResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/poolmanager/pool-response",
      value: PoolResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return PoolResponse.decode(message.value);
  },

  toProto(message) {
    return PoolResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.poolmanager.v1beta1.PoolResponse",
      value: PoolResponse.encode(message).finish()
    };
  }

};

function createBaseAllPoolsRequest() {
  return {};
}

const AllPoolsRequest = {
  typeUrl: "/osmosis.poolmanager.v1beta1.AllPoolsRequest",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAllPoolsRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseAllPoolsRequest();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return AllPoolsRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/poolmanager/all-pools-request",
      value: AllPoolsRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return AllPoolsRequest.decode(message.value);
  },

  toProto(message) {
    return AllPoolsRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.poolmanager.v1beta1.AllPoolsRequest",
      value: AllPoolsRequest.encode(message).finish()
    };
  }

};

function createBaseAllPoolsResponse() {
  return {
    pools: []
  };
}

const AllPoolsResponse = {
  typeUrl: "/osmosis.poolmanager.v1beta1.AllPoolsResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Writer.create()) {
    for (const v of message.pools) {
      _google_protobuf_any__WEBPACK_IMPORTED_MODULE_2__.Any.encode(v, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAllPoolsResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.pools.push(PoolI_InterfaceDecoder(reader));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$pools;

    const message = createBaseAllPoolsResponse();
    message.pools = ((_object$pools = object.pools) === null || _object$pools === void 0 ? void 0 : _object$pools.map(e => _google_protobuf_any__WEBPACK_IMPORTED_MODULE_2__.Any.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      pools: Array.isArray(object === null || object === void 0 ? void 0 : object.pools) ? object.pools.map(e => PoolI_FromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.pools) {
      obj.pools = message.pools.map(e => e ? PoolI_ToAmino(e) : undefined);
    } else {
      obj.pools = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return AllPoolsResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/poolmanager/all-pools-response",
      value: AllPoolsResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return AllPoolsResponse.decode(message.value);
  },

  toProto(message) {
    return AllPoolsResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.poolmanager.v1beta1.AllPoolsResponse",
      value: AllPoolsResponse.encode(message).finish()
    };
  }

};

function createBaseSpotPriceRequest() {
  return {
    poolId: _helpers__WEBPACK_IMPORTED_MODULE_8__/* .Long.UZERO */ .dK.UZERO,
    baseAssetDenom: "",
    quoteAssetDenom: ""
  };
}

const SpotPriceRequest = {
  typeUrl: "/osmosis.poolmanager.v1beta1.SpotPriceRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Writer.create()) {
    if (!message.poolId.isZero()) {
      writer.uint32(8).uint64(message.poolId);
    }

    if (message.baseAssetDenom !== "") {
      writer.uint32(18).string(message.baseAssetDenom);
    }

    if (message.quoteAssetDenom !== "") {
      writer.uint32(26).string(message.quoteAssetDenom);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSpotPriceRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.poolId = reader.uint64();
          break;

        case 2:
          message.baseAssetDenom = reader.string();
          break;

        case 3:
          message.quoteAssetDenom = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$baseAssetDeno, _object$quoteAssetDen;

    const message = createBaseSpotPriceRequest();
    message.poolId = object.poolId !== undefined && object.poolId !== null ? _helpers__WEBPACK_IMPORTED_MODULE_8__/* .Long.fromValue */ .dK.fromValue(object.poolId) : _helpers__WEBPACK_IMPORTED_MODULE_8__/* .Long.UZERO */ .dK.UZERO;
    message.baseAssetDenom = (_object$baseAssetDeno = object.baseAssetDenom) !== null && _object$baseAssetDeno !== void 0 ? _object$baseAssetDeno : "";
    message.quoteAssetDenom = (_object$quoteAssetDen = object.quoteAssetDenom) !== null && _object$quoteAssetDen !== void 0 ? _object$quoteAssetDen : "";
    return message;
  },

  fromAmino(object) {
    return {
      poolId: _helpers__WEBPACK_IMPORTED_MODULE_8__/* .Long.fromString */ .dK.fromString(object.pool_id),
      baseAssetDenom: object.base_asset_denom,
      quoteAssetDenom: object.quote_asset_denom
    };
  },

  toAmino(message) {
    const obj = {};
    obj.pool_id = message.poolId ? message.poolId.toString() : undefined;
    obj.base_asset_denom = message.baseAssetDenom;
    obj.quote_asset_denom = message.quoteAssetDenom;
    return obj;
  },

  fromAminoMsg(object) {
    return SpotPriceRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/poolmanager/spot-price-request",
      value: SpotPriceRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return SpotPriceRequest.decode(message.value);
  },

  toProto(message) {
    return SpotPriceRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.poolmanager.v1beta1.SpotPriceRequest",
      value: SpotPriceRequest.encode(message).finish()
    };
  }

};

function createBaseSpotPriceResponse() {
  return {
    spotPrice: ""
  };
}

const SpotPriceResponse = {
  typeUrl: "/osmosis.poolmanager.v1beta1.SpotPriceResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Writer.create()) {
    if (message.spotPrice !== "") {
      writer.uint32(10).string(message.spotPrice);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSpotPriceResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.spotPrice = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$spotPrice;

    const message = createBaseSpotPriceResponse();
    message.spotPrice = (_object$spotPrice = object.spotPrice) !== null && _object$spotPrice !== void 0 ? _object$spotPrice : "";
    return message;
  },

  fromAmino(object) {
    return {
      spotPrice: object.spot_price
    };
  },

  toAmino(message) {
    const obj = {};
    obj.spot_price = message.spotPrice;
    return obj;
  },

  fromAminoMsg(object) {
    return SpotPriceResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/poolmanager/spot-price-response",
      value: SpotPriceResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return SpotPriceResponse.decode(message.value);
  },

  toProto(message) {
    return SpotPriceResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.poolmanager.v1beta1.SpotPriceResponse",
      value: SpotPriceResponse.encode(message).finish()
    };
  }

};

function createBaseTotalPoolLiquidityRequest() {
  return {
    poolId: _helpers__WEBPACK_IMPORTED_MODULE_8__/* .Long.UZERO */ .dK.UZERO
  };
}

const TotalPoolLiquidityRequest = {
  typeUrl: "/osmosis.poolmanager.v1beta1.TotalPoolLiquidityRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Writer.create()) {
    if (!message.poolId.isZero()) {
      writer.uint32(8).uint64(message.poolId);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTotalPoolLiquidityRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.poolId = reader.uint64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseTotalPoolLiquidityRequest();
    message.poolId = object.poolId !== undefined && object.poolId !== null ? _helpers__WEBPACK_IMPORTED_MODULE_8__/* .Long.fromValue */ .dK.fromValue(object.poolId) : _helpers__WEBPACK_IMPORTED_MODULE_8__/* .Long.UZERO */ .dK.UZERO;
    return message;
  },

  fromAmino(object) {
    return {
      poolId: _helpers__WEBPACK_IMPORTED_MODULE_8__/* .Long.fromString */ .dK.fromString(object.pool_id)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.pool_id = message.poolId ? message.poolId.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return TotalPoolLiquidityRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/poolmanager/total-pool-liquidity-request",
      value: TotalPoolLiquidityRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return TotalPoolLiquidityRequest.decode(message.value);
  },

  toProto(message) {
    return TotalPoolLiquidityRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.poolmanager.v1beta1.TotalPoolLiquidityRequest",
      value: TotalPoolLiquidityRequest.encode(message).finish()
    };
  }

};

function createBaseTotalPoolLiquidityResponse() {
  return {
    liquidity: []
  };
}

const TotalPoolLiquidityResponse = {
  typeUrl: "/osmosis.poolmanager.v1beta1.TotalPoolLiquidityResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Writer.create()) {
    for (const v of message.liquidity) {
      _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_3__.Coin.encode(v, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTotalPoolLiquidityResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.liquidity.push(_cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_3__.Coin.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$liquidity;

    const message = createBaseTotalPoolLiquidityResponse();
    message.liquidity = ((_object$liquidity = object.liquidity) === null || _object$liquidity === void 0 ? void 0 : _object$liquidity.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_3__.Coin.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      liquidity: Array.isArray(object === null || object === void 0 ? void 0 : object.liquidity) ? object.liquidity.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_3__.Coin.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.liquidity) {
      obj.liquidity = message.liquidity.map(e => e ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_3__.Coin.toAmino(e) : undefined);
    } else {
      obj.liquidity = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return TotalPoolLiquidityResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/poolmanager/total-pool-liquidity-response",
      value: TotalPoolLiquidityResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return TotalPoolLiquidityResponse.decode(message.value);
  },

  toProto(message) {
    return TotalPoolLiquidityResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.poolmanager.v1beta1.TotalPoolLiquidityResponse",
      value: TotalPoolLiquidityResponse.encode(message).finish()
    };
  }

};
const PoolI_InterfaceDecoder = input => {
  const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_9__.Reader(input);
  const data = _google_protobuf_any__WEBPACK_IMPORTED_MODULE_2__.Any.decode(reader, reader.uint32());

  switch (data.typeUrl) {
    case "/osmosis.concentratedliquidity.v1beta1.Pool":
      return _concentrated_liquidity_pool__WEBPACK_IMPORTED_MODULE_4__/* .Pool.decode */ .K.decode(data.value);

    case "/osmosis.cosmwasmpool.v1beta1.CosmWasmPool":
      return _cosmwasmpool_v1beta1_model_pool__WEBPACK_IMPORTED_MODULE_5__.CosmWasmPool.decode(data.value);

    case "/osmosis.gamm.v1beta1.Pool":
      return _gamm_pool_models_balancer_balancerPool__WEBPACK_IMPORTED_MODULE_6__.Pool.decode(data.value);

    case "/osmosis.gamm.poolmodels.stableswap.v1beta1.Pool":
      return _gamm_pool_models_stableswap_stableswap_pool__WEBPACK_IMPORTED_MODULE_7__.Pool.decode(data.value);

    default:
      return data;
  }
};
const PoolI_FromAmino = content => {
  switch (content.type) {
    case "osmosis/concentratedliquidity/pool":
      return _google_protobuf_any__WEBPACK_IMPORTED_MODULE_2__.Any.fromPartial({
        typeUrl: "/osmosis.concentratedliquidity.v1beta1.Pool",
        value: _concentrated_liquidity_pool__WEBPACK_IMPORTED_MODULE_4__/* .Pool.encode */ .K.encode(_concentrated_liquidity_pool__WEBPACK_IMPORTED_MODULE_4__/* .Pool.fromPartial */ .K.fromPartial(_concentrated_liquidity_pool__WEBPACK_IMPORTED_MODULE_4__/* .Pool.fromAmino */ .K.fromAmino(content.value))).finish()
      });

    case "osmosis/cosmwasmpool/cosm-wasm-pool":
      return _google_protobuf_any__WEBPACK_IMPORTED_MODULE_2__.Any.fromPartial({
        typeUrl: "/osmosis.cosmwasmpool.v1beta1.CosmWasmPool",
        value: _cosmwasmpool_v1beta1_model_pool__WEBPACK_IMPORTED_MODULE_5__.CosmWasmPool.encode(_cosmwasmpool_v1beta1_model_pool__WEBPACK_IMPORTED_MODULE_5__.CosmWasmPool.fromPartial(_cosmwasmpool_v1beta1_model_pool__WEBPACK_IMPORTED_MODULE_5__.CosmWasmPool.fromAmino(content.value))).finish()
      });

    case "osmosis/gamm/BalancerPool":
      return _google_protobuf_any__WEBPACK_IMPORTED_MODULE_2__.Any.fromPartial({
        typeUrl: "/osmosis.gamm.v1beta1.Pool",
        value: _gamm_pool_models_balancer_balancerPool__WEBPACK_IMPORTED_MODULE_6__.Pool.encode(_gamm_pool_models_balancer_balancerPool__WEBPACK_IMPORTED_MODULE_6__.Pool.fromPartial(_gamm_pool_models_balancer_balancerPool__WEBPACK_IMPORTED_MODULE_6__.Pool.fromAmino(content.value))).finish()
      });

    case "osmosis/gamm/StableswapPool":
      return _google_protobuf_any__WEBPACK_IMPORTED_MODULE_2__.Any.fromPartial({
        typeUrl: "/osmosis.gamm.poolmodels.stableswap.v1beta1.Pool",
        value: _gamm_pool_models_stableswap_stableswap_pool__WEBPACK_IMPORTED_MODULE_7__.Pool.encode(_gamm_pool_models_stableswap_stableswap_pool__WEBPACK_IMPORTED_MODULE_7__.Pool.fromPartial(_gamm_pool_models_stableswap_stableswap_pool__WEBPACK_IMPORTED_MODULE_7__.Pool.fromAmino(content.value))).finish()
      });

    default:
      return _google_protobuf_any__WEBPACK_IMPORTED_MODULE_2__.Any.fromAmino(content);
  }
};
const PoolI_ToAmino = content => {
  switch (content.typeUrl) {
    case "/osmosis.concentratedliquidity.v1beta1.Pool":
      return {
        type: "osmosis/concentratedliquidity/pool",
        value: _concentrated_liquidity_pool__WEBPACK_IMPORTED_MODULE_4__/* .Pool.toAmino */ .K.toAmino(_concentrated_liquidity_pool__WEBPACK_IMPORTED_MODULE_4__/* .Pool.decode */ .K.decode(content.value))
      };

    case "/osmosis.cosmwasmpool.v1beta1.CosmWasmPool":
      return {
        type: "osmosis/cosmwasmpool/cosm-wasm-pool",
        value: _cosmwasmpool_v1beta1_model_pool__WEBPACK_IMPORTED_MODULE_5__.CosmWasmPool.toAmino(_cosmwasmpool_v1beta1_model_pool__WEBPACK_IMPORTED_MODULE_5__.CosmWasmPool.decode(content.value))
      };

    case "/osmosis.gamm.v1beta1.Pool":
      return {
        type: "osmosis/gamm/BalancerPool",
        value: _gamm_pool_models_balancer_balancerPool__WEBPACK_IMPORTED_MODULE_6__.Pool.toAmino(_gamm_pool_models_balancer_balancerPool__WEBPACK_IMPORTED_MODULE_6__.Pool.decode(content.value))
      };

    case "/osmosis.gamm.poolmodels.stableswap.v1beta1.Pool":
      return {
        type: "osmosis/gamm/StableswapPool",
        value: _gamm_pool_models_stableswap_stableswap_pool__WEBPACK_IMPORTED_MODULE_7__.Pool.toAmino(_gamm_pool_models_stableswap_stableswap_pool__WEBPACK_IMPORTED_MODULE_7__.Pool.decode(content.value))
      };

    default:
      return _google_protobuf_any__WEBPACK_IMPORTED_MODULE_2__.Any.toAmino(content);
  }
};

/***/ }),

/***/ 19909:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LCDQueryClient": function() { return /* binding */ LCDQueryClient; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4942);

class LCDQueryClient {
  constructor({
    requestClient
  }) {
    (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, "req", void 0);

    this.req = requestClient;
    this.params = this.params.bind(this);
    this.estimateSwapExactAmountIn = this.estimateSwapExactAmountIn.bind(this);
    this.estimateSinglePoolSwapExactAmountIn = this.estimateSinglePoolSwapExactAmountIn.bind(this);
    this.estimateSwapExactAmountOut = this.estimateSwapExactAmountOut.bind(this);
    this.estimateSinglePoolSwapExactAmountOut = this.estimateSinglePoolSwapExactAmountOut.bind(this);
    this.numPools = this.numPools.bind(this);
    this.pool = this.pool.bind(this);
    this.allPools = this.allPools.bind(this);
    this.spotPrice = this.spotPrice.bind(this);
    this.totalPoolLiquidity = this.totalPoolLiquidity.bind(this);
  }
  /* Params */


  async params(_params = {}) {
    const endpoint = `osmosis/poolmanager/v1beta1/Params`;
    return await this.req.get(endpoint);
  }
  /* Estimates swap amount out given in. */


  async estimateSwapExactAmountIn(params) {
    const options = {
      params: {}
    };

    if (typeof (params === null || params === void 0 ? void 0 : params.tokenIn) !== "undefined") {
      options.params.token_in = params.tokenIn;
    }

    if (typeof (params === null || params === void 0 ? void 0 : params.routes) !== "undefined") {
      options.params.routes = params.routes;
    }

    const endpoint = `osmosis/poolmanager/v1beta1/${params.poolId}/estimate/swap_exact_amount_in`;
    return await this.req.get(endpoint, options);
  }
  /* EstimateSinglePoolSwapExactAmountIn */


  async estimateSinglePoolSwapExactAmountIn(params) {
    const options = {
      params: {}
    };

    if (typeof (params === null || params === void 0 ? void 0 : params.tokenIn) !== "undefined") {
      options.params.token_in = params.tokenIn;
    }

    if (typeof (params === null || params === void 0 ? void 0 : params.tokenOutDenom) !== "undefined") {
      options.params.token_out_denom = params.tokenOutDenom;
    }

    const endpoint = `osmosis/poolmanager/v1beta1/${params.poolId}/estimate/single_pool_swap_exact_amount_in`;
    return await this.req.get(endpoint, options);
  }
  /* Estimates swap amount in given out. */


  async estimateSwapExactAmountOut(params) {
    const options = {
      params: {}
    };

    if (typeof (params === null || params === void 0 ? void 0 : params.routes) !== "undefined") {
      options.params.routes = params.routes;
    }

    if (typeof (params === null || params === void 0 ? void 0 : params.tokenOut) !== "undefined") {
      options.params.token_out = params.tokenOut;
    }

    const endpoint = `osmosis/poolmanager/v1beta1/${params.poolId}/estimate/swap_exact_amount_out`;
    return await this.req.get(endpoint, options);
  }
  /* EstimateSinglePoolSwapExactAmountOut */


  async estimateSinglePoolSwapExactAmountOut(params) {
    const options = {
      params: {}
    };

    if (typeof (params === null || params === void 0 ? void 0 : params.tokenInDenom) !== "undefined") {
      options.params.token_in_denom = params.tokenInDenom;
    }

    if (typeof (params === null || params === void 0 ? void 0 : params.tokenOut) !== "undefined") {
      options.params.token_out = params.tokenOut;
    }

    const endpoint = `osmosis/poolmanager/v1beta1/${params.poolId}/estimate_out/single_pool_swap_exact_amount_out`;
    return await this.req.get(endpoint, options);
  }
  /* Returns the total number of pools existing in Osmosis. */


  async numPools(_params = {}) {
    const endpoint = `osmosis/poolmanager/v1beta1/num_pools`;
    return await this.req.get(endpoint);
  }
  /* Pool returns the Pool specified by the pool id */


  async pool(params) {
    const endpoint = `osmosis/poolmanager/v1beta1/pools/${params.poolId}`;
    return await this.req.get(endpoint);
  }
  /* AllPools returns all pools on the Osmosis chain sorted by IDs. */


  async allPools(_params = {}) {
    const endpoint = `osmosis/poolmanager/v1beta1/all-pools`;
    return await this.req.get(endpoint);
  }
  /* SpotPrice defines a gRPC query handler that returns the spot price given
   a base denomination and a quote denomination. */


  async spotPrice(params) {
    const options = {
      params: {}
    };

    if (typeof (params === null || params === void 0 ? void 0 : params.baseAssetDenom) !== "undefined") {
      options.params.base_asset_denom = params.baseAssetDenom;
    }

    if (typeof (params === null || params === void 0 ? void 0 : params.quoteAssetDenom) !== "undefined") {
      options.params.quote_asset_denom = params.quoteAssetDenom;
    }

    const endpoint = `osmosis/poolmanager/pools/${params.poolId}/prices`;
    return await this.req.get(endpoint, options);
  }
  /* TotalPoolLiquidity */


  async totalPoolLiquidity(params) {
    const endpoint = `osmosis/poolmanager/v1beta1/pools/${params.poolId}/total_pool_liquidity`;
    return await this.req.get(endpoint);
  }

}

/***/ }),

/***/ 58373:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QueryClientImpl": function() { return /* binding */ QueryClientImpl; },
/* harmony export */   "createRpcQueryExtension": function() { return /* binding */ createRpcQueryExtension; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4942);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78441);
/* harmony import */ var _cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38569);




class QueryClientImpl {
  constructor(rpc) {
    (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, "rpc", void 0);

    this.rpc = rpc;
    this.params = this.params.bind(this);
    this.estimateSwapExactAmountIn = this.estimateSwapExactAmountIn.bind(this);
    this.estimateSinglePoolSwapExactAmountIn = this.estimateSinglePoolSwapExactAmountIn.bind(this);
    this.estimateSwapExactAmountOut = this.estimateSwapExactAmountOut.bind(this);
    this.estimateSinglePoolSwapExactAmountOut = this.estimateSinglePoolSwapExactAmountOut.bind(this);
    this.numPools = this.numPools.bind(this);
    this.pool = this.pool.bind(this);
    this.allPools = this.allPools.bind(this);
    this.spotPrice = this.spotPrice.bind(this);
    this.totalPoolLiquidity = this.totalPoolLiquidity.bind(this);
  }

  params(request = {}) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.ParamsRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.poolmanager.v1beta1.Query", "Params", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.ParamsResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  estimateSwapExactAmountIn(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.EstimateSwapExactAmountInRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.poolmanager.v1beta1.Query", "EstimateSwapExactAmountIn", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.EstimateSwapExactAmountInResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  estimateSinglePoolSwapExactAmountIn(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.EstimateSinglePoolSwapExactAmountInRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.poolmanager.v1beta1.Query", "EstimateSinglePoolSwapExactAmountIn", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.EstimateSwapExactAmountInResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  estimateSwapExactAmountOut(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.EstimateSwapExactAmountOutRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.poolmanager.v1beta1.Query", "EstimateSwapExactAmountOut", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.EstimateSwapExactAmountOutResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  estimateSinglePoolSwapExactAmountOut(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.EstimateSinglePoolSwapExactAmountOutRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.poolmanager.v1beta1.Query", "EstimateSinglePoolSwapExactAmountOut", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.EstimateSwapExactAmountOutResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  numPools(request = {}) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.NumPoolsRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.poolmanager.v1beta1.Query", "NumPools", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.NumPoolsResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  pool(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.PoolRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.poolmanager.v1beta1.Query", "Pool", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.PoolResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  allPools(request = {}) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.AllPoolsRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.poolmanager.v1beta1.Query", "AllPools", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.AllPoolsResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  spotPrice(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.SpotPriceRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.poolmanager.v1beta1.Query", "SpotPrice", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.SpotPriceResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  totalPoolLiquidity(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.TotalPoolLiquidityRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.poolmanager.v1beta1.Query", "TotalPoolLiquidity", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.TotalPoolLiquidityResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

}
const createRpcQueryExtension = base => {
  const rpc = (0,_cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1__.createProtobufRpcClient)(base);
  const queryService = new QueryClientImpl(rpc);
  return {
    params(request) {
      return queryService.params(request);
    },

    estimateSwapExactAmountIn(request) {
      return queryService.estimateSwapExactAmountIn(request);
    },

    estimateSinglePoolSwapExactAmountIn(request) {
      return queryService.estimateSinglePoolSwapExactAmountIn(request);
    },

    estimateSwapExactAmountOut(request) {
      return queryService.estimateSwapExactAmountOut(request);
    },

    estimateSinglePoolSwapExactAmountOut(request) {
      return queryService.estimateSinglePoolSwapExactAmountOut(request);
    },

    numPools(request) {
      return queryService.numPools(request);
    },

    pool(request) {
      return queryService.pool(request);
    },

    allPools(request) {
      return queryService.allPools(request);
    },

    spotPrice(request) {
      return queryService.spotPrice(request);
    },

    totalPoolLiquidity(request) {
      return queryService.totalPoolLiquidity(request);
    }

  };
};

/***/ }),

/***/ 23569:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SwapAmountInRoute": function() { return /* binding */ SwapAmountInRoute; },
/* harmony export */   "SwapAmountInSplitRoute": function() { return /* binding */ SwapAmountInSplitRoute; },
/* harmony export */   "SwapAmountOutRoute": function() { return /* binding */ SwapAmountOutRoute; },
/* harmony export */   "SwapAmountOutSplitRoute": function() { return /* binding */ SwapAmountOutSplitRoute; }
/* harmony export */ });
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47895);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__);



function createBaseSwapAmountInRoute() {
  return {
    poolId: _helpers__WEBPACK_IMPORTED_MODULE_0__/* .Long.UZERO */ .dK.UZERO,
    tokenOutDenom: ""
  };
}

const SwapAmountInRoute = {
  typeUrl: "/osmosis.poolmanager.v1beta1.SwapAmountInRoute",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Writer.create()) {
    if (!message.poolId.isZero()) {
      writer.uint32(8).uint64(message.poolId);
    }

    if (message.tokenOutDenom !== "") {
      writer.uint32(18).string(message.tokenOutDenom);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSwapAmountInRoute();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.poolId = reader.uint64();
          break;

        case 2:
          message.tokenOutDenom = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$tokenOutDenom;

    const message = createBaseSwapAmountInRoute();
    message.poolId = object.poolId !== undefined && object.poolId !== null ? _helpers__WEBPACK_IMPORTED_MODULE_0__/* .Long.fromValue */ .dK.fromValue(object.poolId) : _helpers__WEBPACK_IMPORTED_MODULE_0__/* .Long.UZERO */ .dK.UZERO;
    message.tokenOutDenom = (_object$tokenOutDenom = object.tokenOutDenom) !== null && _object$tokenOutDenom !== void 0 ? _object$tokenOutDenom : "";
    return message;
  },

  fromAmino(object) {
    return {
      poolId: _helpers__WEBPACK_IMPORTED_MODULE_0__/* .Long.fromString */ .dK.fromString(object.pool_id),
      tokenOutDenom: object.token_out_denom
    };
  },

  toAmino(message) {
    const obj = {};
    obj.pool_id = message.poolId ? message.poolId.toString() : undefined;
    obj.token_out_denom = message.tokenOutDenom;
    return obj;
  },

  fromAminoMsg(object) {
    return SwapAmountInRoute.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/poolmanager/swap-amount-in-route",
      value: SwapAmountInRoute.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return SwapAmountInRoute.decode(message.value);
  },

  toProto(message) {
    return SwapAmountInRoute.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.poolmanager.v1beta1.SwapAmountInRoute",
      value: SwapAmountInRoute.encode(message).finish()
    };
  }

};

function createBaseSwapAmountOutRoute() {
  return {
    poolId: _helpers__WEBPACK_IMPORTED_MODULE_0__/* .Long.UZERO */ .dK.UZERO,
    tokenInDenom: ""
  };
}

const SwapAmountOutRoute = {
  typeUrl: "/osmosis.poolmanager.v1beta1.SwapAmountOutRoute",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Writer.create()) {
    if (!message.poolId.isZero()) {
      writer.uint32(8).uint64(message.poolId);
    }

    if (message.tokenInDenom !== "") {
      writer.uint32(18).string(message.tokenInDenom);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSwapAmountOutRoute();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.poolId = reader.uint64();
          break;

        case 2:
          message.tokenInDenom = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$tokenInDenom;

    const message = createBaseSwapAmountOutRoute();
    message.poolId = object.poolId !== undefined && object.poolId !== null ? _helpers__WEBPACK_IMPORTED_MODULE_0__/* .Long.fromValue */ .dK.fromValue(object.poolId) : _helpers__WEBPACK_IMPORTED_MODULE_0__/* .Long.UZERO */ .dK.UZERO;
    message.tokenInDenom = (_object$tokenInDenom = object.tokenInDenom) !== null && _object$tokenInDenom !== void 0 ? _object$tokenInDenom : "";
    return message;
  },

  fromAmino(object) {
    return {
      poolId: _helpers__WEBPACK_IMPORTED_MODULE_0__/* .Long.fromString */ .dK.fromString(object.pool_id),
      tokenInDenom: object.token_in_denom
    };
  },

  toAmino(message) {
    const obj = {};
    obj.pool_id = message.poolId ? message.poolId.toString() : undefined;
    obj.token_in_denom = message.tokenInDenom;
    return obj;
  },

  fromAminoMsg(object) {
    return SwapAmountOutRoute.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/poolmanager/swap-amount-out-route",
      value: SwapAmountOutRoute.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return SwapAmountOutRoute.decode(message.value);
  },

  toProto(message) {
    return SwapAmountOutRoute.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.poolmanager.v1beta1.SwapAmountOutRoute",
      value: SwapAmountOutRoute.encode(message).finish()
    };
  }

};

function createBaseSwapAmountInSplitRoute() {
  return {
    pools: [],
    tokenInAmount: ""
  };
}

const SwapAmountInSplitRoute = {
  typeUrl: "/osmosis.poolmanager.v1beta1.SwapAmountInSplitRoute",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Writer.create()) {
    for (const v of message.pools) {
      SwapAmountInRoute.encode(v, writer.uint32(10).fork()).ldelim();
    }

    if (message.tokenInAmount !== "") {
      writer.uint32(18).string(message.tokenInAmount);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSwapAmountInSplitRoute();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.pools.push(SwapAmountInRoute.decode(reader, reader.uint32()));
          break;

        case 2:
          message.tokenInAmount = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$pools, _object$tokenInAmount;

    const message = createBaseSwapAmountInSplitRoute();
    message.pools = ((_object$pools = object.pools) === null || _object$pools === void 0 ? void 0 : _object$pools.map(e => SwapAmountInRoute.fromPartial(e))) || [];
    message.tokenInAmount = (_object$tokenInAmount = object.tokenInAmount) !== null && _object$tokenInAmount !== void 0 ? _object$tokenInAmount : "";
    return message;
  },

  fromAmino(object) {
    return {
      pools: Array.isArray(object === null || object === void 0 ? void 0 : object.pools) ? object.pools.map(e => SwapAmountInRoute.fromAmino(e)) : [],
      tokenInAmount: object.token_in_amount
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.pools) {
      obj.pools = message.pools.map(e => e ? SwapAmountInRoute.toAmino(e) : undefined);
    } else {
      obj.pools = [];
    }

    obj.token_in_amount = message.tokenInAmount;
    return obj;
  },

  fromAminoMsg(object) {
    return SwapAmountInSplitRoute.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/poolmanager/swap-amount-in-split-route",
      value: SwapAmountInSplitRoute.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return SwapAmountInSplitRoute.decode(message.value);
  },

  toProto(message) {
    return SwapAmountInSplitRoute.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.poolmanager.v1beta1.SwapAmountInSplitRoute",
      value: SwapAmountInSplitRoute.encode(message).finish()
    };
  }

};

function createBaseSwapAmountOutSplitRoute() {
  return {
    pools: [],
    tokenOutAmount: ""
  };
}

const SwapAmountOutSplitRoute = {
  typeUrl: "/osmosis.poolmanager.v1beta1.SwapAmountOutSplitRoute",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Writer.create()) {
    for (const v of message.pools) {
      SwapAmountOutRoute.encode(v, writer.uint32(10).fork()).ldelim();
    }

    if (message.tokenOutAmount !== "") {
      writer.uint32(18).string(message.tokenOutAmount);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSwapAmountOutSplitRoute();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.pools.push(SwapAmountOutRoute.decode(reader, reader.uint32()));
          break;

        case 2:
          message.tokenOutAmount = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$pools2, _object$tokenOutAmoun;

    const message = createBaseSwapAmountOutSplitRoute();
    message.pools = ((_object$pools2 = object.pools) === null || _object$pools2 === void 0 ? void 0 : _object$pools2.map(e => SwapAmountOutRoute.fromPartial(e))) || [];
    message.tokenOutAmount = (_object$tokenOutAmoun = object.tokenOutAmount) !== null && _object$tokenOutAmoun !== void 0 ? _object$tokenOutAmoun : "";
    return message;
  },

  fromAmino(object) {
    return {
      pools: Array.isArray(object === null || object === void 0 ? void 0 : object.pools) ? object.pools.map(e => SwapAmountOutRoute.fromAmino(e)) : [],
      tokenOutAmount: object.token_out_amount
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.pools) {
      obj.pools = message.pools.map(e => e ? SwapAmountOutRoute.toAmino(e) : undefined);
    } else {
      obj.pools = [];
    }

    obj.token_out_amount = message.tokenOutAmount;
    return obj;
  },

  fromAminoMsg(object) {
    return SwapAmountOutSplitRoute.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/poolmanager/swap-amount-out-split-route",
      value: SwapAmountOutSplitRoute.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return SwapAmountOutSplitRoute.decode(message.value);
  },

  toProto(message) {
    return SwapAmountOutSplitRoute.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.poolmanager.v1beta1.SwapAmountOutSplitRoute",
      value: SwapAmountOutSplitRoute.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 2824:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MsgSplitRouteSwapExactAmountIn": function() { return /* binding */ MsgSplitRouteSwapExactAmountIn; },
/* harmony export */   "MsgSplitRouteSwapExactAmountInResponse": function() { return /* binding */ MsgSplitRouteSwapExactAmountInResponse; },
/* harmony export */   "MsgSplitRouteSwapExactAmountOut": function() { return /* binding */ MsgSplitRouteSwapExactAmountOut; },
/* harmony export */   "MsgSplitRouteSwapExactAmountOutResponse": function() { return /* binding */ MsgSplitRouteSwapExactAmountOutResponse; },
/* harmony export */   "MsgSwapExactAmountIn": function() { return /* binding */ MsgSwapExactAmountIn; },
/* harmony export */   "MsgSwapExactAmountInResponse": function() { return /* binding */ MsgSwapExactAmountInResponse; },
/* harmony export */   "MsgSwapExactAmountOut": function() { return /* binding */ MsgSwapExactAmountOut; },
/* harmony export */   "MsgSwapExactAmountOutResponse": function() { return /* binding */ MsgSwapExactAmountOutResponse; }
/* harmony export */ });
/* harmony import */ var _swap_route__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23569);
/* harmony import */ var _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26178);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__);



/** ===================== MsgSwapExactAmountIn */

function createBaseMsgSwapExactAmountIn() {
  return {
    sender: "",
    routes: [],
    tokenIn: undefined,
    tokenOutMinAmount: ""
  };
}

const MsgSwapExactAmountIn = {
  typeUrl: "/osmosis.poolmanager.v1beta1.MsgSwapExactAmountIn",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (message.sender !== "") {
      writer.uint32(10).string(message.sender);
    }

    for (const v of message.routes) {
      _swap_route__WEBPACK_IMPORTED_MODULE_0__.SwapAmountInRoute.encode(v, writer.uint32(18).fork()).ldelim();
    }

    if (message.tokenIn !== undefined) {
      _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.encode(message.tokenIn, writer.uint32(26).fork()).ldelim();
    }

    if (message.tokenOutMinAmount !== "") {
      writer.uint32(34).string(message.tokenOutMinAmount);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgSwapExactAmountIn();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.sender = reader.string();
          break;

        case 2:
          message.routes.push(_swap_route__WEBPACK_IMPORTED_MODULE_0__.SwapAmountInRoute.decode(reader, reader.uint32()));
          break;

        case 3:
          message.tokenIn = _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.decode(reader, reader.uint32());
          break;

        case 4:
          message.tokenOutMinAmount = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$sender, _object$routes, _object$tokenOutMinAm;

    const message = createBaseMsgSwapExactAmountIn();
    message.sender = (_object$sender = object.sender) !== null && _object$sender !== void 0 ? _object$sender : "";
    message.routes = ((_object$routes = object.routes) === null || _object$routes === void 0 ? void 0 : _object$routes.map(e => _swap_route__WEBPACK_IMPORTED_MODULE_0__.SwapAmountInRoute.fromPartial(e))) || [];
    message.tokenIn = object.tokenIn !== undefined && object.tokenIn !== null ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.fromPartial(object.tokenIn) : undefined;
    message.tokenOutMinAmount = (_object$tokenOutMinAm = object.tokenOutMinAmount) !== null && _object$tokenOutMinAm !== void 0 ? _object$tokenOutMinAm : "";
    return message;
  },

  fromAmino(object) {
    return {
      sender: object.sender,
      routes: Array.isArray(object === null || object === void 0 ? void 0 : object.routes) ? object.routes.map(e => _swap_route__WEBPACK_IMPORTED_MODULE_0__.SwapAmountInRoute.fromAmino(e)) : [],
      tokenIn: object !== null && object !== void 0 && object.token_in ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.fromAmino(object.token_in) : undefined,
      tokenOutMinAmount: object.token_out_min_amount
    };
  },

  toAmino(message) {
    const obj = {};
    obj.sender = message.sender;

    if (message.routes) {
      obj.routes = message.routes.map(e => e ? _swap_route__WEBPACK_IMPORTED_MODULE_0__.SwapAmountInRoute.toAmino(e) : undefined);
    } else {
      obj.routes = [];
    }

    obj.token_in = message.tokenIn ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.toAmino(message.tokenIn) : undefined;
    obj.token_out_min_amount = message.tokenOutMinAmount;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgSwapExactAmountIn.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/poolmanager/swap-exact-amount-in",
      value: MsgSwapExactAmountIn.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgSwapExactAmountIn.decode(message.value);
  },

  toProto(message) {
    return MsgSwapExactAmountIn.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.poolmanager.v1beta1.MsgSwapExactAmountIn",
      value: MsgSwapExactAmountIn.encode(message).finish()
    };
  }

};

function createBaseMsgSwapExactAmountInResponse() {
  return {
    tokenOutAmount: ""
  };
}

const MsgSwapExactAmountInResponse = {
  typeUrl: "/osmosis.poolmanager.v1beta1.MsgSwapExactAmountInResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (message.tokenOutAmount !== "") {
      writer.uint32(10).string(message.tokenOutAmount);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgSwapExactAmountInResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.tokenOutAmount = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$tokenOutAmoun;

    const message = createBaseMsgSwapExactAmountInResponse();
    message.tokenOutAmount = (_object$tokenOutAmoun = object.tokenOutAmount) !== null && _object$tokenOutAmoun !== void 0 ? _object$tokenOutAmoun : "";
    return message;
  },

  fromAmino(object) {
    return {
      tokenOutAmount: object.token_out_amount
    };
  },

  toAmino(message) {
    const obj = {};
    obj.token_out_amount = message.tokenOutAmount;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgSwapExactAmountInResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/poolmanager/swap-exact-amount-in-response",
      value: MsgSwapExactAmountInResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgSwapExactAmountInResponse.decode(message.value);
  },

  toProto(message) {
    return MsgSwapExactAmountInResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.poolmanager.v1beta1.MsgSwapExactAmountInResponse",
      value: MsgSwapExactAmountInResponse.encode(message).finish()
    };
  }

};

function createBaseMsgSplitRouteSwapExactAmountIn() {
  return {
    sender: "",
    routes: [],
    tokenInDenom: "",
    tokenOutMinAmount: ""
  };
}

const MsgSplitRouteSwapExactAmountIn = {
  typeUrl: "/osmosis.poolmanager.v1beta1.MsgSplitRouteSwapExactAmountIn",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (message.sender !== "") {
      writer.uint32(10).string(message.sender);
    }

    for (const v of message.routes) {
      _swap_route__WEBPACK_IMPORTED_MODULE_0__.SwapAmountInSplitRoute.encode(v, writer.uint32(18).fork()).ldelim();
    }

    if (message.tokenInDenom !== "") {
      writer.uint32(26).string(message.tokenInDenom);
    }

    if (message.tokenOutMinAmount !== "") {
      writer.uint32(34).string(message.tokenOutMinAmount);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgSplitRouteSwapExactAmountIn();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.sender = reader.string();
          break;

        case 2:
          message.routes.push(_swap_route__WEBPACK_IMPORTED_MODULE_0__.SwapAmountInSplitRoute.decode(reader, reader.uint32()));
          break;

        case 3:
          message.tokenInDenom = reader.string();
          break;

        case 4:
          message.tokenOutMinAmount = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$sender2, _object$routes2, _object$tokenInDenom, _object$tokenOutMinAm2;

    const message = createBaseMsgSplitRouteSwapExactAmountIn();
    message.sender = (_object$sender2 = object.sender) !== null && _object$sender2 !== void 0 ? _object$sender2 : "";
    message.routes = ((_object$routes2 = object.routes) === null || _object$routes2 === void 0 ? void 0 : _object$routes2.map(e => _swap_route__WEBPACK_IMPORTED_MODULE_0__.SwapAmountInSplitRoute.fromPartial(e))) || [];
    message.tokenInDenom = (_object$tokenInDenom = object.tokenInDenom) !== null && _object$tokenInDenom !== void 0 ? _object$tokenInDenom : "";
    message.tokenOutMinAmount = (_object$tokenOutMinAm2 = object.tokenOutMinAmount) !== null && _object$tokenOutMinAm2 !== void 0 ? _object$tokenOutMinAm2 : "";
    return message;
  },

  fromAmino(object) {
    return {
      sender: object.sender,
      routes: Array.isArray(object === null || object === void 0 ? void 0 : object.routes) ? object.routes.map(e => _swap_route__WEBPACK_IMPORTED_MODULE_0__.SwapAmountInSplitRoute.fromAmino(e)) : [],
      tokenInDenom: object.token_in_denom,
      tokenOutMinAmount: object.token_out_min_amount
    };
  },

  toAmino(message) {
    const obj = {};
    obj.sender = message.sender;

    if (message.routes) {
      obj.routes = message.routes.map(e => e ? _swap_route__WEBPACK_IMPORTED_MODULE_0__.SwapAmountInSplitRoute.toAmino(e) : undefined);
    } else {
      obj.routes = [];
    }

    obj.token_in_denom = message.tokenInDenom;
    obj.token_out_min_amount = message.tokenOutMinAmount;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgSplitRouteSwapExactAmountIn.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/poolmanager/split-route-swap-exact-amount-in",
      value: MsgSplitRouteSwapExactAmountIn.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgSplitRouteSwapExactAmountIn.decode(message.value);
  },

  toProto(message) {
    return MsgSplitRouteSwapExactAmountIn.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.poolmanager.v1beta1.MsgSplitRouteSwapExactAmountIn",
      value: MsgSplitRouteSwapExactAmountIn.encode(message).finish()
    };
  }

};

function createBaseMsgSplitRouteSwapExactAmountInResponse() {
  return {
    tokenOutAmount: ""
  };
}

const MsgSplitRouteSwapExactAmountInResponse = {
  typeUrl: "/osmosis.poolmanager.v1beta1.MsgSplitRouteSwapExactAmountInResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (message.tokenOutAmount !== "") {
      writer.uint32(10).string(message.tokenOutAmount);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgSplitRouteSwapExactAmountInResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.tokenOutAmount = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$tokenOutAmoun2;

    const message = createBaseMsgSplitRouteSwapExactAmountInResponse();
    message.tokenOutAmount = (_object$tokenOutAmoun2 = object.tokenOutAmount) !== null && _object$tokenOutAmoun2 !== void 0 ? _object$tokenOutAmoun2 : "";
    return message;
  },

  fromAmino(object) {
    return {
      tokenOutAmount: object.token_out_amount
    };
  },

  toAmino(message) {
    const obj = {};
    obj.token_out_amount = message.tokenOutAmount;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgSplitRouteSwapExactAmountInResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/poolmanager/split-route-swap-exact-amount-in-response",
      value: MsgSplitRouteSwapExactAmountInResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgSplitRouteSwapExactAmountInResponse.decode(message.value);
  },

  toProto(message) {
    return MsgSplitRouteSwapExactAmountInResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.poolmanager.v1beta1.MsgSplitRouteSwapExactAmountInResponse",
      value: MsgSplitRouteSwapExactAmountInResponse.encode(message).finish()
    };
  }

};

function createBaseMsgSwapExactAmountOut() {
  return {
    sender: "",
    routes: [],
    tokenInMaxAmount: "",
    tokenOut: undefined
  };
}

const MsgSwapExactAmountOut = {
  typeUrl: "/osmosis.poolmanager.v1beta1.MsgSwapExactAmountOut",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (message.sender !== "") {
      writer.uint32(10).string(message.sender);
    }

    for (const v of message.routes) {
      _swap_route__WEBPACK_IMPORTED_MODULE_0__.SwapAmountOutRoute.encode(v, writer.uint32(18).fork()).ldelim();
    }

    if (message.tokenInMaxAmount !== "") {
      writer.uint32(26).string(message.tokenInMaxAmount);
    }

    if (message.tokenOut !== undefined) {
      _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.encode(message.tokenOut, writer.uint32(34).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgSwapExactAmountOut();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.sender = reader.string();
          break;

        case 2:
          message.routes.push(_swap_route__WEBPACK_IMPORTED_MODULE_0__.SwapAmountOutRoute.decode(reader, reader.uint32()));
          break;

        case 3:
          message.tokenInMaxAmount = reader.string();
          break;

        case 4:
          message.tokenOut = _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$sender3, _object$routes3, _object$tokenInMaxAmo;

    const message = createBaseMsgSwapExactAmountOut();
    message.sender = (_object$sender3 = object.sender) !== null && _object$sender3 !== void 0 ? _object$sender3 : "";
    message.routes = ((_object$routes3 = object.routes) === null || _object$routes3 === void 0 ? void 0 : _object$routes3.map(e => _swap_route__WEBPACK_IMPORTED_MODULE_0__.SwapAmountOutRoute.fromPartial(e))) || [];
    message.tokenInMaxAmount = (_object$tokenInMaxAmo = object.tokenInMaxAmount) !== null && _object$tokenInMaxAmo !== void 0 ? _object$tokenInMaxAmo : "";
    message.tokenOut = object.tokenOut !== undefined && object.tokenOut !== null ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.fromPartial(object.tokenOut) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      sender: object.sender,
      routes: Array.isArray(object === null || object === void 0 ? void 0 : object.routes) ? object.routes.map(e => _swap_route__WEBPACK_IMPORTED_MODULE_0__.SwapAmountOutRoute.fromAmino(e)) : [],
      tokenInMaxAmount: object.token_in_max_amount,
      tokenOut: object !== null && object !== void 0 && object.token_out ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.fromAmino(object.token_out) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.sender = message.sender;

    if (message.routes) {
      obj.routes = message.routes.map(e => e ? _swap_route__WEBPACK_IMPORTED_MODULE_0__.SwapAmountOutRoute.toAmino(e) : undefined);
    } else {
      obj.routes = [];
    }

    obj.token_in_max_amount = message.tokenInMaxAmount;
    obj.token_out = message.tokenOut ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.toAmino(message.tokenOut) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgSwapExactAmountOut.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/poolmanager/swap-exact-amount-out",
      value: MsgSwapExactAmountOut.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgSwapExactAmountOut.decode(message.value);
  },

  toProto(message) {
    return MsgSwapExactAmountOut.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.poolmanager.v1beta1.MsgSwapExactAmountOut",
      value: MsgSwapExactAmountOut.encode(message).finish()
    };
  }

};

function createBaseMsgSwapExactAmountOutResponse() {
  return {
    tokenInAmount: ""
  };
}

const MsgSwapExactAmountOutResponse = {
  typeUrl: "/osmosis.poolmanager.v1beta1.MsgSwapExactAmountOutResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (message.tokenInAmount !== "") {
      writer.uint32(10).string(message.tokenInAmount);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgSwapExactAmountOutResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.tokenInAmount = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$tokenInAmount;

    const message = createBaseMsgSwapExactAmountOutResponse();
    message.tokenInAmount = (_object$tokenInAmount = object.tokenInAmount) !== null && _object$tokenInAmount !== void 0 ? _object$tokenInAmount : "";
    return message;
  },

  fromAmino(object) {
    return {
      tokenInAmount: object.token_in_amount
    };
  },

  toAmino(message) {
    const obj = {};
    obj.token_in_amount = message.tokenInAmount;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgSwapExactAmountOutResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/poolmanager/swap-exact-amount-out-response",
      value: MsgSwapExactAmountOutResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgSwapExactAmountOutResponse.decode(message.value);
  },

  toProto(message) {
    return MsgSwapExactAmountOutResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.poolmanager.v1beta1.MsgSwapExactAmountOutResponse",
      value: MsgSwapExactAmountOutResponse.encode(message).finish()
    };
  }

};

function createBaseMsgSplitRouteSwapExactAmountOut() {
  return {
    sender: "",
    routes: [],
    tokenOutDenom: "",
    tokenInMaxAmount: ""
  };
}

const MsgSplitRouteSwapExactAmountOut = {
  typeUrl: "/osmosis.poolmanager.v1beta1.MsgSplitRouteSwapExactAmountOut",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (message.sender !== "") {
      writer.uint32(10).string(message.sender);
    }

    for (const v of message.routes) {
      _swap_route__WEBPACK_IMPORTED_MODULE_0__.SwapAmountOutSplitRoute.encode(v, writer.uint32(18).fork()).ldelim();
    }

    if (message.tokenOutDenom !== "") {
      writer.uint32(26).string(message.tokenOutDenom);
    }

    if (message.tokenInMaxAmount !== "") {
      writer.uint32(34).string(message.tokenInMaxAmount);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgSplitRouteSwapExactAmountOut();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.sender = reader.string();
          break;

        case 2:
          message.routes.push(_swap_route__WEBPACK_IMPORTED_MODULE_0__.SwapAmountOutSplitRoute.decode(reader, reader.uint32()));
          break;

        case 3:
          message.tokenOutDenom = reader.string();
          break;

        case 4:
          message.tokenInMaxAmount = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$sender4, _object$routes4, _object$tokenOutDenom, _object$tokenInMaxAmo2;

    const message = createBaseMsgSplitRouteSwapExactAmountOut();
    message.sender = (_object$sender4 = object.sender) !== null && _object$sender4 !== void 0 ? _object$sender4 : "";
    message.routes = ((_object$routes4 = object.routes) === null || _object$routes4 === void 0 ? void 0 : _object$routes4.map(e => _swap_route__WEBPACK_IMPORTED_MODULE_0__.SwapAmountOutSplitRoute.fromPartial(e))) || [];
    message.tokenOutDenom = (_object$tokenOutDenom = object.tokenOutDenom) !== null && _object$tokenOutDenom !== void 0 ? _object$tokenOutDenom : "";
    message.tokenInMaxAmount = (_object$tokenInMaxAmo2 = object.tokenInMaxAmount) !== null && _object$tokenInMaxAmo2 !== void 0 ? _object$tokenInMaxAmo2 : "";
    return message;
  },

  fromAmino(object) {
    return {
      sender: object.sender,
      routes: Array.isArray(object === null || object === void 0 ? void 0 : object.routes) ? object.routes.map(e => _swap_route__WEBPACK_IMPORTED_MODULE_0__.SwapAmountOutSplitRoute.fromAmino(e)) : [],
      tokenOutDenom: object.token_out_denom,
      tokenInMaxAmount: object.token_in_max_amount
    };
  },

  toAmino(message) {
    const obj = {};
    obj.sender = message.sender;

    if (message.routes) {
      obj.routes = message.routes.map(e => e ? _swap_route__WEBPACK_IMPORTED_MODULE_0__.SwapAmountOutSplitRoute.toAmino(e) : undefined);
    } else {
      obj.routes = [];
    }

    obj.token_out_denom = message.tokenOutDenom;
    obj.token_in_max_amount = message.tokenInMaxAmount;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgSplitRouteSwapExactAmountOut.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/poolmanager/split-route-swap-exact-amount-out",
      value: MsgSplitRouteSwapExactAmountOut.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgSplitRouteSwapExactAmountOut.decode(message.value);
  },

  toProto(message) {
    return MsgSplitRouteSwapExactAmountOut.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.poolmanager.v1beta1.MsgSplitRouteSwapExactAmountOut",
      value: MsgSplitRouteSwapExactAmountOut.encode(message).finish()
    };
  }

};

function createBaseMsgSplitRouteSwapExactAmountOutResponse() {
  return {
    tokenInAmount: ""
  };
}

const MsgSplitRouteSwapExactAmountOutResponse = {
  typeUrl: "/osmosis.poolmanager.v1beta1.MsgSplitRouteSwapExactAmountOutResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (message.tokenInAmount !== "") {
      writer.uint32(10).string(message.tokenInAmount);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgSplitRouteSwapExactAmountOutResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.tokenInAmount = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$tokenInAmount2;

    const message = createBaseMsgSplitRouteSwapExactAmountOutResponse();
    message.tokenInAmount = (_object$tokenInAmount2 = object.tokenInAmount) !== null && _object$tokenInAmount2 !== void 0 ? _object$tokenInAmount2 : "";
    return message;
  },

  fromAmino(object) {
    return {
      tokenInAmount: object.token_in_amount
    };
  },

  toAmino(message) {
    const obj = {};
    obj.token_in_amount = message.tokenInAmount;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgSplitRouteSwapExactAmountOutResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/poolmanager/split-route-swap-exact-amount-out-response",
      value: MsgSplitRouteSwapExactAmountOutResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgSplitRouteSwapExactAmountOutResponse.decode(message.value);
  },

  toProto(message) {
    return MsgSplitRouteSwapExactAmountOutResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.poolmanager.v1beta1.MsgSplitRouteSwapExactAmountOutResponse",
      value: MsgSplitRouteSwapExactAmountOutResponse.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 71571:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MsgClientImpl": function() { return /* binding */ MsgClientImpl; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4942);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _tx__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2824);



class MsgClientImpl {
  constructor(rpc) {
    (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, "rpc", void 0);

    this.rpc = rpc;
    this.swapExactAmountIn = this.swapExactAmountIn.bind(this);
    this.swapExactAmountOut = this.swapExactAmountOut.bind(this);
    this.splitRouteSwapExactAmountIn = this.splitRouteSwapExactAmountIn.bind(this);
    this.splitRouteSwapExactAmountOut = this.splitRouteSwapExactAmountOut.bind(this);
  }

  swapExactAmountIn(request) {
    const data = _tx__WEBPACK_IMPORTED_MODULE_1__.MsgSwapExactAmountIn.encode(request).finish();
    const promise = this.rpc.request("osmosis.poolmanager.v1beta1.Msg", "SwapExactAmountIn", data);
    return promise.then(data => _tx__WEBPACK_IMPORTED_MODULE_1__.MsgSwapExactAmountInResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  swapExactAmountOut(request) {
    const data = _tx__WEBPACK_IMPORTED_MODULE_1__.MsgSwapExactAmountOut.encode(request).finish();
    const promise = this.rpc.request("osmosis.poolmanager.v1beta1.Msg", "SwapExactAmountOut", data);
    return promise.then(data => _tx__WEBPACK_IMPORTED_MODULE_1__.MsgSwapExactAmountOutResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  splitRouteSwapExactAmountIn(request) {
    const data = _tx__WEBPACK_IMPORTED_MODULE_1__.MsgSplitRouteSwapExactAmountIn.encode(request).finish();
    const promise = this.rpc.request("osmosis.poolmanager.v1beta1.Msg", "SplitRouteSwapExactAmountIn", data);
    return promise.then(data => _tx__WEBPACK_IMPORTED_MODULE_1__.MsgSplitRouteSwapExactAmountInResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  splitRouteSwapExactAmountOut(request) {
    const data = _tx__WEBPACK_IMPORTED_MODULE_1__.MsgSplitRouteSwapExactAmountOut.encode(request).finish();
    const promise = this.rpc.request("osmosis.poolmanager.v1beta1.Msg", "SplitRouteSwapExactAmountOut", data);
    return promise.then(data => _tx__WEBPACK_IMPORTED_MODULE_1__.MsgSplitRouteSwapExactAmountOutResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

}

/***/ }),

/***/ 91051:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Params": function() { return /* binding */ Params; }
/* harmony export */ });
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__);

/** Params defines the parameters for the module. */

function createBaseParams() {
  return {
    enabled: false,
    admin: ""
  };
}

const Params = {
  typeUrl: "/osmosis.protorev.v1beta1.Params",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Writer.create()) {
    if (message.enabled === true) {
      writer.uint32(8).bool(message.enabled);
    }

    if (message.admin !== "") {
      writer.uint32(18).string(message.admin);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseParams();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.enabled = reader.bool();
          break;

        case 2:
          message.admin = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$enabled, _object$admin;

    const message = createBaseParams();
    message.enabled = (_object$enabled = object.enabled) !== null && _object$enabled !== void 0 ? _object$enabled : false;
    message.admin = (_object$admin = object.admin) !== null && _object$admin !== void 0 ? _object$admin : "";
    return message;
  },

  fromAmino(object) {
    return {
      enabled: object.enabled,
      admin: object.admin
    };
  },

  toAmino(message) {
    const obj = {};
    obj.enabled = message.enabled;
    obj.admin = message.admin;
    return obj;
  },

  fromAminoMsg(object) {
    return Params.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/protorev/params",
      value: Params.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return Params.decode(message.value);
  },

  toProto(message) {
    return Params.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.protorev.v1beta1.Params",
      value: Params.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 10673:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BaseDenom": function() { return /* binding */ BaseDenom; },
/* harmony export */   "PoolWeights": function() { return /* binding */ PoolWeights; },
/* harmony export */   "Route": function() { return /* binding */ Route; },
/* harmony export */   "RouteStatistics": function() { return /* binding */ RouteStatistics; },
/* harmony export */   "TokenPairArbRoutes": function() { return /* binding */ TokenPairArbRoutes; },
/* harmony export */   "Trade": function() { return /* binding */ Trade; }
/* harmony export */ });
/* harmony import */ var _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26178);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47895);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__);



/** TokenPairArbRoutes tracks all of the hot routes for a given pair of tokens */

function createBaseTokenPairArbRoutes() {
  return {
    arbRoutes: [],
    tokenIn: "",
    tokenOut: ""
  };
}

const TokenPairArbRoutes = {
  typeUrl: "/osmosis.protorev.v1beta1.TokenPairArbRoutes",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    for (const v of message.arbRoutes) {
      Route.encode(v, writer.uint32(10).fork()).ldelim();
    }

    if (message.tokenIn !== "") {
      writer.uint32(18).string(message.tokenIn);
    }

    if (message.tokenOut !== "") {
      writer.uint32(26).string(message.tokenOut);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTokenPairArbRoutes();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.arbRoutes.push(Route.decode(reader, reader.uint32()));
          break;

        case 2:
          message.tokenIn = reader.string();
          break;

        case 3:
          message.tokenOut = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$arbRoutes, _object$tokenIn, _object$tokenOut;

    const message = createBaseTokenPairArbRoutes();
    message.arbRoutes = ((_object$arbRoutes = object.arbRoutes) === null || _object$arbRoutes === void 0 ? void 0 : _object$arbRoutes.map(e => Route.fromPartial(e))) || [];
    message.tokenIn = (_object$tokenIn = object.tokenIn) !== null && _object$tokenIn !== void 0 ? _object$tokenIn : "";
    message.tokenOut = (_object$tokenOut = object.tokenOut) !== null && _object$tokenOut !== void 0 ? _object$tokenOut : "";
    return message;
  },

  fromAmino(object) {
    return {
      arbRoutes: Array.isArray(object === null || object === void 0 ? void 0 : object.arb_routes) ? object.arb_routes.map(e => Route.fromAmino(e)) : [],
      tokenIn: object.token_in,
      tokenOut: object.token_out
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.arbRoutes) {
      obj.arb_routes = message.arbRoutes.map(e => e ? Route.toAmino(e) : undefined);
    } else {
      obj.arb_routes = [];
    }

    obj.token_in = message.tokenIn;
    obj.token_out = message.tokenOut;
    return obj;
  },

  fromAminoMsg(object) {
    return TokenPairArbRoutes.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/protorev/token-pair-arb-routes",
      value: TokenPairArbRoutes.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return TokenPairArbRoutes.decode(message.value);
  },

  toProto(message) {
    return TokenPairArbRoutes.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.protorev.v1beta1.TokenPairArbRoutes",
      value: TokenPairArbRoutes.encode(message).finish()
    };
  }

};

function createBaseRoute() {
  return {
    trades: [],
    stepSize: ""
  };
}

const Route = {
  typeUrl: "/osmosis.protorev.v1beta1.Route",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    for (const v of message.trades) {
      Trade.encode(v, writer.uint32(10).fork()).ldelim();
    }

    if (message.stepSize !== "") {
      writer.uint32(18).string(message.stepSize);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRoute();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.trades.push(Trade.decode(reader, reader.uint32()));
          break;

        case 2:
          message.stepSize = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$trades, _object$stepSize;

    const message = createBaseRoute();
    message.trades = ((_object$trades = object.trades) === null || _object$trades === void 0 ? void 0 : _object$trades.map(e => Trade.fromPartial(e))) || [];
    message.stepSize = (_object$stepSize = object.stepSize) !== null && _object$stepSize !== void 0 ? _object$stepSize : "";
    return message;
  },

  fromAmino(object) {
    return {
      trades: Array.isArray(object === null || object === void 0 ? void 0 : object.trades) ? object.trades.map(e => Trade.fromAmino(e)) : [],
      stepSize: object.step_size
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.trades) {
      obj.trades = message.trades.map(e => e ? Trade.toAmino(e) : undefined);
    } else {
      obj.trades = [];
    }

    obj.step_size = message.stepSize;
    return obj;
  },

  fromAminoMsg(object) {
    return Route.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/protorev/route",
      value: Route.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return Route.decode(message.value);
  },

  toProto(message) {
    return Route.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.protorev.v1beta1.Route",
      value: Route.encode(message).finish()
    };
  }

};

function createBaseTrade() {
  return {
    pool: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.UZERO */ .dK.UZERO,
    tokenIn: "",
    tokenOut: ""
  };
}

const Trade = {
  typeUrl: "/osmosis.protorev.v1beta1.Trade",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (!message.pool.isZero()) {
      writer.uint32(8).uint64(message.pool);
    }

    if (message.tokenIn !== "") {
      writer.uint32(18).string(message.tokenIn);
    }

    if (message.tokenOut !== "") {
      writer.uint32(26).string(message.tokenOut);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTrade();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.pool = reader.uint64();
          break;

        case 2:
          message.tokenIn = reader.string();
          break;

        case 3:
          message.tokenOut = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$tokenIn2, _object$tokenOut2;

    const message = createBaseTrade();
    message.pool = object.pool !== undefined && object.pool !== null ? _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromValue */ .dK.fromValue(object.pool) : _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.UZERO */ .dK.UZERO;
    message.tokenIn = (_object$tokenIn2 = object.tokenIn) !== null && _object$tokenIn2 !== void 0 ? _object$tokenIn2 : "";
    message.tokenOut = (_object$tokenOut2 = object.tokenOut) !== null && _object$tokenOut2 !== void 0 ? _object$tokenOut2 : "";
    return message;
  },

  fromAmino(object) {
    return {
      pool: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromString */ .dK.fromString(object.pool),
      tokenIn: object.token_in,
      tokenOut: object.token_out
    };
  },

  toAmino(message) {
    const obj = {};
    obj.pool = message.pool ? message.pool.toString() : undefined;
    obj.token_in = message.tokenIn;
    obj.token_out = message.tokenOut;
    return obj;
  },

  fromAminoMsg(object) {
    return Trade.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/protorev/trade",
      value: Trade.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return Trade.decode(message.value);
  },

  toProto(message) {
    return Trade.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.protorev.v1beta1.Trade",
      value: Trade.encode(message).finish()
    };
  }

};

function createBaseRouteStatistics() {
  return {
    profits: [],
    numberOfTrades: "",
    route: []
  };
}

const RouteStatistics = {
  typeUrl: "/osmosis.protorev.v1beta1.RouteStatistics",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    for (const v of message.profits) {
      _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.encode(v, writer.uint32(10).fork()).ldelim();
    }

    if (message.numberOfTrades !== "") {
      writer.uint32(18).string(message.numberOfTrades);
    }

    writer.uint32(26).fork();

    for (const v of message.route) {
      writer.uint64(v);
    }

    writer.ldelim();
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRouteStatistics();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.profits.push(_cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.decode(reader, reader.uint32()));
          break;

        case 2:
          message.numberOfTrades = reader.string();
          break;

        case 3:
          if ((tag & 7) === 2) {
            const end2 = reader.uint32() + reader.pos;

            while (reader.pos < end2) {
              message.route.push(reader.uint64());
            }
          } else {
            message.route.push(reader.uint64());
          }

          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$profits, _object$numberOfTrade, _object$route;

    const message = createBaseRouteStatistics();
    message.profits = ((_object$profits = object.profits) === null || _object$profits === void 0 ? void 0 : _object$profits.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.fromPartial(e))) || [];
    message.numberOfTrades = (_object$numberOfTrade = object.numberOfTrades) !== null && _object$numberOfTrade !== void 0 ? _object$numberOfTrade : "";
    message.route = ((_object$route = object.route) === null || _object$route === void 0 ? void 0 : _object$route.map(e => _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromValue */ .dK.fromValue(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      profits: Array.isArray(object === null || object === void 0 ? void 0 : object.profits) ? object.profits.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.fromAmino(e)) : [],
      numberOfTrades: object.number_of_trades,
      route: Array.isArray(object === null || object === void 0 ? void 0 : object.route) ? object.route.map(e => e) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.profits) {
      obj.profits = message.profits.map(e => e ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.toAmino(e) : undefined);
    } else {
      obj.profits = [];
    }

    obj.number_of_trades = message.numberOfTrades;

    if (message.route) {
      obj.route = message.route.map(e => e);
    } else {
      obj.route = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return RouteStatistics.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/protorev/route-statistics",
      value: RouteStatistics.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return RouteStatistics.decode(message.value);
  },

  toProto(message) {
    return RouteStatistics.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.protorev.v1beta1.RouteStatistics",
      value: RouteStatistics.encode(message).finish()
    };
  }

};

function createBasePoolWeights() {
  return {
    stableWeight: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.UZERO */ .dK.UZERO,
    balancerWeight: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.UZERO */ .dK.UZERO,
    concentratedWeight: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.UZERO */ .dK.UZERO
  };
}

const PoolWeights = {
  typeUrl: "/osmosis.protorev.v1beta1.PoolWeights",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (!message.stableWeight.isZero()) {
      writer.uint32(8).uint64(message.stableWeight);
    }

    if (!message.balancerWeight.isZero()) {
      writer.uint32(16).uint64(message.balancerWeight);
    }

    if (!message.concentratedWeight.isZero()) {
      writer.uint32(24).uint64(message.concentratedWeight);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePoolWeights();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.stableWeight = reader.uint64();
          break;

        case 2:
          message.balancerWeight = reader.uint64();
          break;

        case 3:
          message.concentratedWeight = reader.uint64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBasePoolWeights();
    message.stableWeight = object.stableWeight !== undefined && object.stableWeight !== null ? _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromValue */ .dK.fromValue(object.stableWeight) : _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.UZERO */ .dK.UZERO;
    message.balancerWeight = object.balancerWeight !== undefined && object.balancerWeight !== null ? _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromValue */ .dK.fromValue(object.balancerWeight) : _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.UZERO */ .dK.UZERO;
    message.concentratedWeight = object.concentratedWeight !== undefined && object.concentratedWeight !== null ? _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromValue */ .dK.fromValue(object.concentratedWeight) : _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.UZERO */ .dK.UZERO;
    return message;
  },

  fromAmino(object) {
    return {
      stableWeight: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromString */ .dK.fromString(object.stable_weight),
      balancerWeight: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromString */ .dK.fromString(object.balancer_weight),
      concentratedWeight: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromString */ .dK.fromString(object.concentrated_weight)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.stable_weight = message.stableWeight ? message.stableWeight.toString() : undefined;
    obj.balancer_weight = message.balancerWeight ? message.balancerWeight.toString() : undefined;
    obj.concentrated_weight = message.concentratedWeight ? message.concentratedWeight.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return PoolWeights.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/protorev/pool-weights",
      value: PoolWeights.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return PoolWeights.decode(message.value);
  },

  toProto(message) {
    return PoolWeights.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.protorev.v1beta1.PoolWeights",
      value: PoolWeights.encode(message).finish()
    };
  }

};

function createBaseBaseDenom() {
  return {
    denom: "",
    stepSize: ""
  };
}

const BaseDenom = {
  typeUrl: "/osmosis.protorev.v1beta1.BaseDenom",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (message.denom !== "") {
      writer.uint32(10).string(message.denom);
    }

    if (message.stepSize !== "") {
      writer.uint32(18).string(message.stepSize);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBaseDenom();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.denom = reader.string();
          break;

        case 2:
          message.stepSize = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$denom, _object$stepSize2;

    const message = createBaseBaseDenom();
    message.denom = (_object$denom = object.denom) !== null && _object$denom !== void 0 ? _object$denom : "";
    message.stepSize = (_object$stepSize2 = object.stepSize) !== null && _object$stepSize2 !== void 0 ? _object$stepSize2 : "";
    return message;
  },

  fromAmino(object) {
    return {
      denom: object.denom,
      stepSize: object.step_size
    };
  },

  toAmino(message) {
    const obj = {};
    obj.denom = message.denom;
    obj.step_size = message.stepSize;
    return obj;
  },

  fromAminoMsg(object) {
    return BaseDenom.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/protorev/base-denom",
      value: BaseDenom.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return BaseDenom.decode(message.value);
  },

  toProto(message) {
    return BaseDenom.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.protorev.v1beta1.BaseDenom",
      value: BaseDenom.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 82594:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QueryGetProtoRevAdminAccountRequest": function() { return /* binding */ QueryGetProtoRevAdminAccountRequest; },
/* harmony export */   "QueryGetProtoRevAdminAccountResponse": function() { return /* binding */ QueryGetProtoRevAdminAccountResponse; },
/* harmony export */   "QueryGetProtoRevAllProfitsRequest": function() { return /* binding */ QueryGetProtoRevAllProfitsRequest; },
/* harmony export */   "QueryGetProtoRevAllProfitsResponse": function() { return /* binding */ QueryGetProtoRevAllProfitsResponse; },
/* harmony export */   "QueryGetProtoRevAllRouteStatisticsRequest": function() { return /* binding */ QueryGetProtoRevAllRouteStatisticsRequest; },
/* harmony export */   "QueryGetProtoRevAllRouteStatisticsResponse": function() { return /* binding */ QueryGetProtoRevAllRouteStatisticsResponse; },
/* harmony export */   "QueryGetProtoRevBaseDenomsRequest": function() { return /* binding */ QueryGetProtoRevBaseDenomsRequest; },
/* harmony export */   "QueryGetProtoRevBaseDenomsResponse": function() { return /* binding */ QueryGetProtoRevBaseDenomsResponse; },
/* harmony export */   "QueryGetProtoRevDeveloperAccountRequest": function() { return /* binding */ QueryGetProtoRevDeveloperAccountRequest; },
/* harmony export */   "QueryGetProtoRevDeveloperAccountResponse": function() { return /* binding */ QueryGetProtoRevDeveloperAccountResponse; },
/* harmony export */   "QueryGetProtoRevEnabledRequest": function() { return /* binding */ QueryGetProtoRevEnabledRequest; },
/* harmony export */   "QueryGetProtoRevEnabledResponse": function() { return /* binding */ QueryGetProtoRevEnabledResponse; },
/* harmony export */   "QueryGetProtoRevMaxPoolPointsPerBlockRequest": function() { return /* binding */ QueryGetProtoRevMaxPoolPointsPerBlockRequest; },
/* harmony export */   "QueryGetProtoRevMaxPoolPointsPerBlockResponse": function() { return /* binding */ QueryGetProtoRevMaxPoolPointsPerBlockResponse; },
/* harmony export */   "QueryGetProtoRevMaxPoolPointsPerTxRequest": function() { return /* binding */ QueryGetProtoRevMaxPoolPointsPerTxRequest; },
/* harmony export */   "QueryGetProtoRevMaxPoolPointsPerTxResponse": function() { return /* binding */ QueryGetProtoRevMaxPoolPointsPerTxResponse; },
/* harmony export */   "QueryGetProtoRevNumberOfTradesRequest": function() { return /* binding */ QueryGetProtoRevNumberOfTradesRequest; },
/* harmony export */   "QueryGetProtoRevNumberOfTradesResponse": function() { return /* binding */ QueryGetProtoRevNumberOfTradesResponse; },
/* harmony export */   "QueryGetProtoRevPoolRequest": function() { return /* binding */ QueryGetProtoRevPoolRequest; },
/* harmony export */   "QueryGetProtoRevPoolResponse": function() { return /* binding */ QueryGetProtoRevPoolResponse; },
/* harmony export */   "QueryGetProtoRevPoolWeightsRequest": function() { return /* binding */ QueryGetProtoRevPoolWeightsRequest; },
/* harmony export */   "QueryGetProtoRevPoolWeightsResponse": function() { return /* binding */ QueryGetProtoRevPoolWeightsResponse; },
/* harmony export */   "QueryGetProtoRevProfitsByDenomRequest": function() { return /* binding */ QueryGetProtoRevProfitsByDenomRequest; },
/* harmony export */   "QueryGetProtoRevProfitsByDenomResponse": function() { return /* binding */ QueryGetProtoRevProfitsByDenomResponse; },
/* harmony export */   "QueryGetProtoRevStatisticsByRouteRequest": function() { return /* binding */ QueryGetProtoRevStatisticsByRouteRequest; },
/* harmony export */   "QueryGetProtoRevStatisticsByRouteResponse": function() { return /* binding */ QueryGetProtoRevStatisticsByRouteResponse; },
/* harmony export */   "QueryGetProtoRevTokenPairArbRoutesRequest": function() { return /* binding */ QueryGetProtoRevTokenPairArbRoutesRequest; },
/* harmony export */   "QueryGetProtoRevTokenPairArbRoutesResponse": function() { return /* binding */ QueryGetProtoRevTokenPairArbRoutesResponse; },
/* harmony export */   "QueryParamsRequest": function() { return /* binding */ QueryParamsRequest; },
/* harmony export */   "QueryParamsResponse": function() { return /* binding */ QueryParamsResponse; }
/* harmony export */ });
/* harmony import */ var _params__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91051);
/* harmony import */ var _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26178);
/* harmony import */ var _protorev__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10673);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47895);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__);





/** QueryParamsRequest is request type for the Query/Params RPC method. */

function createBaseQueryParamsRequest() {
  return {};
}

const QueryParamsRequest = {
  typeUrl: "/osmosis.protorev.v1beta1.QueryParamsRequest",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryParamsRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseQueryParamsRequest();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return QueryParamsRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/protorev/query-params-request",
      value: QueryParamsRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryParamsRequest.decode(message.value);
  },

  toProto(message) {
    return QueryParamsRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.protorev.v1beta1.QueryParamsRequest",
      value: QueryParamsRequest.encode(message).finish()
    };
  }

};

function createBaseQueryParamsResponse() {
  return {
    params: undefined
  };
}

const QueryParamsResponse = {
  typeUrl: "/osmosis.protorev.v1beta1.QueryParamsResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    if (message.params !== undefined) {
      _params__WEBPACK_IMPORTED_MODULE_0__.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryParamsResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.params = _params__WEBPACK_IMPORTED_MODULE_0__.Params.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseQueryParamsResponse();
    message.params = object.params !== undefined && object.params !== null ? _params__WEBPACK_IMPORTED_MODULE_0__.Params.fromPartial(object.params) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      params: object !== null && object !== void 0 && object.params ? _params__WEBPACK_IMPORTED_MODULE_0__.Params.fromAmino(object.params) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.params = message.params ? _params__WEBPACK_IMPORTED_MODULE_0__.Params.toAmino(message.params) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryParamsResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/protorev/query-params-response",
      value: QueryParamsResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryParamsResponse.decode(message.value);
  },

  toProto(message) {
    return QueryParamsResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.protorev.v1beta1.QueryParamsResponse",
      value: QueryParamsResponse.encode(message).finish()
    };
  }

};

function createBaseQueryGetProtoRevNumberOfTradesRequest() {
  return {};
}

const QueryGetProtoRevNumberOfTradesRequest = {
  typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevNumberOfTradesRequest",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryGetProtoRevNumberOfTradesRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseQueryGetProtoRevNumberOfTradesRequest();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return QueryGetProtoRevNumberOfTradesRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/protorev/query-get-proto-rev-number-of-trades-request",
      value: QueryGetProtoRevNumberOfTradesRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryGetProtoRevNumberOfTradesRequest.decode(message.value);
  },

  toProto(message) {
    return QueryGetProtoRevNumberOfTradesRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevNumberOfTradesRequest",
      value: QueryGetProtoRevNumberOfTradesRequest.encode(message).finish()
    };
  }

};

function createBaseQueryGetProtoRevNumberOfTradesResponse() {
  return {
    numberOfTrades: ""
  };
}

const QueryGetProtoRevNumberOfTradesResponse = {
  typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevNumberOfTradesResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    if (message.numberOfTrades !== "") {
      writer.uint32(10).string(message.numberOfTrades);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryGetProtoRevNumberOfTradesResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.numberOfTrades = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$numberOfTrade;

    const message = createBaseQueryGetProtoRevNumberOfTradesResponse();
    message.numberOfTrades = (_object$numberOfTrade = object.numberOfTrades) !== null && _object$numberOfTrade !== void 0 ? _object$numberOfTrade : "";
    return message;
  },

  fromAmino(object) {
    return {
      numberOfTrades: object.number_of_trades
    };
  },

  toAmino(message) {
    const obj = {};
    obj.number_of_trades = message.numberOfTrades;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryGetProtoRevNumberOfTradesResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/protorev/query-get-proto-rev-number-of-trades-response",
      value: QueryGetProtoRevNumberOfTradesResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryGetProtoRevNumberOfTradesResponse.decode(message.value);
  },

  toProto(message) {
    return QueryGetProtoRevNumberOfTradesResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevNumberOfTradesResponse",
      value: QueryGetProtoRevNumberOfTradesResponse.encode(message).finish()
    };
  }

};

function createBaseQueryGetProtoRevProfitsByDenomRequest() {
  return {
    denom: ""
  };
}

const QueryGetProtoRevProfitsByDenomRequest = {
  typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevProfitsByDenomRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    if (message.denom !== "") {
      writer.uint32(10).string(message.denom);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryGetProtoRevProfitsByDenomRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.denom = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$denom;

    const message = createBaseQueryGetProtoRevProfitsByDenomRequest();
    message.denom = (_object$denom = object.denom) !== null && _object$denom !== void 0 ? _object$denom : "";
    return message;
  },

  fromAmino(object) {
    return {
      denom: object.denom
    };
  },

  toAmino(message) {
    const obj = {};
    obj.denom = message.denom;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryGetProtoRevProfitsByDenomRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/protorev/query-get-proto-rev-profits-by-denom-request",
      value: QueryGetProtoRevProfitsByDenomRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryGetProtoRevProfitsByDenomRequest.decode(message.value);
  },

  toProto(message) {
    return QueryGetProtoRevProfitsByDenomRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevProfitsByDenomRequest",
      value: QueryGetProtoRevProfitsByDenomRequest.encode(message).finish()
    };
  }

};

function createBaseQueryGetProtoRevProfitsByDenomResponse() {
  return {
    profit: undefined
  };
}

const QueryGetProtoRevProfitsByDenomResponse = {
  typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevProfitsByDenomResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    if (message.profit !== undefined) {
      _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.encode(message.profit, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryGetProtoRevProfitsByDenomResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.profit = _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseQueryGetProtoRevProfitsByDenomResponse();
    message.profit = object.profit !== undefined && object.profit !== null ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.fromPartial(object.profit) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      profit: object !== null && object !== void 0 && object.profit ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.fromAmino(object.profit) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.profit = message.profit ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.toAmino(message.profit) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryGetProtoRevProfitsByDenomResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/protorev/query-get-proto-rev-profits-by-denom-response",
      value: QueryGetProtoRevProfitsByDenomResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryGetProtoRevProfitsByDenomResponse.decode(message.value);
  },

  toProto(message) {
    return QueryGetProtoRevProfitsByDenomResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevProfitsByDenomResponse",
      value: QueryGetProtoRevProfitsByDenomResponse.encode(message).finish()
    };
  }

};

function createBaseQueryGetProtoRevAllProfitsRequest() {
  return {};
}

const QueryGetProtoRevAllProfitsRequest = {
  typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevAllProfitsRequest",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryGetProtoRevAllProfitsRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseQueryGetProtoRevAllProfitsRequest();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return QueryGetProtoRevAllProfitsRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/protorev/query-get-proto-rev-all-profits-request",
      value: QueryGetProtoRevAllProfitsRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryGetProtoRevAllProfitsRequest.decode(message.value);
  },

  toProto(message) {
    return QueryGetProtoRevAllProfitsRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevAllProfitsRequest",
      value: QueryGetProtoRevAllProfitsRequest.encode(message).finish()
    };
  }

};

function createBaseQueryGetProtoRevAllProfitsResponse() {
  return {
    profits: []
  };
}

const QueryGetProtoRevAllProfitsResponse = {
  typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevAllProfitsResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    for (const v of message.profits) {
      _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.encode(v, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryGetProtoRevAllProfitsResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.profits.push(_cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$profits;

    const message = createBaseQueryGetProtoRevAllProfitsResponse();
    message.profits = ((_object$profits = object.profits) === null || _object$profits === void 0 ? void 0 : _object$profits.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      profits: Array.isArray(object === null || object === void 0 ? void 0 : object.profits) ? object.profits.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.profits) {
      obj.profits = message.profits.map(e => e ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.toAmino(e) : undefined);
    } else {
      obj.profits = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return QueryGetProtoRevAllProfitsResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/protorev/query-get-proto-rev-all-profits-response",
      value: QueryGetProtoRevAllProfitsResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryGetProtoRevAllProfitsResponse.decode(message.value);
  },

  toProto(message) {
    return QueryGetProtoRevAllProfitsResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevAllProfitsResponse",
      value: QueryGetProtoRevAllProfitsResponse.encode(message).finish()
    };
  }

};

function createBaseQueryGetProtoRevStatisticsByRouteRequest() {
  return {
    route: []
  };
}

const QueryGetProtoRevStatisticsByRouteRequest = {
  typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevStatisticsByRouteRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    writer.uint32(10).fork();

    for (const v of message.route) {
      writer.uint64(v);
    }

    writer.ldelim();
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryGetProtoRevStatisticsByRouteRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          if ((tag & 7) === 2) {
            const end2 = reader.uint32() + reader.pos;

            while (reader.pos < end2) {
              message.route.push(reader.uint64());
            }
          } else {
            message.route.push(reader.uint64());
          }

          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$route;

    const message = createBaseQueryGetProtoRevStatisticsByRouteRequest();
    message.route = ((_object$route = object.route) === null || _object$route === void 0 ? void 0 : _object$route.map(e => _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.fromValue */ .dK.fromValue(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      route: Array.isArray(object === null || object === void 0 ? void 0 : object.route) ? object.route.map(e => e) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.route) {
      obj.route = message.route.map(e => e);
    } else {
      obj.route = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return QueryGetProtoRevStatisticsByRouteRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/protorev/query-get-proto-rev-statistics-by-route-request",
      value: QueryGetProtoRevStatisticsByRouteRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryGetProtoRevStatisticsByRouteRequest.decode(message.value);
  },

  toProto(message) {
    return QueryGetProtoRevStatisticsByRouteRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevStatisticsByRouteRequest",
      value: QueryGetProtoRevStatisticsByRouteRequest.encode(message).finish()
    };
  }

};

function createBaseQueryGetProtoRevStatisticsByRouteResponse() {
  return {
    statistics: undefined
  };
}

const QueryGetProtoRevStatisticsByRouteResponse = {
  typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevStatisticsByRouteResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    if (message.statistics !== undefined) {
      _protorev__WEBPACK_IMPORTED_MODULE_2__.RouteStatistics.encode(message.statistics, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryGetProtoRevStatisticsByRouteResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.statistics = _protorev__WEBPACK_IMPORTED_MODULE_2__.RouteStatistics.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseQueryGetProtoRevStatisticsByRouteResponse();
    message.statistics = object.statistics !== undefined && object.statistics !== null ? _protorev__WEBPACK_IMPORTED_MODULE_2__.RouteStatistics.fromPartial(object.statistics) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      statistics: object !== null && object !== void 0 && object.statistics ? _protorev__WEBPACK_IMPORTED_MODULE_2__.RouteStatistics.fromAmino(object.statistics) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.statistics = message.statistics ? _protorev__WEBPACK_IMPORTED_MODULE_2__.RouteStatistics.toAmino(message.statistics) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryGetProtoRevStatisticsByRouteResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/protorev/query-get-proto-rev-statistics-by-route-response",
      value: QueryGetProtoRevStatisticsByRouteResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryGetProtoRevStatisticsByRouteResponse.decode(message.value);
  },

  toProto(message) {
    return QueryGetProtoRevStatisticsByRouteResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevStatisticsByRouteResponse",
      value: QueryGetProtoRevStatisticsByRouteResponse.encode(message).finish()
    };
  }

};

function createBaseQueryGetProtoRevAllRouteStatisticsRequest() {
  return {};
}

const QueryGetProtoRevAllRouteStatisticsRequest = {
  typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevAllRouteStatisticsRequest",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryGetProtoRevAllRouteStatisticsRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseQueryGetProtoRevAllRouteStatisticsRequest();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return QueryGetProtoRevAllRouteStatisticsRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/protorev/query-get-proto-rev-all-route-statistics-request",
      value: QueryGetProtoRevAllRouteStatisticsRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryGetProtoRevAllRouteStatisticsRequest.decode(message.value);
  },

  toProto(message) {
    return QueryGetProtoRevAllRouteStatisticsRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevAllRouteStatisticsRequest",
      value: QueryGetProtoRevAllRouteStatisticsRequest.encode(message).finish()
    };
  }

};

function createBaseQueryGetProtoRevAllRouteStatisticsResponse() {
  return {
    statistics: []
  };
}

const QueryGetProtoRevAllRouteStatisticsResponse = {
  typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevAllRouteStatisticsResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    for (const v of message.statistics) {
      _protorev__WEBPACK_IMPORTED_MODULE_2__.RouteStatistics.encode(v, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryGetProtoRevAllRouteStatisticsResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.statistics.push(_protorev__WEBPACK_IMPORTED_MODULE_2__.RouteStatistics.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$statistics;

    const message = createBaseQueryGetProtoRevAllRouteStatisticsResponse();
    message.statistics = ((_object$statistics = object.statistics) === null || _object$statistics === void 0 ? void 0 : _object$statistics.map(e => _protorev__WEBPACK_IMPORTED_MODULE_2__.RouteStatistics.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      statistics: Array.isArray(object === null || object === void 0 ? void 0 : object.statistics) ? object.statistics.map(e => _protorev__WEBPACK_IMPORTED_MODULE_2__.RouteStatistics.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.statistics) {
      obj.statistics = message.statistics.map(e => e ? _protorev__WEBPACK_IMPORTED_MODULE_2__.RouteStatistics.toAmino(e) : undefined);
    } else {
      obj.statistics = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return QueryGetProtoRevAllRouteStatisticsResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/protorev/query-get-proto-rev-all-route-statistics-response",
      value: QueryGetProtoRevAllRouteStatisticsResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryGetProtoRevAllRouteStatisticsResponse.decode(message.value);
  },

  toProto(message) {
    return QueryGetProtoRevAllRouteStatisticsResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevAllRouteStatisticsResponse",
      value: QueryGetProtoRevAllRouteStatisticsResponse.encode(message).finish()
    };
  }

};

function createBaseQueryGetProtoRevTokenPairArbRoutesRequest() {
  return {};
}

const QueryGetProtoRevTokenPairArbRoutesRequest = {
  typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevTokenPairArbRoutesRequest",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryGetProtoRevTokenPairArbRoutesRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseQueryGetProtoRevTokenPairArbRoutesRequest();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return QueryGetProtoRevTokenPairArbRoutesRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/protorev/query-get-proto-rev-token-pair-arb-routes-request",
      value: QueryGetProtoRevTokenPairArbRoutesRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryGetProtoRevTokenPairArbRoutesRequest.decode(message.value);
  },

  toProto(message) {
    return QueryGetProtoRevTokenPairArbRoutesRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevTokenPairArbRoutesRequest",
      value: QueryGetProtoRevTokenPairArbRoutesRequest.encode(message).finish()
    };
  }

};

function createBaseQueryGetProtoRevTokenPairArbRoutesResponse() {
  return {
    routes: []
  };
}

const QueryGetProtoRevTokenPairArbRoutesResponse = {
  typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevTokenPairArbRoutesResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    for (const v of message.routes) {
      _protorev__WEBPACK_IMPORTED_MODULE_2__.TokenPairArbRoutes.encode(v, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryGetProtoRevTokenPairArbRoutesResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.routes.push(_protorev__WEBPACK_IMPORTED_MODULE_2__.TokenPairArbRoutes.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$routes;

    const message = createBaseQueryGetProtoRevTokenPairArbRoutesResponse();
    message.routes = ((_object$routes = object.routes) === null || _object$routes === void 0 ? void 0 : _object$routes.map(e => _protorev__WEBPACK_IMPORTED_MODULE_2__.TokenPairArbRoutes.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      routes: Array.isArray(object === null || object === void 0 ? void 0 : object.routes) ? object.routes.map(e => _protorev__WEBPACK_IMPORTED_MODULE_2__.TokenPairArbRoutes.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.routes) {
      obj.routes = message.routes.map(e => e ? _protorev__WEBPACK_IMPORTED_MODULE_2__.TokenPairArbRoutes.toAmino(e) : undefined);
    } else {
      obj.routes = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return QueryGetProtoRevTokenPairArbRoutesResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/protorev/query-get-proto-rev-token-pair-arb-routes-response",
      value: QueryGetProtoRevTokenPairArbRoutesResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryGetProtoRevTokenPairArbRoutesResponse.decode(message.value);
  },

  toProto(message) {
    return QueryGetProtoRevTokenPairArbRoutesResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevTokenPairArbRoutesResponse",
      value: QueryGetProtoRevTokenPairArbRoutesResponse.encode(message).finish()
    };
  }

};

function createBaseQueryGetProtoRevAdminAccountRequest() {
  return {};
}

const QueryGetProtoRevAdminAccountRequest = {
  typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevAdminAccountRequest",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryGetProtoRevAdminAccountRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseQueryGetProtoRevAdminAccountRequest();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return QueryGetProtoRevAdminAccountRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/protorev/query-get-proto-rev-admin-account-request",
      value: QueryGetProtoRevAdminAccountRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryGetProtoRevAdminAccountRequest.decode(message.value);
  },

  toProto(message) {
    return QueryGetProtoRevAdminAccountRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevAdminAccountRequest",
      value: QueryGetProtoRevAdminAccountRequest.encode(message).finish()
    };
  }

};

function createBaseQueryGetProtoRevAdminAccountResponse() {
  return {
    adminAccount: ""
  };
}

const QueryGetProtoRevAdminAccountResponse = {
  typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevAdminAccountResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    if (message.adminAccount !== "") {
      writer.uint32(10).string(message.adminAccount);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryGetProtoRevAdminAccountResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.adminAccount = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$adminAccount;

    const message = createBaseQueryGetProtoRevAdminAccountResponse();
    message.adminAccount = (_object$adminAccount = object.adminAccount) !== null && _object$adminAccount !== void 0 ? _object$adminAccount : "";
    return message;
  },

  fromAmino(object) {
    return {
      adminAccount: object.admin_account
    };
  },

  toAmino(message) {
    const obj = {};
    obj.admin_account = message.adminAccount;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryGetProtoRevAdminAccountResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/protorev/query-get-proto-rev-admin-account-response",
      value: QueryGetProtoRevAdminAccountResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryGetProtoRevAdminAccountResponse.decode(message.value);
  },

  toProto(message) {
    return QueryGetProtoRevAdminAccountResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevAdminAccountResponse",
      value: QueryGetProtoRevAdminAccountResponse.encode(message).finish()
    };
  }

};

function createBaseQueryGetProtoRevDeveloperAccountRequest() {
  return {};
}

const QueryGetProtoRevDeveloperAccountRequest = {
  typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevDeveloperAccountRequest",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryGetProtoRevDeveloperAccountRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseQueryGetProtoRevDeveloperAccountRequest();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return QueryGetProtoRevDeveloperAccountRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/protorev/query-get-proto-rev-developer-account-request",
      value: QueryGetProtoRevDeveloperAccountRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryGetProtoRevDeveloperAccountRequest.decode(message.value);
  },

  toProto(message) {
    return QueryGetProtoRevDeveloperAccountRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevDeveloperAccountRequest",
      value: QueryGetProtoRevDeveloperAccountRequest.encode(message).finish()
    };
  }

};

function createBaseQueryGetProtoRevDeveloperAccountResponse() {
  return {
    developerAccount: ""
  };
}

const QueryGetProtoRevDeveloperAccountResponse = {
  typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevDeveloperAccountResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    if (message.developerAccount !== "") {
      writer.uint32(10).string(message.developerAccount);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryGetProtoRevDeveloperAccountResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.developerAccount = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$developerAcco;

    const message = createBaseQueryGetProtoRevDeveloperAccountResponse();
    message.developerAccount = (_object$developerAcco = object.developerAccount) !== null && _object$developerAcco !== void 0 ? _object$developerAcco : "";
    return message;
  },

  fromAmino(object) {
    return {
      developerAccount: object.developer_account
    };
  },

  toAmino(message) {
    const obj = {};
    obj.developer_account = message.developerAccount;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryGetProtoRevDeveloperAccountResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/protorev/query-get-proto-rev-developer-account-response",
      value: QueryGetProtoRevDeveloperAccountResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryGetProtoRevDeveloperAccountResponse.decode(message.value);
  },

  toProto(message) {
    return QueryGetProtoRevDeveloperAccountResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevDeveloperAccountResponse",
      value: QueryGetProtoRevDeveloperAccountResponse.encode(message).finish()
    };
  }

};

function createBaseQueryGetProtoRevPoolWeightsRequest() {
  return {};
}

const QueryGetProtoRevPoolWeightsRequest = {
  typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevPoolWeightsRequest",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryGetProtoRevPoolWeightsRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseQueryGetProtoRevPoolWeightsRequest();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return QueryGetProtoRevPoolWeightsRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/protorev/query-get-proto-rev-pool-weights-request",
      value: QueryGetProtoRevPoolWeightsRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryGetProtoRevPoolWeightsRequest.decode(message.value);
  },

  toProto(message) {
    return QueryGetProtoRevPoolWeightsRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevPoolWeightsRequest",
      value: QueryGetProtoRevPoolWeightsRequest.encode(message).finish()
    };
  }

};

function createBaseQueryGetProtoRevPoolWeightsResponse() {
  return {
    poolWeights: undefined
  };
}

const QueryGetProtoRevPoolWeightsResponse = {
  typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevPoolWeightsResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    if (message.poolWeights !== undefined) {
      _protorev__WEBPACK_IMPORTED_MODULE_2__.PoolWeights.encode(message.poolWeights, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryGetProtoRevPoolWeightsResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.poolWeights = _protorev__WEBPACK_IMPORTED_MODULE_2__.PoolWeights.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseQueryGetProtoRevPoolWeightsResponse();
    message.poolWeights = object.poolWeights !== undefined && object.poolWeights !== null ? _protorev__WEBPACK_IMPORTED_MODULE_2__.PoolWeights.fromPartial(object.poolWeights) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      poolWeights: object !== null && object !== void 0 && object.pool_weights ? _protorev__WEBPACK_IMPORTED_MODULE_2__.PoolWeights.fromAmino(object.pool_weights) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.pool_weights = message.poolWeights ? _protorev__WEBPACK_IMPORTED_MODULE_2__.PoolWeights.toAmino(message.poolWeights) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryGetProtoRevPoolWeightsResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/protorev/query-get-proto-rev-pool-weights-response",
      value: QueryGetProtoRevPoolWeightsResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryGetProtoRevPoolWeightsResponse.decode(message.value);
  },

  toProto(message) {
    return QueryGetProtoRevPoolWeightsResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevPoolWeightsResponse",
      value: QueryGetProtoRevPoolWeightsResponse.encode(message).finish()
    };
  }

};

function createBaseQueryGetProtoRevMaxPoolPointsPerBlockRequest() {
  return {};
}

const QueryGetProtoRevMaxPoolPointsPerBlockRequest = {
  typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevMaxPoolPointsPerBlockRequest",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryGetProtoRevMaxPoolPointsPerBlockRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseQueryGetProtoRevMaxPoolPointsPerBlockRequest();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return QueryGetProtoRevMaxPoolPointsPerBlockRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/protorev/query-get-proto-rev-max-pool-points-per-block-request",
      value: QueryGetProtoRevMaxPoolPointsPerBlockRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryGetProtoRevMaxPoolPointsPerBlockRequest.decode(message.value);
  },

  toProto(message) {
    return QueryGetProtoRevMaxPoolPointsPerBlockRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevMaxPoolPointsPerBlockRequest",
      value: QueryGetProtoRevMaxPoolPointsPerBlockRequest.encode(message).finish()
    };
  }

};

function createBaseQueryGetProtoRevMaxPoolPointsPerBlockResponse() {
  return {
    maxPoolPointsPerBlock: _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.UZERO */ .dK.UZERO
  };
}

const QueryGetProtoRevMaxPoolPointsPerBlockResponse = {
  typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevMaxPoolPointsPerBlockResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    if (!message.maxPoolPointsPerBlock.isZero()) {
      writer.uint32(8).uint64(message.maxPoolPointsPerBlock);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryGetProtoRevMaxPoolPointsPerBlockResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.maxPoolPointsPerBlock = reader.uint64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseQueryGetProtoRevMaxPoolPointsPerBlockResponse();
    message.maxPoolPointsPerBlock = object.maxPoolPointsPerBlock !== undefined && object.maxPoolPointsPerBlock !== null ? _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.fromValue */ .dK.fromValue(object.maxPoolPointsPerBlock) : _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.UZERO */ .dK.UZERO;
    return message;
  },

  fromAmino(object) {
    return {
      maxPoolPointsPerBlock: _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.fromString */ .dK.fromString(object.max_pool_points_per_block)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.max_pool_points_per_block = message.maxPoolPointsPerBlock ? message.maxPoolPointsPerBlock.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryGetProtoRevMaxPoolPointsPerBlockResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/protorev/query-get-proto-rev-max-pool-points-per-block-response",
      value: QueryGetProtoRevMaxPoolPointsPerBlockResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryGetProtoRevMaxPoolPointsPerBlockResponse.decode(message.value);
  },

  toProto(message) {
    return QueryGetProtoRevMaxPoolPointsPerBlockResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevMaxPoolPointsPerBlockResponse",
      value: QueryGetProtoRevMaxPoolPointsPerBlockResponse.encode(message).finish()
    };
  }

};

function createBaseQueryGetProtoRevMaxPoolPointsPerTxRequest() {
  return {};
}

const QueryGetProtoRevMaxPoolPointsPerTxRequest = {
  typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevMaxPoolPointsPerTxRequest",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryGetProtoRevMaxPoolPointsPerTxRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseQueryGetProtoRevMaxPoolPointsPerTxRequest();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return QueryGetProtoRevMaxPoolPointsPerTxRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/protorev/query-get-proto-rev-max-pool-points-per-tx-request",
      value: QueryGetProtoRevMaxPoolPointsPerTxRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryGetProtoRevMaxPoolPointsPerTxRequest.decode(message.value);
  },

  toProto(message) {
    return QueryGetProtoRevMaxPoolPointsPerTxRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevMaxPoolPointsPerTxRequest",
      value: QueryGetProtoRevMaxPoolPointsPerTxRequest.encode(message).finish()
    };
  }

};

function createBaseQueryGetProtoRevMaxPoolPointsPerTxResponse() {
  return {
    maxPoolPointsPerTx: _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.UZERO */ .dK.UZERO
  };
}

const QueryGetProtoRevMaxPoolPointsPerTxResponse = {
  typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevMaxPoolPointsPerTxResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    if (!message.maxPoolPointsPerTx.isZero()) {
      writer.uint32(8).uint64(message.maxPoolPointsPerTx);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryGetProtoRevMaxPoolPointsPerTxResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.maxPoolPointsPerTx = reader.uint64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseQueryGetProtoRevMaxPoolPointsPerTxResponse();
    message.maxPoolPointsPerTx = object.maxPoolPointsPerTx !== undefined && object.maxPoolPointsPerTx !== null ? _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.fromValue */ .dK.fromValue(object.maxPoolPointsPerTx) : _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.UZERO */ .dK.UZERO;
    return message;
  },

  fromAmino(object) {
    return {
      maxPoolPointsPerTx: _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.fromString */ .dK.fromString(object.max_pool_points_per_tx)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.max_pool_points_per_tx = message.maxPoolPointsPerTx ? message.maxPoolPointsPerTx.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryGetProtoRevMaxPoolPointsPerTxResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/protorev/query-get-proto-rev-max-pool-points-per-tx-response",
      value: QueryGetProtoRevMaxPoolPointsPerTxResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryGetProtoRevMaxPoolPointsPerTxResponse.decode(message.value);
  },

  toProto(message) {
    return QueryGetProtoRevMaxPoolPointsPerTxResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevMaxPoolPointsPerTxResponse",
      value: QueryGetProtoRevMaxPoolPointsPerTxResponse.encode(message).finish()
    };
  }

};

function createBaseQueryGetProtoRevBaseDenomsRequest() {
  return {};
}

const QueryGetProtoRevBaseDenomsRequest = {
  typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevBaseDenomsRequest",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryGetProtoRevBaseDenomsRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseQueryGetProtoRevBaseDenomsRequest();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return QueryGetProtoRevBaseDenomsRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/protorev/query-get-proto-rev-base-denoms-request",
      value: QueryGetProtoRevBaseDenomsRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryGetProtoRevBaseDenomsRequest.decode(message.value);
  },

  toProto(message) {
    return QueryGetProtoRevBaseDenomsRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevBaseDenomsRequest",
      value: QueryGetProtoRevBaseDenomsRequest.encode(message).finish()
    };
  }

};

function createBaseQueryGetProtoRevBaseDenomsResponse() {
  return {
    baseDenoms: []
  };
}

const QueryGetProtoRevBaseDenomsResponse = {
  typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevBaseDenomsResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    for (const v of message.baseDenoms) {
      _protorev__WEBPACK_IMPORTED_MODULE_2__.BaseDenom.encode(v, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryGetProtoRevBaseDenomsResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.baseDenoms.push(_protorev__WEBPACK_IMPORTED_MODULE_2__.BaseDenom.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$baseDenoms;

    const message = createBaseQueryGetProtoRevBaseDenomsResponse();
    message.baseDenoms = ((_object$baseDenoms = object.baseDenoms) === null || _object$baseDenoms === void 0 ? void 0 : _object$baseDenoms.map(e => _protorev__WEBPACK_IMPORTED_MODULE_2__.BaseDenom.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      baseDenoms: Array.isArray(object === null || object === void 0 ? void 0 : object.base_denoms) ? object.base_denoms.map(e => _protorev__WEBPACK_IMPORTED_MODULE_2__.BaseDenom.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.baseDenoms) {
      obj.base_denoms = message.baseDenoms.map(e => e ? _protorev__WEBPACK_IMPORTED_MODULE_2__.BaseDenom.toAmino(e) : undefined);
    } else {
      obj.base_denoms = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return QueryGetProtoRevBaseDenomsResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/protorev/query-get-proto-rev-base-denoms-response",
      value: QueryGetProtoRevBaseDenomsResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryGetProtoRevBaseDenomsResponse.decode(message.value);
  },

  toProto(message) {
    return QueryGetProtoRevBaseDenomsResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevBaseDenomsResponse",
      value: QueryGetProtoRevBaseDenomsResponse.encode(message).finish()
    };
  }

};

function createBaseQueryGetProtoRevEnabledRequest() {
  return {};
}

const QueryGetProtoRevEnabledRequest = {
  typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevEnabledRequest",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryGetProtoRevEnabledRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseQueryGetProtoRevEnabledRequest();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return QueryGetProtoRevEnabledRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/protorev/query-get-proto-rev-enabled-request",
      value: QueryGetProtoRevEnabledRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryGetProtoRevEnabledRequest.decode(message.value);
  },

  toProto(message) {
    return QueryGetProtoRevEnabledRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevEnabledRequest",
      value: QueryGetProtoRevEnabledRequest.encode(message).finish()
    };
  }

};

function createBaseQueryGetProtoRevEnabledResponse() {
  return {
    enabled: false
  };
}

const QueryGetProtoRevEnabledResponse = {
  typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevEnabledResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    if (message.enabled === true) {
      writer.uint32(8).bool(message.enabled);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryGetProtoRevEnabledResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.enabled = reader.bool();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$enabled;

    const message = createBaseQueryGetProtoRevEnabledResponse();
    message.enabled = (_object$enabled = object.enabled) !== null && _object$enabled !== void 0 ? _object$enabled : false;
    return message;
  },

  fromAmino(object) {
    return {
      enabled: object.enabled
    };
  },

  toAmino(message) {
    const obj = {};
    obj.enabled = message.enabled;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryGetProtoRevEnabledResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/protorev/query-get-proto-rev-enabled-response",
      value: QueryGetProtoRevEnabledResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryGetProtoRevEnabledResponse.decode(message.value);
  },

  toProto(message) {
    return QueryGetProtoRevEnabledResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevEnabledResponse",
      value: QueryGetProtoRevEnabledResponse.encode(message).finish()
    };
  }

};

function createBaseQueryGetProtoRevPoolRequest() {
  return {
    baseDenom: "",
    otherDenom: ""
  };
}

const QueryGetProtoRevPoolRequest = {
  typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevPoolRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    if (message.baseDenom !== "") {
      writer.uint32(10).string(message.baseDenom);
    }

    if (message.otherDenom !== "") {
      writer.uint32(18).string(message.otherDenom);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryGetProtoRevPoolRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.baseDenom = reader.string();
          break;

        case 2:
          message.otherDenom = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$baseDenom, _object$otherDenom;

    const message = createBaseQueryGetProtoRevPoolRequest();
    message.baseDenom = (_object$baseDenom = object.baseDenom) !== null && _object$baseDenom !== void 0 ? _object$baseDenom : "";
    message.otherDenom = (_object$otherDenom = object.otherDenom) !== null && _object$otherDenom !== void 0 ? _object$otherDenom : "";
    return message;
  },

  fromAmino(object) {
    return {
      baseDenom: object.base_denom,
      otherDenom: object.other_denom
    };
  },

  toAmino(message) {
    const obj = {};
    obj.base_denom = message.baseDenom;
    obj.other_denom = message.otherDenom;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryGetProtoRevPoolRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/protorev/query-get-proto-rev-pool-request",
      value: QueryGetProtoRevPoolRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryGetProtoRevPoolRequest.decode(message.value);
  },

  toProto(message) {
    return QueryGetProtoRevPoolRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevPoolRequest",
      value: QueryGetProtoRevPoolRequest.encode(message).finish()
    };
  }

};

function createBaseQueryGetProtoRevPoolResponse() {
  return {
    poolId: _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.UZERO */ .dK.UZERO
  };
}

const QueryGetProtoRevPoolResponse = {
  typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevPoolResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Writer.create()) {
    if (!message.poolId.isZero()) {
      writer.uint32(8).uint64(message.poolId);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_4__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryGetProtoRevPoolResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.poolId = reader.uint64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseQueryGetProtoRevPoolResponse();
    message.poolId = object.poolId !== undefined && object.poolId !== null ? _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.fromValue */ .dK.fromValue(object.poolId) : _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.UZERO */ .dK.UZERO;
    return message;
  },

  fromAmino(object) {
    return {
      poolId: _helpers__WEBPACK_IMPORTED_MODULE_3__/* .Long.fromString */ .dK.fromString(object.pool_id)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.pool_id = message.poolId ? message.poolId.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryGetProtoRevPoolResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/protorev/query-get-proto-rev-pool-response",
      value: QueryGetProtoRevPoolResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryGetProtoRevPoolResponse.decode(message.value);
  },

  toProto(message) {
    return QueryGetProtoRevPoolResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.protorev.v1beta1.QueryGetProtoRevPoolResponse",
      value: QueryGetProtoRevPoolResponse.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 48281:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LCDQueryClient": function() { return /* binding */ LCDQueryClient; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4942);

class LCDQueryClient {
  constructor({
    requestClient
  }) {
    (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, "req", void 0);

    this.req = requestClient;
    this.params = this.params.bind(this);
    this.getProtoRevNumberOfTrades = this.getProtoRevNumberOfTrades.bind(this);
    this.getProtoRevProfitsByDenom = this.getProtoRevProfitsByDenom.bind(this);
    this.getProtoRevAllProfits = this.getProtoRevAllProfits.bind(this);
    this.getProtoRevStatisticsByRoute = this.getProtoRevStatisticsByRoute.bind(this);
    this.getProtoRevAllRouteStatistics = this.getProtoRevAllRouteStatistics.bind(this);
    this.getProtoRevTokenPairArbRoutes = this.getProtoRevTokenPairArbRoutes.bind(this);
    this.getProtoRevAdminAccount = this.getProtoRevAdminAccount.bind(this);
    this.getProtoRevDeveloperAccount = this.getProtoRevDeveloperAccount.bind(this);
    this.getProtoRevPoolWeights = this.getProtoRevPoolWeights.bind(this);
    this.getProtoRevMaxPoolPointsPerTx = this.getProtoRevMaxPoolPointsPerTx.bind(this);
    this.getProtoRevMaxPoolPointsPerBlock = this.getProtoRevMaxPoolPointsPerBlock.bind(this);
    this.getProtoRevBaseDenoms = this.getProtoRevBaseDenoms.bind(this);
    this.getProtoRevEnabled = this.getProtoRevEnabled.bind(this);
    this.getProtoRevPool = this.getProtoRevPool.bind(this);
  }
  /* Params queries the parameters of the module. */


  async params(_params = {}) {
    const endpoint = `osmosis/v14/protorev/params`;
    return await this.req.get(endpoint);
  }
  /* GetProtoRevNumberOfTrades queries the number of arbitrage trades the module
   has executed */


  async getProtoRevNumberOfTrades(_params = {}) {
    const endpoint = `osmosis/v14/protorev/number_of_trades`;
    return await this.req.get(endpoint);
  }
  /* GetProtoRevProfitsByDenom queries the profits of the module by denom */


  async getProtoRevProfitsByDenom(params) {
    const options = {
      params: {}
    };

    if (typeof (params === null || params === void 0 ? void 0 : params.denom) !== "undefined") {
      options.params.denom = params.denom;
    }

    const endpoint = `osmosis/v14/protorev/profits_by_denom`;
    return await this.req.get(endpoint, options);
  }
  /* GetProtoRevAllProfits queries all of the profits from the module */


  async getProtoRevAllProfits(_params = {}) {
    const endpoint = `osmosis/v14/protorev/all_profits`;
    return await this.req.get(endpoint);
  }
  /* GetProtoRevStatisticsByRoute queries the number of arbitrages and profits
   that have been executed for a given route */


  async getProtoRevStatisticsByRoute(params) {
    const options = {
      params: {}
    };

    if (typeof (params === null || params === void 0 ? void 0 : params.route) !== "undefined") {
      options.params.route = params.route;
    }

    const endpoint = `osmosis/v14/protorev/statistics_by_route`;
    return await this.req.get(endpoint, options);
  }
  /* GetProtoRevAllRouteStatistics queries all of routes that the module has
   arbitraged against and the number of trades and profits that have been
   accumulated for each route */


  async getProtoRevAllRouteStatistics(_params = {}) {
    const endpoint = `osmosis/v14/protorev/all_route_statistics`;
    return await this.req.get(endpoint);
  }
  /* GetProtoRevTokenPairArbRoutes queries all of the hot routes that the module
   is currently arbitraging */


  async getProtoRevTokenPairArbRoutes(_params = {}) {
    const endpoint = `osmosis/v14/protorev/token_pair_arb_routes`;
    return await this.req.get(endpoint);
  }
  /* GetProtoRevAdminAccount queries the admin account of the module */


  async getProtoRevAdminAccount(_params = {}) {
    const endpoint = `osmosis/v14/protorev/admin_account`;
    return await this.req.get(endpoint);
  }
  /* GetProtoRevDeveloperAccount queries the developer account of the module */


  async getProtoRevDeveloperAccount(_params = {}) {
    const endpoint = `osmosis/v14/protorev/developer_account`;
    return await this.req.get(endpoint);
  }
  /* GetProtoRevPoolWeights queries the weights of each pool type currently
   being used by the module */


  async getProtoRevPoolWeights(_params = {}) {
    const endpoint = `osmosis/v14/protorev/pool_weights`;
    return await this.req.get(endpoint);
  }
  /* GetProtoRevMaxPoolPointsPerTx queries the maximum number of pool points
   that can be consumed per transaction */


  async getProtoRevMaxPoolPointsPerTx(_params = {}) {
    const endpoint = `osmosis/v14/protorev/max_pool_points_per_tx`;
    return await this.req.get(endpoint);
  }
  /* GetProtoRevMaxPoolPointsPerBlock queries the maximum number of pool points
   that can consumed per block */


  async getProtoRevMaxPoolPointsPerBlock(_params = {}) {
    const endpoint = `osmosis/v14/protorev/max_pool_points_per_block`;
    return await this.req.get(endpoint);
  }
  /* GetProtoRevBaseDenoms queries the base denoms that the module is currently
   utilizing for arbitrage */


  async getProtoRevBaseDenoms(_params = {}) {
    const endpoint = `osmosis/v14/protorev/base_denoms`;
    return await this.req.get(endpoint);
  }
  /* GetProtoRevEnabled queries whether the module is enabled or not */


  async getProtoRevEnabled(_params = {}) {
    const endpoint = `osmosis/v14/protorev/enabled`;
    return await this.req.get(endpoint);
  }
  /* GetProtoRevPool queries the pool id used via the highest liquidity method
   for arbitrage route building given a pair of denominations */


  async getProtoRevPool(params) {
    const options = {
      params: {}
    };

    if (typeof (params === null || params === void 0 ? void 0 : params.baseDenom) !== "undefined") {
      options.params.base_denom = params.baseDenom;
    }

    if (typeof (params === null || params === void 0 ? void 0 : params.otherDenom) !== "undefined") {
      options.params.other_denom = params.otherDenom;
    }

    const endpoint = `osmosis/v14/protorev/pool`;
    return await this.req.get(endpoint, options);
  }

}

/***/ }),

/***/ 78133:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QueryClientImpl": function() { return /* binding */ QueryClientImpl; },
/* harmony export */   "createRpcQueryExtension": function() { return /* binding */ createRpcQueryExtension; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4942);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78441);
/* harmony import */ var _cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82594);




/** Query defines the gRPC querier service. */

class QueryClientImpl {
  constructor(rpc) {
    (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, "rpc", void 0);

    this.rpc = rpc;
    this.params = this.params.bind(this);
    this.getProtoRevNumberOfTrades = this.getProtoRevNumberOfTrades.bind(this);
    this.getProtoRevProfitsByDenom = this.getProtoRevProfitsByDenom.bind(this);
    this.getProtoRevAllProfits = this.getProtoRevAllProfits.bind(this);
    this.getProtoRevStatisticsByRoute = this.getProtoRevStatisticsByRoute.bind(this);
    this.getProtoRevAllRouteStatistics = this.getProtoRevAllRouteStatistics.bind(this);
    this.getProtoRevTokenPairArbRoutes = this.getProtoRevTokenPairArbRoutes.bind(this);
    this.getProtoRevAdminAccount = this.getProtoRevAdminAccount.bind(this);
    this.getProtoRevDeveloperAccount = this.getProtoRevDeveloperAccount.bind(this);
    this.getProtoRevPoolWeights = this.getProtoRevPoolWeights.bind(this);
    this.getProtoRevMaxPoolPointsPerTx = this.getProtoRevMaxPoolPointsPerTx.bind(this);
    this.getProtoRevMaxPoolPointsPerBlock = this.getProtoRevMaxPoolPointsPerBlock.bind(this);
    this.getProtoRevBaseDenoms = this.getProtoRevBaseDenoms.bind(this);
    this.getProtoRevEnabled = this.getProtoRevEnabled.bind(this);
    this.getProtoRevPool = this.getProtoRevPool.bind(this);
  }

  params(request = {}) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryParamsRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.protorev.v1beta1.Query", "Params", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryParamsResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  getProtoRevNumberOfTrades(request = {}) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryGetProtoRevNumberOfTradesRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.protorev.v1beta1.Query", "GetProtoRevNumberOfTrades", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryGetProtoRevNumberOfTradesResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  getProtoRevProfitsByDenom(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryGetProtoRevProfitsByDenomRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.protorev.v1beta1.Query", "GetProtoRevProfitsByDenom", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryGetProtoRevProfitsByDenomResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  getProtoRevAllProfits(request = {}) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryGetProtoRevAllProfitsRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.protorev.v1beta1.Query", "GetProtoRevAllProfits", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryGetProtoRevAllProfitsResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  getProtoRevStatisticsByRoute(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryGetProtoRevStatisticsByRouteRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.protorev.v1beta1.Query", "GetProtoRevStatisticsByRoute", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryGetProtoRevStatisticsByRouteResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  getProtoRevAllRouteStatistics(request = {}) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryGetProtoRevAllRouteStatisticsRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.protorev.v1beta1.Query", "GetProtoRevAllRouteStatistics", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryGetProtoRevAllRouteStatisticsResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  getProtoRevTokenPairArbRoutes(request = {}) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryGetProtoRevTokenPairArbRoutesRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.protorev.v1beta1.Query", "GetProtoRevTokenPairArbRoutes", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryGetProtoRevTokenPairArbRoutesResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  getProtoRevAdminAccount(request = {}) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryGetProtoRevAdminAccountRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.protorev.v1beta1.Query", "GetProtoRevAdminAccount", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryGetProtoRevAdminAccountResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  getProtoRevDeveloperAccount(request = {}) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryGetProtoRevDeveloperAccountRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.protorev.v1beta1.Query", "GetProtoRevDeveloperAccount", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryGetProtoRevDeveloperAccountResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  getProtoRevPoolWeights(request = {}) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryGetProtoRevPoolWeightsRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.protorev.v1beta1.Query", "GetProtoRevPoolWeights", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryGetProtoRevPoolWeightsResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  getProtoRevMaxPoolPointsPerTx(request = {}) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryGetProtoRevMaxPoolPointsPerTxRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.protorev.v1beta1.Query", "GetProtoRevMaxPoolPointsPerTx", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryGetProtoRevMaxPoolPointsPerTxResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  getProtoRevMaxPoolPointsPerBlock(request = {}) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryGetProtoRevMaxPoolPointsPerBlockRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.protorev.v1beta1.Query", "GetProtoRevMaxPoolPointsPerBlock", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryGetProtoRevMaxPoolPointsPerBlockResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  getProtoRevBaseDenoms(request = {}) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryGetProtoRevBaseDenomsRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.protorev.v1beta1.Query", "GetProtoRevBaseDenoms", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryGetProtoRevBaseDenomsResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  getProtoRevEnabled(request = {}) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryGetProtoRevEnabledRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.protorev.v1beta1.Query", "GetProtoRevEnabled", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryGetProtoRevEnabledResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  getProtoRevPool(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryGetProtoRevPoolRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.protorev.v1beta1.Query", "GetProtoRevPool", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryGetProtoRevPoolResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

}
const createRpcQueryExtension = base => {
  const rpc = (0,_cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1__.createProtobufRpcClient)(base);
  const queryService = new QueryClientImpl(rpc);
  return {
    params(request) {
      return queryService.params(request);
    },

    getProtoRevNumberOfTrades(request) {
      return queryService.getProtoRevNumberOfTrades(request);
    },

    getProtoRevProfitsByDenom(request) {
      return queryService.getProtoRevProfitsByDenom(request);
    },

    getProtoRevAllProfits(request) {
      return queryService.getProtoRevAllProfits(request);
    },

    getProtoRevStatisticsByRoute(request) {
      return queryService.getProtoRevStatisticsByRoute(request);
    },

    getProtoRevAllRouteStatistics(request) {
      return queryService.getProtoRevAllRouteStatistics(request);
    },

    getProtoRevTokenPairArbRoutes(request) {
      return queryService.getProtoRevTokenPairArbRoutes(request);
    },

    getProtoRevAdminAccount(request) {
      return queryService.getProtoRevAdminAccount(request);
    },

    getProtoRevDeveloperAccount(request) {
      return queryService.getProtoRevDeveloperAccount(request);
    },

    getProtoRevPoolWeights(request) {
      return queryService.getProtoRevPoolWeights(request);
    },

    getProtoRevMaxPoolPointsPerTx(request) {
      return queryService.getProtoRevMaxPoolPointsPerTx(request);
    },

    getProtoRevMaxPoolPointsPerBlock(request) {
      return queryService.getProtoRevMaxPoolPointsPerBlock(request);
    },

    getProtoRevBaseDenoms(request) {
      return queryService.getProtoRevBaseDenoms(request);
    },

    getProtoRevEnabled(request) {
      return queryService.getProtoRevEnabled(request);
    },

    getProtoRevPool(request) {
      return queryService.getProtoRevPool(request);
    }

  };
};

/***/ }),

/***/ 97560:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MsgSetBaseDenoms": function() { return /* binding */ MsgSetBaseDenoms; },
/* harmony export */   "MsgSetBaseDenomsResponse": function() { return /* binding */ MsgSetBaseDenomsResponse; },
/* harmony export */   "MsgSetDeveloperAccount": function() { return /* binding */ MsgSetDeveloperAccount; },
/* harmony export */   "MsgSetDeveloperAccountResponse": function() { return /* binding */ MsgSetDeveloperAccountResponse; },
/* harmony export */   "MsgSetHotRoutes": function() { return /* binding */ MsgSetHotRoutes; },
/* harmony export */   "MsgSetHotRoutesResponse": function() { return /* binding */ MsgSetHotRoutesResponse; },
/* harmony export */   "MsgSetMaxPoolPointsPerBlock": function() { return /* binding */ MsgSetMaxPoolPointsPerBlock; },
/* harmony export */   "MsgSetMaxPoolPointsPerBlockResponse": function() { return /* binding */ MsgSetMaxPoolPointsPerBlockResponse; },
/* harmony export */   "MsgSetMaxPoolPointsPerTx": function() { return /* binding */ MsgSetMaxPoolPointsPerTx; },
/* harmony export */   "MsgSetMaxPoolPointsPerTxResponse": function() { return /* binding */ MsgSetMaxPoolPointsPerTxResponse; },
/* harmony export */   "MsgSetPoolWeights": function() { return /* binding */ MsgSetPoolWeights; },
/* harmony export */   "MsgSetPoolWeightsResponse": function() { return /* binding */ MsgSetPoolWeightsResponse; }
/* harmony export */ });
/* harmony import */ var _protorev__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10673);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47895);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__);



/** MsgSetHotRoutes defines the Msg/SetHotRoutes request type. */

function createBaseMsgSetHotRoutes() {
  return {
    admin: "",
    hotRoutes: []
  };
}

const MsgSetHotRoutes = {
  typeUrl: "/osmosis.protorev.v1beta1.MsgSetHotRoutes",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (message.admin !== "") {
      writer.uint32(10).string(message.admin);
    }

    for (const v of message.hotRoutes) {
      _protorev__WEBPACK_IMPORTED_MODULE_0__.TokenPairArbRoutes.encode(v, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgSetHotRoutes();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.admin = reader.string();
          break;

        case 2:
          message.hotRoutes.push(_protorev__WEBPACK_IMPORTED_MODULE_0__.TokenPairArbRoutes.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$admin, _object$hotRoutes;

    const message = createBaseMsgSetHotRoutes();
    message.admin = (_object$admin = object.admin) !== null && _object$admin !== void 0 ? _object$admin : "";
    message.hotRoutes = ((_object$hotRoutes = object.hotRoutes) === null || _object$hotRoutes === void 0 ? void 0 : _object$hotRoutes.map(e => _protorev__WEBPACK_IMPORTED_MODULE_0__.TokenPairArbRoutes.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      admin: object.admin,
      hotRoutes: Array.isArray(object === null || object === void 0 ? void 0 : object.hot_routes) ? object.hot_routes.map(e => _protorev__WEBPACK_IMPORTED_MODULE_0__.TokenPairArbRoutes.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.admin = message.admin;

    if (message.hotRoutes) {
      obj.hot_routes = message.hotRoutes.map(e => e ? _protorev__WEBPACK_IMPORTED_MODULE_0__.TokenPairArbRoutes.toAmino(e) : undefined);
    } else {
      obj.hot_routes = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return MsgSetHotRoutes.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/MsgSetHotRoutes",
      value: MsgSetHotRoutes.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgSetHotRoutes.decode(message.value);
  },

  toProto(message) {
    return MsgSetHotRoutes.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.protorev.v1beta1.MsgSetHotRoutes",
      value: MsgSetHotRoutes.encode(message).finish()
    };
  }

};

function createBaseMsgSetHotRoutesResponse() {
  return {};
}

const MsgSetHotRoutesResponse = {
  typeUrl: "/osmosis.protorev.v1beta1.MsgSetHotRoutesResponse",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgSetHotRoutesResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseMsgSetHotRoutesResponse();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return MsgSetHotRoutesResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/protorev/set-hot-routes-response",
      value: MsgSetHotRoutesResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgSetHotRoutesResponse.decode(message.value);
  },

  toProto(message) {
    return MsgSetHotRoutesResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.protorev.v1beta1.MsgSetHotRoutesResponse",
      value: MsgSetHotRoutesResponse.encode(message).finish()
    };
  }

};

function createBaseMsgSetDeveloperAccount() {
  return {
    admin: "",
    developerAccount: ""
  };
}

const MsgSetDeveloperAccount = {
  typeUrl: "/osmosis.protorev.v1beta1.MsgSetDeveloperAccount",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (message.admin !== "") {
      writer.uint32(10).string(message.admin);
    }

    if (message.developerAccount !== "") {
      writer.uint32(18).string(message.developerAccount);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgSetDeveloperAccount();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.admin = reader.string();
          break;

        case 2:
          message.developerAccount = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$admin2, _object$developerAcco;

    const message = createBaseMsgSetDeveloperAccount();
    message.admin = (_object$admin2 = object.admin) !== null && _object$admin2 !== void 0 ? _object$admin2 : "";
    message.developerAccount = (_object$developerAcco = object.developerAccount) !== null && _object$developerAcco !== void 0 ? _object$developerAcco : "";
    return message;
  },

  fromAmino(object) {
    return {
      admin: object.admin,
      developerAccount: object.developer_account
    };
  },

  toAmino(message) {
    const obj = {};
    obj.admin = message.admin;
    obj.developer_account = message.developerAccount;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgSetDeveloperAccount.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/MsgSetDeveloperAccount",
      value: MsgSetDeveloperAccount.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgSetDeveloperAccount.decode(message.value);
  },

  toProto(message) {
    return MsgSetDeveloperAccount.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.protorev.v1beta1.MsgSetDeveloperAccount",
      value: MsgSetDeveloperAccount.encode(message).finish()
    };
  }

};

function createBaseMsgSetDeveloperAccountResponse() {
  return {};
}

const MsgSetDeveloperAccountResponse = {
  typeUrl: "/osmosis.protorev.v1beta1.MsgSetDeveloperAccountResponse",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgSetDeveloperAccountResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseMsgSetDeveloperAccountResponse();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return MsgSetDeveloperAccountResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/protorev/set-developer-account-response",
      value: MsgSetDeveloperAccountResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgSetDeveloperAccountResponse.decode(message.value);
  },

  toProto(message) {
    return MsgSetDeveloperAccountResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.protorev.v1beta1.MsgSetDeveloperAccountResponse",
      value: MsgSetDeveloperAccountResponse.encode(message).finish()
    };
  }

};

function createBaseMsgSetPoolWeights() {
  return {
    admin: "",
    poolWeights: undefined
  };
}

const MsgSetPoolWeights = {
  typeUrl: "/osmosis.protorev.v1beta1.MsgSetPoolWeights",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (message.admin !== "") {
      writer.uint32(10).string(message.admin);
    }

    if (message.poolWeights !== undefined) {
      _protorev__WEBPACK_IMPORTED_MODULE_0__.PoolWeights.encode(message.poolWeights, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgSetPoolWeights();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.admin = reader.string();
          break;

        case 2:
          message.poolWeights = _protorev__WEBPACK_IMPORTED_MODULE_0__.PoolWeights.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$admin3;

    const message = createBaseMsgSetPoolWeights();
    message.admin = (_object$admin3 = object.admin) !== null && _object$admin3 !== void 0 ? _object$admin3 : "";
    message.poolWeights = object.poolWeights !== undefined && object.poolWeights !== null ? _protorev__WEBPACK_IMPORTED_MODULE_0__.PoolWeights.fromPartial(object.poolWeights) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      admin: object.admin,
      poolWeights: object !== null && object !== void 0 && object.pool_weights ? _protorev__WEBPACK_IMPORTED_MODULE_0__.PoolWeights.fromAmino(object.pool_weights) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.admin = message.admin;
    obj.pool_weights = message.poolWeights ? _protorev__WEBPACK_IMPORTED_MODULE_0__.PoolWeights.toAmino(message.poolWeights) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgSetPoolWeights.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/protorev/set-pool-weights",
      value: MsgSetPoolWeights.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgSetPoolWeights.decode(message.value);
  },

  toProto(message) {
    return MsgSetPoolWeights.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.protorev.v1beta1.MsgSetPoolWeights",
      value: MsgSetPoolWeights.encode(message).finish()
    };
  }

};

function createBaseMsgSetPoolWeightsResponse() {
  return {};
}

const MsgSetPoolWeightsResponse = {
  typeUrl: "/osmosis.protorev.v1beta1.MsgSetPoolWeightsResponse",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgSetPoolWeightsResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseMsgSetPoolWeightsResponse();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return MsgSetPoolWeightsResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/protorev/set-pool-weights-response",
      value: MsgSetPoolWeightsResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgSetPoolWeightsResponse.decode(message.value);
  },

  toProto(message) {
    return MsgSetPoolWeightsResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.protorev.v1beta1.MsgSetPoolWeightsResponse",
      value: MsgSetPoolWeightsResponse.encode(message).finish()
    };
  }

};

function createBaseMsgSetMaxPoolPointsPerTx() {
  return {
    admin: "",
    maxPoolPointsPerTx: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.UZERO */ .dK.UZERO
  };
}

const MsgSetMaxPoolPointsPerTx = {
  typeUrl: "/osmosis.protorev.v1beta1.MsgSetMaxPoolPointsPerTx",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (message.admin !== "") {
      writer.uint32(10).string(message.admin);
    }

    if (!message.maxPoolPointsPerTx.isZero()) {
      writer.uint32(16).uint64(message.maxPoolPointsPerTx);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgSetMaxPoolPointsPerTx();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.admin = reader.string();
          break;

        case 2:
          message.maxPoolPointsPerTx = reader.uint64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$admin4;

    const message = createBaseMsgSetMaxPoolPointsPerTx();
    message.admin = (_object$admin4 = object.admin) !== null && _object$admin4 !== void 0 ? _object$admin4 : "";
    message.maxPoolPointsPerTx = object.maxPoolPointsPerTx !== undefined && object.maxPoolPointsPerTx !== null ? _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromValue */ .dK.fromValue(object.maxPoolPointsPerTx) : _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.UZERO */ .dK.UZERO;
    return message;
  },

  fromAmino(object) {
    return {
      admin: object.admin,
      maxPoolPointsPerTx: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromString */ .dK.fromString(object.max_pool_points_per_tx)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.admin = message.admin;
    obj.max_pool_points_per_tx = message.maxPoolPointsPerTx ? message.maxPoolPointsPerTx.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgSetMaxPoolPointsPerTx.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/protorev/set-max-pool-points-per-tx",
      value: MsgSetMaxPoolPointsPerTx.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgSetMaxPoolPointsPerTx.decode(message.value);
  },

  toProto(message) {
    return MsgSetMaxPoolPointsPerTx.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.protorev.v1beta1.MsgSetMaxPoolPointsPerTx",
      value: MsgSetMaxPoolPointsPerTx.encode(message).finish()
    };
  }

};

function createBaseMsgSetMaxPoolPointsPerTxResponse() {
  return {};
}

const MsgSetMaxPoolPointsPerTxResponse = {
  typeUrl: "/osmosis.protorev.v1beta1.MsgSetMaxPoolPointsPerTxResponse",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgSetMaxPoolPointsPerTxResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseMsgSetMaxPoolPointsPerTxResponse();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return MsgSetMaxPoolPointsPerTxResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/protorev/set-max-pool-points-per-tx-response",
      value: MsgSetMaxPoolPointsPerTxResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgSetMaxPoolPointsPerTxResponse.decode(message.value);
  },

  toProto(message) {
    return MsgSetMaxPoolPointsPerTxResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.protorev.v1beta1.MsgSetMaxPoolPointsPerTxResponse",
      value: MsgSetMaxPoolPointsPerTxResponse.encode(message).finish()
    };
  }

};

function createBaseMsgSetMaxPoolPointsPerBlock() {
  return {
    admin: "",
    maxPoolPointsPerBlock: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.UZERO */ .dK.UZERO
  };
}

const MsgSetMaxPoolPointsPerBlock = {
  typeUrl: "/osmosis.protorev.v1beta1.MsgSetMaxPoolPointsPerBlock",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (message.admin !== "") {
      writer.uint32(10).string(message.admin);
    }

    if (!message.maxPoolPointsPerBlock.isZero()) {
      writer.uint32(16).uint64(message.maxPoolPointsPerBlock);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgSetMaxPoolPointsPerBlock();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.admin = reader.string();
          break;

        case 2:
          message.maxPoolPointsPerBlock = reader.uint64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$admin5;

    const message = createBaseMsgSetMaxPoolPointsPerBlock();
    message.admin = (_object$admin5 = object.admin) !== null && _object$admin5 !== void 0 ? _object$admin5 : "";
    message.maxPoolPointsPerBlock = object.maxPoolPointsPerBlock !== undefined && object.maxPoolPointsPerBlock !== null ? _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromValue */ .dK.fromValue(object.maxPoolPointsPerBlock) : _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.UZERO */ .dK.UZERO;
    return message;
  },

  fromAmino(object) {
    return {
      admin: object.admin,
      maxPoolPointsPerBlock: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromString */ .dK.fromString(object.max_pool_points_per_block)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.admin = message.admin;
    obj.max_pool_points_per_block = message.maxPoolPointsPerBlock ? message.maxPoolPointsPerBlock.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgSetMaxPoolPointsPerBlock.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/protorev/set-max-pool-points-per-block",
      value: MsgSetMaxPoolPointsPerBlock.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgSetMaxPoolPointsPerBlock.decode(message.value);
  },

  toProto(message) {
    return MsgSetMaxPoolPointsPerBlock.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.protorev.v1beta1.MsgSetMaxPoolPointsPerBlock",
      value: MsgSetMaxPoolPointsPerBlock.encode(message).finish()
    };
  }

};

function createBaseMsgSetMaxPoolPointsPerBlockResponse() {
  return {};
}

const MsgSetMaxPoolPointsPerBlockResponse = {
  typeUrl: "/osmosis.protorev.v1beta1.MsgSetMaxPoolPointsPerBlockResponse",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgSetMaxPoolPointsPerBlockResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseMsgSetMaxPoolPointsPerBlockResponse();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return MsgSetMaxPoolPointsPerBlockResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/protorev/set-max-pool-points-per-block-response",
      value: MsgSetMaxPoolPointsPerBlockResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgSetMaxPoolPointsPerBlockResponse.decode(message.value);
  },

  toProto(message) {
    return MsgSetMaxPoolPointsPerBlockResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.protorev.v1beta1.MsgSetMaxPoolPointsPerBlockResponse",
      value: MsgSetMaxPoolPointsPerBlockResponse.encode(message).finish()
    };
  }

};

function createBaseMsgSetBaseDenoms() {
  return {
    admin: "",
    baseDenoms: []
  };
}

const MsgSetBaseDenoms = {
  typeUrl: "/osmosis.protorev.v1beta1.MsgSetBaseDenoms",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (message.admin !== "") {
      writer.uint32(10).string(message.admin);
    }

    for (const v of message.baseDenoms) {
      _protorev__WEBPACK_IMPORTED_MODULE_0__.BaseDenom.encode(v, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgSetBaseDenoms();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.admin = reader.string();
          break;

        case 2:
          message.baseDenoms.push(_protorev__WEBPACK_IMPORTED_MODULE_0__.BaseDenom.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$admin6, _object$baseDenoms;

    const message = createBaseMsgSetBaseDenoms();
    message.admin = (_object$admin6 = object.admin) !== null && _object$admin6 !== void 0 ? _object$admin6 : "";
    message.baseDenoms = ((_object$baseDenoms = object.baseDenoms) === null || _object$baseDenoms === void 0 ? void 0 : _object$baseDenoms.map(e => _protorev__WEBPACK_IMPORTED_MODULE_0__.BaseDenom.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      admin: object.admin,
      baseDenoms: Array.isArray(object === null || object === void 0 ? void 0 : object.base_denoms) ? object.base_denoms.map(e => _protorev__WEBPACK_IMPORTED_MODULE_0__.BaseDenom.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.admin = message.admin;

    if (message.baseDenoms) {
      obj.base_denoms = message.baseDenoms.map(e => e ? _protorev__WEBPACK_IMPORTED_MODULE_0__.BaseDenom.toAmino(e) : undefined);
    } else {
      obj.base_denoms = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return MsgSetBaseDenoms.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/protorev/set-base-denoms",
      value: MsgSetBaseDenoms.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgSetBaseDenoms.decode(message.value);
  },

  toProto(message) {
    return MsgSetBaseDenoms.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.protorev.v1beta1.MsgSetBaseDenoms",
      value: MsgSetBaseDenoms.encode(message).finish()
    };
  }

};

function createBaseMsgSetBaseDenomsResponse() {
  return {};
}

const MsgSetBaseDenomsResponse = {
  typeUrl: "/osmosis.protorev.v1beta1.MsgSetBaseDenomsResponse",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgSetBaseDenomsResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseMsgSetBaseDenomsResponse();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return MsgSetBaseDenomsResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/protorev/set-base-denoms-response",
      value: MsgSetBaseDenomsResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgSetBaseDenomsResponse.decode(message.value);
  },

  toProto(message) {
    return MsgSetBaseDenomsResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.protorev.v1beta1.MsgSetBaseDenomsResponse",
      value: MsgSetBaseDenomsResponse.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 19304:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MsgClientImpl": function() { return /* binding */ MsgClientImpl; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4942);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _tx__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97560);



class MsgClientImpl {
  constructor(rpc) {
    (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, "rpc", void 0);

    this.rpc = rpc;
    this.setHotRoutes = this.setHotRoutes.bind(this);
    this.setDeveloperAccount = this.setDeveloperAccount.bind(this);
    this.setMaxPoolPointsPerTx = this.setMaxPoolPointsPerTx.bind(this);
    this.setMaxPoolPointsPerBlock = this.setMaxPoolPointsPerBlock.bind(this);
    this.setPoolWeights = this.setPoolWeights.bind(this);
    this.setBaseDenoms = this.setBaseDenoms.bind(this);
  }

  setHotRoutes(request) {
    const data = _tx__WEBPACK_IMPORTED_MODULE_1__.MsgSetHotRoutes.encode(request).finish();
    const promise = this.rpc.request("osmosis.protorev.v1beta1.Msg", "SetHotRoutes", data);
    return promise.then(data => _tx__WEBPACK_IMPORTED_MODULE_1__.MsgSetHotRoutesResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  setDeveloperAccount(request) {
    const data = _tx__WEBPACK_IMPORTED_MODULE_1__.MsgSetDeveloperAccount.encode(request).finish();
    const promise = this.rpc.request("osmosis.protorev.v1beta1.Msg", "SetDeveloperAccount", data);
    return promise.then(data => _tx__WEBPACK_IMPORTED_MODULE_1__.MsgSetDeveloperAccountResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  setMaxPoolPointsPerTx(request) {
    const data = _tx__WEBPACK_IMPORTED_MODULE_1__.MsgSetMaxPoolPointsPerTx.encode(request).finish();
    const promise = this.rpc.request("osmosis.protorev.v1beta1.Msg", "SetMaxPoolPointsPerTx", data);
    return promise.then(data => _tx__WEBPACK_IMPORTED_MODULE_1__.MsgSetMaxPoolPointsPerTxResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  setMaxPoolPointsPerBlock(request) {
    const data = _tx__WEBPACK_IMPORTED_MODULE_1__.MsgSetMaxPoolPointsPerBlock.encode(request).finish();
    const promise = this.rpc.request("osmosis.protorev.v1beta1.Msg", "SetMaxPoolPointsPerBlock", data);
    return promise.then(data => _tx__WEBPACK_IMPORTED_MODULE_1__.MsgSetMaxPoolPointsPerBlockResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  setPoolWeights(request) {
    const data = _tx__WEBPACK_IMPORTED_MODULE_1__.MsgSetPoolWeights.encode(request).finish();
    const promise = this.rpc.request("osmosis.protorev.v1beta1.Msg", "SetPoolWeights", data);
    return promise.then(data => _tx__WEBPACK_IMPORTED_MODULE_1__.MsgSetPoolWeightsResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  setBaseDenoms(request) {
    const data = _tx__WEBPACK_IMPORTED_MODULE_1__.MsgSetBaseDenoms.encode(request).finish();
    const promise = this.rpc.request("osmosis.protorev.v1beta1.Msg", "SetBaseDenoms", data);
    return promise.then(data => _tx__WEBPACK_IMPORTED_MODULE_1__.MsgSetBaseDenomsResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

}

/***/ }),

/***/ 97866:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Params": function() { return /* binding */ Params; }
/* harmony export */ });
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__);

/** Params holds parameters for the superfluid module */

function createBaseParams() {
  return {
    minimumRiskFactor: ""
  };
}

const Params = {
  typeUrl: "/osmosis.superfluid.Params",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Writer.create()) {
    if (message.minimumRiskFactor !== "") {
      writer.uint32(10).string(message.minimumRiskFactor);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseParams();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.minimumRiskFactor = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$minimumRiskFa;

    const message = createBaseParams();
    message.minimumRiskFactor = (_object$minimumRiskFa = object.minimumRiskFactor) !== null && _object$minimumRiskFa !== void 0 ? _object$minimumRiskFa : "";
    return message;
  },

  fromAmino(object) {
    return {
      minimumRiskFactor: object.minimum_risk_factor
    };
  },

  toAmino(message) {
    const obj = {};
    obj.minimum_risk_factor = message.minimumRiskFactor;
    return obj;
  },

  fromAminoMsg(object) {
    return Params.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/params",
      value: Params.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return Params.decode(message.value);
  },

  toProto(message) {
    return Params.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.superfluid.Params",
      value: Params.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 71459:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AllAssetsRequest": function() { return /* binding */ AllAssetsRequest; },
/* harmony export */   "AllAssetsResponse": function() { return /* binding */ AllAssetsResponse; },
/* harmony export */   "AllIntermediaryAccountsRequest": function() { return /* binding */ AllIntermediaryAccountsRequest; },
/* harmony export */   "AllIntermediaryAccountsResponse": function() { return /* binding */ AllIntermediaryAccountsResponse; },
/* harmony export */   "AssetMultiplierRequest": function() { return /* binding */ AssetMultiplierRequest; },
/* harmony export */   "AssetMultiplierResponse": function() { return /* binding */ AssetMultiplierResponse; },
/* harmony export */   "AssetTypeRequest": function() { return /* binding */ AssetTypeRequest; },
/* harmony export */   "AssetTypeResponse": function() { return /* binding */ AssetTypeResponse; },
/* harmony export */   "ConnectedIntermediaryAccountRequest": function() { return /* binding */ ConnectedIntermediaryAccountRequest; },
/* harmony export */   "ConnectedIntermediaryAccountResponse": function() { return /* binding */ ConnectedIntermediaryAccountResponse; },
/* harmony export */   "Delegations": function() { return /* binding */ Delegations; },
/* harmony export */   "EstimateSuperfluidDelegatedAmountByValidatorDenomRequest": function() { return /* binding */ EstimateSuperfluidDelegatedAmountByValidatorDenomRequest; },
/* harmony export */   "EstimateSuperfluidDelegatedAmountByValidatorDenomResponse": function() { return /* binding */ EstimateSuperfluidDelegatedAmountByValidatorDenomResponse; },
/* harmony export */   "QueryParamsRequest": function() { return /* binding */ QueryParamsRequest; },
/* harmony export */   "QueryParamsResponse": function() { return /* binding */ QueryParamsResponse; },
/* harmony export */   "QueryTotalDelegationByDelegatorRequest": function() { return /* binding */ QueryTotalDelegationByDelegatorRequest; },
/* harmony export */   "QueryTotalDelegationByDelegatorResponse": function() { return /* binding */ QueryTotalDelegationByDelegatorResponse; },
/* harmony export */   "QueryTotalDelegationByValidatorForDenomRequest": function() { return /* binding */ QueryTotalDelegationByValidatorForDenomRequest; },
/* harmony export */   "QueryTotalDelegationByValidatorForDenomResponse": function() { return /* binding */ QueryTotalDelegationByValidatorForDenomResponse; },
/* harmony export */   "QueryUnpoolWhitelistRequest": function() { return /* binding */ QueryUnpoolWhitelistRequest; },
/* harmony export */   "QueryUnpoolWhitelistResponse": function() { return /* binding */ QueryUnpoolWhitelistResponse; },
/* harmony export */   "SuperfluidDelegationAmountRequest": function() { return /* binding */ SuperfluidDelegationAmountRequest; },
/* harmony export */   "SuperfluidDelegationAmountResponse": function() { return /* binding */ SuperfluidDelegationAmountResponse; },
/* harmony export */   "SuperfluidDelegationsByDelegatorRequest": function() { return /* binding */ SuperfluidDelegationsByDelegatorRequest; },
/* harmony export */   "SuperfluidDelegationsByDelegatorResponse": function() { return /* binding */ SuperfluidDelegationsByDelegatorResponse; },
/* harmony export */   "SuperfluidDelegationsByValidatorDenomRequest": function() { return /* binding */ SuperfluidDelegationsByValidatorDenomRequest; },
/* harmony export */   "SuperfluidDelegationsByValidatorDenomResponse": function() { return /* binding */ SuperfluidDelegationsByValidatorDenomResponse; },
/* harmony export */   "SuperfluidIntermediaryAccountInfo": function() { return /* binding */ SuperfluidIntermediaryAccountInfo; },
/* harmony export */   "SuperfluidUndelegationsByDelegatorRequest": function() { return /* binding */ SuperfluidUndelegationsByDelegatorRequest; },
/* harmony export */   "SuperfluidUndelegationsByDelegatorResponse": function() { return /* binding */ SuperfluidUndelegationsByDelegatorResponse; },
/* harmony export */   "TotalSuperfluidDelegationsRequest": function() { return /* binding */ TotalSuperfluidDelegationsRequest; },
/* harmony export */   "TotalSuperfluidDelegationsResponse": function() { return /* binding */ TotalSuperfluidDelegationsResponse; }
/* harmony export */ });
/* harmony import */ var _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48978);
/* harmony import */ var _params__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97866);
/* harmony import */ var _superfluid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68572);
/* harmony import */ var _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26178);
/* harmony import */ var _lockup_lock__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(24902);
/* harmony import */ var _cosmos_staking_v1beta1_staking__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(56959);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47895);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_7__);









function createBaseQueryParamsRequest() {
  return {};
}

const QueryParamsRequest = {
  typeUrl: "/osmosis.superfluid.QueryParamsRequest",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_7__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_7__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_7__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryParamsRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseQueryParamsRequest();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return QueryParamsRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/query-params-request",
      value: QueryParamsRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryParamsRequest.decode(message.value);
  },

  toProto(message) {
    return QueryParamsRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.superfluid.QueryParamsRequest",
      value: QueryParamsRequest.encode(message).finish()
    };
  }

};

function createBaseQueryParamsResponse() {
  return {
    params: undefined
  };
}

const QueryParamsResponse = {
  typeUrl: "/osmosis.superfluid.QueryParamsResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_7__.Writer.create()) {
    if (message.params !== undefined) {
      _params__WEBPACK_IMPORTED_MODULE_1__.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_7__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_7__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryParamsResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.params = _params__WEBPACK_IMPORTED_MODULE_1__.Params.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseQueryParamsResponse();
    message.params = object.params !== undefined && object.params !== null ? _params__WEBPACK_IMPORTED_MODULE_1__.Params.fromPartial(object.params) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      params: object !== null && object !== void 0 && object.params ? _params__WEBPACK_IMPORTED_MODULE_1__.Params.fromAmino(object.params) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.params = message.params ? _params__WEBPACK_IMPORTED_MODULE_1__.Params.toAmino(message.params) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryParamsResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/query-params-response",
      value: QueryParamsResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryParamsResponse.decode(message.value);
  },

  toProto(message) {
    return QueryParamsResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.superfluid.QueryParamsResponse",
      value: QueryParamsResponse.encode(message).finish()
    };
  }

};

function createBaseAssetTypeRequest() {
  return {
    denom: ""
  };
}

const AssetTypeRequest = {
  typeUrl: "/osmosis.superfluid.AssetTypeRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_7__.Writer.create()) {
    if (message.denom !== "") {
      writer.uint32(10).string(message.denom);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_7__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_7__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssetTypeRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.denom = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$denom;

    const message = createBaseAssetTypeRequest();
    message.denom = (_object$denom = object.denom) !== null && _object$denom !== void 0 ? _object$denom : "";
    return message;
  },

  fromAmino(object) {
    return {
      denom: object.denom
    };
  },

  toAmino(message) {
    const obj = {};
    obj.denom = message.denom;
    return obj;
  },

  fromAminoMsg(object) {
    return AssetTypeRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/asset-type-request",
      value: AssetTypeRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return AssetTypeRequest.decode(message.value);
  },

  toProto(message) {
    return AssetTypeRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.superfluid.AssetTypeRequest",
      value: AssetTypeRequest.encode(message).finish()
    };
  }

};

function createBaseAssetTypeResponse() {
  return {
    assetType: 0
  };
}

const AssetTypeResponse = {
  typeUrl: "/osmosis.superfluid.AssetTypeResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_7__.Writer.create()) {
    if (message.assetType !== 0) {
      writer.uint32(8).int32(message.assetType);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_7__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_7__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssetTypeResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.assetType = reader.int32();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$assetType;

    const message = createBaseAssetTypeResponse();
    message.assetType = (_object$assetType = object.assetType) !== null && _object$assetType !== void 0 ? _object$assetType : 0;
    return message;
  },

  fromAmino(object) {
    return {
      assetType: (0,_helpers__WEBPACK_IMPORTED_MODULE_6__/* .isSet */ .DM)(object.asset_type) ? (0,_superfluid__WEBPACK_IMPORTED_MODULE_2__.superfluidAssetTypeFromJSON)(object.asset_type) : 0
    };
  },

  toAmino(message) {
    const obj = {};
    obj.asset_type = message.assetType;
    return obj;
  },

  fromAminoMsg(object) {
    return AssetTypeResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/asset-type-response",
      value: AssetTypeResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return AssetTypeResponse.decode(message.value);
  },

  toProto(message) {
    return AssetTypeResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.superfluid.AssetTypeResponse",
      value: AssetTypeResponse.encode(message).finish()
    };
  }

};

function createBaseAllAssetsRequest() {
  return {};
}

const AllAssetsRequest = {
  typeUrl: "/osmosis.superfluid.AllAssetsRequest",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_7__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_7__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_7__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAllAssetsRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseAllAssetsRequest();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return AllAssetsRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/all-assets-request",
      value: AllAssetsRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return AllAssetsRequest.decode(message.value);
  },

  toProto(message) {
    return AllAssetsRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.superfluid.AllAssetsRequest",
      value: AllAssetsRequest.encode(message).finish()
    };
  }

};

function createBaseAllAssetsResponse() {
  return {
    assets: []
  };
}

const AllAssetsResponse = {
  typeUrl: "/osmosis.superfluid.AllAssetsResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_7__.Writer.create()) {
    for (const v of message.assets) {
      _superfluid__WEBPACK_IMPORTED_MODULE_2__.SuperfluidAsset.encode(v, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_7__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_7__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAllAssetsResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.assets.push(_superfluid__WEBPACK_IMPORTED_MODULE_2__.SuperfluidAsset.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$assets;

    const message = createBaseAllAssetsResponse();
    message.assets = ((_object$assets = object.assets) === null || _object$assets === void 0 ? void 0 : _object$assets.map(e => _superfluid__WEBPACK_IMPORTED_MODULE_2__.SuperfluidAsset.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      assets: Array.isArray(object === null || object === void 0 ? void 0 : object.assets) ? object.assets.map(e => _superfluid__WEBPACK_IMPORTED_MODULE_2__.SuperfluidAsset.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.assets) {
      obj.assets = message.assets.map(e => e ? _superfluid__WEBPACK_IMPORTED_MODULE_2__.SuperfluidAsset.toAmino(e) : undefined);
    } else {
      obj.assets = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return AllAssetsResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/all-assets-response",
      value: AllAssetsResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return AllAssetsResponse.decode(message.value);
  },

  toProto(message) {
    return AllAssetsResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.superfluid.AllAssetsResponse",
      value: AllAssetsResponse.encode(message).finish()
    };
  }

};

function createBaseAssetMultiplierRequest() {
  return {
    denom: ""
  };
}

const AssetMultiplierRequest = {
  typeUrl: "/osmosis.superfluid.AssetMultiplierRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_7__.Writer.create()) {
    if (message.denom !== "") {
      writer.uint32(10).string(message.denom);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_7__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_7__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssetMultiplierRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.denom = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$denom2;

    const message = createBaseAssetMultiplierRequest();
    message.denom = (_object$denom2 = object.denom) !== null && _object$denom2 !== void 0 ? _object$denom2 : "";
    return message;
  },

  fromAmino(object) {
    return {
      denom: object.denom
    };
  },

  toAmino(message) {
    const obj = {};
    obj.denom = message.denom;
    return obj;
  },

  fromAminoMsg(object) {
    return AssetMultiplierRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/asset-multiplier-request",
      value: AssetMultiplierRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return AssetMultiplierRequest.decode(message.value);
  },

  toProto(message) {
    return AssetMultiplierRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.superfluid.AssetMultiplierRequest",
      value: AssetMultiplierRequest.encode(message).finish()
    };
  }

};

function createBaseAssetMultiplierResponse() {
  return {
    osmoEquivalentMultiplier: undefined
  };
}

const AssetMultiplierResponse = {
  typeUrl: "/osmosis.superfluid.AssetMultiplierResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_7__.Writer.create()) {
    if (message.osmoEquivalentMultiplier !== undefined) {
      _superfluid__WEBPACK_IMPORTED_MODULE_2__.OsmoEquivalentMultiplierRecord.encode(message.osmoEquivalentMultiplier, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_7__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_7__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssetMultiplierResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.osmoEquivalentMultiplier = _superfluid__WEBPACK_IMPORTED_MODULE_2__.OsmoEquivalentMultiplierRecord.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseAssetMultiplierResponse();
    message.osmoEquivalentMultiplier = object.osmoEquivalentMultiplier !== undefined && object.osmoEquivalentMultiplier !== null ? _superfluid__WEBPACK_IMPORTED_MODULE_2__.OsmoEquivalentMultiplierRecord.fromPartial(object.osmoEquivalentMultiplier) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      osmoEquivalentMultiplier: object !== null && object !== void 0 && object.osmo_equivalent_multiplier ? _superfluid__WEBPACK_IMPORTED_MODULE_2__.OsmoEquivalentMultiplierRecord.fromAmino(object.osmo_equivalent_multiplier) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.osmo_equivalent_multiplier = message.osmoEquivalentMultiplier ? _superfluid__WEBPACK_IMPORTED_MODULE_2__.OsmoEquivalentMultiplierRecord.toAmino(message.osmoEquivalentMultiplier) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return AssetMultiplierResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/asset-multiplier-response",
      value: AssetMultiplierResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return AssetMultiplierResponse.decode(message.value);
  },

  toProto(message) {
    return AssetMultiplierResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.superfluid.AssetMultiplierResponse",
      value: AssetMultiplierResponse.encode(message).finish()
    };
  }

};

function createBaseSuperfluidIntermediaryAccountInfo() {
  return {
    denom: "",
    valAddr: "",
    gaugeId: _helpers__WEBPACK_IMPORTED_MODULE_6__/* .Long.UZERO */ .dK.UZERO,
    address: ""
  };
}

const SuperfluidIntermediaryAccountInfo = {
  typeUrl: "/osmosis.superfluid.SuperfluidIntermediaryAccountInfo",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_7__.Writer.create()) {
    if (message.denom !== "") {
      writer.uint32(10).string(message.denom);
    }

    if (message.valAddr !== "") {
      writer.uint32(18).string(message.valAddr);
    }

    if (!message.gaugeId.isZero()) {
      writer.uint32(24).uint64(message.gaugeId);
    }

    if (message.address !== "") {
      writer.uint32(34).string(message.address);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_7__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_7__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSuperfluidIntermediaryAccountInfo();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.denom = reader.string();
          break;

        case 2:
          message.valAddr = reader.string();
          break;

        case 3:
          message.gaugeId = reader.uint64();
          break;

        case 4:
          message.address = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$denom3, _object$valAddr, _object$address;

    const message = createBaseSuperfluidIntermediaryAccountInfo();
    message.denom = (_object$denom3 = object.denom) !== null && _object$denom3 !== void 0 ? _object$denom3 : "";
    message.valAddr = (_object$valAddr = object.valAddr) !== null && _object$valAddr !== void 0 ? _object$valAddr : "";
    message.gaugeId = object.gaugeId !== undefined && object.gaugeId !== null ? _helpers__WEBPACK_IMPORTED_MODULE_6__/* .Long.fromValue */ .dK.fromValue(object.gaugeId) : _helpers__WEBPACK_IMPORTED_MODULE_6__/* .Long.UZERO */ .dK.UZERO;
    message.address = (_object$address = object.address) !== null && _object$address !== void 0 ? _object$address : "";
    return message;
  },

  fromAmino(object) {
    return {
      denom: object.denom,
      valAddr: object.val_addr,
      gaugeId: _helpers__WEBPACK_IMPORTED_MODULE_6__/* .Long.fromString */ .dK.fromString(object.gauge_id),
      address: object.address
    };
  },

  toAmino(message) {
    const obj = {};
    obj.denom = message.denom;
    obj.val_addr = message.valAddr;
    obj.gauge_id = message.gaugeId ? message.gaugeId.toString() : undefined;
    obj.address = message.address;
    return obj;
  },

  fromAminoMsg(object) {
    return SuperfluidIntermediaryAccountInfo.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/superfluid-intermediary-account-info",
      value: SuperfluidIntermediaryAccountInfo.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return SuperfluidIntermediaryAccountInfo.decode(message.value);
  },

  toProto(message) {
    return SuperfluidIntermediaryAccountInfo.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.superfluid.SuperfluidIntermediaryAccountInfo",
      value: SuperfluidIntermediaryAccountInfo.encode(message).finish()
    };
  }

};

function createBaseAllIntermediaryAccountsRequest() {
  return {
    pagination: undefined
  };
}

const AllIntermediaryAccountsRequest = {
  typeUrl: "/osmosis.superfluid.AllIntermediaryAccountsRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_7__.Writer.create()) {
    if (message.pagination !== undefined) {
      _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_7__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_7__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAllIntermediaryAccountsRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.pagination = _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseAllIntermediaryAccountsRequest();
    message.pagination = object.pagination !== undefined && object.pagination !== null ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.fromPartial(object.pagination) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      pagination: object !== null && object !== void 0 && object.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.fromAmino(object.pagination) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.pagination = message.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageRequest.toAmino(message.pagination) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return AllIntermediaryAccountsRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/all-intermediary-accounts-request",
      value: AllIntermediaryAccountsRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return AllIntermediaryAccountsRequest.decode(message.value);
  },

  toProto(message) {
    return AllIntermediaryAccountsRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.superfluid.AllIntermediaryAccountsRequest",
      value: AllIntermediaryAccountsRequest.encode(message).finish()
    };
  }

};

function createBaseAllIntermediaryAccountsResponse() {
  return {
    accounts: [],
    pagination: undefined
  };
}

const AllIntermediaryAccountsResponse = {
  typeUrl: "/osmosis.superfluid.AllIntermediaryAccountsResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_7__.Writer.create()) {
    for (const v of message.accounts) {
      SuperfluidIntermediaryAccountInfo.encode(v, writer.uint32(10).fork()).ldelim();
    }

    if (message.pagination !== undefined) {
      _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_7__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_7__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAllIntermediaryAccountsResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.accounts.push(SuperfluidIntermediaryAccountInfo.decode(reader, reader.uint32()));
          break;

        case 2:
          message.pagination = _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$accounts;

    const message = createBaseAllIntermediaryAccountsResponse();
    message.accounts = ((_object$accounts = object.accounts) === null || _object$accounts === void 0 ? void 0 : _object$accounts.map(e => SuperfluidIntermediaryAccountInfo.fromPartial(e))) || [];
    message.pagination = object.pagination !== undefined && object.pagination !== null ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.fromPartial(object.pagination) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      accounts: Array.isArray(object === null || object === void 0 ? void 0 : object.accounts) ? object.accounts.map(e => SuperfluidIntermediaryAccountInfo.fromAmino(e)) : [],
      pagination: object !== null && object !== void 0 && object.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.fromAmino(object.pagination) : undefined
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.accounts) {
      obj.accounts = message.accounts.map(e => e ? SuperfluidIntermediaryAccountInfo.toAmino(e) : undefined);
    } else {
      obj.accounts = [];
    }

    obj.pagination = message.pagination ? _cosmos_base_query_v1beta1_pagination__WEBPACK_IMPORTED_MODULE_0__.PageResponse.toAmino(message.pagination) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return AllIntermediaryAccountsResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/all-intermediary-accounts-response",
      value: AllIntermediaryAccountsResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return AllIntermediaryAccountsResponse.decode(message.value);
  },

  toProto(message) {
    return AllIntermediaryAccountsResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.superfluid.AllIntermediaryAccountsResponse",
      value: AllIntermediaryAccountsResponse.encode(message).finish()
    };
  }

};

function createBaseConnectedIntermediaryAccountRequest() {
  return {
    lockId: _helpers__WEBPACK_IMPORTED_MODULE_6__/* .Long.UZERO */ .dK.UZERO
  };
}

const ConnectedIntermediaryAccountRequest = {
  typeUrl: "/osmosis.superfluid.ConnectedIntermediaryAccountRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_7__.Writer.create()) {
    if (!message.lockId.isZero()) {
      writer.uint32(8).uint64(message.lockId);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_7__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_7__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseConnectedIntermediaryAccountRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.lockId = reader.uint64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseConnectedIntermediaryAccountRequest();
    message.lockId = object.lockId !== undefined && object.lockId !== null ? _helpers__WEBPACK_IMPORTED_MODULE_6__/* .Long.fromValue */ .dK.fromValue(object.lockId) : _helpers__WEBPACK_IMPORTED_MODULE_6__/* .Long.UZERO */ .dK.UZERO;
    return message;
  },

  fromAmino(object) {
    return {
      lockId: _helpers__WEBPACK_IMPORTED_MODULE_6__/* .Long.fromString */ .dK.fromString(object.lock_id)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.lock_id = message.lockId ? message.lockId.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return ConnectedIntermediaryAccountRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/connected-intermediary-account-request",
      value: ConnectedIntermediaryAccountRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return ConnectedIntermediaryAccountRequest.decode(message.value);
  },

  toProto(message) {
    return ConnectedIntermediaryAccountRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.superfluid.ConnectedIntermediaryAccountRequest",
      value: ConnectedIntermediaryAccountRequest.encode(message).finish()
    };
  }

};

function createBaseConnectedIntermediaryAccountResponse() {
  return {
    account: undefined
  };
}

const ConnectedIntermediaryAccountResponse = {
  typeUrl: "/osmosis.superfluid.ConnectedIntermediaryAccountResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_7__.Writer.create()) {
    if (message.account !== undefined) {
      SuperfluidIntermediaryAccountInfo.encode(message.account, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_7__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_7__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseConnectedIntermediaryAccountResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.account = SuperfluidIntermediaryAccountInfo.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseConnectedIntermediaryAccountResponse();
    message.account = object.account !== undefined && object.account !== null ? SuperfluidIntermediaryAccountInfo.fromPartial(object.account) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      account: object !== null && object !== void 0 && object.account ? SuperfluidIntermediaryAccountInfo.fromAmino(object.account) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.account = message.account ? SuperfluidIntermediaryAccountInfo.toAmino(message.account) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return ConnectedIntermediaryAccountResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/connected-intermediary-account-response",
      value: ConnectedIntermediaryAccountResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return ConnectedIntermediaryAccountResponse.decode(message.value);
  },

  toProto(message) {
    return ConnectedIntermediaryAccountResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.superfluid.ConnectedIntermediaryAccountResponse",
      value: ConnectedIntermediaryAccountResponse.encode(message).finish()
    };
  }

};

function createBaseQueryTotalDelegationByValidatorForDenomRequest() {
  return {
    denom: ""
  };
}

const QueryTotalDelegationByValidatorForDenomRequest = {
  typeUrl: "/osmosis.superfluid.QueryTotalDelegationByValidatorForDenomRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_7__.Writer.create()) {
    if (message.denom !== "") {
      writer.uint32(10).string(message.denom);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_7__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_7__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryTotalDelegationByValidatorForDenomRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.denom = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$denom4;

    const message = createBaseQueryTotalDelegationByValidatorForDenomRequest();
    message.denom = (_object$denom4 = object.denom) !== null && _object$denom4 !== void 0 ? _object$denom4 : "";
    return message;
  },

  fromAmino(object) {
    return {
      denom: object.denom
    };
  },

  toAmino(message) {
    const obj = {};
    obj.denom = message.denom;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryTotalDelegationByValidatorForDenomRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/query-total-delegation-by-validator-for-denom-request",
      value: QueryTotalDelegationByValidatorForDenomRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryTotalDelegationByValidatorForDenomRequest.decode(message.value);
  },

  toProto(message) {
    return QueryTotalDelegationByValidatorForDenomRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.superfluid.QueryTotalDelegationByValidatorForDenomRequest",
      value: QueryTotalDelegationByValidatorForDenomRequest.encode(message).finish()
    };
  }

};

function createBaseQueryTotalDelegationByValidatorForDenomResponse() {
  return {
    assets: []
  };
}

const QueryTotalDelegationByValidatorForDenomResponse = {
  typeUrl: "/osmosis.superfluid.QueryTotalDelegationByValidatorForDenomResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_7__.Writer.create()) {
    for (const v of message.assets) {
      Delegations.encode(v, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_7__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_7__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryTotalDelegationByValidatorForDenomResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.assets.push(Delegations.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$assets2;

    const message = createBaseQueryTotalDelegationByValidatorForDenomResponse();
    message.assets = ((_object$assets2 = object.assets) === null || _object$assets2 === void 0 ? void 0 : _object$assets2.map(e => Delegations.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      assets: Array.isArray(object === null || object === void 0 ? void 0 : object.assets) ? object.assets.map(e => Delegations.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.assets) {
      obj.assets = message.assets.map(e => e ? Delegations.toAmino(e) : undefined);
    } else {
      obj.assets = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return QueryTotalDelegationByValidatorForDenomResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/query-total-delegation-by-validator-for-denom-response",
      value: QueryTotalDelegationByValidatorForDenomResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryTotalDelegationByValidatorForDenomResponse.decode(message.value);
  },

  toProto(message) {
    return QueryTotalDelegationByValidatorForDenomResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.superfluid.QueryTotalDelegationByValidatorForDenomResponse",
      value: QueryTotalDelegationByValidatorForDenomResponse.encode(message).finish()
    };
  }

};

function createBaseDelegations() {
  return {
    valAddr: "",
    amountSfsd: "",
    osmoEquivalent: ""
  };
}

const Delegations = {
  typeUrl: "/osmosis.superfluid.Delegations",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_7__.Writer.create()) {
    if (message.valAddr !== "") {
      writer.uint32(10).string(message.valAddr);
    }

    if (message.amountSfsd !== "") {
      writer.uint32(18).string(message.amountSfsd);
    }

    if (message.osmoEquivalent !== "") {
      writer.uint32(26).string(message.osmoEquivalent);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_7__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_7__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDelegations();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.valAddr = reader.string();
          break;

        case 2:
          message.amountSfsd = reader.string();
          break;

        case 3:
          message.osmoEquivalent = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$valAddr2, _object$amountSfsd, _object$osmoEquivalen;

    const message = createBaseDelegations();
    message.valAddr = (_object$valAddr2 = object.valAddr) !== null && _object$valAddr2 !== void 0 ? _object$valAddr2 : "";
    message.amountSfsd = (_object$amountSfsd = object.amountSfsd) !== null && _object$amountSfsd !== void 0 ? _object$amountSfsd : "";
    message.osmoEquivalent = (_object$osmoEquivalen = object.osmoEquivalent) !== null && _object$osmoEquivalen !== void 0 ? _object$osmoEquivalen : "";
    return message;
  },

  fromAmino(object) {
    return {
      valAddr: object.val_addr,
      amountSfsd: object.amount_sfsd,
      osmoEquivalent: object.osmo_equivalent
    };
  },

  toAmino(message) {
    const obj = {};
    obj.val_addr = message.valAddr;
    obj.amount_sfsd = message.amountSfsd;
    obj.osmo_equivalent = message.osmoEquivalent;
    return obj;
  },

  fromAminoMsg(object) {
    return Delegations.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/delegations",
      value: Delegations.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return Delegations.decode(message.value);
  },

  toProto(message) {
    return Delegations.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.superfluid.Delegations",
      value: Delegations.encode(message).finish()
    };
  }

};

function createBaseTotalSuperfluidDelegationsRequest() {
  return {};
}

const TotalSuperfluidDelegationsRequest = {
  typeUrl: "/osmosis.superfluid.TotalSuperfluidDelegationsRequest",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_7__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_7__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_7__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTotalSuperfluidDelegationsRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseTotalSuperfluidDelegationsRequest();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return TotalSuperfluidDelegationsRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/total-superfluid-delegations-request",
      value: TotalSuperfluidDelegationsRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return TotalSuperfluidDelegationsRequest.decode(message.value);
  },

  toProto(message) {
    return TotalSuperfluidDelegationsRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.superfluid.TotalSuperfluidDelegationsRequest",
      value: TotalSuperfluidDelegationsRequest.encode(message).finish()
    };
  }

};

function createBaseTotalSuperfluidDelegationsResponse() {
  return {
    totalDelegations: ""
  };
}

const TotalSuperfluidDelegationsResponse = {
  typeUrl: "/osmosis.superfluid.TotalSuperfluidDelegationsResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_7__.Writer.create()) {
    if (message.totalDelegations !== "") {
      writer.uint32(10).string(message.totalDelegations);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_7__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_7__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTotalSuperfluidDelegationsResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.totalDelegations = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$totalDelegati;

    const message = createBaseTotalSuperfluidDelegationsResponse();
    message.totalDelegations = (_object$totalDelegati = object.totalDelegations) !== null && _object$totalDelegati !== void 0 ? _object$totalDelegati : "";
    return message;
  },

  fromAmino(object) {
    return {
      totalDelegations: object.total_delegations
    };
  },

  toAmino(message) {
    const obj = {};
    obj.total_delegations = message.totalDelegations;
    return obj;
  },

  fromAminoMsg(object) {
    return TotalSuperfluidDelegationsResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/total-superfluid-delegations-response",
      value: TotalSuperfluidDelegationsResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return TotalSuperfluidDelegationsResponse.decode(message.value);
  },

  toProto(message) {
    return TotalSuperfluidDelegationsResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.superfluid.TotalSuperfluidDelegationsResponse",
      value: TotalSuperfluidDelegationsResponse.encode(message).finish()
    };
  }

};

function createBaseSuperfluidDelegationAmountRequest() {
  return {
    delegatorAddress: "",
    validatorAddress: "",
    denom: ""
  };
}

const SuperfluidDelegationAmountRequest = {
  typeUrl: "/osmosis.superfluid.SuperfluidDelegationAmountRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_7__.Writer.create()) {
    if (message.delegatorAddress !== "") {
      writer.uint32(10).string(message.delegatorAddress);
    }

    if (message.validatorAddress !== "") {
      writer.uint32(18).string(message.validatorAddress);
    }

    if (message.denom !== "") {
      writer.uint32(26).string(message.denom);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_7__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_7__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSuperfluidDelegationAmountRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.delegatorAddress = reader.string();
          break;

        case 2:
          message.validatorAddress = reader.string();
          break;

        case 3:
          message.denom = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$delegatorAddr, _object$validatorAddr, _object$denom5;

    const message = createBaseSuperfluidDelegationAmountRequest();
    message.delegatorAddress = (_object$delegatorAddr = object.delegatorAddress) !== null && _object$delegatorAddr !== void 0 ? _object$delegatorAddr : "";
    message.validatorAddress = (_object$validatorAddr = object.validatorAddress) !== null && _object$validatorAddr !== void 0 ? _object$validatorAddr : "";
    message.denom = (_object$denom5 = object.denom) !== null && _object$denom5 !== void 0 ? _object$denom5 : "";
    return message;
  },

  fromAmino(object) {
    return {
      delegatorAddress: object.delegator_address,
      validatorAddress: object.validator_address,
      denom: object.denom
    };
  },

  toAmino(message) {
    const obj = {};
    obj.delegator_address = message.delegatorAddress;
    obj.validator_address = message.validatorAddress;
    obj.denom = message.denom;
    return obj;
  },

  fromAminoMsg(object) {
    return SuperfluidDelegationAmountRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/superfluid-delegation-amount-request",
      value: SuperfluidDelegationAmountRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return SuperfluidDelegationAmountRequest.decode(message.value);
  },

  toProto(message) {
    return SuperfluidDelegationAmountRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.superfluid.SuperfluidDelegationAmountRequest",
      value: SuperfluidDelegationAmountRequest.encode(message).finish()
    };
  }

};

function createBaseSuperfluidDelegationAmountResponse() {
  return {
    amount: []
  };
}

const SuperfluidDelegationAmountResponse = {
  typeUrl: "/osmosis.superfluid.SuperfluidDelegationAmountResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_7__.Writer.create()) {
    for (const v of message.amount) {
      _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_3__.Coin.encode(v, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_7__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_7__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSuperfluidDelegationAmountResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.amount.push(_cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_3__.Coin.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$amount;

    const message = createBaseSuperfluidDelegationAmountResponse();
    message.amount = ((_object$amount = object.amount) === null || _object$amount === void 0 ? void 0 : _object$amount.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_3__.Coin.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      amount: Array.isArray(object === null || object === void 0 ? void 0 : object.amount) ? object.amount.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_3__.Coin.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.amount) {
      obj.amount = message.amount.map(e => e ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_3__.Coin.toAmino(e) : undefined);
    } else {
      obj.amount = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return SuperfluidDelegationAmountResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/superfluid-delegation-amount-response",
      value: SuperfluidDelegationAmountResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return SuperfluidDelegationAmountResponse.decode(message.value);
  },

  toProto(message) {
    return SuperfluidDelegationAmountResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.superfluid.SuperfluidDelegationAmountResponse",
      value: SuperfluidDelegationAmountResponse.encode(message).finish()
    };
  }

};

function createBaseSuperfluidDelegationsByDelegatorRequest() {
  return {
    delegatorAddress: ""
  };
}

const SuperfluidDelegationsByDelegatorRequest = {
  typeUrl: "/osmosis.superfluid.SuperfluidDelegationsByDelegatorRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_7__.Writer.create()) {
    if (message.delegatorAddress !== "") {
      writer.uint32(10).string(message.delegatorAddress);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_7__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_7__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSuperfluidDelegationsByDelegatorRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.delegatorAddress = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$delegatorAddr2;

    const message = createBaseSuperfluidDelegationsByDelegatorRequest();
    message.delegatorAddress = (_object$delegatorAddr2 = object.delegatorAddress) !== null && _object$delegatorAddr2 !== void 0 ? _object$delegatorAddr2 : "";
    return message;
  },

  fromAmino(object) {
    return {
      delegatorAddress: object.delegator_address
    };
  },

  toAmino(message) {
    const obj = {};
    obj.delegator_address = message.delegatorAddress;
    return obj;
  },

  fromAminoMsg(object) {
    return SuperfluidDelegationsByDelegatorRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/superfluid-delegations-by-delegator-request",
      value: SuperfluidDelegationsByDelegatorRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return SuperfluidDelegationsByDelegatorRequest.decode(message.value);
  },

  toProto(message) {
    return SuperfluidDelegationsByDelegatorRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.superfluid.SuperfluidDelegationsByDelegatorRequest",
      value: SuperfluidDelegationsByDelegatorRequest.encode(message).finish()
    };
  }

};

function createBaseSuperfluidDelegationsByDelegatorResponse() {
  return {
    superfluidDelegationRecords: [],
    totalDelegatedCoins: [],
    totalEquivalentStakedAmount: undefined
  };
}

const SuperfluidDelegationsByDelegatorResponse = {
  typeUrl: "/osmosis.superfluid.SuperfluidDelegationsByDelegatorResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_7__.Writer.create()) {
    for (const v of message.superfluidDelegationRecords) {
      _superfluid__WEBPACK_IMPORTED_MODULE_2__.SuperfluidDelegationRecord.encode(v, writer.uint32(10).fork()).ldelim();
    }

    for (const v of message.totalDelegatedCoins) {
      _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_3__.Coin.encode(v, writer.uint32(18).fork()).ldelim();
    }

    if (message.totalEquivalentStakedAmount !== undefined) {
      _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_3__.Coin.encode(message.totalEquivalentStakedAmount, writer.uint32(26).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_7__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_7__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSuperfluidDelegationsByDelegatorResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.superfluidDelegationRecords.push(_superfluid__WEBPACK_IMPORTED_MODULE_2__.SuperfluidDelegationRecord.decode(reader, reader.uint32()));
          break;

        case 2:
          message.totalDelegatedCoins.push(_cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_3__.Coin.decode(reader, reader.uint32()));
          break;

        case 3:
          message.totalEquivalentStakedAmount = _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_3__.Coin.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$superfluidDel, _object$totalDelegate;

    const message = createBaseSuperfluidDelegationsByDelegatorResponse();
    message.superfluidDelegationRecords = ((_object$superfluidDel = object.superfluidDelegationRecords) === null || _object$superfluidDel === void 0 ? void 0 : _object$superfluidDel.map(e => _superfluid__WEBPACK_IMPORTED_MODULE_2__.SuperfluidDelegationRecord.fromPartial(e))) || [];
    message.totalDelegatedCoins = ((_object$totalDelegate = object.totalDelegatedCoins) === null || _object$totalDelegate === void 0 ? void 0 : _object$totalDelegate.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_3__.Coin.fromPartial(e))) || [];
    message.totalEquivalentStakedAmount = object.totalEquivalentStakedAmount !== undefined && object.totalEquivalentStakedAmount !== null ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_3__.Coin.fromPartial(object.totalEquivalentStakedAmount) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      superfluidDelegationRecords: Array.isArray(object === null || object === void 0 ? void 0 : object.superfluid_delegation_records) ? object.superfluid_delegation_records.map(e => _superfluid__WEBPACK_IMPORTED_MODULE_2__.SuperfluidDelegationRecord.fromAmino(e)) : [],
      totalDelegatedCoins: Array.isArray(object === null || object === void 0 ? void 0 : object.total_delegated_coins) ? object.total_delegated_coins.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_3__.Coin.fromAmino(e)) : [],
      totalEquivalentStakedAmount: object !== null && object !== void 0 && object.total_equivalent_staked_amount ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_3__.Coin.fromAmino(object.total_equivalent_staked_amount) : undefined
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.superfluidDelegationRecords) {
      obj.superfluid_delegation_records = message.superfluidDelegationRecords.map(e => e ? _superfluid__WEBPACK_IMPORTED_MODULE_2__.SuperfluidDelegationRecord.toAmino(e) : undefined);
    } else {
      obj.superfluid_delegation_records = [];
    }

    if (message.totalDelegatedCoins) {
      obj.total_delegated_coins = message.totalDelegatedCoins.map(e => e ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_3__.Coin.toAmino(e) : undefined);
    } else {
      obj.total_delegated_coins = [];
    }

    obj.total_equivalent_staked_amount = message.totalEquivalentStakedAmount ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_3__.Coin.toAmino(message.totalEquivalentStakedAmount) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return SuperfluidDelegationsByDelegatorResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/superfluid-delegations-by-delegator-response",
      value: SuperfluidDelegationsByDelegatorResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return SuperfluidDelegationsByDelegatorResponse.decode(message.value);
  },

  toProto(message) {
    return SuperfluidDelegationsByDelegatorResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.superfluid.SuperfluidDelegationsByDelegatorResponse",
      value: SuperfluidDelegationsByDelegatorResponse.encode(message).finish()
    };
  }

};

function createBaseSuperfluidUndelegationsByDelegatorRequest() {
  return {
    delegatorAddress: "",
    denom: ""
  };
}

const SuperfluidUndelegationsByDelegatorRequest = {
  typeUrl: "/osmosis.superfluid.SuperfluidUndelegationsByDelegatorRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_7__.Writer.create()) {
    if (message.delegatorAddress !== "") {
      writer.uint32(10).string(message.delegatorAddress);
    }

    if (message.denom !== "") {
      writer.uint32(18).string(message.denom);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_7__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_7__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSuperfluidUndelegationsByDelegatorRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.delegatorAddress = reader.string();
          break;

        case 2:
          message.denom = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$delegatorAddr3, _object$denom6;

    const message = createBaseSuperfluidUndelegationsByDelegatorRequest();
    message.delegatorAddress = (_object$delegatorAddr3 = object.delegatorAddress) !== null && _object$delegatorAddr3 !== void 0 ? _object$delegatorAddr3 : "";
    message.denom = (_object$denom6 = object.denom) !== null && _object$denom6 !== void 0 ? _object$denom6 : "";
    return message;
  },

  fromAmino(object) {
    return {
      delegatorAddress: object.delegator_address,
      denom: object.denom
    };
  },

  toAmino(message) {
    const obj = {};
    obj.delegator_address = message.delegatorAddress;
    obj.denom = message.denom;
    return obj;
  },

  fromAminoMsg(object) {
    return SuperfluidUndelegationsByDelegatorRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/superfluid-undelegations-by-delegator-request",
      value: SuperfluidUndelegationsByDelegatorRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return SuperfluidUndelegationsByDelegatorRequest.decode(message.value);
  },

  toProto(message) {
    return SuperfluidUndelegationsByDelegatorRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.superfluid.SuperfluidUndelegationsByDelegatorRequest",
      value: SuperfluidUndelegationsByDelegatorRequest.encode(message).finish()
    };
  }

};

function createBaseSuperfluidUndelegationsByDelegatorResponse() {
  return {
    superfluidDelegationRecords: [],
    totalUndelegatedCoins: [],
    syntheticLocks: []
  };
}

const SuperfluidUndelegationsByDelegatorResponse = {
  typeUrl: "/osmosis.superfluid.SuperfluidUndelegationsByDelegatorResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_7__.Writer.create()) {
    for (const v of message.superfluidDelegationRecords) {
      _superfluid__WEBPACK_IMPORTED_MODULE_2__.SuperfluidDelegationRecord.encode(v, writer.uint32(10).fork()).ldelim();
    }

    for (const v of message.totalUndelegatedCoins) {
      _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_3__.Coin.encode(v, writer.uint32(18).fork()).ldelim();
    }

    for (const v of message.syntheticLocks) {
      _lockup_lock__WEBPACK_IMPORTED_MODULE_4__.SyntheticLock.encode(v, writer.uint32(26).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_7__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_7__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSuperfluidUndelegationsByDelegatorResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.superfluidDelegationRecords.push(_superfluid__WEBPACK_IMPORTED_MODULE_2__.SuperfluidDelegationRecord.decode(reader, reader.uint32()));
          break;

        case 2:
          message.totalUndelegatedCoins.push(_cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_3__.Coin.decode(reader, reader.uint32()));
          break;

        case 3:
          message.syntheticLocks.push(_lockup_lock__WEBPACK_IMPORTED_MODULE_4__.SyntheticLock.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$superfluidDel2, _object$totalUndelega, _object$syntheticLock;

    const message = createBaseSuperfluidUndelegationsByDelegatorResponse();
    message.superfluidDelegationRecords = ((_object$superfluidDel2 = object.superfluidDelegationRecords) === null || _object$superfluidDel2 === void 0 ? void 0 : _object$superfluidDel2.map(e => _superfluid__WEBPACK_IMPORTED_MODULE_2__.SuperfluidDelegationRecord.fromPartial(e))) || [];
    message.totalUndelegatedCoins = ((_object$totalUndelega = object.totalUndelegatedCoins) === null || _object$totalUndelega === void 0 ? void 0 : _object$totalUndelega.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_3__.Coin.fromPartial(e))) || [];
    message.syntheticLocks = ((_object$syntheticLock = object.syntheticLocks) === null || _object$syntheticLock === void 0 ? void 0 : _object$syntheticLock.map(e => _lockup_lock__WEBPACK_IMPORTED_MODULE_4__.SyntheticLock.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      superfluidDelegationRecords: Array.isArray(object === null || object === void 0 ? void 0 : object.superfluid_delegation_records) ? object.superfluid_delegation_records.map(e => _superfluid__WEBPACK_IMPORTED_MODULE_2__.SuperfluidDelegationRecord.fromAmino(e)) : [],
      totalUndelegatedCoins: Array.isArray(object === null || object === void 0 ? void 0 : object.total_undelegated_coins) ? object.total_undelegated_coins.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_3__.Coin.fromAmino(e)) : [],
      syntheticLocks: Array.isArray(object === null || object === void 0 ? void 0 : object.synthetic_locks) ? object.synthetic_locks.map(e => _lockup_lock__WEBPACK_IMPORTED_MODULE_4__.SyntheticLock.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.superfluidDelegationRecords) {
      obj.superfluid_delegation_records = message.superfluidDelegationRecords.map(e => e ? _superfluid__WEBPACK_IMPORTED_MODULE_2__.SuperfluidDelegationRecord.toAmino(e) : undefined);
    } else {
      obj.superfluid_delegation_records = [];
    }

    if (message.totalUndelegatedCoins) {
      obj.total_undelegated_coins = message.totalUndelegatedCoins.map(e => e ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_3__.Coin.toAmino(e) : undefined);
    } else {
      obj.total_undelegated_coins = [];
    }

    if (message.syntheticLocks) {
      obj.synthetic_locks = message.syntheticLocks.map(e => e ? _lockup_lock__WEBPACK_IMPORTED_MODULE_4__.SyntheticLock.toAmino(e) : undefined);
    } else {
      obj.synthetic_locks = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return SuperfluidUndelegationsByDelegatorResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/superfluid-undelegations-by-delegator-response",
      value: SuperfluidUndelegationsByDelegatorResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return SuperfluidUndelegationsByDelegatorResponse.decode(message.value);
  },

  toProto(message) {
    return SuperfluidUndelegationsByDelegatorResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.superfluid.SuperfluidUndelegationsByDelegatorResponse",
      value: SuperfluidUndelegationsByDelegatorResponse.encode(message).finish()
    };
  }

};

function createBaseSuperfluidDelegationsByValidatorDenomRequest() {
  return {
    validatorAddress: "",
    denom: ""
  };
}

const SuperfluidDelegationsByValidatorDenomRequest = {
  typeUrl: "/osmosis.superfluid.SuperfluidDelegationsByValidatorDenomRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_7__.Writer.create()) {
    if (message.validatorAddress !== "") {
      writer.uint32(10).string(message.validatorAddress);
    }

    if (message.denom !== "") {
      writer.uint32(18).string(message.denom);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_7__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_7__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSuperfluidDelegationsByValidatorDenomRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.validatorAddress = reader.string();
          break;

        case 2:
          message.denom = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$validatorAddr2, _object$denom7;

    const message = createBaseSuperfluidDelegationsByValidatorDenomRequest();
    message.validatorAddress = (_object$validatorAddr2 = object.validatorAddress) !== null && _object$validatorAddr2 !== void 0 ? _object$validatorAddr2 : "";
    message.denom = (_object$denom7 = object.denom) !== null && _object$denom7 !== void 0 ? _object$denom7 : "";
    return message;
  },

  fromAmino(object) {
    return {
      validatorAddress: object.validator_address,
      denom: object.denom
    };
  },

  toAmino(message) {
    const obj = {};
    obj.validator_address = message.validatorAddress;
    obj.denom = message.denom;
    return obj;
  },

  fromAminoMsg(object) {
    return SuperfluidDelegationsByValidatorDenomRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/superfluid-delegations-by-validator-denom-request",
      value: SuperfluidDelegationsByValidatorDenomRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return SuperfluidDelegationsByValidatorDenomRequest.decode(message.value);
  },

  toProto(message) {
    return SuperfluidDelegationsByValidatorDenomRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.superfluid.SuperfluidDelegationsByValidatorDenomRequest",
      value: SuperfluidDelegationsByValidatorDenomRequest.encode(message).finish()
    };
  }

};

function createBaseSuperfluidDelegationsByValidatorDenomResponse() {
  return {
    superfluidDelegationRecords: []
  };
}

const SuperfluidDelegationsByValidatorDenomResponse = {
  typeUrl: "/osmosis.superfluid.SuperfluidDelegationsByValidatorDenomResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_7__.Writer.create()) {
    for (const v of message.superfluidDelegationRecords) {
      _superfluid__WEBPACK_IMPORTED_MODULE_2__.SuperfluidDelegationRecord.encode(v, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_7__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_7__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSuperfluidDelegationsByValidatorDenomResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.superfluidDelegationRecords.push(_superfluid__WEBPACK_IMPORTED_MODULE_2__.SuperfluidDelegationRecord.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$superfluidDel3;

    const message = createBaseSuperfluidDelegationsByValidatorDenomResponse();
    message.superfluidDelegationRecords = ((_object$superfluidDel3 = object.superfluidDelegationRecords) === null || _object$superfluidDel3 === void 0 ? void 0 : _object$superfluidDel3.map(e => _superfluid__WEBPACK_IMPORTED_MODULE_2__.SuperfluidDelegationRecord.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      superfluidDelegationRecords: Array.isArray(object === null || object === void 0 ? void 0 : object.superfluid_delegation_records) ? object.superfluid_delegation_records.map(e => _superfluid__WEBPACK_IMPORTED_MODULE_2__.SuperfluidDelegationRecord.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.superfluidDelegationRecords) {
      obj.superfluid_delegation_records = message.superfluidDelegationRecords.map(e => e ? _superfluid__WEBPACK_IMPORTED_MODULE_2__.SuperfluidDelegationRecord.toAmino(e) : undefined);
    } else {
      obj.superfluid_delegation_records = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return SuperfluidDelegationsByValidatorDenomResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/superfluid-delegations-by-validator-denom-response",
      value: SuperfluidDelegationsByValidatorDenomResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return SuperfluidDelegationsByValidatorDenomResponse.decode(message.value);
  },

  toProto(message) {
    return SuperfluidDelegationsByValidatorDenomResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.superfluid.SuperfluidDelegationsByValidatorDenomResponse",
      value: SuperfluidDelegationsByValidatorDenomResponse.encode(message).finish()
    };
  }

};

function createBaseEstimateSuperfluidDelegatedAmountByValidatorDenomRequest() {
  return {
    validatorAddress: "",
    denom: ""
  };
}

const EstimateSuperfluidDelegatedAmountByValidatorDenomRequest = {
  typeUrl: "/osmosis.superfluid.EstimateSuperfluidDelegatedAmountByValidatorDenomRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_7__.Writer.create()) {
    if (message.validatorAddress !== "") {
      writer.uint32(10).string(message.validatorAddress);
    }

    if (message.denom !== "") {
      writer.uint32(18).string(message.denom);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_7__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_7__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEstimateSuperfluidDelegatedAmountByValidatorDenomRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.validatorAddress = reader.string();
          break;

        case 2:
          message.denom = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$validatorAddr3, _object$denom8;

    const message = createBaseEstimateSuperfluidDelegatedAmountByValidatorDenomRequest();
    message.validatorAddress = (_object$validatorAddr3 = object.validatorAddress) !== null && _object$validatorAddr3 !== void 0 ? _object$validatorAddr3 : "";
    message.denom = (_object$denom8 = object.denom) !== null && _object$denom8 !== void 0 ? _object$denom8 : "";
    return message;
  },

  fromAmino(object) {
    return {
      validatorAddress: object.validator_address,
      denom: object.denom
    };
  },

  toAmino(message) {
    const obj = {};
    obj.validator_address = message.validatorAddress;
    obj.denom = message.denom;
    return obj;
  },

  fromAminoMsg(object) {
    return EstimateSuperfluidDelegatedAmountByValidatorDenomRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/estimate-superfluid-delegated-amount-by-validator-denom-request",
      value: EstimateSuperfluidDelegatedAmountByValidatorDenomRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return EstimateSuperfluidDelegatedAmountByValidatorDenomRequest.decode(message.value);
  },

  toProto(message) {
    return EstimateSuperfluidDelegatedAmountByValidatorDenomRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.superfluid.EstimateSuperfluidDelegatedAmountByValidatorDenomRequest",
      value: EstimateSuperfluidDelegatedAmountByValidatorDenomRequest.encode(message).finish()
    };
  }

};

function createBaseEstimateSuperfluidDelegatedAmountByValidatorDenomResponse() {
  return {
    totalDelegatedCoins: []
  };
}

const EstimateSuperfluidDelegatedAmountByValidatorDenomResponse = {
  typeUrl: "/osmosis.superfluid.EstimateSuperfluidDelegatedAmountByValidatorDenomResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_7__.Writer.create()) {
    for (const v of message.totalDelegatedCoins) {
      _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_3__.Coin.encode(v, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_7__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_7__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEstimateSuperfluidDelegatedAmountByValidatorDenomResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.totalDelegatedCoins.push(_cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_3__.Coin.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$totalDelegate2;

    const message = createBaseEstimateSuperfluidDelegatedAmountByValidatorDenomResponse();
    message.totalDelegatedCoins = ((_object$totalDelegate2 = object.totalDelegatedCoins) === null || _object$totalDelegate2 === void 0 ? void 0 : _object$totalDelegate2.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_3__.Coin.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      totalDelegatedCoins: Array.isArray(object === null || object === void 0 ? void 0 : object.total_delegated_coins) ? object.total_delegated_coins.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_3__.Coin.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.totalDelegatedCoins) {
      obj.total_delegated_coins = message.totalDelegatedCoins.map(e => e ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_3__.Coin.toAmino(e) : undefined);
    } else {
      obj.total_delegated_coins = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return EstimateSuperfluidDelegatedAmountByValidatorDenomResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/estimate-superfluid-delegated-amount-by-validator-denom-response",
      value: EstimateSuperfluidDelegatedAmountByValidatorDenomResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return EstimateSuperfluidDelegatedAmountByValidatorDenomResponse.decode(message.value);
  },

  toProto(message) {
    return EstimateSuperfluidDelegatedAmountByValidatorDenomResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.superfluid.EstimateSuperfluidDelegatedAmountByValidatorDenomResponse",
      value: EstimateSuperfluidDelegatedAmountByValidatorDenomResponse.encode(message).finish()
    };
  }

};

function createBaseQueryTotalDelegationByDelegatorRequest() {
  return {
    delegatorAddress: ""
  };
}

const QueryTotalDelegationByDelegatorRequest = {
  typeUrl: "/osmosis.superfluid.QueryTotalDelegationByDelegatorRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_7__.Writer.create()) {
    if (message.delegatorAddress !== "") {
      writer.uint32(10).string(message.delegatorAddress);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_7__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_7__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryTotalDelegationByDelegatorRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.delegatorAddress = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$delegatorAddr4;

    const message = createBaseQueryTotalDelegationByDelegatorRequest();
    message.delegatorAddress = (_object$delegatorAddr4 = object.delegatorAddress) !== null && _object$delegatorAddr4 !== void 0 ? _object$delegatorAddr4 : "";
    return message;
  },

  fromAmino(object) {
    return {
      delegatorAddress: object.delegator_address
    };
  },

  toAmino(message) {
    const obj = {};
    obj.delegator_address = message.delegatorAddress;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryTotalDelegationByDelegatorRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/query-total-delegation-by-delegator-request",
      value: QueryTotalDelegationByDelegatorRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryTotalDelegationByDelegatorRequest.decode(message.value);
  },

  toProto(message) {
    return QueryTotalDelegationByDelegatorRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.superfluid.QueryTotalDelegationByDelegatorRequest",
      value: QueryTotalDelegationByDelegatorRequest.encode(message).finish()
    };
  }

};

function createBaseQueryTotalDelegationByDelegatorResponse() {
  return {
    superfluidDelegationRecords: [],
    delegationResponse: [],
    totalDelegatedCoins: [],
    totalEquivalentStakedAmount: undefined
  };
}

const QueryTotalDelegationByDelegatorResponse = {
  typeUrl: "/osmosis.superfluid.QueryTotalDelegationByDelegatorResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_7__.Writer.create()) {
    for (const v of message.superfluidDelegationRecords) {
      _superfluid__WEBPACK_IMPORTED_MODULE_2__.SuperfluidDelegationRecord.encode(v, writer.uint32(10).fork()).ldelim();
    }

    for (const v of message.delegationResponse) {
      _cosmos_staking_v1beta1_staking__WEBPACK_IMPORTED_MODULE_5__.DelegationResponse.encode(v, writer.uint32(18).fork()).ldelim();
    }

    for (const v of message.totalDelegatedCoins) {
      _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_3__.Coin.encode(v, writer.uint32(26).fork()).ldelim();
    }

    if (message.totalEquivalentStakedAmount !== undefined) {
      _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_3__.Coin.encode(message.totalEquivalentStakedAmount, writer.uint32(34).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_7__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_7__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryTotalDelegationByDelegatorResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.superfluidDelegationRecords.push(_superfluid__WEBPACK_IMPORTED_MODULE_2__.SuperfluidDelegationRecord.decode(reader, reader.uint32()));
          break;

        case 2:
          message.delegationResponse.push(_cosmos_staking_v1beta1_staking__WEBPACK_IMPORTED_MODULE_5__.DelegationResponse.decode(reader, reader.uint32()));
          break;

        case 3:
          message.totalDelegatedCoins.push(_cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_3__.Coin.decode(reader, reader.uint32()));
          break;

        case 4:
          message.totalEquivalentStakedAmount = _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_3__.Coin.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$superfluidDel4, _object$delegationRes, _object$totalDelegate3;

    const message = createBaseQueryTotalDelegationByDelegatorResponse();
    message.superfluidDelegationRecords = ((_object$superfluidDel4 = object.superfluidDelegationRecords) === null || _object$superfluidDel4 === void 0 ? void 0 : _object$superfluidDel4.map(e => _superfluid__WEBPACK_IMPORTED_MODULE_2__.SuperfluidDelegationRecord.fromPartial(e))) || [];
    message.delegationResponse = ((_object$delegationRes = object.delegationResponse) === null || _object$delegationRes === void 0 ? void 0 : _object$delegationRes.map(e => _cosmos_staking_v1beta1_staking__WEBPACK_IMPORTED_MODULE_5__.DelegationResponse.fromPartial(e))) || [];
    message.totalDelegatedCoins = ((_object$totalDelegate3 = object.totalDelegatedCoins) === null || _object$totalDelegate3 === void 0 ? void 0 : _object$totalDelegate3.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_3__.Coin.fromPartial(e))) || [];
    message.totalEquivalentStakedAmount = object.totalEquivalentStakedAmount !== undefined && object.totalEquivalentStakedAmount !== null ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_3__.Coin.fromPartial(object.totalEquivalentStakedAmount) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      superfluidDelegationRecords: Array.isArray(object === null || object === void 0 ? void 0 : object.superfluid_delegation_records) ? object.superfluid_delegation_records.map(e => _superfluid__WEBPACK_IMPORTED_MODULE_2__.SuperfluidDelegationRecord.fromAmino(e)) : [],
      delegationResponse: Array.isArray(object === null || object === void 0 ? void 0 : object.delegation_response) ? object.delegation_response.map(e => _cosmos_staking_v1beta1_staking__WEBPACK_IMPORTED_MODULE_5__.DelegationResponse.fromAmino(e)) : [],
      totalDelegatedCoins: Array.isArray(object === null || object === void 0 ? void 0 : object.total_delegated_coins) ? object.total_delegated_coins.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_3__.Coin.fromAmino(e)) : [],
      totalEquivalentStakedAmount: object !== null && object !== void 0 && object.total_equivalent_staked_amount ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_3__.Coin.fromAmino(object.total_equivalent_staked_amount) : undefined
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.superfluidDelegationRecords) {
      obj.superfluid_delegation_records = message.superfluidDelegationRecords.map(e => e ? _superfluid__WEBPACK_IMPORTED_MODULE_2__.SuperfluidDelegationRecord.toAmino(e) : undefined);
    } else {
      obj.superfluid_delegation_records = [];
    }

    if (message.delegationResponse) {
      obj.delegation_response = message.delegationResponse.map(e => e ? _cosmos_staking_v1beta1_staking__WEBPACK_IMPORTED_MODULE_5__.DelegationResponse.toAmino(e) : undefined);
    } else {
      obj.delegation_response = [];
    }

    if (message.totalDelegatedCoins) {
      obj.total_delegated_coins = message.totalDelegatedCoins.map(e => e ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_3__.Coin.toAmino(e) : undefined);
    } else {
      obj.total_delegated_coins = [];
    }

    obj.total_equivalent_staked_amount = message.totalEquivalentStakedAmount ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_3__.Coin.toAmino(message.totalEquivalentStakedAmount) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryTotalDelegationByDelegatorResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/query-total-delegation-by-delegator-response",
      value: QueryTotalDelegationByDelegatorResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryTotalDelegationByDelegatorResponse.decode(message.value);
  },

  toProto(message) {
    return QueryTotalDelegationByDelegatorResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.superfluid.QueryTotalDelegationByDelegatorResponse",
      value: QueryTotalDelegationByDelegatorResponse.encode(message).finish()
    };
  }

};

function createBaseQueryUnpoolWhitelistRequest() {
  return {};
}

const QueryUnpoolWhitelistRequest = {
  typeUrl: "/osmosis.superfluid.QueryUnpoolWhitelistRequest",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_7__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_7__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_7__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryUnpoolWhitelistRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseQueryUnpoolWhitelistRequest();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return QueryUnpoolWhitelistRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/query-unpool-whitelist-request",
      value: QueryUnpoolWhitelistRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryUnpoolWhitelistRequest.decode(message.value);
  },

  toProto(message) {
    return QueryUnpoolWhitelistRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.superfluid.QueryUnpoolWhitelistRequest",
      value: QueryUnpoolWhitelistRequest.encode(message).finish()
    };
  }

};

function createBaseQueryUnpoolWhitelistResponse() {
  return {
    poolIds: []
  };
}

const QueryUnpoolWhitelistResponse = {
  typeUrl: "/osmosis.superfluid.QueryUnpoolWhitelistResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_7__.Writer.create()) {
    writer.uint32(10).fork();

    for (const v of message.poolIds) {
      writer.uint64(v);
    }

    writer.ldelim();
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_7__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_7__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryUnpoolWhitelistResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          if ((tag & 7) === 2) {
            const end2 = reader.uint32() + reader.pos;

            while (reader.pos < end2) {
              message.poolIds.push(reader.uint64());
            }
          } else {
            message.poolIds.push(reader.uint64());
          }

          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$poolIds;

    const message = createBaseQueryUnpoolWhitelistResponse();
    message.poolIds = ((_object$poolIds = object.poolIds) === null || _object$poolIds === void 0 ? void 0 : _object$poolIds.map(e => _helpers__WEBPACK_IMPORTED_MODULE_6__/* .Long.fromValue */ .dK.fromValue(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      poolIds: Array.isArray(object === null || object === void 0 ? void 0 : object.pool_ids) ? object.pool_ids.map(e => e) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.poolIds) {
      obj.pool_ids = message.poolIds.map(e => e);
    } else {
      obj.pool_ids = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return QueryUnpoolWhitelistResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/query-unpool-whitelist-response",
      value: QueryUnpoolWhitelistResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryUnpoolWhitelistResponse.decode(message.value);
  },

  toProto(message) {
    return QueryUnpoolWhitelistResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.superfluid.QueryUnpoolWhitelistResponse",
      value: QueryUnpoolWhitelistResponse.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 59893:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LCDQueryClient": function() { return /* binding */ LCDQueryClient; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4942);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47895);


class LCDQueryClient {
  constructor({
    requestClient
  }) {
    (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, "req", void 0);

    this.req = requestClient;
    this.params = this.params.bind(this);
    this.assetType = this.assetType.bind(this);
    this.allAssets = this.allAssets.bind(this);
    this.assetMultiplier = this.assetMultiplier.bind(this);
    this.allIntermediaryAccounts = this.allIntermediaryAccounts.bind(this);
    this.connectedIntermediaryAccount = this.connectedIntermediaryAccount.bind(this);
    this.totalSuperfluidDelegations = this.totalSuperfluidDelegations.bind(this);
    this.superfluidDelegationAmount = this.superfluidDelegationAmount.bind(this);
    this.superfluidDelegationsByDelegator = this.superfluidDelegationsByDelegator.bind(this);
    this.superfluidUndelegationsByDelegator = this.superfluidUndelegationsByDelegator.bind(this);
    this.superfluidDelegationsByValidatorDenom = this.superfluidDelegationsByValidatorDenom.bind(this);
    this.estimateSuperfluidDelegatedAmountByValidatorDenom = this.estimateSuperfluidDelegatedAmountByValidatorDenom.bind(this);
    this.totalDelegationByDelegator = this.totalDelegationByDelegator.bind(this);
    this.unpoolWhitelist = this.unpoolWhitelist.bind(this);
  }
  /* Params returns the total set of superfluid parameters. */


  async params(_params = {}) {
    const endpoint = `osmosis/superfluid/v1beta1/params`;
    return await this.req.get(endpoint);
  }
  /* Returns superfluid asset type, whether if it's a native asset or an lp
   share. */


  async assetType(params) {
    const options = {
      params: {}
    };

    if (typeof (params === null || params === void 0 ? void 0 : params.denom) !== "undefined") {
      options.params.denom = params.denom;
    }

    const endpoint = `osmosis/superfluid/v1beta1/asset_type`;
    return await this.req.get(endpoint, options);
  }
  /* Returns all registered superfluid assets. */


  async allAssets(_params = {}) {
    const endpoint = `osmosis/superfluid/v1beta1/all_assets`;
    return await this.req.get(endpoint);
  }
  /* Returns the osmo equivalent multiplier used in the most recent epoch. */


  async assetMultiplier(params) {
    const options = {
      params: {}
    };

    if (typeof (params === null || params === void 0 ? void 0 : params.denom) !== "undefined") {
      options.params.denom = params.denom;
    }

    const endpoint = `osmosis/superfluid/v1beta1/asset_multiplier`;
    return await this.req.get(endpoint, options);
  }
  /* Returns all superfluid intermediary accounts. */


  async allIntermediaryAccounts(params = {
    pagination: undefined
  }) {
    const options = {
      params: {}
    };

    if (typeof (params === null || params === void 0 ? void 0 : params.pagination) !== "undefined") {
      (0,_helpers__WEBPACK_IMPORTED_MODULE_0__/* .setPaginationParams */ .q6)(options, params.pagination);
    }

    const endpoint = `osmosis/superfluid/v1beta1/all_intermediary_accounts`;
    return await this.req.get(endpoint, options);
  }
  /* Returns intermediary account connected to a superfluid staked lock by id */


  async connectedIntermediaryAccount(params) {
    const endpoint = `osmosis/superfluid/v1beta1/connected_intermediary_account/${params.lockId}`;
    return await this.req.get(endpoint);
  }
  /* Returns the total amount of osmo superfluidly staked.
   Response is denominated in uosmo. */


  async totalSuperfluidDelegations(_params = {}) {
    const endpoint = `osmosis/superfluid/v1beta1/all_superfluid_delegations`;
    return await this.req.get(endpoint);
  }
  /* Returns the coins superfluid delegated for the delegator, validator, denom
   triplet */


  async superfluidDelegationAmount(params) {
    const options = {
      params: {}
    };

    if (typeof (params === null || params === void 0 ? void 0 : params.delegatorAddress) !== "undefined") {
      options.params.delegator_address = params.delegatorAddress;
    }

    if (typeof (params === null || params === void 0 ? void 0 : params.validatorAddress) !== "undefined") {
      options.params.validator_address = params.validatorAddress;
    }

    if (typeof (params === null || params === void 0 ? void 0 : params.denom) !== "undefined") {
      options.params.denom = params.denom;
    }

    const endpoint = `osmosis/superfluid/v1beta1/superfluid_delegation_amount`;
    return await this.req.get(endpoint, options);
  }
  /* Returns all the delegated superfluid poistions for a specific delegator. */


  async superfluidDelegationsByDelegator(params) {
    const endpoint = `osmosis/superfluid/v1beta1/superfluid_delegations/${params.delegatorAddress}`;
    return await this.req.get(endpoint);
  }
  /* Returns all the undelegating superfluid poistions for a specific delegator. */


  async superfluidUndelegationsByDelegator(params) {
    const options = {
      params: {}
    };

    if (typeof (params === null || params === void 0 ? void 0 : params.denom) !== "undefined") {
      options.params.denom = params.denom;
    }

    const endpoint = `osmosis/superfluid/v1beta1/superfluid_undelegations_by_delegator/${params.delegatorAddress}`;
    return await this.req.get(endpoint, options);
  }
  /* Returns all the superfluid positions of a specific denom delegated to one
   validator */


  async superfluidDelegationsByValidatorDenom(params) {
    const options = {
      params: {}
    };

    if (typeof (params === null || params === void 0 ? void 0 : params.validatorAddress) !== "undefined") {
      options.params.validator_address = params.validatorAddress;
    }

    if (typeof (params === null || params === void 0 ? void 0 : params.denom) !== "undefined") {
      options.params.denom = params.denom;
    }

    const endpoint = `osmosis/superfluid/v1beta1/superfluid_delegations_by_validator_denom`;
    return await this.req.get(endpoint, options);
  }
  /* Returns the amount of a specific denom delegated to a specific validator
   This is labeled an estimate, because the way it calculates the amount can
   lead rounding errors from the true delegated amount */


  async estimateSuperfluidDelegatedAmountByValidatorDenom(params) {
    const options = {
      params: {}
    };

    if (typeof (params === null || params === void 0 ? void 0 : params.validatorAddress) !== "undefined") {
      options.params.validator_address = params.validatorAddress;
    }

    if (typeof (params === null || params === void 0 ? void 0 : params.denom) !== "undefined") {
      options.params.denom = params.denom;
    }

    const endpoint = `osmosis/superfluid/v1beta1/estimate_superfluid_delegation_amount_by_validator_denom`;
    return await this.req.get(endpoint, options);
  }
  /* Returns the specified delegations for a specific delegator */


  async totalDelegationByDelegator(params) {
    const endpoint = `osmosis/superfluid/v1beta1/total_delegation_by_delegator/${params.delegatorAddress}`;
    return await this.req.get(endpoint);
  }
  /* Returns a list of whitelisted pool ids to unpool. */


  async unpoolWhitelist(_params = {}) {
    const endpoint = `osmosis/superfluid/v1beta1/unpool_whitelist`;
    return await this.req.get(endpoint);
  }

}

/***/ }),

/***/ 66977:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QueryClientImpl": function() { return /* binding */ QueryClientImpl; },
/* harmony export */   "createRpcQueryExtension": function() { return /* binding */ createRpcQueryExtension; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4942);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78441);
/* harmony import */ var _cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71459);




/** Query defines the gRPC querier service. */

class QueryClientImpl {
  constructor(rpc) {
    (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, "rpc", void 0);

    this.rpc = rpc;
    this.params = this.params.bind(this);
    this.assetType = this.assetType.bind(this);
    this.allAssets = this.allAssets.bind(this);
    this.assetMultiplier = this.assetMultiplier.bind(this);
    this.allIntermediaryAccounts = this.allIntermediaryAccounts.bind(this);
    this.connectedIntermediaryAccount = this.connectedIntermediaryAccount.bind(this);
    this.totalDelegationByValidatorForDenom = this.totalDelegationByValidatorForDenom.bind(this);
    this.totalSuperfluidDelegations = this.totalSuperfluidDelegations.bind(this);
    this.superfluidDelegationAmount = this.superfluidDelegationAmount.bind(this);
    this.superfluidDelegationsByDelegator = this.superfluidDelegationsByDelegator.bind(this);
    this.superfluidUndelegationsByDelegator = this.superfluidUndelegationsByDelegator.bind(this);
    this.superfluidDelegationsByValidatorDenom = this.superfluidDelegationsByValidatorDenom.bind(this);
    this.estimateSuperfluidDelegatedAmountByValidatorDenom = this.estimateSuperfluidDelegatedAmountByValidatorDenom.bind(this);
    this.totalDelegationByDelegator = this.totalDelegationByDelegator.bind(this);
    this.unpoolWhitelist = this.unpoolWhitelist.bind(this);
  }

  params(request = {}) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryParamsRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.superfluid.Query", "Params", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryParamsResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  assetType(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.AssetTypeRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.superfluid.Query", "AssetType", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.AssetTypeResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  allAssets(request = {}) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.AllAssetsRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.superfluid.Query", "AllAssets", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.AllAssetsResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  assetMultiplier(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.AssetMultiplierRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.superfluid.Query", "AssetMultiplier", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.AssetMultiplierResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  allIntermediaryAccounts(request = {
    pagination: undefined
  }) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.AllIntermediaryAccountsRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.superfluid.Query", "AllIntermediaryAccounts", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.AllIntermediaryAccountsResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  connectedIntermediaryAccount(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.ConnectedIntermediaryAccountRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.superfluid.Query", "ConnectedIntermediaryAccount", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.ConnectedIntermediaryAccountResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  totalDelegationByValidatorForDenom(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryTotalDelegationByValidatorForDenomRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.superfluid.Query", "TotalDelegationByValidatorForDenom", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryTotalDelegationByValidatorForDenomResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  totalSuperfluidDelegations(request = {}) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.TotalSuperfluidDelegationsRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.superfluid.Query", "TotalSuperfluidDelegations", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.TotalSuperfluidDelegationsResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  superfluidDelegationAmount(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.SuperfluidDelegationAmountRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.superfluid.Query", "SuperfluidDelegationAmount", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.SuperfluidDelegationAmountResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  superfluidDelegationsByDelegator(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.SuperfluidDelegationsByDelegatorRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.superfluid.Query", "SuperfluidDelegationsByDelegator", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.SuperfluidDelegationsByDelegatorResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  superfluidUndelegationsByDelegator(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.SuperfluidUndelegationsByDelegatorRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.superfluid.Query", "SuperfluidUndelegationsByDelegator", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.SuperfluidUndelegationsByDelegatorResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  superfluidDelegationsByValidatorDenom(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.SuperfluidDelegationsByValidatorDenomRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.superfluid.Query", "SuperfluidDelegationsByValidatorDenom", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.SuperfluidDelegationsByValidatorDenomResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  estimateSuperfluidDelegatedAmountByValidatorDenom(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.EstimateSuperfluidDelegatedAmountByValidatorDenomRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.superfluid.Query", "EstimateSuperfluidDelegatedAmountByValidatorDenom", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.EstimateSuperfluidDelegatedAmountByValidatorDenomResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  totalDelegationByDelegator(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryTotalDelegationByDelegatorRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.superfluid.Query", "TotalDelegationByDelegator", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryTotalDelegationByDelegatorResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  unpoolWhitelist(request = {}) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryUnpoolWhitelistRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.superfluid.Query", "UnpoolWhitelist", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryUnpoolWhitelistResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

}
const createRpcQueryExtension = base => {
  const rpc = (0,_cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1__.createProtobufRpcClient)(base);
  const queryService = new QueryClientImpl(rpc);
  return {
    params(request) {
      return queryService.params(request);
    },

    assetType(request) {
      return queryService.assetType(request);
    },

    allAssets(request) {
      return queryService.allAssets(request);
    },

    assetMultiplier(request) {
      return queryService.assetMultiplier(request);
    },

    allIntermediaryAccounts(request) {
      return queryService.allIntermediaryAccounts(request);
    },

    connectedIntermediaryAccount(request) {
      return queryService.connectedIntermediaryAccount(request);
    },

    totalDelegationByValidatorForDenom(request) {
      return queryService.totalDelegationByValidatorForDenom(request);
    },

    totalSuperfluidDelegations(request) {
      return queryService.totalSuperfluidDelegations(request);
    },

    superfluidDelegationAmount(request) {
      return queryService.superfluidDelegationAmount(request);
    },

    superfluidDelegationsByDelegator(request) {
      return queryService.superfluidDelegationsByDelegator(request);
    },

    superfluidUndelegationsByDelegator(request) {
      return queryService.superfluidUndelegationsByDelegator(request);
    },

    superfluidDelegationsByValidatorDenom(request) {
      return queryService.superfluidDelegationsByValidatorDenom(request);
    },

    estimateSuperfluidDelegatedAmountByValidatorDenom(request) {
      return queryService.estimateSuperfluidDelegatedAmountByValidatorDenom(request);
    },

    totalDelegationByDelegator(request) {
      return queryService.totalDelegationByDelegator(request);
    },

    unpoolWhitelist(request) {
      return queryService.unpoolWhitelist(request);
    }

  };
};

/***/ }),

/***/ 68572:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LockIdIntermediaryAccountConnection": function() { return /* binding */ LockIdIntermediaryAccountConnection; },
/* harmony export */   "OsmoEquivalentMultiplierRecord": function() { return /* binding */ OsmoEquivalentMultiplierRecord; },
/* harmony export */   "SuperfluidAsset": function() { return /* binding */ SuperfluidAsset; },
/* harmony export */   "SuperfluidAssetType": function() { return /* binding */ SuperfluidAssetType; },
/* harmony export */   "SuperfluidAssetTypeAmino": function() { return /* binding */ SuperfluidAssetTypeAmino; },
/* harmony export */   "SuperfluidAssetTypeSDKType": function() { return /* binding */ SuperfluidAssetTypeSDKType; },
/* harmony export */   "SuperfluidDelegationRecord": function() { return /* binding */ SuperfluidDelegationRecord; },
/* harmony export */   "SuperfluidIntermediaryAccount": function() { return /* binding */ SuperfluidIntermediaryAccount; },
/* harmony export */   "UnpoolWhitelistedPools": function() { return /* binding */ UnpoolWhitelistedPools; },
/* harmony export */   "superfluidAssetTypeFromJSON": function() { return /* binding */ superfluidAssetTypeFromJSON; },
/* harmony export */   "superfluidAssetTypeToJSON": function() { return /* binding */ superfluidAssetTypeToJSON; }
/* harmony export */ });
/* harmony import */ var _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26178);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47895);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__);



/**
 * SuperfluidAssetType indicates whether the superfluid asset is
 * a native token, lp share of a pool, or concentrated share of a pool
 */

let SuperfluidAssetType;

(function (SuperfluidAssetType) {
  SuperfluidAssetType[SuperfluidAssetType["SuperfluidAssetTypeNative"] = 0] = "SuperfluidAssetTypeNative";
  SuperfluidAssetType[SuperfluidAssetType["SuperfluidAssetTypeLPShare"] = 1] = "SuperfluidAssetTypeLPShare";
  SuperfluidAssetType[SuperfluidAssetType["SuperfluidAssetTypeConcentratedShare"] = 2] = "SuperfluidAssetTypeConcentratedShare";
  SuperfluidAssetType[SuperfluidAssetType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(SuperfluidAssetType || (SuperfluidAssetType = {}));

const SuperfluidAssetTypeSDKType = SuperfluidAssetType;
const SuperfluidAssetTypeAmino = SuperfluidAssetType;
function superfluidAssetTypeFromJSON(object) {
  switch (object) {
    case 0:
    case "SuperfluidAssetTypeNative":
      return SuperfluidAssetType.SuperfluidAssetTypeNative;

    case 1:
    case "SuperfluidAssetTypeLPShare":
      return SuperfluidAssetType.SuperfluidAssetTypeLPShare;

    case 2:
    case "SuperfluidAssetTypeConcentratedShare":
      return SuperfluidAssetType.SuperfluidAssetTypeConcentratedShare;

    case -1:
    case "UNRECOGNIZED":
    default:
      return SuperfluidAssetType.UNRECOGNIZED;
  }
}
function superfluidAssetTypeToJSON(object) {
  switch (object) {
    case SuperfluidAssetType.SuperfluidAssetTypeNative:
      return "SuperfluidAssetTypeNative";

    case SuperfluidAssetType.SuperfluidAssetTypeLPShare:
      return "SuperfluidAssetTypeLPShare";

    case SuperfluidAssetType.SuperfluidAssetTypeConcentratedShare:
      return "SuperfluidAssetTypeConcentratedShare";

    case SuperfluidAssetType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
/** SuperfluidAsset stores the pair of superfluid asset type and denom pair */

function createBaseSuperfluidAsset() {
  return {
    denom: "",
    assetType: 0
  };
}

const SuperfluidAsset = {
  typeUrl: "/osmosis.superfluid.SuperfluidAsset",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (message.denom !== "") {
      writer.uint32(10).string(message.denom);
    }

    if (message.assetType !== 0) {
      writer.uint32(16).int32(message.assetType);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSuperfluidAsset();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.denom = reader.string();
          break;

        case 2:
          message.assetType = reader.int32();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$denom, _object$assetType;

    const message = createBaseSuperfluidAsset();
    message.denom = (_object$denom = object.denom) !== null && _object$denom !== void 0 ? _object$denom : "";
    message.assetType = (_object$assetType = object.assetType) !== null && _object$assetType !== void 0 ? _object$assetType : 0;
    return message;
  },

  fromAmino(object) {
    return {
      denom: object.denom,
      assetType: (0,_helpers__WEBPACK_IMPORTED_MODULE_1__/* .isSet */ .DM)(object.asset_type) ? superfluidAssetTypeFromJSON(object.asset_type) : 0
    };
  },

  toAmino(message) {
    const obj = {};
    obj.denom = message.denom;
    obj.asset_type = message.assetType;
    return obj;
  },

  fromAminoMsg(object) {
    return SuperfluidAsset.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/superfluid-asset",
      value: SuperfluidAsset.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return SuperfluidAsset.decode(message.value);
  },

  toProto(message) {
    return SuperfluidAsset.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.superfluid.SuperfluidAsset",
      value: SuperfluidAsset.encode(message).finish()
    };
  }

};

function createBaseSuperfluidIntermediaryAccount() {
  return {
    denom: "",
    valAddr: "",
    gaugeId: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.UZERO */ .dK.UZERO
  };
}

const SuperfluidIntermediaryAccount = {
  typeUrl: "/osmosis.superfluid.SuperfluidIntermediaryAccount",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (message.denom !== "") {
      writer.uint32(10).string(message.denom);
    }

    if (message.valAddr !== "") {
      writer.uint32(18).string(message.valAddr);
    }

    if (!message.gaugeId.isZero()) {
      writer.uint32(24).uint64(message.gaugeId);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSuperfluidIntermediaryAccount();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.denom = reader.string();
          break;

        case 2:
          message.valAddr = reader.string();
          break;

        case 3:
          message.gaugeId = reader.uint64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$denom2, _object$valAddr;

    const message = createBaseSuperfluidIntermediaryAccount();
    message.denom = (_object$denom2 = object.denom) !== null && _object$denom2 !== void 0 ? _object$denom2 : "";
    message.valAddr = (_object$valAddr = object.valAddr) !== null && _object$valAddr !== void 0 ? _object$valAddr : "";
    message.gaugeId = object.gaugeId !== undefined && object.gaugeId !== null ? _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromValue */ .dK.fromValue(object.gaugeId) : _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.UZERO */ .dK.UZERO;
    return message;
  },

  fromAmino(object) {
    return {
      denom: object.denom,
      valAddr: object.val_addr,
      gaugeId: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromString */ .dK.fromString(object.gauge_id)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.denom = message.denom;
    obj.val_addr = message.valAddr;
    obj.gauge_id = message.gaugeId ? message.gaugeId.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return SuperfluidIntermediaryAccount.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/superfluid-intermediary-account",
      value: SuperfluidIntermediaryAccount.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return SuperfluidIntermediaryAccount.decode(message.value);
  },

  toProto(message) {
    return SuperfluidIntermediaryAccount.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.superfluid.SuperfluidIntermediaryAccount",
      value: SuperfluidIntermediaryAccount.encode(message).finish()
    };
  }

};

function createBaseOsmoEquivalentMultiplierRecord() {
  return {
    epochNumber: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.ZERO */ .dK.ZERO,
    denom: "",
    multiplier: ""
  };
}

const OsmoEquivalentMultiplierRecord = {
  typeUrl: "/osmosis.superfluid.OsmoEquivalentMultiplierRecord",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (!message.epochNumber.isZero()) {
      writer.uint32(8).int64(message.epochNumber);
    }

    if (message.denom !== "") {
      writer.uint32(18).string(message.denom);
    }

    if (message.multiplier !== "") {
      writer.uint32(26).string(message.multiplier);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOsmoEquivalentMultiplierRecord();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.epochNumber = reader.int64();
          break;

        case 2:
          message.denom = reader.string();
          break;

        case 3:
          message.multiplier = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$denom3, _object$multiplier;

    const message = createBaseOsmoEquivalentMultiplierRecord();
    message.epochNumber = object.epochNumber !== undefined && object.epochNumber !== null ? _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromValue */ .dK.fromValue(object.epochNumber) : _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.ZERO */ .dK.ZERO;
    message.denom = (_object$denom3 = object.denom) !== null && _object$denom3 !== void 0 ? _object$denom3 : "";
    message.multiplier = (_object$multiplier = object.multiplier) !== null && _object$multiplier !== void 0 ? _object$multiplier : "";
    return message;
  },

  fromAmino(object) {
    return {
      epochNumber: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromString */ .dK.fromString(object.epoch_number),
      denom: object.denom,
      multiplier: object.multiplier
    };
  },

  toAmino(message) {
    const obj = {};
    obj.epoch_number = message.epochNumber ? message.epochNumber.toString() : undefined;
    obj.denom = message.denom;
    obj.multiplier = message.multiplier;
    return obj;
  },

  fromAminoMsg(object) {
    return OsmoEquivalentMultiplierRecord.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/osmo-equivalent-multiplier-record",
      value: OsmoEquivalentMultiplierRecord.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return OsmoEquivalentMultiplierRecord.decode(message.value);
  },

  toProto(message) {
    return OsmoEquivalentMultiplierRecord.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.superfluid.OsmoEquivalentMultiplierRecord",
      value: OsmoEquivalentMultiplierRecord.encode(message).finish()
    };
  }

};

function createBaseSuperfluidDelegationRecord() {
  return {
    delegatorAddress: "",
    validatorAddress: "",
    delegationAmount: undefined,
    equivalentStakedAmount: undefined
  };
}

const SuperfluidDelegationRecord = {
  typeUrl: "/osmosis.superfluid.SuperfluidDelegationRecord",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (message.delegatorAddress !== "") {
      writer.uint32(10).string(message.delegatorAddress);
    }

    if (message.validatorAddress !== "") {
      writer.uint32(18).string(message.validatorAddress);
    }

    if (message.delegationAmount !== undefined) {
      _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.encode(message.delegationAmount, writer.uint32(26).fork()).ldelim();
    }

    if (message.equivalentStakedAmount !== undefined) {
      _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.encode(message.equivalentStakedAmount, writer.uint32(34).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSuperfluidDelegationRecord();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.delegatorAddress = reader.string();
          break;

        case 2:
          message.validatorAddress = reader.string();
          break;

        case 3:
          message.delegationAmount = _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.decode(reader, reader.uint32());
          break;

        case 4:
          message.equivalentStakedAmount = _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$delegatorAddr, _object$validatorAddr;

    const message = createBaseSuperfluidDelegationRecord();
    message.delegatorAddress = (_object$delegatorAddr = object.delegatorAddress) !== null && _object$delegatorAddr !== void 0 ? _object$delegatorAddr : "";
    message.validatorAddress = (_object$validatorAddr = object.validatorAddress) !== null && _object$validatorAddr !== void 0 ? _object$validatorAddr : "";
    message.delegationAmount = object.delegationAmount !== undefined && object.delegationAmount !== null ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.fromPartial(object.delegationAmount) : undefined;
    message.equivalentStakedAmount = object.equivalentStakedAmount !== undefined && object.equivalentStakedAmount !== null ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.fromPartial(object.equivalentStakedAmount) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      delegatorAddress: object.delegator_address,
      validatorAddress: object.validator_address,
      delegationAmount: object !== null && object !== void 0 && object.delegation_amount ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.fromAmino(object.delegation_amount) : undefined,
      equivalentStakedAmount: object !== null && object !== void 0 && object.equivalent_staked_amount ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.fromAmino(object.equivalent_staked_amount) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.delegator_address = message.delegatorAddress;
    obj.validator_address = message.validatorAddress;
    obj.delegation_amount = message.delegationAmount ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.toAmino(message.delegationAmount) : undefined;
    obj.equivalent_staked_amount = message.equivalentStakedAmount ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.toAmino(message.equivalentStakedAmount) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return SuperfluidDelegationRecord.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/superfluid-delegation-record",
      value: SuperfluidDelegationRecord.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return SuperfluidDelegationRecord.decode(message.value);
  },

  toProto(message) {
    return SuperfluidDelegationRecord.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.superfluid.SuperfluidDelegationRecord",
      value: SuperfluidDelegationRecord.encode(message).finish()
    };
  }

};

function createBaseLockIdIntermediaryAccountConnection() {
  return {
    lockId: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.UZERO */ .dK.UZERO,
    intermediaryAccount: ""
  };
}

const LockIdIntermediaryAccountConnection = {
  typeUrl: "/osmosis.superfluid.LockIdIntermediaryAccountConnection",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (!message.lockId.isZero()) {
      writer.uint32(8).uint64(message.lockId);
    }

    if (message.intermediaryAccount !== "") {
      writer.uint32(18).string(message.intermediaryAccount);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLockIdIntermediaryAccountConnection();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.lockId = reader.uint64();
          break;

        case 2:
          message.intermediaryAccount = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$intermediaryA;

    const message = createBaseLockIdIntermediaryAccountConnection();
    message.lockId = object.lockId !== undefined && object.lockId !== null ? _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromValue */ .dK.fromValue(object.lockId) : _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.UZERO */ .dK.UZERO;
    message.intermediaryAccount = (_object$intermediaryA = object.intermediaryAccount) !== null && _object$intermediaryA !== void 0 ? _object$intermediaryA : "";
    return message;
  },

  fromAmino(object) {
    return {
      lockId: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromString */ .dK.fromString(object.lock_id),
      intermediaryAccount: object.intermediary_account
    };
  },

  toAmino(message) {
    const obj = {};
    obj.lock_id = message.lockId ? message.lockId.toString() : undefined;
    obj.intermediary_account = message.intermediaryAccount;
    return obj;
  },

  fromAminoMsg(object) {
    return LockIdIntermediaryAccountConnection.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/lock-id-intermediary-account-connection",
      value: LockIdIntermediaryAccountConnection.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return LockIdIntermediaryAccountConnection.decode(message.value);
  },

  toProto(message) {
    return LockIdIntermediaryAccountConnection.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.superfluid.LockIdIntermediaryAccountConnection",
      value: LockIdIntermediaryAccountConnection.encode(message).finish()
    };
  }

};

function createBaseUnpoolWhitelistedPools() {
  return {
    ids: []
  };
}

const UnpoolWhitelistedPools = {
  typeUrl: "/osmosis.superfluid.UnpoolWhitelistedPools",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    writer.uint32(10).fork();

    for (const v of message.ids) {
      writer.uint64(v);
    }

    writer.ldelim();
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUnpoolWhitelistedPools();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          if ((tag & 7) === 2) {
            const end2 = reader.uint32() + reader.pos;

            while (reader.pos < end2) {
              message.ids.push(reader.uint64());
            }
          } else {
            message.ids.push(reader.uint64());
          }

          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$ids;

    const message = createBaseUnpoolWhitelistedPools();
    message.ids = ((_object$ids = object.ids) === null || _object$ids === void 0 ? void 0 : _object$ids.map(e => _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromValue */ .dK.fromValue(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      ids: Array.isArray(object === null || object === void 0 ? void 0 : object.ids) ? object.ids.map(e => e) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.ids) {
      obj.ids = message.ids.map(e => e);
    } else {
      obj.ids = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return UnpoolWhitelistedPools.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/unpool-whitelisted-pools",
      value: UnpoolWhitelistedPools.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return UnpoolWhitelistedPools.decode(message.value);
  },

  toProto(message) {
    return UnpoolWhitelistedPools.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.superfluid.UnpoolWhitelistedPools",
      value: UnpoolWhitelistedPools.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 56429:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MsgAddToConcentratedLiquiditySuperfluidPosition": function() { return /* binding */ MsgAddToConcentratedLiquiditySuperfluidPosition; },
/* harmony export */   "MsgAddToConcentratedLiquiditySuperfluidPositionResponse": function() { return /* binding */ MsgAddToConcentratedLiquiditySuperfluidPositionResponse; },
/* harmony export */   "MsgCreateFullRangePositionAndSuperfluidDelegate": function() { return /* binding */ MsgCreateFullRangePositionAndSuperfluidDelegate; },
/* harmony export */   "MsgCreateFullRangePositionAndSuperfluidDelegateResponse": function() { return /* binding */ MsgCreateFullRangePositionAndSuperfluidDelegateResponse; },
/* harmony export */   "MsgLockAndSuperfluidDelegate": function() { return /* binding */ MsgLockAndSuperfluidDelegate; },
/* harmony export */   "MsgLockAndSuperfluidDelegateResponse": function() { return /* binding */ MsgLockAndSuperfluidDelegateResponse; },
/* harmony export */   "MsgSuperfluidDelegate": function() { return /* binding */ MsgSuperfluidDelegate; },
/* harmony export */   "MsgSuperfluidDelegateResponse": function() { return /* binding */ MsgSuperfluidDelegateResponse; },
/* harmony export */   "MsgSuperfluidUnbondLock": function() { return /* binding */ MsgSuperfluidUnbondLock; },
/* harmony export */   "MsgSuperfluidUnbondLockResponse": function() { return /* binding */ MsgSuperfluidUnbondLockResponse; },
/* harmony export */   "MsgSuperfluidUndelegate": function() { return /* binding */ MsgSuperfluidUndelegate; },
/* harmony export */   "MsgSuperfluidUndelegateAndUnbondLock": function() { return /* binding */ MsgSuperfluidUndelegateAndUnbondLock; },
/* harmony export */   "MsgSuperfluidUndelegateAndUnbondLockResponse": function() { return /* binding */ MsgSuperfluidUndelegateAndUnbondLockResponse; },
/* harmony export */   "MsgSuperfluidUndelegateResponse": function() { return /* binding */ MsgSuperfluidUndelegateResponse; },
/* harmony export */   "MsgUnPoolWhitelistedPool": function() { return /* binding */ MsgUnPoolWhitelistedPool; },
/* harmony export */   "MsgUnPoolWhitelistedPoolResponse": function() { return /* binding */ MsgUnPoolWhitelistedPoolResponse; },
/* harmony export */   "MsgUnlockAndMigrateSharesToFullRangeConcentratedPosition": function() { return /* binding */ MsgUnlockAndMigrateSharesToFullRangeConcentratedPosition; },
/* harmony export */   "MsgUnlockAndMigrateSharesToFullRangeConcentratedPositionResponse": function() { return /* binding */ MsgUnlockAndMigrateSharesToFullRangeConcentratedPositionResponse; }
/* harmony export */ });
/* harmony import */ var _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26178);
/* harmony import */ var _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20633);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47895);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__);





function createBaseMsgSuperfluidDelegate() {
  return {
    sender: "",
    lockId: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO,
    valAddr: ""
  };
}

const MsgSuperfluidDelegate = {
  typeUrl: "/osmosis.superfluid.MsgSuperfluidDelegate",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.sender !== "") {
      writer.uint32(10).string(message.sender);
    }

    if (!message.lockId.isZero()) {
      writer.uint32(16).uint64(message.lockId);
    }

    if (message.valAddr !== "") {
      writer.uint32(26).string(message.valAddr);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgSuperfluidDelegate();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.sender = reader.string();
          break;

        case 2:
          message.lockId = reader.uint64();
          break;

        case 3:
          message.valAddr = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$sender, _object$valAddr;

    const message = createBaseMsgSuperfluidDelegate();
    message.sender = (_object$sender = object.sender) !== null && _object$sender !== void 0 ? _object$sender : "";
    message.lockId = object.lockId !== undefined && object.lockId !== null ? _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromValue */ .dK.fromValue(object.lockId) : _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO;
    message.valAddr = (_object$valAddr = object.valAddr) !== null && _object$valAddr !== void 0 ? _object$valAddr : "";
    return message;
  },

  fromAmino(object) {
    return {
      sender: object.sender,
      lockId: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromString */ .dK.fromString(object.lock_id),
      valAddr: object.val_addr
    };
  },

  toAmino(message) {
    const obj = {};
    obj.sender = message.sender;
    obj.lock_id = message.lockId ? message.lockId.toString() : undefined;
    obj.val_addr = message.valAddr;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgSuperfluidDelegate.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/superfluid-delegate",
      value: MsgSuperfluidDelegate.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgSuperfluidDelegate.decode(message.value);
  },

  toProto(message) {
    return MsgSuperfluidDelegate.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.superfluid.MsgSuperfluidDelegate",
      value: MsgSuperfluidDelegate.encode(message).finish()
    };
  }

};

function createBaseMsgSuperfluidDelegateResponse() {
  return {};
}

const MsgSuperfluidDelegateResponse = {
  typeUrl: "/osmosis.superfluid.MsgSuperfluidDelegateResponse",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgSuperfluidDelegateResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseMsgSuperfluidDelegateResponse();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return MsgSuperfluidDelegateResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/superfluid-delegate-response",
      value: MsgSuperfluidDelegateResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgSuperfluidDelegateResponse.decode(message.value);
  },

  toProto(message) {
    return MsgSuperfluidDelegateResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.superfluid.MsgSuperfluidDelegateResponse",
      value: MsgSuperfluidDelegateResponse.encode(message).finish()
    };
  }

};

function createBaseMsgSuperfluidUndelegate() {
  return {
    sender: "",
    lockId: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO
  };
}

const MsgSuperfluidUndelegate = {
  typeUrl: "/osmosis.superfluid.MsgSuperfluidUndelegate",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.sender !== "") {
      writer.uint32(10).string(message.sender);
    }

    if (!message.lockId.isZero()) {
      writer.uint32(16).uint64(message.lockId);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgSuperfluidUndelegate();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.sender = reader.string();
          break;

        case 2:
          message.lockId = reader.uint64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$sender2;

    const message = createBaseMsgSuperfluidUndelegate();
    message.sender = (_object$sender2 = object.sender) !== null && _object$sender2 !== void 0 ? _object$sender2 : "";
    message.lockId = object.lockId !== undefined && object.lockId !== null ? _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromValue */ .dK.fromValue(object.lockId) : _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO;
    return message;
  },

  fromAmino(object) {
    return {
      sender: object.sender,
      lockId: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromString */ .dK.fromString(object.lock_id)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.sender = message.sender;
    obj.lock_id = message.lockId ? message.lockId.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgSuperfluidUndelegate.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/superfluid-undelegate",
      value: MsgSuperfluidUndelegate.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgSuperfluidUndelegate.decode(message.value);
  },

  toProto(message) {
    return MsgSuperfluidUndelegate.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.superfluid.MsgSuperfluidUndelegate",
      value: MsgSuperfluidUndelegate.encode(message).finish()
    };
  }

};

function createBaseMsgSuperfluidUndelegateResponse() {
  return {};
}

const MsgSuperfluidUndelegateResponse = {
  typeUrl: "/osmosis.superfluid.MsgSuperfluidUndelegateResponse",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgSuperfluidUndelegateResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseMsgSuperfluidUndelegateResponse();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return MsgSuperfluidUndelegateResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/superfluid-undelegate-response",
      value: MsgSuperfluidUndelegateResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgSuperfluidUndelegateResponse.decode(message.value);
  },

  toProto(message) {
    return MsgSuperfluidUndelegateResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.superfluid.MsgSuperfluidUndelegateResponse",
      value: MsgSuperfluidUndelegateResponse.encode(message).finish()
    };
  }

};

function createBaseMsgSuperfluidUnbondLock() {
  return {
    sender: "",
    lockId: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO
  };
}

const MsgSuperfluidUnbondLock = {
  typeUrl: "/osmosis.superfluid.MsgSuperfluidUnbondLock",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.sender !== "") {
      writer.uint32(10).string(message.sender);
    }

    if (!message.lockId.isZero()) {
      writer.uint32(16).uint64(message.lockId);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgSuperfluidUnbondLock();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.sender = reader.string();
          break;

        case 2:
          message.lockId = reader.uint64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$sender3;

    const message = createBaseMsgSuperfluidUnbondLock();
    message.sender = (_object$sender3 = object.sender) !== null && _object$sender3 !== void 0 ? _object$sender3 : "";
    message.lockId = object.lockId !== undefined && object.lockId !== null ? _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromValue */ .dK.fromValue(object.lockId) : _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO;
    return message;
  },

  fromAmino(object) {
    return {
      sender: object.sender,
      lockId: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromString */ .dK.fromString(object.lock_id)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.sender = message.sender;
    obj.lock_id = message.lockId ? message.lockId.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgSuperfluidUnbondLock.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/superfluid-unbond-lock",
      value: MsgSuperfluidUnbondLock.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgSuperfluidUnbondLock.decode(message.value);
  },

  toProto(message) {
    return MsgSuperfluidUnbondLock.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.superfluid.MsgSuperfluidUnbondLock",
      value: MsgSuperfluidUnbondLock.encode(message).finish()
    };
  }

};

function createBaseMsgSuperfluidUnbondLockResponse() {
  return {};
}

const MsgSuperfluidUnbondLockResponse = {
  typeUrl: "/osmosis.superfluid.MsgSuperfluidUnbondLockResponse",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgSuperfluidUnbondLockResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseMsgSuperfluidUnbondLockResponse();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return MsgSuperfluidUnbondLockResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/superfluid-unbond-lock-response",
      value: MsgSuperfluidUnbondLockResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgSuperfluidUnbondLockResponse.decode(message.value);
  },

  toProto(message) {
    return MsgSuperfluidUnbondLockResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.superfluid.MsgSuperfluidUnbondLockResponse",
      value: MsgSuperfluidUnbondLockResponse.encode(message).finish()
    };
  }

};

function createBaseMsgSuperfluidUndelegateAndUnbondLock() {
  return {
    sender: "",
    lockId: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO,
    coin: undefined
  };
}

const MsgSuperfluidUndelegateAndUnbondLock = {
  typeUrl: "/osmosis.superfluid.MsgSuperfluidUndelegateAndUnbondLock",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.sender !== "") {
      writer.uint32(10).string(message.sender);
    }

    if (!message.lockId.isZero()) {
      writer.uint32(16).uint64(message.lockId);
    }

    if (message.coin !== undefined) {
      _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.encode(message.coin, writer.uint32(26).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgSuperfluidUndelegateAndUnbondLock();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.sender = reader.string();
          break;

        case 2:
          message.lockId = reader.uint64();
          break;

        case 3:
          message.coin = _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$sender4;

    const message = createBaseMsgSuperfluidUndelegateAndUnbondLock();
    message.sender = (_object$sender4 = object.sender) !== null && _object$sender4 !== void 0 ? _object$sender4 : "";
    message.lockId = object.lockId !== undefined && object.lockId !== null ? _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromValue */ .dK.fromValue(object.lockId) : _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO;
    message.coin = object.coin !== undefined && object.coin !== null ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.fromPartial(object.coin) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      sender: object.sender,
      lockId: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromString */ .dK.fromString(object.lock_id),
      coin: object !== null && object !== void 0 && object.coin ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.fromAmino(object.coin) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.sender = message.sender;
    obj.lock_id = message.lockId ? message.lockId.toString() : undefined;
    obj.coin = message.coin ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.toAmino(message.coin) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgSuperfluidUndelegateAndUnbondLock.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/superfluid-undelegate-and-unbond-lock",
      value: MsgSuperfluidUndelegateAndUnbondLock.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgSuperfluidUndelegateAndUnbondLock.decode(message.value);
  },

  toProto(message) {
    return MsgSuperfluidUndelegateAndUnbondLock.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.superfluid.MsgSuperfluidUndelegateAndUnbondLock",
      value: MsgSuperfluidUndelegateAndUnbondLock.encode(message).finish()
    };
  }

};

function createBaseMsgSuperfluidUndelegateAndUnbondLockResponse() {
  return {
    lockId: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO
  };
}

const MsgSuperfluidUndelegateAndUnbondLockResponse = {
  typeUrl: "/osmosis.superfluid.MsgSuperfluidUndelegateAndUnbondLockResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (!message.lockId.isZero()) {
      writer.uint32(8).uint64(message.lockId);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgSuperfluidUndelegateAndUnbondLockResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.lockId = reader.uint64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseMsgSuperfluidUndelegateAndUnbondLockResponse();
    message.lockId = object.lockId !== undefined && object.lockId !== null ? _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromValue */ .dK.fromValue(object.lockId) : _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO;
    return message;
  },

  fromAmino(object) {
    return {
      lockId: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromString */ .dK.fromString(object.lock_id)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.lock_id = message.lockId ? message.lockId.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgSuperfluidUndelegateAndUnbondLockResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/superfluid-undelegate-and-unbond-lock-response",
      value: MsgSuperfluidUndelegateAndUnbondLockResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgSuperfluidUndelegateAndUnbondLockResponse.decode(message.value);
  },

  toProto(message) {
    return MsgSuperfluidUndelegateAndUnbondLockResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.superfluid.MsgSuperfluidUndelegateAndUnbondLockResponse",
      value: MsgSuperfluidUndelegateAndUnbondLockResponse.encode(message).finish()
    };
  }

};

function createBaseMsgLockAndSuperfluidDelegate() {
  return {
    sender: "",
    coins: [],
    valAddr: ""
  };
}

const MsgLockAndSuperfluidDelegate = {
  typeUrl: "/osmosis.superfluid.MsgLockAndSuperfluidDelegate",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.sender !== "") {
      writer.uint32(10).string(message.sender);
    }

    for (const v of message.coins) {
      _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.encode(v, writer.uint32(18).fork()).ldelim();
    }

    if (message.valAddr !== "") {
      writer.uint32(26).string(message.valAddr);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgLockAndSuperfluidDelegate();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.sender = reader.string();
          break;

        case 2:
          message.coins.push(_cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.decode(reader, reader.uint32()));
          break;

        case 3:
          message.valAddr = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$sender5, _object$coins, _object$valAddr2;

    const message = createBaseMsgLockAndSuperfluidDelegate();
    message.sender = (_object$sender5 = object.sender) !== null && _object$sender5 !== void 0 ? _object$sender5 : "";
    message.coins = ((_object$coins = object.coins) === null || _object$coins === void 0 ? void 0 : _object$coins.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.fromPartial(e))) || [];
    message.valAddr = (_object$valAddr2 = object.valAddr) !== null && _object$valAddr2 !== void 0 ? _object$valAddr2 : "";
    return message;
  },

  fromAmino(object) {
    return {
      sender: object.sender,
      coins: Array.isArray(object === null || object === void 0 ? void 0 : object.coins) ? object.coins.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.fromAmino(e)) : [],
      valAddr: object.val_addr
    };
  },

  toAmino(message) {
    const obj = {};
    obj.sender = message.sender;

    if (message.coins) {
      obj.coins = message.coins.map(e => e ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.toAmino(e) : undefined);
    } else {
      obj.coins = [];
    }

    obj.val_addr = message.valAddr;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgLockAndSuperfluidDelegate.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/lock-and-superfluid-delegate",
      value: MsgLockAndSuperfluidDelegate.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgLockAndSuperfluidDelegate.decode(message.value);
  },

  toProto(message) {
    return MsgLockAndSuperfluidDelegate.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.superfluid.MsgLockAndSuperfluidDelegate",
      value: MsgLockAndSuperfluidDelegate.encode(message).finish()
    };
  }

};

function createBaseMsgLockAndSuperfluidDelegateResponse() {
  return {
    ID: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO
  };
}

const MsgLockAndSuperfluidDelegateResponse = {
  typeUrl: "/osmosis.superfluid.MsgLockAndSuperfluidDelegateResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (!message.ID.isZero()) {
      writer.uint32(8).uint64(message.ID);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgLockAndSuperfluidDelegateResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.ID = reader.uint64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseMsgLockAndSuperfluidDelegateResponse();
    message.ID = object.ID !== undefined && object.ID !== null ? _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromValue */ .dK.fromValue(object.ID) : _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO;
    return message;
  },

  fromAmino(object) {
    return {
      ID: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromString */ .dK.fromString(object.ID)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.ID = message.ID ? message.ID.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgLockAndSuperfluidDelegateResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/lock-and-superfluid-delegate-response",
      value: MsgLockAndSuperfluidDelegateResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgLockAndSuperfluidDelegateResponse.decode(message.value);
  },

  toProto(message) {
    return MsgLockAndSuperfluidDelegateResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.superfluid.MsgLockAndSuperfluidDelegateResponse",
      value: MsgLockAndSuperfluidDelegateResponse.encode(message).finish()
    };
  }

};

function createBaseMsgCreateFullRangePositionAndSuperfluidDelegate() {
  return {
    sender: "",
    coins: [],
    valAddr: "",
    poolId: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO
  };
}

const MsgCreateFullRangePositionAndSuperfluidDelegate = {
  typeUrl: "/osmosis.superfluid.MsgCreateFullRangePositionAndSuperfluidDelegate",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.sender !== "") {
      writer.uint32(10).string(message.sender);
    }

    for (const v of message.coins) {
      _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.encode(v, writer.uint32(18).fork()).ldelim();
    }

    if (message.valAddr !== "") {
      writer.uint32(26).string(message.valAddr);
    }

    if (!message.poolId.isZero()) {
      writer.uint32(32).uint64(message.poolId);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgCreateFullRangePositionAndSuperfluidDelegate();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.sender = reader.string();
          break;

        case 2:
          message.coins.push(_cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.decode(reader, reader.uint32()));
          break;

        case 3:
          message.valAddr = reader.string();
          break;

        case 4:
          message.poolId = reader.uint64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$sender6, _object$coins2, _object$valAddr3;

    const message = createBaseMsgCreateFullRangePositionAndSuperfluidDelegate();
    message.sender = (_object$sender6 = object.sender) !== null && _object$sender6 !== void 0 ? _object$sender6 : "";
    message.coins = ((_object$coins2 = object.coins) === null || _object$coins2 === void 0 ? void 0 : _object$coins2.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.fromPartial(e))) || [];
    message.valAddr = (_object$valAddr3 = object.valAddr) !== null && _object$valAddr3 !== void 0 ? _object$valAddr3 : "";
    message.poolId = object.poolId !== undefined && object.poolId !== null ? _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromValue */ .dK.fromValue(object.poolId) : _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO;
    return message;
  },

  fromAmino(object) {
    return {
      sender: object.sender,
      coins: Array.isArray(object === null || object === void 0 ? void 0 : object.coins) ? object.coins.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.fromAmino(e)) : [],
      valAddr: object.val_addr,
      poolId: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromString */ .dK.fromString(object.pool_id)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.sender = message.sender;

    if (message.coins) {
      obj.coins = message.coins.map(e => e ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.toAmino(e) : undefined);
    } else {
      obj.coins = [];
    }

    obj.val_addr = message.valAddr;
    obj.pool_id = message.poolId ? message.poolId.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgCreateFullRangePositionAndSuperfluidDelegate.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/create-full-range-position-and-superfluid-delegate",
      value: MsgCreateFullRangePositionAndSuperfluidDelegate.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgCreateFullRangePositionAndSuperfluidDelegate.decode(message.value);
  },

  toProto(message) {
    return MsgCreateFullRangePositionAndSuperfluidDelegate.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.superfluid.MsgCreateFullRangePositionAndSuperfluidDelegate",
      value: MsgCreateFullRangePositionAndSuperfluidDelegate.encode(message).finish()
    };
  }

};

function createBaseMsgCreateFullRangePositionAndSuperfluidDelegateResponse() {
  return {
    lockID: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO,
    positionID: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO
  };
}

const MsgCreateFullRangePositionAndSuperfluidDelegateResponse = {
  typeUrl: "/osmosis.superfluid.MsgCreateFullRangePositionAndSuperfluidDelegateResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (!message.lockID.isZero()) {
      writer.uint32(8).uint64(message.lockID);
    }

    if (!message.positionID.isZero()) {
      writer.uint32(16).uint64(message.positionID);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgCreateFullRangePositionAndSuperfluidDelegateResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.lockID = reader.uint64();
          break;

        case 2:
          message.positionID = reader.uint64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseMsgCreateFullRangePositionAndSuperfluidDelegateResponse();
    message.lockID = object.lockID !== undefined && object.lockID !== null ? _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromValue */ .dK.fromValue(object.lockID) : _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO;
    message.positionID = object.positionID !== undefined && object.positionID !== null ? _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromValue */ .dK.fromValue(object.positionID) : _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO;
    return message;
  },

  fromAmino(object) {
    return {
      lockID: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromString */ .dK.fromString(object.lockID),
      positionID: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromString */ .dK.fromString(object.positionID)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.lockID = message.lockID ? message.lockID.toString() : undefined;
    obj.positionID = message.positionID ? message.positionID.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgCreateFullRangePositionAndSuperfluidDelegateResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/create-full-range-position-and-superfluid-delegate-response",
      value: MsgCreateFullRangePositionAndSuperfluidDelegateResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgCreateFullRangePositionAndSuperfluidDelegateResponse.decode(message.value);
  },

  toProto(message) {
    return MsgCreateFullRangePositionAndSuperfluidDelegateResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.superfluid.MsgCreateFullRangePositionAndSuperfluidDelegateResponse",
      value: MsgCreateFullRangePositionAndSuperfluidDelegateResponse.encode(message).finish()
    };
  }

};

function createBaseMsgUnPoolWhitelistedPool() {
  return {
    sender: "",
    poolId: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO
  };
}

const MsgUnPoolWhitelistedPool = {
  typeUrl: "/osmosis.superfluid.MsgUnPoolWhitelistedPool",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.sender !== "") {
      writer.uint32(10).string(message.sender);
    }

    if (!message.poolId.isZero()) {
      writer.uint32(16).uint64(message.poolId);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgUnPoolWhitelistedPool();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.sender = reader.string();
          break;

        case 2:
          message.poolId = reader.uint64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$sender7;

    const message = createBaseMsgUnPoolWhitelistedPool();
    message.sender = (_object$sender7 = object.sender) !== null && _object$sender7 !== void 0 ? _object$sender7 : "";
    message.poolId = object.poolId !== undefined && object.poolId !== null ? _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromValue */ .dK.fromValue(object.poolId) : _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO;
    return message;
  },

  fromAmino(object) {
    return {
      sender: object.sender,
      poolId: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromString */ .dK.fromString(object.pool_id)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.sender = message.sender;
    obj.pool_id = message.poolId ? message.poolId.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgUnPoolWhitelistedPool.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/unpool-whitelisted-pool",
      value: MsgUnPoolWhitelistedPool.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgUnPoolWhitelistedPool.decode(message.value);
  },

  toProto(message) {
    return MsgUnPoolWhitelistedPool.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.superfluid.MsgUnPoolWhitelistedPool",
      value: MsgUnPoolWhitelistedPool.encode(message).finish()
    };
  }

};

function createBaseMsgUnPoolWhitelistedPoolResponse() {
  return {
    exitedLockIds: []
  };
}

const MsgUnPoolWhitelistedPoolResponse = {
  typeUrl: "/osmosis.superfluid.MsgUnPoolWhitelistedPoolResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    writer.uint32(10).fork();

    for (const v of message.exitedLockIds) {
      writer.uint64(v);
    }

    writer.ldelim();
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgUnPoolWhitelistedPoolResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          if ((tag & 7) === 2) {
            const end2 = reader.uint32() + reader.pos;

            while (reader.pos < end2) {
              message.exitedLockIds.push(reader.uint64());
            }
          } else {
            message.exitedLockIds.push(reader.uint64());
          }

          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$exitedLockIds;

    const message = createBaseMsgUnPoolWhitelistedPoolResponse();
    message.exitedLockIds = ((_object$exitedLockIds = object.exitedLockIds) === null || _object$exitedLockIds === void 0 ? void 0 : _object$exitedLockIds.map(e => _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromValue */ .dK.fromValue(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      exitedLockIds: Array.isArray(object === null || object === void 0 ? void 0 : object.exited_lock_ids) ? object.exited_lock_ids.map(e => e) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.exitedLockIds) {
      obj.exited_lock_ids = message.exitedLockIds.map(e => e);
    } else {
      obj.exited_lock_ids = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return MsgUnPoolWhitelistedPoolResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/un-pool-whitelisted-pool-response",
      value: MsgUnPoolWhitelistedPoolResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgUnPoolWhitelistedPoolResponse.decode(message.value);
  },

  toProto(message) {
    return MsgUnPoolWhitelistedPoolResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.superfluid.MsgUnPoolWhitelistedPoolResponse",
      value: MsgUnPoolWhitelistedPoolResponse.encode(message).finish()
    };
  }

};

function createBaseMsgUnlockAndMigrateSharesToFullRangeConcentratedPosition() {
  return {
    sender: "",
    lockId: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO,
    sharesToMigrate: undefined,
    tokenOutMins: []
  };
}

const MsgUnlockAndMigrateSharesToFullRangeConcentratedPosition = {
  typeUrl: "/osmosis.superfluid.MsgUnlockAndMigrateSharesToFullRangeConcentratedPosition",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.sender !== "") {
      writer.uint32(10).string(message.sender);
    }

    if (!message.lockId.isZero()) {
      writer.uint32(16).uint64(message.lockId);
    }

    if (message.sharesToMigrate !== undefined) {
      _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.encode(message.sharesToMigrate, writer.uint32(26).fork()).ldelim();
    }

    for (const v of message.tokenOutMins) {
      _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.encode(v, writer.uint32(34).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgUnlockAndMigrateSharesToFullRangeConcentratedPosition();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.sender = reader.string();
          break;

        case 2:
          message.lockId = reader.uint64();
          break;

        case 3:
          message.sharesToMigrate = _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.decode(reader, reader.uint32());
          break;

        case 4:
          message.tokenOutMins.push(_cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$sender8, _object$tokenOutMins;

    const message = createBaseMsgUnlockAndMigrateSharesToFullRangeConcentratedPosition();
    message.sender = (_object$sender8 = object.sender) !== null && _object$sender8 !== void 0 ? _object$sender8 : "";
    message.lockId = object.lockId !== undefined && object.lockId !== null ? _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromValue */ .dK.fromValue(object.lockId) : _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO;
    message.sharesToMigrate = object.sharesToMigrate !== undefined && object.sharesToMigrate !== null ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.fromPartial(object.sharesToMigrate) : undefined;
    message.tokenOutMins = ((_object$tokenOutMins = object.tokenOutMins) === null || _object$tokenOutMins === void 0 ? void 0 : _object$tokenOutMins.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      sender: object.sender,
      lockId: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromString */ .dK.fromString(object.lock_id),
      sharesToMigrate: object !== null && object !== void 0 && object.shares_to_migrate ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.fromAmino(object.shares_to_migrate) : undefined,
      tokenOutMins: Array.isArray(object === null || object === void 0 ? void 0 : object.token_out_mins) ? object.token_out_mins.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.sender = message.sender;
    obj.lock_id = message.lockId ? message.lockId.toString() : undefined;
    obj.shares_to_migrate = message.sharesToMigrate ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.toAmino(message.sharesToMigrate) : undefined;

    if (message.tokenOutMins) {
      obj.token_out_mins = message.tokenOutMins.map(e => e ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.toAmino(e) : undefined);
    } else {
      obj.token_out_mins = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return MsgUnlockAndMigrateSharesToFullRangeConcentratedPosition.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/unlock-and-migrate-shares-to-full-range-concentrated-position",
      value: MsgUnlockAndMigrateSharesToFullRangeConcentratedPosition.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgUnlockAndMigrateSharesToFullRangeConcentratedPosition.decode(message.value);
  },

  toProto(message) {
    return MsgUnlockAndMigrateSharesToFullRangeConcentratedPosition.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.superfluid.MsgUnlockAndMigrateSharesToFullRangeConcentratedPosition",
      value: MsgUnlockAndMigrateSharesToFullRangeConcentratedPosition.encode(message).finish()
    };
  }

};

function createBaseMsgUnlockAndMigrateSharesToFullRangeConcentratedPositionResponse() {
  return {
    amount0: "",
    amount1: "",
    liquidityCreated: "",
    joinTime: undefined
  };
}

const MsgUnlockAndMigrateSharesToFullRangeConcentratedPositionResponse = {
  typeUrl: "/osmosis.superfluid.MsgUnlockAndMigrateSharesToFullRangeConcentratedPositionResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.amount0 !== "") {
      writer.uint32(10).string(message.amount0);
    }

    if (message.amount1 !== "") {
      writer.uint32(18).string(message.amount1);
    }

    if (message.liquidityCreated !== "") {
      writer.uint32(26).string(message.liquidityCreated);
    }

    if (message.joinTime !== undefined) {
      _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_1__.Timestamp.encode((0,_helpers__WEBPACK_IMPORTED_MODULE_2__/* .toTimestamp */ .Uq)(message.joinTime), writer.uint32(34).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgUnlockAndMigrateSharesToFullRangeConcentratedPositionResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.amount0 = reader.string();
          break;

        case 2:
          message.amount1 = reader.string();
          break;

        case 3:
          message.liquidityCreated = reader.string();
          break;

        case 4:
          message.joinTime = (0,_helpers__WEBPACK_IMPORTED_MODULE_2__/* .fromTimestamp */ .Ol)(_google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_1__.Timestamp.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$amount, _object$amount2, _object$liquidityCrea, _object$joinTime;

    const message = createBaseMsgUnlockAndMigrateSharesToFullRangeConcentratedPositionResponse();
    message.amount0 = (_object$amount = object.amount0) !== null && _object$amount !== void 0 ? _object$amount : "";
    message.amount1 = (_object$amount2 = object.amount1) !== null && _object$amount2 !== void 0 ? _object$amount2 : "";
    message.liquidityCreated = (_object$liquidityCrea = object.liquidityCreated) !== null && _object$liquidityCrea !== void 0 ? _object$liquidityCrea : "";
    message.joinTime = (_object$joinTime = object.joinTime) !== null && _object$joinTime !== void 0 ? _object$joinTime : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      amount0: object.amount0,
      amount1: object.amount1,
      liquidityCreated: object.liquidity_created,
      joinTime: object !== null && object !== void 0 && object.join_time ? _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_1__.Timestamp.fromAmino(object.join_time) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.amount0 = message.amount0;
    obj.amount1 = message.amount1;
    obj.liquidity_created = message.liquidityCreated;
    obj.join_time = message.joinTime ? _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_1__.Timestamp.toAmino(message.joinTime) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgUnlockAndMigrateSharesToFullRangeConcentratedPositionResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/unlock-and-migrate-shares-to-full-range-concentrated-position-response",
      value: MsgUnlockAndMigrateSharesToFullRangeConcentratedPositionResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgUnlockAndMigrateSharesToFullRangeConcentratedPositionResponse.decode(message.value);
  },

  toProto(message) {
    return MsgUnlockAndMigrateSharesToFullRangeConcentratedPositionResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.superfluid.MsgUnlockAndMigrateSharesToFullRangeConcentratedPositionResponse",
      value: MsgUnlockAndMigrateSharesToFullRangeConcentratedPositionResponse.encode(message).finish()
    };
  }

};

function createBaseMsgAddToConcentratedLiquiditySuperfluidPosition() {
  return {
    positionId: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO,
    sender: "",
    tokenDesired0: undefined,
    tokenDesired1: undefined
  };
}

const MsgAddToConcentratedLiquiditySuperfluidPosition = {
  typeUrl: "/osmosis.superfluid.MsgAddToConcentratedLiquiditySuperfluidPosition",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (!message.positionId.isZero()) {
      writer.uint32(8).uint64(message.positionId);
    }

    if (message.sender !== "") {
      writer.uint32(18).string(message.sender);
    }

    if (message.tokenDesired0 !== undefined) {
      _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.encode(message.tokenDesired0, writer.uint32(26).fork()).ldelim();
    }

    if (message.tokenDesired1 !== undefined) {
      _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.encode(message.tokenDesired1, writer.uint32(34).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgAddToConcentratedLiquiditySuperfluidPosition();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.positionId = reader.uint64();
          break;

        case 2:
          message.sender = reader.string();
          break;

        case 3:
          message.tokenDesired0 = _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.decode(reader, reader.uint32());
          break;

        case 4:
          message.tokenDesired1 = _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$sender9;

    const message = createBaseMsgAddToConcentratedLiquiditySuperfluidPosition();
    message.positionId = object.positionId !== undefined && object.positionId !== null ? _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromValue */ .dK.fromValue(object.positionId) : _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO;
    message.sender = (_object$sender9 = object.sender) !== null && _object$sender9 !== void 0 ? _object$sender9 : "";
    message.tokenDesired0 = object.tokenDesired0 !== undefined && object.tokenDesired0 !== null ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.fromPartial(object.tokenDesired0) : undefined;
    message.tokenDesired1 = object.tokenDesired1 !== undefined && object.tokenDesired1 !== null ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.fromPartial(object.tokenDesired1) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      positionId: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromString */ .dK.fromString(object.position_id),
      sender: object.sender,
      tokenDesired0: object !== null && object !== void 0 && object.token_desired0 ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.fromAmino(object.token_desired0) : undefined,
      tokenDesired1: object !== null && object !== void 0 && object.token_desired1 ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.fromAmino(object.token_desired1) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.position_id = message.positionId ? message.positionId.toString() : undefined;
    obj.sender = message.sender;
    obj.token_desired0 = message.tokenDesired0 ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.toAmino(message.tokenDesired0) : undefined;
    obj.token_desired1 = message.tokenDesired1 ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.toAmino(message.tokenDesired1) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgAddToConcentratedLiquiditySuperfluidPosition.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/add-to-concentrated-liquidity-superfluid-position",
      value: MsgAddToConcentratedLiquiditySuperfluidPosition.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgAddToConcentratedLiquiditySuperfluidPosition.decode(message.value);
  },

  toProto(message) {
    return MsgAddToConcentratedLiquiditySuperfluidPosition.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.superfluid.MsgAddToConcentratedLiquiditySuperfluidPosition",
      value: MsgAddToConcentratedLiquiditySuperfluidPosition.encode(message).finish()
    };
  }

};

function createBaseMsgAddToConcentratedLiquiditySuperfluidPositionResponse() {
  return {
    positionId: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO,
    amount0: "",
    amount1: "",
    newLiquidity: "",
    lockId: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO
  };
}

const MsgAddToConcentratedLiquiditySuperfluidPositionResponse = {
  typeUrl: "/osmosis.superfluid.MsgAddToConcentratedLiquiditySuperfluidPositionResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (!message.positionId.isZero()) {
      writer.uint32(8).uint64(message.positionId);
    }

    if (message.amount0 !== "") {
      writer.uint32(18).string(message.amount0);
    }

    if (message.amount1 !== "") {
      writer.uint32(26).string(message.amount1);
    }

    if (message.newLiquidity !== "") {
      writer.uint32(42).string(message.newLiquidity);
    }

    if (!message.lockId.isZero()) {
      writer.uint32(32).uint64(message.lockId);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgAddToConcentratedLiquiditySuperfluidPositionResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.positionId = reader.uint64();
          break;

        case 2:
          message.amount0 = reader.string();
          break;

        case 3:
          message.amount1 = reader.string();
          break;

        case 5:
          message.newLiquidity = reader.string();
          break;

        case 4:
          message.lockId = reader.uint64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$amount3, _object$amount4, _object$newLiquidity;

    const message = createBaseMsgAddToConcentratedLiquiditySuperfluidPositionResponse();
    message.positionId = object.positionId !== undefined && object.positionId !== null ? _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromValue */ .dK.fromValue(object.positionId) : _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO;
    message.amount0 = (_object$amount3 = object.amount0) !== null && _object$amount3 !== void 0 ? _object$amount3 : "";
    message.amount1 = (_object$amount4 = object.amount1) !== null && _object$amount4 !== void 0 ? _object$amount4 : "";
    message.newLiquidity = (_object$newLiquidity = object.newLiquidity) !== null && _object$newLiquidity !== void 0 ? _object$newLiquidity : "";
    message.lockId = object.lockId !== undefined && object.lockId !== null ? _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromValue */ .dK.fromValue(object.lockId) : _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO;
    return message;
  },

  fromAmino(object) {
    return {
      positionId: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromString */ .dK.fromString(object.position_id),
      amount0: object.amount0,
      amount1: object.amount1,
      newLiquidity: object.new_liquidity,
      lockId: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromString */ .dK.fromString(object.lock_id)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.position_id = message.positionId ? message.positionId.toString() : undefined;
    obj.amount0 = message.amount0;
    obj.amount1 = message.amount1;
    obj.new_liquidity = message.newLiquidity;
    obj.lock_id = message.lockId ? message.lockId.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgAddToConcentratedLiquiditySuperfluidPositionResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/add-to-concentrated-liquidity-superfluid-position-response",
      value: MsgAddToConcentratedLiquiditySuperfluidPositionResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgAddToConcentratedLiquiditySuperfluidPositionResponse.decode(message.value);
  },

  toProto(message) {
    return MsgAddToConcentratedLiquiditySuperfluidPositionResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.superfluid.MsgAddToConcentratedLiquiditySuperfluidPositionResponse",
      value: MsgAddToConcentratedLiquiditySuperfluidPositionResponse.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 37883:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MsgClientImpl": function() { return /* binding */ MsgClientImpl; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4942);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _tx__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56429);



/** Msg defines the Msg service. */

class MsgClientImpl {
  constructor(rpc) {
    (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, "rpc", void 0);

    this.rpc = rpc;
    this.superfluidDelegate = this.superfluidDelegate.bind(this);
    this.superfluidUndelegate = this.superfluidUndelegate.bind(this);
    this.superfluidUnbondLock = this.superfluidUnbondLock.bind(this);
    this.superfluidUndelegateAndUnbondLock = this.superfluidUndelegateAndUnbondLock.bind(this);
    this.lockAndSuperfluidDelegate = this.lockAndSuperfluidDelegate.bind(this);
    this.createFullRangePositionAndSuperfluidDelegate = this.createFullRangePositionAndSuperfluidDelegate.bind(this);
    this.unPoolWhitelistedPool = this.unPoolWhitelistedPool.bind(this);
    this.unlockAndMigrateSharesToFullRangeConcentratedPosition = this.unlockAndMigrateSharesToFullRangeConcentratedPosition.bind(this);
    this.addToConcentratedLiquiditySuperfluidPosition = this.addToConcentratedLiquiditySuperfluidPosition.bind(this);
  }

  superfluidDelegate(request) {
    const data = _tx__WEBPACK_IMPORTED_MODULE_1__.MsgSuperfluidDelegate.encode(request).finish();
    const promise = this.rpc.request("osmosis.superfluid.Msg", "SuperfluidDelegate", data);
    return promise.then(data => _tx__WEBPACK_IMPORTED_MODULE_1__.MsgSuperfluidDelegateResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  superfluidUndelegate(request) {
    const data = _tx__WEBPACK_IMPORTED_MODULE_1__.MsgSuperfluidUndelegate.encode(request).finish();
    const promise = this.rpc.request("osmosis.superfluid.Msg", "SuperfluidUndelegate", data);
    return promise.then(data => _tx__WEBPACK_IMPORTED_MODULE_1__.MsgSuperfluidUndelegateResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  superfluidUnbondLock(request) {
    const data = _tx__WEBPACK_IMPORTED_MODULE_1__.MsgSuperfluidUnbondLock.encode(request).finish();
    const promise = this.rpc.request("osmosis.superfluid.Msg", "SuperfluidUnbondLock", data);
    return promise.then(data => _tx__WEBPACK_IMPORTED_MODULE_1__.MsgSuperfluidUnbondLockResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  superfluidUndelegateAndUnbondLock(request) {
    const data = _tx__WEBPACK_IMPORTED_MODULE_1__.MsgSuperfluidUndelegateAndUnbondLock.encode(request).finish();
    const promise = this.rpc.request("osmosis.superfluid.Msg", "SuperfluidUndelegateAndUnbondLock", data);
    return promise.then(data => _tx__WEBPACK_IMPORTED_MODULE_1__.MsgSuperfluidUndelegateAndUnbondLockResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  lockAndSuperfluidDelegate(request) {
    const data = _tx__WEBPACK_IMPORTED_MODULE_1__.MsgLockAndSuperfluidDelegate.encode(request).finish();
    const promise = this.rpc.request("osmosis.superfluid.Msg", "LockAndSuperfluidDelegate", data);
    return promise.then(data => _tx__WEBPACK_IMPORTED_MODULE_1__.MsgLockAndSuperfluidDelegateResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  createFullRangePositionAndSuperfluidDelegate(request) {
    const data = _tx__WEBPACK_IMPORTED_MODULE_1__.MsgCreateFullRangePositionAndSuperfluidDelegate.encode(request).finish();
    const promise = this.rpc.request("osmosis.superfluid.Msg", "CreateFullRangePositionAndSuperfluidDelegate", data);
    return promise.then(data => _tx__WEBPACK_IMPORTED_MODULE_1__.MsgCreateFullRangePositionAndSuperfluidDelegateResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  unPoolWhitelistedPool(request) {
    const data = _tx__WEBPACK_IMPORTED_MODULE_1__.MsgUnPoolWhitelistedPool.encode(request).finish();
    const promise = this.rpc.request("osmosis.superfluid.Msg", "UnPoolWhitelistedPool", data);
    return promise.then(data => _tx__WEBPACK_IMPORTED_MODULE_1__.MsgUnPoolWhitelistedPoolResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  unlockAndMigrateSharesToFullRangeConcentratedPosition(request) {
    const data = _tx__WEBPACK_IMPORTED_MODULE_1__.MsgUnlockAndMigrateSharesToFullRangeConcentratedPosition.encode(request).finish();
    const promise = this.rpc.request("osmosis.superfluid.Msg", "UnlockAndMigrateSharesToFullRangeConcentratedPosition", data);
    return promise.then(data => _tx__WEBPACK_IMPORTED_MODULE_1__.MsgUnlockAndMigrateSharesToFullRangeConcentratedPositionResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  addToConcentratedLiquiditySuperfluidPosition(request) {
    const data = _tx__WEBPACK_IMPORTED_MODULE_1__.MsgAddToConcentratedLiquiditySuperfluidPosition.encode(request).finish();
    const promise = this.rpc.request("osmosis.superfluid.Msg", "AddToConcentratedLiquiditySuperfluidPosition", data);
    return promise.then(data => _tx__WEBPACK_IMPORTED_MODULE_1__.MsgAddToConcentratedLiquiditySuperfluidPositionResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

}

/***/ }),

/***/ 56786:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DenomAuthorityMetadata": function() { return /* binding */ DenomAuthorityMetadata; }
/* harmony export */ });
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__);

/**
 * DenomAuthorityMetadata specifies metadata for addresses that have specific
 * capabilities over a token factory denom. Right now there is only one Admin
 * permission, but is planned to be extended to the future.
 */

function createBaseDenomAuthorityMetadata() {
  return {
    admin: ""
  };
}

const DenomAuthorityMetadata = {
  typeUrl: "/osmosis.tokenfactory.v1beta1.DenomAuthorityMetadata",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Writer.create()) {
    if (message.admin !== "") {
      writer.uint32(10).string(message.admin);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDenomAuthorityMetadata();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.admin = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$admin;

    const message = createBaseDenomAuthorityMetadata();
    message.admin = (_object$admin = object.admin) !== null && _object$admin !== void 0 ? _object$admin : "";
    return message;
  },

  fromAmino(object) {
    return {
      admin: object.admin
    };
  },

  toAmino(message) {
    const obj = {};
    obj.admin = message.admin;
    return obj;
  },

  fromAminoMsg(object) {
    return DenomAuthorityMetadata.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/tokenfactory/denom-authority-metadata",
      value: DenomAuthorityMetadata.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return DenomAuthorityMetadata.decode(message.value);
  },

  toProto(message) {
    return DenomAuthorityMetadata.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.tokenfactory.v1beta1.DenomAuthorityMetadata",
      value: DenomAuthorityMetadata.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 86839:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Params": function() { return /* binding */ Params; }
/* harmony export */ });
/* harmony import */ var _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26178);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47895);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__);



/** Params defines the parameters for the tokenfactory module. */

function createBaseParams() {
  return {
    denomCreationFee: [],
    denomCreationGasConsume: undefined
  };
}

const Params = {
  typeUrl: "/osmosis.tokenfactory.v1beta1.Params",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    for (const v of message.denomCreationFee) {
      _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.encode(v, writer.uint32(10).fork()).ldelim();
    }

    if (message.denomCreationGasConsume !== undefined) {
      writer.uint32(16).uint64(message.denomCreationGasConsume);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseParams();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.denomCreationFee.push(_cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.decode(reader, reader.uint32()));
          break;

        case 2:
          message.denomCreationGasConsume = reader.uint64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$denomCreation;

    const message = createBaseParams();
    message.denomCreationFee = ((_object$denomCreation = object.denomCreationFee) === null || _object$denomCreation === void 0 ? void 0 : _object$denomCreation.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.fromPartial(e))) || [];
    message.denomCreationGasConsume = object.denomCreationGasConsume !== undefined && object.denomCreationGasConsume !== null ? _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromValue */ .dK.fromValue(object.denomCreationGasConsume) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      denomCreationFee: Array.isArray(object === null || object === void 0 ? void 0 : object.denom_creation_fee) ? object.denom_creation_fee.map(e => _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.fromAmino(e)) : [],
      denomCreationGasConsume: object !== null && object !== void 0 && object.denom_creation_gas_consume ? _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromString */ .dK.fromString(object.denom_creation_gas_consume) : undefined
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.denomCreationFee) {
      obj.denom_creation_fee = message.denomCreationFee.map(e => e ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.toAmino(e) : undefined);
    } else {
      obj.denom_creation_fee = [];
    }

    obj.denom_creation_gas_consume = message.denomCreationGasConsume ? message.denomCreationGasConsume.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return Params.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/tokenfactory/params",
      value: Params.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return Params.decode(message.value);
  },

  toProto(message) {
    return Params.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.tokenfactory.v1beta1.Params",
      value: Params.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 41920:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QueryBeforeSendHookAddressRequest": function() { return /* binding */ QueryBeforeSendHookAddressRequest; },
/* harmony export */   "QueryBeforeSendHookAddressResponse": function() { return /* binding */ QueryBeforeSendHookAddressResponse; },
/* harmony export */   "QueryDenomAuthorityMetadataRequest": function() { return /* binding */ QueryDenomAuthorityMetadataRequest; },
/* harmony export */   "QueryDenomAuthorityMetadataResponse": function() { return /* binding */ QueryDenomAuthorityMetadataResponse; },
/* harmony export */   "QueryDenomsFromCreatorRequest": function() { return /* binding */ QueryDenomsFromCreatorRequest; },
/* harmony export */   "QueryDenomsFromCreatorResponse": function() { return /* binding */ QueryDenomsFromCreatorResponse; },
/* harmony export */   "QueryParamsRequest": function() { return /* binding */ QueryParamsRequest; },
/* harmony export */   "QueryParamsResponse": function() { return /* binding */ QueryParamsResponse; }
/* harmony export */ });
/* harmony import */ var _params__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(86839);
/* harmony import */ var _authorityMetadata__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56786);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__);



/** QueryParamsRequest is the request type for the Query/Params RPC method. */

function createBaseQueryParamsRequest() {
  return {};
}

const QueryParamsRequest = {
  typeUrl: "/osmosis.tokenfactory.v1beta1.QueryParamsRequest",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryParamsRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseQueryParamsRequest();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return QueryParamsRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/tokenfactory/query-params-request",
      value: QueryParamsRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryParamsRequest.decode(message.value);
  },

  toProto(message) {
    return QueryParamsRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.tokenfactory.v1beta1.QueryParamsRequest",
      value: QueryParamsRequest.encode(message).finish()
    };
  }

};

function createBaseQueryParamsResponse() {
  return {
    params: undefined
  };
}

const QueryParamsResponse = {
  typeUrl: "/osmosis.tokenfactory.v1beta1.QueryParamsResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (message.params !== undefined) {
      _params__WEBPACK_IMPORTED_MODULE_0__.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryParamsResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.params = _params__WEBPACK_IMPORTED_MODULE_0__.Params.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseQueryParamsResponse();
    message.params = object.params !== undefined && object.params !== null ? _params__WEBPACK_IMPORTED_MODULE_0__.Params.fromPartial(object.params) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      params: object !== null && object !== void 0 && object.params ? _params__WEBPACK_IMPORTED_MODULE_0__.Params.fromAmino(object.params) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.params = message.params ? _params__WEBPACK_IMPORTED_MODULE_0__.Params.toAmino(message.params) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryParamsResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/tokenfactory/query-params-response",
      value: QueryParamsResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryParamsResponse.decode(message.value);
  },

  toProto(message) {
    return QueryParamsResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.tokenfactory.v1beta1.QueryParamsResponse",
      value: QueryParamsResponse.encode(message).finish()
    };
  }

};

function createBaseQueryDenomAuthorityMetadataRequest() {
  return {
    denom: ""
  };
}

const QueryDenomAuthorityMetadataRequest = {
  typeUrl: "/osmosis.tokenfactory.v1beta1.QueryDenomAuthorityMetadataRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (message.denom !== "") {
      writer.uint32(10).string(message.denom);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryDenomAuthorityMetadataRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.denom = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$denom;

    const message = createBaseQueryDenomAuthorityMetadataRequest();
    message.denom = (_object$denom = object.denom) !== null && _object$denom !== void 0 ? _object$denom : "";
    return message;
  },

  fromAmino(object) {
    return {
      denom: object.denom
    };
  },

  toAmino(message) {
    const obj = {};
    obj.denom = message.denom;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryDenomAuthorityMetadataRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/tokenfactory/query-denom-authority-metadata-request",
      value: QueryDenomAuthorityMetadataRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryDenomAuthorityMetadataRequest.decode(message.value);
  },

  toProto(message) {
    return QueryDenomAuthorityMetadataRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.tokenfactory.v1beta1.QueryDenomAuthorityMetadataRequest",
      value: QueryDenomAuthorityMetadataRequest.encode(message).finish()
    };
  }

};

function createBaseQueryDenomAuthorityMetadataResponse() {
  return {
    authorityMetadata: undefined
  };
}

const QueryDenomAuthorityMetadataResponse = {
  typeUrl: "/osmosis.tokenfactory.v1beta1.QueryDenomAuthorityMetadataResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (message.authorityMetadata !== undefined) {
      _authorityMetadata__WEBPACK_IMPORTED_MODULE_1__.DenomAuthorityMetadata.encode(message.authorityMetadata, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryDenomAuthorityMetadataResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.authorityMetadata = _authorityMetadata__WEBPACK_IMPORTED_MODULE_1__.DenomAuthorityMetadata.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseQueryDenomAuthorityMetadataResponse();
    message.authorityMetadata = object.authorityMetadata !== undefined && object.authorityMetadata !== null ? _authorityMetadata__WEBPACK_IMPORTED_MODULE_1__.DenomAuthorityMetadata.fromPartial(object.authorityMetadata) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      authorityMetadata: object !== null && object !== void 0 && object.authority_metadata ? _authorityMetadata__WEBPACK_IMPORTED_MODULE_1__.DenomAuthorityMetadata.fromAmino(object.authority_metadata) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.authority_metadata = message.authorityMetadata ? _authorityMetadata__WEBPACK_IMPORTED_MODULE_1__.DenomAuthorityMetadata.toAmino(message.authorityMetadata) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryDenomAuthorityMetadataResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/tokenfactory/query-denom-authority-metadata-response",
      value: QueryDenomAuthorityMetadataResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryDenomAuthorityMetadataResponse.decode(message.value);
  },

  toProto(message) {
    return QueryDenomAuthorityMetadataResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.tokenfactory.v1beta1.QueryDenomAuthorityMetadataResponse",
      value: QueryDenomAuthorityMetadataResponse.encode(message).finish()
    };
  }

};

function createBaseQueryDenomsFromCreatorRequest() {
  return {
    creator: ""
  };
}

const QueryDenomsFromCreatorRequest = {
  typeUrl: "/osmosis.tokenfactory.v1beta1.QueryDenomsFromCreatorRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (message.creator !== "") {
      writer.uint32(10).string(message.creator);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryDenomsFromCreatorRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.creator = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$creator;

    const message = createBaseQueryDenomsFromCreatorRequest();
    message.creator = (_object$creator = object.creator) !== null && _object$creator !== void 0 ? _object$creator : "";
    return message;
  },

  fromAmino(object) {
    return {
      creator: object.creator
    };
  },

  toAmino(message) {
    const obj = {};
    obj.creator = message.creator;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryDenomsFromCreatorRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/tokenfactory/query-denoms-from-creator-request",
      value: QueryDenomsFromCreatorRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryDenomsFromCreatorRequest.decode(message.value);
  },

  toProto(message) {
    return QueryDenomsFromCreatorRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.tokenfactory.v1beta1.QueryDenomsFromCreatorRequest",
      value: QueryDenomsFromCreatorRequest.encode(message).finish()
    };
  }

};

function createBaseQueryDenomsFromCreatorResponse() {
  return {
    denoms: []
  };
}

const QueryDenomsFromCreatorResponse = {
  typeUrl: "/osmosis.tokenfactory.v1beta1.QueryDenomsFromCreatorResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    for (const v of message.denoms) {
      writer.uint32(10).string(v);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryDenomsFromCreatorResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.denoms.push(reader.string());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$denoms;

    const message = createBaseQueryDenomsFromCreatorResponse();
    message.denoms = ((_object$denoms = object.denoms) === null || _object$denoms === void 0 ? void 0 : _object$denoms.map(e => e)) || [];
    return message;
  },

  fromAmino(object) {
    return {
      denoms: Array.isArray(object === null || object === void 0 ? void 0 : object.denoms) ? object.denoms.map(e => e) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.denoms) {
      obj.denoms = message.denoms.map(e => e);
    } else {
      obj.denoms = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return QueryDenomsFromCreatorResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/tokenfactory/query-denoms-from-creator-response",
      value: QueryDenomsFromCreatorResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryDenomsFromCreatorResponse.decode(message.value);
  },

  toProto(message) {
    return QueryDenomsFromCreatorResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.tokenfactory.v1beta1.QueryDenomsFromCreatorResponse",
      value: QueryDenomsFromCreatorResponse.encode(message).finish()
    };
  }

};

function createBaseQueryBeforeSendHookAddressRequest() {
  return {
    denom: ""
  };
}

const QueryBeforeSendHookAddressRequest = {
  typeUrl: "/osmosis.tokenfactory.v1beta1.QueryBeforeSendHookAddressRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (message.denom !== "") {
      writer.uint32(10).string(message.denom);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryBeforeSendHookAddressRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.denom = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$denom2;

    const message = createBaseQueryBeforeSendHookAddressRequest();
    message.denom = (_object$denom2 = object.denom) !== null && _object$denom2 !== void 0 ? _object$denom2 : "";
    return message;
  },

  fromAmino(object) {
    return {
      denom: object.denom
    };
  },

  toAmino(message) {
    const obj = {};
    obj.denom = message.denom;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryBeforeSendHookAddressRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/tokenfactory/query-before-send-hook-address-request",
      value: QueryBeforeSendHookAddressRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryBeforeSendHookAddressRequest.decode(message.value);
  },

  toProto(message) {
    return QueryBeforeSendHookAddressRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.tokenfactory.v1beta1.QueryBeforeSendHookAddressRequest",
      value: QueryBeforeSendHookAddressRequest.encode(message).finish()
    };
  }

};

function createBaseQueryBeforeSendHookAddressResponse() {
  return {
    cosmwasmAddress: ""
  };
}

const QueryBeforeSendHookAddressResponse = {
  typeUrl: "/osmosis.tokenfactory.v1beta1.QueryBeforeSendHookAddressResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (message.cosmwasmAddress !== "") {
      writer.uint32(10).string(message.cosmwasmAddress);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryBeforeSendHookAddressResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.cosmwasmAddress = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$cosmwasmAddre;

    const message = createBaseQueryBeforeSendHookAddressResponse();
    message.cosmwasmAddress = (_object$cosmwasmAddre = object.cosmwasmAddress) !== null && _object$cosmwasmAddre !== void 0 ? _object$cosmwasmAddre : "";
    return message;
  },

  fromAmino(object) {
    return {
      cosmwasmAddress: object.cosmwasm_address
    };
  },

  toAmino(message) {
    const obj = {};
    obj.cosmwasm_address = message.cosmwasmAddress;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryBeforeSendHookAddressResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/tokenfactory/query-before-send-hook-address-response",
      value: QueryBeforeSendHookAddressResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryBeforeSendHookAddressResponse.decode(message.value);
  },

  toProto(message) {
    return QueryBeforeSendHookAddressResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.tokenfactory.v1beta1.QueryBeforeSendHookAddressResponse",
      value: QueryBeforeSendHookAddressResponse.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 12262:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LCDQueryClient": function() { return /* binding */ LCDQueryClient; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4942);

class LCDQueryClient {
  constructor({
    requestClient
  }) {
    (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, "req", void 0);

    this.req = requestClient;
    this.params = this.params.bind(this);
    this.denomAuthorityMetadata = this.denomAuthorityMetadata.bind(this);
    this.denomsFromCreator = this.denomsFromCreator.bind(this);
    this.beforeSendHookAddress = this.beforeSendHookAddress.bind(this);
  }
  /* Params defines a gRPC query method that returns the tokenfactory module's
   parameters. */


  async params(_params = {}) {
    const endpoint = `osmosis/tokenfactory/v1beta1/params`;
    return await this.req.get(endpoint);
  }
  /* DenomAuthorityMetadata defines a gRPC query method for fetching
   DenomAuthorityMetadata for a particular denom. */


  async denomAuthorityMetadata(params) {
    const endpoint = `osmosis/tokenfactory/v1beta1/denoms/${params.denom}/authority_metadata`;
    return await this.req.get(endpoint);
  }
  /* DenomsFromCreator defines a gRPC query method for fetching all
   denominations created by a specific admin/creator. */


  async denomsFromCreator(params) {
    const endpoint = `osmosis/tokenfactory/v1beta1/denoms_from_creator/${params.creator}`;
    return await this.req.get(endpoint);
  }
  /* BeforeSendHookAddress defines a gRPC query method for
   getting the address registered for the before send hook. */


  async beforeSendHookAddress(params) {
    const endpoint = `osmosis/tokenfactory/v1beta1/denoms/${params.denom}/before_send_hook`;
    return await this.req.get(endpoint);
  }

}

/***/ }),

/***/ 46066:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QueryClientImpl": function() { return /* binding */ QueryClientImpl; },
/* harmony export */   "createRpcQueryExtension": function() { return /* binding */ createRpcQueryExtension; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4942);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78441);
/* harmony import */ var _cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41920);




/** Query defines the gRPC querier service. */

class QueryClientImpl {
  constructor(rpc) {
    (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, "rpc", void 0);

    this.rpc = rpc;
    this.params = this.params.bind(this);
    this.denomAuthorityMetadata = this.denomAuthorityMetadata.bind(this);
    this.denomsFromCreator = this.denomsFromCreator.bind(this);
    this.beforeSendHookAddress = this.beforeSendHookAddress.bind(this);
  }

  params(request = {}) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryParamsRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.tokenfactory.v1beta1.Query", "Params", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryParamsResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  denomAuthorityMetadata(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryDenomAuthorityMetadataRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.tokenfactory.v1beta1.Query", "DenomAuthorityMetadata", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryDenomAuthorityMetadataResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  denomsFromCreator(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryDenomsFromCreatorRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.tokenfactory.v1beta1.Query", "DenomsFromCreator", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryDenomsFromCreatorResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  beforeSendHookAddress(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryBeforeSendHookAddressRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.tokenfactory.v1beta1.Query", "BeforeSendHookAddress", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryBeforeSendHookAddressResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

}
const createRpcQueryExtension = base => {
  const rpc = (0,_cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1__.createProtobufRpcClient)(base);
  const queryService = new QueryClientImpl(rpc);
  return {
    params(request) {
      return queryService.params(request);
    },

    denomAuthorityMetadata(request) {
      return queryService.denomAuthorityMetadata(request);
    },

    denomsFromCreator(request) {
      return queryService.denomsFromCreator(request);
    },

    beforeSendHookAddress(request) {
      return queryService.beforeSendHookAddress(request);
    }

  };
};

/***/ }),

/***/ 37974:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MsgBurn": function() { return /* binding */ MsgBurn; },
/* harmony export */   "MsgBurnResponse": function() { return /* binding */ MsgBurnResponse; },
/* harmony export */   "MsgChangeAdmin": function() { return /* binding */ MsgChangeAdmin; },
/* harmony export */   "MsgChangeAdminResponse": function() { return /* binding */ MsgChangeAdminResponse; },
/* harmony export */   "MsgCreateDenom": function() { return /* binding */ MsgCreateDenom; },
/* harmony export */   "MsgCreateDenomResponse": function() { return /* binding */ MsgCreateDenomResponse; },
/* harmony export */   "MsgForceTransfer": function() { return /* binding */ MsgForceTransfer; },
/* harmony export */   "MsgForceTransferResponse": function() { return /* binding */ MsgForceTransferResponse; },
/* harmony export */   "MsgMint": function() { return /* binding */ MsgMint; },
/* harmony export */   "MsgMintResponse": function() { return /* binding */ MsgMintResponse; },
/* harmony export */   "MsgSetBeforeSendHook": function() { return /* binding */ MsgSetBeforeSendHook; },
/* harmony export */   "MsgSetBeforeSendHookResponse": function() { return /* binding */ MsgSetBeforeSendHookResponse; },
/* harmony export */   "MsgSetDenomMetadata": function() { return /* binding */ MsgSetDenomMetadata; },
/* harmony export */   "MsgSetDenomMetadataResponse": function() { return /* binding */ MsgSetDenomMetadataResponse; }
/* harmony export */ });
/* harmony import */ var _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26178);
/* harmony import */ var _cosmos_bank_v1beta1_bank__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38986);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__);



/**
 * MsgCreateDenom defines the message structure for the CreateDenom gRPC service
 * method. It allows an account to create a new denom. It requires a sender
 * address and a sub denomination. The (sender_address, sub_denomination) tuple
 * must be unique and cannot be re-used.
 * 
 * The resulting denom created is defined as
 * <factory/{creatorAddress}/{subdenom}>. The resulting denom's admin is
 * originally set to be the creator, but this can be changed later. The token
 * denom does not indicate the current admin.
 */

function createBaseMsgCreateDenom() {
  return {
    sender: "",
    subdenom: ""
  };
}

const MsgCreateDenom = {
  typeUrl: "/osmosis.tokenfactory.v1beta1.MsgCreateDenom",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (message.sender !== "") {
      writer.uint32(10).string(message.sender);
    }

    if (message.subdenom !== "") {
      writer.uint32(18).string(message.subdenom);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgCreateDenom();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.sender = reader.string();
          break;

        case 2:
          message.subdenom = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$sender, _object$subdenom;

    const message = createBaseMsgCreateDenom();
    message.sender = (_object$sender = object.sender) !== null && _object$sender !== void 0 ? _object$sender : "";
    message.subdenom = (_object$subdenom = object.subdenom) !== null && _object$subdenom !== void 0 ? _object$subdenom : "";
    return message;
  },

  fromAmino(object) {
    return {
      sender: object.sender,
      subdenom: object.subdenom
    };
  },

  toAmino(message) {
    const obj = {};
    obj.sender = message.sender;
    obj.subdenom = message.subdenom;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgCreateDenom.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/tokenfactory/create-denom",
      value: MsgCreateDenom.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgCreateDenom.decode(message.value);
  },

  toProto(message) {
    return MsgCreateDenom.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.tokenfactory.v1beta1.MsgCreateDenom",
      value: MsgCreateDenom.encode(message).finish()
    };
  }

};

function createBaseMsgCreateDenomResponse() {
  return {
    newTokenDenom: ""
  };
}

const MsgCreateDenomResponse = {
  typeUrl: "/osmosis.tokenfactory.v1beta1.MsgCreateDenomResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (message.newTokenDenom !== "") {
      writer.uint32(10).string(message.newTokenDenom);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgCreateDenomResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.newTokenDenom = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$newTokenDenom;

    const message = createBaseMsgCreateDenomResponse();
    message.newTokenDenom = (_object$newTokenDenom = object.newTokenDenom) !== null && _object$newTokenDenom !== void 0 ? _object$newTokenDenom : "";
    return message;
  },

  fromAmino(object) {
    return {
      newTokenDenom: object.new_token_denom
    };
  },

  toAmino(message) {
    const obj = {};
    obj.new_token_denom = message.newTokenDenom;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgCreateDenomResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/tokenfactory/create-denom-response",
      value: MsgCreateDenomResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgCreateDenomResponse.decode(message.value);
  },

  toProto(message) {
    return MsgCreateDenomResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.tokenfactory.v1beta1.MsgCreateDenomResponse",
      value: MsgCreateDenomResponse.encode(message).finish()
    };
  }

};

function createBaseMsgMint() {
  return {
    sender: "",
    amount: undefined,
    mintToAddress: ""
  };
}

const MsgMint = {
  typeUrl: "/osmosis.tokenfactory.v1beta1.MsgMint",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (message.sender !== "") {
      writer.uint32(10).string(message.sender);
    }

    if (message.amount !== undefined) {
      _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.encode(message.amount, writer.uint32(18).fork()).ldelim();
    }

    if (message.mintToAddress !== "") {
      writer.uint32(26).string(message.mintToAddress);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgMint();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.sender = reader.string();
          break;

        case 2:
          message.amount = _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.decode(reader, reader.uint32());
          break;

        case 3:
          message.mintToAddress = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$sender2, _object$mintToAddress;

    const message = createBaseMsgMint();
    message.sender = (_object$sender2 = object.sender) !== null && _object$sender2 !== void 0 ? _object$sender2 : "";
    message.amount = object.amount !== undefined && object.amount !== null ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.fromPartial(object.amount) : undefined;
    message.mintToAddress = (_object$mintToAddress = object.mintToAddress) !== null && _object$mintToAddress !== void 0 ? _object$mintToAddress : "";
    return message;
  },

  fromAmino(object) {
    return {
      sender: object.sender,
      amount: object !== null && object !== void 0 && object.amount ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.fromAmino(object.amount) : undefined,
      mintToAddress: object.mintToAddress
    };
  },

  toAmino(message) {
    const obj = {};
    obj.sender = message.sender;
    obj.amount = message.amount ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.toAmino(message.amount) : undefined;
    obj.mintToAddress = message.mintToAddress;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgMint.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/tokenfactory/mint",
      value: MsgMint.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgMint.decode(message.value);
  },

  toProto(message) {
    return MsgMint.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.tokenfactory.v1beta1.MsgMint",
      value: MsgMint.encode(message).finish()
    };
  }

};

function createBaseMsgMintResponse() {
  return {};
}

const MsgMintResponse = {
  typeUrl: "/osmosis.tokenfactory.v1beta1.MsgMintResponse",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgMintResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseMsgMintResponse();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return MsgMintResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/tokenfactory/mint-response",
      value: MsgMintResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgMintResponse.decode(message.value);
  },

  toProto(message) {
    return MsgMintResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.tokenfactory.v1beta1.MsgMintResponse",
      value: MsgMintResponse.encode(message).finish()
    };
  }

};

function createBaseMsgBurn() {
  return {
    sender: "",
    amount: undefined,
    burnFromAddress: ""
  };
}

const MsgBurn = {
  typeUrl: "/osmosis.tokenfactory.v1beta1.MsgBurn",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (message.sender !== "") {
      writer.uint32(10).string(message.sender);
    }

    if (message.amount !== undefined) {
      _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.encode(message.amount, writer.uint32(18).fork()).ldelim();
    }

    if (message.burnFromAddress !== "") {
      writer.uint32(26).string(message.burnFromAddress);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgBurn();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.sender = reader.string();
          break;

        case 2:
          message.amount = _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.decode(reader, reader.uint32());
          break;

        case 3:
          message.burnFromAddress = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$sender3, _object$burnFromAddre;

    const message = createBaseMsgBurn();
    message.sender = (_object$sender3 = object.sender) !== null && _object$sender3 !== void 0 ? _object$sender3 : "";
    message.amount = object.amount !== undefined && object.amount !== null ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.fromPartial(object.amount) : undefined;
    message.burnFromAddress = (_object$burnFromAddre = object.burnFromAddress) !== null && _object$burnFromAddre !== void 0 ? _object$burnFromAddre : "";
    return message;
  },

  fromAmino(object) {
    return {
      sender: object.sender,
      amount: object !== null && object !== void 0 && object.amount ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.fromAmino(object.amount) : undefined,
      burnFromAddress: object.burnFromAddress
    };
  },

  toAmino(message) {
    const obj = {};
    obj.sender = message.sender;
    obj.amount = message.amount ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.toAmino(message.amount) : undefined;
    obj.burnFromAddress = message.burnFromAddress;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgBurn.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/tokenfactory/burn",
      value: MsgBurn.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgBurn.decode(message.value);
  },

  toProto(message) {
    return MsgBurn.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.tokenfactory.v1beta1.MsgBurn",
      value: MsgBurn.encode(message).finish()
    };
  }

};

function createBaseMsgBurnResponse() {
  return {};
}

const MsgBurnResponse = {
  typeUrl: "/osmosis.tokenfactory.v1beta1.MsgBurnResponse",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgBurnResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseMsgBurnResponse();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return MsgBurnResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/tokenfactory/burn-response",
      value: MsgBurnResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgBurnResponse.decode(message.value);
  },

  toProto(message) {
    return MsgBurnResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.tokenfactory.v1beta1.MsgBurnResponse",
      value: MsgBurnResponse.encode(message).finish()
    };
  }

};

function createBaseMsgChangeAdmin() {
  return {
    sender: "",
    denom: "",
    newAdmin: ""
  };
}

const MsgChangeAdmin = {
  typeUrl: "/osmosis.tokenfactory.v1beta1.MsgChangeAdmin",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (message.sender !== "") {
      writer.uint32(10).string(message.sender);
    }

    if (message.denom !== "") {
      writer.uint32(18).string(message.denom);
    }

    if (message.newAdmin !== "") {
      writer.uint32(26).string(message.newAdmin);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgChangeAdmin();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.sender = reader.string();
          break;

        case 2:
          message.denom = reader.string();
          break;

        case 3:
          message.newAdmin = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$sender4, _object$denom, _object$newAdmin;

    const message = createBaseMsgChangeAdmin();
    message.sender = (_object$sender4 = object.sender) !== null && _object$sender4 !== void 0 ? _object$sender4 : "";
    message.denom = (_object$denom = object.denom) !== null && _object$denom !== void 0 ? _object$denom : "";
    message.newAdmin = (_object$newAdmin = object.newAdmin) !== null && _object$newAdmin !== void 0 ? _object$newAdmin : "";
    return message;
  },

  fromAmino(object) {
    return {
      sender: object.sender,
      denom: object.denom,
      newAdmin: object.new_admin
    };
  },

  toAmino(message) {
    const obj = {};
    obj.sender = message.sender;
    obj.denom = message.denom;
    obj.new_admin = message.newAdmin;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgChangeAdmin.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/tokenfactory/change-admin",
      value: MsgChangeAdmin.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgChangeAdmin.decode(message.value);
  },

  toProto(message) {
    return MsgChangeAdmin.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.tokenfactory.v1beta1.MsgChangeAdmin",
      value: MsgChangeAdmin.encode(message).finish()
    };
  }

};

function createBaseMsgChangeAdminResponse() {
  return {};
}

const MsgChangeAdminResponse = {
  typeUrl: "/osmosis.tokenfactory.v1beta1.MsgChangeAdminResponse",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgChangeAdminResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseMsgChangeAdminResponse();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return MsgChangeAdminResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/tokenfactory/change-admin-response",
      value: MsgChangeAdminResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgChangeAdminResponse.decode(message.value);
  },

  toProto(message) {
    return MsgChangeAdminResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.tokenfactory.v1beta1.MsgChangeAdminResponse",
      value: MsgChangeAdminResponse.encode(message).finish()
    };
  }

};

function createBaseMsgSetBeforeSendHook() {
  return {
    sender: "",
    denom: "",
    cosmwasmAddress: ""
  };
}

const MsgSetBeforeSendHook = {
  typeUrl: "/osmosis.tokenfactory.v1beta1.MsgSetBeforeSendHook",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (message.sender !== "") {
      writer.uint32(10).string(message.sender);
    }

    if (message.denom !== "") {
      writer.uint32(18).string(message.denom);
    }

    if (message.cosmwasmAddress !== "") {
      writer.uint32(26).string(message.cosmwasmAddress);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgSetBeforeSendHook();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.sender = reader.string();
          break;

        case 2:
          message.denom = reader.string();
          break;

        case 3:
          message.cosmwasmAddress = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$sender5, _object$denom2, _object$cosmwasmAddre;

    const message = createBaseMsgSetBeforeSendHook();
    message.sender = (_object$sender5 = object.sender) !== null && _object$sender5 !== void 0 ? _object$sender5 : "";
    message.denom = (_object$denom2 = object.denom) !== null && _object$denom2 !== void 0 ? _object$denom2 : "";
    message.cosmwasmAddress = (_object$cosmwasmAddre = object.cosmwasmAddress) !== null && _object$cosmwasmAddre !== void 0 ? _object$cosmwasmAddre : "";
    return message;
  },

  fromAmino(object) {
    return {
      sender: object.sender,
      denom: object.denom,
      cosmwasmAddress: object.cosmwasm_address
    };
  },

  toAmino(message) {
    const obj = {};
    obj.sender = message.sender;
    obj.denom = message.denom;
    obj.cosmwasm_address = message.cosmwasmAddress;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgSetBeforeSendHook.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/tokenfactory/set-before-send-hook",
      value: MsgSetBeforeSendHook.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgSetBeforeSendHook.decode(message.value);
  },

  toProto(message) {
    return MsgSetBeforeSendHook.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.tokenfactory.v1beta1.MsgSetBeforeSendHook",
      value: MsgSetBeforeSendHook.encode(message).finish()
    };
  }

};

function createBaseMsgSetBeforeSendHookResponse() {
  return {};
}

const MsgSetBeforeSendHookResponse = {
  typeUrl: "/osmosis.tokenfactory.v1beta1.MsgSetBeforeSendHookResponse",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgSetBeforeSendHookResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseMsgSetBeforeSendHookResponse();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return MsgSetBeforeSendHookResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/tokenfactory/set-before-send-hook-response",
      value: MsgSetBeforeSendHookResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgSetBeforeSendHookResponse.decode(message.value);
  },

  toProto(message) {
    return MsgSetBeforeSendHookResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.tokenfactory.v1beta1.MsgSetBeforeSendHookResponse",
      value: MsgSetBeforeSendHookResponse.encode(message).finish()
    };
  }

};

function createBaseMsgSetDenomMetadata() {
  return {
    sender: "",
    metadata: undefined
  };
}

const MsgSetDenomMetadata = {
  typeUrl: "/osmosis.tokenfactory.v1beta1.MsgSetDenomMetadata",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (message.sender !== "") {
      writer.uint32(10).string(message.sender);
    }

    if (message.metadata !== undefined) {
      _cosmos_bank_v1beta1_bank__WEBPACK_IMPORTED_MODULE_1__.Metadata.encode(message.metadata, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgSetDenomMetadata();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.sender = reader.string();
          break;

        case 2:
          message.metadata = _cosmos_bank_v1beta1_bank__WEBPACK_IMPORTED_MODULE_1__.Metadata.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$sender6;

    const message = createBaseMsgSetDenomMetadata();
    message.sender = (_object$sender6 = object.sender) !== null && _object$sender6 !== void 0 ? _object$sender6 : "";
    message.metadata = object.metadata !== undefined && object.metadata !== null ? _cosmos_bank_v1beta1_bank__WEBPACK_IMPORTED_MODULE_1__.Metadata.fromPartial(object.metadata) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      sender: object.sender,
      metadata: object !== null && object !== void 0 && object.metadata ? _cosmos_bank_v1beta1_bank__WEBPACK_IMPORTED_MODULE_1__.Metadata.fromAmino(object.metadata) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.sender = message.sender;
    obj.metadata = message.metadata ? _cosmos_bank_v1beta1_bank__WEBPACK_IMPORTED_MODULE_1__.Metadata.toAmino(message.metadata) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgSetDenomMetadata.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/tokenfactory/set-denom-metadata",
      value: MsgSetDenomMetadata.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgSetDenomMetadata.decode(message.value);
  },

  toProto(message) {
    return MsgSetDenomMetadata.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.tokenfactory.v1beta1.MsgSetDenomMetadata",
      value: MsgSetDenomMetadata.encode(message).finish()
    };
  }

};

function createBaseMsgSetDenomMetadataResponse() {
  return {};
}

const MsgSetDenomMetadataResponse = {
  typeUrl: "/osmosis.tokenfactory.v1beta1.MsgSetDenomMetadataResponse",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgSetDenomMetadataResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseMsgSetDenomMetadataResponse();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return MsgSetDenomMetadataResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/tokenfactory/set-denom-metadata-response",
      value: MsgSetDenomMetadataResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgSetDenomMetadataResponse.decode(message.value);
  },

  toProto(message) {
    return MsgSetDenomMetadataResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.tokenfactory.v1beta1.MsgSetDenomMetadataResponse",
      value: MsgSetDenomMetadataResponse.encode(message).finish()
    };
  }

};

function createBaseMsgForceTransfer() {
  return {
    sender: "",
    amount: undefined,
    transferFromAddress: "",
    transferToAddress: ""
  };
}

const MsgForceTransfer = {
  typeUrl: "/osmosis.tokenfactory.v1beta1.MsgForceTransfer",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (message.sender !== "") {
      writer.uint32(10).string(message.sender);
    }

    if (message.amount !== undefined) {
      _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.encode(message.amount, writer.uint32(18).fork()).ldelim();
    }

    if (message.transferFromAddress !== "") {
      writer.uint32(26).string(message.transferFromAddress);
    }

    if (message.transferToAddress !== "") {
      writer.uint32(34).string(message.transferToAddress);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgForceTransfer();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.sender = reader.string();
          break;

        case 2:
          message.amount = _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.decode(reader, reader.uint32());
          break;

        case 3:
          message.transferFromAddress = reader.string();
          break;

        case 4:
          message.transferToAddress = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$sender7, _object$transferFromA, _object$transferToAdd;

    const message = createBaseMsgForceTransfer();
    message.sender = (_object$sender7 = object.sender) !== null && _object$sender7 !== void 0 ? _object$sender7 : "";
    message.amount = object.amount !== undefined && object.amount !== null ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.fromPartial(object.amount) : undefined;
    message.transferFromAddress = (_object$transferFromA = object.transferFromAddress) !== null && _object$transferFromA !== void 0 ? _object$transferFromA : "";
    message.transferToAddress = (_object$transferToAdd = object.transferToAddress) !== null && _object$transferToAdd !== void 0 ? _object$transferToAdd : "";
    return message;
  },

  fromAmino(object) {
    return {
      sender: object.sender,
      amount: object !== null && object !== void 0 && object.amount ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.fromAmino(object.amount) : undefined,
      transferFromAddress: object.transferFromAddress,
      transferToAddress: object.transferToAddress
    };
  },

  toAmino(message) {
    const obj = {};
    obj.sender = message.sender;
    obj.amount = message.amount ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_0__.Coin.toAmino(message.amount) : undefined;
    obj.transferFromAddress = message.transferFromAddress;
    obj.transferToAddress = message.transferToAddress;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgForceTransfer.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/tokenfactory/force-transfer",
      value: MsgForceTransfer.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgForceTransfer.decode(message.value);
  },

  toProto(message) {
    return MsgForceTransfer.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.tokenfactory.v1beta1.MsgForceTransfer",
      value: MsgForceTransfer.encode(message).finish()
    };
  }

};

function createBaseMsgForceTransferResponse() {
  return {};
}

const MsgForceTransferResponse = {
  typeUrl: "/osmosis.tokenfactory.v1beta1.MsgForceTransferResponse",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgForceTransferResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseMsgForceTransferResponse();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return MsgForceTransferResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/tokenfactory/force-transfer-response",
      value: MsgForceTransferResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgForceTransferResponse.decode(message.value);
  },

  toProto(message) {
    return MsgForceTransferResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.tokenfactory.v1beta1.MsgForceTransferResponse",
      value: MsgForceTransferResponse.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 88301:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MsgClientImpl": function() { return /* binding */ MsgClientImpl; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4942);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _tx__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37974);



/** Msg defines the tokefactory module's gRPC message service. */

class MsgClientImpl {
  constructor(rpc) {
    (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, "rpc", void 0);

    this.rpc = rpc;
    this.createDenom = this.createDenom.bind(this);
    this.mint = this.mint.bind(this);
    this.burn = this.burn.bind(this);
    this.changeAdmin = this.changeAdmin.bind(this);
    this.setDenomMetadata = this.setDenomMetadata.bind(this);
    this.setBeforeSendHook = this.setBeforeSendHook.bind(this);
    this.forceTransfer = this.forceTransfer.bind(this);
  }

  createDenom(request) {
    const data = _tx__WEBPACK_IMPORTED_MODULE_1__.MsgCreateDenom.encode(request).finish();
    const promise = this.rpc.request("osmosis.tokenfactory.v1beta1.Msg", "CreateDenom", data);
    return promise.then(data => _tx__WEBPACK_IMPORTED_MODULE_1__.MsgCreateDenomResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  mint(request) {
    const data = _tx__WEBPACK_IMPORTED_MODULE_1__.MsgMint.encode(request).finish();
    const promise = this.rpc.request("osmosis.tokenfactory.v1beta1.Msg", "Mint", data);
    return promise.then(data => _tx__WEBPACK_IMPORTED_MODULE_1__.MsgMintResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  burn(request) {
    const data = _tx__WEBPACK_IMPORTED_MODULE_1__.MsgBurn.encode(request).finish();
    const promise = this.rpc.request("osmosis.tokenfactory.v1beta1.Msg", "Burn", data);
    return promise.then(data => _tx__WEBPACK_IMPORTED_MODULE_1__.MsgBurnResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  changeAdmin(request) {
    const data = _tx__WEBPACK_IMPORTED_MODULE_1__.MsgChangeAdmin.encode(request).finish();
    const promise = this.rpc.request("osmosis.tokenfactory.v1beta1.Msg", "ChangeAdmin", data);
    return promise.then(data => _tx__WEBPACK_IMPORTED_MODULE_1__.MsgChangeAdminResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  setDenomMetadata(request) {
    const data = _tx__WEBPACK_IMPORTED_MODULE_1__.MsgSetDenomMetadata.encode(request).finish();
    const promise = this.rpc.request("osmosis.tokenfactory.v1beta1.Msg", "SetDenomMetadata", data);
    return promise.then(data => _tx__WEBPACK_IMPORTED_MODULE_1__.MsgSetDenomMetadataResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  setBeforeSendHook(request) {
    const data = _tx__WEBPACK_IMPORTED_MODULE_1__.MsgSetBeforeSendHook.encode(request).finish();
    const promise = this.rpc.request("osmosis.tokenfactory.v1beta1.Msg", "SetBeforeSendHook", data);
    return promise.then(data => _tx__WEBPACK_IMPORTED_MODULE_1__.MsgSetBeforeSendHookResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  forceTransfer(request) {
    const data = _tx__WEBPACK_IMPORTED_MODULE_1__.MsgForceTransfer.encode(request).finish();
    const promise = this.rpc.request("osmosis.tokenfactory.v1beta1.Msg", "ForceTransfer", data);
    return promise.then(data => _tx__WEBPACK_IMPORTED_MODULE_1__.MsgForceTransferResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

}

/***/ }),

/***/ 4003:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GenesisState": function() { return /* binding */ GenesisState; },
/* harmony export */   "Params": function() { return /* binding */ Params; }
/* harmony export */ });
/* harmony import */ var _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6499);
/* harmony import */ var _twap_record__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25754);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__);



/** Params holds parameters for the twap module */

function createBaseParams() {
  return {
    pruneEpochIdentifier: "",
    recordHistoryKeepPeriod: undefined
  };
}

const Params = {
  typeUrl: "/osmosis.twap.v1beta1.Params",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (message.pruneEpochIdentifier !== "") {
      writer.uint32(10).string(message.pruneEpochIdentifier);
    }

    if (message.recordHistoryKeepPeriod !== undefined) {
      _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_0__.Duration.encode(message.recordHistoryKeepPeriod, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseParams();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.pruneEpochIdentifier = reader.string();
          break;

        case 2:
          message.recordHistoryKeepPeriod = _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_0__.Duration.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$pruneEpochIde;

    const message = createBaseParams();
    message.pruneEpochIdentifier = (_object$pruneEpochIde = object.pruneEpochIdentifier) !== null && _object$pruneEpochIde !== void 0 ? _object$pruneEpochIde : "";
    message.recordHistoryKeepPeriod = object.recordHistoryKeepPeriod !== undefined && object.recordHistoryKeepPeriod !== null ? _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_0__.Duration.fromPartial(object.recordHistoryKeepPeriod) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      pruneEpochIdentifier: object.prune_epoch_identifier,
      recordHistoryKeepPeriod: object !== null && object !== void 0 && object.record_history_keep_period ? _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_0__.Duration.fromAmino(object.record_history_keep_period) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.prune_epoch_identifier = message.pruneEpochIdentifier;
    obj.record_history_keep_period = message.recordHistoryKeepPeriod ? _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_0__.Duration.toAmino(message.recordHistoryKeepPeriod) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return Params.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/twap/params",
      value: Params.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return Params.decode(message.value);
  },

  toProto(message) {
    return Params.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.twap.v1beta1.Params",
      value: Params.encode(message).finish()
    };
  }

};

function createBaseGenesisState() {
  return {
    twaps: [],
    params: undefined
  };
}

const GenesisState = {
  typeUrl: "/osmosis.twap.v1beta1.GenesisState",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    for (const v of message.twaps) {
      _twap_record__WEBPACK_IMPORTED_MODULE_1__.TwapRecord.encode(v, writer.uint32(10).fork()).ldelim();
    }

    if (message.params !== undefined) {
      Params.encode(message.params, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGenesisState();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.twaps.push(_twap_record__WEBPACK_IMPORTED_MODULE_1__.TwapRecord.decode(reader, reader.uint32()));
          break;

        case 2:
          message.params = Params.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$twaps;

    const message = createBaseGenesisState();
    message.twaps = ((_object$twaps = object.twaps) === null || _object$twaps === void 0 ? void 0 : _object$twaps.map(e => _twap_record__WEBPACK_IMPORTED_MODULE_1__.TwapRecord.fromPartial(e))) || [];
    message.params = object.params !== undefined && object.params !== null ? Params.fromPartial(object.params) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      twaps: Array.isArray(object === null || object === void 0 ? void 0 : object.twaps) ? object.twaps.map(e => _twap_record__WEBPACK_IMPORTED_MODULE_1__.TwapRecord.fromAmino(e)) : [],
      params: object !== null && object !== void 0 && object.params ? Params.fromAmino(object.params) : undefined
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.twaps) {
      obj.twaps = message.twaps.map(e => e ? _twap_record__WEBPACK_IMPORTED_MODULE_1__.TwapRecord.toAmino(e) : undefined);
    } else {
      obj.twaps = [];
    }

    obj.params = message.params ? Params.toAmino(message.params) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return GenesisState.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/twap/genesis-state",
      value: GenesisState.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return GenesisState.decode(message.value);
  },

  toProto(message) {
    return GenesisState.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.twap.v1beta1.GenesisState",
      value: GenesisState.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 11069:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ArithmeticTwapRequest": function() { return /* binding */ ArithmeticTwapRequest; },
/* harmony export */   "ArithmeticTwapResponse": function() { return /* binding */ ArithmeticTwapResponse; },
/* harmony export */   "ArithmeticTwapToNowRequest": function() { return /* binding */ ArithmeticTwapToNowRequest; },
/* harmony export */   "ArithmeticTwapToNowResponse": function() { return /* binding */ ArithmeticTwapToNowResponse; },
/* harmony export */   "GeometricTwapRequest": function() { return /* binding */ GeometricTwapRequest; },
/* harmony export */   "GeometricTwapResponse": function() { return /* binding */ GeometricTwapResponse; },
/* harmony export */   "GeometricTwapToNowRequest": function() { return /* binding */ GeometricTwapToNowRequest; },
/* harmony export */   "GeometricTwapToNowResponse": function() { return /* binding */ GeometricTwapToNowResponse; },
/* harmony export */   "ParamsRequest": function() { return /* binding */ ParamsRequest; },
/* harmony export */   "ParamsResponse": function() { return /* binding */ ParamsResponse; }
/* harmony export */ });
/* harmony import */ var _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20633);
/* harmony import */ var _genesis__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4003);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47895);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__);





function createBaseArithmeticTwapRequest() {
  return {
    poolId: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO,
    baseAsset: "",
    quoteAsset: "",
    startTime: undefined,
    endTime: undefined
  };
}

const ArithmeticTwapRequest = {
  typeUrl: "/osmosis.twap.v1beta1.ArithmeticTwapRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (!message.poolId.isZero()) {
      writer.uint32(8).uint64(message.poolId);
    }

    if (message.baseAsset !== "") {
      writer.uint32(18).string(message.baseAsset);
    }

    if (message.quoteAsset !== "") {
      writer.uint32(26).string(message.quoteAsset);
    }

    if (message.startTime !== undefined) {
      _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_0__.Timestamp.encode((0,_helpers__WEBPACK_IMPORTED_MODULE_2__/* .toTimestamp */ .Uq)(message.startTime), writer.uint32(34).fork()).ldelim();
    }

    if (message.endTime !== undefined) {
      _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_0__.Timestamp.encode((0,_helpers__WEBPACK_IMPORTED_MODULE_2__/* .toTimestamp */ .Uq)(message.endTime), writer.uint32(42).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseArithmeticTwapRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.poolId = reader.uint64();
          break;

        case 2:
          message.baseAsset = reader.string();
          break;

        case 3:
          message.quoteAsset = reader.string();
          break;

        case 4:
          message.startTime = (0,_helpers__WEBPACK_IMPORTED_MODULE_2__/* .fromTimestamp */ .Ol)(_google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_0__.Timestamp.decode(reader, reader.uint32()));
          break;

        case 5:
          message.endTime = (0,_helpers__WEBPACK_IMPORTED_MODULE_2__/* .fromTimestamp */ .Ol)(_google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_0__.Timestamp.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$baseAsset, _object$quoteAsset, _object$startTime, _object$endTime;

    const message = createBaseArithmeticTwapRequest();
    message.poolId = object.poolId !== undefined && object.poolId !== null ? _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromValue */ .dK.fromValue(object.poolId) : _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO;
    message.baseAsset = (_object$baseAsset = object.baseAsset) !== null && _object$baseAsset !== void 0 ? _object$baseAsset : "";
    message.quoteAsset = (_object$quoteAsset = object.quoteAsset) !== null && _object$quoteAsset !== void 0 ? _object$quoteAsset : "";
    message.startTime = (_object$startTime = object.startTime) !== null && _object$startTime !== void 0 ? _object$startTime : undefined;
    message.endTime = (_object$endTime = object.endTime) !== null && _object$endTime !== void 0 ? _object$endTime : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      poolId: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromString */ .dK.fromString(object.pool_id),
      baseAsset: object.base_asset,
      quoteAsset: object.quote_asset,
      startTime: object !== null && object !== void 0 && object.start_time ? _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_0__.Timestamp.fromAmino(object.start_time) : undefined,
      endTime: object !== null && object !== void 0 && object.end_time ? _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_0__.Timestamp.fromAmino(object.end_time) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.pool_id = message.poolId ? message.poolId.toString() : undefined;
    obj.base_asset = message.baseAsset;
    obj.quote_asset = message.quoteAsset;
    obj.start_time = message.startTime ? _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_0__.Timestamp.toAmino(message.startTime) : undefined;
    obj.end_time = message.endTime ? _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_0__.Timestamp.toAmino(message.endTime) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return ArithmeticTwapRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/twap/arithmetic-twap-request",
      value: ArithmeticTwapRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return ArithmeticTwapRequest.decode(message.value);
  },

  toProto(message) {
    return ArithmeticTwapRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.twap.v1beta1.ArithmeticTwapRequest",
      value: ArithmeticTwapRequest.encode(message).finish()
    };
  }

};

function createBaseArithmeticTwapResponse() {
  return {
    arithmeticTwap: ""
  };
}

const ArithmeticTwapResponse = {
  typeUrl: "/osmosis.twap.v1beta1.ArithmeticTwapResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.arithmeticTwap !== "") {
      writer.uint32(10).string(message.arithmeticTwap);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseArithmeticTwapResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.arithmeticTwap = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$arithmeticTwa;

    const message = createBaseArithmeticTwapResponse();
    message.arithmeticTwap = (_object$arithmeticTwa = object.arithmeticTwap) !== null && _object$arithmeticTwa !== void 0 ? _object$arithmeticTwa : "";
    return message;
  },

  fromAmino(object) {
    return {
      arithmeticTwap: object.arithmetic_twap
    };
  },

  toAmino(message) {
    const obj = {};
    obj.arithmetic_twap = message.arithmeticTwap;
    return obj;
  },

  fromAminoMsg(object) {
    return ArithmeticTwapResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/twap/arithmetic-twap-response",
      value: ArithmeticTwapResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return ArithmeticTwapResponse.decode(message.value);
  },

  toProto(message) {
    return ArithmeticTwapResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.twap.v1beta1.ArithmeticTwapResponse",
      value: ArithmeticTwapResponse.encode(message).finish()
    };
  }

};

function createBaseArithmeticTwapToNowRequest() {
  return {
    poolId: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO,
    baseAsset: "",
    quoteAsset: "",
    startTime: undefined
  };
}

const ArithmeticTwapToNowRequest = {
  typeUrl: "/osmosis.twap.v1beta1.ArithmeticTwapToNowRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (!message.poolId.isZero()) {
      writer.uint32(8).uint64(message.poolId);
    }

    if (message.baseAsset !== "") {
      writer.uint32(18).string(message.baseAsset);
    }

    if (message.quoteAsset !== "") {
      writer.uint32(26).string(message.quoteAsset);
    }

    if (message.startTime !== undefined) {
      _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_0__.Timestamp.encode((0,_helpers__WEBPACK_IMPORTED_MODULE_2__/* .toTimestamp */ .Uq)(message.startTime), writer.uint32(34).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseArithmeticTwapToNowRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.poolId = reader.uint64();
          break;

        case 2:
          message.baseAsset = reader.string();
          break;

        case 3:
          message.quoteAsset = reader.string();
          break;

        case 4:
          message.startTime = (0,_helpers__WEBPACK_IMPORTED_MODULE_2__/* .fromTimestamp */ .Ol)(_google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_0__.Timestamp.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$baseAsset2, _object$quoteAsset2, _object$startTime2;

    const message = createBaseArithmeticTwapToNowRequest();
    message.poolId = object.poolId !== undefined && object.poolId !== null ? _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromValue */ .dK.fromValue(object.poolId) : _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO;
    message.baseAsset = (_object$baseAsset2 = object.baseAsset) !== null && _object$baseAsset2 !== void 0 ? _object$baseAsset2 : "";
    message.quoteAsset = (_object$quoteAsset2 = object.quoteAsset) !== null && _object$quoteAsset2 !== void 0 ? _object$quoteAsset2 : "";
    message.startTime = (_object$startTime2 = object.startTime) !== null && _object$startTime2 !== void 0 ? _object$startTime2 : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      poolId: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromString */ .dK.fromString(object.pool_id),
      baseAsset: object.base_asset,
      quoteAsset: object.quote_asset,
      startTime: object !== null && object !== void 0 && object.start_time ? _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_0__.Timestamp.fromAmino(object.start_time) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.pool_id = message.poolId ? message.poolId.toString() : undefined;
    obj.base_asset = message.baseAsset;
    obj.quote_asset = message.quoteAsset;
    obj.start_time = message.startTime ? _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_0__.Timestamp.toAmino(message.startTime) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return ArithmeticTwapToNowRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/twap/arithmetic-twap-to-now-request",
      value: ArithmeticTwapToNowRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return ArithmeticTwapToNowRequest.decode(message.value);
  },

  toProto(message) {
    return ArithmeticTwapToNowRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.twap.v1beta1.ArithmeticTwapToNowRequest",
      value: ArithmeticTwapToNowRequest.encode(message).finish()
    };
  }

};

function createBaseArithmeticTwapToNowResponse() {
  return {
    arithmeticTwap: ""
  };
}

const ArithmeticTwapToNowResponse = {
  typeUrl: "/osmosis.twap.v1beta1.ArithmeticTwapToNowResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.arithmeticTwap !== "") {
      writer.uint32(10).string(message.arithmeticTwap);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseArithmeticTwapToNowResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.arithmeticTwap = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$arithmeticTwa2;

    const message = createBaseArithmeticTwapToNowResponse();
    message.arithmeticTwap = (_object$arithmeticTwa2 = object.arithmeticTwap) !== null && _object$arithmeticTwa2 !== void 0 ? _object$arithmeticTwa2 : "";
    return message;
  },

  fromAmino(object) {
    return {
      arithmeticTwap: object.arithmetic_twap
    };
  },

  toAmino(message) {
    const obj = {};
    obj.arithmetic_twap = message.arithmeticTwap;
    return obj;
  },

  fromAminoMsg(object) {
    return ArithmeticTwapToNowResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/twap/arithmetic-twap-to-now-response",
      value: ArithmeticTwapToNowResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return ArithmeticTwapToNowResponse.decode(message.value);
  },

  toProto(message) {
    return ArithmeticTwapToNowResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.twap.v1beta1.ArithmeticTwapToNowResponse",
      value: ArithmeticTwapToNowResponse.encode(message).finish()
    };
  }

};

function createBaseGeometricTwapRequest() {
  return {
    poolId: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO,
    baseAsset: "",
    quoteAsset: "",
    startTime: undefined,
    endTime: undefined
  };
}

const GeometricTwapRequest = {
  typeUrl: "/osmosis.twap.v1beta1.GeometricTwapRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (!message.poolId.isZero()) {
      writer.uint32(8).uint64(message.poolId);
    }

    if (message.baseAsset !== "") {
      writer.uint32(18).string(message.baseAsset);
    }

    if (message.quoteAsset !== "") {
      writer.uint32(26).string(message.quoteAsset);
    }

    if (message.startTime !== undefined) {
      _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_0__.Timestamp.encode((0,_helpers__WEBPACK_IMPORTED_MODULE_2__/* .toTimestamp */ .Uq)(message.startTime), writer.uint32(34).fork()).ldelim();
    }

    if (message.endTime !== undefined) {
      _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_0__.Timestamp.encode((0,_helpers__WEBPACK_IMPORTED_MODULE_2__/* .toTimestamp */ .Uq)(message.endTime), writer.uint32(42).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGeometricTwapRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.poolId = reader.uint64();
          break;

        case 2:
          message.baseAsset = reader.string();
          break;

        case 3:
          message.quoteAsset = reader.string();
          break;

        case 4:
          message.startTime = (0,_helpers__WEBPACK_IMPORTED_MODULE_2__/* .fromTimestamp */ .Ol)(_google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_0__.Timestamp.decode(reader, reader.uint32()));
          break;

        case 5:
          message.endTime = (0,_helpers__WEBPACK_IMPORTED_MODULE_2__/* .fromTimestamp */ .Ol)(_google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_0__.Timestamp.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$baseAsset3, _object$quoteAsset3, _object$startTime3, _object$endTime2;

    const message = createBaseGeometricTwapRequest();
    message.poolId = object.poolId !== undefined && object.poolId !== null ? _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromValue */ .dK.fromValue(object.poolId) : _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO;
    message.baseAsset = (_object$baseAsset3 = object.baseAsset) !== null && _object$baseAsset3 !== void 0 ? _object$baseAsset3 : "";
    message.quoteAsset = (_object$quoteAsset3 = object.quoteAsset) !== null && _object$quoteAsset3 !== void 0 ? _object$quoteAsset3 : "";
    message.startTime = (_object$startTime3 = object.startTime) !== null && _object$startTime3 !== void 0 ? _object$startTime3 : undefined;
    message.endTime = (_object$endTime2 = object.endTime) !== null && _object$endTime2 !== void 0 ? _object$endTime2 : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      poolId: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromString */ .dK.fromString(object.pool_id),
      baseAsset: object.base_asset,
      quoteAsset: object.quote_asset,
      startTime: object !== null && object !== void 0 && object.start_time ? _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_0__.Timestamp.fromAmino(object.start_time) : undefined,
      endTime: object !== null && object !== void 0 && object.end_time ? _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_0__.Timestamp.fromAmino(object.end_time) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.pool_id = message.poolId ? message.poolId.toString() : undefined;
    obj.base_asset = message.baseAsset;
    obj.quote_asset = message.quoteAsset;
    obj.start_time = message.startTime ? _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_0__.Timestamp.toAmino(message.startTime) : undefined;
    obj.end_time = message.endTime ? _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_0__.Timestamp.toAmino(message.endTime) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return GeometricTwapRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/twap/geometric-twap-request",
      value: GeometricTwapRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return GeometricTwapRequest.decode(message.value);
  },

  toProto(message) {
    return GeometricTwapRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.twap.v1beta1.GeometricTwapRequest",
      value: GeometricTwapRequest.encode(message).finish()
    };
  }

};

function createBaseGeometricTwapResponse() {
  return {
    geometricTwap: ""
  };
}

const GeometricTwapResponse = {
  typeUrl: "/osmosis.twap.v1beta1.GeometricTwapResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.geometricTwap !== "") {
      writer.uint32(10).string(message.geometricTwap);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGeometricTwapResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.geometricTwap = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$geometricTwap;

    const message = createBaseGeometricTwapResponse();
    message.geometricTwap = (_object$geometricTwap = object.geometricTwap) !== null && _object$geometricTwap !== void 0 ? _object$geometricTwap : "";
    return message;
  },

  fromAmino(object) {
    return {
      geometricTwap: object.geometric_twap
    };
  },

  toAmino(message) {
    const obj = {};
    obj.geometric_twap = message.geometricTwap;
    return obj;
  },

  fromAminoMsg(object) {
    return GeometricTwapResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/twap/geometric-twap-response",
      value: GeometricTwapResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return GeometricTwapResponse.decode(message.value);
  },

  toProto(message) {
    return GeometricTwapResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.twap.v1beta1.GeometricTwapResponse",
      value: GeometricTwapResponse.encode(message).finish()
    };
  }

};

function createBaseGeometricTwapToNowRequest() {
  return {
    poolId: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO,
    baseAsset: "",
    quoteAsset: "",
    startTime: undefined
  };
}

const GeometricTwapToNowRequest = {
  typeUrl: "/osmosis.twap.v1beta1.GeometricTwapToNowRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (!message.poolId.isZero()) {
      writer.uint32(8).uint64(message.poolId);
    }

    if (message.baseAsset !== "") {
      writer.uint32(18).string(message.baseAsset);
    }

    if (message.quoteAsset !== "") {
      writer.uint32(26).string(message.quoteAsset);
    }

    if (message.startTime !== undefined) {
      _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_0__.Timestamp.encode((0,_helpers__WEBPACK_IMPORTED_MODULE_2__/* .toTimestamp */ .Uq)(message.startTime), writer.uint32(34).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGeometricTwapToNowRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.poolId = reader.uint64();
          break;

        case 2:
          message.baseAsset = reader.string();
          break;

        case 3:
          message.quoteAsset = reader.string();
          break;

        case 4:
          message.startTime = (0,_helpers__WEBPACK_IMPORTED_MODULE_2__/* .fromTimestamp */ .Ol)(_google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_0__.Timestamp.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$baseAsset4, _object$quoteAsset4, _object$startTime4;

    const message = createBaseGeometricTwapToNowRequest();
    message.poolId = object.poolId !== undefined && object.poolId !== null ? _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromValue */ .dK.fromValue(object.poolId) : _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO;
    message.baseAsset = (_object$baseAsset4 = object.baseAsset) !== null && _object$baseAsset4 !== void 0 ? _object$baseAsset4 : "";
    message.quoteAsset = (_object$quoteAsset4 = object.quoteAsset) !== null && _object$quoteAsset4 !== void 0 ? _object$quoteAsset4 : "";
    message.startTime = (_object$startTime4 = object.startTime) !== null && _object$startTime4 !== void 0 ? _object$startTime4 : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      poolId: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromString */ .dK.fromString(object.pool_id),
      baseAsset: object.base_asset,
      quoteAsset: object.quote_asset,
      startTime: object !== null && object !== void 0 && object.start_time ? _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_0__.Timestamp.fromAmino(object.start_time) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.pool_id = message.poolId ? message.poolId.toString() : undefined;
    obj.base_asset = message.baseAsset;
    obj.quote_asset = message.quoteAsset;
    obj.start_time = message.startTime ? _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_0__.Timestamp.toAmino(message.startTime) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return GeometricTwapToNowRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/twap/geometric-twap-to-now-request",
      value: GeometricTwapToNowRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return GeometricTwapToNowRequest.decode(message.value);
  },

  toProto(message) {
    return GeometricTwapToNowRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.twap.v1beta1.GeometricTwapToNowRequest",
      value: GeometricTwapToNowRequest.encode(message).finish()
    };
  }

};

function createBaseGeometricTwapToNowResponse() {
  return {
    geometricTwap: ""
  };
}

const GeometricTwapToNowResponse = {
  typeUrl: "/osmosis.twap.v1beta1.GeometricTwapToNowResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.geometricTwap !== "") {
      writer.uint32(10).string(message.geometricTwap);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGeometricTwapToNowResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.geometricTwap = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$geometricTwap2;

    const message = createBaseGeometricTwapToNowResponse();
    message.geometricTwap = (_object$geometricTwap2 = object.geometricTwap) !== null && _object$geometricTwap2 !== void 0 ? _object$geometricTwap2 : "";
    return message;
  },

  fromAmino(object) {
    return {
      geometricTwap: object.geometric_twap
    };
  },

  toAmino(message) {
    const obj = {};
    obj.geometric_twap = message.geometricTwap;
    return obj;
  },

  fromAminoMsg(object) {
    return GeometricTwapToNowResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/twap/geometric-twap-to-now-response",
      value: GeometricTwapToNowResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return GeometricTwapToNowResponse.decode(message.value);
  },

  toProto(message) {
    return GeometricTwapToNowResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.twap.v1beta1.GeometricTwapToNowResponse",
      value: GeometricTwapToNowResponse.encode(message).finish()
    };
  }

};

function createBaseParamsRequest() {
  return {};
}

const ParamsRequest = {
  typeUrl: "/osmosis.twap.v1beta1.ParamsRequest",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseParamsRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseParamsRequest();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return ParamsRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/twap/params-request",
      value: ParamsRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return ParamsRequest.decode(message.value);
  },

  toProto(message) {
    return ParamsRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.twap.v1beta1.ParamsRequest",
      value: ParamsRequest.encode(message).finish()
    };
  }

};

function createBaseParamsResponse() {
  return {
    params: undefined
  };
}

const ParamsResponse = {
  typeUrl: "/osmosis.twap.v1beta1.ParamsResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.params !== undefined) {
      _genesis__WEBPACK_IMPORTED_MODULE_1__.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseParamsResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.params = _genesis__WEBPACK_IMPORTED_MODULE_1__.Params.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseParamsResponse();
    message.params = object.params !== undefined && object.params !== null ? _genesis__WEBPACK_IMPORTED_MODULE_1__.Params.fromPartial(object.params) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      params: object !== null && object !== void 0 && object.params ? _genesis__WEBPACK_IMPORTED_MODULE_1__.Params.fromAmino(object.params) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.params = message.params ? _genesis__WEBPACK_IMPORTED_MODULE_1__.Params.toAmino(message.params) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return ParamsResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/twap/params-response",
      value: ParamsResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return ParamsResponse.decode(message.value);
  },

  toProto(message) {
    return ParamsResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.twap.v1beta1.ParamsResponse",
      value: ParamsResponse.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 37302:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LCDQueryClient": function() { return /* binding */ LCDQueryClient; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4942);

class LCDQueryClient {
  constructor({
    requestClient
  }) {
    (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, "req", void 0);

    this.req = requestClient;
    this.params = this.params.bind(this);
    this.arithmeticTwap = this.arithmeticTwap.bind(this);
    this.arithmeticTwapToNow = this.arithmeticTwapToNow.bind(this);
    this.geometricTwap = this.geometricTwap.bind(this);
    this.geometricTwapToNow = this.geometricTwapToNow.bind(this);
  }
  /* Params */


  async params(_params = {}) {
    const endpoint = `osmosis/twap/v1beta1/Params`;
    return await this.req.get(endpoint);
  }
  /* ArithmeticTwap */


  async arithmeticTwap(params) {
    const options = {
      params: {}
    };

    if (typeof (params === null || params === void 0 ? void 0 : params.poolId) !== "undefined") {
      options.params.pool_id = params.poolId;
    }

    if (typeof (params === null || params === void 0 ? void 0 : params.baseAsset) !== "undefined") {
      options.params.base_asset = params.baseAsset;
    }

    if (typeof (params === null || params === void 0 ? void 0 : params.quoteAsset) !== "undefined") {
      options.params.quote_asset = params.quoteAsset;
    }

    if (typeof (params === null || params === void 0 ? void 0 : params.startTime) !== "undefined") {
      options.params.start_time = params.startTime;
    }

    if (typeof (params === null || params === void 0 ? void 0 : params.endTime) !== "undefined") {
      options.params.end_time = params.endTime;
    }

    const endpoint = `osmosis/twap/v1beta1/ArithmeticTwap`;
    return await this.req.get(endpoint, options);
  }
  /* ArithmeticTwapToNow */


  async arithmeticTwapToNow(params) {
    const options = {
      params: {}
    };

    if (typeof (params === null || params === void 0 ? void 0 : params.poolId) !== "undefined") {
      options.params.pool_id = params.poolId;
    }

    if (typeof (params === null || params === void 0 ? void 0 : params.baseAsset) !== "undefined") {
      options.params.base_asset = params.baseAsset;
    }

    if (typeof (params === null || params === void 0 ? void 0 : params.quoteAsset) !== "undefined") {
      options.params.quote_asset = params.quoteAsset;
    }

    if (typeof (params === null || params === void 0 ? void 0 : params.startTime) !== "undefined") {
      options.params.start_time = params.startTime;
    }

    const endpoint = `osmosis/twap/v1beta1/ArithmeticTwapToNow`;
    return await this.req.get(endpoint, options);
  }
  /* GeometricTwap */


  async geometricTwap(params) {
    const options = {
      params: {}
    };

    if (typeof (params === null || params === void 0 ? void 0 : params.poolId) !== "undefined") {
      options.params.pool_id = params.poolId;
    }

    if (typeof (params === null || params === void 0 ? void 0 : params.baseAsset) !== "undefined") {
      options.params.base_asset = params.baseAsset;
    }

    if (typeof (params === null || params === void 0 ? void 0 : params.quoteAsset) !== "undefined") {
      options.params.quote_asset = params.quoteAsset;
    }

    if (typeof (params === null || params === void 0 ? void 0 : params.startTime) !== "undefined") {
      options.params.start_time = params.startTime;
    }

    if (typeof (params === null || params === void 0 ? void 0 : params.endTime) !== "undefined") {
      options.params.end_time = params.endTime;
    }

    const endpoint = `osmosis/twap/v1beta1/GeometricTwap`;
    return await this.req.get(endpoint, options);
  }
  /* GeometricTwapToNow */


  async geometricTwapToNow(params) {
    const options = {
      params: {}
    };

    if (typeof (params === null || params === void 0 ? void 0 : params.poolId) !== "undefined") {
      options.params.pool_id = params.poolId;
    }

    if (typeof (params === null || params === void 0 ? void 0 : params.baseAsset) !== "undefined") {
      options.params.base_asset = params.baseAsset;
    }

    if (typeof (params === null || params === void 0 ? void 0 : params.quoteAsset) !== "undefined") {
      options.params.quote_asset = params.quoteAsset;
    }

    if (typeof (params === null || params === void 0 ? void 0 : params.startTime) !== "undefined") {
      options.params.start_time = params.startTime;
    }

    const endpoint = `osmosis/twap/v1beta1/GeometricTwapToNow`;
    return await this.req.get(endpoint, options);
  }

}

/***/ }),

/***/ 126:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QueryClientImpl": function() { return /* binding */ QueryClientImpl; },
/* harmony export */   "createRpcQueryExtension": function() { return /* binding */ createRpcQueryExtension; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4942);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78441);
/* harmony import */ var _cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11069);




class QueryClientImpl {
  constructor(rpc) {
    (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, "rpc", void 0);

    this.rpc = rpc;
    this.params = this.params.bind(this);
    this.arithmeticTwap = this.arithmeticTwap.bind(this);
    this.arithmeticTwapToNow = this.arithmeticTwapToNow.bind(this);
    this.geometricTwap = this.geometricTwap.bind(this);
    this.geometricTwapToNow = this.geometricTwapToNow.bind(this);
  }

  params(request = {}) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.ParamsRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.twap.v1beta1.Query", "Params", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.ParamsResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  arithmeticTwap(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.ArithmeticTwapRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.twap.v1beta1.Query", "ArithmeticTwap", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.ArithmeticTwapResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  arithmeticTwapToNow(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.ArithmeticTwapToNowRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.twap.v1beta1.Query", "ArithmeticTwapToNow", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.ArithmeticTwapToNowResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  geometricTwap(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.GeometricTwapRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.twap.v1beta1.Query", "GeometricTwap", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.GeometricTwapResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  geometricTwapToNow(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.GeometricTwapToNowRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.twap.v1beta1.Query", "GeometricTwapToNow", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.GeometricTwapToNowResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

}
const createRpcQueryExtension = base => {
  const rpc = (0,_cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1__.createProtobufRpcClient)(base);
  const queryService = new QueryClientImpl(rpc);
  return {
    params(request) {
      return queryService.params(request);
    },

    arithmeticTwap(request) {
      return queryService.arithmeticTwap(request);
    },

    arithmeticTwapToNow(request) {
      return queryService.arithmeticTwapToNow(request);
    },

    geometricTwap(request) {
      return queryService.geometricTwap(request);
    },

    geometricTwapToNow(request) {
      return queryService.geometricTwapToNow(request);
    }

  };
};

/***/ }),

/***/ 25754:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "TwapRecord": function() { return /* binding */ TwapRecord; }
/* harmony export */ });
/* harmony import */ var _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20633);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47895);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__);



/**
 * A TWAP record should be indexed in state by pool_id, (asset pair), timestamp
 * The asset pair assets should be lexicographically sorted.
 * Technically (pool_id, asset_0_denom, asset_1_denom, height) do not need to
 * appear in the struct however we view this as the wrong performance tradeoff
 * given SDK today. Would rather we optimize for readability and correctness,
 * than an optimal state storage format. The system bottleneck is elsewhere for
 * now.
 */

function createBaseTwapRecord() {
  return {
    poolId: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.UZERO */ .dK.UZERO,
    asset0Denom: "",
    asset1Denom: "",
    height: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.ZERO */ .dK.ZERO,
    time: undefined,
    p0LastSpotPrice: "",
    p1LastSpotPrice: "",
    p0ArithmeticTwapAccumulator: "",
    p1ArithmeticTwapAccumulator: "",
    geometricTwapAccumulator: "",
    lastErrorTime: undefined
  };
}

const TwapRecord = {
  typeUrl: "/osmosis.twap.v1beta1.TwapRecord",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (!message.poolId.isZero()) {
      writer.uint32(8).uint64(message.poolId);
    }

    if (message.asset0Denom !== "") {
      writer.uint32(18).string(message.asset0Denom);
    }

    if (message.asset1Denom !== "") {
      writer.uint32(26).string(message.asset1Denom);
    }

    if (!message.height.isZero()) {
      writer.uint32(32).int64(message.height);
    }

    if (message.time !== undefined) {
      _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_0__.Timestamp.encode((0,_helpers__WEBPACK_IMPORTED_MODULE_1__/* .toTimestamp */ .Uq)(message.time), writer.uint32(42).fork()).ldelim();
    }

    if (message.p0LastSpotPrice !== "") {
      writer.uint32(50).string(message.p0LastSpotPrice);
    }

    if (message.p1LastSpotPrice !== "") {
      writer.uint32(58).string(message.p1LastSpotPrice);
    }

    if (message.p0ArithmeticTwapAccumulator !== "") {
      writer.uint32(66).string(message.p0ArithmeticTwapAccumulator);
    }

    if (message.p1ArithmeticTwapAccumulator !== "") {
      writer.uint32(74).string(message.p1ArithmeticTwapAccumulator);
    }

    if (message.geometricTwapAccumulator !== "") {
      writer.uint32(82).string(message.geometricTwapAccumulator);
    }

    if (message.lastErrorTime !== undefined) {
      _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_0__.Timestamp.encode((0,_helpers__WEBPACK_IMPORTED_MODULE_1__/* .toTimestamp */ .Uq)(message.lastErrorTime), writer.uint32(90).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTwapRecord();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.poolId = reader.uint64();
          break;

        case 2:
          message.asset0Denom = reader.string();
          break;

        case 3:
          message.asset1Denom = reader.string();
          break;

        case 4:
          message.height = reader.int64();
          break;

        case 5:
          message.time = (0,_helpers__WEBPACK_IMPORTED_MODULE_1__/* .fromTimestamp */ .Ol)(_google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_0__.Timestamp.decode(reader, reader.uint32()));
          break;

        case 6:
          message.p0LastSpotPrice = reader.string();
          break;

        case 7:
          message.p1LastSpotPrice = reader.string();
          break;

        case 8:
          message.p0ArithmeticTwapAccumulator = reader.string();
          break;

        case 9:
          message.p1ArithmeticTwapAccumulator = reader.string();
          break;

        case 10:
          message.geometricTwapAccumulator = reader.string();
          break;

        case 11:
          message.lastErrorTime = (0,_helpers__WEBPACK_IMPORTED_MODULE_1__/* .fromTimestamp */ .Ol)(_google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_0__.Timestamp.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$asset0Denom, _object$asset1Denom, _object$time, _object$p0LastSpotPri, _object$p1LastSpotPri, _object$p0ArithmeticT, _object$p1ArithmeticT, _object$geometricTwap, _object$lastErrorTime;

    const message = createBaseTwapRecord();
    message.poolId = object.poolId !== undefined && object.poolId !== null ? _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromValue */ .dK.fromValue(object.poolId) : _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.UZERO */ .dK.UZERO;
    message.asset0Denom = (_object$asset0Denom = object.asset0Denom) !== null && _object$asset0Denom !== void 0 ? _object$asset0Denom : "";
    message.asset1Denom = (_object$asset1Denom = object.asset1Denom) !== null && _object$asset1Denom !== void 0 ? _object$asset1Denom : "";
    message.height = object.height !== undefined && object.height !== null ? _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromValue */ .dK.fromValue(object.height) : _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.ZERO */ .dK.ZERO;
    message.time = (_object$time = object.time) !== null && _object$time !== void 0 ? _object$time : undefined;
    message.p0LastSpotPrice = (_object$p0LastSpotPri = object.p0LastSpotPrice) !== null && _object$p0LastSpotPri !== void 0 ? _object$p0LastSpotPri : "";
    message.p1LastSpotPrice = (_object$p1LastSpotPri = object.p1LastSpotPrice) !== null && _object$p1LastSpotPri !== void 0 ? _object$p1LastSpotPri : "";
    message.p0ArithmeticTwapAccumulator = (_object$p0ArithmeticT = object.p0ArithmeticTwapAccumulator) !== null && _object$p0ArithmeticT !== void 0 ? _object$p0ArithmeticT : "";
    message.p1ArithmeticTwapAccumulator = (_object$p1ArithmeticT = object.p1ArithmeticTwapAccumulator) !== null && _object$p1ArithmeticT !== void 0 ? _object$p1ArithmeticT : "";
    message.geometricTwapAccumulator = (_object$geometricTwap = object.geometricTwapAccumulator) !== null && _object$geometricTwap !== void 0 ? _object$geometricTwap : "";
    message.lastErrorTime = (_object$lastErrorTime = object.lastErrorTime) !== null && _object$lastErrorTime !== void 0 ? _object$lastErrorTime : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      poolId: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromString */ .dK.fromString(object.pool_id),
      asset0Denom: object.asset0_denom,
      asset1Denom: object.asset1_denom,
      height: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromString */ .dK.fromString(object.height),
      time: object !== null && object !== void 0 && object.time ? _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_0__.Timestamp.fromAmino(object.time) : undefined,
      p0LastSpotPrice: object.p0_last_spot_price,
      p1LastSpotPrice: object.p1_last_spot_price,
      p0ArithmeticTwapAccumulator: object.p0_arithmetic_twap_accumulator,
      p1ArithmeticTwapAccumulator: object.p1_arithmetic_twap_accumulator,
      geometricTwapAccumulator: object.geometric_twap_accumulator,
      lastErrorTime: object !== null && object !== void 0 && object.last_error_time ? _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_0__.Timestamp.fromAmino(object.last_error_time) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.pool_id = message.poolId ? message.poolId.toString() : undefined;
    obj.asset0_denom = message.asset0Denom;
    obj.asset1_denom = message.asset1Denom;
    obj.height = message.height ? message.height.toString() : undefined;
    obj.time = message.time ? _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_0__.Timestamp.toAmino(message.time) : undefined;
    obj.p0_last_spot_price = message.p0LastSpotPrice;
    obj.p1_last_spot_price = message.p1LastSpotPrice;
    obj.p0_arithmetic_twap_accumulator = message.p0ArithmeticTwapAccumulator;
    obj.p1_arithmetic_twap_accumulator = message.p1ArithmeticTwapAccumulator;
    obj.geometric_twap_accumulator = message.geometricTwapAccumulator;
    obj.last_error_time = message.lastErrorTime ? _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_0__.Timestamp.toAmino(message.lastErrorTime) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return TwapRecord.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/twap/twap-record",
      value: TwapRecord.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return TwapRecord.decode(message.value);
  },

  toProto(message) {
    return TwapRecord.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.twap.v1beta1.TwapRecord",
      value: TwapRecord.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 83509:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FeeToken": function() { return /* binding */ FeeToken; }
/* harmony export */ });
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47895);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__);


/**
 * FeeToken is a struct that specifies a coin denom, and pool ID pair.
 * This marks the token as eligible for use as a tx fee asset in Osmosis.
 * Its price in osmo is derived through looking at the provided pool ID.
 * The pool ID must have osmo as one of its assets.
 */

function createBaseFeeToken() {
  return {
    denom: "",
    poolID: _helpers__WEBPACK_IMPORTED_MODULE_0__/* .Long.UZERO */ .dK.UZERO
  };
}

const FeeToken = {
  typeUrl: "/osmosis.txfees.v1beta1.FeeToken",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Writer.create()) {
    if (message.denom !== "") {
      writer.uint32(10).string(message.denom);
    }

    if (!message.poolID.isZero()) {
      writer.uint32(16).uint64(message.poolID);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFeeToken();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.denom = reader.string();
          break;

        case 2:
          message.poolID = reader.uint64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$denom;

    const message = createBaseFeeToken();
    message.denom = (_object$denom = object.denom) !== null && _object$denom !== void 0 ? _object$denom : "";
    message.poolID = object.poolID !== undefined && object.poolID !== null ? _helpers__WEBPACK_IMPORTED_MODULE_0__/* .Long.fromValue */ .dK.fromValue(object.poolID) : _helpers__WEBPACK_IMPORTED_MODULE_0__/* .Long.UZERO */ .dK.UZERO;
    return message;
  },

  fromAmino(object) {
    return {
      denom: object.denom,
      poolID: _helpers__WEBPACK_IMPORTED_MODULE_0__/* .Long.fromString */ .dK.fromString(object.poolID)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.denom = message.denom;
    obj.poolID = message.poolID ? message.poolID.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return FeeToken.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/txfees/fee-token",
      value: FeeToken.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return FeeToken.decode(message.value);
  },

  toProto(message) {
    return FeeToken.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.txfees.v1beta1.FeeToken",
      value: FeeToken.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 43717:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QueryBaseDenomRequest": function() { return /* binding */ QueryBaseDenomRequest; },
/* harmony export */   "QueryBaseDenomResponse": function() { return /* binding */ QueryBaseDenomResponse; },
/* harmony export */   "QueryDenomPoolIdRequest": function() { return /* binding */ QueryDenomPoolIdRequest; },
/* harmony export */   "QueryDenomPoolIdResponse": function() { return /* binding */ QueryDenomPoolIdResponse; },
/* harmony export */   "QueryDenomSpotPriceRequest": function() { return /* binding */ QueryDenomSpotPriceRequest; },
/* harmony export */   "QueryDenomSpotPriceResponse": function() { return /* binding */ QueryDenomSpotPriceResponse; },
/* harmony export */   "QueryFeeTokensRequest": function() { return /* binding */ QueryFeeTokensRequest; },
/* harmony export */   "QueryFeeTokensResponse": function() { return /* binding */ QueryFeeTokensResponse; }
/* harmony export */ });
/* harmony import */ var _feetoken__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83509);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47895);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__);




function createBaseQueryFeeTokensRequest() {
  return {};
}

const QueryFeeTokensRequest = {
  typeUrl: "/osmosis.txfees.v1beta1.QueryFeeTokensRequest",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryFeeTokensRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseQueryFeeTokensRequest();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return QueryFeeTokensRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/txfees/query-fee-tokens-request",
      value: QueryFeeTokensRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryFeeTokensRequest.decode(message.value);
  },

  toProto(message) {
    return QueryFeeTokensRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.txfees.v1beta1.QueryFeeTokensRequest",
      value: QueryFeeTokensRequest.encode(message).finish()
    };
  }

};

function createBaseQueryFeeTokensResponse() {
  return {
    feeTokens: []
  };
}

const QueryFeeTokensResponse = {
  typeUrl: "/osmosis.txfees.v1beta1.QueryFeeTokensResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    for (const v of message.feeTokens) {
      _feetoken__WEBPACK_IMPORTED_MODULE_0__.FeeToken.encode(v, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryFeeTokensResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.feeTokens.push(_feetoken__WEBPACK_IMPORTED_MODULE_0__.FeeToken.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$feeTokens;

    const message = createBaseQueryFeeTokensResponse();
    message.feeTokens = ((_object$feeTokens = object.feeTokens) === null || _object$feeTokens === void 0 ? void 0 : _object$feeTokens.map(e => _feetoken__WEBPACK_IMPORTED_MODULE_0__.FeeToken.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      feeTokens: Array.isArray(object === null || object === void 0 ? void 0 : object.fee_tokens) ? object.fee_tokens.map(e => _feetoken__WEBPACK_IMPORTED_MODULE_0__.FeeToken.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.feeTokens) {
      obj.fee_tokens = message.feeTokens.map(e => e ? _feetoken__WEBPACK_IMPORTED_MODULE_0__.FeeToken.toAmino(e) : undefined);
    } else {
      obj.fee_tokens = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return QueryFeeTokensResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/txfees/query-fee-tokens-response",
      value: QueryFeeTokensResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryFeeTokensResponse.decode(message.value);
  },

  toProto(message) {
    return QueryFeeTokensResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.txfees.v1beta1.QueryFeeTokensResponse",
      value: QueryFeeTokensResponse.encode(message).finish()
    };
  }

};

function createBaseQueryDenomSpotPriceRequest() {
  return {
    denom: ""
  };
}

const QueryDenomSpotPriceRequest = {
  typeUrl: "/osmosis.txfees.v1beta1.QueryDenomSpotPriceRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (message.denom !== "") {
      writer.uint32(10).string(message.denom);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryDenomSpotPriceRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.denom = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$denom;

    const message = createBaseQueryDenomSpotPriceRequest();
    message.denom = (_object$denom = object.denom) !== null && _object$denom !== void 0 ? _object$denom : "";
    return message;
  },

  fromAmino(object) {
    return {
      denom: object.denom
    };
  },

  toAmino(message) {
    const obj = {};
    obj.denom = message.denom;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryDenomSpotPriceRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/txfees/query-denom-spot-price-request",
      value: QueryDenomSpotPriceRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryDenomSpotPriceRequest.decode(message.value);
  },

  toProto(message) {
    return QueryDenomSpotPriceRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.txfees.v1beta1.QueryDenomSpotPriceRequest",
      value: QueryDenomSpotPriceRequest.encode(message).finish()
    };
  }

};

function createBaseQueryDenomSpotPriceResponse() {
  return {
    poolID: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.UZERO */ .dK.UZERO,
    spotPrice: ""
  };
}

const QueryDenomSpotPriceResponse = {
  typeUrl: "/osmosis.txfees.v1beta1.QueryDenomSpotPriceResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (!message.poolID.isZero()) {
      writer.uint32(8).uint64(message.poolID);
    }

    if (message.spotPrice !== "") {
      writer.uint32(18).string(message.spotPrice);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryDenomSpotPriceResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.poolID = reader.uint64();
          break;

        case 2:
          message.spotPrice = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$spotPrice;

    const message = createBaseQueryDenomSpotPriceResponse();
    message.poolID = object.poolID !== undefined && object.poolID !== null ? _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromValue */ .dK.fromValue(object.poolID) : _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.UZERO */ .dK.UZERO;
    message.spotPrice = (_object$spotPrice = object.spotPrice) !== null && _object$spotPrice !== void 0 ? _object$spotPrice : "";
    return message;
  },

  fromAmino(object) {
    return {
      poolID: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromString */ .dK.fromString(object.poolID),
      spotPrice: object.spot_price
    };
  },

  toAmino(message) {
    const obj = {};
    obj.poolID = message.poolID ? message.poolID.toString() : undefined;
    obj.spot_price = message.spotPrice;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryDenomSpotPriceResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/txfees/query-denom-spot-price-response",
      value: QueryDenomSpotPriceResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryDenomSpotPriceResponse.decode(message.value);
  },

  toProto(message) {
    return QueryDenomSpotPriceResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.txfees.v1beta1.QueryDenomSpotPriceResponse",
      value: QueryDenomSpotPriceResponse.encode(message).finish()
    };
  }

};

function createBaseQueryDenomPoolIdRequest() {
  return {
    denom: ""
  };
}

const QueryDenomPoolIdRequest = {
  typeUrl: "/osmosis.txfees.v1beta1.QueryDenomPoolIdRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (message.denom !== "") {
      writer.uint32(10).string(message.denom);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryDenomPoolIdRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.denom = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$denom2;

    const message = createBaseQueryDenomPoolIdRequest();
    message.denom = (_object$denom2 = object.denom) !== null && _object$denom2 !== void 0 ? _object$denom2 : "";
    return message;
  },

  fromAmino(object) {
    return {
      denom: object.denom
    };
  },

  toAmino(message) {
    const obj = {};
    obj.denom = message.denom;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryDenomPoolIdRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/txfees/query-denom-pool-id-request",
      value: QueryDenomPoolIdRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryDenomPoolIdRequest.decode(message.value);
  },

  toProto(message) {
    return QueryDenomPoolIdRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.txfees.v1beta1.QueryDenomPoolIdRequest",
      value: QueryDenomPoolIdRequest.encode(message).finish()
    };
  }

};

function createBaseQueryDenomPoolIdResponse() {
  return {
    poolID: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.UZERO */ .dK.UZERO
  };
}

const QueryDenomPoolIdResponse = {
  typeUrl: "/osmosis.txfees.v1beta1.QueryDenomPoolIdResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (!message.poolID.isZero()) {
      writer.uint32(8).uint64(message.poolID);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryDenomPoolIdResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.poolID = reader.uint64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseQueryDenomPoolIdResponse();
    message.poolID = object.poolID !== undefined && object.poolID !== null ? _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromValue */ .dK.fromValue(object.poolID) : _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.UZERO */ .dK.UZERO;
    return message;
  },

  fromAmino(object) {
    return {
      poolID: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromString */ .dK.fromString(object.poolID)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.poolID = message.poolID ? message.poolID.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryDenomPoolIdResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/txfees/query-denom-pool-id-response",
      value: QueryDenomPoolIdResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryDenomPoolIdResponse.decode(message.value);
  },

  toProto(message) {
    return QueryDenomPoolIdResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.txfees.v1beta1.QueryDenomPoolIdResponse",
      value: QueryDenomPoolIdResponse.encode(message).finish()
    };
  }

};

function createBaseQueryBaseDenomRequest() {
  return {};
}

const QueryBaseDenomRequest = {
  typeUrl: "/osmosis.txfees.v1beta1.QueryBaseDenomRequest",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryBaseDenomRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseQueryBaseDenomRequest();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return QueryBaseDenomRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/txfees/query-base-denom-request",
      value: QueryBaseDenomRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryBaseDenomRequest.decode(message.value);
  },

  toProto(message) {
    return QueryBaseDenomRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.txfees.v1beta1.QueryBaseDenomRequest",
      value: QueryBaseDenomRequest.encode(message).finish()
    };
  }

};

function createBaseQueryBaseDenomResponse() {
  return {
    baseDenom: ""
  };
}

const QueryBaseDenomResponse = {
  typeUrl: "/osmosis.txfees.v1beta1.QueryBaseDenomResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (message.baseDenom !== "") {
      writer.uint32(10).string(message.baseDenom);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryBaseDenomResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.baseDenom = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$baseDenom;

    const message = createBaseQueryBaseDenomResponse();
    message.baseDenom = (_object$baseDenom = object.baseDenom) !== null && _object$baseDenom !== void 0 ? _object$baseDenom : "";
    return message;
  },

  fromAmino(object) {
    return {
      baseDenom: object.base_denom
    };
  },

  toAmino(message) {
    const obj = {};
    obj.base_denom = message.baseDenom;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryBaseDenomResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/txfees/query-base-denom-response",
      value: QueryBaseDenomResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryBaseDenomResponse.decode(message.value);
  },

  toProto(message) {
    return QueryBaseDenomResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.txfees.v1beta1.QueryBaseDenomResponse",
      value: QueryBaseDenomResponse.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 82419:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LCDQueryClient": function() { return /* binding */ LCDQueryClient; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4942);

class LCDQueryClient {
  constructor({
    requestClient
  }) {
    (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, "req", void 0);

    this.req = requestClient;
    this.feeTokens = this.feeTokens.bind(this);
    this.denomSpotPrice = this.denomSpotPrice.bind(this);
    this.denomPoolId = this.denomPoolId.bind(this);
    this.baseDenom = this.baseDenom.bind(this);
  }
  /* FeeTokens returns a list of all the whitelisted fee tokens and their
   corresponding pools. It does not include the BaseDenom, which has its own
   query endpoint */


  async feeTokens(_params = {}) {
    const endpoint = `osmosis/txfees/v1beta1/fee_tokens`;
    return await this.req.get(endpoint);
  }
  /* DenomSpotPrice returns all spot prices by each registered token denom. */


  async denomSpotPrice(params) {
    const options = {
      params: {}
    };

    if (typeof (params === null || params === void 0 ? void 0 : params.denom) !== "undefined") {
      options.params.denom = params.denom;
    }

    const endpoint = `osmosis/txfees/v1beta1/spot_price_by_denom`;
    return await this.req.get(endpoint, options);
  }
  /* Returns the poolID for a specified denom input. */


  async denomPoolId(params) {
    const endpoint = `osmosis/txfees/v1beta1/denom_pool_id/${params.denom}`;
    return await this.req.get(endpoint);
  }
  /* Returns a list of all base denom tokens and their corresponding pools. */


  async baseDenom(_params = {}) {
    const endpoint = `osmosis/txfees/v1beta1/base_denom`;
    return await this.req.get(endpoint);
  }

}

/***/ }),

/***/ 72241:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QueryClientImpl": function() { return /* binding */ QueryClientImpl; },
/* harmony export */   "createRpcQueryExtension": function() { return /* binding */ createRpcQueryExtension; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4942);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78441);
/* harmony import */ var _cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43717);




class QueryClientImpl {
  constructor(rpc) {
    (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, "rpc", void 0);

    this.rpc = rpc;
    this.feeTokens = this.feeTokens.bind(this);
    this.denomSpotPrice = this.denomSpotPrice.bind(this);
    this.denomPoolId = this.denomPoolId.bind(this);
    this.baseDenom = this.baseDenom.bind(this);
  }

  feeTokens(request = {}) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryFeeTokensRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.txfees.v1beta1.Query", "FeeTokens", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryFeeTokensResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  denomSpotPrice(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryDenomSpotPriceRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.txfees.v1beta1.Query", "DenomSpotPrice", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryDenomSpotPriceResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  denomPoolId(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryDenomPoolIdRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.txfees.v1beta1.Query", "DenomPoolId", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryDenomPoolIdResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  baseDenom(request = {}) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.QueryBaseDenomRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.txfees.v1beta1.Query", "BaseDenom", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.QueryBaseDenomResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

}
const createRpcQueryExtension = base => {
  const rpc = (0,_cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1__.createProtobufRpcClient)(base);
  const queryService = new QueryClientImpl(rpc);
  return {
    feeTokens(request) {
      return queryService.feeTokens(request);
    },

    denomSpotPrice(request) {
      return queryService.denomSpotPrice(request);
    },

    denomPoolId(request) {
      return queryService.denomPoolId(request);
    },

    baseDenom(request) {
      return queryService.baseDenom(request);
    }

  };
};

/***/ }),

/***/ 31835:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "UserValidatorPreferencesRequest": function() { return /* binding */ UserValidatorPreferencesRequest; },
/* harmony export */   "UserValidatorPreferencesResponse": function() { return /* binding */ UserValidatorPreferencesResponse; }
/* harmony export */ });
/* harmony import */ var _state__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59998);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__);


/** Request type for UserValidatorPreferences. */

function createBaseUserValidatorPreferencesRequest() {
  return {
    address: ""
  };
}

const UserValidatorPreferencesRequest = {
  typeUrl: "/osmosis.valsetpref.v1beta1.UserValidatorPreferencesRequest",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Writer.create()) {
    if (message.address !== "") {
      writer.uint32(10).string(message.address);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUserValidatorPreferencesRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.address = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$address;

    const message = createBaseUserValidatorPreferencesRequest();
    message.address = (_object$address = object.address) !== null && _object$address !== void 0 ? _object$address : "";
    return message;
  },

  fromAmino(object) {
    return {
      address: object.address
    };
  },

  toAmino(message) {
    const obj = {};
    obj.address = message.address;
    return obj;
  },

  fromAminoMsg(object) {
    return UserValidatorPreferencesRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/valsetpref/user-validator-preferences-request",
      value: UserValidatorPreferencesRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return UserValidatorPreferencesRequest.decode(message.value);
  },

  toProto(message) {
    return UserValidatorPreferencesRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.valsetpref.v1beta1.UserValidatorPreferencesRequest",
      value: UserValidatorPreferencesRequest.encode(message).finish()
    };
  }

};

function createBaseUserValidatorPreferencesResponse() {
  return {
    preferences: []
  };
}

const UserValidatorPreferencesResponse = {
  typeUrl: "/osmosis.valsetpref.v1beta1.UserValidatorPreferencesResponse",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Writer.create()) {
    for (const v of message.preferences) {
      _state__WEBPACK_IMPORTED_MODULE_0__.ValidatorPreference.encode(v, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUserValidatorPreferencesResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.preferences.push(_state__WEBPACK_IMPORTED_MODULE_0__.ValidatorPreference.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$preferences;

    const message = createBaseUserValidatorPreferencesResponse();
    message.preferences = ((_object$preferences = object.preferences) === null || _object$preferences === void 0 ? void 0 : _object$preferences.map(e => _state__WEBPACK_IMPORTED_MODULE_0__.ValidatorPreference.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      preferences: Array.isArray(object === null || object === void 0 ? void 0 : object.preferences) ? object.preferences.map(e => _state__WEBPACK_IMPORTED_MODULE_0__.ValidatorPreference.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.preferences) {
      obj.preferences = message.preferences.map(e => e ? _state__WEBPACK_IMPORTED_MODULE_0__.ValidatorPreference.toAmino(e) : undefined);
    } else {
      obj.preferences = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return UserValidatorPreferencesResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/valsetpref/user-validator-preferences-response",
      value: UserValidatorPreferencesResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return UserValidatorPreferencesResponse.decode(message.value);
  },

  toProto(message) {
    return UserValidatorPreferencesResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.valsetpref.v1beta1.UserValidatorPreferencesResponse",
      value: UserValidatorPreferencesResponse.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 62188:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LCDQueryClient": function() { return /* binding */ LCDQueryClient; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4942);

class LCDQueryClient {
  constructor({
    requestClient
  }) {
    (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, "req", void 0);

    this.req = requestClient;
    this.userValidatorPreferences = this.userValidatorPreferences.bind(this);
  }
  /* Returns the list of ValidatorPreferences for the user. */


  async userValidatorPreferences(params) {
    const endpoint = `osmosis/valset-pref/v1beta1/${params.address}`;
    return await this.req.get(endpoint);
  }

}

/***/ }),

/***/ 10926:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QueryClientImpl": function() { return /* binding */ QueryClientImpl; },
/* harmony export */   "createRpcQueryExtension": function() { return /* binding */ createRpcQueryExtension; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4942);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78441);
/* harmony import */ var _cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31835);




/** Query defines the gRPC querier service. */

class QueryClientImpl {
  constructor(rpc) {
    (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, "rpc", void 0);

    this.rpc = rpc;
    this.userValidatorPreferences = this.userValidatorPreferences.bind(this);
  }

  userValidatorPreferences(request) {
    const data = _query__WEBPACK_IMPORTED_MODULE_2__.UserValidatorPreferencesRequest.encode(request).finish();
    const promise = this.rpc.request("osmosis.valsetpref.v1beta1.Query", "UserValidatorPreferences", data);
    return promise.then(data => _query__WEBPACK_IMPORTED_MODULE_2__.UserValidatorPreferencesResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

}
const createRpcQueryExtension = base => {
  const rpc = (0,_cosmjs_stargate__WEBPACK_IMPORTED_MODULE_1__.createProtobufRpcClient)(base);
  const queryService = new QueryClientImpl(rpc);
  return {
    userValidatorPreferences(request) {
      return queryService.userValidatorPreferences(request);
    }

  };
};

/***/ }),

/***/ 59998:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ValidatorPreference": function() { return /* binding */ ValidatorPreference; },
/* harmony export */   "ValidatorSetPreferences": function() { return /* binding */ ValidatorSetPreferences; }
/* harmony export */ });
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__);

/**
 * ValidatorPreference defines the message structure for
 * CreateValidatorSetPreference. It allows a user to set {val_addr, weight} in
 * state. If a user does not have a validator set preference list set, and has
 * staked, make their preference list default to their current staking
 * distribution.
 */

function createBaseValidatorPreference() {
  return {
    valOperAddress: "",
    weight: ""
  };
}

const ValidatorPreference = {
  typeUrl: "/osmosis.valsetpref.v1beta1.ValidatorPreference",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Writer.create()) {
    if (message.valOperAddress !== "") {
      writer.uint32(10).string(message.valOperAddress);
    }

    if (message.weight !== "") {
      writer.uint32(18).string(message.weight);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseValidatorPreference();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.valOperAddress = reader.string();
          break;

        case 2:
          message.weight = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$valOperAddres, _object$weight;

    const message = createBaseValidatorPreference();
    message.valOperAddress = (_object$valOperAddres = object.valOperAddress) !== null && _object$valOperAddres !== void 0 ? _object$valOperAddres : "";
    message.weight = (_object$weight = object.weight) !== null && _object$weight !== void 0 ? _object$weight : "";
    return message;
  },

  fromAmino(object) {
    return {
      valOperAddress: object.val_oper_address,
      weight: object.weight
    };
  },

  toAmino(message) {
    const obj = {};
    obj.val_oper_address = message.valOperAddress;
    obj.weight = message.weight;
    return obj;
  },

  fromAminoMsg(object) {
    return ValidatorPreference.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/valsetpref/validator-preference",
      value: ValidatorPreference.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return ValidatorPreference.decode(message.value);
  },

  toProto(message) {
    return ValidatorPreference.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.valsetpref.v1beta1.ValidatorPreference",
      value: ValidatorPreference.encode(message).finish()
    };
  }

};

function createBaseValidatorSetPreferences() {
  return {
    preferences: []
  };
}

const ValidatorSetPreferences = {
  typeUrl: "/osmosis.valsetpref.v1beta1.ValidatorSetPreferences",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Writer.create()) {
    for (const v of message.preferences) {
      ValidatorPreference.encode(v, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseValidatorSetPreferences();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 2:
          message.preferences.push(ValidatorPreference.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$preferences;

    const message = createBaseValidatorSetPreferences();
    message.preferences = ((_object$preferences = object.preferences) === null || _object$preferences === void 0 ? void 0 : _object$preferences.map(e => ValidatorPreference.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      preferences: Array.isArray(object === null || object === void 0 ? void 0 : object.preferences) ? object.preferences.map(e => ValidatorPreference.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.preferences) {
      obj.preferences = message.preferences.map(e => e ? ValidatorPreference.toAmino(e) : undefined);
    } else {
      obj.preferences = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return ValidatorSetPreferences.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/valsetpref/validator-set-preferences",
      value: ValidatorSetPreferences.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return ValidatorSetPreferences.decode(message.value);
  },

  toProto(message) {
    return ValidatorSetPreferences.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.valsetpref.v1beta1.ValidatorSetPreferences",
      value: ValidatorSetPreferences.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 98866:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MsgDelegateBondedTokens": function() { return /* binding */ MsgDelegateBondedTokens; },
/* harmony export */   "MsgDelegateBondedTokensResponse": function() { return /* binding */ MsgDelegateBondedTokensResponse; },
/* harmony export */   "MsgDelegateToValidatorSet": function() { return /* binding */ MsgDelegateToValidatorSet; },
/* harmony export */   "MsgDelegateToValidatorSetResponse": function() { return /* binding */ MsgDelegateToValidatorSetResponse; },
/* harmony export */   "MsgRedelegateValidatorSet": function() { return /* binding */ MsgRedelegateValidatorSet; },
/* harmony export */   "MsgRedelegateValidatorSetResponse": function() { return /* binding */ MsgRedelegateValidatorSetResponse; },
/* harmony export */   "MsgSetValidatorSetPreference": function() { return /* binding */ MsgSetValidatorSetPreference; },
/* harmony export */   "MsgSetValidatorSetPreferenceResponse": function() { return /* binding */ MsgSetValidatorSetPreferenceResponse; },
/* harmony export */   "MsgUndelegateFromValidatorSet": function() { return /* binding */ MsgUndelegateFromValidatorSet; },
/* harmony export */   "MsgUndelegateFromValidatorSetResponse": function() { return /* binding */ MsgUndelegateFromValidatorSetResponse; },
/* harmony export */   "MsgWithdrawDelegationRewards": function() { return /* binding */ MsgWithdrawDelegationRewards; },
/* harmony export */   "MsgWithdrawDelegationRewardsResponse": function() { return /* binding */ MsgWithdrawDelegationRewardsResponse; }
/* harmony export */ });
/* harmony import */ var _state__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59998);
/* harmony import */ var _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26178);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47895);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__);




/** MsgCreateValidatorSetPreference is a list that holds validator-set. */

function createBaseMsgSetValidatorSetPreference() {
  return {
    delegator: "",
    preferences: []
  };
}

const MsgSetValidatorSetPreference = {
  typeUrl: "/osmosis.valsetpref.v1beta1.MsgSetValidatorSetPreference",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.delegator !== "") {
      writer.uint32(10).string(message.delegator);
    }

    for (const v of message.preferences) {
      _state__WEBPACK_IMPORTED_MODULE_0__.ValidatorPreference.encode(v, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgSetValidatorSetPreference();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.delegator = reader.string();
          break;

        case 2:
          message.preferences.push(_state__WEBPACK_IMPORTED_MODULE_0__.ValidatorPreference.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$delegator, _object$preferences;

    const message = createBaseMsgSetValidatorSetPreference();
    message.delegator = (_object$delegator = object.delegator) !== null && _object$delegator !== void 0 ? _object$delegator : "";
    message.preferences = ((_object$preferences = object.preferences) === null || _object$preferences === void 0 ? void 0 : _object$preferences.map(e => _state__WEBPACK_IMPORTED_MODULE_0__.ValidatorPreference.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      delegator: object.delegator,
      preferences: Array.isArray(object === null || object === void 0 ? void 0 : object.preferences) ? object.preferences.map(e => _state__WEBPACK_IMPORTED_MODULE_0__.ValidatorPreference.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.delegator = message.delegator;

    if (message.preferences) {
      obj.preferences = message.preferences.map(e => e ? _state__WEBPACK_IMPORTED_MODULE_0__.ValidatorPreference.toAmino(e) : undefined);
    } else {
      obj.preferences = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return MsgSetValidatorSetPreference.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/valset-pref/MsgSetValidatorSetPreference",
      value: MsgSetValidatorSetPreference.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgSetValidatorSetPreference.decode(message.value);
  },

  toProto(message) {
    return MsgSetValidatorSetPreference.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.valsetpref.v1beta1.MsgSetValidatorSetPreference",
      value: MsgSetValidatorSetPreference.encode(message).finish()
    };
  }

};

function createBaseMsgSetValidatorSetPreferenceResponse() {
  return {};
}

const MsgSetValidatorSetPreferenceResponse = {
  typeUrl: "/osmosis.valsetpref.v1beta1.MsgSetValidatorSetPreferenceResponse",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgSetValidatorSetPreferenceResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseMsgSetValidatorSetPreferenceResponse();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return MsgSetValidatorSetPreferenceResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/valsetpref/set-validator-set-preference-response",
      value: MsgSetValidatorSetPreferenceResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgSetValidatorSetPreferenceResponse.decode(message.value);
  },

  toProto(message) {
    return MsgSetValidatorSetPreferenceResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.valsetpref.v1beta1.MsgSetValidatorSetPreferenceResponse",
      value: MsgSetValidatorSetPreferenceResponse.encode(message).finish()
    };
  }

};

function createBaseMsgDelegateToValidatorSet() {
  return {
    delegator: "",
    coin: undefined
  };
}

const MsgDelegateToValidatorSet = {
  typeUrl: "/osmosis.valsetpref.v1beta1.MsgDelegateToValidatorSet",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.delegator !== "") {
      writer.uint32(10).string(message.delegator);
    }

    if (message.coin !== undefined) {
      _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.encode(message.coin, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgDelegateToValidatorSet();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.delegator = reader.string();
          break;

        case 2:
          message.coin = _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$delegator2;

    const message = createBaseMsgDelegateToValidatorSet();
    message.delegator = (_object$delegator2 = object.delegator) !== null && _object$delegator2 !== void 0 ? _object$delegator2 : "";
    message.coin = object.coin !== undefined && object.coin !== null ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.fromPartial(object.coin) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      delegator: object.delegator,
      coin: object !== null && object !== void 0 && object.coin ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.fromAmino(object.coin) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.delegator = message.delegator;
    obj.coin = message.coin ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.toAmino(message.coin) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgDelegateToValidatorSet.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/valset-pref/MsgDelegateToValidatorSet",
      value: MsgDelegateToValidatorSet.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgDelegateToValidatorSet.decode(message.value);
  },

  toProto(message) {
    return MsgDelegateToValidatorSet.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.valsetpref.v1beta1.MsgDelegateToValidatorSet",
      value: MsgDelegateToValidatorSet.encode(message).finish()
    };
  }

};

function createBaseMsgDelegateToValidatorSetResponse() {
  return {};
}

const MsgDelegateToValidatorSetResponse = {
  typeUrl: "/osmosis.valsetpref.v1beta1.MsgDelegateToValidatorSetResponse",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgDelegateToValidatorSetResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseMsgDelegateToValidatorSetResponse();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return MsgDelegateToValidatorSetResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/valsetpref/delegate-to-validator-set-response",
      value: MsgDelegateToValidatorSetResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgDelegateToValidatorSetResponse.decode(message.value);
  },

  toProto(message) {
    return MsgDelegateToValidatorSetResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.valsetpref.v1beta1.MsgDelegateToValidatorSetResponse",
      value: MsgDelegateToValidatorSetResponse.encode(message).finish()
    };
  }

};

function createBaseMsgUndelegateFromValidatorSet() {
  return {
    delegator: "",
    coin: undefined
  };
}

const MsgUndelegateFromValidatorSet = {
  typeUrl: "/osmosis.valsetpref.v1beta1.MsgUndelegateFromValidatorSet",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.delegator !== "") {
      writer.uint32(10).string(message.delegator);
    }

    if (message.coin !== undefined) {
      _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.encode(message.coin, writer.uint32(26).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgUndelegateFromValidatorSet();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.delegator = reader.string();
          break;

        case 3:
          message.coin = _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$delegator3;

    const message = createBaseMsgUndelegateFromValidatorSet();
    message.delegator = (_object$delegator3 = object.delegator) !== null && _object$delegator3 !== void 0 ? _object$delegator3 : "";
    message.coin = object.coin !== undefined && object.coin !== null ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.fromPartial(object.coin) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      delegator: object.delegator,
      coin: object !== null && object !== void 0 && object.coin ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.fromAmino(object.coin) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.delegator = message.delegator;
    obj.coin = message.coin ? _cosmos_base_v1beta1_coin__WEBPACK_IMPORTED_MODULE_1__.Coin.toAmino(message.coin) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgUndelegateFromValidatorSet.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/valset-pref/MsgUndelegateFromValidatorSet",
      value: MsgUndelegateFromValidatorSet.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgUndelegateFromValidatorSet.decode(message.value);
  },

  toProto(message) {
    return MsgUndelegateFromValidatorSet.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.valsetpref.v1beta1.MsgUndelegateFromValidatorSet",
      value: MsgUndelegateFromValidatorSet.encode(message).finish()
    };
  }

};

function createBaseMsgUndelegateFromValidatorSetResponse() {
  return {};
}

const MsgUndelegateFromValidatorSetResponse = {
  typeUrl: "/osmosis.valsetpref.v1beta1.MsgUndelegateFromValidatorSetResponse",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgUndelegateFromValidatorSetResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseMsgUndelegateFromValidatorSetResponse();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return MsgUndelegateFromValidatorSetResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/valsetpref/undelegate-from-validator-set-response",
      value: MsgUndelegateFromValidatorSetResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgUndelegateFromValidatorSetResponse.decode(message.value);
  },

  toProto(message) {
    return MsgUndelegateFromValidatorSetResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.valsetpref.v1beta1.MsgUndelegateFromValidatorSetResponse",
      value: MsgUndelegateFromValidatorSetResponse.encode(message).finish()
    };
  }

};

function createBaseMsgRedelegateValidatorSet() {
  return {
    delegator: "",
    preferences: []
  };
}

const MsgRedelegateValidatorSet = {
  typeUrl: "/osmosis.valsetpref.v1beta1.MsgRedelegateValidatorSet",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.delegator !== "") {
      writer.uint32(10).string(message.delegator);
    }

    for (const v of message.preferences) {
      _state__WEBPACK_IMPORTED_MODULE_0__.ValidatorPreference.encode(v, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgRedelegateValidatorSet();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.delegator = reader.string();
          break;

        case 2:
          message.preferences.push(_state__WEBPACK_IMPORTED_MODULE_0__.ValidatorPreference.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$delegator4, _object$preferences2;

    const message = createBaseMsgRedelegateValidatorSet();
    message.delegator = (_object$delegator4 = object.delegator) !== null && _object$delegator4 !== void 0 ? _object$delegator4 : "";
    message.preferences = ((_object$preferences2 = object.preferences) === null || _object$preferences2 === void 0 ? void 0 : _object$preferences2.map(e => _state__WEBPACK_IMPORTED_MODULE_0__.ValidatorPreference.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      delegator: object.delegator,
      preferences: Array.isArray(object === null || object === void 0 ? void 0 : object.preferences) ? object.preferences.map(e => _state__WEBPACK_IMPORTED_MODULE_0__.ValidatorPreference.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.delegator = message.delegator;

    if (message.preferences) {
      obj.preferences = message.preferences.map(e => e ? _state__WEBPACK_IMPORTED_MODULE_0__.ValidatorPreference.toAmino(e) : undefined);
    } else {
      obj.preferences = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return MsgRedelegateValidatorSet.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/valsetpref/redelegate-validator-set",
      value: MsgRedelegateValidatorSet.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgRedelegateValidatorSet.decode(message.value);
  },

  toProto(message) {
    return MsgRedelegateValidatorSet.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.valsetpref.v1beta1.MsgRedelegateValidatorSet",
      value: MsgRedelegateValidatorSet.encode(message).finish()
    };
  }

};

function createBaseMsgRedelegateValidatorSetResponse() {
  return {};
}

const MsgRedelegateValidatorSetResponse = {
  typeUrl: "/osmosis.valsetpref.v1beta1.MsgRedelegateValidatorSetResponse",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgRedelegateValidatorSetResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseMsgRedelegateValidatorSetResponse();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return MsgRedelegateValidatorSetResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/valsetpref/redelegate-validator-set-response",
      value: MsgRedelegateValidatorSetResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgRedelegateValidatorSetResponse.decode(message.value);
  },

  toProto(message) {
    return MsgRedelegateValidatorSetResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.valsetpref.v1beta1.MsgRedelegateValidatorSetResponse",
      value: MsgRedelegateValidatorSetResponse.encode(message).finish()
    };
  }

};

function createBaseMsgWithdrawDelegationRewards() {
  return {
    delegator: ""
  };
}

const MsgWithdrawDelegationRewards = {
  typeUrl: "/osmosis.valsetpref.v1beta1.MsgWithdrawDelegationRewards",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.delegator !== "") {
      writer.uint32(10).string(message.delegator);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgWithdrawDelegationRewards();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.delegator = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$delegator5;

    const message = createBaseMsgWithdrawDelegationRewards();
    message.delegator = (_object$delegator5 = object.delegator) !== null && _object$delegator5 !== void 0 ? _object$delegator5 : "";
    return message;
  },

  fromAmino(object) {
    return {
      delegator: object.delegator
    };
  },

  toAmino(message) {
    const obj = {};
    obj.delegator = message.delegator;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgWithdrawDelegationRewards.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/valset-pref/MsgWithdrawDelegationRewards",
      value: MsgWithdrawDelegationRewards.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgWithdrawDelegationRewards.decode(message.value);
  },

  toProto(message) {
    return MsgWithdrawDelegationRewards.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.valsetpref.v1beta1.MsgWithdrawDelegationRewards",
      value: MsgWithdrawDelegationRewards.encode(message).finish()
    };
  }

};

function createBaseMsgWithdrawDelegationRewardsResponse() {
  return {};
}

const MsgWithdrawDelegationRewardsResponse = {
  typeUrl: "/osmosis.valsetpref.v1beta1.MsgWithdrawDelegationRewardsResponse",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgWithdrawDelegationRewardsResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseMsgWithdrawDelegationRewardsResponse();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return MsgWithdrawDelegationRewardsResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/valsetpref/withdraw-delegation-rewards-response",
      value: MsgWithdrawDelegationRewardsResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgWithdrawDelegationRewardsResponse.decode(message.value);
  },

  toProto(message) {
    return MsgWithdrawDelegationRewardsResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.valsetpref.v1beta1.MsgWithdrawDelegationRewardsResponse",
      value: MsgWithdrawDelegationRewardsResponse.encode(message).finish()
    };
  }

};

function createBaseMsgDelegateBondedTokens() {
  return {
    delegator: "",
    lockID: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO
  };
}

const MsgDelegateBondedTokens = {
  typeUrl: "/osmosis.valsetpref.v1beta1.MsgDelegateBondedTokens",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    if (message.delegator !== "") {
      writer.uint32(10).string(message.delegator);
    }

    if (!message.lockID.isZero()) {
      writer.uint32(16).uint64(message.lockID);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgDelegateBondedTokens();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.delegator = reader.string();
          break;

        case 2:
          message.lockID = reader.uint64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$delegator6;

    const message = createBaseMsgDelegateBondedTokens();
    message.delegator = (_object$delegator6 = object.delegator) !== null && _object$delegator6 !== void 0 ? _object$delegator6 : "";
    message.lockID = object.lockID !== undefined && object.lockID !== null ? _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromValue */ .dK.fromValue(object.lockID) : _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.UZERO */ .dK.UZERO;
    return message;
  },

  fromAmino(object) {
    return {
      delegator: object.delegator,
      lockID: _helpers__WEBPACK_IMPORTED_MODULE_2__/* .Long.fromString */ .dK.fromString(object.lockID)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.delegator = message.delegator;
    obj.lockID = message.lockID ? message.lockID.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgDelegateBondedTokens.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/valsetpref/delegate-bonded-tokens",
      value: MsgDelegateBondedTokens.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgDelegateBondedTokens.decode(message.value);
  },

  toProto(message) {
    return MsgDelegateBondedTokens.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.valsetpref.v1beta1.MsgDelegateBondedTokens",
      value: MsgDelegateBondedTokens.encode(message).finish()
    };
  }

};

function createBaseMsgDelegateBondedTokensResponse() {
  return {};
}

const MsgDelegateBondedTokensResponse = {
  typeUrl: "/osmosis.valsetpref.v1beta1.MsgDelegateBondedTokensResponse",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_3__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgDelegateBondedTokensResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseMsgDelegateBondedTokensResponse();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return MsgDelegateBondedTokensResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/valsetpref/delegate-bonded-tokens-response",
      value: MsgDelegateBondedTokensResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgDelegateBondedTokensResponse.decode(message.value);
  },

  toProto(message) {
    return MsgDelegateBondedTokensResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.valsetpref.v1beta1.MsgDelegateBondedTokensResponse",
      value: MsgDelegateBondedTokensResponse.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 48718:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MsgClientImpl": function() { return /* binding */ MsgClientImpl; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4942);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _tx__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98866);



/** Msg defines the valset-pref modules's gRPC message service. */

class MsgClientImpl {
  constructor(rpc) {
    (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, "rpc", void 0);

    this.rpc = rpc;
    this.setValidatorSetPreference = this.setValidatorSetPreference.bind(this);
    this.delegateToValidatorSet = this.delegateToValidatorSet.bind(this);
    this.undelegateFromValidatorSet = this.undelegateFromValidatorSet.bind(this);
    this.redelegateValidatorSet = this.redelegateValidatorSet.bind(this);
    this.withdrawDelegationRewards = this.withdrawDelegationRewards.bind(this);
    this.delegateBondedTokens = this.delegateBondedTokens.bind(this);
  }

  setValidatorSetPreference(request) {
    const data = _tx__WEBPACK_IMPORTED_MODULE_1__.MsgSetValidatorSetPreference.encode(request).finish();
    const promise = this.rpc.request("osmosis.valsetpref.v1beta1.Msg", "SetValidatorSetPreference", data);
    return promise.then(data => _tx__WEBPACK_IMPORTED_MODULE_1__.MsgSetValidatorSetPreferenceResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  delegateToValidatorSet(request) {
    const data = _tx__WEBPACK_IMPORTED_MODULE_1__.MsgDelegateToValidatorSet.encode(request).finish();
    const promise = this.rpc.request("osmosis.valsetpref.v1beta1.Msg", "DelegateToValidatorSet", data);
    return promise.then(data => _tx__WEBPACK_IMPORTED_MODULE_1__.MsgDelegateToValidatorSetResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  undelegateFromValidatorSet(request) {
    const data = _tx__WEBPACK_IMPORTED_MODULE_1__.MsgUndelegateFromValidatorSet.encode(request).finish();
    const promise = this.rpc.request("osmosis.valsetpref.v1beta1.Msg", "UndelegateFromValidatorSet", data);
    return promise.then(data => _tx__WEBPACK_IMPORTED_MODULE_1__.MsgUndelegateFromValidatorSetResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  redelegateValidatorSet(request) {
    const data = _tx__WEBPACK_IMPORTED_MODULE_1__.MsgRedelegateValidatorSet.encode(request).finish();
    const promise = this.rpc.request("osmosis.valsetpref.v1beta1.Msg", "RedelegateValidatorSet", data);
    return promise.then(data => _tx__WEBPACK_IMPORTED_MODULE_1__.MsgRedelegateValidatorSetResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  withdrawDelegationRewards(request) {
    const data = _tx__WEBPACK_IMPORTED_MODULE_1__.MsgWithdrawDelegationRewards.encode(request).finish();
    const promise = this.rpc.request("osmosis.valsetpref.v1beta1.Msg", "WithdrawDelegationRewards", data);
    return promise.then(data => _tx__WEBPACK_IMPORTED_MODULE_1__.MsgWithdrawDelegationRewardsResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

  delegateBondedTokens(request) {
    const data = _tx__WEBPACK_IMPORTED_MODULE_1__.MsgDelegateBondedTokens.encode(request).finish();
    const promise = this.rpc.request("osmosis.valsetpref.v1beta1.Msg", "DelegateBondedTokens", data);
    return promise.then(data => _tx__WEBPACK_IMPORTED_MODULE_1__.MsgDelegateBondedTokensResponse.decode(new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(data)));
  }

}

/***/ }),

/***/ 10670:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CheckTxType": function() { return /* binding */ CheckTxType; },
/* harmony export */   "CheckTxTypeAmino": function() { return /* binding */ CheckTxTypeAmino; },
/* harmony export */   "CheckTxTypeSDKType": function() { return /* binding */ CheckTxTypeSDKType; },
/* harmony export */   "CommitInfo": function() { return /* binding */ CommitInfo; },
/* harmony export */   "Event": function() { return /* binding */ Event; },
/* harmony export */   "EventAttribute": function() { return /* binding */ EventAttribute; },
/* harmony export */   "ExtendedCommitInfo": function() { return /* binding */ ExtendedCommitInfo; },
/* harmony export */   "ExtendedVoteInfo": function() { return /* binding */ ExtendedVoteInfo; },
/* harmony export */   "Misbehavior": function() { return /* binding */ Misbehavior; },
/* harmony export */   "MisbehaviorType": function() { return /* binding */ MisbehaviorType; },
/* harmony export */   "MisbehaviorTypeAmino": function() { return /* binding */ MisbehaviorTypeAmino; },
/* harmony export */   "MisbehaviorTypeSDKType": function() { return /* binding */ MisbehaviorTypeSDKType; },
/* harmony export */   "Request": function() { return /* binding */ Request; },
/* harmony export */   "RequestApplySnapshotChunk": function() { return /* binding */ RequestApplySnapshotChunk; },
/* harmony export */   "RequestBeginBlock": function() { return /* binding */ RequestBeginBlock; },
/* harmony export */   "RequestCheckTx": function() { return /* binding */ RequestCheckTx; },
/* harmony export */   "RequestCommit": function() { return /* binding */ RequestCommit; },
/* harmony export */   "RequestDeliverTx": function() { return /* binding */ RequestDeliverTx; },
/* harmony export */   "RequestEcho": function() { return /* binding */ RequestEcho; },
/* harmony export */   "RequestEndBlock": function() { return /* binding */ RequestEndBlock; },
/* harmony export */   "RequestFlush": function() { return /* binding */ RequestFlush; },
/* harmony export */   "RequestInfo": function() { return /* binding */ RequestInfo; },
/* harmony export */   "RequestInitChain": function() { return /* binding */ RequestInitChain; },
/* harmony export */   "RequestListSnapshots": function() { return /* binding */ RequestListSnapshots; },
/* harmony export */   "RequestLoadSnapshotChunk": function() { return /* binding */ RequestLoadSnapshotChunk; },
/* harmony export */   "RequestOfferSnapshot": function() { return /* binding */ RequestOfferSnapshot; },
/* harmony export */   "RequestPrepareProposal": function() { return /* binding */ RequestPrepareProposal; },
/* harmony export */   "RequestProcessProposal": function() { return /* binding */ RequestProcessProposal; },
/* harmony export */   "RequestQuery": function() { return /* binding */ RequestQuery; },
/* harmony export */   "Response": function() { return /* binding */ Response; },
/* harmony export */   "ResponseApplySnapshotChunk": function() { return /* binding */ ResponseApplySnapshotChunk; },
/* harmony export */   "ResponseApplySnapshotChunk_Result": function() { return /* binding */ ResponseApplySnapshotChunk_Result; },
/* harmony export */   "ResponseApplySnapshotChunk_ResultAmino": function() { return /* binding */ ResponseApplySnapshotChunk_ResultAmino; },
/* harmony export */   "ResponseApplySnapshotChunk_ResultSDKType": function() { return /* binding */ ResponseApplySnapshotChunk_ResultSDKType; },
/* harmony export */   "ResponseBeginBlock": function() { return /* binding */ ResponseBeginBlock; },
/* harmony export */   "ResponseCheckTx": function() { return /* binding */ ResponseCheckTx; },
/* harmony export */   "ResponseCommit": function() { return /* binding */ ResponseCommit; },
/* harmony export */   "ResponseDeliverTx": function() { return /* binding */ ResponseDeliverTx; },
/* harmony export */   "ResponseEcho": function() { return /* binding */ ResponseEcho; },
/* harmony export */   "ResponseEndBlock": function() { return /* binding */ ResponseEndBlock; },
/* harmony export */   "ResponseException": function() { return /* binding */ ResponseException; },
/* harmony export */   "ResponseFlush": function() { return /* binding */ ResponseFlush; },
/* harmony export */   "ResponseInfo": function() { return /* binding */ ResponseInfo; },
/* harmony export */   "ResponseInitChain": function() { return /* binding */ ResponseInitChain; },
/* harmony export */   "ResponseListSnapshots": function() { return /* binding */ ResponseListSnapshots; },
/* harmony export */   "ResponseLoadSnapshotChunk": function() { return /* binding */ ResponseLoadSnapshotChunk; },
/* harmony export */   "ResponseOfferSnapshot": function() { return /* binding */ ResponseOfferSnapshot; },
/* harmony export */   "ResponseOfferSnapshot_Result": function() { return /* binding */ ResponseOfferSnapshot_Result; },
/* harmony export */   "ResponseOfferSnapshot_ResultAmino": function() { return /* binding */ ResponseOfferSnapshot_ResultAmino; },
/* harmony export */   "ResponseOfferSnapshot_ResultSDKType": function() { return /* binding */ ResponseOfferSnapshot_ResultSDKType; },
/* harmony export */   "ResponsePrepareProposal": function() { return /* binding */ ResponsePrepareProposal; },
/* harmony export */   "ResponseProcessProposal": function() { return /* binding */ ResponseProcessProposal; },
/* harmony export */   "ResponseProcessProposal_ProposalStatus": function() { return /* binding */ ResponseProcessProposal_ProposalStatus; },
/* harmony export */   "ResponseProcessProposal_ProposalStatusAmino": function() { return /* binding */ ResponseProcessProposal_ProposalStatusAmino; },
/* harmony export */   "ResponseProcessProposal_ProposalStatusSDKType": function() { return /* binding */ ResponseProcessProposal_ProposalStatusSDKType; },
/* harmony export */   "ResponseQuery": function() { return /* binding */ ResponseQuery; },
/* harmony export */   "Snapshot": function() { return /* binding */ Snapshot; },
/* harmony export */   "TxResult": function() { return /* binding */ TxResult; },
/* harmony export */   "Validator": function() { return /* binding */ Validator; },
/* harmony export */   "ValidatorUpdate": function() { return /* binding */ ValidatorUpdate; },
/* harmony export */   "VoteInfo": function() { return /* binding */ VoteInfo; },
/* harmony export */   "checkTxTypeFromJSON": function() { return /* binding */ checkTxTypeFromJSON; },
/* harmony export */   "checkTxTypeToJSON": function() { return /* binding */ checkTxTypeToJSON; },
/* harmony export */   "misbehaviorTypeFromJSON": function() { return /* binding */ misbehaviorTypeFromJSON; },
/* harmony export */   "misbehaviorTypeToJSON": function() { return /* binding */ misbehaviorTypeToJSON; },
/* harmony export */   "responseApplySnapshotChunk_ResultFromJSON": function() { return /* binding */ responseApplySnapshotChunk_ResultFromJSON; },
/* harmony export */   "responseApplySnapshotChunk_ResultToJSON": function() { return /* binding */ responseApplySnapshotChunk_ResultToJSON; },
/* harmony export */   "responseOfferSnapshot_ResultFromJSON": function() { return /* binding */ responseOfferSnapshot_ResultFromJSON; },
/* harmony export */   "responseOfferSnapshot_ResultToJSON": function() { return /* binding */ responseOfferSnapshot_ResultToJSON; },
/* harmony export */   "responseProcessProposal_ProposalStatusFromJSON": function() { return /* binding */ responseProcessProposal_ProposalStatusFromJSON; },
/* harmony export */   "responseProcessProposal_ProposalStatusToJSON": function() { return /* binding */ responseProcessProposal_ProposalStatusToJSON; }
/* harmony export */ });
/* harmony import */ var _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20633);
/* harmony import */ var _types_params__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39490);
/* harmony import */ var _types_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87572);
/* harmony import */ var _crypto_proof__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47374);
/* harmony import */ var _crypto_keys__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(79246);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47895);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__);







let CheckTxType;

(function (CheckTxType) {
  CheckTxType[CheckTxType["NEW"] = 0] = "NEW";
  CheckTxType[CheckTxType["RECHECK"] = 1] = "RECHECK";
  CheckTxType[CheckTxType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(CheckTxType || (CheckTxType = {}));

const CheckTxTypeSDKType = CheckTxType;
const CheckTxTypeAmino = CheckTxType;
function checkTxTypeFromJSON(object) {
  switch (object) {
    case 0:
    case "NEW":
      return CheckTxType.NEW;

    case 1:
    case "RECHECK":
      return CheckTxType.RECHECK;

    case -1:
    case "UNRECOGNIZED":
    default:
      return CheckTxType.UNRECOGNIZED;
  }
}
function checkTxTypeToJSON(object) {
  switch (object) {
    case CheckTxType.NEW:
      return "NEW";

    case CheckTxType.RECHECK:
      return "RECHECK";

    case CheckTxType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
let ResponseOfferSnapshot_Result;

(function (ResponseOfferSnapshot_Result) {
  ResponseOfferSnapshot_Result[ResponseOfferSnapshot_Result["UNKNOWN"] = 0] = "UNKNOWN";
  ResponseOfferSnapshot_Result[ResponseOfferSnapshot_Result["ACCEPT"] = 1] = "ACCEPT";
  ResponseOfferSnapshot_Result[ResponseOfferSnapshot_Result["ABORT"] = 2] = "ABORT";
  ResponseOfferSnapshot_Result[ResponseOfferSnapshot_Result["REJECT"] = 3] = "REJECT";
  ResponseOfferSnapshot_Result[ResponseOfferSnapshot_Result["REJECT_FORMAT"] = 4] = "REJECT_FORMAT";
  ResponseOfferSnapshot_Result[ResponseOfferSnapshot_Result["REJECT_SENDER"] = 5] = "REJECT_SENDER";
  ResponseOfferSnapshot_Result[ResponseOfferSnapshot_Result["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(ResponseOfferSnapshot_Result || (ResponseOfferSnapshot_Result = {}));

const ResponseOfferSnapshot_ResultSDKType = ResponseOfferSnapshot_Result;
const ResponseOfferSnapshot_ResultAmino = ResponseOfferSnapshot_Result;
function responseOfferSnapshot_ResultFromJSON(object) {
  switch (object) {
    case 0:
    case "UNKNOWN":
      return ResponseOfferSnapshot_Result.UNKNOWN;

    case 1:
    case "ACCEPT":
      return ResponseOfferSnapshot_Result.ACCEPT;

    case 2:
    case "ABORT":
      return ResponseOfferSnapshot_Result.ABORT;

    case 3:
    case "REJECT":
      return ResponseOfferSnapshot_Result.REJECT;

    case 4:
    case "REJECT_FORMAT":
      return ResponseOfferSnapshot_Result.REJECT_FORMAT;

    case 5:
    case "REJECT_SENDER":
      return ResponseOfferSnapshot_Result.REJECT_SENDER;

    case -1:
    case "UNRECOGNIZED":
    default:
      return ResponseOfferSnapshot_Result.UNRECOGNIZED;
  }
}
function responseOfferSnapshot_ResultToJSON(object) {
  switch (object) {
    case ResponseOfferSnapshot_Result.UNKNOWN:
      return "UNKNOWN";

    case ResponseOfferSnapshot_Result.ACCEPT:
      return "ACCEPT";

    case ResponseOfferSnapshot_Result.ABORT:
      return "ABORT";

    case ResponseOfferSnapshot_Result.REJECT:
      return "REJECT";

    case ResponseOfferSnapshot_Result.REJECT_FORMAT:
      return "REJECT_FORMAT";

    case ResponseOfferSnapshot_Result.REJECT_SENDER:
      return "REJECT_SENDER";

    case ResponseOfferSnapshot_Result.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
let ResponseApplySnapshotChunk_Result;

(function (ResponseApplySnapshotChunk_Result) {
  ResponseApplySnapshotChunk_Result[ResponseApplySnapshotChunk_Result["UNKNOWN"] = 0] = "UNKNOWN";
  ResponseApplySnapshotChunk_Result[ResponseApplySnapshotChunk_Result["ACCEPT"] = 1] = "ACCEPT";
  ResponseApplySnapshotChunk_Result[ResponseApplySnapshotChunk_Result["ABORT"] = 2] = "ABORT";
  ResponseApplySnapshotChunk_Result[ResponseApplySnapshotChunk_Result["RETRY"] = 3] = "RETRY";
  ResponseApplySnapshotChunk_Result[ResponseApplySnapshotChunk_Result["RETRY_SNAPSHOT"] = 4] = "RETRY_SNAPSHOT";
  ResponseApplySnapshotChunk_Result[ResponseApplySnapshotChunk_Result["REJECT_SNAPSHOT"] = 5] = "REJECT_SNAPSHOT";
  ResponseApplySnapshotChunk_Result[ResponseApplySnapshotChunk_Result["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(ResponseApplySnapshotChunk_Result || (ResponseApplySnapshotChunk_Result = {}));

const ResponseApplySnapshotChunk_ResultSDKType = ResponseApplySnapshotChunk_Result;
const ResponseApplySnapshotChunk_ResultAmino = ResponseApplySnapshotChunk_Result;
function responseApplySnapshotChunk_ResultFromJSON(object) {
  switch (object) {
    case 0:
    case "UNKNOWN":
      return ResponseApplySnapshotChunk_Result.UNKNOWN;

    case 1:
    case "ACCEPT":
      return ResponseApplySnapshotChunk_Result.ACCEPT;

    case 2:
    case "ABORT":
      return ResponseApplySnapshotChunk_Result.ABORT;

    case 3:
    case "RETRY":
      return ResponseApplySnapshotChunk_Result.RETRY;

    case 4:
    case "RETRY_SNAPSHOT":
      return ResponseApplySnapshotChunk_Result.RETRY_SNAPSHOT;

    case 5:
    case "REJECT_SNAPSHOT":
      return ResponseApplySnapshotChunk_Result.REJECT_SNAPSHOT;

    case -1:
    case "UNRECOGNIZED":
    default:
      return ResponseApplySnapshotChunk_Result.UNRECOGNIZED;
  }
}
function responseApplySnapshotChunk_ResultToJSON(object) {
  switch (object) {
    case ResponseApplySnapshotChunk_Result.UNKNOWN:
      return "UNKNOWN";

    case ResponseApplySnapshotChunk_Result.ACCEPT:
      return "ACCEPT";

    case ResponseApplySnapshotChunk_Result.ABORT:
      return "ABORT";

    case ResponseApplySnapshotChunk_Result.RETRY:
      return "RETRY";

    case ResponseApplySnapshotChunk_Result.RETRY_SNAPSHOT:
      return "RETRY_SNAPSHOT";

    case ResponseApplySnapshotChunk_Result.REJECT_SNAPSHOT:
      return "REJECT_SNAPSHOT";

    case ResponseApplySnapshotChunk_Result.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
let ResponseProcessProposal_ProposalStatus;

(function (ResponseProcessProposal_ProposalStatus) {
  ResponseProcessProposal_ProposalStatus[ResponseProcessProposal_ProposalStatus["UNKNOWN"] = 0] = "UNKNOWN";
  ResponseProcessProposal_ProposalStatus[ResponseProcessProposal_ProposalStatus["ACCEPT"] = 1] = "ACCEPT";
  ResponseProcessProposal_ProposalStatus[ResponseProcessProposal_ProposalStatus["REJECT"] = 2] = "REJECT";
  ResponseProcessProposal_ProposalStatus[ResponseProcessProposal_ProposalStatus["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(ResponseProcessProposal_ProposalStatus || (ResponseProcessProposal_ProposalStatus = {}));

const ResponseProcessProposal_ProposalStatusSDKType = ResponseProcessProposal_ProposalStatus;
const ResponseProcessProposal_ProposalStatusAmino = ResponseProcessProposal_ProposalStatus;
function responseProcessProposal_ProposalStatusFromJSON(object) {
  switch (object) {
    case 0:
    case "UNKNOWN":
      return ResponseProcessProposal_ProposalStatus.UNKNOWN;

    case 1:
    case "ACCEPT":
      return ResponseProcessProposal_ProposalStatus.ACCEPT;

    case 2:
    case "REJECT":
      return ResponseProcessProposal_ProposalStatus.REJECT;

    case -1:
    case "UNRECOGNIZED":
    default:
      return ResponseProcessProposal_ProposalStatus.UNRECOGNIZED;
  }
}
function responseProcessProposal_ProposalStatusToJSON(object) {
  switch (object) {
    case ResponseProcessProposal_ProposalStatus.UNKNOWN:
      return "UNKNOWN";

    case ResponseProcessProposal_ProposalStatus.ACCEPT:
      return "ACCEPT";

    case ResponseProcessProposal_ProposalStatus.REJECT:
      return "REJECT";

    case ResponseProcessProposal_ProposalStatus.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
let MisbehaviorType;

(function (MisbehaviorType) {
  MisbehaviorType[MisbehaviorType["UNKNOWN"] = 0] = "UNKNOWN";
  MisbehaviorType[MisbehaviorType["DUPLICATE_VOTE"] = 1] = "DUPLICATE_VOTE";
  MisbehaviorType[MisbehaviorType["LIGHT_CLIENT_ATTACK"] = 2] = "LIGHT_CLIENT_ATTACK";
  MisbehaviorType[MisbehaviorType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(MisbehaviorType || (MisbehaviorType = {}));

const MisbehaviorTypeSDKType = MisbehaviorType;
const MisbehaviorTypeAmino = MisbehaviorType;
function misbehaviorTypeFromJSON(object) {
  switch (object) {
    case 0:
    case "UNKNOWN":
      return MisbehaviorType.UNKNOWN;

    case 1:
    case "DUPLICATE_VOTE":
      return MisbehaviorType.DUPLICATE_VOTE;

    case 2:
    case "LIGHT_CLIENT_ATTACK":
      return MisbehaviorType.LIGHT_CLIENT_ATTACK;

    case -1:
    case "UNRECOGNIZED":
    default:
      return MisbehaviorType.UNRECOGNIZED;
  }
}
function misbehaviorTypeToJSON(object) {
  switch (object) {
    case MisbehaviorType.UNKNOWN:
      return "UNKNOWN";

    case MisbehaviorType.DUPLICATE_VOTE:
      return "DUPLICATE_VOTE";

    case MisbehaviorType.LIGHT_CLIENT_ATTACK:
      return "LIGHT_CLIENT_ATTACK";

    case MisbehaviorType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

function createBaseRequest() {
  return {
    echo: undefined,
    flush: undefined,
    info: undefined,
    initChain: undefined,
    query: undefined,
    beginBlock: undefined,
    checkTx: undefined,
    deliverTx: undefined,
    endBlock: undefined,
    commit: undefined,
    listSnapshots: undefined,
    offerSnapshot: undefined,
    loadSnapshotChunk: undefined,
    applySnapshotChunk: undefined,
    prepareProposal: undefined,
    processProposal: undefined
  };
}

const Request = {
  typeUrl: "/tendermint.abci.Request",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    if (message.echo !== undefined) {
      RequestEcho.encode(message.echo, writer.uint32(10).fork()).ldelim();
    }

    if (message.flush !== undefined) {
      RequestFlush.encode(message.flush, writer.uint32(18).fork()).ldelim();
    }

    if (message.info !== undefined) {
      RequestInfo.encode(message.info, writer.uint32(26).fork()).ldelim();
    }

    if (message.initChain !== undefined) {
      RequestInitChain.encode(message.initChain, writer.uint32(42).fork()).ldelim();
    }

    if (message.query !== undefined) {
      RequestQuery.encode(message.query, writer.uint32(50).fork()).ldelim();
    }

    if (message.beginBlock !== undefined) {
      RequestBeginBlock.encode(message.beginBlock, writer.uint32(58).fork()).ldelim();
    }

    if (message.checkTx !== undefined) {
      RequestCheckTx.encode(message.checkTx, writer.uint32(66).fork()).ldelim();
    }

    if (message.deliverTx !== undefined) {
      RequestDeliverTx.encode(message.deliverTx, writer.uint32(74).fork()).ldelim();
    }

    if (message.endBlock !== undefined) {
      RequestEndBlock.encode(message.endBlock, writer.uint32(82).fork()).ldelim();
    }

    if (message.commit !== undefined) {
      RequestCommit.encode(message.commit, writer.uint32(90).fork()).ldelim();
    }

    if (message.listSnapshots !== undefined) {
      RequestListSnapshots.encode(message.listSnapshots, writer.uint32(98).fork()).ldelim();
    }

    if (message.offerSnapshot !== undefined) {
      RequestOfferSnapshot.encode(message.offerSnapshot, writer.uint32(106).fork()).ldelim();
    }

    if (message.loadSnapshotChunk !== undefined) {
      RequestLoadSnapshotChunk.encode(message.loadSnapshotChunk, writer.uint32(114).fork()).ldelim();
    }

    if (message.applySnapshotChunk !== undefined) {
      RequestApplySnapshotChunk.encode(message.applySnapshotChunk, writer.uint32(122).fork()).ldelim();
    }

    if (message.prepareProposal !== undefined) {
      RequestPrepareProposal.encode(message.prepareProposal, writer.uint32(130).fork()).ldelim();
    }

    if (message.processProposal !== undefined) {
      RequestProcessProposal.encode(message.processProposal, writer.uint32(138).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.echo = RequestEcho.decode(reader, reader.uint32());
          break;

        case 2:
          message.flush = RequestFlush.decode(reader, reader.uint32());
          break;

        case 3:
          message.info = RequestInfo.decode(reader, reader.uint32());
          break;

        case 5:
          message.initChain = RequestInitChain.decode(reader, reader.uint32());
          break;

        case 6:
          message.query = RequestQuery.decode(reader, reader.uint32());
          break;

        case 7:
          message.beginBlock = RequestBeginBlock.decode(reader, reader.uint32());
          break;

        case 8:
          message.checkTx = RequestCheckTx.decode(reader, reader.uint32());
          break;

        case 9:
          message.deliverTx = RequestDeliverTx.decode(reader, reader.uint32());
          break;

        case 10:
          message.endBlock = RequestEndBlock.decode(reader, reader.uint32());
          break;

        case 11:
          message.commit = RequestCommit.decode(reader, reader.uint32());
          break;

        case 12:
          message.listSnapshots = RequestListSnapshots.decode(reader, reader.uint32());
          break;

        case 13:
          message.offerSnapshot = RequestOfferSnapshot.decode(reader, reader.uint32());
          break;

        case 14:
          message.loadSnapshotChunk = RequestLoadSnapshotChunk.decode(reader, reader.uint32());
          break;

        case 15:
          message.applySnapshotChunk = RequestApplySnapshotChunk.decode(reader, reader.uint32());
          break;

        case 16:
          message.prepareProposal = RequestPrepareProposal.decode(reader, reader.uint32());
          break;

        case 17:
          message.processProposal = RequestProcessProposal.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseRequest();
    message.echo = object.echo !== undefined && object.echo !== null ? RequestEcho.fromPartial(object.echo) : undefined;
    message.flush = object.flush !== undefined && object.flush !== null ? RequestFlush.fromPartial(object.flush) : undefined;
    message.info = object.info !== undefined && object.info !== null ? RequestInfo.fromPartial(object.info) : undefined;
    message.initChain = object.initChain !== undefined && object.initChain !== null ? RequestInitChain.fromPartial(object.initChain) : undefined;
    message.query = object.query !== undefined && object.query !== null ? RequestQuery.fromPartial(object.query) : undefined;
    message.beginBlock = object.beginBlock !== undefined && object.beginBlock !== null ? RequestBeginBlock.fromPartial(object.beginBlock) : undefined;
    message.checkTx = object.checkTx !== undefined && object.checkTx !== null ? RequestCheckTx.fromPartial(object.checkTx) : undefined;
    message.deliverTx = object.deliverTx !== undefined && object.deliverTx !== null ? RequestDeliverTx.fromPartial(object.deliverTx) : undefined;
    message.endBlock = object.endBlock !== undefined && object.endBlock !== null ? RequestEndBlock.fromPartial(object.endBlock) : undefined;
    message.commit = object.commit !== undefined && object.commit !== null ? RequestCommit.fromPartial(object.commit) : undefined;
    message.listSnapshots = object.listSnapshots !== undefined && object.listSnapshots !== null ? RequestListSnapshots.fromPartial(object.listSnapshots) : undefined;
    message.offerSnapshot = object.offerSnapshot !== undefined && object.offerSnapshot !== null ? RequestOfferSnapshot.fromPartial(object.offerSnapshot) : undefined;
    message.loadSnapshotChunk = object.loadSnapshotChunk !== undefined && object.loadSnapshotChunk !== null ? RequestLoadSnapshotChunk.fromPartial(object.loadSnapshotChunk) : undefined;
    message.applySnapshotChunk = object.applySnapshotChunk !== undefined && object.applySnapshotChunk !== null ? RequestApplySnapshotChunk.fromPartial(object.applySnapshotChunk) : undefined;
    message.prepareProposal = object.prepareProposal !== undefined && object.prepareProposal !== null ? RequestPrepareProposal.fromPartial(object.prepareProposal) : undefined;
    message.processProposal = object.processProposal !== undefined && object.processProposal !== null ? RequestProcessProposal.fromPartial(object.processProposal) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      echo: object !== null && object !== void 0 && object.echo ? RequestEcho.fromAmino(object.echo) : undefined,
      flush: object !== null && object !== void 0 && object.flush ? RequestFlush.fromAmino(object.flush) : undefined,
      info: object !== null && object !== void 0 && object.info ? RequestInfo.fromAmino(object.info) : undefined,
      initChain: object !== null && object !== void 0 && object.init_chain ? RequestInitChain.fromAmino(object.init_chain) : undefined,
      query: object !== null && object !== void 0 && object.query ? RequestQuery.fromAmino(object.query) : undefined,
      beginBlock: object !== null && object !== void 0 && object.begin_block ? RequestBeginBlock.fromAmino(object.begin_block) : undefined,
      checkTx: object !== null && object !== void 0 && object.check_tx ? RequestCheckTx.fromAmino(object.check_tx) : undefined,
      deliverTx: object !== null && object !== void 0 && object.deliver_tx ? RequestDeliverTx.fromAmino(object.deliver_tx) : undefined,
      endBlock: object !== null && object !== void 0 && object.end_block ? RequestEndBlock.fromAmino(object.end_block) : undefined,
      commit: object !== null && object !== void 0 && object.commit ? RequestCommit.fromAmino(object.commit) : undefined,
      listSnapshots: object !== null && object !== void 0 && object.list_snapshots ? RequestListSnapshots.fromAmino(object.list_snapshots) : undefined,
      offerSnapshot: object !== null && object !== void 0 && object.offer_snapshot ? RequestOfferSnapshot.fromAmino(object.offer_snapshot) : undefined,
      loadSnapshotChunk: object !== null && object !== void 0 && object.load_snapshot_chunk ? RequestLoadSnapshotChunk.fromAmino(object.load_snapshot_chunk) : undefined,
      applySnapshotChunk: object !== null && object !== void 0 && object.apply_snapshot_chunk ? RequestApplySnapshotChunk.fromAmino(object.apply_snapshot_chunk) : undefined,
      prepareProposal: object !== null && object !== void 0 && object.prepare_proposal ? RequestPrepareProposal.fromAmino(object.prepare_proposal) : undefined,
      processProposal: object !== null && object !== void 0 && object.process_proposal ? RequestProcessProposal.fromAmino(object.process_proposal) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.echo = message.echo ? RequestEcho.toAmino(message.echo) : undefined;
    obj.flush = message.flush ? RequestFlush.toAmino(message.flush) : undefined;
    obj.info = message.info ? RequestInfo.toAmino(message.info) : undefined;
    obj.init_chain = message.initChain ? RequestInitChain.toAmino(message.initChain) : undefined;
    obj.query = message.query ? RequestQuery.toAmino(message.query) : undefined;
    obj.begin_block = message.beginBlock ? RequestBeginBlock.toAmino(message.beginBlock) : undefined;
    obj.check_tx = message.checkTx ? RequestCheckTx.toAmino(message.checkTx) : undefined;
    obj.deliver_tx = message.deliverTx ? RequestDeliverTx.toAmino(message.deliverTx) : undefined;
    obj.end_block = message.endBlock ? RequestEndBlock.toAmino(message.endBlock) : undefined;
    obj.commit = message.commit ? RequestCommit.toAmino(message.commit) : undefined;
    obj.list_snapshots = message.listSnapshots ? RequestListSnapshots.toAmino(message.listSnapshots) : undefined;
    obj.offer_snapshot = message.offerSnapshot ? RequestOfferSnapshot.toAmino(message.offerSnapshot) : undefined;
    obj.load_snapshot_chunk = message.loadSnapshotChunk ? RequestLoadSnapshotChunk.toAmino(message.loadSnapshotChunk) : undefined;
    obj.apply_snapshot_chunk = message.applySnapshotChunk ? RequestApplySnapshotChunk.toAmino(message.applySnapshotChunk) : undefined;
    obj.prepare_proposal = message.prepareProposal ? RequestPrepareProposal.toAmino(message.prepareProposal) : undefined;
    obj.process_proposal = message.processProposal ? RequestProcessProposal.toAmino(message.processProposal) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return Request.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return Request.decode(message.value);
  },

  toProto(message) {
    return Request.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/tendermint.abci.Request",
      value: Request.encode(message).finish()
    };
  }

};

function createBaseRequestEcho() {
  return {
    message: ""
  };
}

const RequestEcho = {
  typeUrl: "/tendermint.abci.RequestEcho",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    if (message.message !== "") {
      writer.uint32(10).string(message.message);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRequestEcho();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.message = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$message;

    const message = createBaseRequestEcho();
    message.message = (_object$message = object.message) !== null && _object$message !== void 0 ? _object$message : "";
    return message;
  },

  fromAmino(object) {
    return {
      message: object.message
    };
  },

  toAmino(message) {
    const obj = {};
    obj.message = message.message;
    return obj;
  },

  fromAminoMsg(object) {
    return RequestEcho.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return RequestEcho.decode(message.value);
  },

  toProto(message) {
    return RequestEcho.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/tendermint.abci.RequestEcho",
      value: RequestEcho.encode(message).finish()
    };
  }

};

function createBaseRequestFlush() {
  return {};
}

const RequestFlush = {
  typeUrl: "/tendermint.abci.RequestFlush",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRequestFlush();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseRequestFlush();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return RequestFlush.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return RequestFlush.decode(message.value);
  },

  toProto(message) {
    return RequestFlush.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/tendermint.abci.RequestFlush",
      value: RequestFlush.encode(message).finish()
    };
  }

};

function createBaseRequestInfo() {
  return {
    version: "",
    blockVersion: _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.UZERO */ .dK.UZERO,
    p2pVersion: _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.UZERO */ .dK.UZERO,
    abciVersion: ""
  };
}

const RequestInfo = {
  typeUrl: "/tendermint.abci.RequestInfo",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    if (message.version !== "") {
      writer.uint32(10).string(message.version);
    }

    if (!message.blockVersion.isZero()) {
      writer.uint32(16).uint64(message.blockVersion);
    }

    if (!message.p2pVersion.isZero()) {
      writer.uint32(24).uint64(message.p2pVersion);
    }

    if (message.abciVersion !== "") {
      writer.uint32(34).string(message.abciVersion);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRequestInfo();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.version = reader.string();
          break;

        case 2:
          message.blockVersion = reader.uint64();
          break;

        case 3:
          message.p2pVersion = reader.uint64();
          break;

        case 4:
          message.abciVersion = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$version, _object$abciVersion;

    const message = createBaseRequestInfo();
    message.version = (_object$version = object.version) !== null && _object$version !== void 0 ? _object$version : "";
    message.blockVersion = object.blockVersion !== undefined && object.blockVersion !== null ? _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.fromValue */ .dK.fromValue(object.blockVersion) : _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.UZERO */ .dK.UZERO;
    message.p2pVersion = object.p2pVersion !== undefined && object.p2pVersion !== null ? _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.fromValue */ .dK.fromValue(object.p2pVersion) : _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.UZERO */ .dK.UZERO;
    message.abciVersion = (_object$abciVersion = object.abciVersion) !== null && _object$abciVersion !== void 0 ? _object$abciVersion : "";
    return message;
  },

  fromAmino(object) {
    return {
      version: object.version,
      blockVersion: _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.fromString */ .dK.fromString(object.block_version),
      p2pVersion: _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.fromString */ .dK.fromString(object.p2p_version),
      abciVersion: object.abci_version
    };
  },

  toAmino(message) {
    const obj = {};
    obj.version = message.version;
    obj.block_version = message.blockVersion ? message.blockVersion.toString() : undefined;
    obj.p2p_version = message.p2pVersion ? message.p2pVersion.toString() : undefined;
    obj.abci_version = message.abciVersion;
    return obj;
  },

  fromAminoMsg(object) {
    return RequestInfo.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return RequestInfo.decode(message.value);
  },

  toProto(message) {
    return RequestInfo.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/tendermint.abci.RequestInfo",
      value: RequestInfo.encode(message).finish()
    };
  }

};

function createBaseRequestInitChain() {
  return {
    time: undefined,
    chainId: "",
    consensusParams: undefined,
    validators: [],
    appStateBytes: new Uint8Array(),
    initialHeight: _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.ZERO */ .dK.ZERO
  };
}

const RequestInitChain = {
  typeUrl: "/tendermint.abci.RequestInitChain",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    if (message.time !== undefined) {
      _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_0__.Timestamp.encode((0,_helpers__WEBPACK_IMPORTED_MODULE_5__/* .toTimestamp */ .Uq)(message.time), writer.uint32(10).fork()).ldelim();
    }

    if (message.chainId !== "") {
      writer.uint32(18).string(message.chainId);
    }

    if (message.consensusParams !== undefined) {
      _types_params__WEBPACK_IMPORTED_MODULE_1__.ConsensusParams.encode(message.consensusParams, writer.uint32(26).fork()).ldelim();
    }

    for (const v of message.validators) {
      ValidatorUpdate.encode(v, writer.uint32(34).fork()).ldelim();
    }

    if (message.appStateBytes.length !== 0) {
      writer.uint32(42).bytes(message.appStateBytes);
    }

    if (!message.initialHeight.isZero()) {
      writer.uint32(48).int64(message.initialHeight);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRequestInitChain();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.time = (0,_helpers__WEBPACK_IMPORTED_MODULE_5__/* .fromTimestamp */ .Ol)(_google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_0__.Timestamp.decode(reader, reader.uint32()));
          break;

        case 2:
          message.chainId = reader.string();
          break;

        case 3:
          message.consensusParams = _types_params__WEBPACK_IMPORTED_MODULE_1__.ConsensusParams.decode(reader, reader.uint32());
          break;

        case 4:
          message.validators.push(ValidatorUpdate.decode(reader, reader.uint32()));
          break;

        case 5:
          message.appStateBytes = reader.bytes();
          break;

        case 6:
          message.initialHeight = reader.int64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$time, _object$chainId, _object$validators, _object$appStateBytes;

    const message = createBaseRequestInitChain();
    message.time = (_object$time = object.time) !== null && _object$time !== void 0 ? _object$time : undefined;
    message.chainId = (_object$chainId = object.chainId) !== null && _object$chainId !== void 0 ? _object$chainId : "";
    message.consensusParams = object.consensusParams !== undefined && object.consensusParams !== null ? _types_params__WEBPACK_IMPORTED_MODULE_1__.ConsensusParams.fromPartial(object.consensusParams) : undefined;
    message.validators = ((_object$validators = object.validators) === null || _object$validators === void 0 ? void 0 : _object$validators.map(e => ValidatorUpdate.fromPartial(e))) || [];
    message.appStateBytes = (_object$appStateBytes = object.appStateBytes) !== null && _object$appStateBytes !== void 0 ? _object$appStateBytes : new Uint8Array();
    message.initialHeight = object.initialHeight !== undefined && object.initialHeight !== null ? _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.fromValue */ .dK.fromValue(object.initialHeight) : _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.ZERO */ .dK.ZERO;
    return message;
  },

  fromAmino(object) {
    return {
      time: object !== null && object !== void 0 && object.time ? _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_0__.Timestamp.fromAmino(object.time) : undefined,
      chainId: object.chain_id,
      consensusParams: object !== null && object !== void 0 && object.consensus_params ? _types_params__WEBPACK_IMPORTED_MODULE_1__.ConsensusParams.fromAmino(object.consensus_params) : undefined,
      validators: Array.isArray(object === null || object === void 0 ? void 0 : object.validators) ? object.validators.map(e => ValidatorUpdate.fromAmino(e)) : [],
      appStateBytes: object.app_state_bytes,
      initialHeight: _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.fromString */ .dK.fromString(object.initial_height)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.time = message.time ? _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_0__.Timestamp.toAmino(message.time) : undefined;
    obj.chain_id = message.chainId;
    obj.consensus_params = message.consensusParams ? _types_params__WEBPACK_IMPORTED_MODULE_1__.ConsensusParams.toAmino(message.consensusParams) : undefined;

    if (message.validators) {
      obj.validators = message.validators.map(e => e ? ValidatorUpdate.toAmino(e) : undefined);
    } else {
      obj.validators = [];
    }

    obj.app_state_bytes = message.appStateBytes;
    obj.initial_height = message.initialHeight ? message.initialHeight.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return RequestInitChain.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return RequestInitChain.decode(message.value);
  },

  toProto(message) {
    return RequestInitChain.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/tendermint.abci.RequestInitChain",
      value: RequestInitChain.encode(message).finish()
    };
  }

};

function createBaseRequestQuery() {
  return {
    data: new Uint8Array(),
    path: "",
    height: _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.ZERO */ .dK.ZERO,
    prove: false
  };
}

const RequestQuery = {
  typeUrl: "/tendermint.abci.RequestQuery",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    if (message.data.length !== 0) {
      writer.uint32(10).bytes(message.data);
    }

    if (message.path !== "") {
      writer.uint32(18).string(message.path);
    }

    if (!message.height.isZero()) {
      writer.uint32(24).int64(message.height);
    }

    if (message.prove === true) {
      writer.uint32(32).bool(message.prove);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRequestQuery();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.data = reader.bytes();
          break;

        case 2:
          message.path = reader.string();
          break;

        case 3:
          message.height = reader.int64();
          break;

        case 4:
          message.prove = reader.bool();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$data, _object$path, _object$prove;

    const message = createBaseRequestQuery();
    message.data = (_object$data = object.data) !== null && _object$data !== void 0 ? _object$data : new Uint8Array();
    message.path = (_object$path = object.path) !== null && _object$path !== void 0 ? _object$path : "";
    message.height = object.height !== undefined && object.height !== null ? _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.fromValue */ .dK.fromValue(object.height) : _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.ZERO */ .dK.ZERO;
    message.prove = (_object$prove = object.prove) !== null && _object$prove !== void 0 ? _object$prove : false;
    return message;
  },

  fromAmino(object) {
    return {
      data: object.data,
      path: object.path,
      height: _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.fromString */ .dK.fromString(object.height),
      prove: object.prove
    };
  },

  toAmino(message) {
    const obj = {};
    obj.data = message.data;
    obj.path = message.path;
    obj.height = message.height ? message.height.toString() : undefined;
    obj.prove = message.prove;
    return obj;
  },

  fromAminoMsg(object) {
    return RequestQuery.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return RequestQuery.decode(message.value);
  },

  toProto(message) {
    return RequestQuery.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/tendermint.abci.RequestQuery",
      value: RequestQuery.encode(message).finish()
    };
  }

};

function createBaseRequestBeginBlock() {
  return {
    hash: new Uint8Array(),
    header: undefined,
    lastCommitInfo: undefined,
    byzantineValidators: []
  };
}

const RequestBeginBlock = {
  typeUrl: "/tendermint.abci.RequestBeginBlock",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    if (message.hash.length !== 0) {
      writer.uint32(10).bytes(message.hash);
    }

    if (message.header !== undefined) {
      _types_types__WEBPACK_IMPORTED_MODULE_2__.Header.encode(message.header, writer.uint32(18).fork()).ldelim();
    }

    if (message.lastCommitInfo !== undefined) {
      CommitInfo.encode(message.lastCommitInfo, writer.uint32(26).fork()).ldelim();
    }

    for (const v of message.byzantineValidators) {
      Misbehavior.encode(v, writer.uint32(34).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRequestBeginBlock();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.hash = reader.bytes();
          break;

        case 2:
          message.header = _types_types__WEBPACK_IMPORTED_MODULE_2__.Header.decode(reader, reader.uint32());
          break;

        case 3:
          message.lastCommitInfo = CommitInfo.decode(reader, reader.uint32());
          break;

        case 4:
          message.byzantineValidators.push(Misbehavior.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$hash, _object$byzantineVali;

    const message = createBaseRequestBeginBlock();
    message.hash = (_object$hash = object.hash) !== null && _object$hash !== void 0 ? _object$hash : new Uint8Array();
    message.header = object.header !== undefined && object.header !== null ? _types_types__WEBPACK_IMPORTED_MODULE_2__.Header.fromPartial(object.header) : undefined;
    message.lastCommitInfo = object.lastCommitInfo !== undefined && object.lastCommitInfo !== null ? CommitInfo.fromPartial(object.lastCommitInfo) : undefined;
    message.byzantineValidators = ((_object$byzantineVali = object.byzantineValidators) === null || _object$byzantineVali === void 0 ? void 0 : _object$byzantineVali.map(e => Misbehavior.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      hash: object.hash,
      header: object !== null && object !== void 0 && object.header ? _types_types__WEBPACK_IMPORTED_MODULE_2__.Header.fromAmino(object.header) : undefined,
      lastCommitInfo: object !== null && object !== void 0 && object.last_commit_info ? CommitInfo.fromAmino(object.last_commit_info) : undefined,
      byzantineValidators: Array.isArray(object === null || object === void 0 ? void 0 : object.byzantine_validators) ? object.byzantine_validators.map(e => Misbehavior.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.hash = message.hash;
    obj.header = message.header ? _types_types__WEBPACK_IMPORTED_MODULE_2__.Header.toAmino(message.header) : undefined;
    obj.last_commit_info = message.lastCommitInfo ? CommitInfo.toAmino(message.lastCommitInfo) : undefined;

    if (message.byzantineValidators) {
      obj.byzantine_validators = message.byzantineValidators.map(e => e ? Misbehavior.toAmino(e) : undefined);
    } else {
      obj.byzantine_validators = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return RequestBeginBlock.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return RequestBeginBlock.decode(message.value);
  },

  toProto(message) {
    return RequestBeginBlock.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/tendermint.abci.RequestBeginBlock",
      value: RequestBeginBlock.encode(message).finish()
    };
  }

};

function createBaseRequestCheckTx() {
  return {
    tx: new Uint8Array(),
    type: 0
  };
}

const RequestCheckTx = {
  typeUrl: "/tendermint.abci.RequestCheckTx",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    if (message.tx.length !== 0) {
      writer.uint32(10).bytes(message.tx);
    }

    if (message.type !== 0) {
      writer.uint32(16).int32(message.type);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRequestCheckTx();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.tx = reader.bytes();
          break;

        case 2:
          message.type = reader.int32();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$tx, _object$type;

    const message = createBaseRequestCheckTx();
    message.tx = (_object$tx = object.tx) !== null && _object$tx !== void 0 ? _object$tx : new Uint8Array();
    message.type = (_object$type = object.type) !== null && _object$type !== void 0 ? _object$type : 0;
    return message;
  },

  fromAmino(object) {
    return {
      tx: object.tx,
      type: (0,_helpers__WEBPACK_IMPORTED_MODULE_5__/* .isSet */ .DM)(object.type) ? checkTxTypeFromJSON(object.type) : 0
    };
  },

  toAmino(message) {
    const obj = {};
    obj.tx = message.tx;
    obj.type = message.type;
    return obj;
  },

  fromAminoMsg(object) {
    return RequestCheckTx.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return RequestCheckTx.decode(message.value);
  },

  toProto(message) {
    return RequestCheckTx.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/tendermint.abci.RequestCheckTx",
      value: RequestCheckTx.encode(message).finish()
    };
  }

};

function createBaseRequestDeliverTx() {
  return {
    tx: new Uint8Array()
  };
}

const RequestDeliverTx = {
  typeUrl: "/tendermint.abci.RequestDeliverTx",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    if (message.tx.length !== 0) {
      writer.uint32(10).bytes(message.tx);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRequestDeliverTx();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.tx = reader.bytes();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$tx2;

    const message = createBaseRequestDeliverTx();
    message.tx = (_object$tx2 = object.tx) !== null && _object$tx2 !== void 0 ? _object$tx2 : new Uint8Array();
    return message;
  },

  fromAmino(object) {
    return {
      tx: object.tx
    };
  },

  toAmino(message) {
    const obj = {};
    obj.tx = message.tx;
    return obj;
  },

  fromAminoMsg(object) {
    return RequestDeliverTx.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return RequestDeliverTx.decode(message.value);
  },

  toProto(message) {
    return RequestDeliverTx.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/tendermint.abci.RequestDeliverTx",
      value: RequestDeliverTx.encode(message).finish()
    };
  }

};

function createBaseRequestEndBlock() {
  return {
    height: _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.ZERO */ .dK.ZERO
  };
}

const RequestEndBlock = {
  typeUrl: "/tendermint.abci.RequestEndBlock",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    if (!message.height.isZero()) {
      writer.uint32(8).int64(message.height);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRequestEndBlock();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.height = reader.int64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseRequestEndBlock();
    message.height = object.height !== undefined && object.height !== null ? _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.fromValue */ .dK.fromValue(object.height) : _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.ZERO */ .dK.ZERO;
    return message;
  },

  fromAmino(object) {
    return {
      height: _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.fromString */ .dK.fromString(object.height)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.height = message.height ? message.height.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return RequestEndBlock.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return RequestEndBlock.decode(message.value);
  },

  toProto(message) {
    return RequestEndBlock.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/tendermint.abci.RequestEndBlock",
      value: RequestEndBlock.encode(message).finish()
    };
  }

};

function createBaseRequestCommit() {
  return {};
}

const RequestCommit = {
  typeUrl: "/tendermint.abci.RequestCommit",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRequestCommit();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseRequestCommit();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return RequestCommit.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return RequestCommit.decode(message.value);
  },

  toProto(message) {
    return RequestCommit.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/tendermint.abci.RequestCommit",
      value: RequestCommit.encode(message).finish()
    };
  }

};

function createBaseRequestListSnapshots() {
  return {};
}

const RequestListSnapshots = {
  typeUrl: "/tendermint.abci.RequestListSnapshots",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRequestListSnapshots();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseRequestListSnapshots();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return RequestListSnapshots.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return RequestListSnapshots.decode(message.value);
  },

  toProto(message) {
    return RequestListSnapshots.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/tendermint.abci.RequestListSnapshots",
      value: RequestListSnapshots.encode(message).finish()
    };
  }

};

function createBaseRequestOfferSnapshot() {
  return {
    snapshot: undefined,
    appHash: new Uint8Array()
  };
}

const RequestOfferSnapshot = {
  typeUrl: "/tendermint.abci.RequestOfferSnapshot",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    if (message.snapshot !== undefined) {
      Snapshot.encode(message.snapshot, writer.uint32(10).fork()).ldelim();
    }

    if (message.appHash.length !== 0) {
      writer.uint32(18).bytes(message.appHash);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRequestOfferSnapshot();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.snapshot = Snapshot.decode(reader, reader.uint32());
          break;

        case 2:
          message.appHash = reader.bytes();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$appHash;

    const message = createBaseRequestOfferSnapshot();
    message.snapshot = object.snapshot !== undefined && object.snapshot !== null ? Snapshot.fromPartial(object.snapshot) : undefined;
    message.appHash = (_object$appHash = object.appHash) !== null && _object$appHash !== void 0 ? _object$appHash : new Uint8Array();
    return message;
  },

  fromAmino(object) {
    return {
      snapshot: object !== null && object !== void 0 && object.snapshot ? Snapshot.fromAmino(object.snapshot) : undefined,
      appHash: object.app_hash
    };
  },

  toAmino(message) {
    const obj = {};
    obj.snapshot = message.snapshot ? Snapshot.toAmino(message.snapshot) : undefined;
    obj.app_hash = message.appHash;
    return obj;
  },

  fromAminoMsg(object) {
    return RequestOfferSnapshot.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return RequestOfferSnapshot.decode(message.value);
  },

  toProto(message) {
    return RequestOfferSnapshot.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/tendermint.abci.RequestOfferSnapshot",
      value: RequestOfferSnapshot.encode(message).finish()
    };
  }

};

function createBaseRequestLoadSnapshotChunk() {
  return {
    height: _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.UZERO */ .dK.UZERO,
    format: 0,
    chunk: 0
  };
}

const RequestLoadSnapshotChunk = {
  typeUrl: "/tendermint.abci.RequestLoadSnapshotChunk",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    if (!message.height.isZero()) {
      writer.uint32(8).uint64(message.height);
    }

    if (message.format !== 0) {
      writer.uint32(16).uint32(message.format);
    }

    if (message.chunk !== 0) {
      writer.uint32(24).uint32(message.chunk);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRequestLoadSnapshotChunk();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.height = reader.uint64();
          break;

        case 2:
          message.format = reader.uint32();
          break;

        case 3:
          message.chunk = reader.uint32();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$format, _object$chunk;

    const message = createBaseRequestLoadSnapshotChunk();
    message.height = object.height !== undefined && object.height !== null ? _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.fromValue */ .dK.fromValue(object.height) : _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.UZERO */ .dK.UZERO;
    message.format = (_object$format = object.format) !== null && _object$format !== void 0 ? _object$format : 0;
    message.chunk = (_object$chunk = object.chunk) !== null && _object$chunk !== void 0 ? _object$chunk : 0;
    return message;
  },

  fromAmino(object) {
    return {
      height: _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.fromString */ .dK.fromString(object.height),
      format: object.format,
      chunk: object.chunk
    };
  },

  toAmino(message) {
    const obj = {};
    obj.height = message.height ? message.height.toString() : undefined;
    obj.format = message.format;
    obj.chunk = message.chunk;
    return obj;
  },

  fromAminoMsg(object) {
    return RequestLoadSnapshotChunk.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return RequestLoadSnapshotChunk.decode(message.value);
  },

  toProto(message) {
    return RequestLoadSnapshotChunk.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/tendermint.abci.RequestLoadSnapshotChunk",
      value: RequestLoadSnapshotChunk.encode(message).finish()
    };
  }

};

function createBaseRequestApplySnapshotChunk() {
  return {
    index: 0,
    chunk: new Uint8Array(),
    sender: ""
  };
}

const RequestApplySnapshotChunk = {
  typeUrl: "/tendermint.abci.RequestApplySnapshotChunk",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    if (message.index !== 0) {
      writer.uint32(8).uint32(message.index);
    }

    if (message.chunk.length !== 0) {
      writer.uint32(18).bytes(message.chunk);
    }

    if (message.sender !== "") {
      writer.uint32(26).string(message.sender);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRequestApplySnapshotChunk();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.index = reader.uint32();
          break;

        case 2:
          message.chunk = reader.bytes();
          break;

        case 3:
          message.sender = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$index, _object$chunk2, _object$sender;

    const message = createBaseRequestApplySnapshotChunk();
    message.index = (_object$index = object.index) !== null && _object$index !== void 0 ? _object$index : 0;
    message.chunk = (_object$chunk2 = object.chunk) !== null && _object$chunk2 !== void 0 ? _object$chunk2 : new Uint8Array();
    message.sender = (_object$sender = object.sender) !== null && _object$sender !== void 0 ? _object$sender : "";
    return message;
  },

  fromAmino(object) {
    return {
      index: object.index,
      chunk: object.chunk,
      sender: object.sender
    };
  },

  toAmino(message) {
    const obj = {};
    obj.index = message.index;
    obj.chunk = message.chunk;
    obj.sender = message.sender;
    return obj;
  },

  fromAminoMsg(object) {
    return RequestApplySnapshotChunk.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return RequestApplySnapshotChunk.decode(message.value);
  },

  toProto(message) {
    return RequestApplySnapshotChunk.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/tendermint.abci.RequestApplySnapshotChunk",
      value: RequestApplySnapshotChunk.encode(message).finish()
    };
  }

};

function createBaseRequestPrepareProposal() {
  return {
    maxTxBytes: _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.ZERO */ .dK.ZERO,
    txs: [],
    localLastCommit: undefined,
    misbehavior: [],
    height: _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.ZERO */ .dK.ZERO,
    time: undefined,
    nextValidatorsHash: new Uint8Array(),
    proposerAddress: new Uint8Array()
  };
}

const RequestPrepareProposal = {
  typeUrl: "/tendermint.abci.RequestPrepareProposal",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    if (!message.maxTxBytes.isZero()) {
      writer.uint32(8).int64(message.maxTxBytes);
    }

    for (const v of message.txs) {
      writer.uint32(18).bytes(v);
    }

    if (message.localLastCommit !== undefined) {
      ExtendedCommitInfo.encode(message.localLastCommit, writer.uint32(26).fork()).ldelim();
    }

    for (const v of message.misbehavior) {
      Misbehavior.encode(v, writer.uint32(34).fork()).ldelim();
    }

    if (!message.height.isZero()) {
      writer.uint32(40).int64(message.height);
    }

    if (message.time !== undefined) {
      _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_0__.Timestamp.encode((0,_helpers__WEBPACK_IMPORTED_MODULE_5__/* .toTimestamp */ .Uq)(message.time), writer.uint32(50).fork()).ldelim();
    }

    if (message.nextValidatorsHash.length !== 0) {
      writer.uint32(58).bytes(message.nextValidatorsHash);
    }

    if (message.proposerAddress.length !== 0) {
      writer.uint32(66).bytes(message.proposerAddress);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRequestPrepareProposal();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.maxTxBytes = reader.int64();
          break;

        case 2:
          message.txs.push(reader.bytes());
          break;

        case 3:
          message.localLastCommit = ExtendedCommitInfo.decode(reader, reader.uint32());
          break;

        case 4:
          message.misbehavior.push(Misbehavior.decode(reader, reader.uint32()));
          break;

        case 5:
          message.height = reader.int64();
          break;

        case 6:
          message.time = (0,_helpers__WEBPACK_IMPORTED_MODULE_5__/* .fromTimestamp */ .Ol)(_google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_0__.Timestamp.decode(reader, reader.uint32()));
          break;

        case 7:
          message.nextValidatorsHash = reader.bytes();
          break;

        case 8:
          message.proposerAddress = reader.bytes();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$txs, _object$misbehavior, _object$time2, _object$nextValidator, _object$proposerAddre;

    const message = createBaseRequestPrepareProposal();
    message.maxTxBytes = object.maxTxBytes !== undefined && object.maxTxBytes !== null ? _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.fromValue */ .dK.fromValue(object.maxTxBytes) : _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.ZERO */ .dK.ZERO;
    message.txs = ((_object$txs = object.txs) === null || _object$txs === void 0 ? void 0 : _object$txs.map(e => e)) || [];
    message.localLastCommit = object.localLastCommit !== undefined && object.localLastCommit !== null ? ExtendedCommitInfo.fromPartial(object.localLastCommit) : undefined;
    message.misbehavior = ((_object$misbehavior = object.misbehavior) === null || _object$misbehavior === void 0 ? void 0 : _object$misbehavior.map(e => Misbehavior.fromPartial(e))) || [];
    message.height = object.height !== undefined && object.height !== null ? _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.fromValue */ .dK.fromValue(object.height) : _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.ZERO */ .dK.ZERO;
    message.time = (_object$time2 = object.time) !== null && _object$time2 !== void 0 ? _object$time2 : undefined;
    message.nextValidatorsHash = (_object$nextValidator = object.nextValidatorsHash) !== null && _object$nextValidator !== void 0 ? _object$nextValidator : new Uint8Array();
    message.proposerAddress = (_object$proposerAddre = object.proposerAddress) !== null && _object$proposerAddre !== void 0 ? _object$proposerAddre : new Uint8Array();
    return message;
  },

  fromAmino(object) {
    return {
      maxTxBytes: _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.fromString */ .dK.fromString(object.max_tx_bytes),
      txs: Array.isArray(object === null || object === void 0 ? void 0 : object.txs) ? object.txs.map(e => e) : [],
      localLastCommit: object !== null && object !== void 0 && object.local_last_commit ? ExtendedCommitInfo.fromAmino(object.local_last_commit) : undefined,
      misbehavior: Array.isArray(object === null || object === void 0 ? void 0 : object.misbehavior) ? object.misbehavior.map(e => Misbehavior.fromAmino(e)) : [],
      height: _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.fromString */ .dK.fromString(object.height),
      time: object !== null && object !== void 0 && object.time ? _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_0__.Timestamp.fromAmino(object.time) : undefined,
      nextValidatorsHash: object.next_validators_hash,
      proposerAddress: object.proposer_address
    };
  },

  toAmino(message) {
    const obj = {};
    obj.max_tx_bytes = message.maxTxBytes ? message.maxTxBytes.toString() : undefined;

    if (message.txs) {
      obj.txs = message.txs.map(e => e);
    } else {
      obj.txs = [];
    }

    obj.local_last_commit = message.localLastCommit ? ExtendedCommitInfo.toAmino(message.localLastCommit) : undefined;

    if (message.misbehavior) {
      obj.misbehavior = message.misbehavior.map(e => e ? Misbehavior.toAmino(e) : undefined);
    } else {
      obj.misbehavior = [];
    }

    obj.height = message.height ? message.height.toString() : undefined;
    obj.time = message.time ? _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_0__.Timestamp.toAmino(message.time) : undefined;
    obj.next_validators_hash = message.nextValidatorsHash;
    obj.proposer_address = message.proposerAddress;
    return obj;
  },

  fromAminoMsg(object) {
    return RequestPrepareProposal.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return RequestPrepareProposal.decode(message.value);
  },

  toProto(message) {
    return RequestPrepareProposal.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/tendermint.abci.RequestPrepareProposal",
      value: RequestPrepareProposal.encode(message).finish()
    };
  }

};

function createBaseRequestProcessProposal() {
  return {
    txs: [],
    proposedLastCommit: undefined,
    misbehavior: [],
    hash: new Uint8Array(),
    height: _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.ZERO */ .dK.ZERO,
    time: undefined,
    nextValidatorsHash: new Uint8Array(),
    proposerAddress: new Uint8Array()
  };
}

const RequestProcessProposal = {
  typeUrl: "/tendermint.abci.RequestProcessProposal",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    for (const v of message.txs) {
      writer.uint32(10).bytes(v);
    }

    if (message.proposedLastCommit !== undefined) {
      CommitInfo.encode(message.proposedLastCommit, writer.uint32(18).fork()).ldelim();
    }

    for (const v of message.misbehavior) {
      Misbehavior.encode(v, writer.uint32(26).fork()).ldelim();
    }

    if (message.hash.length !== 0) {
      writer.uint32(34).bytes(message.hash);
    }

    if (!message.height.isZero()) {
      writer.uint32(40).int64(message.height);
    }

    if (message.time !== undefined) {
      _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_0__.Timestamp.encode((0,_helpers__WEBPACK_IMPORTED_MODULE_5__/* .toTimestamp */ .Uq)(message.time), writer.uint32(50).fork()).ldelim();
    }

    if (message.nextValidatorsHash.length !== 0) {
      writer.uint32(58).bytes(message.nextValidatorsHash);
    }

    if (message.proposerAddress.length !== 0) {
      writer.uint32(66).bytes(message.proposerAddress);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRequestProcessProposal();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.txs.push(reader.bytes());
          break;

        case 2:
          message.proposedLastCommit = CommitInfo.decode(reader, reader.uint32());
          break;

        case 3:
          message.misbehavior.push(Misbehavior.decode(reader, reader.uint32()));
          break;

        case 4:
          message.hash = reader.bytes();
          break;

        case 5:
          message.height = reader.int64();
          break;

        case 6:
          message.time = (0,_helpers__WEBPACK_IMPORTED_MODULE_5__/* .fromTimestamp */ .Ol)(_google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_0__.Timestamp.decode(reader, reader.uint32()));
          break;

        case 7:
          message.nextValidatorsHash = reader.bytes();
          break;

        case 8:
          message.proposerAddress = reader.bytes();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$txs2, _object$misbehavior2, _object$hash2, _object$time3, _object$nextValidator2, _object$proposerAddre2;

    const message = createBaseRequestProcessProposal();
    message.txs = ((_object$txs2 = object.txs) === null || _object$txs2 === void 0 ? void 0 : _object$txs2.map(e => e)) || [];
    message.proposedLastCommit = object.proposedLastCommit !== undefined && object.proposedLastCommit !== null ? CommitInfo.fromPartial(object.proposedLastCommit) : undefined;
    message.misbehavior = ((_object$misbehavior2 = object.misbehavior) === null || _object$misbehavior2 === void 0 ? void 0 : _object$misbehavior2.map(e => Misbehavior.fromPartial(e))) || [];
    message.hash = (_object$hash2 = object.hash) !== null && _object$hash2 !== void 0 ? _object$hash2 : new Uint8Array();
    message.height = object.height !== undefined && object.height !== null ? _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.fromValue */ .dK.fromValue(object.height) : _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.ZERO */ .dK.ZERO;
    message.time = (_object$time3 = object.time) !== null && _object$time3 !== void 0 ? _object$time3 : undefined;
    message.nextValidatorsHash = (_object$nextValidator2 = object.nextValidatorsHash) !== null && _object$nextValidator2 !== void 0 ? _object$nextValidator2 : new Uint8Array();
    message.proposerAddress = (_object$proposerAddre2 = object.proposerAddress) !== null && _object$proposerAddre2 !== void 0 ? _object$proposerAddre2 : new Uint8Array();
    return message;
  },

  fromAmino(object) {
    return {
      txs: Array.isArray(object === null || object === void 0 ? void 0 : object.txs) ? object.txs.map(e => e) : [],
      proposedLastCommit: object !== null && object !== void 0 && object.proposed_last_commit ? CommitInfo.fromAmino(object.proposed_last_commit) : undefined,
      misbehavior: Array.isArray(object === null || object === void 0 ? void 0 : object.misbehavior) ? object.misbehavior.map(e => Misbehavior.fromAmino(e)) : [],
      hash: object.hash,
      height: _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.fromString */ .dK.fromString(object.height),
      time: object !== null && object !== void 0 && object.time ? _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_0__.Timestamp.fromAmino(object.time) : undefined,
      nextValidatorsHash: object.next_validators_hash,
      proposerAddress: object.proposer_address
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.txs) {
      obj.txs = message.txs.map(e => e);
    } else {
      obj.txs = [];
    }

    obj.proposed_last_commit = message.proposedLastCommit ? CommitInfo.toAmino(message.proposedLastCommit) : undefined;

    if (message.misbehavior) {
      obj.misbehavior = message.misbehavior.map(e => e ? Misbehavior.toAmino(e) : undefined);
    } else {
      obj.misbehavior = [];
    }

    obj.hash = message.hash;
    obj.height = message.height ? message.height.toString() : undefined;
    obj.time = message.time ? _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_0__.Timestamp.toAmino(message.time) : undefined;
    obj.next_validators_hash = message.nextValidatorsHash;
    obj.proposer_address = message.proposerAddress;
    return obj;
  },

  fromAminoMsg(object) {
    return RequestProcessProposal.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return RequestProcessProposal.decode(message.value);
  },

  toProto(message) {
    return RequestProcessProposal.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/tendermint.abci.RequestProcessProposal",
      value: RequestProcessProposal.encode(message).finish()
    };
  }

};

function createBaseResponse() {
  return {
    exception: undefined,
    echo: undefined,
    flush: undefined,
    info: undefined,
    initChain: undefined,
    query: undefined,
    beginBlock: undefined,
    checkTx: undefined,
    deliverTx: undefined,
    endBlock: undefined,
    commit: undefined,
    listSnapshots: undefined,
    offerSnapshot: undefined,
    loadSnapshotChunk: undefined,
    applySnapshotChunk: undefined,
    prepareProposal: undefined,
    processProposal: undefined
  };
}

const Response = {
  typeUrl: "/tendermint.abci.Response",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    if (message.exception !== undefined) {
      ResponseException.encode(message.exception, writer.uint32(10).fork()).ldelim();
    }

    if (message.echo !== undefined) {
      ResponseEcho.encode(message.echo, writer.uint32(18).fork()).ldelim();
    }

    if (message.flush !== undefined) {
      ResponseFlush.encode(message.flush, writer.uint32(26).fork()).ldelim();
    }

    if (message.info !== undefined) {
      ResponseInfo.encode(message.info, writer.uint32(34).fork()).ldelim();
    }

    if (message.initChain !== undefined) {
      ResponseInitChain.encode(message.initChain, writer.uint32(50).fork()).ldelim();
    }

    if (message.query !== undefined) {
      ResponseQuery.encode(message.query, writer.uint32(58).fork()).ldelim();
    }

    if (message.beginBlock !== undefined) {
      ResponseBeginBlock.encode(message.beginBlock, writer.uint32(66).fork()).ldelim();
    }

    if (message.checkTx !== undefined) {
      ResponseCheckTx.encode(message.checkTx, writer.uint32(74).fork()).ldelim();
    }

    if (message.deliverTx !== undefined) {
      ResponseDeliverTx.encode(message.deliverTx, writer.uint32(82).fork()).ldelim();
    }

    if (message.endBlock !== undefined) {
      ResponseEndBlock.encode(message.endBlock, writer.uint32(90).fork()).ldelim();
    }

    if (message.commit !== undefined) {
      ResponseCommit.encode(message.commit, writer.uint32(98).fork()).ldelim();
    }

    if (message.listSnapshots !== undefined) {
      ResponseListSnapshots.encode(message.listSnapshots, writer.uint32(106).fork()).ldelim();
    }

    if (message.offerSnapshot !== undefined) {
      ResponseOfferSnapshot.encode(message.offerSnapshot, writer.uint32(114).fork()).ldelim();
    }

    if (message.loadSnapshotChunk !== undefined) {
      ResponseLoadSnapshotChunk.encode(message.loadSnapshotChunk, writer.uint32(122).fork()).ldelim();
    }

    if (message.applySnapshotChunk !== undefined) {
      ResponseApplySnapshotChunk.encode(message.applySnapshotChunk, writer.uint32(130).fork()).ldelim();
    }

    if (message.prepareProposal !== undefined) {
      ResponsePrepareProposal.encode(message.prepareProposal, writer.uint32(138).fork()).ldelim();
    }

    if (message.processProposal !== undefined) {
      ResponseProcessProposal.encode(message.processProposal, writer.uint32(146).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.exception = ResponseException.decode(reader, reader.uint32());
          break;

        case 2:
          message.echo = ResponseEcho.decode(reader, reader.uint32());
          break;

        case 3:
          message.flush = ResponseFlush.decode(reader, reader.uint32());
          break;

        case 4:
          message.info = ResponseInfo.decode(reader, reader.uint32());
          break;

        case 6:
          message.initChain = ResponseInitChain.decode(reader, reader.uint32());
          break;

        case 7:
          message.query = ResponseQuery.decode(reader, reader.uint32());
          break;

        case 8:
          message.beginBlock = ResponseBeginBlock.decode(reader, reader.uint32());
          break;

        case 9:
          message.checkTx = ResponseCheckTx.decode(reader, reader.uint32());
          break;

        case 10:
          message.deliverTx = ResponseDeliverTx.decode(reader, reader.uint32());
          break;

        case 11:
          message.endBlock = ResponseEndBlock.decode(reader, reader.uint32());
          break;

        case 12:
          message.commit = ResponseCommit.decode(reader, reader.uint32());
          break;

        case 13:
          message.listSnapshots = ResponseListSnapshots.decode(reader, reader.uint32());
          break;

        case 14:
          message.offerSnapshot = ResponseOfferSnapshot.decode(reader, reader.uint32());
          break;

        case 15:
          message.loadSnapshotChunk = ResponseLoadSnapshotChunk.decode(reader, reader.uint32());
          break;

        case 16:
          message.applySnapshotChunk = ResponseApplySnapshotChunk.decode(reader, reader.uint32());
          break;

        case 17:
          message.prepareProposal = ResponsePrepareProposal.decode(reader, reader.uint32());
          break;

        case 18:
          message.processProposal = ResponseProcessProposal.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseResponse();
    message.exception = object.exception !== undefined && object.exception !== null ? ResponseException.fromPartial(object.exception) : undefined;
    message.echo = object.echo !== undefined && object.echo !== null ? ResponseEcho.fromPartial(object.echo) : undefined;
    message.flush = object.flush !== undefined && object.flush !== null ? ResponseFlush.fromPartial(object.flush) : undefined;
    message.info = object.info !== undefined && object.info !== null ? ResponseInfo.fromPartial(object.info) : undefined;
    message.initChain = object.initChain !== undefined && object.initChain !== null ? ResponseInitChain.fromPartial(object.initChain) : undefined;
    message.query = object.query !== undefined && object.query !== null ? ResponseQuery.fromPartial(object.query) : undefined;
    message.beginBlock = object.beginBlock !== undefined && object.beginBlock !== null ? ResponseBeginBlock.fromPartial(object.beginBlock) : undefined;
    message.checkTx = object.checkTx !== undefined && object.checkTx !== null ? ResponseCheckTx.fromPartial(object.checkTx) : undefined;
    message.deliverTx = object.deliverTx !== undefined && object.deliverTx !== null ? ResponseDeliverTx.fromPartial(object.deliverTx) : undefined;
    message.endBlock = object.endBlock !== undefined && object.endBlock !== null ? ResponseEndBlock.fromPartial(object.endBlock) : undefined;
    message.commit = object.commit !== undefined && object.commit !== null ? ResponseCommit.fromPartial(object.commit) : undefined;
    message.listSnapshots = object.listSnapshots !== undefined && object.listSnapshots !== null ? ResponseListSnapshots.fromPartial(object.listSnapshots) : undefined;
    message.offerSnapshot = object.offerSnapshot !== undefined && object.offerSnapshot !== null ? ResponseOfferSnapshot.fromPartial(object.offerSnapshot) : undefined;
    message.loadSnapshotChunk = object.loadSnapshotChunk !== undefined && object.loadSnapshotChunk !== null ? ResponseLoadSnapshotChunk.fromPartial(object.loadSnapshotChunk) : undefined;
    message.applySnapshotChunk = object.applySnapshotChunk !== undefined && object.applySnapshotChunk !== null ? ResponseApplySnapshotChunk.fromPartial(object.applySnapshotChunk) : undefined;
    message.prepareProposal = object.prepareProposal !== undefined && object.prepareProposal !== null ? ResponsePrepareProposal.fromPartial(object.prepareProposal) : undefined;
    message.processProposal = object.processProposal !== undefined && object.processProposal !== null ? ResponseProcessProposal.fromPartial(object.processProposal) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      exception: object !== null && object !== void 0 && object.exception ? ResponseException.fromAmino(object.exception) : undefined,
      echo: object !== null && object !== void 0 && object.echo ? ResponseEcho.fromAmino(object.echo) : undefined,
      flush: object !== null && object !== void 0 && object.flush ? ResponseFlush.fromAmino(object.flush) : undefined,
      info: object !== null && object !== void 0 && object.info ? ResponseInfo.fromAmino(object.info) : undefined,
      initChain: object !== null && object !== void 0 && object.init_chain ? ResponseInitChain.fromAmino(object.init_chain) : undefined,
      query: object !== null && object !== void 0 && object.query ? ResponseQuery.fromAmino(object.query) : undefined,
      beginBlock: object !== null && object !== void 0 && object.begin_block ? ResponseBeginBlock.fromAmino(object.begin_block) : undefined,
      checkTx: object !== null && object !== void 0 && object.check_tx ? ResponseCheckTx.fromAmino(object.check_tx) : undefined,
      deliverTx: object !== null && object !== void 0 && object.deliver_tx ? ResponseDeliverTx.fromAmino(object.deliver_tx) : undefined,
      endBlock: object !== null && object !== void 0 && object.end_block ? ResponseEndBlock.fromAmino(object.end_block) : undefined,
      commit: object !== null && object !== void 0 && object.commit ? ResponseCommit.fromAmino(object.commit) : undefined,
      listSnapshots: object !== null && object !== void 0 && object.list_snapshots ? ResponseListSnapshots.fromAmino(object.list_snapshots) : undefined,
      offerSnapshot: object !== null && object !== void 0 && object.offer_snapshot ? ResponseOfferSnapshot.fromAmino(object.offer_snapshot) : undefined,
      loadSnapshotChunk: object !== null && object !== void 0 && object.load_snapshot_chunk ? ResponseLoadSnapshotChunk.fromAmino(object.load_snapshot_chunk) : undefined,
      applySnapshotChunk: object !== null && object !== void 0 && object.apply_snapshot_chunk ? ResponseApplySnapshotChunk.fromAmino(object.apply_snapshot_chunk) : undefined,
      prepareProposal: object !== null && object !== void 0 && object.prepare_proposal ? ResponsePrepareProposal.fromAmino(object.prepare_proposal) : undefined,
      processProposal: object !== null && object !== void 0 && object.process_proposal ? ResponseProcessProposal.fromAmino(object.process_proposal) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.exception = message.exception ? ResponseException.toAmino(message.exception) : undefined;
    obj.echo = message.echo ? ResponseEcho.toAmino(message.echo) : undefined;
    obj.flush = message.flush ? ResponseFlush.toAmino(message.flush) : undefined;
    obj.info = message.info ? ResponseInfo.toAmino(message.info) : undefined;
    obj.init_chain = message.initChain ? ResponseInitChain.toAmino(message.initChain) : undefined;
    obj.query = message.query ? ResponseQuery.toAmino(message.query) : undefined;
    obj.begin_block = message.beginBlock ? ResponseBeginBlock.toAmino(message.beginBlock) : undefined;
    obj.check_tx = message.checkTx ? ResponseCheckTx.toAmino(message.checkTx) : undefined;
    obj.deliver_tx = message.deliverTx ? ResponseDeliverTx.toAmino(message.deliverTx) : undefined;
    obj.end_block = message.endBlock ? ResponseEndBlock.toAmino(message.endBlock) : undefined;
    obj.commit = message.commit ? ResponseCommit.toAmino(message.commit) : undefined;
    obj.list_snapshots = message.listSnapshots ? ResponseListSnapshots.toAmino(message.listSnapshots) : undefined;
    obj.offer_snapshot = message.offerSnapshot ? ResponseOfferSnapshot.toAmino(message.offerSnapshot) : undefined;
    obj.load_snapshot_chunk = message.loadSnapshotChunk ? ResponseLoadSnapshotChunk.toAmino(message.loadSnapshotChunk) : undefined;
    obj.apply_snapshot_chunk = message.applySnapshotChunk ? ResponseApplySnapshotChunk.toAmino(message.applySnapshotChunk) : undefined;
    obj.prepare_proposal = message.prepareProposal ? ResponsePrepareProposal.toAmino(message.prepareProposal) : undefined;
    obj.process_proposal = message.processProposal ? ResponseProcessProposal.toAmino(message.processProposal) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return Response.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return Response.decode(message.value);
  },

  toProto(message) {
    return Response.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/tendermint.abci.Response",
      value: Response.encode(message).finish()
    };
  }

};

function createBaseResponseException() {
  return {
    error: ""
  };
}

const ResponseException = {
  typeUrl: "/tendermint.abci.ResponseException",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    if (message.error !== "") {
      writer.uint32(10).string(message.error);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseResponseException();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.error = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$error;

    const message = createBaseResponseException();
    message.error = (_object$error = object.error) !== null && _object$error !== void 0 ? _object$error : "";
    return message;
  },

  fromAmino(object) {
    return {
      error: object.error
    };
  },

  toAmino(message) {
    const obj = {};
    obj.error = message.error;
    return obj;
  },

  fromAminoMsg(object) {
    return ResponseException.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return ResponseException.decode(message.value);
  },

  toProto(message) {
    return ResponseException.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/tendermint.abci.ResponseException",
      value: ResponseException.encode(message).finish()
    };
  }

};

function createBaseResponseEcho() {
  return {
    message: ""
  };
}

const ResponseEcho = {
  typeUrl: "/tendermint.abci.ResponseEcho",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    if (message.message !== "") {
      writer.uint32(10).string(message.message);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseResponseEcho();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.message = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$message2;

    const message = createBaseResponseEcho();
    message.message = (_object$message2 = object.message) !== null && _object$message2 !== void 0 ? _object$message2 : "";
    return message;
  },

  fromAmino(object) {
    return {
      message: object.message
    };
  },

  toAmino(message) {
    const obj = {};
    obj.message = message.message;
    return obj;
  },

  fromAminoMsg(object) {
    return ResponseEcho.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return ResponseEcho.decode(message.value);
  },

  toProto(message) {
    return ResponseEcho.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/tendermint.abci.ResponseEcho",
      value: ResponseEcho.encode(message).finish()
    };
  }

};

function createBaseResponseFlush() {
  return {};
}

const ResponseFlush = {
  typeUrl: "/tendermint.abci.ResponseFlush",

  encode(_, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseResponseFlush();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseResponseFlush();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return ResponseFlush.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return ResponseFlush.decode(message.value);
  },

  toProto(message) {
    return ResponseFlush.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/tendermint.abci.ResponseFlush",
      value: ResponseFlush.encode(message).finish()
    };
  }

};

function createBaseResponseInfo() {
  return {
    data: "",
    version: "",
    appVersion: _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.UZERO */ .dK.UZERO,
    lastBlockHeight: _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.ZERO */ .dK.ZERO,
    lastBlockAppHash: new Uint8Array()
  };
}

const ResponseInfo = {
  typeUrl: "/tendermint.abci.ResponseInfo",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    if (message.data !== "") {
      writer.uint32(10).string(message.data);
    }

    if (message.version !== "") {
      writer.uint32(18).string(message.version);
    }

    if (!message.appVersion.isZero()) {
      writer.uint32(24).uint64(message.appVersion);
    }

    if (!message.lastBlockHeight.isZero()) {
      writer.uint32(32).int64(message.lastBlockHeight);
    }

    if (message.lastBlockAppHash.length !== 0) {
      writer.uint32(42).bytes(message.lastBlockAppHash);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseResponseInfo();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.data = reader.string();
          break;

        case 2:
          message.version = reader.string();
          break;

        case 3:
          message.appVersion = reader.uint64();
          break;

        case 4:
          message.lastBlockHeight = reader.int64();
          break;

        case 5:
          message.lastBlockAppHash = reader.bytes();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$data2, _object$version2, _object$lastBlockAppH;

    const message = createBaseResponseInfo();
    message.data = (_object$data2 = object.data) !== null && _object$data2 !== void 0 ? _object$data2 : "";
    message.version = (_object$version2 = object.version) !== null && _object$version2 !== void 0 ? _object$version2 : "";
    message.appVersion = object.appVersion !== undefined && object.appVersion !== null ? _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.fromValue */ .dK.fromValue(object.appVersion) : _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.UZERO */ .dK.UZERO;
    message.lastBlockHeight = object.lastBlockHeight !== undefined && object.lastBlockHeight !== null ? _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.fromValue */ .dK.fromValue(object.lastBlockHeight) : _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.ZERO */ .dK.ZERO;
    message.lastBlockAppHash = (_object$lastBlockAppH = object.lastBlockAppHash) !== null && _object$lastBlockAppH !== void 0 ? _object$lastBlockAppH : new Uint8Array();
    return message;
  },

  fromAmino(object) {
    return {
      data: object.data,
      version: object.version,
      appVersion: _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.fromString */ .dK.fromString(object.app_version),
      lastBlockHeight: _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.fromString */ .dK.fromString(object.last_block_height),
      lastBlockAppHash: object.last_block_app_hash
    };
  },

  toAmino(message) {
    const obj = {};
    obj.data = message.data;
    obj.version = message.version;
    obj.app_version = message.appVersion ? message.appVersion.toString() : undefined;
    obj.last_block_height = message.lastBlockHeight ? message.lastBlockHeight.toString() : undefined;
    obj.last_block_app_hash = message.lastBlockAppHash;
    return obj;
  },

  fromAminoMsg(object) {
    return ResponseInfo.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return ResponseInfo.decode(message.value);
  },

  toProto(message) {
    return ResponseInfo.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/tendermint.abci.ResponseInfo",
      value: ResponseInfo.encode(message).finish()
    };
  }

};

function createBaseResponseInitChain() {
  return {
    consensusParams: undefined,
    validators: [],
    appHash: new Uint8Array()
  };
}

const ResponseInitChain = {
  typeUrl: "/tendermint.abci.ResponseInitChain",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    if (message.consensusParams !== undefined) {
      _types_params__WEBPACK_IMPORTED_MODULE_1__.ConsensusParams.encode(message.consensusParams, writer.uint32(10).fork()).ldelim();
    }

    for (const v of message.validators) {
      ValidatorUpdate.encode(v, writer.uint32(18).fork()).ldelim();
    }

    if (message.appHash.length !== 0) {
      writer.uint32(26).bytes(message.appHash);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseResponseInitChain();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.consensusParams = _types_params__WEBPACK_IMPORTED_MODULE_1__.ConsensusParams.decode(reader, reader.uint32());
          break;

        case 2:
          message.validators.push(ValidatorUpdate.decode(reader, reader.uint32()));
          break;

        case 3:
          message.appHash = reader.bytes();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$validators2, _object$appHash2;

    const message = createBaseResponseInitChain();
    message.consensusParams = object.consensusParams !== undefined && object.consensusParams !== null ? _types_params__WEBPACK_IMPORTED_MODULE_1__.ConsensusParams.fromPartial(object.consensusParams) : undefined;
    message.validators = ((_object$validators2 = object.validators) === null || _object$validators2 === void 0 ? void 0 : _object$validators2.map(e => ValidatorUpdate.fromPartial(e))) || [];
    message.appHash = (_object$appHash2 = object.appHash) !== null && _object$appHash2 !== void 0 ? _object$appHash2 : new Uint8Array();
    return message;
  },

  fromAmino(object) {
    return {
      consensusParams: object !== null && object !== void 0 && object.consensus_params ? _types_params__WEBPACK_IMPORTED_MODULE_1__.ConsensusParams.fromAmino(object.consensus_params) : undefined,
      validators: Array.isArray(object === null || object === void 0 ? void 0 : object.validators) ? object.validators.map(e => ValidatorUpdate.fromAmino(e)) : [],
      appHash: object.app_hash
    };
  },

  toAmino(message) {
    const obj = {};
    obj.consensus_params = message.consensusParams ? _types_params__WEBPACK_IMPORTED_MODULE_1__.ConsensusParams.toAmino(message.consensusParams) : undefined;

    if (message.validators) {
      obj.validators = message.validators.map(e => e ? ValidatorUpdate.toAmino(e) : undefined);
    } else {
      obj.validators = [];
    }

    obj.app_hash = message.appHash;
    return obj;
  },

  fromAminoMsg(object) {
    return ResponseInitChain.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return ResponseInitChain.decode(message.value);
  },

  toProto(message) {
    return ResponseInitChain.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/tendermint.abci.ResponseInitChain",
      value: ResponseInitChain.encode(message).finish()
    };
  }

};

function createBaseResponseQuery() {
  return {
    code: 0,
    log: "",
    info: "",
    index: _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.ZERO */ .dK.ZERO,
    key: new Uint8Array(),
    value: new Uint8Array(),
    proofOps: undefined,
    height: _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.ZERO */ .dK.ZERO,
    codespace: ""
  };
}

const ResponseQuery = {
  typeUrl: "/tendermint.abci.ResponseQuery",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    if (message.code !== 0) {
      writer.uint32(8).uint32(message.code);
    }

    if (message.log !== "") {
      writer.uint32(26).string(message.log);
    }

    if (message.info !== "") {
      writer.uint32(34).string(message.info);
    }

    if (!message.index.isZero()) {
      writer.uint32(40).int64(message.index);
    }

    if (message.key.length !== 0) {
      writer.uint32(50).bytes(message.key);
    }

    if (message.value.length !== 0) {
      writer.uint32(58).bytes(message.value);
    }

    if (message.proofOps !== undefined) {
      _crypto_proof__WEBPACK_IMPORTED_MODULE_3__.ProofOps.encode(message.proofOps, writer.uint32(66).fork()).ldelim();
    }

    if (!message.height.isZero()) {
      writer.uint32(72).int64(message.height);
    }

    if (message.codespace !== "") {
      writer.uint32(82).string(message.codespace);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseResponseQuery();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.code = reader.uint32();
          break;

        case 3:
          message.log = reader.string();
          break;

        case 4:
          message.info = reader.string();
          break;

        case 5:
          message.index = reader.int64();
          break;

        case 6:
          message.key = reader.bytes();
          break;

        case 7:
          message.value = reader.bytes();
          break;

        case 8:
          message.proofOps = _crypto_proof__WEBPACK_IMPORTED_MODULE_3__.ProofOps.decode(reader, reader.uint32());
          break;

        case 9:
          message.height = reader.int64();
          break;

        case 10:
          message.codespace = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$code, _object$log, _object$info, _object$key, _object$value, _object$codespace;

    const message = createBaseResponseQuery();
    message.code = (_object$code = object.code) !== null && _object$code !== void 0 ? _object$code : 0;
    message.log = (_object$log = object.log) !== null && _object$log !== void 0 ? _object$log : "";
    message.info = (_object$info = object.info) !== null && _object$info !== void 0 ? _object$info : "";
    message.index = object.index !== undefined && object.index !== null ? _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.fromValue */ .dK.fromValue(object.index) : _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.ZERO */ .dK.ZERO;
    message.key = (_object$key = object.key) !== null && _object$key !== void 0 ? _object$key : new Uint8Array();
    message.value = (_object$value = object.value) !== null && _object$value !== void 0 ? _object$value : new Uint8Array();
    message.proofOps = object.proofOps !== undefined && object.proofOps !== null ? _crypto_proof__WEBPACK_IMPORTED_MODULE_3__.ProofOps.fromPartial(object.proofOps) : undefined;
    message.height = object.height !== undefined && object.height !== null ? _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.fromValue */ .dK.fromValue(object.height) : _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.ZERO */ .dK.ZERO;
    message.codespace = (_object$codespace = object.codespace) !== null && _object$codespace !== void 0 ? _object$codespace : "";
    return message;
  },

  fromAmino(object) {
    return {
      code: object.code,
      log: object.log,
      info: object.info,
      index: _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.fromString */ .dK.fromString(object.index),
      key: object.key,
      value: object.value,
      proofOps: object !== null && object !== void 0 && object.proof_ops ? _crypto_proof__WEBPACK_IMPORTED_MODULE_3__.ProofOps.fromAmino(object.proof_ops) : undefined,
      height: _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.fromString */ .dK.fromString(object.height),
      codespace: object.codespace
    };
  },

  toAmino(message) {
    const obj = {};
    obj.code = message.code;
    obj.log = message.log;
    obj.info = message.info;
    obj.index = message.index ? message.index.toString() : undefined;
    obj.key = message.key;
    obj.value = message.value;
    obj.proof_ops = message.proofOps ? _crypto_proof__WEBPACK_IMPORTED_MODULE_3__.ProofOps.toAmino(message.proofOps) : undefined;
    obj.height = message.height ? message.height.toString() : undefined;
    obj.codespace = message.codespace;
    return obj;
  },

  fromAminoMsg(object) {
    return ResponseQuery.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return ResponseQuery.decode(message.value);
  },

  toProto(message) {
    return ResponseQuery.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/tendermint.abci.ResponseQuery",
      value: ResponseQuery.encode(message).finish()
    };
  }

};

function createBaseResponseBeginBlock() {
  return {
    events: []
  };
}

const ResponseBeginBlock = {
  typeUrl: "/tendermint.abci.ResponseBeginBlock",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    for (const v of message.events) {
      Event.encode(v, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseResponseBeginBlock();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.events.push(Event.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$events;

    const message = createBaseResponseBeginBlock();
    message.events = ((_object$events = object.events) === null || _object$events === void 0 ? void 0 : _object$events.map(e => Event.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      events: Array.isArray(object === null || object === void 0 ? void 0 : object.events) ? object.events.map(e => Event.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.events) {
      obj.events = message.events.map(e => e ? Event.toAmino(e) : undefined);
    } else {
      obj.events = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return ResponseBeginBlock.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return ResponseBeginBlock.decode(message.value);
  },

  toProto(message) {
    return ResponseBeginBlock.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/tendermint.abci.ResponseBeginBlock",
      value: ResponseBeginBlock.encode(message).finish()
    };
  }

};

function createBaseResponseCheckTx() {
  return {
    code: 0,
    data: new Uint8Array(),
    log: "",
    info: "",
    gasWanted: _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.ZERO */ .dK.ZERO,
    gasUsed: _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.ZERO */ .dK.ZERO,
    events: [],
    codespace: "",
    sender: "",
    priority: _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.ZERO */ .dK.ZERO,
    mempoolError: ""
  };
}

const ResponseCheckTx = {
  typeUrl: "/tendermint.abci.ResponseCheckTx",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    if (message.code !== 0) {
      writer.uint32(8).uint32(message.code);
    }

    if (message.data.length !== 0) {
      writer.uint32(18).bytes(message.data);
    }

    if (message.log !== "") {
      writer.uint32(26).string(message.log);
    }

    if (message.info !== "") {
      writer.uint32(34).string(message.info);
    }

    if (!message.gasWanted.isZero()) {
      writer.uint32(40).int64(message.gasWanted);
    }

    if (!message.gasUsed.isZero()) {
      writer.uint32(48).int64(message.gasUsed);
    }

    for (const v of message.events) {
      Event.encode(v, writer.uint32(58).fork()).ldelim();
    }

    if (message.codespace !== "") {
      writer.uint32(66).string(message.codespace);
    }

    if (message.sender !== "") {
      writer.uint32(74).string(message.sender);
    }

    if (!message.priority.isZero()) {
      writer.uint32(80).int64(message.priority);
    }

    if (message.mempoolError !== "") {
      writer.uint32(90).string(message.mempoolError);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseResponseCheckTx();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.code = reader.uint32();
          break;

        case 2:
          message.data = reader.bytes();
          break;

        case 3:
          message.log = reader.string();
          break;

        case 4:
          message.info = reader.string();
          break;

        case 5:
          message.gasWanted = reader.int64();
          break;

        case 6:
          message.gasUsed = reader.int64();
          break;

        case 7:
          message.events.push(Event.decode(reader, reader.uint32()));
          break;

        case 8:
          message.codespace = reader.string();
          break;

        case 9:
          message.sender = reader.string();
          break;

        case 10:
          message.priority = reader.int64();
          break;

        case 11:
          message.mempoolError = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$code2, _object$data3, _object$log2, _object$info2, _object$events2, _object$codespace2, _object$sender2, _object$mempoolError;

    const message = createBaseResponseCheckTx();
    message.code = (_object$code2 = object.code) !== null && _object$code2 !== void 0 ? _object$code2 : 0;
    message.data = (_object$data3 = object.data) !== null && _object$data3 !== void 0 ? _object$data3 : new Uint8Array();
    message.log = (_object$log2 = object.log) !== null && _object$log2 !== void 0 ? _object$log2 : "";
    message.info = (_object$info2 = object.info) !== null && _object$info2 !== void 0 ? _object$info2 : "";
    message.gasWanted = object.gasWanted !== undefined && object.gasWanted !== null ? _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.fromValue */ .dK.fromValue(object.gasWanted) : _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.ZERO */ .dK.ZERO;
    message.gasUsed = object.gasUsed !== undefined && object.gasUsed !== null ? _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.fromValue */ .dK.fromValue(object.gasUsed) : _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.ZERO */ .dK.ZERO;
    message.events = ((_object$events2 = object.events) === null || _object$events2 === void 0 ? void 0 : _object$events2.map(e => Event.fromPartial(e))) || [];
    message.codespace = (_object$codespace2 = object.codespace) !== null && _object$codespace2 !== void 0 ? _object$codespace2 : "";
    message.sender = (_object$sender2 = object.sender) !== null && _object$sender2 !== void 0 ? _object$sender2 : "";
    message.priority = object.priority !== undefined && object.priority !== null ? _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.fromValue */ .dK.fromValue(object.priority) : _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.ZERO */ .dK.ZERO;
    message.mempoolError = (_object$mempoolError = object.mempoolError) !== null && _object$mempoolError !== void 0 ? _object$mempoolError : "";
    return message;
  },

  fromAmino(object) {
    return {
      code: object.code,
      data: object.data,
      log: object.log,
      info: object.info,
      gasWanted: _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.fromString */ .dK.fromString(object.gas_wanted),
      gasUsed: _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.fromString */ .dK.fromString(object.gas_used),
      events: Array.isArray(object === null || object === void 0 ? void 0 : object.events) ? object.events.map(e => Event.fromAmino(e)) : [],
      codespace: object.codespace,
      sender: object.sender,
      priority: _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.fromString */ .dK.fromString(object.priority),
      mempoolError: object.mempool_error
    };
  },

  toAmino(message) {
    const obj = {};
    obj.code = message.code;
    obj.data = message.data;
    obj.log = message.log;
    obj.info = message.info;
    obj.gas_wanted = message.gasWanted ? message.gasWanted.toString() : undefined;
    obj.gas_used = message.gasUsed ? message.gasUsed.toString() : undefined;

    if (message.events) {
      obj.events = message.events.map(e => e ? Event.toAmino(e) : undefined);
    } else {
      obj.events = [];
    }

    obj.codespace = message.codespace;
    obj.sender = message.sender;
    obj.priority = message.priority ? message.priority.toString() : undefined;
    obj.mempool_error = message.mempoolError;
    return obj;
  },

  fromAminoMsg(object) {
    return ResponseCheckTx.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return ResponseCheckTx.decode(message.value);
  },

  toProto(message) {
    return ResponseCheckTx.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/tendermint.abci.ResponseCheckTx",
      value: ResponseCheckTx.encode(message).finish()
    };
  }

};

function createBaseResponseDeliverTx() {
  return {
    code: 0,
    data: new Uint8Array(),
    log: "",
    info: "",
    gasWanted: _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.ZERO */ .dK.ZERO,
    gasUsed: _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.ZERO */ .dK.ZERO,
    events: [],
    codespace: ""
  };
}

const ResponseDeliverTx = {
  typeUrl: "/tendermint.abci.ResponseDeliverTx",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    if (message.code !== 0) {
      writer.uint32(8).uint32(message.code);
    }

    if (message.data.length !== 0) {
      writer.uint32(18).bytes(message.data);
    }

    if (message.log !== "") {
      writer.uint32(26).string(message.log);
    }

    if (message.info !== "") {
      writer.uint32(34).string(message.info);
    }

    if (!message.gasWanted.isZero()) {
      writer.uint32(40).int64(message.gasWanted);
    }

    if (!message.gasUsed.isZero()) {
      writer.uint32(48).int64(message.gasUsed);
    }

    for (const v of message.events) {
      Event.encode(v, writer.uint32(58).fork()).ldelim();
    }

    if (message.codespace !== "") {
      writer.uint32(66).string(message.codespace);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseResponseDeliverTx();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.code = reader.uint32();
          break;

        case 2:
          message.data = reader.bytes();
          break;

        case 3:
          message.log = reader.string();
          break;

        case 4:
          message.info = reader.string();
          break;

        case 5:
          message.gasWanted = reader.int64();
          break;

        case 6:
          message.gasUsed = reader.int64();
          break;

        case 7:
          message.events.push(Event.decode(reader, reader.uint32()));
          break;

        case 8:
          message.codespace = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$code3, _object$data4, _object$log3, _object$info3, _object$events3, _object$codespace3;

    const message = createBaseResponseDeliverTx();
    message.code = (_object$code3 = object.code) !== null && _object$code3 !== void 0 ? _object$code3 : 0;
    message.data = (_object$data4 = object.data) !== null && _object$data4 !== void 0 ? _object$data4 : new Uint8Array();
    message.log = (_object$log3 = object.log) !== null && _object$log3 !== void 0 ? _object$log3 : "";
    message.info = (_object$info3 = object.info) !== null && _object$info3 !== void 0 ? _object$info3 : "";
    message.gasWanted = object.gasWanted !== undefined && object.gasWanted !== null ? _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.fromValue */ .dK.fromValue(object.gasWanted) : _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.ZERO */ .dK.ZERO;
    message.gasUsed = object.gasUsed !== undefined && object.gasUsed !== null ? _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.fromValue */ .dK.fromValue(object.gasUsed) : _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.ZERO */ .dK.ZERO;
    message.events = ((_object$events3 = object.events) === null || _object$events3 === void 0 ? void 0 : _object$events3.map(e => Event.fromPartial(e))) || [];
    message.codespace = (_object$codespace3 = object.codespace) !== null && _object$codespace3 !== void 0 ? _object$codespace3 : "";
    return message;
  },

  fromAmino(object) {
    return {
      code: object.code,
      data: object.data,
      log: object.log,
      info: object.info,
      gasWanted: _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.fromString */ .dK.fromString(object.gas_wanted),
      gasUsed: _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.fromString */ .dK.fromString(object.gas_used),
      events: Array.isArray(object === null || object === void 0 ? void 0 : object.events) ? object.events.map(e => Event.fromAmino(e)) : [],
      codespace: object.codespace
    };
  },

  toAmino(message) {
    const obj = {};
    obj.code = message.code;
    obj.data = message.data;
    obj.log = message.log;
    obj.info = message.info;
    obj.gas_wanted = message.gasWanted ? message.gasWanted.toString() : undefined;
    obj.gas_used = message.gasUsed ? message.gasUsed.toString() : undefined;

    if (message.events) {
      obj.events = message.events.map(e => e ? Event.toAmino(e) : undefined);
    } else {
      obj.events = [];
    }

    obj.codespace = message.codespace;
    return obj;
  },

  fromAminoMsg(object) {
    return ResponseDeliverTx.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return ResponseDeliverTx.decode(message.value);
  },

  toProto(message) {
    return ResponseDeliverTx.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/tendermint.abci.ResponseDeliverTx",
      value: ResponseDeliverTx.encode(message).finish()
    };
  }

};

function createBaseResponseEndBlock() {
  return {
    validatorUpdates: [],
    consensusParamUpdates: undefined,
    events: []
  };
}

const ResponseEndBlock = {
  typeUrl: "/tendermint.abci.ResponseEndBlock",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    for (const v of message.validatorUpdates) {
      ValidatorUpdate.encode(v, writer.uint32(10).fork()).ldelim();
    }

    if (message.consensusParamUpdates !== undefined) {
      _types_params__WEBPACK_IMPORTED_MODULE_1__.ConsensusParams.encode(message.consensusParamUpdates, writer.uint32(18).fork()).ldelim();
    }

    for (const v of message.events) {
      Event.encode(v, writer.uint32(26).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseResponseEndBlock();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.validatorUpdates.push(ValidatorUpdate.decode(reader, reader.uint32()));
          break;

        case 2:
          message.consensusParamUpdates = _types_params__WEBPACK_IMPORTED_MODULE_1__.ConsensusParams.decode(reader, reader.uint32());
          break;

        case 3:
          message.events.push(Event.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$validatorUpda, _object$events4;

    const message = createBaseResponseEndBlock();
    message.validatorUpdates = ((_object$validatorUpda = object.validatorUpdates) === null || _object$validatorUpda === void 0 ? void 0 : _object$validatorUpda.map(e => ValidatorUpdate.fromPartial(e))) || [];
    message.consensusParamUpdates = object.consensusParamUpdates !== undefined && object.consensusParamUpdates !== null ? _types_params__WEBPACK_IMPORTED_MODULE_1__.ConsensusParams.fromPartial(object.consensusParamUpdates) : undefined;
    message.events = ((_object$events4 = object.events) === null || _object$events4 === void 0 ? void 0 : _object$events4.map(e => Event.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      validatorUpdates: Array.isArray(object === null || object === void 0 ? void 0 : object.validator_updates) ? object.validator_updates.map(e => ValidatorUpdate.fromAmino(e)) : [],
      consensusParamUpdates: object !== null && object !== void 0 && object.consensus_param_updates ? _types_params__WEBPACK_IMPORTED_MODULE_1__.ConsensusParams.fromAmino(object.consensus_param_updates) : undefined,
      events: Array.isArray(object === null || object === void 0 ? void 0 : object.events) ? object.events.map(e => Event.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.validatorUpdates) {
      obj.validator_updates = message.validatorUpdates.map(e => e ? ValidatorUpdate.toAmino(e) : undefined);
    } else {
      obj.validator_updates = [];
    }

    obj.consensus_param_updates = message.consensusParamUpdates ? _types_params__WEBPACK_IMPORTED_MODULE_1__.ConsensusParams.toAmino(message.consensusParamUpdates) : undefined;

    if (message.events) {
      obj.events = message.events.map(e => e ? Event.toAmino(e) : undefined);
    } else {
      obj.events = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return ResponseEndBlock.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return ResponseEndBlock.decode(message.value);
  },

  toProto(message) {
    return ResponseEndBlock.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/tendermint.abci.ResponseEndBlock",
      value: ResponseEndBlock.encode(message).finish()
    };
  }

};

function createBaseResponseCommit() {
  return {
    data: new Uint8Array(),
    retainHeight: _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.ZERO */ .dK.ZERO
  };
}

const ResponseCommit = {
  typeUrl: "/tendermint.abci.ResponseCommit",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    if (message.data.length !== 0) {
      writer.uint32(18).bytes(message.data);
    }

    if (!message.retainHeight.isZero()) {
      writer.uint32(24).int64(message.retainHeight);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseResponseCommit();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 2:
          message.data = reader.bytes();
          break;

        case 3:
          message.retainHeight = reader.int64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$data5;

    const message = createBaseResponseCommit();
    message.data = (_object$data5 = object.data) !== null && _object$data5 !== void 0 ? _object$data5 : new Uint8Array();
    message.retainHeight = object.retainHeight !== undefined && object.retainHeight !== null ? _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.fromValue */ .dK.fromValue(object.retainHeight) : _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.ZERO */ .dK.ZERO;
    return message;
  },

  fromAmino(object) {
    return {
      data: object.data,
      retainHeight: _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.fromString */ .dK.fromString(object.retain_height)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.data = message.data;
    obj.retain_height = message.retainHeight ? message.retainHeight.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return ResponseCommit.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return ResponseCommit.decode(message.value);
  },

  toProto(message) {
    return ResponseCommit.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/tendermint.abci.ResponseCommit",
      value: ResponseCommit.encode(message).finish()
    };
  }

};

function createBaseResponseListSnapshots() {
  return {
    snapshots: []
  };
}

const ResponseListSnapshots = {
  typeUrl: "/tendermint.abci.ResponseListSnapshots",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    for (const v of message.snapshots) {
      Snapshot.encode(v, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseResponseListSnapshots();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.snapshots.push(Snapshot.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$snapshots;

    const message = createBaseResponseListSnapshots();
    message.snapshots = ((_object$snapshots = object.snapshots) === null || _object$snapshots === void 0 ? void 0 : _object$snapshots.map(e => Snapshot.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      snapshots: Array.isArray(object === null || object === void 0 ? void 0 : object.snapshots) ? object.snapshots.map(e => Snapshot.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.snapshots) {
      obj.snapshots = message.snapshots.map(e => e ? Snapshot.toAmino(e) : undefined);
    } else {
      obj.snapshots = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return ResponseListSnapshots.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return ResponseListSnapshots.decode(message.value);
  },

  toProto(message) {
    return ResponseListSnapshots.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/tendermint.abci.ResponseListSnapshots",
      value: ResponseListSnapshots.encode(message).finish()
    };
  }

};

function createBaseResponseOfferSnapshot() {
  return {
    result: 0
  };
}

const ResponseOfferSnapshot = {
  typeUrl: "/tendermint.abci.ResponseOfferSnapshot",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    if (message.result !== 0) {
      writer.uint32(8).int32(message.result);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseResponseOfferSnapshot();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.result = reader.int32();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$result;

    const message = createBaseResponseOfferSnapshot();
    message.result = (_object$result = object.result) !== null && _object$result !== void 0 ? _object$result : 0;
    return message;
  },

  fromAmino(object) {
    return {
      result: (0,_helpers__WEBPACK_IMPORTED_MODULE_5__/* .isSet */ .DM)(object.result) ? responseOfferSnapshot_ResultFromJSON(object.result) : 0
    };
  },

  toAmino(message) {
    const obj = {};
    obj.result = message.result;
    return obj;
  },

  fromAminoMsg(object) {
    return ResponseOfferSnapshot.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return ResponseOfferSnapshot.decode(message.value);
  },

  toProto(message) {
    return ResponseOfferSnapshot.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/tendermint.abci.ResponseOfferSnapshot",
      value: ResponseOfferSnapshot.encode(message).finish()
    };
  }

};

function createBaseResponseLoadSnapshotChunk() {
  return {
    chunk: new Uint8Array()
  };
}

const ResponseLoadSnapshotChunk = {
  typeUrl: "/tendermint.abci.ResponseLoadSnapshotChunk",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    if (message.chunk.length !== 0) {
      writer.uint32(10).bytes(message.chunk);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseResponseLoadSnapshotChunk();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.chunk = reader.bytes();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$chunk3;

    const message = createBaseResponseLoadSnapshotChunk();
    message.chunk = (_object$chunk3 = object.chunk) !== null && _object$chunk3 !== void 0 ? _object$chunk3 : new Uint8Array();
    return message;
  },

  fromAmino(object) {
    return {
      chunk: object.chunk
    };
  },

  toAmino(message) {
    const obj = {};
    obj.chunk = message.chunk;
    return obj;
  },

  fromAminoMsg(object) {
    return ResponseLoadSnapshotChunk.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return ResponseLoadSnapshotChunk.decode(message.value);
  },

  toProto(message) {
    return ResponseLoadSnapshotChunk.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/tendermint.abci.ResponseLoadSnapshotChunk",
      value: ResponseLoadSnapshotChunk.encode(message).finish()
    };
  }

};

function createBaseResponseApplySnapshotChunk() {
  return {
    result: 0,
    refetchChunks: [],
    rejectSenders: []
  };
}

const ResponseApplySnapshotChunk = {
  typeUrl: "/tendermint.abci.ResponseApplySnapshotChunk",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    if (message.result !== 0) {
      writer.uint32(8).int32(message.result);
    }

    writer.uint32(18).fork();

    for (const v of message.refetchChunks) {
      writer.uint32(v);
    }

    writer.ldelim();

    for (const v of message.rejectSenders) {
      writer.uint32(26).string(v);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseResponseApplySnapshotChunk();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.result = reader.int32();
          break;

        case 2:
          if ((tag & 7) === 2) {
            const end2 = reader.uint32() + reader.pos;

            while (reader.pos < end2) {
              message.refetchChunks.push(reader.uint32());
            }
          } else {
            message.refetchChunks.push(reader.uint32());
          }

          break;

        case 3:
          message.rejectSenders.push(reader.string());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$result2, _object$refetchChunks, _object$rejectSenders;

    const message = createBaseResponseApplySnapshotChunk();
    message.result = (_object$result2 = object.result) !== null && _object$result2 !== void 0 ? _object$result2 : 0;
    message.refetchChunks = ((_object$refetchChunks = object.refetchChunks) === null || _object$refetchChunks === void 0 ? void 0 : _object$refetchChunks.map(e => e)) || [];
    message.rejectSenders = ((_object$rejectSenders = object.rejectSenders) === null || _object$rejectSenders === void 0 ? void 0 : _object$rejectSenders.map(e => e)) || [];
    return message;
  },

  fromAmino(object) {
    return {
      result: (0,_helpers__WEBPACK_IMPORTED_MODULE_5__/* .isSet */ .DM)(object.result) ? responseApplySnapshotChunk_ResultFromJSON(object.result) : 0,
      refetchChunks: Array.isArray(object === null || object === void 0 ? void 0 : object.refetch_chunks) ? object.refetch_chunks.map(e => e) : [],
      rejectSenders: Array.isArray(object === null || object === void 0 ? void 0 : object.reject_senders) ? object.reject_senders.map(e => e) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.result = message.result;

    if (message.refetchChunks) {
      obj.refetch_chunks = message.refetchChunks.map(e => e);
    } else {
      obj.refetch_chunks = [];
    }

    if (message.rejectSenders) {
      obj.reject_senders = message.rejectSenders.map(e => e);
    } else {
      obj.reject_senders = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return ResponseApplySnapshotChunk.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return ResponseApplySnapshotChunk.decode(message.value);
  },

  toProto(message) {
    return ResponseApplySnapshotChunk.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/tendermint.abci.ResponseApplySnapshotChunk",
      value: ResponseApplySnapshotChunk.encode(message).finish()
    };
  }

};

function createBaseResponsePrepareProposal() {
  return {
    txs: []
  };
}

const ResponsePrepareProposal = {
  typeUrl: "/tendermint.abci.ResponsePrepareProposal",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    for (const v of message.txs) {
      writer.uint32(10).bytes(v);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseResponsePrepareProposal();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.txs.push(reader.bytes());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$txs3;

    const message = createBaseResponsePrepareProposal();
    message.txs = ((_object$txs3 = object.txs) === null || _object$txs3 === void 0 ? void 0 : _object$txs3.map(e => e)) || [];
    return message;
  },

  fromAmino(object) {
    return {
      txs: Array.isArray(object === null || object === void 0 ? void 0 : object.txs) ? object.txs.map(e => e) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.txs) {
      obj.txs = message.txs.map(e => e);
    } else {
      obj.txs = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return ResponsePrepareProposal.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return ResponsePrepareProposal.decode(message.value);
  },

  toProto(message) {
    return ResponsePrepareProposal.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/tendermint.abci.ResponsePrepareProposal",
      value: ResponsePrepareProposal.encode(message).finish()
    };
  }

};

function createBaseResponseProcessProposal() {
  return {
    status: 0
  };
}

const ResponseProcessProposal = {
  typeUrl: "/tendermint.abci.ResponseProcessProposal",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    if (message.status !== 0) {
      writer.uint32(8).int32(message.status);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseResponseProcessProposal();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.status = reader.int32();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$status;

    const message = createBaseResponseProcessProposal();
    message.status = (_object$status = object.status) !== null && _object$status !== void 0 ? _object$status : 0;
    return message;
  },

  fromAmino(object) {
    return {
      status: (0,_helpers__WEBPACK_IMPORTED_MODULE_5__/* .isSet */ .DM)(object.status) ? responseProcessProposal_ProposalStatusFromJSON(object.status) : 0
    };
  },

  toAmino(message) {
    const obj = {};
    obj.status = message.status;
    return obj;
  },

  fromAminoMsg(object) {
    return ResponseProcessProposal.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return ResponseProcessProposal.decode(message.value);
  },

  toProto(message) {
    return ResponseProcessProposal.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/tendermint.abci.ResponseProcessProposal",
      value: ResponseProcessProposal.encode(message).finish()
    };
  }

};

function createBaseCommitInfo() {
  return {
    round: 0,
    votes: []
  };
}

const CommitInfo = {
  typeUrl: "/tendermint.abci.CommitInfo",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    if (message.round !== 0) {
      writer.uint32(8).int32(message.round);
    }

    for (const v of message.votes) {
      VoteInfo.encode(v, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCommitInfo();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.round = reader.int32();
          break;

        case 2:
          message.votes.push(VoteInfo.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$round, _object$votes;

    const message = createBaseCommitInfo();
    message.round = (_object$round = object.round) !== null && _object$round !== void 0 ? _object$round : 0;
    message.votes = ((_object$votes = object.votes) === null || _object$votes === void 0 ? void 0 : _object$votes.map(e => VoteInfo.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      round: object.round,
      votes: Array.isArray(object === null || object === void 0 ? void 0 : object.votes) ? object.votes.map(e => VoteInfo.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.round = message.round;

    if (message.votes) {
      obj.votes = message.votes.map(e => e ? VoteInfo.toAmino(e) : undefined);
    } else {
      obj.votes = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return CommitInfo.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return CommitInfo.decode(message.value);
  },

  toProto(message) {
    return CommitInfo.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/tendermint.abci.CommitInfo",
      value: CommitInfo.encode(message).finish()
    };
  }

};

function createBaseExtendedCommitInfo() {
  return {
    round: 0,
    votes: []
  };
}

const ExtendedCommitInfo = {
  typeUrl: "/tendermint.abci.ExtendedCommitInfo",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    if (message.round !== 0) {
      writer.uint32(8).int32(message.round);
    }

    for (const v of message.votes) {
      ExtendedVoteInfo.encode(v, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseExtendedCommitInfo();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.round = reader.int32();
          break;

        case 2:
          message.votes.push(ExtendedVoteInfo.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$round2, _object$votes2;

    const message = createBaseExtendedCommitInfo();
    message.round = (_object$round2 = object.round) !== null && _object$round2 !== void 0 ? _object$round2 : 0;
    message.votes = ((_object$votes2 = object.votes) === null || _object$votes2 === void 0 ? void 0 : _object$votes2.map(e => ExtendedVoteInfo.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      round: object.round,
      votes: Array.isArray(object === null || object === void 0 ? void 0 : object.votes) ? object.votes.map(e => ExtendedVoteInfo.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.round = message.round;

    if (message.votes) {
      obj.votes = message.votes.map(e => e ? ExtendedVoteInfo.toAmino(e) : undefined);
    } else {
      obj.votes = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return ExtendedCommitInfo.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return ExtendedCommitInfo.decode(message.value);
  },

  toProto(message) {
    return ExtendedCommitInfo.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/tendermint.abci.ExtendedCommitInfo",
      value: ExtendedCommitInfo.encode(message).finish()
    };
  }

};

function createBaseEvent() {
  return {
    type: "",
    attributes: []
  };
}

const Event = {
  typeUrl: "/tendermint.abci.Event",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    if (message.type !== "") {
      writer.uint32(10).string(message.type);
    }

    for (const v of message.attributes) {
      EventAttribute.encode(v, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEvent();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.type = reader.string();
          break;

        case 2:
          message.attributes.push(EventAttribute.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$type2, _object$attributes;

    const message = createBaseEvent();
    message.type = (_object$type2 = object.type) !== null && _object$type2 !== void 0 ? _object$type2 : "";
    message.attributes = ((_object$attributes = object.attributes) === null || _object$attributes === void 0 ? void 0 : _object$attributes.map(e => EventAttribute.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      type: object.type,
      attributes: Array.isArray(object === null || object === void 0 ? void 0 : object.attributes) ? object.attributes.map(e => EventAttribute.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.type = message.type;

    if (message.attributes) {
      obj.attributes = message.attributes.map(e => e ? EventAttribute.toAmino(e) : undefined);
    } else {
      obj.attributes = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return Event.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return Event.decode(message.value);
  },

  toProto(message) {
    return Event.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/tendermint.abci.Event",
      value: Event.encode(message).finish()
    };
  }

};

function createBaseEventAttribute() {
  return {
    key: "",
    value: "",
    index: false
  };
}

const EventAttribute = {
  typeUrl: "/tendermint.abci.EventAttribute",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }

    if (message.value !== "") {
      writer.uint32(18).string(message.value);
    }

    if (message.index === true) {
      writer.uint32(24).bool(message.index);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEventAttribute();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.key = reader.string();
          break;

        case 2:
          message.value = reader.string();
          break;

        case 3:
          message.index = reader.bool();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$key2, _object$value2, _object$index2;

    const message = createBaseEventAttribute();
    message.key = (_object$key2 = object.key) !== null && _object$key2 !== void 0 ? _object$key2 : "";
    message.value = (_object$value2 = object.value) !== null && _object$value2 !== void 0 ? _object$value2 : "";
    message.index = (_object$index2 = object.index) !== null && _object$index2 !== void 0 ? _object$index2 : false;
    return message;
  },

  fromAmino(object) {
    return {
      key: object.key,
      value: object.value,
      index: object.index
    };
  },

  toAmino(message) {
    const obj = {};
    obj.key = message.key;
    obj.value = message.value;
    obj.index = message.index;
    return obj;
  },

  fromAminoMsg(object) {
    return EventAttribute.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return EventAttribute.decode(message.value);
  },

  toProto(message) {
    return EventAttribute.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/tendermint.abci.EventAttribute",
      value: EventAttribute.encode(message).finish()
    };
  }

};

function createBaseTxResult() {
  return {
    height: _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.ZERO */ .dK.ZERO,
    index: 0,
    tx: new Uint8Array(),
    result: undefined
  };
}

const TxResult = {
  typeUrl: "/tendermint.abci.TxResult",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    if (!message.height.isZero()) {
      writer.uint32(8).int64(message.height);
    }

    if (message.index !== 0) {
      writer.uint32(16).uint32(message.index);
    }

    if (message.tx.length !== 0) {
      writer.uint32(26).bytes(message.tx);
    }

    if (message.result !== undefined) {
      ResponseDeliverTx.encode(message.result, writer.uint32(34).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTxResult();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.height = reader.int64();
          break;

        case 2:
          message.index = reader.uint32();
          break;

        case 3:
          message.tx = reader.bytes();
          break;

        case 4:
          message.result = ResponseDeliverTx.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$index3, _object$tx3;

    const message = createBaseTxResult();
    message.height = object.height !== undefined && object.height !== null ? _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.fromValue */ .dK.fromValue(object.height) : _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.ZERO */ .dK.ZERO;
    message.index = (_object$index3 = object.index) !== null && _object$index3 !== void 0 ? _object$index3 : 0;
    message.tx = (_object$tx3 = object.tx) !== null && _object$tx3 !== void 0 ? _object$tx3 : new Uint8Array();
    message.result = object.result !== undefined && object.result !== null ? ResponseDeliverTx.fromPartial(object.result) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      height: _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.fromString */ .dK.fromString(object.height),
      index: object.index,
      tx: object.tx,
      result: object !== null && object !== void 0 && object.result ? ResponseDeliverTx.fromAmino(object.result) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.height = message.height ? message.height.toString() : undefined;
    obj.index = message.index;
    obj.tx = message.tx;
    obj.result = message.result ? ResponseDeliverTx.toAmino(message.result) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return TxResult.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return TxResult.decode(message.value);
  },

  toProto(message) {
    return TxResult.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/tendermint.abci.TxResult",
      value: TxResult.encode(message).finish()
    };
  }

};

function createBaseValidator() {
  return {
    address: new Uint8Array(),
    power: _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.ZERO */ .dK.ZERO
  };
}

const Validator = {
  typeUrl: "/tendermint.abci.Validator",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    if (message.address.length !== 0) {
      writer.uint32(10).bytes(message.address);
    }

    if (!message.power.isZero()) {
      writer.uint32(24).int64(message.power);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseValidator();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.address = reader.bytes();
          break;

        case 3:
          message.power = reader.int64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$address;

    const message = createBaseValidator();
    message.address = (_object$address = object.address) !== null && _object$address !== void 0 ? _object$address : new Uint8Array();
    message.power = object.power !== undefined && object.power !== null ? _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.fromValue */ .dK.fromValue(object.power) : _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.ZERO */ .dK.ZERO;
    return message;
  },

  fromAmino(object) {
    return {
      address: object.address,
      power: _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.fromString */ .dK.fromString(object.power)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.address = message.address;
    obj.power = message.power ? message.power.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return Validator.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return Validator.decode(message.value);
  },

  toProto(message) {
    return Validator.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/tendermint.abci.Validator",
      value: Validator.encode(message).finish()
    };
  }

};

function createBaseValidatorUpdate() {
  return {
    pubKey: undefined,
    power: _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.ZERO */ .dK.ZERO
  };
}

const ValidatorUpdate = {
  typeUrl: "/tendermint.abci.ValidatorUpdate",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    if (message.pubKey !== undefined) {
      _crypto_keys__WEBPACK_IMPORTED_MODULE_4__.PublicKey.encode(message.pubKey, writer.uint32(10).fork()).ldelim();
    }

    if (!message.power.isZero()) {
      writer.uint32(16).int64(message.power);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseValidatorUpdate();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.pubKey = _crypto_keys__WEBPACK_IMPORTED_MODULE_4__.PublicKey.decode(reader, reader.uint32());
          break;

        case 2:
          message.power = reader.int64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseValidatorUpdate();
    message.pubKey = object.pubKey !== undefined && object.pubKey !== null ? _crypto_keys__WEBPACK_IMPORTED_MODULE_4__.PublicKey.fromPartial(object.pubKey) : undefined;
    message.power = object.power !== undefined && object.power !== null ? _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.fromValue */ .dK.fromValue(object.power) : _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.ZERO */ .dK.ZERO;
    return message;
  },

  fromAmino(object) {
    return {
      pubKey: object !== null && object !== void 0 && object.pub_key ? _crypto_keys__WEBPACK_IMPORTED_MODULE_4__.PublicKey.fromAmino(object.pub_key) : undefined,
      power: _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.fromString */ .dK.fromString(object.power)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.pub_key = message.pubKey ? _crypto_keys__WEBPACK_IMPORTED_MODULE_4__.PublicKey.toAmino(message.pubKey) : undefined;
    obj.power = message.power ? message.power.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return ValidatorUpdate.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return ValidatorUpdate.decode(message.value);
  },

  toProto(message) {
    return ValidatorUpdate.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/tendermint.abci.ValidatorUpdate",
      value: ValidatorUpdate.encode(message).finish()
    };
  }

};

function createBaseVoteInfo() {
  return {
    validator: undefined,
    signedLastBlock: false
  };
}

const VoteInfo = {
  typeUrl: "/tendermint.abci.VoteInfo",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    if (message.validator !== undefined) {
      Validator.encode(message.validator, writer.uint32(10).fork()).ldelim();
    }

    if (message.signedLastBlock === true) {
      writer.uint32(16).bool(message.signedLastBlock);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVoteInfo();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.validator = Validator.decode(reader, reader.uint32());
          break;

        case 2:
          message.signedLastBlock = reader.bool();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$signedLastBlo;

    const message = createBaseVoteInfo();
    message.validator = object.validator !== undefined && object.validator !== null ? Validator.fromPartial(object.validator) : undefined;
    message.signedLastBlock = (_object$signedLastBlo = object.signedLastBlock) !== null && _object$signedLastBlo !== void 0 ? _object$signedLastBlo : false;
    return message;
  },

  fromAmino(object) {
    return {
      validator: object !== null && object !== void 0 && object.validator ? Validator.fromAmino(object.validator) : undefined,
      signedLastBlock: object.signed_last_block
    };
  },

  toAmino(message) {
    const obj = {};
    obj.validator = message.validator ? Validator.toAmino(message.validator) : undefined;
    obj.signed_last_block = message.signedLastBlock;
    return obj;
  },

  fromAminoMsg(object) {
    return VoteInfo.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return VoteInfo.decode(message.value);
  },

  toProto(message) {
    return VoteInfo.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/tendermint.abci.VoteInfo",
      value: VoteInfo.encode(message).finish()
    };
  }

};

function createBaseExtendedVoteInfo() {
  return {
    validator: undefined,
    signedLastBlock: false,
    voteExtension: new Uint8Array()
  };
}

const ExtendedVoteInfo = {
  typeUrl: "/tendermint.abci.ExtendedVoteInfo",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    if (message.validator !== undefined) {
      Validator.encode(message.validator, writer.uint32(10).fork()).ldelim();
    }

    if (message.signedLastBlock === true) {
      writer.uint32(16).bool(message.signedLastBlock);
    }

    if (message.voteExtension.length !== 0) {
      writer.uint32(26).bytes(message.voteExtension);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseExtendedVoteInfo();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.validator = Validator.decode(reader, reader.uint32());
          break;

        case 2:
          message.signedLastBlock = reader.bool();
          break;

        case 3:
          message.voteExtension = reader.bytes();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$signedLastBlo2, _object$voteExtension;

    const message = createBaseExtendedVoteInfo();
    message.validator = object.validator !== undefined && object.validator !== null ? Validator.fromPartial(object.validator) : undefined;
    message.signedLastBlock = (_object$signedLastBlo2 = object.signedLastBlock) !== null && _object$signedLastBlo2 !== void 0 ? _object$signedLastBlo2 : false;
    message.voteExtension = (_object$voteExtension = object.voteExtension) !== null && _object$voteExtension !== void 0 ? _object$voteExtension : new Uint8Array();
    return message;
  },

  fromAmino(object) {
    return {
      validator: object !== null && object !== void 0 && object.validator ? Validator.fromAmino(object.validator) : undefined,
      signedLastBlock: object.signed_last_block,
      voteExtension: object.vote_extension
    };
  },

  toAmino(message) {
    const obj = {};
    obj.validator = message.validator ? Validator.toAmino(message.validator) : undefined;
    obj.signed_last_block = message.signedLastBlock;
    obj.vote_extension = message.voteExtension;
    return obj;
  },

  fromAminoMsg(object) {
    return ExtendedVoteInfo.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return ExtendedVoteInfo.decode(message.value);
  },

  toProto(message) {
    return ExtendedVoteInfo.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/tendermint.abci.ExtendedVoteInfo",
      value: ExtendedVoteInfo.encode(message).finish()
    };
  }

};

function createBaseMisbehavior() {
  return {
    type: 0,
    validator: undefined,
    height: _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.ZERO */ .dK.ZERO,
    time: undefined,
    totalVotingPower: _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.ZERO */ .dK.ZERO
  };
}

const Misbehavior = {
  typeUrl: "/tendermint.abci.Misbehavior",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    if (message.type !== 0) {
      writer.uint32(8).int32(message.type);
    }

    if (message.validator !== undefined) {
      Validator.encode(message.validator, writer.uint32(18).fork()).ldelim();
    }

    if (!message.height.isZero()) {
      writer.uint32(24).int64(message.height);
    }

    if (message.time !== undefined) {
      _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_0__.Timestamp.encode((0,_helpers__WEBPACK_IMPORTED_MODULE_5__/* .toTimestamp */ .Uq)(message.time), writer.uint32(34).fork()).ldelim();
    }

    if (!message.totalVotingPower.isZero()) {
      writer.uint32(40).int64(message.totalVotingPower);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMisbehavior();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.type = reader.int32();
          break;

        case 2:
          message.validator = Validator.decode(reader, reader.uint32());
          break;

        case 3:
          message.height = reader.int64();
          break;

        case 4:
          message.time = (0,_helpers__WEBPACK_IMPORTED_MODULE_5__/* .fromTimestamp */ .Ol)(_google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_0__.Timestamp.decode(reader, reader.uint32()));
          break;

        case 5:
          message.totalVotingPower = reader.int64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$type3, _object$time4;

    const message = createBaseMisbehavior();
    message.type = (_object$type3 = object.type) !== null && _object$type3 !== void 0 ? _object$type3 : 0;
    message.validator = object.validator !== undefined && object.validator !== null ? Validator.fromPartial(object.validator) : undefined;
    message.height = object.height !== undefined && object.height !== null ? _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.fromValue */ .dK.fromValue(object.height) : _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.ZERO */ .dK.ZERO;
    message.time = (_object$time4 = object.time) !== null && _object$time4 !== void 0 ? _object$time4 : undefined;
    message.totalVotingPower = object.totalVotingPower !== undefined && object.totalVotingPower !== null ? _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.fromValue */ .dK.fromValue(object.totalVotingPower) : _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.ZERO */ .dK.ZERO;
    return message;
  },

  fromAmino(object) {
    return {
      type: (0,_helpers__WEBPACK_IMPORTED_MODULE_5__/* .isSet */ .DM)(object.type) ? misbehaviorTypeFromJSON(object.type) : 0,
      validator: object !== null && object !== void 0 && object.validator ? Validator.fromAmino(object.validator) : undefined,
      height: _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.fromString */ .dK.fromString(object.height),
      time: object !== null && object !== void 0 && object.time ? _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_0__.Timestamp.fromAmino(object.time) : undefined,
      totalVotingPower: _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.fromString */ .dK.fromString(object.total_voting_power)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.type = message.type;
    obj.validator = message.validator ? Validator.toAmino(message.validator) : undefined;
    obj.height = message.height ? message.height.toString() : undefined;
    obj.time = message.time ? _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_0__.Timestamp.toAmino(message.time) : undefined;
    obj.total_voting_power = message.totalVotingPower ? message.totalVotingPower.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return Misbehavior.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return Misbehavior.decode(message.value);
  },

  toProto(message) {
    return Misbehavior.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/tendermint.abci.Misbehavior",
      value: Misbehavior.encode(message).finish()
    };
  }

};

function createBaseSnapshot() {
  return {
    height: _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.UZERO */ .dK.UZERO,
    format: 0,
    chunks: 0,
    hash: new Uint8Array(),
    metadata: new Uint8Array()
  };
}

const Snapshot = {
  typeUrl: "/tendermint.abci.Snapshot",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Writer.create()) {
    if (!message.height.isZero()) {
      writer.uint32(8).uint64(message.height);
    }

    if (message.format !== 0) {
      writer.uint32(16).uint32(message.format);
    }

    if (message.chunks !== 0) {
      writer.uint32(24).uint32(message.chunks);
    }

    if (message.hash.length !== 0) {
      writer.uint32(34).bytes(message.hash);
    }

    if (message.metadata.length !== 0) {
      writer.uint32(42).bytes(message.metadata);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_6__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSnapshot();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.height = reader.uint64();
          break;

        case 2:
          message.format = reader.uint32();
          break;

        case 3:
          message.chunks = reader.uint32();
          break;

        case 4:
          message.hash = reader.bytes();
          break;

        case 5:
          message.metadata = reader.bytes();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$format2, _object$chunks, _object$hash3, _object$metadata;

    const message = createBaseSnapshot();
    message.height = object.height !== undefined && object.height !== null ? _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.fromValue */ .dK.fromValue(object.height) : _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.UZERO */ .dK.UZERO;
    message.format = (_object$format2 = object.format) !== null && _object$format2 !== void 0 ? _object$format2 : 0;
    message.chunks = (_object$chunks = object.chunks) !== null && _object$chunks !== void 0 ? _object$chunks : 0;
    message.hash = (_object$hash3 = object.hash) !== null && _object$hash3 !== void 0 ? _object$hash3 : new Uint8Array();
    message.metadata = (_object$metadata = object.metadata) !== null && _object$metadata !== void 0 ? _object$metadata : new Uint8Array();
    return message;
  },

  fromAmino(object) {
    return {
      height: _helpers__WEBPACK_IMPORTED_MODULE_5__/* .Long.fromString */ .dK.fromString(object.height),
      format: object.format,
      chunks: object.chunks,
      hash: object.hash,
      metadata: object.metadata
    };
  },

  toAmino(message) {
    const obj = {};
    obj.height = message.height ? message.height.toString() : undefined;
    obj.format = message.format;
    obj.chunks = message.chunks;
    obj.hash = message.hash;
    obj.metadata = message.metadata;
    return obj;
  },

  fromAminoMsg(object) {
    return Snapshot.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return Snapshot.decode(message.value);
  },

  toProto(message) {
    return Snapshot.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/tendermint.abci.Snapshot",
      value: Snapshot.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 79246:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "PublicKey": function() { return /* binding */ PublicKey; }
/* harmony export */ });
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__);

/** PublicKey defines the keys available for use with Tendermint Validators */

function createBasePublicKey() {
  return {
    ed25519: undefined,
    secp256k1: undefined
  };
}

const PublicKey = {
  typeUrl: "/tendermint.crypto.PublicKey",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Writer.create()) {
    if (message.ed25519 !== undefined) {
      writer.uint32(10).bytes(message.ed25519);
    }

    if (message.secp256k1 !== undefined) {
      writer.uint32(18).bytes(message.secp256k1);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_0__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePublicKey();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.ed25519 = reader.bytes();
          break;

        case 2:
          message.secp256k1 = reader.bytes();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$ed, _object$secp256k;

    const message = createBasePublicKey();
    message.ed25519 = (_object$ed = object.ed25519) !== null && _object$ed !== void 0 ? _object$ed : undefined;
    message.secp256k1 = (_object$secp256k = object.secp256k1) !== null && _object$secp256k !== void 0 ? _object$secp256k : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      ed25519: object === null || object === void 0 ? void 0 : object.ed25519,
      secp256k1: object === null || object === void 0 ? void 0 : object.secp256k1
    };
  },

  toAmino(message) {
    const obj = {};
    obj.ed25519 = message.ed25519;
    obj.secp256k1 = message.secp256k1;
    return obj;
  },

  fromAminoMsg(object) {
    return PublicKey.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return PublicKey.decode(message.value);
  },

  toProto(message) {
    return PublicKey.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/tendermint.crypto.PublicKey",
      value: PublicKey.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 47374:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DominoOp": function() { return /* binding */ DominoOp; },
/* harmony export */   "Proof": function() { return /* binding */ Proof; },
/* harmony export */   "ProofOp": function() { return /* binding */ ProofOp; },
/* harmony export */   "ProofOps": function() { return /* binding */ ProofOps; },
/* harmony export */   "ValueOp": function() { return /* binding */ ValueOp; }
/* harmony export */ });
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47895);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__);



function createBaseProof() {
  return {
    total: _helpers__WEBPACK_IMPORTED_MODULE_0__/* .Long.ZERO */ .dK.ZERO,
    index: _helpers__WEBPACK_IMPORTED_MODULE_0__/* .Long.ZERO */ .dK.ZERO,
    leafHash: new Uint8Array(),
    aunts: []
  };
}

const Proof = {
  typeUrl: "/tendermint.crypto.Proof",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Writer.create()) {
    if (!message.total.isZero()) {
      writer.uint32(8).int64(message.total);
    }

    if (!message.index.isZero()) {
      writer.uint32(16).int64(message.index);
    }

    if (message.leafHash.length !== 0) {
      writer.uint32(26).bytes(message.leafHash);
    }

    for (const v of message.aunts) {
      writer.uint32(34).bytes(v);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseProof();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.total = reader.int64();
          break;

        case 2:
          message.index = reader.int64();
          break;

        case 3:
          message.leafHash = reader.bytes();
          break;

        case 4:
          message.aunts.push(reader.bytes());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$leafHash, _object$aunts;

    const message = createBaseProof();
    message.total = object.total !== undefined && object.total !== null ? _helpers__WEBPACK_IMPORTED_MODULE_0__/* .Long.fromValue */ .dK.fromValue(object.total) : _helpers__WEBPACK_IMPORTED_MODULE_0__/* .Long.ZERO */ .dK.ZERO;
    message.index = object.index !== undefined && object.index !== null ? _helpers__WEBPACK_IMPORTED_MODULE_0__/* .Long.fromValue */ .dK.fromValue(object.index) : _helpers__WEBPACK_IMPORTED_MODULE_0__/* .Long.ZERO */ .dK.ZERO;
    message.leafHash = (_object$leafHash = object.leafHash) !== null && _object$leafHash !== void 0 ? _object$leafHash : new Uint8Array();
    message.aunts = ((_object$aunts = object.aunts) === null || _object$aunts === void 0 ? void 0 : _object$aunts.map(e => e)) || [];
    return message;
  },

  fromAmino(object) {
    return {
      total: _helpers__WEBPACK_IMPORTED_MODULE_0__/* .Long.fromString */ .dK.fromString(object.total),
      index: _helpers__WEBPACK_IMPORTED_MODULE_0__/* .Long.fromString */ .dK.fromString(object.index),
      leafHash: object.leaf_hash,
      aunts: Array.isArray(object === null || object === void 0 ? void 0 : object.aunts) ? object.aunts.map(e => e) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.total = message.total ? message.total.toString() : undefined;
    obj.index = message.index ? message.index.toString() : undefined;
    obj.leaf_hash = message.leafHash;

    if (message.aunts) {
      obj.aunts = message.aunts.map(e => e);
    } else {
      obj.aunts = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return Proof.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return Proof.decode(message.value);
  },

  toProto(message) {
    return Proof.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/tendermint.crypto.Proof",
      value: Proof.encode(message).finish()
    };
  }

};

function createBaseValueOp() {
  return {
    key: new Uint8Array(),
    proof: undefined
  };
}

const ValueOp = {
  typeUrl: "/tendermint.crypto.ValueOp",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Writer.create()) {
    if (message.key.length !== 0) {
      writer.uint32(10).bytes(message.key);
    }

    if (message.proof !== undefined) {
      Proof.encode(message.proof, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseValueOp();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.key = reader.bytes();
          break;

        case 2:
          message.proof = Proof.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$key;

    const message = createBaseValueOp();
    message.key = (_object$key = object.key) !== null && _object$key !== void 0 ? _object$key : new Uint8Array();
    message.proof = object.proof !== undefined && object.proof !== null ? Proof.fromPartial(object.proof) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      key: object.key,
      proof: object !== null && object !== void 0 && object.proof ? Proof.fromAmino(object.proof) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.key = message.key;
    obj.proof = message.proof ? Proof.toAmino(message.proof) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return ValueOp.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return ValueOp.decode(message.value);
  },

  toProto(message) {
    return ValueOp.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/tendermint.crypto.ValueOp",
      value: ValueOp.encode(message).finish()
    };
  }

};

function createBaseDominoOp() {
  return {
    key: "",
    input: "",
    output: ""
  };
}

const DominoOp = {
  typeUrl: "/tendermint.crypto.DominoOp",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Writer.create()) {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }

    if (message.input !== "") {
      writer.uint32(18).string(message.input);
    }

    if (message.output !== "") {
      writer.uint32(26).string(message.output);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDominoOp();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.key = reader.string();
          break;

        case 2:
          message.input = reader.string();
          break;

        case 3:
          message.output = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$key2, _object$input, _object$output;

    const message = createBaseDominoOp();
    message.key = (_object$key2 = object.key) !== null && _object$key2 !== void 0 ? _object$key2 : "";
    message.input = (_object$input = object.input) !== null && _object$input !== void 0 ? _object$input : "";
    message.output = (_object$output = object.output) !== null && _object$output !== void 0 ? _object$output : "";
    return message;
  },

  fromAmino(object) {
    return {
      key: object.key,
      input: object.input,
      output: object.output
    };
  },

  toAmino(message) {
    const obj = {};
    obj.key = message.key;
    obj.input = message.input;
    obj.output = message.output;
    return obj;
  },

  fromAminoMsg(object) {
    return DominoOp.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return DominoOp.decode(message.value);
  },

  toProto(message) {
    return DominoOp.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/tendermint.crypto.DominoOp",
      value: DominoOp.encode(message).finish()
    };
  }

};

function createBaseProofOp() {
  return {
    type: "",
    key: new Uint8Array(),
    data: new Uint8Array()
  };
}

const ProofOp = {
  typeUrl: "/tendermint.crypto.ProofOp",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Writer.create()) {
    if (message.type !== "") {
      writer.uint32(10).string(message.type);
    }

    if (message.key.length !== 0) {
      writer.uint32(18).bytes(message.key);
    }

    if (message.data.length !== 0) {
      writer.uint32(26).bytes(message.data);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseProofOp();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.type = reader.string();
          break;

        case 2:
          message.key = reader.bytes();
          break;

        case 3:
          message.data = reader.bytes();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$type, _object$key3, _object$data;

    const message = createBaseProofOp();
    message.type = (_object$type = object.type) !== null && _object$type !== void 0 ? _object$type : "";
    message.key = (_object$key3 = object.key) !== null && _object$key3 !== void 0 ? _object$key3 : new Uint8Array();
    message.data = (_object$data = object.data) !== null && _object$data !== void 0 ? _object$data : new Uint8Array();
    return message;
  },

  fromAmino(object) {
    return {
      type: object.type,
      key: object.key,
      data: object.data
    };
  },

  toAmino(message) {
    const obj = {};
    obj.type = message.type;
    obj.key = message.key;
    obj.data = message.data;
    return obj;
  },

  fromAminoMsg(object) {
    return ProofOp.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return ProofOp.decode(message.value);
  },

  toProto(message) {
    return ProofOp.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/tendermint.crypto.ProofOp",
      value: ProofOp.encode(message).finish()
    };
  }

};

function createBaseProofOps() {
  return {
    ops: []
  };
}

const ProofOps = {
  typeUrl: "/tendermint.crypto.ProofOps",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Writer.create()) {
    for (const v of message.ops) {
      ProofOp.encode(v, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseProofOps();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.ops.push(ProofOp.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$ops;

    const message = createBaseProofOps();
    message.ops = ((_object$ops = object.ops) === null || _object$ops === void 0 ? void 0 : _object$ops.map(e => ProofOp.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      ops: Array.isArray(object === null || object === void 0 ? void 0 : object.ops) ? object.ops.map(e => ProofOp.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.ops) {
      obj.ops = message.ops.map(e => e ? ProofOp.toAmino(e) : undefined);
    } else {
      obj.ops = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return ProofOps.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return ProofOps.decode(message.value);
  },

  toProto(message) {
    return ProofOps.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/tendermint.crypto.ProofOps",
      value: ProofOps.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 39490:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BlockParams": function() { return /* binding */ BlockParams; },
/* harmony export */   "ConsensusParams": function() { return /* binding */ ConsensusParams; },
/* harmony export */   "EvidenceParams": function() { return /* binding */ EvidenceParams; },
/* harmony export */   "HashedParams": function() { return /* binding */ HashedParams; },
/* harmony export */   "ValidatorParams": function() { return /* binding */ ValidatorParams; },
/* harmony export */   "VersionParams": function() { return /* binding */ VersionParams; }
/* harmony export */ });
/* harmony import */ var _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6499);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47895);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__);



/**
 * ConsensusParams contains consensus critical parameters that determine the
 * validity of blocks.
 */

function createBaseConsensusParams() {
  return {
    block: undefined,
    evidence: undefined,
    validator: undefined,
    version: undefined
  };
}

const ConsensusParams = {
  typeUrl: "/tendermint.types.ConsensusParams",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (message.block !== undefined) {
      BlockParams.encode(message.block, writer.uint32(10).fork()).ldelim();
    }

    if (message.evidence !== undefined) {
      EvidenceParams.encode(message.evidence, writer.uint32(18).fork()).ldelim();
    }

    if (message.validator !== undefined) {
      ValidatorParams.encode(message.validator, writer.uint32(26).fork()).ldelim();
    }

    if (message.version !== undefined) {
      VersionParams.encode(message.version, writer.uint32(34).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseConsensusParams();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.block = BlockParams.decode(reader, reader.uint32());
          break;

        case 2:
          message.evidence = EvidenceParams.decode(reader, reader.uint32());
          break;

        case 3:
          message.validator = ValidatorParams.decode(reader, reader.uint32());
          break;

        case 4:
          message.version = VersionParams.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseConsensusParams();
    message.block = object.block !== undefined && object.block !== null ? BlockParams.fromPartial(object.block) : undefined;
    message.evidence = object.evidence !== undefined && object.evidence !== null ? EvidenceParams.fromPartial(object.evidence) : undefined;
    message.validator = object.validator !== undefined && object.validator !== null ? ValidatorParams.fromPartial(object.validator) : undefined;
    message.version = object.version !== undefined && object.version !== null ? VersionParams.fromPartial(object.version) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      block: object !== null && object !== void 0 && object.block ? BlockParams.fromAmino(object.block) : undefined,
      evidence: object !== null && object !== void 0 && object.evidence ? EvidenceParams.fromAmino(object.evidence) : undefined,
      validator: object !== null && object !== void 0 && object.validator ? ValidatorParams.fromAmino(object.validator) : undefined,
      version: object !== null && object !== void 0 && object.version ? VersionParams.fromAmino(object.version) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.block = message.block ? BlockParams.toAmino(message.block) : undefined;
    obj.evidence = message.evidence ? EvidenceParams.toAmino(message.evidence) : undefined;
    obj.validator = message.validator ? ValidatorParams.toAmino(message.validator) : undefined;
    obj.version = message.version ? VersionParams.toAmino(message.version) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return ConsensusParams.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return ConsensusParams.decode(message.value);
  },

  toProto(message) {
    return ConsensusParams.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/tendermint.types.ConsensusParams",
      value: ConsensusParams.encode(message).finish()
    };
  }

};

function createBaseBlockParams() {
  return {
    maxBytes: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.ZERO */ .dK.ZERO,
    maxGas: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.ZERO */ .dK.ZERO
  };
}

const BlockParams = {
  typeUrl: "/tendermint.types.BlockParams",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (!message.maxBytes.isZero()) {
      writer.uint32(8).int64(message.maxBytes);
    }

    if (!message.maxGas.isZero()) {
      writer.uint32(16).int64(message.maxGas);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBlockParams();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.maxBytes = reader.int64();
          break;

        case 2:
          message.maxGas = reader.int64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseBlockParams();
    message.maxBytes = object.maxBytes !== undefined && object.maxBytes !== null ? _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromValue */ .dK.fromValue(object.maxBytes) : _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.ZERO */ .dK.ZERO;
    message.maxGas = object.maxGas !== undefined && object.maxGas !== null ? _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromValue */ .dK.fromValue(object.maxGas) : _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.ZERO */ .dK.ZERO;
    return message;
  },

  fromAmino(object) {
    return {
      maxBytes: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromString */ .dK.fromString(object.max_bytes),
      maxGas: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromString */ .dK.fromString(object.max_gas)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.max_bytes = message.maxBytes ? message.maxBytes.toString() : undefined;
    obj.max_gas = message.maxGas ? message.maxGas.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return BlockParams.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return BlockParams.decode(message.value);
  },

  toProto(message) {
    return BlockParams.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/tendermint.types.BlockParams",
      value: BlockParams.encode(message).finish()
    };
  }

};

function createBaseEvidenceParams() {
  return {
    maxAgeNumBlocks: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.ZERO */ .dK.ZERO,
    maxAgeDuration: undefined,
    maxBytes: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.ZERO */ .dK.ZERO
  };
}

const EvidenceParams = {
  typeUrl: "/tendermint.types.EvidenceParams",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (!message.maxAgeNumBlocks.isZero()) {
      writer.uint32(8).int64(message.maxAgeNumBlocks);
    }

    if (message.maxAgeDuration !== undefined) {
      _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_0__.Duration.encode(message.maxAgeDuration, writer.uint32(18).fork()).ldelim();
    }

    if (!message.maxBytes.isZero()) {
      writer.uint32(24).int64(message.maxBytes);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEvidenceParams();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.maxAgeNumBlocks = reader.int64();
          break;

        case 2:
          message.maxAgeDuration = _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_0__.Duration.decode(reader, reader.uint32());
          break;

        case 3:
          message.maxBytes = reader.int64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseEvidenceParams();
    message.maxAgeNumBlocks = object.maxAgeNumBlocks !== undefined && object.maxAgeNumBlocks !== null ? _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromValue */ .dK.fromValue(object.maxAgeNumBlocks) : _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.ZERO */ .dK.ZERO;
    message.maxAgeDuration = object.maxAgeDuration !== undefined && object.maxAgeDuration !== null ? _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_0__.Duration.fromPartial(object.maxAgeDuration) : undefined;
    message.maxBytes = object.maxBytes !== undefined && object.maxBytes !== null ? _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromValue */ .dK.fromValue(object.maxBytes) : _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.ZERO */ .dK.ZERO;
    return message;
  },

  fromAmino(object) {
    return {
      maxAgeNumBlocks: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromString */ .dK.fromString(object.max_age_num_blocks),
      maxAgeDuration: object !== null && object !== void 0 && object.max_age_duration ? _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_0__.Duration.fromAmino(object.max_age_duration) : undefined,
      maxBytes: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromString */ .dK.fromString(object.max_bytes)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.max_age_num_blocks = message.maxAgeNumBlocks ? message.maxAgeNumBlocks.toString() : undefined;
    obj.max_age_duration = message.maxAgeDuration ? _google_protobuf_duration__WEBPACK_IMPORTED_MODULE_0__.Duration.toAmino(message.maxAgeDuration) : undefined;
    obj.max_bytes = message.maxBytes ? message.maxBytes.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return EvidenceParams.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return EvidenceParams.decode(message.value);
  },

  toProto(message) {
    return EvidenceParams.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/tendermint.types.EvidenceParams",
      value: EvidenceParams.encode(message).finish()
    };
  }

};

function createBaseValidatorParams() {
  return {
    pubKeyTypes: []
  };
}

const ValidatorParams = {
  typeUrl: "/tendermint.types.ValidatorParams",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    for (const v of message.pubKeyTypes) {
      writer.uint32(10).string(v);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseValidatorParams();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.pubKeyTypes.push(reader.string());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$pubKeyTypes;

    const message = createBaseValidatorParams();
    message.pubKeyTypes = ((_object$pubKeyTypes = object.pubKeyTypes) === null || _object$pubKeyTypes === void 0 ? void 0 : _object$pubKeyTypes.map(e => e)) || [];
    return message;
  },

  fromAmino(object) {
    return {
      pubKeyTypes: Array.isArray(object === null || object === void 0 ? void 0 : object.pub_key_types) ? object.pub_key_types.map(e => e) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.pubKeyTypes) {
      obj.pub_key_types = message.pubKeyTypes.map(e => e);
    } else {
      obj.pub_key_types = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return ValidatorParams.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return ValidatorParams.decode(message.value);
  },

  toProto(message) {
    return ValidatorParams.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/tendermint.types.ValidatorParams",
      value: ValidatorParams.encode(message).finish()
    };
  }

};

function createBaseVersionParams() {
  return {
    app: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.UZERO */ .dK.UZERO
  };
}

const VersionParams = {
  typeUrl: "/tendermint.types.VersionParams",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (!message.app.isZero()) {
      writer.uint32(8).uint64(message.app);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVersionParams();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.app = reader.uint64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseVersionParams();
    message.app = object.app !== undefined && object.app !== null ? _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromValue */ .dK.fromValue(object.app) : _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.UZERO */ .dK.UZERO;
    return message;
  },

  fromAmino(object) {
    return {
      app: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromString */ .dK.fromString(object.app)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.app = message.app ? message.app.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return VersionParams.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return VersionParams.decode(message.value);
  },

  toProto(message) {
    return VersionParams.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/tendermint.types.VersionParams",
      value: VersionParams.encode(message).finish()
    };
  }

};

function createBaseHashedParams() {
  return {
    blockMaxBytes: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.ZERO */ .dK.ZERO,
    blockMaxGas: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.ZERO */ .dK.ZERO
  };
}

const HashedParams = {
  typeUrl: "/tendermint.types.HashedParams",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (!message.blockMaxBytes.isZero()) {
      writer.uint32(8).int64(message.blockMaxBytes);
    }

    if (!message.blockMaxGas.isZero()) {
      writer.uint32(16).int64(message.blockMaxGas);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseHashedParams();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.blockMaxBytes = reader.int64();
          break;

        case 2:
          message.blockMaxGas = reader.int64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseHashedParams();
    message.blockMaxBytes = object.blockMaxBytes !== undefined && object.blockMaxBytes !== null ? _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromValue */ .dK.fromValue(object.blockMaxBytes) : _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.ZERO */ .dK.ZERO;
    message.blockMaxGas = object.blockMaxGas !== undefined && object.blockMaxGas !== null ? _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromValue */ .dK.fromValue(object.blockMaxGas) : _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.ZERO */ .dK.ZERO;
    return message;
  },

  fromAmino(object) {
    return {
      blockMaxBytes: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromString */ .dK.fromString(object.block_max_bytes),
      blockMaxGas: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromString */ .dK.fromString(object.block_max_gas)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.block_max_bytes = message.blockMaxBytes ? message.blockMaxBytes.toString() : undefined;
    obj.block_max_gas = message.blockMaxGas ? message.blockMaxGas.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return HashedParams.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return HashedParams.decode(message.value);
  },

  toProto(message) {
    return HashedParams.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/tendermint.types.HashedParams",
      value: HashedParams.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 87572:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BlockID": function() { return /* binding */ BlockID; },
/* harmony export */   "BlockIDFlag": function() { return /* binding */ BlockIDFlag; },
/* harmony export */   "BlockIDFlagAmino": function() { return /* binding */ BlockIDFlagAmino; },
/* harmony export */   "BlockIDFlagSDKType": function() { return /* binding */ BlockIDFlagSDKType; },
/* harmony export */   "BlockMeta": function() { return /* binding */ BlockMeta; },
/* harmony export */   "Commit": function() { return /* binding */ Commit; },
/* harmony export */   "CommitSig": function() { return /* binding */ CommitSig; },
/* harmony export */   "Data": function() { return /* binding */ Data; },
/* harmony export */   "Header": function() { return /* binding */ Header; },
/* harmony export */   "LightBlock": function() { return /* binding */ LightBlock; },
/* harmony export */   "Part": function() { return /* binding */ Part; },
/* harmony export */   "PartSetHeader": function() { return /* binding */ PartSetHeader; },
/* harmony export */   "Proposal": function() { return /* binding */ Proposal; },
/* harmony export */   "SignedHeader": function() { return /* binding */ SignedHeader; },
/* harmony export */   "SignedMsgType": function() { return /* binding */ SignedMsgType; },
/* harmony export */   "SignedMsgTypeAmino": function() { return /* binding */ SignedMsgTypeAmino; },
/* harmony export */   "SignedMsgTypeSDKType": function() { return /* binding */ SignedMsgTypeSDKType; },
/* harmony export */   "TxProof": function() { return /* binding */ TxProof; },
/* harmony export */   "Vote": function() { return /* binding */ Vote; },
/* harmony export */   "blockIDFlagFromJSON": function() { return /* binding */ blockIDFlagFromJSON; },
/* harmony export */   "blockIDFlagToJSON": function() { return /* binding */ blockIDFlagToJSON; },
/* harmony export */   "signedMsgTypeFromJSON": function() { return /* binding */ signedMsgTypeFromJSON; },
/* harmony export */   "signedMsgTypeToJSON": function() { return /* binding */ signedMsgTypeToJSON; }
/* harmony export */ });
/* harmony import */ var _crypto_proof__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47374);
/* harmony import */ var _version_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88537);
/* harmony import */ var _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20633);
/* harmony import */ var _validator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70850);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47895);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__);






/** BlockIdFlag indicates which BlcokID the signature is for */

let BlockIDFlag;

(function (BlockIDFlag) {
  BlockIDFlag[BlockIDFlag["BLOCK_ID_FLAG_UNKNOWN"] = 0] = "BLOCK_ID_FLAG_UNKNOWN";
  BlockIDFlag[BlockIDFlag["BLOCK_ID_FLAG_ABSENT"] = 1] = "BLOCK_ID_FLAG_ABSENT";
  BlockIDFlag[BlockIDFlag["BLOCK_ID_FLAG_COMMIT"] = 2] = "BLOCK_ID_FLAG_COMMIT";
  BlockIDFlag[BlockIDFlag["BLOCK_ID_FLAG_NIL"] = 3] = "BLOCK_ID_FLAG_NIL";
  BlockIDFlag[BlockIDFlag["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(BlockIDFlag || (BlockIDFlag = {}));

const BlockIDFlagSDKType = BlockIDFlag;
const BlockIDFlagAmino = BlockIDFlag;
function blockIDFlagFromJSON(object) {
  switch (object) {
    case 0:
    case "BLOCK_ID_FLAG_UNKNOWN":
      return BlockIDFlag.BLOCK_ID_FLAG_UNKNOWN;

    case 1:
    case "BLOCK_ID_FLAG_ABSENT":
      return BlockIDFlag.BLOCK_ID_FLAG_ABSENT;

    case 2:
    case "BLOCK_ID_FLAG_COMMIT":
      return BlockIDFlag.BLOCK_ID_FLAG_COMMIT;

    case 3:
    case "BLOCK_ID_FLAG_NIL":
      return BlockIDFlag.BLOCK_ID_FLAG_NIL;

    case -1:
    case "UNRECOGNIZED":
    default:
      return BlockIDFlag.UNRECOGNIZED;
  }
}
function blockIDFlagToJSON(object) {
  switch (object) {
    case BlockIDFlag.BLOCK_ID_FLAG_UNKNOWN:
      return "BLOCK_ID_FLAG_UNKNOWN";

    case BlockIDFlag.BLOCK_ID_FLAG_ABSENT:
      return "BLOCK_ID_FLAG_ABSENT";

    case BlockIDFlag.BLOCK_ID_FLAG_COMMIT:
      return "BLOCK_ID_FLAG_COMMIT";

    case BlockIDFlag.BLOCK_ID_FLAG_NIL:
      return "BLOCK_ID_FLAG_NIL";

    case BlockIDFlag.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
/** SignedMsgType is a type of signed message in the consensus. */

let SignedMsgType;

(function (SignedMsgType) {
  SignedMsgType[SignedMsgType["SIGNED_MSG_TYPE_UNKNOWN"] = 0] = "SIGNED_MSG_TYPE_UNKNOWN";
  SignedMsgType[SignedMsgType["SIGNED_MSG_TYPE_PREVOTE"] = 1] = "SIGNED_MSG_TYPE_PREVOTE";
  SignedMsgType[SignedMsgType["SIGNED_MSG_TYPE_PRECOMMIT"] = 2] = "SIGNED_MSG_TYPE_PRECOMMIT";
  SignedMsgType[SignedMsgType["SIGNED_MSG_TYPE_PROPOSAL"] = 32] = "SIGNED_MSG_TYPE_PROPOSAL";
  SignedMsgType[SignedMsgType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(SignedMsgType || (SignedMsgType = {}));

const SignedMsgTypeSDKType = SignedMsgType;
const SignedMsgTypeAmino = SignedMsgType;
function signedMsgTypeFromJSON(object) {
  switch (object) {
    case 0:
    case "SIGNED_MSG_TYPE_UNKNOWN":
      return SignedMsgType.SIGNED_MSG_TYPE_UNKNOWN;

    case 1:
    case "SIGNED_MSG_TYPE_PREVOTE":
      return SignedMsgType.SIGNED_MSG_TYPE_PREVOTE;

    case 2:
    case "SIGNED_MSG_TYPE_PRECOMMIT":
      return SignedMsgType.SIGNED_MSG_TYPE_PRECOMMIT;

    case 32:
    case "SIGNED_MSG_TYPE_PROPOSAL":
      return SignedMsgType.SIGNED_MSG_TYPE_PROPOSAL;

    case -1:
    case "UNRECOGNIZED":
    default:
      return SignedMsgType.UNRECOGNIZED;
  }
}
function signedMsgTypeToJSON(object) {
  switch (object) {
    case SignedMsgType.SIGNED_MSG_TYPE_UNKNOWN:
      return "SIGNED_MSG_TYPE_UNKNOWN";

    case SignedMsgType.SIGNED_MSG_TYPE_PREVOTE:
      return "SIGNED_MSG_TYPE_PREVOTE";

    case SignedMsgType.SIGNED_MSG_TYPE_PRECOMMIT:
      return "SIGNED_MSG_TYPE_PRECOMMIT";

    case SignedMsgType.SIGNED_MSG_TYPE_PROPOSAL:
      return "SIGNED_MSG_TYPE_PROPOSAL";

    case SignedMsgType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
/** PartsetHeader */

function createBasePartSetHeader() {
  return {
    total: 0,
    hash: new Uint8Array()
  };
}

const PartSetHeader = {
  typeUrl: "/tendermint.types.PartSetHeader",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Writer.create()) {
    if (message.total !== 0) {
      writer.uint32(8).uint32(message.total);
    }

    if (message.hash.length !== 0) {
      writer.uint32(18).bytes(message.hash);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePartSetHeader();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.total = reader.uint32();
          break;

        case 2:
          message.hash = reader.bytes();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$total, _object$hash;

    const message = createBasePartSetHeader();
    message.total = (_object$total = object.total) !== null && _object$total !== void 0 ? _object$total : 0;
    message.hash = (_object$hash = object.hash) !== null && _object$hash !== void 0 ? _object$hash : new Uint8Array();
    return message;
  },

  fromAmino(object) {
    return {
      total: object.total,
      hash: object.hash
    };
  },

  toAmino(message) {
    const obj = {};
    obj.total = message.total;
    obj.hash = message.hash;
    return obj;
  },

  fromAminoMsg(object) {
    return PartSetHeader.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return PartSetHeader.decode(message.value);
  },

  toProto(message) {
    return PartSetHeader.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/tendermint.types.PartSetHeader",
      value: PartSetHeader.encode(message).finish()
    };
  }

};

function createBasePart() {
  return {
    index: 0,
    bytes: new Uint8Array(),
    proof: undefined
  };
}

const Part = {
  typeUrl: "/tendermint.types.Part",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Writer.create()) {
    if (message.index !== 0) {
      writer.uint32(8).uint32(message.index);
    }

    if (message.bytes.length !== 0) {
      writer.uint32(18).bytes(message.bytes);
    }

    if (message.proof !== undefined) {
      _crypto_proof__WEBPACK_IMPORTED_MODULE_0__.Proof.encode(message.proof, writer.uint32(26).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePart();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.index = reader.uint32();
          break;

        case 2:
          message.bytes = reader.bytes();
          break;

        case 3:
          message.proof = _crypto_proof__WEBPACK_IMPORTED_MODULE_0__.Proof.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$index, _object$bytes;

    const message = createBasePart();
    message.index = (_object$index = object.index) !== null && _object$index !== void 0 ? _object$index : 0;
    message.bytes = (_object$bytes = object.bytes) !== null && _object$bytes !== void 0 ? _object$bytes : new Uint8Array();
    message.proof = object.proof !== undefined && object.proof !== null ? _crypto_proof__WEBPACK_IMPORTED_MODULE_0__.Proof.fromPartial(object.proof) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      index: object.index,
      bytes: object.bytes,
      proof: object !== null && object !== void 0 && object.proof ? _crypto_proof__WEBPACK_IMPORTED_MODULE_0__.Proof.fromAmino(object.proof) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.index = message.index;
    obj.bytes = message.bytes;
    obj.proof = message.proof ? _crypto_proof__WEBPACK_IMPORTED_MODULE_0__.Proof.toAmino(message.proof) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return Part.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return Part.decode(message.value);
  },

  toProto(message) {
    return Part.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/tendermint.types.Part",
      value: Part.encode(message).finish()
    };
  }

};

function createBaseBlockID() {
  return {
    hash: new Uint8Array(),
    partSetHeader: undefined
  };
}

const BlockID = {
  typeUrl: "/tendermint.types.BlockID",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Writer.create()) {
    if (message.hash.length !== 0) {
      writer.uint32(10).bytes(message.hash);
    }

    if (message.partSetHeader !== undefined) {
      PartSetHeader.encode(message.partSetHeader, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBlockID();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.hash = reader.bytes();
          break;

        case 2:
          message.partSetHeader = PartSetHeader.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$hash2;

    const message = createBaseBlockID();
    message.hash = (_object$hash2 = object.hash) !== null && _object$hash2 !== void 0 ? _object$hash2 : new Uint8Array();
    message.partSetHeader = object.partSetHeader !== undefined && object.partSetHeader !== null ? PartSetHeader.fromPartial(object.partSetHeader) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      hash: object.hash,
      partSetHeader: object !== null && object !== void 0 && object.part_set_header ? PartSetHeader.fromAmino(object.part_set_header) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.hash = message.hash;
    obj.part_set_header = message.partSetHeader ? PartSetHeader.toAmino(message.partSetHeader) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return BlockID.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return BlockID.decode(message.value);
  },

  toProto(message) {
    return BlockID.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/tendermint.types.BlockID",
      value: BlockID.encode(message).finish()
    };
  }

};

function createBaseHeader() {
  return {
    version: undefined,
    chainId: "",
    height: _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.ZERO */ .dK.ZERO,
    time: undefined,
    lastBlockId: undefined,
    lastCommitHash: new Uint8Array(),
    dataHash: new Uint8Array(),
    validatorsHash: new Uint8Array(),
    nextValidatorsHash: new Uint8Array(),
    consensusHash: new Uint8Array(),
    appHash: new Uint8Array(),
    lastResultsHash: new Uint8Array(),
    evidenceHash: new Uint8Array(),
    proposerAddress: new Uint8Array()
  };
}

const Header = {
  typeUrl: "/tendermint.types.Header",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Writer.create()) {
    if (message.version !== undefined) {
      _version_types__WEBPACK_IMPORTED_MODULE_1__.Consensus.encode(message.version, writer.uint32(10).fork()).ldelim();
    }

    if (message.chainId !== "") {
      writer.uint32(18).string(message.chainId);
    }

    if (!message.height.isZero()) {
      writer.uint32(24).int64(message.height);
    }

    if (message.time !== undefined) {
      _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_2__.Timestamp.encode((0,_helpers__WEBPACK_IMPORTED_MODULE_4__/* .toTimestamp */ .Uq)(message.time), writer.uint32(34).fork()).ldelim();
    }

    if (message.lastBlockId !== undefined) {
      BlockID.encode(message.lastBlockId, writer.uint32(42).fork()).ldelim();
    }

    if (message.lastCommitHash.length !== 0) {
      writer.uint32(50).bytes(message.lastCommitHash);
    }

    if (message.dataHash.length !== 0) {
      writer.uint32(58).bytes(message.dataHash);
    }

    if (message.validatorsHash.length !== 0) {
      writer.uint32(66).bytes(message.validatorsHash);
    }

    if (message.nextValidatorsHash.length !== 0) {
      writer.uint32(74).bytes(message.nextValidatorsHash);
    }

    if (message.consensusHash.length !== 0) {
      writer.uint32(82).bytes(message.consensusHash);
    }

    if (message.appHash.length !== 0) {
      writer.uint32(90).bytes(message.appHash);
    }

    if (message.lastResultsHash.length !== 0) {
      writer.uint32(98).bytes(message.lastResultsHash);
    }

    if (message.evidenceHash.length !== 0) {
      writer.uint32(106).bytes(message.evidenceHash);
    }

    if (message.proposerAddress.length !== 0) {
      writer.uint32(114).bytes(message.proposerAddress);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseHeader();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.version = _version_types__WEBPACK_IMPORTED_MODULE_1__.Consensus.decode(reader, reader.uint32());
          break;

        case 2:
          message.chainId = reader.string();
          break;

        case 3:
          message.height = reader.int64();
          break;

        case 4:
          message.time = (0,_helpers__WEBPACK_IMPORTED_MODULE_4__/* .fromTimestamp */ .Ol)(_google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_2__.Timestamp.decode(reader, reader.uint32()));
          break;

        case 5:
          message.lastBlockId = BlockID.decode(reader, reader.uint32());
          break;

        case 6:
          message.lastCommitHash = reader.bytes();
          break;

        case 7:
          message.dataHash = reader.bytes();
          break;

        case 8:
          message.validatorsHash = reader.bytes();
          break;

        case 9:
          message.nextValidatorsHash = reader.bytes();
          break;

        case 10:
          message.consensusHash = reader.bytes();
          break;

        case 11:
          message.appHash = reader.bytes();
          break;

        case 12:
          message.lastResultsHash = reader.bytes();
          break;

        case 13:
          message.evidenceHash = reader.bytes();
          break;

        case 14:
          message.proposerAddress = reader.bytes();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$chainId, _object$time, _object$lastCommitHas, _object$dataHash, _object$validatorsHas, _object$nextValidator, _object$consensusHash, _object$appHash, _object$lastResultsHa, _object$evidenceHash, _object$proposerAddre;

    const message = createBaseHeader();
    message.version = object.version !== undefined && object.version !== null ? _version_types__WEBPACK_IMPORTED_MODULE_1__.Consensus.fromPartial(object.version) : undefined;
    message.chainId = (_object$chainId = object.chainId) !== null && _object$chainId !== void 0 ? _object$chainId : "";
    message.height = object.height !== undefined && object.height !== null ? _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.fromValue */ .dK.fromValue(object.height) : _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.ZERO */ .dK.ZERO;
    message.time = (_object$time = object.time) !== null && _object$time !== void 0 ? _object$time : undefined;
    message.lastBlockId = object.lastBlockId !== undefined && object.lastBlockId !== null ? BlockID.fromPartial(object.lastBlockId) : undefined;
    message.lastCommitHash = (_object$lastCommitHas = object.lastCommitHash) !== null && _object$lastCommitHas !== void 0 ? _object$lastCommitHas : new Uint8Array();
    message.dataHash = (_object$dataHash = object.dataHash) !== null && _object$dataHash !== void 0 ? _object$dataHash : new Uint8Array();
    message.validatorsHash = (_object$validatorsHas = object.validatorsHash) !== null && _object$validatorsHas !== void 0 ? _object$validatorsHas : new Uint8Array();
    message.nextValidatorsHash = (_object$nextValidator = object.nextValidatorsHash) !== null && _object$nextValidator !== void 0 ? _object$nextValidator : new Uint8Array();
    message.consensusHash = (_object$consensusHash = object.consensusHash) !== null && _object$consensusHash !== void 0 ? _object$consensusHash : new Uint8Array();
    message.appHash = (_object$appHash = object.appHash) !== null && _object$appHash !== void 0 ? _object$appHash : new Uint8Array();
    message.lastResultsHash = (_object$lastResultsHa = object.lastResultsHash) !== null && _object$lastResultsHa !== void 0 ? _object$lastResultsHa : new Uint8Array();
    message.evidenceHash = (_object$evidenceHash = object.evidenceHash) !== null && _object$evidenceHash !== void 0 ? _object$evidenceHash : new Uint8Array();
    message.proposerAddress = (_object$proposerAddre = object.proposerAddress) !== null && _object$proposerAddre !== void 0 ? _object$proposerAddre : new Uint8Array();
    return message;
  },

  fromAmino(object) {
    return {
      version: object !== null && object !== void 0 && object.version ? _version_types__WEBPACK_IMPORTED_MODULE_1__.Consensus.fromAmino(object.version) : undefined,
      chainId: object.chain_id,
      height: _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.fromString */ .dK.fromString(object.height),
      time: object !== null && object !== void 0 && object.time ? _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_2__.Timestamp.fromAmino(object.time) : undefined,
      lastBlockId: object !== null && object !== void 0 && object.last_block_id ? BlockID.fromAmino(object.last_block_id) : undefined,
      lastCommitHash: object.last_commit_hash,
      dataHash: object.data_hash,
      validatorsHash: object.validators_hash,
      nextValidatorsHash: object.next_validators_hash,
      consensusHash: object.consensus_hash,
      appHash: object.app_hash,
      lastResultsHash: object.last_results_hash,
      evidenceHash: object.evidence_hash,
      proposerAddress: object.proposer_address
    };
  },

  toAmino(message) {
    const obj = {};
    obj.version = message.version ? _version_types__WEBPACK_IMPORTED_MODULE_1__.Consensus.toAmino(message.version) : undefined;
    obj.chain_id = message.chainId;
    obj.height = message.height ? message.height.toString() : undefined;
    obj.time = message.time ? _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_2__.Timestamp.toAmino(message.time) : undefined;
    obj.last_block_id = message.lastBlockId ? BlockID.toAmino(message.lastBlockId) : undefined;
    obj.last_commit_hash = message.lastCommitHash;
    obj.data_hash = message.dataHash;
    obj.validators_hash = message.validatorsHash;
    obj.next_validators_hash = message.nextValidatorsHash;
    obj.consensus_hash = message.consensusHash;
    obj.app_hash = message.appHash;
    obj.last_results_hash = message.lastResultsHash;
    obj.evidence_hash = message.evidenceHash;
    obj.proposer_address = message.proposerAddress;
    return obj;
  },

  fromAminoMsg(object) {
    return Header.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return Header.decode(message.value);
  },

  toProto(message) {
    return Header.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/tendermint.types.Header",
      value: Header.encode(message).finish()
    };
  }

};

function createBaseData() {
  return {
    txs: []
  };
}

const Data = {
  typeUrl: "/tendermint.types.Data",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Writer.create()) {
    for (const v of message.txs) {
      writer.uint32(10).bytes(v);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseData();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.txs.push(reader.bytes());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$txs;

    const message = createBaseData();
    message.txs = ((_object$txs = object.txs) === null || _object$txs === void 0 ? void 0 : _object$txs.map(e => e)) || [];
    return message;
  },

  fromAmino(object) {
    return {
      txs: Array.isArray(object === null || object === void 0 ? void 0 : object.txs) ? object.txs.map(e => e) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.txs) {
      obj.txs = message.txs.map(e => e);
    } else {
      obj.txs = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return Data.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return Data.decode(message.value);
  },

  toProto(message) {
    return Data.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/tendermint.types.Data",
      value: Data.encode(message).finish()
    };
  }

};

function createBaseVote() {
  return {
    type: 0,
    height: _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.ZERO */ .dK.ZERO,
    round: 0,
    blockId: undefined,
    timestamp: undefined,
    validatorAddress: new Uint8Array(),
    validatorIndex: 0,
    signature: new Uint8Array()
  };
}

const Vote = {
  typeUrl: "/tendermint.types.Vote",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Writer.create()) {
    if (message.type !== 0) {
      writer.uint32(8).int32(message.type);
    }

    if (!message.height.isZero()) {
      writer.uint32(16).int64(message.height);
    }

    if (message.round !== 0) {
      writer.uint32(24).int32(message.round);
    }

    if (message.blockId !== undefined) {
      BlockID.encode(message.blockId, writer.uint32(34).fork()).ldelim();
    }

    if (message.timestamp !== undefined) {
      _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_2__.Timestamp.encode((0,_helpers__WEBPACK_IMPORTED_MODULE_4__/* .toTimestamp */ .Uq)(message.timestamp), writer.uint32(42).fork()).ldelim();
    }

    if (message.validatorAddress.length !== 0) {
      writer.uint32(50).bytes(message.validatorAddress);
    }

    if (message.validatorIndex !== 0) {
      writer.uint32(56).int32(message.validatorIndex);
    }

    if (message.signature.length !== 0) {
      writer.uint32(66).bytes(message.signature);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVote();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.type = reader.int32();
          break;

        case 2:
          message.height = reader.int64();
          break;

        case 3:
          message.round = reader.int32();
          break;

        case 4:
          message.blockId = BlockID.decode(reader, reader.uint32());
          break;

        case 5:
          message.timestamp = (0,_helpers__WEBPACK_IMPORTED_MODULE_4__/* .fromTimestamp */ .Ol)(_google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_2__.Timestamp.decode(reader, reader.uint32()));
          break;

        case 6:
          message.validatorAddress = reader.bytes();
          break;

        case 7:
          message.validatorIndex = reader.int32();
          break;

        case 8:
          message.signature = reader.bytes();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$type, _object$round, _object$timestamp, _object$validatorAddr, _object$validatorInde, _object$signature;

    const message = createBaseVote();
    message.type = (_object$type = object.type) !== null && _object$type !== void 0 ? _object$type : 0;
    message.height = object.height !== undefined && object.height !== null ? _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.fromValue */ .dK.fromValue(object.height) : _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.ZERO */ .dK.ZERO;
    message.round = (_object$round = object.round) !== null && _object$round !== void 0 ? _object$round : 0;
    message.blockId = object.blockId !== undefined && object.blockId !== null ? BlockID.fromPartial(object.blockId) : undefined;
    message.timestamp = (_object$timestamp = object.timestamp) !== null && _object$timestamp !== void 0 ? _object$timestamp : undefined;
    message.validatorAddress = (_object$validatorAddr = object.validatorAddress) !== null && _object$validatorAddr !== void 0 ? _object$validatorAddr : new Uint8Array();
    message.validatorIndex = (_object$validatorInde = object.validatorIndex) !== null && _object$validatorInde !== void 0 ? _object$validatorInde : 0;
    message.signature = (_object$signature = object.signature) !== null && _object$signature !== void 0 ? _object$signature : new Uint8Array();
    return message;
  },

  fromAmino(object) {
    return {
      type: (0,_helpers__WEBPACK_IMPORTED_MODULE_4__/* .isSet */ .DM)(object.type) ? signedMsgTypeFromJSON(object.type) : 0,
      height: _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.fromString */ .dK.fromString(object.height),
      round: object.round,
      blockId: object !== null && object !== void 0 && object.block_id ? BlockID.fromAmino(object.block_id) : undefined,
      timestamp: object !== null && object !== void 0 && object.timestamp ? _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_2__.Timestamp.fromAmino(object.timestamp) : undefined,
      validatorAddress: object.validator_address,
      validatorIndex: object.validator_index,
      signature: object.signature
    };
  },

  toAmino(message) {
    const obj = {};
    obj.type = message.type;
    obj.height = message.height ? message.height.toString() : undefined;
    obj.round = message.round;
    obj.block_id = message.blockId ? BlockID.toAmino(message.blockId) : undefined;
    obj.timestamp = message.timestamp ? _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_2__.Timestamp.toAmino(message.timestamp) : undefined;
    obj.validator_address = message.validatorAddress;
    obj.validator_index = message.validatorIndex;
    obj.signature = message.signature;
    return obj;
  },

  fromAminoMsg(object) {
    return Vote.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return Vote.decode(message.value);
  },

  toProto(message) {
    return Vote.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/tendermint.types.Vote",
      value: Vote.encode(message).finish()
    };
  }

};

function createBaseCommit() {
  return {
    height: _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.ZERO */ .dK.ZERO,
    round: 0,
    blockId: undefined,
    signatures: []
  };
}

const Commit = {
  typeUrl: "/tendermint.types.Commit",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Writer.create()) {
    if (!message.height.isZero()) {
      writer.uint32(8).int64(message.height);
    }

    if (message.round !== 0) {
      writer.uint32(16).int32(message.round);
    }

    if (message.blockId !== undefined) {
      BlockID.encode(message.blockId, writer.uint32(26).fork()).ldelim();
    }

    for (const v of message.signatures) {
      CommitSig.encode(v, writer.uint32(34).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCommit();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.height = reader.int64();
          break;

        case 2:
          message.round = reader.int32();
          break;

        case 3:
          message.blockId = BlockID.decode(reader, reader.uint32());
          break;

        case 4:
          message.signatures.push(CommitSig.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$round2, _object$signatures;

    const message = createBaseCommit();
    message.height = object.height !== undefined && object.height !== null ? _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.fromValue */ .dK.fromValue(object.height) : _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.ZERO */ .dK.ZERO;
    message.round = (_object$round2 = object.round) !== null && _object$round2 !== void 0 ? _object$round2 : 0;
    message.blockId = object.blockId !== undefined && object.blockId !== null ? BlockID.fromPartial(object.blockId) : undefined;
    message.signatures = ((_object$signatures = object.signatures) === null || _object$signatures === void 0 ? void 0 : _object$signatures.map(e => CommitSig.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      height: _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.fromString */ .dK.fromString(object.height),
      round: object.round,
      blockId: object !== null && object !== void 0 && object.block_id ? BlockID.fromAmino(object.block_id) : undefined,
      signatures: Array.isArray(object === null || object === void 0 ? void 0 : object.signatures) ? object.signatures.map(e => CommitSig.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.height = message.height ? message.height.toString() : undefined;
    obj.round = message.round;
    obj.block_id = message.blockId ? BlockID.toAmino(message.blockId) : undefined;

    if (message.signatures) {
      obj.signatures = message.signatures.map(e => e ? CommitSig.toAmino(e) : undefined);
    } else {
      obj.signatures = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return Commit.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return Commit.decode(message.value);
  },

  toProto(message) {
    return Commit.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/tendermint.types.Commit",
      value: Commit.encode(message).finish()
    };
  }

};

function createBaseCommitSig() {
  return {
    blockIdFlag: 0,
    validatorAddress: new Uint8Array(),
    timestamp: undefined,
    signature: new Uint8Array()
  };
}

const CommitSig = {
  typeUrl: "/tendermint.types.CommitSig",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Writer.create()) {
    if (message.blockIdFlag !== 0) {
      writer.uint32(8).int32(message.blockIdFlag);
    }

    if (message.validatorAddress.length !== 0) {
      writer.uint32(18).bytes(message.validatorAddress);
    }

    if (message.timestamp !== undefined) {
      _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_2__.Timestamp.encode((0,_helpers__WEBPACK_IMPORTED_MODULE_4__/* .toTimestamp */ .Uq)(message.timestamp), writer.uint32(26).fork()).ldelim();
    }

    if (message.signature.length !== 0) {
      writer.uint32(34).bytes(message.signature);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCommitSig();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.blockIdFlag = reader.int32();
          break;

        case 2:
          message.validatorAddress = reader.bytes();
          break;

        case 3:
          message.timestamp = (0,_helpers__WEBPACK_IMPORTED_MODULE_4__/* .fromTimestamp */ .Ol)(_google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_2__.Timestamp.decode(reader, reader.uint32()));
          break;

        case 4:
          message.signature = reader.bytes();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$blockIdFlag, _object$validatorAddr2, _object$timestamp2, _object$signature2;

    const message = createBaseCommitSig();
    message.blockIdFlag = (_object$blockIdFlag = object.blockIdFlag) !== null && _object$blockIdFlag !== void 0 ? _object$blockIdFlag : 0;
    message.validatorAddress = (_object$validatorAddr2 = object.validatorAddress) !== null && _object$validatorAddr2 !== void 0 ? _object$validatorAddr2 : new Uint8Array();
    message.timestamp = (_object$timestamp2 = object.timestamp) !== null && _object$timestamp2 !== void 0 ? _object$timestamp2 : undefined;
    message.signature = (_object$signature2 = object.signature) !== null && _object$signature2 !== void 0 ? _object$signature2 : new Uint8Array();
    return message;
  },

  fromAmino(object) {
    return {
      blockIdFlag: (0,_helpers__WEBPACK_IMPORTED_MODULE_4__/* .isSet */ .DM)(object.block_id_flag) ? blockIDFlagFromJSON(object.block_id_flag) : 0,
      validatorAddress: object.validator_address,
      timestamp: object !== null && object !== void 0 && object.timestamp ? _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_2__.Timestamp.fromAmino(object.timestamp) : undefined,
      signature: object.signature
    };
  },

  toAmino(message) {
    const obj = {};
    obj.block_id_flag = message.blockIdFlag;
    obj.validator_address = message.validatorAddress;
    obj.timestamp = message.timestamp ? _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_2__.Timestamp.toAmino(message.timestamp) : undefined;
    obj.signature = message.signature;
    return obj;
  },

  fromAminoMsg(object) {
    return CommitSig.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return CommitSig.decode(message.value);
  },

  toProto(message) {
    return CommitSig.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/tendermint.types.CommitSig",
      value: CommitSig.encode(message).finish()
    };
  }

};

function createBaseProposal() {
  return {
    type: 0,
    height: _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.ZERO */ .dK.ZERO,
    round: 0,
    polRound: 0,
    blockId: undefined,
    timestamp: undefined,
    signature: new Uint8Array()
  };
}

const Proposal = {
  typeUrl: "/tendermint.types.Proposal",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Writer.create()) {
    if (message.type !== 0) {
      writer.uint32(8).int32(message.type);
    }

    if (!message.height.isZero()) {
      writer.uint32(16).int64(message.height);
    }

    if (message.round !== 0) {
      writer.uint32(24).int32(message.round);
    }

    if (message.polRound !== 0) {
      writer.uint32(32).int32(message.polRound);
    }

    if (message.blockId !== undefined) {
      BlockID.encode(message.blockId, writer.uint32(42).fork()).ldelim();
    }

    if (message.timestamp !== undefined) {
      _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_2__.Timestamp.encode((0,_helpers__WEBPACK_IMPORTED_MODULE_4__/* .toTimestamp */ .Uq)(message.timestamp), writer.uint32(50).fork()).ldelim();
    }

    if (message.signature.length !== 0) {
      writer.uint32(58).bytes(message.signature);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseProposal();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.type = reader.int32();
          break;

        case 2:
          message.height = reader.int64();
          break;

        case 3:
          message.round = reader.int32();
          break;

        case 4:
          message.polRound = reader.int32();
          break;

        case 5:
          message.blockId = BlockID.decode(reader, reader.uint32());
          break;

        case 6:
          message.timestamp = (0,_helpers__WEBPACK_IMPORTED_MODULE_4__/* .fromTimestamp */ .Ol)(_google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_2__.Timestamp.decode(reader, reader.uint32()));
          break;

        case 7:
          message.signature = reader.bytes();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$type2, _object$round3, _object$polRound, _object$timestamp3, _object$signature3;

    const message = createBaseProposal();
    message.type = (_object$type2 = object.type) !== null && _object$type2 !== void 0 ? _object$type2 : 0;
    message.height = object.height !== undefined && object.height !== null ? _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.fromValue */ .dK.fromValue(object.height) : _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.ZERO */ .dK.ZERO;
    message.round = (_object$round3 = object.round) !== null && _object$round3 !== void 0 ? _object$round3 : 0;
    message.polRound = (_object$polRound = object.polRound) !== null && _object$polRound !== void 0 ? _object$polRound : 0;
    message.blockId = object.blockId !== undefined && object.blockId !== null ? BlockID.fromPartial(object.blockId) : undefined;
    message.timestamp = (_object$timestamp3 = object.timestamp) !== null && _object$timestamp3 !== void 0 ? _object$timestamp3 : undefined;
    message.signature = (_object$signature3 = object.signature) !== null && _object$signature3 !== void 0 ? _object$signature3 : new Uint8Array();
    return message;
  },

  fromAmino(object) {
    return {
      type: (0,_helpers__WEBPACK_IMPORTED_MODULE_4__/* .isSet */ .DM)(object.type) ? signedMsgTypeFromJSON(object.type) : 0,
      height: _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.fromString */ .dK.fromString(object.height),
      round: object.round,
      polRound: object.pol_round,
      blockId: object !== null && object !== void 0 && object.block_id ? BlockID.fromAmino(object.block_id) : undefined,
      timestamp: object !== null && object !== void 0 && object.timestamp ? _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_2__.Timestamp.fromAmino(object.timestamp) : undefined,
      signature: object.signature
    };
  },

  toAmino(message) {
    const obj = {};
    obj.type = message.type;
    obj.height = message.height ? message.height.toString() : undefined;
    obj.round = message.round;
    obj.pol_round = message.polRound;
    obj.block_id = message.blockId ? BlockID.toAmino(message.blockId) : undefined;
    obj.timestamp = message.timestamp ? _google_protobuf_timestamp__WEBPACK_IMPORTED_MODULE_2__.Timestamp.toAmino(message.timestamp) : undefined;
    obj.signature = message.signature;
    return obj;
  },

  fromAminoMsg(object) {
    return Proposal.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return Proposal.decode(message.value);
  },

  toProto(message) {
    return Proposal.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/tendermint.types.Proposal",
      value: Proposal.encode(message).finish()
    };
  }

};

function createBaseSignedHeader() {
  return {
    header: undefined,
    commit: undefined
  };
}

const SignedHeader = {
  typeUrl: "/tendermint.types.SignedHeader",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Writer.create()) {
    if (message.header !== undefined) {
      Header.encode(message.header, writer.uint32(10).fork()).ldelim();
    }

    if (message.commit !== undefined) {
      Commit.encode(message.commit, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSignedHeader();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.header = Header.decode(reader, reader.uint32());
          break;

        case 2:
          message.commit = Commit.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseSignedHeader();
    message.header = object.header !== undefined && object.header !== null ? Header.fromPartial(object.header) : undefined;
    message.commit = object.commit !== undefined && object.commit !== null ? Commit.fromPartial(object.commit) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      header: object !== null && object !== void 0 && object.header ? Header.fromAmino(object.header) : undefined,
      commit: object !== null && object !== void 0 && object.commit ? Commit.fromAmino(object.commit) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.header = message.header ? Header.toAmino(message.header) : undefined;
    obj.commit = message.commit ? Commit.toAmino(message.commit) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return SignedHeader.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return SignedHeader.decode(message.value);
  },

  toProto(message) {
    return SignedHeader.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/tendermint.types.SignedHeader",
      value: SignedHeader.encode(message).finish()
    };
  }

};

function createBaseLightBlock() {
  return {
    signedHeader: undefined,
    validatorSet: undefined
  };
}

const LightBlock = {
  typeUrl: "/tendermint.types.LightBlock",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Writer.create()) {
    if (message.signedHeader !== undefined) {
      SignedHeader.encode(message.signedHeader, writer.uint32(10).fork()).ldelim();
    }

    if (message.validatorSet !== undefined) {
      _validator__WEBPACK_IMPORTED_MODULE_3__.ValidatorSet.encode(message.validatorSet, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLightBlock();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.signedHeader = SignedHeader.decode(reader, reader.uint32());
          break;

        case 2:
          message.validatorSet = _validator__WEBPACK_IMPORTED_MODULE_3__.ValidatorSet.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseLightBlock();
    message.signedHeader = object.signedHeader !== undefined && object.signedHeader !== null ? SignedHeader.fromPartial(object.signedHeader) : undefined;
    message.validatorSet = object.validatorSet !== undefined && object.validatorSet !== null ? _validator__WEBPACK_IMPORTED_MODULE_3__.ValidatorSet.fromPartial(object.validatorSet) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      signedHeader: object !== null && object !== void 0 && object.signed_header ? SignedHeader.fromAmino(object.signed_header) : undefined,
      validatorSet: object !== null && object !== void 0 && object.validator_set ? _validator__WEBPACK_IMPORTED_MODULE_3__.ValidatorSet.fromAmino(object.validator_set) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.signed_header = message.signedHeader ? SignedHeader.toAmino(message.signedHeader) : undefined;
    obj.validator_set = message.validatorSet ? _validator__WEBPACK_IMPORTED_MODULE_3__.ValidatorSet.toAmino(message.validatorSet) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return LightBlock.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return LightBlock.decode(message.value);
  },

  toProto(message) {
    return LightBlock.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/tendermint.types.LightBlock",
      value: LightBlock.encode(message).finish()
    };
  }

};

function createBaseBlockMeta() {
  return {
    blockId: undefined,
    blockSize: _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.ZERO */ .dK.ZERO,
    header: undefined,
    numTxs: _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.ZERO */ .dK.ZERO
  };
}

const BlockMeta = {
  typeUrl: "/tendermint.types.BlockMeta",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Writer.create()) {
    if (message.blockId !== undefined) {
      BlockID.encode(message.blockId, writer.uint32(10).fork()).ldelim();
    }

    if (!message.blockSize.isZero()) {
      writer.uint32(16).int64(message.blockSize);
    }

    if (message.header !== undefined) {
      Header.encode(message.header, writer.uint32(26).fork()).ldelim();
    }

    if (!message.numTxs.isZero()) {
      writer.uint32(32).int64(message.numTxs);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBlockMeta();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.blockId = BlockID.decode(reader, reader.uint32());
          break;

        case 2:
          message.blockSize = reader.int64();
          break;

        case 3:
          message.header = Header.decode(reader, reader.uint32());
          break;

        case 4:
          message.numTxs = reader.int64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseBlockMeta();
    message.blockId = object.blockId !== undefined && object.blockId !== null ? BlockID.fromPartial(object.blockId) : undefined;
    message.blockSize = object.blockSize !== undefined && object.blockSize !== null ? _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.fromValue */ .dK.fromValue(object.blockSize) : _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.ZERO */ .dK.ZERO;
    message.header = object.header !== undefined && object.header !== null ? Header.fromPartial(object.header) : undefined;
    message.numTxs = object.numTxs !== undefined && object.numTxs !== null ? _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.fromValue */ .dK.fromValue(object.numTxs) : _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.ZERO */ .dK.ZERO;
    return message;
  },

  fromAmino(object) {
    return {
      blockId: object !== null && object !== void 0 && object.block_id ? BlockID.fromAmino(object.block_id) : undefined,
      blockSize: _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.fromString */ .dK.fromString(object.block_size),
      header: object !== null && object !== void 0 && object.header ? Header.fromAmino(object.header) : undefined,
      numTxs: _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Long.fromString */ .dK.fromString(object.num_txs)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.block_id = message.blockId ? BlockID.toAmino(message.blockId) : undefined;
    obj.block_size = message.blockSize ? message.blockSize.toString() : undefined;
    obj.header = message.header ? Header.toAmino(message.header) : undefined;
    obj.num_txs = message.numTxs ? message.numTxs.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return BlockMeta.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return BlockMeta.decode(message.value);
  },

  toProto(message) {
    return BlockMeta.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/tendermint.types.BlockMeta",
      value: BlockMeta.encode(message).finish()
    };
  }

};

function createBaseTxProof() {
  return {
    rootHash: new Uint8Array(),
    data: new Uint8Array(),
    proof: undefined
  };
}

const TxProof = {
  typeUrl: "/tendermint.types.TxProof",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Writer.create()) {
    if (message.rootHash.length !== 0) {
      writer.uint32(10).bytes(message.rootHash);
    }

    if (message.data.length !== 0) {
      writer.uint32(18).bytes(message.data);
    }

    if (message.proof !== undefined) {
      _crypto_proof__WEBPACK_IMPORTED_MODULE_0__.Proof.encode(message.proof, writer.uint32(26).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_5__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTxProof();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.rootHash = reader.bytes();
          break;

        case 2:
          message.data = reader.bytes();
          break;

        case 3:
          message.proof = _crypto_proof__WEBPACK_IMPORTED_MODULE_0__.Proof.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$rootHash, _object$data;

    const message = createBaseTxProof();
    message.rootHash = (_object$rootHash = object.rootHash) !== null && _object$rootHash !== void 0 ? _object$rootHash : new Uint8Array();
    message.data = (_object$data = object.data) !== null && _object$data !== void 0 ? _object$data : new Uint8Array();
    message.proof = object.proof !== undefined && object.proof !== null ? _crypto_proof__WEBPACK_IMPORTED_MODULE_0__.Proof.fromPartial(object.proof) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      rootHash: object.root_hash,
      data: object.data,
      proof: object !== null && object !== void 0 && object.proof ? _crypto_proof__WEBPACK_IMPORTED_MODULE_0__.Proof.fromAmino(object.proof) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.root_hash = message.rootHash;
    obj.data = message.data;
    obj.proof = message.proof ? _crypto_proof__WEBPACK_IMPORTED_MODULE_0__.Proof.toAmino(message.proof) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return TxProof.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return TxProof.decode(message.value);
  },

  toProto(message) {
    return TxProof.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/tendermint.types.TxProof",
      value: TxProof.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 70850:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SimpleValidator": function() { return /* binding */ SimpleValidator; },
/* harmony export */   "Validator": function() { return /* binding */ Validator; },
/* harmony export */   "ValidatorSet": function() { return /* binding */ ValidatorSet; }
/* harmony export */ });
/* harmony import */ var _crypto_keys__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79246);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47895);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__);




function createBaseValidatorSet() {
  return {
    validators: [],
    proposer: undefined,
    totalVotingPower: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.ZERO */ .dK.ZERO
  };
}

const ValidatorSet = {
  typeUrl: "/tendermint.types.ValidatorSet",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    for (const v of message.validators) {
      Validator.encode(v, writer.uint32(10).fork()).ldelim();
    }

    if (message.proposer !== undefined) {
      Validator.encode(message.proposer, writer.uint32(18).fork()).ldelim();
    }

    if (!message.totalVotingPower.isZero()) {
      writer.uint32(24).int64(message.totalVotingPower);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseValidatorSet();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.validators.push(Validator.decode(reader, reader.uint32()));
          break;

        case 2:
          message.proposer = Validator.decode(reader, reader.uint32());
          break;

        case 3:
          message.totalVotingPower = reader.int64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$validators;

    const message = createBaseValidatorSet();
    message.validators = ((_object$validators = object.validators) === null || _object$validators === void 0 ? void 0 : _object$validators.map(e => Validator.fromPartial(e))) || [];
    message.proposer = object.proposer !== undefined && object.proposer !== null ? Validator.fromPartial(object.proposer) : undefined;
    message.totalVotingPower = object.totalVotingPower !== undefined && object.totalVotingPower !== null ? _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromValue */ .dK.fromValue(object.totalVotingPower) : _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.ZERO */ .dK.ZERO;
    return message;
  },

  fromAmino(object) {
    return {
      validators: Array.isArray(object === null || object === void 0 ? void 0 : object.validators) ? object.validators.map(e => Validator.fromAmino(e)) : [],
      proposer: object !== null && object !== void 0 && object.proposer ? Validator.fromAmino(object.proposer) : undefined,
      totalVotingPower: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromString */ .dK.fromString(object.total_voting_power)
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.validators) {
      obj.validators = message.validators.map(e => e ? Validator.toAmino(e) : undefined);
    } else {
      obj.validators = [];
    }

    obj.proposer = message.proposer ? Validator.toAmino(message.proposer) : undefined;
    obj.total_voting_power = message.totalVotingPower ? message.totalVotingPower.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return ValidatorSet.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return ValidatorSet.decode(message.value);
  },

  toProto(message) {
    return ValidatorSet.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/tendermint.types.ValidatorSet",
      value: ValidatorSet.encode(message).finish()
    };
  }

};

function createBaseValidator() {
  return {
    address: new Uint8Array(),
    pubKey: undefined,
    votingPower: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.ZERO */ .dK.ZERO,
    proposerPriority: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.ZERO */ .dK.ZERO
  };
}

const Validator = {
  typeUrl: "/tendermint.types.Validator",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (message.address.length !== 0) {
      writer.uint32(10).bytes(message.address);
    }

    if (message.pubKey !== undefined) {
      _crypto_keys__WEBPACK_IMPORTED_MODULE_0__.PublicKey.encode(message.pubKey, writer.uint32(18).fork()).ldelim();
    }

    if (!message.votingPower.isZero()) {
      writer.uint32(24).int64(message.votingPower);
    }

    if (!message.proposerPriority.isZero()) {
      writer.uint32(32).int64(message.proposerPriority);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseValidator();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.address = reader.bytes();
          break;

        case 2:
          message.pubKey = _crypto_keys__WEBPACK_IMPORTED_MODULE_0__.PublicKey.decode(reader, reader.uint32());
          break;

        case 3:
          message.votingPower = reader.int64();
          break;

        case 4:
          message.proposerPriority = reader.int64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$address;

    const message = createBaseValidator();
    message.address = (_object$address = object.address) !== null && _object$address !== void 0 ? _object$address : new Uint8Array();
    message.pubKey = object.pubKey !== undefined && object.pubKey !== null ? _crypto_keys__WEBPACK_IMPORTED_MODULE_0__.PublicKey.fromPartial(object.pubKey) : undefined;
    message.votingPower = object.votingPower !== undefined && object.votingPower !== null ? _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromValue */ .dK.fromValue(object.votingPower) : _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.ZERO */ .dK.ZERO;
    message.proposerPriority = object.proposerPriority !== undefined && object.proposerPriority !== null ? _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromValue */ .dK.fromValue(object.proposerPriority) : _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.ZERO */ .dK.ZERO;
    return message;
  },

  fromAmino(object) {
    return {
      address: object.address,
      pubKey: object !== null && object !== void 0 && object.pub_key ? _crypto_keys__WEBPACK_IMPORTED_MODULE_0__.PublicKey.fromAmino(object.pub_key) : undefined,
      votingPower: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromString */ .dK.fromString(object.voting_power),
      proposerPriority: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromString */ .dK.fromString(object.proposer_priority)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.address = message.address;
    obj.pub_key = message.pubKey ? _crypto_keys__WEBPACK_IMPORTED_MODULE_0__.PublicKey.toAmino(message.pubKey) : undefined;
    obj.voting_power = message.votingPower ? message.votingPower.toString() : undefined;
    obj.proposer_priority = message.proposerPriority ? message.proposerPriority.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return Validator.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return Validator.decode(message.value);
  },

  toProto(message) {
    return Validator.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/tendermint.types.Validator",
      value: Validator.encode(message).finish()
    };
  }

};

function createBaseSimpleValidator() {
  return {
    pubKey: undefined,
    votingPower: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.ZERO */ .dK.ZERO
  };
}

const SimpleValidator = {
  typeUrl: "/tendermint.types.SimpleValidator",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Writer.create()) {
    if (message.pubKey !== undefined) {
      _crypto_keys__WEBPACK_IMPORTED_MODULE_0__.PublicKey.encode(message.pubKey, writer.uint32(10).fork()).ldelim();
    }

    if (!message.votingPower.isZero()) {
      writer.uint32(16).int64(message.votingPower);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_2__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSimpleValidator();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.pubKey = _crypto_keys__WEBPACK_IMPORTED_MODULE_0__.PublicKey.decode(reader, reader.uint32());
          break;

        case 2:
          message.votingPower = reader.int64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseSimpleValidator();
    message.pubKey = object.pubKey !== undefined && object.pubKey !== null ? _crypto_keys__WEBPACK_IMPORTED_MODULE_0__.PublicKey.fromPartial(object.pubKey) : undefined;
    message.votingPower = object.votingPower !== undefined && object.votingPower !== null ? _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromValue */ .dK.fromValue(object.votingPower) : _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.ZERO */ .dK.ZERO;
    return message;
  },

  fromAmino(object) {
    return {
      pubKey: object !== null && object !== void 0 && object.pub_key ? _crypto_keys__WEBPACK_IMPORTED_MODULE_0__.PublicKey.fromAmino(object.pub_key) : undefined,
      votingPower: _helpers__WEBPACK_IMPORTED_MODULE_1__/* .Long.fromString */ .dK.fromString(object.voting_power)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.pub_key = message.pubKey ? _crypto_keys__WEBPACK_IMPORTED_MODULE_0__.PublicKey.toAmino(message.pubKey) : undefined;
    obj.voting_power = message.votingPower ? message.votingPower.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return SimpleValidator.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return SimpleValidator.decode(message.value);
  },

  toProto(message) {
    return SimpleValidator.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/tendermint.types.SimpleValidator",
      value: SimpleValidator.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 88537:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "App": function() { return /* binding */ App; },
/* harmony export */   "Consensus": function() { return /* binding */ Consensus; }
/* harmony export */ });
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47895);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62100);
/* harmony import */ var protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__);


/**
 * App includes the protocol and software version for the application.
 * This information is included in ResponseInfo. The App.Protocol can be
 * updated in ResponseEndBlock.
 */

function createBaseApp() {
  return {
    protocol: _helpers__WEBPACK_IMPORTED_MODULE_0__/* .Long.UZERO */ .dK.UZERO,
    software: ""
  };
}

const App = {
  typeUrl: "/tendermint.version.App",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Writer.create()) {
    if (!message.protocol.isZero()) {
      writer.uint32(8).uint64(message.protocol);
    }

    if (message.software !== "") {
      writer.uint32(18).string(message.software);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseApp();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.protocol = reader.uint64();
          break;

        case 2:
          message.software = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$software;

    const message = createBaseApp();
    message.protocol = object.protocol !== undefined && object.protocol !== null ? _helpers__WEBPACK_IMPORTED_MODULE_0__/* .Long.fromValue */ .dK.fromValue(object.protocol) : _helpers__WEBPACK_IMPORTED_MODULE_0__/* .Long.UZERO */ .dK.UZERO;
    message.software = (_object$software = object.software) !== null && _object$software !== void 0 ? _object$software : "";
    return message;
  },

  fromAmino(object) {
    return {
      protocol: _helpers__WEBPACK_IMPORTED_MODULE_0__/* .Long.fromString */ .dK.fromString(object.protocol),
      software: object.software
    };
  },

  toAmino(message) {
    const obj = {};
    obj.protocol = message.protocol ? message.protocol.toString() : undefined;
    obj.software = message.software;
    return obj;
  },

  fromAminoMsg(object) {
    return App.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return App.decode(message.value);
  },

  toProto(message) {
    return App.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/tendermint.version.App",
      value: App.encode(message).finish()
    };
  }

};

function createBaseConsensus() {
  return {
    block: _helpers__WEBPACK_IMPORTED_MODULE_0__/* .Long.UZERO */ .dK.UZERO,
    app: _helpers__WEBPACK_IMPORTED_MODULE_0__/* .Long.UZERO */ .dK.UZERO
  };
}

const Consensus = {
  typeUrl: "/tendermint.version.Consensus",

  encode(message, writer = protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Writer.create()) {
    if (!message.block.isZero()) {
      writer.uint32(8).uint64(message.block);
    }

    if (!message.app.isZero()) {
      writer.uint32(16).uint64(message.app);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader ? input : new protobufjs_minimal__WEBPACK_IMPORTED_MODULE_1__.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseConsensus();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.block = reader.uint64();
          break;

        case 2:
          message.app = reader.uint64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseConsensus();
    message.block = object.block !== undefined && object.block !== null ? _helpers__WEBPACK_IMPORTED_MODULE_0__/* .Long.fromValue */ .dK.fromValue(object.block) : _helpers__WEBPACK_IMPORTED_MODULE_0__/* .Long.UZERO */ .dK.UZERO;
    message.app = object.app !== undefined && object.app !== null ? _helpers__WEBPACK_IMPORTED_MODULE_0__/* .Long.fromValue */ .dK.fromValue(object.app) : _helpers__WEBPACK_IMPORTED_MODULE_0__/* .Long.UZERO */ .dK.UZERO;
    return message;
  },

  fromAmino(object) {
    return {
      block: _helpers__WEBPACK_IMPORTED_MODULE_0__/* .Long.fromString */ .dK.fromString(object.block),
      app: _helpers__WEBPACK_IMPORTED_MODULE_0__/* .Long.fromString */ .dK.fromString(object.app)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.block = message.block ? message.block.toString() : undefined;
    obj.app = message.app ? message.app.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return Consensus.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return Consensus.decode(message.value);
  },

  toProto(message) {
    return Consensus.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/tendermint.version.Consensus",
      value: Consensus.encode(message).finish()
    };
  }

};

/***/ }),

/***/ 7044:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Xx": function() { return /* reexport */ osmosis; }
});

// UNUSED EXPORTS: FEES, FEE_VALUES, GAS_VALUES, amino, capability, cosmos, cosmosAminoConverters, cosmosProtoRegistry, cosmos_proto, cosmwasm, cosmwasmAminoConverters, cosmwasmProtoRegistry, estimateOsmoFee, getSigningCosmosClient, getSigningCosmosClientOptions, getSigningCosmwasmClient, getSigningCosmwasmClientOptions, getSigningIbcClient, getSigningIbcClientOptions, getSigningOsmosisClient, getSigningOsmosisClientOptions, gogoproto, google, ibc, ibcAminoConverters, ibcProtoRegistry, ics23, osmosisAminoConverters, osmosisProtoRegistry, tendermint

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/cosmos/auth/v1beta1/genesis.js
var genesis_namespaceObject = {};
__webpack_require__.r(genesis_namespaceObject);
__webpack_require__.d(genesis_namespaceObject, {
  "GenesisState": function() { return GenesisState; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/cosmos/authz/v1beta1/event.js
var event_namespaceObject = {};
__webpack_require__.r(event_namespaceObject);
__webpack_require__.d(event_namespaceObject, {
  "EventGrant": function() { return EventGrant; },
  "EventRevoke": function() { return EventRevoke; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/cosmos/authz/v1beta1/genesis.js
var v1beta1_genesis_namespaceObject = {};
__webpack_require__.r(v1beta1_genesis_namespaceObject);
__webpack_require__.d(v1beta1_genesis_namespaceObject, {
  "GenesisState": function() { return genesis_GenesisState; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/cosmos/bank/v1beta1/genesis.js
var bank_v1beta1_genesis_namespaceObject = {};
__webpack_require__.r(bank_v1beta1_genesis_namespaceObject);
__webpack_require__.d(bank_v1beta1_genesis_namespaceObject, {
  "Balance": function() { return Balance; },
  "GenesisState": function() { return v1beta1_genesis_GenesisState; },
  "GenesisSupplyOffset": function() { return GenesisSupplyOffset; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/cosmos/base/reflection/v2alpha1/reflection.js
var reflection_namespaceObject = {};
__webpack_require__.r(reflection_namespaceObject);
__webpack_require__.d(reflection_namespaceObject, {
  "AppDescriptor": function() { return AppDescriptor; },
  "AuthnDescriptor": function() { return AuthnDescriptor; },
  "ChainDescriptor": function() { return ChainDescriptor; },
  "CodecDescriptor": function() { return CodecDescriptor; },
  "ConfigurationDescriptor": function() { return ConfigurationDescriptor; },
  "GetAuthnDescriptorRequest": function() { return GetAuthnDescriptorRequest; },
  "GetAuthnDescriptorResponse": function() { return GetAuthnDescriptorResponse; },
  "GetChainDescriptorRequest": function() { return GetChainDescriptorRequest; },
  "GetChainDescriptorResponse": function() { return GetChainDescriptorResponse; },
  "GetCodecDescriptorRequest": function() { return GetCodecDescriptorRequest; },
  "GetCodecDescriptorResponse": function() { return GetCodecDescriptorResponse; },
  "GetConfigurationDescriptorRequest": function() { return GetConfigurationDescriptorRequest; },
  "GetConfigurationDescriptorResponse": function() { return GetConfigurationDescriptorResponse; },
  "GetQueryServicesDescriptorRequest": function() { return GetQueryServicesDescriptorRequest; },
  "GetQueryServicesDescriptorResponse": function() { return GetQueryServicesDescriptorResponse; },
  "GetTxDescriptorRequest": function() { return GetTxDescriptorRequest; },
  "GetTxDescriptorResponse": function() { return GetTxDescriptorResponse; },
  "InterfaceAcceptingMessageDescriptor": function() { return InterfaceAcceptingMessageDescriptor; },
  "InterfaceDescriptor": function() { return InterfaceDescriptor; },
  "InterfaceImplementerDescriptor": function() { return InterfaceImplementerDescriptor; },
  "MsgDescriptor": function() { return MsgDescriptor; },
  "QueryMethodDescriptor": function() { return QueryMethodDescriptor; },
  "QueryServiceDescriptor": function() { return QueryServiceDescriptor; },
  "QueryServicesDescriptor": function() { return QueryServicesDescriptor; },
  "SigningModeDescriptor": function() { return SigningModeDescriptor; },
  "TxDescriptor": function() { return TxDescriptor; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/cosmos/crypto/ed25519/keys.js
var keys_namespaceObject = {};
__webpack_require__.r(keys_namespaceObject);
__webpack_require__.d(keys_namespaceObject, {
  "PrivKey": function() { return PrivKey; },
  "PubKey": function() { return PubKey; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/cosmos/crypto/multisig/keys.js
var multisig_keys_namespaceObject = {};
__webpack_require__.r(multisig_keys_namespaceObject);
__webpack_require__.d(multisig_keys_namespaceObject, {
  "LegacyAminoPubKey": function() { return LegacyAminoPubKey; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/cosmos/crypto/secp256k1/keys.js
var secp256k1_keys_namespaceObject = {};
__webpack_require__.r(secp256k1_keys_namespaceObject);
__webpack_require__.d(secp256k1_keys_namespaceObject, {
  "PrivKey": function() { return keys_PrivKey; },
  "PubKey": function() { return keys_PubKey; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/cosmos/crypto/secp256r1/keys.js
var secp256r1_keys_namespaceObject = {};
__webpack_require__.r(secp256r1_keys_namespaceObject);
__webpack_require__.d(secp256r1_keys_namespaceObject, {
  "PrivKey": function() { return secp256r1_keys_PrivKey; },
  "PubKey": function() { return secp256r1_keys_PubKey; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/cosmos/distribution/v1beta1/genesis.js
var distribution_v1beta1_genesis_namespaceObject = {};
__webpack_require__.r(distribution_v1beta1_genesis_namespaceObject);
__webpack_require__.d(distribution_v1beta1_genesis_namespaceObject, {
  "DelegatorStartingInfoRecord": function() { return DelegatorStartingInfoRecord; },
  "DelegatorWithdrawInfo": function() { return DelegatorWithdrawInfo; },
  "GenesisState": function() { return distribution_v1beta1_genesis_GenesisState; },
  "ValidatorAccumulatedCommissionRecord": function() { return ValidatorAccumulatedCommissionRecord; },
  "ValidatorCurrentRewardsRecord": function() { return ValidatorCurrentRewardsRecord; },
  "ValidatorHistoricalRewardsRecord": function() { return ValidatorHistoricalRewardsRecord; },
  "ValidatorOutstandingRewardsRecord": function() { return ValidatorOutstandingRewardsRecord; },
  "ValidatorSlashEventRecord": function() { return ValidatorSlashEventRecord; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/cosmos/gov/v1beta1/genesis.js
var gov_v1beta1_genesis_namespaceObject = {};
__webpack_require__.r(gov_v1beta1_genesis_namespaceObject);
__webpack_require__.d(gov_v1beta1_genesis_namespaceObject, {
  "GenesisState": function() { return gov_v1beta1_genesis_GenesisState; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/cosmos/staking/v1beta1/genesis.js
var staking_v1beta1_genesis_namespaceObject = {};
__webpack_require__.r(staking_v1beta1_genesis_namespaceObject);
__webpack_require__.d(staking_v1beta1_genesis_namespaceObject, {
  "GenesisState": function() { return staking_v1beta1_genesis_GenesisState; },
  "LastValidatorPower": function() { return LastValidatorPower; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/cosmos/authz/v1beta1/tx.amino.js
var tx_amino_namespaceObject = {};
__webpack_require__.r(tx_amino_namespaceObject);
__webpack_require__.d(tx_amino_namespaceObject, {
  "AminoConverter": function() { return AminoConverter; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/cosmos/bank/v1beta1/tx.amino.js
var v1beta1_tx_amino_namespaceObject = {};
__webpack_require__.r(v1beta1_tx_amino_namespaceObject);
__webpack_require__.d(v1beta1_tx_amino_namespaceObject, {
  "AminoConverter": function() { return tx_amino_AminoConverter; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/cosmos/distribution/v1beta1/tx.amino.js
var distribution_v1beta1_tx_amino_namespaceObject = {};
__webpack_require__.r(distribution_v1beta1_tx_amino_namespaceObject);
__webpack_require__.d(distribution_v1beta1_tx_amino_namespaceObject, {
  "AminoConverter": function() { return v1beta1_tx_amino_AminoConverter; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/cosmos/gov/v1beta1/tx.amino.js
var gov_v1beta1_tx_amino_namespaceObject = {};
__webpack_require__.r(gov_v1beta1_tx_amino_namespaceObject);
__webpack_require__.d(gov_v1beta1_tx_amino_namespaceObject, {
  "AminoConverter": function() { return gov_v1beta1_tx_amino_AminoConverter; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/cosmos/staking/v1beta1/tx.amino.js
var staking_v1beta1_tx_amino_namespaceObject = {};
__webpack_require__.r(staking_v1beta1_tx_amino_namespaceObject);
__webpack_require__.d(staking_v1beta1_tx_amino_namespaceObject, {
  "AminoConverter": function() { return staking_v1beta1_tx_amino_AminoConverter; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/cosmos/authz/v1beta1/tx.registry.js
var tx_registry_namespaceObject = {};
__webpack_require__.r(tx_registry_namespaceObject);
__webpack_require__.d(tx_registry_namespaceObject, {
  "MessageComposer": function() { return MessageComposer; },
  "load": function() { return load; },
  "registry": function() { return registry; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/cosmos/bank/v1beta1/tx.registry.js
var v1beta1_tx_registry_namespaceObject = {};
__webpack_require__.r(v1beta1_tx_registry_namespaceObject);
__webpack_require__.d(v1beta1_tx_registry_namespaceObject, {
  "MessageComposer": function() { return tx_registry_MessageComposer; },
  "load": function() { return tx_registry_load; },
  "registry": function() { return tx_registry_registry; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/cosmos/distribution/v1beta1/tx.registry.js
var distribution_v1beta1_tx_registry_namespaceObject = {};
__webpack_require__.r(distribution_v1beta1_tx_registry_namespaceObject);
__webpack_require__.d(distribution_v1beta1_tx_registry_namespaceObject, {
  "MessageComposer": function() { return v1beta1_tx_registry_MessageComposer; },
  "load": function() { return v1beta1_tx_registry_load; },
  "registry": function() { return v1beta1_tx_registry_registry; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/cosmos/gov/v1beta1/tx.registry.js
var gov_v1beta1_tx_registry_namespaceObject = {};
__webpack_require__.r(gov_v1beta1_tx_registry_namespaceObject);
__webpack_require__.d(gov_v1beta1_tx_registry_namespaceObject, {
  "MessageComposer": function() { return gov_v1beta1_tx_registry_MessageComposer; },
  "load": function() { return gov_v1beta1_tx_registry_load; },
  "registry": function() { return gov_v1beta1_tx_registry_registry; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/cosmos/staking/v1beta1/tx.registry.js
var staking_v1beta1_tx_registry_namespaceObject = {};
__webpack_require__.r(staking_v1beta1_tx_registry_namespaceObject);
__webpack_require__.d(staking_v1beta1_tx_registry_namespaceObject, {
  "MessageComposer": function() { return staking_v1beta1_tx_registry_MessageComposer; },
  "load": function() { return staking_v1beta1_tx_registry_load; },
  "registry": function() { return staking_v1beta1_tx_registry_registry; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/cosmos/lcd.js
var lcd_namespaceObject = {};
__webpack_require__.r(lcd_namespaceObject);
__webpack_require__.d(lcd_namespaceObject, {
  "createLCDClient": function() { return createLCDClient; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/cosmos/rpc.query.js
var rpc_query_namespaceObject = {};
__webpack_require__.r(rpc_query_namespaceObject);
__webpack_require__.d(rpc_query_namespaceObject, {
  "createRPCQueryClient": function() { return createRPCQueryClient; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/cosmos/rpc.tx.js
var rpc_tx_namespaceObject = {};
__webpack_require__.r(rpc_tx_namespaceObject);
__webpack_require__.d(rpc_tx_namespaceObject, {
  "createRPCMsgClient": function() { return createRPCMsgClient; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/amino/amino.js
var amino_namespaceObject = {};
__webpack_require__.r(amino_namespaceObject);

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/tendermint/libs/bits/types.js
var types_namespaceObject = {};
__webpack_require__.r(types_namespaceObject);
__webpack_require__.d(types_namespaceObject, {
  "BitArray": function() { return BitArray; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/tendermint/p2p/types.js
var p2p_types_namespaceObject = {};
__webpack_require__.r(p2p_types_namespaceObject);
__webpack_require__.d(p2p_types_namespaceObject, {
  "DefaultNodeInfo": function() { return DefaultNodeInfo; },
  "DefaultNodeInfoOther": function() { return DefaultNodeInfoOther; },
  "NetAddress": function() { return NetAddress; },
  "ProtocolVersion": function() { return ProtocolVersion; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/tendermint/types/evidence.js
var evidence_namespaceObject = {};
__webpack_require__.r(evidence_namespaceObject);
__webpack_require__.d(evidence_namespaceObject, {
  "DuplicateVoteEvidence": function() { return DuplicateVoteEvidence; },
  "Evidence": function() { return Evidence; },
  "EvidenceList": function() { return EvidenceList; },
  "LightClientAttackEvidence": function() { return LightClientAttackEvidence; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/tendermint/types/block.js
var block_namespaceObject = {};
__webpack_require__.r(block_namespaceObject);
__webpack_require__.d(block_namespaceObject, {
  "Block": function() { return Block; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/capability/v1/capability.js
var capability_namespaceObject = {};
__webpack_require__.r(capability_namespaceObject);
__webpack_require__.d(capability_namespaceObject, {
  "Capability": function() { return Capability; },
  "CapabilityOwners": function() { return CapabilityOwners; },
  "Owner": function() { return Owner; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/capability/v1/genesis.js
var v1_genesis_namespaceObject = {};
__webpack_require__.r(v1_genesis_namespaceObject);
__webpack_require__.d(v1_genesis_namespaceObject, {
  "GenesisOwners": function() { return GenesisOwners; },
  "GenesisState": function() { return v1_genesis_GenesisState; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/ibc/applications/fee/v1/ack.js
var ack_namespaceObject = {};
__webpack_require__.r(ack_namespaceObject);
__webpack_require__.d(ack_namespaceObject, {
  "IncentivizedAcknowledgement": function() { return IncentivizedAcknowledgement; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/ibc/applications/fee/v1/metadata.js
var metadata_namespaceObject = {};
__webpack_require__.r(metadata_namespaceObject);
__webpack_require__.d(metadata_namespaceObject, {
  "Metadata": function() { return Metadata; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/ibc/applications/interchain_accounts/genesis/v1/genesis.js
var genesis_v1_genesis_namespaceObject = {};
__webpack_require__.r(genesis_v1_genesis_namespaceObject);
__webpack_require__.d(genesis_v1_genesis_namespaceObject, {
  "ActiveChannel": function() { return ActiveChannel; },
  "ControllerGenesisState": function() { return ControllerGenesisState; },
  "GenesisState": function() { return genesis_v1_genesis_GenesisState; },
  "HostGenesisState": function() { return HostGenesisState; },
  "RegisteredInterchainAccount": function() { return RegisteredInterchainAccount; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/ibc/applications/interchain_accounts/v1/account.js
var account_namespaceObject = {};
__webpack_require__.r(account_namespaceObject);
__webpack_require__.d(account_namespaceObject, {
  "InterchainAccount": function() { return InterchainAccount; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/ibc/applications/interchain_accounts/v1/metadata.js
var v1_metadata_namespaceObject = {};
__webpack_require__.r(v1_metadata_namespaceObject);
__webpack_require__.d(v1_metadata_namespaceObject, {
  "Metadata": function() { return metadata_Metadata; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/ibc/applications/transfer/v1/authz.js
var authz_namespaceObject = {};
__webpack_require__.r(authz_namespaceObject);
__webpack_require__.d(authz_namespaceObject, {
  "Allocation": function() { return Allocation; },
  "TransferAuthorization": function() { return TransferAuthorization; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/ibc/applications/transfer/v1/genesis.js
var transfer_v1_genesis_namespaceObject = {};
__webpack_require__.r(transfer_v1_genesis_namespaceObject);
__webpack_require__.d(transfer_v1_genesis_namespaceObject, {
  "GenesisState": function() { return transfer_v1_genesis_GenesisState; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/ibc/applications/transfer/v2/packet.js
var packet_namespaceObject = {};
__webpack_require__.r(packet_namespaceObject);
__webpack_require__.d(packet_namespaceObject, {
  "FungibleTokenPacketData": function() { return FungibleTokenPacketData; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/ibc/core/channel/v1/genesis.js
var channel_v1_genesis_namespaceObject = {};
__webpack_require__.r(channel_v1_genesis_namespaceObject);
__webpack_require__.d(channel_v1_genesis_namespaceObject, {
  "GenesisState": function() { return channel_v1_genesis_GenesisState; },
  "PacketSequence": function() { return PacketSequence; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/ibc/core/client/v1/genesis.js
var client_v1_genesis_namespaceObject = {};
__webpack_require__.r(client_v1_genesis_namespaceObject);
__webpack_require__.d(client_v1_genesis_namespaceObject, {
  "GenesisMetadata": function() { return GenesisMetadata; },
  "GenesisState": function() { return client_v1_genesis_GenesisState; },
  "IdentifiedGenesisMetadata": function() { return IdentifiedGenesisMetadata; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/ibc/core/connection/v1/genesis.js
var connection_v1_genesis_namespaceObject = {};
__webpack_require__.r(connection_v1_genesis_namespaceObject);
__webpack_require__.d(connection_v1_genesis_namespaceObject, {
  "GenesisState": function() { return connection_v1_genesis_GenesisState; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/ibc/lightclients/localhost/v2/localhost.js
var localhost_namespaceObject = {};
__webpack_require__.r(localhost_namespaceObject);
__webpack_require__.d(localhost_namespaceObject, {
  "ClientState": function() { return ClientState; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/ibc/lightclients/solomachine/v2/solomachine.js
var solomachine_namespaceObject = {};
__webpack_require__.r(solomachine_namespaceObject);
__webpack_require__.d(solomachine_namespaceObject, {
  "ChannelStateData": function() { return ChannelStateData; },
  "ClientState": function() { return solomachine_ClientState; },
  "ClientStateData": function() { return ClientStateData; },
  "ConnectionStateData": function() { return ConnectionStateData; },
  "ConsensusState": function() { return ConsensusState; },
  "ConsensusStateData": function() { return ConsensusStateData; },
  "DataType": function() { return DataType; },
  "DataTypeAmino": function() { return DataTypeAmino; },
  "DataTypeSDKType": function() { return DataTypeSDKType; },
  "Header": function() { return Header; },
  "HeaderData": function() { return HeaderData; },
  "Misbehaviour": function() { return Misbehaviour; },
  "NextSequenceRecvData": function() { return NextSequenceRecvData; },
  "PacketAcknowledgementData": function() { return PacketAcknowledgementData; },
  "PacketCommitmentData": function() { return PacketCommitmentData; },
  "PacketReceiptAbsenceData": function() { return PacketReceiptAbsenceData; },
  "SignBytes": function() { return SignBytes; },
  "SignatureAndData": function() { return SignatureAndData; },
  "TimestampedSignatureData": function() { return TimestampedSignatureData; },
  "dataTypeFromJSON": function() { return dataTypeFromJSON; },
  "dataTypeToJSON": function() { return dataTypeToJSON; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/ibc/lightclients/solomachine/v3/solomachine.js
var v3_solomachine_namespaceObject = {};
__webpack_require__.r(v3_solomachine_namespaceObject);
__webpack_require__.d(v3_solomachine_namespaceObject, {
  "ClientState": function() { return v3_solomachine_ClientState; },
  "ConsensusState": function() { return solomachine_ConsensusState; },
  "Header": function() { return solomachine_Header; },
  "HeaderData": function() { return solomachine_HeaderData; },
  "Misbehaviour": function() { return solomachine_Misbehaviour; },
  "SignBytes": function() { return solomachine_SignBytes; },
  "SignatureAndData": function() { return solomachine_SignatureAndData; },
  "TimestampedSignatureData": function() { return solomachine_TimestampedSignatureData; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/ibc/lightclients/tendermint/v1/tendermint.js
var tendermint_namespaceObject = {};
__webpack_require__.r(tendermint_namespaceObject);
__webpack_require__.d(tendermint_namespaceObject, {
  "ClientState": function() { return tendermint_ClientState; },
  "ConsensusState": function() { return tendermint_ConsensusState; },
  "Fraction": function() { return Fraction; },
  "Header": function() { return tendermint_Header; },
  "Misbehaviour": function() { return tendermint_Misbehaviour; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/ibc/applications/fee/v1/tx.amino.js
var v1_tx_amino_namespaceObject = {};
__webpack_require__.r(v1_tx_amino_namespaceObject);
__webpack_require__.d(v1_tx_amino_namespaceObject, {
  "AminoConverter": function() { return v1_tx_amino_AminoConverter; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/ibc/applications/interchain_accounts/controller/v1/tx.amino.js
var controller_v1_tx_amino_namespaceObject = {};
__webpack_require__.r(controller_v1_tx_amino_namespaceObject);
__webpack_require__.d(controller_v1_tx_amino_namespaceObject, {
  "AminoConverter": function() { return controller_v1_tx_amino_AminoConverter; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/ibc/applications/transfer/v1/tx.amino.js
var transfer_v1_tx_amino_namespaceObject = {};
__webpack_require__.r(transfer_v1_tx_amino_namespaceObject);
__webpack_require__.d(transfer_v1_tx_amino_namespaceObject, {
  "AminoConverter": function() { return transfer_v1_tx_amino_AminoConverter; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/ibc/core/channel/v1/tx.amino.js
var channel_v1_tx_amino_namespaceObject = {};
__webpack_require__.r(channel_v1_tx_amino_namespaceObject);
__webpack_require__.d(channel_v1_tx_amino_namespaceObject, {
  "AminoConverter": function() { return channel_v1_tx_amino_AminoConverter; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/ibc/core/client/v1/tx.amino.js
var client_v1_tx_amino_namespaceObject = {};
__webpack_require__.r(client_v1_tx_amino_namespaceObject);
__webpack_require__.d(client_v1_tx_amino_namespaceObject, {
  "AminoConverter": function() { return client_v1_tx_amino_AminoConverter; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/ibc/core/connection/v1/tx.amino.js
var connection_v1_tx_amino_namespaceObject = {};
__webpack_require__.r(connection_v1_tx_amino_namespaceObject);
__webpack_require__.d(connection_v1_tx_amino_namespaceObject, {
  "AminoConverter": function() { return connection_v1_tx_amino_AminoConverter; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/ibc/applications/fee/v1/tx.registry.js
var v1_tx_registry_namespaceObject = {};
__webpack_require__.r(v1_tx_registry_namespaceObject);
__webpack_require__.d(v1_tx_registry_namespaceObject, {
  "MessageComposer": function() { return v1_tx_registry_MessageComposer; },
  "load": function() { return v1_tx_registry_load; },
  "registry": function() { return v1_tx_registry_registry; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/ibc/applications/interchain_accounts/controller/v1/tx.registry.js
var controller_v1_tx_registry_namespaceObject = {};
__webpack_require__.r(controller_v1_tx_registry_namespaceObject);
__webpack_require__.d(controller_v1_tx_registry_namespaceObject, {
  "MessageComposer": function() { return controller_v1_tx_registry_MessageComposer; },
  "load": function() { return controller_v1_tx_registry_load; },
  "registry": function() { return controller_v1_tx_registry_registry; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/ibc/applications/transfer/v1/tx.registry.js
var transfer_v1_tx_registry_namespaceObject = {};
__webpack_require__.r(transfer_v1_tx_registry_namespaceObject);
__webpack_require__.d(transfer_v1_tx_registry_namespaceObject, {
  "MessageComposer": function() { return transfer_v1_tx_registry_MessageComposer; },
  "load": function() { return transfer_v1_tx_registry_load; },
  "registry": function() { return transfer_v1_tx_registry_registry; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/ibc/core/channel/v1/tx.registry.js
var channel_v1_tx_registry_namespaceObject = {};
__webpack_require__.r(channel_v1_tx_registry_namespaceObject);
__webpack_require__.d(channel_v1_tx_registry_namespaceObject, {
  "MessageComposer": function() { return channel_v1_tx_registry_MessageComposer; },
  "load": function() { return channel_v1_tx_registry_load; },
  "registry": function() { return channel_v1_tx_registry_registry; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/ibc/core/client/v1/tx.registry.js
var client_v1_tx_registry_namespaceObject = {};
__webpack_require__.r(client_v1_tx_registry_namespaceObject);
__webpack_require__.d(client_v1_tx_registry_namespaceObject, {
  "MessageComposer": function() { return client_v1_tx_registry_MessageComposer; },
  "load": function() { return client_v1_tx_registry_load; },
  "registry": function() { return client_v1_tx_registry_registry; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/ibc/core/connection/v1/tx.registry.js
var connection_v1_tx_registry_namespaceObject = {};
__webpack_require__.r(connection_v1_tx_registry_namespaceObject);
__webpack_require__.d(connection_v1_tx_registry_namespaceObject, {
  "MessageComposer": function() { return connection_v1_tx_registry_MessageComposer; },
  "load": function() { return connection_v1_tx_registry_load; },
  "registry": function() { return connection_v1_tx_registry_registry; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/ibc/lcd.js
var ibc_lcd_namespaceObject = {};
__webpack_require__.r(ibc_lcd_namespaceObject);
__webpack_require__.d(ibc_lcd_namespaceObject, {
  "createLCDClient": function() { return lcd_createLCDClient; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/ibc/rpc.query.js
var ibc_rpc_query_namespaceObject = {};
__webpack_require__.r(ibc_rpc_query_namespaceObject);
__webpack_require__.d(ibc_rpc_query_namespaceObject, {
  "createRPCQueryClient": function() { return rpc_query_createRPCQueryClient; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/ibc/rpc.tx.js
var ibc_rpc_tx_namespaceObject = {};
__webpack_require__.r(ibc_rpc_tx_namespaceObject);
__webpack_require__.d(ibc_rpc_tx_namespaceObject, {
  "createRPCMsgClient": function() { return rpc_tx_createRPCMsgClient; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/cosmwasm/wasm/v1/authz.js
var v1_authz_namespaceObject = {};
__webpack_require__.r(v1_authz_namespaceObject);
__webpack_require__.d(v1_authz_namespaceObject, {
  "AcceptedMessageKeysFilter": function() { return AcceptedMessageKeysFilter; },
  "AcceptedMessagesFilter": function() { return AcceptedMessagesFilter; },
  "AllowAllMessagesFilter": function() { return AllowAllMessagesFilter; },
  "CombinedLimit": function() { return CombinedLimit; },
  "ContractExecutionAuthorization": function() { return ContractExecutionAuthorization; },
  "ContractGrant": function() { return ContractGrant; },
  "ContractMigrationAuthorization": function() { return ContractMigrationAuthorization; },
  "Cosmwasm_wasmv1ContractAuthzFilterX_FromAmino": function() { return Cosmwasm_wasmv1ContractAuthzFilterX_FromAmino; },
  "Cosmwasm_wasmv1ContractAuthzFilterX_InterfaceDecoder": function() { return Cosmwasm_wasmv1ContractAuthzFilterX_InterfaceDecoder; },
  "Cosmwasm_wasmv1ContractAuthzFilterX_ToAmino": function() { return Cosmwasm_wasmv1ContractAuthzFilterX_ToAmino; },
  "Cosmwasm_wasmv1ContractAuthzLimitX_FromAmino": function() { return Cosmwasm_wasmv1ContractAuthzLimitX_FromAmino; },
  "Cosmwasm_wasmv1ContractAuthzLimitX_InterfaceDecoder": function() { return Cosmwasm_wasmv1ContractAuthzLimitX_InterfaceDecoder; },
  "Cosmwasm_wasmv1ContractAuthzLimitX_ToAmino": function() { return Cosmwasm_wasmv1ContractAuthzLimitX_ToAmino; },
  "MaxCallsLimit": function() { return MaxCallsLimit; },
  "MaxFundsLimit": function() { return MaxFundsLimit; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/cosmwasm/wasm/v1/genesis.js
var wasm_v1_genesis_namespaceObject = {};
__webpack_require__.r(wasm_v1_genesis_namespaceObject);
__webpack_require__.d(wasm_v1_genesis_namespaceObject, {
  "Code": function() { return Code; },
  "Contract": function() { return Contract; },
  "GenesisState": function() { return wasm_v1_genesis_GenesisState; },
  "Sequence": function() { return Sequence; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/cosmwasm/wasm/v1/ibc.js
var ibc_namespaceObject = {};
__webpack_require__.r(ibc_namespaceObject);
__webpack_require__.d(ibc_namespaceObject, {
  "MsgIBCCloseChannel": function() { return MsgIBCCloseChannel; },
  "MsgIBCSend": function() { return MsgIBCSend; },
  "MsgIBCSendResponse": function() { return MsgIBCSendResponse; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/cosmwasm/wasm/v1/proposal.js
var proposal_namespaceObject = {};
__webpack_require__.r(proposal_namespaceObject);
__webpack_require__.d(proposal_namespaceObject, {
  "AccessConfigUpdate": function() { return AccessConfigUpdate; },
  "ClearAdminProposal": function() { return ClearAdminProposal; },
  "ExecuteContractProposal": function() { return ExecuteContractProposal; },
  "InstantiateContract2Proposal": function() { return InstantiateContract2Proposal; },
  "InstantiateContractProposal": function() { return InstantiateContractProposal; },
  "MigrateContractProposal": function() { return MigrateContractProposal; },
  "PinCodesProposal": function() { return PinCodesProposal; },
  "StoreAndInstantiateContractProposal": function() { return StoreAndInstantiateContractProposal; },
  "StoreCodeProposal": function() { return StoreCodeProposal; },
  "SudoContractProposal": function() { return SudoContractProposal; },
  "UnpinCodesProposal": function() { return UnpinCodesProposal; },
  "UpdateAdminProposal": function() { return UpdateAdminProposal; },
  "UpdateInstantiateConfigProposal": function() { return UpdateInstantiateConfigProposal; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/cosmwasm/wasm/v1/tx.amino.js
var wasm_v1_tx_amino_namespaceObject = {};
__webpack_require__.r(wasm_v1_tx_amino_namespaceObject);
__webpack_require__.d(wasm_v1_tx_amino_namespaceObject, {
  "AminoConverter": function() { return wasm_v1_tx_amino_AminoConverter; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/cosmwasm/wasm/v1/tx.registry.js
var wasm_v1_tx_registry_namespaceObject = {};
__webpack_require__.r(wasm_v1_tx_registry_namespaceObject);
__webpack_require__.d(wasm_v1_tx_registry_namespaceObject, {
  "MessageComposer": function() { return wasm_v1_tx_registry_MessageComposer; },
  "load": function() { return wasm_v1_tx_registry_load; },
  "registry": function() { return wasm_v1_tx_registry_registry; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/cosmwasm/lcd.js
var cosmwasm_lcd_namespaceObject = {};
__webpack_require__.r(cosmwasm_lcd_namespaceObject);
__webpack_require__.d(cosmwasm_lcd_namespaceObject, {
  "createLCDClient": function() { return cosmwasm_lcd_createLCDClient; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/cosmwasm/rpc.query.js
var cosmwasm_rpc_query_namespaceObject = {};
__webpack_require__.r(cosmwasm_rpc_query_namespaceObject);
__webpack_require__.d(cosmwasm_rpc_query_namespaceObject, {
  "createRPCQueryClient": function() { return cosmwasm_rpc_query_createRPCQueryClient; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/cosmwasm/rpc.tx.js
var cosmwasm_rpc_tx_namespaceObject = {};
__webpack_require__.r(cosmwasm_rpc_tx_namespaceObject);
__webpack_require__.d(cosmwasm_rpc_tx_namespaceObject, {
  "createRPCMsgClient": function() { return cosmwasm_rpc_tx_createRPCMsgClient; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/osmosis/accum/v1beta1/accum.js
var accum_namespaceObject = {};
__webpack_require__.r(accum_namespaceObject);
__webpack_require__.d(accum_namespaceObject, {
  "AccumulatorContent": function() { return AccumulatorContent; },
  "Options": function() { return Options; },
  "Record": function() { return Record; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/osmosis/cosmwasmpool/v1beta1/genesis.js
var cosmwasmpool_v1beta1_genesis_namespaceObject = {};
__webpack_require__.r(cosmwasmpool_v1beta1_genesis_namespaceObject);
__webpack_require__.d(cosmwasmpool_v1beta1_genesis_namespaceObject, {
  "GenesisState": function() { return cosmwasmpool_v1beta1_genesis_GenesisState; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/osmosis/cosmwasmpool/v1beta1/gov.js
var gov_namespaceObject = {};
__webpack_require__.r(gov_namespaceObject);
__webpack_require__.d(gov_namespaceObject, {
  "MigratePoolContractsProposal": function() { return MigratePoolContractsProposal; },
  "UploadCosmWasmPoolCodeAndWhiteListProposal": function() { return UploadCosmWasmPoolCodeAndWhiteListProposal; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/osmosis/cosmwasmpool/v1beta1/model/instantiate_msg.js
var instantiate_msg_namespaceObject = {};
__webpack_require__.r(instantiate_msg_namespaceObject);
__webpack_require__.d(instantiate_msg_namespaceObject, {
  "InstantiateMsg": function() { return InstantiateMsg; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/osmosis/cosmwasmpool/v1beta1/model/module_query_msg.js
var module_query_msg_namespaceObject = {};
__webpack_require__.r(module_query_msg_namespaceObject);
__webpack_require__.d(module_query_msg_namespaceObject, {
  "CalcInAmtGivenOut": function() { return CalcInAmtGivenOut; },
  "CalcInAmtGivenOutRequest": function() { return CalcInAmtGivenOutRequest; },
  "CalcInAmtGivenOutResponse": function() { return CalcInAmtGivenOutResponse; },
  "CalcOutAmtGivenIn": function() { return CalcOutAmtGivenIn; },
  "CalcOutAmtGivenInRequest": function() { return CalcOutAmtGivenInRequest; },
  "CalcOutAmtGivenInResponse": function() { return CalcOutAmtGivenInResponse; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/osmosis/cosmwasmpool/v1beta1/model/module_sudo_msg.js
var module_sudo_msg_namespaceObject = {};
__webpack_require__.r(module_sudo_msg_namespaceObject);
__webpack_require__.d(module_sudo_msg_namespaceObject, {
  "SwapExactAmountIn": function() { return SwapExactAmountIn; },
  "SwapExactAmountInSudoMsg": function() { return SwapExactAmountInSudoMsg; },
  "SwapExactAmountInSudoMsgResponse": function() { return SwapExactAmountInSudoMsgResponse; },
  "SwapExactAmountOut": function() { return SwapExactAmountOut; },
  "SwapExactAmountOutSudoMsg": function() { return SwapExactAmountOutSudoMsg; },
  "SwapExactAmountOutSudoMsgResponse": function() { return SwapExactAmountOutSudoMsgResponse; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/osmosis/cosmwasmpool/v1beta1/model/pool_query_msg.js
var pool_query_msg_namespaceObject = {};
__webpack_require__.r(pool_query_msg_namespaceObject);
__webpack_require__.d(pool_query_msg_namespaceObject, {
  "EmptyStruct": function() { return EmptyStruct; },
  "GetSwapFeeQueryMsg": function() { return GetSwapFeeQueryMsg; },
  "GetSwapFeeQueryMsgResponse": function() { return GetSwapFeeQueryMsgResponse; },
  "GetTotalPoolLiquidityQueryMsg": function() { return GetTotalPoolLiquidityQueryMsg; },
  "GetTotalPoolLiquidityQueryMsgResponse": function() { return GetTotalPoolLiquidityQueryMsgResponse; },
  "GetTotalSharesQueryMsg": function() { return GetTotalSharesQueryMsg; },
  "GetTotalSharesQueryMsgResponse": function() { return GetTotalSharesQueryMsgResponse; },
  "SpotPrice": function() { return SpotPrice; },
  "SpotPriceQueryMsg": function() { return SpotPriceQueryMsg; },
  "SpotPriceQueryMsgResponse": function() { return SpotPriceQueryMsgResponse; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/osmosis/cosmwasmpool/v1beta1/model/transmuter_msgs.js
var transmuter_msgs_namespaceObject = {};
__webpack_require__.r(transmuter_msgs_namespaceObject);
__webpack_require__.d(transmuter_msgs_namespaceObject, {
  "EmptyRequest": function() { return EmptyRequest; },
  "ExitPoolExecuteMsgRequest": function() { return ExitPoolExecuteMsgRequest; },
  "ExitPoolExecuteMsgResponse": function() { return ExitPoolExecuteMsgResponse; },
  "JoinPoolExecuteMsgRequest": function() { return JoinPoolExecuteMsgRequest; },
  "JoinPoolExecuteMsgResponse": function() { return JoinPoolExecuteMsgResponse; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/osmosis/cosmwasmpool/v1beta1/model/tx.js
var tx_namespaceObject = {};
__webpack_require__.r(tx_namespaceObject);
__webpack_require__.d(tx_namespaceObject, {
  "MsgCreateCosmWasmPool": function() { return MsgCreateCosmWasmPool; },
  "MsgCreateCosmWasmPoolResponse": function() { return MsgCreateCosmWasmPoolResponse; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/osmosis/cosmwasmpool/v1beta1/tx.js
var v1beta1_tx_namespaceObject = {};
__webpack_require__.r(v1beta1_tx_namespaceObject);

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/osmosis/downtime-detector/v1beta1/genesis.js
var downtime_detector_v1beta1_genesis_namespaceObject = {};
__webpack_require__.r(downtime_detector_v1beta1_genesis_namespaceObject);
__webpack_require__.d(downtime_detector_v1beta1_genesis_namespaceObject, {
  "GenesisDowntimeEntry": function() { return GenesisDowntimeEntry; },
  "GenesisState": function() { return downtime_detector_v1beta1_genesis_GenesisState; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/osmosis/gamm/v1beta1/genesis.js
var gamm_v1beta1_genesis_namespaceObject = {};
__webpack_require__.r(gamm_v1beta1_genesis_namespaceObject);
__webpack_require__.d(gamm_v1beta1_genesis_namespaceObject, {
  "BalancerToConcentratedPoolLink": function() { return BalancerToConcentratedPoolLink; },
  "GenesisState": function() { return gamm_v1beta1_genesis_GenesisState; },
  "MigrationRecords": function() { return MigrationRecords; },
  "Params": function() { return Params; },
  "PoolI_FromAmino": function() { return PoolI_FromAmino; },
  "PoolI_InterfaceDecoder": function() { return PoolI_InterfaceDecoder; },
  "PoolI_ToAmino": function() { return PoolI_ToAmino; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/osmosis/gamm/v1beta1/gov.js
var v1beta1_gov_namespaceObject = {};
__webpack_require__.r(v1beta1_gov_namespaceObject);
__webpack_require__.d(v1beta1_gov_namespaceObject, {
  "ReplaceMigrationRecordsProposal": function() { return ReplaceMigrationRecordsProposal; },
  "UpdateMigrationRecordsProposal": function() { return UpdateMigrationRecordsProposal; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/osmosis/ibc-rate-limit/v1beta1/genesis.js
var ibc_rate_limit_v1beta1_genesis_namespaceObject = {};
__webpack_require__.r(ibc_rate_limit_v1beta1_genesis_namespaceObject);
__webpack_require__.d(ibc_rate_limit_v1beta1_genesis_namespaceObject, {
  "GenesisState": function() { return ibc_rate_limit_v1beta1_genesis_GenesisState; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/osmosis/incentives/params.js
var params_namespaceObject = {};
__webpack_require__.r(params_namespaceObject);
__webpack_require__.d(params_namespaceObject, {
  "Params": function() { return params_Params; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/osmosis/incentives/genesis.js
var incentives_genesis_namespaceObject = {};
__webpack_require__.r(incentives_genesis_namespaceObject);
__webpack_require__.d(incentives_genesis_namespaceObject, {
  "GenesisState": function() { return incentives_genesis_GenesisState; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/osmosis/lockup/genesis.js
var lockup_genesis_namespaceObject = {};
__webpack_require__.r(lockup_genesis_namespaceObject);
__webpack_require__.d(lockup_genesis_namespaceObject, {
  "GenesisState": function() { return lockup_genesis_GenesisState; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/osmosis/mint/v1beta1/genesis.js
var mint_v1beta1_genesis_namespaceObject = {};
__webpack_require__.r(mint_v1beta1_genesis_namespaceObject);
__webpack_require__.d(mint_v1beta1_genesis_namespaceObject, {
  "GenesisState": function() { return mint_v1beta1_genesis_GenesisState; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/osmosis/pool-incentives/v1beta1/genesis.js
var pool_incentives_v1beta1_genesis_namespaceObject = {};
__webpack_require__.r(pool_incentives_v1beta1_genesis_namespaceObject);
__webpack_require__.d(pool_incentives_v1beta1_genesis_namespaceObject, {
  "GenesisState": function() { return pool_incentives_v1beta1_genesis_GenesisState; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/osmosis/pool-incentives/v1beta1/gov.js
var pool_incentives_v1beta1_gov_namespaceObject = {};
__webpack_require__.r(pool_incentives_v1beta1_gov_namespaceObject);
__webpack_require__.d(pool_incentives_v1beta1_gov_namespaceObject, {
  "ReplacePoolIncentivesProposal": function() { return ReplacePoolIncentivesProposal; },
  "UpdatePoolIncentivesProposal": function() { return UpdatePoolIncentivesProposal; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/osmosis/protorev/v1beta1/genesis.js
var protorev_v1beta1_genesis_namespaceObject = {};
__webpack_require__.r(protorev_v1beta1_genesis_namespaceObject);
__webpack_require__.d(protorev_v1beta1_genesis_namespaceObject, {
  "GenesisState": function() { return protorev_v1beta1_genesis_GenesisState; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/osmosis/protorev/v1beta1/gov.js
var protorev_v1beta1_gov_namespaceObject = {};
__webpack_require__.r(protorev_v1beta1_gov_namespaceObject);
__webpack_require__.d(protorev_v1beta1_gov_namespaceObject, {
  "SetProtoRevAdminAccountProposal": function() { return SetProtoRevAdminAccountProposal; },
  "SetProtoRevEnabledProposal": function() { return SetProtoRevEnabledProposal; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/osmosis/sumtree/v1beta1/tree.js
var tree_namespaceObject = {};
__webpack_require__.r(tree_namespaceObject);
__webpack_require__.d(tree_namespaceObject, {
  "Child": function() { return Child; },
  "Leaf": function() { return Leaf; },
  "Node": function() { return Node; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/osmosis/superfluid/genesis.js
var superfluid_genesis_namespaceObject = {};
__webpack_require__.r(superfluid_genesis_namespaceObject);
__webpack_require__.d(superfluid_genesis_namespaceObject, {
  "GenesisState": function() { return superfluid_genesis_GenesisState; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/osmosis/tokenfactory/v1beta1/genesis.js
var tokenfactory_v1beta1_genesis_namespaceObject = {};
__webpack_require__.r(tokenfactory_v1beta1_genesis_namespaceObject);
__webpack_require__.d(tokenfactory_v1beta1_genesis_namespaceObject, {
  "GenesisDenom": function() { return GenesisDenom; },
  "GenesisState": function() { return tokenfactory_v1beta1_genesis_GenesisState; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/osmosis/txfees/v1beta1/genesis.js
var txfees_v1beta1_genesis_namespaceObject = {};
__webpack_require__.r(txfees_v1beta1_genesis_namespaceObject);
__webpack_require__.d(txfees_v1beta1_genesis_namespaceObject, {
  "GenesisState": function() { return txfees_v1beta1_genesis_GenesisState; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/osmosis/txfees/v1beta1/gov.js
var txfees_v1beta1_gov_namespaceObject = {};
__webpack_require__.r(txfees_v1beta1_gov_namespaceObject);
__webpack_require__.d(txfees_v1beta1_gov_namespaceObject, {
  "UpdateFeeTokenProposal": function() { return UpdateFeeTokenProposal; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/osmosis/gamm/pool-models/balancer/tx/tx.amino.js
var tx_tx_amino_namespaceObject = {};
__webpack_require__.r(tx_tx_amino_namespaceObject);
__webpack_require__.d(tx_tx_amino_namespaceObject, {
  "AminoConverter": function() { return tx_tx_amino_AminoConverter; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/osmosis/gamm/pool-models/stableswap/tx.amino.js
var stableswap_tx_amino_namespaceObject = {};
__webpack_require__.r(stableswap_tx_amino_namespaceObject);
__webpack_require__.d(stableswap_tx_amino_namespaceObject, {
  "AminoConverter": function() { return stableswap_tx_amino_AminoConverter; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/osmosis/gamm/v1beta1/tx.amino.js
var gamm_v1beta1_tx_amino_namespaceObject = {};
__webpack_require__.r(gamm_v1beta1_tx_amino_namespaceObject);
__webpack_require__.d(gamm_v1beta1_tx_amino_namespaceObject, {
  "AminoConverter": function() { return gamm_v1beta1_tx_amino_AminoConverter; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/osmosis/incentives/tx.amino.js
var incentives_tx_amino_namespaceObject = {};
__webpack_require__.r(incentives_tx_amino_namespaceObject);
__webpack_require__.d(incentives_tx_amino_namespaceObject, {
  "AminoConverter": function() { return incentives_tx_amino_AminoConverter; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/osmosis/lockup/tx.amino.js
var lockup_tx_amino_namespaceObject = {};
__webpack_require__.r(lockup_tx_amino_namespaceObject);
__webpack_require__.d(lockup_tx_amino_namespaceObject, {
  "AminoConverter": function() { return lockup_tx_amino_AminoConverter; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/osmosis/poolmanager/v1beta1/tx.amino.js
var poolmanager_v1beta1_tx_amino_namespaceObject = {};
__webpack_require__.r(poolmanager_v1beta1_tx_amino_namespaceObject);
__webpack_require__.d(poolmanager_v1beta1_tx_amino_namespaceObject, {
  "AminoConverter": function() { return poolmanager_v1beta1_tx_amino_AminoConverter; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/osmosis/protorev/v1beta1/tx.amino.js
var protorev_v1beta1_tx_amino_namespaceObject = {};
__webpack_require__.r(protorev_v1beta1_tx_amino_namespaceObject);
__webpack_require__.d(protorev_v1beta1_tx_amino_namespaceObject, {
  "AminoConverter": function() { return protorev_v1beta1_tx_amino_AminoConverter; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/osmosis/superfluid/tx.amino.js
var superfluid_tx_amino_namespaceObject = {};
__webpack_require__.r(superfluid_tx_amino_namespaceObject);
__webpack_require__.d(superfluid_tx_amino_namespaceObject, {
  "AminoConverter": function() { return superfluid_tx_amino_AminoConverter; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/osmosis/tokenfactory/v1beta1/tx.amino.js
var tokenfactory_v1beta1_tx_amino_namespaceObject = {};
__webpack_require__.r(tokenfactory_v1beta1_tx_amino_namespaceObject);
__webpack_require__.d(tokenfactory_v1beta1_tx_amino_namespaceObject, {
  "AminoConverter": function() { return tokenfactory_v1beta1_tx_amino_AminoConverter; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/osmosis/valset-pref/v1beta1/tx.amino.js
var valset_pref_v1beta1_tx_amino_namespaceObject = {};
__webpack_require__.r(valset_pref_v1beta1_tx_amino_namespaceObject);
__webpack_require__.d(valset_pref_v1beta1_tx_amino_namespaceObject, {
  "AminoConverter": function() { return valset_pref_v1beta1_tx_amino_AminoConverter; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/osmosis/gamm/pool-models/balancer/tx/tx.registry.js
var tx_tx_registry_namespaceObject = {};
__webpack_require__.r(tx_tx_registry_namespaceObject);
__webpack_require__.d(tx_tx_registry_namespaceObject, {
  "MessageComposer": function() { return tx_tx_registry_MessageComposer; },
  "load": function() { return tx_tx_registry_load; },
  "registry": function() { return tx_tx_registry_registry; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/osmosis/gamm/pool-models/stableswap/tx.registry.js
var stableswap_tx_registry_namespaceObject = {};
__webpack_require__.r(stableswap_tx_registry_namespaceObject);
__webpack_require__.d(stableswap_tx_registry_namespaceObject, {
  "MessageComposer": function() { return stableswap_tx_registry_MessageComposer; },
  "load": function() { return stableswap_tx_registry_load; },
  "registry": function() { return stableswap_tx_registry_registry; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/osmosis/gamm/v1beta1/tx.registry.js
var gamm_v1beta1_tx_registry_namespaceObject = {};
__webpack_require__.r(gamm_v1beta1_tx_registry_namespaceObject);
__webpack_require__.d(gamm_v1beta1_tx_registry_namespaceObject, {
  "MessageComposer": function() { return gamm_v1beta1_tx_registry_MessageComposer; },
  "load": function() { return gamm_v1beta1_tx_registry_load; },
  "registry": function() { return gamm_v1beta1_tx_registry_registry; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/osmosis/incentives/tx.registry.js
var incentives_tx_registry_namespaceObject = {};
__webpack_require__.r(incentives_tx_registry_namespaceObject);
__webpack_require__.d(incentives_tx_registry_namespaceObject, {
  "MessageComposer": function() { return incentives_tx_registry_MessageComposer; },
  "load": function() { return incentives_tx_registry_load; },
  "registry": function() { return incentives_tx_registry_registry; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/osmosis/lockup/tx.registry.js
var lockup_tx_registry_namespaceObject = {};
__webpack_require__.r(lockup_tx_registry_namespaceObject);
__webpack_require__.d(lockup_tx_registry_namespaceObject, {
  "MessageComposer": function() { return lockup_tx_registry_MessageComposer; },
  "load": function() { return lockup_tx_registry_load; },
  "registry": function() { return lockup_tx_registry_registry; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/osmosis/poolmanager/v1beta1/tx.registry.js
var poolmanager_v1beta1_tx_registry_namespaceObject = {};
__webpack_require__.r(poolmanager_v1beta1_tx_registry_namespaceObject);
__webpack_require__.d(poolmanager_v1beta1_tx_registry_namespaceObject, {
  "MessageComposer": function() { return poolmanager_v1beta1_tx_registry_MessageComposer; },
  "load": function() { return poolmanager_v1beta1_tx_registry_load; },
  "registry": function() { return poolmanager_v1beta1_tx_registry_registry; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/osmosis/protorev/v1beta1/tx.registry.js
var protorev_v1beta1_tx_registry_namespaceObject = {};
__webpack_require__.r(protorev_v1beta1_tx_registry_namespaceObject);
__webpack_require__.d(protorev_v1beta1_tx_registry_namespaceObject, {
  "MessageComposer": function() { return protorev_v1beta1_tx_registry_MessageComposer; },
  "load": function() { return protorev_v1beta1_tx_registry_load; },
  "registry": function() { return protorev_v1beta1_tx_registry_registry; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/osmosis/superfluid/tx.registry.js
var superfluid_tx_registry_namespaceObject = {};
__webpack_require__.r(superfluid_tx_registry_namespaceObject);
__webpack_require__.d(superfluid_tx_registry_namespaceObject, {
  "MessageComposer": function() { return superfluid_tx_registry_MessageComposer; },
  "load": function() { return superfluid_tx_registry_load; },
  "registry": function() { return superfluid_tx_registry_registry; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/osmosis/tokenfactory/v1beta1/tx.registry.js
var tokenfactory_v1beta1_tx_registry_namespaceObject = {};
__webpack_require__.r(tokenfactory_v1beta1_tx_registry_namespaceObject);
__webpack_require__.d(tokenfactory_v1beta1_tx_registry_namespaceObject, {
  "MessageComposer": function() { return tokenfactory_v1beta1_tx_registry_MessageComposer; },
  "load": function() { return tokenfactory_v1beta1_tx_registry_load; },
  "registry": function() { return tokenfactory_v1beta1_tx_registry_registry; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/osmosis/valset-pref/v1beta1/tx.registry.js
var valset_pref_v1beta1_tx_registry_namespaceObject = {};
__webpack_require__.r(valset_pref_v1beta1_tx_registry_namespaceObject);
__webpack_require__.d(valset_pref_v1beta1_tx_registry_namespaceObject, {
  "MessageComposer": function() { return valset_pref_v1beta1_tx_registry_MessageComposer; },
  "load": function() { return valset_pref_v1beta1_tx_registry_load; },
  "registry": function() { return valset_pref_v1beta1_tx_registry_registry; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/osmosis/lcd.js
var osmosis_lcd_namespaceObject = {};
__webpack_require__.r(osmosis_lcd_namespaceObject);
__webpack_require__.d(osmosis_lcd_namespaceObject, {
  "createLCDClient": function() { return osmosis_lcd_createLCDClient; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/osmosis/rpc.query.js
var osmosis_rpc_query_namespaceObject = {};
__webpack_require__.r(osmosis_rpc_query_namespaceObject);
__webpack_require__.d(osmosis_rpc_query_namespaceObject, {
  "createRPCQueryClient": function() { return osmosis_rpc_query_createRPCQueryClient; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/osmosis/rpc.tx.js
var osmosis_rpc_tx_namespaceObject = {};
__webpack_require__.r(osmosis_rpc_tx_namespaceObject);
__webpack_require__.d(osmosis_rpc_tx_namespaceObject, {
  "createRPCMsgClient": function() { return osmosis_rpc_tx_createRPCMsgClient; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/confio/proofs.js
var proofs_namespaceObject = {};
__webpack_require__.r(proofs_namespaceObject);
__webpack_require__.d(proofs_namespaceObject, {
  "BatchEntry": function() { return BatchEntry; },
  "BatchProof": function() { return BatchProof; },
  "CommitmentProof": function() { return CommitmentProof; },
  "CompressedBatchEntry": function() { return CompressedBatchEntry; },
  "CompressedBatchProof": function() { return CompressedBatchProof; },
  "CompressedExistenceProof": function() { return CompressedExistenceProof; },
  "CompressedNonExistenceProof": function() { return CompressedNonExistenceProof; },
  "ExistenceProof": function() { return ExistenceProof; },
  "HashOp": function() { return HashOp; },
  "HashOpAmino": function() { return HashOpAmino; },
  "HashOpSDKType": function() { return HashOpSDKType; },
  "InnerOp": function() { return InnerOp; },
  "InnerSpec": function() { return InnerSpec; },
  "LeafOp": function() { return LeafOp; },
  "LengthOp": function() { return LengthOp; },
  "LengthOpAmino": function() { return LengthOpAmino; },
  "LengthOpSDKType": function() { return LengthOpSDKType; },
  "NonExistenceProof": function() { return NonExistenceProof; },
  "ProofSpec": function() { return ProofSpec; },
  "hashOpFromJSON": function() { return hashOpFromJSON; },
  "hashOpToJSON": function() { return hashOpToJSON; },
  "lengthOpFromJSON": function() { return lengthOpFromJSON; },
  "lengthOpToJSON": function() { return lengthOpToJSON; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/cosmos_proto/cosmos.js
var cosmos_namespaceObject = {};
__webpack_require__.r(cosmos_namespaceObject);
__webpack_require__.d(cosmos_namespaceObject, {
  "InterfaceDescriptor": function() { return cosmos_InterfaceDescriptor; },
  "ScalarDescriptor": function() { return ScalarDescriptor; },
  "ScalarType": function() { return ScalarType; },
  "ScalarTypeAmino": function() { return ScalarTypeAmino; },
  "ScalarTypeSDKType": function() { return ScalarTypeSDKType; },
  "scalarTypeFromJSON": function() { return scalarTypeFromJSON; },
  "scalarTypeToJSON": function() { return scalarTypeToJSON; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/gogoproto/gogo.js
var gogo_namespaceObject = {};
__webpack_require__.r(gogo_namespaceObject);

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/google/protobuf/descriptor.js
var descriptor_namespaceObject = {};
__webpack_require__.r(descriptor_namespaceObject);
__webpack_require__.d(descriptor_namespaceObject, {
  "DescriptorProto": function() { return DescriptorProto; },
  "DescriptorProto_ExtensionRange": function() { return DescriptorProto_ExtensionRange; },
  "DescriptorProto_ReservedRange": function() { return DescriptorProto_ReservedRange; },
  "EnumDescriptorProto": function() { return EnumDescriptorProto; },
  "EnumDescriptorProto_EnumReservedRange": function() { return EnumDescriptorProto_EnumReservedRange; },
  "EnumOptions": function() { return EnumOptions; },
  "EnumValueDescriptorProto": function() { return EnumValueDescriptorProto; },
  "EnumValueOptions": function() { return EnumValueOptions; },
  "ExtensionRangeOptions": function() { return ExtensionRangeOptions; },
  "FieldDescriptorProto": function() { return FieldDescriptorProto; },
  "FieldDescriptorProto_Label": function() { return FieldDescriptorProto_Label; },
  "FieldDescriptorProto_LabelAmino": function() { return FieldDescriptorProto_LabelAmino; },
  "FieldDescriptorProto_LabelSDKType": function() { return FieldDescriptorProto_LabelSDKType; },
  "FieldDescriptorProto_Type": function() { return FieldDescriptorProto_Type; },
  "FieldDescriptorProto_TypeAmino": function() { return FieldDescriptorProto_TypeAmino; },
  "FieldDescriptorProto_TypeSDKType": function() { return FieldDescriptorProto_TypeSDKType; },
  "FieldOptions": function() { return FieldOptions; },
  "FieldOptions_CType": function() { return FieldOptions_CType; },
  "FieldOptions_CTypeAmino": function() { return FieldOptions_CTypeAmino; },
  "FieldOptions_CTypeSDKType": function() { return FieldOptions_CTypeSDKType; },
  "FieldOptions_JSType": function() { return FieldOptions_JSType; },
  "FieldOptions_JSTypeAmino": function() { return FieldOptions_JSTypeAmino; },
  "FieldOptions_JSTypeSDKType": function() { return FieldOptions_JSTypeSDKType; },
  "FileDescriptorProto": function() { return FileDescriptorProto; },
  "FileDescriptorSet": function() { return FileDescriptorSet; },
  "FileOptions": function() { return FileOptions; },
  "FileOptions_OptimizeMode": function() { return FileOptions_OptimizeMode; },
  "FileOptions_OptimizeModeAmino": function() { return FileOptions_OptimizeModeAmino; },
  "FileOptions_OptimizeModeSDKType": function() { return FileOptions_OptimizeModeSDKType; },
  "GeneratedCodeInfo": function() { return GeneratedCodeInfo; },
  "GeneratedCodeInfo_Annotation": function() { return GeneratedCodeInfo_Annotation; },
  "MessageOptions": function() { return MessageOptions; },
  "MethodDescriptorProto": function() { return MethodDescriptorProto; },
  "MethodOptions": function() { return MethodOptions; },
  "MethodOptions_IdempotencyLevel": function() { return MethodOptions_IdempotencyLevel; },
  "MethodOptions_IdempotencyLevelAmino": function() { return MethodOptions_IdempotencyLevelAmino; },
  "MethodOptions_IdempotencyLevelSDKType": function() { return MethodOptions_IdempotencyLevelSDKType; },
  "OneofDescriptorProto": function() { return OneofDescriptorProto; },
  "OneofOptions": function() { return OneofOptions; },
  "ServiceDescriptorProto": function() { return ServiceDescriptorProto; },
  "ServiceOptions": function() { return ServiceOptions; },
  "SourceCodeInfo": function() { return SourceCodeInfo; },
  "SourceCodeInfo_Location": function() { return SourceCodeInfo_Location; },
  "UninterpretedOption": function() { return UninterpretedOption; },
  "UninterpretedOption_NamePart": function() { return UninterpretedOption_NamePart; },
  "fieldDescriptorProto_LabelFromJSON": function() { return fieldDescriptorProto_LabelFromJSON; },
  "fieldDescriptorProto_LabelToJSON": function() { return fieldDescriptorProto_LabelToJSON; },
  "fieldDescriptorProto_TypeFromJSON": function() { return fieldDescriptorProto_TypeFromJSON; },
  "fieldDescriptorProto_TypeToJSON": function() { return fieldDescriptorProto_TypeToJSON; },
  "fieldOptions_CTypeFromJSON": function() { return fieldOptions_CTypeFromJSON; },
  "fieldOptions_CTypeToJSON": function() { return fieldOptions_CTypeToJSON; },
  "fieldOptions_JSTypeFromJSON": function() { return fieldOptions_JSTypeFromJSON; },
  "fieldOptions_JSTypeToJSON": function() { return fieldOptions_JSTypeToJSON; },
  "fileOptions_OptimizeModeFromJSON": function() { return fileOptions_OptimizeModeFromJSON; },
  "fileOptions_OptimizeModeToJSON": function() { return fileOptions_OptimizeModeToJSON; },
  "methodOptions_IdempotencyLevelFromJSON": function() { return methodOptions_IdempotencyLevelFromJSON; },
  "methodOptions_IdempotencyLevelToJSON": function() { return methodOptions_IdempotencyLevelToJSON; }
});

// NAMESPACE OBJECT: ./node_modules/osmojs/module/codegen/google/protobuf/empty.js
var empty_namespaceObject = {};
__webpack_require__.r(empty_namespaceObject);
__webpack_require__.d(empty_namespaceObject, {
  "Empty": function() { return Empty; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(4942);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/cosmos/ics23/v1/proofs.js
var proofs = __webpack_require__(19033);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/cosmos/auth/v1beta1/auth.js
var v1beta1_auth = __webpack_require__(36429);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/google/protobuf/any.js
var any = __webpack_require__(32106);
// EXTERNAL MODULE: ./node_modules/protobufjs/minimal.js
var minimal = __webpack_require__(62100);
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/cosmos/auth/v1beta1/genesis.js



/** GenesisState defines the auth module's genesis state. */

function createBaseGenesisState() {
  return {
    params: undefined,
    accounts: []
  };
}

const GenesisState = {
  typeUrl: "/cosmos.auth.v1beta1.GenesisState",

  encode(message, writer = minimal.Writer.create()) {
    if (message.params !== undefined) {
      v1beta1_auth.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
    }

    for (const v of message.accounts) {
      any.Any.encode(v, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGenesisState();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.params = v1beta1_auth.Params.decode(reader, reader.uint32());
          break;

        case 2:
          message.accounts.push(any.Any.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$accounts;

    const message = createBaseGenesisState();
    message.params = object.params !== undefined && object.params !== null ? v1beta1_auth.Params.fromPartial(object.params) : undefined;
    message.accounts = ((_object$accounts = object.accounts) === null || _object$accounts === void 0 ? void 0 : _object$accounts.map(e => any.Any.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      params: object !== null && object !== void 0 && object.params ? v1beta1_auth.Params.fromAmino(object.params) : undefined,
      accounts: Array.isArray(object === null || object === void 0 ? void 0 : object.accounts) ? object.accounts.map(e => any.Any.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.params = message.params ? v1beta1_auth.Params.toAmino(message.params) : undefined;

    if (message.accounts) {
      obj.accounts = message.accounts.map(e => e ? any.Any.toAmino(e) : undefined);
    } else {
      obj.accounts = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return GenesisState.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/GenesisState",
      value: GenesisState.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return GenesisState.decode(message.value);
  },

  toProto(message) {
    return GenesisState.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.auth.v1beta1.GenesisState",
      value: GenesisState.encode(message).finish()
    };
  }

};
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/cosmos/auth/v1beta1/query.js
var query = __webpack_require__(87634);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/cosmos/authz/v1beta1/authz.js
var v1beta1_authz = __webpack_require__(83421);
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/cosmos/authz/v1beta1/event.js

/** EventGrant is emitted on Msg/Grant */

function createBaseEventGrant() {
  return {
    msgTypeUrl: "",
    granter: "",
    grantee: ""
  };
}

const EventGrant = {
  typeUrl: "/cosmos.authz.v1beta1.EventGrant",

  encode(message, writer = minimal.Writer.create()) {
    if (message.msgTypeUrl !== "") {
      writer.uint32(18).string(message.msgTypeUrl);
    }

    if (message.granter !== "") {
      writer.uint32(26).string(message.granter);
    }

    if (message.grantee !== "") {
      writer.uint32(34).string(message.grantee);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEventGrant();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 2:
          message.msgTypeUrl = reader.string();
          break;

        case 3:
          message.granter = reader.string();
          break;

        case 4:
          message.grantee = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$msgTypeUrl, _object$granter, _object$grantee;

    const message = createBaseEventGrant();
    message.msgTypeUrl = (_object$msgTypeUrl = object.msgTypeUrl) !== null && _object$msgTypeUrl !== void 0 ? _object$msgTypeUrl : "";
    message.granter = (_object$granter = object.granter) !== null && _object$granter !== void 0 ? _object$granter : "";
    message.grantee = (_object$grantee = object.grantee) !== null && _object$grantee !== void 0 ? _object$grantee : "";
    return message;
  },

  fromAmino(object) {
    return {
      msgTypeUrl: object.msg_type_url,
      granter: object.granter,
      grantee: object.grantee
    };
  },

  toAmino(message) {
    const obj = {};
    obj.msg_type_url = message.msgTypeUrl;
    obj.granter = message.granter;
    obj.grantee = message.grantee;
    return obj;
  },

  fromAminoMsg(object) {
    return EventGrant.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/EventGrant",
      value: EventGrant.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return EventGrant.decode(message.value);
  },

  toProto(message) {
    return EventGrant.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.authz.v1beta1.EventGrant",
      value: EventGrant.encode(message).finish()
    };
  }

};

function createBaseEventRevoke() {
  return {
    msgTypeUrl: "",
    granter: "",
    grantee: ""
  };
}

const EventRevoke = {
  typeUrl: "/cosmos.authz.v1beta1.EventRevoke",

  encode(message, writer = minimal.Writer.create()) {
    if (message.msgTypeUrl !== "") {
      writer.uint32(18).string(message.msgTypeUrl);
    }

    if (message.granter !== "") {
      writer.uint32(26).string(message.granter);
    }

    if (message.grantee !== "") {
      writer.uint32(34).string(message.grantee);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEventRevoke();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 2:
          message.msgTypeUrl = reader.string();
          break;

        case 3:
          message.granter = reader.string();
          break;

        case 4:
          message.grantee = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$msgTypeUrl2, _object$granter2, _object$grantee2;

    const message = createBaseEventRevoke();
    message.msgTypeUrl = (_object$msgTypeUrl2 = object.msgTypeUrl) !== null && _object$msgTypeUrl2 !== void 0 ? _object$msgTypeUrl2 : "";
    message.granter = (_object$granter2 = object.granter) !== null && _object$granter2 !== void 0 ? _object$granter2 : "";
    message.grantee = (_object$grantee2 = object.grantee) !== null && _object$grantee2 !== void 0 ? _object$grantee2 : "";
    return message;
  },

  fromAmino(object) {
    return {
      msgTypeUrl: object.msg_type_url,
      granter: object.granter,
      grantee: object.grantee
    };
  },

  toAmino(message) {
    const obj = {};
    obj.msg_type_url = message.msgTypeUrl;
    obj.granter = message.granter;
    obj.grantee = message.grantee;
    return obj;
  },

  fromAminoMsg(object) {
    return EventRevoke.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/EventRevoke",
      value: EventRevoke.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return EventRevoke.decode(message.value);
  },

  toProto(message) {
    return EventRevoke.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.authz.v1beta1.EventRevoke",
      value: EventRevoke.encode(message).finish()
    };
  }

};
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/cosmos/authz/v1beta1/genesis.js


/** GenesisState defines the authz module's genesis state. */

function genesis_createBaseGenesisState() {
  return {
    authorization: []
  };
}

const genesis_GenesisState = {
  typeUrl: "/cosmos.authz.v1beta1.GenesisState",

  encode(message, writer = minimal.Writer.create()) {
    for (const v of message.authorization) {
      v1beta1_authz.GrantAuthorization.encode(v, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = genesis_createBaseGenesisState();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.authorization.push(v1beta1_authz.GrantAuthorization.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$authorization;

    const message = genesis_createBaseGenesisState();
    message.authorization = ((_object$authorization = object.authorization) === null || _object$authorization === void 0 ? void 0 : _object$authorization.map(e => v1beta1_authz.GrantAuthorization.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      authorization: Array.isArray(object === null || object === void 0 ? void 0 : object.authorization) ? object.authorization.map(e => v1beta1_authz.GrantAuthorization.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.authorization) {
      obj.authorization = message.authorization.map(e => e ? v1beta1_authz.GrantAuthorization.toAmino(e) : undefined);
    } else {
      obj.authorization = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return genesis_GenesisState.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/GenesisState",
      value: genesis_GenesisState.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return genesis_GenesisState.decode(message.value);
  },

  toProto(message) {
    return genesis_GenesisState.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.authz.v1beta1.GenesisState",
      value: genesis_GenesisState.encode(message).finish()
    };
  }

};
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/cosmos/authz/v1beta1/query.js
var v1beta1_query = __webpack_require__(31482);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/cosmos/authz/v1beta1/tx.js
var v1beta1_tx = __webpack_require__(51355);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/cosmos/bank/v1beta1/authz.js
var bank_v1beta1_authz = __webpack_require__(19618);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/cosmos/bank/v1beta1/bank.js
var v1beta1_bank = __webpack_require__(38986);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/cosmos/base/v1beta1/coin.js
var coin = __webpack_require__(26178);
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/cosmos/bank/v1beta1/genesis.js



/** GenesisState defines the bank module's genesis state. */

function v1beta1_genesis_createBaseGenesisState() {
  return {
    params: undefined,
    balances: [],
    supply: [],
    denomMetadata: [],
    supplyOffsets: []
  };
}

const v1beta1_genesis_GenesisState = {
  typeUrl: "/cosmos.bank.v1beta1.GenesisState",

  encode(message, writer = minimal.Writer.create()) {
    if (message.params !== undefined) {
      v1beta1_bank.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
    }

    for (const v of message.balances) {
      Balance.encode(v, writer.uint32(18).fork()).ldelim();
    }

    for (const v of message.supply) {
      coin.Coin.encode(v, writer.uint32(26).fork()).ldelim();
    }

    for (const v of message.denomMetadata) {
      v1beta1_bank.Metadata.encode(v, writer.uint32(34).fork()).ldelim();
    }

    for (const v of message.supplyOffsets) {
      GenesisSupplyOffset.encode(v, writer.uint32(42).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = v1beta1_genesis_createBaseGenesisState();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.params = v1beta1_bank.Params.decode(reader, reader.uint32());
          break;

        case 2:
          message.balances.push(Balance.decode(reader, reader.uint32()));
          break;

        case 3:
          message.supply.push(coin.Coin.decode(reader, reader.uint32()));
          break;

        case 4:
          message.denomMetadata.push(v1beta1_bank.Metadata.decode(reader, reader.uint32()));
          break;

        case 5:
          message.supplyOffsets.push(GenesisSupplyOffset.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$balances, _object$supply, _object$denomMetadata, _object$supplyOffsets;

    const message = v1beta1_genesis_createBaseGenesisState();
    message.params = object.params !== undefined && object.params !== null ? v1beta1_bank.Params.fromPartial(object.params) : undefined;
    message.balances = ((_object$balances = object.balances) === null || _object$balances === void 0 ? void 0 : _object$balances.map(e => Balance.fromPartial(e))) || [];
    message.supply = ((_object$supply = object.supply) === null || _object$supply === void 0 ? void 0 : _object$supply.map(e => coin.Coin.fromPartial(e))) || [];
    message.denomMetadata = ((_object$denomMetadata = object.denomMetadata) === null || _object$denomMetadata === void 0 ? void 0 : _object$denomMetadata.map(e => v1beta1_bank.Metadata.fromPartial(e))) || [];
    message.supplyOffsets = ((_object$supplyOffsets = object.supplyOffsets) === null || _object$supplyOffsets === void 0 ? void 0 : _object$supplyOffsets.map(e => GenesisSupplyOffset.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      params: object !== null && object !== void 0 && object.params ? v1beta1_bank.Params.fromAmino(object.params) : undefined,
      balances: Array.isArray(object === null || object === void 0 ? void 0 : object.balances) ? object.balances.map(e => Balance.fromAmino(e)) : [],
      supply: Array.isArray(object === null || object === void 0 ? void 0 : object.supply) ? object.supply.map(e => coin.Coin.fromAmino(e)) : [],
      denomMetadata: Array.isArray(object === null || object === void 0 ? void 0 : object.denom_metadata) ? object.denom_metadata.map(e => v1beta1_bank.Metadata.fromAmino(e)) : [],
      supplyOffsets: Array.isArray(object === null || object === void 0 ? void 0 : object.supply_offsets) ? object.supply_offsets.map(e => GenesisSupplyOffset.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.params = message.params ? v1beta1_bank.Params.toAmino(message.params) : undefined;

    if (message.balances) {
      obj.balances = message.balances.map(e => e ? Balance.toAmino(e) : undefined);
    } else {
      obj.balances = [];
    }

    if (message.supply) {
      obj.supply = message.supply.map(e => e ? coin.Coin.toAmino(e) : undefined);
    } else {
      obj.supply = [];
    }

    if (message.denomMetadata) {
      obj.denom_metadata = message.denomMetadata.map(e => e ? v1beta1_bank.Metadata.toAmino(e) : undefined);
    } else {
      obj.denom_metadata = [];
    }

    if (message.supplyOffsets) {
      obj.supply_offsets = message.supplyOffsets.map(e => e ? GenesisSupplyOffset.toAmino(e) : undefined);
    } else {
      obj.supply_offsets = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return v1beta1_genesis_GenesisState.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/GenesisState",
      value: v1beta1_genesis_GenesisState.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return v1beta1_genesis_GenesisState.decode(message.value);
  },

  toProto(message) {
    return v1beta1_genesis_GenesisState.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.bank.v1beta1.GenesisState",
      value: v1beta1_genesis_GenesisState.encode(message).finish()
    };
  }

};

function createBaseBalance() {
  return {
    address: "",
    coins: []
  };
}

const Balance = {
  typeUrl: "/cosmos.bank.v1beta1.Balance",

  encode(message, writer = minimal.Writer.create()) {
    if (message.address !== "") {
      writer.uint32(10).string(message.address);
    }

    for (const v of message.coins) {
      coin.Coin.encode(v, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBalance();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.address = reader.string();
          break;

        case 2:
          message.coins.push(coin.Coin.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$address, _object$coins;

    const message = createBaseBalance();
    message.address = (_object$address = object.address) !== null && _object$address !== void 0 ? _object$address : "";
    message.coins = ((_object$coins = object.coins) === null || _object$coins === void 0 ? void 0 : _object$coins.map(e => coin.Coin.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      address: object.address,
      coins: Array.isArray(object === null || object === void 0 ? void 0 : object.coins) ? object.coins.map(e => coin.Coin.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.address = message.address;

    if (message.coins) {
      obj.coins = message.coins.map(e => e ? coin.Coin.toAmino(e) : undefined);
    } else {
      obj.coins = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return Balance.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/Balance",
      value: Balance.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return Balance.decode(message.value);
  },

  toProto(message) {
    return Balance.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.bank.v1beta1.Balance",
      value: Balance.encode(message).finish()
    };
  }

};

function createBaseGenesisSupplyOffset() {
  return {
    denom: "",
    offset: ""
  };
}

const GenesisSupplyOffset = {
  typeUrl: "/cosmos.bank.v1beta1.GenesisSupplyOffset",

  encode(message, writer = minimal.Writer.create()) {
    if (message.denom !== "") {
      writer.uint32(10).string(message.denom);
    }

    if (message.offset !== "") {
      writer.uint32(18).string(message.offset);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGenesisSupplyOffset();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.denom = reader.string();
          break;

        case 2:
          message.offset = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$denom, _object$offset;

    const message = createBaseGenesisSupplyOffset();
    message.denom = (_object$denom = object.denom) !== null && _object$denom !== void 0 ? _object$denom : "";
    message.offset = (_object$offset = object.offset) !== null && _object$offset !== void 0 ? _object$offset : "";
    return message;
  },

  fromAmino(object) {
    return {
      denom: object.denom,
      offset: object.offset
    };
  },

  toAmino(message) {
    const obj = {};
    obj.denom = message.denom;
    obj.offset = message.offset;
    return obj;
  },

  fromAminoMsg(object) {
    return GenesisSupplyOffset.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/GenesisSupplyOffset",
      value: GenesisSupplyOffset.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return GenesisSupplyOffset.decode(message.value);
  },

  toProto(message) {
    return GenesisSupplyOffset.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.bank.v1beta1.GenesisSupplyOffset",
      value: GenesisSupplyOffset.encode(message).finish()
    };
  }

};
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/cosmos/bank/v1beta1/query.js
var bank_v1beta1_query = __webpack_require__(33444);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/cosmos/bank/v1beta1/tx.js
var bank_v1beta1_tx = __webpack_require__(80276);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/cosmos/base/abci/v1beta1/abci.js
var v1beta1_abci = __webpack_require__(93049);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/cosmos/base/node/v1beta1/query.js
var node_v1beta1_query = __webpack_require__(34318);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/cosmos/base/query/v1beta1/pagination.js
var pagination = __webpack_require__(48978);
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/cosmos/base/reflection/v2alpha1/reflection.js

/** AppDescriptor describes a cosmos-sdk based application */

function createBaseAppDescriptor() {
  return {
    authn: undefined,
    chain: undefined,
    codec: undefined,
    configuration: undefined,
    queryServices: undefined,
    tx: undefined
  };
}

const AppDescriptor = {
  typeUrl: "/cosmos.base.reflection.v2alpha1.AppDescriptor",

  encode(message, writer = minimal.Writer.create()) {
    if (message.authn !== undefined) {
      AuthnDescriptor.encode(message.authn, writer.uint32(10).fork()).ldelim();
    }

    if (message.chain !== undefined) {
      ChainDescriptor.encode(message.chain, writer.uint32(18).fork()).ldelim();
    }

    if (message.codec !== undefined) {
      CodecDescriptor.encode(message.codec, writer.uint32(26).fork()).ldelim();
    }

    if (message.configuration !== undefined) {
      ConfigurationDescriptor.encode(message.configuration, writer.uint32(34).fork()).ldelim();
    }

    if (message.queryServices !== undefined) {
      QueryServicesDescriptor.encode(message.queryServices, writer.uint32(42).fork()).ldelim();
    }

    if (message.tx !== undefined) {
      TxDescriptor.encode(message.tx, writer.uint32(50).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAppDescriptor();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.authn = AuthnDescriptor.decode(reader, reader.uint32());
          break;

        case 2:
          message.chain = ChainDescriptor.decode(reader, reader.uint32());
          break;

        case 3:
          message.codec = CodecDescriptor.decode(reader, reader.uint32());
          break;

        case 4:
          message.configuration = ConfigurationDescriptor.decode(reader, reader.uint32());
          break;

        case 5:
          message.queryServices = QueryServicesDescriptor.decode(reader, reader.uint32());
          break;

        case 6:
          message.tx = TxDescriptor.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseAppDescriptor();
    message.authn = object.authn !== undefined && object.authn !== null ? AuthnDescriptor.fromPartial(object.authn) : undefined;
    message.chain = object.chain !== undefined && object.chain !== null ? ChainDescriptor.fromPartial(object.chain) : undefined;
    message.codec = object.codec !== undefined && object.codec !== null ? CodecDescriptor.fromPartial(object.codec) : undefined;
    message.configuration = object.configuration !== undefined && object.configuration !== null ? ConfigurationDescriptor.fromPartial(object.configuration) : undefined;
    message.queryServices = object.queryServices !== undefined && object.queryServices !== null ? QueryServicesDescriptor.fromPartial(object.queryServices) : undefined;
    message.tx = object.tx !== undefined && object.tx !== null ? TxDescriptor.fromPartial(object.tx) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      authn: object !== null && object !== void 0 && object.authn ? AuthnDescriptor.fromAmino(object.authn) : undefined,
      chain: object !== null && object !== void 0 && object.chain ? ChainDescriptor.fromAmino(object.chain) : undefined,
      codec: object !== null && object !== void 0 && object.codec ? CodecDescriptor.fromAmino(object.codec) : undefined,
      configuration: object !== null && object !== void 0 && object.configuration ? ConfigurationDescriptor.fromAmino(object.configuration) : undefined,
      queryServices: object !== null && object !== void 0 && object.query_services ? QueryServicesDescriptor.fromAmino(object.query_services) : undefined,
      tx: object !== null && object !== void 0 && object.tx ? TxDescriptor.fromAmino(object.tx) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.authn = message.authn ? AuthnDescriptor.toAmino(message.authn) : undefined;
    obj.chain = message.chain ? ChainDescriptor.toAmino(message.chain) : undefined;
    obj.codec = message.codec ? CodecDescriptor.toAmino(message.codec) : undefined;
    obj.configuration = message.configuration ? ConfigurationDescriptor.toAmino(message.configuration) : undefined;
    obj.query_services = message.queryServices ? QueryServicesDescriptor.toAmino(message.queryServices) : undefined;
    obj.tx = message.tx ? TxDescriptor.toAmino(message.tx) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return AppDescriptor.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/AppDescriptor",
      value: AppDescriptor.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return AppDescriptor.decode(message.value);
  },

  toProto(message) {
    return AppDescriptor.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.base.reflection.v2alpha1.AppDescriptor",
      value: AppDescriptor.encode(message).finish()
    };
  }

};

function createBaseTxDescriptor() {
  return {
    fullname: "",
    msgs: []
  };
}

const TxDescriptor = {
  typeUrl: "/cosmos.base.reflection.v2alpha1.TxDescriptor",

  encode(message, writer = minimal.Writer.create()) {
    if (message.fullname !== "") {
      writer.uint32(10).string(message.fullname);
    }

    for (const v of message.msgs) {
      MsgDescriptor.encode(v, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTxDescriptor();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.fullname = reader.string();
          break;

        case 2:
          message.msgs.push(MsgDescriptor.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$fullname, _object$msgs;

    const message = createBaseTxDescriptor();
    message.fullname = (_object$fullname = object.fullname) !== null && _object$fullname !== void 0 ? _object$fullname : "";
    message.msgs = ((_object$msgs = object.msgs) === null || _object$msgs === void 0 ? void 0 : _object$msgs.map(e => MsgDescriptor.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      fullname: object.fullname,
      msgs: Array.isArray(object === null || object === void 0 ? void 0 : object.msgs) ? object.msgs.map(e => MsgDescriptor.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.fullname = message.fullname;

    if (message.msgs) {
      obj.msgs = message.msgs.map(e => e ? MsgDescriptor.toAmino(e) : undefined);
    } else {
      obj.msgs = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return TxDescriptor.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/TxDescriptor",
      value: TxDescriptor.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return TxDescriptor.decode(message.value);
  },

  toProto(message) {
    return TxDescriptor.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.base.reflection.v2alpha1.TxDescriptor",
      value: TxDescriptor.encode(message).finish()
    };
  }

};

function createBaseAuthnDescriptor() {
  return {
    signModes: []
  };
}

const AuthnDescriptor = {
  typeUrl: "/cosmos.base.reflection.v2alpha1.AuthnDescriptor",

  encode(message, writer = minimal.Writer.create()) {
    for (const v of message.signModes) {
      SigningModeDescriptor.encode(v, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAuthnDescriptor();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.signModes.push(SigningModeDescriptor.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$signModes;

    const message = createBaseAuthnDescriptor();
    message.signModes = ((_object$signModes = object.signModes) === null || _object$signModes === void 0 ? void 0 : _object$signModes.map(e => SigningModeDescriptor.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      signModes: Array.isArray(object === null || object === void 0 ? void 0 : object.sign_modes) ? object.sign_modes.map(e => SigningModeDescriptor.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.signModes) {
      obj.sign_modes = message.signModes.map(e => e ? SigningModeDescriptor.toAmino(e) : undefined);
    } else {
      obj.sign_modes = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return AuthnDescriptor.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/AuthnDescriptor",
      value: AuthnDescriptor.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return AuthnDescriptor.decode(message.value);
  },

  toProto(message) {
    return AuthnDescriptor.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.base.reflection.v2alpha1.AuthnDescriptor",
      value: AuthnDescriptor.encode(message).finish()
    };
  }

};

function createBaseSigningModeDescriptor() {
  return {
    name: "",
    number: 0,
    authnInfoProviderMethodFullname: ""
  };
}

const SigningModeDescriptor = {
  typeUrl: "/cosmos.base.reflection.v2alpha1.SigningModeDescriptor",

  encode(message, writer = minimal.Writer.create()) {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }

    if (message.number !== 0) {
      writer.uint32(16).int32(message.number);
    }

    if (message.authnInfoProviderMethodFullname !== "") {
      writer.uint32(26).string(message.authnInfoProviderMethodFullname);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSigningModeDescriptor();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.name = reader.string();
          break;

        case 2:
          message.number = reader.int32();
          break;

        case 3:
          message.authnInfoProviderMethodFullname = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$name, _object$number, _object$authnInfoProv;

    const message = createBaseSigningModeDescriptor();
    message.name = (_object$name = object.name) !== null && _object$name !== void 0 ? _object$name : "";
    message.number = (_object$number = object.number) !== null && _object$number !== void 0 ? _object$number : 0;
    message.authnInfoProviderMethodFullname = (_object$authnInfoProv = object.authnInfoProviderMethodFullname) !== null && _object$authnInfoProv !== void 0 ? _object$authnInfoProv : "";
    return message;
  },

  fromAmino(object) {
    return {
      name: object.name,
      number: object.number,
      authnInfoProviderMethodFullname: object.authn_info_provider_method_fullname
    };
  },

  toAmino(message) {
    const obj = {};
    obj.name = message.name;
    obj.number = message.number;
    obj.authn_info_provider_method_fullname = message.authnInfoProviderMethodFullname;
    return obj;
  },

  fromAminoMsg(object) {
    return SigningModeDescriptor.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/SigningModeDescriptor",
      value: SigningModeDescriptor.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return SigningModeDescriptor.decode(message.value);
  },

  toProto(message) {
    return SigningModeDescriptor.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.base.reflection.v2alpha1.SigningModeDescriptor",
      value: SigningModeDescriptor.encode(message).finish()
    };
  }

};

function createBaseChainDescriptor() {
  return {
    id: ""
  };
}

const ChainDescriptor = {
  typeUrl: "/cosmos.base.reflection.v2alpha1.ChainDescriptor",

  encode(message, writer = minimal.Writer.create()) {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseChainDescriptor();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.id = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$id;

    const message = createBaseChainDescriptor();
    message.id = (_object$id = object.id) !== null && _object$id !== void 0 ? _object$id : "";
    return message;
  },

  fromAmino(object) {
    return {
      id: object.id
    };
  },

  toAmino(message) {
    const obj = {};
    obj.id = message.id;
    return obj;
  },

  fromAminoMsg(object) {
    return ChainDescriptor.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/ChainDescriptor",
      value: ChainDescriptor.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return ChainDescriptor.decode(message.value);
  },

  toProto(message) {
    return ChainDescriptor.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.base.reflection.v2alpha1.ChainDescriptor",
      value: ChainDescriptor.encode(message).finish()
    };
  }

};

function createBaseCodecDescriptor() {
  return {
    interfaces: []
  };
}

const CodecDescriptor = {
  typeUrl: "/cosmos.base.reflection.v2alpha1.CodecDescriptor",

  encode(message, writer = minimal.Writer.create()) {
    for (const v of message.interfaces) {
      InterfaceDescriptor.encode(v, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCodecDescriptor();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.interfaces.push(InterfaceDescriptor.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$interfaces;

    const message = createBaseCodecDescriptor();
    message.interfaces = ((_object$interfaces = object.interfaces) === null || _object$interfaces === void 0 ? void 0 : _object$interfaces.map(e => InterfaceDescriptor.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      interfaces: Array.isArray(object === null || object === void 0 ? void 0 : object.interfaces) ? object.interfaces.map(e => InterfaceDescriptor.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.interfaces) {
      obj.interfaces = message.interfaces.map(e => e ? InterfaceDescriptor.toAmino(e) : undefined);
    } else {
      obj.interfaces = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return CodecDescriptor.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/CodecDescriptor",
      value: CodecDescriptor.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return CodecDescriptor.decode(message.value);
  },

  toProto(message) {
    return CodecDescriptor.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.base.reflection.v2alpha1.CodecDescriptor",
      value: CodecDescriptor.encode(message).finish()
    };
  }

};

function createBaseInterfaceDescriptor() {
  return {
    fullname: "",
    interfaceAcceptingMessages: [],
    interfaceImplementers: []
  };
}

const InterfaceDescriptor = {
  typeUrl: "/cosmos.base.reflection.v2alpha1.InterfaceDescriptor",

  encode(message, writer = minimal.Writer.create()) {
    if (message.fullname !== "") {
      writer.uint32(10).string(message.fullname);
    }

    for (const v of message.interfaceAcceptingMessages) {
      InterfaceAcceptingMessageDescriptor.encode(v, writer.uint32(18).fork()).ldelim();
    }

    for (const v of message.interfaceImplementers) {
      InterfaceImplementerDescriptor.encode(v, writer.uint32(26).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInterfaceDescriptor();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.fullname = reader.string();
          break;

        case 2:
          message.interfaceAcceptingMessages.push(InterfaceAcceptingMessageDescriptor.decode(reader, reader.uint32()));
          break;

        case 3:
          message.interfaceImplementers.push(InterfaceImplementerDescriptor.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$fullname2, _object$interfaceAcce, _object$interfaceImpl;

    const message = createBaseInterfaceDescriptor();
    message.fullname = (_object$fullname2 = object.fullname) !== null && _object$fullname2 !== void 0 ? _object$fullname2 : "";
    message.interfaceAcceptingMessages = ((_object$interfaceAcce = object.interfaceAcceptingMessages) === null || _object$interfaceAcce === void 0 ? void 0 : _object$interfaceAcce.map(e => InterfaceAcceptingMessageDescriptor.fromPartial(e))) || [];
    message.interfaceImplementers = ((_object$interfaceImpl = object.interfaceImplementers) === null || _object$interfaceImpl === void 0 ? void 0 : _object$interfaceImpl.map(e => InterfaceImplementerDescriptor.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      fullname: object.fullname,
      interfaceAcceptingMessages: Array.isArray(object === null || object === void 0 ? void 0 : object.interface_accepting_messages) ? object.interface_accepting_messages.map(e => InterfaceAcceptingMessageDescriptor.fromAmino(e)) : [],
      interfaceImplementers: Array.isArray(object === null || object === void 0 ? void 0 : object.interface_implementers) ? object.interface_implementers.map(e => InterfaceImplementerDescriptor.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.fullname = message.fullname;

    if (message.interfaceAcceptingMessages) {
      obj.interface_accepting_messages = message.interfaceAcceptingMessages.map(e => e ? InterfaceAcceptingMessageDescriptor.toAmino(e) : undefined);
    } else {
      obj.interface_accepting_messages = [];
    }

    if (message.interfaceImplementers) {
      obj.interface_implementers = message.interfaceImplementers.map(e => e ? InterfaceImplementerDescriptor.toAmino(e) : undefined);
    } else {
      obj.interface_implementers = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return InterfaceDescriptor.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/InterfaceDescriptor",
      value: InterfaceDescriptor.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return InterfaceDescriptor.decode(message.value);
  },

  toProto(message) {
    return InterfaceDescriptor.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.base.reflection.v2alpha1.InterfaceDescriptor",
      value: InterfaceDescriptor.encode(message).finish()
    };
  }

};

function createBaseInterfaceImplementerDescriptor() {
  return {
    fullname: "",
    typeUrl: ""
  };
}

const InterfaceImplementerDescriptor = {
  typeUrl: "/cosmos.base.reflection.v2alpha1.InterfaceImplementerDescriptor",

  encode(message, writer = minimal.Writer.create()) {
    if (message.fullname !== "") {
      writer.uint32(10).string(message.fullname);
    }

    if (message.typeUrl !== "") {
      writer.uint32(18).string(message.typeUrl);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInterfaceImplementerDescriptor();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.fullname = reader.string();
          break;

        case 2:
          message.typeUrl = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$fullname3, _object$typeUrl;

    const message = createBaseInterfaceImplementerDescriptor();
    message.fullname = (_object$fullname3 = object.fullname) !== null && _object$fullname3 !== void 0 ? _object$fullname3 : "";
    message.typeUrl = (_object$typeUrl = object.typeUrl) !== null && _object$typeUrl !== void 0 ? _object$typeUrl : "";
    return message;
  },

  fromAmino(object) {
    return {
      fullname: object.fullname,
      typeUrl: object.type_url
    };
  },

  toAmino(message) {
    const obj = {};
    obj.fullname = message.fullname;
    obj.type_url = message.typeUrl;
    return obj;
  },

  fromAminoMsg(object) {
    return InterfaceImplementerDescriptor.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/InterfaceImplementerDescriptor",
      value: InterfaceImplementerDescriptor.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return InterfaceImplementerDescriptor.decode(message.value);
  },

  toProto(message) {
    return InterfaceImplementerDescriptor.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.base.reflection.v2alpha1.InterfaceImplementerDescriptor",
      value: InterfaceImplementerDescriptor.encode(message).finish()
    };
  }

};

function createBaseInterfaceAcceptingMessageDescriptor() {
  return {
    fullname: "",
    fieldDescriptorNames: []
  };
}

const InterfaceAcceptingMessageDescriptor = {
  typeUrl: "/cosmos.base.reflection.v2alpha1.InterfaceAcceptingMessageDescriptor",

  encode(message, writer = minimal.Writer.create()) {
    if (message.fullname !== "") {
      writer.uint32(10).string(message.fullname);
    }

    for (const v of message.fieldDescriptorNames) {
      writer.uint32(18).string(v);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInterfaceAcceptingMessageDescriptor();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.fullname = reader.string();
          break;

        case 2:
          message.fieldDescriptorNames.push(reader.string());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$fullname4, _object$fieldDescript;

    const message = createBaseInterfaceAcceptingMessageDescriptor();
    message.fullname = (_object$fullname4 = object.fullname) !== null && _object$fullname4 !== void 0 ? _object$fullname4 : "";
    message.fieldDescriptorNames = ((_object$fieldDescript = object.fieldDescriptorNames) === null || _object$fieldDescript === void 0 ? void 0 : _object$fieldDescript.map(e => e)) || [];
    return message;
  },

  fromAmino(object) {
    return {
      fullname: object.fullname,
      fieldDescriptorNames: Array.isArray(object === null || object === void 0 ? void 0 : object.field_descriptor_names) ? object.field_descriptor_names.map(e => e) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.fullname = message.fullname;

    if (message.fieldDescriptorNames) {
      obj.field_descriptor_names = message.fieldDescriptorNames.map(e => e);
    } else {
      obj.field_descriptor_names = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return InterfaceAcceptingMessageDescriptor.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/InterfaceAcceptingMessageDescriptor",
      value: InterfaceAcceptingMessageDescriptor.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return InterfaceAcceptingMessageDescriptor.decode(message.value);
  },

  toProto(message) {
    return InterfaceAcceptingMessageDescriptor.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.base.reflection.v2alpha1.InterfaceAcceptingMessageDescriptor",
      value: InterfaceAcceptingMessageDescriptor.encode(message).finish()
    };
  }

};

function createBaseConfigurationDescriptor() {
  return {
    bech32AccountAddressPrefix: ""
  };
}

const ConfigurationDescriptor = {
  typeUrl: "/cosmos.base.reflection.v2alpha1.ConfigurationDescriptor",

  encode(message, writer = minimal.Writer.create()) {
    if (message.bech32AccountAddressPrefix !== "") {
      writer.uint32(10).string(message.bech32AccountAddressPrefix);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseConfigurationDescriptor();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.bech32AccountAddressPrefix = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$bech32Account;

    const message = createBaseConfigurationDescriptor();
    message.bech32AccountAddressPrefix = (_object$bech32Account = object.bech32AccountAddressPrefix) !== null && _object$bech32Account !== void 0 ? _object$bech32Account : "";
    return message;
  },

  fromAmino(object) {
    return {
      bech32AccountAddressPrefix: object.bech32_account_address_prefix
    };
  },

  toAmino(message) {
    const obj = {};
    obj.bech32_account_address_prefix = message.bech32AccountAddressPrefix;
    return obj;
  },

  fromAminoMsg(object) {
    return ConfigurationDescriptor.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/ConfigurationDescriptor",
      value: ConfigurationDescriptor.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return ConfigurationDescriptor.decode(message.value);
  },

  toProto(message) {
    return ConfigurationDescriptor.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.base.reflection.v2alpha1.ConfigurationDescriptor",
      value: ConfigurationDescriptor.encode(message).finish()
    };
  }

};

function createBaseMsgDescriptor() {
  return {
    msgTypeUrl: ""
  };
}

const MsgDescriptor = {
  typeUrl: "/cosmos.base.reflection.v2alpha1.MsgDescriptor",

  encode(message, writer = minimal.Writer.create()) {
    if (message.msgTypeUrl !== "") {
      writer.uint32(10).string(message.msgTypeUrl);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgDescriptor();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.msgTypeUrl = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$msgTypeUrl;

    const message = createBaseMsgDescriptor();
    message.msgTypeUrl = (_object$msgTypeUrl = object.msgTypeUrl) !== null && _object$msgTypeUrl !== void 0 ? _object$msgTypeUrl : "";
    return message;
  },

  fromAmino(object) {
    return {
      msgTypeUrl: object.msg_type_url
    };
  },

  toAmino(message) {
    const obj = {};
    obj.msg_type_url = message.msgTypeUrl;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgDescriptor.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/MsgDescriptor",
      value: MsgDescriptor.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgDescriptor.decode(message.value);
  },

  toProto(message) {
    return MsgDescriptor.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.base.reflection.v2alpha1.MsgDescriptor",
      value: MsgDescriptor.encode(message).finish()
    };
  }

};

function createBaseGetAuthnDescriptorRequest() {
  return {};
}

const GetAuthnDescriptorRequest = {
  typeUrl: "/cosmos.base.reflection.v2alpha1.GetAuthnDescriptorRequest",

  encode(_, writer = minimal.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetAuthnDescriptorRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseGetAuthnDescriptorRequest();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return GetAuthnDescriptorRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/GetAuthnDescriptorRequest",
      value: GetAuthnDescriptorRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return GetAuthnDescriptorRequest.decode(message.value);
  },

  toProto(message) {
    return GetAuthnDescriptorRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.base.reflection.v2alpha1.GetAuthnDescriptorRequest",
      value: GetAuthnDescriptorRequest.encode(message).finish()
    };
  }

};

function createBaseGetAuthnDescriptorResponse() {
  return {
    authn: undefined
  };
}

const GetAuthnDescriptorResponse = {
  typeUrl: "/cosmos.base.reflection.v2alpha1.GetAuthnDescriptorResponse",

  encode(message, writer = minimal.Writer.create()) {
    if (message.authn !== undefined) {
      AuthnDescriptor.encode(message.authn, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetAuthnDescriptorResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.authn = AuthnDescriptor.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseGetAuthnDescriptorResponse();
    message.authn = object.authn !== undefined && object.authn !== null ? AuthnDescriptor.fromPartial(object.authn) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      authn: object !== null && object !== void 0 && object.authn ? AuthnDescriptor.fromAmino(object.authn) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.authn = message.authn ? AuthnDescriptor.toAmino(message.authn) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return GetAuthnDescriptorResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/GetAuthnDescriptorResponse",
      value: GetAuthnDescriptorResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return GetAuthnDescriptorResponse.decode(message.value);
  },

  toProto(message) {
    return GetAuthnDescriptorResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.base.reflection.v2alpha1.GetAuthnDescriptorResponse",
      value: GetAuthnDescriptorResponse.encode(message).finish()
    };
  }

};

function createBaseGetChainDescriptorRequest() {
  return {};
}

const GetChainDescriptorRequest = {
  typeUrl: "/cosmos.base.reflection.v2alpha1.GetChainDescriptorRequest",

  encode(_, writer = minimal.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetChainDescriptorRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseGetChainDescriptorRequest();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return GetChainDescriptorRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/GetChainDescriptorRequest",
      value: GetChainDescriptorRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return GetChainDescriptorRequest.decode(message.value);
  },

  toProto(message) {
    return GetChainDescriptorRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.base.reflection.v2alpha1.GetChainDescriptorRequest",
      value: GetChainDescriptorRequest.encode(message).finish()
    };
  }

};

function createBaseGetChainDescriptorResponse() {
  return {
    chain: undefined
  };
}

const GetChainDescriptorResponse = {
  typeUrl: "/cosmos.base.reflection.v2alpha1.GetChainDescriptorResponse",

  encode(message, writer = minimal.Writer.create()) {
    if (message.chain !== undefined) {
      ChainDescriptor.encode(message.chain, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetChainDescriptorResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.chain = ChainDescriptor.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseGetChainDescriptorResponse();
    message.chain = object.chain !== undefined && object.chain !== null ? ChainDescriptor.fromPartial(object.chain) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      chain: object !== null && object !== void 0 && object.chain ? ChainDescriptor.fromAmino(object.chain) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.chain = message.chain ? ChainDescriptor.toAmino(message.chain) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return GetChainDescriptorResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/GetChainDescriptorResponse",
      value: GetChainDescriptorResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return GetChainDescriptorResponse.decode(message.value);
  },

  toProto(message) {
    return GetChainDescriptorResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.base.reflection.v2alpha1.GetChainDescriptorResponse",
      value: GetChainDescriptorResponse.encode(message).finish()
    };
  }

};

function createBaseGetCodecDescriptorRequest() {
  return {};
}

const GetCodecDescriptorRequest = {
  typeUrl: "/cosmos.base.reflection.v2alpha1.GetCodecDescriptorRequest",

  encode(_, writer = minimal.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetCodecDescriptorRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseGetCodecDescriptorRequest();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return GetCodecDescriptorRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/GetCodecDescriptorRequest",
      value: GetCodecDescriptorRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return GetCodecDescriptorRequest.decode(message.value);
  },

  toProto(message) {
    return GetCodecDescriptorRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.base.reflection.v2alpha1.GetCodecDescriptorRequest",
      value: GetCodecDescriptorRequest.encode(message).finish()
    };
  }

};

function createBaseGetCodecDescriptorResponse() {
  return {
    codec: undefined
  };
}

const GetCodecDescriptorResponse = {
  typeUrl: "/cosmos.base.reflection.v2alpha1.GetCodecDescriptorResponse",

  encode(message, writer = minimal.Writer.create()) {
    if (message.codec !== undefined) {
      CodecDescriptor.encode(message.codec, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetCodecDescriptorResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.codec = CodecDescriptor.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseGetCodecDescriptorResponse();
    message.codec = object.codec !== undefined && object.codec !== null ? CodecDescriptor.fromPartial(object.codec) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      codec: object !== null && object !== void 0 && object.codec ? CodecDescriptor.fromAmino(object.codec) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.codec = message.codec ? CodecDescriptor.toAmino(message.codec) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return GetCodecDescriptorResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/GetCodecDescriptorResponse",
      value: GetCodecDescriptorResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return GetCodecDescriptorResponse.decode(message.value);
  },

  toProto(message) {
    return GetCodecDescriptorResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.base.reflection.v2alpha1.GetCodecDescriptorResponse",
      value: GetCodecDescriptorResponse.encode(message).finish()
    };
  }

};

function createBaseGetConfigurationDescriptorRequest() {
  return {};
}

const GetConfigurationDescriptorRequest = {
  typeUrl: "/cosmos.base.reflection.v2alpha1.GetConfigurationDescriptorRequest",

  encode(_, writer = minimal.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetConfigurationDescriptorRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseGetConfigurationDescriptorRequest();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return GetConfigurationDescriptorRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/GetConfigurationDescriptorRequest",
      value: GetConfigurationDescriptorRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return GetConfigurationDescriptorRequest.decode(message.value);
  },

  toProto(message) {
    return GetConfigurationDescriptorRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.base.reflection.v2alpha1.GetConfigurationDescriptorRequest",
      value: GetConfigurationDescriptorRequest.encode(message).finish()
    };
  }

};

function createBaseGetConfigurationDescriptorResponse() {
  return {
    config: undefined
  };
}

const GetConfigurationDescriptorResponse = {
  typeUrl: "/cosmos.base.reflection.v2alpha1.GetConfigurationDescriptorResponse",

  encode(message, writer = minimal.Writer.create()) {
    if (message.config !== undefined) {
      ConfigurationDescriptor.encode(message.config, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetConfigurationDescriptorResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.config = ConfigurationDescriptor.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseGetConfigurationDescriptorResponse();
    message.config = object.config !== undefined && object.config !== null ? ConfigurationDescriptor.fromPartial(object.config) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      config: object !== null && object !== void 0 && object.config ? ConfigurationDescriptor.fromAmino(object.config) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.config = message.config ? ConfigurationDescriptor.toAmino(message.config) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return GetConfigurationDescriptorResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/GetConfigurationDescriptorResponse",
      value: GetConfigurationDescriptorResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return GetConfigurationDescriptorResponse.decode(message.value);
  },

  toProto(message) {
    return GetConfigurationDescriptorResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.base.reflection.v2alpha1.GetConfigurationDescriptorResponse",
      value: GetConfigurationDescriptorResponse.encode(message).finish()
    };
  }

};

function createBaseGetQueryServicesDescriptorRequest() {
  return {};
}

const GetQueryServicesDescriptorRequest = {
  typeUrl: "/cosmos.base.reflection.v2alpha1.GetQueryServicesDescriptorRequest",

  encode(_, writer = minimal.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetQueryServicesDescriptorRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseGetQueryServicesDescriptorRequest();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return GetQueryServicesDescriptorRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/GetQueryServicesDescriptorRequest",
      value: GetQueryServicesDescriptorRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return GetQueryServicesDescriptorRequest.decode(message.value);
  },

  toProto(message) {
    return GetQueryServicesDescriptorRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.base.reflection.v2alpha1.GetQueryServicesDescriptorRequest",
      value: GetQueryServicesDescriptorRequest.encode(message).finish()
    };
  }

};

function createBaseGetQueryServicesDescriptorResponse() {
  return {
    queries: undefined
  };
}

const GetQueryServicesDescriptorResponse = {
  typeUrl: "/cosmos.base.reflection.v2alpha1.GetQueryServicesDescriptorResponse",

  encode(message, writer = minimal.Writer.create()) {
    if (message.queries !== undefined) {
      QueryServicesDescriptor.encode(message.queries, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetQueryServicesDescriptorResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.queries = QueryServicesDescriptor.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseGetQueryServicesDescriptorResponse();
    message.queries = object.queries !== undefined && object.queries !== null ? QueryServicesDescriptor.fromPartial(object.queries) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      queries: object !== null && object !== void 0 && object.queries ? QueryServicesDescriptor.fromAmino(object.queries) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.queries = message.queries ? QueryServicesDescriptor.toAmino(message.queries) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return GetQueryServicesDescriptorResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/GetQueryServicesDescriptorResponse",
      value: GetQueryServicesDescriptorResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return GetQueryServicesDescriptorResponse.decode(message.value);
  },

  toProto(message) {
    return GetQueryServicesDescriptorResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.base.reflection.v2alpha1.GetQueryServicesDescriptorResponse",
      value: GetQueryServicesDescriptorResponse.encode(message).finish()
    };
  }

};

function createBaseGetTxDescriptorRequest() {
  return {};
}

const GetTxDescriptorRequest = {
  typeUrl: "/cosmos.base.reflection.v2alpha1.GetTxDescriptorRequest",

  encode(_, writer = minimal.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetTxDescriptorRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseGetTxDescriptorRequest();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return GetTxDescriptorRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/GetTxDescriptorRequest",
      value: GetTxDescriptorRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return GetTxDescriptorRequest.decode(message.value);
  },

  toProto(message) {
    return GetTxDescriptorRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.base.reflection.v2alpha1.GetTxDescriptorRequest",
      value: GetTxDescriptorRequest.encode(message).finish()
    };
  }

};

function createBaseGetTxDescriptorResponse() {
  return {
    tx: undefined
  };
}

const GetTxDescriptorResponse = {
  typeUrl: "/cosmos.base.reflection.v2alpha1.GetTxDescriptorResponse",

  encode(message, writer = minimal.Writer.create()) {
    if (message.tx !== undefined) {
      TxDescriptor.encode(message.tx, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetTxDescriptorResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.tx = TxDescriptor.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseGetTxDescriptorResponse();
    message.tx = object.tx !== undefined && object.tx !== null ? TxDescriptor.fromPartial(object.tx) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      tx: object !== null && object !== void 0 && object.tx ? TxDescriptor.fromAmino(object.tx) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.tx = message.tx ? TxDescriptor.toAmino(message.tx) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return GetTxDescriptorResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/GetTxDescriptorResponse",
      value: GetTxDescriptorResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return GetTxDescriptorResponse.decode(message.value);
  },

  toProto(message) {
    return GetTxDescriptorResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.base.reflection.v2alpha1.GetTxDescriptorResponse",
      value: GetTxDescriptorResponse.encode(message).finish()
    };
  }

};

function createBaseQueryServicesDescriptor() {
  return {
    queryServices: []
  };
}

const QueryServicesDescriptor = {
  typeUrl: "/cosmos.base.reflection.v2alpha1.QueryServicesDescriptor",

  encode(message, writer = minimal.Writer.create()) {
    for (const v of message.queryServices) {
      QueryServiceDescriptor.encode(v, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryServicesDescriptor();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.queryServices.push(QueryServiceDescriptor.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$queryServices;

    const message = createBaseQueryServicesDescriptor();
    message.queryServices = ((_object$queryServices = object.queryServices) === null || _object$queryServices === void 0 ? void 0 : _object$queryServices.map(e => QueryServiceDescriptor.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      queryServices: Array.isArray(object === null || object === void 0 ? void 0 : object.query_services) ? object.query_services.map(e => QueryServiceDescriptor.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.queryServices) {
      obj.query_services = message.queryServices.map(e => e ? QueryServiceDescriptor.toAmino(e) : undefined);
    } else {
      obj.query_services = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return QueryServicesDescriptor.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryServicesDescriptor",
      value: QueryServicesDescriptor.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryServicesDescriptor.decode(message.value);
  },

  toProto(message) {
    return QueryServicesDescriptor.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.base.reflection.v2alpha1.QueryServicesDescriptor",
      value: QueryServicesDescriptor.encode(message).finish()
    };
  }

};

function createBaseQueryServiceDescriptor() {
  return {
    fullname: "",
    isModule: false,
    methods: []
  };
}

const QueryServiceDescriptor = {
  typeUrl: "/cosmos.base.reflection.v2alpha1.QueryServiceDescriptor",

  encode(message, writer = minimal.Writer.create()) {
    if (message.fullname !== "") {
      writer.uint32(10).string(message.fullname);
    }

    if (message.isModule === true) {
      writer.uint32(16).bool(message.isModule);
    }

    for (const v of message.methods) {
      QueryMethodDescriptor.encode(v, writer.uint32(26).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryServiceDescriptor();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.fullname = reader.string();
          break;

        case 2:
          message.isModule = reader.bool();
          break;

        case 3:
          message.methods.push(QueryMethodDescriptor.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$fullname5, _object$isModule, _object$methods;

    const message = createBaseQueryServiceDescriptor();
    message.fullname = (_object$fullname5 = object.fullname) !== null && _object$fullname5 !== void 0 ? _object$fullname5 : "";
    message.isModule = (_object$isModule = object.isModule) !== null && _object$isModule !== void 0 ? _object$isModule : false;
    message.methods = ((_object$methods = object.methods) === null || _object$methods === void 0 ? void 0 : _object$methods.map(e => QueryMethodDescriptor.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      fullname: object.fullname,
      isModule: object.is_module,
      methods: Array.isArray(object === null || object === void 0 ? void 0 : object.methods) ? object.methods.map(e => QueryMethodDescriptor.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.fullname = message.fullname;
    obj.is_module = message.isModule;

    if (message.methods) {
      obj.methods = message.methods.map(e => e ? QueryMethodDescriptor.toAmino(e) : undefined);
    } else {
      obj.methods = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return QueryServiceDescriptor.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryServiceDescriptor",
      value: QueryServiceDescriptor.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryServiceDescriptor.decode(message.value);
  },

  toProto(message) {
    return QueryServiceDescriptor.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.base.reflection.v2alpha1.QueryServiceDescriptor",
      value: QueryServiceDescriptor.encode(message).finish()
    };
  }

};

function createBaseQueryMethodDescriptor() {
  return {
    name: "",
    fullQueryPath: ""
  };
}

const QueryMethodDescriptor = {
  typeUrl: "/cosmos.base.reflection.v2alpha1.QueryMethodDescriptor",

  encode(message, writer = minimal.Writer.create()) {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }

    if (message.fullQueryPath !== "") {
      writer.uint32(18).string(message.fullQueryPath);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryMethodDescriptor();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.name = reader.string();
          break;

        case 2:
          message.fullQueryPath = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$name2, _object$fullQueryPath;

    const message = createBaseQueryMethodDescriptor();
    message.name = (_object$name2 = object.name) !== null && _object$name2 !== void 0 ? _object$name2 : "";
    message.fullQueryPath = (_object$fullQueryPath = object.fullQueryPath) !== null && _object$fullQueryPath !== void 0 ? _object$fullQueryPath : "";
    return message;
  },

  fromAmino(object) {
    return {
      name: object.name,
      fullQueryPath: object.full_query_path
    };
  },

  toAmino(message) {
    const obj = {};
    obj.name = message.name;
    obj.full_query_path = message.fullQueryPath;
    return obj;
  },

  fromAminoMsg(object) {
    return QueryMethodDescriptor.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/QueryMethodDescriptor",
      value: QueryMethodDescriptor.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return QueryMethodDescriptor.decode(message.value);
  },

  toProto(message) {
    return QueryMethodDescriptor.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.base.reflection.v2alpha1.QueryMethodDescriptor",
      value: QueryMethodDescriptor.encode(message).finish()
    };
  }

};
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/cosmos/crypto/ed25519/keys.js

/**
 * PubKey is an ed25519 public key for handling Tendermint keys in SDK.
 * It's needed for Any serialization and SDK compatibility.
 * It must not be used in a non Tendermint key context because it doesn't implement
 * ADR-28. Nevertheless, you will like to use ed25519 in app user level
 * then you must create a new proto message and follow ADR-28 for Address construction.
 */

function createBasePubKey() {
  return {
    key: new Uint8Array()
  };
}

const PubKey = {
  typeUrl: "/cosmos.crypto.ed25519.PubKey",

  encode(message, writer = minimal.Writer.create()) {
    if (message.key.length !== 0) {
      writer.uint32(10).bytes(message.key);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePubKey();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.key = reader.bytes();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$key;

    const message = createBasePubKey();
    message.key = (_object$key = object.key) !== null && _object$key !== void 0 ? _object$key : new Uint8Array();
    return message;
  },

  fromAmino(object) {
    return {
      key: object.key
    };
  },

  toAmino(message) {
    const obj = {};
    obj.key = message.key;
    return obj;
  },

  fromAminoMsg(object) {
    return PubKey.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "tendermint/PubKeyEd25519",
      value: PubKey.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return PubKey.decode(message.value);
  },

  toProto(message) {
    return PubKey.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.crypto.ed25519.PubKey",
      value: PubKey.encode(message).finish()
    };
  }

};

function createBasePrivKey() {
  return {
    key: new Uint8Array()
  };
}

const PrivKey = {
  typeUrl: "/cosmos.crypto.ed25519.PrivKey",

  encode(message, writer = minimal.Writer.create()) {
    if (message.key.length !== 0) {
      writer.uint32(10).bytes(message.key);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePrivKey();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.key = reader.bytes();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$key2;

    const message = createBasePrivKey();
    message.key = (_object$key2 = object.key) !== null && _object$key2 !== void 0 ? _object$key2 : new Uint8Array();
    return message;
  },

  fromAmino(object) {
    return {
      key: object.key
    };
  },

  toAmino(message) {
    const obj = {};
    obj.key = message.key;
    return obj;
  },

  fromAminoMsg(object) {
    return PrivKey.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "tendermint/PrivKeyEd25519",
      value: PrivKey.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return PrivKey.decode(message.value);
  },

  toProto(message) {
    return PrivKey.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.crypto.ed25519.PrivKey",
      value: PrivKey.encode(message).finish()
    };
  }

};
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/cosmos/crypto/multisig/keys.js


/**
 * LegacyAminoPubKey specifies a public key type
 * which nests multiple public keys and a threshold,
 * it uses legacy amino address rules.
 */

function createBaseLegacyAminoPubKey() {
  return {
    threshold: 0,
    publicKeys: []
  };
}

const LegacyAminoPubKey = {
  typeUrl: "/cosmos.crypto.multisig.LegacyAminoPubKey",

  encode(message, writer = minimal.Writer.create()) {
    if (message.threshold !== 0) {
      writer.uint32(8).uint32(message.threshold);
    }

    for (const v of message.publicKeys) {
      any.Any.encode(v, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLegacyAminoPubKey();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.threshold = reader.uint32();
          break;

        case 2:
          message.publicKeys.push(any.Any.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$threshold, _object$publicKeys;

    const message = createBaseLegacyAminoPubKey();
    message.threshold = (_object$threshold = object.threshold) !== null && _object$threshold !== void 0 ? _object$threshold : 0;
    message.publicKeys = ((_object$publicKeys = object.publicKeys) === null || _object$publicKeys === void 0 ? void 0 : _object$publicKeys.map(e => any.Any.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      threshold: object.threshold,
      publicKeys: Array.isArray(object === null || object === void 0 ? void 0 : object.public_keys) ? object.public_keys.map(e => any.Any.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.threshold = message.threshold;

    if (message.publicKeys) {
      obj.public_keys = message.publicKeys.map(e => e ? any.Any.toAmino(e) : undefined);
    } else {
      obj.public_keys = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return LegacyAminoPubKey.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "tendermint/PubKeyMultisigThreshold",
      value: LegacyAminoPubKey.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return LegacyAminoPubKey.decode(message.value);
  },

  toProto(message) {
    return LegacyAminoPubKey.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.crypto.multisig.LegacyAminoPubKey",
      value: LegacyAminoPubKey.encode(message).finish()
    };
  }

};
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/cosmos/crypto/secp256k1/keys.js

/**
 * PubKey defines a secp256k1 public key
 * Key is the compressed form of the pubkey. The first byte depends is a 0x02 byte
 * if the y-coordinate is the lexicographically largest of the two associated with
 * the x-coordinate. Otherwise the first byte is a 0x03.
 * This prefix is followed with the x-coordinate.
 */

function keys_createBasePubKey() {
  return {
    key: new Uint8Array()
  };
}

const keys_PubKey = {
  typeUrl: "/cosmos.crypto.secp256k1.PubKey",

  encode(message, writer = minimal.Writer.create()) {
    if (message.key.length !== 0) {
      writer.uint32(10).bytes(message.key);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = keys_createBasePubKey();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.key = reader.bytes();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$key;

    const message = keys_createBasePubKey();
    message.key = (_object$key = object.key) !== null && _object$key !== void 0 ? _object$key : new Uint8Array();
    return message;
  },

  fromAmino(object) {
    return {
      key: object.key
    };
  },

  toAmino(message) {
    const obj = {};
    obj.key = message.key;
    return obj;
  },

  fromAminoMsg(object) {
    return keys_PubKey.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "tendermint/PubKeySecp256k1",
      value: keys_PubKey.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return keys_PubKey.decode(message.value);
  },

  toProto(message) {
    return keys_PubKey.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.crypto.secp256k1.PubKey",
      value: keys_PubKey.encode(message).finish()
    };
  }

};

function keys_createBasePrivKey() {
  return {
    key: new Uint8Array()
  };
}

const keys_PrivKey = {
  typeUrl: "/cosmos.crypto.secp256k1.PrivKey",

  encode(message, writer = minimal.Writer.create()) {
    if (message.key.length !== 0) {
      writer.uint32(10).bytes(message.key);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = keys_createBasePrivKey();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.key = reader.bytes();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$key2;

    const message = keys_createBasePrivKey();
    message.key = (_object$key2 = object.key) !== null && _object$key2 !== void 0 ? _object$key2 : new Uint8Array();
    return message;
  },

  fromAmino(object) {
    return {
      key: object.key
    };
  },

  toAmino(message) {
    const obj = {};
    obj.key = message.key;
    return obj;
  },

  fromAminoMsg(object) {
    return keys_PrivKey.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "tendermint/PrivKeySecp256k1",
      value: keys_PrivKey.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return keys_PrivKey.decode(message.value);
  },

  toProto(message) {
    return keys_PrivKey.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.crypto.secp256k1.PrivKey",
      value: keys_PrivKey.encode(message).finish()
    };
  }

};
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/cosmos/crypto/secp256r1/keys.js

/** PubKey defines a secp256r1 ECDSA public key. */

function secp256r1_keys_createBasePubKey() {
  return {
    key: new Uint8Array()
  };
}

const secp256r1_keys_PubKey = {
  typeUrl: "/cosmos.crypto.secp256r1.PubKey",

  encode(message, writer = minimal.Writer.create()) {
    if (message.key.length !== 0) {
      writer.uint32(10).bytes(message.key);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = secp256r1_keys_createBasePubKey();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.key = reader.bytes();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$key;

    const message = secp256r1_keys_createBasePubKey();
    message.key = (_object$key = object.key) !== null && _object$key !== void 0 ? _object$key : new Uint8Array();
    return message;
  },

  fromAmino(object) {
    return {
      key: object.key
    };
  },

  toAmino(message) {
    const obj = {};
    obj.key = message.key;
    return obj;
  },

  fromAminoMsg(object) {
    return secp256r1_keys_PubKey.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/PubKey",
      value: secp256r1_keys_PubKey.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return secp256r1_keys_PubKey.decode(message.value);
  },

  toProto(message) {
    return secp256r1_keys_PubKey.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.crypto.secp256r1.PubKey",
      value: secp256r1_keys_PubKey.encode(message).finish()
    };
  }

};

function secp256r1_keys_createBasePrivKey() {
  return {
    secret: new Uint8Array()
  };
}

const secp256r1_keys_PrivKey = {
  typeUrl: "/cosmos.crypto.secp256r1.PrivKey",

  encode(message, writer = minimal.Writer.create()) {
    if (message.secret.length !== 0) {
      writer.uint32(10).bytes(message.secret);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = secp256r1_keys_createBasePrivKey();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.secret = reader.bytes();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$secret;

    const message = secp256r1_keys_createBasePrivKey();
    message.secret = (_object$secret = object.secret) !== null && _object$secret !== void 0 ? _object$secret : new Uint8Array();
    return message;
  },

  fromAmino(object) {
    return {
      secret: object.secret
    };
  },

  toAmino(message) {
    const obj = {};
    obj.secret = message.secret;
    return obj;
  },

  fromAminoMsg(object) {
    return secp256r1_keys_PrivKey.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/PrivKey",
      value: secp256r1_keys_PrivKey.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return secp256r1_keys_PrivKey.decode(message.value);
  },

  toProto(message) {
    return secp256r1_keys_PrivKey.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.crypto.secp256r1.PrivKey",
      value: secp256r1_keys_PrivKey.encode(message).finish()
    };
  }

};
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/cosmos/distribution/v1beta1/distribution.js
var v1beta1_distribution = __webpack_require__(82622);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/helpers.js
var helpers = __webpack_require__(47895);
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/cosmos/distribution/v1beta1/genesis.js




/**
 * DelegatorWithdrawInfo is the address for where distributions rewards are
 * withdrawn to by default this struct is only used at genesis to feed in
 * default withdraw addresses.
 */

function createBaseDelegatorWithdrawInfo() {
  return {
    delegatorAddress: "",
    withdrawAddress: ""
  };
}

const DelegatorWithdrawInfo = {
  typeUrl: "/cosmos.distribution.v1beta1.DelegatorWithdrawInfo",

  encode(message, writer = minimal.Writer.create()) {
    if (message.delegatorAddress !== "") {
      writer.uint32(10).string(message.delegatorAddress);
    }

    if (message.withdrawAddress !== "") {
      writer.uint32(18).string(message.withdrawAddress);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDelegatorWithdrawInfo();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.delegatorAddress = reader.string();
          break;

        case 2:
          message.withdrawAddress = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$delegatorAddr, _object$withdrawAddre;

    const message = createBaseDelegatorWithdrawInfo();
    message.delegatorAddress = (_object$delegatorAddr = object.delegatorAddress) !== null && _object$delegatorAddr !== void 0 ? _object$delegatorAddr : "";
    message.withdrawAddress = (_object$withdrawAddre = object.withdrawAddress) !== null && _object$withdrawAddre !== void 0 ? _object$withdrawAddre : "";
    return message;
  },

  fromAmino(object) {
    return {
      delegatorAddress: object.delegator_address,
      withdrawAddress: object.withdraw_address
    };
  },

  toAmino(message) {
    const obj = {};
    obj.delegator_address = message.delegatorAddress;
    obj.withdraw_address = message.withdrawAddress;
    return obj;
  },

  fromAminoMsg(object) {
    return DelegatorWithdrawInfo.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/DelegatorWithdrawInfo",
      value: DelegatorWithdrawInfo.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return DelegatorWithdrawInfo.decode(message.value);
  },

  toProto(message) {
    return DelegatorWithdrawInfo.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.distribution.v1beta1.DelegatorWithdrawInfo",
      value: DelegatorWithdrawInfo.encode(message).finish()
    };
  }

};

function createBaseValidatorOutstandingRewardsRecord() {
  return {
    validatorAddress: "",
    outstandingRewards: []
  };
}

const ValidatorOutstandingRewardsRecord = {
  typeUrl: "/cosmos.distribution.v1beta1.ValidatorOutstandingRewardsRecord",

  encode(message, writer = minimal.Writer.create()) {
    if (message.validatorAddress !== "") {
      writer.uint32(10).string(message.validatorAddress);
    }

    for (const v of message.outstandingRewards) {
      coin.DecCoin.encode(v, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseValidatorOutstandingRewardsRecord();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.validatorAddress = reader.string();
          break;

        case 2:
          message.outstandingRewards.push(coin.DecCoin.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$validatorAddr, _object$outstandingRe;

    const message = createBaseValidatorOutstandingRewardsRecord();
    message.validatorAddress = (_object$validatorAddr = object.validatorAddress) !== null && _object$validatorAddr !== void 0 ? _object$validatorAddr : "";
    message.outstandingRewards = ((_object$outstandingRe = object.outstandingRewards) === null || _object$outstandingRe === void 0 ? void 0 : _object$outstandingRe.map(e => coin.DecCoin.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      validatorAddress: object.validator_address,
      outstandingRewards: Array.isArray(object === null || object === void 0 ? void 0 : object.outstanding_rewards) ? object.outstanding_rewards.map(e => coin.DecCoin.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.validator_address = message.validatorAddress;

    if (message.outstandingRewards) {
      obj.outstanding_rewards = message.outstandingRewards.map(e => e ? coin.DecCoin.toAmino(e) : undefined);
    } else {
      obj.outstanding_rewards = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return ValidatorOutstandingRewardsRecord.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/ValidatorOutstandingRewardsRecord",
      value: ValidatorOutstandingRewardsRecord.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return ValidatorOutstandingRewardsRecord.decode(message.value);
  },

  toProto(message) {
    return ValidatorOutstandingRewardsRecord.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.distribution.v1beta1.ValidatorOutstandingRewardsRecord",
      value: ValidatorOutstandingRewardsRecord.encode(message).finish()
    };
  }

};

function createBaseValidatorAccumulatedCommissionRecord() {
  return {
    validatorAddress: "",
    accumulated: undefined
  };
}

const ValidatorAccumulatedCommissionRecord = {
  typeUrl: "/cosmos.distribution.v1beta1.ValidatorAccumulatedCommissionRecord",

  encode(message, writer = minimal.Writer.create()) {
    if (message.validatorAddress !== "") {
      writer.uint32(10).string(message.validatorAddress);
    }

    if (message.accumulated !== undefined) {
      v1beta1_distribution.ValidatorAccumulatedCommission.encode(message.accumulated, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseValidatorAccumulatedCommissionRecord();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.validatorAddress = reader.string();
          break;

        case 2:
          message.accumulated = v1beta1_distribution.ValidatorAccumulatedCommission.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$validatorAddr2;

    const message = createBaseValidatorAccumulatedCommissionRecord();
    message.validatorAddress = (_object$validatorAddr2 = object.validatorAddress) !== null && _object$validatorAddr2 !== void 0 ? _object$validatorAddr2 : "";
    message.accumulated = object.accumulated !== undefined && object.accumulated !== null ? v1beta1_distribution.ValidatorAccumulatedCommission.fromPartial(object.accumulated) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      validatorAddress: object.validator_address,
      accumulated: object !== null && object !== void 0 && object.accumulated ? v1beta1_distribution.ValidatorAccumulatedCommission.fromAmino(object.accumulated) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.validator_address = message.validatorAddress;
    obj.accumulated = message.accumulated ? v1beta1_distribution.ValidatorAccumulatedCommission.toAmino(message.accumulated) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return ValidatorAccumulatedCommissionRecord.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/ValidatorAccumulatedCommissionRecord",
      value: ValidatorAccumulatedCommissionRecord.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return ValidatorAccumulatedCommissionRecord.decode(message.value);
  },

  toProto(message) {
    return ValidatorAccumulatedCommissionRecord.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.distribution.v1beta1.ValidatorAccumulatedCommissionRecord",
      value: ValidatorAccumulatedCommissionRecord.encode(message).finish()
    };
  }

};

function createBaseValidatorHistoricalRewardsRecord() {
  return {
    validatorAddress: "",
    period: helpers/* Long.UZERO */.dK.UZERO,
    rewards: undefined
  };
}

const ValidatorHistoricalRewardsRecord = {
  typeUrl: "/cosmos.distribution.v1beta1.ValidatorHistoricalRewardsRecord",

  encode(message, writer = minimal.Writer.create()) {
    if (message.validatorAddress !== "") {
      writer.uint32(10).string(message.validatorAddress);
    }

    if (!message.period.isZero()) {
      writer.uint32(16).uint64(message.period);
    }

    if (message.rewards !== undefined) {
      v1beta1_distribution.ValidatorHistoricalRewards.encode(message.rewards, writer.uint32(26).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseValidatorHistoricalRewardsRecord();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.validatorAddress = reader.string();
          break;

        case 2:
          message.period = reader.uint64();
          break;

        case 3:
          message.rewards = v1beta1_distribution.ValidatorHistoricalRewards.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$validatorAddr3;

    const message = createBaseValidatorHistoricalRewardsRecord();
    message.validatorAddress = (_object$validatorAddr3 = object.validatorAddress) !== null && _object$validatorAddr3 !== void 0 ? _object$validatorAddr3 : "";
    message.period = object.period !== undefined && object.period !== null ? helpers/* Long.fromValue */.dK.fromValue(object.period) : helpers/* Long.UZERO */.dK.UZERO;
    message.rewards = object.rewards !== undefined && object.rewards !== null ? v1beta1_distribution.ValidatorHistoricalRewards.fromPartial(object.rewards) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      validatorAddress: object.validator_address,
      period: helpers/* Long.fromString */.dK.fromString(object.period),
      rewards: object !== null && object !== void 0 && object.rewards ? v1beta1_distribution.ValidatorHistoricalRewards.fromAmino(object.rewards) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.validator_address = message.validatorAddress;
    obj.period = message.period ? message.period.toString() : undefined;
    obj.rewards = message.rewards ? v1beta1_distribution.ValidatorHistoricalRewards.toAmino(message.rewards) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return ValidatorHistoricalRewardsRecord.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/ValidatorHistoricalRewardsRecord",
      value: ValidatorHistoricalRewardsRecord.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return ValidatorHistoricalRewardsRecord.decode(message.value);
  },

  toProto(message) {
    return ValidatorHistoricalRewardsRecord.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.distribution.v1beta1.ValidatorHistoricalRewardsRecord",
      value: ValidatorHistoricalRewardsRecord.encode(message).finish()
    };
  }

};

function createBaseValidatorCurrentRewardsRecord() {
  return {
    validatorAddress: "",
    rewards: undefined
  };
}

const ValidatorCurrentRewardsRecord = {
  typeUrl: "/cosmos.distribution.v1beta1.ValidatorCurrentRewardsRecord",

  encode(message, writer = minimal.Writer.create()) {
    if (message.validatorAddress !== "") {
      writer.uint32(10).string(message.validatorAddress);
    }

    if (message.rewards !== undefined) {
      v1beta1_distribution.ValidatorCurrentRewards.encode(message.rewards, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseValidatorCurrentRewardsRecord();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.validatorAddress = reader.string();
          break;

        case 2:
          message.rewards = v1beta1_distribution.ValidatorCurrentRewards.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$validatorAddr4;

    const message = createBaseValidatorCurrentRewardsRecord();
    message.validatorAddress = (_object$validatorAddr4 = object.validatorAddress) !== null && _object$validatorAddr4 !== void 0 ? _object$validatorAddr4 : "";
    message.rewards = object.rewards !== undefined && object.rewards !== null ? v1beta1_distribution.ValidatorCurrentRewards.fromPartial(object.rewards) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      validatorAddress: object.validator_address,
      rewards: object !== null && object !== void 0 && object.rewards ? v1beta1_distribution.ValidatorCurrentRewards.fromAmino(object.rewards) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.validator_address = message.validatorAddress;
    obj.rewards = message.rewards ? v1beta1_distribution.ValidatorCurrentRewards.toAmino(message.rewards) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return ValidatorCurrentRewardsRecord.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/ValidatorCurrentRewardsRecord",
      value: ValidatorCurrentRewardsRecord.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return ValidatorCurrentRewardsRecord.decode(message.value);
  },

  toProto(message) {
    return ValidatorCurrentRewardsRecord.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.distribution.v1beta1.ValidatorCurrentRewardsRecord",
      value: ValidatorCurrentRewardsRecord.encode(message).finish()
    };
  }

};

function createBaseDelegatorStartingInfoRecord() {
  return {
    delegatorAddress: "",
    validatorAddress: "",
    startingInfo: undefined
  };
}

const DelegatorStartingInfoRecord = {
  typeUrl: "/cosmos.distribution.v1beta1.DelegatorStartingInfoRecord",

  encode(message, writer = minimal.Writer.create()) {
    if (message.delegatorAddress !== "") {
      writer.uint32(10).string(message.delegatorAddress);
    }

    if (message.validatorAddress !== "") {
      writer.uint32(18).string(message.validatorAddress);
    }

    if (message.startingInfo !== undefined) {
      v1beta1_distribution.DelegatorStartingInfo.encode(message.startingInfo, writer.uint32(26).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDelegatorStartingInfoRecord();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.delegatorAddress = reader.string();
          break;

        case 2:
          message.validatorAddress = reader.string();
          break;

        case 3:
          message.startingInfo = v1beta1_distribution.DelegatorStartingInfo.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$delegatorAddr2, _object$validatorAddr5;

    const message = createBaseDelegatorStartingInfoRecord();
    message.delegatorAddress = (_object$delegatorAddr2 = object.delegatorAddress) !== null && _object$delegatorAddr2 !== void 0 ? _object$delegatorAddr2 : "";
    message.validatorAddress = (_object$validatorAddr5 = object.validatorAddress) !== null && _object$validatorAddr5 !== void 0 ? _object$validatorAddr5 : "";
    message.startingInfo = object.startingInfo !== undefined && object.startingInfo !== null ? v1beta1_distribution.DelegatorStartingInfo.fromPartial(object.startingInfo) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      delegatorAddress: object.delegator_address,
      validatorAddress: object.validator_address,
      startingInfo: object !== null && object !== void 0 && object.starting_info ? v1beta1_distribution.DelegatorStartingInfo.fromAmino(object.starting_info) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.delegator_address = message.delegatorAddress;
    obj.validator_address = message.validatorAddress;
    obj.starting_info = message.startingInfo ? v1beta1_distribution.DelegatorStartingInfo.toAmino(message.startingInfo) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return DelegatorStartingInfoRecord.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/DelegatorStartingInfoRecord",
      value: DelegatorStartingInfoRecord.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return DelegatorStartingInfoRecord.decode(message.value);
  },

  toProto(message) {
    return DelegatorStartingInfoRecord.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.distribution.v1beta1.DelegatorStartingInfoRecord",
      value: DelegatorStartingInfoRecord.encode(message).finish()
    };
  }

};

function createBaseValidatorSlashEventRecord() {
  return {
    validatorAddress: "",
    height: helpers/* Long.UZERO */.dK.UZERO,
    period: helpers/* Long.UZERO */.dK.UZERO,
    validatorSlashEvent: undefined
  };
}

const ValidatorSlashEventRecord = {
  typeUrl: "/cosmos.distribution.v1beta1.ValidatorSlashEventRecord",

  encode(message, writer = minimal.Writer.create()) {
    if (message.validatorAddress !== "") {
      writer.uint32(10).string(message.validatorAddress);
    }

    if (!message.height.isZero()) {
      writer.uint32(16).uint64(message.height);
    }

    if (!message.period.isZero()) {
      writer.uint32(24).uint64(message.period);
    }

    if (message.validatorSlashEvent !== undefined) {
      v1beta1_distribution.ValidatorSlashEvent.encode(message.validatorSlashEvent, writer.uint32(34).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseValidatorSlashEventRecord();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.validatorAddress = reader.string();
          break;

        case 2:
          message.height = reader.uint64();
          break;

        case 3:
          message.period = reader.uint64();
          break;

        case 4:
          message.validatorSlashEvent = v1beta1_distribution.ValidatorSlashEvent.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$validatorAddr6;

    const message = createBaseValidatorSlashEventRecord();
    message.validatorAddress = (_object$validatorAddr6 = object.validatorAddress) !== null && _object$validatorAddr6 !== void 0 ? _object$validatorAddr6 : "";
    message.height = object.height !== undefined && object.height !== null ? helpers/* Long.fromValue */.dK.fromValue(object.height) : helpers/* Long.UZERO */.dK.UZERO;
    message.period = object.period !== undefined && object.period !== null ? helpers/* Long.fromValue */.dK.fromValue(object.period) : helpers/* Long.UZERO */.dK.UZERO;
    message.validatorSlashEvent = object.validatorSlashEvent !== undefined && object.validatorSlashEvent !== null ? v1beta1_distribution.ValidatorSlashEvent.fromPartial(object.validatorSlashEvent) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      validatorAddress: object.validator_address,
      height: helpers/* Long.fromString */.dK.fromString(object.height),
      period: helpers/* Long.fromString */.dK.fromString(object.period),
      validatorSlashEvent: object !== null && object !== void 0 && object.validator_slash_event ? v1beta1_distribution.ValidatorSlashEvent.fromAmino(object.validator_slash_event) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.validator_address = message.validatorAddress;
    obj.height = message.height ? message.height.toString() : undefined;
    obj.period = message.period ? message.period.toString() : undefined;
    obj.validator_slash_event = message.validatorSlashEvent ? v1beta1_distribution.ValidatorSlashEvent.toAmino(message.validatorSlashEvent) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return ValidatorSlashEventRecord.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/ValidatorSlashEventRecord",
      value: ValidatorSlashEventRecord.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return ValidatorSlashEventRecord.decode(message.value);
  },

  toProto(message) {
    return ValidatorSlashEventRecord.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.distribution.v1beta1.ValidatorSlashEventRecord",
      value: ValidatorSlashEventRecord.encode(message).finish()
    };
  }

};

function distribution_v1beta1_genesis_createBaseGenesisState() {
  return {
    params: undefined,
    feePool: undefined,
    delegatorWithdrawInfos: [],
    previousProposer: "",
    outstandingRewards: [],
    validatorAccumulatedCommissions: [],
    validatorHistoricalRewards: [],
    validatorCurrentRewards: [],
    delegatorStartingInfos: [],
    validatorSlashEvents: []
  };
}

const distribution_v1beta1_genesis_GenesisState = {
  typeUrl: "/cosmos.distribution.v1beta1.GenesisState",

  encode(message, writer = minimal.Writer.create()) {
    if (message.params !== undefined) {
      v1beta1_distribution.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
    }

    if (message.feePool !== undefined) {
      v1beta1_distribution.FeePool.encode(message.feePool, writer.uint32(18).fork()).ldelim();
    }

    for (const v of message.delegatorWithdrawInfos) {
      DelegatorWithdrawInfo.encode(v, writer.uint32(26).fork()).ldelim();
    }

    if (message.previousProposer !== "") {
      writer.uint32(34).string(message.previousProposer);
    }

    for (const v of message.outstandingRewards) {
      ValidatorOutstandingRewardsRecord.encode(v, writer.uint32(42).fork()).ldelim();
    }

    for (const v of message.validatorAccumulatedCommissions) {
      ValidatorAccumulatedCommissionRecord.encode(v, writer.uint32(50).fork()).ldelim();
    }

    for (const v of message.validatorHistoricalRewards) {
      ValidatorHistoricalRewardsRecord.encode(v, writer.uint32(58).fork()).ldelim();
    }

    for (const v of message.validatorCurrentRewards) {
      ValidatorCurrentRewardsRecord.encode(v, writer.uint32(66).fork()).ldelim();
    }

    for (const v of message.delegatorStartingInfos) {
      DelegatorStartingInfoRecord.encode(v, writer.uint32(74).fork()).ldelim();
    }

    for (const v of message.validatorSlashEvents) {
      ValidatorSlashEventRecord.encode(v, writer.uint32(82).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = distribution_v1beta1_genesis_createBaseGenesisState();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.params = v1beta1_distribution.Params.decode(reader, reader.uint32());
          break;

        case 2:
          message.feePool = v1beta1_distribution.FeePool.decode(reader, reader.uint32());
          break;

        case 3:
          message.delegatorWithdrawInfos.push(DelegatorWithdrawInfo.decode(reader, reader.uint32()));
          break;

        case 4:
          message.previousProposer = reader.string();
          break;

        case 5:
          message.outstandingRewards.push(ValidatorOutstandingRewardsRecord.decode(reader, reader.uint32()));
          break;

        case 6:
          message.validatorAccumulatedCommissions.push(ValidatorAccumulatedCommissionRecord.decode(reader, reader.uint32()));
          break;

        case 7:
          message.validatorHistoricalRewards.push(ValidatorHistoricalRewardsRecord.decode(reader, reader.uint32()));
          break;

        case 8:
          message.validatorCurrentRewards.push(ValidatorCurrentRewardsRecord.decode(reader, reader.uint32()));
          break;

        case 9:
          message.delegatorStartingInfos.push(DelegatorStartingInfoRecord.decode(reader, reader.uint32()));
          break;

        case 10:
          message.validatorSlashEvents.push(ValidatorSlashEventRecord.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$delegatorWith, _object$previousPropo, _object$outstandingRe2, _object$validatorAccu, _object$validatorHist, _object$validatorCurr, _object$delegatorStar, _object$validatorSlas;

    const message = distribution_v1beta1_genesis_createBaseGenesisState();
    message.params = object.params !== undefined && object.params !== null ? v1beta1_distribution.Params.fromPartial(object.params) : undefined;
    message.feePool = object.feePool !== undefined && object.feePool !== null ? v1beta1_distribution.FeePool.fromPartial(object.feePool) : undefined;
    message.delegatorWithdrawInfos = ((_object$delegatorWith = object.delegatorWithdrawInfos) === null || _object$delegatorWith === void 0 ? void 0 : _object$delegatorWith.map(e => DelegatorWithdrawInfo.fromPartial(e))) || [];
    message.previousProposer = (_object$previousPropo = object.previousProposer) !== null && _object$previousPropo !== void 0 ? _object$previousPropo : "";
    message.outstandingRewards = ((_object$outstandingRe2 = object.outstandingRewards) === null || _object$outstandingRe2 === void 0 ? void 0 : _object$outstandingRe2.map(e => ValidatorOutstandingRewardsRecord.fromPartial(e))) || [];
    message.validatorAccumulatedCommissions = ((_object$validatorAccu = object.validatorAccumulatedCommissions) === null || _object$validatorAccu === void 0 ? void 0 : _object$validatorAccu.map(e => ValidatorAccumulatedCommissionRecord.fromPartial(e))) || [];
    message.validatorHistoricalRewards = ((_object$validatorHist = object.validatorHistoricalRewards) === null || _object$validatorHist === void 0 ? void 0 : _object$validatorHist.map(e => ValidatorHistoricalRewardsRecord.fromPartial(e))) || [];
    message.validatorCurrentRewards = ((_object$validatorCurr = object.validatorCurrentRewards) === null || _object$validatorCurr === void 0 ? void 0 : _object$validatorCurr.map(e => ValidatorCurrentRewardsRecord.fromPartial(e))) || [];
    message.delegatorStartingInfos = ((_object$delegatorStar = object.delegatorStartingInfos) === null || _object$delegatorStar === void 0 ? void 0 : _object$delegatorStar.map(e => DelegatorStartingInfoRecord.fromPartial(e))) || [];
    message.validatorSlashEvents = ((_object$validatorSlas = object.validatorSlashEvents) === null || _object$validatorSlas === void 0 ? void 0 : _object$validatorSlas.map(e => ValidatorSlashEventRecord.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      params: object !== null && object !== void 0 && object.params ? v1beta1_distribution.Params.fromAmino(object.params) : undefined,
      feePool: object !== null && object !== void 0 && object.fee_pool ? v1beta1_distribution.FeePool.fromAmino(object.fee_pool) : undefined,
      delegatorWithdrawInfos: Array.isArray(object === null || object === void 0 ? void 0 : object.delegator_withdraw_infos) ? object.delegator_withdraw_infos.map(e => DelegatorWithdrawInfo.fromAmino(e)) : [],
      previousProposer: object.previous_proposer,
      outstandingRewards: Array.isArray(object === null || object === void 0 ? void 0 : object.outstanding_rewards) ? object.outstanding_rewards.map(e => ValidatorOutstandingRewardsRecord.fromAmino(e)) : [],
      validatorAccumulatedCommissions: Array.isArray(object === null || object === void 0 ? void 0 : object.validator_accumulated_commissions) ? object.validator_accumulated_commissions.map(e => ValidatorAccumulatedCommissionRecord.fromAmino(e)) : [],
      validatorHistoricalRewards: Array.isArray(object === null || object === void 0 ? void 0 : object.validator_historical_rewards) ? object.validator_historical_rewards.map(e => ValidatorHistoricalRewardsRecord.fromAmino(e)) : [],
      validatorCurrentRewards: Array.isArray(object === null || object === void 0 ? void 0 : object.validator_current_rewards) ? object.validator_current_rewards.map(e => ValidatorCurrentRewardsRecord.fromAmino(e)) : [],
      delegatorStartingInfos: Array.isArray(object === null || object === void 0 ? void 0 : object.delegator_starting_infos) ? object.delegator_starting_infos.map(e => DelegatorStartingInfoRecord.fromAmino(e)) : [],
      validatorSlashEvents: Array.isArray(object === null || object === void 0 ? void 0 : object.validator_slash_events) ? object.validator_slash_events.map(e => ValidatorSlashEventRecord.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.params = message.params ? v1beta1_distribution.Params.toAmino(message.params) : undefined;
    obj.fee_pool = message.feePool ? v1beta1_distribution.FeePool.toAmino(message.feePool) : undefined;

    if (message.delegatorWithdrawInfos) {
      obj.delegator_withdraw_infos = message.delegatorWithdrawInfos.map(e => e ? DelegatorWithdrawInfo.toAmino(e) : undefined);
    } else {
      obj.delegator_withdraw_infos = [];
    }

    obj.previous_proposer = message.previousProposer;

    if (message.outstandingRewards) {
      obj.outstanding_rewards = message.outstandingRewards.map(e => e ? ValidatorOutstandingRewardsRecord.toAmino(e) : undefined);
    } else {
      obj.outstanding_rewards = [];
    }

    if (message.validatorAccumulatedCommissions) {
      obj.validator_accumulated_commissions = message.validatorAccumulatedCommissions.map(e => e ? ValidatorAccumulatedCommissionRecord.toAmino(e) : undefined);
    } else {
      obj.validator_accumulated_commissions = [];
    }

    if (message.validatorHistoricalRewards) {
      obj.validator_historical_rewards = message.validatorHistoricalRewards.map(e => e ? ValidatorHistoricalRewardsRecord.toAmino(e) : undefined);
    } else {
      obj.validator_historical_rewards = [];
    }

    if (message.validatorCurrentRewards) {
      obj.validator_current_rewards = message.validatorCurrentRewards.map(e => e ? ValidatorCurrentRewardsRecord.toAmino(e) : undefined);
    } else {
      obj.validator_current_rewards = [];
    }

    if (message.delegatorStartingInfos) {
      obj.delegator_starting_infos = message.delegatorStartingInfos.map(e => e ? DelegatorStartingInfoRecord.toAmino(e) : undefined);
    } else {
      obj.delegator_starting_infos = [];
    }

    if (message.validatorSlashEvents) {
      obj.validator_slash_events = message.validatorSlashEvents.map(e => e ? ValidatorSlashEventRecord.toAmino(e) : undefined);
    } else {
      obj.validator_slash_events = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return distribution_v1beta1_genesis_GenesisState.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/GenesisState",
      value: distribution_v1beta1_genesis_GenesisState.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return distribution_v1beta1_genesis_GenesisState.decode(message.value);
  },

  toProto(message) {
    return distribution_v1beta1_genesis_GenesisState.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.distribution.v1beta1.GenesisState",
      value: distribution_v1beta1_genesis_GenesisState.encode(message).finish()
    };
  }

};
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/cosmos/distribution/v1beta1/query.js
var distribution_v1beta1_query = __webpack_require__(54909);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/cosmos/distribution/v1beta1/tx.js
var distribution_v1beta1_tx = __webpack_require__(97966);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/cosmos/gov/v1beta1/gov.js
var v1beta1_gov = __webpack_require__(95180);
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/cosmos/gov/v1beta1/genesis.js



/** GenesisState defines the gov module's genesis state. */

function gov_v1beta1_genesis_createBaseGenesisState() {
  return {
    startingProposalId: helpers/* Long.UZERO */.dK.UZERO,
    deposits: [],
    votes: [],
    proposals: [],
    depositParams: undefined,
    votingParams: undefined,
    tallyParams: undefined
  };
}

const gov_v1beta1_genesis_GenesisState = {
  typeUrl: "/cosmos.gov.v1beta1.GenesisState",

  encode(message, writer = minimal.Writer.create()) {
    if (!message.startingProposalId.isZero()) {
      writer.uint32(8).uint64(message.startingProposalId);
    }

    for (const v of message.deposits) {
      v1beta1_gov.Deposit.encode(v, writer.uint32(18).fork()).ldelim();
    }

    for (const v of message.votes) {
      v1beta1_gov.Vote.encode(v, writer.uint32(26).fork()).ldelim();
    }

    for (const v of message.proposals) {
      v1beta1_gov.Proposal.encode(v, writer.uint32(34).fork()).ldelim();
    }

    if (message.depositParams !== undefined) {
      v1beta1_gov.DepositParams.encode(message.depositParams, writer.uint32(42).fork()).ldelim();
    }

    if (message.votingParams !== undefined) {
      v1beta1_gov.VotingParams.encode(message.votingParams, writer.uint32(50).fork()).ldelim();
    }

    if (message.tallyParams !== undefined) {
      v1beta1_gov.TallyParams.encode(message.tallyParams, writer.uint32(58).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = gov_v1beta1_genesis_createBaseGenesisState();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.startingProposalId = reader.uint64();
          break;

        case 2:
          message.deposits.push(v1beta1_gov.Deposit.decode(reader, reader.uint32()));
          break;

        case 3:
          message.votes.push(v1beta1_gov.Vote.decode(reader, reader.uint32()));
          break;

        case 4:
          message.proposals.push(v1beta1_gov.Proposal.decode(reader, reader.uint32()));
          break;

        case 5:
          message.depositParams = v1beta1_gov.DepositParams.decode(reader, reader.uint32());
          break;

        case 6:
          message.votingParams = v1beta1_gov.VotingParams.decode(reader, reader.uint32());
          break;

        case 7:
          message.tallyParams = v1beta1_gov.TallyParams.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$deposits, _object$votes, _object$proposals;

    const message = gov_v1beta1_genesis_createBaseGenesisState();
    message.startingProposalId = object.startingProposalId !== undefined && object.startingProposalId !== null ? helpers/* Long.fromValue */.dK.fromValue(object.startingProposalId) : helpers/* Long.UZERO */.dK.UZERO;
    message.deposits = ((_object$deposits = object.deposits) === null || _object$deposits === void 0 ? void 0 : _object$deposits.map(e => v1beta1_gov.Deposit.fromPartial(e))) || [];
    message.votes = ((_object$votes = object.votes) === null || _object$votes === void 0 ? void 0 : _object$votes.map(e => v1beta1_gov.Vote.fromPartial(e))) || [];
    message.proposals = ((_object$proposals = object.proposals) === null || _object$proposals === void 0 ? void 0 : _object$proposals.map(e => v1beta1_gov.Proposal.fromPartial(e))) || [];
    message.depositParams = object.depositParams !== undefined && object.depositParams !== null ? v1beta1_gov.DepositParams.fromPartial(object.depositParams) : undefined;
    message.votingParams = object.votingParams !== undefined && object.votingParams !== null ? v1beta1_gov.VotingParams.fromPartial(object.votingParams) : undefined;
    message.tallyParams = object.tallyParams !== undefined && object.tallyParams !== null ? v1beta1_gov.TallyParams.fromPartial(object.tallyParams) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      startingProposalId: helpers/* Long.fromString */.dK.fromString(object.starting_proposal_id),
      deposits: Array.isArray(object === null || object === void 0 ? void 0 : object.deposits) ? object.deposits.map(e => v1beta1_gov.Deposit.fromAmino(e)) : [],
      votes: Array.isArray(object === null || object === void 0 ? void 0 : object.votes) ? object.votes.map(e => v1beta1_gov.Vote.fromAmino(e)) : [],
      proposals: Array.isArray(object === null || object === void 0 ? void 0 : object.proposals) ? object.proposals.map(e => v1beta1_gov.Proposal.fromAmino(e)) : [],
      depositParams: object !== null && object !== void 0 && object.deposit_params ? v1beta1_gov.DepositParams.fromAmino(object.deposit_params) : undefined,
      votingParams: object !== null && object !== void 0 && object.voting_params ? v1beta1_gov.VotingParams.fromAmino(object.voting_params) : undefined,
      tallyParams: object !== null && object !== void 0 && object.tally_params ? v1beta1_gov.TallyParams.fromAmino(object.tally_params) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.starting_proposal_id = message.startingProposalId ? message.startingProposalId.toString() : undefined;

    if (message.deposits) {
      obj.deposits = message.deposits.map(e => e ? v1beta1_gov.Deposit.toAmino(e) : undefined);
    } else {
      obj.deposits = [];
    }

    if (message.votes) {
      obj.votes = message.votes.map(e => e ? v1beta1_gov.Vote.toAmino(e) : undefined);
    } else {
      obj.votes = [];
    }

    if (message.proposals) {
      obj.proposals = message.proposals.map(e => e ? v1beta1_gov.Proposal.toAmino(e) : undefined);
    } else {
      obj.proposals = [];
    }

    obj.deposit_params = message.depositParams ? v1beta1_gov.DepositParams.toAmino(message.depositParams) : undefined;
    obj.voting_params = message.votingParams ? v1beta1_gov.VotingParams.toAmino(message.votingParams) : undefined;
    obj.tally_params = message.tallyParams ? v1beta1_gov.TallyParams.toAmino(message.tallyParams) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return gov_v1beta1_genesis_GenesisState.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/GenesisState",
      value: gov_v1beta1_genesis_GenesisState.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return gov_v1beta1_genesis_GenesisState.decode(message.value);
  },

  toProto(message) {
    return gov_v1beta1_genesis_GenesisState.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.gov.v1beta1.GenesisState",
      value: gov_v1beta1_genesis_GenesisState.encode(message).finish()
    };
  }

};
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/cosmos/gov/v1beta1/query.js
var gov_v1beta1_query = __webpack_require__(71814);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/cosmos/gov/v1beta1/tx.js
var gov_v1beta1_tx = __webpack_require__(98551);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/cosmos/staking/v1beta1/authz.js
var staking_v1beta1_authz = __webpack_require__(8682);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/cosmos/staking/v1beta1/staking.js
var v1beta1_staking = __webpack_require__(56959);
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/cosmos/staking/v1beta1/genesis.js



/** GenesisState defines the staking module's genesis state. */

function staking_v1beta1_genesis_createBaseGenesisState() {
  return {
    params: undefined,
    lastTotalPower: new Uint8Array(),
    lastValidatorPowers: [],
    validators: [],
    delegations: [],
    unbondingDelegations: [],
    redelegations: [],
    exported: false
  };
}

const staking_v1beta1_genesis_GenesisState = {
  typeUrl: "/cosmos.staking.v1beta1.GenesisState",

  encode(message, writer = minimal.Writer.create()) {
    if (message.params !== undefined) {
      v1beta1_staking.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
    }

    if (message.lastTotalPower.length !== 0) {
      writer.uint32(18).bytes(message.lastTotalPower);
    }

    for (const v of message.lastValidatorPowers) {
      LastValidatorPower.encode(v, writer.uint32(26).fork()).ldelim();
    }

    for (const v of message.validators) {
      v1beta1_staking.Validator.encode(v, writer.uint32(34).fork()).ldelim();
    }

    for (const v of message.delegations) {
      v1beta1_staking.Delegation.encode(v, writer.uint32(42).fork()).ldelim();
    }

    for (const v of message.unbondingDelegations) {
      v1beta1_staking.UnbondingDelegation.encode(v, writer.uint32(50).fork()).ldelim();
    }

    for (const v of message.redelegations) {
      v1beta1_staking.Redelegation.encode(v, writer.uint32(58).fork()).ldelim();
    }

    if (message.exported === true) {
      writer.uint32(64).bool(message.exported);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = staking_v1beta1_genesis_createBaseGenesisState();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.params = v1beta1_staking.Params.decode(reader, reader.uint32());
          break;

        case 2:
          message.lastTotalPower = reader.bytes();
          break;

        case 3:
          message.lastValidatorPowers.push(LastValidatorPower.decode(reader, reader.uint32()));
          break;

        case 4:
          message.validators.push(v1beta1_staking.Validator.decode(reader, reader.uint32()));
          break;

        case 5:
          message.delegations.push(v1beta1_staking.Delegation.decode(reader, reader.uint32()));
          break;

        case 6:
          message.unbondingDelegations.push(v1beta1_staking.UnbondingDelegation.decode(reader, reader.uint32()));
          break;

        case 7:
          message.redelegations.push(v1beta1_staking.Redelegation.decode(reader, reader.uint32()));
          break;

        case 8:
          message.exported = reader.bool();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$lastTotalPowe, _object$lastValidator, _object$validators, _object$delegations, _object$unbondingDele, _object$redelegations, _object$exported;

    const message = staking_v1beta1_genesis_createBaseGenesisState();
    message.params = object.params !== undefined && object.params !== null ? v1beta1_staking.Params.fromPartial(object.params) : undefined;
    message.lastTotalPower = (_object$lastTotalPowe = object.lastTotalPower) !== null && _object$lastTotalPowe !== void 0 ? _object$lastTotalPowe : new Uint8Array();
    message.lastValidatorPowers = ((_object$lastValidator = object.lastValidatorPowers) === null || _object$lastValidator === void 0 ? void 0 : _object$lastValidator.map(e => LastValidatorPower.fromPartial(e))) || [];
    message.validators = ((_object$validators = object.validators) === null || _object$validators === void 0 ? void 0 : _object$validators.map(e => v1beta1_staking.Validator.fromPartial(e))) || [];
    message.delegations = ((_object$delegations = object.delegations) === null || _object$delegations === void 0 ? void 0 : _object$delegations.map(e => v1beta1_staking.Delegation.fromPartial(e))) || [];
    message.unbondingDelegations = ((_object$unbondingDele = object.unbondingDelegations) === null || _object$unbondingDele === void 0 ? void 0 : _object$unbondingDele.map(e => v1beta1_staking.UnbondingDelegation.fromPartial(e))) || [];
    message.redelegations = ((_object$redelegations = object.redelegations) === null || _object$redelegations === void 0 ? void 0 : _object$redelegations.map(e => v1beta1_staking.Redelegation.fromPartial(e))) || [];
    message.exported = (_object$exported = object.exported) !== null && _object$exported !== void 0 ? _object$exported : false;
    return message;
  },

  fromAmino(object) {
    return {
      params: object !== null && object !== void 0 && object.params ? v1beta1_staking.Params.fromAmino(object.params) : undefined,
      lastTotalPower: object.last_total_power,
      lastValidatorPowers: Array.isArray(object === null || object === void 0 ? void 0 : object.last_validator_powers) ? object.last_validator_powers.map(e => LastValidatorPower.fromAmino(e)) : [],
      validators: Array.isArray(object === null || object === void 0 ? void 0 : object.validators) ? object.validators.map(e => v1beta1_staking.Validator.fromAmino(e)) : [],
      delegations: Array.isArray(object === null || object === void 0 ? void 0 : object.delegations) ? object.delegations.map(e => v1beta1_staking.Delegation.fromAmino(e)) : [],
      unbondingDelegations: Array.isArray(object === null || object === void 0 ? void 0 : object.unbonding_delegations) ? object.unbonding_delegations.map(e => v1beta1_staking.UnbondingDelegation.fromAmino(e)) : [],
      redelegations: Array.isArray(object === null || object === void 0 ? void 0 : object.redelegations) ? object.redelegations.map(e => v1beta1_staking.Redelegation.fromAmino(e)) : [],
      exported: object.exported
    };
  },

  toAmino(message) {
    const obj = {};
    obj.params = message.params ? v1beta1_staking.Params.toAmino(message.params) : undefined;
    obj.last_total_power = message.lastTotalPower;

    if (message.lastValidatorPowers) {
      obj.last_validator_powers = message.lastValidatorPowers.map(e => e ? LastValidatorPower.toAmino(e) : undefined);
    } else {
      obj.last_validator_powers = [];
    }

    if (message.validators) {
      obj.validators = message.validators.map(e => e ? v1beta1_staking.Validator.toAmino(e) : undefined);
    } else {
      obj.validators = [];
    }

    if (message.delegations) {
      obj.delegations = message.delegations.map(e => e ? v1beta1_staking.Delegation.toAmino(e) : undefined);
    } else {
      obj.delegations = [];
    }

    if (message.unbondingDelegations) {
      obj.unbonding_delegations = message.unbondingDelegations.map(e => e ? v1beta1_staking.UnbondingDelegation.toAmino(e) : undefined);
    } else {
      obj.unbonding_delegations = [];
    }

    if (message.redelegations) {
      obj.redelegations = message.redelegations.map(e => e ? v1beta1_staking.Redelegation.toAmino(e) : undefined);
    } else {
      obj.redelegations = [];
    }

    obj.exported = message.exported;
    return obj;
  },

  fromAminoMsg(object) {
    return staking_v1beta1_genesis_GenesisState.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/GenesisState",
      value: staking_v1beta1_genesis_GenesisState.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return staking_v1beta1_genesis_GenesisState.decode(message.value);
  },

  toProto(message) {
    return staking_v1beta1_genesis_GenesisState.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.GenesisState",
      value: staking_v1beta1_genesis_GenesisState.encode(message).finish()
    };
  }

};

function createBaseLastValidatorPower() {
  return {
    address: "",
    power: helpers/* Long.ZERO */.dK.ZERO
  };
}

const LastValidatorPower = {
  typeUrl: "/cosmos.staking.v1beta1.LastValidatorPower",

  encode(message, writer = minimal.Writer.create()) {
    if (message.address !== "") {
      writer.uint32(10).string(message.address);
    }

    if (!message.power.isZero()) {
      writer.uint32(16).int64(message.power);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLastValidatorPower();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.address = reader.string();
          break;

        case 2:
          message.power = reader.int64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$address;

    const message = createBaseLastValidatorPower();
    message.address = (_object$address = object.address) !== null && _object$address !== void 0 ? _object$address : "";
    message.power = object.power !== undefined && object.power !== null ? helpers/* Long.fromValue */.dK.fromValue(object.power) : helpers/* Long.ZERO */.dK.ZERO;
    return message;
  },

  fromAmino(object) {
    return {
      address: object.address,
      power: helpers/* Long.fromString */.dK.fromString(object.power)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.address = message.address;
    obj.power = message.power ? message.power.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return LastValidatorPower.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/LastValidatorPower",
      value: LastValidatorPower.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return LastValidatorPower.decode(message.value);
  },

  toProto(message) {
    return LastValidatorPower.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos.staking.v1beta1.LastValidatorPower",
      value: LastValidatorPower.encode(message).finish()
    };
  }

};
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/cosmos/staking/v1beta1/query.js
var staking_v1beta1_query = __webpack_require__(75317);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/cosmos/staking/v1beta1/tx.js
var staking_v1beta1_tx = __webpack_require__(9605);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/cosmos/tx/signing/v1beta1/signing.js
var v1beta1_signing = __webpack_require__(80828);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/cosmos/tx/v1beta1/service.js
var service = __webpack_require__(89242);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/cosmos/tx/v1beta1/tx.js
var tx_v1beta1_tx = __webpack_require__(20673);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/cosmos/upgrade/v1beta1/query.js
var upgrade_v1beta1_query = __webpack_require__(72526);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/cosmos/upgrade/v1beta1/upgrade.js
var v1beta1_upgrade = __webpack_require__(60184);
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/cosmos/authz/v1beta1/tx.amino.js
//@ts-nocheck

const AminoConverter = {
  "/cosmos.authz.v1beta1.MsgGrant": {
    aminoType: "cosmos-sdk/MsgGrant",
    toAmino: v1beta1_tx.MsgGrant.toAmino,
    fromAmino: v1beta1_tx.MsgGrant.fromAmino
  },
  "/cosmos.authz.v1beta1.MsgExec": {
    aminoType: "cosmos-sdk/MsgExec",
    toAmino: v1beta1_tx.MsgExec.toAmino,
    fromAmino: v1beta1_tx.MsgExec.fromAmino
  },
  "/cosmos.authz.v1beta1.MsgRevoke": {
    aminoType: "cosmos-sdk/MsgRevoke",
    toAmino: v1beta1_tx.MsgRevoke.toAmino,
    fromAmino: v1beta1_tx.MsgRevoke.fromAmino
  }
};
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/cosmos/bank/v1beta1/tx.amino.js
//@ts-nocheck

const tx_amino_AminoConverter = {
  "/cosmos.bank.v1beta1.MsgSend": {
    aminoType: "cosmos-sdk/MsgSend",
    toAmino: bank_v1beta1_tx.MsgSend.toAmino,
    fromAmino: bank_v1beta1_tx.MsgSend.fromAmino
  },
  "/cosmos.bank.v1beta1.MsgMultiSend": {
    aminoType: "cosmos-sdk/MsgMultiSend",
    toAmino: bank_v1beta1_tx.MsgMultiSend.toAmino,
    fromAmino: bank_v1beta1_tx.MsgMultiSend.fromAmino
  }
};
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/cosmos/distribution/v1beta1/tx.amino.js
//@ts-nocheck

const v1beta1_tx_amino_AminoConverter = {
  "/cosmos.distribution.v1beta1.MsgSetWithdrawAddress": {
    aminoType: "cosmos-sdk/MsgModifyWithdrawAddress",
    toAmino: distribution_v1beta1_tx.MsgSetWithdrawAddress.toAmino,
    fromAmino: distribution_v1beta1_tx.MsgSetWithdrawAddress.fromAmino
  },
  "/cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward": {
    aminoType: "cosmos-sdk/MsgWithdrawDelegationReward",
    toAmino: distribution_v1beta1_tx.MsgWithdrawDelegatorReward.toAmino,
    fromAmino: distribution_v1beta1_tx.MsgWithdrawDelegatorReward.fromAmino
  },
  "/cosmos.distribution.v1beta1.MsgWithdrawValidatorCommission": {
    aminoType: "cosmos-sdk/MsgWithdrawValCommission",
    toAmino: distribution_v1beta1_tx.MsgWithdrawValidatorCommission.toAmino,
    fromAmino: distribution_v1beta1_tx.MsgWithdrawValidatorCommission.fromAmino
  },
  "/cosmos.distribution.v1beta1.MsgFundCommunityPool": {
    aminoType: "cosmos-sdk/MsgFundCommunityPool",
    toAmino: distribution_v1beta1_tx.MsgFundCommunityPool.toAmino,
    fromAmino: distribution_v1beta1_tx.MsgFundCommunityPool.fromAmino
  }
};
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/cosmos/gov/v1beta1/tx.amino.js
//@ts-nocheck

const gov_v1beta1_tx_amino_AminoConverter = {
  "/cosmos.gov.v1beta1.MsgSubmitProposal": {
    aminoType: "cosmos-sdk/v1/MsgSubmitProposal",
    toAmino: gov_v1beta1_tx.MsgSubmitProposal.toAmino,
    fromAmino: gov_v1beta1_tx.MsgSubmitProposal.fromAmino
  },
  "/cosmos.gov.v1beta1.MsgVote": {
    aminoType: "cosmos-sdk/v1/MsgVote",
    toAmino: gov_v1beta1_tx.MsgVote.toAmino,
    fromAmino: gov_v1beta1_tx.MsgVote.fromAmino
  },
  "/cosmos.gov.v1beta1.MsgVoteWeighted": {
    aminoType: "cosmos-sdk/v1/MsgVoteWeighted",
    toAmino: gov_v1beta1_tx.MsgVoteWeighted.toAmino,
    fromAmino: gov_v1beta1_tx.MsgVoteWeighted.fromAmino
  },
  "/cosmos.gov.v1beta1.MsgDeposit": {
    aminoType: "cosmos-sdk/v1/MsgDeposit",
    toAmino: gov_v1beta1_tx.MsgDeposit.toAmino,
    fromAmino: gov_v1beta1_tx.MsgDeposit.fromAmino
  }
};
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/cosmos/staking/v1beta1/tx.amino.js
//@ts-nocheck

const staking_v1beta1_tx_amino_AminoConverter = {
  "/cosmos.staking.v1beta1.MsgCreateValidator": {
    aminoType: "cosmos-sdk/MsgCreateValidator",
    toAmino: staking_v1beta1_tx.MsgCreateValidator.toAmino,
    fromAmino: staking_v1beta1_tx.MsgCreateValidator.fromAmino
  },
  "/cosmos.staking.v1beta1.MsgEditValidator": {
    aminoType: "cosmos-sdk/MsgEditValidator",
    toAmino: staking_v1beta1_tx.MsgEditValidator.toAmino,
    fromAmino: staking_v1beta1_tx.MsgEditValidator.fromAmino
  },
  "/cosmos.staking.v1beta1.MsgDelegate": {
    aminoType: "cosmos-sdk/MsgDelegate",
    toAmino: staking_v1beta1_tx.MsgDelegate.toAmino,
    fromAmino: staking_v1beta1_tx.MsgDelegate.fromAmino
  },
  "/cosmos.staking.v1beta1.MsgBeginRedelegate": {
    aminoType: "cosmos-sdk/MsgBeginRedelegate",
    toAmino: staking_v1beta1_tx.MsgBeginRedelegate.toAmino,
    fromAmino: staking_v1beta1_tx.MsgBeginRedelegate.fromAmino
  },
  "/cosmos.staking.v1beta1.MsgUndelegate": {
    aminoType: "cosmos-sdk/MsgUndelegate",
    toAmino: staking_v1beta1_tx.MsgUndelegate.toAmino,
    fromAmino: staking_v1beta1_tx.MsgUndelegate.fromAmino
  }
};
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/cosmos/authz/v1beta1/tx.registry.js
//@ts-nocheck

const registry = [["/cosmos.authz.v1beta1.MsgGrant", v1beta1_tx.MsgGrant], ["/cosmos.authz.v1beta1.MsgExec", v1beta1_tx.MsgExec], ["/cosmos.authz.v1beta1.MsgRevoke", v1beta1_tx.MsgRevoke]];
const load = protoRegistry => {
  registry.forEach(([typeUrl, mod]) => {
    protoRegistry.register(typeUrl, mod);
  });
};
const MessageComposer = {
  encoded: {
    grant(value) {
      return {
        typeUrl: "/cosmos.authz.v1beta1.MsgGrant",
        value: v1beta1_tx.MsgGrant.encode(value).finish()
      };
    },

    exec(value) {
      return {
        typeUrl: "/cosmos.authz.v1beta1.MsgExec",
        value: v1beta1_tx.MsgExec.encode(value).finish()
      };
    },

    revoke(value) {
      return {
        typeUrl: "/cosmos.authz.v1beta1.MsgRevoke",
        value: v1beta1_tx.MsgRevoke.encode(value).finish()
      };
    }

  },
  withTypeUrl: {
    grant(value) {
      return {
        typeUrl: "/cosmos.authz.v1beta1.MsgGrant",
        value
      };
    },

    exec(value) {
      return {
        typeUrl: "/cosmos.authz.v1beta1.MsgExec",
        value
      };
    },

    revoke(value) {
      return {
        typeUrl: "/cosmos.authz.v1beta1.MsgRevoke",
        value
      };
    }

  },
  fromPartial: {
    grant(value) {
      return {
        typeUrl: "/cosmos.authz.v1beta1.MsgGrant",
        value: v1beta1_tx.MsgGrant.fromPartial(value)
      };
    },

    exec(value) {
      return {
        typeUrl: "/cosmos.authz.v1beta1.MsgExec",
        value: v1beta1_tx.MsgExec.fromPartial(value)
      };
    },

    revoke(value) {
      return {
        typeUrl: "/cosmos.authz.v1beta1.MsgRevoke",
        value: v1beta1_tx.MsgRevoke.fromPartial(value)
      };
    }

  }
};
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/cosmos/bank/v1beta1/tx.registry.js
//@ts-nocheck

const tx_registry_registry = [["/cosmos.bank.v1beta1.MsgSend", bank_v1beta1_tx.MsgSend], ["/cosmos.bank.v1beta1.MsgMultiSend", bank_v1beta1_tx.MsgMultiSend]];
const tx_registry_load = protoRegistry => {
  tx_registry_registry.forEach(([typeUrl, mod]) => {
    protoRegistry.register(typeUrl, mod);
  });
};
const tx_registry_MessageComposer = {
  encoded: {
    send(value) {
      return {
        typeUrl: "/cosmos.bank.v1beta1.MsgSend",
        value: bank_v1beta1_tx.MsgSend.encode(value).finish()
      };
    },

    multiSend(value) {
      return {
        typeUrl: "/cosmos.bank.v1beta1.MsgMultiSend",
        value: bank_v1beta1_tx.MsgMultiSend.encode(value).finish()
      };
    }

  },
  withTypeUrl: {
    send(value) {
      return {
        typeUrl: "/cosmos.bank.v1beta1.MsgSend",
        value
      };
    },

    multiSend(value) {
      return {
        typeUrl: "/cosmos.bank.v1beta1.MsgMultiSend",
        value
      };
    }

  },
  fromPartial: {
    send(value) {
      return {
        typeUrl: "/cosmos.bank.v1beta1.MsgSend",
        value: bank_v1beta1_tx.MsgSend.fromPartial(value)
      };
    },

    multiSend(value) {
      return {
        typeUrl: "/cosmos.bank.v1beta1.MsgMultiSend",
        value: bank_v1beta1_tx.MsgMultiSend.fromPartial(value)
      };
    }

  }
};
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/cosmos/distribution/v1beta1/tx.registry.js
//@ts-nocheck

const v1beta1_tx_registry_registry = [["/cosmos.distribution.v1beta1.MsgSetWithdrawAddress", distribution_v1beta1_tx.MsgSetWithdrawAddress], ["/cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward", distribution_v1beta1_tx.MsgWithdrawDelegatorReward], ["/cosmos.distribution.v1beta1.MsgWithdrawValidatorCommission", distribution_v1beta1_tx.MsgWithdrawValidatorCommission], ["/cosmos.distribution.v1beta1.MsgFundCommunityPool", distribution_v1beta1_tx.MsgFundCommunityPool]];
const v1beta1_tx_registry_load = protoRegistry => {
  v1beta1_tx_registry_registry.forEach(([typeUrl, mod]) => {
    protoRegistry.register(typeUrl, mod);
  });
};
const v1beta1_tx_registry_MessageComposer = {
  encoded: {
    setWithdrawAddress(value) {
      return {
        typeUrl: "/cosmos.distribution.v1beta1.MsgSetWithdrawAddress",
        value: distribution_v1beta1_tx.MsgSetWithdrawAddress.encode(value).finish()
      };
    },

    withdrawDelegatorReward(value) {
      return {
        typeUrl: "/cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward",
        value: distribution_v1beta1_tx.MsgWithdrawDelegatorReward.encode(value).finish()
      };
    },

    withdrawValidatorCommission(value) {
      return {
        typeUrl: "/cosmos.distribution.v1beta1.MsgWithdrawValidatorCommission",
        value: distribution_v1beta1_tx.MsgWithdrawValidatorCommission.encode(value).finish()
      };
    },

    fundCommunityPool(value) {
      return {
        typeUrl: "/cosmos.distribution.v1beta1.MsgFundCommunityPool",
        value: distribution_v1beta1_tx.MsgFundCommunityPool.encode(value).finish()
      };
    }

  },
  withTypeUrl: {
    setWithdrawAddress(value) {
      return {
        typeUrl: "/cosmos.distribution.v1beta1.MsgSetWithdrawAddress",
        value
      };
    },

    withdrawDelegatorReward(value) {
      return {
        typeUrl: "/cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward",
        value
      };
    },

    withdrawValidatorCommission(value) {
      return {
        typeUrl: "/cosmos.distribution.v1beta1.MsgWithdrawValidatorCommission",
        value
      };
    },

    fundCommunityPool(value) {
      return {
        typeUrl: "/cosmos.distribution.v1beta1.MsgFundCommunityPool",
        value
      };
    }

  },
  fromPartial: {
    setWithdrawAddress(value) {
      return {
        typeUrl: "/cosmos.distribution.v1beta1.MsgSetWithdrawAddress",
        value: distribution_v1beta1_tx.MsgSetWithdrawAddress.fromPartial(value)
      };
    },

    withdrawDelegatorReward(value) {
      return {
        typeUrl: "/cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward",
        value: distribution_v1beta1_tx.MsgWithdrawDelegatorReward.fromPartial(value)
      };
    },

    withdrawValidatorCommission(value) {
      return {
        typeUrl: "/cosmos.distribution.v1beta1.MsgWithdrawValidatorCommission",
        value: distribution_v1beta1_tx.MsgWithdrawValidatorCommission.fromPartial(value)
      };
    },

    fundCommunityPool(value) {
      return {
        typeUrl: "/cosmos.distribution.v1beta1.MsgFundCommunityPool",
        value: distribution_v1beta1_tx.MsgFundCommunityPool.fromPartial(value)
      };
    }

  }
};
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/cosmos/gov/v1beta1/tx.registry.js
//@ts-nocheck

const gov_v1beta1_tx_registry_registry = [["/cosmos.gov.v1beta1.MsgSubmitProposal", gov_v1beta1_tx.MsgSubmitProposal], ["/cosmos.gov.v1beta1.MsgVote", gov_v1beta1_tx.MsgVote], ["/cosmos.gov.v1beta1.MsgVoteWeighted", gov_v1beta1_tx.MsgVoteWeighted], ["/cosmos.gov.v1beta1.MsgDeposit", gov_v1beta1_tx.MsgDeposit]];
const gov_v1beta1_tx_registry_load = protoRegistry => {
  gov_v1beta1_tx_registry_registry.forEach(([typeUrl, mod]) => {
    protoRegistry.register(typeUrl, mod);
  });
};
const gov_v1beta1_tx_registry_MessageComposer = {
  encoded: {
    submitProposal(value) {
      return {
        typeUrl: "/cosmos.gov.v1beta1.MsgSubmitProposal",
        value: gov_v1beta1_tx.MsgSubmitProposal.encode(value).finish()
      };
    },

    vote(value) {
      return {
        typeUrl: "/cosmos.gov.v1beta1.MsgVote",
        value: gov_v1beta1_tx.MsgVote.encode(value).finish()
      };
    },

    voteWeighted(value) {
      return {
        typeUrl: "/cosmos.gov.v1beta1.MsgVoteWeighted",
        value: gov_v1beta1_tx.MsgVoteWeighted.encode(value).finish()
      };
    },

    deposit(value) {
      return {
        typeUrl: "/cosmos.gov.v1beta1.MsgDeposit",
        value: gov_v1beta1_tx.MsgDeposit.encode(value).finish()
      };
    }

  },
  withTypeUrl: {
    submitProposal(value) {
      return {
        typeUrl: "/cosmos.gov.v1beta1.MsgSubmitProposal",
        value
      };
    },

    vote(value) {
      return {
        typeUrl: "/cosmos.gov.v1beta1.MsgVote",
        value
      };
    },

    voteWeighted(value) {
      return {
        typeUrl: "/cosmos.gov.v1beta1.MsgVoteWeighted",
        value
      };
    },

    deposit(value) {
      return {
        typeUrl: "/cosmos.gov.v1beta1.MsgDeposit",
        value
      };
    }

  },
  fromPartial: {
    submitProposal(value) {
      return {
        typeUrl: "/cosmos.gov.v1beta1.MsgSubmitProposal",
        value: gov_v1beta1_tx.MsgSubmitProposal.fromPartial(value)
      };
    },

    vote(value) {
      return {
        typeUrl: "/cosmos.gov.v1beta1.MsgVote",
        value: gov_v1beta1_tx.MsgVote.fromPartial(value)
      };
    },

    voteWeighted(value) {
      return {
        typeUrl: "/cosmos.gov.v1beta1.MsgVoteWeighted",
        value: gov_v1beta1_tx.MsgVoteWeighted.fromPartial(value)
      };
    },

    deposit(value) {
      return {
        typeUrl: "/cosmos.gov.v1beta1.MsgDeposit",
        value: gov_v1beta1_tx.MsgDeposit.fromPartial(value)
      };
    }

  }
};
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/cosmos/staking/v1beta1/tx.registry.js
//@ts-nocheck

const staking_v1beta1_tx_registry_registry = [["/cosmos.staking.v1beta1.MsgCreateValidator", staking_v1beta1_tx.MsgCreateValidator], ["/cosmos.staking.v1beta1.MsgEditValidator", staking_v1beta1_tx.MsgEditValidator], ["/cosmos.staking.v1beta1.MsgDelegate", staking_v1beta1_tx.MsgDelegate], ["/cosmos.staking.v1beta1.MsgBeginRedelegate", staking_v1beta1_tx.MsgBeginRedelegate], ["/cosmos.staking.v1beta1.MsgUndelegate", staking_v1beta1_tx.MsgUndelegate]];
const staking_v1beta1_tx_registry_load = protoRegistry => {
  staking_v1beta1_tx_registry_registry.forEach(([typeUrl, mod]) => {
    protoRegistry.register(typeUrl, mod);
  });
};
const staking_v1beta1_tx_registry_MessageComposer = {
  encoded: {
    createValidator(value) {
      return {
        typeUrl: "/cosmos.staking.v1beta1.MsgCreateValidator",
        value: staking_v1beta1_tx.MsgCreateValidator.encode(value).finish()
      };
    },

    editValidator(value) {
      return {
        typeUrl: "/cosmos.staking.v1beta1.MsgEditValidator",
        value: staking_v1beta1_tx.MsgEditValidator.encode(value).finish()
      };
    },

    delegate(value) {
      return {
        typeUrl: "/cosmos.staking.v1beta1.MsgDelegate",
        value: staking_v1beta1_tx.MsgDelegate.encode(value).finish()
      };
    },

    beginRedelegate(value) {
      return {
        typeUrl: "/cosmos.staking.v1beta1.MsgBeginRedelegate",
        value: staking_v1beta1_tx.MsgBeginRedelegate.encode(value).finish()
      };
    },

    undelegate(value) {
      return {
        typeUrl: "/cosmos.staking.v1beta1.MsgUndelegate",
        value: staking_v1beta1_tx.MsgUndelegate.encode(value).finish()
      };
    }

  },
  withTypeUrl: {
    createValidator(value) {
      return {
        typeUrl: "/cosmos.staking.v1beta1.MsgCreateValidator",
        value
      };
    },

    editValidator(value) {
      return {
        typeUrl: "/cosmos.staking.v1beta1.MsgEditValidator",
        value
      };
    },

    delegate(value) {
      return {
        typeUrl: "/cosmos.staking.v1beta1.MsgDelegate",
        value
      };
    },

    beginRedelegate(value) {
      return {
        typeUrl: "/cosmos.staking.v1beta1.MsgBeginRedelegate",
        value
      };
    },

    undelegate(value) {
      return {
        typeUrl: "/cosmos.staking.v1beta1.MsgUndelegate",
        value
      };
    }

  },
  fromPartial: {
    createValidator(value) {
      return {
        typeUrl: "/cosmos.staking.v1beta1.MsgCreateValidator",
        value: staking_v1beta1_tx.MsgCreateValidator.fromPartial(value)
      };
    },

    editValidator(value) {
      return {
        typeUrl: "/cosmos.staking.v1beta1.MsgEditValidator",
        value: staking_v1beta1_tx.MsgEditValidator.fromPartial(value)
      };
    },

    delegate(value) {
      return {
        typeUrl: "/cosmos.staking.v1beta1.MsgDelegate",
        value: staking_v1beta1_tx.MsgDelegate.fromPartial(value)
      };
    },

    beginRedelegate(value) {
      return {
        typeUrl: "/cosmos.staking.v1beta1.MsgBeginRedelegate",
        value: staking_v1beta1_tx.MsgBeginRedelegate.fromPartial(value)
      };
    },

    undelegate(value) {
      return {
        typeUrl: "/cosmos.staking.v1beta1.MsgUndelegate",
        value: staking_v1beta1_tx.MsgUndelegate.fromPartial(value)
      };
    }

  }
};
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/cosmos/auth/v1beta1/query.lcd.js
var query_lcd = __webpack_require__(88436);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/cosmos/authz/v1beta1/query.lcd.js
var v1beta1_query_lcd = __webpack_require__(73300);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/cosmos/bank/v1beta1/query.lcd.js
var bank_v1beta1_query_lcd = __webpack_require__(79926);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/cosmos/base/node/v1beta1/query.lcd.js
var node_v1beta1_query_lcd = __webpack_require__(91318);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/cosmos/distribution/v1beta1/query.lcd.js
var distribution_v1beta1_query_lcd = __webpack_require__(39);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/cosmos/gov/v1beta1/query.lcd.js
var gov_v1beta1_query_lcd = __webpack_require__(3571);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/cosmos/staking/v1beta1/query.lcd.js
var staking_v1beta1_query_lcd = __webpack_require__(24800);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/cosmos/tx/v1beta1/service.lcd.js
var service_lcd = __webpack_require__(57994);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/cosmos/upgrade/v1beta1/query.lcd.js
var upgrade_v1beta1_query_lcd = __webpack_require__(67931);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/cosmos/auth/v1beta1/query.rpc.Query.js
var query_rpc_Query = __webpack_require__(80908);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/cosmos/authz/v1beta1/query.rpc.Query.js
var v1beta1_query_rpc_Query = __webpack_require__(64139);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/cosmos/bank/v1beta1/query.rpc.Query.js
var bank_v1beta1_query_rpc_Query = __webpack_require__(3889);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/cosmos/base/node/v1beta1/query.rpc.Service.js
var query_rpc_Service = __webpack_require__(12345);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/cosmos/distribution/v1beta1/query.rpc.Query.js
var distribution_v1beta1_query_rpc_Query = __webpack_require__(23727);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/cosmos/gov/v1beta1/query.rpc.Query.js
var gov_v1beta1_query_rpc_Query = __webpack_require__(96921);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/cosmos/staking/v1beta1/query.rpc.Query.js
var staking_v1beta1_query_rpc_Query = __webpack_require__(56860);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/cosmos/tx/v1beta1/service.rpc.Service.js
var service_rpc_Service = __webpack_require__(82478);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/cosmos/upgrade/v1beta1/query.rpc.Query.js
var upgrade_v1beta1_query_rpc_Query = __webpack_require__(94898);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/cosmos/authz/v1beta1/tx.rpc.msg.js
var tx_rpc_msg = __webpack_require__(35773);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/cosmos/bank/v1beta1/tx.rpc.msg.js
var v1beta1_tx_rpc_msg = __webpack_require__(85579);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/cosmos/distribution/v1beta1/tx.rpc.msg.js
var distribution_v1beta1_tx_rpc_msg = __webpack_require__(9689);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/cosmos/gov/v1beta1/tx.rpc.msg.js
var gov_v1beta1_tx_rpc_msg = __webpack_require__(3207);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/cosmos/staking/v1beta1/tx.rpc.msg.js
var staking_v1beta1_tx_rpc_msg = __webpack_require__(34191);
// EXTERNAL MODULE: ./node_modules/@osmonauts/lcd/node_modules/axios/index.js
var axios = __webpack_require__(45791);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
;// CONCATENATED MODULE: ./node_modules/@osmonauts/lcd/module/rest.js


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


class LCDClient {
  constructor({
    restEndpoint
  }) {
    (0,defineProperty/* default */.Z)(this, "restEndpoint", void 0);

    (0,defineProperty/* default */.Z)(this, "instance", void 0);

    this.restEndpoint = restEndpoint.endsWith('/') ? restEndpoint : `${restEndpoint}/`;
    this.instance = axios_default().create({
      baseURL: this.restEndpoint,
      timeout: 10000,
      headers: {}
    });
    this.get = this.get.bind(this);
    this.post = this.post.bind(this);
  }

  get(endpoint, opts = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await this.instance.get(endpoint, _objectSpread({
          timeout: 10000
        }, opts));

        if (response && response.data) {
          resolve(response.data);
        } else {
          reject('no response data');
        }
      } catch (e) {
        return reject(e);
      }
    });
  }

  post(endpoint, body = {}, opts = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await this.instance.post(endpoint, body, _objectSpread({
          timeout: 10000
        }, opts));

        if (response && response.data) {
          resolve(response.data);
        } else {
          reject('no response data');
        }
      } catch (e) {
        return reject(e);
      }
    });
  }

}
;// CONCATENATED MODULE: ./node_modules/@osmonauts/lcd/module/index.js

;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/cosmos/lcd.js

const createLCDClient = async ({
  restEndpoint
}) => {
  const requestClient = new LCDClient({
    restEndpoint
  });
  return {
    cosmos: {
      auth: {
        v1beta1: new (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 88436))).LCDQueryClient({
          requestClient
        })
      },
      authz: {
        v1beta1: new (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 73300))).LCDQueryClient({
          requestClient
        })
      },
      bank: {
        v1beta1: new (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 79926))).LCDQueryClient({
          requestClient
        })
      },
      base: {
        node: {
          v1beta1: new (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 91318))).LCDQueryClient({
            requestClient
          })
        }
      },
      distribution: {
        v1beta1: new (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 39))).LCDQueryClient({
          requestClient
        })
      },
      gov: {
        v1beta1: new (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 3571))).LCDQueryClient({
          requestClient
        })
      },
      staking: {
        v1beta1: new (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 24800))).LCDQueryClient({
          requestClient
        })
      },
      tx: {
        v1beta1: new (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 57994))).LCDQueryClient({
          requestClient
        })
      },
      upgrade: {
        v1beta1: new (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 67931))).LCDQueryClient({
          requestClient
        })
      }
    }
  };
};
// EXTERNAL MODULE: ./node_modules/osmojs/node_modules/@cosmjs/tendermint-rpc/build/index.js
var build = __webpack_require__(13482);
// EXTERNAL MODULE: ./node_modules/osmojs/node_modules/@cosmjs/stargate/build/index.js
var stargate_build = __webpack_require__(78441);
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/cosmos/rpc.query.js


const createRPCQueryClient = async ({
  rpcEndpoint
}) => {
  const tmClient = await build.Tendermint34Client.connect(rpcEndpoint);
  const client = new stargate_build.QueryClient(tmClient);
  return {
    cosmos: {
      auth: {
        v1beta1: (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 80908))).createRpcQueryExtension(client)
      },
      authz: {
        v1beta1: (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 64139))).createRpcQueryExtension(client)
      },
      bank: {
        v1beta1: (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 3889))).createRpcQueryExtension(client)
      },
      base: {
        node: {
          v1beta1: (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 12345))).createRpcQueryExtension(client)
        }
      },
      distribution: {
        v1beta1: (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 23727))).createRpcQueryExtension(client)
      },
      gov: {
        v1beta1: (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 96921))).createRpcQueryExtension(client)
      },
      staking: {
        v1beta1: (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 56860))).createRpcQueryExtension(client)
      },
      tx: {
        v1beta1: (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 82478))).createRpcQueryExtension(client)
      },
      upgrade: {
        v1beta1: (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 94898))).createRpcQueryExtension(client)
      }
    }
  };
};
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/cosmos/rpc.tx.js
const createRPCMsgClient = async ({
  rpc
}) => ({
  cosmos: {
    authz: {
      v1beta1: new (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 35773))).MsgClientImpl(rpc)
    },
    bank: {
      v1beta1: new (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 85579))).MsgClientImpl(rpc)
    },
    distribution: {
      v1beta1: new (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 9689))).MsgClientImpl(rpc)
    },
    gov: {
      v1beta1: new (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 3207))).MsgClientImpl(rpc)
    },
    staking: {
      v1beta1: new (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 34191))).MsgClientImpl(rpc)
    }
  }
});
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/cosmos/bundle.js


function bundle_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function bundle_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? bundle_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : bundle_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }














































































let cosmos;

(function (_cosmos) {
  let ics23;

  (function (_ics) {
    const v1 = _ics.v1 = bundle_objectSpread({}, proofs);
  })(ics23 || (ics23 = _cosmos.ics23 || (_cosmos.ics23 = {})));

  let auth;

  (function (_auth) {
    const v1beta1 = _auth.v1beta1 = bundle_objectSpread(bundle_objectSpread(bundle_objectSpread(bundle_objectSpread(bundle_objectSpread({}, v1beta1_auth), genesis_namespaceObject), query), query_lcd), query_rpc_Query);
  })(auth || (auth = _cosmos.auth || (_cosmos.auth = {})));

  let authz;

  (function (_authz) {
    const v1beta1 = _authz.v1beta1 = bundle_objectSpread(bundle_objectSpread(bundle_objectSpread(bundle_objectSpread(bundle_objectSpread(bundle_objectSpread(bundle_objectSpread(bundle_objectSpread(bundle_objectSpread(bundle_objectSpread({}, v1beta1_authz), event_namespaceObject), v1beta1_genesis_namespaceObject), v1beta1_query), v1beta1_tx), tx_amino_namespaceObject), tx_registry_namespaceObject), v1beta1_query_lcd), v1beta1_query_rpc_Query), tx_rpc_msg);
  })(authz || (authz = _cosmos.authz || (_cosmos.authz = {})));

  let bank;

  (function (_bank) {
    const v1beta1 = _bank.v1beta1 = bundle_objectSpread(bundle_objectSpread(bundle_objectSpread(bundle_objectSpread(bundle_objectSpread(bundle_objectSpread(bundle_objectSpread(bundle_objectSpread(bundle_objectSpread(bundle_objectSpread({}, bank_v1beta1_authz), v1beta1_bank), bank_v1beta1_genesis_namespaceObject), bank_v1beta1_query), bank_v1beta1_tx), v1beta1_tx_amino_namespaceObject), v1beta1_tx_registry_namespaceObject), bank_v1beta1_query_lcd), bank_v1beta1_query_rpc_Query), v1beta1_tx_rpc_msg);
  })(bank || (bank = _cosmos.bank || (_cosmos.bank = {})));

  let base;

  (function (_base) {
    let abci;

    (function (_abci) {
      const v1beta1 = _abci.v1beta1 = bundle_objectSpread({}, v1beta1_abci);
    })(abci || (abci = _base.abci || (_base.abci = {})));

    let node;

    (function (_node) {
      const v1beta1 = _node.v1beta1 = bundle_objectSpread(bundle_objectSpread(bundle_objectSpread({}, node_v1beta1_query), node_v1beta1_query_lcd), query_rpc_Service);
    })(node || (node = _base.node || (_base.node = {})));

    let query;

    (function (_query) {
      const v1beta1 = _query.v1beta1 = bundle_objectSpread({}, pagination);
    })(query || (query = _base.query || (_base.query = {})));

    let reflection;

    (function (_reflection) {
      const v2alpha1 = _reflection.v2alpha1 = bundle_objectSpread({}, reflection_namespaceObject);
    })(reflection || (reflection = _base.reflection || (_base.reflection = {})));

    const v1beta1 = _base.v1beta1 = bundle_objectSpread({}, coin);
  })(base || (base = _cosmos.base || (_cosmos.base = {})));

  let crypto;

  (function (_crypto) {
    const ed25519 = _crypto.ed25519 = bundle_objectSpread({}, keys_namespaceObject);

    const multisig = _crypto.multisig = bundle_objectSpread({}, multisig_keys_namespaceObject);

    const secp256k1 = _crypto.secp256k1 = bundle_objectSpread({}, secp256k1_keys_namespaceObject);

    const secp256r1 = _crypto.secp256r1 = bundle_objectSpread({}, secp256r1_keys_namespaceObject);
  })(crypto || (crypto = _cosmos.crypto || (_cosmos.crypto = {})));

  let distribution;

  (function (_distribution) {
    const v1beta1 = _distribution.v1beta1 = bundle_objectSpread(bundle_objectSpread(bundle_objectSpread(bundle_objectSpread(bundle_objectSpread(bundle_objectSpread(bundle_objectSpread(bundle_objectSpread(bundle_objectSpread({}, v1beta1_distribution), distribution_v1beta1_genesis_namespaceObject), distribution_v1beta1_query), distribution_v1beta1_tx), distribution_v1beta1_tx_amino_namespaceObject), distribution_v1beta1_tx_registry_namespaceObject), distribution_v1beta1_query_lcd), distribution_v1beta1_query_rpc_Query), distribution_v1beta1_tx_rpc_msg);
  })(distribution || (distribution = _cosmos.distribution || (_cosmos.distribution = {})));

  let gov;

  (function (_gov) {
    const v1beta1 = _gov.v1beta1 = bundle_objectSpread(bundle_objectSpread(bundle_objectSpread(bundle_objectSpread(bundle_objectSpread(bundle_objectSpread(bundle_objectSpread(bundle_objectSpread(bundle_objectSpread({}, gov_v1beta1_genesis_namespaceObject), v1beta1_gov), gov_v1beta1_query), gov_v1beta1_tx), gov_v1beta1_tx_amino_namespaceObject), gov_v1beta1_tx_registry_namespaceObject), gov_v1beta1_query_lcd), gov_v1beta1_query_rpc_Query), gov_v1beta1_tx_rpc_msg);
  })(gov || (gov = _cosmos.gov || (_cosmos.gov = {})));

  let staking;

  (function (_staking) {
    const v1beta1 = _staking.v1beta1 = bundle_objectSpread(bundle_objectSpread(bundle_objectSpread(bundle_objectSpread(bundle_objectSpread(bundle_objectSpread(bundle_objectSpread(bundle_objectSpread(bundle_objectSpread(bundle_objectSpread({}, staking_v1beta1_authz), staking_v1beta1_genesis_namespaceObject), staking_v1beta1_query), v1beta1_staking), staking_v1beta1_tx), staking_v1beta1_tx_amino_namespaceObject), staking_v1beta1_tx_registry_namespaceObject), staking_v1beta1_query_lcd), staking_v1beta1_query_rpc_Query), staking_v1beta1_tx_rpc_msg);
  })(staking || (staking = _cosmos.staking || (_cosmos.staking = {})));

  let tx;

  (function (_tx) {
    let signing;

    (function (_signing) {
      const v1beta1 = _signing.v1beta1 = bundle_objectSpread({}, v1beta1_signing);
    })(signing || (signing = _tx.signing || (_tx.signing = {})));

    const v1beta1 = _tx.v1beta1 = bundle_objectSpread(bundle_objectSpread(bundle_objectSpread(bundle_objectSpread({}, service), tx_v1beta1_tx), service_lcd), service_rpc_Service);
  })(tx || (tx = _cosmos.tx || (_cosmos.tx = {})));

  let upgrade;

  (function (_upgrade) {
    const v1beta1 = _upgrade.v1beta1 = bundle_objectSpread(bundle_objectSpread(bundle_objectSpread(bundle_objectSpread({}, upgrade_v1beta1_query), v1beta1_upgrade), upgrade_v1beta1_query_lcd), upgrade_v1beta1_query_rpc_Query);
  })(upgrade || (upgrade = _cosmos.upgrade || (_cosmos.upgrade = {})));

  const ClientFactory = _cosmos.ClientFactory = bundle_objectSpread(bundle_objectSpread(bundle_objectSpread({}, lcd_namespaceObject), rpc_query_namespaceObject), rpc_tx_namespaceObject);
})(cosmos || (cosmos = {}));
// EXTERNAL MODULE: ./node_modules/osmojs/node_modules/@cosmjs/proto-signing/build/index.js
var proto_signing_build = __webpack_require__(89934);
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/cosmos/client.js


function client_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function client_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? client_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : client_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }













const cosmosAminoConverters = client_objectSpread(client_objectSpread(client_objectSpread(client_objectSpread(client_objectSpread({}, AminoConverter), tx_amino_AminoConverter), v1beta1_tx_amino_AminoConverter), gov_v1beta1_tx_amino_AminoConverter), staking_v1beta1_tx_amino_AminoConverter);
const cosmosProtoRegistry = [...registry, ...tx_registry_registry, ...v1beta1_tx_registry_registry, ...gov_v1beta1_tx_registry_registry, ...staking_v1beta1_tx_registry_registry];
const getSigningCosmosClientOptions = () => {
  const registry = new Registry([...cosmosProtoRegistry]);
  const aminoTypes = new AminoTypes(client_objectSpread({}, cosmosAminoConverters));
  return {
    registry,
    aminoTypes
  };
};
const getSigningCosmosClient = async ({
  rpcEndpoint,
  signer
}) => {
  const {
    registry,
    aminoTypes
  } = getSigningCosmosClientOptions();
  const client = await SigningStargateClient.connectWithSigner(rpcEndpoint, signer, {
    registry,
    aminoTypes
  });
  return client;
};
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/amino/amino.js

;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/amino/bundle.js


function amino_bundle_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function amino_bundle_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? amino_bundle_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : amino_bundle_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


const amino = amino_bundle_objectSpread({}, amino_namespaceObject);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/tendermint/abci/types.js
var abci_types = __webpack_require__(10670);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/tendermint/crypto/keys.js
var keys = __webpack_require__(79246);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/tendermint/crypto/proof.js
var proof = __webpack_require__(47374);
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/tendermint/libs/bits/types.js



function createBaseBitArray() {
  return {
    bits: helpers/* Long.ZERO */.dK.ZERO,
    elems: []
  };
}

const BitArray = {
  typeUrl: "/tendermint.libs.bits.BitArray",

  encode(message, writer = minimal.Writer.create()) {
    if (!message.bits.isZero()) {
      writer.uint32(8).int64(message.bits);
    }

    writer.uint32(18).fork();

    for (const v of message.elems) {
      writer.uint64(v);
    }

    writer.ldelim();
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBitArray();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.bits = reader.int64();
          break;

        case 2:
          if ((tag & 7) === 2) {
            const end2 = reader.uint32() + reader.pos;

            while (reader.pos < end2) {
              message.elems.push(reader.uint64());
            }
          } else {
            message.elems.push(reader.uint64());
          }

          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$elems;

    const message = createBaseBitArray();
    message.bits = object.bits !== undefined && object.bits !== null ? helpers/* Long.fromValue */.dK.fromValue(object.bits) : helpers/* Long.ZERO */.dK.ZERO;
    message.elems = ((_object$elems = object.elems) === null || _object$elems === void 0 ? void 0 : _object$elems.map(e => helpers/* Long.fromValue */.dK.fromValue(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      bits: helpers/* Long.fromString */.dK.fromString(object.bits),
      elems: Array.isArray(object === null || object === void 0 ? void 0 : object.elems) ? object.elems.map(e => e) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.bits = message.bits ? message.bits.toString() : undefined;

    if (message.elems) {
      obj.elems = message.elems.map(e => e);
    } else {
      obj.elems = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return BitArray.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return BitArray.decode(message.value);
  },

  toProto(message) {
    return BitArray.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/tendermint.libs.bits.BitArray",
      value: BitArray.encode(message).finish()
    };
  }

};
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/tendermint/p2p/types.js



function createBaseNetAddress() {
  return {
    id: "",
    ip: "",
    port: 0
  };
}

const NetAddress = {
  typeUrl: "/tendermint.p2p.NetAddress",

  encode(message, writer = minimal.Writer.create()) {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }

    if (message.ip !== "") {
      writer.uint32(18).string(message.ip);
    }

    if (message.port !== 0) {
      writer.uint32(24).uint32(message.port);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseNetAddress();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.id = reader.string();
          break;

        case 2:
          message.ip = reader.string();
          break;

        case 3:
          message.port = reader.uint32();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$id, _object$ip, _object$port;

    const message = createBaseNetAddress();
    message.id = (_object$id = object.id) !== null && _object$id !== void 0 ? _object$id : "";
    message.ip = (_object$ip = object.ip) !== null && _object$ip !== void 0 ? _object$ip : "";
    message.port = (_object$port = object.port) !== null && _object$port !== void 0 ? _object$port : 0;
    return message;
  },

  fromAmino(object) {
    return {
      id: object.id,
      ip: object.ip,
      port: object.port
    };
  },

  toAmino(message) {
    const obj = {};
    obj.id = message.id;
    obj.ip = message.ip;
    obj.port = message.port;
    return obj;
  },

  fromAminoMsg(object) {
    return NetAddress.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return NetAddress.decode(message.value);
  },

  toProto(message) {
    return NetAddress.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/tendermint.p2p.NetAddress",
      value: NetAddress.encode(message).finish()
    };
  }

};

function createBaseProtocolVersion() {
  return {
    p2p: helpers/* Long.UZERO */.dK.UZERO,
    block: helpers/* Long.UZERO */.dK.UZERO,
    app: helpers/* Long.UZERO */.dK.UZERO
  };
}

const ProtocolVersion = {
  typeUrl: "/tendermint.p2p.ProtocolVersion",

  encode(message, writer = minimal.Writer.create()) {
    if (!message.p2p.isZero()) {
      writer.uint32(8).uint64(message.p2p);
    }

    if (!message.block.isZero()) {
      writer.uint32(16).uint64(message.block);
    }

    if (!message.app.isZero()) {
      writer.uint32(24).uint64(message.app);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseProtocolVersion();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.p2p = reader.uint64();
          break;

        case 2:
          message.block = reader.uint64();
          break;

        case 3:
          message.app = reader.uint64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseProtocolVersion();
    message.p2p = object.p2p !== undefined && object.p2p !== null ? helpers/* Long.fromValue */.dK.fromValue(object.p2p) : helpers/* Long.UZERO */.dK.UZERO;
    message.block = object.block !== undefined && object.block !== null ? helpers/* Long.fromValue */.dK.fromValue(object.block) : helpers/* Long.UZERO */.dK.UZERO;
    message.app = object.app !== undefined && object.app !== null ? helpers/* Long.fromValue */.dK.fromValue(object.app) : helpers/* Long.UZERO */.dK.UZERO;
    return message;
  },

  fromAmino(object) {
    return {
      p2p: helpers/* Long.fromString */.dK.fromString(object.p2p),
      block: helpers/* Long.fromString */.dK.fromString(object.block),
      app: helpers/* Long.fromString */.dK.fromString(object.app)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.p2p = message.p2p ? message.p2p.toString() : undefined;
    obj.block = message.block ? message.block.toString() : undefined;
    obj.app = message.app ? message.app.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return ProtocolVersion.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return ProtocolVersion.decode(message.value);
  },

  toProto(message) {
    return ProtocolVersion.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/tendermint.p2p.ProtocolVersion",
      value: ProtocolVersion.encode(message).finish()
    };
  }

};

function createBaseDefaultNodeInfo() {
  return {
    protocolVersion: undefined,
    defaultNodeId: "",
    listenAddr: "",
    network: "",
    version: "",
    channels: new Uint8Array(),
    moniker: "",
    other: undefined
  };
}

const DefaultNodeInfo = {
  typeUrl: "/tendermint.p2p.DefaultNodeInfo",

  encode(message, writer = minimal.Writer.create()) {
    if (message.protocolVersion !== undefined) {
      ProtocolVersion.encode(message.protocolVersion, writer.uint32(10).fork()).ldelim();
    }

    if (message.defaultNodeId !== "") {
      writer.uint32(18).string(message.defaultNodeId);
    }

    if (message.listenAddr !== "") {
      writer.uint32(26).string(message.listenAddr);
    }

    if (message.network !== "") {
      writer.uint32(34).string(message.network);
    }

    if (message.version !== "") {
      writer.uint32(42).string(message.version);
    }

    if (message.channels.length !== 0) {
      writer.uint32(50).bytes(message.channels);
    }

    if (message.moniker !== "") {
      writer.uint32(58).string(message.moniker);
    }

    if (message.other !== undefined) {
      DefaultNodeInfoOther.encode(message.other, writer.uint32(66).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDefaultNodeInfo();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.protocolVersion = ProtocolVersion.decode(reader, reader.uint32());
          break;

        case 2:
          message.defaultNodeId = reader.string();
          break;

        case 3:
          message.listenAddr = reader.string();
          break;

        case 4:
          message.network = reader.string();
          break;

        case 5:
          message.version = reader.string();
          break;

        case 6:
          message.channels = reader.bytes();
          break;

        case 7:
          message.moniker = reader.string();
          break;

        case 8:
          message.other = DefaultNodeInfoOther.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$defaultNodeId, _object$listenAddr, _object$network, _object$version, _object$channels, _object$moniker;

    const message = createBaseDefaultNodeInfo();
    message.protocolVersion = object.protocolVersion !== undefined && object.protocolVersion !== null ? ProtocolVersion.fromPartial(object.protocolVersion) : undefined;
    message.defaultNodeId = (_object$defaultNodeId = object.defaultNodeId) !== null && _object$defaultNodeId !== void 0 ? _object$defaultNodeId : "";
    message.listenAddr = (_object$listenAddr = object.listenAddr) !== null && _object$listenAddr !== void 0 ? _object$listenAddr : "";
    message.network = (_object$network = object.network) !== null && _object$network !== void 0 ? _object$network : "";
    message.version = (_object$version = object.version) !== null && _object$version !== void 0 ? _object$version : "";
    message.channels = (_object$channels = object.channels) !== null && _object$channels !== void 0 ? _object$channels : new Uint8Array();
    message.moniker = (_object$moniker = object.moniker) !== null && _object$moniker !== void 0 ? _object$moniker : "";
    message.other = object.other !== undefined && object.other !== null ? DefaultNodeInfoOther.fromPartial(object.other) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      protocolVersion: object !== null && object !== void 0 && object.protocol_version ? ProtocolVersion.fromAmino(object.protocol_version) : undefined,
      defaultNodeId: object.default_node_id,
      listenAddr: object.listen_addr,
      network: object.network,
      version: object.version,
      channels: object.channels,
      moniker: object.moniker,
      other: object !== null && object !== void 0 && object.other ? DefaultNodeInfoOther.fromAmino(object.other) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.protocol_version = message.protocolVersion ? ProtocolVersion.toAmino(message.protocolVersion) : undefined;
    obj.default_node_id = message.defaultNodeId;
    obj.listen_addr = message.listenAddr;
    obj.network = message.network;
    obj.version = message.version;
    obj.channels = message.channels;
    obj.moniker = message.moniker;
    obj.other = message.other ? DefaultNodeInfoOther.toAmino(message.other) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return DefaultNodeInfo.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return DefaultNodeInfo.decode(message.value);
  },

  toProto(message) {
    return DefaultNodeInfo.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/tendermint.p2p.DefaultNodeInfo",
      value: DefaultNodeInfo.encode(message).finish()
    };
  }

};

function createBaseDefaultNodeInfoOther() {
  return {
    txIndex: "",
    rpcAddress: ""
  };
}

const DefaultNodeInfoOther = {
  typeUrl: "/tendermint.p2p.DefaultNodeInfoOther",

  encode(message, writer = minimal.Writer.create()) {
    if (message.txIndex !== "") {
      writer.uint32(10).string(message.txIndex);
    }

    if (message.rpcAddress !== "") {
      writer.uint32(18).string(message.rpcAddress);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDefaultNodeInfoOther();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.txIndex = reader.string();
          break;

        case 2:
          message.rpcAddress = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$txIndex, _object$rpcAddress;

    const message = createBaseDefaultNodeInfoOther();
    message.txIndex = (_object$txIndex = object.txIndex) !== null && _object$txIndex !== void 0 ? _object$txIndex : "";
    message.rpcAddress = (_object$rpcAddress = object.rpcAddress) !== null && _object$rpcAddress !== void 0 ? _object$rpcAddress : "";
    return message;
  },

  fromAmino(object) {
    return {
      txIndex: object.tx_index,
      rpcAddress: object.rpc_address
    };
  },

  toAmino(message) {
    const obj = {};
    obj.tx_index = message.txIndex;
    obj.rpc_address = message.rpcAddress;
    return obj;
  },

  fromAminoMsg(object) {
    return DefaultNodeInfoOther.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return DefaultNodeInfoOther.decode(message.value);
  },

  toProto(message) {
    return DefaultNodeInfoOther.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/tendermint.p2p.DefaultNodeInfoOther",
      value: DefaultNodeInfoOther.encode(message).finish()
    };
  }

};
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/tendermint/types/types.js
var types_types = __webpack_require__(87572);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/google/protobuf/timestamp.js
var timestamp = __webpack_require__(20633);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/tendermint/types/validator.js
var validator = __webpack_require__(70850);
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/tendermint/types/evidence.js






function createBaseEvidence() {
  return {
    duplicateVoteEvidence: undefined,
    lightClientAttackEvidence: undefined
  };
}

const Evidence = {
  typeUrl: "/tendermint.types.Evidence",

  encode(message, writer = minimal.Writer.create()) {
    if (message.duplicateVoteEvidence !== undefined) {
      DuplicateVoteEvidence.encode(message.duplicateVoteEvidence, writer.uint32(10).fork()).ldelim();
    }

    if (message.lightClientAttackEvidence !== undefined) {
      LightClientAttackEvidence.encode(message.lightClientAttackEvidence, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEvidence();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.duplicateVoteEvidence = DuplicateVoteEvidence.decode(reader, reader.uint32());
          break;

        case 2:
          message.lightClientAttackEvidence = LightClientAttackEvidence.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseEvidence();
    message.duplicateVoteEvidence = object.duplicateVoteEvidence !== undefined && object.duplicateVoteEvidence !== null ? DuplicateVoteEvidence.fromPartial(object.duplicateVoteEvidence) : undefined;
    message.lightClientAttackEvidence = object.lightClientAttackEvidence !== undefined && object.lightClientAttackEvidence !== null ? LightClientAttackEvidence.fromPartial(object.lightClientAttackEvidence) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      duplicateVoteEvidence: object !== null && object !== void 0 && object.duplicate_vote_evidence ? DuplicateVoteEvidence.fromAmino(object.duplicate_vote_evidence) : undefined,
      lightClientAttackEvidence: object !== null && object !== void 0 && object.light_client_attack_evidence ? LightClientAttackEvidence.fromAmino(object.light_client_attack_evidence) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.duplicate_vote_evidence = message.duplicateVoteEvidence ? DuplicateVoteEvidence.toAmino(message.duplicateVoteEvidence) : undefined;
    obj.light_client_attack_evidence = message.lightClientAttackEvidence ? LightClientAttackEvidence.toAmino(message.lightClientAttackEvidence) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return Evidence.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return Evidence.decode(message.value);
  },

  toProto(message) {
    return Evidence.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/tendermint.types.Evidence",
      value: Evidence.encode(message).finish()
    };
  }

};

function createBaseDuplicateVoteEvidence() {
  return {
    voteA: undefined,
    voteB: undefined,
    totalVotingPower: helpers/* Long.ZERO */.dK.ZERO,
    validatorPower: helpers/* Long.ZERO */.dK.ZERO,
    timestamp: undefined
  };
}

const DuplicateVoteEvidence = {
  typeUrl: "/tendermint.types.DuplicateVoteEvidence",

  encode(message, writer = minimal.Writer.create()) {
    if (message.voteA !== undefined) {
      types_types.Vote.encode(message.voteA, writer.uint32(10).fork()).ldelim();
    }

    if (message.voteB !== undefined) {
      types_types.Vote.encode(message.voteB, writer.uint32(18).fork()).ldelim();
    }

    if (!message.totalVotingPower.isZero()) {
      writer.uint32(24).int64(message.totalVotingPower);
    }

    if (!message.validatorPower.isZero()) {
      writer.uint32(32).int64(message.validatorPower);
    }

    if (message.timestamp !== undefined) {
      timestamp.Timestamp.encode((0,helpers/* toTimestamp */.Uq)(message.timestamp), writer.uint32(42).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDuplicateVoteEvidence();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.voteA = types_types.Vote.decode(reader, reader.uint32());
          break;

        case 2:
          message.voteB = types_types.Vote.decode(reader, reader.uint32());
          break;

        case 3:
          message.totalVotingPower = reader.int64();
          break;

        case 4:
          message.validatorPower = reader.int64();
          break;

        case 5:
          message.timestamp = (0,helpers/* fromTimestamp */.Ol)(timestamp.Timestamp.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$timestamp;

    const message = createBaseDuplicateVoteEvidence();
    message.voteA = object.voteA !== undefined && object.voteA !== null ? types_types.Vote.fromPartial(object.voteA) : undefined;
    message.voteB = object.voteB !== undefined && object.voteB !== null ? types_types.Vote.fromPartial(object.voteB) : undefined;
    message.totalVotingPower = object.totalVotingPower !== undefined && object.totalVotingPower !== null ? helpers/* Long.fromValue */.dK.fromValue(object.totalVotingPower) : helpers/* Long.ZERO */.dK.ZERO;
    message.validatorPower = object.validatorPower !== undefined && object.validatorPower !== null ? helpers/* Long.fromValue */.dK.fromValue(object.validatorPower) : helpers/* Long.ZERO */.dK.ZERO;
    message.timestamp = (_object$timestamp = object.timestamp) !== null && _object$timestamp !== void 0 ? _object$timestamp : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      voteA: object !== null && object !== void 0 && object.vote_a ? types_types.Vote.fromAmino(object.vote_a) : undefined,
      voteB: object !== null && object !== void 0 && object.vote_b ? types_types.Vote.fromAmino(object.vote_b) : undefined,
      totalVotingPower: helpers/* Long.fromString */.dK.fromString(object.total_voting_power),
      validatorPower: helpers/* Long.fromString */.dK.fromString(object.validator_power),
      timestamp: object !== null && object !== void 0 && object.timestamp ? timestamp.Timestamp.fromAmino(object.timestamp) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.vote_a = message.voteA ? types_types.Vote.toAmino(message.voteA) : undefined;
    obj.vote_b = message.voteB ? types_types.Vote.toAmino(message.voteB) : undefined;
    obj.total_voting_power = message.totalVotingPower ? message.totalVotingPower.toString() : undefined;
    obj.validator_power = message.validatorPower ? message.validatorPower.toString() : undefined;
    obj.timestamp = message.timestamp ? timestamp.Timestamp.toAmino(message.timestamp) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return DuplicateVoteEvidence.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return DuplicateVoteEvidence.decode(message.value);
  },

  toProto(message) {
    return DuplicateVoteEvidence.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/tendermint.types.DuplicateVoteEvidence",
      value: DuplicateVoteEvidence.encode(message).finish()
    };
  }

};

function createBaseLightClientAttackEvidence() {
  return {
    conflictingBlock: undefined,
    commonHeight: helpers/* Long.ZERO */.dK.ZERO,
    byzantineValidators: [],
    totalVotingPower: helpers/* Long.ZERO */.dK.ZERO,
    timestamp: undefined
  };
}

const LightClientAttackEvidence = {
  typeUrl: "/tendermint.types.LightClientAttackEvidence",

  encode(message, writer = minimal.Writer.create()) {
    if (message.conflictingBlock !== undefined) {
      types_types.LightBlock.encode(message.conflictingBlock, writer.uint32(10).fork()).ldelim();
    }

    if (!message.commonHeight.isZero()) {
      writer.uint32(16).int64(message.commonHeight);
    }

    for (const v of message.byzantineValidators) {
      validator.Validator.encode(v, writer.uint32(26).fork()).ldelim();
    }

    if (!message.totalVotingPower.isZero()) {
      writer.uint32(32).int64(message.totalVotingPower);
    }

    if (message.timestamp !== undefined) {
      timestamp.Timestamp.encode((0,helpers/* toTimestamp */.Uq)(message.timestamp), writer.uint32(42).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLightClientAttackEvidence();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.conflictingBlock = types_types.LightBlock.decode(reader, reader.uint32());
          break;

        case 2:
          message.commonHeight = reader.int64();
          break;

        case 3:
          message.byzantineValidators.push(validator.Validator.decode(reader, reader.uint32()));
          break;

        case 4:
          message.totalVotingPower = reader.int64();
          break;

        case 5:
          message.timestamp = (0,helpers/* fromTimestamp */.Ol)(timestamp.Timestamp.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$byzantineVali, _object$timestamp2;

    const message = createBaseLightClientAttackEvidence();
    message.conflictingBlock = object.conflictingBlock !== undefined && object.conflictingBlock !== null ? types_types.LightBlock.fromPartial(object.conflictingBlock) : undefined;
    message.commonHeight = object.commonHeight !== undefined && object.commonHeight !== null ? helpers/* Long.fromValue */.dK.fromValue(object.commonHeight) : helpers/* Long.ZERO */.dK.ZERO;
    message.byzantineValidators = ((_object$byzantineVali = object.byzantineValidators) === null || _object$byzantineVali === void 0 ? void 0 : _object$byzantineVali.map(e => validator.Validator.fromPartial(e))) || [];
    message.totalVotingPower = object.totalVotingPower !== undefined && object.totalVotingPower !== null ? helpers/* Long.fromValue */.dK.fromValue(object.totalVotingPower) : helpers/* Long.ZERO */.dK.ZERO;
    message.timestamp = (_object$timestamp2 = object.timestamp) !== null && _object$timestamp2 !== void 0 ? _object$timestamp2 : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      conflictingBlock: object !== null && object !== void 0 && object.conflicting_block ? types_types.LightBlock.fromAmino(object.conflicting_block) : undefined,
      commonHeight: helpers/* Long.fromString */.dK.fromString(object.common_height),
      byzantineValidators: Array.isArray(object === null || object === void 0 ? void 0 : object.byzantine_validators) ? object.byzantine_validators.map(e => validator.Validator.fromAmino(e)) : [],
      totalVotingPower: helpers/* Long.fromString */.dK.fromString(object.total_voting_power),
      timestamp: object !== null && object !== void 0 && object.timestamp ? timestamp.Timestamp.fromAmino(object.timestamp) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.conflicting_block = message.conflictingBlock ? types_types.LightBlock.toAmino(message.conflictingBlock) : undefined;
    obj.common_height = message.commonHeight ? message.commonHeight.toString() : undefined;

    if (message.byzantineValidators) {
      obj.byzantine_validators = message.byzantineValidators.map(e => e ? validator.Validator.toAmino(e) : undefined);
    } else {
      obj.byzantine_validators = [];
    }

    obj.total_voting_power = message.totalVotingPower ? message.totalVotingPower.toString() : undefined;
    obj.timestamp = message.timestamp ? timestamp.Timestamp.toAmino(message.timestamp) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return LightClientAttackEvidence.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return LightClientAttackEvidence.decode(message.value);
  },

  toProto(message) {
    return LightClientAttackEvidence.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/tendermint.types.LightClientAttackEvidence",
      value: LightClientAttackEvidence.encode(message).finish()
    };
  }

};

function createBaseEvidenceList() {
  return {
    evidence: []
  };
}

const EvidenceList = {
  typeUrl: "/tendermint.types.EvidenceList",

  encode(message, writer = minimal.Writer.create()) {
    for (const v of message.evidence) {
      Evidence.encode(v, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEvidenceList();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.evidence.push(Evidence.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$evidence;

    const message = createBaseEvidenceList();
    message.evidence = ((_object$evidence = object.evidence) === null || _object$evidence === void 0 ? void 0 : _object$evidence.map(e => Evidence.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      evidence: Array.isArray(object === null || object === void 0 ? void 0 : object.evidence) ? object.evidence.map(e => Evidence.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.evidence) {
      obj.evidence = message.evidence.map(e => e ? Evidence.toAmino(e) : undefined);
    } else {
      obj.evidence = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return EvidenceList.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return EvidenceList.decode(message.value);
  },

  toProto(message) {
    return EvidenceList.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/tendermint.types.EvidenceList",
      value: EvidenceList.encode(message).finish()
    };
  }

};
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/tendermint/types/block.js




function createBaseBlock() {
  return {
    header: undefined,
    data: undefined,
    evidence: undefined,
    lastCommit: undefined
  };
}

const Block = {
  typeUrl: "/tendermint.types.Block",

  encode(message, writer = minimal.Writer.create()) {
    if (message.header !== undefined) {
      types_types.Header.encode(message.header, writer.uint32(10).fork()).ldelim();
    }

    if (message.data !== undefined) {
      types_types.Data.encode(message.data, writer.uint32(18).fork()).ldelim();
    }

    if (message.evidence !== undefined) {
      EvidenceList.encode(message.evidence, writer.uint32(26).fork()).ldelim();
    }

    if (message.lastCommit !== undefined) {
      types_types.Commit.encode(message.lastCommit, writer.uint32(34).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBlock();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.header = types_types.Header.decode(reader, reader.uint32());
          break;

        case 2:
          message.data = types_types.Data.decode(reader, reader.uint32());
          break;

        case 3:
          message.evidence = EvidenceList.decode(reader, reader.uint32());
          break;

        case 4:
          message.lastCommit = types_types.Commit.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseBlock();
    message.header = object.header !== undefined && object.header !== null ? types_types.Header.fromPartial(object.header) : undefined;
    message.data = object.data !== undefined && object.data !== null ? types_types.Data.fromPartial(object.data) : undefined;
    message.evidence = object.evidence !== undefined && object.evidence !== null ? EvidenceList.fromPartial(object.evidence) : undefined;
    message.lastCommit = object.lastCommit !== undefined && object.lastCommit !== null ? types_types.Commit.fromPartial(object.lastCommit) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      header: object !== null && object !== void 0 && object.header ? types_types.Header.fromAmino(object.header) : undefined,
      data: object !== null && object !== void 0 && object.data ? types_types.Data.fromAmino(object.data) : undefined,
      evidence: object !== null && object !== void 0 && object.evidence ? EvidenceList.fromAmino(object.evidence) : undefined,
      lastCommit: object !== null && object !== void 0 && object.last_commit ? types_types.Commit.fromAmino(object.last_commit) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.header = message.header ? types_types.Header.toAmino(message.header) : undefined;
    obj.data = message.data ? types_types.Data.toAmino(message.data) : undefined;
    obj.evidence = message.evidence ? EvidenceList.toAmino(message.evidence) : undefined;
    obj.last_commit = message.lastCommit ? types_types.Commit.toAmino(message.lastCommit) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return Block.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return Block.decode(message.value);
  },

  toProto(message) {
    return Block.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/tendermint.types.Block",
      value: Block.encode(message).finish()
    };
  }

};
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/tendermint/types/params.js
var params = __webpack_require__(39490);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/tendermint/version/types.js
var version_types = __webpack_require__(88537);
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/tendermint/bundle.js


function tendermint_bundle_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function tendermint_bundle_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? tendermint_bundle_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : tendermint_bundle_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }












let tendermint;

(function (_tendermint) {
  const abci = _tendermint.abci = tendermint_bundle_objectSpread({}, abci_types);

  const crypto = _tendermint.crypto = tendermint_bundle_objectSpread(tendermint_bundle_objectSpread({}, keys), proof);

  let libs;

  (function (_libs) {
    const bits = _libs.bits = tendermint_bundle_objectSpread({}, types_namespaceObject);
  })(libs || (libs = _tendermint.libs || (_tendermint.libs = {})));

  const p2p = _tendermint.p2p = tendermint_bundle_objectSpread({}, p2p_types_namespaceObject);

  const types = _tendermint.types = tendermint_bundle_objectSpread(tendermint_bundle_objectSpread(tendermint_bundle_objectSpread(tendermint_bundle_objectSpread(tendermint_bundle_objectSpread({}, block_namespaceObject), evidence_namespaceObject), params), types_types), validator);

  const version = _tendermint.version = tendermint_bundle_objectSpread({}, version_types);
})(tendermint || (tendermint = {}));
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/capability/v1/capability.js


/**
 * Capability defines an implementation of an object capability. The index
 * provided to a Capability must be globally unique.
 */

function createBaseCapability() {
  return {
    index: helpers/* Long.UZERO */.dK.UZERO
  };
}

const Capability = {
  typeUrl: "/capability.v1.Capability",

  encode(message, writer = minimal.Writer.create()) {
    if (!message.index.isZero()) {
      writer.uint32(8).uint64(message.index);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCapability();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.index = reader.uint64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseCapability();
    message.index = object.index !== undefined && object.index !== null ? helpers/* Long.fromValue */.dK.fromValue(object.index) : helpers/* Long.UZERO */.dK.UZERO;
    return message;
  },

  fromAmino(object) {
    return {
      index: helpers/* Long.fromString */.dK.fromString(object.index)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.index = message.index ? message.index.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return Capability.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return Capability.decode(message.value);
  },

  toProto(message) {
    return Capability.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/capability.v1.Capability",
      value: Capability.encode(message).finish()
    };
  }

};

function createBaseOwner() {
  return {
    module: "",
    name: ""
  };
}

const Owner = {
  typeUrl: "/capability.v1.Owner",

  encode(message, writer = minimal.Writer.create()) {
    if (message.module !== "") {
      writer.uint32(10).string(message.module);
    }

    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOwner();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.module = reader.string();
          break;

        case 2:
          message.name = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$module, _object$name;

    const message = createBaseOwner();
    message.module = (_object$module = object.module) !== null && _object$module !== void 0 ? _object$module : "";
    message.name = (_object$name = object.name) !== null && _object$name !== void 0 ? _object$name : "";
    return message;
  },

  fromAmino(object) {
    return {
      module: object.module,
      name: object.name
    };
  },

  toAmino(message) {
    const obj = {};
    obj.module = message.module;
    obj.name = message.name;
    return obj;
  },

  fromAminoMsg(object) {
    return Owner.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return Owner.decode(message.value);
  },

  toProto(message) {
    return Owner.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/capability.v1.Owner",
      value: Owner.encode(message).finish()
    };
  }

};

function createBaseCapabilityOwners() {
  return {
    owners: []
  };
}

const CapabilityOwners = {
  typeUrl: "/capability.v1.CapabilityOwners",

  encode(message, writer = minimal.Writer.create()) {
    for (const v of message.owners) {
      Owner.encode(v, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCapabilityOwners();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.owners.push(Owner.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$owners;

    const message = createBaseCapabilityOwners();
    message.owners = ((_object$owners = object.owners) === null || _object$owners === void 0 ? void 0 : _object$owners.map(e => Owner.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      owners: Array.isArray(object === null || object === void 0 ? void 0 : object.owners) ? object.owners.map(e => Owner.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.owners) {
      obj.owners = message.owners.map(e => e ? Owner.toAmino(e) : undefined);
    } else {
      obj.owners = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return CapabilityOwners.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return CapabilityOwners.decode(message.value);
  },

  toProto(message) {
    return CapabilityOwners.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/capability.v1.CapabilityOwners",
      value: CapabilityOwners.encode(message).finish()
    };
  }

};
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/capability/v1/genesis.js



/** GenesisOwners defines the capability owners with their corresponding index. */

function createBaseGenesisOwners() {
  return {
    index: helpers/* Long.UZERO */.dK.UZERO,
    indexOwners: undefined
  };
}

const GenesisOwners = {
  typeUrl: "/capability.v1.GenesisOwners",

  encode(message, writer = minimal.Writer.create()) {
    if (!message.index.isZero()) {
      writer.uint32(8).uint64(message.index);
    }

    if (message.indexOwners !== undefined) {
      CapabilityOwners.encode(message.indexOwners, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGenesisOwners();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.index = reader.uint64();
          break;

        case 2:
          message.indexOwners = CapabilityOwners.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseGenesisOwners();
    message.index = object.index !== undefined && object.index !== null ? helpers/* Long.fromValue */.dK.fromValue(object.index) : helpers/* Long.UZERO */.dK.UZERO;
    message.indexOwners = object.indexOwners !== undefined && object.indexOwners !== null ? CapabilityOwners.fromPartial(object.indexOwners) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      index: helpers/* Long.fromString */.dK.fromString(object.index),
      indexOwners: object !== null && object !== void 0 && object.index_owners ? CapabilityOwners.fromAmino(object.index_owners) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.index = message.index ? message.index.toString() : undefined;
    obj.index_owners = message.indexOwners ? CapabilityOwners.toAmino(message.indexOwners) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return GenesisOwners.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return GenesisOwners.decode(message.value);
  },

  toProto(message) {
    return GenesisOwners.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/capability.v1.GenesisOwners",
      value: GenesisOwners.encode(message).finish()
    };
  }

};

function v1_genesis_createBaseGenesisState() {
  return {
    index: helpers/* Long.UZERO */.dK.UZERO,
    owners: []
  };
}

const v1_genesis_GenesisState = {
  typeUrl: "/capability.v1.GenesisState",

  encode(message, writer = minimal.Writer.create()) {
    if (!message.index.isZero()) {
      writer.uint32(8).uint64(message.index);
    }

    for (const v of message.owners) {
      GenesisOwners.encode(v, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = v1_genesis_createBaseGenesisState();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.index = reader.uint64();
          break;

        case 2:
          message.owners.push(GenesisOwners.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$owners;

    const message = v1_genesis_createBaseGenesisState();
    message.index = object.index !== undefined && object.index !== null ? helpers/* Long.fromValue */.dK.fromValue(object.index) : helpers/* Long.UZERO */.dK.UZERO;
    message.owners = ((_object$owners = object.owners) === null || _object$owners === void 0 ? void 0 : _object$owners.map(e => GenesisOwners.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      index: helpers/* Long.fromString */.dK.fromString(object.index),
      owners: Array.isArray(object === null || object === void 0 ? void 0 : object.owners) ? object.owners.map(e => GenesisOwners.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.index = message.index ? message.index.toString() : undefined;

    if (message.owners) {
      obj.owners = message.owners.map(e => e ? GenesisOwners.toAmino(e) : undefined);
    } else {
      obj.owners = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return v1_genesis_GenesisState.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return v1_genesis_GenesisState.decode(message.value);
  },

  toProto(message) {
    return v1_genesis_GenesisState.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/capability.v1.GenesisState",
      value: v1_genesis_GenesisState.encode(message).finish()
    };
  }

};
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/capability/bundle.js


function capability_bundle_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function capability_bundle_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? capability_bundle_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : capability_bundle_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



let capability;

(function (_capability) {
  const v1 = _capability.v1 = capability_bundle_objectSpread(capability_bundle_objectSpread({}, capability_namespaceObject), v1_genesis_namespaceObject);
})(capability || (capability = {}));
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/ibc/applications/fee/v1/ack.js

/** IncentivizedAcknowledgement is the acknowledgement format to be used by applications wrapped in the fee middleware */

function createBaseIncentivizedAcknowledgement() {
  return {
    appAcknowledgement: new Uint8Array(),
    forwardRelayerAddress: "",
    underlyingAppSuccess: false
  };
}

const IncentivizedAcknowledgement = {
  typeUrl: "/ibc.applications.fee.v1.IncentivizedAcknowledgement",

  encode(message, writer = minimal.Writer.create()) {
    if (message.appAcknowledgement.length !== 0) {
      writer.uint32(10).bytes(message.appAcknowledgement);
    }

    if (message.forwardRelayerAddress !== "") {
      writer.uint32(18).string(message.forwardRelayerAddress);
    }

    if (message.underlyingAppSuccess === true) {
      writer.uint32(24).bool(message.underlyingAppSuccess);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseIncentivizedAcknowledgement();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.appAcknowledgement = reader.bytes();
          break;

        case 2:
          message.forwardRelayerAddress = reader.string();
          break;

        case 3:
          message.underlyingAppSuccess = reader.bool();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$appAcknowledg, _object$forwardRelaye, _object$underlyingApp;

    const message = createBaseIncentivizedAcknowledgement();
    message.appAcknowledgement = (_object$appAcknowledg = object.appAcknowledgement) !== null && _object$appAcknowledg !== void 0 ? _object$appAcknowledg : new Uint8Array();
    message.forwardRelayerAddress = (_object$forwardRelaye = object.forwardRelayerAddress) !== null && _object$forwardRelaye !== void 0 ? _object$forwardRelaye : "";
    message.underlyingAppSuccess = (_object$underlyingApp = object.underlyingAppSuccess) !== null && _object$underlyingApp !== void 0 ? _object$underlyingApp : false;
    return message;
  },

  fromAmino(object) {
    return {
      appAcknowledgement: object.app_acknowledgement,
      forwardRelayerAddress: object.forward_relayer_address,
      underlyingAppSuccess: object.underlying_app_success
    };
  },

  toAmino(message) {
    const obj = {};
    obj.app_acknowledgement = message.appAcknowledgement;
    obj.forward_relayer_address = message.forwardRelayerAddress;
    obj.underlying_app_success = message.underlyingAppSuccess;
    return obj;
  },

  fromAminoMsg(object) {
    return IncentivizedAcknowledgement.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/IncentivizedAcknowledgement",
      value: IncentivizedAcknowledgement.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return IncentivizedAcknowledgement.decode(message.value);
  },

  toProto(message) {
    return IncentivizedAcknowledgement.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.applications.fee.v1.IncentivizedAcknowledgement",
      value: IncentivizedAcknowledgement.encode(message).finish()
    };
  }

};
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/ibc/applications/fee/v1/fee.js
var v1_fee = __webpack_require__(20989);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/ibc/applications/fee/v1/genesis.js
var genesis = __webpack_require__(16789);
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/ibc/applications/fee/v1/metadata.js

/**
 * Metadata defines the ICS29 channel specific metadata encoded into the channel version bytestring
 * See ICS004: https://github.com/cosmos/ibc/tree/master/spec/core/ics-004-channel-and-packet-semantics#Versioning
 */

function createBaseMetadata() {
  return {
    feeVersion: "",
    appVersion: ""
  };
}

const Metadata = {
  typeUrl: "/ibc.applications.fee.v1.Metadata",

  encode(message, writer = minimal.Writer.create()) {
    if (message.feeVersion !== "") {
      writer.uint32(10).string(message.feeVersion);
    }

    if (message.appVersion !== "") {
      writer.uint32(18).string(message.appVersion);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMetadata();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.feeVersion = reader.string();
          break;

        case 2:
          message.appVersion = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$feeVersion, _object$appVersion;

    const message = createBaseMetadata();
    message.feeVersion = (_object$feeVersion = object.feeVersion) !== null && _object$feeVersion !== void 0 ? _object$feeVersion : "";
    message.appVersion = (_object$appVersion = object.appVersion) !== null && _object$appVersion !== void 0 ? _object$appVersion : "";
    return message;
  },

  fromAmino(object) {
    return {
      feeVersion: object.fee_version,
      appVersion: object.app_version
    };
  },

  toAmino(message) {
    const obj = {};
    obj.fee_version = message.feeVersion;
    obj.app_version = message.appVersion;
    return obj;
  },

  fromAminoMsg(object) {
    return Metadata.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/Metadata",
      value: Metadata.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return Metadata.decode(message.value);
  },

  toProto(message) {
    return Metadata.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.applications.fee.v1.Metadata",
      value: Metadata.encode(message).finish()
    };
  }

};
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/ibc/applications/fee/v1/query.js
var v1_query = __webpack_require__(65705);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/ibc/applications/fee/v1/tx.js
var tx = __webpack_require__(43930);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/ibc/applications/interchain_accounts/controller/v1/controller.js
var v1_controller = __webpack_require__(46261);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/ibc/applications/interchain_accounts/controller/v1/query.js
var controller_v1_query = __webpack_require__(2082);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/ibc/applications/interchain_accounts/controller/v1/tx.js
var v1_tx = __webpack_require__(51982);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/ibc/applications/interchain_accounts/host/v1/host.js
var v1_host = __webpack_require__(78983);
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/ibc/applications/interchain_accounts/genesis/v1/genesis.js



/** GenesisState defines the interchain accounts genesis state */

function genesis_v1_genesis_createBaseGenesisState() {
  return {
    controllerGenesisState: undefined,
    hostGenesisState: undefined
  };
}

const genesis_v1_genesis_GenesisState = {
  typeUrl: "/ibc.applications.interchain_accounts.genesis.v1.GenesisState",

  encode(message, writer = minimal.Writer.create()) {
    if (message.controllerGenesisState !== undefined) {
      ControllerGenesisState.encode(message.controllerGenesisState, writer.uint32(10).fork()).ldelim();
    }

    if (message.hostGenesisState !== undefined) {
      HostGenesisState.encode(message.hostGenesisState, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = genesis_v1_genesis_createBaseGenesisState();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.controllerGenesisState = ControllerGenesisState.decode(reader, reader.uint32());
          break;

        case 2:
          message.hostGenesisState = HostGenesisState.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = genesis_v1_genesis_createBaseGenesisState();
    message.controllerGenesisState = object.controllerGenesisState !== undefined && object.controllerGenesisState !== null ? ControllerGenesisState.fromPartial(object.controllerGenesisState) : undefined;
    message.hostGenesisState = object.hostGenesisState !== undefined && object.hostGenesisState !== null ? HostGenesisState.fromPartial(object.hostGenesisState) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      controllerGenesisState: object !== null && object !== void 0 && object.controller_genesis_state ? ControllerGenesisState.fromAmino(object.controller_genesis_state) : undefined,
      hostGenesisState: object !== null && object !== void 0 && object.host_genesis_state ? HostGenesisState.fromAmino(object.host_genesis_state) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.controller_genesis_state = message.controllerGenesisState ? ControllerGenesisState.toAmino(message.controllerGenesisState) : undefined;
    obj.host_genesis_state = message.hostGenesisState ? HostGenesisState.toAmino(message.hostGenesisState) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return genesis_v1_genesis_GenesisState.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/GenesisState",
      value: genesis_v1_genesis_GenesisState.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return genesis_v1_genesis_GenesisState.decode(message.value);
  },

  toProto(message) {
    return genesis_v1_genesis_GenesisState.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.applications.interchain_accounts.genesis.v1.GenesisState",
      value: genesis_v1_genesis_GenesisState.encode(message).finish()
    };
  }

};

function createBaseControllerGenesisState() {
  return {
    activeChannels: [],
    interchainAccounts: [],
    ports: [],
    params: undefined
  };
}

const ControllerGenesisState = {
  typeUrl: "/ibc.applications.interchain_accounts.genesis.v1.ControllerGenesisState",

  encode(message, writer = minimal.Writer.create()) {
    for (const v of message.activeChannels) {
      ActiveChannel.encode(v, writer.uint32(10).fork()).ldelim();
    }

    for (const v of message.interchainAccounts) {
      RegisteredInterchainAccount.encode(v, writer.uint32(18).fork()).ldelim();
    }

    for (const v of message.ports) {
      writer.uint32(26).string(v);
    }

    if (message.params !== undefined) {
      v1_controller.Params.encode(message.params, writer.uint32(34).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseControllerGenesisState();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.activeChannels.push(ActiveChannel.decode(reader, reader.uint32()));
          break;

        case 2:
          message.interchainAccounts.push(RegisteredInterchainAccount.decode(reader, reader.uint32()));
          break;

        case 3:
          message.ports.push(reader.string());
          break;

        case 4:
          message.params = v1_controller.Params.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$activeChannel, _object$interchainAcc, _object$ports;

    const message = createBaseControllerGenesisState();
    message.activeChannels = ((_object$activeChannel = object.activeChannels) === null || _object$activeChannel === void 0 ? void 0 : _object$activeChannel.map(e => ActiveChannel.fromPartial(e))) || [];
    message.interchainAccounts = ((_object$interchainAcc = object.interchainAccounts) === null || _object$interchainAcc === void 0 ? void 0 : _object$interchainAcc.map(e => RegisteredInterchainAccount.fromPartial(e))) || [];
    message.ports = ((_object$ports = object.ports) === null || _object$ports === void 0 ? void 0 : _object$ports.map(e => e)) || [];
    message.params = object.params !== undefined && object.params !== null ? v1_controller.Params.fromPartial(object.params) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      activeChannels: Array.isArray(object === null || object === void 0 ? void 0 : object.active_channels) ? object.active_channels.map(e => ActiveChannel.fromAmino(e)) : [],
      interchainAccounts: Array.isArray(object === null || object === void 0 ? void 0 : object.interchain_accounts) ? object.interchain_accounts.map(e => RegisteredInterchainAccount.fromAmino(e)) : [],
      ports: Array.isArray(object === null || object === void 0 ? void 0 : object.ports) ? object.ports.map(e => e) : [],
      params: object !== null && object !== void 0 && object.params ? v1_controller.Params.fromAmino(object.params) : undefined
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.activeChannels) {
      obj.active_channels = message.activeChannels.map(e => e ? ActiveChannel.toAmino(e) : undefined);
    } else {
      obj.active_channels = [];
    }

    if (message.interchainAccounts) {
      obj.interchain_accounts = message.interchainAccounts.map(e => e ? RegisteredInterchainAccount.toAmino(e) : undefined);
    } else {
      obj.interchain_accounts = [];
    }

    if (message.ports) {
      obj.ports = message.ports.map(e => e);
    } else {
      obj.ports = [];
    }

    obj.params = message.params ? v1_controller.Params.toAmino(message.params) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return ControllerGenesisState.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/ControllerGenesisState",
      value: ControllerGenesisState.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return ControllerGenesisState.decode(message.value);
  },

  toProto(message) {
    return ControllerGenesisState.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.applications.interchain_accounts.genesis.v1.ControllerGenesisState",
      value: ControllerGenesisState.encode(message).finish()
    };
  }

};

function createBaseHostGenesisState() {
  return {
    activeChannels: [],
    interchainAccounts: [],
    port: "",
    params: undefined
  };
}

const HostGenesisState = {
  typeUrl: "/ibc.applications.interchain_accounts.genesis.v1.HostGenesisState",

  encode(message, writer = minimal.Writer.create()) {
    for (const v of message.activeChannels) {
      ActiveChannel.encode(v, writer.uint32(10).fork()).ldelim();
    }

    for (const v of message.interchainAccounts) {
      RegisteredInterchainAccount.encode(v, writer.uint32(18).fork()).ldelim();
    }

    if (message.port !== "") {
      writer.uint32(26).string(message.port);
    }

    if (message.params !== undefined) {
      v1_host.Params.encode(message.params, writer.uint32(34).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseHostGenesisState();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.activeChannels.push(ActiveChannel.decode(reader, reader.uint32()));
          break;

        case 2:
          message.interchainAccounts.push(RegisteredInterchainAccount.decode(reader, reader.uint32()));
          break;

        case 3:
          message.port = reader.string();
          break;

        case 4:
          message.params = v1_host.Params.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$activeChannel2, _object$interchainAcc2, _object$port;

    const message = createBaseHostGenesisState();
    message.activeChannels = ((_object$activeChannel2 = object.activeChannels) === null || _object$activeChannel2 === void 0 ? void 0 : _object$activeChannel2.map(e => ActiveChannel.fromPartial(e))) || [];
    message.interchainAccounts = ((_object$interchainAcc2 = object.interchainAccounts) === null || _object$interchainAcc2 === void 0 ? void 0 : _object$interchainAcc2.map(e => RegisteredInterchainAccount.fromPartial(e))) || [];
    message.port = (_object$port = object.port) !== null && _object$port !== void 0 ? _object$port : "";
    message.params = object.params !== undefined && object.params !== null ? v1_host.Params.fromPartial(object.params) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      activeChannels: Array.isArray(object === null || object === void 0 ? void 0 : object.active_channels) ? object.active_channels.map(e => ActiveChannel.fromAmino(e)) : [],
      interchainAccounts: Array.isArray(object === null || object === void 0 ? void 0 : object.interchain_accounts) ? object.interchain_accounts.map(e => RegisteredInterchainAccount.fromAmino(e)) : [],
      port: object.port,
      params: object !== null && object !== void 0 && object.params ? v1_host.Params.fromAmino(object.params) : undefined
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.activeChannels) {
      obj.active_channels = message.activeChannels.map(e => e ? ActiveChannel.toAmino(e) : undefined);
    } else {
      obj.active_channels = [];
    }

    if (message.interchainAccounts) {
      obj.interchain_accounts = message.interchainAccounts.map(e => e ? RegisteredInterchainAccount.toAmino(e) : undefined);
    } else {
      obj.interchain_accounts = [];
    }

    obj.port = message.port;
    obj.params = message.params ? v1_host.Params.toAmino(message.params) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return HostGenesisState.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/HostGenesisState",
      value: HostGenesisState.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return HostGenesisState.decode(message.value);
  },

  toProto(message) {
    return HostGenesisState.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.applications.interchain_accounts.genesis.v1.HostGenesisState",
      value: HostGenesisState.encode(message).finish()
    };
  }

};

function createBaseActiveChannel() {
  return {
    connectionId: "",
    portId: "",
    channelId: "",
    isMiddlewareEnabled: false
  };
}

const ActiveChannel = {
  typeUrl: "/ibc.applications.interchain_accounts.genesis.v1.ActiveChannel",

  encode(message, writer = minimal.Writer.create()) {
    if (message.connectionId !== "") {
      writer.uint32(10).string(message.connectionId);
    }

    if (message.portId !== "") {
      writer.uint32(18).string(message.portId);
    }

    if (message.channelId !== "") {
      writer.uint32(26).string(message.channelId);
    }

    if (message.isMiddlewareEnabled === true) {
      writer.uint32(32).bool(message.isMiddlewareEnabled);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseActiveChannel();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.connectionId = reader.string();
          break;

        case 2:
          message.portId = reader.string();
          break;

        case 3:
          message.channelId = reader.string();
          break;

        case 4:
          message.isMiddlewareEnabled = reader.bool();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$connectionId, _object$portId, _object$channelId, _object$isMiddlewareE;

    const message = createBaseActiveChannel();
    message.connectionId = (_object$connectionId = object.connectionId) !== null && _object$connectionId !== void 0 ? _object$connectionId : "";
    message.portId = (_object$portId = object.portId) !== null && _object$portId !== void 0 ? _object$portId : "";
    message.channelId = (_object$channelId = object.channelId) !== null && _object$channelId !== void 0 ? _object$channelId : "";
    message.isMiddlewareEnabled = (_object$isMiddlewareE = object.isMiddlewareEnabled) !== null && _object$isMiddlewareE !== void 0 ? _object$isMiddlewareE : false;
    return message;
  },

  fromAmino(object) {
    return {
      connectionId: object.connection_id,
      portId: object.port_id,
      channelId: object.channel_id,
      isMiddlewareEnabled: object.is_middleware_enabled
    };
  },

  toAmino(message) {
    const obj = {};
    obj.connection_id = message.connectionId;
    obj.port_id = message.portId;
    obj.channel_id = message.channelId;
    obj.is_middleware_enabled = message.isMiddlewareEnabled;
    return obj;
  },

  fromAminoMsg(object) {
    return ActiveChannel.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/ActiveChannel",
      value: ActiveChannel.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return ActiveChannel.decode(message.value);
  },

  toProto(message) {
    return ActiveChannel.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.applications.interchain_accounts.genesis.v1.ActiveChannel",
      value: ActiveChannel.encode(message).finish()
    };
  }

};

function createBaseRegisteredInterchainAccount() {
  return {
    connectionId: "",
    portId: "",
    accountAddress: ""
  };
}

const RegisteredInterchainAccount = {
  typeUrl: "/ibc.applications.interchain_accounts.genesis.v1.RegisteredInterchainAccount",

  encode(message, writer = minimal.Writer.create()) {
    if (message.connectionId !== "") {
      writer.uint32(10).string(message.connectionId);
    }

    if (message.portId !== "") {
      writer.uint32(18).string(message.portId);
    }

    if (message.accountAddress !== "") {
      writer.uint32(26).string(message.accountAddress);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRegisteredInterchainAccount();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.connectionId = reader.string();
          break;

        case 2:
          message.portId = reader.string();
          break;

        case 3:
          message.accountAddress = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$connectionId2, _object$portId2, _object$accountAddres;

    const message = createBaseRegisteredInterchainAccount();
    message.connectionId = (_object$connectionId2 = object.connectionId) !== null && _object$connectionId2 !== void 0 ? _object$connectionId2 : "";
    message.portId = (_object$portId2 = object.portId) !== null && _object$portId2 !== void 0 ? _object$portId2 : "";
    message.accountAddress = (_object$accountAddres = object.accountAddress) !== null && _object$accountAddres !== void 0 ? _object$accountAddres : "";
    return message;
  },

  fromAmino(object) {
    return {
      connectionId: object.connection_id,
      portId: object.port_id,
      accountAddress: object.account_address
    };
  },

  toAmino(message) {
    const obj = {};
    obj.connection_id = message.connectionId;
    obj.port_id = message.portId;
    obj.account_address = message.accountAddress;
    return obj;
  },

  fromAminoMsg(object) {
    return RegisteredInterchainAccount.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/RegisteredInterchainAccount",
      value: RegisteredInterchainAccount.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return RegisteredInterchainAccount.decode(message.value);
  },

  toProto(message) {
    return RegisteredInterchainAccount.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.applications.interchain_accounts.genesis.v1.RegisteredInterchainAccount",
      value: RegisteredInterchainAccount.encode(message).finish()
    };
  }

};
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/ibc/applications/interchain_accounts/host/v1/query.js
var host_v1_query = __webpack_require__(59643);
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/ibc/applications/interchain_accounts/v1/account.js


/** An InterchainAccount is defined as a BaseAccount & the address of the account owner on the controller chain */

function createBaseInterchainAccount() {
  return {
    $typeUrl: "/ibc.applications.interchain_accounts.v1.InterchainAccount",
    baseAccount: undefined,
    accountOwner: ""
  };
}

const InterchainAccount = {
  typeUrl: "/ibc.applications.interchain_accounts.v1.InterchainAccount",

  encode(message, writer = minimal.Writer.create()) {
    if (message.baseAccount !== undefined) {
      v1beta1_auth.BaseAccount.encode(message.baseAccount, writer.uint32(10).fork()).ldelim();
    }

    if (message.accountOwner !== "") {
      writer.uint32(18).string(message.accountOwner);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInterchainAccount();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.baseAccount = v1beta1_auth.BaseAccount.decode(reader, reader.uint32());
          break;

        case 2:
          message.accountOwner = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$accountOwner;

    const message = createBaseInterchainAccount();
    message.baseAccount = object.baseAccount !== undefined && object.baseAccount !== null ? v1beta1_auth.BaseAccount.fromPartial(object.baseAccount) : undefined;
    message.accountOwner = (_object$accountOwner = object.accountOwner) !== null && _object$accountOwner !== void 0 ? _object$accountOwner : "";
    return message;
  },

  fromAmino(object) {
    return {
      baseAccount: object !== null && object !== void 0 && object.base_account ? v1beta1_auth.BaseAccount.fromAmino(object.base_account) : undefined,
      accountOwner: object.account_owner
    };
  },

  toAmino(message) {
    const obj = {};
    obj.base_account = message.baseAccount ? v1beta1_auth.BaseAccount.toAmino(message.baseAccount) : undefined;
    obj.account_owner = message.accountOwner;
    return obj;
  },

  fromAminoMsg(object) {
    return InterchainAccount.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/InterchainAccount",
      value: InterchainAccount.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return InterchainAccount.decode(message.value);
  },

  toProto(message) {
    return InterchainAccount.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.applications.interchain_accounts.v1.InterchainAccount",
      value: InterchainAccount.encode(message).finish()
    };
  }

};
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/ibc/applications/interchain_accounts/v1/metadata.js

/**
 * Metadata defines a set of protocol specific data encoded into the ICS27 channel version bytestring
 * See ICS004: https://github.com/cosmos/ibc/tree/master/spec/core/ics-004-channel-and-packet-semantics#Versioning
 */

function metadata_createBaseMetadata() {
  return {
    version: "",
    controllerConnectionId: "",
    hostConnectionId: "",
    address: "",
    encoding: "",
    txType: ""
  };
}

const metadata_Metadata = {
  typeUrl: "/ibc.applications.interchain_accounts.v1.Metadata",

  encode(message, writer = minimal.Writer.create()) {
    if (message.version !== "") {
      writer.uint32(10).string(message.version);
    }

    if (message.controllerConnectionId !== "") {
      writer.uint32(18).string(message.controllerConnectionId);
    }

    if (message.hostConnectionId !== "") {
      writer.uint32(26).string(message.hostConnectionId);
    }

    if (message.address !== "") {
      writer.uint32(34).string(message.address);
    }

    if (message.encoding !== "") {
      writer.uint32(42).string(message.encoding);
    }

    if (message.txType !== "") {
      writer.uint32(50).string(message.txType);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = metadata_createBaseMetadata();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.version = reader.string();
          break;

        case 2:
          message.controllerConnectionId = reader.string();
          break;

        case 3:
          message.hostConnectionId = reader.string();
          break;

        case 4:
          message.address = reader.string();
          break;

        case 5:
          message.encoding = reader.string();
          break;

        case 6:
          message.txType = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$version, _object$controllerCon, _object$hostConnectio, _object$address, _object$encoding, _object$txType;

    const message = metadata_createBaseMetadata();
    message.version = (_object$version = object.version) !== null && _object$version !== void 0 ? _object$version : "";
    message.controllerConnectionId = (_object$controllerCon = object.controllerConnectionId) !== null && _object$controllerCon !== void 0 ? _object$controllerCon : "";
    message.hostConnectionId = (_object$hostConnectio = object.hostConnectionId) !== null && _object$hostConnectio !== void 0 ? _object$hostConnectio : "";
    message.address = (_object$address = object.address) !== null && _object$address !== void 0 ? _object$address : "";
    message.encoding = (_object$encoding = object.encoding) !== null && _object$encoding !== void 0 ? _object$encoding : "";
    message.txType = (_object$txType = object.txType) !== null && _object$txType !== void 0 ? _object$txType : "";
    return message;
  },

  fromAmino(object) {
    return {
      version: object.version,
      controllerConnectionId: object.controller_connection_id,
      hostConnectionId: object.host_connection_id,
      address: object.address,
      encoding: object.encoding,
      txType: object.tx_type
    };
  },

  toAmino(message) {
    const obj = {};
    obj.version = message.version;
    obj.controller_connection_id = message.controllerConnectionId;
    obj.host_connection_id = message.hostConnectionId;
    obj.address = message.address;
    obj.encoding = message.encoding;
    obj.tx_type = message.txType;
    return obj;
  },

  fromAminoMsg(object) {
    return metadata_Metadata.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/Metadata",
      value: metadata_Metadata.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return metadata_Metadata.decode(message.value);
  },

  toProto(message) {
    return metadata_Metadata.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.applications.interchain_accounts.v1.Metadata",
      value: metadata_Metadata.encode(message).finish()
    };
  }

};
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/ibc/applications/interchain_accounts/v1/packet.js
var packet = __webpack_require__(2088);
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/ibc/applications/transfer/v1/authz.js


/** Allocation defines the spend limit for a particular port and channel */

function createBaseAllocation() {
  return {
    sourcePort: "",
    sourceChannel: "",
    spendLimit: [],
    allowList: []
  };
}

const Allocation = {
  typeUrl: "/ibc.applications.transfer.v1.Allocation",

  encode(message, writer = minimal.Writer.create()) {
    if (message.sourcePort !== "") {
      writer.uint32(10).string(message.sourcePort);
    }

    if (message.sourceChannel !== "") {
      writer.uint32(18).string(message.sourceChannel);
    }

    for (const v of message.spendLimit) {
      coin.Coin.encode(v, writer.uint32(26).fork()).ldelim();
    }

    for (const v of message.allowList) {
      writer.uint32(34).string(v);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAllocation();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.sourcePort = reader.string();
          break;

        case 2:
          message.sourceChannel = reader.string();
          break;

        case 3:
          message.spendLimit.push(coin.Coin.decode(reader, reader.uint32()));
          break;

        case 4:
          message.allowList.push(reader.string());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$sourcePort, _object$sourceChannel, _object$spendLimit, _object$allowList;

    const message = createBaseAllocation();
    message.sourcePort = (_object$sourcePort = object.sourcePort) !== null && _object$sourcePort !== void 0 ? _object$sourcePort : "";
    message.sourceChannel = (_object$sourceChannel = object.sourceChannel) !== null && _object$sourceChannel !== void 0 ? _object$sourceChannel : "";
    message.spendLimit = ((_object$spendLimit = object.spendLimit) === null || _object$spendLimit === void 0 ? void 0 : _object$spendLimit.map(e => coin.Coin.fromPartial(e))) || [];
    message.allowList = ((_object$allowList = object.allowList) === null || _object$allowList === void 0 ? void 0 : _object$allowList.map(e => e)) || [];
    return message;
  },

  fromAmino(object) {
    return {
      sourcePort: object.source_port,
      sourceChannel: object.source_channel,
      spendLimit: Array.isArray(object === null || object === void 0 ? void 0 : object.spend_limit) ? object.spend_limit.map(e => coin.Coin.fromAmino(e)) : [],
      allowList: Array.isArray(object === null || object === void 0 ? void 0 : object.allow_list) ? object.allow_list.map(e => e) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.source_port = message.sourcePort;
    obj.source_channel = message.sourceChannel;

    if (message.spendLimit) {
      obj.spend_limit = message.spendLimit.map(e => e ? coin.Coin.toAmino(e) : undefined);
    } else {
      obj.spend_limit = [];
    }

    if (message.allowList) {
      obj.allow_list = message.allowList.map(e => e);
    } else {
      obj.allow_list = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return Allocation.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/Allocation",
      value: Allocation.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return Allocation.decode(message.value);
  },

  toProto(message) {
    return Allocation.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.applications.transfer.v1.Allocation",
      value: Allocation.encode(message).finish()
    };
  }

};

function createBaseTransferAuthorization() {
  return {
    $typeUrl: "/ibc.applications.transfer.v1.TransferAuthorization",
    allocations: []
  };
}

const TransferAuthorization = {
  typeUrl: "/ibc.applications.transfer.v1.TransferAuthorization",

  encode(message, writer = minimal.Writer.create()) {
    for (const v of message.allocations) {
      Allocation.encode(v, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTransferAuthorization();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.allocations.push(Allocation.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$allocations;

    const message = createBaseTransferAuthorization();
    message.allocations = ((_object$allocations = object.allocations) === null || _object$allocations === void 0 ? void 0 : _object$allocations.map(e => Allocation.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      allocations: Array.isArray(object === null || object === void 0 ? void 0 : object.allocations) ? object.allocations.map(e => Allocation.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.allocations) {
      obj.allocations = message.allocations.map(e => e ? Allocation.toAmino(e) : undefined);
    } else {
      obj.allocations = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return TransferAuthorization.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/TransferAuthorization",
      value: TransferAuthorization.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return TransferAuthorization.decode(message.value);
  },

  toProto(message) {
    return TransferAuthorization.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.applications.transfer.v1.TransferAuthorization",
      value: TransferAuthorization.encode(message).finish()
    };
  }

};
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/ibc/applications/transfer/v1/transfer.js
var v1_transfer = __webpack_require__(24845);
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/ibc/applications/transfer/v1/genesis.js


/** GenesisState defines the ibc-transfer genesis state */

function transfer_v1_genesis_createBaseGenesisState() {
  return {
    portId: "",
    denomTraces: [],
    params: undefined
  };
}

const transfer_v1_genesis_GenesisState = {
  typeUrl: "/ibc.applications.transfer.v1.GenesisState",

  encode(message, writer = minimal.Writer.create()) {
    if (message.portId !== "") {
      writer.uint32(10).string(message.portId);
    }

    for (const v of message.denomTraces) {
      v1_transfer.DenomTrace.encode(v, writer.uint32(18).fork()).ldelim();
    }

    if (message.params !== undefined) {
      v1_transfer.Params.encode(message.params, writer.uint32(26).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = transfer_v1_genesis_createBaseGenesisState();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.portId = reader.string();
          break;

        case 2:
          message.denomTraces.push(v1_transfer.DenomTrace.decode(reader, reader.uint32()));
          break;

        case 3:
          message.params = v1_transfer.Params.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$portId, _object$denomTraces;

    const message = transfer_v1_genesis_createBaseGenesisState();
    message.portId = (_object$portId = object.portId) !== null && _object$portId !== void 0 ? _object$portId : "";
    message.denomTraces = ((_object$denomTraces = object.denomTraces) === null || _object$denomTraces === void 0 ? void 0 : _object$denomTraces.map(e => v1_transfer.DenomTrace.fromPartial(e))) || [];
    message.params = object.params !== undefined && object.params !== null ? v1_transfer.Params.fromPartial(object.params) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      portId: object.port_id,
      denomTraces: Array.isArray(object === null || object === void 0 ? void 0 : object.denom_traces) ? object.denom_traces.map(e => v1_transfer.DenomTrace.fromAmino(e)) : [],
      params: object !== null && object !== void 0 && object.params ? v1_transfer.Params.fromAmino(object.params) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.port_id = message.portId;

    if (message.denomTraces) {
      obj.denom_traces = message.denomTraces.map(e => e ? v1_transfer.DenomTrace.toAmino(e) : undefined);
    } else {
      obj.denom_traces = [];
    }

    obj.params = message.params ? v1_transfer.Params.toAmino(message.params) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return transfer_v1_genesis_GenesisState.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/GenesisState",
      value: transfer_v1_genesis_GenesisState.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return transfer_v1_genesis_GenesisState.decode(message.value);
  },

  toProto(message) {
    return transfer_v1_genesis_GenesisState.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.applications.transfer.v1.GenesisState",
      value: transfer_v1_genesis_GenesisState.encode(message).finish()
    };
  }

};
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/ibc/applications/transfer/v1/query.js
var transfer_v1_query = __webpack_require__(87502);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/ibc/applications/transfer/v1/tx.js
var transfer_v1_tx = __webpack_require__(71016);
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/ibc/applications/transfer/v2/packet.js

/**
 * FungibleTokenPacketData defines a struct for the packet payload
 * See FungibleTokenPacketData spec:
 * https://github.com/cosmos/ibc/tree/master/spec/app/ics-020-fungible-token-transfer#data-structures
 */

function createBaseFungibleTokenPacketData() {
  return {
    denom: "",
    amount: "",
    sender: "",
    receiver: "",
    memo: ""
  };
}

const FungibleTokenPacketData = {
  typeUrl: "/ibc.applications.transfer.v2.FungibleTokenPacketData",

  encode(message, writer = minimal.Writer.create()) {
    if (message.denom !== "") {
      writer.uint32(10).string(message.denom);
    }

    if (message.amount !== "") {
      writer.uint32(18).string(message.amount);
    }

    if (message.sender !== "") {
      writer.uint32(26).string(message.sender);
    }

    if (message.receiver !== "") {
      writer.uint32(34).string(message.receiver);
    }

    if (message.memo !== "") {
      writer.uint32(42).string(message.memo);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFungibleTokenPacketData();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.denom = reader.string();
          break;

        case 2:
          message.amount = reader.string();
          break;

        case 3:
          message.sender = reader.string();
          break;

        case 4:
          message.receiver = reader.string();
          break;

        case 5:
          message.memo = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$denom, _object$amount, _object$sender, _object$receiver, _object$memo;

    const message = createBaseFungibleTokenPacketData();
    message.denom = (_object$denom = object.denom) !== null && _object$denom !== void 0 ? _object$denom : "";
    message.amount = (_object$amount = object.amount) !== null && _object$amount !== void 0 ? _object$amount : "";
    message.sender = (_object$sender = object.sender) !== null && _object$sender !== void 0 ? _object$sender : "";
    message.receiver = (_object$receiver = object.receiver) !== null && _object$receiver !== void 0 ? _object$receiver : "";
    message.memo = (_object$memo = object.memo) !== null && _object$memo !== void 0 ? _object$memo : "";
    return message;
  },

  fromAmino(object) {
    return {
      denom: object.denom,
      amount: object.amount,
      sender: object.sender,
      receiver: object.receiver,
      memo: object.memo
    };
  },

  toAmino(message) {
    const obj = {};
    obj.denom = message.denom;
    obj.amount = message.amount;
    obj.sender = message.sender;
    obj.receiver = message.receiver;
    obj.memo = message.memo;
    return obj;
  },

  fromAminoMsg(object) {
    return FungibleTokenPacketData.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/FungibleTokenPacketData",
      value: FungibleTokenPacketData.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return FungibleTokenPacketData.decode(message.value);
  },

  toProto(message) {
    return FungibleTokenPacketData.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.applications.transfer.v2.FungibleTokenPacketData",
      value: FungibleTokenPacketData.encode(message).finish()
    };
  }

};
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/ibc/core/channel/v1/channel.js
var v1_channel = __webpack_require__(53624);
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/ibc/core/channel/v1/genesis.js



/** GenesisState defines the ibc channel submodule's genesis state. */

function channel_v1_genesis_createBaseGenesisState() {
  return {
    channels: [],
    acknowledgements: [],
    commitments: [],
    receipts: [],
    sendSequences: [],
    recvSequences: [],
    ackSequences: [],
    nextChannelSequence: helpers/* Long.UZERO */.dK.UZERO
  };
}

const channel_v1_genesis_GenesisState = {
  typeUrl: "/ibc.core.channel.v1.GenesisState",

  encode(message, writer = minimal.Writer.create()) {
    for (const v of message.channels) {
      v1_channel.IdentifiedChannel.encode(v, writer.uint32(10).fork()).ldelim();
    }

    for (const v of message.acknowledgements) {
      v1_channel.PacketState.encode(v, writer.uint32(18).fork()).ldelim();
    }

    for (const v of message.commitments) {
      v1_channel.PacketState.encode(v, writer.uint32(26).fork()).ldelim();
    }

    for (const v of message.receipts) {
      v1_channel.PacketState.encode(v, writer.uint32(34).fork()).ldelim();
    }

    for (const v of message.sendSequences) {
      PacketSequence.encode(v, writer.uint32(42).fork()).ldelim();
    }

    for (const v of message.recvSequences) {
      PacketSequence.encode(v, writer.uint32(50).fork()).ldelim();
    }

    for (const v of message.ackSequences) {
      PacketSequence.encode(v, writer.uint32(58).fork()).ldelim();
    }

    if (!message.nextChannelSequence.isZero()) {
      writer.uint32(64).uint64(message.nextChannelSequence);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = channel_v1_genesis_createBaseGenesisState();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.channels.push(v1_channel.IdentifiedChannel.decode(reader, reader.uint32()));
          break;

        case 2:
          message.acknowledgements.push(v1_channel.PacketState.decode(reader, reader.uint32()));
          break;

        case 3:
          message.commitments.push(v1_channel.PacketState.decode(reader, reader.uint32()));
          break;

        case 4:
          message.receipts.push(v1_channel.PacketState.decode(reader, reader.uint32()));
          break;

        case 5:
          message.sendSequences.push(PacketSequence.decode(reader, reader.uint32()));
          break;

        case 6:
          message.recvSequences.push(PacketSequence.decode(reader, reader.uint32()));
          break;

        case 7:
          message.ackSequences.push(PacketSequence.decode(reader, reader.uint32()));
          break;

        case 8:
          message.nextChannelSequence = reader.uint64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$channels, _object$acknowledgeme, _object$commitments, _object$receipts, _object$sendSequences, _object$recvSequences, _object$ackSequences;

    const message = channel_v1_genesis_createBaseGenesisState();
    message.channels = ((_object$channels = object.channels) === null || _object$channels === void 0 ? void 0 : _object$channels.map(e => v1_channel.IdentifiedChannel.fromPartial(e))) || [];
    message.acknowledgements = ((_object$acknowledgeme = object.acknowledgements) === null || _object$acknowledgeme === void 0 ? void 0 : _object$acknowledgeme.map(e => v1_channel.PacketState.fromPartial(e))) || [];
    message.commitments = ((_object$commitments = object.commitments) === null || _object$commitments === void 0 ? void 0 : _object$commitments.map(e => v1_channel.PacketState.fromPartial(e))) || [];
    message.receipts = ((_object$receipts = object.receipts) === null || _object$receipts === void 0 ? void 0 : _object$receipts.map(e => v1_channel.PacketState.fromPartial(e))) || [];
    message.sendSequences = ((_object$sendSequences = object.sendSequences) === null || _object$sendSequences === void 0 ? void 0 : _object$sendSequences.map(e => PacketSequence.fromPartial(e))) || [];
    message.recvSequences = ((_object$recvSequences = object.recvSequences) === null || _object$recvSequences === void 0 ? void 0 : _object$recvSequences.map(e => PacketSequence.fromPartial(e))) || [];
    message.ackSequences = ((_object$ackSequences = object.ackSequences) === null || _object$ackSequences === void 0 ? void 0 : _object$ackSequences.map(e => PacketSequence.fromPartial(e))) || [];
    message.nextChannelSequence = object.nextChannelSequence !== undefined && object.nextChannelSequence !== null ? helpers/* Long.fromValue */.dK.fromValue(object.nextChannelSequence) : helpers/* Long.UZERO */.dK.UZERO;
    return message;
  },

  fromAmino(object) {
    return {
      channels: Array.isArray(object === null || object === void 0 ? void 0 : object.channels) ? object.channels.map(e => v1_channel.IdentifiedChannel.fromAmino(e)) : [],
      acknowledgements: Array.isArray(object === null || object === void 0 ? void 0 : object.acknowledgements) ? object.acknowledgements.map(e => v1_channel.PacketState.fromAmino(e)) : [],
      commitments: Array.isArray(object === null || object === void 0 ? void 0 : object.commitments) ? object.commitments.map(e => v1_channel.PacketState.fromAmino(e)) : [],
      receipts: Array.isArray(object === null || object === void 0 ? void 0 : object.receipts) ? object.receipts.map(e => v1_channel.PacketState.fromAmino(e)) : [],
      sendSequences: Array.isArray(object === null || object === void 0 ? void 0 : object.send_sequences) ? object.send_sequences.map(e => PacketSequence.fromAmino(e)) : [],
      recvSequences: Array.isArray(object === null || object === void 0 ? void 0 : object.recv_sequences) ? object.recv_sequences.map(e => PacketSequence.fromAmino(e)) : [],
      ackSequences: Array.isArray(object === null || object === void 0 ? void 0 : object.ack_sequences) ? object.ack_sequences.map(e => PacketSequence.fromAmino(e)) : [],
      nextChannelSequence: helpers/* Long.fromString */.dK.fromString(object.next_channel_sequence)
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.channels) {
      obj.channels = message.channels.map(e => e ? v1_channel.IdentifiedChannel.toAmino(e) : undefined);
    } else {
      obj.channels = [];
    }

    if (message.acknowledgements) {
      obj.acknowledgements = message.acknowledgements.map(e => e ? v1_channel.PacketState.toAmino(e) : undefined);
    } else {
      obj.acknowledgements = [];
    }

    if (message.commitments) {
      obj.commitments = message.commitments.map(e => e ? v1_channel.PacketState.toAmino(e) : undefined);
    } else {
      obj.commitments = [];
    }

    if (message.receipts) {
      obj.receipts = message.receipts.map(e => e ? v1_channel.PacketState.toAmino(e) : undefined);
    } else {
      obj.receipts = [];
    }

    if (message.sendSequences) {
      obj.send_sequences = message.sendSequences.map(e => e ? PacketSequence.toAmino(e) : undefined);
    } else {
      obj.send_sequences = [];
    }

    if (message.recvSequences) {
      obj.recv_sequences = message.recvSequences.map(e => e ? PacketSequence.toAmino(e) : undefined);
    } else {
      obj.recv_sequences = [];
    }

    if (message.ackSequences) {
      obj.ack_sequences = message.ackSequences.map(e => e ? PacketSequence.toAmino(e) : undefined);
    } else {
      obj.ack_sequences = [];
    }

    obj.next_channel_sequence = message.nextChannelSequence ? message.nextChannelSequence.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return channel_v1_genesis_GenesisState.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/GenesisState",
      value: channel_v1_genesis_GenesisState.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return channel_v1_genesis_GenesisState.decode(message.value);
  },

  toProto(message) {
    return channel_v1_genesis_GenesisState.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.channel.v1.GenesisState",
      value: channel_v1_genesis_GenesisState.encode(message).finish()
    };
  }

};

function createBasePacketSequence() {
  return {
    portId: "",
    channelId: "",
    sequence: helpers/* Long.UZERO */.dK.UZERO
  };
}

const PacketSequence = {
  typeUrl: "/ibc.core.channel.v1.PacketSequence",

  encode(message, writer = minimal.Writer.create()) {
    if (message.portId !== "") {
      writer.uint32(10).string(message.portId);
    }

    if (message.channelId !== "") {
      writer.uint32(18).string(message.channelId);
    }

    if (!message.sequence.isZero()) {
      writer.uint32(24).uint64(message.sequence);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePacketSequence();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.portId = reader.string();
          break;

        case 2:
          message.channelId = reader.string();
          break;

        case 3:
          message.sequence = reader.uint64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$portId, _object$channelId;

    const message = createBasePacketSequence();
    message.portId = (_object$portId = object.portId) !== null && _object$portId !== void 0 ? _object$portId : "";
    message.channelId = (_object$channelId = object.channelId) !== null && _object$channelId !== void 0 ? _object$channelId : "";
    message.sequence = object.sequence !== undefined && object.sequence !== null ? helpers/* Long.fromValue */.dK.fromValue(object.sequence) : helpers/* Long.UZERO */.dK.UZERO;
    return message;
  },

  fromAmino(object) {
    return {
      portId: object.port_id,
      channelId: object.channel_id,
      sequence: helpers/* Long.fromString */.dK.fromString(object.sequence)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.port_id = message.portId;
    obj.channel_id = message.channelId;
    obj.sequence = message.sequence ? message.sequence.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return PacketSequence.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/PacketSequence",
      value: PacketSequence.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return PacketSequence.decode(message.value);
  },

  toProto(message) {
    return PacketSequence.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.channel.v1.PacketSequence",
      value: PacketSequence.encode(message).finish()
    };
  }

};
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/ibc/core/channel/v1/query.js
var channel_v1_query = __webpack_require__(28397);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/ibc/core/channel/v1/tx.js
var channel_v1_tx = __webpack_require__(63239);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/ibc/core/client/v1/client.js
var v1_client = __webpack_require__(45802);
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/ibc/core/client/v1/genesis.js



/** GenesisState defines the ibc client submodule's genesis state. */

function client_v1_genesis_createBaseGenesisState() {
  return {
    clients: [],
    clientsConsensus: [],
    clientsMetadata: [],
    params: undefined,
    createLocalhost: false,
    nextClientSequence: helpers/* Long.UZERO */.dK.UZERO
  };
}

const client_v1_genesis_GenesisState = {
  typeUrl: "/ibc.core.client.v1.GenesisState",

  encode(message, writer = minimal.Writer.create()) {
    for (const v of message.clients) {
      v1_client.IdentifiedClientState.encode(v, writer.uint32(10).fork()).ldelim();
    }

    for (const v of message.clientsConsensus) {
      v1_client.ClientConsensusStates.encode(v, writer.uint32(18).fork()).ldelim();
    }

    for (const v of message.clientsMetadata) {
      IdentifiedGenesisMetadata.encode(v, writer.uint32(26).fork()).ldelim();
    }

    if (message.params !== undefined) {
      v1_client.Params.encode(message.params, writer.uint32(34).fork()).ldelim();
    }

    if (message.createLocalhost === true) {
      writer.uint32(40).bool(message.createLocalhost);
    }

    if (!message.nextClientSequence.isZero()) {
      writer.uint32(48).uint64(message.nextClientSequence);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = client_v1_genesis_createBaseGenesisState();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.clients.push(v1_client.IdentifiedClientState.decode(reader, reader.uint32()));
          break;

        case 2:
          message.clientsConsensus.push(v1_client.ClientConsensusStates.decode(reader, reader.uint32()));
          break;

        case 3:
          message.clientsMetadata.push(IdentifiedGenesisMetadata.decode(reader, reader.uint32()));
          break;

        case 4:
          message.params = v1_client.Params.decode(reader, reader.uint32());
          break;

        case 5:
          message.createLocalhost = reader.bool();
          break;

        case 6:
          message.nextClientSequence = reader.uint64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$clients, _object$clientsConsen, _object$clientsMetada, _object$createLocalho;

    const message = client_v1_genesis_createBaseGenesisState();
    message.clients = ((_object$clients = object.clients) === null || _object$clients === void 0 ? void 0 : _object$clients.map(e => v1_client.IdentifiedClientState.fromPartial(e))) || [];
    message.clientsConsensus = ((_object$clientsConsen = object.clientsConsensus) === null || _object$clientsConsen === void 0 ? void 0 : _object$clientsConsen.map(e => v1_client.ClientConsensusStates.fromPartial(e))) || [];
    message.clientsMetadata = ((_object$clientsMetada = object.clientsMetadata) === null || _object$clientsMetada === void 0 ? void 0 : _object$clientsMetada.map(e => IdentifiedGenesisMetadata.fromPartial(e))) || [];
    message.params = object.params !== undefined && object.params !== null ? v1_client.Params.fromPartial(object.params) : undefined;
    message.createLocalhost = (_object$createLocalho = object.createLocalhost) !== null && _object$createLocalho !== void 0 ? _object$createLocalho : false;
    message.nextClientSequence = object.nextClientSequence !== undefined && object.nextClientSequence !== null ? helpers/* Long.fromValue */.dK.fromValue(object.nextClientSequence) : helpers/* Long.UZERO */.dK.UZERO;
    return message;
  },

  fromAmino(object) {
    return {
      clients: Array.isArray(object === null || object === void 0 ? void 0 : object.clients) ? object.clients.map(e => v1_client.IdentifiedClientState.fromAmino(e)) : [],
      clientsConsensus: Array.isArray(object === null || object === void 0 ? void 0 : object.clients_consensus) ? object.clients_consensus.map(e => v1_client.ClientConsensusStates.fromAmino(e)) : [],
      clientsMetadata: Array.isArray(object === null || object === void 0 ? void 0 : object.clients_metadata) ? object.clients_metadata.map(e => IdentifiedGenesisMetadata.fromAmino(e)) : [],
      params: object !== null && object !== void 0 && object.params ? v1_client.Params.fromAmino(object.params) : undefined,
      createLocalhost: object.create_localhost,
      nextClientSequence: helpers/* Long.fromString */.dK.fromString(object.next_client_sequence)
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.clients) {
      obj.clients = message.clients.map(e => e ? v1_client.IdentifiedClientState.toAmino(e) : undefined);
    } else {
      obj.clients = [];
    }

    if (message.clientsConsensus) {
      obj.clients_consensus = message.clientsConsensus.map(e => e ? v1_client.ClientConsensusStates.toAmino(e) : undefined);
    } else {
      obj.clients_consensus = [];
    }

    if (message.clientsMetadata) {
      obj.clients_metadata = message.clientsMetadata.map(e => e ? IdentifiedGenesisMetadata.toAmino(e) : undefined);
    } else {
      obj.clients_metadata = [];
    }

    obj.params = message.params ? v1_client.Params.toAmino(message.params) : undefined;
    obj.create_localhost = message.createLocalhost;
    obj.next_client_sequence = message.nextClientSequence ? message.nextClientSequence.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return client_v1_genesis_GenesisState.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/GenesisState",
      value: client_v1_genesis_GenesisState.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return client_v1_genesis_GenesisState.decode(message.value);
  },

  toProto(message) {
    return client_v1_genesis_GenesisState.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.client.v1.GenesisState",
      value: client_v1_genesis_GenesisState.encode(message).finish()
    };
  }

};

function createBaseGenesisMetadata() {
  return {
    key: new Uint8Array(),
    value: new Uint8Array()
  };
}

const GenesisMetadata = {
  typeUrl: "/ibc.core.client.v1.GenesisMetadata",

  encode(message, writer = minimal.Writer.create()) {
    if (message.key.length !== 0) {
      writer.uint32(10).bytes(message.key);
    }

    if (message.value.length !== 0) {
      writer.uint32(18).bytes(message.value);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGenesisMetadata();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.key = reader.bytes();
          break;

        case 2:
          message.value = reader.bytes();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$key, _object$value;

    const message = createBaseGenesisMetadata();
    message.key = (_object$key = object.key) !== null && _object$key !== void 0 ? _object$key : new Uint8Array();
    message.value = (_object$value = object.value) !== null && _object$value !== void 0 ? _object$value : new Uint8Array();
    return message;
  },

  fromAmino(object) {
    return {
      key: object.key,
      value: object.value
    };
  },

  toAmino(message) {
    const obj = {};
    obj.key = message.key;
    obj.value = message.value;
    return obj;
  },

  fromAminoMsg(object) {
    return GenesisMetadata.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/GenesisMetadata",
      value: GenesisMetadata.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return GenesisMetadata.decode(message.value);
  },

  toProto(message) {
    return GenesisMetadata.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.client.v1.GenesisMetadata",
      value: GenesisMetadata.encode(message).finish()
    };
  }

};

function createBaseIdentifiedGenesisMetadata() {
  return {
    clientId: "",
    clientMetadata: []
  };
}

const IdentifiedGenesisMetadata = {
  typeUrl: "/ibc.core.client.v1.IdentifiedGenesisMetadata",

  encode(message, writer = minimal.Writer.create()) {
    if (message.clientId !== "") {
      writer.uint32(10).string(message.clientId);
    }

    for (const v of message.clientMetadata) {
      GenesisMetadata.encode(v, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseIdentifiedGenesisMetadata();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.clientId = reader.string();
          break;

        case 2:
          message.clientMetadata.push(GenesisMetadata.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$clientId, _object$clientMetadat;

    const message = createBaseIdentifiedGenesisMetadata();
    message.clientId = (_object$clientId = object.clientId) !== null && _object$clientId !== void 0 ? _object$clientId : "";
    message.clientMetadata = ((_object$clientMetadat = object.clientMetadata) === null || _object$clientMetadat === void 0 ? void 0 : _object$clientMetadat.map(e => GenesisMetadata.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      clientId: object.client_id,
      clientMetadata: Array.isArray(object === null || object === void 0 ? void 0 : object.client_metadata) ? object.client_metadata.map(e => GenesisMetadata.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.client_id = message.clientId;

    if (message.clientMetadata) {
      obj.client_metadata = message.clientMetadata.map(e => e ? GenesisMetadata.toAmino(e) : undefined);
    } else {
      obj.client_metadata = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return IdentifiedGenesisMetadata.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/IdentifiedGenesisMetadata",
      value: IdentifiedGenesisMetadata.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return IdentifiedGenesisMetadata.decode(message.value);
  },

  toProto(message) {
    return IdentifiedGenesisMetadata.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.client.v1.IdentifiedGenesisMetadata",
      value: IdentifiedGenesisMetadata.encode(message).finish()
    };
  }

};
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/ibc/core/client/v1/query.js
var client_v1_query = __webpack_require__(95638);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/ibc/core/client/v1/tx.js
var client_v1_tx = __webpack_require__(33550);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/ibc/core/commitment/v1/commitment.js
var v1_commitment = __webpack_require__(48768);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/ibc/core/connection/v1/connection.js
var v1_connection = __webpack_require__(14659);
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/ibc/core/connection/v1/genesis.js



/** GenesisState defines the ibc connection submodule's genesis state. */

function connection_v1_genesis_createBaseGenesisState() {
  return {
    connections: [],
    clientConnectionPaths: [],
    nextConnectionSequence: helpers/* Long.UZERO */.dK.UZERO,
    params: undefined
  };
}

const connection_v1_genesis_GenesisState = {
  typeUrl: "/ibc.core.connection.v1.GenesisState",

  encode(message, writer = minimal.Writer.create()) {
    for (const v of message.connections) {
      v1_connection.IdentifiedConnection.encode(v, writer.uint32(10).fork()).ldelim();
    }

    for (const v of message.clientConnectionPaths) {
      v1_connection.ConnectionPaths.encode(v, writer.uint32(18).fork()).ldelim();
    }

    if (!message.nextConnectionSequence.isZero()) {
      writer.uint32(24).uint64(message.nextConnectionSequence);
    }

    if (message.params !== undefined) {
      v1_connection.Params.encode(message.params, writer.uint32(34).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = connection_v1_genesis_createBaseGenesisState();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.connections.push(v1_connection.IdentifiedConnection.decode(reader, reader.uint32()));
          break;

        case 2:
          message.clientConnectionPaths.push(v1_connection.ConnectionPaths.decode(reader, reader.uint32()));
          break;

        case 3:
          message.nextConnectionSequence = reader.uint64();
          break;

        case 4:
          message.params = v1_connection.Params.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$connections, _object$clientConnect;

    const message = connection_v1_genesis_createBaseGenesisState();
    message.connections = ((_object$connections = object.connections) === null || _object$connections === void 0 ? void 0 : _object$connections.map(e => v1_connection.IdentifiedConnection.fromPartial(e))) || [];
    message.clientConnectionPaths = ((_object$clientConnect = object.clientConnectionPaths) === null || _object$clientConnect === void 0 ? void 0 : _object$clientConnect.map(e => v1_connection.ConnectionPaths.fromPartial(e))) || [];
    message.nextConnectionSequence = object.nextConnectionSequence !== undefined && object.nextConnectionSequence !== null ? helpers/* Long.fromValue */.dK.fromValue(object.nextConnectionSequence) : helpers/* Long.UZERO */.dK.UZERO;
    message.params = object.params !== undefined && object.params !== null ? v1_connection.Params.fromPartial(object.params) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      connections: Array.isArray(object === null || object === void 0 ? void 0 : object.connections) ? object.connections.map(e => v1_connection.IdentifiedConnection.fromAmino(e)) : [],
      clientConnectionPaths: Array.isArray(object === null || object === void 0 ? void 0 : object.client_connection_paths) ? object.client_connection_paths.map(e => v1_connection.ConnectionPaths.fromAmino(e)) : [],
      nextConnectionSequence: helpers/* Long.fromString */.dK.fromString(object.next_connection_sequence),
      params: object !== null && object !== void 0 && object.params ? v1_connection.Params.fromAmino(object.params) : undefined
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.connections) {
      obj.connections = message.connections.map(e => e ? v1_connection.IdentifiedConnection.toAmino(e) : undefined);
    } else {
      obj.connections = [];
    }

    if (message.clientConnectionPaths) {
      obj.client_connection_paths = message.clientConnectionPaths.map(e => e ? v1_connection.ConnectionPaths.toAmino(e) : undefined);
    } else {
      obj.client_connection_paths = [];
    }

    obj.next_connection_sequence = message.nextConnectionSequence ? message.nextConnectionSequence.toString() : undefined;
    obj.params = message.params ? v1_connection.Params.toAmino(message.params) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return connection_v1_genesis_GenesisState.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/GenesisState",
      value: connection_v1_genesis_GenesisState.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return connection_v1_genesis_GenesisState.decode(message.value);
  },

  toProto(message) {
    return connection_v1_genesis_GenesisState.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.core.connection.v1.GenesisState",
      value: connection_v1_genesis_GenesisState.encode(message).finish()
    };
  }

};
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/ibc/core/connection/v1/query.js
var connection_v1_query = __webpack_require__(44266);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/ibc/core/connection/v1/tx.js
var connection_v1_tx = __webpack_require__(35111);
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/ibc/lightclients/localhost/v2/localhost.js


/** ClientState defines the 09-localhost client state */

function createBaseClientState() {
  return {
    latestHeight: undefined
  };
}

const ClientState = {
  typeUrl: "/ibc.lightclients.localhost.v2.ClientState",

  encode(message, writer = minimal.Writer.create()) {
    if (message.latestHeight !== undefined) {
      v1_client.Height.encode(message.latestHeight, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseClientState();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.latestHeight = v1_client.Height.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseClientState();
    message.latestHeight = object.latestHeight !== undefined && object.latestHeight !== null ? v1_client.Height.fromPartial(object.latestHeight) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      latestHeight: object !== null && object !== void 0 && object.latest_height ? v1_client.Height.fromAmino(object.latest_height) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.latest_height = message.latestHeight ? v1_client.Height.toAmino(message.latestHeight) : {};
    return obj;
  },

  fromAminoMsg(object) {
    return ClientState.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/ClientState",
      value: ClientState.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return ClientState.decode(message.value);
  },

  toProto(message) {
    return ClientState.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.lightclients.localhost.v2.ClientState",
      value: ClientState.encode(message).finish()
    };
  }

};
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/ibc/lightclients/solomachine/v2/solomachine.js





/**
 * DataType defines the type of solo machine proof being created. This is done
 * to preserve uniqueness of different data sign byte encodings.
 */

let DataType;

(function (DataType) {
  DataType[DataType["DATA_TYPE_UNINITIALIZED_UNSPECIFIED"] = 0] = "DATA_TYPE_UNINITIALIZED_UNSPECIFIED";
  DataType[DataType["DATA_TYPE_CLIENT_STATE"] = 1] = "DATA_TYPE_CLIENT_STATE";
  DataType[DataType["DATA_TYPE_CONSENSUS_STATE"] = 2] = "DATA_TYPE_CONSENSUS_STATE";
  DataType[DataType["DATA_TYPE_CONNECTION_STATE"] = 3] = "DATA_TYPE_CONNECTION_STATE";
  DataType[DataType["DATA_TYPE_CHANNEL_STATE"] = 4] = "DATA_TYPE_CHANNEL_STATE";
  DataType[DataType["DATA_TYPE_PACKET_COMMITMENT"] = 5] = "DATA_TYPE_PACKET_COMMITMENT";
  DataType[DataType["DATA_TYPE_PACKET_ACKNOWLEDGEMENT"] = 6] = "DATA_TYPE_PACKET_ACKNOWLEDGEMENT";
  DataType[DataType["DATA_TYPE_PACKET_RECEIPT_ABSENCE"] = 7] = "DATA_TYPE_PACKET_RECEIPT_ABSENCE";
  DataType[DataType["DATA_TYPE_NEXT_SEQUENCE_RECV"] = 8] = "DATA_TYPE_NEXT_SEQUENCE_RECV";
  DataType[DataType["DATA_TYPE_HEADER"] = 9] = "DATA_TYPE_HEADER";
  DataType[DataType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(DataType || (DataType = {}));

const DataTypeSDKType = DataType;
const DataTypeAmino = DataType;
function dataTypeFromJSON(object) {
  switch (object) {
    case 0:
    case "DATA_TYPE_UNINITIALIZED_UNSPECIFIED":
      return DataType.DATA_TYPE_UNINITIALIZED_UNSPECIFIED;

    case 1:
    case "DATA_TYPE_CLIENT_STATE":
      return DataType.DATA_TYPE_CLIENT_STATE;

    case 2:
    case "DATA_TYPE_CONSENSUS_STATE":
      return DataType.DATA_TYPE_CONSENSUS_STATE;

    case 3:
    case "DATA_TYPE_CONNECTION_STATE":
      return DataType.DATA_TYPE_CONNECTION_STATE;

    case 4:
    case "DATA_TYPE_CHANNEL_STATE":
      return DataType.DATA_TYPE_CHANNEL_STATE;

    case 5:
    case "DATA_TYPE_PACKET_COMMITMENT":
      return DataType.DATA_TYPE_PACKET_COMMITMENT;

    case 6:
    case "DATA_TYPE_PACKET_ACKNOWLEDGEMENT":
      return DataType.DATA_TYPE_PACKET_ACKNOWLEDGEMENT;

    case 7:
    case "DATA_TYPE_PACKET_RECEIPT_ABSENCE":
      return DataType.DATA_TYPE_PACKET_RECEIPT_ABSENCE;

    case 8:
    case "DATA_TYPE_NEXT_SEQUENCE_RECV":
      return DataType.DATA_TYPE_NEXT_SEQUENCE_RECV;

    case 9:
    case "DATA_TYPE_HEADER":
      return DataType.DATA_TYPE_HEADER;

    case -1:
    case "UNRECOGNIZED":
    default:
      return DataType.UNRECOGNIZED;
  }
}
function dataTypeToJSON(object) {
  switch (object) {
    case DataType.DATA_TYPE_UNINITIALIZED_UNSPECIFIED:
      return "DATA_TYPE_UNINITIALIZED_UNSPECIFIED";

    case DataType.DATA_TYPE_CLIENT_STATE:
      return "DATA_TYPE_CLIENT_STATE";

    case DataType.DATA_TYPE_CONSENSUS_STATE:
      return "DATA_TYPE_CONSENSUS_STATE";

    case DataType.DATA_TYPE_CONNECTION_STATE:
      return "DATA_TYPE_CONNECTION_STATE";

    case DataType.DATA_TYPE_CHANNEL_STATE:
      return "DATA_TYPE_CHANNEL_STATE";

    case DataType.DATA_TYPE_PACKET_COMMITMENT:
      return "DATA_TYPE_PACKET_COMMITMENT";

    case DataType.DATA_TYPE_PACKET_ACKNOWLEDGEMENT:
      return "DATA_TYPE_PACKET_ACKNOWLEDGEMENT";

    case DataType.DATA_TYPE_PACKET_RECEIPT_ABSENCE:
      return "DATA_TYPE_PACKET_RECEIPT_ABSENCE";

    case DataType.DATA_TYPE_NEXT_SEQUENCE_RECV:
      return "DATA_TYPE_NEXT_SEQUENCE_RECV";

    case DataType.DATA_TYPE_HEADER:
      return "DATA_TYPE_HEADER";

    case DataType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
/**
 * ClientState defines a solo machine client that tracks the current consensus
 * state and if the client is frozen.
 */

function solomachine_createBaseClientState() {
  return {
    sequence: helpers/* Long.UZERO */.dK.UZERO,
    isFrozen: false,
    consensusState: undefined,
    allowUpdateAfterProposal: false
  };
}

const solomachine_ClientState = {
  typeUrl: "/ibc.lightclients.solomachine.v2.ClientState",

  encode(message, writer = minimal.Writer.create()) {
    if (!message.sequence.isZero()) {
      writer.uint32(8).uint64(message.sequence);
    }

    if (message.isFrozen === true) {
      writer.uint32(16).bool(message.isFrozen);
    }

    if (message.consensusState !== undefined) {
      ConsensusState.encode(message.consensusState, writer.uint32(26).fork()).ldelim();
    }

    if (message.allowUpdateAfterProposal === true) {
      writer.uint32(32).bool(message.allowUpdateAfterProposal);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = solomachine_createBaseClientState();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.sequence = reader.uint64();
          break;

        case 2:
          message.isFrozen = reader.bool();
          break;

        case 3:
          message.consensusState = ConsensusState.decode(reader, reader.uint32());
          break;

        case 4:
          message.allowUpdateAfterProposal = reader.bool();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$isFrozen, _object$allowUpdateAf;

    const message = solomachine_createBaseClientState();
    message.sequence = object.sequence !== undefined && object.sequence !== null ? helpers/* Long.fromValue */.dK.fromValue(object.sequence) : helpers/* Long.UZERO */.dK.UZERO;
    message.isFrozen = (_object$isFrozen = object.isFrozen) !== null && _object$isFrozen !== void 0 ? _object$isFrozen : false;
    message.consensusState = object.consensusState !== undefined && object.consensusState !== null ? ConsensusState.fromPartial(object.consensusState) : undefined;
    message.allowUpdateAfterProposal = (_object$allowUpdateAf = object.allowUpdateAfterProposal) !== null && _object$allowUpdateAf !== void 0 ? _object$allowUpdateAf : false;
    return message;
  },

  fromAmino(object) {
    return {
      sequence: helpers/* Long.fromString */.dK.fromString(object.sequence),
      isFrozen: object.is_frozen,
      consensusState: object !== null && object !== void 0 && object.consensus_state ? ConsensusState.fromAmino(object.consensus_state) : undefined,
      allowUpdateAfterProposal: object.allow_update_after_proposal
    };
  },

  toAmino(message) {
    const obj = {};
    obj.sequence = message.sequence ? message.sequence.toString() : undefined;
    obj.is_frozen = message.isFrozen;
    obj.consensus_state = message.consensusState ? ConsensusState.toAmino(message.consensusState) : undefined;
    obj.allow_update_after_proposal = message.allowUpdateAfterProposal;
    return obj;
  },

  fromAminoMsg(object) {
    return solomachine_ClientState.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/ClientState",
      value: solomachine_ClientState.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return solomachine_ClientState.decode(message.value);
  },

  toProto(message) {
    return solomachine_ClientState.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.lightclients.solomachine.v2.ClientState",
      value: solomachine_ClientState.encode(message).finish()
    };
  }

};

function createBaseConsensusState() {
  return {
    publicKey: undefined,
    diversifier: "",
    timestamp: helpers/* Long.UZERO */.dK.UZERO
  };
}

const ConsensusState = {
  typeUrl: "/ibc.lightclients.solomachine.v2.ConsensusState",

  encode(message, writer = minimal.Writer.create()) {
    if (message.publicKey !== undefined) {
      any.Any.encode(message.publicKey, writer.uint32(10).fork()).ldelim();
    }

    if (message.diversifier !== "") {
      writer.uint32(18).string(message.diversifier);
    }

    if (!message.timestamp.isZero()) {
      writer.uint32(24).uint64(message.timestamp);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseConsensusState();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.publicKey = any.Any.decode(reader, reader.uint32());
          break;

        case 2:
          message.diversifier = reader.string();
          break;

        case 3:
          message.timestamp = reader.uint64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$diversifier;

    const message = createBaseConsensusState();
    message.publicKey = object.publicKey !== undefined && object.publicKey !== null ? any.Any.fromPartial(object.publicKey) : undefined;
    message.diversifier = (_object$diversifier = object.diversifier) !== null && _object$diversifier !== void 0 ? _object$diversifier : "";
    message.timestamp = object.timestamp !== undefined && object.timestamp !== null ? helpers/* Long.fromValue */.dK.fromValue(object.timestamp) : helpers/* Long.UZERO */.dK.UZERO;
    return message;
  },

  fromAmino(object) {
    return {
      publicKey: object !== null && object !== void 0 && object.public_key ? any.Any.fromAmino(object.public_key) : undefined,
      diversifier: object.diversifier,
      timestamp: helpers/* Long.fromString */.dK.fromString(object.timestamp)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.public_key = message.publicKey ? any.Any.toAmino(message.publicKey) : undefined;
    obj.diversifier = message.diversifier;
    obj.timestamp = message.timestamp ? message.timestamp.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return ConsensusState.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/ConsensusState",
      value: ConsensusState.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return ConsensusState.decode(message.value);
  },

  toProto(message) {
    return ConsensusState.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.lightclients.solomachine.v2.ConsensusState",
      value: ConsensusState.encode(message).finish()
    };
  }

};

function createBaseHeader() {
  return {
    sequence: helpers/* Long.UZERO */.dK.UZERO,
    timestamp: helpers/* Long.UZERO */.dK.UZERO,
    signature: new Uint8Array(),
    newPublicKey: undefined,
    newDiversifier: ""
  };
}

const Header = {
  typeUrl: "/ibc.lightclients.solomachine.v2.Header",

  encode(message, writer = minimal.Writer.create()) {
    if (!message.sequence.isZero()) {
      writer.uint32(8).uint64(message.sequence);
    }

    if (!message.timestamp.isZero()) {
      writer.uint32(16).uint64(message.timestamp);
    }

    if (message.signature.length !== 0) {
      writer.uint32(26).bytes(message.signature);
    }

    if (message.newPublicKey !== undefined) {
      any.Any.encode(message.newPublicKey, writer.uint32(34).fork()).ldelim();
    }

    if (message.newDiversifier !== "") {
      writer.uint32(42).string(message.newDiversifier);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseHeader();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.sequence = reader.uint64();
          break;

        case 2:
          message.timestamp = reader.uint64();
          break;

        case 3:
          message.signature = reader.bytes();
          break;

        case 4:
          message.newPublicKey = any.Any.decode(reader, reader.uint32());
          break;

        case 5:
          message.newDiversifier = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$signature, _object$newDiversifie;

    const message = createBaseHeader();
    message.sequence = object.sequence !== undefined && object.sequence !== null ? helpers/* Long.fromValue */.dK.fromValue(object.sequence) : helpers/* Long.UZERO */.dK.UZERO;
    message.timestamp = object.timestamp !== undefined && object.timestamp !== null ? helpers/* Long.fromValue */.dK.fromValue(object.timestamp) : helpers/* Long.UZERO */.dK.UZERO;
    message.signature = (_object$signature = object.signature) !== null && _object$signature !== void 0 ? _object$signature : new Uint8Array();
    message.newPublicKey = object.newPublicKey !== undefined && object.newPublicKey !== null ? any.Any.fromPartial(object.newPublicKey) : undefined;
    message.newDiversifier = (_object$newDiversifie = object.newDiversifier) !== null && _object$newDiversifie !== void 0 ? _object$newDiversifie : "";
    return message;
  },

  fromAmino(object) {
    return {
      sequence: helpers/* Long.fromString */.dK.fromString(object.sequence),
      timestamp: helpers/* Long.fromString */.dK.fromString(object.timestamp),
      signature: object.signature,
      newPublicKey: object !== null && object !== void 0 && object.new_public_key ? any.Any.fromAmino(object.new_public_key) : undefined,
      newDiversifier: object.new_diversifier
    };
  },

  toAmino(message) {
    const obj = {};
    obj.sequence = message.sequence ? message.sequence.toString() : undefined;
    obj.timestamp = message.timestamp ? message.timestamp.toString() : undefined;
    obj.signature = message.signature;
    obj.new_public_key = message.newPublicKey ? any.Any.toAmino(message.newPublicKey) : undefined;
    obj.new_diversifier = message.newDiversifier;
    return obj;
  },

  fromAminoMsg(object) {
    return Header.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/Header",
      value: Header.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return Header.decode(message.value);
  },

  toProto(message) {
    return Header.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.lightclients.solomachine.v2.Header",
      value: Header.encode(message).finish()
    };
  }

};

function createBaseMisbehaviour() {
  return {
    clientId: "",
    sequence: helpers/* Long.UZERO */.dK.UZERO,
    signatureOne: undefined,
    signatureTwo: undefined
  };
}

const Misbehaviour = {
  typeUrl: "/ibc.lightclients.solomachine.v2.Misbehaviour",

  encode(message, writer = minimal.Writer.create()) {
    if (message.clientId !== "") {
      writer.uint32(10).string(message.clientId);
    }

    if (!message.sequence.isZero()) {
      writer.uint32(16).uint64(message.sequence);
    }

    if (message.signatureOne !== undefined) {
      SignatureAndData.encode(message.signatureOne, writer.uint32(26).fork()).ldelim();
    }

    if (message.signatureTwo !== undefined) {
      SignatureAndData.encode(message.signatureTwo, writer.uint32(34).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMisbehaviour();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.clientId = reader.string();
          break;

        case 2:
          message.sequence = reader.uint64();
          break;

        case 3:
          message.signatureOne = SignatureAndData.decode(reader, reader.uint32());
          break;

        case 4:
          message.signatureTwo = SignatureAndData.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$clientId;

    const message = createBaseMisbehaviour();
    message.clientId = (_object$clientId = object.clientId) !== null && _object$clientId !== void 0 ? _object$clientId : "";
    message.sequence = object.sequence !== undefined && object.sequence !== null ? helpers/* Long.fromValue */.dK.fromValue(object.sequence) : helpers/* Long.UZERO */.dK.UZERO;
    message.signatureOne = object.signatureOne !== undefined && object.signatureOne !== null ? SignatureAndData.fromPartial(object.signatureOne) : undefined;
    message.signatureTwo = object.signatureTwo !== undefined && object.signatureTwo !== null ? SignatureAndData.fromPartial(object.signatureTwo) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      clientId: object.client_id,
      sequence: helpers/* Long.fromString */.dK.fromString(object.sequence),
      signatureOne: object !== null && object !== void 0 && object.signature_one ? SignatureAndData.fromAmino(object.signature_one) : undefined,
      signatureTwo: object !== null && object !== void 0 && object.signature_two ? SignatureAndData.fromAmino(object.signature_two) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.client_id = message.clientId;
    obj.sequence = message.sequence ? message.sequence.toString() : undefined;
    obj.signature_one = message.signatureOne ? SignatureAndData.toAmino(message.signatureOne) : undefined;
    obj.signature_two = message.signatureTwo ? SignatureAndData.toAmino(message.signatureTwo) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return Misbehaviour.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/Misbehaviour",
      value: Misbehaviour.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return Misbehaviour.decode(message.value);
  },

  toProto(message) {
    return Misbehaviour.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.lightclients.solomachine.v2.Misbehaviour",
      value: Misbehaviour.encode(message).finish()
    };
  }

};

function createBaseSignatureAndData() {
  return {
    signature: new Uint8Array(),
    dataType: 0,
    data: new Uint8Array(),
    timestamp: helpers/* Long.UZERO */.dK.UZERO
  };
}

const SignatureAndData = {
  typeUrl: "/ibc.lightclients.solomachine.v2.SignatureAndData",

  encode(message, writer = minimal.Writer.create()) {
    if (message.signature.length !== 0) {
      writer.uint32(10).bytes(message.signature);
    }

    if (message.dataType !== 0) {
      writer.uint32(16).int32(message.dataType);
    }

    if (message.data.length !== 0) {
      writer.uint32(26).bytes(message.data);
    }

    if (!message.timestamp.isZero()) {
      writer.uint32(32).uint64(message.timestamp);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSignatureAndData();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.signature = reader.bytes();
          break;

        case 2:
          message.dataType = reader.int32();
          break;

        case 3:
          message.data = reader.bytes();
          break;

        case 4:
          message.timestamp = reader.uint64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$signature2, _object$dataType, _object$data;

    const message = createBaseSignatureAndData();
    message.signature = (_object$signature2 = object.signature) !== null && _object$signature2 !== void 0 ? _object$signature2 : new Uint8Array();
    message.dataType = (_object$dataType = object.dataType) !== null && _object$dataType !== void 0 ? _object$dataType : 0;
    message.data = (_object$data = object.data) !== null && _object$data !== void 0 ? _object$data : new Uint8Array();
    message.timestamp = object.timestamp !== undefined && object.timestamp !== null ? helpers/* Long.fromValue */.dK.fromValue(object.timestamp) : helpers/* Long.UZERO */.dK.UZERO;
    return message;
  },

  fromAmino(object) {
    return {
      signature: object.signature,
      dataType: (0,helpers/* isSet */.DM)(object.data_type) ? dataTypeFromJSON(object.data_type) : 0,
      data: object.data,
      timestamp: helpers/* Long.fromString */.dK.fromString(object.timestamp)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.signature = message.signature;
    obj.data_type = message.dataType;
    obj.data = message.data;
    obj.timestamp = message.timestamp ? message.timestamp.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return SignatureAndData.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/SignatureAndData",
      value: SignatureAndData.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return SignatureAndData.decode(message.value);
  },

  toProto(message) {
    return SignatureAndData.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.lightclients.solomachine.v2.SignatureAndData",
      value: SignatureAndData.encode(message).finish()
    };
  }

};

function createBaseTimestampedSignatureData() {
  return {
    signatureData: new Uint8Array(),
    timestamp: helpers/* Long.UZERO */.dK.UZERO
  };
}

const TimestampedSignatureData = {
  typeUrl: "/ibc.lightclients.solomachine.v2.TimestampedSignatureData",

  encode(message, writer = minimal.Writer.create()) {
    if (message.signatureData.length !== 0) {
      writer.uint32(10).bytes(message.signatureData);
    }

    if (!message.timestamp.isZero()) {
      writer.uint32(16).uint64(message.timestamp);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTimestampedSignatureData();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.signatureData = reader.bytes();
          break;

        case 2:
          message.timestamp = reader.uint64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$signatureData;

    const message = createBaseTimestampedSignatureData();
    message.signatureData = (_object$signatureData = object.signatureData) !== null && _object$signatureData !== void 0 ? _object$signatureData : new Uint8Array();
    message.timestamp = object.timestamp !== undefined && object.timestamp !== null ? helpers/* Long.fromValue */.dK.fromValue(object.timestamp) : helpers/* Long.UZERO */.dK.UZERO;
    return message;
  },

  fromAmino(object) {
    return {
      signatureData: object.signature_data,
      timestamp: helpers/* Long.fromString */.dK.fromString(object.timestamp)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.signature_data = message.signatureData;
    obj.timestamp = message.timestamp ? message.timestamp.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return TimestampedSignatureData.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/TimestampedSignatureData",
      value: TimestampedSignatureData.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return TimestampedSignatureData.decode(message.value);
  },

  toProto(message) {
    return TimestampedSignatureData.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.lightclients.solomachine.v2.TimestampedSignatureData",
      value: TimestampedSignatureData.encode(message).finish()
    };
  }

};

function createBaseSignBytes() {
  return {
    sequence: helpers/* Long.UZERO */.dK.UZERO,
    timestamp: helpers/* Long.UZERO */.dK.UZERO,
    diversifier: "",
    dataType: 0,
    data: new Uint8Array()
  };
}

const SignBytes = {
  typeUrl: "/ibc.lightclients.solomachine.v2.SignBytes",

  encode(message, writer = minimal.Writer.create()) {
    if (!message.sequence.isZero()) {
      writer.uint32(8).uint64(message.sequence);
    }

    if (!message.timestamp.isZero()) {
      writer.uint32(16).uint64(message.timestamp);
    }

    if (message.diversifier !== "") {
      writer.uint32(26).string(message.diversifier);
    }

    if (message.dataType !== 0) {
      writer.uint32(32).int32(message.dataType);
    }

    if (message.data.length !== 0) {
      writer.uint32(42).bytes(message.data);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSignBytes();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.sequence = reader.uint64();
          break;

        case 2:
          message.timestamp = reader.uint64();
          break;

        case 3:
          message.diversifier = reader.string();
          break;

        case 4:
          message.dataType = reader.int32();
          break;

        case 5:
          message.data = reader.bytes();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$diversifier2, _object$dataType2, _object$data2;

    const message = createBaseSignBytes();
    message.sequence = object.sequence !== undefined && object.sequence !== null ? helpers/* Long.fromValue */.dK.fromValue(object.sequence) : helpers/* Long.UZERO */.dK.UZERO;
    message.timestamp = object.timestamp !== undefined && object.timestamp !== null ? helpers/* Long.fromValue */.dK.fromValue(object.timestamp) : helpers/* Long.UZERO */.dK.UZERO;
    message.diversifier = (_object$diversifier2 = object.diversifier) !== null && _object$diversifier2 !== void 0 ? _object$diversifier2 : "";
    message.dataType = (_object$dataType2 = object.dataType) !== null && _object$dataType2 !== void 0 ? _object$dataType2 : 0;
    message.data = (_object$data2 = object.data) !== null && _object$data2 !== void 0 ? _object$data2 : new Uint8Array();
    return message;
  },

  fromAmino(object) {
    return {
      sequence: helpers/* Long.fromString */.dK.fromString(object.sequence),
      timestamp: helpers/* Long.fromString */.dK.fromString(object.timestamp),
      diversifier: object.diversifier,
      dataType: (0,helpers/* isSet */.DM)(object.data_type) ? dataTypeFromJSON(object.data_type) : 0,
      data: object.data
    };
  },

  toAmino(message) {
    const obj = {};
    obj.sequence = message.sequence ? message.sequence.toString() : undefined;
    obj.timestamp = message.timestamp ? message.timestamp.toString() : undefined;
    obj.diversifier = message.diversifier;
    obj.data_type = message.dataType;
    obj.data = message.data;
    return obj;
  },

  fromAminoMsg(object) {
    return SignBytes.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/SignBytes",
      value: SignBytes.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return SignBytes.decode(message.value);
  },

  toProto(message) {
    return SignBytes.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.lightclients.solomachine.v2.SignBytes",
      value: SignBytes.encode(message).finish()
    };
  }

};

function createBaseHeaderData() {
  return {
    newPubKey: undefined,
    newDiversifier: ""
  };
}

const HeaderData = {
  typeUrl: "/ibc.lightclients.solomachine.v2.HeaderData",

  encode(message, writer = minimal.Writer.create()) {
    if (message.newPubKey !== undefined) {
      any.Any.encode(message.newPubKey, writer.uint32(10).fork()).ldelim();
    }

    if (message.newDiversifier !== "") {
      writer.uint32(18).string(message.newDiversifier);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseHeaderData();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.newPubKey = any.Any.decode(reader, reader.uint32());
          break;

        case 2:
          message.newDiversifier = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$newDiversifie2;

    const message = createBaseHeaderData();
    message.newPubKey = object.newPubKey !== undefined && object.newPubKey !== null ? any.Any.fromPartial(object.newPubKey) : undefined;
    message.newDiversifier = (_object$newDiversifie2 = object.newDiversifier) !== null && _object$newDiversifie2 !== void 0 ? _object$newDiversifie2 : "";
    return message;
  },

  fromAmino(object) {
    return {
      newPubKey: object !== null && object !== void 0 && object.new_pub_key ? any.Any.fromAmino(object.new_pub_key) : undefined,
      newDiversifier: object.new_diversifier
    };
  },

  toAmino(message) {
    const obj = {};
    obj.new_pub_key = message.newPubKey ? any.Any.toAmino(message.newPubKey) : undefined;
    obj.new_diversifier = message.newDiversifier;
    return obj;
  },

  fromAminoMsg(object) {
    return HeaderData.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/HeaderData",
      value: HeaderData.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return HeaderData.decode(message.value);
  },

  toProto(message) {
    return HeaderData.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.lightclients.solomachine.v2.HeaderData",
      value: HeaderData.encode(message).finish()
    };
  }

};

function createBaseClientStateData() {
  return {
    path: new Uint8Array(),
    clientState: undefined
  };
}

const ClientStateData = {
  typeUrl: "/ibc.lightclients.solomachine.v2.ClientStateData",

  encode(message, writer = minimal.Writer.create()) {
    if (message.path.length !== 0) {
      writer.uint32(10).bytes(message.path);
    }

    if (message.clientState !== undefined) {
      any.Any.encode(message.clientState, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseClientStateData();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.path = reader.bytes();
          break;

        case 2:
          message.clientState = any.Any.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$path;

    const message = createBaseClientStateData();
    message.path = (_object$path = object.path) !== null && _object$path !== void 0 ? _object$path : new Uint8Array();
    message.clientState = object.clientState !== undefined && object.clientState !== null ? any.Any.fromPartial(object.clientState) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      path: object.path,
      clientState: object !== null && object !== void 0 && object.client_state ? any.Any.fromAmino(object.client_state) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.path = message.path;
    obj.client_state = message.clientState ? any.Any.toAmino(message.clientState) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return ClientStateData.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/ClientStateData",
      value: ClientStateData.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return ClientStateData.decode(message.value);
  },

  toProto(message) {
    return ClientStateData.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.lightclients.solomachine.v2.ClientStateData",
      value: ClientStateData.encode(message).finish()
    };
  }

};

function createBaseConsensusStateData() {
  return {
    path: new Uint8Array(),
    consensusState: undefined
  };
}

const ConsensusStateData = {
  typeUrl: "/ibc.lightclients.solomachine.v2.ConsensusStateData",

  encode(message, writer = minimal.Writer.create()) {
    if (message.path.length !== 0) {
      writer.uint32(10).bytes(message.path);
    }

    if (message.consensusState !== undefined) {
      any.Any.encode(message.consensusState, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseConsensusStateData();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.path = reader.bytes();
          break;

        case 2:
          message.consensusState = any.Any.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$path2;

    const message = createBaseConsensusStateData();
    message.path = (_object$path2 = object.path) !== null && _object$path2 !== void 0 ? _object$path2 : new Uint8Array();
    message.consensusState = object.consensusState !== undefined && object.consensusState !== null ? any.Any.fromPartial(object.consensusState) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      path: object.path,
      consensusState: object !== null && object !== void 0 && object.consensus_state ? any.Any.fromAmino(object.consensus_state) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.path = message.path;
    obj.consensus_state = message.consensusState ? any.Any.toAmino(message.consensusState) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return ConsensusStateData.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/ConsensusStateData",
      value: ConsensusStateData.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return ConsensusStateData.decode(message.value);
  },

  toProto(message) {
    return ConsensusStateData.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.lightclients.solomachine.v2.ConsensusStateData",
      value: ConsensusStateData.encode(message).finish()
    };
  }

};

function createBaseConnectionStateData() {
  return {
    path: new Uint8Array(),
    connection: undefined
  };
}

const ConnectionStateData = {
  typeUrl: "/ibc.lightclients.solomachine.v2.ConnectionStateData",

  encode(message, writer = minimal.Writer.create()) {
    if (message.path.length !== 0) {
      writer.uint32(10).bytes(message.path);
    }

    if (message.connection !== undefined) {
      v1_connection.ConnectionEnd.encode(message.connection, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseConnectionStateData();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.path = reader.bytes();
          break;

        case 2:
          message.connection = v1_connection.ConnectionEnd.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$path3;

    const message = createBaseConnectionStateData();
    message.path = (_object$path3 = object.path) !== null && _object$path3 !== void 0 ? _object$path3 : new Uint8Array();
    message.connection = object.connection !== undefined && object.connection !== null ? v1_connection.ConnectionEnd.fromPartial(object.connection) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      path: object.path,
      connection: object !== null && object !== void 0 && object.connection ? v1_connection.ConnectionEnd.fromAmino(object.connection) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.path = message.path;
    obj.connection = message.connection ? v1_connection.ConnectionEnd.toAmino(message.connection) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return ConnectionStateData.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/ConnectionStateData",
      value: ConnectionStateData.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return ConnectionStateData.decode(message.value);
  },

  toProto(message) {
    return ConnectionStateData.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.lightclients.solomachine.v2.ConnectionStateData",
      value: ConnectionStateData.encode(message).finish()
    };
  }

};

function createBaseChannelStateData() {
  return {
    path: new Uint8Array(),
    channel: undefined
  };
}

const ChannelStateData = {
  typeUrl: "/ibc.lightclients.solomachine.v2.ChannelStateData",

  encode(message, writer = minimal.Writer.create()) {
    if (message.path.length !== 0) {
      writer.uint32(10).bytes(message.path);
    }

    if (message.channel !== undefined) {
      v1_channel.Channel.encode(message.channel, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseChannelStateData();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.path = reader.bytes();
          break;

        case 2:
          message.channel = v1_channel.Channel.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$path4;

    const message = createBaseChannelStateData();
    message.path = (_object$path4 = object.path) !== null && _object$path4 !== void 0 ? _object$path4 : new Uint8Array();
    message.channel = object.channel !== undefined && object.channel !== null ? v1_channel.Channel.fromPartial(object.channel) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      path: object.path,
      channel: object !== null && object !== void 0 && object.channel ? v1_channel.Channel.fromAmino(object.channel) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.path = message.path;
    obj.channel = message.channel ? v1_channel.Channel.toAmino(message.channel) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return ChannelStateData.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/ChannelStateData",
      value: ChannelStateData.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return ChannelStateData.decode(message.value);
  },

  toProto(message) {
    return ChannelStateData.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.lightclients.solomachine.v2.ChannelStateData",
      value: ChannelStateData.encode(message).finish()
    };
  }

};

function createBasePacketCommitmentData() {
  return {
    path: new Uint8Array(),
    commitment: new Uint8Array()
  };
}

const PacketCommitmentData = {
  typeUrl: "/ibc.lightclients.solomachine.v2.PacketCommitmentData",

  encode(message, writer = minimal.Writer.create()) {
    if (message.path.length !== 0) {
      writer.uint32(10).bytes(message.path);
    }

    if (message.commitment.length !== 0) {
      writer.uint32(18).bytes(message.commitment);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePacketCommitmentData();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.path = reader.bytes();
          break;

        case 2:
          message.commitment = reader.bytes();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$path5, _object$commitment;

    const message = createBasePacketCommitmentData();
    message.path = (_object$path5 = object.path) !== null && _object$path5 !== void 0 ? _object$path5 : new Uint8Array();
    message.commitment = (_object$commitment = object.commitment) !== null && _object$commitment !== void 0 ? _object$commitment : new Uint8Array();
    return message;
  },

  fromAmino(object) {
    return {
      path: object.path,
      commitment: object.commitment
    };
  },

  toAmino(message) {
    const obj = {};
    obj.path = message.path;
    obj.commitment = message.commitment;
    return obj;
  },

  fromAminoMsg(object) {
    return PacketCommitmentData.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/PacketCommitmentData",
      value: PacketCommitmentData.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return PacketCommitmentData.decode(message.value);
  },

  toProto(message) {
    return PacketCommitmentData.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.lightclients.solomachine.v2.PacketCommitmentData",
      value: PacketCommitmentData.encode(message).finish()
    };
  }

};

function createBasePacketAcknowledgementData() {
  return {
    path: new Uint8Array(),
    acknowledgement: new Uint8Array()
  };
}

const PacketAcknowledgementData = {
  typeUrl: "/ibc.lightclients.solomachine.v2.PacketAcknowledgementData",

  encode(message, writer = minimal.Writer.create()) {
    if (message.path.length !== 0) {
      writer.uint32(10).bytes(message.path);
    }

    if (message.acknowledgement.length !== 0) {
      writer.uint32(18).bytes(message.acknowledgement);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePacketAcknowledgementData();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.path = reader.bytes();
          break;

        case 2:
          message.acknowledgement = reader.bytes();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$path6, _object$acknowledgeme;

    const message = createBasePacketAcknowledgementData();
    message.path = (_object$path6 = object.path) !== null && _object$path6 !== void 0 ? _object$path6 : new Uint8Array();
    message.acknowledgement = (_object$acknowledgeme = object.acknowledgement) !== null && _object$acknowledgeme !== void 0 ? _object$acknowledgeme : new Uint8Array();
    return message;
  },

  fromAmino(object) {
    return {
      path: object.path,
      acknowledgement: object.acknowledgement
    };
  },

  toAmino(message) {
    const obj = {};
    obj.path = message.path;
    obj.acknowledgement = message.acknowledgement;
    return obj;
  },

  fromAminoMsg(object) {
    return PacketAcknowledgementData.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/PacketAcknowledgementData",
      value: PacketAcknowledgementData.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return PacketAcknowledgementData.decode(message.value);
  },

  toProto(message) {
    return PacketAcknowledgementData.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.lightclients.solomachine.v2.PacketAcknowledgementData",
      value: PacketAcknowledgementData.encode(message).finish()
    };
  }

};

function createBasePacketReceiptAbsenceData() {
  return {
    path: new Uint8Array()
  };
}

const PacketReceiptAbsenceData = {
  typeUrl: "/ibc.lightclients.solomachine.v2.PacketReceiptAbsenceData",

  encode(message, writer = minimal.Writer.create()) {
    if (message.path.length !== 0) {
      writer.uint32(10).bytes(message.path);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePacketReceiptAbsenceData();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.path = reader.bytes();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$path7;

    const message = createBasePacketReceiptAbsenceData();
    message.path = (_object$path7 = object.path) !== null && _object$path7 !== void 0 ? _object$path7 : new Uint8Array();
    return message;
  },

  fromAmino(object) {
    return {
      path: object.path
    };
  },

  toAmino(message) {
    const obj = {};
    obj.path = message.path;
    return obj;
  },

  fromAminoMsg(object) {
    return PacketReceiptAbsenceData.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/PacketReceiptAbsenceData",
      value: PacketReceiptAbsenceData.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return PacketReceiptAbsenceData.decode(message.value);
  },

  toProto(message) {
    return PacketReceiptAbsenceData.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.lightclients.solomachine.v2.PacketReceiptAbsenceData",
      value: PacketReceiptAbsenceData.encode(message).finish()
    };
  }

};

function createBaseNextSequenceRecvData() {
  return {
    path: new Uint8Array(),
    nextSeqRecv: helpers/* Long.UZERO */.dK.UZERO
  };
}

const NextSequenceRecvData = {
  typeUrl: "/ibc.lightclients.solomachine.v2.NextSequenceRecvData",

  encode(message, writer = minimal.Writer.create()) {
    if (message.path.length !== 0) {
      writer.uint32(10).bytes(message.path);
    }

    if (!message.nextSeqRecv.isZero()) {
      writer.uint32(16).uint64(message.nextSeqRecv);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseNextSequenceRecvData();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.path = reader.bytes();
          break;

        case 2:
          message.nextSeqRecv = reader.uint64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$path8;

    const message = createBaseNextSequenceRecvData();
    message.path = (_object$path8 = object.path) !== null && _object$path8 !== void 0 ? _object$path8 : new Uint8Array();
    message.nextSeqRecv = object.nextSeqRecv !== undefined && object.nextSeqRecv !== null ? helpers/* Long.fromValue */.dK.fromValue(object.nextSeqRecv) : helpers/* Long.UZERO */.dK.UZERO;
    return message;
  },

  fromAmino(object) {
    return {
      path: object.path,
      nextSeqRecv: helpers/* Long.fromString */.dK.fromString(object.next_seq_recv)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.path = message.path;
    obj.next_seq_recv = message.nextSeqRecv ? message.nextSeqRecv.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return NextSequenceRecvData.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/NextSequenceRecvData",
      value: NextSequenceRecvData.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return NextSequenceRecvData.decode(message.value);
  },

  toProto(message) {
    return NextSequenceRecvData.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.lightclients.solomachine.v2.NextSequenceRecvData",
      value: NextSequenceRecvData.encode(message).finish()
    };
  }

};
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/ibc/lightclients/solomachine/v3/solomachine.js



/**
 * ClientState defines a solo machine client that tracks the current consensus
 * state and if the client is frozen.
 */

function v3_solomachine_createBaseClientState() {
  return {
    sequence: helpers/* Long.UZERO */.dK.UZERO,
    isFrozen: false,
    consensusState: undefined
  };
}

const v3_solomachine_ClientState = {
  typeUrl: "/ibc.lightclients.solomachine.v3.ClientState",

  encode(message, writer = minimal.Writer.create()) {
    if (!message.sequence.isZero()) {
      writer.uint32(8).uint64(message.sequence);
    }

    if (message.isFrozen === true) {
      writer.uint32(16).bool(message.isFrozen);
    }

    if (message.consensusState !== undefined) {
      solomachine_ConsensusState.encode(message.consensusState, writer.uint32(26).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = v3_solomachine_createBaseClientState();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.sequence = reader.uint64();
          break;

        case 2:
          message.isFrozen = reader.bool();
          break;

        case 3:
          message.consensusState = solomachine_ConsensusState.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$isFrozen;

    const message = v3_solomachine_createBaseClientState();
    message.sequence = object.sequence !== undefined && object.sequence !== null ? helpers/* Long.fromValue */.dK.fromValue(object.sequence) : helpers/* Long.UZERO */.dK.UZERO;
    message.isFrozen = (_object$isFrozen = object.isFrozen) !== null && _object$isFrozen !== void 0 ? _object$isFrozen : false;
    message.consensusState = object.consensusState !== undefined && object.consensusState !== null ? solomachine_ConsensusState.fromPartial(object.consensusState) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      sequence: helpers/* Long.fromString */.dK.fromString(object.sequence),
      isFrozen: object.is_frozen,
      consensusState: object !== null && object !== void 0 && object.consensus_state ? solomachine_ConsensusState.fromAmino(object.consensus_state) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.sequence = message.sequence ? message.sequence.toString() : undefined;
    obj.is_frozen = message.isFrozen;
    obj.consensus_state = message.consensusState ? solomachine_ConsensusState.toAmino(message.consensusState) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return v3_solomachine_ClientState.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/ClientState",
      value: v3_solomachine_ClientState.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return v3_solomachine_ClientState.decode(message.value);
  },

  toProto(message) {
    return v3_solomachine_ClientState.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.lightclients.solomachine.v3.ClientState",
      value: v3_solomachine_ClientState.encode(message).finish()
    };
  }

};

function solomachine_createBaseConsensusState() {
  return {
    publicKey: undefined,
    diversifier: "",
    timestamp: helpers/* Long.UZERO */.dK.UZERO
  };
}

const solomachine_ConsensusState = {
  typeUrl: "/ibc.lightclients.solomachine.v3.ConsensusState",

  encode(message, writer = minimal.Writer.create()) {
    if (message.publicKey !== undefined) {
      any.Any.encode(message.publicKey, writer.uint32(10).fork()).ldelim();
    }

    if (message.diversifier !== "") {
      writer.uint32(18).string(message.diversifier);
    }

    if (!message.timestamp.isZero()) {
      writer.uint32(24).uint64(message.timestamp);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = solomachine_createBaseConsensusState();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.publicKey = any.Any.decode(reader, reader.uint32());
          break;

        case 2:
          message.diversifier = reader.string();
          break;

        case 3:
          message.timestamp = reader.uint64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$diversifier;

    const message = solomachine_createBaseConsensusState();
    message.publicKey = object.publicKey !== undefined && object.publicKey !== null ? any.Any.fromPartial(object.publicKey) : undefined;
    message.diversifier = (_object$diversifier = object.diversifier) !== null && _object$diversifier !== void 0 ? _object$diversifier : "";
    message.timestamp = object.timestamp !== undefined && object.timestamp !== null ? helpers/* Long.fromValue */.dK.fromValue(object.timestamp) : helpers/* Long.UZERO */.dK.UZERO;
    return message;
  },

  fromAmino(object) {
    return {
      publicKey: object !== null && object !== void 0 && object.public_key ? any.Any.fromAmino(object.public_key) : undefined,
      diversifier: object.diversifier,
      timestamp: helpers/* Long.fromString */.dK.fromString(object.timestamp)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.public_key = message.publicKey ? any.Any.toAmino(message.publicKey) : undefined;
    obj.diversifier = message.diversifier;
    obj.timestamp = message.timestamp ? message.timestamp.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return solomachine_ConsensusState.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/ConsensusState",
      value: solomachine_ConsensusState.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return solomachine_ConsensusState.decode(message.value);
  },

  toProto(message) {
    return solomachine_ConsensusState.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.lightclients.solomachine.v3.ConsensusState",
      value: solomachine_ConsensusState.encode(message).finish()
    };
  }

};

function solomachine_createBaseHeader() {
  return {
    timestamp: helpers/* Long.UZERO */.dK.UZERO,
    signature: new Uint8Array(),
    newPublicKey: undefined,
    newDiversifier: ""
  };
}

const solomachine_Header = {
  typeUrl: "/ibc.lightclients.solomachine.v3.Header",

  encode(message, writer = minimal.Writer.create()) {
    if (!message.timestamp.isZero()) {
      writer.uint32(8).uint64(message.timestamp);
    }

    if (message.signature.length !== 0) {
      writer.uint32(18).bytes(message.signature);
    }

    if (message.newPublicKey !== undefined) {
      any.Any.encode(message.newPublicKey, writer.uint32(26).fork()).ldelim();
    }

    if (message.newDiversifier !== "") {
      writer.uint32(34).string(message.newDiversifier);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = solomachine_createBaseHeader();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.timestamp = reader.uint64();
          break;

        case 2:
          message.signature = reader.bytes();
          break;

        case 3:
          message.newPublicKey = any.Any.decode(reader, reader.uint32());
          break;

        case 4:
          message.newDiversifier = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$signature, _object$newDiversifie;

    const message = solomachine_createBaseHeader();
    message.timestamp = object.timestamp !== undefined && object.timestamp !== null ? helpers/* Long.fromValue */.dK.fromValue(object.timestamp) : helpers/* Long.UZERO */.dK.UZERO;
    message.signature = (_object$signature = object.signature) !== null && _object$signature !== void 0 ? _object$signature : new Uint8Array();
    message.newPublicKey = object.newPublicKey !== undefined && object.newPublicKey !== null ? any.Any.fromPartial(object.newPublicKey) : undefined;
    message.newDiversifier = (_object$newDiversifie = object.newDiversifier) !== null && _object$newDiversifie !== void 0 ? _object$newDiversifie : "";
    return message;
  },

  fromAmino(object) {
    return {
      timestamp: helpers/* Long.fromString */.dK.fromString(object.timestamp),
      signature: object.signature,
      newPublicKey: object !== null && object !== void 0 && object.new_public_key ? any.Any.fromAmino(object.new_public_key) : undefined,
      newDiversifier: object.new_diversifier
    };
  },

  toAmino(message) {
    const obj = {};
    obj.timestamp = message.timestamp ? message.timestamp.toString() : undefined;
    obj.signature = message.signature;
    obj.new_public_key = message.newPublicKey ? any.Any.toAmino(message.newPublicKey) : undefined;
    obj.new_diversifier = message.newDiversifier;
    return obj;
  },

  fromAminoMsg(object) {
    return solomachine_Header.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/Header",
      value: solomachine_Header.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return solomachine_Header.decode(message.value);
  },

  toProto(message) {
    return solomachine_Header.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.lightclients.solomachine.v3.Header",
      value: solomachine_Header.encode(message).finish()
    };
  }

};

function solomachine_createBaseMisbehaviour() {
  return {
    sequence: helpers/* Long.UZERO */.dK.UZERO,
    signatureOne: undefined,
    signatureTwo: undefined
  };
}

const solomachine_Misbehaviour = {
  typeUrl: "/ibc.lightclients.solomachine.v3.Misbehaviour",

  encode(message, writer = minimal.Writer.create()) {
    if (!message.sequence.isZero()) {
      writer.uint32(8).uint64(message.sequence);
    }

    if (message.signatureOne !== undefined) {
      solomachine_SignatureAndData.encode(message.signatureOne, writer.uint32(18).fork()).ldelim();
    }

    if (message.signatureTwo !== undefined) {
      solomachine_SignatureAndData.encode(message.signatureTwo, writer.uint32(26).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = solomachine_createBaseMisbehaviour();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.sequence = reader.uint64();
          break;

        case 2:
          message.signatureOne = solomachine_SignatureAndData.decode(reader, reader.uint32());
          break;

        case 3:
          message.signatureTwo = solomachine_SignatureAndData.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = solomachine_createBaseMisbehaviour();
    message.sequence = object.sequence !== undefined && object.sequence !== null ? helpers/* Long.fromValue */.dK.fromValue(object.sequence) : helpers/* Long.UZERO */.dK.UZERO;
    message.signatureOne = object.signatureOne !== undefined && object.signatureOne !== null ? solomachine_SignatureAndData.fromPartial(object.signatureOne) : undefined;
    message.signatureTwo = object.signatureTwo !== undefined && object.signatureTwo !== null ? solomachine_SignatureAndData.fromPartial(object.signatureTwo) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      sequence: helpers/* Long.fromString */.dK.fromString(object.sequence),
      signatureOne: object !== null && object !== void 0 && object.signature_one ? solomachine_SignatureAndData.fromAmino(object.signature_one) : undefined,
      signatureTwo: object !== null && object !== void 0 && object.signature_two ? solomachine_SignatureAndData.fromAmino(object.signature_two) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.sequence = message.sequence ? message.sequence.toString() : undefined;
    obj.signature_one = message.signatureOne ? solomachine_SignatureAndData.toAmino(message.signatureOne) : undefined;
    obj.signature_two = message.signatureTwo ? solomachine_SignatureAndData.toAmino(message.signatureTwo) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return solomachine_Misbehaviour.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/Misbehaviour",
      value: solomachine_Misbehaviour.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return solomachine_Misbehaviour.decode(message.value);
  },

  toProto(message) {
    return solomachine_Misbehaviour.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.lightclients.solomachine.v3.Misbehaviour",
      value: solomachine_Misbehaviour.encode(message).finish()
    };
  }

};

function solomachine_createBaseSignatureAndData() {
  return {
    signature: new Uint8Array(),
    path: new Uint8Array(),
    data: new Uint8Array(),
    timestamp: helpers/* Long.UZERO */.dK.UZERO
  };
}

const solomachine_SignatureAndData = {
  typeUrl: "/ibc.lightclients.solomachine.v3.SignatureAndData",

  encode(message, writer = minimal.Writer.create()) {
    if (message.signature.length !== 0) {
      writer.uint32(10).bytes(message.signature);
    }

    if (message.path.length !== 0) {
      writer.uint32(18).bytes(message.path);
    }

    if (message.data.length !== 0) {
      writer.uint32(26).bytes(message.data);
    }

    if (!message.timestamp.isZero()) {
      writer.uint32(32).uint64(message.timestamp);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = solomachine_createBaseSignatureAndData();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.signature = reader.bytes();
          break;

        case 2:
          message.path = reader.bytes();
          break;

        case 3:
          message.data = reader.bytes();
          break;

        case 4:
          message.timestamp = reader.uint64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$signature2, _object$path, _object$data;

    const message = solomachine_createBaseSignatureAndData();
    message.signature = (_object$signature2 = object.signature) !== null && _object$signature2 !== void 0 ? _object$signature2 : new Uint8Array();
    message.path = (_object$path = object.path) !== null && _object$path !== void 0 ? _object$path : new Uint8Array();
    message.data = (_object$data = object.data) !== null && _object$data !== void 0 ? _object$data : new Uint8Array();
    message.timestamp = object.timestamp !== undefined && object.timestamp !== null ? helpers/* Long.fromValue */.dK.fromValue(object.timestamp) : helpers/* Long.UZERO */.dK.UZERO;
    return message;
  },

  fromAmino(object) {
    return {
      signature: object.signature,
      path: object.path,
      data: object.data,
      timestamp: helpers/* Long.fromString */.dK.fromString(object.timestamp)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.signature = message.signature;
    obj.path = message.path;
    obj.data = message.data;
    obj.timestamp = message.timestamp ? message.timestamp.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return solomachine_SignatureAndData.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/SignatureAndData",
      value: solomachine_SignatureAndData.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return solomachine_SignatureAndData.decode(message.value);
  },

  toProto(message) {
    return solomachine_SignatureAndData.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.lightclients.solomachine.v3.SignatureAndData",
      value: solomachine_SignatureAndData.encode(message).finish()
    };
  }

};

function solomachine_createBaseTimestampedSignatureData() {
  return {
    signatureData: new Uint8Array(),
    timestamp: helpers/* Long.UZERO */.dK.UZERO
  };
}

const solomachine_TimestampedSignatureData = {
  typeUrl: "/ibc.lightclients.solomachine.v3.TimestampedSignatureData",

  encode(message, writer = minimal.Writer.create()) {
    if (message.signatureData.length !== 0) {
      writer.uint32(10).bytes(message.signatureData);
    }

    if (!message.timestamp.isZero()) {
      writer.uint32(16).uint64(message.timestamp);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = solomachine_createBaseTimestampedSignatureData();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.signatureData = reader.bytes();
          break;

        case 2:
          message.timestamp = reader.uint64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$signatureData;

    const message = solomachine_createBaseTimestampedSignatureData();
    message.signatureData = (_object$signatureData = object.signatureData) !== null && _object$signatureData !== void 0 ? _object$signatureData : new Uint8Array();
    message.timestamp = object.timestamp !== undefined && object.timestamp !== null ? helpers/* Long.fromValue */.dK.fromValue(object.timestamp) : helpers/* Long.UZERO */.dK.UZERO;
    return message;
  },

  fromAmino(object) {
    return {
      signatureData: object.signature_data,
      timestamp: helpers/* Long.fromString */.dK.fromString(object.timestamp)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.signature_data = message.signatureData;
    obj.timestamp = message.timestamp ? message.timestamp.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return solomachine_TimestampedSignatureData.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/TimestampedSignatureData",
      value: solomachine_TimestampedSignatureData.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return solomachine_TimestampedSignatureData.decode(message.value);
  },

  toProto(message) {
    return solomachine_TimestampedSignatureData.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.lightclients.solomachine.v3.TimestampedSignatureData",
      value: solomachine_TimestampedSignatureData.encode(message).finish()
    };
  }

};

function solomachine_createBaseSignBytes() {
  return {
    sequence: helpers/* Long.UZERO */.dK.UZERO,
    timestamp: helpers/* Long.UZERO */.dK.UZERO,
    diversifier: "",
    path: new Uint8Array(),
    data: new Uint8Array()
  };
}

const solomachine_SignBytes = {
  typeUrl: "/ibc.lightclients.solomachine.v3.SignBytes",

  encode(message, writer = minimal.Writer.create()) {
    if (!message.sequence.isZero()) {
      writer.uint32(8).uint64(message.sequence);
    }

    if (!message.timestamp.isZero()) {
      writer.uint32(16).uint64(message.timestamp);
    }

    if (message.diversifier !== "") {
      writer.uint32(26).string(message.diversifier);
    }

    if (message.path.length !== 0) {
      writer.uint32(34).bytes(message.path);
    }

    if (message.data.length !== 0) {
      writer.uint32(42).bytes(message.data);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = solomachine_createBaseSignBytes();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.sequence = reader.uint64();
          break;

        case 2:
          message.timestamp = reader.uint64();
          break;

        case 3:
          message.diversifier = reader.string();
          break;

        case 4:
          message.path = reader.bytes();
          break;

        case 5:
          message.data = reader.bytes();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$diversifier2, _object$path2, _object$data2;

    const message = solomachine_createBaseSignBytes();
    message.sequence = object.sequence !== undefined && object.sequence !== null ? helpers/* Long.fromValue */.dK.fromValue(object.sequence) : helpers/* Long.UZERO */.dK.UZERO;
    message.timestamp = object.timestamp !== undefined && object.timestamp !== null ? helpers/* Long.fromValue */.dK.fromValue(object.timestamp) : helpers/* Long.UZERO */.dK.UZERO;
    message.diversifier = (_object$diversifier2 = object.diversifier) !== null && _object$diversifier2 !== void 0 ? _object$diversifier2 : "";
    message.path = (_object$path2 = object.path) !== null && _object$path2 !== void 0 ? _object$path2 : new Uint8Array();
    message.data = (_object$data2 = object.data) !== null && _object$data2 !== void 0 ? _object$data2 : new Uint8Array();
    return message;
  },

  fromAmino(object) {
    return {
      sequence: helpers/* Long.fromString */.dK.fromString(object.sequence),
      timestamp: helpers/* Long.fromString */.dK.fromString(object.timestamp),
      diversifier: object.diversifier,
      path: object.path,
      data: object.data
    };
  },

  toAmino(message) {
    const obj = {};
    obj.sequence = message.sequence ? message.sequence.toString() : undefined;
    obj.timestamp = message.timestamp ? message.timestamp.toString() : undefined;
    obj.diversifier = message.diversifier;
    obj.path = message.path;
    obj.data = message.data;
    return obj;
  },

  fromAminoMsg(object) {
    return solomachine_SignBytes.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/SignBytes",
      value: solomachine_SignBytes.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return solomachine_SignBytes.decode(message.value);
  },

  toProto(message) {
    return solomachine_SignBytes.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.lightclients.solomachine.v3.SignBytes",
      value: solomachine_SignBytes.encode(message).finish()
    };
  }

};

function solomachine_createBaseHeaderData() {
  return {
    newPubKey: undefined,
    newDiversifier: ""
  };
}

const solomachine_HeaderData = {
  typeUrl: "/ibc.lightclients.solomachine.v3.HeaderData",

  encode(message, writer = minimal.Writer.create()) {
    if (message.newPubKey !== undefined) {
      any.Any.encode(message.newPubKey, writer.uint32(10).fork()).ldelim();
    }

    if (message.newDiversifier !== "") {
      writer.uint32(18).string(message.newDiversifier);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = solomachine_createBaseHeaderData();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.newPubKey = any.Any.decode(reader, reader.uint32());
          break;

        case 2:
          message.newDiversifier = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$newDiversifie2;

    const message = solomachine_createBaseHeaderData();
    message.newPubKey = object.newPubKey !== undefined && object.newPubKey !== null ? any.Any.fromPartial(object.newPubKey) : undefined;
    message.newDiversifier = (_object$newDiversifie2 = object.newDiversifier) !== null && _object$newDiversifie2 !== void 0 ? _object$newDiversifie2 : "";
    return message;
  },

  fromAmino(object) {
    return {
      newPubKey: object !== null && object !== void 0 && object.new_pub_key ? any.Any.fromAmino(object.new_pub_key) : undefined,
      newDiversifier: object.new_diversifier
    };
  },

  toAmino(message) {
    const obj = {};
    obj.new_pub_key = message.newPubKey ? any.Any.toAmino(message.newPubKey) : undefined;
    obj.new_diversifier = message.newDiversifier;
    return obj;
  },

  fromAminoMsg(object) {
    return solomachine_HeaderData.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/HeaderData",
      value: solomachine_HeaderData.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return solomachine_HeaderData.decode(message.value);
  },

  toProto(message) {
    return solomachine_HeaderData.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.lightclients.solomachine.v3.HeaderData",
      value: solomachine_HeaderData.encode(message).finish()
    };
  }

};
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/google/protobuf/duration.js
var duration = __webpack_require__(6499);
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/ibc/lightclients/tendermint/v1/tendermint.js









/**
 * ClientState from Tendermint tracks the current validator set, latest height,
 * and a possible frozen height.
 */

function tendermint_createBaseClientState() {
  return {
    chainId: "",
    trustLevel: undefined,
    trustingPeriod: undefined,
    unbondingPeriod: undefined,
    maxClockDrift: undefined,
    frozenHeight: undefined,
    latestHeight: undefined,
    proofSpecs: [],
    upgradePath: [],
    allowUpdateAfterExpiry: false,
    allowUpdateAfterMisbehaviour: false
  };
}

const tendermint_ClientState = {
  typeUrl: "/ibc.lightclients.tendermint.v1.ClientState",

  encode(message, writer = minimal.Writer.create()) {
    if (message.chainId !== "") {
      writer.uint32(10).string(message.chainId);
    }

    if (message.trustLevel !== undefined) {
      Fraction.encode(message.trustLevel, writer.uint32(18).fork()).ldelim();
    }

    if (message.trustingPeriod !== undefined) {
      duration.Duration.encode(message.trustingPeriod, writer.uint32(26).fork()).ldelim();
    }

    if (message.unbondingPeriod !== undefined) {
      duration.Duration.encode(message.unbondingPeriod, writer.uint32(34).fork()).ldelim();
    }

    if (message.maxClockDrift !== undefined) {
      duration.Duration.encode(message.maxClockDrift, writer.uint32(42).fork()).ldelim();
    }

    if (message.frozenHeight !== undefined) {
      v1_client.Height.encode(message.frozenHeight, writer.uint32(50).fork()).ldelim();
    }

    if (message.latestHeight !== undefined) {
      v1_client.Height.encode(message.latestHeight, writer.uint32(58).fork()).ldelim();
    }

    for (const v of message.proofSpecs) {
      proofs.ProofSpec.encode(v, writer.uint32(66).fork()).ldelim();
    }

    for (const v of message.upgradePath) {
      writer.uint32(74).string(v);
    }

    if (message.allowUpdateAfterExpiry === true) {
      writer.uint32(80).bool(message.allowUpdateAfterExpiry);
    }

    if (message.allowUpdateAfterMisbehaviour === true) {
      writer.uint32(88).bool(message.allowUpdateAfterMisbehaviour);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = tendermint_createBaseClientState();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.chainId = reader.string();
          break;

        case 2:
          message.trustLevel = Fraction.decode(reader, reader.uint32());
          break;

        case 3:
          message.trustingPeriod = duration.Duration.decode(reader, reader.uint32());
          break;

        case 4:
          message.unbondingPeriod = duration.Duration.decode(reader, reader.uint32());
          break;

        case 5:
          message.maxClockDrift = duration.Duration.decode(reader, reader.uint32());
          break;

        case 6:
          message.frozenHeight = v1_client.Height.decode(reader, reader.uint32());
          break;

        case 7:
          message.latestHeight = v1_client.Height.decode(reader, reader.uint32());
          break;

        case 8:
          message.proofSpecs.push(proofs.ProofSpec.decode(reader, reader.uint32()));
          break;

        case 9:
          message.upgradePath.push(reader.string());
          break;

        case 10:
          message.allowUpdateAfterExpiry = reader.bool();
          break;

        case 11:
          message.allowUpdateAfterMisbehaviour = reader.bool();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$chainId, _object$proofSpecs, _object$upgradePath, _object$allowUpdateAf, _object$allowUpdateAf2;

    const message = tendermint_createBaseClientState();
    message.chainId = (_object$chainId = object.chainId) !== null && _object$chainId !== void 0 ? _object$chainId : "";
    message.trustLevel = object.trustLevel !== undefined && object.trustLevel !== null ? Fraction.fromPartial(object.trustLevel) : undefined;
    message.trustingPeriod = object.trustingPeriod !== undefined && object.trustingPeriod !== null ? duration.Duration.fromPartial(object.trustingPeriod) : undefined;
    message.unbondingPeriod = object.unbondingPeriod !== undefined && object.unbondingPeriod !== null ? duration.Duration.fromPartial(object.unbondingPeriod) : undefined;
    message.maxClockDrift = object.maxClockDrift !== undefined && object.maxClockDrift !== null ? duration.Duration.fromPartial(object.maxClockDrift) : undefined;
    message.frozenHeight = object.frozenHeight !== undefined && object.frozenHeight !== null ? v1_client.Height.fromPartial(object.frozenHeight) : undefined;
    message.latestHeight = object.latestHeight !== undefined && object.latestHeight !== null ? v1_client.Height.fromPartial(object.latestHeight) : undefined;
    message.proofSpecs = ((_object$proofSpecs = object.proofSpecs) === null || _object$proofSpecs === void 0 ? void 0 : _object$proofSpecs.map(e => proofs.ProofSpec.fromPartial(e))) || [];
    message.upgradePath = ((_object$upgradePath = object.upgradePath) === null || _object$upgradePath === void 0 ? void 0 : _object$upgradePath.map(e => e)) || [];
    message.allowUpdateAfterExpiry = (_object$allowUpdateAf = object.allowUpdateAfterExpiry) !== null && _object$allowUpdateAf !== void 0 ? _object$allowUpdateAf : false;
    message.allowUpdateAfterMisbehaviour = (_object$allowUpdateAf2 = object.allowUpdateAfterMisbehaviour) !== null && _object$allowUpdateAf2 !== void 0 ? _object$allowUpdateAf2 : false;
    return message;
  },

  fromAmino(object) {
    return {
      chainId: object.chain_id,
      trustLevel: object !== null && object !== void 0 && object.trust_level ? Fraction.fromAmino(object.trust_level) : undefined,
      trustingPeriod: object !== null && object !== void 0 && object.trusting_period ? duration.Duration.fromAmino(object.trusting_period) : undefined,
      unbondingPeriod: object !== null && object !== void 0 && object.unbonding_period ? duration.Duration.fromAmino(object.unbonding_period) : undefined,
      maxClockDrift: object !== null && object !== void 0 && object.max_clock_drift ? duration.Duration.fromAmino(object.max_clock_drift) : undefined,
      frozenHeight: object !== null && object !== void 0 && object.frozen_height ? v1_client.Height.fromAmino(object.frozen_height) : undefined,
      latestHeight: object !== null && object !== void 0 && object.latest_height ? v1_client.Height.fromAmino(object.latest_height) : undefined,
      proofSpecs: Array.isArray(object === null || object === void 0 ? void 0 : object.proof_specs) ? object.proof_specs.map(e => proofs.ProofSpec.fromAmino(e)) : [],
      upgradePath: Array.isArray(object === null || object === void 0 ? void 0 : object.upgrade_path) ? object.upgrade_path.map(e => e) : [],
      allowUpdateAfterExpiry: object.allow_update_after_expiry,
      allowUpdateAfterMisbehaviour: object.allow_update_after_misbehaviour
    };
  },

  toAmino(message) {
    const obj = {};
    obj.chain_id = message.chainId;
    obj.trust_level = message.trustLevel ? Fraction.toAmino(message.trustLevel) : undefined;
    obj.trusting_period = message.trustingPeriod ? duration.Duration.toAmino(message.trustingPeriod) : undefined;
    obj.unbonding_period = message.unbondingPeriod ? duration.Duration.toAmino(message.unbondingPeriod) : undefined;
    obj.max_clock_drift = message.maxClockDrift ? duration.Duration.toAmino(message.maxClockDrift) : undefined;
    obj.frozen_height = message.frozenHeight ? v1_client.Height.toAmino(message.frozenHeight) : {};
    obj.latest_height = message.latestHeight ? v1_client.Height.toAmino(message.latestHeight) : {};

    if (message.proofSpecs) {
      obj.proof_specs = message.proofSpecs.map(e => e ? proofs.ProofSpec.toAmino(e) : undefined);
    } else {
      obj.proof_specs = [];
    }

    if (message.upgradePath) {
      obj.upgrade_path = message.upgradePath.map(e => e);
    } else {
      obj.upgrade_path = [];
    }

    obj.allow_update_after_expiry = message.allowUpdateAfterExpiry;
    obj.allow_update_after_misbehaviour = message.allowUpdateAfterMisbehaviour;
    return obj;
  },

  fromAminoMsg(object) {
    return tendermint_ClientState.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/ClientState",
      value: tendermint_ClientState.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return tendermint_ClientState.decode(message.value);
  },

  toProto(message) {
    return tendermint_ClientState.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.lightclients.tendermint.v1.ClientState",
      value: tendermint_ClientState.encode(message).finish()
    };
  }

};

function tendermint_createBaseConsensusState() {
  return {
    timestamp: undefined,
    root: undefined,
    nextValidatorsHash: new Uint8Array()
  };
}

const tendermint_ConsensusState = {
  typeUrl: "/ibc.lightclients.tendermint.v1.ConsensusState",

  encode(message, writer = minimal.Writer.create()) {
    if (message.timestamp !== undefined) {
      timestamp.Timestamp.encode((0,helpers/* toTimestamp */.Uq)(message.timestamp), writer.uint32(10).fork()).ldelim();
    }

    if (message.root !== undefined) {
      v1_commitment.MerkleRoot.encode(message.root, writer.uint32(18).fork()).ldelim();
    }

    if (message.nextValidatorsHash.length !== 0) {
      writer.uint32(26).bytes(message.nextValidatorsHash);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = tendermint_createBaseConsensusState();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.timestamp = (0,helpers/* fromTimestamp */.Ol)(timestamp.Timestamp.decode(reader, reader.uint32()));
          break;

        case 2:
          message.root = v1_commitment.MerkleRoot.decode(reader, reader.uint32());
          break;

        case 3:
          message.nextValidatorsHash = reader.bytes();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$timestamp, _object$nextValidator;

    const message = tendermint_createBaseConsensusState();
    message.timestamp = (_object$timestamp = object.timestamp) !== null && _object$timestamp !== void 0 ? _object$timestamp : undefined;
    message.root = object.root !== undefined && object.root !== null ? v1_commitment.MerkleRoot.fromPartial(object.root) : undefined;
    message.nextValidatorsHash = (_object$nextValidator = object.nextValidatorsHash) !== null && _object$nextValidator !== void 0 ? _object$nextValidator : new Uint8Array();
    return message;
  },

  fromAmino(object) {
    return {
      timestamp: object !== null && object !== void 0 && object.timestamp ? timestamp.Timestamp.fromAmino(object.timestamp) : undefined,
      root: object !== null && object !== void 0 && object.root ? v1_commitment.MerkleRoot.fromAmino(object.root) : undefined,
      nextValidatorsHash: object.next_validators_hash
    };
  },

  toAmino(message) {
    const obj = {};
    obj.timestamp = message.timestamp ? timestamp.Timestamp.toAmino(message.timestamp) : undefined;
    obj.root = message.root ? v1_commitment.MerkleRoot.toAmino(message.root) : undefined;
    obj.next_validators_hash = message.nextValidatorsHash;
    return obj;
  },

  fromAminoMsg(object) {
    return tendermint_ConsensusState.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/ConsensusState",
      value: tendermint_ConsensusState.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return tendermint_ConsensusState.decode(message.value);
  },

  toProto(message) {
    return tendermint_ConsensusState.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.lightclients.tendermint.v1.ConsensusState",
      value: tendermint_ConsensusState.encode(message).finish()
    };
  }

};

function tendermint_createBaseMisbehaviour() {
  return {
    clientId: "",
    header1: undefined,
    header2: undefined
  };
}

const tendermint_Misbehaviour = {
  typeUrl: "/ibc.lightclients.tendermint.v1.Misbehaviour",

  encode(message, writer = minimal.Writer.create()) {
    if (message.clientId !== "") {
      writer.uint32(10).string(message.clientId);
    }

    if (message.header1 !== undefined) {
      tendermint_Header.encode(message.header1, writer.uint32(18).fork()).ldelim();
    }

    if (message.header2 !== undefined) {
      tendermint_Header.encode(message.header2, writer.uint32(26).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = tendermint_createBaseMisbehaviour();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.clientId = reader.string();
          break;

        case 2:
          message.header1 = tendermint_Header.decode(reader, reader.uint32());
          break;

        case 3:
          message.header2 = tendermint_Header.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$clientId;

    const message = tendermint_createBaseMisbehaviour();
    message.clientId = (_object$clientId = object.clientId) !== null && _object$clientId !== void 0 ? _object$clientId : "";
    message.header1 = object.header1 !== undefined && object.header1 !== null ? tendermint_Header.fromPartial(object.header1) : undefined;
    message.header2 = object.header2 !== undefined && object.header2 !== null ? tendermint_Header.fromPartial(object.header2) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      clientId: object.client_id,
      header_1: object !== null && object !== void 0 && object.header_1 ? tendermint_Header.fromAmino(object.header_1) : undefined,
      header_2: object !== null && object !== void 0 && object.header_2 ? tendermint_Header.fromAmino(object.header_2) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.client_id = message.clientId;
    obj.header_1 = message.header_1 ? tendermint_Header.toAmino(message.header_1) : undefined;
    obj.header_2 = message.header_2 ? tendermint_Header.toAmino(message.header_2) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return tendermint_Misbehaviour.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/Misbehaviour",
      value: tendermint_Misbehaviour.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return tendermint_Misbehaviour.decode(message.value);
  },

  toProto(message) {
    return tendermint_Misbehaviour.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.lightclients.tendermint.v1.Misbehaviour",
      value: tendermint_Misbehaviour.encode(message).finish()
    };
  }

};

function tendermint_createBaseHeader() {
  return {
    signedHeader: undefined,
    validatorSet: undefined,
    trustedHeight: undefined,
    trustedValidators: undefined
  };
}

const tendermint_Header = {
  typeUrl: "/ibc.lightclients.tendermint.v1.Header",

  encode(message, writer = minimal.Writer.create()) {
    if (message.signedHeader !== undefined) {
      types_types.SignedHeader.encode(message.signedHeader, writer.uint32(10).fork()).ldelim();
    }

    if (message.validatorSet !== undefined) {
      validator.ValidatorSet.encode(message.validatorSet, writer.uint32(18).fork()).ldelim();
    }

    if (message.trustedHeight !== undefined) {
      v1_client.Height.encode(message.trustedHeight, writer.uint32(26).fork()).ldelim();
    }

    if (message.trustedValidators !== undefined) {
      validator.ValidatorSet.encode(message.trustedValidators, writer.uint32(34).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = tendermint_createBaseHeader();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.signedHeader = types_types.SignedHeader.decode(reader, reader.uint32());
          break;

        case 2:
          message.validatorSet = validator.ValidatorSet.decode(reader, reader.uint32());
          break;

        case 3:
          message.trustedHeight = v1_client.Height.decode(reader, reader.uint32());
          break;

        case 4:
          message.trustedValidators = validator.ValidatorSet.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = tendermint_createBaseHeader();
    message.signedHeader = object.signedHeader !== undefined && object.signedHeader !== null ? types_types.SignedHeader.fromPartial(object.signedHeader) : undefined;
    message.validatorSet = object.validatorSet !== undefined && object.validatorSet !== null ? validator.ValidatorSet.fromPartial(object.validatorSet) : undefined;
    message.trustedHeight = object.trustedHeight !== undefined && object.trustedHeight !== null ? v1_client.Height.fromPartial(object.trustedHeight) : undefined;
    message.trustedValidators = object.trustedValidators !== undefined && object.trustedValidators !== null ? validator.ValidatorSet.fromPartial(object.trustedValidators) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      signedHeader: object !== null && object !== void 0 && object.signed_header ? types_types.SignedHeader.fromAmino(object.signed_header) : undefined,
      validatorSet: object !== null && object !== void 0 && object.validator_set ? validator.ValidatorSet.fromAmino(object.validator_set) : undefined,
      trustedHeight: object !== null && object !== void 0 && object.trusted_height ? v1_client.Height.fromAmino(object.trusted_height) : undefined,
      trustedValidators: object !== null && object !== void 0 && object.trusted_validators ? validator.ValidatorSet.fromAmino(object.trusted_validators) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.signed_header = message.signedHeader ? types_types.SignedHeader.toAmino(message.signedHeader) : undefined;
    obj.validator_set = message.validatorSet ? validator.ValidatorSet.toAmino(message.validatorSet) : undefined;
    obj.trusted_height = message.trustedHeight ? v1_client.Height.toAmino(message.trustedHeight) : {};
    obj.trusted_validators = message.trustedValidators ? validator.ValidatorSet.toAmino(message.trustedValidators) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return tendermint_Header.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/Header",
      value: tendermint_Header.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return tendermint_Header.decode(message.value);
  },

  toProto(message) {
    return tendermint_Header.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.lightclients.tendermint.v1.Header",
      value: tendermint_Header.encode(message).finish()
    };
  }

};

function createBaseFraction() {
  return {
    numerator: helpers/* Long.UZERO */.dK.UZERO,
    denominator: helpers/* Long.UZERO */.dK.UZERO
  };
}

const Fraction = {
  typeUrl: "/ibc.lightclients.tendermint.v1.Fraction",

  encode(message, writer = minimal.Writer.create()) {
    if (!message.numerator.isZero()) {
      writer.uint32(8).uint64(message.numerator);
    }

    if (!message.denominator.isZero()) {
      writer.uint32(16).uint64(message.denominator);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFraction();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.numerator = reader.uint64();
          break;

        case 2:
          message.denominator = reader.uint64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseFraction();
    message.numerator = object.numerator !== undefined && object.numerator !== null ? helpers/* Long.fromValue */.dK.fromValue(object.numerator) : helpers/* Long.UZERO */.dK.UZERO;
    message.denominator = object.denominator !== undefined && object.denominator !== null ? helpers/* Long.fromValue */.dK.fromValue(object.denominator) : helpers/* Long.UZERO */.dK.UZERO;
    return message;
  },

  fromAmino(object) {
    return {
      numerator: helpers/* Long.fromString */.dK.fromString(object.numerator),
      denominator: helpers/* Long.fromString */.dK.fromString(object.denominator)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.numerator = message.numerator ? message.numerator.toString() : undefined;
    obj.denominator = message.denominator ? message.denominator.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return Fraction.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "cosmos-sdk/Fraction",
      value: Fraction.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return Fraction.decode(message.value);
  },

  toProto(message) {
    return Fraction.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ibc.lightclients.tendermint.v1.Fraction",
      value: Fraction.encode(message).finish()
    };
  }

};
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/ibc/applications/fee/v1/tx.amino.js
//@ts-nocheck

const v1_tx_amino_AminoConverter = {
  "/ibc.applications.fee.v1.MsgRegisterPayee": {
    aminoType: "cosmos-sdk/MsgRegisterPayee",
    toAmino: tx.MsgRegisterPayee.toAmino,
    fromAmino: tx.MsgRegisterPayee.fromAmino
  },
  "/ibc.applications.fee.v1.MsgRegisterCounterpartyPayee": {
    aminoType: "cosmos-sdk/MsgRegisterCounterpartyPayee",
    toAmino: tx.MsgRegisterCounterpartyPayee.toAmino,
    fromAmino: tx.MsgRegisterCounterpartyPayee.fromAmino
  },
  "/ibc.applications.fee.v1.MsgPayPacketFee": {
    aminoType: "cosmos-sdk/MsgPayPacketFee",
    toAmino: tx.MsgPayPacketFee.toAmino,
    fromAmino: tx.MsgPayPacketFee.fromAmino
  },
  "/ibc.applications.fee.v1.MsgPayPacketFeeAsync": {
    aminoType: "cosmos-sdk/MsgPayPacketFeeAsync",
    toAmino: tx.MsgPayPacketFeeAsync.toAmino,
    fromAmino: tx.MsgPayPacketFeeAsync.fromAmino
  }
};
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/ibc/applications/interchain_accounts/controller/v1/tx.amino.js
//@ts-nocheck

const controller_v1_tx_amino_AminoConverter = {
  "/ibc.applications.interchain_accounts.controller.v1.MsgRegisterInterchainAccount": {
    aminoType: "cosmos-sdk/MsgRegisterInterchainAccount",
    toAmino: v1_tx.MsgRegisterInterchainAccount.toAmino,
    fromAmino: v1_tx.MsgRegisterInterchainAccount.fromAmino
  },
  "/ibc.applications.interchain_accounts.controller.v1.MsgSendTx": {
    aminoType: "cosmos-sdk/MsgSendTx",
    toAmino: v1_tx.MsgSendTx.toAmino,
    fromAmino: v1_tx.MsgSendTx.fromAmino
  }
};
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/ibc/applications/transfer/v1/tx.amino.js
//@ts-nocheck

const transfer_v1_tx_amino_AminoConverter = {
  "/ibc.applications.transfer.v1.MsgTransfer": {
    aminoType: "cosmos-sdk/MsgTransfer",
    toAmino: transfer_v1_tx.MsgTransfer.toAmino,
    fromAmino: transfer_v1_tx.MsgTransfer.fromAmino
  }
};
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/ibc/core/channel/v1/tx.amino.js
//@ts-nocheck

const channel_v1_tx_amino_AminoConverter = {
  "/ibc.core.channel.v1.MsgChannelOpenInit": {
    aminoType: "cosmos-sdk/MsgChannelOpenInit",
    toAmino: channel_v1_tx.MsgChannelOpenInit.toAmino,
    fromAmino: channel_v1_tx.MsgChannelOpenInit.fromAmino
  },
  "/ibc.core.channel.v1.MsgChannelOpenTry": {
    aminoType: "cosmos-sdk/MsgChannelOpenTry",
    toAmino: channel_v1_tx.MsgChannelOpenTry.toAmino,
    fromAmino: channel_v1_tx.MsgChannelOpenTry.fromAmino
  },
  "/ibc.core.channel.v1.MsgChannelOpenAck": {
    aminoType: "cosmos-sdk/MsgChannelOpenAck",
    toAmino: channel_v1_tx.MsgChannelOpenAck.toAmino,
    fromAmino: channel_v1_tx.MsgChannelOpenAck.fromAmino
  },
  "/ibc.core.channel.v1.MsgChannelOpenConfirm": {
    aminoType: "cosmos-sdk/MsgChannelOpenConfirm",
    toAmino: channel_v1_tx.MsgChannelOpenConfirm.toAmino,
    fromAmino: channel_v1_tx.MsgChannelOpenConfirm.fromAmino
  },
  "/ibc.core.channel.v1.MsgChannelCloseInit": {
    aminoType: "cosmos-sdk/MsgChannelCloseInit",
    toAmino: channel_v1_tx.MsgChannelCloseInit.toAmino,
    fromAmino: channel_v1_tx.MsgChannelCloseInit.fromAmino
  },
  "/ibc.core.channel.v1.MsgChannelCloseConfirm": {
    aminoType: "cosmos-sdk/MsgChannelCloseConfirm",
    toAmino: channel_v1_tx.MsgChannelCloseConfirm.toAmino,
    fromAmino: channel_v1_tx.MsgChannelCloseConfirm.fromAmino
  },
  "/ibc.core.channel.v1.MsgRecvPacket": {
    aminoType: "cosmos-sdk/MsgRecvPacket",
    toAmino: channel_v1_tx.MsgRecvPacket.toAmino,
    fromAmino: channel_v1_tx.MsgRecvPacket.fromAmino
  },
  "/ibc.core.channel.v1.MsgTimeout": {
    aminoType: "cosmos-sdk/MsgTimeout",
    toAmino: channel_v1_tx.MsgTimeout.toAmino,
    fromAmino: channel_v1_tx.MsgTimeout.fromAmino
  },
  "/ibc.core.channel.v1.MsgTimeoutOnClose": {
    aminoType: "cosmos-sdk/MsgTimeoutOnClose",
    toAmino: channel_v1_tx.MsgTimeoutOnClose.toAmino,
    fromAmino: channel_v1_tx.MsgTimeoutOnClose.fromAmino
  },
  "/ibc.core.channel.v1.MsgAcknowledgement": {
    aminoType: "cosmos-sdk/MsgAcknowledgement",
    toAmino: channel_v1_tx.MsgAcknowledgement.toAmino,
    fromAmino: channel_v1_tx.MsgAcknowledgement.fromAmino
  }
};
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/ibc/core/client/v1/tx.amino.js
//@ts-nocheck

const client_v1_tx_amino_AminoConverter = {
  "/ibc.core.client.v1.MsgCreateClient": {
    aminoType: "cosmos-sdk/MsgCreateClient",
    toAmino: client_v1_tx.MsgCreateClient.toAmino,
    fromAmino: client_v1_tx.MsgCreateClient.fromAmino
  },
  "/ibc.core.client.v1.MsgUpdateClient": {
    aminoType: "cosmos-sdk/MsgUpdateClient",
    toAmino: client_v1_tx.MsgUpdateClient.toAmino,
    fromAmino: client_v1_tx.MsgUpdateClient.fromAmino
  },
  "/ibc.core.client.v1.MsgUpgradeClient": {
    aminoType: "cosmos-sdk/MsgUpgradeClient",
    toAmino: client_v1_tx.MsgUpgradeClient.toAmino,
    fromAmino: client_v1_tx.MsgUpgradeClient.fromAmino
  },
  "/ibc.core.client.v1.MsgSubmitMisbehaviour": {
    aminoType: "cosmos-sdk/MsgSubmitMisbehaviour",
    toAmino: client_v1_tx.MsgSubmitMisbehaviour.toAmino,
    fromAmino: client_v1_tx.MsgSubmitMisbehaviour.fromAmino
  }
};
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/ibc/core/connection/v1/tx.amino.js
//@ts-nocheck

const connection_v1_tx_amino_AminoConverter = {
  "/ibc.core.connection.v1.MsgConnectionOpenInit": {
    aminoType: "cosmos-sdk/MsgConnectionOpenInit",
    toAmino: connection_v1_tx.MsgConnectionOpenInit.toAmino,
    fromAmino: connection_v1_tx.MsgConnectionOpenInit.fromAmino
  },
  "/ibc.core.connection.v1.MsgConnectionOpenTry": {
    aminoType: "cosmos-sdk/MsgConnectionOpenTry",
    toAmino: connection_v1_tx.MsgConnectionOpenTry.toAmino,
    fromAmino: connection_v1_tx.MsgConnectionOpenTry.fromAmino
  },
  "/ibc.core.connection.v1.MsgConnectionOpenAck": {
    aminoType: "cosmos-sdk/MsgConnectionOpenAck",
    toAmino: connection_v1_tx.MsgConnectionOpenAck.toAmino,
    fromAmino: connection_v1_tx.MsgConnectionOpenAck.fromAmino
  },
  "/ibc.core.connection.v1.MsgConnectionOpenConfirm": {
    aminoType: "cosmos-sdk/MsgConnectionOpenConfirm",
    toAmino: connection_v1_tx.MsgConnectionOpenConfirm.toAmino,
    fromAmino: connection_v1_tx.MsgConnectionOpenConfirm.fromAmino
  }
};
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/ibc/applications/fee/v1/tx.registry.js
//@ts-nocheck

const v1_tx_registry_registry = [["/ibc.applications.fee.v1.MsgRegisterPayee", tx.MsgRegisterPayee], ["/ibc.applications.fee.v1.MsgRegisterCounterpartyPayee", tx.MsgRegisterCounterpartyPayee], ["/ibc.applications.fee.v1.MsgPayPacketFee", tx.MsgPayPacketFee], ["/ibc.applications.fee.v1.MsgPayPacketFeeAsync", tx.MsgPayPacketFeeAsync]];
const v1_tx_registry_load = protoRegistry => {
  v1_tx_registry_registry.forEach(([typeUrl, mod]) => {
    protoRegistry.register(typeUrl, mod);
  });
};
const v1_tx_registry_MessageComposer = {
  encoded: {
    registerPayee(value) {
      return {
        typeUrl: "/ibc.applications.fee.v1.MsgRegisterPayee",
        value: tx.MsgRegisterPayee.encode(value).finish()
      };
    },

    registerCounterpartyPayee(value) {
      return {
        typeUrl: "/ibc.applications.fee.v1.MsgRegisterCounterpartyPayee",
        value: tx.MsgRegisterCounterpartyPayee.encode(value).finish()
      };
    },

    payPacketFee(value) {
      return {
        typeUrl: "/ibc.applications.fee.v1.MsgPayPacketFee",
        value: tx.MsgPayPacketFee.encode(value).finish()
      };
    },

    payPacketFeeAsync(value) {
      return {
        typeUrl: "/ibc.applications.fee.v1.MsgPayPacketFeeAsync",
        value: tx.MsgPayPacketFeeAsync.encode(value).finish()
      };
    }

  },
  withTypeUrl: {
    registerPayee(value) {
      return {
        typeUrl: "/ibc.applications.fee.v1.MsgRegisterPayee",
        value
      };
    },

    registerCounterpartyPayee(value) {
      return {
        typeUrl: "/ibc.applications.fee.v1.MsgRegisterCounterpartyPayee",
        value
      };
    },

    payPacketFee(value) {
      return {
        typeUrl: "/ibc.applications.fee.v1.MsgPayPacketFee",
        value
      };
    },

    payPacketFeeAsync(value) {
      return {
        typeUrl: "/ibc.applications.fee.v1.MsgPayPacketFeeAsync",
        value
      };
    }

  },
  fromPartial: {
    registerPayee(value) {
      return {
        typeUrl: "/ibc.applications.fee.v1.MsgRegisterPayee",
        value: tx.MsgRegisterPayee.fromPartial(value)
      };
    },

    registerCounterpartyPayee(value) {
      return {
        typeUrl: "/ibc.applications.fee.v1.MsgRegisterCounterpartyPayee",
        value: tx.MsgRegisterCounterpartyPayee.fromPartial(value)
      };
    },

    payPacketFee(value) {
      return {
        typeUrl: "/ibc.applications.fee.v1.MsgPayPacketFee",
        value: tx.MsgPayPacketFee.fromPartial(value)
      };
    },

    payPacketFeeAsync(value) {
      return {
        typeUrl: "/ibc.applications.fee.v1.MsgPayPacketFeeAsync",
        value: tx.MsgPayPacketFeeAsync.fromPartial(value)
      };
    }

  }
};
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/ibc/applications/interchain_accounts/controller/v1/tx.registry.js
//@ts-nocheck

const controller_v1_tx_registry_registry = [["/ibc.applications.interchain_accounts.controller.v1.MsgRegisterInterchainAccount", v1_tx.MsgRegisterInterchainAccount], ["/ibc.applications.interchain_accounts.controller.v1.MsgSendTx", v1_tx.MsgSendTx]];
const controller_v1_tx_registry_load = protoRegistry => {
  controller_v1_tx_registry_registry.forEach(([typeUrl, mod]) => {
    protoRegistry.register(typeUrl, mod);
  });
};
const controller_v1_tx_registry_MessageComposer = {
  encoded: {
    registerInterchainAccount(value) {
      return {
        typeUrl: "/ibc.applications.interchain_accounts.controller.v1.MsgRegisterInterchainAccount",
        value: v1_tx.MsgRegisterInterchainAccount.encode(value).finish()
      };
    },

    sendTx(value) {
      return {
        typeUrl: "/ibc.applications.interchain_accounts.controller.v1.MsgSendTx",
        value: v1_tx.MsgSendTx.encode(value).finish()
      };
    }

  },
  withTypeUrl: {
    registerInterchainAccount(value) {
      return {
        typeUrl: "/ibc.applications.interchain_accounts.controller.v1.MsgRegisterInterchainAccount",
        value
      };
    },

    sendTx(value) {
      return {
        typeUrl: "/ibc.applications.interchain_accounts.controller.v1.MsgSendTx",
        value
      };
    }

  },
  fromPartial: {
    registerInterchainAccount(value) {
      return {
        typeUrl: "/ibc.applications.interchain_accounts.controller.v1.MsgRegisterInterchainAccount",
        value: v1_tx.MsgRegisterInterchainAccount.fromPartial(value)
      };
    },

    sendTx(value) {
      return {
        typeUrl: "/ibc.applications.interchain_accounts.controller.v1.MsgSendTx",
        value: v1_tx.MsgSendTx.fromPartial(value)
      };
    }

  }
};
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/ibc/applications/transfer/v1/tx.registry.js
//@ts-nocheck

const transfer_v1_tx_registry_registry = [["/ibc.applications.transfer.v1.MsgTransfer", transfer_v1_tx.MsgTransfer]];
const transfer_v1_tx_registry_load = protoRegistry => {
  transfer_v1_tx_registry_registry.forEach(([typeUrl, mod]) => {
    protoRegistry.register(typeUrl, mod);
  });
};
const transfer_v1_tx_registry_MessageComposer = {
  encoded: {
    transfer(value) {
      return {
        typeUrl: "/ibc.applications.transfer.v1.MsgTransfer",
        value: transfer_v1_tx.MsgTransfer.encode(value).finish()
      };
    }

  },
  withTypeUrl: {
    transfer(value) {
      return {
        typeUrl: "/ibc.applications.transfer.v1.MsgTransfer",
        value
      };
    }

  },
  fromPartial: {
    transfer(value) {
      return {
        typeUrl: "/ibc.applications.transfer.v1.MsgTransfer",
        value: transfer_v1_tx.MsgTransfer.fromPartial(value)
      };
    }

  }
};
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/ibc/core/channel/v1/tx.registry.js
//@ts-nocheck

const channel_v1_tx_registry_registry = [["/ibc.core.channel.v1.MsgChannelOpenInit", channel_v1_tx.MsgChannelOpenInit], ["/ibc.core.channel.v1.MsgChannelOpenTry", channel_v1_tx.MsgChannelOpenTry], ["/ibc.core.channel.v1.MsgChannelOpenAck", channel_v1_tx.MsgChannelOpenAck], ["/ibc.core.channel.v1.MsgChannelOpenConfirm", channel_v1_tx.MsgChannelOpenConfirm], ["/ibc.core.channel.v1.MsgChannelCloseInit", channel_v1_tx.MsgChannelCloseInit], ["/ibc.core.channel.v1.MsgChannelCloseConfirm", channel_v1_tx.MsgChannelCloseConfirm], ["/ibc.core.channel.v1.MsgRecvPacket", channel_v1_tx.MsgRecvPacket], ["/ibc.core.channel.v1.MsgTimeout", channel_v1_tx.MsgTimeout], ["/ibc.core.channel.v1.MsgTimeoutOnClose", channel_v1_tx.MsgTimeoutOnClose], ["/ibc.core.channel.v1.MsgAcknowledgement", channel_v1_tx.MsgAcknowledgement]];
const channel_v1_tx_registry_load = protoRegistry => {
  channel_v1_tx_registry_registry.forEach(([typeUrl, mod]) => {
    protoRegistry.register(typeUrl, mod);
  });
};
const channel_v1_tx_registry_MessageComposer = {
  encoded: {
    channelOpenInit(value) {
      return {
        typeUrl: "/ibc.core.channel.v1.MsgChannelOpenInit",
        value: channel_v1_tx.MsgChannelOpenInit.encode(value).finish()
      };
    },

    channelOpenTry(value) {
      return {
        typeUrl: "/ibc.core.channel.v1.MsgChannelOpenTry",
        value: channel_v1_tx.MsgChannelOpenTry.encode(value).finish()
      };
    },

    channelOpenAck(value) {
      return {
        typeUrl: "/ibc.core.channel.v1.MsgChannelOpenAck",
        value: channel_v1_tx.MsgChannelOpenAck.encode(value).finish()
      };
    },

    channelOpenConfirm(value) {
      return {
        typeUrl: "/ibc.core.channel.v1.MsgChannelOpenConfirm",
        value: channel_v1_tx.MsgChannelOpenConfirm.encode(value).finish()
      };
    },

    channelCloseInit(value) {
      return {
        typeUrl: "/ibc.core.channel.v1.MsgChannelCloseInit",
        value: channel_v1_tx.MsgChannelCloseInit.encode(value).finish()
      };
    },

    channelCloseConfirm(value) {
      return {
        typeUrl: "/ibc.core.channel.v1.MsgChannelCloseConfirm",
        value: channel_v1_tx.MsgChannelCloseConfirm.encode(value).finish()
      };
    },

    recvPacket(value) {
      return {
        typeUrl: "/ibc.core.channel.v1.MsgRecvPacket",
        value: channel_v1_tx.MsgRecvPacket.encode(value).finish()
      };
    },

    timeout(value) {
      return {
        typeUrl: "/ibc.core.channel.v1.MsgTimeout",
        value: channel_v1_tx.MsgTimeout.encode(value).finish()
      };
    },

    timeoutOnClose(value) {
      return {
        typeUrl: "/ibc.core.channel.v1.MsgTimeoutOnClose",
        value: channel_v1_tx.MsgTimeoutOnClose.encode(value).finish()
      };
    },

    acknowledgement(value) {
      return {
        typeUrl: "/ibc.core.channel.v1.MsgAcknowledgement",
        value: channel_v1_tx.MsgAcknowledgement.encode(value).finish()
      };
    }

  },
  withTypeUrl: {
    channelOpenInit(value) {
      return {
        typeUrl: "/ibc.core.channel.v1.MsgChannelOpenInit",
        value
      };
    },

    channelOpenTry(value) {
      return {
        typeUrl: "/ibc.core.channel.v1.MsgChannelOpenTry",
        value
      };
    },

    channelOpenAck(value) {
      return {
        typeUrl: "/ibc.core.channel.v1.MsgChannelOpenAck",
        value
      };
    },

    channelOpenConfirm(value) {
      return {
        typeUrl: "/ibc.core.channel.v1.MsgChannelOpenConfirm",
        value
      };
    },

    channelCloseInit(value) {
      return {
        typeUrl: "/ibc.core.channel.v1.MsgChannelCloseInit",
        value
      };
    },

    channelCloseConfirm(value) {
      return {
        typeUrl: "/ibc.core.channel.v1.MsgChannelCloseConfirm",
        value
      };
    },

    recvPacket(value) {
      return {
        typeUrl: "/ibc.core.channel.v1.MsgRecvPacket",
        value
      };
    },

    timeout(value) {
      return {
        typeUrl: "/ibc.core.channel.v1.MsgTimeout",
        value
      };
    },

    timeoutOnClose(value) {
      return {
        typeUrl: "/ibc.core.channel.v1.MsgTimeoutOnClose",
        value
      };
    },

    acknowledgement(value) {
      return {
        typeUrl: "/ibc.core.channel.v1.MsgAcknowledgement",
        value
      };
    }

  },
  fromPartial: {
    channelOpenInit(value) {
      return {
        typeUrl: "/ibc.core.channel.v1.MsgChannelOpenInit",
        value: channel_v1_tx.MsgChannelOpenInit.fromPartial(value)
      };
    },

    channelOpenTry(value) {
      return {
        typeUrl: "/ibc.core.channel.v1.MsgChannelOpenTry",
        value: channel_v1_tx.MsgChannelOpenTry.fromPartial(value)
      };
    },

    channelOpenAck(value) {
      return {
        typeUrl: "/ibc.core.channel.v1.MsgChannelOpenAck",
        value: channel_v1_tx.MsgChannelOpenAck.fromPartial(value)
      };
    },

    channelOpenConfirm(value) {
      return {
        typeUrl: "/ibc.core.channel.v1.MsgChannelOpenConfirm",
        value: channel_v1_tx.MsgChannelOpenConfirm.fromPartial(value)
      };
    },

    channelCloseInit(value) {
      return {
        typeUrl: "/ibc.core.channel.v1.MsgChannelCloseInit",
        value: channel_v1_tx.MsgChannelCloseInit.fromPartial(value)
      };
    },

    channelCloseConfirm(value) {
      return {
        typeUrl: "/ibc.core.channel.v1.MsgChannelCloseConfirm",
        value: channel_v1_tx.MsgChannelCloseConfirm.fromPartial(value)
      };
    },

    recvPacket(value) {
      return {
        typeUrl: "/ibc.core.channel.v1.MsgRecvPacket",
        value: channel_v1_tx.MsgRecvPacket.fromPartial(value)
      };
    },

    timeout(value) {
      return {
        typeUrl: "/ibc.core.channel.v1.MsgTimeout",
        value: channel_v1_tx.MsgTimeout.fromPartial(value)
      };
    },

    timeoutOnClose(value) {
      return {
        typeUrl: "/ibc.core.channel.v1.MsgTimeoutOnClose",
        value: channel_v1_tx.MsgTimeoutOnClose.fromPartial(value)
      };
    },

    acknowledgement(value) {
      return {
        typeUrl: "/ibc.core.channel.v1.MsgAcknowledgement",
        value: channel_v1_tx.MsgAcknowledgement.fromPartial(value)
      };
    }

  }
};
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/ibc/core/client/v1/tx.registry.js
//@ts-nocheck

const client_v1_tx_registry_registry = [["/ibc.core.client.v1.MsgCreateClient", client_v1_tx.MsgCreateClient], ["/ibc.core.client.v1.MsgUpdateClient", client_v1_tx.MsgUpdateClient], ["/ibc.core.client.v1.MsgUpgradeClient", client_v1_tx.MsgUpgradeClient], ["/ibc.core.client.v1.MsgSubmitMisbehaviour", client_v1_tx.MsgSubmitMisbehaviour]];
const client_v1_tx_registry_load = protoRegistry => {
  client_v1_tx_registry_registry.forEach(([typeUrl, mod]) => {
    protoRegistry.register(typeUrl, mod);
  });
};
const client_v1_tx_registry_MessageComposer = {
  encoded: {
    createClient(value) {
      return {
        typeUrl: "/ibc.core.client.v1.MsgCreateClient",
        value: client_v1_tx.MsgCreateClient.encode(value).finish()
      };
    },

    updateClient(value) {
      return {
        typeUrl: "/ibc.core.client.v1.MsgUpdateClient",
        value: client_v1_tx.MsgUpdateClient.encode(value).finish()
      };
    },

    upgradeClient(value) {
      return {
        typeUrl: "/ibc.core.client.v1.MsgUpgradeClient",
        value: client_v1_tx.MsgUpgradeClient.encode(value).finish()
      };
    },

    submitMisbehaviour(value) {
      return {
        typeUrl: "/ibc.core.client.v1.MsgSubmitMisbehaviour",
        value: client_v1_tx.MsgSubmitMisbehaviour.encode(value).finish()
      };
    }

  },
  withTypeUrl: {
    createClient(value) {
      return {
        typeUrl: "/ibc.core.client.v1.MsgCreateClient",
        value
      };
    },

    updateClient(value) {
      return {
        typeUrl: "/ibc.core.client.v1.MsgUpdateClient",
        value
      };
    },

    upgradeClient(value) {
      return {
        typeUrl: "/ibc.core.client.v1.MsgUpgradeClient",
        value
      };
    },

    submitMisbehaviour(value) {
      return {
        typeUrl: "/ibc.core.client.v1.MsgSubmitMisbehaviour",
        value
      };
    }

  },
  fromPartial: {
    createClient(value) {
      return {
        typeUrl: "/ibc.core.client.v1.MsgCreateClient",
        value: client_v1_tx.MsgCreateClient.fromPartial(value)
      };
    },

    updateClient(value) {
      return {
        typeUrl: "/ibc.core.client.v1.MsgUpdateClient",
        value: client_v1_tx.MsgUpdateClient.fromPartial(value)
      };
    },

    upgradeClient(value) {
      return {
        typeUrl: "/ibc.core.client.v1.MsgUpgradeClient",
        value: client_v1_tx.MsgUpgradeClient.fromPartial(value)
      };
    },

    submitMisbehaviour(value) {
      return {
        typeUrl: "/ibc.core.client.v1.MsgSubmitMisbehaviour",
        value: client_v1_tx.MsgSubmitMisbehaviour.fromPartial(value)
      };
    }

  }
};
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/ibc/core/connection/v1/tx.registry.js
//@ts-nocheck

const connection_v1_tx_registry_registry = [["/ibc.core.connection.v1.MsgConnectionOpenInit", connection_v1_tx.MsgConnectionOpenInit], ["/ibc.core.connection.v1.MsgConnectionOpenTry", connection_v1_tx.MsgConnectionOpenTry], ["/ibc.core.connection.v1.MsgConnectionOpenAck", connection_v1_tx.MsgConnectionOpenAck], ["/ibc.core.connection.v1.MsgConnectionOpenConfirm", connection_v1_tx.MsgConnectionOpenConfirm]];
const connection_v1_tx_registry_load = protoRegistry => {
  connection_v1_tx_registry_registry.forEach(([typeUrl, mod]) => {
    protoRegistry.register(typeUrl, mod);
  });
};
const connection_v1_tx_registry_MessageComposer = {
  encoded: {
    connectionOpenInit(value) {
      return {
        typeUrl: "/ibc.core.connection.v1.MsgConnectionOpenInit",
        value: connection_v1_tx.MsgConnectionOpenInit.encode(value).finish()
      };
    },

    connectionOpenTry(value) {
      return {
        typeUrl: "/ibc.core.connection.v1.MsgConnectionOpenTry",
        value: connection_v1_tx.MsgConnectionOpenTry.encode(value).finish()
      };
    },

    connectionOpenAck(value) {
      return {
        typeUrl: "/ibc.core.connection.v1.MsgConnectionOpenAck",
        value: connection_v1_tx.MsgConnectionOpenAck.encode(value).finish()
      };
    },

    connectionOpenConfirm(value) {
      return {
        typeUrl: "/ibc.core.connection.v1.MsgConnectionOpenConfirm",
        value: connection_v1_tx.MsgConnectionOpenConfirm.encode(value).finish()
      };
    }

  },
  withTypeUrl: {
    connectionOpenInit(value) {
      return {
        typeUrl: "/ibc.core.connection.v1.MsgConnectionOpenInit",
        value
      };
    },

    connectionOpenTry(value) {
      return {
        typeUrl: "/ibc.core.connection.v1.MsgConnectionOpenTry",
        value
      };
    },

    connectionOpenAck(value) {
      return {
        typeUrl: "/ibc.core.connection.v1.MsgConnectionOpenAck",
        value
      };
    },

    connectionOpenConfirm(value) {
      return {
        typeUrl: "/ibc.core.connection.v1.MsgConnectionOpenConfirm",
        value
      };
    }

  },
  fromPartial: {
    connectionOpenInit(value) {
      return {
        typeUrl: "/ibc.core.connection.v1.MsgConnectionOpenInit",
        value: connection_v1_tx.MsgConnectionOpenInit.fromPartial(value)
      };
    },

    connectionOpenTry(value) {
      return {
        typeUrl: "/ibc.core.connection.v1.MsgConnectionOpenTry",
        value: connection_v1_tx.MsgConnectionOpenTry.fromPartial(value)
      };
    },

    connectionOpenAck(value) {
      return {
        typeUrl: "/ibc.core.connection.v1.MsgConnectionOpenAck",
        value: connection_v1_tx.MsgConnectionOpenAck.fromPartial(value)
      };
    },

    connectionOpenConfirm(value) {
      return {
        typeUrl: "/ibc.core.connection.v1.MsgConnectionOpenConfirm",
        value: connection_v1_tx.MsgConnectionOpenConfirm.fromPartial(value)
      };
    }

  }
};
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/ibc/applications/fee/v1/query.lcd.js
var v1_query_lcd = __webpack_require__(79903);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/ibc/applications/interchain_accounts/controller/v1/query.lcd.js
var controller_v1_query_lcd = __webpack_require__(45789);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/ibc/applications/interchain_accounts/host/v1/query.lcd.js
var host_v1_query_lcd = __webpack_require__(41918);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/ibc/applications/transfer/v1/query.lcd.js
var transfer_v1_query_lcd = __webpack_require__(95693);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/ibc/core/channel/v1/query.lcd.js
var channel_v1_query_lcd = __webpack_require__(18320);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/ibc/core/client/v1/query.lcd.js
var client_v1_query_lcd = __webpack_require__(58251);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/ibc/core/connection/v1/query.lcd.js
var connection_v1_query_lcd = __webpack_require__(15428);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/ibc/applications/fee/v1/query.rpc.Query.js
var v1_query_rpc_Query = __webpack_require__(87300);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/ibc/applications/interchain_accounts/controller/v1/query.rpc.Query.js
var controller_v1_query_rpc_Query = __webpack_require__(6318);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/ibc/applications/interchain_accounts/host/v1/query.rpc.Query.js
var host_v1_query_rpc_Query = __webpack_require__(7651);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/ibc/applications/transfer/v1/query.rpc.Query.js
var transfer_v1_query_rpc_Query = __webpack_require__(13159);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/ibc/core/channel/v1/query.rpc.Query.js
var channel_v1_query_rpc_Query = __webpack_require__(34693);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/ibc/core/client/v1/query.rpc.Query.js
var client_v1_query_rpc_Query = __webpack_require__(93738);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/ibc/core/connection/v1/query.rpc.Query.js
var connection_v1_query_rpc_Query = __webpack_require__(50290);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/ibc/applications/fee/v1/tx.rpc.msg.js
var v1_tx_rpc_msg = __webpack_require__(30472);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/ibc/applications/interchain_accounts/controller/v1/tx.rpc.msg.js
var controller_v1_tx_rpc_msg = __webpack_require__(27147);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/ibc/applications/transfer/v1/tx.rpc.msg.js
var transfer_v1_tx_rpc_msg = __webpack_require__(69402);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/ibc/core/channel/v1/tx.rpc.msg.js
var channel_v1_tx_rpc_msg = __webpack_require__(81922);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/ibc/core/client/v1/tx.rpc.msg.js
var client_v1_tx_rpc_msg = __webpack_require__(25430);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/ibc/core/connection/v1/tx.rpc.msg.js
var connection_v1_tx_rpc_msg = __webpack_require__(10990);
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/ibc/lcd.js

const lcd_createLCDClient = async ({
  restEndpoint
}) => {
  const requestClient = new LCDClient({
    restEndpoint
  });
  return {
    cosmos: {
      auth: {
        v1beta1: new (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 88436))).LCDQueryClient({
          requestClient
        })
      },
      authz: {
        v1beta1: new (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 73300))).LCDQueryClient({
          requestClient
        })
      },
      bank: {
        v1beta1: new (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 79926))).LCDQueryClient({
          requestClient
        })
      },
      base: {
        node: {
          v1beta1: new (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 91318))).LCDQueryClient({
            requestClient
          })
        }
      },
      distribution: {
        v1beta1: new (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 39))).LCDQueryClient({
          requestClient
        })
      },
      gov: {
        v1beta1: new (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 3571))).LCDQueryClient({
          requestClient
        })
      },
      staking: {
        v1beta1: new (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 24800))).LCDQueryClient({
          requestClient
        })
      },
      tx: {
        v1beta1: new (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 57994))).LCDQueryClient({
          requestClient
        })
      },
      upgrade: {
        v1beta1: new (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 67931))).LCDQueryClient({
          requestClient
        })
      }
    },
    ibc: {
      applications: {
        fee: {
          v1: new (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 79903))).LCDQueryClient({
            requestClient
          })
        },
        interchain_accounts: {
          controller: {
            v1: new (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 45789))).LCDQueryClient({
              requestClient
            })
          },
          host: {
            v1: new (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 41918))).LCDQueryClient({
              requestClient
            })
          }
        },
        transfer: {
          v1: new (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 95693))).LCDQueryClient({
            requestClient
          })
        }
      },
      core: {
        channel: {
          v1: new (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 18320))).LCDQueryClient({
            requestClient
          })
        },
        client: {
          v1: new (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 58251))).LCDQueryClient({
            requestClient
          })
        },
        connection: {
          v1: new (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 15428))).LCDQueryClient({
            requestClient
          })
        }
      }
    }
  };
};
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/ibc/rpc.query.js


const rpc_query_createRPCQueryClient = async ({
  rpcEndpoint
}) => {
  const tmClient = await build.Tendermint34Client.connect(rpcEndpoint);
  const client = new stargate_build.QueryClient(tmClient);
  return {
    cosmos: {
      auth: {
        v1beta1: (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 80908))).createRpcQueryExtension(client)
      },
      authz: {
        v1beta1: (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 64139))).createRpcQueryExtension(client)
      },
      bank: {
        v1beta1: (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 3889))).createRpcQueryExtension(client)
      },
      base: {
        node: {
          v1beta1: (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 12345))).createRpcQueryExtension(client)
        }
      },
      distribution: {
        v1beta1: (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 23727))).createRpcQueryExtension(client)
      },
      gov: {
        v1beta1: (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 96921))).createRpcQueryExtension(client)
      },
      staking: {
        v1beta1: (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 56860))).createRpcQueryExtension(client)
      },
      tx: {
        v1beta1: (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 82478))).createRpcQueryExtension(client)
      },
      upgrade: {
        v1beta1: (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 94898))).createRpcQueryExtension(client)
      }
    },
    ibc: {
      applications: {
        fee: {
          v1: (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 87300))).createRpcQueryExtension(client)
        },
        interchain_accounts: {
          controller: {
            v1: (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 6318))).createRpcQueryExtension(client)
          },
          host: {
            v1: (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 7651))).createRpcQueryExtension(client)
          }
        },
        transfer: {
          v1: (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 13159))).createRpcQueryExtension(client)
        }
      },
      core: {
        channel: {
          v1: (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 34693))).createRpcQueryExtension(client)
        },
        client: {
          v1: (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 93738))).createRpcQueryExtension(client)
        },
        connection: {
          v1: (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 50290))).createRpcQueryExtension(client)
        }
      }
    }
  };
};
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/ibc/rpc.tx.js
const rpc_tx_createRPCMsgClient = async ({
  rpc
}) => ({
  cosmos: {
    authz: {
      v1beta1: new (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 35773))).MsgClientImpl(rpc)
    },
    bank: {
      v1beta1: new (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 85579))).MsgClientImpl(rpc)
    },
    distribution: {
      v1beta1: new (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 9689))).MsgClientImpl(rpc)
    },
    gov: {
      v1beta1: new (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 3207))).MsgClientImpl(rpc)
    },
    staking: {
      v1beta1: new (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 34191))).MsgClientImpl(rpc)
    }
  },
  ibc: {
    applications: {
      fee: {
        v1: new (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 30472))).MsgClientImpl(rpc)
      },
      interchain_accounts: {
        controller: {
          v1: new (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 27147))).MsgClientImpl(rpc)
        }
      },
      transfer: {
        v1: new (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 69402))).MsgClientImpl(rpc)
      }
    },
    core: {
      channel: {
        v1: new (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 81922))).MsgClientImpl(rpc)
      },
      client: {
        v1: new (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 25430))).MsgClientImpl(rpc)
      },
      connection: {
        v1: new (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 10990))).MsgClientImpl(rpc)
      }
    }
  }
});
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/ibc/bundle.js


function ibc_bundle_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function ibc_bundle_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ibc_bundle_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ibc_bundle_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }










































































let ibc;

(function (_ibc) {
  let applications;

  (function (_applications) {
    let fee;

    (function (_fee) {
      const v1 = _fee.v1 = ibc_bundle_objectSpread(ibc_bundle_objectSpread(ibc_bundle_objectSpread(ibc_bundle_objectSpread(ibc_bundle_objectSpread(ibc_bundle_objectSpread(ibc_bundle_objectSpread(ibc_bundle_objectSpread(ibc_bundle_objectSpread(ibc_bundle_objectSpread(ibc_bundle_objectSpread({}, ack_namespaceObject), v1_fee), genesis), metadata_namespaceObject), v1_query), tx), v1_tx_amino_namespaceObject), v1_tx_registry_namespaceObject), v1_query_lcd), v1_query_rpc_Query), v1_tx_rpc_msg);
    })(fee || (fee = _applications.fee || (_applications.fee = {})));

    let interchain_accounts;

    (function (_interchain_accounts) {
      let controller;

      (function (_controller) {
        const v1 = _controller.v1 = ibc_bundle_objectSpread(ibc_bundle_objectSpread(ibc_bundle_objectSpread(ibc_bundle_objectSpread(ibc_bundle_objectSpread(ibc_bundle_objectSpread(ibc_bundle_objectSpread(ibc_bundle_objectSpread({}, v1_controller), controller_v1_query), v1_tx), controller_v1_tx_amino_namespaceObject), controller_v1_tx_registry_namespaceObject), controller_v1_query_lcd), controller_v1_query_rpc_Query), controller_v1_tx_rpc_msg);
      })(controller || (controller = _interchain_accounts.controller || (_interchain_accounts.controller = {})));

      let genesis;

      (function (_genesis) {
        const v1 = _genesis.v1 = ibc_bundle_objectSpread({}, genesis_v1_genesis_namespaceObject);
      })(genesis || (genesis = _interchain_accounts.genesis || (_interchain_accounts.genesis = {})));

      let host;

      (function (_host) {
        const v1 = _host.v1 = ibc_bundle_objectSpread(ibc_bundle_objectSpread(ibc_bundle_objectSpread(ibc_bundle_objectSpread({}, v1_host), host_v1_query), host_v1_query_lcd), host_v1_query_rpc_Query);
      })(host || (host = _interchain_accounts.host || (_interchain_accounts.host = {})));

      const v1 = _interchain_accounts.v1 = ibc_bundle_objectSpread(ibc_bundle_objectSpread(ibc_bundle_objectSpread({}, account_namespaceObject), v1_metadata_namespaceObject), packet);
    })(interchain_accounts || (interchain_accounts = _applications.interchain_accounts || (_applications.interchain_accounts = {})));

    let transfer;

    (function (_transfer) {
      const v1 = _transfer.v1 = ibc_bundle_objectSpread(ibc_bundle_objectSpread(ibc_bundle_objectSpread(ibc_bundle_objectSpread(ibc_bundle_objectSpread(ibc_bundle_objectSpread(ibc_bundle_objectSpread(ibc_bundle_objectSpread(ibc_bundle_objectSpread(ibc_bundle_objectSpread({}, authz_namespaceObject), transfer_v1_genesis_namespaceObject), transfer_v1_query), v1_transfer), transfer_v1_tx), transfer_v1_tx_amino_namespaceObject), transfer_v1_tx_registry_namespaceObject), transfer_v1_query_lcd), transfer_v1_query_rpc_Query), transfer_v1_tx_rpc_msg);

      const v2 = _transfer.v2 = ibc_bundle_objectSpread({}, packet_namespaceObject);
    })(transfer || (transfer = _applications.transfer || (_applications.transfer = {})));
  })(applications || (applications = _ibc.applications || (_ibc.applications = {})));

  let core;

  (function (_core) {
    let channel;

    (function (_channel) {
      const v1 = _channel.v1 = ibc_bundle_objectSpread(ibc_bundle_objectSpread(ibc_bundle_objectSpread(ibc_bundle_objectSpread(ibc_bundle_objectSpread(ibc_bundle_objectSpread(ibc_bundle_objectSpread(ibc_bundle_objectSpread(ibc_bundle_objectSpread({}, v1_channel), channel_v1_genesis_namespaceObject), channel_v1_query), channel_v1_tx), channel_v1_tx_amino_namespaceObject), channel_v1_tx_registry_namespaceObject), channel_v1_query_lcd), channel_v1_query_rpc_Query), channel_v1_tx_rpc_msg);
    })(channel || (channel = _core.channel || (_core.channel = {})));

    let client;

    (function (_client) {
      const v1 = _client.v1 = ibc_bundle_objectSpread(ibc_bundle_objectSpread(ibc_bundle_objectSpread(ibc_bundle_objectSpread(ibc_bundle_objectSpread(ibc_bundle_objectSpread(ibc_bundle_objectSpread(ibc_bundle_objectSpread(ibc_bundle_objectSpread({}, v1_client), client_v1_genesis_namespaceObject), client_v1_query), client_v1_tx), client_v1_tx_amino_namespaceObject), client_v1_tx_registry_namespaceObject), client_v1_query_lcd), client_v1_query_rpc_Query), client_v1_tx_rpc_msg);
    })(client || (client = _core.client || (_core.client = {})));

    let commitment;

    (function (_commitment) {
      const v1 = _commitment.v1 = ibc_bundle_objectSpread({}, v1_commitment);
    })(commitment || (commitment = _core.commitment || (_core.commitment = {})));

    let connection;

    (function (_connection) {
      const v1 = _connection.v1 = ibc_bundle_objectSpread(ibc_bundle_objectSpread(ibc_bundle_objectSpread(ibc_bundle_objectSpread(ibc_bundle_objectSpread(ibc_bundle_objectSpread(ibc_bundle_objectSpread(ibc_bundle_objectSpread(ibc_bundle_objectSpread({}, v1_connection), connection_v1_genesis_namespaceObject), connection_v1_query), connection_v1_tx), connection_v1_tx_amino_namespaceObject), connection_v1_tx_registry_namespaceObject), connection_v1_query_lcd), connection_v1_query_rpc_Query), connection_v1_tx_rpc_msg);
    })(connection || (connection = _core.connection || (_core.connection = {})));
  })(core || (core = _ibc.core || (_ibc.core = {})));

  let lightclients;

  (function (_lightclients) {
    let localhost;

    (function (_localhost) {
      const v2 = _localhost.v2 = ibc_bundle_objectSpread({}, localhost_namespaceObject);
    })(localhost || (localhost = _lightclients.localhost || (_lightclients.localhost = {})));

    let solomachine;

    (function (_solomachine) {
      const v2 = _solomachine.v2 = ibc_bundle_objectSpread({}, solomachine_namespaceObject);

      const v3 = _solomachine.v3 = ibc_bundle_objectSpread({}, v3_solomachine_namespaceObject);
    })(solomachine || (solomachine = _lightclients.solomachine || (_lightclients.solomachine = {})));

    let tendermint;

    (function (_tendermint) {
      const v1 = _tendermint.v1 = ibc_bundle_objectSpread({}, tendermint_namespaceObject);
    })(tendermint || (tendermint = _lightclients.tendermint || (_lightclients.tendermint = {})));
  })(lightclients || (lightclients = _ibc.lightclients || (_ibc.lightclients = {})));

  const ClientFactory = _ibc.ClientFactory = ibc_bundle_objectSpread(ibc_bundle_objectSpread(ibc_bundle_objectSpread({}, ibc_lcd_namespaceObject), ibc_rpc_query_namespaceObject), ibc_rpc_tx_namespaceObject);
})(ibc || (ibc = {}));
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/ibc/client.js


function ibc_client_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function ibc_client_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ibc_client_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ibc_client_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }















const ibcAminoConverters = ibc_client_objectSpread(ibc_client_objectSpread(ibc_client_objectSpread(ibc_client_objectSpread(ibc_client_objectSpread(ibc_client_objectSpread({}, v1_tx_amino_AminoConverter), controller_v1_tx_amino_AminoConverter), transfer_v1_tx_amino_AminoConverter), channel_v1_tx_amino_AminoConverter), client_v1_tx_amino_AminoConverter), connection_v1_tx_amino_AminoConverter);
const ibcProtoRegistry = [...v1_tx_registry_registry, ...controller_v1_tx_registry_registry, ...transfer_v1_tx_registry_registry, ...channel_v1_tx_registry_registry, ...client_v1_tx_registry_registry, ...connection_v1_tx_registry_registry];
const getSigningIbcClientOptions = ({
  defaultTypes = defaultRegistryTypes
} = {}) => {
  const registry = new Registry([...defaultTypes, ...ibcProtoRegistry]);
  const aminoTypes = new AminoTypes(ibc_client_objectSpread({}, ibcAminoConverters));
  return {
    registry,
    aminoTypes
  };
};
const getSigningIbcClient = async ({
  rpcEndpoint,
  signer,
  defaultTypes = defaultRegistryTypes
}) => {
  const {
    registry,
    aminoTypes
  } = getSigningIbcClientOptions({
    defaultTypes
  });
  const client = await SigningStargateClient.connectWithSigner(rpcEndpoint, signer, {
    registry,
    aminoTypes
  });
  return client;
};
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/cosmwasm/wasm/v1/authz.js




/**
 * ContractExecutionAuthorization defines authorization for wasm execute.
 * Since: wasmd 0.30
 */

function createBaseContractExecutionAuthorization() {
  return {
    $typeUrl: "/cosmwasm.wasm.v1.ContractExecutionAuthorization",
    grants: []
  };
}

const ContractExecutionAuthorization = {
  typeUrl: "/cosmwasm.wasm.v1.ContractExecutionAuthorization",

  encode(message, writer = minimal.Writer.create()) {
    for (const v of message.grants) {
      ContractGrant.encode(v, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseContractExecutionAuthorization();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.grants.push(ContractGrant.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$grants;

    const message = createBaseContractExecutionAuthorization();
    message.grants = ((_object$grants = object.grants) === null || _object$grants === void 0 ? void 0 : _object$grants.map(e => ContractGrant.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      grants: Array.isArray(object === null || object === void 0 ? void 0 : object.grants) ? object.grants.map(e => ContractGrant.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.grants) {
      obj.grants = message.grants.map(e => e ? ContractGrant.toAmino(e) : undefined);
    } else {
      obj.grants = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return ContractExecutionAuthorization.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "wasm/ContractExecutionAuthorization",
      value: ContractExecutionAuthorization.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return ContractExecutionAuthorization.decode(message.value);
  },

  toProto(message) {
    return ContractExecutionAuthorization.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.ContractExecutionAuthorization",
      value: ContractExecutionAuthorization.encode(message).finish()
    };
  }

};

function createBaseContractMigrationAuthorization() {
  return {
    $typeUrl: "/cosmwasm.wasm.v1.ContractMigrationAuthorization",
    grants: []
  };
}

const ContractMigrationAuthorization = {
  typeUrl: "/cosmwasm.wasm.v1.ContractMigrationAuthorization",

  encode(message, writer = minimal.Writer.create()) {
    for (const v of message.grants) {
      ContractGrant.encode(v, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseContractMigrationAuthorization();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.grants.push(ContractGrant.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$grants2;

    const message = createBaseContractMigrationAuthorization();
    message.grants = ((_object$grants2 = object.grants) === null || _object$grants2 === void 0 ? void 0 : _object$grants2.map(e => ContractGrant.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      grants: Array.isArray(object === null || object === void 0 ? void 0 : object.grants) ? object.grants.map(e => ContractGrant.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.grants) {
      obj.grants = message.grants.map(e => e ? ContractGrant.toAmino(e) : undefined);
    } else {
      obj.grants = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return ContractMigrationAuthorization.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "wasm/ContractMigrationAuthorization",
      value: ContractMigrationAuthorization.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return ContractMigrationAuthorization.decode(message.value);
  },

  toProto(message) {
    return ContractMigrationAuthorization.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.ContractMigrationAuthorization",
      value: ContractMigrationAuthorization.encode(message).finish()
    };
  }

};

function createBaseContractGrant() {
  return {
    contract: "",
    limit: undefined,
    filter: undefined
  };
}

const ContractGrant = {
  typeUrl: "/cosmwasm.wasm.v1.ContractGrant",

  encode(message, writer = minimal.Writer.create()) {
    if (message.contract !== "") {
      writer.uint32(10).string(message.contract);
    }

    if (message.limit !== undefined) {
      any.Any.encode(message.limit, writer.uint32(18).fork()).ldelim();
    }

    if (message.filter !== undefined) {
      any.Any.encode(message.filter, writer.uint32(26).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseContractGrant();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.contract = reader.string();
          break;

        case 2:
          message.limit = Cosmwasm_wasmv1ContractAuthzLimitX_InterfaceDecoder(reader);
          break;

        case 3:
          message.filter = Cosmwasm_wasmv1ContractAuthzFilterX_InterfaceDecoder(reader);
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$contract;

    const message = createBaseContractGrant();
    message.contract = (_object$contract = object.contract) !== null && _object$contract !== void 0 ? _object$contract : "";
    message.limit = object.limit !== undefined && object.limit !== null ? any.Any.fromPartial(object.limit) : undefined;
    message.filter = object.filter !== undefined && object.filter !== null ? any.Any.fromPartial(object.filter) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      contract: object.contract,
      limit: object !== null && object !== void 0 && object.limit ? Cosmwasm_wasmv1ContractAuthzLimitX_FromAmino(object.limit) : undefined,
      filter: object !== null && object !== void 0 && object.filter ? Cosmwasm_wasmv1ContractAuthzFilterX_FromAmino(object.filter) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.contract = message.contract;
    obj.limit = message.limit ? Cosmwasm_wasmv1ContractAuthzLimitX_ToAmino(message.limit) : undefined;
    obj.filter = message.filter ? Cosmwasm_wasmv1ContractAuthzFilterX_ToAmino(message.filter) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return ContractGrant.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "wasm/ContractGrant",
      value: ContractGrant.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return ContractGrant.decode(message.value);
  },

  toProto(message) {
    return ContractGrant.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.ContractGrant",
      value: ContractGrant.encode(message).finish()
    };
  }

};

function createBaseMaxCallsLimit() {
  return {
    $typeUrl: "/cosmwasm.wasm.v1.MaxCallsLimit",
    remaining: helpers/* Long.UZERO */.dK.UZERO
  };
}

const MaxCallsLimit = {
  typeUrl: "/cosmwasm.wasm.v1.MaxCallsLimit",

  encode(message, writer = minimal.Writer.create()) {
    if (!message.remaining.isZero()) {
      writer.uint32(8).uint64(message.remaining);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMaxCallsLimit();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.remaining = reader.uint64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseMaxCallsLimit();
    message.remaining = object.remaining !== undefined && object.remaining !== null ? helpers/* Long.fromValue */.dK.fromValue(object.remaining) : helpers/* Long.UZERO */.dK.UZERO;
    return message;
  },

  fromAmino(object) {
    return {
      remaining: helpers/* Long.fromString */.dK.fromString(object.remaining)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.remaining = message.remaining ? message.remaining.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return MaxCallsLimit.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "wasm/MaxCallsLimit",
      value: MaxCallsLimit.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MaxCallsLimit.decode(message.value);
  },

  toProto(message) {
    return MaxCallsLimit.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.MaxCallsLimit",
      value: MaxCallsLimit.encode(message).finish()
    };
  }

};

function createBaseMaxFundsLimit() {
  return {
    $typeUrl: "/cosmwasm.wasm.v1.MaxFundsLimit",
    amounts: []
  };
}

const MaxFundsLimit = {
  typeUrl: "/cosmwasm.wasm.v1.MaxFundsLimit",

  encode(message, writer = minimal.Writer.create()) {
    for (const v of message.amounts) {
      coin.Coin.encode(v, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMaxFundsLimit();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.amounts.push(coin.Coin.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$amounts;

    const message = createBaseMaxFundsLimit();
    message.amounts = ((_object$amounts = object.amounts) === null || _object$amounts === void 0 ? void 0 : _object$amounts.map(e => coin.Coin.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      amounts: Array.isArray(object === null || object === void 0 ? void 0 : object.amounts) ? object.amounts.map(e => coin.Coin.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.amounts) {
      obj.amounts = message.amounts.map(e => e ? coin.Coin.toAmino(e) : undefined);
    } else {
      obj.amounts = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return MaxFundsLimit.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "wasm/MaxFundsLimit",
      value: MaxFundsLimit.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MaxFundsLimit.decode(message.value);
  },

  toProto(message) {
    return MaxFundsLimit.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.MaxFundsLimit",
      value: MaxFundsLimit.encode(message).finish()
    };
  }

};

function createBaseCombinedLimit() {
  return {
    $typeUrl: "/cosmwasm.wasm.v1.CombinedLimit",
    callsRemaining: helpers/* Long.UZERO */.dK.UZERO,
    amounts: []
  };
}

const CombinedLimit = {
  typeUrl: "/cosmwasm.wasm.v1.CombinedLimit",

  encode(message, writer = minimal.Writer.create()) {
    if (!message.callsRemaining.isZero()) {
      writer.uint32(8).uint64(message.callsRemaining);
    }

    for (const v of message.amounts) {
      coin.Coin.encode(v, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCombinedLimit();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.callsRemaining = reader.uint64();
          break;

        case 2:
          message.amounts.push(coin.Coin.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$amounts2;

    const message = createBaseCombinedLimit();
    message.callsRemaining = object.callsRemaining !== undefined && object.callsRemaining !== null ? helpers/* Long.fromValue */.dK.fromValue(object.callsRemaining) : helpers/* Long.UZERO */.dK.UZERO;
    message.amounts = ((_object$amounts2 = object.amounts) === null || _object$amounts2 === void 0 ? void 0 : _object$amounts2.map(e => coin.Coin.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      callsRemaining: helpers/* Long.fromString */.dK.fromString(object.calls_remaining),
      amounts: Array.isArray(object === null || object === void 0 ? void 0 : object.amounts) ? object.amounts.map(e => coin.Coin.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.calls_remaining = message.callsRemaining ? message.callsRemaining.toString() : undefined;

    if (message.amounts) {
      obj.amounts = message.amounts.map(e => e ? coin.Coin.toAmino(e) : undefined);
    } else {
      obj.amounts = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return CombinedLimit.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "wasm/CombinedLimit",
      value: CombinedLimit.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return CombinedLimit.decode(message.value);
  },

  toProto(message) {
    return CombinedLimit.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.CombinedLimit",
      value: CombinedLimit.encode(message).finish()
    };
  }

};

function createBaseAllowAllMessagesFilter() {
  return {
    $typeUrl: "/cosmwasm.wasm.v1.AllowAllMessagesFilter"
  };
}

const AllowAllMessagesFilter = {
  typeUrl: "/cosmwasm.wasm.v1.AllowAllMessagesFilter",

  encode(_, writer = minimal.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAllowAllMessagesFilter();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseAllowAllMessagesFilter();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return AllowAllMessagesFilter.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "wasm/AllowAllMessagesFilter",
      value: AllowAllMessagesFilter.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return AllowAllMessagesFilter.decode(message.value);
  },

  toProto(message) {
    return AllowAllMessagesFilter.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.AllowAllMessagesFilter",
      value: AllowAllMessagesFilter.encode(message).finish()
    };
  }

};

function createBaseAcceptedMessageKeysFilter() {
  return {
    $typeUrl: "/cosmwasm.wasm.v1.AcceptedMessageKeysFilter",
    keys: []
  };
}

const AcceptedMessageKeysFilter = {
  typeUrl: "/cosmwasm.wasm.v1.AcceptedMessageKeysFilter",

  encode(message, writer = minimal.Writer.create()) {
    for (const v of message.keys) {
      writer.uint32(10).string(v);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAcceptedMessageKeysFilter();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.keys.push(reader.string());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$keys;

    const message = createBaseAcceptedMessageKeysFilter();
    message.keys = ((_object$keys = object.keys) === null || _object$keys === void 0 ? void 0 : _object$keys.map(e => e)) || [];
    return message;
  },

  fromAmino(object) {
    return {
      keys: Array.isArray(object === null || object === void 0 ? void 0 : object.keys) ? object.keys.map(e => e) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.keys) {
      obj.keys = message.keys.map(e => e);
    } else {
      obj.keys = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return AcceptedMessageKeysFilter.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "wasm/AcceptedMessageKeysFilter",
      value: AcceptedMessageKeysFilter.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return AcceptedMessageKeysFilter.decode(message.value);
  },

  toProto(message) {
    return AcceptedMessageKeysFilter.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.AcceptedMessageKeysFilter",
      value: AcceptedMessageKeysFilter.encode(message).finish()
    };
  }

};

function createBaseAcceptedMessagesFilter() {
  return {
    $typeUrl: "/cosmwasm.wasm.v1.AcceptedMessagesFilter",
    messages: []
  };
}

const AcceptedMessagesFilter = {
  typeUrl: "/cosmwasm.wasm.v1.AcceptedMessagesFilter",

  encode(message, writer = minimal.Writer.create()) {
    for (const v of message.messages) {
      writer.uint32(10).bytes(v);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAcceptedMessagesFilter();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.messages.push(reader.bytes());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$messages;

    const message = createBaseAcceptedMessagesFilter();
    message.messages = ((_object$messages = object.messages) === null || _object$messages === void 0 ? void 0 : _object$messages.map(e => e)) || [];
    return message;
  },

  fromAmino(object) {
    return {
      messages: Array.isArray(object === null || object === void 0 ? void 0 : object.messages) ? object.messages.map(e => e) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.messages) {
      obj.messages = message.messages.map(e => e);
    } else {
      obj.messages = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return AcceptedMessagesFilter.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "wasm/AcceptedMessagesFilter",
      value: AcceptedMessagesFilter.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return AcceptedMessagesFilter.decode(message.value);
  },

  toProto(message) {
    return AcceptedMessagesFilter.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.AcceptedMessagesFilter",
      value: AcceptedMessagesFilter.encode(message).finish()
    };
  }

};
const Cosmwasm_wasmv1ContractAuthzLimitX_InterfaceDecoder = input => {
  const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
  const data = any.Any.decode(reader, reader.uint32());

  switch (data.typeUrl) {
    case "/cosmwasm.wasm.v1.MaxCallsLimit":
      return MaxCallsLimit.decode(data.value);

    case "/cosmwasm.wasm.v1.MaxFundsLimit":
      return MaxFundsLimit.decode(data.value);

    case "/cosmwasm.wasm.v1.CombinedLimit":
      return CombinedLimit.decode(data.value);

    default:
      return data;
  }
};
const Cosmwasm_wasmv1ContractAuthzLimitX_FromAmino = content => {
  switch (content.type) {
    case "wasm/MaxCallsLimit":
      return any.Any.fromPartial({
        typeUrl: "/cosmwasm.wasm.v1.MaxCallsLimit",
        value: MaxCallsLimit.encode(MaxCallsLimit.fromPartial(MaxCallsLimit.fromAmino(content.value))).finish()
      });

    case "wasm/MaxFundsLimit":
      return any.Any.fromPartial({
        typeUrl: "/cosmwasm.wasm.v1.MaxFundsLimit",
        value: MaxFundsLimit.encode(MaxFundsLimit.fromPartial(MaxFundsLimit.fromAmino(content.value))).finish()
      });

    case "wasm/CombinedLimit":
      return any.Any.fromPartial({
        typeUrl: "/cosmwasm.wasm.v1.CombinedLimit",
        value: CombinedLimit.encode(CombinedLimit.fromPartial(CombinedLimit.fromAmino(content.value))).finish()
      });

    default:
      return any.Any.fromAmino(content);
  }
};
const Cosmwasm_wasmv1ContractAuthzLimitX_ToAmino = content => {
  switch (content.typeUrl) {
    case "/cosmwasm.wasm.v1.MaxCallsLimit":
      return {
        type: "wasm/MaxCallsLimit",
        value: MaxCallsLimit.toAmino(MaxCallsLimit.decode(content.value))
      };

    case "/cosmwasm.wasm.v1.MaxFundsLimit":
      return {
        type: "wasm/MaxFundsLimit",
        value: MaxFundsLimit.toAmino(MaxFundsLimit.decode(content.value))
      };

    case "/cosmwasm.wasm.v1.CombinedLimit":
      return {
        type: "wasm/CombinedLimit",
        value: CombinedLimit.toAmino(CombinedLimit.decode(content.value))
      };

    default:
      return any.Any.toAmino(content);
  }
};
const Cosmwasm_wasmv1ContractAuthzFilterX_InterfaceDecoder = input => {
  const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
  const data = any.Any.decode(reader, reader.uint32());

  switch (data.typeUrl) {
    case "/cosmwasm.wasm.v1.AllowAllMessagesFilter":
      return AllowAllMessagesFilter.decode(data.value);

    case "/cosmwasm.wasm.v1.AcceptedMessageKeysFilter":
      return AcceptedMessageKeysFilter.decode(data.value);

    case "/cosmwasm.wasm.v1.AcceptedMessagesFilter":
      return AcceptedMessagesFilter.decode(data.value);

    default:
      return data;
  }
};
const Cosmwasm_wasmv1ContractAuthzFilterX_FromAmino = content => {
  switch (content.type) {
    case "wasm/AllowAllMessagesFilter":
      return any.Any.fromPartial({
        typeUrl: "/cosmwasm.wasm.v1.AllowAllMessagesFilter",
        value: AllowAllMessagesFilter.encode(AllowAllMessagesFilter.fromPartial(AllowAllMessagesFilter.fromAmino(content.value))).finish()
      });

    case "wasm/AcceptedMessageKeysFilter":
      return any.Any.fromPartial({
        typeUrl: "/cosmwasm.wasm.v1.AcceptedMessageKeysFilter",
        value: AcceptedMessageKeysFilter.encode(AcceptedMessageKeysFilter.fromPartial(AcceptedMessageKeysFilter.fromAmino(content.value))).finish()
      });

    case "wasm/AcceptedMessagesFilter":
      return any.Any.fromPartial({
        typeUrl: "/cosmwasm.wasm.v1.AcceptedMessagesFilter",
        value: AcceptedMessagesFilter.encode(AcceptedMessagesFilter.fromPartial(AcceptedMessagesFilter.fromAmino(content.value))).finish()
      });

    default:
      return any.Any.fromAmino(content);
  }
};
const Cosmwasm_wasmv1ContractAuthzFilterX_ToAmino = content => {
  switch (content.typeUrl) {
    case "/cosmwasm.wasm.v1.AllowAllMessagesFilter":
      return {
        type: "wasm/AllowAllMessagesFilter",
        value: AllowAllMessagesFilter.toAmino(AllowAllMessagesFilter.decode(content.value))
      };

    case "/cosmwasm.wasm.v1.AcceptedMessageKeysFilter":
      return {
        type: "wasm/AcceptedMessageKeysFilter",
        value: AcceptedMessageKeysFilter.toAmino(AcceptedMessageKeysFilter.decode(content.value))
      };

    case "/cosmwasm.wasm.v1.AcceptedMessagesFilter":
      return {
        type: "wasm/AcceptedMessagesFilter",
        value: AcceptedMessagesFilter.toAmino(AcceptedMessagesFilter.decode(content.value))
      };

    default:
      return any.Any.toAmino(content);
  }
};
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/cosmwasm/wasm/v1/types.js
var types = __webpack_require__(12315);
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/cosmwasm/wasm/v1/genesis.js



/** GenesisState - genesis state of x/wasm */

function wasm_v1_genesis_createBaseGenesisState() {
  return {
    params: undefined,
    codes: [],
    contracts: [],
    sequences: []
  };
}

const wasm_v1_genesis_GenesisState = {
  typeUrl: "/cosmwasm.wasm.v1.GenesisState",

  encode(message, writer = minimal.Writer.create()) {
    if (message.params !== undefined) {
      types.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
    }

    for (const v of message.codes) {
      Code.encode(v, writer.uint32(18).fork()).ldelim();
    }

    for (const v of message.contracts) {
      Contract.encode(v, writer.uint32(26).fork()).ldelim();
    }

    for (const v of message.sequences) {
      Sequence.encode(v, writer.uint32(34).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = wasm_v1_genesis_createBaseGenesisState();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.params = types.Params.decode(reader, reader.uint32());
          break;

        case 2:
          message.codes.push(Code.decode(reader, reader.uint32()));
          break;

        case 3:
          message.contracts.push(Contract.decode(reader, reader.uint32()));
          break;

        case 4:
          message.sequences.push(Sequence.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$codes, _object$contracts, _object$sequences;

    const message = wasm_v1_genesis_createBaseGenesisState();
    message.params = object.params !== undefined && object.params !== null ? types.Params.fromPartial(object.params) : undefined;
    message.codes = ((_object$codes = object.codes) === null || _object$codes === void 0 ? void 0 : _object$codes.map(e => Code.fromPartial(e))) || [];
    message.contracts = ((_object$contracts = object.contracts) === null || _object$contracts === void 0 ? void 0 : _object$contracts.map(e => Contract.fromPartial(e))) || [];
    message.sequences = ((_object$sequences = object.sequences) === null || _object$sequences === void 0 ? void 0 : _object$sequences.map(e => Sequence.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      params: object !== null && object !== void 0 && object.params ? types.Params.fromAmino(object.params) : undefined,
      codes: Array.isArray(object === null || object === void 0 ? void 0 : object.codes) ? object.codes.map(e => Code.fromAmino(e)) : [],
      contracts: Array.isArray(object === null || object === void 0 ? void 0 : object.contracts) ? object.contracts.map(e => Contract.fromAmino(e)) : [],
      sequences: Array.isArray(object === null || object === void 0 ? void 0 : object.sequences) ? object.sequences.map(e => Sequence.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.params = message.params ? types.Params.toAmino(message.params) : undefined;

    if (message.codes) {
      obj.codes = message.codes.map(e => e ? Code.toAmino(e) : undefined);
    } else {
      obj.codes = [];
    }

    if (message.contracts) {
      obj.contracts = message.contracts.map(e => e ? Contract.toAmino(e) : undefined);
    } else {
      obj.contracts = [];
    }

    if (message.sequences) {
      obj.sequences = message.sequences.map(e => e ? Sequence.toAmino(e) : undefined);
    } else {
      obj.sequences = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return wasm_v1_genesis_GenesisState.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "wasm/GenesisState",
      value: wasm_v1_genesis_GenesisState.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return wasm_v1_genesis_GenesisState.decode(message.value);
  },

  toProto(message) {
    return wasm_v1_genesis_GenesisState.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.GenesisState",
      value: wasm_v1_genesis_GenesisState.encode(message).finish()
    };
  }

};

function createBaseCode() {
  return {
    codeId: helpers/* Long.UZERO */.dK.UZERO,
    codeInfo: undefined,
    codeBytes: new Uint8Array(),
    pinned: false
  };
}

const Code = {
  typeUrl: "/cosmwasm.wasm.v1.Code",

  encode(message, writer = minimal.Writer.create()) {
    if (!message.codeId.isZero()) {
      writer.uint32(8).uint64(message.codeId);
    }

    if (message.codeInfo !== undefined) {
      types.CodeInfo.encode(message.codeInfo, writer.uint32(18).fork()).ldelim();
    }

    if (message.codeBytes.length !== 0) {
      writer.uint32(26).bytes(message.codeBytes);
    }

    if (message.pinned === true) {
      writer.uint32(32).bool(message.pinned);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCode();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.codeId = reader.uint64();
          break;

        case 2:
          message.codeInfo = types.CodeInfo.decode(reader, reader.uint32());
          break;

        case 3:
          message.codeBytes = reader.bytes();
          break;

        case 4:
          message.pinned = reader.bool();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$codeBytes, _object$pinned;

    const message = createBaseCode();
    message.codeId = object.codeId !== undefined && object.codeId !== null ? helpers/* Long.fromValue */.dK.fromValue(object.codeId) : helpers/* Long.UZERO */.dK.UZERO;
    message.codeInfo = object.codeInfo !== undefined && object.codeInfo !== null ? types.CodeInfo.fromPartial(object.codeInfo) : undefined;
    message.codeBytes = (_object$codeBytes = object.codeBytes) !== null && _object$codeBytes !== void 0 ? _object$codeBytes : new Uint8Array();
    message.pinned = (_object$pinned = object.pinned) !== null && _object$pinned !== void 0 ? _object$pinned : false;
    return message;
  },

  fromAmino(object) {
    return {
      codeId: helpers/* Long.fromString */.dK.fromString(object.code_id),
      codeInfo: object !== null && object !== void 0 && object.code_info ? types.CodeInfo.fromAmino(object.code_info) : undefined,
      codeBytes: object.code_bytes,
      pinned: object.pinned
    };
  },

  toAmino(message) {
    const obj = {};
    obj.code_id = message.codeId ? message.codeId.toString() : undefined;
    obj.code_info = message.codeInfo ? types.CodeInfo.toAmino(message.codeInfo) : undefined;
    obj.code_bytes = message.codeBytes;
    obj.pinned = message.pinned;
    return obj;
  },

  fromAminoMsg(object) {
    return Code.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "wasm/Code",
      value: Code.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return Code.decode(message.value);
  },

  toProto(message) {
    return Code.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.Code",
      value: Code.encode(message).finish()
    };
  }

};

function createBaseContract() {
  return {
    contractAddress: "",
    contractInfo: undefined,
    contractState: [],
    contractCodeHistory: []
  };
}

const Contract = {
  typeUrl: "/cosmwasm.wasm.v1.Contract",

  encode(message, writer = minimal.Writer.create()) {
    if (message.contractAddress !== "") {
      writer.uint32(10).string(message.contractAddress);
    }

    if (message.contractInfo !== undefined) {
      types.ContractInfo.encode(message.contractInfo, writer.uint32(18).fork()).ldelim();
    }

    for (const v of message.contractState) {
      types.Model.encode(v, writer.uint32(26).fork()).ldelim();
    }

    for (const v of message.contractCodeHistory) {
      types.ContractCodeHistoryEntry.encode(v, writer.uint32(34).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseContract();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.contractAddress = reader.string();
          break;

        case 2:
          message.contractInfo = types.ContractInfo.decode(reader, reader.uint32());
          break;

        case 3:
          message.contractState.push(types.Model.decode(reader, reader.uint32()));
          break;

        case 4:
          message.contractCodeHistory.push(types.ContractCodeHistoryEntry.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$contractAddre, _object$contractState, _object$contractCodeH;

    const message = createBaseContract();
    message.contractAddress = (_object$contractAddre = object.contractAddress) !== null && _object$contractAddre !== void 0 ? _object$contractAddre : "";
    message.contractInfo = object.contractInfo !== undefined && object.contractInfo !== null ? types.ContractInfo.fromPartial(object.contractInfo) : undefined;
    message.contractState = ((_object$contractState = object.contractState) === null || _object$contractState === void 0 ? void 0 : _object$contractState.map(e => types.Model.fromPartial(e))) || [];
    message.contractCodeHistory = ((_object$contractCodeH = object.contractCodeHistory) === null || _object$contractCodeH === void 0 ? void 0 : _object$contractCodeH.map(e => types.ContractCodeHistoryEntry.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      contractAddress: object.contract_address,
      contractInfo: object !== null && object !== void 0 && object.contract_info ? types.ContractInfo.fromAmino(object.contract_info) : undefined,
      contractState: Array.isArray(object === null || object === void 0 ? void 0 : object.contract_state) ? object.contract_state.map(e => types.Model.fromAmino(e)) : [],
      contractCodeHistory: Array.isArray(object === null || object === void 0 ? void 0 : object.contract_code_history) ? object.contract_code_history.map(e => types.ContractCodeHistoryEntry.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.contract_address = message.contractAddress;
    obj.contract_info = message.contractInfo ? types.ContractInfo.toAmino(message.contractInfo) : undefined;

    if (message.contractState) {
      obj.contract_state = message.contractState.map(e => e ? types.Model.toAmino(e) : undefined);
    } else {
      obj.contract_state = [];
    }

    if (message.contractCodeHistory) {
      obj.contract_code_history = message.contractCodeHistory.map(e => e ? types.ContractCodeHistoryEntry.toAmino(e) : undefined);
    } else {
      obj.contract_code_history = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return Contract.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "wasm/Contract",
      value: Contract.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return Contract.decode(message.value);
  },

  toProto(message) {
    return Contract.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.Contract",
      value: Contract.encode(message).finish()
    };
  }

};

function createBaseSequence() {
  return {
    idKey: new Uint8Array(),
    value: helpers/* Long.UZERO */.dK.UZERO
  };
}

const Sequence = {
  typeUrl: "/cosmwasm.wasm.v1.Sequence",

  encode(message, writer = minimal.Writer.create()) {
    if (message.idKey.length !== 0) {
      writer.uint32(10).bytes(message.idKey);
    }

    if (!message.value.isZero()) {
      writer.uint32(16).uint64(message.value);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSequence();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.idKey = reader.bytes();
          break;

        case 2:
          message.value = reader.uint64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$idKey;

    const message = createBaseSequence();
    message.idKey = (_object$idKey = object.idKey) !== null && _object$idKey !== void 0 ? _object$idKey : new Uint8Array();
    message.value = object.value !== undefined && object.value !== null ? helpers/* Long.fromValue */.dK.fromValue(object.value) : helpers/* Long.UZERO */.dK.UZERO;
    return message;
  },

  fromAmino(object) {
    return {
      idKey: object.id_key,
      value: helpers/* Long.fromString */.dK.fromString(object.value)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.id_key = message.idKey;
    obj.value = message.value ? message.value.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return Sequence.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "wasm/Sequence",
      value: Sequence.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return Sequence.decode(message.value);
  },

  toProto(message) {
    return Sequence.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.Sequence",
      value: Sequence.encode(message).finish()
    };
  }

};
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/cosmwasm/wasm/v1/ibc.js


/** MsgIBCSend */

function createBaseMsgIBCSend() {
  return {
    channel: "",
    timeoutHeight: helpers/* Long.UZERO */.dK.UZERO,
    timeoutTimestamp: helpers/* Long.UZERO */.dK.UZERO,
    data: new Uint8Array()
  };
}

const MsgIBCSend = {
  typeUrl: "/cosmwasm.wasm.v1.MsgIBCSend",

  encode(message, writer = minimal.Writer.create()) {
    if (message.channel !== "") {
      writer.uint32(18).string(message.channel);
    }

    if (!message.timeoutHeight.isZero()) {
      writer.uint32(32).uint64(message.timeoutHeight);
    }

    if (!message.timeoutTimestamp.isZero()) {
      writer.uint32(40).uint64(message.timeoutTimestamp);
    }

    if (message.data.length !== 0) {
      writer.uint32(50).bytes(message.data);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgIBCSend();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 2:
          message.channel = reader.string();
          break;

        case 4:
          message.timeoutHeight = reader.uint64();
          break;

        case 5:
          message.timeoutTimestamp = reader.uint64();
          break;

        case 6:
          message.data = reader.bytes();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$channel, _object$data;

    const message = createBaseMsgIBCSend();
    message.channel = (_object$channel = object.channel) !== null && _object$channel !== void 0 ? _object$channel : "";
    message.timeoutHeight = object.timeoutHeight !== undefined && object.timeoutHeight !== null ? helpers/* Long.fromValue */.dK.fromValue(object.timeoutHeight) : helpers/* Long.UZERO */.dK.UZERO;
    message.timeoutTimestamp = object.timeoutTimestamp !== undefined && object.timeoutTimestamp !== null ? helpers/* Long.fromValue */.dK.fromValue(object.timeoutTimestamp) : helpers/* Long.UZERO */.dK.UZERO;
    message.data = (_object$data = object.data) !== null && _object$data !== void 0 ? _object$data : new Uint8Array();
    return message;
  },

  fromAmino(object) {
    return {
      channel: object.channel,
      timeoutHeight: helpers/* Long.fromString */.dK.fromString(object.timeout_height),
      timeoutTimestamp: helpers/* Long.fromString */.dK.fromString(object.timeout_timestamp),
      data: object.data
    };
  },

  toAmino(message) {
    const obj = {};
    obj.channel = message.channel;
    obj.timeout_height = message.timeoutHeight ? message.timeoutHeight.toString() : undefined;
    obj.timeout_timestamp = message.timeoutTimestamp ? message.timeoutTimestamp.toString() : undefined;
    obj.data = message.data;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgIBCSend.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "wasm/MsgIBCSend",
      value: MsgIBCSend.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgIBCSend.decode(message.value);
  },

  toProto(message) {
    return MsgIBCSend.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.MsgIBCSend",
      value: MsgIBCSend.encode(message).finish()
    };
  }

};

function createBaseMsgIBCSendResponse() {
  return {
    sequence: helpers/* Long.UZERO */.dK.UZERO
  };
}

const MsgIBCSendResponse = {
  typeUrl: "/cosmwasm.wasm.v1.MsgIBCSendResponse",

  encode(message, writer = minimal.Writer.create()) {
    if (!message.sequence.isZero()) {
      writer.uint32(8).uint64(message.sequence);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgIBCSendResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.sequence = reader.uint64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseMsgIBCSendResponse();
    message.sequence = object.sequence !== undefined && object.sequence !== null ? helpers/* Long.fromValue */.dK.fromValue(object.sequence) : helpers/* Long.UZERO */.dK.UZERO;
    return message;
  },

  fromAmino(object) {
    return {
      sequence: helpers/* Long.fromString */.dK.fromString(object.sequence)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.sequence = message.sequence ? message.sequence.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgIBCSendResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "wasm/MsgIBCSendResponse",
      value: MsgIBCSendResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgIBCSendResponse.decode(message.value);
  },

  toProto(message) {
    return MsgIBCSendResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.MsgIBCSendResponse",
      value: MsgIBCSendResponse.encode(message).finish()
    };
  }

};

function createBaseMsgIBCCloseChannel() {
  return {
    channel: ""
  };
}

const MsgIBCCloseChannel = {
  typeUrl: "/cosmwasm.wasm.v1.MsgIBCCloseChannel",

  encode(message, writer = minimal.Writer.create()) {
    if (message.channel !== "") {
      writer.uint32(18).string(message.channel);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgIBCCloseChannel();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 2:
          message.channel = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$channel2;

    const message = createBaseMsgIBCCloseChannel();
    message.channel = (_object$channel2 = object.channel) !== null && _object$channel2 !== void 0 ? _object$channel2 : "";
    return message;
  },

  fromAmino(object) {
    return {
      channel: object.channel
    };
  },

  toAmino(message) {
    const obj = {};
    obj.channel = message.channel;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgIBCCloseChannel.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "wasm/MsgIBCCloseChannel",
      value: MsgIBCCloseChannel.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgIBCCloseChannel.decode(message.value);
  },

  toProto(message) {
    return MsgIBCCloseChannel.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.MsgIBCCloseChannel",
      value: MsgIBCCloseChannel.encode(message).finish()
    };
  }

};
// EXTERNAL MODULE: ./node_modules/osmojs/node_modules/@cosmjs/encoding/build/index.js
var encoding_build = __webpack_require__(71555);
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/cosmwasm/wasm/v1/proposal.js





/**
 * Deprecated: Do not use. Since wasmd v0.40, there is no longer a need for
 * an explicit StoreCodeProposal. To submit WASM code to the system,
 * a simple MsgStoreCode can be invoked from the x/gov module via
 * a v1 governance proposal.
 */

/** @deprecated */

function createBaseStoreCodeProposal() {
  return {
    $typeUrl: "/cosmwasm.wasm.v1.StoreCodeProposal",
    title: "",
    description: "",
    runAs: "",
    wasmByteCode: new Uint8Array(),
    instantiatePermission: undefined,
    unpinCode: false,
    source: "",
    builder: "",
    codeHash: new Uint8Array()
  };
}

const StoreCodeProposal = {
  typeUrl: "/cosmwasm.wasm.v1.StoreCodeProposal",

  encode(message, writer = minimal.Writer.create()) {
    if (message.title !== "") {
      writer.uint32(10).string(message.title);
    }

    if (message.description !== "") {
      writer.uint32(18).string(message.description);
    }

    if (message.runAs !== "") {
      writer.uint32(26).string(message.runAs);
    }

    if (message.wasmByteCode.length !== 0) {
      writer.uint32(34).bytes(message.wasmByteCode);
    }

    if (message.instantiatePermission !== undefined) {
      types.AccessConfig.encode(message.instantiatePermission, writer.uint32(58).fork()).ldelim();
    }

    if (message.unpinCode === true) {
      writer.uint32(64).bool(message.unpinCode);
    }

    if (message.source !== "") {
      writer.uint32(74).string(message.source);
    }

    if (message.builder !== "") {
      writer.uint32(82).string(message.builder);
    }

    if (message.codeHash.length !== 0) {
      writer.uint32(90).bytes(message.codeHash);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStoreCodeProposal();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.title = reader.string();
          break;

        case 2:
          message.description = reader.string();
          break;

        case 3:
          message.runAs = reader.string();
          break;

        case 4:
          message.wasmByteCode = reader.bytes();
          break;

        case 7:
          message.instantiatePermission = types.AccessConfig.decode(reader, reader.uint32());
          break;

        case 8:
          message.unpinCode = reader.bool();
          break;

        case 9:
          message.source = reader.string();
          break;

        case 10:
          message.builder = reader.string();
          break;

        case 11:
          message.codeHash = reader.bytes();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$title, _object$description, _object$runAs, _object$wasmByteCode, _object$unpinCode, _object$source, _object$builder, _object$codeHash;

    const message = createBaseStoreCodeProposal();
    message.title = (_object$title = object.title) !== null && _object$title !== void 0 ? _object$title : "";
    message.description = (_object$description = object.description) !== null && _object$description !== void 0 ? _object$description : "";
    message.runAs = (_object$runAs = object.runAs) !== null && _object$runAs !== void 0 ? _object$runAs : "";
    message.wasmByteCode = (_object$wasmByteCode = object.wasmByteCode) !== null && _object$wasmByteCode !== void 0 ? _object$wasmByteCode : new Uint8Array();
    message.instantiatePermission = object.instantiatePermission !== undefined && object.instantiatePermission !== null ? types.AccessConfig.fromPartial(object.instantiatePermission) : undefined;
    message.unpinCode = (_object$unpinCode = object.unpinCode) !== null && _object$unpinCode !== void 0 ? _object$unpinCode : false;
    message.source = (_object$source = object.source) !== null && _object$source !== void 0 ? _object$source : "";
    message.builder = (_object$builder = object.builder) !== null && _object$builder !== void 0 ? _object$builder : "";
    message.codeHash = (_object$codeHash = object.codeHash) !== null && _object$codeHash !== void 0 ? _object$codeHash : new Uint8Array();
    return message;
  },

  fromAmino(object) {
    return {
      title: object.title,
      description: object.description,
      runAs: object.run_as,
      wasmByteCode: (0,encoding_build.fromBase64)(object.wasm_byte_code),
      instantiatePermission: object !== null && object !== void 0 && object.instantiate_permission ? types.AccessConfig.fromAmino(object.instantiate_permission) : undefined,
      unpinCode: object.unpin_code,
      source: object.source,
      builder: object.builder,
      codeHash: object.code_hash
    };
  },

  toAmino(message) {
    const obj = {};
    obj.title = message.title;
    obj.description = message.description;
    obj.run_as = message.runAs;
    obj.wasm_byte_code = message.wasmByteCode ? (0,encoding_build.toBase64)(message.wasmByteCode) : undefined;
    obj.instantiate_permission = message.instantiatePermission ? types.AccessConfig.toAmino(message.instantiatePermission) : undefined;
    obj.unpin_code = message.unpinCode;
    obj.source = message.source;
    obj.builder = message.builder;
    obj.code_hash = message.codeHash;
    return obj;
  },

  fromAminoMsg(object) {
    return StoreCodeProposal.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "wasm/StoreCodeProposal",
      value: StoreCodeProposal.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return StoreCodeProposal.decode(message.value);
  },

  toProto(message) {
    return StoreCodeProposal.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.StoreCodeProposal",
      value: StoreCodeProposal.encode(message).finish()
    };
  }

};

function createBaseInstantiateContractProposal() {
  return {
    $typeUrl: "/cosmwasm.wasm.v1.InstantiateContractProposal",
    title: "",
    description: "",
    runAs: "",
    admin: "",
    codeId: helpers/* Long.UZERO */.dK.UZERO,
    label: "",
    msg: new Uint8Array(),
    funds: []
  };
}

const InstantiateContractProposal = {
  typeUrl: "/cosmwasm.wasm.v1.InstantiateContractProposal",

  encode(message, writer = minimal.Writer.create()) {
    if (message.title !== "") {
      writer.uint32(10).string(message.title);
    }

    if (message.description !== "") {
      writer.uint32(18).string(message.description);
    }

    if (message.runAs !== "") {
      writer.uint32(26).string(message.runAs);
    }

    if (message.admin !== "") {
      writer.uint32(34).string(message.admin);
    }

    if (!message.codeId.isZero()) {
      writer.uint32(40).uint64(message.codeId);
    }

    if (message.label !== "") {
      writer.uint32(50).string(message.label);
    }

    if (message.msg.length !== 0) {
      writer.uint32(58).bytes(message.msg);
    }

    for (const v of message.funds) {
      coin.Coin.encode(v, writer.uint32(66).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInstantiateContractProposal();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.title = reader.string();
          break;

        case 2:
          message.description = reader.string();
          break;

        case 3:
          message.runAs = reader.string();
          break;

        case 4:
          message.admin = reader.string();
          break;

        case 5:
          message.codeId = reader.uint64();
          break;

        case 6:
          message.label = reader.string();
          break;

        case 7:
          message.msg = reader.bytes();
          break;

        case 8:
          message.funds.push(coin.Coin.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$title2, _object$description2, _object$runAs2, _object$admin, _object$label, _object$msg, _object$funds;

    const message = createBaseInstantiateContractProposal();
    message.title = (_object$title2 = object.title) !== null && _object$title2 !== void 0 ? _object$title2 : "";
    message.description = (_object$description2 = object.description) !== null && _object$description2 !== void 0 ? _object$description2 : "";
    message.runAs = (_object$runAs2 = object.runAs) !== null && _object$runAs2 !== void 0 ? _object$runAs2 : "";
    message.admin = (_object$admin = object.admin) !== null && _object$admin !== void 0 ? _object$admin : "";
    message.codeId = object.codeId !== undefined && object.codeId !== null ? helpers/* Long.fromValue */.dK.fromValue(object.codeId) : helpers/* Long.UZERO */.dK.UZERO;
    message.label = (_object$label = object.label) !== null && _object$label !== void 0 ? _object$label : "";
    message.msg = (_object$msg = object.msg) !== null && _object$msg !== void 0 ? _object$msg : new Uint8Array();
    message.funds = ((_object$funds = object.funds) === null || _object$funds === void 0 ? void 0 : _object$funds.map(e => coin.Coin.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      title: object.title,
      description: object.description,
      runAs: object.run_as,
      admin: object.admin,
      codeId: helpers/* Long.fromString */.dK.fromString(object.code_id),
      label: object.label,
      msg: (0,encoding_build.toUtf8)(JSON.stringify(object.msg)),
      funds: Array.isArray(object === null || object === void 0 ? void 0 : object.funds) ? object.funds.map(e => coin.Coin.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.title = message.title;
    obj.description = message.description;
    obj.run_as = message.runAs;
    obj.admin = message.admin;
    obj.code_id = message.codeId ? message.codeId.toString() : undefined;
    obj.label = message.label;
    obj.msg = message.msg ? JSON.parse((0,encoding_build.fromUtf8)(message.msg)) : undefined;

    if (message.funds) {
      obj.funds = message.funds.map(e => e ? coin.Coin.toAmino(e) : undefined);
    } else {
      obj.funds = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return InstantiateContractProposal.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "wasm/InstantiateContractProposal",
      value: InstantiateContractProposal.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return InstantiateContractProposal.decode(message.value);
  },

  toProto(message) {
    return InstantiateContractProposal.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.InstantiateContractProposal",
      value: InstantiateContractProposal.encode(message).finish()
    };
  }

};

function createBaseInstantiateContract2Proposal() {
  return {
    $typeUrl: "/cosmwasm.wasm.v1.InstantiateContract2Proposal",
    title: "",
    description: "",
    runAs: "",
    admin: "",
    codeId: helpers/* Long.UZERO */.dK.UZERO,
    label: "",
    msg: new Uint8Array(),
    funds: [],
    salt: new Uint8Array(),
    fixMsg: false
  };
}

const InstantiateContract2Proposal = {
  typeUrl: "/cosmwasm.wasm.v1.InstantiateContract2Proposal",

  encode(message, writer = minimal.Writer.create()) {
    if (message.title !== "") {
      writer.uint32(10).string(message.title);
    }

    if (message.description !== "") {
      writer.uint32(18).string(message.description);
    }

    if (message.runAs !== "") {
      writer.uint32(26).string(message.runAs);
    }

    if (message.admin !== "") {
      writer.uint32(34).string(message.admin);
    }

    if (!message.codeId.isZero()) {
      writer.uint32(40).uint64(message.codeId);
    }

    if (message.label !== "") {
      writer.uint32(50).string(message.label);
    }

    if (message.msg.length !== 0) {
      writer.uint32(58).bytes(message.msg);
    }

    for (const v of message.funds) {
      coin.Coin.encode(v, writer.uint32(66).fork()).ldelim();
    }

    if (message.salt.length !== 0) {
      writer.uint32(74).bytes(message.salt);
    }

    if (message.fixMsg === true) {
      writer.uint32(80).bool(message.fixMsg);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInstantiateContract2Proposal();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.title = reader.string();
          break;

        case 2:
          message.description = reader.string();
          break;

        case 3:
          message.runAs = reader.string();
          break;

        case 4:
          message.admin = reader.string();
          break;

        case 5:
          message.codeId = reader.uint64();
          break;

        case 6:
          message.label = reader.string();
          break;

        case 7:
          message.msg = reader.bytes();
          break;

        case 8:
          message.funds.push(coin.Coin.decode(reader, reader.uint32()));
          break;

        case 9:
          message.salt = reader.bytes();
          break;

        case 10:
          message.fixMsg = reader.bool();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$title3, _object$description3, _object$runAs3, _object$admin2, _object$label2, _object$msg2, _object$funds2, _object$salt, _object$fixMsg;

    const message = createBaseInstantiateContract2Proposal();
    message.title = (_object$title3 = object.title) !== null && _object$title3 !== void 0 ? _object$title3 : "";
    message.description = (_object$description3 = object.description) !== null && _object$description3 !== void 0 ? _object$description3 : "";
    message.runAs = (_object$runAs3 = object.runAs) !== null && _object$runAs3 !== void 0 ? _object$runAs3 : "";
    message.admin = (_object$admin2 = object.admin) !== null && _object$admin2 !== void 0 ? _object$admin2 : "";
    message.codeId = object.codeId !== undefined && object.codeId !== null ? helpers/* Long.fromValue */.dK.fromValue(object.codeId) : helpers/* Long.UZERO */.dK.UZERO;
    message.label = (_object$label2 = object.label) !== null && _object$label2 !== void 0 ? _object$label2 : "";
    message.msg = (_object$msg2 = object.msg) !== null && _object$msg2 !== void 0 ? _object$msg2 : new Uint8Array();
    message.funds = ((_object$funds2 = object.funds) === null || _object$funds2 === void 0 ? void 0 : _object$funds2.map(e => coin.Coin.fromPartial(e))) || [];
    message.salt = (_object$salt = object.salt) !== null && _object$salt !== void 0 ? _object$salt : new Uint8Array();
    message.fixMsg = (_object$fixMsg = object.fixMsg) !== null && _object$fixMsg !== void 0 ? _object$fixMsg : false;
    return message;
  },

  fromAmino(object) {
    return {
      title: object.title,
      description: object.description,
      runAs: object.run_as,
      admin: object.admin,
      codeId: helpers/* Long.fromString */.dK.fromString(object.code_id),
      label: object.label,
      msg: (0,encoding_build.toUtf8)(JSON.stringify(object.msg)),
      funds: Array.isArray(object === null || object === void 0 ? void 0 : object.funds) ? object.funds.map(e => coin.Coin.fromAmino(e)) : [],
      salt: object.salt,
      fixMsg: object.fix_msg
    };
  },

  toAmino(message) {
    const obj = {};
    obj.title = message.title;
    obj.description = message.description;
    obj.run_as = message.runAs;
    obj.admin = message.admin;
    obj.code_id = message.codeId ? message.codeId.toString() : undefined;
    obj.label = message.label;
    obj.msg = message.msg ? JSON.parse((0,encoding_build.fromUtf8)(message.msg)) : undefined;

    if (message.funds) {
      obj.funds = message.funds.map(e => e ? coin.Coin.toAmino(e) : undefined);
    } else {
      obj.funds = [];
    }

    obj.salt = message.salt;
    obj.fix_msg = message.fixMsg;
    return obj;
  },

  fromAminoMsg(object) {
    return InstantiateContract2Proposal.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "wasm/InstantiateContract2Proposal",
      value: InstantiateContract2Proposal.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return InstantiateContract2Proposal.decode(message.value);
  },

  toProto(message) {
    return InstantiateContract2Proposal.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.InstantiateContract2Proposal",
      value: InstantiateContract2Proposal.encode(message).finish()
    };
  }

};

function createBaseMigrateContractProposal() {
  return {
    $typeUrl: "/cosmwasm.wasm.v1.MigrateContractProposal",
    title: "",
    description: "",
    contract: "",
    codeId: helpers/* Long.UZERO */.dK.UZERO,
    msg: new Uint8Array()
  };
}

const MigrateContractProposal = {
  typeUrl: "/cosmwasm.wasm.v1.MigrateContractProposal",

  encode(message, writer = minimal.Writer.create()) {
    if (message.title !== "") {
      writer.uint32(10).string(message.title);
    }

    if (message.description !== "") {
      writer.uint32(18).string(message.description);
    }

    if (message.contract !== "") {
      writer.uint32(34).string(message.contract);
    }

    if (!message.codeId.isZero()) {
      writer.uint32(40).uint64(message.codeId);
    }

    if (message.msg.length !== 0) {
      writer.uint32(50).bytes(message.msg);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMigrateContractProposal();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.title = reader.string();
          break;

        case 2:
          message.description = reader.string();
          break;

        case 4:
          message.contract = reader.string();
          break;

        case 5:
          message.codeId = reader.uint64();
          break;

        case 6:
          message.msg = reader.bytes();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$title4, _object$description4, _object$contract, _object$msg3;

    const message = createBaseMigrateContractProposal();
    message.title = (_object$title4 = object.title) !== null && _object$title4 !== void 0 ? _object$title4 : "";
    message.description = (_object$description4 = object.description) !== null && _object$description4 !== void 0 ? _object$description4 : "";
    message.contract = (_object$contract = object.contract) !== null && _object$contract !== void 0 ? _object$contract : "";
    message.codeId = object.codeId !== undefined && object.codeId !== null ? helpers/* Long.fromValue */.dK.fromValue(object.codeId) : helpers/* Long.UZERO */.dK.UZERO;
    message.msg = (_object$msg3 = object.msg) !== null && _object$msg3 !== void 0 ? _object$msg3 : new Uint8Array();
    return message;
  },

  fromAmino(object) {
    return {
      title: object.title,
      description: object.description,
      contract: object.contract,
      codeId: helpers/* Long.fromString */.dK.fromString(object.code_id),
      msg: (0,encoding_build.toUtf8)(JSON.stringify(object.msg))
    };
  },

  toAmino(message) {
    const obj = {};
    obj.title = message.title;
    obj.description = message.description;
    obj.contract = message.contract;
    obj.code_id = message.codeId ? message.codeId.toString() : undefined;
    obj.msg = message.msg ? JSON.parse((0,encoding_build.fromUtf8)(message.msg)) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return MigrateContractProposal.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "wasm/MigrateContractProposal",
      value: MigrateContractProposal.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MigrateContractProposal.decode(message.value);
  },

  toProto(message) {
    return MigrateContractProposal.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.MigrateContractProposal",
      value: MigrateContractProposal.encode(message).finish()
    };
  }

};

function createBaseSudoContractProposal() {
  return {
    $typeUrl: "/cosmwasm.wasm.v1.SudoContractProposal",
    title: "",
    description: "",
    contract: "",
    msg: new Uint8Array()
  };
}

const SudoContractProposal = {
  typeUrl: "/cosmwasm.wasm.v1.SudoContractProposal",

  encode(message, writer = minimal.Writer.create()) {
    if (message.title !== "") {
      writer.uint32(10).string(message.title);
    }

    if (message.description !== "") {
      writer.uint32(18).string(message.description);
    }

    if (message.contract !== "") {
      writer.uint32(26).string(message.contract);
    }

    if (message.msg.length !== 0) {
      writer.uint32(34).bytes(message.msg);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSudoContractProposal();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.title = reader.string();
          break;

        case 2:
          message.description = reader.string();
          break;

        case 3:
          message.contract = reader.string();
          break;

        case 4:
          message.msg = reader.bytes();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$title5, _object$description5, _object$contract2, _object$msg4;

    const message = createBaseSudoContractProposal();
    message.title = (_object$title5 = object.title) !== null && _object$title5 !== void 0 ? _object$title5 : "";
    message.description = (_object$description5 = object.description) !== null && _object$description5 !== void 0 ? _object$description5 : "";
    message.contract = (_object$contract2 = object.contract) !== null && _object$contract2 !== void 0 ? _object$contract2 : "";
    message.msg = (_object$msg4 = object.msg) !== null && _object$msg4 !== void 0 ? _object$msg4 : new Uint8Array();
    return message;
  },

  fromAmino(object) {
    return {
      title: object.title,
      description: object.description,
      contract: object.contract,
      msg: (0,encoding_build.toUtf8)(JSON.stringify(object.msg))
    };
  },

  toAmino(message) {
    const obj = {};
    obj.title = message.title;
    obj.description = message.description;
    obj.contract = message.contract;
    obj.msg = message.msg ? JSON.parse((0,encoding_build.fromUtf8)(message.msg)) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return SudoContractProposal.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "wasm/SudoContractProposal",
      value: SudoContractProposal.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return SudoContractProposal.decode(message.value);
  },

  toProto(message) {
    return SudoContractProposal.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.SudoContractProposal",
      value: SudoContractProposal.encode(message).finish()
    };
  }

};

function createBaseExecuteContractProposal() {
  return {
    $typeUrl: "/cosmwasm.wasm.v1.ExecuteContractProposal",
    title: "",
    description: "",
    runAs: "",
    contract: "",
    msg: new Uint8Array(),
    funds: []
  };
}

const ExecuteContractProposal = {
  typeUrl: "/cosmwasm.wasm.v1.ExecuteContractProposal",

  encode(message, writer = minimal.Writer.create()) {
    if (message.title !== "") {
      writer.uint32(10).string(message.title);
    }

    if (message.description !== "") {
      writer.uint32(18).string(message.description);
    }

    if (message.runAs !== "") {
      writer.uint32(26).string(message.runAs);
    }

    if (message.contract !== "") {
      writer.uint32(34).string(message.contract);
    }

    if (message.msg.length !== 0) {
      writer.uint32(42).bytes(message.msg);
    }

    for (const v of message.funds) {
      coin.Coin.encode(v, writer.uint32(50).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseExecuteContractProposal();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.title = reader.string();
          break;

        case 2:
          message.description = reader.string();
          break;

        case 3:
          message.runAs = reader.string();
          break;

        case 4:
          message.contract = reader.string();
          break;

        case 5:
          message.msg = reader.bytes();
          break;

        case 6:
          message.funds.push(coin.Coin.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$title6, _object$description6, _object$runAs4, _object$contract3, _object$msg5, _object$funds3;

    const message = createBaseExecuteContractProposal();
    message.title = (_object$title6 = object.title) !== null && _object$title6 !== void 0 ? _object$title6 : "";
    message.description = (_object$description6 = object.description) !== null && _object$description6 !== void 0 ? _object$description6 : "";
    message.runAs = (_object$runAs4 = object.runAs) !== null && _object$runAs4 !== void 0 ? _object$runAs4 : "";
    message.contract = (_object$contract3 = object.contract) !== null && _object$contract3 !== void 0 ? _object$contract3 : "";
    message.msg = (_object$msg5 = object.msg) !== null && _object$msg5 !== void 0 ? _object$msg5 : new Uint8Array();
    message.funds = ((_object$funds3 = object.funds) === null || _object$funds3 === void 0 ? void 0 : _object$funds3.map(e => coin.Coin.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      title: object.title,
      description: object.description,
      runAs: object.run_as,
      contract: object.contract,
      msg: (0,encoding_build.toUtf8)(JSON.stringify(object.msg)),
      funds: Array.isArray(object === null || object === void 0 ? void 0 : object.funds) ? object.funds.map(e => coin.Coin.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.title = message.title;
    obj.description = message.description;
    obj.run_as = message.runAs;
    obj.contract = message.contract;
    obj.msg = message.msg ? JSON.parse((0,encoding_build.fromUtf8)(message.msg)) : undefined;

    if (message.funds) {
      obj.funds = message.funds.map(e => e ? coin.Coin.toAmino(e) : undefined);
    } else {
      obj.funds = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return ExecuteContractProposal.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "wasm/ExecuteContractProposal",
      value: ExecuteContractProposal.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return ExecuteContractProposal.decode(message.value);
  },

  toProto(message) {
    return ExecuteContractProposal.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.ExecuteContractProposal",
      value: ExecuteContractProposal.encode(message).finish()
    };
  }

};

function createBaseUpdateAdminProposal() {
  return {
    $typeUrl: "/cosmwasm.wasm.v1.UpdateAdminProposal",
    title: "",
    description: "",
    newAdmin: "",
    contract: ""
  };
}

const UpdateAdminProposal = {
  typeUrl: "/cosmwasm.wasm.v1.UpdateAdminProposal",

  encode(message, writer = minimal.Writer.create()) {
    if (message.title !== "") {
      writer.uint32(10).string(message.title);
    }

    if (message.description !== "") {
      writer.uint32(18).string(message.description);
    }

    if (message.newAdmin !== "") {
      writer.uint32(26).string(message.newAdmin);
    }

    if (message.contract !== "") {
      writer.uint32(34).string(message.contract);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateAdminProposal();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.title = reader.string();
          break;

        case 2:
          message.description = reader.string();
          break;

        case 3:
          message.newAdmin = reader.string();
          break;

        case 4:
          message.contract = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$title7, _object$description7, _object$newAdmin, _object$contract4;

    const message = createBaseUpdateAdminProposal();
    message.title = (_object$title7 = object.title) !== null && _object$title7 !== void 0 ? _object$title7 : "";
    message.description = (_object$description7 = object.description) !== null && _object$description7 !== void 0 ? _object$description7 : "";
    message.newAdmin = (_object$newAdmin = object.newAdmin) !== null && _object$newAdmin !== void 0 ? _object$newAdmin : "";
    message.contract = (_object$contract4 = object.contract) !== null && _object$contract4 !== void 0 ? _object$contract4 : "";
    return message;
  },

  fromAmino(object) {
    return {
      title: object.title,
      description: object.description,
      newAdmin: object.new_admin,
      contract: object.contract
    };
  },

  toAmino(message) {
    const obj = {};
    obj.title = message.title;
    obj.description = message.description;
    obj.new_admin = message.newAdmin;
    obj.contract = message.contract;
    return obj;
  },

  fromAminoMsg(object) {
    return UpdateAdminProposal.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "wasm/UpdateAdminProposal",
      value: UpdateAdminProposal.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return UpdateAdminProposal.decode(message.value);
  },

  toProto(message) {
    return UpdateAdminProposal.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.UpdateAdminProposal",
      value: UpdateAdminProposal.encode(message).finish()
    };
  }

};

function createBaseClearAdminProposal() {
  return {
    $typeUrl: "/cosmwasm.wasm.v1.ClearAdminProposal",
    title: "",
    description: "",
    contract: ""
  };
}

const ClearAdminProposal = {
  typeUrl: "/cosmwasm.wasm.v1.ClearAdminProposal",

  encode(message, writer = minimal.Writer.create()) {
    if (message.title !== "") {
      writer.uint32(10).string(message.title);
    }

    if (message.description !== "") {
      writer.uint32(18).string(message.description);
    }

    if (message.contract !== "") {
      writer.uint32(26).string(message.contract);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseClearAdminProposal();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.title = reader.string();
          break;

        case 2:
          message.description = reader.string();
          break;

        case 3:
          message.contract = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$title8, _object$description8, _object$contract5;

    const message = createBaseClearAdminProposal();
    message.title = (_object$title8 = object.title) !== null && _object$title8 !== void 0 ? _object$title8 : "";
    message.description = (_object$description8 = object.description) !== null && _object$description8 !== void 0 ? _object$description8 : "";
    message.contract = (_object$contract5 = object.contract) !== null && _object$contract5 !== void 0 ? _object$contract5 : "";
    return message;
  },

  fromAmino(object) {
    return {
      title: object.title,
      description: object.description,
      contract: object.contract
    };
  },

  toAmino(message) {
    const obj = {};
    obj.title = message.title;
    obj.description = message.description;
    obj.contract = message.contract;
    return obj;
  },

  fromAminoMsg(object) {
    return ClearAdminProposal.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "wasm/ClearAdminProposal",
      value: ClearAdminProposal.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return ClearAdminProposal.decode(message.value);
  },

  toProto(message) {
    return ClearAdminProposal.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.ClearAdminProposal",
      value: ClearAdminProposal.encode(message).finish()
    };
  }

};

function createBasePinCodesProposal() {
  return {
    $typeUrl: "/cosmwasm.wasm.v1.PinCodesProposal",
    title: "",
    description: "",
    codeIds: []
  };
}

const PinCodesProposal = {
  typeUrl: "/cosmwasm.wasm.v1.PinCodesProposal",

  encode(message, writer = minimal.Writer.create()) {
    if (message.title !== "") {
      writer.uint32(10).string(message.title);
    }

    if (message.description !== "") {
      writer.uint32(18).string(message.description);
    }

    writer.uint32(26).fork();

    for (const v of message.codeIds) {
      writer.uint64(v);
    }

    writer.ldelim();
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePinCodesProposal();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.title = reader.string();
          break;

        case 2:
          message.description = reader.string();
          break;

        case 3:
          if ((tag & 7) === 2) {
            const end2 = reader.uint32() + reader.pos;

            while (reader.pos < end2) {
              message.codeIds.push(reader.uint64());
            }
          } else {
            message.codeIds.push(reader.uint64());
          }

          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$title9, _object$description9, _object$codeIds;

    const message = createBasePinCodesProposal();
    message.title = (_object$title9 = object.title) !== null && _object$title9 !== void 0 ? _object$title9 : "";
    message.description = (_object$description9 = object.description) !== null && _object$description9 !== void 0 ? _object$description9 : "";
    message.codeIds = ((_object$codeIds = object.codeIds) === null || _object$codeIds === void 0 ? void 0 : _object$codeIds.map(e => helpers/* Long.fromValue */.dK.fromValue(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      title: object.title,
      description: object.description,
      codeIds: Array.isArray(object === null || object === void 0 ? void 0 : object.code_ids) ? object.code_ids.map(e => e) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.title = message.title;
    obj.description = message.description;

    if (message.codeIds) {
      obj.code_ids = message.codeIds.map(e => e);
    } else {
      obj.code_ids = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return PinCodesProposal.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "wasm/PinCodesProposal",
      value: PinCodesProposal.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return PinCodesProposal.decode(message.value);
  },

  toProto(message) {
    return PinCodesProposal.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.PinCodesProposal",
      value: PinCodesProposal.encode(message).finish()
    };
  }

};

function createBaseUnpinCodesProposal() {
  return {
    $typeUrl: "/cosmwasm.wasm.v1.UnpinCodesProposal",
    title: "",
    description: "",
    codeIds: []
  };
}

const UnpinCodesProposal = {
  typeUrl: "/cosmwasm.wasm.v1.UnpinCodesProposal",

  encode(message, writer = minimal.Writer.create()) {
    if (message.title !== "") {
      writer.uint32(10).string(message.title);
    }

    if (message.description !== "") {
      writer.uint32(18).string(message.description);
    }

    writer.uint32(26).fork();

    for (const v of message.codeIds) {
      writer.uint64(v);
    }

    writer.ldelim();
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUnpinCodesProposal();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.title = reader.string();
          break;

        case 2:
          message.description = reader.string();
          break;

        case 3:
          if ((tag & 7) === 2) {
            const end2 = reader.uint32() + reader.pos;

            while (reader.pos < end2) {
              message.codeIds.push(reader.uint64());
            }
          } else {
            message.codeIds.push(reader.uint64());
          }

          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$title10, _object$description10, _object$codeIds2;

    const message = createBaseUnpinCodesProposal();
    message.title = (_object$title10 = object.title) !== null && _object$title10 !== void 0 ? _object$title10 : "";
    message.description = (_object$description10 = object.description) !== null && _object$description10 !== void 0 ? _object$description10 : "";
    message.codeIds = ((_object$codeIds2 = object.codeIds) === null || _object$codeIds2 === void 0 ? void 0 : _object$codeIds2.map(e => helpers/* Long.fromValue */.dK.fromValue(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      title: object.title,
      description: object.description,
      codeIds: Array.isArray(object === null || object === void 0 ? void 0 : object.code_ids) ? object.code_ids.map(e => e) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.title = message.title;
    obj.description = message.description;

    if (message.codeIds) {
      obj.code_ids = message.codeIds.map(e => e);
    } else {
      obj.code_ids = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return UnpinCodesProposal.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "wasm/UnpinCodesProposal",
      value: UnpinCodesProposal.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return UnpinCodesProposal.decode(message.value);
  },

  toProto(message) {
    return UnpinCodesProposal.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.UnpinCodesProposal",
      value: UnpinCodesProposal.encode(message).finish()
    };
  }

};

function createBaseAccessConfigUpdate() {
  return {
    codeId: helpers/* Long.UZERO */.dK.UZERO,
    instantiatePermission: undefined
  };
}

const AccessConfigUpdate = {
  typeUrl: "/cosmwasm.wasm.v1.AccessConfigUpdate",

  encode(message, writer = minimal.Writer.create()) {
    if (!message.codeId.isZero()) {
      writer.uint32(8).uint64(message.codeId);
    }

    if (message.instantiatePermission !== undefined) {
      types.AccessConfig.encode(message.instantiatePermission, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAccessConfigUpdate();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.codeId = reader.uint64();
          break;

        case 2:
          message.instantiatePermission = types.AccessConfig.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseAccessConfigUpdate();
    message.codeId = object.codeId !== undefined && object.codeId !== null ? helpers/* Long.fromValue */.dK.fromValue(object.codeId) : helpers/* Long.UZERO */.dK.UZERO;
    message.instantiatePermission = object.instantiatePermission !== undefined && object.instantiatePermission !== null ? types.AccessConfig.fromPartial(object.instantiatePermission) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      codeId: helpers/* Long.fromString */.dK.fromString(object.code_id),
      instantiatePermission: object !== null && object !== void 0 && object.instantiate_permission ? types.AccessConfig.fromAmino(object.instantiate_permission) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.code_id = message.codeId ? message.codeId.toString() : undefined;
    obj.instantiate_permission = message.instantiatePermission ? types.AccessConfig.toAmino(message.instantiatePermission) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return AccessConfigUpdate.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "wasm/AccessConfigUpdate",
      value: AccessConfigUpdate.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return AccessConfigUpdate.decode(message.value);
  },

  toProto(message) {
    return AccessConfigUpdate.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.AccessConfigUpdate",
      value: AccessConfigUpdate.encode(message).finish()
    };
  }

};

function createBaseUpdateInstantiateConfigProposal() {
  return {
    $typeUrl: "/cosmwasm.wasm.v1.UpdateInstantiateConfigProposal",
    title: "",
    description: "",
    accessConfigUpdates: []
  };
}

const UpdateInstantiateConfigProposal = {
  typeUrl: "/cosmwasm.wasm.v1.UpdateInstantiateConfigProposal",

  encode(message, writer = minimal.Writer.create()) {
    if (message.title !== "") {
      writer.uint32(10).string(message.title);
    }

    if (message.description !== "") {
      writer.uint32(18).string(message.description);
    }

    for (const v of message.accessConfigUpdates) {
      AccessConfigUpdate.encode(v, writer.uint32(26).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateInstantiateConfigProposal();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.title = reader.string();
          break;

        case 2:
          message.description = reader.string();
          break;

        case 3:
          message.accessConfigUpdates.push(AccessConfigUpdate.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$title11, _object$description11, _object$accessConfigU;

    const message = createBaseUpdateInstantiateConfigProposal();
    message.title = (_object$title11 = object.title) !== null && _object$title11 !== void 0 ? _object$title11 : "";
    message.description = (_object$description11 = object.description) !== null && _object$description11 !== void 0 ? _object$description11 : "";
    message.accessConfigUpdates = ((_object$accessConfigU = object.accessConfigUpdates) === null || _object$accessConfigU === void 0 ? void 0 : _object$accessConfigU.map(e => AccessConfigUpdate.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      title: object.title,
      description: object.description,
      accessConfigUpdates: Array.isArray(object === null || object === void 0 ? void 0 : object.access_config_updates) ? object.access_config_updates.map(e => AccessConfigUpdate.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.title = message.title;
    obj.description = message.description;

    if (message.accessConfigUpdates) {
      obj.access_config_updates = message.accessConfigUpdates.map(e => e ? AccessConfigUpdate.toAmino(e) : undefined);
    } else {
      obj.access_config_updates = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return UpdateInstantiateConfigProposal.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "wasm/UpdateInstantiateConfigProposal",
      value: UpdateInstantiateConfigProposal.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return UpdateInstantiateConfigProposal.decode(message.value);
  },

  toProto(message) {
    return UpdateInstantiateConfigProposal.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.UpdateInstantiateConfigProposal",
      value: UpdateInstantiateConfigProposal.encode(message).finish()
    };
  }

};

function createBaseStoreAndInstantiateContractProposal() {
  return {
    $typeUrl: "/cosmwasm.wasm.v1.StoreAndInstantiateContractProposal",
    title: "",
    description: "",
    runAs: "",
    wasmByteCode: new Uint8Array(),
    instantiatePermission: undefined,
    unpinCode: false,
    admin: "",
    label: "",
    msg: new Uint8Array(),
    funds: [],
    source: "",
    builder: "",
    codeHash: new Uint8Array()
  };
}

const StoreAndInstantiateContractProposal = {
  typeUrl: "/cosmwasm.wasm.v1.StoreAndInstantiateContractProposal",

  encode(message, writer = minimal.Writer.create()) {
    if (message.title !== "") {
      writer.uint32(10).string(message.title);
    }

    if (message.description !== "") {
      writer.uint32(18).string(message.description);
    }

    if (message.runAs !== "") {
      writer.uint32(26).string(message.runAs);
    }

    if (message.wasmByteCode.length !== 0) {
      writer.uint32(34).bytes(message.wasmByteCode);
    }

    if (message.instantiatePermission !== undefined) {
      types.AccessConfig.encode(message.instantiatePermission, writer.uint32(42).fork()).ldelim();
    }

    if (message.unpinCode === true) {
      writer.uint32(48).bool(message.unpinCode);
    }

    if (message.admin !== "") {
      writer.uint32(58).string(message.admin);
    }

    if (message.label !== "") {
      writer.uint32(66).string(message.label);
    }

    if (message.msg.length !== 0) {
      writer.uint32(74).bytes(message.msg);
    }

    for (const v of message.funds) {
      coin.Coin.encode(v, writer.uint32(82).fork()).ldelim();
    }

    if (message.source !== "") {
      writer.uint32(90).string(message.source);
    }

    if (message.builder !== "") {
      writer.uint32(98).string(message.builder);
    }

    if (message.codeHash.length !== 0) {
      writer.uint32(106).bytes(message.codeHash);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStoreAndInstantiateContractProposal();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.title = reader.string();
          break;

        case 2:
          message.description = reader.string();
          break;

        case 3:
          message.runAs = reader.string();
          break;

        case 4:
          message.wasmByteCode = reader.bytes();
          break;

        case 5:
          message.instantiatePermission = types.AccessConfig.decode(reader, reader.uint32());
          break;

        case 6:
          message.unpinCode = reader.bool();
          break;

        case 7:
          message.admin = reader.string();
          break;

        case 8:
          message.label = reader.string();
          break;

        case 9:
          message.msg = reader.bytes();
          break;

        case 10:
          message.funds.push(coin.Coin.decode(reader, reader.uint32()));
          break;

        case 11:
          message.source = reader.string();
          break;

        case 12:
          message.builder = reader.string();
          break;

        case 13:
          message.codeHash = reader.bytes();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$title12, _object$description12, _object$runAs5, _object$wasmByteCode2, _object$unpinCode2, _object$admin3, _object$label3, _object$msg6, _object$funds4, _object$source2, _object$builder2, _object$codeHash2;

    const message = createBaseStoreAndInstantiateContractProposal();
    message.title = (_object$title12 = object.title) !== null && _object$title12 !== void 0 ? _object$title12 : "";
    message.description = (_object$description12 = object.description) !== null && _object$description12 !== void 0 ? _object$description12 : "";
    message.runAs = (_object$runAs5 = object.runAs) !== null && _object$runAs5 !== void 0 ? _object$runAs5 : "";
    message.wasmByteCode = (_object$wasmByteCode2 = object.wasmByteCode) !== null && _object$wasmByteCode2 !== void 0 ? _object$wasmByteCode2 : new Uint8Array();
    message.instantiatePermission = object.instantiatePermission !== undefined && object.instantiatePermission !== null ? types.AccessConfig.fromPartial(object.instantiatePermission) : undefined;
    message.unpinCode = (_object$unpinCode2 = object.unpinCode) !== null && _object$unpinCode2 !== void 0 ? _object$unpinCode2 : false;
    message.admin = (_object$admin3 = object.admin) !== null && _object$admin3 !== void 0 ? _object$admin3 : "";
    message.label = (_object$label3 = object.label) !== null && _object$label3 !== void 0 ? _object$label3 : "";
    message.msg = (_object$msg6 = object.msg) !== null && _object$msg6 !== void 0 ? _object$msg6 : new Uint8Array();
    message.funds = ((_object$funds4 = object.funds) === null || _object$funds4 === void 0 ? void 0 : _object$funds4.map(e => coin.Coin.fromPartial(e))) || [];
    message.source = (_object$source2 = object.source) !== null && _object$source2 !== void 0 ? _object$source2 : "";
    message.builder = (_object$builder2 = object.builder) !== null && _object$builder2 !== void 0 ? _object$builder2 : "";
    message.codeHash = (_object$codeHash2 = object.codeHash) !== null && _object$codeHash2 !== void 0 ? _object$codeHash2 : new Uint8Array();
    return message;
  },

  fromAmino(object) {
    return {
      title: object.title,
      description: object.description,
      runAs: object.run_as,
      wasmByteCode: (0,encoding_build.fromBase64)(object.wasm_byte_code),
      instantiatePermission: object !== null && object !== void 0 && object.instantiate_permission ? types.AccessConfig.fromAmino(object.instantiate_permission) : undefined,
      unpinCode: object.unpin_code,
      admin: object.admin,
      label: object.label,
      msg: (0,encoding_build.toUtf8)(JSON.stringify(object.msg)),
      funds: Array.isArray(object === null || object === void 0 ? void 0 : object.funds) ? object.funds.map(e => coin.Coin.fromAmino(e)) : [],
      source: object.source,
      builder: object.builder,
      codeHash: object.code_hash
    };
  },

  toAmino(message) {
    const obj = {};
    obj.title = message.title;
    obj.description = message.description;
    obj.run_as = message.runAs;
    obj.wasm_byte_code = message.wasmByteCode ? (0,encoding_build.toBase64)(message.wasmByteCode) : undefined;
    obj.instantiate_permission = message.instantiatePermission ? types.AccessConfig.toAmino(message.instantiatePermission) : undefined;
    obj.unpin_code = message.unpinCode;
    obj.admin = message.admin;
    obj.label = message.label;
    obj.msg = message.msg ? JSON.parse((0,encoding_build.fromUtf8)(message.msg)) : undefined;

    if (message.funds) {
      obj.funds = message.funds.map(e => e ? coin.Coin.toAmino(e) : undefined);
    } else {
      obj.funds = [];
    }

    obj.source = message.source;
    obj.builder = message.builder;
    obj.code_hash = message.codeHash;
    return obj;
  },

  fromAminoMsg(object) {
    return StoreAndInstantiateContractProposal.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "wasm/StoreAndInstantiateContractProposal",
      value: StoreAndInstantiateContractProposal.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return StoreAndInstantiateContractProposal.decode(message.value);
  },

  toProto(message) {
    return StoreAndInstantiateContractProposal.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmwasm.wasm.v1.StoreAndInstantiateContractProposal",
      value: StoreAndInstantiateContractProposal.encode(message).finish()
    };
  }

};
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/cosmwasm/wasm/v1/query.js
var wasm_v1_query = __webpack_require__(58980);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/cosmwasm/wasm/v1/tx.js
var wasm_v1_tx = __webpack_require__(88547);
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/cosmwasm/wasm/v1/tx.amino.js
//@ts-nocheck

const wasm_v1_tx_amino_AminoConverter = {
  "/cosmwasm.wasm.v1.MsgStoreCode": {
    aminoType: "wasm/MsgStoreCode",
    toAmino: wasm_v1_tx.MsgStoreCode.toAmino,
    fromAmino: wasm_v1_tx.MsgStoreCode.fromAmino
  },
  "/cosmwasm.wasm.v1.MsgInstantiateContract": {
    aminoType: "wasm/MsgInstantiateContract",
    toAmino: wasm_v1_tx.MsgInstantiateContract.toAmino,
    fromAmino: wasm_v1_tx.MsgInstantiateContract.fromAmino
  },
  "/cosmwasm.wasm.v1.MsgInstantiateContract2": {
    aminoType: "wasm/MsgInstantiateContract2",
    toAmino: wasm_v1_tx.MsgInstantiateContract2.toAmino,
    fromAmino: wasm_v1_tx.MsgInstantiateContract2.fromAmino
  },
  "/cosmwasm.wasm.v1.MsgExecuteContract": {
    aminoType: "wasm/MsgExecuteContract",
    toAmino: wasm_v1_tx.MsgExecuteContract.toAmino,
    fromAmino: wasm_v1_tx.MsgExecuteContract.fromAmino
  },
  "/cosmwasm.wasm.v1.MsgMigrateContract": {
    aminoType: "wasm/MsgMigrateContract",
    toAmino: wasm_v1_tx.MsgMigrateContract.toAmino,
    fromAmino: wasm_v1_tx.MsgMigrateContract.fromAmino
  },
  "/cosmwasm.wasm.v1.MsgUpdateAdmin": {
    aminoType: "wasm/MsgUpdateAdmin",
    toAmino: wasm_v1_tx.MsgUpdateAdmin.toAmino,
    fromAmino: wasm_v1_tx.MsgUpdateAdmin.fromAmino
  },
  "/cosmwasm.wasm.v1.MsgClearAdmin": {
    aminoType: "wasm/MsgClearAdmin",
    toAmino: wasm_v1_tx.MsgClearAdmin.toAmino,
    fromAmino: wasm_v1_tx.MsgClearAdmin.fromAmino
  },
  "/cosmwasm.wasm.v1.MsgUpdateInstantiateConfig": {
    aminoType: "wasm/MsgUpdateInstantiateConfig",
    toAmino: wasm_v1_tx.MsgUpdateInstantiateConfig.toAmino,
    fromAmino: wasm_v1_tx.MsgUpdateInstantiateConfig.fromAmino
  },
  "/cosmwasm.wasm.v1.MsgUpdateParams": {
    aminoType: "wasm/MsgUpdateParams",
    toAmino: wasm_v1_tx.MsgUpdateParams.toAmino,
    fromAmino: wasm_v1_tx.MsgUpdateParams.fromAmino
  },
  "/cosmwasm.wasm.v1.MsgSudoContract": {
    aminoType: "wasm/MsgSudoContract",
    toAmino: wasm_v1_tx.MsgSudoContract.toAmino,
    fromAmino: wasm_v1_tx.MsgSudoContract.fromAmino
  },
  "/cosmwasm.wasm.v1.MsgPinCodes": {
    aminoType: "wasm/MsgPinCodes",
    toAmino: wasm_v1_tx.MsgPinCodes.toAmino,
    fromAmino: wasm_v1_tx.MsgPinCodes.fromAmino
  },
  "/cosmwasm.wasm.v1.MsgUnpinCodes": {
    aminoType: "wasm/MsgUnpinCodes",
    toAmino: wasm_v1_tx.MsgUnpinCodes.toAmino,
    fromAmino: wasm_v1_tx.MsgUnpinCodes.fromAmino
  },
  "/cosmwasm.wasm.v1.MsgStoreAndInstantiateContract": {
    aminoType: "wasm/MsgStoreAndInstantiateContract",
    toAmino: wasm_v1_tx.MsgStoreAndInstantiateContract.toAmino,
    fromAmino: wasm_v1_tx.MsgStoreAndInstantiateContract.fromAmino
  }
};
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/cosmwasm/wasm/v1/tx.registry.js
//@ts-nocheck

const wasm_v1_tx_registry_registry = [["/cosmwasm.wasm.v1.MsgStoreCode", wasm_v1_tx.MsgStoreCode], ["/cosmwasm.wasm.v1.MsgInstantiateContract", wasm_v1_tx.MsgInstantiateContract], ["/cosmwasm.wasm.v1.MsgInstantiateContract2", wasm_v1_tx.MsgInstantiateContract2], ["/cosmwasm.wasm.v1.MsgExecuteContract", wasm_v1_tx.MsgExecuteContract], ["/cosmwasm.wasm.v1.MsgMigrateContract", wasm_v1_tx.MsgMigrateContract], ["/cosmwasm.wasm.v1.MsgUpdateAdmin", wasm_v1_tx.MsgUpdateAdmin], ["/cosmwasm.wasm.v1.MsgClearAdmin", wasm_v1_tx.MsgClearAdmin], ["/cosmwasm.wasm.v1.MsgUpdateInstantiateConfig", wasm_v1_tx.MsgUpdateInstantiateConfig], ["/cosmwasm.wasm.v1.MsgUpdateParams", wasm_v1_tx.MsgUpdateParams], ["/cosmwasm.wasm.v1.MsgSudoContract", wasm_v1_tx.MsgSudoContract], ["/cosmwasm.wasm.v1.MsgPinCodes", wasm_v1_tx.MsgPinCodes], ["/cosmwasm.wasm.v1.MsgUnpinCodes", wasm_v1_tx.MsgUnpinCodes], ["/cosmwasm.wasm.v1.MsgStoreAndInstantiateContract", wasm_v1_tx.MsgStoreAndInstantiateContract]];
const wasm_v1_tx_registry_load = protoRegistry => {
  wasm_v1_tx_registry_registry.forEach(([typeUrl, mod]) => {
    protoRegistry.register(typeUrl, mod);
  });
};
const wasm_v1_tx_registry_MessageComposer = {
  encoded: {
    storeCode(value) {
      return {
        typeUrl: "/cosmwasm.wasm.v1.MsgStoreCode",
        value: wasm_v1_tx.MsgStoreCode.encode(value).finish()
      };
    },

    instantiateContract(value) {
      return {
        typeUrl: "/cosmwasm.wasm.v1.MsgInstantiateContract",
        value: wasm_v1_tx.MsgInstantiateContract.encode(value).finish()
      };
    },

    instantiateContract2(value) {
      return {
        typeUrl: "/cosmwasm.wasm.v1.MsgInstantiateContract2",
        value: wasm_v1_tx.MsgInstantiateContract2.encode(value).finish()
      };
    },

    executeContract(value) {
      return {
        typeUrl: "/cosmwasm.wasm.v1.MsgExecuteContract",
        value: wasm_v1_tx.MsgExecuteContract.encode(value).finish()
      };
    },

    migrateContract(value) {
      return {
        typeUrl: "/cosmwasm.wasm.v1.MsgMigrateContract",
        value: wasm_v1_tx.MsgMigrateContract.encode(value).finish()
      };
    },

    updateAdmin(value) {
      return {
        typeUrl: "/cosmwasm.wasm.v1.MsgUpdateAdmin",
        value: wasm_v1_tx.MsgUpdateAdmin.encode(value).finish()
      };
    },

    clearAdmin(value) {
      return {
        typeUrl: "/cosmwasm.wasm.v1.MsgClearAdmin",
        value: wasm_v1_tx.MsgClearAdmin.encode(value).finish()
      };
    },

    updateInstantiateConfig(value) {
      return {
        typeUrl: "/cosmwasm.wasm.v1.MsgUpdateInstantiateConfig",
        value: wasm_v1_tx.MsgUpdateInstantiateConfig.encode(value).finish()
      };
    },

    updateParams(value) {
      return {
        typeUrl: "/cosmwasm.wasm.v1.MsgUpdateParams",
        value: wasm_v1_tx.MsgUpdateParams.encode(value).finish()
      };
    },

    sudoContract(value) {
      return {
        typeUrl: "/cosmwasm.wasm.v1.MsgSudoContract",
        value: wasm_v1_tx.MsgSudoContract.encode(value).finish()
      };
    },

    pinCodes(value) {
      return {
        typeUrl: "/cosmwasm.wasm.v1.MsgPinCodes",
        value: wasm_v1_tx.MsgPinCodes.encode(value).finish()
      };
    },

    unpinCodes(value) {
      return {
        typeUrl: "/cosmwasm.wasm.v1.MsgUnpinCodes",
        value: wasm_v1_tx.MsgUnpinCodes.encode(value).finish()
      };
    },

    storeAndInstantiateContract(value) {
      return {
        typeUrl: "/cosmwasm.wasm.v1.MsgStoreAndInstantiateContract",
        value: wasm_v1_tx.MsgStoreAndInstantiateContract.encode(value).finish()
      };
    }

  },
  withTypeUrl: {
    storeCode(value) {
      return {
        typeUrl: "/cosmwasm.wasm.v1.MsgStoreCode",
        value
      };
    },

    instantiateContract(value) {
      return {
        typeUrl: "/cosmwasm.wasm.v1.MsgInstantiateContract",
        value
      };
    },

    instantiateContract2(value) {
      return {
        typeUrl: "/cosmwasm.wasm.v1.MsgInstantiateContract2",
        value
      };
    },

    executeContract(value) {
      return {
        typeUrl: "/cosmwasm.wasm.v1.MsgExecuteContract",
        value
      };
    },

    migrateContract(value) {
      return {
        typeUrl: "/cosmwasm.wasm.v1.MsgMigrateContract",
        value
      };
    },

    updateAdmin(value) {
      return {
        typeUrl: "/cosmwasm.wasm.v1.MsgUpdateAdmin",
        value
      };
    },

    clearAdmin(value) {
      return {
        typeUrl: "/cosmwasm.wasm.v1.MsgClearAdmin",
        value
      };
    },

    updateInstantiateConfig(value) {
      return {
        typeUrl: "/cosmwasm.wasm.v1.MsgUpdateInstantiateConfig",
        value
      };
    },

    updateParams(value) {
      return {
        typeUrl: "/cosmwasm.wasm.v1.MsgUpdateParams",
        value
      };
    },

    sudoContract(value) {
      return {
        typeUrl: "/cosmwasm.wasm.v1.MsgSudoContract",
        value
      };
    },

    pinCodes(value) {
      return {
        typeUrl: "/cosmwasm.wasm.v1.MsgPinCodes",
        value
      };
    },

    unpinCodes(value) {
      return {
        typeUrl: "/cosmwasm.wasm.v1.MsgUnpinCodes",
        value
      };
    },

    storeAndInstantiateContract(value) {
      return {
        typeUrl: "/cosmwasm.wasm.v1.MsgStoreAndInstantiateContract",
        value
      };
    }

  },
  fromPartial: {
    storeCode(value) {
      return {
        typeUrl: "/cosmwasm.wasm.v1.MsgStoreCode",
        value: wasm_v1_tx.MsgStoreCode.fromPartial(value)
      };
    },

    instantiateContract(value) {
      return {
        typeUrl: "/cosmwasm.wasm.v1.MsgInstantiateContract",
        value: wasm_v1_tx.MsgInstantiateContract.fromPartial(value)
      };
    },

    instantiateContract2(value) {
      return {
        typeUrl: "/cosmwasm.wasm.v1.MsgInstantiateContract2",
        value: wasm_v1_tx.MsgInstantiateContract2.fromPartial(value)
      };
    },

    executeContract(value) {
      return {
        typeUrl: "/cosmwasm.wasm.v1.MsgExecuteContract",
        value: wasm_v1_tx.MsgExecuteContract.fromPartial(value)
      };
    },

    migrateContract(value) {
      return {
        typeUrl: "/cosmwasm.wasm.v1.MsgMigrateContract",
        value: wasm_v1_tx.MsgMigrateContract.fromPartial(value)
      };
    },

    updateAdmin(value) {
      return {
        typeUrl: "/cosmwasm.wasm.v1.MsgUpdateAdmin",
        value: wasm_v1_tx.MsgUpdateAdmin.fromPartial(value)
      };
    },

    clearAdmin(value) {
      return {
        typeUrl: "/cosmwasm.wasm.v1.MsgClearAdmin",
        value: wasm_v1_tx.MsgClearAdmin.fromPartial(value)
      };
    },

    updateInstantiateConfig(value) {
      return {
        typeUrl: "/cosmwasm.wasm.v1.MsgUpdateInstantiateConfig",
        value: wasm_v1_tx.MsgUpdateInstantiateConfig.fromPartial(value)
      };
    },

    updateParams(value) {
      return {
        typeUrl: "/cosmwasm.wasm.v1.MsgUpdateParams",
        value: wasm_v1_tx.MsgUpdateParams.fromPartial(value)
      };
    },

    sudoContract(value) {
      return {
        typeUrl: "/cosmwasm.wasm.v1.MsgSudoContract",
        value: wasm_v1_tx.MsgSudoContract.fromPartial(value)
      };
    },

    pinCodes(value) {
      return {
        typeUrl: "/cosmwasm.wasm.v1.MsgPinCodes",
        value: wasm_v1_tx.MsgPinCodes.fromPartial(value)
      };
    },

    unpinCodes(value) {
      return {
        typeUrl: "/cosmwasm.wasm.v1.MsgUnpinCodes",
        value: wasm_v1_tx.MsgUnpinCodes.fromPartial(value)
      };
    },

    storeAndInstantiateContract(value) {
      return {
        typeUrl: "/cosmwasm.wasm.v1.MsgStoreAndInstantiateContract",
        value: wasm_v1_tx.MsgStoreAndInstantiateContract.fromPartial(value)
      };
    }

  }
};
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/cosmwasm/wasm/v1/query.lcd.js
var wasm_v1_query_lcd = __webpack_require__(77927);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/cosmwasm/wasm/v1/query.rpc.Query.js
var wasm_v1_query_rpc_Query = __webpack_require__(63564);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/cosmwasm/wasm/v1/tx.rpc.msg.js
var wasm_v1_tx_rpc_msg = __webpack_require__(20891);
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/cosmwasm/lcd.js

const cosmwasm_lcd_createLCDClient = async ({
  restEndpoint
}) => {
  const requestClient = new LCDClient({
    restEndpoint
  });
  return {
    cosmos: {
      auth: {
        v1beta1: new (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 88436))).LCDQueryClient({
          requestClient
        })
      },
      authz: {
        v1beta1: new (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 73300))).LCDQueryClient({
          requestClient
        })
      },
      bank: {
        v1beta1: new (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 79926))).LCDQueryClient({
          requestClient
        })
      },
      base: {
        node: {
          v1beta1: new (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 91318))).LCDQueryClient({
            requestClient
          })
        }
      },
      distribution: {
        v1beta1: new (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 39))).LCDQueryClient({
          requestClient
        })
      },
      gov: {
        v1beta1: new (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 3571))).LCDQueryClient({
          requestClient
        })
      },
      staking: {
        v1beta1: new (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 24800))).LCDQueryClient({
          requestClient
        })
      },
      tx: {
        v1beta1: new (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 57994))).LCDQueryClient({
          requestClient
        })
      },
      upgrade: {
        v1beta1: new (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 67931))).LCDQueryClient({
          requestClient
        })
      }
    },
    cosmwasm: {
      wasm: {
        v1: new (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 77927))).LCDQueryClient({
          requestClient
        })
      }
    }
  };
};
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/cosmwasm/rpc.query.js


const cosmwasm_rpc_query_createRPCQueryClient = async ({
  rpcEndpoint
}) => {
  const tmClient = await build.Tendermint34Client.connect(rpcEndpoint);
  const client = new stargate_build.QueryClient(tmClient);
  return {
    cosmos: {
      auth: {
        v1beta1: (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 80908))).createRpcQueryExtension(client)
      },
      authz: {
        v1beta1: (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 64139))).createRpcQueryExtension(client)
      },
      bank: {
        v1beta1: (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 3889))).createRpcQueryExtension(client)
      },
      base: {
        node: {
          v1beta1: (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 12345))).createRpcQueryExtension(client)
        }
      },
      distribution: {
        v1beta1: (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 23727))).createRpcQueryExtension(client)
      },
      gov: {
        v1beta1: (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 96921))).createRpcQueryExtension(client)
      },
      staking: {
        v1beta1: (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 56860))).createRpcQueryExtension(client)
      },
      tx: {
        v1beta1: (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 82478))).createRpcQueryExtension(client)
      },
      upgrade: {
        v1beta1: (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 94898))).createRpcQueryExtension(client)
      }
    },
    cosmwasm: {
      wasm: {
        v1: (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 63564))).createRpcQueryExtension(client)
      }
    }
  };
};
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/cosmwasm/rpc.tx.js
const cosmwasm_rpc_tx_createRPCMsgClient = async ({
  rpc
}) => ({
  cosmos: {
    authz: {
      v1beta1: new (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 35773))).MsgClientImpl(rpc)
    },
    bank: {
      v1beta1: new (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 85579))).MsgClientImpl(rpc)
    },
    distribution: {
      v1beta1: new (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 9689))).MsgClientImpl(rpc)
    },
    gov: {
      v1beta1: new (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 3207))).MsgClientImpl(rpc)
    },
    staking: {
      v1beta1: new (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 34191))).MsgClientImpl(rpc)
    }
  },
  cosmwasm: {
    wasm: {
      v1: new (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 20891))).MsgClientImpl(rpc)
    }
  }
});
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/cosmwasm/bundle.js


function cosmwasm_bundle_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function cosmwasm_bundle_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? cosmwasm_bundle_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : cosmwasm_bundle_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
















let cosmwasm;

(function (_cosmwasm) {
  let wasm;

  (function (_wasm) {
    const v1 = _wasm.v1 = cosmwasm_bundle_objectSpread(cosmwasm_bundle_objectSpread(cosmwasm_bundle_objectSpread(cosmwasm_bundle_objectSpread(cosmwasm_bundle_objectSpread(cosmwasm_bundle_objectSpread(cosmwasm_bundle_objectSpread(cosmwasm_bundle_objectSpread(cosmwasm_bundle_objectSpread(cosmwasm_bundle_objectSpread(cosmwasm_bundle_objectSpread(cosmwasm_bundle_objectSpread({}, v1_authz_namespaceObject), wasm_v1_genesis_namespaceObject), ibc_namespaceObject), proposal_namespaceObject), wasm_v1_query), wasm_v1_tx), types), wasm_v1_tx_amino_namespaceObject), wasm_v1_tx_registry_namespaceObject), wasm_v1_query_lcd), wasm_v1_query_rpc_Query), wasm_v1_tx_rpc_msg);
  })(wasm || (wasm = _cosmwasm.wasm || (_cosmwasm.wasm = {})));

  const ClientFactory = _cosmwasm.ClientFactory = cosmwasm_bundle_objectSpread(cosmwasm_bundle_objectSpread(cosmwasm_bundle_objectSpread({}, cosmwasm_lcd_namespaceObject), cosmwasm_rpc_query_namespaceObject), cosmwasm_rpc_tx_namespaceObject);
})(cosmwasm || (cosmwasm = {}));
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/cosmwasm/client.js


function cosmwasm_client_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function cosmwasm_client_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? cosmwasm_client_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : cosmwasm_client_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





const cosmwasmAminoConverters = cosmwasm_client_objectSpread({}, wasm_v1_tx_amino_AminoConverter);
const cosmwasmProtoRegistry = [...wasm_v1_tx_registry_registry];
const getSigningCosmwasmClientOptions = ({
  defaultTypes = defaultRegistryTypes
} = {}) => {
  const registry = new Registry([...defaultTypes, ...cosmwasmProtoRegistry]);
  const aminoTypes = new AminoTypes(cosmwasm_client_objectSpread({}, cosmwasmAminoConverters));
  return {
    registry,
    aminoTypes
  };
};
const getSigningCosmwasmClient = async ({
  rpcEndpoint,
  signer,
  defaultTypes = defaultRegistryTypes
}) => {
  const {
    registry,
    aminoTypes
  } = getSigningCosmwasmClientOptions({
    defaultTypes
  });
  const client = await SigningStargateClient.connectWithSigner(rpcEndpoint, signer, {
    registry,
    aminoTypes
  });
  return client;
};
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/osmosis/accum/v1beta1/accum.js


/**
 * AccumulatorContent is the state-entry for the global accumulator.
 * It contains the name of the global accumulator and the total value of
 * shares belonging to it from all positions.
 */

function createBaseAccumulatorContent() {
  return {
    accumValue: [],
    totalShares: ""
  };
}

const AccumulatorContent = {
  typeUrl: "/osmosis.accum.v1beta1.AccumulatorContent",

  encode(message, writer = minimal.Writer.create()) {
    for (const v of message.accumValue) {
      coin.DecCoin.encode(v, writer.uint32(10).fork()).ldelim();
    }

    if (message.totalShares !== "") {
      writer.uint32(18).string(message.totalShares);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAccumulatorContent();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.accumValue.push(coin.DecCoin.decode(reader, reader.uint32()));
          break;

        case 2:
          message.totalShares = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$accumValue, _object$totalShares;

    const message = createBaseAccumulatorContent();
    message.accumValue = ((_object$accumValue = object.accumValue) === null || _object$accumValue === void 0 ? void 0 : _object$accumValue.map(e => coin.DecCoin.fromPartial(e))) || [];
    message.totalShares = (_object$totalShares = object.totalShares) !== null && _object$totalShares !== void 0 ? _object$totalShares : "";
    return message;
  },

  fromAmino(object) {
    return {
      accumValue: Array.isArray(object === null || object === void 0 ? void 0 : object.accum_value) ? object.accum_value.map(e => coin.DecCoin.fromAmino(e)) : [],
      totalShares: object.total_shares
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.accumValue) {
      obj.accum_value = message.accumValue.map(e => e ? coin.DecCoin.toAmino(e) : undefined);
    } else {
      obj.accum_value = [];
    }

    obj.total_shares = message.totalShares;
    return obj;
  },

  fromAminoMsg(object) {
    return AccumulatorContent.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/accum/accumulator-content",
      value: AccumulatorContent.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return AccumulatorContent.decode(message.value);
  },

  toProto(message) {
    return AccumulatorContent.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.accum.v1beta1.AccumulatorContent",
      value: AccumulatorContent.encode(message).finish()
    };
  }

};

function createBaseOptions() {
  return {};
}

const Options = {
  typeUrl: "/osmosis.accum.v1beta1.Options",

  encode(_, writer = minimal.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOptions();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseOptions();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return Options.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/accum/options",
      value: Options.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return Options.decode(message.value);
  },

  toProto(message) {
    return Options.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.accum.v1beta1.Options",
      value: Options.encode(message).finish()
    };
  }

};

function createBaseRecord() {
  return {
    numShares: "",
    accumValuePerShare: [],
    unclaimedRewardsTotal: [],
    options: undefined
  };
}

const Record = {
  typeUrl: "/osmosis.accum.v1beta1.Record",

  encode(message, writer = minimal.Writer.create()) {
    if (message.numShares !== "") {
      writer.uint32(10).string(message.numShares);
    }

    for (const v of message.accumValuePerShare) {
      coin.DecCoin.encode(v, writer.uint32(18).fork()).ldelim();
    }

    for (const v of message.unclaimedRewardsTotal) {
      coin.DecCoin.encode(v, writer.uint32(26).fork()).ldelim();
    }

    if (message.options !== undefined) {
      Options.encode(message.options, writer.uint32(34).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRecord();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.numShares = reader.string();
          break;

        case 2:
          message.accumValuePerShare.push(coin.DecCoin.decode(reader, reader.uint32()));
          break;

        case 3:
          message.unclaimedRewardsTotal.push(coin.DecCoin.decode(reader, reader.uint32()));
          break;

        case 4:
          message.options = Options.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$numShares, _object$accumValuePer, _object$unclaimedRewa;

    const message = createBaseRecord();
    message.numShares = (_object$numShares = object.numShares) !== null && _object$numShares !== void 0 ? _object$numShares : "";
    message.accumValuePerShare = ((_object$accumValuePer = object.accumValuePerShare) === null || _object$accumValuePer === void 0 ? void 0 : _object$accumValuePer.map(e => coin.DecCoin.fromPartial(e))) || [];
    message.unclaimedRewardsTotal = ((_object$unclaimedRewa = object.unclaimedRewardsTotal) === null || _object$unclaimedRewa === void 0 ? void 0 : _object$unclaimedRewa.map(e => coin.DecCoin.fromPartial(e))) || [];
    message.options = object.options !== undefined && object.options !== null ? Options.fromPartial(object.options) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      numShares: object.num_shares,
      accumValuePerShare: Array.isArray(object === null || object === void 0 ? void 0 : object.accum_value_per_share) ? object.accum_value_per_share.map(e => coin.DecCoin.fromAmino(e)) : [],
      unclaimedRewardsTotal: Array.isArray(object === null || object === void 0 ? void 0 : object.unclaimed_rewards_total) ? object.unclaimed_rewards_total.map(e => coin.DecCoin.fromAmino(e)) : [],
      options: object !== null && object !== void 0 && object.options ? Options.fromAmino(object.options) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.num_shares = message.numShares;

    if (message.accumValuePerShare) {
      obj.accum_value_per_share = message.accumValuePerShare.map(e => e ? coin.DecCoin.toAmino(e) : undefined);
    } else {
      obj.accum_value_per_share = [];
    }

    if (message.unclaimedRewardsTotal) {
      obj.unclaimed_rewards_total = message.unclaimedRewardsTotal.map(e => e ? coin.DecCoin.toAmino(e) : undefined);
    } else {
      obj.unclaimed_rewards_total = [];
    }

    obj.options = message.options ? Options.toAmino(message.options) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return Record.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/accum/record",
      value: Record.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return Record.decode(message.value);
  },

  toProto(message) {
    return Record.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.accum.v1beta1.Record",
      value: Record.encode(message).finish()
    };
  }

};
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/osmosis/concentrated-liquidity/params.js
var concentrated_liquidity_params = __webpack_require__(55621);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/osmosis/cosmwasmpool/v1beta1/params.js
var v1beta1_params = __webpack_require__(33140);
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/osmosis/cosmwasmpool/v1beta1/genesis.js


/** GenesisState defines the cosmwasmpool module's genesis state. */

function cosmwasmpool_v1beta1_genesis_createBaseGenesisState() {
  return {
    params: undefined
  };
}

const cosmwasmpool_v1beta1_genesis_GenesisState = {
  typeUrl: "/osmosis.cosmwasmpool.v1beta1.GenesisState",

  encode(message, writer = minimal.Writer.create()) {
    if (message.params !== undefined) {
      v1beta1_params.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = cosmwasmpool_v1beta1_genesis_createBaseGenesisState();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.params = v1beta1_params.Params.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = cosmwasmpool_v1beta1_genesis_createBaseGenesisState();
    message.params = object.params !== undefined && object.params !== null ? v1beta1_params.Params.fromPartial(object.params) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      params: object !== null && object !== void 0 && object.params ? v1beta1_params.Params.fromAmino(object.params) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.params = message.params ? v1beta1_params.Params.toAmino(message.params) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return cosmwasmpool_v1beta1_genesis_GenesisState.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/cosmwasmpool/genesis-state",
      value: cosmwasmpool_v1beta1_genesis_GenesisState.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return cosmwasmpool_v1beta1_genesis_GenesisState.decode(message.value);
  },

  toProto(message) {
    return cosmwasmpool_v1beta1_genesis_GenesisState.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.cosmwasmpool.v1beta1.GenesisState",
      value: cosmwasmpool_v1beta1_genesis_GenesisState.encode(message).finish()
    };
  }

};
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/osmosis/cosmwasmpool/v1beta1/gov.js



/**
 * UploadCosmWasmPoolCodeAndWhiteListProposal is a gov Content type for
 * uploading coswasm pool code and adding it to internal whitelist. Only the
 * code ids created by this message are eligible for being x/cosmwasmpool pools.
 */

function createBaseUploadCosmWasmPoolCodeAndWhiteListProposal() {
  return {
    title: "",
    description: "",
    wasmByteCode: new Uint8Array()
  };
}

const UploadCosmWasmPoolCodeAndWhiteListProposal = {
  typeUrl: "/osmosis.cosmwasmpool.v1beta1.UploadCosmWasmPoolCodeAndWhiteListProposal",

  encode(message, writer = minimal.Writer.create()) {
    if (message.title !== "") {
      writer.uint32(10).string(message.title);
    }

    if (message.description !== "") {
      writer.uint32(18).string(message.description);
    }

    if (message.wasmByteCode.length !== 0) {
      writer.uint32(26).bytes(message.wasmByteCode);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUploadCosmWasmPoolCodeAndWhiteListProposal();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.title = reader.string();
          break;

        case 2:
          message.description = reader.string();
          break;

        case 3:
          message.wasmByteCode = reader.bytes();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$title, _object$description, _object$wasmByteCode;

    const message = createBaseUploadCosmWasmPoolCodeAndWhiteListProposal();
    message.title = (_object$title = object.title) !== null && _object$title !== void 0 ? _object$title : "";
    message.description = (_object$description = object.description) !== null && _object$description !== void 0 ? _object$description : "";
    message.wasmByteCode = (_object$wasmByteCode = object.wasmByteCode) !== null && _object$wasmByteCode !== void 0 ? _object$wasmByteCode : new Uint8Array();
    return message;
  },

  fromAmino(object) {
    return {
      title: object.title,
      description: object.description,
      wasmByteCode: (0,encoding_build.fromBase64)(object.wasm_byte_code)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.title = message.title;
    obj.description = message.description;
    obj.wasm_byte_code = message.wasmByteCode ? (0,encoding_build.toBase64)(message.wasmByteCode) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return UploadCosmWasmPoolCodeAndWhiteListProposal.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/cosmwasmpool/upload-cosm-wasm-pool-code-and-white-list-proposal",
      value: UploadCosmWasmPoolCodeAndWhiteListProposal.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return UploadCosmWasmPoolCodeAndWhiteListProposal.decode(message.value);
  },

  toProto(message) {
    return UploadCosmWasmPoolCodeAndWhiteListProposal.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.cosmwasmpool.v1beta1.UploadCosmWasmPoolCodeAndWhiteListProposal",
      value: UploadCosmWasmPoolCodeAndWhiteListProposal.encode(message).finish()
    };
  }

};

function createBaseMigratePoolContractsProposal() {
  return {
    title: "",
    description: "",
    poolIds: [],
    newCodeId: helpers/* Long.UZERO */.dK.UZERO,
    wasmByteCode: new Uint8Array(),
    migrateMsg: new Uint8Array()
  };
}

const MigratePoolContractsProposal = {
  typeUrl: "/osmosis.cosmwasmpool.v1beta1.MigratePoolContractsProposal",

  encode(message, writer = minimal.Writer.create()) {
    if (message.title !== "") {
      writer.uint32(10).string(message.title);
    }

    if (message.description !== "") {
      writer.uint32(18).string(message.description);
    }

    writer.uint32(26).fork();

    for (const v of message.poolIds) {
      writer.uint64(v);
    }

    writer.ldelim();

    if (!message.newCodeId.isZero()) {
      writer.uint32(32).uint64(message.newCodeId);
    }

    if (message.wasmByteCode.length !== 0) {
      writer.uint32(42).bytes(message.wasmByteCode);
    }

    if (message.migrateMsg.length !== 0) {
      writer.uint32(50).bytes(message.migrateMsg);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMigratePoolContractsProposal();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.title = reader.string();
          break;

        case 2:
          message.description = reader.string();
          break;

        case 3:
          if ((tag & 7) === 2) {
            const end2 = reader.uint32() + reader.pos;

            while (reader.pos < end2) {
              message.poolIds.push(reader.uint64());
            }
          } else {
            message.poolIds.push(reader.uint64());
          }

          break;

        case 4:
          message.newCodeId = reader.uint64();
          break;

        case 5:
          message.wasmByteCode = reader.bytes();
          break;

        case 6:
          message.migrateMsg = reader.bytes();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$title2, _object$description2, _object$poolIds, _object$wasmByteCode2, _object$migrateMsg;

    const message = createBaseMigratePoolContractsProposal();
    message.title = (_object$title2 = object.title) !== null && _object$title2 !== void 0 ? _object$title2 : "";
    message.description = (_object$description2 = object.description) !== null && _object$description2 !== void 0 ? _object$description2 : "";
    message.poolIds = ((_object$poolIds = object.poolIds) === null || _object$poolIds === void 0 ? void 0 : _object$poolIds.map(e => helpers/* Long.fromValue */.dK.fromValue(e))) || [];
    message.newCodeId = object.newCodeId !== undefined && object.newCodeId !== null ? helpers/* Long.fromValue */.dK.fromValue(object.newCodeId) : helpers/* Long.UZERO */.dK.UZERO;
    message.wasmByteCode = (_object$wasmByteCode2 = object.wasmByteCode) !== null && _object$wasmByteCode2 !== void 0 ? _object$wasmByteCode2 : new Uint8Array();
    message.migrateMsg = (_object$migrateMsg = object.migrateMsg) !== null && _object$migrateMsg !== void 0 ? _object$migrateMsg : new Uint8Array();
    return message;
  },

  fromAmino(object) {
    return {
      title: object.title,
      description: object.description,
      poolIds: Array.isArray(object === null || object === void 0 ? void 0 : object.pool_ids) ? object.pool_ids.map(e => e) : [],
      newCodeId: helpers/* Long.fromString */.dK.fromString(object.new_code_id),
      wasmByteCode: (0,encoding_build.fromBase64)(object.wasm_byte_code),
      migrateMsg: object.migrate_msg
    };
  },

  toAmino(message) {
    const obj = {};
    obj.title = message.title;
    obj.description = message.description;

    if (message.poolIds) {
      obj.pool_ids = message.poolIds.map(e => e);
    } else {
      obj.pool_ids = [];
    }

    obj.new_code_id = message.newCodeId ? message.newCodeId.toString() : undefined;
    obj.wasm_byte_code = message.wasmByteCode ? (0,encoding_build.toBase64)(message.wasmByteCode) : undefined;
    obj.migrate_msg = message.migrateMsg;
    return obj;
  },

  fromAminoMsg(object) {
    return MigratePoolContractsProposal.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/cosmwasmpool/migrate-pool-contracts-proposal",
      value: MigratePoolContractsProposal.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MigratePoolContractsProposal.decode(message.value);
  },

  toProto(message) {
    return MigratePoolContractsProposal.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.cosmwasmpool.v1beta1.MigratePoolContractsProposal",
      value: MigratePoolContractsProposal.encode(message).finish()
    };
  }

};
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/osmosis/cosmwasmpool/v1beta1/model/instantiate_msg.js

/** ===================== InstantiateMsg */

function createBaseInstantiateMsg() {
  return {
    poolAssetDenoms: []
  };
}

const InstantiateMsg = {
  typeUrl: "/osmosis.cosmwasmpool.v1beta1.InstantiateMsg",

  encode(message, writer = minimal.Writer.create()) {
    for (const v of message.poolAssetDenoms) {
      writer.uint32(10).string(v);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInstantiateMsg();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.poolAssetDenoms.push(reader.string());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$poolAssetDeno;

    const message = createBaseInstantiateMsg();
    message.poolAssetDenoms = ((_object$poolAssetDeno = object.poolAssetDenoms) === null || _object$poolAssetDeno === void 0 ? void 0 : _object$poolAssetDeno.map(e => e)) || [];
    return message;
  },

  fromAmino(object) {
    return {
      poolAssetDenoms: Array.isArray(object === null || object === void 0 ? void 0 : object.pool_asset_denoms) ? object.pool_asset_denoms.map(e => e) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.poolAssetDenoms) {
      obj.pool_asset_denoms = message.poolAssetDenoms.map(e => e);
    } else {
      obj.pool_asset_denoms = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return InstantiateMsg.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/cosmwasmpool/instantiate-msg",
      value: InstantiateMsg.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return InstantiateMsg.decode(message.value);
  },

  toProto(message) {
    return InstantiateMsg.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.cosmwasmpool.v1beta1.InstantiateMsg",
      value: InstantiateMsg.encode(message).finish()
    };
  }

};
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/osmosis/cosmwasmpool/v1beta1/model/module_query_msg.js


/** ===================== CalcOutAmtGivenIn */

function createBaseCalcOutAmtGivenIn() {
  return {
    tokenIn: undefined,
    tokenOutDenom: "",
    swapFee: ""
  };
}

const CalcOutAmtGivenIn = {
  typeUrl: "/osmosis.cosmwasmpool.v1beta1.CalcOutAmtGivenIn",

  encode(message, writer = minimal.Writer.create()) {
    if (message.tokenIn !== undefined) {
      coin.Coin.encode(message.tokenIn, writer.uint32(10).fork()).ldelim();
    }

    if (message.tokenOutDenom !== "") {
      writer.uint32(18).string(message.tokenOutDenom);
    }

    if (message.swapFee !== "") {
      writer.uint32(26).string(message.swapFee);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCalcOutAmtGivenIn();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.tokenIn = coin.Coin.decode(reader, reader.uint32());
          break;

        case 2:
          message.tokenOutDenom = reader.string();
          break;

        case 3:
          message.swapFee = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$tokenOutDenom, _object$swapFee;

    const message = createBaseCalcOutAmtGivenIn();
    message.tokenIn = object.tokenIn !== undefined && object.tokenIn !== null ? coin.Coin.fromPartial(object.tokenIn) : undefined;
    message.tokenOutDenom = (_object$tokenOutDenom = object.tokenOutDenom) !== null && _object$tokenOutDenom !== void 0 ? _object$tokenOutDenom : "";
    message.swapFee = (_object$swapFee = object.swapFee) !== null && _object$swapFee !== void 0 ? _object$swapFee : "";
    return message;
  },

  fromAmino(object) {
    return {
      tokenIn: object !== null && object !== void 0 && object.token_in ? coin.Coin.fromAmino(object.token_in) : undefined,
      tokenOutDenom: object.token_out_denom,
      swapFee: object.swap_fee
    };
  },

  toAmino(message) {
    const obj = {};
    obj.token_in = message.tokenIn ? coin.Coin.toAmino(message.tokenIn) : undefined;
    obj.token_out_denom = message.tokenOutDenom;
    obj.swap_fee = message.swapFee;
    return obj;
  },

  fromAminoMsg(object) {
    return CalcOutAmtGivenIn.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/cosmwasmpool/calc-out-amt-given-in",
      value: CalcOutAmtGivenIn.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return CalcOutAmtGivenIn.decode(message.value);
  },

  toProto(message) {
    return CalcOutAmtGivenIn.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.cosmwasmpool.v1beta1.CalcOutAmtGivenIn",
      value: CalcOutAmtGivenIn.encode(message).finish()
    };
  }

};

function createBaseCalcOutAmtGivenInRequest() {
  return {
    calcOutAmtGivenIn: undefined
  };
}

const CalcOutAmtGivenInRequest = {
  typeUrl: "/osmosis.cosmwasmpool.v1beta1.CalcOutAmtGivenInRequest",

  encode(message, writer = minimal.Writer.create()) {
    if (message.calcOutAmtGivenIn !== undefined) {
      CalcOutAmtGivenIn.encode(message.calcOutAmtGivenIn, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCalcOutAmtGivenInRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.calcOutAmtGivenIn = CalcOutAmtGivenIn.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseCalcOutAmtGivenInRequest();
    message.calcOutAmtGivenIn = object.calcOutAmtGivenIn !== undefined && object.calcOutAmtGivenIn !== null ? CalcOutAmtGivenIn.fromPartial(object.calcOutAmtGivenIn) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      calcOutAmtGivenIn: object !== null && object !== void 0 && object.calc_out_amt_given_in ? CalcOutAmtGivenIn.fromAmino(object.calc_out_amt_given_in) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.calc_out_amt_given_in = message.calcOutAmtGivenIn ? CalcOutAmtGivenIn.toAmino(message.calcOutAmtGivenIn) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return CalcOutAmtGivenInRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/cosmwasmpool/calc-out-amt-given-in-request",
      value: CalcOutAmtGivenInRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return CalcOutAmtGivenInRequest.decode(message.value);
  },

  toProto(message) {
    return CalcOutAmtGivenInRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.cosmwasmpool.v1beta1.CalcOutAmtGivenInRequest",
      value: CalcOutAmtGivenInRequest.encode(message).finish()
    };
  }

};

function createBaseCalcOutAmtGivenInResponse() {
  return {
    tokenOut: undefined
  };
}

const CalcOutAmtGivenInResponse = {
  typeUrl: "/osmosis.cosmwasmpool.v1beta1.CalcOutAmtGivenInResponse",

  encode(message, writer = minimal.Writer.create()) {
    if (message.tokenOut !== undefined) {
      coin.Coin.encode(message.tokenOut, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCalcOutAmtGivenInResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.tokenOut = coin.Coin.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseCalcOutAmtGivenInResponse();
    message.tokenOut = object.tokenOut !== undefined && object.tokenOut !== null ? coin.Coin.fromPartial(object.tokenOut) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      tokenOut: object !== null && object !== void 0 && object.token_out ? coin.Coin.fromAmino(object.token_out) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.token_out = message.tokenOut ? coin.Coin.toAmino(message.tokenOut) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return CalcOutAmtGivenInResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/cosmwasmpool/calc-out-amt-given-in-response",
      value: CalcOutAmtGivenInResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return CalcOutAmtGivenInResponse.decode(message.value);
  },

  toProto(message) {
    return CalcOutAmtGivenInResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.cosmwasmpool.v1beta1.CalcOutAmtGivenInResponse",
      value: CalcOutAmtGivenInResponse.encode(message).finish()
    };
  }

};

function createBaseCalcInAmtGivenOut() {
  return {
    tokenOut: undefined,
    tokenInDenom: "",
    swapFee: ""
  };
}

const CalcInAmtGivenOut = {
  typeUrl: "/osmosis.cosmwasmpool.v1beta1.CalcInAmtGivenOut",

  encode(message, writer = minimal.Writer.create()) {
    if (message.tokenOut !== undefined) {
      coin.Coin.encode(message.tokenOut, writer.uint32(10).fork()).ldelim();
    }

    if (message.tokenInDenom !== "") {
      writer.uint32(18).string(message.tokenInDenom);
    }

    if (message.swapFee !== "") {
      writer.uint32(26).string(message.swapFee);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCalcInAmtGivenOut();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.tokenOut = coin.Coin.decode(reader, reader.uint32());
          break;

        case 2:
          message.tokenInDenom = reader.string();
          break;

        case 3:
          message.swapFee = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$tokenInDenom, _object$swapFee2;

    const message = createBaseCalcInAmtGivenOut();
    message.tokenOut = object.tokenOut !== undefined && object.tokenOut !== null ? coin.Coin.fromPartial(object.tokenOut) : undefined;
    message.tokenInDenom = (_object$tokenInDenom = object.tokenInDenom) !== null && _object$tokenInDenom !== void 0 ? _object$tokenInDenom : "";
    message.swapFee = (_object$swapFee2 = object.swapFee) !== null && _object$swapFee2 !== void 0 ? _object$swapFee2 : "";
    return message;
  },

  fromAmino(object) {
    return {
      tokenOut: object !== null && object !== void 0 && object.token_out ? coin.Coin.fromAmino(object.token_out) : undefined,
      tokenInDenom: object.token_in_denom,
      swapFee: object.swap_fee
    };
  },

  toAmino(message) {
    const obj = {};
    obj.token_out = message.tokenOut ? coin.Coin.toAmino(message.tokenOut) : undefined;
    obj.token_in_denom = message.tokenInDenom;
    obj.swap_fee = message.swapFee;
    return obj;
  },

  fromAminoMsg(object) {
    return CalcInAmtGivenOut.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/cosmwasmpool/calc-in-amt-given-out",
      value: CalcInAmtGivenOut.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return CalcInAmtGivenOut.decode(message.value);
  },

  toProto(message) {
    return CalcInAmtGivenOut.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.cosmwasmpool.v1beta1.CalcInAmtGivenOut",
      value: CalcInAmtGivenOut.encode(message).finish()
    };
  }

};

function createBaseCalcInAmtGivenOutRequest() {
  return {
    calcInAmtGivenOut: undefined
  };
}

const CalcInAmtGivenOutRequest = {
  typeUrl: "/osmosis.cosmwasmpool.v1beta1.CalcInAmtGivenOutRequest",

  encode(message, writer = minimal.Writer.create()) {
    if (message.calcInAmtGivenOut !== undefined) {
      CalcInAmtGivenOut.encode(message.calcInAmtGivenOut, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCalcInAmtGivenOutRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.calcInAmtGivenOut = CalcInAmtGivenOut.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseCalcInAmtGivenOutRequest();
    message.calcInAmtGivenOut = object.calcInAmtGivenOut !== undefined && object.calcInAmtGivenOut !== null ? CalcInAmtGivenOut.fromPartial(object.calcInAmtGivenOut) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      calcInAmtGivenOut: object !== null && object !== void 0 && object.calc_in_amt_given_out ? CalcInAmtGivenOut.fromAmino(object.calc_in_amt_given_out) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.calc_in_amt_given_out = message.calcInAmtGivenOut ? CalcInAmtGivenOut.toAmino(message.calcInAmtGivenOut) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return CalcInAmtGivenOutRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/cosmwasmpool/calc-in-amt-given-out-request",
      value: CalcInAmtGivenOutRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return CalcInAmtGivenOutRequest.decode(message.value);
  },

  toProto(message) {
    return CalcInAmtGivenOutRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.cosmwasmpool.v1beta1.CalcInAmtGivenOutRequest",
      value: CalcInAmtGivenOutRequest.encode(message).finish()
    };
  }

};

function createBaseCalcInAmtGivenOutResponse() {
  return {
    tokenIn: undefined
  };
}

const CalcInAmtGivenOutResponse = {
  typeUrl: "/osmosis.cosmwasmpool.v1beta1.CalcInAmtGivenOutResponse",

  encode(message, writer = minimal.Writer.create()) {
    if (message.tokenIn !== undefined) {
      coin.Coin.encode(message.tokenIn, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCalcInAmtGivenOutResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.tokenIn = coin.Coin.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseCalcInAmtGivenOutResponse();
    message.tokenIn = object.tokenIn !== undefined && object.tokenIn !== null ? coin.Coin.fromPartial(object.tokenIn) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      tokenIn: object !== null && object !== void 0 && object.token_in ? coin.Coin.fromAmino(object.token_in) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.token_in = message.tokenIn ? coin.Coin.toAmino(message.tokenIn) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return CalcInAmtGivenOutResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/cosmwasmpool/calc-in-amt-given-out-response",
      value: CalcInAmtGivenOutResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return CalcInAmtGivenOutResponse.decode(message.value);
  },

  toProto(message) {
    return CalcInAmtGivenOutResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.cosmwasmpool.v1beta1.CalcInAmtGivenOutResponse",
      value: CalcInAmtGivenOutResponse.encode(message).finish()
    };
  }

};
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/osmosis/cosmwasmpool/v1beta1/model/module_sudo_msg.js


/** ===================== SwapExactAmountIn */

function createBaseSwapExactAmountIn() {
  return {
    sender: "",
    tokenIn: undefined,
    tokenOutDenom: "",
    tokenOutMinAmount: "",
    swapFee: ""
  };
}

const SwapExactAmountIn = {
  typeUrl: "/osmosis.cosmwasmpool.v1beta1.SwapExactAmountIn",

  encode(message, writer = minimal.Writer.create()) {
    if (message.sender !== "") {
      writer.uint32(10).string(message.sender);
    }

    if (message.tokenIn !== undefined) {
      coin.Coin.encode(message.tokenIn, writer.uint32(18).fork()).ldelim();
    }

    if (message.tokenOutDenom !== "") {
      writer.uint32(26).string(message.tokenOutDenom);
    }

    if (message.tokenOutMinAmount !== "") {
      writer.uint32(34).string(message.tokenOutMinAmount);
    }

    if (message.swapFee !== "") {
      writer.uint32(42).string(message.swapFee);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSwapExactAmountIn();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.sender = reader.string();
          break;

        case 2:
          message.tokenIn = coin.Coin.decode(reader, reader.uint32());
          break;

        case 3:
          message.tokenOutDenom = reader.string();
          break;

        case 4:
          message.tokenOutMinAmount = reader.string();
          break;

        case 5:
          message.swapFee = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$sender, _object$tokenOutDenom, _object$tokenOutMinAm, _object$swapFee;

    const message = createBaseSwapExactAmountIn();
    message.sender = (_object$sender = object.sender) !== null && _object$sender !== void 0 ? _object$sender : "";
    message.tokenIn = object.tokenIn !== undefined && object.tokenIn !== null ? coin.Coin.fromPartial(object.tokenIn) : undefined;
    message.tokenOutDenom = (_object$tokenOutDenom = object.tokenOutDenom) !== null && _object$tokenOutDenom !== void 0 ? _object$tokenOutDenom : "";
    message.tokenOutMinAmount = (_object$tokenOutMinAm = object.tokenOutMinAmount) !== null && _object$tokenOutMinAm !== void 0 ? _object$tokenOutMinAm : "";
    message.swapFee = (_object$swapFee = object.swapFee) !== null && _object$swapFee !== void 0 ? _object$swapFee : "";
    return message;
  },

  fromAmino(object) {
    return {
      sender: object.sender,
      tokenIn: object !== null && object !== void 0 && object.token_in ? coin.Coin.fromAmino(object.token_in) : undefined,
      tokenOutDenom: object.token_out_denom,
      tokenOutMinAmount: object.token_out_min_amount,
      swapFee: object.swap_fee
    };
  },

  toAmino(message) {
    const obj = {};
    obj.sender = message.sender;
    obj.token_in = message.tokenIn ? coin.Coin.toAmino(message.tokenIn) : undefined;
    obj.token_out_denom = message.tokenOutDenom;
    obj.token_out_min_amount = message.tokenOutMinAmount;
    obj.swap_fee = message.swapFee;
    return obj;
  },

  fromAminoMsg(object) {
    return SwapExactAmountIn.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/cosmwasmpool/swap-exact-amount-in",
      value: SwapExactAmountIn.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return SwapExactAmountIn.decode(message.value);
  },

  toProto(message) {
    return SwapExactAmountIn.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.cosmwasmpool.v1beta1.SwapExactAmountIn",
      value: SwapExactAmountIn.encode(message).finish()
    };
  }

};

function createBaseSwapExactAmountInSudoMsg() {
  return {
    swapExactAmountIn: undefined
  };
}

const SwapExactAmountInSudoMsg = {
  typeUrl: "/osmosis.cosmwasmpool.v1beta1.SwapExactAmountInSudoMsg",

  encode(message, writer = minimal.Writer.create()) {
    if (message.swapExactAmountIn !== undefined) {
      SwapExactAmountIn.encode(message.swapExactAmountIn, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSwapExactAmountInSudoMsg();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.swapExactAmountIn = SwapExactAmountIn.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseSwapExactAmountInSudoMsg();
    message.swapExactAmountIn = object.swapExactAmountIn !== undefined && object.swapExactAmountIn !== null ? SwapExactAmountIn.fromPartial(object.swapExactAmountIn) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      swapExactAmountIn: object !== null && object !== void 0 && object.swap_exact_amount_in ? SwapExactAmountIn.fromAmino(object.swap_exact_amount_in) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.swap_exact_amount_in = message.swapExactAmountIn ? SwapExactAmountIn.toAmino(message.swapExactAmountIn) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return SwapExactAmountInSudoMsg.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/cosmwasmpool/swap-exact-amount-in-sudo-msg",
      value: SwapExactAmountInSudoMsg.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return SwapExactAmountInSudoMsg.decode(message.value);
  },

  toProto(message) {
    return SwapExactAmountInSudoMsg.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.cosmwasmpool.v1beta1.SwapExactAmountInSudoMsg",
      value: SwapExactAmountInSudoMsg.encode(message).finish()
    };
  }

};

function createBaseSwapExactAmountInSudoMsgResponse() {
  return {
    tokenOutAmount: ""
  };
}

const SwapExactAmountInSudoMsgResponse = {
  typeUrl: "/osmosis.cosmwasmpool.v1beta1.SwapExactAmountInSudoMsgResponse",

  encode(message, writer = minimal.Writer.create()) {
    if (message.tokenOutAmount !== "") {
      writer.uint32(10).string(message.tokenOutAmount);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSwapExactAmountInSudoMsgResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.tokenOutAmount = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$tokenOutAmoun;

    const message = createBaseSwapExactAmountInSudoMsgResponse();
    message.tokenOutAmount = (_object$tokenOutAmoun = object.tokenOutAmount) !== null && _object$tokenOutAmoun !== void 0 ? _object$tokenOutAmoun : "";
    return message;
  },

  fromAmino(object) {
    return {
      tokenOutAmount: object.token_out_amount
    };
  },

  toAmino(message) {
    const obj = {};
    obj.token_out_amount = message.tokenOutAmount;
    return obj;
  },

  fromAminoMsg(object) {
    return SwapExactAmountInSudoMsgResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/cosmwasmpool/swap-exact-amount-in-sudo-msg-response",
      value: SwapExactAmountInSudoMsgResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return SwapExactAmountInSudoMsgResponse.decode(message.value);
  },

  toProto(message) {
    return SwapExactAmountInSudoMsgResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.cosmwasmpool.v1beta1.SwapExactAmountInSudoMsgResponse",
      value: SwapExactAmountInSudoMsgResponse.encode(message).finish()
    };
  }

};

function createBaseSwapExactAmountOut() {
  return {
    sender: "",
    tokenOut: undefined,
    tokenInDenom: "",
    tokenInMaxAmount: "",
    swapFee: ""
  };
}

const SwapExactAmountOut = {
  typeUrl: "/osmosis.cosmwasmpool.v1beta1.SwapExactAmountOut",

  encode(message, writer = minimal.Writer.create()) {
    if (message.sender !== "") {
      writer.uint32(10).string(message.sender);
    }

    if (message.tokenOut !== undefined) {
      coin.Coin.encode(message.tokenOut, writer.uint32(18).fork()).ldelim();
    }

    if (message.tokenInDenom !== "") {
      writer.uint32(26).string(message.tokenInDenom);
    }

    if (message.tokenInMaxAmount !== "") {
      writer.uint32(34).string(message.tokenInMaxAmount);
    }

    if (message.swapFee !== "") {
      writer.uint32(42).string(message.swapFee);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSwapExactAmountOut();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.sender = reader.string();
          break;

        case 2:
          message.tokenOut = coin.Coin.decode(reader, reader.uint32());
          break;

        case 3:
          message.tokenInDenom = reader.string();
          break;

        case 4:
          message.tokenInMaxAmount = reader.string();
          break;

        case 5:
          message.swapFee = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$sender2, _object$tokenInDenom, _object$tokenInMaxAmo, _object$swapFee2;

    const message = createBaseSwapExactAmountOut();
    message.sender = (_object$sender2 = object.sender) !== null && _object$sender2 !== void 0 ? _object$sender2 : "";
    message.tokenOut = object.tokenOut !== undefined && object.tokenOut !== null ? coin.Coin.fromPartial(object.tokenOut) : undefined;
    message.tokenInDenom = (_object$tokenInDenom = object.tokenInDenom) !== null && _object$tokenInDenom !== void 0 ? _object$tokenInDenom : "";
    message.tokenInMaxAmount = (_object$tokenInMaxAmo = object.tokenInMaxAmount) !== null && _object$tokenInMaxAmo !== void 0 ? _object$tokenInMaxAmo : "";
    message.swapFee = (_object$swapFee2 = object.swapFee) !== null && _object$swapFee2 !== void 0 ? _object$swapFee2 : "";
    return message;
  },

  fromAmino(object) {
    return {
      sender: object.sender,
      tokenOut: object !== null && object !== void 0 && object.token_out ? coin.Coin.fromAmino(object.token_out) : undefined,
      tokenInDenom: object.token_in_denom,
      tokenInMaxAmount: object.token_in_max_amount,
      swapFee: object.swap_fee
    };
  },

  toAmino(message) {
    const obj = {};
    obj.sender = message.sender;
    obj.token_out = message.tokenOut ? coin.Coin.toAmino(message.tokenOut) : undefined;
    obj.token_in_denom = message.tokenInDenom;
    obj.token_in_max_amount = message.tokenInMaxAmount;
    obj.swap_fee = message.swapFee;
    return obj;
  },

  fromAminoMsg(object) {
    return SwapExactAmountOut.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/cosmwasmpool/swap-exact-amount-out",
      value: SwapExactAmountOut.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return SwapExactAmountOut.decode(message.value);
  },

  toProto(message) {
    return SwapExactAmountOut.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.cosmwasmpool.v1beta1.SwapExactAmountOut",
      value: SwapExactAmountOut.encode(message).finish()
    };
  }

};

function createBaseSwapExactAmountOutSudoMsg() {
  return {
    swapExactAmountOut: undefined
  };
}

const SwapExactAmountOutSudoMsg = {
  typeUrl: "/osmosis.cosmwasmpool.v1beta1.SwapExactAmountOutSudoMsg",

  encode(message, writer = minimal.Writer.create()) {
    if (message.swapExactAmountOut !== undefined) {
      SwapExactAmountOut.encode(message.swapExactAmountOut, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSwapExactAmountOutSudoMsg();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.swapExactAmountOut = SwapExactAmountOut.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseSwapExactAmountOutSudoMsg();
    message.swapExactAmountOut = object.swapExactAmountOut !== undefined && object.swapExactAmountOut !== null ? SwapExactAmountOut.fromPartial(object.swapExactAmountOut) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      swapExactAmountOut: object !== null && object !== void 0 && object.swap_exact_amount_out ? SwapExactAmountOut.fromAmino(object.swap_exact_amount_out) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.swap_exact_amount_out = message.swapExactAmountOut ? SwapExactAmountOut.toAmino(message.swapExactAmountOut) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return SwapExactAmountOutSudoMsg.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/cosmwasmpool/swap-exact-amount-out-sudo-msg",
      value: SwapExactAmountOutSudoMsg.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return SwapExactAmountOutSudoMsg.decode(message.value);
  },

  toProto(message) {
    return SwapExactAmountOutSudoMsg.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.cosmwasmpool.v1beta1.SwapExactAmountOutSudoMsg",
      value: SwapExactAmountOutSudoMsg.encode(message).finish()
    };
  }

};

function createBaseSwapExactAmountOutSudoMsgResponse() {
  return {
    tokenInAmount: ""
  };
}

const SwapExactAmountOutSudoMsgResponse = {
  typeUrl: "/osmosis.cosmwasmpool.v1beta1.SwapExactAmountOutSudoMsgResponse",

  encode(message, writer = minimal.Writer.create()) {
    if (message.tokenInAmount !== "") {
      writer.uint32(10).string(message.tokenInAmount);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSwapExactAmountOutSudoMsgResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.tokenInAmount = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$tokenInAmount;

    const message = createBaseSwapExactAmountOutSudoMsgResponse();
    message.tokenInAmount = (_object$tokenInAmount = object.tokenInAmount) !== null && _object$tokenInAmount !== void 0 ? _object$tokenInAmount : "";
    return message;
  },

  fromAmino(object) {
    return {
      tokenInAmount: object.token_in_amount
    };
  },

  toAmino(message) {
    const obj = {};
    obj.token_in_amount = message.tokenInAmount;
    return obj;
  },

  fromAminoMsg(object) {
    return SwapExactAmountOutSudoMsgResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/cosmwasmpool/swap-exact-amount-out-sudo-msg-response",
      value: SwapExactAmountOutSudoMsgResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return SwapExactAmountOutSudoMsgResponse.decode(message.value);
  },

  toProto(message) {
    return SwapExactAmountOutSudoMsgResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.cosmwasmpool.v1beta1.SwapExactAmountOutSudoMsgResponse",
      value: SwapExactAmountOutSudoMsgResponse.encode(message).finish()
    };
  }

};
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/osmosis/cosmwasmpool/v1beta1/model/pool_query_msg.js


/** ===================== GetSwapFeeQueryMsg */

function createBaseGetSwapFeeQueryMsg() {
  return {
    getSwapFee: undefined
  };
}

const GetSwapFeeQueryMsg = {
  typeUrl: "/osmosis.cosmwasmpool.v1beta1.GetSwapFeeQueryMsg",

  encode(message, writer = minimal.Writer.create()) {
    if (message.getSwapFee !== undefined) {
      EmptyStruct.encode(message.getSwapFee, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetSwapFeeQueryMsg();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.getSwapFee = EmptyStruct.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseGetSwapFeeQueryMsg();
    message.getSwapFee = object.getSwapFee !== undefined && object.getSwapFee !== null ? EmptyStruct.fromPartial(object.getSwapFee) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      getSwapFee: object !== null && object !== void 0 && object.get_swap_fee ? EmptyStruct.fromAmino(object.get_swap_fee) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.get_swap_fee = message.getSwapFee ? EmptyStruct.toAmino(message.getSwapFee) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return GetSwapFeeQueryMsg.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/cosmwasmpool/get-swap-fee-query-msg",
      value: GetSwapFeeQueryMsg.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return GetSwapFeeQueryMsg.decode(message.value);
  },

  toProto(message) {
    return GetSwapFeeQueryMsg.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.cosmwasmpool.v1beta1.GetSwapFeeQueryMsg",
      value: GetSwapFeeQueryMsg.encode(message).finish()
    };
  }

};

function createBaseGetSwapFeeQueryMsgResponse() {
  return {
    swapFee: ""
  };
}

const GetSwapFeeQueryMsgResponse = {
  typeUrl: "/osmosis.cosmwasmpool.v1beta1.GetSwapFeeQueryMsgResponse",

  encode(message, writer = minimal.Writer.create()) {
    if (message.swapFee !== "") {
      writer.uint32(26).string(message.swapFee);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetSwapFeeQueryMsgResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 3:
          message.swapFee = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$swapFee;

    const message = createBaseGetSwapFeeQueryMsgResponse();
    message.swapFee = (_object$swapFee = object.swapFee) !== null && _object$swapFee !== void 0 ? _object$swapFee : "";
    return message;
  },

  fromAmino(object) {
    return {
      swapFee: object.swap_fee
    };
  },

  toAmino(message) {
    const obj = {};
    obj.swap_fee = message.swapFee;
    return obj;
  },

  fromAminoMsg(object) {
    return GetSwapFeeQueryMsgResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/cosmwasmpool/get-swap-fee-query-msg-response",
      value: GetSwapFeeQueryMsgResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return GetSwapFeeQueryMsgResponse.decode(message.value);
  },

  toProto(message) {
    return GetSwapFeeQueryMsgResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.cosmwasmpool.v1beta1.GetSwapFeeQueryMsgResponse",
      value: GetSwapFeeQueryMsgResponse.encode(message).finish()
    };
  }

};

function createBaseSpotPrice() {
  return {
    quoteAssetDenom: "",
    baseAssetDenom: ""
  };
}

const SpotPrice = {
  typeUrl: "/osmosis.cosmwasmpool.v1beta1.SpotPrice",

  encode(message, writer = minimal.Writer.create()) {
    if (message.quoteAssetDenom !== "") {
      writer.uint32(10).string(message.quoteAssetDenom);
    }

    if (message.baseAssetDenom !== "") {
      writer.uint32(18).string(message.baseAssetDenom);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSpotPrice();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.quoteAssetDenom = reader.string();
          break;

        case 2:
          message.baseAssetDenom = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$quoteAssetDen, _object$baseAssetDeno;

    const message = createBaseSpotPrice();
    message.quoteAssetDenom = (_object$quoteAssetDen = object.quoteAssetDenom) !== null && _object$quoteAssetDen !== void 0 ? _object$quoteAssetDen : "";
    message.baseAssetDenom = (_object$baseAssetDeno = object.baseAssetDenom) !== null && _object$baseAssetDeno !== void 0 ? _object$baseAssetDeno : "";
    return message;
  },

  fromAmino(object) {
    return {
      quoteAssetDenom: object.quote_asset_denom,
      baseAssetDenom: object.base_asset_denom
    };
  },

  toAmino(message) {
    const obj = {};
    obj.quote_asset_denom = message.quoteAssetDenom;
    obj.base_asset_denom = message.baseAssetDenom;
    return obj;
  },

  fromAminoMsg(object) {
    return SpotPrice.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/cosmwasmpool/spot-price",
      value: SpotPrice.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return SpotPrice.decode(message.value);
  },

  toProto(message) {
    return SpotPrice.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.cosmwasmpool.v1beta1.SpotPrice",
      value: SpotPrice.encode(message).finish()
    };
  }

};

function createBaseSpotPriceQueryMsg() {
  return {
    spotPrice: undefined
  };
}

const SpotPriceQueryMsg = {
  typeUrl: "/osmosis.cosmwasmpool.v1beta1.SpotPriceQueryMsg",

  encode(message, writer = minimal.Writer.create()) {
    if (message.spotPrice !== undefined) {
      SpotPrice.encode(message.spotPrice, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSpotPriceQueryMsg();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.spotPrice = SpotPrice.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseSpotPriceQueryMsg();
    message.spotPrice = object.spotPrice !== undefined && object.spotPrice !== null ? SpotPrice.fromPartial(object.spotPrice) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      spotPrice: object !== null && object !== void 0 && object.spot_price ? SpotPrice.fromAmino(object.spot_price) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.spot_price = message.spotPrice ? SpotPrice.toAmino(message.spotPrice) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return SpotPriceQueryMsg.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/cosmwasmpool/spot-price-query-msg",
      value: SpotPriceQueryMsg.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return SpotPriceQueryMsg.decode(message.value);
  },

  toProto(message) {
    return SpotPriceQueryMsg.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.cosmwasmpool.v1beta1.SpotPriceQueryMsg",
      value: SpotPriceQueryMsg.encode(message).finish()
    };
  }

};

function createBaseSpotPriceQueryMsgResponse() {
  return {
    spotPrice: ""
  };
}

const SpotPriceQueryMsgResponse = {
  typeUrl: "/osmosis.cosmwasmpool.v1beta1.SpotPriceQueryMsgResponse",

  encode(message, writer = minimal.Writer.create()) {
    if (message.spotPrice !== "") {
      writer.uint32(10).string(message.spotPrice);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSpotPriceQueryMsgResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.spotPrice = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$spotPrice;

    const message = createBaseSpotPriceQueryMsgResponse();
    message.spotPrice = (_object$spotPrice = object.spotPrice) !== null && _object$spotPrice !== void 0 ? _object$spotPrice : "";
    return message;
  },

  fromAmino(object) {
    return {
      spotPrice: object.spot_price
    };
  },

  toAmino(message) {
    const obj = {};
    obj.spot_price = message.spotPrice;
    return obj;
  },

  fromAminoMsg(object) {
    return SpotPriceQueryMsgResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/cosmwasmpool/spot-price-query-msg-response",
      value: SpotPriceQueryMsgResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return SpotPriceQueryMsgResponse.decode(message.value);
  },

  toProto(message) {
    return SpotPriceQueryMsgResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.cosmwasmpool.v1beta1.SpotPriceQueryMsgResponse",
      value: SpotPriceQueryMsgResponse.encode(message).finish()
    };
  }

};

function createBaseEmptyStruct() {
  return {};
}

const EmptyStruct = {
  typeUrl: "/osmosis.cosmwasmpool.v1beta1.EmptyStruct",

  encode(_, writer = minimal.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEmptyStruct();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseEmptyStruct();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return EmptyStruct.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/cosmwasmpool/empty-struct",
      value: EmptyStruct.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return EmptyStruct.decode(message.value);
  },

  toProto(message) {
    return EmptyStruct.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.cosmwasmpool.v1beta1.EmptyStruct",
      value: EmptyStruct.encode(message).finish()
    };
  }

};

function createBaseGetTotalPoolLiquidityQueryMsg() {
  return {
    getTotalPoolLiquidity: undefined
  };
}

const GetTotalPoolLiquidityQueryMsg = {
  typeUrl: "/osmosis.cosmwasmpool.v1beta1.GetTotalPoolLiquidityQueryMsg",

  encode(message, writer = minimal.Writer.create()) {
    if (message.getTotalPoolLiquidity !== undefined) {
      EmptyStruct.encode(message.getTotalPoolLiquidity, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetTotalPoolLiquidityQueryMsg();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.getTotalPoolLiquidity = EmptyStruct.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseGetTotalPoolLiquidityQueryMsg();
    message.getTotalPoolLiquidity = object.getTotalPoolLiquidity !== undefined && object.getTotalPoolLiquidity !== null ? EmptyStruct.fromPartial(object.getTotalPoolLiquidity) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      getTotalPoolLiquidity: object !== null && object !== void 0 && object.get_total_pool_liquidity ? EmptyStruct.fromAmino(object.get_total_pool_liquidity) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.get_total_pool_liquidity = message.getTotalPoolLiquidity ? EmptyStruct.toAmino(message.getTotalPoolLiquidity) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return GetTotalPoolLiquidityQueryMsg.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/cosmwasmpool/get-total-pool-liquidity-query-msg",
      value: GetTotalPoolLiquidityQueryMsg.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return GetTotalPoolLiquidityQueryMsg.decode(message.value);
  },

  toProto(message) {
    return GetTotalPoolLiquidityQueryMsg.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.cosmwasmpool.v1beta1.GetTotalPoolLiquidityQueryMsg",
      value: GetTotalPoolLiquidityQueryMsg.encode(message).finish()
    };
  }

};

function createBaseGetTotalPoolLiquidityQueryMsgResponse() {
  return {
    totalPoolLiquidity: []
  };
}

const GetTotalPoolLiquidityQueryMsgResponse = {
  typeUrl: "/osmosis.cosmwasmpool.v1beta1.GetTotalPoolLiquidityQueryMsgResponse",

  encode(message, writer = minimal.Writer.create()) {
    for (const v of message.totalPoolLiquidity) {
      coin.Coin.encode(v, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetTotalPoolLiquidityQueryMsgResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.totalPoolLiquidity.push(coin.Coin.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$totalPoolLiqu;

    const message = createBaseGetTotalPoolLiquidityQueryMsgResponse();
    message.totalPoolLiquidity = ((_object$totalPoolLiqu = object.totalPoolLiquidity) === null || _object$totalPoolLiqu === void 0 ? void 0 : _object$totalPoolLiqu.map(e => coin.Coin.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      totalPoolLiquidity: Array.isArray(object === null || object === void 0 ? void 0 : object.total_pool_liquidity) ? object.total_pool_liquidity.map(e => coin.Coin.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.totalPoolLiquidity) {
      obj.total_pool_liquidity = message.totalPoolLiquidity.map(e => e ? coin.Coin.toAmino(e) : undefined);
    } else {
      obj.total_pool_liquidity = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return GetTotalPoolLiquidityQueryMsgResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/cosmwasmpool/get-total-pool-liquidity-query-msg-response",
      value: GetTotalPoolLiquidityQueryMsgResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return GetTotalPoolLiquidityQueryMsgResponse.decode(message.value);
  },

  toProto(message) {
    return GetTotalPoolLiquidityQueryMsgResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.cosmwasmpool.v1beta1.GetTotalPoolLiquidityQueryMsgResponse",
      value: GetTotalPoolLiquidityQueryMsgResponse.encode(message).finish()
    };
  }

};

function createBaseGetTotalSharesQueryMsg() {
  return {
    getTotalShares: undefined
  };
}

const GetTotalSharesQueryMsg = {
  typeUrl: "/osmosis.cosmwasmpool.v1beta1.GetTotalSharesQueryMsg",

  encode(message, writer = minimal.Writer.create()) {
    if (message.getTotalShares !== undefined) {
      EmptyStruct.encode(message.getTotalShares, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetTotalSharesQueryMsg();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.getTotalShares = EmptyStruct.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseGetTotalSharesQueryMsg();
    message.getTotalShares = object.getTotalShares !== undefined && object.getTotalShares !== null ? EmptyStruct.fromPartial(object.getTotalShares) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      getTotalShares: object !== null && object !== void 0 && object.get_total_shares ? EmptyStruct.fromAmino(object.get_total_shares) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.get_total_shares = message.getTotalShares ? EmptyStruct.toAmino(message.getTotalShares) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return GetTotalSharesQueryMsg.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/cosmwasmpool/get-total-shares-query-msg",
      value: GetTotalSharesQueryMsg.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return GetTotalSharesQueryMsg.decode(message.value);
  },

  toProto(message) {
    return GetTotalSharesQueryMsg.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.cosmwasmpool.v1beta1.GetTotalSharesQueryMsg",
      value: GetTotalSharesQueryMsg.encode(message).finish()
    };
  }

};

function createBaseGetTotalSharesQueryMsgResponse() {
  return {
    totalShares: ""
  };
}

const GetTotalSharesQueryMsgResponse = {
  typeUrl: "/osmosis.cosmwasmpool.v1beta1.GetTotalSharesQueryMsgResponse",

  encode(message, writer = minimal.Writer.create()) {
    if (message.totalShares !== "") {
      writer.uint32(10).string(message.totalShares);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetTotalSharesQueryMsgResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.totalShares = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$totalShares;

    const message = createBaseGetTotalSharesQueryMsgResponse();
    message.totalShares = (_object$totalShares = object.totalShares) !== null && _object$totalShares !== void 0 ? _object$totalShares : "";
    return message;
  },

  fromAmino(object) {
    return {
      totalShares: object.total_shares
    };
  },

  toAmino(message) {
    const obj = {};
    obj.total_shares = message.totalShares;
    return obj;
  },

  fromAminoMsg(object) {
    return GetTotalSharesQueryMsgResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/cosmwasmpool/get-total-shares-query-msg-response",
      value: GetTotalSharesQueryMsgResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return GetTotalSharesQueryMsgResponse.decode(message.value);
  },

  toProto(message) {
    return GetTotalSharesQueryMsgResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.cosmwasmpool.v1beta1.GetTotalSharesQueryMsgResponse",
      value: GetTotalSharesQueryMsgResponse.encode(message).finish()
    };
  }

};
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/osmosis/cosmwasmpool/v1beta1/model/pool.js
var pool = __webpack_require__(17186);
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/osmosis/cosmwasmpool/v1beta1/model/transmuter_msgs.js

/** ===================== JoinPoolExecuteMsg */

function createBaseEmptyRequest() {
  return {};
}

const EmptyRequest = {
  typeUrl: "/osmosis.cosmwasmpool.v1beta1.EmptyRequest",

  encode(_, writer = minimal.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEmptyRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseEmptyRequest();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return EmptyRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/cosmwasmpool/empty-request",
      value: EmptyRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return EmptyRequest.decode(message.value);
  },

  toProto(message) {
    return EmptyRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.cosmwasmpool.v1beta1.EmptyRequest",
      value: EmptyRequest.encode(message).finish()
    };
  }

};

function createBaseJoinPoolExecuteMsgRequest() {
  return {
    joinPool: undefined
  };
}

const JoinPoolExecuteMsgRequest = {
  typeUrl: "/osmosis.cosmwasmpool.v1beta1.JoinPoolExecuteMsgRequest",

  encode(message, writer = minimal.Writer.create()) {
    if (message.joinPool !== undefined) {
      EmptyRequest.encode(message.joinPool, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseJoinPoolExecuteMsgRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.joinPool = EmptyRequest.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseJoinPoolExecuteMsgRequest();
    message.joinPool = object.joinPool !== undefined && object.joinPool !== null ? EmptyRequest.fromPartial(object.joinPool) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      joinPool: object !== null && object !== void 0 && object.join_pool ? EmptyRequest.fromAmino(object.join_pool) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.join_pool = message.joinPool ? EmptyRequest.toAmino(message.joinPool) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return JoinPoolExecuteMsgRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/cosmwasmpool/join-pool-execute-msg-request",
      value: JoinPoolExecuteMsgRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return JoinPoolExecuteMsgRequest.decode(message.value);
  },

  toProto(message) {
    return JoinPoolExecuteMsgRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.cosmwasmpool.v1beta1.JoinPoolExecuteMsgRequest",
      value: JoinPoolExecuteMsgRequest.encode(message).finish()
    };
  }

};

function createBaseJoinPoolExecuteMsgResponse() {
  return {};
}

const JoinPoolExecuteMsgResponse = {
  typeUrl: "/osmosis.cosmwasmpool.v1beta1.JoinPoolExecuteMsgResponse",

  encode(_, writer = minimal.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseJoinPoolExecuteMsgResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseJoinPoolExecuteMsgResponse();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return JoinPoolExecuteMsgResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/cosmwasmpool/join-pool-execute-msg-response",
      value: JoinPoolExecuteMsgResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return JoinPoolExecuteMsgResponse.decode(message.value);
  },

  toProto(message) {
    return JoinPoolExecuteMsgResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.cosmwasmpool.v1beta1.JoinPoolExecuteMsgResponse",
      value: JoinPoolExecuteMsgResponse.encode(message).finish()
    };
  }

};

function createBaseExitPoolExecuteMsgRequest() {
  return {
    exitPool: undefined
  };
}

const ExitPoolExecuteMsgRequest = {
  typeUrl: "/osmosis.cosmwasmpool.v1beta1.ExitPoolExecuteMsgRequest",

  encode(message, writer = minimal.Writer.create()) {
    if (message.exitPool !== undefined) {
      EmptyRequest.encode(message.exitPool, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseExitPoolExecuteMsgRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.exitPool = EmptyRequest.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseExitPoolExecuteMsgRequest();
    message.exitPool = object.exitPool !== undefined && object.exitPool !== null ? EmptyRequest.fromPartial(object.exitPool) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      exitPool: object !== null && object !== void 0 && object.exit_pool ? EmptyRequest.fromAmino(object.exit_pool) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.exit_pool = message.exitPool ? EmptyRequest.toAmino(message.exitPool) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return ExitPoolExecuteMsgRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/cosmwasmpool/exit-pool-execute-msg-request",
      value: ExitPoolExecuteMsgRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return ExitPoolExecuteMsgRequest.decode(message.value);
  },

  toProto(message) {
    return ExitPoolExecuteMsgRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.cosmwasmpool.v1beta1.ExitPoolExecuteMsgRequest",
      value: ExitPoolExecuteMsgRequest.encode(message).finish()
    };
  }

};

function createBaseExitPoolExecuteMsgResponse() {
  return {};
}

const ExitPoolExecuteMsgResponse = {
  typeUrl: "/osmosis.cosmwasmpool.v1beta1.ExitPoolExecuteMsgResponse",

  encode(_, writer = minimal.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseExitPoolExecuteMsgResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseExitPoolExecuteMsgResponse();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return ExitPoolExecuteMsgResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/cosmwasmpool/exit-pool-execute-msg-response",
      value: ExitPoolExecuteMsgResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return ExitPoolExecuteMsgResponse.decode(message.value);
  },

  toProto(message) {
    return ExitPoolExecuteMsgResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.cosmwasmpool.v1beta1.ExitPoolExecuteMsgResponse",
      value: ExitPoolExecuteMsgResponse.encode(message).finish()
    };
  }

};
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/osmosis/cosmwasmpool/v1beta1/model/tx.js


/** ===================== MsgCreateCosmwasmPool */

function createBaseMsgCreateCosmWasmPool() {
  return {
    codeId: helpers/* Long.UZERO */.dK.UZERO,
    instantiateMsg: new Uint8Array(),
    sender: ""
  };
}

const MsgCreateCosmWasmPool = {
  typeUrl: "/osmosis.cosmwasmpool.v1beta1.MsgCreateCosmWasmPool",

  encode(message, writer = minimal.Writer.create()) {
    if (!message.codeId.isZero()) {
      writer.uint32(8).uint64(message.codeId);
    }

    if (message.instantiateMsg.length !== 0) {
      writer.uint32(18).bytes(message.instantiateMsg);
    }

    if (message.sender !== "") {
      writer.uint32(26).string(message.sender);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgCreateCosmWasmPool();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.codeId = reader.uint64();
          break;

        case 2:
          message.instantiateMsg = reader.bytes();
          break;

        case 3:
          message.sender = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$instantiateMs, _object$sender;

    const message = createBaseMsgCreateCosmWasmPool();
    message.codeId = object.codeId !== undefined && object.codeId !== null ? helpers/* Long.fromValue */.dK.fromValue(object.codeId) : helpers/* Long.UZERO */.dK.UZERO;
    message.instantiateMsg = (_object$instantiateMs = object.instantiateMsg) !== null && _object$instantiateMs !== void 0 ? _object$instantiateMs : new Uint8Array();
    message.sender = (_object$sender = object.sender) !== null && _object$sender !== void 0 ? _object$sender : "";
    return message;
  },

  fromAmino(object) {
    return {
      codeId: helpers/* Long.fromString */.dK.fromString(object.code_id),
      instantiateMsg: object.instantiate_msg,
      sender: object.sender
    };
  },

  toAmino(message) {
    const obj = {};
    obj.code_id = message.codeId ? message.codeId.toString() : undefined;
    obj.instantiate_msg = message.instantiateMsg;
    obj.sender = message.sender;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgCreateCosmWasmPool.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/cosmwasmpool/create-cosm-wasm-pool",
      value: MsgCreateCosmWasmPool.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgCreateCosmWasmPool.decode(message.value);
  },

  toProto(message) {
    return MsgCreateCosmWasmPool.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.cosmwasmpool.v1beta1.MsgCreateCosmWasmPool",
      value: MsgCreateCosmWasmPool.encode(message).finish()
    };
  }

};

function createBaseMsgCreateCosmWasmPoolResponse() {
  return {
    poolId: helpers/* Long.UZERO */.dK.UZERO
  };
}

const MsgCreateCosmWasmPoolResponse = {
  typeUrl: "/osmosis.cosmwasmpool.v1beta1.MsgCreateCosmWasmPoolResponse",

  encode(message, writer = minimal.Writer.create()) {
    if (!message.poolId.isZero()) {
      writer.uint32(8).uint64(message.poolId);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgCreateCosmWasmPoolResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.poolId = reader.uint64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseMsgCreateCosmWasmPoolResponse();
    message.poolId = object.poolId !== undefined && object.poolId !== null ? helpers/* Long.fromValue */.dK.fromValue(object.poolId) : helpers/* Long.UZERO */.dK.UZERO;
    return message;
  },

  fromAmino(object) {
    return {
      poolId: helpers/* Long.fromString */.dK.fromString(object.pool_id)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.pool_id = message.poolId ? message.poolId.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgCreateCosmWasmPoolResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/cosmwasmpool/create-cosm-wasm-pool-response",
      value: MsgCreateCosmWasmPoolResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgCreateCosmWasmPoolResponse.decode(message.value);
  },

  toProto(message) {
    return MsgCreateCosmWasmPoolResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.cosmwasmpool.v1beta1.MsgCreateCosmWasmPoolResponse",
      value: MsgCreateCosmWasmPoolResponse.encode(message).finish()
    };
  }

};
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/osmosis/cosmwasmpool/v1beta1/query.js
var cosmwasmpool_v1beta1_query = __webpack_require__(40000);
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/osmosis/cosmwasmpool/v1beta1/tx.js

// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/osmosis/downtime-detector/v1beta1/downtime_duration.js
var downtime_duration = __webpack_require__(44525);
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/osmosis/downtime-detector/v1beta1/genesis.js





function createBaseGenesisDowntimeEntry() {
  return {
    duration: 0,
    lastDowntime: undefined
  };
}

const GenesisDowntimeEntry = {
  typeUrl: "/osmosis.downtimedetector.v1beta1.GenesisDowntimeEntry",

  encode(message, writer = minimal.Writer.create()) {
    if (message.duration !== 0) {
      writer.uint32(8).int32(message.duration);
    }

    if (message.lastDowntime !== undefined) {
      timestamp.Timestamp.encode((0,helpers/* toTimestamp */.Uq)(message.lastDowntime), writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGenesisDowntimeEntry();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.duration = reader.int32();
          break;

        case 2:
          message.lastDowntime = (0,helpers/* fromTimestamp */.Ol)(timestamp.Timestamp.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$duration, _object$lastDowntime;

    const message = createBaseGenesisDowntimeEntry();
    message.duration = (_object$duration = object.duration) !== null && _object$duration !== void 0 ? _object$duration : 0;
    message.lastDowntime = (_object$lastDowntime = object.lastDowntime) !== null && _object$lastDowntime !== void 0 ? _object$lastDowntime : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      duration: (0,helpers/* isSet */.DM)(object.duration) ? (0,downtime_duration.downtimeFromJSON)(object.duration) : 0,
      lastDowntime: object !== null && object !== void 0 && object.last_downtime ? timestamp.Timestamp.fromAmino(object.last_downtime) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.duration = message.duration;
    obj.last_downtime = message.lastDowntime ? timestamp.Timestamp.toAmino(message.lastDowntime) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return GenesisDowntimeEntry.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/downtimedetector/genesis-downtime-entry",
      value: GenesisDowntimeEntry.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return GenesisDowntimeEntry.decode(message.value);
  },

  toProto(message) {
    return GenesisDowntimeEntry.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.downtimedetector.v1beta1.GenesisDowntimeEntry",
      value: GenesisDowntimeEntry.encode(message).finish()
    };
  }

};

function downtime_detector_v1beta1_genesis_createBaseGenesisState() {
  return {
    downtimes: [],
    lastBlockTime: undefined
  };
}

const downtime_detector_v1beta1_genesis_GenesisState = {
  typeUrl: "/osmosis.downtimedetector.v1beta1.GenesisState",

  encode(message, writer = minimal.Writer.create()) {
    for (const v of message.downtimes) {
      GenesisDowntimeEntry.encode(v, writer.uint32(10).fork()).ldelim();
    }

    if (message.lastBlockTime !== undefined) {
      timestamp.Timestamp.encode((0,helpers/* toTimestamp */.Uq)(message.lastBlockTime), writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = downtime_detector_v1beta1_genesis_createBaseGenesisState();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.downtimes.push(GenesisDowntimeEntry.decode(reader, reader.uint32()));
          break;

        case 2:
          message.lastBlockTime = (0,helpers/* fromTimestamp */.Ol)(timestamp.Timestamp.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$downtimes, _object$lastBlockTime;

    const message = downtime_detector_v1beta1_genesis_createBaseGenesisState();
    message.downtimes = ((_object$downtimes = object.downtimes) === null || _object$downtimes === void 0 ? void 0 : _object$downtimes.map(e => GenesisDowntimeEntry.fromPartial(e))) || [];
    message.lastBlockTime = (_object$lastBlockTime = object.lastBlockTime) !== null && _object$lastBlockTime !== void 0 ? _object$lastBlockTime : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      downtimes: Array.isArray(object === null || object === void 0 ? void 0 : object.downtimes) ? object.downtimes.map(e => GenesisDowntimeEntry.fromAmino(e)) : [],
      lastBlockTime: object !== null && object !== void 0 && object.last_block_time ? timestamp.Timestamp.fromAmino(object.last_block_time) : undefined
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.downtimes) {
      obj.downtimes = message.downtimes.map(e => e ? GenesisDowntimeEntry.toAmino(e) : undefined);
    } else {
      obj.downtimes = [];
    }

    obj.last_block_time = message.lastBlockTime ? timestamp.Timestamp.toAmino(message.lastBlockTime) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return downtime_detector_v1beta1_genesis_GenesisState.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/downtimedetector/genesis-state",
      value: downtime_detector_v1beta1_genesis_GenesisState.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return downtime_detector_v1beta1_genesis_GenesisState.decode(message.value);
  },

  toProto(message) {
    return downtime_detector_v1beta1_genesis_GenesisState.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.downtimedetector.v1beta1.GenesisState",
      value: downtime_detector_v1beta1_genesis_GenesisState.encode(message).finish()
    };
  }

};
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/osmosis/downtime-detector/v1beta1/query.js
var downtime_detector_v1beta1_query = __webpack_require__(30623);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/osmosis/epochs/genesis.js
var epochs_genesis = __webpack_require__(54871);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/osmosis/epochs/query.js
var epochs_query = __webpack_require__(19775);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/osmosis/gamm/pool-models/balancer/balancerPool.js
var balancerPool = __webpack_require__(4075);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/osmosis/concentrated-liquidity/pool.js
var concentrated_liquidity_pool = __webpack_require__(4343);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/osmosis/gamm/pool-models/stableswap/stableswap_pool.js
var stableswap_pool = __webpack_require__(66761);
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/osmosis/gamm/v1beta1/genesis.js








/** Params holds parameters for the incentives module */

function createBaseParams() {
  return {
    poolCreationFee: []
  };
}

const Params = {
  typeUrl: "/osmosis.gamm.v1beta1.Params",

  encode(message, writer = minimal.Writer.create()) {
    for (const v of message.poolCreationFee) {
      coin.Coin.encode(v, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseParams();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.poolCreationFee.push(coin.Coin.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$poolCreationF;

    const message = createBaseParams();
    message.poolCreationFee = ((_object$poolCreationF = object.poolCreationFee) === null || _object$poolCreationF === void 0 ? void 0 : _object$poolCreationF.map(e => coin.Coin.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      poolCreationFee: Array.isArray(object === null || object === void 0 ? void 0 : object.pool_creation_fee) ? object.pool_creation_fee.map(e => coin.Coin.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.poolCreationFee) {
      obj.pool_creation_fee = message.poolCreationFee.map(e => e ? coin.Coin.toAmino(e) : undefined);
    } else {
      obj.pool_creation_fee = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return Params.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/gamm/params",
      value: Params.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return Params.decode(message.value);
  },

  toProto(message) {
    return Params.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.Params",
      value: Params.encode(message).finish()
    };
  }

};

function gamm_v1beta1_genesis_createBaseGenesisState() {
  return {
    pools: [],
    nextPoolNumber: helpers/* Long.UZERO */.dK.UZERO,
    params: undefined,
    migrationRecords: undefined
  };
}

const gamm_v1beta1_genesis_GenesisState = {
  typeUrl: "/osmosis.gamm.v1beta1.GenesisState",

  encode(message, writer = minimal.Writer.create()) {
    for (const v of message.pools) {
      any.Any.encode(v, writer.uint32(10).fork()).ldelim();
    }

    if (!message.nextPoolNumber.isZero()) {
      writer.uint32(16).uint64(message.nextPoolNumber);
    }

    if (message.params !== undefined) {
      Params.encode(message.params, writer.uint32(26).fork()).ldelim();
    }

    if (message.migrationRecords !== undefined) {
      MigrationRecords.encode(message.migrationRecords, writer.uint32(34).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = gamm_v1beta1_genesis_createBaseGenesisState();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.pools.push(PoolI_InterfaceDecoder(reader));
          break;

        case 2:
          message.nextPoolNumber = reader.uint64();
          break;

        case 3:
          message.params = Params.decode(reader, reader.uint32());
          break;

        case 4:
          message.migrationRecords = MigrationRecords.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$pools;

    const message = gamm_v1beta1_genesis_createBaseGenesisState();
    message.pools = ((_object$pools = object.pools) === null || _object$pools === void 0 ? void 0 : _object$pools.map(e => any.Any.fromPartial(e))) || [];
    message.nextPoolNumber = object.nextPoolNumber !== undefined && object.nextPoolNumber !== null ? helpers/* Long.fromValue */.dK.fromValue(object.nextPoolNumber) : helpers/* Long.UZERO */.dK.UZERO;
    message.params = object.params !== undefined && object.params !== null ? Params.fromPartial(object.params) : undefined;
    message.migrationRecords = object.migrationRecords !== undefined && object.migrationRecords !== null ? MigrationRecords.fromPartial(object.migrationRecords) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      pools: Array.isArray(object === null || object === void 0 ? void 0 : object.pools) ? object.pools.map(e => PoolI_FromAmino(e)) : [],
      nextPoolNumber: helpers/* Long.fromString */.dK.fromString(object.next_pool_number),
      params: object !== null && object !== void 0 && object.params ? Params.fromAmino(object.params) : undefined,
      migrationRecords: object !== null && object !== void 0 && object.migration_records ? MigrationRecords.fromAmino(object.migration_records) : undefined
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.pools) {
      obj.pools = message.pools.map(e => e ? PoolI_ToAmino(e) : undefined);
    } else {
      obj.pools = [];
    }

    obj.next_pool_number = message.nextPoolNumber ? message.nextPoolNumber.toString() : undefined;
    obj.params = message.params ? Params.toAmino(message.params) : undefined;
    obj.migration_records = message.migrationRecords ? MigrationRecords.toAmino(message.migrationRecords) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return gamm_v1beta1_genesis_GenesisState.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/gamm/genesis-state",
      value: gamm_v1beta1_genesis_GenesisState.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return gamm_v1beta1_genesis_GenesisState.decode(message.value);
  },

  toProto(message) {
    return gamm_v1beta1_genesis_GenesisState.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.GenesisState",
      value: gamm_v1beta1_genesis_GenesisState.encode(message).finish()
    };
  }

};

function createBaseMigrationRecords() {
  return {
    balancerToConcentratedPoolLinks: []
  };
}

const MigrationRecords = {
  typeUrl: "/osmosis.gamm.v1beta1.MigrationRecords",

  encode(message, writer = minimal.Writer.create()) {
    for (const v of message.balancerToConcentratedPoolLinks) {
      BalancerToConcentratedPoolLink.encode(v, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMigrationRecords();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.balancerToConcentratedPoolLinks.push(BalancerToConcentratedPoolLink.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$balancerToCon;

    const message = createBaseMigrationRecords();
    message.balancerToConcentratedPoolLinks = ((_object$balancerToCon = object.balancerToConcentratedPoolLinks) === null || _object$balancerToCon === void 0 ? void 0 : _object$balancerToCon.map(e => BalancerToConcentratedPoolLink.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      balancerToConcentratedPoolLinks: Array.isArray(object === null || object === void 0 ? void 0 : object.balancer_to_concentrated_pool_links) ? object.balancer_to_concentrated_pool_links.map(e => BalancerToConcentratedPoolLink.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.balancerToConcentratedPoolLinks) {
      obj.balancer_to_concentrated_pool_links = message.balancerToConcentratedPoolLinks.map(e => e ? BalancerToConcentratedPoolLink.toAmino(e) : undefined);
    } else {
      obj.balancer_to_concentrated_pool_links = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return MigrationRecords.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/gamm/migration-records",
      value: MigrationRecords.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MigrationRecords.decode(message.value);
  },

  toProto(message) {
    return MigrationRecords.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.MigrationRecords",
      value: MigrationRecords.encode(message).finish()
    };
  }

};

function createBaseBalancerToConcentratedPoolLink() {
  return {
    balancerPoolId: helpers/* Long.UZERO */.dK.UZERO,
    clPoolId: helpers/* Long.UZERO */.dK.UZERO
  };
}

const BalancerToConcentratedPoolLink = {
  typeUrl: "/osmosis.gamm.v1beta1.BalancerToConcentratedPoolLink",

  encode(message, writer = minimal.Writer.create()) {
    if (!message.balancerPoolId.isZero()) {
      writer.uint32(8).uint64(message.balancerPoolId);
    }

    if (!message.clPoolId.isZero()) {
      writer.uint32(16).uint64(message.clPoolId);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBalancerToConcentratedPoolLink();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.balancerPoolId = reader.uint64();
          break;

        case 2:
          message.clPoolId = reader.uint64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseBalancerToConcentratedPoolLink();
    message.balancerPoolId = object.balancerPoolId !== undefined && object.balancerPoolId !== null ? helpers/* Long.fromValue */.dK.fromValue(object.balancerPoolId) : helpers/* Long.UZERO */.dK.UZERO;
    message.clPoolId = object.clPoolId !== undefined && object.clPoolId !== null ? helpers/* Long.fromValue */.dK.fromValue(object.clPoolId) : helpers/* Long.UZERO */.dK.UZERO;
    return message;
  },

  fromAmino(object) {
    return {
      balancerPoolId: helpers/* Long.fromString */.dK.fromString(object.balancer_pool_id),
      clPoolId: helpers/* Long.fromString */.dK.fromString(object.cl_pool_id)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.balancer_pool_id = message.balancerPoolId ? message.balancerPoolId.toString() : undefined;
    obj.cl_pool_id = message.clPoolId ? message.clPoolId.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return BalancerToConcentratedPoolLink.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/gamm/balancer-to-concentrated-pool-link",
      value: BalancerToConcentratedPoolLink.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return BalancerToConcentratedPoolLink.decode(message.value);
  },

  toProto(message) {
    return BalancerToConcentratedPoolLink.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.BalancerToConcentratedPoolLink",
      value: BalancerToConcentratedPoolLink.encode(message).finish()
    };
  }

};
const PoolI_InterfaceDecoder = input => {
  const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
  const data = any.Any.decode(reader, reader.uint32());

  switch (data.typeUrl) {
    case "/osmosis.concentratedliquidity.v1beta1.Pool":
      return concentrated_liquidity_pool/* Pool.decode */.K.decode(data.value);

    case "/osmosis.cosmwasmpool.v1beta1.CosmWasmPool":
      return pool.CosmWasmPool.decode(data.value);

    case "/osmosis.gamm.v1beta1.Pool":
      return balancerPool.Pool.decode(data.value);

    case "/osmosis.gamm.poolmodels.stableswap.v1beta1.Pool":
      return stableswap_pool.Pool.decode(data.value);

    default:
      return data;
  }
};
const PoolI_FromAmino = content => {
  switch (content.type) {
    case "osmosis/concentratedliquidity/pool":
      return any.Any.fromPartial({
        typeUrl: "/osmosis.concentratedliquidity.v1beta1.Pool",
        value: concentrated_liquidity_pool/* Pool.encode */.K.encode(concentrated_liquidity_pool/* Pool.fromPartial */.K.fromPartial(concentrated_liquidity_pool/* Pool.fromAmino */.K.fromAmino(content.value))).finish()
      });

    case "osmosis/cosmwasmpool/cosm-wasm-pool":
      return any.Any.fromPartial({
        typeUrl: "/osmosis.cosmwasmpool.v1beta1.CosmWasmPool",
        value: pool.CosmWasmPool.encode(pool.CosmWasmPool.fromPartial(pool.CosmWasmPool.fromAmino(content.value))).finish()
      });

    case "osmosis/gamm/BalancerPool":
      return any.Any.fromPartial({
        typeUrl: "/osmosis.gamm.v1beta1.Pool",
        value: balancerPool.Pool.encode(balancerPool.Pool.fromPartial(balancerPool.Pool.fromAmino(content.value))).finish()
      });

    case "osmosis/gamm/StableswapPool":
      return any.Any.fromPartial({
        typeUrl: "/osmosis.gamm.poolmodels.stableswap.v1beta1.Pool",
        value: stableswap_pool.Pool.encode(stableswap_pool.Pool.fromPartial(stableswap_pool.Pool.fromAmino(content.value))).finish()
      });

    default:
      return any.Any.fromAmino(content);
  }
};
const PoolI_ToAmino = content => {
  switch (content.typeUrl) {
    case "/osmosis.concentratedliquidity.v1beta1.Pool":
      return {
        type: "osmosis/concentratedliquidity/pool",
        value: concentrated_liquidity_pool/* Pool.toAmino */.K.toAmino(concentrated_liquidity_pool/* Pool.decode */.K.decode(content.value))
      };

    case "/osmosis.cosmwasmpool.v1beta1.CosmWasmPool":
      return {
        type: "osmosis/cosmwasmpool/cosm-wasm-pool",
        value: pool.CosmWasmPool.toAmino(pool.CosmWasmPool.decode(content.value))
      };

    case "/osmosis.gamm.v1beta1.Pool":
      return {
        type: "osmosis/gamm/BalancerPool",
        value: balancerPool.Pool.toAmino(balancerPool.Pool.decode(content.value))
      };

    case "/osmosis.gamm.poolmodels.stableswap.v1beta1.Pool":
      return {
        type: "osmosis/gamm/StableswapPool",
        value: stableswap_pool.Pool.toAmino(stableswap_pool.Pool.decode(content.value))
      };

    default:
      return any.Any.toAmino(content);
  }
};
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/osmosis/gamm/v1beta1/gov.js


/**
 * ReplaceMigrationRecordsProposal is a gov Content type for updating the
 * migration records. If a ReplaceMigrationRecordsProposal passes, the
 * proposal’s records override the existing MigrationRecords set in the module.
 * Each record specifies a single connection between a single balancer pool and
 * a single concentrated pool.
 */

function createBaseReplaceMigrationRecordsProposal() {
  return {
    $typeUrl: "/osmosis.gamm.v1beta1.ReplaceMigrationRecordsProposal",
    title: "",
    description: "",
    records: []
  };
}

const ReplaceMigrationRecordsProposal = {
  typeUrl: "/osmosis.gamm.v1beta1.ReplaceMigrationRecordsProposal",

  encode(message, writer = minimal.Writer.create()) {
    if (message.title !== "") {
      writer.uint32(10).string(message.title);
    }

    if (message.description !== "") {
      writer.uint32(18).string(message.description);
    }

    for (const v of message.records) {
      BalancerToConcentratedPoolLink.encode(v, writer.uint32(26).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseReplaceMigrationRecordsProposal();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.title = reader.string();
          break;

        case 2:
          message.description = reader.string();
          break;

        case 3:
          message.records.push(BalancerToConcentratedPoolLink.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$title, _object$description, _object$records;

    const message = createBaseReplaceMigrationRecordsProposal();
    message.title = (_object$title = object.title) !== null && _object$title !== void 0 ? _object$title : "";
    message.description = (_object$description = object.description) !== null && _object$description !== void 0 ? _object$description : "";
    message.records = ((_object$records = object.records) === null || _object$records === void 0 ? void 0 : _object$records.map(e => BalancerToConcentratedPoolLink.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      title: object.title,
      description: object.description,
      records: Array.isArray(object === null || object === void 0 ? void 0 : object.records) ? object.records.map(e => BalancerToConcentratedPoolLink.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.title = message.title;
    obj.description = message.description;

    if (message.records) {
      obj.records = message.records.map(e => e ? BalancerToConcentratedPoolLink.toAmino(e) : undefined);
    } else {
      obj.records = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return ReplaceMigrationRecordsProposal.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/ReplaceMigrationRecordsProposal",
      value: ReplaceMigrationRecordsProposal.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return ReplaceMigrationRecordsProposal.decode(message.value);
  },

  toProto(message) {
    return ReplaceMigrationRecordsProposal.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.ReplaceMigrationRecordsProposal",
      value: ReplaceMigrationRecordsProposal.encode(message).finish()
    };
  }

};

function createBaseUpdateMigrationRecordsProposal() {
  return {
    $typeUrl: "/osmosis.gamm.v1beta1.UpdateMigrationRecordsProposal",
    title: "",
    description: "",
    records: []
  };
}

const UpdateMigrationRecordsProposal = {
  typeUrl: "/osmosis.gamm.v1beta1.UpdateMigrationRecordsProposal",

  encode(message, writer = minimal.Writer.create()) {
    if (message.title !== "") {
      writer.uint32(10).string(message.title);
    }

    if (message.description !== "") {
      writer.uint32(18).string(message.description);
    }

    for (const v of message.records) {
      BalancerToConcentratedPoolLink.encode(v, writer.uint32(26).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateMigrationRecordsProposal();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.title = reader.string();
          break;

        case 2:
          message.description = reader.string();
          break;

        case 3:
          message.records.push(BalancerToConcentratedPoolLink.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$title2, _object$description2, _object$records2;

    const message = createBaseUpdateMigrationRecordsProposal();
    message.title = (_object$title2 = object.title) !== null && _object$title2 !== void 0 ? _object$title2 : "";
    message.description = (_object$description2 = object.description) !== null && _object$description2 !== void 0 ? _object$description2 : "";
    message.records = ((_object$records2 = object.records) === null || _object$records2 === void 0 ? void 0 : _object$records2.map(e => BalancerToConcentratedPoolLink.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      title: object.title,
      description: object.description,
      records: Array.isArray(object === null || object === void 0 ? void 0 : object.records) ? object.records.map(e => BalancerToConcentratedPoolLink.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.title = message.title;
    obj.description = message.description;

    if (message.records) {
      obj.records = message.records.map(e => e ? BalancerToConcentratedPoolLink.toAmino(e) : undefined);
    } else {
      obj.records = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return UpdateMigrationRecordsProposal.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/UpdateMigrationRecordsProposal",
      value: UpdateMigrationRecordsProposal.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return UpdateMigrationRecordsProposal.decode(message.value);
  },

  toProto(message) {
    return UpdateMigrationRecordsProposal.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.gamm.v1beta1.UpdateMigrationRecordsProposal",
      value: UpdateMigrationRecordsProposal.encode(message).finish()
    };
  }

};
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/osmosis/gamm/v1beta1/query.js
var gamm_v1beta1_query = __webpack_require__(1126);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/osmosis/gamm/v1beta1/tx.js
var gamm_v1beta1_tx = __webpack_require__(86537);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/osmosis/gamm/pool-models/balancer/tx/tx.js
var tx_tx = __webpack_require__(48858);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/osmosis/gamm/pool-models/stableswap/tx.js
var stableswap_tx = __webpack_require__(9195);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/osmosis/gamm/v2/query.js
var v2_query = __webpack_require__(80643);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/osmosis/ibc-rate-limit/v1beta1/params.js
var ibc_rate_limit_v1beta1_params = __webpack_require__(78369);
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/osmosis/ibc-rate-limit/v1beta1/genesis.js


/** GenesisState defines the ibc-rate-limit module's genesis state. */

function ibc_rate_limit_v1beta1_genesis_createBaseGenesisState() {
  return {
    params: undefined
  };
}

const ibc_rate_limit_v1beta1_genesis_GenesisState = {
  typeUrl: "/osmosis.ibcratelimit.v1beta1.GenesisState",

  encode(message, writer = minimal.Writer.create()) {
    if (message.params !== undefined) {
      ibc_rate_limit_v1beta1_params.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = ibc_rate_limit_v1beta1_genesis_createBaseGenesisState();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.params = ibc_rate_limit_v1beta1_params.Params.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = ibc_rate_limit_v1beta1_genesis_createBaseGenesisState();
    message.params = object.params !== undefined && object.params !== null ? ibc_rate_limit_v1beta1_params.Params.fromPartial(object.params) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      params: object !== null && object !== void 0 && object.params ? ibc_rate_limit_v1beta1_params.Params.fromAmino(object.params) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.params = message.params ? ibc_rate_limit_v1beta1_params.Params.toAmino(message.params) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return ibc_rate_limit_v1beta1_genesis_GenesisState.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/ibcratelimit/genesis-state",
      value: ibc_rate_limit_v1beta1_genesis_GenesisState.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return ibc_rate_limit_v1beta1_genesis_GenesisState.decode(message.value);
  },

  toProto(message) {
    return ibc_rate_limit_v1beta1_genesis_GenesisState.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.ibcratelimit.v1beta1.GenesisState",
      value: ibc_rate_limit_v1beta1_genesis_GenesisState.encode(message).finish()
    };
  }

};
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/osmosis/ibc-rate-limit/v1beta1/query.js
var ibc_rate_limit_v1beta1_query = __webpack_require__(52885);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/osmosis/incentives/gauge.js
var gauge = __webpack_require__(61927);
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/osmosis/incentives/params.js

/** Params holds parameters for the incentives module */

function params_createBaseParams() {
  return {
    distrEpochIdentifier: ""
  };
}

const params_Params = {
  typeUrl: "/osmosis.incentives.Params",

  encode(message, writer = minimal.Writer.create()) {
    if (message.distrEpochIdentifier !== "") {
      writer.uint32(10).string(message.distrEpochIdentifier);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = params_createBaseParams();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.distrEpochIdentifier = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$distrEpochIde;

    const message = params_createBaseParams();
    message.distrEpochIdentifier = (_object$distrEpochIde = object.distrEpochIdentifier) !== null && _object$distrEpochIde !== void 0 ? _object$distrEpochIde : "";
    return message;
  },

  fromAmino(object) {
    return {
      distrEpochIdentifier: object.distr_epoch_identifier
    };
  },

  toAmino(message) {
    const obj = {};
    obj.distr_epoch_identifier = message.distrEpochIdentifier;
    return obj;
  },

  fromAminoMsg(object) {
    return params_Params.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/incentives/params",
      value: params_Params.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return params_Params.decode(message.value);
  },

  toProto(message) {
    return params_Params.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.incentives.Params",
      value: params_Params.encode(message).finish()
    };
  }

};
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/osmosis/incentives/genesis.js





/**
 * GenesisState defines the incentives module's various parameters when first
 * initialized
 */

function incentives_genesis_createBaseGenesisState() {
  return {
    params: undefined,
    gauges: [],
    lockableDurations: [],
    lastGaugeId: helpers/* Long.UZERO */.dK.UZERO
  };
}

const incentives_genesis_GenesisState = {
  typeUrl: "/osmosis.incentives.GenesisState",

  encode(message, writer = minimal.Writer.create()) {
    if (message.params !== undefined) {
      params_Params.encode(message.params, writer.uint32(10).fork()).ldelim();
    }

    for (const v of message.gauges) {
      gauge.Gauge.encode(v, writer.uint32(18).fork()).ldelim();
    }

    for (const v of message.lockableDurations) {
      duration.Duration.encode(v, writer.uint32(26).fork()).ldelim();
    }

    if (!message.lastGaugeId.isZero()) {
      writer.uint32(32).uint64(message.lastGaugeId);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = incentives_genesis_createBaseGenesisState();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.params = params_Params.decode(reader, reader.uint32());
          break;

        case 2:
          message.gauges.push(gauge.Gauge.decode(reader, reader.uint32()));
          break;

        case 3:
          message.lockableDurations.push(duration.Duration.decode(reader, reader.uint32()));
          break;

        case 4:
          message.lastGaugeId = reader.uint64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$gauges, _object$lockableDurat;

    const message = incentives_genesis_createBaseGenesisState();
    message.params = object.params !== undefined && object.params !== null ? params_Params.fromPartial(object.params) : undefined;
    message.gauges = ((_object$gauges = object.gauges) === null || _object$gauges === void 0 ? void 0 : _object$gauges.map(e => gauge.Gauge.fromPartial(e))) || [];
    message.lockableDurations = ((_object$lockableDurat = object.lockableDurations) === null || _object$lockableDurat === void 0 ? void 0 : _object$lockableDurat.map(e => duration.Duration.fromPartial(e))) || [];
    message.lastGaugeId = object.lastGaugeId !== undefined && object.lastGaugeId !== null ? helpers/* Long.fromValue */.dK.fromValue(object.lastGaugeId) : helpers/* Long.UZERO */.dK.UZERO;
    return message;
  },

  fromAmino(object) {
    return {
      params: object !== null && object !== void 0 && object.params ? params_Params.fromAmino(object.params) : undefined,
      gauges: Array.isArray(object === null || object === void 0 ? void 0 : object.gauges) ? object.gauges.map(e => gauge.Gauge.fromAmino(e)) : [],
      lockableDurations: Array.isArray(object === null || object === void 0 ? void 0 : object.lockable_durations) ? object.lockable_durations.map(e => duration.Duration.fromAmino(e)) : [],
      lastGaugeId: helpers/* Long.fromString */.dK.fromString(object.last_gauge_id)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.params = message.params ? params_Params.toAmino(message.params) : undefined;

    if (message.gauges) {
      obj.gauges = message.gauges.map(e => e ? gauge.Gauge.toAmino(e) : undefined);
    } else {
      obj.gauges = [];
    }

    if (message.lockableDurations) {
      obj.lockable_durations = message.lockableDurations.map(e => e ? duration.Duration.toAmino(e) : undefined);
    } else {
      obj.lockable_durations = [];
    }

    obj.last_gauge_id = message.lastGaugeId ? message.lastGaugeId.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return incentives_genesis_GenesisState.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/incentives/genesis-state",
      value: incentives_genesis_GenesisState.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return incentives_genesis_GenesisState.decode(message.value);
  },

  toProto(message) {
    return incentives_genesis_GenesisState.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.incentives.GenesisState",
      value: incentives_genesis_GenesisState.encode(message).finish()
    };
  }

};
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/osmosis/incentives/query.js
var incentives_query = __webpack_require__(89221);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/osmosis/incentives/tx.js
var incentives_tx = __webpack_require__(13265);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/osmosis/lockup/lock.js
var lock = __webpack_require__(24902);
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/osmosis/lockup/genesis.js



/** GenesisState defines the lockup module's genesis state. */

function lockup_genesis_createBaseGenesisState() {
  return {
    lastLockId: helpers/* Long.UZERO */.dK.UZERO,
    locks: [],
    syntheticLocks: []
  };
}

const lockup_genesis_GenesisState = {
  typeUrl: "/osmosis.lockup.GenesisState",

  encode(message, writer = minimal.Writer.create()) {
    if (!message.lastLockId.isZero()) {
      writer.uint32(8).uint64(message.lastLockId);
    }

    for (const v of message.locks) {
      lock.PeriodLock.encode(v, writer.uint32(18).fork()).ldelim();
    }

    for (const v of message.syntheticLocks) {
      lock.SyntheticLock.encode(v, writer.uint32(26).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = lockup_genesis_createBaseGenesisState();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.lastLockId = reader.uint64();
          break;

        case 2:
          message.locks.push(lock.PeriodLock.decode(reader, reader.uint32()));
          break;

        case 3:
          message.syntheticLocks.push(lock.SyntheticLock.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$locks, _object$syntheticLock;

    const message = lockup_genesis_createBaseGenesisState();
    message.lastLockId = object.lastLockId !== undefined && object.lastLockId !== null ? helpers/* Long.fromValue */.dK.fromValue(object.lastLockId) : helpers/* Long.UZERO */.dK.UZERO;
    message.locks = ((_object$locks = object.locks) === null || _object$locks === void 0 ? void 0 : _object$locks.map(e => lock.PeriodLock.fromPartial(e))) || [];
    message.syntheticLocks = ((_object$syntheticLock = object.syntheticLocks) === null || _object$syntheticLock === void 0 ? void 0 : _object$syntheticLock.map(e => lock.SyntheticLock.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      lastLockId: helpers/* Long.fromString */.dK.fromString(object.last_lock_id),
      locks: Array.isArray(object === null || object === void 0 ? void 0 : object.locks) ? object.locks.map(e => lock.PeriodLock.fromAmino(e)) : [],
      syntheticLocks: Array.isArray(object === null || object === void 0 ? void 0 : object.synthetic_locks) ? object.synthetic_locks.map(e => lock.SyntheticLock.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.last_lock_id = message.lastLockId ? message.lastLockId.toString() : undefined;

    if (message.locks) {
      obj.locks = message.locks.map(e => e ? lock.PeriodLock.toAmino(e) : undefined);
    } else {
      obj.locks = [];
    }

    if (message.syntheticLocks) {
      obj.synthetic_locks = message.syntheticLocks.map(e => e ? lock.SyntheticLock.toAmino(e) : undefined);
    } else {
      obj.synthetic_locks = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return lockup_genesis_GenesisState.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/lockup/genesis-state",
      value: lockup_genesis_GenesisState.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return lockup_genesis_GenesisState.decode(message.value);
  },

  toProto(message) {
    return lockup_genesis_GenesisState.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.lockup.GenesisState",
      value: lockup_genesis_GenesisState.encode(message).finish()
    };
  }

};
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/osmosis/lockup/params.js
var lockup_params = __webpack_require__(13381);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/osmosis/lockup/query.js
var lockup_query = __webpack_require__(10792);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/osmosis/lockup/tx.js
var lockup_tx = __webpack_require__(63784);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/osmosis/mint/v1beta1/mint.js
var v1beta1_mint = __webpack_require__(57200);
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/osmosis/mint/v1beta1/genesis.js



/** GenesisState defines the mint module's genesis state. */

function mint_v1beta1_genesis_createBaseGenesisState() {
  return {
    minter: undefined,
    params: undefined,
    reductionStartedEpoch: helpers/* Long.ZERO */.dK.ZERO
  };
}

const mint_v1beta1_genesis_GenesisState = {
  typeUrl: "/osmosis.mint.v1beta1.GenesisState",

  encode(message, writer = minimal.Writer.create()) {
    if (message.minter !== undefined) {
      v1beta1_mint.Minter.encode(message.minter, writer.uint32(10).fork()).ldelim();
    }

    if (message.params !== undefined) {
      v1beta1_mint.Params.encode(message.params, writer.uint32(18).fork()).ldelim();
    }

    if (!message.reductionStartedEpoch.isZero()) {
      writer.uint32(24).int64(message.reductionStartedEpoch);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = mint_v1beta1_genesis_createBaseGenesisState();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.minter = v1beta1_mint.Minter.decode(reader, reader.uint32());
          break;

        case 2:
          message.params = v1beta1_mint.Params.decode(reader, reader.uint32());
          break;

        case 3:
          message.reductionStartedEpoch = reader.int64();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = mint_v1beta1_genesis_createBaseGenesisState();
    message.minter = object.minter !== undefined && object.minter !== null ? v1beta1_mint.Minter.fromPartial(object.minter) : undefined;
    message.params = object.params !== undefined && object.params !== null ? v1beta1_mint.Params.fromPartial(object.params) : undefined;
    message.reductionStartedEpoch = object.reductionStartedEpoch !== undefined && object.reductionStartedEpoch !== null ? helpers/* Long.fromValue */.dK.fromValue(object.reductionStartedEpoch) : helpers/* Long.ZERO */.dK.ZERO;
    return message;
  },

  fromAmino(object) {
    return {
      minter: object !== null && object !== void 0 && object.minter ? v1beta1_mint.Minter.fromAmino(object.minter) : undefined,
      params: object !== null && object !== void 0 && object.params ? v1beta1_mint.Params.fromAmino(object.params) : undefined,
      reductionStartedEpoch: helpers/* Long.fromString */.dK.fromString(object.reduction_started_epoch)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.minter = message.minter ? v1beta1_mint.Minter.toAmino(message.minter) : undefined;
    obj.params = message.params ? v1beta1_mint.Params.toAmino(message.params) : undefined;
    obj.reduction_started_epoch = message.reductionStartedEpoch ? message.reductionStartedEpoch.toString() : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return mint_v1beta1_genesis_GenesisState.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/mint/genesis-state",
      value: mint_v1beta1_genesis_GenesisState.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return mint_v1beta1_genesis_GenesisState.decode(message.value);
  },

  toProto(message) {
    return mint_v1beta1_genesis_GenesisState.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.mint.v1beta1.GenesisState",
      value: mint_v1beta1_genesis_GenesisState.encode(message).finish()
    };
  }

};
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/osmosis/mint/v1beta1/query.js
var mint_v1beta1_query = __webpack_require__(59485);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/osmosis/pool-incentives/v1beta1/incentives.js
var v1beta1_incentives = __webpack_require__(52993);
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/osmosis/pool-incentives/v1beta1/genesis.js



/** GenesisState defines the pool incentives module's genesis state. */

function pool_incentives_v1beta1_genesis_createBaseGenesisState() {
  return {
    params: undefined,
    lockableDurations: [],
    distrInfo: undefined,
    poolToGauges: undefined
  };
}

const pool_incentives_v1beta1_genesis_GenesisState = {
  typeUrl: "/osmosis.poolincentives.v1beta1.GenesisState",

  encode(message, writer = minimal.Writer.create()) {
    if (message.params !== undefined) {
      v1beta1_incentives.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
    }

    for (const v of message.lockableDurations) {
      duration.Duration.encode(v, writer.uint32(18).fork()).ldelim();
    }

    if (message.distrInfo !== undefined) {
      v1beta1_incentives.DistrInfo.encode(message.distrInfo, writer.uint32(26).fork()).ldelim();
    }

    if (message.poolToGauges !== undefined) {
      v1beta1_incentives.PoolToGauges.encode(message.poolToGauges, writer.uint32(34).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = pool_incentives_v1beta1_genesis_createBaseGenesisState();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.params = v1beta1_incentives.Params.decode(reader, reader.uint32());
          break;

        case 2:
          message.lockableDurations.push(duration.Duration.decode(reader, reader.uint32()));
          break;

        case 3:
          message.distrInfo = v1beta1_incentives.DistrInfo.decode(reader, reader.uint32());
          break;

        case 4:
          message.poolToGauges = v1beta1_incentives.PoolToGauges.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$lockableDurat;

    const message = pool_incentives_v1beta1_genesis_createBaseGenesisState();
    message.params = object.params !== undefined && object.params !== null ? v1beta1_incentives.Params.fromPartial(object.params) : undefined;
    message.lockableDurations = ((_object$lockableDurat = object.lockableDurations) === null || _object$lockableDurat === void 0 ? void 0 : _object$lockableDurat.map(e => duration.Duration.fromPartial(e))) || [];
    message.distrInfo = object.distrInfo !== undefined && object.distrInfo !== null ? v1beta1_incentives.DistrInfo.fromPartial(object.distrInfo) : undefined;
    message.poolToGauges = object.poolToGauges !== undefined && object.poolToGauges !== null ? v1beta1_incentives.PoolToGauges.fromPartial(object.poolToGauges) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      params: object !== null && object !== void 0 && object.params ? v1beta1_incentives.Params.fromAmino(object.params) : undefined,
      lockableDurations: Array.isArray(object === null || object === void 0 ? void 0 : object.lockable_durations) ? object.lockable_durations.map(e => duration.Duration.fromAmino(e)) : [],
      distrInfo: object !== null && object !== void 0 && object.distr_info ? v1beta1_incentives.DistrInfo.fromAmino(object.distr_info) : undefined,
      poolToGauges: object !== null && object !== void 0 && object.pool_to_gauges ? v1beta1_incentives.PoolToGauges.fromAmino(object.pool_to_gauges) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.params = message.params ? v1beta1_incentives.Params.toAmino(message.params) : undefined;

    if (message.lockableDurations) {
      obj.lockable_durations = message.lockableDurations.map(e => e ? duration.Duration.toAmino(e) : undefined);
    } else {
      obj.lockable_durations = [];
    }

    obj.distr_info = message.distrInfo ? v1beta1_incentives.DistrInfo.toAmino(message.distrInfo) : undefined;
    obj.pool_to_gauges = message.poolToGauges ? v1beta1_incentives.PoolToGauges.toAmino(message.poolToGauges) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return pool_incentives_v1beta1_genesis_GenesisState.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/poolincentives/genesis-state",
      value: pool_incentives_v1beta1_genesis_GenesisState.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return pool_incentives_v1beta1_genesis_GenesisState.decode(message.value);
  },

  toProto(message) {
    return pool_incentives_v1beta1_genesis_GenesisState.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.poolincentives.v1beta1.GenesisState",
      value: pool_incentives_v1beta1_genesis_GenesisState.encode(message).finish()
    };
  }

};
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/osmosis/pool-incentives/v1beta1/gov.js


/**
 * ReplacePoolIncentivesProposal is a gov Content type for updating the pool
 * incentives. If a ReplacePoolIncentivesProposal passes, the proposal’s records
 * override the existing DistrRecords set in the module. Each record has a
 * specified gauge id and weight, and the incentives are distributed to each
 * gauge according to weight/total_weight. The incentives are put in the fee
 * pool and it is allocated to gauges and community pool by the DistrRecords
 * configuration. Note that gaugeId=0 represents the community pool.
 */

function createBaseReplacePoolIncentivesProposal() {
  return {
    $typeUrl: "/osmosis.poolincentives.v1beta1.ReplacePoolIncentivesProposal",
    title: "",
    description: "",
    records: []
  };
}

const ReplacePoolIncentivesProposal = {
  typeUrl: "/osmosis.poolincentives.v1beta1.ReplacePoolIncentivesProposal",

  encode(message, writer = minimal.Writer.create()) {
    if (message.title !== "") {
      writer.uint32(10).string(message.title);
    }

    if (message.description !== "") {
      writer.uint32(18).string(message.description);
    }

    for (const v of message.records) {
      v1beta1_incentives.DistrRecord.encode(v, writer.uint32(26).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseReplacePoolIncentivesProposal();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.title = reader.string();
          break;

        case 2:
          message.description = reader.string();
          break;

        case 3:
          message.records.push(v1beta1_incentives.DistrRecord.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$title, _object$description, _object$records;

    const message = createBaseReplacePoolIncentivesProposal();
    message.title = (_object$title = object.title) !== null && _object$title !== void 0 ? _object$title : "";
    message.description = (_object$description = object.description) !== null && _object$description !== void 0 ? _object$description : "";
    message.records = ((_object$records = object.records) === null || _object$records === void 0 ? void 0 : _object$records.map(e => v1beta1_incentives.DistrRecord.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      title: object.title,
      description: object.description,
      records: Array.isArray(object === null || object === void 0 ? void 0 : object.records) ? object.records.map(e => v1beta1_incentives.DistrRecord.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.title = message.title;
    obj.description = message.description;

    if (message.records) {
      obj.records = message.records.map(e => e ? v1beta1_incentives.DistrRecord.toAmino(e) : undefined);
    } else {
      obj.records = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return ReplacePoolIncentivesProposal.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/ReplacePoolIncentivesProposal",
      value: ReplacePoolIncentivesProposal.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return ReplacePoolIncentivesProposal.decode(message.value);
  },

  toProto(message) {
    return ReplacePoolIncentivesProposal.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.poolincentives.v1beta1.ReplacePoolIncentivesProposal",
      value: ReplacePoolIncentivesProposal.encode(message).finish()
    };
  }

};

function createBaseUpdatePoolIncentivesProposal() {
  return {
    $typeUrl: "/osmosis.poolincentives.v1beta1.UpdatePoolIncentivesProposal",
    title: "",
    description: "",
    records: []
  };
}

const UpdatePoolIncentivesProposal = {
  typeUrl: "/osmosis.poolincentives.v1beta1.UpdatePoolIncentivesProposal",

  encode(message, writer = minimal.Writer.create()) {
    if (message.title !== "") {
      writer.uint32(10).string(message.title);
    }

    if (message.description !== "") {
      writer.uint32(18).string(message.description);
    }

    for (const v of message.records) {
      v1beta1_incentives.DistrRecord.encode(v, writer.uint32(26).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdatePoolIncentivesProposal();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.title = reader.string();
          break;

        case 2:
          message.description = reader.string();
          break;

        case 3:
          message.records.push(v1beta1_incentives.DistrRecord.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$title2, _object$description2, _object$records2;

    const message = createBaseUpdatePoolIncentivesProposal();
    message.title = (_object$title2 = object.title) !== null && _object$title2 !== void 0 ? _object$title2 : "";
    message.description = (_object$description2 = object.description) !== null && _object$description2 !== void 0 ? _object$description2 : "";
    message.records = ((_object$records2 = object.records) === null || _object$records2 === void 0 ? void 0 : _object$records2.map(e => v1beta1_incentives.DistrRecord.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      title: object.title,
      description: object.description,
      records: Array.isArray(object === null || object === void 0 ? void 0 : object.records) ? object.records.map(e => v1beta1_incentives.DistrRecord.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.title = message.title;
    obj.description = message.description;

    if (message.records) {
      obj.records = message.records.map(e => e ? v1beta1_incentives.DistrRecord.toAmino(e) : undefined);
    } else {
      obj.records = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return UpdatePoolIncentivesProposal.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/UpdatePoolIncentivesProposal",
      value: UpdatePoolIncentivesProposal.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return UpdatePoolIncentivesProposal.decode(message.value);
  },

  toProto(message) {
    return UpdatePoolIncentivesProposal.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.poolincentives.v1beta1.UpdatePoolIncentivesProposal",
      value: UpdatePoolIncentivesProposal.encode(message).finish()
    };
  }

};
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/osmosis/pool-incentives/v1beta1/query.js
var pool_incentives_v1beta1_query = __webpack_require__(32889);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/osmosis/poolmanager/v1beta1/genesis.js
var v1beta1_genesis = __webpack_require__(11721);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/osmosis/poolmanager/v1beta1/module_route.js
var module_route = __webpack_require__(61103);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/osmosis/poolmanager/v1beta1/query.js
var poolmanager_v1beta1_query = __webpack_require__(38569);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/osmosis/poolmanager/v1beta1/swap_route.js
var swap_route = __webpack_require__(23569);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/osmosis/poolmanager/v1beta1/tx.js
var poolmanager_v1beta1_tx = __webpack_require__(2824);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/osmosis/protorev/v1beta1/params.js
var protorev_v1beta1_params = __webpack_require__(91051);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/osmosis/protorev/v1beta1/protorev.js
var v1beta1_protorev = __webpack_require__(10673);
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/osmosis/protorev/v1beta1/genesis.js





/** GenesisState defines the protorev module's genesis state. */

function protorev_v1beta1_genesis_createBaseGenesisState() {
  return {
    params: undefined,
    tokenPairArbRoutes: [],
    baseDenoms: [],
    poolWeights: undefined,
    daysSinceModuleGenesis: helpers/* Long.UZERO */.dK.UZERO,
    developerFees: [],
    latestBlockHeight: helpers/* Long.UZERO */.dK.UZERO,
    developerAddress: "",
    maxPoolPointsPerBlock: helpers/* Long.UZERO */.dK.UZERO,
    maxPoolPointsPerTx: helpers/* Long.UZERO */.dK.UZERO,
    pointCountForBlock: helpers/* Long.UZERO */.dK.UZERO,
    profits: []
  };
}

const protorev_v1beta1_genesis_GenesisState = {
  typeUrl: "/osmosis.protorev.v1beta1.GenesisState",

  encode(message, writer = minimal.Writer.create()) {
    if (message.params !== undefined) {
      protorev_v1beta1_params.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
    }

    for (const v of message.tokenPairArbRoutes) {
      v1beta1_protorev.TokenPairArbRoutes.encode(v, writer.uint32(18).fork()).ldelim();
    }

    for (const v of message.baseDenoms) {
      v1beta1_protorev.BaseDenom.encode(v, writer.uint32(26).fork()).ldelim();
    }

    if (message.poolWeights !== undefined) {
      v1beta1_protorev.PoolWeights.encode(message.poolWeights, writer.uint32(34).fork()).ldelim();
    }

    if (!message.daysSinceModuleGenesis.isZero()) {
      writer.uint32(40).uint64(message.daysSinceModuleGenesis);
    }

    for (const v of message.developerFees) {
      coin.Coin.encode(v, writer.uint32(50).fork()).ldelim();
    }

    if (!message.latestBlockHeight.isZero()) {
      writer.uint32(56).uint64(message.latestBlockHeight);
    }

    if (message.developerAddress !== "") {
      writer.uint32(66).string(message.developerAddress);
    }

    if (!message.maxPoolPointsPerBlock.isZero()) {
      writer.uint32(72).uint64(message.maxPoolPointsPerBlock);
    }

    if (!message.maxPoolPointsPerTx.isZero()) {
      writer.uint32(80).uint64(message.maxPoolPointsPerTx);
    }

    if (!message.pointCountForBlock.isZero()) {
      writer.uint32(88).uint64(message.pointCountForBlock);
    }

    for (const v of message.profits) {
      coin.Coin.encode(v, writer.uint32(98).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = protorev_v1beta1_genesis_createBaseGenesisState();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.params = protorev_v1beta1_params.Params.decode(reader, reader.uint32());
          break;

        case 2:
          message.tokenPairArbRoutes.push(v1beta1_protorev.TokenPairArbRoutes.decode(reader, reader.uint32()));
          break;

        case 3:
          message.baseDenoms.push(v1beta1_protorev.BaseDenom.decode(reader, reader.uint32()));
          break;

        case 4:
          message.poolWeights = v1beta1_protorev.PoolWeights.decode(reader, reader.uint32());
          break;

        case 5:
          message.daysSinceModuleGenesis = reader.uint64();
          break;

        case 6:
          message.developerFees.push(coin.Coin.decode(reader, reader.uint32()));
          break;

        case 7:
          message.latestBlockHeight = reader.uint64();
          break;

        case 8:
          message.developerAddress = reader.string();
          break;

        case 9:
          message.maxPoolPointsPerBlock = reader.uint64();
          break;

        case 10:
          message.maxPoolPointsPerTx = reader.uint64();
          break;

        case 11:
          message.pointCountForBlock = reader.uint64();
          break;

        case 12:
          message.profits.push(coin.Coin.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$tokenPairArbR, _object$baseDenoms, _object$developerFees, _object$developerAddr, _object$profits;

    const message = protorev_v1beta1_genesis_createBaseGenesisState();
    message.params = object.params !== undefined && object.params !== null ? protorev_v1beta1_params.Params.fromPartial(object.params) : undefined;
    message.tokenPairArbRoutes = ((_object$tokenPairArbR = object.tokenPairArbRoutes) === null || _object$tokenPairArbR === void 0 ? void 0 : _object$tokenPairArbR.map(e => v1beta1_protorev.TokenPairArbRoutes.fromPartial(e))) || [];
    message.baseDenoms = ((_object$baseDenoms = object.baseDenoms) === null || _object$baseDenoms === void 0 ? void 0 : _object$baseDenoms.map(e => v1beta1_protorev.BaseDenom.fromPartial(e))) || [];
    message.poolWeights = object.poolWeights !== undefined && object.poolWeights !== null ? v1beta1_protorev.PoolWeights.fromPartial(object.poolWeights) : undefined;
    message.daysSinceModuleGenesis = object.daysSinceModuleGenesis !== undefined && object.daysSinceModuleGenesis !== null ? helpers/* Long.fromValue */.dK.fromValue(object.daysSinceModuleGenesis) : helpers/* Long.UZERO */.dK.UZERO;
    message.developerFees = ((_object$developerFees = object.developerFees) === null || _object$developerFees === void 0 ? void 0 : _object$developerFees.map(e => coin.Coin.fromPartial(e))) || [];
    message.latestBlockHeight = object.latestBlockHeight !== undefined && object.latestBlockHeight !== null ? helpers/* Long.fromValue */.dK.fromValue(object.latestBlockHeight) : helpers/* Long.UZERO */.dK.UZERO;
    message.developerAddress = (_object$developerAddr = object.developerAddress) !== null && _object$developerAddr !== void 0 ? _object$developerAddr : "";
    message.maxPoolPointsPerBlock = object.maxPoolPointsPerBlock !== undefined && object.maxPoolPointsPerBlock !== null ? helpers/* Long.fromValue */.dK.fromValue(object.maxPoolPointsPerBlock) : helpers/* Long.UZERO */.dK.UZERO;
    message.maxPoolPointsPerTx = object.maxPoolPointsPerTx !== undefined && object.maxPoolPointsPerTx !== null ? helpers/* Long.fromValue */.dK.fromValue(object.maxPoolPointsPerTx) : helpers/* Long.UZERO */.dK.UZERO;
    message.pointCountForBlock = object.pointCountForBlock !== undefined && object.pointCountForBlock !== null ? helpers/* Long.fromValue */.dK.fromValue(object.pointCountForBlock) : helpers/* Long.UZERO */.dK.UZERO;
    message.profits = ((_object$profits = object.profits) === null || _object$profits === void 0 ? void 0 : _object$profits.map(e => coin.Coin.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      params: object !== null && object !== void 0 && object.params ? protorev_v1beta1_params.Params.fromAmino(object.params) : undefined,
      tokenPairArbRoutes: Array.isArray(object === null || object === void 0 ? void 0 : object.token_pair_arb_routes) ? object.token_pair_arb_routes.map(e => v1beta1_protorev.TokenPairArbRoutes.fromAmino(e)) : [],
      baseDenoms: Array.isArray(object === null || object === void 0 ? void 0 : object.base_denoms) ? object.base_denoms.map(e => v1beta1_protorev.BaseDenom.fromAmino(e)) : [],
      poolWeights: object !== null && object !== void 0 && object.pool_weights ? v1beta1_protorev.PoolWeights.fromAmino(object.pool_weights) : undefined,
      daysSinceModuleGenesis: helpers/* Long.fromString */.dK.fromString(object.days_since_module_genesis),
      developerFees: Array.isArray(object === null || object === void 0 ? void 0 : object.developer_fees) ? object.developer_fees.map(e => coin.Coin.fromAmino(e)) : [],
      latestBlockHeight: helpers/* Long.fromString */.dK.fromString(object.latest_block_height),
      developerAddress: object.developer_address,
      maxPoolPointsPerBlock: helpers/* Long.fromString */.dK.fromString(object.max_pool_points_per_block),
      maxPoolPointsPerTx: helpers/* Long.fromString */.dK.fromString(object.max_pool_points_per_tx),
      pointCountForBlock: helpers/* Long.fromString */.dK.fromString(object.point_count_for_block),
      profits: Array.isArray(object === null || object === void 0 ? void 0 : object.profits) ? object.profits.map(e => coin.Coin.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.params = message.params ? protorev_v1beta1_params.Params.toAmino(message.params) : undefined;

    if (message.tokenPairArbRoutes) {
      obj.token_pair_arb_routes = message.tokenPairArbRoutes.map(e => e ? v1beta1_protorev.TokenPairArbRoutes.toAmino(e) : undefined);
    } else {
      obj.token_pair_arb_routes = [];
    }

    if (message.baseDenoms) {
      obj.base_denoms = message.baseDenoms.map(e => e ? v1beta1_protorev.BaseDenom.toAmino(e) : undefined);
    } else {
      obj.base_denoms = [];
    }

    obj.pool_weights = message.poolWeights ? v1beta1_protorev.PoolWeights.toAmino(message.poolWeights) : undefined;
    obj.days_since_module_genesis = message.daysSinceModuleGenesis ? message.daysSinceModuleGenesis.toString() : undefined;

    if (message.developerFees) {
      obj.developer_fees = message.developerFees.map(e => e ? coin.Coin.toAmino(e) : undefined);
    } else {
      obj.developer_fees = [];
    }

    obj.latest_block_height = message.latestBlockHeight ? message.latestBlockHeight.toString() : undefined;
    obj.developer_address = message.developerAddress;
    obj.max_pool_points_per_block = message.maxPoolPointsPerBlock ? message.maxPoolPointsPerBlock.toString() : undefined;
    obj.max_pool_points_per_tx = message.maxPoolPointsPerTx ? message.maxPoolPointsPerTx.toString() : undefined;
    obj.point_count_for_block = message.pointCountForBlock ? message.pointCountForBlock.toString() : undefined;

    if (message.profits) {
      obj.profits = message.profits.map(e => e ? coin.Coin.toAmino(e) : undefined);
    } else {
      obj.profits = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return protorev_v1beta1_genesis_GenesisState.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/protorev/genesis-state",
      value: protorev_v1beta1_genesis_GenesisState.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return protorev_v1beta1_genesis_GenesisState.decode(message.value);
  },

  toProto(message) {
    return protorev_v1beta1_genesis_GenesisState.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.protorev.v1beta1.GenesisState",
      value: protorev_v1beta1_genesis_GenesisState.encode(message).finish()
    };
  }

};
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/osmosis/protorev/v1beta1/gov.js

/**
 * SetProtoRevEnabledProposal is a gov Content type to update whether the
 * protorev module is enabled
 */

function createBaseSetProtoRevEnabledProposal() {
  return {
    $typeUrl: "/osmosis.protorev.v1beta1.SetProtoRevEnabledProposal",
    title: "",
    description: "",
    enabled: false
  };
}

const SetProtoRevEnabledProposal = {
  typeUrl: "/osmosis.protorev.v1beta1.SetProtoRevEnabledProposal",

  encode(message, writer = minimal.Writer.create()) {
    if (message.title !== "") {
      writer.uint32(10).string(message.title);
    }

    if (message.description !== "") {
      writer.uint32(18).string(message.description);
    }

    if (message.enabled === true) {
      writer.uint32(24).bool(message.enabled);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetProtoRevEnabledProposal();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.title = reader.string();
          break;

        case 2:
          message.description = reader.string();
          break;

        case 3:
          message.enabled = reader.bool();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$title, _object$description, _object$enabled;

    const message = createBaseSetProtoRevEnabledProposal();
    message.title = (_object$title = object.title) !== null && _object$title !== void 0 ? _object$title : "";
    message.description = (_object$description = object.description) !== null && _object$description !== void 0 ? _object$description : "";
    message.enabled = (_object$enabled = object.enabled) !== null && _object$enabled !== void 0 ? _object$enabled : false;
    return message;
  },

  fromAmino(object) {
    return {
      title: object.title,
      description: object.description,
      enabled: object.enabled
    };
  },

  toAmino(message) {
    const obj = {};
    obj.title = message.title;
    obj.description = message.description;
    obj.enabled = message.enabled;
    return obj;
  },

  fromAminoMsg(object) {
    return SetProtoRevEnabledProposal.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/SetProtoRevEnabledProposal",
      value: SetProtoRevEnabledProposal.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return SetProtoRevEnabledProposal.decode(message.value);
  },

  toProto(message) {
    return SetProtoRevEnabledProposal.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.protorev.v1beta1.SetProtoRevEnabledProposal",
      value: SetProtoRevEnabledProposal.encode(message).finish()
    };
  }

};

function createBaseSetProtoRevAdminAccountProposal() {
  return {
    $typeUrl: "/osmosis.protorev.v1beta1.SetProtoRevAdminAccountProposal",
    title: "",
    description: "",
    account: ""
  };
}

const SetProtoRevAdminAccountProposal = {
  typeUrl: "/osmosis.protorev.v1beta1.SetProtoRevAdminAccountProposal",

  encode(message, writer = minimal.Writer.create()) {
    if (message.title !== "") {
      writer.uint32(10).string(message.title);
    }

    if (message.description !== "") {
      writer.uint32(18).string(message.description);
    }

    if (message.account !== "") {
      writer.uint32(26).string(message.account);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetProtoRevAdminAccountProposal();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.title = reader.string();
          break;

        case 2:
          message.description = reader.string();
          break;

        case 3:
          message.account = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$title2, _object$description2, _object$account;

    const message = createBaseSetProtoRevAdminAccountProposal();
    message.title = (_object$title2 = object.title) !== null && _object$title2 !== void 0 ? _object$title2 : "";
    message.description = (_object$description2 = object.description) !== null && _object$description2 !== void 0 ? _object$description2 : "";
    message.account = (_object$account = object.account) !== null && _object$account !== void 0 ? _object$account : "";
    return message;
  },

  fromAmino(object) {
    return {
      title: object.title,
      description: object.description,
      account: object.account
    };
  },

  toAmino(message) {
    const obj = {};
    obj.title = message.title;
    obj.description = message.description;
    obj.account = message.account;
    return obj;
  },

  fromAminoMsg(object) {
    return SetProtoRevAdminAccountProposal.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/SetProtoRevAdminAccountProposal",
      value: SetProtoRevAdminAccountProposal.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return SetProtoRevAdminAccountProposal.decode(message.value);
  },

  toProto(message) {
    return SetProtoRevAdminAccountProposal.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.protorev.v1beta1.SetProtoRevAdminAccountProposal",
      value: SetProtoRevAdminAccountProposal.encode(message).finish()
    };
  }

};
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/osmosis/protorev/v1beta1/query.js
var protorev_v1beta1_query = __webpack_require__(82594);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/osmosis/protorev/v1beta1/tx.js
var protorev_v1beta1_tx = __webpack_require__(97560);
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/osmosis/sumtree/v1beta1/tree.js


function createBaseNode() {
  return {
    children: []
  };
}

const Node = {
  typeUrl: "/osmosis.store.v1beta1.Node",

  encode(message, writer = minimal.Writer.create()) {
    for (const v of message.children) {
      Child.encode(v, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseNode();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.children.push(Child.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$children;

    const message = createBaseNode();
    message.children = ((_object$children = object.children) === null || _object$children === void 0 ? void 0 : _object$children.map(e => Child.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      children: Array.isArray(object === null || object === void 0 ? void 0 : object.children) ? object.children.map(e => Child.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.children) {
      obj.children = message.children.map(e => e ? Child.toAmino(e) : undefined);
    } else {
      obj.children = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return Node.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/store/node",
      value: Node.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return Node.decode(message.value);
  },

  toProto(message) {
    return Node.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.store.v1beta1.Node",
      value: Node.encode(message).finish()
    };
  }

};

function createBaseChild() {
  return {
    index: new Uint8Array(),
    accumulation: ""
  };
}

const Child = {
  typeUrl: "/osmosis.store.v1beta1.Child",

  encode(message, writer = minimal.Writer.create()) {
    if (message.index.length !== 0) {
      writer.uint32(10).bytes(message.index);
    }

    if (message.accumulation !== "") {
      writer.uint32(18).string(message.accumulation);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseChild();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.index = reader.bytes();
          break;

        case 2:
          message.accumulation = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$index, _object$accumulation;

    const message = createBaseChild();
    message.index = (_object$index = object.index) !== null && _object$index !== void 0 ? _object$index : new Uint8Array();
    message.accumulation = (_object$accumulation = object.accumulation) !== null && _object$accumulation !== void 0 ? _object$accumulation : "";
    return message;
  },

  fromAmino(object) {
    return {
      index: object.index,
      accumulation: object.accumulation
    };
  },

  toAmino(message) {
    const obj = {};
    obj.index = message.index;
    obj.accumulation = message.accumulation;
    return obj;
  },

  fromAminoMsg(object) {
    return Child.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/store/child",
      value: Child.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return Child.decode(message.value);
  },

  toProto(message) {
    return Child.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.store.v1beta1.Child",
      value: Child.encode(message).finish()
    };
  }

};

function createBaseLeaf() {
  return {
    leaf: undefined
  };
}

const Leaf = {
  typeUrl: "/osmosis.store.v1beta1.Leaf",

  encode(message, writer = minimal.Writer.create()) {
    if (message.leaf !== undefined) {
      Child.encode(message.leaf, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLeaf();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.leaf = Child.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseLeaf();
    message.leaf = object.leaf !== undefined && object.leaf !== null ? Child.fromPartial(object.leaf) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      leaf: object !== null && object !== void 0 && object.leaf ? Child.fromAmino(object.leaf) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.leaf = message.leaf ? Child.toAmino(message.leaf) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return Leaf.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/store/leaf",
      value: Leaf.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return Leaf.decode(message.value);
  },

  toProto(message) {
    return Leaf.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.store.v1beta1.Leaf",
      value: Leaf.encode(message).finish()
    };
  }

};
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/osmosis/superfluid/params.js
var superfluid_params = __webpack_require__(97866);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/osmosis/superfluid/superfluid.js
var superfluid_superfluid = __webpack_require__(68572);
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/osmosis/superfluid/genesis.js



/** GenesisState defines the module's genesis state. */

function superfluid_genesis_createBaseGenesisState() {
  return {
    params: undefined,
    superfluidAssets: [],
    osmoEquivalentMultipliers: [],
    intermediaryAccounts: [],
    intemediaryAccountConnections: []
  };
}

const superfluid_genesis_GenesisState = {
  typeUrl: "/osmosis.superfluid.GenesisState",

  encode(message, writer = minimal.Writer.create()) {
    if (message.params !== undefined) {
      superfluid_params.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
    }

    for (const v of message.superfluidAssets) {
      superfluid_superfluid.SuperfluidAsset.encode(v, writer.uint32(18).fork()).ldelim();
    }

    for (const v of message.osmoEquivalentMultipliers) {
      superfluid_superfluid.OsmoEquivalentMultiplierRecord.encode(v, writer.uint32(26).fork()).ldelim();
    }

    for (const v of message.intermediaryAccounts) {
      superfluid_superfluid.SuperfluidIntermediaryAccount.encode(v, writer.uint32(34).fork()).ldelim();
    }

    for (const v of message.intemediaryAccountConnections) {
      superfluid_superfluid.LockIdIntermediaryAccountConnection.encode(v, writer.uint32(42).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = superfluid_genesis_createBaseGenesisState();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.params = superfluid_params.Params.decode(reader, reader.uint32());
          break;

        case 2:
          message.superfluidAssets.push(superfluid_superfluid.SuperfluidAsset.decode(reader, reader.uint32()));
          break;

        case 3:
          message.osmoEquivalentMultipliers.push(superfluid_superfluid.OsmoEquivalentMultiplierRecord.decode(reader, reader.uint32()));
          break;

        case 4:
          message.intermediaryAccounts.push(superfluid_superfluid.SuperfluidIntermediaryAccount.decode(reader, reader.uint32()));
          break;

        case 5:
          message.intemediaryAccountConnections.push(superfluid_superfluid.LockIdIntermediaryAccountConnection.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$superfluidAss, _object$osmoEquivalen, _object$intermediaryA, _object$intemediaryAc;

    const message = superfluid_genesis_createBaseGenesisState();
    message.params = object.params !== undefined && object.params !== null ? superfluid_params.Params.fromPartial(object.params) : undefined;
    message.superfluidAssets = ((_object$superfluidAss = object.superfluidAssets) === null || _object$superfluidAss === void 0 ? void 0 : _object$superfluidAss.map(e => superfluid_superfluid.SuperfluidAsset.fromPartial(e))) || [];
    message.osmoEquivalentMultipliers = ((_object$osmoEquivalen = object.osmoEquivalentMultipliers) === null || _object$osmoEquivalen === void 0 ? void 0 : _object$osmoEquivalen.map(e => superfluid_superfluid.OsmoEquivalentMultiplierRecord.fromPartial(e))) || [];
    message.intermediaryAccounts = ((_object$intermediaryA = object.intermediaryAccounts) === null || _object$intermediaryA === void 0 ? void 0 : _object$intermediaryA.map(e => superfluid_superfluid.SuperfluidIntermediaryAccount.fromPartial(e))) || [];
    message.intemediaryAccountConnections = ((_object$intemediaryAc = object.intemediaryAccountConnections) === null || _object$intemediaryAc === void 0 ? void 0 : _object$intemediaryAc.map(e => superfluid_superfluid.LockIdIntermediaryAccountConnection.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      params: object !== null && object !== void 0 && object.params ? superfluid_params.Params.fromAmino(object.params) : undefined,
      superfluidAssets: Array.isArray(object === null || object === void 0 ? void 0 : object.superfluid_assets) ? object.superfluid_assets.map(e => superfluid_superfluid.SuperfluidAsset.fromAmino(e)) : [],
      osmoEquivalentMultipliers: Array.isArray(object === null || object === void 0 ? void 0 : object.osmo_equivalent_multipliers) ? object.osmo_equivalent_multipliers.map(e => superfluid_superfluid.OsmoEquivalentMultiplierRecord.fromAmino(e)) : [],
      intermediaryAccounts: Array.isArray(object === null || object === void 0 ? void 0 : object.intermediary_accounts) ? object.intermediary_accounts.map(e => superfluid_superfluid.SuperfluidIntermediaryAccount.fromAmino(e)) : [],
      intemediaryAccountConnections: Array.isArray(object === null || object === void 0 ? void 0 : object.intemediary_account_connections) ? object.intemediary_account_connections.map(e => superfluid_superfluid.LockIdIntermediaryAccountConnection.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.params = message.params ? superfluid_params.Params.toAmino(message.params) : undefined;

    if (message.superfluidAssets) {
      obj.superfluid_assets = message.superfluidAssets.map(e => e ? superfluid_superfluid.SuperfluidAsset.toAmino(e) : undefined);
    } else {
      obj.superfluid_assets = [];
    }

    if (message.osmoEquivalentMultipliers) {
      obj.osmo_equivalent_multipliers = message.osmoEquivalentMultipliers.map(e => e ? superfluid_superfluid.OsmoEquivalentMultiplierRecord.toAmino(e) : undefined);
    } else {
      obj.osmo_equivalent_multipliers = [];
    }

    if (message.intermediaryAccounts) {
      obj.intermediary_accounts = message.intermediaryAccounts.map(e => e ? superfluid_superfluid.SuperfluidIntermediaryAccount.toAmino(e) : undefined);
    } else {
      obj.intermediary_accounts = [];
    }

    if (message.intemediaryAccountConnections) {
      obj.intemediary_account_connections = message.intemediaryAccountConnections.map(e => e ? superfluid_superfluid.LockIdIntermediaryAccountConnection.toAmino(e) : undefined);
    } else {
      obj.intemediary_account_connections = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return superfluid_genesis_GenesisState.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/genesis-state",
      value: superfluid_genesis_GenesisState.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return superfluid_genesis_GenesisState.decode(message.value);
  },

  toProto(message) {
    return superfluid_genesis_GenesisState.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.superfluid.GenesisState",
      value: superfluid_genesis_GenesisState.encode(message).finish()
    };
  }

};
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/osmosis/superfluid/query.js
var superfluid_query = __webpack_require__(71459);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/osmosis/superfluid/tx.js
var superfluid_tx = __webpack_require__(56429);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/osmosis/tokenfactory/v1beta1/authorityMetadata.js
var authorityMetadata = __webpack_require__(56786);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/osmosis/tokenfactory/v1beta1/params.js
var tokenfactory_v1beta1_params = __webpack_require__(86839);
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/osmosis/tokenfactory/v1beta1/genesis.js



/** GenesisState defines the tokenfactory module's genesis state. */

function tokenfactory_v1beta1_genesis_createBaseGenesisState() {
  return {
    params: undefined,
    factoryDenoms: []
  };
}

const tokenfactory_v1beta1_genesis_GenesisState = {
  typeUrl: "/osmosis.tokenfactory.v1beta1.GenesisState",

  encode(message, writer = minimal.Writer.create()) {
    if (message.params !== undefined) {
      tokenfactory_v1beta1_params.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
    }

    for (const v of message.factoryDenoms) {
      GenesisDenom.encode(v, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = tokenfactory_v1beta1_genesis_createBaseGenesisState();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.params = tokenfactory_v1beta1_params.Params.decode(reader, reader.uint32());
          break;

        case 2:
          message.factoryDenoms.push(GenesisDenom.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$factoryDenoms;

    const message = tokenfactory_v1beta1_genesis_createBaseGenesisState();
    message.params = object.params !== undefined && object.params !== null ? tokenfactory_v1beta1_params.Params.fromPartial(object.params) : undefined;
    message.factoryDenoms = ((_object$factoryDenoms = object.factoryDenoms) === null || _object$factoryDenoms === void 0 ? void 0 : _object$factoryDenoms.map(e => GenesisDenom.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      params: object !== null && object !== void 0 && object.params ? tokenfactory_v1beta1_params.Params.fromAmino(object.params) : undefined,
      factoryDenoms: Array.isArray(object === null || object === void 0 ? void 0 : object.factory_denoms) ? object.factory_denoms.map(e => GenesisDenom.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.params = message.params ? tokenfactory_v1beta1_params.Params.toAmino(message.params) : undefined;

    if (message.factoryDenoms) {
      obj.factory_denoms = message.factoryDenoms.map(e => e ? GenesisDenom.toAmino(e) : undefined);
    } else {
      obj.factory_denoms = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return tokenfactory_v1beta1_genesis_GenesisState.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/tokenfactory/genesis-state",
      value: tokenfactory_v1beta1_genesis_GenesisState.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return tokenfactory_v1beta1_genesis_GenesisState.decode(message.value);
  },

  toProto(message) {
    return tokenfactory_v1beta1_genesis_GenesisState.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.tokenfactory.v1beta1.GenesisState",
      value: tokenfactory_v1beta1_genesis_GenesisState.encode(message).finish()
    };
  }

};

function createBaseGenesisDenom() {
  return {
    denom: "",
    authorityMetadata: undefined
  };
}

const GenesisDenom = {
  typeUrl: "/osmosis.tokenfactory.v1beta1.GenesisDenom",

  encode(message, writer = minimal.Writer.create()) {
    if (message.denom !== "") {
      writer.uint32(10).string(message.denom);
    }

    if (message.authorityMetadata !== undefined) {
      authorityMetadata.DenomAuthorityMetadata.encode(message.authorityMetadata, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGenesisDenom();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.denom = reader.string();
          break;

        case 2:
          message.authorityMetadata = authorityMetadata.DenomAuthorityMetadata.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$denom;

    const message = createBaseGenesisDenom();
    message.denom = (_object$denom = object.denom) !== null && _object$denom !== void 0 ? _object$denom : "";
    message.authorityMetadata = object.authorityMetadata !== undefined && object.authorityMetadata !== null ? authorityMetadata.DenomAuthorityMetadata.fromPartial(object.authorityMetadata) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      denom: object.denom,
      authorityMetadata: object !== null && object !== void 0 && object.authority_metadata ? authorityMetadata.DenomAuthorityMetadata.fromAmino(object.authority_metadata) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.denom = message.denom;
    obj.authority_metadata = message.authorityMetadata ? authorityMetadata.DenomAuthorityMetadata.toAmino(message.authorityMetadata) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return GenesisDenom.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/tokenfactory/genesis-denom",
      value: GenesisDenom.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return GenesisDenom.decode(message.value);
  },

  toProto(message) {
    return GenesisDenom.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.tokenfactory.v1beta1.GenesisDenom",
      value: GenesisDenom.encode(message).finish()
    };
  }

};
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/osmosis/tokenfactory/v1beta1/query.js
var tokenfactory_v1beta1_query = __webpack_require__(41920);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/osmosis/tokenfactory/v1beta1/tx.js
var tokenfactory_v1beta1_tx = __webpack_require__(37974);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/osmosis/twap/v1beta1/genesis.js
var twap_v1beta1_genesis = __webpack_require__(4003);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/osmosis/twap/v1beta1/query.js
var twap_v1beta1_query = __webpack_require__(11069);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/osmosis/twap/v1beta1/twap_record.js
var twap_record = __webpack_require__(25754);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/osmosis/txfees/v1beta1/feetoken.js
var feetoken = __webpack_require__(83509);
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/osmosis/txfees/v1beta1/genesis.js


/** GenesisState defines the txfees module's genesis state. */

function txfees_v1beta1_genesis_createBaseGenesisState() {
  return {
    basedenom: "",
    feetokens: []
  };
}

const txfees_v1beta1_genesis_GenesisState = {
  typeUrl: "/osmosis.txfees.v1beta1.GenesisState",

  encode(message, writer = minimal.Writer.create()) {
    if (message.basedenom !== "") {
      writer.uint32(10).string(message.basedenom);
    }

    for (const v of message.feetokens) {
      feetoken.FeeToken.encode(v, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = txfees_v1beta1_genesis_createBaseGenesisState();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.basedenom = reader.string();
          break;

        case 2:
          message.feetokens.push(feetoken.FeeToken.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$basedenom, _object$feetokens;

    const message = txfees_v1beta1_genesis_createBaseGenesisState();
    message.basedenom = (_object$basedenom = object.basedenom) !== null && _object$basedenom !== void 0 ? _object$basedenom : "";
    message.feetokens = ((_object$feetokens = object.feetokens) === null || _object$feetokens === void 0 ? void 0 : _object$feetokens.map(e => feetoken.FeeToken.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      basedenom: object.basedenom,
      feetokens: Array.isArray(object === null || object === void 0 ? void 0 : object.feetokens) ? object.feetokens.map(e => feetoken.FeeToken.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.basedenom = message.basedenom;

    if (message.feetokens) {
      obj.feetokens = message.feetokens.map(e => e ? feetoken.FeeToken.toAmino(e) : undefined);
    } else {
      obj.feetokens = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return txfees_v1beta1_genesis_GenesisState.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/txfees/genesis-state",
      value: txfees_v1beta1_genesis_GenesisState.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return txfees_v1beta1_genesis_GenesisState.decode(message.value);
  },

  toProto(message) {
    return txfees_v1beta1_genesis_GenesisState.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.txfees.v1beta1.GenesisState",
      value: txfees_v1beta1_genesis_GenesisState.encode(message).finish()
    };
  }

};
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/osmosis/txfees/v1beta1/gov.js


/**
 * UpdateFeeTokenProposal is a gov Content type for adding new whitelisted fee
 * token(s). It must specify a denom along with gamm pool ID to use as a spot
 * price calculator. It can be used to add new denoms to the whitelist. It can
 * also be used to update the Pool to associate with the denom. If Pool ID is
 * set to 0, it will remove the denom from the whitelisted set.
 */

function createBaseUpdateFeeTokenProposal() {
  return {
    $typeUrl: "/osmosis.txfees.v1beta1.UpdateFeeTokenProposal",
    title: "",
    description: "",
    feetokens: []
  };
}

const UpdateFeeTokenProposal = {
  typeUrl: "/osmosis.txfees.v1beta1.UpdateFeeTokenProposal",

  encode(message, writer = minimal.Writer.create()) {
    if (message.title !== "") {
      writer.uint32(10).string(message.title);
    }

    if (message.description !== "") {
      writer.uint32(18).string(message.description);
    }

    for (const v of message.feetokens) {
      feetoken.FeeToken.encode(v, writer.uint32(26).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateFeeTokenProposal();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.title = reader.string();
          break;

        case 2:
          message.description = reader.string();
          break;

        case 3:
          message.feetokens.push(feetoken.FeeToken.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$title, _object$description, _object$feetokens;

    const message = createBaseUpdateFeeTokenProposal();
    message.title = (_object$title = object.title) !== null && _object$title !== void 0 ? _object$title : "";
    message.description = (_object$description = object.description) !== null && _object$description !== void 0 ? _object$description : "";
    message.feetokens = ((_object$feetokens = object.feetokens) === null || _object$feetokens === void 0 ? void 0 : _object$feetokens.map(e => feetoken.FeeToken.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      title: object.title,
      description: object.description,
      feetokens: Array.isArray(object === null || object === void 0 ? void 0 : object.feetokens) ? object.feetokens.map(e => feetoken.FeeToken.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.title = message.title;
    obj.description = message.description;

    if (message.feetokens) {
      obj.feetokens = message.feetokens.map(e => e ? feetoken.FeeToken.toAmino(e) : undefined);
    } else {
      obj.feetokens = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return UpdateFeeTokenProposal.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/UpdateFeeTokenProposal",
      value: UpdateFeeTokenProposal.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return UpdateFeeTokenProposal.decode(message.value);
  },

  toProto(message) {
    return UpdateFeeTokenProposal.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.txfees.v1beta1.UpdateFeeTokenProposal",
      value: UpdateFeeTokenProposal.encode(message).finish()
    };
  }

};
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/osmosis/txfees/v1beta1/query.js
var txfees_v1beta1_query = __webpack_require__(43717);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/osmosis/valset-pref/v1beta1/query.js
var valset_pref_v1beta1_query = __webpack_require__(31835);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/osmosis/valset-pref/v1beta1/state.js
var state = __webpack_require__(59998);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/osmosis/valset-pref/v1beta1/tx.js
var valset_pref_v1beta1_tx = __webpack_require__(98866);
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/osmosis/gamm/pool-models/balancer/tx/tx.amino.js
//@ts-nocheck

const tx_tx_amino_AminoConverter = {
  "/osmosis.gamm.poolmodels.balancer.v1beta1.MsgCreateBalancerPool": {
    aminoType: "osmosis/gamm/create-balancer-pool",
    toAmino: tx_tx.MsgCreateBalancerPool.toAmino,
    fromAmino: tx_tx.MsgCreateBalancerPool.fromAmino
  }
};
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/osmosis/gamm/pool-models/stableswap/tx.amino.js
//@ts-nocheck

const stableswap_tx_amino_AminoConverter = {
  "/osmosis.gamm.poolmodels.stableswap.v1beta1.MsgCreateStableswapPool": {
    aminoType: "osmosis/gamm/create-stableswap-pool",
    toAmino: stableswap_tx.MsgCreateStableswapPool.toAmino,
    fromAmino: stableswap_tx.MsgCreateStableswapPool.fromAmino
  },
  "/osmosis.gamm.poolmodels.stableswap.v1beta1.MsgStableSwapAdjustScalingFactors": {
    aminoType: "osmosis/gamm/stableswap-adjust-scaling-factors",
    toAmino: stableswap_tx.MsgStableSwapAdjustScalingFactors.toAmino,
    fromAmino: stableswap_tx.MsgStableSwapAdjustScalingFactors.fromAmino
  }
};
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/osmosis/gamm/v1beta1/tx.amino.js
//@ts-nocheck

const gamm_v1beta1_tx_amino_AminoConverter = {
  "/osmosis.gamm.v1beta1.MsgJoinPool": {
    aminoType: "osmosis/gamm/join-pool",
    toAmino: gamm_v1beta1_tx.MsgJoinPool.toAmino,
    fromAmino: gamm_v1beta1_tx.MsgJoinPool.fromAmino
  },
  "/osmosis.gamm.v1beta1.MsgExitPool": {
    aminoType: "osmosis/gamm/exit-pool",
    toAmino: gamm_v1beta1_tx.MsgExitPool.toAmino,
    fromAmino: gamm_v1beta1_tx.MsgExitPool.fromAmino
  },
  "/osmosis.gamm.v1beta1.MsgSwapExactAmountIn": {
    aminoType: "osmosis/gamm/swap-exact-amount-in",
    toAmino: gamm_v1beta1_tx.MsgSwapExactAmountIn.toAmino,
    fromAmino: gamm_v1beta1_tx.MsgSwapExactAmountIn.fromAmino
  },
  "/osmosis.gamm.v1beta1.MsgSwapExactAmountOut": {
    aminoType: "osmosis/gamm/swap-exact-amount-out",
    toAmino: gamm_v1beta1_tx.MsgSwapExactAmountOut.toAmino,
    fromAmino: gamm_v1beta1_tx.MsgSwapExactAmountOut.fromAmino
  },
  "/osmosis.gamm.v1beta1.MsgJoinSwapExternAmountIn": {
    aminoType: "osmosis/gamm/join-swap-extern-amount-in",
    toAmino: gamm_v1beta1_tx.MsgJoinSwapExternAmountIn.toAmino,
    fromAmino: gamm_v1beta1_tx.MsgJoinSwapExternAmountIn.fromAmino
  },
  "/osmosis.gamm.v1beta1.MsgJoinSwapShareAmountOut": {
    aminoType: "osmosis/gamm/join-swap-share-amount-out",
    toAmino: gamm_v1beta1_tx.MsgJoinSwapShareAmountOut.toAmino,
    fromAmino: gamm_v1beta1_tx.MsgJoinSwapShareAmountOut.fromAmino
  },
  "/osmosis.gamm.v1beta1.MsgExitSwapExternAmountOut": {
    aminoType: "osmosis/gamm/exit-swap-extern-amount-out",
    toAmino: gamm_v1beta1_tx.MsgExitSwapExternAmountOut.toAmino,
    fromAmino: gamm_v1beta1_tx.MsgExitSwapExternAmountOut.fromAmino
  },
  "/osmosis.gamm.v1beta1.MsgExitSwapShareAmountIn": {
    aminoType: "osmosis/gamm/exit-swap-share-amount-in",
    toAmino: gamm_v1beta1_tx.MsgExitSwapShareAmountIn.toAmino,
    fromAmino: gamm_v1beta1_tx.MsgExitSwapShareAmountIn.fromAmino
  }
};
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/osmosis/incentives/tx.amino.js
//@ts-nocheck

const incentives_tx_amino_AminoConverter = {
  "/osmosis.incentives.MsgCreateGauge": {
    aminoType: "osmosis/incentives/create-gauge",
    toAmino: incentives_tx.MsgCreateGauge.toAmino,
    fromAmino: incentives_tx.MsgCreateGauge.fromAmino
  },
  "/osmosis.incentives.MsgAddToGauge": {
    aminoType: "osmosis/incentives/add-to-gauge",
    toAmino: incentives_tx.MsgAddToGauge.toAmino,
    fromAmino: incentives_tx.MsgAddToGauge.fromAmino
  }
};
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/osmosis/lockup/tx.amino.js
//@ts-nocheck

const lockup_tx_amino_AminoConverter = {
  "/osmosis.lockup.MsgLockTokens": {
    aminoType: "osmosis/lockup/lock-tokens",
    toAmino: lockup_tx.MsgLockTokens.toAmino,
    fromAmino: lockup_tx.MsgLockTokens.fromAmino
  },
  "/osmosis.lockup.MsgBeginUnlockingAll": {
    aminoType: "osmosis/lockup/begin-unlock-tokens",
    toAmino: lockup_tx.MsgBeginUnlockingAll.toAmino,
    fromAmino: lockup_tx.MsgBeginUnlockingAll.fromAmino
  },
  "/osmosis.lockup.MsgBeginUnlocking": {
    aminoType: "osmosis/lockup/begin-unlock-period-lock",
    toAmino: lockup_tx.MsgBeginUnlocking.toAmino,
    fromAmino: lockup_tx.MsgBeginUnlocking.fromAmino
  },
  "/osmosis.lockup.MsgExtendLockup": {
    aminoType: "osmosis/lockup/extend-lockup",
    toAmino: lockup_tx.MsgExtendLockup.toAmino,
    fromAmino: lockup_tx.MsgExtendLockup.fromAmino
  },
  "/osmosis.lockup.MsgForceUnlock": {
    aminoType: "osmosis/lockup/force-unlock",
    toAmino: lockup_tx.MsgForceUnlock.toAmino,
    fromAmino: lockup_tx.MsgForceUnlock.fromAmino
  },
  "/osmosis.lockup.MsgSetRewardReceiverAddress": {
    aminoType: "osmosis/lockup/set-reward-receiver-address",
    toAmino: lockup_tx.MsgSetRewardReceiverAddress.toAmino,
    fromAmino: lockup_tx.MsgSetRewardReceiverAddress.fromAmino
  }
};
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/osmosis/poolmanager/v1beta1/tx.amino.js
//@ts-nocheck

const poolmanager_v1beta1_tx_amino_AminoConverter = {
  "/osmosis.poolmanager.v1beta1.MsgSwapExactAmountIn": {
    aminoType: "osmosis/poolmanager/swap-exact-amount-in",
    toAmino: poolmanager_v1beta1_tx.MsgSwapExactAmountIn.toAmino,
    fromAmino: poolmanager_v1beta1_tx.MsgSwapExactAmountIn.fromAmino
  },
  "/osmosis.poolmanager.v1beta1.MsgSwapExactAmountOut": {
    aminoType: "osmosis/poolmanager/swap-exact-amount-out",
    toAmino: poolmanager_v1beta1_tx.MsgSwapExactAmountOut.toAmino,
    fromAmino: poolmanager_v1beta1_tx.MsgSwapExactAmountOut.fromAmino
  },
  "/osmosis.poolmanager.v1beta1.MsgSplitRouteSwapExactAmountIn": {
    aminoType: "osmosis/poolmanager/split-route-swap-exact-amount-in",
    toAmino: poolmanager_v1beta1_tx.MsgSplitRouteSwapExactAmountIn.toAmino,
    fromAmino: poolmanager_v1beta1_tx.MsgSplitRouteSwapExactAmountIn.fromAmino
  },
  "/osmosis.poolmanager.v1beta1.MsgSplitRouteSwapExactAmountOut": {
    aminoType: "osmosis/poolmanager/split-route-swap-exact-amount-out",
    toAmino: poolmanager_v1beta1_tx.MsgSplitRouteSwapExactAmountOut.toAmino,
    fromAmino: poolmanager_v1beta1_tx.MsgSplitRouteSwapExactAmountOut.fromAmino
  }
};
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/osmosis/protorev/v1beta1/tx.amino.js
//@ts-nocheck

const protorev_v1beta1_tx_amino_AminoConverter = {
  "/osmosis.protorev.v1beta1.MsgSetHotRoutes": {
    aminoType: "osmosis/MsgSetHotRoutes",
    toAmino: protorev_v1beta1_tx.MsgSetHotRoutes.toAmino,
    fromAmino: protorev_v1beta1_tx.MsgSetHotRoutes.fromAmino
  },
  "/osmosis.protorev.v1beta1.MsgSetDeveloperAccount": {
    aminoType: "osmosis/MsgSetDeveloperAccount",
    toAmino: protorev_v1beta1_tx.MsgSetDeveloperAccount.toAmino,
    fromAmino: protorev_v1beta1_tx.MsgSetDeveloperAccount.fromAmino
  },
  "/osmosis.protorev.v1beta1.MsgSetMaxPoolPointsPerTx": {
    aminoType: "osmosis/protorev/set-max-pool-points-per-tx",
    toAmino: protorev_v1beta1_tx.MsgSetMaxPoolPointsPerTx.toAmino,
    fromAmino: protorev_v1beta1_tx.MsgSetMaxPoolPointsPerTx.fromAmino
  },
  "/osmosis.protorev.v1beta1.MsgSetMaxPoolPointsPerBlock": {
    aminoType: "osmosis/protorev/set-max-pool-points-per-block",
    toAmino: protorev_v1beta1_tx.MsgSetMaxPoolPointsPerBlock.toAmino,
    fromAmino: protorev_v1beta1_tx.MsgSetMaxPoolPointsPerBlock.fromAmino
  },
  "/osmosis.protorev.v1beta1.MsgSetPoolWeights": {
    aminoType: "osmosis/protorev/set-pool-weights",
    toAmino: protorev_v1beta1_tx.MsgSetPoolWeights.toAmino,
    fromAmino: protorev_v1beta1_tx.MsgSetPoolWeights.fromAmino
  },
  "/osmosis.protorev.v1beta1.MsgSetBaseDenoms": {
    aminoType: "osmosis/protorev/set-base-denoms",
    toAmino: protorev_v1beta1_tx.MsgSetBaseDenoms.toAmino,
    fromAmino: protorev_v1beta1_tx.MsgSetBaseDenoms.fromAmino
  }
};
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/osmosis/superfluid/tx.amino.js
//@ts-nocheck

const superfluid_tx_amino_AminoConverter = {
  "/osmosis.superfluid.MsgSuperfluidDelegate": {
    aminoType: "osmosis/superfluid-delegate",
    toAmino: superfluid_tx.MsgSuperfluidDelegate.toAmino,
    fromAmino: superfluid_tx.MsgSuperfluidDelegate.fromAmino
  },
  "/osmosis.superfluid.MsgSuperfluidUndelegate": {
    aminoType: "osmosis/superfluid-undelegate",
    toAmino: superfluid_tx.MsgSuperfluidUndelegate.toAmino,
    fromAmino: superfluid_tx.MsgSuperfluidUndelegate.fromAmino
  },
  "/osmosis.superfluid.MsgSuperfluidUnbondLock": {
    aminoType: "osmosis/superfluid-unbond-lock",
    toAmino: superfluid_tx.MsgSuperfluidUnbondLock.toAmino,
    fromAmino: superfluid_tx.MsgSuperfluidUnbondLock.fromAmino
  },
  "/osmosis.superfluid.MsgSuperfluidUndelegateAndUnbondLock": {
    aminoType: "osmosis/superfluid-undelegate-and-unbond-lock",
    toAmino: superfluid_tx.MsgSuperfluidUndelegateAndUnbondLock.toAmino,
    fromAmino: superfluid_tx.MsgSuperfluidUndelegateAndUnbondLock.fromAmino
  },
  "/osmosis.superfluid.MsgLockAndSuperfluidDelegate": {
    aminoType: "osmosis/lock-and-superfluid-delegate",
    toAmino: superfluid_tx.MsgLockAndSuperfluidDelegate.toAmino,
    fromAmino: superfluid_tx.MsgLockAndSuperfluidDelegate.fromAmino
  },
  "/osmosis.superfluid.MsgCreateFullRangePositionAndSuperfluidDelegate": {
    aminoType: "osmosis/create-full-range-position-and-superfluid-delegate",
    toAmino: superfluid_tx.MsgCreateFullRangePositionAndSuperfluidDelegate.toAmino,
    fromAmino: superfluid_tx.MsgCreateFullRangePositionAndSuperfluidDelegate.fromAmino
  },
  "/osmosis.superfluid.MsgUnPoolWhitelistedPool": {
    aminoType: "osmosis/unpool-whitelisted-pool",
    toAmino: superfluid_tx.MsgUnPoolWhitelistedPool.toAmino,
    fromAmino: superfluid_tx.MsgUnPoolWhitelistedPool.fromAmino
  },
  "/osmosis.superfluid.MsgUnlockAndMigrateSharesToFullRangeConcentratedPosition": {
    aminoType: "osmosis/unlock-and-migrate-shares-to-full-range-concentrated-position",
    toAmino: superfluid_tx.MsgUnlockAndMigrateSharesToFullRangeConcentratedPosition.toAmino,
    fromAmino: superfluid_tx.MsgUnlockAndMigrateSharesToFullRangeConcentratedPosition.fromAmino
  },
  "/osmosis.superfluid.MsgAddToConcentratedLiquiditySuperfluidPosition": {
    aminoType: "osmosis/add-to-concentrated-liquidity-superfluid-position",
    toAmino: superfluid_tx.MsgAddToConcentratedLiquiditySuperfluidPosition.toAmino,
    fromAmino: superfluid_tx.MsgAddToConcentratedLiquiditySuperfluidPosition.fromAmino
  }
};
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/osmosis/tokenfactory/v1beta1/tx.amino.js
//@ts-nocheck

const tokenfactory_v1beta1_tx_amino_AminoConverter = {
  "/osmosis.tokenfactory.v1beta1.MsgCreateDenom": {
    aminoType: "osmosis/tokenfactory/create-denom",
    toAmino: tokenfactory_v1beta1_tx.MsgCreateDenom.toAmino,
    fromAmino: tokenfactory_v1beta1_tx.MsgCreateDenom.fromAmino
  },
  "/osmosis.tokenfactory.v1beta1.MsgMint": {
    aminoType: "osmosis/tokenfactory/mint",
    toAmino: tokenfactory_v1beta1_tx.MsgMint.toAmino,
    fromAmino: tokenfactory_v1beta1_tx.MsgMint.fromAmino
  },
  "/osmosis.tokenfactory.v1beta1.MsgBurn": {
    aminoType: "osmosis/tokenfactory/burn",
    toAmino: tokenfactory_v1beta1_tx.MsgBurn.toAmino,
    fromAmino: tokenfactory_v1beta1_tx.MsgBurn.fromAmino
  },
  "/osmosis.tokenfactory.v1beta1.MsgChangeAdmin": {
    aminoType: "osmosis/tokenfactory/change-admin",
    toAmino: tokenfactory_v1beta1_tx.MsgChangeAdmin.toAmino,
    fromAmino: tokenfactory_v1beta1_tx.MsgChangeAdmin.fromAmino
  },
  "/osmosis.tokenfactory.v1beta1.MsgSetDenomMetadata": {
    aminoType: "osmosis/tokenfactory/set-denom-metadata",
    toAmino: tokenfactory_v1beta1_tx.MsgSetDenomMetadata.toAmino,
    fromAmino: tokenfactory_v1beta1_tx.MsgSetDenomMetadata.fromAmino
  },
  "/osmosis.tokenfactory.v1beta1.MsgSetBeforeSendHook": {
    aminoType: "osmosis/tokenfactory/set-before-send-hook",
    toAmino: tokenfactory_v1beta1_tx.MsgSetBeforeSendHook.toAmino,
    fromAmino: tokenfactory_v1beta1_tx.MsgSetBeforeSendHook.fromAmino
  },
  "/osmosis.tokenfactory.v1beta1.MsgForceTransfer": {
    aminoType: "osmosis/tokenfactory/force-transfer",
    toAmino: tokenfactory_v1beta1_tx.MsgForceTransfer.toAmino,
    fromAmino: tokenfactory_v1beta1_tx.MsgForceTransfer.fromAmino
  }
};
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/osmosis/valset-pref/v1beta1/tx.amino.js
//@ts-nocheck

const valset_pref_v1beta1_tx_amino_AminoConverter = {
  "/osmosis.valsetpref.v1beta1.MsgSetValidatorSetPreference": {
    aminoType: "osmosis/valset-pref/MsgSetValidatorSetPreference",
    toAmino: valset_pref_v1beta1_tx.MsgSetValidatorSetPreference.toAmino,
    fromAmino: valset_pref_v1beta1_tx.MsgSetValidatorSetPreference.fromAmino
  },
  "/osmosis.valsetpref.v1beta1.MsgDelegateToValidatorSet": {
    aminoType: "osmosis/valset-pref/MsgDelegateToValidatorSet",
    toAmino: valset_pref_v1beta1_tx.MsgDelegateToValidatorSet.toAmino,
    fromAmino: valset_pref_v1beta1_tx.MsgDelegateToValidatorSet.fromAmino
  },
  "/osmosis.valsetpref.v1beta1.MsgUndelegateFromValidatorSet": {
    aminoType: "osmosis/valset-pref/MsgUndelegateFromValidatorSet",
    toAmino: valset_pref_v1beta1_tx.MsgUndelegateFromValidatorSet.toAmino,
    fromAmino: valset_pref_v1beta1_tx.MsgUndelegateFromValidatorSet.fromAmino
  },
  "/osmosis.valsetpref.v1beta1.MsgRedelegateValidatorSet": {
    aminoType: "osmosis/valsetpref/redelegate-validator-set",
    toAmino: valset_pref_v1beta1_tx.MsgRedelegateValidatorSet.toAmino,
    fromAmino: valset_pref_v1beta1_tx.MsgRedelegateValidatorSet.fromAmino
  },
  "/osmosis.valsetpref.v1beta1.MsgWithdrawDelegationRewards": {
    aminoType: "osmosis/valset-pref/MsgWithdrawDelegationRewards",
    toAmino: valset_pref_v1beta1_tx.MsgWithdrawDelegationRewards.toAmino,
    fromAmino: valset_pref_v1beta1_tx.MsgWithdrawDelegationRewards.fromAmino
  },
  "/osmosis.valsetpref.v1beta1.MsgDelegateBondedTokens": {
    aminoType: "osmosis/valsetpref/delegate-bonded-tokens",
    toAmino: valset_pref_v1beta1_tx.MsgDelegateBondedTokens.toAmino,
    fromAmino: valset_pref_v1beta1_tx.MsgDelegateBondedTokens.fromAmino
  }
};
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/osmosis/gamm/pool-models/balancer/tx/tx.registry.js
//@ts-nocheck

const tx_tx_registry_registry = [["/osmosis.gamm.poolmodels.balancer.v1beta1.MsgCreateBalancerPool", tx_tx.MsgCreateBalancerPool]];
const tx_tx_registry_load = protoRegistry => {
  tx_tx_registry_registry.forEach(([typeUrl, mod]) => {
    protoRegistry.register(typeUrl, mod);
  });
};
const tx_tx_registry_MessageComposer = {
  encoded: {
    createBalancerPool(value) {
      return {
        typeUrl: "/osmosis.gamm.poolmodels.balancer.v1beta1.MsgCreateBalancerPool",
        value: tx_tx.MsgCreateBalancerPool.encode(value).finish()
      };
    }

  },
  withTypeUrl: {
    createBalancerPool(value) {
      return {
        typeUrl: "/osmosis.gamm.poolmodels.balancer.v1beta1.MsgCreateBalancerPool",
        value
      };
    }

  },
  fromPartial: {
    createBalancerPool(value) {
      return {
        typeUrl: "/osmosis.gamm.poolmodels.balancer.v1beta1.MsgCreateBalancerPool",
        value: tx_tx.MsgCreateBalancerPool.fromPartial(value)
      };
    }

  }
};
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/osmosis/gamm/pool-models/stableswap/tx.registry.js
//@ts-nocheck

const stableswap_tx_registry_registry = [["/osmosis.gamm.poolmodels.stableswap.v1beta1.MsgCreateStableswapPool", stableswap_tx.MsgCreateStableswapPool], ["/osmosis.gamm.poolmodels.stableswap.v1beta1.MsgStableSwapAdjustScalingFactors", stableswap_tx.MsgStableSwapAdjustScalingFactors]];
const stableswap_tx_registry_load = protoRegistry => {
  stableswap_tx_registry_registry.forEach(([typeUrl, mod]) => {
    protoRegistry.register(typeUrl, mod);
  });
};
const stableswap_tx_registry_MessageComposer = {
  encoded: {
    createStableswapPool(value) {
      return {
        typeUrl: "/osmosis.gamm.poolmodels.stableswap.v1beta1.MsgCreateStableswapPool",
        value: stableswap_tx.MsgCreateStableswapPool.encode(value).finish()
      };
    },

    stableSwapAdjustScalingFactors(value) {
      return {
        typeUrl: "/osmosis.gamm.poolmodels.stableswap.v1beta1.MsgStableSwapAdjustScalingFactors",
        value: stableswap_tx.MsgStableSwapAdjustScalingFactors.encode(value).finish()
      };
    }

  },
  withTypeUrl: {
    createStableswapPool(value) {
      return {
        typeUrl: "/osmosis.gamm.poolmodels.stableswap.v1beta1.MsgCreateStableswapPool",
        value
      };
    },

    stableSwapAdjustScalingFactors(value) {
      return {
        typeUrl: "/osmosis.gamm.poolmodels.stableswap.v1beta1.MsgStableSwapAdjustScalingFactors",
        value
      };
    }

  },
  fromPartial: {
    createStableswapPool(value) {
      return {
        typeUrl: "/osmosis.gamm.poolmodels.stableswap.v1beta1.MsgCreateStableswapPool",
        value: stableswap_tx.MsgCreateStableswapPool.fromPartial(value)
      };
    },

    stableSwapAdjustScalingFactors(value) {
      return {
        typeUrl: "/osmosis.gamm.poolmodels.stableswap.v1beta1.MsgStableSwapAdjustScalingFactors",
        value: stableswap_tx.MsgStableSwapAdjustScalingFactors.fromPartial(value)
      };
    }

  }
};
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/osmosis/gamm/v1beta1/tx.registry.js
//@ts-nocheck

const gamm_v1beta1_tx_registry_registry = [["/osmosis.gamm.v1beta1.MsgJoinPool", gamm_v1beta1_tx.MsgJoinPool], ["/osmosis.gamm.v1beta1.MsgExitPool", gamm_v1beta1_tx.MsgExitPool], ["/osmosis.gamm.v1beta1.MsgSwapExactAmountIn", gamm_v1beta1_tx.MsgSwapExactAmountIn], ["/osmosis.gamm.v1beta1.MsgSwapExactAmountOut", gamm_v1beta1_tx.MsgSwapExactAmountOut], ["/osmosis.gamm.v1beta1.MsgJoinSwapExternAmountIn", gamm_v1beta1_tx.MsgJoinSwapExternAmountIn], ["/osmosis.gamm.v1beta1.MsgJoinSwapShareAmountOut", gamm_v1beta1_tx.MsgJoinSwapShareAmountOut], ["/osmosis.gamm.v1beta1.MsgExitSwapExternAmountOut", gamm_v1beta1_tx.MsgExitSwapExternAmountOut], ["/osmosis.gamm.v1beta1.MsgExitSwapShareAmountIn", gamm_v1beta1_tx.MsgExitSwapShareAmountIn]];
const gamm_v1beta1_tx_registry_load = protoRegistry => {
  gamm_v1beta1_tx_registry_registry.forEach(([typeUrl, mod]) => {
    protoRegistry.register(typeUrl, mod);
  });
};
const gamm_v1beta1_tx_registry_MessageComposer = {
  encoded: {
    joinPool(value) {
      return {
        typeUrl: "/osmosis.gamm.v1beta1.MsgJoinPool",
        value: gamm_v1beta1_tx.MsgJoinPool.encode(value).finish()
      };
    },

    exitPool(value) {
      return {
        typeUrl: "/osmosis.gamm.v1beta1.MsgExitPool",
        value: gamm_v1beta1_tx.MsgExitPool.encode(value).finish()
      };
    },

    swapExactAmountIn(value) {
      return {
        typeUrl: "/osmosis.gamm.v1beta1.MsgSwapExactAmountIn",
        value: gamm_v1beta1_tx.MsgSwapExactAmountIn.encode(value).finish()
      };
    },

    swapExactAmountOut(value) {
      return {
        typeUrl: "/osmosis.gamm.v1beta1.MsgSwapExactAmountOut",
        value: gamm_v1beta1_tx.MsgSwapExactAmountOut.encode(value).finish()
      };
    },

    joinSwapExternAmountIn(value) {
      return {
        typeUrl: "/osmosis.gamm.v1beta1.MsgJoinSwapExternAmountIn",
        value: gamm_v1beta1_tx.MsgJoinSwapExternAmountIn.encode(value).finish()
      };
    },

    joinSwapShareAmountOut(value) {
      return {
        typeUrl: "/osmosis.gamm.v1beta1.MsgJoinSwapShareAmountOut",
        value: gamm_v1beta1_tx.MsgJoinSwapShareAmountOut.encode(value).finish()
      };
    },

    exitSwapExternAmountOut(value) {
      return {
        typeUrl: "/osmosis.gamm.v1beta1.MsgExitSwapExternAmountOut",
        value: gamm_v1beta1_tx.MsgExitSwapExternAmountOut.encode(value).finish()
      };
    },

    exitSwapShareAmountIn(value) {
      return {
        typeUrl: "/osmosis.gamm.v1beta1.MsgExitSwapShareAmountIn",
        value: gamm_v1beta1_tx.MsgExitSwapShareAmountIn.encode(value).finish()
      };
    }

  },
  withTypeUrl: {
    joinPool(value) {
      return {
        typeUrl: "/osmosis.gamm.v1beta1.MsgJoinPool",
        value
      };
    },

    exitPool(value) {
      return {
        typeUrl: "/osmosis.gamm.v1beta1.MsgExitPool",
        value
      };
    },

    swapExactAmountIn(value) {
      return {
        typeUrl: "/osmosis.gamm.v1beta1.MsgSwapExactAmountIn",
        value
      };
    },

    swapExactAmountOut(value) {
      return {
        typeUrl: "/osmosis.gamm.v1beta1.MsgSwapExactAmountOut",
        value
      };
    },

    joinSwapExternAmountIn(value) {
      return {
        typeUrl: "/osmosis.gamm.v1beta1.MsgJoinSwapExternAmountIn",
        value
      };
    },

    joinSwapShareAmountOut(value) {
      return {
        typeUrl: "/osmosis.gamm.v1beta1.MsgJoinSwapShareAmountOut",
        value
      };
    },

    exitSwapExternAmountOut(value) {
      return {
        typeUrl: "/osmosis.gamm.v1beta1.MsgExitSwapExternAmountOut",
        value
      };
    },

    exitSwapShareAmountIn(value) {
      return {
        typeUrl: "/osmosis.gamm.v1beta1.MsgExitSwapShareAmountIn",
        value
      };
    }

  },
  fromPartial: {
    joinPool(value) {
      return {
        typeUrl: "/osmosis.gamm.v1beta1.MsgJoinPool",
        value: gamm_v1beta1_tx.MsgJoinPool.fromPartial(value)
      };
    },

    exitPool(value) {
      return {
        typeUrl: "/osmosis.gamm.v1beta1.MsgExitPool",
        value: gamm_v1beta1_tx.MsgExitPool.fromPartial(value)
      };
    },

    swapExactAmountIn(value) {
      return {
        typeUrl: "/osmosis.gamm.v1beta1.MsgSwapExactAmountIn",
        value: gamm_v1beta1_tx.MsgSwapExactAmountIn.fromPartial(value)
      };
    },

    swapExactAmountOut(value) {
      return {
        typeUrl: "/osmosis.gamm.v1beta1.MsgSwapExactAmountOut",
        value: gamm_v1beta1_tx.MsgSwapExactAmountOut.fromPartial(value)
      };
    },

    joinSwapExternAmountIn(value) {
      return {
        typeUrl: "/osmosis.gamm.v1beta1.MsgJoinSwapExternAmountIn",
        value: gamm_v1beta1_tx.MsgJoinSwapExternAmountIn.fromPartial(value)
      };
    },

    joinSwapShareAmountOut(value) {
      return {
        typeUrl: "/osmosis.gamm.v1beta1.MsgJoinSwapShareAmountOut",
        value: gamm_v1beta1_tx.MsgJoinSwapShareAmountOut.fromPartial(value)
      };
    },

    exitSwapExternAmountOut(value) {
      return {
        typeUrl: "/osmosis.gamm.v1beta1.MsgExitSwapExternAmountOut",
        value: gamm_v1beta1_tx.MsgExitSwapExternAmountOut.fromPartial(value)
      };
    },

    exitSwapShareAmountIn(value) {
      return {
        typeUrl: "/osmosis.gamm.v1beta1.MsgExitSwapShareAmountIn",
        value: gamm_v1beta1_tx.MsgExitSwapShareAmountIn.fromPartial(value)
      };
    }

  }
};
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/osmosis/incentives/tx.registry.js
//@ts-nocheck

const incentives_tx_registry_registry = [["/osmosis.incentives.MsgCreateGauge", incentives_tx.MsgCreateGauge], ["/osmosis.incentives.MsgAddToGauge", incentives_tx.MsgAddToGauge]];
const incentives_tx_registry_load = protoRegistry => {
  incentives_tx_registry_registry.forEach(([typeUrl, mod]) => {
    protoRegistry.register(typeUrl, mod);
  });
};
const incentives_tx_registry_MessageComposer = {
  encoded: {
    createGauge(value) {
      return {
        typeUrl: "/osmosis.incentives.MsgCreateGauge",
        value: incentives_tx.MsgCreateGauge.encode(value).finish()
      };
    },

    addToGauge(value) {
      return {
        typeUrl: "/osmosis.incentives.MsgAddToGauge",
        value: incentives_tx.MsgAddToGauge.encode(value).finish()
      };
    }

  },
  withTypeUrl: {
    createGauge(value) {
      return {
        typeUrl: "/osmosis.incentives.MsgCreateGauge",
        value
      };
    },

    addToGauge(value) {
      return {
        typeUrl: "/osmosis.incentives.MsgAddToGauge",
        value
      };
    }

  },
  fromPartial: {
    createGauge(value) {
      return {
        typeUrl: "/osmosis.incentives.MsgCreateGauge",
        value: incentives_tx.MsgCreateGauge.fromPartial(value)
      };
    },

    addToGauge(value) {
      return {
        typeUrl: "/osmosis.incentives.MsgAddToGauge",
        value: incentives_tx.MsgAddToGauge.fromPartial(value)
      };
    }

  }
};
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/osmosis/lockup/tx.registry.js
//@ts-nocheck

const lockup_tx_registry_registry = [["/osmosis.lockup.MsgLockTokens", lockup_tx.MsgLockTokens], ["/osmosis.lockup.MsgBeginUnlockingAll", lockup_tx.MsgBeginUnlockingAll], ["/osmosis.lockup.MsgBeginUnlocking", lockup_tx.MsgBeginUnlocking], ["/osmosis.lockup.MsgExtendLockup", lockup_tx.MsgExtendLockup], ["/osmosis.lockup.MsgForceUnlock", lockup_tx.MsgForceUnlock], ["/osmosis.lockup.MsgSetRewardReceiverAddress", lockup_tx.MsgSetRewardReceiverAddress]];
const lockup_tx_registry_load = protoRegistry => {
  lockup_tx_registry_registry.forEach(([typeUrl, mod]) => {
    protoRegistry.register(typeUrl, mod);
  });
};
const lockup_tx_registry_MessageComposer = {
  encoded: {
    lockTokens(value) {
      return {
        typeUrl: "/osmosis.lockup.MsgLockTokens",
        value: lockup_tx.MsgLockTokens.encode(value).finish()
      };
    },

    beginUnlockingAll(value) {
      return {
        typeUrl: "/osmosis.lockup.MsgBeginUnlockingAll",
        value: lockup_tx.MsgBeginUnlockingAll.encode(value).finish()
      };
    },

    beginUnlocking(value) {
      return {
        typeUrl: "/osmosis.lockup.MsgBeginUnlocking",
        value: lockup_tx.MsgBeginUnlocking.encode(value).finish()
      };
    },

    extendLockup(value) {
      return {
        typeUrl: "/osmosis.lockup.MsgExtendLockup",
        value: lockup_tx.MsgExtendLockup.encode(value).finish()
      };
    },

    forceUnlock(value) {
      return {
        typeUrl: "/osmosis.lockup.MsgForceUnlock",
        value: lockup_tx.MsgForceUnlock.encode(value).finish()
      };
    },

    setRewardReceiverAddress(value) {
      return {
        typeUrl: "/osmosis.lockup.MsgSetRewardReceiverAddress",
        value: lockup_tx.MsgSetRewardReceiverAddress.encode(value).finish()
      };
    }

  },
  withTypeUrl: {
    lockTokens(value) {
      return {
        typeUrl: "/osmosis.lockup.MsgLockTokens",
        value
      };
    },

    beginUnlockingAll(value) {
      return {
        typeUrl: "/osmosis.lockup.MsgBeginUnlockingAll",
        value
      };
    },

    beginUnlocking(value) {
      return {
        typeUrl: "/osmosis.lockup.MsgBeginUnlocking",
        value
      };
    },

    extendLockup(value) {
      return {
        typeUrl: "/osmosis.lockup.MsgExtendLockup",
        value
      };
    },

    forceUnlock(value) {
      return {
        typeUrl: "/osmosis.lockup.MsgForceUnlock",
        value
      };
    },

    setRewardReceiverAddress(value) {
      return {
        typeUrl: "/osmosis.lockup.MsgSetRewardReceiverAddress",
        value
      };
    }

  },
  fromPartial: {
    lockTokens(value) {
      return {
        typeUrl: "/osmosis.lockup.MsgLockTokens",
        value: lockup_tx.MsgLockTokens.fromPartial(value)
      };
    },

    beginUnlockingAll(value) {
      return {
        typeUrl: "/osmosis.lockup.MsgBeginUnlockingAll",
        value: lockup_tx.MsgBeginUnlockingAll.fromPartial(value)
      };
    },

    beginUnlocking(value) {
      return {
        typeUrl: "/osmosis.lockup.MsgBeginUnlocking",
        value: lockup_tx.MsgBeginUnlocking.fromPartial(value)
      };
    },

    extendLockup(value) {
      return {
        typeUrl: "/osmosis.lockup.MsgExtendLockup",
        value: lockup_tx.MsgExtendLockup.fromPartial(value)
      };
    },

    forceUnlock(value) {
      return {
        typeUrl: "/osmosis.lockup.MsgForceUnlock",
        value: lockup_tx.MsgForceUnlock.fromPartial(value)
      };
    },

    setRewardReceiverAddress(value) {
      return {
        typeUrl: "/osmosis.lockup.MsgSetRewardReceiverAddress",
        value: lockup_tx.MsgSetRewardReceiverAddress.fromPartial(value)
      };
    }

  }
};
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/osmosis/poolmanager/v1beta1/tx.registry.js
//@ts-nocheck

const poolmanager_v1beta1_tx_registry_registry = [["/osmosis.poolmanager.v1beta1.MsgSwapExactAmountIn", poolmanager_v1beta1_tx.MsgSwapExactAmountIn], ["/osmosis.poolmanager.v1beta1.MsgSwapExactAmountOut", poolmanager_v1beta1_tx.MsgSwapExactAmountOut], ["/osmosis.poolmanager.v1beta1.MsgSplitRouteSwapExactAmountIn", poolmanager_v1beta1_tx.MsgSplitRouteSwapExactAmountIn], ["/osmosis.poolmanager.v1beta1.MsgSplitRouteSwapExactAmountOut", poolmanager_v1beta1_tx.MsgSplitRouteSwapExactAmountOut]];
const poolmanager_v1beta1_tx_registry_load = protoRegistry => {
  poolmanager_v1beta1_tx_registry_registry.forEach(([typeUrl, mod]) => {
    protoRegistry.register(typeUrl, mod);
  });
};
const poolmanager_v1beta1_tx_registry_MessageComposer = {
  encoded: {
    swapExactAmountIn(value) {
      return {
        typeUrl: "/osmosis.poolmanager.v1beta1.MsgSwapExactAmountIn",
        value: poolmanager_v1beta1_tx.MsgSwapExactAmountIn.encode(value).finish()
      };
    },

    swapExactAmountOut(value) {
      return {
        typeUrl: "/osmosis.poolmanager.v1beta1.MsgSwapExactAmountOut",
        value: poolmanager_v1beta1_tx.MsgSwapExactAmountOut.encode(value).finish()
      };
    },

    splitRouteSwapExactAmountIn(value) {
      return {
        typeUrl: "/osmosis.poolmanager.v1beta1.MsgSplitRouteSwapExactAmountIn",
        value: poolmanager_v1beta1_tx.MsgSplitRouteSwapExactAmountIn.encode(value).finish()
      };
    },

    splitRouteSwapExactAmountOut(value) {
      return {
        typeUrl: "/osmosis.poolmanager.v1beta1.MsgSplitRouteSwapExactAmountOut",
        value: poolmanager_v1beta1_tx.MsgSplitRouteSwapExactAmountOut.encode(value).finish()
      };
    }

  },
  withTypeUrl: {
    swapExactAmountIn(value) {
      return {
        typeUrl: "/osmosis.poolmanager.v1beta1.MsgSwapExactAmountIn",
        value
      };
    },

    swapExactAmountOut(value) {
      return {
        typeUrl: "/osmosis.poolmanager.v1beta1.MsgSwapExactAmountOut",
        value
      };
    },

    splitRouteSwapExactAmountIn(value) {
      return {
        typeUrl: "/osmosis.poolmanager.v1beta1.MsgSplitRouteSwapExactAmountIn",
        value
      };
    },

    splitRouteSwapExactAmountOut(value) {
      return {
        typeUrl: "/osmosis.poolmanager.v1beta1.MsgSplitRouteSwapExactAmountOut",
        value
      };
    }

  },
  fromPartial: {
    swapExactAmountIn(value) {
      return {
        typeUrl: "/osmosis.poolmanager.v1beta1.MsgSwapExactAmountIn",
        value: poolmanager_v1beta1_tx.MsgSwapExactAmountIn.fromPartial(value)
      };
    },

    swapExactAmountOut(value) {
      return {
        typeUrl: "/osmosis.poolmanager.v1beta1.MsgSwapExactAmountOut",
        value: poolmanager_v1beta1_tx.MsgSwapExactAmountOut.fromPartial(value)
      };
    },

    splitRouteSwapExactAmountIn(value) {
      return {
        typeUrl: "/osmosis.poolmanager.v1beta1.MsgSplitRouteSwapExactAmountIn",
        value: poolmanager_v1beta1_tx.MsgSplitRouteSwapExactAmountIn.fromPartial(value)
      };
    },

    splitRouteSwapExactAmountOut(value) {
      return {
        typeUrl: "/osmosis.poolmanager.v1beta1.MsgSplitRouteSwapExactAmountOut",
        value: poolmanager_v1beta1_tx.MsgSplitRouteSwapExactAmountOut.fromPartial(value)
      };
    }

  }
};
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/osmosis/protorev/v1beta1/tx.registry.js
//@ts-nocheck

const protorev_v1beta1_tx_registry_registry = [["/osmosis.protorev.v1beta1.MsgSetHotRoutes", protorev_v1beta1_tx.MsgSetHotRoutes], ["/osmosis.protorev.v1beta1.MsgSetDeveloperAccount", protorev_v1beta1_tx.MsgSetDeveloperAccount], ["/osmosis.protorev.v1beta1.MsgSetMaxPoolPointsPerTx", protorev_v1beta1_tx.MsgSetMaxPoolPointsPerTx], ["/osmosis.protorev.v1beta1.MsgSetMaxPoolPointsPerBlock", protorev_v1beta1_tx.MsgSetMaxPoolPointsPerBlock], ["/osmosis.protorev.v1beta1.MsgSetPoolWeights", protorev_v1beta1_tx.MsgSetPoolWeights], ["/osmosis.protorev.v1beta1.MsgSetBaseDenoms", protorev_v1beta1_tx.MsgSetBaseDenoms]];
const protorev_v1beta1_tx_registry_load = protoRegistry => {
  protorev_v1beta1_tx_registry_registry.forEach(([typeUrl, mod]) => {
    protoRegistry.register(typeUrl, mod);
  });
};
const protorev_v1beta1_tx_registry_MessageComposer = {
  encoded: {
    setHotRoutes(value) {
      return {
        typeUrl: "/osmosis.protorev.v1beta1.MsgSetHotRoutes",
        value: protorev_v1beta1_tx.MsgSetHotRoutes.encode(value).finish()
      };
    },

    setDeveloperAccount(value) {
      return {
        typeUrl: "/osmosis.protorev.v1beta1.MsgSetDeveloperAccount",
        value: protorev_v1beta1_tx.MsgSetDeveloperAccount.encode(value).finish()
      };
    },

    setMaxPoolPointsPerTx(value) {
      return {
        typeUrl: "/osmosis.protorev.v1beta1.MsgSetMaxPoolPointsPerTx",
        value: protorev_v1beta1_tx.MsgSetMaxPoolPointsPerTx.encode(value).finish()
      };
    },

    setMaxPoolPointsPerBlock(value) {
      return {
        typeUrl: "/osmosis.protorev.v1beta1.MsgSetMaxPoolPointsPerBlock",
        value: protorev_v1beta1_tx.MsgSetMaxPoolPointsPerBlock.encode(value).finish()
      };
    },

    setPoolWeights(value) {
      return {
        typeUrl: "/osmosis.protorev.v1beta1.MsgSetPoolWeights",
        value: protorev_v1beta1_tx.MsgSetPoolWeights.encode(value).finish()
      };
    },

    setBaseDenoms(value) {
      return {
        typeUrl: "/osmosis.protorev.v1beta1.MsgSetBaseDenoms",
        value: protorev_v1beta1_tx.MsgSetBaseDenoms.encode(value).finish()
      };
    }

  },
  withTypeUrl: {
    setHotRoutes(value) {
      return {
        typeUrl: "/osmosis.protorev.v1beta1.MsgSetHotRoutes",
        value
      };
    },

    setDeveloperAccount(value) {
      return {
        typeUrl: "/osmosis.protorev.v1beta1.MsgSetDeveloperAccount",
        value
      };
    },

    setMaxPoolPointsPerTx(value) {
      return {
        typeUrl: "/osmosis.protorev.v1beta1.MsgSetMaxPoolPointsPerTx",
        value
      };
    },

    setMaxPoolPointsPerBlock(value) {
      return {
        typeUrl: "/osmosis.protorev.v1beta1.MsgSetMaxPoolPointsPerBlock",
        value
      };
    },

    setPoolWeights(value) {
      return {
        typeUrl: "/osmosis.protorev.v1beta1.MsgSetPoolWeights",
        value
      };
    },

    setBaseDenoms(value) {
      return {
        typeUrl: "/osmosis.protorev.v1beta1.MsgSetBaseDenoms",
        value
      };
    }

  },
  fromPartial: {
    setHotRoutes(value) {
      return {
        typeUrl: "/osmosis.protorev.v1beta1.MsgSetHotRoutes",
        value: protorev_v1beta1_tx.MsgSetHotRoutes.fromPartial(value)
      };
    },

    setDeveloperAccount(value) {
      return {
        typeUrl: "/osmosis.protorev.v1beta1.MsgSetDeveloperAccount",
        value: protorev_v1beta1_tx.MsgSetDeveloperAccount.fromPartial(value)
      };
    },

    setMaxPoolPointsPerTx(value) {
      return {
        typeUrl: "/osmosis.protorev.v1beta1.MsgSetMaxPoolPointsPerTx",
        value: protorev_v1beta1_tx.MsgSetMaxPoolPointsPerTx.fromPartial(value)
      };
    },

    setMaxPoolPointsPerBlock(value) {
      return {
        typeUrl: "/osmosis.protorev.v1beta1.MsgSetMaxPoolPointsPerBlock",
        value: protorev_v1beta1_tx.MsgSetMaxPoolPointsPerBlock.fromPartial(value)
      };
    },

    setPoolWeights(value) {
      return {
        typeUrl: "/osmosis.protorev.v1beta1.MsgSetPoolWeights",
        value: protorev_v1beta1_tx.MsgSetPoolWeights.fromPartial(value)
      };
    },

    setBaseDenoms(value) {
      return {
        typeUrl: "/osmosis.protorev.v1beta1.MsgSetBaseDenoms",
        value: protorev_v1beta1_tx.MsgSetBaseDenoms.fromPartial(value)
      };
    }

  }
};
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/osmosis/superfluid/tx.registry.js
//@ts-nocheck

const superfluid_tx_registry_registry = [["/osmosis.superfluid.MsgSuperfluidDelegate", superfluid_tx.MsgSuperfluidDelegate], ["/osmosis.superfluid.MsgSuperfluidUndelegate", superfluid_tx.MsgSuperfluidUndelegate], ["/osmosis.superfluid.MsgSuperfluidUnbondLock", superfluid_tx.MsgSuperfluidUnbondLock], ["/osmosis.superfluid.MsgSuperfluidUndelegateAndUnbondLock", superfluid_tx.MsgSuperfluidUndelegateAndUnbondLock], ["/osmosis.superfluid.MsgLockAndSuperfluidDelegate", superfluid_tx.MsgLockAndSuperfluidDelegate], ["/osmosis.superfluid.MsgCreateFullRangePositionAndSuperfluidDelegate", superfluid_tx.MsgCreateFullRangePositionAndSuperfluidDelegate], ["/osmosis.superfluid.MsgUnPoolWhitelistedPool", superfluid_tx.MsgUnPoolWhitelistedPool], ["/osmosis.superfluid.MsgUnlockAndMigrateSharesToFullRangeConcentratedPosition", superfluid_tx.MsgUnlockAndMigrateSharesToFullRangeConcentratedPosition], ["/osmosis.superfluid.MsgAddToConcentratedLiquiditySuperfluidPosition", superfluid_tx.MsgAddToConcentratedLiquiditySuperfluidPosition]];
const superfluid_tx_registry_load = protoRegistry => {
  superfluid_tx_registry_registry.forEach(([typeUrl, mod]) => {
    protoRegistry.register(typeUrl, mod);
  });
};
const superfluid_tx_registry_MessageComposer = {
  encoded: {
    superfluidDelegate(value) {
      return {
        typeUrl: "/osmosis.superfluid.MsgSuperfluidDelegate",
        value: superfluid_tx.MsgSuperfluidDelegate.encode(value).finish()
      };
    },

    superfluidUndelegate(value) {
      return {
        typeUrl: "/osmosis.superfluid.MsgSuperfluidUndelegate",
        value: superfluid_tx.MsgSuperfluidUndelegate.encode(value).finish()
      };
    },

    superfluidUnbondLock(value) {
      return {
        typeUrl: "/osmosis.superfluid.MsgSuperfluidUnbondLock",
        value: superfluid_tx.MsgSuperfluidUnbondLock.encode(value).finish()
      };
    },

    superfluidUndelegateAndUnbondLock(value) {
      return {
        typeUrl: "/osmosis.superfluid.MsgSuperfluidUndelegateAndUnbondLock",
        value: superfluid_tx.MsgSuperfluidUndelegateAndUnbondLock.encode(value).finish()
      };
    },

    lockAndSuperfluidDelegate(value) {
      return {
        typeUrl: "/osmosis.superfluid.MsgLockAndSuperfluidDelegate",
        value: superfluid_tx.MsgLockAndSuperfluidDelegate.encode(value).finish()
      };
    },

    createFullRangePositionAndSuperfluidDelegate(value) {
      return {
        typeUrl: "/osmosis.superfluid.MsgCreateFullRangePositionAndSuperfluidDelegate",
        value: superfluid_tx.MsgCreateFullRangePositionAndSuperfluidDelegate.encode(value).finish()
      };
    },

    unPoolWhitelistedPool(value) {
      return {
        typeUrl: "/osmosis.superfluid.MsgUnPoolWhitelistedPool",
        value: superfluid_tx.MsgUnPoolWhitelistedPool.encode(value).finish()
      };
    },

    unlockAndMigrateSharesToFullRangeConcentratedPosition(value) {
      return {
        typeUrl: "/osmosis.superfluid.MsgUnlockAndMigrateSharesToFullRangeConcentratedPosition",
        value: superfluid_tx.MsgUnlockAndMigrateSharesToFullRangeConcentratedPosition.encode(value).finish()
      };
    },

    addToConcentratedLiquiditySuperfluidPosition(value) {
      return {
        typeUrl: "/osmosis.superfluid.MsgAddToConcentratedLiquiditySuperfluidPosition",
        value: superfluid_tx.MsgAddToConcentratedLiquiditySuperfluidPosition.encode(value).finish()
      };
    }

  },
  withTypeUrl: {
    superfluidDelegate(value) {
      return {
        typeUrl: "/osmosis.superfluid.MsgSuperfluidDelegate",
        value
      };
    },

    superfluidUndelegate(value) {
      return {
        typeUrl: "/osmosis.superfluid.MsgSuperfluidUndelegate",
        value
      };
    },

    superfluidUnbondLock(value) {
      return {
        typeUrl: "/osmosis.superfluid.MsgSuperfluidUnbondLock",
        value
      };
    },

    superfluidUndelegateAndUnbondLock(value) {
      return {
        typeUrl: "/osmosis.superfluid.MsgSuperfluidUndelegateAndUnbondLock",
        value
      };
    },

    lockAndSuperfluidDelegate(value) {
      return {
        typeUrl: "/osmosis.superfluid.MsgLockAndSuperfluidDelegate",
        value
      };
    },

    createFullRangePositionAndSuperfluidDelegate(value) {
      return {
        typeUrl: "/osmosis.superfluid.MsgCreateFullRangePositionAndSuperfluidDelegate",
        value
      };
    },

    unPoolWhitelistedPool(value) {
      return {
        typeUrl: "/osmosis.superfluid.MsgUnPoolWhitelistedPool",
        value
      };
    },

    unlockAndMigrateSharesToFullRangeConcentratedPosition(value) {
      return {
        typeUrl: "/osmosis.superfluid.MsgUnlockAndMigrateSharesToFullRangeConcentratedPosition",
        value
      };
    },

    addToConcentratedLiquiditySuperfluidPosition(value) {
      return {
        typeUrl: "/osmosis.superfluid.MsgAddToConcentratedLiquiditySuperfluidPosition",
        value
      };
    }

  },
  fromPartial: {
    superfluidDelegate(value) {
      return {
        typeUrl: "/osmosis.superfluid.MsgSuperfluidDelegate",
        value: superfluid_tx.MsgSuperfluidDelegate.fromPartial(value)
      };
    },

    superfluidUndelegate(value) {
      return {
        typeUrl: "/osmosis.superfluid.MsgSuperfluidUndelegate",
        value: superfluid_tx.MsgSuperfluidUndelegate.fromPartial(value)
      };
    },

    superfluidUnbondLock(value) {
      return {
        typeUrl: "/osmosis.superfluid.MsgSuperfluidUnbondLock",
        value: superfluid_tx.MsgSuperfluidUnbondLock.fromPartial(value)
      };
    },

    superfluidUndelegateAndUnbondLock(value) {
      return {
        typeUrl: "/osmosis.superfluid.MsgSuperfluidUndelegateAndUnbondLock",
        value: superfluid_tx.MsgSuperfluidUndelegateAndUnbondLock.fromPartial(value)
      };
    },

    lockAndSuperfluidDelegate(value) {
      return {
        typeUrl: "/osmosis.superfluid.MsgLockAndSuperfluidDelegate",
        value: superfluid_tx.MsgLockAndSuperfluidDelegate.fromPartial(value)
      };
    },

    createFullRangePositionAndSuperfluidDelegate(value) {
      return {
        typeUrl: "/osmosis.superfluid.MsgCreateFullRangePositionAndSuperfluidDelegate",
        value: superfluid_tx.MsgCreateFullRangePositionAndSuperfluidDelegate.fromPartial(value)
      };
    },

    unPoolWhitelistedPool(value) {
      return {
        typeUrl: "/osmosis.superfluid.MsgUnPoolWhitelistedPool",
        value: superfluid_tx.MsgUnPoolWhitelistedPool.fromPartial(value)
      };
    },

    unlockAndMigrateSharesToFullRangeConcentratedPosition(value) {
      return {
        typeUrl: "/osmosis.superfluid.MsgUnlockAndMigrateSharesToFullRangeConcentratedPosition",
        value: superfluid_tx.MsgUnlockAndMigrateSharesToFullRangeConcentratedPosition.fromPartial(value)
      };
    },

    addToConcentratedLiquiditySuperfluidPosition(value) {
      return {
        typeUrl: "/osmosis.superfluid.MsgAddToConcentratedLiquiditySuperfluidPosition",
        value: superfluid_tx.MsgAddToConcentratedLiquiditySuperfluidPosition.fromPartial(value)
      };
    }

  }
};
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/osmosis/tokenfactory/v1beta1/tx.registry.js
//@ts-nocheck

const tokenfactory_v1beta1_tx_registry_registry = [["/osmosis.tokenfactory.v1beta1.MsgCreateDenom", tokenfactory_v1beta1_tx.MsgCreateDenom], ["/osmosis.tokenfactory.v1beta1.MsgMint", tokenfactory_v1beta1_tx.MsgMint], ["/osmosis.tokenfactory.v1beta1.MsgBurn", tokenfactory_v1beta1_tx.MsgBurn], ["/osmosis.tokenfactory.v1beta1.MsgChangeAdmin", tokenfactory_v1beta1_tx.MsgChangeAdmin], ["/osmosis.tokenfactory.v1beta1.MsgSetDenomMetadata", tokenfactory_v1beta1_tx.MsgSetDenomMetadata], ["/osmosis.tokenfactory.v1beta1.MsgSetBeforeSendHook", tokenfactory_v1beta1_tx.MsgSetBeforeSendHook], ["/osmosis.tokenfactory.v1beta1.MsgForceTransfer", tokenfactory_v1beta1_tx.MsgForceTransfer]];
const tokenfactory_v1beta1_tx_registry_load = protoRegistry => {
  tokenfactory_v1beta1_tx_registry_registry.forEach(([typeUrl, mod]) => {
    protoRegistry.register(typeUrl, mod);
  });
};
const tokenfactory_v1beta1_tx_registry_MessageComposer = {
  encoded: {
    createDenom(value) {
      return {
        typeUrl: "/osmosis.tokenfactory.v1beta1.MsgCreateDenom",
        value: tokenfactory_v1beta1_tx.MsgCreateDenom.encode(value).finish()
      };
    },

    mint(value) {
      return {
        typeUrl: "/osmosis.tokenfactory.v1beta1.MsgMint",
        value: tokenfactory_v1beta1_tx.MsgMint.encode(value).finish()
      };
    },

    burn(value) {
      return {
        typeUrl: "/osmosis.tokenfactory.v1beta1.MsgBurn",
        value: tokenfactory_v1beta1_tx.MsgBurn.encode(value).finish()
      };
    },

    changeAdmin(value) {
      return {
        typeUrl: "/osmosis.tokenfactory.v1beta1.MsgChangeAdmin",
        value: tokenfactory_v1beta1_tx.MsgChangeAdmin.encode(value).finish()
      };
    },

    setDenomMetadata(value) {
      return {
        typeUrl: "/osmosis.tokenfactory.v1beta1.MsgSetDenomMetadata",
        value: tokenfactory_v1beta1_tx.MsgSetDenomMetadata.encode(value).finish()
      };
    },

    setBeforeSendHook(value) {
      return {
        typeUrl: "/osmosis.tokenfactory.v1beta1.MsgSetBeforeSendHook",
        value: tokenfactory_v1beta1_tx.MsgSetBeforeSendHook.encode(value).finish()
      };
    },

    forceTransfer(value) {
      return {
        typeUrl: "/osmosis.tokenfactory.v1beta1.MsgForceTransfer",
        value: tokenfactory_v1beta1_tx.MsgForceTransfer.encode(value).finish()
      };
    }

  },
  withTypeUrl: {
    createDenom(value) {
      return {
        typeUrl: "/osmosis.tokenfactory.v1beta1.MsgCreateDenom",
        value
      };
    },

    mint(value) {
      return {
        typeUrl: "/osmosis.tokenfactory.v1beta1.MsgMint",
        value
      };
    },

    burn(value) {
      return {
        typeUrl: "/osmosis.tokenfactory.v1beta1.MsgBurn",
        value
      };
    },

    changeAdmin(value) {
      return {
        typeUrl: "/osmosis.tokenfactory.v1beta1.MsgChangeAdmin",
        value
      };
    },

    setDenomMetadata(value) {
      return {
        typeUrl: "/osmosis.tokenfactory.v1beta1.MsgSetDenomMetadata",
        value
      };
    },

    setBeforeSendHook(value) {
      return {
        typeUrl: "/osmosis.tokenfactory.v1beta1.MsgSetBeforeSendHook",
        value
      };
    },

    forceTransfer(value) {
      return {
        typeUrl: "/osmosis.tokenfactory.v1beta1.MsgForceTransfer",
        value
      };
    }

  },
  fromPartial: {
    createDenom(value) {
      return {
        typeUrl: "/osmosis.tokenfactory.v1beta1.MsgCreateDenom",
        value: tokenfactory_v1beta1_tx.MsgCreateDenom.fromPartial(value)
      };
    },

    mint(value) {
      return {
        typeUrl: "/osmosis.tokenfactory.v1beta1.MsgMint",
        value: tokenfactory_v1beta1_tx.MsgMint.fromPartial(value)
      };
    },

    burn(value) {
      return {
        typeUrl: "/osmosis.tokenfactory.v1beta1.MsgBurn",
        value: tokenfactory_v1beta1_tx.MsgBurn.fromPartial(value)
      };
    },

    changeAdmin(value) {
      return {
        typeUrl: "/osmosis.tokenfactory.v1beta1.MsgChangeAdmin",
        value: tokenfactory_v1beta1_tx.MsgChangeAdmin.fromPartial(value)
      };
    },

    setDenomMetadata(value) {
      return {
        typeUrl: "/osmosis.tokenfactory.v1beta1.MsgSetDenomMetadata",
        value: tokenfactory_v1beta1_tx.MsgSetDenomMetadata.fromPartial(value)
      };
    },

    setBeforeSendHook(value) {
      return {
        typeUrl: "/osmosis.tokenfactory.v1beta1.MsgSetBeforeSendHook",
        value: tokenfactory_v1beta1_tx.MsgSetBeforeSendHook.fromPartial(value)
      };
    },

    forceTransfer(value) {
      return {
        typeUrl: "/osmosis.tokenfactory.v1beta1.MsgForceTransfer",
        value: tokenfactory_v1beta1_tx.MsgForceTransfer.fromPartial(value)
      };
    }

  }
};
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/osmosis/valset-pref/v1beta1/tx.registry.js
//@ts-nocheck

const valset_pref_v1beta1_tx_registry_registry = [["/osmosis.valsetpref.v1beta1.MsgSetValidatorSetPreference", valset_pref_v1beta1_tx.MsgSetValidatorSetPreference], ["/osmosis.valsetpref.v1beta1.MsgDelegateToValidatorSet", valset_pref_v1beta1_tx.MsgDelegateToValidatorSet], ["/osmosis.valsetpref.v1beta1.MsgUndelegateFromValidatorSet", valset_pref_v1beta1_tx.MsgUndelegateFromValidatorSet], ["/osmosis.valsetpref.v1beta1.MsgRedelegateValidatorSet", valset_pref_v1beta1_tx.MsgRedelegateValidatorSet], ["/osmosis.valsetpref.v1beta1.MsgWithdrawDelegationRewards", valset_pref_v1beta1_tx.MsgWithdrawDelegationRewards], ["/osmosis.valsetpref.v1beta1.MsgDelegateBondedTokens", valset_pref_v1beta1_tx.MsgDelegateBondedTokens]];
const valset_pref_v1beta1_tx_registry_load = protoRegistry => {
  valset_pref_v1beta1_tx_registry_registry.forEach(([typeUrl, mod]) => {
    protoRegistry.register(typeUrl, mod);
  });
};
const valset_pref_v1beta1_tx_registry_MessageComposer = {
  encoded: {
    setValidatorSetPreference(value) {
      return {
        typeUrl: "/osmosis.valsetpref.v1beta1.MsgSetValidatorSetPreference",
        value: valset_pref_v1beta1_tx.MsgSetValidatorSetPreference.encode(value).finish()
      };
    },

    delegateToValidatorSet(value) {
      return {
        typeUrl: "/osmosis.valsetpref.v1beta1.MsgDelegateToValidatorSet",
        value: valset_pref_v1beta1_tx.MsgDelegateToValidatorSet.encode(value).finish()
      };
    },

    undelegateFromValidatorSet(value) {
      return {
        typeUrl: "/osmosis.valsetpref.v1beta1.MsgUndelegateFromValidatorSet",
        value: valset_pref_v1beta1_tx.MsgUndelegateFromValidatorSet.encode(value).finish()
      };
    },

    redelegateValidatorSet(value) {
      return {
        typeUrl: "/osmosis.valsetpref.v1beta1.MsgRedelegateValidatorSet",
        value: valset_pref_v1beta1_tx.MsgRedelegateValidatorSet.encode(value).finish()
      };
    },

    withdrawDelegationRewards(value) {
      return {
        typeUrl: "/osmosis.valsetpref.v1beta1.MsgWithdrawDelegationRewards",
        value: valset_pref_v1beta1_tx.MsgWithdrawDelegationRewards.encode(value).finish()
      };
    },

    delegateBondedTokens(value) {
      return {
        typeUrl: "/osmosis.valsetpref.v1beta1.MsgDelegateBondedTokens",
        value: valset_pref_v1beta1_tx.MsgDelegateBondedTokens.encode(value).finish()
      };
    }

  },
  withTypeUrl: {
    setValidatorSetPreference(value) {
      return {
        typeUrl: "/osmosis.valsetpref.v1beta1.MsgSetValidatorSetPreference",
        value
      };
    },

    delegateToValidatorSet(value) {
      return {
        typeUrl: "/osmosis.valsetpref.v1beta1.MsgDelegateToValidatorSet",
        value
      };
    },

    undelegateFromValidatorSet(value) {
      return {
        typeUrl: "/osmosis.valsetpref.v1beta1.MsgUndelegateFromValidatorSet",
        value
      };
    },

    redelegateValidatorSet(value) {
      return {
        typeUrl: "/osmosis.valsetpref.v1beta1.MsgRedelegateValidatorSet",
        value
      };
    },

    withdrawDelegationRewards(value) {
      return {
        typeUrl: "/osmosis.valsetpref.v1beta1.MsgWithdrawDelegationRewards",
        value
      };
    },

    delegateBondedTokens(value) {
      return {
        typeUrl: "/osmosis.valsetpref.v1beta1.MsgDelegateBondedTokens",
        value
      };
    }

  },
  fromPartial: {
    setValidatorSetPreference(value) {
      return {
        typeUrl: "/osmosis.valsetpref.v1beta1.MsgSetValidatorSetPreference",
        value: valset_pref_v1beta1_tx.MsgSetValidatorSetPreference.fromPartial(value)
      };
    },

    delegateToValidatorSet(value) {
      return {
        typeUrl: "/osmosis.valsetpref.v1beta1.MsgDelegateToValidatorSet",
        value: valset_pref_v1beta1_tx.MsgDelegateToValidatorSet.fromPartial(value)
      };
    },

    undelegateFromValidatorSet(value) {
      return {
        typeUrl: "/osmosis.valsetpref.v1beta1.MsgUndelegateFromValidatorSet",
        value: valset_pref_v1beta1_tx.MsgUndelegateFromValidatorSet.fromPartial(value)
      };
    },

    redelegateValidatorSet(value) {
      return {
        typeUrl: "/osmosis.valsetpref.v1beta1.MsgRedelegateValidatorSet",
        value: valset_pref_v1beta1_tx.MsgRedelegateValidatorSet.fromPartial(value)
      };
    },

    withdrawDelegationRewards(value) {
      return {
        typeUrl: "/osmosis.valsetpref.v1beta1.MsgWithdrawDelegationRewards",
        value: valset_pref_v1beta1_tx.MsgWithdrawDelegationRewards.fromPartial(value)
      };
    },

    delegateBondedTokens(value) {
      return {
        typeUrl: "/osmosis.valsetpref.v1beta1.MsgDelegateBondedTokens",
        value: valset_pref_v1beta1_tx.MsgDelegateBondedTokens.fromPartial(value)
      };
    }

  }
};
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/osmosis/cosmwasmpool/v1beta1/query.lcd.js
var cosmwasmpool_v1beta1_query_lcd = __webpack_require__(53193);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/osmosis/downtime-detector/v1beta1/query.lcd.js
var downtime_detector_v1beta1_query_lcd = __webpack_require__(90377);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/osmosis/epochs/query.lcd.js
var epochs_query_lcd = __webpack_require__(35305);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/osmosis/gamm/v1beta1/query.lcd.js
var gamm_v1beta1_query_lcd = __webpack_require__(62743);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/osmosis/gamm/v2/query.lcd.js
var v2_query_lcd = __webpack_require__(44507);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/osmosis/ibc-rate-limit/v1beta1/query.lcd.js
var ibc_rate_limit_v1beta1_query_lcd = __webpack_require__(37545);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/osmosis/incentives/query.lcd.js
var incentives_query_lcd = __webpack_require__(29265);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/osmosis/lockup/query.lcd.js
var lockup_query_lcd = __webpack_require__(78268);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/osmosis/mint/v1beta1/query.lcd.js
var mint_v1beta1_query_lcd = __webpack_require__(81867);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/osmosis/pool-incentives/v1beta1/query.lcd.js
var pool_incentives_v1beta1_query_lcd = __webpack_require__(57788);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/osmosis/poolmanager/v1beta1/query.lcd.js
var poolmanager_v1beta1_query_lcd = __webpack_require__(19909);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/osmosis/protorev/v1beta1/query.lcd.js
var protorev_v1beta1_query_lcd = __webpack_require__(48281);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/osmosis/superfluid/query.lcd.js
var superfluid_query_lcd = __webpack_require__(59893);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/osmosis/tokenfactory/v1beta1/query.lcd.js
var tokenfactory_v1beta1_query_lcd = __webpack_require__(12262);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/osmosis/twap/v1beta1/query.lcd.js
var twap_v1beta1_query_lcd = __webpack_require__(37302);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/osmosis/txfees/v1beta1/query.lcd.js
var txfees_v1beta1_query_lcd = __webpack_require__(82419);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/osmosis/valset-pref/v1beta1/query.lcd.js
var valset_pref_v1beta1_query_lcd = __webpack_require__(62188);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/osmosis/cosmwasmpool/v1beta1/query.rpc.Query.js
var cosmwasmpool_v1beta1_query_rpc_Query = __webpack_require__(61887);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/osmosis/downtime-detector/v1beta1/query.rpc.Query.js
var downtime_detector_v1beta1_query_rpc_Query = __webpack_require__(59173);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/osmosis/epochs/query.rpc.Query.js
var epochs_query_rpc_Query = __webpack_require__(69163);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/osmosis/gamm/v1beta1/query.rpc.Query.js
var gamm_v1beta1_query_rpc_Query = __webpack_require__(47198);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/osmosis/gamm/v2/query.rpc.Query.js
var v2_query_rpc_Query = __webpack_require__(8329);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/osmosis/ibc-rate-limit/v1beta1/query.rpc.Query.js
var ibc_rate_limit_v1beta1_query_rpc_Query = __webpack_require__(9804);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/osmosis/incentives/query.rpc.Query.js
var incentives_query_rpc_Query = __webpack_require__(39088);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/osmosis/lockup/query.rpc.Query.js
var lockup_query_rpc_Query = __webpack_require__(17525);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/osmosis/mint/v1beta1/query.rpc.Query.js
var mint_v1beta1_query_rpc_Query = __webpack_require__(9992);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/osmosis/pool-incentives/v1beta1/query.rpc.Query.js
var pool_incentives_v1beta1_query_rpc_Query = __webpack_require__(80709);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/osmosis/poolmanager/v1beta1/query.rpc.Query.js
var poolmanager_v1beta1_query_rpc_Query = __webpack_require__(58373);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/osmosis/protorev/v1beta1/query.rpc.Query.js
var protorev_v1beta1_query_rpc_Query = __webpack_require__(78133);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/osmosis/superfluid/query.rpc.Query.js
var superfluid_query_rpc_Query = __webpack_require__(66977);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/osmosis/tokenfactory/v1beta1/query.rpc.Query.js
var tokenfactory_v1beta1_query_rpc_Query = __webpack_require__(46066);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/osmosis/twap/v1beta1/query.rpc.Query.js
var twap_v1beta1_query_rpc_Query = __webpack_require__(126);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/osmosis/txfees/v1beta1/query.rpc.Query.js
var txfees_v1beta1_query_rpc_Query = __webpack_require__(72241);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/osmosis/valset-pref/v1beta1/query.rpc.Query.js
var valset_pref_v1beta1_query_rpc_Query = __webpack_require__(10926);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/osmosis/gamm/pool-models/balancer/tx/tx.rpc.msg.js
var tx_tx_rpc_msg = __webpack_require__(62360);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/osmosis/gamm/pool-models/stableswap/tx.rpc.msg.js
var stableswap_tx_rpc_msg = __webpack_require__(37343);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/osmosis/gamm/v1beta1/tx.rpc.msg.js
var gamm_v1beta1_tx_rpc_msg = __webpack_require__(89713);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/osmosis/incentives/tx.rpc.msg.js
var incentives_tx_rpc_msg = __webpack_require__(30521);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/osmosis/lockup/tx.rpc.msg.js
var lockup_tx_rpc_msg = __webpack_require__(49168);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/osmosis/poolmanager/v1beta1/tx.rpc.msg.js
var poolmanager_v1beta1_tx_rpc_msg = __webpack_require__(71571);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/osmosis/protorev/v1beta1/tx.rpc.msg.js
var protorev_v1beta1_tx_rpc_msg = __webpack_require__(19304);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/osmosis/superfluid/tx.rpc.msg.js
var superfluid_tx_rpc_msg = __webpack_require__(37883);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/osmosis/tokenfactory/v1beta1/tx.rpc.msg.js
var tokenfactory_v1beta1_tx_rpc_msg = __webpack_require__(88301);
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/osmosis/valset-pref/v1beta1/tx.rpc.msg.js
var valset_pref_v1beta1_tx_rpc_msg = __webpack_require__(48718);
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/osmosis/lcd.js

const osmosis_lcd_createLCDClient = async ({
  restEndpoint
}) => {
  const requestClient = new LCDClient({
    restEndpoint
  });
  return {
    cosmos: {
      auth: {
        v1beta1: new (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 88436))).LCDQueryClient({
          requestClient
        })
      },
      authz: {
        v1beta1: new (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 73300))).LCDQueryClient({
          requestClient
        })
      },
      bank: {
        v1beta1: new (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 79926))).LCDQueryClient({
          requestClient
        })
      },
      base: {
        node: {
          v1beta1: new (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 91318))).LCDQueryClient({
            requestClient
          })
        }
      },
      distribution: {
        v1beta1: new (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 39))).LCDQueryClient({
          requestClient
        })
      },
      gov: {
        v1beta1: new (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 3571))).LCDQueryClient({
          requestClient
        })
      },
      staking: {
        v1beta1: new (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 24800))).LCDQueryClient({
          requestClient
        })
      },
      tx: {
        v1beta1: new (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 57994))).LCDQueryClient({
          requestClient
        })
      },
      upgrade: {
        v1beta1: new (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 67931))).LCDQueryClient({
          requestClient
        })
      }
    },
    osmosis: {
      concentratedliquidity: {
        v1beta1: new (await __webpack_require__.e(/* import() */ 3506).then(__webpack_require__.bind(__webpack_require__, 63506))).LCDQueryClient({
          requestClient
        })
      },
      cosmwasmpool: {
        v1beta1: new (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 53193))).LCDQueryClient({
          requestClient
        })
      },
      downtimedetector: {
        v1beta1: new (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 90377))).LCDQueryClient({
          requestClient
        })
      },
      epochs: {
        v1beta1: new (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 35305))).LCDQueryClient({
          requestClient
        })
      },
      gamm: {
        v1beta1: new (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 62743))).LCDQueryClient({
          requestClient
        }),
        v2: new (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 44507))).LCDQueryClient({
          requestClient
        })
      },
      ibcratelimit: {
        v1beta1: new (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 37545))).LCDQueryClient({
          requestClient
        })
      },
      incentives: new (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 29265))).LCDQueryClient({
        requestClient
      }),
      lockup: new (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 78268))).LCDQueryClient({
        requestClient
      }),
      mint: {
        v1beta1: new (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 81867))).LCDQueryClient({
          requestClient
        })
      },
      poolincentives: {
        v1beta1: new (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 57788))).LCDQueryClient({
          requestClient
        })
      },
      poolmanager: {
        v1beta1: new (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 19909))).LCDQueryClient({
          requestClient
        })
      },
      protorev: {
        v1beta1: new (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 48281))).LCDQueryClient({
          requestClient
        })
      },
      superfluid: new (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 59893))).LCDQueryClient({
        requestClient
      }),
      tokenfactory: {
        v1beta1: new (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 12262))).LCDQueryClient({
          requestClient
        })
      },
      twap: {
        v1beta1: new (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 37302))).LCDQueryClient({
          requestClient
        })
      },
      txfees: {
        v1beta1: new (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 82419))).LCDQueryClient({
          requestClient
        })
      },
      valsetpref: {
        v1beta1: new (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 62188))).LCDQueryClient({
          requestClient
        })
      }
    }
  };
};
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/osmosis/rpc.query.js


const osmosis_rpc_query_createRPCQueryClient = async ({
  rpcEndpoint
}) => {
  const tmClient = await build.Tendermint34Client.connect(rpcEndpoint);
  const client = new stargate_build.QueryClient(tmClient);
  return {
    cosmos: {
      auth: {
        v1beta1: (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 80908))).createRpcQueryExtension(client)
      },
      authz: {
        v1beta1: (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 64139))).createRpcQueryExtension(client)
      },
      bank: {
        v1beta1: (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 3889))).createRpcQueryExtension(client)
      },
      base: {
        node: {
          v1beta1: (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 12345))).createRpcQueryExtension(client)
        }
      },
      distribution: {
        v1beta1: (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 23727))).createRpcQueryExtension(client)
      },
      gov: {
        v1beta1: (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 96921))).createRpcQueryExtension(client)
      },
      staking: {
        v1beta1: (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 56860))).createRpcQueryExtension(client)
      },
      tx: {
        v1beta1: (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 82478))).createRpcQueryExtension(client)
      },
      upgrade: {
        v1beta1: (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 94898))).createRpcQueryExtension(client)
      }
    },
    osmosis: {
      concentratedliquidity: {
        v1beta1: (await __webpack_require__.e(/* import() */ 7360).then(__webpack_require__.bind(__webpack_require__, 87360))).createRpcQueryExtension(client)
      },
      cosmwasmpool: {
        v1beta1: (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 61887))).createRpcQueryExtension(client)
      },
      downtimedetector: {
        v1beta1: (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 59173))).createRpcQueryExtension(client)
      },
      epochs: {
        v1beta1: (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 69163))).createRpcQueryExtension(client)
      },
      gamm: {
        v1beta1: (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 47198))).createRpcQueryExtension(client),
        v2: (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 8329))).createRpcQueryExtension(client)
      },
      ibcratelimit: {
        v1beta1: (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 9804))).createRpcQueryExtension(client)
      },
      incentives: (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 39088))).createRpcQueryExtension(client),
      lockup: (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 17525))).createRpcQueryExtension(client),
      mint: {
        v1beta1: (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 9992))).createRpcQueryExtension(client)
      },
      poolincentives: {
        v1beta1: (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 80709))).createRpcQueryExtension(client)
      },
      poolmanager: {
        v1beta1: (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 58373))).createRpcQueryExtension(client)
      },
      protorev: {
        v1beta1: (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 78133))).createRpcQueryExtension(client)
      },
      superfluid: (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 66977))).createRpcQueryExtension(client),
      tokenfactory: {
        v1beta1: (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 46066))).createRpcQueryExtension(client)
      },
      twap: {
        v1beta1: (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 126))).createRpcQueryExtension(client)
      },
      txfees: {
        v1beta1: (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 72241))).createRpcQueryExtension(client)
      },
      valsetpref: {
        v1beta1: (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 10926))).createRpcQueryExtension(client)
      }
    }
  };
};
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/osmosis/rpc.tx.js
const osmosis_rpc_tx_createRPCMsgClient = async ({
  rpc
}) => ({
  cosmos: {
    authz: {
      v1beta1: new (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 35773))).MsgClientImpl(rpc)
    },
    bank: {
      v1beta1: new (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 85579))).MsgClientImpl(rpc)
    },
    distribution: {
      v1beta1: new (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 9689))).MsgClientImpl(rpc)
    },
    gov: {
      v1beta1: new (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 3207))).MsgClientImpl(rpc)
    },
    staking: {
      v1beta1: new (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 34191))).MsgClientImpl(rpc)
    }
  },
  osmosis: {
    concentratedliquidity: {
      poolmodel: {
        concentrated: {
          v1beta1: new (await __webpack_require__.e(/* import() */ 7980).then(__webpack_require__.bind(__webpack_require__, 77980))).MsgClientImpl(rpc)
        }
      },
      v1beta1: new (await __webpack_require__.e(/* import() */ 9126).then(__webpack_require__.bind(__webpack_require__, 99126))).MsgClientImpl(rpc)
    },
    gamm: {
      poolmodels: {
        balancer: {
          v1beta1: new (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 62360))).MsgClientImpl(rpc)
        },
        stableswap: {
          v1beta1: new (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 37343))).MsgClientImpl(rpc)
        }
      },
      v1beta1: new (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 89713))).MsgClientImpl(rpc)
    },
    incentives: new (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 30521))).MsgClientImpl(rpc),
    lockup: new (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 49168))).MsgClientImpl(rpc),
    poolmanager: {
      v1beta1: new (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 71571))).MsgClientImpl(rpc)
    },
    protorev: {
      v1beta1: new (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 19304))).MsgClientImpl(rpc)
    },
    superfluid: new (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 37883))).MsgClientImpl(rpc),
    tokenfactory: {
      v1beta1: new (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 88301))).MsgClientImpl(rpc)
    },
    valsetpref: {
      v1beta1: new (await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 48718))).MsgClientImpl(rpc)
    }
  }
});
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/osmosis/bundle.js


function osmosis_bundle_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function osmosis_bundle_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? osmosis_bundle_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : osmosis_bundle_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




















































































































































let osmosis;

(function (_osmosis) {
  let accum;

  (function (_accum) {
    const v1beta1 = _accum.v1beta1 = osmosis_bundle_objectSpread({}, accum_namespaceObject);
  })(accum || (accum = _osmosis.accum || (_osmosis.accum = {})));

  const concentratedliquidity = _osmosis.concentratedliquidity = osmosis_bundle_objectSpread({}, concentrated_liquidity_params);

  let cosmwasmpool;

  (function (_cosmwasmpool) {
    const v1beta1 = _cosmwasmpool.v1beta1 = osmosis_bundle_objectSpread(osmosis_bundle_objectSpread(osmosis_bundle_objectSpread(osmosis_bundle_objectSpread(osmosis_bundle_objectSpread(osmosis_bundle_objectSpread(osmosis_bundle_objectSpread(osmosis_bundle_objectSpread(osmosis_bundle_objectSpread(osmosis_bundle_objectSpread(osmosis_bundle_objectSpread(osmosis_bundle_objectSpread(osmosis_bundle_objectSpread(osmosis_bundle_objectSpread({}, cosmwasmpool_v1beta1_genesis_namespaceObject), gov_namespaceObject), instantiate_msg_namespaceObject), module_query_msg_namespaceObject), module_sudo_msg_namespaceObject), pool_query_msg_namespaceObject), pool), transmuter_msgs_namespaceObject), tx_namespaceObject), v1beta1_params), cosmwasmpool_v1beta1_query), v1beta1_tx_namespaceObject), cosmwasmpool_v1beta1_query_lcd), cosmwasmpool_v1beta1_query_rpc_Query);
  })(cosmwasmpool || (cosmwasmpool = _osmosis.cosmwasmpool || (_osmosis.cosmwasmpool = {})));

  let downtimedetector;

  (function (_downtimedetector) {
    const v1beta1 = _downtimedetector.v1beta1 = osmosis_bundle_objectSpread(osmosis_bundle_objectSpread(osmosis_bundle_objectSpread(osmosis_bundle_objectSpread(osmosis_bundle_objectSpread({}, downtime_duration), downtime_detector_v1beta1_genesis_namespaceObject), downtime_detector_v1beta1_query), downtime_detector_v1beta1_query_lcd), downtime_detector_v1beta1_query_rpc_Query);
  })(downtimedetector || (downtimedetector = _osmosis.downtimedetector || (_osmosis.downtimedetector = {})));

  let epochs;

  (function (_epochs) {
    const v1beta1 = _epochs.v1beta1 = osmosis_bundle_objectSpread(osmosis_bundle_objectSpread(osmosis_bundle_objectSpread(osmosis_bundle_objectSpread({}, epochs_genesis), epochs_query), epochs_query_lcd), epochs_query_rpc_Query);
  })(epochs || (epochs = _osmosis.epochs || (_osmosis.epochs = {})));

  let gamm;

  (function (_gamm) {
    const v1beta1 = _gamm.v1beta1 = osmosis_bundle_objectSpread(osmosis_bundle_objectSpread(osmosis_bundle_objectSpread(osmosis_bundle_objectSpread(osmosis_bundle_objectSpread(osmosis_bundle_objectSpread(osmosis_bundle_objectSpread(osmosis_bundle_objectSpread(osmosis_bundle_objectSpread(osmosis_bundle_objectSpread({}, balancerPool), gamm_v1beta1_genesis_namespaceObject), v1beta1_gov_namespaceObject), gamm_v1beta1_query), gamm_v1beta1_tx), gamm_v1beta1_tx_amino_namespaceObject), gamm_v1beta1_tx_registry_namespaceObject), gamm_v1beta1_query_lcd), gamm_v1beta1_query_rpc_Query), gamm_v1beta1_tx_rpc_msg);

    let poolmodels;

    (function (_poolmodels) {
      let balancer;

      (function (_balancer) {
        const v1beta1 = _balancer.v1beta1 = osmosis_bundle_objectSpread(osmosis_bundle_objectSpread(osmosis_bundle_objectSpread(osmosis_bundle_objectSpread({}, tx_tx), tx_tx_amino_namespaceObject), tx_tx_registry_namespaceObject), tx_tx_rpc_msg);
      })(balancer || (balancer = _poolmodels.balancer || (_poolmodels.balancer = {})));

      let stableswap;

      (function (_stableswap) {
        const v1beta1 = _stableswap.v1beta1 = osmosis_bundle_objectSpread(osmosis_bundle_objectSpread(osmosis_bundle_objectSpread(osmosis_bundle_objectSpread(osmosis_bundle_objectSpread({}, stableswap_pool), stableswap_tx), stableswap_tx_amino_namespaceObject), stableswap_tx_registry_namespaceObject), stableswap_tx_rpc_msg);
      })(stableswap || (stableswap = _poolmodels.stableswap || (_poolmodels.stableswap = {})));
    })(poolmodels || (poolmodels = _gamm.poolmodels || (_gamm.poolmodels = {})));

    const v2 = _gamm.v2 = osmosis_bundle_objectSpread(osmosis_bundle_objectSpread(osmosis_bundle_objectSpread({}, v2_query), v2_query_lcd), v2_query_rpc_Query);
  })(gamm || (gamm = _osmosis.gamm || (_osmosis.gamm = {})));

  let ibcratelimit;

  (function (_ibcratelimit) {
    const v1beta1 = _ibcratelimit.v1beta1 = osmosis_bundle_objectSpread(osmosis_bundle_objectSpread(osmosis_bundle_objectSpread(osmosis_bundle_objectSpread(osmosis_bundle_objectSpread({}, ibc_rate_limit_v1beta1_genesis_namespaceObject), ibc_rate_limit_v1beta1_params), ibc_rate_limit_v1beta1_query), ibc_rate_limit_v1beta1_query_lcd), ibc_rate_limit_v1beta1_query_rpc_Query);
  })(ibcratelimit || (ibcratelimit = _osmosis.ibcratelimit || (_osmosis.ibcratelimit = {})));

  const incentives = _osmosis.incentives = osmosis_bundle_objectSpread(osmosis_bundle_objectSpread(osmosis_bundle_objectSpread(osmosis_bundle_objectSpread(osmosis_bundle_objectSpread(osmosis_bundle_objectSpread(osmosis_bundle_objectSpread(osmosis_bundle_objectSpread(osmosis_bundle_objectSpread(osmosis_bundle_objectSpread({}, gauge), incentives_genesis_namespaceObject), params_namespaceObject), incentives_query), incentives_tx), incentives_tx_amino_namespaceObject), incentives_tx_registry_namespaceObject), incentives_query_lcd), incentives_query_rpc_Query), incentives_tx_rpc_msg);

  const lockup = _osmosis.lockup = osmosis_bundle_objectSpread(osmosis_bundle_objectSpread(osmosis_bundle_objectSpread(osmosis_bundle_objectSpread(osmosis_bundle_objectSpread(osmosis_bundle_objectSpread(osmosis_bundle_objectSpread(osmosis_bundle_objectSpread(osmosis_bundle_objectSpread(osmosis_bundle_objectSpread({}, lockup_genesis_namespaceObject), lock), lockup_params), lockup_query), lockup_tx), lockup_tx_amino_namespaceObject), lockup_tx_registry_namespaceObject), lockup_query_lcd), lockup_query_rpc_Query), lockup_tx_rpc_msg);

  let mint;

  (function (_mint) {
    const v1beta1 = _mint.v1beta1 = osmosis_bundle_objectSpread(osmosis_bundle_objectSpread(osmosis_bundle_objectSpread(osmosis_bundle_objectSpread(osmosis_bundle_objectSpread({}, mint_v1beta1_genesis_namespaceObject), v1beta1_mint), mint_v1beta1_query), mint_v1beta1_query_lcd), mint_v1beta1_query_rpc_Query);
  })(mint || (mint = _osmosis.mint || (_osmosis.mint = {})));

  let poolincentives;

  (function (_poolincentives) {
    const v1beta1 = _poolincentives.v1beta1 = osmosis_bundle_objectSpread(osmosis_bundle_objectSpread(osmosis_bundle_objectSpread(osmosis_bundle_objectSpread(osmosis_bundle_objectSpread(osmosis_bundle_objectSpread({}, pool_incentives_v1beta1_genesis_namespaceObject), pool_incentives_v1beta1_gov_namespaceObject), v1beta1_incentives), pool_incentives_v1beta1_query), pool_incentives_v1beta1_query_lcd), pool_incentives_v1beta1_query_rpc_Query);
  })(poolincentives || (poolincentives = _osmosis.poolincentives || (_osmosis.poolincentives = {})));

  let poolmanager;

  (function (_poolmanager) {
    const v1beta1 = _poolmanager.v1beta1 = osmosis_bundle_objectSpread(osmosis_bundle_objectSpread(osmosis_bundle_objectSpread(osmosis_bundle_objectSpread(osmosis_bundle_objectSpread(osmosis_bundle_objectSpread(osmosis_bundle_objectSpread(osmosis_bundle_objectSpread(osmosis_bundle_objectSpread(osmosis_bundle_objectSpread({}, v1beta1_genesis), module_route), poolmanager_v1beta1_query), swap_route), poolmanager_v1beta1_tx), poolmanager_v1beta1_tx_amino_namespaceObject), poolmanager_v1beta1_tx_registry_namespaceObject), poolmanager_v1beta1_query_lcd), poolmanager_v1beta1_query_rpc_Query), poolmanager_v1beta1_tx_rpc_msg);
  })(poolmanager || (poolmanager = _osmosis.poolmanager || (_osmosis.poolmanager = {})));

  let protorev;

  (function (_protorev) {
    const v1beta1 = _protorev.v1beta1 = osmosis_bundle_objectSpread(osmosis_bundle_objectSpread(osmosis_bundle_objectSpread(osmosis_bundle_objectSpread(osmosis_bundle_objectSpread(osmosis_bundle_objectSpread(osmosis_bundle_objectSpread(osmosis_bundle_objectSpread(osmosis_bundle_objectSpread(osmosis_bundle_objectSpread(osmosis_bundle_objectSpread({}, protorev_v1beta1_genesis_namespaceObject), protorev_v1beta1_gov_namespaceObject), protorev_v1beta1_params), v1beta1_protorev), protorev_v1beta1_query), protorev_v1beta1_tx), protorev_v1beta1_tx_amino_namespaceObject), protorev_v1beta1_tx_registry_namespaceObject), protorev_v1beta1_query_lcd), protorev_v1beta1_query_rpc_Query), protorev_v1beta1_tx_rpc_msg);
  })(protorev || (protorev = _osmosis.protorev || (_osmosis.protorev = {})));

  let store;

  (function (_store) {
    const v1beta1 = _store.v1beta1 = osmosis_bundle_objectSpread({}, tree_namespaceObject);
  })(store || (store = _osmosis.store || (_osmosis.store = {})));

  const superfluid = _osmosis.superfluid = osmosis_bundle_objectSpread(osmosis_bundle_objectSpread(osmosis_bundle_objectSpread(osmosis_bundle_objectSpread(osmosis_bundle_objectSpread(osmosis_bundle_objectSpread(osmosis_bundle_objectSpread(osmosis_bundle_objectSpread(osmosis_bundle_objectSpread(osmosis_bundle_objectSpread({}, superfluid_genesis_namespaceObject), superfluid_params), superfluid_query), superfluid_superfluid), superfluid_tx), superfluid_tx_amino_namespaceObject), superfluid_tx_registry_namespaceObject), superfluid_query_lcd), superfluid_query_rpc_Query), superfluid_tx_rpc_msg);

  let tokenfactory;

  (function (_tokenfactory) {
    const v1beta1 = _tokenfactory.v1beta1 = osmosis_bundle_objectSpread(osmosis_bundle_objectSpread(osmosis_bundle_objectSpread(osmosis_bundle_objectSpread(osmosis_bundle_objectSpread(osmosis_bundle_objectSpread(osmosis_bundle_objectSpread(osmosis_bundle_objectSpread(osmosis_bundle_objectSpread(osmosis_bundle_objectSpread({}, authorityMetadata), tokenfactory_v1beta1_genesis_namespaceObject), tokenfactory_v1beta1_params), tokenfactory_v1beta1_query), tokenfactory_v1beta1_tx), tokenfactory_v1beta1_tx_amino_namespaceObject), tokenfactory_v1beta1_tx_registry_namespaceObject), tokenfactory_v1beta1_query_lcd), tokenfactory_v1beta1_query_rpc_Query), tokenfactory_v1beta1_tx_rpc_msg);
  })(tokenfactory || (tokenfactory = _osmosis.tokenfactory || (_osmosis.tokenfactory = {})));

  let twap;

  (function (_twap) {
    const v1beta1 = _twap.v1beta1 = osmosis_bundle_objectSpread(osmosis_bundle_objectSpread(osmosis_bundle_objectSpread(osmosis_bundle_objectSpread(osmosis_bundle_objectSpread({}, twap_v1beta1_genesis), twap_v1beta1_query), twap_record), twap_v1beta1_query_lcd), twap_v1beta1_query_rpc_Query);
  })(twap || (twap = _osmosis.twap || (_osmosis.twap = {})));

  let txfees;

  (function (_txfees) {
    const v1beta1 = _txfees.v1beta1 = osmosis_bundle_objectSpread(osmosis_bundle_objectSpread(osmosis_bundle_objectSpread(osmosis_bundle_objectSpread(osmosis_bundle_objectSpread(osmosis_bundle_objectSpread({}, feetoken), txfees_v1beta1_genesis_namespaceObject), txfees_v1beta1_gov_namespaceObject), txfees_v1beta1_query), txfees_v1beta1_query_lcd), txfees_v1beta1_query_rpc_Query);
  })(txfees || (txfees = _osmosis.txfees || (_osmosis.txfees = {})));

  let valsetpref;

  (function (_valsetpref) {
    const v1beta1 = _valsetpref.v1beta1 = osmosis_bundle_objectSpread(osmosis_bundle_objectSpread(osmosis_bundle_objectSpread(osmosis_bundle_objectSpread(osmosis_bundle_objectSpread(osmosis_bundle_objectSpread(osmosis_bundle_objectSpread(osmosis_bundle_objectSpread({}, valset_pref_v1beta1_query), state), valset_pref_v1beta1_tx), valset_pref_v1beta1_tx_amino_namespaceObject), valset_pref_v1beta1_tx_registry_namespaceObject), valset_pref_v1beta1_query_lcd), valset_pref_v1beta1_query_rpc_Query), valset_pref_v1beta1_tx_rpc_msg);
  })(valsetpref || (valsetpref = _osmosis.valsetpref || (_osmosis.valsetpref = {})));

  const ClientFactory = _osmosis.ClientFactory = osmosis_bundle_objectSpread(osmosis_bundle_objectSpread(osmosis_bundle_objectSpread({}, osmosis_lcd_namespaceObject), osmosis_rpc_query_namespaceObject), osmosis_rpc_tx_namespaceObject);
})(osmosis || (osmosis = {}));
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/osmosis/concentrated-liquidity/pool-model/concentrated/tx.js
var concentrated_tx = __webpack_require__(37486);
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/osmosis/concentrated-liquidity/pool-model/concentrated/tx.registry.js
//@ts-nocheck

const concentrated_tx_registry_registry = [["/osmosis.concentratedliquidity.poolmodel.concentrated.v1beta1.MsgCreateConcentratedPool", concentrated_tx/* MsgCreateConcentratedPool */.S]];
const concentrated_tx_registry_load = protoRegistry => {
  concentrated_tx_registry_registry.forEach(([typeUrl, mod]) => {
    protoRegistry.register(typeUrl, mod);
  });
};
const concentrated_tx_registry_MessageComposer = {
  encoded: {
    createConcentratedPool(value) {
      return {
        typeUrl: "/osmosis.concentratedliquidity.poolmodel.concentrated.v1beta1.MsgCreateConcentratedPool",
        value: concentrated_tx/* MsgCreateConcentratedPool.encode */.S.encode(value).finish()
      };
    }

  },
  withTypeUrl: {
    createConcentratedPool(value) {
      return {
        typeUrl: "/osmosis.concentratedliquidity.poolmodel.concentrated.v1beta1.MsgCreateConcentratedPool",
        value
      };
    }

  },
  fromPartial: {
    createConcentratedPool(value) {
      return {
        typeUrl: "/osmosis.concentratedliquidity.poolmodel.concentrated.v1beta1.MsgCreateConcentratedPool",
        value: concentrated_tx/* MsgCreateConcentratedPool.fromPartial */.S.fromPartial(value)
      };
    }

  }
};
// EXTERNAL MODULE: ./node_modules/osmojs/module/codegen/osmosis/concentrated-liquidity/tx.js
var concentrated_liquidity_tx = __webpack_require__(8481);
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/osmosis/concentrated-liquidity/tx.registry.js
//@ts-nocheck

const concentrated_liquidity_tx_registry_registry = [["/osmosis.concentratedliquidity.v1beta1.MsgCreatePosition", concentrated_liquidity_tx/* MsgCreatePosition */.W5], ["/osmosis.concentratedliquidity.v1beta1.MsgWithdrawPosition", concentrated_liquidity_tx/* MsgWithdrawPosition */.Ar], ["/osmosis.concentratedliquidity.v1beta1.MsgAddToPosition", concentrated_liquidity_tx/* MsgAddToPosition */.Vg], ["/osmosis.concentratedliquidity.v1beta1.MsgCollectSpreadRewards", concentrated_liquidity_tx/* MsgCollectSpreadRewards */.gC], ["/osmosis.concentratedliquidity.v1beta1.MsgCollectIncentives", concentrated_liquidity_tx/* MsgCollectIncentives */.ON]];
const concentrated_liquidity_tx_registry_load = protoRegistry => {
  concentrated_liquidity_tx_registry_registry.forEach(([typeUrl, mod]) => {
    protoRegistry.register(typeUrl, mod);
  });
};
const concentrated_liquidity_tx_registry_MessageComposer = {
  encoded: {
    createPosition(value) {
      return {
        typeUrl: "/osmosis.concentratedliquidity.v1beta1.MsgCreatePosition",
        value: concentrated_liquidity_tx/* MsgCreatePosition.encode */.W5.encode(value).finish()
      };
    },

    withdrawPosition(value) {
      return {
        typeUrl: "/osmosis.concentratedliquidity.v1beta1.MsgWithdrawPosition",
        value: concentrated_liquidity_tx/* MsgWithdrawPosition.encode */.Ar.encode(value).finish()
      };
    },

    addToPosition(value) {
      return {
        typeUrl: "/osmosis.concentratedliquidity.v1beta1.MsgAddToPosition",
        value: concentrated_liquidity_tx/* MsgAddToPosition.encode */.Vg.encode(value).finish()
      };
    },

    collectSpreadRewards(value) {
      return {
        typeUrl: "/osmosis.concentratedliquidity.v1beta1.MsgCollectSpreadRewards",
        value: concentrated_liquidity_tx/* MsgCollectSpreadRewards.encode */.gC.encode(value).finish()
      };
    },

    collectIncentives(value) {
      return {
        typeUrl: "/osmosis.concentratedliquidity.v1beta1.MsgCollectIncentives",
        value: concentrated_liquidity_tx/* MsgCollectIncentives.encode */.ON.encode(value).finish()
      };
    }

  },
  withTypeUrl: {
    createPosition(value) {
      return {
        typeUrl: "/osmosis.concentratedliquidity.v1beta1.MsgCreatePosition",
        value
      };
    },

    withdrawPosition(value) {
      return {
        typeUrl: "/osmosis.concentratedliquidity.v1beta1.MsgWithdrawPosition",
        value
      };
    },

    addToPosition(value) {
      return {
        typeUrl: "/osmosis.concentratedliquidity.v1beta1.MsgAddToPosition",
        value
      };
    },

    collectSpreadRewards(value) {
      return {
        typeUrl: "/osmosis.concentratedliquidity.v1beta1.MsgCollectSpreadRewards",
        value
      };
    },

    collectIncentives(value) {
      return {
        typeUrl: "/osmosis.concentratedliquidity.v1beta1.MsgCollectIncentives",
        value
      };
    }

  },
  fromPartial: {
    createPosition(value) {
      return {
        typeUrl: "/osmosis.concentratedliquidity.v1beta1.MsgCreatePosition",
        value: concentrated_liquidity_tx/* MsgCreatePosition.fromPartial */.W5.fromPartial(value)
      };
    },

    withdrawPosition(value) {
      return {
        typeUrl: "/osmosis.concentratedliquidity.v1beta1.MsgWithdrawPosition",
        value: concentrated_liquidity_tx/* MsgWithdrawPosition.fromPartial */.Ar.fromPartial(value)
      };
    },

    addToPosition(value) {
      return {
        typeUrl: "/osmosis.concentratedliquidity.v1beta1.MsgAddToPosition",
        value: concentrated_liquidity_tx/* MsgAddToPosition.fromPartial */.Vg.fromPartial(value)
      };
    },

    collectSpreadRewards(value) {
      return {
        typeUrl: "/osmosis.concentratedliquidity.v1beta1.MsgCollectSpreadRewards",
        value: concentrated_liquidity_tx/* MsgCollectSpreadRewards.fromPartial */.gC.fromPartial(value)
      };
    },

    collectIncentives(value) {
      return {
        typeUrl: "/osmosis.concentratedliquidity.v1beta1.MsgCollectIncentives",
        value: concentrated_liquidity_tx/* MsgCollectIncentives.fromPartial */.ON.fromPartial(value)
      };
    }

  }
};
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/osmosis/concentrated-liquidity/pool-model/concentrated/tx.amino.js
//@ts-nocheck

const concentrated_tx_amino_AminoConverter = {
  "/osmosis.concentratedliquidity.poolmodel.concentrated.v1beta1.MsgCreateConcentratedPool": {
    aminoType: "osmosis/concentratedliquidity/poolmodel/concentrated/create-concentrated-pool",
    toAmino: concentrated_tx/* MsgCreateConcentratedPool.toAmino */.S.toAmino,
    fromAmino: concentrated_tx/* MsgCreateConcentratedPool.fromAmino */.S.fromAmino
  }
};
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/osmosis/concentrated-liquidity/tx.amino.js
//@ts-nocheck

const concentrated_liquidity_tx_amino_AminoConverter = {
  "/osmosis.concentratedliquidity.v1beta1.MsgCreatePosition": {
    aminoType: "osmosis/concentratedliquidity/create-position",
    toAmino: concentrated_liquidity_tx/* MsgCreatePosition.toAmino */.W5.toAmino,
    fromAmino: concentrated_liquidity_tx/* MsgCreatePosition.fromAmino */.W5.fromAmino
  },
  "/osmosis.concentratedliquidity.v1beta1.MsgWithdrawPosition": {
    aminoType: "osmosis/concentratedliquidity/withdraw-position",
    toAmino: concentrated_liquidity_tx/* MsgWithdrawPosition.toAmino */.Ar.toAmino,
    fromAmino: concentrated_liquidity_tx/* MsgWithdrawPosition.fromAmino */.Ar.fromAmino
  },
  "/osmosis.concentratedliquidity.v1beta1.MsgAddToPosition": {
    aminoType: "osmosis/concentratedliquidity/add-to-position",
    toAmino: concentrated_liquidity_tx/* MsgAddToPosition.toAmino */.Vg.toAmino,
    fromAmino: concentrated_liquidity_tx/* MsgAddToPosition.fromAmino */.Vg.fromAmino
  },
  "/osmosis.concentratedliquidity.v1beta1.MsgCollectSpreadRewards": {
    aminoType: "osmosis/concentratedliquidity/collect-spread-rewards",
    toAmino: concentrated_liquidity_tx/* MsgCollectSpreadRewards.toAmino */.gC.toAmino,
    fromAmino: concentrated_liquidity_tx/* MsgCollectSpreadRewards.fromAmino */.gC.fromAmino
  },
  "/osmosis.concentratedliquidity.v1beta1.MsgCollectIncentives": {
    aminoType: "osmosis/concentratedliquidity/collect-incentives",
    toAmino: concentrated_liquidity_tx/* MsgCollectIncentives.toAmino */.ON.toAmino,
    fromAmino: concentrated_liquidity_tx/* MsgCollectIncentives.fromAmino */.ON.fromAmino
  }
};
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/osmosis/client.js


function osmosis_client_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function osmosis_client_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? osmosis_client_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : osmosis_client_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



























const osmosisAminoConverters = osmosis_client_objectSpread(osmosis_client_objectSpread(osmosis_client_objectSpread(osmosis_client_objectSpread(osmosis_client_objectSpread(osmosis_client_objectSpread(osmosis_client_objectSpread(osmosis_client_objectSpread(osmosis_client_objectSpread(osmosis_client_objectSpread(osmosis_client_objectSpread(osmosis_client_objectSpread({}, concentrated_tx_amino_AminoConverter), concentrated_liquidity_tx_amino_AminoConverter), tx_tx_amino_AminoConverter), stableswap_tx_amino_AminoConverter), gamm_v1beta1_tx_amino_AminoConverter), incentives_tx_amino_AminoConverter), lockup_tx_amino_AminoConverter), poolmanager_v1beta1_tx_amino_AminoConverter), protorev_v1beta1_tx_amino_AminoConverter), superfluid_tx_amino_AminoConverter), tokenfactory_v1beta1_tx_amino_AminoConverter), valset_pref_v1beta1_tx_amino_AminoConverter);
const osmosisProtoRegistry = [...concentrated_tx_registry_registry, ...concentrated_liquidity_tx_registry_registry, ...tx_tx_registry_registry, ...stableswap_tx_registry_registry, ...gamm_v1beta1_tx_registry_registry, ...incentives_tx_registry_registry, ...lockup_tx_registry_registry, ...poolmanager_v1beta1_tx_registry_registry, ...protorev_v1beta1_tx_registry_registry, ...superfluid_tx_registry_registry, ...tokenfactory_v1beta1_tx_registry_registry, ...valset_pref_v1beta1_tx_registry_registry];
const getSigningOsmosisClientOptions = ({
  defaultTypes = defaultRegistryTypes
} = {}) => {
  const registry = new Registry([...defaultTypes, ...osmosisProtoRegistry]);
  const aminoTypes = new AminoTypes(osmosis_client_objectSpread({}, osmosisAminoConverters));
  return {
    registry,
    aminoTypes
  };
};
const getSigningOsmosisClient = async ({
  rpcEndpoint,
  signer,
  defaultTypes = defaultRegistryTypes
}) => {
  const {
    registry,
    aminoTypes
  } = getSigningOsmosisClientOptions({
    defaultTypes
  });
  const client = await SigningStargateClient.connectWithSigner(rpcEndpoint, signer, {
    registry,
    aminoTypes
  });
  return client;
};
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/confio/proofs.js


let HashOp;

(function (HashOp) {
  HashOp[HashOp["NO_HASH"] = 0] = "NO_HASH";
  HashOp[HashOp["SHA256"] = 1] = "SHA256";
  HashOp[HashOp["SHA512"] = 2] = "SHA512";
  HashOp[HashOp["KECCAK"] = 3] = "KECCAK";
  HashOp[HashOp["RIPEMD160"] = 4] = "RIPEMD160";
  HashOp[HashOp["BITCOIN"] = 5] = "BITCOIN";
  HashOp[HashOp["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(HashOp || (HashOp = {}));

const HashOpSDKType = HashOp;
const HashOpAmino = HashOp;
function hashOpFromJSON(object) {
  switch (object) {
    case 0:
    case "NO_HASH":
      return HashOp.NO_HASH;

    case 1:
    case "SHA256":
      return HashOp.SHA256;

    case 2:
    case "SHA512":
      return HashOp.SHA512;

    case 3:
    case "KECCAK":
      return HashOp.KECCAK;

    case 4:
    case "RIPEMD160":
      return HashOp.RIPEMD160;

    case 5:
    case "BITCOIN":
      return HashOp.BITCOIN;

    case -1:
    case "UNRECOGNIZED":
    default:
      return HashOp.UNRECOGNIZED;
  }
}
function hashOpToJSON(object) {
  switch (object) {
    case HashOp.NO_HASH:
      return "NO_HASH";

    case HashOp.SHA256:
      return "SHA256";

    case HashOp.SHA512:
      return "SHA512";

    case HashOp.KECCAK:
      return "KECCAK";

    case HashOp.RIPEMD160:
      return "RIPEMD160";

    case HashOp.BITCOIN:
      return "BITCOIN";

    case HashOp.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
/**
 * LengthOp defines how to process the key and value of the LeafOp
 * to include length information. After encoding the length with the given
 * algorithm, the length will be prepended to the key and value bytes.
 * (Each one with it's own encoded length)
 */

let LengthOp;

(function (LengthOp) {
  LengthOp[LengthOp["NO_PREFIX"] = 0] = "NO_PREFIX";
  LengthOp[LengthOp["VAR_PROTO"] = 1] = "VAR_PROTO";
  LengthOp[LengthOp["VAR_RLP"] = 2] = "VAR_RLP";
  LengthOp[LengthOp["FIXED32_BIG"] = 3] = "FIXED32_BIG";
  LengthOp[LengthOp["FIXED32_LITTLE"] = 4] = "FIXED32_LITTLE";
  LengthOp[LengthOp["FIXED64_BIG"] = 5] = "FIXED64_BIG";
  LengthOp[LengthOp["FIXED64_LITTLE"] = 6] = "FIXED64_LITTLE";
  LengthOp[LengthOp["REQUIRE_32_BYTES"] = 7] = "REQUIRE_32_BYTES";
  LengthOp[LengthOp["REQUIRE_64_BYTES"] = 8] = "REQUIRE_64_BYTES";
  LengthOp[LengthOp["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(LengthOp || (LengthOp = {}));

const LengthOpSDKType = LengthOp;
const LengthOpAmino = LengthOp;
function lengthOpFromJSON(object) {
  switch (object) {
    case 0:
    case "NO_PREFIX":
      return LengthOp.NO_PREFIX;

    case 1:
    case "VAR_PROTO":
      return LengthOp.VAR_PROTO;

    case 2:
    case "VAR_RLP":
      return LengthOp.VAR_RLP;

    case 3:
    case "FIXED32_BIG":
      return LengthOp.FIXED32_BIG;

    case 4:
    case "FIXED32_LITTLE":
      return LengthOp.FIXED32_LITTLE;

    case 5:
    case "FIXED64_BIG":
      return LengthOp.FIXED64_BIG;

    case 6:
    case "FIXED64_LITTLE":
      return LengthOp.FIXED64_LITTLE;

    case 7:
    case "REQUIRE_32_BYTES":
      return LengthOp.REQUIRE_32_BYTES;

    case 8:
    case "REQUIRE_64_BYTES":
      return LengthOp.REQUIRE_64_BYTES;

    case -1:
    case "UNRECOGNIZED":
    default:
      return LengthOp.UNRECOGNIZED;
  }
}
function lengthOpToJSON(object) {
  switch (object) {
    case LengthOp.NO_PREFIX:
      return "NO_PREFIX";

    case LengthOp.VAR_PROTO:
      return "VAR_PROTO";

    case LengthOp.VAR_RLP:
      return "VAR_RLP";

    case LengthOp.FIXED32_BIG:
      return "FIXED32_BIG";

    case LengthOp.FIXED32_LITTLE:
      return "FIXED32_LITTLE";

    case LengthOp.FIXED64_BIG:
      return "FIXED64_BIG";

    case LengthOp.FIXED64_LITTLE:
      return "FIXED64_LITTLE";

    case LengthOp.REQUIRE_32_BYTES:
      return "REQUIRE_32_BYTES";

    case LengthOp.REQUIRE_64_BYTES:
      return "REQUIRE_64_BYTES";

    case LengthOp.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
/**
 * ExistenceProof takes a key and a value and a set of steps to perform on it.
 * The result of peforming all these steps will provide a "root hash", which can
 * be compared to the value in a header.
 * 
 * Since it is computationally infeasible to produce a hash collission for any of the used
 * cryptographic hash functions, if someone can provide a series of operations to transform
 * a given key and value into a root hash that matches some trusted root, these key and values
 * must be in the referenced merkle tree.
 * 
 * The only possible issue is maliablity in LeafOp, such as providing extra prefix data,
 * which should be controlled by a spec. Eg. with lengthOp as NONE,
 * prefix = FOO, key = BAR, value = CHOICE
 * and
 * prefix = F, key = OOBAR, value = CHOICE
 * would produce the same value.
 * 
 * With LengthOp this is tricker but not impossible. Which is why the "leafPrefixEqual" field
 * in the ProofSpec is valuable to prevent this mutability. And why all trees should
 * length-prefix the data before hashing it.
 */

function createBaseExistenceProof() {
  return {
    key: new Uint8Array(),
    value: new Uint8Array(),
    leaf: undefined,
    path: []
  };
}

const ExistenceProof = {
  typeUrl: "/ics23.ExistenceProof",

  encode(message, writer = minimal.Writer.create()) {
    if (message.key.length !== 0) {
      writer.uint32(10).bytes(message.key);
    }

    if (message.value.length !== 0) {
      writer.uint32(18).bytes(message.value);
    }

    if (message.leaf !== undefined) {
      LeafOp.encode(message.leaf, writer.uint32(26).fork()).ldelim();
    }

    for (const v of message.path) {
      InnerOp.encode(v, writer.uint32(34).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseExistenceProof();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.key = reader.bytes();
          break;

        case 2:
          message.value = reader.bytes();
          break;

        case 3:
          message.leaf = LeafOp.decode(reader, reader.uint32());
          break;

        case 4:
          message.path.push(InnerOp.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$key, _object$value, _object$path;

    const message = createBaseExistenceProof();
    message.key = (_object$key = object.key) !== null && _object$key !== void 0 ? _object$key : new Uint8Array();
    message.value = (_object$value = object.value) !== null && _object$value !== void 0 ? _object$value : new Uint8Array();
    message.leaf = object.leaf !== undefined && object.leaf !== null ? LeafOp.fromPartial(object.leaf) : undefined;
    message.path = ((_object$path = object.path) === null || _object$path === void 0 ? void 0 : _object$path.map(e => InnerOp.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      key: object.key,
      value: object.value,
      leaf: object !== null && object !== void 0 && object.leaf ? LeafOp.fromAmino(object.leaf) : undefined,
      path: Array.isArray(object === null || object === void 0 ? void 0 : object.path) ? object.path.map(e => InnerOp.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.key = message.key;
    obj.value = message.value;
    obj.leaf = message.leaf ? LeafOp.toAmino(message.leaf) : undefined;

    if (message.path) {
      obj.path = message.path.map(e => e ? InnerOp.toAmino(e) : undefined);
    } else {
      obj.path = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return ExistenceProof.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return ExistenceProof.decode(message.value);
  },

  toProto(message) {
    return ExistenceProof.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ics23.ExistenceProof",
      value: ExistenceProof.encode(message).finish()
    };
  }

};

function createBaseNonExistenceProof() {
  return {
    key: new Uint8Array(),
    left: undefined,
    right: undefined
  };
}

const NonExistenceProof = {
  typeUrl: "/ics23.NonExistenceProof",

  encode(message, writer = minimal.Writer.create()) {
    if (message.key.length !== 0) {
      writer.uint32(10).bytes(message.key);
    }

    if (message.left !== undefined) {
      ExistenceProof.encode(message.left, writer.uint32(18).fork()).ldelim();
    }

    if (message.right !== undefined) {
      ExistenceProof.encode(message.right, writer.uint32(26).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseNonExistenceProof();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.key = reader.bytes();
          break;

        case 2:
          message.left = ExistenceProof.decode(reader, reader.uint32());
          break;

        case 3:
          message.right = ExistenceProof.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$key2;

    const message = createBaseNonExistenceProof();
    message.key = (_object$key2 = object.key) !== null && _object$key2 !== void 0 ? _object$key2 : new Uint8Array();
    message.left = object.left !== undefined && object.left !== null ? ExistenceProof.fromPartial(object.left) : undefined;
    message.right = object.right !== undefined && object.right !== null ? ExistenceProof.fromPartial(object.right) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      key: object.key,
      left: object !== null && object !== void 0 && object.left ? ExistenceProof.fromAmino(object.left) : undefined,
      right: object !== null && object !== void 0 && object.right ? ExistenceProof.fromAmino(object.right) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.key = message.key;
    obj.left = message.left ? ExistenceProof.toAmino(message.left) : undefined;
    obj.right = message.right ? ExistenceProof.toAmino(message.right) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return NonExistenceProof.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return NonExistenceProof.decode(message.value);
  },

  toProto(message) {
    return NonExistenceProof.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ics23.NonExistenceProof",
      value: NonExistenceProof.encode(message).finish()
    };
  }

};

function createBaseCommitmentProof() {
  return {
    exist: undefined,
    nonexist: undefined,
    batch: undefined,
    compressed: undefined
  };
}

const CommitmentProof = {
  typeUrl: "/ics23.CommitmentProof",

  encode(message, writer = minimal.Writer.create()) {
    if (message.exist !== undefined) {
      ExistenceProof.encode(message.exist, writer.uint32(10).fork()).ldelim();
    }

    if (message.nonexist !== undefined) {
      NonExistenceProof.encode(message.nonexist, writer.uint32(18).fork()).ldelim();
    }

    if (message.batch !== undefined) {
      BatchProof.encode(message.batch, writer.uint32(26).fork()).ldelim();
    }

    if (message.compressed !== undefined) {
      CompressedBatchProof.encode(message.compressed, writer.uint32(34).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCommitmentProof();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.exist = ExistenceProof.decode(reader, reader.uint32());
          break;

        case 2:
          message.nonexist = NonExistenceProof.decode(reader, reader.uint32());
          break;

        case 3:
          message.batch = BatchProof.decode(reader, reader.uint32());
          break;

        case 4:
          message.compressed = CompressedBatchProof.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseCommitmentProof();
    message.exist = object.exist !== undefined && object.exist !== null ? ExistenceProof.fromPartial(object.exist) : undefined;
    message.nonexist = object.nonexist !== undefined && object.nonexist !== null ? NonExistenceProof.fromPartial(object.nonexist) : undefined;
    message.batch = object.batch !== undefined && object.batch !== null ? BatchProof.fromPartial(object.batch) : undefined;
    message.compressed = object.compressed !== undefined && object.compressed !== null ? CompressedBatchProof.fromPartial(object.compressed) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      exist: object !== null && object !== void 0 && object.exist ? ExistenceProof.fromAmino(object.exist) : undefined,
      nonexist: object !== null && object !== void 0 && object.nonexist ? NonExistenceProof.fromAmino(object.nonexist) : undefined,
      batch: object !== null && object !== void 0 && object.batch ? BatchProof.fromAmino(object.batch) : undefined,
      compressed: object !== null && object !== void 0 && object.compressed ? CompressedBatchProof.fromAmino(object.compressed) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.exist = message.exist ? ExistenceProof.toAmino(message.exist) : undefined;
    obj.nonexist = message.nonexist ? NonExistenceProof.toAmino(message.nonexist) : undefined;
    obj.batch = message.batch ? BatchProof.toAmino(message.batch) : undefined;
    obj.compressed = message.compressed ? CompressedBatchProof.toAmino(message.compressed) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return CommitmentProof.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return CommitmentProof.decode(message.value);
  },

  toProto(message) {
    return CommitmentProof.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ics23.CommitmentProof",
      value: CommitmentProof.encode(message).finish()
    };
  }

};

function createBaseLeafOp() {
  return {
    hash: 0,
    prehashKey: 0,
    prehashValue: 0,
    length: 0,
    prefix: new Uint8Array()
  };
}

const LeafOp = {
  typeUrl: "/ics23.LeafOp",

  encode(message, writer = minimal.Writer.create()) {
    if (message.hash !== 0) {
      writer.uint32(8).int32(message.hash);
    }

    if (message.prehashKey !== 0) {
      writer.uint32(16).int32(message.prehashKey);
    }

    if (message.prehashValue !== 0) {
      writer.uint32(24).int32(message.prehashValue);
    }

    if (message.length !== 0) {
      writer.uint32(32).int32(message.length);
    }

    if (message.prefix.length !== 0) {
      writer.uint32(42).bytes(message.prefix);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLeafOp();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.hash = reader.int32();
          break;

        case 2:
          message.prehashKey = reader.int32();
          break;

        case 3:
          message.prehashValue = reader.int32();
          break;

        case 4:
          message.length = reader.int32();
          break;

        case 5:
          message.prefix = reader.bytes();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$hash, _object$prehashKey, _object$prehashValue, _object$length, _object$prefix;

    const message = createBaseLeafOp();
    message.hash = (_object$hash = object.hash) !== null && _object$hash !== void 0 ? _object$hash : 0;
    message.prehashKey = (_object$prehashKey = object.prehashKey) !== null && _object$prehashKey !== void 0 ? _object$prehashKey : 0;
    message.prehashValue = (_object$prehashValue = object.prehashValue) !== null && _object$prehashValue !== void 0 ? _object$prehashValue : 0;
    message.length = (_object$length = object.length) !== null && _object$length !== void 0 ? _object$length : 0;
    message.prefix = (_object$prefix = object.prefix) !== null && _object$prefix !== void 0 ? _object$prefix : new Uint8Array();
    return message;
  },

  fromAmino(object) {
    return {
      hash: (0,helpers/* isSet */.DM)(object.hash) ? hashOpFromJSON(object.hash) : 0,
      prehashKey: (0,helpers/* isSet */.DM)(object.prehash_key) ? hashOpFromJSON(object.prehash_key) : 0,
      prehashValue: (0,helpers/* isSet */.DM)(object.prehash_value) ? hashOpFromJSON(object.prehash_value) : 0,
      length: (0,helpers/* isSet */.DM)(object.length) ? lengthOpFromJSON(object.length) : 0,
      prefix: object.prefix
    };
  },

  toAmino(message) {
    const obj = {};
    obj.hash = message.hash;
    obj.prehash_key = message.prehashKey;
    obj.prehash_value = message.prehashValue;
    obj.length = message.length;
    obj.prefix = message.prefix;
    return obj;
  },

  fromAminoMsg(object) {
    return LeafOp.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return LeafOp.decode(message.value);
  },

  toProto(message) {
    return LeafOp.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ics23.LeafOp",
      value: LeafOp.encode(message).finish()
    };
  }

};

function createBaseInnerOp() {
  return {
    hash: 0,
    prefix: new Uint8Array(),
    suffix: new Uint8Array()
  };
}

const InnerOp = {
  typeUrl: "/ics23.InnerOp",

  encode(message, writer = minimal.Writer.create()) {
    if (message.hash !== 0) {
      writer.uint32(8).int32(message.hash);
    }

    if (message.prefix.length !== 0) {
      writer.uint32(18).bytes(message.prefix);
    }

    if (message.suffix.length !== 0) {
      writer.uint32(26).bytes(message.suffix);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInnerOp();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.hash = reader.int32();
          break;

        case 2:
          message.prefix = reader.bytes();
          break;

        case 3:
          message.suffix = reader.bytes();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$hash2, _object$prefix2, _object$suffix;

    const message = createBaseInnerOp();
    message.hash = (_object$hash2 = object.hash) !== null && _object$hash2 !== void 0 ? _object$hash2 : 0;
    message.prefix = (_object$prefix2 = object.prefix) !== null && _object$prefix2 !== void 0 ? _object$prefix2 : new Uint8Array();
    message.suffix = (_object$suffix = object.suffix) !== null && _object$suffix !== void 0 ? _object$suffix : new Uint8Array();
    return message;
  },

  fromAmino(object) {
    return {
      hash: (0,helpers/* isSet */.DM)(object.hash) ? hashOpFromJSON(object.hash) : 0,
      prefix: object.prefix,
      suffix: object.suffix
    };
  },

  toAmino(message) {
    const obj = {};
    obj.hash = message.hash;
    obj.prefix = message.prefix;
    obj.suffix = message.suffix;
    return obj;
  },

  fromAminoMsg(object) {
    return InnerOp.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return InnerOp.decode(message.value);
  },

  toProto(message) {
    return InnerOp.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ics23.InnerOp",
      value: InnerOp.encode(message).finish()
    };
  }

};

function createBaseProofSpec() {
  return {
    leafSpec: undefined,
    innerSpec: undefined,
    maxDepth: 0,
    minDepth: 0
  };
}

const ProofSpec = {
  typeUrl: "/ics23.ProofSpec",

  encode(message, writer = minimal.Writer.create()) {
    if (message.leafSpec !== undefined) {
      LeafOp.encode(message.leafSpec, writer.uint32(10).fork()).ldelim();
    }

    if (message.innerSpec !== undefined) {
      InnerSpec.encode(message.innerSpec, writer.uint32(18).fork()).ldelim();
    }

    if (message.maxDepth !== 0) {
      writer.uint32(24).int32(message.maxDepth);
    }

    if (message.minDepth !== 0) {
      writer.uint32(32).int32(message.minDepth);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseProofSpec();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.leafSpec = LeafOp.decode(reader, reader.uint32());
          break;

        case 2:
          message.innerSpec = InnerSpec.decode(reader, reader.uint32());
          break;

        case 3:
          message.maxDepth = reader.int32();
          break;

        case 4:
          message.minDepth = reader.int32();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$maxDepth, _object$minDepth;

    const message = createBaseProofSpec();
    message.leafSpec = object.leafSpec !== undefined && object.leafSpec !== null ? LeafOp.fromPartial(object.leafSpec) : undefined;
    message.innerSpec = object.innerSpec !== undefined && object.innerSpec !== null ? InnerSpec.fromPartial(object.innerSpec) : undefined;
    message.maxDepth = (_object$maxDepth = object.maxDepth) !== null && _object$maxDepth !== void 0 ? _object$maxDepth : 0;
    message.minDepth = (_object$minDepth = object.minDepth) !== null && _object$minDepth !== void 0 ? _object$minDepth : 0;
    return message;
  },

  fromAmino(object) {
    return {
      leafSpec: object !== null && object !== void 0 && object.leaf_spec ? LeafOp.fromAmino(object.leaf_spec) : undefined,
      innerSpec: object !== null && object !== void 0 && object.inner_spec ? InnerSpec.fromAmino(object.inner_spec) : undefined,
      maxDepth: object.max_depth,
      minDepth: object.min_depth
    };
  },

  toAmino(message) {
    const obj = {};
    obj.leaf_spec = message.leafSpec ? LeafOp.toAmino(message.leafSpec) : undefined;
    obj.inner_spec = message.innerSpec ? InnerSpec.toAmino(message.innerSpec) : undefined;
    obj.max_depth = message.maxDepth;
    obj.min_depth = message.minDepth;
    return obj;
  },

  fromAminoMsg(object) {
    return ProofSpec.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return ProofSpec.decode(message.value);
  },

  toProto(message) {
    return ProofSpec.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ics23.ProofSpec",
      value: ProofSpec.encode(message).finish()
    };
  }

};

function createBaseInnerSpec() {
  return {
    childOrder: [],
    childSize: 0,
    minPrefixLength: 0,
    maxPrefixLength: 0,
    emptyChild: new Uint8Array(),
    hash: 0
  };
}

const InnerSpec = {
  typeUrl: "/ics23.InnerSpec",

  encode(message, writer = minimal.Writer.create()) {
    writer.uint32(10).fork();

    for (const v of message.childOrder) {
      writer.int32(v);
    }

    writer.ldelim();

    if (message.childSize !== 0) {
      writer.uint32(16).int32(message.childSize);
    }

    if (message.minPrefixLength !== 0) {
      writer.uint32(24).int32(message.minPrefixLength);
    }

    if (message.maxPrefixLength !== 0) {
      writer.uint32(32).int32(message.maxPrefixLength);
    }

    if (message.emptyChild.length !== 0) {
      writer.uint32(42).bytes(message.emptyChild);
    }

    if (message.hash !== 0) {
      writer.uint32(48).int32(message.hash);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInnerSpec();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          if ((tag & 7) === 2) {
            const end2 = reader.uint32() + reader.pos;

            while (reader.pos < end2) {
              message.childOrder.push(reader.int32());
            }
          } else {
            message.childOrder.push(reader.int32());
          }

          break;

        case 2:
          message.childSize = reader.int32();
          break;

        case 3:
          message.minPrefixLength = reader.int32();
          break;

        case 4:
          message.maxPrefixLength = reader.int32();
          break;

        case 5:
          message.emptyChild = reader.bytes();
          break;

        case 6:
          message.hash = reader.int32();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$childOrder, _object$childSize, _object$minPrefixLeng, _object$maxPrefixLeng, _object$emptyChild, _object$hash3;

    const message = createBaseInnerSpec();
    message.childOrder = ((_object$childOrder = object.childOrder) === null || _object$childOrder === void 0 ? void 0 : _object$childOrder.map(e => e)) || [];
    message.childSize = (_object$childSize = object.childSize) !== null && _object$childSize !== void 0 ? _object$childSize : 0;
    message.minPrefixLength = (_object$minPrefixLeng = object.minPrefixLength) !== null && _object$minPrefixLeng !== void 0 ? _object$minPrefixLeng : 0;
    message.maxPrefixLength = (_object$maxPrefixLeng = object.maxPrefixLength) !== null && _object$maxPrefixLeng !== void 0 ? _object$maxPrefixLeng : 0;
    message.emptyChild = (_object$emptyChild = object.emptyChild) !== null && _object$emptyChild !== void 0 ? _object$emptyChild : new Uint8Array();
    message.hash = (_object$hash3 = object.hash) !== null && _object$hash3 !== void 0 ? _object$hash3 : 0;
    return message;
  },

  fromAmino(object) {
    return {
      childOrder: Array.isArray(object === null || object === void 0 ? void 0 : object.child_order) ? object.child_order.map(e => e) : [],
      childSize: object.child_size,
      minPrefixLength: object.min_prefix_length,
      maxPrefixLength: object.max_prefix_length,
      emptyChild: object.empty_child,
      hash: (0,helpers/* isSet */.DM)(object.hash) ? hashOpFromJSON(object.hash) : 0
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.childOrder) {
      obj.child_order = message.childOrder.map(e => e);
    } else {
      obj.child_order = [];
    }

    obj.child_size = message.childSize;
    obj.min_prefix_length = message.minPrefixLength;
    obj.max_prefix_length = message.maxPrefixLength;
    obj.empty_child = message.emptyChild;
    obj.hash = message.hash;
    return obj;
  },

  fromAminoMsg(object) {
    return InnerSpec.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return InnerSpec.decode(message.value);
  },

  toProto(message) {
    return InnerSpec.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ics23.InnerSpec",
      value: InnerSpec.encode(message).finish()
    };
  }

};

function createBaseBatchProof() {
  return {
    entries: []
  };
}

const BatchProof = {
  typeUrl: "/ics23.BatchProof",

  encode(message, writer = minimal.Writer.create()) {
    for (const v of message.entries) {
      BatchEntry.encode(v, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBatchProof();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.entries.push(BatchEntry.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$entries;

    const message = createBaseBatchProof();
    message.entries = ((_object$entries = object.entries) === null || _object$entries === void 0 ? void 0 : _object$entries.map(e => BatchEntry.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      entries: Array.isArray(object === null || object === void 0 ? void 0 : object.entries) ? object.entries.map(e => BatchEntry.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.entries) {
      obj.entries = message.entries.map(e => e ? BatchEntry.toAmino(e) : undefined);
    } else {
      obj.entries = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return BatchProof.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return BatchProof.decode(message.value);
  },

  toProto(message) {
    return BatchProof.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ics23.BatchProof",
      value: BatchProof.encode(message).finish()
    };
  }

};

function createBaseBatchEntry() {
  return {
    exist: undefined,
    nonexist: undefined
  };
}

const BatchEntry = {
  typeUrl: "/ics23.BatchEntry",

  encode(message, writer = minimal.Writer.create()) {
    if (message.exist !== undefined) {
      ExistenceProof.encode(message.exist, writer.uint32(10).fork()).ldelim();
    }

    if (message.nonexist !== undefined) {
      NonExistenceProof.encode(message.nonexist, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBatchEntry();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.exist = ExistenceProof.decode(reader, reader.uint32());
          break;

        case 2:
          message.nonexist = NonExistenceProof.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseBatchEntry();
    message.exist = object.exist !== undefined && object.exist !== null ? ExistenceProof.fromPartial(object.exist) : undefined;
    message.nonexist = object.nonexist !== undefined && object.nonexist !== null ? NonExistenceProof.fromPartial(object.nonexist) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      exist: object !== null && object !== void 0 && object.exist ? ExistenceProof.fromAmino(object.exist) : undefined,
      nonexist: object !== null && object !== void 0 && object.nonexist ? NonExistenceProof.fromAmino(object.nonexist) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.exist = message.exist ? ExistenceProof.toAmino(message.exist) : undefined;
    obj.nonexist = message.nonexist ? NonExistenceProof.toAmino(message.nonexist) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return BatchEntry.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return BatchEntry.decode(message.value);
  },

  toProto(message) {
    return BatchEntry.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ics23.BatchEntry",
      value: BatchEntry.encode(message).finish()
    };
  }

};

function createBaseCompressedBatchProof() {
  return {
    entries: [],
    lookupInners: []
  };
}

const CompressedBatchProof = {
  typeUrl: "/ics23.CompressedBatchProof",

  encode(message, writer = minimal.Writer.create()) {
    for (const v of message.entries) {
      CompressedBatchEntry.encode(v, writer.uint32(10).fork()).ldelim();
    }

    for (const v of message.lookupInners) {
      InnerOp.encode(v, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCompressedBatchProof();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.entries.push(CompressedBatchEntry.decode(reader, reader.uint32()));
          break;

        case 2:
          message.lookupInners.push(InnerOp.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$entries2, _object$lookupInners;

    const message = createBaseCompressedBatchProof();
    message.entries = ((_object$entries2 = object.entries) === null || _object$entries2 === void 0 ? void 0 : _object$entries2.map(e => CompressedBatchEntry.fromPartial(e))) || [];
    message.lookupInners = ((_object$lookupInners = object.lookupInners) === null || _object$lookupInners === void 0 ? void 0 : _object$lookupInners.map(e => InnerOp.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      entries: Array.isArray(object === null || object === void 0 ? void 0 : object.entries) ? object.entries.map(e => CompressedBatchEntry.fromAmino(e)) : [],
      lookupInners: Array.isArray(object === null || object === void 0 ? void 0 : object.lookup_inners) ? object.lookup_inners.map(e => InnerOp.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.entries) {
      obj.entries = message.entries.map(e => e ? CompressedBatchEntry.toAmino(e) : undefined);
    } else {
      obj.entries = [];
    }

    if (message.lookupInners) {
      obj.lookup_inners = message.lookupInners.map(e => e ? InnerOp.toAmino(e) : undefined);
    } else {
      obj.lookup_inners = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return CompressedBatchProof.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return CompressedBatchProof.decode(message.value);
  },

  toProto(message) {
    return CompressedBatchProof.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ics23.CompressedBatchProof",
      value: CompressedBatchProof.encode(message).finish()
    };
  }

};

function createBaseCompressedBatchEntry() {
  return {
    exist: undefined,
    nonexist: undefined
  };
}

const CompressedBatchEntry = {
  typeUrl: "/ics23.CompressedBatchEntry",

  encode(message, writer = minimal.Writer.create()) {
    if (message.exist !== undefined) {
      CompressedExistenceProof.encode(message.exist, writer.uint32(10).fork()).ldelim();
    }

    if (message.nonexist !== undefined) {
      CompressedNonExistenceProof.encode(message.nonexist, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCompressedBatchEntry();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.exist = CompressedExistenceProof.decode(reader, reader.uint32());
          break;

        case 2:
          message.nonexist = CompressedNonExistenceProof.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseCompressedBatchEntry();
    message.exist = object.exist !== undefined && object.exist !== null ? CompressedExistenceProof.fromPartial(object.exist) : undefined;
    message.nonexist = object.nonexist !== undefined && object.nonexist !== null ? CompressedNonExistenceProof.fromPartial(object.nonexist) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      exist: object !== null && object !== void 0 && object.exist ? CompressedExistenceProof.fromAmino(object.exist) : undefined,
      nonexist: object !== null && object !== void 0 && object.nonexist ? CompressedNonExistenceProof.fromAmino(object.nonexist) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.exist = message.exist ? CompressedExistenceProof.toAmino(message.exist) : undefined;
    obj.nonexist = message.nonexist ? CompressedNonExistenceProof.toAmino(message.nonexist) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return CompressedBatchEntry.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return CompressedBatchEntry.decode(message.value);
  },

  toProto(message) {
    return CompressedBatchEntry.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ics23.CompressedBatchEntry",
      value: CompressedBatchEntry.encode(message).finish()
    };
  }

};

function createBaseCompressedExistenceProof() {
  return {
    key: new Uint8Array(),
    value: new Uint8Array(),
    leaf: undefined,
    path: []
  };
}

const CompressedExistenceProof = {
  typeUrl: "/ics23.CompressedExistenceProof",

  encode(message, writer = minimal.Writer.create()) {
    if (message.key.length !== 0) {
      writer.uint32(10).bytes(message.key);
    }

    if (message.value.length !== 0) {
      writer.uint32(18).bytes(message.value);
    }

    if (message.leaf !== undefined) {
      LeafOp.encode(message.leaf, writer.uint32(26).fork()).ldelim();
    }

    writer.uint32(34).fork();

    for (const v of message.path) {
      writer.int32(v);
    }

    writer.ldelim();
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCompressedExistenceProof();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.key = reader.bytes();
          break;

        case 2:
          message.value = reader.bytes();
          break;

        case 3:
          message.leaf = LeafOp.decode(reader, reader.uint32());
          break;

        case 4:
          if ((tag & 7) === 2) {
            const end2 = reader.uint32() + reader.pos;

            while (reader.pos < end2) {
              message.path.push(reader.int32());
            }
          } else {
            message.path.push(reader.int32());
          }

          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$key3, _object$value2, _object$path2;

    const message = createBaseCompressedExistenceProof();
    message.key = (_object$key3 = object.key) !== null && _object$key3 !== void 0 ? _object$key3 : new Uint8Array();
    message.value = (_object$value2 = object.value) !== null && _object$value2 !== void 0 ? _object$value2 : new Uint8Array();
    message.leaf = object.leaf !== undefined && object.leaf !== null ? LeafOp.fromPartial(object.leaf) : undefined;
    message.path = ((_object$path2 = object.path) === null || _object$path2 === void 0 ? void 0 : _object$path2.map(e => e)) || [];
    return message;
  },

  fromAmino(object) {
    return {
      key: object.key,
      value: object.value,
      leaf: object !== null && object !== void 0 && object.leaf ? LeafOp.fromAmino(object.leaf) : undefined,
      path: Array.isArray(object === null || object === void 0 ? void 0 : object.path) ? object.path.map(e => e) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.key = message.key;
    obj.value = message.value;
    obj.leaf = message.leaf ? LeafOp.toAmino(message.leaf) : undefined;

    if (message.path) {
      obj.path = message.path.map(e => e);
    } else {
      obj.path = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return CompressedExistenceProof.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return CompressedExistenceProof.decode(message.value);
  },

  toProto(message) {
    return CompressedExistenceProof.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ics23.CompressedExistenceProof",
      value: CompressedExistenceProof.encode(message).finish()
    };
  }

};

function createBaseCompressedNonExistenceProof() {
  return {
    key: new Uint8Array(),
    left: undefined,
    right: undefined
  };
}

const CompressedNonExistenceProof = {
  typeUrl: "/ics23.CompressedNonExistenceProof",

  encode(message, writer = minimal.Writer.create()) {
    if (message.key.length !== 0) {
      writer.uint32(10).bytes(message.key);
    }

    if (message.left !== undefined) {
      CompressedExistenceProof.encode(message.left, writer.uint32(18).fork()).ldelim();
    }

    if (message.right !== undefined) {
      CompressedExistenceProof.encode(message.right, writer.uint32(26).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCompressedNonExistenceProof();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.key = reader.bytes();
          break;

        case 2:
          message.left = CompressedExistenceProof.decode(reader, reader.uint32());
          break;

        case 3:
          message.right = CompressedExistenceProof.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$key4;

    const message = createBaseCompressedNonExistenceProof();
    message.key = (_object$key4 = object.key) !== null && _object$key4 !== void 0 ? _object$key4 : new Uint8Array();
    message.left = object.left !== undefined && object.left !== null ? CompressedExistenceProof.fromPartial(object.left) : undefined;
    message.right = object.right !== undefined && object.right !== null ? CompressedExistenceProof.fromPartial(object.right) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      key: object.key,
      left: object !== null && object !== void 0 && object.left ? CompressedExistenceProof.fromAmino(object.left) : undefined,
      right: object !== null && object !== void 0 && object.right ? CompressedExistenceProof.fromAmino(object.right) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.key = message.key;
    obj.left = message.left ? CompressedExistenceProof.toAmino(message.left) : undefined;
    obj.right = message.right ? CompressedExistenceProof.toAmino(message.right) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return CompressedNonExistenceProof.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return CompressedNonExistenceProof.decode(message.value);
  },

  toProto(message) {
    return CompressedNonExistenceProof.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/ics23.CompressedNonExistenceProof",
      value: CompressedNonExistenceProof.encode(message).finish()
    };
  }

};
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/ics23/bundle.js


function ics23_bundle_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function ics23_bundle_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ics23_bundle_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ics23_bundle_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


const ics23 = ics23_bundle_objectSpread({}, proofs_namespaceObject);
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/cosmos_proto/cosmos.js

let ScalarType;

(function (ScalarType) {
  ScalarType[ScalarType["SCALAR_TYPE_UNSPECIFIED"] = 0] = "SCALAR_TYPE_UNSPECIFIED";
  ScalarType[ScalarType["SCALAR_TYPE_STRING"] = 1] = "SCALAR_TYPE_STRING";
  ScalarType[ScalarType["SCALAR_TYPE_BYTES"] = 2] = "SCALAR_TYPE_BYTES";
  ScalarType[ScalarType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(ScalarType || (ScalarType = {}));

const ScalarTypeSDKType = ScalarType;
const ScalarTypeAmino = ScalarType;
function scalarTypeFromJSON(object) {
  switch (object) {
    case 0:
    case "SCALAR_TYPE_UNSPECIFIED":
      return ScalarType.SCALAR_TYPE_UNSPECIFIED;

    case 1:
    case "SCALAR_TYPE_STRING":
      return ScalarType.SCALAR_TYPE_STRING;

    case 2:
    case "SCALAR_TYPE_BYTES":
      return ScalarType.SCALAR_TYPE_BYTES;

    case -1:
    case "UNRECOGNIZED":
    default:
      return ScalarType.UNRECOGNIZED;
  }
}
function scalarTypeToJSON(object) {
  switch (object) {
    case ScalarType.SCALAR_TYPE_UNSPECIFIED:
      return "SCALAR_TYPE_UNSPECIFIED";

    case ScalarType.SCALAR_TYPE_STRING:
      return "SCALAR_TYPE_STRING";

    case ScalarType.SCALAR_TYPE_BYTES:
      return "SCALAR_TYPE_BYTES";

    case ScalarType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
/**
 * InterfaceDescriptor describes an interface type to be used with
 * accepts_interface and implements_interface and declared by declare_interface.
 */

function cosmos_createBaseInterfaceDescriptor() {
  return {
    name: "",
    description: ""
  };
}

const cosmos_InterfaceDescriptor = {
  typeUrl: "/cosmos_proto.InterfaceDescriptor",

  encode(message, writer = minimal.Writer.create()) {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }

    if (message.description !== "") {
      writer.uint32(18).string(message.description);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = cosmos_createBaseInterfaceDescriptor();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.name = reader.string();
          break;

        case 2:
          message.description = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$name, _object$description;

    const message = cosmos_createBaseInterfaceDescriptor();
    message.name = (_object$name = object.name) !== null && _object$name !== void 0 ? _object$name : "";
    message.description = (_object$description = object.description) !== null && _object$description !== void 0 ? _object$description : "";
    return message;
  },

  fromAmino(object) {
    return {
      name: object.name,
      description: object.description
    };
  },

  toAmino(message) {
    const obj = {};
    obj.name = message.name;
    obj.description = message.description;
    return obj;
  },

  fromAminoMsg(object) {
    return cosmos_InterfaceDescriptor.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return cosmos_InterfaceDescriptor.decode(message.value);
  },

  toProto(message) {
    return cosmos_InterfaceDescriptor.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos_proto.InterfaceDescriptor",
      value: cosmos_InterfaceDescriptor.encode(message).finish()
    };
  }

};

function createBaseScalarDescriptor() {
  return {
    name: "",
    description: "",
    fieldType: []
  };
}

const ScalarDescriptor = {
  typeUrl: "/cosmos_proto.ScalarDescriptor",

  encode(message, writer = minimal.Writer.create()) {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }

    if (message.description !== "") {
      writer.uint32(18).string(message.description);
    }

    writer.uint32(26).fork();

    for (const v of message.fieldType) {
      writer.int32(v);
    }

    writer.ldelim();
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseScalarDescriptor();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.name = reader.string();
          break;

        case 2:
          message.description = reader.string();
          break;

        case 3:
          if ((tag & 7) === 2) {
            const end2 = reader.uint32() + reader.pos;

            while (reader.pos < end2) {
              message.fieldType.push(reader.int32());
            }
          } else {
            message.fieldType.push(reader.int32());
          }

          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$name2, _object$description2, _object$fieldType;

    const message = createBaseScalarDescriptor();
    message.name = (_object$name2 = object.name) !== null && _object$name2 !== void 0 ? _object$name2 : "";
    message.description = (_object$description2 = object.description) !== null && _object$description2 !== void 0 ? _object$description2 : "";
    message.fieldType = ((_object$fieldType = object.fieldType) === null || _object$fieldType === void 0 ? void 0 : _object$fieldType.map(e => e)) || [];
    return message;
  },

  fromAmino(object) {
    return {
      name: object.name,
      description: object.description,
      fieldType: Array.isArray(object === null || object === void 0 ? void 0 : object.field_type) ? object.field_type.map(e => scalarTypeFromJSON(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.name = message.name;
    obj.description = message.description;

    if (message.fieldType) {
      obj.field_type = message.fieldType.map(e => scalarTypeToJSON(e));
    } else {
      obj.field_type = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return ScalarDescriptor.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return ScalarDescriptor.decode(message.value);
  },

  toProto(message) {
    return ScalarDescriptor.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/cosmos_proto.ScalarDescriptor",
      value: ScalarDescriptor.encode(message).finish()
    };
  }

};
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/cosmos_proto/bundle.js


function cosmos_proto_bundle_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function cosmos_proto_bundle_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? cosmos_proto_bundle_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : cosmos_proto_bundle_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


const cosmos_proto = cosmos_proto_bundle_objectSpread({}, cosmos_namespaceObject);
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/gogoproto/gogo.js

;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/gogoproto/bundle.js


function gogoproto_bundle_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function gogoproto_bundle_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? gogoproto_bundle_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : gogoproto_bundle_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


const gogoproto = gogoproto_bundle_objectSpread({}, gogo_namespaceObject);
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/google/protobuf/descriptor.js


let FieldDescriptorProto_Type;

(function (FieldDescriptorProto_Type) {
  FieldDescriptorProto_Type[FieldDescriptorProto_Type["TYPE_DOUBLE"] = 1] = "TYPE_DOUBLE";
  FieldDescriptorProto_Type[FieldDescriptorProto_Type["TYPE_FLOAT"] = 2] = "TYPE_FLOAT";
  FieldDescriptorProto_Type[FieldDescriptorProto_Type["TYPE_INT64"] = 3] = "TYPE_INT64";
  FieldDescriptorProto_Type[FieldDescriptorProto_Type["TYPE_UINT64"] = 4] = "TYPE_UINT64";
  FieldDescriptorProto_Type[FieldDescriptorProto_Type["TYPE_INT32"] = 5] = "TYPE_INT32";
  FieldDescriptorProto_Type[FieldDescriptorProto_Type["TYPE_FIXED64"] = 6] = "TYPE_FIXED64";
  FieldDescriptorProto_Type[FieldDescriptorProto_Type["TYPE_FIXED32"] = 7] = "TYPE_FIXED32";
  FieldDescriptorProto_Type[FieldDescriptorProto_Type["TYPE_BOOL"] = 8] = "TYPE_BOOL";
  FieldDescriptorProto_Type[FieldDescriptorProto_Type["TYPE_STRING"] = 9] = "TYPE_STRING";
  FieldDescriptorProto_Type[FieldDescriptorProto_Type["TYPE_GROUP"] = 10] = "TYPE_GROUP";
  FieldDescriptorProto_Type[FieldDescriptorProto_Type["TYPE_MESSAGE"] = 11] = "TYPE_MESSAGE";
  FieldDescriptorProto_Type[FieldDescriptorProto_Type["TYPE_BYTES"] = 12] = "TYPE_BYTES";
  FieldDescriptorProto_Type[FieldDescriptorProto_Type["TYPE_UINT32"] = 13] = "TYPE_UINT32";
  FieldDescriptorProto_Type[FieldDescriptorProto_Type["TYPE_ENUM"] = 14] = "TYPE_ENUM";
  FieldDescriptorProto_Type[FieldDescriptorProto_Type["TYPE_SFIXED32"] = 15] = "TYPE_SFIXED32";
  FieldDescriptorProto_Type[FieldDescriptorProto_Type["TYPE_SFIXED64"] = 16] = "TYPE_SFIXED64";
  FieldDescriptorProto_Type[FieldDescriptorProto_Type["TYPE_SINT32"] = 17] = "TYPE_SINT32";
  FieldDescriptorProto_Type[FieldDescriptorProto_Type["TYPE_SINT64"] = 18] = "TYPE_SINT64";
  FieldDescriptorProto_Type[FieldDescriptorProto_Type["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(FieldDescriptorProto_Type || (FieldDescriptorProto_Type = {}));

const FieldDescriptorProto_TypeSDKType = FieldDescriptorProto_Type;
const FieldDescriptorProto_TypeAmino = FieldDescriptorProto_Type;
function fieldDescriptorProto_TypeFromJSON(object) {
  switch (object) {
    case 1:
    case "TYPE_DOUBLE":
      return FieldDescriptorProto_Type.TYPE_DOUBLE;

    case 2:
    case "TYPE_FLOAT":
      return FieldDescriptorProto_Type.TYPE_FLOAT;

    case 3:
    case "TYPE_INT64":
      return FieldDescriptorProto_Type.TYPE_INT64;

    case 4:
    case "TYPE_UINT64":
      return FieldDescriptorProto_Type.TYPE_UINT64;

    case 5:
    case "TYPE_INT32":
      return FieldDescriptorProto_Type.TYPE_INT32;

    case 6:
    case "TYPE_FIXED64":
      return FieldDescriptorProto_Type.TYPE_FIXED64;

    case 7:
    case "TYPE_FIXED32":
      return FieldDescriptorProto_Type.TYPE_FIXED32;

    case 8:
    case "TYPE_BOOL":
      return FieldDescriptorProto_Type.TYPE_BOOL;

    case 9:
    case "TYPE_STRING":
      return FieldDescriptorProto_Type.TYPE_STRING;

    case 10:
    case "TYPE_GROUP":
      return FieldDescriptorProto_Type.TYPE_GROUP;

    case 11:
    case "TYPE_MESSAGE":
      return FieldDescriptorProto_Type.TYPE_MESSAGE;

    case 12:
    case "TYPE_BYTES":
      return FieldDescriptorProto_Type.TYPE_BYTES;

    case 13:
    case "TYPE_UINT32":
      return FieldDescriptorProto_Type.TYPE_UINT32;

    case 14:
    case "TYPE_ENUM":
      return FieldDescriptorProto_Type.TYPE_ENUM;

    case 15:
    case "TYPE_SFIXED32":
      return FieldDescriptorProto_Type.TYPE_SFIXED32;

    case 16:
    case "TYPE_SFIXED64":
      return FieldDescriptorProto_Type.TYPE_SFIXED64;

    case 17:
    case "TYPE_SINT32":
      return FieldDescriptorProto_Type.TYPE_SINT32;

    case 18:
    case "TYPE_SINT64":
      return FieldDescriptorProto_Type.TYPE_SINT64;

    case -1:
    case "UNRECOGNIZED":
    default:
      return FieldDescriptorProto_Type.UNRECOGNIZED;
  }
}
function fieldDescriptorProto_TypeToJSON(object) {
  switch (object) {
    case FieldDescriptorProto_Type.TYPE_DOUBLE:
      return "TYPE_DOUBLE";

    case FieldDescriptorProto_Type.TYPE_FLOAT:
      return "TYPE_FLOAT";

    case FieldDescriptorProto_Type.TYPE_INT64:
      return "TYPE_INT64";

    case FieldDescriptorProto_Type.TYPE_UINT64:
      return "TYPE_UINT64";

    case FieldDescriptorProto_Type.TYPE_INT32:
      return "TYPE_INT32";

    case FieldDescriptorProto_Type.TYPE_FIXED64:
      return "TYPE_FIXED64";

    case FieldDescriptorProto_Type.TYPE_FIXED32:
      return "TYPE_FIXED32";

    case FieldDescriptorProto_Type.TYPE_BOOL:
      return "TYPE_BOOL";

    case FieldDescriptorProto_Type.TYPE_STRING:
      return "TYPE_STRING";

    case FieldDescriptorProto_Type.TYPE_GROUP:
      return "TYPE_GROUP";

    case FieldDescriptorProto_Type.TYPE_MESSAGE:
      return "TYPE_MESSAGE";

    case FieldDescriptorProto_Type.TYPE_BYTES:
      return "TYPE_BYTES";

    case FieldDescriptorProto_Type.TYPE_UINT32:
      return "TYPE_UINT32";

    case FieldDescriptorProto_Type.TYPE_ENUM:
      return "TYPE_ENUM";

    case FieldDescriptorProto_Type.TYPE_SFIXED32:
      return "TYPE_SFIXED32";

    case FieldDescriptorProto_Type.TYPE_SFIXED64:
      return "TYPE_SFIXED64";

    case FieldDescriptorProto_Type.TYPE_SINT32:
      return "TYPE_SINT32";

    case FieldDescriptorProto_Type.TYPE_SINT64:
      return "TYPE_SINT64";

    case FieldDescriptorProto_Type.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
let FieldDescriptorProto_Label;

(function (FieldDescriptorProto_Label) {
  FieldDescriptorProto_Label[FieldDescriptorProto_Label["LABEL_OPTIONAL"] = 1] = "LABEL_OPTIONAL";
  FieldDescriptorProto_Label[FieldDescriptorProto_Label["LABEL_REQUIRED"] = 2] = "LABEL_REQUIRED";
  FieldDescriptorProto_Label[FieldDescriptorProto_Label["LABEL_REPEATED"] = 3] = "LABEL_REPEATED";
  FieldDescriptorProto_Label[FieldDescriptorProto_Label["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(FieldDescriptorProto_Label || (FieldDescriptorProto_Label = {}));

const FieldDescriptorProto_LabelSDKType = FieldDescriptorProto_Label;
const FieldDescriptorProto_LabelAmino = FieldDescriptorProto_Label;
function fieldDescriptorProto_LabelFromJSON(object) {
  switch (object) {
    case 1:
    case "LABEL_OPTIONAL":
      return FieldDescriptorProto_Label.LABEL_OPTIONAL;

    case 2:
    case "LABEL_REQUIRED":
      return FieldDescriptorProto_Label.LABEL_REQUIRED;

    case 3:
    case "LABEL_REPEATED":
      return FieldDescriptorProto_Label.LABEL_REPEATED;

    case -1:
    case "UNRECOGNIZED":
    default:
      return FieldDescriptorProto_Label.UNRECOGNIZED;
  }
}
function fieldDescriptorProto_LabelToJSON(object) {
  switch (object) {
    case FieldDescriptorProto_Label.LABEL_OPTIONAL:
      return "LABEL_OPTIONAL";

    case FieldDescriptorProto_Label.LABEL_REQUIRED:
      return "LABEL_REQUIRED";

    case FieldDescriptorProto_Label.LABEL_REPEATED:
      return "LABEL_REPEATED";

    case FieldDescriptorProto_Label.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
/** Generated classes can be optimized for speed or code size. */

let FileOptions_OptimizeMode;

(function (FileOptions_OptimizeMode) {
  FileOptions_OptimizeMode[FileOptions_OptimizeMode["SPEED"] = 1] = "SPEED";
  FileOptions_OptimizeMode[FileOptions_OptimizeMode["CODE_SIZE"] = 2] = "CODE_SIZE";
  FileOptions_OptimizeMode[FileOptions_OptimizeMode["LITE_RUNTIME"] = 3] = "LITE_RUNTIME";
  FileOptions_OptimizeMode[FileOptions_OptimizeMode["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(FileOptions_OptimizeMode || (FileOptions_OptimizeMode = {}));

const FileOptions_OptimizeModeSDKType = FileOptions_OptimizeMode;
const FileOptions_OptimizeModeAmino = FileOptions_OptimizeMode;
function fileOptions_OptimizeModeFromJSON(object) {
  switch (object) {
    case 1:
    case "SPEED":
      return FileOptions_OptimizeMode.SPEED;

    case 2:
    case "CODE_SIZE":
      return FileOptions_OptimizeMode.CODE_SIZE;

    case 3:
    case "LITE_RUNTIME":
      return FileOptions_OptimizeMode.LITE_RUNTIME;

    case -1:
    case "UNRECOGNIZED":
    default:
      return FileOptions_OptimizeMode.UNRECOGNIZED;
  }
}
function fileOptions_OptimizeModeToJSON(object) {
  switch (object) {
    case FileOptions_OptimizeMode.SPEED:
      return "SPEED";

    case FileOptions_OptimizeMode.CODE_SIZE:
      return "CODE_SIZE";

    case FileOptions_OptimizeMode.LITE_RUNTIME:
      return "LITE_RUNTIME";

    case FileOptions_OptimizeMode.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
let FieldOptions_CType;

(function (FieldOptions_CType) {
  FieldOptions_CType[FieldOptions_CType["STRING"] = 0] = "STRING";
  FieldOptions_CType[FieldOptions_CType["CORD"] = 1] = "CORD";
  FieldOptions_CType[FieldOptions_CType["STRING_PIECE"] = 2] = "STRING_PIECE";
  FieldOptions_CType[FieldOptions_CType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(FieldOptions_CType || (FieldOptions_CType = {}));

const FieldOptions_CTypeSDKType = FieldOptions_CType;
const FieldOptions_CTypeAmino = FieldOptions_CType;
function fieldOptions_CTypeFromJSON(object) {
  switch (object) {
    case 0:
    case "STRING":
      return FieldOptions_CType.STRING;

    case 1:
    case "CORD":
      return FieldOptions_CType.CORD;

    case 2:
    case "STRING_PIECE":
      return FieldOptions_CType.STRING_PIECE;

    case -1:
    case "UNRECOGNIZED":
    default:
      return FieldOptions_CType.UNRECOGNIZED;
  }
}
function fieldOptions_CTypeToJSON(object) {
  switch (object) {
    case FieldOptions_CType.STRING:
      return "STRING";

    case FieldOptions_CType.CORD:
      return "CORD";

    case FieldOptions_CType.STRING_PIECE:
      return "STRING_PIECE";

    case FieldOptions_CType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
let FieldOptions_JSType;

(function (FieldOptions_JSType) {
  FieldOptions_JSType[FieldOptions_JSType["JS_NORMAL"] = 0] = "JS_NORMAL";
  FieldOptions_JSType[FieldOptions_JSType["JS_STRING"] = 1] = "JS_STRING";
  FieldOptions_JSType[FieldOptions_JSType["JS_NUMBER"] = 2] = "JS_NUMBER";
  FieldOptions_JSType[FieldOptions_JSType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(FieldOptions_JSType || (FieldOptions_JSType = {}));

const FieldOptions_JSTypeSDKType = FieldOptions_JSType;
const FieldOptions_JSTypeAmino = FieldOptions_JSType;
function fieldOptions_JSTypeFromJSON(object) {
  switch (object) {
    case 0:
    case "JS_NORMAL":
      return FieldOptions_JSType.JS_NORMAL;

    case 1:
    case "JS_STRING":
      return FieldOptions_JSType.JS_STRING;

    case 2:
    case "JS_NUMBER":
      return FieldOptions_JSType.JS_NUMBER;

    case -1:
    case "UNRECOGNIZED":
    default:
      return FieldOptions_JSType.UNRECOGNIZED;
  }
}
function fieldOptions_JSTypeToJSON(object) {
  switch (object) {
    case FieldOptions_JSType.JS_NORMAL:
      return "JS_NORMAL";

    case FieldOptions_JSType.JS_STRING:
      return "JS_STRING";

    case FieldOptions_JSType.JS_NUMBER:
      return "JS_NUMBER";

    case FieldOptions_JSType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
/**
 * Is this method side-effect-free (or safe in HTTP parlance), or idempotent,
 * or neither? HTTP based RPC implementation may choose GET verb for safe
 * methods, and PUT verb for idempotent methods instead of the default POST.
 */

let MethodOptions_IdempotencyLevel;

(function (MethodOptions_IdempotencyLevel) {
  MethodOptions_IdempotencyLevel[MethodOptions_IdempotencyLevel["IDEMPOTENCY_UNKNOWN"] = 0] = "IDEMPOTENCY_UNKNOWN";
  MethodOptions_IdempotencyLevel[MethodOptions_IdempotencyLevel["NO_SIDE_EFFECTS"] = 1] = "NO_SIDE_EFFECTS";
  MethodOptions_IdempotencyLevel[MethodOptions_IdempotencyLevel["IDEMPOTENT"] = 2] = "IDEMPOTENT";
  MethodOptions_IdempotencyLevel[MethodOptions_IdempotencyLevel["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(MethodOptions_IdempotencyLevel || (MethodOptions_IdempotencyLevel = {}));

const MethodOptions_IdempotencyLevelSDKType = MethodOptions_IdempotencyLevel;
const MethodOptions_IdempotencyLevelAmino = MethodOptions_IdempotencyLevel;
function methodOptions_IdempotencyLevelFromJSON(object) {
  switch (object) {
    case 0:
    case "IDEMPOTENCY_UNKNOWN":
      return MethodOptions_IdempotencyLevel.IDEMPOTENCY_UNKNOWN;

    case 1:
    case "NO_SIDE_EFFECTS":
      return MethodOptions_IdempotencyLevel.NO_SIDE_EFFECTS;

    case 2:
    case "IDEMPOTENT":
      return MethodOptions_IdempotencyLevel.IDEMPOTENT;

    case -1:
    case "UNRECOGNIZED":
    default:
      return MethodOptions_IdempotencyLevel.UNRECOGNIZED;
  }
}
function methodOptions_IdempotencyLevelToJSON(object) {
  switch (object) {
    case MethodOptions_IdempotencyLevel.IDEMPOTENCY_UNKNOWN:
      return "IDEMPOTENCY_UNKNOWN";

    case MethodOptions_IdempotencyLevel.NO_SIDE_EFFECTS:
      return "NO_SIDE_EFFECTS";

    case MethodOptions_IdempotencyLevel.IDEMPOTENT:
      return "IDEMPOTENT";

    case MethodOptions_IdempotencyLevel.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
/**
 * The protocol compiler can output a FileDescriptorSet containing the .proto
 * files it parses.
 */

function createBaseFileDescriptorSet() {
  return {
    file: []
  };
}

const FileDescriptorSet = {
  typeUrl: "/google.protobuf.FileDescriptorSet",

  encode(message, writer = minimal.Writer.create()) {
    for (const v of message.file) {
      FileDescriptorProto.encode(v, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFileDescriptorSet();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.file.push(FileDescriptorProto.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$file;

    const message = createBaseFileDescriptorSet();
    message.file = ((_object$file = object.file) === null || _object$file === void 0 ? void 0 : _object$file.map(e => FileDescriptorProto.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      file: Array.isArray(object === null || object === void 0 ? void 0 : object.file) ? object.file.map(e => FileDescriptorProto.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.file) {
      obj.file = message.file.map(e => e ? FileDescriptorProto.toAmino(e) : undefined);
    } else {
      obj.file = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return FileDescriptorSet.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return FileDescriptorSet.decode(message.value);
  },

  toProto(message) {
    return FileDescriptorSet.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/google.protobuf.FileDescriptorSet",
      value: FileDescriptorSet.encode(message).finish()
    };
  }

};

function createBaseFileDescriptorProto() {
  return {
    name: "",
    package: "",
    dependency: [],
    publicDependency: [],
    weakDependency: [],
    messageType: [],
    enumType: [],
    service: [],
    extension: [],
    options: undefined,
    sourceCodeInfo: undefined,
    syntax: ""
  };
}

const FileDescriptorProto = {
  typeUrl: "/google.protobuf.FileDescriptorProto",

  encode(message, writer = minimal.Writer.create()) {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }

    if (message.package !== "") {
      writer.uint32(18).string(message.package);
    }

    for (const v of message.dependency) {
      writer.uint32(26).string(v);
    }

    writer.uint32(82).fork();

    for (const v of message.publicDependency) {
      writer.int32(v);
    }

    writer.ldelim();
    writer.uint32(90).fork();

    for (const v of message.weakDependency) {
      writer.int32(v);
    }

    writer.ldelim();

    for (const v of message.messageType) {
      DescriptorProto.encode(v, writer.uint32(34).fork()).ldelim();
    }

    for (const v of message.enumType) {
      EnumDescriptorProto.encode(v, writer.uint32(42).fork()).ldelim();
    }

    for (const v of message.service) {
      ServiceDescriptorProto.encode(v, writer.uint32(50).fork()).ldelim();
    }

    for (const v of message.extension) {
      FieldDescriptorProto.encode(v, writer.uint32(58).fork()).ldelim();
    }

    if (message.options !== undefined) {
      FileOptions.encode(message.options, writer.uint32(66).fork()).ldelim();
    }

    if (message.sourceCodeInfo !== undefined) {
      SourceCodeInfo.encode(message.sourceCodeInfo, writer.uint32(74).fork()).ldelim();
    }

    if (message.syntax !== "") {
      writer.uint32(98).string(message.syntax);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFileDescriptorProto();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.name = reader.string();
          break;

        case 2:
          message.package = reader.string();
          break;

        case 3:
          message.dependency.push(reader.string());
          break;

        case 10:
          if ((tag & 7) === 2) {
            const end2 = reader.uint32() + reader.pos;

            while (reader.pos < end2) {
              message.publicDependency.push(reader.int32());
            }
          } else {
            message.publicDependency.push(reader.int32());
          }

          break;

        case 11:
          if ((tag & 7) === 2) {
            const end2 = reader.uint32() + reader.pos;

            while (reader.pos < end2) {
              message.weakDependency.push(reader.int32());
            }
          } else {
            message.weakDependency.push(reader.int32());
          }

          break;

        case 4:
          message.messageType.push(DescriptorProto.decode(reader, reader.uint32()));
          break;

        case 5:
          message.enumType.push(EnumDescriptorProto.decode(reader, reader.uint32()));
          break;

        case 6:
          message.service.push(ServiceDescriptorProto.decode(reader, reader.uint32()));
          break;

        case 7:
          message.extension.push(FieldDescriptorProto.decode(reader, reader.uint32()));
          break;

        case 8:
          message.options = FileOptions.decode(reader, reader.uint32());
          break;

        case 9:
          message.sourceCodeInfo = SourceCodeInfo.decode(reader, reader.uint32());
          break;

        case 12:
          message.syntax = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$name, _object$package, _object$dependency, _object$publicDepende, _object$weakDependenc, _object$messageType, _object$enumType, _object$service, _object$extension, _object$syntax;

    const message = createBaseFileDescriptorProto();
    message.name = (_object$name = object.name) !== null && _object$name !== void 0 ? _object$name : "";
    message.package = (_object$package = object.package) !== null && _object$package !== void 0 ? _object$package : "";
    message.dependency = ((_object$dependency = object.dependency) === null || _object$dependency === void 0 ? void 0 : _object$dependency.map(e => e)) || [];
    message.publicDependency = ((_object$publicDepende = object.publicDependency) === null || _object$publicDepende === void 0 ? void 0 : _object$publicDepende.map(e => e)) || [];
    message.weakDependency = ((_object$weakDependenc = object.weakDependency) === null || _object$weakDependenc === void 0 ? void 0 : _object$weakDependenc.map(e => e)) || [];
    message.messageType = ((_object$messageType = object.messageType) === null || _object$messageType === void 0 ? void 0 : _object$messageType.map(e => DescriptorProto.fromPartial(e))) || [];
    message.enumType = ((_object$enumType = object.enumType) === null || _object$enumType === void 0 ? void 0 : _object$enumType.map(e => EnumDescriptorProto.fromPartial(e))) || [];
    message.service = ((_object$service = object.service) === null || _object$service === void 0 ? void 0 : _object$service.map(e => ServiceDescriptorProto.fromPartial(e))) || [];
    message.extension = ((_object$extension = object.extension) === null || _object$extension === void 0 ? void 0 : _object$extension.map(e => FieldDescriptorProto.fromPartial(e))) || [];
    message.options = object.options !== undefined && object.options !== null ? FileOptions.fromPartial(object.options) : undefined;
    message.sourceCodeInfo = object.sourceCodeInfo !== undefined && object.sourceCodeInfo !== null ? SourceCodeInfo.fromPartial(object.sourceCodeInfo) : undefined;
    message.syntax = (_object$syntax = object.syntax) !== null && _object$syntax !== void 0 ? _object$syntax : "";
    return message;
  },

  fromAmino(object) {
    return {
      name: object.name,
      package: object.package,
      dependency: Array.isArray(object === null || object === void 0 ? void 0 : object.dependency) ? object.dependency.map(e => e) : [],
      publicDependency: Array.isArray(object === null || object === void 0 ? void 0 : object.public_dependency) ? object.public_dependency.map(e => e) : [],
      weakDependency: Array.isArray(object === null || object === void 0 ? void 0 : object.weak_dependency) ? object.weak_dependency.map(e => e) : [],
      messageType: Array.isArray(object === null || object === void 0 ? void 0 : object.message_type) ? object.message_type.map(e => DescriptorProto.fromAmino(e)) : [],
      enumType: Array.isArray(object === null || object === void 0 ? void 0 : object.enum_type) ? object.enum_type.map(e => EnumDescriptorProto.fromAmino(e)) : [],
      service: Array.isArray(object === null || object === void 0 ? void 0 : object.service) ? object.service.map(e => ServiceDescriptorProto.fromAmino(e)) : [],
      extension: Array.isArray(object === null || object === void 0 ? void 0 : object.extension) ? object.extension.map(e => FieldDescriptorProto.fromAmino(e)) : [],
      options: object !== null && object !== void 0 && object.options ? FileOptions.fromAmino(object.options) : undefined,
      sourceCodeInfo: object !== null && object !== void 0 && object.source_code_info ? SourceCodeInfo.fromAmino(object.source_code_info) : undefined,
      syntax: object.syntax
    };
  },

  toAmino(message) {
    const obj = {};
    obj.name = message.name;
    obj.package = message.package;

    if (message.dependency) {
      obj.dependency = message.dependency.map(e => e);
    } else {
      obj.dependency = [];
    }

    if (message.publicDependency) {
      obj.public_dependency = message.publicDependency.map(e => e);
    } else {
      obj.public_dependency = [];
    }

    if (message.weakDependency) {
      obj.weak_dependency = message.weakDependency.map(e => e);
    } else {
      obj.weak_dependency = [];
    }

    if (message.messageType) {
      obj.message_type = message.messageType.map(e => e ? DescriptorProto.toAmino(e) : undefined);
    } else {
      obj.message_type = [];
    }

    if (message.enumType) {
      obj.enum_type = message.enumType.map(e => e ? EnumDescriptorProto.toAmino(e) : undefined);
    } else {
      obj.enum_type = [];
    }

    if (message.service) {
      obj.service = message.service.map(e => e ? ServiceDescriptorProto.toAmino(e) : undefined);
    } else {
      obj.service = [];
    }

    if (message.extension) {
      obj.extension = message.extension.map(e => e ? FieldDescriptorProto.toAmino(e) : undefined);
    } else {
      obj.extension = [];
    }

    obj.options = message.options ? FileOptions.toAmino(message.options) : undefined;
    obj.source_code_info = message.sourceCodeInfo ? SourceCodeInfo.toAmino(message.sourceCodeInfo) : undefined;
    obj.syntax = message.syntax;
    return obj;
  },

  fromAminoMsg(object) {
    return FileDescriptorProto.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return FileDescriptorProto.decode(message.value);
  },

  toProto(message) {
    return FileDescriptorProto.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/google.protobuf.FileDescriptorProto",
      value: FileDescriptorProto.encode(message).finish()
    };
  }

};

function createBaseDescriptorProto() {
  return {
    name: "",
    field: [],
    extension: [],
    nestedType: [],
    enumType: [],
    extensionRange: [],
    oneofDecl: [],
    options: undefined,
    reservedRange: [],
    reservedName: []
  };
}

const DescriptorProto = {
  typeUrl: "/google.protobuf.DescriptorProto",

  encode(message, writer = minimal.Writer.create()) {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }

    for (const v of message.field) {
      FieldDescriptorProto.encode(v, writer.uint32(18).fork()).ldelim();
    }

    for (const v of message.extension) {
      FieldDescriptorProto.encode(v, writer.uint32(50).fork()).ldelim();
    }

    for (const v of message.nestedType) {
      DescriptorProto.encode(v, writer.uint32(26).fork()).ldelim();
    }

    for (const v of message.enumType) {
      EnumDescriptorProto.encode(v, writer.uint32(34).fork()).ldelim();
    }

    for (const v of message.extensionRange) {
      DescriptorProto_ExtensionRange.encode(v, writer.uint32(42).fork()).ldelim();
    }

    for (const v of message.oneofDecl) {
      OneofDescriptorProto.encode(v, writer.uint32(66).fork()).ldelim();
    }

    if (message.options !== undefined) {
      MessageOptions.encode(message.options, writer.uint32(58).fork()).ldelim();
    }

    for (const v of message.reservedRange) {
      DescriptorProto_ReservedRange.encode(v, writer.uint32(74).fork()).ldelim();
    }

    for (const v of message.reservedName) {
      writer.uint32(82).string(v);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDescriptorProto();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.name = reader.string();
          break;

        case 2:
          message.field.push(FieldDescriptorProto.decode(reader, reader.uint32()));
          break;

        case 6:
          message.extension.push(FieldDescriptorProto.decode(reader, reader.uint32()));
          break;

        case 3:
          message.nestedType.push(DescriptorProto.decode(reader, reader.uint32()));
          break;

        case 4:
          message.enumType.push(EnumDescriptorProto.decode(reader, reader.uint32()));
          break;

        case 5:
          message.extensionRange.push(DescriptorProto_ExtensionRange.decode(reader, reader.uint32()));
          break;

        case 8:
          message.oneofDecl.push(OneofDescriptorProto.decode(reader, reader.uint32()));
          break;

        case 7:
          message.options = MessageOptions.decode(reader, reader.uint32());
          break;

        case 9:
          message.reservedRange.push(DescriptorProto_ReservedRange.decode(reader, reader.uint32()));
          break;

        case 10:
          message.reservedName.push(reader.string());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$name2, _object$field, _object$extension2, _object$nestedType, _object$enumType2, _object$extensionRang, _object$oneofDecl, _object$reservedRange, _object$reservedName;

    const message = createBaseDescriptorProto();
    message.name = (_object$name2 = object.name) !== null && _object$name2 !== void 0 ? _object$name2 : "";
    message.field = ((_object$field = object.field) === null || _object$field === void 0 ? void 0 : _object$field.map(e => FieldDescriptorProto.fromPartial(e))) || [];
    message.extension = ((_object$extension2 = object.extension) === null || _object$extension2 === void 0 ? void 0 : _object$extension2.map(e => FieldDescriptorProto.fromPartial(e))) || [];
    message.nestedType = ((_object$nestedType = object.nestedType) === null || _object$nestedType === void 0 ? void 0 : _object$nestedType.map(e => DescriptorProto.fromPartial(e))) || [];
    message.enumType = ((_object$enumType2 = object.enumType) === null || _object$enumType2 === void 0 ? void 0 : _object$enumType2.map(e => EnumDescriptorProto.fromPartial(e))) || [];
    message.extensionRange = ((_object$extensionRang = object.extensionRange) === null || _object$extensionRang === void 0 ? void 0 : _object$extensionRang.map(e => DescriptorProto_ExtensionRange.fromPartial(e))) || [];
    message.oneofDecl = ((_object$oneofDecl = object.oneofDecl) === null || _object$oneofDecl === void 0 ? void 0 : _object$oneofDecl.map(e => OneofDescriptorProto.fromPartial(e))) || [];
    message.options = object.options !== undefined && object.options !== null ? MessageOptions.fromPartial(object.options) : undefined;
    message.reservedRange = ((_object$reservedRange = object.reservedRange) === null || _object$reservedRange === void 0 ? void 0 : _object$reservedRange.map(e => DescriptorProto_ReservedRange.fromPartial(e))) || [];
    message.reservedName = ((_object$reservedName = object.reservedName) === null || _object$reservedName === void 0 ? void 0 : _object$reservedName.map(e => e)) || [];
    return message;
  },

  fromAmino(object) {
    return {
      name: object.name,
      field: Array.isArray(object === null || object === void 0 ? void 0 : object.field) ? object.field.map(e => FieldDescriptorProto.fromAmino(e)) : [],
      extension: Array.isArray(object === null || object === void 0 ? void 0 : object.extension) ? object.extension.map(e => FieldDescriptorProto.fromAmino(e)) : [],
      nestedType: Array.isArray(object === null || object === void 0 ? void 0 : object.nested_type) ? object.nested_type.map(e => DescriptorProto.fromAmino(e)) : [],
      enumType: Array.isArray(object === null || object === void 0 ? void 0 : object.enum_type) ? object.enum_type.map(e => EnumDescriptorProto.fromAmino(e)) : [],
      extensionRange: Array.isArray(object === null || object === void 0 ? void 0 : object.extension_range) ? object.extension_range.map(e => DescriptorProto_ExtensionRange.fromAmino(e)) : [],
      oneofDecl: Array.isArray(object === null || object === void 0 ? void 0 : object.oneof_decl) ? object.oneof_decl.map(e => OneofDescriptorProto.fromAmino(e)) : [],
      options: object !== null && object !== void 0 && object.options ? MessageOptions.fromAmino(object.options) : undefined,
      reservedRange: Array.isArray(object === null || object === void 0 ? void 0 : object.reserved_range) ? object.reserved_range.map(e => DescriptorProto_ReservedRange.fromAmino(e)) : [],
      reservedName: Array.isArray(object === null || object === void 0 ? void 0 : object.reserved_name) ? object.reserved_name.map(e => e) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.name = message.name;

    if (message.field) {
      obj.field = message.field.map(e => e ? FieldDescriptorProto.toAmino(e) : undefined);
    } else {
      obj.field = [];
    }

    if (message.extension) {
      obj.extension = message.extension.map(e => e ? FieldDescriptorProto.toAmino(e) : undefined);
    } else {
      obj.extension = [];
    }

    if (message.nestedType) {
      obj.nested_type = message.nestedType.map(e => e ? DescriptorProto.toAmino(e) : undefined);
    } else {
      obj.nested_type = [];
    }

    if (message.enumType) {
      obj.enum_type = message.enumType.map(e => e ? EnumDescriptorProto.toAmino(e) : undefined);
    } else {
      obj.enum_type = [];
    }

    if (message.extensionRange) {
      obj.extension_range = message.extensionRange.map(e => e ? DescriptorProto_ExtensionRange.toAmino(e) : undefined);
    } else {
      obj.extension_range = [];
    }

    if (message.oneofDecl) {
      obj.oneof_decl = message.oneofDecl.map(e => e ? OneofDescriptorProto.toAmino(e) : undefined);
    } else {
      obj.oneof_decl = [];
    }

    obj.options = message.options ? MessageOptions.toAmino(message.options) : undefined;

    if (message.reservedRange) {
      obj.reserved_range = message.reservedRange.map(e => e ? DescriptorProto_ReservedRange.toAmino(e) : undefined);
    } else {
      obj.reserved_range = [];
    }

    if (message.reservedName) {
      obj.reserved_name = message.reservedName.map(e => e);
    } else {
      obj.reserved_name = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return DescriptorProto.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return DescriptorProto.decode(message.value);
  },

  toProto(message) {
    return DescriptorProto.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/google.protobuf.DescriptorProto",
      value: DescriptorProto.encode(message).finish()
    };
  }

};

function createBaseDescriptorProto_ExtensionRange() {
  return {
    start: 0,
    end: 0,
    options: undefined
  };
}

const DescriptorProto_ExtensionRange = {
  typeUrl: "/google.protobuf.ExtensionRange",

  encode(message, writer = minimal.Writer.create()) {
    if (message.start !== 0) {
      writer.uint32(8).int32(message.start);
    }

    if (message.end !== 0) {
      writer.uint32(16).int32(message.end);
    }

    if (message.options !== undefined) {
      ExtensionRangeOptions.encode(message.options, writer.uint32(26).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDescriptorProto_ExtensionRange();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.start = reader.int32();
          break;

        case 2:
          message.end = reader.int32();
          break;

        case 3:
          message.options = ExtensionRangeOptions.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$start, _object$end;

    const message = createBaseDescriptorProto_ExtensionRange();
    message.start = (_object$start = object.start) !== null && _object$start !== void 0 ? _object$start : 0;
    message.end = (_object$end = object.end) !== null && _object$end !== void 0 ? _object$end : 0;
    message.options = object.options !== undefined && object.options !== null ? ExtensionRangeOptions.fromPartial(object.options) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      start: object.start,
      end: object.end,
      options: object !== null && object !== void 0 && object.options ? ExtensionRangeOptions.fromAmino(object.options) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.start = message.start;
    obj.end = message.end;
    obj.options = message.options ? ExtensionRangeOptions.toAmino(message.options) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return DescriptorProto_ExtensionRange.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return DescriptorProto_ExtensionRange.decode(message.value);
  },

  toProto(message) {
    return DescriptorProto_ExtensionRange.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/google.protobuf.ExtensionRange",
      value: DescriptorProto_ExtensionRange.encode(message).finish()
    };
  }

};

function createBaseDescriptorProto_ReservedRange() {
  return {
    start: 0,
    end: 0
  };
}

const DescriptorProto_ReservedRange = {
  typeUrl: "/google.protobuf.ReservedRange",

  encode(message, writer = minimal.Writer.create()) {
    if (message.start !== 0) {
      writer.uint32(8).int32(message.start);
    }

    if (message.end !== 0) {
      writer.uint32(16).int32(message.end);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDescriptorProto_ReservedRange();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.start = reader.int32();
          break;

        case 2:
          message.end = reader.int32();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$start2, _object$end2;

    const message = createBaseDescriptorProto_ReservedRange();
    message.start = (_object$start2 = object.start) !== null && _object$start2 !== void 0 ? _object$start2 : 0;
    message.end = (_object$end2 = object.end) !== null && _object$end2 !== void 0 ? _object$end2 : 0;
    return message;
  },

  fromAmino(object) {
    return {
      start: object.start,
      end: object.end
    };
  },

  toAmino(message) {
    const obj = {};
    obj.start = message.start;
    obj.end = message.end;
    return obj;
  },

  fromAminoMsg(object) {
    return DescriptorProto_ReservedRange.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return DescriptorProto_ReservedRange.decode(message.value);
  },

  toProto(message) {
    return DescriptorProto_ReservedRange.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/google.protobuf.ReservedRange",
      value: DescriptorProto_ReservedRange.encode(message).finish()
    };
  }

};

function createBaseExtensionRangeOptions() {
  return {
    uninterpretedOption: []
  };
}

const ExtensionRangeOptions = {
  typeUrl: "/google.protobuf.ExtensionRangeOptions",

  encode(message, writer = minimal.Writer.create()) {
    for (const v of message.uninterpretedOption) {
      UninterpretedOption.encode(v, writer.uint32(7994).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseExtensionRangeOptions();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 999:
          message.uninterpretedOption.push(UninterpretedOption.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$uninterpreted;

    const message = createBaseExtensionRangeOptions();
    message.uninterpretedOption = ((_object$uninterpreted = object.uninterpretedOption) === null || _object$uninterpreted === void 0 ? void 0 : _object$uninterpreted.map(e => UninterpretedOption.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      uninterpretedOption: Array.isArray(object === null || object === void 0 ? void 0 : object.uninterpreted_option) ? object.uninterpreted_option.map(e => UninterpretedOption.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.uninterpretedOption) {
      obj.uninterpreted_option = message.uninterpretedOption.map(e => e ? UninterpretedOption.toAmino(e) : undefined);
    } else {
      obj.uninterpreted_option = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return ExtensionRangeOptions.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return ExtensionRangeOptions.decode(message.value);
  },

  toProto(message) {
    return ExtensionRangeOptions.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/google.protobuf.ExtensionRangeOptions",
      value: ExtensionRangeOptions.encode(message).finish()
    };
  }

};

function createBaseFieldDescriptorProto() {
  return {
    name: "",
    number: 0,
    label: 1,
    type: 1,
    typeName: "",
    extendee: "",
    defaultValue: "",
    oneofIndex: 0,
    jsonName: "",
    options: undefined
  };
}

const FieldDescriptorProto = {
  typeUrl: "/google.protobuf.FieldDescriptorProto",

  encode(message, writer = minimal.Writer.create()) {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }

    if (message.number !== 0) {
      writer.uint32(24).int32(message.number);
    }

    if (message.label !== 1) {
      writer.uint32(32).int32(message.label);
    }

    if (message.type !== 1) {
      writer.uint32(40).int32(message.type);
    }

    if (message.typeName !== "") {
      writer.uint32(50).string(message.typeName);
    }

    if (message.extendee !== "") {
      writer.uint32(18).string(message.extendee);
    }

    if (message.defaultValue !== "") {
      writer.uint32(58).string(message.defaultValue);
    }

    if (message.oneofIndex !== 0) {
      writer.uint32(72).int32(message.oneofIndex);
    }

    if (message.jsonName !== "") {
      writer.uint32(82).string(message.jsonName);
    }

    if (message.options !== undefined) {
      FieldOptions.encode(message.options, writer.uint32(66).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFieldDescriptorProto();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.name = reader.string();
          break;

        case 3:
          message.number = reader.int32();
          break;

        case 4:
          message.label = reader.int32();
          break;

        case 5:
          message.type = reader.int32();
          break;

        case 6:
          message.typeName = reader.string();
          break;

        case 2:
          message.extendee = reader.string();
          break;

        case 7:
          message.defaultValue = reader.string();
          break;

        case 9:
          message.oneofIndex = reader.int32();
          break;

        case 10:
          message.jsonName = reader.string();
          break;

        case 8:
          message.options = FieldOptions.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$name3, _object$number, _object$label, _object$type, _object$typeName, _object$extendee, _object$defaultValue, _object$oneofIndex, _object$jsonName;

    const message = createBaseFieldDescriptorProto();
    message.name = (_object$name3 = object.name) !== null && _object$name3 !== void 0 ? _object$name3 : "";
    message.number = (_object$number = object.number) !== null && _object$number !== void 0 ? _object$number : 0;
    message.label = (_object$label = object.label) !== null && _object$label !== void 0 ? _object$label : 1;
    message.type = (_object$type = object.type) !== null && _object$type !== void 0 ? _object$type : 1;
    message.typeName = (_object$typeName = object.typeName) !== null && _object$typeName !== void 0 ? _object$typeName : "";
    message.extendee = (_object$extendee = object.extendee) !== null && _object$extendee !== void 0 ? _object$extendee : "";
    message.defaultValue = (_object$defaultValue = object.defaultValue) !== null && _object$defaultValue !== void 0 ? _object$defaultValue : "";
    message.oneofIndex = (_object$oneofIndex = object.oneofIndex) !== null && _object$oneofIndex !== void 0 ? _object$oneofIndex : 0;
    message.jsonName = (_object$jsonName = object.jsonName) !== null && _object$jsonName !== void 0 ? _object$jsonName : "";
    message.options = object.options !== undefined && object.options !== null ? FieldOptions.fromPartial(object.options) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      name: object.name,
      number: object.number,
      label: (0,helpers/* isSet */.DM)(object.label) ? fieldDescriptorProto_LabelFromJSON(object.label) : 0,
      type: (0,helpers/* isSet */.DM)(object.type) ? fieldDescriptorProto_TypeFromJSON(object.type) : 0,
      typeName: object.type_name,
      extendee: object.extendee,
      defaultValue: object.default_value,
      oneofIndex: object.oneof_index,
      jsonName: object.json_name,
      options: object !== null && object !== void 0 && object.options ? FieldOptions.fromAmino(object.options) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.name = message.name;
    obj.number = message.number;
    obj.label = message.label;
    obj.type = message.type;
    obj.type_name = message.typeName;
    obj.extendee = message.extendee;
    obj.default_value = message.defaultValue;
    obj.oneof_index = message.oneofIndex;
    obj.json_name = message.jsonName;
    obj.options = message.options ? FieldOptions.toAmino(message.options) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return FieldDescriptorProto.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return FieldDescriptorProto.decode(message.value);
  },

  toProto(message) {
    return FieldDescriptorProto.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/google.protobuf.FieldDescriptorProto",
      value: FieldDescriptorProto.encode(message).finish()
    };
  }

};

function createBaseOneofDescriptorProto() {
  return {
    name: "",
    options: undefined
  };
}

const OneofDescriptorProto = {
  typeUrl: "/google.protobuf.OneofDescriptorProto",

  encode(message, writer = minimal.Writer.create()) {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }

    if (message.options !== undefined) {
      OneofOptions.encode(message.options, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOneofDescriptorProto();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.name = reader.string();
          break;

        case 2:
          message.options = OneofOptions.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$name4;

    const message = createBaseOneofDescriptorProto();
    message.name = (_object$name4 = object.name) !== null && _object$name4 !== void 0 ? _object$name4 : "";
    message.options = object.options !== undefined && object.options !== null ? OneofOptions.fromPartial(object.options) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      name: object.name,
      options: object !== null && object !== void 0 && object.options ? OneofOptions.fromAmino(object.options) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.name = message.name;
    obj.options = message.options ? OneofOptions.toAmino(message.options) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return OneofDescriptorProto.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return OneofDescriptorProto.decode(message.value);
  },

  toProto(message) {
    return OneofDescriptorProto.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/google.protobuf.OneofDescriptorProto",
      value: OneofDescriptorProto.encode(message).finish()
    };
  }

};

function createBaseEnumDescriptorProto() {
  return {
    name: "",
    value: [],
    options: undefined,
    reservedRange: [],
    reservedName: []
  };
}

const EnumDescriptorProto = {
  typeUrl: "/google.protobuf.EnumDescriptorProto",

  encode(message, writer = minimal.Writer.create()) {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }

    for (const v of message.value) {
      EnumValueDescriptorProto.encode(v, writer.uint32(18).fork()).ldelim();
    }

    if (message.options !== undefined) {
      EnumOptions.encode(message.options, writer.uint32(26).fork()).ldelim();
    }

    for (const v of message.reservedRange) {
      EnumDescriptorProto_EnumReservedRange.encode(v, writer.uint32(34).fork()).ldelim();
    }

    for (const v of message.reservedName) {
      writer.uint32(42).string(v);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEnumDescriptorProto();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.name = reader.string();
          break;

        case 2:
          message.value.push(EnumValueDescriptorProto.decode(reader, reader.uint32()));
          break;

        case 3:
          message.options = EnumOptions.decode(reader, reader.uint32());
          break;

        case 4:
          message.reservedRange.push(EnumDescriptorProto_EnumReservedRange.decode(reader, reader.uint32()));
          break;

        case 5:
          message.reservedName.push(reader.string());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$name5, _object$value, _object$reservedRange2, _object$reservedName2;

    const message = createBaseEnumDescriptorProto();
    message.name = (_object$name5 = object.name) !== null && _object$name5 !== void 0 ? _object$name5 : "";
    message.value = ((_object$value = object.value) === null || _object$value === void 0 ? void 0 : _object$value.map(e => EnumValueDescriptorProto.fromPartial(e))) || [];
    message.options = object.options !== undefined && object.options !== null ? EnumOptions.fromPartial(object.options) : undefined;
    message.reservedRange = ((_object$reservedRange2 = object.reservedRange) === null || _object$reservedRange2 === void 0 ? void 0 : _object$reservedRange2.map(e => EnumDescriptorProto_EnumReservedRange.fromPartial(e))) || [];
    message.reservedName = ((_object$reservedName2 = object.reservedName) === null || _object$reservedName2 === void 0 ? void 0 : _object$reservedName2.map(e => e)) || [];
    return message;
  },

  fromAmino(object) {
    return {
      name: object.name,
      value: Array.isArray(object === null || object === void 0 ? void 0 : object.value) ? object.value.map(e => EnumValueDescriptorProto.fromAmino(e)) : [],
      options: object !== null && object !== void 0 && object.options ? EnumOptions.fromAmino(object.options) : undefined,
      reservedRange: Array.isArray(object === null || object === void 0 ? void 0 : object.reserved_range) ? object.reserved_range.map(e => EnumDescriptorProto_EnumReservedRange.fromAmino(e)) : [],
      reservedName: Array.isArray(object === null || object === void 0 ? void 0 : object.reserved_name) ? object.reserved_name.map(e => e) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.name = message.name;

    if (message.value) {
      obj.value = message.value.map(e => e ? EnumValueDescriptorProto.toAmino(e) : undefined);
    } else {
      obj.value = [];
    }

    obj.options = message.options ? EnumOptions.toAmino(message.options) : undefined;

    if (message.reservedRange) {
      obj.reserved_range = message.reservedRange.map(e => e ? EnumDescriptorProto_EnumReservedRange.toAmino(e) : undefined);
    } else {
      obj.reserved_range = [];
    }

    if (message.reservedName) {
      obj.reserved_name = message.reservedName.map(e => e);
    } else {
      obj.reserved_name = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return EnumDescriptorProto.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return EnumDescriptorProto.decode(message.value);
  },

  toProto(message) {
    return EnumDescriptorProto.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/google.protobuf.EnumDescriptorProto",
      value: EnumDescriptorProto.encode(message).finish()
    };
  }

};

function createBaseEnumDescriptorProto_EnumReservedRange() {
  return {
    start: 0,
    end: 0
  };
}

const EnumDescriptorProto_EnumReservedRange = {
  typeUrl: "/google.protobuf.EnumReservedRange",

  encode(message, writer = minimal.Writer.create()) {
    if (message.start !== 0) {
      writer.uint32(8).int32(message.start);
    }

    if (message.end !== 0) {
      writer.uint32(16).int32(message.end);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEnumDescriptorProto_EnumReservedRange();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.start = reader.int32();
          break;

        case 2:
          message.end = reader.int32();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$start3, _object$end3;

    const message = createBaseEnumDescriptorProto_EnumReservedRange();
    message.start = (_object$start3 = object.start) !== null && _object$start3 !== void 0 ? _object$start3 : 0;
    message.end = (_object$end3 = object.end) !== null && _object$end3 !== void 0 ? _object$end3 : 0;
    return message;
  },

  fromAmino(object) {
    return {
      start: object.start,
      end: object.end
    };
  },

  toAmino(message) {
    const obj = {};
    obj.start = message.start;
    obj.end = message.end;
    return obj;
  },

  fromAminoMsg(object) {
    return EnumDescriptorProto_EnumReservedRange.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return EnumDescriptorProto_EnumReservedRange.decode(message.value);
  },

  toProto(message) {
    return EnumDescriptorProto_EnumReservedRange.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/google.protobuf.EnumReservedRange",
      value: EnumDescriptorProto_EnumReservedRange.encode(message).finish()
    };
  }

};

function createBaseEnumValueDescriptorProto() {
  return {
    name: "",
    number: 0,
    options: undefined
  };
}

const EnumValueDescriptorProto = {
  typeUrl: "/google.protobuf.EnumValueDescriptorProto",

  encode(message, writer = minimal.Writer.create()) {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }

    if (message.number !== 0) {
      writer.uint32(16).int32(message.number);
    }

    if (message.options !== undefined) {
      EnumValueOptions.encode(message.options, writer.uint32(26).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEnumValueDescriptorProto();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.name = reader.string();
          break;

        case 2:
          message.number = reader.int32();
          break;

        case 3:
          message.options = EnumValueOptions.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$name6, _object$number2;

    const message = createBaseEnumValueDescriptorProto();
    message.name = (_object$name6 = object.name) !== null && _object$name6 !== void 0 ? _object$name6 : "";
    message.number = (_object$number2 = object.number) !== null && _object$number2 !== void 0 ? _object$number2 : 0;
    message.options = object.options !== undefined && object.options !== null ? EnumValueOptions.fromPartial(object.options) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      name: object.name,
      number: object.number,
      options: object !== null && object !== void 0 && object.options ? EnumValueOptions.fromAmino(object.options) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.name = message.name;
    obj.number = message.number;
    obj.options = message.options ? EnumValueOptions.toAmino(message.options) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return EnumValueDescriptorProto.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return EnumValueDescriptorProto.decode(message.value);
  },

  toProto(message) {
    return EnumValueDescriptorProto.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/google.protobuf.EnumValueDescriptorProto",
      value: EnumValueDescriptorProto.encode(message).finish()
    };
  }

};

function createBaseServiceDescriptorProto() {
  return {
    name: "",
    method: [],
    options: undefined
  };
}

const ServiceDescriptorProto = {
  typeUrl: "/google.protobuf.ServiceDescriptorProto",

  encode(message, writer = minimal.Writer.create()) {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }

    for (const v of message.method) {
      MethodDescriptorProto.encode(v, writer.uint32(18).fork()).ldelim();
    }

    if (message.options !== undefined) {
      ServiceOptions.encode(message.options, writer.uint32(26).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseServiceDescriptorProto();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.name = reader.string();
          break;

        case 2:
          message.method.push(MethodDescriptorProto.decode(reader, reader.uint32()));
          break;

        case 3:
          message.options = ServiceOptions.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$name7, _object$method;

    const message = createBaseServiceDescriptorProto();
    message.name = (_object$name7 = object.name) !== null && _object$name7 !== void 0 ? _object$name7 : "";
    message.method = ((_object$method = object.method) === null || _object$method === void 0 ? void 0 : _object$method.map(e => MethodDescriptorProto.fromPartial(e))) || [];
    message.options = object.options !== undefined && object.options !== null ? ServiceOptions.fromPartial(object.options) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      name: object.name,
      method: Array.isArray(object === null || object === void 0 ? void 0 : object.method) ? object.method.map(e => MethodDescriptorProto.fromAmino(e)) : [],
      options: object !== null && object !== void 0 && object.options ? ServiceOptions.fromAmino(object.options) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.name = message.name;

    if (message.method) {
      obj.method = message.method.map(e => e ? MethodDescriptorProto.toAmino(e) : undefined);
    } else {
      obj.method = [];
    }

    obj.options = message.options ? ServiceOptions.toAmino(message.options) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return ServiceDescriptorProto.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return ServiceDescriptorProto.decode(message.value);
  },

  toProto(message) {
    return ServiceDescriptorProto.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/google.protobuf.ServiceDescriptorProto",
      value: ServiceDescriptorProto.encode(message).finish()
    };
  }

};

function createBaseMethodDescriptorProto() {
  return {
    name: "",
    inputType: "",
    outputType: "",
    options: undefined,
    clientStreaming: false,
    serverStreaming: false
  };
}

const MethodDescriptorProto = {
  typeUrl: "/google.protobuf.MethodDescriptorProto",

  encode(message, writer = minimal.Writer.create()) {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }

    if (message.inputType !== "") {
      writer.uint32(18).string(message.inputType);
    }

    if (message.outputType !== "") {
      writer.uint32(26).string(message.outputType);
    }

    if (message.options !== undefined) {
      MethodOptions.encode(message.options, writer.uint32(34).fork()).ldelim();
    }

    if (message.clientStreaming === true) {
      writer.uint32(40).bool(message.clientStreaming);
    }

    if (message.serverStreaming === true) {
      writer.uint32(48).bool(message.serverStreaming);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMethodDescriptorProto();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.name = reader.string();
          break;

        case 2:
          message.inputType = reader.string();
          break;

        case 3:
          message.outputType = reader.string();
          break;

        case 4:
          message.options = MethodOptions.decode(reader, reader.uint32());
          break;

        case 5:
          message.clientStreaming = reader.bool();
          break;

        case 6:
          message.serverStreaming = reader.bool();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$name8, _object$inputType, _object$outputType, _object$clientStreami, _object$serverStreami;

    const message = createBaseMethodDescriptorProto();
    message.name = (_object$name8 = object.name) !== null && _object$name8 !== void 0 ? _object$name8 : "";
    message.inputType = (_object$inputType = object.inputType) !== null && _object$inputType !== void 0 ? _object$inputType : "";
    message.outputType = (_object$outputType = object.outputType) !== null && _object$outputType !== void 0 ? _object$outputType : "";
    message.options = object.options !== undefined && object.options !== null ? MethodOptions.fromPartial(object.options) : undefined;
    message.clientStreaming = (_object$clientStreami = object.clientStreaming) !== null && _object$clientStreami !== void 0 ? _object$clientStreami : false;
    message.serverStreaming = (_object$serverStreami = object.serverStreaming) !== null && _object$serverStreami !== void 0 ? _object$serverStreami : false;
    return message;
  },

  fromAmino(object) {
    return {
      name: object.name,
      inputType: object.input_type,
      outputType: object.output_type,
      options: object !== null && object !== void 0 && object.options ? MethodOptions.fromAmino(object.options) : undefined,
      clientStreaming: object.client_streaming,
      serverStreaming: object.server_streaming
    };
  },

  toAmino(message) {
    const obj = {};
    obj.name = message.name;
    obj.input_type = message.inputType;
    obj.output_type = message.outputType;
    obj.options = message.options ? MethodOptions.toAmino(message.options) : undefined;
    obj.client_streaming = message.clientStreaming;
    obj.server_streaming = message.serverStreaming;
    return obj;
  },

  fromAminoMsg(object) {
    return MethodDescriptorProto.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return MethodDescriptorProto.decode(message.value);
  },

  toProto(message) {
    return MethodDescriptorProto.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/google.protobuf.MethodDescriptorProto",
      value: MethodDescriptorProto.encode(message).finish()
    };
  }

};

function createBaseFileOptions() {
  return {
    javaPackage: "",
    javaOuterClassname: "",
    javaMultipleFiles: false,
    javaGenerateEqualsAndHash: false,
    javaStringCheckUtf8: false,
    optimizeFor: 1,
    goPackage: "",
    ccGenericServices: false,
    javaGenericServices: false,
    pyGenericServices: false,
    phpGenericServices: false,
    deprecated: false,
    ccEnableArenas: false,
    objcClassPrefix: "",
    csharpNamespace: "",
    swiftPrefix: "",
    phpClassPrefix: "",
    phpNamespace: "",
    phpMetadataNamespace: "",
    rubyPackage: "",
    uninterpretedOption: []
  };
}

const FileOptions = {
  typeUrl: "/google.protobuf.FileOptions",

  encode(message, writer = minimal.Writer.create()) {
    if (message.javaPackage !== "") {
      writer.uint32(10).string(message.javaPackage);
    }

    if (message.javaOuterClassname !== "") {
      writer.uint32(66).string(message.javaOuterClassname);
    }

    if (message.javaMultipleFiles === true) {
      writer.uint32(80).bool(message.javaMultipleFiles);
    }

    if (message.javaGenerateEqualsAndHash === true) {
      writer.uint32(160).bool(message.javaGenerateEqualsAndHash);
    }

    if (message.javaStringCheckUtf8 === true) {
      writer.uint32(216).bool(message.javaStringCheckUtf8);
    }

    if (message.optimizeFor !== 1) {
      writer.uint32(72).int32(message.optimizeFor);
    }

    if (message.goPackage !== "") {
      writer.uint32(90).string(message.goPackage);
    }

    if (message.ccGenericServices === true) {
      writer.uint32(128).bool(message.ccGenericServices);
    }

    if (message.javaGenericServices === true) {
      writer.uint32(136).bool(message.javaGenericServices);
    }

    if (message.pyGenericServices === true) {
      writer.uint32(144).bool(message.pyGenericServices);
    }

    if (message.phpGenericServices === true) {
      writer.uint32(336).bool(message.phpGenericServices);
    }

    if (message.deprecated === true) {
      writer.uint32(184).bool(message.deprecated);
    }

    if (message.ccEnableArenas === true) {
      writer.uint32(248).bool(message.ccEnableArenas);
    }

    if (message.objcClassPrefix !== "") {
      writer.uint32(290).string(message.objcClassPrefix);
    }

    if (message.csharpNamespace !== "") {
      writer.uint32(298).string(message.csharpNamespace);
    }

    if (message.swiftPrefix !== "") {
      writer.uint32(314).string(message.swiftPrefix);
    }

    if (message.phpClassPrefix !== "") {
      writer.uint32(322).string(message.phpClassPrefix);
    }

    if (message.phpNamespace !== "") {
      writer.uint32(330).string(message.phpNamespace);
    }

    if (message.phpMetadataNamespace !== "") {
      writer.uint32(354).string(message.phpMetadataNamespace);
    }

    if (message.rubyPackage !== "") {
      writer.uint32(362).string(message.rubyPackage);
    }

    for (const v of message.uninterpretedOption) {
      UninterpretedOption.encode(v, writer.uint32(7994).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFileOptions();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.javaPackage = reader.string();
          break;

        case 8:
          message.javaOuterClassname = reader.string();
          break;

        case 10:
          message.javaMultipleFiles = reader.bool();
          break;

        case 20:
          message.javaGenerateEqualsAndHash = reader.bool();
          break;

        case 27:
          message.javaStringCheckUtf8 = reader.bool();
          break;

        case 9:
          message.optimizeFor = reader.int32();
          break;

        case 11:
          message.goPackage = reader.string();
          break;

        case 16:
          message.ccGenericServices = reader.bool();
          break;

        case 17:
          message.javaGenericServices = reader.bool();
          break;

        case 18:
          message.pyGenericServices = reader.bool();
          break;

        case 42:
          message.phpGenericServices = reader.bool();
          break;

        case 23:
          message.deprecated = reader.bool();
          break;

        case 31:
          message.ccEnableArenas = reader.bool();
          break;

        case 36:
          message.objcClassPrefix = reader.string();
          break;

        case 37:
          message.csharpNamespace = reader.string();
          break;

        case 39:
          message.swiftPrefix = reader.string();
          break;

        case 40:
          message.phpClassPrefix = reader.string();
          break;

        case 41:
          message.phpNamespace = reader.string();
          break;

        case 44:
          message.phpMetadataNamespace = reader.string();
          break;

        case 45:
          message.rubyPackage = reader.string();
          break;

        case 999:
          message.uninterpretedOption.push(UninterpretedOption.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$javaPackage, _object$javaOuterClas, _object$javaMultipleF, _object$javaGenerateE, _object$javaStringChe, _object$optimizeFor, _object$goPackage, _object$ccGenericServ, _object$javaGenericSe, _object$pyGenericServ, _object$phpGenericSer, _object$deprecated, _object$ccEnableArena, _object$objcClassPref, _object$csharpNamespa, _object$swiftPrefix, _object$phpClassPrefi, _object$phpNamespace, _object$phpMetadataNa, _object$rubyPackage, _object$uninterpreted2;

    const message = createBaseFileOptions();
    message.javaPackage = (_object$javaPackage = object.javaPackage) !== null && _object$javaPackage !== void 0 ? _object$javaPackage : "";
    message.javaOuterClassname = (_object$javaOuterClas = object.javaOuterClassname) !== null && _object$javaOuterClas !== void 0 ? _object$javaOuterClas : "";
    message.javaMultipleFiles = (_object$javaMultipleF = object.javaMultipleFiles) !== null && _object$javaMultipleF !== void 0 ? _object$javaMultipleF : false;
    message.javaGenerateEqualsAndHash = (_object$javaGenerateE = object.javaGenerateEqualsAndHash) !== null && _object$javaGenerateE !== void 0 ? _object$javaGenerateE : false;
    message.javaStringCheckUtf8 = (_object$javaStringChe = object.javaStringCheckUtf8) !== null && _object$javaStringChe !== void 0 ? _object$javaStringChe : false;
    message.optimizeFor = (_object$optimizeFor = object.optimizeFor) !== null && _object$optimizeFor !== void 0 ? _object$optimizeFor : 1;
    message.goPackage = (_object$goPackage = object.goPackage) !== null && _object$goPackage !== void 0 ? _object$goPackage : "";
    message.ccGenericServices = (_object$ccGenericServ = object.ccGenericServices) !== null && _object$ccGenericServ !== void 0 ? _object$ccGenericServ : false;
    message.javaGenericServices = (_object$javaGenericSe = object.javaGenericServices) !== null && _object$javaGenericSe !== void 0 ? _object$javaGenericSe : false;
    message.pyGenericServices = (_object$pyGenericServ = object.pyGenericServices) !== null && _object$pyGenericServ !== void 0 ? _object$pyGenericServ : false;
    message.phpGenericServices = (_object$phpGenericSer = object.phpGenericServices) !== null && _object$phpGenericSer !== void 0 ? _object$phpGenericSer : false;
    message.deprecated = (_object$deprecated = object.deprecated) !== null && _object$deprecated !== void 0 ? _object$deprecated : false;
    message.ccEnableArenas = (_object$ccEnableArena = object.ccEnableArenas) !== null && _object$ccEnableArena !== void 0 ? _object$ccEnableArena : false;
    message.objcClassPrefix = (_object$objcClassPref = object.objcClassPrefix) !== null && _object$objcClassPref !== void 0 ? _object$objcClassPref : "";
    message.csharpNamespace = (_object$csharpNamespa = object.csharpNamespace) !== null && _object$csharpNamespa !== void 0 ? _object$csharpNamespa : "";
    message.swiftPrefix = (_object$swiftPrefix = object.swiftPrefix) !== null && _object$swiftPrefix !== void 0 ? _object$swiftPrefix : "";
    message.phpClassPrefix = (_object$phpClassPrefi = object.phpClassPrefix) !== null && _object$phpClassPrefi !== void 0 ? _object$phpClassPrefi : "";
    message.phpNamespace = (_object$phpNamespace = object.phpNamespace) !== null && _object$phpNamespace !== void 0 ? _object$phpNamespace : "";
    message.phpMetadataNamespace = (_object$phpMetadataNa = object.phpMetadataNamespace) !== null && _object$phpMetadataNa !== void 0 ? _object$phpMetadataNa : "";
    message.rubyPackage = (_object$rubyPackage = object.rubyPackage) !== null && _object$rubyPackage !== void 0 ? _object$rubyPackage : "";
    message.uninterpretedOption = ((_object$uninterpreted2 = object.uninterpretedOption) === null || _object$uninterpreted2 === void 0 ? void 0 : _object$uninterpreted2.map(e => UninterpretedOption.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      javaPackage: object.java_package,
      javaOuterClassname: object.java_outer_classname,
      javaMultipleFiles: object.java_multiple_files,
      javaGenerateEqualsAndHash: object.java_generate_equals_and_hash,
      javaStringCheckUtf8: object.java_string_check_utf8,
      optimizeFor: (0,helpers/* isSet */.DM)(object.optimize_for) ? fileOptions_OptimizeModeFromJSON(object.optimize_for) : 0,
      goPackage: object.go_package,
      ccGenericServices: object.cc_generic_services,
      javaGenericServices: object.java_generic_services,
      pyGenericServices: object.py_generic_services,
      phpGenericServices: object.php_generic_services,
      deprecated: object.deprecated,
      ccEnableArenas: object.cc_enable_arenas,
      objcClassPrefix: object.objc_class_prefix,
      csharpNamespace: object.csharp_namespace,
      swiftPrefix: object.swift_prefix,
      phpClassPrefix: object.php_class_prefix,
      phpNamespace: object.php_namespace,
      phpMetadataNamespace: object.php_metadata_namespace,
      rubyPackage: object.ruby_package,
      uninterpretedOption: Array.isArray(object === null || object === void 0 ? void 0 : object.uninterpreted_option) ? object.uninterpreted_option.map(e => UninterpretedOption.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.java_package = message.javaPackage;
    obj.java_outer_classname = message.javaOuterClassname;
    obj.java_multiple_files = message.javaMultipleFiles;
    obj.java_generate_equals_and_hash = message.javaGenerateEqualsAndHash;
    obj.java_string_check_utf8 = message.javaStringCheckUtf8;
    obj.optimize_for = message.optimizeFor;
    obj.go_package = message.goPackage;
    obj.cc_generic_services = message.ccGenericServices;
    obj.java_generic_services = message.javaGenericServices;
    obj.py_generic_services = message.pyGenericServices;
    obj.php_generic_services = message.phpGenericServices;
    obj.deprecated = message.deprecated;
    obj.cc_enable_arenas = message.ccEnableArenas;
    obj.objc_class_prefix = message.objcClassPrefix;
    obj.csharp_namespace = message.csharpNamespace;
    obj.swift_prefix = message.swiftPrefix;
    obj.php_class_prefix = message.phpClassPrefix;
    obj.php_namespace = message.phpNamespace;
    obj.php_metadata_namespace = message.phpMetadataNamespace;
    obj.ruby_package = message.rubyPackage;

    if (message.uninterpretedOption) {
      obj.uninterpreted_option = message.uninterpretedOption.map(e => e ? UninterpretedOption.toAmino(e) : undefined);
    } else {
      obj.uninterpreted_option = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return FileOptions.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return FileOptions.decode(message.value);
  },

  toProto(message) {
    return FileOptions.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/google.protobuf.FileOptions",
      value: FileOptions.encode(message).finish()
    };
  }

};

function createBaseMessageOptions() {
  return {
    messageSetWireFormat: false,
    noStandardDescriptorAccessor: false,
    deprecated: false,
    mapEntry: false,
    uninterpretedOption: []
  };
}

const MessageOptions = {
  typeUrl: "/google.protobuf.MessageOptions",

  encode(message, writer = minimal.Writer.create()) {
    if (message.messageSetWireFormat === true) {
      writer.uint32(8).bool(message.messageSetWireFormat);
    }

    if (message.noStandardDescriptorAccessor === true) {
      writer.uint32(16).bool(message.noStandardDescriptorAccessor);
    }

    if (message.deprecated === true) {
      writer.uint32(24).bool(message.deprecated);
    }

    if (message.mapEntry === true) {
      writer.uint32(56).bool(message.mapEntry);
    }

    for (const v of message.uninterpretedOption) {
      UninterpretedOption.encode(v, writer.uint32(7994).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMessageOptions();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.messageSetWireFormat = reader.bool();
          break;

        case 2:
          message.noStandardDescriptorAccessor = reader.bool();
          break;

        case 3:
          message.deprecated = reader.bool();
          break;

        case 7:
          message.mapEntry = reader.bool();
          break;

        case 999:
          message.uninterpretedOption.push(UninterpretedOption.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$messageSetWir, _object$noStandardDes, _object$deprecated2, _object$mapEntry, _object$uninterpreted3;

    const message = createBaseMessageOptions();
    message.messageSetWireFormat = (_object$messageSetWir = object.messageSetWireFormat) !== null && _object$messageSetWir !== void 0 ? _object$messageSetWir : false;
    message.noStandardDescriptorAccessor = (_object$noStandardDes = object.noStandardDescriptorAccessor) !== null && _object$noStandardDes !== void 0 ? _object$noStandardDes : false;
    message.deprecated = (_object$deprecated2 = object.deprecated) !== null && _object$deprecated2 !== void 0 ? _object$deprecated2 : false;
    message.mapEntry = (_object$mapEntry = object.mapEntry) !== null && _object$mapEntry !== void 0 ? _object$mapEntry : false;
    message.uninterpretedOption = ((_object$uninterpreted3 = object.uninterpretedOption) === null || _object$uninterpreted3 === void 0 ? void 0 : _object$uninterpreted3.map(e => UninterpretedOption.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      messageSetWireFormat: object.message_set_wire_format,
      noStandardDescriptorAccessor: object.no_standard_descriptor_accessor,
      deprecated: object.deprecated,
      mapEntry: object.map_entry,
      uninterpretedOption: Array.isArray(object === null || object === void 0 ? void 0 : object.uninterpreted_option) ? object.uninterpreted_option.map(e => UninterpretedOption.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.message_set_wire_format = message.messageSetWireFormat;
    obj.no_standard_descriptor_accessor = message.noStandardDescriptorAccessor;
    obj.deprecated = message.deprecated;
    obj.map_entry = message.mapEntry;

    if (message.uninterpretedOption) {
      obj.uninterpreted_option = message.uninterpretedOption.map(e => e ? UninterpretedOption.toAmino(e) : undefined);
    } else {
      obj.uninterpreted_option = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return MessageOptions.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return MessageOptions.decode(message.value);
  },

  toProto(message) {
    return MessageOptions.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/google.protobuf.MessageOptions",
      value: MessageOptions.encode(message).finish()
    };
  }

};

function createBaseFieldOptions() {
  return {
    ctype: 1,
    packed: false,
    jstype: 1,
    lazy: false,
    deprecated: false,
    weak: false,
    uninterpretedOption: []
  };
}

const FieldOptions = {
  typeUrl: "/google.protobuf.FieldOptions",

  encode(message, writer = minimal.Writer.create()) {
    if (message.ctype !== 1) {
      writer.uint32(8).int32(message.ctype);
    }

    if (message.packed === true) {
      writer.uint32(16).bool(message.packed);
    }

    if (message.jstype !== 1) {
      writer.uint32(48).int32(message.jstype);
    }

    if (message.lazy === true) {
      writer.uint32(40).bool(message.lazy);
    }

    if (message.deprecated === true) {
      writer.uint32(24).bool(message.deprecated);
    }

    if (message.weak === true) {
      writer.uint32(80).bool(message.weak);
    }

    for (const v of message.uninterpretedOption) {
      UninterpretedOption.encode(v, writer.uint32(7994).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFieldOptions();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.ctype = reader.int32();
          break;

        case 2:
          message.packed = reader.bool();
          break;

        case 6:
          message.jstype = reader.int32();
          break;

        case 5:
          message.lazy = reader.bool();
          break;

        case 3:
          message.deprecated = reader.bool();
          break;

        case 10:
          message.weak = reader.bool();
          break;

        case 999:
          message.uninterpretedOption.push(UninterpretedOption.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$ctype, _object$packed, _object$jstype, _object$lazy, _object$deprecated3, _object$weak, _object$uninterpreted4;

    const message = createBaseFieldOptions();
    message.ctype = (_object$ctype = object.ctype) !== null && _object$ctype !== void 0 ? _object$ctype : 1;
    message.packed = (_object$packed = object.packed) !== null && _object$packed !== void 0 ? _object$packed : false;
    message.jstype = (_object$jstype = object.jstype) !== null && _object$jstype !== void 0 ? _object$jstype : 1;
    message.lazy = (_object$lazy = object.lazy) !== null && _object$lazy !== void 0 ? _object$lazy : false;
    message.deprecated = (_object$deprecated3 = object.deprecated) !== null && _object$deprecated3 !== void 0 ? _object$deprecated3 : false;
    message.weak = (_object$weak = object.weak) !== null && _object$weak !== void 0 ? _object$weak : false;
    message.uninterpretedOption = ((_object$uninterpreted4 = object.uninterpretedOption) === null || _object$uninterpreted4 === void 0 ? void 0 : _object$uninterpreted4.map(e => UninterpretedOption.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      ctype: (0,helpers/* isSet */.DM)(object.ctype) ? fieldOptions_CTypeFromJSON(object.ctype) : 0,
      packed: object.packed,
      jstype: (0,helpers/* isSet */.DM)(object.jstype) ? fieldOptions_JSTypeFromJSON(object.jstype) : 0,
      lazy: object.lazy,
      deprecated: object.deprecated,
      weak: object.weak,
      uninterpretedOption: Array.isArray(object === null || object === void 0 ? void 0 : object.uninterpreted_option) ? object.uninterpreted_option.map(e => UninterpretedOption.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.ctype = message.ctype;
    obj.packed = message.packed;
    obj.jstype = message.jstype;
    obj.lazy = message.lazy;
    obj.deprecated = message.deprecated;
    obj.weak = message.weak;

    if (message.uninterpretedOption) {
      obj.uninterpreted_option = message.uninterpretedOption.map(e => e ? UninterpretedOption.toAmino(e) : undefined);
    } else {
      obj.uninterpreted_option = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return FieldOptions.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return FieldOptions.decode(message.value);
  },

  toProto(message) {
    return FieldOptions.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/google.protobuf.FieldOptions",
      value: FieldOptions.encode(message).finish()
    };
  }

};

function createBaseOneofOptions() {
  return {
    uninterpretedOption: []
  };
}

const OneofOptions = {
  typeUrl: "/google.protobuf.OneofOptions",

  encode(message, writer = minimal.Writer.create()) {
    for (const v of message.uninterpretedOption) {
      UninterpretedOption.encode(v, writer.uint32(7994).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOneofOptions();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 999:
          message.uninterpretedOption.push(UninterpretedOption.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$uninterpreted5;

    const message = createBaseOneofOptions();
    message.uninterpretedOption = ((_object$uninterpreted5 = object.uninterpretedOption) === null || _object$uninterpreted5 === void 0 ? void 0 : _object$uninterpreted5.map(e => UninterpretedOption.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      uninterpretedOption: Array.isArray(object === null || object === void 0 ? void 0 : object.uninterpreted_option) ? object.uninterpreted_option.map(e => UninterpretedOption.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.uninterpretedOption) {
      obj.uninterpreted_option = message.uninterpretedOption.map(e => e ? UninterpretedOption.toAmino(e) : undefined);
    } else {
      obj.uninterpreted_option = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return OneofOptions.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return OneofOptions.decode(message.value);
  },

  toProto(message) {
    return OneofOptions.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/google.protobuf.OneofOptions",
      value: OneofOptions.encode(message).finish()
    };
  }

};

function createBaseEnumOptions() {
  return {
    allowAlias: false,
    deprecated: false,
    uninterpretedOption: []
  };
}

const EnumOptions = {
  typeUrl: "/google.protobuf.EnumOptions",

  encode(message, writer = minimal.Writer.create()) {
    if (message.allowAlias === true) {
      writer.uint32(16).bool(message.allowAlias);
    }

    if (message.deprecated === true) {
      writer.uint32(24).bool(message.deprecated);
    }

    for (const v of message.uninterpretedOption) {
      UninterpretedOption.encode(v, writer.uint32(7994).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEnumOptions();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 2:
          message.allowAlias = reader.bool();
          break;

        case 3:
          message.deprecated = reader.bool();
          break;

        case 999:
          message.uninterpretedOption.push(UninterpretedOption.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$allowAlias, _object$deprecated4, _object$uninterpreted6;

    const message = createBaseEnumOptions();
    message.allowAlias = (_object$allowAlias = object.allowAlias) !== null && _object$allowAlias !== void 0 ? _object$allowAlias : false;
    message.deprecated = (_object$deprecated4 = object.deprecated) !== null && _object$deprecated4 !== void 0 ? _object$deprecated4 : false;
    message.uninterpretedOption = ((_object$uninterpreted6 = object.uninterpretedOption) === null || _object$uninterpreted6 === void 0 ? void 0 : _object$uninterpreted6.map(e => UninterpretedOption.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      allowAlias: object.allow_alias,
      deprecated: object.deprecated,
      uninterpretedOption: Array.isArray(object === null || object === void 0 ? void 0 : object.uninterpreted_option) ? object.uninterpreted_option.map(e => UninterpretedOption.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.allow_alias = message.allowAlias;
    obj.deprecated = message.deprecated;

    if (message.uninterpretedOption) {
      obj.uninterpreted_option = message.uninterpretedOption.map(e => e ? UninterpretedOption.toAmino(e) : undefined);
    } else {
      obj.uninterpreted_option = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return EnumOptions.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return EnumOptions.decode(message.value);
  },

  toProto(message) {
    return EnumOptions.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/google.protobuf.EnumOptions",
      value: EnumOptions.encode(message).finish()
    };
  }

};

function createBaseEnumValueOptions() {
  return {
    deprecated: false,
    uninterpretedOption: []
  };
}

const EnumValueOptions = {
  typeUrl: "/google.protobuf.EnumValueOptions",

  encode(message, writer = minimal.Writer.create()) {
    if (message.deprecated === true) {
      writer.uint32(8).bool(message.deprecated);
    }

    for (const v of message.uninterpretedOption) {
      UninterpretedOption.encode(v, writer.uint32(7994).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEnumValueOptions();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.deprecated = reader.bool();
          break;

        case 999:
          message.uninterpretedOption.push(UninterpretedOption.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$deprecated5, _object$uninterpreted7;

    const message = createBaseEnumValueOptions();
    message.deprecated = (_object$deprecated5 = object.deprecated) !== null && _object$deprecated5 !== void 0 ? _object$deprecated5 : false;
    message.uninterpretedOption = ((_object$uninterpreted7 = object.uninterpretedOption) === null || _object$uninterpreted7 === void 0 ? void 0 : _object$uninterpreted7.map(e => UninterpretedOption.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      deprecated: object.deprecated,
      uninterpretedOption: Array.isArray(object === null || object === void 0 ? void 0 : object.uninterpreted_option) ? object.uninterpreted_option.map(e => UninterpretedOption.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.deprecated = message.deprecated;

    if (message.uninterpretedOption) {
      obj.uninterpreted_option = message.uninterpretedOption.map(e => e ? UninterpretedOption.toAmino(e) : undefined);
    } else {
      obj.uninterpreted_option = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return EnumValueOptions.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return EnumValueOptions.decode(message.value);
  },

  toProto(message) {
    return EnumValueOptions.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/google.protobuf.EnumValueOptions",
      value: EnumValueOptions.encode(message).finish()
    };
  }

};

function createBaseServiceOptions() {
  return {
    deprecated: false,
    uninterpretedOption: []
  };
}

const ServiceOptions = {
  typeUrl: "/google.protobuf.ServiceOptions",

  encode(message, writer = minimal.Writer.create()) {
    if (message.deprecated === true) {
      writer.uint32(264).bool(message.deprecated);
    }

    for (const v of message.uninterpretedOption) {
      UninterpretedOption.encode(v, writer.uint32(7994).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseServiceOptions();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 33:
          message.deprecated = reader.bool();
          break;

        case 999:
          message.uninterpretedOption.push(UninterpretedOption.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$deprecated6, _object$uninterpreted8;

    const message = createBaseServiceOptions();
    message.deprecated = (_object$deprecated6 = object.deprecated) !== null && _object$deprecated6 !== void 0 ? _object$deprecated6 : false;
    message.uninterpretedOption = ((_object$uninterpreted8 = object.uninterpretedOption) === null || _object$uninterpreted8 === void 0 ? void 0 : _object$uninterpreted8.map(e => UninterpretedOption.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      deprecated: object.deprecated,
      uninterpretedOption: Array.isArray(object === null || object === void 0 ? void 0 : object.uninterpreted_option) ? object.uninterpreted_option.map(e => UninterpretedOption.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.deprecated = message.deprecated;

    if (message.uninterpretedOption) {
      obj.uninterpreted_option = message.uninterpretedOption.map(e => e ? UninterpretedOption.toAmino(e) : undefined);
    } else {
      obj.uninterpreted_option = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return ServiceOptions.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return ServiceOptions.decode(message.value);
  },

  toProto(message) {
    return ServiceOptions.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/google.protobuf.ServiceOptions",
      value: ServiceOptions.encode(message).finish()
    };
  }

};

function createBaseMethodOptions() {
  return {
    deprecated: false,
    idempotencyLevel: 1,
    uninterpretedOption: []
  };
}

const MethodOptions = {
  typeUrl: "/google.protobuf.MethodOptions",

  encode(message, writer = minimal.Writer.create()) {
    if (message.deprecated === true) {
      writer.uint32(264).bool(message.deprecated);
    }

    if (message.idempotencyLevel !== 1) {
      writer.uint32(272).int32(message.idempotencyLevel);
    }

    for (const v of message.uninterpretedOption) {
      UninterpretedOption.encode(v, writer.uint32(7994).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMethodOptions();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 33:
          message.deprecated = reader.bool();
          break;

        case 34:
          message.idempotencyLevel = reader.int32();
          break;

        case 999:
          message.uninterpretedOption.push(UninterpretedOption.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$deprecated7, _object$idempotencyLe, _object$uninterpreted9;

    const message = createBaseMethodOptions();
    message.deprecated = (_object$deprecated7 = object.deprecated) !== null && _object$deprecated7 !== void 0 ? _object$deprecated7 : false;
    message.idempotencyLevel = (_object$idempotencyLe = object.idempotencyLevel) !== null && _object$idempotencyLe !== void 0 ? _object$idempotencyLe : 1;
    message.uninterpretedOption = ((_object$uninterpreted9 = object.uninterpretedOption) === null || _object$uninterpreted9 === void 0 ? void 0 : _object$uninterpreted9.map(e => UninterpretedOption.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      deprecated: object.deprecated,
      idempotencyLevel: (0,helpers/* isSet */.DM)(object.idempotency_level) ? methodOptions_IdempotencyLevelFromJSON(object.idempotency_level) : 0,
      uninterpretedOption: Array.isArray(object === null || object === void 0 ? void 0 : object.uninterpreted_option) ? object.uninterpreted_option.map(e => UninterpretedOption.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};
    obj.deprecated = message.deprecated;
    obj.idempotency_level = message.idempotencyLevel;

    if (message.uninterpretedOption) {
      obj.uninterpreted_option = message.uninterpretedOption.map(e => e ? UninterpretedOption.toAmino(e) : undefined);
    } else {
      obj.uninterpreted_option = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return MethodOptions.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return MethodOptions.decode(message.value);
  },

  toProto(message) {
    return MethodOptions.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/google.protobuf.MethodOptions",
      value: MethodOptions.encode(message).finish()
    };
  }

};

function createBaseUninterpretedOption() {
  return {
    name: [],
    identifierValue: "",
    positiveIntValue: helpers/* Long.UZERO */.dK.UZERO,
    negativeIntValue: helpers/* Long.ZERO */.dK.ZERO,
    doubleValue: 0,
    stringValue: new Uint8Array(),
    aggregateValue: ""
  };
}

const UninterpretedOption = {
  typeUrl: "/google.protobuf.UninterpretedOption",

  encode(message, writer = minimal.Writer.create()) {
    for (const v of message.name) {
      UninterpretedOption_NamePart.encode(v, writer.uint32(18).fork()).ldelim();
    }

    if (message.identifierValue !== "") {
      writer.uint32(26).string(message.identifierValue);
    }

    if (!message.positiveIntValue.isZero()) {
      writer.uint32(32).uint64(message.positiveIntValue);
    }

    if (!message.negativeIntValue.isZero()) {
      writer.uint32(40).int64(message.negativeIntValue);
    }

    if (message.doubleValue !== 0) {
      writer.uint32(49).double(message.doubleValue);
    }

    if (message.stringValue.length !== 0) {
      writer.uint32(58).bytes(message.stringValue);
    }

    if (message.aggregateValue !== "") {
      writer.uint32(66).string(message.aggregateValue);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUninterpretedOption();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 2:
          message.name.push(UninterpretedOption_NamePart.decode(reader, reader.uint32()));
          break;

        case 3:
          message.identifierValue = reader.string();
          break;

        case 4:
          message.positiveIntValue = reader.uint64();
          break;

        case 5:
          message.negativeIntValue = reader.int64();
          break;

        case 6:
          message.doubleValue = reader.double();
          break;

        case 7:
          message.stringValue = reader.bytes();
          break;

        case 8:
          message.aggregateValue = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$name9, _object$identifierVal, _object$doubleValue, _object$stringValue, _object$aggregateValu;

    const message = createBaseUninterpretedOption();
    message.name = ((_object$name9 = object.name) === null || _object$name9 === void 0 ? void 0 : _object$name9.map(e => UninterpretedOption_NamePart.fromPartial(e))) || [];
    message.identifierValue = (_object$identifierVal = object.identifierValue) !== null && _object$identifierVal !== void 0 ? _object$identifierVal : "";
    message.positiveIntValue = object.positiveIntValue !== undefined && object.positiveIntValue !== null ? helpers/* Long.fromValue */.dK.fromValue(object.positiveIntValue) : helpers/* Long.UZERO */.dK.UZERO;
    message.negativeIntValue = object.negativeIntValue !== undefined && object.negativeIntValue !== null ? helpers/* Long.fromValue */.dK.fromValue(object.negativeIntValue) : helpers/* Long.ZERO */.dK.ZERO;
    message.doubleValue = (_object$doubleValue = object.doubleValue) !== null && _object$doubleValue !== void 0 ? _object$doubleValue : 0;
    message.stringValue = (_object$stringValue = object.stringValue) !== null && _object$stringValue !== void 0 ? _object$stringValue : new Uint8Array();
    message.aggregateValue = (_object$aggregateValu = object.aggregateValue) !== null && _object$aggregateValu !== void 0 ? _object$aggregateValu : "";
    return message;
  },

  fromAmino(object) {
    return {
      name: Array.isArray(object === null || object === void 0 ? void 0 : object.name) ? object.name.map(e => UninterpretedOption_NamePart.fromAmino(e)) : [],
      identifierValue: object.identifier_value,
      positiveIntValue: helpers/* Long.fromString */.dK.fromString(object.positive_int_value),
      negativeIntValue: helpers/* Long.fromString */.dK.fromString(object.negative_int_value),
      doubleValue: object.double_value,
      stringValue: object.string_value,
      aggregateValue: object.aggregate_value
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.name) {
      obj.name = message.name.map(e => e ? UninterpretedOption_NamePart.toAmino(e) : undefined);
    } else {
      obj.name = [];
    }

    obj.identifier_value = message.identifierValue;
    obj.positive_int_value = message.positiveIntValue ? message.positiveIntValue.toString() : undefined;
    obj.negative_int_value = message.negativeIntValue ? message.negativeIntValue.toString() : undefined;
    obj.double_value = message.doubleValue;
    obj.string_value = message.stringValue;
    obj.aggregate_value = message.aggregateValue;
    return obj;
  },

  fromAminoMsg(object) {
    return UninterpretedOption.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return UninterpretedOption.decode(message.value);
  },

  toProto(message) {
    return UninterpretedOption.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/google.protobuf.UninterpretedOption",
      value: UninterpretedOption.encode(message).finish()
    };
  }

};

function createBaseUninterpretedOption_NamePart() {
  return {
    namePart: "",
    isExtension: false
  };
}

const UninterpretedOption_NamePart = {
  typeUrl: "/google.protobuf.NamePart",

  encode(message, writer = minimal.Writer.create()) {
    if (message.namePart !== "") {
      writer.uint32(10).string(message.namePart);
    }

    if (message.isExtension === true) {
      writer.uint32(16).bool(message.isExtension);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUninterpretedOption_NamePart();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.namePart = reader.string();
          break;

        case 2:
          message.isExtension = reader.bool();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$namePart, _object$isExtension;

    const message = createBaseUninterpretedOption_NamePart();
    message.namePart = (_object$namePart = object.namePart) !== null && _object$namePart !== void 0 ? _object$namePart : "";
    message.isExtension = (_object$isExtension = object.isExtension) !== null && _object$isExtension !== void 0 ? _object$isExtension : false;
    return message;
  },

  fromAmino(object) {
    return {
      namePart: object.name_part,
      isExtension: object.is_extension
    };
  },

  toAmino(message) {
    const obj = {};
    obj.name_part = message.namePart;
    obj.is_extension = message.isExtension;
    return obj;
  },

  fromAminoMsg(object) {
    return UninterpretedOption_NamePart.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return UninterpretedOption_NamePart.decode(message.value);
  },

  toProto(message) {
    return UninterpretedOption_NamePart.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/google.protobuf.NamePart",
      value: UninterpretedOption_NamePart.encode(message).finish()
    };
  }

};

function createBaseSourceCodeInfo() {
  return {
    location: []
  };
}

const SourceCodeInfo = {
  typeUrl: "/google.protobuf.SourceCodeInfo",

  encode(message, writer = minimal.Writer.create()) {
    for (const v of message.location) {
      SourceCodeInfo_Location.encode(v, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSourceCodeInfo();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.location.push(SourceCodeInfo_Location.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$location;

    const message = createBaseSourceCodeInfo();
    message.location = ((_object$location = object.location) === null || _object$location === void 0 ? void 0 : _object$location.map(e => SourceCodeInfo_Location.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      location: Array.isArray(object === null || object === void 0 ? void 0 : object.location) ? object.location.map(e => SourceCodeInfo_Location.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.location) {
      obj.location = message.location.map(e => e ? SourceCodeInfo_Location.toAmino(e) : undefined);
    } else {
      obj.location = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return SourceCodeInfo.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return SourceCodeInfo.decode(message.value);
  },

  toProto(message) {
    return SourceCodeInfo.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/google.protobuf.SourceCodeInfo",
      value: SourceCodeInfo.encode(message).finish()
    };
  }

};

function createBaseSourceCodeInfo_Location() {
  return {
    path: [],
    span: [],
    leadingComments: "",
    trailingComments: "",
    leadingDetachedComments: []
  };
}

const SourceCodeInfo_Location = {
  typeUrl: "/google.protobuf.Location",

  encode(message, writer = minimal.Writer.create()) {
    writer.uint32(10).fork();

    for (const v of message.path) {
      writer.int32(v);
    }

    writer.ldelim();
    writer.uint32(18).fork();

    for (const v of message.span) {
      writer.int32(v);
    }

    writer.ldelim();

    if (message.leadingComments !== "") {
      writer.uint32(26).string(message.leadingComments);
    }

    if (message.trailingComments !== "") {
      writer.uint32(34).string(message.trailingComments);
    }

    for (const v of message.leadingDetachedComments) {
      writer.uint32(50).string(v);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSourceCodeInfo_Location();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          if ((tag & 7) === 2) {
            const end2 = reader.uint32() + reader.pos;

            while (reader.pos < end2) {
              message.path.push(reader.int32());
            }
          } else {
            message.path.push(reader.int32());
          }

          break;

        case 2:
          if ((tag & 7) === 2) {
            const end2 = reader.uint32() + reader.pos;

            while (reader.pos < end2) {
              message.span.push(reader.int32());
            }
          } else {
            message.span.push(reader.int32());
          }

          break;

        case 3:
          message.leadingComments = reader.string();
          break;

        case 4:
          message.trailingComments = reader.string();
          break;

        case 6:
          message.leadingDetachedComments.push(reader.string());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$path, _object$span, _object$leadingCommen, _object$trailingComme, _object$leadingDetach;

    const message = createBaseSourceCodeInfo_Location();
    message.path = ((_object$path = object.path) === null || _object$path === void 0 ? void 0 : _object$path.map(e => e)) || [];
    message.span = ((_object$span = object.span) === null || _object$span === void 0 ? void 0 : _object$span.map(e => e)) || [];
    message.leadingComments = (_object$leadingCommen = object.leadingComments) !== null && _object$leadingCommen !== void 0 ? _object$leadingCommen : "";
    message.trailingComments = (_object$trailingComme = object.trailingComments) !== null && _object$trailingComme !== void 0 ? _object$trailingComme : "";
    message.leadingDetachedComments = ((_object$leadingDetach = object.leadingDetachedComments) === null || _object$leadingDetach === void 0 ? void 0 : _object$leadingDetach.map(e => e)) || [];
    return message;
  },

  fromAmino(object) {
    return {
      path: Array.isArray(object === null || object === void 0 ? void 0 : object.path) ? object.path.map(e => e) : [],
      span: Array.isArray(object === null || object === void 0 ? void 0 : object.span) ? object.span.map(e => e) : [],
      leadingComments: object.leading_comments,
      trailingComments: object.trailing_comments,
      leadingDetachedComments: Array.isArray(object === null || object === void 0 ? void 0 : object.leading_detached_comments) ? object.leading_detached_comments.map(e => e) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.path) {
      obj.path = message.path.map(e => e);
    } else {
      obj.path = [];
    }

    if (message.span) {
      obj.span = message.span.map(e => e);
    } else {
      obj.span = [];
    }

    obj.leading_comments = message.leadingComments;
    obj.trailing_comments = message.trailingComments;

    if (message.leadingDetachedComments) {
      obj.leading_detached_comments = message.leadingDetachedComments.map(e => e);
    } else {
      obj.leading_detached_comments = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return SourceCodeInfo_Location.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return SourceCodeInfo_Location.decode(message.value);
  },

  toProto(message) {
    return SourceCodeInfo_Location.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/google.protobuf.Location",
      value: SourceCodeInfo_Location.encode(message).finish()
    };
  }

};

function createBaseGeneratedCodeInfo() {
  return {
    annotation: []
  };
}

const GeneratedCodeInfo = {
  typeUrl: "/google.protobuf.GeneratedCodeInfo",

  encode(message, writer = minimal.Writer.create()) {
    for (const v of message.annotation) {
      GeneratedCodeInfo_Annotation.encode(v, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGeneratedCodeInfo();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.annotation.push(GeneratedCodeInfo_Annotation.decode(reader, reader.uint32()));
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$annotation;

    const message = createBaseGeneratedCodeInfo();
    message.annotation = ((_object$annotation = object.annotation) === null || _object$annotation === void 0 ? void 0 : _object$annotation.map(e => GeneratedCodeInfo_Annotation.fromPartial(e))) || [];
    return message;
  },

  fromAmino(object) {
    return {
      annotation: Array.isArray(object === null || object === void 0 ? void 0 : object.annotation) ? object.annotation.map(e => GeneratedCodeInfo_Annotation.fromAmino(e)) : []
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.annotation) {
      obj.annotation = message.annotation.map(e => e ? GeneratedCodeInfo_Annotation.toAmino(e) : undefined);
    } else {
      obj.annotation = [];
    }

    return obj;
  },

  fromAminoMsg(object) {
    return GeneratedCodeInfo.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return GeneratedCodeInfo.decode(message.value);
  },

  toProto(message) {
    return GeneratedCodeInfo.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/google.protobuf.GeneratedCodeInfo",
      value: GeneratedCodeInfo.encode(message).finish()
    };
  }

};

function createBaseGeneratedCodeInfo_Annotation() {
  return {
    path: [],
    sourceFile: "",
    begin: 0,
    end: 0
  };
}

const GeneratedCodeInfo_Annotation = {
  typeUrl: "/google.protobuf.Annotation",

  encode(message, writer = minimal.Writer.create()) {
    writer.uint32(10).fork();

    for (const v of message.path) {
      writer.int32(v);
    }

    writer.ldelim();

    if (message.sourceFile !== "") {
      writer.uint32(18).string(message.sourceFile);
    }

    if (message.begin !== 0) {
      writer.uint32(24).int32(message.begin);
    }

    if (message.end !== 0) {
      writer.uint32(32).int32(message.end);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGeneratedCodeInfo_Annotation();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          if ((tag & 7) === 2) {
            const end2 = reader.uint32() + reader.pos;

            while (reader.pos < end2) {
              message.path.push(reader.int32());
            }
          } else {
            message.path.push(reader.int32());
          }

          break;

        case 2:
          message.sourceFile = reader.string();
          break;

        case 3:
          message.begin = reader.int32();
          break;

        case 4:
          message.end = reader.int32();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$path2, _object$sourceFile, _object$begin, _object$end4;

    const message = createBaseGeneratedCodeInfo_Annotation();
    message.path = ((_object$path2 = object.path) === null || _object$path2 === void 0 ? void 0 : _object$path2.map(e => e)) || [];
    message.sourceFile = (_object$sourceFile = object.sourceFile) !== null && _object$sourceFile !== void 0 ? _object$sourceFile : "";
    message.begin = (_object$begin = object.begin) !== null && _object$begin !== void 0 ? _object$begin : 0;
    message.end = (_object$end4 = object.end) !== null && _object$end4 !== void 0 ? _object$end4 : 0;
    return message;
  },

  fromAmino(object) {
    return {
      path: Array.isArray(object === null || object === void 0 ? void 0 : object.path) ? object.path.map(e => e) : [],
      sourceFile: object.source_file,
      begin: object.begin,
      end: object.end
    };
  },

  toAmino(message) {
    const obj = {};

    if (message.path) {
      obj.path = message.path.map(e => e);
    } else {
      obj.path = [];
    }

    obj.source_file = message.sourceFile;
    obj.begin = message.begin;
    obj.end = message.end;
    return obj;
  },

  fromAminoMsg(object) {
    return GeneratedCodeInfo_Annotation.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return GeneratedCodeInfo_Annotation.decode(message.value);
  },

  toProto(message) {
    return GeneratedCodeInfo_Annotation.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/google.protobuf.Annotation",
      value: GeneratedCodeInfo_Annotation.encode(message).finish()
    };
  }

};
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/google/protobuf/empty.js

/**
 * A generic empty message that you can re-use to avoid defining duplicated
 * empty messages in your APIs. A typical example is to use it as the request
 * or the response type of an API method. For instance:
 * 
 *     service Foo {
 *       rpc Bar(google.protobuf.Empty) returns (google.protobuf.Empty);
 *     }
 * 
 * The JSON representation for `Empty` is empty JSON object `{}`.
 */

function createBaseEmpty() {
  return {};
}

const Empty = {
  typeUrl: "/google.protobuf.Empty",

  encode(_, writer = minimal.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof minimal.Reader ? input : new minimal.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEmpty();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseEmpty();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return Empty.fromAmino(object.value);
  },

  fromProtoMsg(message) {
    return Empty.decode(message.value);
  },

  toProto(message) {
    return Empty.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/google.protobuf.Empty",
      value: Empty.encode(message).finish()
    };
  }

};
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/google/bundle.js


function google_bundle_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function google_bundle_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? google_bundle_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : google_bundle_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






let google;

(function (_google) {
  const protobuf = _google.protobuf = google_bundle_objectSpread(google_bundle_objectSpread(google_bundle_objectSpread(google_bundle_objectSpread(google_bundle_objectSpread({}, any), descriptor_namespaceObject), duration), empty_namespaceObject), timestamp);
})(google || (google = {}));
;// CONCATENATED MODULE: ./node_modules/osmojs/module/codegen/index.js
/**
  * This file and any referenced files were automatically generated by @osmonauts/telescope@0.90.0
  * DO NOT MODIFY BY HAND. Instead, download the latest proto files for your chain
  * and run the transpile command or yarn proto command to regenerate this bundle.
  */















;// CONCATENATED MODULE: ./node_modules/osmojs/module/utils/gas/estimation.js

const estimateOsmoFee = async (client, address, msgs, memo) => {
  const gasPrice = GasPrice.fromString('0.025uosmo');
  const gasEstimation = await client.simulate(address, msgs, memo);
  const fee = calculateFee(Math.round(gasEstimation * 1.3), gasPrice);
  return fee;
};
// EXTERNAL MODULE: ./node_modules/osmojs/node_modules/@cosmjs/amino/build/index.js
var amino_build = __webpack_require__(52105);
;// CONCATENATED MODULE: ./node_modules/osmojs/module/utils/gas/values.js

const GAS_VALUES = {
  osmosis: {
    createPool: '250000',
    joinPool: '250000',
    joinSwapExternAmountIn: '250000',
    exitPool: '250000',
    swapExactAmountIn: '250000',
    swapExactAmountOut: '250000',
    lockTokens: '265000',
    beginUnlocking: '250000',
    unlockPeriodLock: '250000'
  }
};
const FEE_VALUES = {
  osmosis: {
    low: '650',
    // 625 is minimum
    medium: '6250',
    high: '10000'
  }
}; // export const FEES = Object.keys(GAS_VALUES).reduce((m, chain) => {
//     m[chain] = Object.keys(GAS_VALUES[chain]).reduce((m2, method) => {
//         m2[method] = (fee = 'low') => ({
//             amount: coins(FEE_VALUES[chain][fee], 'uosmo'),
//             gas: GAS_VALUES[chain][method]
//         });
//         return m2;
//     }, {});
//     return m;
// }, {});

const FEES = {
  osmosis: {
    createPool: (fee = 'low') => ({
      amount: (0,amino_build/* coins */.TN)(FEE_VALUES.osmosis[fee], 'uosmo'),
      gas: GAS_VALUES.osmosis.createPool
    }),
    joinPool: (fee = 'low') => ({
      amount: (0,amino_build/* coins */.TN)(FEE_VALUES.osmosis[fee], 'uosmo'),
      gas: GAS_VALUES.osmosis.joinPool
    }),
    joinSwapExternAmountIn: (fee = 'low') => ({
      amount: (0,amino_build/* coins */.TN)(FEE_VALUES.osmosis[fee], 'uosmo'),
      gas: GAS_VALUES.osmosis.joinSwapExternAmountIn
    }),
    exitPool: (fee = 'low') => ({
      amount: (0,amino_build/* coins */.TN)(FEE_VALUES.osmosis[fee], 'uosmo'),
      gas: GAS_VALUES.osmosis.exitPool
    }),
    swapExactAmountIn: (fee = 'low') => ({
      amount: (0,amino_build/* coins */.TN)(FEE_VALUES.osmosis[fee], 'uosmo'),
      gas: GAS_VALUES.osmosis.swapExactAmountIn
    }),
    swapExactAmountOut: (fee = 'low') => ({
      amount: (0,amino_build/* coins */.TN)(FEE_VALUES.osmosis[fee], 'uosmo'),
      gas: GAS_VALUES.osmosis.swapExactAmountOut
    }),
    lockTokens: (fee = 'low') => ({
      amount: (0,amino_build/* coins */.TN)(FEE_VALUES.osmosis[fee], 'uosmo'),
      gas: GAS_VALUES.osmosis.lockTokens
    }),
    beginUnlocking: (fee = 'low') => ({
      amount: (0,amino_build/* coins */.TN)(FEE_VALUES.osmosis[fee], 'uosmo'),
      gas: GAS_VALUES.osmosis.beginUnlocking
    }),
    unlockPeriodLock: (fee = 'low') => ({
      amount: (0,amino_build/* coins */.TN)(FEE_VALUES.osmosis[fee], 'uosmo'),
      gas: GAS_VALUES.osmosis.unlockPeriodLock
    })
  }
};
;// CONCATENATED MODULE: ./node_modules/osmojs/module/utils/gas/index.js


;// CONCATENATED MODULE: ./node_modules/osmojs/module/utils/index.js

;// CONCATENATED MODULE: ./node_modules/osmojs/module/index.js




/***/ }),

/***/ 76450:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

// See https://github.com/tendermint/tendermint/blob/f2ada0a604b4c0763bda2f64fac53d506d3beca7/docs/spec/blockchain/encoding.md#public-key-cryptography
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.pubkeyToAddress = exports.pubkeyToRawAddress = exports.rawSecp256k1PubkeyToRawAddress = exports.rawEd25519PubkeyToRawAddress = void 0;
const crypto_1 = __webpack_require__(79562);
const encoding_1 = __webpack_require__(71555);
const encoding_2 = __webpack_require__(48128);
const pubkeys_1 = __webpack_require__(38682);
function rawEd25519PubkeyToRawAddress(pubkeyData) {
    if (pubkeyData.length !== 32) {
        throw new Error(`Invalid Ed25519 pubkey length: ${pubkeyData.length}`);
    }
    return (0, crypto_1.sha256)(pubkeyData).slice(0, 20);
}
exports.rawEd25519PubkeyToRawAddress = rawEd25519PubkeyToRawAddress;
function rawSecp256k1PubkeyToRawAddress(pubkeyData) {
    if (pubkeyData.length !== 33) {
        throw new Error(`Invalid Secp256k1 pubkey length (compressed): ${pubkeyData.length}`);
    }
    return (0, crypto_1.ripemd160)((0, crypto_1.sha256)(pubkeyData));
}
exports.rawSecp256k1PubkeyToRawAddress = rawSecp256k1PubkeyToRawAddress;
// For secp256k1 this assumes we already have a compressed pubkey.
function pubkeyToRawAddress(pubkey) {
    if ((0, pubkeys_1.isSecp256k1Pubkey)(pubkey)) {
        const pubkeyData = (0, encoding_1.fromBase64)(pubkey.value);
        return rawSecp256k1PubkeyToRawAddress(pubkeyData);
    }
    else if ((0, pubkeys_1.isEd25519Pubkey)(pubkey)) {
        const pubkeyData = (0, encoding_1.fromBase64)(pubkey.value);
        return rawEd25519PubkeyToRawAddress(pubkeyData);
    }
    else if ((0, pubkeys_1.isMultisigThresholdPubkey)(pubkey)) {
        // https://github.com/tendermint/tendermint/blob/38b401657e4ad7a7eeb3c30a3cbf512037df3740/crypto/multisig/threshold_pubkey.go#L71-L74
        const pubkeyData = (0, encoding_2.encodeAminoPubkey)(pubkey);
        return (0, crypto_1.sha256)(pubkeyData).slice(0, 20);
    }
    else {
        throw new Error("Unsupported public key type");
    }
}
exports.pubkeyToRawAddress = pubkeyToRawAddress;
function pubkeyToAddress(pubkey, prefix) {
    return (0, encoding_1.toBech32)(prefix, pubkeyToRawAddress(pubkey));
}
exports.pubkeyToAddress = pubkeyToAddress;
//# sourceMappingURL=addresses.js.map

/***/ }),

/***/ 96079:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.addCoins = exports.parseCoins = exports.coins = exports.coin = void 0;
const math_1 = __webpack_require__(62949);
/**
 * Creates a coin.
 *
 * If your values do not exceed the safe integer range of JS numbers (53 bit),
 * you can use the number type here. This is the case for all typical Cosmos SDK
 * chains that use the default 6 decimals.
 *
 * In case you need to supportr larger values, use unsigned integer strings instead.
 */
function coin(amount, denom) {
    let outAmount;
    if (typeof amount === "number") {
        try {
            outAmount = new math_1.Uint53(amount).toString();
        }
        catch (_err) {
            throw new Error("Given amount is not a safe integer. Consider using a string instead to overcome the limitations of JS numbers.");
        }
    }
    else {
        if (!amount.match(/^[0-9]+$/)) {
            throw new Error("Invalid unsigned integer string format");
        }
        outAmount = amount.replace(/^0*/, "") || "0";
    }
    return {
        amount: outAmount,
        denom: denom,
    };
}
exports.coin = coin;
/**
 * Creates a list of coins with one element.
 */
function coins(amount, denom) {
    return [coin(amount, denom)];
}
exports.coins = coins;
/**
 * Takes a coins list like "819966000ucosm,700000000ustake" and parses it.
 *
 * A Stargate-ready variant of this function is available via:
 *
 * ```
 * import { parseCoins } from "@cosmjs/proto-signing";
 * // or
 * import { parseCoins } from "@cosmjs/stargate";
 * ```
 */
function parseCoins(input) {
    return input
        .replace(/\s/g, "")
        .split(",")
        .filter(Boolean)
        .map((part) => {
        const match = part.match(/^([0-9]+)([a-zA-Z]+)/);
        if (!match)
            throw new Error("Got an invalid coin string");
        return {
            amount: match[1].replace(/^0+/, "") || "0",
            denom: match[2],
        };
    });
}
exports.parseCoins = parseCoins;
/**
 * Function to sum up coins with type Coin
 */
function addCoins(lhs, rhs) {
    if (lhs.denom !== rhs.denom)
        throw new Error("Trying to add two coins with different denoms");
    return {
        amount: math_1.Decimal.fromAtomics(lhs.amount, 0).plus(math_1.Decimal.fromAtomics(rhs.amount, 0)).atomics,
        denom: lhs.denom,
    };
}
exports.addCoins = addCoins;
//# sourceMappingURL=coins.js.map

/***/ }),

/***/ 48128:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.encodeBech32Pubkey = exports.encodeAminoPubkey = exports.decodeBech32Pubkey = exports.decodeAminoPubkey = exports.encodeEd25519Pubkey = exports.encodeSecp256k1Pubkey = void 0;
const encoding_1 = __webpack_require__(71555);
const math_1 = __webpack_require__(62949);
const utils_1 = __webpack_require__(85553);
const pubkeys_1 = __webpack_require__(38682);
/**
 * Takes a Secp256k1 public key as raw bytes and returns the Amino JSON
 * representation of it (the type/value wrapper object).
 */
function encodeSecp256k1Pubkey(pubkey) {
    if (pubkey.length !== 33 || (pubkey[0] !== 0x02 && pubkey[0] !== 0x03)) {
        throw new Error("Public key must be compressed secp256k1, i.e. 33 bytes starting with 0x02 or 0x03");
    }
    return {
        type: pubkeys_1.pubkeyType.secp256k1,
        value: (0, encoding_1.toBase64)(pubkey),
    };
}
exports.encodeSecp256k1Pubkey = encodeSecp256k1Pubkey;
/**
 * Takes an Edd25519 public key as raw bytes and returns the Amino JSON
 * representation of it (the type/value wrapper object).
 */
function encodeEd25519Pubkey(pubkey) {
    if (pubkey.length !== 32) {
        throw new Error("Ed25519 public key must be 32 bytes long");
    }
    return {
        type: pubkeys_1.pubkeyType.ed25519,
        value: (0, encoding_1.toBase64)(pubkey),
    };
}
exports.encodeEd25519Pubkey = encodeEd25519Pubkey;
// As discussed in https://github.com/binance-chain/javascript-sdk/issues/163
// Prefixes listed here: https://github.com/tendermint/tendermint/blob/d419fffe18531317c28c29a292ad7d253f6cafdf/docs/spec/blockchain/encoding.md#public-key-cryptography
// Last bytes is varint-encoded length prefix
const pubkeyAminoPrefixSecp256k1 = (0, encoding_1.fromHex)("eb5ae987" + "21" /* fixed length */);
const pubkeyAminoPrefixEd25519 = (0, encoding_1.fromHex)("1624de64" + "20" /* fixed length */);
const pubkeyAminoPrefixSr25519 = (0, encoding_1.fromHex)("0dfb1005" + "20" /* fixed length */);
/** See https://github.com/tendermint/tendermint/commit/38b401657e4ad7a7eeb3c30a3cbf512037df3740 */
const pubkeyAminoPrefixMultisigThreshold = (0, encoding_1.fromHex)("22c1f7e2" /* variable length not included */);
/**
 * Decodes a pubkey in the Amino binary format to a type/value object.
 */
function decodeAminoPubkey(data) {
    if ((0, utils_1.arrayContentStartsWith)(data, pubkeyAminoPrefixSecp256k1)) {
        const rest = data.slice(pubkeyAminoPrefixSecp256k1.length);
        if (rest.length !== 33) {
            throw new Error("Invalid rest data length. Expected 33 bytes (compressed secp256k1 pubkey).");
        }
        return {
            type: pubkeys_1.pubkeyType.secp256k1,
            value: (0, encoding_1.toBase64)(rest),
        };
    }
    else if ((0, utils_1.arrayContentStartsWith)(data, pubkeyAminoPrefixEd25519)) {
        const rest = data.slice(pubkeyAminoPrefixEd25519.length);
        if (rest.length !== 32) {
            throw new Error("Invalid rest data length. Expected 32 bytes (Ed25519 pubkey).");
        }
        return {
            type: pubkeys_1.pubkeyType.ed25519,
            value: (0, encoding_1.toBase64)(rest),
        };
    }
    else if ((0, utils_1.arrayContentStartsWith)(data, pubkeyAminoPrefixSr25519)) {
        const rest = data.slice(pubkeyAminoPrefixSr25519.length);
        if (rest.length !== 32) {
            throw new Error("Invalid rest data length. Expected 32 bytes (Sr25519 pubkey).");
        }
        return {
            type: pubkeys_1.pubkeyType.sr25519,
            value: (0, encoding_1.toBase64)(rest),
        };
    }
    else if ((0, utils_1.arrayContentStartsWith)(data, pubkeyAminoPrefixMultisigThreshold)) {
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        return decodeMultisigPubkey(data);
    }
    else {
        throw new Error("Unsupported public key type. Amino data starts with: " + (0, encoding_1.toHex)(data.slice(0, 5)));
    }
}
exports.decodeAminoPubkey = decodeAminoPubkey;
/**
 * Decodes a bech32 pubkey to Amino binary, which is then decoded to a type/value object.
 * The bech32 prefix is ignored and discareded.
 *
 * @param bechEncoded the bech32 encoded pubkey
 */
function decodeBech32Pubkey(bechEncoded) {
    const { data } = (0, encoding_1.fromBech32)(bechEncoded);
    return decodeAminoPubkey(data);
}
exports.decodeBech32Pubkey = decodeBech32Pubkey;
/**
 * Uvarint decoder for Amino.
 * @see https://github.com/tendermint/go-amino/blob/8e779b71f40d175/decoder.go#L64-76
 * @returns varint as number, and bytes count occupied by varaint
 */
function decodeUvarint(reader) {
    if (reader.length < 1) {
        throw new Error("Can't decode varint. EOF");
    }
    if (reader[0] > 127) {
        throw new Error("Decoding numbers > 127 is not supported here. Please tell those lazy CosmJS maintainers to port the binary.Varint implementation from the Go standard library and write some tests.");
    }
    return [reader[0], 1];
}
/**
 * Decodes a multisig pubkey to type object.
 * Pubkey structure [ prefix + const + threshold + loop:(const + pubkeyLength + pubkey            ) ]
 *                  [   4b   + 1b    +  varint   + loop:(1b    +    varint    + pubkeyLength bytes) ]
 * @param data encoded pubkey
 */
function decodeMultisigPubkey(data) {
    const reader = Array.from(data);
    // remove multisig amino prefix;
    const prefixFromReader = reader.splice(0, pubkeyAminoPrefixMultisigThreshold.length);
    if (!(0, utils_1.arrayContentStartsWith)(prefixFromReader, pubkeyAminoPrefixMultisigThreshold)) {
        throw new Error("Invalid multisig prefix.");
    }
    // remove 0x08 threshold prefix;
    if (reader.shift() != 0x08) {
        throw new Error("Invalid multisig data. Expecting 0x08 prefix before threshold.");
    }
    // read threshold
    const [threshold, thresholdBytesLength] = decodeUvarint(reader);
    reader.splice(0, thresholdBytesLength);
    // read participants pubkeys
    const pubkeys = [];
    while (reader.length > 0) {
        // remove 0x12 threshold prefix;
        if (reader.shift() != 0x12) {
            throw new Error("Invalid multisig data. Expecting 0x12 prefix before participant pubkey length.");
        }
        // read pubkey length
        const [pubkeyLength, pubkeyLengthBytesSize] = decodeUvarint(reader);
        reader.splice(0, pubkeyLengthBytesSize);
        // verify that we can read pubkey
        if (reader.length < pubkeyLength) {
            throw new Error("Invalid multisig data length.");
        }
        // read and decode participant pubkey
        const encodedPubkey = reader.splice(0, pubkeyLength);
        const pubkey = decodeAminoPubkey(Uint8Array.from(encodedPubkey));
        pubkeys.push(pubkey);
    }
    return {
        type: pubkeys_1.pubkeyType.multisigThreshold,
        value: {
            threshold: threshold.toString(),
            pubkeys: pubkeys,
        },
    };
}
/**
 * Uvarint encoder for Amino. This is the same encoding as `binary.PutUvarint` from the Go
 * standard library.
 *
 * @see https://github.com/tendermint/go-amino/blob/8e779b71f40d175/encoder.go#L77-L85
 */
function encodeUvarint(value) {
    const checked = math_1.Uint53.fromString(value.toString()).toNumber();
    if (checked > 127) {
        throw new Error("Encoding numbers > 127 is not supported here. Please tell those lazy CosmJS maintainers to port the binary.PutUvarint implementation from the Go standard library and write some tests.");
    }
    return [checked];
}
/**
 * Encodes a public key to binary Amino.
 */
function encodeAminoPubkey(pubkey) {
    if ((0, pubkeys_1.isMultisigThresholdPubkey)(pubkey)) {
        const out = Array.from(pubkeyAminoPrefixMultisigThreshold);
        out.push(0x08); // TODO: What is this?
        out.push(...encodeUvarint(pubkey.value.threshold));
        for (const pubkeyData of pubkey.value.pubkeys.map((p) => encodeAminoPubkey(p))) {
            out.push(0x12); // TODO: What is this?
            out.push(...encodeUvarint(pubkeyData.length));
            out.push(...pubkeyData);
        }
        return new Uint8Array(out);
    }
    else if ((0, pubkeys_1.isEd25519Pubkey)(pubkey)) {
        return new Uint8Array([...pubkeyAminoPrefixEd25519, ...(0, encoding_1.fromBase64)(pubkey.value)]);
    }
    else if ((0, pubkeys_1.isSecp256k1Pubkey)(pubkey)) {
        return new Uint8Array([...pubkeyAminoPrefixSecp256k1, ...(0, encoding_1.fromBase64)(pubkey.value)]);
    }
    else {
        throw new Error("Unsupported pubkey type");
    }
}
exports.encodeAminoPubkey = encodeAminoPubkey;
/**
 * Encodes a public key to binary Amino and then to bech32.
 *
 * @param pubkey the public key to encode
 * @param prefix the bech32 prefix (human readable part)
 */
function encodeBech32Pubkey(pubkey, prefix) {
    return (0, encoding_1.toBech32)(prefix, encodeAminoPubkey(pubkey));
}
exports.encodeBech32Pubkey = encodeBech32Pubkey;
//# sourceMappingURL=encoding.js.map

/***/ }),

/***/ 52105:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
__webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = exports.N2 = __webpack_unused_export__ = exports.xC = __webpack_unused_export__ = __webpack_unused_export__ = exports.TN = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = void 0;
var addresses_1 = __webpack_require__(76450);
__webpack_unused_export__ = ({ enumerable: true, get: function () { return addresses_1.pubkeyToAddress; } });
__webpack_unused_export__ = ({ enumerable: true, get: function () { return addresses_1.pubkeyToRawAddress; } });
__webpack_unused_export__ = ({ enumerable: true, get: function () { return addresses_1.rawEd25519PubkeyToRawAddress; } });
__webpack_unused_export__ = ({ enumerable: true, get: function () { return addresses_1.rawSecp256k1PubkeyToRawAddress; } });
var coins_1 = __webpack_require__(96079);
__webpack_unused_export__ = ({ enumerable: true, get: function () { return coins_1.addCoins; } });
__webpack_unused_export__ = ({ enumerable: true, get: function () { return coins_1.coin; } });
Object.defineProperty(exports, "TN", ({ enumerable: true, get: function () { return coins_1.coins; } }));
__webpack_unused_export__ = ({ enumerable: true, get: function () { return coins_1.parseCoins; } });
var encoding_1 = __webpack_require__(48128);
__webpack_unused_export__ = ({ enumerable: true, get: function () { return encoding_1.decodeAminoPubkey; } });
Object.defineProperty(exports, "xC", ({ enumerable: true, get: function () { return encoding_1.decodeBech32Pubkey; } }));
__webpack_unused_export__ = ({ enumerable: true, get: function () { return encoding_1.encodeAminoPubkey; } });
Object.defineProperty(exports, "N2", ({ enumerable: true, get: function () { return encoding_1.encodeBech32Pubkey; } }));
__webpack_unused_export__ = ({ enumerable: true, get: function () { return encoding_1.encodeEd25519Pubkey; } });
__webpack_unused_export__ = ({ enumerable: true, get: function () { return encoding_1.encodeSecp256k1Pubkey; } });
var multisig_1 = __webpack_require__(14752);
__webpack_unused_export__ = ({ enumerable: true, get: function () { return multisig_1.createMultisigThresholdPubkey; } });
var paths_1 = __webpack_require__(9001);
__webpack_unused_export__ = ({ enumerable: true, get: function () { return paths_1.makeCosmoshubPath; } });
var pubkeys_1 = __webpack_require__(38682);
__webpack_unused_export__ = ({ enumerable: true, get: function () { return pubkeys_1.isEd25519Pubkey; } });
__webpack_unused_export__ = ({ enumerable: true, get: function () { return pubkeys_1.isMultisigThresholdPubkey; } });
__webpack_unused_export__ = ({ enumerable: true, get: function () { return pubkeys_1.isSecp256k1Pubkey; } });
__webpack_unused_export__ = ({ enumerable: true, get: function () { return pubkeys_1.isSinglePubkey; } });
__webpack_unused_export__ = ({ enumerable: true, get: function () { return pubkeys_1.pubkeyType; } });
var secp256k1hdwallet_1 = __webpack_require__(5331);
__webpack_unused_export__ = ({ enumerable: true, get: function () { return secp256k1hdwallet_1.extractKdfConfiguration; } });
__webpack_unused_export__ = ({ enumerable: true, get: function () { return secp256k1hdwallet_1.Secp256k1HdWallet; } });
var secp256k1wallet_1 = __webpack_require__(22437);
__webpack_unused_export__ = ({ enumerable: true, get: function () { return secp256k1wallet_1.Secp256k1Wallet; } });
var signature_1 = __webpack_require__(10204);
__webpack_unused_export__ = ({ enumerable: true, get: function () { return signature_1.decodeSignature; } });
__webpack_unused_export__ = ({ enumerable: true, get: function () { return signature_1.encodeSecp256k1Signature; } });
var signdoc_1 = __webpack_require__(44669);
__webpack_unused_export__ = ({ enumerable: true, get: function () { return signdoc_1.makeSignDoc; } });
__webpack_unused_export__ = ({ enumerable: true, get: function () { return signdoc_1.serializeSignDoc; } });
var stdtx_1 = __webpack_require__(12474);
__webpack_unused_export__ = ({ enumerable: true, get: function () { return stdtx_1.isStdTx; } });
__webpack_unused_export__ = ({ enumerable: true, get: function () { return stdtx_1.makeStdTx; } });
var wallet_1 = __webpack_require__(67137);
__webpack_unused_export__ = ({ enumerable: true, get: function () { return wallet_1.executeKdf; } });
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 14752:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.createMultisigThresholdPubkey = exports.compareArrays = void 0;
const encoding_1 = __webpack_require__(71555);
const math_1 = __webpack_require__(62949);
const addresses_1 = __webpack_require__(76450);
/**
 * Compare arrays lexicographically.
 *
 * Returns value < 0 if `a < b`.
 * Returns value > 0 if `a > b`.
 * Returns 0 if `a === b`.
 */
function compareArrays(a, b) {
    const aHex = (0, encoding_1.toHex)(a);
    const bHex = (0, encoding_1.toHex)(b);
    return aHex === bHex ? 0 : aHex < bHex ? -1 : 1;
}
exports.compareArrays = compareArrays;
function createMultisigThresholdPubkey(pubkeys, threshold, nosort = false) {
    const uintThreshold = new math_1.Uint53(threshold);
    if (uintThreshold.toNumber() > pubkeys.length) {
        throw new Error(`Threshold k = ${uintThreshold.toNumber()} exceeds number of keys n = ${pubkeys.length}`);
    }
    const outPubkeys = nosort
        ? pubkeys
        : Array.from(pubkeys).sort((lhs, rhs) => {
            // https://github.com/cosmos/cosmos-sdk/blob/v0.42.2/client/keys/add.go#L172-L174
            const addressLhs = (0, addresses_1.pubkeyToRawAddress)(lhs);
            const addressRhs = (0, addresses_1.pubkeyToRawAddress)(rhs);
            return compareArrays(addressLhs, addressRhs);
        });
    return {
        type: "tendermint/PubKeyMultisigThreshold",
        value: {
            threshold: uintThreshold.toString(),
            pubkeys: outPubkeys,
        },
    };
}
exports.createMultisigThresholdPubkey = createMultisigThresholdPubkey;
//# sourceMappingURL=multisig.js.map

/***/ }),

/***/ 9001:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.makeCosmoshubPath = void 0;
const crypto_1 = __webpack_require__(79562);
/**
 * The Cosmos Hub derivation path in the form `m/44'/118'/0'/0/a`
 * with 0-based account index `a`.
 */
function makeCosmoshubPath(a) {
    return [
        crypto_1.Slip10RawIndex.hardened(44),
        crypto_1.Slip10RawIndex.hardened(118),
        crypto_1.Slip10RawIndex.hardened(0),
        crypto_1.Slip10RawIndex.normal(0),
        crypto_1.Slip10RawIndex.normal(a),
    ];
}
exports.makeCosmoshubPath = makeCosmoshubPath;
//# sourceMappingURL=paths.js.map

/***/ }),

/***/ 38682:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.isMultisigThresholdPubkey = exports.isSinglePubkey = exports.pubkeyType = exports.isSecp256k1Pubkey = exports.isEd25519Pubkey = void 0;
function isEd25519Pubkey(pubkey) {
    return pubkey.type === "tendermint/PubKeyEd25519";
}
exports.isEd25519Pubkey = isEd25519Pubkey;
function isSecp256k1Pubkey(pubkey) {
    return pubkey.type === "tendermint/PubKeySecp256k1";
}
exports.isSecp256k1Pubkey = isSecp256k1Pubkey;
exports.pubkeyType = {
    /** @see https://github.com/tendermint/tendermint/blob/v0.33.0/crypto/ed25519/ed25519.go#L22 */
    secp256k1: "tendermint/PubKeySecp256k1",
    /** @see https://github.com/tendermint/tendermint/blob/v0.33.0/crypto/secp256k1/secp256k1.go#L23 */
    ed25519: "tendermint/PubKeyEd25519",
    /** @see https://github.com/tendermint/tendermint/blob/v0.33.0/crypto/sr25519/codec.go#L12 */
    sr25519: "tendermint/PubKeySr25519",
    multisigThreshold: "tendermint/PubKeyMultisigThreshold",
};
function isSinglePubkey(pubkey) {
    const singPubkeyTypes = [exports.pubkeyType.ed25519, exports.pubkeyType.secp256k1, exports.pubkeyType.sr25519];
    return singPubkeyTypes.includes(pubkey.type);
}
exports.isSinglePubkey = isSinglePubkey;
function isMultisigThresholdPubkey(pubkey) {
    return pubkey.type === "tendermint/PubKeyMultisigThreshold";
}
exports.isMultisigThresholdPubkey = isMultisigThresholdPubkey;
//# sourceMappingURL=pubkeys.js.map

/***/ }),

/***/ 5331:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Secp256k1HdWallet = exports.extractKdfConfiguration = void 0;
const crypto_1 = __webpack_require__(79562);
const encoding_1 = __webpack_require__(71555);
const utils_1 = __webpack_require__(85553);
const addresses_1 = __webpack_require__(76450);
const paths_1 = __webpack_require__(9001);
const signature_1 = __webpack_require__(10204);
const signdoc_1 = __webpack_require__(44669);
const wallet_1 = __webpack_require__(67137);
const serializationTypeV1 = "secp256k1wallet-v1";
/**
 * A KDF configuration that is not very strong but can be used on the main thread.
 * It takes about 1 second in Node.js 16.0.0 and should have similar runtimes in other modern Wasm hosts.
 */
const basicPasswordHashingOptions = {
    algorithm: "argon2id",
    params: {
        outputLength: 32,
        opsLimit: 24,
        memLimitKib: 12 * 1024,
    },
};
function isDerivationJson(thing) {
    if (!(0, utils_1.isNonNullObject)(thing))
        return false;
    if (typeof thing.hdPath !== "string")
        return false;
    if (typeof thing.prefix !== "string")
        return false;
    return true;
}
function extractKdfConfigurationV1(doc) {
    return doc.kdf;
}
function extractKdfConfiguration(serialization) {
    const root = JSON.parse(serialization);
    if (!(0, utils_1.isNonNullObject)(root))
        throw new Error("Root document is not an object.");
    switch (root.type) {
        case serializationTypeV1:
            return extractKdfConfigurationV1(root);
        default:
            throw new Error("Unsupported serialization type");
    }
}
exports.extractKdfConfiguration = extractKdfConfiguration;
const defaultOptions = {
    bip39Password: "",
    hdPaths: [(0, paths_1.makeCosmoshubPath)(0)],
    prefix: "cosmos",
};
class Secp256k1HdWallet {
    constructor(mnemonic, options) {
        var _a, _b;
        const hdPaths = (_a = options.hdPaths) !== null && _a !== void 0 ? _a : defaultOptions.hdPaths;
        const prefix = (_b = options.prefix) !== null && _b !== void 0 ? _b : defaultOptions.prefix;
        this.secret = mnemonic;
        this.seed = options.seed;
        this.accounts = hdPaths.map((hdPath) => ({
            hdPath: hdPath,
            prefix,
        }));
    }
    /**
     * Restores a wallet from the given BIP39 mnemonic.
     *
     * @param mnemonic Any valid English mnemonic.
     * @param options An optional `Secp256k1HdWalletOptions` object optionally containing a bip39Password, hdPaths, and prefix.
     */
    static async fromMnemonic(mnemonic, options = {}) {
        const mnemonicChecked = new crypto_1.EnglishMnemonic(mnemonic);
        const seed = await crypto_1.Bip39.mnemonicToSeed(mnemonicChecked, options.bip39Password);
        return new Secp256k1HdWallet(mnemonicChecked, {
            ...options,
            seed: seed,
        });
    }
    /**
     * Generates a new wallet with a BIP39 mnemonic of the given length.
     *
     * @param length The number of words in the mnemonic (12, 15, 18, 21 or 24).
     * @param options An optional `Secp256k1HdWalletOptions` object optionally containing a bip39Password, hdPaths, and prefix.
     */
    static async generate(length = 12, options = {}) {
        const entropyLength = 4 * Math.floor((11 * length) / 33);
        const entropy = crypto_1.Random.getBytes(entropyLength);
        const mnemonic = crypto_1.Bip39.encode(entropy);
        return Secp256k1HdWallet.fromMnemonic(mnemonic.toString(), options);
    }
    /**
     * Restores a wallet from an encrypted serialization.
     *
     * @param password The user provided password used to generate an encryption key via a KDF.
     *                 This is not normalized internally (see "Unicode normalization" to learn more).
     */
    static async deserialize(serialization, password) {
        const root = JSON.parse(serialization);
        if (!(0, utils_1.isNonNullObject)(root))
            throw new Error("Root document is not an object.");
        switch (root.type) {
            case serializationTypeV1:
                return Secp256k1HdWallet.deserializeTypeV1(serialization, password);
            default:
                throw new Error("Unsupported serialization type");
        }
    }
    /**
     * Restores a wallet from an encrypted serialization.
     *
     * This is an advanced alternative to calling `deserialize(serialization, password)` directly, which allows
     * you to offload the KDF execution to a non-UI thread (e.g. in a WebWorker).
     *
     * The caller is responsible for ensuring the key was derived with the given KDF configuration. This can be
     * done using `extractKdfConfiguration(serialization)` and `executeKdf(password, kdfConfiguration)` from this package.
     */
    static async deserializeWithEncryptionKey(serialization, encryptionKey) {
        const root = JSON.parse(serialization);
        if (!(0, utils_1.isNonNullObject)(root))
            throw new Error("Root document is not an object.");
        const untypedRoot = root;
        switch (untypedRoot.type) {
            case serializationTypeV1: {
                const decryptedBytes = await (0, wallet_1.decrypt)((0, encoding_1.fromBase64)(untypedRoot.data), encryptionKey, untypedRoot.encryption);
                const decryptedDocument = JSON.parse((0, encoding_1.fromUtf8)(decryptedBytes));
                const { mnemonic, accounts } = decryptedDocument;
                (0, utils_1.assert)(typeof mnemonic === "string");
                if (!Array.isArray(accounts))
                    throw new Error("Property 'accounts' is not an array");
                if (!accounts.every((account) => isDerivationJson(account))) {
                    throw new Error("Account is not in the correct format.");
                }
                const firstPrefix = accounts[0].prefix;
                if (!accounts.every(({ prefix }) => prefix === firstPrefix)) {
                    throw new Error("Accounts do not all have the same prefix");
                }
                const hdPaths = accounts.map(({ hdPath }) => (0, crypto_1.stringToPath)(hdPath));
                return Secp256k1HdWallet.fromMnemonic(mnemonic, {
                    hdPaths: hdPaths,
                    prefix: firstPrefix,
                });
            }
            default:
                throw new Error("Unsupported serialization type");
        }
    }
    static async deserializeTypeV1(serialization, password) {
        const root = JSON.parse(serialization);
        if (!(0, utils_1.isNonNullObject)(root))
            throw new Error("Root document is not an object.");
        const encryptionKey = await (0, wallet_1.executeKdf)(password, root.kdf);
        return Secp256k1HdWallet.deserializeWithEncryptionKey(serialization, encryptionKey);
    }
    get mnemonic() {
        return this.secret.toString();
    }
    async getAccounts() {
        const accountsWithPrivkeys = await this.getAccountsWithPrivkeys();
        return accountsWithPrivkeys.map(({ algo, pubkey, address }) => ({
            algo: algo,
            pubkey: pubkey,
            address: address,
        }));
    }
    async signAmino(signerAddress, signDoc) {
        const accounts = await this.getAccountsWithPrivkeys();
        const account = accounts.find(({ address }) => address === signerAddress);
        if (account === undefined) {
            throw new Error(`Address ${signerAddress} not found in wallet`);
        }
        const { privkey, pubkey } = account;
        const message = (0, crypto_1.sha256)((0, signdoc_1.serializeSignDoc)(signDoc));
        const signature = await crypto_1.Secp256k1.createSignature(message, privkey);
        const signatureBytes = new Uint8Array([...signature.r(32), ...signature.s(32)]);
        return {
            signed: signDoc,
            signature: (0, signature_1.encodeSecp256k1Signature)(pubkey, signatureBytes),
        };
    }
    /**
     * Generates an encrypted serialization of this wallet.
     *
     * @param password The user provided password used to generate an encryption key via a KDF.
     *                 This is not normalized internally (see "Unicode normalization" to learn more).
     */
    async serialize(password) {
        const kdfConfiguration = basicPasswordHashingOptions;
        const encryptionKey = await (0, wallet_1.executeKdf)(password, kdfConfiguration);
        return this.serializeWithEncryptionKey(encryptionKey, kdfConfiguration);
    }
    /**
     * Generates an encrypted serialization of this wallet.
     *
     * This is an advanced alternative to calling `serialize(password)` directly, which allows you to
     * offload the KDF execution to a non-UI thread (e.g. in a WebWorker).
     *
     * The caller is responsible for ensuring the key was derived with the given KDF options. If this
     * is not the case, the wallet cannot be restored with the original password.
     */
    async serializeWithEncryptionKey(encryptionKey, kdfConfiguration) {
        const dataToEncrypt = {
            mnemonic: this.mnemonic,
            accounts: this.accounts.map(({ hdPath, prefix }) => ({
                hdPath: (0, crypto_1.pathToString)(hdPath),
                prefix: prefix,
            })),
        };
        const dataToEncryptRaw = (0, encoding_1.toUtf8)(JSON.stringify(dataToEncrypt));
        const encryptionConfiguration = {
            algorithm: wallet_1.supportedAlgorithms.xchacha20poly1305Ietf,
        };
        const encryptedData = await (0, wallet_1.encrypt)(dataToEncryptRaw, encryptionKey, encryptionConfiguration);
        const out = {
            type: serializationTypeV1,
            kdf: kdfConfiguration,
            encryption: encryptionConfiguration,
            data: (0, encoding_1.toBase64)(encryptedData),
        };
        return JSON.stringify(out);
    }
    async getKeyPair(hdPath) {
        const { privkey } = crypto_1.Slip10.derivePath(crypto_1.Slip10Curve.Secp256k1, this.seed, hdPath);
        const { pubkey } = await crypto_1.Secp256k1.makeKeypair(privkey);
        return {
            privkey: privkey,
            pubkey: crypto_1.Secp256k1.compressPubkey(pubkey),
        };
    }
    async getAccountsWithPrivkeys() {
        return Promise.all(this.accounts.map(async ({ hdPath, prefix }) => {
            const { privkey, pubkey } = await this.getKeyPair(hdPath);
            const address = (0, encoding_1.toBech32)(prefix, (0, addresses_1.rawSecp256k1PubkeyToRawAddress)(pubkey));
            return {
                algo: "secp256k1",
                privkey: privkey,
                pubkey: pubkey,
                address: address,
            };
        }));
    }
}
exports.Secp256k1HdWallet = Secp256k1HdWallet;
//# sourceMappingURL=secp256k1hdwallet.js.map

/***/ }),

/***/ 22437:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Secp256k1Wallet = void 0;
const crypto_1 = __webpack_require__(79562);
const encoding_1 = __webpack_require__(71555);
const addresses_1 = __webpack_require__(76450);
const signature_1 = __webpack_require__(10204);
const signdoc_1 = __webpack_require__(44669);
/**
 * A wallet that holds a single secp256k1 keypair.
 *
 * If you want to work with BIP39 mnemonics and multiple accounts, use Secp256k1HdWallet.
 */
class Secp256k1Wallet {
    constructor(privkey, pubkey, prefix) {
        this.privkey = privkey;
        this.pubkey = pubkey;
        this.prefix = prefix;
    }
    /**
     * Creates a Secp256k1Wallet from the given private key
     *
     * @param privkey The private key.
     * @param prefix The bech32 address prefix (human readable part). Defaults to "cosmos".
     */
    static async fromKey(privkey, prefix = "cosmos") {
        const uncompressed = (await crypto_1.Secp256k1.makeKeypair(privkey)).pubkey;
        return new Secp256k1Wallet(privkey, crypto_1.Secp256k1.compressPubkey(uncompressed), prefix);
    }
    get address() {
        return (0, encoding_1.toBech32)(this.prefix, (0, addresses_1.rawSecp256k1PubkeyToRawAddress)(this.pubkey));
    }
    async getAccounts() {
        return [
            {
                algo: "secp256k1",
                address: this.address,
                pubkey: this.pubkey,
            },
        ];
    }
    async signAmino(signerAddress, signDoc) {
        if (signerAddress !== this.address) {
            throw new Error(`Address ${signerAddress} not found in wallet`);
        }
        const message = new crypto_1.Sha256((0, signdoc_1.serializeSignDoc)(signDoc)).digest();
        const signature = await crypto_1.Secp256k1.createSignature(message, this.privkey);
        const signatureBytes = new Uint8Array([...signature.r(32), ...signature.s(32)]);
        return {
            signed: signDoc,
            signature: (0, signature_1.encodeSecp256k1Signature)(this.pubkey, signatureBytes),
        };
    }
}
exports.Secp256k1Wallet = Secp256k1Wallet;
//# sourceMappingURL=secp256k1wallet.js.map

/***/ }),

/***/ 10204:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.decodeSignature = exports.encodeSecp256k1Signature = void 0;
/* eslint-disable @typescript-eslint/naming-convention */
const encoding_1 = __webpack_require__(71555);
const encoding_2 = __webpack_require__(48128);
const pubkeys_1 = __webpack_require__(38682);
/**
 * Takes a binary pubkey and signature to create a signature object
 *
 * @param pubkey a compressed secp256k1 public key
 * @param signature a 64 byte fixed length representation of secp256k1 signature components r and s
 */
function encodeSecp256k1Signature(pubkey, signature) {
    if (signature.length !== 64) {
        throw new Error("Signature must be 64 bytes long. Cosmos SDK uses a 2x32 byte fixed length encoding for the secp256k1 signature integers r and s.");
    }
    return {
        pub_key: (0, encoding_2.encodeSecp256k1Pubkey)(pubkey),
        signature: (0, encoding_1.toBase64)(signature),
    };
}
exports.encodeSecp256k1Signature = encodeSecp256k1Signature;
function decodeSignature(signature) {
    switch (signature.pub_key.type) {
        // Note: please don't add cases here without writing additional unit tests
        case pubkeys_1.pubkeyType.secp256k1:
            return {
                pubkey: (0, encoding_1.fromBase64)(signature.pub_key.value),
                signature: (0, encoding_1.fromBase64)(signature.signature),
            };
        default:
            throw new Error("Unsupported pubkey type");
    }
}
exports.decodeSignature = decodeSignature;
//# sourceMappingURL=signature.js.map

/***/ }),

/***/ 44669:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.serializeSignDoc = exports.makeSignDoc = exports.sortedJsonStringify = void 0;
/* eslint-disable @typescript-eslint/naming-convention */
const encoding_1 = __webpack_require__(71555);
const math_1 = __webpack_require__(62949);
function sortedObject(obj) {
    if (typeof obj !== "object" || obj === null) {
        return obj;
    }
    if (Array.isArray(obj)) {
        return obj.map(sortedObject);
    }
    const sortedKeys = Object.keys(obj).sort();
    const result = {};
    // NOTE: Use forEach instead of reduce for performance with large objects eg Wasm code
    sortedKeys.forEach((key) => {
        result[key] = sortedObject(obj[key]);
    });
    return result;
}
/** Returns a JSON string with objects sorted by key */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function sortedJsonStringify(obj) {
    return JSON.stringify(sortedObject(obj));
}
exports.sortedJsonStringify = sortedJsonStringify;
function makeSignDoc(msgs, fee, chainId, memo, accountNumber, sequence) {
    return {
        chain_id: chainId,
        account_number: math_1.Uint53.fromString(accountNumber.toString()).toString(),
        sequence: math_1.Uint53.fromString(sequence.toString()).toString(),
        fee: fee,
        msgs: msgs,
        memo: memo || "",
    };
}
exports.makeSignDoc = makeSignDoc;
function serializeSignDoc(signDoc) {
    return (0, encoding_1.toUtf8)(sortedJsonStringify(signDoc));
}
exports.serializeSignDoc = serializeSignDoc;
//# sourceMappingURL=signdoc.js.map

/***/ }),

/***/ 12474:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.makeStdTx = exports.isStdTx = void 0;
function isStdTx(txValue) {
    const { memo, msg, fee, signatures } = txValue;
    return (typeof memo === "string" && Array.isArray(msg) && typeof fee === "object" && Array.isArray(signatures));
}
exports.isStdTx = isStdTx;
function makeStdTx(content, signatures) {
    return {
        msg: content.msgs,
        fee: content.fee,
        memo: content.memo,
        signatures: Array.isArray(signatures) ? signatures : [signatures],
    };
}
exports.makeStdTx = makeStdTx;
//# sourceMappingURL=stdtx.js.map

/***/ }),

/***/ 67137:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.decrypt = exports.encrypt = exports.supportedAlgorithms = exports.executeKdf = exports.cosmjsSalt = void 0;
const crypto_1 = __webpack_require__(79562);
const encoding_1 = __webpack_require__(71555);
/**
 * A fixed salt is chosen to archive a deterministic password to key derivation.
 * This reduces the scope of a potential rainbow attack to all CosmJS users.
 * Must be 16 bytes due to implementation limitations.
 */
exports.cosmjsSalt = (0, encoding_1.toAscii)("The CosmJS salt.");
async function executeKdf(password, configuration) {
    switch (configuration.algorithm) {
        case "argon2id": {
            const options = configuration.params;
            if (!(0, crypto_1.isArgon2idOptions)(options))
                throw new Error("Invalid format of argon2id params");
            return crypto_1.Argon2id.execute(password, exports.cosmjsSalt, options);
        }
        default:
            throw new Error("Unsupported KDF algorithm");
    }
}
exports.executeKdf = executeKdf;
exports.supportedAlgorithms = {
    xchacha20poly1305Ietf: "xchacha20poly1305-ietf",
};
async function encrypt(plaintext, encryptionKey, config) {
    switch (config.algorithm) {
        case exports.supportedAlgorithms.xchacha20poly1305Ietf: {
            const nonce = crypto_1.Random.getBytes(crypto_1.xchacha20NonceLength);
            // Prepend fixed-length nonce to ciphertext as suggested in the example from https://github.com/jedisct1/libsodium.js#api
            return new Uint8Array([
                ...nonce,
                ...(await crypto_1.Xchacha20poly1305Ietf.encrypt(plaintext, encryptionKey, nonce)),
            ]);
        }
        default:
            throw new Error(`Unsupported encryption algorithm: '${config.algorithm}'`);
    }
}
exports.encrypt = encrypt;
async function decrypt(ciphertext, encryptionKey, config) {
    switch (config.algorithm) {
        case exports.supportedAlgorithms.xchacha20poly1305Ietf: {
            const nonce = ciphertext.slice(0, crypto_1.xchacha20NonceLength);
            return crypto_1.Xchacha20poly1305Ietf.decrypt(ciphertext.slice(crypto_1.xchacha20NonceLength), encryptionKey, nonce);
        }
        default:
            throw new Error(`Unsupported encryption algorithm: '${config.algorithm}'`);
    }
}
exports.decrypt = decrypt;
//# sourceMappingURL=wallet.js.map

/***/ }),

/***/ 23294:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.fromAscii = exports.toAscii = void 0;
function toAscii(input) {
    const toNums = (str) => str.split("").map((x) => {
        const charCode = x.charCodeAt(0);
        // 0x00–0x1F control characters
        // 0x20–0x7E printable characters
        // 0x7F delete character
        // 0x80–0xFF out of 7 bit ascii range
        if (charCode < 0x20 || charCode > 0x7e) {
            throw new Error("Cannot encode character that is out of printable ASCII range: " + charCode);
        }
        return charCode;
    });
    return Uint8Array.from(toNums(input));
}
exports.toAscii = toAscii;
function fromAscii(data) {
    const fromNums = (listOfNumbers) => listOfNumbers.map((x) => {
        // 0x00–0x1F control characters
        // 0x20–0x7E printable characters
        // 0x7F delete character
        // 0x80–0xFF out of 7 bit ascii range
        if (x < 0x20 || x > 0x7e) {
            throw new Error("Cannot decode character that is out of printable ASCII range: " + x);
        }
        return String.fromCharCode(x);
    });
    return fromNums(Array.from(data)).join("");
}
exports.fromAscii = fromAscii;
//# sourceMappingURL=ascii.js.map

/***/ }),

/***/ 7324:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.fromBase64 = exports.toBase64 = void 0;
const base64js = __importStar(__webpack_require__(79742));
function toBase64(data) {
    return base64js.fromByteArray(data);
}
exports.toBase64 = toBase64;
function fromBase64(base64String) {
    if (!base64String.match(/^[a-zA-Z0-9+/]*={0,2}$/)) {
        throw new Error("Invalid base64 string format");
    }
    return base64js.toByteArray(base64String);
}
exports.fromBase64 = fromBase64;
//# sourceMappingURL=base64.js.map

/***/ }),

/***/ 93433:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Bech32 = exports.normalizeBech32 = exports.fromBech32 = exports.toBech32 = void 0;
const bech32 = __importStar(__webpack_require__(19054));
function toBech32(prefix, data, limit) {
    const address = bech32.encode(prefix, bech32.toWords(data), limit);
    return address;
}
exports.toBech32 = toBech32;
function fromBech32(address, limit = Infinity) {
    const decodedAddress = bech32.decode(address, limit);
    return {
        prefix: decodedAddress.prefix,
        data: new Uint8Array(bech32.fromWords(decodedAddress.words)),
    };
}
exports.fromBech32 = fromBech32;
/**
 * Takes a bech32 address and returns a normalized (i.e. lower case) representation of it.
 *
 * The input is validated along the way, which makes this significantly safer than
 * using `address.toLowerCase()`.
 */
function normalizeBech32(address) {
    const { prefix, data } = fromBech32(address);
    return toBech32(prefix, data);
}
exports.normalizeBech32 = normalizeBech32;
/**
 * @deprecated This class is deprecated and will be removed soon. Please use fromBech32() and toBech32() instead. For more details please refer to https://github.com/cosmos/cosmjs/issues/1053.
 */
class Bech32 {
    /**
     * @deprecated This class is deprecated and will be removed soon. Please use fromBech32() and toBech32() instead. For more details please refer to https://github.com/cosmos/cosmjs/issues/1053.
     */
    static encode(prefix, data, limit) {
        return toBech32(prefix, data, limit);
    }
    /**
     * @deprecated This class is deprecated and will be removed soon. Please use fromBech32() and toBech32() instead. For more details please refer to https://github.com/cosmos/cosmjs/issues/1053.
     */
    static decode(address, limit = Infinity) {
        return fromBech32(address, limit);
    }
}
exports.Bech32 = Bech32;
//# sourceMappingURL=bech32.js.map

/***/ }),

/***/ 79364:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.fromHex = exports.toHex = void 0;
function toHex(data) {
    let out = "";
    for (const byte of data) {
        out += ("0" + byte.toString(16)).slice(-2);
    }
    return out;
}
exports.toHex = toHex;
function fromHex(hexstring) {
    if (hexstring.length % 2 !== 0) {
        throw new Error("hex string length must be a multiple of 2");
    }
    const out = new Uint8Array(hexstring.length / 2);
    for (let i = 0; i < out.length; i++) {
        const j = 2 * i;
        const hexByteAsString = hexstring.slice(j, j + 2);
        if (!hexByteAsString.match(/[0-9a-f]{2}/i)) {
            throw new Error("hex string contains invalid characters");
        }
        out[i] = parseInt(hexByteAsString, 16);
    }
    return out;
}
exports.fromHex = fromHex;
//# sourceMappingURL=hex.js.map

/***/ }),

/***/ 71555:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.toUtf8 = exports.fromUtf8 = exports.toRfc3339 = exports.fromRfc3339 = exports.toHex = exports.fromHex = exports.toBech32 = exports.normalizeBech32 = exports.fromBech32 = exports.Bech32 = exports.toBase64 = exports.fromBase64 = exports.toAscii = exports.fromAscii = void 0;
var ascii_1 = __webpack_require__(23294);
Object.defineProperty(exports, "fromAscii", ({ enumerable: true, get: function () { return ascii_1.fromAscii; } }));
Object.defineProperty(exports, "toAscii", ({ enumerable: true, get: function () { return ascii_1.toAscii; } }));
var base64_1 = __webpack_require__(7324);
Object.defineProperty(exports, "fromBase64", ({ enumerable: true, get: function () { return base64_1.fromBase64; } }));
Object.defineProperty(exports, "toBase64", ({ enumerable: true, get: function () { return base64_1.toBase64; } }));
var bech32_1 = __webpack_require__(93433);
Object.defineProperty(exports, "Bech32", ({ enumerable: true, get: function () { return bech32_1.Bech32; } }));
Object.defineProperty(exports, "fromBech32", ({ enumerable: true, get: function () { return bech32_1.fromBech32; } }));
Object.defineProperty(exports, "normalizeBech32", ({ enumerable: true, get: function () { return bech32_1.normalizeBech32; } }));
Object.defineProperty(exports, "toBech32", ({ enumerable: true, get: function () { return bech32_1.toBech32; } }));
var hex_1 = __webpack_require__(79364);
Object.defineProperty(exports, "fromHex", ({ enumerable: true, get: function () { return hex_1.fromHex; } }));
Object.defineProperty(exports, "toHex", ({ enumerable: true, get: function () { return hex_1.toHex; } }));
var rfc3339_1 = __webpack_require__(72417);
Object.defineProperty(exports, "fromRfc3339", ({ enumerable: true, get: function () { return rfc3339_1.fromRfc3339; } }));
Object.defineProperty(exports, "toRfc3339", ({ enumerable: true, get: function () { return rfc3339_1.toRfc3339; } }));
var utf8_1 = __webpack_require__(40460);
Object.defineProperty(exports, "fromUtf8", ({ enumerable: true, get: function () { return utf8_1.fromUtf8; } }));
Object.defineProperty(exports, "toUtf8", ({ enumerable: true, get: function () { return utf8_1.toUtf8; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 72417:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.toRfc3339 = exports.fromRfc3339 = void 0;
const rfc3339Matcher = /^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2}):(\d{2})(\.\d{1,9})?((?:[+-]\d{2}:\d{2})|Z)$/;
function padded(integer, length = 2) {
    return integer.toString().padStart(length, "0");
}
function fromRfc3339(str) {
    const matches = rfc3339Matcher.exec(str);
    if (!matches) {
        throw new Error("Date string is not in RFC3339 format");
    }
    const year = +matches[1];
    const month = +matches[2];
    const day = +matches[3];
    const hour = +matches[4];
    const minute = +matches[5];
    const second = +matches[6];
    // fractional seconds match either undefined or a string like ".1", ".123456789"
    const milliSeconds = matches[7] ? Math.floor(+matches[7] * 1000) : 0;
    let tzOffsetSign;
    let tzOffsetHours;
    let tzOffsetMinutes;
    // if timezone is undefined, it must be Z or nothing (otherwise the group would have captured).
    if (matches[8] === "Z") {
        tzOffsetSign = 1;
        tzOffsetHours = 0;
        tzOffsetMinutes = 0;
    }
    else {
        tzOffsetSign = matches[8].substring(0, 1) === "-" ? -1 : 1;
        tzOffsetHours = +matches[8].substring(1, 3);
        tzOffsetMinutes = +matches[8].substring(4, 6);
    }
    const tzOffset = tzOffsetSign * (tzOffsetHours * 60 + tzOffsetMinutes) * 60; // seconds
    const timestamp = Date.UTC(year, month - 1, day, hour, minute, second, milliSeconds) - tzOffset * 1000;
    return new Date(timestamp);
}
exports.fromRfc3339 = fromRfc3339;
function toRfc3339(date) {
    const year = date.getUTCFullYear();
    const month = padded(date.getUTCMonth() + 1);
    const day = padded(date.getUTCDate());
    const hour = padded(date.getUTCHours());
    const minute = padded(date.getUTCMinutes());
    const second = padded(date.getUTCSeconds());
    const ms = padded(date.getUTCMilliseconds(), 3);
    return `${year}-${month}-${day}T${hour}:${minute}:${second}.${ms}Z`;
}
exports.toRfc3339 = toRfc3339;
//# sourceMappingURL=rfc3339.js.map

/***/ }),

/***/ 40460:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.fromUtf8 = exports.toUtf8 = void 0;
function toUtf8(str) {
    return new TextEncoder().encode(str);
}
exports.toUtf8 = toUtf8;
/**
 * Takes UTF-8 data and decodes it to a string.
 *
 * In lossy mode, the replacement character � is used to substitude invalid
 * encodings. By default lossy mode is off and invalid data will lead to exceptions.
 */
function fromUtf8(data, lossy = false) {
    const fatal = !lossy;
    return new TextDecoder("utf-8", { fatal }).decode(data);
}
exports.fromUtf8 = fromUtf8;
//# sourceMappingURL=utf8.js.map

/***/ }),

/***/ 56849:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.isJsonCompatibleDictionary = exports.isJsonCompatibleArray = exports.isJsonCompatibleValue = void 0;
function isJsonCompatibleValue(value) {
    if (typeof value === "string" ||
        typeof value === "number" ||
        typeof value === "boolean" ||
        value === null ||
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        isJsonCompatibleArray(value) ||
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        isJsonCompatibleDictionary(value)) {
        return true;
    }
    else {
        return false;
    }
}
exports.isJsonCompatibleValue = isJsonCompatibleValue;
function isJsonCompatibleArray(value) {
    if (!Array.isArray(value)) {
        return false;
    }
    for (const item of value) {
        if (!isJsonCompatibleValue(item)) {
            return false;
        }
    }
    // all items okay
    return true;
}
exports.isJsonCompatibleArray = isJsonCompatibleArray;
function isJsonCompatibleDictionary(data) {
    if (typeof data !== "object" || data === null) {
        // data must be a non-null object
        return false;
    }
    // Exclude special kind of objects like Array, Date or Uint8Array
    // Object.prototype.toString() returns a specified value:
    // http://www.ecma-international.org/ecma-262/7.0/index.html#sec-object.prototype.tostring
    if (Object.prototype.toString.call(data) !== "[object Object]") {
        return false;
    }
    return Object.values(data).every(isJsonCompatibleValue);
}
exports.isJsonCompatibleDictionary = isJsonCompatibleDictionary;
//# sourceMappingURL=compatibility.js.map

/***/ }),

/***/ 2695:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.makeJsonRpcId = void 0;
// Start with 10001 to avoid possible collisions with all hand-selected values like e.g. 1,2,3,42,100
let counter = 10000;
/**
 * Creates a new ID to be used for creating a JSON-RPC request.
 *
 * Multiple calls of this produce unique values.
 *
 * The output may be any value compatible to JSON-RPC request IDs with an undefined output format and generation logic.
 */
function makeJsonRpcId() {
    return (counter += 1);
}
exports.makeJsonRpcId = makeJsonRpcId;
//# sourceMappingURL=id.js.map

/***/ }),

/***/ 95633:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.jsonRpcCode = exports.isJsonRpcSuccessResponse = exports.isJsonRpcErrorResponse = exports.parseJsonRpcSuccessResponse = exports.parseJsonRpcResponse = exports.parseJsonRpcRequest = exports.parseJsonRpcId = exports.parseJsonRpcErrorResponse = exports.JsonRpcClient = exports.makeJsonRpcId = void 0;
var id_1 = __webpack_require__(2695);
Object.defineProperty(exports, "makeJsonRpcId", ({ enumerable: true, get: function () { return id_1.makeJsonRpcId; } }));
var jsonrpcclient_1 = __webpack_require__(37324);
Object.defineProperty(exports, "JsonRpcClient", ({ enumerable: true, get: function () { return jsonrpcclient_1.JsonRpcClient; } }));
var parse_1 = __webpack_require__(40344);
Object.defineProperty(exports, "parseJsonRpcErrorResponse", ({ enumerable: true, get: function () { return parse_1.parseJsonRpcErrorResponse; } }));
Object.defineProperty(exports, "parseJsonRpcId", ({ enumerable: true, get: function () { return parse_1.parseJsonRpcId; } }));
Object.defineProperty(exports, "parseJsonRpcRequest", ({ enumerable: true, get: function () { return parse_1.parseJsonRpcRequest; } }));
Object.defineProperty(exports, "parseJsonRpcResponse", ({ enumerable: true, get: function () { return parse_1.parseJsonRpcResponse; } }));
Object.defineProperty(exports, "parseJsonRpcSuccessResponse", ({ enumerable: true, get: function () { return parse_1.parseJsonRpcSuccessResponse; } }));
var types_1 = __webpack_require__(9905);
Object.defineProperty(exports, "isJsonRpcErrorResponse", ({ enumerable: true, get: function () { return types_1.isJsonRpcErrorResponse; } }));
Object.defineProperty(exports, "isJsonRpcSuccessResponse", ({ enumerable: true, get: function () { return types_1.isJsonRpcSuccessResponse; } }));
Object.defineProperty(exports, "jsonRpcCode", ({ enumerable: true, get: function () { return types_1.jsonRpcCode; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 37324:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.JsonRpcClient = void 0;
const stream_1 = __webpack_require__(81459);
const types_1 = __webpack_require__(9905);
/**
 * A thin wrapper that is used to bring together requests and responses by ID.
 *
 * Using this class is only advised for continous communication channels like
 * WebSockets or WebWorker messaging.
 */
class JsonRpcClient {
    constructor(connection) {
        this.connection = connection;
    }
    async run(request) {
        const filteredStream = this.connection.responseStream.filter((r) => r.id === request.id);
        const pendingResponses = (0, stream_1.firstEvent)(filteredStream);
        this.connection.sendRequest(request);
        const response = await pendingResponses;
        if ((0, types_1.isJsonRpcErrorResponse)(response)) {
            const error = response.error;
            throw new Error(`JSON RPC error: code=${error.code}; message='${error.message}'`);
        }
        return response;
    }
}
exports.JsonRpcClient = JsonRpcClient;
//# sourceMappingURL=jsonrpcclient.js.map

/***/ }),

/***/ 40344:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.parseJsonRpcResponse = exports.parseJsonRpcSuccessResponse = exports.parseJsonRpcErrorResponse = exports.parseJsonRpcRequest = exports.parseJsonRpcId = void 0;
const compatibility_1 = __webpack_require__(56849);
/**
 * Extracts ID field from request or response object.
 *
 * Returns `null` when no valid ID was found.
 */
function parseJsonRpcId(data) {
    if (!(0, compatibility_1.isJsonCompatibleDictionary)(data)) {
        throw new Error("Data must be JSON compatible dictionary");
    }
    const id = data.id;
    if (typeof id !== "number" && typeof id !== "string") {
        return null;
    }
    return id;
}
exports.parseJsonRpcId = parseJsonRpcId;
function parseJsonRpcRequest(data) {
    if (!(0, compatibility_1.isJsonCompatibleDictionary)(data)) {
        throw new Error("Data must be JSON compatible dictionary");
    }
    if (data.jsonrpc !== "2.0") {
        throw new Error(`Got unexpected jsonrpc version: ${data.jsonrpc}`);
    }
    const id = parseJsonRpcId(data);
    if (id === null) {
        throw new Error("Invalid id field");
    }
    const method = data.method;
    if (typeof method !== "string") {
        throw new Error("Invalid method field");
    }
    if (!(0, compatibility_1.isJsonCompatibleArray)(data.params) && !(0, compatibility_1.isJsonCompatibleDictionary)(data.params)) {
        throw new Error("Invalid params field");
    }
    return {
        jsonrpc: "2.0",
        id: id,
        method: method,
        params: data.params,
    };
}
exports.parseJsonRpcRequest = parseJsonRpcRequest;
function parseError(error) {
    if (typeof error.code !== "number") {
        throw new Error("Error property 'code' is not a number");
    }
    if (typeof error.message !== "string") {
        throw new Error("Error property 'message' is not a string");
    }
    let maybeUndefinedData;
    if (error.data === undefined) {
        maybeUndefinedData = undefined;
    }
    else if ((0, compatibility_1.isJsonCompatibleValue)(error.data)) {
        maybeUndefinedData = error.data;
    }
    else {
        throw new Error("Error property 'data' is defined but not a JSON compatible value.");
    }
    return {
        code: error.code,
        message: error.message,
        ...(maybeUndefinedData !== undefined ? { data: maybeUndefinedData } : {}),
    };
}
/** Throws if data is not a JsonRpcErrorResponse */
function parseJsonRpcErrorResponse(data) {
    if (!(0, compatibility_1.isJsonCompatibleDictionary)(data)) {
        throw new Error("Data must be JSON compatible dictionary");
    }
    if (data.jsonrpc !== "2.0") {
        throw new Error(`Got unexpected jsonrpc version: ${JSON.stringify(data)}`);
    }
    const id = data.id;
    if (typeof id !== "number" && typeof id !== "string" && id !== null) {
        throw new Error("Invalid id field");
    }
    if (typeof data.error === "undefined" || !(0, compatibility_1.isJsonCompatibleDictionary)(data.error)) {
        throw new Error("Invalid error field");
    }
    return {
        jsonrpc: "2.0",
        id: id,
        error: parseError(data.error),
    };
}
exports.parseJsonRpcErrorResponse = parseJsonRpcErrorResponse;
/** Throws if data is not a JsonRpcSuccessResponse */
function parseJsonRpcSuccessResponse(data) {
    if (!(0, compatibility_1.isJsonCompatibleDictionary)(data)) {
        throw new Error("Data must be JSON compatible dictionary");
    }
    if (data.jsonrpc !== "2.0") {
        throw new Error(`Got unexpected jsonrpc version: ${JSON.stringify(data)}`);
    }
    const id = data.id;
    if (typeof id !== "number" && typeof id !== "string") {
        throw new Error("Invalid id field");
    }
    if (typeof data.result === "undefined") {
        throw new Error("Invalid result field");
    }
    const result = data.result;
    return {
        jsonrpc: "2.0",
        id: id,
        result: result,
    };
}
exports.parseJsonRpcSuccessResponse = parseJsonRpcSuccessResponse;
/**
 * Returns a JsonRpcErrorResponse if input can be parsed as a JSON-RPC error. Otherwise parses
 * input as JsonRpcSuccessResponse. Throws if input is neither a valid error nor success response.
 */
function parseJsonRpcResponse(data) {
    let response;
    try {
        response = parseJsonRpcErrorResponse(data);
    }
    catch (_) {
        response = parseJsonRpcSuccessResponse(data);
    }
    return response;
}
exports.parseJsonRpcResponse = parseJsonRpcResponse;
//# sourceMappingURL=parse.js.map

/***/ }),

/***/ 9905:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.jsonRpcCode = exports.isJsonRpcSuccessResponse = exports.isJsonRpcErrorResponse = void 0;
function isJsonRpcErrorResponse(response) {
    return typeof response.error === "object";
}
exports.isJsonRpcErrorResponse = isJsonRpcErrorResponse;
function isJsonRpcSuccessResponse(response) {
    return !isJsonRpcErrorResponse(response);
}
exports.isJsonRpcSuccessResponse = isJsonRpcSuccessResponse;
/**
 * Error codes as specified in JSON-RPC 2.0
 *
 * @see https://www.jsonrpc.org/specification#error_object
 */
exports.jsonRpcCode = {
    parseError: -32700,
    invalidRequest: -32600,
    methodNotFound: -32601,
    invalidParams: -32602,
    internalError: -32603,
    // server error (Reserved for implementation-defined server-errors.):
    // -32000 to -32099
    serverError: {
        default: -32000,
    },
};
//# sourceMappingURL=types.js.map

/***/ }),

/***/ 34166:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.parseCoins = void 0;
/**
 * Takes a coins list like "819966000ucosm,700000000ustake" and parses it.
 *
 * This is a Stargate ready version of parseCoins from @cosmjs/amino.
 * It supports more denoms.
 */
function parseCoins(input) {
    return input
        .replace(/\s/g, "")
        .split(",")
        .filter(Boolean)
        .map((part) => {
        // Denom regex from Stargate (https://github.com/cosmos/cosmos-sdk/blob/v0.42.7/types/coin.go#L599-L601)
        const match = part.match(/^([0-9]+)([a-zA-Z][a-zA-Z0-9/]{2,127})$/);
        if (!match)
            throw new Error("Got an invalid coin string");
        return {
            amount: match[1].replace(/^0+/, "") || "0",
            denom: match[2],
        };
    });
}
exports.parseCoins = parseCoins;
//# sourceMappingURL=coins.js.map

/***/ }),

/***/ 4738:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.decodeTxRaw = void 0;
const tx_1 = __webpack_require__(94289);
/**
 * Takes a serialized TxRaw (the bytes stored in Tendermint) and decodes it into something usable.
 */
function decodeTxRaw(tx) {
    const txRaw = tx_1.TxRaw.decode(tx);
    return {
        authInfo: tx_1.AuthInfo.decode(txRaw.authInfoBytes),
        body: tx_1.TxBody.decode(txRaw.bodyBytes),
        signatures: txRaw.signatures,
    };
}
exports.decodeTxRaw = decodeTxRaw;
//# sourceMappingURL=decode.js.map

/***/ }),

/***/ 63028:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.DirectSecp256k1HdWallet = exports.extractKdfConfiguration = void 0;
const amino_1 = __webpack_require__(24822);
const crypto_1 = __webpack_require__(79562);
const encoding_1 = __webpack_require__(71555);
const utils_1 = __webpack_require__(85553);
const signing_1 = __webpack_require__(24816);
const wallet_1 = __webpack_require__(63165);
const serializationTypeV1 = "directsecp256k1hdwallet-v1";
/**
 * A KDF configuration that is not very strong but can be used on the main thread.
 * It takes about 1 second in Node.js 16.0.0 and should have similar runtimes in other modern Wasm hosts.
 */
const basicPasswordHashingOptions = {
    algorithm: "argon2id",
    params: {
        outputLength: 32,
        opsLimit: 24,
        memLimitKib: 12 * 1024,
    },
};
function isDerivationJson(thing) {
    if (!(0, utils_1.isNonNullObject)(thing))
        return false;
    if (typeof thing.hdPath !== "string")
        return false;
    if (typeof thing.prefix !== "string")
        return false;
    return true;
}
function extractKdfConfigurationV1(doc) {
    return doc.kdf;
}
function extractKdfConfiguration(serialization) {
    const root = JSON.parse(serialization);
    if (!(0, utils_1.isNonNullObject)(root))
        throw new Error("Root document is not an object.");
    switch (root.type) {
        case serializationTypeV1:
            return extractKdfConfigurationV1(root);
        default:
            throw new Error("Unsupported serialization type");
    }
}
exports.extractKdfConfiguration = extractKdfConfiguration;
const defaultOptions = {
    bip39Password: "",
    hdPaths: [(0, amino_1.makeCosmoshubPath)(0)],
    prefix: "cosmos",
};
/** A wallet for protobuf based signing using SIGN_MODE_DIRECT */
class DirectSecp256k1HdWallet {
    constructor(mnemonic, options) {
        var _a, _b;
        const prefix = (_a = options.prefix) !== null && _a !== void 0 ? _a : defaultOptions.prefix;
        const hdPaths = (_b = options.hdPaths) !== null && _b !== void 0 ? _b : defaultOptions.hdPaths;
        this.secret = mnemonic;
        this.seed = options.seed;
        this.accounts = hdPaths.map((hdPath) => ({
            hdPath: hdPath,
            prefix: prefix,
        }));
    }
    /**
     * Restores a wallet from the given BIP39 mnemonic.
     *
     * @param mnemonic Any valid English mnemonic.
     * @param options An optional `DirectSecp256k1HdWalletOptions` object optionally containing a bip39Password, hdPaths, and prefix.
     */
    static async fromMnemonic(mnemonic, options = {}) {
        const mnemonicChecked = new crypto_1.EnglishMnemonic(mnemonic);
        const seed = await crypto_1.Bip39.mnemonicToSeed(mnemonicChecked, options.bip39Password);
        return new DirectSecp256k1HdWallet(mnemonicChecked, {
            ...options,
            seed: seed,
        });
    }
    /**
     * Generates a new wallet with a BIP39 mnemonic of the given length.
     *
     * @param length The number of words in the mnemonic (12, 15, 18, 21 or 24).
     * @param options An optional `DirectSecp256k1HdWalletOptions` object optionally containing a bip39Password, hdPaths, and prefix.
     */
    static async generate(length = 12, options = {}) {
        const entropyLength = 4 * Math.floor((11 * length) / 33);
        const entropy = crypto_1.Random.getBytes(entropyLength);
        const mnemonic = crypto_1.Bip39.encode(entropy);
        return DirectSecp256k1HdWallet.fromMnemonic(mnemonic.toString(), options);
    }
    /**
     * Restores a wallet from an encrypted serialization.
     *
     * @param password The user provided password used to generate an encryption key via a KDF.
     *                 This is not normalized internally (see "Unicode normalization" to learn more).
     */
    static async deserialize(serialization, password) {
        const root = JSON.parse(serialization);
        if (!(0, utils_1.isNonNullObject)(root))
            throw new Error("Root document is not an object.");
        switch (root.type) {
            case serializationTypeV1:
                return DirectSecp256k1HdWallet.deserializeTypeV1(serialization, password);
            default:
                throw new Error("Unsupported serialization type");
        }
    }
    /**
     * Restores a wallet from an encrypted serialization.
     *
     * This is an advanced alternative to calling `deserialize(serialization, password)` directly, which allows
     * you to offload the KDF execution to a non-UI thread (e.g. in a WebWorker).
     *
     * The caller is responsible for ensuring the key was derived with the given KDF configuration. This can be
     * done using `extractKdfConfiguration(serialization)` and `executeKdf(password, kdfConfiguration)` from this package.
     */
    static async deserializeWithEncryptionKey(serialization, encryptionKey) {
        const root = JSON.parse(serialization);
        if (!(0, utils_1.isNonNullObject)(root))
            throw new Error("Root document is not an object.");
        const untypedRoot = root;
        switch (untypedRoot.type) {
            case serializationTypeV1: {
                const decryptedBytes = await (0, wallet_1.decrypt)((0, encoding_1.fromBase64)(untypedRoot.data), encryptionKey, untypedRoot.encryption);
                const decryptedDocument = JSON.parse((0, encoding_1.fromUtf8)(decryptedBytes));
                const { mnemonic, accounts } = decryptedDocument;
                (0, utils_1.assert)(typeof mnemonic === "string");
                if (!Array.isArray(accounts))
                    throw new Error("Property 'accounts' is not an array");
                if (!accounts.every((account) => isDerivationJson(account))) {
                    throw new Error("Account is not in the correct format.");
                }
                const firstPrefix = accounts[0].prefix;
                if (!accounts.every(({ prefix }) => prefix === firstPrefix)) {
                    throw new Error("Accounts do not all have the same prefix");
                }
                const hdPaths = accounts.map(({ hdPath }) => (0, crypto_1.stringToPath)(hdPath));
                return DirectSecp256k1HdWallet.fromMnemonic(mnemonic, {
                    hdPaths: hdPaths,
                    prefix: firstPrefix,
                });
            }
            default:
                throw new Error("Unsupported serialization type");
        }
    }
    static async deserializeTypeV1(serialization, password) {
        const root = JSON.parse(serialization);
        if (!(0, utils_1.isNonNullObject)(root))
            throw new Error("Root document is not an object.");
        const encryptionKey = await (0, wallet_1.executeKdf)(password, root.kdf);
        return DirectSecp256k1HdWallet.deserializeWithEncryptionKey(serialization, encryptionKey);
    }
    get mnemonic() {
        return this.secret.toString();
    }
    async getAccounts() {
        const accountsWithPrivkeys = await this.getAccountsWithPrivkeys();
        return accountsWithPrivkeys.map(({ algo, pubkey, address }) => ({
            algo: algo,
            pubkey: pubkey,
            address: address,
        }));
    }
    async signDirect(signerAddress, signDoc) {
        const accounts = await this.getAccountsWithPrivkeys();
        const account = accounts.find(({ address }) => address === signerAddress);
        if (account === undefined) {
            throw new Error(`Address ${signerAddress} not found in wallet`);
        }
        const { privkey, pubkey } = account;
        const signBytes = (0, signing_1.makeSignBytes)(signDoc);
        const hashedMessage = (0, crypto_1.sha256)(signBytes);
        const signature = await crypto_1.Secp256k1.createSignature(hashedMessage, privkey);
        const signatureBytes = new Uint8Array([...signature.r(32), ...signature.s(32)]);
        const stdSignature = (0, amino_1.encodeSecp256k1Signature)(pubkey, signatureBytes);
        return {
            signed: signDoc,
            signature: stdSignature,
        };
    }
    /**
     * Generates an encrypted serialization of this wallet.
     *
     * @param password The user provided password used to generate an encryption key via a KDF.
     *                 This is not normalized internally (see "Unicode normalization" to learn more).
     */
    async serialize(password) {
        const kdfConfiguration = basicPasswordHashingOptions;
        const encryptionKey = await (0, wallet_1.executeKdf)(password, kdfConfiguration);
        return this.serializeWithEncryptionKey(encryptionKey, kdfConfiguration);
    }
    /**
     * Generates an encrypted serialization of this wallet.
     *
     * This is an advanced alternative to calling `serialize(password)` directly, which allows you to
     * offload the KDF execution to a non-UI thread (e.g. in a WebWorker).
     *
     * The caller is responsible for ensuring the key was derived with the given KDF options. If this
     * is not the case, the wallet cannot be restored with the original password.
     */
    async serializeWithEncryptionKey(encryptionKey, kdfConfiguration) {
        const dataToEncrypt = {
            mnemonic: this.mnemonic,
            accounts: this.accounts.map(({ hdPath, prefix }) => ({
                hdPath: (0, crypto_1.pathToString)(hdPath),
                prefix: prefix,
            })),
        };
        const dataToEncryptRaw = (0, encoding_1.toUtf8)(JSON.stringify(dataToEncrypt));
        const encryptionConfiguration = {
            algorithm: wallet_1.supportedAlgorithms.xchacha20poly1305Ietf,
        };
        const encryptedData = await (0, wallet_1.encrypt)(dataToEncryptRaw, encryptionKey, encryptionConfiguration);
        const out = {
            type: serializationTypeV1,
            kdf: kdfConfiguration,
            encryption: encryptionConfiguration,
            data: (0, encoding_1.toBase64)(encryptedData),
        };
        return JSON.stringify(out);
    }
    async getKeyPair(hdPath) {
        const { privkey } = crypto_1.Slip10.derivePath(crypto_1.Slip10Curve.Secp256k1, this.seed, hdPath);
        const { pubkey } = await crypto_1.Secp256k1.makeKeypair(privkey);
        return {
            privkey: privkey,
            pubkey: crypto_1.Secp256k1.compressPubkey(pubkey),
        };
    }
    async getAccountsWithPrivkeys() {
        return Promise.all(this.accounts.map(async ({ hdPath, prefix }) => {
            const { privkey, pubkey } = await this.getKeyPair(hdPath);
            const address = (0, encoding_1.toBech32)(prefix, (0, amino_1.rawSecp256k1PubkeyToRawAddress)(pubkey));
            return {
                algo: "secp256k1",
                privkey: privkey,
                pubkey: pubkey,
                address: address,
            };
        }));
    }
}
exports.DirectSecp256k1HdWallet = DirectSecp256k1HdWallet;
//# sourceMappingURL=directsecp256k1hdwallet.js.map

/***/ }),

/***/ 26591:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.DirectSecp256k1Wallet = void 0;
const amino_1 = __webpack_require__(24822);
const crypto_1 = __webpack_require__(79562);
const encoding_1 = __webpack_require__(71555);
const signing_1 = __webpack_require__(24816);
/**
 * A wallet that holds a single secp256k1 keypair.
 *
 * If you want to work with BIP39 mnemonics and multiple accounts, use DirectSecp256k1HdWallet.
 */
class DirectSecp256k1Wallet {
    constructor(privkey, pubkey, prefix) {
        this.privkey = privkey;
        this.pubkey = pubkey;
        this.prefix = prefix;
    }
    /**
     * Creates a DirectSecp256k1Wallet from the given private key
     *
     * @param privkey The private key.
     * @param prefix The bech32 address prefix (human readable part). Defaults to "cosmos".
     */
    static async fromKey(privkey, prefix = "cosmos") {
        const uncompressed = (await crypto_1.Secp256k1.makeKeypair(privkey)).pubkey;
        return new DirectSecp256k1Wallet(privkey, crypto_1.Secp256k1.compressPubkey(uncompressed), prefix);
    }
    get address() {
        return (0, encoding_1.toBech32)(this.prefix, (0, amino_1.rawSecp256k1PubkeyToRawAddress)(this.pubkey));
    }
    async getAccounts() {
        return [
            {
                algo: "secp256k1",
                address: this.address,
                pubkey: this.pubkey,
            },
        ];
    }
    async signDirect(address, signDoc) {
        const signBytes = (0, signing_1.makeSignBytes)(signDoc);
        if (address !== this.address) {
            throw new Error(`Address ${address} not found in wallet`);
        }
        const hashedMessage = (0, crypto_1.sha256)(signBytes);
        const signature = await crypto_1.Secp256k1.createSignature(hashedMessage, this.privkey);
        const signatureBytes = new Uint8Array([...signature.r(32), ...signature.s(32)]);
        const stdSignature = (0, amino_1.encodeSecp256k1Signature)(this.pubkey, signatureBytes);
        return {
            signed: signDoc,
            signature: stdSignature,
        };
    }
}
exports.DirectSecp256k1Wallet = DirectSecp256k1Wallet;
//# sourceMappingURL=directsecp256k1wallet.js.map

/***/ }),

/***/ 89934:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
__webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = void 0;
// This type happens to be shared between Amino and Direct sign modes
var coins_1 = __webpack_require__(34166);
__webpack_unused_export__ = ({ enumerable: true, get: function () { return coins_1.parseCoins; } });
var decode_1 = __webpack_require__(4738);
__webpack_unused_export__ = ({ enumerable: true, get: function () { return decode_1.decodeTxRaw; } });
var directsecp256k1hdwallet_1 = __webpack_require__(63028);
__webpack_unused_export__ = ({ enumerable: true, get: function () { return directsecp256k1hdwallet_1.DirectSecp256k1HdWallet; } });
__webpack_unused_export__ = ({ enumerable: true, get: function () { return directsecp256k1hdwallet_1.extractKdfConfiguration; } });
var directsecp256k1wallet_1 = __webpack_require__(26591);
__webpack_unused_export__ = ({ enumerable: true, get: function () { return directsecp256k1wallet_1.DirectSecp256k1Wallet; } });
var paths_1 = __webpack_require__(86067);
__webpack_unused_export__ = ({ enumerable: true, get: function () { return paths_1.makeCosmoshubPath; } });
var pubkey_1 = __webpack_require__(92766);
__webpack_unused_export__ = ({ enumerable: true, get: function () { return pubkey_1.anyToSinglePubkey; } });
__webpack_unused_export__ = ({ enumerable: true, get: function () { return pubkey_1.decodePubkey; } });
__webpack_unused_export__ = ({ enumerable: true, get: function () { return pubkey_1.encodePubkey; } });
var registry_1 = __webpack_require__(66072);
__webpack_unused_export__ = ({ enumerable: true, get: function () { return registry_1.isPbjsGeneratedType; } });
__webpack_unused_export__ = ({ enumerable: true, get: function () { return registry_1.isTsProtoGeneratedType; } });
__webpack_unused_export__ = ({ enumerable: true, get: function () { return registry_1.isTxBodyEncodeObject; } });
__webpack_unused_export__ = ({ enumerable: true, get: function () { return registry_1.Registry; } });
var signer_1 = __webpack_require__(35927);
__webpack_unused_export__ = ({ enumerable: true, get: function () { return signer_1.isOfflineDirectSigner; } });
var signing_1 = __webpack_require__(24816);
__webpack_unused_export__ = ({ enumerable: true, get: function () { return signing_1.makeAuthInfoBytes; } });
__webpack_unused_export__ = ({ enumerable: true, get: function () { return signing_1.makeSignBytes; } });
__webpack_unused_export__ = ({ enumerable: true, get: function () { return signing_1.makeSignDoc; } });
var wallet_1 = __webpack_require__(63165);
__webpack_unused_export__ = ({ enumerable: true, get: function () { return wallet_1.executeKdf; } });
var amino_1 = __webpack_require__(24822);
__webpack_unused_export__ = ({ enumerable: true, get: function () { return amino_1.coin; } });
__webpack_unused_export__ = ({ enumerable: true, get: function () { return amino_1.coins; } });
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 86067:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.makeCosmoshubPath = void 0;
const crypto_1 = __webpack_require__(79562);
/**
 * The Cosmos Hub derivation path in the form `m/44'/118'/0'/0/a`
 * with 0-based account index `a`.
 */
function makeCosmoshubPath(a) {
    return [
        crypto_1.Slip10RawIndex.hardened(44),
        crypto_1.Slip10RawIndex.hardened(118),
        crypto_1.Slip10RawIndex.hardened(0),
        crypto_1.Slip10RawIndex.normal(0),
        crypto_1.Slip10RawIndex.normal(a),
    ];
}
exports.makeCosmoshubPath = makeCosmoshubPath;
//# sourceMappingURL=paths.js.map

/***/ }),

/***/ 92766:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.decodePubkey = exports.anyToSinglePubkey = exports.encodePubkey = void 0;
/* eslint-disable @typescript-eslint/naming-convention */
const amino_1 = __webpack_require__(24822);
const encoding_1 = __webpack_require__(71555);
const math_1 = __webpack_require__(62949);
const keys_1 = __webpack_require__(2029);
const keys_2 = __webpack_require__(68070);
const keys_3 = __webpack_require__(61599);
const any_1 = __webpack_require__(90007);
/**
 * Takes a pubkey in the Amino JSON object style (type/value wrapper)
 * and convertes it into a protobuf `Any`.
 *
 * This is the reverse operation to `decodePubkey`.
 */
function encodePubkey(pubkey) {
    if ((0, amino_1.isSecp256k1Pubkey)(pubkey)) {
        const pubkeyProto = keys_3.PubKey.fromPartial({
            key: (0, encoding_1.fromBase64)(pubkey.value),
        });
        return any_1.Any.fromPartial({
            typeUrl: "/cosmos.crypto.secp256k1.PubKey",
            value: Uint8Array.from(keys_3.PubKey.encode(pubkeyProto).finish()),
        });
    }
    else if ((0, amino_1.isEd25519Pubkey)(pubkey)) {
        const pubkeyProto = keys_1.PubKey.fromPartial({
            key: (0, encoding_1.fromBase64)(pubkey.value),
        });
        return any_1.Any.fromPartial({
            typeUrl: "/cosmos.crypto.ed25519.PubKey",
            value: Uint8Array.from(keys_1.PubKey.encode(pubkeyProto).finish()),
        });
    }
    else if ((0, amino_1.isMultisigThresholdPubkey)(pubkey)) {
        const pubkeyProto = keys_2.LegacyAminoPubKey.fromPartial({
            threshold: math_1.Uint53.fromString(pubkey.value.threshold).toNumber(),
            publicKeys: pubkey.value.pubkeys.map(encodePubkey),
        });
        return any_1.Any.fromPartial({
            typeUrl: "/cosmos.crypto.multisig.LegacyAminoPubKey",
            value: Uint8Array.from(keys_2.LegacyAminoPubKey.encode(pubkeyProto).finish()),
        });
    }
    else {
        throw new Error(`Pubkey type ${pubkey.type} not recognized`);
    }
}
exports.encodePubkey = encodePubkey;
/**
 * Decodes a single pubkey (i.e. not a multisig pubkey) from `Any` into
 * `SinglePubkey`.
 *
 * In most cases you probably want to use `decodePubkey`, but `anyToSinglePubkey`
 * might be preferred in CosmJS 0.29.x due to https://github.com/cosmos/cosmjs/issues/1289.
 */
function anyToSinglePubkey(pubkey) {
    switch (pubkey.typeUrl) {
        case "/cosmos.crypto.secp256k1.PubKey": {
            const { key } = keys_3.PubKey.decode(pubkey.value);
            return (0, amino_1.encodeSecp256k1Pubkey)(key);
        }
        case "/cosmos.crypto.ed25519.PubKey": {
            const { key } = keys_1.PubKey.decode(pubkey.value);
            return (0, amino_1.encodeEd25519Pubkey)(key);
        }
        default:
            throw new Error(`Pubkey type_url ${pubkey.typeUrl} not recognized as single public key type`);
    }
}
exports.anyToSinglePubkey = anyToSinglePubkey;
function decodePubkey(pubkey) {
    if (!pubkey || !pubkey.value) {
        return null;
    }
    switch (pubkey.typeUrl) {
        case "/cosmos.crypto.secp256k1.PubKey":
        case "/cosmos.crypto.ed25519.PubKey": {
            return anyToSinglePubkey(pubkey);
        }
        case "/cosmos.crypto.multisig.LegacyAminoPubKey": {
            const { threshold, publicKeys } = keys_2.LegacyAminoPubKey.decode(pubkey.value);
            const out = {
                type: "tendermint/PubKeyMultisigThreshold",
                value: {
                    threshold: threshold.toString(),
                    pubkeys: publicKeys.map(anyToSinglePubkey),
                },
            };
            return out;
        }
        default:
            throw new Error(`Pubkey type_url ${pubkey.typeUrl} not recognized`);
    }
}
exports.decodePubkey = decodePubkey;
//# sourceMappingURL=pubkey.js.map

/***/ }),

/***/ 66072:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/* provided dependency */ var Buffer = __webpack_require__(48764)["Buffer"];

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Registry = exports.isTxBodyEncodeObject = exports.isPbjsGeneratedType = exports.isTsProtoGeneratedType = void 0;
/* eslint-disable @typescript-eslint/naming-convention */
const tx_1 = __webpack_require__(67722);
const coin_1 = __webpack_require__(26119);
const tx_2 = __webpack_require__(94289);
const any_1 = __webpack_require__(90007);
function isTsProtoGeneratedType(type) {
    return typeof type.fromPartial === "function";
}
exports.isTsProtoGeneratedType = isTsProtoGeneratedType;
function isPbjsGeneratedType(type) {
    return !isTsProtoGeneratedType(type);
}
exports.isPbjsGeneratedType = isPbjsGeneratedType;
const defaultTypeUrls = {
    cosmosCoin: "/cosmos.base.v1beta1.Coin",
    cosmosMsgSend: "/cosmos.bank.v1beta1.MsgSend",
    cosmosTxBody: "/cosmos.tx.v1beta1.TxBody",
    googleAny: "/google.protobuf.Any",
};
function isTxBodyEncodeObject(encodeObject) {
    return encodeObject.typeUrl === "/cosmos.tx.v1beta1.TxBody";
}
exports.isTxBodyEncodeObject = isTxBodyEncodeObject;
class Registry {
    /**
     * Creates a new Registry for mapping protobuf type identifiers/type URLs to
     * actual implementations. Those implementations are typically generated with ts-proto
     * but we also support protobuf.js as a type generator.
     *
     * If there is no parameter given, a `new Registry()` adds the types `Coin` and `MsgSend`
     * for historic reasons. Those can be overriden by customTypes.
     *
     * There are currently two methods for adding new types:
     * 1. Passing types to the constructor.
     * 2. Using the `register()` method
     */
    constructor(customTypes) {
        const { cosmosCoin, cosmosMsgSend } = defaultTypeUrls;
        this.types = customTypes
            ? new Map([...customTypes])
            : new Map([
                [cosmosCoin, coin_1.Coin],
                [cosmosMsgSend, tx_1.MsgSend],
            ]);
    }
    register(typeUrl, type) {
        this.types.set(typeUrl, type);
    }
    /**
     * Looks up a type that was previously added to the registry.
     *
     * The generator information (ts-proto or pbjs) gets lost along the way.
     * If you need to work with the result type in TypeScript, you can use:
     *
     * ```
     * import { assert } from "@cosmjs/utils";
     *
     * const Coin = registry.lookupType("/cosmos.base.v1beta1.Coin");
     * assert(Coin); // Ensures not unset
     * assert(isTsProtoGeneratedType(Coin)); // Ensures this is the type we expect
     *
     * // Coin is typed TsProtoGeneratedType now.
     * ```
     */
    lookupType(typeUrl) {
        return this.types.get(typeUrl);
    }
    lookupTypeWithError(typeUrl) {
        const type = this.lookupType(typeUrl);
        if (!type) {
            throw new Error(`Unregistered type url: ${typeUrl}`);
        }
        return type;
    }
    /**
     * Takes a typeUrl/value pair and encodes the value to protobuf if
     * the given type was previously registered.
     *
     * If the value has to be wrapped in an Any, this needs to be done
     * manually after this call. Or use `encodeAsAny` instead.
     */
    encode(encodeObject) {
        const { value, typeUrl } = encodeObject;
        if (isTxBodyEncodeObject(encodeObject)) {
            return this.encodeTxBody(value);
        }
        const type = this.lookupTypeWithError(typeUrl);
        const instance = isTsProtoGeneratedType(type) ? type.fromPartial(value) : type.create(value);
        return type.encode(instance).finish();
    }
    /**
     * Takes a typeUrl/value pair and encodes the value to an Any if
     * the given type was previously registered.
     */
    encodeAsAny(encodeObject) {
        const binaryValue = this.encode(encodeObject);
        return any_1.Any.fromPartial({
            typeUrl: encodeObject.typeUrl,
            value: binaryValue,
        });
    }
    encodeTxBody(txBodyFields) {
        const wrappedMessages = txBodyFields.messages.map((message) => this.encodeAsAny(message));
        const txBody = tx_2.TxBody.fromPartial({
            ...txBodyFields,
            messages: wrappedMessages,
        });
        return tx_2.TxBody.encode(txBody).finish();
    }
    decode({ typeUrl, value }) {
        if (typeUrl === defaultTypeUrls.cosmosTxBody) {
            return this.decodeTxBody(value);
        }
        const type = this.lookupTypeWithError(typeUrl);
        const decoded = type.decode(value);
        Object.entries(decoded).forEach(([key, val]) => {
            if (typeof Buffer !== "undefined" && typeof Buffer.isBuffer !== "undefined" && Buffer.isBuffer(val)) {
                decoded[key] = Uint8Array.from(val);
            }
        });
        return decoded;
    }
    decodeTxBody(txBody) {
        const decodedTxBody = tx_2.TxBody.decode(txBody);
        return {
            ...decodedTxBody,
            messages: decodedTxBody.messages.map(({ typeUrl: typeUrl, value }) => {
                if (!typeUrl) {
                    throw new Error("Missing type_url in Any");
                }
                if (!value) {
                    throw new Error("Missing value in Any");
                }
                return this.decode({ typeUrl, value });
            }),
        };
    }
}
exports.Registry = Registry;
//# sourceMappingURL=registry.js.map

/***/ }),

/***/ 35927:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.isOfflineDirectSigner = void 0;
function isOfflineDirectSigner(signer) {
    return signer.signDirect !== undefined;
}
exports.isOfflineDirectSigner = isOfflineDirectSigner;
//# sourceMappingURL=signer.js.map

/***/ }),

/***/ 24816:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.makeSignBytes = exports.makeSignDoc = exports.makeAuthInfoBytes = void 0;
/* eslint-disable @typescript-eslint/naming-convention */
const utils_1 = __webpack_require__(85553);
const signing_1 = __webpack_require__(94600);
const tx_1 = __webpack_require__(94289);
const long_1 = __importDefault(__webpack_require__(71976));
/**
 * Create signer infos from the provided signers.
 *
 * This implementation does not support different signing modes for the different signers.
 */
function makeSignerInfos(signers, signMode) {
    return signers.map(({ pubkey, sequence }) => ({
        publicKey: pubkey,
        modeInfo: {
            single: { mode: signMode },
        },
        sequence: long_1.default.fromNumber(sequence),
    }));
}
/**
 * Creates and serializes an AuthInfo document.
 *
 * This implementation does not support different signing modes for the different signers.
 */
function makeAuthInfoBytes(signers, feeAmount, gasLimit, feeGranter, feePayer, signMode = signing_1.SignMode.SIGN_MODE_DIRECT) {
    // Required arguments 4 and 5 were added in CosmJS 0.29. Use runtime checks to help our non-TS users.
    (0, utils_1.assert)(feeGranter === undefined || typeof feeGranter === "string", "feeGranter must be undefined or string");
    (0, utils_1.assert)(feePayer === undefined || typeof feePayer === "string", "feePayer must be undefined or string");
    const authInfo = {
        signerInfos: makeSignerInfos(signers, signMode),
        fee: {
            amount: [...feeAmount],
            gasLimit: long_1.default.fromNumber(gasLimit),
            granter: feeGranter,
            payer: feePayer,
        },
    };
    return tx_1.AuthInfo.encode(tx_1.AuthInfo.fromPartial(authInfo)).finish();
}
exports.makeAuthInfoBytes = makeAuthInfoBytes;
function makeSignDoc(bodyBytes, authInfoBytes, chainId, accountNumber) {
    return {
        bodyBytes: bodyBytes,
        authInfoBytes: authInfoBytes,
        chainId: chainId,
        accountNumber: long_1.default.fromNumber(accountNumber),
    };
}
exports.makeSignDoc = makeSignDoc;
function makeSignBytes({ accountNumber, authInfoBytes, bodyBytes, chainId }) {
    const signDoc = tx_1.SignDoc.fromPartial({
        accountNumber: accountNumber,
        authInfoBytes: authInfoBytes,
        bodyBytes: bodyBytes,
        chainId: chainId,
    });
    return tx_1.SignDoc.encode(signDoc).finish();
}
exports.makeSignBytes = makeSignBytes;
//# sourceMappingURL=signing.js.map

/***/ }),

/***/ 63165:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.decrypt = exports.encrypt = exports.supportedAlgorithms = exports.executeKdf = exports.cosmjsSalt = void 0;
const crypto_1 = __webpack_require__(79562);
const encoding_1 = __webpack_require__(71555);
/**
 * A fixed salt is chosen to archive a deterministic password to key derivation.
 * This reduces the scope of a potential rainbow attack to all CosmJS users.
 * Must be 16 bytes due to implementation limitations.
 */
exports.cosmjsSalt = (0, encoding_1.toAscii)("The CosmJS salt.");
async function executeKdf(password, configuration) {
    switch (configuration.algorithm) {
        case "argon2id": {
            const options = configuration.params;
            if (!(0, crypto_1.isArgon2idOptions)(options))
                throw new Error("Invalid format of argon2id params");
            return crypto_1.Argon2id.execute(password, exports.cosmjsSalt, options);
        }
        default:
            throw new Error("Unsupported KDF algorithm");
    }
}
exports.executeKdf = executeKdf;
exports.supportedAlgorithms = {
    xchacha20poly1305Ietf: "xchacha20poly1305-ietf",
};
async function encrypt(plaintext, encryptionKey, config) {
    switch (config.algorithm) {
        case exports.supportedAlgorithms.xchacha20poly1305Ietf: {
            const nonce = crypto_1.Random.getBytes(crypto_1.xchacha20NonceLength);
            // Prepend fixed-length nonce to ciphertext as suggested in the example from https://github.com/jedisct1/libsodium.js#api
            return new Uint8Array([
                ...nonce,
                ...(await crypto_1.Xchacha20poly1305Ietf.encrypt(plaintext, encryptionKey, nonce)),
            ]);
        }
        default:
            throw new Error(`Unsupported encryption algorithm: '${config.algorithm}'`);
    }
}
exports.encrypt = encrypt;
async function decrypt(ciphertext, encryptionKey, config) {
    switch (config.algorithm) {
        case exports.supportedAlgorithms.xchacha20poly1305Ietf: {
            const nonce = ciphertext.slice(0, crypto_1.xchacha20NonceLength);
            return crypto_1.Xchacha20poly1305Ietf.decrypt(ciphertext.slice(crypto_1.xchacha20NonceLength), encryptionKey, nonce);
        }
        default:
            throw new Error(`Unsupported encryption algorithm: '${config.algorithm}'`);
    }
}
exports.decrypt = decrypt;
//# sourceMappingURL=wallet.js.map

/***/ }),

/***/ 83692:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

// See https://github.com/tendermint/tendermint/blob/f2ada0a604b4c0763bda2f64fac53d506d3beca7/docs/spec/blockchain/encoding.md#public-key-cryptography
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.pubkeyToAddress = exports.pubkeyToRawAddress = exports.rawSecp256k1PubkeyToRawAddress = exports.rawEd25519PubkeyToRawAddress = void 0;
const crypto_1 = __webpack_require__(79562);
const encoding_1 = __webpack_require__(71555);
const encoding_2 = __webpack_require__(99053);
const pubkeys_1 = __webpack_require__(9673);
function rawEd25519PubkeyToRawAddress(pubkeyData) {
    if (pubkeyData.length !== 32) {
        throw new Error(`Invalid Ed25519 pubkey length: ${pubkeyData.length}`);
    }
    return (0, crypto_1.sha256)(pubkeyData).slice(0, 20);
}
exports.rawEd25519PubkeyToRawAddress = rawEd25519PubkeyToRawAddress;
function rawSecp256k1PubkeyToRawAddress(pubkeyData) {
    if (pubkeyData.length !== 33) {
        throw new Error(`Invalid Secp256k1 pubkey length (compressed): ${pubkeyData.length}`);
    }
    return (0, crypto_1.ripemd160)((0, crypto_1.sha256)(pubkeyData));
}
exports.rawSecp256k1PubkeyToRawAddress = rawSecp256k1PubkeyToRawAddress;
// For secp256k1 this assumes we already have a compressed pubkey.
function pubkeyToRawAddress(pubkey) {
    if ((0, pubkeys_1.isSecp256k1Pubkey)(pubkey)) {
        const pubkeyData = (0, encoding_1.fromBase64)(pubkey.value);
        return rawSecp256k1PubkeyToRawAddress(pubkeyData);
    }
    else if ((0, pubkeys_1.isEd25519Pubkey)(pubkey)) {
        const pubkeyData = (0, encoding_1.fromBase64)(pubkey.value);
        return rawEd25519PubkeyToRawAddress(pubkeyData);
    }
    else if ((0, pubkeys_1.isMultisigThresholdPubkey)(pubkey)) {
        // https://github.com/tendermint/tendermint/blob/38b401657e4ad7a7eeb3c30a3cbf512037df3740/crypto/multisig/threshold_pubkey.go#L71-L74
        const pubkeyData = (0, encoding_2.encodeAminoPubkey)(pubkey);
        return (0, crypto_1.sha256)(pubkeyData).slice(0, 20);
    }
    else {
        throw new Error("Unsupported public key type");
    }
}
exports.pubkeyToRawAddress = pubkeyToRawAddress;
function pubkeyToAddress(pubkey, prefix) {
    return (0, encoding_1.toBech32)(prefix, pubkeyToRawAddress(pubkey));
}
exports.pubkeyToAddress = pubkeyToAddress;
//# sourceMappingURL=addresses.js.map

/***/ }),

/***/ 81745:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.addCoins = exports.parseCoins = exports.coins = exports.coin = void 0;
const math_1 = __webpack_require__(62949);
/**
 * Creates a coin.
 *
 * If your values do not exceed the safe integer range of JS numbers (53 bit),
 * you can use the number type here. This is the case for all typical Cosmos SDK
 * chains that use the default 6 decimals.
 *
 * In case you need to supportr larger values, use unsigned integer strings instead.
 */
function coin(amount, denom) {
    let outAmount;
    if (typeof amount === "number") {
        try {
            outAmount = new math_1.Uint53(amount).toString();
        }
        catch (_err) {
            throw new Error("Given amount is not a safe integer. Consider using a string instead to overcome the limitations of JS numbers.");
        }
    }
    else {
        if (!amount.match(/^[0-9]+$/)) {
            throw new Error("Invalid unsigned integer string format");
        }
        outAmount = amount.replace(/^0*/, "") || "0";
    }
    return {
        amount: outAmount,
        denom: denom,
    };
}
exports.coin = coin;
/**
 * Creates a list of coins with one element.
 */
function coins(amount, denom) {
    return [coin(amount, denom)];
}
exports.coins = coins;
/**
 * Takes a coins list like "819966000ucosm,700000000ustake" and parses it.
 *
 * A Stargate-ready variant of this function is available via:
 *
 * ```
 * import { parseCoins } from "@cosmjs/proto-signing";
 * // or
 * import { parseCoins } from "@cosmjs/stargate";
 * ```
 */
function parseCoins(input) {
    return input
        .replace(/\s/g, "")
        .split(",")
        .filter(Boolean)
        .map((part) => {
        const match = part.match(/^([0-9]+)([a-zA-Z]+)/);
        if (!match)
            throw new Error("Got an invalid coin string");
        return {
            amount: match[1].replace(/^0+/, "") || "0",
            denom: match[2],
        };
    });
}
exports.parseCoins = parseCoins;
/**
 * Function to sum up coins with type Coin
 */
function addCoins(lhs, rhs) {
    if (lhs.denom !== rhs.denom)
        throw new Error("Trying to add two coins with different denoms");
    return {
        amount: math_1.Decimal.fromAtomics(lhs.amount, 0).plus(math_1.Decimal.fromAtomics(rhs.amount, 0)).atomics,
        denom: lhs.denom,
    };
}
exports.addCoins = addCoins;
//# sourceMappingURL=coins.js.map

/***/ }),

/***/ 99053:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.encodeBech32Pubkey = exports.encodeAminoPubkey = exports.decodeBech32Pubkey = exports.decodeAminoPubkey = exports.encodeEd25519Pubkey = exports.encodeSecp256k1Pubkey = void 0;
const encoding_1 = __webpack_require__(71555);
const math_1 = __webpack_require__(62949);
const utils_1 = __webpack_require__(85553);
const pubkeys_1 = __webpack_require__(9673);
/**
 * Takes a Secp256k1 public key as raw bytes and returns the Amino JSON
 * representation of it (the type/value wrapper object).
 */
function encodeSecp256k1Pubkey(pubkey) {
    if (pubkey.length !== 33 || (pubkey[0] !== 0x02 && pubkey[0] !== 0x03)) {
        throw new Error("Public key must be compressed secp256k1, i.e. 33 bytes starting with 0x02 or 0x03");
    }
    return {
        type: pubkeys_1.pubkeyType.secp256k1,
        value: (0, encoding_1.toBase64)(pubkey),
    };
}
exports.encodeSecp256k1Pubkey = encodeSecp256k1Pubkey;
/**
 * Takes an Edd25519 public key as raw bytes and returns the Amino JSON
 * representation of it (the type/value wrapper object).
 */
function encodeEd25519Pubkey(pubkey) {
    if (pubkey.length !== 32) {
        throw new Error("Ed25519 public key must be 32 bytes long");
    }
    return {
        type: pubkeys_1.pubkeyType.ed25519,
        value: (0, encoding_1.toBase64)(pubkey),
    };
}
exports.encodeEd25519Pubkey = encodeEd25519Pubkey;
// As discussed in https://github.com/binance-chain/javascript-sdk/issues/163
// Prefixes listed here: https://github.com/tendermint/tendermint/blob/d419fffe18531317c28c29a292ad7d253f6cafdf/docs/spec/blockchain/encoding.md#public-key-cryptography
// Last bytes is varint-encoded length prefix
const pubkeyAminoPrefixSecp256k1 = (0, encoding_1.fromHex)("eb5ae987" + "21" /* fixed length */);
const pubkeyAminoPrefixEd25519 = (0, encoding_1.fromHex)("1624de64" + "20" /* fixed length */);
const pubkeyAminoPrefixSr25519 = (0, encoding_1.fromHex)("0dfb1005" + "20" /* fixed length */);
/** See https://github.com/tendermint/tendermint/commit/38b401657e4ad7a7eeb3c30a3cbf512037df3740 */
const pubkeyAminoPrefixMultisigThreshold = (0, encoding_1.fromHex)("22c1f7e2" /* variable length not included */);
/**
 * Decodes a pubkey in the Amino binary format to a type/value object.
 */
function decodeAminoPubkey(data) {
    if ((0, utils_1.arrayContentStartsWith)(data, pubkeyAminoPrefixSecp256k1)) {
        const rest = data.slice(pubkeyAminoPrefixSecp256k1.length);
        if (rest.length !== 33) {
            throw new Error("Invalid rest data length. Expected 33 bytes (compressed secp256k1 pubkey).");
        }
        return {
            type: pubkeys_1.pubkeyType.secp256k1,
            value: (0, encoding_1.toBase64)(rest),
        };
    }
    else if ((0, utils_1.arrayContentStartsWith)(data, pubkeyAminoPrefixEd25519)) {
        const rest = data.slice(pubkeyAminoPrefixEd25519.length);
        if (rest.length !== 32) {
            throw new Error("Invalid rest data length. Expected 32 bytes (Ed25519 pubkey).");
        }
        return {
            type: pubkeys_1.pubkeyType.ed25519,
            value: (0, encoding_1.toBase64)(rest),
        };
    }
    else if ((0, utils_1.arrayContentStartsWith)(data, pubkeyAminoPrefixSr25519)) {
        const rest = data.slice(pubkeyAminoPrefixSr25519.length);
        if (rest.length !== 32) {
            throw new Error("Invalid rest data length. Expected 32 bytes (Sr25519 pubkey).");
        }
        return {
            type: pubkeys_1.pubkeyType.sr25519,
            value: (0, encoding_1.toBase64)(rest),
        };
    }
    else if ((0, utils_1.arrayContentStartsWith)(data, pubkeyAminoPrefixMultisigThreshold)) {
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        return decodeMultisigPubkey(data);
    }
    else {
        throw new Error("Unsupported public key type. Amino data starts with: " + (0, encoding_1.toHex)(data.slice(0, 5)));
    }
}
exports.decodeAminoPubkey = decodeAminoPubkey;
/**
 * Decodes a bech32 pubkey to Amino binary, which is then decoded to a type/value object.
 * The bech32 prefix is ignored and discareded.
 *
 * @param bechEncoded the bech32 encoded pubkey
 */
function decodeBech32Pubkey(bechEncoded) {
    const { data } = (0, encoding_1.fromBech32)(bechEncoded);
    return decodeAminoPubkey(data);
}
exports.decodeBech32Pubkey = decodeBech32Pubkey;
/**
 * Uvarint decoder for Amino.
 * @see https://github.com/tendermint/go-amino/blob/8e779b71f40d175/decoder.go#L64-76
 * @returns varint as number, and bytes count occupied by varaint
 */
function decodeUvarint(reader) {
    if (reader.length < 1) {
        throw new Error("Can't decode varint. EOF");
    }
    if (reader[0] > 127) {
        throw new Error("Decoding numbers > 127 is not supported here. Please tell those lazy CosmJS maintainers to port the binary.Varint implementation from the Go standard library and write some tests.");
    }
    return [reader[0], 1];
}
/**
 * Decodes a multisig pubkey to type object.
 * Pubkey structure [ prefix + const + threshold + loop:(const + pubkeyLength + pubkey            ) ]
 *                  [   4b   + 1b    +  varint   + loop:(1b    +    varint    + pubkeyLength bytes) ]
 * @param data encoded pubkey
 */
function decodeMultisigPubkey(data) {
    const reader = Array.from(data);
    // remove multisig amino prefix;
    const prefixFromReader = reader.splice(0, pubkeyAminoPrefixMultisigThreshold.length);
    if (!(0, utils_1.arrayContentStartsWith)(prefixFromReader, pubkeyAminoPrefixMultisigThreshold)) {
        throw new Error("Invalid multisig prefix.");
    }
    // remove 0x08 threshold prefix;
    if (reader.shift() != 0x08) {
        throw new Error("Invalid multisig data. Expecting 0x08 prefix before threshold.");
    }
    // read threshold
    const [threshold, thresholdBytesLength] = decodeUvarint(reader);
    reader.splice(0, thresholdBytesLength);
    // read participants pubkeys
    const pubkeys = [];
    while (reader.length > 0) {
        // remove 0x12 threshold prefix;
        if (reader.shift() != 0x12) {
            throw new Error("Invalid multisig data. Expecting 0x12 prefix before participant pubkey length.");
        }
        // read pubkey length
        const [pubkeyLength, pubkeyLengthBytesSize] = decodeUvarint(reader);
        reader.splice(0, pubkeyLengthBytesSize);
        // verify that we can read pubkey
        if (reader.length < pubkeyLength) {
            throw new Error("Invalid multisig data length.");
        }
        // read and decode participant pubkey
        const encodedPubkey = reader.splice(0, pubkeyLength);
        const pubkey = decodeAminoPubkey(Uint8Array.from(encodedPubkey));
        pubkeys.push(pubkey);
    }
    return {
        type: pubkeys_1.pubkeyType.multisigThreshold,
        value: {
            threshold: threshold.toString(),
            pubkeys: pubkeys,
        },
    };
}
/**
 * Uvarint encoder for Amino. This is the same encoding as `binary.PutUvarint` from the Go
 * standard library.
 *
 * @see https://github.com/tendermint/go-amino/blob/8e779b71f40d175/encoder.go#L77-L85
 */
function encodeUvarint(value) {
    const checked = math_1.Uint53.fromString(value.toString()).toNumber();
    if (checked > 127) {
        throw new Error("Encoding numbers > 127 is not supported here. Please tell those lazy CosmJS maintainers to port the binary.PutUvarint implementation from the Go standard library and write some tests.");
    }
    return [checked];
}
/**
 * Encodes a public key to binary Amino.
 */
function encodeAminoPubkey(pubkey) {
    if ((0, pubkeys_1.isMultisigThresholdPubkey)(pubkey)) {
        const out = Array.from(pubkeyAminoPrefixMultisigThreshold);
        out.push(0x08); // TODO: What is this?
        out.push(...encodeUvarint(pubkey.value.threshold));
        for (const pubkeyData of pubkey.value.pubkeys.map((p) => encodeAminoPubkey(p))) {
            out.push(0x12); // TODO: What is this?
            out.push(...encodeUvarint(pubkeyData.length));
            out.push(...pubkeyData);
        }
        return new Uint8Array(out);
    }
    else if ((0, pubkeys_1.isEd25519Pubkey)(pubkey)) {
        return new Uint8Array([...pubkeyAminoPrefixEd25519, ...(0, encoding_1.fromBase64)(pubkey.value)]);
    }
    else if ((0, pubkeys_1.isSecp256k1Pubkey)(pubkey)) {
        return new Uint8Array([...pubkeyAminoPrefixSecp256k1, ...(0, encoding_1.fromBase64)(pubkey.value)]);
    }
    else {
        throw new Error("Unsupported pubkey type");
    }
}
exports.encodeAminoPubkey = encodeAminoPubkey;
/**
 * Encodes a public key to binary Amino and then to bech32.
 *
 * @param pubkey the public key to encode
 * @param prefix the bech32 prefix (human readable part)
 */
function encodeBech32Pubkey(pubkey, prefix) {
    return (0, encoding_1.toBech32)(prefix, encodeAminoPubkey(pubkey));
}
exports.encodeBech32Pubkey = encodeBech32Pubkey;
//# sourceMappingURL=encoding.js.map

/***/ }),

/***/ 24822:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.executeKdf = exports.makeStdTx = exports.isStdTx = exports.serializeSignDoc = exports.makeSignDoc = exports.encodeSecp256k1Signature = exports.decodeSignature = exports.Secp256k1Wallet = exports.Secp256k1HdWallet = exports.extractKdfConfiguration = exports.pubkeyType = exports.isSinglePubkey = exports.isSecp256k1Pubkey = exports.isMultisigThresholdPubkey = exports.isEd25519Pubkey = exports.makeCosmoshubPath = exports.createMultisigThresholdPubkey = exports.encodeSecp256k1Pubkey = exports.encodeEd25519Pubkey = exports.encodeBech32Pubkey = exports.encodeAminoPubkey = exports.decodeBech32Pubkey = exports.decodeAminoPubkey = exports.parseCoins = exports.coins = exports.coin = exports.addCoins = exports.rawSecp256k1PubkeyToRawAddress = exports.rawEd25519PubkeyToRawAddress = exports.pubkeyToRawAddress = exports.pubkeyToAddress = void 0;
var addresses_1 = __webpack_require__(83692);
Object.defineProperty(exports, "pubkeyToAddress", ({ enumerable: true, get: function () { return addresses_1.pubkeyToAddress; } }));
Object.defineProperty(exports, "pubkeyToRawAddress", ({ enumerable: true, get: function () { return addresses_1.pubkeyToRawAddress; } }));
Object.defineProperty(exports, "rawEd25519PubkeyToRawAddress", ({ enumerable: true, get: function () { return addresses_1.rawEd25519PubkeyToRawAddress; } }));
Object.defineProperty(exports, "rawSecp256k1PubkeyToRawAddress", ({ enumerable: true, get: function () { return addresses_1.rawSecp256k1PubkeyToRawAddress; } }));
var coins_1 = __webpack_require__(81745);
Object.defineProperty(exports, "addCoins", ({ enumerable: true, get: function () { return coins_1.addCoins; } }));
Object.defineProperty(exports, "coin", ({ enumerable: true, get: function () { return coins_1.coin; } }));
Object.defineProperty(exports, "coins", ({ enumerable: true, get: function () { return coins_1.coins; } }));
Object.defineProperty(exports, "parseCoins", ({ enumerable: true, get: function () { return coins_1.parseCoins; } }));
var encoding_1 = __webpack_require__(99053);
Object.defineProperty(exports, "decodeAminoPubkey", ({ enumerable: true, get: function () { return encoding_1.decodeAminoPubkey; } }));
Object.defineProperty(exports, "decodeBech32Pubkey", ({ enumerable: true, get: function () { return encoding_1.decodeBech32Pubkey; } }));
Object.defineProperty(exports, "encodeAminoPubkey", ({ enumerable: true, get: function () { return encoding_1.encodeAminoPubkey; } }));
Object.defineProperty(exports, "encodeBech32Pubkey", ({ enumerable: true, get: function () { return encoding_1.encodeBech32Pubkey; } }));
Object.defineProperty(exports, "encodeEd25519Pubkey", ({ enumerable: true, get: function () { return encoding_1.encodeEd25519Pubkey; } }));
Object.defineProperty(exports, "encodeSecp256k1Pubkey", ({ enumerable: true, get: function () { return encoding_1.encodeSecp256k1Pubkey; } }));
var multisig_1 = __webpack_require__(32414);
Object.defineProperty(exports, "createMultisigThresholdPubkey", ({ enumerable: true, get: function () { return multisig_1.createMultisigThresholdPubkey; } }));
var paths_1 = __webpack_require__(96292);
Object.defineProperty(exports, "makeCosmoshubPath", ({ enumerable: true, get: function () { return paths_1.makeCosmoshubPath; } }));
var pubkeys_1 = __webpack_require__(9673);
Object.defineProperty(exports, "isEd25519Pubkey", ({ enumerable: true, get: function () { return pubkeys_1.isEd25519Pubkey; } }));
Object.defineProperty(exports, "isMultisigThresholdPubkey", ({ enumerable: true, get: function () { return pubkeys_1.isMultisigThresholdPubkey; } }));
Object.defineProperty(exports, "isSecp256k1Pubkey", ({ enumerable: true, get: function () { return pubkeys_1.isSecp256k1Pubkey; } }));
Object.defineProperty(exports, "isSinglePubkey", ({ enumerable: true, get: function () { return pubkeys_1.isSinglePubkey; } }));
Object.defineProperty(exports, "pubkeyType", ({ enumerable: true, get: function () { return pubkeys_1.pubkeyType; } }));
var secp256k1hdwallet_1 = __webpack_require__(40489);
Object.defineProperty(exports, "extractKdfConfiguration", ({ enumerable: true, get: function () { return secp256k1hdwallet_1.extractKdfConfiguration; } }));
Object.defineProperty(exports, "Secp256k1HdWallet", ({ enumerable: true, get: function () { return secp256k1hdwallet_1.Secp256k1HdWallet; } }));
var secp256k1wallet_1 = __webpack_require__(17759);
Object.defineProperty(exports, "Secp256k1Wallet", ({ enumerable: true, get: function () { return secp256k1wallet_1.Secp256k1Wallet; } }));
var signature_1 = __webpack_require__(62090);
Object.defineProperty(exports, "decodeSignature", ({ enumerable: true, get: function () { return signature_1.decodeSignature; } }));
Object.defineProperty(exports, "encodeSecp256k1Signature", ({ enumerable: true, get: function () { return signature_1.encodeSecp256k1Signature; } }));
var signdoc_1 = __webpack_require__(66167);
Object.defineProperty(exports, "makeSignDoc", ({ enumerable: true, get: function () { return signdoc_1.makeSignDoc; } }));
Object.defineProperty(exports, "serializeSignDoc", ({ enumerable: true, get: function () { return signdoc_1.serializeSignDoc; } }));
var stdtx_1 = __webpack_require__(21887);
Object.defineProperty(exports, "isStdTx", ({ enumerable: true, get: function () { return stdtx_1.isStdTx; } }));
Object.defineProperty(exports, "makeStdTx", ({ enumerable: true, get: function () { return stdtx_1.makeStdTx; } }));
var wallet_1 = __webpack_require__(40816);
Object.defineProperty(exports, "executeKdf", ({ enumerable: true, get: function () { return wallet_1.executeKdf; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 32414:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.createMultisigThresholdPubkey = exports.compareArrays = void 0;
const encoding_1 = __webpack_require__(71555);
const math_1 = __webpack_require__(62949);
const addresses_1 = __webpack_require__(83692);
/**
 * Compare arrays lexicographically.
 *
 * Returns value < 0 if `a < b`.
 * Returns value > 0 if `a > b`.
 * Returns 0 if `a === b`.
 */
function compareArrays(a, b) {
    const aHex = (0, encoding_1.toHex)(a);
    const bHex = (0, encoding_1.toHex)(b);
    return aHex === bHex ? 0 : aHex < bHex ? -1 : 1;
}
exports.compareArrays = compareArrays;
function createMultisigThresholdPubkey(pubkeys, threshold, nosort = false) {
    const uintThreshold = new math_1.Uint53(threshold);
    if (uintThreshold.toNumber() > pubkeys.length) {
        throw new Error(`Threshold k = ${uintThreshold.toNumber()} exceeds number of keys n = ${pubkeys.length}`);
    }
    const outPubkeys = nosort
        ? pubkeys
        : Array.from(pubkeys).sort((lhs, rhs) => {
            // https://github.com/cosmos/cosmos-sdk/blob/v0.42.2/client/keys/add.go#L172-L174
            const addressLhs = (0, addresses_1.pubkeyToRawAddress)(lhs);
            const addressRhs = (0, addresses_1.pubkeyToRawAddress)(rhs);
            return compareArrays(addressLhs, addressRhs);
        });
    return {
        type: "tendermint/PubKeyMultisigThreshold",
        value: {
            threshold: uintThreshold.toString(),
            pubkeys: outPubkeys,
        },
    };
}
exports.createMultisigThresholdPubkey = createMultisigThresholdPubkey;
//# sourceMappingURL=multisig.js.map

/***/ }),

/***/ 96292:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.makeCosmoshubPath = void 0;
const crypto_1 = __webpack_require__(79562);
/**
 * The Cosmos Hub derivation path in the form `m/44'/118'/0'/0/a`
 * with 0-based account index `a`.
 */
function makeCosmoshubPath(a) {
    return [
        crypto_1.Slip10RawIndex.hardened(44),
        crypto_1.Slip10RawIndex.hardened(118),
        crypto_1.Slip10RawIndex.hardened(0),
        crypto_1.Slip10RawIndex.normal(0),
        crypto_1.Slip10RawIndex.normal(a),
    ];
}
exports.makeCosmoshubPath = makeCosmoshubPath;
//# sourceMappingURL=paths.js.map

/***/ }),

/***/ 9673:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.isMultisigThresholdPubkey = exports.isSinglePubkey = exports.pubkeyType = exports.isSecp256k1Pubkey = exports.isEd25519Pubkey = void 0;
function isEd25519Pubkey(pubkey) {
    return pubkey.type === "tendermint/PubKeyEd25519";
}
exports.isEd25519Pubkey = isEd25519Pubkey;
function isSecp256k1Pubkey(pubkey) {
    return pubkey.type === "tendermint/PubKeySecp256k1";
}
exports.isSecp256k1Pubkey = isSecp256k1Pubkey;
exports.pubkeyType = {
    /** @see https://github.com/tendermint/tendermint/blob/v0.33.0/crypto/ed25519/ed25519.go#L22 */
    secp256k1: "tendermint/PubKeySecp256k1",
    /** @see https://github.com/tendermint/tendermint/blob/v0.33.0/crypto/secp256k1/secp256k1.go#L23 */
    ed25519: "tendermint/PubKeyEd25519",
    /** @see https://github.com/tendermint/tendermint/blob/v0.33.0/crypto/sr25519/codec.go#L12 */
    sr25519: "tendermint/PubKeySr25519",
    multisigThreshold: "tendermint/PubKeyMultisigThreshold",
};
function isSinglePubkey(pubkey) {
    const singPubkeyTypes = [exports.pubkeyType.ed25519, exports.pubkeyType.secp256k1, exports.pubkeyType.sr25519];
    return singPubkeyTypes.includes(pubkey.type);
}
exports.isSinglePubkey = isSinglePubkey;
function isMultisigThresholdPubkey(pubkey) {
    return pubkey.type === "tendermint/PubKeyMultisigThreshold";
}
exports.isMultisigThresholdPubkey = isMultisigThresholdPubkey;
//# sourceMappingURL=pubkeys.js.map

/***/ }),

/***/ 40489:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Secp256k1HdWallet = exports.extractKdfConfiguration = void 0;
const crypto_1 = __webpack_require__(79562);
const encoding_1 = __webpack_require__(71555);
const utils_1 = __webpack_require__(85553);
const addresses_1 = __webpack_require__(83692);
const paths_1 = __webpack_require__(96292);
const signature_1 = __webpack_require__(62090);
const signdoc_1 = __webpack_require__(66167);
const wallet_1 = __webpack_require__(40816);
const serializationTypeV1 = "secp256k1wallet-v1";
/**
 * A KDF configuration that is not very strong but can be used on the main thread.
 * It takes about 1 second in Node.js 16.0.0 and should have similar runtimes in other modern Wasm hosts.
 */
const basicPasswordHashingOptions = {
    algorithm: "argon2id",
    params: {
        outputLength: 32,
        opsLimit: 24,
        memLimitKib: 12 * 1024,
    },
};
function isDerivationJson(thing) {
    if (!(0, utils_1.isNonNullObject)(thing))
        return false;
    if (typeof thing.hdPath !== "string")
        return false;
    if (typeof thing.prefix !== "string")
        return false;
    return true;
}
function extractKdfConfigurationV1(doc) {
    return doc.kdf;
}
function extractKdfConfiguration(serialization) {
    const root = JSON.parse(serialization);
    if (!(0, utils_1.isNonNullObject)(root))
        throw new Error("Root document is not an object.");
    switch (root.type) {
        case serializationTypeV1:
            return extractKdfConfigurationV1(root);
        default:
            throw new Error("Unsupported serialization type");
    }
}
exports.extractKdfConfiguration = extractKdfConfiguration;
const defaultOptions = {
    bip39Password: "",
    hdPaths: [(0, paths_1.makeCosmoshubPath)(0)],
    prefix: "cosmos",
};
class Secp256k1HdWallet {
    constructor(mnemonic, options) {
        var _a, _b;
        const hdPaths = (_a = options.hdPaths) !== null && _a !== void 0 ? _a : defaultOptions.hdPaths;
        const prefix = (_b = options.prefix) !== null && _b !== void 0 ? _b : defaultOptions.prefix;
        this.secret = mnemonic;
        this.seed = options.seed;
        this.accounts = hdPaths.map((hdPath) => ({
            hdPath: hdPath,
            prefix,
        }));
    }
    /**
     * Restores a wallet from the given BIP39 mnemonic.
     *
     * @param mnemonic Any valid English mnemonic.
     * @param options An optional `Secp256k1HdWalletOptions` object optionally containing a bip39Password, hdPaths, and prefix.
     */
    static async fromMnemonic(mnemonic, options = {}) {
        const mnemonicChecked = new crypto_1.EnglishMnemonic(mnemonic);
        const seed = await crypto_1.Bip39.mnemonicToSeed(mnemonicChecked, options.bip39Password);
        return new Secp256k1HdWallet(mnemonicChecked, {
            ...options,
            seed: seed,
        });
    }
    /**
     * Generates a new wallet with a BIP39 mnemonic of the given length.
     *
     * @param length The number of words in the mnemonic (12, 15, 18, 21 or 24).
     * @param options An optional `Secp256k1HdWalletOptions` object optionally containing a bip39Password, hdPaths, and prefix.
     */
    static async generate(length = 12, options = {}) {
        const entropyLength = 4 * Math.floor((11 * length) / 33);
        const entropy = crypto_1.Random.getBytes(entropyLength);
        const mnemonic = crypto_1.Bip39.encode(entropy);
        return Secp256k1HdWallet.fromMnemonic(mnemonic.toString(), options);
    }
    /**
     * Restores a wallet from an encrypted serialization.
     *
     * @param password The user provided password used to generate an encryption key via a KDF.
     *                 This is not normalized internally (see "Unicode normalization" to learn more).
     */
    static async deserialize(serialization, password) {
        const root = JSON.parse(serialization);
        if (!(0, utils_1.isNonNullObject)(root))
            throw new Error("Root document is not an object.");
        switch (root.type) {
            case serializationTypeV1:
                return Secp256k1HdWallet.deserializeTypeV1(serialization, password);
            default:
                throw new Error("Unsupported serialization type");
        }
    }
    /**
     * Restores a wallet from an encrypted serialization.
     *
     * This is an advanced alternative to calling `deserialize(serialization, password)` directly, which allows
     * you to offload the KDF execution to a non-UI thread (e.g. in a WebWorker).
     *
     * The caller is responsible for ensuring the key was derived with the given KDF configuration. This can be
     * done using `extractKdfConfiguration(serialization)` and `executeKdf(password, kdfConfiguration)` from this package.
     */
    static async deserializeWithEncryptionKey(serialization, encryptionKey) {
        const root = JSON.parse(serialization);
        if (!(0, utils_1.isNonNullObject)(root))
            throw new Error("Root document is not an object.");
        const untypedRoot = root;
        switch (untypedRoot.type) {
            case serializationTypeV1: {
                const decryptedBytes = await (0, wallet_1.decrypt)((0, encoding_1.fromBase64)(untypedRoot.data), encryptionKey, untypedRoot.encryption);
                const decryptedDocument = JSON.parse((0, encoding_1.fromUtf8)(decryptedBytes));
                const { mnemonic, accounts } = decryptedDocument;
                (0, utils_1.assert)(typeof mnemonic === "string");
                if (!Array.isArray(accounts))
                    throw new Error("Property 'accounts' is not an array");
                if (!accounts.every((account) => isDerivationJson(account))) {
                    throw new Error("Account is not in the correct format.");
                }
                const firstPrefix = accounts[0].prefix;
                if (!accounts.every(({ prefix }) => prefix === firstPrefix)) {
                    throw new Error("Accounts do not all have the same prefix");
                }
                const hdPaths = accounts.map(({ hdPath }) => (0, crypto_1.stringToPath)(hdPath));
                return Secp256k1HdWallet.fromMnemonic(mnemonic, {
                    hdPaths: hdPaths,
                    prefix: firstPrefix,
                });
            }
            default:
                throw new Error("Unsupported serialization type");
        }
    }
    static async deserializeTypeV1(serialization, password) {
        const root = JSON.parse(serialization);
        if (!(0, utils_1.isNonNullObject)(root))
            throw new Error("Root document is not an object.");
        const encryptionKey = await (0, wallet_1.executeKdf)(password, root.kdf);
        return Secp256k1HdWallet.deserializeWithEncryptionKey(serialization, encryptionKey);
    }
    get mnemonic() {
        return this.secret.toString();
    }
    async getAccounts() {
        const accountsWithPrivkeys = await this.getAccountsWithPrivkeys();
        return accountsWithPrivkeys.map(({ algo, pubkey, address }) => ({
            algo: algo,
            pubkey: pubkey,
            address: address,
        }));
    }
    async signAmino(signerAddress, signDoc) {
        const accounts = await this.getAccountsWithPrivkeys();
        const account = accounts.find(({ address }) => address === signerAddress);
        if (account === undefined) {
            throw new Error(`Address ${signerAddress} not found in wallet`);
        }
        const { privkey, pubkey } = account;
        const message = (0, crypto_1.sha256)((0, signdoc_1.serializeSignDoc)(signDoc));
        const signature = await crypto_1.Secp256k1.createSignature(message, privkey);
        const signatureBytes = new Uint8Array([...signature.r(32), ...signature.s(32)]);
        return {
            signed: signDoc,
            signature: (0, signature_1.encodeSecp256k1Signature)(pubkey, signatureBytes),
        };
    }
    /**
     * Generates an encrypted serialization of this wallet.
     *
     * @param password The user provided password used to generate an encryption key via a KDF.
     *                 This is not normalized internally (see "Unicode normalization" to learn more).
     */
    async serialize(password) {
        const kdfConfiguration = basicPasswordHashingOptions;
        const encryptionKey = await (0, wallet_1.executeKdf)(password, kdfConfiguration);
        return this.serializeWithEncryptionKey(encryptionKey, kdfConfiguration);
    }
    /**
     * Generates an encrypted serialization of this wallet.
     *
     * This is an advanced alternative to calling `serialize(password)` directly, which allows you to
     * offload the KDF execution to a non-UI thread (e.g. in a WebWorker).
     *
     * The caller is responsible for ensuring the key was derived with the given KDF options. If this
     * is not the case, the wallet cannot be restored with the original password.
     */
    async serializeWithEncryptionKey(encryptionKey, kdfConfiguration) {
        const dataToEncrypt = {
            mnemonic: this.mnemonic,
            accounts: this.accounts.map(({ hdPath, prefix }) => ({
                hdPath: (0, crypto_1.pathToString)(hdPath),
                prefix: prefix,
            })),
        };
        const dataToEncryptRaw = (0, encoding_1.toUtf8)(JSON.stringify(dataToEncrypt));
        const encryptionConfiguration = {
            algorithm: wallet_1.supportedAlgorithms.xchacha20poly1305Ietf,
        };
        const encryptedData = await (0, wallet_1.encrypt)(dataToEncryptRaw, encryptionKey, encryptionConfiguration);
        const out = {
            type: serializationTypeV1,
            kdf: kdfConfiguration,
            encryption: encryptionConfiguration,
            data: (0, encoding_1.toBase64)(encryptedData),
        };
        return JSON.stringify(out);
    }
    async getKeyPair(hdPath) {
        const { privkey } = crypto_1.Slip10.derivePath(crypto_1.Slip10Curve.Secp256k1, this.seed, hdPath);
        const { pubkey } = await crypto_1.Secp256k1.makeKeypair(privkey);
        return {
            privkey: privkey,
            pubkey: crypto_1.Secp256k1.compressPubkey(pubkey),
        };
    }
    async getAccountsWithPrivkeys() {
        return Promise.all(this.accounts.map(async ({ hdPath, prefix }) => {
            const { privkey, pubkey } = await this.getKeyPair(hdPath);
            const address = (0, encoding_1.toBech32)(prefix, (0, addresses_1.rawSecp256k1PubkeyToRawAddress)(pubkey));
            return {
                algo: "secp256k1",
                privkey: privkey,
                pubkey: pubkey,
                address: address,
            };
        }));
    }
}
exports.Secp256k1HdWallet = Secp256k1HdWallet;
//# sourceMappingURL=secp256k1hdwallet.js.map

/***/ }),

/***/ 17759:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Secp256k1Wallet = void 0;
const crypto_1 = __webpack_require__(79562);
const encoding_1 = __webpack_require__(71555);
const addresses_1 = __webpack_require__(83692);
const signature_1 = __webpack_require__(62090);
const signdoc_1 = __webpack_require__(66167);
/**
 * A wallet that holds a single secp256k1 keypair.
 *
 * If you want to work with BIP39 mnemonics and multiple accounts, use Secp256k1HdWallet.
 */
class Secp256k1Wallet {
    constructor(privkey, pubkey, prefix) {
        this.privkey = privkey;
        this.pubkey = pubkey;
        this.prefix = prefix;
    }
    /**
     * Creates a Secp256k1Wallet from the given private key
     *
     * @param privkey The private key.
     * @param prefix The bech32 address prefix (human readable part). Defaults to "cosmos".
     */
    static async fromKey(privkey, prefix = "cosmos") {
        const uncompressed = (await crypto_1.Secp256k1.makeKeypair(privkey)).pubkey;
        return new Secp256k1Wallet(privkey, crypto_1.Secp256k1.compressPubkey(uncompressed), prefix);
    }
    get address() {
        return (0, encoding_1.toBech32)(this.prefix, (0, addresses_1.rawSecp256k1PubkeyToRawAddress)(this.pubkey));
    }
    async getAccounts() {
        return [
            {
                algo: "secp256k1",
                address: this.address,
                pubkey: this.pubkey,
            },
        ];
    }
    async signAmino(signerAddress, signDoc) {
        if (signerAddress !== this.address) {
            throw new Error(`Address ${signerAddress} not found in wallet`);
        }
        const message = new crypto_1.Sha256((0, signdoc_1.serializeSignDoc)(signDoc)).digest();
        const signature = await crypto_1.Secp256k1.createSignature(message, this.privkey);
        const signatureBytes = new Uint8Array([...signature.r(32), ...signature.s(32)]);
        return {
            signed: signDoc,
            signature: (0, signature_1.encodeSecp256k1Signature)(this.pubkey, signatureBytes),
        };
    }
}
exports.Secp256k1Wallet = Secp256k1Wallet;
//# sourceMappingURL=secp256k1wallet.js.map

/***/ }),

/***/ 62090:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.decodeSignature = exports.encodeSecp256k1Signature = void 0;
/* eslint-disable @typescript-eslint/naming-convention */
const encoding_1 = __webpack_require__(71555);
const encoding_2 = __webpack_require__(99053);
const pubkeys_1 = __webpack_require__(9673);
/**
 * Takes a binary pubkey and signature to create a signature object
 *
 * @param pubkey a compressed secp256k1 public key
 * @param signature a 64 byte fixed length representation of secp256k1 signature components r and s
 */
function encodeSecp256k1Signature(pubkey, signature) {
    if (signature.length !== 64) {
        throw new Error("Signature must be 64 bytes long. Cosmos SDK uses a 2x32 byte fixed length encoding for the secp256k1 signature integers r and s.");
    }
    return {
        pub_key: (0, encoding_2.encodeSecp256k1Pubkey)(pubkey),
        signature: (0, encoding_1.toBase64)(signature),
    };
}
exports.encodeSecp256k1Signature = encodeSecp256k1Signature;
function decodeSignature(signature) {
    switch (signature.pub_key.type) {
        // Note: please don't add cases here without writing additional unit tests
        case pubkeys_1.pubkeyType.secp256k1:
            return {
                pubkey: (0, encoding_1.fromBase64)(signature.pub_key.value),
                signature: (0, encoding_1.fromBase64)(signature.signature),
            };
        default:
            throw new Error("Unsupported pubkey type");
    }
}
exports.decodeSignature = decodeSignature;
//# sourceMappingURL=signature.js.map

/***/ }),

/***/ 66167:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.serializeSignDoc = exports.makeSignDoc = exports.sortedJsonStringify = void 0;
/* eslint-disable @typescript-eslint/naming-convention */
const encoding_1 = __webpack_require__(71555);
const math_1 = __webpack_require__(62949);
function sortedObject(obj) {
    if (typeof obj !== "object" || obj === null) {
        return obj;
    }
    if (Array.isArray(obj)) {
        return obj.map(sortedObject);
    }
    const sortedKeys = Object.keys(obj).sort();
    const result = {};
    // NOTE: Use forEach instead of reduce for performance with large objects eg Wasm code
    sortedKeys.forEach((key) => {
        result[key] = sortedObject(obj[key]);
    });
    return result;
}
/** Returns a JSON string with objects sorted by key */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function sortedJsonStringify(obj) {
    return JSON.stringify(sortedObject(obj));
}
exports.sortedJsonStringify = sortedJsonStringify;
function makeSignDoc(msgs, fee, chainId, memo, accountNumber, sequence) {
    return {
        chain_id: chainId,
        account_number: math_1.Uint53.fromString(accountNumber.toString()).toString(),
        sequence: math_1.Uint53.fromString(sequence.toString()).toString(),
        fee: fee,
        msgs: msgs,
        memo: memo || "",
    };
}
exports.makeSignDoc = makeSignDoc;
function serializeSignDoc(signDoc) {
    return (0, encoding_1.toUtf8)(sortedJsonStringify(signDoc));
}
exports.serializeSignDoc = serializeSignDoc;
//# sourceMappingURL=signdoc.js.map

/***/ }),

/***/ 21887:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.makeStdTx = exports.isStdTx = void 0;
function isStdTx(txValue) {
    const { memo, msg, fee, signatures } = txValue;
    return (typeof memo === "string" && Array.isArray(msg) && typeof fee === "object" && Array.isArray(signatures));
}
exports.isStdTx = isStdTx;
function makeStdTx(content, signatures) {
    return {
        msg: content.msgs,
        fee: content.fee,
        memo: content.memo,
        signatures: Array.isArray(signatures) ? signatures : [signatures],
    };
}
exports.makeStdTx = makeStdTx;
//# sourceMappingURL=stdtx.js.map

/***/ }),

/***/ 40816:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.decrypt = exports.encrypt = exports.supportedAlgorithms = exports.executeKdf = exports.cosmjsSalt = void 0;
const crypto_1 = __webpack_require__(79562);
const encoding_1 = __webpack_require__(71555);
/**
 * A fixed salt is chosen to archive a deterministic password to key derivation.
 * This reduces the scope of a potential rainbow attack to all CosmJS users.
 * Must be 16 bytes due to implementation limitations.
 */
exports.cosmjsSalt = (0, encoding_1.toAscii)("The CosmJS salt.");
async function executeKdf(password, configuration) {
    switch (configuration.algorithm) {
        case "argon2id": {
            const options = configuration.params;
            if (!(0, crypto_1.isArgon2idOptions)(options))
                throw new Error("Invalid format of argon2id params");
            return crypto_1.Argon2id.execute(password, exports.cosmjsSalt, options);
        }
        default:
            throw new Error("Unsupported KDF algorithm");
    }
}
exports.executeKdf = executeKdf;
exports.supportedAlgorithms = {
    xchacha20poly1305Ietf: "xchacha20poly1305-ietf",
};
async function encrypt(plaintext, encryptionKey, config) {
    switch (config.algorithm) {
        case exports.supportedAlgorithms.xchacha20poly1305Ietf: {
            const nonce = crypto_1.Random.getBytes(crypto_1.xchacha20NonceLength);
            // Prepend fixed-length nonce to ciphertext as suggested in the example from https://github.com/jedisct1/libsodium.js#api
            return new Uint8Array([
                ...nonce,
                ...(await crypto_1.Xchacha20poly1305Ietf.encrypt(plaintext, encryptionKey, nonce)),
            ]);
        }
        default:
            throw new Error(`Unsupported encryption algorithm: '${config.algorithm}'`);
    }
}
exports.encrypt = encrypt;
async function decrypt(ciphertext, encryptionKey, config) {
    switch (config.algorithm) {
        case exports.supportedAlgorithms.xchacha20poly1305Ietf: {
            const nonce = ciphertext.slice(0, crypto_1.xchacha20NonceLength);
            return crypto_1.Xchacha20poly1305Ietf.decrypt(ciphertext.slice(crypto_1.xchacha20NonceLength), encryptionKey, nonce);
        }
        default:
            throw new Error(`Unsupported encryption algorithm: '${config.algorithm}'`);
    }
}
exports.decrypt = decrypt;
//# sourceMappingURL=wallet.js.map

/***/ }),

/***/ 71976:
/***/ (function(module) {

module.exports = Long;

/**
 * wasm optimizations, to do native i64 multiplication and divide
 */
var wasm = null;

try {
  wasm = new WebAssembly.Instance(new WebAssembly.Module(new Uint8Array([
    0, 97, 115, 109, 1, 0, 0, 0, 1, 13, 2, 96, 0, 1, 127, 96, 4, 127, 127, 127, 127, 1, 127, 3, 7, 6, 0, 1, 1, 1, 1, 1, 6, 6, 1, 127, 1, 65, 0, 11, 7, 50, 6, 3, 109, 117, 108, 0, 1, 5, 100, 105, 118, 95, 115, 0, 2, 5, 100, 105, 118, 95, 117, 0, 3, 5, 114, 101, 109, 95, 115, 0, 4, 5, 114, 101, 109, 95, 117, 0, 5, 8, 103, 101, 116, 95, 104, 105, 103, 104, 0, 0, 10, 191, 1, 6, 4, 0, 35, 0, 11, 36, 1, 1, 126, 32, 0, 173, 32, 1, 173, 66, 32, 134, 132, 32, 2, 173, 32, 3, 173, 66, 32, 134, 132, 126, 34, 4, 66, 32, 135, 167, 36, 0, 32, 4, 167, 11, 36, 1, 1, 126, 32, 0, 173, 32, 1, 173, 66, 32, 134, 132, 32, 2, 173, 32, 3, 173, 66, 32, 134, 132, 127, 34, 4, 66, 32, 135, 167, 36, 0, 32, 4, 167, 11, 36, 1, 1, 126, 32, 0, 173, 32, 1, 173, 66, 32, 134, 132, 32, 2, 173, 32, 3, 173, 66, 32, 134, 132, 128, 34, 4, 66, 32, 135, 167, 36, 0, 32, 4, 167, 11, 36, 1, 1, 126, 32, 0, 173, 32, 1, 173, 66, 32, 134, 132, 32, 2, 173, 32, 3, 173, 66, 32, 134, 132, 129, 34, 4, 66, 32, 135, 167, 36, 0, 32, 4, 167, 11, 36, 1, 1, 126, 32, 0, 173, 32, 1, 173, 66, 32, 134, 132, 32, 2, 173, 32, 3, 173, 66, 32, 134, 132, 130, 34, 4, 66, 32, 135, 167, 36, 0, 32, 4, 167, 11
  ])), {}).exports;
} catch (e) {
  // no wasm support :(
}

/**
 * Constructs a 64 bit two's-complement integer, given its low and high 32 bit values as *signed* integers.
 *  See the from* functions below for more convenient ways of constructing Longs.
 * @exports Long
 * @class A Long class for representing a 64 bit two's-complement integer value.
 * @param {number} low The low (signed) 32 bits of the long
 * @param {number} high The high (signed) 32 bits of the long
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @constructor
 */
function Long(low, high, unsigned) {

    /**
     * The low 32 bits as a signed value.
     * @type {number}
     */
    this.low = low | 0;

    /**
     * The high 32 bits as a signed value.
     * @type {number}
     */
    this.high = high | 0;

    /**
     * Whether unsigned or not.
     * @type {boolean}
     */
    this.unsigned = !!unsigned;
}

// The internal representation of a long is the two given signed, 32-bit values.
// We use 32-bit pieces because these are the size of integers on which
// Javascript performs bit-operations.  For operations like addition and
// multiplication, we split each number into 16 bit pieces, which can easily be
// multiplied within Javascript's floating-point representation without overflow
// or change in sign.
//
// In the algorithms below, we frequently reduce the negative case to the
// positive case by negating the input(s) and then post-processing the result.
// Note that we must ALWAYS check specially whether those values are MIN_VALUE
// (-2^63) because -MIN_VALUE == MIN_VALUE (since 2^63 cannot be represented as
// a positive number, it overflows back into a negative).  Not handling this
// case would often result in infinite recursion.
//
// Common constant values ZERO, ONE, NEG_ONE, etc. are defined below the from*
// methods on which they depend.

/**
 * An indicator used to reliably determine if an object is a Long or not.
 * @type {boolean}
 * @const
 * @private
 */
Long.prototype.__isLong__;

Object.defineProperty(Long.prototype, "__isLong__", { value: true });

/**
 * @function
 * @param {*} obj Object
 * @returns {boolean}
 * @inner
 */
function isLong(obj) {
    return (obj && obj["__isLong__"]) === true;
}

/**
 * Tests if the specified object is a Long.
 * @function
 * @param {*} obj Object
 * @returns {boolean}
 */
Long.isLong = isLong;

/**
 * A cache of the Long representations of small integer values.
 * @type {!Object}
 * @inner
 */
var INT_CACHE = {};

/**
 * A cache of the Long representations of small unsigned integer values.
 * @type {!Object}
 * @inner
 */
var UINT_CACHE = {};

/**
 * @param {number} value
 * @param {boolean=} unsigned
 * @returns {!Long}
 * @inner
 */
function fromInt(value, unsigned) {
    var obj, cachedObj, cache;
    if (unsigned) {
        value >>>= 0;
        if (cache = (0 <= value && value < 256)) {
            cachedObj = UINT_CACHE[value];
            if (cachedObj)
                return cachedObj;
        }
        obj = fromBits(value, (value | 0) < 0 ? -1 : 0, true);
        if (cache)
            UINT_CACHE[value] = obj;
        return obj;
    } else {
        value |= 0;
        if (cache = (-128 <= value && value < 128)) {
            cachedObj = INT_CACHE[value];
            if (cachedObj)
                return cachedObj;
        }
        obj = fromBits(value, value < 0 ? -1 : 0, false);
        if (cache)
            INT_CACHE[value] = obj;
        return obj;
    }
}

/**
 * Returns a Long representing the given 32 bit integer value.
 * @function
 * @param {number} value The 32 bit integer in question
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {!Long} The corresponding Long value
 */
Long.fromInt = fromInt;

/**
 * @param {number} value
 * @param {boolean=} unsigned
 * @returns {!Long}
 * @inner
 */
function fromNumber(value, unsigned) {
    if (isNaN(value))
        return unsigned ? UZERO : ZERO;
    if (unsigned) {
        if (value < 0)
            return UZERO;
        if (value >= TWO_PWR_64_DBL)
            return MAX_UNSIGNED_VALUE;
    } else {
        if (value <= -TWO_PWR_63_DBL)
            return MIN_VALUE;
        if (value + 1 >= TWO_PWR_63_DBL)
            return MAX_VALUE;
    }
    if (value < 0)
        return fromNumber(-value, unsigned).neg();
    return fromBits((value % TWO_PWR_32_DBL) | 0, (value / TWO_PWR_32_DBL) | 0, unsigned);
}

/**
 * Returns a Long representing the given value, provided that it is a finite number. Otherwise, zero is returned.
 * @function
 * @param {number} value The number in question
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {!Long} The corresponding Long value
 */
Long.fromNumber = fromNumber;

/**
 * @param {number} lowBits
 * @param {number} highBits
 * @param {boolean=} unsigned
 * @returns {!Long}
 * @inner
 */
function fromBits(lowBits, highBits, unsigned) {
    return new Long(lowBits, highBits, unsigned);
}

/**
 * Returns a Long representing the 64 bit integer that comes by concatenating the given low and high bits. Each is
 *  assumed to use 32 bits.
 * @function
 * @param {number} lowBits The low 32 bits
 * @param {number} highBits The high 32 bits
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {!Long} The corresponding Long value
 */
Long.fromBits = fromBits;

/**
 * @function
 * @param {number} base
 * @param {number} exponent
 * @returns {number}
 * @inner
 */
var pow_dbl = Math.pow; // Used 4 times (4*8 to 15+4)

/**
 * @param {string} str
 * @param {(boolean|number)=} unsigned
 * @param {number=} radix
 * @returns {!Long}
 * @inner
 */
function fromString(str, unsigned, radix) {
    if (str.length === 0)
        throw Error('empty string');
    if (str === "NaN" || str === "Infinity" || str === "+Infinity" || str === "-Infinity")
        return ZERO;
    if (typeof unsigned === 'number') {
        // For goog.math.long compatibility
        radix = unsigned,
        unsigned = false;
    } else {
        unsigned = !! unsigned;
    }
    radix = radix || 10;
    if (radix < 2 || 36 < radix)
        throw RangeError('radix');

    var p;
    if ((p = str.indexOf('-')) > 0)
        throw Error('interior hyphen');
    else if (p === 0) {
        return fromString(str.substring(1), unsigned, radix).neg();
    }

    // Do several (8) digits each time through the loop, so as to
    // minimize the calls to the very expensive emulated div.
    var radixToPower = fromNumber(pow_dbl(radix, 8));

    var result = ZERO;
    for (var i = 0; i < str.length; i += 8) {
        var size = Math.min(8, str.length - i),
            value = parseInt(str.substring(i, i + size), radix);
        if (size < 8) {
            var power = fromNumber(pow_dbl(radix, size));
            result = result.mul(power).add(fromNumber(value));
        } else {
            result = result.mul(radixToPower);
            result = result.add(fromNumber(value));
        }
    }
    result.unsigned = unsigned;
    return result;
}

/**
 * Returns a Long representation of the given string, written using the specified radix.
 * @function
 * @param {string} str The textual representation of the Long
 * @param {(boolean|number)=} unsigned Whether unsigned or not, defaults to signed
 * @param {number=} radix The radix in which the text is written (2-36), defaults to 10
 * @returns {!Long} The corresponding Long value
 */
Long.fromString = fromString;

/**
 * @function
 * @param {!Long|number|string|!{low: number, high: number, unsigned: boolean}} val
 * @param {boolean=} unsigned
 * @returns {!Long}
 * @inner
 */
function fromValue(val, unsigned) {
    if (typeof val === 'number')
        return fromNumber(val, unsigned);
    if (typeof val === 'string')
        return fromString(val, unsigned);
    // Throws for non-objects, converts non-instanceof Long:
    return fromBits(val.low, val.high, typeof unsigned === 'boolean' ? unsigned : val.unsigned);
}

/**
 * Converts the specified value to a Long using the appropriate from* function for its type.
 * @function
 * @param {!Long|number|string|!{low: number, high: number, unsigned: boolean}} val Value
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {!Long}
 */
Long.fromValue = fromValue;

// NOTE: the compiler should inline these constant values below and then remove these variables, so there should be
// no runtime penalty for these.

/**
 * @type {number}
 * @const
 * @inner
 */
var TWO_PWR_16_DBL = 1 << 16;

/**
 * @type {number}
 * @const
 * @inner
 */
var TWO_PWR_24_DBL = 1 << 24;

/**
 * @type {number}
 * @const
 * @inner
 */
var TWO_PWR_32_DBL = TWO_PWR_16_DBL * TWO_PWR_16_DBL;

/**
 * @type {number}
 * @const
 * @inner
 */
var TWO_PWR_64_DBL = TWO_PWR_32_DBL * TWO_PWR_32_DBL;

/**
 * @type {number}
 * @const
 * @inner
 */
var TWO_PWR_63_DBL = TWO_PWR_64_DBL / 2;

/**
 * @type {!Long}
 * @const
 * @inner
 */
var TWO_PWR_24 = fromInt(TWO_PWR_24_DBL);

/**
 * @type {!Long}
 * @inner
 */
var ZERO = fromInt(0);

/**
 * Signed zero.
 * @type {!Long}
 */
Long.ZERO = ZERO;

/**
 * @type {!Long}
 * @inner
 */
var UZERO = fromInt(0, true);

/**
 * Unsigned zero.
 * @type {!Long}
 */
Long.UZERO = UZERO;

/**
 * @type {!Long}
 * @inner
 */
var ONE = fromInt(1);

/**
 * Signed one.
 * @type {!Long}
 */
Long.ONE = ONE;

/**
 * @type {!Long}
 * @inner
 */
var UONE = fromInt(1, true);

/**
 * Unsigned one.
 * @type {!Long}
 */
Long.UONE = UONE;

/**
 * @type {!Long}
 * @inner
 */
var NEG_ONE = fromInt(-1);

/**
 * Signed negative one.
 * @type {!Long}
 */
Long.NEG_ONE = NEG_ONE;

/**
 * @type {!Long}
 * @inner
 */
var MAX_VALUE = fromBits(0xFFFFFFFF|0, 0x7FFFFFFF|0, false);

/**
 * Maximum signed value.
 * @type {!Long}
 */
Long.MAX_VALUE = MAX_VALUE;

/**
 * @type {!Long}
 * @inner
 */
var MAX_UNSIGNED_VALUE = fromBits(0xFFFFFFFF|0, 0xFFFFFFFF|0, true);

/**
 * Maximum unsigned value.
 * @type {!Long}
 */
Long.MAX_UNSIGNED_VALUE = MAX_UNSIGNED_VALUE;

/**
 * @type {!Long}
 * @inner
 */
var MIN_VALUE = fromBits(0, 0x80000000|0, false);

/**
 * Minimum signed value.
 * @type {!Long}
 */
Long.MIN_VALUE = MIN_VALUE;

/**
 * @alias Long.prototype
 * @inner
 */
var LongPrototype = Long.prototype;

/**
 * Converts the Long to a 32 bit integer, assuming it is a 32 bit integer.
 * @returns {number}
 */
LongPrototype.toInt = function toInt() {
    return this.unsigned ? this.low >>> 0 : this.low;
};

/**
 * Converts the Long to a the nearest floating-point representation of this value (double, 53 bit mantissa).
 * @returns {number}
 */
LongPrototype.toNumber = function toNumber() {
    if (this.unsigned)
        return ((this.high >>> 0) * TWO_PWR_32_DBL) + (this.low >>> 0);
    return this.high * TWO_PWR_32_DBL + (this.low >>> 0);
};

/**
 * Converts the Long to a string written in the specified radix.
 * @param {number=} radix Radix (2-36), defaults to 10
 * @returns {string}
 * @override
 * @throws {RangeError} If `radix` is out of range
 */
LongPrototype.toString = function toString(radix) {
    radix = radix || 10;
    if (radix < 2 || 36 < radix)
        throw RangeError('radix');
    if (this.isZero())
        return '0';
    if (this.isNegative()) { // Unsigned Longs are never negative
        if (this.eq(MIN_VALUE)) {
            // We need to change the Long value before it can be negated, so we remove
            // the bottom-most digit in this base and then recurse to do the rest.
            var radixLong = fromNumber(radix),
                div = this.div(radixLong),
                rem1 = div.mul(radixLong).sub(this);
            return div.toString(radix) + rem1.toInt().toString(radix);
        } else
            return '-' + this.neg().toString(radix);
    }

    // Do several (6) digits each time through the loop, so as to
    // minimize the calls to the very expensive emulated div.
    var radixToPower = fromNumber(pow_dbl(radix, 6), this.unsigned),
        rem = this;
    var result = '';
    while (true) {
        var remDiv = rem.div(radixToPower),
            intval = rem.sub(remDiv.mul(radixToPower)).toInt() >>> 0,
            digits = intval.toString(radix);
        rem = remDiv;
        if (rem.isZero())
            return digits + result;
        else {
            while (digits.length < 6)
                digits = '0' + digits;
            result = '' + digits + result;
        }
    }
};

/**
 * Gets the high 32 bits as a signed integer.
 * @returns {number} Signed high bits
 */
LongPrototype.getHighBits = function getHighBits() {
    return this.high;
};

/**
 * Gets the high 32 bits as an unsigned integer.
 * @returns {number} Unsigned high bits
 */
LongPrototype.getHighBitsUnsigned = function getHighBitsUnsigned() {
    return this.high >>> 0;
};

/**
 * Gets the low 32 bits as a signed integer.
 * @returns {number} Signed low bits
 */
LongPrototype.getLowBits = function getLowBits() {
    return this.low;
};

/**
 * Gets the low 32 bits as an unsigned integer.
 * @returns {number} Unsigned low bits
 */
LongPrototype.getLowBitsUnsigned = function getLowBitsUnsigned() {
    return this.low >>> 0;
};

/**
 * Gets the number of bits needed to represent the absolute value of this Long.
 * @returns {number}
 */
LongPrototype.getNumBitsAbs = function getNumBitsAbs() {
    if (this.isNegative()) // Unsigned Longs are never negative
        return this.eq(MIN_VALUE) ? 64 : this.neg().getNumBitsAbs();
    var val = this.high != 0 ? this.high : this.low;
    for (var bit = 31; bit > 0; bit--)
        if ((val & (1 << bit)) != 0)
            break;
    return this.high != 0 ? bit + 33 : bit + 1;
};

/**
 * Tests if this Long's value equals zero.
 * @returns {boolean}
 */
LongPrototype.isZero = function isZero() {
    return this.high === 0 && this.low === 0;
};

/**
 * Tests if this Long's value equals zero. This is an alias of {@link Long#isZero}.
 * @returns {boolean}
 */
LongPrototype.eqz = LongPrototype.isZero;

/**
 * Tests if this Long's value is negative.
 * @returns {boolean}
 */
LongPrototype.isNegative = function isNegative() {
    return !this.unsigned && this.high < 0;
};

/**
 * Tests if this Long's value is positive.
 * @returns {boolean}
 */
LongPrototype.isPositive = function isPositive() {
    return this.unsigned || this.high >= 0;
};

/**
 * Tests if this Long's value is odd.
 * @returns {boolean}
 */
LongPrototype.isOdd = function isOdd() {
    return (this.low & 1) === 1;
};

/**
 * Tests if this Long's value is even.
 * @returns {boolean}
 */
LongPrototype.isEven = function isEven() {
    return (this.low & 1) === 0;
};

/**
 * Tests if this Long's value equals the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */
LongPrototype.equals = function equals(other) {
    if (!isLong(other))
        other = fromValue(other);
    if (this.unsigned !== other.unsigned && (this.high >>> 31) === 1 && (other.high >>> 31) === 1)
        return false;
    return this.high === other.high && this.low === other.low;
};

/**
 * Tests if this Long's value equals the specified's. This is an alias of {@link Long#equals}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */
LongPrototype.eq = LongPrototype.equals;

/**
 * Tests if this Long's value differs from the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */
LongPrototype.notEquals = function notEquals(other) {
    return !this.eq(/* validates */ other);
};

/**
 * Tests if this Long's value differs from the specified's. This is an alias of {@link Long#notEquals}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */
LongPrototype.neq = LongPrototype.notEquals;

/**
 * Tests if this Long's value differs from the specified's. This is an alias of {@link Long#notEquals}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */
LongPrototype.ne = LongPrototype.notEquals;

/**
 * Tests if this Long's value is less than the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */
LongPrototype.lessThan = function lessThan(other) {
    return this.comp(/* validates */ other) < 0;
};

/**
 * Tests if this Long's value is less than the specified's. This is an alias of {@link Long#lessThan}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */
LongPrototype.lt = LongPrototype.lessThan;

/**
 * Tests if this Long's value is less than or equal the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */
LongPrototype.lessThanOrEqual = function lessThanOrEqual(other) {
    return this.comp(/* validates */ other) <= 0;
};

/**
 * Tests if this Long's value is less than or equal the specified's. This is an alias of {@link Long#lessThanOrEqual}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */
LongPrototype.lte = LongPrototype.lessThanOrEqual;

/**
 * Tests if this Long's value is less than or equal the specified's. This is an alias of {@link Long#lessThanOrEqual}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */
LongPrototype.le = LongPrototype.lessThanOrEqual;

/**
 * Tests if this Long's value is greater than the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */
LongPrototype.greaterThan = function greaterThan(other) {
    return this.comp(/* validates */ other) > 0;
};

/**
 * Tests if this Long's value is greater than the specified's. This is an alias of {@link Long#greaterThan}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */
LongPrototype.gt = LongPrototype.greaterThan;

/**
 * Tests if this Long's value is greater than or equal the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */
LongPrototype.greaterThanOrEqual = function greaterThanOrEqual(other) {
    return this.comp(/* validates */ other) >= 0;
};

/**
 * Tests if this Long's value is greater than or equal the specified's. This is an alias of {@link Long#greaterThanOrEqual}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */
LongPrototype.gte = LongPrototype.greaterThanOrEqual;

/**
 * Tests if this Long's value is greater than or equal the specified's. This is an alias of {@link Long#greaterThanOrEqual}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */
LongPrototype.ge = LongPrototype.greaterThanOrEqual;

/**
 * Compares this Long's value with the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {number} 0 if they are the same, 1 if the this is greater and -1
 *  if the given one is greater
 */
LongPrototype.compare = function compare(other) {
    if (!isLong(other))
        other = fromValue(other);
    if (this.eq(other))
        return 0;
    var thisNeg = this.isNegative(),
        otherNeg = other.isNegative();
    if (thisNeg && !otherNeg)
        return -1;
    if (!thisNeg && otherNeg)
        return 1;
    // At this point the sign bits are the same
    if (!this.unsigned)
        return this.sub(other).isNegative() ? -1 : 1;
    // Both are positive if at least one is unsigned
    return (other.high >>> 0) > (this.high >>> 0) || (other.high === this.high && (other.low >>> 0) > (this.low >>> 0)) ? -1 : 1;
};

/**
 * Compares this Long's value with the specified's. This is an alias of {@link Long#compare}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {number} 0 if they are the same, 1 if the this is greater and -1
 *  if the given one is greater
 */
LongPrototype.comp = LongPrototype.compare;

/**
 * Negates this Long's value.
 * @returns {!Long} Negated Long
 */
LongPrototype.negate = function negate() {
    if (!this.unsigned && this.eq(MIN_VALUE))
        return MIN_VALUE;
    return this.not().add(ONE);
};

/**
 * Negates this Long's value. This is an alias of {@link Long#negate}.
 * @function
 * @returns {!Long} Negated Long
 */
LongPrototype.neg = LongPrototype.negate;

/**
 * Returns the sum of this and the specified Long.
 * @param {!Long|number|string} addend Addend
 * @returns {!Long} Sum
 */
LongPrototype.add = function add(addend) {
    if (!isLong(addend))
        addend = fromValue(addend);

    // Divide each number into 4 chunks of 16 bits, and then sum the chunks.

    var a48 = this.high >>> 16;
    var a32 = this.high & 0xFFFF;
    var a16 = this.low >>> 16;
    var a00 = this.low & 0xFFFF;

    var b48 = addend.high >>> 16;
    var b32 = addend.high & 0xFFFF;
    var b16 = addend.low >>> 16;
    var b00 = addend.low & 0xFFFF;

    var c48 = 0, c32 = 0, c16 = 0, c00 = 0;
    c00 += a00 + b00;
    c16 += c00 >>> 16;
    c00 &= 0xFFFF;
    c16 += a16 + b16;
    c32 += c16 >>> 16;
    c16 &= 0xFFFF;
    c32 += a32 + b32;
    c48 += c32 >>> 16;
    c32 &= 0xFFFF;
    c48 += a48 + b48;
    c48 &= 0xFFFF;
    return fromBits((c16 << 16) | c00, (c48 << 16) | c32, this.unsigned);
};

/**
 * Returns the difference of this and the specified Long.
 * @param {!Long|number|string} subtrahend Subtrahend
 * @returns {!Long} Difference
 */
LongPrototype.subtract = function subtract(subtrahend) {
    if (!isLong(subtrahend))
        subtrahend = fromValue(subtrahend);
    return this.add(subtrahend.neg());
};

/**
 * Returns the difference of this and the specified Long. This is an alias of {@link Long#subtract}.
 * @function
 * @param {!Long|number|string} subtrahend Subtrahend
 * @returns {!Long} Difference
 */
LongPrototype.sub = LongPrototype.subtract;

/**
 * Returns the product of this and the specified Long.
 * @param {!Long|number|string} multiplier Multiplier
 * @returns {!Long} Product
 */
LongPrototype.multiply = function multiply(multiplier) {
    if (this.isZero())
        return ZERO;
    if (!isLong(multiplier))
        multiplier = fromValue(multiplier);

    // use wasm support if present
    if (wasm) {
        var low = wasm.mul(this.low,
                           this.high,
                           multiplier.low,
                           multiplier.high);
        return fromBits(low, wasm.get_high(), this.unsigned);
    }

    if (multiplier.isZero())
        return ZERO;
    if (this.eq(MIN_VALUE))
        return multiplier.isOdd() ? MIN_VALUE : ZERO;
    if (multiplier.eq(MIN_VALUE))
        return this.isOdd() ? MIN_VALUE : ZERO;

    if (this.isNegative()) {
        if (multiplier.isNegative())
            return this.neg().mul(multiplier.neg());
        else
            return this.neg().mul(multiplier).neg();
    } else if (multiplier.isNegative())
        return this.mul(multiplier.neg()).neg();

    // If both longs are small, use float multiplication
    if (this.lt(TWO_PWR_24) && multiplier.lt(TWO_PWR_24))
        return fromNumber(this.toNumber() * multiplier.toNumber(), this.unsigned);

    // Divide each long into 4 chunks of 16 bits, and then add up 4x4 products.
    // We can skip products that would overflow.

    var a48 = this.high >>> 16;
    var a32 = this.high & 0xFFFF;
    var a16 = this.low >>> 16;
    var a00 = this.low & 0xFFFF;

    var b48 = multiplier.high >>> 16;
    var b32 = multiplier.high & 0xFFFF;
    var b16 = multiplier.low >>> 16;
    var b00 = multiplier.low & 0xFFFF;

    var c48 = 0, c32 = 0, c16 = 0, c00 = 0;
    c00 += a00 * b00;
    c16 += c00 >>> 16;
    c00 &= 0xFFFF;
    c16 += a16 * b00;
    c32 += c16 >>> 16;
    c16 &= 0xFFFF;
    c16 += a00 * b16;
    c32 += c16 >>> 16;
    c16 &= 0xFFFF;
    c32 += a32 * b00;
    c48 += c32 >>> 16;
    c32 &= 0xFFFF;
    c32 += a16 * b16;
    c48 += c32 >>> 16;
    c32 &= 0xFFFF;
    c32 += a00 * b32;
    c48 += c32 >>> 16;
    c32 &= 0xFFFF;
    c48 += a48 * b00 + a32 * b16 + a16 * b32 + a00 * b48;
    c48 &= 0xFFFF;
    return fromBits((c16 << 16) | c00, (c48 << 16) | c32, this.unsigned);
};

/**
 * Returns the product of this and the specified Long. This is an alias of {@link Long#multiply}.
 * @function
 * @param {!Long|number|string} multiplier Multiplier
 * @returns {!Long} Product
 */
LongPrototype.mul = LongPrototype.multiply;

/**
 * Returns this Long divided by the specified. The result is signed if this Long is signed or
 *  unsigned if this Long is unsigned.
 * @param {!Long|number|string} divisor Divisor
 * @returns {!Long} Quotient
 */
LongPrototype.divide = function divide(divisor) {
    if (!isLong(divisor))
        divisor = fromValue(divisor);
    if (divisor.isZero())
        throw Error('division by zero');

    // use wasm support if present
    if (wasm) {
        // guard against signed division overflow: the largest
        // negative number / -1 would be 1 larger than the largest
        // positive number, due to two's complement.
        if (!this.unsigned &&
            this.high === -0x80000000 &&
            divisor.low === -1 && divisor.high === -1) {
            // be consistent with non-wasm code path
            return this;
        }
        var low = (this.unsigned ? wasm.div_u : wasm.div_s)(
            this.low,
            this.high,
            divisor.low,
            divisor.high
        );
        return fromBits(low, wasm.get_high(), this.unsigned);
    }

    if (this.isZero())
        return this.unsigned ? UZERO : ZERO;
    var approx, rem, res;
    if (!this.unsigned) {
        // This section is only relevant for signed longs and is derived from the
        // closure library as a whole.
        if (this.eq(MIN_VALUE)) {
            if (divisor.eq(ONE) || divisor.eq(NEG_ONE))
                return MIN_VALUE;  // recall that -MIN_VALUE == MIN_VALUE
            else if (divisor.eq(MIN_VALUE))
                return ONE;
            else {
                // At this point, we have |other| >= 2, so |this/other| < |MIN_VALUE|.
                var halfThis = this.shr(1);
                approx = halfThis.div(divisor).shl(1);
                if (approx.eq(ZERO)) {
                    return divisor.isNegative() ? ONE : NEG_ONE;
                } else {
                    rem = this.sub(divisor.mul(approx));
                    res = approx.add(rem.div(divisor));
                    return res;
                }
            }
        } else if (divisor.eq(MIN_VALUE))
            return this.unsigned ? UZERO : ZERO;
        if (this.isNegative()) {
            if (divisor.isNegative())
                return this.neg().div(divisor.neg());
            return this.neg().div(divisor).neg();
        } else if (divisor.isNegative())
            return this.div(divisor.neg()).neg();
        res = ZERO;
    } else {
        // The algorithm below has not been made for unsigned longs. It's therefore
        // required to take special care of the MSB prior to running it.
        if (!divisor.unsigned)
            divisor = divisor.toUnsigned();
        if (divisor.gt(this))
            return UZERO;
        if (divisor.gt(this.shru(1))) // 15 >>> 1 = 7 ; with divisor = 8 ; true
            return UONE;
        res = UZERO;
    }

    // Repeat the following until the remainder is less than other:  find a
    // floating-point that approximates remainder / other *from below*, add this
    // into the result, and subtract it from the remainder.  It is critical that
    // the approximate value is less than or equal to the real value so that the
    // remainder never becomes negative.
    rem = this;
    while (rem.gte(divisor)) {
        // Approximate the result of division. This may be a little greater or
        // smaller than the actual value.
        approx = Math.max(1, Math.floor(rem.toNumber() / divisor.toNumber()));

        // We will tweak the approximate result by changing it in the 48-th digit or
        // the smallest non-fractional digit, whichever is larger.
        var log2 = Math.ceil(Math.log(approx) / Math.LN2),
            delta = (log2 <= 48) ? 1 : pow_dbl(2, log2 - 48),

        // Decrease the approximation until it is smaller than the remainder.  Note
        // that if it is too large, the product overflows and is negative.
            approxRes = fromNumber(approx),
            approxRem = approxRes.mul(divisor);
        while (approxRem.isNegative() || approxRem.gt(rem)) {
            approx -= delta;
            approxRes = fromNumber(approx, this.unsigned);
            approxRem = approxRes.mul(divisor);
        }

        // We know the answer can't be zero... and actually, zero would cause
        // infinite recursion since we would make no progress.
        if (approxRes.isZero())
            approxRes = ONE;

        res = res.add(approxRes);
        rem = rem.sub(approxRem);
    }
    return res;
};

/**
 * Returns this Long divided by the specified. This is an alias of {@link Long#divide}.
 * @function
 * @param {!Long|number|string} divisor Divisor
 * @returns {!Long} Quotient
 */
LongPrototype.div = LongPrototype.divide;

/**
 * Returns this Long modulo the specified.
 * @param {!Long|number|string} divisor Divisor
 * @returns {!Long} Remainder
 */
LongPrototype.modulo = function modulo(divisor) {
    if (!isLong(divisor))
        divisor = fromValue(divisor);

    // use wasm support if present
    if (wasm) {
        var low = (this.unsigned ? wasm.rem_u : wasm.rem_s)(
            this.low,
            this.high,
            divisor.low,
            divisor.high
        );
        return fromBits(low, wasm.get_high(), this.unsigned);
    }

    return this.sub(this.div(divisor).mul(divisor));
};

/**
 * Returns this Long modulo the specified. This is an alias of {@link Long#modulo}.
 * @function
 * @param {!Long|number|string} divisor Divisor
 * @returns {!Long} Remainder
 */
LongPrototype.mod = LongPrototype.modulo;

/**
 * Returns this Long modulo the specified. This is an alias of {@link Long#modulo}.
 * @function
 * @param {!Long|number|string} divisor Divisor
 * @returns {!Long} Remainder
 */
LongPrototype.rem = LongPrototype.modulo;

/**
 * Returns the bitwise NOT of this Long.
 * @returns {!Long}
 */
LongPrototype.not = function not() {
    return fromBits(~this.low, ~this.high, this.unsigned);
};

/**
 * Returns the bitwise AND of this Long and the specified.
 * @param {!Long|number|string} other Other Long
 * @returns {!Long}
 */
LongPrototype.and = function and(other) {
    if (!isLong(other))
        other = fromValue(other);
    return fromBits(this.low & other.low, this.high & other.high, this.unsigned);
};

/**
 * Returns the bitwise OR of this Long and the specified.
 * @param {!Long|number|string} other Other Long
 * @returns {!Long}
 */
LongPrototype.or = function or(other) {
    if (!isLong(other))
        other = fromValue(other);
    return fromBits(this.low | other.low, this.high | other.high, this.unsigned);
};

/**
 * Returns the bitwise XOR of this Long and the given one.
 * @param {!Long|number|string} other Other Long
 * @returns {!Long}
 */
LongPrototype.xor = function xor(other) {
    if (!isLong(other))
        other = fromValue(other);
    return fromBits(this.low ^ other.low, this.high ^ other.high, this.unsigned);
};

/**
 * Returns this Long with bits shifted to the left by the given amount.
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */
LongPrototype.shiftLeft = function shiftLeft(numBits) {
    if (isLong(numBits))
        numBits = numBits.toInt();
    if ((numBits &= 63) === 0)
        return this;
    else if (numBits < 32)
        return fromBits(this.low << numBits, (this.high << numBits) | (this.low >>> (32 - numBits)), this.unsigned);
    else
        return fromBits(0, this.low << (numBits - 32), this.unsigned);
};

/**
 * Returns this Long with bits shifted to the left by the given amount. This is an alias of {@link Long#shiftLeft}.
 * @function
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */
LongPrototype.shl = LongPrototype.shiftLeft;

/**
 * Returns this Long with bits arithmetically shifted to the right by the given amount.
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */
LongPrototype.shiftRight = function shiftRight(numBits) {
    if (isLong(numBits))
        numBits = numBits.toInt();
    if ((numBits &= 63) === 0)
        return this;
    else if (numBits < 32)
        return fromBits((this.low >>> numBits) | (this.high << (32 - numBits)), this.high >> numBits, this.unsigned);
    else
        return fromBits(this.high >> (numBits - 32), this.high >= 0 ? 0 : -1, this.unsigned);
};

/**
 * Returns this Long with bits arithmetically shifted to the right by the given amount. This is an alias of {@link Long#shiftRight}.
 * @function
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */
LongPrototype.shr = LongPrototype.shiftRight;

/**
 * Returns this Long with bits logically shifted to the right by the given amount.
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */
LongPrototype.shiftRightUnsigned = function shiftRightUnsigned(numBits) {
    if (isLong(numBits))
        numBits = numBits.toInt();
    numBits &= 63;
    if (numBits === 0)
        return this;
    else {
        var high = this.high;
        if (numBits < 32) {
            var low = this.low;
            return fromBits((low >>> numBits) | (high << (32 - numBits)), high >>> numBits, this.unsigned);
        } else if (numBits === 32)
            return fromBits(high, 0, this.unsigned);
        else
            return fromBits(high >>> (numBits - 32), 0, this.unsigned);
    }
};

/**
 * Returns this Long with bits logically shifted to the right by the given amount. This is an alias of {@link Long#shiftRightUnsigned}.
 * @function
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */
LongPrototype.shru = LongPrototype.shiftRightUnsigned;

/**
 * Returns this Long with bits logically shifted to the right by the given amount. This is an alias of {@link Long#shiftRightUnsigned}.
 * @function
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */
LongPrototype.shr_u = LongPrototype.shiftRightUnsigned;

/**
 * Converts this Long to signed.
 * @returns {!Long} Signed long
 */
LongPrototype.toSigned = function toSigned() {
    if (!this.unsigned)
        return this;
    return fromBits(this.low, this.high, false);
};

/**
 * Converts this Long to unsigned.
 * @returns {!Long} Unsigned long
 */
LongPrototype.toUnsigned = function toUnsigned() {
    if (this.unsigned)
        return this;
    return fromBits(this.low, this.high, true);
};

/**
 * Converts this Long to its byte representation.
 * @param {boolean=} le Whether little or big endian, defaults to big endian
 * @returns {!Array.<number>} Byte representation
 */
LongPrototype.toBytes = function toBytes(le) {
    return le ? this.toBytesLE() : this.toBytesBE();
};

/**
 * Converts this Long to its little endian byte representation.
 * @returns {!Array.<number>} Little endian byte representation
 */
LongPrototype.toBytesLE = function toBytesLE() {
    var hi = this.high,
        lo = this.low;
    return [
        lo        & 0xff,
        lo >>>  8 & 0xff,
        lo >>> 16 & 0xff,
        lo >>> 24       ,
        hi        & 0xff,
        hi >>>  8 & 0xff,
        hi >>> 16 & 0xff,
        hi >>> 24
    ];
};

/**
 * Converts this Long to its big endian byte representation.
 * @returns {!Array.<number>} Big endian byte representation
 */
LongPrototype.toBytesBE = function toBytesBE() {
    var hi = this.high,
        lo = this.low;
    return [
        hi >>> 24       ,
        hi >>> 16 & 0xff,
        hi >>>  8 & 0xff,
        hi        & 0xff,
        lo >>> 24       ,
        lo >>> 16 & 0xff,
        lo >>>  8 & 0xff,
        lo        & 0xff
    ];
};

/**
 * Creates a Long from its byte representation.
 * @param {!Array.<number>} bytes Byte representation
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @param {boolean=} le Whether little or big endian, defaults to big endian
 * @returns {Long} The corresponding Long value
 */
Long.fromBytes = function fromBytes(bytes, unsigned, le) {
    return le ? Long.fromBytesLE(bytes, unsigned) : Long.fromBytesBE(bytes, unsigned);
};

/**
 * Creates a Long from its little endian byte representation.
 * @param {!Array.<number>} bytes Little endian byte representation
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {Long} The corresponding Long value
 */
Long.fromBytesLE = function fromBytesLE(bytes, unsigned) {
    return new Long(
        bytes[0]       |
        bytes[1] <<  8 |
        bytes[2] << 16 |
        bytes[3] << 24,
        bytes[4]       |
        bytes[5] <<  8 |
        bytes[6] << 16 |
        bytes[7] << 24,
        unsigned
    );
};

/**
 * Creates a Long from its big endian byte representation.
 * @param {!Array.<number>} bytes Big endian byte representation
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {Long} The corresponding Long value
 */
Long.fromBytesBE = function fromBytesBE(bytes, unsigned) {
    return new Long(
        bytes[4] << 24 |
        bytes[5] << 16 |
        bytes[6] <<  8 |
        bytes[7],
        bytes[0] << 24 |
        bytes[1] << 16 |
        bytes[2] <<  8 |
        bytes[3],
        unsigned
    );
};


/***/ }),

/***/ 90620:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.StreamingSocket = exports.SocketWrapper = exports.ReconnectingSocket = exports.QueueingStreamingSocket = exports.ConnectionStatus = void 0;
var queueingstreamingsocket_1 = __webpack_require__(42953);
Object.defineProperty(exports, "ConnectionStatus", ({ enumerable: true, get: function () { return queueingstreamingsocket_1.ConnectionStatus; } }));
Object.defineProperty(exports, "QueueingStreamingSocket", ({ enumerable: true, get: function () { return queueingstreamingsocket_1.QueueingStreamingSocket; } }));
var reconnectingsocket_1 = __webpack_require__(20327);
Object.defineProperty(exports, "ReconnectingSocket", ({ enumerable: true, get: function () { return reconnectingsocket_1.ReconnectingSocket; } }));
var socketwrapper_1 = __webpack_require__(77632);
Object.defineProperty(exports, "SocketWrapper", ({ enumerable: true, get: function () { return socketwrapper_1.SocketWrapper; } }));
var streamingsocket_1 = __webpack_require__(28325);
Object.defineProperty(exports, "StreamingSocket", ({ enumerable: true, get: function () { return streamingsocket_1.StreamingSocket; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 42953:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.QueueingStreamingSocket = exports.ConnectionStatus = void 0;
const stream_1 = __webpack_require__(81459);
const xstream_1 = __webpack_require__(43813);
const streamingsocket_1 = __webpack_require__(28325);
var ConnectionStatus;
(function (ConnectionStatus) {
    ConnectionStatus[ConnectionStatus["Unconnected"] = 0] = "Unconnected";
    ConnectionStatus[ConnectionStatus["Connecting"] = 1] = "Connecting";
    ConnectionStatus[ConnectionStatus["Connected"] = 2] = "Connected";
    ConnectionStatus[ConnectionStatus["Disconnected"] = 3] = "Disconnected";
})(ConnectionStatus = exports.ConnectionStatus || (exports.ConnectionStatus = {}));
/**
 * A wrapper around StreamingSocket that can queue requests.
 */
class QueueingStreamingSocket {
    constructor(url, timeout = 10000, reconnectedHandler) {
        this.queue = [];
        this.isProcessingQueue = false;
        this.url = url;
        this.timeout = timeout;
        this.reconnectedHandler = reconnectedHandler;
        const eventProducer = {
            start: (listener) => (this.eventProducerListener = listener),
            stop: () => (this.eventProducerListener = undefined),
        };
        this.events = xstream_1.Stream.create(eventProducer);
        this.connectionStatusProducer = new stream_1.DefaultValueProducer(ConnectionStatus.Unconnected);
        this.connectionStatus = new stream_1.ValueAndUpdates(this.connectionStatusProducer);
        this.socket = new streamingsocket_1.StreamingSocket(this.url, this.timeout);
        this.socket.events.subscribe({
            next: (event) => {
                if (!this.eventProducerListener)
                    throw new Error("No event producer listener set");
                this.eventProducerListener.next(event);
            },
            error: () => this.connectionStatusProducer.update(ConnectionStatus.Disconnected),
        });
    }
    connect() {
        this.connectionStatusProducer.update(ConnectionStatus.Connecting);
        this.socket.connected.then(async () => {
            this.connectionStatusProducer.update(ConnectionStatus.Connected);
            return this.processQueue();
        }, () => this.connectionStatusProducer.update(ConnectionStatus.Disconnected));
        this.socket.connect();
    }
    disconnect() {
        this.connectionStatusProducer.update(ConnectionStatus.Disconnected);
        this.socket.disconnect();
    }
    reconnect() {
        this.socket = new streamingsocket_1.StreamingSocket(this.url, this.timeout);
        this.socket.events.subscribe({
            next: (event) => {
                if (!this.eventProducerListener)
                    throw new Error("No event producer listener set");
                this.eventProducerListener.next(event);
            },
            error: () => this.connectionStatusProducer.update(ConnectionStatus.Disconnected),
        });
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.socket.connected.then(() => {
            if (this.reconnectedHandler) {
                this.reconnectedHandler();
            }
        });
        this.connect();
    }
    getQueueLength() {
        return this.queue.length;
    }
    queueRequest(request) {
        this.queue.push(request);
        // We don’t need to wait for the queue to be processed.
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.processQueue();
    }
    async processQueue() {
        if (this.isProcessingQueue || this.connectionStatus.value !== ConnectionStatus.Connected) {
            return;
        }
        this.isProcessingQueue = true;
        let request;
        while ((request = this.queue.shift())) {
            try {
                await this.socket.send(request);
                this.isProcessingQueue = false;
            }
            catch (error) {
                // Probably the connection is down; will try again automatically when reconnected.
                this.queue.unshift(request);
                this.isProcessingQueue = false;
                return;
            }
        }
    }
}
exports.QueueingStreamingSocket = QueueingStreamingSocket;
//# sourceMappingURL=queueingstreamingsocket.js.map

/***/ }),

/***/ 20327:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ReconnectingSocket = void 0;
const xstream_1 = __webpack_require__(43813);
const queueingstreamingsocket_1 = __webpack_require__(42953);
/**
 * A wrapper around QueueingStreamingSocket that reconnects automatically.
 */
class ReconnectingSocket {
    constructor(url, timeout = 10000, reconnectedHandler) {
        this.unconnected = true;
        this.disconnected = false;
        this.timeoutIndex = 0;
        this.reconnectTimeout = null;
        const eventProducer = {
            start: (listener) => (this.eventProducerListener = listener),
            stop: () => (this.eventProducerListener = undefined),
        };
        this.events = xstream_1.Stream.create(eventProducer);
        this.socket = new queueingstreamingsocket_1.QueueingStreamingSocket(url, timeout, reconnectedHandler);
        this.socket.events.subscribe({
            next: (event) => {
                if (this.eventProducerListener) {
                    this.eventProducerListener.next(event);
                }
            },
            error: (error) => {
                if (this.eventProducerListener) {
                    this.eventProducerListener.error(error);
                }
            },
        });
        this.connectionStatus = this.socket.connectionStatus;
        this.connectionStatus.updates.subscribe({
            next: (status) => {
                if (status === queueingstreamingsocket_1.ConnectionStatus.Connected) {
                    this.timeoutIndex = 0;
                }
                if (status === queueingstreamingsocket_1.ConnectionStatus.Disconnected) {
                    if (this.reconnectTimeout) {
                        clearTimeout(this.reconnectTimeout);
                        this.reconnectTimeout = null;
                    }
                    this.reconnectTimeout = setTimeout(() => this.socket.reconnect(), ReconnectingSocket.calculateTimeout(this.timeoutIndex++));
                }
            },
        });
    }
    /** Starts with a 0.1 second timeout, then doubles every attempt with a maximum timeout of 5 seconds. */
    static calculateTimeout(index) {
        return Math.min(2 ** index * 100, 5000);
    }
    connect() {
        if (!this.unconnected) {
            throw new Error("Cannot connect: socket has already connected");
        }
        this.socket.connect();
        this.unconnected = false;
    }
    disconnect() {
        if (this.unconnected) {
            throw new Error("Cannot disconnect: socket has not yet connected");
        }
        this.socket.disconnect();
        if (this.eventProducerListener) {
            this.eventProducerListener.complete();
        }
        this.disconnected = true;
    }
    queueRequest(request) {
        if (this.disconnected) {
            throw new Error("Cannot queue request: socket has disconnected");
        }
        this.socket.queueRequest(request);
    }
}
exports.ReconnectingSocket = ReconnectingSocket;
//# sourceMappingURL=reconnectingsocket.js.map

/***/ }),

/***/ 77632:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(34155);

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.SocketWrapper = void 0;
const isomorphic_ws_1 = __importDefault(__webpack_require__(46792));
function environmentIsNodeJs() {
    return (typeof process !== "undefined" &&
        typeof process.versions !== "undefined" &&
        typeof process.versions.node !== "undefined");
}
/**
 * A thin wrapper around isomorphic-ws' WebSocket class that adds
 * - constant message/error/open/close handlers
 * - explict connection via a connect() method
 * - type support for events
 * - handling of corner cases in the open and close behaviour
 */
class SocketWrapper {
    constructor(url, messageHandler, errorHandler, openHandler, closeHandler, timeout = 10000) {
        this.closed = false;
        this.connected = new Promise((resolve, reject) => {
            this.connectedResolver = resolve;
            this.connectedRejecter = reject;
        });
        this.url = url;
        this.messageHandler = messageHandler;
        this.errorHandler = errorHandler;
        this.openHandler = openHandler;
        this.closeHandler = closeHandler;
        this.timeout = timeout;
    }
    /**
     * returns a promise that resolves when connection is open
     */
    connect() {
        const socket = new isomorphic_ws_1.default(this.url);
        socket.onerror = (error) => {
            this.clearTimeout();
            if (this.errorHandler) {
                this.errorHandler(error);
            }
        };
        socket.onmessage = (messageEvent) => {
            this.messageHandler({
                type: messageEvent.type,
                data: messageEvent.data,
            });
        };
        socket.onopen = (_) => {
            this.clearTimeout();
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            this.connectedResolver();
            if (this.openHandler) {
                this.openHandler();
            }
        };
        socket.onclose = (closeEvent) => {
            this.closed = true;
            if (this.closeHandler) {
                this.closeHandler(closeEvent);
            }
        };
        const started = Date.now();
        this.timeoutId = setTimeout(() => {
            socket.onmessage = () => 0;
            socket.onerror = () => 0;
            socket.onopen = () => 0;
            socket.onclose = () => 0;
            socket.close();
            this.socket = undefined;
            const elapsed = Math.floor(Date.now() - started);
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            this.connectedRejecter(`Connection attempt timed out after ${elapsed} ms`);
        }, this.timeout);
        this.socket = socket;
    }
    /**
     * Closes an established connection and aborts other connection states
     */
    disconnect() {
        if (!this.socket) {
            throw new Error("Socket undefined. This must be called after connecting.");
        }
        this.clearTimeout();
        switch (this.socket.readyState) {
            case isomorphic_ws_1.default.OPEN:
                this.socket.close(1000 /* Normal Closure */);
                break;
            case isomorphic_ws_1.default.CLOSED:
                // nothing to be done
                break;
            case isomorphic_ws_1.default.CONNECTING:
                // imitate missing abort API
                this.socket.onopen = () => 0;
                this.socket.onclose = () => 0;
                this.socket.onerror = () => 0;
                this.socket.onmessage = () => 0;
                this.socket = undefined;
                if (this.closeHandler) {
                    this.closeHandler({ wasClean: false, code: 4001 });
                }
                break;
            case isomorphic_ws_1.default.CLOSING:
                // already closing. Let it proceed
                break;
            default:
                throw new Error(`Unknown readyState: ${this.socket.readyState}`);
        }
    }
    async send(data) {
        return new Promise((resolve, reject) => {
            if (!this.socket) {
                throw new Error("Socket undefined. This must be called after connecting.");
            }
            if (this.closed) {
                throw new Error("Socket was closed, so no data can be sent anymore.");
            }
            // this exception should be thrown by send() automatically according to
            // https://developer.mozilla.org/de/docs/Web/API/WebSocket#send() but it does not work in browsers
            if (this.socket.readyState !== isomorphic_ws_1.default.OPEN) {
                throw new Error("Websocket is not open");
            }
            if (environmentIsNodeJs()) {
                this.socket.send(data, (err) => (err ? reject(err) : resolve()));
            }
            else {
                // Browser websocket send method does not accept a callback
                this.socket.send(data);
                resolve();
            }
        });
    }
    /**
     * Clears the timeout function, such that no timeout error will be raised anymore. This should be
     * called when the connection is established, a connection error occurred or the socket is disconnected.
     *
     * This method must not be called before `connect()`.
     * This method is idempotent.
     */
    clearTimeout() {
        if (!this.timeoutId) {
            throw new Error("Timeout ID not set. This should not happen and usually means connect() was not called.");
        }
        // Note: do not unset this.timeoutId to allow multiple calls to this function
        clearTimeout(this.timeoutId);
    }
}
exports.SocketWrapper = SocketWrapper;
//# sourceMappingURL=socketwrapper.js.map

/***/ }),

/***/ 28325:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.StreamingSocket = void 0;
const xstream_1 = __webpack_require__(43813);
const socketwrapper_1 = __webpack_require__(77632);
/**
 * A WebSocket wrapper that exposes all events as a stream.
 *
 * This underlying socket will not be closed when the stream has no listeners
 */
class StreamingSocket {
    constructor(url, timeout = 10000) {
        this.socket = new socketwrapper_1.SocketWrapper(url, (event) => {
            if (this.eventProducerListener) {
                this.eventProducerListener.next(event);
            }
        }, (errorEvent) => {
            if (this.eventProducerListener) {
                this.eventProducerListener.error(errorEvent);
            }
        }, () => {
            // socket opened
        }, (closeEvent) => {
            if (this.eventProducerListener) {
                if (closeEvent.wasClean) {
                    this.eventProducerListener.complete();
                }
                else {
                    this.eventProducerListener.error("Socket was closed unclean");
                }
            }
        }, timeout);
        this.connected = this.socket.connected;
        const eventProducer = {
            start: (listener) => (this.eventProducerListener = listener),
            stop: () => (this.eventProducerListener = undefined),
        };
        this.events = xstream_1.Stream.create(eventProducer);
    }
    connect() {
        this.socket.connect();
    }
    disconnect() {
        this.socket.disconnect();
    }
    async send(data) {
        return this.socket.send(data);
    }
}
exports.StreamingSocket = StreamingSocket;
//# sourceMappingURL=streamingsocket.js.map

/***/ }),

/***/ 48433:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.accountFromAny = void 0;
const math_1 = __webpack_require__(62949);
const proto_signing_1 = __webpack_require__(348);
const utils_1 = __webpack_require__(85553);
const auth_1 = __webpack_require__(32024);
const vesting_1 = __webpack_require__(41694);
function uint64FromProto(input) {
    return math_1.Uint64.fromString(input.toString());
}
function accountFromBaseAccount(input) {
    const { address, pubKey, accountNumber, sequence } = input;
    const pubkey = (0, proto_signing_1.decodePubkey)(pubKey);
    return {
        address: address,
        pubkey: pubkey,
        accountNumber: uint64FromProto(accountNumber).toNumber(),
        sequence: uint64FromProto(sequence).toNumber(),
    };
}
/**
 * Basic implementation of AccountParser. This is supposed to support the most relevant
 * common Cosmos SDK account types. If you need support for exotic account types,
 * you'll need to write your own account decoder.
 */
function accountFromAny(input) {
    var _a, _b, _c, _d, _e, _f, _g;
    const { typeUrl, value } = input;
    switch (typeUrl) {
        // auth
        case "/cosmos.auth.v1beta1.BaseAccount":
            return accountFromBaseAccount(auth_1.BaseAccount.decode(value));
        case "/cosmos.auth.v1beta1.ModuleAccount": {
            const baseAccount = auth_1.ModuleAccount.decode(value).baseAccount;
            (0, utils_1.assert)(baseAccount);
            return accountFromBaseAccount(baseAccount);
        }
        // vesting
        case "/cosmos.vesting.v1beta1.BaseVestingAccount": {
            const baseAccount = (_a = vesting_1.BaseVestingAccount.decode(value)) === null || _a === void 0 ? void 0 : _a.baseAccount;
            (0, utils_1.assert)(baseAccount);
            return accountFromBaseAccount(baseAccount);
        }
        case "/cosmos.vesting.v1beta1.ContinuousVestingAccount": {
            const baseAccount = (_c = (_b = vesting_1.ContinuousVestingAccount.decode(value)) === null || _b === void 0 ? void 0 : _b.baseVestingAccount) === null || _c === void 0 ? void 0 : _c.baseAccount;
            (0, utils_1.assert)(baseAccount);
            return accountFromBaseAccount(baseAccount);
        }
        case "/cosmos.vesting.v1beta1.DelayedVestingAccount": {
            const baseAccount = (_e = (_d = vesting_1.DelayedVestingAccount.decode(value)) === null || _d === void 0 ? void 0 : _d.baseVestingAccount) === null || _e === void 0 ? void 0 : _e.baseAccount;
            (0, utils_1.assert)(baseAccount);
            return accountFromBaseAccount(baseAccount);
        }
        case "/cosmos.vesting.v1beta1.PeriodicVestingAccount": {
            const baseAccount = (_g = (_f = vesting_1.PeriodicVestingAccount.decode(value)) === null || _f === void 0 ? void 0 : _f.baseVestingAccount) === null || _g === void 0 ? void 0 : _g.baseAccount;
            (0, utils_1.assert)(baseAccount);
            return accountFromBaseAccount(baseAccount);
        }
        default:
            throw new Error(`Unsupported type: '${typeUrl}'`);
    }
}
exports.accountFromAny = accountFromAny;
//# sourceMappingURL=accounts.js.map

/***/ }),

/***/ 88825:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.AminoTypes = void 0;
function isAminoConverter(converter) {
    return typeof converter[1] !== "string";
}
/**
 * A map from Stargate message types as used in the messages's `Any` type
 * to Amino types.
 */
class AminoTypes {
    constructor(types) {
        this.register = types;
    }
    toAmino({ typeUrl, value }) {
        const converter = this.register[typeUrl];
        if (converter === "not_supported_by_chain") {
            throw new Error(`The message type '${typeUrl}' cannot be signed using the Amino JSON sign mode because this is not supported by chain.`);
        }
        if (!converter) {
            throw new Error(`Type URL '${typeUrl}' does not exist in the Amino message type register. ` +
                "If you need support for this message type, you can pass in additional entries to the AminoTypes constructor. " +
                "If you think this message type should be included by default, please open an issue at https://github.com/cosmos/cosmjs/issues.");
        }
        return {
            type: converter.aminoType,
            value: converter.toAmino(value),
        };
    }
    fromAmino({ type, value }) {
        const matches = Object.entries(this.register)
            .filter(isAminoConverter)
            .filter(([_typeUrl, { aminoType }]) => aminoType === type);
        switch (matches.length) {
            case 0: {
                throw new Error(`Amino type identifier '${type}' does not exist in the Amino message type register. ` +
                    "If you need support for this message type, you can pass in additional entries to the AminoTypes constructor. " +
                    "If you think this message type should be included by default, please open an issue at https://github.com/cosmos/cosmjs/issues.");
            }
            case 1: {
                const [typeUrl, converter] = matches[0];
                return {
                    typeUrl: typeUrl,
                    value: converter.fromAmino(value),
                };
            }
            default:
                throw new Error(`Multiple types are registered with Amino type identifier '${type}': '` +
                    matches
                        .map(([key, _value]) => key)
                        .sort()
                        .join("', '") +
                    "'. Thus fromAmino cannot be performed.");
        }
    }
}
exports.AminoTypes = AminoTypes;
//# sourceMappingURL=aminotypes.js.map

/***/ }),

/***/ 1225:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.fromTendermint34Event = void 0;
const encoding_1 = __webpack_require__(71555);
/**
 * Takes a Tendemrint 0.34 event with binary encoded key and value
 * and converts it into an `Event` with string attributes.
 */
function fromTendermint34Event(event) {
    return {
        type: event.type,
        attributes: event.attributes.map((attr) => ({
            key: (0, encoding_1.fromUtf8)(attr.key, true),
            value: (0, encoding_1.fromUtf8)(attr.value, true),
        })),
    };
}
exports.fromTendermint34Event = fromTendermint34Event;
//# sourceMappingURL=events.js.map

/***/ }),

/***/ 44458:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.calculateFee = exports.GasPrice = void 0;
const math_1 = __webpack_require__(62949);
const proto_signing_1 = __webpack_require__(348);
/**
 * Denom checker for the Cosmos SDK 0.42 denom pattern
 * (https://github.com/cosmos/cosmos-sdk/blob/v0.42.4/types/coin.go#L599-L601).
 *
 * This is like a regexp but with helpful error messages.
 */
function checkDenom(denom) {
    if (denom.length < 3 || denom.length > 128) {
        throw new Error("Denom must be between 3 and 128 characters");
    }
}
/**
 * A gas price, i.e. the price of a single unit of gas. This is typically a fraction of
 * the smallest fee token unit, such as 0.012utoken.
 */
class GasPrice {
    constructor(amount, denom) {
        this.amount = amount;
        this.denom = denom;
    }
    /**
     * Parses a gas price formatted as `<amount><denom>`, e.g. `GasPrice.fromString("0.012utoken")`.
     *
     * The denom must match the Cosmos SDK 0.42 pattern (https://github.com/cosmos/cosmos-sdk/blob/v0.42.4/types/coin.go#L599-L601).
     * See `GasPrice` in @cosmjs/stargate for a more generic matcher.
     *
     * Separators are not yet supported.
     */
    static fromString(gasPrice) {
        // Use Decimal.fromUserInput and checkDenom for detailed checks and helpful error messages
        const matchResult = gasPrice.match(/^([0-9.]+)([a-z][a-z0-9]*)$/i);
        if (!matchResult) {
            throw new Error("Invalid gas price string");
        }
        const [_, amount, denom] = matchResult;
        checkDenom(denom);
        const fractionalDigits = 18;
        const decimalAmount = math_1.Decimal.fromUserInput(amount, fractionalDigits);
        return new GasPrice(decimalAmount, denom);
    }
    /**
     * Returns a string representation of this gas price, e.g. "0.025uatom".
     * This can be used as an input to `GasPrice.fromString`.
     */
    toString() {
        return this.amount.toString() + this.denom;
    }
}
exports.GasPrice = GasPrice;
function calculateFee(gasLimit, gasPrice) {
    const processedGasPrice = typeof gasPrice === "string" ? GasPrice.fromString(gasPrice) : gasPrice;
    const { denom, amount: gasPriceAmount } = processedGasPrice;
    // Note: Amount can exceed the safe integer range (https://github.com/cosmos/cosmjs/issues/1134),
    // which we handle by converting from Decimal to string without going through number.
    const amount = gasPriceAmount.multiply(new math_1.Uint53(gasLimit)).ceil().toString();
    return {
        amount: (0, proto_signing_1.coins)(amount, denom),
        gas: gasLimit.toString(),
    };
}
exports.calculateFee = calculateFee;
//# sourceMappingURL=fee.js.map

/***/ }),

/***/ 78441:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.setupAuthExtension = exports.isMsgWithdrawDelegatorRewardEncodeObject = exports.isMsgVoteWeightedEncodeObject = exports.isMsgVoteEncodeObject = exports.isMsgUndelegateEncodeObject = exports.isMsgTransferEncodeObject = exports.isMsgSubmitProposalEncodeObject = exports.isMsgSendEncodeObject = exports.isMsgEditValidatorEncodeObject = exports.isMsgDepositEncodeObject = exports.isMsgDelegateEncodeObject = exports.isMsgCreateValidatorEncodeObject = exports.isMsgBeginRedelegateEncodeObject = exports.isAminoMsgWithdrawValidatorCommission = exports.isAminoMsgWithdrawDelegatorReward = exports.isAminoMsgVoteWeighted = exports.isAminoMsgVote = exports.isAminoMsgVerifyInvariant = exports.isAminoMsgUnjail = exports.isAminoMsgUndelegate = exports.isAminoMsgTransfer = exports.isAminoMsgSubmitProposal = exports.isAminoMsgSubmitEvidence = exports.isAminoMsgSetWithdrawAddress = exports.isAminoMsgSend = exports.isAminoMsgMultiSend = exports.isAminoMsgFundCommunityPool = exports.isAminoMsgEditValidator = exports.isAminoMsgDeposit = exports.isAminoMsgDelegate = exports.isAminoMsgCreateVestingAccount = exports.isAminoMsgCreateValidator = exports.isAminoMsgBeginRedelegate = exports.createVestingAminoConverters = exports.createStakingAminoConverters = exports.createSlashingAminoConverters = exports.createIbcAminoConverters = exports.createGovAminoConverters = exports.createFeegrantAminoConverters = exports.createEvidenceAminoConverters = exports.createDistributionAminoConverters = exports.createCrysisAminoConverters = exports.createBankAminoConverters = exports.createAuthzAminoConverters = exports.logs = exports.GasPrice = exports.calculateFee = exports.fromTendermint34Event = exports.AminoTypes = exports.accountFromAny = void 0;
exports.parseCoins = exports.makeCosmoshubPath = exports.coins = exports.coin = exports.TimeoutError = exports.StargateClient = exports.isDeliverTxSuccess = exports.isDeliverTxFailure = exports.BroadcastTxError = exports.assertIsDeliverTxSuccess = exports.assertIsDeliverTxFailure = exports.SigningStargateClient = exports.defaultRegistryTypes = exports.isSearchByTagsQuery = exports.isSearchBySentFromOrToQuery = exports.isSearchByHeightQuery = exports.QueryClient = exports.decodeCosmosSdkDecFromProto = exports.createProtobufRpcClient = exports.createPagination = exports.makeMultisignedTxBytes = exports.makeMultisignedTx = exports.setupTxExtension = exports.setupStakingExtension = exports.setupSlashingExtension = exports.setupMintExtension = exports.setupIbcExtension = exports.setupGovExtension = exports.setupFeegrantExtension = exports.setupDistributionExtension = exports.setupBankExtension = exports.setupAuthzExtension = void 0;
var accounts_1 = __webpack_require__(48433);
Object.defineProperty(exports, "accountFromAny", ({ enumerable: true, get: function () { return accounts_1.accountFromAny; } }));
var aminotypes_1 = __webpack_require__(88825);
Object.defineProperty(exports, "AminoTypes", ({ enumerable: true, get: function () { return aminotypes_1.AminoTypes; } }));
var events_1 = __webpack_require__(1225);
Object.defineProperty(exports, "fromTendermint34Event", ({ enumerable: true, get: function () { return events_1.fromTendermint34Event; } }));
var fee_1 = __webpack_require__(44458);
Object.defineProperty(exports, "calculateFee", ({ enumerable: true, get: function () { return fee_1.calculateFee; } }));
Object.defineProperty(exports, "GasPrice", ({ enumerable: true, get: function () { return fee_1.GasPrice; } }));
exports.logs = __importStar(__webpack_require__(36398));
var modules_1 = __webpack_require__(95689);
Object.defineProperty(exports, "createAuthzAminoConverters", ({ enumerable: true, get: function () { return modules_1.createAuthzAminoConverters; } }));
Object.defineProperty(exports, "createBankAminoConverters", ({ enumerable: true, get: function () { return modules_1.createBankAminoConverters; } }));
Object.defineProperty(exports, "createCrysisAminoConverters", ({ enumerable: true, get: function () { return modules_1.createCrysisAminoConverters; } }));
Object.defineProperty(exports, "createDistributionAminoConverters", ({ enumerable: true, get: function () { return modules_1.createDistributionAminoConverters; } }));
Object.defineProperty(exports, "createEvidenceAminoConverters", ({ enumerable: true, get: function () { return modules_1.createEvidenceAminoConverters; } }));
Object.defineProperty(exports, "createFeegrantAminoConverters", ({ enumerable: true, get: function () { return modules_1.createFeegrantAminoConverters; } }));
Object.defineProperty(exports, "createGovAminoConverters", ({ enumerable: true, get: function () { return modules_1.createGovAminoConverters; } }));
Object.defineProperty(exports, "createIbcAminoConverters", ({ enumerable: true, get: function () { return modules_1.createIbcAminoConverters; } }));
Object.defineProperty(exports, "createSlashingAminoConverters", ({ enumerable: true, get: function () { return modules_1.createSlashingAminoConverters; } }));
Object.defineProperty(exports, "createStakingAminoConverters", ({ enumerable: true, get: function () { return modules_1.createStakingAminoConverters; } }));
Object.defineProperty(exports, "createVestingAminoConverters", ({ enumerable: true, get: function () { return modules_1.createVestingAminoConverters; } }));
Object.defineProperty(exports, "isAminoMsgBeginRedelegate", ({ enumerable: true, get: function () { return modules_1.isAminoMsgBeginRedelegate; } }));
Object.defineProperty(exports, "isAminoMsgCreateValidator", ({ enumerable: true, get: function () { return modules_1.isAminoMsgCreateValidator; } }));
Object.defineProperty(exports, "isAminoMsgCreateVestingAccount", ({ enumerable: true, get: function () { return modules_1.isAminoMsgCreateVestingAccount; } }));
Object.defineProperty(exports, "isAminoMsgDelegate", ({ enumerable: true, get: function () { return modules_1.isAminoMsgDelegate; } }));
Object.defineProperty(exports, "isAminoMsgDeposit", ({ enumerable: true, get: function () { return modules_1.isAminoMsgDeposit; } }));
Object.defineProperty(exports, "isAminoMsgEditValidator", ({ enumerable: true, get: function () { return modules_1.isAminoMsgEditValidator; } }));
Object.defineProperty(exports, "isAminoMsgFundCommunityPool", ({ enumerable: true, get: function () { return modules_1.isAminoMsgFundCommunityPool; } }));
Object.defineProperty(exports, "isAminoMsgMultiSend", ({ enumerable: true, get: function () { return modules_1.isAminoMsgMultiSend; } }));
Object.defineProperty(exports, "isAminoMsgSend", ({ enumerable: true, get: function () { return modules_1.isAminoMsgSend; } }));
Object.defineProperty(exports, "isAminoMsgSetWithdrawAddress", ({ enumerable: true, get: function () { return modules_1.isAminoMsgSetWithdrawAddress; } }));
Object.defineProperty(exports, "isAminoMsgSubmitEvidence", ({ enumerable: true, get: function () { return modules_1.isAminoMsgSubmitEvidence; } }));
Object.defineProperty(exports, "isAminoMsgSubmitProposal", ({ enumerable: true, get: function () { return modules_1.isAminoMsgSubmitProposal; } }));
Object.defineProperty(exports, "isAminoMsgTransfer", ({ enumerable: true, get: function () { return modules_1.isAminoMsgTransfer; } }));
Object.defineProperty(exports, "isAminoMsgUndelegate", ({ enumerable: true, get: function () { return modules_1.isAminoMsgUndelegate; } }));
Object.defineProperty(exports, "isAminoMsgUnjail", ({ enumerable: true, get: function () { return modules_1.isAminoMsgUnjail; } }));
Object.defineProperty(exports, "isAminoMsgVerifyInvariant", ({ enumerable: true, get: function () { return modules_1.isAminoMsgVerifyInvariant; } }));
Object.defineProperty(exports, "isAminoMsgVote", ({ enumerable: true, get: function () { return modules_1.isAminoMsgVote; } }));
Object.defineProperty(exports, "isAminoMsgVoteWeighted", ({ enumerable: true, get: function () { return modules_1.isAminoMsgVoteWeighted; } }));
Object.defineProperty(exports, "isAminoMsgWithdrawDelegatorReward", ({ enumerable: true, get: function () { return modules_1.isAminoMsgWithdrawDelegatorReward; } }));
Object.defineProperty(exports, "isAminoMsgWithdrawValidatorCommission", ({ enumerable: true, get: function () { return modules_1.isAminoMsgWithdrawValidatorCommission; } }));
Object.defineProperty(exports, "isMsgBeginRedelegateEncodeObject", ({ enumerable: true, get: function () { return modules_1.isMsgBeginRedelegateEncodeObject; } }));
Object.defineProperty(exports, "isMsgCreateValidatorEncodeObject", ({ enumerable: true, get: function () { return modules_1.isMsgCreateValidatorEncodeObject; } }));
Object.defineProperty(exports, "isMsgDelegateEncodeObject", ({ enumerable: true, get: function () { return modules_1.isMsgDelegateEncodeObject; } }));
Object.defineProperty(exports, "isMsgDepositEncodeObject", ({ enumerable: true, get: function () { return modules_1.isMsgDepositEncodeObject; } }));
Object.defineProperty(exports, "isMsgEditValidatorEncodeObject", ({ enumerable: true, get: function () { return modules_1.isMsgEditValidatorEncodeObject; } }));
Object.defineProperty(exports, "isMsgSendEncodeObject", ({ enumerable: true, get: function () { return modules_1.isMsgSendEncodeObject; } }));
Object.defineProperty(exports, "isMsgSubmitProposalEncodeObject", ({ enumerable: true, get: function () { return modules_1.isMsgSubmitProposalEncodeObject; } }));
Object.defineProperty(exports, "isMsgTransferEncodeObject", ({ enumerable: true, get: function () { return modules_1.isMsgTransferEncodeObject; } }));
Object.defineProperty(exports, "isMsgUndelegateEncodeObject", ({ enumerable: true, get: function () { return modules_1.isMsgUndelegateEncodeObject; } }));
Object.defineProperty(exports, "isMsgVoteEncodeObject", ({ enumerable: true, get: function () { return modules_1.isMsgVoteEncodeObject; } }));
Object.defineProperty(exports, "isMsgVoteWeightedEncodeObject", ({ enumerable: true, get: function () { return modules_1.isMsgVoteWeightedEncodeObject; } }));
Object.defineProperty(exports, "isMsgWithdrawDelegatorRewardEncodeObject", ({ enumerable: true, get: function () { return modules_1.isMsgWithdrawDelegatorRewardEncodeObject; } }));
Object.defineProperty(exports, "setupAuthExtension", ({ enumerable: true, get: function () { return modules_1.setupAuthExtension; } }));
Object.defineProperty(exports, "setupAuthzExtension", ({ enumerable: true, get: function () { return modules_1.setupAuthzExtension; } }));
Object.defineProperty(exports, "setupBankExtension", ({ enumerable: true, get: function () { return modules_1.setupBankExtension; } }));
Object.defineProperty(exports, "setupDistributionExtension", ({ enumerable: true, get: function () { return modules_1.setupDistributionExtension; } }));
Object.defineProperty(exports, "setupFeegrantExtension", ({ enumerable: true, get: function () { return modules_1.setupFeegrantExtension; } }));
Object.defineProperty(exports, "setupGovExtension", ({ enumerable: true, get: function () { return modules_1.setupGovExtension; } }));
Object.defineProperty(exports, "setupIbcExtension", ({ enumerable: true, get: function () { return modules_1.setupIbcExtension; } }));
Object.defineProperty(exports, "setupMintExtension", ({ enumerable: true, get: function () { return modules_1.setupMintExtension; } }));
Object.defineProperty(exports, "setupSlashingExtension", ({ enumerable: true, get: function () { return modules_1.setupSlashingExtension; } }));
Object.defineProperty(exports, "setupStakingExtension", ({ enumerable: true, get: function () { return modules_1.setupStakingExtension; } }));
Object.defineProperty(exports, "setupTxExtension", ({ enumerable: true, get: function () { return modules_1.setupTxExtension; } }));
var multisignature_1 = __webpack_require__(40709);
Object.defineProperty(exports, "makeMultisignedTx", ({ enumerable: true, get: function () { return multisignature_1.makeMultisignedTx; } }));
Object.defineProperty(exports, "makeMultisignedTxBytes", ({ enumerable: true, get: function () { return multisignature_1.makeMultisignedTxBytes; } }));
var queryclient_1 = __webpack_require__(22995);
Object.defineProperty(exports, "createPagination", ({ enumerable: true, get: function () { return queryclient_1.createPagination; } }));
Object.defineProperty(exports, "createProtobufRpcClient", ({ enumerable: true, get: function () { return queryclient_1.createProtobufRpcClient; } }));
Object.defineProperty(exports, "decodeCosmosSdkDecFromProto", ({ enumerable: true, get: function () { return queryclient_1.decodeCosmosSdkDecFromProto; } }));
Object.defineProperty(exports, "QueryClient", ({ enumerable: true, get: function () { return queryclient_1.QueryClient; } }));
var search_1 = __webpack_require__(2018);
Object.defineProperty(exports, "isSearchByHeightQuery", ({ enumerable: true, get: function () { return search_1.isSearchByHeightQuery; } }));
Object.defineProperty(exports, "isSearchBySentFromOrToQuery", ({ enumerable: true, get: function () { return search_1.isSearchBySentFromOrToQuery; } }));
Object.defineProperty(exports, "isSearchByTagsQuery", ({ enumerable: true, get: function () { return search_1.isSearchByTagsQuery; } }));
var signingstargateclient_1 = __webpack_require__(48744);
Object.defineProperty(exports, "defaultRegistryTypes", ({ enumerable: true, get: function () { return signingstargateclient_1.defaultRegistryTypes; } }));
Object.defineProperty(exports, "SigningStargateClient", ({ enumerable: true, get: function () { return signingstargateclient_1.SigningStargateClient; } }));
var stargateclient_1 = __webpack_require__(61503);
Object.defineProperty(exports, "assertIsDeliverTxFailure", ({ enumerable: true, get: function () { return stargateclient_1.assertIsDeliverTxFailure; } }));
Object.defineProperty(exports, "assertIsDeliverTxSuccess", ({ enumerable: true, get: function () { return stargateclient_1.assertIsDeliverTxSuccess; } }));
Object.defineProperty(exports, "BroadcastTxError", ({ enumerable: true, get: function () { return stargateclient_1.BroadcastTxError; } }));
Object.defineProperty(exports, "isDeliverTxFailure", ({ enumerable: true, get: function () { return stargateclient_1.isDeliverTxFailure; } }));
Object.defineProperty(exports, "isDeliverTxSuccess", ({ enumerable: true, get: function () { return stargateclient_1.isDeliverTxSuccess; } }));
Object.defineProperty(exports, "StargateClient", ({ enumerable: true, get: function () { return stargateclient_1.StargateClient; } }));
Object.defineProperty(exports, "TimeoutError", ({ enumerable: true, get: function () { return stargateclient_1.TimeoutError; } }));
var proto_signing_1 = __webpack_require__(348);
Object.defineProperty(exports, "coin", ({ enumerable: true, get: function () { return proto_signing_1.coin; } }));
Object.defineProperty(exports, "coins", ({ enumerable: true, get: function () { return proto_signing_1.coins; } }));
Object.defineProperty(exports, "makeCosmoshubPath", ({ enumerable: true, get: function () { return proto_signing_1.makeCosmoshubPath; } }));
Object.defineProperty(exports, "parseCoins", ({ enumerable: true, get: function () { return proto_signing_1.parseCoins; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 36398:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.findAttribute = exports.parseRawLog = exports.parseLogs = exports.parseLog = exports.parseEvent = exports.parseAttribute = void 0;
/* eslint-disable @typescript-eslint/naming-convention */
const utils_1 = __webpack_require__(85553);
function parseAttribute(input) {
    if (!(0, utils_1.isNonNullObject)(input))
        throw new Error("Attribute must be a non-null object");
    const { key, value } = input;
    if (typeof key !== "string" || !key)
        throw new Error("Attribute's key must be a non-empty string");
    if (typeof value !== "string" && typeof value !== "undefined") {
        throw new Error("Attribute's value must be a string or unset");
    }
    return {
        key: key,
        value: value || "",
    };
}
exports.parseAttribute = parseAttribute;
function parseEvent(input) {
    if (!(0, utils_1.isNonNullObject)(input))
        throw new Error("Event must be a non-null object");
    const { type, attributes } = input;
    if (typeof type !== "string" || type === "") {
        throw new Error(`Event type must be a non-empty string`);
    }
    if (!Array.isArray(attributes))
        throw new Error("Event's attributes must be an array");
    return {
        type: type,
        attributes: attributes.map(parseAttribute),
    };
}
exports.parseEvent = parseEvent;
function parseLog(input) {
    if (!(0, utils_1.isNonNullObject)(input))
        throw new Error("Log must be a non-null object");
    const { msg_index, log, events } = input;
    if (typeof msg_index !== "number")
        throw new Error("Log's msg_index must be a number");
    if (typeof log !== "string")
        throw new Error("Log's log must be a string");
    if (!Array.isArray(events))
        throw new Error("Log's events must be an array");
    return {
        msg_index: msg_index,
        log: log,
        events: events.map(parseEvent),
    };
}
exports.parseLog = parseLog;
function parseLogs(input) {
    if (!Array.isArray(input))
        throw new Error("Logs must be an array");
    return input.map(parseLog);
}
exports.parseLogs = parseLogs;
function parseRawLog(input = "[]") {
    const logsToParse = JSON.parse(input).map(({ events }, i) => ({
        msg_index: i,
        events,
        log: "",
    }));
    return parseLogs(logsToParse);
}
exports.parseRawLog = parseRawLog;
/**
 * Searches in logs for the first event of the given event type and in that event
 * for the first first attribute with the given attribute key.
 *
 * Throws if the attribute was not found.
 */
function findAttribute(logs, eventType, attrKey) {
    var _a;
    const firstLogs = logs.find(() => true);
    const out = (_a = firstLogs === null || firstLogs === void 0 ? void 0 : firstLogs.events.find((event) => event.type === eventType)) === null || _a === void 0 ? void 0 : _a.attributes.find((attr) => attr.key === attrKey);
    if (!out) {
        throw new Error(`Could not find attribute '${attrKey}' in first event of type '${eventType}' in first log.`);
    }
    return out;
}
exports.findAttribute = findAttribute;
//# sourceMappingURL=logs.js.map

/***/ }),

/***/ 7999:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.setupAuthExtension = void 0;
const query_1 = __webpack_require__(68230);
const queryclient_1 = __webpack_require__(22995);
function setupAuthExtension(base) {
    const rpc = (0, queryclient_1.createProtobufRpcClient)(base);
    // Use this service to get easy typed access to query methods
    // This cannot be used for proof verification
    const queryService = new query_1.QueryClientImpl(rpc);
    return {
        auth: {
            account: async (address) => {
                const { account } = await queryService.Account({ address: address });
                return account !== null && account !== void 0 ? account : null;
            },
        },
    };
}
exports.setupAuthExtension = setupAuthExtension;
//# sourceMappingURL=queries.js.map

/***/ }),

/***/ 55062:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.createAuthzAminoConverters = void 0;
function createAuthzAminoConverters() {
    return {
        "/cosmos.authz.v1beta1.MsgGrant": "not_supported_by_chain",
        "/cosmos.authz.v1beta1.MsgExec": "not_supported_by_chain",
        "/cosmos.authz.v1beta1.MsgRevoke": "not_supported_by_chain",
    };
}
exports.createAuthzAminoConverters = createAuthzAminoConverters;
//# sourceMappingURL=aminomessages.js.map

/***/ }),

/***/ 43416:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.authzTypes = void 0;
const tx_1 = __webpack_require__(65677);
exports.authzTypes = [
    ["/cosmos.authz.v1beta1.MsgExec", tx_1.MsgExec],
    ["/cosmos.authz.v1beta1.MsgGrant", tx_1.MsgGrant],
    ["/cosmos.authz.v1beta1.MsgRevoke", tx_1.MsgRevoke],
];
//# sourceMappingURL=messages.js.map

/***/ }),

/***/ 10042:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.setupAuthzExtension = void 0;
const query_1 = __webpack_require__(15486);
const queryclient_1 = __webpack_require__(22995);
function setupAuthzExtension(base) {
    // Use this service to get easy typed access to query methods
    // This cannot be used for proof verification
    const rpc = (0, queryclient_1.createProtobufRpcClient)(base);
    const queryService = new query_1.QueryClientImpl(rpc);
    return {
        authz: {
            grants: async (granter, grantee, msgTypeUrl, paginationKey) => {
                const response = await queryService.Grants({
                    granter: granter,
                    grantee: grantee,
                    msgTypeUrl: msgTypeUrl,
                    pagination: (0, queryclient_1.createPagination)(paginationKey),
                });
                return response;
            },
        },
    };
}
exports.setupAuthzExtension = setupAuthzExtension;
//# sourceMappingURL=queries.js.map

/***/ }),

/***/ 49001:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.createBankAminoConverters = exports.isAminoMsgMultiSend = exports.isAminoMsgSend = void 0;
function isAminoMsgSend(msg) {
    return msg.type === "cosmos-sdk/MsgSend";
}
exports.isAminoMsgSend = isAminoMsgSend;
function isAminoMsgMultiSend(msg) {
    return msg.type === "cosmos-sdk/MsgMultiSend";
}
exports.isAminoMsgMultiSend = isAminoMsgMultiSend;
function createBankAminoConverters() {
    return {
        "/cosmos.bank.v1beta1.MsgSend": {
            aminoType: "cosmos-sdk/MsgSend",
            toAmino: ({ fromAddress, toAddress, amount }) => ({
                from_address: fromAddress,
                to_address: toAddress,
                amount: [...amount],
            }),
            fromAmino: ({ from_address, to_address, amount }) => ({
                fromAddress: from_address,
                toAddress: to_address,
                amount: [...amount],
            }),
        },
        "/cosmos.bank.v1beta1.MsgMultiSend": {
            aminoType: "cosmos-sdk/MsgMultiSend",
            toAmino: ({ inputs, outputs }) => ({
                inputs: inputs.map((input) => ({
                    address: input.address,
                    coins: [...input.coins],
                })),
                outputs: outputs.map((output) => ({
                    address: output.address,
                    coins: [...output.coins],
                })),
            }),
            fromAmino: ({ inputs, outputs }) => ({
                inputs: inputs.map((input) => ({
                    address: input.address,
                    coins: [...input.coins],
                })),
                outputs: outputs.map((output) => ({
                    address: output.address,
                    coins: [...output.coins],
                })),
            }),
        },
    };
}
exports.createBankAminoConverters = createBankAminoConverters;
//# sourceMappingURL=aminomessages.js.map

/***/ }),

/***/ 39468:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.isMsgSendEncodeObject = exports.bankTypes = void 0;
const tx_1 = __webpack_require__(67722);
exports.bankTypes = [
    ["/cosmos.bank.v1beta1.MsgMultiSend", tx_1.MsgMultiSend],
    ["/cosmos.bank.v1beta1.MsgSend", tx_1.MsgSend],
];
function isMsgSendEncodeObject(encodeObject) {
    return encodeObject.typeUrl === "/cosmos.bank.v1beta1.MsgSend";
}
exports.isMsgSendEncodeObject = isMsgSendEncodeObject;
//# sourceMappingURL=messages.js.map

/***/ }),

/***/ 45447:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.setupBankExtension = void 0;
/* eslint-disable @typescript-eslint/naming-convention */
const utils_1 = __webpack_require__(85553);
const query_1 = __webpack_require__(15788);
const queryclient_1 = __webpack_require__(22995);
function setupBankExtension(base) {
    const rpc = (0, queryclient_1.createProtobufRpcClient)(base);
    // Use this service to get easy typed access to query methods
    // This cannot be used for proof verification
    const queryService = new query_1.QueryClientImpl(rpc);
    return {
        bank: {
            balance: async (address, denom) => {
                const { balance } = await queryService.Balance({ address: address, denom: denom });
                (0, utils_1.assert)(balance);
                return balance;
            },
            allBalances: async (address) => {
                const { balances } = await queryService.AllBalances({ address: address });
                return balances;
            },
            totalSupply: async (paginationKey) => {
                const response = await queryService.TotalSupply({
                    pagination: (0, queryclient_1.createPagination)(paginationKey),
                });
                return response;
            },
            supplyOf: async (denom) => {
                const { amount } = await queryService.SupplyOf({ denom: denom });
                (0, utils_1.assert)(amount);
                return amount;
            },
            denomMetadata: async (denom) => {
                const { metadata } = await queryService.DenomMetadata({ denom });
                (0, utils_1.assert)(metadata);
                return metadata;
            },
            denomsMetadata: async () => {
                const { metadatas } = await queryService.DenomsMetadata({
                    pagination: undefined, // Not implemented
                });
                return metadatas;
            },
        },
    };
}
exports.setupBankExtension = setupBankExtension;
//# sourceMappingURL=queries.js.map

/***/ }),

/***/ 90801:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.createCrysisAminoConverters = exports.isAminoMsgVerifyInvariant = void 0;
function isAminoMsgVerifyInvariant(msg) {
    return msg.type === "cosmos-sdk/MsgVerifyInvariant";
}
exports.isAminoMsgVerifyInvariant = isAminoMsgVerifyInvariant;
function createCrysisAminoConverters() {
    throw new Error("Not implemented");
}
exports.createCrysisAminoConverters = createCrysisAminoConverters;
//# sourceMappingURL=aminomessages.js.map

/***/ }),

/***/ 41249:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.createDistributionAminoConverters = exports.isAminoMsgFundCommunityPool = exports.isAminoMsgWithdrawValidatorCommission = exports.isAminoMsgWithdrawDelegatorReward = exports.isAminoMsgSetWithdrawAddress = void 0;
function isAminoMsgSetWithdrawAddress(msg) {
    // NOTE: Type string and names diverge here!
    return msg.type === "cosmos-sdk/MsgModifyWithdrawAddress";
}
exports.isAminoMsgSetWithdrawAddress = isAminoMsgSetWithdrawAddress;
function isAminoMsgWithdrawDelegatorReward(msg) {
    // NOTE: Type string and names diverge here!
    return msg.type === "cosmos-sdk/MsgWithdrawDelegationReward";
}
exports.isAminoMsgWithdrawDelegatorReward = isAminoMsgWithdrawDelegatorReward;
function isAminoMsgWithdrawValidatorCommission(msg) {
    return msg.type === "cosmos-sdk/MsgWithdrawValidatorCommission";
}
exports.isAminoMsgWithdrawValidatorCommission = isAminoMsgWithdrawValidatorCommission;
function isAminoMsgFundCommunityPool(msg) {
    return msg.type === "cosmos-sdk/MsgFundCommunityPool";
}
exports.isAminoMsgFundCommunityPool = isAminoMsgFundCommunityPool;
function createDistributionAminoConverters() {
    return {
        "/cosmos.distribution.v1beta1.MsgFundCommunityPool": {
            aminoType: "cosmos-sdk/MsgFundCommunityPool",
            toAmino: ({ amount, depositor }) => ({
                amount: [...amount],
                depositor: depositor,
            }),
            fromAmino: ({ amount, depositor }) => ({
                amount: [...amount],
                depositor: depositor,
            }),
        },
        "/cosmos.distribution.v1beta1.MsgSetWithdrawAddress": {
            aminoType: "cosmos-sdk/MsgModifyWithdrawAddress",
            toAmino: ({ delegatorAddress, withdrawAddress, }) => ({
                delegator_address: delegatorAddress,
                withdraw_address: withdrawAddress,
            }),
            fromAmino: ({ delegator_address, withdraw_address, }) => ({
                delegatorAddress: delegator_address,
                withdrawAddress: withdraw_address,
            }),
        },
        "/cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward": {
            aminoType: "cosmos-sdk/MsgWithdrawDelegationReward",
            toAmino: ({ delegatorAddress, validatorAddress, }) => ({
                delegator_address: delegatorAddress,
                validator_address: validatorAddress,
            }),
            fromAmino: ({ delegator_address, validator_address, }) => ({
                delegatorAddress: delegator_address,
                validatorAddress: validator_address,
            }),
        },
        "/cosmos.distribution.v1beta1.MsgWithdrawValidatorCommission": {
            aminoType: "cosmos-sdk/MsgWithdrawValidatorCommission",
            toAmino: ({ validatorAddress, }) => ({
                validator_address: validatorAddress,
            }),
            fromAmino: ({ validator_address, }) => ({
                validatorAddress: validator_address,
            }),
        },
    };
}
exports.createDistributionAminoConverters = createDistributionAminoConverters;
//# sourceMappingURL=aminomessages.js.map

/***/ }),

/***/ 53178:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.isMsgWithdrawDelegatorRewardEncodeObject = exports.distributionTypes = void 0;
const tx_1 = __webpack_require__(42632);
exports.distributionTypes = [
    ["/cosmos.distribution.v1beta1.MsgFundCommunityPool", tx_1.MsgFundCommunityPool],
    ["/cosmos.distribution.v1beta1.MsgSetWithdrawAddress", tx_1.MsgSetWithdrawAddress],
    ["/cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward", tx_1.MsgWithdrawDelegatorReward],
    ["/cosmos.distribution.v1beta1.MsgWithdrawValidatorCommission", tx_1.MsgWithdrawValidatorCommission],
];
function isMsgWithdrawDelegatorRewardEncodeObject(object) {
    return (object.typeUrl ===
        "/cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward");
}
exports.isMsgWithdrawDelegatorRewardEncodeObject = isMsgWithdrawDelegatorRewardEncodeObject;
//# sourceMappingURL=messages.js.map

/***/ }),

/***/ 62772:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.setupDistributionExtension = void 0;
/* eslint-disable @typescript-eslint/naming-convention */
const query_1 = __webpack_require__(62904);
const long_1 = __importDefault(__webpack_require__(21305));
const queryclient_1 = __webpack_require__(22995);
function setupDistributionExtension(base) {
    const rpc = (0, queryclient_1.createProtobufRpcClient)(base);
    // Use this service to get easy typed access to query methods
    // This cannot be used for proof verification
    const queryService = new query_1.QueryClientImpl(rpc);
    return {
        distribution: {
            communityPool: async () => {
                const response = await queryService.CommunityPool({});
                return response;
            },
            delegationRewards: async (delegatorAddress, validatorAddress) => {
                const response = await queryService.DelegationRewards({
                    delegatorAddress: delegatorAddress,
                    validatorAddress: validatorAddress,
                });
                return response;
            },
            delegationTotalRewards: async (delegatorAddress) => {
                const response = await queryService.DelegationTotalRewards({
                    delegatorAddress: delegatorAddress,
                });
                return response;
            },
            delegatorValidators: async (delegatorAddress) => {
                const response = await queryService.DelegatorValidators({
                    delegatorAddress: delegatorAddress,
                });
                return response;
            },
            delegatorWithdrawAddress: async (delegatorAddress) => {
                const response = await queryService.DelegatorWithdrawAddress({
                    delegatorAddress: delegatorAddress,
                });
                return response;
            },
            params: async () => {
                const response = await queryService.Params({});
                return response;
            },
            validatorCommission: async (validatorAddress) => {
                const response = await queryService.ValidatorCommission({
                    validatorAddress: validatorAddress,
                });
                return response;
            },
            validatorOutstandingRewards: async (validatorAddress) => {
                const response = await queryService.ValidatorOutstandingRewards({
                    validatorAddress: validatorAddress,
                });
                return response;
            },
            validatorSlashes: async (validatorAddress, startingHeight, endingHeight, paginationKey) => {
                const response = await queryService.ValidatorSlashes({
                    validatorAddress: validatorAddress,
                    startingHeight: long_1.default.fromNumber(startingHeight, true),
                    endingHeight: long_1.default.fromNumber(endingHeight, true),
                    pagination: (0, queryclient_1.createPagination)(paginationKey),
                });
                return response;
            },
        },
    };
}
exports.setupDistributionExtension = setupDistributionExtension;
//# sourceMappingURL=queries.js.map

/***/ }),

/***/ 40159:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.createEvidenceAminoConverters = exports.isAminoMsgSubmitEvidence = void 0;
function isAminoMsgSubmitEvidence(msg) {
    return msg.type === "cosmos-sdk/MsgSubmitEvidence";
}
exports.isAminoMsgSubmitEvidence = isAminoMsgSubmitEvidence;
function createEvidenceAminoConverters() {
    throw new Error("Not implemented");
}
exports.createEvidenceAminoConverters = createEvidenceAminoConverters;
//# sourceMappingURL=aminomessages.js.map

/***/ }),

/***/ 38687:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.createFeegrantAminoConverters = void 0;
function createFeegrantAminoConverters() {
    return {
        "/cosmos.feegrant.v1beta1.MsgGrantAllowance": "not_supported_by_chain",
        "/cosmos.feegrant.v1beta1.MsgRevokeAllowance": "not_supported_by_chain",
    };
}
exports.createFeegrantAminoConverters = createFeegrantAminoConverters;
//# sourceMappingURL=aminomessages.js.map

/***/ }),

/***/ 97764:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.feegrantTypes = void 0;
const tx_1 = __webpack_require__(38196);
exports.feegrantTypes = [
    ["/cosmos.feegrant.v1beta1.MsgGrantAllowance", tx_1.MsgGrantAllowance],
    ["/cosmos.feegrant.v1beta1.MsgRevokeAllowance", tx_1.MsgRevokeAllowance],
];
//# sourceMappingURL=messages.js.map

/***/ }),

/***/ 93302:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.setupFeegrantExtension = void 0;
const query_1 = __webpack_require__(57519);
const queryclient_1 = __webpack_require__(22995);
function setupFeegrantExtension(base) {
    // Use this service to get easy typed access to query methods
    // This cannot be used for proof verification
    const rpc = (0, queryclient_1.createProtobufRpcClient)(base);
    const queryService = new query_1.QueryClientImpl(rpc);
    return {
        feegrant: {
            allowance: async (granter, grantee) => {
                const response = await queryService.Allowance({
                    granter: granter,
                    grantee: grantee,
                });
                return response;
            },
            allowances: async (grantee, paginationKey) => {
                const response = await queryService.Allowances({
                    grantee: grantee,
                    pagination: (0, queryclient_1.createPagination)(paginationKey),
                });
                return response;
            },
        },
    };
}
exports.setupFeegrantExtension = setupFeegrantExtension;
//# sourceMappingURL=queries.js.map

/***/ }),

/***/ 80677:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.createGovAminoConverters = exports.isAminoMsgDeposit = exports.isAminoMsgVoteWeighted = exports.isAminoMsgVote = exports.isAminoMsgSubmitProposal = void 0;
const math_1 = __webpack_require__(62949);
const utils_1 = __webpack_require__(85553);
const gov_1 = __webpack_require__(72980);
const any_1 = __webpack_require__(90007);
const long_1 = __importDefault(__webpack_require__(21305));
const queryclient_1 = __webpack_require__(22995);
function isAminoMsgSubmitProposal(msg) {
    return msg.type === "cosmos-sdk/MsgSubmitProposal";
}
exports.isAminoMsgSubmitProposal = isAminoMsgSubmitProposal;
function isAminoMsgVote(msg) {
    return msg.type === "cosmos-sdk/MsgVote";
}
exports.isAminoMsgVote = isAminoMsgVote;
function isAminoMsgVoteWeighted(msg) {
    return msg.type === "cosmos-sdk/MsgVoteWeighted";
}
exports.isAminoMsgVoteWeighted = isAminoMsgVoteWeighted;
function isAminoMsgDeposit(msg) {
    return msg.type === "cosmos-sdk/MsgDeposit";
}
exports.isAminoMsgDeposit = isAminoMsgDeposit;
function createGovAminoConverters() {
    return {
        "/cosmos.gov.v1beta1.MsgDeposit": {
            aminoType: "cosmos-sdk/MsgDeposit",
            toAmino: ({ amount, depositor, proposalId }) => {
                return {
                    amount,
                    depositor,
                    proposal_id: proposalId.toString(),
                };
            },
            fromAmino: ({ amount, depositor, proposal_id }) => {
                return {
                    amount: Array.from(amount),
                    depositor,
                    proposalId: long_1.default.fromString(proposal_id),
                };
            },
        },
        "/cosmos.gov.v1beta1.MsgVote": {
            aminoType: "cosmos-sdk/MsgVote",
            toAmino: ({ option, proposalId, voter }) => {
                return {
                    option: option,
                    proposal_id: proposalId.toString(),
                    voter: voter,
                };
            },
            fromAmino: ({ option, proposal_id, voter }) => {
                return {
                    option: (0, gov_1.voteOptionFromJSON)(option),
                    proposalId: long_1.default.fromString(proposal_id),
                    voter: voter,
                };
            },
        },
        "/cosmos.gov.v1beta1.MsgVoteWeighted": {
            aminoType: "cosmos-sdk/MsgVoteWeighted",
            toAmino: ({ options, proposalId, voter }) => {
                return {
                    options: options.map((o) => ({
                        option: o.option,
                        // Weight is between 0 and 1, so we always have 20 characters when printing all trailing
                        // zeros (e.g. "0.700000000000000000" or "1.000000000000000000")
                        weight: (0, queryclient_1.decodeCosmosSdkDecFromProto)(o.weight).toString().padEnd(20, "0"),
                    })),
                    proposal_id: proposalId.toString(),
                    voter: voter,
                };
            },
            fromAmino: ({ options, proposal_id, voter }) => {
                return {
                    proposalId: long_1.default.fromString(proposal_id),
                    voter: voter,
                    options: options.map((o) => ({
                        option: (0, gov_1.voteOptionFromJSON)(o.option),
                        weight: math_1.Decimal.fromUserInput(o.weight, 18).atomics,
                    })),
                };
            },
        },
        "/cosmos.gov.v1beta1.MsgSubmitProposal": {
            aminoType: "cosmos-sdk/MsgSubmitProposal",
            toAmino: ({ initialDeposit, proposer, content, }) => {
                (0, utils_1.assertDefinedAndNotNull)(content);
                let proposal;
                switch (content.typeUrl) {
                    case "/cosmos.gov.v1beta1.TextProposal": {
                        const textProposal = gov_1.TextProposal.decode(content.value);
                        proposal = {
                            type: "cosmos-sdk/TextProposal",
                            value: {
                                description: textProposal.description,
                                title: textProposal.title,
                            },
                        };
                        break;
                    }
                    default:
                        throw new Error(`Unsupported proposal type: '${content.typeUrl}'`);
                }
                return {
                    initial_deposit: initialDeposit,
                    proposer: proposer,
                    content: proposal,
                };
            },
            fromAmino: ({ initial_deposit, proposer, content, }) => {
                let any_content;
                switch (content.type) {
                    case "cosmos-sdk/TextProposal": {
                        const { value } = content;
                        (0, utils_1.assert)((0, utils_1.isNonNullObject)(value));
                        const { title, description } = value;
                        (0, utils_1.assert)(typeof title === "string");
                        (0, utils_1.assert)(typeof description === "string");
                        any_content = any_1.Any.fromPartial({
                            typeUrl: "/cosmos.gov.v1beta1.TextProposal",
                            value: gov_1.TextProposal.encode(gov_1.TextProposal.fromPartial({
                                title: title,
                                description: description,
                            })).finish(),
                        });
                        break;
                    }
                    default:
                        throw new Error(`Unsupported proposal type: '${content.type}'`);
                }
                return {
                    initialDeposit: Array.from(initial_deposit),
                    proposer: proposer,
                    content: any_content,
                };
            },
        },
    };
}
exports.createGovAminoConverters = createGovAminoConverters;
//# sourceMappingURL=aminomessages.js.map

/***/ }),

/***/ 81342:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.isMsgVoteWeightedEncodeObject = exports.isMsgVoteEncodeObject = exports.isMsgSubmitProposalEncodeObject = exports.isMsgDepositEncodeObject = exports.govTypes = void 0;
const tx_1 = __webpack_require__(63937);
exports.govTypes = [
    ["/cosmos.gov.v1beta1.MsgDeposit", tx_1.MsgDeposit],
    ["/cosmos.gov.v1beta1.MsgSubmitProposal", tx_1.MsgSubmitProposal],
    ["/cosmos.gov.v1beta1.MsgVote", tx_1.MsgVote],
    ["/cosmos.gov.v1beta1.MsgVoteWeighted", tx_1.MsgVoteWeighted],
];
function isMsgDepositEncodeObject(object) {
    return object.typeUrl === "/cosmos.gov.v1beta1.MsgDeposit";
}
exports.isMsgDepositEncodeObject = isMsgDepositEncodeObject;
function isMsgSubmitProposalEncodeObject(object) {
    return object.typeUrl === "/cosmos.gov.v1beta1.MsgSubmitProposal";
}
exports.isMsgSubmitProposalEncodeObject = isMsgSubmitProposalEncodeObject;
function isMsgVoteEncodeObject(object) {
    return object.typeUrl === "/cosmos.gov.v1beta1.MsgVote";
}
exports.isMsgVoteEncodeObject = isMsgVoteEncodeObject;
function isMsgVoteWeightedEncodeObject(object) {
    return object.typeUrl === "/cosmos.gov.v1beta1.MsgVoteWeighted";
}
exports.isMsgVoteWeightedEncodeObject = isMsgVoteWeightedEncodeObject;
//# sourceMappingURL=messages.js.map

/***/ }),

/***/ 19442:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.setupGovExtension = void 0;
const query_1 = __webpack_require__(13645);
const queryclient_1 = __webpack_require__(22995);
function setupGovExtension(base) {
    const rpc = (0, queryclient_1.createProtobufRpcClient)(base);
    // Use this service to get easy typed access to query methods
    // This cannot be used for proof verification
    const queryService = new query_1.QueryClientImpl(rpc);
    return {
        gov: {
            params: async (parametersType) => {
                const response = await queryService.Params({ paramsType: parametersType });
                return response;
            },
            proposals: async (proposalStatus, depositorAddress, voterAddress, paginationKey) => {
                const response = await queryService.Proposals({
                    proposalStatus,
                    depositor: depositorAddress,
                    voter: voterAddress,
                    pagination: (0, queryclient_1.createPagination)(paginationKey),
                });
                return response;
            },
            proposal: async (proposalId) => {
                const response = await queryService.Proposal({ proposalId: (0, queryclient_1.longify)(proposalId) });
                return response;
            },
            deposits: async (proposalId, paginationKey) => {
                const response = await queryService.Deposits({
                    proposalId: (0, queryclient_1.longify)(proposalId),
                    pagination: (0, queryclient_1.createPagination)(paginationKey),
                });
                return response;
            },
            deposit: async (proposalId, depositorAddress) => {
                const response = await queryService.Deposit({
                    proposalId: (0, queryclient_1.longify)(proposalId),
                    depositor: depositorAddress,
                });
                return response;
            },
            tally: async (proposalId) => {
                const response = await queryService.TallyResult({
                    proposalId: (0, queryclient_1.longify)(proposalId),
                });
                return response;
            },
            votes: async (proposalId, paginationKey) => {
                const response = await queryService.Votes({
                    proposalId: (0, queryclient_1.longify)(proposalId),
                    pagination: (0, queryclient_1.createPagination)(paginationKey),
                });
                return response;
            },
            vote: async (proposalId, voterAddress) => {
                const response = await queryService.Vote({
                    proposalId: (0, queryclient_1.longify)(proposalId),
                    voter: voterAddress,
                });
                return response;
            },
        },
    };
}
exports.setupGovExtension = setupGovExtension;
//# sourceMappingURL=queries.js.map

/***/ }),

/***/ 94532:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.createIbcAminoConverters = exports.isAminoMsgTransfer = void 0;
const long_1 = __importDefault(__webpack_require__(21305));
function isAminoMsgTransfer(msg) {
    return msg.type === "cosmos-sdk/MsgTransfer";
}
exports.isAminoMsgTransfer = isAminoMsgTransfer;
function omitDefault(input) {
    if (typeof input === "string") {
        return input === "" ? undefined : input;
    }
    if (typeof input === "number") {
        return input === 0 ? undefined : input;
    }
    if (long_1.default.isLong(input)) {
        return input.isZero() ? undefined : input;
    }
    throw new Error(`Got unsupported type '${typeof input}'`);
}
function createIbcAminoConverters() {
    return {
        "/ibc.applications.transfer.v1.MsgTransfer": {
            aminoType: "cosmos-sdk/MsgTransfer",
            toAmino: ({ sourcePort, sourceChannel, token, sender, receiver, timeoutHeight, timeoutTimestamp, }) => {
                var _a, _b, _c;
                return ({
                    source_port: sourcePort,
                    source_channel: sourceChannel,
                    token: token,
                    sender: sender,
                    receiver: receiver,
                    timeout_height: timeoutHeight
                        ? {
                            revision_height: (_a = omitDefault(timeoutHeight.revisionHeight)) === null || _a === void 0 ? void 0 : _a.toString(),
                            revision_number: (_b = omitDefault(timeoutHeight.revisionNumber)) === null || _b === void 0 ? void 0 : _b.toString(),
                        }
                        : {},
                    timeout_timestamp: (_c = omitDefault(timeoutTimestamp)) === null || _c === void 0 ? void 0 : _c.toString(),
                });
            },
            fromAmino: ({ source_port, source_channel, token, sender, receiver, timeout_height, timeout_timestamp, }) => ({
                sourcePort: source_port,
                sourceChannel: source_channel,
                token: token,
                sender: sender,
                receiver: receiver,
                timeoutHeight: timeout_height
                    ? {
                        revisionHeight: long_1.default.fromString(timeout_height.revision_height || "0", true),
                        revisionNumber: long_1.default.fromString(timeout_height.revision_number || "0", true),
                    }
                    : undefined,
                timeoutTimestamp: long_1.default.fromString(timeout_timestamp || "0", true),
            }),
        },
    };
}
exports.createIbcAminoConverters = createIbcAminoConverters;
//# sourceMappingURL=aminomessages.js.map

/***/ }),

/***/ 75174:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.isMsgTransferEncodeObject = exports.ibcTypes = void 0;
const tx_1 = __webpack_require__(38848);
const tx_2 = __webpack_require__(50581);
const tx_3 = __webpack_require__(97657);
const tx_4 = __webpack_require__(28300);
exports.ibcTypes = [
    ["/ibc.applications.transfer.v1.MsgTransfer", tx_1.MsgTransfer],
    ["/ibc.core.channel.v1.MsgAcknowledgement", tx_2.MsgAcknowledgement],
    ["/ibc.core.channel.v1.MsgChannelCloseConfirm", tx_2.MsgChannelCloseConfirm],
    ["/ibc.core.channel.v1.MsgChannelCloseInit", tx_2.MsgChannelCloseInit],
    ["/ibc.core.channel.v1.MsgChannelOpenAck", tx_2.MsgChannelOpenAck],
    ["/ibc.core.channel.v1.MsgChannelOpenConfirm", tx_2.MsgChannelOpenConfirm],
    ["/ibc.core.channel.v1.MsgChannelOpenInit", tx_2.MsgChannelOpenInit],
    ["/ibc.core.channel.v1.MsgChannelOpenTry", tx_2.MsgChannelOpenTry],
    ["/ibc.core.channel.v1.MsgRecvPacket", tx_2.MsgRecvPacket],
    ["/ibc.core.channel.v1.MsgTimeout", tx_2.MsgTimeout],
    ["/ibc.core.channel.v1.MsgTimeoutOnClose", tx_2.MsgTimeoutOnClose],
    ["/ibc.core.client.v1.MsgCreateClient", tx_3.MsgCreateClient],
    ["/ibc.core.client.v1.MsgSubmitMisbehaviour", tx_3.MsgSubmitMisbehaviour],
    ["/ibc.core.client.v1.MsgUpdateClient", tx_3.MsgUpdateClient],
    ["/ibc.core.client.v1.MsgUpgradeClient", tx_3.MsgUpgradeClient],
    ["/ibc.core.connection.v1.MsgConnectionOpenAck", tx_4.MsgConnectionOpenAck],
    ["/ibc.core.connection.v1.MsgConnectionOpenConfirm", tx_4.MsgConnectionOpenConfirm],
    ["/ibc.core.connection.v1.MsgConnectionOpenInit", tx_4.MsgConnectionOpenInit],
    ["/ibc.core.connection.v1.MsgConnectionOpenTry", tx_4.MsgConnectionOpenTry],
];
function isMsgTransferEncodeObject(object) {
    return object.typeUrl === "/ibc.applications.transfer.v1.MsgTransfer";
}
exports.isMsgTransferEncodeObject = isMsgTransferEncodeObject;
//# sourceMappingURL=messages.js.map

/***/ }),

/***/ 32939:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.setupIbcExtension = void 0;
/* eslint-disable @typescript-eslint/naming-convention */
const encoding_1 = __webpack_require__(71555);
const math_1 = __webpack_require__(62949);
const query_1 = __webpack_require__(35028);
const channel_1 = __webpack_require__(37212);
const query_2 = __webpack_require__(15470);
const query_3 = __webpack_require__(12858);
const query_4 = __webpack_require__(34463);
const tendermint_1 = __webpack_require__(83359);
const long_1 = __importDefault(__webpack_require__(21305));
const queryclient_1 = __webpack_require__(22995);
function decodeTendermintClientStateAny(clientState) {
    if ((clientState === null || clientState === void 0 ? void 0 : clientState.typeUrl) !== "/ibc.lightclients.tendermint.v1.ClientState") {
        throw new Error(`Unexpected client state type: ${clientState === null || clientState === void 0 ? void 0 : clientState.typeUrl}`);
    }
    return tendermint_1.ClientState.decode(clientState.value);
}
function decodeTendermintConsensusStateAny(clientState) {
    if ((clientState === null || clientState === void 0 ? void 0 : clientState.typeUrl) !== "/ibc.lightclients.tendermint.v1.ConsensusState") {
        throw new Error(`Unexpected client state type: ${clientState === null || clientState === void 0 ? void 0 : clientState.typeUrl}`);
    }
    return tendermint_1.ConsensusState.decode(clientState.value);
}
function setupIbcExtension(base) {
    const rpc = (0, queryclient_1.createProtobufRpcClient)(base);
    // Use these services to get easy typed access to query methods
    // These cannot be used for proof verification
    const channelQueryService = new query_2.QueryClientImpl(rpc);
    const clientQueryService = new query_3.QueryClientImpl(rpc);
    const connectionQueryService = new query_4.QueryClientImpl(rpc);
    const transferQueryService = new query_1.QueryClientImpl(rpc);
    return {
        ibc: {
            channel: {
                channel: async (portId, channelId) => channelQueryService.Channel({
                    portId: portId,
                    channelId: channelId,
                }),
                channels: async (paginationKey) => channelQueryService.Channels({
                    pagination: (0, queryclient_1.createPagination)(paginationKey),
                }),
                allChannels: async () => {
                    var _a;
                    const channels = [];
                    let response;
                    let key;
                    do {
                        response = await channelQueryService.Channels({
                            pagination: (0, queryclient_1.createPagination)(key),
                        });
                        channels.push(...response.channels);
                        key = (_a = response.pagination) === null || _a === void 0 ? void 0 : _a.nextKey;
                    } while (key && key.length);
                    return {
                        channels: channels,
                        height: response.height,
                    };
                },
                connectionChannels: async (connection, paginationKey) => channelQueryService.ConnectionChannels({
                    connection: connection,
                    pagination: (0, queryclient_1.createPagination)(paginationKey),
                }),
                allConnectionChannels: async (connection) => {
                    var _a;
                    const channels = [];
                    let response;
                    let key;
                    do {
                        response = await channelQueryService.ConnectionChannels({
                            connection: connection,
                            pagination: (0, queryclient_1.createPagination)(key),
                        });
                        channels.push(...response.channels);
                        key = (_a = response.pagination) === null || _a === void 0 ? void 0 : _a.nextKey;
                    } while (key && key.length);
                    return {
                        channels: channels,
                        height: response.height,
                    };
                },
                clientState: async (portId, channelId) => channelQueryService.ChannelClientState({
                    portId: portId,
                    channelId: channelId,
                }),
                consensusState: async (portId, channelId, revisionNumber, revisionHeight) => channelQueryService.ChannelConsensusState({
                    portId: portId,
                    channelId: channelId,
                    revisionNumber: long_1.default.fromNumber(revisionNumber, true),
                    revisionHeight: long_1.default.fromNumber(revisionHeight, true),
                }),
                packetCommitment: async (portId, channelId, sequence) => channelQueryService.PacketCommitment({
                    portId: portId,
                    channelId: channelId,
                    sequence: long_1.default.fromNumber(sequence, true),
                }),
                packetCommitments: async (portId, channelId, paginationKey) => channelQueryService.PacketCommitments({
                    channelId: channelId,
                    portId: portId,
                    pagination: (0, queryclient_1.createPagination)(paginationKey),
                }),
                allPacketCommitments: async (portId, channelId) => {
                    var _a;
                    const commitments = [];
                    let response;
                    let key;
                    do {
                        response = await channelQueryService.PacketCommitments({
                            channelId: channelId,
                            portId: portId,
                            pagination: (0, queryclient_1.createPagination)(key),
                        });
                        commitments.push(...response.commitments);
                        key = (_a = response.pagination) === null || _a === void 0 ? void 0 : _a.nextKey;
                    } while (key && key.length);
                    return {
                        commitments: commitments,
                        height: response.height,
                    };
                },
                packetReceipt: async (portId, channelId, sequence) => channelQueryService.PacketReceipt({
                    portId: portId,
                    channelId: channelId,
                    sequence: long_1.default.fromNumber(sequence, true),
                }),
                packetAcknowledgement: async (portId, channelId, sequence) => channelQueryService.PacketAcknowledgement({
                    portId: portId,
                    channelId: channelId,
                    sequence: long_1.default.fromNumber(sequence, true),
                }),
                packetAcknowledgements: async (portId, channelId, paginationKey) => {
                    const request = query_2.QueryPacketAcknowledgementsRequest.fromPartial({
                        portId: portId,
                        channelId: channelId,
                        pagination: (0, queryclient_1.createPagination)(paginationKey),
                    });
                    return channelQueryService.PacketAcknowledgements(request);
                },
                allPacketAcknowledgements: async (portId, channelId) => {
                    var _a;
                    const acknowledgements = [];
                    let response;
                    let key;
                    do {
                        const request = query_2.QueryPacketAcknowledgementsRequest.fromPartial({
                            channelId: channelId,
                            portId: portId,
                            pagination: (0, queryclient_1.createPagination)(key),
                        });
                        response = await channelQueryService.PacketAcknowledgements(request);
                        acknowledgements.push(...response.acknowledgements);
                        key = (_a = response.pagination) === null || _a === void 0 ? void 0 : _a.nextKey;
                    } while (key && key.length);
                    return {
                        acknowledgements: acknowledgements,
                        height: response.height,
                    };
                },
                unreceivedPackets: async (portId, channelId, packetCommitmentSequences) => channelQueryService.UnreceivedPackets({
                    portId: portId,
                    channelId: channelId,
                    packetCommitmentSequences: packetCommitmentSequences.map((s) => long_1.default.fromNumber(s, true)),
                }),
                unreceivedAcks: async (portId, channelId, packetAckSequences) => channelQueryService.UnreceivedAcks({
                    portId: portId,
                    channelId: channelId,
                    packetAckSequences: packetAckSequences.map((s) => long_1.default.fromNumber(s, true)),
                }),
                nextSequenceReceive: async (portId, channelId) => channelQueryService.NextSequenceReceive({
                    portId: portId,
                    channelId: channelId,
                }),
            },
            client: {
                state: async (clientId) => clientQueryService.ClientState({ clientId }),
                states: async (paginationKey) => clientQueryService.ClientStates({
                    pagination: (0, queryclient_1.createPagination)(paginationKey),
                }),
                allStates: async () => {
                    var _a;
                    const clientStates = [];
                    let response;
                    let key;
                    do {
                        response = await clientQueryService.ClientStates({
                            pagination: (0, queryclient_1.createPagination)(key),
                        });
                        clientStates.push(...response.clientStates);
                        key = (_a = response.pagination) === null || _a === void 0 ? void 0 : _a.nextKey;
                    } while (key && key.length);
                    return {
                        clientStates: clientStates,
                    };
                },
                consensusState: async (clientId, consensusHeight) => clientQueryService.ConsensusState(query_3.QueryConsensusStateRequest.fromPartial({
                    clientId: clientId,
                    revisionHeight: consensusHeight !== undefined ? long_1.default.fromNumber(consensusHeight, true) : undefined,
                    latestHeight: consensusHeight === undefined,
                })),
                consensusStates: async (clientId, paginationKey) => clientQueryService.ConsensusStates({
                    clientId: clientId,
                    pagination: (0, queryclient_1.createPagination)(paginationKey),
                }),
                allConsensusStates: async (clientId) => {
                    var _a;
                    const consensusStates = [];
                    let response;
                    let key;
                    do {
                        response = await clientQueryService.ConsensusStates({
                            clientId: clientId,
                            pagination: (0, queryclient_1.createPagination)(key),
                        });
                        consensusStates.push(...response.consensusStates);
                        key = (_a = response.pagination) === null || _a === void 0 ? void 0 : _a.nextKey;
                    } while (key && key.length);
                    return {
                        consensusStates: consensusStates,
                    };
                },
                params: async () => clientQueryService.ClientParams({}),
                stateTm: async (clientId) => {
                    const response = await clientQueryService.ClientState({ clientId });
                    return decodeTendermintClientStateAny(response.clientState);
                },
                statesTm: async (paginationKey) => {
                    const { clientStates } = await clientQueryService.ClientStates({
                        pagination: (0, queryclient_1.createPagination)(paginationKey),
                    });
                    return clientStates.map(({ clientState }) => decodeTendermintClientStateAny(clientState));
                },
                allStatesTm: async () => {
                    var _a;
                    const clientStates = [];
                    let response;
                    let key;
                    do {
                        response = await clientQueryService.ClientStates({
                            pagination: (0, queryclient_1.createPagination)(key),
                        });
                        clientStates.push(...response.clientStates);
                        key = (_a = response.pagination) === null || _a === void 0 ? void 0 : _a.nextKey;
                    } while (key && key.length);
                    return clientStates.map(({ clientState }) => decodeTendermintClientStateAny(clientState));
                },
                consensusStateTm: async (clientId, consensusHeight) => {
                    const response = await clientQueryService.ConsensusState(query_3.QueryConsensusStateRequest.fromPartial({
                        clientId: clientId,
                        revisionHeight: consensusHeight === null || consensusHeight === void 0 ? void 0 : consensusHeight.revisionHeight,
                        revisionNumber: consensusHeight === null || consensusHeight === void 0 ? void 0 : consensusHeight.revisionNumber,
                        latestHeight: consensusHeight === undefined,
                    }));
                    return decodeTendermintConsensusStateAny(response.consensusState);
                },
            },
            connection: {
                connection: async (connectionId) => connectionQueryService.Connection({
                    connectionId: connectionId,
                }),
                connections: async (paginationKey) => connectionQueryService.Connections({
                    pagination: (0, queryclient_1.createPagination)(paginationKey),
                }),
                allConnections: async () => {
                    var _a;
                    const connections = [];
                    let response;
                    let key;
                    do {
                        response = await connectionQueryService.Connections({
                            pagination: (0, queryclient_1.createPagination)(key),
                        });
                        connections.push(...response.connections);
                        key = (_a = response.pagination) === null || _a === void 0 ? void 0 : _a.nextKey;
                    } while (key && key.length);
                    return {
                        connections: connections,
                        height: response.height,
                    };
                },
                clientConnections: async (clientId) => connectionQueryService.ClientConnections({
                    clientId: clientId,
                }),
                clientState: async (connectionId) => connectionQueryService.ConnectionClientState({
                    connectionId: connectionId,
                }),
                consensusState: async (connectionId, revisionHeight) => connectionQueryService.ConnectionConsensusState(query_4.QueryConnectionConsensusStateRequest.fromPartial({
                    connectionId: connectionId,
                    revisionHeight: long_1.default.fromNumber(revisionHeight, true),
                })),
            },
            transfer: {
                denomTrace: async (hash) => transferQueryService.DenomTrace({ hash: hash }),
                denomTraces: async (paginationKey) => transferQueryService.DenomTraces({
                    pagination: (0, queryclient_1.createPagination)(paginationKey),
                }),
                allDenomTraces: async () => {
                    var _a;
                    const denomTraces = [];
                    let response;
                    let key;
                    do {
                        response = await transferQueryService.DenomTraces({
                            pagination: (0, queryclient_1.createPagination)(key),
                        });
                        denomTraces.push(...response.denomTraces);
                        key = (_a = response.pagination) === null || _a === void 0 ? void 0 : _a.nextKey;
                    } while (key && key.length);
                    return {
                        denomTraces: denomTraces,
                    };
                },
                params: async () => transferQueryService.Params({}),
            },
            verified: {
                channel: {
                    channel: async (portId, channelId) => {
                        // keeper: https://github.com/cosmos/cosmos-sdk/blob/3bafd8255a502e5a9cee07391cf8261538245dfd/x/ibc/04-channel/keeper/keeper.go#L55-L65
                        // key: https://github.com/cosmos/cosmos-sdk/blob/ef0a7344af345882729598bc2958a21143930a6b/x/ibc/24-host/keys.go#L117-L120
                        const key = (0, encoding_1.toAscii)(`channelEnds/ports/${portId}/channels/${channelId}`);
                        const responseData = await base.queryVerified("ibc", key);
                        return responseData.length ? channel_1.Channel.decode(responseData) : null;
                    },
                    packetCommitment: async (portId, channelId, sequence) => {
                        // keeper: https://github.com/cosmos/cosmos-sdk/blob/3bafd8255a502e5a9cee07391cf8261538245dfd/x/ibc/04-channel/keeper/keeper.go#L128-L133
                        // key: https://github.com/cosmos/cosmos-sdk/blob/ef0a7344af345882729598bc2958a21143930a6b/x/ibc/24-host/keys.go#L183-L185
                        const key = (0, encoding_1.toAscii)(`commitments/ports/${portId}/channels/${channelId}/packets/${sequence}`);
                        const responseData = await base.queryVerified("ibc", key);
                        // keeper code doesn't parse, but returns raw
                        return responseData;
                    },
                    packetAcknowledgement: async (portId, channelId, sequence) => {
                        // keeper: https://github.com/cosmos/cosmos-sdk/blob/3bafd8255a502e5a9cee07391cf8261538245dfd/x/ibc/04-channel/keeper/keeper.go#L159-L166
                        // key: https://github.com/cosmos/cosmos-sdk/blob/ef0a7344af345882729598bc2958a21143930a6b/x/ibc/24-host/keys.go#L153-L156
                        const key = (0, encoding_1.toAscii)(`acks/ports/${portId}/channels/${channelId}/acknowledgements/${sequence}`);
                        const responseData = await base.queryVerified("ibc", key);
                        // keeper code doesn't parse, but returns raw
                        return responseData;
                    },
                    nextSequenceReceive: async (portId, channelId) => {
                        // keeper: https://github.com/cosmos/cosmos-sdk/blob/3bafd8255a502e5a9cee07391cf8261538245dfd/x/ibc/04-channel/keeper/keeper.go#L92-L101
                        // key: https://github.com/cosmos/cosmos-sdk/blob/ef0a7344af345882729598bc2958a21143930a6b/x/ibc/24-host/keys.go#L133-L136
                        const key = (0, encoding_1.toAscii)(`seqAcks/ports/${portId}/channels/${channelId}/nextSequenceAck`);
                        const responseData = await base.queryVerified("ibc", key);
                        return responseData.length ? math_1.Uint64.fromBytes(responseData).toNumber() : null;
                    },
                },
            },
        },
    };
}
exports.setupIbcExtension = setupIbcExtension;
//# sourceMappingURL=queries.js.map

/***/ }),

/***/ 95689:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.isAminoMsgEditValidator = exports.isAminoMsgDelegate = exports.isAminoMsgCreateValidator = exports.isAminoMsgBeginRedelegate = exports.createStakingAminoConverters = exports.setupSlashingExtension = exports.isAminoMsgUnjail = exports.createSlashingAminoConverters = exports.setupMintExtension = exports.setupIbcExtension = exports.isMsgTransferEncodeObject = exports.ibcTypes = exports.isAminoMsgTransfer = exports.createIbcAminoConverters = exports.setupGovExtension = exports.isMsgVoteWeightedEncodeObject = exports.isMsgVoteEncodeObject = exports.isMsgSubmitProposalEncodeObject = exports.isMsgDepositEncodeObject = exports.govTypes = exports.isAminoMsgVoteWeighted = exports.isAminoMsgVote = exports.isAminoMsgSubmitProposal = exports.isAminoMsgDeposit = exports.createGovAminoConverters = exports.setupFeegrantExtension = exports.feegrantTypes = exports.createFeegrantAminoConverters = exports.isAminoMsgSubmitEvidence = exports.createEvidenceAminoConverters = exports.setupDistributionExtension = exports.isMsgWithdrawDelegatorRewardEncodeObject = exports.distributionTypes = exports.isAminoMsgWithdrawValidatorCommission = exports.isAminoMsgWithdrawDelegatorReward = exports.isAminoMsgSetWithdrawAddress = exports.isAminoMsgFundCommunityPool = exports.createDistributionAminoConverters = exports.isAminoMsgVerifyInvariant = exports.createCrysisAminoConverters = exports.setupBankExtension = exports.isMsgSendEncodeObject = exports.bankTypes = exports.isAminoMsgSend = exports.isAminoMsgMultiSend = exports.createBankAminoConverters = exports.setupAuthzExtension = exports.authzTypes = exports.createAuthzAminoConverters = exports.setupAuthExtension = void 0;
exports.vestingTypes = exports.isAminoMsgCreateVestingAccount = exports.createVestingAminoConverters = exports.setupTxExtension = exports.setupStakingExtension = exports.stakingTypes = exports.isMsgUndelegateEncodeObject = exports.isMsgEditValidatorEncodeObject = exports.isMsgDelegateEncodeObject = exports.isMsgCreateValidatorEncodeObject = exports.isMsgBeginRedelegateEncodeObject = exports.isAminoMsgUndelegate = void 0;
var queries_1 = __webpack_require__(7999);
Object.defineProperty(exports, "setupAuthExtension", ({ enumerable: true, get: function () { return queries_1.setupAuthExtension; } }));
var aminomessages_1 = __webpack_require__(55062);
Object.defineProperty(exports, "createAuthzAminoConverters", ({ enumerable: true, get: function () { return aminomessages_1.createAuthzAminoConverters; } }));
var messages_1 = __webpack_require__(43416);
Object.defineProperty(exports, "authzTypes", ({ enumerable: true, get: function () { return messages_1.authzTypes; } }));
var queries_2 = __webpack_require__(10042);
Object.defineProperty(exports, "setupAuthzExtension", ({ enumerable: true, get: function () { return queries_2.setupAuthzExtension; } }));
var aminomessages_2 = __webpack_require__(49001);
Object.defineProperty(exports, "createBankAminoConverters", ({ enumerable: true, get: function () { return aminomessages_2.createBankAminoConverters; } }));
Object.defineProperty(exports, "isAminoMsgMultiSend", ({ enumerable: true, get: function () { return aminomessages_2.isAminoMsgMultiSend; } }));
Object.defineProperty(exports, "isAminoMsgSend", ({ enumerable: true, get: function () { return aminomessages_2.isAminoMsgSend; } }));
var messages_2 = __webpack_require__(39468);
Object.defineProperty(exports, "bankTypes", ({ enumerable: true, get: function () { return messages_2.bankTypes; } }));
Object.defineProperty(exports, "isMsgSendEncodeObject", ({ enumerable: true, get: function () { return messages_2.isMsgSendEncodeObject; } }));
var queries_3 = __webpack_require__(45447);
Object.defineProperty(exports, "setupBankExtension", ({ enumerable: true, get: function () { return queries_3.setupBankExtension; } }));
var aminomessages_3 = __webpack_require__(90801);
Object.defineProperty(exports, "createCrysisAminoConverters", ({ enumerable: true, get: function () { return aminomessages_3.createCrysisAminoConverters; } }));
Object.defineProperty(exports, "isAminoMsgVerifyInvariant", ({ enumerable: true, get: function () { return aminomessages_3.isAminoMsgVerifyInvariant; } }));
var aminomessages_4 = __webpack_require__(41249);
Object.defineProperty(exports, "createDistributionAminoConverters", ({ enumerable: true, get: function () { return aminomessages_4.createDistributionAminoConverters; } }));
Object.defineProperty(exports, "isAminoMsgFundCommunityPool", ({ enumerable: true, get: function () { return aminomessages_4.isAminoMsgFundCommunityPool; } }));
Object.defineProperty(exports, "isAminoMsgSetWithdrawAddress", ({ enumerable: true, get: function () { return aminomessages_4.isAminoMsgSetWithdrawAddress; } }));
Object.defineProperty(exports, "isAminoMsgWithdrawDelegatorReward", ({ enumerable: true, get: function () { return aminomessages_4.isAminoMsgWithdrawDelegatorReward; } }));
Object.defineProperty(exports, "isAminoMsgWithdrawValidatorCommission", ({ enumerable: true, get: function () { return aminomessages_4.isAminoMsgWithdrawValidatorCommission; } }));
var messages_3 = __webpack_require__(53178);
Object.defineProperty(exports, "distributionTypes", ({ enumerable: true, get: function () { return messages_3.distributionTypes; } }));
Object.defineProperty(exports, "isMsgWithdrawDelegatorRewardEncodeObject", ({ enumerable: true, get: function () { return messages_3.isMsgWithdrawDelegatorRewardEncodeObject; } }));
var queries_4 = __webpack_require__(62772);
Object.defineProperty(exports, "setupDistributionExtension", ({ enumerable: true, get: function () { return queries_4.setupDistributionExtension; } }));
var aminomessages_5 = __webpack_require__(40159);
Object.defineProperty(exports, "createEvidenceAminoConverters", ({ enumerable: true, get: function () { return aminomessages_5.createEvidenceAminoConverters; } }));
Object.defineProperty(exports, "isAminoMsgSubmitEvidence", ({ enumerable: true, get: function () { return aminomessages_5.isAminoMsgSubmitEvidence; } }));
var aminomessages_6 = __webpack_require__(38687);
Object.defineProperty(exports, "createFeegrantAminoConverters", ({ enumerable: true, get: function () { return aminomessages_6.createFeegrantAminoConverters; } }));
var messages_4 = __webpack_require__(97764);
Object.defineProperty(exports, "feegrantTypes", ({ enumerable: true, get: function () { return messages_4.feegrantTypes; } }));
var queries_5 = __webpack_require__(93302);
Object.defineProperty(exports, "setupFeegrantExtension", ({ enumerable: true, get: function () { return queries_5.setupFeegrantExtension; } }));
var aminomessages_7 = __webpack_require__(80677);
Object.defineProperty(exports, "createGovAminoConverters", ({ enumerable: true, get: function () { return aminomessages_7.createGovAminoConverters; } }));
Object.defineProperty(exports, "isAminoMsgDeposit", ({ enumerable: true, get: function () { return aminomessages_7.isAminoMsgDeposit; } }));
Object.defineProperty(exports, "isAminoMsgSubmitProposal", ({ enumerable: true, get: function () { return aminomessages_7.isAminoMsgSubmitProposal; } }));
Object.defineProperty(exports, "isAminoMsgVote", ({ enumerable: true, get: function () { return aminomessages_7.isAminoMsgVote; } }));
Object.defineProperty(exports, "isAminoMsgVoteWeighted", ({ enumerable: true, get: function () { return aminomessages_7.isAminoMsgVoteWeighted; } }));
var messages_5 = __webpack_require__(81342);
Object.defineProperty(exports, "govTypes", ({ enumerable: true, get: function () { return messages_5.govTypes; } }));
Object.defineProperty(exports, "isMsgDepositEncodeObject", ({ enumerable: true, get: function () { return messages_5.isMsgDepositEncodeObject; } }));
Object.defineProperty(exports, "isMsgSubmitProposalEncodeObject", ({ enumerable: true, get: function () { return messages_5.isMsgSubmitProposalEncodeObject; } }));
Object.defineProperty(exports, "isMsgVoteEncodeObject", ({ enumerable: true, get: function () { return messages_5.isMsgVoteEncodeObject; } }));
Object.defineProperty(exports, "isMsgVoteWeightedEncodeObject", ({ enumerable: true, get: function () { return messages_5.isMsgVoteWeightedEncodeObject; } }));
var queries_6 = __webpack_require__(19442);
Object.defineProperty(exports, "setupGovExtension", ({ enumerable: true, get: function () { return queries_6.setupGovExtension; } }));
var aminomessages_8 = __webpack_require__(94532);
Object.defineProperty(exports, "createIbcAminoConverters", ({ enumerable: true, get: function () { return aminomessages_8.createIbcAminoConverters; } }));
Object.defineProperty(exports, "isAminoMsgTransfer", ({ enumerable: true, get: function () { return aminomessages_8.isAminoMsgTransfer; } }));
var messages_6 = __webpack_require__(75174);
Object.defineProperty(exports, "ibcTypes", ({ enumerable: true, get: function () { return messages_6.ibcTypes; } }));
Object.defineProperty(exports, "isMsgTransferEncodeObject", ({ enumerable: true, get: function () { return messages_6.isMsgTransferEncodeObject; } }));
var queries_7 = __webpack_require__(32939);
Object.defineProperty(exports, "setupIbcExtension", ({ enumerable: true, get: function () { return queries_7.setupIbcExtension; } }));
var queries_8 = __webpack_require__(93115);
Object.defineProperty(exports, "setupMintExtension", ({ enumerable: true, get: function () { return queries_8.setupMintExtension; } }));
var aminomessages_9 = __webpack_require__(74168);
Object.defineProperty(exports, "createSlashingAminoConverters", ({ enumerable: true, get: function () { return aminomessages_9.createSlashingAminoConverters; } }));
Object.defineProperty(exports, "isAminoMsgUnjail", ({ enumerable: true, get: function () { return aminomessages_9.isAminoMsgUnjail; } }));
var queries_9 = __webpack_require__(29710);
Object.defineProperty(exports, "setupSlashingExtension", ({ enumerable: true, get: function () { return queries_9.setupSlashingExtension; } }));
var aminomessages_10 = __webpack_require__(85262);
Object.defineProperty(exports, "createStakingAminoConverters", ({ enumerable: true, get: function () { return aminomessages_10.createStakingAminoConverters; } }));
Object.defineProperty(exports, "isAminoMsgBeginRedelegate", ({ enumerable: true, get: function () { return aminomessages_10.isAminoMsgBeginRedelegate; } }));
Object.defineProperty(exports, "isAminoMsgCreateValidator", ({ enumerable: true, get: function () { return aminomessages_10.isAminoMsgCreateValidator; } }));
Object.defineProperty(exports, "isAminoMsgDelegate", ({ enumerable: true, get: function () { return aminomessages_10.isAminoMsgDelegate; } }));
Object.defineProperty(exports, "isAminoMsgEditValidator", ({ enumerable: true, get: function () { return aminomessages_10.isAminoMsgEditValidator; } }));
Object.defineProperty(exports, "isAminoMsgUndelegate", ({ enumerable: true, get: function () { return aminomessages_10.isAminoMsgUndelegate; } }));
var messages_7 = __webpack_require__(91822);
Object.defineProperty(exports, "isMsgBeginRedelegateEncodeObject", ({ enumerable: true, get: function () { return messages_7.isMsgBeginRedelegateEncodeObject; } }));
Object.defineProperty(exports, "isMsgCreateValidatorEncodeObject", ({ enumerable: true, get: function () { return messages_7.isMsgCreateValidatorEncodeObject; } }));
Object.defineProperty(exports, "isMsgDelegateEncodeObject", ({ enumerable: true, get: function () { return messages_7.isMsgDelegateEncodeObject; } }));
Object.defineProperty(exports, "isMsgEditValidatorEncodeObject", ({ enumerable: true, get: function () { return messages_7.isMsgEditValidatorEncodeObject; } }));
Object.defineProperty(exports, "isMsgUndelegateEncodeObject", ({ enumerable: true, get: function () { return messages_7.isMsgUndelegateEncodeObject; } }));
Object.defineProperty(exports, "stakingTypes", ({ enumerable: true, get: function () { return messages_7.stakingTypes; } }));
var queries_10 = __webpack_require__(91356);
Object.defineProperty(exports, "setupStakingExtension", ({ enumerable: true, get: function () { return queries_10.setupStakingExtension; } }));
var queries_11 = __webpack_require__(68208);
Object.defineProperty(exports, "setupTxExtension", ({ enumerable: true, get: function () { return queries_11.setupTxExtension; } }));
var aminomessages_11 = __webpack_require__(74064);
Object.defineProperty(exports, "createVestingAminoConverters", ({ enumerable: true, get: function () { return aminomessages_11.createVestingAminoConverters; } }));
Object.defineProperty(exports, "isAminoMsgCreateVestingAccount", ({ enumerable: true, get: function () { return aminomessages_11.isAminoMsgCreateVestingAccount; } }));
var messages_8 = __webpack_require__(6394);
Object.defineProperty(exports, "vestingTypes", ({ enumerable: true, get: function () { return messages_8.vestingTypes; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 93115:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.setupMintExtension = void 0;
const utils_1 = __webpack_require__(85553);
const query_1 = __webpack_require__(83246);
const queryclient_1 = __webpack_require__(22995);
function setupMintExtension(base) {
    const rpc = (0, queryclient_1.createProtobufRpcClient)(base);
    // Use this service to get easy typed access to query methods
    // This cannot be used for proof verification
    const queryService = new query_1.QueryClientImpl(rpc);
    return {
        mint: {
            params: async () => {
                const { params } = await queryService.Params({});
                (0, utils_1.assert)(params);
                return {
                    blocksPerYear: params.blocksPerYear,
                    goalBonded: (0, queryclient_1.decodeCosmosSdkDecFromProto)(params.goalBonded),
                    inflationMin: (0, queryclient_1.decodeCosmosSdkDecFromProto)(params.inflationMin),
                    inflationMax: (0, queryclient_1.decodeCosmosSdkDecFromProto)(params.inflationMax),
                    inflationRateChange: (0, queryclient_1.decodeCosmosSdkDecFromProto)(params.inflationRateChange),
                    mintDenom: params.mintDenom,
                };
            },
            inflation: async () => {
                const { inflation } = await queryService.Inflation({});
                return (0, queryclient_1.decodeCosmosSdkDecFromProto)(inflation);
            },
            annualProvisions: async () => {
                const { annualProvisions } = await queryService.AnnualProvisions({});
                return (0, queryclient_1.decodeCosmosSdkDecFromProto)(annualProvisions);
            },
        },
    };
}
exports.setupMintExtension = setupMintExtension;
//# sourceMappingURL=queries.js.map

/***/ }),

/***/ 74168:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.createSlashingAminoConverters = exports.isAminoMsgUnjail = void 0;
function isAminoMsgUnjail(msg) {
    return msg.type === "cosmos-sdk/MsgUnjail";
}
exports.isAminoMsgUnjail = isAminoMsgUnjail;
function createSlashingAminoConverters() {
    throw new Error("Not implemented");
}
exports.createSlashingAminoConverters = createSlashingAminoConverters;
//# sourceMappingURL=aminomessages.js.map

/***/ }),

/***/ 29710:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.setupSlashingExtension = void 0;
const query_1 = __webpack_require__(25252);
const queryclient_1 = __webpack_require__(22995);
function setupSlashingExtension(base) {
    const rpc = (0, queryclient_1.createProtobufRpcClient)(base);
    const queryService = new query_1.QueryClientImpl(rpc);
    return {
        slashing: {
            signingInfo: async (consAddress) => {
                const response = await queryService.SigningInfo({
                    consAddress: consAddress,
                });
                return response;
            },
            signingInfos: async (paginationKey) => {
                const response = await queryService.SigningInfos({
                    pagination: (0, queryclient_1.createPagination)(paginationKey),
                });
                return response;
            },
            params: async () => {
                const response = await queryService.Params({});
                return response;
            },
        },
    };
}
exports.setupSlashingExtension = setupSlashingExtension;
//# sourceMappingURL=queries.js.map

/***/ }),

/***/ 85262:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.createStakingAminoConverters = exports.isAminoMsgUndelegate = exports.isAminoMsgBeginRedelegate = exports.isAminoMsgDelegate = exports.isAminoMsgEditValidator = exports.isAminoMsgCreateValidator = void 0;
const math_1 = __webpack_require__(62949);
const proto_signing_1 = __webpack_require__(348);
const utils_1 = __webpack_require__(85553);
function protoDecimalToJson(decimal) {
    const parsed = math_1.Decimal.fromAtomics(decimal, 18);
    const [whole, fractional] = parsed.toString().split(".");
    return `${whole}.${fractional.padEnd(18, "0")}`;
}
function jsonDecimalToProto(decimal) {
    const parsed = math_1.Decimal.fromUserInput(decimal, 18);
    return parsed.atomics;
}
function isAminoMsgCreateValidator(msg) {
    return msg.type === "cosmos-sdk/MsgCreateValidator";
}
exports.isAminoMsgCreateValidator = isAminoMsgCreateValidator;
function isAminoMsgEditValidator(msg) {
    return msg.type === "cosmos-sdk/MsgEditValidator";
}
exports.isAminoMsgEditValidator = isAminoMsgEditValidator;
function isAminoMsgDelegate(msg) {
    return msg.type === "cosmos-sdk/MsgDelegate";
}
exports.isAminoMsgDelegate = isAminoMsgDelegate;
function isAminoMsgBeginRedelegate(msg) {
    return msg.type === "cosmos-sdk/MsgBeginRedelegate";
}
exports.isAminoMsgBeginRedelegate = isAminoMsgBeginRedelegate;
function isAminoMsgUndelegate(msg) {
    return msg.type === "cosmos-sdk/MsgUndelegate";
}
exports.isAminoMsgUndelegate = isAminoMsgUndelegate;
function createStakingAminoConverters(_prefix) {
    return {
        "/cosmos.staking.v1beta1.MsgBeginRedelegate": {
            aminoType: "cosmos-sdk/MsgBeginRedelegate",
            toAmino: ({ delegatorAddress, validatorSrcAddress, validatorDstAddress, amount, }) => {
                (0, utils_1.assertDefinedAndNotNull)(amount, "missing amount");
                return {
                    delegator_address: delegatorAddress,
                    validator_src_address: validatorSrcAddress,
                    validator_dst_address: validatorDstAddress,
                    amount: amount,
                };
            },
            fromAmino: ({ delegator_address, validator_src_address, validator_dst_address, amount, }) => ({
                delegatorAddress: delegator_address,
                validatorSrcAddress: validator_src_address,
                validatorDstAddress: validator_dst_address,
                amount: amount,
            }),
        },
        "/cosmos.staking.v1beta1.MsgCreateValidator": {
            aminoType: "cosmos-sdk/MsgCreateValidator",
            toAmino: ({ description, commission, minSelfDelegation, delegatorAddress, validatorAddress, pubkey, value, }) => {
                (0, utils_1.assertDefinedAndNotNull)(description, "missing description");
                (0, utils_1.assertDefinedAndNotNull)(commission, "missing commission");
                (0, utils_1.assertDefinedAndNotNull)(pubkey, "missing pubkey");
                (0, utils_1.assertDefinedAndNotNull)(value, "missing value");
                return {
                    description: {
                        moniker: description.moniker,
                        identity: description.identity,
                        website: description.website,
                        security_contact: description.securityContact,
                        details: description.details,
                    },
                    commission: {
                        rate: protoDecimalToJson(commission.rate),
                        max_rate: protoDecimalToJson(commission.maxRate),
                        max_change_rate: protoDecimalToJson(commission.maxChangeRate),
                    },
                    min_self_delegation: minSelfDelegation,
                    delegator_address: delegatorAddress,
                    validator_address: validatorAddress,
                    pubkey: (0, proto_signing_1.anyToSinglePubkey)(pubkey),
                    value: value,
                };
            },
            fromAmino: ({ description, commission, min_self_delegation, delegator_address, validator_address, pubkey, value, }) => {
                return {
                    description: {
                        moniker: description.moniker,
                        identity: description.identity,
                        website: description.website,
                        securityContact: description.security_contact,
                        details: description.details,
                    },
                    commission: {
                        rate: jsonDecimalToProto(commission.rate),
                        maxRate: jsonDecimalToProto(commission.max_rate),
                        maxChangeRate: jsonDecimalToProto(commission.max_change_rate),
                    },
                    minSelfDelegation: min_self_delegation,
                    delegatorAddress: delegator_address,
                    validatorAddress: validator_address,
                    pubkey: (0, proto_signing_1.encodePubkey)(pubkey),
                    value: value,
                };
            },
        },
        "/cosmos.staking.v1beta1.MsgDelegate": {
            aminoType: "cosmos-sdk/MsgDelegate",
            toAmino: ({ delegatorAddress, validatorAddress, amount }) => {
                (0, utils_1.assertDefinedAndNotNull)(amount, "missing amount");
                return {
                    delegator_address: delegatorAddress,
                    validator_address: validatorAddress,
                    amount: amount,
                };
            },
            fromAmino: ({ delegator_address, validator_address, amount, }) => ({
                delegatorAddress: delegator_address,
                validatorAddress: validator_address,
                amount: amount,
            }),
        },
        "/cosmos.staking.v1beta1.MsgEditValidator": {
            aminoType: "cosmos-sdk/MsgEditValidator",
            toAmino: ({ description, commissionRate, minSelfDelegation, validatorAddress, }) => {
                (0, utils_1.assertDefinedAndNotNull)(description, "missing description");
                return {
                    description: {
                        moniker: description.moniker,
                        identity: description.identity,
                        website: description.website,
                        security_contact: description.securityContact,
                        details: description.details,
                    },
                    // empty string in the protobuf document means "do not change"
                    commission_rate: commissionRate ? protoDecimalToJson(commissionRate) : undefined,
                    // empty string in the protobuf document means "do not change"
                    min_self_delegation: minSelfDelegation ? minSelfDelegation : undefined,
                    validator_address: validatorAddress,
                };
            },
            fromAmino: ({ description, commission_rate, min_self_delegation, validator_address, }) => ({
                description: {
                    moniker: description.moniker,
                    identity: description.identity,
                    website: description.website,
                    securityContact: description.security_contact,
                    details: description.details,
                },
                // empty string in the protobuf document means "do not change"
                commissionRate: commission_rate ? jsonDecimalToProto(commission_rate) : "",
                // empty string in the protobuf document means "do not change"
                minSelfDelegation: min_self_delegation !== null && min_self_delegation !== void 0 ? min_self_delegation : "",
                validatorAddress: validator_address,
            }),
        },
        "/cosmos.staking.v1beta1.MsgUndelegate": {
            aminoType: "cosmos-sdk/MsgUndelegate",
            toAmino: ({ delegatorAddress, validatorAddress, amount, }) => {
                (0, utils_1.assertDefinedAndNotNull)(amount, "missing amount");
                return {
                    delegator_address: delegatorAddress,
                    validator_address: validatorAddress,
                    amount: amount,
                };
            },
            fromAmino: ({ delegator_address, validator_address, amount, }) => ({
                delegatorAddress: delegator_address,
                validatorAddress: validator_address,
                amount: amount,
            }),
        },
    };
}
exports.createStakingAminoConverters = createStakingAminoConverters;
//# sourceMappingURL=aminomessages.js.map

/***/ }),

/***/ 91822:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.isMsgUndelegateEncodeObject = exports.isMsgEditValidatorEncodeObject = exports.isMsgDelegateEncodeObject = exports.isMsgCreateValidatorEncodeObject = exports.isMsgBeginRedelegateEncodeObject = exports.stakingTypes = void 0;
const tx_1 = __webpack_require__(96440);
exports.stakingTypes = [
    ["/cosmos.staking.v1beta1.MsgBeginRedelegate", tx_1.MsgBeginRedelegate],
    ["/cosmos.staking.v1beta1.MsgCreateValidator", tx_1.MsgCreateValidator],
    ["/cosmos.staking.v1beta1.MsgDelegate", tx_1.MsgDelegate],
    ["/cosmos.staking.v1beta1.MsgEditValidator", tx_1.MsgEditValidator],
    ["/cosmos.staking.v1beta1.MsgUndelegate", tx_1.MsgUndelegate],
];
function isMsgBeginRedelegateEncodeObject(o) {
    return o.typeUrl === "/cosmos.staking.v1beta1.MsgBeginRedelegate";
}
exports.isMsgBeginRedelegateEncodeObject = isMsgBeginRedelegateEncodeObject;
function isMsgCreateValidatorEncodeObject(o) {
    return o.typeUrl === "/cosmos.staking.v1beta1.MsgCreateValidator";
}
exports.isMsgCreateValidatorEncodeObject = isMsgCreateValidatorEncodeObject;
function isMsgDelegateEncodeObject(object) {
    return object.typeUrl === "/cosmos.staking.v1beta1.MsgDelegate";
}
exports.isMsgDelegateEncodeObject = isMsgDelegateEncodeObject;
function isMsgEditValidatorEncodeObject(o) {
    return o.typeUrl === "/cosmos.staking.v1beta1.MsgEditValidator";
}
exports.isMsgEditValidatorEncodeObject = isMsgEditValidatorEncodeObject;
function isMsgUndelegateEncodeObject(object) {
    return object.typeUrl === "/cosmos.staking.v1beta1.MsgUndelegate";
}
exports.isMsgUndelegateEncodeObject = isMsgUndelegateEncodeObject;
//# sourceMappingURL=messages.js.map

/***/ }),

/***/ 91356:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.setupStakingExtension = void 0;
/* eslint-disable @typescript-eslint/naming-convention */
const query_1 = __webpack_require__(34082);
const long_1 = __importDefault(__webpack_require__(21305));
const queryclient_1 = __webpack_require__(22995);
function setupStakingExtension(base) {
    // Use this service to get easy typed access to query methods
    // This cannot be used for proof verification
    const rpc = (0, queryclient_1.createProtobufRpcClient)(base);
    const queryService = new query_1.QueryClientImpl(rpc);
    return {
        staking: {
            delegation: async (delegatorAddress, validatorAddress) => {
                const response = await queryService.Delegation({
                    delegatorAddr: delegatorAddress,
                    validatorAddr: validatorAddress,
                });
                return response;
            },
            delegatorDelegations: async (delegatorAddress, paginationKey) => {
                const response = await queryService.DelegatorDelegations({
                    delegatorAddr: delegatorAddress,
                    pagination: (0, queryclient_1.createPagination)(paginationKey),
                });
                return response;
            },
            delegatorUnbondingDelegations: async (delegatorAddress, paginationKey) => {
                const response = await queryService.DelegatorUnbondingDelegations({
                    delegatorAddr: delegatorAddress,
                    pagination: (0, queryclient_1.createPagination)(paginationKey),
                });
                return response;
            },
            delegatorValidator: async (delegatorAddress, validatorAddress) => {
                const response = await queryService.DelegatorValidator({
                    delegatorAddr: delegatorAddress,
                    validatorAddr: validatorAddress,
                });
                return response;
            },
            delegatorValidators: async (delegatorAddress, paginationKey) => {
                const response = await queryService.DelegatorValidators({
                    delegatorAddr: delegatorAddress,
                    pagination: (0, queryclient_1.createPagination)(paginationKey),
                });
                return response;
            },
            historicalInfo: async (height) => {
                const response = await queryService.HistoricalInfo({
                    height: long_1.default.fromNumber(height, true),
                });
                return response;
            },
            params: async () => {
                const response = await queryService.Params({});
                return response;
            },
            pool: async () => {
                const response = await queryService.Pool({});
                return response;
            },
            redelegations: async (delegatorAddress, sourceValidatorAddress, destinationValidatorAddress, paginationKey) => {
                const response = await queryService.Redelegations({
                    delegatorAddr: delegatorAddress,
                    srcValidatorAddr: sourceValidatorAddress,
                    dstValidatorAddr: destinationValidatorAddress,
                    pagination: (0, queryclient_1.createPagination)(paginationKey),
                });
                return response;
            },
            unbondingDelegation: async (delegatorAddress, validatorAddress) => {
                const response = await queryService.UnbondingDelegation({
                    delegatorAddr: delegatorAddress,
                    validatorAddr: validatorAddress,
                });
                return response;
            },
            validator: async (validatorAddress) => {
                const response = await queryService.Validator({ validatorAddr: validatorAddress });
                return response;
            },
            validatorDelegations: async (validatorAddress, paginationKey) => {
                const response = await queryService.ValidatorDelegations({
                    validatorAddr: validatorAddress,
                    pagination: (0, queryclient_1.createPagination)(paginationKey),
                });
                return response;
            },
            validators: async (status, paginationKey) => {
                const response = await queryService.Validators({
                    status: status,
                    pagination: (0, queryclient_1.createPagination)(paginationKey),
                });
                return response;
            },
            validatorUnbondingDelegations: async (validatorAddress, paginationKey) => {
                const response = await queryService.ValidatorUnbondingDelegations({
                    validatorAddr: validatorAddress,
                    pagination: (0, queryclient_1.createPagination)(paginationKey),
                });
                return response;
            },
        },
    };
}
exports.setupStakingExtension = setupStakingExtension;
//# sourceMappingURL=queries.js.map

/***/ }),

/***/ 68208:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.setupTxExtension = void 0;
const proto_signing_1 = __webpack_require__(348);
const signing_1 = __webpack_require__(94600);
const service_1 = __webpack_require__(31956);
const tx_1 = __webpack_require__(94289);
const long_1 = __importDefault(__webpack_require__(21305));
const queryclient_1 = __webpack_require__(22995);
function setupTxExtension(base) {
    // Use this service to get easy typed access to query methods
    // This cannot be used for proof verification
    const rpc = (0, queryclient_1.createProtobufRpcClient)(base);
    const queryService = new service_1.ServiceClientImpl(rpc);
    return {
        tx: {
            getTx: async (txId) => {
                const request = {
                    hash: txId,
                };
                const response = await queryService.GetTx(request);
                return response;
            },
            simulate: async (messages, memo, signer, sequence) => {
                const tx = tx_1.Tx.fromPartial({
                    authInfo: tx_1.AuthInfo.fromPartial({
                        fee: tx_1.Fee.fromPartial({}),
                        signerInfos: [
                            {
                                publicKey: (0, proto_signing_1.encodePubkey)(signer),
                                sequence: long_1.default.fromNumber(sequence, true),
                                modeInfo: { single: { mode: signing_1.SignMode.SIGN_MODE_UNSPECIFIED } },
                            },
                        ],
                    }),
                    body: tx_1.TxBody.fromPartial({
                        messages: Array.from(messages),
                        memo: memo,
                    }),
                    signatures: [new Uint8Array()],
                });
                const request = service_1.SimulateRequest.fromPartial({
                    txBytes: tx_1.Tx.encode(tx).finish(),
                });
                const response = await queryService.Simulate(request);
                return response;
            },
        },
    };
}
exports.setupTxExtension = setupTxExtension;
//# sourceMappingURL=queries.js.map

/***/ }),

/***/ 74064:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.createVestingAminoConverters = exports.isAminoMsgCreateVestingAccount = void 0;
const long_1 = __importDefault(__webpack_require__(21305));
function isAminoMsgCreateVestingAccount(msg) {
    return msg.type === "cosmos-sdk/MsgCreateVestingAccount";
}
exports.isAminoMsgCreateVestingAccount = isAminoMsgCreateVestingAccount;
function createVestingAminoConverters() {
    return {
        "/cosmos.vesting.v1beta1.MsgCreateVestingAccount": {
            aminoType: "cosmos-sdk/MsgCreateVestingAccount",
            toAmino: ({ fromAddress, toAddress, amount, endTime, delayed, }) => ({
                from_address: fromAddress,
                to_address: toAddress,
                amount: [...amount],
                end_time: endTime.toString(),
                delayed: delayed,
            }),
            fromAmino: ({ from_address, to_address, amount, end_time, delayed, }) => ({
                fromAddress: from_address,
                toAddress: to_address,
                amount: [...amount],
                endTime: long_1.default.fromString(end_time),
                delayed: delayed,
            }),
        },
    };
}
exports.createVestingAminoConverters = createVestingAminoConverters;
//# sourceMappingURL=aminomessages.js.map

/***/ }),

/***/ 6394:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.vestingTypes = void 0;
const tx_1 = __webpack_require__(32079);
exports.vestingTypes = [
    ["/cosmos.vesting.v1beta1.MsgCreateVestingAccount", tx_1.MsgCreateVestingAccount],
];
//# sourceMappingURL=messages.js.map

/***/ }),

/***/ 40709:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.makeMultisignedTxBytes = exports.makeMultisignedTx = exports.makeCompactBitArray = void 0;
const amino_1 = __webpack_require__(38190);
const encoding_1 = __webpack_require__(71555);
const proto_signing_1 = __webpack_require__(348);
const multisig_1 = __webpack_require__(76203);
const signing_1 = __webpack_require__(94600);
const tx_1 = __webpack_require__(94289);
const tx_2 = __webpack_require__(94289);
const long_1 = __importDefault(__webpack_require__(21305));
function makeCompactBitArray(bits) {
    const byteCount = Math.ceil(bits.length / 8);
    const extraBits = bits.length - Math.floor(bits.length / 8) * 8;
    const bytes = new Uint8Array(byteCount); // zero-filled
    bits.forEach((value, index) => {
        const bytePos = Math.floor(index / 8);
        const bitPos = index % 8;
        // eslint-disable-next-line no-bitwise
        if (value)
            bytes[bytePos] |= 0b1 << (8 - 1 - bitPos);
    });
    return multisig_1.CompactBitArray.fromPartial({ elems: bytes, extraBitsStored: extraBits });
}
exports.makeCompactBitArray = makeCompactBitArray;
/**
 * Creates a signed transaction from signer info, transaction body and signatures.
 * The result can be broadcasted after serialization.
 *
 * Consider using `makeMultisignedTxBytes` instead if you want to broadcast the
 * transaction immediately.
 */
function makeMultisignedTx(multisigPubkey, sequence, fee, bodyBytes, signatures) {
    const addresses = Array.from(signatures.keys());
    const prefix = (0, encoding_1.fromBech32)(addresses[0]).prefix;
    const signers = Array(multisigPubkey.value.pubkeys.length).fill(false);
    const signaturesList = new Array();
    for (let i = 0; i < multisigPubkey.value.pubkeys.length; i++) {
        const signerAddress = (0, amino_1.pubkeyToAddress)(multisigPubkey.value.pubkeys[i], prefix);
        const signature = signatures.get(signerAddress);
        if (signature) {
            signers[i] = true;
            signaturesList.push(signature);
        }
    }
    const signerInfo = {
        publicKey: (0, proto_signing_1.encodePubkey)(multisigPubkey),
        modeInfo: {
            multi: {
                bitarray: makeCompactBitArray(signers),
                modeInfos: signaturesList.map((_) => ({ single: { mode: signing_1.SignMode.SIGN_MODE_LEGACY_AMINO_JSON } })),
            },
        },
        sequence: long_1.default.fromNumber(sequence),
    };
    const authInfo = tx_1.AuthInfo.fromPartial({
        signerInfos: [signerInfo],
        fee: {
            amount: [...fee.amount],
            gasLimit: long_1.default.fromString(fee.gas),
        },
    });
    const authInfoBytes = tx_1.AuthInfo.encode(authInfo).finish();
    const signedTx = tx_2.TxRaw.fromPartial({
        bodyBytes: bodyBytes,
        authInfoBytes: authInfoBytes,
        signatures: [multisig_1.MultiSignature.encode(multisig_1.MultiSignature.fromPartial({ signatures: signaturesList })).finish()],
    });
    return signedTx;
}
exports.makeMultisignedTx = makeMultisignedTx;
/**
 * Creates a signed transaction from signer info, transaction body and signatures.
 * The result can be broadcasted.
 *
 * This is a wrapper around `makeMultisignedTx` that encodes the transaction for broadcasting.
 */
function makeMultisignedTxBytes(multisigPubkey, sequence, fee, bodyBytes, signatures) {
    const signedTx = makeMultisignedTx(multisigPubkey, sequence, fee, bodyBytes, signatures);
    return Uint8Array.from(tx_2.TxRaw.encode(signedTx).finish());
}
exports.makeMultisignedTxBytes = makeMultisignedTxBytes;
//# sourceMappingURL=multisignature.js.map

/***/ }),

/***/ 22995:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.longify = exports.decodeCosmosSdkDecFromProto = exports.createProtobufRpcClient = exports.createPagination = exports.QueryClient = void 0;
var queryclient_1 = __webpack_require__(88780);
Object.defineProperty(exports, "QueryClient", ({ enumerable: true, get: function () { return queryclient_1.QueryClient; } }));
var utils_1 = __webpack_require__(32497);
Object.defineProperty(exports, "createPagination", ({ enumerable: true, get: function () { return utils_1.createPagination; } }));
Object.defineProperty(exports, "createProtobufRpcClient", ({ enumerable: true, get: function () { return utils_1.createProtobufRpcClient; } }));
Object.defineProperty(exports, "decodeCosmosSdkDecFromProto", ({ enumerable: true, get: function () { return utils_1.decodeCosmosSdkDecFromProto; } }));
Object.defineProperty(exports, "longify", ({ enumerable: true, get: function () { return utils_1.longify; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 88780:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.QueryClient = void 0;
/* eslint-disable no-dupe-class-members, @typescript-eslint/ban-types, @typescript-eslint/naming-convention */
const ics23_1 = __webpack_require__(55201);
const encoding_1 = __webpack_require__(71555);
const stream_1 = __webpack_require__(81459);
const utils_1 = __webpack_require__(85553);
function checkAndParseOp(op, kind, key) {
    if (op.type !== kind) {
        throw new Error(`Op expected to be ${kind}, got "${op.type}`);
    }
    if (!(0, utils_1.arrayContentEquals)(key, op.key)) {
        throw new Error(`Proven key different than queried key.\nQuery: ${(0, encoding_1.toHex)(key)}\nProven: ${(0, encoding_1.toHex)(op.key)}`);
    }
    return ics23_1.ics23.CommitmentProof.decode(op.data);
}
class QueryClient {
    constructor(tmClient) {
        this.tmClient = tmClient;
    }
    static withExtensions(tmClient, ...extensionSetups) {
        const client = new QueryClient(tmClient);
        const extensions = extensionSetups.map((setupExtension) => setupExtension(client));
        for (const extension of extensions) {
            (0, utils_1.assert)((0, utils_1.isNonNullObject)(extension), `Extension must be a non-null object`);
            for (const [moduleKey, moduleValue] of Object.entries(extension)) {
                (0, utils_1.assert)((0, utils_1.isNonNullObject)(moduleValue), `Module must be a non-null object. Found type ${typeof moduleValue} for module "${moduleKey}".`);
                const current = client[moduleKey] || {};
                client[moduleKey] = {
                    ...current,
                    ...moduleValue,
                };
            }
        }
        return client;
    }
    async queryVerified(store, key, desiredHeight) {
        const { height, proof, value } = await this.queryRawProof(store, key, desiredHeight);
        const subProof = checkAndParseOp(proof.ops[0], "ics23:iavl", key);
        const storeProof = checkAndParseOp(proof.ops[1], "ics23:simple", (0, encoding_1.toAscii)(store));
        // this must always be existence, if the store is not a typo
        (0, utils_1.assert)(storeProof.exist);
        (0, utils_1.assert)(storeProof.exist.value);
        // this may be exist or non-exist, depends on response
        if (!value || value.length === 0) {
            // non-existence check
            (0, utils_1.assert)(subProof.nonexist);
            // the subproof must map the desired key to the "value" of the storeProof
            (0, ics23_1.verifyNonExistence)(subProof.nonexist, ics23_1.iavlSpec, storeProof.exist.value, key);
        }
        else {
            // existence check
            (0, utils_1.assert)(subProof.exist);
            (0, utils_1.assert)(subProof.exist.value);
            // the subproof must map the desired key to the "value" of the storeProof
            (0, ics23_1.verifyExistence)(subProof.exist, ics23_1.iavlSpec, storeProof.exist.value, key, value);
        }
        // the store proof must map its declared value (root of subProof) to the appHash of the next block
        const header = await this.getNextHeader(height);
        (0, ics23_1.verifyExistence)(storeProof.exist, ics23_1.tendermintSpec, header.appHash, (0, encoding_1.toAscii)(store), storeProof.exist.value);
        return value;
    }
    async queryRawProof(store, queryKey, desiredHeight) {
        var _a;
        const { key, value, height, proof, code, log } = await this.tmClient.abciQuery({
            // we need the StoreKey for the module, not the module name
            // https://github.com/cosmos/cosmos-sdk/blob/8cab43c8120fec5200c3459cbf4a92017bb6f287/x/auth/types/keys.go#L12
            path: `/store/${store}/key`,
            data: queryKey,
            prove: true,
            height: desiredHeight,
        });
        if (code) {
            throw new Error(`Query failed with (${code}): ${log}`);
        }
        if (!(0, utils_1.arrayContentEquals)(queryKey, key)) {
            throw new Error(`Response key ${(0, encoding_1.toHex)(key)} doesn't match query key ${(0, encoding_1.toHex)(queryKey)}`);
        }
        if (!height) {
            throw new Error("No query height returned");
        }
        if (!proof || proof.ops.length !== 2) {
            throw new Error(`Expected 2 proof ops, got ${(_a = proof === null || proof === void 0 ? void 0 : proof.ops.length) !== null && _a !== void 0 ? _a : 0}. Are you using stargate?`);
        }
        // we don't need the results, but we can ensure the data is the proper format
        checkAndParseOp(proof.ops[0], "ics23:iavl", key);
        checkAndParseOp(proof.ops[1], "ics23:simple", (0, encoding_1.toAscii)(store));
        return {
            key: key,
            value: value,
            height: height,
            // need to clone this: readonly input / writeable output
            proof: {
                ops: [...proof.ops],
            },
        };
    }
    async queryUnverified(path, request, desiredHeight) {
        const response = await this.tmClient.abciQuery({
            path: path,
            data: request,
            prove: false,
            height: desiredHeight,
        });
        if (response.code) {
            throw new Error(`Query failed with (${response.code}): ${response.log}`);
        }
        return response.value;
    }
    // this must return the header for height+1
    // throws an error if height is 0 or undefined
    async getNextHeader(height) {
        (0, utils_1.assertDefined)(height);
        if (height === 0) {
            throw new Error("Query returned height 0, cannot prove it");
        }
        const searchHeight = height + 1;
        let nextHeader;
        let headersSubscription;
        try {
            headersSubscription = this.tmClient.subscribeNewBlockHeader();
        }
        catch (_a) {
            // Ignore exception caused by non-WebSocket Tendermint clients
        }
        if (headersSubscription) {
            const firstHeader = await (0, stream_1.firstEvent)(headersSubscription);
            // The first header we get might not be n+1 but n+2 or even higher. In such cases we fall back on a query.
            if (firstHeader.height === searchHeight) {
                nextHeader = firstHeader;
            }
        }
        while (!nextHeader) {
            // start from current height to avoid backend error for minHeight in the future
            const correctHeader = (await this.tmClient.blockchain(height, searchHeight)).blockMetas
                .map((meta) => meta.header)
                .find((h) => h.height === searchHeight);
            if (correctHeader) {
                nextHeader = correctHeader;
            }
            else {
                await (0, utils_1.sleep)(1000);
            }
        }
        (0, utils_1.assert)(nextHeader.height === searchHeight, "Got wrong header. This is a bug in the logic above.");
        return nextHeader;
    }
}
exports.QueryClient = QueryClient;
//# sourceMappingURL=queryclient.js.map

/***/ }),

/***/ 32497:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.decodeCosmosSdkDecFromProto = exports.longify = exports.createProtobufRpcClient = exports.createPagination = exports.toAccAddress = void 0;
const encoding_1 = __webpack_require__(71555);
const math_1 = __webpack_require__(62949);
const pagination_1 = __webpack_require__(62635);
const long_1 = __importDefault(__webpack_require__(21305));
/**
 * Takes a bech32 encoded address and returns the data part. The prefix is ignored and discarded.
 * This is called AccAddress in Cosmos SDK, which is basically an alias for raw binary data.
 * The result is typically 20 bytes long but not restricted to that.
 */
function toAccAddress(address) {
    return (0, encoding_1.fromBech32)(address).data;
}
exports.toAccAddress = toAccAddress;
/**
 * If paginationKey is set, return a `PageRequest` with the given key.
 * If paginationKey is unset, return `undefined`.
 *
 * Use this with a query response's pagination next key to
 * request the next page.
 */
function createPagination(paginationKey) {
    return paginationKey ? pagination_1.PageRequest.fromPartial({ key: paginationKey }) : undefined;
}
exports.createPagination = createPagination;
function createProtobufRpcClient(base) {
    return {
        request: (service, method, data) => {
            const path = `/${service}/${method}`;
            return base.queryUnverified(path, data);
        },
    };
}
exports.createProtobufRpcClient = createProtobufRpcClient;
/**
 * Takes a uint64 value as string, number, Long or Uint64 and returns an unsigned Long instance
 * of it.
 */
function longify(value) {
    const checkedValue = math_1.Uint64.fromString(value.toString());
    return long_1.default.fromBytesBE([...checkedValue.toBytesBigEndian()], true);
}
exports.longify = longify;
/**
 * Takes a string or binary encoded `github.com/cosmos/cosmos-sdk/types.Dec` from the
 * protobuf API and converts it into a `Decimal` with 18 fractional digits.
 *
 * See https://github.com/cosmos/cosmos-sdk/issues/10863 for more context why this is needed.
 */
function decodeCosmosSdkDecFromProto(input) {
    const asString = typeof input === "string" ? input : (0, encoding_1.fromAscii)(input);
    return math_1.Decimal.fromAtomics(asString, 18);
}
exports.decodeCosmosSdkDecFromProto = decodeCosmosSdkDecFromProto;
//# sourceMappingURL=utils.js.map

/***/ }),

/***/ 2018:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.isSearchByTagsQuery = exports.isSearchBySentFromOrToQuery = exports.isSearchByHeightQuery = void 0;
function isSearchByHeightQuery(query) {
    return query.height !== undefined;
}
exports.isSearchByHeightQuery = isSearchByHeightQuery;
function isSearchBySentFromOrToQuery(query) {
    return query.sentFromOrTo !== undefined;
}
exports.isSearchBySentFromOrToQuery = isSearchBySentFromOrToQuery;
function isSearchByTagsQuery(query) {
    return query.tags !== undefined;
}
exports.isSearchByTagsQuery = isSearchByTagsQuery;
//# sourceMappingURL=search.js.map

/***/ }),

/***/ 48744:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.SigningStargateClient = exports.defaultRegistryTypes = void 0;
const amino_1 = __webpack_require__(38190);
const encoding_1 = __webpack_require__(71555);
const math_1 = __webpack_require__(62949);
const proto_signing_1 = __webpack_require__(348);
const tendermint_rpc_1 = __webpack_require__(13482);
const utils_1 = __webpack_require__(85553);
const coin_1 = __webpack_require__(26119);
const tx_1 = __webpack_require__(42632);
const tx_2 = __webpack_require__(96440);
const signing_1 = __webpack_require__(94600);
const tx_3 = __webpack_require__(94289);
const tx_4 = __webpack_require__(38848);
const long_1 = __importDefault(__webpack_require__(21305));
const aminotypes_1 = __webpack_require__(88825);
const fee_1 = __webpack_require__(44458);
const modules_1 = __webpack_require__(95689);
const modules_2 = __webpack_require__(95689);
const stargateclient_1 = __webpack_require__(61503);
exports.defaultRegistryTypes = [
    ["/cosmos.base.v1beta1.Coin", coin_1.Coin],
    ...modules_1.authzTypes,
    ...modules_1.bankTypes,
    ...modules_1.distributionTypes,
    ...modules_1.feegrantTypes,
    ...modules_1.govTypes,
    ...modules_1.stakingTypes,
    ...modules_1.ibcTypes,
    ...modules_1.vestingTypes,
];
function createDefaultRegistry() {
    return new proto_signing_1.Registry(exports.defaultRegistryTypes);
}
function createDefaultTypes(prefix) {
    return {
        ...(0, modules_2.createAuthzAminoConverters)(),
        ...(0, modules_2.createBankAminoConverters)(),
        ...(0, modules_2.createDistributionAminoConverters)(),
        ...(0, modules_2.createGovAminoConverters)(),
        ...(0, modules_2.createStakingAminoConverters)(prefix),
        ...(0, modules_2.createIbcAminoConverters)(),
        ...(0, modules_2.createFeegrantAminoConverters)(),
        ...(0, modules_2.createVestingAminoConverters)(),
    };
}
class SigningStargateClient extends stargateclient_1.StargateClient {
    constructor(tmClient, signer, options) {
        var _a;
        super(tmClient, options);
        // TODO: do we really want to set a default here? Ideally we could get it from the signer such that users only have to set it once.
        const prefix = (_a = options.prefix) !== null && _a !== void 0 ? _a : "cosmos";
        const { registry = createDefaultRegistry(), aminoTypes = new aminotypes_1.AminoTypes(createDefaultTypes(prefix)) } = options;
        this.registry = registry;
        this.aminoTypes = aminoTypes;
        this.signer = signer;
        this.broadcastTimeoutMs = options.broadcastTimeoutMs;
        this.broadcastPollIntervalMs = options.broadcastPollIntervalMs;
        this.gasPrice = options.gasPrice;
    }
    static async connectWithSigner(endpoint, signer, options = {}) {
        const tmClient = await tendermint_rpc_1.Tendermint34Client.connect(endpoint);
        return new SigningStargateClient(tmClient, signer, options);
    }
    /**
     * Creates a client in offline mode.
     *
     * This should only be used in niche cases where you know exactly what you're doing,
     * e.g. when building an offline signing application.
     *
     * When you try to use online functionality with such a signer, an
     * exception will be raised.
     */
    static async offline(signer, options = {}) {
        return new SigningStargateClient(undefined, signer, options);
    }
    async simulate(signerAddress, messages, memo) {
        const anyMsgs = messages.map((m) => this.registry.encodeAsAny(m));
        const accountFromSigner = (await this.signer.getAccounts()).find((account) => account.address === signerAddress);
        if (!accountFromSigner) {
            throw new Error("Failed to retrieve account from signer");
        }
        const pubkey = (0, amino_1.encodeSecp256k1Pubkey)(accountFromSigner.pubkey);
        const { sequence } = await this.getSequence(signerAddress);
        const { gasInfo } = await this.forceGetQueryClient().tx.simulate(anyMsgs, memo, pubkey, sequence);
        (0, utils_1.assertDefined)(gasInfo);
        return math_1.Uint53.fromString(gasInfo.gasUsed.toString()).toNumber();
    }
    async sendTokens(senderAddress, recipientAddress, amount, fee, memo = "") {
        const sendMsg = {
            typeUrl: "/cosmos.bank.v1beta1.MsgSend",
            value: {
                fromAddress: senderAddress,
                toAddress: recipientAddress,
                amount: [...amount],
            },
        };
        return this.signAndBroadcast(senderAddress, [sendMsg], fee, memo);
    }
    async delegateTokens(delegatorAddress, validatorAddress, amount, fee, memo = "") {
        const delegateMsg = {
            typeUrl: "/cosmos.staking.v1beta1.MsgDelegate",
            value: tx_2.MsgDelegate.fromPartial({
                delegatorAddress: delegatorAddress,
                validatorAddress: validatorAddress,
                amount: amount,
            }),
        };
        return this.signAndBroadcast(delegatorAddress, [delegateMsg], fee, memo);
    }
    async undelegateTokens(delegatorAddress, validatorAddress, amount, fee, memo = "") {
        const undelegateMsg = {
            typeUrl: "/cosmos.staking.v1beta1.MsgUndelegate",
            value: tx_2.MsgUndelegate.fromPartial({
                delegatorAddress: delegatorAddress,
                validatorAddress: validatorAddress,
                amount: amount,
            }),
        };
        return this.signAndBroadcast(delegatorAddress, [undelegateMsg], fee, memo);
    }
    async withdrawRewards(delegatorAddress, validatorAddress, fee, memo = "") {
        const withdrawMsg = {
            typeUrl: "/cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward",
            value: tx_1.MsgWithdrawDelegatorReward.fromPartial({
                delegatorAddress: delegatorAddress,
                validatorAddress: validatorAddress,
            }),
        };
        return this.signAndBroadcast(delegatorAddress, [withdrawMsg], fee, memo);
    }
    async sendIbcTokens(senderAddress, recipientAddress, transferAmount, sourcePort, sourceChannel, timeoutHeight, 
    /** timeout in seconds */
    timeoutTimestamp, fee, memo = "") {
        const timeoutTimestampNanoseconds = timeoutTimestamp
            ? long_1.default.fromNumber(timeoutTimestamp).multiply(1000000000)
            : undefined;
        const transferMsg = {
            typeUrl: "/ibc.applications.transfer.v1.MsgTransfer",
            value: tx_4.MsgTransfer.fromPartial({
                sourcePort: sourcePort,
                sourceChannel: sourceChannel,
                sender: senderAddress,
                receiver: recipientAddress,
                token: transferAmount,
                timeoutHeight: timeoutHeight,
                timeoutTimestamp: timeoutTimestampNanoseconds,
            }),
        };
        return this.signAndBroadcast(senderAddress, [transferMsg], fee, memo);
    }
    async signAndBroadcast(signerAddress, messages, fee, memo = "") {
        let usedFee;
        if (fee == "auto" || typeof fee === "number") {
            (0, utils_1.assertDefined)(this.gasPrice, "Gas price must be set in the client options when auto gas is used.");
            const gasEstimation = await this.simulate(signerAddress, messages, memo);
            const multiplier = typeof fee === "number" ? fee : 1.3;
            usedFee = (0, fee_1.calculateFee)(Math.round(gasEstimation * multiplier), this.gasPrice);
        }
        else {
            usedFee = fee;
        }
        const txRaw = await this.sign(signerAddress, messages, usedFee, memo);
        const txBytes = tx_3.TxRaw.encode(txRaw).finish();
        return this.broadcastTx(txBytes, this.broadcastTimeoutMs, this.broadcastPollIntervalMs);
    }
    /**
     * Gets account number and sequence from the API, creates a sign doc,
     * creates a single signature and assembles the signed transaction.
     *
     * The sign mode (SIGN_MODE_DIRECT or SIGN_MODE_LEGACY_AMINO_JSON) is determined by this client's signer.
     *
     * You can pass signer data (account number, sequence and chain ID) explicitly instead of querying them
     * from the chain. This is needed when signing for a multisig account, but it also allows for offline signing
     * (See the SigningStargateClient.offline constructor).
     */
    async sign(signerAddress, messages, fee, memo, explicitSignerData) {
        let signerData;
        if (explicitSignerData) {
            signerData = explicitSignerData;
        }
        else {
            const { accountNumber, sequence } = await this.getSequence(signerAddress);
            const chainId = await this.getChainId();
            signerData = {
                accountNumber: accountNumber,
                sequence: sequence,
                chainId: chainId,
            };
        }
        return (0, proto_signing_1.isOfflineDirectSigner)(this.signer)
            ? this.signDirect(signerAddress, messages, fee, memo, signerData)
            : this.signAmino(signerAddress, messages, fee, memo, signerData);
    }
    async signAmino(signerAddress, messages, fee, memo, { accountNumber, sequence, chainId }) {
        (0, utils_1.assert)(!(0, proto_signing_1.isOfflineDirectSigner)(this.signer));
        const accountFromSigner = (await this.signer.getAccounts()).find((account) => account.address === signerAddress);
        if (!accountFromSigner) {
            throw new Error("Failed to retrieve account from signer");
        }
        const pubkey = (0, proto_signing_1.encodePubkey)((0, amino_1.encodeSecp256k1Pubkey)(accountFromSigner.pubkey));
        const signMode = signing_1.SignMode.SIGN_MODE_LEGACY_AMINO_JSON;
        const msgs = messages.map((msg) => this.aminoTypes.toAmino(msg));
        const signDoc = (0, amino_1.makeSignDoc)(msgs, fee, chainId, memo, accountNumber, sequence);
        const { signature, signed } = await this.signer.signAmino(signerAddress, signDoc);
        const signedTxBody = {
            messages: signed.msgs.map((msg) => this.aminoTypes.fromAmino(msg)),
            memo: signed.memo,
        };
        const signedTxBodyEncodeObject = {
            typeUrl: "/cosmos.tx.v1beta1.TxBody",
            value: signedTxBody,
        };
        const signedTxBodyBytes = this.registry.encode(signedTxBodyEncodeObject);
        const signedGasLimit = math_1.Int53.fromString(signed.fee.gas).toNumber();
        const signedSequence = math_1.Int53.fromString(signed.sequence).toNumber();
        const signedAuthInfoBytes = (0, proto_signing_1.makeAuthInfoBytes)([{ pubkey, sequence: signedSequence }], signed.fee.amount, signedGasLimit, signed.fee.granter, signed.fee.payer, signMode);
        return tx_3.TxRaw.fromPartial({
            bodyBytes: signedTxBodyBytes,
            authInfoBytes: signedAuthInfoBytes,
            signatures: [(0, encoding_1.fromBase64)(signature.signature)],
        });
    }
    async signDirect(signerAddress, messages, fee, memo, { accountNumber, sequence, chainId }) {
        (0, utils_1.assert)((0, proto_signing_1.isOfflineDirectSigner)(this.signer));
        const accountFromSigner = (await this.signer.getAccounts()).find((account) => account.address === signerAddress);
        if (!accountFromSigner) {
            throw new Error("Failed to retrieve account from signer");
        }
        const pubkey = (0, proto_signing_1.encodePubkey)((0, amino_1.encodeSecp256k1Pubkey)(accountFromSigner.pubkey));
        const txBodyEncodeObject = {
            typeUrl: "/cosmos.tx.v1beta1.TxBody",
            value: {
                messages: messages,
                memo: memo,
            },
        };
        const txBodyBytes = this.registry.encode(txBodyEncodeObject);
        const gasLimit = math_1.Int53.fromString(fee.gas).toNumber();
        const authInfoBytes = (0, proto_signing_1.makeAuthInfoBytes)([{ pubkey, sequence }], fee.amount, gasLimit, fee.granter, fee.payer);
        const signDoc = (0, proto_signing_1.makeSignDoc)(txBodyBytes, authInfoBytes, chainId, accountNumber);
        const { signature, signed } = await this.signer.signDirect(signerAddress, signDoc);
        return tx_3.TxRaw.fromPartial({
            bodyBytes: signed.bodyBytes,
            authInfoBytes: signed.authInfoBytes,
            signatures: [(0, encoding_1.fromBase64)(signature.signature)],
        });
    }
}
exports.SigningStargateClient = SigningStargateClient;
//# sourceMappingURL=signingstargateclient.js.map

/***/ }),

/***/ 61503:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.StargateClient = exports.BroadcastTxError = exports.assertIsDeliverTxFailure = exports.assertIsDeliverTxSuccess = exports.isDeliverTxSuccess = exports.isDeliverTxFailure = exports.TimeoutError = void 0;
/* eslint-disable @typescript-eslint/naming-convention */
const amino_1 = __webpack_require__(38190);
const encoding_1 = __webpack_require__(71555);
const math_1 = __webpack_require__(62949);
const tendermint_rpc_1 = __webpack_require__(13482);
const utils_1 = __webpack_require__(85553);
const accounts_1 = __webpack_require__(48433);
const events_1 = __webpack_require__(1225);
const modules_1 = __webpack_require__(95689);
const queryclient_1 = __webpack_require__(22995);
const search_1 = __webpack_require__(2018);
class TimeoutError extends Error {
    constructor(message, txId) {
        super(message);
        this.txId = txId;
    }
}
exports.TimeoutError = TimeoutError;
function isDeliverTxFailure(result) {
    return !!result.code;
}
exports.isDeliverTxFailure = isDeliverTxFailure;
function isDeliverTxSuccess(result) {
    return !isDeliverTxFailure(result);
}
exports.isDeliverTxSuccess = isDeliverTxSuccess;
/**
 * Ensures the given result is a success. Throws a detailed error message otherwise.
 */
function assertIsDeliverTxSuccess(result) {
    if (isDeliverTxFailure(result)) {
        throw new Error(`Error when broadcasting tx ${result.transactionHash} at height ${result.height}. Code: ${result.code}; Raw log: ${result.rawLog}`);
    }
}
exports.assertIsDeliverTxSuccess = assertIsDeliverTxSuccess;
/**
 * Ensures the given result is a failure. Throws a detailed error message otherwise.
 */
function assertIsDeliverTxFailure(result) {
    if (isDeliverTxSuccess(result)) {
        throw new Error(`Transaction ${result.transactionHash} did not fail at height ${result.height}. Code: ${result.code}; Raw log: ${result.rawLog}`);
    }
}
exports.assertIsDeliverTxFailure = assertIsDeliverTxFailure;
/**
 * An error when broadcasting the transaction. This contains the CheckTx errors
 * from the blockchain. Once a transaction is included in a block no BroadcastTxError
 * is thrown, even if the execution fails (DeliverTx errors).
 */
class BroadcastTxError extends Error {
    constructor(code, codespace, log) {
        super(`Broadcasting transaction failed with code ${code} (codespace: ${codespace}). Log: ${log}`);
        this.code = code;
        this.codespace = codespace;
        this.log = log;
    }
}
exports.BroadcastTxError = BroadcastTxError;
class StargateClient {
    constructor(tmClient, options) {
        if (tmClient) {
            this.tmClient = tmClient;
            this.queryClient = queryclient_1.QueryClient.withExtensions(tmClient, modules_1.setupAuthExtension, modules_1.setupBankExtension, modules_1.setupStakingExtension, modules_1.setupTxExtension);
        }
        const { accountParser = accounts_1.accountFromAny } = options;
        this.accountParser = accountParser;
    }
    static async connect(endpoint, options = {}) {
        const tmClient = await tendermint_rpc_1.Tendermint34Client.connect(endpoint);
        return new StargateClient(tmClient, options);
    }
    getTmClient() {
        return this.tmClient;
    }
    forceGetTmClient() {
        if (!this.tmClient) {
            throw new Error("Tendermint client not available. You cannot use online functionality in offline mode.");
        }
        return this.tmClient;
    }
    getQueryClient() {
        return this.queryClient;
    }
    forceGetQueryClient() {
        if (!this.queryClient) {
            throw new Error("Query client not available. You cannot use online functionality in offline mode.");
        }
        return this.queryClient;
    }
    async getChainId() {
        if (!this.chainId) {
            const response = await this.forceGetTmClient().status();
            const chainId = response.nodeInfo.network;
            if (!chainId)
                throw new Error("Chain ID must not be empty");
            this.chainId = chainId;
        }
        return this.chainId;
    }
    async getHeight() {
        const status = await this.forceGetTmClient().status();
        return status.syncInfo.latestBlockHeight;
    }
    async getAccount(searchAddress) {
        try {
            const account = await this.forceGetQueryClient().auth.account(searchAddress);
            return account ? this.accountParser(account) : null;
        }
        catch (error) {
            if (/rpc error: code = NotFound/i.test(error.toString())) {
                return null;
            }
            throw error;
        }
    }
    async getSequence(address) {
        const account = await this.getAccount(address);
        if (!account) {
            throw new Error(`Account '${address}' does not exist on chain. Send some tokens there before trying to query sequence.`);
        }
        return {
            accountNumber: account.accountNumber,
            sequence: account.sequence,
        };
    }
    async getBlock(height) {
        const response = await this.forceGetTmClient().block(height);
        return {
            id: (0, encoding_1.toHex)(response.blockId.hash).toUpperCase(),
            header: {
                version: {
                    block: new math_1.Uint53(response.block.header.version.block).toString(),
                    app: new math_1.Uint53(response.block.header.version.app).toString(),
                },
                height: response.block.header.height,
                chainId: response.block.header.chainId,
                time: (0, tendermint_rpc_1.toRfc3339WithNanoseconds)(response.block.header.time),
            },
            txs: response.block.txs,
        };
    }
    async getBalance(address, searchDenom) {
        return this.forceGetQueryClient().bank.balance(address, searchDenom);
    }
    /**
     * Queries all balances for all denoms that belong to this address.
     *
     * Uses the grpc queries (which iterates over the store internally), and we cannot get
     * proofs from such a method.
     */
    async getAllBalances(address) {
        return this.forceGetQueryClient().bank.allBalances(address);
    }
    async getBalanceStaked(address) {
        const allDelegations = [];
        let startAtKey = undefined;
        do {
            const { delegationResponses, pagination } = await this.forceGetQueryClient().staking.delegatorDelegations(address, startAtKey);
            const loadedDelegations = delegationResponses || [];
            allDelegations.push(...loadedDelegations);
            startAtKey = pagination === null || pagination === void 0 ? void 0 : pagination.nextKey;
        } while (startAtKey !== undefined && startAtKey.length !== 0);
        const sumValues = allDelegations.reduce((previousValue, currentValue) => {
            // Safe because field is set to non-nullable (https://github.com/cosmos/cosmos-sdk/blob/v0.45.3/proto/cosmos/staking/v1beta1/staking.proto#L295)
            (0, utils_1.assert)(currentValue.balance);
            return previousValue !== null ? (0, amino_1.addCoins)(previousValue, currentValue.balance) : currentValue.balance;
        }, null);
        return sumValues;
    }
    async getDelegation(delegatorAddress, validatorAddress) {
        var _a;
        let delegatedAmount;
        try {
            delegatedAmount = (_a = (await this.forceGetQueryClient().staking.delegation(delegatorAddress, validatorAddress)).delegationResponse) === null || _a === void 0 ? void 0 : _a.balance;
        }
        catch (e) {
            if (e.toString().includes("key not found")) {
                // ignore, `delegatedAmount` remains undefined
            }
            else {
                throw e;
            }
        }
        return delegatedAmount || null;
    }
    async getTx(id) {
        var _a;
        const results = await this.txsQuery(`tx.hash='${id}'`);
        return (_a = results[0]) !== null && _a !== void 0 ? _a : null;
    }
    async searchTx(query, filter = {}) {
        const minHeight = filter.minHeight || 0;
        const maxHeight = filter.maxHeight || Number.MAX_SAFE_INTEGER;
        if (maxHeight < minHeight)
            return []; // optional optimization
        function withFilters(originalQuery) {
            return `${originalQuery} AND tx.height>=${minHeight} AND tx.height<=${maxHeight}`;
        }
        let txs;
        if ((0, search_1.isSearchByHeightQuery)(query)) {
            txs =
                query.height >= minHeight && query.height <= maxHeight
                    ? await this.txsQuery(`tx.height=${query.height}`)
                    : [];
        }
        else if ((0, search_1.isSearchBySentFromOrToQuery)(query)) {
            const sentQuery = withFilters(`message.module='bank' AND transfer.sender='${query.sentFromOrTo}'`);
            const receivedQuery = withFilters(`message.module='bank' AND transfer.recipient='${query.sentFromOrTo}'`);
            const [sent, received] = await Promise.all([sentQuery, receivedQuery].map((rawQuery) => this.txsQuery(rawQuery)));
            const sentHashes = sent.map((t) => t.hash);
            txs = [...sent, ...received.filter((t) => !sentHashes.includes(t.hash))];
        }
        else if ((0, search_1.isSearchByTagsQuery)(query)) {
            const rawQuery = withFilters(query.tags.map((t) => `${t.key}='${t.value}'`).join(" AND "));
            txs = await this.txsQuery(rawQuery);
        }
        else {
            throw new Error("Unknown query type");
        }
        const filtered = txs.filter((tx) => tx.height >= minHeight && tx.height <= maxHeight);
        return filtered;
    }
    disconnect() {
        if (this.tmClient)
            this.tmClient.disconnect();
    }
    /**
     * Broadcasts a signed transaction to the network and monitors its inclusion in a block.
     *
     * If broadcasting is rejected by the node for some reason (e.g. because of a CheckTx failure),
     * an error is thrown.
     *
     * If the transaction is not included in a block before the provided timeout, this errors with a `TimeoutError`.
     *
     * If the transaction is included in a block, a `DeliverTxResponse` is returned. The caller then
     * usually needs to check for execution success or failure.
     */
    async broadcastTx(tx, timeoutMs = 60000, pollIntervalMs = 3000) {
        var _a;
        let timedOut = false;
        const txPollTimeout = setTimeout(() => {
            timedOut = true;
        }, timeoutMs);
        const pollForTx = async (txId) => {
            if (timedOut) {
                throw new TimeoutError(`Transaction with ID ${txId} was submitted but was not yet found on the chain. You might want to check later. There was a wait of ${timeoutMs / 1000} seconds.`, txId);
            }
            await (0, utils_1.sleep)(pollIntervalMs);
            const result = await this.getTx(txId);
            return result
                ? {
                    code: result.code,
                    height: result.height,
                    events: result.events,
                    rawLog: result.rawLog,
                    transactionHash: txId,
                    gasUsed: result.gasUsed,
                    gasWanted: result.gasWanted,
                }
                : pollForTx(txId);
        };
        const broadcasted = await this.forceGetTmClient().broadcastTxSync({ tx });
        if (broadcasted.code) {
            return Promise.reject(new BroadcastTxError(broadcasted.code, (_a = broadcasted.codespace) !== null && _a !== void 0 ? _a : "", broadcasted.log));
        }
        const transactionId = (0, encoding_1.toHex)(broadcasted.hash).toUpperCase();
        return new Promise((resolve, reject) => pollForTx(transactionId).then((value) => {
            clearTimeout(txPollTimeout);
            resolve(value);
        }, (error) => {
            clearTimeout(txPollTimeout);
            reject(error);
        }));
    }
    async txsQuery(query) {
        const results = await this.forceGetTmClient().txSearchAll({ query: query });
        return results.txs.map((tx) => {
            return {
                height: tx.height,
                hash: (0, encoding_1.toHex)(tx.hash).toUpperCase(),
                code: tx.result.code,
                events: tx.result.events.map(events_1.fromTendermint34Event),
                rawLog: tx.result.log || "",
                tx: tx.tx,
                gasUsed: tx.result.gasUsed,
                gasWanted: tx.result.gasWanted,
            };
        });
    }
}
exports.StargateClient = StargateClient;
//# sourceMappingURL=stargateclient.js.map

/***/ }),

/***/ 63588:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

// See https://github.com/tendermint/tendermint/blob/f2ada0a604b4c0763bda2f64fac53d506d3beca7/docs/spec/blockchain/encoding.md#public-key-cryptography
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.pubkeyToAddress = exports.pubkeyToRawAddress = exports.rawSecp256k1PubkeyToRawAddress = exports.rawEd25519PubkeyToRawAddress = void 0;
const crypto_1 = __webpack_require__(79562);
const encoding_1 = __webpack_require__(71555);
const encoding_2 = __webpack_require__(33590);
const pubkeys_1 = __webpack_require__(84106);
function rawEd25519PubkeyToRawAddress(pubkeyData) {
    if (pubkeyData.length !== 32) {
        throw new Error(`Invalid Ed25519 pubkey length: ${pubkeyData.length}`);
    }
    return (0, crypto_1.sha256)(pubkeyData).slice(0, 20);
}
exports.rawEd25519PubkeyToRawAddress = rawEd25519PubkeyToRawAddress;
function rawSecp256k1PubkeyToRawAddress(pubkeyData) {
    if (pubkeyData.length !== 33) {
        throw new Error(`Invalid Secp256k1 pubkey length (compressed): ${pubkeyData.length}`);
    }
    return (0, crypto_1.ripemd160)((0, crypto_1.sha256)(pubkeyData));
}
exports.rawSecp256k1PubkeyToRawAddress = rawSecp256k1PubkeyToRawAddress;
// For secp256k1 this assumes we already have a compressed pubkey.
function pubkeyToRawAddress(pubkey) {
    if ((0, pubkeys_1.isSecp256k1Pubkey)(pubkey)) {
        const pubkeyData = (0, encoding_1.fromBase64)(pubkey.value);
        return rawSecp256k1PubkeyToRawAddress(pubkeyData);
    }
    else if ((0, pubkeys_1.isEd25519Pubkey)(pubkey)) {
        const pubkeyData = (0, encoding_1.fromBase64)(pubkey.value);
        return rawEd25519PubkeyToRawAddress(pubkeyData);
    }
    else if ((0, pubkeys_1.isMultisigThresholdPubkey)(pubkey)) {
        // https://github.com/tendermint/tendermint/blob/38b401657e4ad7a7eeb3c30a3cbf512037df3740/crypto/multisig/threshold_pubkey.go#L71-L74
        const pubkeyData = (0, encoding_2.encodeAminoPubkey)(pubkey);
        return (0, crypto_1.sha256)(pubkeyData).slice(0, 20);
    }
    else {
        throw new Error("Unsupported public key type");
    }
}
exports.pubkeyToRawAddress = pubkeyToRawAddress;
function pubkeyToAddress(pubkey, prefix) {
    return (0, encoding_1.toBech32)(prefix, pubkeyToRawAddress(pubkey));
}
exports.pubkeyToAddress = pubkeyToAddress;
//# sourceMappingURL=addresses.js.map

/***/ }),

/***/ 38330:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.addCoins = exports.parseCoins = exports.coins = exports.coin = void 0;
const math_1 = __webpack_require__(62949);
/**
 * Creates a coin.
 *
 * If your values do not exceed the safe integer range of JS numbers (53 bit),
 * you can use the number type here. This is the case for all typical Cosmos SDK
 * chains that use the default 6 decimals.
 *
 * In case you need to supportr larger values, use unsigned integer strings instead.
 */
function coin(amount, denom) {
    let outAmount;
    if (typeof amount === "number") {
        try {
            outAmount = new math_1.Uint53(amount).toString();
        }
        catch (_err) {
            throw new Error("Given amount is not a safe integer. Consider using a string instead to overcome the limitations of JS numbers.");
        }
    }
    else {
        if (!amount.match(/^[0-9]+$/)) {
            throw new Error("Invalid unsigned integer string format");
        }
        outAmount = amount.replace(/^0*/, "") || "0";
    }
    return {
        amount: outAmount,
        denom: denom,
    };
}
exports.coin = coin;
/**
 * Creates a list of coins with one element.
 */
function coins(amount, denom) {
    return [coin(amount, denom)];
}
exports.coins = coins;
/**
 * Takes a coins list like "819966000ucosm,700000000ustake" and parses it.
 *
 * A Stargate-ready variant of this function is available via:
 *
 * ```
 * import { parseCoins } from "@cosmjs/proto-signing";
 * // or
 * import { parseCoins } from "@cosmjs/stargate";
 * ```
 */
function parseCoins(input) {
    return input
        .replace(/\s/g, "")
        .split(",")
        .filter(Boolean)
        .map((part) => {
        const match = part.match(/^([0-9]+)([a-zA-Z]+)/);
        if (!match)
            throw new Error("Got an invalid coin string");
        return {
            amount: match[1].replace(/^0+/, "") || "0",
            denom: match[2],
        };
    });
}
exports.parseCoins = parseCoins;
/**
 * Function to sum up coins with type Coin
 */
function addCoins(lhs, rhs) {
    if (lhs.denom !== rhs.denom)
        throw new Error("Trying to add two coins with different denoms");
    return {
        amount: math_1.Decimal.fromAtomics(lhs.amount, 0).plus(math_1.Decimal.fromAtomics(rhs.amount, 0)).atomics,
        denom: lhs.denom,
    };
}
exports.addCoins = addCoins;
//# sourceMappingURL=coins.js.map

/***/ }),

/***/ 33590:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.encodeBech32Pubkey = exports.encodeAminoPubkey = exports.decodeBech32Pubkey = exports.decodeAminoPubkey = exports.encodeEd25519Pubkey = exports.encodeSecp256k1Pubkey = void 0;
const encoding_1 = __webpack_require__(71555);
const math_1 = __webpack_require__(62949);
const utils_1 = __webpack_require__(85553);
const pubkeys_1 = __webpack_require__(84106);
/**
 * Takes a Secp256k1 public key as raw bytes and returns the Amino JSON
 * representation of it (the type/value wrapper object).
 */
function encodeSecp256k1Pubkey(pubkey) {
    if (pubkey.length !== 33 || (pubkey[0] !== 0x02 && pubkey[0] !== 0x03)) {
        throw new Error("Public key must be compressed secp256k1, i.e. 33 bytes starting with 0x02 or 0x03");
    }
    return {
        type: pubkeys_1.pubkeyType.secp256k1,
        value: (0, encoding_1.toBase64)(pubkey),
    };
}
exports.encodeSecp256k1Pubkey = encodeSecp256k1Pubkey;
/**
 * Takes an Edd25519 public key as raw bytes and returns the Amino JSON
 * representation of it (the type/value wrapper object).
 */
function encodeEd25519Pubkey(pubkey) {
    if (pubkey.length !== 32) {
        throw new Error("Ed25519 public key must be 32 bytes long");
    }
    return {
        type: pubkeys_1.pubkeyType.ed25519,
        value: (0, encoding_1.toBase64)(pubkey),
    };
}
exports.encodeEd25519Pubkey = encodeEd25519Pubkey;
// As discussed in https://github.com/binance-chain/javascript-sdk/issues/163
// Prefixes listed here: https://github.com/tendermint/tendermint/blob/d419fffe18531317c28c29a292ad7d253f6cafdf/docs/spec/blockchain/encoding.md#public-key-cryptography
// Last bytes is varint-encoded length prefix
const pubkeyAminoPrefixSecp256k1 = (0, encoding_1.fromHex)("eb5ae987" + "21" /* fixed length */);
const pubkeyAminoPrefixEd25519 = (0, encoding_1.fromHex)("1624de64" + "20" /* fixed length */);
const pubkeyAminoPrefixSr25519 = (0, encoding_1.fromHex)("0dfb1005" + "20" /* fixed length */);
/** See https://github.com/tendermint/tendermint/commit/38b401657e4ad7a7eeb3c30a3cbf512037df3740 */
const pubkeyAminoPrefixMultisigThreshold = (0, encoding_1.fromHex)("22c1f7e2" /* variable length not included */);
/**
 * Decodes a pubkey in the Amino binary format to a type/value object.
 */
function decodeAminoPubkey(data) {
    if ((0, utils_1.arrayContentStartsWith)(data, pubkeyAminoPrefixSecp256k1)) {
        const rest = data.slice(pubkeyAminoPrefixSecp256k1.length);
        if (rest.length !== 33) {
            throw new Error("Invalid rest data length. Expected 33 bytes (compressed secp256k1 pubkey).");
        }
        return {
            type: pubkeys_1.pubkeyType.secp256k1,
            value: (0, encoding_1.toBase64)(rest),
        };
    }
    else if ((0, utils_1.arrayContentStartsWith)(data, pubkeyAminoPrefixEd25519)) {
        const rest = data.slice(pubkeyAminoPrefixEd25519.length);
        if (rest.length !== 32) {
            throw new Error("Invalid rest data length. Expected 32 bytes (Ed25519 pubkey).");
        }
        return {
            type: pubkeys_1.pubkeyType.ed25519,
            value: (0, encoding_1.toBase64)(rest),
        };
    }
    else if ((0, utils_1.arrayContentStartsWith)(data, pubkeyAminoPrefixSr25519)) {
        const rest = data.slice(pubkeyAminoPrefixSr25519.length);
        if (rest.length !== 32) {
            throw new Error("Invalid rest data length. Expected 32 bytes (Sr25519 pubkey).");
        }
        return {
            type: pubkeys_1.pubkeyType.sr25519,
            value: (0, encoding_1.toBase64)(rest),
        };
    }
    else if ((0, utils_1.arrayContentStartsWith)(data, pubkeyAminoPrefixMultisigThreshold)) {
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        return decodeMultisigPubkey(data);
    }
    else {
        throw new Error("Unsupported public key type. Amino data starts with: " + (0, encoding_1.toHex)(data.slice(0, 5)));
    }
}
exports.decodeAminoPubkey = decodeAminoPubkey;
/**
 * Decodes a bech32 pubkey to Amino binary, which is then decoded to a type/value object.
 * The bech32 prefix is ignored and discareded.
 *
 * @param bechEncoded the bech32 encoded pubkey
 */
function decodeBech32Pubkey(bechEncoded) {
    const { data } = (0, encoding_1.fromBech32)(bechEncoded);
    return decodeAminoPubkey(data);
}
exports.decodeBech32Pubkey = decodeBech32Pubkey;
/**
 * Uvarint decoder for Amino.
 * @see https://github.com/tendermint/go-amino/blob/8e779b71f40d175/decoder.go#L64-76
 * @returns varint as number, and bytes count occupied by varaint
 */
function decodeUvarint(reader) {
    if (reader.length < 1) {
        throw new Error("Can't decode varint. EOF");
    }
    if (reader[0] > 127) {
        throw new Error("Decoding numbers > 127 is not supported here. Please tell those lazy CosmJS maintainers to port the binary.Varint implementation from the Go standard library and write some tests.");
    }
    return [reader[0], 1];
}
/**
 * Decodes a multisig pubkey to type object.
 * Pubkey structure [ prefix + const + threshold + loop:(const + pubkeyLength + pubkey            ) ]
 *                  [   4b   + 1b    +  varint   + loop:(1b    +    varint    + pubkeyLength bytes) ]
 * @param data encoded pubkey
 */
function decodeMultisigPubkey(data) {
    const reader = Array.from(data);
    // remove multisig amino prefix;
    const prefixFromReader = reader.splice(0, pubkeyAminoPrefixMultisigThreshold.length);
    if (!(0, utils_1.arrayContentStartsWith)(prefixFromReader, pubkeyAminoPrefixMultisigThreshold)) {
        throw new Error("Invalid multisig prefix.");
    }
    // remove 0x08 threshold prefix;
    if (reader.shift() != 0x08) {
        throw new Error("Invalid multisig data. Expecting 0x08 prefix before threshold.");
    }
    // read threshold
    const [threshold, thresholdBytesLength] = decodeUvarint(reader);
    reader.splice(0, thresholdBytesLength);
    // read participants pubkeys
    const pubkeys = [];
    while (reader.length > 0) {
        // remove 0x12 threshold prefix;
        if (reader.shift() != 0x12) {
            throw new Error("Invalid multisig data. Expecting 0x12 prefix before participant pubkey length.");
        }
        // read pubkey length
        const [pubkeyLength, pubkeyLengthBytesSize] = decodeUvarint(reader);
        reader.splice(0, pubkeyLengthBytesSize);
        // verify that we can read pubkey
        if (reader.length < pubkeyLength) {
            throw new Error("Invalid multisig data length.");
        }
        // read and decode participant pubkey
        const encodedPubkey = reader.splice(0, pubkeyLength);
        const pubkey = decodeAminoPubkey(Uint8Array.from(encodedPubkey));
        pubkeys.push(pubkey);
    }
    return {
        type: pubkeys_1.pubkeyType.multisigThreshold,
        value: {
            threshold: threshold.toString(),
            pubkeys: pubkeys,
        },
    };
}
/**
 * Uvarint encoder for Amino. This is the same encoding as `binary.PutUvarint` from the Go
 * standard library.
 *
 * @see https://github.com/tendermint/go-amino/blob/8e779b71f40d175/encoder.go#L77-L85
 */
function encodeUvarint(value) {
    const checked = math_1.Uint53.fromString(value.toString()).toNumber();
    if (checked > 127) {
        throw new Error("Encoding numbers > 127 is not supported here. Please tell those lazy CosmJS maintainers to port the binary.PutUvarint implementation from the Go standard library and write some tests.");
    }
    return [checked];
}
/**
 * Encodes a public key to binary Amino.
 */
function encodeAminoPubkey(pubkey) {
    if ((0, pubkeys_1.isMultisigThresholdPubkey)(pubkey)) {
        const out = Array.from(pubkeyAminoPrefixMultisigThreshold);
        out.push(0x08); // TODO: What is this?
        out.push(...encodeUvarint(pubkey.value.threshold));
        for (const pubkeyData of pubkey.value.pubkeys.map((p) => encodeAminoPubkey(p))) {
            out.push(0x12); // TODO: What is this?
            out.push(...encodeUvarint(pubkeyData.length));
            out.push(...pubkeyData);
        }
        return new Uint8Array(out);
    }
    else if ((0, pubkeys_1.isEd25519Pubkey)(pubkey)) {
        return new Uint8Array([...pubkeyAminoPrefixEd25519, ...(0, encoding_1.fromBase64)(pubkey.value)]);
    }
    else if ((0, pubkeys_1.isSecp256k1Pubkey)(pubkey)) {
        return new Uint8Array([...pubkeyAminoPrefixSecp256k1, ...(0, encoding_1.fromBase64)(pubkey.value)]);
    }
    else {
        throw new Error("Unsupported pubkey type");
    }
}
exports.encodeAminoPubkey = encodeAminoPubkey;
/**
 * Encodes a public key to binary Amino and then to bech32.
 *
 * @param pubkey the public key to encode
 * @param prefix the bech32 prefix (human readable part)
 */
function encodeBech32Pubkey(pubkey, prefix) {
    return (0, encoding_1.toBech32)(prefix, encodeAminoPubkey(pubkey));
}
exports.encodeBech32Pubkey = encodeBech32Pubkey;
//# sourceMappingURL=encoding.js.map

/***/ }),

/***/ 38190:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.executeKdf = exports.makeStdTx = exports.isStdTx = exports.serializeSignDoc = exports.makeSignDoc = exports.encodeSecp256k1Signature = exports.decodeSignature = exports.Secp256k1Wallet = exports.Secp256k1HdWallet = exports.extractKdfConfiguration = exports.pubkeyType = exports.isSinglePubkey = exports.isSecp256k1Pubkey = exports.isMultisigThresholdPubkey = exports.isEd25519Pubkey = exports.makeCosmoshubPath = exports.createMultisigThresholdPubkey = exports.encodeSecp256k1Pubkey = exports.encodeEd25519Pubkey = exports.encodeBech32Pubkey = exports.encodeAminoPubkey = exports.decodeBech32Pubkey = exports.decodeAminoPubkey = exports.parseCoins = exports.coins = exports.coin = exports.addCoins = exports.rawSecp256k1PubkeyToRawAddress = exports.rawEd25519PubkeyToRawAddress = exports.pubkeyToRawAddress = exports.pubkeyToAddress = void 0;
var addresses_1 = __webpack_require__(63588);
Object.defineProperty(exports, "pubkeyToAddress", ({ enumerable: true, get: function () { return addresses_1.pubkeyToAddress; } }));
Object.defineProperty(exports, "pubkeyToRawAddress", ({ enumerable: true, get: function () { return addresses_1.pubkeyToRawAddress; } }));
Object.defineProperty(exports, "rawEd25519PubkeyToRawAddress", ({ enumerable: true, get: function () { return addresses_1.rawEd25519PubkeyToRawAddress; } }));
Object.defineProperty(exports, "rawSecp256k1PubkeyToRawAddress", ({ enumerable: true, get: function () { return addresses_1.rawSecp256k1PubkeyToRawAddress; } }));
var coins_1 = __webpack_require__(38330);
Object.defineProperty(exports, "addCoins", ({ enumerable: true, get: function () { return coins_1.addCoins; } }));
Object.defineProperty(exports, "coin", ({ enumerable: true, get: function () { return coins_1.coin; } }));
Object.defineProperty(exports, "coins", ({ enumerable: true, get: function () { return coins_1.coins; } }));
Object.defineProperty(exports, "parseCoins", ({ enumerable: true, get: function () { return coins_1.parseCoins; } }));
var encoding_1 = __webpack_require__(33590);
Object.defineProperty(exports, "decodeAminoPubkey", ({ enumerable: true, get: function () { return encoding_1.decodeAminoPubkey; } }));
Object.defineProperty(exports, "decodeBech32Pubkey", ({ enumerable: true, get: function () { return encoding_1.decodeBech32Pubkey; } }));
Object.defineProperty(exports, "encodeAminoPubkey", ({ enumerable: true, get: function () { return encoding_1.encodeAminoPubkey; } }));
Object.defineProperty(exports, "encodeBech32Pubkey", ({ enumerable: true, get: function () { return encoding_1.encodeBech32Pubkey; } }));
Object.defineProperty(exports, "encodeEd25519Pubkey", ({ enumerable: true, get: function () { return encoding_1.encodeEd25519Pubkey; } }));
Object.defineProperty(exports, "encodeSecp256k1Pubkey", ({ enumerable: true, get: function () { return encoding_1.encodeSecp256k1Pubkey; } }));
var multisig_1 = __webpack_require__(87633);
Object.defineProperty(exports, "createMultisigThresholdPubkey", ({ enumerable: true, get: function () { return multisig_1.createMultisigThresholdPubkey; } }));
var paths_1 = __webpack_require__(94284);
Object.defineProperty(exports, "makeCosmoshubPath", ({ enumerable: true, get: function () { return paths_1.makeCosmoshubPath; } }));
var pubkeys_1 = __webpack_require__(84106);
Object.defineProperty(exports, "isEd25519Pubkey", ({ enumerable: true, get: function () { return pubkeys_1.isEd25519Pubkey; } }));
Object.defineProperty(exports, "isMultisigThresholdPubkey", ({ enumerable: true, get: function () { return pubkeys_1.isMultisigThresholdPubkey; } }));
Object.defineProperty(exports, "isSecp256k1Pubkey", ({ enumerable: true, get: function () { return pubkeys_1.isSecp256k1Pubkey; } }));
Object.defineProperty(exports, "isSinglePubkey", ({ enumerable: true, get: function () { return pubkeys_1.isSinglePubkey; } }));
Object.defineProperty(exports, "pubkeyType", ({ enumerable: true, get: function () { return pubkeys_1.pubkeyType; } }));
var secp256k1hdwallet_1 = __webpack_require__(91220);
Object.defineProperty(exports, "extractKdfConfiguration", ({ enumerable: true, get: function () { return secp256k1hdwallet_1.extractKdfConfiguration; } }));
Object.defineProperty(exports, "Secp256k1HdWallet", ({ enumerable: true, get: function () { return secp256k1hdwallet_1.Secp256k1HdWallet; } }));
var secp256k1wallet_1 = __webpack_require__(49484);
Object.defineProperty(exports, "Secp256k1Wallet", ({ enumerable: true, get: function () { return secp256k1wallet_1.Secp256k1Wallet; } }));
var signature_1 = __webpack_require__(11895);
Object.defineProperty(exports, "decodeSignature", ({ enumerable: true, get: function () { return signature_1.decodeSignature; } }));
Object.defineProperty(exports, "encodeSecp256k1Signature", ({ enumerable: true, get: function () { return signature_1.encodeSecp256k1Signature; } }));
var signdoc_1 = __webpack_require__(14698);
Object.defineProperty(exports, "makeSignDoc", ({ enumerable: true, get: function () { return signdoc_1.makeSignDoc; } }));
Object.defineProperty(exports, "serializeSignDoc", ({ enumerable: true, get: function () { return signdoc_1.serializeSignDoc; } }));
var stdtx_1 = __webpack_require__(98671);
Object.defineProperty(exports, "isStdTx", ({ enumerable: true, get: function () { return stdtx_1.isStdTx; } }));
Object.defineProperty(exports, "makeStdTx", ({ enumerable: true, get: function () { return stdtx_1.makeStdTx; } }));
var wallet_1 = __webpack_require__(84675);
Object.defineProperty(exports, "executeKdf", ({ enumerable: true, get: function () { return wallet_1.executeKdf; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 87633:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.createMultisigThresholdPubkey = exports.compareArrays = void 0;
const encoding_1 = __webpack_require__(71555);
const math_1 = __webpack_require__(62949);
const addresses_1 = __webpack_require__(63588);
/**
 * Compare arrays lexicographically.
 *
 * Returns value < 0 if `a < b`.
 * Returns value > 0 if `a > b`.
 * Returns 0 if `a === b`.
 */
function compareArrays(a, b) {
    const aHex = (0, encoding_1.toHex)(a);
    const bHex = (0, encoding_1.toHex)(b);
    return aHex === bHex ? 0 : aHex < bHex ? -1 : 1;
}
exports.compareArrays = compareArrays;
function createMultisigThresholdPubkey(pubkeys, threshold, nosort = false) {
    const uintThreshold = new math_1.Uint53(threshold);
    if (uintThreshold.toNumber() > pubkeys.length) {
        throw new Error(`Threshold k = ${uintThreshold.toNumber()} exceeds number of keys n = ${pubkeys.length}`);
    }
    const outPubkeys = nosort
        ? pubkeys
        : Array.from(pubkeys).sort((lhs, rhs) => {
            // https://github.com/cosmos/cosmos-sdk/blob/v0.42.2/client/keys/add.go#L172-L174
            const addressLhs = (0, addresses_1.pubkeyToRawAddress)(lhs);
            const addressRhs = (0, addresses_1.pubkeyToRawAddress)(rhs);
            return compareArrays(addressLhs, addressRhs);
        });
    return {
        type: "tendermint/PubKeyMultisigThreshold",
        value: {
            threshold: uintThreshold.toString(),
            pubkeys: outPubkeys,
        },
    };
}
exports.createMultisigThresholdPubkey = createMultisigThresholdPubkey;
//# sourceMappingURL=multisig.js.map

/***/ }),

/***/ 94284:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.makeCosmoshubPath = void 0;
const crypto_1 = __webpack_require__(79562);
/**
 * The Cosmos Hub derivation path in the form `m/44'/118'/0'/0/a`
 * with 0-based account index `a`.
 */
function makeCosmoshubPath(a) {
    return [
        crypto_1.Slip10RawIndex.hardened(44),
        crypto_1.Slip10RawIndex.hardened(118),
        crypto_1.Slip10RawIndex.hardened(0),
        crypto_1.Slip10RawIndex.normal(0),
        crypto_1.Slip10RawIndex.normal(a),
    ];
}
exports.makeCosmoshubPath = makeCosmoshubPath;
//# sourceMappingURL=paths.js.map

/***/ }),

/***/ 84106:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.isMultisigThresholdPubkey = exports.isSinglePubkey = exports.pubkeyType = exports.isSecp256k1Pubkey = exports.isEd25519Pubkey = void 0;
function isEd25519Pubkey(pubkey) {
    return pubkey.type === "tendermint/PubKeyEd25519";
}
exports.isEd25519Pubkey = isEd25519Pubkey;
function isSecp256k1Pubkey(pubkey) {
    return pubkey.type === "tendermint/PubKeySecp256k1";
}
exports.isSecp256k1Pubkey = isSecp256k1Pubkey;
exports.pubkeyType = {
    /** @see https://github.com/tendermint/tendermint/blob/v0.33.0/crypto/ed25519/ed25519.go#L22 */
    secp256k1: "tendermint/PubKeySecp256k1",
    /** @see https://github.com/tendermint/tendermint/blob/v0.33.0/crypto/secp256k1/secp256k1.go#L23 */
    ed25519: "tendermint/PubKeyEd25519",
    /** @see https://github.com/tendermint/tendermint/blob/v0.33.0/crypto/sr25519/codec.go#L12 */
    sr25519: "tendermint/PubKeySr25519",
    multisigThreshold: "tendermint/PubKeyMultisigThreshold",
};
function isSinglePubkey(pubkey) {
    const singPubkeyTypes = [exports.pubkeyType.ed25519, exports.pubkeyType.secp256k1, exports.pubkeyType.sr25519];
    return singPubkeyTypes.includes(pubkey.type);
}
exports.isSinglePubkey = isSinglePubkey;
function isMultisigThresholdPubkey(pubkey) {
    return pubkey.type === "tendermint/PubKeyMultisigThreshold";
}
exports.isMultisigThresholdPubkey = isMultisigThresholdPubkey;
//# sourceMappingURL=pubkeys.js.map

/***/ }),

/***/ 91220:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Secp256k1HdWallet = exports.extractKdfConfiguration = void 0;
const crypto_1 = __webpack_require__(79562);
const encoding_1 = __webpack_require__(71555);
const utils_1 = __webpack_require__(85553);
const addresses_1 = __webpack_require__(63588);
const paths_1 = __webpack_require__(94284);
const signature_1 = __webpack_require__(11895);
const signdoc_1 = __webpack_require__(14698);
const wallet_1 = __webpack_require__(84675);
const serializationTypeV1 = "secp256k1wallet-v1";
/**
 * A KDF configuration that is not very strong but can be used on the main thread.
 * It takes about 1 second in Node.js 16.0.0 and should have similar runtimes in other modern Wasm hosts.
 */
const basicPasswordHashingOptions = {
    algorithm: "argon2id",
    params: {
        outputLength: 32,
        opsLimit: 24,
        memLimitKib: 12 * 1024,
    },
};
function isDerivationJson(thing) {
    if (!(0, utils_1.isNonNullObject)(thing))
        return false;
    if (typeof thing.hdPath !== "string")
        return false;
    if (typeof thing.prefix !== "string")
        return false;
    return true;
}
function extractKdfConfigurationV1(doc) {
    return doc.kdf;
}
function extractKdfConfiguration(serialization) {
    const root = JSON.parse(serialization);
    if (!(0, utils_1.isNonNullObject)(root))
        throw new Error("Root document is not an object.");
    switch (root.type) {
        case serializationTypeV1:
            return extractKdfConfigurationV1(root);
        default:
            throw new Error("Unsupported serialization type");
    }
}
exports.extractKdfConfiguration = extractKdfConfiguration;
const defaultOptions = {
    bip39Password: "",
    hdPaths: [(0, paths_1.makeCosmoshubPath)(0)],
    prefix: "cosmos",
};
class Secp256k1HdWallet {
    constructor(mnemonic, options) {
        var _a, _b;
        const hdPaths = (_a = options.hdPaths) !== null && _a !== void 0 ? _a : defaultOptions.hdPaths;
        const prefix = (_b = options.prefix) !== null && _b !== void 0 ? _b : defaultOptions.prefix;
        this.secret = mnemonic;
        this.seed = options.seed;
        this.accounts = hdPaths.map((hdPath) => ({
            hdPath: hdPath,
            prefix,
        }));
    }
    /**
     * Restores a wallet from the given BIP39 mnemonic.
     *
     * @param mnemonic Any valid English mnemonic.
     * @param options An optional `Secp256k1HdWalletOptions` object optionally containing a bip39Password, hdPaths, and prefix.
     */
    static async fromMnemonic(mnemonic, options = {}) {
        const mnemonicChecked = new crypto_1.EnglishMnemonic(mnemonic);
        const seed = await crypto_1.Bip39.mnemonicToSeed(mnemonicChecked, options.bip39Password);
        return new Secp256k1HdWallet(mnemonicChecked, {
            ...options,
            seed: seed,
        });
    }
    /**
     * Generates a new wallet with a BIP39 mnemonic of the given length.
     *
     * @param length The number of words in the mnemonic (12, 15, 18, 21 or 24).
     * @param options An optional `Secp256k1HdWalletOptions` object optionally containing a bip39Password, hdPaths, and prefix.
     */
    static async generate(length = 12, options = {}) {
        const entropyLength = 4 * Math.floor((11 * length) / 33);
        const entropy = crypto_1.Random.getBytes(entropyLength);
        const mnemonic = crypto_1.Bip39.encode(entropy);
        return Secp256k1HdWallet.fromMnemonic(mnemonic.toString(), options);
    }
    /**
     * Restores a wallet from an encrypted serialization.
     *
     * @param password The user provided password used to generate an encryption key via a KDF.
     *                 This is not normalized internally (see "Unicode normalization" to learn more).
     */
    static async deserialize(serialization, password) {
        const root = JSON.parse(serialization);
        if (!(0, utils_1.isNonNullObject)(root))
            throw new Error("Root document is not an object.");
        switch (root.type) {
            case serializationTypeV1:
                return Secp256k1HdWallet.deserializeTypeV1(serialization, password);
            default:
                throw new Error("Unsupported serialization type");
        }
    }
    /**
     * Restores a wallet from an encrypted serialization.
     *
     * This is an advanced alternative to calling `deserialize(serialization, password)` directly, which allows
     * you to offload the KDF execution to a non-UI thread (e.g. in a WebWorker).
     *
     * The caller is responsible for ensuring the key was derived with the given KDF configuration. This can be
     * done using `extractKdfConfiguration(serialization)` and `executeKdf(password, kdfConfiguration)` from this package.
     */
    static async deserializeWithEncryptionKey(serialization, encryptionKey) {
        const root = JSON.parse(serialization);
        if (!(0, utils_1.isNonNullObject)(root))
            throw new Error("Root document is not an object.");
        const untypedRoot = root;
        switch (untypedRoot.type) {
            case serializationTypeV1: {
                const decryptedBytes = await (0, wallet_1.decrypt)((0, encoding_1.fromBase64)(untypedRoot.data), encryptionKey, untypedRoot.encryption);
                const decryptedDocument = JSON.parse((0, encoding_1.fromUtf8)(decryptedBytes));
                const { mnemonic, accounts } = decryptedDocument;
                (0, utils_1.assert)(typeof mnemonic === "string");
                if (!Array.isArray(accounts))
                    throw new Error("Property 'accounts' is not an array");
                if (!accounts.every((account) => isDerivationJson(account))) {
                    throw new Error("Account is not in the correct format.");
                }
                const firstPrefix = accounts[0].prefix;
                if (!accounts.every(({ prefix }) => prefix === firstPrefix)) {
                    throw new Error("Accounts do not all have the same prefix");
                }
                const hdPaths = accounts.map(({ hdPath }) => (0, crypto_1.stringToPath)(hdPath));
                return Secp256k1HdWallet.fromMnemonic(mnemonic, {
                    hdPaths: hdPaths,
                    prefix: firstPrefix,
                });
            }
            default:
                throw new Error("Unsupported serialization type");
        }
    }
    static async deserializeTypeV1(serialization, password) {
        const root = JSON.parse(serialization);
        if (!(0, utils_1.isNonNullObject)(root))
            throw new Error("Root document is not an object.");
        const encryptionKey = await (0, wallet_1.executeKdf)(password, root.kdf);
        return Secp256k1HdWallet.deserializeWithEncryptionKey(serialization, encryptionKey);
    }
    get mnemonic() {
        return this.secret.toString();
    }
    async getAccounts() {
        const accountsWithPrivkeys = await this.getAccountsWithPrivkeys();
        return accountsWithPrivkeys.map(({ algo, pubkey, address }) => ({
            algo: algo,
            pubkey: pubkey,
            address: address,
        }));
    }
    async signAmino(signerAddress, signDoc) {
        const accounts = await this.getAccountsWithPrivkeys();
        const account = accounts.find(({ address }) => address === signerAddress);
        if (account === undefined) {
            throw new Error(`Address ${signerAddress} not found in wallet`);
        }
        const { privkey, pubkey } = account;
        const message = (0, crypto_1.sha256)((0, signdoc_1.serializeSignDoc)(signDoc));
        const signature = await crypto_1.Secp256k1.createSignature(message, privkey);
        const signatureBytes = new Uint8Array([...signature.r(32), ...signature.s(32)]);
        return {
            signed: signDoc,
            signature: (0, signature_1.encodeSecp256k1Signature)(pubkey, signatureBytes),
        };
    }
    /**
     * Generates an encrypted serialization of this wallet.
     *
     * @param password The user provided password used to generate an encryption key via a KDF.
     *                 This is not normalized internally (see "Unicode normalization" to learn more).
     */
    async serialize(password) {
        const kdfConfiguration = basicPasswordHashingOptions;
        const encryptionKey = await (0, wallet_1.executeKdf)(password, kdfConfiguration);
        return this.serializeWithEncryptionKey(encryptionKey, kdfConfiguration);
    }
    /**
     * Generates an encrypted serialization of this wallet.
     *
     * This is an advanced alternative to calling `serialize(password)` directly, which allows you to
     * offload the KDF execution to a non-UI thread (e.g. in a WebWorker).
     *
     * The caller is responsible for ensuring the key was derived with the given KDF options. If this
     * is not the case, the wallet cannot be restored with the original password.
     */
    async serializeWithEncryptionKey(encryptionKey, kdfConfiguration) {
        const dataToEncrypt = {
            mnemonic: this.mnemonic,
            accounts: this.accounts.map(({ hdPath, prefix }) => ({
                hdPath: (0, crypto_1.pathToString)(hdPath),
                prefix: prefix,
            })),
        };
        const dataToEncryptRaw = (0, encoding_1.toUtf8)(JSON.stringify(dataToEncrypt));
        const encryptionConfiguration = {
            algorithm: wallet_1.supportedAlgorithms.xchacha20poly1305Ietf,
        };
        const encryptedData = await (0, wallet_1.encrypt)(dataToEncryptRaw, encryptionKey, encryptionConfiguration);
        const out = {
            type: serializationTypeV1,
            kdf: kdfConfiguration,
            encryption: encryptionConfiguration,
            data: (0, encoding_1.toBase64)(encryptedData),
        };
        return JSON.stringify(out);
    }
    async getKeyPair(hdPath) {
        const { privkey } = crypto_1.Slip10.derivePath(crypto_1.Slip10Curve.Secp256k1, this.seed, hdPath);
        const { pubkey } = await crypto_1.Secp256k1.makeKeypair(privkey);
        return {
            privkey: privkey,
            pubkey: crypto_1.Secp256k1.compressPubkey(pubkey),
        };
    }
    async getAccountsWithPrivkeys() {
        return Promise.all(this.accounts.map(async ({ hdPath, prefix }) => {
            const { privkey, pubkey } = await this.getKeyPair(hdPath);
            const address = (0, encoding_1.toBech32)(prefix, (0, addresses_1.rawSecp256k1PubkeyToRawAddress)(pubkey));
            return {
                algo: "secp256k1",
                privkey: privkey,
                pubkey: pubkey,
                address: address,
            };
        }));
    }
}
exports.Secp256k1HdWallet = Secp256k1HdWallet;
//# sourceMappingURL=secp256k1hdwallet.js.map

/***/ }),

/***/ 49484:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Secp256k1Wallet = void 0;
const crypto_1 = __webpack_require__(79562);
const encoding_1 = __webpack_require__(71555);
const addresses_1 = __webpack_require__(63588);
const signature_1 = __webpack_require__(11895);
const signdoc_1 = __webpack_require__(14698);
/**
 * A wallet that holds a single secp256k1 keypair.
 *
 * If you want to work with BIP39 mnemonics and multiple accounts, use Secp256k1HdWallet.
 */
class Secp256k1Wallet {
    constructor(privkey, pubkey, prefix) {
        this.privkey = privkey;
        this.pubkey = pubkey;
        this.prefix = prefix;
    }
    /**
     * Creates a Secp256k1Wallet from the given private key
     *
     * @param privkey The private key.
     * @param prefix The bech32 address prefix (human readable part). Defaults to "cosmos".
     */
    static async fromKey(privkey, prefix = "cosmos") {
        const uncompressed = (await crypto_1.Secp256k1.makeKeypair(privkey)).pubkey;
        return new Secp256k1Wallet(privkey, crypto_1.Secp256k1.compressPubkey(uncompressed), prefix);
    }
    get address() {
        return (0, encoding_1.toBech32)(this.prefix, (0, addresses_1.rawSecp256k1PubkeyToRawAddress)(this.pubkey));
    }
    async getAccounts() {
        return [
            {
                algo: "secp256k1",
                address: this.address,
                pubkey: this.pubkey,
            },
        ];
    }
    async signAmino(signerAddress, signDoc) {
        if (signerAddress !== this.address) {
            throw new Error(`Address ${signerAddress} not found in wallet`);
        }
        const message = new crypto_1.Sha256((0, signdoc_1.serializeSignDoc)(signDoc)).digest();
        const signature = await crypto_1.Secp256k1.createSignature(message, this.privkey);
        const signatureBytes = new Uint8Array([...signature.r(32), ...signature.s(32)]);
        return {
            signed: signDoc,
            signature: (0, signature_1.encodeSecp256k1Signature)(this.pubkey, signatureBytes),
        };
    }
}
exports.Secp256k1Wallet = Secp256k1Wallet;
//# sourceMappingURL=secp256k1wallet.js.map

/***/ }),

/***/ 11895:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.decodeSignature = exports.encodeSecp256k1Signature = void 0;
/* eslint-disable @typescript-eslint/naming-convention */
const encoding_1 = __webpack_require__(71555);
const encoding_2 = __webpack_require__(33590);
const pubkeys_1 = __webpack_require__(84106);
/**
 * Takes a binary pubkey and signature to create a signature object
 *
 * @param pubkey a compressed secp256k1 public key
 * @param signature a 64 byte fixed length representation of secp256k1 signature components r and s
 */
function encodeSecp256k1Signature(pubkey, signature) {
    if (signature.length !== 64) {
        throw new Error("Signature must be 64 bytes long. Cosmos SDK uses a 2x32 byte fixed length encoding for the secp256k1 signature integers r and s.");
    }
    return {
        pub_key: (0, encoding_2.encodeSecp256k1Pubkey)(pubkey),
        signature: (0, encoding_1.toBase64)(signature),
    };
}
exports.encodeSecp256k1Signature = encodeSecp256k1Signature;
function decodeSignature(signature) {
    switch (signature.pub_key.type) {
        // Note: please don't add cases here without writing additional unit tests
        case pubkeys_1.pubkeyType.secp256k1:
            return {
                pubkey: (0, encoding_1.fromBase64)(signature.pub_key.value),
                signature: (0, encoding_1.fromBase64)(signature.signature),
            };
        default:
            throw new Error("Unsupported pubkey type");
    }
}
exports.decodeSignature = decodeSignature;
//# sourceMappingURL=signature.js.map

/***/ }),

/***/ 14698:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.serializeSignDoc = exports.makeSignDoc = exports.sortedJsonStringify = void 0;
/* eslint-disable @typescript-eslint/naming-convention */
const encoding_1 = __webpack_require__(71555);
const math_1 = __webpack_require__(62949);
function sortedObject(obj) {
    if (typeof obj !== "object" || obj === null) {
        return obj;
    }
    if (Array.isArray(obj)) {
        return obj.map(sortedObject);
    }
    const sortedKeys = Object.keys(obj).sort();
    const result = {};
    // NOTE: Use forEach instead of reduce for performance with large objects eg Wasm code
    sortedKeys.forEach((key) => {
        result[key] = sortedObject(obj[key]);
    });
    return result;
}
/** Returns a JSON string with objects sorted by key */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function sortedJsonStringify(obj) {
    return JSON.stringify(sortedObject(obj));
}
exports.sortedJsonStringify = sortedJsonStringify;
function makeSignDoc(msgs, fee, chainId, memo, accountNumber, sequence) {
    return {
        chain_id: chainId,
        account_number: math_1.Uint53.fromString(accountNumber.toString()).toString(),
        sequence: math_1.Uint53.fromString(sequence.toString()).toString(),
        fee: fee,
        msgs: msgs,
        memo: memo || "",
    };
}
exports.makeSignDoc = makeSignDoc;
function serializeSignDoc(signDoc) {
    return (0, encoding_1.toUtf8)(sortedJsonStringify(signDoc));
}
exports.serializeSignDoc = serializeSignDoc;
//# sourceMappingURL=signdoc.js.map

/***/ }),

/***/ 98671:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.makeStdTx = exports.isStdTx = void 0;
function isStdTx(txValue) {
    const { memo, msg, fee, signatures } = txValue;
    return (typeof memo === "string" && Array.isArray(msg) && typeof fee === "object" && Array.isArray(signatures));
}
exports.isStdTx = isStdTx;
function makeStdTx(content, signatures) {
    return {
        msg: content.msgs,
        fee: content.fee,
        memo: content.memo,
        signatures: Array.isArray(signatures) ? signatures : [signatures],
    };
}
exports.makeStdTx = makeStdTx;
//# sourceMappingURL=stdtx.js.map

/***/ }),

/***/ 84675:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.decrypt = exports.encrypt = exports.supportedAlgorithms = exports.executeKdf = exports.cosmjsSalt = void 0;
const crypto_1 = __webpack_require__(79562);
const encoding_1 = __webpack_require__(71555);
/**
 * A fixed salt is chosen to archive a deterministic password to key derivation.
 * This reduces the scope of a potential rainbow attack to all CosmJS users.
 * Must be 16 bytes due to implementation limitations.
 */
exports.cosmjsSalt = (0, encoding_1.toAscii)("The CosmJS salt.");
async function executeKdf(password, configuration) {
    switch (configuration.algorithm) {
        case "argon2id": {
            const options = configuration.params;
            if (!(0, crypto_1.isArgon2idOptions)(options))
                throw new Error("Invalid format of argon2id params");
            return crypto_1.Argon2id.execute(password, exports.cosmjsSalt, options);
        }
        default:
            throw new Error("Unsupported KDF algorithm");
    }
}
exports.executeKdf = executeKdf;
exports.supportedAlgorithms = {
    xchacha20poly1305Ietf: "xchacha20poly1305-ietf",
};
async function encrypt(plaintext, encryptionKey, config) {
    switch (config.algorithm) {
        case exports.supportedAlgorithms.xchacha20poly1305Ietf: {
            const nonce = crypto_1.Random.getBytes(crypto_1.xchacha20NonceLength);
            // Prepend fixed-length nonce to ciphertext as suggested in the example from https://github.com/jedisct1/libsodium.js#api
            return new Uint8Array([
                ...nonce,
                ...(await crypto_1.Xchacha20poly1305Ietf.encrypt(plaintext, encryptionKey, nonce)),
            ]);
        }
        default:
            throw new Error(`Unsupported encryption algorithm: '${config.algorithm}'`);
    }
}
exports.encrypt = encrypt;
async function decrypt(ciphertext, encryptionKey, config) {
    switch (config.algorithm) {
        case exports.supportedAlgorithms.xchacha20poly1305Ietf: {
            const nonce = ciphertext.slice(0, crypto_1.xchacha20NonceLength);
            return crypto_1.Xchacha20poly1305Ietf.decrypt(ciphertext.slice(crypto_1.xchacha20NonceLength), encryptionKey, nonce);
        }
        default:
            throw new Error(`Unsupported encryption algorithm: '${config.algorithm}'`);
    }
}
exports.decrypt = decrypt;
//# sourceMappingURL=wallet.js.map

/***/ }),

/***/ 25240:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.parseCoins = void 0;
/**
 * Takes a coins list like "819966000ucosm,700000000ustake" and parses it.
 *
 * This is a Stargate ready version of parseCoins from @cosmjs/amino.
 * It supports more denoms.
 */
function parseCoins(input) {
    return input
        .replace(/\s/g, "")
        .split(",")
        .filter(Boolean)
        .map((part) => {
        // Denom regex from Stargate (https://github.com/cosmos/cosmos-sdk/blob/v0.42.7/types/coin.go#L599-L601)
        const match = part.match(/^([0-9]+)([a-zA-Z][a-zA-Z0-9/]{2,127})$/);
        if (!match)
            throw new Error("Got an invalid coin string");
        return {
            amount: match[1].replace(/^0+/, "") || "0",
            denom: match[2],
        };
    });
}
exports.parseCoins = parseCoins;
//# sourceMappingURL=coins.js.map

/***/ }),

/***/ 88764:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.decodeTxRaw = void 0;
const tx_1 = __webpack_require__(94289);
/**
 * Takes a serialized TxRaw (the bytes stored in Tendermint) and decodes it into something usable.
 */
function decodeTxRaw(tx) {
    const txRaw = tx_1.TxRaw.decode(tx);
    return {
        authInfo: tx_1.AuthInfo.decode(txRaw.authInfoBytes),
        body: tx_1.TxBody.decode(txRaw.bodyBytes),
        signatures: txRaw.signatures,
    };
}
exports.decodeTxRaw = decodeTxRaw;
//# sourceMappingURL=decode.js.map

/***/ }),

/***/ 26265:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.DirectSecp256k1HdWallet = exports.extractKdfConfiguration = void 0;
const amino_1 = __webpack_require__(38190);
const crypto_1 = __webpack_require__(79562);
const encoding_1 = __webpack_require__(71555);
const utils_1 = __webpack_require__(85553);
const signing_1 = __webpack_require__(26883);
const wallet_1 = __webpack_require__(9528);
const serializationTypeV1 = "directsecp256k1hdwallet-v1";
/**
 * A KDF configuration that is not very strong but can be used on the main thread.
 * It takes about 1 second in Node.js 16.0.0 and should have similar runtimes in other modern Wasm hosts.
 */
const basicPasswordHashingOptions = {
    algorithm: "argon2id",
    params: {
        outputLength: 32,
        opsLimit: 24,
        memLimitKib: 12 * 1024,
    },
};
function isDerivationJson(thing) {
    if (!(0, utils_1.isNonNullObject)(thing))
        return false;
    if (typeof thing.hdPath !== "string")
        return false;
    if (typeof thing.prefix !== "string")
        return false;
    return true;
}
function extractKdfConfigurationV1(doc) {
    return doc.kdf;
}
function extractKdfConfiguration(serialization) {
    const root = JSON.parse(serialization);
    if (!(0, utils_1.isNonNullObject)(root))
        throw new Error("Root document is not an object.");
    switch (root.type) {
        case serializationTypeV1:
            return extractKdfConfigurationV1(root);
        default:
            throw new Error("Unsupported serialization type");
    }
}
exports.extractKdfConfiguration = extractKdfConfiguration;
const defaultOptions = {
    bip39Password: "",
    hdPaths: [(0, amino_1.makeCosmoshubPath)(0)],
    prefix: "cosmos",
};
/** A wallet for protobuf based signing using SIGN_MODE_DIRECT */
class DirectSecp256k1HdWallet {
    constructor(mnemonic, options) {
        var _a, _b;
        const prefix = (_a = options.prefix) !== null && _a !== void 0 ? _a : defaultOptions.prefix;
        const hdPaths = (_b = options.hdPaths) !== null && _b !== void 0 ? _b : defaultOptions.hdPaths;
        this.secret = mnemonic;
        this.seed = options.seed;
        this.accounts = hdPaths.map((hdPath) => ({
            hdPath: hdPath,
            prefix: prefix,
        }));
    }
    /**
     * Restores a wallet from the given BIP39 mnemonic.
     *
     * @param mnemonic Any valid English mnemonic.
     * @param options An optional `DirectSecp256k1HdWalletOptions` object optionally containing a bip39Password, hdPaths, and prefix.
     */
    static async fromMnemonic(mnemonic, options = {}) {
        const mnemonicChecked = new crypto_1.EnglishMnemonic(mnemonic);
        const seed = await crypto_1.Bip39.mnemonicToSeed(mnemonicChecked, options.bip39Password);
        return new DirectSecp256k1HdWallet(mnemonicChecked, {
            ...options,
            seed: seed,
        });
    }
    /**
     * Generates a new wallet with a BIP39 mnemonic of the given length.
     *
     * @param length The number of words in the mnemonic (12, 15, 18, 21 or 24).
     * @param options An optional `DirectSecp256k1HdWalletOptions` object optionally containing a bip39Password, hdPaths, and prefix.
     */
    static async generate(length = 12, options = {}) {
        const entropyLength = 4 * Math.floor((11 * length) / 33);
        const entropy = crypto_1.Random.getBytes(entropyLength);
        const mnemonic = crypto_1.Bip39.encode(entropy);
        return DirectSecp256k1HdWallet.fromMnemonic(mnemonic.toString(), options);
    }
    /**
     * Restores a wallet from an encrypted serialization.
     *
     * @param password The user provided password used to generate an encryption key via a KDF.
     *                 This is not normalized internally (see "Unicode normalization" to learn more).
     */
    static async deserialize(serialization, password) {
        const root = JSON.parse(serialization);
        if (!(0, utils_1.isNonNullObject)(root))
            throw new Error("Root document is not an object.");
        switch (root.type) {
            case serializationTypeV1:
                return DirectSecp256k1HdWallet.deserializeTypeV1(serialization, password);
            default:
                throw new Error("Unsupported serialization type");
        }
    }
    /**
     * Restores a wallet from an encrypted serialization.
     *
     * This is an advanced alternative to calling `deserialize(serialization, password)` directly, which allows
     * you to offload the KDF execution to a non-UI thread (e.g. in a WebWorker).
     *
     * The caller is responsible for ensuring the key was derived with the given KDF configuration. This can be
     * done using `extractKdfConfiguration(serialization)` and `executeKdf(password, kdfConfiguration)` from this package.
     */
    static async deserializeWithEncryptionKey(serialization, encryptionKey) {
        const root = JSON.parse(serialization);
        if (!(0, utils_1.isNonNullObject)(root))
            throw new Error("Root document is not an object.");
        const untypedRoot = root;
        switch (untypedRoot.type) {
            case serializationTypeV1: {
                const decryptedBytes = await (0, wallet_1.decrypt)((0, encoding_1.fromBase64)(untypedRoot.data), encryptionKey, untypedRoot.encryption);
                const decryptedDocument = JSON.parse((0, encoding_1.fromUtf8)(decryptedBytes));
                const { mnemonic, accounts } = decryptedDocument;
                (0, utils_1.assert)(typeof mnemonic === "string");
                if (!Array.isArray(accounts))
                    throw new Error("Property 'accounts' is not an array");
                if (!accounts.every((account) => isDerivationJson(account))) {
                    throw new Error("Account is not in the correct format.");
                }
                const firstPrefix = accounts[0].prefix;
                if (!accounts.every(({ prefix }) => prefix === firstPrefix)) {
                    throw new Error("Accounts do not all have the same prefix");
                }
                const hdPaths = accounts.map(({ hdPath }) => (0, crypto_1.stringToPath)(hdPath));
                return DirectSecp256k1HdWallet.fromMnemonic(mnemonic, {
                    hdPaths: hdPaths,
                    prefix: firstPrefix,
                });
            }
            default:
                throw new Error("Unsupported serialization type");
        }
    }
    static async deserializeTypeV1(serialization, password) {
        const root = JSON.parse(serialization);
        if (!(0, utils_1.isNonNullObject)(root))
            throw new Error("Root document is not an object.");
        const encryptionKey = await (0, wallet_1.executeKdf)(password, root.kdf);
        return DirectSecp256k1HdWallet.deserializeWithEncryptionKey(serialization, encryptionKey);
    }
    get mnemonic() {
        return this.secret.toString();
    }
    async getAccounts() {
        const accountsWithPrivkeys = await this.getAccountsWithPrivkeys();
        return accountsWithPrivkeys.map(({ algo, pubkey, address }) => ({
            algo: algo,
            pubkey: pubkey,
            address: address,
        }));
    }
    async signDirect(signerAddress, signDoc) {
        const accounts = await this.getAccountsWithPrivkeys();
        const account = accounts.find(({ address }) => address === signerAddress);
        if (account === undefined) {
            throw new Error(`Address ${signerAddress} not found in wallet`);
        }
        const { privkey, pubkey } = account;
        const signBytes = (0, signing_1.makeSignBytes)(signDoc);
        const hashedMessage = (0, crypto_1.sha256)(signBytes);
        const signature = await crypto_1.Secp256k1.createSignature(hashedMessage, privkey);
        const signatureBytes = new Uint8Array([...signature.r(32), ...signature.s(32)]);
        const stdSignature = (0, amino_1.encodeSecp256k1Signature)(pubkey, signatureBytes);
        return {
            signed: signDoc,
            signature: stdSignature,
        };
    }
    /**
     * Generates an encrypted serialization of this wallet.
     *
     * @param password The user provided password used to generate an encryption key via a KDF.
     *                 This is not normalized internally (see "Unicode normalization" to learn more).
     */
    async serialize(password) {
        const kdfConfiguration = basicPasswordHashingOptions;
        const encryptionKey = await (0, wallet_1.executeKdf)(password, kdfConfiguration);
        return this.serializeWithEncryptionKey(encryptionKey, kdfConfiguration);
    }
    /**
     * Generates an encrypted serialization of this wallet.
     *
     * This is an advanced alternative to calling `serialize(password)` directly, which allows you to
     * offload the KDF execution to a non-UI thread (e.g. in a WebWorker).
     *
     * The caller is responsible for ensuring the key was derived with the given KDF options. If this
     * is not the case, the wallet cannot be restored with the original password.
     */
    async serializeWithEncryptionKey(encryptionKey, kdfConfiguration) {
        const dataToEncrypt = {
            mnemonic: this.mnemonic,
            accounts: this.accounts.map(({ hdPath, prefix }) => ({
                hdPath: (0, crypto_1.pathToString)(hdPath),
                prefix: prefix,
            })),
        };
        const dataToEncryptRaw = (0, encoding_1.toUtf8)(JSON.stringify(dataToEncrypt));
        const encryptionConfiguration = {
            algorithm: wallet_1.supportedAlgorithms.xchacha20poly1305Ietf,
        };
        const encryptedData = await (0, wallet_1.encrypt)(dataToEncryptRaw, encryptionKey, encryptionConfiguration);
        const out = {
            type: serializationTypeV1,
            kdf: kdfConfiguration,
            encryption: encryptionConfiguration,
            data: (0, encoding_1.toBase64)(encryptedData),
        };
        return JSON.stringify(out);
    }
    async getKeyPair(hdPath) {
        const { privkey } = crypto_1.Slip10.derivePath(crypto_1.Slip10Curve.Secp256k1, this.seed, hdPath);
        const { pubkey } = await crypto_1.Secp256k1.makeKeypair(privkey);
        return {
            privkey: privkey,
            pubkey: crypto_1.Secp256k1.compressPubkey(pubkey),
        };
    }
    async getAccountsWithPrivkeys() {
        return Promise.all(this.accounts.map(async ({ hdPath, prefix }) => {
            const { privkey, pubkey } = await this.getKeyPair(hdPath);
            const address = (0, encoding_1.toBech32)(prefix, (0, amino_1.rawSecp256k1PubkeyToRawAddress)(pubkey));
            return {
                algo: "secp256k1",
                privkey: privkey,
                pubkey: pubkey,
                address: address,
            };
        }));
    }
}
exports.DirectSecp256k1HdWallet = DirectSecp256k1HdWallet;
//# sourceMappingURL=directsecp256k1hdwallet.js.map

/***/ }),

/***/ 5558:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.DirectSecp256k1Wallet = void 0;
const amino_1 = __webpack_require__(38190);
const crypto_1 = __webpack_require__(79562);
const encoding_1 = __webpack_require__(71555);
const signing_1 = __webpack_require__(26883);
/**
 * A wallet that holds a single secp256k1 keypair.
 *
 * If you want to work with BIP39 mnemonics and multiple accounts, use DirectSecp256k1HdWallet.
 */
class DirectSecp256k1Wallet {
    constructor(privkey, pubkey, prefix) {
        this.privkey = privkey;
        this.pubkey = pubkey;
        this.prefix = prefix;
    }
    /**
     * Creates a DirectSecp256k1Wallet from the given private key
     *
     * @param privkey The private key.
     * @param prefix The bech32 address prefix (human readable part). Defaults to "cosmos".
     */
    static async fromKey(privkey, prefix = "cosmos") {
        const uncompressed = (await crypto_1.Secp256k1.makeKeypair(privkey)).pubkey;
        return new DirectSecp256k1Wallet(privkey, crypto_1.Secp256k1.compressPubkey(uncompressed), prefix);
    }
    get address() {
        return (0, encoding_1.toBech32)(this.prefix, (0, amino_1.rawSecp256k1PubkeyToRawAddress)(this.pubkey));
    }
    async getAccounts() {
        return [
            {
                algo: "secp256k1",
                address: this.address,
                pubkey: this.pubkey,
            },
        ];
    }
    async signDirect(address, signDoc) {
        const signBytes = (0, signing_1.makeSignBytes)(signDoc);
        if (address !== this.address) {
            throw new Error(`Address ${address} not found in wallet`);
        }
        const hashedMessage = (0, crypto_1.sha256)(signBytes);
        const signature = await crypto_1.Secp256k1.createSignature(hashedMessage, this.privkey);
        const signatureBytes = new Uint8Array([...signature.r(32), ...signature.s(32)]);
        const stdSignature = (0, amino_1.encodeSecp256k1Signature)(this.pubkey, signatureBytes);
        return {
            signed: signDoc,
            signature: stdSignature,
        };
    }
}
exports.DirectSecp256k1Wallet = DirectSecp256k1Wallet;
//# sourceMappingURL=directsecp256k1wallet.js.map

/***/ }),

/***/ 348:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.coins = exports.coin = exports.executeKdf = exports.makeSignDoc = exports.makeSignBytes = exports.makeAuthInfoBytes = exports.isOfflineDirectSigner = exports.Registry = exports.isTxBodyEncodeObject = exports.isTsProtoGeneratedType = exports.isPbjsGeneratedType = exports.encodePubkey = exports.decodePubkey = exports.anyToSinglePubkey = exports.makeCosmoshubPath = exports.DirectSecp256k1Wallet = exports.extractKdfConfiguration = exports.DirectSecp256k1HdWallet = exports.decodeTxRaw = exports.parseCoins = void 0;
// This type happens to be shared between Amino and Direct sign modes
var coins_1 = __webpack_require__(25240);
Object.defineProperty(exports, "parseCoins", ({ enumerable: true, get: function () { return coins_1.parseCoins; } }));
var decode_1 = __webpack_require__(88764);
Object.defineProperty(exports, "decodeTxRaw", ({ enumerable: true, get: function () { return decode_1.decodeTxRaw; } }));
var directsecp256k1hdwallet_1 = __webpack_require__(26265);
Object.defineProperty(exports, "DirectSecp256k1HdWallet", ({ enumerable: true, get: function () { return directsecp256k1hdwallet_1.DirectSecp256k1HdWallet; } }));
Object.defineProperty(exports, "extractKdfConfiguration", ({ enumerable: true, get: function () { return directsecp256k1hdwallet_1.extractKdfConfiguration; } }));
var directsecp256k1wallet_1 = __webpack_require__(5558);
Object.defineProperty(exports, "DirectSecp256k1Wallet", ({ enumerable: true, get: function () { return directsecp256k1wallet_1.DirectSecp256k1Wallet; } }));
var paths_1 = __webpack_require__(12699);
Object.defineProperty(exports, "makeCosmoshubPath", ({ enumerable: true, get: function () { return paths_1.makeCosmoshubPath; } }));
var pubkey_1 = __webpack_require__(98503);
Object.defineProperty(exports, "anyToSinglePubkey", ({ enumerable: true, get: function () { return pubkey_1.anyToSinglePubkey; } }));
Object.defineProperty(exports, "decodePubkey", ({ enumerable: true, get: function () { return pubkey_1.decodePubkey; } }));
Object.defineProperty(exports, "encodePubkey", ({ enumerable: true, get: function () { return pubkey_1.encodePubkey; } }));
var registry_1 = __webpack_require__(33081);
Object.defineProperty(exports, "isPbjsGeneratedType", ({ enumerable: true, get: function () { return registry_1.isPbjsGeneratedType; } }));
Object.defineProperty(exports, "isTsProtoGeneratedType", ({ enumerable: true, get: function () { return registry_1.isTsProtoGeneratedType; } }));
Object.defineProperty(exports, "isTxBodyEncodeObject", ({ enumerable: true, get: function () { return registry_1.isTxBodyEncodeObject; } }));
Object.defineProperty(exports, "Registry", ({ enumerable: true, get: function () { return registry_1.Registry; } }));
var signer_1 = __webpack_require__(91733);
Object.defineProperty(exports, "isOfflineDirectSigner", ({ enumerable: true, get: function () { return signer_1.isOfflineDirectSigner; } }));
var signing_1 = __webpack_require__(26883);
Object.defineProperty(exports, "makeAuthInfoBytes", ({ enumerable: true, get: function () { return signing_1.makeAuthInfoBytes; } }));
Object.defineProperty(exports, "makeSignBytes", ({ enumerable: true, get: function () { return signing_1.makeSignBytes; } }));
Object.defineProperty(exports, "makeSignDoc", ({ enumerable: true, get: function () { return signing_1.makeSignDoc; } }));
var wallet_1 = __webpack_require__(9528);
Object.defineProperty(exports, "executeKdf", ({ enumerable: true, get: function () { return wallet_1.executeKdf; } }));
var amino_1 = __webpack_require__(38190);
Object.defineProperty(exports, "coin", ({ enumerable: true, get: function () { return amino_1.coin; } }));
Object.defineProperty(exports, "coins", ({ enumerable: true, get: function () { return amino_1.coins; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 12699:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.makeCosmoshubPath = void 0;
const crypto_1 = __webpack_require__(79562);
/**
 * The Cosmos Hub derivation path in the form `m/44'/118'/0'/0/a`
 * with 0-based account index `a`.
 */
function makeCosmoshubPath(a) {
    return [
        crypto_1.Slip10RawIndex.hardened(44),
        crypto_1.Slip10RawIndex.hardened(118),
        crypto_1.Slip10RawIndex.hardened(0),
        crypto_1.Slip10RawIndex.normal(0),
        crypto_1.Slip10RawIndex.normal(a),
    ];
}
exports.makeCosmoshubPath = makeCosmoshubPath;
//# sourceMappingURL=paths.js.map

/***/ }),

/***/ 98503:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.decodePubkey = exports.anyToSinglePubkey = exports.encodePubkey = void 0;
/* eslint-disable @typescript-eslint/naming-convention */
const amino_1 = __webpack_require__(38190);
const encoding_1 = __webpack_require__(71555);
const math_1 = __webpack_require__(62949);
const keys_1 = __webpack_require__(2029);
const keys_2 = __webpack_require__(68070);
const keys_3 = __webpack_require__(61599);
const any_1 = __webpack_require__(90007);
/**
 * Takes a pubkey in the Amino JSON object style (type/value wrapper)
 * and convertes it into a protobuf `Any`.
 *
 * This is the reverse operation to `decodePubkey`.
 */
function encodePubkey(pubkey) {
    if ((0, amino_1.isSecp256k1Pubkey)(pubkey)) {
        const pubkeyProto = keys_3.PubKey.fromPartial({
            key: (0, encoding_1.fromBase64)(pubkey.value),
        });
        return any_1.Any.fromPartial({
            typeUrl: "/cosmos.crypto.secp256k1.PubKey",
            value: Uint8Array.from(keys_3.PubKey.encode(pubkeyProto).finish()),
        });
    }
    else if ((0, amino_1.isEd25519Pubkey)(pubkey)) {
        const pubkeyProto = keys_1.PubKey.fromPartial({
            key: (0, encoding_1.fromBase64)(pubkey.value),
        });
        return any_1.Any.fromPartial({
            typeUrl: "/cosmos.crypto.ed25519.PubKey",
            value: Uint8Array.from(keys_1.PubKey.encode(pubkeyProto).finish()),
        });
    }
    else if ((0, amino_1.isMultisigThresholdPubkey)(pubkey)) {
        const pubkeyProto = keys_2.LegacyAminoPubKey.fromPartial({
            threshold: math_1.Uint53.fromString(pubkey.value.threshold).toNumber(),
            publicKeys: pubkey.value.pubkeys.map(encodePubkey),
        });
        return any_1.Any.fromPartial({
            typeUrl: "/cosmos.crypto.multisig.LegacyAminoPubKey",
            value: Uint8Array.from(keys_2.LegacyAminoPubKey.encode(pubkeyProto).finish()),
        });
    }
    else {
        throw new Error(`Pubkey type ${pubkey.type} not recognized`);
    }
}
exports.encodePubkey = encodePubkey;
/**
 * Decodes a single pubkey (i.e. not a multisig pubkey) from `Any` into
 * `SinglePubkey`.
 *
 * In most cases you probably want to use `decodePubkey`, but `anyToSinglePubkey`
 * might be preferred in CosmJS 0.29.x due to https://github.com/cosmos/cosmjs/issues/1289.
 */
function anyToSinglePubkey(pubkey) {
    switch (pubkey.typeUrl) {
        case "/cosmos.crypto.secp256k1.PubKey": {
            const { key } = keys_3.PubKey.decode(pubkey.value);
            return (0, amino_1.encodeSecp256k1Pubkey)(key);
        }
        case "/cosmos.crypto.ed25519.PubKey": {
            const { key } = keys_1.PubKey.decode(pubkey.value);
            return (0, amino_1.encodeEd25519Pubkey)(key);
        }
        default:
            throw new Error(`Pubkey type_url ${pubkey.typeUrl} not recognized as single public key type`);
    }
}
exports.anyToSinglePubkey = anyToSinglePubkey;
function decodePubkey(pubkey) {
    if (!pubkey || !pubkey.value) {
        return null;
    }
    switch (pubkey.typeUrl) {
        case "/cosmos.crypto.secp256k1.PubKey":
        case "/cosmos.crypto.ed25519.PubKey": {
            return anyToSinglePubkey(pubkey);
        }
        case "/cosmos.crypto.multisig.LegacyAminoPubKey": {
            const { threshold, publicKeys } = keys_2.LegacyAminoPubKey.decode(pubkey.value);
            const out = {
                type: "tendermint/PubKeyMultisigThreshold",
                value: {
                    threshold: threshold.toString(),
                    pubkeys: publicKeys.map(anyToSinglePubkey),
                },
            };
            return out;
        }
        default:
            throw new Error(`Pubkey type_url ${pubkey.typeUrl} not recognized`);
    }
}
exports.decodePubkey = decodePubkey;
//# sourceMappingURL=pubkey.js.map

/***/ }),

/***/ 33081:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/* provided dependency */ var Buffer = __webpack_require__(48764)["Buffer"];

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Registry = exports.isTxBodyEncodeObject = exports.isPbjsGeneratedType = exports.isTsProtoGeneratedType = void 0;
/* eslint-disable @typescript-eslint/naming-convention */
const tx_1 = __webpack_require__(67722);
const coin_1 = __webpack_require__(26119);
const tx_2 = __webpack_require__(94289);
const any_1 = __webpack_require__(90007);
function isTsProtoGeneratedType(type) {
    return typeof type.fromPartial === "function";
}
exports.isTsProtoGeneratedType = isTsProtoGeneratedType;
function isPbjsGeneratedType(type) {
    return !isTsProtoGeneratedType(type);
}
exports.isPbjsGeneratedType = isPbjsGeneratedType;
const defaultTypeUrls = {
    cosmosCoin: "/cosmos.base.v1beta1.Coin",
    cosmosMsgSend: "/cosmos.bank.v1beta1.MsgSend",
    cosmosTxBody: "/cosmos.tx.v1beta1.TxBody",
    googleAny: "/google.protobuf.Any",
};
function isTxBodyEncodeObject(encodeObject) {
    return encodeObject.typeUrl === "/cosmos.tx.v1beta1.TxBody";
}
exports.isTxBodyEncodeObject = isTxBodyEncodeObject;
class Registry {
    /**
     * Creates a new Registry for mapping protobuf type identifiers/type URLs to
     * actual implementations. Those implementations are typically generated with ts-proto
     * but we also support protobuf.js as a type generator.
     *
     * If there is no parameter given, a `new Registry()` adds the types `Coin` and `MsgSend`
     * for historic reasons. Those can be overriden by customTypes.
     *
     * There are currently two methods for adding new types:
     * 1. Passing types to the constructor.
     * 2. Using the `register()` method
     */
    constructor(customTypes) {
        const { cosmosCoin, cosmosMsgSend } = defaultTypeUrls;
        this.types = customTypes
            ? new Map([...customTypes])
            : new Map([
                [cosmosCoin, coin_1.Coin],
                [cosmosMsgSend, tx_1.MsgSend],
            ]);
    }
    register(typeUrl, type) {
        this.types.set(typeUrl, type);
    }
    /**
     * Looks up a type that was previously added to the registry.
     *
     * The generator information (ts-proto or pbjs) gets lost along the way.
     * If you need to work with the result type in TypeScript, you can use:
     *
     * ```
     * import { assert } from "@cosmjs/utils";
     *
     * const Coin = registry.lookupType("/cosmos.base.v1beta1.Coin");
     * assert(Coin); // Ensures not unset
     * assert(isTsProtoGeneratedType(Coin)); // Ensures this is the type we expect
     *
     * // Coin is typed TsProtoGeneratedType now.
     * ```
     */
    lookupType(typeUrl) {
        return this.types.get(typeUrl);
    }
    lookupTypeWithError(typeUrl) {
        const type = this.lookupType(typeUrl);
        if (!type) {
            throw new Error(`Unregistered type url: ${typeUrl}`);
        }
        return type;
    }
    /**
     * Takes a typeUrl/value pair and encodes the value to protobuf if
     * the given type was previously registered.
     *
     * If the value has to be wrapped in an Any, this needs to be done
     * manually after this call. Or use `encodeAsAny` instead.
     */
    encode(encodeObject) {
        const { value, typeUrl } = encodeObject;
        if (isTxBodyEncodeObject(encodeObject)) {
            return this.encodeTxBody(value);
        }
        const type = this.lookupTypeWithError(typeUrl);
        const instance = isTsProtoGeneratedType(type) ? type.fromPartial(value) : type.create(value);
        return type.encode(instance).finish();
    }
    /**
     * Takes a typeUrl/value pair and encodes the value to an Any if
     * the given type was previously registered.
     */
    encodeAsAny(encodeObject) {
        const binaryValue = this.encode(encodeObject);
        return any_1.Any.fromPartial({
            typeUrl: encodeObject.typeUrl,
            value: binaryValue,
        });
    }
    encodeTxBody(txBodyFields) {
        const wrappedMessages = txBodyFields.messages.map((message) => this.encodeAsAny(message));
        const txBody = tx_2.TxBody.fromPartial({
            ...txBodyFields,
            messages: wrappedMessages,
        });
        return tx_2.TxBody.encode(txBody).finish();
    }
    decode({ typeUrl, value }) {
        if (typeUrl === defaultTypeUrls.cosmosTxBody) {
            return this.decodeTxBody(value);
        }
        const type = this.lookupTypeWithError(typeUrl);
        const decoded = type.decode(value);
        Object.entries(decoded).forEach(([key, val]) => {
            if (typeof Buffer !== "undefined" && typeof Buffer.isBuffer !== "undefined" && Buffer.isBuffer(val)) {
                decoded[key] = Uint8Array.from(val);
            }
        });
        return decoded;
    }
    decodeTxBody(txBody) {
        const decodedTxBody = tx_2.TxBody.decode(txBody);
        return {
            ...decodedTxBody,
            messages: decodedTxBody.messages.map(({ typeUrl: typeUrl, value }) => {
                if (!typeUrl) {
                    throw new Error("Missing type_url in Any");
                }
                if (!value) {
                    throw new Error("Missing value in Any");
                }
                return this.decode({ typeUrl, value });
            }),
        };
    }
}
exports.Registry = Registry;
//# sourceMappingURL=registry.js.map

/***/ }),

/***/ 91733:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.isOfflineDirectSigner = void 0;
function isOfflineDirectSigner(signer) {
    return signer.signDirect !== undefined;
}
exports.isOfflineDirectSigner = isOfflineDirectSigner;
//# sourceMappingURL=signer.js.map

/***/ }),

/***/ 26883:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.makeSignBytes = exports.makeSignDoc = exports.makeAuthInfoBytes = void 0;
/* eslint-disable @typescript-eslint/naming-convention */
const utils_1 = __webpack_require__(85553);
const signing_1 = __webpack_require__(94600);
const tx_1 = __webpack_require__(94289);
const long_1 = __importDefault(__webpack_require__(21305));
/**
 * Create signer infos from the provided signers.
 *
 * This implementation does not support different signing modes for the different signers.
 */
function makeSignerInfos(signers, signMode) {
    return signers.map(({ pubkey, sequence }) => ({
        publicKey: pubkey,
        modeInfo: {
            single: { mode: signMode },
        },
        sequence: long_1.default.fromNumber(sequence),
    }));
}
/**
 * Creates and serializes an AuthInfo document.
 *
 * This implementation does not support different signing modes for the different signers.
 */
function makeAuthInfoBytes(signers, feeAmount, gasLimit, feeGranter, feePayer, signMode = signing_1.SignMode.SIGN_MODE_DIRECT) {
    // Required arguments 4 and 5 were added in CosmJS 0.29. Use runtime checks to help our non-TS users.
    (0, utils_1.assert)(feeGranter === undefined || typeof feeGranter === "string", "feeGranter must be undefined or string");
    (0, utils_1.assert)(feePayer === undefined || typeof feePayer === "string", "feePayer must be undefined or string");
    const authInfo = tx_1.AuthInfo.fromPartial({
        signerInfos: makeSignerInfos(signers, signMode),
        fee: {
            amount: [...feeAmount],
            gasLimit: long_1.default.fromNumber(gasLimit),
            granter: feeGranter,
            payer: feePayer,
        },
    });
    return tx_1.AuthInfo.encode(authInfo).finish();
}
exports.makeAuthInfoBytes = makeAuthInfoBytes;
function makeSignDoc(bodyBytes, authInfoBytes, chainId, accountNumber) {
    return {
        bodyBytes: bodyBytes,
        authInfoBytes: authInfoBytes,
        chainId: chainId,
        accountNumber: long_1.default.fromNumber(accountNumber),
    };
}
exports.makeSignDoc = makeSignDoc;
function makeSignBytes({ accountNumber, authInfoBytes, bodyBytes, chainId }) {
    const signDoc = tx_1.SignDoc.fromPartial({
        accountNumber: accountNumber,
        authInfoBytes: authInfoBytes,
        bodyBytes: bodyBytes,
        chainId: chainId,
    });
    return tx_1.SignDoc.encode(signDoc).finish();
}
exports.makeSignBytes = makeSignBytes;
//# sourceMappingURL=signing.js.map

/***/ }),

/***/ 9528:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.decrypt = exports.encrypt = exports.supportedAlgorithms = exports.executeKdf = exports.cosmjsSalt = void 0;
const crypto_1 = __webpack_require__(79562);
const encoding_1 = __webpack_require__(71555);
/**
 * A fixed salt is chosen to archive a deterministic password to key derivation.
 * This reduces the scope of a potential rainbow attack to all CosmJS users.
 * Must be 16 bytes due to implementation limitations.
 */
exports.cosmjsSalt = (0, encoding_1.toAscii)("The CosmJS salt.");
async function executeKdf(password, configuration) {
    switch (configuration.algorithm) {
        case "argon2id": {
            const options = configuration.params;
            if (!(0, crypto_1.isArgon2idOptions)(options))
                throw new Error("Invalid format of argon2id params");
            return crypto_1.Argon2id.execute(password, exports.cosmjsSalt, options);
        }
        default:
            throw new Error("Unsupported KDF algorithm");
    }
}
exports.executeKdf = executeKdf;
exports.supportedAlgorithms = {
    xchacha20poly1305Ietf: "xchacha20poly1305-ietf",
};
async function encrypt(plaintext, encryptionKey, config) {
    switch (config.algorithm) {
        case exports.supportedAlgorithms.xchacha20poly1305Ietf: {
            const nonce = crypto_1.Random.getBytes(crypto_1.xchacha20NonceLength);
            // Prepend fixed-length nonce to ciphertext as suggested in the example from https://github.com/jedisct1/libsodium.js#api
            return new Uint8Array([
                ...nonce,
                ...(await crypto_1.Xchacha20poly1305Ietf.encrypt(plaintext, encryptionKey, nonce)),
            ]);
        }
        default:
            throw new Error(`Unsupported encryption algorithm: '${config.algorithm}'`);
    }
}
exports.encrypt = encrypt;
async function decrypt(ciphertext, encryptionKey, config) {
    switch (config.algorithm) {
        case exports.supportedAlgorithms.xchacha20poly1305Ietf: {
            const nonce = ciphertext.slice(0, crypto_1.xchacha20NonceLength);
            return crypto_1.Xchacha20poly1305Ietf.decrypt(ciphertext.slice(crypto_1.xchacha20NonceLength), encryptionKey, nonce);
        }
        default:
            throw new Error(`Unsupported encryption algorithm: '${config.algorithm}'`);
    }
}
exports.decrypt = decrypt;
//# sourceMappingURL=wallet.js.map

/***/ }),

/***/ 21305:
/***/ (function(module) {

module.exports = Long;

/**
 * wasm optimizations, to do native i64 multiplication and divide
 */
var wasm = null;

try {
  wasm = new WebAssembly.Instance(new WebAssembly.Module(new Uint8Array([
    0, 97, 115, 109, 1, 0, 0, 0, 1, 13, 2, 96, 0, 1, 127, 96, 4, 127, 127, 127, 127, 1, 127, 3, 7, 6, 0, 1, 1, 1, 1, 1, 6, 6, 1, 127, 1, 65, 0, 11, 7, 50, 6, 3, 109, 117, 108, 0, 1, 5, 100, 105, 118, 95, 115, 0, 2, 5, 100, 105, 118, 95, 117, 0, 3, 5, 114, 101, 109, 95, 115, 0, 4, 5, 114, 101, 109, 95, 117, 0, 5, 8, 103, 101, 116, 95, 104, 105, 103, 104, 0, 0, 10, 191, 1, 6, 4, 0, 35, 0, 11, 36, 1, 1, 126, 32, 0, 173, 32, 1, 173, 66, 32, 134, 132, 32, 2, 173, 32, 3, 173, 66, 32, 134, 132, 126, 34, 4, 66, 32, 135, 167, 36, 0, 32, 4, 167, 11, 36, 1, 1, 126, 32, 0, 173, 32, 1, 173, 66, 32, 134, 132, 32, 2, 173, 32, 3, 173, 66, 32, 134, 132, 127, 34, 4, 66, 32, 135, 167, 36, 0, 32, 4, 167, 11, 36, 1, 1, 126, 32, 0, 173, 32, 1, 173, 66, 32, 134, 132, 32, 2, 173, 32, 3, 173, 66, 32, 134, 132, 128, 34, 4, 66, 32, 135, 167, 36, 0, 32, 4, 167, 11, 36, 1, 1, 126, 32, 0, 173, 32, 1, 173, 66, 32, 134, 132, 32, 2, 173, 32, 3, 173, 66, 32, 134, 132, 129, 34, 4, 66, 32, 135, 167, 36, 0, 32, 4, 167, 11, 36, 1, 1, 126, 32, 0, 173, 32, 1, 173, 66, 32, 134, 132, 32, 2, 173, 32, 3, 173, 66, 32, 134, 132, 130, 34, 4, 66, 32, 135, 167, 36, 0, 32, 4, 167, 11
  ])), {}).exports;
} catch (e) {
  // no wasm support :(
}

/**
 * Constructs a 64 bit two's-complement integer, given its low and high 32 bit values as *signed* integers.
 *  See the from* functions below for more convenient ways of constructing Longs.
 * @exports Long
 * @class A Long class for representing a 64 bit two's-complement integer value.
 * @param {number} low The low (signed) 32 bits of the long
 * @param {number} high The high (signed) 32 bits of the long
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @constructor
 */
function Long(low, high, unsigned) {

    /**
     * The low 32 bits as a signed value.
     * @type {number}
     */
    this.low = low | 0;

    /**
     * The high 32 bits as a signed value.
     * @type {number}
     */
    this.high = high | 0;

    /**
     * Whether unsigned or not.
     * @type {boolean}
     */
    this.unsigned = !!unsigned;
}

// The internal representation of a long is the two given signed, 32-bit values.
// We use 32-bit pieces because these are the size of integers on which
// Javascript performs bit-operations.  For operations like addition and
// multiplication, we split each number into 16 bit pieces, which can easily be
// multiplied within Javascript's floating-point representation without overflow
// or change in sign.
//
// In the algorithms below, we frequently reduce the negative case to the
// positive case by negating the input(s) and then post-processing the result.
// Note that we must ALWAYS check specially whether those values are MIN_VALUE
// (-2^63) because -MIN_VALUE == MIN_VALUE (since 2^63 cannot be represented as
// a positive number, it overflows back into a negative).  Not handling this
// case would often result in infinite recursion.
//
// Common constant values ZERO, ONE, NEG_ONE, etc. are defined below the from*
// methods on which they depend.

/**
 * An indicator used to reliably determine if an object is a Long or not.
 * @type {boolean}
 * @const
 * @private
 */
Long.prototype.__isLong__;

Object.defineProperty(Long.prototype, "__isLong__", { value: true });

/**
 * @function
 * @param {*} obj Object
 * @returns {boolean}
 * @inner
 */
function isLong(obj) {
    return (obj && obj["__isLong__"]) === true;
}

/**
 * Tests if the specified object is a Long.
 * @function
 * @param {*} obj Object
 * @returns {boolean}
 */
Long.isLong = isLong;

/**
 * A cache of the Long representations of small integer values.
 * @type {!Object}
 * @inner
 */
var INT_CACHE = {};

/**
 * A cache of the Long representations of small unsigned integer values.
 * @type {!Object}
 * @inner
 */
var UINT_CACHE = {};

/**
 * @param {number} value
 * @param {boolean=} unsigned
 * @returns {!Long}
 * @inner
 */
function fromInt(value, unsigned) {
    var obj, cachedObj, cache;
    if (unsigned) {
        value >>>= 0;
        if (cache = (0 <= value && value < 256)) {
            cachedObj = UINT_CACHE[value];
            if (cachedObj)
                return cachedObj;
        }
        obj = fromBits(value, (value | 0) < 0 ? -1 : 0, true);
        if (cache)
            UINT_CACHE[value] = obj;
        return obj;
    } else {
        value |= 0;
        if (cache = (-128 <= value && value < 128)) {
            cachedObj = INT_CACHE[value];
            if (cachedObj)
                return cachedObj;
        }
        obj = fromBits(value, value < 0 ? -1 : 0, false);
        if (cache)
            INT_CACHE[value] = obj;
        return obj;
    }
}

/**
 * Returns a Long representing the given 32 bit integer value.
 * @function
 * @param {number} value The 32 bit integer in question
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {!Long} The corresponding Long value
 */
Long.fromInt = fromInt;

/**
 * @param {number} value
 * @param {boolean=} unsigned
 * @returns {!Long}
 * @inner
 */
function fromNumber(value, unsigned) {
    if (isNaN(value))
        return unsigned ? UZERO : ZERO;
    if (unsigned) {
        if (value < 0)
            return UZERO;
        if (value >= TWO_PWR_64_DBL)
            return MAX_UNSIGNED_VALUE;
    } else {
        if (value <= -TWO_PWR_63_DBL)
            return MIN_VALUE;
        if (value + 1 >= TWO_PWR_63_DBL)
            return MAX_VALUE;
    }
    if (value < 0)
        return fromNumber(-value, unsigned).neg();
    return fromBits((value % TWO_PWR_32_DBL) | 0, (value / TWO_PWR_32_DBL) | 0, unsigned);
}

/**
 * Returns a Long representing the given value, provided that it is a finite number. Otherwise, zero is returned.
 * @function
 * @param {number} value The number in question
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {!Long} The corresponding Long value
 */
Long.fromNumber = fromNumber;

/**
 * @param {number} lowBits
 * @param {number} highBits
 * @param {boolean=} unsigned
 * @returns {!Long}
 * @inner
 */
function fromBits(lowBits, highBits, unsigned) {
    return new Long(lowBits, highBits, unsigned);
}

/**
 * Returns a Long representing the 64 bit integer that comes by concatenating the given low and high bits. Each is
 *  assumed to use 32 bits.
 * @function
 * @param {number} lowBits The low 32 bits
 * @param {number} highBits The high 32 bits
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {!Long} The corresponding Long value
 */
Long.fromBits = fromBits;

/**
 * @function
 * @param {number} base
 * @param {number} exponent
 * @returns {number}
 * @inner
 */
var pow_dbl = Math.pow; // Used 4 times (4*8 to 15+4)

/**
 * @param {string} str
 * @param {(boolean|number)=} unsigned
 * @param {number=} radix
 * @returns {!Long}
 * @inner
 */
function fromString(str, unsigned, radix) {
    if (str.length === 0)
        throw Error('empty string');
    if (str === "NaN" || str === "Infinity" || str === "+Infinity" || str === "-Infinity")
        return ZERO;
    if (typeof unsigned === 'number') {
        // For goog.math.long compatibility
        radix = unsigned,
        unsigned = false;
    } else {
        unsigned = !! unsigned;
    }
    radix = radix || 10;
    if (radix < 2 || 36 < radix)
        throw RangeError('radix');

    var p;
    if ((p = str.indexOf('-')) > 0)
        throw Error('interior hyphen');
    else if (p === 0) {
        return fromString(str.substring(1), unsigned, radix).neg();
    }

    // Do several (8) digits each time through the loop, so as to
    // minimize the calls to the very expensive emulated div.
    var radixToPower = fromNumber(pow_dbl(radix, 8));

    var result = ZERO;
    for (var i = 0; i < str.length; i += 8) {
        var size = Math.min(8, str.length - i),
            value = parseInt(str.substring(i, i + size), radix);
        if (size < 8) {
            var power = fromNumber(pow_dbl(radix, size));
            result = result.mul(power).add(fromNumber(value));
        } else {
            result = result.mul(radixToPower);
            result = result.add(fromNumber(value));
        }
    }
    result.unsigned = unsigned;
    return result;
}

/**
 * Returns a Long representation of the given string, written using the specified radix.
 * @function
 * @param {string} str The textual representation of the Long
 * @param {(boolean|number)=} unsigned Whether unsigned or not, defaults to signed
 * @param {number=} radix The radix in which the text is written (2-36), defaults to 10
 * @returns {!Long} The corresponding Long value
 */
Long.fromString = fromString;

/**
 * @function
 * @param {!Long|number|string|!{low: number, high: number, unsigned: boolean}} val
 * @param {boolean=} unsigned
 * @returns {!Long}
 * @inner
 */
function fromValue(val, unsigned) {
    if (typeof val === 'number')
        return fromNumber(val, unsigned);
    if (typeof val === 'string')
        return fromString(val, unsigned);
    // Throws for non-objects, converts non-instanceof Long:
    return fromBits(val.low, val.high, typeof unsigned === 'boolean' ? unsigned : val.unsigned);
}

/**
 * Converts the specified value to a Long using the appropriate from* function for its type.
 * @function
 * @param {!Long|number|string|!{low: number, high: number, unsigned: boolean}} val Value
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {!Long}
 */
Long.fromValue = fromValue;

// NOTE: the compiler should inline these constant values below and then remove these variables, so there should be
// no runtime penalty for these.

/**
 * @type {number}
 * @const
 * @inner
 */
var TWO_PWR_16_DBL = 1 << 16;

/**
 * @type {number}
 * @const
 * @inner
 */
var TWO_PWR_24_DBL = 1 << 24;

/**
 * @type {number}
 * @const
 * @inner
 */
var TWO_PWR_32_DBL = TWO_PWR_16_DBL * TWO_PWR_16_DBL;

/**
 * @type {number}
 * @const
 * @inner
 */
var TWO_PWR_64_DBL = TWO_PWR_32_DBL * TWO_PWR_32_DBL;

/**
 * @type {number}
 * @const
 * @inner
 */
var TWO_PWR_63_DBL = TWO_PWR_64_DBL / 2;

/**
 * @type {!Long}
 * @const
 * @inner
 */
var TWO_PWR_24 = fromInt(TWO_PWR_24_DBL);

/**
 * @type {!Long}
 * @inner
 */
var ZERO = fromInt(0);

/**
 * Signed zero.
 * @type {!Long}
 */
Long.ZERO = ZERO;

/**
 * @type {!Long}
 * @inner
 */
var UZERO = fromInt(0, true);

/**
 * Unsigned zero.
 * @type {!Long}
 */
Long.UZERO = UZERO;

/**
 * @type {!Long}
 * @inner
 */
var ONE = fromInt(1);

/**
 * Signed one.
 * @type {!Long}
 */
Long.ONE = ONE;

/**
 * @type {!Long}
 * @inner
 */
var UONE = fromInt(1, true);

/**
 * Unsigned one.
 * @type {!Long}
 */
Long.UONE = UONE;

/**
 * @type {!Long}
 * @inner
 */
var NEG_ONE = fromInt(-1);

/**
 * Signed negative one.
 * @type {!Long}
 */
Long.NEG_ONE = NEG_ONE;

/**
 * @type {!Long}
 * @inner
 */
var MAX_VALUE = fromBits(0xFFFFFFFF|0, 0x7FFFFFFF|0, false);

/**
 * Maximum signed value.
 * @type {!Long}
 */
Long.MAX_VALUE = MAX_VALUE;

/**
 * @type {!Long}
 * @inner
 */
var MAX_UNSIGNED_VALUE = fromBits(0xFFFFFFFF|0, 0xFFFFFFFF|0, true);

/**
 * Maximum unsigned value.
 * @type {!Long}
 */
Long.MAX_UNSIGNED_VALUE = MAX_UNSIGNED_VALUE;

/**
 * @type {!Long}
 * @inner
 */
var MIN_VALUE = fromBits(0, 0x80000000|0, false);

/**
 * Minimum signed value.
 * @type {!Long}
 */
Long.MIN_VALUE = MIN_VALUE;

/**
 * @alias Long.prototype
 * @inner
 */
var LongPrototype = Long.prototype;

/**
 * Converts the Long to a 32 bit integer, assuming it is a 32 bit integer.
 * @returns {number}
 */
LongPrototype.toInt = function toInt() {
    return this.unsigned ? this.low >>> 0 : this.low;
};

/**
 * Converts the Long to a the nearest floating-point representation of this value (double, 53 bit mantissa).
 * @returns {number}
 */
LongPrototype.toNumber = function toNumber() {
    if (this.unsigned)
        return ((this.high >>> 0) * TWO_PWR_32_DBL) + (this.low >>> 0);
    return this.high * TWO_PWR_32_DBL + (this.low >>> 0);
};

/**
 * Converts the Long to a string written in the specified radix.
 * @param {number=} radix Radix (2-36), defaults to 10
 * @returns {string}
 * @override
 * @throws {RangeError} If `radix` is out of range
 */
LongPrototype.toString = function toString(radix) {
    radix = radix || 10;
    if (radix < 2 || 36 < radix)
        throw RangeError('radix');
    if (this.isZero())
        return '0';
    if (this.isNegative()) { // Unsigned Longs are never negative
        if (this.eq(MIN_VALUE)) {
            // We need to change the Long value before it can be negated, so we remove
            // the bottom-most digit in this base and then recurse to do the rest.
            var radixLong = fromNumber(radix),
                div = this.div(radixLong),
                rem1 = div.mul(radixLong).sub(this);
            return div.toString(radix) + rem1.toInt().toString(radix);
        } else
            return '-' + this.neg().toString(radix);
    }

    // Do several (6) digits each time through the loop, so as to
    // minimize the calls to the very expensive emulated div.
    var radixToPower = fromNumber(pow_dbl(radix, 6), this.unsigned),
        rem = this;
    var result = '';
    while (true) {
        var remDiv = rem.div(radixToPower),
            intval = rem.sub(remDiv.mul(radixToPower)).toInt() >>> 0,
            digits = intval.toString(radix);
        rem = remDiv;
        if (rem.isZero())
            return digits + result;
        else {
            while (digits.length < 6)
                digits = '0' + digits;
            result = '' + digits + result;
        }
    }
};

/**
 * Gets the high 32 bits as a signed integer.
 * @returns {number} Signed high bits
 */
LongPrototype.getHighBits = function getHighBits() {
    return this.high;
};

/**
 * Gets the high 32 bits as an unsigned integer.
 * @returns {number} Unsigned high bits
 */
LongPrototype.getHighBitsUnsigned = function getHighBitsUnsigned() {
    return this.high >>> 0;
};

/**
 * Gets the low 32 bits as a signed integer.
 * @returns {number} Signed low bits
 */
LongPrototype.getLowBits = function getLowBits() {
    return this.low;
};

/**
 * Gets the low 32 bits as an unsigned integer.
 * @returns {number} Unsigned low bits
 */
LongPrototype.getLowBitsUnsigned = function getLowBitsUnsigned() {
    return this.low >>> 0;
};

/**
 * Gets the number of bits needed to represent the absolute value of this Long.
 * @returns {number}
 */
LongPrototype.getNumBitsAbs = function getNumBitsAbs() {
    if (this.isNegative()) // Unsigned Longs are never negative
        return this.eq(MIN_VALUE) ? 64 : this.neg().getNumBitsAbs();
    var val = this.high != 0 ? this.high : this.low;
    for (var bit = 31; bit > 0; bit--)
        if ((val & (1 << bit)) != 0)
            break;
    return this.high != 0 ? bit + 33 : bit + 1;
};

/**
 * Tests if this Long's value equals zero.
 * @returns {boolean}
 */
LongPrototype.isZero = function isZero() {
    return this.high === 0 && this.low === 0;
};

/**
 * Tests if this Long's value equals zero. This is an alias of {@link Long#isZero}.
 * @returns {boolean}
 */
LongPrototype.eqz = LongPrototype.isZero;

/**
 * Tests if this Long's value is negative.
 * @returns {boolean}
 */
LongPrototype.isNegative = function isNegative() {
    return !this.unsigned && this.high < 0;
};

/**
 * Tests if this Long's value is positive.
 * @returns {boolean}
 */
LongPrototype.isPositive = function isPositive() {
    return this.unsigned || this.high >= 0;
};

/**
 * Tests if this Long's value is odd.
 * @returns {boolean}
 */
LongPrototype.isOdd = function isOdd() {
    return (this.low & 1) === 1;
};

/**
 * Tests if this Long's value is even.
 * @returns {boolean}
 */
LongPrototype.isEven = function isEven() {
    return (this.low & 1) === 0;
};

/**
 * Tests if this Long's value equals the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */
LongPrototype.equals = function equals(other) {
    if (!isLong(other))
        other = fromValue(other);
    if (this.unsigned !== other.unsigned && (this.high >>> 31) === 1 && (other.high >>> 31) === 1)
        return false;
    return this.high === other.high && this.low === other.low;
};

/**
 * Tests if this Long's value equals the specified's. This is an alias of {@link Long#equals}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */
LongPrototype.eq = LongPrototype.equals;

/**
 * Tests if this Long's value differs from the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */
LongPrototype.notEquals = function notEquals(other) {
    return !this.eq(/* validates */ other);
};

/**
 * Tests if this Long's value differs from the specified's. This is an alias of {@link Long#notEquals}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */
LongPrototype.neq = LongPrototype.notEquals;

/**
 * Tests if this Long's value differs from the specified's. This is an alias of {@link Long#notEquals}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */
LongPrototype.ne = LongPrototype.notEquals;

/**
 * Tests if this Long's value is less than the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */
LongPrototype.lessThan = function lessThan(other) {
    return this.comp(/* validates */ other) < 0;
};

/**
 * Tests if this Long's value is less than the specified's. This is an alias of {@link Long#lessThan}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */
LongPrototype.lt = LongPrototype.lessThan;

/**
 * Tests if this Long's value is less than or equal the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */
LongPrototype.lessThanOrEqual = function lessThanOrEqual(other) {
    return this.comp(/* validates */ other) <= 0;
};

/**
 * Tests if this Long's value is less than or equal the specified's. This is an alias of {@link Long#lessThanOrEqual}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */
LongPrototype.lte = LongPrototype.lessThanOrEqual;

/**
 * Tests if this Long's value is less than or equal the specified's. This is an alias of {@link Long#lessThanOrEqual}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */
LongPrototype.le = LongPrototype.lessThanOrEqual;

/**
 * Tests if this Long's value is greater than the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */
LongPrototype.greaterThan = function greaterThan(other) {
    return this.comp(/* validates */ other) > 0;
};

/**
 * Tests if this Long's value is greater than the specified's. This is an alias of {@link Long#greaterThan}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */
LongPrototype.gt = LongPrototype.greaterThan;

/**
 * Tests if this Long's value is greater than or equal the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */
LongPrototype.greaterThanOrEqual = function greaterThanOrEqual(other) {
    return this.comp(/* validates */ other) >= 0;
};

/**
 * Tests if this Long's value is greater than or equal the specified's. This is an alias of {@link Long#greaterThanOrEqual}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */
LongPrototype.gte = LongPrototype.greaterThanOrEqual;

/**
 * Tests if this Long's value is greater than or equal the specified's. This is an alias of {@link Long#greaterThanOrEqual}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */
LongPrototype.ge = LongPrototype.greaterThanOrEqual;

/**
 * Compares this Long's value with the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {number} 0 if they are the same, 1 if the this is greater and -1
 *  if the given one is greater
 */
LongPrototype.compare = function compare(other) {
    if (!isLong(other))
        other = fromValue(other);
    if (this.eq(other))
        return 0;
    var thisNeg = this.isNegative(),
        otherNeg = other.isNegative();
    if (thisNeg && !otherNeg)
        return -1;
    if (!thisNeg && otherNeg)
        return 1;
    // At this point the sign bits are the same
    if (!this.unsigned)
        return this.sub(other).isNegative() ? -1 : 1;
    // Both are positive if at least one is unsigned
    return (other.high >>> 0) > (this.high >>> 0) || (other.high === this.high && (other.low >>> 0) > (this.low >>> 0)) ? -1 : 1;
};

/**
 * Compares this Long's value with the specified's. This is an alias of {@link Long#compare}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {number} 0 if they are the same, 1 if the this is greater and -1
 *  if the given one is greater
 */
LongPrototype.comp = LongPrototype.compare;

/**
 * Negates this Long's value.
 * @returns {!Long} Negated Long
 */
LongPrototype.negate = function negate() {
    if (!this.unsigned && this.eq(MIN_VALUE))
        return MIN_VALUE;
    return this.not().add(ONE);
};

/**
 * Negates this Long's value. This is an alias of {@link Long#negate}.
 * @function
 * @returns {!Long} Negated Long
 */
LongPrototype.neg = LongPrototype.negate;

/**
 * Returns the sum of this and the specified Long.
 * @param {!Long|number|string} addend Addend
 * @returns {!Long} Sum
 */
LongPrototype.add = function add(addend) {
    if (!isLong(addend))
        addend = fromValue(addend);

    // Divide each number into 4 chunks of 16 bits, and then sum the chunks.

    var a48 = this.high >>> 16;
    var a32 = this.high & 0xFFFF;
    var a16 = this.low >>> 16;
    var a00 = this.low & 0xFFFF;

    var b48 = addend.high >>> 16;
    var b32 = addend.high & 0xFFFF;
    var b16 = addend.low >>> 16;
    var b00 = addend.low & 0xFFFF;

    var c48 = 0, c32 = 0, c16 = 0, c00 = 0;
    c00 += a00 + b00;
    c16 += c00 >>> 16;
    c00 &= 0xFFFF;
    c16 += a16 + b16;
    c32 += c16 >>> 16;
    c16 &= 0xFFFF;
    c32 += a32 + b32;
    c48 += c32 >>> 16;
    c32 &= 0xFFFF;
    c48 += a48 + b48;
    c48 &= 0xFFFF;
    return fromBits((c16 << 16) | c00, (c48 << 16) | c32, this.unsigned);
};

/**
 * Returns the difference of this and the specified Long.
 * @param {!Long|number|string} subtrahend Subtrahend
 * @returns {!Long} Difference
 */
LongPrototype.subtract = function subtract(subtrahend) {
    if (!isLong(subtrahend))
        subtrahend = fromValue(subtrahend);
    return this.add(subtrahend.neg());
};

/**
 * Returns the difference of this and the specified Long. This is an alias of {@link Long#subtract}.
 * @function
 * @param {!Long|number|string} subtrahend Subtrahend
 * @returns {!Long} Difference
 */
LongPrototype.sub = LongPrototype.subtract;

/**
 * Returns the product of this and the specified Long.
 * @param {!Long|number|string} multiplier Multiplier
 * @returns {!Long} Product
 */
LongPrototype.multiply = function multiply(multiplier) {
    if (this.isZero())
        return ZERO;
    if (!isLong(multiplier))
        multiplier = fromValue(multiplier);

    // use wasm support if present
    if (wasm) {
        var low = wasm.mul(this.low,
                           this.high,
                           multiplier.low,
                           multiplier.high);
        return fromBits(low, wasm.get_high(), this.unsigned);
    }

    if (multiplier.isZero())
        return ZERO;
    if (this.eq(MIN_VALUE))
        return multiplier.isOdd() ? MIN_VALUE : ZERO;
    if (multiplier.eq(MIN_VALUE))
        return this.isOdd() ? MIN_VALUE : ZERO;

    if (this.isNegative()) {
        if (multiplier.isNegative())
            return this.neg().mul(multiplier.neg());
        else
            return this.neg().mul(multiplier).neg();
    } else if (multiplier.isNegative())
        return this.mul(multiplier.neg()).neg();

    // If both longs are small, use float multiplication
    if (this.lt(TWO_PWR_24) && multiplier.lt(TWO_PWR_24))
        return fromNumber(this.toNumber() * multiplier.toNumber(), this.unsigned);

    // Divide each long into 4 chunks of 16 bits, and then add up 4x4 products.
    // We can skip products that would overflow.

    var a48 = this.high >>> 16;
    var a32 = this.high & 0xFFFF;
    var a16 = this.low >>> 16;
    var a00 = this.low & 0xFFFF;

    var b48 = multiplier.high >>> 16;
    var b32 = multiplier.high & 0xFFFF;
    var b16 = multiplier.low >>> 16;
    var b00 = multiplier.low & 0xFFFF;

    var c48 = 0, c32 = 0, c16 = 0, c00 = 0;
    c00 += a00 * b00;
    c16 += c00 >>> 16;
    c00 &= 0xFFFF;
    c16 += a16 * b00;
    c32 += c16 >>> 16;
    c16 &= 0xFFFF;
    c16 += a00 * b16;
    c32 += c16 >>> 16;
    c16 &= 0xFFFF;
    c32 += a32 * b00;
    c48 += c32 >>> 16;
    c32 &= 0xFFFF;
    c32 += a16 * b16;
    c48 += c32 >>> 16;
    c32 &= 0xFFFF;
    c32 += a00 * b32;
    c48 += c32 >>> 16;
    c32 &= 0xFFFF;
    c48 += a48 * b00 + a32 * b16 + a16 * b32 + a00 * b48;
    c48 &= 0xFFFF;
    return fromBits((c16 << 16) | c00, (c48 << 16) | c32, this.unsigned);
};

/**
 * Returns the product of this and the specified Long. This is an alias of {@link Long#multiply}.
 * @function
 * @param {!Long|number|string} multiplier Multiplier
 * @returns {!Long} Product
 */
LongPrototype.mul = LongPrototype.multiply;

/**
 * Returns this Long divided by the specified. The result is signed if this Long is signed or
 *  unsigned if this Long is unsigned.
 * @param {!Long|number|string} divisor Divisor
 * @returns {!Long} Quotient
 */
LongPrototype.divide = function divide(divisor) {
    if (!isLong(divisor))
        divisor = fromValue(divisor);
    if (divisor.isZero())
        throw Error('division by zero');

    // use wasm support if present
    if (wasm) {
        // guard against signed division overflow: the largest
        // negative number / -1 would be 1 larger than the largest
        // positive number, due to two's complement.
        if (!this.unsigned &&
            this.high === -0x80000000 &&
            divisor.low === -1 && divisor.high === -1) {
            // be consistent with non-wasm code path
            return this;
        }
        var low = (this.unsigned ? wasm.div_u : wasm.div_s)(
            this.low,
            this.high,
            divisor.low,
            divisor.high
        );
        return fromBits(low, wasm.get_high(), this.unsigned);
    }

    if (this.isZero())
        return this.unsigned ? UZERO : ZERO;
    var approx, rem, res;
    if (!this.unsigned) {
        // This section is only relevant for signed longs and is derived from the
        // closure library as a whole.
        if (this.eq(MIN_VALUE)) {
            if (divisor.eq(ONE) || divisor.eq(NEG_ONE))
                return MIN_VALUE;  // recall that -MIN_VALUE == MIN_VALUE
            else if (divisor.eq(MIN_VALUE))
                return ONE;
            else {
                // At this point, we have |other| >= 2, so |this/other| < |MIN_VALUE|.
                var halfThis = this.shr(1);
                approx = halfThis.div(divisor).shl(1);
                if (approx.eq(ZERO)) {
                    return divisor.isNegative() ? ONE : NEG_ONE;
                } else {
                    rem = this.sub(divisor.mul(approx));
                    res = approx.add(rem.div(divisor));
                    return res;
                }
            }
        } else if (divisor.eq(MIN_VALUE))
            return this.unsigned ? UZERO : ZERO;
        if (this.isNegative()) {
            if (divisor.isNegative())
                return this.neg().div(divisor.neg());
            return this.neg().div(divisor).neg();
        } else if (divisor.isNegative())
            return this.div(divisor.neg()).neg();
        res = ZERO;
    } else {
        // The algorithm below has not been made for unsigned longs. It's therefore
        // required to take special care of the MSB prior to running it.
        if (!divisor.unsigned)
            divisor = divisor.toUnsigned();
        if (divisor.gt(this))
            return UZERO;
        if (divisor.gt(this.shru(1))) // 15 >>> 1 = 7 ; with divisor = 8 ; true
            return UONE;
        res = UZERO;
    }

    // Repeat the following until the remainder is less than other:  find a
    // floating-point that approximates remainder / other *from below*, add this
    // into the result, and subtract it from the remainder.  It is critical that
    // the approximate value is less than or equal to the real value so that the
    // remainder never becomes negative.
    rem = this;
    while (rem.gte(divisor)) {
        // Approximate the result of division. This may be a little greater or
        // smaller than the actual value.
        approx = Math.max(1, Math.floor(rem.toNumber() / divisor.toNumber()));

        // We will tweak the approximate result by changing it in the 48-th digit or
        // the smallest non-fractional digit, whichever is larger.
        var log2 = Math.ceil(Math.log(approx) / Math.LN2),
            delta = (log2 <= 48) ? 1 : pow_dbl(2, log2 - 48),

        // Decrease the approximation until it is smaller than the remainder.  Note
        // that if it is too large, the product overflows and is negative.
            approxRes = fromNumber(approx),
            approxRem = approxRes.mul(divisor);
        while (approxRem.isNegative() || approxRem.gt(rem)) {
            approx -= delta;
            approxRes = fromNumber(approx, this.unsigned);
            approxRem = approxRes.mul(divisor);
        }

        // We know the answer can't be zero... and actually, zero would cause
        // infinite recursion since we would make no progress.
        if (approxRes.isZero())
            approxRes = ONE;

        res = res.add(approxRes);
        rem = rem.sub(approxRem);
    }
    return res;
};

/**
 * Returns this Long divided by the specified. This is an alias of {@link Long#divide}.
 * @function
 * @param {!Long|number|string} divisor Divisor
 * @returns {!Long} Quotient
 */
LongPrototype.div = LongPrototype.divide;

/**
 * Returns this Long modulo the specified.
 * @param {!Long|number|string} divisor Divisor
 * @returns {!Long} Remainder
 */
LongPrototype.modulo = function modulo(divisor) {
    if (!isLong(divisor))
        divisor = fromValue(divisor);

    // use wasm support if present
    if (wasm) {
        var low = (this.unsigned ? wasm.rem_u : wasm.rem_s)(
            this.low,
            this.high,
            divisor.low,
            divisor.high
        );
        return fromBits(low, wasm.get_high(), this.unsigned);
    }

    return this.sub(this.div(divisor).mul(divisor));
};

/**
 * Returns this Long modulo the specified. This is an alias of {@link Long#modulo}.
 * @function
 * @param {!Long|number|string} divisor Divisor
 * @returns {!Long} Remainder
 */
LongPrototype.mod = LongPrototype.modulo;

/**
 * Returns this Long modulo the specified. This is an alias of {@link Long#modulo}.
 * @function
 * @param {!Long|number|string} divisor Divisor
 * @returns {!Long} Remainder
 */
LongPrototype.rem = LongPrototype.modulo;

/**
 * Returns the bitwise NOT of this Long.
 * @returns {!Long}
 */
LongPrototype.not = function not() {
    return fromBits(~this.low, ~this.high, this.unsigned);
};

/**
 * Returns the bitwise AND of this Long and the specified.
 * @param {!Long|number|string} other Other Long
 * @returns {!Long}
 */
LongPrototype.and = function and(other) {
    if (!isLong(other))
        other = fromValue(other);
    return fromBits(this.low & other.low, this.high & other.high, this.unsigned);
};

/**
 * Returns the bitwise OR of this Long and the specified.
 * @param {!Long|number|string} other Other Long
 * @returns {!Long}
 */
LongPrototype.or = function or(other) {
    if (!isLong(other))
        other = fromValue(other);
    return fromBits(this.low | other.low, this.high | other.high, this.unsigned);
};

/**
 * Returns the bitwise XOR of this Long and the given one.
 * @param {!Long|number|string} other Other Long
 * @returns {!Long}
 */
LongPrototype.xor = function xor(other) {
    if (!isLong(other))
        other = fromValue(other);
    return fromBits(this.low ^ other.low, this.high ^ other.high, this.unsigned);
};

/**
 * Returns this Long with bits shifted to the left by the given amount.
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */
LongPrototype.shiftLeft = function shiftLeft(numBits) {
    if (isLong(numBits))
        numBits = numBits.toInt();
    if ((numBits &= 63) === 0)
        return this;
    else if (numBits < 32)
        return fromBits(this.low << numBits, (this.high << numBits) | (this.low >>> (32 - numBits)), this.unsigned);
    else
        return fromBits(0, this.low << (numBits - 32), this.unsigned);
};

/**
 * Returns this Long with bits shifted to the left by the given amount. This is an alias of {@link Long#shiftLeft}.
 * @function
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */
LongPrototype.shl = LongPrototype.shiftLeft;

/**
 * Returns this Long with bits arithmetically shifted to the right by the given amount.
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */
LongPrototype.shiftRight = function shiftRight(numBits) {
    if (isLong(numBits))
        numBits = numBits.toInt();
    if ((numBits &= 63) === 0)
        return this;
    else if (numBits < 32)
        return fromBits((this.low >>> numBits) | (this.high << (32 - numBits)), this.high >> numBits, this.unsigned);
    else
        return fromBits(this.high >> (numBits - 32), this.high >= 0 ? 0 : -1, this.unsigned);
};

/**
 * Returns this Long with bits arithmetically shifted to the right by the given amount. This is an alias of {@link Long#shiftRight}.
 * @function
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */
LongPrototype.shr = LongPrototype.shiftRight;

/**
 * Returns this Long with bits logically shifted to the right by the given amount.
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */
LongPrototype.shiftRightUnsigned = function shiftRightUnsigned(numBits) {
    if (isLong(numBits))
        numBits = numBits.toInt();
    numBits &= 63;
    if (numBits === 0)
        return this;
    else {
        var high = this.high;
        if (numBits < 32) {
            var low = this.low;
            return fromBits((low >>> numBits) | (high << (32 - numBits)), high >>> numBits, this.unsigned);
        } else if (numBits === 32)
            return fromBits(high, 0, this.unsigned);
        else
            return fromBits(high >>> (numBits - 32), 0, this.unsigned);
    }
};

/**
 * Returns this Long with bits logically shifted to the right by the given amount. This is an alias of {@link Long#shiftRightUnsigned}.
 * @function
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */
LongPrototype.shru = LongPrototype.shiftRightUnsigned;

/**
 * Returns this Long with bits logically shifted to the right by the given amount. This is an alias of {@link Long#shiftRightUnsigned}.
 * @function
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */
LongPrototype.shr_u = LongPrototype.shiftRightUnsigned;

/**
 * Converts this Long to signed.
 * @returns {!Long} Signed long
 */
LongPrototype.toSigned = function toSigned() {
    if (!this.unsigned)
        return this;
    return fromBits(this.low, this.high, false);
};

/**
 * Converts this Long to unsigned.
 * @returns {!Long} Unsigned long
 */
LongPrototype.toUnsigned = function toUnsigned() {
    if (this.unsigned)
        return this;
    return fromBits(this.low, this.high, true);
};

/**
 * Converts this Long to its byte representation.
 * @param {boolean=} le Whether little or big endian, defaults to big endian
 * @returns {!Array.<number>} Byte representation
 */
LongPrototype.toBytes = function toBytes(le) {
    return le ? this.toBytesLE() : this.toBytesBE();
};

/**
 * Converts this Long to its little endian byte representation.
 * @returns {!Array.<number>} Little endian byte representation
 */
LongPrototype.toBytesLE = function toBytesLE() {
    var hi = this.high,
        lo = this.low;
    return [
        lo        & 0xff,
        lo >>>  8 & 0xff,
        lo >>> 16 & 0xff,
        lo >>> 24       ,
        hi        & 0xff,
        hi >>>  8 & 0xff,
        hi >>> 16 & 0xff,
        hi >>> 24
    ];
};

/**
 * Converts this Long to its big endian byte representation.
 * @returns {!Array.<number>} Big endian byte representation
 */
LongPrototype.toBytesBE = function toBytesBE() {
    var hi = this.high,
        lo = this.low;
    return [
        hi >>> 24       ,
        hi >>> 16 & 0xff,
        hi >>>  8 & 0xff,
        hi        & 0xff,
        lo >>> 24       ,
        lo >>> 16 & 0xff,
        lo >>>  8 & 0xff,
        lo        & 0xff
    ];
};

/**
 * Creates a Long from its byte representation.
 * @param {!Array.<number>} bytes Byte representation
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @param {boolean=} le Whether little or big endian, defaults to big endian
 * @returns {Long} The corresponding Long value
 */
Long.fromBytes = function fromBytes(bytes, unsigned, le) {
    return le ? Long.fromBytesLE(bytes, unsigned) : Long.fromBytesBE(bytes, unsigned);
};

/**
 * Creates a Long from its little endian byte representation.
 * @param {!Array.<number>} bytes Little endian byte representation
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {Long} The corresponding Long value
 */
Long.fromBytesLE = function fromBytesLE(bytes, unsigned) {
    return new Long(
        bytes[0]       |
        bytes[1] <<  8 |
        bytes[2] << 16 |
        bytes[3] << 24,
        bytes[4]       |
        bytes[5] <<  8 |
        bytes[6] << 16 |
        bytes[7] << 24,
        unsigned
    );
};

/**
 * Creates a Long from its big endian byte representation.
 * @param {!Array.<number>} bytes Big endian byte representation
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {Long} The corresponding Long value
 */
Long.fromBytesBE = function fromBytesBE(bytes, unsigned) {
    return new Long(
        bytes[4] << 24 |
        bytes[5] << 16 |
        bytes[6] <<  8 |
        bytes[7],
        bytes[0] << 24 |
        bytes[1] << 16 |
        bytes[2] <<  8 |
        bytes[3],
        unsigned
    );
};


/***/ }),

/***/ 24324:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.pubkeyToAddress = exports.pubkeyToRawAddress = exports.rawSecp256k1PubkeyToRawAddress = exports.rawEd25519PubkeyToRawAddress = void 0;
const crypto_1 = __webpack_require__(79562);
const encoding_1 = __webpack_require__(71555);
function rawEd25519PubkeyToRawAddress(pubkeyData) {
    if (pubkeyData.length !== 32) {
        throw new Error(`Invalid Ed25519 pubkey length: ${pubkeyData.length}`);
    }
    return (0, crypto_1.sha256)(pubkeyData).slice(0, 20);
}
exports.rawEd25519PubkeyToRawAddress = rawEd25519PubkeyToRawAddress;
function rawSecp256k1PubkeyToRawAddress(pubkeyData) {
    if (pubkeyData.length !== 33) {
        throw new Error(`Invalid Secp256k1 pubkey length (compressed): ${pubkeyData.length}`);
    }
    return (0, crypto_1.ripemd160)((0, crypto_1.sha256)(pubkeyData));
}
exports.rawSecp256k1PubkeyToRawAddress = rawSecp256k1PubkeyToRawAddress;
/**
 * Returns Tendermint address as bytes.
 *
 * This is for addresses that are derived by the Tendermint keypair (typically Ed25519).
 * Sometimes those addresses are bech32-encoded and contain the term "cons" in the presix
 * ("cosmosvalcons1...").
 *
 * For secp256k1 this assumes we already have a compressed pubkey, which is the default in Cosmos.
 */
function pubkeyToRawAddress(type, data) {
    switch (type) {
        case "ed25519":
            return rawEd25519PubkeyToRawAddress(data);
        case "secp256k1":
            return rawSecp256k1PubkeyToRawAddress(data);
        default:
            // Keep this case here to guard against new types being added but not handled
            throw new Error(`Pubkey type ${type} not supported`);
    }
}
exports.pubkeyToRawAddress = pubkeyToRawAddress;
/**
 * Returns Tendermint address in uppercase hex format.
 *
 * This is for addresses that are derived by the Tendermint keypair (typically Ed25519).
 * Sometimes those addresses are bech32-encoded and contain the term "cons" in the presix
 * ("cosmosvalcons1...").
 *
 * For secp256k1 this assumes we already have a compressed pubkey, which is the default in Cosmos.
 */
function pubkeyToAddress(type, data) {
    return (0, encoding_1.toHex)(pubkeyToRawAddress(type, data)).toUpperCase();
}
exports.pubkeyToAddress = pubkeyToAddress;
//# sourceMappingURL=addresses.js.map

/***/ }),

/***/ 6405:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.DateTime = exports.toSeconds = exports.fromSeconds = exports.toRfc3339WithNanoseconds = exports.fromRfc3339WithNanoseconds = void 0;
const encoding_1 = __webpack_require__(71555);
const math_1 = __webpack_require__(62949);
function fromRfc3339WithNanoseconds(dateTimeString) {
    const out = (0, encoding_1.fromRfc3339)(dateTimeString);
    const nanosecondsMatch = dateTimeString.match(/\.(\d+)Z$/);
    const nanoseconds = nanosecondsMatch ? nanosecondsMatch[1].slice(3) : "";
    out.nanoseconds = parseInt(nanoseconds.padEnd(6, "0"), 10);
    return out;
}
exports.fromRfc3339WithNanoseconds = fromRfc3339WithNanoseconds;
function toRfc3339WithNanoseconds(dateTime) {
    var _a, _b;
    const millisecondIso = dateTime.toISOString();
    const nanoseconds = (_b = (_a = dateTime.nanoseconds) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : "";
    return `${millisecondIso.slice(0, -1)}${nanoseconds.padStart(6, "0")}Z`;
}
exports.toRfc3339WithNanoseconds = toRfc3339WithNanoseconds;
function fromSeconds(seconds, nanos = 0) {
    const checkedNanos = new math_1.Uint32(nanos).toNumber();
    if (checkedNanos > 999999999) {
        throw new Error("Nano seconds must not exceed 999999999");
    }
    const out = new Date(seconds * 1000 + Math.floor(checkedNanos / 1000000));
    out.nanoseconds = checkedNanos % 1000000;
    return out;
}
exports.fromSeconds = fromSeconds;
/**
 * Calculates the UNIX timestamp in seconds as well as the nanoseconds after the given second.
 *
 * This is useful when dealing with external systems like the protobuf type
 * [.google.protobuf.Timestamp](https://developers.google.com/protocol-buffers/docs/reference/google.protobuf#google.protobuf.Timestamp)
 * or any other system that does not use millisecond precision.
 */
function toSeconds(date) {
    var _a;
    return {
        seconds: Math.floor(date.getTime() / 1000),
        nanos: (date.getTime() % 1000) * 1000000 + ((_a = date.nanoseconds) !== null && _a !== void 0 ? _a : 0),
    };
}
exports.toSeconds = toSeconds;
/** @deprecated Use fromRfc3339WithNanoseconds/toRfc3339WithNanoseconds instead */
class DateTime {
    /** @deprecated Use fromRfc3339WithNanoseconds instead */
    static decode(dateTimeString) {
        return fromRfc3339WithNanoseconds(dateTimeString);
    }
    /** @deprecated Use toRfc3339WithNanoseconds instead */
    static encode(dateTime) {
        return toRfc3339WithNanoseconds(dateTime);
    }
}
exports.DateTime = DateTime;
//# sourceMappingURL=dates.js.map

/***/ }),

/***/ 13482:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.BlockIdFlag = exports.Tendermint34Client = exports.tendermint34 = exports.VoteType = exports.SubscriptionEventType = exports.Method = exports.broadcastTxSyncSuccess = exports.broadcastTxCommitSuccess = exports.WebsocketClient = exports.HttpClient = exports.HttpBatchClient = exports.toSeconds = exports.toRfc3339WithNanoseconds = exports.fromSeconds = exports.fromRfc3339WithNanoseconds = exports.DateTime = exports.rawSecp256k1PubkeyToRawAddress = exports.rawEd25519PubkeyToRawAddress = exports.pubkeyToRawAddress = exports.pubkeyToAddress = void 0;
var addresses_1 = __webpack_require__(24324);
Object.defineProperty(exports, "pubkeyToAddress", ({ enumerable: true, get: function () { return addresses_1.pubkeyToAddress; } }));
Object.defineProperty(exports, "pubkeyToRawAddress", ({ enumerable: true, get: function () { return addresses_1.pubkeyToRawAddress; } }));
Object.defineProperty(exports, "rawEd25519PubkeyToRawAddress", ({ enumerable: true, get: function () { return addresses_1.rawEd25519PubkeyToRawAddress; } }));
Object.defineProperty(exports, "rawSecp256k1PubkeyToRawAddress", ({ enumerable: true, get: function () { return addresses_1.rawSecp256k1PubkeyToRawAddress; } }));
var dates_1 = __webpack_require__(6405);
Object.defineProperty(exports, "DateTime", ({ enumerable: true, get: function () { return dates_1.DateTime; } }));
Object.defineProperty(exports, "fromRfc3339WithNanoseconds", ({ enumerable: true, get: function () { return dates_1.fromRfc3339WithNanoseconds; } }));
Object.defineProperty(exports, "fromSeconds", ({ enumerable: true, get: function () { return dates_1.fromSeconds; } }));
Object.defineProperty(exports, "toRfc3339WithNanoseconds", ({ enumerable: true, get: function () { return dates_1.toRfc3339WithNanoseconds; } }));
Object.defineProperty(exports, "toSeconds", ({ enumerable: true, get: function () { return dates_1.toSeconds; } }));
// The public Tendermint34Client.create constructor allows manually choosing an RpcClient.
// This is currently the only way to switch to the HttpBatchClient (which may become default at some point).
// Due to this API, we make RPC client implementations public.
var rpcclients_1 = __webpack_require__(30652);
Object.defineProperty(exports, "HttpBatchClient", ({ enumerable: true, get: function () { return rpcclients_1.HttpBatchClient; } }));
Object.defineProperty(exports, "HttpClient", ({ enumerable: true, get: function () { return rpcclients_1.HttpClient; } }));
Object.defineProperty(exports, "WebsocketClient", ({ enumerable: true, get: function () { return rpcclients_1.WebsocketClient; } }));
var tendermint34_1 = __webpack_require__(59818);
Object.defineProperty(exports, "broadcastTxCommitSuccess", ({ enumerable: true, get: function () { return tendermint34_1.broadcastTxCommitSuccess; } }));
Object.defineProperty(exports, "broadcastTxSyncSuccess", ({ enumerable: true, get: function () { return tendermint34_1.broadcastTxSyncSuccess; } }));
Object.defineProperty(exports, "Method", ({ enumerable: true, get: function () { return tendermint34_1.Method; } }));
Object.defineProperty(exports, "SubscriptionEventType", ({ enumerable: true, get: function () { return tendermint34_1.SubscriptionEventType; } }));
Object.defineProperty(exports, "VoteType", ({ enumerable: true, get: function () { return tendermint34_1.VoteType; } }));
exports.tendermint34 = __importStar(__webpack_require__(59818));
var tendermint34_2 = __webpack_require__(59818);
Object.defineProperty(exports, "Tendermint34Client", ({ enumerable: true, get: function () { return tendermint34_2.Tendermint34Client; } }));
// Tendermint 0.35 support is not public. The implementation may break or be removed at any point in time.
// See https://github.com/cosmos/cosmjs/issues/1225 for more context.
// export * as tendermint35 from "./tendermint35";
// export { Tendermint35Client } from "./tendermint35";
var types_1 = __webpack_require__(36023);
Object.defineProperty(exports, "BlockIdFlag", ({ enumerable: true, get: function () { return types_1.BlockIdFlag; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 32340:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.smallIntToApi = exports.apiToBigInt = exports.apiToSmallInt = void 0;
const math_1 = __webpack_require__(62949);
const encodings_1 = __webpack_require__(5179);
/**
 * Takes an integer value from the Tendermint RPC API and
 * returns it as number.
 *
 * Only works within the safe integer range.
 */
function apiToSmallInt(input) {
    const asInt = typeof input === "number" ? new math_1.Int53(input) : math_1.Int53.fromString(input);
    return asInt.toNumber();
}
exports.apiToSmallInt = apiToSmallInt;
/**
 * Takes an integer value from the Tendermint RPC API and
 * returns it as BigInt.
 *
 * This supports the full uint64 and int64 ranges.
 */
function apiToBigInt(input) {
    (0, encodings_1.assertString)(input); // Runtime check on top of TypeScript just to be safe for semi-trusted API types
    if (!input.match(/^-?[0-9]+$/)) {
        throw new Error("Invalid string format");
    }
    return BigInt(input);
}
exports.apiToBigInt = apiToBigInt;
/**
 * Takes an integer in the safe integer range and returns
 * a string representation to be used in the Tendermint RPC API.
 */
function smallIntToApi(num) {
    return new math_1.Int53(num).toString();
}
exports.smallIntToApi = smallIntToApi;
//# sourceMappingURL=inthelpers.js.map

/***/ }),

/***/ 49485:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.createJsonRpcRequest = void 0;
const numbersWithoutZero = "123456789";
/** generates a random numeric character  */
function randomNumericChar() {
    return numbersWithoutZero[Math.floor(Math.random() * numbersWithoutZero.length)];
}
/**
 * An (absolutely not cryptographically secure) random integer > 0.
 */
function randomId() {
    return parseInt(Array.from({ length: 12 })
        .map(() => randomNumericChar())
        .join(""), 10);
}
/** Creates a JSON-RPC request with random ID */
// eslint-disable-next-line @typescript-eslint/ban-types
function createJsonRpcRequest(method, params) {
    const paramsCopy = params ? { ...params } : {};
    return {
        jsonrpc: "2.0",
        id: randomId(),
        method: method,
        params: paramsCopy,
    };
}
exports.createJsonRpcRequest = createJsonRpcRequest;
//# sourceMappingURL=jsonrpc.js.map

/***/ }),

/***/ 10458:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.http = void 0;
const axios_1 = __importDefault(__webpack_require__(9669));
function filterBadStatus(res) {
    if (res.status >= 400) {
        throw new Error(`Bad status on response: ${res.status}`);
    }
    return res;
}
/**
 * Helper to work around missing CORS support in Tendermint (https://github.com/tendermint/tendermint/pull/2800)
 *
 * For some reason, fetch does not complain about missing server-side CORS support.
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
async function http(method, url, headers, request) {
    if (typeof fetch !== "undefined") {
        const settings = {
            method: method,
            body: request ? JSON.stringify(request) : undefined,
            headers: {
                // eslint-disable-next-line @typescript-eslint/naming-convention
                "Content-Type": "application/json",
                ...headers,
            },
        };
        return fetch(url, settings)
            .then(filterBadStatus)
            .then((res) => res.json());
    }
    else {
        return axios_1.default
            .request({ url: url, method: method, data: request, headers: headers })
            .then((res) => res.data);
    }
}
exports.http = http;
//# sourceMappingURL=http.js.map

/***/ }),

/***/ 17312:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.HttpBatchClient = void 0;
const json_rpc_1 = __webpack_require__(95633);
const http_1 = __webpack_require__(10458);
const rpcclient_1 = __webpack_require__(95610);
// Those values are private and can change any time.
// Does a user need to know them? I don't think so. You either set
// a custom value or leave the option field unset.
const defaultHttpBatchClientOptions = {
    dispatchInterval: 20,
    batchSizeLimit: 20,
};
class HttpBatchClient {
    constructor(endpoint, options = {}) {
        var _a, _b;
        this.queue = [];
        this.options = {
            batchSizeLimit: (_a = options.batchSizeLimit) !== null && _a !== void 0 ? _a : defaultHttpBatchClientOptions.batchSizeLimit,
            dispatchInterval: (_b = options.dispatchInterval) !== null && _b !== void 0 ? _b : defaultHttpBatchClientOptions.dispatchInterval,
        };
        if (typeof endpoint === "string") {
            // accept host.name:port and assume http protocol
            this.url = (0, rpcclient_1.hasProtocol)(endpoint) ? endpoint : "http://" + endpoint;
        }
        else {
            this.url = endpoint.url;
            this.headers = endpoint.headers;
        }
        this.timer = setInterval(() => this.tick(), options.dispatchInterval);
        this.validate();
    }
    disconnect() {
        this.timer && clearInterval(this.timer);
        this.timer = undefined;
    }
    async execute(request) {
        return new Promise((resolve, reject) => {
            this.queue.push({ request, resolve, reject });
            if (this.queue.length >= this.options.batchSizeLimit) {
                // this train is full, let's go
                this.tick();
            }
        });
    }
    validate() {
        if (!this.options.batchSizeLimit ||
            !Number.isSafeInteger(this.options.batchSizeLimit) ||
            this.options.batchSizeLimit < 1) {
            throw new Error("batchSizeLimit must be a safe integer >= 1");
        }
    }
    /**
     * This is called in an interval where promise rejections cannot be handled.
     * So this is not async and HTTP errors need to be handled by the queued promises.
     */
    tick() {
        // Avoid race conditions
        const batch = this.queue.splice(0, this.options.batchSizeLimit);
        if (!batch.length)
            return;
        const requests = batch.map((s) => s.request);
        const requestIds = requests.map((request) => request.id);
        (0, http_1.http)("POST", this.url, this.headers, requests).then((raw) => {
            // Requests with a single entry return as an object
            const arr = Array.isArray(raw) ? raw : [raw];
            arr.forEach((el) => {
                const req = batch.find((s) => s.request.id === el.id);
                if (!req)
                    return;
                const { reject, resolve } = req;
                const response = (0, json_rpc_1.parseJsonRpcResponse)(el);
                if ((0, json_rpc_1.isJsonRpcErrorResponse)(response)) {
                    reject(new Error(JSON.stringify(response.error)));
                }
                else {
                    resolve(response);
                }
            });
        }, (error) => {
            for (const requestId of requestIds) {
                const req = batch.find((s) => s.request.id === requestId);
                if (!req)
                    return;
                req.reject(error);
            }
        });
    }
}
exports.HttpBatchClient = HttpBatchClient;
//# sourceMappingURL=httpbatchclient.js.map

/***/ }),

/***/ 32244:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.HttpClient = void 0;
const json_rpc_1 = __webpack_require__(95633);
const http_1 = __webpack_require__(10458);
const rpcclient_1 = __webpack_require__(95610);
class HttpClient {
    constructor(endpoint) {
        if (typeof endpoint === "string") {
            // accept host.name:port and assume http protocol
            this.url = (0, rpcclient_1.hasProtocol)(endpoint) ? endpoint : "http://" + endpoint;
        }
        else {
            this.url = endpoint.url;
            this.headers = endpoint.headers;
        }
    }
    disconnect() {
        // nothing to be done
    }
    async execute(request) {
        const response = (0, json_rpc_1.parseJsonRpcResponse)(await (0, http_1.http)("POST", this.url, this.headers, request));
        if ((0, json_rpc_1.isJsonRpcErrorResponse)(response)) {
            throw new Error(JSON.stringify(response.error));
        }
        return response;
    }
}
exports.HttpClient = HttpClient;
//# sourceMappingURL=httpclient.js.map

/***/ }),

/***/ 30652:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

// This folder contains Tendermint-specific RPC clients
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.WebsocketClient = exports.instanceOfRpcStreamingClient = exports.HttpClient = exports.HttpBatchClient = void 0;
var httpbatchclient_1 = __webpack_require__(17312);
Object.defineProperty(exports, "HttpBatchClient", ({ enumerable: true, get: function () { return httpbatchclient_1.HttpBatchClient; } }));
var httpclient_1 = __webpack_require__(32244);
Object.defineProperty(exports, "HttpClient", ({ enumerable: true, get: function () { return httpclient_1.HttpClient; } }));
var rpcclient_1 = __webpack_require__(95610);
Object.defineProperty(exports, "instanceOfRpcStreamingClient", ({ enumerable: true, get: function () { return rpcclient_1.instanceOfRpcStreamingClient; } }));
var websocketclient_1 = __webpack_require__(83310);
Object.defineProperty(exports, "WebsocketClient", ({ enumerable: true, get: function () { return websocketclient_1.WebsocketClient; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 95610:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.hasProtocol = exports.instanceOfRpcStreamingClient = void 0;
function instanceOfRpcStreamingClient(client) {
    return typeof client.listen === "function";
}
exports.instanceOfRpcStreamingClient = instanceOfRpcStreamingClient;
// Helpers for all RPC clients
function hasProtocol(url) {
    return url.search("://") !== -1;
}
exports.hasProtocol = hasProtocol;
//# sourceMappingURL=rpcclient.js.map

/***/ }),

/***/ 83310:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.WebsocketClient = void 0;
const json_rpc_1 = __webpack_require__(95633);
const socket_1 = __webpack_require__(90620);
const stream_1 = __webpack_require__(81459);
const xstream_1 = __webpack_require__(43813);
const rpcclient_1 = __webpack_require__(95610);
function defaultErrorHandler(error) {
    throw error;
}
function toJsonRpcResponse(message) {
    // this should never happen, but I want an alert if it does
    if (message.type !== "message") {
        throw new Error(`Unexcepted message type on websocket: ${message.type}`);
    }
    const jsonRpcEvent = (0, json_rpc_1.parseJsonRpcResponse)(JSON.parse(message.data));
    return jsonRpcEvent;
}
class RpcEventProducer {
    constructor(request, socket) {
        this.running = false;
        this.subscriptions = [];
        this.request = request;
        this.socket = socket;
    }
    /**
     * Implementation of Producer.start
     */
    start(listener) {
        if (this.running) {
            throw Error("Already started. Please stop first before restarting.");
        }
        this.running = true;
        this.connectToClient(listener);
        this.socket.queueRequest(JSON.stringify(this.request));
    }
    /**
     * Implementation of Producer.stop
     *
     * Called by the stream when the stream's last listener stopped listening
     * or when the producer completed.
     */
    stop() {
        this.running = false;
        // Tell the server we are done in order to save resources. We cannot wait for the result.
        // This may fail when socket connection is not open, thus ignore errors in queueRequest
        const endRequest = { ...this.request, method: "unsubscribe" };
        try {
            this.socket.queueRequest(JSON.stringify(endRequest));
        }
        catch (error) {
            if (error instanceof Error && error.message.match(/socket has disconnected/i)) {
                // ignore
            }
            else {
                throw error;
            }
        }
    }
    connectToClient(listener) {
        const responseStream = this.socket.events.map(toJsonRpcResponse);
        // this should unsubscribe itself, so doesn't need to be removed explicitly
        const idSubscription = responseStream
            .filter((response) => response.id === this.request.id)
            .subscribe({
            next: (response) => {
                if ((0, json_rpc_1.isJsonRpcErrorResponse)(response)) {
                    this.closeSubscriptions();
                    listener.error(JSON.stringify(response.error));
                }
                idSubscription.unsubscribe();
            },
        });
        // this will fire on a response (success or error)
        // Tendermint adds an "#event" suffix for events that follow a previous subscription
        // https://github.com/tendermint/tendermint/blob/v0.23.0/rpc/core/events.go#L107
        const idEventSubscription = responseStream
            .filter((response) => response.id === this.request.id)
            .subscribe({
            next: (response) => {
                if ((0, json_rpc_1.isJsonRpcErrorResponse)(response)) {
                    this.closeSubscriptions();
                    listener.error(JSON.stringify(response.error));
                }
                else {
                    listener.next(response.result);
                }
            },
        });
        // this will fire in case the websocket disconnects cleanly
        const nonResponseSubscription = responseStream.subscribe({
            error: (error) => {
                this.closeSubscriptions();
                listener.error(error);
            },
            complete: () => {
                this.closeSubscriptions();
                listener.complete();
            },
        });
        this.subscriptions.push(idSubscription, idEventSubscription, nonResponseSubscription);
    }
    closeSubscriptions() {
        for (const subscription of this.subscriptions) {
            subscription.unsubscribe();
        }
        // clear unused subscriptions
        this.subscriptions = [];
    }
}
class WebsocketClient {
    constructor(baseUrl, onError = defaultErrorHandler) {
        // Lazily create streams and use the same stream when listening to the same query twice.
        //
        // Creating streams is cheap since producer is not started as long as nobody listens to events. Thus this
        // map is never cleared and there is no need to do so. But unsubscribe all the subscriptions!
        this.subscriptionStreams = new Map();
        // accept host.name:port and assume ws protocol
        // make sure we don't end up with ...//websocket
        const path = baseUrl.endsWith("/") ? "websocket" : "/websocket";
        const cleanBaseUrl = (0, rpcclient_1.hasProtocol)(baseUrl) ? baseUrl : "ws://" + baseUrl;
        this.url = cleanBaseUrl + path;
        this.socket = new socket_1.ReconnectingSocket(this.url);
        const errorSubscription = this.socket.events.subscribe({
            error: (error) => {
                onError(error);
                errorSubscription.unsubscribe();
            },
        });
        this.jsonRpcResponseStream = this.socket.events.map(toJsonRpcResponse);
        this.socket.connect();
    }
    async execute(request) {
        const pendingResponse = this.responseForRequestId(request.id);
        this.socket.queueRequest(JSON.stringify(request));
        const response = await pendingResponse;
        if ((0, json_rpc_1.isJsonRpcErrorResponse)(response)) {
            throw new Error(JSON.stringify(response.error));
        }
        return response;
    }
    listen(request) {
        if (request.method !== "subscribe") {
            throw new Error(`Request method must be "subscribe" to start event listening`);
        }
        const query = request.params.query;
        if (typeof query !== "string") {
            throw new Error("request.params.query must be a string");
        }
        if (!this.subscriptionStreams.has(query)) {
            const producer = new RpcEventProducer(request, this.socket);
            const stream = xstream_1.Stream.create(producer);
            this.subscriptionStreams.set(query, stream);
        }
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return this.subscriptionStreams.get(query).filter((response) => response.query !== undefined);
    }
    /**
     * Resolves as soon as websocket is connected. execute() queues requests automatically,
     * so this should be required for testing purposes only.
     */
    async connected() {
        await this.socket.connectionStatus.waitFor(socket_1.ConnectionStatus.Connected);
    }
    disconnect() {
        this.socket.disconnect();
    }
    async responseForRequestId(id) {
        return (0, stream_1.firstEvent)(this.jsonRpcResponseStream.filter((r) => r.id === id));
    }
}
exports.WebsocketClient = WebsocketClient;
//# sourceMappingURL=websocketclient.js.map

/***/ }),

/***/ 63524:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.adaptor34 = void 0;
const hasher_1 = __webpack_require__(3479);
const requests_1 = __webpack_require__(43936);
const responses_1 = __webpack_require__(51265);
exports.adaptor34 = {
    params: requests_1.Params,
    responses: responses_1.Responses,
    hashTx: hasher_1.hashTx,
    hashBlock: hasher_1.hashBlock,
};
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 43936:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Params = void 0;
/* eslint-disable @typescript-eslint/naming-convention */
const encoding_1 = __webpack_require__(71555);
const inthelpers_1 = __webpack_require__(32340);
const jsonrpc_1 = __webpack_require__(49485);
const encodings_1 = __webpack_require__(5179);
const requests = __importStar(__webpack_require__(23059));
function encodeHeightParam(param) {
    return {
        height: (0, encodings_1.may)(inthelpers_1.smallIntToApi, param.height),
    };
}
function encodeBlockchainRequestParams(param) {
    return {
        minHeight: (0, encodings_1.may)(inthelpers_1.smallIntToApi, param.minHeight),
        maxHeight: (0, encodings_1.may)(inthelpers_1.smallIntToApi, param.maxHeight),
    };
}
function encodeBlockSearchParams(params) {
    return {
        query: params.query,
        page: (0, encodings_1.may)(inthelpers_1.smallIntToApi, params.page),
        per_page: (0, encodings_1.may)(inthelpers_1.smallIntToApi, params.per_page),
        order_by: params.order_by,
    };
}
function encodeAbciQueryParams(params) {
    return {
        path: (0, encodings_1.assertNotEmpty)(params.path),
        data: (0, encoding_1.toHex)(params.data),
        height: (0, encodings_1.may)(inthelpers_1.smallIntToApi, params.height),
        prove: params.prove,
    };
}
function encodeBroadcastTxParams(params) {
    return {
        tx: (0, encoding_1.toBase64)((0, encodings_1.assertNotEmpty)(params.tx)),
    };
}
function encodeTxParams(params) {
    return {
        hash: (0, encoding_1.toBase64)((0, encodings_1.assertNotEmpty)(params.hash)),
        prove: params.prove,
    };
}
function encodeTxSearchParams(params) {
    return {
        query: params.query,
        prove: params.prove,
        page: (0, encodings_1.may)(inthelpers_1.smallIntToApi, params.page),
        per_page: (0, encodings_1.may)(inthelpers_1.smallIntToApi, params.per_page),
        order_by: params.order_by,
    };
}
function encodeValidatorsParams(params) {
    return {
        height: (0, encodings_1.may)(inthelpers_1.smallIntToApi, params.height),
        page: (0, encodings_1.may)(inthelpers_1.smallIntToApi, params.page),
        per_page: (0, encodings_1.may)(inthelpers_1.smallIntToApi, params.per_page),
    };
}
class Params {
    static encodeAbciInfo(req) {
        return (0, jsonrpc_1.createJsonRpcRequest)(req.method);
    }
    static encodeAbciQuery(req) {
        return (0, jsonrpc_1.createJsonRpcRequest)(req.method, encodeAbciQueryParams(req.params));
    }
    static encodeBlock(req) {
        return (0, jsonrpc_1.createJsonRpcRequest)(req.method, encodeHeightParam(req.params));
    }
    static encodeBlockchain(req) {
        return (0, jsonrpc_1.createJsonRpcRequest)(req.method, encodeBlockchainRequestParams(req.params));
    }
    static encodeBlockResults(req) {
        return (0, jsonrpc_1.createJsonRpcRequest)(req.method, encodeHeightParam(req.params));
    }
    static encodeBlockSearch(req) {
        return (0, jsonrpc_1.createJsonRpcRequest)(req.method, encodeBlockSearchParams(req.params));
    }
    static encodeBroadcastTx(req) {
        return (0, jsonrpc_1.createJsonRpcRequest)(req.method, encodeBroadcastTxParams(req.params));
    }
    static encodeCommit(req) {
        return (0, jsonrpc_1.createJsonRpcRequest)(req.method, encodeHeightParam(req.params));
    }
    static encodeGenesis(req) {
        return (0, jsonrpc_1.createJsonRpcRequest)(req.method);
    }
    static encodeHealth(req) {
        return (0, jsonrpc_1.createJsonRpcRequest)(req.method);
    }
    static encodeNumUnconfirmedTxs(req) {
        return (0, jsonrpc_1.createJsonRpcRequest)(req.method);
    }
    static encodeStatus(req) {
        return (0, jsonrpc_1.createJsonRpcRequest)(req.method);
    }
    static encodeSubscribe(req) {
        const eventTag = { key: "tm.event", value: req.query.type };
        const query = requests.buildQuery({ tags: [eventTag], raw: req.query.raw });
        return (0, jsonrpc_1.createJsonRpcRequest)("subscribe", { query: query });
    }
    static encodeTx(req) {
        return (0, jsonrpc_1.createJsonRpcRequest)(req.method, encodeTxParams(req.params));
    }
    // TODO: encode params for query string???
    static encodeTxSearch(req) {
        return (0, jsonrpc_1.createJsonRpcRequest)(req.method, encodeTxSearchParams(req.params));
    }
    static encodeValidators(req) {
        return (0, jsonrpc_1.createJsonRpcRequest)(req.method, encodeValidatorsParams(req.params));
    }
}
exports.Params = Params;
//# sourceMappingURL=requests.js.map

/***/ }),

/***/ 51265:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Responses = exports.decodeValidatorInfo = exports.decodeValidatorGenesis = exports.decodeValidatorUpdate = exports.decodeEvent = void 0;
/* eslint-disable @typescript-eslint/naming-convention */
const encoding_1 = __webpack_require__(71555);
const utils_1 = __webpack_require__(85553);
const dates_1 = __webpack_require__(6405);
const inthelpers_1 = __webpack_require__(32340);
const types_1 = __webpack_require__(36023);
const encodings_1 = __webpack_require__(5179);
const hasher_1 = __webpack_require__(3479);
function decodeAbciInfo(data) {
    return {
        data: data.data,
        lastBlockHeight: (0, encodings_1.may)(inthelpers_1.apiToSmallInt, data.last_block_height),
        lastBlockAppHash: (0, encodings_1.may)(encoding_1.fromBase64, data.last_block_app_hash),
    };
}
function decodeQueryProof(data) {
    return {
        ops: data.ops.map((op) => ({
            type: op.type,
            key: (0, encoding_1.fromBase64)(op.key),
            data: (0, encoding_1.fromBase64)(op.data),
        })),
    };
}
function decodeAbciQuery(data) {
    var _a, _b, _c, _d;
    return {
        key: (0, encoding_1.fromBase64)((0, encodings_1.assertString)((_a = data.key) !== null && _a !== void 0 ? _a : "")),
        value: (0, encoding_1.fromBase64)((0, encodings_1.assertString)((_b = data.value) !== null && _b !== void 0 ? _b : "")),
        proof: (0, encodings_1.may)(decodeQueryProof, data.proofOps),
        height: (0, encodings_1.may)(inthelpers_1.apiToSmallInt, data.height),
        code: (0, encodings_1.may)(inthelpers_1.apiToSmallInt, data.code),
        codespace: (0, encodings_1.assertString)((_c = data.codespace) !== null && _c !== void 0 ? _c : ""),
        index: (0, encodings_1.may)(inthelpers_1.apiToSmallInt, data.index),
        log: data.log,
        info: (0, encodings_1.assertString)((_d = data.info) !== null && _d !== void 0 ? _d : ""),
    };
}
function decodeAttribute(attribute) {
    var _a;
    return {
        key: (0, encoding_1.fromBase64)((0, encodings_1.assertNotEmpty)(attribute.key)),
        value: (0, encoding_1.fromBase64)((0, encodings_1.assertString)((_a = attribute.value) !== null && _a !== void 0 ? _a : "")),
    };
}
function decodeAttributes(attributes) {
    return (0, encodings_1.assertArray)(attributes).map(decodeAttribute);
}
function decodeEvent(event) {
    return {
        type: event.type,
        attributes: event.attributes ? decodeAttributes(event.attributes) : [],
    };
}
exports.decodeEvent = decodeEvent;
function decodeEvents(events) {
    return (0, encodings_1.assertArray)(events).map(decodeEvent);
}
function decodeTxData(data) {
    var _a, _b, _c;
    return {
        code: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNumber)((_a = data.code) !== null && _a !== void 0 ? _a : 0)),
        codespace: data.codespace,
        log: data.log,
        data: (0, encodings_1.may)(encoding_1.fromBase64, data.data),
        events: data.events ? decodeEvents(data.events) : [],
        gasWanted: (0, inthelpers_1.apiToSmallInt)((_b = data.gas_wanted) !== null && _b !== void 0 ? _b : "0"),
        gasUsed: (0, inthelpers_1.apiToSmallInt)((_c = data.gas_used) !== null && _c !== void 0 ? _c : "0"),
    };
}
function decodePubkey(data) {
    if ("Sum" in data) {
        // we don't need to check type because we're checking algorithm
        const [[algorithm, value]] = Object.entries(data.Sum.value);
        (0, utils_1.assert)(algorithm === "ed25519" || algorithm === "secp256k1", `unknown pubkey type: ${algorithm}`);
        return {
            algorithm,
            data: (0, encoding_1.fromBase64)((0, encodings_1.assertNotEmpty)(value)),
        };
    }
    else {
        switch (data.type) {
            // go-amino special code
            case "tendermint/PubKeyEd25519":
                return {
                    algorithm: "ed25519",
                    data: (0, encoding_1.fromBase64)((0, encodings_1.assertNotEmpty)(data.value)),
                };
            case "tendermint/PubKeySecp256k1":
                return {
                    algorithm: "secp256k1",
                    data: (0, encoding_1.fromBase64)((0, encodings_1.assertNotEmpty)(data.value)),
                };
            default:
                throw new Error(`unknown pubkey type: ${data.type}`);
        }
    }
}
/**
 * Note: we do not parse block.time_iota_ms for now because of this CHANGELOG entry
 *
 * > Add time_iota_ms to block's consensus parameters (not exposed to the application)
 * https://github.com/tendermint/tendermint/blob/master/CHANGELOG.md#v0310
 */
function decodeBlockParams(data) {
    return {
        maxBytes: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(data.max_bytes)),
        maxGas: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(data.max_gas)),
    };
}
function decodeEvidenceParams(data) {
    return {
        maxAgeNumBlocks: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(data.max_age_num_blocks)),
        maxAgeDuration: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(data.max_age_duration)),
    };
}
function decodeConsensusParams(data) {
    return {
        block: decodeBlockParams((0, encodings_1.assertObject)(data.block)),
        evidence: decodeEvidenceParams((0, encodings_1.assertObject)(data.evidence)),
    };
}
function decodeValidatorUpdate(data) {
    var _a;
    return {
        pubkey: decodePubkey((0, encodings_1.assertObject)(data.pub_key)),
        votingPower: (0, inthelpers_1.apiToBigInt)((_a = data.power) !== null && _a !== void 0 ? _a : "0"),
    };
}
exports.decodeValidatorUpdate = decodeValidatorUpdate;
function decodeBlockResults(data) {
    return {
        height: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(data.height)),
        results: (data.txs_results || []).map(decodeTxData),
        validatorUpdates: (data.validator_updates || []).map(decodeValidatorUpdate),
        consensusUpdates: (0, encodings_1.may)(decodeConsensusParams, data.consensus_param_updates),
        beginBlockEvents: decodeEvents(data.begin_block_events || []),
        endBlockEvents: decodeEvents(data.end_block_events || []),
    };
}
function decodeBlockId(data) {
    return {
        hash: (0, encoding_1.fromHex)((0, encodings_1.assertNotEmpty)(data.hash)),
        parts: {
            total: (0, encodings_1.assertNotEmpty)(data.parts.total),
            hash: (0, encoding_1.fromHex)((0, encodings_1.assertNotEmpty)(data.parts.hash)),
        },
    };
}
function decodeBlockVersion(data) {
    var _a;
    return {
        block: (0, inthelpers_1.apiToSmallInt)(data.block),
        app: (0, inthelpers_1.apiToSmallInt)((_a = data.app) !== null && _a !== void 0 ? _a : 0),
    };
}
function decodeHeader(data) {
    return {
        version: decodeBlockVersion(data.version),
        chainId: (0, encodings_1.assertNotEmpty)(data.chain_id),
        height: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(data.height)),
        time: (0, dates_1.fromRfc3339WithNanoseconds)((0, encodings_1.assertNotEmpty)(data.time)),
        // When there is no last block ID (i.e. this block's height is 1), we get an empty structure like this:
        // { hash: '', parts: { total: 0, hash: '' } }
        lastBlockId: data.last_block_id.hash ? decodeBlockId(data.last_block_id) : null,
        lastCommitHash: (0, encoding_1.fromHex)((0, encodings_1.assertSet)(data.last_commit_hash)),
        dataHash: (0, encoding_1.fromHex)((0, encodings_1.assertSet)(data.data_hash)),
        validatorsHash: (0, encoding_1.fromHex)((0, encodings_1.assertSet)(data.validators_hash)),
        nextValidatorsHash: (0, encoding_1.fromHex)((0, encodings_1.assertSet)(data.next_validators_hash)),
        consensusHash: (0, encoding_1.fromHex)((0, encodings_1.assertSet)(data.consensus_hash)),
        appHash: (0, encoding_1.fromHex)((0, encodings_1.assertSet)(data.app_hash)),
        lastResultsHash: (0, encoding_1.fromHex)((0, encodings_1.assertSet)(data.last_results_hash)),
        evidenceHash: (0, encoding_1.fromHex)((0, encodings_1.assertSet)(data.evidence_hash)),
        proposerAddress: (0, encoding_1.fromHex)((0, encodings_1.assertNotEmpty)(data.proposer_address)),
    };
}
function decodeBlockMeta(data) {
    return {
        blockId: decodeBlockId(data.block_id),
        blockSize: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(data.block_size)),
        header: decodeHeader(data.header),
        numTxs: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(data.num_txs)),
    };
}
function decodeBlockchain(data) {
    return {
        lastHeight: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(data.last_height)),
        blockMetas: (0, encodings_1.assertArray)(data.block_metas).map(decodeBlockMeta),
    };
}
function decodeBroadcastTxSync(data) {
    return {
        ...decodeTxData(data),
        hash: (0, encoding_1.fromHex)((0, encodings_1.assertNotEmpty)(data.hash)),
    };
}
function decodeBroadcastTxCommit(data) {
    return {
        height: (0, inthelpers_1.apiToSmallInt)(data.height),
        hash: (0, encoding_1.fromHex)((0, encodings_1.assertNotEmpty)(data.hash)),
        checkTx: decodeTxData((0, encodings_1.assertObject)(data.check_tx)),
        deliverTx: (0, encodings_1.may)(decodeTxData, data.deliver_tx),
    };
}
function decodeBlockIdFlag(blockIdFlag) {
    (0, utils_1.assert)(blockIdFlag in types_1.BlockIdFlag);
    return blockIdFlag;
}
/**
 * In some cases a timestamp is optional and set to the value 0 in Go.
 * This can lead to strings like "0001-01-01T00:00:00Z" (see https://github.com/cosmos/cosmjs/issues/704#issuecomment-797122415).
 * This decoder tries to clean up such encoding from the API and turn them
 * into undefined values.
 */
function decodeOptionalTime(timestamp) {
    const nonZeroTime = timestamp && !timestamp.startsWith("0001-01-01");
    return nonZeroTime ? (0, dates_1.fromRfc3339WithNanoseconds)(timestamp) : undefined;
}
function decodeCommitSignature(data) {
    return {
        blockIdFlag: decodeBlockIdFlag(data.block_id_flag),
        validatorAddress: data.validator_address ? (0, encoding_1.fromHex)(data.validator_address) : undefined,
        timestamp: decodeOptionalTime(data.timestamp),
        signature: data.signature ? (0, encoding_1.fromBase64)(data.signature) : undefined,
    };
}
function decodeCommit(data) {
    return {
        blockId: decodeBlockId((0, encodings_1.assertObject)(data.block_id)),
        height: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(data.height)),
        round: (0, inthelpers_1.apiToSmallInt)(data.round),
        signatures: (0, encodings_1.assertArray)(data.signatures).map(decodeCommitSignature),
    };
}
function decodeCommitResponse(data) {
    return {
        canonical: (0, encodings_1.assertBoolean)(data.canonical),
        header: decodeHeader(data.signed_header.header),
        commit: decodeCommit(data.signed_header.commit),
    };
}
function decodeValidatorGenesis(data) {
    return {
        address: (0, encoding_1.fromHex)((0, encodings_1.assertNotEmpty)(data.address)),
        pubkey: decodePubkey((0, encodings_1.assertObject)(data.pub_key)),
        votingPower: (0, inthelpers_1.apiToBigInt)((0, encodings_1.assertNotEmpty)(data.power)),
    };
}
exports.decodeValidatorGenesis = decodeValidatorGenesis;
function decodeGenesis(data) {
    return {
        genesisTime: (0, dates_1.fromRfc3339WithNanoseconds)((0, encodings_1.assertNotEmpty)(data.genesis_time)),
        chainId: (0, encodings_1.assertNotEmpty)(data.chain_id),
        consensusParams: decodeConsensusParams(data.consensus_params),
        validators: data.validators ? (0, encodings_1.assertArray)(data.validators).map(decodeValidatorGenesis) : [],
        appHash: (0, encoding_1.fromHex)((0, encodings_1.assertSet)(data.app_hash)),
        appState: data.app_state,
    };
}
function decodeValidatorInfo(data) {
    return {
        pubkey: decodePubkey((0, encodings_1.assertObject)(data.pub_key)),
        votingPower: (0, inthelpers_1.apiToBigInt)((0, encodings_1.assertNotEmpty)(data.voting_power)),
        address: (0, encoding_1.fromHex)((0, encodings_1.assertNotEmpty)(data.address)),
        proposerPriority: data.proposer_priority ? (0, inthelpers_1.apiToSmallInt)(data.proposer_priority) : undefined,
    };
}
exports.decodeValidatorInfo = decodeValidatorInfo;
function decodeNodeInfo(data) {
    return {
        id: (0, encoding_1.fromHex)((0, encodings_1.assertNotEmpty)(data.id)),
        listenAddr: (0, encodings_1.assertNotEmpty)(data.listen_addr),
        network: (0, encodings_1.assertNotEmpty)(data.network),
        version: (0, encodings_1.assertString)(data.version),
        channels: (0, encodings_1.assertNotEmpty)(data.channels),
        moniker: (0, encodings_1.assertNotEmpty)(data.moniker),
        other: (0, encodings_1.dictionaryToStringMap)(data.other),
        protocolVersion: {
            app: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(data.protocol_version.app)),
            block: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(data.protocol_version.block)),
            p2p: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(data.protocol_version.p2p)),
        },
    };
}
function decodeSyncInfo(data) {
    return {
        latestBlockHash: (0, encoding_1.fromHex)((0, encodings_1.assertNotEmpty)(data.latest_block_hash)),
        latestAppHash: (0, encoding_1.fromHex)((0, encodings_1.assertNotEmpty)(data.latest_app_hash)),
        latestBlockTime: (0, dates_1.fromRfc3339WithNanoseconds)((0, encodings_1.assertNotEmpty)(data.latest_block_time)),
        latestBlockHeight: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(data.latest_block_height)),
        catchingUp: (0, encodings_1.assertBoolean)(data.catching_up),
    };
}
function decodeStatus(data) {
    return {
        nodeInfo: decodeNodeInfo(data.node_info),
        syncInfo: decodeSyncInfo(data.sync_info),
        validatorInfo: decodeValidatorInfo(data.validator_info),
    };
}
function decodeTxProof(data) {
    return {
        data: (0, encoding_1.fromBase64)((0, encodings_1.assertNotEmpty)(data.data)),
        rootHash: (0, encoding_1.fromHex)((0, encodings_1.assertNotEmpty)(data.root_hash)),
        proof: {
            total: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(data.proof.total)),
            index: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(data.proof.index)),
            leafHash: (0, encoding_1.fromBase64)((0, encodings_1.assertNotEmpty)(data.proof.leaf_hash)),
            aunts: (0, encodings_1.assertArray)(data.proof.aunts).map(encoding_1.fromBase64),
        },
    };
}
function decodeTxResponse(data) {
    return {
        tx: (0, encoding_1.fromBase64)((0, encodings_1.assertNotEmpty)(data.tx)),
        result: decodeTxData((0, encodings_1.assertObject)(data.tx_result)),
        height: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(data.height)),
        index: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNumber)(data.index)),
        hash: (0, encoding_1.fromHex)((0, encodings_1.assertNotEmpty)(data.hash)),
        proof: (0, encodings_1.may)(decodeTxProof, data.proof),
    };
}
function decodeTxSearch(data) {
    return {
        totalCount: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(data.total_count)),
        txs: (0, encodings_1.assertArray)(data.txs).map(decodeTxResponse),
    };
}
function decodeTxEvent(data) {
    const tx = (0, encoding_1.fromBase64)((0, encodings_1.assertNotEmpty)(data.tx));
    return {
        tx: tx,
        hash: (0, hasher_1.hashTx)(tx),
        result: decodeTxData(data.result),
        height: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(data.height)),
        index: (0, encodings_1.may)(inthelpers_1.apiToSmallInt, data.index),
    };
}
function decodeValidators(data) {
    return {
        blockHeight: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(data.block_height)),
        validators: (0, encodings_1.assertArray)(data.validators).map(decodeValidatorInfo),
        count: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(data.count)),
        total: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(data.total)),
    };
}
function decodeBlock(data) {
    var _a, _b;
    return {
        header: decodeHeader((0, encodings_1.assertObject)(data.header)),
        // For the block at height 1, last commit is not set. This is represented in an empty object like this:
        // { height: '0', round: 0, block_id: { hash: '', parts: [Object] }, signatures: [] }
        lastCommit: data.last_commit.block_id.hash ? decodeCommit((0, encodings_1.assertObject)(data.last_commit)) : null,
        txs: data.data.txs ? (0, encodings_1.assertArray)(data.data.txs).map(encoding_1.fromBase64) : [],
        // Lift up .evidence.evidence to just .evidence
        // See https://github.com/tendermint/tendermint/issues/7697
        evidence: (_b = (_a = data.evidence) === null || _a === void 0 ? void 0 : _a.evidence) !== null && _b !== void 0 ? _b : [],
    };
}
function decodeBlockResponse(data) {
    return {
        blockId: decodeBlockId(data.block_id),
        block: decodeBlock(data.block),
    };
}
function decodeBlockSearch(data) {
    return {
        totalCount: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(data.total_count)),
        blocks: (0, encodings_1.assertArray)(data.blocks).map(decodeBlockResponse),
    };
}
function decodeNumUnconfirmedTxs(data) {
    return {
        total: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(data.total)),
        totalBytes: (0, inthelpers_1.apiToSmallInt)((0, encodings_1.assertNotEmpty)(data.total_bytes)),
    };
}
class Responses {
    static decodeAbciInfo(response) {
        return decodeAbciInfo((0, encodings_1.assertObject)(response.result.response));
    }
    static decodeAbciQuery(response) {
        return decodeAbciQuery((0, encodings_1.assertObject)(response.result.response));
    }
    static decodeBlock(response) {
        return decodeBlockResponse(response.result);
    }
    static decodeBlockResults(response) {
        return decodeBlockResults(response.result);
    }
    static decodeBlockSearch(response) {
        return decodeBlockSearch(response.result);
    }
    static decodeBlockchain(response) {
        return decodeBlockchain(response.result);
    }
    static decodeBroadcastTxSync(response) {
        return decodeBroadcastTxSync(response.result);
    }
    static decodeBroadcastTxAsync(response) {
        return Responses.decodeBroadcastTxSync(response);
    }
    static decodeBroadcastTxCommit(response) {
        return decodeBroadcastTxCommit(response.result);
    }
    static decodeCommit(response) {
        return decodeCommitResponse(response.result);
    }
    static decodeGenesis(response) {
        return decodeGenesis((0, encodings_1.assertObject)(response.result.genesis));
    }
    static decodeHealth() {
        return null;
    }
    static decodeNumUnconfirmedTxs(response) {
        return decodeNumUnconfirmedTxs(response.result);
    }
    static decodeStatus(response) {
        return decodeStatus(response.result);
    }
    static decodeNewBlockEvent(event) {
        return decodeBlock(event.data.value.block);
    }
    static decodeNewBlockHeaderEvent(event) {
        return decodeHeader(event.data.value.header);
    }
    static decodeTxEvent(event) {
        return decodeTxEvent(event.data.value.TxResult);
    }
    static decodeTx(response) {
        return decodeTxResponse(response.result);
    }
    static decodeTxSearch(response) {
        return decodeTxSearch(response.result);
    }
    static decodeValidators(response) {
        return decodeValidators(response.result);
    }
}
exports.Responses = Responses;
//# sourceMappingURL=responses.js.map

/***/ }),

/***/ 5179:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.encodeBlockId = exports.encodeVersion = exports.encodeBytes = exports.encodeTime = exports.encodeUvarint = exports.encodeString = exports.dictionaryToStringMap = exports.may = exports.assertNotEmpty = exports.assertObject = exports.assertArray = exports.assertNumber = exports.assertString = exports.assertBoolean = exports.assertSet = void 0;
const encoding_1 = __webpack_require__(71555);
/**
 * A runtime checker that ensures a given value is set (i.e. not undefined or null)
 *
 * This is used when you want to verify that data at runtime matches the expected type.
 */
function assertSet(value) {
    if (value === undefined) {
        throw new Error("Value must not be undefined");
    }
    if (value === null) {
        throw new Error("Value must not be null");
    }
    return value;
}
exports.assertSet = assertSet;
/**
 * A runtime checker that ensures a given value is a boolean
 *
 * This is used when you want to verify that data at runtime matches the expected type.
 * This implies assertSet.
 */
function assertBoolean(value) {
    assertSet(value);
    if (typeof value !== "boolean") {
        throw new Error("Value must be a boolean");
    }
    return value;
}
exports.assertBoolean = assertBoolean;
/**
 * A runtime checker that ensures a given value is a string.
 *
 * This is used when you want to verify that data at runtime matches the expected type.
 * This implies assertSet.
 */
function assertString(value) {
    assertSet(value);
    if (typeof value !== "string") {
        throw new Error("Value must be a string");
    }
    return value;
}
exports.assertString = assertString;
/**
 * A runtime checker that ensures a given value is a number
 *
 * This is used when you want to verify that data at runtime matches the expected type.
 * This implies assertSet.
 */
function assertNumber(value) {
    assertSet(value);
    if (typeof value !== "number") {
        throw new Error("Value must be a number");
    }
    return value;
}
exports.assertNumber = assertNumber;
/**
 * A runtime checker that ensures a given value is an array
 *
 * This is used when you want to verify that data at runtime matches the expected type.
 * This implies assertSet.
 */
function assertArray(value) {
    assertSet(value);
    if (!Array.isArray(value)) {
        throw new Error("Value must be a an array");
    }
    return value;
}
exports.assertArray = assertArray;
/**
 * A runtime checker that ensures a given value is an object in the sense of JSON
 * (an unordered collection of key–value pairs where the keys are strings)
 *
 * This is used when you want to verify that data at runtime matches the expected type.
 * This implies assertSet.
 */
function assertObject(value) {
    assertSet(value);
    if (typeof value !== "object") {
        throw new Error("Value must be an object");
    }
    // Exclude special kind of objects like Array, Date or Uint8Array
    // Object.prototype.toString() returns a specified value:
    // http://www.ecma-international.org/ecma-262/7.0/index.html#sec-object.prototype.tostring
    if (Object.prototype.toString.call(value) !== "[object Object]") {
        throw new Error("Value must be a simple object");
    }
    return value;
}
exports.assertObject = assertObject;
/**
 * Throws an error if value matches the empty value for the
 * given type (array/string of length 0, number of value 0, ...)
 *
 * Otherwise returns the value.
 *
 * This implies assertSet
 */
function assertNotEmpty(value) {
    assertSet(value);
    if (typeof value === "number" && value === 0) {
        throw new Error("must provide a non-zero value");
    }
    else if (value.length === 0) {
        throw new Error("must provide a non-empty value");
    }
    return value;
}
exports.assertNotEmpty = assertNotEmpty;
// may will run the transform if value is defined, otherwise returns undefined
function may(transform, value) {
    return value === undefined || value === null ? undefined : transform(value);
}
exports.may = may;
function dictionaryToStringMap(obj) {
    const out = new Map();
    for (const key of Object.keys(obj)) {
        const value = obj[key];
        if (typeof value !== "string") {
            throw new Error("Found dictionary value of type other than string");
        }
        out.set(key, value);
    }
    return out;
}
exports.dictionaryToStringMap = dictionaryToStringMap;
// Encodings needed for hashing block headers
// Several of these functions are inspired by https://github.com/nomic-io/js-tendermint/blob/tendermint-0.30/src/
// See https://github.com/tendermint/go-amino/blob/v0.15.0/encoder.go#L193-L195
function encodeString(s) {
    const utf8 = (0, encoding_1.toUtf8)(s);
    return Uint8Array.from([utf8.length, ...utf8]);
}
exports.encodeString = encodeString;
// See https://github.com/tendermint/go-amino/blob/v0.15.0/encoder.go#L79-L87
function encodeUvarint(n) {
    return n >= 0x80
        ? // eslint-disable-next-line no-bitwise
            Uint8Array.from([(n & 0xff) | 0x80, ...encodeUvarint(n >> 7)])
        : // eslint-disable-next-line no-bitwise
            Uint8Array.from([n & 0xff]);
}
exports.encodeUvarint = encodeUvarint;
// See https://github.com/tendermint/go-amino/blob/v0.15.0/encoder.go#L134-L178
function encodeTime(time) {
    const milliseconds = time.getTime();
    const seconds = Math.floor(milliseconds / 1000);
    const secondsArray = seconds ? [0x08, ...encodeUvarint(seconds)] : new Uint8Array();
    const nanoseconds = (time.nanoseconds || 0) + (milliseconds % 1000) * 1e6;
    const nanosecondsArray = nanoseconds ? [0x10, ...encodeUvarint(nanoseconds)] : new Uint8Array();
    return Uint8Array.from([...secondsArray, ...nanosecondsArray]);
}
exports.encodeTime = encodeTime;
// See https://github.com/tendermint/go-amino/blob/v0.15.0/encoder.go#L180-L187
function encodeBytes(bytes) {
    // Since we're only dealing with short byte arrays we don't need a full VarBuffer implementation yet
    if (bytes.length >= 0x80)
        throw new Error("Not implemented for byte arrays of length 128 or more");
    return bytes.length ? Uint8Array.from([bytes.length, ...bytes]) : new Uint8Array();
}
exports.encodeBytes = encodeBytes;
function encodeVersion(version) {
    const blockArray = version.block
        ? Uint8Array.from([0x08, ...encodeUvarint(version.block)])
        : new Uint8Array();
    const appArray = version.app ? Uint8Array.from([0x10, ...encodeUvarint(version.app)]) : new Uint8Array();
    return Uint8Array.from([...blockArray, ...appArray]);
}
exports.encodeVersion = encodeVersion;
function encodeBlockId(blockId) {
    return Uint8Array.from([
        0x0a,
        blockId.hash.length,
        ...blockId.hash,
        0x12,
        blockId.parts.hash.length + 4,
        0x08,
        blockId.parts.total,
        0x12,
        blockId.parts.hash.length,
        ...blockId.parts.hash,
    ]);
}
exports.encodeBlockId = encodeBlockId;
//# sourceMappingURL=encodings.js.map

/***/ }),

/***/ 3479:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.hashBlock = exports.hashTx = void 0;
const crypto_1 = __webpack_require__(79562);
const encodings_1 = __webpack_require__(5179);
// hash is sha256
// https://github.com/tendermint/tendermint/blob/master/UPGRADING.md#v0260
function hashTx(tx) {
    return (0, crypto_1.sha256)(tx);
}
exports.hashTx = hashTx;
function getSplitPoint(n) {
    if (n < 1)
        throw new Error("Cannot split an empty tree");
    const largestPowerOf2 = 2 ** Math.floor(Math.log2(n));
    return largestPowerOf2 < n ? largestPowerOf2 : largestPowerOf2 / 2;
}
function hashLeaf(leaf) {
    const hash = new crypto_1.Sha256(Uint8Array.from([0]));
    hash.update(leaf);
    return hash.digest();
}
function hashInner(left, right) {
    const hash = new crypto_1.Sha256(Uint8Array.from([1]));
    hash.update(left);
    hash.update(right);
    return hash.digest();
}
// See https://github.com/tendermint/tendermint/blob/v0.31.8/docs/spec/blockchain/encoding.md#merkleroot
// Note: the hashes input may not actually be hashes, especially before a recursive call
function hashTree(hashes) {
    switch (hashes.length) {
        case 0:
            throw new Error("Cannot hash empty tree");
        case 1:
            return hashLeaf(hashes[0]);
        default: {
            const slicePoint = getSplitPoint(hashes.length);
            const left = hashTree(hashes.slice(0, slicePoint));
            const right = hashTree(hashes.slice(slicePoint));
            return hashInner(left, right);
        }
    }
}
function hashBlock(header) {
    if (!header.lastBlockId) {
        throw new Error("Hashing a block header with no last block ID (i.e. header at height 1) is not supported. If you need this, contributions are welcome. Please add documentation and test vectors for this case.");
    }
    const encodedFields = [
        (0, encodings_1.encodeVersion)(header.version),
        (0, encodings_1.encodeString)(header.chainId),
        (0, encodings_1.encodeUvarint)(header.height),
        (0, encodings_1.encodeTime)(header.time),
        (0, encodings_1.encodeBlockId)(header.lastBlockId),
        (0, encodings_1.encodeBytes)(header.lastCommitHash),
        (0, encodings_1.encodeBytes)(header.dataHash),
        (0, encodings_1.encodeBytes)(header.validatorsHash),
        (0, encodings_1.encodeBytes)(header.nextValidatorsHash),
        (0, encodings_1.encodeBytes)(header.consensusHash),
        (0, encodings_1.encodeBytes)(header.appHash),
        (0, encodings_1.encodeBytes)(header.lastResultsHash),
        (0, encodings_1.encodeBytes)(header.evidenceHash),
        (0, encodings_1.encodeBytes)(header.proposerAddress),
    ];
    return hashTree(encodedFields);
}
exports.hashBlock = hashBlock;
//# sourceMappingURL=hasher.js.map

/***/ }),

/***/ 59818:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

// Note: all exports in this module are publicly available via
// `import { tendermint34 } from "@cosmjs/tendermint-rpc"`
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Tendermint34Client = exports.VoteType = exports.broadcastTxSyncSuccess = exports.broadcastTxCommitSuccess = exports.SubscriptionEventType = exports.Method = void 0;
var requests_1 = __webpack_require__(23059);
Object.defineProperty(exports, "Method", ({ enumerable: true, get: function () { return requests_1.Method; } }));
Object.defineProperty(exports, "SubscriptionEventType", ({ enumerable: true, get: function () { return requests_1.SubscriptionEventType; } }));
var responses_1 = __webpack_require__(4689);
Object.defineProperty(exports, "broadcastTxCommitSuccess", ({ enumerable: true, get: function () { return responses_1.broadcastTxCommitSuccess; } }));
Object.defineProperty(exports, "broadcastTxSyncSuccess", ({ enumerable: true, get: function () { return responses_1.broadcastTxSyncSuccess; } }));
Object.defineProperty(exports, "VoteType", ({ enumerable: true, get: function () { return responses_1.VoteType; } }));
var tendermint34client_1 = __webpack_require__(53166);
Object.defineProperty(exports, "Tendermint34Client", ({ enumerable: true, get: function () { return tendermint34client_1.Tendermint34Client; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 23059:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

/* eslint-disable @typescript-eslint/naming-convention */
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.buildQuery = exports.SubscriptionEventType = exports.Method = void 0;
/**
 * RPC methods as documented in https://docs.tendermint.com/master/rpc/
 *
 * Enum raw value must match the spelling in the "shell" example call (snake_case)
 */
var Method;
(function (Method) {
    Method["AbciInfo"] = "abci_info";
    Method["AbciQuery"] = "abci_query";
    Method["Block"] = "block";
    /** Get block headers for minHeight <= height <= maxHeight. */
    Method["Blockchain"] = "blockchain";
    Method["BlockResults"] = "block_results";
    Method["BlockSearch"] = "block_search";
    Method["BroadcastTxAsync"] = "broadcast_tx_async";
    Method["BroadcastTxSync"] = "broadcast_tx_sync";
    Method["BroadcastTxCommit"] = "broadcast_tx_commit";
    Method["Commit"] = "commit";
    Method["Genesis"] = "genesis";
    Method["Health"] = "health";
    Method["NumUnconfirmedTxs"] = "num_unconfirmed_txs";
    Method["Status"] = "status";
    Method["Subscribe"] = "subscribe";
    Method["Tx"] = "tx";
    Method["TxSearch"] = "tx_search";
    Method["Validators"] = "validators";
    Method["Unsubscribe"] = "unsubscribe";
})(Method = exports.Method || (exports.Method = {}));
/**
 * Raw values must match the tendermint event name
 *
 * @see https://godoc.org/github.com/tendermint/tendermint/types#pkg-constants
 */
var SubscriptionEventType;
(function (SubscriptionEventType) {
    SubscriptionEventType["NewBlock"] = "NewBlock";
    SubscriptionEventType["NewBlockHeader"] = "NewBlockHeader";
    SubscriptionEventType["Tx"] = "Tx";
})(SubscriptionEventType = exports.SubscriptionEventType || (exports.SubscriptionEventType = {}));
function buildQuery(components) {
    const tags = components.tags ? components.tags : [];
    const tagComponents = tags.map((tag) => `${tag.key}='${tag.value}'`);
    const rawComponents = components.raw ? [components.raw] : [];
    return [...tagComponents, ...rawComponents].join(" AND ");
}
exports.buildQuery = buildQuery;
//# sourceMappingURL=requests.js.map

/***/ }),

/***/ 4689:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.VoteType = exports.broadcastTxCommitSuccess = exports.broadcastTxSyncSuccess = void 0;
/**
 * Returns true iff transaction made it successfully into the transaction pool
 */
function broadcastTxSyncSuccess(res) {
    // code must be 0 on success
    return res.code === 0;
}
exports.broadcastTxSyncSuccess = broadcastTxSyncSuccess;
/**
 * Returns true iff transaction made it successfully into a block
 * (i.e. success in `check_tx` and `deliver_tx` field)
 */
function broadcastTxCommitSuccess(response) {
    // code must be 0 on success
    // deliverTx may be present but empty on failure
    return response.checkTx.code === 0 && !!response.deliverTx && response.deliverTx.code === 0;
}
exports.broadcastTxCommitSuccess = broadcastTxCommitSuccess;
/**
 * raw values from https://github.com/tendermint/tendermint/blob/dfa9a9a30a666132425b29454e90a472aa579a48/types/vote.go#L44
 */
var VoteType;
(function (VoteType) {
    VoteType[VoteType["PreVote"] = 1] = "PreVote";
    VoteType[VoteType["PreCommit"] = 2] = "PreCommit";
})(VoteType = exports.VoteType || (exports.VoteType = {}));
//# sourceMappingURL=responses.js.map

/***/ }),

/***/ 53166:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Tendermint34Client = void 0;
const jsonrpc_1 = __webpack_require__(49485);
const rpcclients_1 = __webpack_require__(30652);
const adaptor_1 = __webpack_require__(63524);
const requests = __importStar(__webpack_require__(23059));
class Tendermint34Client {
    /**
     * Use `Tendermint34Client.connect` or `Tendermint34Client.create` to create an instance.
     */
    constructor(client) {
        this.client = client;
        this.p = adaptor_1.adaptor34.params;
        this.r = adaptor_1.adaptor34.responses;
    }
    /**
     * Creates a new Tendermint client for the given endpoint.
     *
     * Uses HTTP when the URL schema is http or https. Uses WebSockets otherwise.
     */
    static async connect(endpoint) {
        if (typeof endpoint === "object") {
            return Tendermint34Client.create(new rpcclients_1.HttpClient(endpoint));
        }
        else {
            const useHttp = endpoint.startsWith("http://") || endpoint.startsWith("https://");
            const rpcClient = useHttp ? new rpcclients_1.HttpClient(endpoint) : new rpcclients_1.WebsocketClient(endpoint);
            return Tendermint34Client.create(rpcClient);
        }
    }
    /**
     * Creates a new Tendermint client given an RPC client.
     */
    static async create(rpcClient) {
        // For some very strange reason I don't understand, tests start to fail on some systems
        // (our CI) when skipping the status call before doing other queries. Sleeping a little
        // while did not help. Thus we query the version as a way to say "hi" to the backend,
        // even in cases where we don't use the result.
        const _version = await this.detectVersion(rpcClient);
        return new Tendermint34Client(rpcClient);
    }
    static async detectVersion(client) {
        const req = (0, jsonrpc_1.createJsonRpcRequest)(requests.Method.Status);
        const response = await client.execute(req);
        const result = response.result;
        if (!result || !result.node_info) {
            throw new Error("Unrecognized format for status response");
        }
        const version = result.node_info.version;
        if (typeof version !== "string") {
            throw new Error("Unrecognized version format: must be string");
        }
        return version;
    }
    disconnect() {
        this.client.disconnect();
    }
    async abciInfo() {
        const query = { method: requests.Method.AbciInfo };
        return this.doCall(query, this.p.encodeAbciInfo, this.r.decodeAbciInfo);
    }
    async abciQuery(params) {
        const query = { params: params, method: requests.Method.AbciQuery };
        return this.doCall(query, this.p.encodeAbciQuery, this.r.decodeAbciQuery);
    }
    async block(height) {
        const query = { method: requests.Method.Block, params: { height: height } };
        return this.doCall(query, this.p.encodeBlock, this.r.decodeBlock);
    }
    async blockResults(height) {
        const query = {
            method: requests.Method.BlockResults,
            params: { height: height },
        };
        return this.doCall(query, this.p.encodeBlockResults, this.r.decodeBlockResults);
    }
    /**
     * Search for events that are in a block.
     *
     * NOTE
     * This method will error on any node that is running a Tendermint version lower than 0.34.9.
     *
     * @see https://docs.tendermint.com/master/rpc/#/Info/block_search
     */
    async blockSearch(params) {
        const query = { params: params, method: requests.Method.BlockSearch };
        const resp = await this.doCall(query, this.p.encodeBlockSearch, this.r.decodeBlockSearch);
        return {
            ...resp,
            // make sure we sort by height, as tendermint may be sorting by string value of the height
            blocks: [...resp.blocks].sort((a, b) => a.block.header.height - b.block.header.height),
        };
    }
    // this should paginate through all blockSearch options to ensure it returns all results.
    // starts with page 1 or whatever was provided (eg. to start on page 7)
    //
    // NOTE
    // This method will error on any node that is running a Tendermint version lower than 0.34.9.
    async blockSearchAll(params) {
        let page = params.page || 1;
        const blocks = [];
        let done = false;
        while (!done) {
            const resp = await this.blockSearch({ ...params, page: page });
            blocks.push(...resp.blocks);
            if (blocks.length < resp.totalCount) {
                page++;
            }
            else {
                done = true;
            }
        }
        // make sure we sort by height, as tendermint may be sorting by string value of the height
        // and the earlier items may be in a higher page than the later items
        blocks.sort((a, b) => a.block.header.height - b.block.header.height);
        return {
            totalCount: blocks.length,
            blocks: blocks,
        };
    }
    /**
     * Queries block headers filtered by minHeight <= height <= maxHeight.
     *
     * @param minHeight The minimum height to be included in the result. Defaults to 0.
     * @param maxHeight The maximum height to be included in the result. Defaults to infinity.
     */
    async blockchain(minHeight, maxHeight) {
        const query = {
            method: requests.Method.Blockchain,
            params: {
                minHeight: minHeight,
                maxHeight: maxHeight,
            },
        };
        return this.doCall(query, this.p.encodeBlockchain, this.r.decodeBlockchain);
    }
    /**
     * Broadcast transaction to mempool and wait for response
     *
     * @see https://docs.tendermint.com/master/rpc/#/Tx/broadcast_tx_sync
     */
    async broadcastTxSync(params) {
        const query = { params: params, method: requests.Method.BroadcastTxSync };
        return this.doCall(query, this.p.encodeBroadcastTx, this.r.decodeBroadcastTxSync);
    }
    /**
     * Broadcast transaction to mempool and do not wait for result
     *
     * @see https://docs.tendermint.com/master/rpc/#/Tx/broadcast_tx_async
     */
    async broadcastTxAsync(params) {
        const query = { params: params, method: requests.Method.BroadcastTxAsync };
        return this.doCall(query, this.p.encodeBroadcastTx, this.r.decodeBroadcastTxAsync);
    }
    /**
     * Broadcast transaction to mempool and wait for block
     *
     * @see https://docs.tendermint.com/master/rpc/#/Tx/broadcast_tx_commit
     */
    async broadcastTxCommit(params) {
        const query = { params: params, method: requests.Method.BroadcastTxCommit };
        return this.doCall(query, this.p.encodeBroadcastTx, this.r.decodeBroadcastTxCommit);
    }
    async commit(height) {
        const query = { method: requests.Method.Commit, params: { height: height } };
        return this.doCall(query, this.p.encodeCommit, this.r.decodeCommit);
    }
    async genesis() {
        const query = { method: requests.Method.Genesis };
        return this.doCall(query, this.p.encodeGenesis, this.r.decodeGenesis);
    }
    async health() {
        const query = { method: requests.Method.Health };
        return this.doCall(query, this.p.encodeHealth, this.r.decodeHealth);
    }
    async numUnconfirmedTxs() {
        const query = { method: requests.Method.NumUnconfirmedTxs };
        return this.doCall(query, this.p.encodeNumUnconfirmedTxs, this.r.decodeNumUnconfirmedTxs);
    }
    async status() {
        const query = { method: requests.Method.Status };
        return this.doCall(query, this.p.encodeStatus, this.r.decodeStatus);
    }
    subscribeNewBlock() {
        const request = {
            method: requests.Method.Subscribe,
            query: { type: requests.SubscriptionEventType.NewBlock },
        };
        return this.subscribe(request, this.r.decodeNewBlockEvent);
    }
    subscribeNewBlockHeader() {
        const request = {
            method: requests.Method.Subscribe,
            query: { type: requests.SubscriptionEventType.NewBlockHeader },
        };
        return this.subscribe(request, this.r.decodeNewBlockHeaderEvent);
    }
    subscribeTx(query) {
        const request = {
            method: requests.Method.Subscribe,
            query: {
                type: requests.SubscriptionEventType.Tx,
                raw: query,
            },
        };
        return this.subscribe(request, this.r.decodeTxEvent);
    }
    /**
     * Get a single transaction by hash
     *
     * @see https://docs.tendermint.com/master/rpc/#/Info/tx
     */
    async tx(params) {
        const query = { params: params, method: requests.Method.Tx };
        return this.doCall(query, this.p.encodeTx, this.r.decodeTx);
    }
    /**
     * Search for transactions that are in a block
     *
     * @see https://docs.tendermint.com/master/rpc/#/Info/tx_search
     */
    async txSearch(params) {
        const query = { params: params, method: requests.Method.TxSearch };
        return this.doCall(query, this.p.encodeTxSearch, this.r.decodeTxSearch);
    }
    // this should paginate through all txSearch options to ensure it returns all results.
    // starts with page 1 or whatever was provided (eg. to start on page 7)
    async txSearchAll(params) {
        let page = params.page || 1;
        const txs = [];
        let done = false;
        while (!done) {
            const resp = await this.txSearch({ ...params, page: page });
            txs.push(...resp.txs);
            if (txs.length < resp.totalCount) {
                page++;
            }
            else {
                done = true;
            }
        }
        return {
            totalCount: txs.length,
            txs: txs,
        };
    }
    async validators(params) {
        const query = {
            method: requests.Method.Validators,
            params: params,
        };
        return this.doCall(query, this.p.encodeValidators, this.r.decodeValidators);
    }
    async validatorsAll(height) {
        const validators = [];
        let page = 1;
        let done = false;
        let blockHeight = height;
        while (!done) {
            const response = await this.validators({
                per_page: 50,
                height: blockHeight,
                page: page,
            });
            validators.push(...response.validators);
            blockHeight = blockHeight || response.blockHeight;
            if (validators.length < response.total) {
                page++;
            }
            else {
                done = true;
            }
        }
        return {
            // NOTE: Default value is for type safety but this should always be set
            blockHeight: blockHeight !== null && blockHeight !== void 0 ? blockHeight : 0,
            count: validators.length,
            total: validators.length,
            validators: validators,
        };
    }
    // doCall is a helper to handle the encode/call/decode logic
    async doCall(request, encode, decode) {
        const req = encode(request);
        const result = await this.client.execute(req);
        return decode(result);
    }
    subscribe(request, decode) {
        if (!(0, rpcclients_1.instanceOfRpcStreamingClient)(this.client)) {
            throw new Error("This RPC client type cannot subscribe to events");
        }
        const req = this.p.encodeSubscribe(request);
        const eventStream = this.client.listen(req);
        return eventStream.map((event) => {
            return decode(event);
        });
    }
}
exports.Tendermint34Client = Tendermint34Client;
//# sourceMappingURL=tendermint34client.js.map

/***/ }),

/***/ 36023:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

// Types in this file are exported outside of the @cosmjs/tendermint-rpc package,
// e.g. as part of a request or response
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.BlockIdFlag = void 0;
var BlockIdFlag;
(function (BlockIdFlag) {
    BlockIdFlag[BlockIdFlag["Unknown"] = 0] = "Unknown";
    BlockIdFlag[BlockIdFlag["Absent"] = 1] = "Absent";
    BlockIdFlag[BlockIdFlag["Commit"] = 2] = "Commit";
    BlockIdFlag[BlockIdFlag["Nil"] = 3] = "Nil";
    BlockIdFlag[BlockIdFlag["Unrecognized"] = -1] = "Unrecognized";
})(BlockIdFlag = exports.BlockIdFlag || (exports.BlockIdFlag = {}));
//# sourceMappingURL=types.js.map

/***/ }),

/***/ 19054:
/***/ (function(module) {

"use strict";

var ALPHABET = 'qpzry9x8gf2tvdw0s3jn54khce6mua7l'

// pre-compute lookup table
var ALPHABET_MAP = {}
for (var z = 0; z < ALPHABET.length; z++) {
  var x = ALPHABET.charAt(z)

  if (ALPHABET_MAP[x] !== undefined) throw new TypeError(x + ' is ambiguous')
  ALPHABET_MAP[x] = z
}

function polymodStep (pre) {
  var b = pre >> 25
  return ((pre & 0x1FFFFFF) << 5) ^
    (-((b >> 0) & 1) & 0x3b6a57b2) ^
    (-((b >> 1) & 1) & 0x26508e6d) ^
    (-((b >> 2) & 1) & 0x1ea119fa) ^
    (-((b >> 3) & 1) & 0x3d4233dd) ^
    (-((b >> 4) & 1) & 0x2a1462b3)
}

function prefixChk (prefix) {
  var chk = 1
  for (var i = 0; i < prefix.length; ++i) {
    var c = prefix.charCodeAt(i)
    if (c < 33 || c > 126) return 'Invalid prefix (' + prefix + ')'

    chk = polymodStep(chk) ^ (c >> 5)
  }
  chk = polymodStep(chk)

  for (i = 0; i < prefix.length; ++i) {
    var v = prefix.charCodeAt(i)
    chk = polymodStep(chk) ^ (v & 0x1f)
  }
  return chk
}

function encode (prefix, words, LIMIT) {
  LIMIT = LIMIT || 90
  if ((prefix.length + 7 + words.length) > LIMIT) throw new TypeError('Exceeds length limit')

  prefix = prefix.toLowerCase()

  // determine chk mod
  var chk = prefixChk(prefix)
  if (typeof chk === 'string') throw new Error(chk)

  var result = prefix + '1'
  for (var i = 0; i < words.length; ++i) {
    var x = words[i]
    if ((x >> 5) !== 0) throw new Error('Non 5-bit word')

    chk = polymodStep(chk) ^ x
    result += ALPHABET.charAt(x)
  }

  for (i = 0; i < 6; ++i) {
    chk = polymodStep(chk)
  }
  chk ^= 1

  for (i = 0; i < 6; ++i) {
    var v = (chk >> ((5 - i) * 5)) & 0x1f
    result += ALPHABET.charAt(v)
  }

  return result
}

function __decode (str, LIMIT) {
  LIMIT = LIMIT || 90
  if (str.length < 8) return str + ' too short'
  if (str.length > LIMIT) return 'Exceeds length limit'

  // don't allow mixed case
  var lowered = str.toLowerCase()
  var uppered = str.toUpperCase()
  if (str !== lowered && str !== uppered) return 'Mixed-case string ' + str
  str = lowered

  var split = str.lastIndexOf('1')
  if (split === -1) return 'No separator character for ' + str
  if (split === 0) return 'Missing prefix for ' + str

  var prefix = str.slice(0, split)
  var wordChars = str.slice(split + 1)
  if (wordChars.length < 6) return 'Data too short'

  var chk = prefixChk(prefix)
  if (typeof chk === 'string') return chk

  var words = []
  for (var i = 0; i < wordChars.length; ++i) {
    var c = wordChars.charAt(i)
    var v = ALPHABET_MAP[c]
    if (v === undefined) return 'Unknown character ' + c
    chk = polymodStep(chk) ^ v

    // not in the checksum?
    if (i + 6 >= wordChars.length) continue
    words.push(v)
  }

  if (chk !== 1) return 'Invalid checksum for ' + str
  return { prefix: prefix, words: words }
}

function decodeUnsafe () {
  var res = __decode.apply(null, arguments)
  if (typeof res === 'object') return res
}

function decode (str) {
  var res = __decode.apply(null, arguments)
  if (typeof res === 'object') return res

  throw new Error(res)
}

function convert (data, inBits, outBits, pad) {
  var value = 0
  var bits = 0
  var maxV = (1 << outBits) - 1

  var result = []
  for (var i = 0; i < data.length; ++i) {
    value = (value << inBits) | data[i]
    bits += inBits

    while (bits >= outBits) {
      bits -= outBits
      result.push((value >> bits) & maxV)
    }
  }

  if (pad) {
    if (bits > 0) {
      result.push((value << (outBits - bits)) & maxV)
    }
  } else {
    if (bits >= inBits) return 'Excess padding'
    if ((value << (outBits - bits)) & maxV) return 'Non-zero padding'
  }

  return result
}

function toWordsUnsafe (bytes) {
  var res = convert(bytes, 8, 5, true)
  if (Array.isArray(res)) return res
}

function toWords (bytes) {
  var res = convert(bytes, 8, 5, true)
  if (Array.isArray(res)) return res

  throw new Error(res)
}

function fromWordsUnsafe (words) {
  var res = convert(words, 5, 8, false)
  if (Array.isArray(res)) return res
}

function fromWords (words) {
  var res = convert(words, 5, 8, false)
  if (Array.isArray(res)) return res

  throw new Error(res)
}

module.exports = {
  decodeUnsafe: decodeUnsafe,
  decode: decode,
  encode: encode,
  toWordsUnsafe: toWordsUnsafe,
  toWords: toWords,
  fromWordsUnsafe: fromWordsUnsafe,
  fromWords: fromWords
}


/***/ }),

/***/ 69892:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CompressedNonExistenceProof = exports.CompressedExistenceProof = exports.CompressedBatchEntry = exports.CompressedBatchProof = exports.BatchEntry = exports.BatchProof = exports.InnerSpec = exports.ProofSpec = exports.InnerOp = exports.LeafOp = exports.CommitmentProof = exports.NonExistenceProof = exports.ExistenceProof = exports.lengthOpToJSON = exports.lengthOpFromJSON = exports.LengthOp = exports.hashOpToJSON = exports.hashOpFromJSON = exports.HashOp = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(__webpack_require__(47873));
const minimal_1 = __importDefault(__webpack_require__(62100));
exports.protobufPackage = "ics23";
var HashOp;
(function (HashOp) {
    /** NO_HASH - NO_HASH is the default if no data passed. Note this is an illegal argument some places. */
    HashOp[HashOp["NO_HASH"] = 0] = "NO_HASH";
    HashOp[HashOp["SHA256"] = 1] = "SHA256";
    HashOp[HashOp["SHA512"] = 2] = "SHA512";
    HashOp[HashOp["KECCAK"] = 3] = "KECCAK";
    HashOp[HashOp["RIPEMD160"] = 4] = "RIPEMD160";
    /** BITCOIN - ripemd160(sha256(x)) */
    HashOp[HashOp["BITCOIN"] = 5] = "BITCOIN";
    HashOp[HashOp["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(HashOp = exports.HashOp || (exports.HashOp = {}));
function hashOpFromJSON(object) {
    switch (object) {
        case 0:
        case "NO_HASH":
            return HashOp.NO_HASH;
        case 1:
        case "SHA256":
            return HashOp.SHA256;
        case 2:
        case "SHA512":
            return HashOp.SHA512;
        case 3:
        case "KECCAK":
            return HashOp.KECCAK;
        case 4:
        case "RIPEMD160":
            return HashOp.RIPEMD160;
        case 5:
        case "BITCOIN":
            return HashOp.BITCOIN;
        case -1:
        case "UNRECOGNIZED":
        default:
            return HashOp.UNRECOGNIZED;
    }
}
exports.hashOpFromJSON = hashOpFromJSON;
function hashOpToJSON(object) {
    switch (object) {
        case HashOp.NO_HASH:
            return "NO_HASH";
        case HashOp.SHA256:
            return "SHA256";
        case HashOp.SHA512:
            return "SHA512";
        case HashOp.KECCAK:
            return "KECCAK";
        case HashOp.RIPEMD160:
            return "RIPEMD160";
        case HashOp.BITCOIN:
            return "BITCOIN";
        case HashOp.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.hashOpToJSON = hashOpToJSON;
/**
 * LengthOp defines how to process the key and value of the LeafOp
 * to include length information. After encoding the length with the given
 * algorithm, the length will be prepended to the key and value bytes.
 * (Each one with it's own encoded length)
 */
var LengthOp;
(function (LengthOp) {
    /** NO_PREFIX - NO_PREFIX don't include any length info */
    LengthOp[LengthOp["NO_PREFIX"] = 0] = "NO_PREFIX";
    /** VAR_PROTO - VAR_PROTO uses protobuf (and go-amino) varint encoding of the length */
    LengthOp[LengthOp["VAR_PROTO"] = 1] = "VAR_PROTO";
    /** VAR_RLP - VAR_RLP uses rlp int encoding of the length */
    LengthOp[LengthOp["VAR_RLP"] = 2] = "VAR_RLP";
    /** FIXED32_BIG - FIXED32_BIG uses big-endian encoding of the length as a 32 bit integer */
    LengthOp[LengthOp["FIXED32_BIG"] = 3] = "FIXED32_BIG";
    /** FIXED32_LITTLE - FIXED32_LITTLE uses little-endian encoding of the length as a 32 bit integer */
    LengthOp[LengthOp["FIXED32_LITTLE"] = 4] = "FIXED32_LITTLE";
    /** FIXED64_BIG - FIXED64_BIG uses big-endian encoding of the length as a 64 bit integer */
    LengthOp[LengthOp["FIXED64_BIG"] = 5] = "FIXED64_BIG";
    /** FIXED64_LITTLE - FIXED64_LITTLE uses little-endian encoding of the length as a 64 bit integer */
    LengthOp[LengthOp["FIXED64_LITTLE"] = 6] = "FIXED64_LITTLE";
    /** REQUIRE_32_BYTES - REQUIRE_32_BYTES is like NONE, but will fail if the input is not exactly 32 bytes (sha256 output) */
    LengthOp[LengthOp["REQUIRE_32_BYTES"] = 7] = "REQUIRE_32_BYTES";
    /** REQUIRE_64_BYTES - REQUIRE_64_BYTES is like NONE, but will fail if the input is not exactly 64 bytes (sha512 output) */
    LengthOp[LengthOp["REQUIRE_64_BYTES"] = 8] = "REQUIRE_64_BYTES";
    LengthOp[LengthOp["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(LengthOp = exports.LengthOp || (exports.LengthOp = {}));
function lengthOpFromJSON(object) {
    switch (object) {
        case 0:
        case "NO_PREFIX":
            return LengthOp.NO_PREFIX;
        case 1:
        case "VAR_PROTO":
            return LengthOp.VAR_PROTO;
        case 2:
        case "VAR_RLP":
            return LengthOp.VAR_RLP;
        case 3:
        case "FIXED32_BIG":
            return LengthOp.FIXED32_BIG;
        case 4:
        case "FIXED32_LITTLE":
            return LengthOp.FIXED32_LITTLE;
        case 5:
        case "FIXED64_BIG":
            return LengthOp.FIXED64_BIG;
        case 6:
        case "FIXED64_LITTLE":
            return LengthOp.FIXED64_LITTLE;
        case 7:
        case "REQUIRE_32_BYTES":
            return LengthOp.REQUIRE_32_BYTES;
        case 8:
        case "REQUIRE_64_BYTES":
            return LengthOp.REQUIRE_64_BYTES;
        case -1:
        case "UNRECOGNIZED":
        default:
            return LengthOp.UNRECOGNIZED;
    }
}
exports.lengthOpFromJSON = lengthOpFromJSON;
function lengthOpToJSON(object) {
    switch (object) {
        case LengthOp.NO_PREFIX:
            return "NO_PREFIX";
        case LengthOp.VAR_PROTO:
            return "VAR_PROTO";
        case LengthOp.VAR_RLP:
            return "VAR_RLP";
        case LengthOp.FIXED32_BIG:
            return "FIXED32_BIG";
        case LengthOp.FIXED32_LITTLE:
            return "FIXED32_LITTLE";
        case LengthOp.FIXED64_BIG:
            return "FIXED64_BIG";
        case LengthOp.FIXED64_LITTLE:
            return "FIXED64_LITTLE";
        case LengthOp.REQUIRE_32_BYTES:
            return "REQUIRE_32_BYTES";
        case LengthOp.REQUIRE_64_BYTES:
            return "REQUIRE_64_BYTES";
        case LengthOp.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.lengthOpToJSON = lengthOpToJSON;
function createBaseExistenceProof() {
    return { key: new Uint8Array(), value: new Uint8Array(), leaf: undefined, path: [] };
}
exports.ExistenceProof = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.key.length !== 0) {
            writer.uint32(10).bytes(message.key);
        }
        if (message.value.length !== 0) {
            writer.uint32(18).bytes(message.value);
        }
        if (message.leaf !== undefined) {
            exports.LeafOp.encode(message.leaf, writer.uint32(26).fork()).ldelim();
        }
        for (const v of message.path) {
            exports.InnerOp.encode(v, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseExistenceProof();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.key = reader.bytes();
                    break;
                case 2:
                    message.value = reader.bytes();
                    break;
                case 3:
                    message.leaf = exports.LeafOp.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.path.push(exports.InnerOp.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            key: isSet(object.key) ? bytesFromBase64(object.key) : new Uint8Array(),
            value: isSet(object.value) ? bytesFromBase64(object.value) : new Uint8Array(),
            leaf: isSet(object.leaf) ? exports.LeafOp.fromJSON(object.leaf) : undefined,
            path: Array.isArray(object === null || object === void 0 ? void 0 : object.path) ? object.path.map((e) => exports.InnerOp.fromJSON(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        message.key !== undefined &&
            (obj.key = base64FromBytes(message.key !== undefined ? message.key : new Uint8Array()));
        message.value !== undefined &&
            (obj.value = base64FromBytes(message.value !== undefined ? message.value : new Uint8Array()));
        message.leaf !== undefined && (obj.leaf = message.leaf ? exports.LeafOp.toJSON(message.leaf) : undefined);
        if (message.path) {
            obj.path = message.path.map((e) => (e ? exports.InnerOp.toJSON(e) : undefined));
        }
        else {
            obj.path = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseExistenceProof();
        message.key = (_a = object.key) !== null && _a !== void 0 ? _a : new Uint8Array();
        message.value = (_b = object.value) !== null && _b !== void 0 ? _b : new Uint8Array();
        message.leaf =
            object.leaf !== undefined && object.leaf !== null ? exports.LeafOp.fromPartial(object.leaf) : undefined;
        message.path = ((_c = object.path) === null || _c === void 0 ? void 0 : _c.map((e) => exports.InnerOp.fromPartial(e))) || [];
        return message;
    },
};
function createBaseNonExistenceProof() {
    return { key: new Uint8Array(), left: undefined, right: undefined };
}
exports.NonExistenceProof = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.key.length !== 0) {
            writer.uint32(10).bytes(message.key);
        }
        if (message.left !== undefined) {
            exports.ExistenceProof.encode(message.left, writer.uint32(18).fork()).ldelim();
        }
        if (message.right !== undefined) {
            exports.ExistenceProof.encode(message.right, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseNonExistenceProof();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.key = reader.bytes();
                    break;
                case 2:
                    message.left = exports.ExistenceProof.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.right = exports.ExistenceProof.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            key: isSet(object.key) ? bytesFromBase64(object.key) : new Uint8Array(),
            left: isSet(object.left) ? exports.ExistenceProof.fromJSON(object.left) : undefined,
            right: isSet(object.right) ? exports.ExistenceProof.fromJSON(object.right) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.key !== undefined &&
            (obj.key = base64FromBytes(message.key !== undefined ? message.key : new Uint8Array()));
        message.left !== undefined && (obj.left = message.left ? exports.ExistenceProof.toJSON(message.left) : undefined);
        message.right !== undefined &&
            (obj.right = message.right ? exports.ExistenceProof.toJSON(message.right) : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseNonExistenceProof();
        message.key = (_a = object.key) !== null && _a !== void 0 ? _a : new Uint8Array();
        message.left =
            object.left !== undefined && object.left !== null ? exports.ExistenceProof.fromPartial(object.left) : undefined;
        message.right =
            object.right !== undefined && object.right !== null
                ? exports.ExistenceProof.fromPartial(object.right)
                : undefined;
        return message;
    },
};
function createBaseCommitmentProof() {
    return { exist: undefined, nonexist: undefined, batch: undefined, compressed: undefined };
}
exports.CommitmentProof = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.exist !== undefined) {
            exports.ExistenceProof.encode(message.exist, writer.uint32(10).fork()).ldelim();
        }
        if (message.nonexist !== undefined) {
            exports.NonExistenceProof.encode(message.nonexist, writer.uint32(18).fork()).ldelim();
        }
        if (message.batch !== undefined) {
            exports.BatchProof.encode(message.batch, writer.uint32(26).fork()).ldelim();
        }
        if (message.compressed !== undefined) {
            exports.CompressedBatchProof.encode(message.compressed, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCommitmentProof();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.exist = exports.ExistenceProof.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.nonexist = exports.NonExistenceProof.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.batch = exports.BatchProof.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.compressed = exports.CompressedBatchProof.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            exist: isSet(object.exist) ? exports.ExistenceProof.fromJSON(object.exist) : undefined,
            nonexist: isSet(object.nonexist) ? exports.NonExistenceProof.fromJSON(object.nonexist) : undefined,
            batch: isSet(object.batch) ? exports.BatchProof.fromJSON(object.batch) : undefined,
            compressed: isSet(object.compressed) ? exports.CompressedBatchProof.fromJSON(object.compressed) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.exist !== undefined &&
            (obj.exist = message.exist ? exports.ExistenceProof.toJSON(message.exist) : undefined);
        message.nonexist !== undefined &&
            (obj.nonexist = message.nonexist ? exports.NonExistenceProof.toJSON(message.nonexist) : undefined);
        message.batch !== undefined && (obj.batch = message.batch ? exports.BatchProof.toJSON(message.batch) : undefined);
        message.compressed !== undefined &&
            (obj.compressed = message.compressed ? exports.CompressedBatchProof.toJSON(message.compressed) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseCommitmentProof();
        message.exist =
            object.exist !== undefined && object.exist !== null
                ? exports.ExistenceProof.fromPartial(object.exist)
                : undefined;
        message.nonexist =
            object.nonexist !== undefined && object.nonexist !== null
                ? exports.NonExistenceProof.fromPartial(object.nonexist)
                : undefined;
        message.batch =
            object.batch !== undefined && object.batch !== null ? exports.BatchProof.fromPartial(object.batch) : undefined;
        message.compressed =
            object.compressed !== undefined && object.compressed !== null
                ? exports.CompressedBatchProof.fromPartial(object.compressed)
                : undefined;
        return message;
    },
};
function createBaseLeafOp() {
    return { hash: 0, prehashKey: 0, prehashValue: 0, length: 0, prefix: new Uint8Array() };
}
exports.LeafOp = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.hash !== 0) {
            writer.uint32(8).int32(message.hash);
        }
        if (message.prehashKey !== 0) {
            writer.uint32(16).int32(message.prehashKey);
        }
        if (message.prehashValue !== 0) {
            writer.uint32(24).int32(message.prehashValue);
        }
        if (message.length !== 0) {
            writer.uint32(32).int32(message.length);
        }
        if (message.prefix.length !== 0) {
            writer.uint32(42).bytes(message.prefix);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseLeafOp();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.hash = reader.int32();
                    break;
                case 2:
                    message.prehashKey = reader.int32();
                    break;
                case 3:
                    message.prehashValue = reader.int32();
                    break;
                case 4:
                    message.length = reader.int32();
                    break;
                case 5:
                    message.prefix = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            hash: isSet(object.hash) ? hashOpFromJSON(object.hash) : 0,
            prehashKey: isSet(object.prehashKey) ? hashOpFromJSON(object.prehashKey) : 0,
            prehashValue: isSet(object.prehashValue) ? hashOpFromJSON(object.prehashValue) : 0,
            length: isSet(object.length) ? lengthOpFromJSON(object.length) : 0,
            prefix: isSet(object.prefix) ? bytesFromBase64(object.prefix) : new Uint8Array(),
        };
    },
    toJSON(message) {
        const obj = {};
        message.hash !== undefined && (obj.hash = hashOpToJSON(message.hash));
        message.prehashKey !== undefined && (obj.prehashKey = hashOpToJSON(message.prehashKey));
        message.prehashValue !== undefined && (obj.prehashValue = hashOpToJSON(message.prehashValue));
        message.length !== undefined && (obj.length = lengthOpToJSON(message.length));
        message.prefix !== undefined &&
            (obj.prefix = base64FromBytes(message.prefix !== undefined ? message.prefix : new Uint8Array()));
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e;
        const message = createBaseLeafOp();
        message.hash = (_a = object.hash) !== null && _a !== void 0 ? _a : 0;
        message.prehashKey = (_b = object.prehashKey) !== null && _b !== void 0 ? _b : 0;
        message.prehashValue = (_c = object.prehashValue) !== null && _c !== void 0 ? _c : 0;
        message.length = (_d = object.length) !== null && _d !== void 0 ? _d : 0;
        message.prefix = (_e = object.prefix) !== null && _e !== void 0 ? _e : new Uint8Array();
        return message;
    },
};
function createBaseInnerOp() {
    return { hash: 0, prefix: new Uint8Array(), suffix: new Uint8Array() };
}
exports.InnerOp = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.hash !== 0) {
            writer.uint32(8).int32(message.hash);
        }
        if (message.prefix.length !== 0) {
            writer.uint32(18).bytes(message.prefix);
        }
        if (message.suffix.length !== 0) {
            writer.uint32(26).bytes(message.suffix);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseInnerOp();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.hash = reader.int32();
                    break;
                case 2:
                    message.prefix = reader.bytes();
                    break;
                case 3:
                    message.suffix = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            hash: isSet(object.hash) ? hashOpFromJSON(object.hash) : 0,
            prefix: isSet(object.prefix) ? bytesFromBase64(object.prefix) : new Uint8Array(),
            suffix: isSet(object.suffix) ? bytesFromBase64(object.suffix) : new Uint8Array(),
        };
    },
    toJSON(message) {
        const obj = {};
        message.hash !== undefined && (obj.hash = hashOpToJSON(message.hash));
        message.prefix !== undefined &&
            (obj.prefix = base64FromBytes(message.prefix !== undefined ? message.prefix : new Uint8Array()));
        message.suffix !== undefined &&
            (obj.suffix = base64FromBytes(message.suffix !== undefined ? message.suffix : new Uint8Array()));
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseInnerOp();
        message.hash = (_a = object.hash) !== null && _a !== void 0 ? _a : 0;
        message.prefix = (_b = object.prefix) !== null && _b !== void 0 ? _b : new Uint8Array();
        message.suffix = (_c = object.suffix) !== null && _c !== void 0 ? _c : new Uint8Array();
        return message;
    },
};
function createBaseProofSpec() {
    return { leafSpec: undefined, innerSpec: undefined, maxDepth: 0, minDepth: 0 };
}
exports.ProofSpec = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.leafSpec !== undefined) {
            exports.LeafOp.encode(message.leafSpec, writer.uint32(10).fork()).ldelim();
        }
        if (message.innerSpec !== undefined) {
            exports.InnerSpec.encode(message.innerSpec, writer.uint32(18).fork()).ldelim();
        }
        if (message.maxDepth !== 0) {
            writer.uint32(24).int32(message.maxDepth);
        }
        if (message.minDepth !== 0) {
            writer.uint32(32).int32(message.minDepth);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseProofSpec();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.leafSpec = exports.LeafOp.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.innerSpec = exports.InnerSpec.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.maxDepth = reader.int32();
                    break;
                case 4:
                    message.minDepth = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            leafSpec: isSet(object.leafSpec) ? exports.LeafOp.fromJSON(object.leafSpec) : undefined,
            innerSpec: isSet(object.innerSpec) ? exports.InnerSpec.fromJSON(object.innerSpec) : undefined,
            maxDepth: isSet(object.maxDepth) ? Number(object.maxDepth) : 0,
            minDepth: isSet(object.minDepth) ? Number(object.minDepth) : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        message.leafSpec !== undefined &&
            (obj.leafSpec = message.leafSpec ? exports.LeafOp.toJSON(message.leafSpec) : undefined);
        message.innerSpec !== undefined &&
            (obj.innerSpec = message.innerSpec ? exports.InnerSpec.toJSON(message.innerSpec) : undefined);
        message.maxDepth !== undefined && (obj.maxDepth = Math.round(message.maxDepth));
        message.minDepth !== undefined && (obj.minDepth = Math.round(message.minDepth));
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseProofSpec();
        message.leafSpec =
            object.leafSpec !== undefined && object.leafSpec !== null
                ? exports.LeafOp.fromPartial(object.leafSpec)
                : undefined;
        message.innerSpec =
            object.innerSpec !== undefined && object.innerSpec !== null
                ? exports.InnerSpec.fromPartial(object.innerSpec)
                : undefined;
        message.maxDepth = (_a = object.maxDepth) !== null && _a !== void 0 ? _a : 0;
        message.minDepth = (_b = object.minDepth) !== null && _b !== void 0 ? _b : 0;
        return message;
    },
};
function createBaseInnerSpec() {
    return {
        childOrder: [],
        childSize: 0,
        minPrefixLength: 0,
        maxPrefixLength: 0,
        emptyChild: new Uint8Array(),
        hash: 0,
    };
}
exports.InnerSpec = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        writer.uint32(10).fork();
        for (const v of message.childOrder) {
            writer.int32(v);
        }
        writer.ldelim();
        if (message.childSize !== 0) {
            writer.uint32(16).int32(message.childSize);
        }
        if (message.minPrefixLength !== 0) {
            writer.uint32(24).int32(message.minPrefixLength);
        }
        if (message.maxPrefixLength !== 0) {
            writer.uint32(32).int32(message.maxPrefixLength);
        }
        if (message.emptyChild.length !== 0) {
            writer.uint32(42).bytes(message.emptyChild);
        }
        if (message.hash !== 0) {
            writer.uint32(48).int32(message.hash);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseInnerSpec();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if ((tag & 7) === 2) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.childOrder.push(reader.int32());
                        }
                    }
                    else {
                        message.childOrder.push(reader.int32());
                    }
                    break;
                case 2:
                    message.childSize = reader.int32();
                    break;
                case 3:
                    message.minPrefixLength = reader.int32();
                    break;
                case 4:
                    message.maxPrefixLength = reader.int32();
                    break;
                case 5:
                    message.emptyChild = reader.bytes();
                    break;
                case 6:
                    message.hash = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            childOrder: Array.isArray(object === null || object === void 0 ? void 0 : object.childOrder) ? object.childOrder.map((e) => Number(e)) : [],
            childSize: isSet(object.childSize) ? Number(object.childSize) : 0,
            minPrefixLength: isSet(object.minPrefixLength) ? Number(object.minPrefixLength) : 0,
            maxPrefixLength: isSet(object.maxPrefixLength) ? Number(object.maxPrefixLength) : 0,
            emptyChild: isSet(object.emptyChild) ? bytesFromBase64(object.emptyChild) : new Uint8Array(),
            hash: isSet(object.hash) ? hashOpFromJSON(object.hash) : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.childOrder) {
            obj.childOrder = message.childOrder.map((e) => Math.round(e));
        }
        else {
            obj.childOrder = [];
        }
        message.childSize !== undefined && (obj.childSize = Math.round(message.childSize));
        message.minPrefixLength !== undefined && (obj.minPrefixLength = Math.round(message.minPrefixLength));
        message.maxPrefixLength !== undefined && (obj.maxPrefixLength = Math.round(message.maxPrefixLength));
        message.emptyChild !== undefined &&
            (obj.emptyChild = base64FromBytes(message.emptyChild !== undefined ? message.emptyChild : new Uint8Array()));
        message.hash !== undefined && (obj.hash = hashOpToJSON(message.hash));
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f;
        const message = createBaseInnerSpec();
        message.childOrder = ((_a = object.childOrder) === null || _a === void 0 ? void 0 : _a.map((e) => e)) || [];
        message.childSize = (_b = object.childSize) !== null && _b !== void 0 ? _b : 0;
        message.minPrefixLength = (_c = object.minPrefixLength) !== null && _c !== void 0 ? _c : 0;
        message.maxPrefixLength = (_d = object.maxPrefixLength) !== null && _d !== void 0 ? _d : 0;
        message.emptyChild = (_e = object.emptyChild) !== null && _e !== void 0 ? _e : new Uint8Array();
        message.hash = (_f = object.hash) !== null && _f !== void 0 ? _f : 0;
        return message;
    },
};
function createBaseBatchProof() {
    return { entries: [] };
}
exports.BatchProof = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.entries) {
            exports.BatchEntry.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseBatchProof();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.entries.push(exports.BatchEntry.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            entries: Array.isArray(object === null || object === void 0 ? void 0 : object.entries) ? object.entries.map((e) => exports.BatchEntry.fromJSON(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.entries) {
            obj.entries = message.entries.map((e) => (e ? exports.BatchEntry.toJSON(e) : undefined));
        }
        else {
            obj.entries = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseBatchProof();
        message.entries = ((_a = object.entries) === null || _a === void 0 ? void 0 : _a.map((e) => exports.BatchEntry.fromPartial(e))) || [];
        return message;
    },
};
function createBaseBatchEntry() {
    return { exist: undefined, nonexist: undefined };
}
exports.BatchEntry = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.exist !== undefined) {
            exports.ExistenceProof.encode(message.exist, writer.uint32(10).fork()).ldelim();
        }
        if (message.nonexist !== undefined) {
            exports.NonExistenceProof.encode(message.nonexist, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseBatchEntry();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.exist = exports.ExistenceProof.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.nonexist = exports.NonExistenceProof.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            exist: isSet(object.exist) ? exports.ExistenceProof.fromJSON(object.exist) : undefined,
            nonexist: isSet(object.nonexist) ? exports.NonExistenceProof.fromJSON(object.nonexist) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.exist !== undefined &&
            (obj.exist = message.exist ? exports.ExistenceProof.toJSON(message.exist) : undefined);
        message.nonexist !== undefined &&
            (obj.nonexist = message.nonexist ? exports.NonExistenceProof.toJSON(message.nonexist) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseBatchEntry();
        message.exist =
            object.exist !== undefined && object.exist !== null
                ? exports.ExistenceProof.fromPartial(object.exist)
                : undefined;
        message.nonexist =
            object.nonexist !== undefined && object.nonexist !== null
                ? exports.NonExistenceProof.fromPartial(object.nonexist)
                : undefined;
        return message;
    },
};
function createBaseCompressedBatchProof() {
    return { entries: [], lookupInners: [] };
}
exports.CompressedBatchProof = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.entries) {
            exports.CompressedBatchEntry.encode(v, writer.uint32(10).fork()).ldelim();
        }
        for (const v of message.lookupInners) {
            exports.InnerOp.encode(v, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCompressedBatchProof();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.entries.push(exports.CompressedBatchEntry.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.lookupInners.push(exports.InnerOp.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            entries: Array.isArray(object === null || object === void 0 ? void 0 : object.entries)
                ? object.entries.map((e) => exports.CompressedBatchEntry.fromJSON(e))
                : [],
            lookupInners: Array.isArray(object === null || object === void 0 ? void 0 : object.lookupInners)
                ? object.lookupInners.map((e) => exports.InnerOp.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.entries) {
            obj.entries = message.entries.map((e) => (e ? exports.CompressedBatchEntry.toJSON(e) : undefined));
        }
        else {
            obj.entries = [];
        }
        if (message.lookupInners) {
            obj.lookupInners = message.lookupInners.map((e) => (e ? exports.InnerOp.toJSON(e) : undefined));
        }
        else {
            obj.lookupInners = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseCompressedBatchProof();
        message.entries = ((_a = object.entries) === null || _a === void 0 ? void 0 : _a.map((e) => exports.CompressedBatchEntry.fromPartial(e))) || [];
        message.lookupInners = ((_b = object.lookupInners) === null || _b === void 0 ? void 0 : _b.map((e) => exports.InnerOp.fromPartial(e))) || [];
        return message;
    },
};
function createBaseCompressedBatchEntry() {
    return { exist: undefined, nonexist: undefined };
}
exports.CompressedBatchEntry = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.exist !== undefined) {
            exports.CompressedExistenceProof.encode(message.exist, writer.uint32(10).fork()).ldelim();
        }
        if (message.nonexist !== undefined) {
            exports.CompressedNonExistenceProof.encode(message.nonexist, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCompressedBatchEntry();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.exist = exports.CompressedExistenceProof.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.nonexist = exports.CompressedNonExistenceProof.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            exist: isSet(object.exist) ? exports.CompressedExistenceProof.fromJSON(object.exist) : undefined,
            nonexist: isSet(object.nonexist) ? exports.CompressedNonExistenceProof.fromJSON(object.nonexist) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.exist !== undefined &&
            (obj.exist = message.exist ? exports.CompressedExistenceProof.toJSON(message.exist) : undefined);
        message.nonexist !== undefined &&
            (obj.nonexist = message.nonexist ? exports.CompressedNonExistenceProof.toJSON(message.nonexist) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseCompressedBatchEntry();
        message.exist =
            object.exist !== undefined && object.exist !== null
                ? exports.CompressedExistenceProof.fromPartial(object.exist)
                : undefined;
        message.nonexist =
            object.nonexist !== undefined && object.nonexist !== null
                ? exports.CompressedNonExistenceProof.fromPartial(object.nonexist)
                : undefined;
        return message;
    },
};
function createBaseCompressedExistenceProof() {
    return { key: new Uint8Array(), value: new Uint8Array(), leaf: undefined, path: [] };
}
exports.CompressedExistenceProof = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.key.length !== 0) {
            writer.uint32(10).bytes(message.key);
        }
        if (message.value.length !== 0) {
            writer.uint32(18).bytes(message.value);
        }
        if (message.leaf !== undefined) {
            exports.LeafOp.encode(message.leaf, writer.uint32(26).fork()).ldelim();
        }
        writer.uint32(34).fork();
        for (const v of message.path) {
            writer.int32(v);
        }
        writer.ldelim();
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCompressedExistenceProof();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.key = reader.bytes();
                    break;
                case 2:
                    message.value = reader.bytes();
                    break;
                case 3:
                    message.leaf = exports.LeafOp.decode(reader, reader.uint32());
                    break;
                case 4:
                    if ((tag & 7) === 2) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.path.push(reader.int32());
                        }
                    }
                    else {
                        message.path.push(reader.int32());
                    }
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            key: isSet(object.key) ? bytesFromBase64(object.key) : new Uint8Array(),
            value: isSet(object.value) ? bytesFromBase64(object.value) : new Uint8Array(),
            leaf: isSet(object.leaf) ? exports.LeafOp.fromJSON(object.leaf) : undefined,
            path: Array.isArray(object === null || object === void 0 ? void 0 : object.path) ? object.path.map((e) => Number(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        message.key !== undefined &&
            (obj.key = base64FromBytes(message.key !== undefined ? message.key : new Uint8Array()));
        message.value !== undefined &&
            (obj.value = base64FromBytes(message.value !== undefined ? message.value : new Uint8Array()));
        message.leaf !== undefined && (obj.leaf = message.leaf ? exports.LeafOp.toJSON(message.leaf) : undefined);
        if (message.path) {
            obj.path = message.path.map((e) => Math.round(e));
        }
        else {
            obj.path = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseCompressedExistenceProof();
        message.key = (_a = object.key) !== null && _a !== void 0 ? _a : new Uint8Array();
        message.value = (_b = object.value) !== null && _b !== void 0 ? _b : new Uint8Array();
        message.leaf =
            object.leaf !== undefined && object.leaf !== null ? exports.LeafOp.fromPartial(object.leaf) : undefined;
        message.path = ((_c = object.path) === null || _c === void 0 ? void 0 : _c.map((e) => e)) || [];
        return message;
    },
};
function createBaseCompressedNonExistenceProof() {
    return { key: new Uint8Array(), left: undefined, right: undefined };
}
exports.CompressedNonExistenceProof = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.key.length !== 0) {
            writer.uint32(10).bytes(message.key);
        }
        if (message.left !== undefined) {
            exports.CompressedExistenceProof.encode(message.left, writer.uint32(18).fork()).ldelim();
        }
        if (message.right !== undefined) {
            exports.CompressedExistenceProof.encode(message.right, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCompressedNonExistenceProof();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.key = reader.bytes();
                    break;
                case 2:
                    message.left = exports.CompressedExistenceProof.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.right = exports.CompressedExistenceProof.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            key: isSet(object.key) ? bytesFromBase64(object.key) : new Uint8Array(),
            left: isSet(object.left) ? exports.CompressedExistenceProof.fromJSON(object.left) : undefined,
            right: isSet(object.right) ? exports.CompressedExistenceProof.fromJSON(object.right) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.key !== undefined &&
            (obj.key = base64FromBytes(message.key !== undefined ? message.key : new Uint8Array()));
        message.left !== undefined &&
            (obj.left = message.left ? exports.CompressedExistenceProof.toJSON(message.left) : undefined);
        message.right !== undefined &&
            (obj.right = message.right ? exports.CompressedExistenceProof.toJSON(message.right) : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseCompressedNonExistenceProof();
        message.key = (_a = object.key) !== null && _a !== void 0 ? _a : new Uint8Array();
        message.left =
            object.left !== undefined && object.left !== null
                ? exports.CompressedExistenceProof.fromPartial(object.left)
                : undefined;
        message.right =
            object.right !== undefined && object.right !== null
                ? exports.CompressedExistenceProof.fromPartial(object.right)
                : undefined;
        return message;
    },
};
var globalThis = (() => {
    if (typeof globalThis !== "undefined") {
        return globalThis;
    }
    if (typeof self !== "undefined") {
        return self;
    }
    if (typeof window !== "undefined") {
        return window;
    }
    if (typeof __webpack_require__.g !== "undefined") {
        return __webpack_require__.g;
    }
    throw "Unable to locate global object";
})();
function bytesFromBase64(b64) {
    if (globalThis.Buffer) {
        return Uint8Array.from(globalThis.Buffer.from(b64, "base64"));
    }
    else {
        const bin = globalThis.atob(b64);
        const arr = new Uint8Array(bin.length);
        for (let i = 0; i < bin.length; ++i) {
            arr[i] = bin.charCodeAt(i);
        }
        return arr;
    }
}
function base64FromBytes(arr) {
    if (globalThis.Buffer) {
        return globalThis.Buffer.from(arr).toString("base64");
    }
    else {
        const bin = [];
        arr.forEach((byte) => {
            bin.push(String.fromCharCode(byte));
        });
        return globalThis.btoa(bin.join(""));
    }
}
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=proofs.js.map

/***/ }),

/***/ 32024:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Params = exports.ModuleAccount = exports.BaseAccount = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(__webpack_require__(47873));
const minimal_1 = __importDefault(__webpack_require__(62100));
const any_1 = __webpack_require__(90007);
exports.protobufPackage = "cosmos.auth.v1beta1";
function createBaseBaseAccount() {
    return { address: "", pubKey: undefined, accountNumber: long_1.default.UZERO, sequence: long_1.default.UZERO };
}
exports.BaseAccount = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.address !== "") {
            writer.uint32(10).string(message.address);
        }
        if (message.pubKey !== undefined) {
            any_1.Any.encode(message.pubKey, writer.uint32(18).fork()).ldelim();
        }
        if (!message.accountNumber.isZero()) {
            writer.uint32(24).uint64(message.accountNumber);
        }
        if (!message.sequence.isZero()) {
            writer.uint32(32).uint64(message.sequence);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseBaseAccount();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.pubKey = any_1.Any.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.accountNumber = reader.uint64();
                    break;
                case 4:
                    message.sequence = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            address: isSet(object.address) ? String(object.address) : "",
            pubKey: isSet(object.pubKey) ? any_1.Any.fromJSON(object.pubKey) : undefined,
            accountNumber: isSet(object.accountNumber) ? long_1.default.fromValue(object.accountNumber) : long_1.default.UZERO,
            sequence: isSet(object.sequence) ? long_1.default.fromValue(object.sequence) : long_1.default.UZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.pubKey !== undefined && (obj.pubKey = message.pubKey ? any_1.Any.toJSON(message.pubKey) : undefined);
        message.accountNumber !== undefined &&
            (obj.accountNumber = (message.accountNumber || long_1.default.UZERO).toString());
        message.sequence !== undefined && (obj.sequence = (message.sequence || long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseBaseAccount();
        message.address = (_a = object.address) !== null && _a !== void 0 ? _a : "";
        message.pubKey =
            object.pubKey !== undefined && object.pubKey !== null ? any_1.Any.fromPartial(object.pubKey) : undefined;
        message.accountNumber =
            object.accountNumber !== undefined && object.accountNumber !== null
                ? long_1.default.fromValue(object.accountNumber)
                : long_1.default.UZERO;
        message.sequence =
            object.sequence !== undefined && object.sequence !== null
                ? long_1.default.fromValue(object.sequence)
                : long_1.default.UZERO;
        return message;
    },
};
function createBaseModuleAccount() {
    return { baseAccount: undefined, name: "", permissions: [] };
}
exports.ModuleAccount = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.baseAccount !== undefined) {
            exports.BaseAccount.encode(message.baseAccount, writer.uint32(10).fork()).ldelim();
        }
        if (message.name !== "") {
            writer.uint32(18).string(message.name);
        }
        for (const v of message.permissions) {
            writer.uint32(26).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseModuleAccount();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.baseAccount = exports.BaseAccount.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.name = reader.string();
                    break;
                case 3:
                    message.permissions.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            baseAccount: isSet(object.baseAccount) ? exports.BaseAccount.fromJSON(object.baseAccount) : undefined,
            name: isSet(object.name) ? String(object.name) : "",
            permissions: Array.isArray(object === null || object === void 0 ? void 0 : object.permissions) ? object.permissions.map((e) => String(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        message.baseAccount !== undefined &&
            (obj.baseAccount = message.baseAccount ? exports.BaseAccount.toJSON(message.baseAccount) : undefined);
        message.name !== undefined && (obj.name = message.name);
        if (message.permissions) {
            obj.permissions = message.permissions.map((e) => e);
        }
        else {
            obj.permissions = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseModuleAccount();
        message.baseAccount =
            object.baseAccount !== undefined && object.baseAccount !== null
                ? exports.BaseAccount.fromPartial(object.baseAccount)
                : undefined;
        message.name = (_a = object.name) !== null && _a !== void 0 ? _a : "";
        message.permissions = ((_b = object.permissions) === null || _b === void 0 ? void 0 : _b.map((e) => e)) || [];
        return message;
    },
};
function createBaseParams() {
    return {
        maxMemoCharacters: long_1.default.UZERO,
        txSigLimit: long_1.default.UZERO,
        txSizeCostPerByte: long_1.default.UZERO,
        sigVerifyCostEd25519: long_1.default.UZERO,
        sigVerifyCostSecp256k1: long_1.default.UZERO,
    };
}
exports.Params = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (!message.maxMemoCharacters.isZero()) {
            writer.uint32(8).uint64(message.maxMemoCharacters);
        }
        if (!message.txSigLimit.isZero()) {
            writer.uint32(16).uint64(message.txSigLimit);
        }
        if (!message.txSizeCostPerByte.isZero()) {
            writer.uint32(24).uint64(message.txSizeCostPerByte);
        }
        if (!message.sigVerifyCostEd25519.isZero()) {
            writer.uint32(32).uint64(message.sigVerifyCostEd25519);
        }
        if (!message.sigVerifyCostSecp256k1.isZero()) {
            writer.uint32(40).uint64(message.sigVerifyCostSecp256k1);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseParams();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.maxMemoCharacters = reader.uint64();
                    break;
                case 2:
                    message.txSigLimit = reader.uint64();
                    break;
                case 3:
                    message.txSizeCostPerByte = reader.uint64();
                    break;
                case 4:
                    message.sigVerifyCostEd25519 = reader.uint64();
                    break;
                case 5:
                    message.sigVerifyCostSecp256k1 = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            maxMemoCharacters: isSet(object.maxMemoCharacters)
                ? long_1.default.fromValue(object.maxMemoCharacters)
                : long_1.default.UZERO,
            txSigLimit: isSet(object.txSigLimit) ? long_1.default.fromValue(object.txSigLimit) : long_1.default.UZERO,
            txSizeCostPerByte: isSet(object.txSizeCostPerByte)
                ? long_1.default.fromValue(object.txSizeCostPerByte)
                : long_1.default.UZERO,
            sigVerifyCostEd25519: isSet(object.sigVerifyCostEd25519)
                ? long_1.default.fromValue(object.sigVerifyCostEd25519)
                : long_1.default.UZERO,
            sigVerifyCostSecp256k1: isSet(object.sigVerifyCostSecp256k1)
                ? long_1.default.fromValue(object.sigVerifyCostSecp256k1)
                : long_1.default.UZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        message.maxMemoCharacters !== undefined &&
            (obj.maxMemoCharacters = (message.maxMemoCharacters || long_1.default.UZERO).toString());
        message.txSigLimit !== undefined && (obj.txSigLimit = (message.txSigLimit || long_1.default.UZERO).toString());
        message.txSizeCostPerByte !== undefined &&
            (obj.txSizeCostPerByte = (message.txSizeCostPerByte || long_1.default.UZERO).toString());
        message.sigVerifyCostEd25519 !== undefined &&
            (obj.sigVerifyCostEd25519 = (message.sigVerifyCostEd25519 || long_1.default.UZERO).toString());
        message.sigVerifyCostSecp256k1 !== undefined &&
            (obj.sigVerifyCostSecp256k1 = (message.sigVerifyCostSecp256k1 || long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseParams();
        message.maxMemoCharacters =
            object.maxMemoCharacters !== undefined && object.maxMemoCharacters !== null
                ? long_1.default.fromValue(object.maxMemoCharacters)
                : long_1.default.UZERO;
        message.txSigLimit =
            object.txSigLimit !== undefined && object.txSigLimit !== null
                ? long_1.default.fromValue(object.txSigLimit)
                : long_1.default.UZERO;
        message.txSizeCostPerByte =
            object.txSizeCostPerByte !== undefined && object.txSizeCostPerByte !== null
                ? long_1.default.fromValue(object.txSizeCostPerByte)
                : long_1.default.UZERO;
        message.sigVerifyCostEd25519 =
            object.sigVerifyCostEd25519 !== undefined && object.sigVerifyCostEd25519 !== null
                ? long_1.default.fromValue(object.sigVerifyCostEd25519)
                : long_1.default.UZERO;
        message.sigVerifyCostSecp256k1 =
            object.sigVerifyCostSecp256k1 !== undefined && object.sigVerifyCostSecp256k1 !== null
                ? long_1.default.fromValue(object.sigVerifyCostSecp256k1)
                : long_1.default.UZERO;
        return message;
    },
};
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=auth.js.map

/***/ }),

/***/ 68230:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.QueryClientImpl = exports.QueryParamsResponse = exports.QueryParamsRequest = exports.QueryAccountResponse = exports.QueryAccountRequest = exports.QueryAccountsResponse = exports.QueryAccountsRequest = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(__webpack_require__(47873));
const minimal_1 = __importDefault(__webpack_require__(62100));
const any_1 = __webpack_require__(90007);
const pagination_1 = __webpack_require__(62635);
const auth_1 = __webpack_require__(32024);
exports.protobufPackage = "cosmos.auth.v1beta1";
function createBaseQueryAccountsRequest() {
    return { pagination: undefined };
}
exports.QueryAccountsRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryAccountsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { pagination: isSet(object.pagination) ? pagination_1.PageRequest.fromJSON(object.pagination) : undefined };
    },
    toJSON(message) {
        const obj = {};
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryAccountsRequest();
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryAccountsResponse() {
    return { accounts: [], pagination: undefined };
}
exports.QueryAccountsResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.accounts) {
            any_1.Any.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryAccountsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.accounts.push(any_1.Any.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            accounts: Array.isArray(object === null || object === void 0 ? void 0 : object.accounts) ? object.accounts.map((e) => any_1.Any.fromJSON(e)) : [],
            pagination: isSet(object.pagination) ? pagination_1.PageResponse.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.accounts) {
            obj.accounts = message.accounts.map((e) => (e ? any_1.Any.toJSON(e) : undefined));
        }
        else {
            obj.accounts = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryAccountsResponse();
        message.accounts = ((_a = object.accounts) === null || _a === void 0 ? void 0 : _a.map((e) => any_1.Any.fromPartial(e))) || [];
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryAccountRequest() {
    return { address: "" };
}
exports.QueryAccountRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.address !== "") {
            writer.uint32(10).string(message.address);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryAccountRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.address = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { address: isSet(object.address) ? String(object.address) : "" };
    },
    toJSON(message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryAccountRequest();
        message.address = (_a = object.address) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
function createBaseQueryAccountResponse() {
    return { account: undefined };
}
exports.QueryAccountResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.account !== undefined) {
            any_1.Any.encode(message.account, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryAccountResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.account = any_1.Any.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { account: isSet(object.account) ? any_1.Any.fromJSON(object.account) : undefined };
    },
    toJSON(message) {
        const obj = {};
        message.account !== undefined &&
            (obj.account = message.account ? any_1.Any.toJSON(message.account) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryAccountResponse();
        message.account =
            object.account !== undefined && object.account !== null ? any_1.Any.fromPartial(object.account) : undefined;
        return message;
    },
};
function createBaseQueryParamsRequest() {
    return {};
}
exports.QueryParamsRequest = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryParamsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseQueryParamsRequest();
        return message;
    },
};
function createBaseQueryParamsResponse() {
    return { params: undefined };
}
exports.QueryParamsResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.params !== undefined) {
            auth_1.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryParamsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.params = auth_1.Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { params: isSet(object.params) ? auth_1.Params.fromJSON(object.params) : undefined };
    },
    toJSON(message) {
        const obj = {};
        message.params !== undefined && (obj.params = message.params ? auth_1.Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryParamsResponse();
        message.params =
            object.params !== undefined && object.params !== null ? auth_1.Params.fromPartial(object.params) : undefined;
        return message;
    },
};
class QueryClientImpl {
    constructor(rpc) {
        this.rpc = rpc;
        this.Accounts = this.Accounts.bind(this);
        this.Account = this.Account.bind(this);
        this.Params = this.Params.bind(this);
    }
    Accounts(request) {
        const data = exports.QueryAccountsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.auth.v1beta1.Query", "Accounts", data);
        return promise.then((data) => exports.QueryAccountsResponse.decode(new minimal_1.default.Reader(data)));
    }
    Account(request) {
        const data = exports.QueryAccountRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.auth.v1beta1.Query", "Account", data);
        return promise.then((data) => exports.QueryAccountResponse.decode(new minimal_1.default.Reader(data)));
    }
    Params(request) {
        const data = exports.QueryParamsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.auth.v1beta1.Query", "Params", data);
        return promise.then((data) => exports.QueryParamsResponse.decode(new minimal_1.default.Reader(data)));
    }
}
exports.QueryClientImpl = QueryClientImpl;
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=query.js.map

/***/ }),

/***/ 5670:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.GrantAuthorization = exports.Grant = exports.GenericAuthorization = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(__webpack_require__(47873));
const minimal_1 = __importDefault(__webpack_require__(62100));
const any_1 = __webpack_require__(90007);
const timestamp_1 = __webpack_require__(76620);
exports.protobufPackage = "cosmos.authz.v1beta1";
function createBaseGenericAuthorization() {
    return { msg: "" };
}
exports.GenericAuthorization = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.msg !== "") {
            writer.uint32(10).string(message.msg);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGenericAuthorization();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.msg = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { msg: isSet(object.msg) ? String(object.msg) : "" };
    },
    toJSON(message) {
        const obj = {};
        message.msg !== undefined && (obj.msg = message.msg);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseGenericAuthorization();
        message.msg = (_a = object.msg) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
function createBaseGrant() {
    return { authorization: undefined, expiration: undefined };
}
exports.Grant = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.authorization !== undefined) {
            any_1.Any.encode(message.authorization, writer.uint32(10).fork()).ldelim();
        }
        if (message.expiration !== undefined) {
            timestamp_1.Timestamp.encode(message.expiration, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGrant();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.authorization = any_1.Any.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.expiration = timestamp_1.Timestamp.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            authorization: isSet(object.authorization) ? any_1.Any.fromJSON(object.authorization) : undefined,
            expiration: isSet(object.expiration) ? fromJsonTimestamp(object.expiration) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.authorization !== undefined &&
            (obj.authorization = message.authorization ? any_1.Any.toJSON(message.authorization) : undefined);
        message.expiration !== undefined && (obj.expiration = fromTimestamp(message.expiration).toISOString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseGrant();
        message.authorization =
            object.authorization !== undefined && object.authorization !== null
                ? any_1.Any.fromPartial(object.authorization)
                : undefined;
        message.expiration =
            object.expiration !== undefined && object.expiration !== null
                ? timestamp_1.Timestamp.fromPartial(object.expiration)
                : undefined;
        return message;
    },
};
function createBaseGrantAuthorization() {
    return { granter: "", grantee: "", authorization: undefined, expiration: undefined };
}
exports.GrantAuthorization = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.granter !== "") {
            writer.uint32(10).string(message.granter);
        }
        if (message.grantee !== "") {
            writer.uint32(18).string(message.grantee);
        }
        if (message.authorization !== undefined) {
            any_1.Any.encode(message.authorization, writer.uint32(26).fork()).ldelim();
        }
        if (message.expiration !== undefined) {
            timestamp_1.Timestamp.encode(message.expiration, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGrantAuthorization();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.granter = reader.string();
                    break;
                case 2:
                    message.grantee = reader.string();
                    break;
                case 3:
                    message.authorization = any_1.Any.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.expiration = timestamp_1.Timestamp.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            granter: isSet(object.granter) ? String(object.granter) : "",
            grantee: isSet(object.grantee) ? String(object.grantee) : "",
            authorization: isSet(object.authorization) ? any_1.Any.fromJSON(object.authorization) : undefined,
            expiration: isSet(object.expiration) ? fromJsonTimestamp(object.expiration) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.granter !== undefined && (obj.granter = message.granter);
        message.grantee !== undefined && (obj.grantee = message.grantee);
        message.authorization !== undefined &&
            (obj.authorization = message.authorization ? any_1.Any.toJSON(message.authorization) : undefined);
        message.expiration !== undefined && (obj.expiration = fromTimestamp(message.expiration).toISOString());
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseGrantAuthorization();
        message.granter = (_a = object.granter) !== null && _a !== void 0 ? _a : "";
        message.grantee = (_b = object.grantee) !== null && _b !== void 0 ? _b : "";
        message.authorization =
            object.authorization !== undefined && object.authorization !== null
                ? any_1.Any.fromPartial(object.authorization)
                : undefined;
        message.expiration =
            object.expiration !== undefined && object.expiration !== null
                ? timestamp_1.Timestamp.fromPartial(object.expiration)
                : undefined;
        return message;
    },
};
function toTimestamp(date) {
    const seconds = numberToLong(date.getTime() / 1000);
    const nanos = (date.getTime() % 1000) * 1000000;
    return { seconds, nanos };
}
function fromTimestamp(t) {
    let millis = t.seconds.toNumber() * 1000;
    millis += t.nanos / 1000000;
    return new Date(millis);
}
function fromJsonTimestamp(o) {
    if (o instanceof Date) {
        return toTimestamp(o);
    }
    else if (typeof o === "string") {
        return toTimestamp(new Date(o));
    }
    else {
        return timestamp_1.Timestamp.fromJSON(o);
    }
}
function numberToLong(number) {
    return long_1.default.fromNumber(number);
}
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=authz.js.map

/***/ }),

/***/ 15486:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.QueryClientImpl = exports.QueryGranteeGrantsResponse = exports.QueryGranteeGrantsRequest = exports.QueryGranterGrantsResponse = exports.QueryGranterGrantsRequest = exports.QueryGrantsResponse = exports.QueryGrantsRequest = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(__webpack_require__(47873));
const minimal_1 = __importDefault(__webpack_require__(62100));
const pagination_1 = __webpack_require__(62635);
const authz_1 = __webpack_require__(5670);
exports.protobufPackage = "cosmos.authz.v1beta1";
function createBaseQueryGrantsRequest() {
    return { granter: "", grantee: "", msgTypeUrl: "", pagination: undefined };
}
exports.QueryGrantsRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.granter !== "") {
            writer.uint32(10).string(message.granter);
        }
        if (message.grantee !== "") {
            writer.uint32(18).string(message.grantee);
        }
        if (message.msgTypeUrl !== "") {
            writer.uint32(26).string(message.msgTypeUrl);
        }
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryGrantsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.granter = reader.string();
                    break;
                case 2:
                    message.grantee = reader.string();
                    break;
                case 3:
                    message.msgTypeUrl = reader.string();
                    break;
                case 4:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            granter: isSet(object.granter) ? String(object.granter) : "",
            grantee: isSet(object.grantee) ? String(object.grantee) : "",
            msgTypeUrl: isSet(object.msgTypeUrl) ? String(object.msgTypeUrl) : "",
            pagination: isSet(object.pagination) ? pagination_1.PageRequest.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.granter !== undefined && (obj.granter = message.granter);
        message.grantee !== undefined && (obj.grantee = message.grantee);
        message.msgTypeUrl !== undefined && (obj.msgTypeUrl = message.msgTypeUrl);
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseQueryGrantsRequest();
        message.granter = (_a = object.granter) !== null && _a !== void 0 ? _a : "";
        message.grantee = (_b = object.grantee) !== null && _b !== void 0 ? _b : "";
        message.msgTypeUrl = (_c = object.msgTypeUrl) !== null && _c !== void 0 ? _c : "";
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryGrantsResponse() {
    return { grants: [], pagination: undefined };
}
exports.QueryGrantsResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.grants) {
            authz_1.Grant.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryGrantsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.grants.push(authz_1.Grant.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            grants: Array.isArray(object === null || object === void 0 ? void 0 : object.grants) ? object.grants.map((e) => authz_1.Grant.fromJSON(e)) : [],
            pagination: isSet(object.pagination) ? pagination_1.PageResponse.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.grants) {
            obj.grants = message.grants.map((e) => (e ? authz_1.Grant.toJSON(e) : undefined));
        }
        else {
            obj.grants = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryGrantsResponse();
        message.grants = ((_a = object.grants) === null || _a === void 0 ? void 0 : _a.map((e) => authz_1.Grant.fromPartial(e))) || [];
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryGranterGrantsRequest() {
    return { granter: "", pagination: undefined };
}
exports.QueryGranterGrantsRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.granter !== "") {
            writer.uint32(10).string(message.granter);
        }
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryGranterGrantsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.granter = reader.string();
                    break;
                case 2:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            granter: isSet(object.granter) ? String(object.granter) : "",
            pagination: isSet(object.pagination) ? pagination_1.PageRequest.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.granter !== undefined && (obj.granter = message.granter);
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryGranterGrantsRequest();
        message.granter = (_a = object.granter) !== null && _a !== void 0 ? _a : "";
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryGranterGrantsResponse() {
    return { grants: [], pagination: undefined };
}
exports.QueryGranterGrantsResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.grants) {
            authz_1.GrantAuthorization.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryGranterGrantsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.grants.push(authz_1.GrantAuthorization.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            grants: Array.isArray(object === null || object === void 0 ? void 0 : object.grants)
                ? object.grants.map((e) => authz_1.GrantAuthorization.fromJSON(e))
                : [],
            pagination: isSet(object.pagination) ? pagination_1.PageResponse.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.grants) {
            obj.grants = message.grants.map((e) => (e ? authz_1.GrantAuthorization.toJSON(e) : undefined));
        }
        else {
            obj.grants = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryGranterGrantsResponse();
        message.grants = ((_a = object.grants) === null || _a === void 0 ? void 0 : _a.map((e) => authz_1.GrantAuthorization.fromPartial(e))) || [];
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryGranteeGrantsRequest() {
    return { grantee: "", pagination: undefined };
}
exports.QueryGranteeGrantsRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.grantee !== "") {
            writer.uint32(10).string(message.grantee);
        }
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryGranteeGrantsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.grantee = reader.string();
                    break;
                case 2:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            grantee: isSet(object.grantee) ? String(object.grantee) : "",
            pagination: isSet(object.pagination) ? pagination_1.PageRequest.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.grantee !== undefined && (obj.grantee = message.grantee);
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryGranteeGrantsRequest();
        message.grantee = (_a = object.grantee) !== null && _a !== void 0 ? _a : "";
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryGranteeGrantsResponse() {
    return { grants: [], pagination: undefined };
}
exports.QueryGranteeGrantsResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.grants) {
            authz_1.GrantAuthorization.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryGranteeGrantsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.grants.push(authz_1.GrantAuthorization.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            grants: Array.isArray(object === null || object === void 0 ? void 0 : object.grants)
                ? object.grants.map((e) => authz_1.GrantAuthorization.fromJSON(e))
                : [],
            pagination: isSet(object.pagination) ? pagination_1.PageResponse.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.grants) {
            obj.grants = message.grants.map((e) => (e ? authz_1.GrantAuthorization.toJSON(e) : undefined));
        }
        else {
            obj.grants = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryGranteeGrantsResponse();
        message.grants = ((_a = object.grants) === null || _a === void 0 ? void 0 : _a.map((e) => authz_1.GrantAuthorization.fromPartial(e))) || [];
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
class QueryClientImpl {
    constructor(rpc) {
        this.rpc = rpc;
        this.Grants = this.Grants.bind(this);
        this.GranterGrants = this.GranterGrants.bind(this);
        this.GranteeGrants = this.GranteeGrants.bind(this);
    }
    Grants(request) {
        const data = exports.QueryGrantsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.authz.v1beta1.Query", "Grants", data);
        return promise.then((data) => exports.QueryGrantsResponse.decode(new minimal_1.default.Reader(data)));
    }
    GranterGrants(request) {
        const data = exports.QueryGranterGrantsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.authz.v1beta1.Query", "GranterGrants", data);
        return promise.then((data) => exports.QueryGranterGrantsResponse.decode(new minimal_1.default.Reader(data)));
    }
    GranteeGrants(request) {
        const data = exports.QueryGranteeGrantsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.authz.v1beta1.Query", "GranteeGrants", data);
        return promise.then((data) => exports.QueryGranteeGrantsResponse.decode(new minimal_1.default.Reader(data)));
    }
}
exports.QueryClientImpl = QueryClientImpl;
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=query.js.map

/***/ }),

/***/ 65677:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MsgClientImpl = exports.MsgRevokeResponse = exports.MsgRevoke = exports.MsgGrantResponse = exports.MsgExec = exports.MsgExecResponse = exports.MsgGrant = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(__webpack_require__(47873));
const minimal_1 = __importDefault(__webpack_require__(62100));
const any_1 = __webpack_require__(90007);
const authz_1 = __webpack_require__(5670);
exports.protobufPackage = "cosmos.authz.v1beta1";
function createBaseMsgGrant() {
    return { granter: "", grantee: "", grant: undefined };
}
exports.MsgGrant = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.granter !== "") {
            writer.uint32(10).string(message.granter);
        }
        if (message.grantee !== "") {
            writer.uint32(18).string(message.grantee);
        }
        if (message.grant !== undefined) {
            authz_1.Grant.encode(message.grant, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgGrant();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.granter = reader.string();
                    break;
                case 2:
                    message.grantee = reader.string();
                    break;
                case 3:
                    message.grant = authz_1.Grant.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            granter: isSet(object.granter) ? String(object.granter) : "",
            grantee: isSet(object.grantee) ? String(object.grantee) : "",
            grant: isSet(object.grant) ? authz_1.Grant.fromJSON(object.grant) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.granter !== undefined && (obj.granter = message.granter);
        message.grantee !== undefined && (obj.grantee = message.grantee);
        message.grant !== undefined && (obj.grant = message.grant ? authz_1.Grant.toJSON(message.grant) : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseMsgGrant();
        message.granter = (_a = object.granter) !== null && _a !== void 0 ? _a : "";
        message.grantee = (_b = object.grantee) !== null && _b !== void 0 ? _b : "";
        message.grant =
            object.grant !== undefined && object.grant !== null ? authz_1.Grant.fromPartial(object.grant) : undefined;
        return message;
    },
};
function createBaseMsgExecResponse() {
    return { results: [] };
}
exports.MsgExecResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.results) {
            writer.uint32(10).bytes(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgExecResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.results.push(reader.bytes());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            results: Array.isArray(object === null || object === void 0 ? void 0 : object.results) ? object.results.map((e) => bytesFromBase64(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.results) {
            obj.results = message.results.map((e) => base64FromBytes(e !== undefined ? e : new Uint8Array()));
        }
        else {
            obj.results = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseMsgExecResponse();
        message.results = ((_a = object.results) === null || _a === void 0 ? void 0 : _a.map((e) => e)) || [];
        return message;
    },
};
function createBaseMsgExec() {
    return { grantee: "", msgs: [] };
}
exports.MsgExec = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.grantee !== "") {
            writer.uint32(10).string(message.grantee);
        }
        for (const v of message.msgs) {
            any_1.Any.encode(v, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgExec();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.grantee = reader.string();
                    break;
                case 2:
                    message.msgs.push(any_1.Any.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            grantee: isSet(object.grantee) ? String(object.grantee) : "",
            msgs: Array.isArray(object === null || object === void 0 ? void 0 : object.msgs) ? object.msgs.map((e) => any_1.Any.fromJSON(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        message.grantee !== undefined && (obj.grantee = message.grantee);
        if (message.msgs) {
            obj.msgs = message.msgs.map((e) => (e ? any_1.Any.toJSON(e) : undefined));
        }
        else {
            obj.msgs = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseMsgExec();
        message.grantee = (_a = object.grantee) !== null && _a !== void 0 ? _a : "";
        message.msgs = ((_b = object.msgs) === null || _b === void 0 ? void 0 : _b.map((e) => any_1.Any.fromPartial(e))) || [];
        return message;
    },
};
function createBaseMsgGrantResponse() {
    return {};
}
exports.MsgGrantResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgGrantResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgGrantResponse();
        return message;
    },
};
function createBaseMsgRevoke() {
    return { granter: "", grantee: "", msgTypeUrl: "" };
}
exports.MsgRevoke = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.granter !== "") {
            writer.uint32(10).string(message.granter);
        }
        if (message.grantee !== "") {
            writer.uint32(18).string(message.grantee);
        }
        if (message.msgTypeUrl !== "") {
            writer.uint32(26).string(message.msgTypeUrl);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgRevoke();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.granter = reader.string();
                    break;
                case 2:
                    message.grantee = reader.string();
                    break;
                case 3:
                    message.msgTypeUrl = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            granter: isSet(object.granter) ? String(object.granter) : "",
            grantee: isSet(object.grantee) ? String(object.grantee) : "",
            msgTypeUrl: isSet(object.msgTypeUrl) ? String(object.msgTypeUrl) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.granter !== undefined && (obj.granter = message.granter);
        message.grantee !== undefined && (obj.grantee = message.grantee);
        message.msgTypeUrl !== undefined && (obj.msgTypeUrl = message.msgTypeUrl);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseMsgRevoke();
        message.granter = (_a = object.granter) !== null && _a !== void 0 ? _a : "";
        message.grantee = (_b = object.grantee) !== null && _b !== void 0 ? _b : "";
        message.msgTypeUrl = (_c = object.msgTypeUrl) !== null && _c !== void 0 ? _c : "";
        return message;
    },
};
function createBaseMsgRevokeResponse() {
    return {};
}
exports.MsgRevokeResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgRevokeResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgRevokeResponse();
        return message;
    },
};
class MsgClientImpl {
    constructor(rpc) {
        this.rpc = rpc;
        this.Grant = this.Grant.bind(this);
        this.Exec = this.Exec.bind(this);
        this.Revoke = this.Revoke.bind(this);
    }
    Grant(request) {
        const data = exports.MsgGrant.encode(request).finish();
        const promise = this.rpc.request("cosmos.authz.v1beta1.Msg", "Grant", data);
        return promise.then((data) => exports.MsgGrantResponse.decode(new minimal_1.default.Reader(data)));
    }
    Exec(request) {
        const data = exports.MsgExec.encode(request).finish();
        const promise = this.rpc.request("cosmos.authz.v1beta1.Msg", "Exec", data);
        return promise.then((data) => exports.MsgExecResponse.decode(new minimal_1.default.Reader(data)));
    }
    Revoke(request) {
        const data = exports.MsgRevoke.encode(request).finish();
        const promise = this.rpc.request("cosmos.authz.v1beta1.Msg", "Revoke", data);
        return promise.then((data) => exports.MsgRevokeResponse.decode(new minimal_1.default.Reader(data)));
    }
}
exports.MsgClientImpl = MsgClientImpl;
var globalThis = (() => {
    if (typeof globalThis !== "undefined") {
        return globalThis;
    }
    if (typeof self !== "undefined") {
        return self;
    }
    if (typeof window !== "undefined") {
        return window;
    }
    if (typeof __webpack_require__.g !== "undefined") {
        return __webpack_require__.g;
    }
    throw "Unable to locate global object";
})();
function bytesFromBase64(b64) {
    if (globalThis.Buffer) {
        return Uint8Array.from(globalThis.Buffer.from(b64, "base64"));
    }
    else {
        const bin = globalThis.atob(b64);
        const arr = new Uint8Array(bin.length);
        for (let i = 0; i < bin.length; ++i) {
            arr[i] = bin.charCodeAt(i);
        }
        return arr;
    }
}
function base64FromBytes(arr) {
    if (globalThis.Buffer) {
        return globalThis.Buffer.from(arr).toString("base64");
    }
    else {
        const bin = [];
        arr.forEach((byte) => {
            bin.push(String.fromCharCode(byte));
        });
        return globalThis.btoa(bin.join(""));
    }
}
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=tx.js.map

/***/ }),

/***/ 83611:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Metadata = exports.DenomUnit = exports.Supply = exports.Output = exports.Input = exports.SendEnabled = exports.Params = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(__webpack_require__(47873));
const minimal_1 = __importDefault(__webpack_require__(62100));
const coin_1 = __webpack_require__(26119);
exports.protobufPackage = "cosmos.bank.v1beta1";
function createBaseParams() {
    return { sendEnabled: [], defaultSendEnabled: false };
}
exports.Params = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.sendEnabled) {
            exports.SendEnabled.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.defaultSendEnabled === true) {
            writer.uint32(16).bool(message.defaultSendEnabled);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseParams();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.sendEnabled.push(exports.SendEnabled.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.defaultSendEnabled = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            sendEnabled: Array.isArray(object === null || object === void 0 ? void 0 : object.sendEnabled)
                ? object.sendEnabled.map((e) => exports.SendEnabled.fromJSON(e))
                : [],
            defaultSendEnabled: isSet(object.defaultSendEnabled) ? Boolean(object.defaultSendEnabled) : false,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.sendEnabled) {
            obj.sendEnabled = message.sendEnabled.map((e) => (e ? exports.SendEnabled.toJSON(e) : undefined));
        }
        else {
            obj.sendEnabled = [];
        }
        message.defaultSendEnabled !== undefined && (obj.defaultSendEnabled = message.defaultSendEnabled);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseParams();
        message.sendEnabled = ((_a = object.sendEnabled) === null || _a === void 0 ? void 0 : _a.map((e) => exports.SendEnabled.fromPartial(e))) || [];
        message.defaultSendEnabled = (_b = object.defaultSendEnabled) !== null && _b !== void 0 ? _b : false;
        return message;
    },
};
function createBaseSendEnabled() {
    return { denom: "", enabled: false };
}
exports.SendEnabled = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.denom !== "") {
            writer.uint32(10).string(message.denom);
        }
        if (message.enabled === true) {
            writer.uint32(16).bool(message.enabled);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSendEnabled();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.denom = reader.string();
                    break;
                case 2:
                    message.enabled = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            denom: isSet(object.denom) ? String(object.denom) : "",
            enabled: isSet(object.enabled) ? Boolean(object.enabled) : false,
        };
    },
    toJSON(message) {
        const obj = {};
        message.denom !== undefined && (obj.denom = message.denom);
        message.enabled !== undefined && (obj.enabled = message.enabled);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseSendEnabled();
        message.denom = (_a = object.denom) !== null && _a !== void 0 ? _a : "";
        message.enabled = (_b = object.enabled) !== null && _b !== void 0 ? _b : false;
        return message;
    },
};
function createBaseInput() {
    return { address: "", coins: [] };
}
exports.Input = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.address !== "") {
            writer.uint32(10).string(message.address);
        }
        for (const v of message.coins) {
            coin_1.Coin.encode(v, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseInput();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.coins.push(coin_1.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            address: isSet(object.address) ? String(object.address) : "",
            coins: Array.isArray(object === null || object === void 0 ? void 0 : object.coins) ? object.coins.map((e) => coin_1.Coin.fromJSON(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        if (message.coins) {
            obj.coins = message.coins.map((e) => (e ? coin_1.Coin.toJSON(e) : undefined));
        }
        else {
            obj.coins = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseInput();
        message.address = (_a = object.address) !== null && _a !== void 0 ? _a : "";
        message.coins = ((_b = object.coins) === null || _b === void 0 ? void 0 : _b.map((e) => coin_1.Coin.fromPartial(e))) || [];
        return message;
    },
};
function createBaseOutput() {
    return { address: "", coins: [] };
}
exports.Output = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.address !== "") {
            writer.uint32(10).string(message.address);
        }
        for (const v of message.coins) {
            coin_1.Coin.encode(v, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseOutput();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.coins.push(coin_1.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            address: isSet(object.address) ? String(object.address) : "",
            coins: Array.isArray(object === null || object === void 0 ? void 0 : object.coins) ? object.coins.map((e) => coin_1.Coin.fromJSON(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        if (message.coins) {
            obj.coins = message.coins.map((e) => (e ? coin_1.Coin.toJSON(e) : undefined));
        }
        else {
            obj.coins = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseOutput();
        message.address = (_a = object.address) !== null && _a !== void 0 ? _a : "";
        message.coins = ((_b = object.coins) === null || _b === void 0 ? void 0 : _b.map((e) => coin_1.Coin.fromPartial(e))) || [];
        return message;
    },
};
function createBaseSupply() {
    return { total: [] };
}
exports.Supply = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.total) {
            coin_1.Coin.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSupply();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.total.push(coin_1.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { total: Array.isArray(object === null || object === void 0 ? void 0 : object.total) ? object.total.map((e) => coin_1.Coin.fromJSON(e)) : [] };
    },
    toJSON(message) {
        const obj = {};
        if (message.total) {
            obj.total = message.total.map((e) => (e ? coin_1.Coin.toJSON(e) : undefined));
        }
        else {
            obj.total = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseSupply();
        message.total = ((_a = object.total) === null || _a === void 0 ? void 0 : _a.map((e) => coin_1.Coin.fromPartial(e))) || [];
        return message;
    },
};
function createBaseDenomUnit() {
    return { denom: "", exponent: 0, aliases: [] };
}
exports.DenomUnit = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.denom !== "") {
            writer.uint32(10).string(message.denom);
        }
        if (message.exponent !== 0) {
            writer.uint32(16).uint32(message.exponent);
        }
        for (const v of message.aliases) {
            writer.uint32(26).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDenomUnit();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.denom = reader.string();
                    break;
                case 2:
                    message.exponent = reader.uint32();
                    break;
                case 3:
                    message.aliases.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            denom: isSet(object.denom) ? String(object.denom) : "",
            exponent: isSet(object.exponent) ? Number(object.exponent) : 0,
            aliases: Array.isArray(object === null || object === void 0 ? void 0 : object.aliases) ? object.aliases.map((e) => String(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        message.denom !== undefined && (obj.denom = message.denom);
        message.exponent !== undefined && (obj.exponent = Math.round(message.exponent));
        if (message.aliases) {
            obj.aliases = message.aliases.map((e) => e);
        }
        else {
            obj.aliases = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseDenomUnit();
        message.denom = (_a = object.denom) !== null && _a !== void 0 ? _a : "";
        message.exponent = (_b = object.exponent) !== null && _b !== void 0 ? _b : 0;
        message.aliases = ((_c = object.aliases) === null || _c === void 0 ? void 0 : _c.map((e) => e)) || [];
        return message;
    },
};
function createBaseMetadata() {
    return { description: "", denomUnits: [], base: "", display: "", name: "", symbol: "" };
}
exports.Metadata = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.description !== "") {
            writer.uint32(10).string(message.description);
        }
        for (const v of message.denomUnits) {
            exports.DenomUnit.encode(v, writer.uint32(18).fork()).ldelim();
        }
        if (message.base !== "") {
            writer.uint32(26).string(message.base);
        }
        if (message.display !== "") {
            writer.uint32(34).string(message.display);
        }
        if (message.name !== "") {
            writer.uint32(42).string(message.name);
        }
        if (message.symbol !== "") {
            writer.uint32(50).string(message.symbol);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMetadata();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.description = reader.string();
                    break;
                case 2:
                    message.denomUnits.push(exports.DenomUnit.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.base = reader.string();
                    break;
                case 4:
                    message.display = reader.string();
                    break;
                case 5:
                    message.name = reader.string();
                    break;
                case 6:
                    message.symbol = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            description: isSet(object.description) ? String(object.description) : "",
            denomUnits: Array.isArray(object === null || object === void 0 ? void 0 : object.denomUnits)
                ? object.denomUnits.map((e) => exports.DenomUnit.fromJSON(e))
                : [],
            base: isSet(object.base) ? String(object.base) : "",
            display: isSet(object.display) ? String(object.display) : "",
            name: isSet(object.name) ? String(object.name) : "",
            symbol: isSet(object.symbol) ? String(object.symbol) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.description !== undefined && (obj.description = message.description);
        if (message.denomUnits) {
            obj.denomUnits = message.denomUnits.map((e) => (e ? exports.DenomUnit.toJSON(e) : undefined));
        }
        else {
            obj.denomUnits = [];
        }
        message.base !== undefined && (obj.base = message.base);
        message.display !== undefined && (obj.display = message.display);
        message.name !== undefined && (obj.name = message.name);
        message.symbol !== undefined && (obj.symbol = message.symbol);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f;
        const message = createBaseMetadata();
        message.description = (_a = object.description) !== null && _a !== void 0 ? _a : "";
        message.denomUnits = ((_b = object.denomUnits) === null || _b === void 0 ? void 0 : _b.map((e) => exports.DenomUnit.fromPartial(e))) || [];
        message.base = (_c = object.base) !== null && _c !== void 0 ? _c : "";
        message.display = (_d = object.display) !== null && _d !== void 0 ? _d : "";
        message.name = (_e = object.name) !== null && _e !== void 0 ? _e : "";
        message.symbol = (_f = object.symbol) !== null && _f !== void 0 ? _f : "";
        return message;
    },
};
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=bank.js.map

/***/ }),

/***/ 15788:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.QueryClientImpl = exports.QueryDenomMetadataResponse = exports.QueryDenomMetadataRequest = exports.QueryDenomsMetadataResponse = exports.QueryDenomsMetadataRequest = exports.QueryParamsResponse = exports.QueryParamsRequest = exports.QuerySupplyOfResponse = exports.QuerySupplyOfRequest = exports.QueryTotalSupplyResponse = exports.QueryTotalSupplyRequest = exports.QuerySpendableBalancesResponse = exports.QuerySpendableBalancesRequest = exports.QueryAllBalancesResponse = exports.QueryAllBalancesRequest = exports.QueryBalanceResponse = exports.QueryBalanceRequest = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(__webpack_require__(47873));
const minimal_1 = __importDefault(__webpack_require__(62100));
const pagination_1 = __webpack_require__(62635);
const coin_1 = __webpack_require__(26119);
const bank_1 = __webpack_require__(83611);
exports.protobufPackage = "cosmos.bank.v1beta1";
function createBaseQueryBalanceRequest() {
    return { address: "", denom: "" };
}
exports.QueryBalanceRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.address !== "") {
            writer.uint32(10).string(message.address);
        }
        if (message.denom !== "") {
            writer.uint32(18).string(message.denom);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryBalanceRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.denom = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            address: isSet(object.address) ? String(object.address) : "",
            denom: isSet(object.denom) ? String(object.denom) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.denom !== undefined && (obj.denom = message.denom);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseQueryBalanceRequest();
        message.address = (_a = object.address) !== null && _a !== void 0 ? _a : "";
        message.denom = (_b = object.denom) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
function createBaseQueryBalanceResponse() {
    return { balance: undefined };
}
exports.QueryBalanceResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.balance !== undefined) {
            coin_1.Coin.encode(message.balance, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryBalanceResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.balance = coin_1.Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { balance: isSet(object.balance) ? coin_1.Coin.fromJSON(object.balance) : undefined };
    },
    toJSON(message) {
        const obj = {};
        message.balance !== undefined &&
            (obj.balance = message.balance ? coin_1.Coin.toJSON(message.balance) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryBalanceResponse();
        message.balance =
            object.balance !== undefined && object.balance !== null ? coin_1.Coin.fromPartial(object.balance) : undefined;
        return message;
    },
};
function createBaseQueryAllBalancesRequest() {
    return { address: "", pagination: undefined };
}
exports.QueryAllBalancesRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.address !== "") {
            writer.uint32(10).string(message.address);
        }
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryAllBalancesRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            address: isSet(object.address) ? String(object.address) : "",
            pagination: isSet(object.pagination) ? pagination_1.PageRequest.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryAllBalancesRequest();
        message.address = (_a = object.address) !== null && _a !== void 0 ? _a : "";
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryAllBalancesResponse() {
    return { balances: [], pagination: undefined };
}
exports.QueryAllBalancesResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.balances) {
            coin_1.Coin.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryAllBalancesResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.balances.push(coin_1.Coin.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            balances: Array.isArray(object === null || object === void 0 ? void 0 : object.balances) ? object.balances.map((e) => coin_1.Coin.fromJSON(e)) : [],
            pagination: isSet(object.pagination) ? pagination_1.PageResponse.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.balances) {
            obj.balances = message.balances.map((e) => (e ? coin_1.Coin.toJSON(e) : undefined));
        }
        else {
            obj.balances = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryAllBalancesResponse();
        message.balances = ((_a = object.balances) === null || _a === void 0 ? void 0 : _a.map((e) => coin_1.Coin.fromPartial(e))) || [];
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQuerySpendableBalancesRequest() {
    return { address: "", pagination: undefined };
}
exports.QuerySpendableBalancesRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.address !== "") {
            writer.uint32(10).string(message.address);
        }
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQuerySpendableBalancesRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            address: isSet(object.address) ? String(object.address) : "",
            pagination: isSet(object.pagination) ? pagination_1.PageRequest.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQuerySpendableBalancesRequest();
        message.address = (_a = object.address) !== null && _a !== void 0 ? _a : "";
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQuerySpendableBalancesResponse() {
    return { balances: [], pagination: undefined };
}
exports.QuerySpendableBalancesResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.balances) {
            coin_1.Coin.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQuerySpendableBalancesResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.balances.push(coin_1.Coin.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            balances: Array.isArray(object === null || object === void 0 ? void 0 : object.balances) ? object.balances.map((e) => coin_1.Coin.fromJSON(e)) : [],
            pagination: isSet(object.pagination) ? pagination_1.PageResponse.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.balances) {
            obj.balances = message.balances.map((e) => (e ? coin_1.Coin.toJSON(e) : undefined));
        }
        else {
            obj.balances = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQuerySpendableBalancesResponse();
        message.balances = ((_a = object.balances) === null || _a === void 0 ? void 0 : _a.map((e) => coin_1.Coin.fromPartial(e))) || [];
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryTotalSupplyRequest() {
    return { pagination: undefined };
}
exports.QueryTotalSupplyRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryTotalSupplyRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { pagination: isSet(object.pagination) ? pagination_1.PageRequest.fromJSON(object.pagination) : undefined };
    },
    toJSON(message) {
        const obj = {};
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryTotalSupplyRequest();
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryTotalSupplyResponse() {
    return { supply: [], pagination: undefined };
}
exports.QueryTotalSupplyResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.supply) {
            coin_1.Coin.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryTotalSupplyResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.supply.push(coin_1.Coin.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            supply: Array.isArray(object === null || object === void 0 ? void 0 : object.supply) ? object.supply.map((e) => coin_1.Coin.fromJSON(e)) : [],
            pagination: isSet(object.pagination) ? pagination_1.PageResponse.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.supply) {
            obj.supply = message.supply.map((e) => (e ? coin_1.Coin.toJSON(e) : undefined));
        }
        else {
            obj.supply = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryTotalSupplyResponse();
        message.supply = ((_a = object.supply) === null || _a === void 0 ? void 0 : _a.map((e) => coin_1.Coin.fromPartial(e))) || [];
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQuerySupplyOfRequest() {
    return { denom: "" };
}
exports.QuerySupplyOfRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.denom !== "") {
            writer.uint32(10).string(message.denom);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQuerySupplyOfRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.denom = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { denom: isSet(object.denom) ? String(object.denom) : "" };
    },
    toJSON(message) {
        const obj = {};
        message.denom !== undefined && (obj.denom = message.denom);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQuerySupplyOfRequest();
        message.denom = (_a = object.denom) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
function createBaseQuerySupplyOfResponse() {
    return { amount: undefined };
}
exports.QuerySupplyOfResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.amount !== undefined) {
            coin_1.Coin.encode(message.amount, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQuerySupplyOfResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.amount = coin_1.Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { amount: isSet(object.amount) ? coin_1.Coin.fromJSON(object.amount) : undefined };
    },
    toJSON(message) {
        const obj = {};
        message.amount !== undefined && (obj.amount = message.amount ? coin_1.Coin.toJSON(message.amount) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQuerySupplyOfResponse();
        message.amount =
            object.amount !== undefined && object.amount !== null ? coin_1.Coin.fromPartial(object.amount) : undefined;
        return message;
    },
};
function createBaseQueryParamsRequest() {
    return {};
}
exports.QueryParamsRequest = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryParamsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseQueryParamsRequest();
        return message;
    },
};
function createBaseQueryParamsResponse() {
    return { params: undefined };
}
exports.QueryParamsResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.params !== undefined) {
            bank_1.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryParamsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.params = bank_1.Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { params: isSet(object.params) ? bank_1.Params.fromJSON(object.params) : undefined };
    },
    toJSON(message) {
        const obj = {};
        message.params !== undefined && (obj.params = message.params ? bank_1.Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryParamsResponse();
        message.params =
            object.params !== undefined && object.params !== null ? bank_1.Params.fromPartial(object.params) : undefined;
        return message;
    },
};
function createBaseQueryDenomsMetadataRequest() {
    return { pagination: undefined };
}
exports.QueryDenomsMetadataRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryDenomsMetadataRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { pagination: isSet(object.pagination) ? pagination_1.PageRequest.fromJSON(object.pagination) : undefined };
    },
    toJSON(message) {
        const obj = {};
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryDenomsMetadataRequest();
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryDenomsMetadataResponse() {
    return { metadatas: [], pagination: undefined };
}
exports.QueryDenomsMetadataResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.metadatas) {
            bank_1.Metadata.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryDenomsMetadataResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.metadatas.push(bank_1.Metadata.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            metadatas: Array.isArray(object === null || object === void 0 ? void 0 : object.metadatas)
                ? object.metadatas.map((e) => bank_1.Metadata.fromJSON(e))
                : [],
            pagination: isSet(object.pagination) ? pagination_1.PageResponse.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.metadatas) {
            obj.metadatas = message.metadatas.map((e) => (e ? bank_1.Metadata.toJSON(e) : undefined));
        }
        else {
            obj.metadatas = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryDenomsMetadataResponse();
        message.metadatas = ((_a = object.metadatas) === null || _a === void 0 ? void 0 : _a.map((e) => bank_1.Metadata.fromPartial(e))) || [];
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryDenomMetadataRequest() {
    return { denom: "" };
}
exports.QueryDenomMetadataRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.denom !== "") {
            writer.uint32(10).string(message.denom);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryDenomMetadataRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.denom = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { denom: isSet(object.denom) ? String(object.denom) : "" };
    },
    toJSON(message) {
        const obj = {};
        message.denom !== undefined && (obj.denom = message.denom);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryDenomMetadataRequest();
        message.denom = (_a = object.denom) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
function createBaseQueryDenomMetadataResponse() {
    return { metadata: undefined };
}
exports.QueryDenomMetadataResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.metadata !== undefined) {
            bank_1.Metadata.encode(message.metadata, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryDenomMetadataResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.metadata = bank_1.Metadata.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { metadata: isSet(object.metadata) ? bank_1.Metadata.fromJSON(object.metadata) : undefined };
    },
    toJSON(message) {
        const obj = {};
        message.metadata !== undefined &&
            (obj.metadata = message.metadata ? bank_1.Metadata.toJSON(message.metadata) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryDenomMetadataResponse();
        message.metadata =
            object.metadata !== undefined && object.metadata !== null
                ? bank_1.Metadata.fromPartial(object.metadata)
                : undefined;
        return message;
    },
};
class QueryClientImpl {
    constructor(rpc) {
        this.rpc = rpc;
        this.Balance = this.Balance.bind(this);
        this.AllBalances = this.AllBalances.bind(this);
        this.SpendableBalances = this.SpendableBalances.bind(this);
        this.TotalSupply = this.TotalSupply.bind(this);
        this.SupplyOf = this.SupplyOf.bind(this);
        this.Params = this.Params.bind(this);
        this.DenomMetadata = this.DenomMetadata.bind(this);
        this.DenomsMetadata = this.DenomsMetadata.bind(this);
    }
    Balance(request) {
        const data = exports.QueryBalanceRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.bank.v1beta1.Query", "Balance", data);
        return promise.then((data) => exports.QueryBalanceResponse.decode(new minimal_1.default.Reader(data)));
    }
    AllBalances(request) {
        const data = exports.QueryAllBalancesRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.bank.v1beta1.Query", "AllBalances", data);
        return promise.then((data) => exports.QueryAllBalancesResponse.decode(new minimal_1.default.Reader(data)));
    }
    SpendableBalances(request) {
        const data = exports.QuerySpendableBalancesRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.bank.v1beta1.Query", "SpendableBalances", data);
        return promise.then((data) => exports.QuerySpendableBalancesResponse.decode(new minimal_1.default.Reader(data)));
    }
    TotalSupply(request) {
        const data = exports.QueryTotalSupplyRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.bank.v1beta1.Query", "TotalSupply", data);
        return promise.then((data) => exports.QueryTotalSupplyResponse.decode(new minimal_1.default.Reader(data)));
    }
    SupplyOf(request) {
        const data = exports.QuerySupplyOfRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.bank.v1beta1.Query", "SupplyOf", data);
        return promise.then((data) => exports.QuerySupplyOfResponse.decode(new minimal_1.default.Reader(data)));
    }
    Params(request) {
        const data = exports.QueryParamsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.bank.v1beta1.Query", "Params", data);
        return promise.then((data) => exports.QueryParamsResponse.decode(new minimal_1.default.Reader(data)));
    }
    DenomMetadata(request) {
        const data = exports.QueryDenomMetadataRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.bank.v1beta1.Query", "DenomMetadata", data);
        return promise.then((data) => exports.QueryDenomMetadataResponse.decode(new minimal_1.default.Reader(data)));
    }
    DenomsMetadata(request) {
        const data = exports.QueryDenomsMetadataRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.bank.v1beta1.Query", "DenomsMetadata", data);
        return promise.then((data) => exports.QueryDenomsMetadataResponse.decode(new minimal_1.default.Reader(data)));
    }
}
exports.QueryClientImpl = QueryClientImpl;
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=query.js.map

/***/ }),

/***/ 67722:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MsgClientImpl = exports.MsgMultiSendResponse = exports.MsgMultiSend = exports.MsgSendResponse = exports.MsgSend = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(__webpack_require__(47873));
const minimal_1 = __importDefault(__webpack_require__(62100));
const coin_1 = __webpack_require__(26119);
const bank_1 = __webpack_require__(83611);
exports.protobufPackage = "cosmos.bank.v1beta1";
function createBaseMsgSend() {
    return { fromAddress: "", toAddress: "", amount: [] };
}
exports.MsgSend = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.fromAddress !== "") {
            writer.uint32(10).string(message.fromAddress);
        }
        if (message.toAddress !== "") {
            writer.uint32(18).string(message.toAddress);
        }
        for (const v of message.amount) {
            coin_1.Coin.encode(v, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgSend();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.fromAddress = reader.string();
                    break;
                case 2:
                    message.toAddress = reader.string();
                    break;
                case 3:
                    message.amount.push(coin_1.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            fromAddress: isSet(object.fromAddress) ? String(object.fromAddress) : "",
            toAddress: isSet(object.toAddress) ? String(object.toAddress) : "",
            amount: Array.isArray(object === null || object === void 0 ? void 0 : object.amount) ? object.amount.map((e) => coin_1.Coin.fromJSON(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        message.fromAddress !== undefined && (obj.fromAddress = message.fromAddress);
        message.toAddress !== undefined && (obj.toAddress = message.toAddress);
        if (message.amount) {
            obj.amount = message.amount.map((e) => (e ? coin_1.Coin.toJSON(e) : undefined));
        }
        else {
            obj.amount = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseMsgSend();
        message.fromAddress = (_a = object.fromAddress) !== null && _a !== void 0 ? _a : "";
        message.toAddress = (_b = object.toAddress) !== null && _b !== void 0 ? _b : "";
        message.amount = ((_c = object.amount) === null || _c === void 0 ? void 0 : _c.map((e) => coin_1.Coin.fromPartial(e))) || [];
        return message;
    },
};
function createBaseMsgSendResponse() {
    return {};
}
exports.MsgSendResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgSendResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgSendResponse();
        return message;
    },
};
function createBaseMsgMultiSend() {
    return { inputs: [], outputs: [] };
}
exports.MsgMultiSend = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.inputs) {
            bank_1.Input.encode(v, writer.uint32(10).fork()).ldelim();
        }
        for (const v of message.outputs) {
            bank_1.Output.encode(v, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgMultiSend();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.inputs.push(bank_1.Input.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.outputs.push(bank_1.Output.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            inputs: Array.isArray(object === null || object === void 0 ? void 0 : object.inputs) ? object.inputs.map((e) => bank_1.Input.fromJSON(e)) : [],
            outputs: Array.isArray(object === null || object === void 0 ? void 0 : object.outputs) ? object.outputs.map((e) => bank_1.Output.fromJSON(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.inputs) {
            obj.inputs = message.inputs.map((e) => (e ? bank_1.Input.toJSON(e) : undefined));
        }
        else {
            obj.inputs = [];
        }
        if (message.outputs) {
            obj.outputs = message.outputs.map((e) => (e ? bank_1.Output.toJSON(e) : undefined));
        }
        else {
            obj.outputs = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseMsgMultiSend();
        message.inputs = ((_a = object.inputs) === null || _a === void 0 ? void 0 : _a.map((e) => bank_1.Input.fromPartial(e))) || [];
        message.outputs = ((_b = object.outputs) === null || _b === void 0 ? void 0 : _b.map((e) => bank_1.Output.fromPartial(e))) || [];
        return message;
    },
};
function createBaseMsgMultiSendResponse() {
    return {};
}
exports.MsgMultiSendResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgMultiSendResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgMultiSendResponse();
        return message;
    },
};
class MsgClientImpl {
    constructor(rpc) {
        this.rpc = rpc;
        this.Send = this.Send.bind(this);
        this.MultiSend = this.MultiSend.bind(this);
    }
    Send(request) {
        const data = exports.MsgSend.encode(request).finish();
        const promise = this.rpc.request("cosmos.bank.v1beta1.Msg", "Send", data);
        return promise.then((data) => exports.MsgSendResponse.decode(new minimal_1.default.Reader(data)));
    }
    MultiSend(request) {
        const data = exports.MsgMultiSend.encode(request).finish();
        const promise = this.rpc.request("cosmos.bank.v1beta1.Msg", "MultiSend", data);
        return promise.then((data) => exports.MsgMultiSendResponse.decode(new minimal_1.default.Reader(data)));
    }
}
exports.MsgClientImpl = MsgClientImpl;
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=tx.js.map

/***/ }),

/***/ 17825:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.SearchTxsResult = exports.TxMsgData = exports.MsgData = exports.SimulationResponse = exports.Result = exports.GasInfo = exports.Attribute = exports.StringEvent = exports.ABCIMessageLog = exports.TxResponse = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(__webpack_require__(47873));
const minimal_1 = __importDefault(__webpack_require__(62100));
const any_1 = __webpack_require__(90007);
const types_1 = __webpack_require__(6179);
exports.protobufPackage = "cosmos.base.abci.v1beta1";
function createBaseTxResponse() {
    return {
        height: long_1.default.ZERO,
        txhash: "",
        codespace: "",
        code: 0,
        data: "",
        rawLog: "",
        logs: [],
        info: "",
        gasWanted: long_1.default.ZERO,
        gasUsed: long_1.default.ZERO,
        tx: undefined,
        timestamp: "",
        events: [],
    };
}
exports.TxResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (!message.height.isZero()) {
            writer.uint32(8).int64(message.height);
        }
        if (message.txhash !== "") {
            writer.uint32(18).string(message.txhash);
        }
        if (message.codespace !== "") {
            writer.uint32(26).string(message.codespace);
        }
        if (message.code !== 0) {
            writer.uint32(32).uint32(message.code);
        }
        if (message.data !== "") {
            writer.uint32(42).string(message.data);
        }
        if (message.rawLog !== "") {
            writer.uint32(50).string(message.rawLog);
        }
        for (const v of message.logs) {
            exports.ABCIMessageLog.encode(v, writer.uint32(58).fork()).ldelim();
        }
        if (message.info !== "") {
            writer.uint32(66).string(message.info);
        }
        if (!message.gasWanted.isZero()) {
            writer.uint32(72).int64(message.gasWanted);
        }
        if (!message.gasUsed.isZero()) {
            writer.uint32(80).int64(message.gasUsed);
        }
        if (message.tx !== undefined) {
            any_1.Any.encode(message.tx, writer.uint32(90).fork()).ldelim();
        }
        if (message.timestamp !== "") {
            writer.uint32(98).string(message.timestamp);
        }
        for (const v of message.events) {
            types_1.Event.encode(v, writer.uint32(106).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTxResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.height = reader.int64();
                    break;
                case 2:
                    message.txhash = reader.string();
                    break;
                case 3:
                    message.codespace = reader.string();
                    break;
                case 4:
                    message.code = reader.uint32();
                    break;
                case 5:
                    message.data = reader.string();
                    break;
                case 6:
                    message.rawLog = reader.string();
                    break;
                case 7:
                    message.logs.push(exports.ABCIMessageLog.decode(reader, reader.uint32()));
                    break;
                case 8:
                    message.info = reader.string();
                    break;
                case 9:
                    message.gasWanted = reader.int64();
                    break;
                case 10:
                    message.gasUsed = reader.int64();
                    break;
                case 11:
                    message.tx = any_1.Any.decode(reader, reader.uint32());
                    break;
                case 12:
                    message.timestamp = reader.string();
                    break;
                case 13:
                    message.events.push(types_1.Event.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            height: isSet(object.height) ? long_1.default.fromValue(object.height) : long_1.default.ZERO,
            txhash: isSet(object.txhash) ? String(object.txhash) : "",
            codespace: isSet(object.codespace) ? String(object.codespace) : "",
            code: isSet(object.code) ? Number(object.code) : 0,
            data: isSet(object.data) ? String(object.data) : "",
            rawLog: isSet(object.rawLog) ? String(object.rawLog) : "",
            logs: Array.isArray(object === null || object === void 0 ? void 0 : object.logs) ? object.logs.map((e) => exports.ABCIMessageLog.fromJSON(e)) : [],
            info: isSet(object.info) ? String(object.info) : "",
            gasWanted: isSet(object.gasWanted) ? long_1.default.fromValue(object.gasWanted) : long_1.default.ZERO,
            gasUsed: isSet(object.gasUsed) ? long_1.default.fromValue(object.gasUsed) : long_1.default.ZERO,
            tx: isSet(object.tx) ? any_1.Any.fromJSON(object.tx) : undefined,
            timestamp: isSet(object.timestamp) ? String(object.timestamp) : "",
            events: Array.isArray(object === null || object === void 0 ? void 0 : object.events) ? object.events.map((e) => types_1.Event.fromJSON(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        message.height !== undefined && (obj.height = (message.height || long_1.default.ZERO).toString());
        message.txhash !== undefined && (obj.txhash = message.txhash);
        message.codespace !== undefined && (obj.codespace = message.codespace);
        message.code !== undefined && (obj.code = Math.round(message.code));
        message.data !== undefined && (obj.data = message.data);
        message.rawLog !== undefined && (obj.rawLog = message.rawLog);
        if (message.logs) {
            obj.logs = message.logs.map((e) => (e ? exports.ABCIMessageLog.toJSON(e) : undefined));
        }
        else {
            obj.logs = [];
        }
        message.info !== undefined && (obj.info = message.info);
        message.gasWanted !== undefined && (obj.gasWanted = (message.gasWanted || long_1.default.ZERO).toString());
        message.gasUsed !== undefined && (obj.gasUsed = (message.gasUsed || long_1.default.ZERO).toString());
        message.tx !== undefined && (obj.tx = message.tx ? any_1.Any.toJSON(message.tx) : undefined);
        message.timestamp !== undefined && (obj.timestamp = message.timestamp);
        if (message.events) {
            obj.events = message.events.map((e) => (e ? types_1.Event.toJSON(e) : undefined));
        }
        else {
            obj.events = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        const message = createBaseTxResponse();
        message.height =
            object.height !== undefined && object.height !== null ? long_1.default.fromValue(object.height) : long_1.default.ZERO;
        message.txhash = (_a = object.txhash) !== null && _a !== void 0 ? _a : "";
        message.codespace = (_b = object.codespace) !== null && _b !== void 0 ? _b : "";
        message.code = (_c = object.code) !== null && _c !== void 0 ? _c : 0;
        message.data = (_d = object.data) !== null && _d !== void 0 ? _d : "";
        message.rawLog = (_e = object.rawLog) !== null && _e !== void 0 ? _e : "";
        message.logs = ((_f = object.logs) === null || _f === void 0 ? void 0 : _f.map((e) => exports.ABCIMessageLog.fromPartial(e))) || [];
        message.info = (_g = object.info) !== null && _g !== void 0 ? _g : "";
        message.gasWanted =
            object.gasWanted !== undefined && object.gasWanted !== null
                ? long_1.default.fromValue(object.gasWanted)
                : long_1.default.ZERO;
        message.gasUsed =
            object.gasUsed !== undefined && object.gasUsed !== null ? long_1.default.fromValue(object.gasUsed) : long_1.default.ZERO;
        message.tx = object.tx !== undefined && object.tx !== null ? any_1.Any.fromPartial(object.tx) : undefined;
        message.timestamp = (_h = object.timestamp) !== null && _h !== void 0 ? _h : "";
        message.events = ((_j = object.events) === null || _j === void 0 ? void 0 : _j.map((e) => types_1.Event.fromPartial(e))) || [];
        return message;
    },
};
function createBaseABCIMessageLog() {
    return { msgIndex: 0, log: "", events: [] };
}
exports.ABCIMessageLog = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.msgIndex !== 0) {
            writer.uint32(8).uint32(message.msgIndex);
        }
        if (message.log !== "") {
            writer.uint32(18).string(message.log);
        }
        for (const v of message.events) {
            exports.StringEvent.encode(v, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseABCIMessageLog();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.msgIndex = reader.uint32();
                    break;
                case 2:
                    message.log = reader.string();
                    break;
                case 3:
                    message.events.push(exports.StringEvent.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            msgIndex: isSet(object.msgIndex) ? Number(object.msgIndex) : 0,
            log: isSet(object.log) ? String(object.log) : "",
            events: Array.isArray(object === null || object === void 0 ? void 0 : object.events) ? object.events.map((e) => exports.StringEvent.fromJSON(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        message.msgIndex !== undefined && (obj.msgIndex = Math.round(message.msgIndex));
        message.log !== undefined && (obj.log = message.log);
        if (message.events) {
            obj.events = message.events.map((e) => (e ? exports.StringEvent.toJSON(e) : undefined));
        }
        else {
            obj.events = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseABCIMessageLog();
        message.msgIndex = (_a = object.msgIndex) !== null && _a !== void 0 ? _a : 0;
        message.log = (_b = object.log) !== null && _b !== void 0 ? _b : "";
        message.events = ((_c = object.events) === null || _c === void 0 ? void 0 : _c.map((e) => exports.StringEvent.fromPartial(e))) || [];
        return message;
    },
};
function createBaseStringEvent() {
    return { type: "", attributes: [] };
}
exports.StringEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.type !== "") {
            writer.uint32(10).string(message.type);
        }
        for (const v of message.attributes) {
            exports.Attribute.encode(v, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseStringEvent();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.type = reader.string();
                    break;
                case 2:
                    message.attributes.push(exports.Attribute.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            type: isSet(object.type) ? String(object.type) : "",
            attributes: Array.isArray(object === null || object === void 0 ? void 0 : object.attributes)
                ? object.attributes.map((e) => exports.Attribute.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        message.type !== undefined && (obj.type = message.type);
        if (message.attributes) {
            obj.attributes = message.attributes.map((e) => (e ? exports.Attribute.toJSON(e) : undefined));
        }
        else {
            obj.attributes = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseStringEvent();
        message.type = (_a = object.type) !== null && _a !== void 0 ? _a : "";
        message.attributes = ((_b = object.attributes) === null || _b === void 0 ? void 0 : _b.map((e) => exports.Attribute.fromPartial(e))) || [];
        return message;
    },
};
function createBaseAttribute() {
    return { key: "", value: "" };
}
exports.Attribute = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.key !== "") {
            writer.uint32(10).string(message.key);
        }
        if (message.value !== "") {
            writer.uint32(18).string(message.value);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAttribute();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.key = reader.string();
                    break;
                case 2:
                    message.value = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            key: isSet(object.key) ? String(object.key) : "",
            value: isSet(object.value) ? String(object.value) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.key !== undefined && (obj.key = message.key);
        message.value !== undefined && (obj.value = message.value);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseAttribute();
        message.key = (_a = object.key) !== null && _a !== void 0 ? _a : "";
        message.value = (_b = object.value) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
function createBaseGasInfo() {
    return { gasWanted: long_1.default.UZERO, gasUsed: long_1.default.UZERO };
}
exports.GasInfo = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (!message.gasWanted.isZero()) {
            writer.uint32(8).uint64(message.gasWanted);
        }
        if (!message.gasUsed.isZero()) {
            writer.uint32(16).uint64(message.gasUsed);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGasInfo();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.gasWanted = reader.uint64();
                    break;
                case 2:
                    message.gasUsed = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            gasWanted: isSet(object.gasWanted) ? long_1.default.fromValue(object.gasWanted) : long_1.default.UZERO,
            gasUsed: isSet(object.gasUsed) ? long_1.default.fromValue(object.gasUsed) : long_1.default.UZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        message.gasWanted !== undefined && (obj.gasWanted = (message.gasWanted || long_1.default.UZERO).toString());
        message.gasUsed !== undefined && (obj.gasUsed = (message.gasUsed || long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseGasInfo();
        message.gasWanted =
            object.gasWanted !== undefined && object.gasWanted !== null
                ? long_1.default.fromValue(object.gasWanted)
                : long_1.default.UZERO;
        message.gasUsed =
            object.gasUsed !== undefined && object.gasUsed !== null ? long_1.default.fromValue(object.gasUsed) : long_1.default.UZERO;
        return message;
    },
};
function createBaseResult() {
    return { data: new Uint8Array(), log: "", events: [] };
}
exports.Result = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.data.length !== 0) {
            writer.uint32(10).bytes(message.data);
        }
        if (message.log !== "") {
            writer.uint32(18).string(message.log);
        }
        for (const v of message.events) {
            types_1.Event.encode(v, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseResult();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.data = reader.bytes();
                    break;
                case 2:
                    message.log = reader.string();
                    break;
                case 3:
                    message.events.push(types_1.Event.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            data: isSet(object.data) ? bytesFromBase64(object.data) : new Uint8Array(),
            log: isSet(object.log) ? String(object.log) : "",
            events: Array.isArray(object === null || object === void 0 ? void 0 : object.events) ? object.events.map((e) => types_1.Event.fromJSON(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        message.data !== undefined &&
            (obj.data = base64FromBytes(message.data !== undefined ? message.data : new Uint8Array()));
        message.log !== undefined && (obj.log = message.log);
        if (message.events) {
            obj.events = message.events.map((e) => (e ? types_1.Event.toJSON(e) : undefined));
        }
        else {
            obj.events = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseResult();
        message.data = (_a = object.data) !== null && _a !== void 0 ? _a : new Uint8Array();
        message.log = (_b = object.log) !== null && _b !== void 0 ? _b : "";
        message.events = ((_c = object.events) === null || _c === void 0 ? void 0 : _c.map((e) => types_1.Event.fromPartial(e))) || [];
        return message;
    },
};
function createBaseSimulationResponse() {
    return { gasInfo: undefined, result: undefined };
}
exports.SimulationResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.gasInfo !== undefined) {
            exports.GasInfo.encode(message.gasInfo, writer.uint32(10).fork()).ldelim();
        }
        if (message.result !== undefined) {
            exports.Result.encode(message.result, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSimulationResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.gasInfo = exports.GasInfo.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.result = exports.Result.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            gasInfo: isSet(object.gasInfo) ? exports.GasInfo.fromJSON(object.gasInfo) : undefined,
            result: isSet(object.result) ? exports.Result.fromJSON(object.result) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.gasInfo !== undefined &&
            (obj.gasInfo = message.gasInfo ? exports.GasInfo.toJSON(message.gasInfo) : undefined);
        message.result !== undefined && (obj.result = message.result ? exports.Result.toJSON(message.result) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseSimulationResponse();
        message.gasInfo =
            object.gasInfo !== undefined && object.gasInfo !== null
                ? exports.GasInfo.fromPartial(object.gasInfo)
                : undefined;
        message.result =
            object.result !== undefined && object.result !== null ? exports.Result.fromPartial(object.result) : undefined;
        return message;
    },
};
function createBaseMsgData() {
    return { msgType: "", data: new Uint8Array() };
}
exports.MsgData = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.msgType !== "") {
            writer.uint32(10).string(message.msgType);
        }
        if (message.data.length !== 0) {
            writer.uint32(18).bytes(message.data);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgData();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.msgType = reader.string();
                    break;
                case 2:
                    message.data = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            msgType: isSet(object.msgType) ? String(object.msgType) : "",
            data: isSet(object.data) ? bytesFromBase64(object.data) : new Uint8Array(),
        };
    },
    toJSON(message) {
        const obj = {};
        message.msgType !== undefined && (obj.msgType = message.msgType);
        message.data !== undefined &&
            (obj.data = base64FromBytes(message.data !== undefined ? message.data : new Uint8Array()));
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseMsgData();
        message.msgType = (_a = object.msgType) !== null && _a !== void 0 ? _a : "";
        message.data = (_b = object.data) !== null && _b !== void 0 ? _b : new Uint8Array();
        return message;
    },
};
function createBaseTxMsgData() {
    return { data: [] };
}
exports.TxMsgData = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.data) {
            exports.MsgData.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTxMsgData();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.data.push(exports.MsgData.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { data: Array.isArray(object === null || object === void 0 ? void 0 : object.data) ? object.data.map((e) => exports.MsgData.fromJSON(e)) : [] };
    },
    toJSON(message) {
        const obj = {};
        if (message.data) {
            obj.data = message.data.map((e) => (e ? exports.MsgData.toJSON(e) : undefined));
        }
        else {
            obj.data = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseTxMsgData();
        message.data = ((_a = object.data) === null || _a === void 0 ? void 0 : _a.map((e) => exports.MsgData.fromPartial(e))) || [];
        return message;
    },
};
function createBaseSearchTxsResult() {
    return {
        totalCount: long_1.default.UZERO,
        count: long_1.default.UZERO,
        pageNumber: long_1.default.UZERO,
        pageTotal: long_1.default.UZERO,
        limit: long_1.default.UZERO,
        txs: [],
    };
}
exports.SearchTxsResult = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (!message.totalCount.isZero()) {
            writer.uint32(8).uint64(message.totalCount);
        }
        if (!message.count.isZero()) {
            writer.uint32(16).uint64(message.count);
        }
        if (!message.pageNumber.isZero()) {
            writer.uint32(24).uint64(message.pageNumber);
        }
        if (!message.pageTotal.isZero()) {
            writer.uint32(32).uint64(message.pageTotal);
        }
        if (!message.limit.isZero()) {
            writer.uint32(40).uint64(message.limit);
        }
        for (const v of message.txs) {
            exports.TxResponse.encode(v, writer.uint32(50).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSearchTxsResult();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.totalCount = reader.uint64();
                    break;
                case 2:
                    message.count = reader.uint64();
                    break;
                case 3:
                    message.pageNumber = reader.uint64();
                    break;
                case 4:
                    message.pageTotal = reader.uint64();
                    break;
                case 5:
                    message.limit = reader.uint64();
                    break;
                case 6:
                    message.txs.push(exports.TxResponse.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            totalCount: isSet(object.totalCount) ? long_1.default.fromValue(object.totalCount) : long_1.default.UZERO,
            count: isSet(object.count) ? long_1.default.fromValue(object.count) : long_1.default.UZERO,
            pageNumber: isSet(object.pageNumber) ? long_1.default.fromValue(object.pageNumber) : long_1.default.UZERO,
            pageTotal: isSet(object.pageTotal) ? long_1.default.fromValue(object.pageTotal) : long_1.default.UZERO,
            limit: isSet(object.limit) ? long_1.default.fromValue(object.limit) : long_1.default.UZERO,
            txs: Array.isArray(object === null || object === void 0 ? void 0 : object.txs) ? object.txs.map((e) => exports.TxResponse.fromJSON(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        message.totalCount !== undefined && (obj.totalCount = (message.totalCount || long_1.default.UZERO).toString());
        message.count !== undefined && (obj.count = (message.count || long_1.default.UZERO).toString());
        message.pageNumber !== undefined && (obj.pageNumber = (message.pageNumber || long_1.default.UZERO).toString());
        message.pageTotal !== undefined && (obj.pageTotal = (message.pageTotal || long_1.default.UZERO).toString());
        message.limit !== undefined && (obj.limit = (message.limit || long_1.default.UZERO).toString());
        if (message.txs) {
            obj.txs = message.txs.map((e) => (e ? exports.TxResponse.toJSON(e) : undefined));
        }
        else {
            obj.txs = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseSearchTxsResult();
        message.totalCount =
            object.totalCount !== undefined && object.totalCount !== null
                ? long_1.default.fromValue(object.totalCount)
                : long_1.default.UZERO;
        message.count =
            object.count !== undefined && object.count !== null ? long_1.default.fromValue(object.count) : long_1.default.UZERO;
        message.pageNumber =
            object.pageNumber !== undefined && object.pageNumber !== null
                ? long_1.default.fromValue(object.pageNumber)
                : long_1.default.UZERO;
        message.pageTotal =
            object.pageTotal !== undefined && object.pageTotal !== null
                ? long_1.default.fromValue(object.pageTotal)
                : long_1.default.UZERO;
        message.limit =
            object.limit !== undefined && object.limit !== null ? long_1.default.fromValue(object.limit) : long_1.default.UZERO;
        message.txs = ((_a = object.txs) === null || _a === void 0 ? void 0 : _a.map((e) => exports.TxResponse.fromPartial(e))) || [];
        return message;
    },
};
var globalThis = (() => {
    if (typeof globalThis !== "undefined") {
        return globalThis;
    }
    if (typeof self !== "undefined") {
        return self;
    }
    if (typeof window !== "undefined") {
        return window;
    }
    if (typeof __webpack_require__.g !== "undefined") {
        return __webpack_require__.g;
    }
    throw "Unable to locate global object";
})();
function bytesFromBase64(b64) {
    if (globalThis.Buffer) {
        return Uint8Array.from(globalThis.Buffer.from(b64, "base64"));
    }
    else {
        const bin = globalThis.atob(b64);
        const arr = new Uint8Array(bin.length);
        for (let i = 0; i < bin.length; ++i) {
            arr[i] = bin.charCodeAt(i);
        }
        return arr;
    }
}
function base64FromBytes(arr) {
    if (globalThis.Buffer) {
        return globalThis.Buffer.from(arr).toString("base64");
    }
    else {
        const bin = [];
        arr.forEach((byte) => {
            bin.push(String.fromCharCode(byte));
        });
        return globalThis.btoa(bin.join(""));
    }
}
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=abci.js.map

/***/ }),

/***/ 62635:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PageResponse = exports.PageRequest = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(__webpack_require__(47873));
const minimal_1 = __importDefault(__webpack_require__(62100));
exports.protobufPackage = "cosmos.base.query.v1beta1";
function createBasePageRequest() {
    return { key: new Uint8Array(), offset: long_1.default.UZERO, limit: long_1.default.UZERO, countTotal: false, reverse: false };
}
exports.PageRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.key.length !== 0) {
            writer.uint32(10).bytes(message.key);
        }
        if (!message.offset.isZero()) {
            writer.uint32(16).uint64(message.offset);
        }
        if (!message.limit.isZero()) {
            writer.uint32(24).uint64(message.limit);
        }
        if (message.countTotal === true) {
            writer.uint32(32).bool(message.countTotal);
        }
        if (message.reverse === true) {
            writer.uint32(40).bool(message.reverse);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePageRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.key = reader.bytes();
                    break;
                case 2:
                    message.offset = reader.uint64();
                    break;
                case 3:
                    message.limit = reader.uint64();
                    break;
                case 4:
                    message.countTotal = reader.bool();
                    break;
                case 5:
                    message.reverse = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            key: isSet(object.key) ? bytesFromBase64(object.key) : new Uint8Array(),
            offset: isSet(object.offset) ? long_1.default.fromValue(object.offset) : long_1.default.UZERO,
            limit: isSet(object.limit) ? long_1.default.fromValue(object.limit) : long_1.default.UZERO,
            countTotal: isSet(object.countTotal) ? Boolean(object.countTotal) : false,
            reverse: isSet(object.reverse) ? Boolean(object.reverse) : false,
        };
    },
    toJSON(message) {
        const obj = {};
        message.key !== undefined &&
            (obj.key = base64FromBytes(message.key !== undefined ? message.key : new Uint8Array()));
        message.offset !== undefined && (obj.offset = (message.offset || long_1.default.UZERO).toString());
        message.limit !== undefined && (obj.limit = (message.limit || long_1.default.UZERO).toString());
        message.countTotal !== undefined && (obj.countTotal = message.countTotal);
        message.reverse !== undefined && (obj.reverse = message.reverse);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBasePageRequest();
        message.key = (_a = object.key) !== null && _a !== void 0 ? _a : new Uint8Array();
        message.offset =
            object.offset !== undefined && object.offset !== null ? long_1.default.fromValue(object.offset) : long_1.default.UZERO;
        message.limit =
            object.limit !== undefined && object.limit !== null ? long_1.default.fromValue(object.limit) : long_1.default.UZERO;
        message.countTotal = (_b = object.countTotal) !== null && _b !== void 0 ? _b : false;
        message.reverse = (_c = object.reverse) !== null && _c !== void 0 ? _c : false;
        return message;
    },
};
function createBasePageResponse() {
    return { nextKey: new Uint8Array(), total: long_1.default.UZERO };
}
exports.PageResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.nextKey.length !== 0) {
            writer.uint32(10).bytes(message.nextKey);
        }
        if (!message.total.isZero()) {
            writer.uint32(16).uint64(message.total);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePageResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.nextKey = reader.bytes();
                    break;
                case 2:
                    message.total = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            nextKey: isSet(object.nextKey) ? bytesFromBase64(object.nextKey) : new Uint8Array(),
            total: isSet(object.total) ? long_1.default.fromValue(object.total) : long_1.default.UZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        message.nextKey !== undefined &&
            (obj.nextKey = base64FromBytes(message.nextKey !== undefined ? message.nextKey : new Uint8Array()));
        message.total !== undefined && (obj.total = (message.total || long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBasePageResponse();
        message.nextKey = (_a = object.nextKey) !== null && _a !== void 0 ? _a : new Uint8Array();
        message.total =
            object.total !== undefined && object.total !== null ? long_1.default.fromValue(object.total) : long_1.default.UZERO;
        return message;
    },
};
var globalThis = (() => {
    if (typeof globalThis !== "undefined") {
        return globalThis;
    }
    if (typeof self !== "undefined") {
        return self;
    }
    if (typeof window !== "undefined") {
        return window;
    }
    if (typeof __webpack_require__.g !== "undefined") {
        return __webpack_require__.g;
    }
    throw "Unable to locate global object";
})();
function bytesFromBase64(b64) {
    if (globalThis.Buffer) {
        return Uint8Array.from(globalThis.Buffer.from(b64, "base64"));
    }
    else {
        const bin = globalThis.atob(b64);
        const arr = new Uint8Array(bin.length);
        for (let i = 0; i < bin.length; ++i) {
            arr[i] = bin.charCodeAt(i);
        }
        return arr;
    }
}
function base64FromBytes(arr) {
    if (globalThis.Buffer) {
        return globalThis.Buffer.from(arr).toString("base64");
    }
    else {
        const bin = [];
        arr.forEach((byte) => {
            bin.push(String.fromCharCode(byte));
        });
        return globalThis.btoa(bin.join(""));
    }
}
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=pagination.js.map

/***/ }),

/***/ 26119:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.DecProto = exports.IntProto = exports.DecCoin = exports.Coin = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(__webpack_require__(47873));
const minimal_1 = __importDefault(__webpack_require__(62100));
exports.protobufPackage = "cosmos.base.v1beta1";
function createBaseCoin() {
    return { denom: "", amount: "" };
}
exports.Coin = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.denom !== "") {
            writer.uint32(10).string(message.denom);
        }
        if (message.amount !== "") {
            writer.uint32(18).string(message.amount);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCoin();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.denom = reader.string();
                    break;
                case 2:
                    message.amount = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            denom: isSet(object.denom) ? String(object.denom) : "",
            amount: isSet(object.amount) ? String(object.amount) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.denom !== undefined && (obj.denom = message.denom);
        message.amount !== undefined && (obj.amount = message.amount);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseCoin();
        message.denom = (_a = object.denom) !== null && _a !== void 0 ? _a : "";
        message.amount = (_b = object.amount) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
function createBaseDecCoin() {
    return { denom: "", amount: "" };
}
exports.DecCoin = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.denom !== "") {
            writer.uint32(10).string(message.denom);
        }
        if (message.amount !== "") {
            writer.uint32(18).string(message.amount);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDecCoin();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.denom = reader.string();
                    break;
                case 2:
                    message.amount = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            denom: isSet(object.denom) ? String(object.denom) : "",
            amount: isSet(object.amount) ? String(object.amount) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.denom !== undefined && (obj.denom = message.denom);
        message.amount !== undefined && (obj.amount = message.amount);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseDecCoin();
        message.denom = (_a = object.denom) !== null && _a !== void 0 ? _a : "";
        message.amount = (_b = object.amount) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
function createBaseIntProto() {
    return { int: "" };
}
exports.IntProto = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.int !== "") {
            writer.uint32(10).string(message.int);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseIntProto();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.int = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { int: isSet(object.int) ? String(object.int) : "" };
    },
    toJSON(message) {
        const obj = {};
        message.int !== undefined && (obj.int = message.int);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseIntProto();
        message.int = (_a = object.int) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
function createBaseDecProto() {
    return { dec: "" };
}
exports.DecProto = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.dec !== "") {
            writer.uint32(10).string(message.dec);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDecProto();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.dec = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { dec: isSet(object.dec) ? String(object.dec) : "" };
    },
    toJSON(message) {
        const obj = {};
        message.dec !== undefined && (obj.dec = message.dec);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseDecProto();
        message.dec = (_a = object.dec) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=coin.js.map

/***/ }),

/***/ 2029:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PrivKey = exports.PubKey = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(__webpack_require__(47873));
const minimal_1 = __importDefault(__webpack_require__(62100));
exports.protobufPackage = "cosmos.crypto.ed25519";
function createBasePubKey() {
    return { key: new Uint8Array() };
}
exports.PubKey = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.key.length !== 0) {
            writer.uint32(10).bytes(message.key);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePubKey();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.key = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { key: isSet(object.key) ? bytesFromBase64(object.key) : new Uint8Array() };
    },
    toJSON(message) {
        const obj = {};
        message.key !== undefined &&
            (obj.key = base64FromBytes(message.key !== undefined ? message.key : new Uint8Array()));
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBasePubKey();
        message.key = (_a = object.key) !== null && _a !== void 0 ? _a : new Uint8Array();
        return message;
    },
};
function createBasePrivKey() {
    return { key: new Uint8Array() };
}
exports.PrivKey = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.key.length !== 0) {
            writer.uint32(10).bytes(message.key);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePrivKey();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.key = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { key: isSet(object.key) ? bytesFromBase64(object.key) : new Uint8Array() };
    },
    toJSON(message) {
        const obj = {};
        message.key !== undefined &&
            (obj.key = base64FromBytes(message.key !== undefined ? message.key : new Uint8Array()));
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBasePrivKey();
        message.key = (_a = object.key) !== null && _a !== void 0 ? _a : new Uint8Array();
        return message;
    },
};
var globalThis = (() => {
    if (typeof globalThis !== "undefined") {
        return globalThis;
    }
    if (typeof self !== "undefined") {
        return self;
    }
    if (typeof window !== "undefined") {
        return window;
    }
    if (typeof __webpack_require__.g !== "undefined") {
        return __webpack_require__.g;
    }
    throw "Unable to locate global object";
})();
function bytesFromBase64(b64) {
    if (globalThis.Buffer) {
        return Uint8Array.from(globalThis.Buffer.from(b64, "base64"));
    }
    else {
        const bin = globalThis.atob(b64);
        const arr = new Uint8Array(bin.length);
        for (let i = 0; i < bin.length; ++i) {
            arr[i] = bin.charCodeAt(i);
        }
        return arr;
    }
}
function base64FromBytes(arr) {
    if (globalThis.Buffer) {
        return globalThis.Buffer.from(arr).toString("base64");
    }
    else {
        const bin = [];
        arr.forEach((byte) => {
            bin.push(String.fromCharCode(byte));
        });
        return globalThis.btoa(bin.join(""));
    }
}
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=keys.js.map

/***/ }),

/***/ 68070:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.LegacyAminoPubKey = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(__webpack_require__(47873));
const minimal_1 = __importDefault(__webpack_require__(62100));
const any_1 = __webpack_require__(90007);
exports.protobufPackage = "cosmos.crypto.multisig";
function createBaseLegacyAminoPubKey() {
    return { threshold: 0, publicKeys: [] };
}
exports.LegacyAminoPubKey = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.threshold !== 0) {
            writer.uint32(8).uint32(message.threshold);
        }
        for (const v of message.publicKeys) {
            any_1.Any.encode(v, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseLegacyAminoPubKey();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.threshold = reader.uint32();
                    break;
                case 2:
                    message.publicKeys.push(any_1.Any.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            threshold: isSet(object.threshold) ? Number(object.threshold) : 0,
            publicKeys: Array.isArray(object === null || object === void 0 ? void 0 : object.publicKeys) ? object.publicKeys.map((e) => any_1.Any.fromJSON(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        message.threshold !== undefined && (obj.threshold = Math.round(message.threshold));
        if (message.publicKeys) {
            obj.publicKeys = message.publicKeys.map((e) => (e ? any_1.Any.toJSON(e) : undefined));
        }
        else {
            obj.publicKeys = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseLegacyAminoPubKey();
        message.threshold = (_a = object.threshold) !== null && _a !== void 0 ? _a : 0;
        message.publicKeys = ((_b = object.publicKeys) === null || _b === void 0 ? void 0 : _b.map((e) => any_1.Any.fromPartial(e))) || [];
        return message;
    },
};
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=keys.js.map

/***/ }),

/***/ 76203:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CompactBitArray = exports.MultiSignature = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(__webpack_require__(47873));
const minimal_1 = __importDefault(__webpack_require__(62100));
exports.protobufPackage = "cosmos.crypto.multisig.v1beta1";
function createBaseMultiSignature() {
    return { signatures: [] };
}
exports.MultiSignature = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.signatures) {
            writer.uint32(10).bytes(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMultiSignature();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.signatures.push(reader.bytes());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            signatures: Array.isArray(object === null || object === void 0 ? void 0 : object.signatures)
                ? object.signatures.map((e) => bytesFromBase64(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.signatures) {
            obj.signatures = message.signatures.map((e) => base64FromBytes(e !== undefined ? e : new Uint8Array()));
        }
        else {
            obj.signatures = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseMultiSignature();
        message.signatures = ((_a = object.signatures) === null || _a === void 0 ? void 0 : _a.map((e) => e)) || [];
        return message;
    },
};
function createBaseCompactBitArray() {
    return { extraBitsStored: 0, elems: new Uint8Array() };
}
exports.CompactBitArray = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.extraBitsStored !== 0) {
            writer.uint32(8).uint32(message.extraBitsStored);
        }
        if (message.elems.length !== 0) {
            writer.uint32(18).bytes(message.elems);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCompactBitArray();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.extraBitsStored = reader.uint32();
                    break;
                case 2:
                    message.elems = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            extraBitsStored: isSet(object.extraBitsStored) ? Number(object.extraBitsStored) : 0,
            elems: isSet(object.elems) ? bytesFromBase64(object.elems) : new Uint8Array(),
        };
    },
    toJSON(message) {
        const obj = {};
        message.extraBitsStored !== undefined && (obj.extraBitsStored = Math.round(message.extraBitsStored));
        message.elems !== undefined &&
            (obj.elems = base64FromBytes(message.elems !== undefined ? message.elems : new Uint8Array()));
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseCompactBitArray();
        message.extraBitsStored = (_a = object.extraBitsStored) !== null && _a !== void 0 ? _a : 0;
        message.elems = (_b = object.elems) !== null && _b !== void 0 ? _b : new Uint8Array();
        return message;
    },
};
var globalThis = (() => {
    if (typeof globalThis !== "undefined") {
        return globalThis;
    }
    if (typeof self !== "undefined") {
        return self;
    }
    if (typeof window !== "undefined") {
        return window;
    }
    if (typeof __webpack_require__.g !== "undefined") {
        return __webpack_require__.g;
    }
    throw "Unable to locate global object";
})();
function bytesFromBase64(b64) {
    if (globalThis.Buffer) {
        return Uint8Array.from(globalThis.Buffer.from(b64, "base64"));
    }
    else {
        const bin = globalThis.atob(b64);
        const arr = new Uint8Array(bin.length);
        for (let i = 0; i < bin.length; ++i) {
            arr[i] = bin.charCodeAt(i);
        }
        return arr;
    }
}
function base64FromBytes(arr) {
    if (globalThis.Buffer) {
        return globalThis.Buffer.from(arr).toString("base64");
    }
    else {
        const bin = [];
        arr.forEach((byte) => {
            bin.push(String.fromCharCode(byte));
        });
        return globalThis.btoa(bin.join(""));
    }
}
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=multisig.js.map

/***/ }),

/***/ 61599:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PrivKey = exports.PubKey = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(__webpack_require__(47873));
const minimal_1 = __importDefault(__webpack_require__(62100));
exports.protobufPackage = "cosmos.crypto.secp256k1";
function createBasePubKey() {
    return { key: new Uint8Array() };
}
exports.PubKey = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.key.length !== 0) {
            writer.uint32(10).bytes(message.key);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePubKey();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.key = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { key: isSet(object.key) ? bytesFromBase64(object.key) : new Uint8Array() };
    },
    toJSON(message) {
        const obj = {};
        message.key !== undefined &&
            (obj.key = base64FromBytes(message.key !== undefined ? message.key : new Uint8Array()));
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBasePubKey();
        message.key = (_a = object.key) !== null && _a !== void 0 ? _a : new Uint8Array();
        return message;
    },
};
function createBasePrivKey() {
    return { key: new Uint8Array() };
}
exports.PrivKey = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.key.length !== 0) {
            writer.uint32(10).bytes(message.key);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePrivKey();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.key = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { key: isSet(object.key) ? bytesFromBase64(object.key) : new Uint8Array() };
    },
    toJSON(message) {
        const obj = {};
        message.key !== undefined &&
            (obj.key = base64FromBytes(message.key !== undefined ? message.key : new Uint8Array()));
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBasePrivKey();
        message.key = (_a = object.key) !== null && _a !== void 0 ? _a : new Uint8Array();
        return message;
    },
};
var globalThis = (() => {
    if (typeof globalThis !== "undefined") {
        return globalThis;
    }
    if (typeof self !== "undefined") {
        return self;
    }
    if (typeof window !== "undefined") {
        return window;
    }
    if (typeof __webpack_require__.g !== "undefined") {
        return __webpack_require__.g;
    }
    throw "Unable to locate global object";
})();
function bytesFromBase64(b64) {
    if (globalThis.Buffer) {
        return Uint8Array.from(globalThis.Buffer.from(b64, "base64"));
    }
    else {
        const bin = globalThis.atob(b64);
        const arr = new Uint8Array(bin.length);
        for (let i = 0; i < bin.length; ++i) {
            arr[i] = bin.charCodeAt(i);
        }
        return arr;
    }
}
function base64FromBytes(arr) {
    if (globalThis.Buffer) {
        return globalThis.Buffer.from(arr).toString("base64");
    }
    else {
        const bin = [];
        arr.forEach((byte) => {
            bin.push(String.fromCharCode(byte));
        });
        return globalThis.btoa(bin.join(""));
    }
}
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=keys.js.map

/***/ }),

/***/ 6821:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CommunityPoolSpendProposalWithDeposit = exports.DelegationDelegatorReward = exports.DelegatorStartingInfo = exports.CommunityPoolSpendProposal = exports.FeePool = exports.ValidatorSlashEvents = exports.ValidatorSlashEvent = exports.ValidatorOutstandingRewards = exports.ValidatorAccumulatedCommission = exports.ValidatorCurrentRewards = exports.ValidatorHistoricalRewards = exports.Params = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(__webpack_require__(47873));
const minimal_1 = __importDefault(__webpack_require__(62100));
const coin_1 = __webpack_require__(26119);
exports.protobufPackage = "cosmos.distribution.v1beta1";
function createBaseParams() {
    return { communityTax: "", baseProposerReward: "", bonusProposerReward: "", withdrawAddrEnabled: false };
}
exports.Params = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.communityTax !== "") {
            writer.uint32(10).string(message.communityTax);
        }
        if (message.baseProposerReward !== "") {
            writer.uint32(18).string(message.baseProposerReward);
        }
        if (message.bonusProposerReward !== "") {
            writer.uint32(26).string(message.bonusProposerReward);
        }
        if (message.withdrawAddrEnabled === true) {
            writer.uint32(32).bool(message.withdrawAddrEnabled);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseParams();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.communityTax = reader.string();
                    break;
                case 2:
                    message.baseProposerReward = reader.string();
                    break;
                case 3:
                    message.bonusProposerReward = reader.string();
                    break;
                case 4:
                    message.withdrawAddrEnabled = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            communityTax: isSet(object.communityTax) ? String(object.communityTax) : "",
            baseProposerReward: isSet(object.baseProposerReward) ? String(object.baseProposerReward) : "",
            bonusProposerReward: isSet(object.bonusProposerReward) ? String(object.bonusProposerReward) : "",
            withdrawAddrEnabled: isSet(object.withdrawAddrEnabled) ? Boolean(object.withdrawAddrEnabled) : false,
        };
    },
    toJSON(message) {
        const obj = {};
        message.communityTax !== undefined && (obj.communityTax = message.communityTax);
        message.baseProposerReward !== undefined && (obj.baseProposerReward = message.baseProposerReward);
        message.bonusProposerReward !== undefined && (obj.bonusProposerReward = message.bonusProposerReward);
        message.withdrawAddrEnabled !== undefined && (obj.withdrawAddrEnabled = message.withdrawAddrEnabled);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d;
        const message = createBaseParams();
        message.communityTax = (_a = object.communityTax) !== null && _a !== void 0 ? _a : "";
        message.baseProposerReward = (_b = object.baseProposerReward) !== null && _b !== void 0 ? _b : "";
        message.bonusProposerReward = (_c = object.bonusProposerReward) !== null && _c !== void 0 ? _c : "";
        message.withdrawAddrEnabled = (_d = object.withdrawAddrEnabled) !== null && _d !== void 0 ? _d : false;
        return message;
    },
};
function createBaseValidatorHistoricalRewards() {
    return { cumulativeRewardRatio: [], referenceCount: 0 };
}
exports.ValidatorHistoricalRewards = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.cumulativeRewardRatio) {
            coin_1.DecCoin.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.referenceCount !== 0) {
            writer.uint32(16).uint32(message.referenceCount);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseValidatorHistoricalRewards();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.cumulativeRewardRatio.push(coin_1.DecCoin.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.referenceCount = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            cumulativeRewardRatio: Array.isArray(object === null || object === void 0 ? void 0 : object.cumulativeRewardRatio)
                ? object.cumulativeRewardRatio.map((e) => coin_1.DecCoin.fromJSON(e))
                : [],
            referenceCount: isSet(object.referenceCount) ? Number(object.referenceCount) : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.cumulativeRewardRatio) {
            obj.cumulativeRewardRatio = message.cumulativeRewardRatio.map((e) => e ? coin_1.DecCoin.toJSON(e) : undefined);
        }
        else {
            obj.cumulativeRewardRatio = [];
        }
        message.referenceCount !== undefined && (obj.referenceCount = Math.round(message.referenceCount));
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseValidatorHistoricalRewards();
        message.cumulativeRewardRatio = ((_a = object.cumulativeRewardRatio) === null || _a === void 0 ? void 0 : _a.map((e) => coin_1.DecCoin.fromPartial(e))) || [];
        message.referenceCount = (_b = object.referenceCount) !== null && _b !== void 0 ? _b : 0;
        return message;
    },
};
function createBaseValidatorCurrentRewards() {
    return { rewards: [], period: long_1.default.UZERO };
}
exports.ValidatorCurrentRewards = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.rewards) {
            coin_1.DecCoin.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (!message.period.isZero()) {
            writer.uint32(16).uint64(message.period);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseValidatorCurrentRewards();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.rewards.push(coin_1.DecCoin.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.period = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            rewards: Array.isArray(object === null || object === void 0 ? void 0 : object.rewards) ? object.rewards.map((e) => coin_1.DecCoin.fromJSON(e)) : [],
            period: isSet(object.period) ? long_1.default.fromValue(object.period) : long_1.default.UZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.rewards) {
            obj.rewards = message.rewards.map((e) => (e ? coin_1.DecCoin.toJSON(e) : undefined));
        }
        else {
            obj.rewards = [];
        }
        message.period !== undefined && (obj.period = (message.period || long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseValidatorCurrentRewards();
        message.rewards = ((_a = object.rewards) === null || _a === void 0 ? void 0 : _a.map((e) => coin_1.DecCoin.fromPartial(e))) || [];
        message.period =
            object.period !== undefined && object.period !== null ? long_1.default.fromValue(object.period) : long_1.default.UZERO;
        return message;
    },
};
function createBaseValidatorAccumulatedCommission() {
    return { commission: [] };
}
exports.ValidatorAccumulatedCommission = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.commission) {
            coin_1.DecCoin.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseValidatorAccumulatedCommission();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.commission.push(coin_1.DecCoin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            commission: Array.isArray(object === null || object === void 0 ? void 0 : object.commission)
                ? object.commission.map((e) => coin_1.DecCoin.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.commission) {
            obj.commission = message.commission.map((e) => (e ? coin_1.DecCoin.toJSON(e) : undefined));
        }
        else {
            obj.commission = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseValidatorAccumulatedCommission();
        message.commission = ((_a = object.commission) === null || _a === void 0 ? void 0 : _a.map((e) => coin_1.DecCoin.fromPartial(e))) || [];
        return message;
    },
};
function createBaseValidatorOutstandingRewards() {
    return { rewards: [] };
}
exports.ValidatorOutstandingRewards = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.rewards) {
            coin_1.DecCoin.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseValidatorOutstandingRewards();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.rewards.push(coin_1.DecCoin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            rewards: Array.isArray(object === null || object === void 0 ? void 0 : object.rewards) ? object.rewards.map((e) => coin_1.DecCoin.fromJSON(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.rewards) {
            obj.rewards = message.rewards.map((e) => (e ? coin_1.DecCoin.toJSON(e) : undefined));
        }
        else {
            obj.rewards = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseValidatorOutstandingRewards();
        message.rewards = ((_a = object.rewards) === null || _a === void 0 ? void 0 : _a.map((e) => coin_1.DecCoin.fromPartial(e))) || [];
        return message;
    },
};
function createBaseValidatorSlashEvent() {
    return { validatorPeriod: long_1.default.UZERO, fraction: "" };
}
exports.ValidatorSlashEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (!message.validatorPeriod.isZero()) {
            writer.uint32(8).uint64(message.validatorPeriod);
        }
        if (message.fraction !== "") {
            writer.uint32(18).string(message.fraction);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseValidatorSlashEvent();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.validatorPeriod = reader.uint64();
                    break;
                case 2:
                    message.fraction = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            validatorPeriod: isSet(object.validatorPeriod) ? long_1.default.fromValue(object.validatorPeriod) : long_1.default.UZERO,
            fraction: isSet(object.fraction) ? String(object.fraction) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.validatorPeriod !== undefined &&
            (obj.validatorPeriod = (message.validatorPeriod || long_1.default.UZERO).toString());
        message.fraction !== undefined && (obj.fraction = message.fraction);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseValidatorSlashEvent();
        message.validatorPeriod =
            object.validatorPeriod !== undefined && object.validatorPeriod !== null
                ? long_1.default.fromValue(object.validatorPeriod)
                : long_1.default.UZERO;
        message.fraction = (_a = object.fraction) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
function createBaseValidatorSlashEvents() {
    return { validatorSlashEvents: [] };
}
exports.ValidatorSlashEvents = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.validatorSlashEvents) {
            exports.ValidatorSlashEvent.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseValidatorSlashEvents();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.validatorSlashEvents.push(exports.ValidatorSlashEvent.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            validatorSlashEvents: Array.isArray(object === null || object === void 0 ? void 0 : object.validatorSlashEvents)
                ? object.validatorSlashEvents.map((e) => exports.ValidatorSlashEvent.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.validatorSlashEvents) {
            obj.validatorSlashEvents = message.validatorSlashEvents.map((e) => e ? exports.ValidatorSlashEvent.toJSON(e) : undefined);
        }
        else {
            obj.validatorSlashEvents = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseValidatorSlashEvents();
        message.validatorSlashEvents =
            ((_a = object.validatorSlashEvents) === null || _a === void 0 ? void 0 : _a.map((e) => exports.ValidatorSlashEvent.fromPartial(e))) || [];
        return message;
    },
};
function createBaseFeePool() {
    return { communityPool: [] };
}
exports.FeePool = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.communityPool) {
            coin_1.DecCoin.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseFeePool();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.communityPool.push(coin_1.DecCoin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            communityPool: Array.isArray(object === null || object === void 0 ? void 0 : object.communityPool)
                ? object.communityPool.map((e) => coin_1.DecCoin.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.communityPool) {
            obj.communityPool = message.communityPool.map((e) => (e ? coin_1.DecCoin.toJSON(e) : undefined));
        }
        else {
            obj.communityPool = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseFeePool();
        message.communityPool = ((_a = object.communityPool) === null || _a === void 0 ? void 0 : _a.map((e) => coin_1.DecCoin.fromPartial(e))) || [];
        return message;
    },
};
function createBaseCommunityPoolSpendProposal() {
    return { title: "", description: "", recipient: "", amount: [] };
}
exports.CommunityPoolSpendProposal = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.title !== "") {
            writer.uint32(10).string(message.title);
        }
        if (message.description !== "") {
            writer.uint32(18).string(message.description);
        }
        if (message.recipient !== "") {
            writer.uint32(26).string(message.recipient);
        }
        for (const v of message.amount) {
            coin_1.Coin.encode(v, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCommunityPoolSpendProposal();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.title = reader.string();
                    break;
                case 2:
                    message.description = reader.string();
                    break;
                case 3:
                    message.recipient = reader.string();
                    break;
                case 4:
                    message.amount.push(coin_1.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            title: isSet(object.title) ? String(object.title) : "",
            description: isSet(object.description) ? String(object.description) : "",
            recipient: isSet(object.recipient) ? String(object.recipient) : "",
            amount: Array.isArray(object === null || object === void 0 ? void 0 : object.amount) ? object.amount.map((e) => coin_1.Coin.fromJSON(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        message.title !== undefined && (obj.title = message.title);
        message.description !== undefined && (obj.description = message.description);
        message.recipient !== undefined && (obj.recipient = message.recipient);
        if (message.amount) {
            obj.amount = message.amount.map((e) => (e ? coin_1.Coin.toJSON(e) : undefined));
        }
        else {
            obj.amount = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d;
        const message = createBaseCommunityPoolSpendProposal();
        message.title = (_a = object.title) !== null && _a !== void 0 ? _a : "";
        message.description = (_b = object.description) !== null && _b !== void 0 ? _b : "";
        message.recipient = (_c = object.recipient) !== null && _c !== void 0 ? _c : "";
        message.amount = ((_d = object.amount) === null || _d === void 0 ? void 0 : _d.map((e) => coin_1.Coin.fromPartial(e))) || [];
        return message;
    },
};
function createBaseDelegatorStartingInfo() {
    return { previousPeriod: long_1.default.UZERO, stake: "", height: long_1.default.UZERO };
}
exports.DelegatorStartingInfo = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (!message.previousPeriod.isZero()) {
            writer.uint32(8).uint64(message.previousPeriod);
        }
        if (message.stake !== "") {
            writer.uint32(18).string(message.stake);
        }
        if (!message.height.isZero()) {
            writer.uint32(24).uint64(message.height);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDelegatorStartingInfo();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.previousPeriod = reader.uint64();
                    break;
                case 2:
                    message.stake = reader.string();
                    break;
                case 3:
                    message.height = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            previousPeriod: isSet(object.previousPeriod) ? long_1.default.fromValue(object.previousPeriod) : long_1.default.UZERO,
            stake: isSet(object.stake) ? String(object.stake) : "",
            height: isSet(object.height) ? long_1.default.fromValue(object.height) : long_1.default.UZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        message.previousPeriod !== undefined &&
            (obj.previousPeriod = (message.previousPeriod || long_1.default.UZERO).toString());
        message.stake !== undefined && (obj.stake = message.stake);
        message.height !== undefined && (obj.height = (message.height || long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseDelegatorStartingInfo();
        message.previousPeriod =
            object.previousPeriod !== undefined && object.previousPeriod !== null
                ? long_1.default.fromValue(object.previousPeriod)
                : long_1.default.UZERO;
        message.stake = (_a = object.stake) !== null && _a !== void 0 ? _a : "";
        message.height =
            object.height !== undefined && object.height !== null ? long_1.default.fromValue(object.height) : long_1.default.UZERO;
        return message;
    },
};
function createBaseDelegationDelegatorReward() {
    return { validatorAddress: "", reward: [] };
}
exports.DelegationDelegatorReward = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.validatorAddress !== "") {
            writer.uint32(10).string(message.validatorAddress);
        }
        for (const v of message.reward) {
            coin_1.DecCoin.encode(v, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDelegationDelegatorReward();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.validatorAddress = reader.string();
                    break;
                case 2:
                    message.reward.push(coin_1.DecCoin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            validatorAddress: isSet(object.validatorAddress) ? String(object.validatorAddress) : "",
            reward: Array.isArray(object === null || object === void 0 ? void 0 : object.reward) ? object.reward.map((e) => coin_1.DecCoin.fromJSON(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        if (message.reward) {
            obj.reward = message.reward.map((e) => (e ? coin_1.DecCoin.toJSON(e) : undefined));
        }
        else {
            obj.reward = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseDelegationDelegatorReward();
        message.validatorAddress = (_a = object.validatorAddress) !== null && _a !== void 0 ? _a : "";
        message.reward = ((_b = object.reward) === null || _b === void 0 ? void 0 : _b.map((e) => coin_1.DecCoin.fromPartial(e))) || [];
        return message;
    },
};
function createBaseCommunityPoolSpendProposalWithDeposit() {
    return { title: "", description: "", recipient: "", amount: "", deposit: "" };
}
exports.CommunityPoolSpendProposalWithDeposit = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.title !== "") {
            writer.uint32(10).string(message.title);
        }
        if (message.description !== "") {
            writer.uint32(18).string(message.description);
        }
        if (message.recipient !== "") {
            writer.uint32(26).string(message.recipient);
        }
        if (message.amount !== "") {
            writer.uint32(34).string(message.amount);
        }
        if (message.deposit !== "") {
            writer.uint32(42).string(message.deposit);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCommunityPoolSpendProposalWithDeposit();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.title = reader.string();
                    break;
                case 2:
                    message.description = reader.string();
                    break;
                case 3:
                    message.recipient = reader.string();
                    break;
                case 4:
                    message.amount = reader.string();
                    break;
                case 5:
                    message.deposit = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            title: isSet(object.title) ? String(object.title) : "",
            description: isSet(object.description) ? String(object.description) : "",
            recipient: isSet(object.recipient) ? String(object.recipient) : "",
            amount: isSet(object.amount) ? String(object.amount) : "",
            deposit: isSet(object.deposit) ? String(object.deposit) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.title !== undefined && (obj.title = message.title);
        message.description !== undefined && (obj.description = message.description);
        message.recipient !== undefined && (obj.recipient = message.recipient);
        message.amount !== undefined && (obj.amount = message.amount);
        message.deposit !== undefined && (obj.deposit = message.deposit);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e;
        const message = createBaseCommunityPoolSpendProposalWithDeposit();
        message.title = (_a = object.title) !== null && _a !== void 0 ? _a : "";
        message.description = (_b = object.description) !== null && _b !== void 0 ? _b : "";
        message.recipient = (_c = object.recipient) !== null && _c !== void 0 ? _c : "";
        message.amount = (_d = object.amount) !== null && _d !== void 0 ? _d : "";
        message.deposit = (_e = object.deposit) !== null && _e !== void 0 ? _e : "";
        return message;
    },
};
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=distribution.js.map

/***/ }),

/***/ 62904:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.QueryClientImpl = exports.QueryCommunityPoolResponse = exports.QueryCommunityPoolRequest = exports.QueryDelegatorWithdrawAddressResponse = exports.QueryDelegatorWithdrawAddressRequest = exports.QueryDelegatorValidatorsResponse = exports.QueryDelegatorValidatorsRequest = exports.QueryDelegationTotalRewardsResponse = exports.QueryDelegationTotalRewardsRequest = exports.QueryDelegationRewardsResponse = exports.QueryDelegationRewardsRequest = exports.QueryValidatorSlashesResponse = exports.QueryValidatorSlashesRequest = exports.QueryValidatorCommissionResponse = exports.QueryValidatorCommissionRequest = exports.QueryValidatorOutstandingRewardsResponse = exports.QueryValidatorOutstandingRewardsRequest = exports.QueryParamsResponse = exports.QueryParamsRequest = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(__webpack_require__(47873));
const minimal_1 = __importDefault(__webpack_require__(62100));
const pagination_1 = __webpack_require__(62635);
const coin_1 = __webpack_require__(26119);
const distribution_1 = __webpack_require__(6821);
exports.protobufPackage = "cosmos.distribution.v1beta1";
function createBaseQueryParamsRequest() {
    return {};
}
exports.QueryParamsRequest = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryParamsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseQueryParamsRequest();
        return message;
    },
};
function createBaseQueryParamsResponse() {
    return { params: undefined };
}
exports.QueryParamsResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.params !== undefined) {
            distribution_1.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryParamsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.params = distribution_1.Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { params: isSet(object.params) ? distribution_1.Params.fromJSON(object.params) : undefined };
    },
    toJSON(message) {
        const obj = {};
        message.params !== undefined && (obj.params = message.params ? distribution_1.Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryParamsResponse();
        message.params =
            object.params !== undefined && object.params !== null ? distribution_1.Params.fromPartial(object.params) : undefined;
        return message;
    },
};
function createBaseQueryValidatorOutstandingRewardsRequest() {
    return { validatorAddress: "" };
}
exports.QueryValidatorOutstandingRewardsRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.validatorAddress !== "") {
            writer.uint32(10).string(message.validatorAddress);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryValidatorOutstandingRewardsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.validatorAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { validatorAddress: isSet(object.validatorAddress) ? String(object.validatorAddress) : "" };
    },
    toJSON(message) {
        const obj = {};
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryValidatorOutstandingRewardsRequest();
        message.validatorAddress = (_a = object.validatorAddress) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
function createBaseQueryValidatorOutstandingRewardsResponse() {
    return { rewards: undefined };
}
exports.QueryValidatorOutstandingRewardsResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.rewards !== undefined) {
            distribution_1.ValidatorOutstandingRewards.encode(message.rewards, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryValidatorOutstandingRewardsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.rewards = distribution_1.ValidatorOutstandingRewards.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            rewards: isSet(object.rewards) ? distribution_1.ValidatorOutstandingRewards.fromJSON(object.rewards) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.rewards !== undefined &&
            (obj.rewards = message.rewards ? distribution_1.ValidatorOutstandingRewards.toJSON(message.rewards) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryValidatorOutstandingRewardsResponse();
        message.rewards =
            object.rewards !== undefined && object.rewards !== null
                ? distribution_1.ValidatorOutstandingRewards.fromPartial(object.rewards)
                : undefined;
        return message;
    },
};
function createBaseQueryValidatorCommissionRequest() {
    return { validatorAddress: "" };
}
exports.QueryValidatorCommissionRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.validatorAddress !== "") {
            writer.uint32(10).string(message.validatorAddress);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryValidatorCommissionRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.validatorAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { validatorAddress: isSet(object.validatorAddress) ? String(object.validatorAddress) : "" };
    },
    toJSON(message) {
        const obj = {};
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryValidatorCommissionRequest();
        message.validatorAddress = (_a = object.validatorAddress) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
function createBaseQueryValidatorCommissionResponse() {
    return { commission: undefined };
}
exports.QueryValidatorCommissionResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.commission !== undefined) {
            distribution_1.ValidatorAccumulatedCommission.encode(message.commission, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryValidatorCommissionResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.commission = distribution_1.ValidatorAccumulatedCommission.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            commission: isSet(object.commission)
                ? distribution_1.ValidatorAccumulatedCommission.fromJSON(object.commission)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.commission !== undefined &&
            (obj.commission = message.commission
                ? distribution_1.ValidatorAccumulatedCommission.toJSON(message.commission)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryValidatorCommissionResponse();
        message.commission =
            object.commission !== undefined && object.commission !== null
                ? distribution_1.ValidatorAccumulatedCommission.fromPartial(object.commission)
                : undefined;
        return message;
    },
};
function createBaseQueryValidatorSlashesRequest() {
    return {
        validatorAddress: "",
        startingHeight: long_1.default.UZERO,
        endingHeight: long_1.default.UZERO,
        pagination: undefined,
    };
}
exports.QueryValidatorSlashesRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.validatorAddress !== "") {
            writer.uint32(10).string(message.validatorAddress);
        }
        if (!message.startingHeight.isZero()) {
            writer.uint32(16).uint64(message.startingHeight);
        }
        if (!message.endingHeight.isZero()) {
            writer.uint32(24).uint64(message.endingHeight);
        }
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryValidatorSlashesRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.validatorAddress = reader.string();
                    break;
                case 2:
                    message.startingHeight = reader.uint64();
                    break;
                case 3:
                    message.endingHeight = reader.uint64();
                    break;
                case 4:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            validatorAddress: isSet(object.validatorAddress) ? String(object.validatorAddress) : "",
            startingHeight: isSet(object.startingHeight) ? long_1.default.fromValue(object.startingHeight) : long_1.default.UZERO,
            endingHeight: isSet(object.endingHeight) ? long_1.default.fromValue(object.endingHeight) : long_1.default.UZERO,
            pagination: isSet(object.pagination) ? pagination_1.PageRequest.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        message.startingHeight !== undefined &&
            (obj.startingHeight = (message.startingHeight || long_1.default.UZERO).toString());
        message.endingHeight !== undefined &&
            (obj.endingHeight = (message.endingHeight || long_1.default.UZERO).toString());
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryValidatorSlashesRequest();
        message.validatorAddress = (_a = object.validatorAddress) !== null && _a !== void 0 ? _a : "";
        message.startingHeight =
            object.startingHeight !== undefined && object.startingHeight !== null
                ? long_1.default.fromValue(object.startingHeight)
                : long_1.default.UZERO;
        message.endingHeight =
            object.endingHeight !== undefined && object.endingHeight !== null
                ? long_1.default.fromValue(object.endingHeight)
                : long_1.default.UZERO;
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryValidatorSlashesResponse() {
    return { slashes: [], pagination: undefined };
}
exports.QueryValidatorSlashesResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.slashes) {
            distribution_1.ValidatorSlashEvent.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryValidatorSlashesResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.slashes.push(distribution_1.ValidatorSlashEvent.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            slashes: Array.isArray(object === null || object === void 0 ? void 0 : object.slashes)
                ? object.slashes.map((e) => distribution_1.ValidatorSlashEvent.fromJSON(e))
                : [],
            pagination: isSet(object.pagination) ? pagination_1.PageResponse.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.slashes) {
            obj.slashes = message.slashes.map((e) => (e ? distribution_1.ValidatorSlashEvent.toJSON(e) : undefined));
        }
        else {
            obj.slashes = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryValidatorSlashesResponse();
        message.slashes = ((_a = object.slashes) === null || _a === void 0 ? void 0 : _a.map((e) => distribution_1.ValidatorSlashEvent.fromPartial(e))) || [];
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryDelegationRewardsRequest() {
    return { delegatorAddress: "", validatorAddress: "" };
}
exports.QueryDelegationRewardsRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.delegatorAddress !== "") {
            writer.uint32(10).string(message.delegatorAddress);
        }
        if (message.validatorAddress !== "") {
            writer.uint32(18).string(message.validatorAddress);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryDelegationRewardsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            delegatorAddress: isSet(object.delegatorAddress) ? String(object.delegatorAddress) : "",
            validatorAddress: isSet(object.validatorAddress) ? String(object.validatorAddress) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseQueryDelegationRewardsRequest();
        message.delegatorAddress = (_a = object.delegatorAddress) !== null && _a !== void 0 ? _a : "";
        message.validatorAddress = (_b = object.validatorAddress) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
function createBaseQueryDelegationRewardsResponse() {
    return { rewards: [] };
}
exports.QueryDelegationRewardsResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.rewards) {
            coin_1.DecCoin.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryDelegationRewardsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.rewards.push(coin_1.DecCoin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            rewards: Array.isArray(object === null || object === void 0 ? void 0 : object.rewards) ? object.rewards.map((e) => coin_1.DecCoin.fromJSON(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.rewards) {
            obj.rewards = message.rewards.map((e) => (e ? coin_1.DecCoin.toJSON(e) : undefined));
        }
        else {
            obj.rewards = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryDelegationRewardsResponse();
        message.rewards = ((_a = object.rewards) === null || _a === void 0 ? void 0 : _a.map((e) => coin_1.DecCoin.fromPartial(e))) || [];
        return message;
    },
};
function createBaseQueryDelegationTotalRewardsRequest() {
    return { delegatorAddress: "" };
}
exports.QueryDelegationTotalRewardsRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.delegatorAddress !== "") {
            writer.uint32(10).string(message.delegatorAddress);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryDelegationTotalRewardsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { delegatorAddress: isSet(object.delegatorAddress) ? String(object.delegatorAddress) : "" };
    },
    toJSON(message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryDelegationTotalRewardsRequest();
        message.delegatorAddress = (_a = object.delegatorAddress) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
function createBaseQueryDelegationTotalRewardsResponse() {
    return { rewards: [], total: [] };
}
exports.QueryDelegationTotalRewardsResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.rewards) {
            distribution_1.DelegationDelegatorReward.encode(v, writer.uint32(10).fork()).ldelim();
        }
        for (const v of message.total) {
            coin_1.DecCoin.encode(v, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryDelegationTotalRewardsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.rewards.push(distribution_1.DelegationDelegatorReward.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.total.push(coin_1.DecCoin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            rewards: Array.isArray(object === null || object === void 0 ? void 0 : object.rewards)
                ? object.rewards.map((e) => distribution_1.DelegationDelegatorReward.fromJSON(e))
                : [],
            total: Array.isArray(object === null || object === void 0 ? void 0 : object.total) ? object.total.map((e) => coin_1.DecCoin.fromJSON(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.rewards) {
            obj.rewards = message.rewards.map((e) => (e ? distribution_1.DelegationDelegatorReward.toJSON(e) : undefined));
        }
        else {
            obj.rewards = [];
        }
        if (message.total) {
            obj.total = message.total.map((e) => (e ? coin_1.DecCoin.toJSON(e) : undefined));
        }
        else {
            obj.total = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseQueryDelegationTotalRewardsResponse();
        message.rewards = ((_a = object.rewards) === null || _a === void 0 ? void 0 : _a.map((e) => distribution_1.DelegationDelegatorReward.fromPartial(e))) || [];
        message.total = ((_b = object.total) === null || _b === void 0 ? void 0 : _b.map((e) => coin_1.DecCoin.fromPartial(e))) || [];
        return message;
    },
};
function createBaseQueryDelegatorValidatorsRequest() {
    return { delegatorAddress: "" };
}
exports.QueryDelegatorValidatorsRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.delegatorAddress !== "") {
            writer.uint32(10).string(message.delegatorAddress);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryDelegatorValidatorsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { delegatorAddress: isSet(object.delegatorAddress) ? String(object.delegatorAddress) : "" };
    },
    toJSON(message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryDelegatorValidatorsRequest();
        message.delegatorAddress = (_a = object.delegatorAddress) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
function createBaseQueryDelegatorValidatorsResponse() {
    return { validators: [] };
}
exports.QueryDelegatorValidatorsResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.validators) {
            writer.uint32(10).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryDelegatorValidatorsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.validators.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            validators: Array.isArray(object === null || object === void 0 ? void 0 : object.validators) ? object.validators.map((e) => String(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.validators) {
            obj.validators = message.validators.map((e) => e);
        }
        else {
            obj.validators = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryDelegatorValidatorsResponse();
        message.validators = ((_a = object.validators) === null || _a === void 0 ? void 0 : _a.map((e) => e)) || [];
        return message;
    },
};
function createBaseQueryDelegatorWithdrawAddressRequest() {
    return { delegatorAddress: "" };
}
exports.QueryDelegatorWithdrawAddressRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.delegatorAddress !== "") {
            writer.uint32(10).string(message.delegatorAddress);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryDelegatorWithdrawAddressRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { delegatorAddress: isSet(object.delegatorAddress) ? String(object.delegatorAddress) : "" };
    },
    toJSON(message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryDelegatorWithdrawAddressRequest();
        message.delegatorAddress = (_a = object.delegatorAddress) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
function createBaseQueryDelegatorWithdrawAddressResponse() {
    return { withdrawAddress: "" };
}
exports.QueryDelegatorWithdrawAddressResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.withdrawAddress !== "") {
            writer.uint32(10).string(message.withdrawAddress);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryDelegatorWithdrawAddressResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.withdrawAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { withdrawAddress: isSet(object.withdrawAddress) ? String(object.withdrawAddress) : "" };
    },
    toJSON(message) {
        const obj = {};
        message.withdrawAddress !== undefined && (obj.withdrawAddress = message.withdrawAddress);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryDelegatorWithdrawAddressResponse();
        message.withdrawAddress = (_a = object.withdrawAddress) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
function createBaseQueryCommunityPoolRequest() {
    return {};
}
exports.QueryCommunityPoolRequest = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryCommunityPoolRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseQueryCommunityPoolRequest();
        return message;
    },
};
function createBaseQueryCommunityPoolResponse() {
    return { pool: [] };
}
exports.QueryCommunityPoolResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.pool) {
            coin_1.DecCoin.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryCommunityPoolResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.pool.push(coin_1.DecCoin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { pool: Array.isArray(object === null || object === void 0 ? void 0 : object.pool) ? object.pool.map((e) => coin_1.DecCoin.fromJSON(e)) : [] };
    },
    toJSON(message) {
        const obj = {};
        if (message.pool) {
            obj.pool = message.pool.map((e) => (e ? coin_1.DecCoin.toJSON(e) : undefined));
        }
        else {
            obj.pool = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryCommunityPoolResponse();
        message.pool = ((_a = object.pool) === null || _a === void 0 ? void 0 : _a.map((e) => coin_1.DecCoin.fromPartial(e))) || [];
        return message;
    },
};
class QueryClientImpl {
    constructor(rpc) {
        this.rpc = rpc;
        this.Params = this.Params.bind(this);
        this.ValidatorOutstandingRewards = this.ValidatorOutstandingRewards.bind(this);
        this.ValidatorCommission = this.ValidatorCommission.bind(this);
        this.ValidatorSlashes = this.ValidatorSlashes.bind(this);
        this.DelegationRewards = this.DelegationRewards.bind(this);
        this.DelegationTotalRewards = this.DelegationTotalRewards.bind(this);
        this.DelegatorValidators = this.DelegatorValidators.bind(this);
        this.DelegatorWithdrawAddress = this.DelegatorWithdrawAddress.bind(this);
        this.CommunityPool = this.CommunityPool.bind(this);
    }
    Params(request) {
        const data = exports.QueryParamsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.distribution.v1beta1.Query", "Params", data);
        return promise.then((data) => exports.QueryParamsResponse.decode(new minimal_1.default.Reader(data)));
    }
    ValidatorOutstandingRewards(request) {
        const data = exports.QueryValidatorOutstandingRewardsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.distribution.v1beta1.Query", "ValidatorOutstandingRewards", data);
        return promise.then((data) => exports.QueryValidatorOutstandingRewardsResponse.decode(new minimal_1.default.Reader(data)));
    }
    ValidatorCommission(request) {
        const data = exports.QueryValidatorCommissionRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.distribution.v1beta1.Query", "ValidatorCommission", data);
        return promise.then((data) => exports.QueryValidatorCommissionResponse.decode(new minimal_1.default.Reader(data)));
    }
    ValidatorSlashes(request) {
        const data = exports.QueryValidatorSlashesRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.distribution.v1beta1.Query", "ValidatorSlashes", data);
        return promise.then((data) => exports.QueryValidatorSlashesResponse.decode(new minimal_1.default.Reader(data)));
    }
    DelegationRewards(request) {
        const data = exports.QueryDelegationRewardsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.distribution.v1beta1.Query", "DelegationRewards", data);
        return promise.then((data) => exports.QueryDelegationRewardsResponse.decode(new minimal_1.default.Reader(data)));
    }
    DelegationTotalRewards(request) {
        const data = exports.QueryDelegationTotalRewardsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.distribution.v1beta1.Query", "DelegationTotalRewards", data);
        return promise.then((data) => exports.QueryDelegationTotalRewardsResponse.decode(new minimal_1.default.Reader(data)));
    }
    DelegatorValidators(request) {
        const data = exports.QueryDelegatorValidatorsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.distribution.v1beta1.Query", "DelegatorValidators", data);
        return promise.then((data) => exports.QueryDelegatorValidatorsResponse.decode(new minimal_1.default.Reader(data)));
    }
    DelegatorWithdrawAddress(request) {
        const data = exports.QueryDelegatorWithdrawAddressRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.distribution.v1beta1.Query", "DelegatorWithdrawAddress", data);
        return promise.then((data) => exports.QueryDelegatorWithdrawAddressResponse.decode(new minimal_1.default.Reader(data)));
    }
    CommunityPool(request) {
        const data = exports.QueryCommunityPoolRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.distribution.v1beta1.Query", "CommunityPool", data);
        return promise.then((data) => exports.QueryCommunityPoolResponse.decode(new minimal_1.default.Reader(data)));
    }
}
exports.QueryClientImpl = QueryClientImpl;
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=query.js.map

/***/ }),

/***/ 42632:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MsgClientImpl = exports.MsgFundCommunityPoolResponse = exports.MsgFundCommunityPool = exports.MsgWithdrawValidatorCommissionResponse = exports.MsgWithdrawValidatorCommission = exports.MsgWithdrawDelegatorRewardResponse = exports.MsgWithdrawDelegatorReward = exports.MsgSetWithdrawAddressResponse = exports.MsgSetWithdrawAddress = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(__webpack_require__(47873));
const minimal_1 = __importDefault(__webpack_require__(62100));
const coin_1 = __webpack_require__(26119);
exports.protobufPackage = "cosmos.distribution.v1beta1";
function createBaseMsgSetWithdrawAddress() {
    return { delegatorAddress: "", withdrawAddress: "" };
}
exports.MsgSetWithdrawAddress = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.delegatorAddress !== "") {
            writer.uint32(10).string(message.delegatorAddress);
        }
        if (message.withdrawAddress !== "") {
            writer.uint32(18).string(message.withdrawAddress);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgSetWithdrawAddress();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.withdrawAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            delegatorAddress: isSet(object.delegatorAddress) ? String(object.delegatorAddress) : "",
            withdrawAddress: isSet(object.withdrawAddress) ? String(object.withdrawAddress) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.withdrawAddress !== undefined && (obj.withdrawAddress = message.withdrawAddress);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseMsgSetWithdrawAddress();
        message.delegatorAddress = (_a = object.delegatorAddress) !== null && _a !== void 0 ? _a : "";
        message.withdrawAddress = (_b = object.withdrawAddress) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
function createBaseMsgSetWithdrawAddressResponse() {
    return {};
}
exports.MsgSetWithdrawAddressResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgSetWithdrawAddressResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgSetWithdrawAddressResponse();
        return message;
    },
};
function createBaseMsgWithdrawDelegatorReward() {
    return { delegatorAddress: "", validatorAddress: "" };
}
exports.MsgWithdrawDelegatorReward = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.delegatorAddress !== "") {
            writer.uint32(10).string(message.delegatorAddress);
        }
        if (message.validatorAddress !== "") {
            writer.uint32(18).string(message.validatorAddress);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgWithdrawDelegatorReward();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            delegatorAddress: isSet(object.delegatorAddress) ? String(object.delegatorAddress) : "",
            validatorAddress: isSet(object.validatorAddress) ? String(object.validatorAddress) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseMsgWithdrawDelegatorReward();
        message.delegatorAddress = (_a = object.delegatorAddress) !== null && _a !== void 0 ? _a : "";
        message.validatorAddress = (_b = object.validatorAddress) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
function createBaseMsgWithdrawDelegatorRewardResponse() {
    return {};
}
exports.MsgWithdrawDelegatorRewardResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgWithdrawDelegatorRewardResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgWithdrawDelegatorRewardResponse();
        return message;
    },
};
function createBaseMsgWithdrawValidatorCommission() {
    return { validatorAddress: "" };
}
exports.MsgWithdrawValidatorCommission = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.validatorAddress !== "") {
            writer.uint32(10).string(message.validatorAddress);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgWithdrawValidatorCommission();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.validatorAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { validatorAddress: isSet(object.validatorAddress) ? String(object.validatorAddress) : "" };
    },
    toJSON(message) {
        const obj = {};
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseMsgWithdrawValidatorCommission();
        message.validatorAddress = (_a = object.validatorAddress) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
function createBaseMsgWithdrawValidatorCommissionResponse() {
    return {};
}
exports.MsgWithdrawValidatorCommissionResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgWithdrawValidatorCommissionResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgWithdrawValidatorCommissionResponse();
        return message;
    },
};
function createBaseMsgFundCommunityPool() {
    return { amount: [], depositor: "" };
}
exports.MsgFundCommunityPool = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.amount) {
            coin_1.Coin.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.depositor !== "") {
            writer.uint32(18).string(message.depositor);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgFundCommunityPool();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.amount.push(coin_1.Coin.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.depositor = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            amount: Array.isArray(object === null || object === void 0 ? void 0 : object.amount) ? object.amount.map((e) => coin_1.Coin.fromJSON(e)) : [],
            depositor: isSet(object.depositor) ? String(object.depositor) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.amount) {
            obj.amount = message.amount.map((e) => (e ? coin_1.Coin.toJSON(e) : undefined));
        }
        else {
            obj.amount = [];
        }
        message.depositor !== undefined && (obj.depositor = message.depositor);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseMsgFundCommunityPool();
        message.amount = ((_a = object.amount) === null || _a === void 0 ? void 0 : _a.map((e) => coin_1.Coin.fromPartial(e))) || [];
        message.depositor = (_b = object.depositor) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
function createBaseMsgFundCommunityPoolResponse() {
    return {};
}
exports.MsgFundCommunityPoolResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgFundCommunityPoolResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgFundCommunityPoolResponse();
        return message;
    },
};
class MsgClientImpl {
    constructor(rpc) {
        this.rpc = rpc;
        this.SetWithdrawAddress = this.SetWithdrawAddress.bind(this);
        this.WithdrawDelegatorReward = this.WithdrawDelegatorReward.bind(this);
        this.WithdrawValidatorCommission = this.WithdrawValidatorCommission.bind(this);
        this.FundCommunityPool = this.FundCommunityPool.bind(this);
    }
    SetWithdrawAddress(request) {
        const data = exports.MsgSetWithdrawAddress.encode(request).finish();
        const promise = this.rpc.request("cosmos.distribution.v1beta1.Msg", "SetWithdrawAddress", data);
        return promise.then((data) => exports.MsgSetWithdrawAddressResponse.decode(new minimal_1.default.Reader(data)));
    }
    WithdrawDelegatorReward(request) {
        const data = exports.MsgWithdrawDelegatorReward.encode(request).finish();
        const promise = this.rpc.request("cosmos.distribution.v1beta1.Msg", "WithdrawDelegatorReward", data);
        return promise.then((data) => exports.MsgWithdrawDelegatorRewardResponse.decode(new minimal_1.default.Reader(data)));
    }
    WithdrawValidatorCommission(request) {
        const data = exports.MsgWithdrawValidatorCommission.encode(request).finish();
        const promise = this.rpc.request("cosmos.distribution.v1beta1.Msg", "WithdrawValidatorCommission", data);
        return promise.then((data) => exports.MsgWithdrawValidatorCommissionResponse.decode(new minimal_1.default.Reader(data)));
    }
    FundCommunityPool(request) {
        const data = exports.MsgFundCommunityPool.encode(request).finish();
        const promise = this.rpc.request("cosmos.distribution.v1beta1.Msg", "FundCommunityPool", data);
        return promise.then((data) => exports.MsgFundCommunityPoolResponse.decode(new minimal_1.default.Reader(data)));
    }
}
exports.MsgClientImpl = MsgClientImpl;
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=tx.js.map

/***/ }),

/***/ 82482:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Grant = exports.AllowedMsgAllowance = exports.PeriodicAllowance = exports.BasicAllowance = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(__webpack_require__(47873));
const minimal_1 = __importDefault(__webpack_require__(62100));
const any_1 = __webpack_require__(90007);
const duration_1 = __webpack_require__(59769);
const timestamp_1 = __webpack_require__(76620);
const coin_1 = __webpack_require__(26119);
exports.protobufPackage = "cosmos.feegrant.v1beta1";
function createBaseBasicAllowance() {
    return { spendLimit: [], expiration: undefined };
}
exports.BasicAllowance = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.spendLimit) {
            coin_1.Coin.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.expiration !== undefined) {
            timestamp_1.Timestamp.encode(message.expiration, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseBasicAllowance();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.spendLimit.push(coin_1.Coin.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.expiration = timestamp_1.Timestamp.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            spendLimit: Array.isArray(object === null || object === void 0 ? void 0 : object.spendLimit)
                ? object.spendLimit.map((e) => coin_1.Coin.fromJSON(e))
                : [],
            expiration: isSet(object.expiration) ? fromJsonTimestamp(object.expiration) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.spendLimit) {
            obj.spendLimit = message.spendLimit.map((e) => (e ? coin_1.Coin.toJSON(e) : undefined));
        }
        else {
            obj.spendLimit = [];
        }
        message.expiration !== undefined && (obj.expiration = fromTimestamp(message.expiration).toISOString());
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseBasicAllowance();
        message.spendLimit = ((_a = object.spendLimit) === null || _a === void 0 ? void 0 : _a.map((e) => coin_1.Coin.fromPartial(e))) || [];
        message.expiration =
            object.expiration !== undefined && object.expiration !== null
                ? timestamp_1.Timestamp.fromPartial(object.expiration)
                : undefined;
        return message;
    },
};
function createBasePeriodicAllowance() {
    return {
        basic: undefined,
        period: undefined,
        periodSpendLimit: [],
        periodCanSpend: [],
        periodReset: undefined,
    };
}
exports.PeriodicAllowance = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.basic !== undefined) {
            exports.BasicAllowance.encode(message.basic, writer.uint32(10).fork()).ldelim();
        }
        if (message.period !== undefined) {
            duration_1.Duration.encode(message.period, writer.uint32(18).fork()).ldelim();
        }
        for (const v of message.periodSpendLimit) {
            coin_1.Coin.encode(v, writer.uint32(26).fork()).ldelim();
        }
        for (const v of message.periodCanSpend) {
            coin_1.Coin.encode(v, writer.uint32(34).fork()).ldelim();
        }
        if (message.periodReset !== undefined) {
            timestamp_1.Timestamp.encode(message.periodReset, writer.uint32(42).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePeriodicAllowance();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.basic = exports.BasicAllowance.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.period = duration_1.Duration.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.periodSpendLimit.push(coin_1.Coin.decode(reader, reader.uint32()));
                    break;
                case 4:
                    message.periodCanSpend.push(coin_1.Coin.decode(reader, reader.uint32()));
                    break;
                case 5:
                    message.periodReset = timestamp_1.Timestamp.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            basic: isSet(object.basic) ? exports.BasicAllowance.fromJSON(object.basic) : undefined,
            period: isSet(object.period) ? duration_1.Duration.fromJSON(object.period) : undefined,
            periodSpendLimit: Array.isArray(object === null || object === void 0 ? void 0 : object.periodSpendLimit)
                ? object.periodSpendLimit.map((e) => coin_1.Coin.fromJSON(e))
                : [],
            periodCanSpend: Array.isArray(object === null || object === void 0 ? void 0 : object.periodCanSpend)
                ? object.periodCanSpend.map((e) => coin_1.Coin.fromJSON(e))
                : [],
            periodReset: isSet(object.periodReset) ? fromJsonTimestamp(object.periodReset) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.basic !== undefined &&
            (obj.basic = message.basic ? exports.BasicAllowance.toJSON(message.basic) : undefined);
        message.period !== undefined &&
            (obj.period = message.period ? duration_1.Duration.toJSON(message.period) : undefined);
        if (message.periodSpendLimit) {
            obj.periodSpendLimit = message.periodSpendLimit.map((e) => (e ? coin_1.Coin.toJSON(e) : undefined));
        }
        else {
            obj.periodSpendLimit = [];
        }
        if (message.periodCanSpend) {
            obj.periodCanSpend = message.periodCanSpend.map((e) => (e ? coin_1.Coin.toJSON(e) : undefined));
        }
        else {
            obj.periodCanSpend = [];
        }
        message.periodReset !== undefined && (obj.periodReset = fromTimestamp(message.periodReset).toISOString());
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBasePeriodicAllowance();
        message.basic =
            object.basic !== undefined && object.basic !== null
                ? exports.BasicAllowance.fromPartial(object.basic)
                : undefined;
        message.period =
            object.period !== undefined && object.period !== null ? duration_1.Duration.fromPartial(object.period) : undefined;
        message.periodSpendLimit = ((_a = object.periodSpendLimit) === null || _a === void 0 ? void 0 : _a.map((e) => coin_1.Coin.fromPartial(e))) || [];
        message.periodCanSpend = ((_b = object.periodCanSpend) === null || _b === void 0 ? void 0 : _b.map((e) => coin_1.Coin.fromPartial(e))) || [];
        message.periodReset =
            object.periodReset !== undefined && object.periodReset !== null
                ? timestamp_1.Timestamp.fromPartial(object.periodReset)
                : undefined;
        return message;
    },
};
function createBaseAllowedMsgAllowance() {
    return { allowance: undefined, allowedMessages: [] };
}
exports.AllowedMsgAllowance = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.allowance !== undefined) {
            any_1.Any.encode(message.allowance, writer.uint32(10).fork()).ldelim();
        }
        for (const v of message.allowedMessages) {
            writer.uint32(18).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAllowedMsgAllowance();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.allowance = any_1.Any.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.allowedMessages.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            allowance: isSet(object.allowance) ? any_1.Any.fromJSON(object.allowance) : undefined,
            allowedMessages: Array.isArray(object === null || object === void 0 ? void 0 : object.allowedMessages)
                ? object.allowedMessages.map((e) => String(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        message.allowance !== undefined &&
            (obj.allowance = message.allowance ? any_1.Any.toJSON(message.allowance) : undefined);
        if (message.allowedMessages) {
            obj.allowedMessages = message.allowedMessages.map((e) => e);
        }
        else {
            obj.allowedMessages = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseAllowedMsgAllowance();
        message.allowance =
            object.allowance !== undefined && object.allowance !== null
                ? any_1.Any.fromPartial(object.allowance)
                : undefined;
        message.allowedMessages = ((_a = object.allowedMessages) === null || _a === void 0 ? void 0 : _a.map((e) => e)) || [];
        return message;
    },
};
function createBaseGrant() {
    return { granter: "", grantee: "", allowance: undefined };
}
exports.Grant = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.granter !== "") {
            writer.uint32(10).string(message.granter);
        }
        if (message.grantee !== "") {
            writer.uint32(18).string(message.grantee);
        }
        if (message.allowance !== undefined) {
            any_1.Any.encode(message.allowance, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGrant();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.granter = reader.string();
                    break;
                case 2:
                    message.grantee = reader.string();
                    break;
                case 3:
                    message.allowance = any_1.Any.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            granter: isSet(object.granter) ? String(object.granter) : "",
            grantee: isSet(object.grantee) ? String(object.grantee) : "",
            allowance: isSet(object.allowance) ? any_1.Any.fromJSON(object.allowance) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.granter !== undefined && (obj.granter = message.granter);
        message.grantee !== undefined && (obj.grantee = message.grantee);
        message.allowance !== undefined &&
            (obj.allowance = message.allowance ? any_1.Any.toJSON(message.allowance) : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseGrant();
        message.granter = (_a = object.granter) !== null && _a !== void 0 ? _a : "";
        message.grantee = (_b = object.grantee) !== null && _b !== void 0 ? _b : "";
        message.allowance =
            object.allowance !== undefined && object.allowance !== null
                ? any_1.Any.fromPartial(object.allowance)
                : undefined;
        return message;
    },
};
function toTimestamp(date) {
    const seconds = numberToLong(date.getTime() / 1000);
    const nanos = (date.getTime() % 1000) * 1000000;
    return { seconds, nanos };
}
function fromTimestamp(t) {
    let millis = t.seconds.toNumber() * 1000;
    millis += t.nanos / 1000000;
    return new Date(millis);
}
function fromJsonTimestamp(o) {
    if (o instanceof Date) {
        return toTimestamp(o);
    }
    else if (typeof o === "string") {
        return toTimestamp(new Date(o));
    }
    else {
        return timestamp_1.Timestamp.fromJSON(o);
    }
}
function numberToLong(number) {
    return long_1.default.fromNumber(number);
}
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=feegrant.js.map

/***/ }),

/***/ 57519:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.QueryClientImpl = exports.QueryAllowancesByGranterResponse = exports.QueryAllowancesByGranterRequest = exports.QueryAllowancesResponse = exports.QueryAllowancesRequest = exports.QueryAllowanceResponse = exports.QueryAllowanceRequest = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(__webpack_require__(47873));
const minimal_1 = __importDefault(__webpack_require__(62100));
const pagination_1 = __webpack_require__(62635);
const feegrant_1 = __webpack_require__(82482);
exports.protobufPackage = "cosmos.feegrant.v1beta1";
function createBaseQueryAllowanceRequest() {
    return { granter: "", grantee: "" };
}
exports.QueryAllowanceRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.granter !== "") {
            writer.uint32(10).string(message.granter);
        }
        if (message.grantee !== "") {
            writer.uint32(18).string(message.grantee);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryAllowanceRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.granter = reader.string();
                    break;
                case 2:
                    message.grantee = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            granter: isSet(object.granter) ? String(object.granter) : "",
            grantee: isSet(object.grantee) ? String(object.grantee) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.granter !== undefined && (obj.granter = message.granter);
        message.grantee !== undefined && (obj.grantee = message.grantee);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseQueryAllowanceRequest();
        message.granter = (_a = object.granter) !== null && _a !== void 0 ? _a : "";
        message.grantee = (_b = object.grantee) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
function createBaseQueryAllowanceResponse() {
    return { allowance: undefined };
}
exports.QueryAllowanceResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.allowance !== undefined) {
            feegrant_1.Grant.encode(message.allowance, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryAllowanceResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.allowance = feegrant_1.Grant.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { allowance: isSet(object.allowance) ? feegrant_1.Grant.fromJSON(object.allowance) : undefined };
    },
    toJSON(message) {
        const obj = {};
        message.allowance !== undefined &&
            (obj.allowance = message.allowance ? feegrant_1.Grant.toJSON(message.allowance) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryAllowanceResponse();
        message.allowance =
            object.allowance !== undefined && object.allowance !== null
                ? feegrant_1.Grant.fromPartial(object.allowance)
                : undefined;
        return message;
    },
};
function createBaseQueryAllowancesRequest() {
    return { grantee: "", pagination: undefined };
}
exports.QueryAllowancesRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.grantee !== "") {
            writer.uint32(10).string(message.grantee);
        }
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryAllowancesRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.grantee = reader.string();
                    break;
                case 2:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            grantee: isSet(object.grantee) ? String(object.grantee) : "",
            pagination: isSet(object.pagination) ? pagination_1.PageRequest.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.grantee !== undefined && (obj.grantee = message.grantee);
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryAllowancesRequest();
        message.grantee = (_a = object.grantee) !== null && _a !== void 0 ? _a : "";
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryAllowancesResponse() {
    return { allowances: [], pagination: undefined };
}
exports.QueryAllowancesResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.allowances) {
            feegrant_1.Grant.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryAllowancesResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.allowances.push(feegrant_1.Grant.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            allowances: Array.isArray(object === null || object === void 0 ? void 0 : object.allowances)
                ? object.allowances.map((e) => feegrant_1.Grant.fromJSON(e))
                : [],
            pagination: isSet(object.pagination) ? pagination_1.PageResponse.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.allowances) {
            obj.allowances = message.allowances.map((e) => (e ? feegrant_1.Grant.toJSON(e) : undefined));
        }
        else {
            obj.allowances = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryAllowancesResponse();
        message.allowances = ((_a = object.allowances) === null || _a === void 0 ? void 0 : _a.map((e) => feegrant_1.Grant.fromPartial(e))) || [];
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryAllowancesByGranterRequest() {
    return { granter: "", pagination: undefined };
}
exports.QueryAllowancesByGranterRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.granter !== "") {
            writer.uint32(10).string(message.granter);
        }
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryAllowancesByGranterRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.granter = reader.string();
                    break;
                case 2:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            granter: isSet(object.granter) ? String(object.granter) : "",
            pagination: isSet(object.pagination) ? pagination_1.PageRequest.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.granter !== undefined && (obj.granter = message.granter);
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryAllowancesByGranterRequest();
        message.granter = (_a = object.granter) !== null && _a !== void 0 ? _a : "";
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryAllowancesByGranterResponse() {
    return { allowances: [], pagination: undefined };
}
exports.QueryAllowancesByGranterResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.allowances) {
            feegrant_1.Grant.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryAllowancesByGranterResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.allowances.push(feegrant_1.Grant.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            allowances: Array.isArray(object === null || object === void 0 ? void 0 : object.allowances)
                ? object.allowances.map((e) => feegrant_1.Grant.fromJSON(e))
                : [],
            pagination: isSet(object.pagination) ? pagination_1.PageResponse.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.allowances) {
            obj.allowances = message.allowances.map((e) => (e ? feegrant_1.Grant.toJSON(e) : undefined));
        }
        else {
            obj.allowances = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryAllowancesByGranterResponse();
        message.allowances = ((_a = object.allowances) === null || _a === void 0 ? void 0 : _a.map((e) => feegrant_1.Grant.fromPartial(e))) || [];
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
class QueryClientImpl {
    constructor(rpc) {
        this.rpc = rpc;
        this.Allowance = this.Allowance.bind(this);
        this.Allowances = this.Allowances.bind(this);
        this.AllowancesByGranter = this.AllowancesByGranter.bind(this);
    }
    Allowance(request) {
        const data = exports.QueryAllowanceRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.feegrant.v1beta1.Query", "Allowance", data);
        return promise.then((data) => exports.QueryAllowanceResponse.decode(new minimal_1.default.Reader(data)));
    }
    Allowances(request) {
        const data = exports.QueryAllowancesRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.feegrant.v1beta1.Query", "Allowances", data);
        return promise.then((data) => exports.QueryAllowancesResponse.decode(new minimal_1.default.Reader(data)));
    }
    AllowancesByGranter(request) {
        const data = exports.QueryAllowancesByGranterRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.feegrant.v1beta1.Query", "AllowancesByGranter", data);
        return promise.then((data) => exports.QueryAllowancesByGranterResponse.decode(new minimal_1.default.Reader(data)));
    }
}
exports.QueryClientImpl = QueryClientImpl;
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=query.js.map

/***/ }),

/***/ 38196:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MsgClientImpl = exports.MsgRevokeAllowanceResponse = exports.MsgRevokeAllowance = exports.MsgGrantAllowanceResponse = exports.MsgGrantAllowance = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(__webpack_require__(47873));
const minimal_1 = __importDefault(__webpack_require__(62100));
const any_1 = __webpack_require__(90007);
exports.protobufPackage = "cosmos.feegrant.v1beta1";
function createBaseMsgGrantAllowance() {
    return { granter: "", grantee: "", allowance: undefined };
}
exports.MsgGrantAllowance = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.granter !== "") {
            writer.uint32(10).string(message.granter);
        }
        if (message.grantee !== "") {
            writer.uint32(18).string(message.grantee);
        }
        if (message.allowance !== undefined) {
            any_1.Any.encode(message.allowance, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgGrantAllowance();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.granter = reader.string();
                    break;
                case 2:
                    message.grantee = reader.string();
                    break;
                case 3:
                    message.allowance = any_1.Any.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            granter: isSet(object.granter) ? String(object.granter) : "",
            grantee: isSet(object.grantee) ? String(object.grantee) : "",
            allowance: isSet(object.allowance) ? any_1.Any.fromJSON(object.allowance) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.granter !== undefined && (obj.granter = message.granter);
        message.grantee !== undefined && (obj.grantee = message.grantee);
        message.allowance !== undefined &&
            (obj.allowance = message.allowance ? any_1.Any.toJSON(message.allowance) : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseMsgGrantAllowance();
        message.granter = (_a = object.granter) !== null && _a !== void 0 ? _a : "";
        message.grantee = (_b = object.grantee) !== null && _b !== void 0 ? _b : "";
        message.allowance =
            object.allowance !== undefined && object.allowance !== null
                ? any_1.Any.fromPartial(object.allowance)
                : undefined;
        return message;
    },
};
function createBaseMsgGrantAllowanceResponse() {
    return {};
}
exports.MsgGrantAllowanceResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgGrantAllowanceResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgGrantAllowanceResponse();
        return message;
    },
};
function createBaseMsgRevokeAllowance() {
    return { granter: "", grantee: "" };
}
exports.MsgRevokeAllowance = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.granter !== "") {
            writer.uint32(10).string(message.granter);
        }
        if (message.grantee !== "") {
            writer.uint32(18).string(message.grantee);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgRevokeAllowance();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.granter = reader.string();
                    break;
                case 2:
                    message.grantee = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            granter: isSet(object.granter) ? String(object.granter) : "",
            grantee: isSet(object.grantee) ? String(object.grantee) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.granter !== undefined && (obj.granter = message.granter);
        message.grantee !== undefined && (obj.grantee = message.grantee);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseMsgRevokeAllowance();
        message.granter = (_a = object.granter) !== null && _a !== void 0 ? _a : "";
        message.grantee = (_b = object.grantee) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
function createBaseMsgRevokeAllowanceResponse() {
    return {};
}
exports.MsgRevokeAllowanceResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgRevokeAllowanceResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgRevokeAllowanceResponse();
        return message;
    },
};
class MsgClientImpl {
    constructor(rpc) {
        this.rpc = rpc;
        this.GrantAllowance = this.GrantAllowance.bind(this);
        this.RevokeAllowance = this.RevokeAllowance.bind(this);
    }
    GrantAllowance(request) {
        const data = exports.MsgGrantAllowance.encode(request).finish();
        const promise = this.rpc.request("cosmos.feegrant.v1beta1.Msg", "GrantAllowance", data);
        return promise.then((data) => exports.MsgGrantAllowanceResponse.decode(new minimal_1.default.Reader(data)));
    }
    RevokeAllowance(request) {
        const data = exports.MsgRevokeAllowance.encode(request).finish();
        const promise = this.rpc.request("cosmos.feegrant.v1beta1.Msg", "RevokeAllowance", data);
        return promise.then((data) => exports.MsgRevokeAllowanceResponse.decode(new minimal_1.default.Reader(data)));
    }
}
exports.MsgClientImpl = MsgClientImpl;
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=tx.js.map

/***/ }),

/***/ 72980:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.TallyParams = exports.VotingParams = exports.DepositParams = exports.Vote = exports.TallyResult = exports.Proposal = exports.Deposit = exports.TextProposal = exports.WeightedVoteOption = exports.proposalStatusToJSON = exports.proposalStatusFromJSON = exports.ProposalStatus = exports.voteOptionToJSON = exports.voteOptionFromJSON = exports.VoteOption = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(__webpack_require__(47873));
const minimal_1 = __importDefault(__webpack_require__(62100));
const any_1 = __webpack_require__(90007);
const duration_1 = __webpack_require__(59769);
const timestamp_1 = __webpack_require__(76620);
const coin_1 = __webpack_require__(26119);
exports.protobufPackage = "cosmos.gov.v1beta1";
/** VoteOption enumerates the valid vote options for a given governance proposal. */
var VoteOption;
(function (VoteOption) {
    /** VOTE_OPTION_UNSPECIFIED - VOTE_OPTION_UNSPECIFIED defines a no-op vote option. */
    VoteOption[VoteOption["VOTE_OPTION_UNSPECIFIED"] = 0] = "VOTE_OPTION_UNSPECIFIED";
    /** VOTE_OPTION_YES - VOTE_OPTION_YES defines a yes vote option. */
    VoteOption[VoteOption["VOTE_OPTION_YES"] = 1] = "VOTE_OPTION_YES";
    /** VOTE_OPTION_ABSTAIN - VOTE_OPTION_ABSTAIN defines an abstain vote option. */
    VoteOption[VoteOption["VOTE_OPTION_ABSTAIN"] = 2] = "VOTE_OPTION_ABSTAIN";
    /** VOTE_OPTION_NO - VOTE_OPTION_NO defines a no vote option. */
    VoteOption[VoteOption["VOTE_OPTION_NO"] = 3] = "VOTE_OPTION_NO";
    /** VOTE_OPTION_NO_WITH_VETO - VOTE_OPTION_NO_WITH_VETO defines a no with veto vote option. */
    VoteOption[VoteOption["VOTE_OPTION_NO_WITH_VETO"] = 4] = "VOTE_OPTION_NO_WITH_VETO";
    VoteOption[VoteOption["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(VoteOption = exports.VoteOption || (exports.VoteOption = {}));
function voteOptionFromJSON(object) {
    switch (object) {
        case 0:
        case "VOTE_OPTION_UNSPECIFIED":
            return VoteOption.VOTE_OPTION_UNSPECIFIED;
        case 1:
        case "VOTE_OPTION_YES":
            return VoteOption.VOTE_OPTION_YES;
        case 2:
        case "VOTE_OPTION_ABSTAIN":
            return VoteOption.VOTE_OPTION_ABSTAIN;
        case 3:
        case "VOTE_OPTION_NO":
            return VoteOption.VOTE_OPTION_NO;
        case 4:
        case "VOTE_OPTION_NO_WITH_VETO":
            return VoteOption.VOTE_OPTION_NO_WITH_VETO;
        case -1:
        case "UNRECOGNIZED":
        default:
            return VoteOption.UNRECOGNIZED;
    }
}
exports.voteOptionFromJSON = voteOptionFromJSON;
function voteOptionToJSON(object) {
    switch (object) {
        case VoteOption.VOTE_OPTION_UNSPECIFIED:
            return "VOTE_OPTION_UNSPECIFIED";
        case VoteOption.VOTE_OPTION_YES:
            return "VOTE_OPTION_YES";
        case VoteOption.VOTE_OPTION_ABSTAIN:
            return "VOTE_OPTION_ABSTAIN";
        case VoteOption.VOTE_OPTION_NO:
            return "VOTE_OPTION_NO";
        case VoteOption.VOTE_OPTION_NO_WITH_VETO:
            return "VOTE_OPTION_NO_WITH_VETO";
        case VoteOption.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.voteOptionToJSON = voteOptionToJSON;
/** ProposalStatus enumerates the valid statuses of a proposal. */
var ProposalStatus;
(function (ProposalStatus) {
    /** PROPOSAL_STATUS_UNSPECIFIED - PROPOSAL_STATUS_UNSPECIFIED defines the default propopsal status. */
    ProposalStatus[ProposalStatus["PROPOSAL_STATUS_UNSPECIFIED"] = 0] = "PROPOSAL_STATUS_UNSPECIFIED";
    /**
     * PROPOSAL_STATUS_DEPOSIT_PERIOD - PROPOSAL_STATUS_DEPOSIT_PERIOD defines a proposal status during the deposit
     * period.
     */
    ProposalStatus[ProposalStatus["PROPOSAL_STATUS_DEPOSIT_PERIOD"] = 1] = "PROPOSAL_STATUS_DEPOSIT_PERIOD";
    /**
     * PROPOSAL_STATUS_VOTING_PERIOD - PROPOSAL_STATUS_VOTING_PERIOD defines a proposal status during the voting
     * period.
     */
    ProposalStatus[ProposalStatus["PROPOSAL_STATUS_VOTING_PERIOD"] = 2] = "PROPOSAL_STATUS_VOTING_PERIOD";
    /**
     * PROPOSAL_STATUS_PASSED - PROPOSAL_STATUS_PASSED defines a proposal status of a proposal that has
     * passed.
     */
    ProposalStatus[ProposalStatus["PROPOSAL_STATUS_PASSED"] = 3] = "PROPOSAL_STATUS_PASSED";
    /**
     * PROPOSAL_STATUS_REJECTED - PROPOSAL_STATUS_REJECTED defines a proposal status of a proposal that has
     * been rejected.
     */
    ProposalStatus[ProposalStatus["PROPOSAL_STATUS_REJECTED"] = 4] = "PROPOSAL_STATUS_REJECTED";
    /**
     * PROPOSAL_STATUS_FAILED - PROPOSAL_STATUS_FAILED defines a proposal status of a proposal that has
     * failed.
     */
    ProposalStatus[ProposalStatus["PROPOSAL_STATUS_FAILED"] = 5] = "PROPOSAL_STATUS_FAILED";
    ProposalStatus[ProposalStatus["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(ProposalStatus = exports.ProposalStatus || (exports.ProposalStatus = {}));
function proposalStatusFromJSON(object) {
    switch (object) {
        case 0:
        case "PROPOSAL_STATUS_UNSPECIFIED":
            return ProposalStatus.PROPOSAL_STATUS_UNSPECIFIED;
        case 1:
        case "PROPOSAL_STATUS_DEPOSIT_PERIOD":
            return ProposalStatus.PROPOSAL_STATUS_DEPOSIT_PERIOD;
        case 2:
        case "PROPOSAL_STATUS_VOTING_PERIOD":
            return ProposalStatus.PROPOSAL_STATUS_VOTING_PERIOD;
        case 3:
        case "PROPOSAL_STATUS_PASSED":
            return ProposalStatus.PROPOSAL_STATUS_PASSED;
        case 4:
        case "PROPOSAL_STATUS_REJECTED":
            return ProposalStatus.PROPOSAL_STATUS_REJECTED;
        case 5:
        case "PROPOSAL_STATUS_FAILED":
            return ProposalStatus.PROPOSAL_STATUS_FAILED;
        case -1:
        case "UNRECOGNIZED":
        default:
            return ProposalStatus.UNRECOGNIZED;
    }
}
exports.proposalStatusFromJSON = proposalStatusFromJSON;
function proposalStatusToJSON(object) {
    switch (object) {
        case ProposalStatus.PROPOSAL_STATUS_UNSPECIFIED:
            return "PROPOSAL_STATUS_UNSPECIFIED";
        case ProposalStatus.PROPOSAL_STATUS_DEPOSIT_PERIOD:
            return "PROPOSAL_STATUS_DEPOSIT_PERIOD";
        case ProposalStatus.PROPOSAL_STATUS_VOTING_PERIOD:
            return "PROPOSAL_STATUS_VOTING_PERIOD";
        case ProposalStatus.PROPOSAL_STATUS_PASSED:
            return "PROPOSAL_STATUS_PASSED";
        case ProposalStatus.PROPOSAL_STATUS_REJECTED:
            return "PROPOSAL_STATUS_REJECTED";
        case ProposalStatus.PROPOSAL_STATUS_FAILED:
            return "PROPOSAL_STATUS_FAILED";
        case ProposalStatus.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.proposalStatusToJSON = proposalStatusToJSON;
function createBaseWeightedVoteOption() {
    return { option: 0, weight: "" };
}
exports.WeightedVoteOption = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.option !== 0) {
            writer.uint32(8).int32(message.option);
        }
        if (message.weight !== "") {
            writer.uint32(18).string(message.weight);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseWeightedVoteOption();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.option = reader.int32();
                    break;
                case 2:
                    message.weight = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            option: isSet(object.option) ? voteOptionFromJSON(object.option) : 0,
            weight: isSet(object.weight) ? String(object.weight) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.option !== undefined && (obj.option = voteOptionToJSON(message.option));
        message.weight !== undefined && (obj.weight = message.weight);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseWeightedVoteOption();
        message.option = (_a = object.option) !== null && _a !== void 0 ? _a : 0;
        message.weight = (_b = object.weight) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
function createBaseTextProposal() {
    return { title: "", description: "" };
}
exports.TextProposal = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.title !== "") {
            writer.uint32(10).string(message.title);
        }
        if (message.description !== "") {
            writer.uint32(18).string(message.description);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTextProposal();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.title = reader.string();
                    break;
                case 2:
                    message.description = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            title: isSet(object.title) ? String(object.title) : "",
            description: isSet(object.description) ? String(object.description) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.title !== undefined && (obj.title = message.title);
        message.description !== undefined && (obj.description = message.description);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseTextProposal();
        message.title = (_a = object.title) !== null && _a !== void 0 ? _a : "";
        message.description = (_b = object.description) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
function createBaseDeposit() {
    return { proposalId: long_1.default.UZERO, depositor: "", amount: [] };
}
exports.Deposit = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (!message.proposalId.isZero()) {
            writer.uint32(8).uint64(message.proposalId);
        }
        if (message.depositor !== "") {
            writer.uint32(18).string(message.depositor);
        }
        for (const v of message.amount) {
            coin_1.Coin.encode(v, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDeposit();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.depositor = reader.string();
                    break;
                case 3:
                    message.amount.push(coin_1.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            proposalId: isSet(object.proposalId) ? long_1.default.fromValue(object.proposalId) : long_1.default.UZERO,
            depositor: isSet(object.depositor) ? String(object.depositor) : "",
            amount: Array.isArray(object === null || object === void 0 ? void 0 : object.amount) ? object.amount.map((e) => coin_1.Coin.fromJSON(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || long_1.default.UZERO).toString());
        message.depositor !== undefined && (obj.depositor = message.depositor);
        if (message.amount) {
            obj.amount = message.amount.map((e) => (e ? coin_1.Coin.toJSON(e) : undefined));
        }
        else {
            obj.amount = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseDeposit();
        message.proposalId =
            object.proposalId !== undefined && object.proposalId !== null
                ? long_1.default.fromValue(object.proposalId)
                : long_1.default.UZERO;
        message.depositor = (_a = object.depositor) !== null && _a !== void 0 ? _a : "";
        message.amount = ((_b = object.amount) === null || _b === void 0 ? void 0 : _b.map((e) => coin_1.Coin.fromPartial(e))) || [];
        return message;
    },
};
function createBaseProposal() {
    return {
        proposalId: long_1.default.UZERO,
        content: undefined,
        status: 0,
        finalTallyResult: undefined,
        submitTime: undefined,
        depositEndTime: undefined,
        totalDeposit: [],
        votingStartTime: undefined,
        votingEndTime: undefined,
    };
}
exports.Proposal = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (!message.proposalId.isZero()) {
            writer.uint32(8).uint64(message.proposalId);
        }
        if (message.content !== undefined) {
            any_1.Any.encode(message.content, writer.uint32(18).fork()).ldelim();
        }
        if (message.status !== 0) {
            writer.uint32(24).int32(message.status);
        }
        if (message.finalTallyResult !== undefined) {
            exports.TallyResult.encode(message.finalTallyResult, writer.uint32(34).fork()).ldelim();
        }
        if (message.submitTime !== undefined) {
            timestamp_1.Timestamp.encode(message.submitTime, writer.uint32(42).fork()).ldelim();
        }
        if (message.depositEndTime !== undefined) {
            timestamp_1.Timestamp.encode(message.depositEndTime, writer.uint32(50).fork()).ldelim();
        }
        for (const v of message.totalDeposit) {
            coin_1.Coin.encode(v, writer.uint32(58).fork()).ldelim();
        }
        if (message.votingStartTime !== undefined) {
            timestamp_1.Timestamp.encode(message.votingStartTime, writer.uint32(66).fork()).ldelim();
        }
        if (message.votingEndTime !== undefined) {
            timestamp_1.Timestamp.encode(message.votingEndTime, writer.uint32(74).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseProposal();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.content = any_1.Any.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.status = reader.int32();
                    break;
                case 4:
                    message.finalTallyResult = exports.TallyResult.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.submitTime = timestamp_1.Timestamp.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.depositEndTime = timestamp_1.Timestamp.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.totalDeposit.push(coin_1.Coin.decode(reader, reader.uint32()));
                    break;
                case 8:
                    message.votingStartTime = timestamp_1.Timestamp.decode(reader, reader.uint32());
                    break;
                case 9:
                    message.votingEndTime = timestamp_1.Timestamp.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            proposalId: isSet(object.proposalId) ? long_1.default.fromValue(object.proposalId) : long_1.default.UZERO,
            content: isSet(object.content) ? any_1.Any.fromJSON(object.content) : undefined,
            status: isSet(object.status) ? proposalStatusFromJSON(object.status) : 0,
            finalTallyResult: isSet(object.finalTallyResult)
                ? exports.TallyResult.fromJSON(object.finalTallyResult)
                : undefined,
            submitTime: isSet(object.submitTime) ? fromJsonTimestamp(object.submitTime) : undefined,
            depositEndTime: isSet(object.depositEndTime) ? fromJsonTimestamp(object.depositEndTime) : undefined,
            totalDeposit: Array.isArray(object === null || object === void 0 ? void 0 : object.totalDeposit)
                ? object.totalDeposit.map((e) => coin_1.Coin.fromJSON(e))
                : [],
            votingStartTime: isSet(object.votingStartTime) ? fromJsonTimestamp(object.votingStartTime) : undefined,
            votingEndTime: isSet(object.votingEndTime) ? fromJsonTimestamp(object.votingEndTime) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || long_1.default.UZERO).toString());
        message.content !== undefined &&
            (obj.content = message.content ? any_1.Any.toJSON(message.content) : undefined);
        message.status !== undefined && (obj.status = proposalStatusToJSON(message.status));
        message.finalTallyResult !== undefined &&
            (obj.finalTallyResult = message.finalTallyResult
                ? exports.TallyResult.toJSON(message.finalTallyResult)
                : undefined);
        message.submitTime !== undefined && (obj.submitTime = fromTimestamp(message.submitTime).toISOString());
        message.depositEndTime !== undefined &&
            (obj.depositEndTime = fromTimestamp(message.depositEndTime).toISOString());
        if (message.totalDeposit) {
            obj.totalDeposit = message.totalDeposit.map((e) => (e ? coin_1.Coin.toJSON(e) : undefined));
        }
        else {
            obj.totalDeposit = [];
        }
        message.votingStartTime !== undefined &&
            (obj.votingStartTime = fromTimestamp(message.votingStartTime).toISOString());
        message.votingEndTime !== undefined &&
            (obj.votingEndTime = fromTimestamp(message.votingEndTime).toISOString());
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseProposal();
        message.proposalId =
            object.proposalId !== undefined && object.proposalId !== null
                ? long_1.default.fromValue(object.proposalId)
                : long_1.default.UZERO;
        message.content =
            object.content !== undefined && object.content !== null ? any_1.Any.fromPartial(object.content) : undefined;
        message.status = (_a = object.status) !== null && _a !== void 0 ? _a : 0;
        message.finalTallyResult =
            object.finalTallyResult !== undefined && object.finalTallyResult !== null
                ? exports.TallyResult.fromPartial(object.finalTallyResult)
                : undefined;
        message.submitTime =
            object.submitTime !== undefined && object.submitTime !== null
                ? timestamp_1.Timestamp.fromPartial(object.submitTime)
                : undefined;
        message.depositEndTime =
            object.depositEndTime !== undefined && object.depositEndTime !== null
                ? timestamp_1.Timestamp.fromPartial(object.depositEndTime)
                : undefined;
        message.totalDeposit = ((_b = object.totalDeposit) === null || _b === void 0 ? void 0 : _b.map((e) => coin_1.Coin.fromPartial(e))) || [];
        message.votingStartTime =
            object.votingStartTime !== undefined && object.votingStartTime !== null
                ? timestamp_1.Timestamp.fromPartial(object.votingStartTime)
                : undefined;
        message.votingEndTime =
            object.votingEndTime !== undefined && object.votingEndTime !== null
                ? timestamp_1.Timestamp.fromPartial(object.votingEndTime)
                : undefined;
        return message;
    },
};
function createBaseTallyResult() {
    return { yes: "", abstain: "", no: "", noWithVeto: "" };
}
exports.TallyResult = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.yes !== "") {
            writer.uint32(10).string(message.yes);
        }
        if (message.abstain !== "") {
            writer.uint32(18).string(message.abstain);
        }
        if (message.no !== "") {
            writer.uint32(26).string(message.no);
        }
        if (message.noWithVeto !== "") {
            writer.uint32(34).string(message.noWithVeto);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTallyResult();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.yes = reader.string();
                    break;
                case 2:
                    message.abstain = reader.string();
                    break;
                case 3:
                    message.no = reader.string();
                    break;
                case 4:
                    message.noWithVeto = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            yes: isSet(object.yes) ? String(object.yes) : "",
            abstain: isSet(object.abstain) ? String(object.abstain) : "",
            no: isSet(object.no) ? String(object.no) : "",
            noWithVeto: isSet(object.noWithVeto) ? String(object.noWithVeto) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.yes !== undefined && (obj.yes = message.yes);
        message.abstain !== undefined && (obj.abstain = message.abstain);
        message.no !== undefined && (obj.no = message.no);
        message.noWithVeto !== undefined && (obj.noWithVeto = message.noWithVeto);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d;
        const message = createBaseTallyResult();
        message.yes = (_a = object.yes) !== null && _a !== void 0 ? _a : "";
        message.abstain = (_b = object.abstain) !== null && _b !== void 0 ? _b : "";
        message.no = (_c = object.no) !== null && _c !== void 0 ? _c : "";
        message.noWithVeto = (_d = object.noWithVeto) !== null && _d !== void 0 ? _d : "";
        return message;
    },
};
function createBaseVote() {
    return { proposalId: long_1.default.UZERO, voter: "", option: 0, options: [] };
}
exports.Vote = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (!message.proposalId.isZero()) {
            writer.uint32(8).uint64(message.proposalId);
        }
        if (message.voter !== "") {
            writer.uint32(18).string(message.voter);
        }
        if (message.option !== 0) {
            writer.uint32(24).int32(message.option);
        }
        for (const v of message.options) {
            exports.WeightedVoteOption.encode(v, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVote();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.voter = reader.string();
                    break;
                case 3:
                    message.option = reader.int32();
                    break;
                case 4:
                    message.options.push(exports.WeightedVoteOption.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            proposalId: isSet(object.proposalId) ? long_1.default.fromValue(object.proposalId) : long_1.default.UZERO,
            voter: isSet(object.voter) ? String(object.voter) : "",
            option: isSet(object.option) ? voteOptionFromJSON(object.option) : 0,
            options: Array.isArray(object === null || object === void 0 ? void 0 : object.options)
                ? object.options.map((e) => exports.WeightedVoteOption.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || long_1.default.UZERO).toString());
        message.voter !== undefined && (obj.voter = message.voter);
        message.option !== undefined && (obj.option = voteOptionToJSON(message.option));
        if (message.options) {
            obj.options = message.options.map((e) => (e ? exports.WeightedVoteOption.toJSON(e) : undefined));
        }
        else {
            obj.options = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseVote();
        message.proposalId =
            object.proposalId !== undefined && object.proposalId !== null
                ? long_1.default.fromValue(object.proposalId)
                : long_1.default.UZERO;
        message.voter = (_a = object.voter) !== null && _a !== void 0 ? _a : "";
        message.option = (_b = object.option) !== null && _b !== void 0 ? _b : 0;
        message.options = ((_c = object.options) === null || _c === void 0 ? void 0 : _c.map((e) => exports.WeightedVoteOption.fromPartial(e))) || [];
        return message;
    },
};
function createBaseDepositParams() {
    return { minDeposit: [], maxDepositPeriod: undefined };
}
exports.DepositParams = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.minDeposit) {
            coin_1.Coin.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.maxDepositPeriod !== undefined) {
            duration_1.Duration.encode(message.maxDepositPeriod, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDepositParams();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.minDeposit.push(coin_1.Coin.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.maxDepositPeriod = duration_1.Duration.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            minDeposit: Array.isArray(object === null || object === void 0 ? void 0 : object.minDeposit)
                ? object.minDeposit.map((e) => coin_1.Coin.fromJSON(e))
                : [],
            maxDepositPeriod: isSet(object.maxDepositPeriod)
                ? duration_1.Duration.fromJSON(object.maxDepositPeriod)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.minDeposit) {
            obj.minDeposit = message.minDeposit.map((e) => (e ? coin_1.Coin.toJSON(e) : undefined));
        }
        else {
            obj.minDeposit = [];
        }
        message.maxDepositPeriod !== undefined &&
            (obj.maxDepositPeriod = message.maxDepositPeriod
                ? duration_1.Duration.toJSON(message.maxDepositPeriod)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseDepositParams();
        message.minDeposit = ((_a = object.minDeposit) === null || _a === void 0 ? void 0 : _a.map((e) => coin_1.Coin.fromPartial(e))) || [];
        message.maxDepositPeriod =
            object.maxDepositPeriod !== undefined && object.maxDepositPeriod !== null
                ? duration_1.Duration.fromPartial(object.maxDepositPeriod)
                : undefined;
        return message;
    },
};
function createBaseVotingParams() {
    return { votingPeriod: undefined };
}
exports.VotingParams = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.votingPeriod !== undefined) {
            duration_1.Duration.encode(message.votingPeriod, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVotingParams();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.votingPeriod = duration_1.Duration.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { votingPeriod: isSet(object.votingPeriod) ? duration_1.Duration.fromJSON(object.votingPeriod) : undefined };
    },
    toJSON(message) {
        const obj = {};
        message.votingPeriod !== undefined &&
            (obj.votingPeriod = message.votingPeriod ? duration_1.Duration.toJSON(message.votingPeriod) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseVotingParams();
        message.votingPeriod =
            object.votingPeriod !== undefined && object.votingPeriod !== null
                ? duration_1.Duration.fromPartial(object.votingPeriod)
                : undefined;
        return message;
    },
};
function createBaseTallyParams() {
    return { quorum: new Uint8Array(), threshold: new Uint8Array(), vetoThreshold: new Uint8Array() };
}
exports.TallyParams = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.quorum.length !== 0) {
            writer.uint32(10).bytes(message.quorum);
        }
        if (message.threshold.length !== 0) {
            writer.uint32(18).bytes(message.threshold);
        }
        if (message.vetoThreshold.length !== 0) {
            writer.uint32(26).bytes(message.vetoThreshold);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTallyParams();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.quorum = reader.bytes();
                    break;
                case 2:
                    message.threshold = reader.bytes();
                    break;
                case 3:
                    message.vetoThreshold = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            quorum: isSet(object.quorum) ? bytesFromBase64(object.quorum) : new Uint8Array(),
            threshold: isSet(object.threshold) ? bytesFromBase64(object.threshold) : new Uint8Array(),
            vetoThreshold: isSet(object.vetoThreshold) ? bytesFromBase64(object.vetoThreshold) : new Uint8Array(),
        };
    },
    toJSON(message) {
        const obj = {};
        message.quorum !== undefined &&
            (obj.quorum = base64FromBytes(message.quorum !== undefined ? message.quorum : new Uint8Array()));
        message.threshold !== undefined &&
            (obj.threshold = base64FromBytes(message.threshold !== undefined ? message.threshold : new Uint8Array()));
        message.vetoThreshold !== undefined &&
            (obj.vetoThreshold = base64FromBytes(message.vetoThreshold !== undefined ? message.vetoThreshold : new Uint8Array()));
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseTallyParams();
        message.quorum = (_a = object.quorum) !== null && _a !== void 0 ? _a : new Uint8Array();
        message.threshold = (_b = object.threshold) !== null && _b !== void 0 ? _b : new Uint8Array();
        message.vetoThreshold = (_c = object.vetoThreshold) !== null && _c !== void 0 ? _c : new Uint8Array();
        return message;
    },
};
var globalThis = (() => {
    if (typeof globalThis !== "undefined") {
        return globalThis;
    }
    if (typeof self !== "undefined") {
        return self;
    }
    if (typeof window !== "undefined") {
        return window;
    }
    if (typeof __webpack_require__.g !== "undefined") {
        return __webpack_require__.g;
    }
    throw "Unable to locate global object";
})();
function bytesFromBase64(b64) {
    if (globalThis.Buffer) {
        return Uint8Array.from(globalThis.Buffer.from(b64, "base64"));
    }
    else {
        const bin = globalThis.atob(b64);
        const arr = new Uint8Array(bin.length);
        for (let i = 0; i < bin.length; ++i) {
            arr[i] = bin.charCodeAt(i);
        }
        return arr;
    }
}
function base64FromBytes(arr) {
    if (globalThis.Buffer) {
        return globalThis.Buffer.from(arr).toString("base64");
    }
    else {
        const bin = [];
        arr.forEach((byte) => {
            bin.push(String.fromCharCode(byte));
        });
        return globalThis.btoa(bin.join(""));
    }
}
function toTimestamp(date) {
    const seconds = numberToLong(date.getTime() / 1000);
    const nanos = (date.getTime() % 1000) * 1000000;
    return { seconds, nanos };
}
function fromTimestamp(t) {
    let millis = t.seconds.toNumber() * 1000;
    millis += t.nanos / 1000000;
    return new Date(millis);
}
function fromJsonTimestamp(o) {
    if (o instanceof Date) {
        return toTimestamp(o);
    }
    else if (typeof o === "string") {
        return toTimestamp(new Date(o));
    }
    else {
        return timestamp_1.Timestamp.fromJSON(o);
    }
}
function numberToLong(number) {
    return long_1.default.fromNumber(number);
}
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=gov.js.map

/***/ }),

/***/ 13645:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.QueryClientImpl = exports.QueryTallyResultResponse = exports.QueryTallyResultRequest = exports.QueryDepositsResponse = exports.QueryDepositsRequest = exports.QueryDepositResponse = exports.QueryDepositRequest = exports.QueryParamsResponse = exports.QueryParamsRequest = exports.QueryVotesResponse = exports.QueryVotesRequest = exports.QueryVoteResponse = exports.QueryVoteRequest = exports.QueryProposalsResponse = exports.QueryProposalsRequest = exports.QueryProposalResponse = exports.QueryProposalRequest = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(__webpack_require__(47873));
const minimal_1 = __importDefault(__webpack_require__(62100));
const pagination_1 = __webpack_require__(62635);
const gov_1 = __webpack_require__(72980);
exports.protobufPackage = "cosmos.gov.v1beta1";
function createBaseQueryProposalRequest() {
    return { proposalId: long_1.default.UZERO };
}
exports.QueryProposalRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (!message.proposalId.isZero()) {
            writer.uint32(8).uint64(message.proposalId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryProposalRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { proposalId: isSet(object.proposalId) ? long_1.default.fromValue(object.proposalId) : long_1.default.UZERO };
    },
    toJSON(message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryProposalRequest();
        message.proposalId =
            object.proposalId !== undefined && object.proposalId !== null
                ? long_1.default.fromValue(object.proposalId)
                : long_1.default.UZERO;
        return message;
    },
};
function createBaseQueryProposalResponse() {
    return { proposal: undefined };
}
exports.QueryProposalResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.proposal !== undefined) {
            gov_1.Proposal.encode(message.proposal, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryProposalResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.proposal = gov_1.Proposal.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { proposal: isSet(object.proposal) ? gov_1.Proposal.fromJSON(object.proposal) : undefined };
    },
    toJSON(message) {
        const obj = {};
        message.proposal !== undefined &&
            (obj.proposal = message.proposal ? gov_1.Proposal.toJSON(message.proposal) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryProposalResponse();
        message.proposal =
            object.proposal !== undefined && object.proposal !== null
                ? gov_1.Proposal.fromPartial(object.proposal)
                : undefined;
        return message;
    },
};
function createBaseQueryProposalsRequest() {
    return { proposalStatus: 0, voter: "", depositor: "", pagination: undefined };
}
exports.QueryProposalsRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.proposalStatus !== 0) {
            writer.uint32(8).int32(message.proposalStatus);
        }
        if (message.voter !== "") {
            writer.uint32(18).string(message.voter);
        }
        if (message.depositor !== "") {
            writer.uint32(26).string(message.depositor);
        }
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryProposalsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.proposalStatus = reader.int32();
                    break;
                case 2:
                    message.voter = reader.string();
                    break;
                case 3:
                    message.depositor = reader.string();
                    break;
                case 4:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            proposalStatus: isSet(object.proposalStatus) ? (0, gov_1.proposalStatusFromJSON)(object.proposalStatus) : 0,
            voter: isSet(object.voter) ? String(object.voter) : "",
            depositor: isSet(object.depositor) ? String(object.depositor) : "",
            pagination: isSet(object.pagination) ? pagination_1.PageRequest.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.proposalStatus !== undefined &&
            (obj.proposalStatus = (0, gov_1.proposalStatusToJSON)(message.proposalStatus));
        message.voter !== undefined && (obj.voter = message.voter);
        message.depositor !== undefined && (obj.depositor = message.depositor);
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseQueryProposalsRequest();
        message.proposalStatus = (_a = object.proposalStatus) !== null && _a !== void 0 ? _a : 0;
        message.voter = (_b = object.voter) !== null && _b !== void 0 ? _b : "";
        message.depositor = (_c = object.depositor) !== null && _c !== void 0 ? _c : "";
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryProposalsResponse() {
    return { proposals: [], pagination: undefined };
}
exports.QueryProposalsResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.proposals) {
            gov_1.Proposal.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryProposalsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.proposals.push(gov_1.Proposal.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            proposals: Array.isArray(object === null || object === void 0 ? void 0 : object.proposals)
                ? object.proposals.map((e) => gov_1.Proposal.fromJSON(e))
                : [],
            pagination: isSet(object.pagination) ? pagination_1.PageResponse.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.proposals) {
            obj.proposals = message.proposals.map((e) => (e ? gov_1.Proposal.toJSON(e) : undefined));
        }
        else {
            obj.proposals = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryProposalsResponse();
        message.proposals = ((_a = object.proposals) === null || _a === void 0 ? void 0 : _a.map((e) => gov_1.Proposal.fromPartial(e))) || [];
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryVoteRequest() {
    return { proposalId: long_1.default.UZERO, voter: "" };
}
exports.QueryVoteRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (!message.proposalId.isZero()) {
            writer.uint32(8).uint64(message.proposalId);
        }
        if (message.voter !== "") {
            writer.uint32(18).string(message.voter);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryVoteRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.voter = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            proposalId: isSet(object.proposalId) ? long_1.default.fromValue(object.proposalId) : long_1.default.UZERO,
            voter: isSet(object.voter) ? String(object.voter) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || long_1.default.UZERO).toString());
        message.voter !== undefined && (obj.voter = message.voter);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryVoteRequest();
        message.proposalId =
            object.proposalId !== undefined && object.proposalId !== null
                ? long_1.default.fromValue(object.proposalId)
                : long_1.default.UZERO;
        message.voter = (_a = object.voter) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
function createBaseQueryVoteResponse() {
    return { vote: undefined };
}
exports.QueryVoteResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.vote !== undefined) {
            gov_1.Vote.encode(message.vote, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryVoteResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.vote = gov_1.Vote.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { vote: isSet(object.vote) ? gov_1.Vote.fromJSON(object.vote) : undefined };
    },
    toJSON(message) {
        const obj = {};
        message.vote !== undefined && (obj.vote = message.vote ? gov_1.Vote.toJSON(message.vote) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryVoteResponse();
        message.vote =
            object.vote !== undefined && object.vote !== null ? gov_1.Vote.fromPartial(object.vote) : undefined;
        return message;
    },
};
function createBaseQueryVotesRequest() {
    return { proposalId: long_1.default.UZERO, pagination: undefined };
}
exports.QueryVotesRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (!message.proposalId.isZero()) {
            writer.uint32(8).uint64(message.proposalId);
        }
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryVotesRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            proposalId: isSet(object.proposalId) ? long_1.default.fromValue(object.proposalId) : long_1.default.UZERO,
            pagination: isSet(object.pagination) ? pagination_1.PageRequest.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || long_1.default.UZERO).toString());
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryVotesRequest();
        message.proposalId =
            object.proposalId !== undefined && object.proposalId !== null
                ? long_1.default.fromValue(object.proposalId)
                : long_1.default.UZERO;
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryVotesResponse() {
    return { votes: [], pagination: undefined };
}
exports.QueryVotesResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.votes) {
            gov_1.Vote.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryVotesResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.votes.push(gov_1.Vote.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            votes: Array.isArray(object === null || object === void 0 ? void 0 : object.votes) ? object.votes.map((e) => gov_1.Vote.fromJSON(e)) : [],
            pagination: isSet(object.pagination) ? pagination_1.PageResponse.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.votes) {
            obj.votes = message.votes.map((e) => (e ? gov_1.Vote.toJSON(e) : undefined));
        }
        else {
            obj.votes = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryVotesResponse();
        message.votes = ((_a = object.votes) === null || _a === void 0 ? void 0 : _a.map((e) => gov_1.Vote.fromPartial(e))) || [];
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryParamsRequest() {
    return { paramsType: "" };
}
exports.QueryParamsRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.paramsType !== "") {
            writer.uint32(10).string(message.paramsType);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryParamsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.paramsType = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { paramsType: isSet(object.paramsType) ? String(object.paramsType) : "" };
    },
    toJSON(message) {
        const obj = {};
        message.paramsType !== undefined && (obj.paramsType = message.paramsType);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryParamsRequest();
        message.paramsType = (_a = object.paramsType) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
function createBaseQueryParamsResponse() {
    return { votingParams: undefined, depositParams: undefined, tallyParams: undefined };
}
exports.QueryParamsResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.votingParams !== undefined) {
            gov_1.VotingParams.encode(message.votingParams, writer.uint32(10).fork()).ldelim();
        }
        if (message.depositParams !== undefined) {
            gov_1.DepositParams.encode(message.depositParams, writer.uint32(18).fork()).ldelim();
        }
        if (message.tallyParams !== undefined) {
            gov_1.TallyParams.encode(message.tallyParams, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryParamsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.votingParams = gov_1.VotingParams.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.depositParams = gov_1.DepositParams.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.tallyParams = gov_1.TallyParams.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            votingParams: isSet(object.votingParams) ? gov_1.VotingParams.fromJSON(object.votingParams) : undefined,
            depositParams: isSet(object.depositParams) ? gov_1.DepositParams.fromJSON(object.depositParams) : undefined,
            tallyParams: isSet(object.tallyParams) ? gov_1.TallyParams.fromJSON(object.tallyParams) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.votingParams !== undefined &&
            (obj.votingParams = message.votingParams ? gov_1.VotingParams.toJSON(message.votingParams) : undefined);
        message.depositParams !== undefined &&
            (obj.depositParams = message.depositParams ? gov_1.DepositParams.toJSON(message.depositParams) : undefined);
        message.tallyParams !== undefined &&
            (obj.tallyParams = message.tallyParams ? gov_1.TallyParams.toJSON(message.tallyParams) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryParamsResponse();
        message.votingParams =
            object.votingParams !== undefined && object.votingParams !== null
                ? gov_1.VotingParams.fromPartial(object.votingParams)
                : undefined;
        message.depositParams =
            object.depositParams !== undefined && object.depositParams !== null
                ? gov_1.DepositParams.fromPartial(object.depositParams)
                : undefined;
        message.tallyParams =
            object.tallyParams !== undefined && object.tallyParams !== null
                ? gov_1.TallyParams.fromPartial(object.tallyParams)
                : undefined;
        return message;
    },
};
function createBaseQueryDepositRequest() {
    return { proposalId: long_1.default.UZERO, depositor: "" };
}
exports.QueryDepositRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (!message.proposalId.isZero()) {
            writer.uint32(8).uint64(message.proposalId);
        }
        if (message.depositor !== "") {
            writer.uint32(18).string(message.depositor);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryDepositRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.depositor = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            proposalId: isSet(object.proposalId) ? long_1.default.fromValue(object.proposalId) : long_1.default.UZERO,
            depositor: isSet(object.depositor) ? String(object.depositor) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || long_1.default.UZERO).toString());
        message.depositor !== undefined && (obj.depositor = message.depositor);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryDepositRequest();
        message.proposalId =
            object.proposalId !== undefined && object.proposalId !== null
                ? long_1.default.fromValue(object.proposalId)
                : long_1.default.UZERO;
        message.depositor = (_a = object.depositor) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
function createBaseQueryDepositResponse() {
    return { deposit: undefined };
}
exports.QueryDepositResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.deposit !== undefined) {
            gov_1.Deposit.encode(message.deposit, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryDepositResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.deposit = gov_1.Deposit.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { deposit: isSet(object.deposit) ? gov_1.Deposit.fromJSON(object.deposit) : undefined };
    },
    toJSON(message) {
        const obj = {};
        message.deposit !== undefined &&
            (obj.deposit = message.deposit ? gov_1.Deposit.toJSON(message.deposit) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryDepositResponse();
        message.deposit =
            object.deposit !== undefined && object.deposit !== null
                ? gov_1.Deposit.fromPartial(object.deposit)
                : undefined;
        return message;
    },
};
function createBaseQueryDepositsRequest() {
    return { proposalId: long_1.default.UZERO, pagination: undefined };
}
exports.QueryDepositsRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (!message.proposalId.isZero()) {
            writer.uint32(8).uint64(message.proposalId);
        }
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryDepositsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            proposalId: isSet(object.proposalId) ? long_1.default.fromValue(object.proposalId) : long_1.default.UZERO,
            pagination: isSet(object.pagination) ? pagination_1.PageRequest.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || long_1.default.UZERO).toString());
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryDepositsRequest();
        message.proposalId =
            object.proposalId !== undefined && object.proposalId !== null
                ? long_1.default.fromValue(object.proposalId)
                : long_1.default.UZERO;
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryDepositsResponse() {
    return { deposits: [], pagination: undefined };
}
exports.QueryDepositsResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.deposits) {
            gov_1.Deposit.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryDepositsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.deposits.push(gov_1.Deposit.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            deposits: Array.isArray(object === null || object === void 0 ? void 0 : object.deposits) ? object.deposits.map((e) => gov_1.Deposit.fromJSON(e)) : [],
            pagination: isSet(object.pagination) ? pagination_1.PageResponse.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.deposits) {
            obj.deposits = message.deposits.map((e) => (e ? gov_1.Deposit.toJSON(e) : undefined));
        }
        else {
            obj.deposits = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryDepositsResponse();
        message.deposits = ((_a = object.deposits) === null || _a === void 0 ? void 0 : _a.map((e) => gov_1.Deposit.fromPartial(e))) || [];
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryTallyResultRequest() {
    return { proposalId: long_1.default.UZERO };
}
exports.QueryTallyResultRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (!message.proposalId.isZero()) {
            writer.uint32(8).uint64(message.proposalId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryTallyResultRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { proposalId: isSet(object.proposalId) ? long_1.default.fromValue(object.proposalId) : long_1.default.UZERO };
    },
    toJSON(message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryTallyResultRequest();
        message.proposalId =
            object.proposalId !== undefined && object.proposalId !== null
                ? long_1.default.fromValue(object.proposalId)
                : long_1.default.UZERO;
        return message;
    },
};
function createBaseQueryTallyResultResponse() {
    return { tally: undefined };
}
exports.QueryTallyResultResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.tally !== undefined) {
            gov_1.TallyResult.encode(message.tally, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryTallyResultResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.tally = gov_1.TallyResult.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { tally: isSet(object.tally) ? gov_1.TallyResult.fromJSON(object.tally) : undefined };
    },
    toJSON(message) {
        const obj = {};
        message.tally !== undefined &&
            (obj.tally = message.tally ? gov_1.TallyResult.toJSON(message.tally) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryTallyResultResponse();
        message.tally =
            object.tally !== undefined && object.tally !== null ? gov_1.TallyResult.fromPartial(object.tally) : undefined;
        return message;
    },
};
class QueryClientImpl {
    constructor(rpc) {
        this.rpc = rpc;
        this.Proposal = this.Proposal.bind(this);
        this.Proposals = this.Proposals.bind(this);
        this.Vote = this.Vote.bind(this);
        this.Votes = this.Votes.bind(this);
        this.Params = this.Params.bind(this);
        this.Deposit = this.Deposit.bind(this);
        this.Deposits = this.Deposits.bind(this);
        this.TallyResult = this.TallyResult.bind(this);
    }
    Proposal(request) {
        const data = exports.QueryProposalRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.gov.v1beta1.Query", "Proposal", data);
        return promise.then((data) => exports.QueryProposalResponse.decode(new minimal_1.default.Reader(data)));
    }
    Proposals(request) {
        const data = exports.QueryProposalsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.gov.v1beta1.Query", "Proposals", data);
        return promise.then((data) => exports.QueryProposalsResponse.decode(new minimal_1.default.Reader(data)));
    }
    Vote(request) {
        const data = exports.QueryVoteRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.gov.v1beta1.Query", "Vote", data);
        return promise.then((data) => exports.QueryVoteResponse.decode(new minimal_1.default.Reader(data)));
    }
    Votes(request) {
        const data = exports.QueryVotesRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.gov.v1beta1.Query", "Votes", data);
        return promise.then((data) => exports.QueryVotesResponse.decode(new minimal_1.default.Reader(data)));
    }
    Params(request) {
        const data = exports.QueryParamsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.gov.v1beta1.Query", "Params", data);
        return promise.then((data) => exports.QueryParamsResponse.decode(new minimal_1.default.Reader(data)));
    }
    Deposit(request) {
        const data = exports.QueryDepositRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.gov.v1beta1.Query", "Deposit", data);
        return promise.then((data) => exports.QueryDepositResponse.decode(new minimal_1.default.Reader(data)));
    }
    Deposits(request) {
        const data = exports.QueryDepositsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.gov.v1beta1.Query", "Deposits", data);
        return promise.then((data) => exports.QueryDepositsResponse.decode(new minimal_1.default.Reader(data)));
    }
    TallyResult(request) {
        const data = exports.QueryTallyResultRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.gov.v1beta1.Query", "TallyResult", data);
        return promise.then((data) => exports.QueryTallyResultResponse.decode(new minimal_1.default.Reader(data)));
    }
}
exports.QueryClientImpl = QueryClientImpl;
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=query.js.map

/***/ }),

/***/ 63937:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MsgClientImpl = exports.MsgDepositResponse = exports.MsgDeposit = exports.MsgVoteWeightedResponse = exports.MsgVoteWeighted = exports.MsgVoteResponse = exports.MsgVote = exports.MsgSubmitProposalResponse = exports.MsgSubmitProposal = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(__webpack_require__(47873));
const minimal_1 = __importDefault(__webpack_require__(62100));
const any_1 = __webpack_require__(90007);
const coin_1 = __webpack_require__(26119);
const gov_1 = __webpack_require__(72980);
exports.protobufPackage = "cosmos.gov.v1beta1";
function createBaseMsgSubmitProposal() {
    return { content: undefined, initialDeposit: [], proposer: "" };
}
exports.MsgSubmitProposal = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.content !== undefined) {
            any_1.Any.encode(message.content, writer.uint32(10).fork()).ldelim();
        }
        for (const v of message.initialDeposit) {
            coin_1.Coin.encode(v, writer.uint32(18).fork()).ldelim();
        }
        if (message.proposer !== "") {
            writer.uint32(26).string(message.proposer);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgSubmitProposal();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.content = any_1.Any.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.initialDeposit.push(coin_1.Coin.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.proposer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            content: isSet(object.content) ? any_1.Any.fromJSON(object.content) : undefined,
            initialDeposit: Array.isArray(object === null || object === void 0 ? void 0 : object.initialDeposit)
                ? object.initialDeposit.map((e) => coin_1.Coin.fromJSON(e))
                : [],
            proposer: isSet(object.proposer) ? String(object.proposer) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.content !== undefined &&
            (obj.content = message.content ? any_1.Any.toJSON(message.content) : undefined);
        if (message.initialDeposit) {
            obj.initialDeposit = message.initialDeposit.map((e) => (e ? coin_1.Coin.toJSON(e) : undefined));
        }
        else {
            obj.initialDeposit = [];
        }
        message.proposer !== undefined && (obj.proposer = message.proposer);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseMsgSubmitProposal();
        message.content =
            object.content !== undefined && object.content !== null ? any_1.Any.fromPartial(object.content) : undefined;
        message.initialDeposit = ((_a = object.initialDeposit) === null || _a === void 0 ? void 0 : _a.map((e) => coin_1.Coin.fromPartial(e))) || [];
        message.proposer = (_b = object.proposer) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
function createBaseMsgSubmitProposalResponse() {
    return { proposalId: long_1.default.UZERO };
}
exports.MsgSubmitProposalResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (!message.proposalId.isZero()) {
            writer.uint32(8).uint64(message.proposalId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgSubmitProposalResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { proposalId: isSet(object.proposalId) ? long_1.default.fromValue(object.proposalId) : long_1.default.UZERO };
    },
    toJSON(message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgSubmitProposalResponse();
        message.proposalId =
            object.proposalId !== undefined && object.proposalId !== null
                ? long_1.default.fromValue(object.proposalId)
                : long_1.default.UZERO;
        return message;
    },
};
function createBaseMsgVote() {
    return { proposalId: long_1.default.UZERO, voter: "", option: 0 };
}
exports.MsgVote = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (!message.proposalId.isZero()) {
            writer.uint32(8).uint64(message.proposalId);
        }
        if (message.voter !== "") {
            writer.uint32(18).string(message.voter);
        }
        if (message.option !== 0) {
            writer.uint32(24).int32(message.option);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgVote();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.voter = reader.string();
                    break;
                case 3:
                    message.option = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            proposalId: isSet(object.proposalId) ? long_1.default.fromValue(object.proposalId) : long_1.default.UZERO,
            voter: isSet(object.voter) ? String(object.voter) : "",
            option: isSet(object.option) ? (0, gov_1.voteOptionFromJSON)(object.option) : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || long_1.default.UZERO).toString());
        message.voter !== undefined && (obj.voter = message.voter);
        message.option !== undefined && (obj.option = (0, gov_1.voteOptionToJSON)(message.option));
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseMsgVote();
        message.proposalId =
            object.proposalId !== undefined && object.proposalId !== null
                ? long_1.default.fromValue(object.proposalId)
                : long_1.default.UZERO;
        message.voter = (_a = object.voter) !== null && _a !== void 0 ? _a : "";
        message.option = (_b = object.option) !== null && _b !== void 0 ? _b : 0;
        return message;
    },
};
function createBaseMsgVoteResponse() {
    return {};
}
exports.MsgVoteResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgVoteResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgVoteResponse();
        return message;
    },
};
function createBaseMsgVoteWeighted() {
    return { proposalId: long_1.default.UZERO, voter: "", options: [] };
}
exports.MsgVoteWeighted = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (!message.proposalId.isZero()) {
            writer.uint32(8).uint64(message.proposalId);
        }
        if (message.voter !== "") {
            writer.uint32(18).string(message.voter);
        }
        for (const v of message.options) {
            gov_1.WeightedVoteOption.encode(v, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgVoteWeighted();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.voter = reader.string();
                    break;
                case 3:
                    message.options.push(gov_1.WeightedVoteOption.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            proposalId: isSet(object.proposalId) ? long_1.default.fromValue(object.proposalId) : long_1.default.UZERO,
            voter: isSet(object.voter) ? String(object.voter) : "",
            options: Array.isArray(object === null || object === void 0 ? void 0 : object.options)
                ? object.options.map((e) => gov_1.WeightedVoteOption.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || long_1.default.UZERO).toString());
        message.voter !== undefined && (obj.voter = message.voter);
        if (message.options) {
            obj.options = message.options.map((e) => (e ? gov_1.WeightedVoteOption.toJSON(e) : undefined));
        }
        else {
            obj.options = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseMsgVoteWeighted();
        message.proposalId =
            object.proposalId !== undefined && object.proposalId !== null
                ? long_1.default.fromValue(object.proposalId)
                : long_1.default.UZERO;
        message.voter = (_a = object.voter) !== null && _a !== void 0 ? _a : "";
        message.options = ((_b = object.options) === null || _b === void 0 ? void 0 : _b.map((e) => gov_1.WeightedVoteOption.fromPartial(e))) || [];
        return message;
    },
};
function createBaseMsgVoteWeightedResponse() {
    return {};
}
exports.MsgVoteWeightedResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgVoteWeightedResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgVoteWeightedResponse();
        return message;
    },
};
function createBaseMsgDeposit() {
    return { proposalId: long_1.default.UZERO, depositor: "", amount: [] };
}
exports.MsgDeposit = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (!message.proposalId.isZero()) {
            writer.uint32(8).uint64(message.proposalId);
        }
        if (message.depositor !== "") {
            writer.uint32(18).string(message.depositor);
        }
        for (const v of message.amount) {
            coin_1.Coin.encode(v, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgDeposit();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.depositor = reader.string();
                    break;
                case 3:
                    message.amount.push(coin_1.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            proposalId: isSet(object.proposalId) ? long_1.default.fromValue(object.proposalId) : long_1.default.UZERO,
            depositor: isSet(object.depositor) ? String(object.depositor) : "",
            amount: Array.isArray(object === null || object === void 0 ? void 0 : object.amount) ? object.amount.map((e) => coin_1.Coin.fromJSON(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || long_1.default.UZERO).toString());
        message.depositor !== undefined && (obj.depositor = message.depositor);
        if (message.amount) {
            obj.amount = message.amount.map((e) => (e ? coin_1.Coin.toJSON(e) : undefined));
        }
        else {
            obj.amount = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseMsgDeposit();
        message.proposalId =
            object.proposalId !== undefined && object.proposalId !== null
                ? long_1.default.fromValue(object.proposalId)
                : long_1.default.UZERO;
        message.depositor = (_a = object.depositor) !== null && _a !== void 0 ? _a : "";
        message.amount = ((_b = object.amount) === null || _b === void 0 ? void 0 : _b.map((e) => coin_1.Coin.fromPartial(e))) || [];
        return message;
    },
};
function createBaseMsgDepositResponse() {
    return {};
}
exports.MsgDepositResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgDepositResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgDepositResponse();
        return message;
    },
};
class MsgClientImpl {
    constructor(rpc) {
        this.rpc = rpc;
        this.SubmitProposal = this.SubmitProposal.bind(this);
        this.Vote = this.Vote.bind(this);
        this.VoteWeighted = this.VoteWeighted.bind(this);
        this.Deposit = this.Deposit.bind(this);
    }
    SubmitProposal(request) {
        const data = exports.MsgSubmitProposal.encode(request).finish();
        const promise = this.rpc.request("cosmos.gov.v1beta1.Msg", "SubmitProposal", data);
        return promise.then((data) => exports.MsgSubmitProposalResponse.decode(new minimal_1.default.Reader(data)));
    }
    Vote(request) {
        const data = exports.MsgVote.encode(request).finish();
        const promise = this.rpc.request("cosmos.gov.v1beta1.Msg", "Vote", data);
        return promise.then((data) => exports.MsgVoteResponse.decode(new minimal_1.default.Reader(data)));
    }
    VoteWeighted(request) {
        const data = exports.MsgVoteWeighted.encode(request).finish();
        const promise = this.rpc.request("cosmos.gov.v1beta1.Msg", "VoteWeighted", data);
        return promise.then((data) => exports.MsgVoteWeightedResponse.decode(new minimal_1.default.Reader(data)));
    }
    Deposit(request) {
        const data = exports.MsgDeposit.encode(request).finish();
        const promise = this.rpc.request("cosmos.gov.v1beta1.Msg", "Deposit", data);
        return promise.then((data) => exports.MsgDepositResponse.decode(new minimal_1.default.Reader(data)));
    }
}
exports.MsgClientImpl = MsgClientImpl;
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=tx.js.map

/***/ }),

/***/ 57652:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Params = exports.Minter = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(__webpack_require__(47873));
const minimal_1 = __importDefault(__webpack_require__(62100));
exports.protobufPackage = "cosmos.mint.v1beta1";
function createBaseMinter() {
    return { inflation: "", annualProvisions: "" };
}
exports.Minter = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.inflation !== "") {
            writer.uint32(10).string(message.inflation);
        }
        if (message.annualProvisions !== "") {
            writer.uint32(18).string(message.annualProvisions);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMinter();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.inflation = reader.string();
                    break;
                case 2:
                    message.annualProvisions = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            inflation: isSet(object.inflation) ? String(object.inflation) : "",
            annualProvisions: isSet(object.annualProvisions) ? String(object.annualProvisions) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.inflation !== undefined && (obj.inflation = message.inflation);
        message.annualProvisions !== undefined && (obj.annualProvisions = message.annualProvisions);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseMinter();
        message.inflation = (_a = object.inflation) !== null && _a !== void 0 ? _a : "";
        message.annualProvisions = (_b = object.annualProvisions) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
function createBaseParams() {
    return {
        mintDenom: "",
        inflationRateChange: "",
        inflationMax: "",
        inflationMin: "",
        goalBonded: "",
        blocksPerYear: long_1.default.UZERO,
    };
}
exports.Params = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.mintDenom !== "") {
            writer.uint32(10).string(message.mintDenom);
        }
        if (message.inflationRateChange !== "") {
            writer.uint32(18).string(message.inflationRateChange);
        }
        if (message.inflationMax !== "") {
            writer.uint32(26).string(message.inflationMax);
        }
        if (message.inflationMin !== "") {
            writer.uint32(34).string(message.inflationMin);
        }
        if (message.goalBonded !== "") {
            writer.uint32(42).string(message.goalBonded);
        }
        if (!message.blocksPerYear.isZero()) {
            writer.uint32(48).uint64(message.blocksPerYear);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseParams();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.mintDenom = reader.string();
                    break;
                case 2:
                    message.inflationRateChange = reader.string();
                    break;
                case 3:
                    message.inflationMax = reader.string();
                    break;
                case 4:
                    message.inflationMin = reader.string();
                    break;
                case 5:
                    message.goalBonded = reader.string();
                    break;
                case 6:
                    message.blocksPerYear = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            mintDenom: isSet(object.mintDenom) ? String(object.mintDenom) : "",
            inflationRateChange: isSet(object.inflationRateChange) ? String(object.inflationRateChange) : "",
            inflationMax: isSet(object.inflationMax) ? String(object.inflationMax) : "",
            inflationMin: isSet(object.inflationMin) ? String(object.inflationMin) : "",
            goalBonded: isSet(object.goalBonded) ? String(object.goalBonded) : "",
            blocksPerYear: isSet(object.blocksPerYear) ? long_1.default.fromValue(object.blocksPerYear) : long_1.default.UZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        message.mintDenom !== undefined && (obj.mintDenom = message.mintDenom);
        message.inflationRateChange !== undefined && (obj.inflationRateChange = message.inflationRateChange);
        message.inflationMax !== undefined && (obj.inflationMax = message.inflationMax);
        message.inflationMin !== undefined && (obj.inflationMin = message.inflationMin);
        message.goalBonded !== undefined && (obj.goalBonded = message.goalBonded);
        message.blocksPerYear !== undefined &&
            (obj.blocksPerYear = (message.blocksPerYear || long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e;
        const message = createBaseParams();
        message.mintDenom = (_a = object.mintDenom) !== null && _a !== void 0 ? _a : "";
        message.inflationRateChange = (_b = object.inflationRateChange) !== null && _b !== void 0 ? _b : "";
        message.inflationMax = (_c = object.inflationMax) !== null && _c !== void 0 ? _c : "";
        message.inflationMin = (_d = object.inflationMin) !== null && _d !== void 0 ? _d : "";
        message.goalBonded = (_e = object.goalBonded) !== null && _e !== void 0 ? _e : "";
        message.blocksPerYear =
            object.blocksPerYear !== undefined && object.blocksPerYear !== null
                ? long_1.default.fromValue(object.blocksPerYear)
                : long_1.default.UZERO;
        return message;
    },
};
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=mint.js.map

/***/ }),

/***/ 83246:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.QueryClientImpl = exports.QueryAnnualProvisionsResponse = exports.QueryAnnualProvisionsRequest = exports.QueryInflationResponse = exports.QueryInflationRequest = exports.QueryParamsResponse = exports.QueryParamsRequest = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(__webpack_require__(47873));
const minimal_1 = __importDefault(__webpack_require__(62100));
const mint_1 = __webpack_require__(57652);
exports.protobufPackage = "cosmos.mint.v1beta1";
function createBaseQueryParamsRequest() {
    return {};
}
exports.QueryParamsRequest = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryParamsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseQueryParamsRequest();
        return message;
    },
};
function createBaseQueryParamsResponse() {
    return { params: undefined };
}
exports.QueryParamsResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.params !== undefined) {
            mint_1.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryParamsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.params = mint_1.Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { params: isSet(object.params) ? mint_1.Params.fromJSON(object.params) : undefined };
    },
    toJSON(message) {
        const obj = {};
        message.params !== undefined && (obj.params = message.params ? mint_1.Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryParamsResponse();
        message.params =
            object.params !== undefined && object.params !== null ? mint_1.Params.fromPartial(object.params) : undefined;
        return message;
    },
};
function createBaseQueryInflationRequest() {
    return {};
}
exports.QueryInflationRequest = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryInflationRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseQueryInflationRequest();
        return message;
    },
};
function createBaseQueryInflationResponse() {
    return { inflation: new Uint8Array() };
}
exports.QueryInflationResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.inflation.length !== 0) {
            writer.uint32(10).bytes(message.inflation);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryInflationResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.inflation = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { inflation: isSet(object.inflation) ? bytesFromBase64(object.inflation) : new Uint8Array() };
    },
    toJSON(message) {
        const obj = {};
        message.inflation !== undefined &&
            (obj.inflation = base64FromBytes(message.inflation !== undefined ? message.inflation : new Uint8Array()));
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryInflationResponse();
        message.inflation = (_a = object.inflation) !== null && _a !== void 0 ? _a : new Uint8Array();
        return message;
    },
};
function createBaseQueryAnnualProvisionsRequest() {
    return {};
}
exports.QueryAnnualProvisionsRequest = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryAnnualProvisionsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseQueryAnnualProvisionsRequest();
        return message;
    },
};
function createBaseQueryAnnualProvisionsResponse() {
    return { annualProvisions: new Uint8Array() };
}
exports.QueryAnnualProvisionsResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.annualProvisions.length !== 0) {
            writer.uint32(10).bytes(message.annualProvisions);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryAnnualProvisionsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.annualProvisions = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            annualProvisions: isSet(object.annualProvisions)
                ? bytesFromBase64(object.annualProvisions)
                : new Uint8Array(),
        };
    },
    toJSON(message) {
        const obj = {};
        message.annualProvisions !== undefined &&
            (obj.annualProvisions = base64FromBytes(message.annualProvisions !== undefined ? message.annualProvisions : new Uint8Array()));
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryAnnualProvisionsResponse();
        message.annualProvisions = (_a = object.annualProvisions) !== null && _a !== void 0 ? _a : new Uint8Array();
        return message;
    },
};
class QueryClientImpl {
    constructor(rpc) {
        this.rpc = rpc;
        this.Params = this.Params.bind(this);
        this.Inflation = this.Inflation.bind(this);
        this.AnnualProvisions = this.AnnualProvisions.bind(this);
    }
    Params(request) {
        const data = exports.QueryParamsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.mint.v1beta1.Query", "Params", data);
        return promise.then((data) => exports.QueryParamsResponse.decode(new minimal_1.default.Reader(data)));
    }
    Inflation(request) {
        const data = exports.QueryInflationRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.mint.v1beta1.Query", "Inflation", data);
        return promise.then((data) => exports.QueryInflationResponse.decode(new minimal_1.default.Reader(data)));
    }
    AnnualProvisions(request) {
        const data = exports.QueryAnnualProvisionsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.mint.v1beta1.Query", "AnnualProvisions", data);
        return promise.then((data) => exports.QueryAnnualProvisionsResponse.decode(new minimal_1.default.Reader(data)));
    }
}
exports.QueryClientImpl = QueryClientImpl;
var globalThis = (() => {
    if (typeof globalThis !== "undefined") {
        return globalThis;
    }
    if (typeof self !== "undefined") {
        return self;
    }
    if (typeof window !== "undefined") {
        return window;
    }
    if (typeof __webpack_require__.g !== "undefined") {
        return __webpack_require__.g;
    }
    throw "Unable to locate global object";
})();
function bytesFromBase64(b64) {
    if (globalThis.Buffer) {
        return Uint8Array.from(globalThis.Buffer.from(b64, "base64"));
    }
    else {
        const bin = globalThis.atob(b64);
        const arr = new Uint8Array(bin.length);
        for (let i = 0; i < bin.length; ++i) {
            arr[i] = bin.charCodeAt(i);
        }
        return arr;
    }
}
function base64FromBytes(arr) {
    if (globalThis.Buffer) {
        return globalThis.Buffer.from(arr).toString("base64");
    }
    else {
        const bin = [];
        arr.forEach((byte) => {
            bin.push(String.fromCharCode(byte));
        });
        return globalThis.btoa(bin.join(""));
    }
}
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=query.js.map

/***/ }),

/***/ 25252:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.QueryClientImpl = exports.QuerySigningInfosResponse = exports.QuerySigningInfosRequest = exports.QuerySigningInfoResponse = exports.QuerySigningInfoRequest = exports.QueryParamsResponse = exports.QueryParamsRequest = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(__webpack_require__(47873));
const minimal_1 = __importDefault(__webpack_require__(62100));
const pagination_1 = __webpack_require__(62635);
const slashing_1 = __webpack_require__(18073);
exports.protobufPackage = "cosmos.slashing.v1beta1";
function createBaseQueryParamsRequest() {
    return {};
}
exports.QueryParamsRequest = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryParamsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseQueryParamsRequest();
        return message;
    },
};
function createBaseQueryParamsResponse() {
    return { params: undefined };
}
exports.QueryParamsResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.params !== undefined) {
            slashing_1.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryParamsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.params = slashing_1.Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { params: isSet(object.params) ? slashing_1.Params.fromJSON(object.params) : undefined };
    },
    toJSON(message) {
        const obj = {};
        message.params !== undefined && (obj.params = message.params ? slashing_1.Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryParamsResponse();
        message.params =
            object.params !== undefined && object.params !== null ? slashing_1.Params.fromPartial(object.params) : undefined;
        return message;
    },
};
function createBaseQuerySigningInfoRequest() {
    return { consAddress: "" };
}
exports.QuerySigningInfoRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.consAddress !== "") {
            writer.uint32(10).string(message.consAddress);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQuerySigningInfoRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.consAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { consAddress: isSet(object.consAddress) ? String(object.consAddress) : "" };
    },
    toJSON(message) {
        const obj = {};
        message.consAddress !== undefined && (obj.consAddress = message.consAddress);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQuerySigningInfoRequest();
        message.consAddress = (_a = object.consAddress) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
function createBaseQuerySigningInfoResponse() {
    return { valSigningInfo: undefined };
}
exports.QuerySigningInfoResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.valSigningInfo !== undefined) {
            slashing_1.ValidatorSigningInfo.encode(message.valSigningInfo, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQuerySigningInfoResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.valSigningInfo = slashing_1.ValidatorSigningInfo.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            valSigningInfo: isSet(object.valSigningInfo)
                ? slashing_1.ValidatorSigningInfo.fromJSON(object.valSigningInfo)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.valSigningInfo !== undefined &&
            (obj.valSigningInfo = message.valSigningInfo
                ? slashing_1.ValidatorSigningInfo.toJSON(message.valSigningInfo)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQuerySigningInfoResponse();
        message.valSigningInfo =
            object.valSigningInfo !== undefined && object.valSigningInfo !== null
                ? slashing_1.ValidatorSigningInfo.fromPartial(object.valSigningInfo)
                : undefined;
        return message;
    },
};
function createBaseQuerySigningInfosRequest() {
    return { pagination: undefined };
}
exports.QuerySigningInfosRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQuerySigningInfosRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { pagination: isSet(object.pagination) ? pagination_1.PageRequest.fromJSON(object.pagination) : undefined };
    },
    toJSON(message) {
        const obj = {};
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQuerySigningInfosRequest();
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQuerySigningInfosResponse() {
    return { info: [], pagination: undefined };
}
exports.QuerySigningInfosResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.info) {
            slashing_1.ValidatorSigningInfo.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQuerySigningInfosResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.info.push(slashing_1.ValidatorSigningInfo.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            info: Array.isArray(object === null || object === void 0 ? void 0 : object.info) ? object.info.map((e) => slashing_1.ValidatorSigningInfo.fromJSON(e)) : [],
            pagination: isSet(object.pagination) ? pagination_1.PageResponse.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.info) {
            obj.info = message.info.map((e) => (e ? slashing_1.ValidatorSigningInfo.toJSON(e) : undefined));
        }
        else {
            obj.info = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQuerySigningInfosResponse();
        message.info = ((_a = object.info) === null || _a === void 0 ? void 0 : _a.map((e) => slashing_1.ValidatorSigningInfo.fromPartial(e))) || [];
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
class QueryClientImpl {
    constructor(rpc) {
        this.rpc = rpc;
        this.Params = this.Params.bind(this);
        this.SigningInfo = this.SigningInfo.bind(this);
        this.SigningInfos = this.SigningInfos.bind(this);
    }
    Params(request) {
        const data = exports.QueryParamsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.slashing.v1beta1.Query", "Params", data);
        return promise.then((data) => exports.QueryParamsResponse.decode(new minimal_1.default.Reader(data)));
    }
    SigningInfo(request) {
        const data = exports.QuerySigningInfoRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.slashing.v1beta1.Query", "SigningInfo", data);
        return promise.then((data) => exports.QuerySigningInfoResponse.decode(new minimal_1.default.Reader(data)));
    }
    SigningInfos(request) {
        const data = exports.QuerySigningInfosRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.slashing.v1beta1.Query", "SigningInfos", data);
        return promise.then((data) => exports.QuerySigningInfosResponse.decode(new minimal_1.default.Reader(data)));
    }
}
exports.QueryClientImpl = QueryClientImpl;
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=query.js.map

/***/ }),

/***/ 18073:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Params = exports.ValidatorSigningInfo = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(__webpack_require__(47873));
const minimal_1 = __importDefault(__webpack_require__(62100));
const duration_1 = __webpack_require__(59769);
const timestamp_1 = __webpack_require__(76620);
exports.protobufPackage = "cosmos.slashing.v1beta1";
function createBaseValidatorSigningInfo() {
    return {
        address: "",
        startHeight: long_1.default.ZERO,
        indexOffset: long_1.default.ZERO,
        jailedUntil: undefined,
        tombstoned: false,
        missedBlocksCounter: long_1.default.ZERO,
    };
}
exports.ValidatorSigningInfo = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.address !== "") {
            writer.uint32(10).string(message.address);
        }
        if (!message.startHeight.isZero()) {
            writer.uint32(16).int64(message.startHeight);
        }
        if (!message.indexOffset.isZero()) {
            writer.uint32(24).int64(message.indexOffset);
        }
        if (message.jailedUntil !== undefined) {
            timestamp_1.Timestamp.encode(message.jailedUntil, writer.uint32(34).fork()).ldelim();
        }
        if (message.tombstoned === true) {
            writer.uint32(40).bool(message.tombstoned);
        }
        if (!message.missedBlocksCounter.isZero()) {
            writer.uint32(48).int64(message.missedBlocksCounter);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseValidatorSigningInfo();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.startHeight = reader.int64();
                    break;
                case 3:
                    message.indexOffset = reader.int64();
                    break;
                case 4:
                    message.jailedUntil = timestamp_1.Timestamp.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.tombstoned = reader.bool();
                    break;
                case 6:
                    message.missedBlocksCounter = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            address: isSet(object.address) ? String(object.address) : "",
            startHeight: isSet(object.startHeight) ? long_1.default.fromValue(object.startHeight) : long_1.default.ZERO,
            indexOffset: isSet(object.indexOffset) ? long_1.default.fromValue(object.indexOffset) : long_1.default.ZERO,
            jailedUntil: isSet(object.jailedUntil) ? fromJsonTimestamp(object.jailedUntil) : undefined,
            tombstoned: isSet(object.tombstoned) ? Boolean(object.tombstoned) : false,
            missedBlocksCounter: isSet(object.missedBlocksCounter)
                ? long_1.default.fromValue(object.missedBlocksCounter)
                : long_1.default.ZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.startHeight !== undefined && (obj.startHeight = (message.startHeight || long_1.default.ZERO).toString());
        message.indexOffset !== undefined && (obj.indexOffset = (message.indexOffset || long_1.default.ZERO).toString());
        message.jailedUntil !== undefined && (obj.jailedUntil = fromTimestamp(message.jailedUntil).toISOString());
        message.tombstoned !== undefined && (obj.tombstoned = message.tombstoned);
        message.missedBlocksCounter !== undefined &&
            (obj.missedBlocksCounter = (message.missedBlocksCounter || long_1.default.ZERO).toString());
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseValidatorSigningInfo();
        message.address = (_a = object.address) !== null && _a !== void 0 ? _a : "";
        message.startHeight =
            object.startHeight !== undefined && object.startHeight !== null
                ? long_1.default.fromValue(object.startHeight)
                : long_1.default.ZERO;
        message.indexOffset =
            object.indexOffset !== undefined && object.indexOffset !== null
                ? long_1.default.fromValue(object.indexOffset)
                : long_1.default.ZERO;
        message.jailedUntil =
            object.jailedUntil !== undefined && object.jailedUntil !== null
                ? timestamp_1.Timestamp.fromPartial(object.jailedUntil)
                : undefined;
        message.tombstoned = (_b = object.tombstoned) !== null && _b !== void 0 ? _b : false;
        message.missedBlocksCounter =
            object.missedBlocksCounter !== undefined && object.missedBlocksCounter !== null
                ? long_1.default.fromValue(object.missedBlocksCounter)
                : long_1.default.ZERO;
        return message;
    },
};
function createBaseParams() {
    return {
        signedBlocksWindow: long_1.default.ZERO,
        minSignedPerWindow: new Uint8Array(),
        downtimeJailDuration: undefined,
        slashFractionDoubleSign: new Uint8Array(),
        slashFractionDowntime: new Uint8Array(),
    };
}
exports.Params = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (!message.signedBlocksWindow.isZero()) {
            writer.uint32(8).int64(message.signedBlocksWindow);
        }
        if (message.minSignedPerWindow.length !== 0) {
            writer.uint32(18).bytes(message.minSignedPerWindow);
        }
        if (message.downtimeJailDuration !== undefined) {
            duration_1.Duration.encode(message.downtimeJailDuration, writer.uint32(26).fork()).ldelim();
        }
        if (message.slashFractionDoubleSign.length !== 0) {
            writer.uint32(34).bytes(message.slashFractionDoubleSign);
        }
        if (message.slashFractionDowntime.length !== 0) {
            writer.uint32(42).bytes(message.slashFractionDowntime);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseParams();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.signedBlocksWindow = reader.int64();
                    break;
                case 2:
                    message.minSignedPerWindow = reader.bytes();
                    break;
                case 3:
                    message.downtimeJailDuration = duration_1.Duration.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.slashFractionDoubleSign = reader.bytes();
                    break;
                case 5:
                    message.slashFractionDowntime = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            signedBlocksWindow: isSet(object.signedBlocksWindow)
                ? long_1.default.fromValue(object.signedBlocksWindow)
                : long_1.default.ZERO,
            minSignedPerWindow: isSet(object.minSignedPerWindow)
                ? bytesFromBase64(object.minSignedPerWindow)
                : new Uint8Array(),
            downtimeJailDuration: isSet(object.downtimeJailDuration)
                ? duration_1.Duration.fromJSON(object.downtimeJailDuration)
                : undefined,
            slashFractionDoubleSign: isSet(object.slashFractionDoubleSign)
                ? bytesFromBase64(object.slashFractionDoubleSign)
                : new Uint8Array(),
            slashFractionDowntime: isSet(object.slashFractionDowntime)
                ? bytesFromBase64(object.slashFractionDowntime)
                : new Uint8Array(),
        };
    },
    toJSON(message) {
        const obj = {};
        message.signedBlocksWindow !== undefined &&
            (obj.signedBlocksWindow = (message.signedBlocksWindow || long_1.default.ZERO).toString());
        message.minSignedPerWindow !== undefined &&
            (obj.minSignedPerWindow = base64FromBytes(message.minSignedPerWindow !== undefined ? message.minSignedPerWindow : new Uint8Array()));
        message.downtimeJailDuration !== undefined &&
            (obj.downtimeJailDuration = message.downtimeJailDuration
                ? duration_1.Duration.toJSON(message.downtimeJailDuration)
                : undefined);
        message.slashFractionDoubleSign !== undefined &&
            (obj.slashFractionDoubleSign = base64FromBytes(message.slashFractionDoubleSign !== undefined ? message.slashFractionDoubleSign : new Uint8Array()));
        message.slashFractionDowntime !== undefined &&
            (obj.slashFractionDowntime = base64FromBytes(message.slashFractionDowntime !== undefined ? message.slashFractionDowntime : new Uint8Array()));
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseParams();
        message.signedBlocksWindow =
            object.signedBlocksWindow !== undefined && object.signedBlocksWindow !== null
                ? long_1.default.fromValue(object.signedBlocksWindow)
                : long_1.default.ZERO;
        message.minSignedPerWindow = (_a = object.minSignedPerWindow) !== null && _a !== void 0 ? _a : new Uint8Array();
        message.downtimeJailDuration =
            object.downtimeJailDuration !== undefined && object.downtimeJailDuration !== null
                ? duration_1.Duration.fromPartial(object.downtimeJailDuration)
                : undefined;
        message.slashFractionDoubleSign = (_b = object.slashFractionDoubleSign) !== null && _b !== void 0 ? _b : new Uint8Array();
        message.slashFractionDowntime = (_c = object.slashFractionDowntime) !== null && _c !== void 0 ? _c : new Uint8Array();
        return message;
    },
};
var globalThis = (() => {
    if (typeof globalThis !== "undefined") {
        return globalThis;
    }
    if (typeof self !== "undefined") {
        return self;
    }
    if (typeof window !== "undefined") {
        return window;
    }
    if (typeof __webpack_require__.g !== "undefined") {
        return __webpack_require__.g;
    }
    throw "Unable to locate global object";
})();
function bytesFromBase64(b64) {
    if (globalThis.Buffer) {
        return Uint8Array.from(globalThis.Buffer.from(b64, "base64"));
    }
    else {
        const bin = globalThis.atob(b64);
        const arr = new Uint8Array(bin.length);
        for (let i = 0; i < bin.length; ++i) {
            arr[i] = bin.charCodeAt(i);
        }
        return arr;
    }
}
function base64FromBytes(arr) {
    if (globalThis.Buffer) {
        return globalThis.Buffer.from(arr).toString("base64");
    }
    else {
        const bin = [];
        arr.forEach((byte) => {
            bin.push(String.fromCharCode(byte));
        });
        return globalThis.btoa(bin.join(""));
    }
}
function toTimestamp(date) {
    const seconds = numberToLong(date.getTime() / 1000);
    const nanos = (date.getTime() % 1000) * 1000000;
    return { seconds, nanos };
}
function fromTimestamp(t) {
    let millis = t.seconds.toNumber() * 1000;
    millis += t.nanos / 1000000;
    return new Date(millis);
}
function fromJsonTimestamp(o) {
    if (o instanceof Date) {
        return toTimestamp(o);
    }
    else if (typeof o === "string") {
        return toTimestamp(new Date(o));
    }
    else {
        return timestamp_1.Timestamp.fromJSON(o);
    }
}
function numberToLong(number) {
    return long_1.default.fromNumber(number);
}
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=slashing.js.map

/***/ }),

/***/ 34082:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.QueryClientImpl = exports.QueryParamsResponse = exports.QueryParamsRequest = exports.QueryPoolResponse = exports.QueryPoolRequest = exports.QueryHistoricalInfoResponse = exports.QueryHistoricalInfoRequest = exports.QueryDelegatorValidatorResponse = exports.QueryDelegatorValidatorRequest = exports.QueryDelegatorValidatorsResponse = exports.QueryDelegatorValidatorsRequest = exports.QueryRedelegationsResponse = exports.QueryRedelegationsRequest = exports.QueryDelegatorUnbondingDelegationsResponse = exports.QueryDelegatorUnbondingDelegationsRequest = exports.QueryDelegatorDelegationsResponse = exports.QueryDelegatorDelegationsRequest = exports.QueryUnbondingDelegationResponse = exports.QueryUnbondingDelegationRequest = exports.QueryDelegationResponse = exports.QueryDelegationRequest = exports.QueryValidatorUnbondingDelegationsResponse = exports.QueryValidatorUnbondingDelegationsRequest = exports.QueryValidatorDelegationsResponse = exports.QueryValidatorDelegationsRequest = exports.QueryValidatorResponse = exports.QueryValidatorRequest = exports.QueryValidatorsResponse = exports.QueryValidatorsRequest = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(__webpack_require__(47873));
const minimal_1 = __importDefault(__webpack_require__(62100));
const pagination_1 = __webpack_require__(62635);
const staking_1 = __webpack_require__(59992);
exports.protobufPackage = "cosmos.staking.v1beta1";
function createBaseQueryValidatorsRequest() {
    return { status: "", pagination: undefined };
}
exports.QueryValidatorsRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.status !== "") {
            writer.uint32(10).string(message.status);
        }
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryValidatorsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.status = reader.string();
                    break;
                case 2:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            status: isSet(object.status) ? String(object.status) : "",
            pagination: isSet(object.pagination) ? pagination_1.PageRequest.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.status !== undefined && (obj.status = message.status);
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryValidatorsRequest();
        message.status = (_a = object.status) !== null && _a !== void 0 ? _a : "";
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryValidatorsResponse() {
    return { validators: [], pagination: undefined };
}
exports.QueryValidatorsResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.validators) {
            staking_1.Validator.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryValidatorsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.validators.push(staking_1.Validator.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            validators: Array.isArray(object === null || object === void 0 ? void 0 : object.validators)
                ? object.validators.map((e) => staking_1.Validator.fromJSON(e))
                : [],
            pagination: isSet(object.pagination) ? pagination_1.PageResponse.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.validators) {
            obj.validators = message.validators.map((e) => (e ? staking_1.Validator.toJSON(e) : undefined));
        }
        else {
            obj.validators = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryValidatorsResponse();
        message.validators = ((_a = object.validators) === null || _a === void 0 ? void 0 : _a.map((e) => staking_1.Validator.fromPartial(e))) || [];
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryValidatorRequest() {
    return { validatorAddr: "" };
}
exports.QueryValidatorRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.validatorAddr !== "") {
            writer.uint32(10).string(message.validatorAddr);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryValidatorRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.validatorAddr = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { validatorAddr: isSet(object.validatorAddr) ? String(object.validatorAddr) : "" };
    },
    toJSON(message) {
        const obj = {};
        message.validatorAddr !== undefined && (obj.validatorAddr = message.validatorAddr);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryValidatorRequest();
        message.validatorAddr = (_a = object.validatorAddr) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
function createBaseQueryValidatorResponse() {
    return { validator: undefined };
}
exports.QueryValidatorResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.validator !== undefined) {
            staking_1.Validator.encode(message.validator, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryValidatorResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.validator = staking_1.Validator.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { validator: isSet(object.validator) ? staking_1.Validator.fromJSON(object.validator) : undefined };
    },
    toJSON(message) {
        const obj = {};
        message.validator !== undefined &&
            (obj.validator = message.validator ? staking_1.Validator.toJSON(message.validator) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryValidatorResponse();
        message.validator =
            object.validator !== undefined && object.validator !== null
                ? staking_1.Validator.fromPartial(object.validator)
                : undefined;
        return message;
    },
};
function createBaseQueryValidatorDelegationsRequest() {
    return { validatorAddr: "", pagination: undefined };
}
exports.QueryValidatorDelegationsRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.validatorAddr !== "") {
            writer.uint32(10).string(message.validatorAddr);
        }
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryValidatorDelegationsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.validatorAddr = reader.string();
                    break;
                case 2:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            validatorAddr: isSet(object.validatorAddr) ? String(object.validatorAddr) : "",
            pagination: isSet(object.pagination) ? pagination_1.PageRequest.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.validatorAddr !== undefined && (obj.validatorAddr = message.validatorAddr);
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryValidatorDelegationsRequest();
        message.validatorAddr = (_a = object.validatorAddr) !== null && _a !== void 0 ? _a : "";
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryValidatorDelegationsResponse() {
    return { delegationResponses: [], pagination: undefined };
}
exports.QueryValidatorDelegationsResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.delegationResponses) {
            staking_1.DelegationResponse.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryValidatorDelegationsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.delegationResponses.push(staking_1.DelegationResponse.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            delegationResponses: Array.isArray(object === null || object === void 0 ? void 0 : object.delegationResponses)
                ? object.delegationResponses.map((e) => staking_1.DelegationResponse.fromJSON(e))
                : [],
            pagination: isSet(object.pagination) ? pagination_1.PageResponse.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.delegationResponses) {
            obj.delegationResponses = message.delegationResponses.map((e) => e ? staking_1.DelegationResponse.toJSON(e) : undefined);
        }
        else {
            obj.delegationResponses = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryValidatorDelegationsResponse();
        message.delegationResponses =
            ((_a = object.delegationResponses) === null || _a === void 0 ? void 0 : _a.map((e) => staking_1.DelegationResponse.fromPartial(e))) || [];
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryValidatorUnbondingDelegationsRequest() {
    return { validatorAddr: "", pagination: undefined };
}
exports.QueryValidatorUnbondingDelegationsRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.validatorAddr !== "") {
            writer.uint32(10).string(message.validatorAddr);
        }
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryValidatorUnbondingDelegationsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.validatorAddr = reader.string();
                    break;
                case 2:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            validatorAddr: isSet(object.validatorAddr) ? String(object.validatorAddr) : "",
            pagination: isSet(object.pagination) ? pagination_1.PageRequest.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.validatorAddr !== undefined && (obj.validatorAddr = message.validatorAddr);
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryValidatorUnbondingDelegationsRequest();
        message.validatorAddr = (_a = object.validatorAddr) !== null && _a !== void 0 ? _a : "";
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryValidatorUnbondingDelegationsResponse() {
    return { unbondingResponses: [], pagination: undefined };
}
exports.QueryValidatorUnbondingDelegationsResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.unbondingResponses) {
            staking_1.UnbondingDelegation.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryValidatorUnbondingDelegationsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.unbondingResponses.push(staking_1.UnbondingDelegation.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            unbondingResponses: Array.isArray(object === null || object === void 0 ? void 0 : object.unbondingResponses)
                ? object.unbondingResponses.map((e) => staking_1.UnbondingDelegation.fromJSON(e))
                : [],
            pagination: isSet(object.pagination) ? pagination_1.PageResponse.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.unbondingResponses) {
            obj.unbondingResponses = message.unbondingResponses.map((e) => e ? staking_1.UnbondingDelegation.toJSON(e) : undefined);
        }
        else {
            obj.unbondingResponses = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryValidatorUnbondingDelegationsResponse();
        message.unbondingResponses =
            ((_a = object.unbondingResponses) === null || _a === void 0 ? void 0 : _a.map((e) => staking_1.UnbondingDelegation.fromPartial(e))) || [];
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryDelegationRequest() {
    return { delegatorAddr: "", validatorAddr: "" };
}
exports.QueryDelegationRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.delegatorAddr !== "") {
            writer.uint32(10).string(message.delegatorAddr);
        }
        if (message.validatorAddr !== "") {
            writer.uint32(18).string(message.validatorAddr);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryDelegationRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.delegatorAddr = reader.string();
                    break;
                case 2:
                    message.validatorAddr = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            delegatorAddr: isSet(object.delegatorAddr) ? String(object.delegatorAddr) : "",
            validatorAddr: isSet(object.validatorAddr) ? String(object.validatorAddr) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.delegatorAddr !== undefined && (obj.delegatorAddr = message.delegatorAddr);
        message.validatorAddr !== undefined && (obj.validatorAddr = message.validatorAddr);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseQueryDelegationRequest();
        message.delegatorAddr = (_a = object.delegatorAddr) !== null && _a !== void 0 ? _a : "";
        message.validatorAddr = (_b = object.validatorAddr) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
function createBaseQueryDelegationResponse() {
    return { delegationResponse: undefined };
}
exports.QueryDelegationResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.delegationResponse !== undefined) {
            staking_1.DelegationResponse.encode(message.delegationResponse, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryDelegationResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.delegationResponse = staking_1.DelegationResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            delegationResponse: isSet(object.delegationResponse)
                ? staking_1.DelegationResponse.fromJSON(object.delegationResponse)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.delegationResponse !== undefined &&
            (obj.delegationResponse = message.delegationResponse
                ? staking_1.DelegationResponse.toJSON(message.delegationResponse)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryDelegationResponse();
        message.delegationResponse =
            object.delegationResponse !== undefined && object.delegationResponse !== null
                ? staking_1.DelegationResponse.fromPartial(object.delegationResponse)
                : undefined;
        return message;
    },
};
function createBaseQueryUnbondingDelegationRequest() {
    return { delegatorAddr: "", validatorAddr: "" };
}
exports.QueryUnbondingDelegationRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.delegatorAddr !== "") {
            writer.uint32(10).string(message.delegatorAddr);
        }
        if (message.validatorAddr !== "") {
            writer.uint32(18).string(message.validatorAddr);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryUnbondingDelegationRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.delegatorAddr = reader.string();
                    break;
                case 2:
                    message.validatorAddr = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            delegatorAddr: isSet(object.delegatorAddr) ? String(object.delegatorAddr) : "",
            validatorAddr: isSet(object.validatorAddr) ? String(object.validatorAddr) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.delegatorAddr !== undefined && (obj.delegatorAddr = message.delegatorAddr);
        message.validatorAddr !== undefined && (obj.validatorAddr = message.validatorAddr);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseQueryUnbondingDelegationRequest();
        message.delegatorAddr = (_a = object.delegatorAddr) !== null && _a !== void 0 ? _a : "";
        message.validatorAddr = (_b = object.validatorAddr) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
function createBaseQueryUnbondingDelegationResponse() {
    return { unbond: undefined };
}
exports.QueryUnbondingDelegationResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.unbond !== undefined) {
            staking_1.UnbondingDelegation.encode(message.unbond, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryUnbondingDelegationResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.unbond = staking_1.UnbondingDelegation.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { unbond: isSet(object.unbond) ? staking_1.UnbondingDelegation.fromJSON(object.unbond) : undefined };
    },
    toJSON(message) {
        const obj = {};
        message.unbond !== undefined &&
            (obj.unbond = message.unbond ? staking_1.UnbondingDelegation.toJSON(message.unbond) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryUnbondingDelegationResponse();
        message.unbond =
            object.unbond !== undefined && object.unbond !== null
                ? staking_1.UnbondingDelegation.fromPartial(object.unbond)
                : undefined;
        return message;
    },
};
function createBaseQueryDelegatorDelegationsRequest() {
    return { delegatorAddr: "", pagination: undefined };
}
exports.QueryDelegatorDelegationsRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.delegatorAddr !== "") {
            writer.uint32(10).string(message.delegatorAddr);
        }
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryDelegatorDelegationsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.delegatorAddr = reader.string();
                    break;
                case 2:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            delegatorAddr: isSet(object.delegatorAddr) ? String(object.delegatorAddr) : "",
            pagination: isSet(object.pagination) ? pagination_1.PageRequest.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.delegatorAddr !== undefined && (obj.delegatorAddr = message.delegatorAddr);
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryDelegatorDelegationsRequest();
        message.delegatorAddr = (_a = object.delegatorAddr) !== null && _a !== void 0 ? _a : "";
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryDelegatorDelegationsResponse() {
    return { delegationResponses: [], pagination: undefined };
}
exports.QueryDelegatorDelegationsResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.delegationResponses) {
            staking_1.DelegationResponse.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryDelegatorDelegationsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.delegationResponses.push(staking_1.DelegationResponse.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            delegationResponses: Array.isArray(object === null || object === void 0 ? void 0 : object.delegationResponses)
                ? object.delegationResponses.map((e) => staking_1.DelegationResponse.fromJSON(e))
                : [],
            pagination: isSet(object.pagination) ? pagination_1.PageResponse.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.delegationResponses) {
            obj.delegationResponses = message.delegationResponses.map((e) => e ? staking_1.DelegationResponse.toJSON(e) : undefined);
        }
        else {
            obj.delegationResponses = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryDelegatorDelegationsResponse();
        message.delegationResponses =
            ((_a = object.delegationResponses) === null || _a === void 0 ? void 0 : _a.map((e) => staking_1.DelegationResponse.fromPartial(e))) || [];
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryDelegatorUnbondingDelegationsRequest() {
    return { delegatorAddr: "", pagination: undefined };
}
exports.QueryDelegatorUnbondingDelegationsRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.delegatorAddr !== "") {
            writer.uint32(10).string(message.delegatorAddr);
        }
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryDelegatorUnbondingDelegationsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.delegatorAddr = reader.string();
                    break;
                case 2:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            delegatorAddr: isSet(object.delegatorAddr) ? String(object.delegatorAddr) : "",
            pagination: isSet(object.pagination) ? pagination_1.PageRequest.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.delegatorAddr !== undefined && (obj.delegatorAddr = message.delegatorAddr);
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryDelegatorUnbondingDelegationsRequest();
        message.delegatorAddr = (_a = object.delegatorAddr) !== null && _a !== void 0 ? _a : "";
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryDelegatorUnbondingDelegationsResponse() {
    return { unbondingResponses: [], pagination: undefined };
}
exports.QueryDelegatorUnbondingDelegationsResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.unbondingResponses) {
            staking_1.UnbondingDelegation.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryDelegatorUnbondingDelegationsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.unbondingResponses.push(staking_1.UnbondingDelegation.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            unbondingResponses: Array.isArray(object === null || object === void 0 ? void 0 : object.unbondingResponses)
                ? object.unbondingResponses.map((e) => staking_1.UnbondingDelegation.fromJSON(e))
                : [],
            pagination: isSet(object.pagination) ? pagination_1.PageResponse.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.unbondingResponses) {
            obj.unbondingResponses = message.unbondingResponses.map((e) => e ? staking_1.UnbondingDelegation.toJSON(e) : undefined);
        }
        else {
            obj.unbondingResponses = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryDelegatorUnbondingDelegationsResponse();
        message.unbondingResponses =
            ((_a = object.unbondingResponses) === null || _a === void 0 ? void 0 : _a.map((e) => staking_1.UnbondingDelegation.fromPartial(e))) || [];
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryRedelegationsRequest() {
    return { delegatorAddr: "", srcValidatorAddr: "", dstValidatorAddr: "", pagination: undefined };
}
exports.QueryRedelegationsRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.delegatorAddr !== "") {
            writer.uint32(10).string(message.delegatorAddr);
        }
        if (message.srcValidatorAddr !== "") {
            writer.uint32(18).string(message.srcValidatorAddr);
        }
        if (message.dstValidatorAddr !== "") {
            writer.uint32(26).string(message.dstValidatorAddr);
        }
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryRedelegationsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.delegatorAddr = reader.string();
                    break;
                case 2:
                    message.srcValidatorAddr = reader.string();
                    break;
                case 3:
                    message.dstValidatorAddr = reader.string();
                    break;
                case 4:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            delegatorAddr: isSet(object.delegatorAddr) ? String(object.delegatorAddr) : "",
            srcValidatorAddr: isSet(object.srcValidatorAddr) ? String(object.srcValidatorAddr) : "",
            dstValidatorAddr: isSet(object.dstValidatorAddr) ? String(object.dstValidatorAddr) : "",
            pagination: isSet(object.pagination) ? pagination_1.PageRequest.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.delegatorAddr !== undefined && (obj.delegatorAddr = message.delegatorAddr);
        message.srcValidatorAddr !== undefined && (obj.srcValidatorAddr = message.srcValidatorAddr);
        message.dstValidatorAddr !== undefined && (obj.dstValidatorAddr = message.dstValidatorAddr);
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseQueryRedelegationsRequest();
        message.delegatorAddr = (_a = object.delegatorAddr) !== null && _a !== void 0 ? _a : "";
        message.srcValidatorAddr = (_b = object.srcValidatorAddr) !== null && _b !== void 0 ? _b : "";
        message.dstValidatorAddr = (_c = object.dstValidatorAddr) !== null && _c !== void 0 ? _c : "";
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryRedelegationsResponse() {
    return { redelegationResponses: [], pagination: undefined };
}
exports.QueryRedelegationsResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.redelegationResponses) {
            staking_1.RedelegationResponse.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryRedelegationsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.redelegationResponses.push(staking_1.RedelegationResponse.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            redelegationResponses: Array.isArray(object === null || object === void 0 ? void 0 : object.redelegationResponses)
                ? object.redelegationResponses.map((e) => staking_1.RedelegationResponse.fromJSON(e))
                : [],
            pagination: isSet(object.pagination) ? pagination_1.PageResponse.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.redelegationResponses) {
            obj.redelegationResponses = message.redelegationResponses.map((e) => e ? staking_1.RedelegationResponse.toJSON(e) : undefined);
        }
        else {
            obj.redelegationResponses = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryRedelegationsResponse();
        message.redelegationResponses =
            ((_a = object.redelegationResponses) === null || _a === void 0 ? void 0 : _a.map((e) => staking_1.RedelegationResponse.fromPartial(e))) || [];
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryDelegatorValidatorsRequest() {
    return { delegatorAddr: "", pagination: undefined };
}
exports.QueryDelegatorValidatorsRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.delegatorAddr !== "") {
            writer.uint32(10).string(message.delegatorAddr);
        }
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryDelegatorValidatorsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.delegatorAddr = reader.string();
                    break;
                case 2:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            delegatorAddr: isSet(object.delegatorAddr) ? String(object.delegatorAddr) : "",
            pagination: isSet(object.pagination) ? pagination_1.PageRequest.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.delegatorAddr !== undefined && (obj.delegatorAddr = message.delegatorAddr);
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryDelegatorValidatorsRequest();
        message.delegatorAddr = (_a = object.delegatorAddr) !== null && _a !== void 0 ? _a : "";
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryDelegatorValidatorsResponse() {
    return { validators: [], pagination: undefined };
}
exports.QueryDelegatorValidatorsResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.validators) {
            staking_1.Validator.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryDelegatorValidatorsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.validators.push(staking_1.Validator.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            validators: Array.isArray(object === null || object === void 0 ? void 0 : object.validators)
                ? object.validators.map((e) => staking_1.Validator.fromJSON(e))
                : [],
            pagination: isSet(object.pagination) ? pagination_1.PageResponse.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.validators) {
            obj.validators = message.validators.map((e) => (e ? staking_1.Validator.toJSON(e) : undefined));
        }
        else {
            obj.validators = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryDelegatorValidatorsResponse();
        message.validators = ((_a = object.validators) === null || _a === void 0 ? void 0 : _a.map((e) => staking_1.Validator.fromPartial(e))) || [];
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryDelegatorValidatorRequest() {
    return { delegatorAddr: "", validatorAddr: "" };
}
exports.QueryDelegatorValidatorRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.delegatorAddr !== "") {
            writer.uint32(10).string(message.delegatorAddr);
        }
        if (message.validatorAddr !== "") {
            writer.uint32(18).string(message.validatorAddr);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryDelegatorValidatorRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.delegatorAddr = reader.string();
                    break;
                case 2:
                    message.validatorAddr = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            delegatorAddr: isSet(object.delegatorAddr) ? String(object.delegatorAddr) : "",
            validatorAddr: isSet(object.validatorAddr) ? String(object.validatorAddr) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.delegatorAddr !== undefined && (obj.delegatorAddr = message.delegatorAddr);
        message.validatorAddr !== undefined && (obj.validatorAddr = message.validatorAddr);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseQueryDelegatorValidatorRequest();
        message.delegatorAddr = (_a = object.delegatorAddr) !== null && _a !== void 0 ? _a : "";
        message.validatorAddr = (_b = object.validatorAddr) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
function createBaseQueryDelegatorValidatorResponse() {
    return { validator: undefined };
}
exports.QueryDelegatorValidatorResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.validator !== undefined) {
            staking_1.Validator.encode(message.validator, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryDelegatorValidatorResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.validator = staking_1.Validator.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { validator: isSet(object.validator) ? staking_1.Validator.fromJSON(object.validator) : undefined };
    },
    toJSON(message) {
        const obj = {};
        message.validator !== undefined &&
            (obj.validator = message.validator ? staking_1.Validator.toJSON(message.validator) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryDelegatorValidatorResponse();
        message.validator =
            object.validator !== undefined && object.validator !== null
                ? staking_1.Validator.fromPartial(object.validator)
                : undefined;
        return message;
    },
};
function createBaseQueryHistoricalInfoRequest() {
    return { height: long_1.default.ZERO };
}
exports.QueryHistoricalInfoRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (!message.height.isZero()) {
            writer.uint32(8).int64(message.height);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryHistoricalInfoRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.height = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { height: isSet(object.height) ? long_1.default.fromValue(object.height) : long_1.default.ZERO };
    },
    toJSON(message) {
        const obj = {};
        message.height !== undefined && (obj.height = (message.height || long_1.default.ZERO).toString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryHistoricalInfoRequest();
        message.height =
            object.height !== undefined && object.height !== null ? long_1.default.fromValue(object.height) : long_1.default.ZERO;
        return message;
    },
};
function createBaseQueryHistoricalInfoResponse() {
    return { hist: undefined };
}
exports.QueryHistoricalInfoResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.hist !== undefined) {
            staking_1.HistoricalInfo.encode(message.hist, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryHistoricalInfoResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.hist = staking_1.HistoricalInfo.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { hist: isSet(object.hist) ? staking_1.HistoricalInfo.fromJSON(object.hist) : undefined };
    },
    toJSON(message) {
        const obj = {};
        message.hist !== undefined && (obj.hist = message.hist ? staking_1.HistoricalInfo.toJSON(message.hist) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryHistoricalInfoResponse();
        message.hist =
            object.hist !== undefined && object.hist !== null ? staking_1.HistoricalInfo.fromPartial(object.hist) : undefined;
        return message;
    },
};
function createBaseQueryPoolRequest() {
    return {};
}
exports.QueryPoolRequest = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryPoolRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseQueryPoolRequest();
        return message;
    },
};
function createBaseQueryPoolResponse() {
    return { pool: undefined };
}
exports.QueryPoolResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.pool !== undefined) {
            staking_1.Pool.encode(message.pool, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryPoolResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.pool = staking_1.Pool.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { pool: isSet(object.pool) ? staking_1.Pool.fromJSON(object.pool) : undefined };
    },
    toJSON(message) {
        const obj = {};
        message.pool !== undefined && (obj.pool = message.pool ? staking_1.Pool.toJSON(message.pool) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryPoolResponse();
        message.pool =
            object.pool !== undefined && object.pool !== null ? staking_1.Pool.fromPartial(object.pool) : undefined;
        return message;
    },
};
function createBaseQueryParamsRequest() {
    return {};
}
exports.QueryParamsRequest = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryParamsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseQueryParamsRequest();
        return message;
    },
};
function createBaseQueryParamsResponse() {
    return { params: undefined };
}
exports.QueryParamsResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.params !== undefined) {
            staking_1.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryParamsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.params = staking_1.Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { params: isSet(object.params) ? staking_1.Params.fromJSON(object.params) : undefined };
    },
    toJSON(message) {
        const obj = {};
        message.params !== undefined && (obj.params = message.params ? staking_1.Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryParamsResponse();
        message.params =
            object.params !== undefined && object.params !== null ? staking_1.Params.fromPartial(object.params) : undefined;
        return message;
    },
};
class QueryClientImpl {
    constructor(rpc) {
        this.rpc = rpc;
        this.Validators = this.Validators.bind(this);
        this.Validator = this.Validator.bind(this);
        this.ValidatorDelegations = this.ValidatorDelegations.bind(this);
        this.ValidatorUnbondingDelegations = this.ValidatorUnbondingDelegations.bind(this);
        this.Delegation = this.Delegation.bind(this);
        this.UnbondingDelegation = this.UnbondingDelegation.bind(this);
        this.DelegatorDelegations = this.DelegatorDelegations.bind(this);
        this.DelegatorUnbondingDelegations = this.DelegatorUnbondingDelegations.bind(this);
        this.Redelegations = this.Redelegations.bind(this);
        this.DelegatorValidators = this.DelegatorValidators.bind(this);
        this.DelegatorValidator = this.DelegatorValidator.bind(this);
        this.HistoricalInfo = this.HistoricalInfo.bind(this);
        this.Pool = this.Pool.bind(this);
        this.Params = this.Params.bind(this);
    }
    Validators(request) {
        const data = exports.QueryValidatorsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Query", "Validators", data);
        return promise.then((data) => exports.QueryValidatorsResponse.decode(new minimal_1.default.Reader(data)));
    }
    Validator(request) {
        const data = exports.QueryValidatorRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Query", "Validator", data);
        return promise.then((data) => exports.QueryValidatorResponse.decode(new minimal_1.default.Reader(data)));
    }
    ValidatorDelegations(request) {
        const data = exports.QueryValidatorDelegationsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Query", "ValidatorDelegations", data);
        return promise.then((data) => exports.QueryValidatorDelegationsResponse.decode(new minimal_1.default.Reader(data)));
    }
    ValidatorUnbondingDelegations(request) {
        const data = exports.QueryValidatorUnbondingDelegationsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Query", "ValidatorUnbondingDelegations", data);
        return promise.then((data) => exports.QueryValidatorUnbondingDelegationsResponse.decode(new minimal_1.default.Reader(data)));
    }
    Delegation(request) {
        const data = exports.QueryDelegationRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Query", "Delegation", data);
        return promise.then((data) => exports.QueryDelegationResponse.decode(new minimal_1.default.Reader(data)));
    }
    UnbondingDelegation(request) {
        const data = exports.QueryUnbondingDelegationRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Query", "UnbondingDelegation", data);
        return promise.then((data) => exports.QueryUnbondingDelegationResponse.decode(new minimal_1.default.Reader(data)));
    }
    DelegatorDelegations(request) {
        const data = exports.QueryDelegatorDelegationsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Query", "DelegatorDelegations", data);
        return promise.then((data) => exports.QueryDelegatorDelegationsResponse.decode(new minimal_1.default.Reader(data)));
    }
    DelegatorUnbondingDelegations(request) {
        const data = exports.QueryDelegatorUnbondingDelegationsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Query", "DelegatorUnbondingDelegations", data);
        return promise.then((data) => exports.QueryDelegatorUnbondingDelegationsResponse.decode(new minimal_1.default.Reader(data)));
    }
    Redelegations(request) {
        const data = exports.QueryRedelegationsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Query", "Redelegations", data);
        return promise.then((data) => exports.QueryRedelegationsResponse.decode(new minimal_1.default.Reader(data)));
    }
    DelegatorValidators(request) {
        const data = exports.QueryDelegatorValidatorsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Query", "DelegatorValidators", data);
        return promise.then((data) => exports.QueryDelegatorValidatorsResponse.decode(new minimal_1.default.Reader(data)));
    }
    DelegatorValidator(request) {
        const data = exports.QueryDelegatorValidatorRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Query", "DelegatorValidator", data);
        return promise.then((data) => exports.QueryDelegatorValidatorResponse.decode(new minimal_1.default.Reader(data)));
    }
    HistoricalInfo(request) {
        const data = exports.QueryHistoricalInfoRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Query", "HistoricalInfo", data);
        return promise.then((data) => exports.QueryHistoricalInfoResponse.decode(new minimal_1.default.Reader(data)));
    }
    Pool(request) {
        const data = exports.QueryPoolRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Query", "Pool", data);
        return promise.then((data) => exports.QueryPoolResponse.decode(new minimal_1.default.Reader(data)));
    }
    Params(request) {
        const data = exports.QueryParamsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Query", "Params", data);
        return promise.then((data) => exports.QueryParamsResponse.decode(new minimal_1.default.Reader(data)));
    }
}
exports.QueryClientImpl = QueryClientImpl;
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=query.js.map

/***/ }),

/***/ 59992:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Pool = exports.RedelegationResponse = exports.RedelegationEntryResponse = exports.DelegationResponse = exports.Params = exports.Redelegation = exports.RedelegationEntry = exports.UnbondingDelegationEntry = exports.UnbondingDelegation = exports.Delegation = exports.DVVTriplets = exports.DVVTriplet = exports.DVPairs = exports.DVPair = exports.ValAddresses = exports.Validator = exports.Description = exports.Commission = exports.CommissionRates = exports.HistoricalInfo = exports.bondStatusToJSON = exports.bondStatusFromJSON = exports.BondStatus = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(__webpack_require__(47873));
const minimal_1 = __importDefault(__webpack_require__(62100));
const any_1 = __webpack_require__(90007);
const duration_1 = __webpack_require__(59769);
const timestamp_1 = __webpack_require__(76620);
const types_1 = __webpack_require__(54028);
const coin_1 = __webpack_require__(26119);
exports.protobufPackage = "cosmos.staking.v1beta1";
/** BondStatus is the status of a validator. */
var BondStatus;
(function (BondStatus) {
    /** BOND_STATUS_UNSPECIFIED - UNSPECIFIED defines an invalid validator status. */
    BondStatus[BondStatus["BOND_STATUS_UNSPECIFIED"] = 0] = "BOND_STATUS_UNSPECIFIED";
    /** BOND_STATUS_UNBONDED - UNBONDED defines a validator that is not bonded. */
    BondStatus[BondStatus["BOND_STATUS_UNBONDED"] = 1] = "BOND_STATUS_UNBONDED";
    /** BOND_STATUS_UNBONDING - UNBONDING defines a validator that is unbonding. */
    BondStatus[BondStatus["BOND_STATUS_UNBONDING"] = 2] = "BOND_STATUS_UNBONDING";
    /** BOND_STATUS_BONDED - BONDED defines a validator that is bonded. */
    BondStatus[BondStatus["BOND_STATUS_BONDED"] = 3] = "BOND_STATUS_BONDED";
    BondStatus[BondStatus["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(BondStatus = exports.BondStatus || (exports.BondStatus = {}));
function bondStatusFromJSON(object) {
    switch (object) {
        case 0:
        case "BOND_STATUS_UNSPECIFIED":
            return BondStatus.BOND_STATUS_UNSPECIFIED;
        case 1:
        case "BOND_STATUS_UNBONDED":
            return BondStatus.BOND_STATUS_UNBONDED;
        case 2:
        case "BOND_STATUS_UNBONDING":
            return BondStatus.BOND_STATUS_UNBONDING;
        case 3:
        case "BOND_STATUS_BONDED":
            return BondStatus.BOND_STATUS_BONDED;
        case -1:
        case "UNRECOGNIZED":
        default:
            return BondStatus.UNRECOGNIZED;
    }
}
exports.bondStatusFromJSON = bondStatusFromJSON;
function bondStatusToJSON(object) {
    switch (object) {
        case BondStatus.BOND_STATUS_UNSPECIFIED:
            return "BOND_STATUS_UNSPECIFIED";
        case BondStatus.BOND_STATUS_UNBONDED:
            return "BOND_STATUS_UNBONDED";
        case BondStatus.BOND_STATUS_UNBONDING:
            return "BOND_STATUS_UNBONDING";
        case BondStatus.BOND_STATUS_BONDED:
            return "BOND_STATUS_BONDED";
        case BondStatus.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.bondStatusToJSON = bondStatusToJSON;
function createBaseHistoricalInfo() {
    return { header: undefined, valset: [] };
}
exports.HistoricalInfo = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.header !== undefined) {
            types_1.Header.encode(message.header, writer.uint32(10).fork()).ldelim();
        }
        for (const v of message.valset) {
            exports.Validator.encode(v, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseHistoricalInfo();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.header = types_1.Header.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.valset.push(exports.Validator.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            header: isSet(object.header) ? types_1.Header.fromJSON(object.header) : undefined,
            valset: Array.isArray(object === null || object === void 0 ? void 0 : object.valset) ? object.valset.map((e) => exports.Validator.fromJSON(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        message.header !== undefined && (obj.header = message.header ? types_1.Header.toJSON(message.header) : undefined);
        if (message.valset) {
            obj.valset = message.valset.map((e) => (e ? exports.Validator.toJSON(e) : undefined));
        }
        else {
            obj.valset = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseHistoricalInfo();
        message.header =
            object.header !== undefined && object.header !== null ? types_1.Header.fromPartial(object.header) : undefined;
        message.valset = ((_a = object.valset) === null || _a === void 0 ? void 0 : _a.map((e) => exports.Validator.fromPartial(e))) || [];
        return message;
    },
};
function createBaseCommissionRates() {
    return { rate: "", maxRate: "", maxChangeRate: "" };
}
exports.CommissionRates = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.rate !== "") {
            writer.uint32(10).string(message.rate);
        }
        if (message.maxRate !== "") {
            writer.uint32(18).string(message.maxRate);
        }
        if (message.maxChangeRate !== "") {
            writer.uint32(26).string(message.maxChangeRate);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCommissionRates();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.rate = reader.string();
                    break;
                case 2:
                    message.maxRate = reader.string();
                    break;
                case 3:
                    message.maxChangeRate = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            rate: isSet(object.rate) ? String(object.rate) : "",
            maxRate: isSet(object.maxRate) ? String(object.maxRate) : "",
            maxChangeRate: isSet(object.maxChangeRate) ? String(object.maxChangeRate) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.rate !== undefined && (obj.rate = message.rate);
        message.maxRate !== undefined && (obj.maxRate = message.maxRate);
        message.maxChangeRate !== undefined && (obj.maxChangeRate = message.maxChangeRate);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseCommissionRates();
        message.rate = (_a = object.rate) !== null && _a !== void 0 ? _a : "";
        message.maxRate = (_b = object.maxRate) !== null && _b !== void 0 ? _b : "";
        message.maxChangeRate = (_c = object.maxChangeRate) !== null && _c !== void 0 ? _c : "";
        return message;
    },
};
function createBaseCommission() {
    return { commissionRates: undefined, updateTime: undefined };
}
exports.Commission = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.commissionRates !== undefined) {
            exports.CommissionRates.encode(message.commissionRates, writer.uint32(10).fork()).ldelim();
        }
        if (message.updateTime !== undefined) {
            timestamp_1.Timestamp.encode(message.updateTime, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCommission();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.commissionRates = exports.CommissionRates.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.updateTime = timestamp_1.Timestamp.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            commissionRates: isSet(object.commissionRates)
                ? exports.CommissionRates.fromJSON(object.commissionRates)
                : undefined,
            updateTime: isSet(object.updateTime) ? fromJsonTimestamp(object.updateTime) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.commissionRates !== undefined &&
            (obj.commissionRates = message.commissionRates
                ? exports.CommissionRates.toJSON(message.commissionRates)
                : undefined);
        message.updateTime !== undefined && (obj.updateTime = fromTimestamp(message.updateTime).toISOString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseCommission();
        message.commissionRates =
            object.commissionRates !== undefined && object.commissionRates !== null
                ? exports.CommissionRates.fromPartial(object.commissionRates)
                : undefined;
        message.updateTime =
            object.updateTime !== undefined && object.updateTime !== null
                ? timestamp_1.Timestamp.fromPartial(object.updateTime)
                : undefined;
        return message;
    },
};
function createBaseDescription() {
    return { moniker: "", identity: "", website: "", securityContact: "", details: "" };
}
exports.Description = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.moniker !== "") {
            writer.uint32(10).string(message.moniker);
        }
        if (message.identity !== "") {
            writer.uint32(18).string(message.identity);
        }
        if (message.website !== "") {
            writer.uint32(26).string(message.website);
        }
        if (message.securityContact !== "") {
            writer.uint32(34).string(message.securityContact);
        }
        if (message.details !== "") {
            writer.uint32(42).string(message.details);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDescription();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.moniker = reader.string();
                    break;
                case 2:
                    message.identity = reader.string();
                    break;
                case 3:
                    message.website = reader.string();
                    break;
                case 4:
                    message.securityContact = reader.string();
                    break;
                case 5:
                    message.details = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            moniker: isSet(object.moniker) ? String(object.moniker) : "",
            identity: isSet(object.identity) ? String(object.identity) : "",
            website: isSet(object.website) ? String(object.website) : "",
            securityContact: isSet(object.securityContact) ? String(object.securityContact) : "",
            details: isSet(object.details) ? String(object.details) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.moniker !== undefined && (obj.moniker = message.moniker);
        message.identity !== undefined && (obj.identity = message.identity);
        message.website !== undefined && (obj.website = message.website);
        message.securityContact !== undefined && (obj.securityContact = message.securityContact);
        message.details !== undefined && (obj.details = message.details);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e;
        const message = createBaseDescription();
        message.moniker = (_a = object.moniker) !== null && _a !== void 0 ? _a : "";
        message.identity = (_b = object.identity) !== null && _b !== void 0 ? _b : "";
        message.website = (_c = object.website) !== null && _c !== void 0 ? _c : "";
        message.securityContact = (_d = object.securityContact) !== null && _d !== void 0 ? _d : "";
        message.details = (_e = object.details) !== null && _e !== void 0 ? _e : "";
        return message;
    },
};
function createBaseValidator() {
    return {
        operatorAddress: "",
        consensusPubkey: undefined,
        jailed: false,
        status: 0,
        tokens: "",
        delegatorShares: "",
        description: undefined,
        unbondingHeight: long_1.default.ZERO,
        unbondingTime: undefined,
        commission: undefined,
        minSelfDelegation: "",
    };
}
exports.Validator = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.operatorAddress !== "") {
            writer.uint32(10).string(message.operatorAddress);
        }
        if (message.consensusPubkey !== undefined) {
            any_1.Any.encode(message.consensusPubkey, writer.uint32(18).fork()).ldelim();
        }
        if (message.jailed === true) {
            writer.uint32(24).bool(message.jailed);
        }
        if (message.status !== 0) {
            writer.uint32(32).int32(message.status);
        }
        if (message.tokens !== "") {
            writer.uint32(42).string(message.tokens);
        }
        if (message.delegatorShares !== "") {
            writer.uint32(50).string(message.delegatorShares);
        }
        if (message.description !== undefined) {
            exports.Description.encode(message.description, writer.uint32(58).fork()).ldelim();
        }
        if (!message.unbondingHeight.isZero()) {
            writer.uint32(64).int64(message.unbondingHeight);
        }
        if (message.unbondingTime !== undefined) {
            timestamp_1.Timestamp.encode(message.unbondingTime, writer.uint32(74).fork()).ldelim();
        }
        if (message.commission !== undefined) {
            exports.Commission.encode(message.commission, writer.uint32(82).fork()).ldelim();
        }
        if (message.minSelfDelegation !== "") {
            writer.uint32(90).string(message.minSelfDelegation);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseValidator();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.operatorAddress = reader.string();
                    break;
                case 2:
                    message.consensusPubkey = any_1.Any.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.jailed = reader.bool();
                    break;
                case 4:
                    message.status = reader.int32();
                    break;
                case 5:
                    message.tokens = reader.string();
                    break;
                case 6:
                    message.delegatorShares = reader.string();
                    break;
                case 7:
                    message.description = exports.Description.decode(reader, reader.uint32());
                    break;
                case 8:
                    message.unbondingHeight = reader.int64();
                    break;
                case 9:
                    message.unbondingTime = timestamp_1.Timestamp.decode(reader, reader.uint32());
                    break;
                case 10:
                    message.commission = exports.Commission.decode(reader, reader.uint32());
                    break;
                case 11:
                    message.minSelfDelegation = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            operatorAddress: isSet(object.operatorAddress) ? String(object.operatorAddress) : "",
            consensusPubkey: isSet(object.consensusPubkey) ? any_1.Any.fromJSON(object.consensusPubkey) : undefined,
            jailed: isSet(object.jailed) ? Boolean(object.jailed) : false,
            status: isSet(object.status) ? bondStatusFromJSON(object.status) : 0,
            tokens: isSet(object.tokens) ? String(object.tokens) : "",
            delegatorShares: isSet(object.delegatorShares) ? String(object.delegatorShares) : "",
            description: isSet(object.description) ? exports.Description.fromJSON(object.description) : undefined,
            unbondingHeight: isSet(object.unbondingHeight) ? long_1.default.fromValue(object.unbondingHeight) : long_1.default.ZERO,
            unbondingTime: isSet(object.unbondingTime) ? fromJsonTimestamp(object.unbondingTime) : undefined,
            commission: isSet(object.commission) ? exports.Commission.fromJSON(object.commission) : undefined,
            minSelfDelegation: isSet(object.minSelfDelegation) ? String(object.minSelfDelegation) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.operatorAddress !== undefined && (obj.operatorAddress = message.operatorAddress);
        message.consensusPubkey !== undefined &&
            (obj.consensusPubkey = message.consensusPubkey ? any_1.Any.toJSON(message.consensusPubkey) : undefined);
        message.jailed !== undefined && (obj.jailed = message.jailed);
        message.status !== undefined && (obj.status = bondStatusToJSON(message.status));
        message.tokens !== undefined && (obj.tokens = message.tokens);
        message.delegatorShares !== undefined && (obj.delegatorShares = message.delegatorShares);
        message.description !== undefined &&
            (obj.description = message.description ? exports.Description.toJSON(message.description) : undefined);
        message.unbondingHeight !== undefined &&
            (obj.unbondingHeight = (message.unbondingHeight || long_1.default.ZERO).toString());
        message.unbondingTime !== undefined &&
            (obj.unbondingTime = fromTimestamp(message.unbondingTime).toISOString());
        message.commission !== undefined &&
            (obj.commission = message.commission ? exports.Commission.toJSON(message.commission) : undefined);
        message.minSelfDelegation !== undefined && (obj.minSelfDelegation = message.minSelfDelegation);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f;
        const message = createBaseValidator();
        message.operatorAddress = (_a = object.operatorAddress) !== null && _a !== void 0 ? _a : "";
        message.consensusPubkey =
            object.consensusPubkey !== undefined && object.consensusPubkey !== null
                ? any_1.Any.fromPartial(object.consensusPubkey)
                : undefined;
        message.jailed = (_b = object.jailed) !== null && _b !== void 0 ? _b : false;
        message.status = (_c = object.status) !== null && _c !== void 0 ? _c : 0;
        message.tokens = (_d = object.tokens) !== null && _d !== void 0 ? _d : "";
        message.delegatorShares = (_e = object.delegatorShares) !== null && _e !== void 0 ? _e : "";
        message.description =
            object.description !== undefined && object.description !== null
                ? exports.Description.fromPartial(object.description)
                : undefined;
        message.unbondingHeight =
            object.unbondingHeight !== undefined && object.unbondingHeight !== null
                ? long_1.default.fromValue(object.unbondingHeight)
                : long_1.default.ZERO;
        message.unbondingTime =
            object.unbondingTime !== undefined && object.unbondingTime !== null
                ? timestamp_1.Timestamp.fromPartial(object.unbondingTime)
                : undefined;
        message.commission =
            object.commission !== undefined && object.commission !== null
                ? exports.Commission.fromPartial(object.commission)
                : undefined;
        message.minSelfDelegation = (_f = object.minSelfDelegation) !== null && _f !== void 0 ? _f : "";
        return message;
    },
};
function createBaseValAddresses() {
    return { addresses: [] };
}
exports.ValAddresses = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.addresses) {
            writer.uint32(10).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseValAddresses();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.addresses.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { addresses: Array.isArray(object === null || object === void 0 ? void 0 : object.addresses) ? object.addresses.map((e) => String(e)) : [] };
    },
    toJSON(message) {
        const obj = {};
        if (message.addresses) {
            obj.addresses = message.addresses.map((e) => e);
        }
        else {
            obj.addresses = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseValAddresses();
        message.addresses = ((_a = object.addresses) === null || _a === void 0 ? void 0 : _a.map((e) => e)) || [];
        return message;
    },
};
function createBaseDVPair() {
    return { delegatorAddress: "", validatorAddress: "" };
}
exports.DVPair = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.delegatorAddress !== "") {
            writer.uint32(10).string(message.delegatorAddress);
        }
        if (message.validatorAddress !== "") {
            writer.uint32(18).string(message.validatorAddress);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDVPair();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            delegatorAddress: isSet(object.delegatorAddress) ? String(object.delegatorAddress) : "",
            validatorAddress: isSet(object.validatorAddress) ? String(object.validatorAddress) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseDVPair();
        message.delegatorAddress = (_a = object.delegatorAddress) !== null && _a !== void 0 ? _a : "";
        message.validatorAddress = (_b = object.validatorAddress) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
function createBaseDVPairs() {
    return { pairs: [] };
}
exports.DVPairs = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.pairs) {
            exports.DVPair.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDVPairs();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.pairs.push(exports.DVPair.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { pairs: Array.isArray(object === null || object === void 0 ? void 0 : object.pairs) ? object.pairs.map((e) => exports.DVPair.fromJSON(e)) : [] };
    },
    toJSON(message) {
        const obj = {};
        if (message.pairs) {
            obj.pairs = message.pairs.map((e) => (e ? exports.DVPair.toJSON(e) : undefined));
        }
        else {
            obj.pairs = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseDVPairs();
        message.pairs = ((_a = object.pairs) === null || _a === void 0 ? void 0 : _a.map((e) => exports.DVPair.fromPartial(e))) || [];
        return message;
    },
};
function createBaseDVVTriplet() {
    return { delegatorAddress: "", validatorSrcAddress: "", validatorDstAddress: "" };
}
exports.DVVTriplet = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.delegatorAddress !== "") {
            writer.uint32(10).string(message.delegatorAddress);
        }
        if (message.validatorSrcAddress !== "") {
            writer.uint32(18).string(message.validatorSrcAddress);
        }
        if (message.validatorDstAddress !== "") {
            writer.uint32(26).string(message.validatorDstAddress);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDVVTriplet();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorSrcAddress = reader.string();
                    break;
                case 3:
                    message.validatorDstAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            delegatorAddress: isSet(object.delegatorAddress) ? String(object.delegatorAddress) : "",
            validatorSrcAddress: isSet(object.validatorSrcAddress) ? String(object.validatorSrcAddress) : "",
            validatorDstAddress: isSet(object.validatorDstAddress) ? String(object.validatorDstAddress) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorSrcAddress !== undefined && (obj.validatorSrcAddress = message.validatorSrcAddress);
        message.validatorDstAddress !== undefined && (obj.validatorDstAddress = message.validatorDstAddress);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseDVVTriplet();
        message.delegatorAddress = (_a = object.delegatorAddress) !== null && _a !== void 0 ? _a : "";
        message.validatorSrcAddress = (_b = object.validatorSrcAddress) !== null && _b !== void 0 ? _b : "";
        message.validatorDstAddress = (_c = object.validatorDstAddress) !== null && _c !== void 0 ? _c : "";
        return message;
    },
};
function createBaseDVVTriplets() {
    return { triplets: [] };
}
exports.DVVTriplets = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.triplets) {
            exports.DVVTriplet.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDVVTriplets();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.triplets.push(exports.DVVTriplet.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            triplets: Array.isArray(object === null || object === void 0 ? void 0 : object.triplets)
                ? object.triplets.map((e) => exports.DVVTriplet.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.triplets) {
            obj.triplets = message.triplets.map((e) => (e ? exports.DVVTriplet.toJSON(e) : undefined));
        }
        else {
            obj.triplets = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseDVVTriplets();
        message.triplets = ((_a = object.triplets) === null || _a === void 0 ? void 0 : _a.map((e) => exports.DVVTriplet.fromPartial(e))) || [];
        return message;
    },
};
function createBaseDelegation() {
    return { delegatorAddress: "", validatorAddress: "", shares: "" };
}
exports.Delegation = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.delegatorAddress !== "") {
            writer.uint32(10).string(message.delegatorAddress);
        }
        if (message.validatorAddress !== "") {
            writer.uint32(18).string(message.validatorAddress);
        }
        if (message.shares !== "") {
            writer.uint32(26).string(message.shares);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDelegation();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorAddress = reader.string();
                    break;
                case 3:
                    message.shares = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            delegatorAddress: isSet(object.delegatorAddress) ? String(object.delegatorAddress) : "",
            validatorAddress: isSet(object.validatorAddress) ? String(object.validatorAddress) : "",
            shares: isSet(object.shares) ? String(object.shares) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        message.shares !== undefined && (obj.shares = message.shares);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseDelegation();
        message.delegatorAddress = (_a = object.delegatorAddress) !== null && _a !== void 0 ? _a : "";
        message.validatorAddress = (_b = object.validatorAddress) !== null && _b !== void 0 ? _b : "";
        message.shares = (_c = object.shares) !== null && _c !== void 0 ? _c : "";
        return message;
    },
};
function createBaseUnbondingDelegation() {
    return { delegatorAddress: "", validatorAddress: "", entries: [] };
}
exports.UnbondingDelegation = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.delegatorAddress !== "") {
            writer.uint32(10).string(message.delegatorAddress);
        }
        if (message.validatorAddress !== "") {
            writer.uint32(18).string(message.validatorAddress);
        }
        for (const v of message.entries) {
            exports.UnbondingDelegationEntry.encode(v, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUnbondingDelegation();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorAddress = reader.string();
                    break;
                case 3:
                    message.entries.push(exports.UnbondingDelegationEntry.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            delegatorAddress: isSet(object.delegatorAddress) ? String(object.delegatorAddress) : "",
            validatorAddress: isSet(object.validatorAddress) ? String(object.validatorAddress) : "",
            entries: Array.isArray(object === null || object === void 0 ? void 0 : object.entries)
                ? object.entries.map((e) => exports.UnbondingDelegationEntry.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        if (message.entries) {
            obj.entries = message.entries.map((e) => (e ? exports.UnbondingDelegationEntry.toJSON(e) : undefined));
        }
        else {
            obj.entries = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseUnbondingDelegation();
        message.delegatorAddress = (_a = object.delegatorAddress) !== null && _a !== void 0 ? _a : "";
        message.validatorAddress = (_b = object.validatorAddress) !== null && _b !== void 0 ? _b : "";
        message.entries = ((_c = object.entries) === null || _c === void 0 ? void 0 : _c.map((e) => exports.UnbondingDelegationEntry.fromPartial(e))) || [];
        return message;
    },
};
function createBaseUnbondingDelegationEntry() {
    return { creationHeight: long_1.default.ZERO, completionTime: undefined, initialBalance: "", balance: "" };
}
exports.UnbondingDelegationEntry = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (!message.creationHeight.isZero()) {
            writer.uint32(8).int64(message.creationHeight);
        }
        if (message.completionTime !== undefined) {
            timestamp_1.Timestamp.encode(message.completionTime, writer.uint32(18).fork()).ldelim();
        }
        if (message.initialBalance !== "") {
            writer.uint32(26).string(message.initialBalance);
        }
        if (message.balance !== "") {
            writer.uint32(34).string(message.balance);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUnbondingDelegationEntry();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creationHeight = reader.int64();
                    break;
                case 2:
                    message.completionTime = timestamp_1.Timestamp.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.initialBalance = reader.string();
                    break;
                case 4:
                    message.balance = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            creationHeight: isSet(object.creationHeight) ? long_1.default.fromValue(object.creationHeight) : long_1.default.ZERO,
            completionTime: isSet(object.completionTime) ? fromJsonTimestamp(object.completionTime) : undefined,
            initialBalance: isSet(object.initialBalance) ? String(object.initialBalance) : "",
            balance: isSet(object.balance) ? String(object.balance) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.creationHeight !== undefined &&
            (obj.creationHeight = (message.creationHeight || long_1.default.ZERO).toString());
        message.completionTime !== undefined &&
            (obj.completionTime = fromTimestamp(message.completionTime).toISOString());
        message.initialBalance !== undefined && (obj.initialBalance = message.initialBalance);
        message.balance !== undefined && (obj.balance = message.balance);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseUnbondingDelegationEntry();
        message.creationHeight =
            object.creationHeight !== undefined && object.creationHeight !== null
                ? long_1.default.fromValue(object.creationHeight)
                : long_1.default.ZERO;
        message.completionTime =
            object.completionTime !== undefined && object.completionTime !== null
                ? timestamp_1.Timestamp.fromPartial(object.completionTime)
                : undefined;
        message.initialBalance = (_a = object.initialBalance) !== null && _a !== void 0 ? _a : "";
        message.balance = (_b = object.balance) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
function createBaseRedelegationEntry() {
    return { creationHeight: long_1.default.ZERO, completionTime: undefined, initialBalance: "", sharesDst: "" };
}
exports.RedelegationEntry = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (!message.creationHeight.isZero()) {
            writer.uint32(8).int64(message.creationHeight);
        }
        if (message.completionTime !== undefined) {
            timestamp_1.Timestamp.encode(message.completionTime, writer.uint32(18).fork()).ldelim();
        }
        if (message.initialBalance !== "") {
            writer.uint32(26).string(message.initialBalance);
        }
        if (message.sharesDst !== "") {
            writer.uint32(34).string(message.sharesDst);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRedelegationEntry();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creationHeight = reader.int64();
                    break;
                case 2:
                    message.completionTime = timestamp_1.Timestamp.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.initialBalance = reader.string();
                    break;
                case 4:
                    message.sharesDst = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            creationHeight: isSet(object.creationHeight) ? long_1.default.fromValue(object.creationHeight) : long_1.default.ZERO,
            completionTime: isSet(object.completionTime) ? fromJsonTimestamp(object.completionTime) : undefined,
            initialBalance: isSet(object.initialBalance) ? String(object.initialBalance) : "",
            sharesDst: isSet(object.sharesDst) ? String(object.sharesDst) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.creationHeight !== undefined &&
            (obj.creationHeight = (message.creationHeight || long_1.default.ZERO).toString());
        message.completionTime !== undefined &&
            (obj.completionTime = fromTimestamp(message.completionTime).toISOString());
        message.initialBalance !== undefined && (obj.initialBalance = message.initialBalance);
        message.sharesDst !== undefined && (obj.sharesDst = message.sharesDst);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseRedelegationEntry();
        message.creationHeight =
            object.creationHeight !== undefined && object.creationHeight !== null
                ? long_1.default.fromValue(object.creationHeight)
                : long_1.default.ZERO;
        message.completionTime =
            object.completionTime !== undefined && object.completionTime !== null
                ? timestamp_1.Timestamp.fromPartial(object.completionTime)
                : undefined;
        message.initialBalance = (_a = object.initialBalance) !== null && _a !== void 0 ? _a : "";
        message.sharesDst = (_b = object.sharesDst) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
function createBaseRedelegation() {
    return { delegatorAddress: "", validatorSrcAddress: "", validatorDstAddress: "", entries: [] };
}
exports.Redelegation = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.delegatorAddress !== "") {
            writer.uint32(10).string(message.delegatorAddress);
        }
        if (message.validatorSrcAddress !== "") {
            writer.uint32(18).string(message.validatorSrcAddress);
        }
        if (message.validatorDstAddress !== "") {
            writer.uint32(26).string(message.validatorDstAddress);
        }
        for (const v of message.entries) {
            exports.RedelegationEntry.encode(v, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRedelegation();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorSrcAddress = reader.string();
                    break;
                case 3:
                    message.validatorDstAddress = reader.string();
                    break;
                case 4:
                    message.entries.push(exports.RedelegationEntry.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            delegatorAddress: isSet(object.delegatorAddress) ? String(object.delegatorAddress) : "",
            validatorSrcAddress: isSet(object.validatorSrcAddress) ? String(object.validatorSrcAddress) : "",
            validatorDstAddress: isSet(object.validatorDstAddress) ? String(object.validatorDstAddress) : "",
            entries: Array.isArray(object === null || object === void 0 ? void 0 : object.entries)
                ? object.entries.map((e) => exports.RedelegationEntry.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorSrcAddress !== undefined && (obj.validatorSrcAddress = message.validatorSrcAddress);
        message.validatorDstAddress !== undefined && (obj.validatorDstAddress = message.validatorDstAddress);
        if (message.entries) {
            obj.entries = message.entries.map((e) => (e ? exports.RedelegationEntry.toJSON(e) : undefined));
        }
        else {
            obj.entries = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d;
        const message = createBaseRedelegation();
        message.delegatorAddress = (_a = object.delegatorAddress) !== null && _a !== void 0 ? _a : "";
        message.validatorSrcAddress = (_b = object.validatorSrcAddress) !== null && _b !== void 0 ? _b : "";
        message.validatorDstAddress = (_c = object.validatorDstAddress) !== null && _c !== void 0 ? _c : "";
        message.entries = ((_d = object.entries) === null || _d === void 0 ? void 0 : _d.map((e) => exports.RedelegationEntry.fromPartial(e))) || [];
        return message;
    },
};
function createBaseParams() {
    return { unbondingTime: undefined, maxValidators: 0, maxEntries: 0, historicalEntries: 0, bondDenom: "" };
}
exports.Params = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.unbondingTime !== undefined) {
            duration_1.Duration.encode(message.unbondingTime, writer.uint32(10).fork()).ldelim();
        }
        if (message.maxValidators !== 0) {
            writer.uint32(16).uint32(message.maxValidators);
        }
        if (message.maxEntries !== 0) {
            writer.uint32(24).uint32(message.maxEntries);
        }
        if (message.historicalEntries !== 0) {
            writer.uint32(32).uint32(message.historicalEntries);
        }
        if (message.bondDenom !== "") {
            writer.uint32(42).string(message.bondDenom);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseParams();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.unbondingTime = duration_1.Duration.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.maxValidators = reader.uint32();
                    break;
                case 3:
                    message.maxEntries = reader.uint32();
                    break;
                case 4:
                    message.historicalEntries = reader.uint32();
                    break;
                case 5:
                    message.bondDenom = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            unbondingTime: isSet(object.unbondingTime) ? duration_1.Duration.fromJSON(object.unbondingTime) : undefined,
            maxValidators: isSet(object.maxValidators) ? Number(object.maxValidators) : 0,
            maxEntries: isSet(object.maxEntries) ? Number(object.maxEntries) : 0,
            historicalEntries: isSet(object.historicalEntries) ? Number(object.historicalEntries) : 0,
            bondDenom: isSet(object.bondDenom) ? String(object.bondDenom) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.unbondingTime !== undefined &&
            (obj.unbondingTime = message.unbondingTime ? duration_1.Duration.toJSON(message.unbondingTime) : undefined);
        message.maxValidators !== undefined && (obj.maxValidators = Math.round(message.maxValidators));
        message.maxEntries !== undefined && (obj.maxEntries = Math.round(message.maxEntries));
        message.historicalEntries !== undefined &&
            (obj.historicalEntries = Math.round(message.historicalEntries));
        message.bondDenom !== undefined && (obj.bondDenom = message.bondDenom);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d;
        const message = createBaseParams();
        message.unbondingTime =
            object.unbondingTime !== undefined && object.unbondingTime !== null
                ? duration_1.Duration.fromPartial(object.unbondingTime)
                : undefined;
        message.maxValidators = (_a = object.maxValidators) !== null && _a !== void 0 ? _a : 0;
        message.maxEntries = (_b = object.maxEntries) !== null && _b !== void 0 ? _b : 0;
        message.historicalEntries = (_c = object.historicalEntries) !== null && _c !== void 0 ? _c : 0;
        message.bondDenom = (_d = object.bondDenom) !== null && _d !== void 0 ? _d : "";
        return message;
    },
};
function createBaseDelegationResponse() {
    return { delegation: undefined, balance: undefined };
}
exports.DelegationResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.delegation !== undefined) {
            exports.Delegation.encode(message.delegation, writer.uint32(10).fork()).ldelim();
        }
        if (message.balance !== undefined) {
            coin_1.Coin.encode(message.balance, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDelegationResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.delegation = exports.Delegation.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.balance = coin_1.Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            delegation: isSet(object.delegation) ? exports.Delegation.fromJSON(object.delegation) : undefined,
            balance: isSet(object.balance) ? coin_1.Coin.fromJSON(object.balance) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.delegation !== undefined &&
            (obj.delegation = message.delegation ? exports.Delegation.toJSON(message.delegation) : undefined);
        message.balance !== undefined &&
            (obj.balance = message.balance ? coin_1.Coin.toJSON(message.balance) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseDelegationResponse();
        message.delegation =
            object.delegation !== undefined && object.delegation !== null
                ? exports.Delegation.fromPartial(object.delegation)
                : undefined;
        message.balance =
            object.balance !== undefined && object.balance !== null ? coin_1.Coin.fromPartial(object.balance) : undefined;
        return message;
    },
};
function createBaseRedelegationEntryResponse() {
    return { redelegationEntry: undefined, balance: "" };
}
exports.RedelegationEntryResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.redelegationEntry !== undefined) {
            exports.RedelegationEntry.encode(message.redelegationEntry, writer.uint32(10).fork()).ldelim();
        }
        if (message.balance !== "") {
            writer.uint32(34).string(message.balance);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRedelegationEntryResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.redelegationEntry = exports.RedelegationEntry.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.balance = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            redelegationEntry: isSet(object.redelegationEntry)
                ? exports.RedelegationEntry.fromJSON(object.redelegationEntry)
                : undefined,
            balance: isSet(object.balance) ? String(object.balance) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.redelegationEntry !== undefined &&
            (obj.redelegationEntry = message.redelegationEntry
                ? exports.RedelegationEntry.toJSON(message.redelegationEntry)
                : undefined);
        message.balance !== undefined && (obj.balance = message.balance);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseRedelegationEntryResponse();
        message.redelegationEntry =
            object.redelegationEntry !== undefined && object.redelegationEntry !== null
                ? exports.RedelegationEntry.fromPartial(object.redelegationEntry)
                : undefined;
        message.balance = (_a = object.balance) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
function createBaseRedelegationResponse() {
    return { redelegation: undefined, entries: [] };
}
exports.RedelegationResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.redelegation !== undefined) {
            exports.Redelegation.encode(message.redelegation, writer.uint32(10).fork()).ldelim();
        }
        for (const v of message.entries) {
            exports.RedelegationEntryResponse.encode(v, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRedelegationResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.redelegation = exports.Redelegation.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.entries.push(exports.RedelegationEntryResponse.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            redelegation: isSet(object.redelegation) ? exports.Redelegation.fromJSON(object.redelegation) : undefined,
            entries: Array.isArray(object === null || object === void 0 ? void 0 : object.entries)
                ? object.entries.map((e) => exports.RedelegationEntryResponse.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        message.redelegation !== undefined &&
            (obj.redelegation = message.redelegation ? exports.Redelegation.toJSON(message.redelegation) : undefined);
        if (message.entries) {
            obj.entries = message.entries.map((e) => (e ? exports.RedelegationEntryResponse.toJSON(e) : undefined));
        }
        else {
            obj.entries = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseRedelegationResponse();
        message.redelegation =
            object.redelegation !== undefined && object.redelegation !== null
                ? exports.Redelegation.fromPartial(object.redelegation)
                : undefined;
        message.entries = ((_a = object.entries) === null || _a === void 0 ? void 0 : _a.map((e) => exports.RedelegationEntryResponse.fromPartial(e))) || [];
        return message;
    },
};
function createBasePool() {
    return { notBondedTokens: "", bondedTokens: "" };
}
exports.Pool = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.notBondedTokens !== "") {
            writer.uint32(10).string(message.notBondedTokens);
        }
        if (message.bondedTokens !== "") {
            writer.uint32(18).string(message.bondedTokens);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePool();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.notBondedTokens = reader.string();
                    break;
                case 2:
                    message.bondedTokens = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            notBondedTokens: isSet(object.notBondedTokens) ? String(object.notBondedTokens) : "",
            bondedTokens: isSet(object.bondedTokens) ? String(object.bondedTokens) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.notBondedTokens !== undefined && (obj.notBondedTokens = message.notBondedTokens);
        message.bondedTokens !== undefined && (obj.bondedTokens = message.bondedTokens);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBasePool();
        message.notBondedTokens = (_a = object.notBondedTokens) !== null && _a !== void 0 ? _a : "";
        message.bondedTokens = (_b = object.bondedTokens) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
function toTimestamp(date) {
    const seconds = numberToLong(date.getTime() / 1000);
    const nanos = (date.getTime() % 1000) * 1000000;
    return { seconds, nanos };
}
function fromTimestamp(t) {
    let millis = t.seconds.toNumber() * 1000;
    millis += t.nanos / 1000000;
    return new Date(millis);
}
function fromJsonTimestamp(o) {
    if (o instanceof Date) {
        return toTimestamp(o);
    }
    else if (typeof o === "string") {
        return toTimestamp(new Date(o));
    }
    else {
        return timestamp_1.Timestamp.fromJSON(o);
    }
}
function numberToLong(number) {
    return long_1.default.fromNumber(number);
}
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=staking.js.map

/***/ }),

/***/ 96440:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MsgClientImpl = exports.MsgUndelegateResponse = exports.MsgUndelegate = exports.MsgBeginRedelegateResponse = exports.MsgBeginRedelegate = exports.MsgDelegateResponse = exports.MsgDelegate = exports.MsgEditValidatorResponse = exports.MsgEditValidator = exports.MsgCreateValidatorResponse = exports.MsgCreateValidator = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(__webpack_require__(47873));
const minimal_1 = __importDefault(__webpack_require__(62100));
const any_1 = __webpack_require__(90007);
const timestamp_1 = __webpack_require__(76620);
const coin_1 = __webpack_require__(26119);
const staking_1 = __webpack_require__(59992);
exports.protobufPackage = "cosmos.staking.v1beta1";
function createBaseMsgCreateValidator() {
    return {
        description: undefined,
        commission: undefined,
        minSelfDelegation: "",
        delegatorAddress: "",
        validatorAddress: "",
        pubkey: undefined,
        value: undefined,
    };
}
exports.MsgCreateValidator = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.description !== undefined) {
            staking_1.Description.encode(message.description, writer.uint32(10).fork()).ldelim();
        }
        if (message.commission !== undefined) {
            staking_1.CommissionRates.encode(message.commission, writer.uint32(18).fork()).ldelim();
        }
        if (message.minSelfDelegation !== "") {
            writer.uint32(26).string(message.minSelfDelegation);
        }
        if (message.delegatorAddress !== "") {
            writer.uint32(34).string(message.delegatorAddress);
        }
        if (message.validatorAddress !== "") {
            writer.uint32(42).string(message.validatorAddress);
        }
        if (message.pubkey !== undefined) {
            any_1.Any.encode(message.pubkey, writer.uint32(50).fork()).ldelim();
        }
        if (message.value !== undefined) {
            coin_1.Coin.encode(message.value, writer.uint32(58).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgCreateValidator();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.description = staking_1.Description.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.commission = staking_1.CommissionRates.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.minSelfDelegation = reader.string();
                    break;
                case 4:
                    message.delegatorAddress = reader.string();
                    break;
                case 5:
                    message.validatorAddress = reader.string();
                    break;
                case 6:
                    message.pubkey = any_1.Any.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.value = coin_1.Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            description: isSet(object.description) ? staking_1.Description.fromJSON(object.description) : undefined,
            commission: isSet(object.commission) ? staking_1.CommissionRates.fromJSON(object.commission) : undefined,
            minSelfDelegation: isSet(object.minSelfDelegation) ? String(object.minSelfDelegation) : "",
            delegatorAddress: isSet(object.delegatorAddress) ? String(object.delegatorAddress) : "",
            validatorAddress: isSet(object.validatorAddress) ? String(object.validatorAddress) : "",
            pubkey: isSet(object.pubkey) ? any_1.Any.fromJSON(object.pubkey) : undefined,
            value: isSet(object.value) ? coin_1.Coin.fromJSON(object.value) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.description !== undefined &&
            (obj.description = message.description ? staking_1.Description.toJSON(message.description) : undefined);
        message.commission !== undefined &&
            (obj.commission = message.commission ? staking_1.CommissionRates.toJSON(message.commission) : undefined);
        message.minSelfDelegation !== undefined && (obj.minSelfDelegation = message.minSelfDelegation);
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        message.pubkey !== undefined && (obj.pubkey = message.pubkey ? any_1.Any.toJSON(message.pubkey) : undefined);
        message.value !== undefined && (obj.value = message.value ? coin_1.Coin.toJSON(message.value) : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseMsgCreateValidator();
        message.description =
            object.description !== undefined && object.description !== null
                ? staking_1.Description.fromPartial(object.description)
                : undefined;
        message.commission =
            object.commission !== undefined && object.commission !== null
                ? staking_1.CommissionRates.fromPartial(object.commission)
                : undefined;
        message.minSelfDelegation = (_a = object.minSelfDelegation) !== null && _a !== void 0 ? _a : "";
        message.delegatorAddress = (_b = object.delegatorAddress) !== null && _b !== void 0 ? _b : "";
        message.validatorAddress = (_c = object.validatorAddress) !== null && _c !== void 0 ? _c : "";
        message.pubkey =
            object.pubkey !== undefined && object.pubkey !== null ? any_1.Any.fromPartial(object.pubkey) : undefined;
        message.value =
            object.value !== undefined && object.value !== null ? coin_1.Coin.fromPartial(object.value) : undefined;
        return message;
    },
};
function createBaseMsgCreateValidatorResponse() {
    return {};
}
exports.MsgCreateValidatorResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgCreateValidatorResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgCreateValidatorResponse();
        return message;
    },
};
function createBaseMsgEditValidator() {
    return { description: undefined, validatorAddress: "", commissionRate: "", minSelfDelegation: "" };
}
exports.MsgEditValidator = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.description !== undefined) {
            staking_1.Description.encode(message.description, writer.uint32(10).fork()).ldelim();
        }
        if (message.validatorAddress !== "") {
            writer.uint32(18).string(message.validatorAddress);
        }
        if (message.commissionRate !== "") {
            writer.uint32(26).string(message.commissionRate);
        }
        if (message.minSelfDelegation !== "") {
            writer.uint32(34).string(message.minSelfDelegation);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgEditValidator();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.description = staking_1.Description.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.validatorAddress = reader.string();
                    break;
                case 3:
                    message.commissionRate = reader.string();
                    break;
                case 4:
                    message.minSelfDelegation = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            description: isSet(object.description) ? staking_1.Description.fromJSON(object.description) : undefined,
            validatorAddress: isSet(object.validatorAddress) ? String(object.validatorAddress) : "",
            commissionRate: isSet(object.commissionRate) ? String(object.commissionRate) : "",
            minSelfDelegation: isSet(object.minSelfDelegation) ? String(object.minSelfDelegation) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.description !== undefined &&
            (obj.description = message.description ? staking_1.Description.toJSON(message.description) : undefined);
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        message.commissionRate !== undefined && (obj.commissionRate = message.commissionRate);
        message.minSelfDelegation !== undefined && (obj.minSelfDelegation = message.minSelfDelegation);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseMsgEditValidator();
        message.description =
            object.description !== undefined && object.description !== null
                ? staking_1.Description.fromPartial(object.description)
                : undefined;
        message.validatorAddress = (_a = object.validatorAddress) !== null && _a !== void 0 ? _a : "";
        message.commissionRate = (_b = object.commissionRate) !== null && _b !== void 0 ? _b : "";
        message.minSelfDelegation = (_c = object.minSelfDelegation) !== null && _c !== void 0 ? _c : "";
        return message;
    },
};
function createBaseMsgEditValidatorResponse() {
    return {};
}
exports.MsgEditValidatorResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgEditValidatorResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgEditValidatorResponse();
        return message;
    },
};
function createBaseMsgDelegate() {
    return { delegatorAddress: "", validatorAddress: "", amount: undefined };
}
exports.MsgDelegate = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.delegatorAddress !== "") {
            writer.uint32(10).string(message.delegatorAddress);
        }
        if (message.validatorAddress !== "") {
            writer.uint32(18).string(message.validatorAddress);
        }
        if (message.amount !== undefined) {
            coin_1.Coin.encode(message.amount, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgDelegate();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorAddress = reader.string();
                    break;
                case 3:
                    message.amount = coin_1.Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            delegatorAddress: isSet(object.delegatorAddress) ? String(object.delegatorAddress) : "",
            validatorAddress: isSet(object.validatorAddress) ? String(object.validatorAddress) : "",
            amount: isSet(object.amount) ? coin_1.Coin.fromJSON(object.amount) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        message.amount !== undefined && (obj.amount = message.amount ? coin_1.Coin.toJSON(message.amount) : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseMsgDelegate();
        message.delegatorAddress = (_a = object.delegatorAddress) !== null && _a !== void 0 ? _a : "";
        message.validatorAddress = (_b = object.validatorAddress) !== null && _b !== void 0 ? _b : "";
        message.amount =
            object.amount !== undefined && object.amount !== null ? coin_1.Coin.fromPartial(object.amount) : undefined;
        return message;
    },
};
function createBaseMsgDelegateResponse() {
    return {};
}
exports.MsgDelegateResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgDelegateResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgDelegateResponse();
        return message;
    },
};
function createBaseMsgBeginRedelegate() {
    return { delegatorAddress: "", validatorSrcAddress: "", validatorDstAddress: "", amount: undefined };
}
exports.MsgBeginRedelegate = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.delegatorAddress !== "") {
            writer.uint32(10).string(message.delegatorAddress);
        }
        if (message.validatorSrcAddress !== "") {
            writer.uint32(18).string(message.validatorSrcAddress);
        }
        if (message.validatorDstAddress !== "") {
            writer.uint32(26).string(message.validatorDstAddress);
        }
        if (message.amount !== undefined) {
            coin_1.Coin.encode(message.amount, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgBeginRedelegate();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorSrcAddress = reader.string();
                    break;
                case 3:
                    message.validatorDstAddress = reader.string();
                    break;
                case 4:
                    message.amount = coin_1.Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            delegatorAddress: isSet(object.delegatorAddress) ? String(object.delegatorAddress) : "",
            validatorSrcAddress: isSet(object.validatorSrcAddress) ? String(object.validatorSrcAddress) : "",
            validatorDstAddress: isSet(object.validatorDstAddress) ? String(object.validatorDstAddress) : "",
            amount: isSet(object.amount) ? coin_1.Coin.fromJSON(object.amount) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorSrcAddress !== undefined && (obj.validatorSrcAddress = message.validatorSrcAddress);
        message.validatorDstAddress !== undefined && (obj.validatorDstAddress = message.validatorDstAddress);
        message.amount !== undefined && (obj.amount = message.amount ? coin_1.Coin.toJSON(message.amount) : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseMsgBeginRedelegate();
        message.delegatorAddress = (_a = object.delegatorAddress) !== null && _a !== void 0 ? _a : "";
        message.validatorSrcAddress = (_b = object.validatorSrcAddress) !== null && _b !== void 0 ? _b : "";
        message.validatorDstAddress = (_c = object.validatorDstAddress) !== null && _c !== void 0 ? _c : "";
        message.amount =
            object.amount !== undefined && object.amount !== null ? coin_1.Coin.fromPartial(object.amount) : undefined;
        return message;
    },
};
function createBaseMsgBeginRedelegateResponse() {
    return { completionTime: undefined };
}
exports.MsgBeginRedelegateResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.completionTime !== undefined) {
            timestamp_1.Timestamp.encode(message.completionTime, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgBeginRedelegateResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.completionTime = timestamp_1.Timestamp.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            completionTime: isSet(object.completionTime) ? fromJsonTimestamp(object.completionTime) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.completionTime !== undefined &&
            (obj.completionTime = fromTimestamp(message.completionTime).toISOString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgBeginRedelegateResponse();
        message.completionTime =
            object.completionTime !== undefined && object.completionTime !== null
                ? timestamp_1.Timestamp.fromPartial(object.completionTime)
                : undefined;
        return message;
    },
};
function createBaseMsgUndelegate() {
    return { delegatorAddress: "", validatorAddress: "", amount: undefined };
}
exports.MsgUndelegate = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.delegatorAddress !== "") {
            writer.uint32(10).string(message.delegatorAddress);
        }
        if (message.validatorAddress !== "") {
            writer.uint32(18).string(message.validatorAddress);
        }
        if (message.amount !== undefined) {
            coin_1.Coin.encode(message.amount, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgUndelegate();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorAddress = reader.string();
                    break;
                case 3:
                    message.amount = coin_1.Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            delegatorAddress: isSet(object.delegatorAddress) ? String(object.delegatorAddress) : "",
            validatorAddress: isSet(object.validatorAddress) ? String(object.validatorAddress) : "",
            amount: isSet(object.amount) ? coin_1.Coin.fromJSON(object.amount) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        message.amount !== undefined && (obj.amount = message.amount ? coin_1.Coin.toJSON(message.amount) : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseMsgUndelegate();
        message.delegatorAddress = (_a = object.delegatorAddress) !== null && _a !== void 0 ? _a : "";
        message.validatorAddress = (_b = object.validatorAddress) !== null && _b !== void 0 ? _b : "";
        message.amount =
            object.amount !== undefined && object.amount !== null ? coin_1.Coin.fromPartial(object.amount) : undefined;
        return message;
    },
};
function createBaseMsgUndelegateResponse() {
    return { completionTime: undefined };
}
exports.MsgUndelegateResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.completionTime !== undefined) {
            timestamp_1.Timestamp.encode(message.completionTime, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgUndelegateResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.completionTime = timestamp_1.Timestamp.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            completionTime: isSet(object.completionTime) ? fromJsonTimestamp(object.completionTime) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.completionTime !== undefined &&
            (obj.completionTime = fromTimestamp(message.completionTime).toISOString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgUndelegateResponse();
        message.completionTime =
            object.completionTime !== undefined && object.completionTime !== null
                ? timestamp_1.Timestamp.fromPartial(object.completionTime)
                : undefined;
        return message;
    },
};
class MsgClientImpl {
    constructor(rpc) {
        this.rpc = rpc;
        this.CreateValidator = this.CreateValidator.bind(this);
        this.EditValidator = this.EditValidator.bind(this);
        this.Delegate = this.Delegate.bind(this);
        this.BeginRedelegate = this.BeginRedelegate.bind(this);
        this.Undelegate = this.Undelegate.bind(this);
    }
    CreateValidator(request) {
        const data = exports.MsgCreateValidator.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Msg", "CreateValidator", data);
        return promise.then((data) => exports.MsgCreateValidatorResponse.decode(new minimal_1.default.Reader(data)));
    }
    EditValidator(request) {
        const data = exports.MsgEditValidator.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Msg", "EditValidator", data);
        return promise.then((data) => exports.MsgEditValidatorResponse.decode(new minimal_1.default.Reader(data)));
    }
    Delegate(request) {
        const data = exports.MsgDelegate.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Msg", "Delegate", data);
        return promise.then((data) => exports.MsgDelegateResponse.decode(new minimal_1.default.Reader(data)));
    }
    BeginRedelegate(request) {
        const data = exports.MsgBeginRedelegate.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Msg", "BeginRedelegate", data);
        return promise.then((data) => exports.MsgBeginRedelegateResponse.decode(new minimal_1.default.Reader(data)));
    }
    Undelegate(request) {
        const data = exports.MsgUndelegate.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Msg", "Undelegate", data);
        return promise.then((data) => exports.MsgUndelegateResponse.decode(new minimal_1.default.Reader(data)));
    }
}
exports.MsgClientImpl = MsgClientImpl;
function toTimestamp(date) {
    const seconds = numberToLong(date.getTime() / 1000);
    const nanos = (date.getTime() % 1000) * 1000000;
    return { seconds, nanos };
}
function fromTimestamp(t) {
    let millis = t.seconds.toNumber() * 1000;
    millis += t.nanos / 1000000;
    return new Date(millis);
}
function fromJsonTimestamp(o) {
    if (o instanceof Date) {
        return toTimestamp(o);
    }
    else if (typeof o === "string") {
        return toTimestamp(new Date(o));
    }
    else {
        return timestamp_1.Timestamp.fromJSON(o);
    }
}
function numberToLong(number) {
    return long_1.default.fromNumber(number);
}
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=tx.js.map

/***/ }),

/***/ 94600:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.SignatureDescriptor_Data_Multi = exports.SignatureDescriptor_Data_Single = exports.SignatureDescriptor_Data = exports.SignatureDescriptor = exports.SignatureDescriptors = exports.signModeToJSON = exports.signModeFromJSON = exports.SignMode = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(__webpack_require__(47873));
const minimal_1 = __importDefault(__webpack_require__(62100));
const any_1 = __webpack_require__(90007);
const multisig_1 = __webpack_require__(76203);
exports.protobufPackage = "cosmos.tx.signing.v1beta1";
/** SignMode represents a signing mode with its own security guarantees. */
var SignMode;
(function (SignMode) {
    /**
     * SIGN_MODE_UNSPECIFIED - SIGN_MODE_UNSPECIFIED specifies an unknown signing mode and will be
     * rejected
     */
    SignMode[SignMode["SIGN_MODE_UNSPECIFIED"] = 0] = "SIGN_MODE_UNSPECIFIED";
    /**
     * SIGN_MODE_DIRECT - SIGN_MODE_DIRECT specifies a signing mode which uses SignDoc and is
     * verified with raw bytes from Tx
     */
    SignMode[SignMode["SIGN_MODE_DIRECT"] = 1] = "SIGN_MODE_DIRECT";
    /**
     * SIGN_MODE_TEXTUAL - SIGN_MODE_TEXTUAL is a future signing mode that will verify some
     * human-readable textual representation on top of the binary representation
     * from SIGN_MODE_DIRECT
     */
    SignMode[SignMode["SIGN_MODE_TEXTUAL"] = 2] = "SIGN_MODE_TEXTUAL";
    /**
     * SIGN_MODE_LEGACY_AMINO_JSON - SIGN_MODE_LEGACY_AMINO_JSON is a backwards compatibility mode which uses
     * Amino JSON and will be removed in the future
     */
    SignMode[SignMode["SIGN_MODE_LEGACY_AMINO_JSON"] = 127] = "SIGN_MODE_LEGACY_AMINO_JSON";
    /**
     * SIGN_MODE_EIP_191 - SIGN_MODE_EIP_191 specifies the sign mode for EIP 191 signing on the Cosmos
     * SDK. Ref: https://eips.ethereum.org/EIPS/eip-191
     *
     * Currently, SIGN_MODE_EIP_191 is registered as a SignMode enum variant,
     * but is not implemented on the SDK by default. To enable EIP-191, you need
     * to pass a custom `TxConfig` that has an implementation of
     * `SignModeHandler` for EIP-191. The SDK may decide to fully support
     * EIP-191 in the future.
     *
     * Since: cosmos-sdk 0.45.2
     */
    SignMode[SignMode["SIGN_MODE_EIP_191"] = 191] = "SIGN_MODE_EIP_191";
    SignMode[SignMode["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(SignMode = exports.SignMode || (exports.SignMode = {}));
function signModeFromJSON(object) {
    switch (object) {
        case 0:
        case "SIGN_MODE_UNSPECIFIED":
            return SignMode.SIGN_MODE_UNSPECIFIED;
        case 1:
        case "SIGN_MODE_DIRECT":
            return SignMode.SIGN_MODE_DIRECT;
        case 2:
        case "SIGN_MODE_TEXTUAL":
            return SignMode.SIGN_MODE_TEXTUAL;
        case 127:
        case "SIGN_MODE_LEGACY_AMINO_JSON":
            return SignMode.SIGN_MODE_LEGACY_AMINO_JSON;
        case 191:
        case "SIGN_MODE_EIP_191":
            return SignMode.SIGN_MODE_EIP_191;
        case -1:
        case "UNRECOGNIZED":
        default:
            return SignMode.UNRECOGNIZED;
    }
}
exports.signModeFromJSON = signModeFromJSON;
function signModeToJSON(object) {
    switch (object) {
        case SignMode.SIGN_MODE_UNSPECIFIED:
            return "SIGN_MODE_UNSPECIFIED";
        case SignMode.SIGN_MODE_DIRECT:
            return "SIGN_MODE_DIRECT";
        case SignMode.SIGN_MODE_TEXTUAL:
            return "SIGN_MODE_TEXTUAL";
        case SignMode.SIGN_MODE_LEGACY_AMINO_JSON:
            return "SIGN_MODE_LEGACY_AMINO_JSON";
        case SignMode.SIGN_MODE_EIP_191:
            return "SIGN_MODE_EIP_191";
        case SignMode.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.signModeToJSON = signModeToJSON;
function createBaseSignatureDescriptors() {
    return { signatures: [] };
}
exports.SignatureDescriptors = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.signatures) {
            exports.SignatureDescriptor.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSignatureDescriptors();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.signatures.push(exports.SignatureDescriptor.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            signatures: Array.isArray(object === null || object === void 0 ? void 0 : object.signatures)
                ? object.signatures.map((e) => exports.SignatureDescriptor.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.signatures) {
            obj.signatures = message.signatures.map((e) => (e ? exports.SignatureDescriptor.toJSON(e) : undefined));
        }
        else {
            obj.signatures = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseSignatureDescriptors();
        message.signatures = ((_a = object.signatures) === null || _a === void 0 ? void 0 : _a.map((e) => exports.SignatureDescriptor.fromPartial(e))) || [];
        return message;
    },
};
function createBaseSignatureDescriptor() {
    return { publicKey: undefined, data: undefined, sequence: long_1.default.UZERO };
}
exports.SignatureDescriptor = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.publicKey !== undefined) {
            any_1.Any.encode(message.publicKey, writer.uint32(10).fork()).ldelim();
        }
        if (message.data !== undefined) {
            exports.SignatureDescriptor_Data.encode(message.data, writer.uint32(18).fork()).ldelim();
        }
        if (!message.sequence.isZero()) {
            writer.uint32(24).uint64(message.sequence);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSignatureDescriptor();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.publicKey = any_1.Any.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.data = exports.SignatureDescriptor_Data.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.sequence = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            publicKey: isSet(object.publicKey) ? any_1.Any.fromJSON(object.publicKey) : undefined,
            data: isSet(object.data) ? exports.SignatureDescriptor_Data.fromJSON(object.data) : undefined,
            sequence: isSet(object.sequence) ? long_1.default.fromValue(object.sequence) : long_1.default.UZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        message.publicKey !== undefined &&
            (obj.publicKey = message.publicKey ? any_1.Any.toJSON(message.publicKey) : undefined);
        message.data !== undefined &&
            (obj.data = message.data ? exports.SignatureDescriptor_Data.toJSON(message.data) : undefined);
        message.sequence !== undefined && (obj.sequence = (message.sequence || long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseSignatureDescriptor();
        message.publicKey =
            object.publicKey !== undefined && object.publicKey !== null
                ? any_1.Any.fromPartial(object.publicKey)
                : undefined;
        message.data =
            object.data !== undefined && object.data !== null
                ? exports.SignatureDescriptor_Data.fromPartial(object.data)
                : undefined;
        message.sequence =
            object.sequence !== undefined && object.sequence !== null
                ? long_1.default.fromValue(object.sequence)
                : long_1.default.UZERO;
        return message;
    },
};
function createBaseSignatureDescriptor_Data() {
    return { single: undefined, multi: undefined };
}
exports.SignatureDescriptor_Data = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.single !== undefined) {
            exports.SignatureDescriptor_Data_Single.encode(message.single, writer.uint32(10).fork()).ldelim();
        }
        if (message.multi !== undefined) {
            exports.SignatureDescriptor_Data_Multi.encode(message.multi, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSignatureDescriptor_Data();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.single = exports.SignatureDescriptor_Data_Single.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.multi = exports.SignatureDescriptor_Data_Multi.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            single: isSet(object.single) ? exports.SignatureDescriptor_Data_Single.fromJSON(object.single) : undefined,
            multi: isSet(object.multi) ? exports.SignatureDescriptor_Data_Multi.fromJSON(object.multi) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.single !== undefined &&
            (obj.single = message.single ? exports.SignatureDescriptor_Data_Single.toJSON(message.single) : undefined);
        message.multi !== undefined &&
            (obj.multi = message.multi ? exports.SignatureDescriptor_Data_Multi.toJSON(message.multi) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseSignatureDescriptor_Data();
        message.single =
            object.single !== undefined && object.single !== null
                ? exports.SignatureDescriptor_Data_Single.fromPartial(object.single)
                : undefined;
        message.multi =
            object.multi !== undefined && object.multi !== null
                ? exports.SignatureDescriptor_Data_Multi.fromPartial(object.multi)
                : undefined;
        return message;
    },
};
function createBaseSignatureDescriptor_Data_Single() {
    return { mode: 0, signature: new Uint8Array() };
}
exports.SignatureDescriptor_Data_Single = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.mode !== 0) {
            writer.uint32(8).int32(message.mode);
        }
        if (message.signature.length !== 0) {
            writer.uint32(18).bytes(message.signature);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSignatureDescriptor_Data_Single();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.mode = reader.int32();
                    break;
                case 2:
                    message.signature = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            mode: isSet(object.mode) ? signModeFromJSON(object.mode) : 0,
            signature: isSet(object.signature) ? bytesFromBase64(object.signature) : new Uint8Array(),
        };
    },
    toJSON(message) {
        const obj = {};
        message.mode !== undefined && (obj.mode = signModeToJSON(message.mode));
        message.signature !== undefined &&
            (obj.signature = base64FromBytes(message.signature !== undefined ? message.signature : new Uint8Array()));
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseSignatureDescriptor_Data_Single();
        message.mode = (_a = object.mode) !== null && _a !== void 0 ? _a : 0;
        message.signature = (_b = object.signature) !== null && _b !== void 0 ? _b : new Uint8Array();
        return message;
    },
};
function createBaseSignatureDescriptor_Data_Multi() {
    return { bitarray: undefined, signatures: [] };
}
exports.SignatureDescriptor_Data_Multi = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.bitarray !== undefined) {
            multisig_1.CompactBitArray.encode(message.bitarray, writer.uint32(10).fork()).ldelim();
        }
        for (const v of message.signatures) {
            exports.SignatureDescriptor_Data.encode(v, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSignatureDescriptor_Data_Multi();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.bitarray = multisig_1.CompactBitArray.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.signatures.push(exports.SignatureDescriptor_Data.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            bitarray: isSet(object.bitarray) ? multisig_1.CompactBitArray.fromJSON(object.bitarray) : undefined,
            signatures: Array.isArray(object === null || object === void 0 ? void 0 : object.signatures)
                ? object.signatures.map((e) => exports.SignatureDescriptor_Data.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        message.bitarray !== undefined &&
            (obj.bitarray = message.bitarray ? multisig_1.CompactBitArray.toJSON(message.bitarray) : undefined);
        if (message.signatures) {
            obj.signatures = message.signatures.map((e) => (e ? exports.SignatureDescriptor_Data.toJSON(e) : undefined));
        }
        else {
            obj.signatures = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseSignatureDescriptor_Data_Multi();
        message.bitarray =
            object.bitarray !== undefined && object.bitarray !== null
                ? multisig_1.CompactBitArray.fromPartial(object.bitarray)
                : undefined;
        message.signatures = ((_a = object.signatures) === null || _a === void 0 ? void 0 : _a.map((e) => exports.SignatureDescriptor_Data.fromPartial(e))) || [];
        return message;
    },
};
var globalThis = (() => {
    if (typeof globalThis !== "undefined") {
        return globalThis;
    }
    if (typeof self !== "undefined") {
        return self;
    }
    if (typeof window !== "undefined") {
        return window;
    }
    if (typeof __webpack_require__.g !== "undefined") {
        return __webpack_require__.g;
    }
    throw "Unable to locate global object";
})();
function bytesFromBase64(b64) {
    if (globalThis.Buffer) {
        return Uint8Array.from(globalThis.Buffer.from(b64, "base64"));
    }
    else {
        const bin = globalThis.atob(b64);
        const arr = new Uint8Array(bin.length);
        for (let i = 0; i < bin.length; ++i) {
            arr[i] = bin.charCodeAt(i);
        }
        return arr;
    }
}
function base64FromBytes(arr) {
    if (globalThis.Buffer) {
        return globalThis.Buffer.from(arr).toString("base64");
    }
    else {
        const bin = [];
        arr.forEach((byte) => {
            bin.push(String.fromCharCode(byte));
        });
        return globalThis.btoa(bin.join(""));
    }
}
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=signing.js.map

/***/ }),

/***/ 31956:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ServiceClientImpl = exports.GetBlockWithTxsResponse = exports.GetBlockWithTxsRequest = exports.GetTxResponse = exports.GetTxRequest = exports.SimulateResponse = exports.SimulateRequest = exports.BroadcastTxResponse = exports.BroadcastTxRequest = exports.GetTxsEventResponse = exports.GetTxsEventRequest = exports.broadcastModeToJSON = exports.broadcastModeFromJSON = exports.BroadcastMode = exports.orderByToJSON = exports.orderByFromJSON = exports.OrderBy = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(__webpack_require__(47873));
const minimal_1 = __importDefault(__webpack_require__(62100));
const block_1 = __webpack_require__(62516);
const types_1 = __webpack_require__(54028);
const abci_1 = __webpack_require__(17825);
const pagination_1 = __webpack_require__(62635);
const tx_1 = __webpack_require__(94289);
exports.protobufPackage = "cosmos.tx.v1beta1";
/** OrderBy defines the sorting order */
var OrderBy;
(function (OrderBy) {
    /** ORDER_BY_UNSPECIFIED - ORDER_BY_UNSPECIFIED specifies an unknown sorting order. OrderBy defaults to ASC in this case. */
    OrderBy[OrderBy["ORDER_BY_UNSPECIFIED"] = 0] = "ORDER_BY_UNSPECIFIED";
    /** ORDER_BY_ASC - ORDER_BY_ASC defines ascending order */
    OrderBy[OrderBy["ORDER_BY_ASC"] = 1] = "ORDER_BY_ASC";
    /** ORDER_BY_DESC - ORDER_BY_DESC defines descending order */
    OrderBy[OrderBy["ORDER_BY_DESC"] = 2] = "ORDER_BY_DESC";
    OrderBy[OrderBy["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(OrderBy = exports.OrderBy || (exports.OrderBy = {}));
function orderByFromJSON(object) {
    switch (object) {
        case 0:
        case "ORDER_BY_UNSPECIFIED":
            return OrderBy.ORDER_BY_UNSPECIFIED;
        case 1:
        case "ORDER_BY_ASC":
            return OrderBy.ORDER_BY_ASC;
        case 2:
        case "ORDER_BY_DESC":
            return OrderBy.ORDER_BY_DESC;
        case -1:
        case "UNRECOGNIZED":
        default:
            return OrderBy.UNRECOGNIZED;
    }
}
exports.orderByFromJSON = orderByFromJSON;
function orderByToJSON(object) {
    switch (object) {
        case OrderBy.ORDER_BY_UNSPECIFIED:
            return "ORDER_BY_UNSPECIFIED";
        case OrderBy.ORDER_BY_ASC:
            return "ORDER_BY_ASC";
        case OrderBy.ORDER_BY_DESC:
            return "ORDER_BY_DESC";
        case OrderBy.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.orderByToJSON = orderByToJSON;
/** BroadcastMode specifies the broadcast mode for the TxService.Broadcast RPC method. */
var BroadcastMode;
(function (BroadcastMode) {
    /** BROADCAST_MODE_UNSPECIFIED - zero-value for mode ordering */
    BroadcastMode[BroadcastMode["BROADCAST_MODE_UNSPECIFIED"] = 0] = "BROADCAST_MODE_UNSPECIFIED";
    /**
     * BROADCAST_MODE_BLOCK - BROADCAST_MODE_BLOCK defines a tx broadcasting mode where the client waits for
     * the tx to be committed in a block.
     */
    BroadcastMode[BroadcastMode["BROADCAST_MODE_BLOCK"] = 1] = "BROADCAST_MODE_BLOCK";
    /**
     * BROADCAST_MODE_SYNC - BROADCAST_MODE_SYNC defines a tx broadcasting mode where the client waits for
     * a CheckTx execution response only.
     */
    BroadcastMode[BroadcastMode["BROADCAST_MODE_SYNC"] = 2] = "BROADCAST_MODE_SYNC";
    /**
     * BROADCAST_MODE_ASYNC - BROADCAST_MODE_ASYNC defines a tx broadcasting mode where the client returns
     * immediately.
     */
    BroadcastMode[BroadcastMode["BROADCAST_MODE_ASYNC"] = 3] = "BROADCAST_MODE_ASYNC";
    BroadcastMode[BroadcastMode["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(BroadcastMode = exports.BroadcastMode || (exports.BroadcastMode = {}));
function broadcastModeFromJSON(object) {
    switch (object) {
        case 0:
        case "BROADCAST_MODE_UNSPECIFIED":
            return BroadcastMode.BROADCAST_MODE_UNSPECIFIED;
        case 1:
        case "BROADCAST_MODE_BLOCK":
            return BroadcastMode.BROADCAST_MODE_BLOCK;
        case 2:
        case "BROADCAST_MODE_SYNC":
            return BroadcastMode.BROADCAST_MODE_SYNC;
        case 3:
        case "BROADCAST_MODE_ASYNC":
            return BroadcastMode.BROADCAST_MODE_ASYNC;
        case -1:
        case "UNRECOGNIZED":
        default:
            return BroadcastMode.UNRECOGNIZED;
    }
}
exports.broadcastModeFromJSON = broadcastModeFromJSON;
function broadcastModeToJSON(object) {
    switch (object) {
        case BroadcastMode.BROADCAST_MODE_UNSPECIFIED:
            return "BROADCAST_MODE_UNSPECIFIED";
        case BroadcastMode.BROADCAST_MODE_BLOCK:
            return "BROADCAST_MODE_BLOCK";
        case BroadcastMode.BROADCAST_MODE_SYNC:
            return "BROADCAST_MODE_SYNC";
        case BroadcastMode.BROADCAST_MODE_ASYNC:
            return "BROADCAST_MODE_ASYNC";
        case BroadcastMode.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.broadcastModeToJSON = broadcastModeToJSON;
function createBaseGetTxsEventRequest() {
    return { events: [], pagination: undefined, orderBy: 0 };
}
exports.GetTxsEventRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.events) {
            writer.uint32(10).string(v);
        }
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        if (message.orderBy !== 0) {
            writer.uint32(24).int32(message.orderBy);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetTxsEventRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.events.push(reader.string());
                    break;
                case 2:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.orderBy = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            events: Array.isArray(object === null || object === void 0 ? void 0 : object.events) ? object.events.map((e) => String(e)) : [],
            pagination: isSet(object.pagination) ? pagination_1.PageRequest.fromJSON(object.pagination) : undefined,
            orderBy: isSet(object.orderBy) ? orderByFromJSON(object.orderBy) : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.events) {
            obj.events = message.events.map((e) => e);
        }
        else {
            obj.events = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageRequest.toJSON(message.pagination) : undefined);
        message.orderBy !== undefined && (obj.orderBy = orderByToJSON(message.orderBy));
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseGetTxsEventRequest();
        message.events = ((_a = object.events) === null || _a === void 0 ? void 0 : _a.map((e) => e)) || [];
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        message.orderBy = (_b = object.orderBy) !== null && _b !== void 0 ? _b : 0;
        return message;
    },
};
function createBaseGetTxsEventResponse() {
    return { txs: [], txResponses: [], pagination: undefined };
}
exports.GetTxsEventResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.txs) {
            tx_1.Tx.encode(v, writer.uint32(10).fork()).ldelim();
        }
        for (const v of message.txResponses) {
            abci_1.TxResponse.encode(v, writer.uint32(18).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetTxsEventResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.txs.push(tx_1.Tx.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.txResponses.push(abci_1.TxResponse.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            txs: Array.isArray(object === null || object === void 0 ? void 0 : object.txs) ? object.txs.map((e) => tx_1.Tx.fromJSON(e)) : [],
            txResponses: Array.isArray(object === null || object === void 0 ? void 0 : object.txResponses)
                ? object.txResponses.map((e) => abci_1.TxResponse.fromJSON(e))
                : [],
            pagination: isSet(object.pagination) ? pagination_1.PageResponse.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.txs) {
            obj.txs = message.txs.map((e) => (e ? tx_1.Tx.toJSON(e) : undefined));
        }
        else {
            obj.txs = [];
        }
        if (message.txResponses) {
            obj.txResponses = message.txResponses.map((e) => (e ? abci_1.TxResponse.toJSON(e) : undefined));
        }
        else {
            obj.txResponses = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseGetTxsEventResponse();
        message.txs = ((_a = object.txs) === null || _a === void 0 ? void 0 : _a.map((e) => tx_1.Tx.fromPartial(e))) || [];
        message.txResponses = ((_b = object.txResponses) === null || _b === void 0 ? void 0 : _b.map((e) => abci_1.TxResponse.fromPartial(e))) || [];
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseBroadcastTxRequest() {
    return { txBytes: new Uint8Array(), mode: 0 };
}
exports.BroadcastTxRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.txBytes.length !== 0) {
            writer.uint32(10).bytes(message.txBytes);
        }
        if (message.mode !== 0) {
            writer.uint32(16).int32(message.mode);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseBroadcastTxRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.txBytes = reader.bytes();
                    break;
                case 2:
                    message.mode = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            txBytes: isSet(object.txBytes) ? bytesFromBase64(object.txBytes) : new Uint8Array(),
            mode: isSet(object.mode) ? broadcastModeFromJSON(object.mode) : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        message.txBytes !== undefined &&
            (obj.txBytes = base64FromBytes(message.txBytes !== undefined ? message.txBytes : new Uint8Array()));
        message.mode !== undefined && (obj.mode = broadcastModeToJSON(message.mode));
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseBroadcastTxRequest();
        message.txBytes = (_a = object.txBytes) !== null && _a !== void 0 ? _a : new Uint8Array();
        message.mode = (_b = object.mode) !== null && _b !== void 0 ? _b : 0;
        return message;
    },
};
function createBaseBroadcastTxResponse() {
    return { txResponse: undefined };
}
exports.BroadcastTxResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.txResponse !== undefined) {
            abci_1.TxResponse.encode(message.txResponse, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseBroadcastTxResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.txResponse = abci_1.TxResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { txResponse: isSet(object.txResponse) ? abci_1.TxResponse.fromJSON(object.txResponse) : undefined };
    },
    toJSON(message) {
        const obj = {};
        message.txResponse !== undefined &&
            (obj.txResponse = message.txResponse ? abci_1.TxResponse.toJSON(message.txResponse) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseBroadcastTxResponse();
        message.txResponse =
            object.txResponse !== undefined && object.txResponse !== null
                ? abci_1.TxResponse.fromPartial(object.txResponse)
                : undefined;
        return message;
    },
};
function createBaseSimulateRequest() {
    return { tx: undefined, txBytes: new Uint8Array() };
}
exports.SimulateRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.tx !== undefined) {
            tx_1.Tx.encode(message.tx, writer.uint32(10).fork()).ldelim();
        }
        if (message.txBytes.length !== 0) {
            writer.uint32(18).bytes(message.txBytes);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSimulateRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.tx = tx_1.Tx.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.txBytes = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            tx: isSet(object.tx) ? tx_1.Tx.fromJSON(object.tx) : undefined,
            txBytes: isSet(object.txBytes) ? bytesFromBase64(object.txBytes) : new Uint8Array(),
        };
    },
    toJSON(message) {
        const obj = {};
        message.tx !== undefined && (obj.tx = message.tx ? tx_1.Tx.toJSON(message.tx) : undefined);
        message.txBytes !== undefined &&
            (obj.txBytes = base64FromBytes(message.txBytes !== undefined ? message.txBytes : new Uint8Array()));
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseSimulateRequest();
        message.tx = object.tx !== undefined && object.tx !== null ? tx_1.Tx.fromPartial(object.tx) : undefined;
        message.txBytes = (_a = object.txBytes) !== null && _a !== void 0 ? _a : new Uint8Array();
        return message;
    },
};
function createBaseSimulateResponse() {
    return { gasInfo: undefined, result: undefined };
}
exports.SimulateResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.gasInfo !== undefined) {
            abci_1.GasInfo.encode(message.gasInfo, writer.uint32(10).fork()).ldelim();
        }
        if (message.result !== undefined) {
            abci_1.Result.encode(message.result, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSimulateResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.gasInfo = abci_1.GasInfo.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.result = abci_1.Result.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            gasInfo: isSet(object.gasInfo) ? abci_1.GasInfo.fromJSON(object.gasInfo) : undefined,
            result: isSet(object.result) ? abci_1.Result.fromJSON(object.result) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.gasInfo !== undefined &&
            (obj.gasInfo = message.gasInfo ? abci_1.GasInfo.toJSON(message.gasInfo) : undefined);
        message.result !== undefined && (obj.result = message.result ? abci_1.Result.toJSON(message.result) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseSimulateResponse();
        message.gasInfo =
            object.gasInfo !== undefined && object.gasInfo !== null
                ? abci_1.GasInfo.fromPartial(object.gasInfo)
                : undefined;
        message.result =
            object.result !== undefined && object.result !== null ? abci_1.Result.fromPartial(object.result) : undefined;
        return message;
    },
};
function createBaseGetTxRequest() {
    return { hash: "" };
}
exports.GetTxRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.hash !== "") {
            writer.uint32(10).string(message.hash);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetTxRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.hash = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { hash: isSet(object.hash) ? String(object.hash) : "" };
    },
    toJSON(message) {
        const obj = {};
        message.hash !== undefined && (obj.hash = message.hash);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseGetTxRequest();
        message.hash = (_a = object.hash) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
function createBaseGetTxResponse() {
    return { tx: undefined, txResponse: undefined };
}
exports.GetTxResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.tx !== undefined) {
            tx_1.Tx.encode(message.tx, writer.uint32(10).fork()).ldelim();
        }
        if (message.txResponse !== undefined) {
            abci_1.TxResponse.encode(message.txResponse, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetTxResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.tx = tx_1.Tx.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.txResponse = abci_1.TxResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            tx: isSet(object.tx) ? tx_1.Tx.fromJSON(object.tx) : undefined,
            txResponse: isSet(object.txResponse) ? abci_1.TxResponse.fromJSON(object.txResponse) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.tx !== undefined && (obj.tx = message.tx ? tx_1.Tx.toJSON(message.tx) : undefined);
        message.txResponse !== undefined &&
            (obj.txResponse = message.txResponse ? abci_1.TxResponse.toJSON(message.txResponse) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseGetTxResponse();
        message.tx = object.tx !== undefined && object.tx !== null ? tx_1.Tx.fromPartial(object.tx) : undefined;
        message.txResponse =
            object.txResponse !== undefined && object.txResponse !== null
                ? abci_1.TxResponse.fromPartial(object.txResponse)
                : undefined;
        return message;
    },
};
function createBaseGetBlockWithTxsRequest() {
    return { height: long_1.default.ZERO, pagination: undefined };
}
exports.GetBlockWithTxsRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (!message.height.isZero()) {
            writer.uint32(8).int64(message.height);
        }
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetBlockWithTxsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.height = reader.int64();
                    break;
                case 2:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            height: isSet(object.height) ? long_1.default.fromValue(object.height) : long_1.default.ZERO,
            pagination: isSet(object.pagination) ? pagination_1.PageRequest.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.height !== undefined && (obj.height = (message.height || long_1.default.ZERO).toString());
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseGetBlockWithTxsRequest();
        message.height =
            object.height !== undefined && object.height !== null ? long_1.default.fromValue(object.height) : long_1.default.ZERO;
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseGetBlockWithTxsResponse() {
    return { txs: [], blockId: undefined, block: undefined, pagination: undefined };
}
exports.GetBlockWithTxsResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.txs) {
            tx_1.Tx.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.blockId !== undefined) {
            types_1.BlockID.encode(message.blockId, writer.uint32(18).fork()).ldelim();
        }
        if (message.block !== undefined) {
            block_1.Block.encode(message.block, writer.uint32(26).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetBlockWithTxsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.txs.push(tx_1.Tx.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.blockId = types_1.BlockID.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.block = block_1.Block.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            txs: Array.isArray(object === null || object === void 0 ? void 0 : object.txs) ? object.txs.map((e) => tx_1.Tx.fromJSON(e)) : [],
            blockId: isSet(object.blockId) ? types_1.BlockID.fromJSON(object.blockId) : undefined,
            block: isSet(object.block) ? block_1.Block.fromJSON(object.block) : undefined,
            pagination: isSet(object.pagination) ? pagination_1.PageResponse.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.txs) {
            obj.txs = message.txs.map((e) => (e ? tx_1.Tx.toJSON(e) : undefined));
        }
        else {
            obj.txs = [];
        }
        message.blockId !== undefined &&
            (obj.blockId = message.blockId ? types_1.BlockID.toJSON(message.blockId) : undefined);
        message.block !== undefined && (obj.block = message.block ? block_1.Block.toJSON(message.block) : undefined);
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseGetBlockWithTxsResponse();
        message.txs = ((_a = object.txs) === null || _a === void 0 ? void 0 : _a.map((e) => tx_1.Tx.fromPartial(e))) || [];
        message.blockId =
            object.blockId !== undefined && object.blockId !== null
                ? types_1.BlockID.fromPartial(object.blockId)
                : undefined;
        message.block =
            object.block !== undefined && object.block !== null ? block_1.Block.fromPartial(object.block) : undefined;
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
class ServiceClientImpl {
    constructor(rpc) {
        this.rpc = rpc;
        this.Simulate = this.Simulate.bind(this);
        this.GetTx = this.GetTx.bind(this);
        this.BroadcastTx = this.BroadcastTx.bind(this);
        this.GetTxsEvent = this.GetTxsEvent.bind(this);
        this.GetBlockWithTxs = this.GetBlockWithTxs.bind(this);
    }
    Simulate(request) {
        const data = exports.SimulateRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.tx.v1beta1.Service", "Simulate", data);
        return promise.then((data) => exports.SimulateResponse.decode(new minimal_1.default.Reader(data)));
    }
    GetTx(request) {
        const data = exports.GetTxRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.tx.v1beta1.Service", "GetTx", data);
        return promise.then((data) => exports.GetTxResponse.decode(new minimal_1.default.Reader(data)));
    }
    BroadcastTx(request) {
        const data = exports.BroadcastTxRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.tx.v1beta1.Service", "BroadcastTx", data);
        return promise.then((data) => exports.BroadcastTxResponse.decode(new minimal_1.default.Reader(data)));
    }
    GetTxsEvent(request) {
        const data = exports.GetTxsEventRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.tx.v1beta1.Service", "GetTxsEvent", data);
        return promise.then((data) => exports.GetTxsEventResponse.decode(new minimal_1.default.Reader(data)));
    }
    GetBlockWithTxs(request) {
        const data = exports.GetBlockWithTxsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.tx.v1beta1.Service", "GetBlockWithTxs", data);
        return promise.then((data) => exports.GetBlockWithTxsResponse.decode(new minimal_1.default.Reader(data)));
    }
}
exports.ServiceClientImpl = ServiceClientImpl;
var globalThis = (() => {
    if (typeof globalThis !== "undefined") {
        return globalThis;
    }
    if (typeof self !== "undefined") {
        return self;
    }
    if (typeof window !== "undefined") {
        return window;
    }
    if (typeof __webpack_require__.g !== "undefined") {
        return __webpack_require__.g;
    }
    throw "Unable to locate global object";
})();
function bytesFromBase64(b64) {
    if (globalThis.Buffer) {
        return Uint8Array.from(globalThis.Buffer.from(b64, "base64"));
    }
    else {
        const bin = globalThis.atob(b64);
        const arr = new Uint8Array(bin.length);
        for (let i = 0; i < bin.length; ++i) {
            arr[i] = bin.charCodeAt(i);
        }
        return arr;
    }
}
function base64FromBytes(arr) {
    if (globalThis.Buffer) {
        return globalThis.Buffer.from(arr).toString("base64");
    }
    else {
        const bin = [];
        arr.forEach((byte) => {
            bin.push(String.fromCharCode(byte));
        });
        return globalThis.btoa(bin.join(""));
    }
}
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=service.js.map

/***/ }),

/***/ 94289:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Fee = exports.ModeInfo_Multi = exports.ModeInfo_Single = exports.ModeInfo = exports.SignerInfo = exports.AuthInfo = exports.TxBody = exports.SignDoc = exports.TxRaw = exports.Tx = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(__webpack_require__(47873));
const minimal_1 = __importDefault(__webpack_require__(62100));
const any_1 = __webpack_require__(90007);
const coin_1 = __webpack_require__(26119);
const multisig_1 = __webpack_require__(76203);
const signing_1 = __webpack_require__(94600);
exports.protobufPackage = "cosmos.tx.v1beta1";
function createBaseTx() {
    return { body: undefined, authInfo: undefined, signatures: [] };
}
exports.Tx = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.body !== undefined) {
            exports.TxBody.encode(message.body, writer.uint32(10).fork()).ldelim();
        }
        if (message.authInfo !== undefined) {
            exports.AuthInfo.encode(message.authInfo, writer.uint32(18).fork()).ldelim();
        }
        for (const v of message.signatures) {
            writer.uint32(26).bytes(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTx();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.body = exports.TxBody.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.authInfo = exports.AuthInfo.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.signatures.push(reader.bytes());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            body: isSet(object.body) ? exports.TxBody.fromJSON(object.body) : undefined,
            authInfo: isSet(object.authInfo) ? exports.AuthInfo.fromJSON(object.authInfo) : undefined,
            signatures: Array.isArray(object === null || object === void 0 ? void 0 : object.signatures)
                ? object.signatures.map((e) => bytesFromBase64(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        message.body !== undefined && (obj.body = message.body ? exports.TxBody.toJSON(message.body) : undefined);
        message.authInfo !== undefined &&
            (obj.authInfo = message.authInfo ? exports.AuthInfo.toJSON(message.authInfo) : undefined);
        if (message.signatures) {
            obj.signatures = message.signatures.map((e) => base64FromBytes(e !== undefined ? e : new Uint8Array()));
        }
        else {
            obj.signatures = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseTx();
        message.body =
            object.body !== undefined && object.body !== null ? exports.TxBody.fromPartial(object.body) : undefined;
        message.authInfo =
            object.authInfo !== undefined && object.authInfo !== null
                ? exports.AuthInfo.fromPartial(object.authInfo)
                : undefined;
        message.signatures = ((_a = object.signatures) === null || _a === void 0 ? void 0 : _a.map((e) => e)) || [];
        return message;
    },
};
function createBaseTxRaw() {
    return { bodyBytes: new Uint8Array(), authInfoBytes: new Uint8Array(), signatures: [] };
}
exports.TxRaw = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.bodyBytes.length !== 0) {
            writer.uint32(10).bytes(message.bodyBytes);
        }
        if (message.authInfoBytes.length !== 0) {
            writer.uint32(18).bytes(message.authInfoBytes);
        }
        for (const v of message.signatures) {
            writer.uint32(26).bytes(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTxRaw();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.bodyBytes = reader.bytes();
                    break;
                case 2:
                    message.authInfoBytes = reader.bytes();
                    break;
                case 3:
                    message.signatures.push(reader.bytes());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            bodyBytes: isSet(object.bodyBytes) ? bytesFromBase64(object.bodyBytes) : new Uint8Array(),
            authInfoBytes: isSet(object.authInfoBytes) ? bytesFromBase64(object.authInfoBytes) : new Uint8Array(),
            signatures: Array.isArray(object === null || object === void 0 ? void 0 : object.signatures)
                ? object.signatures.map((e) => bytesFromBase64(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        message.bodyBytes !== undefined &&
            (obj.bodyBytes = base64FromBytes(message.bodyBytes !== undefined ? message.bodyBytes : new Uint8Array()));
        message.authInfoBytes !== undefined &&
            (obj.authInfoBytes = base64FromBytes(message.authInfoBytes !== undefined ? message.authInfoBytes : new Uint8Array()));
        if (message.signatures) {
            obj.signatures = message.signatures.map((e) => base64FromBytes(e !== undefined ? e : new Uint8Array()));
        }
        else {
            obj.signatures = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseTxRaw();
        message.bodyBytes = (_a = object.bodyBytes) !== null && _a !== void 0 ? _a : new Uint8Array();
        message.authInfoBytes = (_b = object.authInfoBytes) !== null && _b !== void 0 ? _b : new Uint8Array();
        message.signatures = ((_c = object.signatures) === null || _c === void 0 ? void 0 : _c.map((e) => e)) || [];
        return message;
    },
};
function createBaseSignDoc() {
    return {
        bodyBytes: new Uint8Array(),
        authInfoBytes: new Uint8Array(),
        chainId: "",
        accountNumber: long_1.default.UZERO,
    };
}
exports.SignDoc = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.bodyBytes.length !== 0) {
            writer.uint32(10).bytes(message.bodyBytes);
        }
        if (message.authInfoBytes.length !== 0) {
            writer.uint32(18).bytes(message.authInfoBytes);
        }
        if (message.chainId !== "") {
            writer.uint32(26).string(message.chainId);
        }
        if (!message.accountNumber.isZero()) {
            writer.uint32(32).uint64(message.accountNumber);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSignDoc();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.bodyBytes = reader.bytes();
                    break;
                case 2:
                    message.authInfoBytes = reader.bytes();
                    break;
                case 3:
                    message.chainId = reader.string();
                    break;
                case 4:
                    message.accountNumber = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            bodyBytes: isSet(object.bodyBytes) ? bytesFromBase64(object.bodyBytes) : new Uint8Array(),
            authInfoBytes: isSet(object.authInfoBytes) ? bytesFromBase64(object.authInfoBytes) : new Uint8Array(),
            chainId: isSet(object.chainId) ? String(object.chainId) : "",
            accountNumber: isSet(object.accountNumber) ? long_1.default.fromValue(object.accountNumber) : long_1.default.UZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        message.bodyBytes !== undefined &&
            (obj.bodyBytes = base64FromBytes(message.bodyBytes !== undefined ? message.bodyBytes : new Uint8Array()));
        message.authInfoBytes !== undefined &&
            (obj.authInfoBytes = base64FromBytes(message.authInfoBytes !== undefined ? message.authInfoBytes : new Uint8Array()));
        message.chainId !== undefined && (obj.chainId = message.chainId);
        message.accountNumber !== undefined &&
            (obj.accountNumber = (message.accountNumber || long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseSignDoc();
        message.bodyBytes = (_a = object.bodyBytes) !== null && _a !== void 0 ? _a : new Uint8Array();
        message.authInfoBytes = (_b = object.authInfoBytes) !== null && _b !== void 0 ? _b : new Uint8Array();
        message.chainId = (_c = object.chainId) !== null && _c !== void 0 ? _c : "";
        message.accountNumber =
            object.accountNumber !== undefined && object.accountNumber !== null
                ? long_1.default.fromValue(object.accountNumber)
                : long_1.default.UZERO;
        return message;
    },
};
function createBaseTxBody() {
    return {
        messages: [],
        memo: "",
        timeoutHeight: long_1.default.UZERO,
        extensionOptions: [],
        nonCriticalExtensionOptions: [],
    };
}
exports.TxBody = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.messages) {
            any_1.Any.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.memo !== "") {
            writer.uint32(18).string(message.memo);
        }
        if (!message.timeoutHeight.isZero()) {
            writer.uint32(24).uint64(message.timeoutHeight);
        }
        for (const v of message.extensionOptions) {
            any_1.Any.encode(v, writer.uint32(8186).fork()).ldelim();
        }
        for (const v of message.nonCriticalExtensionOptions) {
            any_1.Any.encode(v, writer.uint32(16378).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTxBody();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.messages.push(any_1.Any.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.memo = reader.string();
                    break;
                case 3:
                    message.timeoutHeight = reader.uint64();
                    break;
                case 1023:
                    message.extensionOptions.push(any_1.Any.decode(reader, reader.uint32()));
                    break;
                case 2047:
                    message.nonCriticalExtensionOptions.push(any_1.Any.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            messages: Array.isArray(object === null || object === void 0 ? void 0 : object.messages) ? object.messages.map((e) => any_1.Any.fromJSON(e)) : [],
            memo: isSet(object.memo) ? String(object.memo) : "",
            timeoutHeight: isSet(object.timeoutHeight) ? long_1.default.fromValue(object.timeoutHeight) : long_1.default.UZERO,
            extensionOptions: Array.isArray(object === null || object === void 0 ? void 0 : object.extensionOptions)
                ? object.extensionOptions.map((e) => any_1.Any.fromJSON(e))
                : [],
            nonCriticalExtensionOptions: Array.isArray(object === null || object === void 0 ? void 0 : object.nonCriticalExtensionOptions)
                ? object.nonCriticalExtensionOptions.map((e) => any_1.Any.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.messages) {
            obj.messages = message.messages.map((e) => (e ? any_1.Any.toJSON(e) : undefined));
        }
        else {
            obj.messages = [];
        }
        message.memo !== undefined && (obj.memo = message.memo);
        message.timeoutHeight !== undefined &&
            (obj.timeoutHeight = (message.timeoutHeight || long_1.default.UZERO).toString());
        if (message.extensionOptions) {
            obj.extensionOptions = message.extensionOptions.map((e) => (e ? any_1.Any.toJSON(e) : undefined));
        }
        else {
            obj.extensionOptions = [];
        }
        if (message.nonCriticalExtensionOptions) {
            obj.nonCriticalExtensionOptions = message.nonCriticalExtensionOptions.map((e) => e ? any_1.Any.toJSON(e) : undefined);
        }
        else {
            obj.nonCriticalExtensionOptions = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d;
        const message = createBaseTxBody();
        message.messages = ((_a = object.messages) === null || _a === void 0 ? void 0 : _a.map((e) => any_1.Any.fromPartial(e))) || [];
        message.memo = (_b = object.memo) !== null && _b !== void 0 ? _b : "";
        message.timeoutHeight =
            object.timeoutHeight !== undefined && object.timeoutHeight !== null
                ? long_1.default.fromValue(object.timeoutHeight)
                : long_1.default.UZERO;
        message.extensionOptions = ((_c = object.extensionOptions) === null || _c === void 0 ? void 0 : _c.map((e) => any_1.Any.fromPartial(e))) || [];
        message.nonCriticalExtensionOptions =
            ((_d = object.nonCriticalExtensionOptions) === null || _d === void 0 ? void 0 : _d.map((e) => any_1.Any.fromPartial(e))) || [];
        return message;
    },
};
function createBaseAuthInfo() {
    return { signerInfos: [], fee: undefined };
}
exports.AuthInfo = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.signerInfos) {
            exports.SignerInfo.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.fee !== undefined) {
            exports.Fee.encode(message.fee, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAuthInfo();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.signerInfos.push(exports.SignerInfo.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.fee = exports.Fee.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            signerInfos: Array.isArray(object === null || object === void 0 ? void 0 : object.signerInfos)
                ? object.signerInfos.map((e) => exports.SignerInfo.fromJSON(e))
                : [],
            fee: isSet(object.fee) ? exports.Fee.fromJSON(object.fee) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.signerInfos) {
            obj.signerInfos = message.signerInfos.map((e) => (e ? exports.SignerInfo.toJSON(e) : undefined));
        }
        else {
            obj.signerInfos = [];
        }
        message.fee !== undefined && (obj.fee = message.fee ? exports.Fee.toJSON(message.fee) : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseAuthInfo();
        message.signerInfos = ((_a = object.signerInfos) === null || _a === void 0 ? void 0 : _a.map((e) => exports.SignerInfo.fromPartial(e))) || [];
        message.fee = object.fee !== undefined && object.fee !== null ? exports.Fee.fromPartial(object.fee) : undefined;
        return message;
    },
};
function createBaseSignerInfo() {
    return { publicKey: undefined, modeInfo: undefined, sequence: long_1.default.UZERO };
}
exports.SignerInfo = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.publicKey !== undefined) {
            any_1.Any.encode(message.publicKey, writer.uint32(10).fork()).ldelim();
        }
        if (message.modeInfo !== undefined) {
            exports.ModeInfo.encode(message.modeInfo, writer.uint32(18).fork()).ldelim();
        }
        if (!message.sequence.isZero()) {
            writer.uint32(24).uint64(message.sequence);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSignerInfo();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.publicKey = any_1.Any.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.modeInfo = exports.ModeInfo.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.sequence = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            publicKey: isSet(object.publicKey) ? any_1.Any.fromJSON(object.publicKey) : undefined,
            modeInfo: isSet(object.modeInfo) ? exports.ModeInfo.fromJSON(object.modeInfo) : undefined,
            sequence: isSet(object.sequence) ? long_1.default.fromValue(object.sequence) : long_1.default.UZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        message.publicKey !== undefined &&
            (obj.publicKey = message.publicKey ? any_1.Any.toJSON(message.publicKey) : undefined);
        message.modeInfo !== undefined &&
            (obj.modeInfo = message.modeInfo ? exports.ModeInfo.toJSON(message.modeInfo) : undefined);
        message.sequence !== undefined && (obj.sequence = (message.sequence || long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseSignerInfo();
        message.publicKey =
            object.publicKey !== undefined && object.publicKey !== null
                ? any_1.Any.fromPartial(object.publicKey)
                : undefined;
        message.modeInfo =
            object.modeInfo !== undefined && object.modeInfo !== null
                ? exports.ModeInfo.fromPartial(object.modeInfo)
                : undefined;
        message.sequence =
            object.sequence !== undefined && object.sequence !== null
                ? long_1.default.fromValue(object.sequence)
                : long_1.default.UZERO;
        return message;
    },
};
function createBaseModeInfo() {
    return { single: undefined, multi: undefined };
}
exports.ModeInfo = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.single !== undefined) {
            exports.ModeInfo_Single.encode(message.single, writer.uint32(10).fork()).ldelim();
        }
        if (message.multi !== undefined) {
            exports.ModeInfo_Multi.encode(message.multi, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseModeInfo();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.single = exports.ModeInfo_Single.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.multi = exports.ModeInfo_Multi.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            single: isSet(object.single) ? exports.ModeInfo_Single.fromJSON(object.single) : undefined,
            multi: isSet(object.multi) ? exports.ModeInfo_Multi.fromJSON(object.multi) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.single !== undefined &&
            (obj.single = message.single ? exports.ModeInfo_Single.toJSON(message.single) : undefined);
        message.multi !== undefined &&
            (obj.multi = message.multi ? exports.ModeInfo_Multi.toJSON(message.multi) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseModeInfo();
        message.single =
            object.single !== undefined && object.single !== null
                ? exports.ModeInfo_Single.fromPartial(object.single)
                : undefined;
        message.multi =
            object.multi !== undefined && object.multi !== null
                ? exports.ModeInfo_Multi.fromPartial(object.multi)
                : undefined;
        return message;
    },
};
function createBaseModeInfo_Single() {
    return { mode: 0 };
}
exports.ModeInfo_Single = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.mode !== 0) {
            writer.uint32(8).int32(message.mode);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseModeInfo_Single();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.mode = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { mode: isSet(object.mode) ? (0, signing_1.signModeFromJSON)(object.mode) : 0 };
    },
    toJSON(message) {
        const obj = {};
        message.mode !== undefined && (obj.mode = (0, signing_1.signModeToJSON)(message.mode));
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseModeInfo_Single();
        message.mode = (_a = object.mode) !== null && _a !== void 0 ? _a : 0;
        return message;
    },
};
function createBaseModeInfo_Multi() {
    return { bitarray: undefined, modeInfos: [] };
}
exports.ModeInfo_Multi = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.bitarray !== undefined) {
            multisig_1.CompactBitArray.encode(message.bitarray, writer.uint32(10).fork()).ldelim();
        }
        for (const v of message.modeInfos) {
            exports.ModeInfo.encode(v, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseModeInfo_Multi();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.bitarray = multisig_1.CompactBitArray.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.modeInfos.push(exports.ModeInfo.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            bitarray: isSet(object.bitarray) ? multisig_1.CompactBitArray.fromJSON(object.bitarray) : undefined,
            modeInfos: Array.isArray(object === null || object === void 0 ? void 0 : object.modeInfos)
                ? object.modeInfos.map((e) => exports.ModeInfo.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        message.bitarray !== undefined &&
            (obj.bitarray = message.bitarray ? multisig_1.CompactBitArray.toJSON(message.bitarray) : undefined);
        if (message.modeInfos) {
            obj.modeInfos = message.modeInfos.map((e) => (e ? exports.ModeInfo.toJSON(e) : undefined));
        }
        else {
            obj.modeInfos = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseModeInfo_Multi();
        message.bitarray =
            object.bitarray !== undefined && object.bitarray !== null
                ? multisig_1.CompactBitArray.fromPartial(object.bitarray)
                : undefined;
        message.modeInfos = ((_a = object.modeInfos) === null || _a === void 0 ? void 0 : _a.map((e) => exports.ModeInfo.fromPartial(e))) || [];
        return message;
    },
};
function createBaseFee() {
    return { amount: [], gasLimit: long_1.default.UZERO, payer: "", granter: "" };
}
exports.Fee = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.amount) {
            coin_1.Coin.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (!message.gasLimit.isZero()) {
            writer.uint32(16).uint64(message.gasLimit);
        }
        if (message.payer !== "") {
            writer.uint32(26).string(message.payer);
        }
        if (message.granter !== "") {
            writer.uint32(34).string(message.granter);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseFee();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.amount.push(coin_1.Coin.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.gasLimit = reader.uint64();
                    break;
                case 3:
                    message.payer = reader.string();
                    break;
                case 4:
                    message.granter = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            amount: Array.isArray(object === null || object === void 0 ? void 0 : object.amount) ? object.amount.map((e) => coin_1.Coin.fromJSON(e)) : [],
            gasLimit: isSet(object.gasLimit) ? long_1.default.fromValue(object.gasLimit) : long_1.default.UZERO,
            payer: isSet(object.payer) ? String(object.payer) : "",
            granter: isSet(object.granter) ? String(object.granter) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.amount) {
            obj.amount = message.amount.map((e) => (e ? coin_1.Coin.toJSON(e) : undefined));
        }
        else {
            obj.amount = [];
        }
        message.gasLimit !== undefined && (obj.gasLimit = (message.gasLimit || long_1.default.UZERO).toString());
        message.payer !== undefined && (obj.payer = message.payer);
        message.granter !== undefined && (obj.granter = message.granter);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseFee();
        message.amount = ((_a = object.amount) === null || _a === void 0 ? void 0 : _a.map((e) => coin_1.Coin.fromPartial(e))) || [];
        message.gasLimit =
            object.gasLimit !== undefined && object.gasLimit !== null
                ? long_1.default.fromValue(object.gasLimit)
                : long_1.default.UZERO;
        message.payer = (_b = object.payer) !== null && _b !== void 0 ? _b : "";
        message.granter = (_c = object.granter) !== null && _c !== void 0 ? _c : "";
        return message;
    },
};
var globalThis = (() => {
    if (typeof globalThis !== "undefined") {
        return globalThis;
    }
    if (typeof self !== "undefined") {
        return self;
    }
    if (typeof window !== "undefined") {
        return window;
    }
    if (typeof __webpack_require__.g !== "undefined") {
        return __webpack_require__.g;
    }
    throw "Unable to locate global object";
})();
function bytesFromBase64(b64) {
    if (globalThis.Buffer) {
        return Uint8Array.from(globalThis.Buffer.from(b64, "base64"));
    }
    else {
        const bin = globalThis.atob(b64);
        const arr = new Uint8Array(bin.length);
        for (let i = 0; i < bin.length; ++i) {
            arr[i] = bin.charCodeAt(i);
        }
        return arr;
    }
}
function base64FromBytes(arr) {
    if (globalThis.Buffer) {
        return globalThis.Buffer.from(arr).toString("base64");
    }
    else {
        const bin = [];
        arr.forEach((byte) => {
            bin.push(String.fromCharCode(byte));
        });
        return globalThis.btoa(bin.join(""));
    }
}
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=tx.js.map

/***/ }),

/***/ 48419:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ModuleVersion = exports.CancelSoftwareUpgradeProposal = exports.SoftwareUpgradeProposal = exports.Plan = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(__webpack_require__(47873));
const minimal_1 = __importDefault(__webpack_require__(62100));
const any_1 = __webpack_require__(90007);
const timestamp_1 = __webpack_require__(76620);
exports.protobufPackage = "cosmos.upgrade.v1beta1";
function createBasePlan() {
    return { name: "", time: undefined, height: long_1.default.ZERO, info: "", upgradedClientState: undefined };
}
exports.Plan = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.name !== "") {
            writer.uint32(10).string(message.name);
        }
        if (message.time !== undefined) {
            timestamp_1.Timestamp.encode(message.time, writer.uint32(18).fork()).ldelim();
        }
        if (!message.height.isZero()) {
            writer.uint32(24).int64(message.height);
        }
        if (message.info !== "") {
            writer.uint32(34).string(message.info);
        }
        if (message.upgradedClientState !== undefined) {
            any_1.Any.encode(message.upgradedClientState, writer.uint32(42).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlan();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.name = reader.string();
                    break;
                case 2:
                    message.time = timestamp_1.Timestamp.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.height = reader.int64();
                    break;
                case 4:
                    message.info = reader.string();
                    break;
                case 5:
                    message.upgradedClientState = any_1.Any.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            name: isSet(object.name) ? String(object.name) : "",
            time: isSet(object.time) ? fromJsonTimestamp(object.time) : undefined,
            height: isSet(object.height) ? long_1.default.fromValue(object.height) : long_1.default.ZERO,
            info: isSet(object.info) ? String(object.info) : "",
            upgradedClientState: isSet(object.upgradedClientState)
                ? any_1.Any.fromJSON(object.upgradedClientState)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.name !== undefined && (obj.name = message.name);
        message.time !== undefined && (obj.time = fromTimestamp(message.time).toISOString());
        message.height !== undefined && (obj.height = (message.height || long_1.default.ZERO).toString());
        message.info !== undefined && (obj.info = message.info);
        message.upgradedClientState !== undefined &&
            (obj.upgradedClientState = message.upgradedClientState
                ? any_1.Any.toJSON(message.upgradedClientState)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBasePlan();
        message.name = (_a = object.name) !== null && _a !== void 0 ? _a : "";
        message.time =
            object.time !== undefined && object.time !== null ? timestamp_1.Timestamp.fromPartial(object.time) : undefined;
        message.height =
            object.height !== undefined && object.height !== null ? long_1.default.fromValue(object.height) : long_1.default.ZERO;
        message.info = (_b = object.info) !== null && _b !== void 0 ? _b : "";
        message.upgradedClientState =
            object.upgradedClientState !== undefined && object.upgradedClientState !== null
                ? any_1.Any.fromPartial(object.upgradedClientState)
                : undefined;
        return message;
    },
};
function createBaseSoftwareUpgradeProposal() {
    return { title: "", description: "", plan: undefined };
}
exports.SoftwareUpgradeProposal = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.title !== "") {
            writer.uint32(10).string(message.title);
        }
        if (message.description !== "") {
            writer.uint32(18).string(message.description);
        }
        if (message.plan !== undefined) {
            exports.Plan.encode(message.plan, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSoftwareUpgradeProposal();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.title = reader.string();
                    break;
                case 2:
                    message.description = reader.string();
                    break;
                case 3:
                    message.plan = exports.Plan.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            title: isSet(object.title) ? String(object.title) : "",
            description: isSet(object.description) ? String(object.description) : "",
            plan: isSet(object.plan) ? exports.Plan.fromJSON(object.plan) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.title !== undefined && (obj.title = message.title);
        message.description !== undefined && (obj.description = message.description);
        message.plan !== undefined && (obj.plan = message.plan ? exports.Plan.toJSON(message.plan) : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseSoftwareUpgradeProposal();
        message.title = (_a = object.title) !== null && _a !== void 0 ? _a : "";
        message.description = (_b = object.description) !== null && _b !== void 0 ? _b : "";
        message.plan =
            object.plan !== undefined && object.plan !== null ? exports.Plan.fromPartial(object.plan) : undefined;
        return message;
    },
};
function createBaseCancelSoftwareUpgradeProposal() {
    return { title: "", description: "" };
}
exports.CancelSoftwareUpgradeProposal = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.title !== "") {
            writer.uint32(10).string(message.title);
        }
        if (message.description !== "") {
            writer.uint32(18).string(message.description);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCancelSoftwareUpgradeProposal();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.title = reader.string();
                    break;
                case 2:
                    message.description = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            title: isSet(object.title) ? String(object.title) : "",
            description: isSet(object.description) ? String(object.description) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.title !== undefined && (obj.title = message.title);
        message.description !== undefined && (obj.description = message.description);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseCancelSoftwareUpgradeProposal();
        message.title = (_a = object.title) !== null && _a !== void 0 ? _a : "";
        message.description = (_b = object.description) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
function createBaseModuleVersion() {
    return { name: "", version: long_1.default.UZERO };
}
exports.ModuleVersion = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.name !== "") {
            writer.uint32(10).string(message.name);
        }
        if (!message.version.isZero()) {
            writer.uint32(16).uint64(message.version);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseModuleVersion();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.name = reader.string();
                    break;
                case 2:
                    message.version = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            name: isSet(object.name) ? String(object.name) : "",
            version: isSet(object.version) ? long_1.default.fromValue(object.version) : long_1.default.UZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        message.name !== undefined && (obj.name = message.name);
        message.version !== undefined && (obj.version = (message.version || long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseModuleVersion();
        message.name = (_a = object.name) !== null && _a !== void 0 ? _a : "";
        message.version =
            object.version !== undefined && object.version !== null ? long_1.default.fromValue(object.version) : long_1.default.UZERO;
        return message;
    },
};
function toTimestamp(date) {
    const seconds = numberToLong(date.getTime() / 1000);
    const nanos = (date.getTime() % 1000) * 1000000;
    return { seconds, nanos };
}
function fromTimestamp(t) {
    let millis = t.seconds.toNumber() * 1000;
    millis += t.nanos / 1000000;
    return new Date(millis);
}
function fromJsonTimestamp(o) {
    if (o instanceof Date) {
        return toTimestamp(o);
    }
    else if (typeof o === "string") {
        return toTimestamp(new Date(o));
    }
    else {
        return timestamp_1.Timestamp.fromJSON(o);
    }
}
function numberToLong(number) {
    return long_1.default.fromNumber(number);
}
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=upgrade.js.map

/***/ }),

/***/ 32079:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MsgClientImpl = exports.MsgCreateVestingAccountResponse = exports.MsgCreateVestingAccount = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(__webpack_require__(47873));
const minimal_1 = __importDefault(__webpack_require__(62100));
const coin_1 = __webpack_require__(26119);
exports.protobufPackage = "cosmos.vesting.v1beta1";
function createBaseMsgCreateVestingAccount() {
    return { fromAddress: "", toAddress: "", amount: [], endTime: long_1.default.ZERO, delayed: false };
}
exports.MsgCreateVestingAccount = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.fromAddress !== "") {
            writer.uint32(10).string(message.fromAddress);
        }
        if (message.toAddress !== "") {
            writer.uint32(18).string(message.toAddress);
        }
        for (const v of message.amount) {
            coin_1.Coin.encode(v, writer.uint32(26).fork()).ldelim();
        }
        if (!message.endTime.isZero()) {
            writer.uint32(32).int64(message.endTime);
        }
        if (message.delayed === true) {
            writer.uint32(40).bool(message.delayed);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgCreateVestingAccount();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.fromAddress = reader.string();
                    break;
                case 2:
                    message.toAddress = reader.string();
                    break;
                case 3:
                    message.amount.push(coin_1.Coin.decode(reader, reader.uint32()));
                    break;
                case 4:
                    message.endTime = reader.int64();
                    break;
                case 5:
                    message.delayed = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            fromAddress: isSet(object.fromAddress) ? String(object.fromAddress) : "",
            toAddress: isSet(object.toAddress) ? String(object.toAddress) : "",
            amount: Array.isArray(object === null || object === void 0 ? void 0 : object.amount) ? object.amount.map((e) => coin_1.Coin.fromJSON(e)) : [],
            endTime: isSet(object.endTime) ? long_1.default.fromValue(object.endTime) : long_1.default.ZERO,
            delayed: isSet(object.delayed) ? Boolean(object.delayed) : false,
        };
    },
    toJSON(message) {
        const obj = {};
        message.fromAddress !== undefined && (obj.fromAddress = message.fromAddress);
        message.toAddress !== undefined && (obj.toAddress = message.toAddress);
        if (message.amount) {
            obj.amount = message.amount.map((e) => (e ? coin_1.Coin.toJSON(e) : undefined));
        }
        else {
            obj.amount = [];
        }
        message.endTime !== undefined && (obj.endTime = (message.endTime || long_1.default.ZERO).toString());
        message.delayed !== undefined && (obj.delayed = message.delayed);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d;
        const message = createBaseMsgCreateVestingAccount();
        message.fromAddress = (_a = object.fromAddress) !== null && _a !== void 0 ? _a : "";
        message.toAddress = (_b = object.toAddress) !== null && _b !== void 0 ? _b : "";
        message.amount = ((_c = object.amount) === null || _c === void 0 ? void 0 : _c.map((e) => coin_1.Coin.fromPartial(e))) || [];
        message.endTime =
            object.endTime !== undefined && object.endTime !== null ? long_1.default.fromValue(object.endTime) : long_1.default.ZERO;
        message.delayed = (_d = object.delayed) !== null && _d !== void 0 ? _d : false;
        return message;
    },
};
function createBaseMsgCreateVestingAccountResponse() {
    return {};
}
exports.MsgCreateVestingAccountResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgCreateVestingAccountResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgCreateVestingAccountResponse();
        return message;
    },
};
class MsgClientImpl {
    constructor(rpc) {
        this.rpc = rpc;
        this.CreateVestingAccount = this.CreateVestingAccount.bind(this);
    }
    CreateVestingAccount(request) {
        const data = exports.MsgCreateVestingAccount.encode(request).finish();
        const promise = this.rpc.request("cosmos.vesting.v1beta1.Msg", "CreateVestingAccount", data);
        return promise.then((data) => exports.MsgCreateVestingAccountResponse.decode(new minimal_1.default.Reader(data)));
    }
}
exports.MsgClientImpl = MsgClientImpl;
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=tx.js.map

/***/ }),

/***/ 41694:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PermanentLockedAccount = exports.PeriodicVestingAccount = exports.Period = exports.DelayedVestingAccount = exports.ContinuousVestingAccount = exports.BaseVestingAccount = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(__webpack_require__(47873));
const minimal_1 = __importDefault(__webpack_require__(62100));
const auth_1 = __webpack_require__(32024);
const coin_1 = __webpack_require__(26119);
exports.protobufPackage = "cosmos.vesting.v1beta1";
function createBaseBaseVestingAccount() {
    return {
        baseAccount: undefined,
        originalVesting: [],
        delegatedFree: [],
        delegatedVesting: [],
        endTime: long_1.default.ZERO,
    };
}
exports.BaseVestingAccount = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.baseAccount !== undefined) {
            auth_1.BaseAccount.encode(message.baseAccount, writer.uint32(10).fork()).ldelim();
        }
        for (const v of message.originalVesting) {
            coin_1.Coin.encode(v, writer.uint32(18).fork()).ldelim();
        }
        for (const v of message.delegatedFree) {
            coin_1.Coin.encode(v, writer.uint32(26).fork()).ldelim();
        }
        for (const v of message.delegatedVesting) {
            coin_1.Coin.encode(v, writer.uint32(34).fork()).ldelim();
        }
        if (!message.endTime.isZero()) {
            writer.uint32(40).int64(message.endTime);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseBaseVestingAccount();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.baseAccount = auth_1.BaseAccount.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.originalVesting.push(coin_1.Coin.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.delegatedFree.push(coin_1.Coin.decode(reader, reader.uint32()));
                    break;
                case 4:
                    message.delegatedVesting.push(coin_1.Coin.decode(reader, reader.uint32()));
                    break;
                case 5:
                    message.endTime = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            baseAccount: isSet(object.baseAccount) ? auth_1.BaseAccount.fromJSON(object.baseAccount) : undefined,
            originalVesting: Array.isArray(object === null || object === void 0 ? void 0 : object.originalVesting)
                ? object.originalVesting.map((e) => coin_1.Coin.fromJSON(e))
                : [],
            delegatedFree: Array.isArray(object === null || object === void 0 ? void 0 : object.delegatedFree)
                ? object.delegatedFree.map((e) => coin_1.Coin.fromJSON(e))
                : [],
            delegatedVesting: Array.isArray(object === null || object === void 0 ? void 0 : object.delegatedVesting)
                ? object.delegatedVesting.map((e) => coin_1.Coin.fromJSON(e))
                : [],
            endTime: isSet(object.endTime) ? long_1.default.fromValue(object.endTime) : long_1.default.ZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        message.baseAccount !== undefined &&
            (obj.baseAccount = message.baseAccount ? auth_1.BaseAccount.toJSON(message.baseAccount) : undefined);
        if (message.originalVesting) {
            obj.originalVesting = message.originalVesting.map((e) => (e ? coin_1.Coin.toJSON(e) : undefined));
        }
        else {
            obj.originalVesting = [];
        }
        if (message.delegatedFree) {
            obj.delegatedFree = message.delegatedFree.map((e) => (e ? coin_1.Coin.toJSON(e) : undefined));
        }
        else {
            obj.delegatedFree = [];
        }
        if (message.delegatedVesting) {
            obj.delegatedVesting = message.delegatedVesting.map((e) => (e ? coin_1.Coin.toJSON(e) : undefined));
        }
        else {
            obj.delegatedVesting = [];
        }
        message.endTime !== undefined && (obj.endTime = (message.endTime || long_1.default.ZERO).toString());
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseBaseVestingAccount();
        message.baseAccount =
            object.baseAccount !== undefined && object.baseAccount !== null
                ? auth_1.BaseAccount.fromPartial(object.baseAccount)
                : undefined;
        message.originalVesting = ((_a = object.originalVesting) === null || _a === void 0 ? void 0 : _a.map((e) => coin_1.Coin.fromPartial(e))) || [];
        message.delegatedFree = ((_b = object.delegatedFree) === null || _b === void 0 ? void 0 : _b.map((e) => coin_1.Coin.fromPartial(e))) || [];
        message.delegatedVesting = ((_c = object.delegatedVesting) === null || _c === void 0 ? void 0 : _c.map((e) => coin_1.Coin.fromPartial(e))) || [];
        message.endTime =
            object.endTime !== undefined && object.endTime !== null ? long_1.default.fromValue(object.endTime) : long_1.default.ZERO;
        return message;
    },
};
function createBaseContinuousVestingAccount() {
    return { baseVestingAccount: undefined, startTime: long_1.default.ZERO };
}
exports.ContinuousVestingAccount = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.baseVestingAccount !== undefined) {
            exports.BaseVestingAccount.encode(message.baseVestingAccount, writer.uint32(10).fork()).ldelim();
        }
        if (!message.startTime.isZero()) {
            writer.uint32(16).int64(message.startTime);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseContinuousVestingAccount();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.baseVestingAccount = exports.BaseVestingAccount.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.startTime = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            baseVestingAccount: isSet(object.baseVestingAccount)
                ? exports.BaseVestingAccount.fromJSON(object.baseVestingAccount)
                : undefined,
            startTime: isSet(object.startTime) ? long_1.default.fromValue(object.startTime) : long_1.default.ZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        message.baseVestingAccount !== undefined &&
            (obj.baseVestingAccount = message.baseVestingAccount
                ? exports.BaseVestingAccount.toJSON(message.baseVestingAccount)
                : undefined);
        message.startTime !== undefined && (obj.startTime = (message.startTime || long_1.default.ZERO).toString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseContinuousVestingAccount();
        message.baseVestingAccount =
            object.baseVestingAccount !== undefined && object.baseVestingAccount !== null
                ? exports.BaseVestingAccount.fromPartial(object.baseVestingAccount)
                : undefined;
        message.startTime =
            object.startTime !== undefined && object.startTime !== null
                ? long_1.default.fromValue(object.startTime)
                : long_1.default.ZERO;
        return message;
    },
};
function createBaseDelayedVestingAccount() {
    return { baseVestingAccount: undefined };
}
exports.DelayedVestingAccount = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.baseVestingAccount !== undefined) {
            exports.BaseVestingAccount.encode(message.baseVestingAccount, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDelayedVestingAccount();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.baseVestingAccount = exports.BaseVestingAccount.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            baseVestingAccount: isSet(object.baseVestingAccount)
                ? exports.BaseVestingAccount.fromJSON(object.baseVestingAccount)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.baseVestingAccount !== undefined &&
            (obj.baseVestingAccount = message.baseVestingAccount
                ? exports.BaseVestingAccount.toJSON(message.baseVestingAccount)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseDelayedVestingAccount();
        message.baseVestingAccount =
            object.baseVestingAccount !== undefined && object.baseVestingAccount !== null
                ? exports.BaseVestingAccount.fromPartial(object.baseVestingAccount)
                : undefined;
        return message;
    },
};
function createBasePeriod() {
    return { length: long_1.default.ZERO, amount: [] };
}
exports.Period = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (!message.length.isZero()) {
            writer.uint32(8).int64(message.length);
        }
        for (const v of message.amount) {
            coin_1.Coin.encode(v, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePeriod();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.length = reader.int64();
                    break;
                case 2:
                    message.amount.push(coin_1.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            length: isSet(object.length) ? long_1.default.fromValue(object.length) : long_1.default.ZERO,
            amount: Array.isArray(object === null || object === void 0 ? void 0 : object.amount) ? object.amount.map((e) => coin_1.Coin.fromJSON(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        message.length !== undefined && (obj.length = (message.length || long_1.default.ZERO).toString());
        if (message.amount) {
            obj.amount = message.amount.map((e) => (e ? coin_1.Coin.toJSON(e) : undefined));
        }
        else {
            obj.amount = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBasePeriod();
        message.length =
            object.length !== undefined && object.length !== null ? long_1.default.fromValue(object.length) : long_1.default.ZERO;
        message.amount = ((_a = object.amount) === null || _a === void 0 ? void 0 : _a.map((e) => coin_1.Coin.fromPartial(e))) || [];
        return message;
    },
};
function createBasePeriodicVestingAccount() {
    return { baseVestingAccount: undefined, startTime: long_1.default.ZERO, vestingPeriods: [] };
}
exports.PeriodicVestingAccount = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.baseVestingAccount !== undefined) {
            exports.BaseVestingAccount.encode(message.baseVestingAccount, writer.uint32(10).fork()).ldelim();
        }
        if (!message.startTime.isZero()) {
            writer.uint32(16).int64(message.startTime);
        }
        for (const v of message.vestingPeriods) {
            exports.Period.encode(v, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePeriodicVestingAccount();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.baseVestingAccount = exports.BaseVestingAccount.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.startTime = reader.int64();
                    break;
                case 3:
                    message.vestingPeriods.push(exports.Period.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            baseVestingAccount: isSet(object.baseVestingAccount)
                ? exports.BaseVestingAccount.fromJSON(object.baseVestingAccount)
                : undefined,
            startTime: isSet(object.startTime) ? long_1.default.fromValue(object.startTime) : long_1.default.ZERO,
            vestingPeriods: Array.isArray(object === null || object === void 0 ? void 0 : object.vestingPeriods)
                ? object.vestingPeriods.map((e) => exports.Period.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        message.baseVestingAccount !== undefined &&
            (obj.baseVestingAccount = message.baseVestingAccount
                ? exports.BaseVestingAccount.toJSON(message.baseVestingAccount)
                : undefined);
        message.startTime !== undefined && (obj.startTime = (message.startTime || long_1.default.ZERO).toString());
        if (message.vestingPeriods) {
            obj.vestingPeriods = message.vestingPeriods.map((e) => (e ? exports.Period.toJSON(e) : undefined));
        }
        else {
            obj.vestingPeriods = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBasePeriodicVestingAccount();
        message.baseVestingAccount =
            object.baseVestingAccount !== undefined && object.baseVestingAccount !== null
                ? exports.BaseVestingAccount.fromPartial(object.baseVestingAccount)
                : undefined;
        message.startTime =
            object.startTime !== undefined && object.startTime !== null
                ? long_1.default.fromValue(object.startTime)
                : long_1.default.ZERO;
        message.vestingPeriods = ((_a = object.vestingPeriods) === null || _a === void 0 ? void 0 : _a.map((e) => exports.Period.fromPartial(e))) || [];
        return message;
    },
};
function createBasePermanentLockedAccount() {
    return { baseVestingAccount: undefined };
}
exports.PermanentLockedAccount = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.baseVestingAccount !== undefined) {
            exports.BaseVestingAccount.encode(message.baseVestingAccount, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePermanentLockedAccount();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.baseVestingAccount = exports.BaseVestingAccount.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            baseVestingAccount: isSet(object.baseVestingAccount)
                ? exports.BaseVestingAccount.fromJSON(object.baseVestingAccount)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.baseVestingAccount !== undefined &&
            (obj.baseVestingAccount = message.baseVestingAccount
                ? exports.BaseVestingAccount.toJSON(message.baseVestingAccount)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBasePermanentLockedAccount();
        message.baseVestingAccount =
            object.baseVestingAccount !== undefined && object.baseVestingAccount !== null
                ? exports.BaseVestingAccount.fromPartial(object.baseVestingAccount)
                : undefined;
        return message;
    },
};
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=vesting.js.map

/***/ }),

/***/ 90007:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Any = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(__webpack_require__(47873));
const minimal_1 = __importDefault(__webpack_require__(62100));
exports.protobufPackage = "google.protobuf";
function createBaseAny() {
    return { typeUrl: "", value: new Uint8Array() };
}
exports.Any = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.typeUrl !== "") {
            writer.uint32(10).string(message.typeUrl);
        }
        if (message.value.length !== 0) {
            writer.uint32(18).bytes(message.value);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAny();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.typeUrl = reader.string();
                    break;
                case 2:
                    message.value = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            typeUrl: isSet(object.typeUrl) ? String(object.typeUrl) : "",
            value: isSet(object.value) ? bytesFromBase64(object.value) : new Uint8Array(),
        };
    },
    toJSON(message) {
        const obj = {};
        message.typeUrl !== undefined && (obj.typeUrl = message.typeUrl);
        message.value !== undefined &&
            (obj.value = base64FromBytes(message.value !== undefined ? message.value : new Uint8Array()));
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseAny();
        message.typeUrl = (_a = object.typeUrl) !== null && _a !== void 0 ? _a : "";
        message.value = (_b = object.value) !== null && _b !== void 0 ? _b : new Uint8Array();
        return message;
    },
};
var globalThis = (() => {
    if (typeof globalThis !== "undefined") {
        return globalThis;
    }
    if (typeof self !== "undefined") {
        return self;
    }
    if (typeof window !== "undefined") {
        return window;
    }
    if (typeof __webpack_require__.g !== "undefined") {
        return __webpack_require__.g;
    }
    throw "Unable to locate global object";
})();
function bytesFromBase64(b64) {
    if (globalThis.Buffer) {
        return Uint8Array.from(globalThis.Buffer.from(b64, "base64"));
    }
    else {
        const bin = globalThis.atob(b64);
        const arr = new Uint8Array(bin.length);
        for (let i = 0; i < bin.length; ++i) {
            arr[i] = bin.charCodeAt(i);
        }
        return arr;
    }
}
function base64FromBytes(arr) {
    if (globalThis.Buffer) {
        return globalThis.Buffer.from(arr).toString("base64");
    }
    else {
        const bin = [];
        arr.forEach((byte) => {
            bin.push(String.fromCharCode(byte));
        });
        return globalThis.btoa(bin.join(""));
    }
}
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=any.js.map

/***/ }),

/***/ 59769:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Duration = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(__webpack_require__(47873));
const minimal_1 = __importDefault(__webpack_require__(62100));
exports.protobufPackage = "google.protobuf";
function createBaseDuration() {
    return { seconds: long_1.default.ZERO, nanos: 0 };
}
exports.Duration = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (!message.seconds.isZero()) {
            writer.uint32(8).int64(message.seconds);
        }
        if (message.nanos !== 0) {
            writer.uint32(16).int32(message.nanos);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDuration();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.seconds = reader.int64();
                    break;
                case 2:
                    message.nanos = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            seconds: isSet(object.seconds) ? long_1.default.fromValue(object.seconds) : long_1.default.ZERO,
            nanos: isSet(object.nanos) ? Number(object.nanos) : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        message.seconds !== undefined && (obj.seconds = (message.seconds || long_1.default.ZERO).toString());
        message.nanos !== undefined && (obj.nanos = Math.round(message.nanos));
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseDuration();
        message.seconds =
            object.seconds !== undefined && object.seconds !== null ? long_1.default.fromValue(object.seconds) : long_1.default.ZERO;
        message.nanos = (_a = object.nanos) !== null && _a !== void 0 ? _a : 0;
        return message;
    },
};
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=duration.js.map

/***/ }),

/***/ 76620:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Timestamp = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(__webpack_require__(47873));
const minimal_1 = __importDefault(__webpack_require__(62100));
exports.protobufPackage = "google.protobuf";
function createBaseTimestamp() {
    return { seconds: long_1.default.ZERO, nanos: 0 };
}
exports.Timestamp = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (!message.seconds.isZero()) {
            writer.uint32(8).int64(message.seconds);
        }
        if (message.nanos !== 0) {
            writer.uint32(16).int32(message.nanos);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTimestamp();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.seconds = reader.int64();
                    break;
                case 2:
                    message.nanos = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            seconds: isSet(object.seconds) ? long_1.default.fromValue(object.seconds) : long_1.default.ZERO,
            nanos: isSet(object.nanos) ? Number(object.nanos) : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        message.seconds !== undefined && (obj.seconds = (message.seconds || long_1.default.ZERO).toString());
        message.nanos !== undefined && (obj.nanos = Math.round(message.nanos));
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseTimestamp();
        message.seconds =
            object.seconds !== undefined && object.seconds !== null ? long_1.default.fromValue(object.seconds) : long_1.default.ZERO;
        message.nanos = (_a = object.nanos) !== null && _a !== void 0 ? _a : 0;
        return message;
    },
};
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=timestamp.js.map

/***/ }),

/***/ 35028:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.QueryClientImpl = exports.QueryDenomHashResponse = exports.QueryDenomHashRequest = exports.QueryParamsResponse = exports.QueryParamsRequest = exports.QueryDenomTracesResponse = exports.QueryDenomTracesRequest = exports.QueryDenomTraceResponse = exports.QueryDenomTraceRequest = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(__webpack_require__(47873));
const minimal_1 = __importDefault(__webpack_require__(62100));
const pagination_1 = __webpack_require__(62635);
const transfer_1 = __webpack_require__(93120);
exports.protobufPackage = "ibc.applications.transfer.v1";
function createBaseQueryDenomTraceRequest() {
    return { hash: "" };
}
exports.QueryDenomTraceRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.hash !== "") {
            writer.uint32(10).string(message.hash);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryDenomTraceRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.hash = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { hash: isSet(object.hash) ? String(object.hash) : "" };
    },
    toJSON(message) {
        const obj = {};
        message.hash !== undefined && (obj.hash = message.hash);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryDenomTraceRequest();
        message.hash = (_a = object.hash) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
function createBaseQueryDenomTraceResponse() {
    return { denomTrace: undefined };
}
exports.QueryDenomTraceResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.denomTrace !== undefined) {
            transfer_1.DenomTrace.encode(message.denomTrace, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryDenomTraceResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.denomTrace = transfer_1.DenomTrace.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { denomTrace: isSet(object.denomTrace) ? transfer_1.DenomTrace.fromJSON(object.denomTrace) : undefined };
    },
    toJSON(message) {
        const obj = {};
        message.denomTrace !== undefined &&
            (obj.denomTrace = message.denomTrace ? transfer_1.DenomTrace.toJSON(message.denomTrace) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryDenomTraceResponse();
        message.denomTrace =
            object.denomTrace !== undefined && object.denomTrace !== null
                ? transfer_1.DenomTrace.fromPartial(object.denomTrace)
                : undefined;
        return message;
    },
};
function createBaseQueryDenomTracesRequest() {
    return { pagination: undefined };
}
exports.QueryDenomTracesRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryDenomTracesRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { pagination: isSet(object.pagination) ? pagination_1.PageRequest.fromJSON(object.pagination) : undefined };
    },
    toJSON(message) {
        const obj = {};
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryDenomTracesRequest();
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryDenomTracesResponse() {
    return { denomTraces: [], pagination: undefined };
}
exports.QueryDenomTracesResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.denomTraces) {
            transfer_1.DenomTrace.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryDenomTracesResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.denomTraces.push(transfer_1.DenomTrace.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            denomTraces: Array.isArray(object === null || object === void 0 ? void 0 : object.denomTraces)
                ? object.denomTraces.map((e) => transfer_1.DenomTrace.fromJSON(e))
                : [],
            pagination: isSet(object.pagination) ? pagination_1.PageResponse.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.denomTraces) {
            obj.denomTraces = message.denomTraces.map((e) => (e ? transfer_1.DenomTrace.toJSON(e) : undefined));
        }
        else {
            obj.denomTraces = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryDenomTracesResponse();
        message.denomTraces = ((_a = object.denomTraces) === null || _a === void 0 ? void 0 : _a.map((e) => transfer_1.DenomTrace.fromPartial(e))) || [];
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryParamsRequest() {
    return {};
}
exports.QueryParamsRequest = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryParamsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseQueryParamsRequest();
        return message;
    },
};
function createBaseQueryParamsResponse() {
    return { params: undefined };
}
exports.QueryParamsResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.params !== undefined) {
            transfer_1.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryParamsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.params = transfer_1.Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { params: isSet(object.params) ? transfer_1.Params.fromJSON(object.params) : undefined };
    },
    toJSON(message) {
        const obj = {};
        message.params !== undefined && (obj.params = message.params ? transfer_1.Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryParamsResponse();
        message.params =
            object.params !== undefined && object.params !== null ? transfer_1.Params.fromPartial(object.params) : undefined;
        return message;
    },
};
function createBaseQueryDenomHashRequest() {
    return { trace: "" };
}
exports.QueryDenomHashRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.trace !== "") {
            writer.uint32(10).string(message.trace);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryDenomHashRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.trace = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { trace: isSet(object.trace) ? String(object.trace) : "" };
    },
    toJSON(message) {
        const obj = {};
        message.trace !== undefined && (obj.trace = message.trace);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryDenomHashRequest();
        message.trace = (_a = object.trace) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
function createBaseQueryDenomHashResponse() {
    return { hash: "" };
}
exports.QueryDenomHashResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.hash !== "") {
            writer.uint32(10).string(message.hash);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryDenomHashResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.hash = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { hash: isSet(object.hash) ? String(object.hash) : "" };
    },
    toJSON(message) {
        const obj = {};
        message.hash !== undefined && (obj.hash = message.hash);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryDenomHashResponse();
        message.hash = (_a = object.hash) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
class QueryClientImpl {
    constructor(rpc) {
        this.rpc = rpc;
        this.DenomTrace = this.DenomTrace.bind(this);
        this.DenomTraces = this.DenomTraces.bind(this);
        this.Params = this.Params.bind(this);
        this.DenomHash = this.DenomHash.bind(this);
    }
    DenomTrace(request) {
        const data = exports.QueryDenomTraceRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.applications.transfer.v1.Query", "DenomTrace", data);
        return promise.then((data) => exports.QueryDenomTraceResponse.decode(new minimal_1.default.Reader(data)));
    }
    DenomTraces(request) {
        const data = exports.QueryDenomTracesRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.applications.transfer.v1.Query", "DenomTraces", data);
        return promise.then((data) => exports.QueryDenomTracesResponse.decode(new minimal_1.default.Reader(data)));
    }
    Params(request) {
        const data = exports.QueryParamsRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.applications.transfer.v1.Query", "Params", data);
        return promise.then((data) => exports.QueryParamsResponse.decode(new minimal_1.default.Reader(data)));
    }
    DenomHash(request) {
        const data = exports.QueryDenomHashRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.applications.transfer.v1.Query", "DenomHash", data);
        return promise.then((data) => exports.QueryDenomHashResponse.decode(new minimal_1.default.Reader(data)));
    }
}
exports.QueryClientImpl = QueryClientImpl;
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=query.js.map

/***/ }),

/***/ 93120:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Params = exports.DenomTrace = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(__webpack_require__(47873));
const minimal_1 = __importDefault(__webpack_require__(62100));
exports.protobufPackage = "ibc.applications.transfer.v1";
function createBaseDenomTrace() {
    return { path: "", baseDenom: "" };
}
exports.DenomTrace = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.path !== "") {
            writer.uint32(10).string(message.path);
        }
        if (message.baseDenom !== "") {
            writer.uint32(18).string(message.baseDenom);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDenomTrace();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.path = reader.string();
                    break;
                case 2:
                    message.baseDenom = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            path: isSet(object.path) ? String(object.path) : "",
            baseDenom: isSet(object.baseDenom) ? String(object.baseDenom) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.path !== undefined && (obj.path = message.path);
        message.baseDenom !== undefined && (obj.baseDenom = message.baseDenom);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseDenomTrace();
        message.path = (_a = object.path) !== null && _a !== void 0 ? _a : "";
        message.baseDenom = (_b = object.baseDenom) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
function createBaseParams() {
    return { sendEnabled: false, receiveEnabled: false };
}
exports.Params = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.sendEnabled === true) {
            writer.uint32(8).bool(message.sendEnabled);
        }
        if (message.receiveEnabled === true) {
            writer.uint32(16).bool(message.receiveEnabled);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseParams();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.sendEnabled = reader.bool();
                    break;
                case 2:
                    message.receiveEnabled = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            sendEnabled: isSet(object.sendEnabled) ? Boolean(object.sendEnabled) : false,
            receiveEnabled: isSet(object.receiveEnabled) ? Boolean(object.receiveEnabled) : false,
        };
    },
    toJSON(message) {
        const obj = {};
        message.sendEnabled !== undefined && (obj.sendEnabled = message.sendEnabled);
        message.receiveEnabled !== undefined && (obj.receiveEnabled = message.receiveEnabled);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseParams();
        message.sendEnabled = (_a = object.sendEnabled) !== null && _a !== void 0 ? _a : false;
        message.receiveEnabled = (_b = object.receiveEnabled) !== null && _b !== void 0 ? _b : false;
        return message;
    },
};
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=transfer.js.map

/***/ }),

/***/ 38848:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MsgClientImpl = exports.MsgTransferResponse = exports.MsgTransfer = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(__webpack_require__(47873));
const minimal_1 = __importDefault(__webpack_require__(62100));
const coin_1 = __webpack_require__(26119);
const client_1 = __webpack_require__(74373);
exports.protobufPackage = "ibc.applications.transfer.v1";
function createBaseMsgTransfer() {
    return {
        sourcePort: "",
        sourceChannel: "",
        token: undefined,
        sender: "",
        receiver: "",
        timeoutHeight: undefined,
        timeoutTimestamp: long_1.default.UZERO,
    };
}
exports.MsgTransfer = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.sourcePort !== "") {
            writer.uint32(10).string(message.sourcePort);
        }
        if (message.sourceChannel !== "") {
            writer.uint32(18).string(message.sourceChannel);
        }
        if (message.token !== undefined) {
            coin_1.Coin.encode(message.token, writer.uint32(26).fork()).ldelim();
        }
        if (message.sender !== "") {
            writer.uint32(34).string(message.sender);
        }
        if (message.receiver !== "") {
            writer.uint32(42).string(message.receiver);
        }
        if (message.timeoutHeight !== undefined) {
            client_1.Height.encode(message.timeoutHeight, writer.uint32(50).fork()).ldelim();
        }
        if (!message.timeoutTimestamp.isZero()) {
            writer.uint32(56).uint64(message.timeoutTimestamp);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgTransfer();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.sourcePort = reader.string();
                    break;
                case 2:
                    message.sourceChannel = reader.string();
                    break;
                case 3:
                    message.token = coin_1.Coin.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.sender = reader.string();
                    break;
                case 5:
                    message.receiver = reader.string();
                    break;
                case 6:
                    message.timeoutHeight = client_1.Height.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.timeoutTimestamp = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            sourcePort: isSet(object.sourcePort) ? String(object.sourcePort) : "",
            sourceChannel: isSet(object.sourceChannel) ? String(object.sourceChannel) : "",
            token: isSet(object.token) ? coin_1.Coin.fromJSON(object.token) : undefined,
            sender: isSet(object.sender) ? String(object.sender) : "",
            receiver: isSet(object.receiver) ? String(object.receiver) : "",
            timeoutHeight: isSet(object.timeoutHeight) ? client_1.Height.fromJSON(object.timeoutHeight) : undefined,
            timeoutTimestamp: isSet(object.timeoutTimestamp) ? long_1.default.fromValue(object.timeoutTimestamp) : long_1.default.UZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        message.sourcePort !== undefined && (obj.sourcePort = message.sourcePort);
        message.sourceChannel !== undefined && (obj.sourceChannel = message.sourceChannel);
        message.token !== undefined && (obj.token = message.token ? coin_1.Coin.toJSON(message.token) : undefined);
        message.sender !== undefined && (obj.sender = message.sender);
        message.receiver !== undefined && (obj.receiver = message.receiver);
        message.timeoutHeight !== undefined &&
            (obj.timeoutHeight = message.timeoutHeight ? client_1.Height.toJSON(message.timeoutHeight) : undefined);
        message.timeoutTimestamp !== undefined &&
            (obj.timeoutTimestamp = (message.timeoutTimestamp || long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d;
        const message = createBaseMsgTransfer();
        message.sourcePort = (_a = object.sourcePort) !== null && _a !== void 0 ? _a : "";
        message.sourceChannel = (_b = object.sourceChannel) !== null && _b !== void 0 ? _b : "";
        message.token =
            object.token !== undefined && object.token !== null ? coin_1.Coin.fromPartial(object.token) : undefined;
        message.sender = (_c = object.sender) !== null && _c !== void 0 ? _c : "";
        message.receiver = (_d = object.receiver) !== null && _d !== void 0 ? _d : "";
        message.timeoutHeight =
            object.timeoutHeight !== undefined && object.timeoutHeight !== null
                ? client_1.Height.fromPartial(object.timeoutHeight)
                : undefined;
        message.timeoutTimestamp =
            object.timeoutTimestamp !== undefined && object.timeoutTimestamp !== null
                ? long_1.default.fromValue(object.timeoutTimestamp)
                : long_1.default.UZERO;
        return message;
    },
};
function createBaseMsgTransferResponse() {
    return {};
}
exports.MsgTransferResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgTransferResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgTransferResponse();
        return message;
    },
};
class MsgClientImpl {
    constructor(rpc) {
        this.rpc = rpc;
        this.Transfer = this.Transfer.bind(this);
    }
    Transfer(request) {
        const data = exports.MsgTransfer.encode(request).finish();
        const promise = this.rpc.request("ibc.applications.transfer.v1.Msg", "Transfer", data);
        return promise.then((data) => exports.MsgTransferResponse.decode(new minimal_1.default.Reader(data)));
    }
}
exports.MsgClientImpl = MsgClientImpl;
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=tx.js.map

/***/ }),

/***/ 37212:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Acknowledgement = exports.PacketState = exports.Packet = exports.Counterparty = exports.IdentifiedChannel = exports.Channel = exports.orderToJSON = exports.orderFromJSON = exports.Order = exports.stateToJSON = exports.stateFromJSON = exports.State = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(__webpack_require__(47873));
const minimal_1 = __importDefault(__webpack_require__(62100));
const client_1 = __webpack_require__(74373);
exports.protobufPackage = "ibc.core.channel.v1";
/**
 * State defines if a channel is in one of the following states:
 * CLOSED, INIT, TRYOPEN, OPEN or UNINITIALIZED.
 */
var State;
(function (State) {
    /** STATE_UNINITIALIZED_UNSPECIFIED - Default State */
    State[State["STATE_UNINITIALIZED_UNSPECIFIED"] = 0] = "STATE_UNINITIALIZED_UNSPECIFIED";
    /** STATE_INIT - A channel has just started the opening handshake. */
    State[State["STATE_INIT"] = 1] = "STATE_INIT";
    /** STATE_TRYOPEN - A channel has acknowledged the handshake step on the counterparty chain. */
    State[State["STATE_TRYOPEN"] = 2] = "STATE_TRYOPEN";
    /**
     * STATE_OPEN - A channel has completed the handshake. Open channels are
     * ready to send and receive packets.
     */
    State[State["STATE_OPEN"] = 3] = "STATE_OPEN";
    /**
     * STATE_CLOSED - A channel has been closed and can no longer be used to send or receive
     * packets.
     */
    State[State["STATE_CLOSED"] = 4] = "STATE_CLOSED";
    State[State["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(State = exports.State || (exports.State = {}));
function stateFromJSON(object) {
    switch (object) {
        case 0:
        case "STATE_UNINITIALIZED_UNSPECIFIED":
            return State.STATE_UNINITIALIZED_UNSPECIFIED;
        case 1:
        case "STATE_INIT":
            return State.STATE_INIT;
        case 2:
        case "STATE_TRYOPEN":
            return State.STATE_TRYOPEN;
        case 3:
        case "STATE_OPEN":
            return State.STATE_OPEN;
        case 4:
        case "STATE_CLOSED":
            return State.STATE_CLOSED;
        case -1:
        case "UNRECOGNIZED":
        default:
            return State.UNRECOGNIZED;
    }
}
exports.stateFromJSON = stateFromJSON;
function stateToJSON(object) {
    switch (object) {
        case State.STATE_UNINITIALIZED_UNSPECIFIED:
            return "STATE_UNINITIALIZED_UNSPECIFIED";
        case State.STATE_INIT:
            return "STATE_INIT";
        case State.STATE_TRYOPEN:
            return "STATE_TRYOPEN";
        case State.STATE_OPEN:
            return "STATE_OPEN";
        case State.STATE_CLOSED:
            return "STATE_CLOSED";
        case State.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.stateToJSON = stateToJSON;
/** Order defines if a channel is ORDERED or UNORDERED */
var Order;
(function (Order) {
    /** ORDER_NONE_UNSPECIFIED - zero-value for channel ordering */
    Order[Order["ORDER_NONE_UNSPECIFIED"] = 0] = "ORDER_NONE_UNSPECIFIED";
    /**
     * ORDER_UNORDERED - packets can be delivered in any order, which may differ from the order in
     * which they were sent.
     */
    Order[Order["ORDER_UNORDERED"] = 1] = "ORDER_UNORDERED";
    /** ORDER_ORDERED - packets are delivered exactly in the order which they were sent */
    Order[Order["ORDER_ORDERED"] = 2] = "ORDER_ORDERED";
    Order[Order["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(Order = exports.Order || (exports.Order = {}));
function orderFromJSON(object) {
    switch (object) {
        case 0:
        case "ORDER_NONE_UNSPECIFIED":
            return Order.ORDER_NONE_UNSPECIFIED;
        case 1:
        case "ORDER_UNORDERED":
            return Order.ORDER_UNORDERED;
        case 2:
        case "ORDER_ORDERED":
            return Order.ORDER_ORDERED;
        case -1:
        case "UNRECOGNIZED":
        default:
            return Order.UNRECOGNIZED;
    }
}
exports.orderFromJSON = orderFromJSON;
function orderToJSON(object) {
    switch (object) {
        case Order.ORDER_NONE_UNSPECIFIED:
            return "ORDER_NONE_UNSPECIFIED";
        case Order.ORDER_UNORDERED:
            return "ORDER_UNORDERED";
        case Order.ORDER_ORDERED:
            return "ORDER_ORDERED";
        case Order.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.orderToJSON = orderToJSON;
function createBaseChannel() {
    return { state: 0, ordering: 0, counterparty: undefined, connectionHops: [], version: "" };
}
exports.Channel = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.state !== 0) {
            writer.uint32(8).int32(message.state);
        }
        if (message.ordering !== 0) {
            writer.uint32(16).int32(message.ordering);
        }
        if (message.counterparty !== undefined) {
            exports.Counterparty.encode(message.counterparty, writer.uint32(26).fork()).ldelim();
        }
        for (const v of message.connectionHops) {
            writer.uint32(34).string(v);
        }
        if (message.version !== "") {
            writer.uint32(42).string(message.version);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseChannel();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.state = reader.int32();
                    break;
                case 2:
                    message.ordering = reader.int32();
                    break;
                case 3:
                    message.counterparty = exports.Counterparty.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.connectionHops.push(reader.string());
                    break;
                case 5:
                    message.version = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            state: isSet(object.state) ? stateFromJSON(object.state) : 0,
            ordering: isSet(object.ordering) ? orderFromJSON(object.ordering) : 0,
            counterparty: isSet(object.counterparty) ? exports.Counterparty.fromJSON(object.counterparty) : undefined,
            connectionHops: Array.isArray(object === null || object === void 0 ? void 0 : object.connectionHops)
                ? object.connectionHops.map((e) => String(e))
                : [],
            version: isSet(object.version) ? String(object.version) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.state !== undefined && (obj.state = stateToJSON(message.state));
        message.ordering !== undefined && (obj.ordering = orderToJSON(message.ordering));
        message.counterparty !== undefined &&
            (obj.counterparty = message.counterparty ? exports.Counterparty.toJSON(message.counterparty) : undefined);
        if (message.connectionHops) {
            obj.connectionHops = message.connectionHops.map((e) => e);
        }
        else {
            obj.connectionHops = [];
        }
        message.version !== undefined && (obj.version = message.version);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d;
        const message = createBaseChannel();
        message.state = (_a = object.state) !== null && _a !== void 0 ? _a : 0;
        message.ordering = (_b = object.ordering) !== null && _b !== void 0 ? _b : 0;
        message.counterparty =
            object.counterparty !== undefined && object.counterparty !== null
                ? exports.Counterparty.fromPartial(object.counterparty)
                : undefined;
        message.connectionHops = ((_c = object.connectionHops) === null || _c === void 0 ? void 0 : _c.map((e) => e)) || [];
        message.version = (_d = object.version) !== null && _d !== void 0 ? _d : "";
        return message;
    },
};
function createBaseIdentifiedChannel() {
    return {
        state: 0,
        ordering: 0,
        counterparty: undefined,
        connectionHops: [],
        version: "",
        portId: "",
        channelId: "",
    };
}
exports.IdentifiedChannel = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.state !== 0) {
            writer.uint32(8).int32(message.state);
        }
        if (message.ordering !== 0) {
            writer.uint32(16).int32(message.ordering);
        }
        if (message.counterparty !== undefined) {
            exports.Counterparty.encode(message.counterparty, writer.uint32(26).fork()).ldelim();
        }
        for (const v of message.connectionHops) {
            writer.uint32(34).string(v);
        }
        if (message.version !== "") {
            writer.uint32(42).string(message.version);
        }
        if (message.portId !== "") {
            writer.uint32(50).string(message.portId);
        }
        if (message.channelId !== "") {
            writer.uint32(58).string(message.channelId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseIdentifiedChannel();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.state = reader.int32();
                    break;
                case 2:
                    message.ordering = reader.int32();
                    break;
                case 3:
                    message.counterparty = exports.Counterparty.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.connectionHops.push(reader.string());
                    break;
                case 5:
                    message.version = reader.string();
                    break;
                case 6:
                    message.portId = reader.string();
                    break;
                case 7:
                    message.channelId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            state: isSet(object.state) ? stateFromJSON(object.state) : 0,
            ordering: isSet(object.ordering) ? orderFromJSON(object.ordering) : 0,
            counterparty: isSet(object.counterparty) ? exports.Counterparty.fromJSON(object.counterparty) : undefined,
            connectionHops: Array.isArray(object === null || object === void 0 ? void 0 : object.connectionHops)
                ? object.connectionHops.map((e) => String(e))
                : [],
            version: isSet(object.version) ? String(object.version) : "",
            portId: isSet(object.portId) ? String(object.portId) : "",
            channelId: isSet(object.channelId) ? String(object.channelId) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.state !== undefined && (obj.state = stateToJSON(message.state));
        message.ordering !== undefined && (obj.ordering = orderToJSON(message.ordering));
        message.counterparty !== undefined &&
            (obj.counterparty = message.counterparty ? exports.Counterparty.toJSON(message.counterparty) : undefined);
        if (message.connectionHops) {
            obj.connectionHops = message.connectionHops.map((e) => e);
        }
        else {
            obj.connectionHops = [];
        }
        message.version !== undefined && (obj.version = message.version);
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f;
        const message = createBaseIdentifiedChannel();
        message.state = (_a = object.state) !== null && _a !== void 0 ? _a : 0;
        message.ordering = (_b = object.ordering) !== null && _b !== void 0 ? _b : 0;
        message.counterparty =
            object.counterparty !== undefined && object.counterparty !== null
                ? exports.Counterparty.fromPartial(object.counterparty)
                : undefined;
        message.connectionHops = ((_c = object.connectionHops) === null || _c === void 0 ? void 0 : _c.map((e) => e)) || [];
        message.version = (_d = object.version) !== null && _d !== void 0 ? _d : "";
        message.portId = (_e = object.portId) !== null && _e !== void 0 ? _e : "";
        message.channelId = (_f = object.channelId) !== null && _f !== void 0 ? _f : "";
        return message;
    },
};
function createBaseCounterparty() {
    return { portId: "", channelId: "" };
}
exports.Counterparty = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.portId !== "") {
            writer.uint32(10).string(message.portId);
        }
        if (message.channelId !== "") {
            writer.uint32(18).string(message.channelId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCounterparty();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            portId: isSet(object.portId) ? String(object.portId) : "",
            channelId: isSet(object.channelId) ? String(object.channelId) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseCounterparty();
        message.portId = (_a = object.portId) !== null && _a !== void 0 ? _a : "";
        message.channelId = (_b = object.channelId) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
function createBasePacket() {
    return {
        sequence: long_1.default.UZERO,
        sourcePort: "",
        sourceChannel: "",
        destinationPort: "",
        destinationChannel: "",
        data: new Uint8Array(),
        timeoutHeight: undefined,
        timeoutTimestamp: long_1.default.UZERO,
    };
}
exports.Packet = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (!message.sequence.isZero()) {
            writer.uint32(8).uint64(message.sequence);
        }
        if (message.sourcePort !== "") {
            writer.uint32(18).string(message.sourcePort);
        }
        if (message.sourceChannel !== "") {
            writer.uint32(26).string(message.sourceChannel);
        }
        if (message.destinationPort !== "") {
            writer.uint32(34).string(message.destinationPort);
        }
        if (message.destinationChannel !== "") {
            writer.uint32(42).string(message.destinationChannel);
        }
        if (message.data.length !== 0) {
            writer.uint32(50).bytes(message.data);
        }
        if (message.timeoutHeight !== undefined) {
            client_1.Height.encode(message.timeoutHeight, writer.uint32(58).fork()).ldelim();
        }
        if (!message.timeoutTimestamp.isZero()) {
            writer.uint32(64).uint64(message.timeoutTimestamp);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePacket();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.sequence = reader.uint64();
                    break;
                case 2:
                    message.sourcePort = reader.string();
                    break;
                case 3:
                    message.sourceChannel = reader.string();
                    break;
                case 4:
                    message.destinationPort = reader.string();
                    break;
                case 5:
                    message.destinationChannel = reader.string();
                    break;
                case 6:
                    message.data = reader.bytes();
                    break;
                case 7:
                    message.timeoutHeight = client_1.Height.decode(reader, reader.uint32());
                    break;
                case 8:
                    message.timeoutTimestamp = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            sequence: isSet(object.sequence) ? long_1.default.fromValue(object.sequence) : long_1.default.UZERO,
            sourcePort: isSet(object.sourcePort) ? String(object.sourcePort) : "",
            sourceChannel: isSet(object.sourceChannel) ? String(object.sourceChannel) : "",
            destinationPort: isSet(object.destinationPort) ? String(object.destinationPort) : "",
            destinationChannel: isSet(object.destinationChannel) ? String(object.destinationChannel) : "",
            data: isSet(object.data) ? bytesFromBase64(object.data) : new Uint8Array(),
            timeoutHeight: isSet(object.timeoutHeight) ? client_1.Height.fromJSON(object.timeoutHeight) : undefined,
            timeoutTimestamp: isSet(object.timeoutTimestamp) ? long_1.default.fromValue(object.timeoutTimestamp) : long_1.default.UZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        message.sequence !== undefined && (obj.sequence = (message.sequence || long_1.default.UZERO).toString());
        message.sourcePort !== undefined && (obj.sourcePort = message.sourcePort);
        message.sourceChannel !== undefined && (obj.sourceChannel = message.sourceChannel);
        message.destinationPort !== undefined && (obj.destinationPort = message.destinationPort);
        message.destinationChannel !== undefined && (obj.destinationChannel = message.destinationChannel);
        message.data !== undefined &&
            (obj.data = base64FromBytes(message.data !== undefined ? message.data : new Uint8Array()));
        message.timeoutHeight !== undefined &&
            (obj.timeoutHeight = message.timeoutHeight ? client_1.Height.toJSON(message.timeoutHeight) : undefined);
        message.timeoutTimestamp !== undefined &&
            (obj.timeoutTimestamp = (message.timeoutTimestamp || long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e;
        const message = createBasePacket();
        message.sequence =
            object.sequence !== undefined && object.sequence !== null
                ? long_1.default.fromValue(object.sequence)
                : long_1.default.UZERO;
        message.sourcePort = (_a = object.sourcePort) !== null && _a !== void 0 ? _a : "";
        message.sourceChannel = (_b = object.sourceChannel) !== null && _b !== void 0 ? _b : "";
        message.destinationPort = (_c = object.destinationPort) !== null && _c !== void 0 ? _c : "";
        message.destinationChannel = (_d = object.destinationChannel) !== null && _d !== void 0 ? _d : "";
        message.data = (_e = object.data) !== null && _e !== void 0 ? _e : new Uint8Array();
        message.timeoutHeight =
            object.timeoutHeight !== undefined && object.timeoutHeight !== null
                ? client_1.Height.fromPartial(object.timeoutHeight)
                : undefined;
        message.timeoutTimestamp =
            object.timeoutTimestamp !== undefined && object.timeoutTimestamp !== null
                ? long_1.default.fromValue(object.timeoutTimestamp)
                : long_1.default.UZERO;
        return message;
    },
};
function createBasePacketState() {
    return { portId: "", channelId: "", sequence: long_1.default.UZERO, data: new Uint8Array() };
}
exports.PacketState = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.portId !== "") {
            writer.uint32(10).string(message.portId);
        }
        if (message.channelId !== "") {
            writer.uint32(18).string(message.channelId);
        }
        if (!message.sequence.isZero()) {
            writer.uint32(24).uint64(message.sequence);
        }
        if (message.data.length !== 0) {
            writer.uint32(34).bytes(message.data);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePacketState();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                case 3:
                    message.sequence = reader.uint64();
                    break;
                case 4:
                    message.data = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            portId: isSet(object.portId) ? String(object.portId) : "",
            channelId: isSet(object.channelId) ? String(object.channelId) : "",
            sequence: isSet(object.sequence) ? long_1.default.fromValue(object.sequence) : long_1.default.UZERO,
            data: isSet(object.data) ? bytesFromBase64(object.data) : new Uint8Array(),
        };
    },
    toJSON(message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        message.sequence !== undefined && (obj.sequence = (message.sequence || long_1.default.UZERO).toString());
        message.data !== undefined &&
            (obj.data = base64FromBytes(message.data !== undefined ? message.data : new Uint8Array()));
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBasePacketState();
        message.portId = (_a = object.portId) !== null && _a !== void 0 ? _a : "";
        message.channelId = (_b = object.channelId) !== null && _b !== void 0 ? _b : "";
        message.sequence =
            object.sequence !== undefined && object.sequence !== null
                ? long_1.default.fromValue(object.sequence)
                : long_1.default.UZERO;
        message.data = (_c = object.data) !== null && _c !== void 0 ? _c : new Uint8Array();
        return message;
    },
};
function createBaseAcknowledgement() {
    return { result: undefined, error: undefined };
}
exports.Acknowledgement = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.result !== undefined) {
            writer.uint32(170).bytes(message.result);
        }
        if (message.error !== undefined) {
            writer.uint32(178).string(message.error);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAcknowledgement();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 21:
                    message.result = reader.bytes();
                    break;
                case 22:
                    message.error = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            result: isSet(object.result) ? bytesFromBase64(object.result) : undefined,
            error: isSet(object.error) ? String(object.error) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.result !== undefined &&
            (obj.result = message.result !== undefined ? base64FromBytes(message.result) : undefined);
        message.error !== undefined && (obj.error = message.error);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseAcknowledgement();
        message.result = (_a = object.result) !== null && _a !== void 0 ? _a : undefined;
        message.error = (_b = object.error) !== null && _b !== void 0 ? _b : undefined;
        return message;
    },
};
var globalThis = (() => {
    if (typeof globalThis !== "undefined") {
        return globalThis;
    }
    if (typeof self !== "undefined") {
        return self;
    }
    if (typeof window !== "undefined") {
        return window;
    }
    if (typeof __webpack_require__.g !== "undefined") {
        return __webpack_require__.g;
    }
    throw "Unable to locate global object";
})();
function bytesFromBase64(b64) {
    if (globalThis.Buffer) {
        return Uint8Array.from(globalThis.Buffer.from(b64, "base64"));
    }
    else {
        const bin = globalThis.atob(b64);
        const arr = new Uint8Array(bin.length);
        for (let i = 0; i < bin.length; ++i) {
            arr[i] = bin.charCodeAt(i);
        }
        return arr;
    }
}
function base64FromBytes(arr) {
    if (globalThis.Buffer) {
        return globalThis.Buffer.from(arr).toString("base64");
    }
    else {
        const bin = [];
        arr.forEach((byte) => {
            bin.push(String.fromCharCode(byte));
        });
        return globalThis.btoa(bin.join(""));
    }
}
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=channel.js.map

/***/ }),

/***/ 15470:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.QueryClientImpl = exports.QueryNextSequenceReceiveResponse = exports.QueryNextSequenceReceiveRequest = exports.QueryUnreceivedAcksResponse = exports.QueryUnreceivedAcksRequest = exports.QueryUnreceivedPacketsResponse = exports.QueryUnreceivedPacketsRequest = exports.QueryPacketAcknowledgementsResponse = exports.QueryPacketAcknowledgementsRequest = exports.QueryPacketAcknowledgementResponse = exports.QueryPacketAcknowledgementRequest = exports.QueryPacketReceiptResponse = exports.QueryPacketReceiptRequest = exports.QueryPacketCommitmentsResponse = exports.QueryPacketCommitmentsRequest = exports.QueryPacketCommitmentResponse = exports.QueryPacketCommitmentRequest = exports.QueryChannelConsensusStateResponse = exports.QueryChannelConsensusStateRequest = exports.QueryChannelClientStateResponse = exports.QueryChannelClientStateRequest = exports.QueryConnectionChannelsResponse = exports.QueryConnectionChannelsRequest = exports.QueryChannelsResponse = exports.QueryChannelsRequest = exports.QueryChannelResponse = exports.QueryChannelRequest = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(__webpack_require__(47873));
const minimal_1 = __importDefault(__webpack_require__(62100));
const pagination_1 = __webpack_require__(62635);
const any_1 = __webpack_require__(90007);
const client_1 = __webpack_require__(74373);
const channel_1 = __webpack_require__(37212);
exports.protobufPackage = "ibc.core.channel.v1";
function createBaseQueryChannelRequest() {
    return { portId: "", channelId: "" };
}
exports.QueryChannelRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.portId !== "") {
            writer.uint32(10).string(message.portId);
        }
        if (message.channelId !== "") {
            writer.uint32(18).string(message.channelId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryChannelRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            portId: isSet(object.portId) ? String(object.portId) : "",
            channelId: isSet(object.channelId) ? String(object.channelId) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseQueryChannelRequest();
        message.portId = (_a = object.portId) !== null && _a !== void 0 ? _a : "";
        message.channelId = (_b = object.channelId) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
function createBaseQueryChannelResponse() {
    return { channel: undefined, proof: new Uint8Array(), proofHeight: undefined };
}
exports.QueryChannelResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.channel !== undefined) {
            channel_1.Channel.encode(message.channel, writer.uint32(10).fork()).ldelim();
        }
        if (message.proof.length !== 0) {
            writer.uint32(18).bytes(message.proof);
        }
        if (message.proofHeight !== undefined) {
            client_1.Height.encode(message.proofHeight, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryChannelResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.channel = channel_1.Channel.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.proof = reader.bytes();
                    break;
                case 3:
                    message.proofHeight = client_1.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            channel: isSet(object.channel) ? channel_1.Channel.fromJSON(object.channel) : undefined,
            proof: isSet(object.proof) ? bytesFromBase64(object.proof) : new Uint8Array(),
            proofHeight: isSet(object.proofHeight) ? client_1.Height.fromJSON(object.proofHeight) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.channel !== undefined &&
            (obj.channel = message.channel ? channel_1.Channel.toJSON(message.channel) : undefined);
        message.proof !== undefined &&
            (obj.proof = base64FromBytes(message.proof !== undefined ? message.proof : new Uint8Array()));
        message.proofHeight !== undefined &&
            (obj.proofHeight = message.proofHeight ? client_1.Height.toJSON(message.proofHeight) : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryChannelResponse();
        message.channel =
            object.channel !== undefined && object.channel !== null
                ? channel_1.Channel.fromPartial(object.channel)
                : undefined;
        message.proof = (_a = object.proof) !== null && _a !== void 0 ? _a : new Uint8Array();
        message.proofHeight =
            object.proofHeight !== undefined && object.proofHeight !== null
                ? client_1.Height.fromPartial(object.proofHeight)
                : undefined;
        return message;
    },
};
function createBaseQueryChannelsRequest() {
    return { pagination: undefined };
}
exports.QueryChannelsRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryChannelsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { pagination: isSet(object.pagination) ? pagination_1.PageRequest.fromJSON(object.pagination) : undefined };
    },
    toJSON(message) {
        const obj = {};
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryChannelsRequest();
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryChannelsResponse() {
    return { channels: [], pagination: undefined, height: undefined };
}
exports.QueryChannelsResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.channels) {
            channel_1.IdentifiedChannel.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        if (message.height !== undefined) {
            client_1.Height.encode(message.height, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryChannelsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.channels.push(channel_1.IdentifiedChannel.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.height = client_1.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            channels: Array.isArray(object === null || object === void 0 ? void 0 : object.channels)
                ? object.channels.map((e) => channel_1.IdentifiedChannel.fromJSON(e))
                : [],
            pagination: isSet(object.pagination) ? pagination_1.PageResponse.fromJSON(object.pagination) : undefined,
            height: isSet(object.height) ? client_1.Height.fromJSON(object.height) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.channels) {
            obj.channels = message.channels.map((e) => (e ? channel_1.IdentifiedChannel.toJSON(e) : undefined));
        }
        else {
            obj.channels = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageResponse.toJSON(message.pagination) : undefined);
        message.height !== undefined && (obj.height = message.height ? client_1.Height.toJSON(message.height) : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryChannelsResponse();
        message.channels = ((_a = object.channels) === null || _a === void 0 ? void 0 : _a.map((e) => channel_1.IdentifiedChannel.fromPartial(e))) || [];
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        message.height =
            object.height !== undefined && object.height !== null ? client_1.Height.fromPartial(object.height) : undefined;
        return message;
    },
};
function createBaseQueryConnectionChannelsRequest() {
    return { connection: "", pagination: undefined };
}
exports.QueryConnectionChannelsRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.connection !== "") {
            writer.uint32(10).string(message.connection);
        }
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryConnectionChannelsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.connection = reader.string();
                    break;
                case 2:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            connection: isSet(object.connection) ? String(object.connection) : "",
            pagination: isSet(object.pagination) ? pagination_1.PageRequest.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.connection !== undefined && (obj.connection = message.connection);
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryConnectionChannelsRequest();
        message.connection = (_a = object.connection) !== null && _a !== void 0 ? _a : "";
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryConnectionChannelsResponse() {
    return { channels: [], pagination: undefined, height: undefined };
}
exports.QueryConnectionChannelsResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.channels) {
            channel_1.IdentifiedChannel.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        if (message.height !== undefined) {
            client_1.Height.encode(message.height, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryConnectionChannelsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.channels.push(channel_1.IdentifiedChannel.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.height = client_1.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            channels: Array.isArray(object === null || object === void 0 ? void 0 : object.channels)
                ? object.channels.map((e) => channel_1.IdentifiedChannel.fromJSON(e))
                : [],
            pagination: isSet(object.pagination) ? pagination_1.PageResponse.fromJSON(object.pagination) : undefined,
            height: isSet(object.height) ? client_1.Height.fromJSON(object.height) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.channels) {
            obj.channels = message.channels.map((e) => (e ? channel_1.IdentifiedChannel.toJSON(e) : undefined));
        }
        else {
            obj.channels = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageResponse.toJSON(message.pagination) : undefined);
        message.height !== undefined && (obj.height = message.height ? client_1.Height.toJSON(message.height) : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryConnectionChannelsResponse();
        message.channels = ((_a = object.channels) === null || _a === void 0 ? void 0 : _a.map((e) => channel_1.IdentifiedChannel.fromPartial(e))) || [];
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        message.height =
            object.height !== undefined && object.height !== null ? client_1.Height.fromPartial(object.height) : undefined;
        return message;
    },
};
function createBaseQueryChannelClientStateRequest() {
    return { portId: "", channelId: "" };
}
exports.QueryChannelClientStateRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.portId !== "") {
            writer.uint32(10).string(message.portId);
        }
        if (message.channelId !== "") {
            writer.uint32(18).string(message.channelId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryChannelClientStateRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            portId: isSet(object.portId) ? String(object.portId) : "",
            channelId: isSet(object.channelId) ? String(object.channelId) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseQueryChannelClientStateRequest();
        message.portId = (_a = object.portId) !== null && _a !== void 0 ? _a : "";
        message.channelId = (_b = object.channelId) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
function createBaseQueryChannelClientStateResponse() {
    return { identifiedClientState: undefined, proof: new Uint8Array(), proofHeight: undefined };
}
exports.QueryChannelClientStateResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.identifiedClientState !== undefined) {
            client_1.IdentifiedClientState.encode(message.identifiedClientState, writer.uint32(10).fork()).ldelim();
        }
        if (message.proof.length !== 0) {
            writer.uint32(18).bytes(message.proof);
        }
        if (message.proofHeight !== undefined) {
            client_1.Height.encode(message.proofHeight, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryChannelClientStateResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.identifiedClientState = client_1.IdentifiedClientState.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.proof = reader.bytes();
                    break;
                case 3:
                    message.proofHeight = client_1.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            identifiedClientState: isSet(object.identifiedClientState)
                ? client_1.IdentifiedClientState.fromJSON(object.identifiedClientState)
                : undefined,
            proof: isSet(object.proof) ? bytesFromBase64(object.proof) : new Uint8Array(),
            proofHeight: isSet(object.proofHeight) ? client_1.Height.fromJSON(object.proofHeight) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.identifiedClientState !== undefined &&
            (obj.identifiedClientState = message.identifiedClientState
                ? client_1.IdentifiedClientState.toJSON(message.identifiedClientState)
                : undefined);
        message.proof !== undefined &&
            (obj.proof = base64FromBytes(message.proof !== undefined ? message.proof : new Uint8Array()));
        message.proofHeight !== undefined &&
            (obj.proofHeight = message.proofHeight ? client_1.Height.toJSON(message.proofHeight) : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryChannelClientStateResponse();
        message.identifiedClientState =
            object.identifiedClientState !== undefined && object.identifiedClientState !== null
                ? client_1.IdentifiedClientState.fromPartial(object.identifiedClientState)
                : undefined;
        message.proof = (_a = object.proof) !== null && _a !== void 0 ? _a : new Uint8Array();
        message.proofHeight =
            object.proofHeight !== undefined && object.proofHeight !== null
                ? client_1.Height.fromPartial(object.proofHeight)
                : undefined;
        return message;
    },
};
function createBaseQueryChannelConsensusStateRequest() {
    return { portId: "", channelId: "", revisionNumber: long_1.default.UZERO, revisionHeight: long_1.default.UZERO };
}
exports.QueryChannelConsensusStateRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.portId !== "") {
            writer.uint32(10).string(message.portId);
        }
        if (message.channelId !== "") {
            writer.uint32(18).string(message.channelId);
        }
        if (!message.revisionNumber.isZero()) {
            writer.uint32(24).uint64(message.revisionNumber);
        }
        if (!message.revisionHeight.isZero()) {
            writer.uint32(32).uint64(message.revisionHeight);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryChannelConsensusStateRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                case 3:
                    message.revisionNumber = reader.uint64();
                    break;
                case 4:
                    message.revisionHeight = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            portId: isSet(object.portId) ? String(object.portId) : "",
            channelId: isSet(object.channelId) ? String(object.channelId) : "",
            revisionNumber: isSet(object.revisionNumber) ? long_1.default.fromValue(object.revisionNumber) : long_1.default.UZERO,
            revisionHeight: isSet(object.revisionHeight) ? long_1.default.fromValue(object.revisionHeight) : long_1.default.UZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        message.revisionNumber !== undefined &&
            (obj.revisionNumber = (message.revisionNumber || long_1.default.UZERO).toString());
        message.revisionHeight !== undefined &&
            (obj.revisionHeight = (message.revisionHeight || long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseQueryChannelConsensusStateRequest();
        message.portId = (_a = object.portId) !== null && _a !== void 0 ? _a : "";
        message.channelId = (_b = object.channelId) !== null && _b !== void 0 ? _b : "";
        message.revisionNumber =
            object.revisionNumber !== undefined && object.revisionNumber !== null
                ? long_1.default.fromValue(object.revisionNumber)
                : long_1.default.UZERO;
        message.revisionHeight =
            object.revisionHeight !== undefined && object.revisionHeight !== null
                ? long_1.default.fromValue(object.revisionHeight)
                : long_1.default.UZERO;
        return message;
    },
};
function createBaseQueryChannelConsensusStateResponse() {
    return { consensusState: undefined, clientId: "", proof: new Uint8Array(), proofHeight: undefined };
}
exports.QueryChannelConsensusStateResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.consensusState !== undefined) {
            any_1.Any.encode(message.consensusState, writer.uint32(10).fork()).ldelim();
        }
        if (message.clientId !== "") {
            writer.uint32(18).string(message.clientId);
        }
        if (message.proof.length !== 0) {
            writer.uint32(26).bytes(message.proof);
        }
        if (message.proofHeight !== undefined) {
            client_1.Height.encode(message.proofHeight, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryChannelConsensusStateResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.consensusState = any_1.Any.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.clientId = reader.string();
                    break;
                case 3:
                    message.proof = reader.bytes();
                    break;
                case 4:
                    message.proofHeight = client_1.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            consensusState: isSet(object.consensusState) ? any_1.Any.fromJSON(object.consensusState) : undefined,
            clientId: isSet(object.clientId) ? String(object.clientId) : "",
            proof: isSet(object.proof) ? bytesFromBase64(object.proof) : new Uint8Array(),
            proofHeight: isSet(object.proofHeight) ? client_1.Height.fromJSON(object.proofHeight) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.consensusState !== undefined &&
            (obj.consensusState = message.consensusState ? any_1.Any.toJSON(message.consensusState) : undefined);
        message.clientId !== undefined && (obj.clientId = message.clientId);
        message.proof !== undefined &&
            (obj.proof = base64FromBytes(message.proof !== undefined ? message.proof : new Uint8Array()));
        message.proofHeight !== undefined &&
            (obj.proofHeight = message.proofHeight ? client_1.Height.toJSON(message.proofHeight) : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseQueryChannelConsensusStateResponse();
        message.consensusState =
            object.consensusState !== undefined && object.consensusState !== null
                ? any_1.Any.fromPartial(object.consensusState)
                : undefined;
        message.clientId = (_a = object.clientId) !== null && _a !== void 0 ? _a : "";
        message.proof = (_b = object.proof) !== null && _b !== void 0 ? _b : new Uint8Array();
        message.proofHeight =
            object.proofHeight !== undefined && object.proofHeight !== null
                ? client_1.Height.fromPartial(object.proofHeight)
                : undefined;
        return message;
    },
};
function createBaseQueryPacketCommitmentRequest() {
    return { portId: "", channelId: "", sequence: long_1.default.UZERO };
}
exports.QueryPacketCommitmentRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.portId !== "") {
            writer.uint32(10).string(message.portId);
        }
        if (message.channelId !== "") {
            writer.uint32(18).string(message.channelId);
        }
        if (!message.sequence.isZero()) {
            writer.uint32(24).uint64(message.sequence);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryPacketCommitmentRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                case 3:
                    message.sequence = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            portId: isSet(object.portId) ? String(object.portId) : "",
            channelId: isSet(object.channelId) ? String(object.channelId) : "",
            sequence: isSet(object.sequence) ? long_1.default.fromValue(object.sequence) : long_1.default.UZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        message.sequence !== undefined && (obj.sequence = (message.sequence || long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseQueryPacketCommitmentRequest();
        message.portId = (_a = object.portId) !== null && _a !== void 0 ? _a : "";
        message.channelId = (_b = object.channelId) !== null && _b !== void 0 ? _b : "";
        message.sequence =
            object.sequence !== undefined && object.sequence !== null
                ? long_1.default.fromValue(object.sequence)
                : long_1.default.UZERO;
        return message;
    },
};
function createBaseQueryPacketCommitmentResponse() {
    return { commitment: new Uint8Array(), proof: new Uint8Array(), proofHeight: undefined };
}
exports.QueryPacketCommitmentResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.commitment.length !== 0) {
            writer.uint32(10).bytes(message.commitment);
        }
        if (message.proof.length !== 0) {
            writer.uint32(18).bytes(message.proof);
        }
        if (message.proofHeight !== undefined) {
            client_1.Height.encode(message.proofHeight, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryPacketCommitmentResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.commitment = reader.bytes();
                    break;
                case 2:
                    message.proof = reader.bytes();
                    break;
                case 3:
                    message.proofHeight = client_1.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            commitment: isSet(object.commitment) ? bytesFromBase64(object.commitment) : new Uint8Array(),
            proof: isSet(object.proof) ? bytesFromBase64(object.proof) : new Uint8Array(),
            proofHeight: isSet(object.proofHeight) ? client_1.Height.fromJSON(object.proofHeight) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.commitment !== undefined &&
            (obj.commitment = base64FromBytes(message.commitment !== undefined ? message.commitment : new Uint8Array()));
        message.proof !== undefined &&
            (obj.proof = base64FromBytes(message.proof !== undefined ? message.proof : new Uint8Array()));
        message.proofHeight !== undefined &&
            (obj.proofHeight = message.proofHeight ? client_1.Height.toJSON(message.proofHeight) : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseQueryPacketCommitmentResponse();
        message.commitment = (_a = object.commitment) !== null && _a !== void 0 ? _a : new Uint8Array();
        message.proof = (_b = object.proof) !== null && _b !== void 0 ? _b : new Uint8Array();
        message.proofHeight =
            object.proofHeight !== undefined && object.proofHeight !== null
                ? client_1.Height.fromPartial(object.proofHeight)
                : undefined;
        return message;
    },
};
function createBaseQueryPacketCommitmentsRequest() {
    return { portId: "", channelId: "", pagination: undefined };
}
exports.QueryPacketCommitmentsRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.portId !== "") {
            writer.uint32(10).string(message.portId);
        }
        if (message.channelId !== "") {
            writer.uint32(18).string(message.channelId);
        }
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryPacketCommitmentsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                case 3:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            portId: isSet(object.portId) ? String(object.portId) : "",
            channelId: isSet(object.channelId) ? String(object.channelId) : "",
            pagination: isSet(object.pagination) ? pagination_1.PageRequest.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseQueryPacketCommitmentsRequest();
        message.portId = (_a = object.portId) !== null && _a !== void 0 ? _a : "";
        message.channelId = (_b = object.channelId) !== null && _b !== void 0 ? _b : "";
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryPacketCommitmentsResponse() {
    return { commitments: [], pagination: undefined, height: undefined };
}
exports.QueryPacketCommitmentsResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.commitments) {
            channel_1.PacketState.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        if (message.height !== undefined) {
            client_1.Height.encode(message.height, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryPacketCommitmentsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.commitments.push(channel_1.PacketState.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.height = client_1.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            commitments: Array.isArray(object === null || object === void 0 ? void 0 : object.commitments)
                ? object.commitments.map((e) => channel_1.PacketState.fromJSON(e))
                : [],
            pagination: isSet(object.pagination) ? pagination_1.PageResponse.fromJSON(object.pagination) : undefined,
            height: isSet(object.height) ? client_1.Height.fromJSON(object.height) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.commitments) {
            obj.commitments = message.commitments.map((e) => (e ? channel_1.PacketState.toJSON(e) : undefined));
        }
        else {
            obj.commitments = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageResponse.toJSON(message.pagination) : undefined);
        message.height !== undefined && (obj.height = message.height ? client_1.Height.toJSON(message.height) : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryPacketCommitmentsResponse();
        message.commitments = ((_a = object.commitments) === null || _a === void 0 ? void 0 : _a.map((e) => channel_1.PacketState.fromPartial(e))) || [];
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        message.height =
            object.height !== undefined && object.height !== null ? client_1.Height.fromPartial(object.height) : undefined;
        return message;
    },
};
function createBaseQueryPacketReceiptRequest() {
    return { portId: "", channelId: "", sequence: long_1.default.UZERO };
}
exports.QueryPacketReceiptRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.portId !== "") {
            writer.uint32(10).string(message.portId);
        }
        if (message.channelId !== "") {
            writer.uint32(18).string(message.channelId);
        }
        if (!message.sequence.isZero()) {
            writer.uint32(24).uint64(message.sequence);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryPacketReceiptRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                case 3:
                    message.sequence = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            portId: isSet(object.portId) ? String(object.portId) : "",
            channelId: isSet(object.channelId) ? String(object.channelId) : "",
            sequence: isSet(object.sequence) ? long_1.default.fromValue(object.sequence) : long_1.default.UZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        message.sequence !== undefined && (obj.sequence = (message.sequence || long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseQueryPacketReceiptRequest();
        message.portId = (_a = object.portId) !== null && _a !== void 0 ? _a : "";
        message.channelId = (_b = object.channelId) !== null && _b !== void 0 ? _b : "";
        message.sequence =
            object.sequence !== undefined && object.sequence !== null
                ? long_1.default.fromValue(object.sequence)
                : long_1.default.UZERO;
        return message;
    },
};
function createBaseQueryPacketReceiptResponse() {
    return { received: false, proof: new Uint8Array(), proofHeight: undefined };
}
exports.QueryPacketReceiptResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.received === true) {
            writer.uint32(16).bool(message.received);
        }
        if (message.proof.length !== 0) {
            writer.uint32(26).bytes(message.proof);
        }
        if (message.proofHeight !== undefined) {
            client_1.Height.encode(message.proofHeight, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryPacketReceiptResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 2:
                    message.received = reader.bool();
                    break;
                case 3:
                    message.proof = reader.bytes();
                    break;
                case 4:
                    message.proofHeight = client_1.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            received: isSet(object.received) ? Boolean(object.received) : false,
            proof: isSet(object.proof) ? bytesFromBase64(object.proof) : new Uint8Array(),
            proofHeight: isSet(object.proofHeight) ? client_1.Height.fromJSON(object.proofHeight) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.received !== undefined && (obj.received = message.received);
        message.proof !== undefined &&
            (obj.proof = base64FromBytes(message.proof !== undefined ? message.proof : new Uint8Array()));
        message.proofHeight !== undefined &&
            (obj.proofHeight = message.proofHeight ? client_1.Height.toJSON(message.proofHeight) : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseQueryPacketReceiptResponse();
        message.received = (_a = object.received) !== null && _a !== void 0 ? _a : false;
        message.proof = (_b = object.proof) !== null && _b !== void 0 ? _b : new Uint8Array();
        message.proofHeight =
            object.proofHeight !== undefined && object.proofHeight !== null
                ? client_1.Height.fromPartial(object.proofHeight)
                : undefined;
        return message;
    },
};
function createBaseQueryPacketAcknowledgementRequest() {
    return { portId: "", channelId: "", sequence: long_1.default.UZERO };
}
exports.QueryPacketAcknowledgementRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.portId !== "") {
            writer.uint32(10).string(message.portId);
        }
        if (message.channelId !== "") {
            writer.uint32(18).string(message.channelId);
        }
        if (!message.sequence.isZero()) {
            writer.uint32(24).uint64(message.sequence);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryPacketAcknowledgementRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                case 3:
                    message.sequence = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            portId: isSet(object.portId) ? String(object.portId) : "",
            channelId: isSet(object.channelId) ? String(object.channelId) : "",
            sequence: isSet(object.sequence) ? long_1.default.fromValue(object.sequence) : long_1.default.UZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        message.sequence !== undefined && (obj.sequence = (message.sequence || long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseQueryPacketAcknowledgementRequest();
        message.portId = (_a = object.portId) !== null && _a !== void 0 ? _a : "";
        message.channelId = (_b = object.channelId) !== null && _b !== void 0 ? _b : "";
        message.sequence =
            object.sequence !== undefined && object.sequence !== null
                ? long_1.default.fromValue(object.sequence)
                : long_1.default.UZERO;
        return message;
    },
};
function createBaseQueryPacketAcknowledgementResponse() {
    return { acknowledgement: new Uint8Array(), proof: new Uint8Array(), proofHeight: undefined };
}
exports.QueryPacketAcknowledgementResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.acknowledgement.length !== 0) {
            writer.uint32(10).bytes(message.acknowledgement);
        }
        if (message.proof.length !== 0) {
            writer.uint32(18).bytes(message.proof);
        }
        if (message.proofHeight !== undefined) {
            client_1.Height.encode(message.proofHeight, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryPacketAcknowledgementResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.acknowledgement = reader.bytes();
                    break;
                case 2:
                    message.proof = reader.bytes();
                    break;
                case 3:
                    message.proofHeight = client_1.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            acknowledgement: isSet(object.acknowledgement)
                ? bytesFromBase64(object.acknowledgement)
                : new Uint8Array(),
            proof: isSet(object.proof) ? bytesFromBase64(object.proof) : new Uint8Array(),
            proofHeight: isSet(object.proofHeight) ? client_1.Height.fromJSON(object.proofHeight) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.acknowledgement !== undefined &&
            (obj.acknowledgement = base64FromBytes(message.acknowledgement !== undefined ? message.acknowledgement : new Uint8Array()));
        message.proof !== undefined &&
            (obj.proof = base64FromBytes(message.proof !== undefined ? message.proof : new Uint8Array()));
        message.proofHeight !== undefined &&
            (obj.proofHeight = message.proofHeight ? client_1.Height.toJSON(message.proofHeight) : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseQueryPacketAcknowledgementResponse();
        message.acknowledgement = (_a = object.acknowledgement) !== null && _a !== void 0 ? _a : new Uint8Array();
        message.proof = (_b = object.proof) !== null && _b !== void 0 ? _b : new Uint8Array();
        message.proofHeight =
            object.proofHeight !== undefined && object.proofHeight !== null
                ? client_1.Height.fromPartial(object.proofHeight)
                : undefined;
        return message;
    },
};
function createBaseQueryPacketAcknowledgementsRequest() {
    return { portId: "", channelId: "", pagination: undefined, packetCommitmentSequences: [] };
}
exports.QueryPacketAcknowledgementsRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.portId !== "") {
            writer.uint32(10).string(message.portId);
        }
        if (message.channelId !== "") {
            writer.uint32(18).string(message.channelId);
        }
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(26).fork()).ldelim();
        }
        writer.uint32(34).fork();
        for (const v of message.packetCommitmentSequences) {
            writer.uint64(v);
        }
        writer.ldelim();
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryPacketAcknowledgementsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                case 3:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                case 4:
                    if ((tag & 7) === 2) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.packetCommitmentSequences.push(reader.uint64());
                        }
                    }
                    else {
                        message.packetCommitmentSequences.push(reader.uint64());
                    }
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            portId: isSet(object.portId) ? String(object.portId) : "",
            channelId: isSet(object.channelId) ? String(object.channelId) : "",
            pagination: isSet(object.pagination) ? pagination_1.PageRequest.fromJSON(object.pagination) : undefined,
            packetCommitmentSequences: Array.isArray(object === null || object === void 0 ? void 0 : object.packetCommitmentSequences)
                ? object.packetCommitmentSequences.map((e) => long_1.default.fromValue(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageRequest.toJSON(message.pagination) : undefined);
        if (message.packetCommitmentSequences) {
            obj.packetCommitmentSequences = message.packetCommitmentSequences.map((e) => (e || long_1.default.UZERO).toString());
        }
        else {
            obj.packetCommitmentSequences = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseQueryPacketAcknowledgementsRequest();
        message.portId = (_a = object.portId) !== null && _a !== void 0 ? _a : "";
        message.channelId = (_b = object.channelId) !== null && _b !== void 0 ? _b : "";
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        message.packetCommitmentSequences = ((_c = object.packetCommitmentSequences) === null || _c === void 0 ? void 0 : _c.map((e) => long_1.default.fromValue(e))) || [];
        return message;
    },
};
function createBaseQueryPacketAcknowledgementsResponse() {
    return { acknowledgements: [], pagination: undefined, height: undefined };
}
exports.QueryPacketAcknowledgementsResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.acknowledgements) {
            channel_1.PacketState.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        if (message.height !== undefined) {
            client_1.Height.encode(message.height, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryPacketAcknowledgementsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.acknowledgements.push(channel_1.PacketState.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.height = client_1.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            acknowledgements: Array.isArray(object === null || object === void 0 ? void 0 : object.acknowledgements)
                ? object.acknowledgements.map((e) => channel_1.PacketState.fromJSON(e))
                : [],
            pagination: isSet(object.pagination) ? pagination_1.PageResponse.fromJSON(object.pagination) : undefined,
            height: isSet(object.height) ? client_1.Height.fromJSON(object.height) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.acknowledgements) {
            obj.acknowledgements = message.acknowledgements.map((e) => (e ? channel_1.PacketState.toJSON(e) : undefined));
        }
        else {
            obj.acknowledgements = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageResponse.toJSON(message.pagination) : undefined);
        message.height !== undefined && (obj.height = message.height ? client_1.Height.toJSON(message.height) : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryPacketAcknowledgementsResponse();
        message.acknowledgements = ((_a = object.acknowledgements) === null || _a === void 0 ? void 0 : _a.map((e) => channel_1.PacketState.fromPartial(e))) || [];
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        message.height =
            object.height !== undefined && object.height !== null ? client_1.Height.fromPartial(object.height) : undefined;
        return message;
    },
};
function createBaseQueryUnreceivedPacketsRequest() {
    return { portId: "", channelId: "", packetCommitmentSequences: [] };
}
exports.QueryUnreceivedPacketsRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.portId !== "") {
            writer.uint32(10).string(message.portId);
        }
        if (message.channelId !== "") {
            writer.uint32(18).string(message.channelId);
        }
        writer.uint32(26).fork();
        for (const v of message.packetCommitmentSequences) {
            writer.uint64(v);
        }
        writer.ldelim();
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryUnreceivedPacketsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                case 3:
                    if ((tag & 7) === 2) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.packetCommitmentSequences.push(reader.uint64());
                        }
                    }
                    else {
                        message.packetCommitmentSequences.push(reader.uint64());
                    }
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            portId: isSet(object.portId) ? String(object.portId) : "",
            channelId: isSet(object.channelId) ? String(object.channelId) : "",
            packetCommitmentSequences: Array.isArray(object === null || object === void 0 ? void 0 : object.packetCommitmentSequences)
                ? object.packetCommitmentSequences.map((e) => long_1.default.fromValue(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        if (message.packetCommitmentSequences) {
            obj.packetCommitmentSequences = message.packetCommitmentSequences.map((e) => (e || long_1.default.UZERO).toString());
        }
        else {
            obj.packetCommitmentSequences = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseQueryUnreceivedPacketsRequest();
        message.portId = (_a = object.portId) !== null && _a !== void 0 ? _a : "";
        message.channelId = (_b = object.channelId) !== null && _b !== void 0 ? _b : "";
        message.packetCommitmentSequences = ((_c = object.packetCommitmentSequences) === null || _c === void 0 ? void 0 : _c.map((e) => long_1.default.fromValue(e))) || [];
        return message;
    },
};
function createBaseQueryUnreceivedPacketsResponse() {
    return { sequences: [], height: undefined };
}
exports.QueryUnreceivedPacketsResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        writer.uint32(10).fork();
        for (const v of message.sequences) {
            writer.uint64(v);
        }
        writer.ldelim();
        if (message.height !== undefined) {
            client_1.Height.encode(message.height, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryUnreceivedPacketsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if ((tag & 7) === 2) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.sequences.push(reader.uint64());
                        }
                    }
                    else {
                        message.sequences.push(reader.uint64());
                    }
                    break;
                case 2:
                    message.height = client_1.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            sequences: Array.isArray(object === null || object === void 0 ? void 0 : object.sequences) ? object.sequences.map((e) => long_1.default.fromValue(e)) : [],
            height: isSet(object.height) ? client_1.Height.fromJSON(object.height) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.sequences) {
            obj.sequences = message.sequences.map((e) => (e || long_1.default.UZERO).toString());
        }
        else {
            obj.sequences = [];
        }
        message.height !== undefined && (obj.height = message.height ? client_1.Height.toJSON(message.height) : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryUnreceivedPacketsResponse();
        message.sequences = ((_a = object.sequences) === null || _a === void 0 ? void 0 : _a.map((e) => long_1.default.fromValue(e))) || [];
        message.height =
            object.height !== undefined && object.height !== null ? client_1.Height.fromPartial(object.height) : undefined;
        return message;
    },
};
function createBaseQueryUnreceivedAcksRequest() {
    return { portId: "", channelId: "", packetAckSequences: [] };
}
exports.QueryUnreceivedAcksRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.portId !== "") {
            writer.uint32(10).string(message.portId);
        }
        if (message.channelId !== "") {
            writer.uint32(18).string(message.channelId);
        }
        writer.uint32(26).fork();
        for (const v of message.packetAckSequences) {
            writer.uint64(v);
        }
        writer.ldelim();
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryUnreceivedAcksRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                case 3:
                    if ((tag & 7) === 2) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.packetAckSequences.push(reader.uint64());
                        }
                    }
                    else {
                        message.packetAckSequences.push(reader.uint64());
                    }
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            portId: isSet(object.portId) ? String(object.portId) : "",
            channelId: isSet(object.channelId) ? String(object.channelId) : "",
            packetAckSequences: Array.isArray(object === null || object === void 0 ? void 0 : object.packetAckSequences)
                ? object.packetAckSequences.map((e) => long_1.default.fromValue(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        if (message.packetAckSequences) {
            obj.packetAckSequences = message.packetAckSequences.map((e) => (e || long_1.default.UZERO).toString());
        }
        else {
            obj.packetAckSequences = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseQueryUnreceivedAcksRequest();
        message.portId = (_a = object.portId) !== null && _a !== void 0 ? _a : "";
        message.channelId = (_b = object.channelId) !== null && _b !== void 0 ? _b : "";
        message.packetAckSequences = ((_c = object.packetAckSequences) === null || _c === void 0 ? void 0 : _c.map((e) => long_1.default.fromValue(e))) || [];
        return message;
    },
};
function createBaseQueryUnreceivedAcksResponse() {
    return { sequences: [], height: undefined };
}
exports.QueryUnreceivedAcksResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        writer.uint32(10).fork();
        for (const v of message.sequences) {
            writer.uint64(v);
        }
        writer.ldelim();
        if (message.height !== undefined) {
            client_1.Height.encode(message.height, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryUnreceivedAcksResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if ((tag & 7) === 2) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.sequences.push(reader.uint64());
                        }
                    }
                    else {
                        message.sequences.push(reader.uint64());
                    }
                    break;
                case 2:
                    message.height = client_1.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            sequences: Array.isArray(object === null || object === void 0 ? void 0 : object.sequences) ? object.sequences.map((e) => long_1.default.fromValue(e)) : [],
            height: isSet(object.height) ? client_1.Height.fromJSON(object.height) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.sequences) {
            obj.sequences = message.sequences.map((e) => (e || long_1.default.UZERO).toString());
        }
        else {
            obj.sequences = [];
        }
        message.height !== undefined && (obj.height = message.height ? client_1.Height.toJSON(message.height) : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryUnreceivedAcksResponse();
        message.sequences = ((_a = object.sequences) === null || _a === void 0 ? void 0 : _a.map((e) => long_1.default.fromValue(e))) || [];
        message.height =
            object.height !== undefined && object.height !== null ? client_1.Height.fromPartial(object.height) : undefined;
        return message;
    },
};
function createBaseQueryNextSequenceReceiveRequest() {
    return { portId: "", channelId: "" };
}
exports.QueryNextSequenceReceiveRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.portId !== "") {
            writer.uint32(10).string(message.portId);
        }
        if (message.channelId !== "") {
            writer.uint32(18).string(message.channelId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryNextSequenceReceiveRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            portId: isSet(object.portId) ? String(object.portId) : "",
            channelId: isSet(object.channelId) ? String(object.channelId) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseQueryNextSequenceReceiveRequest();
        message.portId = (_a = object.portId) !== null && _a !== void 0 ? _a : "";
        message.channelId = (_b = object.channelId) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
function createBaseQueryNextSequenceReceiveResponse() {
    return { nextSequenceReceive: long_1.default.UZERO, proof: new Uint8Array(), proofHeight: undefined };
}
exports.QueryNextSequenceReceiveResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (!message.nextSequenceReceive.isZero()) {
            writer.uint32(8).uint64(message.nextSequenceReceive);
        }
        if (message.proof.length !== 0) {
            writer.uint32(18).bytes(message.proof);
        }
        if (message.proofHeight !== undefined) {
            client_1.Height.encode(message.proofHeight, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryNextSequenceReceiveResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.nextSequenceReceive = reader.uint64();
                    break;
                case 2:
                    message.proof = reader.bytes();
                    break;
                case 3:
                    message.proofHeight = client_1.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            nextSequenceReceive: isSet(object.nextSequenceReceive)
                ? long_1.default.fromValue(object.nextSequenceReceive)
                : long_1.default.UZERO,
            proof: isSet(object.proof) ? bytesFromBase64(object.proof) : new Uint8Array(),
            proofHeight: isSet(object.proofHeight) ? client_1.Height.fromJSON(object.proofHeight) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.nextSequenceReceive !== undefined &&
            (obj.nextSequenceReceive = (message.nextSequenceReceive || long_1.default.UZERO).toString());
        message.proof !== undefined &&
            (obj.proof = base64FromBytes(message.proof !== undefined ? message.proof : new Uint8Array()));
        message.proofHeight !== undefined &&
            (obj.proofHeight = message.proofHeight ? client_1.Height.toJSON(message.proofHeight) : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryNextSequenceReceiveResponse();
        message.nextSequenceReceive =
            object.nextSequenceReceive !== undefined && object.nextSequenceReceive !== null
                ? long_1.default.fromValue(object.nextSequenceReceive)
                : long_1.default.UZERO;
        message.proof = (_a = object.proof) !== null && _a !== void 0 ? _a : new Uint8Array();
        message.proofHeight =
            object.proofHeight !== undefined && object.proofHeight !== null
                ? client_1.Height.fromPartial(object.proofHeight)
                : undefined;
        return message;
    },
};
class QueryClientImpl {
    constructor(rpc) {
        this.rpc = rpc;
        this.Channel = this.Channel.bind(this);
        this.Channels = this.Channels.bind(this);
        this.ConnectionChannels = this.ConnectionChannels.bind(this);
        this.ChannelClientState = this.ChannelClientState.bind(this);
        this.ChannelConsensusState = this.ChannelConsensusState.bind(this);
        this.PacketCommitment = this.PacketCommitment.bind(this);
        this.PacketCommitments = this.PacketCommitments.bind(this);
        this.PacketReceipt = this.PacketReceipt.bind(this);
        this.PacketAcknowledgement = this.PacketAcknowledgement.bind(this);
        this.PacketAcknowledgements = this.PacketAcknowledgements.bind(this);
        this.UnreceivedPackets = this.UnreceivedPackets.bind(this);
        this.UnreceivedAcks = this.UnreceivedAcks.bind(this);
        this.NextSequenceReceive = this.NextSequenceReceive.bind(this);
    }
    Channel(request) {
        const data = exports.QueryChannelRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Query", "Channel", data);
        return promise.then((data) => exports.QueryChannelResponse.decode(new minimal_1.default.Reader(data)));
    }
    Channels(request) {
        const data = exports.QueryChannelsRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Query", "Channels", data);
        return promise.then((data) => exports.QueryChannelsResponse.decode(new minimal_1.default.Reader(data)));
    }
    ConnectionChannels(request) {
        const data = exports.QueryConnectionChannelsRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Query", "ConnectionChannels", data);
        return promise.then((data) => exports.QueryConnectionChannelsResponse.decode(new minimal_1.default.Reader(data)));
    }
    ChannelClientState(request) {
        const data = exports.QueryChannelClientStateRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Query", "ChannelClientState", data);
        return promise.then((data) => exports.QueryChannelClientStateResponse.decode(new minimal_1.default.Reader(data)));
    }
    ChannelConsensusState(request) {
        const data = exports.QueryChannelConsensusStateRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Query", "ChannelConsensusState", data);
        return promise.then((data) => exports.QueryChannelConsensusStateResponse.decode(new minimal_1.default.Reader(data)));
    }
    PacketCommitment(request) {
        const data = exports.QueryPacketCommitmentRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Query", "PacketCommitment", data);
        return promise.then((data) => exports.QueryPacketCommitmentResponse.decode(new minimal_1.default.Reader(data)));
    }
    PacketCommitments(request) {
        const data = exports.QueryPacketCommitmentsRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Query", "PacketCommitments", data);
        return promise.then((data) => exports.QueryPacketCommitmentsResponse.decode(new minimal_1.default.Reader(data)));
    }
    PacketReceipt(request) {
        const data = exports.QueryPacketReceiptRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Query", "PacketReceipt", data);
        return promise.then((data) => exports.QueryPacketReceiptResponse.decode(new minimal_1.default.Reader(data)));
    }
    PacketAcknowledgement(request) {
        const data = exports.QueryPacketAcknowledgementRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Query", "PacketAcknowledgement", data);
        return promise.then((data) => exports.QueryPacketAcknowledgementResponse.decode(new minimal_1.default.Reader(data)));
    }
    PacketAcknowledgements(request) {
        const data = exports.QueryPacketAcknowledgementsRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Query", "PacketAcknowledgements", data);
        return promise.then((data) => exports.QueryPacketAcknowledgementsResponse.decode(new minimal_1.default.Reader(data)));
    }
    UnreceivedPackets(request) {
        const data = exports.QueryUnreceivedPacketsRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Query", "UnreceivedPackets", data);
        return promise.then((data) => exports.QueryUnreceivedPacketsResponse.decode(new minimal_1.default.Reader(data)));
    }
    UnreceivedAcks(request) {
        const data = exports.QueryUnreceivedAcksRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Query", "UnreceivedAcks", data);
        return promise.then((data) => exports.QueryUnreceivedAcksResponse.decode(new minimal_1.default.Reader(data)));
    }
    NextSequenceReceive(request) {
        const data = exports.QueryNextSequenceReceiveRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Query", "NextSequenceReceive", data);
        return promise.then((data) => exports.QueryNextSequenceReceiveResponse.decode(new minimal_1.default.Reader(data)));
    }
}
exports.QueryClientImpl = QueryClientImpl;
var globalThis = (() => {
    if (typeof globalThis !== "undefined") {
        return globalThis;
    }
    if (typeof self !== "undefined") {
        return self;
    }
    if (typeof window !== "undefined") {
        return window;
    }
    if (typeof __webpack_require__.g !== "undefined") {
        return __webpack_require__.g;
    }
    throw "Unable to locate global object";
})();
function bytesFromBase64(b64) {
    if (globalThis.Buffer) {
        return Uint8Array.from(globalThis.Buffer.from(b64, "base64"));
    }
    else {
        const bin = globalThis.atob(b64);
        const arr = new Uint8Array(bin.length);
        for (let i = 0; i < bin.length; ++i) {
            arr[i] = bin.charCodeAt(i);
        }
        return arr;
    }
}
function base64FromBytes(arr) {
    if (globalThis.Buffer) {
        return globalThis.Buffer.from(arr).toString("base64");
    }
    else {
        const bin = [];
        arr.forEach((byte) => {
            bin.push(String.fromCharCode(byte));
        });
        return globalThis.btoa(bin.join(""));
    }
}
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=query.js.map

/***/ }),

/***/ 50581:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MsgClientImpl = exports.MsgAcknowledgementResponse = exports.MsgAcknowledgement = exports.MsgTimeoutOnCloseResponse = exports.MsgTimeoutOnClose = exports.MsgTimeoutResponse = exports.MsgTimeout = exports.MsgRecvPacketResponse = exports.MsgRecvPacket = exports.MsgChannelCloseConfirmResponse = exports.MsgChannelCloseConfirm = exports.MsgChannelCloseInitResponse = exports.MsgChannelCloseInit = exports.MsgChannelOpenConfirmResponse = exports.MsgChannelOpenConfirm = exports.MsgChannelOpenAckResponse = exports.MsgChannelOpenAck = exports.MsgChannelOpenTryResponse = exports.MsgChannelOpenTry = exports.MsgChannelOpenInitResponse = exports.MsgChannelOpenInit = exports.responseResultTypeToJSON = exports.responseResultTypeFromJSON = exports.ResponseResultType = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(__webpack_require__(47873));
const minimal_1 = __importDefault(__webpack_require__(62100));
const client_1 = __webpack_require__(74373);
const channel_1 = __webpack_require__(37212);
exports.protobufPackage = "ibc.core.channel.v1";
/** ResponseResultType defines the possible outcomes of the execution of a message */
var ResponseResultType;
(function (ResponseResultType) {
    /** RESPONSE_RESULT_UNSPECIFIED - Default zero value enumeration */
    ResponseResultType[ResponseResultType["RESPONSE_RESULT_UNSPECIFIED"] = 0] = "RESPONSE_RESULT_UNSPECIFIED";
    /** RESPONSE_RESULT_NOOP - The message did not call the IBC application callbacks (because, for example, the packet had already been relayed) */
    ResponseResultType[ResponseResultType["RESPONSE_RESULT_NOOP"] = 1] = "RESPONSE_RESULT_NOOP";
    /** RESPONSE_RESULT_SUCCESS - The message was executed successfully */
    ResponseResultType[ResponseResultType["RESPONSE_RESULT_SUCCESS"] = 2] = "RESPONSE_RESULT_SUCCESS";
    ResponseResultType[ResponseResultType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(ResponseResultType = exports.ResponseResultType || (exports.ResponseResultType = {}));
function responseResultTypeFromJSON(object) {
    switch (object) {
        case 0:
        case "RESPONSE_RESULT_UNSPECIFIED":
            return ResponseResultType.RESPONSE_RESULT_UNSPECIFIED;
        case 1:
        case "RESPONSE_RESULT_NOOP":
            return ResponseResultType.RESPONSE_RESULT_NOOP;
        case 2:
        case "RESPONSE_RESULT_SUCCESS":
            return ResponseResultType.RESPONSE_RESULT_SUCCESS;
        case -1:
        case "UNRECOGNIZED":
        default:
            return ResponseResultType.UNRECOGNIZED;
    }
}
exports.responseResultTypeFromJSON = responseResultTypeFromJSON;
function responseResultTypeToJSON(object) {
    switch (object) {
        case ResponseResultType.RESPONSE_RESULT_UNSPECIFIED:
            return "RESPONSE_RESULT_UNSPECIFIED";
        case ResponseResultType.RESPONSE_RESULT_NOOP:
            return "RESPONSE_RESULT_NOOP";
        case ResponseResultType.RESPONSE_RESULT_SUCCESS:
            return "RESPONSE_RESULT_SUCCESS";
        case ResponseResultType.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.responseResultTypeToJSON = responseResultTypeToJSON;
function createBaseMsgChannelOpenInit() {
    return { portId: "", channel: undefined, signer: "" };
}
exports.MsgChannelOpenInit = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.portId !== "") {
            writer.uint32(10).string(message.portId);
        }
        if (message.channel !== undefined) {
            channel_1.Channel.encode(message.channel, writer.uint32(18).fork()).ldelim();
        }
        if (message.signer !== "") {
            writer.uint32(26).string(message.signer);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgChannelOpenInit();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channel = channel_1.Channel.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            portId: isSet(object.portId) ? String(object.portId) : "",
            channel: isSet(object.channel) ? channel_1.Channel.fromJSON(object.channel) : undefined,
            signer: isSet(object.signer) ? String(object.signer) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channel !== undefined &&
            (obj.channel = message.channel ? channel_1.Channel.toJSON(message.channel) : undefined);
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseMsgChannelOpenInit();
        message.portId = (_a = object.portId) !== null && _a !== void 0 ? _a : "";
        message.channel =
            object.channel !== undefined && object.channel !== null
                ? channel_1.Channel.fromPartial(object.channel)
                : undefined;
        message.signer = (_b = object.signer) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
function createBaseMsgChannelOpenInitResponse() {
    return { channelId: "" };
}
exports.MsgChannelOpenInitResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.channelId !== "") {
            writer.uint32(10).string(message.channelId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgChannelOpenInitResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.channelId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { channelId: isSet(object.channelId) ? String(object.channelId) : "" };
    },
    toJSON(message) {
        const obj = {};
        message.channelId !== undefined && (obj.channelId = message.channelId);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseMsgChannelOpenInitResponse();
        message.channelId = (_a = object.channelId) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
function createBaseMsgChannelOpenTry() {
    return {
        portId: "",
        previousChannelId: "",
        channel: undefined,
        counterpartyVersion: "",
        proofInit: new Uint8Array(),
        proofHeight: undefined,
        signer: "",
    };
}
exports.MsgChannelOpenTry = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.portId !== "") {
            writer.uint32(10).string(message.portId);
        }
        if (message.previousChannelId !== "") {
            writer.uint32(18).string(message.previousChannelId);
        }
        if (message.channel !== undefined) {
            channel_1.Channel.encode(message.channel, writer.uint32(26).fork()).ldelim();
        }
        if (message.counterpartyVersion !== "") {
            writer.uint32(34).string(message.counterpartyVersion);
        }
        if (message.proofInit.length !== 0) {
            writer.uint32(42).bytes(message.proofInit);
        }
        if (message.proofHeight !== undefined) {
            client_1.Height.encode(message.proofHeight, writer.uint32(50).fork()).ldelim();
        }
        if (message.signer !== "") {
            writer.uint32(58).string(message.signer);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgChannelOpenTry();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.previousChannelId = reader.string();
                    break;
                case 3:
                    message.channel = channel_1.Channel.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.counterpartyVersion = reader.string();
                    break;
                case 5:
                    message.proofInit = reader.bytes();
                    break;
                case 6:
                    message.proofHeight = client_1.Height.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            portId: isSet(object.portId) ? String(object.portId) : "",
            previousChannelId: isSet(object.previousChannelId) ? String(object.previousChannelId) : "",
            channel: isSet(object.channel) ? channel_1.Channel.fromJSON(object.channel) : undefined,
            counterpartyVersion: isSet(object.counterpartyVersion) ? String(object.counterpartyVersion) : "",
            proofInit: isSet(object.proofInit) ? bytesFromBase64(object.proofInit) : new Uint8Array(),
            proofHeight: isSet(object.proofHeight) ? client_1.Height.fromJSON(object.proofHeight) : undefined,
            signer: isSet(object.signer) ? String(object.signer) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.previousChannelId !== undefined && (obj.previousChannelId = message.previousChannelId);
        message.channel !== undefined &&
            (obj.channel = message.channel ? channel_1.Channel.toJSON(message.channel) : undefined);
        message.counterpartyVersion !== undefined && (obj.counterpartyVersion = message.counterpartyVersion);
        message.proofInit !== undefined &&
            (obj.proofInit = base64FromBytes(message.proofInit !== undefined ? message.proofInit : new Uint8Array()));
        message.proofHeight !== undefined &&
            (obj.proofHeight = message.proofHeight ? client_1.Height.toJSON(message.proofHeight) : undefined);
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e;
        const message = createBaseMsgChannelOpenTry();
        message.portId = (_a = object.portId) !== null && _a !== void 0 ? _a : "";
        message.previousChannelId = (_b = object.previousChannelId) !== null && _b !== void 0 ? _b : "";
        message.channel =
            object.channel !== undefined && object.channel !== null
                ? channel_1.Channel.fromPartial(object.channel)
                : undefined;
        message.counterpartyVersion = (_c = object.counterpartyVersion) !== null && _c !== void 0 ? _c : "";
        message.proofInit = (_d = object.proofInit) !== null && _d !== void 0 ? _d : new Uint8Array();
        message.proofHeight =
            object.proofHeight !== undefined && object.proofHeight !== null
                ? client_1.Height.fromPartial(object.proofHeight)
                : undefined;
        message.signer = (_e = object.signer) !== null && _e !== void 0 ? _e : "";
        return message;
    },
};
function createBaseMsgChannelOpenTryResponse() {
    return {};
}
exports.MsgChannelOpenTryResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgChannelOpenTryResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgChannelOpenTryResponse();
        return message;
    },
};
function createBaseMsgChannelOpenAck() {
    return {
        portId: "",
        channelId: "",
        counterpartyChannelId: "",
        counterpartyVersion: "",
        proofTry: new Uint8Array(),
        proofHeight: undefined,
        signer: "",
    };
}
exports.MsgChannelOpenAck = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.portId !== "") {
            writer.uint32(10).string(message.portId);
        }
        if (message.channelId !== "") {
            writer.uint32(18).string(message.channelId);
        }
        if (message.counterpartyChannelId !== "") {
            writer.uint32(26).string(message.counterpartyChannelId);
        }
        if (message.counterpartyVersion !== "") {
            writer.uint32(34).string(message.counterpartyVersion);
        }
        if (message.proofTry.length !== 0) {
            writer.uint32(42).bytes(message.proofTry);
        }
        if (message.proofHeight !== undefined) {
            client_1.Height.encode(message.proofHeight, writer.uint32(50).fork()).ldelim();
        }
        if (message.signer !== "") {
            writer.uint32(58).string(message.signer);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgChannelOpenAck();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                case 3:
                    message.counterpartyChannelId = reader.string();
                    break;
                case 4:
                    message.counterpartyVersion = reader.string();
                    break;
                case 5:
                    message.proofTry = reader.bytes();
                    break;
                case 6:
                    message.proofHeight = client_1.Height.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            portId: isSet(object.portId) ? String(object.portId) : "",
            channelId: isSet(object.channelId) ? String(object.channelId) : "",
            counterpartyChannelId: isSet(object.counterpartyChannelId) ? String(object.counterpartyChannelId) : "",
            counterpartyVersion: isSet(object.counterpartyVersion) ? String(object.counterpartyVersion) : "",
            proofTry: isSet(object.proofTry) ? bytesFromBase64(object.proofTry) : new Uint8Array(),
            proofHeight: isSet(object.proofHeight) ? client_1.Height.fromJSON(object.proofHeight) : undefined,
            signer: isSet(object.signer) ? String(object.signer) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        message.counterpartyChannelId !== undefined &&
            (obj.counterpartyChannelId = message.counterpartyChannelId);
        message.counterpartyVersion !== undefined && (obj.counterpartyVersion = message.counterpartyVersion);
        message.proofTry !== undefined &&
            (obj.proofTry = base64FromBytes(message.proofTry !== undefined ? message.proofTry : new Uint8Array()));
        message.proofHeight !== undefined &&
            (obj.proofHeight = message.proofHeight ? client_1.Height.toJSON(message.proofHeight) : undefined);
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f;
        const message = createBaseMsgChannelOpenAck();
        message.portId = (_a = object.portId) !== null && _a !== void 0 ? _a : "";
        message.channelId = (_b = object.channelId) !== null && _b !== void 0 ? _b : "";
        message.counterpartyChannelId = (_c = object.counterpartyChannelId) !== null && _c !== void 0 ? _c : "";
        message.counterpartyVersion = (_d = object.counterpartyVersion) !== null && _d !== void 0 ? _d : "";
        message.proofTry = (_e = object.proofTry) !== null && _e !== void 0 ? _e : new Uint8Array();
        message.proofHeight =
            object.proofHeight !== undefined && object.proofHeight !== null
                ? client_1.Height.fromPartial(object.proofHeight)
                : undefined;
        message.signer = (_f = object.signer) !== null && _f !== void 0 ? _f : "";
        return message;
    },
};
function createBaseMsgChannelOpenAckResponse() {
    return {};
}
exports.MsgChannelOpenAckResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgChannelOpenAckResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgChannelOpenAckResponse();
        return message;
    },
};
function createBaseMsgChannelOpenConfirm() {
    return { portId: "", channelId: "", proofAck: new Uint8Array(), proofHeight: undefined, signer: "" };
}
exports.MsgChannelOpenConfirm = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.portId !== "") {
            writer.uint32(10).string(message.portId);
        }
        if (message.channelId !== "") {
            writer.uint32(18).string(message.channelId);
        }
        if (message.proofAck.length !== 0) {
            writer.uint32(26).bytes(message.proofAck);
        }
        if (message.proofHeight !== undefined) {
            client_1.Height.encode(message.proofHeight, writer.uint32(34).fork()).ldelim();
        }
        if (message.signer !== "") {
            writer.uint32(42).string(message.signer);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgChannelOpenConfirm();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                case 3:
                    message.proofAck = reader.bytes();
                    break;
                case 4:
                    message.proofHeight = client_1.Height.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            portId: isSet(object.portId) ? String(object.portId) : "",
            channelId: isSet(object.channelId) ? String(object.channelId) : "",
            proofAck: isSet(object.proofAck) ? bytesFromBase64(object.proofAck) : new Uint8Array(),
            proofHeight: isSet(object.proofHeight) ? client_1.Height.fromJSON(object.proofHeight) : undefined,
            signer: isSet(object.signer) ? String(object.signer) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        message.proofAck !== undefined &&
            (obj.proofAck = base64FromBytes(message.proofAck !== undefined ? message.proofAck : new Uint8Array()));
        message.proofHeight !== undefined &&
            (obj.proofHeight = message.proofHeight ? client_1.Height.toJSON(message.proofHeight) : undefined);
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d;
        const message = createBaseMsgChannelOpenConfirm();
        message.portId = (_a = object.portId) !== null && _a !== void 0 ? _a : "";
        message.channelId = (_b = object.channelId) !== null && _b !== void 0 ? _b : "";
        message.proofAck = (_c = object.proofAck) !== null && _c !== void 0 ? _c : new Uint8Array();
        message.proofHeight =
            object.proofHeight !== undefined && object.proofHeight !== null
                ? client_1.Height.fromPartial(object.proofHeight)
                : undefined;
        message.signer = (_d = object.signer) !== null && _d !== void 0 ? _d : "";
        return message;
    },
};
function createBaseMsgChannelOpenConfirmResponse() {
    return {};
}
exports.MsgChannelOpenConfirmResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgChannelOpenConfirmResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgChannelOpenConfirmResponse();
        return message;
    },
};
function createBaseMsgChannelCloseInit() {
    return { portId: "", channelId: "", signer: "" };
}
exports.MsgChannelCloseInit = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.portId !== "") {
            writer.uint32(10).string(message.portId);
        }
        if (message.channelId !== "") {
            writer.uint32(18).string(message.channelId);
        }
        if (message.signer !== "") {
            writer.uint32(26).string(message.signer);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgChannelCloseInit();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                case 3:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            portId: isSet(object.portId) ? String(object.portId) : "",
            channelId: isSet(object.channelId) ? String(object.channelId) : "",
            signer: isSet(object.signer) ? String(object.signer) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseMsgChannelCloseInit();
        message.portId = (_a = object.portId) !== null && _a !== void 0 ? _a : "";
        message.channelId = (_b = object.channelId) !== null && _b !== void 0 ? _b : "";
        message.signer = (_c = object.signer) !== null && _c !== void 0 ? _c : "";
        return message;
    },
};
function createBaseMsgChannelCloseInitResponse() {
    return {};
}
exports.MsgChannelCloseInitResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgChannelCloseInitResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgChannelCloseInitResponse();
        return message;
    },
};
function createBaseMsgChannelCloseConfirm() {
    return { portId: "", channelId: "", proofInit: new Uint8Array(), proofHeight: undefined, signer: "" };
}
exports.MsgChannelCloseConfirm = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.portId !== "") {
            writer.uint32(10).string(message.portId);
        }
        if (message.channelId !== "") {
            writer.uint32(18).string(message.channelId);
        }
        if (message.proofInit.length !== 0) {
            writer.uint32(26).bytes(message.proofInit);
        }
        if (message.proofHeight !== undefined) {
            client_1.Height.encode(message.proofHeight, writer.uint32(34).fork()).ldelim();
        }
        if (message.signer !== "") {
            writer.uint32(42).string(message.signer);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgChannelCloseConfirm();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                case 3:
                    message.proofInit = reader.bytes();
                    break;
                case 4:
                    message.proofHeight = client_1.Height.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            portId: isSet(object.portId) ? String(object.portId) : "",
            channelId: isSet(object.channelId) ? String(object.channelId) : "",
            proofInit: isSet(object.proofInit) ? bytesFromBase64(object.proofInit) : new Uint8Array(),
            proofHeight: isSet(object.proofHeight) ? client_1.Height.fromJSON(object.proofHeight) : undefined,
            signer: isSet(object.signer) ? String(object.signer) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        message.proofInit !== undefined &&
            (obj.proofInit = base64FromBytes(message.proofInit !== undefined ? message.proofInit : new Uint8Array()));
        message.proofHeight !== undefined &&
            (obj.proofHeight = message.proofHeight ? client_1.Height.toJSON(message.proofHeight) : undefined);
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d;
        const message = createBaseMsgChannelCloseConfirm();
        message.portId = (_a = object.portId) !== null && _a !== void 0 ? _a : "";
        message.channelId = (_b = object.channelId) !== null && _b !== void 0 ? _b : "";
        message.proofInit = (_c = object.proofInit) !== null && _c !== void 0 ? _c : new Uint8Array();
        message.proofHeight =
            object.proofHeight !== undefined && object.proofHeight !== null
                ? client_1.Height.fromPartial(object.proofHeight)
                : undefined;
        message.signer = (_d = object.signer) !== null && _d !== void 0 ? _d : "";
        return message;
    },
};
function createBaseMsgChannelCloseConfirmResponse() {
    return {};
}
exports.MsgChannelCloseConfirmResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgChannelCloseConfirmResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgChannelCloseConfirmResponse();
        return message;
    },
};
function createBaseMsgRecvPacket() {
    return { packet: undefined, proofCommitment: new Uint8Array(), proofHeight: undefined, signer: "" };
}
exports.MsgRecvPacket = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.packet !== undefined) {
            channel_1.Packet.encode(message.packet, writer.uint32(10).fork()).ldelim();
        }
        if (message.proofCommitment.length !== 0) {
            writer.uint32(18).bytes(message.proofCommitment);
        }
        if (message.proofHeight !== undefined) {
            client_1.Height.encode(message.proofHeight, writer.uint32(26).fork()).ldelim();
        }
        if (message.signer !== "") {
            writer.uint32(34).string(message.signer);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgRecvPacket();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.packet = channel_1.Packet.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.proofCommitment = reader.bytes();
                    break;
                case 3:
                    message.proofHeight = client_1.Height.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            packet: isSet(object.packet) ? channel_1.Packet.fromJSON(object.packet) : undefined,
            proofCommitment: isSet(object.proofCommitment)
                ? bytesFromBase64(object.proofCommitment)
                : new Uint8Array(),
            proofHeight: isSet(object.proofHeight) ? client_1.Height.fromJSON(object.proofHeight) : undefined,
            signer: isSet(object.signer) ? String(object.signer) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.packet !== undefined && (obj.packet = message.packet ? channel_1.Packet.toJSON(message.packet) : undefined);
        message.proofCommitment !== undefined &&
            (obj.proofCommitment = base64FromBytes(message.proofCommitment !== undefined ? message.proofCommitment : new Uint8Array()));
        message.proofHeight !== undefined &&
            (obj.proofHeight = message.proofHeight ? client_1.Height.toJSON(message.proofHeight) : undefined);
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseMsgRecvPacket();
        message.packet =
            object.packet !== undefined && object.packet !== null ? channel_1.Packet.fromPartial(object.packet) : undefined;
        message.proofCommitment = (_a = object.proofCommitment) !== null && _a !== void 0 ? _a : new Uint8Array();
        message.proofHeight =
            object.proofHeight !== undefined && object.proofHeight !== null
                ? client_1.Height.fromPartial(object.proofHeight)
                : undefined;
        message.signer = (_b = object.signer) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
function createBaseMsgRecvPacketResponse() {
    return { result: 0 };
}
exports.MsgRecvPacketResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.result !== 0) {
            writer.uint32(8).int32(message.result);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgRecvPacketResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.result = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { result: isSet(object.result) ? responseResultTypeFromJSON(object.result) : 0 };
    },
    toJSON(message) {
        const obj = {};
        message.result !== undefined && (obj.result = responseResultTypeToJSON(message.result));
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseMsgRecvPacketResponse();
        message.result = (_a = object.result) !== null && _a !== void 0 ? _a : 0;
        return message;
    },
};
function createBaseMsgTimeout() {
    return {
        packet: undefined,
        proofUnreceived: new Uint8Array(),
        proofHeight: undefined,
        nextSequenceRecv: long_1.default.UZERO,
        signer: "",
    };
}
exports.MsgTimeout = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.packet !== undefined) {
            channel_1.Packet.encode(message.packet, writer.uint32(10).fork()).ldelim();
        }
        if (message.proofUnreceived.length !== 0) {
            writer.uint32(18).bytes(message.proofUnreceived);
        }
        if (message.proofHeight !== undefined) {
            client_1.Height.encode(message.proofHeight, writer.uint32(26).fork()).ldelim();
        }
        if (!message.nextSequenceRecv.isZero()) {
            writer.uint32(32).uint64(message.nextSequenceRecv);
        }
        if (message.signer !== "") {
            writer.uint32(42).string(message.signer);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgTimeout();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.packet = channel_1.Packet.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.proofUnreceived = reader.bytes();
                    break;
                case 3:
                    message.proofHeight = client_1.Height.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.nextSequenceRecv = reader.uint64();
                    break;
                case 5:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            packet: isSet(object.packet) ? channel_1.Packet.fromJSON(object.packet) : undefined,
            proofUnreceived: isSet(object.proofUnreceived)
                ? bytesFromBase64(object.proofUnreceived)
                : new Uint8Array(),
            proofHeight: isSet(object.proofHeight) ? client_1.Height.fromJSON(object.proofHeight) : undefined,
            nextSequenceRecv: isSet(object.nextSequenceRecv) ? long_1.default.fromValue(object.nextSequenceRecv) : long_1.default.UZERO,
            signer: isSet(object.signer) ? String(object.signer) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.packet !== undefined && (obj.packet = message.packet ? channel_1.Packet.toJSON(message.packet) : undefined);
        message.proofUnreceived !== undefined &&
            (obj.proofUnreceived = base64FromBytes(message.proofUnreceived !== undefined ? message.proofUnreceived : new Uint8Array()));
        message.proofHeight !== undefined &&
            (obj.proofHeight = message.proofHeight ? client_1.Height.toJSON(message.proofHeight) : undefined);
        message.nextSequenceRecv !== undefined &&
            (obj.nextSequenceRecv = (message.nextSequenceRecv || long_1.default.UZERO).toString());
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseMsgTimeout();
        message.packet =
            object.packet !== undefined && object.packet !== null ? channel_1.Packet.fromPartial(object.packet) : undefined;
        message.proofUnreceived = (_a = object.proofUnreceived) !== null && _a !== void 0 ? _a : new Uint8Array();
        message.proofHeight =
            object.proofHeight !== undefined && object.proofHeight !== null
                ? client_1.Height.fromPartial(object.proofHeight)
                : undefined;
        message.nextSequenceRecv =
            object.nextSequenceRecv !== undefined && object.nextSequenceRecv !== null
                ? long_1.default.fromValue(object.nextSequenceRecv)
                : long_1.default.UZERO;
        message.signer = (_b = object.signer) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
function createBaseMsgTimeoutResponse() {
    return { result: 0 };
}
exports.MsgTimeoutResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.result !== 0) {
            writer.uint32(8).int32(message.result);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgTimeoutResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.result = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { result: isSet(object.result) ? responseResultTypeFromJSON(object.result) : 0 };
    },
    toJSON(message) {
        const obj = {};
        message.result !== undefined && (obj.result = responseResultTypeToJSON(message.result));
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseMsgTimeoutResponse();
        message.result = (_a = object.result) !== null && _a !== void 0 ? _a : 0;
        return message;
    },
};
function createBaseMsgTimeoutOnClose() {
    return {
        packet: undefined,
        proofUnreceived: new Uint8Array(),
        proofClose: new Uint8Array(),
        proofHeight: undefined,
        nextSequenceRecv: long_1.default.UZERO,
        signer: "",
    };
}
exports.MsgTimeoutOnClose = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.packet !== undefined) {
            channel_1.Packet.encode(message.packet, writer.uint32(10).fork()).ldelim();
        }
        if (message.proofUnreceived.length !== 0) {
            writer.uint32(18).bytes(message.proofUnreceived);
        }
        if (message.proofClose.length !== 0) {
            writer.uint32(26).bytes(message.proofClose);
        }
        if (message.proofHeight !== undefined) {
            client_1.Height.encode(message.proofHeight, writer.uint32(34).fork()).ldelim();
        }
        if (!message.nextSequenceRecv.isZero()) {
            writer.uint32(40).uint64(message.nextSequenceRecv);
        }
        if (message.signer !== "") {
            writer.uint32(50).string(message.signer);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgTimeoutOnClose();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.packet = channel_1.Packet.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.proofUnreceived = reader.bytes();
                    break;
                case 3:
                    message.proofClose = reader.bytes();
                    break;
                case 4:
                    message.proofHeight = client_1.Height.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.nextSequenceRecv = reader.uint64();
                    break;
                case 6:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            packet: isSet(object.packet) ? channel_1.Packet.fromJSON(object.packet) : undefined,
            proofUnreceived: isSet(object.proofUnreceived)
                ? bytesFromBase64(object.proofUnreceived)
                : new Uint8Array(),
            proofClose: isSet(object.proofClose) ? bytesFromBase64(object.proofClose) : new Uint8Array(),
            proofHeight: isSet(object.proofHeight) ? client_1.Height.fromJSON(object.proofHeight) : undefined,
            nextSequenceRecv: isSet(object.nextSequenceRecv) ? long_1.default.fromValue(object.nextSequenceRecv) : long_1.default.UZERO,
            signer: isSet(object.signer) ? String(object.signer) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.packet !== undefined && (obj.packet = message.packet ? channel_1.Packet.toJSON(message.packet) : undefined);
        message.proofUnreceived !== undefined &&
            (obj.proofUnreceived = base64FromBytes(message.proofUnreceived !== undefined ? message.proofUnreceived : new Uint8Array()));
        message.proofClose !== undefined &&
            (obj.proofClose = base64FromBytes(message.proofClose !== undefined ? message.proofClose : new Uint8Array()));
        message.proofHeight !== undefined &&
            (obj.proofHeight = message.proofHeight ? client_1.Height.toJSON(message.proofHeight) : undefined);
        message.nextSequenceRecv !== undefined &&
            (obj.nextSequenceRecv = (message.nextSequenceRecv || long_1.default.UZERO).toString());
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseMsgTimeoutOnClose();
        message.packet =
            object.packet !== undefined && object.packet !== null ? channel_1.Packet.fromPartial(object.packet) : undefined;
        message.proofUnreceived = (_a = object.proofUnreceived) !== null && _a !== void 0 ? _a : new Uint8Array();
        message.proofClose = (_b = object.proofClose) !== null && _b !== void 0 ? _b : new Uint8Array();
        message.proofHeight =
            object.proofHeight !== undefined && object.proofHeight !== null
                ? client_1.Height.fromPartial(object.proofHeight)
                : undefined;
        message.nextSequenceRecv =
            object.nextSequenceRecv !== undefined && object.nextSequenceRecv !== null
                ? long_1.default.fromValue(object.nextSequenceRecv)
                : long_1.default.UZERO;
        message.signer = (_c = object.signer) !== null && _c !== void 0 ? _c : "";
        return message;
    },
};
function createBaseMsgTimeoutOnCloseResponse() {
    return { result: 0 };
}
exports.MsgTimeoutOnCloseResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.result !== 0) {
            writer.uint32(8).int32(message.result);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgTimeoutOnCloseResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.result = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { result: isSet(object.result) ? responseResultTypeFromJSON(object.result) : 0 };
    },
    toJSON(message) {
        const obj = {};
        message.result !== undefined && (obj.result = responseResultTypeToJSON(message.result));
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseMsgTimeoutOnCloseResponse();
        message.result = (_a = object.result) !== null && _a !== void 0 ? _a : 0;
        return message;
    },
};
function createBaseMsgAcknowledgement() {
    return {
        packet: undefined,
        acknowledgement: new Uint8Array(),
        proofAcked: new Uint8Array(),
        proofHeight: undefined,
        signer: "",
    };
}
exports.MsgAcknowledgement = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.packet !== undefined) {
            channel_1.Packet.encode(message.packet, writer.uint32(10).fork()).ldelim();
        }
        if (message.acknowledgement.length !== 0) {
            writer.uint32(18).bytes(message.acknowledgement);
        }
        if (message.proofAcked.length !== 0) {
            writer.uint32(26).bytes(message.proofAcked);
        }
        if (message.proofHeight !== undefined) {
            client_1.Height.encode(message.proofHeight, writer.uint32(34).fork()).ldelim();
        }
        if (message.signer !== "") {
            writer.uint32(42).string(message.signer);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgAcknowledgement();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.packet = channel_1.Packet.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.acknowledgement = reader.bytes();
                    break;
                case 3:
                    message.proofAcked = reader.bytes();
                    break;
                case 4:
                    message.proofHeight = client_1.Height.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            packet: isSet(object.packet) ? channel_1.Packet.fromJSON(object.packet) : undefined,
            acknowledgement: isSet(object.acknowledgement)
                ? bytesFromBase64(object.acknowledgement)
                : new Uint8Array(),
            proofAcked: isSet(object.proofAcked) ? bytesFromBase64(object.proofAcked) : new Uint8Array(),
            proofHeight: isSet(object.proofHeight) ? client_1.Height.fromJSON(object.proofHeight) : undefined,
            signer: isSet(object.signer) ? String(object.signer) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.packet !== undefined && (obj.packet = message.packet ? channel_1.Packet.toJSON(message.packet) : undefined);
        message.acknowledgement !== undefined &&
            (obj.acknowledgement = base64FromBytes(message.acknowledgement !== undefined ? message.acknowledgement : new Uint8Array()));
        message.proofAcked !== undefined &&
            (obj.proofAcked = base64FromBytes(message.proofAcked !== undefined ? message.proofAcked : new Uint8Array()));
        message.proofHeight !== undefined &&
            (obj.proofHeight = message.proofHeight ? client_1.Height.toJSON(message.proofHeight) : undefined);
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseMsgAcknowledgement();
        message.packet =
            object.packet !== undefined && object.packet !== null ? channel_1.Packet.fromPartial(object.packet) : undefined;
        message.acknowledgement = (_a = object.acknowledgement) !== null && _a !== void 0 ? _a : new Uint8Array();
        message.proofAcked = (_b = object.proofAcked) !== null && _b !== void 0 ? _b : new Uint8Array();
        message.proofHeight =
            object.proofHeight !== undefined && object.proofHeight !== null
                ? client_1.Height.fromPartial(object.proofHeight)
                : undefined;
        message.signer = (_c = object.signer) !== null && _c !== void 0 ? _c : "";
        return message;
    },
};
function createBaseMsgAcknowledgementResponse() {
    return { result: 0 };
}
exports.MsgAcknowledgementResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.result !== 0) {
            writer.uint32(8).int32(message.result);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgAcknowledgementResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.result = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { result: isSet(object.result) ? responseResultTypeFromJSON(object.result) : 0 };
    },
    toJSON(message) {
        const obj = {};
        message.result !== undefined && (obj.result = responseResultTypeToJSON(message.result));
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseMsgAcknowledgementResponse();
        message.result = (_a = object.result) !== null && _a !== void 0 ? _a : 0;
        return message;
    },
};
class MsgClientImpl {
    constructor(rpc) {
        this.rpc = rpc;
        this.ChannelOpenInit = this.ChannelOpenInit.bind(this);
        this.ChannelOpenTry = this.ChannelOpenTry.bind(this);
        this.ChannelOpenAck = this.ChannelOpenAck.bind(this);
        this.ChannelOpenConfirm = this.ChannelOpenConfirm.bind(this);
        this.ChannelCloseInit = this.ChannelCloseInit.bind(this);
        this.ChannelCloseConfirm = this.ChannelCloseConfirm.bind(this);
        this.RecvPacket = this.RecvPacket.bind(this);
        this.Timeout = this.Timeout.bind(this);
        this.TimeoutOnClose = this.TimeoutOnClose.bind(this);
        this.Acknowledgement = this.Acknowledgement.bind(this);
    }
    ChannelOpenInit(request) {
        const data = exports.MsgChannelOpenInit.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Msg", "ChannelOpenInit", data);
        return promise.then((data) => exports.MsgChannelOpenInitResponse.decode(new minimal_1.default.Reader(data)));
    }
    ChannelOpenTry(request) {
        const data = exports.MsgChannelOpenTry.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Msg", "ChannelOpenTry", data);
        return promise.then((data) => exports.MsgChannelOpenTryResponse.decode(new minimal_1.default.Reader(data)));
    }
    ChannelOpenAck(request) {
        const data = exports.MsgChannelOpenAck.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Msg", "ChannelOpenAck", data);
        return promise.then((data) => exports.MsgChannelOpenAckResponse.decode(new minimal_1.default.Reader(data)));
    }
    ChannelOpenConfirm(request) {
        const data = exports.MsgChannelOpenConfirm.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Msg", "ChannelOpenConfirm", data);
        return promise.then((data) => exports.MsgChannelOpenConfirmResponse.decode(new minimal_1.default.Reader(data)));
    }
    ChannelCloseInit(request) {
        const data = exports.MsgChannelCloseInit.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Msg", "ChannelCloseInit", data);
        return promise.then((data) => exports.MsgChannelCloseInitResponse.decode(new minimal_1.default.Reader(data)));
    }
    ChannelCloseConfirm(request) {
        const data = exports.MsgChannelCloseConfirm.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Msg", "ChannelCloseConfirm", data);
        return promise.then((data) => exports.MsgChannelCloseConfirmResponse.decode(new minimal_1.default.Reader(data)));
    }
    RecvPacket(request) {
        const data = exports.MsgRecvPacket.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Msg", "RecvPacket", data);
        return promise.then((data) => exports.MsgRecvPacketResponse.decode(new minimal_1.default.Reader(data)));
    }
    Timeout(request) {
        const data = exports.MsgTimeout.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Msg", "Timeout", data);
        return promise.then((data) => exports.MsgTimeoutResponse.decode(new minimal_1.default.Reader(data)));
    }
    TimeoutOnClose(request) {
        const data = exports.MsgTimeoutOnClose.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Msg", "TimeoutOnClose", data);
        return promise.then((data) => exports.MsgTimeoutOnCloseResponse.decode(new minimal_1.default.Reader(data)));
    }
    Acknowledgement(request) {
        const data = exports.MsgAcknowledgement.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Msg", "Acknowledgement", data);
        return promise.then((data) => exports.MsgAcknowledgementResponse.decode(new minimal_1.default.Reader(data)));
    }
}
exports.MsgClientImpl = MsgClientImpl;
var globalThis = (() => {
    if (typeof globalThis !== "undefined") {
        return globalThis;
    }
    if (typeof self !== "undefined") {
        return self;
    }
    if (typeof window !== "undefined") {
        return window;
    }
    if (typeof __webpack_require__.g !== "undefined") {
        return __webpack_require__.g;
    }
    throw "Unable to locate global object";
})();
function bytesFromBase64(b64) {
    if (globalThis.Buffer) {
        return Uint8Array.from(globalThis.Buffer.from(b64, "base64"));
    }
    else {
        const bin = globalThis.atob(b64);
        const arr = new Uint8Array(bin.length);
        for (let i = 0; i < bin.length; ++i) {
            arr[i] = bin.charCodeAt(i);
        }
        return arr;
    }
}
function base64FromBytes(arr) {
    if (globalThis.Buffer) {
        return globalThis.Buffer.from(arr).toString("base64");
    }
    else {
        const bin = [];
        arr.forEach((byte) => {
            bin.push(String.fromCharCode(byte));
        });
        return globalThis.btoa(bin.join(""));
    }
}
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=tx.js.map

/***/ }),

/***/ 74373:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Params = exports.Height = exports.UpgradeProposal = exports.ClientUpdateProposal = exports.ClientConsensusStates = exports.ConsensusStateWithHeight = exports.IdentifiedClientState = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(__webpack_require__(47873));
const minimal_1 = __importDefault(__webpack_require__(62100));
const upgrade_1 = __webpack_require__(48419);
const any_1 = __webpack_require__(90007);
exports.protobufPackage = "ibc.core.client.v1";
function createBaseIdentifiedClientState() {
    return { clientId: "", clientState: undefined };
}
exports.IdentifiedClientState = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.clientId !== "") {
            writer.uint32(10).string(message.clientId);
        }
        if (message.clientState !== undefined) {
            any_1.Any.encode(message.clientState, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseIdentifiedClientState();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.clientState = any_1.Any.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            clientId: isSet(object.clientId) ? String(object.clientId) : "",
            clientState: isSet(object.clientState) ? any_1.Any.fromJSON(object.clientState) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        message.clientState !== undefined &&
            (obj.clientState = message.clientState ? any_1.Any.toJSON(message.clientState) : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseIdentifiedClientState();
        message.clientId = (_a = object.clientId) !== null && _a !== void 0 ? _a : "";
        message.clientState =
            object.clientState !== undefined && object.clientState !== null
                ? any_1.Any.fromPartial(object.clientState)
                : undefined;
        return message;
    },
};
function createBaseConsensusStateWithHeight() {
    return { height: undefined, consensusState: undefined };
}
exports.ConsensusStateWithHeight = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.height !== undefined) {
            exports.Height.encode(message.height, writer.uint32(10).fork()).ldelim();
        }
        if (message.consensusState !== undefined) {
            any_1.Any.encode(message.consensusState, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseConsensusStateWithHeight();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.height = exports.Height.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.consensusState = any_1.Any.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            height: isSet(object.height) ? exports.Height.fromJSON(object.height) : undefined,
            consensusState: isSet(object.consensusState) ? any_1.Any.fromJSON(object.consensusState) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.height !== undefined && (obj.height = message.height ? exports.Height.toJSON(message.height) : undefined);
        message.consensusState !== undefined &&
            (obj.consensusState = message.consensusState ? any_1.Any.toJSON(message.consensusState) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseConsensusStateWithHeight();
        message.height =
            object.height !== undefined && object.height !== null ? exports.Height.fromPartial(object.height) : undefined;
        message.consensusState =
            object.consensusState !== undefined && object.consensusState !== null
                ? any_1.Any.fromPartial(object.consensusState)
                : undefined;
        return message;
    },
};
function createBaseClientConsensusStates() {
    return { clientId: "", consensusStates: [] };
}
exports.ClientConsensusStates = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.clientId !== "") {
            writer.uint32(10).string(message.clientId);
        }
        for (const v of message.consensusStates) {
            exports.ConsensusStateWithHeight.encode(v, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseClientConsensusStates();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.consensusStates.push(exports.ConsensusStateWithHeight.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            clientId: isSet(object.clientId) ? String(object.clientId) : "",
            consensusStates: Array.isArray(object === null || object === void 0 ? void 0 : object.consensusStates)
                ? object.consensusStates.map((e) => exports.ConsensusStateWithHeight.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        if (message.consensusStates) {
            obj.consensusStates = message.consensusStates.map((e) => e ? exports.ConsensusStateWithHeight.toJSON(e) : undefined);
        }
        else {
            obj.consensusStates = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseClientConsensusStates();
        message.clientId = (_a = object.clientId) !== null && _a !== void 0 ? _a : "";
        message.consensusStates =
            ((_b = object.consensusStates) === null || _b === void 0 ? void 0 : _b.map((e) => exports.ConsensusStateWithHeight.fromPartial(e))) || [];
        return message;
    },
};
function createBaseClientUpdateProposal() {
    return { title: "", description: "", subjectClientId: "", substituteClientId: "" };
}
exports.ClientUpdateProposal = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.title !== "") {
            writer.uint32(10).string(message.title);
        }
        if (message.description !== "") {
            writer.uint32(18).string(message.description);
        }
        if (message.subjectClientId !== "") {
            writer.uint32(26).string(message.subjectClientId);
        }
        if (message.substituteClientId !== "") {
            writer.uint32(34).string(message.substituteClientId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseClientUpdateProposal();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.title = reader.string();
                    break;
                case 2:
                    message.description = reader.string();
                    break;
                case 3:
                    message.subjectClientId = reader.string();
                    break;
                case 4:
                    message.substituteClientId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            title: isSet(object.title) ? String(object.title) : "",
            description: isSet(object.description) ? String(object.description) : "",
            subjectClientId: isSet(object.subjectClientId) ? String(object.subjectClientId) : "",
            substituteClientId: isSet(object.substituteClientId) ? String(object.substituteClientId) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.title !== undefined && (obj.title = message.title);
        message.description !== undefined && (obj.description = message.description);
        message.subjectClientId !== undefined && (obj.subjectClientId = message.subjectClientId);
        message.substituteClientId !== undefined && (obj.substituteClientId = message.substituteClientId);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d;
        const message = createBaseClientUpdateProposal();
        message.title = (_a = object.title) !== null && _a !== void 0 ? _a : "";
        message.description = (_b = object.description) !== null && _b !== void 0 ? _b : "";
        message.subjectClientId = (_c = object.subjectClientId) !== null && _c !== void 0 ? _c : "";
        message.substituteClientId = (_d = object.substituteClientId) !== null && _d !== void 0 ? _d : "";
        return message;
    },
};
function createBaseUpgradeProposal() {
    return { title: "", description: "", plan: undefined, upgradedClientState: undefined };
}
exports.UpgradeProposal = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.title !== "") {
            writer.uint32(10).string(message.title);
        }
        if (message.description !== "") {
            writer.uint32(18).string(message.description);
        }
        if (message.plan !== undefined) {
            upgrade_1.Plan.encode(message.plan, writer.uint32(26).fork()).ldelim();
        }
        if (message.upgradedClientState !== undefined) {
            any_1.Any.encode(message.upgradedClientState, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUpgradeProposal();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.title = reader.string();
                    break;
                case 2:
                    message.description = reader.string();
                    break;
                case 3:
                    message.plan = upgrade_1.Plan.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.upgradedClientState = any_1.Any.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            title: isSet(object.title) ? String(object.title) : "",
            description: isSet(object.description) ? String(object.description) : "",
            plan: isSet(object.plan) ? upgrade_1.Plan.fromJSON(object.plan) : undefined,
            upgradedClientState: isSet(object.upgradedClientState)
                ? any_1.Any.fromJSON(object.upgradedClientState)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.title !== undefined && (obj.title = message.title);
        message.description !== undefined && (obj.description = message.description);
        message.plan !== undefined && (obj.plan = message.plan ? upgrade_1.Plan.toJSON(message.plan) : undefined);
        message.upgradedClientState !== undefined &&
            (obj.upgradedClientState = message.upgradedClientState
                ? any_1.Any.toJSON(message.upgradedClientState)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseUpgradeProposal();
        message.title = (_a = object.title) !== null && _a !== void 0 ? _a : "";
        message.description = (_b = object.description) !== null && _b !== void 0 ? _b : "";
        message.plan =
            object.plan !== undefined && object.plan !== null ? upgrade_1.Plan.fromPartial(object.plan) : undefined;
        message.upgradedClientState =
            object.upgradedClientState !== undefined && object.upgradedClientState !== null
                ? any_1.Any.fromPartial(object.upgradedClientState)
                : undefined;
        return message;
    },
};
function createBaseHeight() {
    return { revisionNumber: long_1.default.UZERO, revisionHeight: long_1.default.UZERO };
}
exports.Height = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (!message.revisionNumber.isZero()) {
            writer.uint32(8).uint64(message.revisionNumber);
        }
        if (!message.revisionHeight.isZero()) {
            writer.uint32(16).uint64(message.revisionHeight);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseHeight();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.revisionNumber = reader.uint64();
                    break;
                case 2:
                    message.revisionHeight = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            revisionNumber: isSet(object.revisionNumber) ? long_1.default.fromValue(object.revisionNumber) : long_1.default.UZERO,
            revisionHeight: isSet(object.revisionHeight) ? long_1.default.fromValue(object.revisionHeight) : long_1.default.UZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        message.revisionNumber !== undefined &&
            (obj.revisionNumber = (message.revisionNumber || long_1.default.UZERO).toString());
        message.revisionHeight !== undefined &&
            (obj.revisionHeight = (message.revisionHeight || long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseHeight();
        message.revisionNumber =
            object.revisionNumber !== undefined && object.revisionNumber !== null
                ? long_1.default.fromValue(object.revisionNumber)
                : long_1.default.UZERO;
        message.revisionHeight =
            object.revisionHeight !== undefined && object.revisionHeight !== null
                ? long_1.default.fromValue(object.revisionHeight)
                : long_1.default.UZERO;
        return message;
    },
};
function createBaseParams() {
    return { allowedClients: [] };
}
exports.Params = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.allowedClients) {
            writer.uint32(10).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseParams();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.allowedClients.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            allowedClients: Array.isArray(object === null || object === void 0 ? void 0 : object.allowedClients)
                ? object.allowedClients.map((e) => String(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.allowedClients) {
            obj.allowedClients = message.allowedClients.map((e) => e);
        }
        else {
            obj.allowedClients = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseParams();
        message.allowedClients = ((_a = object.allowedClients) === null || _a === void 0 ? void 0 : _a.map((e) => e)) || [];
        return message;
    },
};
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=client.js.map

/***/ }),

/***/ 12858:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.QueryClientImpl = exports.QueryUpgradedConsensusStateResponse = exports.QueryUpgradedConsensusStateRequest = exports.QueryUpgradedClientStateResponse = exports.QueryUpgradedClientStateRequest = exports.QueryClientParamsResponse = exports.QueryClientParamsRequest = exports.QueryClientStatusResponse = exports.QueryClientStatusRequest = exports.QueryConsensusStatesResponse = exports.QueryConsensusStatesRequest = exports.QueryConsensusStateResponse = exports.QueryConsensusStateRequest = exports.QueryClientStatesResponse = exports.QueryClientStatesRequest = exports.QueryClientStateResponse = exports.QueryClientStateRequest = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(__webpack_require__(47873));
const minimal_1 = __importDefault(__webpack_require__(62100));
const pagination_1 = __webpack_require__(62635);
const any_1 = __webpack_require__(90007);
const client_1 = __webpack_require__(74373);
exports.protobufPackage = "ibc.core.client.v1";
function createBaseQueryClientStateRequest() {
    return { clientId: "" };
}
exports.QueryClientStateRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.clientId !== "") {
            writer.uint32(10).string(message.clientId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryClientStateRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.clientId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { clientId: isSet(object.clientId) ? String(object.clientId) : "" };
    },
    toJSON(message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryClientStateRequest();
        message.clientId = (_a = object.clientId) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
function createBaseQueryClientStateResponse() {
    return { clientState: undefined, proof: new Uint8Array(), proofHeight: undefined };
}
exports.QueryClientStateResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.clientState !== undefined) {
            any_1.Any.encode(message.clientState, writer.uint32(10).fork()).ldelim();
        }
        if (message.proof.length !== 0) {
            writer.uint32(18).bytes(message.proof);
        }
        if (message.proofHeight !== undefined) {
            client_1.Height.encode(message.proofHeight, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryClientStateResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.clientState = any_1.Any.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.proof = reader.bytes();
                    break;
                case 3:
                    message.proofHeight = client_1.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            clientState: isSet(object.clientState) ? any_1.Any.fromJSON(object.clientState) : undefined,
            proof: isSet(object.proof) ? bytesFromBase64(object.proof) : new Uint8Array(),
            proofHeight: isSet(object.proofHeight) ? client_1.Height.fromJSON(object.proofHeight) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.clientState !== undefined &&
            (obj.clientState = message.clientState ? any_1.Any.toJSON(message.clientState) : undefined);
        message.proof !== undefined &&
            (obj.proof = base64FromBytes(message.proof !== undefined ? message.proof : new Uint8Array()));
        message.proofHeight !== undefined &&
            (obj.proofHeight = message.proofHeight ? client_1.Height.toJSON(message.proofHeight) : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryClientStateResponse();
        message.clientState =
            object.clientState !== undefined && object.clientState !== null
                ? any_1.Any.fromPartial(object.clientState)
                : undefined;
        message.proof = (_a = object.proof) !== null && _a !== void 0 ? _a : new Uint8Array();
        message.proofHeight =
            object.proofHeight !== undefined && object.proofHeight !== null
                ? client_1.Height.fromPartial(object.proofHeight)
                : undefined;
        return message;
    },
};
function createBaseQueryClientStatesRequest() {
    return { pagination: undefined };
}
exports.QueryClientStatesRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryClientStatesRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { pagination: isSet(object.pagination) ? pagination_1.PageRequest.fromJSON(object.pagination) : undefined };
    },
    toJSON(message) {
        const obj = {};
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryClientStatesRequest();
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryClientStatesResponse() {
    return { clientStates: [], pagination: undefined };
}
exports.QueryClientStatesResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.clientStates) {
            client_1.IdentifiedClientState.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryClientStatesResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.clientStates.push(client_1.IdentifiedClientState.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            clientStates: Array.isArray(object === null || object === void 0 ? void 0 : object.clientStates)
                ? object.clientStates.map((e) => client_1.IdentifiedClientState.fromJSON(e))
                : [],
            pagination: isSet(object.pagination) ? pagination_1.PageResponse.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.clientStates) {
            obj.clientStates = message.clientStates.map((e) => (e ? client_1.IdentifiedClientState.toJSON(e) : undefined));
        }
        else {
            obj.clientStates = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryClientStatesResponse();
        message.clientStates = ((_a = object.clientStates) === null || _a === void 0 ? void 0 : _a.map((e) => client_1.IdentifiedClientState.fromPartial(e))) || [];
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryConsensusStateRequest() {
    return { clientId: "", revisionNumber: long_1.default.UZERO, revisionHeight: long_1.default.UZERO, latestHeight: false };
}
exports.QueryConsensusStateRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.clientId !== "") {
            writer.uint32(10).string(message.clientId);
        }
        if (!message.revisionNumber.isZero()) {
            writer.uint32(16).uint64(message.revisionNumber);
        }
        if (!message.revisionHeight.isZero()) {
            writer.uint32(24).uint64(message.revisionHeight);
        }
        if (message.latestHeight === true) {
            writer.uint32(32).bool(message.latestHeight);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryConsensusStateRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.revisionNumber = reader.uint64();
                    break;
                case 3:
                    message.revisionHeight = reader.uint64();
                    break;
                case 4:
                    message.latestHeight = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            clientId: isSet(object.clientId) ? String(object.clientId) : "",
            revisionNumber: isSet(object.revisionNumber) ? long_1.default.fromValue(object.revisionNumber) : long_1.default.UZERO,
            revisionHeight: isSet(object.revisionHeight) ? long_1.default.fromValue(object.revisionHeight) : long_1.default.UZERO,
            latestHeight: isSet(object.latestHeight) ? Boolean(object.latestHeight) : false,
        };
    },
    toJSON(message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        message.revisionNumber !== undefined &&
            (obj.revisionNumber = (message.revisionNumber || long_1.default.UZERO).toString());
        message.revisionHeight !== undefined &&
            (obj.revisionHeight = (message.revisionHeight || long_1.default.UZERO).toString());
        message.latestHeight !== undefined && (obj.latestHeight = message.latestHeight);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseQueryConsensusStateRequest();
        message.clientId = (_a = object.clientId) !== null && _a !== void 0 ? _a : "";
        message.revisionNumber =
            object.revisionNumber !== undefined && object.revisionNumber !== null
                ? long_1.default.fromValue(object.revisionNumber)
                : long_1.default.UZERO;
        message.revisionHeight =
            object.revisionHeight !== undefined && object.revisionHeight !== null
                ? long_1.default.fromValue(object.revisionHeight)
                : long_1.default.UZERO;
        message.latestHeight = (_b = object.latestHeight) !== null && _b !== void 0 ? _b : false;
        return message;
    },
};
function createBaseQueryConsensusStateResponse() {
    return { consensusState: undefined, proof: new Uint8Array(), proofHeight: undefined };
}
exports.QueryConsensusStateResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.consensusState !== undefined) {
            any_1.Any.encode(message.consensusState, writer.uint32(10).fork()).ldelim();
        }
        if (message.proof.length !== 0) {
            writer.uint32(18).bytes(message.proof);
        }
        if (message.proofHeight !== undefined) {
            client_1.Height.encode(message.proofHeight, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryConsensusStateResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.consensusState = any_1.Any.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.proof = reader.bytes();
                    break;
                case 3:
                    message.proofHeight = client_1.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            consensusState: isSet(object.consensusState) ? any_1.Any.fromJSON(object.consensusState) : undefined,
            proof: isSet(object.proof) ? bytesFromBase64(object.proof) : new Uint8Array(),
            proofHeight: isSet(object.proofHeight) ? client_1.Height.fromJSON(object.proofHeight) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.consensusState !== undefined &&
            (obj.consensusState = message.consensusState ? any_1.Any.toJSON(message.consensusState) : undefined);
        message.proof !== undefined &&
            (obj.proof = base64FromBytes(message.proof !== undefined ? message.proof : new Uint8Array()));
        message.proofHeight !== undefined &&
            (obj.proofHeight = message.proofHeight ? client_1.Height.toJSON(message.proofHeight) : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryConsensusStateResponse();
        message.consensusState =
            object.consensusState !== undefined && object.consensusState !== null
                ? any_1.Any.fromPartial(object.consensusState)
                : undefined;
        message.proof = (_a = object.proof) !== null && _a !== void 0 ? _a : new Uint8Array();
        message.proofHeight =
            object.proofHeight !== undefined && object.proofHeight !== null
                ? client_1.Height.fromPartial(object.proofHeight)
                : undefined;
        return message;
    },
};
function createBaseQueryConsensusStatesRequest() {
    return { clientId: "", pagination: undefined };
}
exports.QueryConsensusStatesRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.clientId !== "") {
            writer.uint32(10).string(message.clientId);
        }
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryConsensusStatesRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            clientId: isSet(object.clientId) ? String(object.clientId) : "",
            pagination: isSet(object.pagination) ? pagination_1.PageRequest.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryConsensusStatesRequest();
        message.clientId = (_a = object.clientId) !== null && _a !== void 0 ? _a : "";
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryConsensusStatesResponse() {
    return { consensusStates: [], pagination: undefined };
}
exports.QueryConsensusStatesResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.consensusStates) {
            client_1.ConsensusStateWithHeight.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryConsensusStatesResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.consensusStates.push(client_1.ConsensusStateWithHeight.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            consensusStates: Array.isArray(object === null || object === void 0 ? void 0 : object.consensusStates)
                ? object.consensusStates.map((e) => client_1.ConsensusStateWithHeight.fromJSON(e))
                : [],
            pagination: isSet(object.pagination) ? pagination_1.PageResponse.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.consensusStates) {
            obj.consensusStates = message.consensusStates.map((e) => e ? client_1.ConsensusStateWithHeight.toJSON(e) : undefined);
        }
        else {
            obj.consensusStates = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryConsensusStatesResponse();
        message.consensusStates =
            ((_a = object.consensusStates) === null || _a === void 0 ? void 0 : _a.map((e) => client_1.ConsensusStateWithHeight.fromPartial(e))) || [];
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryClientStatusRequest() {
    return { clientId: "" };
}
exports.QueryClientStatusRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.clientId !== "") {
            writer.uint32(10).string(message.clientId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryClientStatusRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.clientId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { clientId: isSet(object.clientId) ? String(object.clientId) : "" };
    },
    toJSON(message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryClientStatusRequest();
        message.clientId = (_a = object.clientId) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
function createBaseQueryClientStatusResponse() {
    return { status: "" };
}
exports.QueryClientStatusResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.status !== "") {
            writer.uint32(10).string(message.status);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryClientStatusResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.status = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { status: isSet(object.status) ? String(object.status) : "" };
    },
    toJSON(message) {
        const obj = {};
        message.status !== undefined && (obj.status = message.status);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryClientStatusResponse();
        message.status = (_a = object.status) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
function createBaseQueryClientParamsRequest() {
    return {};
}
exports.QueryClientParamsRequest = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryClientParamsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseQueryClientParamsRequest();
        return message;
    },
};
function createBaseQueryClientParamsResponse() {
    return { params: undefined };
}
exports.QueryClientParamsResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.params !== undefined) {
            client_1.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryClientParamsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.params = client_1.Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { params: isSet(object.params) ? client_1.Params.fromJSON(object.params) : undefined };
    },
    toJSON(message) {
        const obj = {};
        message.params !== undefined && (obj.params = message.params ? client_1.Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryClientParamsResponse();
        message.params =
            object.params !== undefined && object.params !== null ? client_1.Params.fromPartial(object.params) : undefined;
        return message;
    },
};
function createBaseQueryUpgradedClientStateRequest() {
    return {};
}
exports.QueryUpgradedClientStateRequest = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryUpgradedClientStateRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseQueryUpgradedClientStateRequest();
        return message;
    },
};
function createBaseQueryUpgradedClientStateResponse() {
    return { upgradedClientState: undefined };
}
exports.QueryUpgradedClientStateResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.upgradedClientState !== undefined) {
            any_1.Any.encode(message.upgradedClientState, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryUpgradedClientStateResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.upgradedClientState = any_1.Any.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            upgradedClientState: isSet(object.upgradedClientState)
                ? any_1.Any.fromJSON(object.upgradedClientState)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.upgradedClientState !== undefined &&
            (obj.upgradedClientState = message.upgradedClientState
                ? any_1.Any.toJSON(message.upgradedClientState)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryUpgradedClientStateResponse();
        message.upgradedClientState =
            object.upgradedClientState !== undefined && object.upgradedClientState !== null
                ? any_1.Any.fromPartial(object.upgradedClientState)
                : undefined;
        return message;
    },
};
function createBaseQueryUpgradedConsensusStateRequest() {
    return {};
}
exports.QueryUpgradedConsensusStateRequest = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryUpgradedConsensusStateRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseQueryUpgradedConsensusStateRequest();
        return message;
    },
};
function createBaseQueryUpgradedConsensusStateResponse() {
    return { upgradedConsensusState: undefined };
}
exports.QueryUpgradedConsensusStateResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.upgradedConsensusState !== undefined) {
            any_1.Any.encode(message.upgradedConsensusState, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryUpgradedConsensusStateResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.upgradedConsensusState = any_1.Any.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            upgradedConsensusState: isSet(object.upgradedConsensusState)
                ? any_1.Any.fromJSON(object.upgradedConsensusState)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.upgradedConsensusState !== undefined &&
            (obj.upgradedConsensusState = message.upgradedConsensusState
                ? any_1.Any.toJSON(message.upgradedConsensusState)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryUpgradedConsensusStateResponse();
        message.upgradedConsensusState =
            object.upgradedConsensusState !== undefined && object.upgradedConsensusState !== null
                ? any_1.Any.fromPartial(object.upgradedConsensusState)
                : undefined;
        return message;
    },
};
class QueryClientImpl {
    constructor(rpc) {
        this.rpc = rpc;
        this.ClientState = this.ClientState.bind(this);
        this.ClientStates = this.ClientStates.bind(this);
        this.ConsensusState = this.ConsensusState.bind(this);
        this.ConsensusStates = this.ConsensusStates.bind(this);
        this.ClientStatus = this.ClientStatus.bind(this);
        this.ClientParams = this.ClientParams.bind(this);
        this.UpgradedClientState = this.UpgradedClientState.bind(this);
        this.UpgradedConsensusState = this.UpgradedConsensusState.bind(this);
    }
    ClientState(request) {
        const data = exports.QueryClientStateRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.client.v1.Query", "ClientState", data);
        return promise.then((data) => exports.QueryClientStateResponse.decode(new minimal_1.default.Reader(data)));
    }
    ClientStates(request) {
        const data = exports.QueryClientStatesRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.client.v1.Query", "ClientStates", data);
        return promise.then((data) => exports.QueryClientStatesResponse.decode(new minimal_1.default.Reader(data)));
    }
    ConsensusState(request) {
        const data = exports.QueryConsensusStateRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.client.v1.Query", "ConsensusState", data);
        return promise.then((data) => exports.QueryConsensusStateResponse.decode(new minimal_1.default.Reader(data)));
    }
    ConsensusStates(request) {
        const data = exports.QueryConsensusStatesRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.client.v1.Query", "ConsensusStates", data);
        return promise.then((data) => exports.QueryConsensusStatesResponse.decode(new minimal_1.default.Reader(data)));
    }
    ClientStatus(request) {
        const data = exports.QueryClientStatusRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.client.v1.Query", "ClientStatus", data);
        return promise.then((data) => exports.QueryClientStatusResponse.decode(new minimal_1.default.Reader(data)));
    }
    ClientParams(request) {
        const data = exports.QueryClientParamsRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.client.v1.Query", "ClientParams", data);
        return promise.then((data) => exports.QueryClientParamsResponse.decode(new minimal_1.default.Reader(data)));
    }
    UpgradedClientState(request) {
        const data = exports.QueryUpgradedClientStateRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.client.v1.Query", "UpgradedClientState", data);
        return promise.then((data) => exports.QueryUpgradedClientStateResponse.decode(new minimal_1.default.Reader(data)));
    }
    UpgradedConsensusState(request) {
        const data = exports.QueryUpgradedConsensusStateRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.client.v1.Query", "UpgradedConsensusState", data);
        return promise.then((data) => exports.QueryUpgradedConsensusStateResponse.decode(new minimal_1.default.Reader(data)));
    }
}
exports.QueryClientImpl = QueryClientImpl;
var globalThis = (() => {
    if (typeof globalThis !== "undefined") {
        return globalThis;
    }
    if (typeof self !== "undefined") {
        return self;
    }
    if (typeof window !== "undefined") {
        return window;
    }
    if (typeof __webpack_require__.g !== "undefined") {
        return __webpack_require__.g;
    }
    throw "Unable to locate global object";
})();
function bytesFromBase64(b64) {
    if (globalThis.Buffer) {
        return Uint8Array.from(globalThis.Buffer.from(b64, "base64"));
    }
    else {
        const bin = globalThis.atob(b64);
        const arr = new Uint8Array(bin.length);
        for (let i = 0; i < bin.length; ++i) {
            arr[i] = bin.charCodeAt(i);
        }
        return arr;
    }
}
function base64FromBytes(arr) {
    if (globalThis.Buffer) {
        return globalThis.Buffer.from(arr).toString("base64");
    }
    else {
        const bin = [];
        arr.forEach((byte) => {
            bin.push(String.fromCharCode(byte));
        });
        return globalThis.btoa(bin.join(""));
    }
}
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=query.js.map

/***/ }),

/***/ 97657:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MsgClientImpl = exports.MsgSubmitMisbehaviourResponse = exports.MsgSubmitMisbehaviour = exports.MsgUpgradeClientResponse = exports.MsgUpgradeClient = exports.MsgUpdateClientResponse = exports.MsgUpdateClient = exports.MsgCreateClientResponse = exports.MsgCreateClient = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(__webpack_require__(47873));
const minimal_1 = __importDefault(__webpack_require__(62100));
const any_1 = __webpack_require__(90007);
exports.protobufPackage = "ibc.core.client.v1";
function createBaseMsgCreateClient() {
    return { clientState: undefined, consensusState: undefined, signer: "" };
}
exports.MsgCreateClient = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.clientState !== undefined) {
            any_1.Any.encode(message.clientState, writer.uint32(10).fork()).ldelim();
        }
        if (message.consensusState !== undefined) {
            any_1.Any.encode(message.consensusState, writer.uint32(18).fork()).ldelim();
        }
        if (message.signer !== "") {
            writer.uint32(26).string(message.signer);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgCreateClient();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.clientState = any_1.Any.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.consensusState = any_1.Any.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            clientState: isSet(object.clientState) ? any_1.Any.fromJSON(object.clientState) : undefined,
            consensusState: isSet(object.consensusState) ? any_1.Any.fromJSON(object.consensusState) : undefined,
            signer: isSet(object.signer) ? String(object.signer) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.clientState !== undefined &&
            (obj.clientState = message.clientState ? any_1.Any.toJSON(message.clientState) : undefined);
        message.consensusState !== undefined &&
            (obj.consensusState = message.consensusState ? any_1.Any.toJSON(message.consensusState) : undefined);
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseMsgCreateClient();
        message.clientState =
            object.clientState !== undefined && object.clientState !== null
                ? any_1.Any.fromPartial(object.clientState)
                : undefined;
        message.consensusState =
            object.consensusState !== undefined && object.consensusState !== null
                ? any_1.Any.fromPartial(object.consensusState)
                : undefined;
        message.signer = (_a = object.signer) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
function createBaseMsgCreateClientResponse() {
    return {};
}
exports.MsgCreateClientResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgCreateClientResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgCreateClientResponse();
        return message;
    },
};
function createBaseMsgUpdateClient() {
    return { clientId: "", header: undefined, signer: "" };
}
exports.MsgUpdateClient = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.clientId !== "") {
            writer.uint32(10).string(message.clientId);
        }
        if (message.header !== undefined) {
            any_1.Any.encode(message.header, writer.uint32(18).fork()).ldelim();
        }
        if (message.signer !== "") {
            writer.uint32(26).string(message.signer);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgUpdateClient();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.header = any_1.Any.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            clientId: isSet(object.clientId) ? String(object.clientId) : "",
            header: isSet(object.header) ? any_1.Any.fromJSON(object.header) : undefined,
            signer: isSet(object.signer) ? String(object.signer) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        message.header !== undefined && (obj.header = message.header ? any_1.Any.toJSON(message.header) : undefined);
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseMsgUpdateClient();
        message.clientId = (_a = object.clientId) !== null && _a !== void 0 ? _a : "";
        message.header =
            object.header !== undefined && object.header !== null ? any_1.Any.fromPartial(object.header) : undefined;
        message.signer = (_b = object.signer) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
function createBaseMsgUpdateClientResponse() {
    return {};
}
exports.MsgUpdateClientResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgUpdateClientResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgUpdateClientResponse();
        return message;
    },
};
function createBaseMsgUpgradeClient() {
    return {
        clientId: "",
        clientState: undefined,
        consensusState: undefined,
        proofUpgradeClient: new Uint8Array(),
        proofUpgradeConsensusState: new Uint8Array(),
        signer: "",
    };
}
exports.MsgUpgradeClient = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.clientId !== "") {
            writer.uint32(10).string(message.clientId);
        }
        if (message.clientState !== undefined) {
            any_1.Any.encode(message.clientState, writer.uint32(18).fork()).ldelim();
        }
        if (message.consensusState !== undefined) {
            any_1.Any.encode(message.consensusState, writer.uint32(26).fork()).ldelim();
        }
        if (message.proofUpgradeClient.length !== 0) {
            writer.uint32(34).bytes(message.proofUpgradeClient);
        }
        if (message.proofUpgradeConsensusState.length !== 0) {
            writer.uint32(42).bytes(message.proofUpgradeConsensusState);
        }
        if (message.signer !== "") {
            writer.uint32(50).string(message.signer);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgUpgradeClient();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.clientState = any_1.Any.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.consensusState = any_1.Any.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.proofUpgradeClient = reader.bytes();
                    break;
                case 5:
                    message.proofUpgradeConsensusState = reader.bytes();
                    break;
                case 6:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            clientId: isSet(object.clientId) ? String(object.clientId) : "",
            clientState: isSet(object.clientState) ? any_1.Any.fromJSON(object.clientState) : undefined,
            consensusState: isSet(object.consensusState) ? any_1.Any.fromJSON(object.consensusState) : undefined,
            proofUpgradeClient: isSet(object.proofUpgradeClient)
                ? bytesFromBase64(object.proofUpgradeClient)
                : new Uint8Array(),
            proofUpgradeConsensusState: isSet(object.proofUpgradeConsensusState)
                ? bytesFromBase64(object.proofUpgradeConsensusState)
                : new Uint8Array(),
            signer: isSet(object.signer) ? String(object.signer) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        message.clientState !== undefined &&
            (obj.clientState = message.clientState ? any_1.Any.toJSON(message.clientState) : undefined);
        message.consensusState !== undefined &&
            (obj.consensusState = message.consensusState ? any_1.Any.toJSON(message.consensusState) : undefined);
        message.proofUpgradeClient !== undefined &&
            (obj.proofUpgradeClient = base64FromBytes(message.proofUpgradeClient !== undefined ? message.proofUpgradeClient : new Uint8Array()));
        message.proofUpgradeConsensusState !== undefined &&
            (obj.proofUpgradeConsensusState = base64FromBytes(message.proofUpgradeConsensusState !== undefined
                ? message.proofUpgradeConsensusState
                : new Uint8Array()));
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d;
        const message = createBaseMsgUpgradeClient();
        message.clientId = (_a = object.clientId) !== null && _a !== void 0 ? _a : "";
        message.clientState =
            object.clientState !== undefined && object.clientState !== null
                ? any_1.Any.fromPartial(object.clientState)
                : undefined;
        message.consensusState =
            object.consensusState !== undefined && object.consensusState !== null
                ? any_1.Any.fromPartial(object.consensusState)
                : undefined;
        message.proofUpgradeClient = (_b = object.proofUpgradeClient) !== null && _b !== void 0 ? _b : new Uint8Array();
        message.proofUpgradeConsensusState = (_c = object.proofUpgradeConsensusState) !== null && _c !== void 0 ? _c : new Uint8Array();
        message.signer = (_d = object.signer) !== null && _d !== void 0 ? _d : "";
        return message;
    },
};
function createBaseMsgUpgradeClientResponse() {
    return {};
}
exports.MsgUpgradeClientResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgUpgradeClientResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgUpgradeClientResponse();
        return message;
    },
};
function createBaseMsgSubmitMisbehaviour() {
    return { clientId: "", misbehaviour: undefined, signer: "" };
}
exports.MsgSubmitMisbehaviour = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.clientId !== "") {
            writer.uint32(10).string(message.clientId);
        }
        if (message.misbehaviour !== undefined) {
            any_1.Any.encode(message.misbehaviour, writer.uint32(18).fork()).ldelim();
        }
        if (message.signer !== "") {
            writer.uint32(26).string(message.signer);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgSubmitMisbehaviour();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.misbehaviour = any_1.Any.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            clientId: isSet(object.clientId) ? String(object.clientId) : "",
            misbehaviour: isSet(object.misbehaviour) ? any_1.Any.fromJSON(object.misbehaviour) : undefined,
            signer: isSet(object.signer) ? String(object.signer) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        message.misbehaviour !== undefined &&
            (obj.misbehaviour = message.misbehaviour ? any_1.Any.toJSON(message.misbehaviour) : undefined);
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseMsgSubmitMisbehaviour();
        message.clientId = (_a = object.clientId) !== null && _a !== void 0 ? _a : "";
        message.misbehaviour =
            object.misbehaviour !== undefined && object.misbehaviour !== null
                ? any_1.Any.fromPartial(object.misbehaviour)
                : undefined;
        message.signer = (_b = object.signer) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
function createBaseMsgSubmitMisbehaviourResponse() {
    return {};
}
exports.MsgSubmitMisbehaviourResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgSubmitMisbehaviourResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgSubmitMisbehaviourResponse();
        return message;
    },
};
class MsgClientImpl {
    constructor(rpc) {
        this.rpc = rpc;
        this.CreateClient = this.CreateClient.bind(this);
        this.UpdateClient = this.UpdateClient.bind(this);
        this.UpgradeClient = this.UpgradeClient.bind(this);
        this.SubmitMisbehaviour = this.SubmitMisbehaviour.bind(this);
    }
    CreateClient(request) {
        const data = exports.MsgCreateClient.encode(request).finish();
        const promise = this.rpc.request("ibc.core.client.v1.Msg", "CreateClient", data);
        return promise.then((data) => exports.MsgCreateClientResponse.decode(new minimal_1.default.Reader(data)));
    }
    UpdateClient(request) {
        const data = exports.MsgUpdateClient.encode(request).finish();
        const promise = this.rpc.request("ibc.core.client.v1.Msg", "UpdateClient", data);
        return promise.then((data) => exports.MsgUpdateClientResponse.decode(new minimal_1.default.Reader(data)));
    }
    UpgradeClient(request) {
        const data = exports.MsgUpgradeClient.encode(request).finish();
        const promise = this.rpc.request("ibc.core.client.v1.Msg", "UpgradeClient", data);
        return promise.then((data) => exports.MsgUpgradeClientResponse.decode(new minimal_1.default.Reader(data)));
    }
    SubmitMisbehaviour(request) {
        const data = exports.MsgSubmitMisbehaviour.encode(request).finish();
        const promise = this.rpc.request("ibc.core.client.v1.Msg", "SubmitMisbehaviour", data);
        return promise.then((data) => exports.MsgSubmitMisbehaviourResponse.decode(new minimal_1.default.Reader(data)));
    }
}
exports.MsgClientImpl = MsgClientImpl;
var globalThis = (() => {
    if (typeof globalThis !== "undefined") {
        return globalThis;
    }
    if (typeof self !== "undefined") {
        return self;
    }
    if (typeof window !== "undefined") {
        return window;
    }
    if (typeof __webpack_require__.g !== "undefined") {
        return __webpack_require__.g;
    }
    throw "Unable to locate global object";
})();
function bytesFromBase64(b64) {
    if (globalThis.Buffer) {
        return Uint8Array.from(globalThis.Buffer.from(b64, "base64"));
    }
    else {
        const bin = globalThis.atob(b64);
        const arr = new Uint8Array(bin.length);
        for (let i = 0; i < bin.length; ++i) {
            arr[i] = bin.charCodeAt(i);
        }
        return arr;
    }
}
function base64FromBytes(arr) {
    if (globalThis.Buffer) {
        return globalThis.Buffer.from(arr).toString("base64");
    }
    else {
        const bin = [];
        arr.forEach((byte) => {
            bin.push(String.fromCharCode(byte));
        });
        return globalThis.btoa(bin.join(""));
    }
}
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=tx.js.map

/***/ }),

/***/ 81102:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MerkleProof = exports.MerklePath = exports.MerklePrefix = exports.MerkleRoot = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(__webpack_require__(47873));
const minimal_1 = __importDefault(__webpack_require__(62100));
const proofs_1 = __webpack_require__(69892);
exports.protobufPackage = "ibc.core.commitment.v1";
function createBaseMerkleRoot() {
    return { hash: new Uint8Array() };
}
exports.MerkleRoot = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.hash.length !== 0) {
            writer.uint32(10).bytes(message.hash);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMerkleRoot();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.hash = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { hash: isSet(object.hash) ? bytesFromBase64(object.hash) : new Uint8Array() };
    },
    toJSON(message) {
        const obj = {};
        message.hash !== undefined &&
            (obj.hash = base64FromBytes(message.hash !== undefined ? message.hash : new Uint8Array()));
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseMerkleRoot();
        message.hash = (_a = object.hash) !== null && _a !== void 0 ? _a : new Uint8Array();
        return message;
    },
};
function createBaseMerklePrefix() {
    return { keyPrefix: new Uint8Array() };
}
exports.MerklePrefix = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.keyPrefix.length !== 0) {
            writer.uint32(10).bytes(message.keyPrefix);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMerklePrefix();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.keyPrefix = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { keyPrefix: isSet(object.keyPrefix) ? bytesFromBase64(object.keyPrefix) : new Uint8Array() };
    },
    toJSON(message) {
        const obj = {};
        message.keyPrefix !== undefined &&
            (obj.keyPrefix = base64FromBytes(message.keyPrefix !== undefined ? message.keyPrefix : new Uint8Array()));
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseMerklePrefix();
        message.keyPrefix = (_a = object.keyPrefix) !== null && _a !== void 0 ? _a : new Uint8Array();
        return message;
    },
};
function createBaseMerklePath() {
    return { keyPath: [] };
}
exports.MerklePath = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.keyPath) {
            writer.uint32(10).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMerklePath();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.keyPath.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { keyPath: Array.isArray(object === null || object === void 0 ? void 0 : object.keyPath) ? object.keyPath.map((e) => String(e)) : [] };
    },
    toJSON(message) {
        const obj = {};
        if (message.keyPath) {
            obj.keyPath = message.keyPath.map((e) => e);
        }
        else {
            obj.keyPath = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseMerklePath();
        message.keyPath = ((_a = object.keyPath) === null || _a === void 0 ? void 0 : _a.map((e) => e)) || [];
        return message;
    },
};
function createBaseMerkleProof() {
    return { proofs: [] };
}
exports.MerkleProof = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.proofs) {
            proofs_1.CommitmentProof.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMerkleProof();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.proofs.push(proofs_1.CommitmentProof.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            proofs: Array.isArray(object === null || object === void 0 ? void 0 : object.proofs) ? object.proofs.map((e) => proofs_1.CommitmentProof.fromJSON(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.proofs) {
            obj.proofs = message.proofs.map((e) => (e ? proofs_1.CommitmentProof.toJSON(e) : undefined));
        }
        else {
            obj.proofs = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseMerkleProof();
        message.proofs = ((_a = object.proofs) === null || _a === void 0 ? void 0 : _a.map((e) => proofs_1.CommitmentProof.fromPartial(e))) || [];
        return message;
    },
};
var globalThis = (() => {
    if (typeof globalThis !== "undefined") {
        return globalThis;
    }
    if (typeof self !== "undefined") {
        return self;
    }
    if (typeof window !== "undefined") {
        return window;
    }
    if (typeof __webpack_require__.g !== "undefined") {
        return __webpack_require__.g;
    }
    throw "Unable to locate global object";
})();
function bytesFromBase64(b64) {
    if (globalThis.Buffer) {
        return Uint8Array.from(globalThis.Buffer.from(b64, "base64"));
    }
    else {
        const bin = globalThis.atob(b64);
        const arr = new Uint8Array(bin.length);
        for (let i = 0; i < bin.length; ++i) {
            arr[i] = bin.charCodeAt(i);
        }
        return arr;
    }
}
function base64FromBytes(arr) {
    if (globalThis.Buffer) {
        return globalThis.Buffer.from(arr).toString("base64");
    }
    else {
        const bin = [];
        arr.forEach((byte) => {
            bin.push(String.fromCharCode(byte));
        });
        return globalThis.btoa(bin.join(""));
    }
}
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=commitment.js.map

/***/ }),

/***/ 1609:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Params = exports.Version = exports.ConnectionPaths = exports.ClientPaths = exports.Counterparty = exports.IdentifiedConnection = exports.ConnectionEnd = exports.stateToJSON = exports.stateFromJSON = exports.State = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(__webpack_require__(47873));
const minimal_1 = __importDefault(__webpack_require__(62100));
const commitment_1 = __webpack_require__(81102);
exports.protobufPackage = "ibc.core.connection.v1";
/**
 * State defines if a connection is in one of the following states:
 * INIT, TRYOPEN, OPEN or UNINITIALIZED.
 */
var State;
(function (State) {
    /** STATE_UNINITIALIZED_UNSPECIFIED - Default State */
    State[State["STATE_UNINITIALIZED_UNSPECIFIED"] = 0] = "STATE_UNINITIALIZED_UNSPECIFIED";
    /** STATE_INIT - A connection end has just started the opening handshake. */
    State[State["STATE_INIT"] = 1] = "STATE_INIT";
    /**
     * STATE_TRYOPEN - A connection end has acknowledged the handshake step on the counterparty
     * chain.
     */
    State[State["STATE_TRYOPEN"] = 2] = "STATE_TRYOPEN";
    /** STATE_OPEN - A connection end has completed the handshake. */
    State[State["STATE_OPEN"] = 3] = "STATE_OPEN";
    State[State["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(State = exports.State || (exports.State = {}));
function stateFromJSON(object) {
    switch (object) {
        case 0:
        case "STATE_UNINITIALIZED_UNSPECIFIED":
            return State.STATE_UNINITIALIZED_UNSPECIFIED;
        case 1:
        case "STATE_INIT":
            return State.STATE_INIT;
        case 2:
        case "STATE_TRYOPEN":
            return State.STATE_TRYOPEN;
        case 3:
        case "STATE_OPEN":
            return State.STATE_OPEN;
        case -1:
        case "UNRECOGNIZED":
        default:
            return State.UNRECOGNIZED;
    }
}
exports.stateFromJSON = stateFromJSON;
function stateToJSON(object) {
    switch (object) {
        case State.STATE_UNINITIALIZED_UNSPECIFIED:
            return "STATE_UNINITIALIZED_UNSPECIFIED";
        case State.STATE_INIT:
            return "STATE_INIT";
        case State.STATE_TRYOPEN:
            return "STATE_TRYOPEN";
        case State.STATE_OPEN:
            return "STATE_OPEN";
        case State.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.stateToJSON = stateToJSON;
function createBaseConnectionEnd() {
    return { clientId: "", versions: [], state: 0, counterparty: undefined, delayPeriod: long_1.default.UZERO };
}
exports.ConnectionEnd = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.clientId !== "") {
            writer.uint32(10).string(message.clientId);
        }
        for (const v of message.versions) {
            exports.Version.encode(v, writer.uint32(18).fork()).ldelim();
        }
        if (message.state !== 0) {
            writer.uint32(24).int32(message.state);
        }
        if (message.counterparty !== undefined) {
            exports.Counterparty.encode(message.counterparty, writer.uint32(34).fork()).ldelim();
        }
        if (!message.delayPeriod.isZero()) {
            writer.uint32(40).uint64(message.delayPeriod);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseConnectionEnd();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.versions.push(exports.Version.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.state = reader.int32();
                    break;
                case 4:
                    message.counterparty = exports.Counterparty.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.delayPeriod = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            clientId: isSet(object.clientId) ? String(object.clientId) : "",
            versions: Array.isArray(object === null || object === void 0 ? void 0 : object.versions) ? object.versions.map((e) => exports.Version.fromJSON(e)) : [],
            state: isSet(object.state) ? stateFromJSON(object.state) : 0,
            counterparty: isSet(object.counterparty) ? exports.Counterparty.fromJSON(object.counterparty) : undefined,
            delayPeriod: isSet(object.delayPeriod) ? long_1.default.fromValue(object.delayPeriod) : long_1.default.UZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        if (message.versions) {
            obj.versions = message.versions.map((e) => (e ? exports.Version.toJSON(e) : undefined));
        }
        else {
            obj.versions = [];
        }
        message.state !== undefined && (obj.state = stateToJSON(message.state));
        message.counterparty !== undefined &&
            (obj.counterparty = message.counterparty ? exports.Counterparty.toJSON(message.counterparty) : undefined);
        message.delayPeriod !== undefined && (obj.delayPeriod = (message.delayPeriod || long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseConnectionEnd();
        message.clientId = (_a = object.clientId) !== null && _a !== void 0 ? _a : "";
        message.versions = ((_b = object.versions) === null || _b === void 0 ? void 0 : _b.map((e) => exports.Version.fromPartial(e))) || [];
        message.state = (_c = object.state) !== null && _c !== void 0 ? _c : 0;
        message.counterparty =
            object.counterparty !== undefined && object.counterparty !== null
                ? exports.Counterparty.fromPartial(object.counterparty)
                : undefined;
        message.delayPeriod =
            object.delayPeriod !== undefined && object.delayPeriod !== null
                ? long_1.default.fromValue(object.delayPeriod)
                : long_1.default.UZERO;
        return message;
    },
};
function createBaseIdentifiedConnection() {
    return { id: "", clientId: "", versions: [], state: 0, counterparty: undefined, delayPeriod: long_1.default.UZERO };
}
exports.IdentifiedConnection = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.id !== "") {
            writer.uint32(10).string(message.id);
        }
        if (message.clientId !== "") {
            writer.uint32(18).string(message.clientId);
        }
        for (const v of message.versions) {
            exports.Version.encode(v, writer.uint32(26).fork()).ldelim();
        }
        if (message.state !== 0) {
            writer.uint32(32).int32(message.state);
        }
        if (message.counterparty !== undefined) {
            exports.Counterparty.encode(message.counterparty, writer.uint32(42).fork()).ldelim();
        }
        if (!message.delayPeriod.isZero()) {
            writer.uint32(48).uint64(message.delayPeriod);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseIdentifiedConnection();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.id = reader.string();
                    break;
                case 2:
                    message.clientId = reader.string();
                    break;
                case 3:
                    message.versions.push(exports.Version.decode(reader, reader.uint32()));
                    break;
                case 4:
                    message.state = reader.int32();
                    break;
                case 5:
                    message.counterparty = exports.Counterparty.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.delayPeriod = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            id: isSet(object.id) ? String(object.id) : "",
            clientId: isSet(object.clientId) ? String(object.clientId) : "",
            versions: Array.isArray(object === null || object === void 0 ? void 0 : object.versions) ? object.versions.map((e) => exports.Version.fromJSON(e)) : [],
            state: isSet(object.state) ? stateFromJSON(object.state) : 0,
            counterparty: isSet(object.counterparty) ? exports.Counterparty.fromJSON(object.counterparty) : undefined,
            delayPeriod: isSet(object.delayPeriod) ? long_1.default.fromValue(object.delayPeriod) : long_1.default.UZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        message.id !== undefined && (obj.id = message.id);
        message.clientId !== undefined && (obj.clientId = message.clientId);
        if (message.versions) {
            obj.versions = message.versions.map((e) => (e ? exports.Version.toJSON(e) : undefined));
        }
        else {
            obj.versions = [];
        }
        message.state !== undefined && (obj.state = stateToJSON(message.state));
        message.counterparty !== undefined &&
            (obj.counterparty = message.counterparty ? exports.Counterparty.toJSON(message.counterparty) : undefined);
        message.delayPeriod !== undefined && (obj.delayPeriod = (message.delayPeriod || long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d;
        const message = createBaseIdentifiedConnection();
        message.id = (_a = object.id) !== null && _a !== void 0 ? _a : "";
        message.clientId = (_b = object.clientId) !== null && _b !== void 0 ? _b : "";
        message.versions = ((_c = object.versions) === null || _c === void 0 ? void 0 : _c.map((e) => exports.Version.fromPartial(e))) || [];
        message.state = (_d = object.state) !== null && _d !== void 0 ? _d : 0;
        message.counterparty =
            object.counterparty !== undefined && object.counterparty !== null
                ? exports.Counterparty.fromPartial(object.counterparty)
                : undefined;
        message.delayPeriod =
            object.delayPeriod !== undefined && object.delayPeriod !== null
                ? long_1.default.fromValue(object.delayPeriod)
                : long_1.default.UZERO;
        return message;
    },
};
function createBaseCounterparty() {
    return { clientId: "", connectionId: "", prefix: undefined };
}
exports.Counterparty = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.clientId !== "") {
            writer.uint32(10).string(message.clientId);
        }
        if (message.connectionId !== "") {
            writer.uint32(18).string(message.connectionId);
        }
        if (message.prefix !== undefined) {
            commitment_1.MerklePrefix.encode(message.prefix, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCounterparty();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.connectionId = reader.string();
                    break;
                case 3:
                    message.prefix = commitment_1.MerklePrefix.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            clientId: isSet(object.clientId) ? String(object.clientId) : "",
            connectionId: isSet(object.connectionId) ? String(object.connectionId) : "",
            prefix: isSet(object.prefix) ? commitment_1.MerklePrefix.fromJSON(object.prefix) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        message.connectionId !== undefined && (obj.connectionId = message.connectionId);
        message.prefix !== undefined &&
            (obj.prefix = message.prefix ? commitment_1.MerklePrefix.toJSON(message.prefix) : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseCounterparty();
        message.clientId = (_a = object.clientId) !== null && _a !== void 0 ? _a : "";
        message.connectionId = (_b = object.connectionId) !== null && _b !== void 0 ? _b : "";
        message.prefix =
            object.prefix !== undefined && object.prefix !== null
                ? commitment_1.MerklePrefix.fromPartial(object.prefix)
                : undefined;
        return message;
    },
};
function createBaseClientPaths() {
    return { paths: [] };
}
exports.ClientPaths = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.paths) {
            writer.uint32(10).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseClientPaths();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.paths.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { paths: Array.isArray(object === null || object === void 0 ? void 0 : object.paths) ? object.paths.map((e) => String(e)) : [] };
    },
    toJSON(message) {
        const obj = {};
        if (message.paths) {
            obj.paths = message.paths.map((e) => e);
        }
        else {
            obj.paths = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseClientPaths();
        message.paths = ((_a = object.paths) === null || _a === void 0 ? void 0 : _a.map((e) => e)) || [];
        return message;
    },
};
function createBaseConnectionPaths() {
    return { clientId: "", paths: [] };
}
exports.ConnectionPaths = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.clientId !== "") {
            writer.uint32(10).string(message.clientId);
        }
        for (const v of message.paths) {
            writer.uint32(18).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseConnectionPaths();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.paths.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            clientId: isSet(object.clientId) ? String(object.clientId) : "",
            paths: Array.isArray(object === null || object === void 0 ? void 0 : object.paths) ? object.paths.map((e) => String(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        if (message.paths) {
            obj.paths = message.paths.map((e) => e);
        }
        else {
            obj.paths = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseConnectionPaths();
        message.clientId = (_a = object.clientId) !== null && _a !== void 0 ? _a : "";
        message.paths = ((_b = object.paths) === null || _b === void 0 ? void 0 : _b.map((e) => e)) || [];
        return message;
    },
};
function createBaseVersion() {
    return { identifier: "", features: [] };
}
exports.Version = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.identifier !== "") {
            writer.uint32(10).string(message.identifier);
        }
        for (const v of message.features) {
            writer.uint32(18).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVersion();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.identifier = reader.string();
                    break;
                case 2:
                    message.features.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            identifier: isSet(object.identifier) ? String(object.identifier) : "",
            features: Array.isArray(object === null || object === void 0 ? void 0 : object.features) ? object.features.map((e) => String(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        message.identifier !== undefined && (obj.identifier = message.identifier);
        if (message.features) {
            obj.features = message.features.map((e) => e);
        }
        else {
            obj.features = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseVersion();
        message.identifier = (_a = object.identifier) !== null && _a !== void 0 ? _a : "";
        message.features = ((_b = object.features) === null || _b === void 0 ? void 0 : _b.map((e) => e)) || [];
        return message;
    },
};
function createBaseParams() {
    return { maxExpectedTimePerBlock: long_1.default.UZERO };
}
exports.Params = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (!message.maxExpectedTimePerBlock.isZero()) {
            writer.uint32(8).uint64(message.maxExpectedTimePerBlock);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseParams();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.maxExpectedTimePerBlock = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            maxExpectedTimePerBlock: isSet(object.maxExpectedTimePerBlock)
                ? long_1.default.fromValue(object.maxExpectedTimePerBlock)
                : long_1.default.UZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        message.maxExpectedTimePerBlock !== undefined &&
            (obj.maxExpectedTimePerBlock = (message.maxExpectedTimePerBlock || long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseParams();
        message.maxExpectedTimePerBlock =
            object.maxExpectedTimePerBlock !== undefined && object.maxExpectedTimePerBlock !== null
                ? long_1.default.fromValue(object.maxExpectedTimePerBlock)
                : long_1.default.UZERO;
        return message;
    },
};
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=connection.js.map

/***/ }),

/***/ 34463:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.QueryClientImpl = exports.QueryConnectionConsensusStateResponse = exports.QueryConnectionConsensusStateRequest = exports.QueryConnectionClientStateResponse = exports.QueryConnectionClientStateRequest = exports.QueryClientConnectionsResponse = exports.QueryClientConnectionsRequest = exports.QueryConnectionsResponse = exports.QueryConnectionsRequest = exports.QueryConnectionResponse = exports.QueryConnectionRequest = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(__webpack_require__(47873));
const minimal_1 = __importDefault(__webpack_require__(62100));
const pagination_1 = __webpack_require__(62635);
const any_1 = __webpack_require__(90007);
const client_1 = __webpack_require__(74373);
const connection_1 = __webpack_require__(1609);
exports.protobufPackage = "ibc.core.connection.v1";
function createBaseQueryConnectionRequest() {
    return { connectionId: "" };
}
exports.QueryConnectionRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.connectionId !== "") {
            writer.uint32(10).string(message.connectionId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryConnectionRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.connectionId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { connectionId: isSet(object.connectionId) ? String(object.connectionId) : "" };
    },
    toJSON(message) {
        const obj = {};
        message.connectionId !== undefined && (obj.connectionId = message.connectionId);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryConnectionRequest();
        message.connectionId = (_a = object.connectionId) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
function createBaseQueryConnectionResponse() {
    return { connection: undefined, proof: new Uint8Array(), proofHeight: undefined };
}
exports.QueryConnectionResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.connection !== undefined) {
            connection_1.ConnectionEnd.encode(message.connection, writer.uint32(10).fork()).ldelim();
        }
        if (message.proof.length !== 0) {
            writer.uint32(18).bytes(message.proof);
        }
        if (message.proofHeight !== undefined) {
            client_1.Height.encode(message.proofHeight, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryConnectionResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.connection = connection_1.ConnectionEnd.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.proof = reader.bytes();
                    break;
                case 3:
                    message.proofHeight = client_1.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            connection: isSet(object.connection) ? connection_1.ConnectionEnd.fromJSON(object.connection) : undefined,
            proof: isSet(object.proof) ? bytesFromBase64(object.proof) : new Uint8Array(),
            proofHeight: isSet(object.proofHeight) ? client_1.Height.fromJSON(object.proofHeight) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.connection !== undefined &&
            (obj.connection = message.connection ? connection_1.ConnectionEnd.toJSON(message.connection) : undefined);
        message.proof !== undefined &&
            (obj.proof = base64FromBytes(message.proof !== undefined ? message.proof : new Uint8Array()));
        message.proofHeight !== undefined &&
            (obj.proofHeight = message.proofHeight ? client_1.Height.toJSON(message.proofHeight) : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryConnectionResponse();
        message.connection =
            object.connection !== undefined && object.connection !== null
                ? connection_1.ConnectionEnd.fromPartial(object.connection)
                : undefined;
        message.proof = (_a = object.proof) !== null && _a !== void 0 ? _a : new Uint8Array();
        message.proofHeight =
            object.proofHeight !== undefined && object.proofHeight !== null
                ? client_1.Height.fromPartial(object.proofHeight)
                : undefined;
        return message;
    },
};
function createBaseQueryConnectionsRequest() {
    return { pagination: undefined };
}
exports.QueryConnectionsRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryConnectionsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { pagination: isSet(object.pagination) ? pagination_1.PageRequest.fromJSON(object.pagination) : undefined };
    },
    toJSON(message) {
        const obj = {};
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryConnectionsRequest();
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
function createBaseQueryConnectionsResponse() {
    return { connections: [], pagination: undefined, height: undefined };
}
exports.QueryConnectionsResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.connections) {
            connection_1.IdentifiedConnection.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        if (message.height !== undefined) {
            client_1.Height.encode(message.height, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryConnectionsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.connections.push(connection_1.IdentifiedConnection.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.height = client_1.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            connections: Array.isArray(object === null || object === void 0 ? void 0 : object.connections)
                ? object.connections.map((e) => connection_1.IdentifiedConnection.fromJSON(e))
                : [],
            pagination: isSet(object.pagination) ? pagination_1.PageResponse.fromJSON(object.pagination) : undefined,
            height: isSet(object.height) ? client_1.Height.fromJSON(object.height) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.connections) {
            obj.connections = message.connections.map((e) => (e ? connection_1.IdentifiedConnection.toJSON(e) : undefined));
        }
        else {
            obj.connections = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageResponse.toJSON(message.pagination) : undefined);
        message.height !== undefined && (obj.height = message.height ? client_1.Height.toJSON(message.height) : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryConnectionsResponse();
        message.connections = ((_a = object.connections) === null || _a === void 0 ? void 0 : _a.map((e) => connection_1.IdentifiedConnection.fromPartial(e))) || [];
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        message.height =
            object.height !== undefined && object.height !== null ? client_1.Height.fromPartial(object.height) : undefined;
        return message;
    },
};
function createBaseQueryClientConnectionsRequest() {
    return { clientId: "" };
}
exports.QueryClientConnectionsRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.clientId !== "") {
            writer.uint32(10).string(message.clientId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryClientConnectionsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.clientId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { clientId: isSet(object.clientId) ? String(object.clientId) : "" };
    },
    toJSON(message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryClientConnectionsRequest();
        message.clientId = (_a = object.clientId) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
function createBaseQueryClientConnectionsResponse() {
    return { connectionPaths: [], proof: new Uint8Array(), proofHeight: undefined };
}
exports.QueryClientConnectionsResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.connectionPaths) {
            writer.uint32(10).string(v);
        }
        if (message.proof.length !== 0) {
            writer.uint32(18).bytes(message.proof);
        }
        if (message.proofHeight !== undefined) {
            client_1.Height.encode(message.proofHeight, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryClientConnectionsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.connectionPaths.push(reader.string());
                    break;
                case 2:
                    message.proof = reader.bytes();
                    break;
                case 3:
                    message.proofHeight = client_1.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            connectionPaths: Array.isArray(object === null || object === void 0 ? void 0 : object.connectionPaths)
                ? object.connectionPaths.map((e) => String(e))
                : [],
            proof: isSet(object.proof) ? bytesFromBase64(object.proof) : new Uint8Array(),
            proofHeight: isSet(object.proofHeight) ? client_1.Height.fromJSON(object.proofHeight) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.connectionPaths) {
            obj.connectionPaths = message.connectionPaths.map((e) => e);
        }
        else {
            obj.connectionPaths = [];
        }
        message.proof !== undefined &&
            (obj.proof = base64FromBytes(message.proof !== undefined ? message.proof : new Uint8Array()));
        message.proofHeight !== undefined &&
            (obj.proofHeight = message.proofHeight ? client_1.Height.toJSON(message.proofHeight) : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseQueryClientConnectionsResponse();
        message.connectionPaths = ((_a = object.connectionPaths) === null || _a === void 0 ? void 0 : _a.map((e) => e)) || [];
        message.proof = (_b = object.proof) !== null && _b !== void 0 ? _b : new Uint8Array();
        message.proofHeight =
            object.proofHeight !== undefined && object.proofHeight !== null
                ? client_1.Height.fromPartial(object.proofHeight)
                : undefined;
        return message;
    },
};
function createBaseQueryConnectionClientStateRequest() {
    return { connectionId: "" };
}
exports.QueryConnectionClientStateRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.connectionId !== "") {
            writer.uint32(10).string(message.connectionId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryConnectionClientStateRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.connectionId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { connectionId: isSet(object.connectionId) ? String(object.connectionId) : "" };
    },
    toJSON(message) {
        const obj = {};
        message.connectionId !== undefined && (obj.connectionId = message.connectionId);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryConnectionClientStateRequest();
        message.connectionId = (_a = object.connectionId) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
function createBaseQueryConnectionClientStateResponse() {
    return { identifiedClientState: undefined, proof: new Uint8Array(), proofHeight: undefined };
}
exports.QueryConnectionClientStateResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.identifiedClientState !== undefined) {
            client_1.IdentifiedClientState.encode(message.identifiedClientState, writer.uint32(10).fork()).ldelim();
        }
        if (message.proof.length !== 0) {
            writer.uint32(18).bytes(message.proof);
        }
        if (message.proofHeight !== undefined) {
            client_1.Height.encode(message.proofHeight, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryConnectionClientStateResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.identifiedClientState = client_1.IdentifiedClientState.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.proof = reader.bytes();
                    break;
                case 3:
                    message.proofHeight = client_1.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            identifiedClientState: isSet(object.identifiedClientState)
                ? client_1.IdentifiedClientState.fromJSON(object.identifiedClientState)
                : undefined,
            proof: isSet(object.proof) ? bytesFromBase64(object.proof) : new Uint8Array(),
            proofHeight: isSet(object.proofHeight) ? client_1.Height.fromJSON(object.proofHeight) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.identifiedClientState !== undefined &&
            (obj.identifiedClientState = message.identifiedClientState
                ? client_1.IdentifiedClientState.toJSON(message.identifiedClientState)
                : undefined);
        message.proof !== undefined &&
            (obj.proof = base64FromBytes(message.proof !== undefined ? message.proof : new Uint8Array()));
        message.proofHeight !== undefined &&
            (obj.proofHeight = message.proofHeight ? client_1.Height.toJSON(message.proofHeight) : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryConnectionClientStateResponse();
        message.identifiedClientState =
            object.identifiedClientState !== undefined && object.identifiedClientState !== null
                ? client_1.IdentifiedClientState.fromPartial(object.identifiedClientState)
                : undefined;
        message.proof = (_a = object.proof) !== null && _a !== void 0 ? _a : new Uint8Array();
        message.proofHeight =
            object.proofHeight !== undefined && object.proofHeight !== null
                ? client_1.Height.fromPartial(object.proofHeight)
                : undefined;
        return message;
    },
};
function createBaseQueryConnectionConsensusStateRequest() {
    return { connectionId: "", revisionNumber: long_1.default.UZERO, revisionHeight: long_1.default.UZERO };
}
exports.QueryConnectionConsensusStateRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.connectionId !== "") {
            writer.uint32(10).string(message.connectionId);
        }
        if (!message.revisionNumber.isZero()) {
            writer.uint32(16).uint64(message.revisionNumber);
        }
        if (!message.revisionHeight.isZero()) {
            writer.uint32(24).uint64(message.revisionHeight);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryConnectionConsensusStateRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.connectionId = reader.string();
                    break;
                case 2:
                    message.revisionNumber = reader.uint64();
                    break;
                case 3:
                    message.revisionHeight = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            connectionId: isSet(object.connectionId) ? String(object.connectionId) : "",
            revisionNumber: isSet(object.revisionNumber) ? long_1.default.fromValue(object.revisionNumber) : long_1.default.UZERO,
            revisionHeight: isSet(object.revisionHeight) ? long_1.default.fromValue(object.revisionHeight) : long_1.default.UZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        message.connectionId !== undefined && (obj.connectionId = message.connectionId);
        message.revisionNumber !== undefined &&
            (obj.revisionNumber = (message.revisionNumber || long_1.default.UZERO).toString());
        message.revisionHeight !== undefined &&
            (obj.revisionHeight = (message.revisionHeight || long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseQueryConnectionConsensusStateRequest();
        message.connectionId = (_a = object.connectionId) !== null && _a !== void 0 ? _a : "";
        message.revisionNumber =
            object.revisionNumber !== undefined && object.revisionNumber !== null
                ? long_1.default.fromValue(object.revisionNumber)
                : long_1.default.UZERO;
        message.revisionHeight =
            object.revisionHeight !== undefined && object.revisionHeight !== null
                ? long_1.default.fromValue(object.revisionHeight)
                : long_1.default.UZERO;
        return message;
    },
};
function createBaseQueryConnectionConsensusStateResponse() {
    return { consensusState: undefined, clientId: "", proof: new Uint8Array(), proofHeight: undefined };
}
exports.QueryConnectionConsensusStateResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.consensusState !== undefined) {
            any_1.Any.encode(message.consensusState, writer.uint32(10).fork()).ldelim();
        }
        if (message.clientId !== "") {
            writer.uint32(18).string(message.clientId);
        }
        if (message.proof.length !== 0) {
            writer.uint32(26).bytes(message.proof);
        }
        if (message.proofHeight !== undefined) {
            client_1.Height.encode(message.proofHeight, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryConnectionConsensusStateResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.consensusState = any_1.Any.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.clientId = reader.string();
                    break;
                case 3:
                    message.proof = reader.bytes();
                    break;
                case 4:
                    message.proofHeight = client_1.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            consensusState: isSet(object.consensusState) ? any_1.Any.fromJSON(object.consensusState) : undefined,
            clientId: isSet(object.clientId) ? String(object.clientId) : "",
            proof: isSet(object.proof) ? bytesFromBase64(object.proof) : new Uint8Array(),
            proofHeight: isSet(object.proofHeight) ? client_1.Height.fromJSON(object.proofHeight) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.consensusState !== undefined &&
            (obj.consensusState = message.consensusState ? any_1.Any.toJSON(message.consensusState) : undefined);
        message.clientId !== undefined && (obj.clientId = message.clientId);
        message.proof !== undefined &&
            (obj.proof = base64FromBytes(message.proof !== undefined ? message.proof : new Uint8Array()));
        message.proofHeight !== undefined &&
            (obj.proofHeight = message.proofHeight ? client_1.Height.toJSON(message.proofHeight) : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseQueryConnectionConsensusStateResponse();
        message.consensusState =
            object.consensusState !== undefined && object.consensusState !== null
                ? any_1.Any.fromPartial(object.consensusState)
                : undefined;
        message.clientId = (_a = object.clientId) !== null && _a !== void 0 ? _a : "";
        message.proof = (_b = object.proof) !== null && _b !== void 0 ? _b : new Uint8Array();
        message.proofHeight =
            object.proofHeight !== undefined && object.proofHeight !== null
                ? client_1.Height.fromPartial(object.proofHeight)
                : undefined;
        return message;
    },
};
class QueryClientImpl {
    constructor(rpc) {
        this.rpc = rpc;
        this.Connection = this.Connection.bind(this);
        this.Connections = this.Connections.bind(this);
        this.ClientConnections = this.ClientConnections.bind(this);
        this.ConnectionClientState = this.ConnectionClientState.bind(this);
        this.ConnectionConsensusState = this.ConnectionConsensusState.bind(this);
    }
    Connection(request) {
        const data = exports.QueryConnectionRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.connection.v1.Query", "Connection", data);
        return promise.then((data) => exports.QueryConnectionResponse.decode(new minimal_1.default.Reader(data)));
    }
    Connections(request) {
        const data = exports.QueryConnectionsRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.connection.v1.Query", "Connections", data);
        return promise.then((data) => exports.QueryConnectionsResponse.decode(new minimal_1.default.Reader(data)));
    }
    ClientConnections(request) {
        const data = exports.QueryClientConnectionsRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.connection.v1.Query", "ClientConnections", data);
        return promise.then((data) => exports.QueryClientConnectionsResponse.decode(new minimal_1.default.Reader(data)));
    }
    ConnectionClientState(request) {
        const data = exports.QueryConnectionClientStateRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.connection.v1.Query", "ConnectionClientState", data);
        return promise.then((data) => exports.QueryConnectionClientStateResponse.decode(new minimal_1.default.Reader(data)));
    }
    ConnectionConsensusState(request) {
        const data = exports.QueryConnectionConsensusStateRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.connection.v1.Query", "ConnectionConsensusState", data);
        return promise.then((data) => exports.QueryConnectionConsensusStateResponse.decode(new minimal_1.default.Reader(data)));
    }
}
exports.QueryClientImpl = QueryClientImpl;
var globalThis = (() => {
    if (typeof globalThis !== "undefined") {
        return globalThis;
    }
    if (typeof self !== "undefined") {
        return self;
    }
    if (typeof window !== "undefined") {
        return window;
    }
    if (typeof __webpack_require__.g !== "undefined") {
        return __webpack_require__.g;
    }
    throw "Unable to locate global object";
})();
function bytesFromBase64(b64) {
    if (globalThis.Buffer) {
        return Uint8Array.from(globalThis.Buffer.from(b64, "base64"));
    }
    else {
        const bin = globalThis.atob(b64);
        const arr = new Uint8Array(bin.length);
        for (let i = 0; i < bin.length; ++i) {
            arr[i] = bin.charCodeAt(i);
        }
        return arr;
    }
}
function base64FromBytes(arr) {
    if (globalThis.Buffer) {
        return globalThis.Buffer.from(arr).toString("base64");
    }
    else {
        const bin = [];
        arr.forEach((byte) => {
            bin.push(String.fromCharCode(byte));
        });
        return globalThis.btoa(bin.join(""));
    }
}
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=query.js.map

/***/ }),

/***/ 28300:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MsgClientImpl = exports.MsgConnectionOpenConfirmResponse = exports.MsgConnectionOpenConfirm = exports.MsgConnectionOpenAckResponse = exports.MsgConnectionOpenAck = exports.MsgConnectionOpenTryResponse = exports.MsgConnectionOpenTry = exports.MsgConnectionOpenInitResponse = exports.MsgConnectionOpenInit = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(__webpack_require__(47873));
const minimal_1 = __importDefault(__webpack_require__(62100));
const any_1 = __webpack_require__(90007);
const client_1 = __webpack_require__(74373);
const connection_1 = __webpack_require__(1609);
exports.protobufPackage = "ibc.core.connection.v1";
function createBaseMsgConnectionOpenInit() {
    return { clientId: "", counterparty: undefined, version: undefined, delayPeriod: long_1.default.UZERO, signer: "" };
}
exports.MsgConnectionOpenInit = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.clientId !== "") {
            writer.uint32(10).string(message.clientId);
        }
        if (message.counterparty !== undefined) {
            connection_1.Counterparty.encode(message.counterparty, writer.uint32(18).fork()).ldelim();
        }
        if (message.version !== undefined) {
            connection_1.Version.encode(message.version, writer.uint32(26).fork()).ldelim();
        }
        if (!message.delayPeriod.isZero()) {
            writer.uint32(32).uint64(message.delayPeriod);
        }
        if (message.signer !== "") {
            writer.uint32(42).string(message.signer);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgConnectionOpenInit();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.counterparty = connection_1.Counterparty.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.version = connection_1.Version.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.delayPeriod = reader.uint64();
                    break;
                case 5:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            clientId: isSet(object.clientId) ? String(object.clientId) : "",
            counterparty: isSet(object.counterparty) ? connection_1.Counterparty.fromJSON(object.counterparty) : undefined,
            version: isSet(object.version) ? connection_1.Version.fromJSON(object.version) : undefined,
            delayPeriod: isSet(object.delayPeriod) ? long_1.default.fromValue(object.delayPeriod) : long_1.default.UZERO,
            signer: isSet(object.signer) ? String(object.signer) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        message.counterparty !== undefined &&
            (obj.counterparty = message.counterparty ? connection_1.Counterparty.toJSON(message.counterparty) : undefined);
        message.version !== undefined &&
            (obj.version = message.version ? connection_1.Version.toJSON(message.version) : undefined);
        message.delayPeriod !== undefined && (obj.delayPeriod = (message.delayPeriod || long_1.default.UZERO).toString());
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseMsgConnectionOpenInit();
        message.clientId = (_a = object.clientId) !== null && _a !== void 0 ? _a : "";
        message.counterparty =
            object.counterparty !== undefined && object.counterparty !== null
                ? connection_1.Counterparty.fromPartial(object.counterparty)
                : undefined;
        message.version =
            object.version !== undefined && object.version !== null
                ? connection_1.Version.fromPartial(object.version)
                : undefined;
        message.delayPeriod =
            object.delayPeriod !== undefined && object.delayPeriod !== null
                ? long_1.default.fromValue(object.delayPeriod)
                : long_1.default.UZERO;
        message.signer = (_b = object.signer) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
function createBaseMsgConnectionOpenInitResponse() {
    return {};
}
exports.MsgConnectionOpenInitResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgConnectionOpenInitResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgConnectionOpenInitResponse();
        return message;
    },
};
function createBaseMsgConnectionOpenTry() {
    return {
        clientId: "",
        previousConnectionId: "",
        clientState: undefined,
        counterparty: undefined,
        delayPeriod: long_1.default.UZERO,
        counterpartyVersions: [],
        proofHeight: undefined,
        proofInit: new Uint8Array(),
        proofClient: new Uint8Array(),
        proofConsensus: new Uint8Array(),
        consensusHeight: undefined,
        signer: "",
    };
}
exports.MsgConnectionOpenTry = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.clientId !== "") {
            writer.uint32(10).string(message.clientId);
        }
        if (message.previousConnectionId !== "") {
            writer.uint32(18).string(message.previousConnectionId);
        }
        if (message.clientState !== undefined) {
            any_1.Any.encode(message.clientState, writer.uint32(26).fork()).ldelim();
        }
        if (message.counterparty !== undefined) {
            connection_1.Counterparty.encode(message.counterparty, writer.uint32(34).fork()).ldelim();
        }
        if (!message.delayPeriod.isZero()) {
            writer.uint32(40).uint64(message.delayPeriod);
        }
        for (const v of message.counterpartyVersions) {
            connection_1.Version.encode(v, writer.uint32(50).fork()).ldelim();
        }
        if (message.proofHeight !== undefined) {
            client_1.Height.encode(message.proofHeight, writer.uint32(58).fork()).ldelim();
        }
        if (message.proofInit.length !== 0) {
            writer.uint32(66).bytes(message.proofInit);
        }
        if (message.proofClient.length !== 0) {
            writer.uint32(74).bytes(message.proofClient);
        }
        if (message.proofConsensus.length !== 0) {
            writer.uint32(82).bytes(message.proofConsensus);
        }
        if (message.consensusHeight !== undefined) {
            client_1.Height.encode(message.consensusHeight, writer.uint32(90).fork()).ldelim();
        }
        if (message.signer !== "") {
            writer.uint32(98).string(message.signer);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgConnectionOpenTry();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.previousConnectionId = reader.string();
                    break;
                case 3:
                    message.clientState = any_1.Any.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.counterparty = connection_1.Counterparty.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.delayPeriod = reader.uint64();
                    break;
                case 6:
                    message.counterpartyVersions.push(connection_1.Version.decode(reader, reader.uint32()));
                    break;
                case 7:
                    message.proofHeight = client_1.Height.decode(reader, reader.uint32());
                    break;
                case 8:
                    message.proofInit = reader.bytes();
                    break;
                case 9:
                    message.proofClient = reader.bytes();
                    break;
                case 10:
                    message.proofConsensus = reader.bytes();
                    break;
                case 11:
                    message.consensusHeight = client_1.Height.decode(reader, reader.uint32());
                    break;
                case 12:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            clientId: isSet(object.clientId) ? String(object.clientId) : "",
            previousConnectionId: isSet(object.previousConnectionId) ? String(object.previousConnectionId) : "",
            clientState: isSet(object.clientState) ? any_1.Any.fromJSON(object.clientState) : undefined,
            counterparty: isSet(object.counterparty) ? connection_1.Counterparty.fromJSON(object.counterparty) : undefined,
            delayPeriod: isSet(object.delayPeriod) ? long_1.default.fromValue(object.delayPeriod) : long_1.default.UZERO,
            counterpartyVersions: Array.isArray(object === null || object === void 0 ? void 0 : object.counterpartyVersions)
                ? object.counterpartyVersions.map((e) => connection_1.Version.fromJSON(e))
                : [],
            proofHeight: isSet(object.proofHeight) ? client_1.Height.fromJSON(object.proofHeight) : undefined,
            proofInit: isSet(object.proofInit) ? bytesFromBase64(object.proofInit) : new Uint8Array(),
            proofClient: isSet(object.proofClient) ? bytesFromBase64(object.proofClient) : new Uint8Array(),
            proofConsensus: isSet(object.proofConsensus)
                ? bytesFromBase64(object.proofConsensus)
                : new Uint8Array(),
            consensusHeight: isSet(object.consensusHeight) ? client_1.Height.fromJSON(object.consensusHeight) : undefined,
            signer: isSet(object.signer) ? String(object.signer) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        message.previousConnectionId !== undefined && (obj.previousConnectionId = message.previousConnectionId);
        message.clientState !== undefined &&
            (obj.clientState = message.clientState ? any_1.Any.toJSON(message.clientState) : undefined);
        message.counterparty !== undefined &&
            (obj.counterparty = message.counterparty ? connection_1.Counterparty.toJSON(message.counterparty) : undefined);
        message.delayPeriod !== undefined && (obj.delayPeriod = (message.delayPeriod || long_1.default.UZERO).toString());
        if (message.counterpartyVersions) {
            obj.counterpartyVersions = message.counterpartyVersions.map((e) => (e ? connection_1.Version.toJSON(e) : undefined));
        }
        else {
            obj.counterpartyVersions = [];
        }
        message.proofHeight !== undefined &&
            (obj.proofHeight = message.proofHeight ? client_1.Height.toJSON(message.proofHeight) : undefined);
        message.proofInit !== undefined &&
            (obj.proofInit = base64FromBytes(message.proofInit !== undefined ? message.proofInit : new Uint8Array()));
        message.proofClient !== undefined &&
            (obj.proofClient = base64FromBytes(message.proofClient !== undefined ? message.proofClient : new Uint8Array()));
        message.proofConsensus !== undefined &&
            (obj.proofConsensus = base64FromBytes(message.proofConsensus !== undefined ? message.proofConsensus : new Uint8Array()));
        message.consensusHeight !== undefined &&
            (obj.consensusHeight = message.consensusHeight ? client_1.Height.toJSON(message.consensusHeight) : undefined);
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f, _g;
        const message = createBaseMsgConnectionOpenTry();
        message.clientId = (_a = object.clientId) !== null && _a !== void 0 ? _a : "";
        message.previousConnectionId = (_b = object.previousConnectionId) !== null && _b !== void 0 ? _b : "";
        message.clientState =
            object.clientState !== undefined && object.clientState !== null
                ? any_1.Any.fromPartial(object.clientState)
                : undefined;
        message.counterparty =
            object.counterparty !== undefined && object.counterparty !== null
                ? connection_1.Counterparty.fromPartial(object.counterparty)
                : undefined;
        message.delayPeriod =
            object.delayPeriod !== undefined && object.delayPeriod !== null
                ? long_1.default.fromValue(object.delayPeriod)
                : long_1.default.UZERO;
        message.counterpartyVersions = ((_c = object.counterpartyVersions) === null || _c === void 0 ? void 0 : _c.map((e) => connection_1.Version.fromPartial(e))) || [];
        message.proofHeight =
            object.proofHeight !== undefined && object.proofHeight !== null
                ? client_1.Height.fromPartial(object.proofHeight)
                : undefined;
        message.proofInit = (_d = object.proofInit) !== null && _d !== void 0 ? _d : new Uint8Array();
        message.proofClient = (_e = object.proofClient) !== null && _e !== void 0 ? _e : new Uint8Array();
        message.proofConsensus = (_f = object.proofConsensus) !== null && _f !== void 0 ? _f : new Uint8Array();
        message.consensusHeight =
            object.consensusHeight !== undefined && object.consensusHeight !== null
                ? client_1.Height.fromPartial(object.consensusHeight)
                : undefined;
        message.signer = (_g = object.signer) !== null && _g !== void 0 ? _g : "";
        return message;
    },
};
function createBaseMsgConnectionOpenTryResponse() {
    return {};
}
exports.MsgConnectionOpenTryResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgConnectionOpenTryResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgConnectionOpenTryResponse();
        return message;
    },
};
function createBaseMsgConnectionOpenAck() {
    return {
        connectionId: "",
        counterpartyConnectionId: "",
        version: undefined,
        clientState: undefined,
        proofHeight: undefined,
        proofTry: new Uint8Array(),
        proofClient: new Uint8Array(),
        proofConsensus: new Uint8Array(),
        consensusHeight: undefined,
        signer: "",
    };
}
exports.MsgConnectionOpenAck = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.connectionId !== "") {
            writer.uint32(10).string(message.connectionId);
        }
        if (message.counterpartyConnectionId !== "") {
            writer.uint32(18).string(message.counterpartyConnectionId);
        }
        if (message.version !== undefined) {
            connection_1.Version.encode(message.version, writer.uint32(26).fork()).ldelim();
        }
        if (message.clientState !== undefined) {
            any_1.Any.encode(message.clientState, writer.uint32(34).fork()).ldelim();
        }
        if (message.proofHeight !== undefined) {
            client_1.Height.encode(message.proofHeight, writer.uint32(42).fork()).ldelim();
        }
        if (message.proofTry.length !== 0) {
            writer.uint32(50).bytes(message.proofTry);
        }
        if (message.proofClient.length !== 0) {
            writer.uint32(58).bytes(message.proofClient);
        }
        if (message.proofConsensus.length !== 0) {
            writer.uint32(66).bytes(message.proofConsensus);
        }
        if (message.consensusHeight !== undefined) {
            client_1.Height.encode(message.consensusHeight, writer.uint32(74).fork()).ldelim();
        }
        if (message.signer !== "") {
            writer.uint32(82).string(message.signer);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgConnectionOpenAck();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.connectionId = reader.string();
                    break;
                case 2:
                    message.counterpartyConnectionId = reader.string();
                    break;
                case 3:
                    message.version = connection_1.Version.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.clientState = any_1.Any.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.proofHeight = client_1.Height.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.proofTry = reader.bytes();
                    break;
                case 7:
                    message.proofClient = reader.bytes();
                    break;
                case 8:
                    message.proofConsensus = reader.bytes();
                    break;
                case 9:
                    message.consensusHeight = client_1.Height.decode(reader, reader.uint32());
                    break;
                case 10:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            connectionId: isSet(object.connectionId) ? String(object.connectionId) : "",
            counterpartyConnectionId: isSet(object.counterpartyConnectionId)
                ? String(object.counterpartyConnectionId)
                : "",
            version: isSet(object.version) ? connection_1.Version.fromJSON(object.version) : undefined,
            clientState: isSet(object.clientState) ? any_1.Any.fromJSON(object.clientState) : undefined,
            proofHeight: isSet(object.proofHeight) ? client_1.Height.fromJSON(object.proofHeight) : undefined,
            proofTry: isSet(object.proofTry) ? bytesFromBase64(object.proofTry) : new Uint8Array(),
            proofClient: isSet(object.proofClient) ? bytesFromBase64(object.proofClient) : new Uint8Array(),
            proofConsensus: isSet(object.proofConsensus)
                ? bytesFromBase64(object.proofConsensus)
                : new Uint8Array(),
            consensusHeight: isSet(object.consensusHeight) ? client_1.Height.fromJSON(object.consensusHeight) : undefined,
            signer: isSet(object.signer) ? String(object.signer) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.connectionId !== undefined && (obj.connectionId = message.connectionId);
        message.counterpartyConnectionId !== undefined &&
            (obj.counterpartyConnectionId = message.counterpartyConnectionId);
        message.version !== undefined &&
            (obj.version = message.version ? connection_1.Version.toJSON(message.version) : undefined);
        message.clientState !== undefined &&
            (obj.clientState = message.clientState ? any_1.Any.toJSON(message.clientState) : undefined);
        message.proofHeight !== undefined &&
            (obj.proofHeight = message.proofHeight ? client_1.Height.toJSON(message.proofHeight) : undefined);
        message.proofTry !== undefined &&
            (obj.proofTry = base64FromBytes(message.proofTry !== undefined ? message.proofTry : new Uint8Array()));
        message.proofClient !== undefined &&
            (obj.proofClient = base64FromBytes(message.proofClient !== undefined ? message.proofClient : new Uint8Array()));
        message.proofConsensus !== undefined &&
            (obj.proofConsensus = base64FromBytes(message.proofConsensus !== undefined ? message.proofConsensus : new Uint8Array()));
        message.consensusHeight !== undefined &&
            (obj.consensusHeight = message.consensusHeight ? client_1.Height.toJSON(message.consensusHeight) : undefined);
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f;
        const message = createBaseMsgConnectionOpenAck();
        message.connectionId = (_a = object.connectionId) !== null && _a !== void 0 ? _a : "";
        message.counterpartyConnectionId = (_b = object.counterpartyConnectionId) !== null && _b !== void 0 ? _b : "";
        message.version =
            object.version !== undefined && object.version !== null
                ? connection_1.Version.fromPartial(object.version)
                : undefined;
        message.clientState =
            object.clientState !== undefined && object.clientState !== null
                ? any_1.Any.fromPartial(object.clientState)
                : undefined;
        message.proofHeight =
            object.proofHeight !== undefined && object.proofHeight !== null
                ? client_1.Height.fromPartial(object.proofHeight)
                : undefined;
        message.proofTry = (_c = object.proofTry) !== null && _c !== void 0 ? _c : new Uint8Array();
        message.proofClient = (_d = object.proofClient) !== null && _d !== void 0 ? _d : new Uint8Array();
        message.proofConsensus = (_e = object.proofConsensus) !== null && _e !== void 0 ? _e : new Uint8Array();
        message.consensusHeight =
            object.consensusHeight !== undefined && object.consensusHeight !== null
                ? client_1.Height.fromPartial(object.consensusHeight)
                : undefined;
        message.signer = (_f = object.signer) !== null && _f !== void 0 ? _f : "";
        return message;
    },
};
function createBaseMsgConnectionOpenAckResponse() {
    return {};
}
exports.MsgConnectionOpenAckResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgConnectionOpenAckResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgConnectionOpenAckResponse();
        return message;
    },
};
function createBaseMsgConnectionOpenConfirm() {
    return { connectionId: "", proofAck: new Uint8Array(), proofHeight: undefined, signer: "" };
}
exports.MsgConnectionOpenConfirm = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.connectionId !== "") {
            writer.uint32(10).string(message.connectionId);
        }
        if (message.proofAck.length !== 0) {
            writer.uint32(18).bytes(message.proofAck);
        }
        if (message.proofHeight !== undefined) {
            client_1.Height.encode(message.proofHeight, writer.uint32(26).fork()).ldelim();
        }
        if (message.signer !== "") {
            writer.uint32(34).string(message.signer);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgConnectionOpenConfirm();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.connectionId = reader.string();
                    break;
                case 2:
                    message.proofAck = reader.bytes();
                    break;
                case 3:
                    message.proofHeight = client_1.Height.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            connectionId: isSet(object.connectionId) ? String(object.connectionId) : "",
            proofAck: isSet(object.proofAck) ? bytesFromBase64(object.proofAck) : new Uint8Array(),
            proofHeight: isSet(object.proofHeight) ? client_1.Height.fromJSON(object.proofHeight) : undefined,
            signer: isSet(object.signer) ? String(object.signer) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.connectionId !== undefined && (obj.connectionId = message.connectionId);
        message.proofAck !== undefined &&
            (obj.proofAck = base64FromBytes(message.proofAck !== undefined ? message.proofAck : new Uint8Array()));
        message.proofHeight !== undefined &&
            (obj.proofHeight = message.proofHeight ? client_1.Height.toJSON(message.proofHeight) : undefined);
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseMsgConnectionOpenConfirm();
        message.connectionId = (_a = object.connectionId) !== null && _a !== void 0 ? _a : "";
        message.proofAck = (_b = object.proofAck) !== null && _b !== void 0 ? _b : new Uint8Array();
        message.proofHeight =
            object.proofHeight !== undefined && object.proofHeight !== null
                ? client_1.Height.fromPartial(object.proofHeight)
                : undefined;
        message.signer = (_c = object.signer) !== null && _c !== void 0 ? _c : "";
        return message;
    },
};
function createBaseMsgConnectionOpenConfirmResponse() {
    return {};
}
exports.MsgConnectionOpenConfirmResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgConnectionOpenConfirmResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgConnectionOpenConfirmResponse();
        return message;
    },
};
class MsgClientImpl {
    constructor(rpc) {
        this.rpc = rpc;
        this.ConnectionOpenInit = this.ConnectionOpenInit.bind(this);
        this.ConnectionOpenTry = this.ConnectionOpenTry.bind(this);
        this.ConnectionOpenAck = this.ConnectionOpenAck.bind(this);
        this.ConnectionOpenConfirm = this.ConnectionOpenConfirm.bind(this);
    }
    ConnectionOpenInit(request) {
        const data = exports.MsgConnectionOpenInit.encode(request).finish();
        const promise = this.rpc.request("ibc.core.connection.v1.Msg", "ConnectionOpenInit", data);
        return promise.then((data) => exports.MsgConnectionOpenInitResponse.decode(new minimal_1.default.Reader(data)));
    }
    ConnectionOpenTry(request) {
        const data = exports.MsgConnectionOpenTry.encode(request).finish();
        const promise = this.rpc.request("ibc.core.connection.v1.Msg", "ConnectionOpenTry", data);
        return promise.then((data) => exports.MsgConnectionOpenTryResponse.decode(new minimal_1.default.Reader(data)));
    }
    ConnectionOpenAck(request) {
        const data = exports.MsgConnectionOpenAck.encode(request).finish();
        const promise = this.rpc.request("ibc.core.connection.v1.Msg", "ConnectionOpenAck", data);
        return promise.then((data) => exports.MsgConnectionOpenAckResponse.decode(new minimal_1.default.Reader(data)));
    }
    ConnectionOpenConfirm(request) {
        const data = exports.MsgConnectionOpenConfirm.encode(request).finish();
        const promise = this.rpc.request("ibc.core.connection.v1.Msg", "ConnectionOpenConfirm", data);
        return promise.then((data) => exports.MsgConnectionOpenConfirmResponse.decode(new minimal_1.default.Reader(data)));
    }
}
exports.MsgClientImpl = MsgClientImpl;
var globalThis = (() => {
    if (typeof globalThis !== "undefined") {
        return globalThis;
    }
    if (typeof self !== "undefined") {
        return self;
    }
    if (typeof window !== "undefined") {
        return window;
    }
    if (typeof __webpack_require__.g !== "undefined") {
        return __webpack_require__.g;
    }
    throw "Unable to locate global object";
})();
function bytesFromBase64(b64) {
    if (globalThis.Buffer) {
        return Uint8Array.from(globalThis.Buffer.from(b64, "base64"));
    }
    else {
        const bin = globalThis.atob(b64);
        const arr = new Uint8Array(bin.length);
        for (let i = 0; i < bin.length; ++i) {
            arr[i] = bin.charCodeAt(i);
        }
        return arr;
    }
}
function base64FromBytes(arr) {
    if (globalThis.Buffer) {
        return globalThis.Buffer.from(arr).toString("base64");
    }
    else {
        const bin = [];
        arr.forEach((byte) => {
            bin.push(String.fromCharCode(byte));
        });
        return globalThis.btoa(bin.join(""));
    }
}
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=tx.js.map

/***/ }),

/***/ 83359:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Fraction = exports.Header = exports.Misbehaviour = exports.ConsensusState = exports.ClientState = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(__webpack_require__(47873));
const minimal_1 = __importDefault(__webpack_require__(62100));
const proofs_1 = __webpack_require__(69892);
const duration_1 = __webpack_require__(59769);
const timestamp_1 = __webpack_require__(76620);
const types_1 = __webpack_require__(54028);
const validator_1 = __webpack_require__(75293);
const client_1 = __webpack_require__(74373);
const commitment_1 = __webpack_require__(81102);
exports.protobufPackage = "ibc.lightclients.tendermint.v1";
function createBaseClientState() {
    return {
        chainId: "",
        trustLevel: undefined,
        trustingPeriod: undefined,
        unbondingPeriod: undefined,
        maxClockDrift: undefined,
        frozenHeight: undefined,
        latestHeight: undefined,
        proofSpecs: [],
        upgradePath: [],
        allowUpdateAfterExpiry: false,
        allowUpdateAfterMisbehaviour: false,
    };
}
exports.ClientState = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.chainId !== "") {
            writer.uint32(10).string(message.chainId);
        }
        if (message.trustLevel !== undefined) {
            exports.Fraction.encode(message.trustLevel, writer.uint32(18).fork()).ldelim();
        }
        if (message.trustingPeriod !== undefined) {
            duration_1.Duration.encode(message.trustingPeriod, writer.uint32(26).fork()).ldelim();
        }
        if (message.unbondingPeriod !== undefined) {
            duration_1.Duration.encode(message.unbondingPeriod, writer.uint32(34).fork()).ldelim();
        }
        if (message.maxClockDrift !== undefined) {
            duration_1.Duration.encode(message.maxClockDrift, writer.uint32(42).fork()).ldelim();
        }
        if (message.frozenHeight !== undefined) {
            client_1.Height.encode(message.frozenHeight, writer.uint32(50).fork()).ldelim();
        }
        if (message.latestHeight !== undefined) {
            client_1.Height.encode(message.latestHeight, writer.uint32(58).fork()).ldelim();
        }
        for (const v of message.proofSpecs) {
            proofs_1.ProofSpec.encode(v, writer.uint32(66).fork()).ldelim();
        }
        for (const v of message.upgradePath) {
            writer.uint32(74).string(v);
        }
        if (message.allowUpdateAfterExpiry === true) {
            writer.uint32(80).bool(message.allowUpdateAfterExpiry);
        }
        if (message.allowUpdateAfterMisbehaviour === true) {
            writer.uint32(88).bool(message.allowUpdateAfterMisbehaviour);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseClientState();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.chainId = reader.string();
                    break;
                case 2:
                    message.trustLevel = exports.Fraction.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.trustingPeriod = duration_1.Duration.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.unbondingPeriod = duration_1.Duration.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.maxClockDrift = duration_1.Duration.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.frozenHeight = client_1.Height.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.latestHeight = client_1.Height.decode(reader, reader.uint32());
                    break;
                case 8:
                    message.proofSpecs.push(proofs_1.ProofSpec.decode(reader, reader.uint32()));
                    break;
                case 9:
                    message.upgradePath.push(reader.string());
                    break;
                case 10:
                    message.allowUpdateAfterExpiry = reader.bool();
                    break;
                case 11:
                    message.allowUpdateAfterMisbehaviour = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            chainId: isSet(object.chainId) ? String(object.chainId) : "",
            trustLevel: isSet(object.trustLevel) ? exports.Fraction.fromJSON(object.trustLevel) : undefined,
            trustingPeriod: isSet(object.trustingPeriod) ? duration_1.Duration.fromJSON(object.trustingPeriod) : undefined,
            unbondingPeriod: isSet(object.unbondingPeriod) ? duration_1.Duration.fromJSON(object.unbondingPeriod) : undefined,
            maxClockDrift: isSet(object.maxClockDrift) ? duration_1.Duration.fromJSON(object.maxClockDrift) : undefined,
            frozenHeight: isSet(object.frozenHeight) ? client_1.Height.fromJSON(object.frozenHeight) : undefined,
            latestHeight: isSet(object.latestHeight) ? client_1.Height.fromJSON(object.latestHeight) : undefined,
            proofSpecs: Array.isArray(object === null || object === void 0 ? void 0 : object.proofSpecs)
                ? object.proofSpecs.map((e) => proofs_1.ProofSpec.fromJSON(e))
                : [],
            upgradePath: Array.isArray(object === null || object === void 0 ? void 0 : object.upgradePath) ? object.upgradePath.map((e) => String(e)) : [],
            allowUpdateAfterExpiry: isSet(object.allowUpdateAfterExpiry)
                ? Boolean(object.allowUpdateAfterExpiry)
                : false,
            allowUpdateAfterMisbehaviour: isSet(object.allowUpdateAfterMisbehaviour)
                ? Boolean(object.allowUpdateAfterMisbehaviour)
                : false,
        };
    },
    toJSON(message) {
        const obj = {};
        message.chainId !== undefined && (obj.chainId = message.chainId);
        message.trustLevel !== undefined &&
            (obj.trustLevel = message.trustLevel ? exports.Fraction.toJSON(message.trustLevel) : undefined);
        message.trustingPeriod !== undefined &&
            (obj.trustingPeriod = message.trustingPeriod ? duration_1.Duration.toJSON(message.trustingPeriod) : undefined);
        message.unbondingPeriod !== undefined &&
            (obj.unbondingPeriod = message.unbondingPeriod ? duration_1.Duration.toJSON(message.unbondingPeriod) : undefined);
        message.maxClockDrift !== undefined &&
            (obj.maxClockDrift = message.maxClockDrift ? duration_1.Duration.toJSON(message.maxClockDrift) : undefined);
        message.frozenHeight !== undefined &&
            (obj.frozenHeight = message.frozenHeight ? client_1.Height.toJSON(message.frozenHeight) : undefined);
        message.latestHeight !== undefined &&
            (obj.latestHeight = message.latestHeight ? client_1.Height.toJSON(message.latestHeight) : undefined);
        if (message.proofSpecs) {
            obj.proofSpecs = message.proofSpecs.map((e) => (e ? proofs_1.ProofSpec.toJSON(e) : undefined));
        }
        else {
            obj.proofSpecs = [];
        }
        if (message.upgradePath) {
            obj.upgradePath = message.upgradePath.map((e) => e);
        }
        else {
            obj.upgradePath = [];
        }
        message.allowUpdateAfterExpiry !== undefined &&
            (obj.allowUpdateAfterExpiry = message.allowUpdateAfterExpiry);
        message.allowUpdateAfterMisbehaviour !== undefined &&
            (obj.allowUpdateAfterMisbehaviour = message.allowUpdateAfterMisbehaviour);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e;
        const message = createBaseClientState();
        message.chainId = (_a = object.chainId) !== null && _a !== void 0 ? _a : "";
        message.trustLevel =
            object.trustLevel !== undefined && object.trustLevel !== null
                ? exports.Fraction.fromPartial(object.trustLevel)
                : undefined;
        message.trustingPeriod =
            object.trustingPeriod !== undefined && object.trustingPeriod !== null
                ? duration_1.Duration.fromPartial(object.trustingPeriod)
                : undefined;
        message.unbondingPeriod =
            object.unbondingPeriod !== undefined && object.unbondingPeriod !== null
                ? duration_1.Duration.fromPartial(object.unbondingPeriod)
                : undefined;
        message.maxClockDrift =
            object.maxClockDrift !== undefined && object.maxClockDrift !== null
                ? duration_1.Duration.fromPartial(object.maxClockDrift)
                : undefined;
        message.frozenHeight =
            object.frozenHeight !== undefined && object.frozenHeight !== null
                ? client_1.Height.fromPartial(object.frozenHeight)
                : undefined;
        message.latestHeight =
            object.latestHeight !== undefined && object.latestHeight !== null
                ? client_1.Height.fromPartial(object.latestHeight)
                : undefined;
        message.proofSpecs = ((_b = object.proofSpecs) === null || _b === void 0 ? void 0 : _b.map((e) => proofs_1.ProofSpec.fromPartial(e))) || [];
        message.upgradePath = ((_c = object.upgradePath) === null || _c === void 0 ? void 0 : _c.map((e) => e)) || [];
        message.allowUpdateAfterExpiry = (_d = object.allowUpdateAfterExpiry) !== null && _d !== void 0 ? _d : false;
        message.allowUpdateAfterMisbehaviour = (_e = object.allowUpdateAfterMisbehaviour) !== null && _e !== void 0 ? _e : false;
        return message;
    },
};
function createBaseConsensusState() {
    return { timestamp: undefined, root: undefined, nextValidatorsHash: new Uint8Array() };
}
exports.ConsensusState = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.timestamp !== undefined) {
            timestamp_1.Timestamp.encode(message.timestamp, writer.uint32(10).fork()).ldelim();
        }
        if (message.root !== undefined) {
            commitment_1.MerkleRoot.encode(message.root, writer.uint32(18).fork()).ldelim();
        }
        if (message.nextValidatorsHash.length !== 0) {
            writer.uint32(26).bytes(message.nextValidatorsHash);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseConsensusState();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.timestamp = timestamp_1.Timestamp.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.root = commitment_1.MerkleRoot.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.nextValidatorsHash = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            timestamp: isSet(object.timestamp) ? fromJsonTimestamp(object.timestamp) : undefined,
            root: isSet(object.root) ? commitment_1.MerkleRoot.fromJSON(object.root) : undefined,
            nextValidatorsHash: isSet(object.nextValidatorsHash)
                ? bytesFromBase64(object.nextValidatorsHash)
                : new Uint8Array(),
        };
    },
    toJSON(message) {
        const obj = {};
        message.timestamp !== undefined && (obj.timestamp = fromTimestamp(message.timestamp).toISOString());
        message.root !== undefined && (obj.root = message.root ? commitment_1.MerkleRoot.toJSON(message.root) : undefined);
        message.nextValidatorsHash !== undefined &&
            (obj.nextValidatorsHash = base64FromBytes(message.nextValidatorsHash !== undefined ? message.nextValidatorsHash : new Uint8Array()));
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseConsensusState();
        message.timestamp =
            object.timestamp !== undefined && object.timestamp !== null
                ? timestamp_1.Timestamp.fromPartial(object.timestamp)
                : undefined;
        message.root =
            object.root !== undefined && object.root !== null ? commitment_1.MerkleRoot.fromPartial(object.root) : undefined;
        message.nextValidatorsHash = (_a = object.nextValidatorsHash) !== null && _a !== void 0 ? _a : new Uint8Array();
        return message;
    },
};
function createBaseMisbehaviour() {
    return { clientId: "", header1: undefined, header2: undefined };
}
exports.Misbehaviour = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.clientId !== "") {
            writer.uint32(10).string(message.clientId);
        }
        if (message.header1 !== undefined) {
            exports.Header.encode(message.header1, writer.uint32(18).fork()).ldelim();
        }
        if (message.header2 !== undefined) {
            exports.Header.encode(message.header2, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMisbehaviour();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.header1 = exports.Header.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.header2 = exports.Header.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            clientId: isSet(object.clientId) ? String(object.clientId) : "",
            header1: isSet(object.header1) ? exports.Header.fromJSON(object.header1) : undefined,
            header2: isSet(object.header2) ? exports.Header.fromJSON(object.header2) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        message.header1 !== undefined &&
            (obj.header1 = message.header1 ? exports.Header.toJSON(message.header1) : undefined);
        message.header2 !== undefined &&
            (obj.header2 = message.header2 ? exports.Header.toJSON(message.header2) : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseMisbehaviour();
        message.clientId = (_a = object.clientId) !== null && _a !== void 0 ? _a : "";
        message.header1 =
            object.header1 !== undefined && object.header1 !== null
                ? exports.Header.fromPartial(object.header1)
                : undefined;
        message.header2 =
            object.header2 !== undefined && object.header2 !== null
                ? exports.Header.fromPartial(object.header2)
                : undefined;
        return message;
    },
};
function createBaseHeader() {
    return {
        signedHeader: undefined,
        validatorSet: undefined,
        trustedHeight: undefined,
        trustedValidators: undefined,
    };
}
exports.Header = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.signedHeader !== undefined) {
            types_1.SignedHeader.encode(message.signedHeader, writer.uint32(10).fork()).ldelim();
        }
        if (message.validatorSet !== undefined) {
            validator_1.ValidatorSet.encode(message.validatorSet, writer.uint32(18).fork()).ldelim();
        }
        if (message.trustedHeight !== undefined) {
            client_1.Height.encode(message.trustedHeight, writer.uint32(26).fork()).ldelim();
        }
        if (message.trustedValidators !== undefined) {
            validator_1.ValidatorSet.encode(message.trustedValidators, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseHeader();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.signedHeader = types_1.SignedHeader.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.validatorSet = validator_1.ValidatorSet.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.trustedHeight = client_1.Height.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.trustedValidators = validator_1.ValidatorSet.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            signedHeader: isSet(object.signedHeader) ? types_1.SignedHeader.fromJSON(object.signedHeader) : undefined,
            validatorSet: isSet(object.validatorSet) ? validator_1.ValidatorSet.fromJSON(object.validatorSet) : undefined,
            trustedHeight: isSet(object.trustedHeight) ? client_1.Height.fromJSON(object.trustedHeight) : undefined,
            trustedValidators: isSet(object.trustedValidators)
                ? validator_1.ValidatorSet.fromJSON(object.trustedValidators)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.signedHeader !== undefined &&
            (obj.signedHeader = message.signedHeader ? types_1.SignedHeader.toJSON(message.signedHeader) : undefined);
        message.validatorSet !== undefined &&
            (obj.validatorSet = message.validatorSet ? validator_1.ValidatorSet.toJSON(message.validatorSet) : undefined);
        message.trustedHeight !== undefined &&
            (obj.trustedHeight = message.trustedHeight ? client_1.Height.toJSON(message.trustedHeight) : undefined);
        message.trustedValidators !== undefined &&
            (obj.trustedValidators = message.trustedValidators
                ? validator_1.ValidatorSet.toJSON(message.trustedValidators)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseHeader();
        message.signedHeader =
            object.signedHeader !== undefined && object.signedHeader !== null
                ? types_1.SignedHeader.fromPartial(object.signedHeader)
                : undefined;
        message.validatorSet =
            object.validatorSet !== undefined && object.validatorSet !== null
                ? validator_1.ValidatorSet.fromPartial(object.validatorSet)
                : undefined;
        message.trustedHeight =
            object.trustedHeight !== undefined && object.trustedHeight !== null
                ? client_1.Height.fromPartial(object.trustedHeight)
                : undefined;
        message.trustedValidators =
            object.trustedValidators !== undefined && object.trustedValidators !== null
                ? validator_1.ValidatorSet.fromPartial(object.trustedValidators)
                : undefined;
        return message;
    },
};
function createBaseFraction() {
    return { numerator: long_1.default.UZERO, denominator: long_1.default.UZERO };
}
exports.Fraction = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (!message.numerator.isZero()) {
            writer.uint32(8).uint64(message.numerator);
        }
        if (!message.denominator.isZero()) {
            writer.uint32(16).uint64(message.denominator);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseFraction();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.numerator = reader.uint64();
                    break;
                case 2:
                    message.denominator = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            numerator: isSet(object.numerator) ? long_1.default.fromValue(object.numerator) : long_1.default.UZERO,
            denominator: isSet(object.denominator) ? long_1.default.fromValue(object.denominator) : long_1.default.UZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        message.numerator !== undefined && (obj.numerator = (message.numerator || long_1.default.UZERO).toString());
        message.denominator !== undefined && (obj.denominator = (message.denominator || long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseFraction();
        message.numerator =
            object.numerator !== undefined && object.numerator !== null
                ? long_1.default.fromValue(object.numerator)
                : long_1.default.UZERO;
        message.denominator =
            object.denominator !== undefined && object.denominator !== null
                ? long_1.default.fromValue(object.denominator)
                : long_1.default.UZERO;
        return message;
    },
};
var globalThis = (() => {
    if (typeof globalThis !== "undefined") {
        return globalThis;
    }
    if (typeof self !== "undefined") {
        return self;
    }
    if (typeof window !== "undefined") {
        return window;
    }
    if (typeof __webpack_require__.g !== "undefined") {
        return __webpack_require__.g;
    }
    throw "Unable to locate global object";
})();
function bytesFromBase64(b64) {
    if (globalThis.Buffer) {
        return Uint8Array.from(globalThis.Buffer.from(b64, "base64"));
    }
    else {
        const bin = globalThis.atob(b64);
        const arr = new Uint8Array(bin.length);
        for (let i = 0; i < bin.length; ++i) {
            arr[i] = bin.charCodeAt(i);
        }
        return arr;
    }
}
function base64FromBytes(arr) {
    if (globalThis.Buffer) {
        return globalThis.Buffer.from(arr).toString("base64");
    }
    else {
        const bin = [];
        arr.forEach((byte) => {
            bin.push(String.fromCharCode(byte));
        });
        return globalThis.btoa(bin.join(""));
    }
}
function toTimestamp(date) {
    const seconds = numberToLong(date.getTime() / 1000);
    const nanos = (date.getTime() % 1000) * 1000000;
    return { seconds, nanos };
}
function fromTimestamp(t) {
    let millis = t.seconds.toNumber() * 1000;
    millis += t.nanos / 1000000;
    return new Date(millis);
}
function fromJsonTimestamp(o) {
    if (o instanceof Date) {
        return toTimestamp(o);
    }
    else if (typeof o === "string") {
        return toTimestamp(new Date(o));
    }
    else {
        return timestamp_1.Timestamp.fromJSON(o);
    }
}
function numberToLong(number) {
    return long_1.default.fromNumber(number);
}
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=tendermint.js.map

/***/ }),

/***/ 47873:
/***/ (function(module) {

module.exports = Long;

/**
 * wasm optimizations, to do native i64 multiplication and divide
 */
var wasm = null;

try {
  wasm = new WebAssembly.Instance(new WebAssembly.Module(new Uint8Array([
    0, 97, 115, 109, 1, 0, 0, 0, 1, 13, 2, 96, 0, 1, 127, 96, 4, 127, 127, 127, 127, 1, 127, 3, 7, 6, 0, 1, 1, 1, 1, 1, 6, 6, 1, 127, 1, 65, 0, 11, 7, 50, 6, 3, 109, 117, 108, 0, 1, 5, 100, 105, 118, 95, 115, 0, 2, 5, 100, 105, 118, 95, 117, 0, 3, 5, 114, 101, 109, 95, 115, 0, 4, 5, 114, 101, 109, 95, 117, 0, 5, 8, 103, 101, 116, 95, 104, 105, 103, 104, 0, 0, 10, 191, 1, 6, 4, 0, 35, 0, 11, 36, 1, 1, 126, 32, 0, 173, 32, 1, 173, 66, 32, 134, 132, 32, 2, 173, 32, 3, 173, 66, 32, 134, 132, 126, 34, 4, 66, 32, 135, 167, 36, 0, 32, 4, 167, 11, 36, 1, 1, 126, 32, 0, 173, 32, 1, 173, 66, 32, 134, 132, 32, 2, 173, 32, 3, 173, 66, 32, 134, 132, 127, 34, 4, 66, 32, 135, 167, 36, 0, 32, 4, 167, 11, 36, 1, 1, 126, 32, 0, 173, 32, 1, 173, 66, 32, 134, 132, 32, 2, 173, 32, 3, 173, 66, 32, 134, 132, 128, 34, 4, 66, 32, 135, 167, 36, 0, 32, 4, 167, 11, 36, 1, 1, 126, 32, 0, 173, 32, 1, 173, 66, 32, 134, 132, 32, 2, 173, 32, 3, 173, 66, 32, 134, 132, 129, 34, 4, 66, 32, 135, 167, 36, 0, 32, 4, 167, 11, 36, 1, 1, 126, 32, 0, 173, 32, 1, 173, 66, 32, 134, 132, 32, 2, 173, 32, 3, 173, 66, 32, 134, 132, 130, 34, 4, 66, 32, 135, 167, 36, 0, 32, 4, 167, 11
  ])), {}).exports;
} catch (e) {
  // no wasm support :(
}

/**
 * Constructs a 64 bit two's-complement integer, given its low and high 32 bit values as *signed* integers.
 *  See the from* functions below for more convenient ways of constructing Longs.
 * @exports Long
 * @class A Long class for representing a 64 bit two's-complement integer value.
 * @param {number} low The low (signed) 32 bits of the long
 * @param {number} high The high (signed) 32 bits of the long
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @constructor
 */
function Long(low, high, unsigned) {

    /**
     * The low 32 bits as a signed value.
     * @type {number}
     */
    this.low = low | 0;

    /**
     * The high 32 bits as a signed value.
     * @type {number}
     */
    this.high = high | 0;

    /**
     * Whether unsigned or not.
     * @type {boolean}
     */
    this.unsigned = !!unsigned;
}

// The internal representation of a long is the two given signed, 32-bit values.
// We use 32-bit pieces because these are the size of integers on which
// Javascript performs bit-operations.  For operations like addition and
// multiplication, we split each number into 16 bit pieces, which can easily be
// multiplied within Javascript's floating-point representation without overflow
// or change in sign.
//
// In the algorithms below, we frequently reduce the negative case to the
// positive case by negating the input(s) and then post-processing the result.
// Note that we must ALWAYS check specially whether those values are MIN_VALUE
// (-2^63) because -MIN_VALUE == MIN_VALUE (since 2^63 cannot be represented as
// a positive number, it overflows back into a negative).  Not handling this
// case would often result in infinite recursion.
//
// Common constant values ZERO, ONE, NEG_ONE, etc. are defined below the from*
// methods on which they depend.

/**
 * An indicator used to reliably determine if an object is a Long or not.
 * @type {boolean}
 * @const
 * @private
 */
Long.prototype.__isLong__;

Object.defineProperty(Long.prototype, "__isLong__", { value: true });

/**
 * @function
 * @param {*} obj Object
 * @returns {boolean}
 * @inner
 */
function isLong(obj) {
    return (obj && obj["__isLong__"]) === true;
}

/**
 * Tests if the specified object is a Long.
 * @function
 * @param {*} obj Object
 * @returns {boolean}
 */
Long.isLong = isLong;

/**
 * A cache of the Long representations of small integer values.
 * @type {!Object}
 * @inner
 */
var INT_CACHE = {};

/**
 * A cache of the Long representations of small unsigned integer values.
 * @type {!Object}
 * @inner
 */
var UINT_CACHE = {};

/**
 * @param {number} value
 * @param {boolean=} unsigned
 * @returns {!Long}
 * @inner
 */
function fromInt(value, unsigned) {
    var obj, cachedObj, cache;
    if (unsigned) {
        value >>>= 0;
        if (cache = (0 <= value && value < 256)) {
            cachedObj = UINT_CACHE[value];
            if (cachedObj)
                return cachedObj;
        }
        obj = fromBits(value, (value | 0) < 0 ? -1 : 0, true);
        if (cache)
            UINT_CACHE[value] = obj;
        return obj;
    } else {
        value |= 0;
        if (cache = (-128 <= value && value < 128)) {
            cachedObj = INT_CACHE[value];
            if (cachedObj)
                return cachedObj;
        }
        obj = fromBits(value, value < 0 ? -1 : 0, false);
        if (cache)
            INT_CACHE[value] = obj;
        return obj;
    }
}

/**
 * Returns a Long representing the given 32 bit integer value.
 * @function
 * @param {number} value The 32 bit integer in question
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {!Long} The corresponding Long value
 */
Long.fromInt = fromInt;

/**
 * @param {number} value
 * @param {boolean=} unsigned
 * @returns {!Long}
 * @inner
 */
function fromNumber(value, unsigned) {
    if (isNaN(value))
        return unsigned ? UZERO : ZERO;
    if (unsigned) {
        if (value < 0)
            return UZERO;
        if (value >= TWO_PWR_64_DBL)
            return MAX_UNSIGNED_VALUE;
    } else {
        if (value <= -TWO_PWR_63_DBL)
            return MIN_VALUE;
        if (value + 1 >= TWO_PWR_63_DBL)
            return MAX_VALUE;
    }
    if (value < 0)
        return fromNumber(-value, unsigned).neg();
    return fromBits((value % TWO_PWR_32_DBL) | 0, (value / TWO_PWR_32_DBL) | 0, unsigned);
}

/**
 * Returns a Long representing the given value, provided that it is a finite number. Otherwise, zero is returned.
 * @function
 * @param {number} value The number in question
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {!Long} The corresponding Long value
 */
Long.fromNumber = fromNumber;

/**
 * @param {number} lowBits
 * @param {number} highBits
 * @param {boolean=} unsigned
 * @returns {!Long}
 * @inner
 */
function fromBits(lowBits, highBits, unsigned) {
    return new Long(lowBits, highBits, unsigned);
}

/**
 * Returns a Long representing the 64 bit integer that comes by concatenating the given low and high bits. Each is
 *  assumed to use 32 bits.
 * @function
 * @param {number} lowBits The low 32 bits
 * @param {number} highBits The high 32 bits
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {!Long} The corresponding Long value
 */
Long.fromBits = fromBits;

/**
 * @function
 * @param {number} base
 * @param {number} exponent
 * @returns {number}
 * @inner
 */
var pow_dbl = Math.pow; // Used 4 times (4*8 to 15+4)

/**
 * @param {string} str
 * @param {(boolean|number)=} unsigned
 * @param {number=} radix
 * @returns {!Long}
 * @inner
 */
function fromString(str, unsigned, radix) {
    if (str.length === 0)
        throw Error('empty string');
    if (str === "NaN" || str === "Infinity" || str === "+Infinity" || str === "-Infinity")
        return ZERO;
    if (typeof unsigned === 'number') {
        // For goog.math.long compatibility
        radix = unsigned,
        unsigned = false;
    } else {
        unsigned = !! unsigned;
    }
    radix = radix || 10;
    if (radix < 2 || 36 < radix)
        throw RangeError('radix');

    var p;
    if ((p = str.indexOf('-')) > 0)
        throw Error('interior hyphen');
    else if (p === 0) {
        return fromString(str.substring(1), unsigned, radix).neg();
    }

    // Do several (8) digits each time through the loop, so as to
    // minimize the calls to the very expensive emulated div.
    var radixToPower = fromNumber(pow_dbl(radix, 8));

    var result = ZERO;
    for (var i = 0; i < str.length; i += 8) {
        var size = Math.min(8, str.length - i),
            value = parseInt(str.substring(i, i + size), radix);
        if (size < 8) {
            var power = fromNumber(pow_dbl(radix, size));
            result = result.mul(power).add(fromNumber(value));
        } else {
            result = result.mul(radixToPower);
            result = result.add(fromNumber(value));
        }
    }
    result.unsigned = unsigned;
    return result;
}

/**
 * Returns a Long representation of the given string, written using the specified radix.
 * @function
 * @param {string} str The textual representation of the Long
 * @param {(boolean|number)=} unsigned Whether unsigned or not, defaults to signed
 * @param {number=} radix The radix in which the text is written (2-36), defaults to 10
 * @returns {!Long} The corresponding Long value
 */
Long.fromString = fromString;

/**
 * @function
 * @param {!Long|number|string|!{low: number, high: number, unsigned: boolean}} val
 * @param {boolean=} unsigned
 * @returns {!Long}
 * @inner
 */
function fromValue(val, unsigned) {
    if (typeof val === 'number')
        return fromNumber(val, unsigned);
    if (typeof val === 'string')
        return fromString(val, unsigned);
    // Throws for non-objects, converts non-instanceof Long:
    return fromBits(val.low, val.high, typeof unsigned === 'boolean' ? unsigned : val.unsigned);
}

/**
 * Converts the specified value to a Long using the appropriate from* function for its type.
 * @function
 * @param {!Long|number|string|!{low: number, high: number, unsigned: boolean}} val Value
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {!Long}
 */
Long.fromValue = fromValue;

// NOTE: the compiler should inline these constant values below and then remove these variables, so there should be
// no runtime penalty for these.

/**
 * @type {number}
 * @const
 * @inner
 */
var TWO_PWR_16_DBL = 1 << 16;

/**
 * @type {number}
 * @const
 * @inner
 */
var TWO_PWR_24_DBL = 1 << 24;

/**
 * @type {number}
 * @const
 * @inner
 */
var TWO_PWR_32_DBL = TWO_PWR_16_DBL * TWO_PWR_16_DBL;

/**
 * @type {number}
 * @const
 * @inner
 */
var TWO_PWR_64_DBL = TWO_PWR_32_DBL * TWO_PWR_32_DBL;

/**
 * @type {number}
 * @const
 * @inner
 */
var TWO_PWR_63_DBL = TWO_PWR_64_DBL / 2;

/**
 * @type {!Long}
 * @const
 * @inner
 */
var TWO_PWR_24 = fromInt(TWO_PWR_24_DBL);

/**
 * @type {!Long}
 * @inner
 */
var ZERO = fromInt(0);

/**
 * Signed zero.
 * @type {!Long}
 */
Long.ZERO = ZERO;

/**
 * @type {!Long}
 * @inner
 */
var UZERO = fromInt(0, true);

/**
 * Unsigned zero.
 * @type {!Long}
 */
Long.UZERO = UZERO;

/**
 * @type {!Long}
 * @inner
 */
var ONE = fromInt(1);

/**
 * Signed one.
 * @type {!Long}
 */
Long.ONE = ONE;

/**
 * @type {!Long}
 * @inner
 */
var UONE = fromInt(1, true);

/**
 * Unsigned one.
 * @type {!Long}
 */
Long.UONE = UONE;

/**
 * @type {!Long}
 * @inner
 */
var NEG_ONE = fromInt(-1);

/**
 * Signed negative one.
 * @type {!Long}
 */
Long.NEG_ONE = NEG_ONE;

/**
 * @type {!Long}
 * @inner
 */
var MAX_VALUE = fromBits(0xFFFFFFFF|0, 0x7FFFFFFF|0, false);

/**
 * Maximum signed value.
 * @type {!Long}
 */
Long.MAX_VALUE = MAX_VALUE;

/**
 * @type {!Long}
 * @inner
 */
var MAX_UNSIGNED_VALUE = fromBits(0xFFFFFFFF|0, 0xFFFFFFFF|0, true);

/**
 * Maximum unsigned value.
 * @type {!Long}
 */
Long.MAX_UNSIGNED_VALUE = MAX_UNSIGNED_VALUE;

/**
 * @type {!Long}
 * @inner
 */
var MIN_VALUE = fromBits(0, 0x80000000|0, false);

/**
 * Minimum signed value.
 * @type {!Long}
 */
Long.MIN_VALUE = MIN_VALUE;

/**
 * @alias Long.prototype
 * @inner
 */
var LongPrototype = Long.prototype;

/**
 * Converts the Long to a 32 bit integer, assuming it is a 32 bit integer.
 * @returns {number}
 */
LongPrototype.toInt = function toInt() {
    return this.unsigned ? this.low >>> 0 : this.low;
};

/**
 * Converts the Long to a the nearest floating-point representation of this value (double, 53 bit mantissa).
 * @returns {number}
 */
LongPrototype.toNumber = function toNumber() {
    if (this.unsigned)
        return ((this.high >>> 0) * TWO_PWR_32_DBL) + (this.low >>> 0);
    return this.high * TWO_PWR_32_DBL + (this.low >>> 0);
};

/**
 * Converts the Long to a string written in the specified radix.
 * @param {number=} radix Radix (2-36), defaults to 10
 * @returns {string}
 * @override
 * @throws {RangeError} If `radix` is out of range
 */
LongPrototype.toString = function toString(radix) {
    radix = radix || 10;
    if (radix < 2 || 36 < radix)
        throw RangeError('radix');
    if (this.isZero())
        return '0';
    if (this.isNegative()) { // Unsigned Longs are never negative
        if (this.eq(MIN_VALUE)) {
            // We need to change the Long value before it can be negated, so we remove
            // the bottom-most digit in this base and then recurse to do the rest.
            var radixLong = fromNumber(radix),
                div = this.div(radixLong),
                rem1 = div.mul(radixLong).sub(this);
            return div.toString(radix) + rem1.toInt().toString(radix);
        } else
            return '-' + this.neg().toString(radix);
    }

    // Do several (6) digits each time through the loop, so as to
    // minimize the calls to the very expensive emulated div.
    var radixToPower = fromNumber(pow_dbl(radix, 6), this.unsigned),
        rem = this;
    var result = '';
    while (true) {
        var remDiv = rem.div(radixToPower),
            intval = rem.sub(remDiv.mul(radixToPower)).toInt() >>> 0,
            digits = intval.toString(radix);
        rem = remDiv;
        if (rem.isZero())
            return digits + result;
        else {
            while (digits.length < 6)
                digits = '0' + digits;
            result = '' + digits + result;
        }
    }
};

/**
 * Gets the high 32 bits as a signed integer.
 * @returns {number} Signed high bits
 */
LongPrototype.getHighBits = function getHighBits() {
    return this.high;
};

/**
 * Gets the high 32 bits as an unsigned integer.
 * @returns {number} Unsigned high bits
 */
LongPrototype.getHighBitsUnsigned = function getHighBitsUnsigned() {
    return this.high >>> 0;
};

/**
 * Gets the low 32 bits as a signed integer.
 * @returns {number} Signed low bits
 */
LongPrototype.getLowBits = function getLowBits() {
    return this.low;
};

/**
 * Gets the low 32 bits as an unsigned integer.
 * @returns {number} Unsigned low bits
 */
LongPrototype.getLowBitsUnsigned = function getLowBitsUnsigned() {
    return this.low >>> 0;
};

/**
 * Gets the number of bits needed to represent the absolute value of this Long.
 * @returns {number}
 */
LongPrototype.getNumBitsAbs = function getNumBitsAbs() {
    if (this.isNegative()) // Unsigned Longs are never negative
        return this.eq(MIN_VALUE) ? 64 : this.neg().getNumBitsAbs();
    var val = this.high != 0 ? this.high : this.low;
    for (var bit = 31; bit > 0; bit--)
        if ((val & (1 << bit)) != 0)
            break;
    return this.high != 0 ? bit + 33 : bit + 1;
};

/**
 * Tests if this Long's value equals zero.
 * @returns {boolean}
 */
LongPrototype.isZero = function isZero() {
    return this.high === 0 && this.low === 0;
};

/**
 * Tests if this Long's value equals zero. This is an alias of {@link Long#isZero}.
 * @returns {boolean}
 */
LongPrototype.eqz = LongPrototype.isZero;

/**
 * Tests if this Long's value is negative.
 * @returns {boolean}
 */
LongPrototype.isNegative = function isNegative() {
    return !this.unsigned && this.high < 0;
};

/**
 * Tests if this Long's value is positive.
 * @returns {boolean}
 */
LongPrototype.isPositive = function isPositive() {
    return this.unsigned || this.high >= 0;
};

/**
 * Tests if this Long's value is odd.
 * @returns {boolean}
 */
LongPrototype.isOdd = function isOdd() {
    return (this.low & 1) === 1;
};

/**
 * Tests if this Long's value is even.
 * @returns {boolean}
 */
LongPrototype.isEven = function isEven() {
    return (this.low & 1) === 0;
};

/**
 * Tests if this Long's value equals the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */
LongPrototype.equals = function equals(other) {
    if (!isLong(other))
        other = fromValue(other);
    if (this.unsigned !== other.unsigned && (this.high >>> 31) === 1 && (other.high >>> 31) === 1)
        return false;
    return this.high === other.high && this.low === other.low;
};

/**
 * Tests if this Long's value equals the specified's. This is an alias of {@link Long#equals}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */
LongPrototype.eq = LongPrototype.equals;

/**
 * Tests if this Long's value differs from the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */
LongPrototype.notEquals = function notEquals(other) {
    return !this.eq(/* validates */ other);
};

/**
 * Tests if this Long's value differs from the specified's. This is an alias of {@link Long#notEquals}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */
LongPrototype.neq = LongPrototype.notEquals;

/**
 * Tests if this Long's value differs from the specified's. This is an alias of {@link Long#notEquals}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */
LongPrototype.ne = LongPrototype.notEquals;

/**
 * Tests if this Long's value is less than the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */
LongPrototype.lessThan = function lessThan(other) {
    return this.comp(/* validates */ other) < 0;
};

/**
 * Tests if this Long's value is less than the specified's. This is an alias of {@link Long#lessThan}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */
LongPrototype.lt = LongPrototype.lessThan;

/**
 * Tests if this Long's value is less than or equal the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */
LongPrototype.lessThanOrEqual = function lessThanOrEqual(other) {
    return this.comp(/* validates */ other) <= 0;
};

/**
 * Tests if this Long's value is less than or equal the specified's. This is an alias of {@link Long#lessThanOrEqual}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */
LongPrototype.lte = LongPrototype.lessThanOrEqual;

/**
 * Tests if this Long's value is less than or equal the specified's. This is an alias of {@link Long#lessThanOrEqual}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */
LongPrototype.le = LongPrototype.lessThanOrEqual;

/**
 * Tests if this Long's value is greater than the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */
LongPrototype.greaterThan = function greaterThan(other) {
    return this.comp(/* validates */ other) > 0;
};

/**
 * Tests if this Long's value is greater than the specified's. This is an alias of {@link Long#greaterThan}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */
LongPrototype.gt = LongPrototype.greaterThan;

/**
 * Tests if this Long's value is greater than or equal the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */
LongPrototype.greaterThanOrEqual = function greaterThanOrEqual(other) {
    return this.comp(/* validates */ other) >= 0;
};

/**
 * Tests if this Long's value is greater than or equal the specified's. This is an alias of {@link Long#greaterThanOrEqual}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */
LongPrototype.gte = LongPrototype.greaterThanOrEqual;

/**
 * Tests if this Long's value is greater than or equal the specified's. This is an alias of {@link Long#greaterThanOrEqual}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */
LongPrototype.ge = LongPrototype.greaterThanOrEqual;

/**
 * Compares this Long's value with the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {number} 0 if they are the same, 1 if the this is greater and -1
 *  if the given one is greater
 */
LongPrototype.compare = function compare(other) {
    if (!isLong(other))
        other = fromValue(other);
    if (this.eq(other))
        return 0;
    var thisNeg = this.isNegative(),
        otherNeg = other.isNegative();
    if (thisNeg && !otherNeg)
        return -1;
    if (!thisNeg && otherNeg)
        return 1;
    // At this point the sign bits are the same
    if (!this.unsigned)
        return this.sub(other).isNegative() ? -1 : 1;
    // Both are positive if at least one is unsigned
    return (other.high >>> 0) > (this.high >>> 0) || (other.high === this.high && (other.low >>> 0) > (this.low >>> 0)) ? -1 : 1;
};

/**
 * Compares this Long's value with the specified's. This is an alias of {@link Long#compare}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {number} 0 if they are the same, 1 if the this is greater and -1
 *  if the given one is greater
 */
LongPrototype.comp = LongPrototype.compare;

/**
 * Negates this Long's value.
 * @returns {!Long} Negated Long
 */
LongPrototype.negate = function negate() {
    if (!this.unsigned && this.eq(MIN_VALUE))
        return MIN_VALUE;
    return this.not().add(ONE);
};

/**
 * Negates this Long's value. This is an alias of {@link Long#negate}.
 * @function
 * @returns {!Long} Negated Long
 */
LongPrototype.neg = LongPrototype.negate;

/**
 * Returns the sum of this and the specified Long.
 * @param {!Long|number|string} addend Addend
 * @returns {!Long} Sum
 */
LongPrototype.add = function add(addend) {
    if (!isLong(addend))
        addend = fromValue(addend);

    // Divide each number into 4 chunks of 16 bits, and then sum the chunks.

    var a48 = this.high >>> 16;
    var a32 = this.high & 0xFFFF;
    var a16 = this.low >>> 16;
    var a00 = this.low & 0xFFFF;

    var b48 = addend.high >>> 16;
    var b32 = addend.high & 0xFFFF;
    var b16 = addend.low >>> 16;
    var b00 = addend.low & 0xFFFF;

    var c48 = 0, c32 = 0, c16 = 0, c00 = 0;
    c00 += a00 + b00;
    c16 += c00 >>> 16;
    c00 &= 0xFFFF;
    c16 += a16 + b16;
    c32 += c16 >>> 16;
    c16 &= 0xFFFF;
    c32 += a32 + b32;
    c48 += c32 >>> 16;
    c32 &= 0xFFFF;
    c48 += a48 + b48;
    c48 &= 0xFFFF;
    return fromBits((c16 << 16) | c00, (c48 << 16) | c32, this.unsigned);
};

/**
 * Returns the difference of this and the specified Long.
 * @param {!Long|number|string} subtrahend Subtrahend
 * @returns {!Long} Difference
 */
LongPrototype.subtract = function subtract(subtrahend) {
    if (!isLong(subtrahend))
        subtrahend = fromValue(subtrahend);
    return this.add(subtrahend.neg());
};

/**
 * Returns the difference of this and the specified Long. This is an alias of {@link Long#subtract}.
 * @function
 * @param {!Long|number|string} subtrahend Subtrahend
 * @returns {!Long} Difference
 */
LongPrototype.sub = LongPrototype.subtract;

/**
 * Returns the product of this and the specified Long.
 * @param {!Long|number|string} multiplier Multiplier
 * @returns {!Long} Product
 */
LongPrototype.multiply = function multiply(multiplier) {
    if (this.isZero())
        return ZERO;
    if (!isLong(multiplier))
        multiplier = fromValue(multiplier);

    // use wasm support if present
    if (wasm) {
        var low = wasm.mul(this.low,
                           this.high,
                           multiplier.low,
                           multiplier.high);
        return fromBits(low, wasm.get_high(), this.unsigned);
    }

    if (multiplier.isZero())
        return ZERO;
    if (this.eq(MIN_VALUE))
        return multiplier.isOdd() ? MIN_VALUE : ZERO;
    if (multiplier.eq(MIN_VALUE))
        return this.isOdd() ? MIN_VALUE : ZERO;

    if (this.isNegative()) {
        if (multiplier.isNegative())
            return this.neg().mul(multiplier.neg());
        else
            return this.neg().mul(multiplier).neg();
    } else if (multiplier.isNegative())
        return this.mul(multiplier.neg()).neg();

    // If both longs are small, use float multiplication
    if (this.lt(TWO_PWR_24) && multiplier.lt(TWO_PWR_24))
        return fromNumber(this.toNumber() * multiplier.toNumber(), this.unsigned);

    // Divide each long into 4 chunks of 16 bits, and then add up 4x4 products.
    // We can skip products that would overflow.

    var a48 = this.high >>> 16;
    var a32 = this.high & 0xFFFF;
    var a16 = this.low >>> 16;
    var a00 = this.low & 0xFFFF;

    var b48 = multiplier.high >>> 16;
    var b32 = multiplier.high & 0xFFFF;
    var b16 = multiplier.low >>> 16;
    var b00 = multiplier.low & 0xFFFF;

    var c48 = 0, c32 = 0, c16 = 0, c00 = 0;
    c00 += a00 * b00;
    c16 += c00 >>> 16;
    c00 &= 0xFFFF;
    c16 += a16 * b00;
    c32 += c16 >>> 16;
    c16 &= 0xFFFF;
    c16 += a00 * b16;
    c32 += c16 >>> 16;
    c16 &= 0xFFFF;
    c32 += a32 * b00;
    c48 += c32 >>> 16;
    c32 &= 0xFFFF;
    c32 += a16 * b16;
    c48 += c32 >>> 16;
    c32 &= 0xFFFF;
    c32 += a00 * b32;
    c48 += c32 >>> 16;
    c32 &= 0xFFFF;
    c48 += a48 * b00 + a32 * b16 + a16 * b32 + a00 * b48;
    c48 &= 0xFFFF;
    return fromBits((c16 << 16) | c00, (c48 << 16) | c32, this.unsigned);
};

/**
 * Returns the product of this and the specified Long. This is an alias of {@link Long#multiply}.
 * @function
 * @param {!Long|number|string} multiplier Multiplier
 * @returns {!Long} Product
 */
LongPrototype.mul = LongPrototype.multiply;

/**
 * Returns this Long divided by the specified. The result is signed if this Long is signed or
 *  unsigned if this Long is unsigned.
 * @param {!Long|number|string} divisor Divisor
 * @returns {!Long} Quotient
 */
LongPrototype.divide = function divide(divisor) {
    if (!isLong(divisor))
        divisor = fromValue(divisor);
    if (divisor.isZero())
        throw Error('division by zero');

    // use wasm support if present
    if (wasm) {
        // guard against signed division overflow: the largest
        // negative number / -1 would be 1 larger than the largest
        // positive number, due to two's complement.
        if (!this.unsigned &&
            this.high === -0x80000000 &&
            divisor.low === -1 && divisor.high === -1) {
            // be consistent with non-wasm code path
            return this;
        }
        var low = (this.unsigned ? wasm.div_u : wasm.div_s)(
            this.low,
            this.high,
            divisor.low,
            divisor.high
        );
        return fromBits(low, wasm.get_high(), this.unsigned);
    }

    if (this.isZero())
        return this.unsigned ? UZERO : ZERO;
    var approx, rem, res;
    if (!this.unsigned) {
        // This section is only relevant for signed longs and is derived from the
        // closure library as a whole.
        if (this.eq(MIN_VALUE)) {
            if (divisor.eq(ONE) || divisor.eq(NEG_ONE))
                return MIN_VALUE;  // recall that -MIN_VALUE == MIN_VALUE
            else if (divisor.eq(MIN_VALUE))
                return ONE;
            else {
                // At this point, we have |other| >= 2, so |this/other| < |MIN_VALUE|.
                var halfThis = this.shr(1);
                approx = halfThis.div(divisor).shl(1);
                if (approx.eq(ZERO)) {
                    return divisor.isNegative() ? ONE : NEG_ONE;
                } else {
                    rem = this.sub(divisor.mul(approx));
                    res = approx.add(rem.div(divisor));
                    return res;
                }
            }
        } else if (divisor.eq(MIN_VALUE))
            return this.unsigned ? UZERO : ZERO;
        if (this.isNegative()) {
            if (divisor.isNegative())
                return this.neg().div(divisor.neg());
            return this.neg().div(divisor).neg();
        } else if (divisor.isNegative())
            return this.div(divisor.neg()).neg();
        res = ZERO;
    } else {
        // The algorithm below has not been made for unsigned longs. It's therefore
        // required to take special care of the MSB prior to running it.
        if (!divisor.unsigned)
            divisor = divisor.toUnsigned();
        if (divisor.gt(this))
            return UZERO;
        if (divisor.gt(this.shru(1))) // 15 >>> 1 = 7 ; with divisor = 8 ; true
            return UONE;
        res = UZERO;
    }

    // Repeat the following until the remainder is less than other:  find a
    // floating-point that approximates remainder / other *from below*, add this
    // into the result, and subtract it from the remainder.  It is critical that
    // the approximate value is less than or equal to the real value so that the
    // remainder never becomes negative.
    rem = this;
    while (rem.gte(divisor)) {
        // Approximate the result of division. This may be a little greater or
        // smaller than the actual value.
        approx = Math.max(1, Math.floor(rem.toNumber() / divisor.toNumber()));

        // We will tweak the approximate result by changing it in the 48-th digit or
        // the smallest non-fractional digit, whichever is larger.
        var log2 = Math.ceil(Math.log(approx) / Math.LN2),
            delta = (log2 <= 48) ? 1 : pow_dbl(2, log2 - 48),

        // Decrease the approximation until it is smaller than the remainder.  Note
        // that if it is too large, the product overflows and is negative.
            approxRes = fromNumber(approx),
            approxRem = approxRes.mul(divisor);
        while (approxRem.isNegative() || approxRem.gt(rem)) {
            approx -= delta;
            approxRes = fromNumber(approx, this.unsigned);
            approxRem = approxRes.mul(divisor);
        }

        // We know the answer can't be zero... and actually, zero would cause
        // infinite recursion since we would make no progress.
        if (approxRes.isZero())
            approxRes = ONE;

        res = res.add(approxRes);
        rem = rem.sub(approxRem);
    }
    return res;
};

/**
 * Returns this Long divided by the specified. This is an alias of {@link Long#divide}.
 * @function
 * @param {!Long|number|string} divisor Divisor
 * @returns {!Long} Quotient
 */
LongPrototype.div = LongPrototype.divide;

/**
 * Returns this Long modulo the specified.
 * @param {!Long|number|string} divisor Divisor
 * @returns {!Long} Remainder
 */
LongPrototype.modulo = function modulo(divisor) {
    if (!isLong(divisor))
        divisor = fromValue(divisor);

    // use wasm support if present
    if (wasm) {
        var low = (this.unsigned ? wasm.rem_u : wasm.rem_s)(
            this.low,
            this.high,
            divisor.low,
            divisor.high
        );
        return fromBits(low, wasm.get_high(), this.unsigned);
    }

    return this.sub(this.div(divisor).mul(divisor));
};

/**
 * Returns this Long modulo the specified. This is an alias of {@link Long#modulo}.
 * @function
 * @param {!Long|number|string} divisor Divisor
 * @returns {!Long} Remainder
 */
LongPrototype.mod = LongPrototype.modulo;

/**
 * Returns this Long modulo the specified. This is an alias of {@link Long#modulo}.
 * @function
 * @param {!Long|number|string} divisor Divisor
 * @returns {!Long} Remainder
 */
LongPrototype.rem = LongPrototype.modulo;

/**
 * Returns the bitwise NOT of this Long.
 * @returns {!Long}
 */
LongPrototype.not = function not() {
    return fromBits(~this.low, ~this.high, this.unsigned);
};

/**
 * Returns the bitwise AND of this Long and the specified.
 * @param {!Long|number|string} other Other Long
 * @returns {!Long}
 */
LongPrototype.and = function and(other) {
    if (!isLong(other))
        other = fromValue(other);
    return fromBits(this.low & other.low, this.high & other.high, this.unsigned);
};

/**
 * Returns the bitwise OR of this Long and the specified.
 * @param {!Long|number|string} other Other Long
 * @returns {!Long}
 */
LongPrototype.or = function or(other) {
    if (!isLong(other))
        other = fromValue(other);
    return fromBits(this.low | other.low, this.high | other.high, this.unsigned);
};

/**
 * Returns the bitwise XOR of this Long and the given one.
 * @param {!Long|number|string} other Other Long
 * @returns {!Long}
 */
LongPrototype.xor = function xor(other) {
    if (!isLong(other))
        other = fromValue(other);
    return fromBits(this.low ^ other.low, this.high ^ other.high, this.unsigned);
};

/**
 * Returns this Long with bits shifted to the left by the given amount.
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */
LongPrototype.shiftLeft = function shiftLeft(numBits) {
    if (isLong(numBits))
        numBits = numBits.toInt();
    if ((numBits &= 63) === 0)
        return this;
    else if (numBits < 32)
        return fromBits(this.low << numBits, (this.high << numBits) | (this.low >>> (32 - numBits)), this.unsigned);
    else
        return fromBits(0, this.low << (numBits - 32), this.unsigned);
};

/**
 * Returns this Long with bits shifted to the left by the given amount. This is an alias of {@link Long#shiftLeft}.
 * @function
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */
LongPrototype.shl = LongPrototype.shiftLeft;

/**
 * Returns this Long with bits arithmetically shifted to the right by the given amount.
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */
LongPrototype.shiftRight = function shiftRight(numBits) {
    if (isLong(numBits))
        numBits = numBits.toInt();
    if ((numBits &= 63) === 0)
        return this;
    else if (numBits < 32)
        return fromBits((this.low >>> numBits) | (this.high << (32 - numBits)), this.high >> numBits, this.unsigned);
    else
        return fromBits(this.high >> (numBits - 32), this.high >= 0 ? 0 : -1, this.unsigned);
};

/**
 * Returns this Long with bits arithmetically shifted to the right by the given amount. This is an alias of {@link Long#shiftRight}.
 * @function
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */
LongPrototype.shr = LongPrototype.shiftRight;

/**
 * Returns this Long with bits logically shifted to the right by the given amount.
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */
LongPrototype.shiftRightUnsigned = function shiftRightUnsigned(numBits) {
    if (isLong(numBits))
        numBits = numBits.toInt();
    numBits &= 63;
    if (numBits === 0)
        return this;
    else {
        var high = this.high;
        if (numBits < 32) {
            var low = this.low;
            return fromBits((low >>> numBits) | (high << (32 - numBits)), high >>> numBits, this.unsigned);
        } else if (numBits === 32)
            return fromBits(high, 0, this.unsigned);
        else
            return fromBits(high >>> (numBits - 32), 0, this.unsigned);
    }
};

/**
 * Returns this Long with bits logically shifted to the right by the given amount. This is an alias of {@link Long#shiftRightUnsigned}.
 * @function
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */
LongPrototype.shru = LongPrototype.shiftRightUnsigned;

/**
 * Returns this Long with bits logically shifted to the right by the given amount. This is an alias of {@link Long#shiftRightUnsigned}.
 * @function
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */
LongPrototype.shr_u = LongPrototype.shiftRightUnsigned;

/**
 * Converts this Long to signed.
 * @returns {!Long} Signed long
 */
LongPrototype.toSigned = function toSigned() {
    if (!this.unsigned)
        return this;
    return fromBits(this.low, this.high, false);
};

/**
 * Converts this Long to unsigned.
 * @returns {!Long} Unsigned long
 */
LongPrototype.toUnsigned = function toUnsigned() {
    if (this.unsigned)
        return this;
    return fromBits(this.low, this.high, true);
};

/**
 * Converts this Long to its byte representation.
 * @param {boolean=} le Whether little or big endian, defaults to big endian
 * @returns {!Array.<number>} Byte representation
 */
LongPrototype.toBytes = function toBytes(le) {
    return le ? this.toBytesLE() : this.toBytesBE();
};

/**
 * Converts this Long to its little endian byte representation.
 * @returns {!Array.<number>} Little endian byte representation
 */
LongPrototype.toBytesLE = function toBytesLE() {
    var hi = this.high,
        lo = this.low;
    return [
        lo        & 0xff,
        lo >>>  8 & 0xff,
        lo >>> 16 & 0xff,
        lo >>> 24       ,
        hi        & 0xff,
        hi >>>  8 & 0xff,
        hi >>> 16 & 0xff,
        hi >>> 24
    ];
};

/**
 * Converts this Long to its big endian byte representation.
 * @returns {!Array.<number>} Big endian byte representation
 */
LongPrototype.toBytesBE = function toBytesBE() {
    var hi = this.high,
        lo = this.low;
    return [
        hi >>> 24       ,
        hi >>> 16 & 0xff,
        hi >>>  8 & 0xff,
        hi        & 0xff,
        lo >>> 24       ,
        lo >>> 16 & 0xff,
        lo >>>  8 & 0xff,
        lo        & 0xff
    ];
};

/**
 * Creates a Long from its byte representation.
 * @param {!Array.<number>} bytes Byte representation
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @param {boolean=} le Whether little or big endian, defaults to big endian
 * @returns {Long} The corresponding Long value
 */
Long.fromBytes = function fromBytes(bytes, unsigned, le) {
    return le ? Long.fromBytesLE(bytes, unsigned) : Long.fromBytesBE(bytes, unsigned);
};

/**
 * Creates a Long from its little endian byte representation.
 * @param {!Array.<number>} bytes Little endian byte representation
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {Long} The corresponding Long value
 */
Long.fromBytesLE = function fromBytesLE(bytes, unsigned) {
    return new Long(
        bytes[0]       |
        bytes[1] <<  8 |
        bytes[2] << 16 |
        bytes[3] << 24,
        bytes[4]       |
        bytes[5] <<  8 |
        bytes[6] << 16 |
        bytes[7] << 24,
        unsigned
    );
};

/**
 * Creates a Long from its big endian byte representation.
 * @param {!Array.<number>} bytes Big endian byte representation
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {Long} The corresponding Long value
 */
Long.fromBytesBE = function fromBytesBE(bytes, unsigned) {
    return new Long(
        bytes[4] << 24 |
        bytes[5] << 16 |
        bytes[6] <<  8 |
        bytes[7],
        bytes[0] << 24 |
        bytes[1] << 16 |
        bytes[2] <<  8 |
        bytes[3],
        unsigned
    );
};


/***/ }),

/***/ 6179:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Event = exports.LastCommitInfo = exports.BlockParams = exports.ConsensusParams = exports.ResponseApplySnapshotChunk = exports.ResponseLoadSnapshotChunk = exports.ResponseOfferSnapshot = exports.ResponseListSnapshots = exports.ResponseCommit = exports.ResponseEndBlock = exports.ResponseDeliverTx = exports.ResponseCheckTx = exports.ResponseBeginBlock = exports.ResponseQuery = exports.ResponseInitChain = exports.ResponseSetOption = exports.ResponseInfo = exports.ResponseFlush = exports.ResponseEcho = exports.ResponseException = exports.Response = exports.RequestApplySnapshotChunk = exports.RequestLoadSnapshotChunk = exports.RequestOfferSnapshot = exports.RequestListSnapshots = exports.RequestCommit = exports.RequestEndBlock = exports.RequestDeliverTx = exports.RequestCheckTx = exports.RequestBeginBlock = exports.RequestQuery = exports.RequestInitChain = exports.RequestSetOption = exports.RequestInfo = exports.RequestFlush = exports.RequestEcho = exports.Request = exports.responseApplySnapshotChunk_ResultToJSON = exports.responseApplySnapshotChunk_ResultFromJSON = exports.ResponseApplySnapshotChunk_Result = exports.responseOfferSnapshot_ResultToJSON = exports.responseOfferSnapshot_ResultFromJSON = exports.ResponseOfferSnapshot_Result = exports.evidenceTypeToJSON = exports.evidenceTypeFromJSON = exports.EvidenceType = exports.checkTxTypeToJSON = exports.checkTxTypeFromJSON = exports.CheckTxType = exports.protobufPackage = void 0;
exports.ABCIApplicationClientImpl = exports.Snapshot = exports.Evidence = exports.VoteInfo = exports.ValidatorUpdate = exports.Validator = exports.TxResult = exports.EventAttribute = void 0;
/* eslint-disable */
const long_1 = __importDefault(__webpack_require__(47873));
const minimal_1 = __importDefault(__webpack_require__(62100));
const timestamp_1 = __webpack_require__(76620);
const keys_1 = __webpack_require__(54568);
const proof_1 = __webpack_require__(60730);
const params_1 = __webpack_require__(44179);
const types_1 = __webpack_require__(54028);
exports.protobufPackage = "tendermint.abci";
var CheckTxType;
(function (CheckTxType) {
    CheckTxType[CheckTxType["NEW"] = 0] = "NEW";
    CheckTxType[CheckTxType["RECHECK"] = 1] = "RECHECK";
    CheckTxType[CheckTxType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(CheckTxType = exports.CheckTxType || (exports.CheckTxType = {}));
function checkTxTypeFromJSON(object) {
    switch (object) {
        case 0:
        case "NEW":
            return CheckTxType.NEW;
        case 1:
        case "RECHECK":
            return CheckTxType.RECHECK;
        case -1:
        case "UNRECOGNIZED":
        default:
            return CheckTxType.UNRECOGNIZED;
    }
}
exports.checkTxTypeFromJSON = checkTxTypeFromJSON;
function checkTxTypeToJSON(object) {
    switch (object) {
        case CheckTxType.NEW:
            return "NEW";
        case CheckTxType.RECHECK:
            return "RECHECK";
        case CheckTxType.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.checkTxTypeToJSON = checkTxTypeToJSON;
var EvidenceType;
(function (EvidenceType) {
    EvidenceType[EvidenceType["UNKNOWN"] = 0] = "UNKNOWN";
    EvidenceType[EvidenceType["DUPLICATE_VOTE"] = 1] = "DUPLICATE_VOTE";
    EvidenceType[EvidenceType["LIGHT_CLIENT_ATTACK"] = 2] = "LIGHT_CLIENT_ATTACK";
    EvidenceType[EvidenceType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(EvidenceType = exports.EvidenceType || (exports.EvidenceType = {}));
function evidenceTypeFromJSON(object) {
    switch (object) {
        case 0:
        case "UNKNOWN":
            return EvidenceType.UNKNOWN;
        case 1:
        case "DUPLICATE_VOTE":
            return EvidenceType.DUPLICATE_VOTE;
        case 2:
        case "LIGHT_CLIENT_ATTACK":
            return EvidenceType.LIGHT_CLIENT_ATTACK;
        case -1:
        case "UNRECOGNIZED":
        default:
            return EvidenceType.UNRECOGNIZED;
    }
}
exports.evidenceTypeFromJSON = evidenceTypeFromJSON;
function evidenceTypeToJSON(object) {
    switch (object) {
        case EvidenceType.UNKNOWN:
            return "UNKNOWN";
        case EvidenceType.DUPLICATE_VOTE:
            return "DUPLICATE_VOTE";
        case EvidenceType.LIGHT_CLIENT_ATTACK:
            return "LIGHT_CLIENT_ATTACK";
        case EvidenceType.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.evidenceTypeToJSON = evidenceTypeToJSON;
var ResponseOfferSnapshot_Result;
(function (ResponseOfferSnapshot_Result) {
    /** UNKNOWN - Unknown result, abort all snapshot restoration */
    ResponseOfferSnapshot_Result[ResponseOfferSnapshot_Result["UNKNOWN"] = 0] = "UNKNOWN";
    /** ACCEPT - Snapshot accepted, apply chunks */
    ResponseOfferSnapshot_Result[ResponseOfferSnapshot_Result["ACCEPT"] = 1] = "ACCEPT";
    /** ABORT - Abort all snapshot restoration */
    ResponseOfferSnapshot_Result[ResponseOfferSnapshot_Result["ABORT"] = 2] = "ABORT";
    /** REJECT - Reject this specific snapshot, try others */
    ResponseOfferSnapshot_Result[ResponseOfferSnapshot_Result["REJECT"] = 3] = "REJECT";
    /** REJECT_FORMAT - Reject all snapshots of this format, try others */
    ResponseOfferSnapshot_Result[ResponseOfferSnapshot_Result["REJECT_FORMAT"] = 4] = "REJECT_FORMAT";
    /** REJECT_SENDER - Reject all snapshots from the sender(s), try others */
    ResponseOfferSnapshot_Result[ResponseOfferSnapshot_Result["REJECT_SENDER"] = 5] = "REJECT_SENDER";
    ResponseOfferSnapshot_Result[ResponseOfferSnapshot_Result["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(ResponseOfferSnapshot_Result = exports.ResponseOfferSnapshot_Result || (exports.ResponseOfferSnapshot_Result = {}));
function responseOfferSnapshot_ResultFromJSON(object) {
    switch (object) {
        case 0:
        case "UNKNOWN":
            return ResponseOfferSnapshot_Result.UNKNOWN;
        case 1:
        case "ACCEPT":
            return ResponseOfferSnapshot_Result.ACCEPT;
        case 2:
        case "ABORT":
            return ResponseOfferSnapshot_Result.ABORT;
        case 3:
        case "REJECT":
            return ResponseOfferSnapshot_Result.REJECT;
        case 4:
        case "REJECT_FORMAT":
            return ResponseOfferSnapshot_Result.REJECT_FORMAT;
        case 5:
        case "REJECT_SENDER":
            return ResponseOfferSnapshot_Result.REJECT_SENDER;
        case -1:
        case "UNRECOGNIZED":
        default:
            return ResponseOfferSnapshot_Result.UNRECOGNIZED;
    }
}
exports.responseOfferSnapshot_ResultFromJSON = responseOfferSnapshot_ResultFromJSON;
function responseOfferSnapshot_ResultToJSON(object) {
    switch (object) {
        case ResponseOfferSnapshot_Result.UNKNOWN:
            return "UNKNOWN";
        case ResponseOfferSnapshot_Result.ACCEPT:
            return "ACCEPT";
        case ResponseOfferSnapshot_Result.ABORT:
            return "ABORT";
        case ResponseOfferSnapshot_Result.REJECT:
            return "REJECT";
        case ResponseOfferSnapshot_Result.REJECT_FORMAT:
            return "REJECT_FORMAT";
        case ResponseOfferSnapshot_Result.REJECT_SENDER:
            return "REJECT_SENDER";
        case ResponseOfferSnapshot_Result.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.responseOfferSnapshot_ResultToJSON = responseOfferSnapshot_ResultToJSON;
var ResponseApplySnapshotChunk_Result;
(function (ResponseApplySnapshotChunk_Result) {
    /** UNKNOWN - Unknown result, abort all snapshot restoration */
    ResponseApplySnapshotChunk_Result[ResponseApplySnapshotChunk_Result["UNKNOWN"] = 0] = "UNKNOWN";
    /** ACCEPT - Chunk successfully accepted */
    ResponseApplySnapshotChunk_Result[ResponseApplySnapshotChunk_Result["ACCEPT"] = 1] = "ACCEPT";
    /** ABORT - Abort all snapshot restoration */
    ResponseApplySnapshotChunk_Result[ResponseApplySnapshotChunk_Result["ABORT"] = 2] = "ABORT";
    /** RETRY - Retry chunk (combine with refetch and reject) */
    ResponseApplySnapshotChunk_Result[ResponseApplySnapshotChunk_Result["RETRY"] = 3] = "RETRY";
    /** RETRY_SNAPSHOT - Retry snapshot (combine with refetch and reject) */
    ResponseApplySnapshotChunk_Result[ResponseApplySnapshotChunk_Result["RETRY_SNAPSHOT"] = 4] = "RETRY_SNAPSHOT";
    /** REJECT_SNAPSHOT - Reject this snapshot, try others */
    ResponseApplySnapshotChunk_Result[ResponseApplySnapshotChunk_Result["REJECT_SNAPSHOT"] = 5] = "REJECT_SNAPSHOT";
    ResponseApplySnapshotChunk_Result[ResponseApplySnapshotChunk_Result["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(ResponseApplySnapshotChunk_Result = exports.ResponseApplySnapshotChunk_Result || (exports.ResponseApplySnapshotChunk_Result = {}));
function responseApplySnapshotChunk_ResultFromJSON(object) {
    switch (object) {
        case 0:
        case "UNKNOWN":
            return ResponseApplySnapshotChunk_Result.UNKNOWN;
        case 1:
        case "ACCEPT":
            return ResponseApplySnapshotChunk_Result.ACCEPT;
        case 2:
        case "ABORT":
            return ResponseApplySnapshotChunk_Result.ABORT;
        case 3:
        case "RETRY":
            return ResponseApplySnapshotChunk_Result.RETRY;
        case 4:
        case "RETRY_SNAPSHOT":
            return ResponseApplySnapshotChunk_Result.RETRY_SNAPSHOT;
        case 5:
        case "REJECT_SNAPSHOT":
            return ResponseApplySnapshotChunk_Result.REJECT_SNAPSHOT;
        case -1:
        case "UNRECOGNIZED":
        default:
            return ResponseApplySnapshotChunk_Result.UNRECOGNIZED;
    }
}
exports.responseApplySnapshotChunk_ResultFromJSON = responseApplySnapshotChunk_ResultFromJSON;
function responseApplySnapshotChunk_ResultToJSON(object) {
    switch (object) {
        case ResponseApplySnapshotChunk_Result.UNKNOWN:
            return "UNKNOWN";
        case ResponseApplySnapshotChunk_Result.ACCEPT:
            return "ACCEPT";
        case ResponseApplySnapshotChunk_Result.ABORT:
            return "ABORT";
        case ResponseApplySnapshotChunk_Result.RETRY:
            return "RETRY";
        case ResponseApplySnapshotChunk_Result.RETRY_SNAPSHOT:
            return "RETRY_SNAPSHOT";
        case ResponseApplySnapshotChunk_Result.REJECT_SNAPSHOT:
            return "REJECT_SNAPSHOT";
        case ResponseApplySnapshotChunk_Result.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.responseApplySnapshotChunk_ResultToJSON = responseApplySnapshotChunk_ResultToJSON;
function createBaseRequest() {
    return {
        echo: undefined,
        flush: undefined,
        info: undefined,
        setOption: undefined,
        initChain: undefined,
        query: undefined,
        beginBlock: undefined,
        checkTx: undefined,
        deliverTx: undefined,
        endBlock: undefined,
        commit: undefined,
        listSnapshots: undefined,
        offerSnapshot: undefined,
        loadSnapshotChunk: undefined,
        applySnapshotChunk: undefined,
    };
}
exports.Request = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.echo !== undefined) {
            exports.RequestEcho.encode(message.echo, writer.uint32(10).fork()).ldelim();
        }
        if (message.flush !== undefined) {
            exports.RequestFlush.encode(message.flush, writer.uint32(18).fork()).ldelim();
        }
        if (message.info !== undefined) {
            exports.RequestInfo.encode(message.info, writer.uint32(26).fork()).ldelim();
        }
        if (message.setOption !== undefined) {
            exports.RequestSetOption.encode(message.setOption, writer.uint32(34).fork()).ldelim();
        }
        if (message.initChain !== undefined) {
            exports.RequestInitChain.encode(message.initChain, writer.uint32(42).fork()).ldelim();
        }
        if (message.query !== undefined) {
            exports.RequestQuery.encode(message.query, writer.uint32(50).fork()).ldelim();
        }
        if (message.beginBlock !== undefined) {
            exports.RequestBeginBlock.encode(message.beginBlock, writer.uint32(58).fork()).ldelim();
        }
        if (message.checkTx !== undefined) {
            exports.RequestCheckTx.encode(message.checkTx, writer.uint32(66).fork()).ldelim();
        }
        if (message.deliverTx !== undefined) {
            exports.RequestDeliverTx.encode(message.deliverTx, writer.uint32(74).fork()).ldelim();
        }
        if (message.endBlock !== undefined) {
            exports.RequestEndBlock.encode(message.endBlock, writer.uint32(82).fork()).ldelim();
        }
        if (message.commit !== undefined) {
            exports.RequestCommit.encode(message.commit, writer.uint32(90).fork()).ldelim();
        }
        if (message.listSnapshots !== undefined) {
            exports.RequestListSnapshots.encode(message.listSnapshots, writer.uint32(98).fork()).ldelim();
        }
        if (message.offerSnapshot !== undefined) {
            exports.RequestOfferSnapshot.encode(message.offerSnapshot, writer.uint32(106).fork()).ldelim();
        }
        if (message.loadSnapshotChunk !== undefined) {
            exports.RequestLoadSnapshotChunk.encode(message.loadSnapshotChunk, writer.uint32(114).fork()).ldelim();
        }
        if (message.applySnapshotChunk !== undefined) {
            exports.RequestApplySnapshotChunk.encode(message.applySnapshotChunk, writer.uint32(122).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.echo = exports.RequestEcho.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.flush = exports.RequestFlush.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.info = exports.RequestInfo.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.setOption = exports.RequestSetOption.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.initChain = exports.RequestInitChain.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.query = exports.RequestQuery.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.beginBlock = exports.RequestBeginBlock.decode(reader, reader.uint32());
                    break;
                case 8:
                    message.checkTx = exports.RequestCheckTx.decode(reader, reader.uint32());
                    break;
                case 9:
                    message.deliverTx = exports.RequestDeliverTx.decode(reader, reader.uint32());
                    break;
                case 10:
                    message.endBlock = exports.RequestEndBlock.decode(reader, reader.uint32());
                    break;
                case 11:
                    message.commit = exports.RequestCommit.decode(reader, reader.uint32());
                    break;
                case 12:
                    message.listSnapshots = exports.RequestListSnapshots.decode(reader, reader.uint32());
                    break;
                case 13:
                    message.offerSnapshot = exports.RequestOfferSnapshot.decode(reader, reader.uint32());
                    break;
                case 14:
                    message.loadSnapshotChunk = exports.RequestLoadSnapshotChunk.decode(reader, reader.uint32());
                    break;
                case 15:
                    message.applySnapshotChunk = exports.RequestApplySnapshotChunk.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            echo: isSet(object.echo) ? exports.RequestEcho.fromJSON(object.echo) : undefined,
            flush: isSet(object.flush) ? exports.RequestFlush.fromJSON(object.flush) : undefined,
            info: isSet(object.info) ? exports.RequestInfo.fromJSON(object.info) : undefined,
            setOption: isSet(object.setOption) ? exports.RequestSetOption.fromJSON(object.setOption) : undefined,
            initChain: isSet(object.initChain) ? exports.RequestInitChain.fromJSON(object.initChain) : undefined,
            query: isSet(object.query) ? exports.RequestQuery.fromJSON(object.query) : undefined,
            beginBlock: isSet(object.beginBlock) ? exports.RequestBeginBlock.fromJSON(object.beginBlock) : undefined,
            checkTx: isSet(object.checkTx) ? exports.RequestCheckTx.fromJSON(object.checkTx) : undefined,
            deliverTx: isSet(object.deliverTx) ? exports.RequestDeliverTx.fromJSON(object.deliverTx) : undefined,
            endBlock: isSet(object.endBlock) ? exports.RequestEndBlock.fromJSON(object.endBlock) : undefined,
            commit: isSet(object.commit) ? exports.RequestCommit.fromJSON(object.commit) : undefined,
            listSnapshots: isSet(object.listSnapshots)
                ? exports.RequestListSnapshots.fromJSON(object.listSnapshots)
                : undefined,
            offerSnapshot: isSet(object.offerSnapshot)
                ? exports.RequestOfferSnapshot.fromJSON(object.offerSnapshot)
                : undefined,
            loadSnapshotChunk: isSet(object.loadSnapshotChunk)
                ? exports.RequestLoadSnapshotChunk.fromJSON(object.loadSnapshotChunk)
                : undefined,
            applySnapshotChunk: isSet(object.applySnapshotChunk)
                ? exports.RequestApplySnapshotChunk.fromJSON(object.applySnapshotChunk)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.echo !== undefined && (obj.echo = message.echo ? exports.RequestEcho.toJSON(message.echo) : undefined);
        message.flush !== undefined &&
            (obj.flush = message.flush ? exports.RequestFlush.toJSON(message.flush) : undefined);
        message.info !== undefined && (obj.info = message.info ? exports.RequestInfo.toJSON(message.info) : undefined);
        message.setOption !== undefined &&
            (obj.setOption = message.setOption ? exports.RequestSetOption.toJSON(message.setOption) : undefined);
        message.initChain !== undefined &&
            (obj.initChain = message.initChain ? exports.RequestInitChain.toJSON(message.initChain) : undefined);
        message.query !== undefined &&
            (obj.query = message.query ? exports.RequestQuery.toJSON(message.query) : undefined);
        message.beginBlock !== undefined &&
            (obj.beginBlock = message.beginBlock ? exports.RequestBeginBlock.toJSON(message.beginBlock) : undefined);
        message.checkTx !== undefined &&
            (obj.checkTx = message.checkTx ? exports.RequestCheckTx.toJSON(message.checkTx) : undefined);
        message.deliverTx !== undefined &&
            (obj.deliverTx = message.deliverTx ? exports.RequestDeliverTx.toJSON(message.deliverTx) : undefined);
        message.endBlock !== undefined &&
            (obj.endBlock = message.endBlock ? exports.RequestEndBlock.toJSON(message.endBlock) : undefined);
        message.commit !== undefined &&
            (obj.commit = message.commit ? exports.RequestCommit.toJSON(message.commit) : undefined);
        message.listSnapshots !== undefined &&
            (obj.listSnapshots = message.listSnapshots
                ? exports.RequestListSnapshots.toJSON(message.listSnapshots)
                : undefined);
        message.offerSnapshot !== undefined &&
            (obj.offerSnapshot = message.offerSnapshot
                ? exports.RequestOfferSnapshot.toJSON(message.offerSnapshot)
                : undefined);
        message.loadSnapshotChunk !== undefined &&
            (obj.loadSnapshotChunk = message.loadSnapshotChunk
                ? exports.RequestLoadSnapshotChunk.toJSON(message.loadSnapshotChunk)
                : undefined);
        message.applySnapshotChunk !== undefined &&
            (obj.applySnapshotChunk = message.applySnapshotChunk
                ? exports.RequestApplySnapshotChunk.toJSON(message.applySnapshotChunk)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseRequest();
        message.echo =
            object.echo !== undefined && object.echo !== null ? exports.RequestEcho.fromPartial(object.echo) : undefined;
        message.flush =
            object.flush !== undefined && object.flush !== null
                ? exports.RequestFlush.fromPartial(object.flush)
                : undefined;
        message.info =
            object.info !== undefined && object.info !== null ? exports.RequestInfo.fromPartial(object.info) : undefined;
        message.setOption =
            object.setOption !== undefined && object.setOption !== null
                ? exports.RequestSetOption.fromPartial(object.setOption)
                : undefined;
        message.initChain =
            object.initChain !== undefined && object.initChain !== null
                ? exports.RequestInitChain.fromPartial(object.initChain)
                : undefined;
        message.query =
            object.query !== undefined && object.query !== null
                ? exports.RequestQuery.fromPartial(object.query)
                : undefined;
        message.beginBlock =
            object.beginBlock !== undefined && object.beginBlock !== null
                ? exports.RequestBeginBlock.fromPartial(object.beginBlock)
                : undefined;
        message.checkTx =
            object.checkTx !== undefined && object.checkTx !== null
                ? exports.RequestCheckTx.fromPartial(object.checkTx)
                : undefined;
        message.deliverTx =
            object.deliverTx !== undefined && object.deliverTx !== null
                ? exports.RequestDeliverTx.fromPartial(object.deliverTx)
                : undefined;
        message.endBlock =
            object.endBlock !== undefined && object.endBlock !== null
                ? exports.RequestEndBlock.fromPartial(object.endBlock)
                : undefined;
        message.commit =
            object.commit !== undefined && object.commit !== null
                ? exports.RequestCommit.fromPartial(object.commit)
                : undefined;
        message.listSnapshots =
            object.listSnapshots !== undefined && object.listSnapshots !== null
                ? exports.RequestListSnapshots.fromPartial(object.listSnapshots)
                : undefined;
        message.offerSnapshot =
            object.offerSnapshot !== undefined && object.offerSnapshot !== null
                ? exports.RequestOfferSnapshot.fromPartial(object.offerSnapshot)
                : undefined;
        message.loadSnapshotChunk =
            object.loadSnapshotChunk !== undefined && object.loadSnapshotChunk !== null
                ? exports.RequestLoadSnapshotChunk.fromPartial(object.loadSnapshotChunk)
                : undefined;
        message.applySnapshotChunk =
            object.applySnapshotChunk !== undefined && object.applySnapshotChunk !== null
                ? exports.RequestApplySnapshotChunk.fromPartial(object.applySnapshotChunk)
                : undefined;
        return message;
    },
};
function createBaseRequestEcho() {
    return { message: "" };
}
exports.RequestEcho = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.message !== "") {
            writer.uint32(10).string(message.message);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRequestEcho();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.message = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { message: isSet(object.message) ? String(object.message) : "" };
    },
    toJSON(message) {
        const obj = {};
        message.message !== undefined && (obj.message = message.message);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseRequestEcho();
        message.message = (_a = object.message) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
function createBaseRequestFlush() {
    return {};
}
exports.RequestFlush = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRequestFlush();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseRequestFlush();
        return message;
    },
};
function createBaseRequestInfo() {
    return { version: "", blockVersion: long_1.default.UZERO, p2pVersion: long_1.default.UZERO };
}
exports.RequestInfo = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.version !== "") {
            writer.uint32(10).string(message.version);
        }
        if (!message.blockVersion.isZero()) {
            writer.uint32(16).uint64(message.blockVersion);
        }
        if (!message.p2pVersion.isZero()) {
            writer.uint32(24).uint64(message.p2pVersion);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRequestInfo();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.version = reader.string();
                    break;
                case 2:
                    message.blockVersion = reader.uint64();
                    break;
                case 3:
                    message.p2pVersion = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            version: isSet(object.version) ? String(object.version) : "",
            blockVersion: isSet(object.blockVersion) ? long_1.default.fromValue(object.blockVersion) : long_1.default.UZERO,
            p2pVersion: isSet(object.p2pVersion) ? long_1.default.fromValue(object.p2pVersion) : long_1.default.UZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        message.version !== undefined && (obj.version = message.version);
        message.blockVersion !== undefined &&
            (obj.blockVersion = (message.blockVersion || long_1.default.UZERO).toString());
        message.p2pVersion !== undefined && (obj.p2pVersion = (message.p2pVersion || long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseRequestInfo();
        message.version = (_a = object.version) !== null && _a !== void 0 ? _a : "";
        message.blockVersion =
            object.blockVersion !== undefined && object.blockVersion !== null
                ? long_1.default.fromValue(object.blockVersion)
                : long_1.default.UZERO;
        message.p2pVersion =
            object.p2pVersion !== undefined && object.p2pVersion !== null
                ? long_1.default.fromValue(object.p2pVersion)
                : long_1.default.UZERO;
        return message;
    },
};
function createBaseRequestSetOption() {
    return { key: "", value: "" };
}
exports.RequestSetOption = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.key !== "") {
            writer.uint32(10).string(message.key);
        }
        if (message.value !== "") {
            writer.uint32(18).string(message.value);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRequestSetOption();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.key = reader.string();
                    break;
                case 2:
                    message.value = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            key: isSet(object.key) ? String(object.key) : "",
            value: isSet(object.value) ? String(object.value) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.key !== undefined && (obj.key = message.key);
        message.value !== undefined && (obj.value = message.value);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseRequestSetOption();
        message.key = (_a = object.key) !== null && _a !== void 0 ? _a : "";
        message.value = (_b = object.value) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
function createBaseRequestInitChain() {
    return {
        time: undefined,
        chainId: "",
        consensusParams: undefined,
        validators: [],
        appStateBytes: new Uint8Array(),
        initialHeight: long_1.default.ZERO,
    };
}
exports.RequestInitChain = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.time !== undefined) {
            timestamp_1.Timestamp.encode(message.time, writer.uint32(10).fork()).ldelim();
        }
        if (message.chainId !== "") {
            writer.uint32(18).string(message.chainId);
        }
        if (message.consensusParams !== undefined) {
            exports.ConsensusParams.encode(message.consensusParams, writer.uint32(26).fork()).ldelim();
        }
        for (const v of message.validators) {
            exports.ValidatorUpdate.encode(v, writer.uint32(34).fork()).ldelim();
        }
        if (message.appStateBytes.length !== 0) {
            writer.uint32(42).bytes(message.appStateBytes);
        }
        if (!message.initialHeight.isZero()) {
            writer.uint32(48).int64(message.initialHeight);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRequestInitChain();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.time = timestamp_1.Timestamp.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.chainId = reader.string();
                    break;
                case 3:
                    message.consensusParams = exports.ConsensusParams.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.validators.push(exports.ValidatorUpdate.decode(reader, reader.uint32()));
                    break;
                case 5:
                    message.appStateBytes = reader.bytes();
                    break;
                case 6:
                    message.initialHeight = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            time: isSet(object.time) ? fromJsonTimestamp(object.time) : undefined,
            chainId: isSet(object.chainId) ? String(object.chainId) : "",
            consensusParams: isSet(object.consensusParams)
                ? exports.ConsensusParams.fromJSON(object.consensusParams)
                : undefined,
            validators: Array.isArray(object === null || object === void 0 ? void 0 : object.validators)
                ? object.validators.map((e) => exports.ValidatorUpdate.fromJSON(e))
                : [],
            appStateBytes: isSet(object.appStateBytes) ? bytesFromBase64(object.appStateBytes) : new Uint8Array(),
            initialHeight: isSet(object.initialHeight) ? long_1.default.fromValue(object.initialHeight) : long_1.default.ZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        message.time !== undefined && (obj.time = fromTimestamp(message.time).toISOString());
        message.chainId !== undefined && (obj.chainId = message.chainId);
        message.consensusParams !== undefined &&
            (obj.consensusParams = message.consensusParams
                ? exports.ConsensusParams.toJSON(message.consensusParams)
                : undefined);
        if (message.validators) {
            obj.validators = message.validators.map((e) => (e ? exports.ValidatorUpdate.toJSON(e) : undefined));
        }
        else {
            obj.validators = [];
        }
        message.appStateBytes !== undefined &&
            (obj.appStateBytes = base64FromBytes(message.appStateBytes !== undefined ? message.appStateBytes : new Uint8Array()));
        message.initialHeight !== undefined &&
            (obj.initialHeight = (message.initialHeight || long_1.default.ZERO).toString());
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseRequestInitChain();
        message.time =
            object.time !== undefined && object.time !== null ? timestamp_1.Timestamp.fromPartial(object.time) : undefined;
        message.chainId = (_a = object.chainId) !== null && _a !== void 0 ? _a : "";
        message.consensusParams =
            object.consensusParams !== undefined && object.consensusParams !== null
                ? exports.ConsensusParams.fromPartial(object.consensusParams)
                : undefined;
        message.validators = ((_b = object.validators) === null || _b === void 0 ? void 0 : _b.map((e) => exports.ValidatorUpdate.fromPartial(e))) || [];
        message.appStateBytes = (_c = object.appStateBytes) !== null && _c !== void 0 ? _c : new Uint8Array();
        message.initialHeight =
            object.initialHeight !== undefined && object.initialHeight !== null
                ? long_1.default.fromValue(object.initialHeight)
                : long_1.default.ZERO;
        return message;
    },
};
function createBaseRequestQuery() {
    return { data: new Uint8Array(), path: "", height: long_1.default.ZERO, prove: false };
}
exports.RequestQuery = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.data.length !== 0) {
            writer.uint32(10).bytes(message.data);
        }
        if (message.path !== "") {
            writer.uint32(18).string(message.path);
        }
        if (!message.height.isZero()) {
            writer.uint32(24).int64(message.height);
        }
        if (message.prove === true) {
            writer.uint32(32).bool(message.prove);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRequestQuery();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.data = reader.bytes();
                    break;
                case 2:
                    message.path = reader.string();
                    break;
                case 3:
                    message.height = reader.int64();
                    break;
                case 4:
                    message.prove = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            data: isSet(object.data) ? bytesFromBase64(object.data) : new Uint8Array(),
            path: isSet(object.path) ? String(object.path) : "",
            height: isSet(object.height) ? long_1.default.fromValue(object.height) : long_1.default.ZERO,
            prove: isSet(object.prove) ? Boolean(object.prove) : false,
        };
    },
    toJSON(message) {
        const obj = {};
        message.data !== undefined &&
            (obj.data = base64FromBytes(message.data !== undefined ? message.data : new Uint8Array()));
        message.path !== undefined && (obj.path = message.path);
        message.height !== undefined && (obj.height = (message.height || long_1.default.ZERO).toString());
        message.prove !== undefined && (obj.prove = message.prove);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseRequestQuery();
        message.data = (_a = object.data) !== null && _a !== void 0 ? _a : new Uint8Array();
        message.path = (_b = object.path) !== null && _b !== void 0 ? _b : "";
        message.height =
            object.height !== undefined && object.height !== null ? long_1.default.fromValue(object.height) : long_1.default.ZERO;
        message.prove = (_c = object.prove) !== null && _c !== void 0 ? _c : false;
        return message;
    },
};
function createBaseRequestBeginBlock() {
    return { hash: new Uint8Array(), header: undefined, lastCommitInfo: undefined, byzantineValidators: [] };
}
exports.RequestBeginBlock = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.hash.length !== 0) {
            writer.uint32(10).bytes(message.hash);
        }
        if (message.header !== undefined) {
            types_1.Header.encode(message.header, writer.uint32(18).fork()).ldelim();
        }
        if (message.lastCommitInfo !== undefined) {
            exports.LastCommitInfo.encode(message.lastCommitInfo, writer.uint32(26).fork()).ldelim();
        }
        for (const v of message.byzantineValidators) {
            exports.Evidence.encode(v, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRequestBeginBlock();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.hash = reader.bytes();
                    break;
                case 2:
                    message.header = types_1.Header.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.lastCommitInfo = exports.LastCommitInfo.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.byzantineValidators.push(exports.Evidence.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            hash: isSet(object.hash) ? bytesFromBase64(object.hash) : new Uint8Array(),
            header: isSet(object.header) ? types_1.Header.fromJSON(object.header) : undefined,
            lastCommitInfo: isSet(object.lastCommitInfo)
                ? exports.LastCommitInfo.fromJSON(object.lastCommitInfo)
                : undefined,
            byzantineValidators: Array.isArray(object === null || object === void 0 ? void 0 : object.byzantineValidators)
                ? object.byzantineValidators.map((e) => exports.Evidence.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        message.hash !== undefined &&
            (obj.hash = base64FromBytes(message.hash !== undefined ? message.hash : new Uint8Array()));
        message.header !== undefined && (obj.header = message.header ? types_1.Header.toJSON(message.header) : undefined);
        message.lastCommitInfo !== undefined &&
            (obj.lastCommitInfo = message.lastCommitInfo
                ? exports.LastCommitInfo.toJSON(message.lastCommitInfo)
                : undefined);
        if (message.byzantineValidators) {
            obj.byzantineValidators = message.byzantineValidators.map((e) => (e ? exports.Evidence.toJSON(e) : undefined));
        }
        else {
            obj.byzantineValidators = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseRequestBeginBlock();
        message.hash = (_a = object.hash) !== null && _a !== void 0 ? _a : new Uint8Array();
        message.header =
            object.header !== undefined && object.header !== null ? types_1.Header.fromPartial(object.header) : undefined;
        message.lastCommitInfo =
            object.lastCommitInfo !== undefined && object.lastCommitInfo !== null
                ? exports.LastCommitInfo.fromPartial(object.lastCommitInfo)
                : undefined;
        message.byzantineValidators = ((_b = object.byzantineValidators) === null || _b === void 0 ? void 0 : _b.map((e) => exports.Evidence.fromPartial(e))) || [];
        return message;
    },
};
function createBaseRequestCheckTx() {
    return { tx: new Uint8Array(), type: 0 };
}
exports.RequestCheckTx = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.tx.length !== 0) {
            writer.uint32(10).bytes(message.tx);
        }
        if (message.type !== 0) {
            writer.uint32(16).int32(message.type);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRequestCheckTx();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.tx = reader.bytes();
                    break;
                case 2:
                    message.type = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            tx: isSet(object.tx) ? bytesFromBase64(object.tx) : new Uint8Array(),
            type: isSet(object.type) ? checkTxTypeFromJSON(object.type) : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        message.tx !== undefined &&
            (obj.tx = base64FromBytes(message.tx !== undefined ? message.tx : new Uint8Array()));
        message.type !== undefined && (obj.type = checkTxTypeToJSON(message.type));
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseRequestCheckTx();
        message.tx = (_a = object.tx) !== null && _a !== void 0 ? _a : new Uint8Array();
        message.type = (_b = object.type) !== null && _b !== void 0 ? _b : 0;
        return message;
    },
};
function createBaseRequestDeliverTx() {
    return { tx: new Uint8Array() };
}
exports.RequestDeliverTx = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.tx.length !== 0) {
            writer.uint32(10).bytes(message.tx);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRequestDeliverTx();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.tx = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { tx: isSet(object.tx) ? bytesFromBase64(object.tx) : new Uint8Array() };
    },
    toJSON(message) {
        const obj = {};
        message.tx !== undefined &&
            (obj.tx = base64FromBytes(message.tx !== undefined ? message.tx : new Uint8Array()));
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseRequestDeliverTx();
        message.tx = (_a = object.tx) !== null && _a !== void 0 ? _a : new Uint8Array();
        return message;
    },
};
function createBaseRequestEndBlock() {
    return { height: long_1.default.ZERO };
}
exports.RequestEndBlock = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (!message.height.isZero()) {
            writer.uint32(8).int64(message.height);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRequestEndBlock();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.height = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { height: isSet(object.height) ? long_1.default.fromValue(object.height) : long_1.default.ZERO };
    },
    toJSON(message) {
        const obj = {};
        message.height !== undefined && (obj.height = (message.height || long_1.default.ZERO).toString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseRequestEndBlock();
        message.height =
            object.height !== undefined && object.height !== null ? long_1.default.fromValue(object.height) : long_1.default.ZERO;
        return message;
    },
};
function createBaseRequestCommit() {
    return {};
}
exports.RequestCommit = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRequestCommit();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseRequestCommit();
        return message;
    },
};
function createBaseRequestListSnapshots() {
    return {};
}
exports.RequestListSnapshots = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRequestListSnapshots();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseRequestListSnapshots();
        return message;
    },
};
function createBaseRequestOfferSnapshot() {
    return { snapshot: undefined, appHash: new Uint8Array() };
}
exports.RequestOfferSnapshot = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.snapshot !== undefined) {
            exports.Snapshot.encode(message.snapshot, writer.uint32(10).fork()).ldelim();
        }
        if (message.appHash.length !== 0) {
            writer.uint32(18).bytes(message.appHash);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRequestOfferSnapshot();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.snapshot = exports.Snapshot.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.appHash = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            snapshot: isSet(object.snapshot) ? exports.Snapshot.fromJSON(object.snapshot) : undefined,
            appHash: isSet(object.appHash) ? bytesFromBase64(object.appHash) : new Uint8Array(),
        };
    },
    toJSON(message) {
        const obj = {};
        message.snapshot !== undefined &&
            (obj.snapshot = message.snapshot ? exports.Snapshot.toJSON(message.snapshot) : undefined);
        message.appHash !== undefined &&
            (obj.appHash = base64FromBytes(message.appHash !== undefined ? message.appHash : new Uint8Array()));
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseRequestOfferSnapshot();
        message.snapshot =
            object.snapshot !== undefined && object.snapshot !== null
                ? exports.Snapshot.fromPartial(object.snapshot)
                : undefined;
        message.appHash = (_a = object.appHash) !== null && _a !== void 0 ? _a : new Uint8Array();
        return message;
    },
};
function createBaseRequestLoadSnapshotChunk() {
    return { height: long_1.default.UZERO, format: 0, chunk: 0 };
}
exports.RequestLoadSnapshotChunk = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (!message.height.isZero()) {
            writer.uint32(8).uint64(message.height);
        }
        if (message.format !== 0) {
            writer.uint32(16).uint32(message.format);
        }
        if (message.chunk !== 0) {
            writer.uint32(24).uint32(message.chunk);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRequestLoadSnapshotChunk();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.height = reader.uint64();
                    break;
                case 2:
                    message.format = reader.uint32();
                    break;
                case 3:
                    message.chunk = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            height: isSet(object.height) ? long_1.default.fromValue(object.height) : long_1.default.UZERO,
            format: isSet(object.format) ? Number(object.format) : 0,
            chunk: isSet(object.chunk) ? Number(object.chunk) : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        message.height !== undefined && (obj.height = (message.height || long_1.default.UZERO).toString());
        message.format !== undefined && (obj.format = Math.round(message.format));
        message.chunk !== undefined && (obj.chunk = Math.round(message.chunk));
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseRequestLoadSnapshotChunk();
        message.height =
            object.height !== undefined && object.height !== null ? long_1.default.fromValue(object.height) : long_1.default.UZERO;
        message.format = (_a = object.format) !== null && _a !== void 0 ? _a : 0;
        message.chunk = (_b = object.chunk) !== null && _b !== void 0 ? _b : 0;
        return message;
    },
};
function createBaseRequestApplySnapshotChunk() {
    return { index: 0, chunk: new Uint8Array(), sender: "" };
}
exports.RequestApplySnapshotChunk = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.index !== 0) {
            writer.uint32(8).uint32(message.index);
        }
        if (message.chunk.length !== 0) {
            writer.uint32(18).bytes(message.chunk);
        }
        if (message.sender !== "") {
            writer.uint32(26).string(message.sender);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRequestApplySnapshotChunk();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.index = reader.uint32();
                    break;
                case 2:
                    message.chunk = reader.bytes();
                    break;
                case 3:
                    message.sender = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            index: isSet(object.index) ? Number(object.index) : 0,
            chunk: isSet(object.chunk) ? bytesFromBase64(object.chunk) : new Uint8Array(),
            sender: isSet(object.sender) ? String(object.sender) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.index !== undefined && (obj.index = Math.round(message.index));
        message.chunk !== undefined &&
            (obj.chunk = base64FromBytes(message.chunk !== undefined ? message.chunk : new Uint8Array()));
        message.sender !== undefined && (obj.sender = message.sender);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseRequestApplySnapshotChunk();
        message.index = (_a = object.index) !== null && _a !== void 0 ? _a : 0;
        message.chunk = (_b = object.chunk) !== null && _b !== void 0 ? _b : new Uint8Array();
        message.sender = (_c = object.sender) !== null && _c !== void 0 ? _c : "";
        return message;
    },
};
function createBaseResponse() {
    return {
        exception: undefined,
        echo: undefined,
        flush: undefined,
        info: undefined,
        setOption: undefined,
        initChain: undefined,
        query: undefined,
        beginBlock: undefined,
        checkTx: undefined,
        deliverTx: undefined,
        endBlock: undefined,
        commit: undefined,
        listSnapshots: undefined,
        offerSnapshot: undefined,
        loadSnapshotChunk: undefined,
        applySnapshotChunk: undefined,
    };
}
exports.Response = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.exception !== undefined) {
            exports.ResponseException.encode(message.exception, writer.uint32(10).fork()).ldelim();
        }
        if (message.echo !== undefined) {
            exports.ResponseEcho.encode(message.echo, writer.uint32(18).fork()).ldelim();
        }
        if (message.flush !== undefined) {
            exports.ResponseFlush.encode(message.flush, writer.uint32(26).fork()).ldelim();
        }
        if (message.info !== undefined) {
            exports.ResponseInfo.encode(message.info, writer.uint32(34).fork()).ldelim();
        }
        if (message.setOption !== undefined) {
            exports.ResponseSetOption.encode(message.setOption, writer.uint32(42).fork()).ldelim();
        }
        if (message.initChain !== undefined) {
            exports.ResponseInitChain.encode(message.initChain, writer.uint32(50).fork()).ldelim();
        }
        if (message.query !== undefined) {
            exports.ResponseQuery.encode(message.query, writer.uint32(58).fork()).ldelim();
        }
        if (message.beginBlock !== undefined) {
            exports.ResponseBeginBlock.encode(message.beginBlock, writer.uint32(66).fork()).ldelim();
        }
        if (message.checkTx !== undefined) {
            exports.ResponseCheckTx.encode(message.checkTx, writer.uint32(74).fork()).ldelim();
        }
        if (message.deliverTx !== undefined) {
            exports.ResponseDeliverTx.encode(message.deliverTx, writer.uint32(82).fork()).ldelim();
        }
        if (message.endBlock !== undefined) {
            exports.ResponseEndBlock.encode(message.endBlock, writer.uint32(90).fork()).ldelim();
        }
        if (message.commit !== undefined) {
            exports.ResponseCommit.encode(message.commit, writer.uint32(98).fork()).ldelim();
        }
        if (message.listSnapshots !== undefined) {
            exports.ResponseListSnapshots.encode(message.listSnapshots, writer.uint32(106).fork()).ldelim();
        }
        if (message.offerSnapshot !== undefined) {
            exports.ResponseOfferSnapshot.encode(message.offerSnapshot, writer.uint32(114).fork()).ldelim();
        }
        if (message.loadSnapshotChunk !== undefined) {
            exports.ResponseLoadSnapshotChunk.encode(message.loadSnapshotChunk, writer.uint32(122).fork()).ldelim();
        }
        if (message.applySnapshotChunk !== undefined) {
            exports.ResponseApplySnapshotChunk.encode(message.applySnapshotChunk, writer.uint32(130).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.exception = exports.ResponseException.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.echo = exports.ResponseEcho.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.flush = exports.ResponseFlush.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.info = exports.ResponseInfo.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.setOption = exports.ResponseSetOption.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.initChain = exports.ResponseInitChain.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.query = exports.ResponseQuery.decode(reader, reader.uint32());
                    break;
                case 8:
                    message.beginBlock = exports.ResponseBeginBlock.decode(reader, reader.uint32());
                    break;
                case 9:
                    message.checkTx = exports.ResponseCheckTx.decode(reader, reader.uint32());
                    break;
                case 10:
                    message.deliverTx = exports.ResponseDeliverTx.decode(reader, reader.uint32());
                    break;
                case 11:
                    message.endBlock = exports.ResponseEndBlock.decode(reader, reader.uint32());
                    break;
                case 12:
                    message.commit = exports.ResponseCommit.decode(reader, reader.uint32());
                    break;
                case 13:
                    message.listSnapshots = exports.ResponseListSnapshots.decode(reader, reader.uint32());
                    break;
                case 14:
                    message.offerSnapshot = exports.ResponseOfferSnapshot.decode(reader, reader.uint32());
                    break;
                case 15:
                    message.loadSnapshotChunk = exports.ResponseLoadSnapshotChunk.decode(reader, reader.uint32());
                    break;
                case 16:
                    message.applySnapshotChunk = exports.ResponseApplySnapshotChunk.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            exception: isSet(object.exception) ? exports.ResponseException.fromJSON(object.exception) : undefined,
            echo: isSet(object.echo) ? exports.ResponseEcho.fromJSON(object.echo) : undefined,
            flush: isSet(object.flush) ? exports.ResponseFlush.fromJSON(object.flush) : undefined,
            info: isSet(object.info) ? exports.ResponseInfo.fromJSON(object.info) : undefined,
            setOption: isSet(object.setOption) ? exports.ResponseSetOption.fromJSON(object.setOption) : undefined,
            initChain: isSet(object.initChain) ? exports.ResponseInitChain.fromJSON(object.initChain) : undefined,
            query: isSet(object.query) ? exports.ResponseQuery.fromJSON(object.query) : undefined,
            beginBlock: isSet(object.beginBlock) ? exports.ResponseBeginBlock.fromJSON(object.beginBlock) : undefined,
            checkTx: isSet(object.checkTx) ? exports.ResponseCheckTx.fromJSON(object.checkTx) : undefined,
            deliverTx: isSet(object.deliverTx) ? exports.ResponseDeliverTx.fromJSON(object.deliverTx) : undefined,
            endBlock: isSet(object.endBlock) ? exports.ResponseEndBlock.fromJSON(object.endBlock) : undefined,
            commit: isSet(object.commit) ? exports.ResponseCommit.fromJSON(object.commit) : undefined,
            listSnapshots: isSet(object.listSnapshots)
                ? exports.ResponseListSnapshots.fromJSON(object.listSnapshots)
                : undefined,
            offerSnapshot: isSet(object.offerSnapshot)
                ? exports.ResponseOfferSnapshot.fromJSON(object.offerSnapshot)
                : undefined,
            loadSnapshotChunk: isSet(object.loadSnapshotChunk)
                ? exports.ResponseLoadSnapshotChunk.fromJSON(object.loadSnapshotChunk)
                : undefined,
            applySnapshotChunk: isSet(object.applySnapshotChunk)
                ? exports.ResponseApplySnapshotChunk.fromJSON(object.applySnapshotChunk)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.exception !== undefined &&
            (obj.exception = message.exception ? exports.ResponseException.toJSON(message.exception) : undefined);
        message.echo !== undefined && (obj.echo = message.echo ? exports.ResponseEcho.toJSON(message.echo) : undefined);
        message.flush !== undefined &&
            (obj.flush = message.flush ? exports.ResponseFlush.toJSON(message.flush) : undefined);
        message.info !== undefined && (obj.info = message.info ? exports.ResponseInfo.toJSON(message.info) : undefined);
        message.setOption !== undefined &&
            (obj.setOption = message.setOption ? exports.ResponseSetOption.toJSON(message.setOption) : undefined);
        message.initChain !== undefined &&
            (obj.initChain = message.initChain ? exports.ResponseInitChain.toJSON(message.initChain) : undefined);
        message.query !== undefined &&
            (obj.query = message.query ? exports.ResponseQuery.toJSON(message.query) : undefined);
        message.beginBlock !== undefined &&
            (obj.beginBlock = message.beginBlock ? exports.ResponseBeginBlock.toJSON(message.beginBlock) : undefined);
        message.checkTx !== undefined &&
            (obj.checkTx = message.checkTx ? exports.ResponseCheckTx.toJSON(message.checkTx) : undefined);
        message.deliverTx !== undefined &&
            (obj.deliverTx = message.deliverTx ? exports.ResponseDeliverTx.toJSON(message.deliverTx) : undefined);
        message.endBlock !== undefined &&
            (obj.endBlock = message.endBlock ? exports.ResponseEndBlock.toJSON(message.endBlock) : undefined);
        message.commit !== undefined &&
            (obj.commit = message.commit ? exports.ResponseCommit.toJSON(message.commit) : undefined);
        message.listSnapshots !== undefined &&
            (obj.listSnapshots = message.listSnapshots
                ? exports.ResponseListSnapshots.toJSON(message.listSnapshots)
                : undefined);
        message.offerSnapshot !== undefined &&
            (obj.offerSnapshot = message.offerSnapshot
                ? exports.ResponseOfferSnapshot.toJSON(message.offerSnapshot)
                : undefined);
        message.loadSnapshotChunk !== undefined &&
            (obj.loadSnapshotChunk = message.loadSnapshotChunk
                ? exports.ResponseLoadSnapshotChunk.toJSON(message.loadSnapshotChunk)
                : undefined);
        message.applySnapshotChunk !== undefined &&
            (obj.applySnapshotChunk = message.applySnapshotChunk
                ? exports.ResponseApplySnapshotChunk.toJSON(message.applySnapshotChunk)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseResponse();
        message.exception =
            object.exception !== undefined && object.exception !== null
                ? exports.ResponseException.fromPartial(object.exception)
                : undefined;
        message.echo =
            object.echo !== undefined && object.echo !== null ? exports.ResponseEcho.fromPartial(object.echo) : undefined;
        message.flush =
            object.flush !== undefined && object.flush !== null
                ? exports.ResponseFlush.fromPartial(object.flush)
                : undefined;
        message.info =
            object.info !== undefined && object.info !== null ? exports.ResponseInfo.fromPartial(object.info) : undefined;
        message.setOption =
            object.setOption !== undefined && object.setOption !== null
                ? exports.ResponseSetOption.fromPartial(object.setOption)
                : undefined;
        message.initChain =
            object.initChain !== undefined && object.initChain !== null
                ? exports.ResponseInitChain.fromPartial(object.initChain)
                : undefined;
        message.query =
            object.query !== undefined && object.query !== null
                ? exports.ResponseQuery.fromPartial(object.query)
                : undefined;
        message.beginBlock =
            object.beginBlock !== undefined && object.beginBlock !== null
                ? exports.ResponseBeginBlock.fromPartial(object.beginBlock)
                : undefined;
        message.checkTx =
            object.checkTx !== undefined && object.checkTx !== null
                ? exports.ResponseCheckTx.fromPartial(object.checkTx)
                : undefined;
        message.deliverTx =
            object.deliverTx !== undefined && object.deliverTx !== null
                ? exports.ResponseDeliverTx.fromPartial(object.deliverTx)
                : undefined;
        message.endBlock =
            object.endBlock !== undefined && object.endBlock !== null
                ? exports.ResponseEndBlock.fromPartial(object.endBlock)
                : undefined;
        message.commit =
            object.commit !== undefined && object.commit !== null
                ? exports.ResponseCommit.fromPartial(object.commit)
                : undefined;
        message.listSnapshots =
            object.listSnapshots !== undefined && object.listSnapshots !== null
                ? exports.ResponseListSnapshots.fromPartial(object.listSnapshots)
                : undefined;
        message.offerSnapshot =
            object.offerSnapshot !== undefined && object.offerSnapshot !== null
                ? exports.ResponseOfferSnapshot.fromPartial(object.offerSnapshot)
                : undefined;
        message.loadSnapshotChunk =
            object.loadSnapshotChunk !== undefined && object.loadSnapshotChunk !== null
                ? exports.ResponseLoadSnapshotChunk.fromPartial(object.loadSnapshotChunk)
                : undefined;
        message.applySnapshotChunk =
            object.applySnapshotChunk !== undefined && object.applySnapshotChunk !== null
                ? exports.ResponseApplySnapshotChunk.fromPartial(object.applySnapshotChunk)
                : undefined;
        return message;
    },
};
function createBaseResponseException() {
    return { error: "" };
}
exports.ResponseException = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.error !== "") {
            writer.uint32(10).string(message.error);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseResponseException();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.error = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { error: isSet(object.error) ? String(object.error) : "" };
    },
    toJSON(message) {
        const obj = {};
        message.error !== undefined && (obj.error = message.error);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseResponseException();
        message.error = (_a = object.error) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
function createBaseResponseEcho() {
    return { message: "" };
}
exports.ResponseEcho = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.message !== "") {
            writer.uint32(10).string(message.message);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseResponseEcho();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.message = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { message: isSet(object.message) ? String(object.message) : "" };
    },
    toJSON(message) {
        const obj = {};
        message.message !== undefined && (obj.message = message.message);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseResponseEcho();
        message.message = (_a = object.message) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
function createBaseResponseFlush() {
    return {};
}
exports.ResponseFlush = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseResponseFlush();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseResponseFlush();
        return message;
    },
};
function createBaseResponseInfo() {
    return {
        data: "",
        version: "",
        appVersion: long_1.default.UZERO,
        lastBlockHeight: long_1.default.ZERO,
        lastBlockAppHash: new Uint8Array(),
    };
}
exports.ResponseInfo = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.data !== "") {
            writer.uint32(10).string(message.data);
        }
        if (message.version !== "") {
            writer.uint32(18).string(message.version);
        }
        if (!message.appVersion.isZero()) {
            writer.uint32(24).uint64(message.appVersion);
        }
        if (!message.lastBlockHeight.isZero()) {
            writer.uint32(32).int64(message.lastBlockHeight);
        }
        if (message.lastBlockAppHash.length !== 0) {
            writer.uint32(42).bytes(message.lastBlockAppHash);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseResponseInfo();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.data = reader.string();
                    break;
                case 2:
                    message.version = reader.string();
                    break;
                case 3:
                    message.appVersion = reader.uint64();
                    break;
                case 4:
                    message.lastBlockHeight = reader.int64();
                    break;
                case 5:
                    message.lastBlockAppHash = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            data: isSet(object.data) ? String(object.data) : "",
            version: isSet(object.version) ? String(object.version) : "",
            appVersion: isSet(object.appVersion) ? long_1.default.fromValue(object.appVersion) : long_1.default.UZERO,
            lastBlockHeight: isSet(object.lastBlockHeight) ? long_1.default.fromValue(object.lastBlockHeight) : long_1.default.ZERO,
            lastBlockAppHash: isSet(object.lastBlockAppHash)
                ? bytesFromBase64(object.lastBlockAppHash)
                : new Uint8Array(),
        };
    },
    toJSON(message) {
        const obj = {};
        message.data !== undefined && (obj.data = message.data);
        message.version !== undefined && (obj.version = message.version);
        message.appVersion !== undefined && (obj.appVersion = (message.appVersion || long_1.default.UZERO).toString());
        message.lastBlockHeight !== undefined &&
            (obj.lastBlockHeight = (message.lastBlockHeight || long_1.default.ZERO).toString());
        message.lastBlockAppHash !== undefined &&
            (obj.lastBlockAppHash = base64FromBytes(message.lastBlockAppHash !== undefined ? message.lastBlockAppHash : new Uint8Array()));
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseResponseInfo();
        message.data = (_a = object.data) !== null && _a !== void 0 ? _a : "";
        message.version = (_b = object.version) !== null && _b !== void 0 ? _b : "";
        message.appVersion =
            object.appVersion !== undefined && object.appVersion !== null
                ? long_1.default.fromValue(object.appVersion)
                : long_1.default.UZERO;
        message.lastBlockHeight =
            object.lastBlockHeight !== undefined && object.lastBlockHeight !== null
                ? long_1.default.fromValue(object.lastBlockHeight)
                : long_1.default.ZERO;
        message.lastBlockAppHash = (_c = object.lastBlockAppHash) !== null && _c !== void 0 ? _c : new Uint8Array();
        return message;
    },
};
function createBaseResponseSetOption() {
    return { code: 0, log: "", info: "" };
}
exports.ResponseSetOption = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.code !== 0) {
            writer.uint32(8).uint32(message.code);
        }
        if (message.log !== "") {
            writer.uint32(26).string(message.log);
        }
        if (message.info !== "") {
            writer.uint32(34).string(message.info);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseResponseSetOption();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.code = reader.uint32();
                    break;
                case 3:
                    message.log = reader.string();
                    break;
                case 4:
                    message.info = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            code: isSet(object.code) ? Number(object.code) : 0,
            log: isSet(object.log) ? String(object.log) : "",
            info: isSet(object.info) ? String(object.info) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.code !== undefined && (obj.code = Math.round(message.code));
        message.log !== undefined && (obj.log = message.log);
        message.info !== undefined && (obj.info = message.info);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseResponseSetOption();
        message.code = (_a = object.code) !== null && _a !== void 0 ? _a : 0;
        message.log = (_b = object.log) !== null && _b !== void 0 ? _b : "";
        message.info = (_c = object.info) !== null && _c !== void 0 ? _c : "";
        return message;
    },
};
function createBaseResponseInitChain() {
    return { consensusParams: undefined, validators: [], appHash: new Uint8Array() };
}
exports.ResponseInitChain = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.consensusParams !== undefined) {
            exports.ConsensusParams.encode(message.consensusParams, writer.uint32(10).fork()).ldelim();
        }
        for (const v of message.validators) {
            exports.ValidatorUpdate.encode(v, writer.uint32(18).fork()).ldelim();
        }
        if (message.appHash.length !== 0) {
            writer.uint32(26).bytes(message.appHash);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseResponseInitChain();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.consensusParams = exports.ConsensusParams.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.validators.push(exports.ValidatorUpdate.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.appHash = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            consensusParams: isSet(object.consensusParams)
                ? exports.ConsensusParams.fromJSON(object.consensusParams)
                : undefined,
            validators: Array.isArray(object === null || object === void 0 ? void 0 : object.validators)
                ? object.validators.map((e) => exports.ValidatorUpdate.fromJSON(e))
                : [],
            appHash: isSet(object.appHash) ? bytesFromBase64(object.appHash) : new Uint8Array(),
        };
    },
    toJSON(message) {
        const obj = {};
        message.consensusParams !== undefined &&
            (obj.consensusParams = message.consensusParams
                ? exports.ConsensusParams.toJSON(message.consensusParams)
                : undefined);
        if (message.validators) {
            obj.validators = message.validators.map((e) => (e ? exports.ValidatorUpdate.toJSON(e) : undefined));
        }
        else {
            obj.validators = [];
        }
        message.appHash !== undefined &&
            (obj.appHash = base64FromBytes(message.appHash !== undefined ? message.appHash : new Uint8Array()));
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseResponseInitChain();
        message.consensusParams =
            object.consensusParams !== undefined && object.consensusParams !== null
                ? exports.ConsensusParams.fromPartial(object.consensusParams)
                : undefined;
        message.validators = ((_a = object.validators) === null || _a === void 0 ? void 0 : _a.map((e) => exports.ValidatorUpdate.fromPartial(e))) || [];
        message.appHash = (_b = object.appHash) !== null && _b !== void 0 ? _b : new Uint8Array();
        return message;
    },
};
function createBaseResponseQuery() {
    return {
        code: 0,
        log: "",
        info: "",
        index: long_1.default.ZERO,
        key: new Uint8Array(),
        value: new Uint8Array(),
        proofOps: undefined,
        height: long_1.default.ZERO,
        codespace: "",
    };
}
exports.ResponseQuery = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.code !== 0) {
            writer.uint32(8).uint32(message.code);
        }
        if (message.log !== "") {
            writer.uint32(26).string(message.log);
        }
        if (message.info !== "") {
            writer.uint32(34).string(message.info);
        }
        if (!message.index.isZero()) {
            writer.uint32(40).int64(message.index);
        }
        if (message.key.length !== 0) {
            writer.uint32(50).bytes(message.key);
        }
        if (message.value.length !== 0) {
            writer.uint32(58).bytes(message.value);
        }
        if (message.proofOps !== undefined) {
            proof_1.ProofOps.encode(message.proofOps, writer.uint32(66).fork()).ldelim();
        }
        if (!message.height.isZero()) {
            writer.uint32(72).int64(message.height);
        }
        if (message.codespace !== "") {
            writer.uint32(82).string(message.codespace);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseResponseQuery();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.code = reader.uint32();
                    break;
                case 3:
                    message.log = reader.string();
                    break;
                case 4:
                    message.info = reader.string();
                    break;
                case 5:
                    message.index = reader.int64();
                    break;
                case 6:
                    message.key = reader.bytes();
                    break;
                case 7:
                    message.value = reader.bytes();
                    break;
                case 8:
                    message.proofOps = proof_1.ProofOps.decode(reader, reader.uint32());
                    break;
                case 9:
                    message.height = reader.int64();
                    break;
                case 10:
                    message.codespace = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            code: isSet(object.code) ? Number(object.code) : 0,
            log: isSet(object.log) ? String(object.log) : "",
            info: isSet(object.info) ? String(object.info) : "",
            index: isSet(object.index) ? long_1.default.fromValue(object.index) : long_1.default.ZERO,
            key: isSet(object.key) ? bytesFromBase64(object.key) : new Uint8Array(),
            value: isSet(object.value) ? bytesFromBase64(object.value) : new Uint8Array(),
            proofOps: isSet(object.proofOps) ? proof_1.ProofOps.fromJSON(object.proofOps) : undefined,
            height: isSet(object.height) ? long_1.default.fromValue(object.height) : long_1.default.ZERO,
            codespace: isSet(object.codespace) ? String(object.codespace) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.code !== undefined && (obj.code = Math.round(message.code));
        message.log !== undefined && (obj.log = message.log);
        message.info !== undefined && (obj.info = message.info);
        message.index !== undefined && (obj.index = (message.index || long_1.default.ZERO).toString());
        message.key !== undefined &&
            (obj.key = base64FromBytes(message.key !== undefined ? message.key : new Uint8Array()));
        message.value !== undefined &&
            (obj.value = base64FromBytes(message.value !== undefined ? message.value : new Uint8Array()));
        message.proofOps !== undefined &&
            (obj.proofOps = message.proofOps ? proof_1.ProofOps.toJSON(message.proofOps) : undefined);
        message.height !== undefined && (obj.height = (message.height || long_1.default.ZERO).toString());
        message.codespace !== undefined && (obj.codespace = message.codespace);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f;
        const message = createBaseResponseQuery();
        message.code = (_a = object.code) !== null && _a !== void 0 ? _a : 0;
        message.log = (_b = object.log) !== null && _b !== void 0 ? _b : "";
        message.info = (_c = object.info) !== null && _c !== void 0 ? _c : "";
        message.index =
            object.index !== undefined && object.index !== null ? long_1.default.fromValue(object.index) : long_1.default.ZERO;
        message.key = (_d = object.key) !== null && _d !== void 0 ? _d : new Uint8Array();
        message.value = (_e = object.value) !== null && _e !== void 0 ? _e : new Uint8Array();
        message.proofOps =
            object.proofOps !== undefined && object.proofOps !== null
                ? proof_1.ProofOps.fromPartial(object.proofOps)
                : undefined;
        message.height =
            object.height !== undefined && object.height !== null ? long_1.default.fromValue(object.height) : long_1.default.ZERO;
        message.codespace = (_f = object.codespace) !== null && _f !== void 0 ? _f : "";
        return message;
    },
};
function createBaseResponseBeginBlock() {
    return { events: [] };
}
exports.ResponseBeginBlock = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.events) {
            exports.Event.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseResponseBeginBlock();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.events.push(exports.Event.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { events: Array.isArray(object === null || object === void 0 ? void 0 : object.events) ? object.events.map((e) => exports.Event.fromJSON(e)) : [] };
    },
    toJSON(message) {
        const obj = {};
        if (message.events) {
            obj.events = message.events.map((e) => (e ? exports.Event.toJSON(e) : undefined));
        }
        else {
            obj.events = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseResponseBeginBlock();
        message.events = ((_a = object.events) === null || _a === void 0 ? void 0 : _a.map((e) => exports.Event.fromPartial(e))) || [];
        return message;
    },
};
function createBaseResponseCheckTx() {
    return {
        code: 0,
        data: new Uint8Array(),
        log: "",
        info: "",
        gasWanted: long_1.default.ZERO,
        gasUsed: long_1.default.ZERO,
        events: [],
        codespace: "",
    };
}
exports.ResponseCheckTx = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.code !== 0) {
            writer.uint32(8).uint32(message.code);
        }
        if (message.data.length !== 0) {
            writer.uint32(18).bytes(message.data);
        }
        if (message.log !== "") {
            writer.uint32(26).string(message.log);
        }
        if (message.info !== "") {
            writer.uint32(34).string(message.info);
        }
        if (!message.gasWanted.isZero()) {
            writer.uint32(40).int64(message.gasWanted);
        }
        if (!message.gasUsed.isZero()) {
            writer.uint32(48).int64(message.gasUsed);
        }
        for (const v of message.events) {
            exports.Event.encode(v, writer.uint32(58).fork()).ldelim();
        }
        if (message.codespace !== "") {
            writer.uint32(66).string(message.codespace);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseResponseCheckTx();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.code = reader.uint32();
                    break;
                case 2:
                    message.data = reader.bytes();
                    break;
                case 3:
                    message.log = reader.string();
                    break;
                case 4:
                    message.info = reader.string();
                    break;
                case 5:
                    message.gasWanted = reader.int64();
                    break;
                case 6:
                    message.gasUsed = reader.int64();
                    break;
                case 7:
                    message.events.push(exports.Event.decode(reader, reader.uint32()));
                    break;
                case 8:
                    message.codespace = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            code: isSet(object.code) ? Number(object.code) : 0,
            data: isSet(object.data) ? bytesFromBase64(object.data) : new Uint8Array(),
            log: isSet(object.log) ? String(object.log) : "",
            info: isSet(object.info) ? String(object.info) : "",
            gasWanted: isSet(object.gas_wanted) ? long_1.default.fromValue(object.gas_wanted) : long_1.default.ZERO,
            gasUsed: isSet(object.gas_used) ? long_1.default.fromValue(object.gas_used) : long_1.default.ZERO,
            events: Array.isArray(object === null || object === void 0 ? void 0 : object.events) ? object.events.map((e) => exports.Event.fromJSON(e)) : [],
            codespace: isSet(object.codespace) ? String(object.codespace) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.code !== undefined && (obj.code = Math.round(message.code));
        message.data !== undefined &&
            (obj.data = base64FromBytes(message.data !== undefined ? message.data : new Uint8Array()));
        message.log !== undefined && (obj.log = message.log);
        message.info !== undefined && (obj.info = message.info);
        message.gasWanted !== undefined && (obj.gas_wanted = (message.gasWanted || long_1.default.ZERO).toString());
        message.gasUsed !== undefined && (obj.gas_used = (message.gasUsed || long_1.default.ZERO).toString());
        if (message.events) {
            obj.events = message.events.map((e) => (e ? exports.Event.toJSON(e) : undefined));
        }
        else {
            obj.events = [];
        }
        message.codespace !== undefined && (obj.codespace = message.codespace);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f;
        const message = createBaseResponseCheckTx();
        message.code = (_a = object.code) !== null && _a !== void 0 ? _a : 0;
        message.data = (_b = object.data) !== null && _b !== void 0 ? _b : new Uint8Array();
        message.log = (_c = object.log) !== null && _c !== void 0 ? _c : "";
        message.info = (_d = object.info) !== null && _d !== void 0 ? _d : "";
        message.gasWanted =
            object.gasWanted !== undefined && object.gasWanted !== null
                ? long_1.default.fromValue(object.gasWanted)
                : long_1.default.ZERO;
        message.gasUsed =
            object.gasUsed !== undefined && object.gasUsed !== null ? long_1.default.fromValue(object.gasUsed) : long_1.default.ZERO;
        message.events = ((_e = object.events) === null || _e === void 0 ? void 0 : _e.map((e) => exports.Event.fromPartial(e))) || [];
        message.codespace = (_f = object.codespace) !== null && _f !== void 0 ? _f : "";
        return message;
    },
};
function createBaseResponseDeliverTx() {
    return {
        code: 0,
        data: new Uint8Array(),
        log: "",
        info: "",
        gasWanted: long_1.default.ZERO,
        gasUsed: long_1.default.ZERO,
        events: [],
        codespace: "",
    };
}
exports.ResponseDeliverTx = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.code !== 0) {
            writer.uint32(8).uint32(message.code);
        }
        if (message.data.length !== 0) {
            writer.uint32(18).bytes(message.data);
        }
        if (message.log !== "") {
            writer.uint32(26).string(message.log);
        }
        if (message.info !== "") {
            writer.uint32(34).string(message.info);
        }
        if (!message.gasWanted.isZero()) {
            writer.uint32(40).int64(message.gasWanted);
        }
        if (!message.gasUsed.isZero()) {
            writer.uint32(48).int64(message.gasUsed);
        }
        for (const v of message.events) {
            exports.Event.encode(v, writer.uint32(58).fork()).ldelim();
        }
        if (message.codespace !== "") {
            writer.uint32(66).string(message.codespace);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseResponseDeliverTx();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.code = reader.uint32();
                    break;
                case 2:
                    message.data = reader.bytes();
                    break;
                case 3:
                    message.log = reader.string();
                    break;
                case 4:
                    message.info = reader.string();
                    break;
                case 5:
                    message.gasWanted = reader.int64();
                    break;
                case 6:
                    message.gasUsed = reader.int64();
                    break;
                case 7:
                    message.events.push(exports.Event.decode(reader, reader.uint32()));
                    break;
                case 8:
                    message.codespace = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            code: isSet(object.code) ? Number(object.code) : 0,
            data: isSet(object.data) ? bytesFromBase64(object.data) : new Uint8Array(),
            log: isSet(object.log) ? String(object.log) : "",
            info: isSet(object.info) ? String(object.info) : "",
            gasWanted: isSet(object.gas_wanted) ? long_1.default.fromValue(object.gas_wanted) : long_1.default.ZERO,
            gasUsed: isSet(object.gas_used) ? long_1.default.fromValue(object.gas_used) : long_1.default.ZERO,
            events: Array.isArray(object === null || object === void 0 ? void 0 : object.events) ? object.events.map((e) => exports.Event.fromJSON(e)) : [],
            codespace: isSet(object.codespace) ? String(object.codespace) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.code !== undefined && (obj.code = Math.round(message.code));
        message.data !== undefined &&
            (obj.data = base64FromBytes(message.data !== undefined ? message.data : new Uint8Array()));
        message.log !== undefined && (obj.log = message.log);
        message.info !== undefined && (obj.info = message.info);
        message.gasWanted !== undefined && (obj.gas_wanted = (message.gasWanted || long_1.default.ZERO).toString());
        message.gasUsed !== undefined && (obj.gas_used = (message.gasUsed || long_1.default.ZERO).toString());
        if (message.events) {
            obj.events = message.events.map((e) => (e ? exports.Event.toJSON(e) : undefined));
        }
        else {
            obj.events = [];
        }
        message.codespace !== undefined && (obj.codespace = message.codespace);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f;
        const message = createBaseResponseDeliverTx();
        message.code = (_a = object.code) !== null && _a !== void 0 ? _a : 0;
        message.data = (_b = object.data) !== null && _b !== void 0 ? _b : new Uint8Array();
        message.log = (_c = object.log) !== null && _c !== void 0 ? _c : "";
        message.info = (_d = object.info) !== null && _d !== void 0 ? _d : "";
        message.gasWanted =
            object.gasWanted !== undefined && object.gasWanted !== null
                ? long_1.default.fromValue(object.gasWanted)
                : long_1.default.ZERO;
        message.gasUsed =
            object.gasUsed !== undefined && object.gasUsed !== null ? long_1.default.fromValue(object.gasUsed) : long_1.default.ZERO;
        message.events = ((_e = object.events) === null || _e === void 0 ? void 0 : _e.map((e) => exports.Event.fromPartial(e))) || [];
        message.codespace = (_f = object.codespace) !== null && _f !== void 0 ? _f : "";
        return message;
    },
};
function createBaseResponseEndBlock() {
    return { validatorUpdates: [], consensusParamUpdates: undefined, events: [] };
}
exports.ResponseEndBlock = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.validatorUpdates) {
            exports.ValidatorUpdate.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.consensusParamUpdates !== undefined) {
            exports.ConsensusParams.encode(message.consensusParamUpdates, writer.uint32(18).fork()).ldelim();
        }
        for (const v of message.events) {
            exports.Event.encode(v, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseResponseEndBlock();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.validatorUpdates.push(exports.ValidatorUpdate.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.consensusParamUpdates = exports.ConsensusParams.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.events.push(exports.Event.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            validatorUpdates: Array.isArray(object === null || object === void 0 ? void 0 : object.validatorUpdates)
                ? object.validatorUpdates.map((e) => exports.ValidatorUpdate.fromJSON(e))
                : [],
            consensusParamUpdates: isSet(object.consensusParamUpdates)
                ? exports.ConsensusParams.fromJSON(object.consensusParamUpdates)
                : undefined,
            events: Array.isArray(object === null || object === void 0 ? void 0 : object.events) ? object.events.map((e) => exports.Event.fromJSON(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.validatorUpdates) {
            obj.validatorUpdates = message.validatorUpdates.map((e) => (e ? exports.ValidatorUpdate.toJSON(e) : undefined));
        }
        else {
            obj.validatorUpdates = [];
        }
        message.consensusParamUpdates !== undefined &&
            (obj.consensusParamUpdates = message.consensusParamUpdates
                ? exports.ConsensusParams.toJSON(message.consensusParamUpdates)
                : undefined);
        if (message.events) {
            obj.events = message.events.map((e) => (e ? exports.Event.toJSON(e) : undefined));
        }
        else {
            obj.events = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseResponseEndBlock();
        message.validatorUpdates = ((_a = object.validatorUpdates) === null || _a === void 0 ? void 0 : _a.map((e) => exports.ValidatorUpdate.fromPartial(e))) || [];
        message.consensusParamUpdates =
            object.consensusParamUpdates !== undefined && object.consensusParamUpdates !== null
                ? exports.ConsensusParams.fromPartial(object.consensusParamUpdates)
                : undefined;
        message.events = ((_b = object.events) === null || _b === void 0 ? void 0 : _b.map((e) => exports.Event.fromPartial(e))) || [];
        return message;
    },
};
function createBaseResponseCommit() {
    return { data: new Uint8Array(), retainHeight: long_1.default.ZERO };
}
exports.ResponseCommit = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.data.length !== 0) {
            writer.uint32(18).bytes(message.data);
        }
        if (!message.retainHeight.isZero()) {
            writer.uint32(24).int64(message.retainHeight);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseResponseCommit();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 2:
                    message.data = reader.bytes();
                    break;
                case 3:
                    message.retainHeight = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            data: isSet(object.data) ? bytesFromBase64(object.data) : new Uint8Array(),
            retainHeight: isSet(object.retainHeight) ? long_1.default.fromValue(object.retainHeight) : long_1.default.ZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        message.data !== undefined &&
            (obj.data = base64FromBytes(message.data !== undefined ? message.data : new Uint8Array()));
        message.retainHeight !== undefined && (obj.retainHeight = (message.retainHeight || long_1.default.ZERO).toString());
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseResponseCommit();
        message.data = (_a = object.data) !== null && _a !== void 0 ? _a : new Uint8Array();
        message.retainHeight =
            object.retainHeight !== undefined && object.retainHeight !== null
                ? long_1.default.fromValue(object.retainHeight)
                : long_1.default.ZERO;
        return message;
    },
};
function createBaseResponseListSnapshots() {
    return { snapshots: [] };
}
exports.ResponseListSnapshots = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.snapshots) {
            exports.Snapshot.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseResponseListSnapshots();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.snapshots.push(exports.Snapshot.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            snapshots: Array.isArray(object === null || object === void 0 ? void 0 : object.snapshots)
                ? object.snapshots.map((e) => exports.Snapshot.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.snapshots) {
            obj.snapshots = message.snapshots.map((e) => (e ? exports.Snapshot.toJSON(e) : undefined));
        }
        else {
            obj.snapshots = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseResponseListSnapshots();
        message.snapshots = ((_a = object.snapshots) === null || _a === void 0 ? void 0 : _a.map((e) => exports.Snapshot.fromPartial(e))) || [];
        return message;
    },
};
function createBaseResponseOfferSnapshot() {
    return { result: 0 };
}
exports.ResponseOfferSnapshot = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.result !== 0) {
            writer.uint32(8).int32(message.result);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseResponseOfferSnapshot();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.result = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { result: isSet(object.result) ? responseOfferSnapshot_ResultFromJSON(object.result) : 0 };
    },
    toJSON(message) {
        const obj = {};
        message.result !== undefined && (obj.result = responseOfferSnapshot_ResultToJSON(message.result));
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseResponseOfferSnapshot();
        message.result = (_a = object.result) !== null && _a !== void 0 ? _a : 0;
        return message;
    },
};
function createBaseResponseLoadSnapshotChunk() {
    return { chunk: new Uint8Array() };
}
exports.ResponseLoadSnapshotChunk = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.chunk.length !== 0) {
            writer.uint32(10).bytes(message.chunk);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseResponseLoadSnapshotChunk();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.chunk = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { chunk: isSet(object.chunk) ? bytesFromBase64(object.chunk) : new Uint8Array() };
    },
    toJSON(message) {
        const obj = {};
        message.chunk !== undefined &&
            (obj.chunk = base64FromBytes(message.chunk !== undefined ? message.chunk : new Uint8Array()));
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseResponseLoadSnapshotChunk();
        message.chunk = (_a = object.chunk) !== null && _a !== void 0 ? _a : new Uint8Array();
        return message;
    },
};
function createBaseResponseApplySnapshotChunk() {
    return { result: 0, refetchChunks: [], rejectSenders: [] };
}
exports.ResponseApplySnapshotChunk = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.result !== 0) {
            writer.uint32(8).int32(message.result);
        }
        writer.uint32(18).fork();
        for (const v of message.refetchChunks) {
            writer.uint32(v);
        }
        writer.ldelim();
        for (const v of message.rejectSenders) {
            writer.uint32(26).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseResponseApplySnapshotChunk();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.result = reader.int32();
                    break;
                case 2:
                    if ((tag & 7) === 2) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.refetchChunks.push(reader.uint32());
                        }
                    }
                    else {
                        message.refetchChunks.push(reader.uint32());
                    }
                    break;
                case 3:
                    message.rejectSenders.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            result: isSet(object.result) ? responseApplySnapshotChunk_ResultFromJSON(object.result) : 0,
            refetchChunks: Array.isArray(object === null || object === void 0 ? void 0 : object.refetchChunks)
                ? object.refetchChunks.map((e) => Number(e))
                : [],
            rejectSenders: Array.isArray(object === null || object === void 0 ? void 0 : object.rejectSenders)
                ? object.rejectSenders.map((e) => String(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        message.result !== undefined && (obj.result = responseApplySnapshotChunk_ResultToJSON(message.result));
        if (message.refetchChunks) {
            obj.refetchChunks = message.refetchChunks.map((e) => Math.round(e));
        }
        else {
            obj.refetchChunks = [];
        }
        if (message.rejectSenders) {
            obj.rejectSenders = message.rejectSenders.map((e) => e);
        }
        else {
            obj.rejectSenders = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseResponseApplySnapshotChunk();
        message.result = (_a = object.result) !== null && _a !== void 0 ? _a : 0;
        message.refetchChunks = ((_b = object.refetchChunks) === null || _b === void 0 ? void 0 : _b.map((e) => e)) || [];
        message.rejectSenders = ((_c = object.rejectSenders) === null || _c === void 0 ? void 0 : _c.map((e) => e)) || [];
        return message;
    },
};
function createBaseConsensusParams() {
    return { block: undefined, evidence: undefined, validator: undefined, version: undefined };
}
exports.ConsensusParams = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.block !== undefined) {
            exports.BlockParams.encode(message.block, writer.uint32(10).fork()).ldelim();
        }
        if (message.evidence !== undefined) {
            params_1.EvidenceParams.encode(message.evidence, writer.uint32(18).fork()).ldelim();
        }
        if (message.validator !== undefined) {
            params_1.ValidatorParams.encode(message.validator, writer.uint32(26).fork()).ldelim();
        }
        if (message.version !== undefined) {
            params_1.VersionParams.encode(message.version, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseConsensusParams();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.block = exports.BlockParams.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.evidence = params_1.EvidenceParams.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.validator = params_1.ValidatorParams.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.version = params_1.VersionParams.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            block: isSet(object.block) ? exports.BlockParams.fromJSON(object.block) : undefined,
            evidence: isSet(object.evidence) ? params_1.EvidenceParams.fromJSON(object.evidence) : undefined,
            validator: isSet(object.validator) ? params_1.ValidatorParams.fromJSON(object.validator) : undefined,
            version: isSet(object.version) ? params_1.VersionParams.fromJSON(object.version) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.block !== undefined &&
            (obj.block = message.block ? exports.BlockParams.toJSON(message.block) : undefined);
        message.evidence !== undefined &&
            (obj.evidence = message.evidence ? params_1.EvidenceParams.toJSON(message.evidence) : undefined);
        message.validator !== undefined &&
            (obj.validator = message.validator ? params_1.ValidatorParams.toJSON(message.validator) : undefined);
        message.version !== undefined &&
            (obj.version = message.version ? params_1.VersionParams.toJSON(message.version) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseConsensusParams();
        message.block =
            object.block !== undefined && object.block !== null ? exports.BlockParams.fromPartial(object.block) : undefined;
        message.evidence =
            object.evidence !== undefined && object.evidence !== null
                ? params_1.EvidenceParams.fromPartial(object.evidence)
                : undefined;
        message.validator =
            object.validator !== undefined && object.validator !== null
                ? params_1.ValidatorParams.fromPartial(object.validator)
                : undefined;
        message.version =
            object.version !== undefined && object.version !== null
                ? params_1.VersionParams.fromPartial(object.version)
                : undefined;
        return message;
    },
};
function createBaseBlockParams() {
    return { maxBytes: long_1.default.ZERO, maxGas: long_1.default.ZERO };
}
exports.BlockParams = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (!message.maxBytes.isZero()) {
            writer.uint32(8).int64(message.maxBytes);
        }
        if (!message.maxGas.isZero()) {
            writer.uint32(16).int64(message.maxGas);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseBlockParams();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.maxBytes = reader.int64();
                    break;
                case 2:
                    message.maxGas = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            maxBytes: isSet(object.maxBytes) ? long_1.default.fromValue(object.maxBytes) : long_1.default.ZERO,
            maxGas: isSet(object.maxGas) ? long_1.default.fromValue(object.maxGas) : long_1.default.ZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        message.maxBytes !== undefined && (obj.maxBytes = (message.maxBytes || long_1.default.ZERO).toString());
        message.maxGas !== undefined && (obj.maxGas = (message.maxGas || long_1.default.ZERO).toString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseBlockParams();
        message.maxBytes =
            object.maxBytes !== undefined && object.maxBytes !== null ? long_1.default.fromValue(object.maxBytes) : long_1.default.ZERO;
        message.maxGas =
            object.maxGas !== undefined && object.maxGas !== null ? long_1.default.fromValue(object.maxGas) : long_1.default.ZERO;
        return message;
    },
};
function createBaseLastCommitInfo() {
    return { round: 0, votes: [] };
}
exports.LastCommitInfo = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.round !== 0) {
            writer.uint32(8).int32(message.round);
        }
        for (const v of message.votes) {
            exports.VoteInfo.encode(v, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseLastCommitInfo();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.round = reader.int32();
                    break;
                case 2:
                    message.votes.push(exports.VoteInfo.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            round: isSet(object.round) ? Number(object.round) : 0,
            votes: Array.isArray(object === null || object === void 0 ? void 0 : object.votes) ? object.votes.map((e) => exports.VoteInfo.fromJSON(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        message.round !== undefined && (obj.round = Math.round(message.round));
        if (message.votes) {
            obj.votes = message.votes.map((e) => (e ? exports.VoteInfo.toJSON(e) : undefined));
        }
        else {
            obj.votes = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseLastCommitInfo();
        message.round = (_a = object.round) !== null && _a !== void 0 ? _a : 0;
        message.votes = ((_b = object.votes) === null || _b === void 0 ? void 0 : _b.map((e) => exports.VoteInfo.fromPartial(e))) || [];
        return message;
    },
};
function createBaseEvent() {
    return { type: "", attributes: [] };
}
exports.Event = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.type !== "") {
            writer.uint32(10).string(message.type);
        }
        for (const v of message.attributes) {
            exports.EventAttribute.encode(v, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseEvent();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.type = reader.string();
                    break;
                case 2:
                    message.attributes.push(exports.EventAttribute.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            type: isSet(object.type) ? String(object.type) : "",
            attributes: Array.isArray(object === null || object === void 0 ? void 0 : object.attributes)
                ? object.attributes.map((e) => exports.EventAttribute.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        message.type !== undefined && (obj.type = message.type);
        if (message.attributes) {
            obj.attributes = message.attributes.map((e) => (e ? exports.EventAttribute.toJSON(e) : undefined));
        }
        else {
            obj.attributes = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseEvent();
        message.type = (_a = object.type) !== null && _a !== void 0 ? _a : "";
        message.attributes = ((_b = object.attributes) === null || _b === void 0 ? void 0 : _b.map((e) => exports.EventAttribute.fromPartial(e))) || [];
        return message;
    },
};
function createBaseEventAttribute() {
    return { key: new Uint8Array(), value: new Uint8Array(), index: false };
}
exports.EventAttribute = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.key.length !== 0) {
            writer.uint32(10).bytes(message.key);
        }
        if (message.value.length !== 0) {
            writer.uint32(18).bytes(message.value);
        }
        if (message.index === true) {
            writer.uint32(24).bool(message.index);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseEventAttribute();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.key = reader.bytes();
                    break;
                case 2:
                    message.value = reader.bytes();
                    break;
                case 3:
                    message.index = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            key: isSet(object.key) ? bytesFromBase64(object.key) : new Uint8Array(),
            value: isSet(object.value) ? bytesFromBase64(object.value) : new Uint8Array(),
            index: isSet(object.index) ? Boolean(object.index) : false,
        };
    },
    toJSON(message) {
        const obj = {};
        message.key !== undefined &&
            (obj.key = base64FromBytes(message.key !== undefined ? message.key : new Uint8Array()));
        message.value !== undefined &&
            (obj.value = base64FromBytes(message.value !== undefined ? message.value : new Uint8Array()));
        message.index !== undefined && (obj.index = message.index);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseEventAttribute();
        message.key = (_a = object.key) !== null && _a !== void 0 ? _a : new Uint8Array();
        message.value = (_b = object.value) !== null && _b !== void 0 ? _b : new Uint8Array();
        message.index = (_c = object.index) !== null && _c !== void 0 ? _c : false;
        return message;
    },
};
function createBaseTxResult() {
    return { height: long_1.default.ZERO, index: 0, tx: new Uint8Array(), result: undefined };
}
exports.TxResult = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (!message.height.isZero()) {
            writer.uint32(8).int64(message.height);
        }
        if (message.index !== 0) {
            writer.uint32(16).uint32(message.index);
        }
        if (message.tx.length !== 0) {
            writer.uint32(26).bytes(message.tx);
        }
        if (message.result !== undefined) {
            exports.ResponseDeliverTx.encode(message.result, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTxResult();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.height = reader.int64();
                    break;
                case 2:
                    message.index = reader.uint32();
                    break;
                case 3:
                    message.tx = reader.bytes();
                    break;
                case 4:
                    message.result = exports.ResponseDeliverTx.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            height: isSet(object.height) ? long_1.default.fromValue(object.height) : long_1.default.ZERO,
            index: isSet(object.index) ? Number(object.index) : 0,
            tx: isSet(object.tx) ? bytesFromBase64(object.tx) : new Uint8Array(),
            result: isSet(object.result) ? exports.ResponseDeliverTx.fromJSON(object.result) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.height !== undefined && (obj.height = (message.height || long_1.default.ZERO).toString());
        message.index !== undefined && (obj.index = Math.round(message.index));
        message.tx !== undefined &&
            (obj.tx = base64FromBytes(message.tx !== undefined ? message.tx : new Uint8Array()));
        message.result !== undefined &&
            (obj.result = message.result ? exports.ResponseDeliverTx.toJSON(message.result) : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseTxResult();
        message.height =
            object.height !== undefined && object.height !== null ? long_1.default.fromValue(object.height) : long_1.default.ZERO;
        message.index = (_a = object.index) !== null && _a !== void 0 ? _a : 0;
        message.tx = (_b = object.tx) !== null && _b !== void 0 ? _b : new Uint8Array();
        message.result =
            object.result !== undefined && object.result !== null
                ? exports.ResponseDeliverTx.fromPartial(object.result)
                : undefined;
        return message;
    },
};
function createBaseValidator() {
    return { address: new Uint8Array(), power: long_1.default.ZERO };
}
exports.Validator = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.address.length !== 0) {
            writer.uint32(10).bytes(message.address);
        }
        if (!message.power.isZero()) {
            writer.uint32(24).int64(message.power);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseValidator();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.address = reader.bytes();
                    break;
                case 3:
                    message.power = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            address: isSet(object.address) ? bytesFromBase64(object.address) : new Uint8Array(),
            power: isSet(object.power) ? long_1.default.fromValue(object.power) : long_1.default.ZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        message.address !== undefined &&
            (obj.address = base64FromBytes(message.address !== undefined ? message.address : new Uint8Array()));
        message.power !== undefined && (obj.power = (message.power || long_1.default.ZERO).toString());
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseValidator();
        message.address = (_a = object.address) !== null && _a !== void 0 ? _a : new Uint8Array();
        message.power =
            object.power !== undefined && object.power !== null ? long_1.default.fromValue(object.power) : long_1.default.ZERO;
        return message;
    },
};
function createBaseValidatorUpdate() {
    return { pubKey: undefined, power: long_1.default.ZERO };
}
exports.ValidatorUpdate = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.pubKey !== undefined) {
            keys_1.PublicKey.encode(message.pubKey, writer.uint32(10).fork()).ldelim();
        }
        if (!message.power.isZero()) {
            writer.uint32(16).int64(message.power);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseValidatorUpdate();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.pubKey = keys_1.PublicKey.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.power = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            pubKey: isSet(object.pubKey) ? keys_1.PublicKey.fromJSON(object.pubKey) : undefined,
            power: isSet(object.power) ? long_1.default.fromValue(object.power) : long_1.default.ZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        message.pubKey !== undefined &&
            (obj.pubKey = message.pubKey ? keys_1.PublicKey.toJSON(message.pubKey) : undefined);
        message.power !== undefined && (obj.power = (message.power || long_1.default.ZERO).toString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseValidatorUpdate();
        message.pubKey =
            object.pubKey !== undefined && object.pubKey !== null
                ? keys_1.PublicKey.fromPartial(object.pubKey)
                : undefined;
        message.power =
            object.power !== undefined && object.power !== null ? long_1.default.fromValue(object.power) : long_1.default.ZERO;
        return message;
    },
};
function createBaseVoteInfo() {
    return { validator: undefined, signedLastBlock: false };
}
exports.VoteInfo = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.validator !== undefined) {
            exports.Validator.encode(message.validator, writer.uint32(10).fork()).ldelim();
        }
        if (message.signedLastBlock === true) {
            writer.uint32(16).bool(message.signedLastBlock);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVoteInfo();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.validator = exports.Validator.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.signedLastBlock = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            validator: isSet(object.validator) ? exports.Validator.fromJSON(object.validator) : undefined,
            signedLastBlock: isSet(object.signedLastBlock) ? Boolean(object.signedLastBlock) : false,
        };
    },
    toJSON(message) {
        const obj = {};
        message.validator !== undefined &&
            (obj.validator = message.validator ? exports.Validator.toJSON(message.validator) : undefined);
        message.signedLastBlock !== undefined && (obj.signedLastBlock = message.signedLastBlock);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseVoteInfo();
        message.validator =
            object.validator !== undefined && object.validator !== null
                ? exports.Validator.fromPartial(object.validator)
                : undefined;
        message.signedLastBlock = (_a = object.signedLastBlock) !== null && _a !== void 0 ? _a : false;
        return message;
    },
};
function createBaseEvidence() {
    return { type: 0, validator: undefined, height: long_1.default.ZERO, time: undefined, totalVotingPower: long_1.default.ZERO };
}
exports.Evidence = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.type !== 0) {
            writer.uint32(8).int32(message.type);
        }
        if (message.validator !== undefined) {
            exports.Validator.encode(message.validator, writer.uint32(18).fork()).ldelim();
        }
        if (!message.height.isZero()) {
            writer.uint32(24).int64(message.height);
        }
        if (message.time !== undefined) {
            timestamp_1.Timestamp.encode(message.time, writer.uint32(34).fork()).ldelim();
        }
        if (!message.totalVotingPower.isZero()) {
            writer.uint32(40).int64(message.totalVotingPower);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseEvidence();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.type = reader.int32();
                    break;
                case 2:
                    message.validator = exports.Validator.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.height = reader.int64();
                    break;
                case 4:
                    message.time = timestamp_1.Timestamp.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.totalVotingPower = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            type: isSet(object.type) ? evidenceTypeFromJSON(object.type) : 0,
            validator: isSet(object.validator) ? exports.Validator.fromJSON(object.validator) : undefined,
            height: isSet(object.height) ? long_1.default.fromValue(object.height) : long_1.default.ZERO,
            time: isSet(object.time) ? fromJsonTimestamp(object.time) : undefined,
            totalVotingPower: isSet(object.totalVotingPower) ? long_1.default.fromValue(object.totalVotingPower) : long_1.default.ZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        message.type !== undefined && (obj.type = evidenceTypeToJSON(message.type));
        message.validator !== undefined &&
            (obj.validator = message.validator ? exports.Validator.toJSON(message.validator) : undefined);
        message.height !== undefined && (obj.height = (message.height || long_1.default.ZERO).toString());
        message.time !== undefined && (obj.time = fromTimestamp(message.time).toISOString());
        message.totalVotingPower !== undefined &&
            (obj.totalVotingPower = (message.totalVotingPower || long_1.default.ZERO).toString());
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseEvidence();
        message.type = (_a = object.type) !== null && _a !== void 0 ? _a : 0;
        message.validator =
            object.validator !== undefined && object.validator !== null
                ? exports.Validator.fromPartial(object.validator)
                : undefined;
        message.height =
            object.height !== undefined && object.height !== null ? long_1.default.fromValue(object.height) : long_1.default.ZERO;
        message.time =
            object.time !== undefined && object.time !== null ? timestamp_1.Timestamp.fromPartial(object.time) : undefined;
        message.totalVotingPower =
            object.totalVotingPower !== undefined && object.totalVotingPower !== null
                ? long_1.default.fromValue(object.totalVotingPower)
                : long_1.default.ZERO;
        return message;
    },
};
function createBaseSnapshot() {
    return { height: long_1.default.UZERO, format: 0, chunks: 0, hash: new Uint8Array(), metadata: new Uint8Array() };
}
exports.Snapshot = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (!message.height.isZero()) {
            writer.uint32(8).uint64(message.height);
        }
        if (message.format !== 0) {
            writer.uint32(16).uint32(message.format);
        }
        if (message.chunks !== 0) {
            writer.uint32(24).uint32(message.chunks);
        }
        if (message.hash.length !== 0) {
            writer.uint32(34).bytes(message.hash);
        }
        if (message.metadata.length !== 0) {
            writer.uint32(42).bytes(message.metadata);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSnapshot();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.height = reader.uint64();
                    break;
                case 2:
                    message.format = reader.uint32();
                    break;
                case 3:
                    message.chunks = reader.uint32();
                    break;
                case 4:
                    message.hash = reader.bytes();
                    break;
                case 5:
                    message.metadata = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            height: isSet(object.height) ? long_1.default.fromValue(object.height) : long_1.default.UZERO,
            format: isSet(object.format) ? Number(object.format) : 0,
            chunks: isSet(object.chunks) ? Number(object.chunks) : 0,
            hash: isSet(object.hash) ? bytesFromBase64(object.hash) : new Uint8Array(),
            metadata: isSet(object.metadata) ? bytesFromBase64(object.metadata) : new Uint8Array(),
        };
    },
    toJSON(message) {
        const obj = {};
        message.height !== undefined && (obj.height = (message.height || long_1.default.UZERO).toString());
        message.format !== undefined && (obj.format = Math.round(message.format));
        message.chunks !== undefined && (obj.chunks = Math.round(message.chunks));
        message.hash !== undefined &&
            (obj.hash = base64FromBytes(message.hash !== undefined ? message.hash : new Uint8Array()));
        message.metadata !== undefined &&
            (obj.metadata = base64FromBytes(message.metadata !== undefined ? message.metadata : new Uint8Array()));
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d;
        const message = createBaseSnapshot();
        message.height =
            object.height !== undefined && object.height !== null ? long_1.default.fromValue(object.height) : long_1.default.UZERO;
        message.format = (_a = object.format) !== null && _a !== void 0 ? _a : 0;
        message.chunks = (_b = object.chunks) !== null && _b !== void 0 ? _b : 0;
        message.hash = (_c = object.hash) !== null && _c !== void 0 ? _c : new Uint8Array();
        message.metadata = (_d = object.metadata) !== null && _d !== void 0 ? _d : new Uint8Array();
        return message;
    },
};
class ABCIApplicationClientImpl {
    constructor(rpc) {
        this.rpc = rpc;
        this.Echo = this.Echo.bind(this);
        this.Flush = this.Flush.bind(this);
        this.Info = this.Info.bind(this);
        this.SetOption = this.SetOption.bind(this);
        this.DeliverTx = this.DeliverTx.bind(this);
        this.CheckTx = this.CheckTx.bind(this);
        this.Query = this.Query.bind(this);
        this.Commit = this.Commit.bind(this);
        this.InitChain = this.InitChain.bind(this);
        this.BeginBlock = this.BeginBlock.bind(this);
        this.EndBlock = this.EndBlock.bind(this);
        this.ListSnapshots = this.ListSnapshots.bind(this);
        this.OfferSnapshot = this.OfferSnapshot.bind(this);
        this.LoadSnapshotChunk = this.LoadSnapshotChunk.bind(this);
        this.ApplySnapshotChunk = this.ApplySnapshotChunk.bind(this);
    }
    Echo(request) {
        const data = exports.RequestEcho.encode(request).finish();
        const promise = this.rpc.request("tendermint.abci.ABCIApplication", "Echo", data);
        return promise.then((data) => exports.ResponseEcho.decode(new minimal_1.default.Reader(data)));
    }
    Flush(request) {
        const data = exports.RequestFlush.encode(request).finish();
        const promise = this.rpc.request("tendermint.abci.ABCIApplication", "Flush", data);
        return promise.then((data) => exports.ResponseFlush.decode(new minimal_1.default.Reader(data)));
    }
    Info(request) {
        const data = exports.RequestInfo.encode(request).finish();
        const promise = this.rpc.request("tendermint.abci.ABCIApplication", "Info", data);
        return promise.then((data) => exports.ResponseInfo.decode(new minimal_1.default.Reader(data)));
    }
    SetOption(request) {
        const data = exports.RequestSetOption.encode(request).finish();
        const promise = this.rpc.request("tendermint.abci.ABCIApplication", "SetOption", data);
        return promise.then((data) => exports.ResponseSetOption.decode(new minimal_1.default.Reader(data)));
    }
    DeliverTx(request) {
        const data = exports.RequestDeliverTx.encode(request).finish();
        const promise = this.rpc.request("tendermint.abci.ABCIApplication", "DeliverTx", data);
        return promise.then((data) => exports.ResponseDeliverTx.decode(new minimal_1.default.Reader(data)));
    }
    CheckTx(request) {
        const data = exports.RequestCheckTx.encode(request).finish();
        const promise = this.rpc.request("tendermint.abci.ABCIApplication", "CheckTx", data);
        return promise.then((data) => exports.ResponseCheckTx.decode(new minimal_1.default.Reader(data)));
    }
    Query(request) {
        const data = exports.RequestQuery.encode(request).finish();
        const promise = this.rpc.request("tendermint.abci.ABCIApplication", "Query", data);
        return promise.then((data) => exports.ResponseQuery.decode(new minimal_1.default.Reader(data)));
    }
    Commit(request) {
        const data = exports.RequestCommit.encode(request).finish();
        const promise = this.rpc.request("tendermint.abci.ABCIApplication", "Commit", data);
        return promise.then((data) => exports.ResponseCommit.decode(new minimal_1.default.Reader(data)));
    }
    InitChain(request) {
        const data = exports.RequestInitChain.encode(request).finish();
        const promise = this.rpc.request("tendermint.abci.ABCIApplication", "InitChain", data);
        return promise.then((data) => exports.ResponseInitChain.decode(new minimal_1.default.Reader(data)));
    }
    BeginBlock(request) {
        const data = exports.RequestBeginBlock.encode(request).finish();
        const promise = this.rpc.request("tendermint.abci.ABCIApplication", "BeginBlock", data);
        return promise.then((data) => exports.ResponseBeginBlock.decode(new minimal_1.default.Reader(data)));
    }
    EndBlock(request) {
        const data = exports.RequestEndBlock.encode(request).finish();
        const promise = this.rpc.request("tendermint.abci.ABCIApplication", "EndBlock", data);
        return promise.then((data) => exports.ResponseEndBlock.decode(new minimal_1.default.Reader(data)));
    }
    ListSnapshots(request) {
        const data = exports.RequestListSnapshots.encode(request).finish();
        const promise = this.rpc.request("tendermint.abci.ABCIApplication", "ListSnapshots", data);
        return promise.then((data) => exports.ResponseListSnapshots.decode(new minimal_1.default.Reader(data)));
    }
    OfferSnapshot(request) {
        const data = exports.RequestOfferSnapshot.encode(request).finish();
        const promise = this.rpc.request("tendermint.abci.ABCIApplication", "OfferSnapshot", data);
        return promise.then((data) => exports.ResponseOfferSnapshot.decode(new minimal_1.default.Reader(data)));
    }
    LoadSnapshotChunk(request) {
        const data = exports.RequestLoadSnapshotChunk.encode(request).finish();
        const promise = this.rpc.request("tendermint.abci.ABCIApplication", "LoadSnapshotChunk", data);
        return promise.then((data) => exports.ResponseLoadSnapshotChunk.decode(new minimal_1.default.Reader(data)));
    }
    ApplySnapshotChunk(request) {
        const data = exports.RequestApplySnapshotChunk.encode(request).finish();
        const promise = this.rpc.request("tendermint.abci.ABCIApplication", "ApplySnapshotChunk", data);
        return promise.then((data) => exports.ResponseApplySnapshotChunk.decode(new minimal_1.default.Reader(data)));
    }
}
exports.ABCIApplicationClientImpl = ABCIApplicationClientImpl;
var globalThis = (() => {
    if (typeof globalThis !== "undefined") {
        return globalThis;
    }
    if (typeof self !== "undefined") {
        return self;
    }
    if (typeof window !== "undefined") {
        return window;
    }
    if (typeof __webpack_require__.g !== "undefined") {
        return __webpack_require__.g;
    }
    throw "Unable to locate global object";
})();
function bytesFromBase64(b64) {
    if (globalThis.Buffer) {
        return Uint8Array.from(globalThis.Buffer.from(b64, "base64"));
    }
    else {
        const bin = globalThis.atob(b64);
        const arr = new Uint8Array(bin.length);
        for (let i = 0; i < bin.length; ++i) {
            arr[i] = bin.charCodeAt(i);
        }
        return arr;
    }
}
function base64FromBytes(arr) {
    if (globalThis.Buffer) {
        return globalThis.Buffer.from(arr).toString("base64");
    }
    else {
        const bin = [];
        arr.forEach((byte) => {
            bin.push(String.fromCharCode(byte));
        });
        return globalThis.btoa(bin.join(""));
    }
}
function toTimestamp(date) {
    const seconds = numberToLong(date.getTime() / 1000);
    const nanos = (date.getTime() % 1000) * 1000000;
    return { seconds, nanos };
}
function fromTimestamp(t) {
    let millis = t.seconds.toNumber() * 1000;
    millis += t.nanos / 1000000;
    return new Date(millis);
}
function fromJsonTimestamp(o) {
    if (o instanceof Date) {
        return toTimestamp(o);
    }
    else if (typeof o === "string") {
        return toTimestamp(new Date(o));
    }
    else {
        return timestamp_1.Timestamp.fromJSON(o);
    }
}
function numberToLong(number) {
    return long_1.default.fromNumber(number);
}
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=types.js.map

/***/ }),

/***/ 54568:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PublicKey = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(__webpack_require__(47873));
const minimal_1 = __importDefault(__webpack_require__(62100));
exports.protobufPackage = "tendermint.crypto";
function createBasePublicKey() {
    return { ed25519: undefined, secp256k1: undefined };
}
exports.PublicKey = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.ed25519 !== undefined) {
            writer.uint32(10).bytes(message.ed25519);
        }
        if (message.secp256k1 !== undefined) {
            writer.uint32(18).bytes(message.secp256k1);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePublicKey();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.ed25519 = reader.bytes();
                    break;
                case 2:
                    message.secp256k1 = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            ed25519: isSet(object.ed25519) ? bytesFromBase64(object.ed25519) : undefined,
            secp256k1: isSet(object.secp256k1) ? bytesFromBase64(object.secp256k1) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.ed25519 !== undefined &&
            (obj.ed25519 = message.ed25519 !== undefined ? base64FromBytes(message.ed25519) : undefined);
        message.secp256k1 !== undefined &&
            (obj.secp256k1 = message.secp256k1 !== undefined ? base64FromBytes(message.secp256k1) : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBasePublicKey();
        message.ed25519 = (_a = object.ed25519) !== null && _a !== void 0 ? _a : undefined;
        message.secp256k1 = (_b = object.secp256k1) !== null && _b !== void 0 ? _b : undefined;
        return message;
    },
};
var globalThis = (() => {
    if (typeof globalThis !== "undefined") {
        return globalThis;
    }
    if (typeof self !== "undefined") {
        return self;
    }
    if (typeof window !== "undefined") {
        return window;
    }
    if (typeof __webpack_require__.g !== "undefined") {
        return __webpack_require__.g;
    }
    throw "Unable to locate global object";
})();
function bytesFromBase64(b64) {
    if (globalThis.Buffer) {
        return Uint8Array.from(globalThis.Buffer.from(b64, "base64"));
    }
    else {
        const bin = globalThis.atob(b64);
        const arr = new Uint8Array(bin.length);
        for (let i = 0; i < bin.length; ++i) {
            arr[i] = bin.charCodeAt(i);
        }
        return arr;
    }
}
function base64FromBytes(arr) {
    if (globalThis.Buffer) {
        return globalThis.Buffer.from(arr).toString("base64");
    }
    else {
        const bin = [];
        arr.forEach((byte) => {
            bin.push(String.fromCharCode(byte));
        });
        return globalThis.btoa(bin.join(""));
    }
}
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=keys.js.map

/***/ }),

/***/ 60730:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ProofOps = exports.ProofOp = exports.DominoOp = exports.ValueOp = exports.Proof = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(__webpack_require__(47873));
const minimal_1 = __importDefault(__webpack_require__(62100));
exports.protobufPackage = "tendermint.crypto";
function createBaseProof() {
    return { total: long_1.default.ZERO, index: long_1.default.ZERO, leafHash: new Uint8Array(), aunts: [] };
}
exports.Proof = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (!message.total.isZero()) {
            writer.uint32(8).int64(message.total);
        }
        if (!message.index.isZero()) {
            writer.uint32(16).int64(message.index);
        }
        if (message.leafHash.length !== 0) {
            writer.uint32(26).bytes(message.leafHash);
        }
        for (const v of message.aunts) {
            writer.uint32(34).bytes(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseProof();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.total = reader.int64();
                    break;
                case 2:
                    message.index = reader.int64();
                    break;
                case 3:
                    message.leafHash = reader.bytes();
                    break;
                case 4:
                    message.aunts.push(reader.bytes());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            total: isSet(object.total) ? long_1.default.fromValue(object.total) : long_1.default.ZERO,
            index: isSet(object.index) ? long_1.default.fromValue(object.index) : long_1.default.ZERO,
            leafHash: isSet(object.leafHash) ? bytesFromBase64(object.leafHash) : new Uint8Array(),
            aunts: Array.isArray(object === null || object === void 0 ? void 0 : object.aunts) ? object.aunts.map((e) => bytesFromBase64(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        message.total !== undefined && (obj.total = (message.total || long_1.default.ZERO).toString());
        message.index !== undefined && (obj.index = (message.index || long_1.default.ZERO).toString());
        message.leafHash !== undefined &&
            (obj.leafHash = base64FromBytes(message.leafHash !== undefined ? message.leafHash : new Uint8Array()));
        if (message.aunts) {
            obj.aunts = message.aunts.map((e) => base64FromBytes(e !== undefined ? e : new Uint8Array()));
        }
        else {
            obj.aunts = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseProof();
        message.total =
            object.total !== undefined && object.total !== null ? long_1.default.fromValue(object.total) : long_1.default.ZERO;
        message.index =
            object.index !== undefined && object.index !== null ? long_1.default.fromValue(object.index) : long_1.default.ZERO;
        message.leafHash = (_a = object.leafHash) !== null && _a !== void 0 ? _a : new Uint8Array();
        message.aunts = ((_b = object.aunts) === null || _b === void 0 ? void 0 : _b.map((e) => e)) || [];
        return message;
    },
};
function createBaseValueOp() {
    return { key: new Uint8Array(), proof: undefined };
}
exports.ValueOp = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.key.length !== 0) {
            writer.uint32(10).bytes(message.key);
        }
        if (message.proof !== undefined) {
            exports.Proof.encode(message.proof, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseValueOp();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.key = reader.bytes();
                    break;
                case 2:
                    message.proof = exports.Proof.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            key: isSet(object.key) ? bytesFromBase64(object.key) : new Uint8Array(),
            proof: isSet(object.proof) ? exports.Proof.fromJSON(object.proof) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.key !== undefined &&
            (obj.key = base64FromBytes(message.key !== undefined ? message.key : new Uint8Array()));
        message.proof !== undefined && (obj.proof = message.proof ? exports.Proof.toJSON(message.proof) : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseValueOp();
        message.key = (_a = object.key) !== null && _a !== void 0 ? _a : new Uint8Array();
        message.proof =
            object.proof !== undefined && object.proof !== null ? exports.Proof.fromPartial(object.proof) : undefined;
        return message;
    },
};
function createBaseDominoOp() {
    return { key: "", input: "", output: "" };
}
exports.DominoOp = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.key !== "") {
            writer.uint32(10).string(message.key);
        }
        if (message.input !== "") {
            writer.uint32(18).string(message.input);
        }
        if (message.output !== "") {
            writer.uint32(26).string(message.output);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDominoOp();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.key = reader.string();
                    break;
                case 2:
                    message.input = reader.string();
                    break;
                case 3:
                    message.output = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            key: isSet(object.key) ? String(object.key) : "",
            input: isSet(object.input) ? String(object.input) : "",
            output: isSet(object.output) ? String(object.output) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.key !== undefined && (obj.key = message.key);
        message.input !== undefined && (obj.input = message.input);
        message.output !== undefined && (obj.output = message.output);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseDominoOp();
        message.key = (_a = object.key) !== null && _a !== void 0 ? _a : "";
        message.input = (_b = object.input) !== null && _b !== void 0 ? _b : "";
        message.output = (_c = object.output) !== null && _c !== void 0 ? _c : "";
        return message;
    },
};
function createBaseProofOp() {
    return { type: "", key: new Uint8Array(), data: new Uint8Array() };
}
exports.ProofOp = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.type !== "") {
            writer.uint32(10).string(message.type);
        }
        if (message.key.length !== 0) {
            writer.uint32(18).bytes(message.key);
        }
        if (message.data.length !== 0) {
            writer.uint32(26).bytes(message.data);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseProofOp();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.type = reader.string();
                    break;
                case 2:
                    message.key = reader.bytes();
                    break;
                case 3:
                    message.data = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            type: isSet(object.type) ? String(object.type) : "",
            key: isSet(object.key) ? bytesFromBase64(object.key) : new Uint8Array(),
            data: isSet(object.data) ? bytesFromBase64(object.data) : new Uint8Array(),
        };
    },
    toJSON(message) {
        const obj = {};
        message.type !== undefined && (obj.type = message.type);
        message.key !== undefined &&
            (obj.key = base64FromBytes(message.key !== undefined ? message.key : new Uint8Array()));
        message.data !== undefined &&
            (obj.data = base64FromBytes(message.data !== undefined ? message.data : new Uint8Array()));
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseProofOp();
        message.type = (_a = object.type) !== null && _a !== void 0 ? _a : "";
        message.key = (_b = object.key) !== null && _b !== void 0 ? _b : new Uint8Array();
        message.data = (_c = object.data) !== null && _c !== void 0 ? _c : new Uint8Array();
        return message;
    },
};
function createBaseProofOps() {
    return { ops: [] };
}
exports.ProofOps = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.ops) {
            exports.ProofOp.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseProofOps();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.ops.push(exports.ProofOp.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { ops: Array.isArray(object === null || object === void 0 ? void 0 : object.ops) ? object.ops.map((e) => exports.ProofOp.fromJSON(e)) : [] };
    },
    toJSON(message) {
        const obj = {};
        if (message.ops) {
            obj.ops = message.ops.map((e) => (e ? exports.ProofOp.toJSON(e) : undefined));
        }
        else {
            obj.ops = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseProofOps();
        message.ops = ((_a = object.ops) === null || _a === void 0 ? void 0 : _a.map((e) => exports.ProofOp.fromPartial(e))) || [];
        return message;
    },
};
var globalThis = (() => {
    if (typeof globalThis !== "undefined") {
        return globalThis;
    }
    if (typeof self !== "undefined") {
        return self;
    }
    if (typeof window !== "undefined") {
        return window;
    }
    if (typeof __webpack_require__.g !== "undefined") {
        return __webpack_require__.g;
    }
    throw "Unable to locate global object";
})();
function bytesFromBase64(b64) {
    if (globalThis.Buffer) {
        return Uint8Array.from(globalThis.Buffer.from(b64, "base64"));
    }
    else {
        const bin = globalThis.atob(b64);
        const arr = new Uint8Array(bin.length);
        for (let i = 0; i < bin.length; ++i) {
            arr[i] = bin.charCodeAt(i);
        }
        return arr;
    }
}
function base64FromBytes(arr) {
    if (globalThis.Buffer) {
        return globalThis.Buffer.from(arr).toString("base64");
    }
    else {
        const bin = [];
        arr.forEach((byte) => {
            bin.push(String.fromCharCode(byte));
        });
        return globalThis.btoa(bin.join(""));
    }
}
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=proof.js.map

/***/ }),

/***/ 62516:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Block = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(__webpack_require__(47873));
const minimal_1 = __importDefault(__webpack_require__(62100));
const evidence_1 = __webpack_require__(63860);
const types_1 = __webpack_require__(54028);
exports.protobufPackage = "tendermint.types";
function createBaseBlock() {
    return { header: undefined, data: undefined, evidence: undefined, lastCommit: undefined };
}
exports.Block = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.header !== undefined) {
            types_1.Header.encode(message.header, writer.uint32(10).fork()).ldelim();
        }
        if (message.data !== undefined) {
            types_1.Data.encode(message.data, writer.uint32(18).fork()).ldelim();
        }
        if (message.evidence !== undefined) {
            evidence_1.EvidenceList.encode(message.evidence, writer.uint32(26).fork()).ldelim();
        }
        if (message.lastCommit !== undefined) {
            types_1.Commit.encode(message.lastCommit, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseBlock();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.header = types_1.Header.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.data = types_1.Data.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.evidence = evidence_1.EvidenceList.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.lastCommit = types_1.Commit.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            header: isSet(object.header) ? types_1.Header.fromJSON(object.header) : undefined,
            data: isSet(object.data) ? types_1.Data.fromJSON(object.data) : undefined,
            evidence: isSet(object.evidence) ? evidence_1.EvidenceList.fromJSON(object.evidence) : undefined,
            lastCommit: isSet(object.lastCommit) ? types_1.Commit.fromJSON(object.lastCommit) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.header !== undefined && (obj.header = message.header ? types_1.Header.toJSON(message.header) : undefined);
        message.data !== undefined && (obj.data = message.data ? types_1.Data.toJSON(message.data) : undefined);
        message.evidence !== undefined &&
            (obj.evidence = message.evidence ? evidence_1.EvidenceList.toJSON(message.evidence) : undefined);
        message.lastCommit !== undefined &&
            (obj.lastCommit = message.lastCommit ? types_1.Commit.toJSON(message.lastCommit) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseBlock();
        message.header =
            object.header !== undefined && object.header !== null ? types_1.Header.fromPartial(object.header) : undefined;
        message.data =
            object.data !== undefined && object.data !== null ? types_1.Data.fromPartial(object.data) : undefined;
        message.evidence =
            object.evidence !== undefined && object.evidence !== null
                ? evidence_1.EvidenceList.fromPartial(object.evidence)
                : undefined;
        message.lastCommit =
            object.lastCommit !== undefined && object.lastCommit !== null
                ? types_1.Commit.fromPartial(object.lastCommit)
                : undefined;
        return message;
    },
};
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=block.js.map

/***/ }),

/***/ 63860:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.EvidenceList = exports.LightClientAttackEvidence = exports.DuplicateVoteEvidence = exports.Evidence = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(__webpack_require__(47873));
const minimal_1 = __importDefault(__webpack_require__(62100));
const timestamp_1 = __webpack_require__(76620);
const types_1 = __webpack_require__(54028);
const validator_1 = __webpack_require__(75293);
exports.protobufPackage = "tendermint.types";
function createBaseEvidence() {
    return { duplicateVoteEvidence: undefined, lightClientAttackEvidence: undefined };
}
exports.Evidence = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.duplicateVoteEvidence !== undefined) {
            exports.DuplicateVoteEvidence.encode(message.duplicateVoteEvidence, writer.uint32(10).fork()).ldelim();
        }
        if (message.lightClientAttackEvidence !== undefined) {
            exports.LightClientAttackEvidence.encode(message.lightClientAttackEvidence, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseEvidence();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.duplicateVoteEvidence = exports.DuplicateVoteEvidence.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.lightClientAttackEvidence = exports.LightClientAttackEvidence.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            duplicateVoteEvidence: isSet(object.duplicateVoteEvidence)
                ? exports.DuplicateVoteEvidence.fromJSON(object.duplicateVoteEvidence)
                : undefined,
            lightClientAttackEvidence: isSet(object.lightClientAttackEvidence)
                ? exports.LightClientAttackEvidence.fromJSON(object.lightClientAttackEvidence)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.duplicateVoteEvidence !== undefined &&
            (obj.duplicateVoteEvidence = message.duplicateVoteEvidence
                ? exports.DuplicateVoteEvidence.toJSON(message.duplicateVoteEvidence)
                : undefined);
        message.lightClientAttackEvidence !== undefined &&
            (obj.lightClientAttackEvidence = message.lightClientAttackEvidence
                ? exports.LightClientAttackEvidence.toJSON(message.lightClientAttackEvidence)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseEvidence();
        message.duplicateVoteEvidence =
            object.duplicateVoteEvidence !== undefined && object.duplicateVoteEvidence !== null
                ? exports.DuplicateVoteEvidence.fromPartial(object.duplicateVoteEvidence)
                : undefined;
        message.lightClientAttackEvidence =
            object.lightClientAttackEvidence !== undefined && object.lightClientAttackEvidence !== null
                ? exports.LightClientAttackEvidence.fromPartial(object.lightClientAttackEvidence)
                : undefined;
        return message;
    },
};
function createBaseDuplicateVoteEvidence() {
    return {
        voteA: undefined,
        voteB: undefined,
        totalVotingPower: long_1.default.ZERO,
        validatorPower: long_1.default.ZERO,
        timestamp: undefined,
    };
}
exports.DuplicateVoteEvidence = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.voteA !== undefined) {
            types_1.Vote.encode(message.voteA, writer.uint32(10).fork()).ldelim();
        }
        if (message.voteB !== undefined) {
            types_1.Vote.encode(message.voteB, writer.uint32(18).fork()).ldelim();
        }
        if (!message.totalVotingPower.isZero()) {
            writer.uint32(24).int64(message.totalVotingPower);
        }
        if (!message.validatorPower.isZero()) {
            writer.uint32(32).int64(message.validatorPower);
        }
        if (message.timestamp !== undefined) {
            timestamp_1.Timestamp.encode(message.timestamp, writer.uint32(42).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDuplicateVoteEvidence();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.voteA = types_1.Vote.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.voteB = types_1.Vote.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.totalVotingPower = reader.int64();
                    break;
                case 4:
                    message.validatorPower = reader.int64();
                    break;
                case 5:
                    message.timestamp = timestamp_1.Timestamp.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            voteA: isSet(object.voteA) ? types_1.Vote.fromJSON(object.voteA) : undefined,
            voteB: isSet(object.voteB) ? types_1.Vote.fromJSON(object.voteB) : undefined,
            totalVotingPower: isSet(object.totalVotingPower) ? long_1.default.fromValue(object.totalVotingPower) : long_1.default.ZERO,
            validatorPower: isSet(object.validatorPower) ? long_1.default.fromValue(object.validatorPower) : long_1.default.ZERO,
            timestamp: isSet(object.timestamp) ? fromJsonTimestamp(object.timestamp) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.voteA !== undefined && (obj.voteA = message.voteA ? types_1.Vote.toJSON(message.voteA) : undefined);
        message.voteB !== undefined && (obj.voteB = message.voteB ? types_1.Vote.toJSON(message.voteB) : undefined);
        message.totalVotingPower !== undefined &&
            (obj.totalVotingPower = (message.totalVotingPower || long_1.default.ZERO).toString());
        message.validatorPower !== undefined &&
            (obj.validatorPower = (message.validatorPower || long_1.default.ZERO).toString());
        message.timestamp !== undefined && (obj.timestamp = fromTimestamp(message.timestamp).toISOString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseDuplicateVoteEvidence();
        message.voteA =
            object.voteA !== undefined && object.voteA !== null ? types_1.Vote.fromPartial(object.voteA) : undefined;
        message.voteB =
            object.voteB !== undefined && object.voteB !== null ? types_1.Vote.fromPartial(object.voteB) : undefined;
        message.totalVotingPower =
            object.totalVotingPower !== undefined && object.totalVotingPower !== null
                ? long_1.default.fromValue(object.totalVotingPower)
                : long_1.default.ZERO;
        message.validatorPower =
            object.validatorPower !== undefined && object.validatorPower !== null
                ? long_1.default.fromValue(object.validatorPower)
                : long_1.default.ZERO;
        message.timestamp =
            object.timestamp !== undefined && object.timestamp !== null
                ? timestamp_1.Timestamp.fromPartial(object.timestamp)
                : undefined;
        return message;
    },
};
function createBaseLightClientAttackEvidence() {
    return {
        conflictingBlock: undefined,
        commonHeight: long_1.default.ZERO,
        byzantineValidators: [],
        totalVotingPower: long_1.default.ZERO,
        timestamp: undefined,
    };
}
exports.LightClientAttackEvidence = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.conflictingBlock !== undefined) {
            types_1.LightBlock.encode(message.conflictingBlock, writer.uint32(10).fork()).ldelim();
        }
        if (!message.commonHeight.isZero()) {
            writer.uint32(16).int64(message.commonHeight);
        }
        for (const v of message.byzantineValidators) {
            validator_1.Validator.encode(v, writer.uint32(26).fork()).ldelim();
        }
        if (!message.totalVotingPower.isZero()) {
            writer.uint32(32).int64(message.totalVotingPower);
        }
        if (message.timestamp !== undefined) {
            timestamp_1.Timestamp.encode(message.timestamp, writer.uint32(42).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseLightClientAttackEvidence();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.conflictingBlock = types_1.LightBlock.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.commonHeight = reader.int64();
                    break;
                case 3:
                    message.byzantineValidators.push(validator_1.Validator.decode(reader, reader.uint32()));
                    break;
                case 4:
                    message.totalVotingPower = reader.int64();
                    break;
                case 5:
                    message.timestamp = timestamp_1.Timestamp.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            conflictingBlock: isSet(object.conflictingBlock)
                ? types_1.LightBlock.fromJSON(object.conflictingBlock)
                : undefined,
            commonHeight: isSet(object.commonHeight) ? long_1.default.fromValue(object.commonHeight) : long_1.default.ZERO,
            byzantineValidators: Array.isArray(object === null || object === void 0 ? void 0 : object.byzantineValidators)
                ? object.byzantineValidators.map((e) => validator_1.Validator.fromJSON(e))
                : [],
            totalVotingPower: isSet(object.totalVotingPower) ? long_1.default.fromValue(object.totalVotingPower) : long_1.default.ZERO,
            timestamp: isSet(object.timestamp) ? fromJsonTimestamp(object.timestamp) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.conflictingBlock !== undefined &&
            (obj.conflictingBlock = message.conflictingBlock
                ? types_1.LightBlock.toJSON(message.conflictingBlock)
                : undefined);
        message.commonHeight !== undefined && (obj.commonHeight = (message.commonHeight || long_1.default.ZERO).toString());
        if (message.byzantineValidators) {
            obj.byzantineValidators = message.byzantineValidators.map((e) => (e ? validator_1.Validator.toJSON(e) : undefined));
        }
        else {
            obj.byzantineValidators = [];
        }
        message.totalVotingPower !== undefined &&
            (obj.totalVotingPower = (message.totalVotingPower || long_1.default.ZERO).toString());
        message.timestamp !== undefined && (obj.timestamp = fromTimestamp(message.timestamp).toISOString());
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseLightClientAttackEvidence();
        message.conflictingBlock =
            object.conflictingBlock !== undefined && object.conflictingBlock !== null
                ? types_1.LightBlock.fromPartial(object.conflictingBlock)
                : undefined;
        message.commonHeight =
            object.commonHeight !== undefined && object.commonHeight !== null
                ? long_1.default.fromValue(object.commonHeight)
                : long_1.default.ZERO;
        message.byzantineValidators = ((_a = object.byzantineValidators) === null || _a === void 0 ? void 0 : _a.map((e) => validator_1.Validator.fromPartial(e))) || [];
        message.totalVotingPower =
            object.totalVotingPower !== undefined && object.totalVotingPower !== null
                ? long_1.default.fromValue(object.totalVotingPower)
                : long_1.default.ZERO;
        message.timestamp =
            object.timestamp !== undefined && object.timestamp !== null
                ? timestamp_1.Timestamp.fromPartial(object.timestamp)
                : undefined;
        return message;
    },
};
function createBaseEvidenceList() {
    return { evidence: [] };
}
exports.EvidenceList = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.evidence) {
            exports.Evidence.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseEvidenceList();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.evidence.push(exports.Evidence.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            evidence: Array.isArray(object === null || object === void 0 ? void 0 : object.evidence) ? object.evidence.map((e) => exports.Evidence.fromJSON(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.evidence) {
            obj.evidence = message.evidence.map((e) => (e ? exports.Evidence.toJSON(e) : undefined));
        }
        else {
            obj.evidence = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseEvidenceList();
        message.evidence = ((_a = object.evidence) === null || _a === void 0 ? void 0 : _a.map((e) => exports.Evidence.fromPartial(e))) || [];
        return message;
    },
};
function toTimestamp(date) {
    const seconds = numberToLong(date.getTime() / 1000);
    const nanos = (date.getTime() % 1000) * 1000000;
    return { seconds, nanos };
}
function fromTimestamp(t) {
    let millis = t.seconds.toNumber() * 1000;
    millis += t.nanos / 1000000;
    return new Date(millis);
}
function fromJsonTimestamp(o) {
    if (o instanceof Date) {
        return toTimestamp(o);
    }
    else if (typeof o === "string") {
        return toTimestamp(new Date(o));
    }
    else {
        return timestamp_1.Timestamp.fromJSON(o);
    }
}
function numberToLong(number) {
    return long_1.default.fromNumber(number);
}
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=evidence.js.map

/***/ }),

/***/ 44179:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.HashedParams = exports.VersionParams = exports.ValidatorParams = exports.EvidenceParams = exports.BlockParams = exports.ConsensusParams = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(__webpack_require__(47873));
const minimal_1 = __importDefault(__webpack_require__(62100));
const duration_1 = __webpack_require__(59769);
exports.protobufPackage = "tendermint.types";
function createBaseConsensusParams() {
    return { block: undefined, evidence: undefined, validator: undefined, version: undefined };
}
exports.ConsensusParams = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.block !== undefined) {
            exports.BlockParams.encode(message.block, writer.uint32(10).fork()).ldelim();
        }
        if (message.evidence !== undefined) {
            exports.EvidenceParams.encode(message.evidence, writer.uint32(18).fork()).ldelim();
        }
        if (message.validator !== undefined) {
            exports.ValidatorParams.encode(message.validator, writer.uint32(26).fork()).ldelim();
        }
        if (message.version !== undefined) {
            exports.VersionParams.encode(message.version, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseConsensusParams();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.block = exports.BlockParams.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.evidence = exports.EvidenceParams.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.validator = exports.ValidatorParams.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.version = exports.VersionParams.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            block: isSet(object.block) ? exports.BlockParams.fromJSON(object.block) : undefined,
            evidence: isSet(object.evidence) ? exports.EvidenceParams.fromJSON(object.evidence) : undefined,
            validator: isSet(object.validator) ? exports.ValidatorParams.fromJSON(object.validator) : undefined,
            version: isSet(object.version) ? exports.VersionParams.fromJSON(object.version) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.block !== undefined &&
            (obj.block = message.block ? exports.BlockParams.toJSON(message.block) : undefined);
        message.evidence !== undefined &&
            (obj.evidence = message.evidence ? exports.EvidenceParams.toJSON(message.evidence) : undefined);
        message.validator !== undefined &&
            (obj.validator = message.validator ? exports.ValidatorParams.toJSON(message.validator) : undefined);
        message.version !== undefined &&
            (obj.version = message.version ? exports.VersionParams.toJSON(message.version) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseConsensusParams();
        message.block =
            object.block !== undefined && object.block !== null ? exports.BlockParams.fromPartial(object.block) : undefined;
        message.evidence =
            object.evidence !== undefined && object.evidence !== null
                ? exports.EvidenceParams.fromPartial(object.evidence)
                : undefined;
        message.validator =
            object.validator !== undefined && object.validator !== null
                ? exports.ValidatorParams.fromPartial(object.validator)
                : undefined;
        message.version =
            object.version !== undefined && object.version !== null
                ? exports.VersionParams.fromPartial(object.version)
                : undefined;
        return message;
    },
};
function createBaseBlockParams() {
    return { maxBytes: long_1.default.ZERO, maxGas: long_1.default.ZERO, timeIotaMs: long_1.default.ZERO };
}
exports.BlockParams = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (!message.maxBytes.isZero()) {
            writer.uint32(8).int64(message.maxBytes);
        }
        if (!message.maxGas.isZero()) {
            writer.uint32(16).int64(message.maxGas);
        }
        if (!message.timeIotaMs.isZero()) {
            writer.uint32(24).int64(message.timeIotaMs);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseBlockParams();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.maxBytes = reader.int64();
                    break;
                case 2:
                    message.maxGas = reader.int64();
                    break;
                case 3:
                    message.timeIotaMs = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            maxBytes: isSet(object.maxBytes) ? long_1.default.fromValue(object.maxBytes) : long_1.default.ZERO,
            maxGas: isSet(object.maxGas) ? long_1.default.fromValue(object.maxGas) : long_1.default.ZERO,
            timeIotaMs: isSet(object.timeIotaMs) ? long_1.default.fromValue(object.timeIotaMs) : long_1.default.ZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        message.maxBytes !== undefined && (obj.maxBytes = (message.maxBytes || long_1.default.ZERO).toString());
        message.maxGas !== undefined && (obj.maxGas = (message.maxGas || long_1.default.ZERO).toString());
        message.timeIotaMs !== undefined && (obj.timeIotaMs = (message.timeIotaMs || long_1.default.ZERO).toString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseBlockParams();
        message.maxBytes =
            object.maxBytes !== undefined && object.maxBytes !== null ? long_1.default.fromValue(object.maxBytes) : long_1.default.ZERO;
        message.maxGas =
            object.maxGas !== undefined && object.maxGas !== null ? long_1.default.fromValue(object.maxGas) : long_1.default.ZERO;
        message.timeIotaMs =
            object.timeIotaMs !== undefined && object.timeIotaMs !== null
                ? long_1.default.fromValue(object.timeIotaMs)
                : long_1.default.ZERO;
        return message;
    },
};
function createBaseEvidenceParams() {
    return { maxAgeNumBlocks: long_1.default.ZERO, maxAgeDuration: undefined, maxBytes: long_1.default.ZERO };
}
exports.EvidenceParams = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (!message.maxAgeNumBlocks.isZero()) {
            writer.uint32(8).int64(message.maxAgeNumBlocks);
        }
        if (message.maxAgeDuration !== undefined) {
            duration_1.Duration.encode(message.maxAgeDuration, writer.uint32(18).fork()).ldelim();
        }
        if (!message.maxBytes.isZero()) {
            writer.uint32(24).int64(message.maxBytes);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseEvidenceParams();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.maxAgeNumBlocks = reader.int64();
                    break;
                case 2:
                    message.maxAgeDuration = duration_1.Duration.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.maxBytes = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            maxAgeNumBlocks: isSet(object.maxAgeNumBlocks) ? long_1.default.fromValue(object.maxAgeNumBlocks) : long_1.default.ZERO,
            maxAgeDuration: isSet(object.maxAgeDuration) ? duration_1.Duration.fromJSON(object.maxAgeDuration) : undefined,
            maxBytes: isSet(object.maxBytes) ? long_1.default.fromValue(object.maxBytes) : long_1.default.ZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        message.maxAgeNumBlocks !== undefined &&
            (obj.maxAgeNumBlocks = (message.maxAgeNumBlocks || long_1.default.ZERO).toString());
        message.maxAgeDuration !== undefined &&
            (obj.maxAgeDuration = message.maxAgeDuration ? duration_1.Duration.toJSON(message.maxAgeDuration) : undefined);
        message.maxBytes !== undefined && (obj.maxBytes = (message.maxBytes || long_1.default.ZERO).toString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseEvidenceParams();
        message.maxAgeNumBlocks =
            object.maxAgeNumBlocks !== undefined && object.maxAgeNumBlocks !== null
                ? long_1.default.fromValue(object.maxAgeNumBlocks)
                : long_1.default.ZERO;
        message.maxAgeDuration =
            object.maxAgeDuration !== undefined && object.maxAgeDuration !== null
                ? duration_1.Duration.fromPartial(object.maxAgeDuration)
                : undefined;
        message.maxBytes =
            object.maxBytes !== undefined && object.maxBytes !== null ? long_1.default.fromValue(object.maxBytes) : long_1.default.ZERO;
        return message;
    },
};
function createBaseValidatorParams() {
    return { pubKeyTypes: [] };
}
exports.ValidatorParams = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.pubKeyTypes) {
            writer.uint32(10).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseValidatorParams();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.pubKeyTypes.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            pubKeyTypes: Array.isArray(object === null || object === void 0 ? void 0 : object.pubKeyTypes) ? object.pubKeyTypes.map((e) => String(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.pubKeyTypes) {
            obj.pubKeyTypes = message.pubKeyTypes.map((e) => e);
        }
        else {
            obj.pubKeyTypes = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseValidatorParams();
        message.pubKeyTypes = ((_a = object.pubKeyTypes) === null || _a === void 0 ? void 0 : _a.map((e) => e)) || [];
        return message;
    },
};
function createBaseVersionParams() {
    return { appVersion: long_1.default.UZERO };
}
exports.VersionParams = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (!message.appVersion.isZero()) {
            writer.uint32(8).uint64(message.appVersion);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVersionParams();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.appVersion = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { appVersion: isSet(object.appVersion) ? long_1.default.fromValue(object.appVersion) : long_1.default.UZERO };
    },
    toJSON(message) {
        const obj = {};
        message.appVersion !== undefined && (obj.appVersion = (message.appVersion || long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseVersionParams();
        message.appVersion =
            object.appVersion !== undefined && object.appVersion !== null
                ? long_1.default.fromValue(object.appVersion)
                : long_1.default.UZERO;
        return message;
    },
};
function createBaseHashedParams() {
    return { blockMaxBytes: long_1.default.ZERO, blockMaxGas: long_1.default.ZERO };
}
exports.HashedParams = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (!message.blockMaxBytes.isZero()) {
            writer.uint32(8).int64(message.blockMaxBytes);
        }
        if (!message.blockMaxGas.isZero()) {
            writer.uint32(16).int64(message.blockMaxGas);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseHashedParams();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.blockMaxBytes = reader.int64();
                    break;
                case 2:
                    message.blockMaxGas = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            blockMaxBytes: isSet(object.blockMaxBytes) ? long_1.default.fromValue(object.blockMaxBytes) : long_1.default.ZERO,
            blockMaxGas: isSet(object.blockMaxGas) ? long_1.default.fromValue(object.blockMaxGas) : long_1.default.ZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        message.blockMaxBytes !== undefined &&
            (obj.blockMaxBytes = (message.blockMaxBytes || long_1.default.ZERO).toString());
        message.blockMaxGas !== undefined && (obj.blockMaxGas = (message.blockMaxGas || long_1.default.ZERO).toString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseHashedParams();
        message.blockMaxBytes =
            object.blockMaxBytes !== undefined && object.blockMaxBytes !== null
                ? long_1.default.fromValue(object.blockMaxBytes)
                : long_1.default.ZERO;
        message.blockMaxGas =
            object.blockMaxGas !== undefined && object.blockMaxGas !== null
                ? long_1.default.fromValue(object.blockMaxGas)
                : long_1.default.ZERO;
        return message;
    },
};
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=params.js.map

/***/ }),

/***/ 54028:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.TxProof = exports.BlockMeta = exports.LightBlock = exports.SignedHeader = exports.Proposal = exports.CommitSig = exports.Commit = exports.Vote = exports.Data = exports.Header = exports.BlockID = exports.Part = exports.PartSetHeader = exports.signedMsgTypeToJSON = exports.signedMsgTypeFromJSON = exports.SignedMsgType = exports.blockIDFlagToJSON = exports.blockIDFlagFromJSON = exports.BlockIDFlag = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(__webpack_require__(47873));
const minimal_1 = __importDefault(__webpack_require__(62100));
const timestamp_1 = __webpack_require__(76620);
const proof_1 = __webpack_require__(60730);
const types_1 = __webpack_require__(42107);
const validator_1 = __webpack_require__(75293);
exports.protobufPackage = "tendermint.types";
/** BlockIdFlag indicates which BlcokID the signature is for */
var BlockIDFlag;
(function (BlockIDFlag) {
    BlockIDFlag[BlockIDFlag["BLOCK_ID_FLAG_UNKNOWN"] = 0] = "BLOCK_ID_FLAG_UNKNOWN";
    BlockIDFlag[BlockIDFlag["BLOCK_ID_FLAG_ABSENT"] = 1] = "BLOCK_ID_FLAG_ABSENT";
    BlockIDFlag[BlockIDFlag["BLOCK_ID_FLAG_COMMIT"] = 2] = "BLOCK_ID_FLAG_COMMIT";
    BlockIDFlag[BlockIDFlag["BLOCK_ID_FLAG_NIL"] = 3] = "BLOCK_ID_FLAG_NIL";
    BlockIDFlag[BlockIDFlag["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(BlockIDFlag = exports.BlockIDFlag || (exports.BlockIDFlag = {}));
function blockIDFlagFromJSON(object) {
    switch (object) {
        case 0:
        case "BLOCK_ID_FLAG_UNKNOWN":
            return BlockIDFlag.BLOCK_ID_FLAG_UNKNOWN;
        case 1:
        case "BLOCK_ID_FLAG_ABSENT":
            return BlockIDFlag.BLOCK_ID_FLAG_ABSENT;
        case 2:
        case "BLOCK_ID_FLAG_COMMIT":
            return BlockIDFlag.BLOCK_ID_FLAG_COMMIT;
        case 3:
        case "BLOCK_ID_FLAG_NIL":
            return BlockIDFlag.BLOCK_ID_FLAG_NIL;
        case -1:
        case "UNRECOGNIZED":
        default:
            return BlockIDFlag.UNRECOGNIZED;
    }
}
exports.blockIDFlagFromJSON = blockIDFlagFromJSON;
function blockIDFlagToJSON(object) {
    switch (object) {
        case BlockIDFlag.BLOCK_ID_FLAG_UNKNOWN:
            return "BLOCK_ID_FLAG_UNKNOWN";
        case BlockIDFlag.BLOCK_ID_FLAG_ABSENT:
            return "BLOCK_ID_FLAG_ABSENT";
        case BlockIDFlag.BLOCK_ID_FLAG_COMMIT:
            return "BLOCK_ID_FLAG_COMMIT";
        case BlockIDFlag.BLOCK_ID_FLAG_NIL:
            return "BLOCK_ID_FLAG_NIL";
        case BlockIDFlag.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.blockIDFlagToJSON = blockIDFlagToJSON;
/** SignedMsgType is a type of signed message in the consensus. */
var SignedMsgType;
(function (SignedMsgType) {
    SignedMsgType[SignedMsgType["SIGNED_MSG_TYPE_UNKNOWN"] = 0] = "SIGNED_MSG_TYPE_UNKNOWN";
    /** SIGNED_MSG_TYPE_PREVOTE - Votes */
    SignedMsgType[SignedMsgType["SIGNED_MSG_TYPE_PREVOTE"] = 1] = "SIGNED_MSG_TYPE_PREVOTE";
    SignedMsgType[SignedMsgType["SIGNED_MSG_TYPE_PRECOMMIT"] = 2] = "SIGNED_MSG_TYPE_PRECOMMIT";
    /** SIGNED_MSG_TYPE_PROPOSAL - Proposals */
    SignedMsgType[SignedMsgType["SIGNED_MSG_TYPE_PROPOSAL"] = 32] = "SIGNED_MSG_TYPE_PROPOSAL";
    SignedMsgType[SignedMsgType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(SignedMsgType = exports.SignedMsgType || (exports.SignedMsgType = {}));
function signedMsgTypeFromJSON(object) {
    switch (object) {
        case 0:
        case "SIGNED_MSG_TYPE_UNKNOWN":
            return SignedMsgType.SIGNED_MSG_TYPE_UNKNOWN;
        case 1:
        case "SIGNED_MSG_TYPE_PREVOTE":
            return SignedMsgType.SIGNED_MSG_TYPE_PREVOTE;
        case 2:
        case "SIGNED_MSG_TYPE_PRECOMMIT":
            return SignedMsgType.SIGNED_MSG_TYPE_PRECOMMIT;
        case 32:
        case "SIGNED_MSG_TYPE_PROPOSAL":
            return SignedMsgType.SIGNED_MSG_TYPE_PROPOSAL;
        case -1:
        case "UNRECOGNIZED":
        default:
            return SignedMsgType.UNRECOGNIZED;
    }
}
exports.signedMsgTypeFromJSON = signedMsgTypeFromJSON;
function signedMsgTypeToJSON(object) {
    switch (object) {
        case SignedMsgType.SIGNED_MSG_TYPE_UNKNOWN:
            return "SIGNED_MSG_TYPE_UNKNOWN";
        case SignedMsgType.SIGNED_MSG_TYPE_PREVOTE:
            return "SIGNED_MSG_TYPE_PREVOTE";
        case SignedMsgType.SIGNED_MSG_TYPE_PRECOMMIT:
            return "SIGNED_MSG_TYPE_PRECOMMIT";
        case SignedMsgType.SIGNED_MSG_TYPE_PROPOSAL:
            return "SIGNED_MSG_TYPE_PROPOSAL";
        case SignedMsgType.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.signedMsgTypeToJSON = signedMsgTypeToJSON;
function createBasePartSetHeader() {
    return { total: 0, hash: new Uint8Array() };
}
exports.PartSetHeader = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.total !== 0) {
            writer.uint32(8).uint32(message.total);
        }
        if (message.hash.length !== 0) {
            writer.uint32(18).bytes(message.hash);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePartSetHeader();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.total = reader.uint32();
                    break;
                case 2:
                    message.hash = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            total: isSet(object.total) ? Number(object.total) : 0,
            hash: isSet(object.hash) ? bytesFromBase64(object.hash) : new Uint8Array(),
        };
    },
    toJSON(message) {
        const obj = {};
        message.total !== undefined && (obj.total = Math.round(message.total));
        message.hash !== undefined &&
            (obj.hash = base64FromBytes(message.hash !== undefined ? message.hash : new Uint8Array()));
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBasePartSetHeader();
        message.total = (_a = object.total) !== null && _a !== void 0 ? _a : 0;
        message.hash = (_b = object.hash) !== null && _b !== void 0 ? _b : new Uint8Array();
        return message;
    },
};
function createBasePart() {
    return { index: 0, bytes: new Uint8Array(), proof: undefined };
}
exports.Part = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.index !== 0) {
            writer.uint32(8).uint32(message.index);
        }
        if (message.bytes.length !== 0) {
            writer.uint32(18).bytes(message.bytes);
        }
        if (message.proof !== undefined) {
            proof_1.Proof.encode(message.proof, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePart();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.index = reader.uint32();
                    break;
                case 2:
                    message.bytes = reader.bytes();
                    break;
                case 3:
                    message.proof = proof_1.Proof.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            index: isSet(object.index) ? Number(object.index) : 0,
            bytes: isSet(object.bytes) ? bytesFromBase64(object.bytes) : new Uint8Array(),
            proof: isSet(object.proof) ? proof_1.Proof.fromJSON(object.proof) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.index !== undefined && (obj.index = Math.round(message.index));
        message.bytes !== undefined &&
            (obj.bytes = base64FromBytes(message.bytes !== undefined ? message.bytes : new Uint8Array()));
        message.proof !== undefined && (obj.proof = message.proof ? proof_1.Proof.toJSON(message.proof) : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBasePart();
        message.index = (_a = object.index) !== null && _a !== void 0 ? _a : 0;
        message.bytes = (_b = object.bytes) !== null && _b !== void 0 ? _b : new Uint8Array();
        message.proof =
            object.proof !== undefined && object.proof !== null ? proof_1.Proof.fromPartial(object.proof) : undefined;
        return message;
    },
};
function createBaseBlockID() {
    return { hash: new Uint8Array(), partSetHeader: undefined };
}
exports.BlockID = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.hash.length !== 0) {
            writer.uint32(10).bytes(message.hash);
        }
        if (message.partSetHeader !== undefined) {
            exports.PartSetHeader.encode(message.partSetHeader, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseBlockID();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.hash = reader.bytes();
                    break;
                case 2:
                    message.partSetHeader = exports.PartSetHeader.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            hash: isSet(object.hash) ? bytesFromBase64(object.hash) : new Uint8Array(),
            partSetHeader: isSet(object.partSetHeader) ? exports.PartSetHeader.fromJSON(object.partSetHeader) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.hash !== undefined &&
            (obj.hash = base64FromBytes(message.hash !== undefined ? message.hash : new Uint8Array()));
        message.partSetHeader !== undefined &&
            (obj.partSetHeader = message.partSetHeader ? exports.PartSetHeader.toJSON(message.partSetHeader) : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseBlockID();
        message.hash = (_a = object.hash) !== null && _a !== void 0 ? _a : new Uint8Array();
        message.partSetHeader =
            object.partSetHeader !== undefined && object.partSetHeader !== null
                ? exports.PartSetHeader.fromPartial(object.partSetHeader)
                : undefined;
        return message;
    },
};
function createBaseHeader() {
    return {
        version: undefined,
        chainId: "",
        height: long_1.default.ZERO,
        time: undefined,
        lastBlockId: undefined,
        lastCommitHash: new Uint8Array(),
        dataHash: new Uint8Array(),
        validatorsHash: new Uint8Array(),
        nextValidatorsHash: new Uint8Array(),
        consensusHash: new Uint8Array(),
        appHash: new Uint8Array(),
        lastResultsHash: new Uint8Array(),
        evidenceHash: new Uint8Array(),
        proposerAddress: new Uint8Array(),
    };
}
exports.Header = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.version !== undefined) {
            types_1.Consensus.encode(message.version, writer.uint32(10).fork()).ldelim();
        }
        if (message.chainId !== "") {
            writer.uint32(18).string(message.chainId);
        }
        if (!message.height.isZero()) {
            writer.uint32(24).int64(message.height);
        }
        if (message.time !== undefined) {
            timestamp_1.Timestamp.encode(message.time, writer.uint32(34).fork()).ldelim();
        }
        if (message.lastBlockId !== undefined) {
            exports.BlockID.encode(message.lastBlockId, writer.uint32(42).fork()).ldelim();
        }
        if (message.lastCommitHash.length !== 0) {
            writer.uint32(50).bytes(message.lastCommitHash);
        }
        if (message.dataHash.length !== 0) {
            writer.uint32(58).bytes(message.dataHash);
        }
        if (message.validatorsHash.length !== 0) {
            writer.uint32(66).bytes(message.validatorsHash);
        }
        if (message.nextValidatorsHash.length !== 0) {
            writer.uint32(74).bytes(message.nextValidatorsHash);
        }
        if (message.consensusHash.length !== 0) {
            writer.uint32(82).bytes(message.consensusHash);
        }
        if (message.appHash.length !== 0) {
            writer.uint32(90).bytes(message.appHash);
        }
        if (message.lastResultsHash.length !== 0) {
            writer.uint32(98).bytes(message.lastResultsHash);
        }
        if (message.evidenceHash.length !== 0) {
            writer.uint32(106).bytes(message.evidenceHash);
        }
        if (message.proposerAddress.length !== 0) {
            writer.uint32(114).bytes(message.proposerAddress);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseHeader();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.version = types_1.Consensus.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.chainId = reader.string();
                    break;
                case 3:
                    message.height = reader.int64();
                    break;
                case 4:
                    message.time = timestamp_1.Timestamp.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.lastBlockId = exports.BlockID.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.lastCommitHash = reader.bytes();
                    break;
                case 7:
                    message.dataHash = reader.bytes();
                    break;
                case 8:
                    message.validatorsHash = reader.bytes();
                    break;
                case 9:
                    message.nextValidatorsHash = reader.bytes();
                    break;
                case 10:
                    message.consensusHash = reader.bytes();
                    break;
                case 11:
                    message.appHash = reader.bytes();
                    break;
                case 12:
                    message.lastResultsHash = reader.bytes();
                    break;
                case 13:
                    message.evidenceHash = reader.bytes();
                    break;
                case 14:
                    message.proposerAddress = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            version: isSet(object.version) ? types_1.Consensus.fromJSON(object.version) : undefined,
            chainId: isSet(object.chainId) ? String(object.chainId) : "",
            height: isSet(object.height) ? long_1.default.fromValue(object.height) : long_1.default.ZERO,
            time: isSet(object.time) ? fromJsonTimestamp(object.time) : undefined,
            lastBlockId: isSet(object.lastBlockId) ? exports.BlockID.fromJSON(object.lastBlockId) : undefined,
            lastCommitHash: isSet(object.lastCommitHash)
                ? bytesFromBase64(object.lastCommitHash)
                : new Uint8Array(),
            dataHash: isSet(object.dataHash) ? bytesFromBase64(object.dataHash) : new Uint8Array(),
            validatorsHash: isSet(object.validatorsHash)
                ? bytesFromBase64(object.validatorsHash)
                : new Uint8Array(),
            nextValidatorsHash: isSet(object.nextValidatorsHash)
                ? bytesFromBase64(object.nextValidatorsHash)
                : new Uint8Array(),
            consensusHash: isSet(object.consensusHash) ? bytesFromBase64(object.consensusHash) : new Uint8Array(),
            appHash: isSet(object.appHash) ? bytesFromBase64(object.appHash) : new Uint8Array(),
            lastResultsHash: isSet(object.lastResultsHash)
                ? bytesFromBase64(object.lastResultsHash)
                : new Uint8Array(),
            evidenceHash: isSet(object.evidenceHash) ? bytesFromBase64(object.evidenceHash) : new Uint8Array(),
            proposerAddress: isSet(object.proposerAddress)
                ? bytesFromBase64(object.proposerAddress)
                : new Uint8Array(),
        };
    },
    toJSON(message) {
        const obj = {};
        message.version !== undefined &&
            (obj.version = message.version ? types_1.Consensus.toJSON(message.version) : undefined);
        message.chainId !== undefined && (obj.chainId = message.chainId);
        message.height !== undefined && (obj.height = (message.height || long_1.default.ZERO).toString());
        message.time !== undefined && (obj.time = fromTimestamp(message.time).toISOString());
        message.lastBlockId !== undefined &&
            (obj.lastBlockId = message.lastBlockId ? exports.BlockID.toJSON(message.lastBlockId) : undefined);
        message.lastCommitHash !== undefined &&
            (obj.lastCommitHash = base64FromBytes(message.lastCommitHash !== undefined ? message.lastCommitHash : new Uint8Array()));
        message.dataHash !== undefined &&
            (obj.dataHash = base64FromBytes(message.dataHash !== undefined ? message.dataHash : new Uint8Array()));
        message.validatorsHash !== undefined &&
            (obj.validatorsHash = base64FromBytes(message.validatorsHash !== undefined ? message.validatorsHash : new Uint8Array()));
        message.nextValidatorsHash !== undefined &&
            (obj.nextValidatorsHash = base64FromBytes(message.nextValidatorsHash !== undefined ? message.nextValidatorsHash : new Uint8Array()));
        message.consensusHash !== undefined &&
            (obj.consensusHash = base64FromBytes(message.consensusHash !== undefined ? message.consensusHash : new Uint8Array()));
        message.appHash !== undefined &&
            (obj.appHash = base64FromBytes(message.appHash !== undefined ? message.appHash : new Uint8Array()));
        message.lastResultsHash !== undefined &&
            (obj.lastResultsHash = base64FromBytes(message.lastResultsHash !== undefined ? message.lastResultsHash : new Uint8Array()));
        message.evidenceHash !== undefined &&
            (obj.evidenceHash = base64FromBytes(message.evidenceHash !== undefined ? message.evidenceHash : new Uint8Array()));
        message.proposerAddress !== undefined &&
            (obj.proposerAddress = base64FromBytes(message.proposerAddress !== undefined ? message.proposerAddress : new Uint8Array()));
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        const message = createBaseHeader();
        message.version =
            object.version !== undefined && object.version !== null
                ? types_1.Consensus.fromPartial(object.version)
                : undefined;
        message.chainId = (_a = object.chainId) !== null && _a !== void 0 ? _a : "";
        message.height =
            object.height !== undefined && object.height !== null ? long_1.default.fromValue(object.height) : long_1.default.ZERO;
        message.time =
            object.time !== undefined && object.time !== null ? timestamp_1.Timestamp.fromPartial(object.time) : undefined;
        message.lastBlockId =
            object.lastBlockId !== undefined && object.lastBlockId !== null
                ? exports.BlockID.fromPartial(object.lastBlockId)
                : undefined;
        message.lastCommitHash = (_b = object.lastCommitHash) !== null && _b !== void 0 ? _b : new Uint8Array();
        message.dataHash = (_c = object.dataHash) !== null && _c !== void 0 ? _c : new Uint8Array();
        message.validatorsHash = (_d = object.validatorsHash) !== null && _d !== void 0 ? _d : new Uint8Array();
        message.nextValidatorsHash = (_e = object.nextValidatorsHash) !== null && _e !== void 0 ? _e : new Uint8Array();
        message.consensusHash = (_f = object.consensusHash) !== null && _f !== void 0 ? _f : new Uint8Array();
        message.appHash = (_g = object.appHash) !== null && _g !== void 0 ? _g : new Uint8Array();
        message.lastResultsHash = (_h = object.lastResultsHash) !== null && _h !== void 0 ? _h : new Uint8Array();
        message.evidenceHash = (_j = object.evidenceHash) !== null && _j !== void 0 ? _j : new Uint8Array();
        message.proposerAddress = (_k = object.proposerAddress) !== null && _k !== void 0 ? _k : new Uint8Array();
        return message;
    },
};
function createBaseData() {
    return { txs: [] };
}
exports.Data = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.txs) {
            writer.uint32(10).bytes(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseData();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.txs.push(reader.bytes());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { txs: Array.isArray(object === null || object === void 0 ? void 0 : object.txs) ? object.txs.map((e) => bytesFromBase64(e)) : [] };
    },
    toJSON(message) {
        const obj = {};
        if (message.txs) {
            obj.txs = message.txs.map((e) => base64FromBytes(e !== undefined ? e : new Uint8Array()));
        }
        else {
            obj.txs = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseData();
        message.txs = ((_a = object.txs) === null || _a === void 0 ? void 0 : _a.map((e) => e)) || [];
        return message;
    },
};
function createBaseVote() {
    return {
        type: 0,
        height: long_1.default.ZERO,
        round: 0,
        blockId: undefined,
        timestamp: undefined,
        validatorAddress: new Uint8Array(),
        validatorIndex: 0,
        signature: new Uint8Array(),
    };
}
exports.Vote = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.type !== 0) {
            writer.uint32(8).int32(message.type);
        }
        if (!message.height.isZero()) {
            writer.uint32(16).int64(message.height);
        }
        if (message.round !== 0) {
            writer.uint32(24).int32(message.round);
        }
        if (message.blockId !== undefined) {
            exports.BlockID.encode(message.blockId, writer.uint32(34).fork()).ldelim();
        }
        if (message.timestamp !== undefined) {
            timestamp_1.Timestamp.encode(message.timestamp, writer.uint32(42).fork()).ldelim();
        }
        if (message.validatorAddress.length !== 0) {
            writer.uint32(50).bytes(message.validatorAddress);
        }
        if (message.validatorIndex !== 0) {
            writer.uint32(56).int32(message.validatorIndex);
        }
        if (message.signature.length !== 0) {
            writer.uint32(66).bytes(message.signature);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVote();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.type = reader.int32();
                    break;
                case 2:
                    message.height = reader.int64();
                    break;
                case 3:
                    message.round = reader.int32();
                    break;
                case 4:
                    message.blockId = exports.BlockID.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.timestamp = timestamp_1.Timestamp.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.validatorAddress = reader.bytes();
                    break;
                case 7:
                    message.validatorIndex = reader.int32();
                    break;
                case 8:
                    message.signature = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            type: isSet(object.type) ? signedMsgTypeFromJSON(object.type) : 0,
            height: isSet(object.height) ? long_1.default.fromValue(object.height) : long_1.default.ZERO,
            round: isSet(object.round) ? Number(object.round) : 0,
            blockId: isSet(object.blockId) ? exports.BlockID.fromJSON(object.blockId) : undefined,
            timestamp: isSet(object.timestamp) ? fromJsonTimestamp(object.timestamp) : undefined,
            validatorAddress: isSet(object.validatorAddress)
                ? bytesFromBase64(object.validatorAddress)
                : new Uint8Array(),
            validatorIndex: isSet(object.validatorIndex) ? Number(object.validatorIndex) : 0,
            signature: isSet(object.signature) ? bytesFromBase64(object.signature) : new Uint8Array(),
        };
    },
    toJSON(message) {
        const obj = {};
        message.type !== undefined && (obj.type = signedMsgTypeToJSON(message.type));
        message.height !== undefined && (obj.height = (message.height || long_1.default.ZERO).toString());
        message.round !== undefined && (obj.round = Math.round(message.round));
        message.blockId !== undefined &&
            (obj.blockId = message.blockId ? exports.BlockID.toJSON(message.blockId) : undefined);
        message.timestamp !== undefined && (obj.timestamp = fromTimestamp(message.timestamp).toISOString());
        message.validatorAddress !== undefined &&
            (obj.validatorAddress = base64FromBytes(message.validatorAddress !== undefined ? message.validatorAddress : new Uint8Array()));
        message.validatorIndex !== undefined && (obj.validatorIndex = Math.round(message.validatorIndex));
        message.signature !== undefined &&
            (obj.signature = base64FromBytes(message.signature !== undefined ? message.signature : new Uint8Array()));
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e;
        const message = createBaseVote();
        message.type = (_a = object.type) !== null && _a !== void 0 ? _a : 0;
        message.height =
            object.height !== undefined && object.height !== null ? long_1.default.fromValue(object.height) : long_1.default.ZERO;
        message.round = (_b = object.round) !== null && _b !== void 0 ? _b : 0;
        message.blockId =
            object.blockId !== undefined && object.blockId !== null
                ? exports.BlockID.fromPartial(object.blockId)
                : undefined;
        message.timestamp =
            object.timestamp !== undefined && object.timestamp !== null
                ? timestamp_1.Timestamp.fromPartial(object.timestamp)
                : undefined;
        message.validatorAddress = (_c = object.validatorAddress) !== null && _c !== void 0 ? _c : new Uint8Array();
        message.validatorIndex = (_d = object.validatorIndex) !== null && _d !== void 0 ? _d : 0;
        message.signature = (_e = object.signature) !== null && _e !== void 0 ? _e : new Uint8Array();
        return message;
    },
};
function createBaseCommit() {
    return { height: long_1.default.ZERO, round: 0, blockId: undefined, signatures: [] };
}
exports.Commit = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (!message.height.isZero()) {
            writer.uint32(8).int64(message.height);
        }
        if (message.round !== 0) {
            writer.uint32(16).int32(message.round);
        }
        if (message.blockId !== undefined) {
            exports.BlockID.encode(message.blockId, writer.uint32(26).fork()).ldelim();
        }
        for (const v of message.signatures) {
            exports.CommitSig.encode(v, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCommit();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.height = reader.int64();
                    break;
                case 2:
                    message.round = reader.int32();
                    break;
                case 3:
                    message.blockId = exports.BlockID.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.signatures.push(exports.CommitSig.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            height: isSet(object.height) ? long_1.default.fromValue(object.height) : long_1.default.ZERO,
            round: isSet(object.round) ? Number(object.round) : 0,
            blockId: isSet(object.blockId) ? exports.BlockID.fromJSON(object.blockId) : undefined,
            signatures: Array.isArray(object === null || object === void 0 ? void 0 : object.signatures)
                ? object.signatures.map((e) => exports.CommitSig.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        message.height !== undefined && (obj.height = (message.height || long_1.default.ZERO).toString());
        message.round !== undefined && (obj.round = Math.round(message.round));
        message.blockId !== undefined &&
            (obj.blockId = message.blockId ? exports.BlockID.toJSON(message.blockId) : undefined);
        if (message.signatures) {
            obj.signatures = message.signatures.map((e) => (e ? exports.CommitSig.toJSON(e) : undefined));
        }
        else {
            obj.signatures = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseCommit();
        message.height =
            object.height !== undefined && object.height !== null ? long_1.default.fromValue(object.height) : long_1.default.ZERO;
        message.round = (_a = object.round) !== null && _a !== void 0 ? _a : 0;
        message.blockId =
            object.blockId !== undefined && object.blockId !== null
                ? exports.BlockID.fromPartial(object.blockId)
                : undefined;
        message.signatures = ((_b = object.signatures) === null || _b === void 0 ? void 0 : _b.map((e) => exports.CommitSig.fromPartial(e))) || [];
        return message;
    },
};
function createBaseCommitSig() {
    return {
        blockIdFlag: 0,
        validatorAddress: new Uint8Array(),
        timestamp: undefined,
        signature: new Uint8Array(),
    };
}
exports.CommitSig = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.blockIdFlag !== 0) {
            writer.uint32(8).int32(message.blockIdFlag);
        }
        if (message.validatorAddress.length !== 0) {
            writer.uint32(18).bytes(message.validatorAddress);
        }
        if (message.timestamp !== undefined) {
            timestamp_1.Timestamp.encode(message.timestamp, writer.uint32(26).fork()).ldelim();
        }
        if (message.signature.length !== 0) {
            writer.uint32(34).bytes(message.signature);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCommitSig();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.blockIdFlag = reader.int32();
                    break;
                case 2:
                    message.validatorAddress = reader.bytes();
                    break;
                case 3:
                    message.timestamp = timestamp_1.Timestamp.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.signature = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            blockIdFlag: isSet(object.blockIdFlag) ? blockIDFlagFromJSON(object.blockIdFlag) : 0,
            validatorAddress: isSet(object.validatorAddress)
                ? bytesFromBase64(object.validatorAddress)
                : new Uint8Array(),
            timestamp: isSet(object.timestamp) ? fromJsonTimestamp(object.timestamp) : undefined,
            signature: isSet(object.signature) ? bytesFromBase64(object.signature) : new Uint8Array(),
        };
    },
    toJSON(message) {
        const obj = {};
        message.blockIdFlag !== undefined && (obj.blockIdFlag = blockIDFlagToJSON(message.blockIdFlag));
        message.validatorAddress !== undefined &&
            (obj.validatorAddress = base64FromBytes(message.validatorAddress !== undefined ? message.validatorAddress : new Uint8Array()));
        message.timestamp !== undefined && (obj.timestamp = fromTimestamp(message.timestamp).toISOString());
        message.signature !== undefined &&
            (obj.signature = base64FromBytes(message.signature !== undefined ? message.signature : new Uint8Array()));
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseCommitSig();
        message.blockIdFlag = (_a = object.blockIdFlag) !== null && _a !== void 0 ? _a : 0;
        message.validatorAddress = (_b = object.validatorAddress) !== null && _b !== void 0 ? _b : new Uint8Array();
        message.timestamp =
            object.timestamp !== undefined && object.timestamp !== null
                ? timestamp_1.Timestamp.fromPartial(object.timestamp)
                : undefined;
        message.signature = (_c = object.signature) !== null && _c !== void 0 ? _c : new Uint8Array();
        return message;
    },
};
function createBaseProposal() {
    return {
        type: 0,
        height: long_1.default.ZERO,
        round: 0,
        polRound: 0,
        blockId: undefined,
        timestamp: undefined,
        signature: new Uint8Array(),
    };
}
exports.Proposal = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.type !== 0) {
            writer.uint32(8).int32(message.type);
        }
        if (!message.height.isZero()) {
            writer.uint32(16).int64(message.height);
        }
        if (message.round !== 0) {
            writer.uint32(24).int32(message.round);
        }
        if (message.polRound !== 0) {
            writer.uint32(32).int32(message.polRound);
        }
        if (message.blockId !== undefined) {
            exports.BlockID.encode(message.blockId, writer.uint32(42).fork()).ldelim();
        }
        if (message.timestamp !== undefined) {
            timestamp_1.Timestamp.encode(message.timestamp, writer.uint32(50).fork()).ldelim();
        }
        if (message.signature.length !== 0) {
            writer.uint32(58).bytes(message.signature);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseProposal();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.type = reader.int32();
                    break;
                case 2:
                    message.height = reader.int64();
                    break;
                case 3:
                    message.round = reader.int32();
                    break;
                case 4:
                    message.polRound = reader.int32();
                    break;
                case 5:
                    message.blockId = exports.BlockID.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.timestamp = timestamp_1.Timestamp.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.signature = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            type: isSet(object.type) ? signedMsgTypeFromJSON(object.type) : 0,
            height: isSet(object.height) ? long_1.default.fromValue(object.height) : long_1.default.ZERO,
            round: isSet(object.round) ? Number(object.round) : 0,
            polRound: isSet(object.polRound) ? Number(object.polRound) : 0,
            blockId: isSet(object.blockId) ? exports.BlockID.fromJSON(object.blockId) : undefined,
            timestamp: isSet(object.timestamp) ? fromJsonTimestamp(object.timestamp) : undefined,
            signature: isSet(object.signature) ? bytesFromBase64(object.signature) : new Uint8Array(),
        };
    },
    toJSON(message) {
        const obj = {};
        message.type !== undefined && (obj.type = signedMsgTypeToJSON(message.type));
        message.height !== undefined && (obj.height = (message.height || long_1.default.ZERO).toString());
        message.round !== undefined && (obj.round = Math.round(message.round));
        message.polRound !== undefined && (obj.polRound = Math.round(message.polRound));
        message.blockId !== undefined &&
            (obj.blockId = message.blockId ? exports.BlockID.toJSON(message.blockId) : undefined);
        message.timestamp !== undefined && (obj.timestamp = fromTimestamp(message.timestamp).toISOString());
        message.signature !== undefined &&
            (obj.signature = base64FromBytes(message.signature !== undefined ? message.signature : new Uint8Array()));
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d;
        const message = createBaseProposal();
        message.type = (_a = object.type) !== null && _a !== void 0 ? _a : 0;
        message.height =
            object.height !== undefined && object.height !== null ? long_1.default.fromValue(object.height) : long_1.default.ZERO;
        message.round = (_b = object.round) !== null && _b !== void 0 ? _b : 0;
        message.polRound = (_c = object.polRound) !== null && _c !== void 0 ? _c : 0;
        message.blockId =
            object.blockId !== undefined && object.blockId !== null
                ? exports.BlockID.fromPartial(object.blockId)
                : undefined;
        message.timestamp =
            object.timestamp !== undefined && object.timestamp !== null
                ? timestamp_1.Timestamp.fromPartial(object.timestamp)
                : undefined;
        message.signature = (_d = object.signature) !== null && _d !== void 0 ? _d : new Uint8Array();
        return message;
    },
};
function createBaseSignedHeader() {
    return { header: undefined, commit: undefined };
}
exports.SignedHeader = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.header !== undefined) {
            exports.Header.encode(message.header, writer.uint32(10).fork()).ldelim();
        }
        if (message.commit !== undefined) {
            exports.Commit.encode(message.commit, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSignedHeader();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.header = exports.Header.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.commit = exports.Commit.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            header: isSet(object.header) ? exports.Header.fromJSON(object.header) : undefined,
            commit: isSet(object.commit) ? exports.Commit.fromJSON(object.commit) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.header !== undefined && (obj.header = message.header ? exports.Header.toJSON(message.header) : undefined);
        message.commit !== undefined && (obj.commit = message.commit ? exports.Commit.toJSON(message.commit) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseSignedHeader();
        message.header =
            object.header !== undefined && object.header !== null ? exports.Header.fromPartial(object.header) : undefined;
        message.commit =
            object.commit !== undefined && object.commit !== null ? exports.Commit.fromPartial(object.commit) : undefined;
        return message;
    },
};
function createBaseLightBlock() {
    return { signedHeader: undefined, validatorSet: undefined };
}
exports.LightBlock = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.signedHeader !== undefined) {
            exports.SignedHeader.encode(message.signedHeader, writer.uint32(10).fork()).ldelim();
        }
        if (message.validatorSet !== undefined) {
            validator_1.ValidatorSet.encode(message.validatorSet, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseLightBlock();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.signedHeader = exports.SignedHeader.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.validatorSet = validator_1.ValidatorSet.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            signedHeader: isSet(object.signedHeader) ? exports.SignedHeader.fromJSON(object.signedHeader) : undefined,
            validatorSet: isSet(object.validatorSet) ? validator_1.ValidatorSet.fromJSON(object.validatorSet) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.signedHeader !== undefined &&
            (obj.signedHeader = message.signedHeader ? exports.SignedHeader.toJSON(message.signedHeader) : undefined);
        message.validatorSet !== undefined &&
            (obj.validatorSet = message.validatorSet ? validator_1.ValidatorSet.toJSON(message.validatorSet) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseLightBlock();
        message.signedHeader =
            object.signedHeader !== undefined && object.signedHeader !== null
                ? exports.SignedHeader.fromPartial(object.signedHeader)
                : undefined;
        message.validatorSet =
            object.validatorSet !== undefined && object.validatorSet !== null
                ? validator_1.ValidatorSet.fromPartial(object.validatorSet)
                : undefined;
        return message;
    },
};
function createBaseBlockMeta() {
    return { blockId: undefined, blockSize: long_1.default.ZERO, header: undefined, numTxs: long_1.default.ZERO };
}
exports.BlockMeta = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.blockId !== undefined) {
            exports.BlockID.encode(message.blockId, writer.uint32(10).fork()).ldelim();
        }
        if (!message.blockSize.isZero()) {
            writer.uint32(16).int64(message.blockSize);
        }
        if (message.header !== undefined) {
            exports.Header.encode(message.header, writer.uint32(26).fork()).ldelim();
        }
        if (!message.numTxs.isZero()) {
            writer.uint32(32).int64(message.numTxs);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseBlockMeta();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.blockId = exports.BlockID.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.blockSize = reader.int64();
                    break;
                case 3:
                    message.header = exports.Header.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.numTxs = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            blockId: isSet(object.blockId) ? exports.BlockID.fromJSON(object.blockId) : undefined,
            blockSize: isSet(object.blockSize) ? long_1.default.fromValue(object.blockSize) : long_1.default.ZERO,
            header: isSet(object.header) ? exports.Header.fromJSON(object.header) : undefined,
            numTxs: isSet(object.numTxs) ? long_1.default.fromValue(object.numTxs) : long_1.default.ZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        message.blockId !== undefined &&
            (obj.blockId = message.blockId ? exports.BlockID.toJSON(message.blockId) : undefined);
        message.blockSize !== undefined && (obj.blockSize = (message.blockSize || long_1.default.ZERO).toString());
        message.header !== undefined && (obj.header = message.header ? exports.Header.toJSON(message.header) : undefined);
        message.numTxs !== undefined && (obj.numTxs = (message.numTxs || long_1.default.ZERO).toString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseBlockMeta();
        message.blockId =
            object.blockId !== undefined && object.blockId !== null
                ? exports.BlockID.fromPartial(object.blockId)
                : undefined;
        message.blockSize =
            object.blockSize !== undefined && object.blockSize !== null
                ? long_1.default.fromValue(object.blockSize)
                : long_1.default.ZERO;
        message.header =
            object.header !== undefined && object.header !== null ? exports.Header.fromPartial(object.header) : undefined;
        message.numTxs =
            object.numTxs !== undefined && object.numTxs !== null ? long_1.default.fromValue(object.numTxs) : long_1.default.ZERO;
        return message;
    },
};
function createBaseTxProof() {
    return { rootHash: new Uint8Array(), data: new Uint8Array(), proof: undefined };
}
exports.TxProof = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.rootHash.length !== 0) {
            writer.uint32(10).bytes(message.rootHash);
        }
        if (message.data.length !== 0) {
            writer.uint32(18).bytes(message.data);
        }
        if (message.proof !== undefined) {
            proof_1.Proof.encode(message.proof, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTxProof();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.rootHash = reader.bytes();
                    break;
                case 2:
                    message.data = reader.bytes();
                    break;
                case 3:
                    message.proof = proof_1.Proof.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            rootHash: isSet(object.rootHash) ? bytesFromBase64(object.rootHash) : new Uint8Array(),
            data: isSet(object.data) ? bytesFromBase64(object.data) : new Uint8Array(),
            proof: isSet(object.proof) ? proof_1.Proof.fromJSON(object.proof) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.rootHash !== undefined &&
            (obj.rootHash = base64FromBytes(message.rootHash !== undefined ? message.rootHash : new Uint8Array()));
        message.data !== undefined &&
            (obj.data = base64FromBytes(message.data !== undefined ? message.data : new Uint8Array()));
        message.proof !== undefined && (obj.proof = message.proof ? proof_1.Proof.toJSON(message.proof) : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseTxProof();
        message.rootHash = (_a = object.rootHash) !== null && _a !== void 0 ? _a : new Uint8Array();
        message.data = (_b = object.data) !== null && _b !== void 0 ? _b : new Uint8Array();
        message.proof =
            object.proof !== undefined && object.proof !== null ? proof_1.Proof.fromPartial(object.proof) : undefined;
        return message;
    },
};
var globalThis = (() => {
    if (typeof globalThis !== "undefined") {
        return globalThis;
    }
    if (typeof self !== "undefined") {
        return self;
    }
    if (typeof window !== "undefined") {
        return window;
    }
    if (typeof __webpack_require__.g !== "undefined") {
        return __webpack_require__.g;
    }
    throw "Unable to locate global object";
})();
function bytesFromBase64(b64) {
    if (globalThis.Buffer) {
        return Uint8Array.from(globalThis.Buffer.from(b64, "base64"));
    }
    else {
        const bin = globalThis.atob(b64);
        const arr = new Uint8Array(bin.length);
        for (let i = 0; i < bin.length; ++i) {
            arr[i] = bin.charCodeAt(i);
        }
        return arr;
    }
}
function base64FromBytes(arr) {
    if (globalThis.Buffer) {
        return globalThis.Buffer.from(arr).toString("base64");
    }
    else {
        const bin = [];
        arr.forEach((byte) => {
            bin.push(String.fromCharCode(byte));
        });
        return globalThis.btoa(bin.join(""));
    }
}
function toTimestamp(date) {
    const seconds = numberToLong(date.getTime() / 1000);
    const nanos = (date.getTime() % 1000) * 1000000;
    return { seconds, nanos };
}
function fromTimestamp(t) {
    let millis = t.seconds.toNumber() * 1000;
    millis += t.nanos / 1000000;
    return new Date(millis);
}
function fromJsonTimestamp(o) {
    if (o instanceof Date) {
        return toTimestamp(o);
    }
    else if (typeof o === "string") {
        return toTimestamp(new Date(o));
    }
    else {
        return timestamp_1.Timestamp.fromJSON(o);
    }
}
function numberToLong(number) {
    return long_1.default.fromNumber(number);
}
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=types.js.map

/***/ }),

/***/ 75293:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.SimpleValidator = exports.Validator = exports.ValidatorSet = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(__webpack_require__(47873));
const minimal_1 = __importDefault(__webpack_require__(62100));
const keys_1 = __webpack_require__(54568);
exports.protobufPackage = "tendermint.types";
function createBaseValidatorSet() {
    return { validators: [], proposer: undefined, totalVotingPower: long_1.default.ZERO };
}
exports.ValidatorSet = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.validators) {
            exports.Validator.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.proposer !== undefined) {
            exports.Validator.encode(message.proposer, writer.uint32(18).fork()).ldelim();
        }
        if (!message.totalVotingPower.isZero()) {
            writer.uint32(24).int64(message.totalVotingPower);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseValidatorSet();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.validators.push(exports.Validator.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.proposer = exports.Validator.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.totalVotingPower = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            validators: Array.isArray(object === null || object === void 0 ? void 0 : object.validators)
                ? object.validators.map((e) => exports.Validator.fromJSON(e))
                : [],
            proposer: isSet(object.proposer) ? exports.Validator.fromJSON(object.proposer) : undefined,
            totalVotingPower: isSet(object.totalVotingPower) ? long_1.default.fromValue(object.totalVotingPower) : long_1.default.ZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.validators) {
            obj.validators = message.validators.map((e) => (e ? exports.Validator.toJSON(e) : undefined));
        }
        else {
            obj.validators = [];
        }
        message.proposer !== undefined &&
            (obj.proposer = message.proposer ? exports.Validator.toJSON(message.proposer) : undefined);
        message.totalVotingPower !== undefined &&
            (obj.totalVotingPower = (message.totalVotingPower || long_1.default.ZERO).toString());
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseValidatorSet();
        message.validators = ((_a = object.validators) === null || _a === void 0 ? void 0 : _a.map((e) => exports.Validator.fromPartial(e))) || [];
        message.proposer =
            object.proposer !== undefined && object.proposer !== null
                ? exports.Validator.fromPartial(object.proposer)
                : undefined;
        message.totalVotingPower =
            object.totalVotingPower !== undefined && object.totalVotingPower !== null
                ? long_1.default.fromValue(object.totalVotingPower)
                : long_1.default.ZERO;
        return message;
    },
};
function createBaseValidator() {
    return {
        address: new Uint8Array(),
        pubKey: undefined,
        votingPower: long_1.default.ZERO,
        proposerPriority: long_1.default.ZERO,
    };
}
exports.Validator = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.address.length !== 0) {
            writer.uint32(10).bytes(message.address);
        }
        if (message.pubKey !== undefined) {
            keys_1.PublicKey.encode(message.pubKey, writer.uint32(18).fork()).ldelim();
        }
        if (!message.votingPower.isZero()) {
            writer.uint32(24).int64(message.votingPower);
        }
        if (!message.proposerPriority.isZero()) {
            writer.uint32(32).int64(message.proposerPriority);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseValidator();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.address = reader.bytes();
                    break;
                case 2:
                    message.pubKey = keys_1.PublicKey.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.votingPower = reader.int64();
                    break;
                case 4:
                    message.proposerPriority = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            address: isSet(object.address) ? bytesFromBase64(object.address) : new Uint8Array(),
            pubKey: isSet(object.pubKey) ? keys_1.PublicKey.fromJSON(object.pubKey) : undefined,
            votingPower: isSet(object.votingPower) ? long_1.default.fromValue(object.votingPower) : long_1.default.ZERO,
            proposerPriority: isSet(object.proposerPriority) ? long_1.default.fromValue(object.proposerPriority) : long_1.default.ZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        message.address !== undefined &&
            (obj.address = base64FromBytes(message.address !== undefined ? message.address : new Uint8Array()));
        message.pubKey !== undefined &&
            (obj.pubKey = message.pubKey ? keys_1.PublicKey.toJSON(message.pubKey) : undefined);
        message.votingPower !== undefined && (obj.votingPower = (message.votingPower || long_1.default.ZERO).toString());
        message.proposerPriority !== undefined &&
            (obj.proposerPriority = (message.proposerPriority || long_1.default.ZERO).toString());
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseValidator();
        message.address = (_a = object.address) !== null && _a !== void 0 ? _a : new Uint8Array();
        message.pubKey =
            object.pubKey !== undefined && object.pubKey !== null
                ? keys_1.PublicKey.fromPartial(object.pubKey)
                : undefined;
        message.votingPower =
            object.votingPower !== undefined && object.votingPower !== null
                ? long_1.default.fromValue(object.votingPower)
                : long_1.default.ZERO;
        message.proposerPriority =
            object.proposerPriority !== undefined && object.proposerPriority !== null
                ? long_1.default.fromValue(object.proposerPriority)
                : long_1.default.ZERO;
        return message;
    },
};
function createBaseSimpleValidator() {
    return { pubKey: undefined, votingPower: long_1.default.ZERO };
}
exports.SimpleValidator = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.pubKey !== undefined) {
            keys_1.PublicKey.encode(message.pubKey, writer.uint32(10).fork()).ldelim();
        }
        if (!message.votingPower.isZero()) {
            writer.uint32(16).int64(message.votingPower);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSimpleValidator();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.pubKey = keys_1.PublicKey.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.votingPower = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            pubKey: isSet(object.pubKey) ? keys_1.PublicKey.fromJSON(object.pubKey) : undefined,
            votingPower: isSet(object.votingPower) ? long_1.default.fromValue(object.votingPower) : long_1.default.ZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        message.pubKey !== undefined &&
            (obj.pubKey = message.pubKey ? keys_1.PublicKey.toJSON(message.pubKey) : undefined);
        message.votingPower !== undefined && (obj.votingPower = (message.votingPower || long_1.default.ZERO).toString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseSimpleValidator();
        message.pubKey =
            object.pubKey !== undefined && object.pubKey !== null
                ? keys_1.PublicKey.fromPartial(object.pubKey)
                : undefined;
        message.votingPower =
            object.votingPower !== undefined && object.votingPower !== null
                ? long_1.default.fromValue(object.votingPower)
                : long_1.default.ZERO;
        return message;
    },
};
var globalThis = (() => {
    if (typeof globalThis !== "undefined") {
        return globalThis;
    }
    if (typeof self !== "undefined") {
        return self;
    }
    if (typeof window !== "undefined") {
        return window;
    }
    if (typeof __webpack_require__.g !== "undefined") {
        return __webpack_require__.g;
    }
    throw "Unable to locate global object";
})();
function bytesFromBase64(b64) {
    if (globalThis.Buffer) {
        return Uint8Array.from(globalThis.Buffer.from(b64, "base64"));
    }
    else {
        const bin = globalThis.atob(b64);
        const arr = new Uint8Array(bin.length);
        for (let i = 0; i < bin.length; ++i) {
            arr[i] = bin.charCodeAt(i);
        }
        return arr;
    }
}
function base64FromBytes(arr) {
    if (globalThis.Buffer) {
        return globalThis.Buffer.from(arr).toString("base64");
    }
    else {
        const bin = [];
        arr.forEach((byte) => {
            bin.push(String.fromCharCode(byte));
        });
        return globalThis.btoa(bin.join(""));
    }
}
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=validator.js.map

/***/ }),

/***/ 42107:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Consensus = exports.App = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(__webpack_require__(47873));
const minimal_1 = __importDefault(__webpack_require__(62100));
exports.protobufPackage = "tendermint.version";
function createBaseApp() {
    return { protocol: long_1.default.UZERO, software: "" };
}
exports.App = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (!message.protocol.isZero()) {
            writer.uint32(8).uint64(message.protocol);
        }
        if (message.software !== "") {
            writer.uint32(18).string(message.software);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseApp();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.protocol = reader.uint64();
                    break;
                case 2:
                    message.software = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            protocol: isSet(object.protocol) ? long_1.default.fromValue(object.protocol) : long_1.default.UZERO,
            software: isSet(object.software) ? String(object.software) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.protocol !== undefined && (obj.protocol = (message.protocol || long_1.default.UZERO).toString());
        message.software !== undefined && (obj.software = message.software);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseApp();
        message.protocol =
            object.protocol !== undefined && object.protocol !== null
                ? long_1.default.fromValue(object.protocol)
                : long_1.default.UZERO;
        message.software = (_a = object.software) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
function createBaseConsensus() {
    return { block: long_1.default.UZERO, app: long_1.default.UZERO };
}
exports.Consensus = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (!message.block.isZero()) {
            writer.uint32(8).uint64(message.block);
        }
        if (!message.app.isZero()) {
            writer.uint32(16).uint64(message.app);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseConsensus();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.block = reader.uint64();
                    break;
                case 2:
                    message.app = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            block: isSet(object.block) ? long_1.default.fromValue(object.block) : long_1.default.UZERO,
            app: isSet(object.app) ? long_1.default.fromValue(object.app) : long_1.default.UZERO,
        };
    },
    toJSON(message) {
        const obj = {};
        message.block !== undefined && (obj.block = (message.block || long_1.default.UZERO).toString());
        message.app !== undefined && (obj.app = (message.app || long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseConsensus();
        message.block =
            object.block !== undefined && object.block !== null ? long_1.default.fromValue(object.block) : long_1.default.UZERO;
        message.app = object.app !== undefined && object.app !== null ? long_1.default.fromValue(object.app) : long_1.default.UZERO;
        return message;
    },
};
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=types.js.map

/***/ }),

/***/ 61034:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ isArray; }
/* harmony export */ });
const { isArray } = Array


/***/ }),

/***/ 35167:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ keys; }
/* harmony export */ });
const { keys } = Object


/***/ }),

/***/ 70799:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ all; }
/* harmony export */ });
function all(predicate, list){
  if (arguments.length === 1) return _list => all(predicate, _list)

  for (let i = 0; i < list.length; i++){
    if (!predicate(list[ i ])) return false
  }

  return true
}


/***/ }),

/***/ 52680:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "hX": function() { return /* binding */ filter; }
/* harmony export */ });
/* unused harmony exports filterObject, filterArray */
/* harmony import */ var _internals_isArray_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61034);


function filterObject(predicate, obj){
  const willReturn = {}

  for (const prop in obj){
    if (predicate(
      obj[ prop ], prop, obj
    )){
      willReturn[ prop ] = obj[ prop ]
    }
  }

  return willReturn
}

function filterArray(
  predicate, list, indexed = false
){
  let index = 0
  const len = list.length
  const willReturn = []

  while (index < len){
    const predicateResult = indexed ?
      predicate(list[ index ], index) :
      predicate(list[ index ])
    if (predicateResult){
      willReturn.push(list[ index ])
    }

    index++
  }

  return willReturn
}

function filter(predicate, iterable){
  if (arguments.length === 1)
    return _iterable => filter(predicate, _iterable)
  if (!iterable){
    throw new Error('Incorrect iterable input')
  }

  if ((0,_internals_isArray_js__WEBPACK_IMPORTED_MODULE_0__/* .isArray */ .k)(iterable)) return filterArray(
    predicate, iterable, false
  )

  return filterObject(predicate, iterable)
}


/***/ }),

/***/ 92179:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ forEach; }
/* harmony export */ });
/* harmony import */ var _internals_isArray_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61034);
/* harmony import */ var _internals_keys_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35167);



function forEach(fn, list){
  if (arguments.length === 1) return _list => forEach(fn, _list)

  if (list === undefined){
    return
  }

  if ((0,_internals_isArray_js__WEBPACK_IMPORTED_MODULE_0__/* .isArray */ .k)(list)){
    let index = 0
    const len = list.length

    while (index < len){
      fn(list[ index ])
      index++
    }
  } else {
    let index = 0
    const listKeys = (0,_internals_keys_js__WEBPACK_IMPORTED_MODULE_1__/* .keys */ .X)(list)
    const len = listKeys.length

    while (index < len){
      const key = listKeys[ index ]
      fn(
        list[ key ], key, list
      )
      index++
    }
  }

  return list
}


/***/ }),

/***/ 3794:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "H": function() { return /* binding */ indexBy; }
});

;// CONCATENATED MODULE: ./node_modules/rambda/src/_internals/createPath.js
function createPath(path, delimiter = '.'){
  return typeof path === 'string' ? path.split(delimiter) : path
}

;// CONCATENATED MODULE: ./node_modules/rambda/src/path.js


function path(pathInput, obj){
  if (arguments.length === 1) return _obj => path(pathInput, _obj)

  if (obj === null || obj === undefined){
    return undefined
  }
  let willReturn = obj
  let counter = 0

  const pathArrValue = createPath(pathInput)

  while (counter < pathArrValue.length){
    if (willReturn === null || willReturn === undefined){
      return undefined
    }
    if (willReturn[ pathArrValue[ counter ] ] === null) return undefined

    willReturn = willReturn[ pathArrValue[ counter ] ]
    counter++
  }

  return willReturn
}

;// CONCATENATED MODULE: ./node_modules/rambda/src/indexBy.js


function indexByPath(pathInput, list){
  const toReturn = {}
  for (let i = 0; i < list.length; i++){
    const item = list[ i ]
    toReturn[ path(pathInput, item) ] = item
  }

  return toReturn
}

function indexBy(condition, list){
  if (arguments.length === 1){
    return _list => indexBy(condition, _list)
  }

  if (typeof condition === 'string'){
    return indexByPath(condition, list)
  }

  const toReturn = {}
  for (let i = 0; i < list.length; i++){
    const item = list[ i ]
    toReturn[ condition(item) ] = item
  }

  return toReturn
}


/***/ }),

/***/ 46596:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ isNil; }
/* harmony export */ });
function isNil(x){
  return x === undefined || x === null
}


/***/ }),

/***/ 73542:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ keys; }
/* harmony export */ });
function keys(x){
  return Object.keys(x)
}


/***/ }),

/***/ 77493:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ length; }
/* harmony export */ });
/* harmony import */ var _internals_isArray_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61034);


function length(x){
  if ((0,_internals_isArray_js__WEBPACK_IMPORTED_MODULE_0__/* .isArray */ .k)(x)) return x.length
  if (typeof x === 'string') return x.length

  return NaN
}


/***/ }),

/***/ 98991:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "UI": function() { return /* binding */ map; }
});

// UNUSED EXPORTS: mapArray, mapObjIndexed, mapObject

;// CONCATENATED MODULE: ./node_modules/rambda/src/_internals/constants.js
const INCORRECT_ITERABLE_INPUT = 'Incorrect iterable input'

// EXTERNAL MODULE: ./node_modules/rambda/src/_internals/isArray.js
var isArray = __webpack_require__(61034);
// EXTERNAL MODULE: ./node_modules/rambda/src/_internals/keys.js
var keys = __webpack_require__(35167);
;// CONCATENATED MODULE: ./node_modules/rambda/src/map.js




function mapArray(
  fn, list, isIndexed = false
){
  let index = 0
  const willReturn = Array(list.length)

  while (index < list.length){
    willReturn[ index ] = isIndexed ? fn(list[ index ], index) : fn(list[ index ])

    index++
  }

  return willReturn
}

function mapObject(fn, obj){
  if (arguments.length === 1){
    return _obj => mapObject(fn, _obj)
  }
  let index = 0
  const objKeys = (0,keys/* keys */.X)(obj)
  const len = objKeys.length
  const willReturn = {}

  while (index < len){
    const key = objKeys[ index ]
    willReturn[ key ] = fn(
      obj[ key ], key, obj
    )
    index++
  }

  return willReturn
}

const mapObjIndexed = (/* unused pure expression or super */ null && (mapObject))

function map(fn, iterable){
  if (arguments.length === 1) return _iterable => map(fn, _iterable)
  if (!iterable){
    throw new Error(INCORRECT_ITERABLE_INPUT)
  }

  if ((0,isArray/* isArray */.k)(iterable)) return mapArray(fn, iterable)

  return mapObject(fn, iterable)
}


/***/ }),

/***/ 89279:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "J": function() { return /* binding */ mergeAll; }
});

// EXTERNAL MODULE: ./node_modules/rambda/src/map.js + 1 modules
var map = __webpack_require__(98991);
;// CONCATENATED MODULE: ./node_modules/rambda/src/mergeRight.js
function mergeRight(target, newProps){
  if (arguments.length === 1)
    return _newProps => mergeRight(target, _newProps)

  return Object.assign(
    {}, target || {}, newProps || {}
  )
}

;// CONCATENATED MODULE: ./node_modules/rambda/src/mergeAll.js



function mergeAll(arr){
  let willReturn = {}
  ;(0,map/* map */.UI)(val => {
    willReturn = mergeRight(willReturn, val)
  }, arr)

  return willReturn
}


/***/ }),

/***/ 71981:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "u4": function() { return /* binding */ reduce; }
});

// UNUSED EXPORTS: reduceFn, reduceStopper

// EXTERNAL MODULE: ./node_modules/rambda/src/_internals/isArray.js
var isArray = __webpack_require__(61034);
;// CONCATENATED MODULE: ./node_modules/rambda/src/curry.js
function curry(fn, args = []){
  return (..._args) =>
    (rest => rest.length >= fn.length ? fn(...rest) : curry(fn, rest))([
      ...args,
      ..._args,
    ])
}

;// CONCATENATED MODULE: ./node_modules/rambda/src/reduce.js



class ReduceStopper{
  constructor(value){
    this.value = value
  }
}

function reduceFn(
  reducer, acc, list
){
  if (!(0,isArray/* isArray */.k)(list)){
    throw new TypeError('reduce: list must be array or iterable')
  }
  let index = 0
  const len = list.length

  while (index < len){
    acc = reducer(
      acc, list[ index ], index, list
    )
    if (acc instanceof ReduceStopper){
      return acc.value
    }
    index++
  }

  return acc
}

const reduce = curry(reduceFn)
const reduceStopper = value => new ReduceStopper(value)


/***/ }),

/***/ 82370:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ reverse; }
/* harmony export */ });
function reverse(listOrString){
  if (typeof listOrString === 'string'){
    return listOrString.split('').reverse()
      .join('')
  }

  const clone = listOrString.slice()

  return clone.reverse()
}


/***/ }),

/***/ 29977:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "D": function() { return /* binding */ sort; }
});

;// CONCATENATED MODULE: ./node_modules/rambda/src/_internals/cloneList.js
const cloneList = list => Array.prototype.slice.call(list)

;// CONCATENATED MODULE: ./node_modules/rambda/src/sort.js


function sort(sortFn, list){
  if (arguments.length === 1) return _list => sort(sortFn, _list)

  return cloneList(list).sort(sortFn)
}


/***/ }),

/***/ 99615:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ split; }
/* harmony export */ });
function split(separator, str){
  if (arguments.length === 1) return _str => split(separator, _str)

  return str.split(separator)
}


/***/ }),

/***/ 78277:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ toLower; }
/* harmony export */ });
function toLower(str){
  return str.toLowerCase()
}


/***/ }),

/***/ 2728:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ toPairs; }
/* harmony export */ });
function toPairs(obj){
  return Object.entries(obj)
}


/***/ }),

/***/ 85694:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ type; }
/* harmony export */ });
function type(input){
  if (input === null){
    return 'Null'
  } else if (input === undefined){
    return 'Undefined'
  } else if (Number.isNaN(input)){
    return 'NaN'
  }
  const typeResult = Object.prototype.toString.call(input).slice(8, -1)

  return typeResult === 'AsyncFunction' ? 'Promise' : typeResult
}


/***/ }),

/***/ 55836:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "j": function() { return /* binding */ uniq; }
});

// EXTERNAL MODULE: ./node_modules/rambda/src/_internals/isArray.js
var _internals_isArray = __webpack_require__(61034);
// EXTERNAL MODULE: ./node_modules/rambda/src/type.js
var src_type = __webpack_require__(85694);
;// CONCATENATED MODULE: ./node_modules/rambda/src/equals.js



function _lastIndexOf(valueToFind, list){
  if (!isArray(list)){
    throw new Error(`Cannot read property 'indexOf' of ${ list }`)
  }
  const typeOfValue = type(valueToFind)
  if (![ 'Object', 'Array', 'NaN', 'RegExp' ].includes(typeOfValue))
    return list.lastIndexOf(valueToFind)

  const { length } = list
  let index = length
  let foundIndex = -1

  while (--index > -1 && foundIndex === -1){
    if (equals(list[ index ], valueToFind)){
      foundIndex = index
    }
  }

  return foundIndex
}

function _indexOf(valueToFind, list){
  if (!(0,_internals_isArray/* isArray */.k)(list)){
    throw new Error(`Cannot read property 'indexOf' of ${ list }`)
  }
  const typeOfValue = (0,src_type/* type */.d)(valueToFind)
  if (![ 'Object', 'Array', 'NaN', 'RegExp' ].includes(typeOfValue))
    return list.indexOf(valueToFind)

  let index = -1
  let foundIndex = -1
  const { length } = list

  while (++index < length && foundIndex === -1){
    if (equals(list[ index ], valueToFind)){
      foundIndex = index
    }
  }

  return foundIndex
}

function _arrayFromIterator(iter){
  const list = []
  let next
  while (!(next = iter.next()).done){
    list.push(next.value)
  }

  return list
}

function _equalsSets(a, b){
  if (a.size !== b.size){
    return false
  }
  const aList = _arrayFromIterator(a.values())
  const bList = _arrayFromIterator(b.values())

  const filtered = aList.filter(aInstance => _indexOf(aInstance, bList) === -1)

  return filtered.length === 0
}

function parseError(maybeError){
  const typeofError = maybeError.__proto__.toString()
  if (![ 'Error', 'TypeError' ].includes(typeofError)) return []

  return [ typeofError, maybeError.message ]
}

function parseDate(maybeDate){
  if (!maybeDate.toDateString) return [ false ]

  return [ true, maybeDate.getTime() ]
}

function parseRegex(maybeRegex){
  if (maybeRegex.constructor !== RegExp) return [ false ]

  return [ true, maybeRegex.toString() ]
}

function equals(a, b){
  if (arguments.length === 1) return _b => equals(a, _b)

  const aType = (0,src_type/* type */.d)(a)

  if (aType !== (0,src_type/* type */.d)(b)) return false
  if (aType === 'Function'){
    return a.name === undefined ? false : a.name === b.name
  }

  if ([ 'NaN', 'Undefined', 'Null' ].includes(aType)) return true

  if (aType === 'Number'){
    if (Object.is(-0, a) !== Object.is(-0, b)) return false

    return a.toString() === b.toString()
  }

  if ([ 'String', 'Boolean' ].includes(aType)){
    return a.toString() === b.toString()
  }

  if (aType === 'Array'){
    const aClone = Array.from(a)
    const bClone = Array.from(b)

    if (aClone.toString() !== bClone.toString()){
      return false
    }

    let loopArrayFlag = true
    aClone.forEach((aCloneInstance, aCloneIndex) => {
      if (loopArrayFlag){
        if (
          aCloneInstance !== bClone[ aCloneIndex ] &&
          !equals(aCloneInstance, bClone[ aCloneIndex ])
        ){
          loopArrayFlag = false
        }
      }
    })

    return loopArrayFlag
  }

  const aRegex = parseRegex(a)
  const bRegex = parseRegex(b)

  if (aRegex[ 0 ]){
    return bRegex[ 0 ] ? aRegex[ 1 ] === bRegex[ 1 ] : false
  } else if (bRegex[ 0 ]) return false

  const aDate = parseDate(a)
  const bDate = parseDate(b)

  if (aDate[ 0 ]){
    return bDate[ 0 ] ? aDate[ 1 ] === bDate[ 1 ] : false
  } else if (bDate[ 0 ]) return false

  const aError = parseError(a)
  const bError = parseError(b)

  if (aError[ 0 ]){
    return bError[ 0 ] ?
      aError[ 0 ] === bError[ 0 ] && aError[ 1 ] === bError[ 1 ] :
      false
  }
  if (aType === 'Set'){
    return _equalsSets(a, b)
  }
  if (aType === 'Object'){
    const aKeys = Object.keys(a)

    if (aKeys.length !== Object.keys(b).length){
      return false
    }

    let loopObjectFlag = true
    aKeys.forEach(aKeyInstance => {
      if (loopObjectFlag){
        const aValue = a[ aKeyInstance ]
        const bValue = b[ aKeyInstance ]

        if (aValue !== bValue && !equals(aValue, bValue)){
          loopObjectFlag = false
        }
      }
    })

    return loopObjectFlag
  }

  return false
}

;// CONCATENATED MODULE: ./node_modules/rambda/src/_internals/set.js



class _Set{
  constructor(){
    this.set = new Set()
    this.items = {}
  }

  checkUniqueness(item){
    const type = (0,src_type/* type */.d)(item)
    if ([ 'Null', 'Undefined', 'NaN' ].includes(type)){
      if (type in this.items){
        return false
      }
      this.items[ type ] = true

      return true
    }
    if (![ 'Object', 'Array' ].includes(type)){
      const prevSize = this.set.size
      this.set.add(item)

      return this.set.size !== prevSize
    }

    if (!(type in this.items)){
      this.items[ type ] = [ item ]

      return true
    }

    if (_indexOf(item, this.items[ type ]) === -1){
      this.items[ type ].push(item)

      return true
    }

    return false
  }
}

;// CONCATENATED MODULE: ./node_modules/rambda/src/uniq.js


function uniq(list){
  const set = new _Set()
  const willReturn = []
  list.forEach(item => {
    if (set.checkUniqueness(item)){
      willReturn.push(item)
    }
  })

  return willReturn
}


/***/ }),

/***/ 6285:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ values; }
/* harmony export */ });
/* harmony import */ var _type_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85694);


function values(obj){
  if ((0,_type_js__WEBPACK_IMPORTED_MODULE_0__/* .type */ .d)(obj) !== 'Object') return []

  return Object.values(obj)
}


/***/ }),

/***/ 49577:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ zip; }
/* harmony export */ });
function zip(left, right){
  if (arguments.length === 1) return _right => zip(left, _right)

  const result = []
  const length = Math.min(left.length, right.length)

  for (let i = 0; i < length; i++){
    result[ i ] = [ left[ i ], right[ i ] ]
  }

  return result
}


/***/ }),

/***/ 48731:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// This is free and unencumbered software released into the public domain.
// See LICENSE.md for more information.

var encoding = __webpack_require__(74498);

module.exports = {
  TextEncoder: encoding.TextEncoder,
  TextDecoder: encoding.TextDecoder,
};


/***/ }),

/***/ 74498:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// This is free and unencumbered software released into the public domain.
// See LICENSE.md for more information.

/**
 * @fileoverview Global |this| required for resolving indexes in node.
 * @suppress {globalThis}
 */
(function(global) {
  'use strict';

  // If we're in node require encoding-indexes and attach it to the global.
  if ( true && module.exports &&
    !global["encoding-indexes"]) {
    global["encoding-indexes"] =
      (__webpack_require__(52162)["encoding-indexes"]);
  }

  //
  // Utilities
  //

  /**
   * @param {number} a The number to test.
   * @param {number} min The minimum value in the range, inclusive.
   * @param {number} max The maximum value in the range, inclusive.
   * @return {boolean} True if a >= min and a <= max.
   */
  function inRange(a, min, max) {
    return min <= a && a <= max;
  }

  /**
   * @param {!Array.<*>} array The array to check.
   * @param {*} item The item to look for in the array.
   * @return {boolean} True if the item appears in the array.
   */
  function includes(array, item) {
    return array.indexOf(item) !== -1;
  }

  var floor = Math.floor;

  /**
   * @param {*} o
   * @return {Object}
   */
  function ToDictionary(o) {
    if (o === undefined) return {};
    if (o === Object(o)) return o;
    throw TypeError('Could not convert argument to dictionary');
  }

  /**
   * @param {string} string Input string of UTF-16 code units.
   * @return {!Array.<number>} Code points.
   */
  function stringToCodePoints(string) {
    // https://heycam.github.io/webidl/#dfn-obtain-unicode

    // 1. Let S be the DOMString value.
    var s = String(string);

    // 2. Let n be the length of S.
    var n = s.length;

    // 3. Initialize i to 0.
    var i = 0;

    // 4. Initialize U to be an empty sequence of Unicode characters.
    var u = [];

    // 5. While i < n:
    while (i < n) {

      // 1. Let c be the code unit in S at index i.
      var c = s.charCodeAt(i);

      // 2. Depending on the value of c:

      // c < 0xD800 or c > 0xDFFF
      if (c < 0xD800 || c > 0xDFFF) {
        // Append to U the Unicode character with code point c.
        u.push(c);
      }

      // 0xDC00 ≤ c ≤ 0xDFFF
      else if (0xDC00 <= c && c <= 0xDFFF) {
        // Append to U a U+FFFD REPLACEMENT CHARACTER.
        u.push(0xFFFD);
      }

      // 0xD800 ≤ c ≤ 0xDBFF
      else if (0xD800 <= c && c <= 0xDBFF) {
        // 1. If i = n−1, then append to U a U+FFFD REPLACEMENT
        // CHARACTER.
        if (i === n - 1) {
          u.push(0xFFFD);
        }
        // 2. Otherwise, i < n−1:
        else {
          // 1. Let d be the code unit in S at index i+1.
          var d = s.charCodeAt(i + 1);

          // 2. If 0xDC00 ≤ d ≤ 0xDFFF, then:
          if (0xDC00 <= d && d <= 0xDFFF) {
            // 1. Let a be c & 0x3FF.
            var a = c & 0x3FF;

            // 2. Let b be d & 0x3FF.
            var b = d & 0x3FF;

            // 3. Append to U the Unicode character with code point
            // 2^16+2^10*a+b.
            u.push(0x10000 + (a << 10) + b);

            // 4. Set i to i+1.
            i += 1;
          }

          // 3. Otherwise, d < 0xDC00 or d > 0xDFFF. Append to U a
          // U+FFFD REPLACEMENT CHARACTER.
          else  {
            u.push(0xFFFD);
          }
        }
      }

      // 3. Set i to i+1.
      i += 1;
    }

    // 6. Return U.
    return u;
  }

  /**
   * @param {!Array.<number>} code_points Array of code points.
   * @return {string} string String of UTF-16 code units.
   */
  function codePointsToString(code_points) {
    var s = '';
    for (var i = 0; i < code_points.length; ++i) {
      var cp = code_points[i];
      if (cp <= 0xFFFF) {
        s += String.fromCharCode(cp);
      } else {
        cp -= 0x10000;
        s += String.fromCharCode((cp >> 10) + 0xD800,
                                 (cp & 0x3FF) + 0xDC00);
      }
    }
    return s;
  }


  //
  // Implementation of Encoding specification
  // https://encoding.spec.whatwg.org/
  //

  //
  // 4. Terminology
  //

  /**
   * An ASCII byte is a byte in the range 0x00 to 0x7F, inclusive.
   * @param {number} a The number to test.
   * @return {boolean} True if a is in the range 0x00 to 0x7F, inclusive.
   */
  function isASCIIByte(a) {
    return 0x00 <= a && a <= 0x7F;
  }

  /**
   * An ASCII code point is a code point in the range U+0000 to
   * U+007F, inclusive.
   */
  var isASCIICodePoint = isASCIIByte;


  /**
   * End-of-stream is a special token that signifies no more tokens
   * are in the stream.
   * @const
   */ var end_of_stream = -1;

  /**
   * A stream represents an ordered sequence of tokens.
   *
   * @constructor
   * @param {!(Array.<number>|Uint8Array)} tokens Array of tokens that provide
   * the stream.
   */
  function Stream(tokens) {
    /** @type {!Array.<number>} */
    this.tokens = [].slice.call(tokens);
    // Reversed as push/pop is more efficient than shift/unshift.
    this.tokens.reverse();
  }

  Stream.prototype = {
    /**
     * @return {boolean} True if end-of-stream has been hit.
     */
    endOfStream: function() {
      return !this.tokens.length;
    },

    /**
     * When a token is read from a stream, the first token in the
     * stream must be returned and subsequently removed, and
     * end-of-stream must be returned otherwise.
     *
     * @return {number} Get the next token from the stream, or
     * end_of_stream.
     */
     read: function() {
      if (!this.tokens.length)
        return end_of_stream;
       return this.tokens.pop();
     },

    /**
     * When one or more tokens are prepended to a stream, those tokens
     * must be inserted, in given order, before the first token in the
     * stream.
     *
     * @param {(number|!Array.<number>)} token The token(s) to prepend to the
     * stream.
     */
    prepend: function(token) {
      if (Array.isArray(token)) {
        var tokens = /**@type {!Array.<number>}*/(token);
        while (tokens.length)
          this.tokens.push(tokens.pop());
      } else {
        this.tokens.push(token);
      }
    },

    /**
     * When one or more tokens are pushed to a stream, those tokens
     * must be inserted, in given order, after the last token in the
     * stream.
     *
     * @param {(number|!Array.<number>)} token The tokens(s) to push to the
     * stream.
     */
    push: function(token) {
      if (Array.isArray(token)) {
        var tokens = /**@type {!Array.<number>}*/(token);
        while (tokens.length)
          this.tokens.unshift(tokens.shift());
      } else {
        this.tokens.unshift(token);
      }
    }
  };

  //
  // 5. Encodings
  //

  // 5.1 Encoders and decoders

  /** @const */
  var finished = -1;

  /**
   * @param {boolean} fatal If true, decoding errors raise an exception.
   * @param {number=} opt_code_point Override the standard fallback code point.
   * @return {number} The code point to insert on a decoding error.
   */
  function decoderError(fatal, opt_code_point) {
    if (fatal)
      throw TypeError('Decoder error');
    return opt_code_point || 0xFFFD;
  }

  /**
   * @param {number} code_point The code point that could not be encoded.
   * @return {number} Always throws, no value is actually returned.
   */
  function encoderError(code_point) {
    throw TypeError('The code point ' + code_point + ' could not be encoded.');
  }

  /** @interface */
  function Decoder() {}
  Decoder.prototype = {
    /**
     * @param {Stream} stream The stream of bytes being decoded.
     * @param {number} bite The next byte read from the stream.
     * @return {?(number|!Array.<number>)} The next code point(s)
     *     decoded, or null if not enough data exists in the input
     *     stream to decode a complete code point, or |finished|.
     */
    handler: function(stream, bite) {}
  };

  /** @interface */
  function Encoder() {}
  Encoder.prototype = {
    /**
     * @param {Stream} stream The stream of code points being encoded.
     * @param {number} code_point Next code point read from the stream.
     * @return {(number|!Array.<number>)} Byte(s) to emit, or |finished|.
     */
    handler: function(stream, code_point) {}
  };

  // 5.2 Names and labels

  // TODO: Define @typedef for Encoding: {name:string,labels:Array.<string>}
  // https://github.com/google/closure-compiler/issues/247

  /**
   * @param {string} label The encoding label.
   * @return {?{name:string,labels:Array.<string>}}
   */
  function getEncoding(label) {
    // 1. Remove any leading and trailing ASCII whitespace from label.
    label = String(label).trim().toLowerCase();

    // 2. If label is an ASCII case-insensitive match for any of the
    // labels listed in the table below, return the corresponding
    // encoding, and failure otherwise.
    if (Object.prototype.hasOwnProperty.call(label_to_encoding, label)) {
      return label_to_encoding[label];
    }
    return null;
  }

  /**
   * Encodings table: https://encoding.spec.whatwg.org/encodings.json
   * @const
   * @type {!Array.<{
   *          heading: string,
   *          encodings: Array.<{name:string,labels:Array.<string>}>
   *        }>}
   */
  var encodings = [
    {
      "encodings": [
        {
          "labels": [
            "unicode-1-1-utf-8",
            "utf-8",
            "utf8"
          ],
          "name": "UTF-8"
        }
      ],
      "heading": "The Encoding"
    },
    {
      "encodings": [
        {
          "labels": [
            "866",
            "cp866",
            "csibm866",
            "ibm866"
          ],
          "name": "IBM866"
        },
        {
          "labels": [
            "csisolatin2",
            "iso-8859-2",
            "iso-ir-101",
            "iso8859-2",
            "iso88592",
            "iso_8859-2",
            "iso_8859-2:1987",
            "l2",
            "latin2"
          ],
          "name": "ISO-8859-2"
        },
        {
          "labels": [
            "csisolatin3",
            "iso-8859-3",
            "iso-ir-109",
            "iso8859-3",
            "iso88593",
            "iso_8859-3",
            "iso_8859-3:1988",
            "l3",
            "latin3"
          ],
          "name": "ISO-8859-3"
        },
        {
          "labels": [
            "csisolatin4",
            "iso-8859-4",
            "iso-ir-110",
            "iso8859-4",
            "iso88594",
            "iso_8859-4",
            "iso_8859-4:1988",
            "l4",
            "latin4"
          ],
          "name": "ISO-8859-4"
        },
        {
          "labels": [
            "csisolatincyrillic",
            "cyrillic",
            "iso-8859-5",
            "iso-ir-144",
            "iso8859-5",
            "iso88595",
            "iso_8859-5",
            "iso_8859-5:1988"
          ],
          "name": "ISO-8859-5"
        },
        {
          "labels": [
            "arabic",
            "asmo-708",
            "csiso88596e",
            "csiso88596i",
            "csisolatinarabic",
            "ecma-114",
            "iso-8859-6",
            "iso-8859-6-e",
            "iso-8859-6-i",
            "iso-ir-127",
            "iso8859-6",
            "iso88596",
            "iso_8859-6",
            "iso_8859-6:1987"
          ],
          "name": "ISO-8859-6"
        },
        {
          "labels": [
            "csisolatingreek",
            "ecma-118",
            "elot_928",
            "greek",
            "greek8",
            "iso-8859-7",
            "iso-ir-126",
            "iso8859-7",
            "iso88597",
            "iso_8859-7",
            "iso_8859-7:1987",
            "sun_eu_greek"
          ],
          "name": "ISO-8859-7"
        },
        {
          "labels": [
            "csiso88598e",
            "csisolatinhebrew",
            "hebrew",
            "iso-8859-8",
            "iso-8859-8-e",
            "iso-ir-138",
            "iso8859-8",
            "iso88598",
            "iso_8859-8",
            "iso_8859-8:1988",
            "visual"
          ],
          "name": "ISO-8859-8"
        },
        {
          "labels": [
            "csiso88598i",
            "iso-8859-8-i",
            "logical"
          ],
          "name": "ISO-8859-8-I"
        },
        {
          "labels": [
            "csisolatin6",
            "iso-8859-10",
            "iso-ir-157",
            "iso8859-10",
            "iso885910",
            "l6",
            "latin6"
          ],
          "name": "ISO-8859-10"
        },
        {
          "labels": [
            "iso-8859-13",
            "iso8859-13",
            "iso885913"
          ],
          "name": "ISO-8859-13"
        },
        {
          "labels": [
            "iso-8859-14",
            "iso8859-14",
            "iso885914"
          ],
          "name": "ISO-8859-14"
        },
        {
          "labels": [
            "csisolatin9",
            "iso-8859-15",
            "iso8859-15",
            "iso885915",
            "iso_8859-15",
            "l9"
          ],
          "name": "ISO-8859-15"
        },
        {
          "labels": [
            "iso-8859-16"
          ],
          "name": "ISO-8859-16"
        },
        {
          "labels": [
            "cskoi8r",
            "koi",
            "koi8",
            "koi8-r",
            "koi8_r"
          ],
          "name": "KOI8-R"
        },
        {
          "labels": [
            "koi8-ru",
            "koi8-u"
          ],
          "name": "KOI8-U"
        },
        {
          "labels": [
            "csmacintosh",
            "mac",
            "macintosh",
            "x-mac-roman"
          ],
          "name": "macintosh"
        },
        {
          "labels": [
            "dos-874",
            "iso-8859-11",
            "iso8859-11",
            "iso885911",
            "tis-620",
            "windows-874"
          ],
          "name": "windows-874"
        },
        {
          "labels": [
            "cp1250",
            "windows-1250",
            "x-cp1250"
          ],
          "name": "windows-1250"
        },
        {
          "labels": [
            "cp1251",
            "windows-1251",
            "x-cp1251"
          ],
          "name": "windows-1251"
        },
        {
          "labels": [
            "ansi_x3.4-1968",
            "ascii",
            "cp1252",
            "cp819",
            "csisolatin1",
            "ibm819",
            "iso-8859-1",
            "iso-ir-100",
            "iso8859-1",
            "iso88591",
            "iso_8859-1",
            "iso_8859-1:1987",
            "l1",
            "latin1",
            "us-ascii",
            "windows-1252",
            "x-cp1252"
          ],
          "name": "windows-1252"
        },
        {
          "labels": [
            "cp1253",
            "windows-1253",
            "x-cp1253"
          ],
          "name": "windows-1253"
        },
        {
          "labels": [
            "cp1254",
            "csisolatin5",
            "iso-8859-9",
            "iso-ir-148",
            "iso8859-9",
            "iso88599",
            "iso_8859-9",
            "iso_8859-9:1989",
            "l5",
            "latin5",
            "windows-1254",
            "x-cp1254"
          ],
          "name": "windows-1254"
        },
        {
          "labels": [
            "cp1255",
            "windows-1255",
            "x-cp1255"
          ],
          "name": "windows-1255"
        },
        {
          "labels": [
            "cp1256",
            "windows-1256",
            "x-cp1256"
          ],
          "name": "windows-1256"
        },
        {
          "labels": [
            "cp1257",
            "windows-1257",
            "x-cp1257"
          ],
          "name": "windows-1257"
        },
        {
          "labels": [
            "cp1258",
            "windows-1258",
            "x-cp1258"
          ],
          "name": "windows-1258"
        },
        {
          "labels": [
            "x-mac-cyrillic",
            "x-mac-ukrainian"
          ],
          "name": "x-mac-cyrillic"
        }
      ],
      "heading": "Legacy single-byte encodings"
    },
    {
      "encodings": [
        {
          "labels": [
            "chinese",
            "csgb2312",
            "csiso58gb231280",
            "gb2312",
            "gb_2312",
            "gb_2312-80",
            "gbk",
            "iso-ir-58",
            "x-gbk"
          ],
          "name": "GBK"
        },
        {
          "labels": [
            "gb18030"
          ],
          "name": "gb18030"
        }
      ],
      "heading": "Legacy multi-byte Chinese (simplified) encodings"
    },
    {
      "encodings": [
        {
          "labels": [
            "big5",
            "big5-hkscs",
            "cn-big5",
            "csbig5",
            "x-x-big5"
          ],
          "name": "Big5"
        }
      ],
      "heading": "Legacy multi-byte Chinese (traditional) encodings"
    },
    {
      "encodings": [
        {
          "labels": [
            "cseucpkdfmtjapanese",
            "euc-jp",
            "x-euc-jp"
          ],
          "name": "EUC-JP"
        },
        {
          "labels": [
            "csiso2022jp",
            "iso-2022-jp"
          ],
          "name": "ISO-2022-JP"
        },
        {
          "labels": [
            "csshiftjis",
            "ms932",
            "ms_kanji",
            "shift-jis",
            "shift_jis",
            "sjis",
            "windows-31j",
            "x-sjis"
          ],
          "name": "Shift_JIS"
        }
      ],
      "heading": "Legacy multi-byte Japanese encodings"
    },
    {
      "encodings": [
        {
          "labels": [
            "cseuckr",
            "csksc56011987",
            "euc-kr",
            "iso-ir-149",
            "korean",
            "ks_c_5601-1987",
            "ks_c_5601-1989",
            "ksc5601",
            "ksc_5601",
            "windows-949"
          ],
          "name": "EUC-KR"
        }
      ],
      "heading": "Legacy multi-byte Korean encodings"
    },
    {
      "encodings": [
        {
          "labels": [
            "csiso2022kr",
            "hz-gb-2312",
            "iso-2022-cn",
            "iso-2022-cn-ext",
            "iso-2022-kr"
          ],
          "name": "replacement"
        },
        {
          "labels": [
            "utf-16be"
          ],
          "name": "UTF-16BE"
        },
        {
          "labels": [
            "utf-16",
            "utf-16le"
          ],
          "name": "UTF-16LE"
        },
        {
          "labels": [
            "x-user-defined"
          ],
          "name": "x-user-defined"
        }
      ],
      "heading": "Legacy miscellaneous encodings"
    }
  ];

  // Label to encoding registry.
  /** @type {Object.<string,{name:string,labels:Array.<string>}>} */
  var label_to_encoding = {};
  encodings.forEach(function(category) {
    category.encodings.forEach(function(encoding) {
      encoding.labels.forEach(function(label) {
        label_to_encoding[label] = encoding;
      });
    });
  });

  // Registry of of encoder/decoder factories, by encoding name.
  /** @type {Object.<string, function({fatal:boolean}): Encoder>} */
  var encoders = {};
  /** @type {Object.<string, function({fatal:boolean}): Decoder>} */
  var decoders = {};

  //
  // 6. Indexes
  //

  /**
   * @param {number} pointer The |pointer| to search for.
   * @param {(!Array.<?number>|undefined)} index The |index| to search within.
   * @return {?number} The code point corresponding to |pointer| in |index|,
   *     or null if |code point| is not in |index|.
   */
  function indexCodePointFor(pointer, index) {
    if (!index) return null;
    return index[pointer] || null;
  }

  /**
   * @param {number} code_point The |code point| to search for.
   * @param {!Array.<?number>} index The |index| to search within.
   * @return {?number} The first pointer corresponding to |code point| in
   *     |index|, or null if |code point| is not in |index|.
   */
  function indexPointerFor(code_point, index) {
    var pointer = index.indexOf(code_point);
    return pointer === -1 ? null : pointer;
  }

  /**
   * @param {string} name Name of the index.
   * @return {(!Array.<number>|!Array.<Array.<number>>)}
   *  */
  function index(name) {
    if (!('encoding-indexes' in global)) {
      throw Error("Indexes missing." +
                  " Did you forget to include encoding-indexes.js first?");
    }
    return global['encoding-indexes'][name];
  }

  /**
   * @param {number} pointer The |pointer| to search for in the gb18030 index.
   * @return {?number} The code point corresponding to |pointer| in |index|,
   *     or null if |code point| is not in the gb18030 index.
   */
  function indexGB18030RangesCodePointFor(pointer) {
    // 1. If pointer is greater than 39419 and less than 189000, or
    // pointer is greater than 1237575, return null.
    if ((pointer > 39419 && pointer < 189000) || (pointer > 1237575))
      return null;

    // 2. If pointer is 7457, return code point U+E7C7.
    if (pointer === 7457) return 0xE7C7;

    // 3. Let offset be the last pointer in index gb18030 ranges that
    // is equal to or less than pointer and let code point offset be
    // its corresponding code point.
    var offset = 0;
    var code_point_offset = 0;
    var idx = index('gb18030-ranges');
    var i;
    for (i = 0; i < idx.length; ++i) {
      /** @type {!Array.<number>} */
      var entry = idx[i];
      if (entry[0] <= pointer) {
        offset = entry[0];
        code_point_offset = entry[1];
      } else {
        break;
      }
    }

    // 4. Return a code point whose value is code point offset +
    // pointer − offset.
    return code_point_offset + pointer - offset;
  }

  /**
   * @param {number} code_point The |code point| to locate in the gb18030 index.
   * @return {number} The first pointer corresponding to |code point| in the
   *     gb18030 index.
   */
  function indexGB18030RangesPointerFor(code_point) {
    // 1. If code point is U+E7C7, return pointer 7457.
    if (code_point === 0xE7C7) return 7457;

    // 2. Let offset be the last code point in index gb18030 ranges
    // that is equal to or less than code point and let pointer offset
    // be its corresponding pointer.
    var offset = 0;
    var pointer_offset = 0;
    var idx = index('gb18030-ranges');
    var i;
    for (i = 0; i < idx.length; ++i) {
      /** @type {!Array.<number>} */
      var entry = idx[i];
      if (entry[1] <= code_point) {
        offset = entry[1];
        pointer_offset = entry[0];
      } else {
        break;
      }
    }

    // 3. Return a pointer whose value is pointer offset + code point
    // − offset.
    return pointer_offset + code_point - offset;
  }

  /**
   * @param {number} code_point The |code_point| to search for in the Shift_JIS
   *     index.
   * @return {?number} The code point corresponding to |pointer| in |index|,
   *     or null if |code point| is not in the Shift_JIS index.
   */
  function indexShiftJISPointerFor(code_point) {
    // 1. Let index be index jis0208 excluding all entries whose
    // pointer is in the range 8272 to 8835, inclusive.
    shift_jis_index = shift_jis_index ||
      index('jis0208').map(function(code_point, pointer) {
        return inRange(pointer, 8272, 8835) ? null : code_point;
      });
    var index_ = shift_jis_index;

    // 2. Return the index pointer for code point in index.
    return index_.indexOf(code_point);
  }
  var shift_jis_index;

  /**
   * @param {number} code_point The |code_point| to search for in the big5
   *     index.
   * @return {?number} The code point corresponding to |pointer| in |index|,
   *     or null if |code point| is not in the big5 index.
   */
  function indexBig5PointerFor(code_point) {
    // 1. Let index be index Big5 excluding all entries whose pointer
    big5_index_no_hkscs = big5_index_no_hkscs ||
      index('big5').map(function(code_point, pointer) {
        return (pointer < (0xA1 - 0x81) * 157) ? null : code_point;
      });
    var index_ = big5_index_no_hkscs;

    // 2. If code point is U+2550, U+255E, U+2561, U+256A, U+5341, or
    // U+5345, return the last pointer corresponding to code point in
    // index.
    if (code_point === 0x2550 || code_point === 0x255E ||
        code_point === 0x2561 || code_point === 0x256A ||
        code_point === 0x5341 || code_point === 0x5345) {
      return index_.lastIndexOf(code_point);
    }

    // 3. Return the index pointer for code point in index.
    return indexPointerFor(code_point, index_);
  }
  var big5_index_no_hkscs;

  //
  // 8. API
  //

  /** @const */ var DEFAULT_ENCODING = 'utf-8';

  // 8.1 Interface TextDecoder

  /**
   * @constructor
   * @param {string=} label The label of the encoding;
   *     defaults to 'utf-8'.
   * @param {Object=} options
   */
  function TextDecoder(label, options) {
    // Web IDL conventions
    if (!(this instanceof TextDecoder))
      throw TypeError('Called as a function. Did you forget \'new\'?');
    label = label !== undefined ? String(label) : DEFAULT_ENCODING;
    options = ToDictionary(options);

    // A TextDecoder object has an associated encoding, decoder,
    // stream, ignore BOM flag (initially unset), BOM seen flag
    // (initially unset), error mode (initially replacement), and do
    // not flush flag (initially unset).

    /** @private */
    this._encoding = null;
    /** @private @type {?Decoder} */
    this._decoder = null;
    /** @private @type {boolean} */
    this._ignoreBOM = false;
    /** @private @type {boolean} */
    this._BOMseen = false;
    /** @private @type {string} */
    this._error_mode = 'replacement';
    /** @private @type {boolean} */
    this._do_not_flush = false;


    // 1. Let encoding be the result of getting an encoding from
    // label.
    var encoding = getEncoding(label);

    // 2. If encoding is failure or replacement, throw a RangeError.
    if (encoding === null || encoding.name === 'replacement')
      throw RangeError('Unknown encoding: ' + label);
    if (!decoders[encoding.name]) {
      throw Error('Decoder not present.' +
                  ' Did you forget to include encoding-indexes.js first?');
    }

    // 3. Let dec be a new TextDecoder object.
    var dec = this;

    // 4. Set dec's encoding to encoding.
    dec._encoding = encoding;

    // 5. If options's fatal member is true, set dec's error mode to
    // fatal.
    if (Boolean(options['fatal']))
      dec._error_mode = 'fatal';

    // 6. If options's ignoreBOM member is true, set dec's ignore BOM
    // flag.
    if (Boolean(options['ignoreBOM']))
      dec._ignoreBOM = true;

    // For pre-ES5 runtimes:
    if (!Object.defineProperty) {
      this.encoding = dec._encoding.name.toLowerCase();
      this.fatal = dec._error_mode === 'fatal';
      this.ignoreBOM = dec._ignoreBOM;
    }

    // 7. Return dec.
    return dec;
  }

  if (Object.defineProperty) {
    // The encoding attribute's getter must return encoding's name.
    Object.defineProperty(TextDecoder.prototype, 'encoding', {
      /** @this {TextDecoder} */
      get: function() { return this._encoding.name.toLowerCase(); }
    });

    // The fatal attribute's getter must return true if error mode
    // is fatal, and false otherwise.
    Object.defineProperty(TextDecoder.prototype, 'fatal', {
      /** @this {TextDecoder} */
      get: function() { return this._error_mode === 'fatal'; }
    });

    // The ignoreBOM attribute's getter must return true if ignore
    // BOM flag is set, and false otherwise.
    Object.defineProperty(TextDecoder.prototype, 'ignoreBOM', {
      /** @this {TextDecoder} */
      get: function() { return this._ignoreBOM; }
    });
  }

  /**
   * @param {BufferSource=} input The buffer of bytes to decode.
   * @param {Object=} options
   * @return {string} The decoded string.
   */
  TextDecoder.prototype.decode = function decode(input, options) {
    var bytes;
    if (typeof input === 'object' && input instanceof ArrayBuffer) {
      bytes = new Uint8Array(input);
    } else if (typeof input === 'object' && 'buffer' in input &&
               input.buffer instanceof ArrayBuffer) {
      bytes = new Uint8Array(input.buffer,
                             input.byteOffset,
                             input.byteLength);
    } else {
      bytes = new Uint8Array(0);
    }

    options = ToDictionary(options);

    // 1. If the do not flush flag is unset, set decoder to a new
    // encoding's decoder, set stream to a new stream, and unset the
    // BOM seen flag.
    if (!this._do_not_flush) {
      this._decoder = decoders[this._encoding.name]({
        fatal: this._error_mode === 'fatal'});
      this._BOMseen = false;
    }

    // 2. If options's stream is true, set the do not flush flag, and
    // unset the do not flush flag otherwise.
    this._do_not_flush = Boolean(options['stream']);

    // 3. If input is given, push a copy of input to stream.
    // TODO: Align with spec algorithm - maintain stream on instance.
    var input_stream = new Stream(bytes);

    // 4. Let output be a new stream.
    var output = [];

    /** @type {?(number|!Array.<number>)} */
    var result;

    // 5. While true:
    while (true) {
      // 1. Let token be the result of reading from stream.
      var token = input_stream.read();

      // 2. If token is end-of-stream and the do not flush flag is
      // set, return output, serialized.
      // TODO: Align with spec algorithm.
      if (token === end_of_stream)
        break;

      // 3. Otherwise, run these subsubsteps:

      // 1. Let result be the result of processing token for decoder,
      // stream, output, and error mode.
      result = this._decoder.handler(input_stream, token);

      // 2. If result is finished, return output, serialized.
      if (result === finished)
        break;

      if (result !== null) {
        if (Array.isArray(result))
          output.push.apply(output, /**@type {!Array.<number>}*/(result));
        else
          output.push(result);
      }

      // 3. Otherwise, if result is error, throw a TypeError.
      // (Thrown in handler)

      // 4. Otherwise, do nothing.
    }
    // TODO: Align with spec algorithm.
    if (!this._do_not_flush) {
      do {
        result = this._decoder.handler(input_stream, input_stream.read());
        if (result === finished)
          break;
        if (result === null)
          continue;
        if (Array.isArray(result))
          output.push.apply(output, /**@type {!Array.<number>}*/(result));
        else
          output.push(result);
      } while (!input_stream.endOfStream());
      this._decoder = null;
    }

    // A TextDecoder object also has an associated serialize stream
    // algorithm...
    /**
     * @param {!Array.<number>} stream
     * @return {string}
     * @this {TextDecoder}
     */
    function serializeStream(stream) {
      // 1. Let token be the result of reading from stream.
      // (Done in-place on array, rather than as a stream)

      // 2. If encoding is UTF-8, UTF-16BE, or UTF-16LE, and ignore
      // BOM flag and BOM seen flag are unset, run these subsubsteps:
      if (includes(['UTF-8', 'UTF-16LE', 'UTF-16BE'], this._encoding.name) &&
          !this._ignoreBOM && !this._BOMseen) {
        if (stream.length > 0 && stream[0] === 0xFEFF) {
          // 1. If token is U+FEFF, set BOM seen flag.
          this._BOMseen = true;
          stream.shift();
        } else if (stream.length > 0) {
          // 2. Otherwise, if token is not end-of-stream, set BOM seen
          // flag and append token to stream.
          this._BOMseen = true;
        } else {
          // 3. Otherwise, if token is not end-of-stream, append token
          // to output.
          // (no-op)
        }
      }
      // 4. Otherwise, return output.
      return codePointsToString(stream);
    }

    return serializeStream.call(this, output);
  };

  // 8.2 Interface TextEncoder

  /**
   * @constructor
   * @param {string=} label The label of the encoding. NONSTANDARD.
   * @param {Object=} options NONSTANDARD.
   */
  function TextEncoder(label, options) {
    // Web IDL conventions
    if (!(this instanceof TextEncoder))
      throw TypeError('Called as a function. Did you forget \'new\'?');
    options = ToDictionary(options);

    // A TextEncoder object has an associated encoding and encoder.

    /** @private */
    this._encoding = null;
    /** @private @type {?Encoder} */
    this._encoder = null;

    // Non-standard
    /** @private @type {boolean} */
    this._do_not_flush = false;
    /** @private @type {string} */
    this._fatal = Boolean(options['fatal']) ? 'fatal' : 'replacement';

    // 1. Let enc be a new TextEncoder object.
    var enc = this;

    // 2. Set enc's encoding to UTF-8's encoder.
    if (Boolean(options['NONSTANDARD_allowLegacyEncoding'])) {
      // NONSTANDARD behavior.
      label = label !== undefined ? String(label) : DEFAULT_ENCODING;
      var encoding = getEncoding(label);
      if (encoding === null || encoding.name === 'replacement')
        throw RangeError('Unknown encoding: ' + label);
      if (!encoders[encoding.name]) {
        throw Error('Encoder not present.' +
                    ' Did you forget to include encoding-indexes.js first?');
      }
      enc._encoding = encoding;
    } else {
      // Standard behavior.
      enc._encoding = getEncoding('utf-8');

      if (label !== undefined && 'console' in global) {
        console.warn('TextEncoder constructor called with encoding label, '
                     + 'which is ignored.');
      }
    }

    // For pre-ES5 runtimes:
    if (!Object.defineProperty)
      this.encoding = enc._encoding.name.toLowerCase();

    // 3. Return enc.
    return enc;
  }

  if (Object.defineProperty) {
    // The encoding attribute's getter must return encoding's name.
    Object.defineProperty(TextEncoder.prototype, 'encoding', {
      /** @this {TextEncoder} */
      get: function() { return this._encoding.name.toLowerCase(); }
    });
  }

  /**
   * @param {string=} opt_string The string to encode.
   * @param {Object=} options
   * @return {!Uint8Array} Encoded bytes, as a Uint8Array.
   */
  TextEncoder.prototype.encode = function encode(opt_string, options) {
    opt_string = opt_string === undefined ? '' : String(opt_string);
    options = ToDictionary(options);

    // NOTE: This option is nonstandard. None of the encodings
    // permitted for encoding (i.e. UTF-8, UTF-16) are stateful when
    // the input is a USVString so streaming is not necessary.
    if (!this._do_not_flush)
      this._encoder = encoders[this._encoding.name]({
        fatal: this._fatal === 'fatal'});
    this._do_not_flush = Boolean(options['stream']);

    // 1. Convert input to a stream.
    var input = new Stream(stringToCodePoints(opt_string));

    // 2. Let output be a new stream
    var output = [];

    /** @type {?(number|!Array.<number>)} */
    var result;
    // 3. While true, run these substeps:
    while (true) {
      // 1. Let token be the result of reading from input.
      var token = input.read();
      if (token === end_of_stream)
        break;
      // 2. Let result be the result of processing token for encoder,
      // input, output.
      result = this._encoder.handler(input, token);
      if (result === finished)
        break;
      if (Array.isArray(result))
        output.push.apply(output, /**@type {!Array.<number>}*/(result));
      else
        output.push(result);
    }
    // TODO: Align with spec algorithm.
    if (!this._do_not_flush) {
      while (true) {
        result = this._encoder.handler(input, input.read());
        if (result === finished)
          break;
        if (Array.isArray(result))
          output.push.apply(output, /**@type {!Array.<number>}*/(result));
        else
          output.push(result);
      }
      this._encoder = null;
    }
    // 3. If result is finished, convert output into a byte sequence,
    // and then return a Uint8Array object wrapping an ArrayBuffer
    // containing output.
    return new Uint8Array(output);
  };


  //
  // 9. The encoding
  //

  // 9.1 utf-8

  // 9.1.1 utf-8 decoder
  /**
   * @constructor
   * @implements {Decoder}
   * @param {{fatal: boolean}} options
   */
  function UTF8Decoder(options) {
    var fatal = options.fatal;

    // utf-8's decoder's has an associated utf-8 code point, utf-8
    // bytes seen, and utf-8 bytes needed (all initially 0), a utf-8
    // lower boundary (initially 0x80), and a utf-8 upper boundary
    // (initially 0xBF).
    var /** @type {number} */ utf8_code_point = 0,
        /** @type {number} */ utf8_bytes_seen = 0,
        /** @type {number} */ utf8_bytes_needed = 0,
        /** @type {number} */ utf8_lower_boundary = 0x80,
        /** @type {number} */ utf8_upper_boundary = 0xBF;

    /**
     * @param {Stream} stream The stream of bytes being decoded.
     * @param {number} bite The next byte read from the stream.
     * @return {?(number|!Array.<number>)} The next code point(s)
     *     decoded, or null if not enough data exists in the input
     *     stream to decode a complete code point.
     */
    this.handler = function(stream, bite) {
      // 1. If byte is end-of-stream and utf-8 bytes needed is not 0,
      // set utf-8 bytes needed to 0 and return error.
      if (bite === end_of_stream && utf8_bytes_needed !== 0) {
        utf8_bytes_needed = 0;
        return decoderError(fatal);
      }

      // 2. If byte is end-of-stream, return finished.
      if (bite === end_of_stream)
        return finished;

      // 3. If utf-8 bytes needed is 0, based on byte:
      if (utf8_bytes_needed === 0) {

        // 0x00 to 0x7F
        if (inRange(bite, 0x00, 0x7F)) {
          // Return a code point whose value is byte.
          return bite;
        }

        // 0xC2 to 0xDF
        else if (inRange(bite, 0xC2, 0xDF)) {
          // 1. Set utf-8 bytes needed to 1.
          utf8_bytes_needed = 1;

          // 2. Set UTF-8 code point to byte & 0x1F.
          utf8_code_point = bite & 0x1F;
        }

        // 0xE0 to 0xEF
        else if (inRange(bite, 0xE0, 0xEF)) {
          // 1. If byte is 0xE0, set utf-8 lower boundary to 0xA0.
          if (bite === 0xE0)
            utf8_lower_boundary = 0xA0;
          // 2. If byte is 0xED, set utf-8 upper boundary to 0x9F.
          if (bite === 0xED)
            utf8_upper_boundary = 0x9F;
          // 3. Set utf-8 bytes needed to 2.
          utf8_bytes_needed = 2;
          // 4. Set UTF-8 code point to byte & 0xF.
          utf8_code_point = bite & 0xF;
        }

        // 0xF0 to 0xF4
        else if (inRange(bite, 0xF0, 0xF4)) {
          // 1. If byte is 0xF0, set utf-8 lower boundary to 0x90.
          if (bite === 0xF0)
            utf8_lower_boundary = 0x90;
          // 2. If byte is 0xF4, set utf-8 upper boundary to 0x8F.
          if (bite === 0xF4)
            utf8_upper_boundary = 0x8F;
          // 3. Set utf-8 bytes needed to 3.
          utf8_bytes_needed = 3;
          // 4. Set UTF-8 code point to byte & 0x7.
          utf8_code_point = bite & 0x7;
        }

        // Otherwise
        else {
          // Return error.
          return decoderError(fatal);
        }

        // Return continue.
        return null;
      }

      // 4. If byte is not in the range utf-8 lower boundary to utf-8
      // upper boundary, inclusive, run these substeps:
      if (!inRange(bite, utf8_lower_boundary, utf8_upper_boundary)) {

        // 1. Set utf-8 code point, utf-8 bytes needed, and utf-8
        // bytes seen to 0, set utf-8 lower boundary to 0x80, and set
        // utf-8 upper boundary to 0xBF.
        utf8_code_point = utf8_bytes_needed = utf8_bytes_seen = 0;
        utf8_lower_boundary = 0x80;
        utf8_upper_boundary = 0xBF;

        // 2. Prepend byte to stream.
        stream.prepend(bite);

        // 3. Return error.
        return decoderError(fatal);
      }

      // 5. Set utf-8 lower boundary to 0x80 and utf-8 upper boundary
      // to 0xBF.
      utf8_lower_boundary = 0x80;
      utf8_upper_boundary = 0xBF;

      // 6. Set UTF-8 code point to (UTF-8 code point << 6) | (byte &
      // 0x3F)
      utf8_code_point = (utf8_code_point << 6) | (bite & 0x3F);

      // 7. Increase utf-8 bytes seen by one.
      utf8_bytes_seen += 1;

      // 8. If utf-8 bytes seen is not equal to utf-8 bytes needed,
      // continue.
      if (utf8_bytes_seen !== utf8_bytes_needed)
        return null;

      // 9. Let code point be utf-8 code point.
      var code_point = utf8_code_point;

      // 10. Set utf-8 code point, utf-8 bytes needed, and utf-8 bytes
      // seen to 0.
      utf8_code_point = utf8_bytes_needed = utf8_bytes_seen = 0;

      // 11. Return a code point whose value is code point.
      return code_point;
    };
  }

  // 9.1.2 utf-8 encoder
  /**
   * @constructor
   * @implements {Encoder}
   * @param {{fatal: boolean}} options
   */
  function UTF8Encoder(options) {
    var fatal = options.fatal;
    /**
     * @param {Stream} stream Input stream.
     * @param {number} code_point Next code point read from the stream.
     * @return {(number|!Array.<number>)} Byte(s) to emit.
     */
    this.handler = function(stream, code_point) {
      // 1. If code point is end-of-stream, return finished.
      if (code_point === end_of_stream)
        return finished;

      // 2. If code point is an ASCII code point, return a byte whose
      // value is code point.
      if (isASCIICodePoint(code_point))
        return code_point;

      // 3. Set count and offset based on the range code point is in:
      var count, offset;
      // U+0080 to U+07FF, inclusive:
      if (inRange(code_point, 0x0080, 0x07FF)) {
        // 1 and 0xC0
        count = 1;
        offset = 0xC0;
      }
      // U+0800 to U+FFFF, inclusive:
      else if (inRange(code_point, 0x0800, 0xFFFF)) {
        // 2 and 0xE0
        count = 2;
        offset = 0xE0;
      }
      // U+10000 to U+10FFFF, inclusive:
      else if (inRange(code_point, 0x10000, 0x10FFFF)) {
        // 3 and 0xF0
        count = 3;
        offset = 0xF0;
      }

      // 4. Let bytes be a byte sequence whose first byte is (code
      // point >> (6 × count)) + offset.
      var bytes = [(code_point >> (6 * count)) + offset];

      // 5. Run these substeps while count is greater than 0:
      while (count > 0) {

        // 1. Set temp to code point >> (6 × (count − 1)).
        var temp = code_point >> (6 * (count - 1));

        // 2. Append to bytes 0x80 | (temp & 0x3F).
        bytes.push(0x80 | (temp & 0x3F));

        // 3. Decrease count by one.
        count -= 1;
      }

      // 6. Return bytes bytes, in order.
      return bytes;
    };
  }

  /** @param {{fatal: boolean}} options */
  encoders['UTF-8'] = function(options) {
    return new UTF8Encoder(options);
  };
  /** @param {{fatal: boolean}} options */
  decoders['UTF-8'] = function(options) {
    return new UTF8Decoder(options);
  };

  //
  // 10. Legacy single-byte encodings
  //

  // 10.1 single-byte decoder
  /**
   * @constructor
   * @implements {Decoder}
   * @param {!Array.<number>} index The encoding index.
   * @param {{fatal: boolean}} options
   */
  function SingleByteDecoder(index, options) {
    var fatal = options.fatal;
    /**
     * @param {Stream} stream The stream of bytes being decoded.
     * @param {number} bite The next byte read from the stream.
     * @return {?(number|!Array.<number>)} The next code point(s)
     *     decoded, or null if not enough data exists in the input
     *     stream to decode a complete code point.
     */
    this.handler = function(stream, bite) {
      // 1. If byte is end-of-stream, return finished.
      if (bite === end_of_stream)
        return finished;

      // 2. If byte is an ASCII byte, return a code point whose value
      // is byte.
      if (isASCIIByte(bite))
        return bite;

      // 3. Let code point be the index code point for byte − 0x80 in
      // index single-byte.
      var code_point = index[bite - 0x80];

      // 4. If code point is null, return error.
      if (code_point === null)
        return decoderError(fatal);

      // 5. Return a code point whose value is code point.
      return code_point;
    };
  }

  // 10.2 single-byte encoder
  /**
   * @constructor
   * @implements {Encoder}
   * @param {!Array.<?number>} index The encoding index.
   * @param {{fatal: boolean}} options
   */
  function SingleByteEncoder(index, options) {
    var fatal = options.fatal;
    /**
     * @param {Stream} stream Input stream.
     * @param {number} code_point Next code point read from the stream.
     * @return {(number|!Array.<number>)} Byte(s) to emit.
     */
    this.handler = function(stream, code_point) {
      // 1. If code point is end-of-stream, return finished.
      if (code_point === end_of_stream)
        return finished;

      // 2. If code point is an ASCII code point, return a byte whose
      // value is code point.
      if (isASCIICodePoint(code_point))
        return code_point;

      // 3. Let pointer be the index pointer for code point in index
      // single-byte.
      var pointer = indexPointerFor(code_point, index);

      // 4. If pointer is null, return error with code point.
      if (pointer === null)
        encoderError(code_point);

      // 5. Return a byte whose value is pointer + 0x80.
      return pointer + 0x80;
    };
  }

  (function() {
    if (!('encoding-indexes' in global))
      return;
    encodings.forEach(function(category) {
      if (category.heading !== 'Legacy single-byte encodings')
        return;
      category.encodings.forEach(function(encoding) {
        var name = encoding.name;
        var idx = index(name.toLowerCase());
        /** @param {{fatal: boolean}} options */
        decoders[name] = function(options) {
          return new SingleByteDecoder(idx, options);
        };
        /** @param {{fatal: boolean}} options */
        encoders[name] = function(options) {
          return new SingleByteEncoder(idx, options);
        };
      });
    });
  }());

  //
  // 11. Legacy multi-byte Chinese (simplified) encodings
  //

  // 11.1 gbk

  // 11.1.1 gbk decoder
  // gbk's decoder is gb18030's decoder.
  /** @param {{fatal: boolean}} options */
  decoders['GBK'] = function(options) {
    return new GB18030Decoder(options);
  };

  // 11.1.2 gbk encoder
  // gbk's encoder is gb18030's encoder with its gbk flag set.
  /** @param {{fatal: boolean}} options */
  encoders['GBK'] = function(options) {
    return new GB18030Encoder(options, true);
  };

  // 11.2 gb18030

  // 11.2.1 gb18030 decoder
  /**
   * @constructor
   * @implements {Decoder}
   * @param {{fatal: boolean}} options
   */
  function GB18030Decoder(options) {
    var fatal = options.fatal;
    // gb18030's decoder has an associated gb18030 first, gb18030
    // second, and gb18030 third (all initially 0x00).
    var /** @type {number} */ gb18030_first = 0x00,
        /** @type {number} */ gb18030_second = 0x00,
        /** @type {number} */ gb18030_third = 0x00;
    /**
     * @param {Stream} stream The stream of bytes being decoded.
     * @param {number} bite The next byte read from the stream.
     * @return {?(number|!Array.<number>)} The next code point(s)
     *     decoded, or null if not enough data exists in the input
     *     stream to decode a complete code point.
     */
    this.handler = function(stream, bite) {
      // 1. If byte is end-of-stream and gb18030 first, gb18030
      // second, and gb18030 third are 0x00, return finished.
      if (bite === end_of_stream && gb18030_first === 0x00 &&
          gb18030_second === 0x00 && gb18030_third === 0x00) {
        return finished;
      }
      // 2. If byte is end-of-stream, and gb18030 first, gb18030
      // second, or gb18030 third is not 0x00, set gb18030 first,
      // gb18030 second, and gb18030 third to 0x00, and return error.
      if (bite === end_of_stream &&
          (gb18030_first !== 0x00 || gb18030_second !== 0x00 ||
           gb18030_third !== 0x00)) {
        gb18030_first = 0x00;
        gb18030_second = 0x00;
        gb18030_third = 0x00;
        decoderError(fatal);
      }
      var code_point;
      // 3. If gb18030 third is not 0x00, run these substeps:
      if (gb18030_third !== 0x00) {
        // 1. Let code point be null.
        code_point = null;
        // 2. If byte is in the range 0x30 to 0x39, inclusive, set
        // code point to the index gb18030 ranges code point for
        // (((gb18030 first − 0x81) × 10 + gb18030 second − 0x30) ×
        // 126 + gb18030 third − 0x81) × 10 + byte − 0x30.
        if (inRange(bite, 0x30, 0x39)) {
          code_point = indexGB18030RangesCodePointFor(
              (((gb18030_first - 0x81) * 10 + gb18030_second - 0x30) * 126 +
               gb18030_third - 0x81) * 10 + bite - 0x30);
        }

        // 3. Let buffer be a byte sequence consisting of gb18030
        // second, gb18030 third, and byte, in order.
        var buffer = [gb18030_second, gb18030_third, bite];

        // 4. Set gb18030 first, gb18030 second, and gb18030 third to
        // 0x00.
        gb18030_first = 0x00;
        gb18030_second = 0x00;
        gb18030_third = 0x00;

        // 5. If code point is null, prepend buffer to stream and
        // return error.
        if (code_point === null) {
          stream.prepend(buffer);
          return decoderError(fatal);
        }

        // 6. Return a code point whose value is code point.
        return code_point;
      }

      // 4. If gb18030 second is not 0x00, run these substeps:
      if (gb18030_second !== 0x00) {

        // 1. If byte is in the range 0x81 to 0xFE, inclusive, set
        // gb18030 third to byte and return continue.
        if (inRange(bite, 0x81, 0xFE)) {
          gb18030_third = bite;
          return null;
        }

        // 2. Prepend gb18030 second followed by byte to stream, set
        // gb18030 first and gb18030 second to 0x00, and return error.
        stream.prepend([gb18030_second, bite]);
        gb18030_first = 0x00;
        gb18030_second = 0x00;
        return decoderError(fatal);
      }

      // 5. If gb18030 first is not 0x00, run these substeps:
      if (gb18030_first !== 0x00) {

        // 1. If byte is in the range 0x30 to 0x39, inclusive, set
        // gb18030 second to byte and return continue.
        if (inRange(bite, 0x30, 0x39)) {
          gb18030_second = bite;
          return null;
        }

        // 2. Let lead be gb18030 first, let pointer be null, and set
        // gb18030 first to 0x00.
        var lead = gb18030_first;
        var pointer = null;
        gb18030_first = 0x00;

        // 3. Let offset be 0x40 if byte is less than 0x7F and 0x41
        // otherwise.
        var offset = bite < 0x7F ? 0x40 : 0x41;

        // 4. If byte is in the range 0x40 to 0x7E, inclusive, or 0x80
        // to 0xFE, inclusive, set pointer to (lead − 0x81) × 190 +
        // (byte − offset).
        if (inRange(bite, 0x40, 0x7E) || inRange(bite, 0x80, 0xFE))
          pointer = (lead - 0x81) * 190 + (bite - offset);

        // 5. Let code point be null if pointer is null and the index
        // code point for pointer in index gb18030 otherwise.
        code_point = pointer === null ? null :
            indexCodePointFor(pointer, index('gb18030'));

        // 6. If code point is null and byte is an ASCII byte, prepend
        // byte to stream.
        if (code_point === null && isASCIIByte(bite))
          stream.prepend(bite);

        // 7. If code point is null, return error.
        if (code_point === null)
          return decoderError(fatal);

        // 8. Return a code point whose value is code point.
        return code_point;
      }

      // 6. If byte is an ASCII byte, return a code point whose value
      // is byte.
      if (isASCIIByte(bite))
        return bite;

      // 7. If byte is 0x80, return code point U+20AC.
      if (bite === 0x80)
        return 0x20AC;

      // 8. If byte is in the range 0x81 to 0xFE, inclusive, set
      // gb18030 first to byte and return continue.
      if (inRange(bite, 0x81, 0xFE)) {
        gb18030_first = bite;
        return null;
      }

      // 9. Return error.
      return decoderError(fatal);
    };
  }

  // 11.2.2 gb18030 encoder
  /**
   * @constructor
   * @implements {Encoder}
   * @param {{fatal: boolean}} options
   * @param {boolean=} gbk_flag
   */
  function GB18030Encoder(options, gbk_flag) {
    var fatal = options.fatal;
    // gb18030's decoder has an associated gbk flag (initially unset).
    /**
     * @param {Stream} stream Input stream.
     * @param {number} code_point Next code point read from the stream.
     * @return {(number|!Array.<number>)} Byte(s) to emit.
     */
    this.handler = function(stream, code_point) {
      // 1. If code point is end-of-stream, return finished.
      if (code_point === end_of_stream)
        return finished;

      // 2. If code point is an ASCII code point, return a byte whose
      // value is code point.
      if (isASCIICodePoint(code_point))
        return code_point;

      // 3. If code point is U+E5E5, return error with code point.
      if (code_point === 0xE5E5)
        return encoderError(code_point);

      // 4. If the gbk flag is set and code point is U+20AC, return
      // byte 0x80.
      if (gbk_flag && code_point === 0x20AC)
        return 0x80;

      // 5. Let pointer be the index pointer for code point in index
      // gb18030.
      var pointer = indexPointerFor(code_point, index('gb18030'));

      // 6. If pointer is not null, run these substeps:
      if (pointer !== null) {

        // 1. Let lead be floor(pointer / 190) + 0x81.
        var lead = floor(pointer / 190) + 0x81;

        // 2. Let trail be pointer % 190.
        var trail = pointer % 190;

        // 3. Let offset be 0x40 if trail is less than 0x3F and 0x41 otherwise.
        var offset = trail < 0x3F ? 0x40 : 0x41;

        // 4. Return two bytes whose values are lead and trail + offset.
        return [lead, trail + offset];
      }

      // 7. If gbk flag is set, return error with code point.
      if (gbk_flag)
        return encoderError(code_point);

      // 8. Set pointer to the index gb18030 ranges pointer for code
      // point.
      pointer = indexGB18030RangesPointerFor(code_point);

      // 9. Let byte1 be floor(pointer / 10 / 126 / 10).
      var byte1 = floor(pointer / 10 / 126 / 10);

      // 10. Set pointer to pointer − byte1 × 10 × 126 × 10.
      pointer = pointer - byte1 * 10 * 126 * 10;

      // 11. Let byte2 be floor(pointer / 10 / 126).
      var byte2 = floor(pointer / 10 / 126);

      // 12. Set pointer to pointer − byte2 × 10 × 126.
      pointer = pointer - byte2 * 10 * 126;

      // 13. Let byte3 be floor(pointer / 10).
      var byte3 = floor(pointer / 10);

      // 14. Let byte4 be pointer − byte3 × 10.
      var byte4 = pointer - byte3 * 10;

      // 15. Return four bytes whose values are byte1 + 0x81, byte2 +
      // 0x30, byte3 + 0x81, byte4 + 0x30.
      return [byte1 + 0x81,
              byte2 + 0x30,
              byte3 + 0x81,
              byte4 + 0x30];
    };
  }

  /** @param {{fatal: boolean}} options */
  encoders['gb18030'] = function(options) {
    return new GB18030Encoder(options);
  };
  /** @param {{fatal: boolean}} options */
  decoders['gb18030'] = function(options) {
    return new GB18030Decoder(options);
  };


  //
  // 12. Legacy multi-byte Chinese (traditional) encodings
  //

  // 12.1 Big5

  // 12.1.1 Big5 decoder
  /**
   * @constructor
   * @implements {Decoder}
   * @param {{fatal: boolean}} options
   */
  function Big5Decoder(options) {
    var fatal = options.fatal;
    // Big5's decoder has an associated Big5 lead (initially 0x00).
    var /** @type {number} */ Big5_lead = 0x00;

    /**
     * @param {Stream} stream The stream of bytes being decoded.
     * @param {number} bite The next byte read from the stream.
     * @return {?(number|!Array.<number>)} The next code point(s)
     *     decoded, or null if not enough data exists in the input
     *     stream to decode a complete code point.
     */
    this.handler = function(stream, bite) {
      // 1. If byte is end-of-stream and Big5 lead is not 0x00, set
      // Big5 lead to 0x00 and return error.
      if (bite === end_of_stream && Big5_lead !== 0x00) {
        Big5_lead = 0x00;
        return decoderError(fatal);
      }

      // 2. If byte is end-of-stream and Big5 lead is 0x00, return
      // finished.
      if (bite === end_of_stream && Big5_lead === 0x00)
        return finished;

      // 3. If Big5 lead is not 0x00, let lead be Big5 lead, let
      // pointer be null, set Big5 lead to 0x00, and then run these
      // substeps:
      if (Big5_lead !== 0x00) {
        var lead = Big5_lead;
        var pointer = null;
        Big5_lead = 0x00;

        // 1. Let offset be 0x40 if byte is less than 0x7F and 0x62
        // otherwise.
        var offset = bite < 0x7F ? 0x40 : 0x62;

        // 2. If byte is in the range 0x40 to 0x7E, inclusive, or 0xA1
        // to 0xFE, inclusive, set pointer to (lead − 0x81) × 157 +
        // (byte − offset).
        if (inRange(bite, 0x40, 0x7E) || inRange(bite, 0xA1, 0xFE))
          pointer = (lead - 0x81) * 157 + (bite - offset);

        // 3. If there is a row in the table below whose first column
        // is pointer, return the two code points listed in its second
        // column
        // Pointer | Code points
        // --------+--------------
        // 1133    | U+00CA U+0304
        // 1135    | U+00CA U+030C
        // 1164    | U+00EA U+0304
        // 1166    | U+00EA U+030C
        switch (pointer) {
          case 1133: return [0x00CA, 0x0304];
          case 1135: return [0x00CA, 0x030C];
          case 1164: return [0x00EA, 0x0304];
          case 1166: return [0x00EA, 0x030C];
        }

        // 4. Let code point be null if pointer is null and the index
        // code point for pointer in index Big5 otherwise.
        var code_point = (pointer === null) ? null :
            indexCodePointFor(pointer, index('big5'));

        // 5. If code point is null and byte is an ASCII byte, prepend
        // byte to stream.
        if (code_point === null && isASCIIByte(bite))
          stream.prepend(bite);

        // 6. If code point is null, return error.
        if (code_point === null)
          return decoderError(fatal);

        // 7. Return a code point whose value is code point.
        return code_point;
      }

      // 4. If byte is an ASCII byte, return a code point whose value
      // is byte.
      if (isASCIIByte(bite))
        return bite;

      // 5. If byte is in the range 0x81 to 0xFE, inclusive, set Big5
      // lead to byte and return continue.
      if (inRange(bite, 0x81, 0xFE)) {
        Big5_lead = bite;
        return null;
      }

      // 6. Return error.
      return decoderError(fatal);
    };
  }

  // 12.1.2 Big5 encoder
  /**
   * @constructor
   * @implements {Encoder}
   * @param {{fatal: boolean}} options
   */
  function Big5Encoder(options) {
    var fatal = options.fatal;
    /**
     * @param {Stream} stream Input stream.
     * @param {number} code_point Next code point read from the stream.
     * @return {(number|!Array.<number>)} Byte(s) to emit.
     */
    this.handler = function(stream, code_point) {
      // 1. If code point is end-of-stream, return finished.
      if (code_point === end_of_stream)
        return finished;

      // 2. If code point is an ASCII code point, return a byte whose
      // value is code point.
      if (isASCIICodePoint(code_point))
        return code_point;

      // 3. Let pointer be the index Big5 pointer for code point.
      var pointer = indexBig5PointerFor(code_point);

      // 4. If pointer is null, return error with code point.
      if (pointer === null)
        return encoderError(code_point);

      // 5. Let lead be floor(pointer / 157) + 0x81.
      var lead = floor(pointer / 157) + 0x81;

      // 6. If lead is less than 0xA1, return error with code point.
      if (lead < 0xA1)
        return encoderError(code_point);

      // 7. Let trail be pointer % 157.
      var trail = pointer % 157;

      // 8. Let offset be 0x40 if trail is less than 0x3F and 0x62
      // otherwise.
      var offset = trail < 0x3F ? 0x40 : 0x62;

      // Return two bytes whose values are lead and trail + offset.
      return [lead, trail + offset];
    };
  }

  /** @param {{fatal: boolean}} options */
  encoders['Big5'] = function(options) {
    return new Big5Encoder(options);
  };
  /** @param {{fatal: boolean}} options */
  decoders['Big5'] = function(options) {
    return new Big5Decoder(options);
  };


  //
  // 13. Legacy multi-byte Japanese encodings
  //

  // 13.1 euc-jp

  // 13.1.1 euc-jp decoder
  /**
   * @constructor
   * @implements {Decoder}
   * @param {{fatal: boolean}} options
   */
  function EUCJPDecoder(options) {
    var fatal = options.fatal;

    // euc-jp's decoder has an associated euc-jp jis0212 flag
    // (initially unset) and euc-jp lead (initially 0x00).
    var /** @type {boolean} */ eucjp_jis0212_flag = false,
        /** @type {number} */ eucjp_lead = 0x00;

    /**
     * @param {Stream} stream The stream of bytes being decoded.
     * @param {number} bite The next byte read from the stream.
     * @return {?(number|!Array.<number>)} The next code point(s)
     *     decoded, or null if not enough data exists in the input
     *     stream to decode a complete code point.
     */
    this.handler = function(stream, bite) {
      // 1. If byte is end-of-stream and euc-jp lead is not 0x00, set
      // euc-jp lead to 0x00, and return error.
      if (bite === end_of_stream && eucjp_lead !== 0x00) {
        eucjp_lead = 0x00;
        return decoderError(fatal);
      }

      // 2. If byte is end-of-stream and euc-jp lead is 0x00, return
      // finished.
      if (bite === end_of_stream && eucjp_lead === 0x00)
        return finished;

      // 3. If euc-jp lead is 0x8E and byte is in the range 0xA1 to
      // 0xDF, inclusive, set euc-jp lead to 0x00 and return a code
      // point whose value is 0xFF61 − 0xA1 + byte.
      if (eucjp_lead === 0x8E && inRange(bite, 0xA1, 0xDF)) {
        eucjp_lead = 0x00;
        return 0xFF61 - 0xA1 + bite;
      }

      // 4. If euc-jp lead is 0x8F and byte is in the range 0xA1 to
      // 0xFE, inclusive, set the euc-jp jis0212 flag, set euc-jp lead
      // to byte, and return continue.
      if (eucjp_lead === 0x8F && inRange(bite, 0xA1, 0xFE)) {
        eucjp_jis0212_flag = true;
        eucjp_lead = bite;
        return null;
      }

      // 5. If euc-jp lead is not 0x00, let lead be euc-jp lead, set
      // euc-jp lead to 0x00, and run these substeps:
      if (eucjp_lead !== 0x00) {
        var lead = eucjp_lead;
        eucjp_lead = 0x00;

        // 1. Let code point be null.
        var code_point = null;

        // 2. If lead and byte are both in the range 0xA1 to 0xFE,
        // inclusive, set code point to the index code point for (lead
        // − 0xA1) × 94 + byte − 0xA1 in index jis0208 if the euc-jp
        // jis0212 flag is unset and in index jis0212 otherwise.
        if (inRange(lead, 0xA1, 0xFE) && inRange(bite, 0xA1, 0xFE)) {
          code_point = indexCodePointFor(
            (lead - 0xA1) * 94 + (bite - 0xA1),
            index(!eucjp_jis0212_flag ? 'jis0208' : 'jis0212'));
        }

        // 3. Unset the euc-jp jis0212 flag.
        eucjp_jis0212_flag = false;

        // 4. If byte is not in the range 0xA1 to 0xFE, inclusive,
        // prepend byte to stream.
        if (!inRange(bite, 0xA1, 0xFE))
          stream.prepend(bite);

        // 5. If code point is null, return error.
        if (code_point === null)
          return decoderError(fatal);

        // 6. Return a code point whose value is code point.
        return code_point;
      }

      // 6. If byte is an ASCII byte, return a code point whose value
      // is byte.
      if (isASCIIByte(bite))
        return bite;

      // 7. If byte is 0x8E, 0x8F, or in the range 0xA1 to 0xFE,
      // inclusive, set euc-jp lead to byte and return continue.
      if (bite === 0x8E || bite === 0x8F || inRange(bite, 0xA1, 0xFE)) {
        eucjp_lead = bite;
        return null;
      }

      // 8. Return error.
      return decoderError(fatal);
    };
  }

  // 13.1.2 euc-jp encoder
  /**
   * @constructor
   * @implements {Encoder}
   * @param {{fatal: boolean}} options
   */
  function EUCJPEncoder(options) {
    var fatal = options.fatal;
    /**
     * @param {Stream} stream Input stream.
     * @param {number} code_point Next code point read from the stream.
     * @return {(number|!Array.<number>)} Byte(s) to emit.
     */
    this.handler = function(stream, code_point) {
      // 1. If code point is end-of-stream, return finished.
      if (code_point === end_of_stream)
        return finished;

      // 2. If code point is an ASCII code point, return a byte whose
      // value is code point.
      if (isASCIICodePoint(code_point))
        return code_point;

      // 3. If code point is U+00A5, return byte 0x5C.
      if (code_point === 0x00A5)
        return 0x5C;

      // 4. If code point is U+203E, return byte 0x7E.
      if (code_point === 0x203E)
        return 0x7E;

      // 5. If code point is in the range U+FF61 to U+FF9F, inclusive,
      // return two bytes whose values are 0x8E and code point −
      // 0xFF61 + 0xA1.
      if (inRange(code_point, 0xFF61, 0xFF9F))
        return [0x8E, code_point - 0xFF61 + 0xA1];

      // 6. If code point is U+2212, set it to U+FF0D.
      if (code_point === 0x2212)
        code_point = 0xFF0D;

      // 7. Let pointer be the index pointer for code point in index
      // jis0208.
      var pointer = indexPointerFor(code_point, index('jis0208'));

      // 8. If pointer is null, return error with code point.
      if (pointer === null)
        return encoderError(code_point);

      // 9. Let lead be floor(pointer / 94) + 0xA1.
      var lead = floor(pointer / 94) + 0xA1;

      // 10. Let trail be pointer % 94 + 0xA1.
      var trail = pointer % 94 + 0xA1;

      // 11. Return two bytes whose values are lead and trail.
      return [lead, trail];
    };
  }

  /** @param {{fatal: boolean}} options */
  encoders['EUC-JP'] = function(options) {
    return new EUCJPEncoder(options);
  };
  /** @param {{fatal: boolean}} options */
  decoders['EUC-JP'] = function(options) {
    return new EUCJPDecoder(options);
  };

  // 13.2 iso-2022-jp

  // 13.2.1 iso-2022-jp decoder
  /**
   * @constructor
   * @implements {Decoder}
   * @param {{fatal: boolean}} options
   */
  function ISO2022JPDecoder(options) {
    var fatal = options.fatal;
    /** @enum */
    var states = {
      ASCII: 0,
      Roman: 1,
      Katakana: 2,
      LeadByte: 3,
      TrailByte: 4,
      EscapeStart: 5,
      Escape: 6
    };
    // iso-2022-jp's decoder has an associated iso-2022-jp decoder
    // state (initially ASCII), iso-2022-jp decoder output state
    // (initially ASCII), iso-2022-jp lead (initially 0x00), and
    // iso-2022-jp output flag (initially unset).
    var /** @type {number} */ iso2022jp_decoder_state = states.ASCII,
        /** @type {number} */ iso2022jp_decoder_output_state = states.ASCII,
        /** @type {number} */ iso2022jp_lead = 0x00,
        /** @type {boolean} */ iso2022jp_output_flag = false;
    /**
     * @param {Stream} stream The stream of bytes being decoded.
     * @param {number} bite The next byte read from the stream.
     * @return {?(number|!Array.<number>)} The next code point(s)
     *     decoded, or null if not enough data exists in the input
     *     stream to decode a complete code point.
     */
    this.handler = function(stream, bite) {
      // switching on iso-2022-jp decoder state:
      switch (iso2022jp_decoder_state) {
      default:
      case states.ASCII:
        // ASCII
        // Based on byte:

        // 0x1B
        if (bite === 0x1B) {
          // Set iso-2022-jp decoder state to escape start and return
          // continue.
          iso2022jp_decoder_state = states.EscapeStart;
          return null;
        }

        // 0x00 to 0x7F, excluding 0x0E, 0x0F, and 0x1B
        if (inRange(bite, 0x00, 0x7F) && bite !== 0x0E
            && bite !== 0x0F && bite !== 0x1B) {
          // Unset the iso-2022-jp output flag and return a code point
          // whose value is byte.
          iso2022jp_output_flag = false;
          return bite;
        }

        // end-of-stream
        if (bite === end_of_stream) {
          // Return finished.
          return finished;
        }

        // Otherwise
        // Unset the iso-2022-jp output flag and return error.
        iso2022jp_output_flag = false;
        return decoderError(fatal);

      case states.Roman:
        // Roman
        // Based on byte:

        // 0x1B
        if (bite === 0x1B) {
          // Set iso-2022-jp decoder state to escape start and return
          // continue.
          iso2022jp_decoder_state = states.EscapeStart;
          return null;
        }

        // 0x5C
        if (bite === 0x5C) {
          // Unset the iso-2022-jp output flag and return code point
          // U+00A5.
          iso2022jp_output_flag = false;
          return 0x00A5;
        }

        // 0x7E
        if (bite === 0x7E) {
          // Unset the iso-2022-jp output flag and return code point
          // U+203E.
          iso2022jp_output_flag = false;
          return 0x203E;
        }

        // 0x00 to 0x7F, excluding 0x0E, 0x0F, 0x1B, 0x5C, and 0x7E
        if (inRange(bite, 0x00, 0x7F) && bite !== 0x0E && bite !== 0x0F
            && bite !== 0x1B && bite !== 0x5C && bite !== 0x7E) {
          // Unset the iso-2022-jp output flag and return a code point
          // whose value is byte.
          iso2022jp_output_flag = false;
          return bite;
        }

        // end-of-stream
        if (bite === end_of_stream) {
          // Return finished.
          return finished;
        }

        // Otherwise
        // Unset the iso-2022-jp output flag and return error.
        iso2022jp_output_flag = false;
        return decoderError(fatal);

      case states.Katakana:
        // Katakana
        // Based on byte:

        // 0x1B
        if (bite === 0x1B) {
          // Set iso-2022-jp decoder state to escape start and return
          // continue.
          iso2022jp_decoder_state = states.EscapeStart;
          return null;
        }

        // 0x21 to 0x5F
        if (inRange(bite, 0x21, 0x5F)) {
          // Unset the iso-2022-jp output flag and return a code point
          // whose value is 0xFF61 − 0x21 + byte.
          iso2022jp_output_flag = false;
          return 0xFF61 - 0x21 + bite;
        }

        // end-of-stream
        if (bite === end_of_stream) {
          // Return finished.
          return finished;
        }

        // Otherwise
        // Unset the iso-2022-jp output flag and return error.
        iso2022jp_output_flag = false;
        return decoderError(fatal);

      case states.LeadByte:
        // Lead byte
        // Based on byte:

        // 0x1B
        if (bite === 0x1B) {
          // Set iso-2022-jp decoder state to escape start and return
          // continue.
          iso2022jp_decoder_state = states.EscapeStart;
          return null;
        }

        // 0x21 to 0x7E
        if (inRange(bite, 0x21, 0x7E)) {
          // Unset the iso-2022-jp output flag, set iso-2022-jp lead
          // to byte, iso-2022-jp decoder state to trail byte, and
          // return continue.
          iso2022jp_output_flag = false;
          iso2022jp_lead = bite;
          iso2022jp_decoder_state = states.TrailByte;
          return null;
        }

        // end-of-stream
        if (bite === end_of_stream) {
          // Return finished.
          return finished;
        }

        // Otherwise
        // Unset the iso-2022-jp output flag and return error.
        iso2022jp_output_flag = false;
        return decoderError(fatal);

      case states.TrailByte:
        // Trail byte
        // Based on byte:

        // 0x1B
        if (bite === 0x1B) {
          // Set iso-2022-jp decoder state to escape start and return
          // continue.
          iso2022jp_decoder_state = states.EscapeStart;
          return decoderError(fatal);
        }

        // 0x21 to 0x7E
        if (inRange(bite, 0x21, 0x7E)) {
          // 1. Set the iso-2022-jp decoder state to lead byte.
          iso2022jp_decoder_state = states.LeadByte;

          // 2. Let pointer be (iso-2022-jp lead − 0x21) × 94 + byte − 0x21.
          var pointer = (iso2022jp_lead - 0x21) * 94 + bite - 0x21;

          // 3. Let code point be the index code point for pointer in
          // index jis0208.
          var code_point = indexCodePointFor(pointer, index('jis0208'));

          // 4. If code point is null, return error.
          if (code_point === null)
            return decoderError(fatal);

          // 5. Return a code point whose value is code point.
          return code_point;
        }

        // end-of-stream
        if (bite === end_of_stream) {
          // Set the iso-2022-jp decoder state to lead byte, prepend
          // byte to stream, and return error.
          iso2022jp_decoder_state = states.LeadByte;
          stream.prepend(bite);
          return decoderError(fatal);
        }

        // Otherwise
        // Set iso-2022-jp decoder state to lead byte and return
        // error.
        iso2022jp_decoder_state = states.LeadByte;
        return decoderError(fatal);

      case states.EscapeStart:
        // Escape start

        // 1. If byte is either 0x24 or 0x28, set iso-2022-jp lead to
        // byte, iso-2022-jp decoder state to escape, and return
        // continue.
        if (bite === 0x24 || bite === 0x28) {
          iso2022jp_lead = bite;
          iso2022jp_decoder_state = states.Escape;
          return null;
        }

        // 2. Prepend byte to stream.
        stream.prepend(bite);

        // 3. Unset the iso-2022-jp output flag, set iso-2022-jp
        // decoder state to iso-2022-jp decoder output state, and
        // return error.
        iso2022jp_output_flag = false;
        iso2022jp_decoder_state = iso2022jp_decoder_output_state;
        return decoderError(fatal);

      case states.Escape:
        // Escape

        // 1. Let lead be iso-2022-jp lead and set iso-2022-jp lead to
        // 0x00.
        var lead = iso2022jp_lead;
        iso2022jp_lead = 0x00;

        // 2. Let state be null.
        var state = null;

        // 3. If lead is 0x28 and byte is 0x42, set state to ASCII.
        if (lead === 0x28 && bite === 0x42)
          state = states.ASCII;

        // 4. If lead is 0x28 and byte is 0x4A, set state to Roman.
        if (lead === 0x28 && bite === 0x4A)
          state = states.Roman;

        // 5. If lead is 0x28 and byte is 0x49, set state to Katakana.
        if (lead === 0x28 && bite === 0x49)
          state = states.Katakana;

        // 6. If lead is 0x24 and byte is either 0x40 or 0x42, set
        // state to lead byte.
        if (lead === 0x24 && (bite === 0x40 || bite === 0x42))
          state = states.LeadByte;

        // 7. If state is non-null, run these substeps:
        if (state !== null) {
          // 1. Set iso-2022-jp decoder state and iso-2022-jp decoder
          // output state to states.
          iso2022jp_decoder_state = iso2022jp_decoder_state = state;

          // 2. Let output flag be the iso-2022-jp output flag.
          var output_flag = iso2022jp_output_flag;

          // 3. Set the iso-2022-jp output flag.
          iso2022jp_output_flag = true;

          // 4. Return continue, if output flag is unset, and error
          // otherwise.
          return !output_flag ? null : decoderError(fatal);
        }

        // 8. Prepend lead and byte to stream.
        stream.prepend([lead, bite]);

        // 9. Unset the iso-2022-jp output flag, set iso-2022-jp
        // decoder state to iso-2022-jp decoder output state and
        // return error.
        iso2022jp_output_flag = false;
        iso2022jp_decoder_state = iso2022jp_decoder_output_state;
        return decoderError(fatal);
      }
    };
  }

  // 13.2.2 iso-2022-jp encoder
  /**
   * @constructor
   * @implements {Encoder}
   * @param {{fatal: boolean}} options
   */
  function ISO2022JPEncoder(options) {
    var fatal = options.fatal;
    // iso-2022-jp's encoder has an associated iso-2022-jp encoder
    // state which is one of ASCII, Roman, and jis0208 (initially
    // ASCII).
    /** @enum */
    var states = {
      ASCII: 0,
      Roman: 1,
      jis0208: 2
    };
    var /** @type {number} */ iso2022jp_state = states.ASCII;
    /**
     * @param {Stream} stream Input stream.
     * @param {number} code_point Next code point read from the stream.
     * @return {(number|!Array.<number>)} Byte(s) to emit.
     */
    this.handler = function(stream, code_point) {
      // 1. If code point is end-of-stream and iso-2022-jp encoder
      // state is not ASCII, prepend code point to stream, set
      // iso-2022-jp encoder state to ASCII, and return three bytes
      // 0x1B 0x28 0x42.
      if (code_point === end_of_stream &&
          iso2022jp_state !== states.ASCII) {
        stream.prepend(code_point);
        iso2022jp_state = states.ASCII;
        return [0x1B, 0x28, 0x42];
      }

      // 2. If code point is end-of-stream and iso-2022-jp encoder
      // state is ASCII, return finished.
      if (code_point === end_of_stream && iso2022jp_state === states.ASCII)
        return finished;

      // 3. If ISO-2022-JP encoder state is ASCII or Roman, and code
      // point is U+000E, U+000F, or U+001B, return error with U+FFFD.
      if ((iso2022jp_state === states.ASCII ||
           iso2022jp_state === states.Roman) &&
          (code_point === 0x000E || code_point === 0x000F ||
           code_point === 0x001B)) {
        return encoderError(0xFFFD);
      }

      // 4. If iso-2022-jp encoder state is ASCII and code point is an
      // ASCII code point, return a byte whose value is code point.
      if (iso2022jp_state === states.ASCII &&
          isASCIICodePoint(code_point))
        return code_point;

      // 5. If iso-2022-jp encoder state is Roman and code point is an
      // ASCII code point, excluding U+005C and U+007E, or is U+00A5
      // or U+203E, run these substeps:
      if (iso2022jp_state === states.Roman &&
          ((isASCIICodePoint(code_point) &&
           code_point !== 0x005C && code_point !== 0x007E) ||
          (code_point == 0x00A5 || code_point == 0x203E))) {

        // 1. If code point is an ASCII code point, return a byte
        // whose value is code point.
        if (isASCIICodePoint(code_point))
          return code_point;

        // 2. If code point is U+00A5, return byte 0x5C.
        if (code_point === 0x00A5)
          return 0x5C;

        // 3. If code point is U+203E, return byte 0x7E.
        if (code_point === 0x203E)
          return 0x7E;
      }

      // 6. If code point is an ASCII code point, and iso-2022-jp
      // encoder state is not ASCII, prepend code point to stream, set
      // iso-2022-jp encoder state to ASCII, and return three bytes
      // 0x1B 0x28 0x42.
      if (isASCIICodePoint(code_point) &&
          iso2022jp_state !== states.ASCII) {
        stream.prepend(code_point);
        iso2022jp_state = states.ASCII;
        return [0x1B, 0x28, 0x42];
      }

      // 7. If code point is either U+00A5 or U+203E, and iso-2022-jp
      // encoder state is not Roman, prepend code point to stream, set
      // iso-2022-jp encoder state to Roman, and return three bytes
      // 0x1B 0x28 0x4A.
      if ((code_point === 0x00A5 || code_point === 0x203E) &&
          iso2022jp_state !== states.Roman) {
        stream.prepend(code_point);
        iso2022jp_state = states.Roman;
        return [0x1B, 0x28, 0x4A];
      }

      // 8. If code point is U+2212, set it to U+FF0D.
      if (code_point === 0x2212)
        code_point = 0xFF0D;

      // 9. Let pointer be the index pointer for code point in index
      // jis0208.
      var pointer = indexPointerFor(code_point, index('jis0208'));

      // 10. If pointer is null, return error with code point.
      if (pointer === null)
        return encoderError(code_point);

      // 11. If iso-2022-jp encoder state is not jis0208, prepend code
      // point to stream, set iso-2022-jp encoder state to jis0208,
      // and return three bytes 0x1B 0x24 0x42.
      if (iso2022jp_state !== states.jis0208) {
        stream.prepend(code_point);
        iso2022jp_state = states.jis0208;
        return [0x1B, 0x24, 0x42];
      }

      // 12. Let lead be floor(pointer / 94) + 0x21.
      var lead = floor(pointer / 94) + 0x21;

      // 13. Let trail be pointer % 94 + 0x21.
      var trail = pointer % 94 + 0x21;

      // 14. Return two bytes whose values are lead and trail.
      return [lead, trail];
    };
  }

  /** @param {{fatal: boolean}} options */
  encoders['ISO-2022-JP'] = function(options) {
    return new ISO2022JPEncoder(options);
  };
  /** @param {{fatal: boolean}} options */
  decoders['ISO-2022-JP'] = function(options) {
    return new ISO2022JPDecoder(options);
  };

  // 13.3 Shift_JIS

  // 13.3.1 Shift_JIS decoder
  /**
   * @constructor
   * @implements {Decoder}
   * @param {{fatal: boolean}} options
   */
  function ShiftJISDecoder(options) {
    var fatal = options.fatal;
    // Shift_JIS's decoder has an associated Shift_JIS lead (initially
    // 0x00).
    var /** @type {number} */ Shift_JIS_lead = 0x00;
    /**
     * @param {Stream} stream The stream of bytes being decoded.
     * @param {number} bite The next byte read from the stream.
     * @return {?(number|!Array.<number>)} The next code point(s)
     *     decoded, or null if not enough data exists in the input
     *     stream to decode a complete code point.
     */
    this.handler = function(stream, bite) {
      // 1. If byte is end-of-stream and Shift_JIS lead is not 0x00,
      // set Shift_JIS lead to 0x00 and return error.
      if (bite === end_of_stream && Shift_JIS_lead !== 0x00) {
        Shift_JIS_lead = 0x00;
        return decoderError(fatal);
      }

      // 2. If byte is end-of-stream and Shift_JIS lead is 0x00,
      // return finished.
      if (bite === end_of_stream && Shift_JIS_lead === 0x00)
        return finished;

      // 3. If Shift_JIS lead is not 0x00, let lead be Shift_JIS lead,
      // let pointer be null, set Shift_JIS lead to 0x00, and then run
      // these substeps:
      if (Shift_JIS_lead !== 0x00) {
        var lead = Shift_JIS_lead;
        var pointer = null;
        Shift_JIS_lead = 0x00;

        // 1. Let offset be 0x40, if byte is less than 0x7F, and 0x41
        // otherwise.
        var offset = (bite < 0x7F) ? 0x40 : 0x41;

        // 2. Let lead offset be 0x81, if lead is less than 0xA0, and
        // 0xC1 otherwise.
        var lead_offset = (lead < 0xA0) ? 0x81 : 0xC1;

        // 3. If byte is in the range 0x40 to 0x7E, inclusive, or 0x80
        // to 0xFC, inclusive, set pointer to (lead − lead offset) ×
        // 188 + byte − offset.
        if (inRange(bite, 0x40, 0x7E) || inRange(bite, 0x80, 0xFC))
          pointer = (lead - lead_offset) * 188 + bite - offset;

        // 4. If pointer is in the range 8836 to 10715, inclusive,
        // return a code point whose value is 0xE000 − 8836 + pointer.
        if (inRange(pointer, 8836, 10715))
          return 0xE000 - 8836 + pointer;

        // 5. Let code point be null, if pointer is null, and the
        // index code point for pointer in index jis0208 otherwise.
        var code_point = (pointer === null) ? null :
              indexCodePointFor(pointer, index('jis0208'));

        // 6. If code point is null and byte is an ASCII byte, prepend
        // byte to stream.
        if (code_point === null && isASCIIByte(bite))
          stream.prepend(bite);

        // 7. If code point is null, return error.
        if (code_point === null)
          return decoderError(fatal);

        // 8. Return a code point whose value is code point.
        return code_point;
      }

      // 4. If byte is an ASCII byte or 0x80, return a code point
      // whose value is byte.
      if (isASCIIByte(bite) || bite === 0x80)
        return bite;

      // 5. If byte is in the range 0xA1 to 0xDF, inclusive, return a
      // code point whose value is 0xFF61 − 0xA1 + byte.
      if (inRange(bite, 0xA1, 0xDF))
        return 0xFF61 - 0xA1 + bite;

      // 6. If byte is in the range 0x81 to 0x9F, inclusive, or 0xE0
      // to 0xFC, inclusive, set Shift_JIS lead to byte and return
      // continue.
      if (inRange(bite, 0x81, 0x9F) || inRange(bite, 0xE0, 0xFC)) {
        Shift_JIS_lead = bite;
        return null;
      }

      // 7. Return error.
      return decoderError(fatal);
    };
  }

  // 13.3.2 Shift_JIS encoder
  /**
   * @constructor
   * @implements {Encoder}
   * @param {{fatal: boolean}} options
   */
  function ShiftJISEncoder(options) {
    var fatal = options.fatal;
    /**
     * @param {Stream} stream Input stream.
     * @param {number} code_point Next code point read from the stream.
     * @return {(number|!Array.<number>)} Byte(s) to emit.
     */
    this.handler = function(stream, code_point) {
      // 1. If code point is end-of-stream, return finished.
      if (code_point === end_of_stream)
        return finished;

      // 2. If code point is an ASCII code point or U+0080, return a
      // byte whose value is code point.
      if (isASCIICodePoint(code_point) || code_point === 0x0080)
        return code_point;

      // 3. If code point is U+00A5, return byte 0x5C.
      if (code_point === 0x00A5)
        return 0x5C;

      // 4. If code point is U+203E, return byte 0x7E.
      if (code_point === 0x203E)
        return 0x7E;

      // 5. If code point is in the range U+FF61 to U+FF9F, inclusive,
      // return a byte whose value is code point − 0xFF61 + 0xA1.
      if (inRange(code_point, 0xFF61, 0xFF9F))
        return code_point - 0xFF61 + 0xA1;

      // 6. If code point is U+2212, set it to U+FF0D.
      if (code_point === 0x2212)
        code_point = 0xFF0D;

      // 7. Let pointer be the index Shift_JIS pointer for code point.
      var pointer = indexShiftJISPointerFor(code_point);

      // 8. If pointer is null, return error with code point.
      if (pointer === null)
        return encoderError(code_point);

      // 9. Let lead be floor(pointer / 188).
      var lead = floor(pointer / 188);

      // 10. Let lead offset be 0x81, if lead is less than 0x1F, and
      // 0xC1 otherwise.
      var lead_offset = (lead < 0x1F) ? 0x81 : 0xC1;

      // 11. Let trail be pointer % 188.
      var trail = pointer % 188;

      // 12. Let offset be 0x40, if trail is less than 0x3F, and 0x41
      // otherwise.
      var offset = (trail < 0x3F) ? 0x40 : 0x41;

      // 13. Return two bytes whose values are lead + lead offset and
      // trail + offset.
      return [lead + lead_offset, trail + offset];
    };
  }

  /** @param {{fatal: boolean}} options */
  encoders['Shift_JIS'] = function(options) {
    return new ShiftJISEncoder(options);
  };
  /** @param {{fatal: boolean}} options */
  decoders['Shift_JIS'] = function(options) {
    return new ShiftJISDecoder(options);
  };

  //
  // 14. Legacy multi-byte Korean encodings
  //

  // 14.1 euc-kr

  // 14.1.1 euc-kr decoder
  /**
   * @constructor
   * @implements {Decoder}
   * @param {{fatal: boolean}} options
   */
  function EUCKRDecoder(options) {
    var fatal = options.fatal;

    // euc-kr's decoder has an associated euc-kr lead (initially 0x00).
    var /** @type {number} */ euckr_lead = 0x00;
    /**
     * @param {Stream} stream The stream of bytes being decoded.
     * @param {number} bite The next byte read from the stream.
     * @return {?(number|!Array.<number>)} The next code point(s)
     *     decoded, or null if not enough data exists in the input
     *     stream to decode a complete code point.
     */
    this.handler = function(stream, bite) {
      // 1. If byte is end-of-stream and euc-kr lead is not 0x00, set
      // euc-kr lead to 0x00 and return error.
      if (bite === end_of_stream && euckr_lead !== 0) {
        euckr_lead = 0x00;
        return decoderError(fatal);
      }

      // 2. If byte is end-of-stream and euc-kr lead is 0x00, return
      // finished.
      if (bite === end_of_stream && euckr_lead === 0)
        return finished;

      // 3. If euc-kr lead is not 0x00, let lead be euc-kr lead, let
      // pointer be null, set euc-kr lead to 0x00, and then run these
      // substeps:
      if (euckr_lead !== 0x00) {
        var lead = euckr_lead;
        var pointer = null;
        euckr_lead = 0x00;

        // 1. If byte is in the range 0x41 to 0xFE, inclusive, set
        // pointer to (lead − 0x81) × 190 + (byte − 0x41).
        if (inRange(bite, 0x41, 0xFE))
          pointer = (lead - 0x81) * 190 + (bite - 0x41);

        // 2. Let code point be null, if pointer is null, and the
        // index code point for pointer in index euc-kr otherwise.
        var code_point = (pointer === null)
              ? null : indexCodePointFor(pointer, index('euc-kr'));

        // 3. If code point is null and byte is an ASCII byte, prepend
        // byte to stream.
        if (pointer === null && isASCIIByte(bite))
          stream.prepend(bite);

        // 4. If code point is null, return error.
        if (code_point === null)
          return decoderError(fatal);

        // 5. Return a code point whose value is code point.
        return code_point;
      }

      // 4. If byte is an ASCII byte, return a code point whose value
      // is byte.
      if (isASCIIByte(bite))
        return bite;

      // 5. If byte is in the range 0x81 to 0xFE, inclusive, set
      // euc-kr lead to byte and return continue.
      if (inRange(bite, 0x81, 0xFE)) {
        euckr_lead = bite;
        return null;
      }

      // 6. Return error.
      return decoderError(fatal);
    };
  }

  // 14.1.2 euc-kr encoder
  /**
   * @constructor
   * @implements {Encoder}
   * @param {{fatal: boolean}} options
   */
  function EUCKREncoder(options) {
    var fatal = options.fatal;
    /**
     * @param {Stream} stream Input stream.
     * @param {number} code_point Next code point read from the stream.
     * @return {(number|!Array.<number>)} Byte(s) to emit.
     */
    this.handler = function(stream, code_point) {
      // 1. If code point is end-of-stream, return finished.
      if (code_point === end_of_stream)
        return finished;

      // 2. If code point is an ASCII code point, return a byte whose
      // value is code point.
      if (isASCIICodePoint(code_point))
        return code_point;

      // 3. Let pointer be the index pointer for code point in index
      // euc-kr.
      var pointer = indexPointerFor(code_point, index('euc-kr'));

      // 4. If pointer is null, return error with code point.
      if (pointer === null)
        return encoderError(code_point);

      // 5. Let lead be floor(pointer / 190) + 0x81.
      var lead = floor(pointer / 190) + 0x81;

      // 6. Let trail be pointer % 190 + 0x41.
      var trail = (pointer % 190) + 0x41;

      // 7. Return two bytes whose values are lead and trail.
      return [lead, trail];
    };
  }

  /** @param {{fatal: boolean}} options */
  encoders['EUC-KR'] = function(options) {
    return new EUCKREncoder(options);
  };
  /** @param {{fatal: boolean}} options */
  decoders['EUC-KR'] = function(options) {
    return new EUCKRDecoder(options);
  };


  //
  // 15. Legacy miscellaneous encodings
  //

  // 15.1 replacement

  // Not needed - API throws RangeError

  // 15.2 Common infrastructure for utf-16be and utf-16le

  /**
   * @param {number} code_unit
   * @param {boolean} utf16be
   * @return {!Array.<number>} bytes
   */
  function convertCodeUnitToBytes(code_unit, utf16be) {
    // 1. Let byte1 be code unit >> 8.
    var byte1 = code_unit >> 8;

    // 2. Let byte2 be code unit & 0x00FF.
    var byte2 = code_unit & 0x00FF;

    // 3. Then return the bytes in order:
        // utf-16be flag is set: byte1, then byte2.
    if (utf16be)
      return [byte1, byte2];
    // utf-16be flag is unset: byte2, then byte1.
    return [byte2, byte1];
  }

  // 15.2.1 shared utf-16 decoder
  /**
   * @constructor
   * @implements {Decoder}
   * @param {boolean} utf16_be True if big-endian, false if little-endian.
   * @param {{fatal: boolean}} options
   */
  function UTF16Decoder(utf16_be, options) {
    var fatal = options.fatal;
    var /** @type {?number} */ utf16_lead_byte = null,
        /** @type {?number} */ utf16_lead_surrogate = null;
    /**
     * @param {Stream} stream The stream of bytes being decoded.
     * @param {number} bite The next byte read from the stream.
     * @return {?(number|!Array.<number>)} The next code point(s)
     *     decoded, or null if not enough data exists in the input
     *     stream to decode a complete code point.
     */
    this.handler = function(stream, bite) {
      // 1. If byte is end-of-stream and either utf-16 lead byte or
      // utf-16 lead surrogate is not null, set utf-16 lead byte and
      // utf-16 lead surrogate to null, and return error.
      if (bite === end_of_stream && (utf16_lead_byte !== null ||
                                utf16_lead_surrogate !== null)) {
        return decoderError(fatal);
      }

      // 2. If byte is end-of-stream and utf-16 lead byte and utf-16
      // lead surrogate are null, return finished.
      if (bite === end_of_stream && utf16_lead_byte === null &&
          utf16_lead_surrogate === null) {
        return finished;
      }

      // 3. If utf-16 lead byte is null, set utf-16 lead byte to byte
      // and return continue.
      if (utf16_lead_byte === null) {
        utf16_lead_byte = bite;
        return null;
      }

      // 4. Let code unit be the result of:
      var code_unit;
      if (utf16_be) {
        // utf-16be decoder flag is set
        //   (utf-16 lead byte << 8) + byte.
        code_unit = (utf16_lead_byte << 8) + bite;
      } else {
        // utf-16be decoder flag is unset
        //   (byte << 8) + utf-16 lead byte.
        code_unit = (bite << 8) + utf16_lead_byte;
      }
      // Then set utf-16 lead byte to null.
      utf16_lead_byte = null;

      // 5. If utf-16 lead surrogate is not null, let lead surrogate
      // be utf-16 lead surrogate, set utf-16 lead surrogate to null,
      // and then run these substeps:
      if (utf16_lead_surrogate !== null) {
        var lead_surrogate = utf16_lead_surrogate;
        utf16_lead_surrogate = null;

        // 1. If code unit is in the range U+DC00 to U+DFFF,
        // inclusive, return a code point whose value is 0x10000 +
        // ((lead surrogate − 0xD800) << 10) + (code unit − 0xDC00).
        if (inRange(code_unit, 0xDC00, 0xDFFF)) {
          return 0x10000 + (lead_surrogate - 0xD800) * 0x400 +
              (code_unit - 0xDC00);
        }

        // 2. Prepend the sequence resulting of converting code unit
        // to bytes using utf-16be decoder flag to stream and return
        // error.
        stream.prepend(convertCodeUnitToBytes(code_unit, utf16_be));
        return decoderError(fatal);
      }

      // 6. If code unit is in the range U+D800 to U+DBFF, inclusive,
      // set utf-16 lead surrogate to code unit and return continue.
      if (inRange(code_unit, 0xD800, 0xDBFF)) {
        utf16_lead_surrogate = code_unit;
        return null;
      }

      // 7. If code unit is in the range U+DC00 to U+DFFF, inclusive,
      // return error.
      if (inRange(code_unit, 0xDC00, 0xDFFF))
        return decoderError(fatal);

      // 8. Return code point code unit.
      return code_unit;
    };
  }

  // 15.2.2 shared utf-16 encoder
  /**
   * @constructor
   * @implements {Encoder}
   * @param {boolean} utf16_be True if big-endian, false if little-endian.
   * @param {{fatal: boolean}} options
   */
  function UTF16Encoder(utf16_be, options) {
    var fatal = options.fatal;
    /**
     * @param {Stream} stream Input stream.
     * @param {number} code_point Next code point read from the stream.
     * @return {(number|!Array.<number>)} Byte(s) to emit.
     */
    this.handler = function(stream, code_point) {
      // 1. If code point is end-of-stream, return finished.
      if (code_point === end_of_stream)
        return finished;

      // 2. If code point is in the range U+0000 to U+FFFF, inclusive,
      // return the sequence resulting of converting code point to
      // bytes using utf-16be encoder flag.
      if (inRange(code_point, 0x0000, 0xFFFF))
        return convertCodeUnitToBytes(code_point, utf16_be);

      // 3. Let lead be ((code point − 0x10000) >> 10) + 0xD800,
      // converted to bytes using utf-16be encoder flag.
      var lead = convertCodeUnitToBytes(
        ((code_point - 0x10000) >> 10) + 0xD800, utf16_be);

      // 4. Let trail be ((code point − 0x10000) & 0x3FF) + 0xDC00,
      // converted to bytes using utf-16be encoder flag.
      var trail = convertCodeUnitToBytes(
        ((code_point - 0x10000) & 0x3FF) + 0xDC00, utf16_be);

      // 5. Return a byte sequence of lead followed by trail.
      return lead.concat(trail);
    };
  }

  // 15.3 utf-16be
  // 15.3.1 utf-16be decoder
  /** @param {{fatal: boolean}} options */
  encoders['UTF-16BE'] = function(options) {
    return new UTF16Encoder(true, options);
  };
  // 15.3.2 utf-16be encoder
  /** @param {{fatal: boolean}} options */
  decoders['UTF-16BE'] = function(options) {
    return new UTF16Decoder(true, options);
  };

  // 15.4 utf-16le
  // 15.4.1 utf-16le decoder
  /** @param {{fatal: boolean}} options */
  encoders['UTF-16LE'] = function(options) {
    return new UTF16Encoder(false, options);
  };
  // 15.4.2 utf-16le encoder
  /** @param {{fatal: boolean}} options */
  decoders['UTF-16LE'] = function(options) {
    return new UTF16Decoder(false, options);
  };

  // 15.5 x-user-defined

  // 15.5.1 x-user-defined decoder
  /**
   * @constructor
   * @implements {Decoder}
   * @param {{fatal: boolean}} options
   */
  function XUserDefinedDecoder(options) {
    var fatal = options.fatal;
    /**
     * @param {Stream} stream The stream of bytes being decoded.
     * @param {number} bite The next byte read from the stream.
     * @return {?(number|!Array.<number>)} The next code point(s)
     *     decoded, or null if not enough data exists in the input
     *     stream to decode a complete code point.
     */
    this.handler = function(stream, bite) {
      // 1. If byte is end-of-stream, return finished.
      if (bite === end_of_stream)
        return finished;

      // 2. If byte is an ASCII byte, return a code point whose value
      // is byte.
      if (isASCIIByte(bite))
        return bite;

      // 3. Return a code point whose value is 0xF780 + byte − 0x80.
      return 0xF780 + bite - 0x80;
    };
  }

  // 15.5.2 x-user-defined encoder
  /**
   * @constructor
   * @implements {Encoder}
   * @param {{fatal: boolean}} options
   */
  function XUserDefinedEncoder(options) {
    var fatal = options.fatal;
    /**
     * @param {Stream} stream Input stream.
     * @param {number} code_point Next code point read from the stream.
     * @return {(number|!Array.<number>)} Byte(s) to emit.
     */
    this.handler = function(stream, code_point) {
      // 1.If code point is end-of-stream, return finished.
      if (code_point === end_of_stream)
        return finished;

      // 2. If code point is an ASCII code point, return a byte whose
      // value is code point.
      if (isASCIICodePoint(code_point))
        return code_point;

      // 3. If code point is in the range U+F780 to U+F7FF, inclusive,
      // return a byte whose value is code point − 0xF780 + 0x80.
      if (inRange(code_point, 0xF780, 0xF7FF))
        return code_point - 0xF780 + 0x80;

      // 4. Return error with code point.
      return encoderError(code_point);
    };
  }

  /** @param {{fatal: boolean}} options */
  encoders['x-user-defined'] = function(options) {
    return new XUserDefinedEncoder(options);
  };
  /** @param {{fatal: boolean}} options */
  decoders['x-user-defined'] = function(options) {
    return new XUserDefinedDecoder(options);
  };

  if (!global['TextEncoder'])
    global['TextEncoder'] = TextEncoder;
  if (!global['TextDecoder'])
    global['TextDecoder'] = TextDecoder;

  if ( true && module.exports) {
    module.exports = {
      TextEncoder: global['TextEncoder'],
      TextDecoder: global['TextDecoder'],
      EncodingIndexes: global["encoding-indexes"]
    };
  }

// For strict environments where `this` inside the global scope
// is `undefined`, take a pure object instead
}(this || {}));

/***/ }),

/***/ 52183:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ BreadcrumbStylesProvider; },
/* harmony export */   "w": function() { return /* binding */ useBreadcrumbStyles; }
/* harmony export */ });
/* harmony import */ var _chakra_ui_react_context__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55227);
'use client'

// src/breadcrumb-context.ts
;
var [BreadcrumbStylesProvider, useBreadcrumbStyles] = (0,_chakra_ui_react_context__WEBPACK_IMPORTED_MODULE_0__/* .createContext */ .k)({
  name: `BreadcrumbStylesContext`,
  errorMessage: `useBreadcrumbStyles returned is 'undefined'. Seems you forgot to wrap the components in "<Breadcrumb />" `
});


//# sourceMappingURL=chunk-24NX3CUR.mjs.map

/***/ }),

/***/ 52718:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ Breadcrumb; }
/* harmony export */ });
/* harmony import */ var _chunk_24NX3CUR_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(52183);
/* harmony import */ var _chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(25432);
/* harmony import */ var _chakra_ui_react_children_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(92495);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16554);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77030);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(33179);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(22548);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
'use client'
;

// src/breadcrumb.tsx





var Breadcrumb = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .forwardRef */ .G)(
  function Breadcrumb2(props, ref) {
    const styles = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__/* .useMultiStyleConfig */ .jC)("Breadcrumb", props);
    const ownProps = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_4__/* .omitThemingProps */ .Lr)(props);
    const {
      children,
      spacing = "0.5rem",
      separator = "/",
      className,
      listProps,
      ...rest
    } = ownProps;
    const validChildren = (0,_chakra_ui_react_children_utils__WEBPACK_IMPORTED_MODULE_5__/* .getValidChildren */ .W)(children);
    const count = validChildren.length;
    const clones = validChildren.map(
      (child, index) => (0,react__WEBPACK_IMPORTED_MODULE_0__.cloneElement)(child, {
        separator,
        spacing,
        isLastChild: count === index + 1
      })
    );
    const _className = (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_6__.cx)("chakra-breadcrumb", className);
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
      _chakra_ui_system__WEBPACK_IMPORTED_MODULE_7__/* .chakra.nav */ .m.nav,
      {
        ref,
        "aria-label": "breadcrumb",
        className: _className,
        __css: styles.container,
        ...rest,
        children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chunk_24NX3CUR_mjs__WEBPACK_IMPORTED_MODULE_8__/* .BreadcrumbStylesProvider */ .W, { value: styles, children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
          _chakra_ui_system__WEBPACK_IMPORTED_MODULE_7__/* .chakra.ol */ .m.ol,
          {
            className: "chakra-breadcrumb__list",
            ...listProps,
            __css: {
              display: "flex",
              alignItems: "center",
              ...styles.list
            },
            children: clones
          }
        ) })
      }
    );
  }
);
Breadcrumb.displayName = "Breadcrumb";


//# sourceMappingURL=chunk-QOOL75FN.mjs.map

/***/ }),

/***/ 25322:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "g": function() { return /* binding */ BreadcrumbItem; }
});

// EXTERNAL MODULE: ./node_modules/@chakra-ui/breadcrumb/dist/chunk-UIZJRKRT.mjs
var chunk_UIZJRKRT = __webpack_require__(94236);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/breadcrumb/dist/chunk-24NX3CUR.mjs
var chunk_24NX3CUR = __webpack_require__(52183);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/system/dist/chunk-ZJJGQIVY.mjs
var chunk_ZJJGQIVY = __webpack_require__(16554);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/system/dist/chunk-ZHQNHOQS.mjs + 6 modules
var chunk_ZHQNHOQS = __webpack_require__(22548);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@chakra-ui/breadcrumb/dist/chunk-I4SEDIQD.mjs
'use client'
;

// src/breadcrumb-separator.tsx


var BreadcrumbSeparator = (0,chunk_ZJJGQIVY/* forwardRef */.G)(
  function BreadcrumbSeparator2(props, ref) {
    const { spacing, ...rest } = props;
    const styles = (0,chunk_24NX3CUR/* useBreadcrumbStyles */.w)();
    const separatorStyles = {
      mx: spacing,
      ...styles.separator
    };
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(
      chunk_ZHQNHOQS/* chakra.span */.m.span,
      {
        ref,
        role: "presentation",
        ...rest,
        __css: separatorStyles
      }
    );
  }
);
BreadcrumbSeparator.displayName = "BreadcrumbSeparator";


//# sourceMappingURL=chunk-I4SEDIQD.mjs.map
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react-children-utils/dist/index.mjs
var dist = __webpack_require__(92495);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/shared-utils/dist/index.mjs
var shared_utils_dist = __webpack_require__(25432);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@chakra-ui/breadcrumb/dist/chunk-U7EUQI2I.mjs
'use client'
;



// src/breadcrumb-item.tsx





var BreadcrumbItem = (0,chunk_ZJJGQIVY/* forwardRef */.G)(
  function BreadcrumbItem2(props, ref) {
    const {
      isCurrentPage,
      separator,
      isLastChild,
      spacing,
      children,
      className,
      ...rest
    } = props;
    const validChildren = (0,dist/* getValidChildren */.W)(children);
    const clones = validChildren.map((child) => {
      if (child.type === chunk_UIZJRKRT/* BreadcrumbLink */.A) {
        return (0,react.cloneElement)(child, {
          isCurrentPage
        });
      }
      if (child.type === BreadcrumbSeparator) {
        return (0,react.cloneElement)(child, {
          spacing,
          children: child.props.children || separator
        });
      }
      return child;
    });
    const styles = (0,chunk_24NX3CUR/* useBreadcrumbStyles */.w)();
    const itemStyles = {
      display: "inline-flex",
      alignItems: "center",
      ...styles.item
    };
    const _className = (0,shared_utils_dist.cx)("chakra-breadcrumb__list-item", className);
    return /* @__PURE__ */ (0,jsx_runtime.jsxs)(chunk_ZHQNHOQS/* chakra.li */.m.li, { ref, className: _className, ...rest, __css: itemStyles, children: [
      clones,
      !isLastChild && /* @__PURE__ */ (0,jsx_runtime.jsx)(BreadcrumbSeparator, { spacing, children: separator })
    ] });
  }
);
BreadcrumbItem.displayName = "BreadcrumbItem";


//# sourceMappingURL=chunk-U7EUQI2I.mjs.map

/***/ }),

/***/ 94236:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ BreadcrumbLink; }
/* harmony export */ });
/* harmony import */ var _chunk_24NX3CUR_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52183);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16554);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22548);
/* harmony import */ var _chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25432);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
'use client'
;

// src/breadcrumb-link.tsx



var BreadcrumbLink = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .forwardRef */ .G)(
  function BreadcrumbLink2(props, ref) {
    const { isCurrentPage, as, className, href, ...rest } = props;
    const styles = (0,_chunk_24NX3CUR_mjs__WEBPACK_IMPORTED_MODULE_2__/* .useBreadcrumbStyles */ .w)();
    const sharedProps = {
      ref,
      as,
      className: (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_3__.cx)("chakra-breadcrumb__link", className),
      ...rest
    };
    if (isCurrentPage) {
      return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_4__/* .chakra.span */ .m.span, { "aria-current": "page", __css: styles.link, ...sharedProps });
    }
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_4__/* .chakra.a */ .m.a, { __css: styles.link, href, ...sharedProps });
  }
);
BreadcrumbLink.displayName = "BreadcrumbLink";


//# sourceMappingURL=chunk-UIZJRKRT.mjs.map

/***/ }),

/***/ 89993:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ IconButton; }
/* harmony export */ });
/* harmony import */ var _chunk_UVUR7MCU_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93108);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16554);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
'use client'
;

// src/icon-button.tsx



var IconButton = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .forwardRef */ .G)(
  (props, ref) => {
    const { icon, children, isRound, "aria-label": ariaLabel, ...rest } = props;
    const element = icon || children;
    const _children = (0,react__WEBPACK_IMPORTED_MODULE_0__.isValidElement)(element) ? (0,react__WEBPACK_IMPORTED_MODULE_0__.cloneElement)(element, {
      "aria-hidden": true,
      focusable: false
    }) : null;
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
      _chunk_UVUR7MCU_mjs__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .z,
      {
        padding: "0",
        borderRadius: isRound ? "full" : void 0,
        ref,
        "aria-label": ariaLabel,
        ...rest,
        children: _children
      }
    );
  }
);
IconButton.displayName = "IconButton";


//# sourceMappingURL=chunk-6QYXN73V.mjs.map

/***/ }),

/***/ 78590:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ ButtonGroup; }
/* harmony export */ });
/* harmony import */ var _chunk_T6ZDZOLO_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(78522);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16554);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(22548);
/* harmony import */ var _chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25432);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
'use client'
;

// src/button-group.tsx




var attachedStyles = {
  horizontal: {
    "> *:first-of-type:not(:last-of-type)": { borderEndRadius: 0 },
    "> *:not(:first-of-type):not(:last-of-type)": { borderRadius: 0 },
    "> *:not(:first-of-type):last-of-type": { borderStartRadius: 0 }
  },
  vertical: {
    "> *:first-of-type:not(:last-of-type)": { borderBottomRadius: 0 },
    "> *:not(:first-of-type):not(:last-of-type)": { borderRadius: 0 },
    "> *:not(:first-of-type):last-of-type": { borderTopRadius: 0 }
  }
};
var gapStyles = {
  horizontal: (spacing) => ({
    "& > *:not(style) ~ *:not(style)": { marginStart: spacing }
  }),
  vertical: (spacing) => ({
    "& > *:not(style) ~ *:not(style)": { marginTop: spacing }
  })
};
var ButtonGroup = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .forwardRef */ .G)(
  function ButtonGroup2(props, ref) {
    const {
      size,
      colorScheme,
      variant,
      className,
      spacing = "0.5rem",
      isAttached,
      isDisabled,
      orientation = "horizontal",
      ...rest
    } = props;
    const _className = (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_3__.cx)("chakra-button__group", className);
    const context = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(
      () => ({ size, colorScheme, variant, isDisabled }),
      [size, colorScheme, variant, isDisabled]
    );
    let groupStyles = {
      display: "inline-flex",
      ...isAttached ? attachedStyles[orientation] : gapStyles[orientation](spacing)
    };
    const isVertical = orientation === "vertical";
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chunk_T6ZDZOLO_mjs__WEBPACK_IMPORTED_MODULE_4__/* .ButtonGroupProvider */ .D, { value: context, children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
      _chakra_ui_system__WEBPACK_IMPORTED_MODULE_5__/* .chakra.div */ .m.div,
      {
        ref,
        role: "group",
        __css: groupStyles,
        className: _className,
        "data-attached": isAttached ? "" : void 0,
        "data-orientation": orientation,
        flexDir: isVertical ? "column" : void 0,
        ...rest
      }
    ) });
  }
);
ButtonGroup.displayName = "ButtonGroup";


//# sourceMappingURL=chunk-DA7QIPTJ.mjs.map

/***/ }),

/***/ 65225:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "n": function() { return /* binding */ createDescendantContext; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@chakra-ui/descendant/dist/chunk-3A5YOZDU.mjs
'use client'
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};

// src/utils.ts

function sortNodes(nodes) {
  return nodes.sort((a, b) => {
    const compare = a.compareDocumentPosition(b);
    if (compare & Node.DOCUMENT_POSITION_FOLLOWING || compare & Node.DOCUMENT_POSITION_CONTAINED_BY) {
      return -1;
    }
    if (compare & Node.DOCUMENT_POSITION_PRECEDING || compare & Node.DOCUMENT_POSITION_CONTAINS) {
      return 1;
    }
    if (compare & Node.DOCUMENT_POSITION_DISCONNECTED || compare & Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC) {
      throw Error("Cannot sort the given nodes.");
    } else {
      return 0;
    }
  });
}
var isElement = (el) => typeof el == "object" && "nodeType" in el && el.nodeType === Node.ELEMENT_NODE;
function getNextIndex(current, max, loop) {
  let next = current + 1;
  if (loop && next >= max)
    next = 0;
  return next;
}
function getPrevIndex(current, max, loop) {
  let next = current - 1;
  if (loop && next < 0)
    next = max;
  return next;
}
var useSafeLayoutEffect = typeof window !== "undefined" ? react.useLayoutEffect : react.useEffect;
var cast = (value) => value;


//# sourceMappingURL=chunk-3A5YOZDU.mjs.map
;// CONCATENATED MODULE: ./node_modules/@chakra-ui/descendant/dist/chunk-FT3H4P66.mjs
'use client'
;

// src/descendant.ts
var DescendantsManager = class {
  constructor() {
    __publicField(this, "descendants", /* @__PURE__ */ new Map());
    __publicField(this, "register", (nodeOrOptions) => {
      if (nodeOrOptions == null)
        return;
      if (isElement(nodeOrOptions)) {
        return this.registerNode(nodeOrOptions);
      }
      return (node) => {
        this.registerNode(node, nodeOrOptions);
      };
    });
    __publicField(this, "unregister", (node) => {
      this.descendants.delete(node);
      const sorted = sortNodes(Array.from(this.descendants.keys()));
      this.assignIndex(sorted);
    });
    __publicField(this, "destroy", () => {
      this.descendants.clear();
    });
    __publicField(this, "assignIndex", (descendants) => {
      this.descendants.forEach((descendant) => {
        const index = descendants.indexOf(descendant.node);
        descendant.index = index;
        descendant.node.dataset["index"] = descendant.index.toString();
      });
    });
    __publicField(this, "count", () => this.descendants.size);
    __publicField(this, "enabledCount", () => this.enabledValues().length);
    __publicField(this, "values", () => {
      const values = Array.from(this.descendants.values());
      return values.sort((a, b) => a.index - b.index);
    });
    __publicField(this, "enabledValues", () => {
      return this.values().filter((descendant) => !descendant.disabled);
    });
    __publicField(this, "item", (index) => {
      if (this.count() === 0)
        return void 0;
      return this.values()[index];
    });
    __publicField(this, "enabledItem", (index) => {
      if (this.enabledCount() === 0)
        return void 0;
      return this.enabledValues()[index];
    });
    __publicField(this, "first", () => this.item(0));
    __publicField(this, "firstEnabled", () => this.enabledItem(0));
    __publicField(this, "last", () => this.item(this.descendants.size - 1));
    __publicField(this, "lastEnabled", () => {
      const lastIndex = this.enabledValues().length - 1;
      return this.enabledItem(lastIndex);
    });
    __publicField(this, "indexOf", (node) => {
      var _a, _b;
      if (!node)
        return -1;
      return (_b = (_a = this.descendants.get(node)) == null ? void 0 : _a.index) != null ? _b : -1;
    });
    __publicField(this, "enabledIndexOf", (node) => {
      if (node == null)
        return -1;
      return this.enabledValues().findIndex((i) => i.node.isSameNode(node));
    });
    __publicField(this, "next", (index, loop = true) => {
      const next = getNextIndex(index, this.count(), loop);
      return this.item(next);
    });
    __publicField(this, "nextEnabled", (index, loop = true) => {
      const item = this.item(index);
      if (!item)
        return;
      const enabledIndex = this.enabledIndexOf(item.node);
      const nextEnabledIndex = getNextIndex(
        enabledIndex,
        this.enabledCount(),
        loop
      );
      return this.enabledItem(nextEnabledIndex);
    });
    __publicField(this, "prev", (index, loop = true) => {
      const prev = getPrevIndex(index, this.count() - 1, loop);
      return this.item(prev);
    });
    __publicField(this, "prevEnabled", (index, loop = true) => {
      const item = this.item(index);
      if (!item)
        return;
      const enabledIndex = this.enabledIndexOf(item.node);
      const prevEnabledIndex = getPrevIndex(
        enabledIndex,
        this.enabledCount() - 1,
        loop
      );
      return this.enabledItem(prevEnabledIndex);
    });
    __publicField(this, "registerNode", (node, options) => {
      if (!node || this.descendants.has(node))
        return;
      const keys = Array.from(this.descendants.keys()).concat(node);
      const sorted = sortNodes(keys);
      if (options == null ? void 0 : options.disabled) {
        options.disabled = !!options.disabled;
      }
      const descendant = { node, index: -1, ...options };
      this.descendants.set(node, descendant);
      this.assignIndex(sorted);
    });
  }
};


//# sourceMappingURL=chunk-FT3H4P66.mjs.map
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react-context/dist/index.mjs
var dist = __webpack_require__(55227);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react-use-merge-refs/dist/index.mjs
var react_use_merge_refs_dist = __webpack_require__(81103);
;// CONCATENATED MODULE: ./node_modules/@chakra-ui/descendant/dist/chunk-OCNORRQU.mjs
'use client'
;


// src/use-descendant.ts



function useDescendants() {
  const descendants = (0,react.useRef)(new DescendantsManager());
  useSafeLayoutEffect(() => {
    return () => descendants.current.destroy();
  });
  return descendants.current;
}
var [DescendantsContextProvider, useDescendantsContext] = (0,dist/* createContext */.k)({
  name: "DescendantsProvider",
  errorMessage: "useDescendantsContext must be used within DescendantsProvider"
});
function useDescendant(options) {
  const descendants = useDescendantsContext();
  const [index, setIndex] = (0,react.useState)(-1);
  const ref = (0,react.useRef)(null);
  useSafeLayoutEffect(() => {
    return () => {
      if (!ref.current)
        return;
      descendants.unregister(ref.current);
    };
  }, []);
  useSafeLayoutEffect(() => {
    if (!ref.current)
      return;
    const dataIndex = Number(ref.current.dataset["index"]);
    if (index != dataIndex && !Number.isNaN(dataIndex)) {
      setIndex(dataIndex);
    }
  });
  const refCallback = options ? cast(descendants.register(options)) : cast(descendants.register);
  return {
    descendants,
    index,
    enabledIndex: descendants.enabledIndexOf(ref.current),
    register: (0,react_use_merge_refs_dist/* mergeRefs */.lq)(refCallback, ref)
  };
}
function createDescendantContext() {
  const ContextProvider = cast(DescendantsContextProvider);
  const _useDescendantsContext = () => cast(useDescendantsContext());
  const _useDescendant = (options) => useDescendant(options);
  const _useDescendants = () => useDescendants();
  return [
    // context provider
    ContextProvider,
    // call this when you need to read from context
    _useDescendantsContext,
    // descendants state information, to be called and passed to `ContextProvider`
    _useDescendants,
    // descendant index information
    _useDescendant
  ];
}


//# sourceMappingURL=chunk-OCNORRQU.mjs.map

/***/ }),

/***/ 53978:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ useClipboard; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var copy_to_clipboard__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20640);
'use client'

// src/use-clipboard.ts
;

function useClipboard(value, optionsOrTimeout = {}) {
  const [hasCopied, setHasCopied] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  const [valueState, setValueState] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(value);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => setValueState(value), [value]);
  const { timeout = 1500, ...copyOptions } = typeof optionsOrTimeout === "number" ? { timeout: optionsOrTimeout } : optionsOrTimeout;
  const onCopy = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
    const didCopy = copy_to_clipboard__WEBPACK_IMPORTED_MODULE_1__(valueState, copyOptions);
    setHasCopied(didCopy);
  }, [valueState, copyOptions]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    let timeoutId = null;
    if (hasCopied) {
      timeoutId = window.setTimeout(() => {
        setHasCopied(false);
      }, timeout);
    }
    return () => {
      if (timeoutId) {
        window.clearTimeout(timeoutId);
      }
    };
  }, [timeout, hasCopied]);
  return {
    value: valueState,
    setValue: setValueState,
    onCopy,
    hasCopied
  };
}


//# sourceMappingURL=chunk-KYYEOW6S.mjs.map

/***/ }),

/***/ 56714:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ useOutsideClick; }
/* harmony export */ });
/* harmony import */ var _chunk_KA2477BY_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76264);
/* harmony import */ var _chakra_ui_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81982);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
'use client'
;

// src/use-outside-click.ts


function useOutsideClick(props) {
  const { ref, handler, enabled = true } = props;
  const savedHandler = (0,_chunk_KA2477BY_mjs__WEBPACK_IMPORTED_MODULE_1__/* .useCallbackRef */ .W)(handler);
  const stateRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({
    isPointerDown: false,
    ignoreEmulatedMouseEvents: false
  });
  const state = stateRef.current;
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (!enabled)
      return;
    const onPointerDown = (e) => {
      if (isValidEvent(e, ref)) {
        state.isPointerDown = true;
      }
    };
    const onMouseUp = (event) => {
      if (state.ignoreEmulatedMouseEvents) {
        state.ignoreEmulatedMouseEvents = false;
        return;
      }
      if (state.isPointerDown && handler && isValidEvent(event, ref)) {
        state.isPointerDown = false;
        savedHandler(event);
      }
    };
    const onTouchEnd = (event) => {
      state.ignoreEmulatedMouseEvents = true;
      if (handler && state.isPointerDown && isValidEvent(event, ref)) {
        state.isPointerDown = false;
        savedHandler(event);
      }
    };
    const doc = (0,_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_2__/* .getOwnerDocument */ .lZ)(ref.current);
    doc.addEventListener("mousedown", onPointerDown, true);
    doc.addEventListener("mouseup", onMouseUp, true);
    doc.addEventListener("touchstart", onPointerDown, true);
    doc.addEventListener("touchend", onTouchEnd, true);
    return () => {
      doc.removeEventListener("mousedown", onPointerDown, true);
      doc.removeEventListener("mouseup", onMouseUp, true);
      doc.removeEventListener("touchstart", onPointerDown, true);
      doc.removeEventListener("touchend", onTouchEnd, true);
    };
  }, [handler, ref, savedHandler, state, enabled]);
}
function isValidEvent(event, ref) {
  var _a;
  const target = event.target;
  if (target) {
    const doc = (0,_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_2__/* .getOwnerDocument */ .lZ)(target);
    if (!doc.contains(target))
      return false;
  }
  return !((_a = ref.current) == null ? void 0 : _a.contains(target));
}


//# sourceMappingURL=chunk-R5W6LHQW.mjs.map

/***/ }),

/***/ 24027:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ createIcon; }
/* harmony export */ });
/* harmony import */ var _chunk_2GBDXOMA_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36948);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16554);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
'use client'
;

// src/create-icon.tsx



function createIcon(options) {
  const {
    viewBox = "0 0 24 24",
    d: pathDefinition,
    displayName,
    defaultProps = {}
  } = options;
  const path = react__WEBPACK_IMPORTED_MODULE_0__.Children.toArray(options.path);
  const Comp = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .forwardRef */ .G)((props, ref) => /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chunk_2GBDXOMA_mjs__WEBPACK_IMPORTED_MODULE_3__/* .Icon */ .J, { ref, viewBox, ...defaultProps, ...props, children: path.length ? path : /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", { fill: "currentColor", d: pathDefinition }) }));
  Comp.displayName = displayName;
  return Comp;
}


//# sourceMappingURL=chunk-DEQZ7DVA.mjs.map

/***/ }),

/***/ 45349:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ ExternalLinkIcon; }
/* harmony export */ });
/* harmony import */ var _chakra_ui_icon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24027);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
'use client'

// src/ExternalLink.tsx
;

var ExternalLinkIcon = (0,_chakra_ui_icon__WEBPACK_IMPORTED_MODULE_1__/* .createIcon */ .I)({
  displayName: "ExternalLinkIcon",
  path: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", { fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "2", children: [
    /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", { d: "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" }),
    /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", { d: "M15 3h6v6" }),
    /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", { d: "M10 14L21 3" })
  ] })
});


//# sourceMappingURL=chunk-6UX5C75U.mjs.map

/***/ }),

/***/ 21371:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ QuestionOutlineIcon; }
/* harmony export */ });
/* harmony import */ var _chakra_ui_icon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24027);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
'use client'

// src/QuestionOutline.tsx
;

var QuestionOutlineIcon = (0,_chakra_ui_icon__WEBPACK_IMPORTED_MODULE_1__/* .createIcon */ .I)({
  displayName: "QuestionOutlineIcon",
  path: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", { stroke: "currentColor", strokeWidth: "1.5", children: [
    /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
      "path",
      {
        strokeLinecap: "round",
        fill: "none",
        d: "M9,9a3,3,0,1,1,4,2.829,1.5,1.5,0,0,0-1,1.415V14.25"
      }
    ),
    /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
      "path",
      {
        fill: "none",
        strokeLinecap: "round",
        d: "M12,17.25a.375.375,0,1,0,.375.375A.375.375,0,0,0,12,17.25h0"
      }
    ),
    /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", { fill: "none", strokeMiterlimit: "10", cx: "12", cy: "12", r: "11.25" })
  ] })
});


//# sourceMappingURL=chunk-SK7D2XJH.mjs.map

/***/ }),

/***/ 65028:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ Spacer; }
/* harmony export */ });
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22548);
'use client'

// src/spacer.tsx
;
var Spacer = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_0__/* .chakra */ .m)("div", {
  baseStyle: {
    flex: 1,
    justifySelf: "stretch",
    alignSelf: "stretch"
  }
});
Spacer.displayName = "Spacer";


//# sourceMappingURL=chunk-BL2ZZSHG.mjs.map

/***/ }),

/***/ 79078:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ Grid; }
/* harmony export */ });
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16554);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22548);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
'use client'

// src/grid.tsx
;

var Grid = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .forwardRef */ .G)(function Grid2(props, ref) {
  const {
    templateAreas,
    gap,
    rowGap,
    columnGap,
    column,
    row,
    autoFlow,
    autoRows,
    templateRows,
    autoColumns,
    templateColumns,
    ...rest
  } = props;
  const styles = {
    display: "grid",
    gridTemplateAreas: templateAreas,
    gridGap: gap,
    gridRowGap: rowGap,
    gridColumnGap: columnGap,
    gridAutoColumns: autoColumns,
    gridColumn: column,
    gridRow: row,
    gridAutoFlow: autoFlow,
    gridAutoRows: autoRows,
    gridTemplateRows: templateRows,
    gridTemplateColumns: templateColumns
  };
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .chakra.div */ .m.div, { ref, __css: styles, ...rest });
});
Grid.displayName = "Grid";


//# sourceMappingURL=chunk-JARCRF6W.mjs.map

/***/ }),

/***/ 32883:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ Link; }
/* harmony export */ });
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16554);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77030);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(33179);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22548);
/* harmony import */ var _chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25432);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
'use client'

// src/link.tsx
;


var Link = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .forwardRef */ .G)(function Link2(props, ref) {
  const styles = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .useStyleConfig */ .mq)("Link", props);
  const { className, isExternal, ...rest } = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__/* .omitThemingProps */ .Lr)(props);
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
    _chakra_ui_system__WEBPACK_IMPORTED_MODULE_4__/* .chakra.a */ .m.a,
    {
      target: isExternal ? "_blank" : void 0,
      rel: isExternal ? "noopener" : void 0,
      ref,
      className: (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_5__.cx)("chakra-link", className),
      ...rest,
      __css: styles
    }
  );
});
Link.displayName = "Link";


//# sourceMappingURL=chunk-K7XRJ7NL.mjs.map

/***/ }),

/***/ 48783:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ VStack; }
/* harmony export */ });
/* harmony import */ var _chunk_ZHMYA64R_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55281);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16554);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
'use client'
;

// src/stack/v-stack.tsx


var VStack = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .forwardRef */ .G)((props, ref) => /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chunk_ZHMYA64R_mjs__WEBPACK_IMPORTED_MODULE_2__/* .Stack */ .K, { align: "center", ...props, direction: "column", ref }));
VStack.displayName = "VStack";


//# sourceMappingURL=chunk-NTCQBYKE.mjs.map

/***/ }),

/***/ 49289:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ Divider; }
/* harmony export */ });
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16554);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77030);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(33179);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22548);
/* harmony import */ var _chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25432);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
'use client'

// src/divider.tsx
;


var Divider = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .forwardRef */ .G)(function Divider2(props, ref) {
  const {
    borderLeftWidth,
    borderBottomWidth,
    borderTopWidth,
    borderRightWidth,
    borderWidth,
    borderStyle,
    borderColor,
    ...styles
  } = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .useStyleConfig */ .mq)("Divider", props);
  const {
    className,
    orientation = "horizontal",
    __css,
    ...rest
  } = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__/* .omitThemingProps */ .Lr)(props);
  const dividerStyles = {
    vertical: {
      borderLeftWidth: borderLeftWidth || borderRightWidth || borderWidth || "1px",
      height: "100%"
    },
    horizontal: {
      borderBottomWidth: borderBottomWidth || borderTopWidth || borderWidth || "1px",
      width: "100%"
    }
  };
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
    _chakra_ui_system__WEBPACK_IMPORTED_MODULE_4__/* .chakra.hr */ .m.hr,
    {
      ref,
      "aria-orientation": orientation,
      ...rest,
      __css: {
        ...styles,
        border: "0",
        borderColor,
        borderStyle,
        ...dividerStyles[orientation],
        ...__css
      },
      className: (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_5__.cx)("chakra-divider", className)
    }
  );
});
Divider.displayName = "Divider";


//# sourceMappingURL=chunk-W7WUSNWJ.mjs.map

/***/ }),

/***/ 68519:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ GridItem; }
/* harmony export */ });
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16554);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22548);
/* harmony import */ var _chakra_ui_object_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87052);
/* harmony import */ var _chakra_ui_breakpoint_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33951);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
'use client'

// src/grid-item.tsx
;



function spanFn(span) {
  return (0,_chakra_ui_breakpoint_utils__WEBPACK_IMPORTED_MODULE_1__/* .mapResponsive */ .XQ)(
    span,
    (value) => value === "auto" ? "auto" : `span ${value}/span ${value}`
  );
}
var GridItem = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .forwardRef */ .G)(function GridItem2(props, ref) {
  const {
    area,
    colSpan,
    colStart,
    colEnd,
    rowEnd,
    rowSpan,
    rowStart,
    ...rest
  } = props;
  const styles = (0,_chakra_ui_object_utils__WEBPACK_IMPORTED_MODULE_3__/* .compact */ .o)({
    gridArea: area,
    gridColumn: spanFn(colSpan),
    gridRow: spanFn(rowSpan),
    gridColumnStart: colStart,
    gridColumnEnd: colEnd,
    gridRowStart: rowStart,
    gridRowEnd: rowEnd
  });
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_4__/* .chakra.div */ .m.div, { ref, __css: styles, ...rest });
});
GridItem.displayName = "GridItem";


//# sourceMappingURL=chunk-ZPFGWTBB.mjs.map

/***/ }),

/***/ 4040:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ MenuList; }
/* harmony export */ });
/* harmony import */ var _chunk_UZJ3TPNQ_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(66712);
/* harmony import */ var _chunk_SANI5SUM_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73579);
/* harmony import */ var _chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(25432);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22548);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16554);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38043);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
'use client'
;


// src/menu-list.tsx




var motionVariants = {
  enter: {
    visibility: "visible",
    opacity: 1,
    scale: 1,
    transition: {
      duration: 0.2,
      ease: [0.4, 0, 0.2, 1]
    }
  },
  exit: {
    transitionEnd: {
      visibility: "hidden"
    },
    opacity: 0,
    scale: 0.8,
    transition: {
      duration: 0.1,
      easings: "easeOut"
    }
  }
};
var MenuTransition = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .chakra */ .m)(framer_motion__WEBPACK_IMPORTED_MODULE_2__/* .motion.div */ .E.div);
var MenuList = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__/* .forwardRef */ .G)(function MenuList2(props, ref) {
  var _a, _b;
  const { rootProps, motionProps, ...rest } = props;
  const {
    isOpen,
    onTransitionEnd,
    unstable__animationState: animated
  } = (0,_chunk_SANI5SUM_mjs__WEBPACK_IMPORTED_MODULE_4__/* .useMenuContext */ .Xh)();
  const listProps = (0,_chunk_SANI5SUM_mjs__WEBPACK_IMPORTED_MODULE_4__/* .useMenuList */ ._l)(rest, ref);
  const positionerProps = (0,_chunk_SANI5SUM_mjs__WEBPACK_IMPORTED_MODULE_4__/* .useMenuPositioner */ .Qh)(rootProps);
  const styles = (0,_chunk_UZJ3TPNQ_mjs__WEBPACK_IMPORTED_MODULE_5__/* .useMenuStyles */ .x)();
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
    _chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .chakra.div */ .m.div,
    {
      ...positionerProps,
      __css: { zIndex: (_b = props.zIndex) != null ? _b : (_a = styles.list) == null ? void 0 : _a.zIndex },
      children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
        MenuTransition,
        {
          variants: motionVariants,
          initial: false,
          animate: isOpen ? "enter" : "exit",
          __css: { outline: 0, ...styles.list },
          ...motionProps,
          className: (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_6__.cx)("chakra-menu__menu-list", listProps.className),
          ...listProps,
          onUpdate: onTransitionEnd,
          onAnimationComplete: (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_6__/* .callAll */ .PP)(
            animated.onComplete,
            listProps.onAnimationComplete
          )
        }
      )
    }
  );
});
MenuList.displayName = "MenuList";


//# sourceMappingURL=chunk-6MF6NSK4.mjs.map

/***/ }),

/***/ 82931:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "i": function() { return /* binding */ MenuItemOption; }
});

// EXTERNAL MODULE: ./node_modules/@chakra-ui/menu/dist/chunk-UZJ3TPNQ.mjs
var chunk_UZJ3TPNQ = __webpack_require__(66712);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/system/dist/chunk-ZJJGQIVY.mjs
var chunk_ZJJGQIVY = __webpack_require__(16554);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/system/dist/chunk-ZHQNHOQS.mjs + 6 modules
var chunk_ZHQNHOQS = __webpack_require__(22548);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@chakra-ui/menu/dist/chunk-M565QO7N.mjs
'use client'
;

// src/styled-menu-item.tsx



var StyledMenuItem = (0,chunk_ZJJGQIVY/* forwardRef */.G)(
  (props, ref) => {
    const { type, ...rest } = props;
    const styles = (0,chunk_UZJ3TPNQ/* useMenuStyles */.x)();
    const btnType = rest.as || type ? type != null ? type : void 0 : "button";
    const buttonStyles = (0,react.useMemo)(
      () => ({
        textDecoration: "none",
        color: "inherit",
        userSelect: "none",
        display: "flex",
        width: "100%",
        alignItems: "center",
        textAlign: "start",
        flex: "0 0 auto",
        outline: 0,
        ...styles.item
      }),
      [styles.item]
    );
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(chunk_ZHQNHOQS/* chakra.button */.m.button, { ref, type: btnType, ...rest, __css: buttonStyles });
  }
);


//# sourceMappingURL=chunk-M565QO7N.mjs.map
// EXTERNAL MODULE: ./node_modules/@chakra-ui/menu/dist/chunk-HB6KBUMZ.mjs
var chunk_HB6KBUMZ = __webpack_require__(17148);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/menu/dist/chunk-SANI5SUM.mjs + 5 modules
var chunk_SANI5SUM = __webpack_require__(73579);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/shared-utils/dist/index.mjs
var dist = __webpack_require__(25432);
;// CONCATENATED MODULE: ./node_modules/@chakra-ui/menu/dist/chunk-B3RAGXFV.mjs
'use client'
;



// src/menu-item-option.tsx



var CheckIcon = (props) => /* @__PURE__ */ (0,jsx_runtime.jsx)("svg", { viewBox: "0 0 14 14", width: "1em", height: "1em", ...props, children: /* @__PURE__ */ (0,jsx_runtime.jsx)(
  "polygon",
  {
    fill: "currentColor",
    points: "5.5 11.9993304 14 3.49933039 12.5 2 5.5 8.99933039 1.5 4.9968652 0 6.49933039"
  }
) });
var MenuItemOption = (0,chunk_ZJJGQIVY/* forwardRef */.G)(
  (props, ref) => {
    const { icon, iconSpacing = "0.75rem", ...rest } = props;
    const optionProps = (0,chunk_SANI5SUM/* useMenuOption */.gO)(rest, ref);
    return /* @__PURE__ */ (0,jsx_runtime.jsxs)(
      StyledMenuItem,
      {
        ...optionProps,
        className: (0,dist.cx)("chakra-menu__menuitem-option", rest.className),
        children: [
          icon !== null && /* @__PURE__ */ (0,jsx_runtime.jsx)(
            chunk_HB6KBUMZ/* MenuIcon */.O,
            {
              fontSize: "0.8em",
              marginEnd: iconSpacing,
              opacity: props.isChecked ? 1 : 0,
              children: icon || /* @__PURE__ */ (0,jsx_runtime.jsx)(CheckIcon, {})
            }
          ),
          /* @__PURE__ */ (0,jsx_runtime.jsx)("span", { style: { flex: 1 }, children: optionProps.children })
        ]
      }
    );
  }
);
MenuItemOption.id = "MenuItemOption";
MenuItemOption.displayName = "MenuItemOption";


//# sourceMappingURL=chunk-B3RAGXFV.mjs.map

/***/ }),

/***/ 17148:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ MenuIcon; }
/* harmony export */ });
/* harmony import */ var _chunk_UZJ3TPNQ_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66712);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22548);
/* harmony import */ var _chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25432);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
'use client'
;

// src/menu-icon.tsx




var MenuIcon = (props) => {
  const { className, children, ...rest } = props;
  const styles = (0,_chunk_UZJ3TPNQ_mjs__WEBPACK_IMPORTED_MODULE_2__/* .useMenuStyles */ .x)();
  const child = react__WEBPACK_IMPORTED_MODULE_0__.Children.only(children);
  const clone = (0,react__WEBPACK_IMPORTED_MODULE_0__.isValidElement)(child) ? (0,react__WEBPACK_IMPORTED_MODULE_0__.cloneElement)(child, {
    focusable: "false",
    "aria-hidden": true,
    className: (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_3__.cx)("chakra-menu__icon", child.props.className)
  }) : null;
  const _className = (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_3__.cx)("chakra-menu__icon-wrapper", className);
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_4__/* .chakra.span */ .m.span, { className: _className, ...rest, __css: styles.icon, children: clone });
};
MenuIcon.displayName = "MenuIcon";


//# sourceMappingURL=chunk-HB6KBUMZ.mjs.map

/***/ }),

/***/ 73579:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "wN": function() { return /* binding */ MenuDescendantsProvider; },
  "Kb": function() { return /* binding */ MenuProvider; },
  "H9": function() { return /* binding */ useMenu; },
  "zZ": function() { return /* binding */ useMenuButton; },
  "Xh": function() { return /* binding */ useMenuContext; },
  "_l": function() { return /* binding */ useMenuList; },
  "gO": function() { return /* binding */ useMenuOption; },
  "Qh": function() { return /* binding */ useMenuPositioner; }
});

// UNUSED EXPORTS: useMenuDescendant, useMenuDescendants, useMenuDescendantsContext, useMenuItem, useMenuOptionGroup, useMenuState

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@chakra-ui/menu/dist/chunk-YSKACL7R.mjs
'use client'

// src/use-shortcut.ts
;
function isPrintableCharacter(event) {
  const { key } = event;
  return key.length === 1 || key.length > 1 && /[^a-zA-Z0-9]/.test(key);
}
function useShortcut(props = {}) {
  const { timeout = 300, preventDefault = () => true } = props;
  const [keys, setKeys] = (0,react.useState)([]);
  const timeoutRef = (0,react.useRef)();
  const flush = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
  };
  const clearKeysAfterDelay = () => {
    flush();
    timeoutRef.current = setTimeout(() => {
      setKeys([]);
      timeoutRef.current = null;
    }, timeout);
  };
  (0,react.useEffect)(() => flush, []);
  function onKeyDown(fn) {
    return (event) => {
      if (event.key === "Backspace") {
        const keysCopy = [...keys];
        keysCopy.pop();
        setKeys(keysCopy);
        return;
      }
      if (isPrintableCharacter(event)) {
        const keysCopy = keys.concat(event.key);
        if (preventDefault(event)) {
          event.preventDefault();
          event.stopPropagation();
        }
        setKeys(keysCopy);
        fn(keysCopy.join(""));
        clearKeysAfterDelay();
      }
    };
  }
  return onKeyDown;
}


//# sourceMappingURL=chunk-YSKACL7R.mjs.map
;// CONCATENATED MODULE: ./node_modules/@chakra-ui/menu/dist/chunk-BWUXSGSJ.mjs
'use client'

// src/get-next-item-from-search.ts
function getNextItemFromSearch(items, searchString, itemToString, currentItem) {
  if (searchString == null) {
    return currentItem;
  }
  if (!currentItem) {
    const foundItem = items.find(
      (item) => itemToString(item).toLowerCase().startsWith(searchString.toLowerCase())
    );
    return foundItem;
  }
  const matchingItems = items.filter(
    (item) => itemToString(item).toLowerCase().startsWith(searchString.toLowerCase())
  );
  if (matchingItems.length > 0) {
    let nextIndex;
    if (matchingItems.includes(currentItem)) {
      const currentIndex = matchingItems.indexOf(currentItem);
      nextIndex = currentIndex + 1;
      if (nextIndex === matchingItems.length) {
        nextIndex = 0;
      }
      return matchingItems[nextIndex];
    }
    nextIndex = items.indexOf(matchingItems[0]);
    return items[nextIndex];
  }
  return currentItem;
}


//# sourceMappingURL=chunk-BWUXSGSJ.mjs.map
;// CONCATENATED MODULE: ./node_modules/@chakra-ui/clickable/dist/chunk-VDSXRTOE.mjs
'use client'

// src/use-event-listeners.ts
;
function useEventListeners() {
  const listeners = (0,react.useRef)(/* @__PURE__ */ new Map());
  const currentListeners = listeners.current;
  const add = (0,react.useCallback)((el, type, listener, options) => {
    listeners.current.set(listener, { type, el, options });
    el.addEventListener(type, listener, options);
  }, []);
  const remove = (0,react.useCallback)(
    (el, type, listener, options) => {
      el.removeEventListener(type, listener, options);
      listeners.current.delete(listener);
    },
    []
  );
  (0,react.useEffect)(
    () => () => {
      currentListeners.forEach((value, key) => {
        remove(value.el, value.type, key, value.options);
      });
    },
    [remove, currentListeners]
  );
  return { add, remove };
}


//# sourceMappingURL=chunk-VDSXRTOE.mjs.map
// EXTERNAL MODULE: ./node_modules/@chakra-ui/shared-utils/dist/index.mjs
var dist = __webpack_require__(25432);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react-use-merge-refs/dist/index.mjs
var react_use_merge_refs_dist = __webpack_require__(81103);
;// CONCATENATED MODULE: ./node_modules/@chakra-ui/clickable/dist/chunk-AXLEE3EK.mjs
'use client'
;

// src/use-clickable.ts



function isValidElement(event) {
  const element = event.target;
  const { tagName, isContentEditable } = element;
  return tagName !== "INPUT" && tagName !== "TEXTAREA" && isContentEditable !== true;
}
function useClickable(props = {}) {
  const {
    ref: htmlRef,
    isDisabled,
    isFocusable,
    clickOnEnter = true,
    clickOnSpace = true,
    onMouseDown,
    onMouseUp,
    onClick,
    onKeyDown,
    onKeyUp,
    tabIndex: tabIndexProp,
    onMouseOver,
    onMouseLeave,
    ...htmlProps
  } = props;
  const [isButton, setIsButton] = (0,react.useState)(true);
  const [isPressed, setIsPressed] = (0,react.useState)(false);
  const listeners = useEventListeners();
  const refCallback = (node) => {
    if (!node)
      return;
    if (node.tagName !== "BUTTON") {
      setIsButton(false);
    }
  };
  const tabIndex = isButton ? tabIndexProp : tabIndexProp || 0;
  const trulyDisabled = isDisabled && !isFocusable;
  const handleClick = (0,react.useCallback)(
    (event) => {
      if (isDisabled) {
        event.stopPropagation();
        event.preventDefault();
        return;
      }
      const self = event.currentTarget;
      self.focus();
      onClick == null ? void 0 : onClick(event);
    },
    [isDisabled, onClick]
  );
  const onDocumentKeyUp = (0,react.useCallback)(
    (e) => {
      if (isPressed && isValidElement(e)) {
        e.preventDefault();
        e.stopPropagation();
        setIsPressed(false);
        listeners.remove(document, "keyup", onDocumentKeyUp, false);
      }
    },
    [isPressed, listeners]
  );
  const handleKeyDown = (0,react.useCallback)(
    (event) => {
      onKeyDown == null ? void 0 : onKeyDown(event);
      if (isDisabled || event.defaultPrevented || event.metaKey) {
        return;
      }
      if (!isValidElement(event.nativeEvent) || isButton)
        return;
      const shouldClickOnEnter = clickOnEnter && event.key === "Enter";
      const shouldClickOnSpace = clickOnSpace && event.key === " ";
      if (shouldClickOnSpace) {
        event.preventDefault();
        setIsPressed(true);
      }
      if (shouldClickOnEnter) {
        event.preventDefault();
        const self = event.currentTarget;
        self.click();
      }
      listeners.add(document, "keyup", onDocumentKeyUp, false);
    },
    [
      isDisabled,
      isButton,
      onKeyDown,
      clickOnEnter,
      clickOnSpace,
      listeners,
      onDocumentKeyUp
    ]
  );
  const handleKeyUp = (0,react.useCallback)(
    (event) => {
      onKeyUp == null ? void 0 : onKeyUp(event);
      if (isDisabled || event.defaultPrevented || event.metaKey)
        return;
      if (!isValidElement(event.nativeEvent) || isButton)
        return;
      const shouldClickOnSpace = clickOnSpace && event.key === " ";
      if (shouldClickOnSpace) {
        event.preventDefault();
        setIsPressed(false);
        const self = event.currentTarget;
        self.click();
      }
    },
    [clickOnSpace, isButton, isDisabled, onKeyUp]
  );
  const onDocumentMouseUp = (0,react.useCallback)(
    (event) => {
      if (event.button !== 0)
        return;
      setIsPressed(false);
      listeners.remove(document, "mouseup", onDocumentMouseUp, false);
    },
    [listeners]
  );
  const handleMouseDown = (0,react.useCallback)(
    (event) => {
      if (event.button !== 0)
        return;
      if (isDisabled) {
        event.stopPropagation();
        event.preventDefault();
        return;
      }
      if (!isButton) {
        setIsPressed(true);
      }
      const target = event.currentTarget;
      target.focus({ preventScroll: true });
      listeners.add(document, "mouseup", onDocumentMouseUp, false);
      onMouseDown == null ? void 0 : onMouseDown(event);
    },
    [isDisabled, isButton, onMouseDown, listeners, onDocumentMouseUp]
  );
  const handleMouseUp = (0,react.useCallback)(
    (event) => {
      if (event.button !== 0)
        return;
      if (!isButton) {
        setIsPressed(false);
      }
      onMouseUp == null ? void 0 : onMouseUp(event);
    },
    [onMouseUp, isButton]
  );
  const handleMouseOver = (0,react.useCallback)(
    (event) => {
      if (isDisabled) {
        event.preventDefault();
        return;
      }
      onMouseOver == null ? void 0 : onMouseOver(event);
    },
    [isDisabled, onMouseOver]
  );
  const handleMouseLeave = (0,react.useCallback)(
    (event) => {
      if (isPressed) {
        event.preventDefault();
        setIsPressed(false);
      }
      onMouseLeave == null ? void 0 : onMouseLeave(event);
    },
    [isPressed, onMouseLeave]
  );
  const ref = (0,react_use_merge_refs_dist/* mergeRefs */.lq)(htmlRef, refCallback);
  if (isButton) {
    return {
      ...htmlProps,
      ref,
      type: "button",
      "aria-disabled": trulyDisabled ? void 0 : isDisabled,
      disabled: trulyDisabled,
      onClick: handleClick,
      onMouseDown,
      onMouseUp,
      onKeyUp,
      onKeyDown,
      onMouseOver,
      onMouseLeave
    };
  }
  return {
    ...htmlProps,
    ref,
    role: "button",
    "data-active": (0,dist/* dataAttr */.PB)(isPressed),
    "aria-disabled": isDisabled ? "true" : void 0,
    tabIndex: trulyDisabled ? void 0 : tabIndex,
    onClick: handleClick,
    onMouseDown: handleMouseDown,
    onMouseUp: handleMouseUp,
    onKeyUp: handleKeyUp,
    onKeyDown: handleKeyDown,
    onMouseOver: handleMouseOver,
    onMouseLeave: handleMouseLeave
  };
}


//# sourceMappingURL=chunk-AXLEE3EK.mjs.map
// EXTERNAL MODULE: ./node_modules/@chakra-ui/descendant/dist/chunk-OCNORRQU.mjs + 2 modules
var chunk_OCNORRQU = __webpack_require__(65225);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react-use-focus-effect/dist/index.mjs
var react_use_focus_effect_dist = __webpack_require__(32654);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/popper/dist/chunk-LUYFNC5G.mjs + 56 modules
var chunk_LUYFNC5G = __webpack_require__(66919);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react-use-disclosure/dist/index.mjs
var react_use_disclosure_dist = __webpack_require__(85075);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react-use-callback-ref/dist/index.mjs
var react_use_callback_ref_dist = __webpack_require__(35155);
;// CONCATENATED MODULE: ./node_modules/@chakra-ui/react-use-outside-click/dist/index.mjs
'use client'

// src/index.ts
;

function useOutsideClick(props) {
  const { ref, handler, enabled = true } = props;
  const savedHandler = (0,react_use_callback_ref_dist/* useCallbackRef */.W)(handler);
  const stateRef = (0,react.useRef)({
    isPointerDown: false,
    ignoreEmulatedMouseEvents: false
  });
  const state = stateRef.current;
  (0,react.useEffect)(() => {
    if (!enabled)
      return;
    const onPointerDown = (e) => {
      if (isValidEvent(e, ref)) {
        state.isPointerDown = true;
      }
    };
    const onMouseUp = (event) => {
      if (state.ignoreEmulatedMouseEvents) {
        state.ignoreEmulatedMouseEvents = false;
        return;
      }
      if (state.isPointerDown && handler && isValidEvent(event, ref)) {
        state.isPointerDown = false;
        savedHandler(event);
      }
    };
    const onTouchEnd = (event) => {
      state.ignoreEmulatedMouseEvents = true;
      if (handler && state.isPointerDown && isValidEvent(event, ref)) {
        state.isPointerDown = false;
        savedHandler(event);
      }
    };
    const doc = getOwnerDocument(ref.current);
    doc.addEventListener("mousedown", onPointerDown, true);
    doc.addEventListener("mouseup", onMouseUp, true);
    doc.addEventListener("touchstart", onPointerDown, true);
    doc.addEventListener("touchend", onTouchEnd, true);
    return () => {
      doc.removeEventListener("mousedown", onPointerDown, true);
      doc.removeEventListener("mouseup", onMouseUp, true);
      doc.removeEventListener("touchstart", onPointerDown, true);
      doc.removeEventListener("touchend", onTouchEnd, true);
    };
  }, [handler, ref, savedHandler, state, enabled]);
}
function isValidEvent(event, ref) {
  var _a;
  const target = event.target;
  if (target) {
    const doc = getOwnerDocument(target);
    if (!doc.contains(target))
      return false;
  }
  return !((_a = ref.current) == null ? void 0 : _a.contains(target));
}
function getOwnerDocument(node) {
  var _a;
  return (_a = node == null ? void 0 : node.ownerDocument) != null ? _a : document;
}

//# sourceMappingURL=index.mjs.map
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react-use-animation-state/dist/index.mjs
var react_use_animation_state_dist = __webpack_require__(93694);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react-context/dist/index.mjs
var react_context_dist = __webpack_require__(55227);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react-use-update-effect/dist/index.mjs
var react_use_update_effect_dist = __webpack_require__(52366);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/lazy-utils/dist/index.mjs
var lazy_utils_dist = __webpack_require__(92625);
;// CONCATENATED MODULE: ./node_modules/@chakra-ui/menu/dist/chunk-SANI5SUM.mjs
'use client'
;


// src/use-menu.ts















var [
  MenuDescendantsProvider,
  useMenuDescendantsContext,
  useMenuDescendants,
  useMenuDescendant
] = (0,chunk_OCNORRQU/* createDescendantContext */.n)();
var [MenuProvider, useMenuContext] = (0,react_context_dist/* createContext */.k)({
  strict: false,
  name: "MenuContext"
});
function useIds(idProp, ...prefixes) {
  const reactId = (0,react.useId)();
  const id = idProp || reactId;
  return (0,react.useMemo)(() => {
    return prefixes.map((prefix) => `${prefix}-${id}`);
  }, [id, prefixes]);
}
function chunk_SANI5SUM_getOwnerDocument(node) {
  var _a;
  return (_a = node == null ? void 0 : node.ownerDocument) != null ? _a : document;
}
function isActiveElement(element) {
  const doc = chunk_SANI5SUM_getOwnerDocument(element);
  return doc.activeElement === element;
}
function useMenu(props = {}) {
  const {
    id,
    closeOnSelect = true,
    closeOnBlur = true,
    initialFocusRef,
    autoSelect = true,
    isLazy,
    isOpen: isOpenProp,
    defaultIsOpen,
    onClose: onCloseProp,
    onOpen: onOpenProp,
    placement = "bottom-start",
    lazyBehavior = "unmount",
    direction,
    computePositionOnMount = false,
    ...popperProps
  } = props;
  const menuRef = (0,react.useRef)(null);
  const buttonRef = (0,react.useRef)(null);
  const descendants = useMenuDescendants();
  const focusMenu = (0,react.useCallback)(() => {
    requestAnimationFrame(() => {
      var _a;
      (_a = menuRef.current) == null ? void 0 : _a.focus({ preventScroll: false });
    });
  }, []);
  const focusFirstItem = (0,react.useCallback)(() => {
    const id2 = setTimeout(() => {
      var _a;
      if (initialFocusRef) {
        (_a = initialFocusRef.current) == null ? void 0 : _a.focus();
      } else {
        const first = descendants.firstEnabled();
        if (first)
          setFocusedIndex(first.index);
      }
    });
    timeoutIds.current.add(id2);
  }, [descendants, initialFocusRef]);
  const focusLastItem = (0,react.useCallback)(() => {
    const id2 = setTimeout(() => {
      const last = descendants.lastEnabled();
      if (last)
        setFocusedIndex(last.index);
    });
    timeoutIds.current.add(id2);
  }, [descendants]);
  const onOpenInternal = (0,react.useCallback)(() => {
    onOpenProp == null ? void 0 : onOpenProp();
    if (autoSelect) {
      focusFirstItem();
    } else {
      focusMenu();
    }
  }, [autoSelect, focusFirstItem, focusMenu, onOpenProp]);
  const { isOpen, onOpen, onClose, onToggle } = (0,react_use_disclosure_dist/* useDisclosure */.q)({
    isOpen: isOpenProp,
    defaultIsOpen,
    onClose: onCloseProp,
    onOpen: onOpenInternal
  });
  useOutsideClick({
    enabled: isOpen && closeOnBlur,
    ref: menuRef,
    handler: (event) => {
      var _a;
      if (!((_a = buttonRef.current) == null ? void 0 : _a.contains(event.target))) {
        onClose();
      }
    }
  });
  const popper = (0,chunk_LUYFNC5G/* usePopper */.D)({
    ...popperProps,
    enabled: isOpen || computePositionOnMount,
    placement,
    direction
  });
  const [focusedIndex, setFocusedIndex] = (0,react.useState)(-1);
  (0,react_use_update_effect_dist/* useUpdateEffect */.r)(() => {
    if (!isOpen) {
      setFocusedIndex(-1);
    }
  }, [isOpen]);
  (0,react_use_focus_effect_dist/* useFocusOnHide */.C)(menuRef, {
    focusRef: buttonRef,
    visible: isOpen,
    shouldFocus: true
  });
  const animationState = (0,react_use_animation_state_dist/* useAnimationState */.h)({ isOpen, ref: menuRef });
  const [buttonId, menuId] = useIds(id, `menu-button`, `menu-list`);
  const openAndFocusMenu = (0,react.useCallback)(() => {
    onOpen();
    focusMenu();
  }, [onOpen, focusMenu]);
  const timeoutIds = (0,react.useRef)(/* @__PURE__ */ new Set([]));
  (0,react.useEffect)(() => {
    const ids = timeoutIds.current;
    return () => {
      ids.forEach((id2) => clearTimeout(id2));
      ids.clear();
    };
  }, []);
  const openAndFocusFirstItem = (0,react.useCallback)(() => {
    onOpen();
    focusFirstItem();
  }, [focusFirstItem, onOpen]);
  const openAndFocusLastItem = (0,react.useCallback)(() => {
    onOpen();
    focusLastItem();
  }, [onOpen, focusLastItem]);
  const refocus = (0,react.useCallback)(() => {
    var _a, _b;
    const doc = chunk_SANI5SUM_getOwnerDocument(menuRef.current);
    const hasFocusWithin = (_a = menuRef.current) == null ? void 0 : _a.contains(doc.activeElement);
    const shouldRefocus = isOpen && !hasFocusWithin;
    if (!shouldRefocus)
      return;
    const node = (_b = descendants.item(focusedIndex)) == null ? void 0 : _b.node;
    node == null ? void 0 : node.focus({ preventScroll: true });
  }, [isOpen, focusedIndex, descendants]);
  const rafId = (0,react.useRef)(null);
  return {
    openAndFocusMenu,
    openAndFocusFirstItem,
    openAndFocusLastItem,
    onTransitionEnd: refocus,
    unstable__animationState: animationState,
    descendants,
    popper,
    buttonId,
    menuId,
    forceUpdate: popper.forceUpdate,
    orientation: "vertical",
    isOpen,
    onToggle,
    onOpen,
    onClose,
    menuRef,
    buttonRef,
    focusedIndex,
    closeOnSelect,
    closeOnBlur,
    autoSelect,
    setFocusedIndex,
    isLazy,
    lazyBehavior,
    initialFocusRef,
    rafId
  };
}
function useMenuButton(props = {}, externalRef = null) {
  const menu = useMenuContext();
  const { onToggle, popper, openAndFocusFirstItem, openAndFocusLastItem } = menu;
  const onKeyDown = (0,react.useCallback)(
    (event) => {
      const eventKey = event.key;
      const keyMap = {
        Enter: openAndFocusFirstItem,
        ArrowDown: openAndFocusFirstItem,
        ArrowUp: openAndFocusLastItem
      };
      const action = keyMap[eventKey];
      if (action) {
        event.preventDefault();
        event.stopPropagation();
        action(event);
      }
    },
    [openAndFocusFirstItem, openAndFocusLastItem]
  );
  return {
    ...props,
    ref: (0,react_use_merge_refs_dist/* mergeRefs */.lq)(menu.buttonRef, externalRef, popper.referenceRef),
    id: menu.buttonId,
    "data-active": (0,dist/* dataAttr */.PB)(menu.isOpen),
    "aria-expanded": menu.isOpen,
    "aria-haspopup": "menu",
    "aria-controls": menu.menuId,
    onClick: (0,dist/* callAllHandlers */.v0)(props.onClick, onToggle),
    onKeyDown: (0,dist/* callAllHandlers */.v0)(props.onKeyDown, onKeyDown)
  };
}
function isTargetMenuItem(target) {
  var _a;
  return isHTMLElement(target) && !!((_a = target == null ? void 0 : target.getAttribute("role")) == null ? void 0 : _a.startsWith("menuitem"));
}
function useMenuList(props = {}, ref = null) {
  const menu = useMenuContext();
  if (!menu) {
    throw new Error(
      `useMenuContext: context is undefined. Seems you forgot to wrap component within <Menu>`
    );
  }
  const {
    focusedIndex,
    setFocusedIndex,
    menuRef,
    isOpen,
    onClose,
    menuId,
    isLazy,
    lazyBehavior,
    unstable__animationState: animated
  } = menu;
  const descendants = useMenuDescendantsContext();
  const createTypeaheadHandler = useShortcut({
    preventDefault: (event) => event.key !== " " && isTargetMenuItem(event.target)
  });
  const onKeyDown = (0,react.useCallback)(
    (event) => {
      if (!event.currentTarget.contains(event.target))
        return;
      const eventKey = event.key;
      const keyMap = {
        Tab: (event2) => event2.preventDefault(),
        Escape: onClose,
        ArrowDown: () => {
          const next = descendants.nextEnabled(focusedIndex);
          if (next)
            setFocusedIndex(next.index);
        },
        ArrowUp: () => {
          const prev = descendants.prevEnabled(focusedIndex);
          if (prev)
            setFocusedIndex(prev.index);
        }
      };
      const fn = keyMap[eventKey];
      if (fn) {
        event.preventDefault();
        fn(event);
        return;
      }
      const onTypeahead = createTypeaheadHandler((character) => {
        const nextItem = getNextItemFromSearch(
          descendants.values(),
          character,
          (item) => {
            var _a, _b;
            return (_b = (_a = item == null ? void 0 : item.node) == null ? void 0 : _a.textContent) != null ? _b : "";
          },
          descendants.item(focusedIndex)
        );
        if (nextItem) {
          const index = descendants.indexOf(nextItem.node);
          setFocusedIndex(index);
        }
      });
      if (isTargetMenuItem(event.target)) {
        onTypeahead(event);
      }
    },
    [
      descendants,
      focusedIndex,
      createTypeaheadHandler,
      onClose,
      setFocusedIndex
    ]
  );
  const hasBeenOpened = (0,react.useRef)(false);
  if (isOpen) {
    hasBeenOpened.current = true;
  }
  const shouldRenderChildren = (0,lazy_utils_dist/* lazyDisclosure */.k)({
    wasSelected: hasBeenOpened.current,
    enabled: isLazy,
    mode: lazyBehavior,
    isSelected: animated.present
  });
  return {
    ...props,
    ref: (0,react_use_merge_refs_dist/* mergeRefs */.lq)(menuRef, ref),
    children: shouldRenderChildren ? props.children : null,
    tabIndex: -1,
    role: "menu",
    id: menuId,
    style: {
      ...props.style,
      transformOrigin: "var(--popper-transform-origin)"
    },
    "aria-orientation": "vertical",
    onKeyDown: (0,dist/* callAllHandlers */.v0)(props.onKeyDown, onKeyDown)
  };
}
function useMenuPositioner(props = {}) {
  const { popper, isOpen } = useMenuContext();
  return popper.getPopperProps({
    ...props,
    style: {
      visibility: isOpen ? "visible" : "hidden",
      ...props.style
    }
  });
}
function useMenuItem(props = {}, externalRef = null) {
  const {
    onMouseEnter: onMouseEnterProp,
    onMouseMove: onMouseMoveProp,
    onMouseLeave: onMouseLeaveProp,
    onClick: onClickProp,
    onFocus: onFocusProp,
    isDisabled,
    isFocusable,
    closeOnSelect,
    type: typeProp,
    ...htmlProps
  } = props;
  const menu = useMenuContext();
  const {
    setFocusedIndex,
    focusedIndex,
    closeOnSelect: menuCloseOnSelect,
    onClose,
    menuRef,
    isOpen,
    menuId,
    rafId
  } = menu;
  const ref = (0,react.useRef)(null);
  const id = `${menuId}-menuitem-${(0,react.useId)()}`;
  const { index, register } = useMenuDescendant({
    disabled: isDisabled && !isFocusable
  });
  const onMouseEnter = (0,react.useCallback)(
    (event) => {
      onMouseEnterProp == null ? void 0 : onMouseEnterProp(event);
      if (isDisabled)
        return;
      setFocusedIndex(index);
    },
    [setFocusedIndex, index, isDisabled, onMouseEnterProp]
  );
  const onMouseMove = (0,react.useCallback)(
    (event) => {
      onMouseMoveProp == null ? void 0 : onMouseMoveProp(event);
      if (ref.current && !isActiveElement(ref.current)) {
        onMouseEnter(event);
      }
    },
    [onMouseEnter, onMouseMoveProp]
  );
  const onMouseLeave = (0,react.useCallback)(
    (event) => {
      onMouseLeaveProp == null ? void 0 : onMouseLeaveProp(event);
      if (isDisabled)
        return;
      setFocusedIndex(-1);
    },
    [setFocusedIndex, isDisabled, onMouseLeaveProp]
  );
  const onClick = (0,react.useCallback)(
    (event) => {
      onClickProp == null ? void 0 : onClickProp(event);
      if (!isTargetMenuItem(event.currentTarget))
        return;
      if (closeOnSelect != null ? closeOnSelect : menuCloseOnSelect) {
        onClose();
      }
    },
    [onClose, onClickProp, menuCloseOnSelect, closeOnSelect]
  );
  const onFocus = (0,react.useCallback)(
    (event) => {
      onFocusProp == null ? void 0 : onFocusProp(event);
      setFocusedIndex(index);
    },
    [setFocusedIndex, onFocusProp, index]
  );
  const isFocused = index === focusedIndex;
  const trulyDisabled = isDisabled && !isFocusable;
  (0,react_use_update_effect_dist/* useUpdateEffect */.r)(() => {
    if (!isOpen)
      return;
    if (isFocused && !trulyDisabled && ref.current) {
      if (rafId.current) {
        cancelAnimationFrame(rafId.current);
      }
      rafId.current = requestAnimationFrame(() => {
        var _a;
        (_a = ref.current) == null ? void 0 : _a.focus({ preventScroll: true });
        rafId.current = null;
      });
    } else if (menuRef.current && !isActiveElement(menuRef.current)) {
      menuRef.current.focus({ preventScroll: true });
    }
    return () => {
      if (rafId.current) {
        cancelAnimationFrame(rafId.current);
      }
    };
  }, [isFocused, trulyDisabled, menuRef, isOpen]);
  const clickableProps = useClickable({
    onClick,
    onFocus,
    onMouseEnter,
    onMouseMove,
    onMouseLeave,
    ref: (0,react_use_merge_refs_dist/* mergeRefs */.lq)(register, ref, externalRef),
    isDisabled,
    isFocusable
  });
  return {
    ...htmlProps,
    ...clickableProps,
    type: typeProp != null ? typeProp : clickableProps.type,
    id,
    role: "menuitem",
    tabIndex: isFocused ? 0 : -1
  };
}
function useMenuOption(props = {}, ref = null) {
  const { type = "radio", isChecked, ...rest } = props;
  const ownProps = useMenuItem(rest, ref);
  return {
    ...ownProps,
    role: `menuitem${type}`,
    "aria-checked": isChecked
  };
}
function useMenuOptionGroup(props = {}) {
  const {
    children,
    type = "radio",
    value: valueProp,
    defaultValue,
    onChange: onChangeProp,
    ...htmlProps
  } = props;
  const isRadio = type === "radio";
  const fallback = isRadio ? "" : [];
  const [value, setValue] = useControllableState({
    defaultValue: defaultValue != null ? defaultValue : fallback,
    value: valueProp,
    onChange: onChangeProp
  });
  const onChange = useCallback(
    (selectedValue) => {
      if (type === "radio" && typeof value === "string") {
        setValue(selectedValue);
      }
      if (type === "checkbox" && Array.isArray(value)) {
        const nextValue = value.includes(selectedValue) ? value.filter((item) => item !== selectedValue) : value.concat(selectedValue);
        setValue(nextValue);
      }
    },
    [value, setValue, type]
  );
  const validChildren = getValidChildren(children);
  const clones = validChildren.map((child) => {
    if (child.type.id !== "MenuItemOption")
      return child;
    const onClick = (event) => {
      var _a, _b;
      onChange(child.props.value);
      (_b = (_a = child.props).onClick) == null ? void 0 : _b.call(_a, event);
    };
    const isChecked = type === "radio" ? child.props.value === value : value.includes(child.props.value);
    return cloneElement(child, {
      type,
      onClick,
      isChecked
    });
  });
  return {
    ...htmlProps,
    children: clones
  };
}
function useMenuState() {
  const { isOpen, onClose } = useMenuContext();
  return { isOpen, onClose };
}
function isHTMLElement(el) {
  var _a;
  if (!isElement(el))
    return false;
  const win = (_a = el.ownerDocument.defaultView) != null ? _a : window;
  return el instanceof win.HTMLElement;
}
function isElement(el) {
  return el != null && typeof el == "object" && "nodeType" in el && el.nodeType === Node.ELEMENT_NODE;
}


//# sourceMappingURL=chunk-SANI5SUM.mjs.map

/***/ }),

/***/ 66712:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ Menu; },
/* harmony export */   "x": function() { return /* binding */ useMenuStyles; }
/* harmony export */ });
/* harmony import */ var _chunk_SANI5SUM_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(73579);
/* harmony import */ var _chakra_ui_react_context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55227);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77030);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(33179);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(48940);
/* harmony import */ var _chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(25432);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
'use client'
;

// src/menu.tsx





var [MenuStylesProvider, useMenuStyles] = (0,_chakra_ui_react_context__WEBPACK_IMPORTED_MODULE_2__/* .createContext */ .k)({
  name: `MenuStylesContext`,
  errorMessage: `useMenuStyles returned is 'undefined'. Seems you forgot to wrap the components in "<Menu />" `
});
var Menu = (props) => {
  const { children } = props;
  const styles = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__/* .useMultiStyleConfig */ .jC)("Menu", props);
  const ownProps = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_4__/* .omitThemingProps */ .Lr)(props);
  const { direction } = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_5__/* .useTheme */ .F)();
  const { descendants, ...ctx } = (0,_chunk_SANI5SUM_mjs__WEBPACK_IMPORTED_MODULE_6__/* .useMenu */ .H9)({ ...ownProps, direction });
  const context = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => ctx, [ctx]);
  const { isOpen, onClose, forceUpdate } = context;
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chunk_SANI5SUM_mjs__WEBPACK_IMPORTED_MODULE_6__/* .MenuDescendantsProvider */ .wN, { value: descendants, children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chunk_SANI5SUM_mjs__WEBPACK_IMPORTED_MODULE_6__/* .MenuProvider */ .Kb, { value: context, children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(MenuStylesProvider, { value: styles, children: (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_7__/* .runIfFn */ .Pu)(children, { isOpen, onClose, forceUpdate }) }) }) });
};
Menu.displayName = "Menu";


//# sourceMappingURL=chunk-UZJ3TPNQ.mjs.map

/***/ }),

/***/ 91170:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ MenuButton; }
/* harmony export */ });
/* harmony import */ var _chunk_UZJ3TPNQ_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66712);
/* harmony import */ var _chunk_SANI5SUM_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73579);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16554);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22548);
/* harmony import */ var _chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25432);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
'use client'
;


// src/menu-button.tsx



var StyledMenuButton = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .forwardRef */ .G)((props, ref) => {
  const styles = (0,_chunk_UZJ3TPNQ_mjs__WEBPACK_IMPORTED_MODULE_2__/* .useMenuStyles */ .x)();
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
    _chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__/* .chakra.button */ .m.button,
    {
      ref,
      ...props,
      __css: {
        display: "inline-flex",
        appearance: "none",
        alignItems: "center",
        outline: 0,
        ...styles.button
      }
    }
  );
});
var MenuButton = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .forwardRef */ .G)(
  (props, ref) => {
    const { children, as: As, ...rest } = props;
    const buttonProps = (0,_chunk_SANI5SUM_mjs__WEBPACK_IMPORTED_MODULE_4__/* .useMenuButton */ .zZ)(rest, ref);
    const Element = As || StyledMenuButton;
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
      Element,
      {
        ...buttonProps,
        className: (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_5__.cx)("chakra-menu__menu-button", props.className),
        children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
          _chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__/* .chakra.span */ .m.span,
          {
            __css: { pointerEvents: "none", flex: "1 1 auto", minW: 0 },
            children: props.children
          }
        )
      }
    );
  }
);
MenuButton.displayName = "MenuButton";


//# sourceMappingURL=chunk-Z3VR2BFQ.mjs.map

/***/ }),

/***/ 66205:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ ModalCloseButton; }
/* harmony export */ });
/* harmony import */ var _chunk_MSA2NPQT_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35541);
/* harmony import */ var _chakra_ui_close_button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3949);
/* harmony import */ var _chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25432);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16554);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
'use client'
;

// src/modal-close-button.tsx




var ModalCloseButton = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .forwardRef */ .G)(
  (props, ref) => {
    const { onClick, className, ...rest } = props;
    const { onClose } = (0,_chunk_MSA2NPQT_mjs__WEBPACK_IMPORTED_MODULE_2__/* .useModalContext */ .vR)();
    const _className = (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_3__.cx)("chakra-modal__close-btn", className);
    const styles = (0,_chunk_MSA2NPQT_mjs__WEBPACK_IMPORTED_MODULE_2__/* .useModalStyles */ .I_)();
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
      _chakra_ui_close_button__WEBPACK_IMPORTED_MODULE_4__/* .CloseButton */ .P,
      {
        ref,
        __css: styles.closeButton,
        className: _className,
        onClick: (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_3__/* .callAllHandlers */ .v0)(onClick, (event) => {
          event.stopPropagation();
          onClose();
        }),
        ...rest
      }
    );
  }
);
ModalCloseButton.displayName = "ModalCloseButton";


//# sourceMappingURL=chunk-4FCEGNGT.mjs.map

/***/ }),

/***/ 85335:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "s": function() { return /* binding */ DrawerContent; }
});

// EXTERNAL MODULE: ./node_modules/@chakra-ui/modal/dist/chunk-MCHDHFCQ.mjs
var chunk_MCHDHFCQ = __webpack_require__(55083);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/modal/dist/chunk-NABYTFTG.mjs + 18 modules
var chunk_NABYTFTG = __webpack_require__(27083);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/modal/dist/chunk-MSA2NPQT.mjs + 2 modules
var chunk_MSA2NPQT = __webpack_require__(35541);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/shared-utils/dist/index.mjs
var dist = __webpack_require__(25432);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/system/dist/chunk-ZHQNHOQS.mjs + 6 modules
var chunk_ZHQNHOQS = __webpack_require__(22548);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/system/dist/chunk-ZJJGQIVY.mjs
var chunk_ZJJGQIVY = __webpack_require__(16554);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/transition/dist/chunk-6NHXDBFO.mjs
var chunk_6NHXDBFO = __webpack_require__(52094);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs + 3 modules
var AnimatePresence = __webpack_require__(21190);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.mjs + 166 modules
var motion = __webpack_require__(38043);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@chakra-ui/transition/dist/chunk-CYUETFQE.mjs
'use client'
;

// src/slide.tsx




var defaultTransition = {
  exit: {
    duration: 0.15,
    ease: chunk_6NHXDBFO/* TRANSITION_EASINGS.easeInOut */.Lj.easeInOut
  },
  enter: {
    type: "spring",
    damping: 25,
    stiffness: 180
  }
};
var variants = {
  exit: ({ direction, transition, transitionEnd, delay }) => {
    var _a;
    const { exit: exitStyles } = (0,chunk_6NHXDBFO/* getSlideTransition */.js)({ direction });
    return {
      ...exitStyles,
      transition: (_a = transition == null ? void 0 : transition.exit) != null ? _a : chunk_6NHXDBFO/* withDelay.exit */.p$.exit(defaultTransition.exit, delay),
      transitionEnd: transitionEnd == null ? void 0 : transitionEnd.exit
    };
  },
  enter: ({ direction, transitionEnd, transition, delay }) => {
    var _a;
    const { enter: enterStyles } = (0,chunk_6NHXDBFO/* getSlideTransition */.js)({ direction });
    return {
      ...enterStyles,
      transition: (_a = transition == null ? void 0 : transition.enter) != null ? _a : chunk_6NHXDBFO/* withDelay.enter */.p$.enter(defaultTransition.enter, delay),
      transitionEnd: transitionEnd == null ? void 0 : transitionEnd.enter
    };
  }
};
var Slide = (0,react.forwardRef)(function Slide2(props, ref) {
  const {
    direction = "right",
    style,
    unmountOnExit,
    in: isOpen,
    className,
    transition,
    transitionEnd,
    delay,
    motionProps,
    ...rest
  } = props;
  const transitionStyles = (0,chunk_6NHXDBFO/* getSlideTransition */.js)({ direction });
  const computedStyle = Object.assign(
    { position: "fixed" },
    transitionStyles.position,
    style
  );
  const show = unmountOnExit ? isOpen && unmountOnExit : true;
  const animate = isOpen || unmountOnExit ? "enter" : "exit";
  const custom = { transitionEnd, transition, direction, delay };
  return /* @__PURE__ */ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, { custom, children: show && /* @__PURE__ */ (0,jsx_runtime.jsx)(
    motion/* motion.div */.E.div,
    {
      ...rest,
      ref,
      initial: "exit",
      className: (0,dist.cx)("chakra-slide", className),
      animate,
      exit: "exit",
      custom,
      variants,
      style: computedStyle,
      ...motionProps
    }
  ) });
});
Slide.displayName = "Slide";


//# sourceMappingURL=chunk-CYUETFQE.mjs.map
;// CONCATENATED MODULE: ./node_modules/@chakra-ui/modal/dist/chunk-65IR7CTH.mjs
'use client'
;



// src/drawer-content.tsx




var MotionDiv = (0,chunk_ZHQNHOQS/* chakra */.m)(Slide);
var DrawerContent = (0,chunk_ZJJGQIVY/* forwardRef */.G)(
  (props, ref) => {
    const {
      className,
      children,
      motionProps,
      containerProps: rootProps,
      ...rest
    } = props;
    const { getDialogProps, getDialogContainerProps, isOpen } = (0,chunk_MSA2NPQT/* useModalContext */.vR)();
    const dialogProps = getDialogProps(rest, ref);
    const containerProps = getDialogContainerProps(rootProps);
    const _className = (0,dist.cx)("chakra-modal__content", className);
    const styles = (0,chunk_MSA2NPQT/* useModalStyles */.I_)();
    const dialogStyles = {
      display: "flex",
      flexDirection: "column",
      position: "relative",
      width: "100%",
      outline: 0,
      ...styles.dialog
    };
    const dialogContainerStyles = {
      display: "flex",
      width: "100vw",
      height: "$100vh",
      position: "fixed",
      left: 0,
      top: 0,
      ...styles.dialogContainer
    };
    const { placement } = (0,chunk_MCHDHFCQ/* useDrawerContext */.M)();
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(chunk_NABYTFTG/* ModalFocusScope */.M, { children: /* @__PURE__ */ (0,jsx_runtime.jsx)(
      chunk_ZHQNHOQS/* chakra.div */.m.div,
      {
        ...containerProps,
        className: "chakra-modal__content-container",
        __css: dialogContainerStyles,
        children: /* @__PURE__ */ (0,jsx_runtime.jsx)(
          MotionDiv,
          {
            motionProps,
            direction: placement,
            in: isOpen,
            className: _className,
            ...dialogProps,
            __css: dialogStyles,
            children
          }
        )
      }
    ) });
  }
);
DrawerContent.displayName = "DrawerContent";


//# sourceMappingURL=chunk-65IR7CTH.mjs.map

/***/ }),

/***/ 55083:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ useDrawerContext; },
/* harmony export */   "d": function() { return /* binding */ Drawer; }
/* harmony export */ });
/* harmony import */ var _chunk_MSA2NPQT_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35541);
/* harmony import */ var _chakra_ui_react_context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55227);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48940);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
'use client'
;

// src/drawer.tsx



var [DrawerContextProvider, useDrawerContext] = (0,_chakra_ui_react_context__WEBPACK_IMPORTED_MODULE_1__/* .createContext */ .k)();
var placementMap = {
  start: { ltr: "left", rtl: "right" },
  end: { ltr: "right", rtl: "left" }
};
function getDrawerPlacement(placement, dir) {
  var _a, _b;
  if (!placement)
    return;
  return (_b = (_a = placementMap[placement]) == null ? void 0 : _a[dir]) != null ? _b : placement;
}
function Drawer(props) {
  var _a;
  const {
    isOpen,
    onClose,
    placement: placementProp = "right",
    children,
    ...rest
  } = props;
  const theme = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .useTheme */ .F)();
  const drawerStyleConfig = (_a = theme.components) == null ? void 0 : _a.Drawer;
  const placement = getDrawerPlacement(placementProp, theme.direction);
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DrawerContextProvider, { value: { placement }, children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
    _chunk_MSA2NPQT_mjs__WEBPACK_IMPORTED_MODULE_3__/* .Modal */ .u_,
    {
      isOpen,
      onClose,
      styleConfig: drawerStyleConfig,
      ...rest,
      children
    }
  ) });
}


//# sourceMappingURL=chunk-MCHDHFCQ.mjs.map

/***/ }),

/***/ 64325:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "y": function() { return /* binding */ PopoverContent; }
});

// EXTERNAL MODULE: ./node_modules/@chakra-ui/popover/dist/chunk-Z3POGKNI.mjs
var chunk_Z3POGKNI = __webpack_require__(5904);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/system/dist/chunk-ZHQNHOQS.mjs + 6 modules
var chunk_ZHQNHOQS = __webpack_require__(22548);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/system/dist/chunk-ZJJGQIVY.mjs
var chunk_ZJJGQIVY = __webpack_require__(16554);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.mjs + 166 modules
var motion = __webpack_require__(38043);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@chakra-ui/popover/dist/chunk-F4GPNG57.mjs
'use client'
;

// src/popover-transition.tsx



function mergeVariants(variants) {
  if (!variants)
    return;
  return {
    enter: {
      ...variants.enter,
      visibility: "visible"
    },
    exit: {
      ...variants.exit,
      transitionEnd: {
        visibility: "hidden"
      }
    }
  };
}
var scaleFade = {
  exit: {
    opacity: 0,
    scale: 0.95,
    transition: {
      duration: 0.1,
      ease: [0.4, 0, 1, 1]
    }
  },
  enter: {
    scale: 1,
    opacity: 1,
    transition: {
      duration: 0.15,
      ease: [0, 0, 0.2, 1]
    }
  }
};
var MotionSection = (0,chunk_ZHQNHOQS/* chakra */.m)(motion/* motion.section */.E.section);
var PopoverTransition = (0,chunk_ZJJGQIVY/* forwardRef */.G)(function PopoverTransition2(props, ref) {
  const { variants = scaleFade, ...rest } = props;
  const { isOpen } = (0,chunk_Z3POGKNI/* usePopoverContext */.lp)();
  return /* @__PURE__ */ (0,jsx_runtime.jsx)(
    MotionSection,
    {
      ref,
      variants: mergeVariants(variants),
      initial: false,
      animate: isOpen ? "enter" : "exit",
      ...rest
    }
  );
});
PopoverTransition.displayName = "PopoverTransition";


//# sourceMappingURL=chunk-F4GPNG57.mjs.map
// EXTERNAL MODULE: ./node_modules/@chakra-ui/shared-utils/dist/index.mjs
var dist = __webpack_require__(25432);
;// CONCATENATED MODULE: ./node_modules/@chakra-ui/popover/dist/chunk-24I2HV4N.mjs
'use client'
;


// src/popover-content.tsx



var PopoverContent = (0,chunk_ZJJGQIVY/* forwardRef */.G)(
  function PopoverContent2(props, ref) {
    const { rootProps, motionProps, ...contentProps } = props;
    const { getPopoverProps, getPopoverPositionerProps, onAnimationComplete } = (0,chunk_Z3POGKNI/* usePopoverContext */.lp)();
    const styles = (0,chunk_Z3POGKNI/* usePopoverStyles */.SV)();
    const contentStyles = {
      position: "relative",
      display: "flex",
      flexDirection: "column",
      ...styles.content
    };
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(
      chunk_ZHQNHOQS/* chakra.div */.m.div,
      {
        ...getPopoverPositionerProps(rootProps),
        __css: styles.popper,
        className: "chakra-popover__popper",
        children: /* @__PURE__ */ (0,jsx_runtime.jsx)(
          PopoverTransition,
          {
            ...motionProps,
            ...getPopoverProps(contentProps, ref),
            onAnimationComplete: (0,dist/* callAll */.PP)(
              onAnimationComplete,
              contentProps.onAnimationComplete
            ),
            className: (0,dist.cx)("chakra-popover__content", props.className),
            __css: contentStyles
          }
        )
      }
    );
  }
);
PopoverContent.displayName = "PopoverContent";


//# sourceMappingURL=chunk-24I2HV4N.mjs.map

/***/ }),

/***/ 50151:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ PopoverTrigger; }
/* harmony export */ });
/* harmony import */ var _chunk_Z3POGKNI_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5904);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
'use client'
;

// src/popover-trigger.tsx

function PopoverTrigger(props) {
  const child = react__WEBPACK_IMPORTED_MODULE_0__.Children.only(props.children);
  const { getTriggerProps } = (0,_chunk_Z3POGKNI_mjs__WEBPACK_IMPORTED_MODULE_1__/* .usePopoverContext */ .lp)();
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.cloneElement)(child, getTriggerProps(child.props, child.ref));
}
PopoverTrigger.displayName = "PopoverTrigger";


//# sourceMappingURL=chunk-OFUG2FGD.mjs.map

/***/ }),

/***/ 58972:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ useRadio; }
/* harmony export */ });
/* harmony import */ var _chunk_FESYGSQT_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42669);
/* harmony import */ var _chakra_ui_form_control__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85970);
/* harmony import */ var _chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25432);
/* harmony import */ var _zag_js_focus_visible__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12934);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
'use client'
;

// src/use-radio.ts



// ../visually-hidden/src/visually-hidden.style.ts
var visuallyHiddenStyle = {
  border: "0",
  clip: "rect(0, 0, 0, 0)",
  height: "1px",
  width: "1px",
  margin: "-1px",
  padding: "0",
  overflow: "hidden",
  whiteSpace: "nowrap",
  position: "absolute"
};

// src/use-radio.ts


function useRadio(props = {}) {
  const {
    defaultChecked,
    isChecked: isCheckedProp,
    isFocusable,
    isDisabled: isDisabledProp,
    isReadOnly: isReadOnlyProp,
    isRequired: isRequiredProp,
    onChange,
    isInvalid: isInvalidProp,
    name,
    value,
    id: idProp,
    "data-radiogroup": dataRadioGroup,
    "aria-describedby": ariaDescribedBy,
    ...htmlProps
  } = props;
  const uuid = `radio-${(0,react__WEBPACK_IMPORTED_MODULE_0__.useId)()}`;
  const formControl = (0,_chakra_ui_form_control__WEBPACK_IMPORTED_MODULE_1__/* .useFormControlContext */ .NJ)();
  const group = (0,_chunk_FESYGSQT_mjs__WEBPACK_IMPORTED_MODULE_2__/* .useRadioGroupContext */ .X)();
  const isWithinRadioGroup = !!group || !!dataRadioGroup;
  const isWithinFormControl = !!formControl;
  let id = isWithinFormControl && !isWithinRadioGroup ? formControl.id : uuid;
  id = idProp != null ? idProp : id;
  const isDisabled = isDisabledProp != null ? isDisabledProp : formControl == null ? void 0 : formControl.isDisabled;
  const isReadOnly = isReadOnlyProp != null ? isReadOnlyProp : formControl == null ? void 0 : formControl.isReadOnly;
  const isRequired = isRequiredProp != null ? isRequiredProp : formControl == null ? void 0 : formControl.isRequired;
  const isInvalid = isInvalidProp != null ? isInvalidProp : formControl == null ? void 0 : formControl.isInvalid;
  const [isFocusVisible, setIsFocusVisible] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  const [isFocused, setFocused] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  const [isHovered, setHovering] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  const [isActive, setActive] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  const [isCheckedState, setChecked] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(Boolean(defaultChecked));
  const isControlled = typeof isCheckedProp !== "undefined";
  const isChecked = isControlled ? isCheckedProp : isCheckedState;
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    return (0,_zag_js_focus_visible__WEBPACK_IMPORTED_MODULE_3__/* .trackFocusVisible */ .BT)(setIsFocusVisible);
  }, []);
  const handleChange = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    (event) => {
      if (isReadOnly || isDisabled) {
        event.preventDefault();
        return;
      }
      if (!isControlled) {
        setChecked(event.target.checked);
      }
      onChange == null ? void 0 : onChange(event);
    },
    [isControlled, isDisabled, isReadOnly, onChange]
  );
  const onKeyDown = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    (event) => {
      if (event.key === " ") {
        setActive(true);
      }
    },
    [setActive]
  );
  const onKeyUp = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    (event) => {
      if (event.key === " ") {
        setActive(false);
      }
    },
    [setActive]
  );
  const getRadioProps = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    (props2 = {}, ref = null) => ({
      ...props2,
      ref,
      "data-active": (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_4__/* .dataAttr */ .PB)(isActive),
      "data-hover": (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_4__/* .dataAttr */ .PB)(isHovered),
      "data-disabled": (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_4__/* .dataAttr */ .PB)(isDisabled),
      "data-invalid": (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_4__/* .dataAttr */ .PB)(isInvalid),
      "data-checked": (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_4__/* .dataAttr */ .PB)(isChecked),
      "data-focus": (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_4__/* .dataAttr */ .PB)(isFocused),
      "data-focus-visible": (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_4__/* .dataAttr */ .PB)(isFocused && isFocusVisible),
      "data-readonly": (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_4__/* .dataAttr */ .PB)(isReadOnly),
      "aria-hidden": true,
      onMouseDown: (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_4__/* .callAllHandlers */ .v0)(props2.onMouseDown, () => setActive(true)),
      onMouseUp: (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_4__/* .callAllHandlers */ .v0)(props2.onMouseUp, () => setActive(false)),
      onMouseEnter: (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_4__/* .callAllHandlers */ .v0)(
        props2.onMouseEnter,
        () => setHovering(true)
      ),
      onMouseLeave: (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_4__/* .callAllHandlers */ .v0)(
        props2.onMouseLeave,
        () => setHovering(false)
      )
    }),
    [
      isActive,
      isHovered,
      isDisabled,
      isInvalid,
      isChecked,
      isFocused,
      isReadOnly,
      isFocusVisible
    ]
  );
  const { onFocus, onBlur } = formControl != null ? formControl : {};
  const getInputProps = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    (props2 = {}, ref = null) => {
      const trulyDisabled = isDisabled && !isFocusable;
      return {
        ...props2,
        id,
        ref,
        type: "radio",
        name,
        value,
        onChange: (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_4__/* .callAllHandlers */ .v0)(props2.onChange, handleChange),
        onBlur: (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_4__/* .callAllHandlers */ .v0)(
          onBlur,
          props2.onBlur,
          () => setFocused(false)
        ),
        onFocus: (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_4__/* .callAllHandlers */ .v0)(
          onFocus,
          props2.onFocus,
          () => setFocused(true)
        ),
        onKeyDown: (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_4__/* .callAllHandlers */ .v0)(props2.onKeyDown, onKeyDown),
        onKeyUp: (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_4__/* .callAllHandlers */ .v0)(props2.onKeyUp, onKeyUp),
        checked: isChecked,
        disabled: trulyDisabled,
        readOnly: isReadOnly,
        required: isRequired,
        "aria-invalid": (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_4__/* .ariaAttr */ .Qm)(isInvalid),
        "aria-disabled": (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_4__/* .ariaAttr */ .Qm)(trulyDisabled),
        "aria-required": (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_4__/* .ariaAttr */ .Qm)(isRequired),
        "data-readonly": (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_4__/* .dataAttr */ .PB)(isReadOnly),
        "aria-describedby": ariaDescribedBy,
        style: visuallyHiddenStyle
      };
    },
    [
      isDisabled,
      isFocusable,
      id,
      name,
      value,
      handleChange,
      onBlur,
      onFocus,
      onKeyDown,
      onKeyUp,
      isChecked,
      isReadOnly,
      isRequired,
      isInvalid,
      ariaDescribedBy
    ]
  );
  const getLabelProps = (props2 = {}, ref = null) => ({
    ...props2,
    ref,
    onMouseDown: (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_4__/* .callAllHandlers */ .v0)(props2.onMouseDown, stopEvent),
    "data-disabled": (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_4__/* .dataAttr */ .PB)(isDisabled),
    "data-checked": (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_4__/* .dataAttr */ .PB)(isChecked),
    "data-invalid": (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_4__/* .dataAttr */ .PB)(isInvalid)
  });
  const getRootProps = (props2, ref = null) => ({
    ...props2,
    ref,
    "data-disabled": (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_4__/* .dataAttr */ .PB)(isDisabled),
    "data-checked": (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_4__/* .dataAttr */ .PB)(isChecked),
    "data-invalid": (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_4__/* .dataAttr */ .PB)(isInvalid)
  });
  const state = {
    isInvalid,
    isFocused,
    isChecked,
    isActive,
    isHovered,
    isDisabled,
    isReadOnly,
    isRequired
  };
  return {
    state,
    /**
     * @deprecated - use `getRadioProps` instead
     */
    getCheckboxProps: getRadioProps,
    getRadioProps,
    getInputProps,
    getLabelProps,
    getRootProps,
    htmlProps
  };
}
function stopEvent(event) {
  event.preventDefault();
  event.stopPropagation();
}


//# sourceMappingURL=chunk-2WQJ2JCV.mjs.map

/***/ }),

/***/ 42669:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ RadioGroup; },
/* harmony export */   "X": function() { return /* binding */ useRadioGroupContext; }
/* harmony export */ });
/* harmony import */ var _chunk_Q56JAA3U_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(20307);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16554);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(22548);
/* harmony import */ var _chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(25432);
/* harmony import */ var _chakra_ui_react_context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55227);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
'use client'
;

// src/radio-group.tsx





var [RadioGroupProvider, useRadioGroupContext] = (0,_chakra_ui_react_context__WEBPACK_IMPORTED_MODULE_2__/* .createContext */ .k)({
  name: "RadioGroupContext",
  strict: false
});
var RadioGroup = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__/* .forwardRef */ .G)((props, ref) => {
  const {
    colorScheme,
    size,
    variant,
    children,
    className,
    isDisabled,
    isFocusable,
    ...rest
  } = props;
  const { value, onChange, getRootProps, name, htmlProps } = (0,_chunk_Q56JAA3U_mjs__WEBPACK_IMPORTED_MODULE_4__/* .useRadioGroup */ .a)(rest);
  const group = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(
    () => ({
      name,
      size,
      onChange,
      colorScheme,
      value,
      variant,
      isDisabled,
      isFocusable
    }),
    [
      name,
      size,
      onChange,
      colorScheme,
      value,
      variant,
      isDisabled,
      isFocusable
    ]
  );
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(RadioGroupProvider, { value: group, children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(
    _chakra_ui_system__WEBPACK_IMPORTED_MODULE_5__/* .chakra.div */ .m.div,
    {
      ...getRootProps(htmlProps, ref),
      className: (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_6__.cx)("chakra-radio-group", className),
      children
    }
  ) });
});
RadioGroup.displayName = "RadioGroup";


//# sourceMappingURL=chunk-FESYGSQT.mjs.map

/***/ }),

/***/ 20307:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ useRadioGroup; }
/* harmony export */ });
/* harmony import */ var _chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25432);
/* harmony import */ var _chakra_ui_react_use_merge_refs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81103);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
'use client'

// src/use-radio-group.ts
;


function isInputEvent(value) {
  return value && (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_1__/* .isObject */ .Kn)(value) && (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_1__/* .isObject */ .Kn)(value.target);
}
function useRadioGroup(props = {}) {
  const {
    onChange: onChangeProp,
    value: valueProp,
    defaultValue,
    name: nameProp,
    isDisabled,
    isFocusable,
    isNative,
    ...htmlProps
  } = props;
  const [valueState, setValue] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(defaultValue || "");
  const isControlled = typeof valueProp !== "undefined";
  const value = isControlled ? valueProp : valueState;
  const ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  const focus = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
    const rootNode = ref.current;
    if (!rootNode)
      return;
    let query = `input:not(:disabled):checked`;
    const firstEnabledAndCheckedInput = rootNode.querySelector(
      query
    );
    if (firstEnabledAndCheckedInput) {
      firstEnabledAndCheckedInput.focus();
      return;
    }
    query = `input:not(:disabled)`;
    const firstEnabledInput = rootNode.querySelector(query);
    firstEnabledInput == null ? void 0 : firstEnabledInput.focus();
  }, []);
  const uuid = (0,react__WEBPACK_IMPORTED_MODULE_0__.useId)();
  const fallbackName = `radio-${uuid}`;
  const name = nameProp || fallbackName;
  const onChange = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    (eventOrValue) => {
      const nextValue = isInputEvent(eventOrValue) ? eventOrValue.target.value : eventOrValue;
      if (!isControlled) {
        setValue(nextValue);
      }
      onChangeProp == null ? void 0 : onChangeProp(String(nextValue));
    },
    [onChangeProp, isControlled]
  );
  const getRootProps = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    (props2 = {}, forwardedRef = null) => ({
      ...props2,
      ref: (0,_chakra_ui_react_use_merge_refs__WEBPACK_IMPORTED_MODULE_2__/* .mergeRefs */ .lq)(forwardedRef, ref),
      role: "radiogroup"
    }),
    []
  );
  const getRadioProps = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    (props2 = {}, ref2 = null) => {
      const checkedKey = isNative ? "checked" : "isChecked";
      return {
        ...props2,
        ref: ref2,
        name,
        [checkedKey]: value != null ? props2.value === value : void 0,
        onChange(event) {
          onChange(event);
        },
        "data-radiogroup": true
      };
    },
    [isNative, name, onChange, value]
  );
  return {
    getRootProps,
    getRadioProps,
    name,
    ref,
    focus,
    setValue,
    value,
    onChange,
    isDisabled,
    isFocusable,
    htmlProps
  };
}


//# sourceMappingURL=chunk-Q56JAA3U.mjs.map

/***/ }),

/***/ 7963:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ useToast; }
/* harmony export */ });
/* unused harmony export use_toast_default */
/* harmony import */ var _chunk_3Y4YXCR2_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21089);
/* harmony import */ var _chunk_HYCJNCPE_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15863);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7634);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
'use client'
;


// src/use-toast.tsx


function useToast(options) {
  const { theme } = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .useChakra */ .uP)();
  const defaultOptions = (0,_chunk_3Y4YXCR2_mjs__WEBPACK_IMPORTED_MODULE_2__/* .useToastOptionContext */ .OX)();
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(
    () => (0,_chunk_HYCJNCPE_mjs__WEBPACK_IMPORTED_MODULE_3__/* .createToastFn */ .Cj)(theme.direction, {
      ...defaultOptions,
      ...options
    }),
    [options, theme.direction, defaultOptions]
  );
}
var use_toast_default = (/* unused pure expression or super */ null && (useToast));


//# sourceMappingURL=chunk-6RSEZNRH.mjs.map

/***/ }),

/***/ 97702:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "u": function() { return /* binding */ Tooltip; }
});

;// CONCATENATED MODULE: ./node_modules/@chakra-ui/tooltip/dist/chunk-XRZH7COS.mjs
'use client'

// src/tooltip.transition.tsx
var scale = {
  exit: {
    scale: 0.85,
    opacity: 0,
    transition: {
      opacity: { duration: 0.15, easings: "easeInOut" },
      scale: { duration: 0.2, easings: "easeInOut" }
    }
  },
  enter: {
    scale: 1,
    opacity: 1,
    transition: {
      opacity: { easings: "easeOut", duration: 0.2 },
      scale: { duration: 0.2, ease: [0.175, 0.885, 0.4, 1.1] }
    }
  }
};


//# sourceMappingURL=chunk-XRZH7COS.mjs.map
// EXTERNAL MODULE: ./node_modules/@chakra-ui/dom-utils/dist/chunk-3XANSPY5.mjs
var chunk_3XANSPY5 = __webpack_require__(61735);
;// CONCATENATED MODULE: ./node_modules/@chakra-ui/dom-utils/dist/chunk-4WEUWBTD.mjs


// src/scroll.ts
function isScrollParent(el) {
  const win = el.ownerDocument.defaultView || window;
  const { overflow, overflowX, overflowY } = win.getComputedStyle(el);
  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}
function getParent(el) {
  if (el.localName === "html")
    return el;
  return el.assignedSlot || el.parentElement || el.ownerDocument.documentElement;
}
function getScrollParent(el) {
  if (["html", "body", "#document"].includes(el.localName)) {
    return el.ownerDocument.body;
  }
  if ((0,chunk_3XANSPY5/* isHTMLElement */.Re)(el) && isScrollParent(el)) {
    return el;
  }
  return getScrollParent(getParent(el));
}



// EXTERNAL MODULE: ./node_modules/@chakra-ui/popper/dist/chunk-LUYFNC5G.mjs + 56 modules
var chunk_LUYFNC5G = __webpack_require__(66919);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/popper/dist/chunk-6WT2JRWX.mjs
var chunk_6WT2JRWX = __webpack_require__(76766);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react-use-disclosure/dist/index.mjs
var dist = __webpack_require__(85075);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react-use-event-listener/dist/index.mjs
var react_use_event_listener_dist = __webpack_require__(57134);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react-use-merge-refs/dist/index.mjs
var react_use_merge_refs_dist = __webpack_require__(81103);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/shared-utils/dist/index.mjs
var shared_utils_dist = __webpack_require__(25432);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@chakra-ui/tooltip/dist/chunk-P7BNLW77.mjs
'use client'

// src/use-tooltip.ts
;






var getDoc = (ref) => {
  var _a;
  return ((_a = ref.current) == null ? void 0 : _a.ownerDocument) || document;
};
var getWin = (ref) => {
  var _a, _b;
  return ((_b = (_a = ref.current) == null ? void 0 : _a.ownerDocument) == null ? void 0 : _b.defaultView) || window;
};
function useTooltip(props = {}) {
  const {
    openDelay = 0,
    closeDelay = 0,
    closeOnClick = true,
    closeOnMouseDown,
    closeOnScroll,
    closeOnPointerDown = closeOnMouseDown,
    closeOnEsc = true,
    onOpen: onOpenProp,
    onClose: onCloseProp,
    placement,
    id,
    isOpen: isOpenProp,
    defaultIsOpen,
    arrowSize = 10,
    arrowShadowColor,
    arrowPadding,
    modifiers,
    isDisabled,
    gutter,
    offset,
    direction,
    ...htmlProps
  } = props;
  const { isOpen, onOpen, onClose } = (0,dist/* useDisclosure */.q)({
    isOpen: isOpenProp,
    defaultIsOpen,
    onOpen: onOpenProp,
    onClose: onCloseProp
  });
  const { referenceRef, getPopperProps, getArrowInnerProps, getArrowProps } = (0,chunk_LUYFNC5G/* usePopper */.D)({
    enabled: isOpen,
    placement,
    arrowPadding,
    modifiers,
    gutter,
    offset,
    direction
  });
  const uuid = (0,react.useId)();
  const uid = id != null ? id : uuid;
  const tooltipId = `tooltip-${uid}`;
  const ref = (0,react.useRef)(null);
  const enterTimeout = (0,react.useRef)();
  const clearEnterTimeout = (0,react.useCallback)(() => {
    if (enterTimeout.current) {
      clearTimeout(enterTimeout.current);
      enterTimeout.current = void 0;
    }
  }, []);
  const exitTimeout = (0,react.useRef)();
  const clearExitTimeout = (0,react.useCallback)(() => {
    if (exitTimeout.current) {
      clearTimeout(exitTimeout.current);
      exitTimeout.current = void 0;
    }
  }, []);
  const closeNow = (0,react.useCallback)(() => {
    clearExitTimeout();
    onClose();
  }, [onClose, clearExitTimeout]);
  const dispatchCloseEvent = useCloseEvent(ref, closeNow);
  const openWithDelay = (0,react.useCallback)(() => {
    if (!isDisabled && !enterTimeout.current) {
      if (isOpen)
        dispatchCloseEvent();
      const win = getWin(ref);
      enterTimeout.current = win.setTimeout(onOpen, openDelay);
    }
  }, [dispatchCloseEvent, isDisabled, isOpen, onOpen, openDelay]);
  const closeWithDelay = (0,react.useCallback)(() => {
    clearEnterTimeout();
    const win = getWin(ref);
    exitTimeout.current = win.setTimeout(closeNow, closeDelay);
  }, [closeDelay, closeNow, clearEnterTimeout]);
  const onClick = (0,react.useCallback)(() => {
    if (isOpen && closeOnClick) {
      closeWithDelay();
    }
  }, [closeOnClick, closeWithDelay, isOpen]);
  const onPointerDown = (0,react.useCallback)(() => {
    if (isOpen && closeOnPointerDown) {
      closeWithDelay();
    }
  }, [closeOnPointerDown, closeWithDelay, isOpen]);
  const onKeyDown = (0,react.useCallback)(
    (event) => {
      if (isOpen && event.key === "Escape") {
        closeWithDelay();
      }
    },
    [isOpen, closeWithDelay]
  );
  (0,react_use_event_listener_dist/* useEventListener */.O)(
    () => getDoc(ref),
    "keydown",
    closeOnEsc ? onKeyDown : void 0
  );
  (0,react_use_event_listener_dist/* useEventListener */.O)(
    () => {
      if (!closeOnScroll)
        return null;
      const node = ref.current;
      if (!node)
        return null;
      const scrollParent = getScrollParent(node);
      return scrollParent.localName === "body" ? getWin(ref) : scrollParent;
    },
    "scroll",
    () => {
      if (isOpen && closeOnScroll) {
        closeNow();
      }
    },
    { passive: true, capture: true }
  );
  (0,react.useEffect)(() => {
    if (!isDisabled)
      return;
    clearEnterTimeout();
    if (isOpen)
      onClose();
  }, [isDisabled, isOpen, onClose, clearEnterTimeout]);
  (0,react.useEffect)(() => {
    return () => {
      clearEnterTimeout();
      clearExitTimeout();
    };
  }, [clearEnterTimeout, clearExitTimeout]);
  (0,react_use_event_listener_dist/* useEventListener */.O)(() => ref.current, "pointerleave", closeWithDelay);
  const getTriggerProps = (0,react.useCallback)(
    (props2 = {}, _ref = null) => {
      const triggerProps = {
        ...props2,
        ref: (0,react_use_merge_refs_dist/* mergeRefs */.lq)(ref, _ref, referenceRef),
        onPointerEnter: (0,shared_utils_dist/* callAllHandlers */.v0)(props2.onPointerEnter, (e) => {
          if (e.pointerType === "touch")
            return;
          openWithDelay();
        }),
        onClick: (0,shared_utils_dist/* callAllHandlers */.v0)(props2.onClick, onClick),
        onPointerDown: (0,shared_utils_dist/* callAllHandlers */.v0)(props2.onPointerDown, onPointerDown),
        onFocus: (0,shared_utils_dist/* callAllHandlers */.v0)(props2.onFocus, openWithDelay),
        onBlur: (0,shared_utils_dist/* callAllHandlers */.v0)(props2.onBlur, closeWithDelay),
        "aria-describedby": isOpen ? tooltipId : void 0
      };
      return triggerProps;
    },
    [
      openWithDelay,
      closeWithDelay,
      onPointerDown,
      isOpen,
      tooltipId,
      onClick,
      referenceRef
    ]
  );
  const getTooltipPositionerProps = (0,react.useCallback)(
    (props2 = {}, forwardedRef = null) => getPopperProps(
      {
        ...props2,
        style: {
          ...props2.style,
          [chunk_6WT2JRWX/* cssVars.arrowSize.var */.Dq.arrowSize["var"]]: arrowSize ? `${arrowSize}px` : void 0,
          [chunk_6WT2JRWX/* cssVars.arrowShadowColor.var */.Dq.arrowShadowColor["var"]]: arrowShadowColor
        }
      },
      forwardedRef
    ),
    [getPopperProps, arrowSize, arrowShadowColor]
  );
  const getTooltipProps = (0,react.useCallback)(
    (props2 = {}, ref2 = null) => {
      const styles = {
        ...props2.style,
        position: "relative",
        transformOrigin: chunk_6WT2JRWX/* cssVars.transformOrigin.varRef */.Dq.transformOrigin.varRef
      };
      return {
        ref: ref2,
        ...htmlProps,
        ...props2,
        id: tooltipId,
        role: "tooltip",
        style: styles
      };
    },
    [htmlProps, tooltipId]
  );
  return {
    isOpen,
    show: openWithDelay,
    hide: closeWithDelay,
    getTriggerProps,
    getTooltipProps,
    getTooltipPositionerProps,
    getArrowProps,
    getArrowInnerProps
  };
}
var closeEventName = "chakra-ui:close-tooltip";
function useCloseEvent(ref, close) {
  (0,react.useEffect)(() => {
    const doc = getDoc(ref);
    doc.addEventListener(closeEventName, close);
    return () => doc.removeEventListener(closeEventName, close);
  }, [close, ref]);
  return () => {
    const doc = getDoc(ref);
    const win = getWin(ref);
    doc.dispatchEvent(new win.CustomEvent(closeEventName));
  };
}


//# sourceMappingURL=chunk-P7BNLW77.mjs.map
// EXTERNAL MODULE: ./node_modules/@chakra-ui/portal/dist/chunk-34PD6CUK.mjs
var chunk_34PD6CUK = __webpack_require__(1702);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/system/dist/chunk-ZHQNHOQS.mjs + 6 modules
var chunk_ZHQNHOQS = __webpack_require__(22548);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/system/dist/chunk-ZJJGQIVY.mjs
var chunk_ZJJGQIVY = __webpack_require__(16554);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/system/dist/chunk-DMO4EI7P.mjs
var chunk_DMO4EI7P = __webpack_require__(77030);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/styled-system/dist/index.mjs
var styled_system_dist = __webpack_require__(33179);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/system/dist/chunk-UIGT7YZF.mjs
var chunk_UIGT7YZF = __webpack_require__(48940);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.mjs + 166 modules
var motion = __webpack_require__(38043);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs + 3 modules
var AnimatePresence = __webpack_require__(21190);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@chakra-ui/tooltip/dist/chunk-TK6VMDNP.mjs
'use client'
;


// src/tooltip.tsx




// ../../utilities/object-utils/src/omit.ts
function omit(object, keysToOmit = []) {
  const clone = Object.assign({}, object);
  for (const key of keysToOmit) {
    if (key in clone) {
      delete clone[key];
    }
  }
  return clone;
}

// ../../utilities/object-utils/src/pick.ts
function pick(object, keysToPick) {
  const result = {};
  for (const key of keysToPick) {
    if (key in object) {
      result[key] = object[key];
    }
  }
  return result;
}

// src/tooltip.tsx



var MotionDiv = (0,chunk_ZHQNHOQS/* chakra */.m)(motion/* motion.div */.E.div);
var Tooltip = (0,chunk_ZJJGQIVY/* forwardRef */.G)((props, ref) => {
  var _a, _b;
  const styles = (0,chunk_DMO4EI7P/* useStyleConfig */.mq)("Tooltip", props);
  const ownProps = (0,styled_system_dist/* omitThemingProps */.Lr)(props);
  const theme = (0,chunk_UIGT7YZF/* useTheme */.F)();
  const {
    children,
    label,
    shouldWrapChildren,
    "aria-label": ariaLabel,
    hasArrow,
    bg,
    portalProps,
    background,
    backgroundColor,
    bgColor,
    motionProps,
    ...rest
  } = ownProps;
  const userDefinedBg = (_b = (_a = background != null ? background : backgroundColor) != null ? _a : bg) != null ? _b : bgColor;
  if (userDefinedBg) {
    styles.bg = userDefinedBg;
    const bgVar = (0,styled_system_dist/* getCSSVar */.K1)(theme, "colors", userDefinedBg);
    styles[chunk_6WT2JRWX/* cssVars.arrowBg.var */.Dq.arrowBg["var"]] = bgVar;
  }
  const tooltip = useTooltip({ ...rest, direction: theme.direction });
  const shouldWrap = typeof children === "string" || shouldWrapChildren;
  let trigger;
  if (shouldWrap) {
    trigger = /* @__PURE__ */ (0,jsx_runtime.jsx)(
      chunk_ZHQNHOQS/* chakra.span */.m.span,
      {
        display: "inline-block",
        tabIndex: 0,
        ...tooltip.getTriggerProps(),
        children
      }
    );
  } else {
    const child = react.Children.only(children);
    trigger = (0,react.cloneElement)(
      child,
      tooltip.getTriggerProps(child.props, child.ref)
    );
  }
  const hasAriaLabel = !!ariaLabel;
  const _tooltipProps = tooltip.getTooltipProps({}, ref);
  const tooltipProps = hasAriaLabel ? omit(_tooltipProps, ["role", "id"]) : _tooltipProps;
  const srOnlyProps = pick(_tooltipProps, ["role", "id"]);
  if (!label) {
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, { children });
  }
  return /* @__PURE__ */ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, { children: [
    trigger,
    /* @__PURE__ */ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, { children: tooltip.isOpen && /* @__PURE__ */ (0,jsx_runtime.jsx)(chunk_34PD6CUK/* Portal */.h, { ...portalProps, children: /* @__PURE__ */ (0,jsx_runtime.jsx)(
      chunk_ZHQNHOQS/* chakra.div */.m.div,
      {
        ...tooltip.getTooltipPositionerProps(),
        __css: {
          zIndex: styles.zIndex,
          pointerEvents: "none"
        },
        children: /* @__PURE__ */ (0,jsx_runtime.jsxs)(
          MotionDiv,
          {
            variants: scale,
            initial: "exit",
            animate: "enter",
            exit: "exit",
            ...motionProps,
            ...tooltipProps,
            __css: styles,
            children: [
              label,
              hasAriaLabel && /* @__PURE__ */ (0,jsx_runtime.jsx)(chunk_ZHQNHOQS/* chakra.span */.m.span, { srOnly: true, ...srOnlyProps, children: ariaLabel }),
              hasArrow && /* @__PURE__ */ (0,jsx_runtime.jsx)(
                chunk_ZHQNHOQS/* chakra.div */.m.div,
                {
                  "data-popper-arrow": true,
                  className: "chakra-tooltip__arrow-wrapper",
                  children: /* @__PURE__ */ (0,jsx_runtime.jsx)(
                    chunk_ZHQNHOQS/* chakra.div */.m.div,
                    {
                      "data-popper-arrow-inner": true,
                      className: "chakra-tooltip__arrow",
                      __css: { bg: styles.bg }
                    }
                  )
                }
              )
            ]
          }
        )
      }
    ) }) })
  ] });
});
Tooltip.displayName = "Tooltip";


//# sourceMappingURL=chunk-TK6VMDNP.mjs.map

/***/ }),

/***/ 67848:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "a": function() { return /* binding */ useQuery; }
});

// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/lib/utils.mjs
var utils = __webpack_require__(32161);
// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/lib/notifyManager.mjs
var notifyManager = __webpack_require__(30081);
// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/lib/focusManager.mjs
var focusManager = __webpack_require__(15761);
// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/lib/subscribable.mjs
var subscribable = __webpack_require__(33989);
// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/lib/retryer.mjs
var retryer = __webpack_require__(72379);
;// CONCATENATED MODULE: ./node_modules/@tanstack/query-core/build/lib/queryObserver.mjs






class QueryObserver extends subscribable/* Subscribable */.l {
  constructor(client, options) {
    super();
    this.client = client;
    this.options = options;
    this.trackedProps = new Set();
    this.selectError = null;
    this.bindMethods();
    this.setOptions(options);
  }

  bindMethods() {
    this.remove = this.remove.bind(this);
    this.refetch = this.refetch.bind(this);
  }

  onSubscribe() {
    if (this.listeners.size === 1) {
      this.currentQuery.addObserver(this);

      if (shouldFetchOnMount(this.currentQuery, this.options)) {
        this.executeFetch();
      }

      this.updateTimers();
    }
  }

  onUnsubscribe() {
    if (!this.hasListeners()) {
      this.destroy();
    }
  }

  shouldFetchOnReconnect() {
    return shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnReconnect);
  }

  shouldFetchOnWindowFocus() {
    return shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnWindowFocus);
  }

  destroy() {
    this.listeners = new Set();
    this.clearStaleTimeout();
    this.clearRefetchInterval();
    this.currentQuery.removeObserver(this);
  }

  setOptions(options, notifyOptions) {
    const prevOptions = this.options;
    const prevQuery = this.currentQuery;
    this.options = this.client.defaultQueryOptions(options);

    if (false) {}

    if (!(0,utils/* shallowEqualObjects */.VS)(prevOptions, this.options)) {
      this.client.getQueryCache().notify({
        type: 'observerOptionsUpdated',
        query: this.currentQuery,
        observer: this
      });
    }

    if (typeof this.options.enabled !== 'undefined' && typeof this.options.enabled !== 'boolean') {
      throw new Error('Expected enabled to be a boolean');
    } // Keep previous query key if the user does not supply one


    if (!this.options.queryKey) {
      this.options.queryKey = prevOptions.queryKey;
    }

    this.updateQuery();
    const mounted = this.hasListeners(); // Fetch if there are subscribers

    if (mounted && shouldFetchOptionally(this.currentQuery, prevQuery, this.options, prevOptions)) {
      this.executeFetch();
    } // Update result


    this.updateResult(notifyOptions); // Update stale interval if needed

    if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || this.options.staleTime !== prevOptions.staleTime)) {
      this.updateStaleTimeout();
    }

    const nextRefetchInterval = this.computeRefetchInterval(); // Update refetch interval if needed

    if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || nextRefetchInterval !== this.currentRefetchInterval)) {
      this.updateRefetchInterval(nextRefetchInterval);
    }
  }

  getOptimisticResult(options) {
    const query = this.client.getQueryCache().build(this.client, options);
    const result = this.createResult(query, options);

    if (shouldAssignObserverCurrentProperties(this, result, options)) {
      // this assigns the optimistic result to the current Observer
      // because if the query function changes, useQuery will be performing
      // an effect where it would fetch again.
      // When the fetch finishes, we perform a deep data cloning in order
      // to reuse objects references. This deep data clone is performed against
      // the `observer.currentResult.data` property
      // When QueryKey changes, we refresh the query and get new `optimistic`
      // result, while we leave the `observer.currentResult`, so when new data
      // arrives, it finds the old `observer.currentResult` which is related
      // to the old QueryKey. Which means that currentResult and selectData are
      // out of sync already.
      // To solve this, we move the cursor of the currentResult everytime
      // an observer reads an optimistic value.
      // When keeping the previous data, the result doesn't change until new
      // data arrives.
      this.currentResult = result;
      this.currentResultOptions = this.options;
      this.currentResultState = this.currentQuery.state;
    }

    return result;
  }

  getCurrentResult() {
    return this.currentResult;
  }

  trackResult(result) {
    const trackedResult = {};
    Object.keys(result).forEach(key => {
      Object.defineProperty(trackedResult, key, {
        configurable: false,
        enumerable: true,
        get: () => {
          this.trackedProps.add(key);
          return result[key];
        }
      });
    });
    return trackedResult;
  }

  getCurrentQuery() {
    return this.currentQuery;
  }

  remove() {
    this.client.getQueryCache().remove(this.currentQuery);
  }

  refetch({
    refetchPage,
    ...options
  } = {}) {
    return this.fetch({ ...options,
      meta: {
        refetchPage
      }
    });
  }

  fetchOptimistic(options) {
    const defaultedOptions = this.client.defaultQueryOptions(options);
    const query = this.client.getQueryCache().build(this.client, defaultedOptions);
    query.isFetchingOptimistic = true;
    return query.fetch().then(() => this.createResult(query, defaultedOptions));
  }

  fetch(fetchOptions) {
    var _fetchOptions$cancelR;

    return this.executeFetch({ ...fetchOptions,
      cancelRefetch: (_fetchOptions$cancelR = fetchOptions.cancelRefetch) != null ? _fetchOptions$cancelR : true
    }).then(() => {
      this.updateResult();
      return this.currentResult;
    });
  }

  executeFetch(fetchOptions) {
    // Make sure we reference the latest query as the current one might have been removed
    this.updateQuery(); // Fetch

    let promise = this.currentQuery.fetch(this.options, fetchOptions);

    if (!(fetchOptions != null && fetchOptions.throwOnError)) {
      promise = promise.catch(utils/* noop */.ZT);
    }

    return promise;
  }

  updateStaleTimeout() {
    this.clearStaleTimeout();

    if (utils/* isServer */.sk || this.currentResult.isStale || !(0,utils/* isValidTimeout */.PN)(this.options.staleTime)) {
      return;
    }

    const time = (0,utils/* timeUntilStale */.Kp)(this.currentResult.dataUpdatedAt, this.options.staleTime); // The timeout is sometimes triggered 1 ms before the stale time expiration.
    // To mitigate this issue we always add 1 ms to the timeout.

    const timeout = time + 1;
    this.staleTimeoutId = setTimeout(() => {
      if (!this.currentResult.isStale) {
        this.updateResult();
      }
    }, timeout);
  }

  computeRefetchInterval() {
    var _this$options$refetch;

    return typeof this.options.refetchInterval === 'function' ? this.options.refetchInterval(this.currentResult.data, this.currentQuery) : (_this$options$refetch = this.options.refetchInterval) != null ? _this$options$refetch : false;
  }

  updateRefetchInterval(nextInterval) {
    this.clearRefetchInterval();
    this.currentRefetchInterval = nextInterval;

    if (utils/* isServer */.sk || this.options.enabled === false || !(0,utils/* isValidTimeout */.PN)(this.currentRefetchInterval) || this.currentRefetchInterval === 0) {
      return;
    }

    this.refetchIntervalId = setInterval(() => {
      if (this.options.refetchIntervalInBackground || focusManager/* focusManager.isFocused */.j.isFocused()) {
        this.executeFetch();
      }
    }, this.currentRefetchInterval);
  }

  updateTimers() {
    this.updateStaleTimeout();
    this.updateRefetchInterval(this.computeRefetchInterval());
  }

  clearStaleTimeout() {
    if (this.staleTimeoutId) {
      clearTimeout(this.staleTimeoutId);
      this.staleTimeoutId = undefined;
    }
  }

  clearRefetchInterval() {
    if (this.refetchIntervalId) {
      clearInterval(this.refetchIntervalId);
      this.refetchIntervalId = undefined;
    }
  }

  createResult(query, options) {
    const prevQuery = this.currentQuery;
    const prevOptions = this.options;
    const prevResult = this.currentResult;
    const prevResultState = this.currentResultState;
    const prevResultOptions = this.currentResultOptions;
    const queryChange = query !== prevQuery;
    const queryInitialState = queryChange ? query.state : this.currentQueryInitialState;
    const prevQueryResult = queryChange ? this.currentResult : this.previousQueryResult;
    const {
      state
    } = query;
    let {
      dataUpdatedAt,
      error,
      errorUpdatedAt,
      fetchStatus,
      status
    } = state;
    let isPreviousData = false;
    let isPlaceholderData = false;
    let data; // Optimistically set result in fetching state if needed

    if (options._optimisticResults) {
      const mounted = this.hasListeners();
      const fetchOnMount = !mounted && shouldFetchOnMount(query, options);
      const fetchOptionally = mounted && shouldFetchOptionally(query, prevQuery, options, prevOptions);

      if (fetchOnMount || fetchOptionally) {
        fetchStatus = (0,retryer/* canFetch */.Kw)(query.options.networkMode) ? 'fetching' : 'paused';

        if (!dataUpdatedAt) {
          status = 'loading';
        }
      }

      if (options._optimisticResults === 'isRestoring') {
        fetchStatus = 'idle';
      }
    } // Keep previous data if needed


    if (options.keepPreviousData && !state.dataUpdatedAt && prevQueryResult != null && prevQueryResult.isSuccess && status !== 'error') {
      data = prevQueryResult.data;
      dataUpdatedAt = prevQueryResult.dataUpdatedAt;
      status = prevQueryResult.status;
      isPreviousData = true;
    } // Select data if needed
    else if (options.select && typeof state.data !== 'undefined') {
      // Memoize select result
      if (prevResult && state.data === (prevResultState == null ? void 0 : prevResultState.data) && options.select === this.selectFn) {
        data = this.selectResult;
      } else {
        try {
          this.selectFn = options.select;
          data = options.select(state.data);
          data = (0,utils/* replaceData */.oE)(prevResult == null ? void 0 : prevResult.data, data, options);
          this.selectResult = data;
          this.selectError = null;
        } catch (selectError) {
          if (false) {}

          this.selectError = selectError;
        }
      }
    } // Use query data
    else {
      data = state.data;
    } // Show placeholder data if needed


    if (typeof options.placeholderData !== 'undefined' && typeof data === 'undefined' && status === 'loading') {
      let placeholderData; // Memoize placeholder data

      if (prevResult != null && prevResult.isPlaceholderData && options.placeholderData === (prevResultOptions == null ? void 0 : prevResultOptions.placeholderData)) {
        placeholderData = prevResult.data;
      } else {
        placeholderData = typeof options.placeholderData === 'function' ? options.placeholderData() : options.placeholderData;

        if (options.select && typeof placeholderData !== 'undefined') {
          try {
            placeholderData = options.select(placeholderData);
            this.selectError = null;
          } catch (selectError) {
            if (false) {}

            this.selectError = selectError;
          }
        }
      }

      if (typeof placeholderData !== 'undefined') {
        status = 'success';
        data = (0,utils/* replaceData */.oE)(prevResult == null ? void 0 : prevResult.data, placeholderData, options);
        isPlaceholderData = true;
      }
    }

    if (this.selectError) {
      error = this.selectError;
      data = this.selectResult;
      errorUpdatedAt = Date.now();
      status = 'error';
    }

    const isFetching = fetchStatus === 'fetching';
    const isLoading = status === 'loading';
    const isError = status === 'error';
    const result = {
      status,
      fetchStatus,
      isLoading,
      isSuccess: status === 'success',
      isError,
      isInitialLoading: isLoading && isFetching,
      data,
      dataUpdatedAt,
      error,
      errorUpdatedAt,
      failureCount: state.fetchFailureCount,
      failureReason: state.fetchFailureReason,
      errorUpdateCount: state.errorUpdateCount,
      isFetched: state.dataUpdateCount > 0 || state.errorUpdateCount > 0,
      isFetchedAfterMount: state.dataUpdateCount > queryInitialState.dataUpdateCount || state.errorUpdateCount > queryInitialState.errorUpdateCount,
      isFetching,
      isRefetching: isFetching && !isLoading,
      isLoadingError: isError && state.dataUpdatedAt === 0,
      isPaused: fetchStatus === 'paused',
      isPlaceholderData,
      isPreviousData,
      isRefetchError: isError && state.dataUpdatedAt !== 0,
      isStale: isStale(query, options),
      refetch: this.refetch,
      remove: this.remove
    };
    return result;
  }

  updateResult(notifyOptions) {
    const prevResult = this.currentResult;
    const nextResult = this.createResult(this.currentQuery, this.options);
    this.currentResultState = this.currentQuery.state;
    this.currentResultOptions = this.options; // Only notify and update result if something has changed

    if ((0,utils/* shallowEqualObjects */.VS)(nextResult, prevResult)) {
      return;
    }

    this.currentResult = nextResult; // Determine which callbacks to trigger

    const defaultNotifyOptions = {
      cache: true
    };

    const shouldNotifyListeners = () => {
      if (!prevResult) {
        return true;
      }

      const {
        notifyOnChangeProps
      } = this.options;
      const notifyOnChangePropsValue = typeof notifyOnChangeProps === 'function' ? notifyOnChangeProps() : notifyOnChangeProps;

      if (notifyOnChangePropsValue === 'all' || !notifyOnChangePropsValue && !this.trackedProps.size) {
        return true;
      }

      const includedProps = new Set(notifyOnChangePropsValue != null ? notifyOnChangePropsValue : this.trackedProps);

      if (this.options.useErrorBoundary) {
        includedProps.add('error');
      }

      return Object.keys(this.currentResult).some(key => {
        const typedKey = key;
        const changed = this.currentResult[typedKey] !== prevResult[typedKey];
        return changed && includedProps.has(typedKey);
      });
    };

    if ((notifyOptions == null ? void 0 : notifyOptions.listeners) !== false && shouldNotifyListeners()) {
      defaultNotifyOptions.listeners = true;
    }

    this.notify({ ...defaultNotifyOptions,
      ...notifyOptions
    });
  }

  updateQuery() {
    const query = this.client.getQueryCache().build(this.client, this.options);

    if (query === this.currentQuery) {
      return;
    }

    const prevQuery = this.currentQuery;
    this.currentQuery = query;
    this.currentQueryInitialState = query.state;
    this.previousQueryResult = this.currentResult;

    if (this.hasListeners()) {
      prevQuery == null ? void 0 : prevQuery.removeObserver(this);
      query.addObserver(this);
    }
  }

  onQueryUpdate(action) {
    const notifyOptions = {};

    if (action.type === 'success') {
      notifyOptions.onSuccess = !action.manual;
    } else if (action.type === 'error' && !(0,retryer/* isCancelledError */.DV)(action.error)) {
      notifyOptions.onError = true;
    }

    this.updateResult(notifyOptions);

    if (this.hasListeners()) {
      this.updateTimers();
    }
  }

  notify(notifyOptions) {
    notifyManager/* notifyManager.batch */.V.batch(() => {
      // First trigger the configuration callbacks
      if (notifyOptions.onSuccess) {
        var _this$options$onSucce, _this$options, _this$options$onSettl, _this$options2;

        (_this$options$onSucce = (_this$options = this.options).onSuccess) == null ? void 0 : _this$options$onSucce.call(_this$options, this.currentResult.data);
        (_this$options$onSettl = (_this$options2 = this.options).onSettled) == null ? void 0 : _this$options$onSettl.call(_this$options2, this.currentResult.data, null);
      } else if (notifyOptions.onError) {
        var _this$options$onError, _this$options3, _this$options$onSettl2, _this$options4;

        (_this$options$onError = (_this$options3 = this.options).onError) == null ? void 0 : _this$options$onError.call(_this$options3, this.currentResult.error);
        (_this$options$onSettl2 = (_this$options4 = this.options).onSettled) == null ? void 0 : _this$options$onSettl2.call(_this$options4, undefined, this.currentResult.error);
      } // Then trigger the listeners


      if (notifyOptions.listeners) {
        this.listeners.forEach(({
          listener
        }) => {
          listener(this.currentResult);
        });
      } // Then the cache listeners


      if (notifyOptions.cache) {
        this.client.getQueryCache().notify({
          query: this.currentQuery,
          type: 'observerResultsUpdated'
        });
      }
    });
  }

}

function shouldLoadOnMount(query, options) {
  return options.enabled !== false && !query.state.dataUpdatedAt && !(query.state.status === 'error' && options.retryOnMount === false);
}

function shouldFetchOnMount(query, options) {
  return shouldLoadOnMount(query, options) || query.state.dataUpdatedAt > 0 && shouldFetchOn(query, options, options.refetchOnMount);
}

function shouldFetchOn(query, options, field) {
  if (options.enabled !== false) {
    const value = typeof field === 'function' ? field(query) : field;
    return value === 'always' || value !== false && isStale(query, options);
  }

  return false;
}

function shouldFetchOptionally(query, prevQuery, options, prevOptions) {
  return options.enabled !== false && (query !== prevQuery || prevOptions.enabled === false) && (!options.suspense || query.state.status !== 'error') && isStale(query, options);
}

function isStale(query, options) {
  return query.isStaleByTime(options.staleTime);
} // this function would decide if we will update the observer's 'current'
// properties after an optimistic reading via getOptimisticResult


function shouldAssignObserverCurrentProperties(observer, optimisticResult, options) {
  // it is important to keep this condition like this for three reasons:
  // 1. It will get removed in the v5
  // 2. it reads: don't update the properties if we want to keep the previous
  // data.
  // 3. The opposite condition (!options.keepPreviousData) would fallthrough
  // and will result in a bad decision
  if (options.keepPreviousData) {
    return false;
  } // this means we want to put some placeholder data when pending and queryKey
  // changed.


  if (options.placeholderData !== undefined) {
    // re-assign properties only if current data is placeholder data
    // which means that data did not arrive yet, so, if there is some cached data
    // we need to "prepare" to receive it
    return optimisticResult.isPlaceholderData;
  } // if the newly created result isn't what the observer is holding as current,
  // then we'll need to update the properties as well


  if (!(0,utils/* shallowEqualObjects */.VS)(observer.getCurrentResult(), optimisticResult)) {
    return true;
  } // basically, just keep previous properties if nothing changed


  return false;
}


//# sourceMappingURL=queryObserver.mjs.map

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useSyncExternalStore.mjs
var useSyncExternalStore = __webpack_require__(464);
;// CONCATENATED MODULE: ./node_modules/@tanstack/react-query/build/lib/QueryErrorResetBoundary.mjs
'use client';


function createValue() {
  let isReset = false;
  return {
    clearReset: () => {
      isReset = false;
    },
    reset: () => {
      isReset = true;
    },
    isReset: () => {
      return isReset;
    }
  };
}

const QueryErrorResetBoundaryContext = /*#__PURE__*/react.createContext(createValue()); // HOOK

const useQueryErrorResetBoundary = () => react.useContext(QueryErrorResetBoundaryContext); // COMPONENT

const QueryErrorResetBoundary = ({
  children
}) => {
  const [value] = React.useState(() => createValue());
  return /*#__PURE__*/React.createElement(QueryErrorResetBoundaryContext.Provider, {
    value: value
  }, typeof children === 'function' ? children(value) : children);
};


//# sourceMappingURL=QueryErrorResetBoundary.mjs.map

// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/QueryClientProvider.mjs
var QueryClientProvider = __webpack_require__(85945);
;// CONCATENATED MODULE: ./node_modules/@tanstack/react-query/build/lib/isRestoring.mjs
'use client';


const IsRestoringContext = /*#__PURE__*/react.createContext(false);
const useIsRestoring = () => react.useContext(IsRestoringContext);
const IsRestoringProvider = IsRestoringContext.Provider;


//# sourceMappingURL=isRestoring.mjs.map

// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/utils.mjs
var lib_utils = __webpack_require__(24798);
;// CONCATENATED MODULE: ./node_modules/@tanstack/react-query/build/lib/errorBoundaryUtils.mjs
'use client';



const ensurePreventErrorBoundaryRetry = (options, errorResetBoundary) => {
  if (options.suspense || options.useErrorBoundary) {
    // Prevent retrying failed query if the error boundary has not been reset yet
    if (!errorResetBoundary.isReset()) {
      options.retryOnMount = false;
    }
  }
};
const useClearResetErrorBoundary = errorResetBoundary => {
  react.useEffect(() => {
    errorResetBoundary.clearReset();
  }, [errorResetBoundary]);
};
const getHasError = ({
  result,
  errorResetBoundary,
  useErrorBoundary,
  query
}) => {
  return result.isError && !errorResetBoundary.isReset() && !result.isFetching && (0,lib_utils/* shouldThrowError */.L)(useErrorBoundary, [result.error, query]);
};


//# sourceMappingURL=errorBoundaryUtils.mjs.map

;// CONCATENATED MODULE: ./node_modules/@tanstack/react-query/build/lib/suspense.mjs
const ensureStaleTime = defaultedOptions => {
  if (defaultedOptions.suspense) {
    // Always set stale time when using suspense to prevent
    // fetching again when directly mounting after suspending
    if (typeof defaultedOptions.staleTime !== 'number') {
      defaultedOptions.staleTime = 1000;
    }
  }
};
const willFetch = (result, isRestoring) => result.isLoading && result.isFetching && !isRestoring;
const shouldSuspend = (defaultedOptions, result, isRestoring) => (defaultedOptions == null ? void 0 : defaultedOptions.suspense) && willFetch(result, isRestoring);
const fetchOptimistic = (defaultedOptions, observer, errorResetBoundary) => observer.fetchOptimistic(defaultedOptions).then(({
  data
}) => {
  defaultedOptions.onSuccess == null ? void 0 : defaultedOptions.onSuccess(data);
  defaultedOptions.onSettled == null ? void 0 : defaultedOptions.onSettled(data, null);
}).catch(error => {
  errorResetBoundary.clearReset();
  defaultedOptions.onError == null ? void 0 : defaultedOptions.onError(error);
  defaultedOptions.onSettled == null ? void 0 : defaultedOptions.onSettled(undefined, error);
});


//# sourceMappingURL=suspense.mjs.map

;// CONCATENATED MODULE: ./node_modules/@tanstack/react-query/build/lib/useBaseQuery.mjs
'use client';









function useBaseQuery(options, Observer) {
  const queryClient = (0,QueryClientProvider/* useQueryClient */.NL)({
    context: options.context
  });
  const isRestoring = useIsRestoring();
  const errorResetBoundary = useQueryErrorResetBoundary();
  const defaultedOptions = queryClient.defaultQueryOptions(options); // Make sure results are optimistically set in fetching state before subscribing or updating options

  defaultedOptions._optimisticResults = isRestoring ? 'isRestoring' : 'optimistic'; // Include callbacks in batch renders

  if (defaultedOptions.onError) {
    defaultedOptions.onError = notifyManager/* notifyManager.batchCalls */.V.batchCalls(defaultedOptions.onError);
  }

  if (defaultedOptions.onSuccess) {
    defaultedOptions.onSuccess = notifyManager/* notifyManager.batchCalls */.V.batchCalls(defaultedOptions.onSuccess);
  }

  if (defaultedOptions.onSettled) {
    defaultedOptions.onSettled = notifyManager/* notifyManager.batchCalls */.V.batchCalls(defaultedOptions.onSettled);
  }

  ensureStaleTime(defaultedOptions);
  ensurePreventErrorBoundaryRetry(defaultedOptions, errorResetBoundary);
  useClearResetErrorBoundary(errorResetBoundary);
  const [observer] = react.useState(() => new Observer(queryClient, defaultedOptions));
  const result = observer.getOptimisticResult(defaultedOptions);
  (0,useSyncExternalStore/* useSyncExternalStore */.$)(react.useCallback(onStoreChange => {
    const unsubscribe = isRestoring ? () => undefined : observer.subscribe(notifyManager/* notifyManager.batchCalls */.V.batchCalls(onStoreChange)); // Update result to make sure we did not miss any query updates
    // between creating the observer and subscribing to it.

    observer.updateResult();
    return unsubscribe;
  }, [observer, isRestoring]), () => observer.getCurrentResult(), () => observer.getCurrentResult());
  react.useEffect(() => {
    // Do not notify on updates because of changes in the options because
    // these changes should already be reflected in the optimistic result.
    observer.setOptions(defaultedOptions, {
      listeners: false
    });
  }, [defaultedOptions, observer]); // Handle suspense

  if (shouldSuspend(defaultedOptions, result, isRestoring)) {
    throw fetchOptimistic(defaultedOptions, observer, errorResetBoundary);
  } // Handle error boundary


  if (getHasError({
    result,
    errorResetBoundary,
    useErrorBoundary: defaultedOptions.useErrorBoundary,
    query: observer.getCurrentQuery()
  })) {
    throw result.error;
  } // Handle result property usage tracking


  return !defaultedOptions.notifyOnChangeProps ? observer.trackResult(result) : result;
}


//# sourceMappingURL=useBaseQuery.mjs.map

;// CONCATENATED MODULE: ./node_modules/@tanstack/react-query/build/lib/useQuery.mjs
'use client';



function useQuery(arg1, arg2, arg3) {
  const parsedOptions = (0,utils/* parseQueryArgs */._v)(arg1, arg2, arg3);
  return useBaseQuery(parsedOptions, QueryObserver);
}


//# sourceMappingURL=useQuery.mjs.map


/***/ }),

/***/ 464:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ useSyncExternalStore; }
/* harmony export */ });
/* harmony import */ var use_sync_external_store_shim_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61688);
'use client';


const useSyncExternalStore = use_sync_external_store_shim_index_js__WEBPACK_IMPORTED_MODULE_0__.useSyncExternalStore;


//# sourceMappingURL=useSyncExternalStore.mjs.map


/***/ }),

/***/ 24798:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ shouldThrowError; }
/* harmony export */ });
function shouldThrowError(_useErrorBoundary, params) {
  // Allow useErrorBoundary function to override throwing behavior on a per-error basis
  if (typeof _useErrorBoundary === 'function') {
    return _useErrorBoundary(...params);
  }

  return !!_useErrorBoundary;
}


//# sourceMappingURL=utils.mjs.map


/***/ }),

/***/ 86831:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _typeof; }
/* harmony export */ });
function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

/***/ })

}]);